/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 468);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(53);
var hide = __webpack_require__(32);
var redefine = __webpack_require__(33);
var ctx = __webpack_require__(42);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(670);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(680)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(320);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(235);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sheetsManager = undefined;

var _keys = __webpack_require__(80);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _map = __webpack_require__(825);

var _map2 = _interopRequireDefault(_map);

var _minSafeInteger = __webpack_require__(840);

var _minSafeInteger2 = _interopRequireDefault(_minSafeInteger);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _hoistNonReactStatics = __webpack_require__(134);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _getDisplayName = __webpack_require__(374);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _wrapDisplayName = __webpack_require__(152);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _contextTypes = __webpack_require__(843);

var _contextTypes2 = _interopRequireDefault(_contextTypes);

var _jss = __webpack_require__(376);

var _ns = __webpack_require__(375);

var ns = _interopRequireWildcard(_ns);

var _jssPreset = __webpack_require__(382);

var _jssPreset2 = _interopRequireDefault(_jssPreset);

var _createMuiTheme = __webpack_require__(243);

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _themeListener = __webpack_require__(245);

var _themeListener2 = _interopRequireDefault(_themeListener);

var _createGenerateClassName = __webpack_require__(388);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _getStylesCreator = __webpack_require__(884);

var _getStylesCreator2 = _interopRequireDefault(_getStylesCreator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// New JSS instance.
var jss = (0, _jss.create)((0, _jssPreset2.default)());

// Use a singleton or the provided one by the context.
var generateClassName = (0, _createGenerateClassName2.default)();

// Global index counter to preserve source order.
// As we create the style sheet during componentWillMount lifecycle,
// children are handled after the parents, so the order of style elements would
// be parent->child. It is a problem though when a parent passes a className
// which needs to override any childs styles. StyleSheet of the child has a higher
// specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = _minSafeInteger2.default;

var sheetsManager = exports.sheetsManager = new _map2.default();

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};

// In order to have self-supporting components, we rely on default theme when not provided.
var defaultTheme = void 0;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme2.default)();
  return defaultTheme;
}

// Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === undefined ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === undefined ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties3.default)(options, ['withTheme', 'flip', 'name']);

    var stylesCreator = (0, _getStylesCreator2.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';

    indexCounter += 1;
    stylesCreator.options.index = indexCounter;

     false ? (0, _warning2.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;

    var WithStyles = function (_React$Component) {
      (0, _inherits3.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        (0, _classCallCheck3.default)(this, WithStyles);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).call(this, props, context));

        _this.state = {};
        _this.disableStylesGeneration = false;
        _this.jss = null;
        _this.sheetOptions = null;
        _this.sheetsManager = sheetsManager;
        _this.stylesCreatorSaved = null;
        _this.theme = null;
        _this.unsubscribeId = null;


        _this.jss = _this.context[ns.jss] || jss;

        var muiThemeProviderOptions = _this.context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        }

        // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107
        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3.default)({
          generateClassName: generateClassName
        }, _this.context[ns.sheetOptions]);
        // We use || as the function call is lazy evaluated.
        _this.theme = listenToTheme ? _themeListener2.default.initial(context) || getDefaultTheme() : noopTheme;
        return _this;
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.attach(this.theme);
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;
            _this2.attach(_this2.theme);

            // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.
            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: 'attach',
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);

          if (!sheetManager) {
            sheetManager = new _map2.default();
            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
          }

          var sheetManagerTheme = sheetManager.get(theme);

          if (!sheetManagerTheme) {
            sheetManagerTheme = {
              refs: 0,
              sheet: null
            };
            sheetManager.set(theme, sheetManagerTheme);
          }

          if (sheetManagerTheme.refs === 0) {
            var styles = stylesCreatorSaved.create(theme, name);
            var meta = name;

            if (false) {
              meta = (0, _getDisplayName2.default)(Component);
            }

            var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
              meta: meta,
              classNamePrefix: meta,
              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
              link: false
            }, this.sheetOptions, stylesCreatorSaved.options, {
              name: name
            }, styleSheetOptions));

            sheetManagerTheme.sheet = sheet;
            sheet.attach();

            var sheetsRegistry = this.context[ns.sheetsRegistry];
            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManagerTheme.refs += 1;
        }
      }, {
        key: 'detach',
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
          var sheetManagerTheme = sheetManager.get(theme);

          sheetManagerTheme.refs -= 1;

          if (sheetManagerTheme.refs === 0) {
            sheetManager.delete(theme);
            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
            var sheetsRegistry = this.context[ns.sheetsRegistry];
            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManagerTheme.sheet);
            }
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;

          var _props = this.props,
              classesProp = _props.classes,
              innerRef = _props.innerRef,
              other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'innerRef']);


          var classes = void 0;
          var renderedClasses = {};

          if (!this.disableStylesGeneration) {
            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
            var sheetsManagerTheme = sheetManager.get(this.theme);
            renderedClasses = sheetsManagerTheme.sheet.classes;
          }

          if (classesProp) {
            classes = (0, _extends3.default)({}, renderedClasses, (0, _keys2.default)(classesProp).reduce(function (accumulator, key) {
               false ? (0, _warning2.default)(renderedClasses[key] || _this3.disableStylesGeneration, ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not implemented in ' + (0, _getDisplayName2.default)(Component) + '.'), 'You can only override one of the following: ' + (0, _keys2.default)(renderedClasses).join(',')].join('\n')) : void 0;

               false ? (0, _warning2.default)(!classesProp[key] || typeof classesProp[key] === 'string', ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not valid for ' + (0, _getDisplayName2.default)(Component) + '.'), 'You need to provide a non empty string instead of: ' + classesProp[key] + '.'].join('\n')) : void 0;

              if (classesProp[key]) {
                accumulator[key] = renderedClasses[key] + ' ' + classesProp[key];
              }

              return accumulator;
            }, {}));
          } else {
            classes = renderedClasses;
          }

          var more = {};

          // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.
          if (withTheme) {
            more.theme = this.theme;
          }

          return _react2.default.createElement(Component, (0, _extends3.default)({ classes: classes }, more, other, { ref: innerRef }));
        }
      }]);
      return WithStyles;
    }(_react2.default.Component);

    WithStyles.propTypes =  false ? {
      /**
       * Useful to extend the style applied to components.
       */
      classes: _propTypes2.default.object,
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes2.default.func
    } : {};

    WithStyles.contextTypes = (0, _extends3.default)({
      muiThemeProviderOptions: _propTypes2.default.object
    }, _contextTypes2.default, listenToTheme ? _themeListener2.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = (0, _wrapDisplayName2.default)(Component, 'WithStyles');
    }

    (0, _hoistNonReactStatics2.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};

exports.default = withStyles;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(149);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(774);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(778);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(149);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(235);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(118)('wks');
var uid = __webpack_require__(65);
var Symbol = __webpack_require__(8).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(816), __esModule: true };

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(14)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var IE8_DOM_DEFINE = __webpack_require__(275);
var toPrimitive = __webpack_require__(47);
var dP = Object.defineProperty;

exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(49);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(48);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var core = __webpack_require__(23);
var ctx = __webpack_require__(56);
var hide = __webpack_require__(61);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(394);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(214)('wks');
var uid = __webpack_require__(138);
var Symbol = __webpack_require__(28).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var createDesc = __webpack_require__(64);
module.exports = __webpack_require__(19) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(32);
var has = __webpack_require__(31);
var SRC = __webpack_require__(65)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(53).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(14);
var defined = __webpack_require__(48);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(671);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(94);
var defined = __webpack_require__(48);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(95);
var createDesc = __webpack_require__(64);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(47);
var has = __webpack_require__(31);
var IE8_DOM_DEFINE = __webpack_require__(275);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(31);
var toObject = __webpack_require__(22);
var IE_PROTO = __webpack_require__(179)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(25);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(14);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(57);
var IE8_DOM_DEFINE = __webpack_require__(321);
var toPrimitive = __webpack_require__(209);
var dP = Object.defineProperty;

exports.f = __webpack_require__(52) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(16);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(53);
var fails = __webpack_require__(14);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(42);
var IObject = __webpack_require__(94);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(21);
var asc = __webpack_require__(196);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(75)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(19)) {
  var LIBRARY = __webpack_require__(66);
  var global = __webpack_require__(8);
  var fails = __webpack_require__(14);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(128);
  var $buffer = __webpack_require__(202);
  var ctx = __webpack_require__(42);
  var anInstance = __webpack_require__(72);
  var propertyDesc = __webpack_require__(64);
  var hide = __webpack_require__(32);
  var redefineAll = __webpack_require__(74);
  var toInteger = __webpack_require__(49);
  var toLength = __webpack_require__(21);
  var toIndex = __webpack_require__(301);
  var toAbsoluteIndex = __webpack_require__(68);
  var toPrimitive = __webpack_require__(47);
  var has = __webpack_require__(31);
  var classof = __webpack_require__(96);
  var isObject = __webpack_require__(16);
  var toObject = __webpack_require__(22);
  var isArrayIter = __webpack_require__(193);
  var create = __webpack_require__(69);
  var getPrototypeOf = __webpack_require__(40);
  var gOPN = __webpack_require__(70).f;
  var getIterFn = __webpack_require__(195);
  var uid = __webpack_require__(65);
  var wks = __webpack_require__(17);
  var createArrayMethod = __webpack_require__(51);
  var createArrayIncludes = __webpack_require__(119);
  var speciesConstructor = __webpack_require__(126);
  var ArrayIterators = __webpack_require__(198);
  var Iterators = __webpack_require__(85);
  var $iterDetect = __webpack_require__(123);
  var setSpecies = __webpack_require__(71);
  var arrayFill = __webpack_require__(197);
  var arrayCopyWithin = __webpack_require__(291);
  var $DP = __webpack_require__(20);
  var $GOPD = __webpack_require__(39);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(296);
var $export = __webpack_require__(0);
var shared = __webpack_require__(118)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(299))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(97);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(46);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* unused harmony export XHR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_keyMirror__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_keyMirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_keyMirror__);
/**
 * @namespace Constants
 * @desc App constants
 *//**
 * @constant {Object} ActionTypes
 * @memberof Constants
 */var ActionTypes=__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_keyMirror___default()({USER_LOGIN_REQUEST:undefined,USER_LOGIN_SUCCESS:undefined,USER_LOGIN_FAILURE:undefined,USER_LOGOUT_REQUEST:undefined,USER_LOGOUT_SUCCESS:undefined,USER_LOGOUT_FAILURE:undefined,GITHUB_GET_REPOS_REQUEST:undefined,GITHUB_GET_REPOS_SUCCESS:undefined,GITHUB_GET_REPOS_FAILURE:undefined,SHOW_ALERT:undefined,HIDE_ALERT:undefined,DRAWER_CHANGE:undefined,DRAWER_CHANGED:undefined,GET_EDGES:undefined,GET_EDGES_SUCCESS:undefined,GET_EDGES_FAILURE:undefined,GET_NODES:undefined,GET_NODES_SUCCESS:undefined,GET_ALL_NODES_SUCCESS:undefined,GET_NODES_FAILURE:undefined,GET_TAGS_SUCCESS:undefined,SET_TAG_SUCCESS:undefined,SET_DETAIL:undefined,SET_DETAIL_SUCCESS:undefined,SET_DETAIL_FAILURE:undefined,CLOSE_INTRO:undefined,SHOW_INTRO:undefined,GET_HTML:undefined,GET_HTML_SUCCESS:undefined,GET_HTML_FAILURE:undefined,INFO_DRAWER_CHANGE:undefined,INFO_DRAWER_CHANGED:undefined,GET_NODES_BY_COUNTRY:undefined,SET_NODES:undefined});/**
 * @constant {Object} XHR
 * @memberof Constants
 */var XHR=__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_keyMirror___default()({SUCCESS:undefined,FAIL:undefined});

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(65)('meta');
var isObject = __webpack_require__(16);
var has = __webpack_require__(31);
var setDesc = __webpack_require__(20).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(14)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(17)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(32)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(45);
var createDesc = __webpack_require__(98);
module.exports = __webpack_require__(52) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(1031);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(277);
var enumBugKeys = __webpack_require__(180);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(6);
var dPs = __webpack_require__(278);
var enumBugKeys = __webpack_require__(180);
var IE_PROTO = __webpack_require__(179)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(177)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(181).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(277);
var hiddenKeys = __webpack_require__(180).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var dP = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(19);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(42);
var call = __webpack_require__(289);
var isArrayIter = __webpack_require__(193);
var anObject = __webpack_require__(6);
var toLength = __webpack_require__(21);
var getIterFn = __webpack_require__(195);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(33);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["h"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["g"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["f"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* unused harmony export select */
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* unused harmony export takeEvery */
/* harmony export (immutable) */ __webpack_exports__["i"] = takeLatest;
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(326);



var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FLUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REHYDRATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PERSIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PURGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_VERSION; });
var KEY_PREFIX = 'persist:';
var FLUSH = 'persist/FLUSH';
var REHYDRATE = 'persist/REHYDRATE';
var PAUSE = 'persist/PAUSE';
var PERSIST = 'persist/PERSIST';
var PURGE = 'persist/PURGE';
var REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = -1;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = {"appname":"Qatar's ties to terror","logo_title":"Qatar's","logo_subtitle":"ties to terror","logo_image":"https://assets.qatar-terror-network.eu/countries/qatar.png","genericicons":{"charity":"https://assets.qatar-terror-network.eu/generic/charity.png","company":"https://assets.qatar-terror-network.eu/generic/company.png","bank":"https://assets.qatar-terror-network.eu/generic/dollar-sign-and-piles-of-coins.png","terror-organization":"https://assets.qatar-terror-network.eu/generic/terrorist-organization.png","organization":"https://assets.qatar-terror-network.eu/generic/organization.png","association":"https://assets.qatar-terror-network.eu/generic/organization.png","group":"https://assets.qatar-terror-network.eu/generic/collaboration.png","mosque":"https://assets.qatar-terror-network.eu/generic/mosque.png","project":"https://assets.qatar-terror-network.eu/generic/settings-work-tool.png","university":"https://assets.qatar-terror-network.eu/generic/college-graduation.png","government":"https://assets.qatar-terror-network.eu/generic/capitol-building.png","person":"https://assets.qatar-terror-network.eu/generic/person.png"},"colorBrownFocus":"#795548","colorBrown":"#D7CCC8","colorBrownBorder":"#D7CCC8","colorHighlight":"#8D6E63","reportPageOffset":8,"reportPDFLink":"https://assets.qatar-terror-network.eu/pdf.js/web/viewer.html","flags":[{"country":"brotherhood","name":"Muslim Brotherhood","image":"https://assets.qatar-terror-network.eu/nodes/48.png"},{"country":"qa","name":"Qatar","image":"https://assets.qatar-terror-network.eu/countries/qatar.png"},{"country":"kw","name":"Kuwait","image":"https://assets.qatar-terror-network.eu/countries/kuwait.png"},{"country":"gb","name":"Great Britain","image":"https://assets.qatar-terror-network.eu/countries/united-kingdom.png"}],"fileURL":"https://assets.qatar-terror-network.eu/full-text.pdf"}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(822), __esModule: true };

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(149);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(80);

var _keys2 = _interopRequireDefault(_keys);

exports.capitalizeFirstLetter = capitalizeFirstLetter;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalizeFirstLetter(string) {
   false ? (0, _warning2.default)(typeof string === 'string', 'Material-UI: capitalizeFirstLetter(string) expects a string argument.') : void 0;

  return string.charAt(0).toUpperCase() + string.slice(1);
} //  weak

function contains(obj, pred) {
  return (0, _keys2.default)(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = typeof pred === 'undefined' ? 'undefined' : (0, _typeof3.default)(pred);
  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (func) {
    return func != null;
  }).reduce(function (acc, func) {
     false ? (0, _warning2.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(910),
    getValue = __webpack_require__(913);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(20).f;
var has = __webpack_require__(31);
var TAG = __webpack_require__(17)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(48);
var fails = __webpack_require__(14);
var spaces = __webpack_require__(183);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(210);
var defined = __webpack_require__(211);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(211);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(323);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(240);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(153);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, nextValue) {
      // It's a setter.
      if (nextValue != null) {
        // Don't do anything if the value has not changed.
        if (this.style[name] !== nextValue) {
          nextValue = this.options.jss.plugins.onChangeValue(nextValue, name, this);
          this.style[name] = nextValue;

          // Renderable is defined if StyleSheet option `link` is true.
          if (this.renderable) this.renderer.setStyle(this.renderable, name, nextValue);else {
            var sheet = this.options.sheet;

            if (sheet && sheet.attached) {
              (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
            }
          }
        }
        return this;
      }

      return this.style[name];
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setStyle(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (this.renderable) {
        var hasChanged = this.renderer.setSelector(this.renderable, selector);

        // If selector setter is not implemented, rerender the rule.
        if (!hasChanged && this.renderable) {
          var renderable = this.renderer.replaceRule(this.renderable, this);
          if (renderable) this.renderable = renderable;
        }
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93),
    getRawTag = __webpack_require__(900),
    objectToString = __webpack_require__(901);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(26);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(43);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(43);
var TAG = __webpack_require__(17)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(322);
var enumBugKeys = __webpack_require__(215);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 100 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(77);
/* unused harmony reexport take */
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* unused harmony reexport race */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* unused harmony reexport cancel */
/* unused harmony reexport select */
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* unused harmony reexport takeEvery */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* unused harmony reexport throttle */


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(745);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(45).f;
var has = __webpack_require__(76);
var TAG = __webpack_require__(29)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(56);
var call = __webpack_require__(352);
var isArrayIter = __webpack_require__(353);
var anObject = __webpack_require__(57);
var toLength = __webpack_require__(137);
var getIterFn = __webpack_require__(354);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Drawer = __webpack_require__(815);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Drawer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(154);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(379);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(91);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(848);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options = this.options,
          parent = _options.parent,
          sheet = _options.sheet,
          jss = _options.jss,
          Renderer = _options.Renderer,
          generateClassName = _options.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'update',
    value: function update(name, data) {
      var _options2 = this.options,
          plugins = _options2.jss.plugins,
          sheet = _options2.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, this.get(name), sheet);
        return;
      }

      for (var index = 0; index < this.index.length; index++) {
        plugins.onUpdate(name, this.index[index], sheet);
      }
    }

    /**
     * Link renderable rules with CSSRuleList.
     */

  }, {
    key: 'link',
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(92),
    isObjectLike = __webpack_require__(62);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__(902);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Paper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 113 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(415),
    baseAssignValue = __webpack_require__(254);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(111);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SvgIcon = __webpack_require__(1083);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SvgIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(21);
var toAbsoluteIndex = __webpack_require__(68);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(43);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(16);
var cof = __webpack_require__(43);
var MATCH = __webpack_require__(17)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(17)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(6);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(32);
var redefine = __webpack_require__(33);
var fails = __webpack_require__(14);
var defined = __webpack_require__(48);
var wks = __webpack_require__(17);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(25);
var SPECIES = __webpack_require__(17)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(33);
var redefineAll = __webpack_require__(74);
var meta = __webpack_require__(59);
var forOf = __webpack_require__(73);
var anInstance = __webpack_require__(72);
var isObject = __webpack_require__(16);
var fails = __webpack_require__(14);
var $iterDetect = __webpack_require__(123);
var setToStringTag = __webpack_require__(83);
var inheritIfRequired = __webpack_require__(184);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var hide = __webpack_require__(32);
var uid = __webpack_require__(65);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(66) || !__webpack_require__(14)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(8)[K];
});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(25);
var ctx = __webpack_require__(42);
var forOf = __webpack_require__(73);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(212);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 138 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(41);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(103);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(751)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(226)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(57);
var dPs = __webpack_require__(753);
var enumBugKeys = __webpack_require__(215);
var IE_PROTO = __webpack_require__(213)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(208)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(349).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createReducer;
/* unused harmony export createRequestTypes */
/* unused harmony export datasetToObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/**
 * Helper functions
 * @module Helpers
 *//**
 * Generate reducer.
 *
 * @param {Object} initialState
 * @param {Object} handlers
 * @returns {function}
 */function createReducer(initialState,handlers){return function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if({}.hasOwnProperty.call(handlers,action.type)){return handlers[action.type](state,action);}return state;};}/**
 * Create request types for contants
 * @param {string} base
 * @returns {Object}
 */function createRequestTypes(base){return['REQUEST','SUCCESS','FAILURE'].reduce(function(acc,type){acc[type]=base+'_'+type;return acc;},{});}/**
 * Convert data attributes to Object
 * @param {Element} elem
 * @returns {{}}
 */function datasetToObject(elem){var data={};[].forEach.call(elem.attributes,function(attr){/* istanbul ignore else */if(/^data-/.test(attr.name)){var camelCaseName=attr.name.substr(5).replace(/-(.)/g,function($0,$1){return $1.toUpperCase();});data[camelCaseName]=attr.value;}});return data;}var ServerError=function(_Error){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ServerError,_Error);function ServerError(response){var _ref;var _ret;__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this,ServerError);for(var _len=arguments.length,params=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){params[_key-1]=arguments[_key];}var _this=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=ServerError.__proto__||Object.getPrototypeOf(ServerError)).call.apply(_ref,[this].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params))));Error.captureStackTrace(_this,ServerError);_this.name='ServerError';_this.response={};return _ret=_this,__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}return ServerError;}(Error);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(761);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(765);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(767);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(151);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(374);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(91);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(847);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, optionsArgument) {
	var clone = !optionsArgument || optionsArgument.clone !== false;

	return (clone && isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, optionsArgument)
		: value
}

function defaultArrayMerge(target, source, optionsArgument) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, optionsArgument)
	})
}

function mergeObject(target, source, optionsArgument) {
	var destination = {};
	if (isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], optionsArgument);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], optionsArgument);
		} else {
			destination[key] = deepmerge(target[key], source[key], optionsArgument);
		}
	});
	return destination
}

function deepmerge(target, source, optionsArgument) {
	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, optionsArgument)
	} else if (sourceIsArray) {
		var arrayMerge = options.arrayMerge || defaultArrayMerge;
		return arrayMerge(target, source, optionsArgument)
	} else {
		return mergeObject(target, source, optionsArgument)
	}
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, optionsArgument)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = undefined;

var _keys = __webpack_require__(80);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isNan = __webpack_require__(879);

var _isNan2 = _interopRequireDefault(_isNan);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = exports.easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

/* eslint-disable no-param-reassign */

var duration = exports.duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

var formatMs = exports.formatMs = function formatMs(milliseconds) {
  return Math.round(milliseconds) + 'ms';
};
var isString = exports.isString = function isString(value) {
  return typeof value === 'string';
};
var isNumber = exports.isNumber = function isNumber(value) {
  return !(0, _isNan2.default)(parseFloat(value));
};

/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */
exports.default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === undefined ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === undefined ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === undefined ? 0 : _options$delay,
        other = (0, _objectWithoutProperties3.default)(options, ['duration', 'easing', 'delay']);


     false ? (0, _warning2.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array') : void 0;
     false ? (0, _warning2.default)(isNumber(durationOption), 'Material-UI: argument "duration" must be a number but found ' + durationOption) : void 0;
     false ? (0, _warning2.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string') : void 0;
     false ? (0, _warning2.default)(isNumber(delay), 'Material-UI: argument "delay" must be a string') : void 0;
     false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0, 'Material-UI: unrecognized argument(s) [' + (0, _keys2.default)(other).join(',') + ']') : void 0;

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return animatedProp + ' ' + formatMs(durationOption) + ' ' + easingOption + ' ' + formatMs(delay);
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36;

    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(2);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(35);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(134);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _wrapDisplayName = __webpack_require__(152);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createMuiTheme = __webpack_require__(243);

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _themeListener = __webpack_require__(245);

var _themeListener2 = _interopRequireDefault(_themeListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = void 0;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme2.default)();
  return defaultTheme;
}

// Provide the theme object as a property to the input component.
var withTheme = function withTheme() {
  return function (Component) {
    var WithTheme = function (_React$Component) {
      (0, _inherits3.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        (0, _classCallCheck3.default)(this, WithTheme);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WithTheme.__proto__ || (0, _getPrototypeOf2.default)(WithTheme)).call(this, props, context));

        _this.state = {};
        _this.unsubscribeId = null;

        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener2.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass3.default)(WithTheme, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
            _this2.setState({ theme: theme });
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, (0, _extends3.default)({ theme: this.state.theme }, this.props));
        }
      }]);
      return WithTheme;
    }(_react2.default.Component);

    WithTheme.contextTypes = _themeListener2.default.contextTypes;

    if (false) {
      WithTheme.displayName = (0, _wrapDisplayName2.default)(Component, 'WithTheme');
    }

    (0, _hoistNonReactStatics2.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};

exports.default = withTheme;

/***/ }),
/* 160 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(92),
    isObject = __webpack_require__(37);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(163),
    isObject = __webpack_require__(37);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(416),
    baseKeys = __webpack_require__(418),
    isArrayLike = __webpack_require__(169);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(937),
    isObjectLike = __webpack_require__(62);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(26),
    stubFalse = __webpack_require__(938);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(161),
    isLength = __webpack_require__(256);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(171),
    stackClear = __webpack_require__(948),
    stackDelete = __webpack_require__(949),
    stackGet = __webpack_require__(950),
    stackHas = __webpack_require__(951),
    stackSet = __webpack_require__(952);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(943),
    listCacheDelete = __webpack_require__(944),
    listCacheGet = __webpack_require__(945),
    listCacheHas = __webpack_require__(946),
    listCacheSet = __webpack_require__(947);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(115);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(82);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(961);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(416),
    baseKeysIn = __webpack_require__(966),
    isArrayLike = __webpack_require__(169);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Typography = __webpack_require__(1062);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Typography).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var document = __webpack_require__(8).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var core = __webpack_require__(53);
var LIBRARY = __webpack_require__(66);
var wksExt = __webpack_require__(276);
var defineProperty = __webpack_require__(20).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(118)('keys');
var uid = __webpack_require__(65);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(8).document;
module.exports = document && document.documentElement;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(16);
var anObject = __webpack_require__(6);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(42)(Function.call, __webpack_require__(39).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var setPrototypeOf = __webpack_require__(182).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(49);
var defined = __webpack_require__(48);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 186 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 187 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(49);
var defined = __webpack_require__(48);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(66);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(33);
var hide = __webpack_require__(32);
var has = __webpack_require__(31);
var Iterators = __webpack_require__(85);
var $iterCreate = __webpack_require__(190);
var setToStringTag = __webpack_require__(83);
var getPrototypeOf = __webpack_require__(40);
var ITERATOR = __webpack_require__(17)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(69);
var descriptor = __webpack_require__(64);
var setToStringTag = __webpack_require__(83);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(32)(IteratorPrototype, __webpack_require__(17)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(122);
var defined = __webpack_require__(48);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(17)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(85);
var ITERATOR = __webpack_require__(17)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(20);
var createDesc = __webpack_require__(64);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(96);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(85);
module.exports = __webpack_require__(53).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(560);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(68);
var toLength = __webpack_require__(21);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(60);
var step = __webpack_require__(292);
var Iterators = __webpack_require__(85);
var toIObject = __webpack_require__(38);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(189)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(42);
var invoke = __webpack_require__(282);
var html = __webpack_require__(181);
var cel = __webpack_require__(177);
var global = __webpack_require__(8);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(43)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var macrotask = __webpack_require__(199).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(43)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(25);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var DESCRIPTORS = __webpack_require__(19);
var LIBRARY = __webpack_require__(66);
var $typed = __webpack_require__(128);
var hide = __webpack_require__(32);
var redefineAll = __webpack_require__(74);
var fails = __webpack_require__(14);
var anInstance = __webpack_require__(72);
var toInteger = __webpack_require__(49);
var toLength = __webpack_require__(21);
var toIndex = __webpack_require__(301);
var gOPN = __webpack_require__(70).f;
var dP = __webpack_require__(20).f;
var arrayFill = __webpack_require__(197);
var setToStringTag = __webpack_require__(83);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(693);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(46);
var document = __webpack_require__(28).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(46);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(100);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 212 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(214)('keys');
var uid = __webpack_require__(138);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 215 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 216 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(324);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(89);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(140);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(326);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["j"]; });
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(77);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(720);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(41);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(729);
/* unused harmony reexport getLocation */
/* unused harmony reexport createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(337);
/* unused harmony reexport LOCATION_CHANGE */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(338);
/* unused harmony reexport CALL_HISTORY_METHOD */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["b"]; });
/* unused harmony reexport replace */
/* unused harmony reexport go */
/* unused harmony reexport goBack */
/* unused harmony reexport goForward */
/* unused harmony reexport routerActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middleware__ = __webpack_require__(730);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__middleware__["a"]; });









/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(329);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(330);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(143);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistoid__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__purgeStoredState__ = __webpack_require__(341);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  @TODO add validation / handling for:
  - persisting a reducer which has nested _persist
  - handling actions that fire before reydrate is called
*/
function persistReducer(config, baseReducer) {
  if (false) {
    if (!config) throw new Error('config is required for persistReducer');
    if (!config.key) throw new Error('key is required in persistor config');
    if (!config.storage) throw new Error("redux-persist: config.storage is required. Try using one of the provided storage engines `import storageLocal from 'redux-persist/es/storage/local'");
  }

  var version = config.version !== undefined ? config.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
  var debug = config.debug || false;
  var stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_1__stateReconciler_autoMergeLevel1__["a" /* default */] : config.stateReconciler;
  var getStoredState = config.getStoredState || __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a" /* default */];
  var _persistoid = null;
  var _purge = false;
  var _paused = true;

  return function (state, action) {
    var _ref = state || {},
        _persist = _ref._persist,
        rest = _objectWithoutProperties(_ref, ['_persist']);

    var restState = rest;

    if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PERSIST */]) {
      // @NOTE PERSIST resumes if paused.
      _paused = false;

      // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
      if (!_persistoid) _persistoid = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistoid__["a" /* default */])(config);

      // @NOTE PERSIST can be called multiple times, noop after the first
      if (_persist) return state;
      if (typeof action.rehydrate !== 'function' || typeof action.register !== 'function') throw new Error('redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.');

      action.register(config.key);

      getStoredState(config).then(function (restoredState) {
        var migrate = config.migrate || function (s, v) {
          return Promise.resolve(s);
        };
        migrate(restoredState, version).then(function (migratedState) {
          action.rehydrate(config.key, migratedState);
        }, function (migrateErr) {
          if (false) console.error('redux-persist: migration error', migrateErr);
          action.rehydrate(config.key, undefined, migrateErr);
        });
      }, function (err) {
        action.rehydrate(config.key, undefined, err);
      });

      return _extends({}, baseReducer(restState, action), {
        _persist: { version: version, rehydrated: false }
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PURGE */]) {
      _purge = true;
      action.result(Object(__WEBPACK_IMPORTED_MODULE_4__purgeStoredState__["a" /* default */])(config));
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FLUSH */]) {
      action.result(_persistoid && _persistoid.flush());
      return _extends({}, baseReducer(restState, action), {
        _persist: _persist
      });
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PAUSE */]) {
      _paused = true;
    } else if (action.type === __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REHYDRATE */]) {
      // noop on restState if purging
      if (_purge) return _extends({}, restState, {
        _persist: _extends({}, _persist, { rehydrated: true })

        // @NOTE if key does not match, will continue to default else below
      });if (action.key === config.key) {
        var reducedState = baseReducer(restState, action);
        var inboundState = action.payload;
        var reconciledRest = stateReconciler !== false ? stateReconciler(inboundState, state, reducedState, config) : reducedState;

        return _extends({}, reconciledRest, {
          _persist: _extends({}, _persist, { rehydrated: true })
        });
      }
    }

    // if we have not already handled PERSIST, straight passthrough
    if (!_persist) return baseReducer(state, action);

    // otherwise, pull off _persist, run the reducer, and update the persistoid
    // @TODO more performant workaround for combineReducers warning
    var newState = _extends({}, baseReducer(restState, action), {
      _persist: _persist
      // update the persistoid only if we are already rehydrated and are not paused
    });_persist.rehydrated && _persistoid && !_paused && _persistoid.update(newState);
    return newState;
  };
}

/***/ }),
/* 225 */
/***/ (function(module, exports) {



/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(145);
var $export = __webpack_require__(24);
var redefine = __webpack_require__(348);
var hide = __webpack_require__(61);
var has = __webpack_require__(76);
var Iterators = __webpack_require__(105);
var $iterCreate = __webpack_require__(752);
var setToStringTag = __webpack_require__(106);
var getPrototypeOf = __webpack_require__(350);
var ITERATOR = __webpack_require__(29)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(754);
var global = __webpack_require__(28);
var hide = __webpack_require__(61);
var Iterators = __webpack_require__(105);
var TO_STRING_TAG = __webpack_require__(29)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(100);
var TAG = __webpack_require__(29)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(97);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(61);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(29);


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(138)('meta');
var isObject = __webpack_require__(46);
var has = __webpack_require__(76);
var setDesc = __webpack_require__(45).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(75)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var core = __webpack_require__(23);
var LIBRARY = __webpack_require__(145);
var wksExt = __webpack_require__(232);
var defineProperty = __webpack_require__(45).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(787), __esModule: true };

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(36);

var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;

var toString = Object.prototype.toString
var type = function(obj) {
  return toString.call(obj).slice(8, -1);
}

var assign = Object.assign || /* istanbul ignore next */ function assign(target, source) {
  getAllKeys(source).forEach(function(key) {
    if (hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  });
  return target;
};

var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
  /* istanbul ignore next */ function(obj) { return Object.keys(obj) };

/* istanbul ignore next */
function copy(object) {
  if (Array.isArray(object)) {
    return assign(object.constructor(object.length), object)
  } else if (type(object) === 'Map') {
    return new Map(object)
  } else if (type(object) === 'Set') {
    return new Set(object)
  } else if (object && typeof object === 'object') {
    var prototype = object.constructor && object.constructor.prototype
    return assign(Object.create(prototype || null), object);
  } else {
    return object;
  }
}

function newContext() {
  var commands = assign({}, defaultCommands);
  update.extend = function(directive, fn) {
    commands[directive] = fn;
  };
  update.isEquals = function(a, b) { return a === b; };

  return update;

  function update(object, spec) {
    if (typeof spec === 'function') {
      return spec(object);
    }

    if (!(Array.isArray(object) && Array.isArray(spec))) {
      invariant(
        !Array.isArray(spec),
        'update(): You provided an invalid spec to update(). The spec may ' +
        'not contain an array except as the value of $set, $push, $unshift, ' +
        '$splice or any custom command allowing an array value.'
      );
    }

    invariant(
      typeof spec === 'object' && spec !== null,
      'update(): You provided an invalid spec to update(). The spec and ' +
      'every included key path must be plain objects containing one of the ' +
      'following commands: %s.',
      Object.keys(commands).join(', ')
    );

    var nextObject = object;
    var index, key;
    getAllKeys(spec).forEach(function(key) {
      if (hasOwnProperty.call(commands, key)) {
        var objectWasNextObject = object === nextObject;
        nextObject = commands[key](spec[key], nextObject, spec, object);
        if (objectWasNextObject && update.isEquals(nextObject, object)) {
          nextObject = object;
        }
      } else {
        var nextValueForKey = update(object[key], spec[key]);
        if (!update.isEquals(nextValueForKey, nextObject[key]) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
          if (nextObject === object) {
            nextObject = copy(object);
          }
          nextObject[key] = nextValueForKey;
        }
      }
    })
    return nextObject;
  }

}

var defaultCommands = {
  $push: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$push');
    return value.length ? nextObject.concat(value) : nextObject;
  },
  $unshift: function(value, nextObject, spec) {
    invariantPushAndUnshift(nextObject, spec, '$unshift');
    return value.length ? value.concat(nextObject) : nextObject;
  },
  $splice: function(value, nextObject, spec, originalObject) {
    invariantSplices(nextObject, spec);
    value.forEach(function(args) {
      invariantSplice(args);
      if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
      splice.apply(nextObject, args);
    });
    return nextObject;
  },
  $set: function(value, nextObject, spec) {
    invariantSet(spec);
    return value;
  },
  $toggle: function(targets, nextObject) {
    invariantSpecArray(targets, '$toggle');
    var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;

    targets.forEach(function(target) {
      nextObjectCopy[target] = !nextObject[target];
    });

    return nextObjectCopy;
  },
  $unset: function(value, nextObject, spec, originalObject) {
    invariantSpecArray(value, '$unset');
    value.forEach(function(key) {
      if (Object.hasOwnProperty.call(nextObject, key)) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        delete nextObject[key];
      }
    });
    return nextObject;
  },
  $add: function(value, nextObject, spec, originalObject) {
    invariantMapOrSet(nextObject, '$add');
    invariantSpecArray(value, '$add');
    if (type(nextObject) === 'Map') {
      value.forEach(function(pair) {
        var key = pair[0];
        var value = pair[1];
        if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
        nextObject.set(key, value);
      });
    } else {
      value.forEach(function(value) {
        if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
        nextObject.add(value);
      });
    }
    return nextObject;
  },
  $remove: function(value, nextObject, spec, originalObject) {
    invariantMapOrSet(nextObject, '$remove');
    invariantSpecArray(value, '$remove');
    value.forEach(function(key) {
      if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
      nextObject.delete(key);
    });
    return nextObject;
  },
  $merge: function(value, nextObject, spec, originalObject) {
    invariantMerge(nextObject, value);
    getAllKeys(value).forEach(function(key) {
      if (value[key] !== nextObject[key]) {
        if (nextObject === originalObject) nextObject = copy(originalObject);
        nextObject[key] = value[key];
      }
    });
    return nextObject;
  },
  $apply: function(value, original) {
    invariantApply(value);
    return value(original);
  }
};

module.exports = newContext();
module.exports.newContext = newContext;

// invariants

function invariantPushAndUnshift(value, spec, command) {
  invariant(
    Array.isArray(value),
    'update(): expected target of %s to be an array; got %s.',
    command,
    value
  );
  invariantSpecArray(spec[command], command)
}

function invariantSpecArray(spec, command) {
  invariant(
    Array.isArray(spec),
    'update(): expected spec of %s to be an array; got %s. ' +
    'Did you forget to wrap your parameter in an array?',
    command,
    spec
  );
}

function invariantSplices(value, spec) {
  invariant(
    Array.isArray(value),
    'Expected $splice target to be an array; got %s',
    value
  );
  invariantSplice(spec['$splice']);
}

function invariantSplice(value) {
  invariant(
    Array.isArray(value),
    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
    'Did you forget to wrap your parameters in an array?',
    value
  );
}

function invariantApply(fn) {
  invariant(
    typeof fn === 'function',
    'update(): expected spec of $apply to be a function; got %s.',
    fn
  );
}

function invariantSet(spec) {
  invariant(
    Object.keys(spec).length === 1,
    'Cannot have more than one key in an object with $set'
  );
}

function invariantMerge(target, specValue) {
  invariant(
    specValue && typeof specValue === 'object',
    'update(): $merge expects a spec of type \'object\'; got %s',
    specValue
  );
  invariant(
    target && typeof target === 'object',
    'update(): $merge expects a target of type \'object\'; got %s',
    target
  );
}

function invariantMapOrSet(target, command) {
  var typeOfTarget = type(target);
  invariant(
    typeOfTarget === 'Map' || typeOfTarget === 'Set',
    'update(): %s expects a target of type Set or Map; got %s',
    command,
    typeOfTarget
  );
}


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(793);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(794);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(796);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(797);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(798);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(799);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(238);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(800);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(801);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(802);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(803);
/* unused harmony reexport withRouter */



























/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(141);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.specialProperty = undefined;

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(80);

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = __webpack_require__(3);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = exactProp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.

var specialProperty = exports.specialProperty = 'exact-prop: \u200B';

function exactProp(propTypes, componentNameInError) {
  return (0, _extends4.default)({}, propTypes, (0, _defineProperty3.default)({}, specialProperty, function (props) {
    var unknownProps = (0, _keys2.default)(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });
    if (unknownProps.length > 0) {
      return new TypeError(componentNameInError + ': unknown props found: ' + unknownProps.join(', ') + '. Please remove the unknown properties.');
    }
    return null;
  }));
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(153);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    }
    // Object syntax {fallbacks: {prop: value}}
    else {
        for (var _prop in fallbacks) {
          var _value = fallbacks[_prop];
          if (_value != null) {
            result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
          }
        }
      }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(377);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(155);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _deepmerge = __webpack_require__(156);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _createTypography = __webpack_require__(874);

var _createTypography2 = _interopRequireDefault(_createTypography);

var _createBreakpoints = __webpack_require__(875);

var _createBreakpoints2 = _interopRequireDefault(_createBreakpoints);

var _createPalette = __webpack_require__(876);

var _createPalette2 = _interopRequireDefault(_createPalette);

var _createMixins = __webpack_require__(877);

var _createMixins2 = _interopRequireDefault(_createMixins);

var _shadows = __webpack_require__(878);

var _shadows2 = _interopRequireDefault(_shadows);

var _transitions = __webpack_require__(157);

var _transitions2 = _interopRequireDefault(_transitions);

var _zIndex = __webpack_require__(882);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _spacing = __webpack_require__(883);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$palette = options.palette,
      paletteInput = _options$palette === undefined ? {} : _options$palette,
      _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === undefined ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === undefined ? {} : _options$mixins,
      _options$typography = options.typography,
      typographyInput = _options$typography === undefined ? {} : _options$typography,
      shadowsInput = options.shadows,
      other = (0, _objectWithoutProperties3.default)(options, ['palette', 'breakpoints', 'mixins', 'typography', 'shadows']);


  var palette = (0, _createPalette2.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints2.default)(breakpointsInput);

  var muiTheme = (0, _extends3.default)({
    direction: 'ltr',
    palette: palette,
    typography: (0, _createTypography2.default)(palette, typographyInput),
    mixins: (0, _createMixins2.default)(breakpoints, _spacing2.default, mixinsInput),
    breakpoints: breakpoints,
    shadows: shadowsInput || _shadows2.default
  }, (0, _deepmerge2.default)({
    transitions: _transitions2.default,
    spacing: _spacing2.default,
    zIndex: _zIndex2.default
  }, other));

   false ? (0, _warning2.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;

  return muiTheme;
} // < 1kb payload overhead when lodash/merge is > 3kb.
exports.default = createMuiTheme;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

   false ? (0, _warning2.default)(value >= min && value <= max, 'Material-UI: the value provided ' + value + ' is out of range [' + min + ', ' + max + '].') : void 0;

  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
//  weak
/* eslint-disable no-use-before-define */

function convertHexToRGB(color) {
  color = color.substr(1);

  var re = new RegExp('.{1,' + color.length / 3 + '}', 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? 'rgb(' + colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', ') + ')' : '';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  var type = color.type;
  var values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') > -1) {
    values[1] = values[1] + '%';
    values[2] = values[2] + '%';
  }

  return color.type + '(' + values.join(', ') + ')';
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') > -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } else if (decomposedColor.type.indexOf('hsl') > -1) {
    return decomposedColor.values[2] / 100;
  }

  throw new Error('Material-UI: unsupported `' + color + '` color.');
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in fade(' + color + ', ' + value + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return recomposeColor(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in darken(' + color + ', ' + coefficient + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in lighten(' + color + ', ' + coefficient + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANNEL = undefined;

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Same value used by react-jss
var CHANNEL = exports.CHANNEL = '__THEMING__';

var themeListener = {
  contextTypes: (0, _defineProperty3.default)({}, CHANNEL, _propTypes2.default.object),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};

exports.default = themeListener;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = __webpack_require__(149);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(80);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _assign = __webpack_require__(320);

var _assign2 = _interopRequireDefault(_assign);

exports.withOptions = withOptions;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(205);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _supports = __webpack_require__(898);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return (0, _assign2.default)({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(_supports.passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);


  (0, _keys2.default)(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];
    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
    }
  });
}

function withOptions(handler, options) {
   false ? (0, _warning2.default)(options, 'react-event-listener: should be specified options in withOptions.') : void 0;

  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener = function (_React$Component) {
  (0, _inherits3.default)(EventListener, _React$Component);

  function EventListener() {
    (0, _classCallCheck3.default)(this, EventListener);
    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.removeListeners();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.addListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.applyListeners(on);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      this.applyListeners(off);
    }
  }, {
    key: 'applyListeners',
    value: function applyListeners(onOrOff) {
      var target = this.props.target;


      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(this.props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);
  return EventListener;
}(_react2.default.Component);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: _propTypes2.default.node,
  /**
   * The DOM target to listen to.
   */
  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
} : {};

exports.default = EventListener;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37),
    now = __webpack_require__(899),
    toNumber = __webpack_require__(395);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(397),
    createBind = __webpack_require__(914),
    createCurry = __webpack_require__(915),
    createHybrid = __webpack_require__(401),
    createPartial = __webpack_require__(933),
    getData = __webpack_require__(405),
    mergeData = __webpack_require__(934),
    setData = __webpack_require__(407),
    setWrapToString = __webpack_require__(409),
    toInteger = __webpack_require__(413);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(163),
    baseLodash = __webpack_require__(250);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(925),
    shortOut = __webpack_require__(408);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(410);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(939),
    baseUnary = __webpack_require__(417),
    nodeUtil = __webpack_require__(940);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(82),
    root = __webpack_require__(26);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(953),
    mapCacheDelete = __webpack_require__(960),
    mapCacheGet = __webpack_require__(962),
    mapCacheHas = __webpack_require__(963),
    mapCacheSet = __webpack_require__(964);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(969),
    stubArray = __webpack_require__(422);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(419);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(427);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(989),
    isObjectLike = __webpack_require__(62);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(30),
    isSymbol = __webpack_require__(111);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(160),
    overRest = __webpack_require__(443),
    setToString = __webpack_require__(251);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.7.0
//     http://underscorejs.org
//     (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    concat           = ArrayProto.concat,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind;

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.7.0';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var createCallback = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  _.iteratee = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return createCallback(value, context, argCount);
    if (_.isObject(value)) return _.matches(value);
    return _.property(value);
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    if (obj == null) return obj;
    iteratee = createCallback(iteratee, context);
    var i, length = obj.length;
    if (length === +length) {
      for (i = 0; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    if (obj == null) return [];
    iteratee = _.iteratee(iteratee, context);
    var keys = obj.length !== +obj.length && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length),
        currentKey;
    for (var index = 0; index < length; index++) {
      currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  var reduceError = 'Reduce of empty array with no initial value';

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = function(obj, iteratee, memo, context) {
    if (obj == null) obj = [];
    iteratee = createCallback(iteratee, context, 4);
    var keys = obj.length !== +obj.length && _.keys(obj),
        length = (keys || obj).length,
        index = 0, currentKey;
    if (arguments.length < 3) {
      if (!length) throw new TypeError(reduceError);
      memo = obj[keys ? keys[index++] : index++];
    }
    for (; index < length; index++) {
      currentKey = keys ? keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = function(obj, iteratee, memo, context) {
    if (obj == null) obj = [];
    iteratee = createCallback(iteratee, context, 4);
    var keys = obj.length !== + obj.length && _.keys(obj),
        index = (keys || obj).length,
        currentKey;
    if (arguments.length < 3) {
      if (!index) throw new TypeError(reduceError);
      memo = obj[keys ? keys[--index] : --index];
    }
    while (index--) {
      currentKey = keys ? keys[index] : index;
      memo = iteratee(memo, obj[currentKey], currentKey, obj);
    }
    return memo;
  };

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var result;
    predicate = _.iteratee(predicate, context);
    _.some(obj, function(value, index, list) {
      if (predicate(value, index, list)) {
        result = value;
        return true;
      }
    });
    return result;
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    if (obj == null) return results;
    predicate = _.iteratee(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(_.iteratee(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    if (obj == null) return true;
    predicate = _.iteratee(predicate, context);
    var keys = obj.length !== +obj.length && _.keys(obj),
        length = (keys || obj).length,
        index, currentKey;
    for (index = 0; index < length; index++) {
      currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    if (obj == null) return false;
    predicate = _.iteratee(predicate, context);
    var keys = obj.length !== +obj.length && _.keys(obj),
        length = (keys || obj).length,
        index, currentKey;
    for (index = 0; index < length; index++) {
      currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given value (using `===`).
  // Aliased as `include`.
  _.contains = _.include = function(obj, target) {
    if (obj == null) return false;
    if (obj.length !== +obj.length) obj = _.values(obj);
    return _.indexOf(obj, target) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      return (isFunc ? method : value[method]).apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matches(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matches(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = obj.length === +obj.length ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = _.iteratee(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = obj.length === +obj.length ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = _.iteratee(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = obj && obj.length === +obj.length ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (obj.length !== +obj.length) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = _.iteratee(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = _.iteratee(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = _.iteratee(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = array.length;
    while (low < high) {
      var mid = low + high >>> 1;
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (obj.length === +obj.length) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return obj.length === +obj.length ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = _.iteratee(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    if (n < 0) return [];
    return slice.call(array, 0, n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N. The **guard** check allows it to work with
  // `_.map`.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array. The **guard** check allows it to work with `_.map`.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return slice.call(array, Math.max(array.length - n, 0));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array. The **guard**
  // check allows it to work with `_.map`.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    if (shallow && _.every(input, _.isArray)) {
      return concat.apply(output, input);
    }
    for (var i = 0, length = input.length; i < length; i++) {
      var value = input[i];
      if (!_.isArray(value) && !_.isArguments(value)) {
        if (!strict) output.push(value);
      } else if (shallow) {
        push.apply(output, value);
      } else {
        flatten(value, shallow, strict, output);
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false, []);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (array == null) return [];
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = _.iteratee(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = array.length; i < length; i++) {
      var value = array[i];
      if (isSorted) {
        if (!i || seen !== value) result.push(value);
        seen = value;
      } else if (iteratee) {
        var computed = iteratee(value, i, array);
        if (_.indexOf(seen, computed) < 0) {
          seen.push(computed);
          result.push(value);
        }
      } else if (_.indexOf(result, value) < 0) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true, []));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    if (array == null) return [];
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = array.length; i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(slice.call(arguments, 1), true, true, []);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function(array) {
    if (array == null) return [];
    var length = _.max(arguments, 'length').length;
    var results = Array(length);
    for (var i = 0; i < length; i++) {
      results[i] = _.pluck(arguments, i);
    }
    return results;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    if (list == null) return {};
    var result = {};
    for (var i = 0, length = list.length; i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = function(array, item, isSorted) {
    if (array == null) return -1;
    var i = 0, length = array.length;
    if (isSorted) {
      if (typeof isSorted == 'number') {
        i = isSorted < 0 ? Math.max(0, length + isSorted) : isSorted;
      } else {
        i = _.sortedIndex(array, item);
        return array[i] === item ? i : -1;
      }
    }
    for (; i < length; i++) if (array[i] === item) return i;
    return -1;
  };

  _.lastIndexOf = function(array, item, from) {
    if (array == null) return -1;
    var idx = array.length;
    if (typeof from == 'number') {
      idx = from < 0 ? idx + from + 1 : Math.min(idx, from + 1);
    }
    while (--idx >= 0) if (array[idx] === item) return idx;
    return -1;
  };

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (arguments.length <= 1) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Reusable constructor function for prototype setting.
  var Ctor = function(){};

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    args = slice.call(arguments, 2);
    bound = function() {
      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
      Ctor.prototype = func.prototype;
      var self = new Ctor;
      Ctor.prototype = null;
      var result = func.apply(self, args.concat(slice.call(arguments)));
      if (_.isObject(result)) return result;
      return self;
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    return function() {
      var position = 0;
      var args = boundArgs.slice();
      for (var i = 0, length = args.length; i < length; i++) {
        if (args[i] === _) args[i] = arguments[position++];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return func.apply(this, args);
    };
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = hasher ? hasher.apply(this, arguments) : key;
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = function(func) {
    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
  };

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last > 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed after being called N times.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed before being called N times.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      } else {
        func = null;
      }
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Retrieve the names of an object's properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = function(obj) {
    if (!_.isObject(obj)) return obj;
    var source, prop;
    for (var i = 1, length = arguments.length; i < length; i++) {
      source = arguments[i];
      for (prop in source) {
        if (hasOwnProperty.call(source, prop)) {
            obj[prop] = source[prop];
        }
      }
    }
    return obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(obj, iteratee, context) {
    var result = {}, key;
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      iteratee = createCallback(iteratee, context);
      for (key in obj) {
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
      }
    } else {
      var keys = concat.apply([], slice.call(arguments, 1));
      obj = new Object(obj);
      for (var i = 0, length = keys.length; i < length; i++) {
        key = keys[i];
        if (key in obj) result[key] = obj[key];
      }
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(concat.apply([], slice.call(arguments, 1)), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = function(obj) {
    if (!_.isObject(obj)) return obj;
    for (var i = 1, length = arguments.length; i < length; i++) {
      var source = arguments[i];
      for (var prop in source) {
        if (obj[prop] === void 0) obj[prop] = source[prop];
      }
    }
    return obj;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }
    if (typeof a != 'object' || typeof b != 'object') return false;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }
    // Objects with different constructors are not equivalent, but `Object`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (
      aCtor !== bCtor &&
      // Handle Object.create(x) cases
      'constructor' in a && 'constructor' in b &&
      !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
        _.isFunction(bCtor) && bCtor instanceof bCtor)
    ) {
      return false;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    var size, result;
    // Recursively compare objects and arrays.
    if (className === '[object Array]') {
      // Compare array lengths to determine if a deep comparison is necessary.
      size = a.length;
      result = size === b.length;
      if (result) {
        // Deep compare the contents, ignoring non-numeric properties.
        while (size--) {
          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
        }
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      size = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      result = _.keys(b).length === size;
      if (result) {
        while (size--) {
          // Deep compare each member
          key = keys[size];
          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
        }
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return result;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b, [], []);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (_.isArray(obj) || _.isString(obj) || _.isArguments(obj)) return obj.length === 0;
    for (var key in obj) if (_.has(obj, key)) return false;
    return true;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around an IE 11 bug.
  if (true) {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = function(key) {
    return function(obj) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of `key:value` pairs.
  _.matches = function(attrs) {
    var pairs = _.pairs(attrs), length = pairs.length;
    return function(obj) {
      if (obj == null) return !length;
      obj = new Object(obj);
      for (var i = 0; i < length; i++) {
        var pair = pairs[i], key = pair[0];
        if (pair[1] !== obj[key] || !(key in obj)) return false;
      }
      return true;
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = createCallback(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property) {
    if (object == null) return void 0;
    var value = object[property];
    return _.isFunction(value) ? object[property]() : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(obj) {
    return this._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result.call(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result.call(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result.call(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Menu = __webpack_require__(451);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});

var _MenuList = __webpack_require__(452);

Object.defineProperty(exports, 'MenuList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuList).default;
  }
});

var _MenuItem = __webpack_require__(1066);

Object.defineProperty(exports, 'MenuItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = __webpack_require__(1);

function cloneChildrenWithClassName(children, className) {
  return _react.Children.map(children, function (child) {
    return (0, _react.isValidElement)(child) && (0, _react.cloneElement)(child, {
      className: child.props.hasOwnProperty('className') ? child.props.className + ' ' + className : className
    });
  });
}
/* eslint-disable import/prefer-default-export */

function isMuiElement(element, muiNames) {
  return (0, _react.isValidElement)(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app__ = __webpack_require__(1076);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__app__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__github__ = __webpack_require__(1077);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(1078);
/* unused harmony namespace reexport */


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createGenerateClassName = __webpack_require__(388);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName).default;
  }
});

var _createMuiTheme = __webpack_require__(243);

Object.defineProperty(exports, 'createMuiTheme', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createMuiTheme).default;
  }
});

var _jssPreset = __webpack_require__(382);

Object.defineProperty(exports, 'jssPreset', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_jssPreset).default;
  }
});

var _MuiThemeProvider = __webpack_require__(1086);

Object.defineProperty(exports, 'MuiThemeProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MuiThemeProvider).default;
  }
});

var _withStyles = __webpack_require__(9);

Object.defineProperty(exports, 'withStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withStyles).default;
  }
});

var _withTheme = __webpack_require__(159);

Object.defineProperty(exports, 'withTheme', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withTheme).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(1089);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(1091);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(457);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(152);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.hasValue = hasValue;
exports.isDirty = isDirty;
exports.isAdornedStart = isAdornedStart;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(270);

var _Textarea = __webpack_require__(1099);

var _Textarea2 = _interopRequireDefault(_Textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
}

// Determine if field is dirty (a.k.a. filled).
//
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isDirty(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}

// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function isAdornedStart(obj) {
  return obj.startAdornment;
}

var styles = exports.styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.ease
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';

  return {
    root: {
      // Mimics the default input display property used by browsers for an input.
      display: 'inline-flex',
      alignItems: 'baseline',
      position: 'relative',
      fontFamily: theme.typography.fontFamily,
      color: light ? 'rgba(0, 0, 0, 0.87)' : theme.palette.common.fullWhite,
      fontSize: theme.typography.pxToRem(16)
    },
    formControl: {
      'label + &': {
        marginTop: theme.spacing.unit * 2
      }
    },
    inkbar: {
      '&:after': {
        backgroundColor: theme.palette.primary[light ? 'dark' : 'light'],
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 2,
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      }
    },
    error: {
      '&:after': {
        backgroundColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red
      }
    },
    focused: {},
    disabled: {
      color: theme.palette.text.disabled
    },
    underline: {
      '&:before': {
        backgroundColor: bottomLineColor,
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 1,
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('background-color', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.ease
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&:hover:not($disabled):before': {
        backgroundColor: theme.palette.text.primary,
        height: 2
      },
      '&$disabled:before': {
        background: 'transparent',
        backgroundImage: 'linear-gradient(to right, ' + bottomLineColor + ' 33%, transparent 0%)',
        backgroundPosition: 'left top',
        backgroundRepeat: 'repeat-x',
        backgroundSize: '5px 1px'
      }
    },
    multiline: {
      padding: theme.spacing.unit - 2 + 'px 0 ' + (theme.spacing.unit - 1) + 'px'
    },
    fullWidth: {
      width: '100%'
    },
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: theme.spacing.unit - 2 + 'px 0 ' + (theme.spacing.unit - 1) + 'px',
      border: 0,
      boxSizing: 'content-box',
      verticalAlign: 'middle',
      background: 'none',
      margin: 0, // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: theme.palette.common.transparent,
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder, // Firefox 19+
      '&:-ms-input-placeholder': placeholder, // IE 11
      '&::-ms-input-placeholder': placeholder, // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        appearance: 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden, // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden, // IE 11
        '&::-ms-input-placeholder': placeholderHidden, // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible, // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible, // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
      }
    },
    inputDense: {
      paddingTop: theme.spacing.unit / 2 - 1
    },
    inputDisabled: {
      opacity: 1 // Reset iOS opacity
    },
    inputSingleline: {
      height: '1.1875em' // Reset (19px)
    },
    inputMultiline: {
      resize: 'none',
      padding: 0
    },
    inputSearch: {
      appearance: 'textfield' // Improve type search style.
    }
  };
};

function formControlState(props, context) {
  var disabled = props.disabled;
  var error = props.error;
  var margin = props.margin;

  if (context.muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = context.muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = context.muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = context.muiFormControl.margin;
    }
  }

  return {
    disabled: disabled,
    error: error,
    margin: margin
  };
}

var Input = function (_React$Component) {
  (0, _inherits3.default)(Input, _React$Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.input = null, _this.handleFocus = function (event) {
      // Fix an bug with IE11 where the focus/blur events are triggered
      // while the input is disabled.
      if (formControlState(_this.props, _this.context).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({ focused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleBlur = function (event) {
      _this.setState({ focused: false });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleChange = function (event) {
      if (!_this.isControlled) {
        _this.checkDirty(_this.input);
      }

      // Perform in the willUpdate
      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _this.handleRefInput = function (node) {
      _this.input = node;
      if (_this.props.inputRef) {
        _this.props.inputRef(node);
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        _this.props.inputProps.ref(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Input, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isControlled = this.props.value != null;

      if (this.isControlled) {
        this.checkDirty(this.props);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.input);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!formControlState(this.props, this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        this.setState({
          focused: false
        });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState, nextContext) {
      if (this.isControlled) {
        this.checkDirty(nextProps);
      } // else performed in the onChange

      // Book keep the focused state.
      if (!formControlState(this.props, this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        var muiFormControl = this.context.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }
    }

    // Holds the input reference

  }, {
    key: 'checkDirty',
    value: function checkDirty(obj) {
      var muiFormControl = this.context.muiFormControl;


      if (isDirty(obj)) {
        if (muiFormControl && muiFormControl.onDirty) {
          muiFormControl.onDirty();
        }
        if (this.props.onDirty) {
          this.props.onDirty();
        }
        return;
      }

      if (muiFormControl && muiFormControl.onClean) {
        muiFormControl.onClean();
      }
      if (this.props.onClean) {
        this.props.onClean();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          autoComplete = _props.autoComplete,
          autoFocus = _props.autoFocus,
          classes = _props.classes,
          classNameProp = _props.className,
          defaultValue = _props.defaultValue,
          disabledProp = _props.disabled,
          disableUnderline = _props.disableUnderline,
          endAdornment = _props.endAdornment,
          errorProp = _props.error,
          fullWidth = _props.fullWidth,
          id = _props.id,
          inputComponent = _props.inputComponent,
          _props$inputProps = _props.inputProps;
      _props$inputProps = _props$inputProps === undefined ? {} : _props$inputProps;
      var inputPropsClassName = _props$inputProps.className,
          inputPropsProp = (0, _objectWithoutProperties3.default)(_props$inputProps, ['className']),
          inputRef = _props.inputRef,
          marginProp = _props.margin,
          multiline = _props.multiline,
          name = _props.name,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClean = _props.onClean,
          onDirty = _props.onDirty,
          onFocus = _props.onFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          startAdornment = _props.startAdornment,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoComplete', 'autoFocus', 'classes', 'className', 'defaultValue', 'disabled', 'disableUnderline', 'endAdornment', 'error', 'fullWidth', 'id', 'inputComponent', 'inputProps', 'inputRef', 'margin', 'multiline', 'name', 'onBlur', 'onChange', 'onClean', 'onDirty', 'onFocus', 'onKeyDown', 'onKeyUp', 'placeholder', 'readOnly', 'rows', 'rowsMax', 'startAdornment', 'type', 'value']);
      var muiFormControl = this.context.muiFormControl;

      var _formControlState = formControlState(this.props, this.context),
          disabled = _formControlState.disabled,
          error = _formControlState.error,
          margin = _formControlState.margin;

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty3.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty3.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty3.default)(_classNames, classes.inkbar, !disableUnderline), (0, _defineProperty3.default)(_classNames, classes.multiline, multiline), (0, _defineProperty3.default)(_classNames, classes.underline, !disableUnderline), _classNames), classNameProp);

      var inputClassName = (0, _classnames2.default)(classes.input, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.inputDisabled, disabled), (0, _defineProperty3.default)(_classNames2, classes.inputSingleline, !multiline), (0, _defineProperty3.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty3.default)(_classNames2, classes.inputSearch, type === 'search'), (0, _defineProperty3.default)(_classNames2, classes.inputDense, margin === 'dense'), _classNames2), inputPropsClassName);

      var required = muiFormControl && muiFormControl.required === true;

      var InputComponent = 'input';
      var inputProps = (0, _extends3.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (inputComponent) {
        InputComponent = inputComponent;

        if ((0, _reactHelpers.isMuiComponent)(InputComponent, ['SelectInput'])) {
          inputProps = (0, _extends3.default)({
            selectRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
        }
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _extends3.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea2.default;
        }
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ onBlur: this.handleBlur, onFocus: this.handleFocus, className: className }, other),
        startAdornment,
        _react2.default.createElement(InputComponent, (0, _extends3.default)({
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          className: inputClassName,
          onChange: this.handleChange,
          onKeyUp: onKeyUp,
          onKeyDown: onKeyDown,
          disabled: disabled,
          required: required ? true : undefined,
          value: value,
          id: id,
          name: name,
          defaultValue: defaultValue,
          placeholder: placeholder,
          type: type,
          readOnly: readOnly,
          rows: rows,
          'aria-required': required,
          'aria-invalid': error
        }, inputProps)),
        endAdornment
      );
    }
  }]);
  return Input;
}(_react2.default.Component);

Input.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes2.default.string,
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes2.default.string,
  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes2.default.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes2.default.node,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense', 'none']),
  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes2.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChange: _propTypes2.default.func,
  /**
   * TODO
   */
  onClean: _propTypes2.default.func,
  /**
   * TODO
   */
  onDirty: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes2.default.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes2.default.string,
  /**
   * @ignore
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes2.default.node,
  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes2.default.string,
  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

Input.muiName = 'Input';

Input.defaultProps = {
  disableUnderline: false,
  fullWidth: false,
  multiline: false,
  type: 'text'
};

Input.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInput' })(Input);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(19) && !__webpack_require__(14)(function () {
  return Object.defineProperty(__webpack_require__(177)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(17);


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(31);
var toIObject = __webpack_require__(38);
var arrayIndexOf = __webpack_require__(119)(false);
var IE_PROTO = __webpack_require__(179)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var anObject = __webpack_require__(6);
var getKeys = __webpack_require__(67);

module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(38);
var gOPN = __webpack_require__(70).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(67);
var gOPS = __webpack_require__(120);
var pIE = __webpack_require__(95);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(94);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(14)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(25);
var isObject = __webpack_require__(16);
var invoke = __webpack_require__(282);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 282 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(8).parseInt;
var $trim = __webpack_require__(84).trim;
var ws = __webpack_require__(183);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(8).parseFloat;
var $trim = __webpack_require__(84).trim;

module.exports = 1 / $parseFloat(__webpack_require__(183) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(43);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(16);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 287 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(186);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(6);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(25);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(94);
var toLength = __webpack_require__(21);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(68);
var toLength = __webpack_require__(21);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(19) && /./g.flags != 'g') __webpack_require__(20).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(124)
});


/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(6);
var isObject = __webpack_require__(16);
var newPromiseCapability = __webpack_require__(201);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(297);
var validate = __webpack_require__(86);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(127)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(20).f;
var create = __webpack_require__(69);
var redefineAll = __webpack_require__(74);
var ctx = __webpack_require__(42);
var anInstance = __webpack_require__(72);
var forOf = __webpack_require__(73);
var $iterDefine = __webpack_require__(189);
var step = __webpack_require__(292);
var setSpecies = __webpack_require__(71);
var DESCRIPTORS = __webpack_require__(19);
var fastKey = __webpack_require__(59).fastKey;
var validate = __webpack_require__(86);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(297);
var validate = __webpack_require__(86);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(127)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(51)(0);
var redefine = __webpack_require__(33);
var meta = __webpack_require__(59);
var assign = __webpack_require__(280);
var weak = __webpack_require__(300);
var isObject = __webpack_require__(16);
var fails = __webpack_require__(14);
var validate = __webpack_require__(86);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(127)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(74);
var getWeak = __webpack_require__(59).getWeak;
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(16);
var anInstance = __webpack_require__(72);
var forOf = __webpack_require__(73);
var createArrayMethod = __webpack_require__(51);
var $has = __webpack_require__(31);
var validate = __webpack_require__(86);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(49);
var toLength = __webpack_require__(21);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(70);
var gOPS = __webpack_require__(120);
var anObject = __webpack_require__(6);
var Reflect = __webpack_require__(8).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(121);
var isObject = __webpack_require__(16);
var toLength = __webpack_require__(21);
var ctx = __webpack_require__(42);
var IS_CONCAT_SPREADABLE = __webpack_require__(17)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(21);
var repeat = __webpack_require__(185);
var defined = __webpack_require__(48);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(67);
var toIObject = __webpack_require__(38);
var isEnum = __webpack_require__(95).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(96);
var from = __webpack_require__(307);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(73);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(311);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(687);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(694);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(319);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(206);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(710), __esModule: true };

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(52) && !__webpack_require__(75)(function () {
  return Object.defineProperty(__webpack_require__(208)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(76);
var toIObject = __webpack_require__(87);
var arrayIndexOf = __webpack_require__(713)(false);
var IE_PROTO = __webpack_require__(213)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(325);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(140);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(41);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(328);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(331);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(332);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(223);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(334);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(335);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(336);
/* unused harmony reexport withRouter */



















/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(141);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(723);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(141);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(143);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(223);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null

  /**
   * This reducer will update the state with the most recent location history
   * has transitioned to. This may not be in sync with the router, particularly
   * if you have asynchronously-loaded routes, so reading from and relying on
   * this state is discouraged.
   */
};function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return push; });
/* unused harmony export replace */
/* unused harmony export go */
/* unused harmony export goBack */
/* unused harmony export goForward */
/* unused harmony export routerActions */

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistoid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(78);


function createPersistoid(config) {
  // defaults
  var blacklist = config.blacklist || null;
  var whitelist = config.whitelist || null;
  var transforms = config.transforms || [];
  var throttle = config.throttle || 0;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var serialize = config.serialize === false ? function (x) {
    return x;
  } : defaultSerialize;

  // initialize stateful values
  var lastState = {};
  var stagedState = {};
  var keysToProcess = [];
  var timeIterator = null;
  var writePromise = null;

  var update = function update(state) {
    // add any changed keys to the queue
    Object.keys(state).forEach(function (key) {
      var subState = state[key];
      if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
      if (lastState[key] === state[key]) return; // value unchanged? noop
      if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
      keysToProcess.push(key); // add key to queue
    });

    // start the time iterator if not running (read: throttle)
    if (timeIterator === null) {
      timeIterator = setInterval(processNextKey, throttle);
    }

    lastState = state;
  };

  function processNextKey() {
    if (keysToProcess.length === 0) {
      if (timeIterator) clearInterval(timeIterator);
      timeIterator = null;
      return;
    }

    var key = keysToProcess.shift();
    var endState = transforms.reduce(function (subState, transformer) {
      return transformer.in(subState, key);
    }, lastState[key]);
    if (typeof endState !== 'undefined') stagedWrite(key, endState);
  }

  function stagedWrite(key, endState) {
    try {
      stagedState[key] = serialize(endState);
    } catch (err) {
      console.error('redux-persist/createPersistoid: error serializing state', err);
    }
    if (keysToProcess.length === 0) {
      // cleanup any removed keys just before write.
      Object.keys(stagedState).forEach(function (key) {
        if (lastState[key] === undefined) {
          delete stagedState[key];
        }
      });

      writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1 && key !== '_persist') return false;
    if (blacklist && blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function onWriteFail(err) {
    // @TODO add fail handlers (typically storage full)
    if (err && "production" !== 'production') {
      console.error('Error storing data', err);
    }
  }

  var flush = function flush() {
    while (keysToProcess.length !== 0) {
      processNextKey();
    }
    return writePromise || Promise.resolve();
  };

  // return `persistoid`
  return {
    update: update,
    flush: flush
  };
}

// @NOTE in the future this may be exposed via config
function defaultSerialize(data) {
  return JSON.stringify(data);
}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(78);




function getStoredState(config) {
  var transforms = config.transforms || [];
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  var storage = config.storage;
  var debug = config.debug;
  var deserialize = config.serialize === false ? function (x) {
    return x;
  } : defaultDeserialize;
  return storage.getItem(storageKey).then(function (serialized) {
    if (!serialized) return undefined;else {
      try {
        var state = {};
        var rawState = deserialize(serialized);
        Object.keys(rawState).forEach(function (key) {
          state[key] = transforms.reduceRight(function (subState, transformer) {
            return transformer.out(subState, key);
          }, deserialize(rawState[key]));
        });
        return state;
      } catch (err) {
        if (false) console.log('redux-persist/getStoredState: Error restoring data ' + serialized, err);
        throw err;
      }
    }
  });
}

function defaultDeserialize(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(78);




function purgeStoredState(config) {
  var storage = config.storage;
  var storageKey = '' + (config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* KEY_PREFIX */]) + config.key;
  return storage.removeItem(storageKey, warnIfRemoveError);
}

function warnIfRemoveError(err) {
  if (err && "production" !== 'production') {
    console.error('redux-persist/purgeStoredState: Error purging data stored state', err);
  }
}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
var basename='/';/* istanbul ignore next */if(false){basename='/react-redux-saga-boilerplate/';}var history=__WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default()({basename:basename});history.location=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},history.location,{query:__WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(history.location.search.substr(1)),state:{modal:false,scroll:false}});/* istanbul ignore next */history.listen(function(){history.location=__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},history.location,{query:__WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(history.location.search.substr(1)),state:history.location.state||{}});});/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(220);

var _PathUtils = __webpack_require__(102);

var _createTransitionManager = __webpack_require__(221);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(344);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

exports.arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

exports.isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_helpers__ = __webpack_require__(147);
/**
 * API functions
 * @module API
 *//**
 * Fetch data
 *
 * @param {string} url
 * @param {Object} options
 * @param {string} [options.method] - Request method ( GET, POST, PUT, ... ).
 * @param {string} [options.payload] - Request body.
 * @param {Object} [options.headers]
 *
 * @returns {Promise}
 */function request(url){var _this=this;var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var config=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({method:'GET'},options);var errors=[];if(!url){errors.push('url');}if(!config.payload&&config.method!=='GET'&&config.method!=='DELETE'){errors.push('payload');}if(errors.length){throw new Error('Error! You must pass `'+errors.join('`, `')+'`');}var headers=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({Accept:'application/json','Content-Type':'application/json'},config.headers);var params={headers:headers,method:config.method};if(params.method!=='GET'){params.body=JSON.stringify(config.payload);}return fetch(url,params).then(function(){var _ref=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var error,contentType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(response.status>299)){_context.next=19;break;}error=new __WEBPACK_IMPORTED_MODULE_3_modules_helpers__["a" /* ServerError */](response.statusText);contentType=response.headers.get('content-type');if(!(contentType&&contentType.indexOf('application/json')!==-1)){_context.next=11;break;}_context.t0=response.status;_context.next=7;return response.json();case 7:_context.t1=_context.sent;error.response={status:_context.t0,data:_context.t1};_context.next=16;break;case 11:_context.t2=response.status;_context.next=14;return response.text();case 14:_context.t3=_context.sent;error.response={status:_context.t2,data:_context.t3};case 16:throw error;case 19:return _context.abrupt('return',response);case 20:case'end':return _context.stop();}}},_callee,_this);}));return function(_x2){return _ref.apply(this,arguments);};}()).then(function(response){var contentType=response.headers.get('content-type');if(contentType&&contentType.indexOf('application/json')!==-1){return response.json();}return response.text();});}

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(61);


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(28).document;
module.exports = document && document.documentElement;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(76);
var toObject = __webpack_require__(88);
var IE_PROTO = __webpack_require__(213)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(57);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(105);
var ITERATOR = __webpack_require__(29)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(228);
var ITERATOR = __webpack_require__(29)('iterator');
var Iterators = __webpack_require__(105);
module.exports = __webpack_require__(23).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(57);
var aFunction = __webpack_require__(97);
var SPECIES = __webpack_require__(29)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(56);
var invoke = __webpack_require__(757);
var html = __webpack_require__(349);
var cel = __webpack_require__(208);
var global = __webpack_require__(28);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(100)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(57);
var isObject = __webpack_require__(46);
var newPromiseCapability = __webpack_require__(230);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(28);
var core = __webpack_require__(23);
var dP = __webpack_require__(45);
var DESCRIPTORS = __webpack_require__(52);
var SPECIES = __webpack_require__(29)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(29)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(100);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(322);
var hiddenKeys = __webpack_require__(215).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(139);
var createDesc = __webpack_require__(98);
var toIObject = __webpack_require__(87);
var toPrimitive = __webpack_require__(209);
var has = __webpack_require__(76);
var IE8_DOM_DEFINE = __webpack_require__(321);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(52) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports = [{"id":1,"label":"QCUK","alias":"QCUK (WORKING NAME), NECTAR TRUST (WORKING NAME), QATAR CHARITY UK (OLD NAME)","tags":"qatar-charity,qcuk,history,leadership,sheffield,funding","type":"charity","image":"https://assets.qatar-terror-network.eu/nodes/1.png","country":"gb","description":"QATAR CHARITY UK was registered with the UK Charity Commission on 27 March 2012. Other names listed for the charity are:\n - QATAR CHARITY UK (Old Name)\n - QCUK (Working Name)\n - NECTAR TRUST (Working Name) \n \nThe Mission of QATAR CHARITY UK: ”QCUK will assist and empower individuals and organisations of the most needy in society to improve their social and economic conditions through educational, cultural, economic and humanitarian programmes.”","page":"19, 18","reference":"http://opencharities.org/charities/1146597","reference2":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20140331_E_C.pdf"},{"id":3,"label":"FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE","alias":"FIOE","tags":"sheffield,leadership,qcuk,funding","type":"organization","country":"fr","description":"AKRAM BONHAM is facebook friend with CHAKIB BENMAKHLOUF connected to FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE which is known to be connected to the Global Muslim Brotherhood.","page":9},{"id":6,"label":"EUROPE TRUST","tags":"qcuk,sheffield,leadership,funding,history","type":"charity","country":"gb","description":"This Sheffield, UK mosque complex, near completion or already completed, is the latest in a series of attempts by the EUROPE TRUST to covertly build large Islamic facilities in European cities controlled by the MUSLIM BROTHERHOOD.","page":1},{"id":7,"label":"THE EMAAN TRUST","alias":"AL-EMAAN TRUST, THE SHEFFIELD PROJECT","tags":"qatar-charity,qcuk,sheffield,history,leadership,funding","type":"charity","country":"gb","description":"The third largest QCUK expenditures listed and for 638,695 was for the “Sheffield Project, Emaan Trust that is described as a “multi purposes centre” that will contain a nursery, full-time school, social and cultural centre with a multipurpose hall, in addition to a library and restaurant, a prayer hall, a gym and a car parking.\n \nThe EMAAN TRUST Sheffield project appears to be focused on providing facilities for the Yemeni MUSLIM BROTHERHOOD in the UK and centers on UK converts to Islam. Many of the EMAAN TRUST officers have problematic ties to the MUSLIM BROTHERHOOD, Islamism, and/or terrorism.","page":1},{"id":8,"label":"CATALYST REGENERATION","tags":"sheffield,history,leadership","type":"charity","country":"gb","description":"The Sheffield project had its origins in a July 2006 application to the local planning department for the BOTHAM STREET MOSQUE AND ISLAMIC CENTRE, signed on behalf of CATALYST REGENERATION by AKRAM BONHAM (MCIAT), head of the Building Design Department.\n \n The CATALYST REGENERATION website explains that the company has been providing multi-disciplinary consultancy services to the construction industry for 30 years in the UK, Europe, and the Middle East. Although the CATALYST REGENERATION website identifies many secular building projects, it also lists numerous mosques, Islamic centers, and Islamic educational facilities in its portfolio.","page":42924},{"id":10,"label":"YEMENI MUSLIM BROTHERHOOD UK","tags":"qatar-charity,qcuk,history,leadership,sheffield,funding","type":"terror-organization","image":"https://assets.qatar-terror-network.eu/nodes/10.png","country":"gb","description":"The EMAAN TRUST Sheffield project appears to be focused on providing facilities for the Yemeni MUSLIM BROTHERHOOD in the UK and centers on UK converts to Islam.","page":1},{"id":11,"label":"BOTHAM STREET MOSQUE","tags":"sheffield,history","type":"mosque","country":"gb","description":"The Sheffield project had its origins in a July 2006 application to the local planning department for the BOTHAM STREET MOSQUE AND ISLAMIC CENTRE, signed on behalf of CATALYST REGENERATION by AKRAM BONHAM (MCIAT), head of the Building Design Department.","page":7},{"id":14,"label":"HAMEED AL-ASALY","alias":"HAMEED SALEH ALASALY","tags":"sheffield,leadership,history","type":"person","country":"gb","description":"HAMEED AL-ASALY, of the Birmingham-based CATALYST REGENERATION (UK) LTD was described as managing the project which was reportedly to be funded by Sheffield Muslims, including former World boxing champion NASEEM HAMED. No further activity on the project appears to have taken place until September 2010 when a new planning department les was created with the applicant as HAMEED AL-ASALY who listed the AL-EMAAN TRUST as the company.","page":7,"reference":"https://beta.companieshouse.gov.uk/officers/oDAZvDu4jRpUvhF2w0ZIXLpSQHU/appointments","reference2":"http://www.192.com/atoz/people/al-asaly/hameed/"},{"id":15,"label":"NASEEM HAMED","tags":"sheffield,history","type":"person","country":"gb","description":"NASEEM HAMED former World boxing champion was funding the Sheffield project.","page":7},{"id":17,"label":"OMER AL-HAMDOON","alias":"OMER EL-HAMDOON","tags":"sheffield,history","type":"person","country":"gb","description":"The agent listed for the incorporation of THE EMAAN TRUST was OMER AL-HAMDOON, likely the current President of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and using the address of the MUSLIM WELFARE HOUSE OF SHEFFIELD.\n \nAKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - OMER EL-HAMDOON (MUSLIM ASSOCIATION OF BRITAIN)","page":42925,"reference":"https://www.linkedin.com/authwall?trk=gf&trkInfo=AQG1wOUzWAzlIQAAAV_jC24Q0V_wrSgHxO5d4_IQ1q49xvzpwsyj5hU3sa25qgA6tK-YU7VvZ1_O58MG6n8Hub3WuvxEKd2SmBJ4L7lATADWA8zfafYrfhCYB1ynsDip4W_v4AQ=&originalReferer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fomer-el-hamdoon-a0748336"},{"id":18,"label":"MUSLIM ASSOCIATION OF BRITAIN","alias":"MAB","tags":"sheffield,history,leadership","type":"organization","country":"gb","description":"The agent listed for the incorporation of THE EMAAN TRUST was OMER AL-HAMDOON, likely the current President of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and using the address of the MUSLIM WELFARE HOUSE OF SHEFFIELD.","page":7},{"id":19,"label":"MUSLIM WELFARE HOUSE OF SHEFFIELD","alias":"MWHS","tags":"sheffield,history,leadership","type":"charity","country":"gb","description":"The agent listed for the incorporation of THE EMAAN TRUST was OMER AL-HAMDOON, likely the current President of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and using the address of the MUSLIM WELFARE HOUSE OF SHEFFIELD.","page":7},{"id":20,"label":"SALEH ALI ALNOUD","tags":"sheffield,history","type":"person","country":"gb","description":"Three initial officers of the EMAAN Trust company were listed, all profiled below:\nQatar Charity UK\n - SALEH ALI ALNOUD (Secretary)\n - AIMAN MOHAMMED EBRAHIM SAEED (Director)\n - SALEH MOHAMED HUSSEIN (Director)","page":7,"reference":"https://beta.companieshouse.gov.uk/company/06806357/filing-history/MjAyNDYxNDUxNmFkaXF6a2N4/document?format=pdf&download=0"},{"id":21,"label":"AIMAN MOHAMMED EBRAHIM SAEED","tags":"sheffield,history","type":"person","country":"je","description":"Three initial officers of the EMAAN Trust company were listed, all profiled below:\n Qatar Charity UK\n - SALEH ALI ALNOUD (Secretary)\n - AIMAN MOHAMMED EBRAHIM SAEED (Director)\n - SALEH MOHAMED HUSSEIN (Director)","page":7,"reference":"https://beta.companieshouse.gov.uk/company/06806357/filing-history/MjAyNDYxNDUxNmFkaXF6a2N4/document?format=pdf&download=0"},{"id":22,"label":"SALEH MOHAMED HUSSEIN","tags":"sheffield,history","type":"person","image":"https://assets.qatar-terror-network.eu/nodes/22.png","country":"gb","description":"SALEH MOHAMED HUSSEIN is an 80-year-old British national resident in the UK who has listed his profession as “Travel Agency Owner” and “Trader. He is also a director of the AL RAHMAN MOSQUE AND CULTURAL CENTRE LTD, likely associated with the AL-RAHMAN MOSQUE AND CULTURAL CENTRE in Sheffield.\n \n SALEH MOHAMED HUSSEIN (Director) is an officer of the EMAAN Trust company.","page":"15, 7","reference":"https://beta.companieshouse.gov.uk/company/06806357/filing-history/MjAyNDYxNDUxNmFkaXF6a2N4/document?format=pdf&download=0"},{"id":23,"label":"AL RAHMAN MOSQUE AND CULTURAL CENTRE LTD.","tags":"sheffield","type":"mosque","description":"SALEH MOHAMED HUSSEIN is also a director of the AL RAHMAN MOSQUE AND CULTURAL CENTRE LTD, likely associated with the AL-RAHMAN MOSQUE AND CULTURAL CENTRE in Sheffield.","page":15,"reference":"https://beta.companieshouse.gov.uk/officers/uNpecO0BS-Ky9xGEO39SNjAMozg/appointments"},{"id":24,"label":"HASSAN ALKATIB","tags":"sheffield,leadership,history,qcuk","type":"person","description":"HASSAN ALKATIB is a Leeds resident who has listed his profession as “Property Development Consultant” who was described by UK media as “an active member of the Muslim Brotherhood” and also was a former director of the LEEDS GRAND MOSQUE. ALKATIB is also known to have been an officer in multiple companies tied to the UK MUSLIM BROTHERHOOD.","page":7,"reference":"https://beta.companieshouse.gov.uk/officers/Jwp13aRpTq96TNcvumU7jaA_184/appointments"},{"id":25,"label":"LEEDS GRAND MOSQUE","tags":"qcuk,sheffield,history,leadership","type":"mosque","country":"gb","description":"HASSAN ALKATIB is a Leeds resident who has listed his profession as “Property Development Consultant” who was described by UK media as “an active member of the Muslim Brotherhood” and also was a former director of the LEEDS GRAND MOSQUE.","page":7},{"id":26,"label":"UK MUSLIM BROTHERHOOD","tags":"qcuk,leadership,sheffield,history,funding","type":"terror-organization","image":"https://assets.qatar-terror-network.eu/nodes/26.png","country":"gb","description":"HASSAN ALKATIB is a Leeds resident who has listed his profession as “Property Development Consultant” who was described by UK media as “an active member of the Muslim Brotherhood” and also was a former director of the LEEDS GRAND MOSQUE. ALKATIB is also known to have been an officer in multiple companies tied to the UK MUSLIM BROTHERHOOD.","page":7},{"id":30,"label":"ABDULRAZAQ BUQARA","alias":"ABDERREZAK BOUGARA","tags":"sheffield,leadership","type":"person","image":"https://assets.qatar-terror-network.eu/nodes/30.png","description":"ABDERREZAK BOUGARA is a Mathematics Teacher at the Meadowhead School in Sheffield, works at the Birley Community College, and is a Muslim Religious Advisor at the University of Sheffield.","page":12,"reference":"http://opencharities.org/charities/1131861"},{"id":32,"label":"AHMED AL-RAWI","tags":"sheffield,leadership,qcuk","type":"person","image":"https://assets.qatar-terror-network.eu/nodes/32.png","country":"gb","description":"AHMED AL-RAWI is a 69-year-old British national resident in England who is best known as the former President of both the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and the MUSLIM ASSOCIATION OF BRITAIN (MAB). He is currently the head of the EUROPE TRUST and has been extensively profiled in other reports.","page":9,"reference":"http://opencharities.org/charities/1131861"},{"id":35,"label":"SHEFFIELD MUSLIMS","tags":"sheffield","type":"group","country":"gb","description":"HAMEED AL-ASALY, of the Birmingham-based CATALYST REGENERATION (UK) LTD was described as managing the project which was reportedly to be funded by Sheffield Muslims, including former World boxing champion NASEEM HAMED.","page":7,"reference":"https://www.thestar.co.uk/lifestyle/features/why-plans-for-a-new-mosque-have-split-this-city-community-1-336205"},{"id":36,"label":"MOKHTAR BADRI","tags":"sheffield,history","type":"person","description":"The document also identifies MOKHTAR BADRI as the Project Manager with a Wembley address associated with the MUSLIM ASSOCIATION OF BRITAIN (MAB). In 2008, UK media identified MOKHTAR BADRI as the vice-president of the MAB.","page":44,"reference":"http://www.telegraph.co.uk/news/religion/3212112/Protests-expected-as-woman-leads-Muslim-prayers-in-Britain-for-first-time.html"},{"id":37,"label":"KUWAIT","tags":"sheffield,funding","type":"country","image":"https://assets.qatar-terror-network.eu/countries/kuwait.png","country":"kw","description":"EMAAN TRUST reports to the UK Charity Commission contain the following information about the source of the charity’s donors and finances: In 2013 contributions for the Sheffield project came from Kuwait £402,763.","page":8,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends61/0001131861_AC_20130131_E_C.pdf"},{"id":38,"label":"UNITED KINGDOM","tags":"sheffield,funding","type":"country","image":"https://assets.qatar-terror-network.eu/countries/united-kingdom.png","country":"gb","description":"EMAAN TRUST reports to the UK Charity Commission contain the following information about the source of the charity’s donors and finances: In 2013 contributions for the Sheffield project came from UK £42,171.","page":8,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends61/0001131861_AC_20130131_E_C.pdf"},{"id":39,"label":"UAE","tags":"sheffield,funding","type":"country","image":"https://assets.qatar-terror-network.eu/countries/united-arab-emirates.png","country":"ae","description":"EMAAN TRUST reports to the UK Charity Commission contain the following information about the source of the charity’s donors and finances: In 2013 contributions for the Sheffield project came from UAE £1,485.","page":8,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends61/0001131861_AC_20130131_E_C.pdf"},{"id":40,"label":"QATAR","tags":"sheffield,funding","type":"country","image":"https://assets.qatar-terror-network.eu/countries/qatar.png","country":"qa","description":"EMAAN TRUST reports to the UK Charity Commission contain the following information about the source of the charity’s donors and finances: In 2013 contributions for the Sheffield project came from Qatar £397,043.\n \n In the QCUK annual report, its stated that bankers for QCUK are the AL-RYAN BANK, formerly the ISLAMIC BANK OF BRITAIN that is known to provide banking services for MUSLIM BROTHERHOOD / HAMAS organizations in the UK and which was majority-owned by the QATAR INTERNATIONAL ISLAMIC BANK.","page":"7,8","reference":"14 Qatar Charity UK Trustee’s Report and  nancial Statements For the Year Ended 31 March 2015\rhttp://apps.charitycommission.gov.uk/Accounts/ Ends97/0001146597_AC_20150331_E_C.pdf\r\n15 BREAKING NEWS: Important U.K. Palestinian/ Hamas Charity Reports Facing Closure : http://www.globalmbwatch.com/2008/11/19/breaking- news-important-uk-union-of-good-organization- reports-facing-closure/\r\n16 Islamic banking UK: Islamic Bank of Britain re-branded to Al Rayan Bank as number of non- Muslim investors grows - Qatar’s Masraf Al Rayan | City A.M. : http://www.cityam.com/1414071782/ islamic-bank-britain-gets-rebrand\r\n17 Qatari shareholder helps Islamic Bank of Brit- ain narrow loss - Al Arabiya English : http:// english.alarabiya.net/en/business/banking-and-  nance/2013/04/30/Qatari-lender-helps-Islamic- Bank-of-Britain-narrow-loss.html\r\n18 Financial history : http://apps.charitycommission. gov.uk/Showcharity/RegisterOfCharities/Financial- History.aspx?RegisteredCharityNumber=1146597& SubsidiaryNumber=0\r\n19 Qatar Charity UK Trustee’s Report and  nancial Statements For the Year Ended 31 March 2015"},{"id":41,"label":"MINISTRY OF AWQAF IN KUWAIT","alias":"MINISTRY OF WAQF","tags":"sheffield,funding,leadership","type":"government","image":"https://assets.qatar-terror-network.eu/nodes/islamic-affairs-kuwait.png","country":"kw","description":"In 2014 it was reported that the Ministry of Awqaf in Kuwait donated £85,753 to the Emaan School and to Administration costs.’","page":"8,12","reference":"http://apps.charitycommission.gov.uk/Accounts/Ends61/0001131861_AC_20140131_E_C.pdf"},{"id":42,"label":"TRACY AL-ASALY","alias":"TRACY A ALASALY","tags":"sheffield,leadership","type":"person","image":"https://assets.qatar-terror-network.eu/nodes/42.png","country":"gb","description":"TRACY AL-ASALY is a 51-year-old British national resident in England who runs a Proofreading & Editing Service in Sheffield and who describes herself as a “qualified adult tutor” who does proofreading for university students nationwide as well as commercial work.\n \n HAMEED AL-ASALY was married to TRACY A ALASALY in Sheffield in October 1997.","page":8,"reference":"http://search.findmypast.co.uk/record?id=bmd%2fm%2f1997%2f10%2f90682524"},{"id":43,"label":"HUMAN APPEAL INTERNATIONAL","alias":"HAI","tags":"sheffield,leadership","type":"charity","country":"gb","description":"HAMEED AL-ASALY is also known to be or have been affiliated with the following six organizations, all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - HUMAN APPEAL INTERNATIONAL (HAI).\n - MUSLIMAAT SHEFFIELD ASSOCIATION OF\n MUSLIM WOMEN AND GIRLS, associated with the FATIMA COMMUNITY CENTRE, likely tied to the Muslim Association of Britain (MAB).\n - NATIVE EUROPEAN MUSLIM ASSOCIATION (NEMA), an organization centered on new Islamic converts and discussed later in this report.\n - MUATH TRUST.\n - MUSLIM ASSOCIATION OF BRITAIN (MAB).\n - MUSLIM STUDENTS SOCIETY UK & EIRE\n (MSSUK)","page":8,"reference":"https://www.linkedin.com/in/hameed-al-asaly-83359050"},{"id":45,"label":"NATIVE EUROPEAN MUSLIM ASSOCIATION","alias":"NEMA","tags":"sheffield,leadership","type":"organization","country":"gb","description":"HAMEED AL-ASALY is also known to be or have been affiliated with the following six organizations, all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - HUMAN APPEAL INTERNATIONAL (HAI).\n - MUSLIMAAT SHEFFIELD ASSOCIATION OF\n MUSLIM WOMEN AND GIRLS, associated with the FATIMA COMMUNITY CENTRE, likely tied to the Muslim Association of Britain (MAB).\n - NATIVE EUROPEAN MUSLIM ASSOCIATION (NEMA), an organization centered on new Islamic converts and discussed later in this report.\n - MUATH TRUST.\n - MUSLIM ASSOCIATION OF BRITAIN (MAB).\n - MUSLIM STUDENTS SOCIETY UK & EIRE\n (MSSUK)","page":8,"reference":"https://www.linkedin.com/in/hameed-al-asaly-83359050"},{"id":46,"label":"MUATH TRUST","tags":"sheffield","type":"charity","country":"gb","description":"HAMEED AL-ASALY is also known to be or have been affiliated with the following six organizations, all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - HUMAN APPEAL INTERNATIONAL (HAI).\n - MUSLIMAAT SHEFFIELD ASSOCIATION OF\n MUSLIM WOMEN AND GIRLS, associated with the FATIMA COMMUNITY CENTRE, likely tied to the Muslim Association of Britain (MAB).\n - NATIVE EUROPEAN MUSLIM ASSOCIATION (NEMA), an organization centered on new Islamic converts and discussed later in this report.\n - MUATH TRUST.\n - MUSLIM ASSOCIATION OF BRITAIN (MAB).\n - MUSLIM STUDENTS SOCIETY UK & EIRE\n (MSSUK)","page":8,"reference":"https://www.linkedin.com/in/hameed-al-asaly-83359050"},{"id":47,"label":"MUSLIM STUDENTS SOCIETY UK & EIRE","alias":"MSSUK","tags":"sheffield","type":"charity","country":"gb","description":"HAMEED AL-ASALY is also known to be or have been affiliated with the following six organizations, all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - HUMAN APPEAL INTERNATIONAL (HAI).\n - MUSLIMAAT SHEFFIELD ASSOCIATION OF\n MUSLIM WOMEN AND GIRLS, associated with the FATIMA COMMUNITY CENTRE, likely tied to the Muslim Association of Britain (MAB).\n - NATIVE EUROPEAN MUSLIM ASSOCIATION (NEMA), an organization centered on new Islamic converts and discussed later in this report.\n - MUATH TRUST.\n - MUSLIM ASSOCIATION OF BRITAIN (MAB).\n - MUSLIM STUDENTS SOCIETY UK & EIRE\n (MSSUK)","page":8,"reference":"https://www.linkedin.com/in/hameed-al-asaly-83359050"},{"id":48,"label":"GLOBAL MUSLIM BROTHERHOOD","tags":"qatar-charity,qcuk,history,leadership,sheffield,funding","type":"terror-organization","image":"https://assets.qatar-terror-network.eu/nodes/48.png","description":"Most of the EMAAN TRUST officers have problematic ties to the UK and/or global MUSLIM BROTHERHOOD, Islamism, and/or extremism and terrorism.\n \nQCUK has strong ties to the UK and European MUSLIM BROTHERHOOD and most of the known QCUK expenditures are being directed to MUSLIM BROTHERHOOD related projects in the UK and Europe.","page":1},{"id":49,"label":"FATIMA COMMUNITY CENTRE","tags":"sheffield,leadership","type":"charity","country":"gb","description":"MUSLIMAAT SHEFFIELD ASSOCIATION OF MUSLIM WOMEN AND GIRLS, associated with the FATIMA COMMUNITY CENTRE, likely tied to the Muslim Association of Britain (MAB).","page":8,"reference":"http://heyevent.uk/venue/el3wl24ezezima"},{"id":50,"label":"SUNNA SPORTS LTD","tags":"sheffield","type":"organization","country":"gb","description":"TRACY ALASALY was also the sole director of a now-dissolved sports company known as SUNNA SPORTS LTD.","page":8,"reference":"https://beta.companieshouse.gov.uk/officers/EGpaFTpkIKOxWZ-34V_M4XUHA14/appointments"},{"id":51,"label":"ANAS ALTIKRITI","tags":"sheffield","type":"person","country":"gb","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ANAS ALTIKRITI","reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"id":52,"label":"MAB BIRMINGHAM","tags":"sheffield","type":"charity","country":"gb","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - MAB BIRMINGHAM","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"id":53,"label":"HANY ELDEEB","tags":"sheffield","type":"person","country":"gb","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - HANY ELDEEB (Muslim Welfare House, FIOE, NEMA, Egyptian Muslim Brotherhood)","page":42956,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"id":54,"label":"ADNAN SAIF","alias":"ADNAN ABDUL RAHMAN SAIF","tags":"sheffield","type":"person","country":"gb","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"id":55,"label":"EGYPTIAN MUSLIM BROTHERHOOD","tags":"qcuk,history,leadership,sheffield","type":"terror-organization","image":"https://assets.qatar-terror-network.eu/nodes/55.png","country":"eg","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - HANY ELDEEB (Egyptian Muslim Brotherhood)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"id":56,"label":"BRITISH MUSLIM HERITAGE CENTRE","tags":"sheffield","type":"charity","country":"gb","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"id":57,"label":"ISLAMIC RELIEF (WORLDWIDE)","tags":"sheffield","type":"organization","country":"gb","description":"A number of EMAAN TRUST officers are listed as her facebook friends as well as other individuals of interest including:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)\n \n KHALID AL-MATHKOOR: Chairman of the SHEIKH ABDULLAH AL-NOURI CHARITY SOCIETY, a Kuwait charity that is described by ISLAMIC RELIEF WORLDWIDE as a close partner.","page":42956,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl","reference2":"http://www.islamic-relief.org/event-held-to-mark-30th-anniversary/"},{"id":58,"label":"MARK BONHAM","alias":"AKRAM BONHAM","tags":"sheffield,leadership,history","type":"person","image":"https://assets.qatar-terror-network.eu/nodes/58.png","country":"gb","description":"MARK BONHAM as a 50-year-old British national resident in England based on multiple sources is highly likely the same individual referred to in this report as AKRAM BONHAM and an Islamic convert who adopted Akram as an Arabic surname.","page":8},{"id":59,"label":"BARB SERVICES LTD. UK","tags":"sheffield,leadership","type":"organization","country":"gb","description":"From 1996 through 2008, it ways Mark Bonham was the Managing Director for BARB SERVICES LTD. UK an architectural consulting firm in Birmingham.","page":8},{"id":60,"label":"TISEER TRUST","tags":"sheffield,leadership","type":"charity","country":"gb","description":"From 1996 through 2008, it ways Mark Bonham was the Managing Director for BARB SERVICES LTD. UK an architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - EUROPE TRUST \n - TISEER TRUST \n - RIGHTSTART FOUNDATION \n - ASSOCIATION OF MUSLIM SCHOOLS UK","page":8},{"id":61,"label":"RIGHTSTART FOUNDATION","tags":"sheffield,leadership","type":"charity","country":"gb","description":"From 1996 through 2008, it ways Mark Bonham was the Managing Director for BARB SERVICES LTD. UK an architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - EUROPE TRUST \n - TISEER TRUST \n - RIGHTSTART FOUNDATION \n - ASSOCIATION OF MUSLIM SCHOOLS UK","page":8},{"id":62,"label":"ASSOCIATION OF MUSLIM SCHOOLS UK","tags":"sheffield,leadership","type":"organization","country":"gb","description":"From 1996 through 2008, it ways Mark Bonham was the Managing Director for BARB SERVICES LTD. UK an architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - EUROPE TRUST \n - TISEER TRUST \n - RIGHTSTART FOUNDATION \n - ASSOCIATION OF MUSLIM SCHOOLS UK","page":8},{"id":63,"label":"BONHAM REYNOLDS PROJECT MANAGEMENT","tags":"sheffield","type":"organization","country":"gb","description":"BONHAM was employed from 1980 through 1996 as a director OF BONHAM REYNOLDS PROJECT MANAGEMENT, a business & management consultancy.","page":9,"reference":"https://companycheck.co.uk/company/02516288/BONHAM-REYNOLDS-PROJECT-MANAGEMENT-LIMITED/companies-house-data"},{"id":64,"label":"KEITH WILLIAM REYNOLDS","tags":"sheffield","type":"person","country":"gb","description":"BONHAM was employed from 1980 through 1996 as a director OF BONHAM REYNOLDS PROJECT MANAGEMENT, a business & management consultancy that also included KEITH WILLIAM REYNOLDS as a director.","page":9},{"id":65,"label":"HAMDI BONHAM REYNOLDS (INTERNATIONAL) LIMITED","tags":"sheffield","type":"organization","country":"ae","description":"BONHAM REYNOLDS PROJECT MANAGEMENT is known to have had at least 10 UK corporate affiliations including as a director in 1992 of HAMDI BONHAM REYNOLDS (INTERNATIONAL) LIMITED, an engineering company with one address in Sharjah, UAE.","page":9,"reference":"https://companycheck.co.uk/company/02737946/HAMDI-BONHAM-REYNOLDS-INTERNATIONAL-LIMITED/companies-house-data"},{"id":66,"label":"H E SHEIKH HAMAD BIN NASSER AL THANI","tags":"qcuk,history","type":"person","country":"qa","description":"The London office of QCUK was formally opened in June 2014 by a QATAR CHARITY (QC) delegation headed by QC Chairman H E SHEIKH HAMAD BIN NASSER AL THANI and QC CEO YUSUF BIN AHMED AL KUWARI.","page":17,"reference":"http://thepeninsulaqatar.com/news/qatar/286763/qatar-charity-opens-uk-office\n"},{"id":67,"label":"YUSUF BIN AHMED AL KUWARI","alias":"YOUSUF AHMAD AL-KUWARI","tags":"qcuk,history","type":"person","country":"qa","description":"The London office of QCUK was formally opened in June 2014 by a QATAR CHARITY (QC) delegation headed by QC Chairman H E SHEIKH HAMAD BIN NASSER AL THANI and QC CEO YUSUF BIN AHMED AL KUWARI.\n \nYOUSUF AHMAD AL-KUWARI- Qatari National was previously Head of Information Technology for the QATAR MINISTRY OF ENDOWMENTS AND ISLAMIC AFFAIRS.","page":"20, 3","reference":"http://thepeninsulaqatar.com/news/qatar/286763/qatar-charity-opens-uk-office\n"},{"id":68,"label":"SALAH AHMED AL-HAMMADI","tags":"qcuk,leadership,history","type":"person","country":"qa","description":"According to UK corporate records, SALAH AHMED AL-HAMMADI is a 33-year-old Qatari national who was described in March 2016 by Italian media reports as Vice-President of the English headquarters of the QATAR CHARITY and responsible for projects in Europe.","page":22,"reference":"https://beta.companieshouse.gov.uk/compa- ny/08006947/ ling-history/MzEyMzIzMzMxN- 2FkaXF6a2N4/document?format=pdf&download=0\n","reference2":"http://bergamo.corriere. it/notizie/cronaca/16_marzo_04/qatar-rivuole-suo- denaro-la-moschea-valuteremo-futuro-8e14af6c- e20e-11e5-b31b-034bb632a08d.shtml\n"},{"id":69,"label":"QATAR MINISTRY OF ENDOWMENTS AND ISLAMIC AFFAIRS","tags":"qcuk","type":"government","country":"qa","description":"YOUSUF AHMAD AL-KUWARI - Qatari National who is QATAR CHARITY’s CEO; previously Head of Information Technology for the QATAR MINISTRY OF ENDOWMENTS AND ISLAMIC AFFAIRS.","page":3},{"id":70,"label":"AYYOUB ABOULIAQIN","tags":"qcuk,history,leadership","type":"person","country":"qa","description":"AYYOUB ABOULIAQIN, national and QCUK Director General): member of the Conseil D'administration of the ASSOCIATION DES MUSULMANS D'ALSACE (AMAL), affiliated with the MUSLIM BROTHERHOOD in France.\n \nIn a June 2014 Arabic-language interview, QCUK’s General-Manager AYYOUB ABOULIYAQIN stressed the importance of choosing the UK as a base of operation, saying that almost half of Qatar’s foreign investments went there and that the UK has a long history of involvement in humanitarian work. ABOULIYAQIN added that QC’s headquarters in Qatar operates 110 cultural programs in cooperation with 58 European organizations. Altogether, in the previous 5 years, QC spent almost half a billion Riyals (almost $ 140 million) on such programs.","page":"3,18","reference":"http://www.al-sharq.com/news/details/244312"},{"id":71,"label":"ASSOCIATION DES MUSULMANS D'ALSACE","alias":"AMAL","tags":"qcuk,history,leadership","type":"organization","country":"fr","description":"AYYOUB ABOULIAQIN - member of the Conseil D'administration of the ASSOCIATION DES MUSULMANS D'ALSACE (AMAL), affiliated with the MUSLIM BROTHERHOOD in France.","page":3},{"id":72,"label":"HAFEZ AHMAD AHMAD","alias":"HAFEZ AL-KARMI","tags":"qcuk,leadership,history","type":"person","country":"jo","description":"HAFEZ AHMAD AHMAD (born on 21 April 1961) is a British national resident in England who was appointed as a QCUK Director on 14 January 2013 and who resigned on 4 February 2016. He listed his Occupation as “Director” and used a QCUK address as his correspondence address.\n \n Given that HAFEZ AHMAD AHMAD AND HAFEZ AL-KARMI use the same address and have the same date of birth, it is believed that these are in fact the same individuals. is would appear to be confirmed by theuse of ANAS AHMAD and ANAS ALKARMI by an individual believed to be the son and who is listed as ANAS AHMAD at the same London address and by the use of both names in UK Charity Commission documents.","page":"32,4","reference":"https://beta.companieshouse.gov.uk/company/08006947/officers"},{"id":73,"label":"PALESTINIAN FORUM IN BRITAIN","alias":"PFB","tags":"qcuk,leadership","type":"organization","country":"ps","description":"A full profile of the PFB is beyond the scope of this report but has been described as follows:\nThe Palestinian Forum in Britain (PFB) is part of the UK Muslim Brotherhood and Hamas support infrastructure.\n \nHafez Ahmad Ahmad is a former Director of QCUK. He is highly relevant in understanding the charity’s history British national resident in England and likely an alias for HAFEZ AL-KARMI, best known as a leader in the PALESTINIAN FORUM IN BRITAIN (PFB), a part of the UK MUSLIM BROTHERHOOD and HAMAS support infrastructure.","page":"33, 4","reference":"https://www.globalmbwatch.com/palestinian-forum-in-britain/"},{"id":74,"label":"HAMAS","tags":"qcuk,history,leadership,sheffield,funding","type":"terror-organization","country":"ps","description":"One of the former Directors of QCUK is highly relevant in understanding the charity’s history British national resident in England and likely an alias for HAFEZ AL-KARMI, best known as a leader in the PALESTINIAN FORUM IN BRITAIN (PFB), a part of the UK MUSLIM BROTHERHOOD and HAMAS support infrastructure.","page":4},{"id":75,"label":"KASSIM BIN MOHAMMED AL - THANI MAYFAIR ISLAMIC CENTRE","alias":"MIC, QATAR ISLAMIC CENTRE","tags":"qcuk","type":"charity","country":"qa","description":"HAFEZ AHMAD AHMAD is also the Charity manager for the KASSIM BIN MOHAMMED AL-THANI MAYFAIR ISLAMIC CENTRE (MIC), named for the founder of Qatar and formerly known as the QATAR ISLAMIC CENTRE.","page":32,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends12/0001075012_AC_20150331_E_C.pdf"},{"id":76,"label":"MINISTRY OF AWKAF AND ISLAMIC AFFAIRS","type":"government","country":"qa","description":"The MIC receives significant donations each year from the MINISTRY OF AWKAF AND ISLAMIC AFFAIRS in Qatar and since 2011, the MIC has received £2,872,267 from the State of Qatar. In turn, it has distributed an estimated £874,768 to various charities and organizations ranging from £1,500-£38,855 to numerous groups all known to be tied to the Muslim Brotherhood in the UK. In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"id":80,"label":"FINSBURY MOSQUE","type":"mosque","country":"gb","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"id":81,"label":"PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","type":"organization","country":"ps","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"id":82,"label":"AL-RAHMAN MOSQUE AND CULTURAL CENTRE SHEFFIELD","tags":"sheffield","type":"mosque","country":"gb","description":"SALEH MOHAMED HUSSEIN is an 80-year-old British national resident in the UK who has listed his profession as “Travel Agency Owner” and “Trader. He is also a director of the AL RAHMAN MOSQUE AND CULTURAL CENTRE LTD, likely associated with the AL-RAHMAN MOSQUE AND CULTURAL CENTRE in Sheffield.","page":15,"reference":"https://beta.companieshouse.gov.uk/officers/uNpecO0BS-Ky9xGEO39SNjAMozg/appointments"},{"id":83,"label":"MUSLIM WELFARE HOUSE","alias":"MWH","tags":"sheffield","type":"charity","country":"gb","description":"The MUSLIM WELFARE HOUSE has been mentioned several times in this report and known to be part of the MUSLIM BROTHERHOOD in the UK.","page":62},{"id":84,"label":"ZAHID PARVEZ","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- ZAHID PARVEZ (MARKFIELD INSTITUTE)","page":9},{"id":85,"label":"JACOB VAN DER BLOM","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- JACOB VAN DER BLOM (EUROPE TRUST NETHERLANDS)","page":9,"reference":"http://www.carelbrendel.nl/2013/07/20/paleisrevolutie-binnen-de-blauwe-moskee-yahia-bouyafa-maakt-comeback/"},{"id":86,"label":"MOHAMMED SAIF","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - MOHAMMED SAIF (QATAR FOUNDATION)","page":9},{"id":87,"label":"HANY EL BANNA","alias":"HANY ELBANNA, HANY EL-BANNA OBE","tags":"sheffield,qcuk,history","type":"person","country":"gb","description":"The UK Charity Commission currently lists four trustees and one contact person for Zakat House. The best known of these trustees is Dr. HANY ELBANNA who is listed as the Founder and Chair of Trustees on the Zakat House website.\n \n AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- HANY EL BANNA (ISLAMIC RELIEF, MUSLIM CHARITIES FORUM","page":"21, 9","reference":"http://apps.charitycommission.gov.uk/Showcharity/RegisterOfCharities/PrintReport.aspx?RegisteredCharityNumber=1130399&ReportType=COLOUR"},{"id":89,"label":"HUSSEIN NAGI","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation:\n - HUSSEIN NAGI (HUMAN APPEAL INTERNATIONAL)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":90,"label":"GEHAD EL-HADDAD","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- GEHAD EL-HADDAD (EGYPTIAN MUSLIM BROTHERHOOD)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":91,"label":"CHAKIB BENMAKHLOUF","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- CHAKIB BENMAKHLOUF (FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":92,"label":"MOHAMMED KOZBAR","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- MOHAMMED KOZBAR (MUSLIM ASSOCIATION OF BRITAIN, FINSBURY MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":93,"label":"TOUFIK KACIMI","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- TOUFIK KACIMI (MUSLIM WELFARE HOUSE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":94,"label":"BASHIR OSMAN","tags":"sheffield","type":"person","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- BASHIR OSMAN (FOSIS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":96,"label":"MARKFIELD INSTITUTE","tags":"sheffield","type":"organization","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- ZAHID PARVEZ (MARKFIELD INSTITUTE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":97,"label":"EUROPE TRUST NETHERLANDS","tags":"sheffield","type":"organization","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- JACOB VAN DER BLOM (EUROPE TRUST NETHERLANDS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":98,"label":"QATAR FOUNDATION","tags":"sheffield","type":"organization","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- MOHAMMED SAIF (QATAR FOUNDATION)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":99,"label":"MUSLIM CHARITIES FORUM","tags":"sheffield","type":"charity","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- HANY EL BANNA (ISLAMIC RELIEF, MUSLIM CHARITIES FORUM)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":101,"label":"MUSLIM ASSOCIATION OF BRITAIN","tags":"sheffield","type":"organization","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- MOHAMMED KOZBAR (MUSLIM ASSOCIATION OF BRITAIN, FINSBURY MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":102,"label":"FEDERATION OF STUDENT ISLAMIC SOCIETIES","alias":"FOSIS","tags":"sheffield","type":"organization","country":"gb","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n- BASHIR OSMAN (FEDERATION OF STUDENT ISLAMIC SOCIETIES - FOSIS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"id":103,"label":"KHALID AL-MATHKOOR","alias":"KHALID ALMATHKOUR","tags":"sheffield,leadership","type":"person","country":"kw","description":"KHALID ALMATHKOUR as a 70-year-old Kuwaiti national resident in Kuwait who obtained a Ph.D. in Comparative Jurisprudence from AL- AZHAR UNIVERSITY in 1978 and who is a Professor in Comparative Jurisprudence and Shariah governance and politics at the Faculty of Shariah, University of Kuwait.","page":9,"reference":"https://beta.companieshouse.gov.uk/officers/3pLFgnLKyGlg34DKvlA4U8EqpOU/appointments"},{"id":104,"label":"DIWAN AMIRI","tags":"sheffield","type":"headquarter","country":"kw","description":"KHALID AL-MATHKOOR holds the following positions in Kuwait: Chairman of the SUPREME ADVISORY COMMITTEE FOR THE COMPLETION OF THE IMPLEMENTATION SHARIAH of the Diwan Amiri in Kuwait.","page":9},{"id":105,"label":"INTERNATIONAL ISLAMIC FIQH ACADEMY","tags":"sheffield","type":"organization","country":"kw","description":"KHALID AL-MATHKOOR Representative member of Kuwait at INTERNATIONAL ISLAMIC FIQH ACADEMY OF THE ORGANIZATION OF ISLAMIC CONFERENCE Jeddah.","page":9},{"id":106,"label":"THE ORGANIZATION OF ISLAMIC CONFERENCE JEDDAH","tags":"sheffield","type":"organization","country":"kw","description":"KHALID AL-MATHKOOR Representative member of Kuwait at INTERNATIONAL ISLAMIC FIQH ACADEMY OF THE ORGANIZATION OF ISLAMIC CONFERENCE Jeddah.","page":9},{"id":107,"label":"SHEIKH ABDULLAH AL-NOURI CHARITY SOCIETY","tags":"sheffield","type":"charity","country":"kw","description":"KHALID AL-MATHKOOR Chairman of the SHEIKH ABDULLAH AL-NOURI CHARITY SOCIETY, a Kuwait charity that is described by ISLAMIC RELIEF WORLDWIDE as a close partner.","page":9,"reference":"http://www.kuna.net.kw/ArticlePrintPage.aspx?id=2068125&language=en"},{"id":108,"label":"INTERNATIONAL ISLAMIC CHARITY ORGANIZATION","alias":"IICO","tags":"sheffield","type":"charity","country":"kw","description":"KHALID AL-MATHKOOR Member of the General Assembly of the INTERNATIONAL ISLAMIC CHARITY ORGANIZATION (IICO), strongly tied to the Global MUSLIM BROTHERHOOD.","page":9,"reference":"http://www.kuna.net.kw/ArticlePrintPage.aspx?id=2068125&language=en"},{"id":109,"label":"SOCIAL REPORT SOCIETY","tags":"sheffield","type":"organization","country":"kw","description":"KHALID AL-MATHKOOR Member of the SOCIAL REPORT SOCIETY, the charitable arm of the MUSLIM BROTHERHOOD in Kuwait.","page":9},{"id":110,"label":"MUSLIM BROTHERHOOD KUWAIT","tags":"sheffield","type":"terror-organization","country":"kw","description":"KHALID AL-MATHKOOR Member of the SOCIAL REPORT SOCIETY, the charitable arm of the MUSLIM BROTHERHOOD in Kuwait.","page":9},{"id":111,"label":"FATWA AND SHARIA's SUPERVISORY BOARD","tags":"sheffield","type":"organization","country":"kw","description":"KHALID AL-MATHKOOR Member of the Fatwa and Shari’a Supervisory Board for a number of companies and Islamic financial institutions.","page":9},{"id":112,"label":"MUTLAQ AL-QARAWI","tags":"sheffield,leadership","type":"person","country":"kw","description":"MUTLAQ AL-QARAWI is a 64-year-old Kuwaiti national resident in Kuwait is best known as an official of the MINISTRY OF AWQAF & ISLAMIC AFFAIRS in Kuwait where he has been referred to variously as Assistant Undersecretary, director of the media Department, Assistant Undersecretary for Technical A airs and Foreign Affairs, Assistant Undersecretary.","page":10,"reference":"http://cms.islam.gov.kw/Pages/en/NewsDetails.aspx?newsId=138"},{"id":113,"label":"WORLD MODERATION CENTER","alias":"INTERNATIONAL MODERATION CENTRE IMC","tags":"sheffield,leadership","type":"organization","country":"kw","description":"MUTLAQ AL-QARAWI In his role at the Ministry, AL-QARAWI was active in the Kuwaiti WORLD MODERATION CENTER (aka INTERNATIONAL MODERATION CENTRE IMC), headed by ESSAM AL-BASHIR of Sudan, a gure closely tied to the GLOBAL MUSLIM BROTHERHOOD.","page":10,"reference":"https://wikileaks.org/plusd/cables/06KUWAIT4610_a.html#_jmp0_"},{"id":114,"label":"ESSAM AL-BASHIR","tags":"sheffield,leadership","type":"person","country":"sd","description":"In his role at the Ministry, AL-QARAWI was active in the Kuwaiti WORLD MODERATION CENTER (aka INTERNATIONAL MODERATION CENTRE IMC), headed by ESSAM AL-BASHIR of Sudan, a gure closely tied to the GLOBAL MUSLIM BROTHERHOOD.","page":10,"reference":"https://wikileaks.org/plusd/cables/06KUWAIT4610_a.html#_jmp0_"},{"id":115,"label":"BLAUWE MOSKEE IN SLOTERVAART","alias":"BLUE MOSQUE IN SLOTERVAART","tags":"sheffield,leadership","type":"mosque","country":"nl","description":"AL-QARAWI has attracted substantial media attention in the Netherlands in connection with his role in the BLAUWE MOSKEE IN SLOTERVAART (Blue Mosque in Slotervaart), a mosque and cultural center in Amsterdam that was initially funded by the EUROPE TRUST, headed by AHMED AL-RAWI with whom AL-QARAWI has had a long-standing relationship.","page":10,"reference":"http://www.carelbrendel.nl/2013/06/03/blauwe-moskeeruzie-zet-zich-voort-met-publiciteit-over-koeweitse-invloed/"},{"id":116,"label":"ISLAMIC SOCIETY OF NORTH AMERICA","alias":"ISNA","tags":"sheffield,leadership","type":"organization","country":"us","description":"On 29 March 2013, MUTLAQ AL-QARAWI was part of a Kuwaiti delegation that attended an education forum of the ISLAMIC SOCIETY OF NORTH AMERICA (ISNA) in Rosemont, Illinois. ISNA is a large Islamic umbrella group central to the MUSLIM BROTHERHOOD in the US.","page":10,"reference":"https://www.globalmbwatch.com/islamic-society-of-north-america/","reference2":"http://muslimobserver.com/another-successful-education-forum/"},{"id":117,"label":"MUSLIM BROTHERHOOD US","tags":"sheffield,leadership,funding","type":"terror-organization","country":"us","description":"On 29 March 2013, MUTLAQ AL-QARAWI was part of a Kuwaiti delegation that attended an education forum of the ISLAMIC SOCIETY OF NORTH AMERICA (ISNA) in Rosemont, Illinois. ISNA is a large Islamic umbrella group central to the MUSLIM BROTHERHOOD in the US.","page":10,"reference":"https://www.globalmbwatch.com/islamic-society-of-north-america/"},{"id":118,"label":"THE NATIONAL ASSOCIATION OF SCHOOLMASTERS UNION OF WOMAN TEACHERS","alias":"NASUWT","tags":"sheffield,leadership","type":"organization","country":"gb","description":"ABDULRAZAQ BUQARA From February 2013 – February\n 2014, he was also the President of the NASUWT (the teachers’ Union).","page":12},{"id":119,"label":"MUSLIM ASSOCIATION OF BRITAIN CHARITABLE TRUST","alias":"MAB CHARITABLE TRUST","tags":"sheffield,leadership","type":"organization","country":"gb","description":"ABDULRAZAQ BUQARA is also a past chairman of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and a current director of the MAB CHARITABLE TRUST.","page":12,"reference":"https://www.globalmbwatch.com/muslim-association-of-britain/","reference2":"https://www.thestar.co.uk/whats-on/out-and-about/church-leaders-unite-in-a-show-of-faith-against-extremism-1-240789 "},{"id":120,"label":"RABIA4","tags":"sheffield","type":"organization","country":"gb","description":"ABDULRAZAQ BUQARA A photo on his facebook page displays the RABIA4 symbol, associated with support for the MUSLIM BROTHERHOOD.","page":12},{"id":121,"label":"AMINA BLAKE","alias":"AMEENA ALI, AMENNA BLAKE","tags":"sheffield,leadership","type":"person","country":"gb","description":"AMINA BLAKE, also known as AMEENA ALI, is a 41-year-old British national resident in England who had adopted parents and who converted to Islam in her late teens. She has worked as an English teacher for the Sheffield City Council and currently describes herself as a “Strategic planning and leadership consultant” for unidentified organizations, also has numerous affiliations to groups associated with the UK and global MUSLIM BROTHERHOOD.","page":12,"reference":"https://beta.companieshouse.gov.uk/officers/zgsXqjU9Nnl5PiHJTdg2TobvmSA/appointments"},{"id":122,"label":"MUSLIM COUNCIL OF BRITAIN","alias":"MCB","tags":"sheffield,leadership","type":"organization","country":"gb","description":"AMINA BLAKE has numerous affliations to groups associated with the UK and global MUSLIM BROTHERHOOD, including: Offcial of the MUSLIM COUNCIL OF BRITAIN (MCB)","page":12,"reference":"http://www.dailymail.co.uk/news/article-3417578/Ofsted-inspectors-ordered-mark-schools-allowing-pupils-wear-veil-harming-education.html"},{"id":123,"label":"TIES CENTER","tags":"sheffield,leadership","type":"charity","country":"kw","description":"AMINA BLAKE has numerous affliations to groups associated with the UK and global MUSLIM BROTHERHOOD, including: Trustee of TIES (charity whose trustees are officials of the MUSLIM WELFARE HOUSE and WAMY)","page":12,"reference":"http://apps.charitycommission.gov.uk/Showcharity/RegisterOfCharities/ContactAndTrustees.aspx?RegisteredCharityNumber=1168269&SubsidiaryNumber=0"},{"id":124,"label":"EDEN HOUSES","tags":"sheffield","type":"charity","country":"gb","description":"AMINA BLAKE Director of EDEN HOUSES, as female only, part time staffed supported accommodation for ladies (and their children) and whose head office is at the MUSLIM WELFARE HOUSE in London.","page":12,"reference":"http://www.edenhousesuk.com/about_us"},{"id":125,"label":"STOCKHOLM MOSQUE","tags":"sheffield","type":"mosque","country":"gb","description":"AMINA BLAKE She has spoken at a variety of mosques in the UK and in 2016 spoke at at the STOCKHOLM MOSQUE, likely the same mosque that is associated with the MUSLIM BROTHERHOOD in Sweden.","page":12},{"id":126,"label":"MUSLIM BROTHERHOOD SWEDEN","tags":"history,leadership,sheffield,funding","type":"terror-organization","country":"se","description":"AMINA BLAKE She has spoken at a variety of mosques in the UK and in 2016 spoke at at the STOCKHOLM MOSQUE, likely the same mosque that is associated with the MUSLIM BROTHERHOOD in Sweden.","page":12},{"id":127,"label":"GRAND MOSQUE KUWAIT","tags":"sheffield","type":"mosque","country":"kw","description":"AMINA BLAKE She was scheduled to speak at a mosque in Kuwait in a talk sponsored by the GRAND MOSQUE in association with the MINISTRY OF WAQF and in November 2014 was in Kuwait giving lectures.","page":12},{"id":128,"label":"INTERNATIONAL ISLAMIC COUNCIL FOR DA’WAH AND RELIEF","alias":"IICDR","tags":"sheffield","type":"organization","country":"eg","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: Attended multiple meetings of the INTERNATIONAL ISLAMIC COUNCIL FOR DA’WAH AND RELIEF (IICDR), a Cairo- umbrella group for 86 Islamic organizations, many of which are associated with the global Muslim Brotherhood, Hamas fundraising, or financial/material support of Al Qaeda.","page":12,"reference":"https://www.globalmbwatch.com/international-islamic-council-for-dawa-and-relief/"},{"id":129,"label":"NICK CLEGG","tags":"sheffield","type":"person","country":"gb","description":"In October 2014 AMINA BLAKE was at an Eid Reception of then deputy prime minister NICK CLEGG.","page":12},{"id":130,"label":"TALAT AHMED","tags":"sheffield","type":"person","country":"gb","description":"AMEENA BLAKE Her friends of interest include: TALAT AHMED – HR advisor Islamic Relief UK","page":13},{"id":131,"label":"ATEEQ SALIK","tags":"sheffield","type":"person","country":"gb","description":"AMEENA BLAKE Her friends of interest include: ATEEQ SALIK – Manager Islamic Relief UK","page":13},{"id":132,"label":"SHEIKH ABOMAZEN","tags":"sheffield","type":"person","country":"gb","description":"AMEENA BLAKE Her friends of interest include: SHEIKH ABOMAZEN – who seems to be connected with the Egyptian MB in the UK","page":13},{"id":133,"label":"ADEL ABDULLAH AL-FALAH","alias":"ADEL AL-FALAH","tags":"sheffield,leadership","type":"person","country":"kw","description":"ADEL ABDULLAH AL-FALAH Is 63-year-old Kuwaiti national who has been the Undersecretary of the Kuwait Ministry of Awqaf and Islamic Affairs Since 1991, he has also been the Vice President of the Supreme Committee of Working towards Completing the Implementation of the Islamic Shariah of the Amiri Diwan. An Arab Times Kuwait report from 27 August 2014 said that the Deputy Prime Minister was not expected to renew the position of ADEL AL- FALAH at the Ministry of Awqaf and appeared to link him TO MUSLIM BROTHERHOOD activity in the country. It could not be confirmed whether or not AL-FALAH is currently employed by the Ministry.","page":14,"reference":"http://www.iicowric.org/en/pdf/Dr.%20Adel%20Abdullah%20Al-Falah.pdf"},{"id":134,"label":"AL QAEDA","alias":"AL-QAIDA, EL KAIDA, AL-KAIDA","tags":"qcuk,history,leadership,sheffield,funding","type":"terror-organization","description":"ADEL ABDULLAH AL-FALAH attended multiple meetings of the INTERNATIONAL ISLAMIC COUNCIL FOR DA’WAH AND RELIEF (IICDR) , a Cairo- umbrella group for 86 Islamic organizations, many of which are associated with the global Muslim Brotherhood, Hamas fundraising, or nancial/material support of Al Qaeda.","page":14,"reference":"https://www.globalmbwatch.com/international-islamic-council-for-dawa-and-relief/"},{"id":135,"label":"INTERNATIONAL SUPPORT ORGANIZATION","alias":"ISO","tags":"sheffield","type":"organization","description":"INTERNATIONAL SUPPORT ORGANIZATION (ISO), headed by Global Muslim Brotherhood leader YOUSSEF QARADAWI.","page":14,"reference":"http://www.da.gov.kw/eng/newsroom/newsDetails.php?id=1965"},{"id":136,"label":"YOUSSEF QARADAWI","tags":"sheffield","type":"person","description":"INTERNATIONAL SUPPORT ORGANIZATION (ISO), headed by Global Muslim Brotherhood leader YOUSSEF QARADAWI.","page":14,"reference":"http://www.da.gov.kw/eng/newsroom/newsDetails.php?id=1965"},{"id":137,"label":"KHALID BIN RASHID AL MANSOURI","tags":"qcuk,history","type":"person","country":"qa","description":"At the QCUK opening KHALID BIN RASHID AL MANSOURI Qatari Ambassador, a high-level delegation from the Qatari embassy was also present.","page":17},{"id":138,"label":"SALMAN GALADARI","tags":"qcuk,history","type":"person","description":"Also at the opening was SALMAN GALADARI the Managing Director of the new office of QCUK.\n \n Galadari gave a presentation on QC and its goals and work, pointing out that the main goal is to support social and economic progress of the most disadvantaged in the UK and other European countries, help strengthen society there, help improve e ciency with which donations are collected in these countries and work with charitable organisations to support humanitarian work in general. He said the o ce will provide an opportunity for Qatari investors and businesses in the UK to carry out their social responsibility.","page":17,"reference":"http://thepeninsulaqatar.com/news/qatar/286763/qatar-charity-opens-uk-office"},{"id":139,"label":"SALEH SAEED","tags":"qcuk,history","type":"person","country":"gb","description":"QATAR CHARITY UK (QCUK) was incorporated on 26 March 2012 by an agent identified as SALEH SAEED using an address in West Bromwich UK.\n \nAccording to UK corporate records, SALEH SAEED is also a director of the following three companies:\n- ZAKAT HOUSE\n- YEMENI COMMUNITY ASSOCIATION IN SANDWELL LIMITED\n- DISASTERS EMERGENCY COMMITTEE","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/jACfFs5p4Yh5C9QvGRzZiHlN3DSHCYwjZvBiQ3nQZaA/application-pdf"},{"id":140,"label":"ZAKAT HOUSE","tags":"qcuk,history","type":"organization","country":"gb","description":"Zakat House was set up in 2009 to support and work with new and growing charities to make the charity sector sustainable and efficient. We do this by offering affordable office space and office services and resources to support these charities.\n \nAccording to UK corporate records, SALEH SAEED is also a director of the following company: ZAKAT HOUSE","page":"21, 20","reference":"http://zakat-house.com/"},{"id":141,"label":"YEMENI COMMUNITY ASSOCIATION IN SANDWELL LIMITED","tags":"qcuk,history","type":"organization","country":"gb","description":"According to UK corporate records, SALEH SAEED is also a director of the following company: YEMENI COMMUNITY ASSOCIATION IN SANDWELL LIMITED","page":20},{"id":142,"label":"DISASTERS EMERGENCY COMMITTEE","tags":"qcuk,history","type":"organization","country":"gb","description":"According to UK corporate records, SALEH SAEED is also a director of the following company: DISASTERS EMERGENCY COMMITTEE","page":20},{"id":143,"label":"JASSIM SALEM AL-ANSARI","tags":"qcuk,history","type":"person","country":"qa","description":"JASSIM SALEM AL-ANSARI (Qatari, Aid Worker) was one of the three directors from QCUK. Other two: YOUSUF AHMAD AL-KUWARI, Qatari, CEO of QATAR CHARITY and YOUSUF AHMED HASSAN AL-HAMMADI, Qatari, businessman.\n\nQATAR CHARITY UK corporate documents indicate that subsequently, the following important changes were made: \nOn 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed:\n-  AHMED AHMED, British\n- IJAZ AHMAD, British\n- SALMAN MOHAMMED ALI A. M. KALDARI, Qatari\n- MOHAMMED ALI AL-GHAMDI, Qatari","page":20,"reference":"https://beta.companieshouse.gov.uk/company/08006947/filing-history","reference2":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/WUriqQ1-gZSoYI6OXuQVmM8GYpr5lttEIgeBjf3WS4Y/application-pdf?AWSAccessKeyId=ASIAJCGELG2R4P3S32QA&Expires=1511161849&Signature=fpQ41PbGz0YYKt5SRr0E9GuGmlo%3D&x-amz-security-token=FQoDYXdzEM3%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDCLavOVuNcbdRjjrhSK3A1Oq7mFT6DCKfYP7%2ByKbzQNyfX6HWCGBbZCn2PSKZaHplJ8NhjK%2F03PxJ4zt%2FHgs9nUJPj0qBeBmu4HoK25eKZycHHnSl1Z6rcvvE9RugSlQGfEtzHQopwpGGr8i79mu5%2FpptdbGwo779piJ07tjkfzGKrb5Xws5RRKcFJE5PCoYcrNK3ZGkiaLuDjdDfBJxqBYZ%2BSMIqoAxdeMtq2MCLkm6boEq7cMC7aSsdtaavSayYs5JFpBZO15HmV%2FlKH0PNb72gVIo1bipIKYbAIWtedv5NgYQ3q%2FLaq7hR5JSXw0qs6HNkiNlGQtajRYy%2FQTFm2z86JoKMpEbkCrL7zXjk8plP1dz86ME95rGDpqnuyzFZ5rCLh%2BO9UDMPWlIUm6NjPLmiD9OCy5bKByRd1mmZuMd2b0Wu99pzx%2BTdztviBeQC%2FhZMjhkOfmiRv%2FTwgwC1wndGev6lDmIiFqNu0RzSFUEWC9H8uXso2xlLUxUgjAtUcSB41aEloSGm7ffyMB%2BjbHwGTXn69YgRxPU6SRRXgycDQGEird0JlFhF%2BehpeHrxah2WGKEPpVF7hvG9gfi5JisSPULls8o1Z3J0AU%3D"},{"id":144,"label":"YOUSUF AHMED HASSAN AL-HAMMADI","alias":"YOUSUF AL-HAMMADI","tags":"qcuk,history","type":"person","country":"qa","description":"QATAR CHARITY UK corporate documents indicate that subsequently, the following important changes were made: \n On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed: \n- HAFEZ AHMED AHMED, British\n- IJAZ AHMAD, British\n- SALMAN MOHAMMED ALI A. M. KALDARI, Qatari\n- MOHAMMED ALI AL-GHAMDI, Qatari","page":20,"reference":"https://beta.companieshouse.gov.uk/company/08006947/filing-history","reference2":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/cecxTR9trBwn15wiqkUTMCyC-9ir6yUFcOGNJJvbOmQ/application-pdf?AWSAccessKeyId=ASIAJ6LILDVNVD3EZTKQ&Expires=1511161967&Signature=wnOP1cmy01vU3EtclvOSADD4zHg%3D&x-amz-security-token=FQoDYXdzEM%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDATV7SbKYuKOCm8mliK3A8chsXFXGhmBb0evMTrVqo0elp4TaUq9mubCHmc5HCCjST1%2FOR%2FErG1VehBS0DX9DCGIxXxAiWIzXXisC%2BZyQ3xhg0gjoGS4li1DBGd4nWfqaAkuw9OVUZ7%2BX2FqBGYEj0p3ChbqOSrppHK7oaYJZazQMCKPL1qW3huxpActdm5H%2F8I9PM7e9guMENmjILyHNVz8EIaoHYqqIXjl9QCrrx07WACqAbqmDcHxF5yKw%2BCxN53MEC8cj4hUaNRwU%2BhBSYiqHT4P9EKajDI5o81zjHwNyV8Cer8w8Oc4j%2Be78jJt0fAhSbNgtJHYEB0ReDk220YUH2NFovNuKBuv4POm7f1%2BZDf70onzG8NewZVxJrE8VhpC2sB9K48TKYXzWpKgnq84lua%2BejQG5d4Z24v8DoGejZ2czxFiz4gQTp7gQyyL0Ex8Sgq53YLqVzsSQfNt4bnyjNKpOO9DiOek72YiN6qOnwCMDeGTzoQK9p7V2opgYzGwTAjgRgDItUTPKKiz6X2kFw0cbDrmpQXs7axZJ6Z6KAnMFF0DrGXCBswe2aTiHnOynDzYm2qSmn%2Bl9W7IyeG8VXjLCl0oqtjJ0AU%3D"},{"id":146,"label":"MOHAMMED SAADON AL-KUWARI","tags":"qcuk,history","type":"person","country":"qa","description":"On 10 April 2015 two new directors were appointed: \n- MOHAMMED SAADON AL-KUWARI, Qatari, director\n- SALAH AHMED AL-HAMMADI, Qatari, director","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/dTHqGuIGkj_fwmZanp7S0hAHUWaIULWzaxXVybh036M/application-pdf?AWSAccessKeyId=ASIAJNDNV57TVXXVBH7A&Expires=1511163478&Signature=RcrV4cwk9poOjbJv3142SmBRhs4%3D&x-amz-security-token=FQoDYXdzEM7%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDE0Hs%2BWUFBjU5WZB4SK3Ayu8PZ5dO%2Fk2mwdiy0pGtBQScdGuqzd2eo1yC8nKBDzjJse%2FbnrZ5YSZewOOyqRC6MqOq2ZUbe1165rUpb8eCWsp0avkf%2BsBxuXdRByGhtyOhmK%2F%2BlxjCvIm%2FrMS4MwkV3rTg8JhfidKmu3RLQRCqQCUBw5suflaREzYrGjV3Qz6mN6eeyBhqdA%2BEQPjcgcbfUX%2FqKRaFLw2Kp01WX2RQ6FVYoC13Ja9HmqxhFu%2BvCk1hEiuPtUO%2Fb1cYkAXZkO3%2FPf1ujkv0HDlXQjVnMCxGQjFKFKTmAy7nE9JS2ySioC4AQjtv3ztb6nAUWP0MccbSM2hspPuisX48KUY%2Fwlco46AFBUNKba9YoPZNp%2BiKnwv66xr3TjFqDyxf8%2FKE3PVxr%2BDN6Fza11%2Boe%2FdbjtjyYil5dbZF8t5M8MsgalxHuPVWHFBGynMpw17i8DdJhI1w%2BBBtMyTyhk1i%2B9gDRrbPeQkA3zS%2B%2FJYCEPr%2FwJUxbmY112I0V9pZWRjBsLyh3MRSaYEFgHYZrToh4xHcHUjkB4uovHilUcEhyv3ntVtnfV2Oqqb5neo3dxSAyotOa67m5fW8MpSpBso2rrJ0AU%3D","reference2":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/aPr6PQEtne8uJVKA099vHWfcgkdmY3Lj5WTWqpsy5nY/application-pdf?AWSAccessKeyId=ASIAJD2MA2FP33Y2BULQ&Expires=1511163477&Signature=xQJ0EuzkzcepqmfTlB%2BhYA8%2B6ZM%3D&x-amz-security-token=FQoDYXdzEM3%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDElzkNxwkbvjNDiujCK3AwqQIb3qe%2Ff6TbZHYv3y97n%2FbQR0yocQy1c0HRxBhG0A6J9DTRbM0CSDL%2Bv3m2yCSmCMPtJXRifl8CHOX8UM5hKIqoeODPQqa90pnHb6cv3IJI%2BEPd8lYNTli3V3s5LeKxhv77gLPsC7%2B%2FlNcTBjz4zhuWArdSmKIcJS8%2BxnLxTPw2jG7IfAR%2F%2BBE2Zm69kguii6iFKZpVPpbMCpHGJaR2bU00Do%2BnGNhPzOQcBm00YThV3uBTg2tmY2wO7MWnUFSLcN7zXAKg2WewvGcGl%2B4GGCC%2FUaadcm6oIYsJh%2By4TrAl%2F7f2%2BUZDcObeBdh8JsNbDeht6h5HoszzqkEZvS5ck%2BomqWKh0edg5NKVX1kU4EphpvQ8I2kLZIPKk8P6RkqIOqf1gnt795iGBpXz0Lq0HqwaL4sIXczi7TN5LqnsXbbIyUeWzGPaoDcAlofVt4nxYHRCktjr5AI%2B5913%2Fqu6nDBq%2F2blvRtO3Dlgc6WDXfJwgCTT%2BlnmBJcN9eP2Xrtv9bsosrRdWx9wqqfc67KwW8y5M9ZWaj4%2FgEe33rCnDHrJFbEGl%2BSMNoly%2FxOZOwkS39foFIx4Mo5KrJ0AU%3D"},{"id":148,"label":"QATAR CHARITY","alias":"QC","tags":"qatar-charity,sheffield,qcuk,leadership,funding,history","type":"charity","country":"qa","description":"This report shows how Qatar has opened a branch of one of its most important funding infrastructures – Qatar Charity (QC) - at the heart of Europe’s financial center London and is coordinating and funding Islamist projects in the West through this entity. While the official data demonstrate that funding for such projects in the UK is in the range of few millions of Pounds, the information distributed by the Charity itself shows that hundreds of millions of Pounds are likely invested in various other European countries.","page":3},{"id":149,"label":"MUSLIM BROTHERHOOD FRANCE","tags":"qcuk,history,leadership,sheffield,funding","type":"terror-organization","country":"fr","description":"AYYOUB ABOULIAQIN- (national and QCUK Director General; member of the Conseil D'administration of the ASSOCIATION DES MUSULMANS D'ALSACE (AMAL), affiliated with the MUSLIM BROTHERHOOD in France.","page":3},{"id":150,"label":"IJAZ AHMAD","tags":"qcuk,history","type":"person","country":"gb","description":"On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed: \n- IJAZ AHMAD, British","page":20},{"id":151,"label":"SALMAN MOHAMMED ALI A. M. KALDARI","tags":"qcuk,history","type":"person","country":"qa","description":"On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed: \n- MOHAMMED SAADON AL-KUWARI, Qatari, director","page":20},{"id":152,"label":"MUSLIMAAT SHEFFIELD","tags":"qcuk,history,sheffield,leadership","type":"person","country":"qa","description":"On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed: \n- MOHAMMED ALI AL-GHAMDI, Qatari","page":20},{"id":156,"label":"AL-RYAN BANK","alias":"ISLAMIC BANK OF BRITAIN","tags":"sheffield,funding","type":"bank","country":"gb","description":"According to the QCUK annual reports, bankers for QCUK are the AL-RYAN BANK, formerly the ISLAMIC BANK OF BRITAIN that is known to provide banking services for MUSLIM BROTHERHOOD/HAMAS organizations in the UK and which was majority-owned by the QATAR INTERNATIONAL ISLAMIC BANK.","page":19,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":157,"label":"QATAR INTERNATIONAL ISLAMIC BANK","tags":"sheffield,funding","type":"bank","country":"qa","description":"According to the QCUK annual reports, bankers\nfor QCUK are the AL-RYAN BANK, formerly\nthe ISLAMIC BANK OF BRITAIN that is\nknown to provide banking services for MUSLIM BROTHERHOOD/HAMAS organizations in the UK and which was majority-owned by the QATAR INTERNATIONAL ISLAMIC BANK.","page":19,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":158,"label":"MUSLIM BROTHERHOOD EUROPE","tags":"sheffield,leadership,qcuk,funding,history","type":"terror-organization","description":"FEDERATION\nOF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and its French member the UNION DES ORGANISATIONS ISLAMIQUES DE FRANCE (UOIF), both organizations representing THE MUSLIM BROTHERHOOD in Europe.","page":36,"reference":"https://www.globalmbwatch.com/institut-europeen-des-sciences-humaines/"},{"id":159,"label":"SYRIA EMERGENCY","tags":"qcuk,funding","type":"organization","country":"sy","description":"According to the 2014 QCUK report to the Charity Commission, only £1,084 was expended on programmatic charitable activity with the remainder of the expenditures going for operating expenses.\n\nAttachement: 10.Statement of Funds: £535 was funded by Syria Emergency in 2014. ","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":160,"label":"SADQA","tags":"qcuk,funding","type":"organization","description":"According to the 2014 QCUK report to the Charity Commission, only £1,084 was expended on programmatic charitable activity with the remainder of the expenditures going for operating expenses.\n\nAttachement: 10.Statement of Funds: £25 was funded by Sadqa in 2014.","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":161,"label":"COMMUNITY DEVELOPMENT","tags":"qcuk,funding","type":"project","country":"gb","description":"The bulk of the funds, £2,069,615, was spent on “Community Development.” According to the report:\n This figure consists of three restricted projects for the development of the community. Two projects will be implemented for the UK and one will be designed for Europe. These community development projects will fund, either fully or partially, the purchase or construction of community centres where marriage functions can be hosted, the youth can be involved in sports activities, day care centres for mothers, prayer areas, shops and classrooms for teaching Arabic language and for tuition.\n No further information was available about these projects.","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":162,"label":"EIHS IN CHATEAU CHINON","alias":"EUROPEAN INSTITUTE OF HUMAN \nSCIENCES (EIHS),\nINSTITUT EUROPÉEN DES SCIENCES HUMAINES (IEHS)","tags":"qcuk,funding,leadership","type":"organization","country":"fr","description":"The second largest QCUK expenditures listed and \nfor £736,690 was for the “EIHS in Chateau Chinon.”\n\nThe EIHS in presumably the same organization as the INSTITUT EUROPÉEN DES SCIENCES HUMAINES (IESH), an educational and imam training facility in France associated with the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and its French member the UNION DES ORGANISATIONS ISLAMIQUES DE FRANCE (UOIF), both organizations representing THE MUSLIM BROTHERHOOD in Europe.\n\nThis project comprises establishing new buildings, where the Institute wishes to expand and revamp its premises to transform from an institute to a university campus which will include apartments for married students and others for single students, modern classroom equipped with distance learning technologies, a lecture hall and providing places for sports. Due diligence was still continuing on this restricted grant on the date of signing of these accounts.","page":"36,37","reference":"https://www.globalmbwatch.com/institut-europeen-des-sciences-humaines/","reference2":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":163,"label":"UNION DES ORGANISATIONS ISLAMIQUES DE FRANCE","alias":"UOIF","tags":"qcuk,funding,leadership","type":"organization","country":"fr","description":"The EIHS in presumably the same organization as  the INSTITUT EUROPÉEN DES SCIENCES HUMAINES (IESH), an educational and imam training facility in France associated with the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and its French member the UNION DES ORGANISATIONS ISLAMIQUES DE FRANCE (UOIF), both organizations representing THE MUSLIM BROTHERHOOD in Europe.","page":36,"reference":"https://www.globalmbwatch.com/institut-europeen-des-sciences-humaines/"},{"id":164,"label":"SWANSEA UNIVERSITY CAMPUS","tags":"qcuk,funding","type":"university","country":"gb","description":"The fourth largest QCUK expenditures listed and for £85,318 was for the “Swanse University Campus” and described as follows:\n is restricted grant from Qatar Charity will be utilised to build a Lecture theatre, meeting rooms, administrative offices, crèche providing childcare, classrooms for teach Arabic language, a prayer hall and car parking. Due diligence was still continuing on this restricted grant on the date of signing of these accounts. \nIt is likely, but not confirmed, that the above mentioned construction projects relate to the mosque known to \nbe located on the campus of SWANSEA University in Swansea, Wales.","page":37,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":165,"label":"MULTIPURPOSE CENTER MULHOUSE","tags":"qcuk,funding","type":"organization","country":"gb","description":"The  fifth largest QCUK expenditures listed and for £56,530 was for the “Multipurpose Center Mulhouse.” This funding presumably is the same project referred to in the document as the “AL Huda Project in Illzach (Suburb of Mulhouse)”, explained as follows:\nAfter the completion of internal due diligence it was decided not to continue with this restricted grant.  e trustees of QCUK will now decide to re-assign this restricted funding to another community centre project after con rming approval from the donor of this funding, Qatar Charity.","page":37,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":166,"label":"UKRAINE STUDENTS","tags":"qcuk,funding","type":"project","country":"gb","description":"The sixth largest QCUK expenditures listed and for £31,244 was for the “Swanse University Campus” and described as follows: is restricted grant from Qatar Charity will contribute to the payment of university fee installments for 20 university students to enable them to complete their studies. The beneficiaries have either no funds or are especially needy. Due diligence was still continuing on this restricted grant on the date of signing of these accounts. No further information was available on this project. However, it should be noted that the website of the ALL-UKRAINIAN ASSOCIATION OF SOCIAL ORGANISATIONS (ALRAID), the Ukrainian member organization of FIOE, lists the QATAR CHARITY ORGANIZATION as one of its “Partners and Donors.”","page":37,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":167,"label":"IFTAAR UK","tags":"qcuk,funding","type":"project","country":"gb","description":"The seventh largest QCUK expenditures listed and for £26,289 was for the “Iftaar UK” and was described as follows: \nThis restricted funding provided 26 grants to support local organizations around the UK and in Europe to prove Iftar (Ramadan meals) to poor individuals and to the wider community. This is a restricted grant from Qatar Charity.","page":"37,38","reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"id":168,"label":"ALL-UKRAINIAN ASSOCIATION OF SOCIAL\nORGANISATIONS","alias":"ALRAID","tags":"qcuk,funding","type":"organization","country":"ua","description":"\rNo further information was available on this project. \rHowever, it should be noted that the website of the\r ALL-UKRAINIAN ASSOCIATION OF SOCIAL\r ORGANISATIONS (ALRAID), the Ukrainian member \rorganization of FIOE, lists the QATAR CHARITY\r ORGANIZATION as one of its “Partners and Donors.","page":37,"reference":"http://www.arraid.org/en/partners-donors"},{"id":169,"label":"MOHAMMED ALI AL-GHAMDI","tags":"qcuk,history","type":"person","country":"qa","description":"On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed:\r- HAFEZ AHMED AHMED, British 72\r- IJAZ AHMAD, British 150\r- SALMAN MOHAMMED ALI A. M. KALDARI,Qatari,businessmann 151\r- MOHAMMED ALI AL-GHAMDI, Qatari, executive director\r","page":20,"reference":"https://beta.companieshouse.gov.uk/company/08006947/filing-history"}]

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(223);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 367 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/**
 * Configuration
 * @module config
 */var config={name:__WEBPACK_IMPORTED_MODULE_0__package_json___default.a.name,title:__WEBPACK_IMPORTED_MODULE_0__package_json___default.a.title,description:__WEBPACK_IMPORTED_MODULE_0__package_json___default.a.description};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(24);
var core = __webpack_require__(23);
var fails = __webpack_require__(75);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(818);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Modal).default;
  }
});

var _Backdrop = __webpack_require__(392);

Object.defineProperty(exports, 'Backdrop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Backdrop).default;
  }
});

var _ModalManager = __webpack_require__(389);

Object.defineProperty(exports, 'ModalManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalManager).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(90);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  node.addEventListener(event, handler, capture);
  return {
    remove: function remove() {
      node.removeEventListener(event, handler, capture);
    }
  };
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(46);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(845);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(153);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(377);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(846);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(110);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(241);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(380);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(850);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(315);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(381);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(849);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(379);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(110);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleSheet = function () {
  function StyleSheet(styles, options) {
    _classCallCheck(this, StyleSheet);

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var name in styles) {
        added.push(this.addRule(name, styles[name], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'update',
    value: function update(name, data) {
      this.rules.update(name, data);
      return this;
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jssGlobal = __webpack_require__(863);

var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

var _jssNested = __webpack_require__(864);

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssCamelCase = __webpack_require__(865);

var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

var _jssDefaultUnit = __webpack_require__(866);

var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

var _jssVendorPrefixer = __webpack_require__(868);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _jssPropsSort = __webpack_require__(873);

var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Subset of jss-preset-default with only the plugins the Material-UI
// components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal2.default)(), (0, _jssNested2.default)(), (0, _jssCamelCase2.default)(), (0, _jssDefaultUnit2.default)(), (0, _jssVendorPrefixer2.default)(), (0, _jssPropsSort2.default)()]
  };
}

exports.default = jssPreset;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};

exports.default = indigo;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

exports.default = pink;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

exports.default = grey;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};

exports.default = red;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var common = {
  transparent: 'transparent',
  black: '#000',
  fullBlack: 'rgba(0, 0, 0, 1)',
  white: '#fff',
  fullWhite: 'rgba(255, 255, 255, 1)'
};

exports.default = common;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generatorCounter = 0;

// Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === undefined ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === undefined ? 'jss' : _options$productionPr;

  var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
  var ruleCounter = 0;

  // - HMR can lead to many class name generators being instantiated,
  // so the warning is only triggered in production.
  // - We expect a class name generator to be instantiated per new request on the server,
  // so the warning is only triggered client side.
  // - You can get away with having multiple class name generators
  // by modifying the `productionPrefix`.
  if ("production" === 'production' && typeof window !== 'undefined' && productionPrefix === 'jss') {
    generatorCounter += 1;

    if (generatorCounter > 2) {
      // eslint-disable-next-line no-console
      console.error(['Material-UI: we have detected more than needed creation of the class name generator.', 'You should only use one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n'));
    }
  }

  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning2.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    // Code branch the whole block at the expense of more code.
    if (dangerouslyUseGlobalCSS) {
      if (styleSheet && styleSheet.options.classNamePrefix) {
        var prefix = styleSheet.options.classNamePrefix;
        // Sanitize the string as will be used to prefix the generated class name.
        prefix = prefix.replace(escapeRegex, '-');

        if (prefix.match(/^Mui/)) {
          return prefix + '-' + rule.key;
        }

        if (false) {
          return prefix + '-' + rule.key + '-' + ruleCounter;
        }
      }

      if (true) {
        return '' + productionPrefix + ruleCounter;
      }

      return rule.key + '-' + ruleCounter;
    }

    if (true) {
      return '' + productionPrefix + ruleCounter;
    }

    if (styleSheet && styleSheet.options.classNamePrefix) {
      var _prefix = styleSheet.options.classNamePrefix;
      // Sanitize the string as will be used to prefix the generated class name.
      _prefix = _prefix.replace(escapeRegex, '-');

      return _prefix + '-' + rule.key + '-' + ruleCounter;
    }

    return rule.key + '-' + ruleCounter;
  };
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _keys = __webpack_require__(80);

var _keys2 = _interopRequireDefault(_keys);

var _style = __webpack_require__(885);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(391);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(893);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(895);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (item) {
    return item.modals.indexOf(modal) !== -1;
  });
}

function getPaddingRight(node) {
  return parseInt((0, _style2.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = { overflow: 'hidden' };

  // We are only interested in the actual `style` here because we will override it.
  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize2.default)();

    // Use computed style, here to get the real padding to add our scrollbar width.
    style.paddingRight = getPaddingRight(container) + scrollbarSize + 'px';

    // .mui-fixed is a global helper.
    var fixedNodes = document.querySelectorAll('.mui-fixed');
    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = paddingRight + scrollbarSize + 'px';
    }
  }

  (0, _keys2.default)(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data, container) {
  (0, _keys2.default)(data.style).forEach(function (key) {
    container.style[key] = data.style[key];
  });

  var fixedNodes = document.querySelectorAll('.mui-fixed');
  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = data.prevPaddings[i] + 'px';
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class
 * Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$hideSiblingNodes = _ref.hideSiblingNodes,
      hideSiblingNodes = _ref$hideSiblingNodes === undefined ? true : _ref$hideSiblingNodes,
      _ref$handleContainerO = _ref.handleContainerOverflow,
      handleContainerOverflow = _ref$handleContainerO === undefined ? true : _ref$handleContainerO;

  (0, _classCallCheck3.default)(this, ModalManager);

  this.add = function (modal, container) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      overflowing: (0, _isOverflowing2.default)(container),
      prevPaddings: []
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return modalIdx;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);
    _this.modals.splice(modalIdx, 1);

    // If that was the last modal in a container, clean up the container.
    if (data.modals.length === 0) {
      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      // Otherwise make sure the next top modal is visible to a SR.
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }

    return modalIdx;
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  // this.modals[modalIdx] = modal
  this.modals = [];
  // this.containers[containerIdx] = container
  this.containers = [];
  // this.data[containerIdx] = {
  //   modals: [],
  // }
  this.data = [];
};

exports.default = ModalManager;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(886);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(151);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Fade = __webpack_require__(896);

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      zIndex: -1,
      width: '100%',
      height: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      // Remove grey highlight
      WebkitTapHighlightColor: theme.palette.common.transparent,
      willChange: 'opacity',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    invisible: {
      backgroundColor: theme.palette.common.transparent
    }
  };
};

function Backdrop(props) {
  var classes = props.classes,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'invisible', 'open', 'transitionDuration']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.invisible, invisible));

  return _react2.default.createElement(
    _Fade2.default,
    (0, _extends3.default)({ appear: true, 'in': open, timeout: transitionDuration }, other),
    _react2.default.createElement('div', { className: className, 'aria-hidden': 'true' })
  );
}

Backdrop.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes2.default.bool,
  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Backdrop.defaultProps = {
  invisible: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBackdrop' })(Backdrop);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37),
    isSymbol = __webpack_require__(111);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(160),
    metaMap = __webpack_require__(398);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(399);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(82),
    root = __webpack_require__(26);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(402),
    composeArgsRight = __webpack_require__(403),
    countHolders = __webpack_require__(916),
    createCtor = __webpack_require__(162),
    createRecurry = __webpack_require__(404),
    getHolder = __webpack_require__(412),
    reorder = __webpack_require__(932),
    replaceHolders = __webpack_require__(253),
    root = __webpack_require__(26);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 403 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(917),
    setData = __webpack_require__(407),
    setWrapToString = __webpack_require__(409);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(398),
    noop = __webpack_require__(918);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(163),
    baseLodash = __webpack_require__(250);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(397),
    shortOut = __webpack_require__(408);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 408 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(923),
    insertWrapDetails = __webpack_require__(924),
    setToString = __webpack_require__(251),
    updateWrapDetails = __webpack_require__(927);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(82);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(928);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 412 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(935);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(114),
    keys = __webpack_require__(166);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(254),
    eq = __webpack_require__(115);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(936),
    isArguments = __webpack_require__(167),
    isArray = __webpack_require__(30),
    isBuffer = __webpack_require__(168),
    isIndex = __webpack_require__(165),
    isTypedArray = __webpack_require__(255);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 417 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(257),
    nativeKeys = __webpack_require__(941);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(170),
    arrayEach = __webpack_require__(252),
    assignValue = __webpack_require__(415),
    baseAssign = __webpack_require__(414),
    baseAssignIn = __webpack_require__(965),
    cloneBuffer = __webpack_require__(421),
    copyArray = __webpack_require__(113),
    copySymbols = __webpack_require__(968),
    copySymbolsIn = __webpack_require__(970),
    getAllKeys = __webpack_require__(424),
    getAllKeysIn = __webpack_require__(971),
    getTag = __webpack_require__(426),
    initCloneArray = __webpack_require__(975),
    initCloneByTag = __webpack_require__(976),
    initCloneObject = __webpack_require__(432),
    isArray = __webpack_require__(30),
    isBuffer = __webpack_require__(168),
    isObject = __webpack_require__(37),
    keys = __webpack_require__(166);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(26);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ }),
/* 422 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(261),
    getPrototype = __webpack_require__(262),
    getSymbols = __webpack_require__(260),
    stubArray = __webpack_require__(422);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(425),
    getSymbols = __webpack_require__(260),
    keys = __webpack_require__(166);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(261),
    isArray = __webpack_require__(30);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(972),
    Map = __webpack_require__(258),
    Promise = __webpack_require__(973),
    Set = __webpack_require__(974),
    WeakMap = __webpack_require__(399),
    baseGetTag = __webpack_require__(92),
    toSource = __webpack_require__(400);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(26);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 428 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 429 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 430 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(263);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(163),
    getPrototype = __webpack_require__(262),
    isPrototype = __webpack_require__(257);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(434),
    arraySome = __webpack_require__(992),
    cacheHas = __webpack_require__(435);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(259),
    setCacheAdd = __webpack_require__(990),
    setCacheHas = __webpack_require__(991);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 435 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(439),
    toKey = __webpack_require__(116);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(30),
    isKey = __webpack_require__(265),
    stringToPath = __webpack_require__(440),
    toString = __webpack_require__(441);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(998);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1000);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(261),
    isFlattenable = __webpack_require__(1010);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(164);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(170),
    assignMergeValue = __webpack_require__(445),
    baseFor = __webpack_require__(1014),
    baseMergeDeep = __webpack_require__(1016),
    isObject = __webpack_require__(37),
    keysIn = __webpack_require__(175);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(254),
    eq = __webpack_require__(115);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(169),
    isObjectLike = __webpack_require__(62);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 448 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(447);
var bytesToUuid = __webpack_require__(448);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regions = {};

regions.centralAsia = {
  name: 'Central Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_Asia
    'KZ', // Kazakhstan
    'KG', // Kyrgyzstan
    'TJ', // Tajikistan
    'TM', // Turkmenistan
    'UZ', // Uzbekistan
  ]
}

regions.southernAsia = {
  name: 'Southern Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/South_Asia
    'AF', // Afghanistan
    'BD', // Bangladesh
    'BT', // Bhutan
    'IO', // British Indian Ocean Territory
    'IN', // India
    'IR', // Iran
    'MV', // Maldives
    'NP', // Nepal
    'PK', // Pakistan
    'LK', // Sri Lanka
  ]
}

regions.southeastAsia = {
  name: 'Southeast Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Southeast_Asia
    'BN', // Brunei
    'KH', // Cambodia
    'CX', // Christmas Island
    'CC', // Cocos (Keeling) Islands
    'TL', // East Timor
    'ID', // Indonesia
    'LA', // Laos
    'MY', // Malaysia
    'MM', // Myanmar (Burma)
    'PH', // Philippines
    'SG', // Singapore
    'TH', // Thailand
    'VN', // Vietnam
  ]
}

regions.eastAsia = {
  name: 'East Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/East_Asia
    'CN', // China
    'HK', // Hong Kong
    'JP', // Japan
    'KP', // North Korea
    'KR', // South Korea
    'MO', // Macao
    'MN', // Mongolia
    'TW', // Taiwan
  ]
}

regions.westernAsia = {
  name: 'Western Asia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Western_Asia
    'AM', // Armenia
    'AZ', // Azerbaijan
    'BH', // Bahrain
    'IQ', // Iraq
    'IL', // Israel
    'JO', // Jordan
    'KW', // Kuwait
    'LB', // Lebanon
    'OM', // Oman
    'PS', // Palestinian territories
    'QA', // Qatar
    'SA', // Saudi Arabia
    'SY', // Syria
    'TR', // Turkey
    'AE', // United Arab Emirates
    'YE', // Yemen
  ]
}

regions.centralAfrica = {
  name: 'Central Aftrica',
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_Africa
    'AO', // Angola
    'CM', // Cameroon
    'CF', // Central African Republic
    'TD', // Chad
    'CG', // Republic of the Congo
    'CD', // Democratic Republic of the Congo
    'GQ', // Equatorial Guinea
    'GA', // Gabon
    'ST', // São Tomé and Príncipe
  ]
};

regions.northAfrica = {
  name: 'North Africa',
  countries: [
    // source is http://en.wikipedia.org/wiki/North_Africa
    'DZ', // Algeria
    'EG', // Egypt
    'LY', // Libya
    'MA', // Morocco
    'SD', // Sudan
    'TN', // Tunisia
    'EH', // Western Sahara
  ]
};

regions.southernAfrica = {
  name: 'Southern Africa',
  countries: [
    // source is http://en.wikipedia.org/wiki/Southern_Africa
    'BW', // Botswana
    'LS', // Lesotho
    'NA', // Namibia
    'ZA', // South Africa
    'SZ', // Swaziland
  ]
};

regions.eastAfrica = {
  name: 'East Africa',
  countries: [
    // source is http://en.wikipedia.org/wiki/East_Africa
    'BI', // Burundi
    'KM', // Comoros
    'DJ', // Djibouti
    'ER', // Eritrea
    'ET', // Ethiopia
    'KE', // Kenya
    'MG', // Madagascar
    'MW', // Malawi
    'MU', // Mauritius
    'YT', // Mayotte (France)
    'MZ', // Mozambique
    'RE', // Réunion (France)
    'RW', // Rwanda
    'SC', // Seychelles
    'SO', // Somalia
    'SS', // South Sudan
    'TZ', // Tanzania
    'UG', // Uganda
    'ZM', // Zambia
    'ZW', // Zimbabwe
  ]
};

regions.westAfrica = {
  name: 'West Africa',
  countries: [
    // source is http://en.wikipedia.org/wiki/West_Africa
    'BJ', // Benin
    'BF', // Burkina Faso
    'CV', // Cabo Verde
    'CI', // Côte d'Ivoire
    'GM', // Gambia
    'GH', // Ghana
    'GN', // Guinea
    'GW', // Guinea-Bissau
    'LR', // Liberia
    'ML', // Mali
    'MR', // Mauritania
    'NE', // Niger
    'NG', // Nigeria
    'SH', // Saint Helena, Ascension and Tristan da Cunha (United Kingdom)
    'SN', // Senegal
    'SL', // Sierra Leone
    'TG', // Togo
  ]
};

regions.centralAmerica = {
  name: 'Central America',
  countries: [
    // source is http://en.wikipedia.org/wiki/Central_America
    'BZ', // Belize
    'CR', // Costa Rica
    'SV', // El Salvador
    'GT', // Guatemala
    'HN', // Honduras
    'NI', // Nicaragua
    'PA', // Panama
  ]
}

regions.northernAmerica = {
  name: 'Northern America',
  countries: [
    // source is http://en.wikipedia.org/wiki/Northern_America
    'BM', // Bermuda
    'CA', // Canada
    'GL', // Greenland
    'MX', // Mexico
    'PM', // Saint Pierre and Miquelon
    'US', // United States
  ]
}

regions.caribbean = {
  name: 'Caribbean',
  countries: [
    // source is http://en.wikipedia.org/wiki/Caribbean
    'AI', // Anguilla
    'AG', // Antigua and Barbuda
    'AW', // Aruba
    'BS', // Bahamas
    'BB', // Barbados
    'BQ', // Bonaire, Sint Eustatius & Saba
    'VG', // British Virgin Islands
    'KY', // Cayman Islands
    'CU', // Cuba
    'CW', // Curaçao
    'DM', // Dominica
    'DO', // Dominican Republic
    'GD', // Grenada
    'GP', // Guadeloupe
    'HT', // Haiti
    'JM', // Jamaica
    'MQ', // Martinique
    'MS', // Montserrat
    'PR', // Puerto Rico
    'BL', // Saint Barthélemy
    'KN', // St. Kitts & Nevis
    'LC', // Saint Lucia
    'MF', // Saint Martin
    'VC', // Saint Vincent and the Grenadines
    'SX', // Sint Maarten
    'TT', // Trinidad and Tobago
    'TC', // Turks & Caicos
    'VI', // United States Virgin Islands
  ]
}

regions.southAmerica = {
  name: 'South America',
  countries: [
    // source is http://en.wikipedia.org/wiki/South_America
    'AR', // Argentina
    'BO', // Bolivia
    'BR', // Brazil
    'CL', // Chile
    'CO', // Colombia
    'EC', // Ecuador
    'FK', // Falkland Islands
    'GF', // French Guiana
    'GY', // Guyana
    'PY', // Paraguay
    'PE', // Peru
    'SR', // Suriname
    'UY', // Uruguay
    'VE', // Venezuela
  ]
}

regions.antartica = {
  name: 'Antartica',
  countries: [
    // source is http://en.wikipedia.org/wiki/Antarctica
    'AQ', // Antarctica
    'BV', // Bouvet Island
    'TF', // French Southern Territories
    'HM', // Heard Island and McDonald Islands
    'GS', // South Georgia and the South Sandwich Islands
  ]
}

regions.northernEurope = {
  name: 'Northern Europe',
  countries: [
    // source is http://en.wikipedia.org/wiki/Northern_Europe
    'AX', // Åland
    'DK', // Denmark
    'EE', // Estonia
    'FO', // Faroe Islands
    'FI', // Finland
    'GG', // Guernsey
    'IS', // Iceland
    'IE', // Republic of Ireland
    'JE', // Jersey (UK)
    'IM', // Isle of Man
    'LV', // Latvia
    'LT', // Lithuania
    'NO', // Norway
    'SJ', // Svalbard and Jan Mayen
    'SE', // Sweden
    'GB', // United Kingdom
  ]
}

regions.southernEurope = {
  name: 'Southern Europe',
  countries: [
    // source is http://en.wikipedia.org/wiki/Southern_Europe
    'AL', // Albania
    'AD', // Andorra
    'BA', // Bosnia and Herzegovina
    'HR', // Croatia
    'CY', // Cyprus
    'GI', // Gibraltar
    'GR', // Greece
    'IT', // Italy
    'MK', // Republic of Macedonia
    'VA', // Vatican City
    'MT', // Malta
    'ME', // Montenegro
    'PT', // Portugal
    'SM', // San Marino
    'RS', // Serbia
    'SI', // Slovenia
    'ES', // Spain
  ]
}

regions.easternEurope = {
  name: 'Eastern Europe',
  countries: [
    // source is http://en.wikipedia.org/wiki/Eastern_Europe
    'BY', // Belarus
    'BG', // Bulgaria
    'CZ', // Czech Republic
    'GE', // Georgia
    'HU', // Hungary
    'MD', // Moldova
    'PL', // Poland
    'RO', // Romania
    'RU', // Russia
    'SK', // Slovakia
    'UA', // Ukraine
  ]
}

regions.westernEurope = {
  name: 'Western Europe',
  countries: [
    // source is http://en.wikipedia.org/wiki/Western_Europe
    'AT', // Austria
    'BE', // Belgium
    'FR', // France
    'DE', // Germany
    'LI', // Liechtenstein
    'LU', // Luxembourg
    'MC', // Monaco
    'NL', // Netherlands
    'CH', // Switzerland
  ],
};
 
regions.australia = {
  name: 'Australia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    'AU', // Australia
    'NF', // Norfolk Island
    'NZ', // New Zealand
  ]
};

regions.melanesia = {
  name: 'Melanesia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    'FJ', // Fiji
    'NC', //  New Caledonia
    'PG', // Papua New Guinea
    'SB', // Solomon Islands
    'VU', // Vanuatu
  ]
};    

regions.micronesia = {
  name: 'Micronesia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    'GU', // Guam
    'KI', // Kiribati
    'MH', // Marshall Islands
    'FM', // Micronesia, Fed. Sts.
    'NR', // Nauru
    'MP', // Northern Mariana Islands
    'PW', // Palau
    'UM', // United States Minor Outlying Islands
  ]
};    

regions.polynesia = {
  name: 'Polynesia',
  countries: [
    // source is http://en.wikipedia.org/wiki/Oceania
    'AS', // American Samoa
    'CK', // Cook Islands
    'PF', // French Polynesia
    'NU', // Niue
    'PN', // Pitcairn Islands
    'WS', // Samoa
    'TK', // Tokelau
    'TO', // Tonga
    'TV', // Tuvalu
    'WF', // Wallis and Futuna
  ]
};

module.exports = regions;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _scrollbarSize = __webpack_require__(391);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Popover = __webpack_require__(1045);

var _Popover2 = _interopRequireDefault(_Popover);

var _MenuList = __webpack_require__(452);

var _MenuList2 = _interopRequireDefault(_MenuList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
}; // @inheritedComponent Popover

var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};

var styles = exports.styles = {
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100vh - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};

var Menu = function (_React$Component) {
  (0, _inherits3.default)(Menu, _React$Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.getContentAnchorEl = function () {
      if (!_this.menuList || !_this.menuList.selectedItem) {
        return (0, _reactDom.findDOMNode)(_this.menuList).firstChild;
      }

      return (0, _reactDom.findDOMNode)(_this.menuList.selectedItem);
    }, _this.menuList = undefined, _this.focus = function () {
      if (_this.menuList && _this.menuList.selectedItem) {
        (0, _reactDom.findDOMNode)(_this.menuList.selectedItem).focus();
        return;
      }

      var menuList = (0, _reactDom.findDOMNode)(_this.menuList);
      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    }, _this.handleEnter = function (element) {
      var theme = _this.props.theme;

      var menuList = (0, _reactDom.findDOMNode)(_this.menuList);

      // Focus so the scroll computation of the Popover works as expected.
      _this.focus();

      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = (0, _scrollbarSize2.default)() + 'px';
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = 'calc(100% + ' + size + ')';
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    }, _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.open) {
        this.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          MenuListProps = _props.MenuListProps,
          onEnter = _props.onEnter,
          _props$PaperProps = _props.PaperProps,
          PaperProps = _props$PaperProps === undefined ? {} : _props$PaperProps,
          PopoverClasses = _props.PopoverClasses,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'MenuListProps', 'onEnter', 'PaperProps', 'PopoverClasses', 'theme']);


      return _react2.default.createElement(
        _Popover2.default,
        (0, _extends3.default)({
          getContentAnchorEl: this.getContentAnchorEl,
          classes: PopoverClasses,
          onEnter: this.handleEnter,
          anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
          transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
          PaperProps: (0, _extends3.default)({}, PaperProps, {
            classes: (0, _extends3.default)({}, PaperProps.classes, {
              root: classes.paper
            })
          })
        }, other),
        _react2.default.createElement(
          _MenuList2.default,
          (0, _extends3.default)({
            role: 'menu',
            onKeyDown: this.handleListKeyDown
          }, MenuListProps, {
            ref: function ref(node) {
              _this2.menuList = node;
            }
          }),
          children
        )
      );
    }
  }]);
  return Menu;
}(_react2.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * Properties applied to the `MenuList` element.
   */
  MenuListProps: _propTypes2.default.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: _propTypes2.default.object,
  /**
   * `classes` property applied to the `Popover` element.
   */
  PopoverClasses: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Menu.defaultProps = {
  transitionDuration: 'auto'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenu', withTheme: true })(Menu);

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(148);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _keycode = __webpack_require__(109);

var _keycode2 = _interopRequireDefault(_keycode);

var _contains = __webpack_require__(150);

var _contains2 = _interopRequireDefault(_contains);

var _activeElement = __webpack_require__(371);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = __webpack_require__(90);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _List = __webpack_require__(453);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent List

var MenuList = function (_React$Component) {
  (0, _inherits3.default)(MenuList, _React$Component);

  function MenuList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuList.__proto__ || (0, _getPrototypeOf2.default)(MenuList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTabIndex: undefined
    }, _this.list = undefined, _this.selectedItem = undefined, _this.blurTimer = undefined, _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.list) {
          var list = (0, _reactDom.findDOMNode)(_this.list);
          var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
          if (!(0, _contains2.default)(list, currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      var list = (0, _reactDom.findDOMNode)(_this.list);
      var key = (0, _keycode2.default)(event);
      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !(0, _contains2.default)(list, currentFocus))) {
        if (_this.selectedItem) {
          (0, _reactDom.findDOMNode)(_this.selectedItem).focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();
        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();
        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    }, _this.handleItemFocus = function (event) {
      var list = (0, _reactDom.findDOMNode)(_this.list);
      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);
            break;
          }
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: 'setTabIndex',
    value: function setTabIndex(index) {
      this.setState({ currentTabIndex: index });
    }
  }, {
    key: 'focus',
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;

      var list = (0, _reactDom.findDOMNode)(this.list);
      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: 'resetTabIndex',
    value: function resetTabIndex() {
      var list = (0, _reactDom.findDOMNode)(this.list);
      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
      var items = [].concat((0, _toConsumableArray3.default)(list.children));
      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItem) {
        return this.setTabIndex(items.indexOf((0, _reactDom.findDOMNode)(this.selectedItem)));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onBlur = _props.onBlur,
          onKeyDown = _props.onKeyDown,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onBlur', 'onKeyDown']);


      return _react2.default.createElement(
        _List2.default,
        (0, _extends3.default)({
          role: 'menu',
          ref: function ref(node) {
            _this2.list = node;
          },
          className: className,
          onKeyDown: this.handleKeyDown,
          onBlur: this.handleBlur
        }, other),
        _react2.default.Children.map(children, function (child, index) {
          if (!_react2.default.isValidElement(child)) {
            return null;
          }

          return _react2.default.cloneElement(child, {
            tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
            ref: child.props.selected ? function (node) {
              _this2.selectedItem = node;
            } : undefined,
            onFocus: _this2.handleItemFocus
          });
        })
      );
    }
  }]);
  return MenuList;
}(_react2.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func
} : {};

exports.default = MenuList;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _List = __webpack_require__(1052);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

var _ListItem = __webpack_require__(454);

Object.defineProperty(exports, 'ListItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItem).default;
  }
});

var _ListItemAvatar = __webpack_require__(1060);

Object.defineProperty(exports, 'ListItemAvatar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemAvatar).default;
  }
});

var _ListItemText = __webpack_require__(1061);

Object.defineProperty(exports, 'ListItemText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemText).default;
  }
});

var _ListItemIcon = __webpack_require__(1063);

Object.defineProperty(exports, 'ListItemIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemIcon).default;
  }
});

var _ListItemSecondaryAction = __webpack_require__(1064);

Object.defineProperty(exports, 'ListItemSecondaryAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemSecondaryAction).default;
  }
});

var _ListSubheader = __webpack_require__(1065);

Object.defineProperty(exports, 'ListSubheader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListSubheader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(455);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _reactHelpers = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none'
    },
    container: {
      position: 'relative'
    },
    keyboardFocused: {
      backgroundColor: theme.palette.action.hover
    },
    default: {
      paddingTop: 12,
      paddingBottom: 12
    },
    dense: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    disabled: {
      opacity: 0.5
    },
    divider: {
      borderBottom: '1px solid ' + theme.palette.divider
    },
    gutters: {
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2
    },
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    },
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: theme.spacing.unit * 4
    }
  };
};

var ListItem = function (_React$Component) {
  (0, _inherits3.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck3.default)(this, ListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          button = _props.button,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          componentProp = _props.component,
          dense = _props.dense,
          disabled = _props.disabled,
          disableGutters = _props.disableGutters,
          divider = _props.divider,
          other = (0, _objectWithoutProperties3.default)(_props, ['button', 'children', 'classes', 'className', 'component', 'dense', 'disabled', 'disableGutters', 'divider']);

      var isDense = dense || this.context.dense || false;
      var children = _react2.default.Children.toArray(childrenProp);

      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty3.default)(_classNames, classes.divider, divider), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.button, button), (0, _defineProperty3.default)(_classNames, classes.secondaryAction, hasSecondaryAction), (0, _defineProperty3.default)(_classNames, isDense || hasAvatar ? classes.dense : classes.default, true), _classNames), classNameProp);

      var listItemProps = (0, _extends3.default)({ className: className, disabled: disabled }, other);
      var ComponentMain = componentProp;

      if (button) {
        ComponentMain = _ButtonBase2.default;
        listItemProps.component = componentProp;
        listItemProps.keyboardFocusedClassName = classes.keyboardFocused;
      }

      if (hasSecondaryAction) {
        return _react2.default.createElement(
          'div',
          { className: classes.container },
          _react2.default.createElement(
            ComponentMain,
            listItemProps,
            children
          ),
          children.pop()
        );
      }

      return _react2.default.createElement(
        ComponentMain,
        listItemProps,
        children
      );
    }
  }]);
  return ListItem;
}(_react2.default.Component);

ListItem.propTypes =  false ? {
  /**
   * If `true`, the ListItem will be a button.
   */
  button: _propTypes2.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes2.default.bool,
  /**
   * @ignore
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes2.default.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes2.default.bool
} : {};

ListItem.defaultProps = {
  button: false,
  component: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};

ListItem.contextTypes = {
  dense: _propTypes2.default.bool
};

ListItem.childContextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItem' })(ListItem);

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonBase = __webpack_require__(1053);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonBase).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(1085);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(1090);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(274);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _InputAdornment = __webpack_require__(1100);

Object.defineProperty(exports, 'InputAdornment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InputAdornment).default;
  }
});

var _InputLabel = __webpack_require__(1101);

Object.defineProperty(exports, 'InputLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InputLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Input = __webpack_require__(274);

var _reactHelpers = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      flexDirection: 'column',
      position: 'relative',
      // Reset fieldset default style
      minWidth: 0,
      padding: 0,
      margin: 0,
      border: 0
    },
    marginNormal: {
      marginTop: theme.spacing.unit * 2,
      marginBottom: theme.spacing.unit
    },
    marginDense: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit / 2
    },
    fullWidth: {
      width: '100%'
    }
  };
};

/**
 * Provides context such as dirty/focused/error/required for form inputs.
 * Relying on the context provides high flexibilty and ensures that the state always stay
 * consitent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 */

var FormControl = function (_React$Component) {
  (0, _inherits3.default)(FormControl, _React$Component);

  function FormControl(props, context) {
    (0, _classCallCheck3.default)(this, FormControl);

    // We need to iterate through the children and find the Input in order
    // to fully support server side rendering.
    var _this = (0, _possibleConstructorReturn3.default)(this, (FormControl.__proto__ || (0, _getPrototypeOf2.default)(FormControl)).call(this, props, context));

    _this.state = {
      adornedStart: false,
      dirty: false,
      focused: false
    };

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState(function (state) {
        return !state.focused ? { focused: true } : null;
      });
    };

    _this.handleBlur = function (event) {
      // The event might be undefined.
      // For instance, a child component might call this hook
      // when an input is disabled but still having the focus.
      if (_this.props.onBlur && event) {
        _this.props.onBlur(event);
      }
      _this.setState(function (state) {
        return state.focused ? { focused: false } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.dirty) {
        _this.setState({ dirty: true });
      }
    };

    _this.handleClean = function () {
      if (_this.state.dirty) {
        _this.setState({ dirty: false });
      }
    };

    var children = _this.props.children;

    if (children) {
      _react2.default.Children.forEach(children, function (child) {
        if ((0, _reactHelpers.isMuiElement)(child, ['Input', 'Select']) && (0, _Input.isDirty)(child.props, true)) {
          _this.state.dirty = true;
        }
        if ((0, _reactHelpers.isMuiElement)(child, ['Input']) && (0, _Input.isAdornedStart)(child.props)) {
          _this.state.adornedStart = true;
        }
      });
    }
    return _this;
  }

  (0, _createClass3.default)(FormControl, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          disabled = _props.disabled,
          error = _props.error,
          required = _props.required,
          margin = _props.margin;
      var _state = this.state,
          adornedStart = _state.adornedStart,
          dirty = _state.dirty,
          focused = _state.focused;


      return {
        muiFormControl: {
          adornedStart: adornedStart,
          dirty: dirty,
          disabled: disabled,
          error: error,
          focused: focused,
          margin: margin,
          required: required,
          onDirty: this.handleDirty,
          onClean: this.handleClean,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          classes = _props2.classes,
          className = _props2.className,
          Component = _props2.component,
          disabled = _props2.disabled,
          error = _props2.error,
          fullWidth = _props2.fullWidth,
          margin = _props2.margin,
          other = (0, _objectWithoutProperties3.default)(_props2, ['classes', 'className', 'component', 'disabled', 'error', 'fullWidth', 'margin']);


      return _react2.default.createElement(Component, (0, _extends3.default)({
        className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.marginNormal, margin === 'normal'), (0, _defineProperty3.default)(_classNames, classes.marginDense, margin === 'dense'), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other, {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }));
    }
  }]);
  return FormControl;
}(_react2.default.Component);

FormControl.propTypes =  false ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the component, as well as its children,
   * will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes2.default.oneOf(['none', 'dense', 'normal']),
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool
} : {};

FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false
};

FormControl.childContextTypes = {
  muiFormControl: _propTypes2.default.object.isRequired
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormControl' })(FormControl);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: theme.spacing.unit,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0
    },
    dense: {
      marginTop: theme.spacing.unit / 2
    },
    error: {
      color: theme.palette.error.main
    },
    disabled: {
      color: theme.palette.text.disabled
    }
  };
};

function FormHelperText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      disabledProp = props.disabled,
      errorProp = props.error,
      marginProp = props.margin,
      Component = props.component,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'disabled', 'error', 'margin', 'component']);
  var muiFormControl = context.muiFormControl;


  var disabled = disabledProp;
  var error = errorProp;
  var margin = marginProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = muiFormControl.margin;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), (0, _defineProperty3.default)(_classNames, classes.dense, margin === 'dense'), _classNames), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

FormHelperText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense'])
} : {};

FormHelperText.defaultProps = {
  component: 'p'
};

FormHelperText.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormHelperText' })(FormHelperText);

/***/ }),
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_shim__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_shim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_shim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classlist_polyfill__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classlist_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classlist_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendor_polyfills__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vendor_polyfills___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vendor_polyfills__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_hot_loader__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_integration_react__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_integration_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_integration_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_app_store__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_containers_App__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Loader__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_styles__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_colors__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_main_scss__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__styles_main_scss__);
// Polyfills
// Create a theme instance.
var theme=Object(__WEBPACK_IMPORTED_MODULE_12_material_ui_styles__["createMuiTheme"])({palette:{primary:__WEBPACK_IMPORTED_MODULE_13_material_ui_colors__["blue"],accent:__WEBPACK_IMPORTED_MODULE_13_material_ui_colors__["white"],type:'light'}});/* istanbul ignore next */if(true){__webpack_require__(1139).install();}function renderRoot(Component){var root=document.getElementById('react');/* istanbul ignore next */if(root){__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_styles__["MuiThemeProvider"],{theme:theme},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_hot_loader__["AppContainer"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_9_app_store__["b" /* store */]},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_redux_persist_lib_integration_react__["PersistGate"],{loading:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_Loader__["a" /* default */],null),persistor:__WEBPACK_IMPORTED_MODULE_9_app_store__["a" /* persistor */]},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component,null))))),root);}}renderRoot(__WEBPACK_IMPORTED_MODULE_10_containers_App__["a" /* default */]);/* istanbul ignore next  */if(false){module.hot.accept('containers/App',function(){return renderRoot(App);});}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(470);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(198);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(293);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(296);
__webpack_require__(298);
__webpack_require__(299);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
module.exports = __webpack_require__(53);


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(8);
var has = __webpack_require__(31);
var DESCRIPTORS = __webpack_require__(19);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(33);
var META = __webpack_require__(59).KEY;
var $fails = __webpack_require__(14);
var shared = __webpack_require__(118);
var setToStringTag = __webpack_require__(83);
var uid = __webpack_require__(65);
var wks = __webpack_require__(17);
var wksExt = __webpack_require__(276);
var wksDefine = __webpack_require__(178);
var enumKeys = __webpack_require__(471);
var isArray = __webpack_require__(121);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(16);
var toIObject = __webpack_require__(38);
var toPrimitive = __webpack_require__(47);
var createDesc = __webpack_require__(64);
var _create = __webpack_require__(69);
var gOPNExt = __webpack_require__(279);
var $GOPD = __webpack_require__(39);
var $DP = __webpack_require__(20);
var $keys = __webpack_require__(67);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(70).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(95).f = $propertyIsEnumerable;
  __webpack_require__(120).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(66)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(32)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(67);
var gOPS = __webpack_require__(120);
var pIE = __webpack_require__(95);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(69) });


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperties: __webpack_require__(278) });


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(38);
var $getOwnPropertyDescriptor = __webpack_require__(39).f;

__webpack_require__(50)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(22);
var $getPrototypeOf = __webpack_require__(40);

__webpack_require__(50)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(22);
var $keys = __webpack_require__(67);

__webpack_require__(50)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(50)('getOwnPropertyNames', function () {
  return __webpack_require__(279).f;
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(16);
var meta = __webpack_require__(59).onFreeze;

__webpack_require__(50)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(16);
var meta = __webpack_require__(59).onFreeze;

__webpack_require__(50)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(16);
var meta = __webpack_require__(59).onFreeze;

__webpack_require__(50)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(16);

__webpack_require__(50)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(16);

__webpack_require__(50)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(16);

__webpack_require__(50)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(280) });


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(487) });


/***/ }),
/* 487 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(182).set });


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(96);
var test = {};
test[__webpack_require__(17)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(33)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(281) });


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(19) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(40);
var HAS_INSTANCE = __webpack_require__(17)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(20).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(283);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(284);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(8);
var has = __webpack_require__(31);
var cof = __webpack_require__(43);
var inheritIfRequired = __webpack_require__(184);
var toPrimitive = __webpack_require__(47);
var fails = __webpack_require__(14);
var gOPN = __webpack_require__(70).f;
var gOPD = __webpack_require__(39).f;
var dP = __webpack_require__(20).f;
var $trim = __webpack_require__(84).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(69)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(19) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(33)(global, NUMBER, $Number);
}


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(49);
var aNumberValue = __webpack_require__(285);
var repeat = __webpack_require__(185);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(14)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(14);
var aNumberValue = __webpack_require__(285);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(8).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(286) });


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(286);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(284);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(283);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(287);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(186);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(187);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(288) });


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(14)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(287) });


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(186) });


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(187);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(14)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(187);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(68);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(38);
var toLength = __webpack_require__(21);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(84)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(188)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(189)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(188)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(21);
var context = __webpack_require__(191);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(192)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(191);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(192)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(185)
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(21);
var context = __webpack_require__(191);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(192)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(34)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(34)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(34)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(34)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(34)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(34)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(34)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(34)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(34)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(34)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(34)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(34)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(34)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(47);

$export($export.P + $export.F * __webpack_require__(14)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(549);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(14);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(33)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(17)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(32)(proto, TO_PRIMITIVE, __webpack_require__(552));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(47);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(121) });


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(42);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var call = __webpack_require__(289);
var isArrayIter = __webpack_require__(193);
var toLength = __webpack_require__(21);
var createProperty = __webpack_require__(194);
var getIterFn = __webpack_require__(195);

$export($export.S + $export.F * !__webpack_require__(123)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(194);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(14)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(38);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(94) != Object || !__webpack_require__(44)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(181);
var cof = __webpack_require__(43);
var toAbsoluteIndex = __webpack_require__(68);
var toLength = __webpack_require__(21);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(14)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(25);
var toObject = __webpack_require__(22);
var fails = __webpack_require__(14);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(44)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(51)(0);
var STRICT = __webpack_require__(44)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);
var isArray = __webpack_require__(121);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(51)(1);

$export($export.P + $export.F * !__webpack_require__(44)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(51)(2);

$export($export.P + $export.F * !__webpack_require__(44)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(51)(3);

$export($export.P + $export.F * !__webpack_require__(44)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(51)(4);

$export($export.P + $export.F * !__webpack_require__(44)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(290);

$export($export.P + $export.F * !__webpack_require__(44)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(290);

$export($export.P + $export.F * !__webpack_require__(44)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(119)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(44)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(38);
var toInteger = __webpack_require__(49);
var toLength = __webpack_require__(21);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(44)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(291) });

__webpack_require__(60)('copyWithin');


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(197) });

__webpack_require__(60)('fill');


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(51)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(60)(KEY);


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(51)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(60)(KEY);


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(71)('Array');


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(8);
var inheritIfRequired = __webpack_require__(184);
var dP = __webpack_require__(20).f;
var gOPN = __webpack_require__(70).f;
var isRegExp = __webpack_require__(122);
var $flags = __webpack_require__(124);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(19) && (!CORRECT_NEW || __webpack_require__(14)(function () {
  re2[__webpack_require__(17)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(33)(global, 'RegExp', $RegExp);
}

__webpack_require__(71)('RegExp');


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(293);
var anObject = __webpack_require__(6);
var $flags = __webpack_require__(124);
var DESCRIPTORS = __webpack_require__(19);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(33)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(14)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(125)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(125)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(125)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(125)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(122);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(66);
var global = __webpack_require__(8);
var ctx = __webpack_require__(42);
var classof = __webpack_require__(96);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(16);
var aFunction = __webpack_require__(25);
var anInstance = __webpack_require__(72);
var forOf = __webpack_require__(73);
var speciesConstructor = __webpack_require__(126);
var task = __webpack_require__(199).set;
var microtask = __webpack_require__(200)();
var newPromiseCapabilityModule = __webpack_require__(201);
var perform = __webpack_require__(294);
var promiseResolve = __webpack_require__(295);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(17)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(74)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(83)($Promise, PROMISE);
__webpack_require__(71)(PROMISE);
Wrapper = __webpack_require__(53)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(123)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(300);
var validate = __webpack_require__(86);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(127)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(128);
var buffer = __webpack_require__(202);
var anObject = __webpack_require__(6);
var toAbsoluteIndex = __webpack_require__(68);
var toLength = __webpack_require__(21);
var isObject = __webpack_require__(16);
var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
var speciesConstructor = __webpack_require__(126);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(14)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(71)(ARRAY_BUFFER);


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(128).ABV, {
  DataView: __webpack_require__(202).DataView
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(54)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(6);
var rApply = (__webpack_require__(8).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(14)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(69);
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(16);
var fails = __webpack_require__(14);
var bind = __webpack_require__(281);
var rConstruct = (__webpack_require__(8).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(20);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var toPrimitive = __webpack_require__(47);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(14)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(39).f;
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(190)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(39);
var getPrototypeOf = __webpack_require__(40);
var has = __webpack_require__(31);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(16);
var anObject = __webpack_require__(6);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(39);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(40);
var anObject = __webpack_require__(6);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(302) });


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(6);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(20);
var gOPD = __webpack_require__(39);
var getPrototypeOf = __webpack_require__(40);
var has = __webpack_require__(31);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(64);
var anObject = __webpack_require__(6);
var isObject = __webpack_require__(16);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(182);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(119)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(60)('includes');


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(303);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(21);
var aFunction = __webpack_require__(25);
var arraySpeciesCreate = __webpack_require__(196);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(60)('flatMap');


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(303);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(21);
var toInteger = __webpack_require__(49);
var arraySpeciesCreate = __webpack_require__(196);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(60)('flatten');


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(188)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(304);
var userAgent = __webpack_require__(203);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(304);
var userAgent = __webpack_require__(203);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(84)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(84)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(48);
var toLength = __webpack_require__(21);
var isRegExp = __webpack_require__(122);
var getFlags = __webpack_require__(124);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(190)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178)('asyncIterator');


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178)('observable');


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(302);
var toIObject = __webpack_require__(38);
var gOPD = __webpack_require__(39);
var createProperty = __webpack_require__(194);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(305)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(305)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var aFunction = __webpack_require__(25);
var $defineProperty = __webpack_require__(20);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(19) && $export($export.P + __webpack_require__(129), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var aFunction = __webpack_require__(25);
var $defineProperty = __webpack_require__(20);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(19) && $export($export.P + __webpack_require__(129), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(40);
var getOwnPropertyDescriptor = __webpack_require__(39).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(19) && $export($export.P + __webpack_require__(129), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(40);
var getOwnPropertyDescriptor = __webpack_require__(39).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(19) && $export($export.P + __webpack_require__(129), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(306)('Map') });


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(306)('Set') });


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(130)('Map');


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(130)('Set');


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(130)('WeakMap');


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(130)('WeakSet');


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(131)('Map');


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(131)('Set');


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(131)('WeakMap');


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(131)('WeakSet');


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(8) });


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(8) });


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(43);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(308);
var fround = __webpack_require__(288);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(308) });


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(53);
var global = __webpack_require__(8);
var speciesConstructor = __webpack_require__(126);
var promiseResolve = __webpack_require__(295);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(201);
var perform = __webpack_require__(294);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(40);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(298);
var from = __webpack_require__(307);
var metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(40);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var getPrototypeOf = __webpack_require__(40);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(55);
var anObject = __webpack_require__(6);
var aFunction = __webpack_require__(25);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(200)();
var process = __webpack_require__(8).process;
var isNode = __webpack_require__(43)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(8);
var core = __webpack_require__(53);
var microtask = __webpack_require__(200)();
var OBSERVABLE = __webpack_require__(17)('observable');
var aFunction = __webpack_require__(25);
var anObject = __webpack_require__(6);
var anInstance = __webpack_require__(72);
var redefineAll = __webpack_require__(74);
var hide = __webpack_require__(32);
var forOf = __webpack_require__(73);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(71)('Observable');


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(8);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(203);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(199);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(198);
var getKeys = __webpack_require__(67);
var redefine = __webpack_require__(33);
var global = __webpack_require__(8);
var hide = __webpack_require__(32);
var Iterators = __webpack_require__(85);
var wks = __webpack_require__(17);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(667);
module.exports = self.fetch.bind(self);


/***/ }),
/* 667 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 668 */
/***/ (function(module, exports) {

/*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20170427
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */

/*global self, document, DOMException */

/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */

if ("document" in window.self) {

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList
if (!("classList" in document.createElement("_")) 
	|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {

(function (view) {

"use strict";

if (!('Element' in view)) return;

var
	  classListProp = "classList"
	, protoProp = "prototype"
	, elemCtrProto = view.Element[protoProp]
	, objCtr = Object
	, strTrim = String[protoProp].trim || function () {
		return this.replace(/^\s+|\s+$/g, "");
	}
	, arrIndexOf = Array[protoProp].indexOf || function (item) {
		var
			  i = 0
			, len = this.length
		;
		for (; i < len; i++) {
			if (i in this && this[i] === item) {
				return i;
			}
		}
		return -1;
	}
	// Vendors: please allow content code to instantiate DOMExceptions
	, DOMEx = function (type, message) {
		this.name = type;
		this.code = DOMException[type];
		this.message = message;
	}
	, checkTokenAndGetIndex = function (classList, token) {
		if (token === "") {
			throw new DOMEx(
				  "SYNTAX_ERR"
				, "An invalid or illegal string was specified"
			);
		}
		if (/\s/.test(token)) {
			throw new DOMEx(
				  "INVALID_CHARACTER_ERR"
				, "String contains an invalid character"
			);
		}
		return arrIndexOf.call(classList, token);
	}
	, ClassList = function (elem) {
		var
			  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
			, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
			, i = 0
			, len = classes.length
		;
		for (; i < len; i++) {
			this.push(classes[i]);
		}
		this._updateClassName = function () {
			elem.setAttribute("class", this.toString());
		};
	}
	, classListProto = ClassList[protoProp] = []
	, classListGetter = function () {
		return new ClassList(this);
	}
;
// Most DOMException implementations don't allow calling DOMException's toString()
// on non-DOMExceptions. Error's toString() is sufficient here.
DOMEx[protoProp] = Error[protoProp];
classListProto.item = function (i) {
	return this[i] || null;
};
classListProto.contains = function (token) {
	token += "";
	return checkTokenAndGetIndex(this, token) !== -1;
};
classListProto.add = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
	;
	do {
		token = tokens[i] + "";
		if (checkTokenAndGetIndex(this, token) === -1) {
			this.push(token);
			updated = true;
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.remove = function () {
	var
		  tokens = arguments
		, i = 0
		, l = tokens.length
		, token
		, updated = false
		, index
	;
	do {
		token = tokens[i] + "";
		index = checkTokenAndGetIndex(this, token);
		while (index !== -1) {
			this.splice(index, 1);
			updated = true;
			index = checkTokenAndGetIndex(this, token);
		}
	}
	while (++i < l);

	if (updated) {
		this._updateClassName();
	}
};
classListProto.toggle = function (token, force) {
	token += "";

	var
		  result = this.contains(token)
		, method = result ?
			force !== true && "remove"
		:
			force !== false && "add"
	;

	if (method) {
		this[method](token);
	}

	if (force === true || force === false) {
		return force;
	} else {
		return !result;
	}
};
classListProto.toString = function () {
	return this.join(" ");
};

if (objCtr.defineProperty) {
	var classListPropDesc = {
		  get: classListGetter
		, enumerable: true
		, configurable: true
	};
	try {
		objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	} catch (ex) { // IE 8 doesn't support enumerable:true
		// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
		// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
		if (ex.number === undefined || ex.number === -0x7FF5EC54) {
			classListPropDesc.enumerable = false;
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		}
	}
} else if (objCtr[protoProp].__defineGetter__) {
	elemCtrProto.__defineGetter__(classListProp, classListGetter);
}

}(window.self));

}

// There is full or partial native classList support, so just check if we need
// to normalize the add/remove and toggle APIs.

(function () {
	"use strict";

	var testElement = document.createElement("_");

	testElement.classList.add("c1", "c2");

	// Polyfill for IE 10/11 and Firefox <26, where classList.add and
	// classList.remove exist but support only one argument at a time.
	if (!testElement.classList.contains("c2")) {
		var createMethod = function(method) {
			var original = DOMTokenList.prototype[method];

			DOMTokenList.prototype[method] = function(token) {
				var i, len = arguments.length;

				for (i = 0; i < len; i++) {
					token = arguments[i];
					original.call(this, token);
				}
			};
		};
		createMethod('add');
		createMethod('remove');
	}

	testElement.classList.toggle("c3", false);

	// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	// support the second argument.
	if (testElement.classList.contains("c3")) {
		var _toggle = DOMTokenList.prototype.toggle;

		DOMTokenList.prototype.toggle = function(token, force) {
			if (1 in arguments && !this.contains(token) === !force) {
				return force;
			} else {
				return _toggle.call(this, token);
			}
		};

	}

	testElement = null;
}());

}


/***/ }),
/* 669 */
/***/ (function(module, exports) {

/*eslint-disable func-names *//**
 * @module Polyfills
 * @desc Add CustomEvent and Dataset for older browsers.
 *//**
 * CustomEvent Polyfill
 *//* istanbul ignore next */(function(){if(typeof window.CustomEvent==='function'){return;}function CustomEvent(event,params){var newParams=params||{bubbles:false,cancelable:false,detail:undefined};var evt=document.createEvent('CustomEvent');evt.initCustomEvent(event,newParams.bubbles,newParams.cancelable,newParams.detail);return evt;}CustomEvent.prototype=window.Event.prototype;window.CustomEvent=CustomEvent;})();/**
 * Dataset Polyfill
 *//* istanbul ignore next */(function(){if(!document.documentElement.dataset&&(!Object.getOwnPropertyDescriptor(Element.prototype,'dataset')||!Object.getOwnPropertyDescriptor(Element.prototype,'dataset').get)){var descriptor={};descriptor.enumerable=true;descriptor.get=function(){var element=this;var map={};var attributes=this.attributes;function toUpperCase(n0){return n0.charAt(1).toUpperCase();}function getter(){return this.value;}function setter(name,value){if(typeof value!=='undefined'){this.setAttribute(name,value);}else{this.removeAttribute(name);}}for(var i=0;i<attributes.length;i++){var attribute=attributes[i];// This test really should allow any XML Name without
// colons (and non-uppercase for XHTML)
if(attribute&&attribute.name&&/^data-\w[\w-]*$/.test(attribute.name)){var name=attribute.name,value=attribute.value;// Change to CamelCase
var propName=name.substr(5).replace(/-./g,toUpperCase);Object.defineProperty(map,propName,{enumerable:this.enumerable,get:getter.bind({value:value||''}),set:setter.bind(element,name)});}}return map;};Object.defineProperty(Element.prototype,'dataset',descriptor);}})();

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(204),n=__webpack_require__(309),p=__webpack_require__(132),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(1),l=__webpack_require__(672),B=__webpack_require__(204),C=__webpack_require__(132),ba=__webpack_require__(673),da=__webpack_require__(674),ea=__webpack_require__(205),fa=__webpack_require__(675),ia=__webpack_require__(678),D=__webpack_require__(309);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(132);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(676);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(677);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(206);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(132);
var invariant = __webpack_require__(310);
var ReactPropTypesSecret = __webpack_require__(681);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(701);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(318);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(690);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(688);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(314);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(692);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(695);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(136)(module)))

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(316);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(317);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(318);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(319);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(702);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(206);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(704)


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(705);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(706);

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(707);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(1);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PersistGate = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-line import/no-unresolved
// eslint-disable-line import/no-unresolved
var PersistGate = exports.PersistGate = function (_PureComponent) {
  _inherits(PersistGate, _PureComponent);

  function PersistGate() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PersistGate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersistGate.__proto__ || Object.getPrototypeOf(PersistGate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      bootstrapped: false
    }, _this.handlePersistorState = function () {
      var persistor = _this.props.persistor;

      var _persistor$getState = persistor.getState(),
          bootstrapped = _persistor$getState.bootstrapped;

      if (bootstrapped) {
        if (_this.props.onBeforeLift) {
          Promise.resolve(_this.props.onBeforeLift()).then(function () {
            return _this.setState({ bootstrapped: true });
          }).catch(function () {
            return _this.setState({ bootstrapped: true });
          });
        } else {
          _this.setState({ bootstrapped: true });
        }
        _this._unsubscribe && _this._unsubscribe();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PersistGate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
      this.handlePersistorState();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unsubscribe && this._unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.bootstrapped ? this.props.children : this.props.loading;
    }
  }]);

  return PersistGate;
}(_react.PureComponent);

PersistGate.defaultProps = {
  loading: null
};

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return persistor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_persist__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_persist_lib_storage__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_persist_lib_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_persist_lib_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_history__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sagas__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_reducers__ = __webpack_require__(785);
var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga__["a" /* default */])();var reducer=Object(__WEBPACK_IMPORTED_MODULE_5_redux_persist__["a" /* persistReducer */])({key:'septt',// key is required
storage:__WEBPACK_IMPORTED_MODULE_6_redux_persist_lib_storage___default.a,// storage is now required
whitelist:['app','user']},Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* combineReducers */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},__WEBPACK_IMPORTED_MODULE_9_reducers__["a" /* default */],{router:__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["d" /* routerReducer */]})));var middleware=[__WEBPACK_IMPORTED_MODULE_2_redux_thunk___default.a,sagaMiddleware,Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["c" /* routerMiddleware */])(__WEBPACK_IMPORTED_MODULE_7_modules_history__["a" /* default */])];/* istanbul ignore next */if(false){var _require=require('redux-logger'),createLogger=_require.createLogger;middleware.push(createLogger({collapsed:true}));}var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||__WEBPACK_IMPORTED_MODULE_1_redux__["d" /* compose */];/* istanbul ignore next */var configStore=function configStore(){var initialState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var createStoreWithMiddleware=composeEnhancers(__WEBPACK_IMPORTED_MODULE_1_redux__["a" /* applyMiddleware */].apply(undefined,middleware))(__WEBPACK_IMPORTED_MODULE_1_redux__["e" /* createStore */]);var store=createStoreWithMiddleware(reducer,initialState);sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_8_sagas__["a" /* default */]);if(false){module.hot.accept('reducers',function(){store.replaceReducer(require('reducers').default);});}return{persistor:Object(__WEBPACK_IMPORTED_MODULE_5_redux_persist__["b" /* persistStore */])(store),store:store};};var _configStore=configStore(),store=_configStore.store,persistor=_configStore.persistor;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(711);
module.exports = __webpack_require__(23).Object.assign;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(24);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(712) });


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(99);
var gOPS = __webpack_require__(216);
var pIE = __webpack_require__(139);
var toObject = __webpack_require__(88);
var IObject = __webpack_require__(210);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(75)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(87);
var toLength = __webpack_require__(137);
var toAbsoluteIndex = __webpack_require__(714);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(212);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(324);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(89);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(89);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(41);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(41);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(77);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(325);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(337);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* LOCATION_CHANGE */],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history,
        isSSR = _props.isSSR;

    this.store = propsStore || this.context.store;
    this.handleLocationChange(history.location);

    if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Router */], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  isSSR: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConnectedRouter);

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(102);

var _LocationUtils = __webpack_require__(220);

var _createTransitionManager = __webpack_require__(221);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(724);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(725);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(726);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(142);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(103);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(333);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(333);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(222);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(728)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 728 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLocation */
/* unused harmony export createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(327);


var getLocation = function getLocation(state) {
  return state.router.location;
};

var createMatchSelector = function createMatchSelector(path) {
  var lastPathname = null;
  var lastMatch = null;
  return function (state) {
    var _ref = getLocation(state) || {},
        pathname = _ref.pathname;

    if (pathname === lastPathname) {
      return lastMatch;
    }
    lastPathname = pathname;
    var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* matchPath */])(pathname, path);
    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match;
    }
    return lastMatch;
  };
};

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(338);


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__persistReducer__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__persistReducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistCombineReducers__ = __webpack_require__(733);
/* unused harmony reexport persistCombineReducers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__persistStore__ = __webpack_require__(735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__persistStore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMigrate__ = __webpack_require__(736);
/* unused harmony reexport createMigrate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransform__ = __webpack_require__(737);
/* unused harmony reexport createTransform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getStoredState__ = __webpack_require__(340);
/* unused harmony reexport getStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createPersistoid__ = __webpack_require__(339);
/* unused harmony reexport createPersistoid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__purgeStoredState__ = __webpack_require__(341);
/* unused harmony reexport purgeStoredState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(78);
/* unused harmony namespace reexport */











/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel1;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel1(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      // otherwise hard set the new value
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel1: 
    - merges 1 level of substate
    - skips substate if already modified
*/

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__ = __webpack_require__(734);




// combineReducers + persistReducer with stateReconciler defaulted to autoMergeLevel2
function persistCombineReducers(config, reducers) {
  config.stateReconciler = config.stateReconciler === undefined ? __WEBPACK_IMPORTED_MODULE_2__stateReconciler_autoMergeLevel2__["a" /* default */] : config.stateReconciler;
  return Object(__WEBPACK_IMPORTED_MODULE_1__persistReducer__["a" /* default */])(config, Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(reducers));
}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoMergeLevel2;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function autoMergeLevel2(inboundState, originalState, reducedState, _ref) {
  var debug = _ref.debug;

  var newState = _extends({}, reducedState);
  // only rehydrate if inboundState exists and is an object
  if (inboundState && (typeof inboundState === 'undefined' ? 'undefined' : _typeof(inboundState)) === 'object') {
    Object.keys(inboundState).forEach(function (key) {
      // ignore _persist data
      if (key === '_persist') return;
      // if reducer modifies substate, skip auto rehydration
      if (originalState[key] !== reducedState[key]) {
        if (false) console.log('redux-persist/stateReconciler: sub state for key `%s` modified, skipping.', key);
        return;
      }
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = _extends({}, newState[key], inboundState[key]);
        return;
      }
      // otherwise hard set
      newState[key] = inboundState[key];
    });
  }

  if (false) console.log('redux-persist/stateReconciler: rehydrated keys \'' + Object.keys(inboundState).join(', ') + '\'');

  return newState;
}

/*
  autoMergeLevel2: 
    - merges 2 level of substate
    - skips substate if already modified
    - this is essentially redux-perist v4 behavior
*/

function isPlainEnoughObject(o) {
  return o !== null && !Array.isArray(o) && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
}

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__persistReducer__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(78);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var initialState = {
  registry: [],
  bootstrapped: false
};

var persistorReducer = function persistorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */]:
      return _extends({}, state, { registry: [].concat(_toConsumableArray(state.registry), [action.key]) });
    case __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */]:
      var firstIndex = state.registry.indexOf(action.key);
      var registry = [].concat(_toConsumableArray(state.registry));
      registry.splice(firstIndex, 1);
      return _extends({}, state, { registry: registry, bootstrapped: registry.length === 0 });
    default:
      return state;
  }
};

function persistStore(store, persistorOptions, cb) {
  var options = persistorOptions || {};

  // help catch incorrect usage of passing PersistConfig in as PersistorOptions
  if (false) {
    var bannedKeys = ['blacklist', 'whitelist', 'transforms', 'storage', 'keyPrefix', 'migrate'];
    bannedKeys.forEach(function (k) {
      if (!!options[k]) console.error('redux-persist: invalid option passed to persistStore: "' + k + '". You may be incorrectly passing persistConfig into persistStore, whereas it should be passed into persistReducer.');
    });
  }
  var boostrappedCb = cb || false;
  var persistor = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(persistorReducer, undefined, options.enhancer);

  persistor.purge = function () {
    var results = [];
    store.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PURGE */],
      result: function result(purgeResult) {
        results.push(purgeResult);
      }
    });
    return Promise.all(results);
  };

  persistor.flush = function () {
    var results = [];
    store.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["b" /* FLUSH */],
      result: function result(flushResult) {
        results.push(flushResult);
      }
    });
    return Promise.all(results);
  };

  persistor.pause = function () {
    store.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* PAUSE */]
    });
  };

  var register = function register(key) {
    persistor.dispatch({
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REGISTER */],
      key: key
    });
  };

  var rehydrate = function rehydrate(key, payload, err) {
    var rehydrateAction = {
      type: __WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REHYDRATE */],
      payload: payload,
      err: err,
      key: key
      // dispatch to `store` to rehydrate and `persistor` to track result
    };store.dispatch(rehydrateAction);
    persistor.dispatch(rehydrateAction);
    if (boostrappedCb && persistor.getState().bootstrapped) {
      boostrappedCb();
      boostrappedCb = false;
    }
  };

  persistor.persist = function () {
    store.dispatch({ type: __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PERSIST */], register: register, rehydrate: rehydrate });
  };

  persistor.persist();

  return persistor;
}

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(78);


function createMigrate(migrations, config) {
  var _ref = config || {},
      debug = _ref.debug;

  return function (state, currentVersion) {
    if (!state) {
      if (false) console.log('redux-persist: no inbound state, skipping migration');
      return Promise.resolve(undefined);
    }

    var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DEFAULT_VERSION */];
    if (inboundVersion === currentVersion) {
      if (false) console.log('redux-persist: versions match, noop migration');
      return Promise.resolve(state);
    }
    if (inboundVersion > currentVersion) {
      if (false) console.error('redux-persist: downgrading version is not supported');
      return Promise.resolve(state);
    }

    var migrationKeys = Object.keys(migrations).map(function (ver) {
      return parseInt(ver);
    }).filter(function (key) {
      return currentVersion >= key && key > inboundVersion;
    }).sort(function (a, b) {
      return a - b;
    });

    if (false) console.log('redux-persist: migrationKeys', migrationKeys);
    try {
      var migratedState = migrationKeys.reduce(function (state, versionKey) {
        if (false) console.log('redux-persist: running migration for versionKey', versionKey);
        return migrations[versionKey](state);
      }, state);
      return Promise.resolve(migratedState);
    } catch (err) {
      return Promise.reject(err);
    }
  };
}

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */


function createTransform(
// @NOTE inbound: transform state coming from redux on its way to being serialized and stored
inbound,
// @NOTE outbound: transform state coming from storage, on its way to be rehydrated into redux
outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createWebStorage = __webpack_require__(739);

var _createWebStorage2 = _interopRequireDefault(_createWebStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createWebStorage2.default)('local');

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createWebStorage;

var _getStorage = __webpack_require__(740);

var _getStorage2 = _interopRequireDefault(_getStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createWebStorage(type) {
  var storage = (0, _getStorage2.default)(type);
  return {
    getItem: function getItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.getItem(key));
      });
    },
    setItem: function setItem(key, item) {
      return new Promise(function (resolve, reject) {
        resolve(storage.setItem(key, item));
      });
    },
    removeItem: function removeItem(key) {
      return new Promise(function (resolve, reject) {
        resolve(storage.removeItem(key));
      });
    }
  };
}

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getStorage;


function noop() {}

var noopStorage = {
  getItem: noop,
  setItem: noop,
  removeItem: noop
};

function hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function getStorage(type) {
  var storageType = type + 'Storage';
  if (hasStorage(storageType)) return window[storageType];else {
    if (false) {
      console.error('redux-persist failed to create sync storage. falling back to memory storage.');
    }
    return noopStorage;
  }
}

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(742);
var parse = __webpack_require__(743);
var formats = __webpack_require__(346);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(345);
var formats = __webpack_require__(346);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(345);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = root;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__github__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app__ = __webpack_require__(783);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(root);/**
 * rootSaga
 */function root(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function root$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_2__github__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_3__user__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* fork */])(__WEBPACK_IMPORTED_MODULE_4__app__["a" /* default */])]);case 2:case'end':return _context.stop();}}},_marked,this);}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(746);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 746 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRepos */
/* harmony export (immutable) */ __webpack_exports__["a"] = root;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_api__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(58);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getRepos),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(root);/**
 * @module Sagas/GitHub
 * @desc GitHub
 *//**
 * Login
 *
 * @param {Object} action
 *
 */function getRepos(_ref){var payload=_ref.payload;var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getRepos$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_modules_api__["a" /* request */],'https://api.github.com/search/repositories?q='+payload.query+'&sort=stars');case 3:response=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_SUCCESS,payload:{data:response.items}});case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_FAILURE,payload:_context.t0});case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}/**
 * GitHub Sagas
 */function root(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function root$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_REQUEST,getRepos)]);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(749);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(750), __esModule: true };

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
__webpack_require__(144);
__webpack_require__(227);
__webpack_require__(756);
__webpack_require__(759);
__webpack_require__(760);
module.exports = __webpack_require__(23).Promise;


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(212);
var defined = __webpack_require__(211);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(146);
var descriptor = __webpack_require__(98);
var setToStringTag = __webpack_require__(106);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(61)(IteratorPrototype, __webpack_require__(29)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(45);
var anObject = __webpack_require__(57);
var getKeys = __webpack_require__(99);

module.exports = __webpack_require__(52) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(755);
var step = __webpack_require__(351);
var Iterators = __webpack_require__(105);
var toIObject = __webpack_require__(87);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(226)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(145);
var global = __webpack_require__(28);
var ctx = __webpack_require__(56);
var classof = __webpack_require__(228);
var $export = __webpack_require__(24);
var isObject = __webpack_require__(46);
var aFunction = __webpack_require__(97);
var anInstance = __webpack_require__(229);
var forOf = __webpack_require__(107);
var speciesConstructor = __webpack_require__(355);
var task = __webpack_require__(356).set;
var microtask = __webpack_require__(758)();
var newPromiseCapabilityModule = __webpack_require__(230);
var perform = __webpack_require__(357);
var promiseResolve = __webpack_require__(358);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(29)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(231)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(106)($Promise, PROMISE);
__webpack_require__(359)(PROMISE);
Wrapper = __webpack_require__(23)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(360)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 757 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var macrotask = __webpack_require__(356).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(100)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(24);
var core = __webpack_require__(23);
var global = __webpack_require__(28);
var speciesConstructor = __webpack_require__(355);
var promiseResolve = __webpack_require__(358);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(24);
var newPromiseCapability = __webpack_require__(230);
var perform = __webpack_require__(357);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(762), __esModule: true };

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144);
__webpack_require__(763);
module.exports = __webpack_require__(23).Array.from;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(56);
var $export = __webpack_require__(24);
var toObject = __webpack_require__(88);
var call = __webpack_require__(352);
var isArrayIter = __webpack_require__(353);
var toLength = __webpack_require__(137);
var createProperty = __webpack_require__(764);
var getIterFn = __webpack_require__(354);

$export($export.S + $export.F * !__webpack_require__(360)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(45);
var createDesc = __webpack_require__(98);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(766), __esModule: true };

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(144);
__webpack_require__(227);
module.exports = __webpack_require__(232).f('iterator');


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(768), __esModule: true };

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(769);
__webpack_require__(225);
__webpack_require__(772);
__webpack_require__(773);
module.exports = __webpack_require__(23).Symbol;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(28);
var has = __webpack_require__(76);
var DESCRIPTORS = __webpack_require__(52);
var $export = __webpack_require__(24);
var redefine = __webpack_require__(348);
var META = __webpack_require__(233).KEY;
var $fails = __webpack_require__(75);
var shared = __webpack_require__(214);
var setToStringTag = __webpack_require__(106);
var uid = __webpack_require__(138);
var wks = __webpack_require__(29);
var wksExt = __webpack_require__(232);
var wksDefine = __webpack_require__(234);
var enumKeys = __webpack_require__(770);
var isArray = __webpack_require__(361);
var anObject = __webpack_require__(57);
var isObject = __webpack_require__(46);
var toIObject = __webpack_require__(87);
var toPrimitive = __webpack_require__(209);
var createDesc = __webpack_require__(98);
var _create = __webpack_require__(146);
var gOPNExt = __webpack_require__(771);
var $GOPD = __webpack_require__(363);
var $DP = __webpack_require__(45);
var $keys = __webpack_require__(99);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(362).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(139).f = $propertyIsEnumerable;
  __webpack_require__(216).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(145)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(61)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(99);
var gOPS = __webpack_require__(216);
var pIE = __webpack_require__(139);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(87);
var gOPN = __webpack_require__(362).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234)('asyncIterator');


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234)('observable');


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(775), __esModule: true };

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(776);
module.exports = __webpack_require__(23).Object.setPrototypeOf;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(24);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(777).set });


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(46);
var anObject = __webpack_require__(57);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(56)(Function.call, __webpack_require__(363).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(779), __esModule: true };

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(780);
var $Object = __webpack_require__(23).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(24);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(146) });


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */



var invariant = __webpack_require__(310);

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function keyMirror(obj) {
  var ret = {};
  var key;
  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export login */
/* unused harmony export logout */
/* harmony export (immutable) */ __webpack_exports__["a"] = root;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(58);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(login),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(logout),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(root);/**
 * @module Sagas/User
 * @desc User
 *//**
 * Login
 */function login(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function login$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],400);case 3:_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGIN_SUCCESS});case 5:_context.next=11;break;case 7:_context.prev=7;_context.t0=_context['catch'](0);_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGIN_FAILURE,payload:_context.t0});case 11:case'end':return _context.stop();}}},_marked,this,[[0,7]]);}/**
 * Logout
 */function logout(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function logout$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_1_redux_saga__["b" /* delay */],200);case 3:_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGOUT_SUCCESS});case 5:_context2.next=11;break;case 7:_context2.prev=7;_context2.t0=_context2['catch'](0);_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGOUT_FAILURE,payload:_context2.t0});case 11:case'end':return _context2.stop();}}},_marked2,this,[[0,7]]);}/**
 * User Sagas
 */function root(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function root$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGIN_REQUEST,login),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGOUT_REQUEST,logout)]);case 2:case'end':return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRepos */
/* unused harmony export drawerStatusChange */
/* unused harmony export closeIntro */
/* unused harmony export showIntro */
/* unused harmony export getEdges */
/* unused harmony export getNodes */
/* unused harmony export setDetail */
/* unused harmony export getHtml */
/* unused harmony export infoDrawerStatusChange */
/* unused harmony export getNodesByCountry */
/* harmony export (immutable) */ __webpack_exports__["a"] = root;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_api__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_index__ = __webpack_require__(58);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getRepos),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(drawerStatusChange),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(closeIntro),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(showIntro),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getEdges),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getNodes),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setDetail),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getHtml),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(infoDrawerStatusChange),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getNodesByCountry),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(root);/**
 * @module Sagas/App
 * @desc App
 */var CONFIG=__webpack_require__(79);function getRepos(_ref){var payload=_ref.payload;var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getRepos$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_modules_api__["a" /* request */],'https://api.github.com/search/repositories?q='+payload.query+'&sort=stars');case 3:response=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_SUCCESS,payload:{data:response.items}});case 6:_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](0);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_FAILURE,payload:_context.t0});case 12:case'end':return _context.stop();}}},_marked,this,[[0,8]]);}/**
 * drawerStatusChange
 */function drawerStatusChange(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function drawerStatusChange$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].DRAWER_CHANGED});case 2:case'end':return _context2.stop();}}},_marked2,this);}function closeIntro(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function closeIntro$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].CLOSE_INTRO});case 2:case'end':return _context3.stop();}}},_marked3,this);}function showIntro(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function showIntro$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SHOW_INTRO});case 2:case'end':return _context4.stop();}}},_marked4,this);}function getEdges(){var response,edges,index,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,edge;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getEdges$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;//const response = yield call(request, './edges.json');
response=__webpack_require__(784);edges=[];index=1;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context5.prev=7;for(_iterator=response[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){edge=_step.value;if(!edge.id){edge.id=index;}index++;edges.push(edge);}_context5.next=15;break;case 11:_context5.prev=11;_context5.t0=_context5['catch'](7);_didIteratorError=true;_iteratorError=_context5.t0;case 15:_context5.prev=15;_context5.prev=16;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 18:_context5.prev=18;if(!_didIteratorError){_context5.next=21;break;}throw _iteratorError;case 21:return _context5.finish(18);case 22:return _context5.finish(15);case 23:_context5.next=25;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_EDGES_SUCCESS,payload:{data:edges}});case 25:_context5.next=31;break;case 27:_context5.prev=27;_context5.t1=_context5['catch'](0);_context5.next=31;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_EDGES_FAILURE,payload:_context5.t1});case 31:case'end':return _context5.stop();}}},_marked5,this,[[0,27],[7,11,15,23],[16,,18,22]]);}function getNodes(_ref2){var payload=_ref2.payload;var tag,response,nodes,allnodes,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,node,tagstr,tags,search_tags,index,_iteratorNormalCompletion3,_didIteratorError3,_iteratorError3,_iterator3,_step3,search_tag;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getNodes$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;tag=payload.tag;//const response = yield call(request, './nodes.json');
response=__webpack_require__(364);nodes=[];allnodes=[];_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context6.prev=8;_iterator2=response[Symbol.iterator]();case 10:if(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done){_context6.next=49;break;}node=_step2.value;if(!node.image){node.image=CONFIG.genericicons[node.type];}if(node.image){node.shape='circularImage';}node.title=node.label;if(node.type==='terror-organization'){node.color={border:'red',highlight:{background:'red',border:'red'},hover:{background:'red',border:'red'}};}allnodes.push(node);tagstr=node.tags;if(!(tag===''||!tag)){_context6.next=22;break;}nodes.push(node);_context6.next=46;break;case 22:if(!tagstr){_context6.next=46;break;}tags=tagstr.split(',');search_tags=tag.split('+');index=0;_iteratorNormalCompletion3=true;_didIteratorError3=false;_iteratorError3=undefined;_context6.prev=29;for(_iterator3=search_tags[Symbol.iterator]();!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){search_tag=_step3.value;if(tags.indexOf(search_tag)!==-1){index++;}}_context6.next=37;break;case 33:_context6.prev=33;_context6.t0=_context6['catch'](29);_didIteratorError3=true;_iteratorError3=_context6.t0;case 37:_context6.prev=37;_context6.prev=38;if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}case 40:_context6.prev=40;if(!_didIteratorError3){_context6.next=43;break;}throw _iteratorError3;case 43:return _context6.finish(40);case 44:return _context6.finish(37);case 45:if(index===search_tags.length){nodes.push(node);}case 46:_iteratorNormalCompletion2=true;_context6.next=10;break;case 49:_context6.next=55;break;case 51:_context6.prev=51;_context6.t1=_context6['catch'](8);_didIteratorError2=true;_iteratorError2=_context6.t1;case 55:_context6.prev=55;_context6.prev=56;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 58:_context6.prev=58;if(!_didIteratorError2){_context6.next=61;break;}throw _iteratorError2;case 61:return _context6.finish(58);case 62:return _context6.finish(55);case 63:_context6.next=65;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES_SUCCESS,payload:{data:nodes}});case 65:_context6.next=67;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_ALL_NODES_SUCCESS,payload:{data:allnodes}});case 67:_context6.next=69;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_TAG_SUCCESS,payload:{data:tag}});case 69:_context6.next=75;break;case 71:_context6.prev=71;_context6.t2=_context6['catch'](0);_context6.next=75;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES_FAILURE,payload:_context6.t2});case 75:case'end':return _context6.stop();}}},_marked6,this,[[0,71],[8,51,55,63],[29,33,37,45],[38,,40,44],[56,,58,62]]);}function setDetail(_ref3){var payload=_ref3.payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setDetail$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_DETAIL_SUCCESS,payload:{info:payload}});case 3:_context7.next=9;break;case 5:_context7.prev=5;_context7.t0=_context7['catch'](0);_context7.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_DETAIL_FAILURE,payload:_context7.t0});case 9:case'end':return _context7.stop();}}},_marked7,this,[[0,5]]);}function getHtml(_ref4){var payload=_ref4.payload;var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getHtml$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_modules_api__["a" /* request */],'../html/test.html');case 3:response=_context8.sent;_context8.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_HTML_SUCCESS,payload:{data:response}});case 6:_context8.next=12;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](0);_context8.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_HTML_FAILURE,payload:_context8.t0});case 12:case'end':return _context8.stop();}}},_marked8,this,[[0,8]]);}function infoDrawerStatusChange(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function infoDrawerStatusChange$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].INFO_DRAWER_CHANGED});case 2:case'end':return _context9.stop();}}},_marked9,this);}function getNodesByCountry(_ref5){var payload=_ref5.payload;var country,response,nodes,_iteratorNormalCompletion4,_didIteratorError4,_iteratorError4,_iterator4,_step4,node,countrystr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getNodesByCountry$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.prev=0;country=payload.country;response=__webpack_require__(364);nodes=[];_iteratorNormalCompletion4=true;_didIteratorError4=false;_iteratorError4=undefined;_context10.prev=7;for(_iterator4=response[Symbol.iterator]();!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){node=_step4.value;if(!node.image){node.image=CONFIG.genericicons[node.type];}if(node.image){node.shape='circularImage';}node.title=node.label;if(node.type==='terror-organization'){node.color={border:'red',highlight:{background:'red',border:'red'},hover:{background:'red',border:'red'}};}countrystr=node.country;if(countrystr){if(countrystr===country){nodes.push(node);}}}_context10.next=15;break;case 11:_context10.prev=11;_context10.t0=_context10['catch'](7);_didIteratorError4=true;_iteratorError4=_context10.t0;case 15:_context10.prev=15;_context10.prev=16;if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}case 18:_context10.prev=18;if(!_didIteratorError4){_context10.next=21;break;}throw _iteratorError4;case 21:return _context10.finish(18);case 22:return _context10.finish(15);case 23:_context10.next=25;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES_SUCCESS,payload:{data:nodes}});case 25:_context10.next=31;break;case 27:_context10.prev=27;_context10.t1=_context10['catch'](0);_context10.next=31;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* put */])({type:__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES_FAILURE,payload:_context10.t1});case 31:case'end':return _context10.stop();}}},_marked10,this,[[0,27],[7,11,15,23],[16,,18,22]]);}/**
 * App Sagas
 */function root(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function root$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].DRAWER_CHANGE,drawerStatusChange),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_EDGES,getEdges),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES,getNodes),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_DETAIL,setDetail),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_HTML,getHtml),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].INFO_DRAWER_CHANGE,infoDrawerStatusChange),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES_BY_COUNTRY,getNodesByCountry)]);case 2:case'end':return _context11.stop();}}},_marked11,this);}

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = [{"from":1,"to":7,"type":"project","description":"\"The third largest QCUK expenditures listed and for 638,695 was for the “Sheffield Project, Emaan Trust that is described as a “multi purposes centre” that will contain a nursery, full-time school, social and cultural centre with a multipurpose hall, in addition to a library and restaurant, a prayer hall, a gym and a car parking.\n \nThe EMAAN TRUST Sheffield project appears to be focused on providing facilities for the Yemeni MUSLIM BROTHERHOOD in the UK and centers on UK converts to Islam. Many of the EMAAN TRUST officers have problematic ties to the MUSLIM BROTHERHOOD, Islamism, and/or terrorism.\"","page":1},{"from":7,"to":11,"type":"application-send","description":"The project had its origins in a July 2006 application to the local planning department for the BOTHAM STREET MOSQUE AND ISLAMIC CENTRE, signed on behalf of CATALYST REGENERATION by AKRAM BONHAM (MCIAT), head of the Building Design Department.","page":4,"reference":"https://planningapps.sheffield.gov.uk/online-applications/files/19B9DC3771EA97BBD135161F5C6D87D8/pdf/06_03268_FUL-CORRESPONDENCE-148556.pdf"},{"from":8,"to":58,"type":"signed-on-behalf-of","description":"The project had its origins in a July 2006 application to the local planning department for the BOTHAM STREET MOSQUE AND ISLAMIC CENTRE, signed on behalf of CATALYST REGENERATION by AKRAM BONHAM (MCIAT), head of the Building Design Department.","page":7,"reference":"https://planningapps.sheffield.gov.uk/online-applications/files/19B9DC3771EA97BBD135161F5C6D87D8/pdf/06_03268_FUL-CORRESPONDENCE-148556.pdf"},{"from":7,"to":10,"type":"providing-facilities-for","description":"The EMAAN TRUST Sheffield project appears to be focused on providing facilities for the Yemeni MUSLIM BROTHERHOOD in the UK and centers on UK converts to Islam.","page":4},{"from":11,"to":8,"type":"signed-on-behalf-of","description":"The project had its origins in a July 2006 application to the local planning department for the BOTHAM STREET MOSQUE AND ISLAMIC CENTRE, signed on behalf of CATALYST REGENERATION by AKRAM BONHAM (MCIAT), head of the Building Design Department.","page":7,"reference":"https://planningapps.sheffield.gov.uk/online-applications/files/19B9DC3771EA97BBD135161F5C6D87D8/pdf/06_03268_FUL-CORRESPONDENCE-148556.pdf"},{"from":8,"to":58,"type":"signed-on-behalf-of","description":"The project had its origins in a July 2006 application to the local planning department for the BOTHAM STREET MOSQUE AND ISLAMIC CENTRE, signed on behalf of CATALYST REGENERATION by AKRAM BONHAM (MCIAT), head of the Building Design Department.","page":7,"reference":"https://planningapps.sheffield.gov.uk/online-applications/files/19B9DC3771EA97BBD135161F5C6D87D8/pdf/06_03268_FUL-CORRESPONDENCE-148556.pdf"},{"from":14,"to":7,"type":"listed-for-incorporation","description":"No further activity on the project appears to have taken place until September 2010 when a new planning department files was created with the applicant as HAMEED AL-ASALY who listed the AL-EMAAN TRUST as the company.","page":7,"reference":"Rothay Street She eld South Yorkshire S4 8BD"},{"from":35,"to":8,"type":"funding","description":"HAMEED AL-ASALY, of the Birmingham-based CATALYST REGENERATION (UK) LTD was described as managing the project which was reportedly to be funded by Sheffield Muslims, including former World boxing champion NASEEM HAMED.","page":7},{"from":17,"to":7,"type":"listed-for-incorporation","description":"EMAAN TRUST OF SHEFFIELD was incorporated in January 2009 and a charity with the name THE EMAAN TRUST was registered with the UK Charity Commission in September 2009. The agent listed for the incorporation was OMER AL-HAMDOON, likely the current President of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and using the address of the MUSLIM WELFARE HOUSE OF SHEFFIELD.","page":7},{"from":15,"to":7,"type":"funding","description":"HAMEED AL-ASALY is based in Birmingham CATALYST REGENERATION (UK) LTD was described as managing the project which was reportedly to be funded by Sheffield Muslims, including former World boxing champion NASEEM HAMED.","page":7},{"from":14,"to":8,"type":"chairman","description":"In 2006 local media had identified HAMEED AL-ASALY as chairman of the committee managing the mosque project for CATALYST REGENERATION although no record of any employment for AL-ASALY by CATALYST REGENERATION was found. \n \n The CATALYST REGENERATION website explains that the company has been providing multi-disciplinary consultancy services to the construction industry for 30 years in the UK, Europe, and the Middle East. Although the CATALYST REGENERATION website identifies many secular building projects, it also lists numerous mosques, Islamic centers, and Islamic educational facilities in its portfolio.","page":8,"reference":"http://catalystr.com/portfolio/"},{"from":17,"to":18,"type":"president","description":"The agent listed for the incorporation was OMER AL-HAMDOON, likely the current President of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and using the address of the MUSLIM WELFARE HOUSE OF SHEFFIELD.","page":8,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/OggCkpP_F1uCSrLlS2hzDf2Y__oYKjbSI9Tqmga-dK8/application-pdf?AWSAccessKeyId=ASIAIXESVVFLY4N64VHA&Expires=1516626780&Signature=G9sNsU0ezwOE1KeymsiGIR%2FurlE%3D&x-amz-security-token=FQoDYXdzECoaDLxE%2BJI2cctwr5x90yK3A0hm5EIqYiVF%2BEDgJ6Fqd4MJNJzCb7UTMZXfD8jKiFRkdiGEEGsog6TjjrjKI2kcwmiGFAjJiUd%2BLYfzJdammSOlaw16ZmUar0mSafAeWYF7hqD74AIDfYTGboJpVwahMsVOMDrS9bftLO9PDAPhB7KAYV1KxsEYVzJ0mKjos9TdhF1SUEAZWTBFFY2SVeV7Py01uw%2FVy%2FLSe%2F%2BLXo6VeoVz33mVUP3f0EqpMQfpfvY1A41I3uiSxVyXOVMChyeHnPLnlciGcx5aFesjhRL5y5VhvVzJo7747vJq4fwewbsS3JDNXruIa0WoXPPW6mSOHI9GywT06T2yu8PYJrHfwnllCmhZBGhPZdBYE06os6r34U%2FA5TuLyILIngwUJs0As1ylBgg67eqXpDoAGwaTi%2BH5lAoXGaizV8AHNPffgCSfTUB0oxgAy77yVR9CcTlpajJ8nle7LxsPVGQEXj4lxSwOhmebiHyaVGAtgbQhhyFHcuRo9RfGUnBMZzsZpJFbw5fWaxtZkzXM1xcjRBSQUFQIwyro4Ra%2BkupD4%2FpSqgBn3IDC685AgoabG7Mv9q%2FkogsjmeML8AAojc6W0wU%3D"},{"from":18,"to":19,"type":"using-same-address","description":"The agent listed for the incorporation was OMER AL-HAMDOON, likely the current President of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and using the address of the MUSLIM WELFARE HOUSE OF SHEFFIELD.","page":7,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/OggCkpP_F1uCSrLlS2hzDf2Y__oYKjbSI9Tqmga-dK8/application-pdf?AWSAccessKeyId=ASIAIXESVVFLY4N64VHA&Expires=1516626780&Signature=G9sNsU0ezwOE1KeymsiGIR%2FurlE%3D&x-amz-security-token=FQoDYXdzECoaDLxE%2BJI2cctwr5x90yK3A0hm5EIqYiVF%2BEDgJ6Fqd4MJNJzCb7UTMZXfD8jKiFRkdiGEEGsog6TjjrjKI2kcwmiGFAjJiUd%2BLYfzJdammSOlaw16ZmUar0mSafAeWYF7hqD74AIDfYTGboJpVwahMsVOMDrS9bftLO9PDAPhB7KAYV1KxsEYVzJ0mKjos9TdhF1SUEAZWTBFFY2SVeV7Py01uw%2FVy%2FLSe%2F%2BLXo6VeoVz33mVUP3f0EqpMQfpfvY1A41I3uiSxVyXOVMChyeHnPLnlciGcx5aFesjhRL5y5VhvVzJo7747vJq4fwewbsS3JDNXruIa0WoXPPW6mSOHI9GywT06T2yu8PYJrHfwnllCmhZBGhPZdBYE06os6r34U%2FA5TuLyILIngwUJs0As1ylBgg67eqXpDoAGwaTi%2BH5lAoXGaizV8AHNPffgCSfTUB0oxgAy77yVR9CcTlpajJ8nle7LxsPVGQEXj4lxSwOhmebiHyaVGAtgbQhhyFHcuRo9RfGUnBMZzsZpJFbw5fWaxtZkzXM1xcjRBSQUFQIwyro4Ra%2BkupD4%2FpSqgBn3IDC685AgoabG7Mv9q%2FkogsjmeML8AAojc6W0wU%3D"},{"from":7,"to":20,"type":"secretary","description":"Three initial officers of the EMAAN Trust company were listed, all profiled below:\n Qatar Charity UK\n - SALEH ALI ALNOUD (Secretary)\n - AIMAN MOHAMMED EBRAHIM SAEED (Director)\n - SALEH MOHAMED HUSSEIN (Director)","page":7,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/nfNlK8z-oyjh3kND3czIW7NC3JhijONShKeNpzOYV9I/application-pdf?AWSAccessKeyId=ASIAJ3LHBO6T5MZ4BLWA&Expires=1516626887&Signature=AfU8rHnNRjCuAFdeJHZhFF1jkcE%3D&x-amz-security-token=FQoDYXdzECoaDM5moEIEyd9vOAbF5yK3A8VBCmzGEDpujJ%2B4GguF7D0oRdUABTpydtJCMeaOOjgUZsuHBx79dOE7ONBe7kLKMasG9WpiRC1gDizUYnWO2ENMz8MZ3uWJml%2FyzRUg8x8k%2Fr9v2dBHQJfq8R61jEnVw%2B3HwIQGoukFq7wdFOWkihkvlWnmzTWJeMGdKR24Kua0bRXxI52gZs3Hh6qOkKwUYMrxeSrpt5bA5PW2PtBLWXkkBBN%2BulairWrU5B31OQQo8tK1kcg2chvyQ8Dbjbq0HKfiaRSEYTXJLDkg2xoQfLj5B2bzjU2lgE9ccqmdpqMGxQZyqeyIh2mM%2F%2FCVv7D6%2BC904cjP369vBVjY8AAEU8BeWqo3118Xz54nHWnsRJX4GQ7tKQsEIdXPZUovc%2FvUdMLAFiSH1iyNZukDcCETeUR62QubA86%2F5i23eQvEtmoCLx8SikfQ1xJH96%2B%2F2IvYe3STMvJtXAf4f9KGXB0oJZ6g2U65fhy9770n1ZnADtJjQipvlFpILSnwXhFMn8E5zdMgEwbhvtVCq5FTD8BDhUYqO2dwgeRx0GP5hI%2BcrGiikTulw9mjYb2DuVF6AM22ROrXFEcl%2BO8o7sSW0wU%3D"},{"from":7,"to":21,"type":"director","description":"Three initial officers of the EMAAN Trust company were listed, all profiled below:\n Qatar Charity UK\n - SALEH ALI ALNOUD (Secretary)\n - AIMAN MOHAMMED EBRAHIM SAEED (Director)\n - SALEH MOHAMED HUSSEIN (Director)","page":7,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/nfNlK8z-oyjh3kND3czIW7NC3JhijONShKeNpzOYV9I/application-pdf?AWSAccessKeyId=ASIAJ3LHBO6T5MZ4BLWA&Expires=1516626887&Signature=AfU8rHnNRjCuAFdeJHZhFF1jkcE%3D&x-amz-security-token=FQoDYXdzECoaDM5moEIEyd9vOAbF5yK3A8VBCmzGEDpujJ%2B4GguF7D0oRdUABTpydtJCMeaOOjgUZsuHBx79dOE7ONBe7kLKMasG9WpiRC1gDizUYnWO2ENMz8MZ3uWJml%2FyzRUg8x8k%2Fr9v2dBHQJfq8R61jEnVw%2B3HwIQGoukFq7wdFOWkihkvlWnmzTWJeMGdKR24Kua0bRXxI52gZs3Hh6qOkKwUYMrxeSrpt5bA5PW2PtBLWXkkBBN%2BulairWrU5B31OQQo8tK1kcg2chvyQ8Dbjbq0HKfiaRSEYTXJLDkg2xoQfLj5B2bzjU2lgE9ccqmdpqMGxQZyqeyIh2mM%2F%2FCVv7D6%2BC904cjP369vBVjY8AAEU8BeWqo3118Xz54nHWnsRJX4GQ7tKQsEIdXPZUovc%2FvUdMLAFiSH1iyNZukDcCETeUR62QubA86%2F5i23eQvEtmoCLx8SikfQ1xJH96%2B%2F2IvYe3STMvJtXAf4f9KGXB0oJZ6g2U65fhy9770n1ZnADtJjQipvlFpILSnwXhFMn8E5zdMgEwbhvtVCq5FTD8BDhUYqO2dwgeRx0GP5hI%2BcrGiikTulw9mjYb2DuVF6AM22ROrXFEcl%2BO8o7sSW0wU%3D"},{"from":7,"to":22,"type":"director","description":"Three initial officers of the EMAAN Trust company were listed, all profiled below:\n Qatar Charity UK\n - SALEH ALI ALNOUD (Secretary)\n - AIMAN MOHAMMED EBRAHIM SAEED (Director)\n - SALEH MOHAMED HUSSEIN (Director)","page":7,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/nfNlK8z-oyjh3kND3czIW7NC3JhijONShKeNpzOYV9I/application-pdf?AWSAccessKeyId=ASIAJ3LHBO6T5MZ4BLWA&Expires=1516626887&Signature=AfU8rHnNRjCuAFdeJHZhFF1jkcE%3D&x-amz-security-token=FQoDYXdzECoaDM5moEIEyd9vOAbF5yK3A8VBCmzGEDpujJ%2B4GguF7D0oRdUABTpydtJCMeaOOjgUZsuHBx79dOE7ONBe7kLKMasG9WpiRC1gDizUYnWO2ENMz8MZ3uWJml%2FyzRUg8x8k%2Fr9v2dBHQJfq8R61jEnVw%2B3HwIQGoukFq7wdFOWkihkvlWnmzTWJeMGdKR24Kua0bRXxI52gZs3Hh6qOkKwUYMrxeSrpt5bA5PW2PtBLWXkkBBN%2BulairWrU5B31OQQo8tK1kcg2chvyQ8Dbjbq0HKfiaRSEYTXJLDkg2xoQfLj5B2bzjU2lgE9ccqmdpqMGxQZyqeyIh2mM%2F%2FCVv7D6%2BC904cjP369vBVjY8AAEU8BeWqo3118Xz54nHWnsRJX4GQ7tKQsEIdXPZUovc%2FvUdMLAFiSH1iyNZukDcCETeUR62QubA86%2F5i23eQvEtmoCLx8SikfQ1xJH96%2B%2F2IvYe3STMvJtXAf4f9KGXB0oJZ6g2U65fhy9770n1ZnADtJjQipvlFpILSnwXhFMn8E5zdMgEwbhvtVCq5FTD8BDhUYqO2dwgeRx0GP5hI%2BcrGiikTulw9mjYb2DuVF6AM22ROrXFEcl%2BO8o7sSW0wU%3D"},{"from":22,"to":23,"type":"director","description":"SALEH MOHAMED HUSSEIN is also a director of the AL RAHMAN MOSQUE AND CULTURAL CENTRE LTD, likely associated with the AL-RAHMAN MOSQUE AND CULTURAL CENTRE in Sheffield.","page":7,"reference":"https://beta.companieshouse.gov.uk/officers/uNpecO0BS-Ky9xGEO39SNjAMozg/appointments"},{"from":23,"to":82,"type":"associated-with","description":"SALEH MOHAMED HUSSEIN is also a director of the AL RAHMAN MOSQUE AND CULTURAL CENTRE LTD, likely associated with the AL-RAHMAN MOSQUE AND CULTURAL CENTRE in Sheffield.","page":7,"reference":"https://beta.companieshouse.gov.uk/officers/uNpecO0BS-Ky9xGEO39SNjAMozg/appointments"},{"from":24,"to":25,"type":"former-director","description":"HASSAN ALKATIB is a Leeds resident who has listed his profession as “Property Development Consultant” who was described by UK media as “an active member of the Muslim Brotherhood” and also was a former director of the LEEDS GRAND MOSQUE.","page":7},{"from":25,"to":26,"type":"tied-to","description":"HASSAN ALKATIB is also known to have been an officer in multiple companies tied to the UK MUSLIM BROTHERHOOD.","page":7},{"from":24,"to":48,"type":"active-member","description":"HASSAN ALKATIB is a Leeds resident who has listed his profession as “Property Development Consultant” who was described by UK media as “an active member of the Muslim Brotherhood” and also was a former director of the LEEDS GRAND MOSQUE.","page":7},{"from":32,"to":3,"type":"former-president","description":"AHMED AL-RAWI is a 69-year-old British national resident in England who is best known as the former President of both the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and the MUSLIM ASSOCIATION OF BRITAIN (MAB).","page":9},{"from":32,"to":18,"type":"former-president","description":"AHMED AL-RAWI is a 69-year-old British national resident in England who is best known as the former President of both the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and the MUSLIM ASSOCIATION OF BRITAIN (MAB).","page":9},{"from":32,"to":6,"type":"head","description":"AHMED AL-RAWI is currently the head of the EUROPE TRUST.","page":9},{"from":24,"to":25,"type":"director","description":"HASSAN ALKATIB is a Leeds resident who has listed his profession as “Property Development Consultant” who was described by UK media as “an active member of the Muslim Brotherhood” and also was a former director of the LEEDS GRAND MOSQUE.","page":7,"reference":"http://opencharities.org/charities/1131861"},{"from":24,"to":26,"type":"officer-in-multiple-companies-tied-to","description":"ALKATIB is also known to have been an officer in multiple companies tied to the UK MUSLIM BROTHERHOOD.","page":7},{"from":7,"to":30,"type":"trustees","description":"The LinkedIn resume for ABDERREZAK BOUGARA identifies him as a Trustee of the EMAAN TRUST.","page":65,"reference":"http://opencharities.org/charities/1131861"},{"from":36,"to":18,"type":"vice-president","description":"In 2008, UK media identifed MOKHTAR BADRI as the vice-president of the MAB.","page":44,"reference":"http://www.telegraph.co.uk/news/religion/3212112/Protests-expected-as-woman-leads-Muslim-prayers-in-Britain-for-first-time.html"},{"from":41,"to":7,"type":"funding","description":"In 2014 it was reported that the Ministry of Awqaf in Kuwait donated £85,753 to the Emaan School and to Administration costs.","page":8,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends61/0001131861_AC_20140131_E_C.pdf"},{"from":14,"to":7,"type":"registration-address","description":"HAMEED AL-ASALY is a 51-year-old British national who listed correspondence address in Sheffield that is social housing and that is also used as the registered address for the EMAAN TRUST.","page":8},{"from":14,"to":42,"type":"married","description":"HAMEED AL-ASALY was married to TRACY A ALASALY, in Sheffield in October 1997.","page":8,"reference":"http://search.findmypast.co.uk/record?id=bmd%2fm%2f1997%2f10%2f90682524"},{"from":14,"to":43,"type":"connection","description":"HAMEED AL-ASALY also known to be or have been affiliated with the following organization (total 6 organizations), all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - HUMAN APPEAL INTERNATIONAL (HAI)","page":8,"reference":"https://www.linkedin.com/in/hameed-al-asaly-83359050"},{"from":14,"to":152,"type":"connection","description":"HAMEED AL-ASALY also known to be or have been affiliated with the following organization (total 6 organizations), all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - MUSLIMAAT SHEFFIELD ASSOCIATION OF MUSLIM WOMEN AND GIRLS","page":8,"reference":"http://opencharities.org/charities/1052325"},{"from":14,"to":45,"type":"connection","description":"HAMEED AL-ASALY also known to be or have been affiliated with the following organization (total 6 organizations), all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - NATIVE EUROPEAN MUSLIM ASSOCIATION (NEMA), an organization centered on new Islamic converts and discussed later in this report.","page":8,"reference":"http://web.archive.org/web/20120920162918/http://www.nema.eu.com/article.php?id=28"},{"from":14,"to":46,"type":"connection","description":"HAMEED AL-ASALY also known to be or have been affiliated with the following organization (total 6 organizations), all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - MUATH TRUST","page":8,"reference":"http://standforpeace.org.uk/muath-trust-hosts-hate-preacher-in-aid-of-terror-linked-charity/"},{"from":14,"to":47,"type":"connection","description":"HAMEED AL-ASALY also known to be or have been affiliated with the following organization (total 6 organizations), all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - MUSLIM STUDENTS SOCIETY UK & EIRE (MSSUK)","page":8,"reference":"https://books.google.com/books?id=TlXRCwAAQBAJ&pg=PA49&lpg=PA49&dq=%22muslim+student+society+%22+Muslim+Brotherhood&source=bl&ots=6Izkwy16iI&sig=Ay8pqeHD4Ln3_LVdHgbDtNdoYes&hl=en&sa=X&redir_esc=y#v=onepage&q=%22muslim student society %22 Muslim Brotherhood&f=false"},{"from":14,"to":18,"type":"connection","description":"\"HAMEED AL-ASALY also known to be or have been affiliated with the following organization (total 6 organizations), all tied to the Global MUSLIM BROTHERHOOD and/or Hamas:\n - MUSLIM ASSOCIATION OF BRITAIN (MAB).","page":8,"reference":"http://www.globalmbwatch.com/muslim-association-of-britain/"},{"from":152,"to":49,"type":"connection","description":"- MUSLIMAAT SHEFFIELD ASSOCIATION OF MUSLIM WOMEN AND GIRLS, associated with the FATIMA COMMUNITY CENTRE, likely tied to the Muslim Association of Britain (MAB).","page":8,"reference":"http://heyevent.uk/venue/el3wl24ezezima"},{"from":49,"to":18,"type":"tied-to","description":"- MUSLIMAAT SHEFFIELD ASSOCIATION OF MUSLIM WOMEN AND GIRLS, associated with the FATIMA COMMUNITY CENTRE, likely tied to the Muslim Association of Britain (MAB).","page":8,"reference":"http://heyevent.uk/venue/el3wl24ezezima"},{"from":42,"to":50,"type":"director","description":"TRACY AL-ASALY was also the sole director of a now-dissolved sports company known as SUNNA SPORTS LTD.","page":8,"reference":"https://beta.companieshouse.gov.uk/company/07614880/officers"},{"from":42,"to":51,"type":"facebook","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ANAS ALTIKRITI","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":42,"to":52,"type":"facebook","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n -MAB BIRMINGHAM","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":42,"to":53,"type":"facebook","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":42,"to":54,"type":"facebook","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":53,"to":3,"type":"connection","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - HANY ELDEEB (FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE - FIOE)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":53,"to":45,"type":"connection","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - HANY ELDEEB (NATIVE EUROPEAN MUSLIM ASSOCIATION - NEMA)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":53,"to":55,"type":"connection","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - HANY ELDEEB (Egyptian Muslim Brotherhood)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":53,"to":83,"type":"connection","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - HANY ELDEEB (Muslim Welfare House)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":54,"to":46,"type":"connection","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ADNAN SAIF (MUATH TRUST)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":54,"to":56,"type":"connection","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":54,"to":57,"type":"connection","description":"A number of EMAAN TRUST officers are listed as TRACY AL-ASALY facebook friends as well as other individuals of interest including:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":8,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":54,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be to the Global Muslim Brotherhood, some of whom were identified in this investigation: - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":9,"reference":"https://www.facebook.com/markupproofreading/friends?source_ref=pb_friends_tl"},{"from":58,"to":59,"type":"director","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD.","page":8,"reference":"https://beta.companieshouse.gov.uk/officers/nX_Y4s7gqpJsEZ3yWW9ipJii6Bw/appointments"},{"from":59,"to":60,"type":"using-same-address","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - EUROPE TRUST \n - TISEER TRUST \n - RIGHTSTART FOUNDATION \n - ASSOCIATION OF MUSLIM SCHOOLS UK","page":8},{"from":59,"to":61,"type":"using-same-address","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - EUROPE TRUST \n - TISEER TRUST \n - RIGHTSTART FOUNDATION \n - ASSOCIATION OF MUSLIM SCHOOLS UK","page":8},{"from":59,"to":62,"type":"using-same-address","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD.","page":8},{"from":59,"to":6,"type":"using-same-address","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - EUROPE TRUST \n - TISEER TRUST \n - RIGHTSTART FOUNDATION \n - ASSOCIATION OF MUSLIM SCHOOLS UK","page":8},{"from":6,"to":26,"type":"connection","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - EUROPE TRUST \n - TISEER TRUST \n - RIGHTSTART FOUNDATION \n - ASSOCIATION OF MUSLIM SCHOOLS UK","page":8},{"from":60,"to":26,"type":"connection","description":"From 1996 through 2008, it\n ways he was the Managing Director for BARB SERVICES LTD. UK and architectural consulting rm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD:\n - TISEER TRUST","page":8},{"from":61,"to":26,"type":"connection","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - RIGHTSTART FOUNDATION","page":8},{"from":62,"to":26,"type":"connection","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - ASSOCIATION OF MUSLIM SCHOOLS UK","page":8},{"from":26,"to":6,"type":"connection","description":"From 1996 through 2008, Mark Bonham ways was the Managing Director for BARB SERVICES LTD. UK and architectural consulting firm in Birmingham that from October 2005 until July 2006 used an address associated with at least four other companies and/or charities tied to the UK MUSLIM BROTHERHOOD: \n - EUROPE TRUST","page":8},{"from":58,"to":63,"type":"director","description":"BONHAM was employed from 1980 through 1996 as a director OF BONHAM REYNOLDS PROJECT MANAGEMENT, a business & management consultancy that also included KEITH WILLIAM REYNOLDS as a director.","page":9,"reference":"https://companycheck.co.uk/company/02516288/BONHAM-REYNOLDS-PROJECT-MANAGEMENT-LIMITED/companies-house-data"},{"from":63,"to":64,"type":"director","description":"BONHAM was employed from 1980 through 1996 as a director OF BONHAM REYNOLDS PROJECT MANAGEMENT, a business & management consultancy.","page":9,"reference":"https://companycheck.co.uk/company/02516288/BONHAM-REYNOLDS-PROJECT-MANAGEMENT-LIMITED/companies-house-data"},{"from":64,"to":65,"type":"director","description":"BONHAM was employed from 1980 through 1996 as a director OF BONHAM REYNOLDS PROJECT MANAGEMENT, a business & management consultancy that also included KEITH WILLIAM REYNOLDS ads a director. REYNOLDS is known to have had at least 10 UK corporate a liations including as a director in 1992 of HAMDI BONHAM REYNOLDS (INTERNATIONAL) LIMITED, an engineering company with one address in Sharjah, UAE.","page":9,"reference":"https://companycheck.co.uk/company/02516288/BONHAM-REYNOLDS-PROJECT-MANAGEMENT-LIMITED/companies-house-data"},{"from":8,"to":58,"type":"signatory","description":"The project had its origins in a July 2006 application to the local planning department for the BOTHAM STREET MOSQUE AND ISLAMIC CENTRE, signed on behalf of CATALYST REGENERATION by AKRAM BONHAM (MCIAT), head of the Building Design Department.","page":7,"reference":"https://planningapps.sheffield.gov.uk/online-applications/files/19B9DC3771EA97BBD135161F5C6D87D8/pdf/06_03268_FUL-CORRESPONDENCE-148556.pdf"},{"from":1,"to":66,"type":"chairman","description":"The London office of QCUK was formally opened in June 2014 by a QATAR CHARITY (QC) delegation headed by QC Chairman H E SHEIKH HAMAD BIN NASSER AL THANI and QC CEO YUSUF BIN AHMED AL KUWARI.","page":17,"reference":"http://thepeninsulaqatar.com/news/qa- tar/286763/qatar-charity-opens-uk-office"},{"from":1,"to":67,"type":"CEO","description":"The London office of QCUK was formally opened in June 2014 by a QATAR CHARITY (QC) delegation headed by QC Chairman H E SHEIKH HAMAD BIN NASSER AL THANI and QC CEO YUSUF BIN AHMED AL KUWARI.","page":17,"reference":"http://thepeninsulaqatar.com/news/qa- tar/286763/qatar-charity-opens-uk-office"},{"from":1,"to":68,"type":"director","description":"SALAH AHMED AL-HAMMADI - Qatari national who is also reported to be the Vice-President of QCUK and responsible for projects in Europe.","page":22,"reference":"https://beta.companieshouse.gov.uk/compa- ny/08006947/ ling-history/MzEyMzIzMzMxN- 2FkaXF6a2N4/document?format=pdf&download=0","reference2":"http://bergamo.corriere. it/notizie/cronaca/16_marzo_04/qatar-rivuole-suo- denaro-la-moschea-valuteremo-futuro-8e14af6c- e20e-11e5-b31b-034bb632a08d.shtml"},{"from":67,"to":69,"type":"head","description":"YOUSUF AHMAD AL-KUWARI - Qatari National who is QATAR CHARITY’s CEO; previously Head of Information Technology for the QATAR MINISTRY OF ENDOWMENTS AND ISLAMIC AFFAIRS.","page":3},{"from":1,"to":70,"type":"director","description":"AYYOUB ABOULIAQIN - (national and QCUK Director General; member of the Conseil D'administration of the ASSOCIATION DES MUSULMANS D'ALSACE (AMAL), affiliated with the MUSLIM BROTHERHOOD in France.","page":3},{"from":70,"to":71,"type":"member","description":"AYYOUB ABOULIAQIN - (national and QCUK Director General; member of the Conseil D'administration of the ASSOCIATION DES MUSULMANS D'ALSACE (AMAL), affiliated with the MUSLIM BROTHERHOOD in France.","page":3},{"from":1,"to":72,"type":"director","description":"HAFEZ AHMAD AHMAD (born on 21 April 1961) is a British national resident in England who was appointed as a QCUK Director on 14 January 2013 and who resigned on 4 February 2016. He listed his Occupation as “Director” and used a QCUK address as his correspondence address. dk) 165)","page":32,"reference":"https://beta.companieshouse.gov.uk/company/08006947/officers"},{"from":73,"to":26,"type":"a part of","description":"HAFEZ AL-KARMI, best known as a leader in the PALESTINIAN FORUM IN BRITAIN (PFB), a part of the UK MUSLIM BROTHERHOOD and HAMAS support infrastructure.","page":4},{"from":148,"to":66,"type":"connection","description":"The London office of QCUK was formally opened in June 2014 by a QATAR CHARITY (QC) delegation headed by QC Chairman H E SHEIKH HAMAD BIN NASSER AL THANI and QC CEO YUSUF BIN AHMED AL KUWARI.","page":3},{"from":148,"to":67,"type":"connection","description":"The London office of QCUK was formally opened in June 2014 by a QATAR CHARITY (QC) delegation headed by QC Chairman H E SHEIKH HAMAD BIN NASSER AL THANI and QC CEO YUSUF BIN AHMED AL KUWARI.","page":3},{"from":1,"to":66,"type":"opened","description":"The London office of QCUK was formally opened in June 2014 by a QATAR CHARITY (QC) delegation headed by QC Chairman H E SHEIKH HAMAD BIN NASSER AL THANI and QC CEO YUSUF BIN AHMED AL KUWARI.","page":3},{"from":1,"to":67,"type":"opened","description":"The London office of QCUK was formally opened in June 2014 by a QATAR CHARITY (QC) delegation headed by QC Chairman H E SHEIKH HAMAD BIN NASSER AL THANI and QC CEO YUSUF BIN AHMED AL KUWARI.","page":3},{"from":67,"to":148,"type":"CEO","description":"YOUSUF AHMAD AL-KUWARI- Qatari National who is QATAR CHARITY’s CEO; previously Head of Information Technology for the QATAR MINISTRY OF ENDOWMENTS AND ISLAMIC AFFAIRS.","page":3},{"from":67,"to":69,"type":"previously-head-of-it","description":"YOUSUF AHMAD AL-KUWARI- Qatari National who is QATAR CHARITY’s CEO; previously Head of Information Technology for the QATAR MINISTRY OF ENDOWMENTS AND ISLAMIC AFFAIRS.","page":3},{"from":71,"to":149,"type":"connection","description":"AYYOUB ABOULIAQIN - national and QCUK Director General; member of the Conseil D'administration of the ASSOCIATION DES MUSULMANS D'ALSACE (AMAL), affiliated with the MUSLIM BROTHERHOOD in France.","page":3},{"from":72,"to":73,"type":"leader","description":"HAFEZ AL-KARMI, best known as a leader in the PALESTINIAN FORUM IN BRITAIN (PFB), a part of the UK MUSLIM BROTHERHOOD and HAMAS support infrastructure.","page":4},{"from":73,"to":74,"type":"a part of","description":"HAFEZ AL-KARMI, best known as a leader in the PALESTINIAN FORUM IN BRITAIN (PFB), a part of the UK MUSLIM BROTHERHOOD and HAMAS support infrastructure.","page":4},{"from":75,"to":26,"type":"connection","description":"The MIC has received £2,872,267 from the State of Qatar. In turn, it has distributed an estimated £874,768 to various charities and organizations ranging from £1,500-£38,855 to numerous groups all known to be tied to the Muslim Brotherhood in the UK.","page":4},{"from":72,"to":19,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":73,"to":19,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":75,"to":19,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":72,"to":80,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":73,"to":80,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":75,"to":80,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":72,"to":81,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":73,"to":81,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":75,"to":81,"type":"connection","description":"In addition to the PFB and the MIC, HAFEZ AL-KARMI has or has had additional ties to the following organizations tied to the MUSLIM BROTHERHOOD and/or HAMAS: the MUSLIM WELFARE HOUSE, FINSBURY MOSQUE; PALESTINE SCHOLARS' ASSOCIATION IN DIASPORA","page":4},{"from":7,"to":6,"type":"connection","description":"This Sheffield, UK mosque complex (THE EMAAN TRUST), near completion or already completed, is the latest in a series of attempts by\n the EUROPE TRUST to covertly build large Islamic facilities in European cities controlled by the MUSLIM BROTHERHOOD.","page":1},{"from":6,"to":48,"type":"connection","description":"This Sheffield, UK mosque complex (THE EMAAN TRUST), near completion or already completed, is the latest in a series of attempts by\n the EUROPE TRUST to covertly build large Islamic facilities in European cities controlled by the MUSLIM BROTHERHOOD.","page":1},{"from":75,"to":76,"type":"donation","description":"The KASSIM BIN MOHAMMED AL-THANI MAYFAIR ISLAMIC CENTRE (MIC) receives significant donations each year from the MINISTRY OF AWKAF AND ISLAMIC AFFAIRS in Qatar and since 2011.","page":4},{"from":75,"to":40,"type":"funding","description":"The MIC receives significant donations each year from the MINISTRY OF AWKAF AND ISLAMIC AFFAIRS in Qatar and since 2011, the MIC has received £2,872,267 from the State of Qatar.","page":4},{"from":72,"to":75,"type":"manager","description":"HAFEZ AHMAD AHMAD is also the Charity manager for the KASSIM BIN MOHAMMED AL-THANI MAYFAIR ISLAMIC CENTRE (MIC), named for the founder of Qatar and formerly known as the QATAR ISLAMIC CENTRE.","page":4},{"from":58,"to":54,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":54,"to":56,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":54,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":54,"to":46,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":54,"to":57,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation:\n - ADNAN SAIF (BRITISH MUSLIM HERITAGE CENTRE, MUATH TRUST, ISLAMIC RELIEF)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":84,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - ZAHID PARVEZ (MARKFIELD INSTITUTE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":84,"to":96,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - ZAHID PARVEZ (MARKFIELD INSTITUTE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":84,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - ZAHID PARVEZ (MARKFIELD INSTITUTE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":85,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - JACOB VAN DER BLOM (EUROPE TRUST NETHERLANDS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":85,"to":97,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - JACOB VAN DER BLOM (EUROPE TRUST NETHERLANDS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":85,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - JACOB VAN DER BLOM (EUROPE TRUST NETHERLANDS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":86,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - MOHAMMED SAIF (QATAR FOUNDATION)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":86,"to":98,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - MOHAMMED SAIF (QATAR FOUNDATION)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":86,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - MOHAMMED SAIF (QATAR FOUNDATION)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":86,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY EL BANNA (ISLAMIC RELIEF, MUSLIM CHARITIES FORUM","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":86,"to":98,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY EL BANNA (ISLAMIC RELIEF, MUSLIM CHARITIES FORUM","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":87,"to":99,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY EL BANNA (ISLAMIC RELIEF, MUSLIM CHARITIES FORUM","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":87,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY EL BANNA (ISLAMIC RELIEF, MUSLIM CHARITIES FORUM","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":17,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - OMER EL-HAMDOON (MUSLIM ASSOCIATION OF BRITAIN)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":17,"to":101,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - OMER EL-HAMDOON (MUSLIM ASSOCIATION OF BRITAIN)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":17,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - OMER EL-HAMDOON (MUSLIM ASSOCIATION OF BRITAIN)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":89,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n -HUSSEIN NAGI (HUMAN APPEAL INTERNATIONAL)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":89,"to":43,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n -HUSSEIN NAGI (HUMAN APPEAL INTERNATIONAL)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":89,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n -HUSSEIN NAGI (HUMAN APPEAL INTERNATIONAL)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":90,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - GEHAD EL-HADDAD (EGYPTIAN MUSLIM BROTHERHOOD)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":90,"to":55,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - GEHAD EL-HADDAD (EGYPTIAN MUSLIM BROTHERHOOD)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":91,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - CHAKIB BENMAKHLOUF (FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":91,"to":3,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - CHAKIB BENMAKHLOUF (FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":91,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - CHAKIB BENMAKHLOUF (FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":92,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - MOHAMMED KOZBAR (MUSLIM ASSOCIATION OF BRITAIN, FINSBURY MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":92,"to":18,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - MOHAMMED KOZBAR (MUSLIM ASSOCIATION OF BRITAIN, FINSBURY MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":92,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - MOHAMMED KOZBAR (MUSLIM ASSOCIATION OF BRITAIN, FINSBURY MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":92,"to":80,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - MOHAMMED KOZBAR (MUSLIM ASSOCIATION OF BRITAIN, FINSBURY MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":93,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - TOUFIK KACIMI (MUSLIM WELFARE HOUSE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":93,"to":83,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - TOUFIK KACIMI (MUSLIM WELFARE HOUSE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":94,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - BASHIR OSMAN (FOSIS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":94,"to":102,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - BASHIR OSMAN (FOSIS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":94,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - BASHIR OSMAN (FOSIS)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":24,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HASSAN ALKATIB (LEEDS GRAND MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":24,"to":25,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HASSAN ALKATIB (LEEDS GRAND MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":25,"to":48,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HASSAN ALKATIB (LEEDS GRAND MOSQUE)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":58,"to":53,"type":"facebook","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY ELDEEB (Muslim Welfare House, FIOE, NEMA, Egyptian Muslim Brotherhood)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":53,"to":83,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY ELDEEB (Muslim Welfare House, FIOE, NEMA, Egyptian Muslim Brotherhood)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":53,"to":3,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY ELDEEB (Muslim Welfare House, FIOE, NEMA, Egyptian Muslim Brotherhood)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":53,"to":45,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY ELDEEB (Muslim Welfare House, FIOE, NEMA, Egyptian Muslim Brotherhood)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":53,"to":55,"type":"connection","description":"AKRAM BONHAM is facebook friends with the following individuals all known to be connected to the Global Muslim Brotherhood, some of whom were identified in this investigation: \n - HANY ELDEEB (Muslim Welfare House, FIOE, NEMA, Egyptian Muslim Brotherhood)","page":9,"reference":"https://www.facebook.com/akram.bonham/friends?pnref=lhc"},{"from":103,"to":107,"type":"chairman","description":"KHALID AL-MATHKOOR Chairman of the SHEIKH ABDULLAH AL-NOURI CHARITY SOCIETY, a Kuwait charity that is described by ISLAMIC RELIEF WORLDWIDE as a close partner.","page":9,"reference":"https://www.kuna.net.kw/ArticlePrintPage.aspx?id=2068125&language=en"},{"from":107,"to":57,"type":"partner","description":"KHALID AL-MATHKOOR Chairman of the SHEIKH ABDULLAH AL-NOURI CHARITY SOCIETY, a Kuwait charity that is described by ISLAMIC RELIEF WORLDWIDE as a close partner.","page":9,"reference":"http://www.islamic-relief.org/event-held-to-mark-30th-anniversary/"},{"from":108,"to":48,"type":"connection","description":"KHALID AL-MATHKOOR Member of the General Assembly of the INTERNATIONAL ISLAMIC CHARITY ORGANIZATION (IICO), strongly tied to the Global MUSLIM BROTHERHOOD.","page":9,"reference":"https://www.globalmbwatch.com/international-islamic-charitable-organization/"},{"from":103,"to":109,"type":"member","description":"KHALID AL-MATHKOOR Member of the SOCIAL REPORT SOCIETY, the charitable arm of the MUSLIM BROTHERHOOD in Kuwait.","page":9,"reference":"http://news.kuwaittimes.net/pdf/2014/mar/20/kt.pdf"},{"from":109,"to":110,"type":"connection","description":"KHALID AL-MATHKOOR Member of the SOCIAL REPORT SOCIETY, the charitable arm of the MUSLIM BROTHERHOOD in Kuwait.","page":9,"reference":"http://news.kuwaittimes.net/pdf/2014/mar/20/kt.pdf"},{"from":103,"to":111,"type":"member","description":"KHALID AL-MATHKOOR Member of the Fatwa and Shari’a Supervisory Board for a number of companies and Islamic financial institutions.","page":9,"reference":"http://cdm16639.contentdm.oclc.org/cdm/ref/collection/p16639coll5/id/52"},{"from":103,"to":48,"type":"connection","description":"AL-MATHKOOR has been described as a “religious conservative” and he has made remarks strongly defending the MUSLIM BROTHERHOOD.","page":9,"reference":"http://www.southcoasttoday.com/article/20011130/News/311309968"},{"from":112,"to":41,"type":"offical","description":"MUTLAQ AL-QARAWI is a 64-year-old Kuwaiti national resident in Kuwait is best known as an official of the MINISTRY OF AWQAF & ISLAMIC AFFAIRS in Kuwait where he has been referred to variously as Assistant Undersecretary, director of the media Department, Assistant Undersecretary for Technical A airs and Foreign Affairs, Assistant Undersecretary.","page":10,"reference":"http://cms.islam.gov.kw/Pages/en/NewsDetails.aspx?newsId=138"},{"from":112,"to":113,"type":"active-member","description":"MUTLAQ AL-QARAWI In his role at the Ministry, AL-QARAWI was active in the Kuwaiti WORLD MODERATION CENTER (aka INTERNATIONAL MODERATION CENTRE IMC), headed by ESSAM AL-BASHIR of Sudan, a gure closely tied to the GLOBAL MUSLIM BROTHERHOOD.","page":10,"reference":"https://wikileaks.org/plusd/cables/06KUWAIT4610_a.html#_jmp0_"},{"from":113,"to":114,"type":"head-of","description":"MUTLAQ AL-QARAWI In his role at the Ministry, AL-QARAWI was active in the Kuwaiti WORLD MODERATION CENTER (aka INTERNATIONAL MODERATION CENTRE IMC), headed by ESSAM AL-BASHIR of Sudan, a gure closely tied to the GLOBAL MUSLIM BROTHERHOOD.","page":10,"reference":"https://wikileaks.org/plusd/cables/06KUWAIT4610_a.html#_jmp0_"},{"from":114,"to":48,"type":"tied-to","description":"MUTLAQ AL-QARAWI In his role at the Ministry, AL-QARAWI was active in the Kuwaiti WORLD MODERATION CENTER (aka INTERNATIONAL MODERATION CENTRE IMC), headed by ESSAM AL-BASHIR of Sudan, a gure closely tied to the GLOBAL MUSLIM BROTHERHOOD.","page":10,"reference":"https://wikileaks.org/plusd/cables/06KUWAIT4610_a.html#_jmp0_"},{"from":112,"to":115,"type":"connection","description":"MUTLAQ AL-QARAWI has attracted substantial media attention in the Netherlands in connection with his role in the BLAUWE MOSKEE IN SLOTERVAART (Blue Mosque in Slotervaart), a mosque and cultural center in Amsterdam that was initially funded by the EUROPE TRUST, headed by AHMED AL-RAWI with whom AL-QARAWI has had a long-standing relationship.","page":10,"reference":"http://www.carelbrendel.nl/2012/11/12/topman-europese-moslimbroederschap-stond-aan-wieg-van-blauwe-moskee-in-slotervaart/"},{"from":115,"to":6,"type":"funding","description":"MUTLAQ AL-QARAWI has attracted substantial media attention in the Netherlands in connection with his role in the BLAUWE MOSKEE IN SLOTERVAART (Blue Mosque in Slotervaart), a mosque and cultural center in Amsterdam that was initially funded by the EUROPE TRUST, headed by AHMED AL-RAWI with whom AL-QARAWI has had a long-standing relationship.","page":10,"reference":"http://www.carelbrendel.nl/2012/11/12/topman-europese-moslimbroederschap-stond-aan-wieg-van-blauwe-moskee-in-slotervaart/"},{"from":6,"to":32,"type":"headed-by","description":"MUTLAQ AL-QARAWI has attracted substantial media attention in the Netherlands in connection with his role in the BLAUWE MOSKEE IN SLOTERVAART (Blue Mosque in Slotervaart), a mosque and cultural center in Amsterdam that was initially funded by the EUROPE TRUST, headed by AHMED AL-RAWI with whom AL-QARAWI has had a long-standing relationship.","page":10,"reference":"http://www.carelbrendel.nl/2012/11/12/topman-europese-moslimbroederschap-stond-aan-wieg-van-blauwe-moskee-in-slotervaart/"},{"from":32,"to":112,"type":"relationship","description":"MUTLAQ AL-QARAWI has attracted substantial media attention in the Netherlands in connection with his role in the BLAUWE MOSKEE IN SLOTERVAART (Blue Mosque in Slotervaart), a mosque and cultural center in Amsterdam that was initially funded by the EUROPE TRUST, headed by AHMED AL-RAWI with whom AL-QARAWI has had a long-standing relationship.","page":10},{"from":108,"to":112,"type":"member","description":"MUTLAQ AL-QARAWI and AHMED AL-RAWI: Both individuals are members of the General Assembly of the Kuwait based INTERNATIONAL ISLAMIC CHARITY ORGANIZATION (IICO), strongly tied to the Global MUSLIM BROTHERHOOD","page":10,"reference":"https://www.iico.org/InnerPageContent_en.aspx"},{"from":32,"to":112,"type":"member","description":"MUTLAQ AL-QARAWI and AHMED AL-RAWI: Both individuals are members of the General Assembly of the Kuwait based INTERNATIONAL ISLAMIC CHARITY ORGANIZATION (IICO), strongly tied to the Global MUSLIM BROTHERHOOD","page":10,"reference":"https://www.iico.org/InnerPageContent_en.aspx"},{"from":108,"to":48,"type":"tied-to","description":"MUTLAQ AL-QARAWI and AHMED AL-RAWI: Both individuals are members of the General Assembly of the Kuwait based INTERNATIONAL ISLAMIC CHARITY ORGANIZATION (IICO), strongly tied to the Global MUSLIM BROTHERHOOD","page":10,"reference":"https://www.globalmbwatch.com/international-islamic-charitable-organization/"},{"from":112,"to":3,"type":"connection","description":"MUTLAQ AL-QARAWI In addition to the relationship between MUTLAQ AL-QARAWI and AHMED AL-RAWI, there is also a long-standing relationship between FIOE, AL-QARAWI and JACOB VAN DER BLOM, a leader of the BLAUWE MOSKEE and a trustee of the NATIVE EUROPEAN MUSLIM ASSEMBLY (NEMA), a part of the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and centered on European coverts to Islam.","page":10,"reference":"http://www.nema.eu.com/article.php?id=1"},{"from":112,"to":85,"type":"connection","description":"MUTLAQ AL-QARAWI In addition to the relationship between MUTLAQ AL-QARAWI and AHMED AL-RAWI, there is also a long-standing relationship between FIOE, AL-QARAWI and JACOB VAN DER BLOM, a leader of the BLAUWE MOSKEE and a trustee of the NATIVE EUROPEAN MUSLIM ASSEMBLY (NEMA), a part of the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and centered on European coverts to Islam.","page":10,"reference":"http://www.carelbrendel.nl/2014/12/03/raar-nieuwsuur-zoektocht-naar-gewone-moslims-eindigt-bij-moslimbroeders/"},{"from":85,"to":115,"type":"leader","description":"MUTLAQ AL-QARAWI In addition to the relationship between MUTLAQ AL-QARAWI and AHMED AL-RAWI, there is also a long-standing relationship between FIOE, AL-QARAWI and JACOB VAN DER BLOM, a leader of the BLAUWE MOSKEE and a trustee of the NATIVE EUROPEAN MUSLIM ASSEMBLY (NEMA), a part of the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and centered on European coverts to Islam.","page":10,"reference":"http://www.carelbrendel.nl/2014/12/03/raar-nieuwsuur-zoektocht-naar-gewone-moslims-eindigt-bij-moslimbroeders/"},{"from":85,"to":45,"type":"trustees","description":"MUTLAQ AL-QARAWI In addition to the relationship between MUTLAQ AL-QARAWI and AHMED AL-RAWI, there is also a long-standing relationship between FIOE, AL-QARAWI and JACOB VAN DER BLOM, a leader of the BLAUWE MOSKEE and a trustee of the NATIVE EUROPEAN MUSLIM ASSEMBLY (NEMA), a part of the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and centered on European coverts to Islam.","page":10,"reference":"http://www.carelbrendel.nl/2014/12/03/raar-nieuwsuur-zoektocht-naar-gewone-moslims-eindigt-bij-moslimbroeders/"},{"from":45,"to":3,"type":"a-part-of","description":"MUTLAQ AL-QARAWI In addition to the relationship between MUTLAQ AL-QARAWI and AHMED AL-RAWI, there is also a long-standing relationship between FIOE, AL-QARAWI and JACOB VAN DER BLOM, a leader of the BLAUWE MOSKEE and a trustee of the NATIVE EUROPEAN MUSLIM ASSEMBLY (NEMA), a part of the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and centered on European coverts to Islam.","page":10,"reference":"http://www.carelbrendel.nl/2014/12/03/raar-nieuwsuur-zoektocht-naar-gewone-moslims-eindigt-bij-moslimbroeders/"},{"from":112,"to":116,"type":"attended-forum","description":"MUTLAQ AL-QARAWI On 29 March 2013, MUTLAQ AL-QARAWI was part of a Kuwaiti delegation that attended an education forum of the ISLAMIC SOCIETY OF NORTH AMERICA (ISNA) in Rosemont, Illinois. ISNA is a large Islamic umbrella group central to the MUSLIM BROTHERHOOD in the US.","page":10,"reference":"http://muslimobserver.com/another-successful-education-forum/"},{"from":116,"to":117,"type":"tied-to","description":"MUTLAQ AL-QARAWI On 29 March 2013, MUTLAQ AL-QARAWI was part of a Kuwaiti delegation that attended an education forum of the ISLAMIC SOCIETY OF NORTH AMERICA (ISNA) in Rosemont, Illinois. ISNA is a large Islamic umbrella group central to the MUSLIM BROTHERHOOD in the US.","page":10,"reference":"http://www.globalmbwatch.com/islamic-society-of-north-america/"},{"from":30,"to":118,"type":"president","description":"ABDULRAZAQ BUQARA From February 2013 – February 2014, he was also the President of the NASUWT ( the teachers’ Union).","page":12},{"from":30,"to":18,"type":"past-chairman","description":"ABDULRAZAQ BUQARA BOUGARA is also a past chairman of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and a current director of the M A B CHARITABLE TRUST.","page":12,"reference":"https://www.thestar.co.uk/whats-on/out-and-about/church-leaders-unite-in-a-show-of-faith-against-extremism-1-240789"},{"from":30,"to":119,"type":"director","description":"ABDULRAZAQ BUQARA BOUGARA is also a past chairman of the MUSLIM ASSOCIATION OF BRITAIN (MAB) and a current director of the M A B CHARITABLE TRUST.","page":12,"reference":"http://www.therevival.co.uk/forum/general/5149"},{"from":30,"to":152,"type":"trustees","description":"ABDULRAZAQ BUQARA He is also a trustee of the MUSLIMAAT SHEFFIELD ASSOCIATION OF MUSLIM WOMEN AND GIRLS, discussed above in connection with HAMEED ASALY and likely tied to the MAB and an Executive Committee Member of the MUSLIM WELFARE HOUSE in Sheffield also close to the MAB.","page":12,"reference":"https://beta.companieshouse.gov.uk/company/08043568"},{"from":30,"to":14,"type":"connection","description":"ABDULRAZAQ BUQARA He is also a trustee of the MUSLIMAAT SHEFFIELD ASSOCIATION OF MUSLIM WOMEN AND GIRLS, discussed above in connection with HAMEED ASALY and likely tied to the MAB and an Executive Committee Member of the MUSLIM WELFARE HOUSE in Sheffield also close to the MAB.","page":12,"reference":"http://opencharities.org/charities/1052325"},{"from":30,"to":83,"type":"member","description":"ABDULRAZAQ BUQARA He is also a trustee of the MUSLIMAAT SHEFFIELD ASSOCIATION OF MUSLIM WOMEN AND GIRLS, discussed above in connection with HAMEED ASALY and likely tied to the MAB and an Executive Committee Member of the MUSLIM WELFARE HOUSE in Sheffield also close to the MAB.","page":12,"reference":"https://www.globalmbwatch.com/muslim-association-of-britain/"},{"from":30,"to":120,"type":"fb-sympol","description":"ABDULRAZAQ BUQARA A photo on his facebook page displays the RABIA4 symbol, associated with support for the MUSLIM BROTHERHOOD.","page":12,"reference":"https://www.facebook.com/abderrezak.bougara"},{"from":120,"to":48,"type":"connection","description":"ABDULRAZAQ BUQARA A photo on his facebook page displays the RABIA4 symbol, associated with support for the MUSLIM BROTHERHOOD.","page":12,"reference":"https://www.facebook.com/abderrezak.bougara/photos_all"},{"from":121,"to":18,"type":"vice-president","description":"AMINA BLAKE has numerous affiliations to groups associated with the UK and global MUSLIM BROTHERHOOD, including: Vice-President of the MUSLIM ASSOCIATION OF BRITAIN (MAB)","page":12},{"from":121,"to":122,"type":"official","description":"AMINA BLAKE has numerous affiliations to groups associated with the UK and global MUSLIM BROTHERHOOD, including: Official of the MUSLIM COUNCIL OF BRITAIN (MCB)","page":12,"reference":"http://www.mcb.org.uk/muslim-council-of-britain-elects-new-leadership-and-discusses-british-values/"},{"from":121,"to":45,"type":"tied-to","description":"AMINA BLAKE has numerous affiliations to groups associated with the UK and global MUSLIM BROTHERHOOD, including: Associated with the NATIVE EUROPEAN MUSLIM ASSEMBLY (NEMA)","page":12,"reference":"https://www.globalmbwatch.com/muslim-council-of-britain/"},{"from":121,"to":123,"type":"trustees","description":"AMINA BLAKE has numerous affiliations to groups associated with the UK and global MUSLIM BROTHERHOOD, including: Trustee of TIES (charity whose trustees are officials of the MUSLIM WELFARE HOUSE and WAMY)","page":12,"reference":"http://apps.charitycommission.gov.uk/Showcharity/RegisterOfCharities/ContactAndTrustees.aspx?RegisteredCharityNumber=1168269&SubsidiaryNumber=0&TID=11580159"},{"from":121,"to":152,"type":"trustees","description":"AMINA BLAKE has numerous affiliations to groups associated with the UK and global MUSLIM BROTHERHOOD, including: Trustee of the MUSLIMAAT SHEFFIELD ASSOCIATION OF MUSLIM WOMEN AND GIRLS","page":12,"reference":"http://opencharities.org/charities/1052325"},{"from":121,"to":124,"type":"director","description":"Other relevant affiliations for AMENNA BLAKE include: Director of EDEN HOUSES, as female only, part time staffed supported accommodation for ladies (and their children) and whose head o ce is at the MUSLIM WELFARE HOUSE in London.","page":12,"reference":"http://www.ukim.org/webpages/detailnews.aspx?id=38990fd1-1b7b-4cf0-8bbc-d57734a52119"},{"from":124,"to":83,"type":"using-same-address","description":"Other relevant affiliations for AMENNA BLAKE include: Director of EDEN HOUSES, as female only, part time staffed supported accommodation for ladies (and their children) and whose head office is at the MUSLIM WELFARE HOUSE in London.","page":12,"reference":"http://www.edenhousesuk.com/"},{"from":121,"to":125,"type":"connection","description":"AMINA BLAKE She has spoken at a variety of mosques in the UK and in 2016 spoke at at the STOCKHOLM MOSQUE, likely the same mosque that is associated with the MUSLIM BROTHERHOOD in Sweden.","page":12,"reference":"http://tofo.me/stockholmsungamuslimer"},{"from":125,"to":126,"type":"associated-with","description":"AMINA BLAKE She has spoken at a variety of mosques in the UK and in 2016 spoke at at the STOCKHOLM MOSQUE, likely the same mosque that is associated with the MUSLIM BROTHERHOOD in Sweden.","page":12,"reference":"https://www.globalmbwatch.com/2010/12/13/exclusive-top-swedish-imam-condems-stockholm-car-bombing-accused-of-incendiary-speeches-in-arabic/"},{"from":121,"to":127,"type":"connection","description":"AMINA BLAKE She was scheduled to speak at a mosque in Kuwait in a talk sponsored by the GRAND MOSQUE in association with the MINISTRY OF WAQF and in November 2014 was in Kuwait giving lectures.","page":12,"reference":"http://kuwaitsblog.com/wp-content/uploads/2016/03/12901129_10153338341541831_2266946150817633586_o.jpg"},{"from":127,"to":41,"type":"associated-with","description":"AMINA BLAKE She was scheduled to speak at a mosque in Kuwait in a talk sponsored by the GRAND MOSQUE in association with the MINISTRY OF WAQF and in November 2014 was in Kuwait giving lectures.","page":12,"reference":"http://kuwaitsblog.com/wp-content/uploads/2016/03/12901129_10153338341541831_2266946150817633586_o.jpg"},{"from":121,"to":129,"type":"work-for","description":"AMINA BLAKE In October 2014 she was at an Eid Reception of then deputy prime minister NICK CLEGG.","page":12,"reference":"https://www.facebook.com/photo.php?fbid=10152795520488599&set=a.10151144274258599.465861.642163598&type=3&theater"},{"from":121,"to":53,"type":"facebook","description":"AMEENA BLAKE Her friends of interest include: HANY ELDEEB","page":12,"reference":"https://www.facebook.com/ameenablake/friends?lst=100013461930362%3A642163598%3A1517234754&source_ref=pb_friends_tl"},{"from":121,"to":94,"type":"facebook","description":"AMEENA BLAKE Her friends of interest include: BASHIR OSMAN (the last year drowned chairman of FOSIS)","page":12,"reference":"https://www.facebook.com/ameenablake/friends?lst=100013461930362%3A642163598%3A1517234754&source_ref=pb_friends_tl"},{"from":121,"to":130,"type":"facebook","description":"AMEENA BLAKE Her friends of interest include: TALAT AHMED – HR advisor Islamic Relief UK","page":14,"reference":"https://www.facebook.com/ameenablake/friends?lst=100013461930362%3A642163598%3A1517234754&source_ref=pb_friends_tl"},{"from":130,"to":57,"type":"work-for","description":"AMEENA BLAKE Her friends of interest include: TALAT AHMED – HR advisor Islamic Relief UK","page":14,"reference":"https://www.facebook.com/ameenablake/friends?lst=100013461930362%3A642163598%3A1517234754&source_ref=pb_friends_tl"},{"from":121,"to":131,"type":"facebook","description":"AMEENA BLAKE Her friends of interest include: ATEEQ SALIK – Manager Islamic Relief UK","page":14,"reference":"https://www.facebook.com/ameenablake/friends?lst=100013461930362%3A642163598%3A1517234754&source_ref=pb_friends_tl"},{"from":131,"to":57,"type":"manager","description":"AMEENA BLAKE Her friends of interest include: ATEEQ SALIK – Manager Islamic Relief UK","page":14,"reference":"https://www.facebook.com/ameenablake/friends?lst=100013461930362%3A642163598%3A1517234754&source_ref=pb_friends_tl"},{"from":121,"to":132,"type":"facebook","description":"AMEENA BLAKE Her friends of interest include: SHEIKH ABOMAZEN – who seems to be connected with the Egyptian MB in the UK","page":14,"reference":"https://www.facebook.com/ameenablake/friends?lst=100013461930362%3A642163598%3A1517234754&source_ref=pb_friends_tl"},{"from":132,"to":55,"type":"connection","description":"AMEENA BLAKE Her friends of interest include: SHEIKH ABOMAZEN – who seems to be connected with the Egyptian MB in the UK","page":14,"reference":"https://www.facebook.com/ameenablake/friends?lst=100013461930362%3A642163598%3A1517234754&source_ref=pb_friends_tl"},{"from":133,"to":41,"type":"work-for","description":"ADEL ABDULLAH AL-FALAH Is 63-year-old Kuwaiti national who has been the Undersecretary of the Kuwait Ministry of Awqaf and Islamic Affairs Since 1991, he has also been the Vice President of the Supreme Committee of Working towards Completing the Implementation of the Islamic Shariah of the Amiri Diwan.","page":14,"reference":"http://www.iicowric.org/en/pdf/Dr.%20Adel%20Abdullah%20Al-Falah.pdf"},{"from":133,"to":104,"type":"vice-president","description":"ADEL ABDULLAH AL-FALAH He has also been the Vice President of the Supreme Committee of Working towards Completing the Implementation of the Islamic Shariah of the Amiri Diwan.","page":14,"reference":"http://www.iicowric.org/en/pdf/Dr.%20Adel%20Abdullah%20Al-Falah.pdf"},{"from":133,"to":48,"type":"connection","description":"ADEL ABDULLAH AL-FALAH An Arab Times Kuwait report from 27 August 2014 said that the Deputy Prime Minister was not expected to renew the position of ADEL AL- FALAH at the Ministry of Awqaf and appeared to link him TO MUSLIM BROTHERHOOD activity in the country. It could not be con rmed whether or not AL-FALAH is currently employed by the Ministry.","page":14,"reference":"https://www.zawya.com/mena/en/story/News_of_DAESH_entering_Kuwait_incorrect_-ZAWYA20140828050416/"},{"from":133,"to":108,"type":"member","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: He is a member of the General Assembly of the INTERNATIONAL ISLAMIC CHARITY ORGANIZATION (IICO)","page":14,"reference":"https://www.iico.org/InnerPageContent_en.aspx"},{"from":133,"to":128,"type":"connection","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: Attended multiple meetings of the INTERNATIONAL ISLAMIC COUNCIL FOR DA’WAH AND RELIEF (IICDR) , a Cairo- umbrella group for 86 Islamic organizations, many of which are associated with the global Muslim Brotherhood, Hamas fundraising, or nancial/material support of Al Qaeda.","page":14,"reference":"https://www.globalmbwatch.com/international-islamic-council-for-dawa-and-relief/"},{"from":128,"to":48,"type":"connection","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: Attended multiple meetings of the INTERNATIONAL ISLAMIC COUNCIL FOR DA’WAH AND RELIEF (IICDR) , a Cairo- umbrella group for 86 Islamic organizations, many of which are associated with the global Muslim Brotherhood, Hamas fundraising, or nancial/material support of Al Qaeda.","page":14,"reference":"https://www.globalmbwatch.com/international-islamic-council-for-dawa-and-relief/"},{"from":128,"to":74,"type":"connection","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: Attended multiple meetings of the INTERNATIONAL ISLAMIC COUNCIL FOR DA’WAH AND RELIEF (IICDR) , a Cairo- umbrella group for 86 Islamic organizations, many of which are associated with the global Muslim Brotherhood, Hamas fundraising, or nancial/material support of Al Qaeda.","page":14,"reference":"https://www.globalmbwatch.com/international-islamic-council-for-dawa-and-relief/"},{"from":128,"to":134,"type":"connection","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: Attended multiple meetings of the INTERNATIONAL ISLAMIC COUNCIL FOR DA’WAH AND RELIEF (IICDR) , a Cairo- umbrella group for 86 Islamic organizations, many of which are associated with the global Muslim Brotherhood, Hamas fundraising, or nancial/material support of Al Qaeda.","page":14,"reference":"https://www.globalmbwatch.com/international-islamic-council-for-dawa-and-relief/"},{"from":133,"to":56,"type":"trustees","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: Trustee of the BRITISH MUSLIM HERITAGE CENTRE (BMHC), known to be part of the MUSLIM BROTHERHOOD/HAMAS in the UK.","page":14,"reference":"http://opencharities.org/charities/1110104"},{"from":56,"to":26,"type":"a-part-of","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: Trustee of the BRITISH MUSLIM HERITAGE CENTRE (BMHC), known to be part of the MUSLIM BROTHERHOOD/HAMAS in the UK.","page":14,"reference":"http://standforpeace.org.uk/british-muslim-heritage-centre/"},{"from":56,"to":74,"type":"a-part-of","description":"ADEL AL-FALAH Has numerous affiliations of interest and that include: Trustee of the BRITISH MUSLIM HERITAGE CENTRE (BMHC), known to be part of the MUSLIM BROTHERHOOD/HAMAS in the UK.","page":14,"reference":"http://standforpeace.org.uk/british-muslim-heritage-centre/"},{"from":133,"to":135,"type":"connection","description":"ADEL AL-FALAH has also attended numerous conferences and meetings of interest that also included: INTERNATIONAL SUPPORT ORGANIZATION (ISO), headed by Global Muslim Brotherhood leader YOUSSEF QARADAWI.","page":14,"reference":"http://www.da.gov.kw/eng/newsroom/newsDetails.php?id=1965"},{"from":135,"to":48,"type":"headed-by","description":"ADEL AL-FALAH has also attended numerous conferences and meetings of interest that also included: INTERNATIONAL SUPPORT ORGANIZATION (ISO), headed by Global Muslim Brotherhood leader YOUSSEF QARADAWI.","page":14,"reference":"https://www.globalmbwatch.com/2010/04/13/dutch-muslim-brotherhood-to-co-sponsor-conference-with-global-muslim-brotherhood-organization/"},{"from":135,"to":136,"type":"head","description":"ADEL AL-FALAH has also attended numerous conferences and meetings of interest that also included: INTERNATIONAL SUPPORT ORGANIZATION (ISO), headed by Global Muslim Brotherhood leader YOUSSEF QARADAWI.","page":14,"reference":"https://www.globalmbwatch.com/2010/04/13/dutch-muslim-brotherhood-to-co-sponsor-conference-with-global-muslim-brotherhood-organization/"},{"from":137,"to":1,"type":"connection","description":"At the QCUK opening KHALID BIN RASHID AL MANSOURI Qatari Ambassador, a high-level delegation from the Qatari embassy was also present.","page":17,"reference":"https://qcharity.org.uk/"},{"from":138,"to":1,"type":"director","description":"Also at the opening was SALMAN GALADARI the Managing Director of the new office of QCUK.","page":17,"reference":" http://thepeninsulaqatar.com/news/qatar/286763/qatar-charity-opens-uk-office"},{"from":1,"to":146,"type":"director","description":"QCUK: On 10 April 2015 two new directors were appointed: \n MOHAMMED SAADON AL-KUWARI, Qatari, director","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/aPr6PQEtne8uJVKA099vHWfcgkdmY3Lj5WTWqpsy5nY/application-pdf?AWSAccessKeyId=ASIAJD2MA2FP33Y2BULQ&Expires=1511163477&Signature=xQJ0EuzkzcepqmfTlB%2BhYA8%2B6ZM%3D&x-amz-security-token=FQoDYXdzEM3%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDElzkNxwkbvjNDiujCK3AwqQIb3qe%2Ff6TbZHYv3y97n%2FbQR0yocQy1c0HRxBhG0A6J9DTRbM0CSDL%2Bv3m2yCSmCMPtJXRifl8CHOX8UM5hKIqoeODPQqa90pnHb6cv3IJI%2BEPd8lYNTli3V3s5LeKxhv77gLPsC7%2B%2FlNcTBjz4zhuWArdSmKIcJS8%2BxnLxTPw2jG7IfAR%2F%2BBE2Zm69kguii6iFKZpVPpbMCpHGJaR2bU00Do%2BnGNhPzOQcBm00YThV3uBTg2tmY2wO7MWnUFSLcN7zXAKg2WewvGcGl%2B4GGCC%2FUaadcm6oIYsJh%2By4TrAl%2F7f2%2BUZDcObeBdh8JsNbDeht6h5HoszzqkEZvS5ck%2BomqWKh0edg5NKVX1kU4EphpvQ8I2kLZIPKk8P6RkqIOqf1gnt795iGBpXz0Lq0HqwaL4sIXczi7TN5LqnsXbbIyUeWzGPaoDcAlofVt4nxYHRCktjr5AI%2B5913%2Fqu6nDBq%2F2blvRtO3Dlgc6WDXfJwgCTT%2BlnmBJcN9eP2Xrtv9bsosrRdWx9wqqfc67KwW8y5M9ZWaj4%2FgEe33rCnDHrJFbEGl%2BSMNoly%2FxOZOwkS39foFIx4Mo5KrJ0AU%3D"},{"from":1,"to":68,"type":"director","description":"QCUK: On 10 April 2015 two new directors were appointed: \n SALAH AHMED AL-HAMMADI, Qatari, director","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/dTHqGuIGkj_fwmZanp7S0hAHUWaIULWzaxXVybh036M/application-pdf?AWSAccessKeyId=ASIAJNDNV57TVXXVBH7A&Expires=1511163478&Signature=RcrV4cwk9poOjbJv3142SmBRhs4%3D&x-amz-security-token=FQoDYXdzEM7%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDE0Hs%2BWUFBjU5WZB4SK3Ayu8PZ5dO%2Fk2mwdiy0pGtBQScdGuqzd2eo1yC8nKBDzjJse%2FbnrZ5YSZewOOyqRC6MqOq2ZUbe1165rUpb8eCWsp0avkf%2BsBxuXdRByGhtyOhmK%2F%2BlxjCvIm%2FrMS4MwkV3rTg8JhfidKmu3RLQRCqQCUBw5suflaREzYrGjV3Qz6mN6eeyBhqdA%2BEQPjcgcbfUX%2FqKRaFLw2Kp01WX2RQ6FVYoC13Ja9HmqxhFu%2BvCk1hEiuPtUO%2Fb1cYkAXZkO3%2FPf1ujkv0HDlXQjVnMCxGQjFKFKTmAy7nE9JS2ySioC4AQjtv3ztb6nAUWP0MccbSM2hspPuisX48KUY%2Fwlco46AFBUNKba9YoPZNp%2BiKnwv66xr3TjFqDyxf8%2FKE3PVxr%2BDN6Fza11%2Boe%2FdbjtjyYil5dbZF8t5M8MsgalxHuPVWHFBGynMpw17i8DdJhI1w%2BBBtMyTyhk1i%2B9gDRrbPeQkA3zS%2B%2FJYCEPr%2FwJUxbmY112I0V9pZWRjBsLyh3MRSaYEFgHYZrToh4xHcHUjkB4uovHilUcEhyv3ntVtnfV2Oqqb5neo3dxSAyotOa67m5fW8MpSpBso2rrJ0AU%3D"},{"from":156,"to":68,"type":"connection","description":"QCUK: On 10 April 2015 two new directors were appointed: \n MOHAMMED SAADON AL-KUWARI, Qatari, director\n SALAH AHMED AL-HAMMADI, Qatari, director","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/aPr6PQEtne8uJVKA099vHWfcgkdmY3Lj5WTWqpsy5nY/application-pdf?AWSAccessKeyId=ASIAJD2MA2FP33Y2BULQ&Expires=1511163477&Signature=xQJ0EuzkzcepqmfTlB%2BhYA8%2B6ZM%3D&x-amz-security-token=FQoDYXdzEM3%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDElzkNxwkbvjNDiujCK3AwqQIb3qe%2Ff6TbZHYv3y97n%2FbQR0yocQy1c0HRxBhG0A6J9DTRbM0CSDL%2Bv3m2yCSmCMPtJXRifl8CHOX8UM5hKIqoeODPQqa90pnHb6cv3IJI%2BEPd8lYNTli3V3s5LeKxhv77gLPsC7%2B%2FlNcTBjz4zhuWArdSmKIcJS8%2BxnLxTPw2jG7IfAR%2F%2BBE2Zm69kguii6iFKZpVPpbMCpHGJaR2bU00Do%2BnGNhPzOQcBm00YThV3uBTg2tmY2wO7MWnUFSLcN7zXAKg2WewvGcGl%2B4GGCC%2FUaadcm6oIYsJh%2By4TrAl%2F7f2%2BUZDcObeBdh8JsNbDeht6h5HoszzqkEZvS5ck%2BomqWKh0edg5NKVX1kU4EphpvQ8I2kLZIPKk8P6RkqIOqf1gnt795iGBpXz0Lq0HqwaL4sIXczi7TN5LqnsXbbIyUeWzGPaoDcAlofVt4nxYHRCktjr5AI%2B5913%2Fqu6nDBq%2F2blvRtO3Dlgc6WDXfJwgCTT%2BlnmBJcN9eP2Xrtv9bsosrRdWx9wqqfc67KwW8y5M9ZWaj4%2FgEe33rCnDHrJFbEGl%2BSMNoly%2FxOZOwkS39foFIx4Mo5KrJ0AU%3D"},{"from":1,"to":139,"type":"incorporated-by","description":"QATAR CHARITY UK (QCUK) was incorporated on\n 26 March 2012 by an agent identified as SALEH SAEED using an address in West Bromwich UK.","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/jACfFs5p4Yh5C9QvGRzZiHlN3DSHCYwjZvBiQ3nQZaA/application-pdf"},{"from":139,"to":140,"type":"director","description":"According to UK corporate records, SALEH SAEED is also a director of the following company: ZAKAT HOUSE","page":20},{"from":139,"to":141,"type":"director","description":"According to UK corporate records, SALEH SAEED is also a director of the following company: YEMENI COMMUNITY ASSOCIATION IN SANDWELL LIMITED","page":20},{"from":139,"to":142,"type":"director","description":"According to UK corporate records, SALEH SAEED is also a director of the following company: DISASTERS EMERGENCY COMMITTEE","page":20},{"from":87,"to":140,"type":"trustees","description":"The UK Charity Commission currently lists four trustees and one contact person. The best known of these trustees is Dr. HANY ELBANNA who is listed as the Founder and Chair of Trustees on the Zakat House website.","page":21,"reference":"http://apps.charitycommission.gov.uk/Showcharity/RegisterOfCharities/PrintReport.aspx?RegisteredCharityNumber=1130399&ReportType=COLOUR"},{"from":1,"to":140,"type":"using-same-address","description":"As noted above, until December 2013, QCUK used the ZAKAT HOUSE (ZH) as its registered address.","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/-oym-zpczW-9uaqRrl9YLya8d09NBG1XIMIOcGC2Cns/application-pdf"},{"from":103,"to":105,"type":"member","description":"KHALID AL-MATHKOOR Representative member of Kuwait at INTERNATIONAL ISLAMIC FIQH ACADEMY OF THE ORGANIZATION OF ISLAMIC CONFERENCE Jeddah.","page":9},{"from":105,"to":106,"type":"connection","description":"KHALID AL-MATHKOOR Representative member of Kuwait at INTERNATIONAL ISLAMIC FIQH ACADEMY OF THE ORGANIZATION OF ISLAMIC CONFERENCE Jeddah.","page":9},{"from":1,"to":155,"type":"past-director","description":"\"QATAR CHARITY UK corporate documents indicate that subsequently, the following important changes were made: \n On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed.","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/WUriqQ1-gZSoYI6OXuQVmM8GYpr5lttEIgeBjf3WS4Y/application-pdf?AWSAccessKeyId=ASIAJNJ2YWBJ2CMVO2AA&Expires=1517235889&Signature=X5RbY%2FpzBKhdrtttGlu%2BsdQ%2Bhjw%3D&x-amz-security-token=FQoDYXdzENf%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDCGWN2574J0ZJuYNuyK3AxrqeUcq5yObr6zCoWeYcf3XmgyATAg9u%2FFySqMIozN44IGlVYYM3mO%2BOk4uWiuYrtEEGu%2Bpo2ZEJ2kXPHpPD4Nqrama0r3oFBeQv0vQhx5SG5w4qypCs5UvMXg6JMN44bKARx1ubWdb9GDnhRCw%2FKGP2ZccJG%2BZdSJmddvWhr05N2GA1mJqMS5DSb5cpgwBevn4sYwno5l2hRtJsQJXI1btuRKNkIaFpYDH3Q%2B0kltvA8P0shSD%2BtdxqciHgohnWIo7DYd9vF2XHRaw8cRY5PEXVT%2BjDpu9GayX3y4ad7N3JStRt5y0hh3qgiam%2FZCK48qfaqCWxfXuOgi16LvBlHwE0qh9jSKNwLg8k1q1Wtoozc6N2dAWIAYGYX82aK%2F3aN42KwbQ%2F40iUCmLwIcdQe8OzXvO8DNYI2R0GiKiAsMhvEGaW3%2F6YJjhu%2FHyc%2FDqyMk50slXQL%2BuroS%2FlkA%2BLj80HiRh5YxoiBfu0gBdNH4AzrQgBkf47ECxNI344iNai9gBd9dObni3Y10cMilmNPtHe5xnBJPSp24mBjlrZNhq2n4Irs5lL1PJue5qHc6oiUfFQb2OU98ok9W80wU%3D","reference2":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/cecxTR9trBwn15wiqkUTMCyC-9ir6yUFcOGNJJvbOmQ/application-pdf?AWSAccessKeyId=ASIAJMQKMPQY7JNO6BVQ&Expires=1517235934&Signature=RTeNjjINFrImygcgcj6g0hX5qRc%3D&x-amz-security-token=FQoDYXdzENb%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDBV3HgliV9aEFWxb5CK3AynNLxDI3%2B8F8TokNgbxq5RgqTuhXUvrKUAUcSphs8c6bIiDypoNwtk42QSSAXYwC5LgrfBVTQPLdM%2Fdy6HbYbbJbWyBzqVRJkt7u5avofAbkFcci6fgP1owX2bVXpicFLM%2FJkSxo7cWvuBdFad%2FEpbrzP3rLwC8WZueJLgZ0N6LV%2FppenlXGoQzg%2FI7VXDGrw%2BmUp3veC6W6naCdEUUKosrZG4wSzmLsm2JBMINytrNd%2BVCPXh8iPY7zkIzQi9%2B4AdeVLBXN%2FwEWJmAzBKkF%2F0OsXB4294gs%2FCZxuAtizGfvBpJrTWJtbB6%2BTBTVql%2FTvSBmmmQsQNdm7HSoG4t9fy883ZVudljzogwNYueIYL7yhuMxzI9miqSG7TJ1nOpTldxUSURVVPPmjrvgR5an%2BOLgwijgspugA%2FoXNqpZyUm73QnzyshyCG9fwwRoSrL83EUvm4%2F3SrcHppukcvJHCRdu6fV2x1%2BToFUSgujqmxtPeQEvd6si1F0LjI%2FyeY6boopCF91X0ErM4F2G2dxo8lc5xanQzXbPeK%2Bcg7OpXwWvkw9LemiK%2BerRaC9qvXZDSMRUKnhGaAo0q%2B80wU%3D"},{"from":1,"to":150,"type":"director","description":"On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed: \n - IJAZ AHMAD, British","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/KLHDAd_E54Z3YrB2E644pUE13MzAAmLoVQ7rrfp4uhE/application-pdf?AWSAccessKeyId=ASIAIDJ5PWRATSIZIQYQ&Expires=1517235994&Signature=IzRQ9I7jqa3RvAAv20I8iPi1xWU%3D&x-amz-security-token=FQoDYXdzENX%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDEcHFKfL7c1kHBBviSK3A8oMFgOLyiePQjG8sHtXdE8qnPQtS79DLA4fP7XcfybzF6ixj6cgqfDEiB53jArKtfF4ij%2BPLZzxs8UZoEl59uWh19GzcscR1o%2Bqt9p6J1skU9hWq9GYzuY9lpMo7%2BROvraM9J3yc7z0%2B3TmrbC0u457xfl9eXWFZea%2BzAuqaYNxHyxE260aQmZOtzXj%2BWSFvSvNcseLyNAKzLyebK9BzSErGY4kyOR0OY5hEndkYP8bM8ss4Ci6VAWeK11XjcMCF7sGGe1NLUeM3PKUCE1utk1Wn9%2FTieum%2B9kP8bp7l798yMSUp%2FP9fsmBzGrY5cn2XcgwS3T4PyYpEHDyV0KwdT05snf1bRLgOADper9KcK%2Fb5jeD75XOY6WE3EJufgEiIn7So6j8KFVWd0H%2BGpAP2x%2F2KjSFi2sTCVQAxFQQb7%2Fa7R6Me7ARr%2BirPiYvGJHUzqw%2BMnbm2kJYFA1lmEcE8JeVbR%2FalMB1WfFCDXXpm0zEcO4%2FQSagni8N%2F%2F6IPrEnvfeGuqJscU5gzlp6pRhQuDDiMixYdAqCCDrNGCwAZ%2B697HbvsmXP7y%2FbnAgF%2BThqf7b%2BQ6FrQVko6Y%2B80wU%3D"},{"from":1,"to":151,"type":"director","description":"On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed: \n - MOHAMMED SAADON AL-KUWARI, Qatari, director","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/aPr6PQEtne8uJVKA099vHWfcgkdmY3Lj5WTWqpsy5nY/application-pdf?AWSAccessKeyId=ASIAJGJOVE7INLLX37IA&Expires=1517236097&Signature=M%2Be62OCw7v5KXVLHvrhF%2FexhaJk%3D&x-amz-security-token=FQoDYXdzENf%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDNmFmDgMY9SNDwrRtCK3A8eD7DaK3zv2qVoI0Ym%2B7dz68YcNLGRM7ab72n8kX2nsu4T6FouB%2Bfu%2BKxrbSb4yRd187i8Ogy7jtAIFJSoZ4xKFotlhsSRl4en9nNNbSIITZ4h2FGOnOHNEZpDqrIPh7D01Yyt70RN5ovr2w4cX4WVaxd8q5u5086y3q%2B9eJI5Ce31y8eUBdNk7U8J%2BHFsAVdqNoqZmzfhn20ls%2FnxwdnPA54Ah17RQaIEMj%2FvFWpxohlzDN9kRmjo%2BRkhUGtDTBWIWUvAoY%2Fywgp%2FbCo1GtrkDmOr6oz8egIUTdkYYCpBtflsPSJxCLwjU%2FUgM3aVJrhWRyYmyw5iO0V91C%2FY%2FvP9dy5R0sAeSyd6fDrD662Tq%2Bpdkq58txF8v53gytjzc7KcZGDc73fZFXwh15mEoKH0v%2BtedEqW0tbGXhnSF6Bk6oe04%2Bjw5roaE2j2HC%2FFxQ8ta5oQlo%2BvwzDICXDwRxkJmhqcEbFQgBu7kxGMcv3Ksu6E5WEaUzFQNpSxLVWGtc%2FZ5sm1FN3FbE39U3w94sSjnY8E%2BVAhbpHh%2FKWjVIqgCxTBWFkuqjlBuH6bHI1EdDxIAh5oLtFko%2FtG80wU%3D"},{"from":1,"to":152,"type":"director","description":"On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed: \n - MOHAMMED ALI AL-GHAMDI, Qatari","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/e8sTgzMkUUlzB2bCt25NSjkqP8t9oiUCdVshoD9JE8k/application-pdf?AWSAccessKeyId=ASIAJMQKMPQY7JNO6BVQ&Expires=1517236179&Signature=IHtNJNeAxY9NM8LRK4hon1AP%2BzU%3D&x-amz-security-token=FQoDYXdzENb%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDBV3HgliV9aEFWxb5CK3AynNLxDI3%2B8F8TokNgbxq5RgqTuhXUvrKUAUcSphs8c6bIiDypoNwtk42QSSAXYwC5LgrfBVTQPLdM%2Fdy6HbYbbJbWyBzqVRJkt7u5avofAbkFcci6fgP1owX2bVXpicFLM%2FJkSxo7cWvuBdFad%2FEpbrzP3rLwC8WZueJLgZ0N6LV%2FppenlXGoQzg%2FI7VXDGrw%2BmUp3veC6W6naCdEUUKosrZG4wSzmLsm2JBMINytrNd%2BVCPXh8iPY7zkIzQi9%2B4AdeVLBXN%2FwEWJmAzBKkF%2F0OsXB4294gs%2FCZxuAtizGfvBpJrTWJtbB6%2BTBTVql%2FTvSBmmmQsQNdm7HSoG4t9fy883ZVudljzogwNYueIYL7yhuMxzI9miqSG7TJ1nOpTldxUSURVVPPmjrvgR5an%2BOLgwijgspugA%2FoXNqpZyUm73QnzyshyCG9fwwRoSrL83EUvm4%2F3SrcHppukcvJHCRdu6fV2x1%2BToFUSgujqmxtPeQEvd6si1F0LjI%2FyeY6boopCF91X0ErM4F2G2dxo8lc5xanQzXbPeK%2Bcg7OpXwWvkw9LemiK%2BerRaC9qvXZDSMRUKnhGaAo0q%2B80wU%3D"},{"from":83,"to":26,"type":"connection","description":"The MUSLIM WELFARE HOUSE has been mentioned several times in this report and known to be part of the MUSLIM BROTHERHOOD in the UK.","page":62},{"from":139,"to":141,"type":"director","description":"According to UK corporate records, SALEH SAEED is also a director of the following company: YEMENI COMMUNITY ASSOCIATION IN SANDWELL LIMITED","page":20,"reference":"http://apps.charitycommission.gov.uk/Showcharity/RegisterOfCharities/PrintReport.aspx?RegisteredCharityNumber=1130399&ReportType=COLOUR"},{"from":1,"to":143,"type":"director","description":"JASSIM SALEM AL-ANSARI (Qatari, Aid Worker) was one of the three directors from QCUK. Other two: YOUSUF AHMAD AL-KUWARI, Qatari, CEO of QATAR CHARITY and YOUSUF AHMED HASSAN AL-HAMMADI, Qatari, businessman.","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/-oym-zpczW-9uaqRrl9YLya8d09NBG1XIMIOcGC2Cns/application-pdf"},{"from":1,"to":67,"type":"director","description":"JASSIM SALEM AL-ANSARI (Qatari, Aid Worker) was one of the three directors from QCUK. Other two: YOUSUF AHMAD AL-KUWARI, Qatari, CEO of QATAR CHARITY and YOUSUF AHMED HASSAN AL-HAMMADI, Qatari, businessman.","page":20,"reference":"http://apps.charitycommission.gov.uk/Showcharity/RegisterOfCharities/PrintReport.aspx?RegisteredCharityNumber=1130399&ReportType=COLOUR"},{"from":1,"to":144,"type":"director","description":"JASSIM SALEM AL-ANSARI (Qatari, Aid Worker) was one of the three directors from QCUK. Other two: YOUSUF AHMAD AL-KUWARI, Qatari, CEO of QATAR CHARITY and YOUSUF AHMED HASSAN AL-HAMMADI, Qatari, businessman.","page":20,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/-oym-zpczW-9uaqRrl9YLya8d09NBG1XIMIOcGC2Cns/application-pdf"},{"from":156,"to":1,"type":"bankers-for","description":"According to the QCUK annual reports, bankers\n for QCUK are the AL-RYAN BANK, formerly\n the ISLAMIC BANK OF BRITAIN.","page":19,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"from":156,"to":26,"type":"provide-banking-service","description":"According to the QCUK annual reports, bankers for QCUK are the AL-RYAN BANK, formerly the ISLAMIC BANK OF BRITAIN that is known to provide banking services for MUSLIM BROTHERHOOD/HAMAS organizations in the UK.","page":19,"reference":"https://www.globalmbwatch.com/2008/11/19/breaking-news-important-uk-union-of-good-organization-reports-facing-closure/"},{"from":156,"to":74,"type":"provide-banking-service","description":"According to the QCUK annual reports, bankers for QCUK are the AL-RYAN BANK, formerly the ISLAMIC BANK OF BRITAIN that is known to provide banking services for MUSLIM BROTHERHOOD/HAMAS organizations in the UK.","page":19,"reference":"http://www.cityam.com/1414071782/islamic-bank-britain-gets-rebrand"},{"from":156,"to":157,"type":"majority-owned-by","description":"According to the QCUK annual reports, bankers for QCUK are the AL-RYAN BANK, formerly the ISLAMIC BANK OF BRITAIN that is\nknown to provide banking services for MUSLIM BROTHERHOOD/HAMAS organizations in the UK.","page":19},{"from":7,"to":156,"type":"provide-banking-service","description":"According to the QCUK annual reports, bankers for QCUK are the AL-RYAN BANK, formerly the ISLAMIC BANK OF BRITAIN that is known to provide banking services for MUSLIM BROTHERHOOD/HAMAS organizations in the UK and which was majority-owned by the QATAR INTERNATIONAL ISLAMIC BANK.","page":19},{"from":7,"to":24,"type":"trustees","description":"On 6 June 2009, the EMAAN TRUST filed a Memo of Association with UK corporate authorities signed by 14 subscribers, 12 of whom are identifieed below as EMAAN TRUST officers/trustees. Hassan Alkatib is one of the trusstees. ","page":7,"reference":"http://opencharities.org/charities/1131861"},{"from":148,"to":1,"type":"expantion","description":"This report shows how Qatar has opened a branch of one of its most important funding infrastructures – Qatar Charity (QC) - at the heart of Europe’s financial center London and is coordinating and funding Islamist projects in the West through this entity. ","page":3},{"from":148,"to":7,"type":"project","description":"QATAR CHARITY (QCUK) was established ostensibly because of a need to supervise growing QC projects in the UK & Europe. The EMAAN TRUST Sheffield project appears to be focused on providing facilities for the Yemeni MUSLIM BROTHERHOOD in the UK and centers on UK converts to Islam.","page":1},{"from":148,"to":1,"type":"connection","description":"QATAR CHARITY (QCUK) was established ostensibly because of a need to supervise growing Qatar Charity projects in the UK & Europe.","page":1},{"from":1,"to":48,"type":"connection","description":"The report further identifies individuals that are most heavily involved in the QCUK’s work in London – many of them with ties to the GLOBAL MUSLIM BROTHERHOOD. ","page":3},{"from":87,"to":48,"type":"connection","description":"ELBANNA has been a leader in multiple UK charity organizations tied to the Global MUSLIM BROTHERHOOD.","page":21,"reference":"https://www.globalmbwatch.com/2015/01/19/featured-global-muslim-brotherhood-hold-2016-charity-summit-uk-charity-commission-advises-organizer/"},{"from":7,"to":58,"type":"leadership","description":"The EMAAN TRUST corporate records identify MARK BONHAM as a 50-year-old British national resident in England who listed his  profession as Engineer. It is judged highly likely that MARK BONHAM is the same individual referred to in this report as AKRAM BONHAM.","page":47,"reference":"https://beta.companieshouse.gov.uk/officers/OSd8b1HSukWF0aAOh4VGXWAUgKw/appointments"},{"from":7,"to":32,"type":"leadership","description":"The EMAAN TRUST corporate records identify AHMED AL-RAWI as a 69-year-old British national resident in England who listed his occupation as Project Manager.","page":49,"reference":"https://s3-eu-west-1.amazonaws.com/document-api-images-prod/docs/hIk4FEhj-niAIkTN1-YAHPxoK2yRrzn4cNGJqzAZ9Hg/application-pdf?AWSAccessKeyId=ASIAJ46RC2O6KA3ICBYA&Expires=1517237335&Signature=bqdJf%2F1tuqCfpq3A7ru6eWu3GIg%3D&x-amz-security-token=FQoDYXdzENX%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaDH3lBjeprB%2BpFlzmMyK3A1%2Fk0rvpUT31%2BX4GnbAuu6mh4FS9KJCvq%2Bv6w1dfR%2Bas9C%2FiAeuyqFvHGWQzRhlogYp%2Fx76R3LYZm1Gxbyh%2BHtivG%2Bu3GYzP0TFBijnKj9dF%2BPfsMRaI7o8yPeOachdvlUz1mQFxyM%2Bpp3pHPazDu3hBwLrqOUymcvzbV7RvR0rMWYtE6h0JbFIsodbt693tvnAkgptTs2pouo7aAtn9EaZJliAaZoTfvyGJZHcY0f1ORv4tuAkrLu2sBdGtn4edse9DGwHKu9XhnG1xNOApywk1MjnVI1ZAup0hOpO%2FZnNXHBIli5NTdm2Wd6SexXntKg3H6pOTiR6lRTD9zu7zxJuFyHgpJwWzGkY%2FXWZI0yQVEmA84Gyaplaa45380nE2EI7KeEFMCMhjHPdThDPBTHhQWtJgHTl%2Bq12PB63aigXjed5%2FBow7uY%2BsHbs55VMjijkGCYkS5lpM5NlaH9FGHG2ovTG%2Fdw1RO91hZk1IHZ0TXTSZrwDtY%2B2jv75rV%2BoL7LmBApsQiumu%2FQ4jjSCpSyiR8tFroT0BNKaSVBKt2UMaRVJzYY2rOvCPmrfBnGfgQjgwRpvPLVcohaG80wU%3D"},{"from":7,"to":103,"type":"leadership","description":"The EMAAN TRUST corporate records identify KHALID ALMATHKOUR as a 70-year- old Kuwaiti national resident in Kuwait who listed his occupation as “Scholar.”","page":51,"reference":"https://beta.companieshouse.gov.uk/officers/3pLFgnLKyGlg34DKvlA4U8EqpOU/appointments"},{"from":7,"to":112,"type":"leadership","description":"EMAAN TRUST corporate records identify Dr. MUTLAQ AL-QARAWI as a 64-year-old Kuwaiti national resident in Kuwait who listed his occupation as Retired Scholar.","page":55,"reference":"https://beta.companieshouse.gov.uk/officers/G39Hzndu65jwSI_wscNtIufPdU4/appointments"},{"from":7,"to":121,"type":"leadership","description":"EMAAN TRUST Trustee HAMEED AL-ASALY is the NEMA Secretary and that EMAAN TRUST Trustee AMINA BLAKE ALI gave a speech in 2008 to the group.","page":56,"reference":"https://beta.companieshouse.gov.uk/officers/oDAZvDu4jRpUvhF2w0ZIXLpSQHU/appointments"},{"from":7,"to":42,"type":"leadership","description":"The EMAAN TRUST corporate records identify Mrs. TRACY AL-ASALY as a British national resident in England who listed her occupation as Educationalist.","page":46,"reference":"https://beta.companieshouse.gov.uk/officers/ju9-I06dWRBhiyzac_Sv_fHYd5M/appointments"},{"from":7,"to":133,"type":"leadership","description":"The 2013 EMAAN TRUST \rreport to the UK Charity \rCommission identifies ADEL\rAL-FALAH a Trustee at\r that time although by the \r2014 report, his name was \rremoved. According to\r his CV, ADEL ABDULLAH\rAL-FALAH is 63-year-old \rKuwaiti national who has been the Undersecretary of the Kuwait Ministry of Awqaf and Islamic Affairs since 1992 until the current time.","page":75,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends61/0001131861_AC_20130131_E_C.pdf"},{"from":18,"to":26,"type":"connection","description":"From 15 July 2005 to 16 March 2007, UK corporate records list HAFEZ AL-KARMI as a Director of the MUSLIM WELFARE HOUSE, part of the UK MUSLIM BROTHERHOOD and closely tied to the MUSLIM ASSOCIATION OF BRITAIN (MAB).","page":34,"reference":"https://beta.companieshouse.gov.uk/officers/uJElRIdf08OXfFYT6Gt9bowy4Pc/appointments"},{"from":119,"to":18,"type":"a part of","description":"UK corporate records identify ABDERREZAK BOUGARA as a director of the M A B CHARITABLE TRUST, described on the MAB website as part of the MAB.","page":66,"reference":"https://beta.companieshouse.gov.uk/company/08043568/officers"},{"from":14,"to":8,"type":"manager","description":"The article went on to identify HAMEED AL-ASALY, of the Birmingham-based CATALYST REGENERATION (UK) LTD, the company behind\n the proposed mosque. AL-ASALY was reported to be\n the chairman of the committee managing the project for CATALYST REGENERATION. ","page":41},{"from":1,"to":26,"type":"tied-to","description":"QCUK has had strong ties to the MUSLIM BROTHERHOOD UK and MUSLIM BROTHERHOOD EUROPE and most of the known QCUK expenditures are being directed to MUSLIM BROTHERHOOD related projects in the UK and Europe.","page":1},{"from":1,"to":158,"type":"tied-to","description":"QCUK has had strong ties to the MUSLIM BROTHERHOOD UK and MUSLIM BROTHERHOOD EUROPE and most of the known QCUK expenditures are being directed to MUSLIM BROTHERHOOD related projects in the UK and Europe.","page":1},{"from":3,"to":158,"type":"representing","description":"FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and its French member the UNION DES ORGANISATIONS ISLAMIQUES DE FRANCE (UOIF), both organizations representing THE MUSLIM BROTHERHOOD in Europe.","page":36,"reference":"https://www.globalmbwatch.com/institut-europeen-des-sciences-humaines/"},{"from":1,"to":159,"type":"funding","description":"According to the 2014 QCUK report to the Charity Commission, only £1,084 was expended on programmatic charitable activity with the remainder of the expenditures going for operating expenses.\n\nAttachement: 10.Statement of Funds: £535 was funded by Syria Emergency in 2014.","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20140331_E_C.pdf"},{"from":1,"to":140,"type":"funding","description":"According to the 2014 QCUK report to the Charity Commission, only £1,084 was expended on programmatic charitable activity with the remainder of the expenditures going for operating expenses.\n\nAttachement: 10.Statement of Funds: £524 was funded by Zakat in 2014. ","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20140331_E_C.pdf"},{"from":1,"to":160,"type":"funding","description":"According to the 2014 QCUK report to the Charity Commission, only £1,084 was expended on programmatic charitable activity with the remainder of the expenditures going for operating expenses.\n\nAttachement: 10.Statement of Funds: £25 was funded by Sadqa in 2014.","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20140331_E_C.pdf"},{"from":1,"to":71,"type":"loan given to","description":"The report does note a loan made to AMAL, presumably the ASSOCIATION DES MUSULMANS D’ALSACE, referred to above and in involved in the AL NOUR MOSQUE project. \n\nAccording to the report:\nA Loan of  £99,151 was provided by AMAL to assist QCUK to commence its operational activities. The loan is valid until 25/6/2015 as per contractual agreement and there is no interest payable.","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20140331_E_C.pdf"},{"from":1,"to":161,"type":"funds spent on","description":"The bulk of the funds, £2,069,615, was spent on “Community Development.” According to the report:\n This figure consists of three restricted projects for the development of the community. Two projects will be implemented for the UK and one will be designed for Europe. These community development projects will fund, either fully or partially, the purchase or construction of community centres where marriage functions can be hosted, the youth can be involved in sports activities, day care centres for mothers, prayer areas, shops and classrooms for teaching Arabic language and for tuition.\n No further information was available about these projects.","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20140331_E_C.pdf"},{"from":163,"to":158,"type":"representing","description":"FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and its French member the UNION DES ORGANISATIONS ISLAMIQUES DE FRANCE (UOIF), both organizations representing THE MUSLIM BROTHERHOOD in Europe.","page":36,"reference":"https://www.globalmbwatch.com/institut-europeen-des-sciences-humaines/"},{"from":1,"to":161,"type":"project","description":"The bulk of the funds, £2,069,615, was spent on “Community Development.” According to the report:\n\nThis figure consists of three restricted projects for the development of the community. Two projects will be implemented for the UK and one will be designed for Europe. These community development projects will fund, either fully or partially, the purchase or construction of community centres where marriage functions can be hosted, the youth can be involved in sports activities, day care centres for mothers, prayer areas, shops and classrooms for teaching Arabic language and for tuition.\n\nNo further information was available about these projects.","page":36,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"from":1,"to":162,"type":"project","description":"\"The second largest QCUK expenditures listed and \nfor £736,690 was for the “EIHS in Chateau Chinon.”\n\nThe EIHS in presumably the same organization as the INSTITUT EUROPÉEN DES SCIENCES HUMAINES (IESH), an educational and imam training facility in France associated with the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and its French member the UNION DES ORGANISATIONS ISLAMIQUES DE FRANCE (UOIF), both organizations representing THE MUSLIM BROTHERHOOD in Europe.\n\nThis project comprises establishing new buildings, where the Institute wishes to expand and revamp its premises to transform from an institute to a university campus which will include apartments for married students and others for single students, modern classroom equipped with distance learning technologies, a lecture hall and providing places for sports. Due diligence was still continuing on this restricted grant on the date of signing of these accounts.\"        36,37","page":"36,37","reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"from":162,"to":3,"type":"associated-with","description":"The EIHS in presumably the same organization as \nthe INSTITUT EUROPÉEN DES SCIENCES HUMAINES (IESH), an educational and imam training facility in France associated with the FEDERATION\nOF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) ","page":36,"reference":"https://www.globalmbwatch.com/institut-europeen-des-sciences-humaines/"},{"from":1,"to":163,"type":"associated-with","description":"The EIHS in presumably the same organization as \nthe INSTITUT EUROPÉEN DES SCIENCES HUMAINES (IESH), an educational and imam training facility in France associated with the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) and its French member the UNION DES ORGANISATIONS ISLAMIQUES DE FRANCE (UOIF), both organizations representing THE MUSLIM BROTHERHOOD in Europe.","page":36,"reference":"https://www.globalmbwatch.com/institut-europeen-des-sciences-humaines/"},{"from":1,"to":164,"type":"project","description":"The fourth largest QCUK expenditures listed and for £85,318 was for the “Swanse University Campus” and described as follows:\n is restricted grant from Qatar Charity will be utilised to build a Lecture theatre, meeting rooms, administrative offices, crèche providing childcare, classrooms for teach Arabic language, a prayer hall and car parking. Due diligence was still continuing on this restricted grant on the date of signing of these accounts. \nIt is likely, but not confirmed, that the above mentioned construction projects relate to the mosque known to \nbe located on the campus of SWANSEA University in Swansea, Wales.","page":37,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"from":162,"to":32,"type":"trustee","description":"It should be noted that Swansea is a known location for\nsta  of the EUROPEAN INSTITUTE OF HUMAN\nSCIENCES (EIHS), UK branch of L’INSTITUT\nEUROPÉEN DE SCIENCES HUMAINES (IESH),\noriginally founded by the UNION OF ISLAMIC\nORGANIZATIONS IN FRANCE (UOIF) and where\nAHMED AL-RAWI serves as trustee.","page":37},{"from":162,"to":163,"type":"founded-by ","description":"It should be noted that Swansea is a known location for\nsta  of the EUROPEAN INSTITUTE OF HUMAN\nSCIENCES (EIHS), UK branch of L’INSTITUT\nEUROPÉEN DE SCIENCES HUMAINES (IESH),\noriginally founded by the UNION OF ISLAMIC\nORGANIZATIONS IN FRANCE (UOIF).","page":37},{"from":1,"to":165,"type":"project","description":"\"The  fifth largest QCUK expenditures listed and for £56,530 was for the “Multipurpose Center Mulhouse.” This funding presumably is the same project referred to in the document as the “AL Huda Project in Illzach (Suburb of Mulhouse)”, explained as follows:\nAfter the completion of internal due diligence it was decided not to continue with this restricted grant. The trustees of QCUK will now decide to re-assign this restricted funding to another community centre project after con rming approval from the donor of this funding, Qatar Charity.\"","page":37,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"from":1,"to":166,"type":"project","description":"The sixth largest QCUK expenditures listed and for £31,244 was for the “Swanse University Campus” and described as follows:\r is restricted grant from Qatar Charity will contribute to the payment of university fee installments for 20 university students to enable them to complete their studies. The beneficiaries have either no funds or are especially needy. Due diligence was still continuing on this restricted grant on the date of signing of these accounts.\rNo further information was available on this project. \rHowever, it should be noted that the website of the \rALL-UKRAINIAN ASSOCIATION OF SOCIAL\rORGANISATIONS (ALRAID), the Ukrainian member \rorganization of FIOE, lists the QATAR CHARITY \rORGANIZATION as one of its “Partners and Donors.”","page":37,"reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"from":166,"to":148,"type":"restricted-grant-from","description":"This restricted grant from Qatar Charity will contribute to the payment of university fee installments for 20 university students to enable them to complete their studies. The beneficiaries have either no funds or are especially needy. Due diligence was still continuing on this restricted grant on the date of signing of these accounts.","page":37},{"from":168,"to":3,"type":"ukrainian-member-of","description":"\nNo further information was available on this project. \nHowever, it should be noted that the website of the\n ALL-UKRAINIAN ASSOCIATION OF SOCIAL\n ORGANISATIONS (ALRAID), the Ukrainian member \norganization of FIOE, lists the QATAR CHARITY\n ORGANIZATION as one of its “Partners and Donors.","page":37,"reference":"https://www.globalmbwatch.com/2011/12/28/ukranian-muslim-brotherhood-holds-10th-annual-conference/"},{"from":166,"to":168,"type":"website-of-the","description":"It should be noted that the website of the ALL-UKRAINIAN ASSOCIATION OF SOCIAL ORGANISATIONS (ALRAID), the Ukrainian member organization of FIOE, lists the QATAR CHARITY ORGANIZATION as one of its “Partners and Donors.","page":37,"reference":"http://www.arraid.org/en/partners-donors"},{"from":3,"to":148,"type":"partners-and-donors","description":"It should be noted that the website of the ALL-UKRAINIAN ASSOCIATION OF SOCIAL ORGANISATIONS (ALRAID), the Ukrainian member organization of FIOE, lists the QATAR CHARITY ORGANIZATION as one of its “Partners and Donors.","page":37,"reference":"http://www.arraid.org/en/partners-donors"},{"from":1,"to":167,"type":"project","description":"The seventh largest QCUK expenditures listed and for £26,289 was for the “Iftaar UK” and was described as follows: \nThis restricted funding provided 26 grants to support local organizations around the UK and in Europe to prove Iftar (Ramadan meals) to poor individuals and to the wider community. This is a restricted grant from Qatar Charity.","page":"37,38","reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"from":167,"to":148,"type":"restricted-grant-from","description":"The seventh largest QCUK expenditures listed and for £26,289 was for the “Iftaar UK” and was described as follows: \nThis restricted funding provided 26 grants to support local organizations around the UK and in Europe to prove Iftar (Ramadan meals) to poor individuals and to the wider community. This is a restricted grant from Qatar Charity.","page":"37,38","reference":"http://apps.charitycommission.gov.uk/Accounts/Ends97/0001146597_AC_20150331_E_C.pdf"},{"from":1,"to":169,"type":"director","description":"On 14 January 2013 two directors, JASSIM AL-ANSARI and YOUSUF AL-HAMMADI resigned and four new directors were appointed:\r\n- HAFEZ AHMED AHMED, British \n\r- IJAZ AHMAD, British \n\r- SALMAN MOHAMMED ALI A. M. KALDARI,Qatari,businessmann \n\r- MOHAMMED ALI AL-GHAMDI, Qatari, executive director\r","page":20},{"from":68,"to":48,"type":"sympathizer-of","description":"The postings on Facebook are mainly in Arabic and some in English and include emotions about the fall of the MORSI government and anti-Israel sentiment. His Facebook contacts include MOHAMMED EL-BENNY an Egyptian preacher in New Jersey who has many contacts with Egyptian MB personalities including in the UK. El-BENNY was a subject in a court case against an Islamic school in Minnesota. Another contact is VAIL AL-BEKHESI a Kuwaiti living in Kiev, Ukraine and person very well connected within the European MB structures. \n\nHe has 154 friends including ANIS AL-RAWI, CHAKIB BENMAKHLOUF, ANAS AL-TIKRITI, FOAUD ALAOUI and ABOULKHEIR BREIGHECHE. \n\nOther items of interest from his Facebook account include: \n- A post expressing support for the veiling of women.\n- A posting of a video by YOUSSEF QARADAWI.\n- Many posts discussing the overthrow of the MUSLIM BROTHERHOOD government in Egypt.\n- Posting a link from an Arab language website that translated a New York Times article allegedly showing involvement of Saudi Arabia and the UAE with the overthrowing of the MORSI regime in Egypt.\n- Posting a picture of AHMED AL-HAMMADI making the Rabi’a sign.\n- Posting a profile picture with the Rabi’a sign in it.\n- Posting pictures and message from Kuwaiti MUSLIM BROTHERHOOD leader TARIQ SUWAIDAN\n- Posting “It’s true that I love MB. And my views might be considered biased by many.”\n- Posting “I was supporting Hizbollah when they were resisting Israel.” And following a comment on Hizbollah “Nothing is totally good or totally bad.”\n- Sharing a post from the INSTITUT EUROPÉEN DES SCIENCES HUMAINES (IESH), an educational and imam training facility in France associated with the FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE.\n\nThe only Instagram follower of interest is former FEDERATION OF ISLAMIC ORGANIZATIONS IN EUROPE (FIOE) president CHAKIB BENMAKHLOUF.","page":"22,23"}]

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__github__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__(791);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},__WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__github__["a" /* default */],__WEBPACK_IMPORTED_MODULE_3__user__["a" /* default */]));

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export appState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutability_helper__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_constants__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_helpers__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_constants_index__ = __webpack_require__(58);
var _createReducer;var isfirstvisit=true;if(localStorage.isfirstvisit==='1'){isfirstvisit=false;}var appState={alerts:[],draweropened:false,isfirstvisit:true,edges:{data:[]},nodes:{data:[]},allnodes:{data:[]},tags:{data:[]},html:{data:[]},nodeid:0,edgeid:0,info:{data:[]}};/* harmony default export */ __webpack_exports__["a"] = ({app:Object(__WEBPACK_IMPORTED_MODULE_3_modules_helpers__["b" /* createReducer */])(appState,(_createReducer={},__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_2_redux_persist_lib_constants__["REHYDRATE"],function(state){return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{alerts:{$set:[]}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].HIDE_ALERT,function(state,_ref){var id=_ref.payload.id;var alerts=state.alerts.filter(function(d){return d.id!==id;});return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{alerts:{$set:alerts}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SHOW_ALERT,function(state,_ref2){var payload=_ref2.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{alerts:{$push:[payload]}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].DRAWER_CHANGE,function(state,_ref3){var payload=_ref3.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{draweropened:{$set:payload.draweropened}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].CLOSE_INTRO,function(state,_ref4){var payload=_ref4.payload;localStorage.isfirstvisit=1;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{isfirstvisit:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SHOW_INTRO,function(state,_ref5){var payload=_ref5.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{isfirstvisit:{$set:true}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_HTML,function(state,_ref6){var payload=_ref6.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{error:{$set:false},isRunning:{$set:true}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_HTML_SUCCESS,function(state,_ref7){var payload=_ref7.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{html:{data:{$set:payload.data||''},isRunning:{$set:false}}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_HTML_FAILURE,function(state,_ref8){var payload=_ref8.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{error:{$set:false},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES,function(state,_ref9){var payload=_ref9.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{error:{$set:false},isRunning:{$set:true},tag:{$set:payload.tag}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_EDGES,function(state,_ref10){var payload=_ref10.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{error:{$set:false},isRunning:{$set:true}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_EDGES_SUCCESS,function(state,_ref11){var payload=_ref11.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{edges:{data:{$set:payload.data||[]},isRunning:{$set:false}}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_EDGES_FAILURE,function(state,_ref12){var payload=_ref12.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{error:{$set:false},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES_SUCCESS,function(state,_ref13){var payload=_ref13.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{nodes:{data:{$set:payload.data||[]}},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_ALL_NODES_SUCCESS,function(state,_ref14){var payload=_ref14.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{allnodes:{data:{$set:payload.data||[]}},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_TAGS_SUCCESS,function(state,_ref15){var payload=_ref15.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{tags:{data:{$set:payload.data||[]}},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_TAG_SUCCESS,function(state,_ref16){var payload=_ref16.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{tag:{data:{$set:payload.data||[]}},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES_FAILURE,function(state,_ref17){var payload=_ref17.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{error:{$set:false},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_DETAIL,function(state,_ref18){var payload=_ref18.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{info:{$set:payload.info||[]},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_DETAIL_SUCCESS,function(state,_ref19){var payload=_ref19.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{info:{$set:payload.info||[]},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_DETAIL_FAILURE,function(state,_ref20){var payload=_ref20.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{error:{$set:false},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].INFO_DRAWER_CHANGE,function(state,_ref21){var payload=_ref21.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{infodraweropened:{$set:payload.draweropened}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].GET_NODES_BY_FLAG,function(state,_ref22){var payload=_ref22.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{error:{$set:false},isRunning:{$set:true},flag:{$set:payload.country}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_4_constants_index__["a" /* ActionTypes */].SET_NODES,function(state,_ref23){var payload=_ref23.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{nodes:{data:{$set:payload.nodes.filtered_nodes||[]}},isRunning:{$set:false}});}),_createReducer))});

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(788);
var $Object = __webpack_require__(23).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(24);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(52), 'Object', { defineProperty: __webpack_require__(45).f });


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var KEY_PREFIX = exports.KEY_PREFIX = 'persist:';
var FLUSH = exports.FLUSH = 'persist/FLUSH';
var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';
var PAUSE = exports.PAUSE = 'persist/PAUSE';
var PERSIST = exports.PERSIST = 'persist/PERSIST';
var PURGE = exports.PURGE = 'persist/PURGE';
var REGISTER = exports.REGISTER = 'persist/REGISTER';
var DEFAULT_VERSION = exports.DEFAULT_VERSION = -1;

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export githubState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutability_helper__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_helpers__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(58);
var _createReducer;var githubState={repos:{data:[],error:false,isRunning:false,message:'',q:''}};/* harmony default export */ __webpack_exports__["a"] = ({github:Object(__WEBPACK_IMPORTED_MODULE_2_modules_helpers__["b" /* createReducer */])(githubState,(_createReducer={},__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_REQUEST,function(state,_ref){var payload=_ref.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{repos:{error:{$set:false},isRunning:{$set:true},message:{$set:''},q:{$set:payload.q}}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_SUCCESS,function(state,_ref2){var payload=_ref2.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{repos:{data:{$set:payload.data||[]},isRunning:{$set:false}}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_FAILURE,function(state,_ref3){var payload=_ref3.payload;return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{repos:{error:{$set:true},isRunning:{$set:false},message:{$set:payload.message}}});}),_createReducer))});

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export userState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutability_helper__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutability_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_helpers__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_constants_index__ = __webpack_require__(58);
var _createReducer;var userState={isAuthenticated:false,isRunning:false};/* harmony default export */ __webpack_exports__["a"] = ({user:Object(__WEBPACK_IMPORTED_MODULE_2_modules_helpers__["b" /* createReducer */])(userState,(_createReducer={},__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGIN_REQUEST,function(state){return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{isRunning:{$set:true}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGIN_SUCCESS,function(state){return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{isAuthenticated:{$set:true},isRunning:{$set:false}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGOUT_REQUEST,function(state){return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{isRunning:{$set:true}});}),__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_createReducer,__WEBPACK_IMPORTED_MODULE_3_constants_index__["a" /* ActionTypes */].USER_LOGOUT_SUCCESS,function(state){return __WEBPACK_IMPORTED_MODULE_1_immutability_helper___default()(state,{isAuthenticated:{$set:false},isRunning:{$set:false}});}),_createReducer))});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export App */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_history__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_RoutePublic__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_config__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_routes_Home__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_routes_NotFound__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_actions__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Introduce__ = __webpack_require__(1115);
var App=function(_React$Component){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(App,_React$Component);function App(props){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,App);var _this=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={};return _this;}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(App,[{key:'render',value:function render(){var _props=this.props,app=_props.app,dispatch=_props.dispatch;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["a" /* ConnectedRouter */],{history:__WEBPACK_IMPORTED_MODULE_10_modules_history__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_helmet___default.a,{defer:false,htmlAttributes:{lang:'en-us'},encodeSpecialCharacters:true,defaultTitle:__WEBPACK_IMPORTED_MODULE_12_config__["a" /* default */].title,titleTemplate:'%s | '+__WEBPACK_IMPORTED_MODULE_12_config__["a" /* default */].name,titleAttributes:{itemprop:'name',lang:'en-us'}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_Introduce__["a" /* default */],{isopen:app.isfirstvisit,handleCloseClick:function handleCloseClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_15_actions__["a" /* closeIntro */])(false));}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('main',{className:'app__main'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{exact:true,path:'/',render:function render(){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["b" /* Redirect */],{to:'/tags/qatar-charity'});}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_modules_RoutePublic__["a" /* default */],{path:'/node/:nodeid',exact:true,component:__WEBPACK_IMPORTED_MODULE_13_routes_Home__["a" /* default */],dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_modules_RoutePublic__["a" /* default */],{path:'/edge/:edgeid',exact:true,component:__WEBPACK_IMPORTED_MODULE_13_routes_Home__["a" /* default */],dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_modules_RoutePublic__["a" /* default */],{path:'/tags/:tag',exact:true,component:__WEBPACK_IMPORTED_MODULE_13_routes_Home__["a" /* default */],dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_modules_RoutePublic__["a" /* default */],{path:'/country/:country',exact:true,component:__WEBPACK_IMPORTED_MODULE_13_routes_Home__["a" /* default */],dispatch:dispatch}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["c" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_14_routes_NotFound__["a" /* default */]})))));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);/* istanbul ignore next */App.propTypes={app:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,dispatch:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired};function mapStateToProps(state){return{app:state.app};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(App));

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(238);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(238);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(36);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(220);

var _PathUtils = __webpack_require__(102);

var _createTransitionManager = __webpack_require__(221);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(344);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(328);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(365);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(331);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(332);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(334);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(335);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(143);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(336);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(805);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(808);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(811);

var _HelmetConstants = __webpack_require__(367);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(806);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(807);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(809);
var isArguments = __webpack_require__(810);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 809 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 810 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(204);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(367);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(237);
var RoutePublic=function RoutePublic(_ref){var Component=_ref.component,isAuthenticated=_ref.isAuthenticated,to=_ref.to,rest=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref,['component','isAuthenticated','to']);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},rest,{render:function render(props){return isAuthenticated?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Redirect */],{to:to}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component,props);}}));};RoutePublic.propTypes={component:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,to:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};RoutePublic.defaultProps={to:'/private'};/* harmony default export */ __webpack_exports__["a"] = (RoutePublic);

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports = {"name":"qatars-ties-to-terror","title":"Qatar's ties to terror","description":"Network Explorer","version":"1.0.2","author":"","repository":{"type":"git","url":"https://github.com/m3nu/react-network-explorer.git"},"bugs":"https://github.com/m3nu/react-network-explorer/issues","license":"MIT","dependencies":{"bootstrap":"^4.0.0","classlist-polyfill":"^1.2.0","classnames":"^2.2.5","core-js":"^2.5.3","country-data":"0.0.31","downshift":"^1.25.0","ease-component":"^1.0.0","fbjs":"^0.8.16","gsjson":"^0.1.8","history":"^4.7.2","iframe-resizer":"^3.5.16","immutability-helper":"^2.6.4","is-finite":"^1.0.2","isomorphic-fetch":"^2.2.1","lodash":"^4.17.4","markdown":"^0.5.0","material-ui":"^1.0.0-beta.30","material-ui-icons":"^1.0.0-beta.17","mobile-detect":"^1.4.1","modernizr":"^3.5.0","prop-types":"^15.6.0","qs":"^6.5.1","react":"^16.2.0","react-autosuggest":"^9.3.2","react-dom":"^16.2.0","react-graph-vis":"^1.0.2","react-helmet":"^5.2.0","react-iframe-resizer-super":"^0.2.0","react-inlinesvg":"^0.7.4","react-markdown":"^3.1.4","react-popper":"^0.7.5","react-redux":"^5.0.6","react-resize-detector":"^1.1.0","react-router-dom":"^4.2.2","react-router-redux":"^5.0.0-alpha.9","react-transition-group":"^2.2.1","react-world-flags":"0.0.3","redux":"^3.7.2","redux-persist":"^5.5.0","redux-saga":"^0.16.0","redux-thunk":"^2.2.0","sass-mediaqueries":"^1.6.1","scroll":"^2.0.1","scroll-doc":"^0.2.1","stringify":"^5.2.0","typeface-roboto":"0.0.43","url-parse":"^1.2.0","uuid":"^3.2.1"},"devDependencies":{"autoprefixer":"^7.2.5","babel-core":"^6.26.0","babel-eslint":"^8.2.1","babel-jest":"^21.2.0","babel-loader":"^7.1.2","babel-plugin-array-includes":"^2.0.3","babel-plugin-istanbul":"^4.1.5","babel-plugin-lodash":"^3.3.2","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.6.1","babel-preset-react":"^6.24.1","babel-preset-stage-1":"^6.24.1","babel-runtime":"^6.26.0","browser-sync":"^2.23.6","browser-sync-webpack-plugin":"^1.2.0","bundlesize":"^0.15.3","case-sensitive-paths-webpack-plugin":"^2.1.1","chalk":"^2.3.0","clean-webpack-plugin":"^0.1.17","copy-webpack-plugin":"^4.3.1","css-loader":"^0.28.9","date-fns":"^1.29.0","del":"^3.0.0","dotenv":"^4.0.0","enzyme":"^3.3.0","enzyme-adapter-react-16":"^1.1.1","esdoc":"^1.0.4","esdoc-es7-plugin":"^0.0.3","eslint":"^4.16.0","eslint-config-airbnb":"^16.1.0","eslint-import-resolver-webpack":"^0.8.4","eslint-loader":"^1.9.0","eslint-plugin-babel":"^4.1.2","eslint-plugin-flowtype":"^2.42.0","eslint-plugin-import":"^2.8.0","eslint-plugin-jsx-a11y":"^6.0.3","eslint-plugin-react":"^7.6.0","expose-loader":"^0.7.4","extract-text-webpack-plugin":"^3.0.2","file-loader":"^1.1.6","flow-bin":"^0.58.0","gh-pages":"^1.1.0","git-info-webpack-plugin":"^1.0.1","html-loader":"^0.5.5","html-webpack-plugin":"^2.30.1","husky":"^0.14.3","image-webpack-loader":"^3.6.0","jest":"^21.2.1","jest-enzyme":"^4.0.2","jsdom":"^11.6.1","json-loader":"^0.5.7","markdown-loader":"^2.0.2","modernizr-loader":"^1.0.1","nock":"^9.1.6","node-sass":"^4.7.2","offline-plugin":"^4.9.0","postcss-loader":"^2.0.10","raw-loader":"^0.5.1","react-addons-test-utils":"^15.6.2","react-dev-utils":"^4.2.1","react-error-overlay":"^3.0.0","react-hot-loader":"^3.1.3","redux-logger":"^3.0.6","redux-mock-store":"^1.4.0","redux-saga-test-plan":"^3.3.1","sass-loader":"^6.0.6","script-loader":"^0.7.2","source-map-support":"^0.5.3","style-loader":"^0.19.1","stylelint":"^8.4.0","stylelint-config-standard":"^17.0.0","stylelint-declaration-strict-value":"^1.0.4","stylelint-order":"^0.7.0","stylelint-scss":"^2.2.0","url-loader":"^0.6.2","webpack":"^3.10.0","webpack-dev-server":"^2.11.1","webpack-merge":"^4.1.1"},"scripts":{"start":"APP_ENV=development node tools/start.js","build":"NODE_ENV=production APP_ENV=production webpack --config config/webpack.config.prod.js","build:pages":"NODE_ENV=production APP_ENV=pages webpack --config config/webpack.config.prod.js","analyze":"NODE_ENV=production webpack --config config/webpack.prod.js --profile --json > webpack.stats.json","lint":"eslint  --ext .js --ext .jsx app/scripts config test","lint:styles":"stylelint app/styles/**/*.scss","test":"jest --config config/jest.config.js --coverage","test:watch":"jest --config config/jest.config.js --watch","test:automation":"npm run start headless & cypress run","bundlesize":"bundlesize","deploy":"node tools deploy","publish":"node tools publish","docs":"node tools docs","precommit":"node tools commits && npm run lint && npm run lint:styles && npm test && npm run bundlesize","postmerge":"node tools update && npm update"},"browserslist":["ie >= 11","ie_mob >= 10","ff >= 30","chrome >= 34","safari >= 7","opera >= 23","ios >= 7","android >= 4.4","bb >= 10"],"bundlesize":[{"path":"./dist/scripts/app.*.js","maxSize":"150 kB"},{"path":"./dist/scripts/modernizr.*.js","maxSize":"30 kB"}]}

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Home */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Drawer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_graph_vis__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_graph_vis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_graph_vis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ZoomControl__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_EdgeDetail__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_NodeDetail__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Hover__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Menu__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_LoadHtml__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Header__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_RightMenu__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_actions__ = __webpack_require__(271);
var CONFIG=__webpack_require__(79);var parse=__webpack_require__(1111);var Home=function(_React$PureComponent){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Home,_React$PureComponent);function Home(props){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,Home);var _this=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.events={select:function select(event){var nodes=event.nodes,edges=event.edges;if(nodes.length>0){window.network.showDetailPanel(nodes[0],0);}else{window.network.showDetailPanel(edges[0],1);}},afterDrawing:function afterDrawing(){}};_this.state={menuopened:false,htmlopened:false,nodes:[],options:{autoResize:true,width:'100%',height:'100%',interaction:{hover:true},manipulation:{enabled:true},nodes:{shape:'dot',borderWidth:4,size:20,color:{border:CONFIG.colorBrownBorder,background:CONFIG.colorBrown,highlight:CONFIG.colorHighlight,hover:{border:CONFIG.colorHighlight,background:CONFIG.colorBrown}},font:{multi:true,size:12},widthConstraint:{minimum:150,maximum:150}},edges:{color:{highlight:CONFIG.colorHighlight,hover:CONFIG.colorHighlight},length:250,widthConstraint:{maximum:200}},physics:{barnesHut:{gravitationalConstant:-3000,centralGravity:0.1,damping:0.14,avoidOverlap:0.02},maxVelocity:13,minVelocity:0.43,timestep:0.2,adaptiveTimestep:true,solver:'barnesHut',stabilization:{enabled:true,iterations:1500,fit:true}}}};_this.hoverNode=_this.hoverNode.bind(_this);_this.blurNode=_this.blurNode.bind(_this);_this.scaleIn=_this.scaleIn.bind(_this);_this.scaleOut=_this.scaleOut.bind(_this);_this.animateFit=_this.animateFit.bind(_this);_this.handleTagClick=_this.handleTagClick.bind(_this);_this.handleFilter=_this.handleFilter.bind(_this);_this.handleFlagClick=_this.handleFlagClick.bind(_this);_this.onClick=_this.onClick.bind(_this);return _this;}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Home,[{key:'componentWillMount',value:function componentWillMount(){var dispatch=this.props.dispatch;if(window.innerWidth<=1000){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(false));}dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["c" /* getEdges */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["d" /* getNodes */])(''));window.network=this;this.handleSidebarClick=this.handleSidebarClick.bind(this);this.handleMenuClick=this.handleMenuClick.bind(this);}/**
   * Add event listener
   */},{key:'componentDidMount',value:function componentDidMount(){this.onDrawFinished();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var app=this.props.app;var nextapp=nextProps.app;if(app.nodes.data.length!==nextapp.nodes.data.length){this.props=nextProps;this.onDrawFinished();}if(app.edges.data.length!==nextapp.edges.data.length){this.props=nextProps;this.onDrawFinished();}if(app.tag!==nextapp.tag){this.onDrawFinished();}}},{key:'onDrawFinished',value:function onDrawFinished(){var _props=this.props,dispatch=_props.dispatch,app=_props.app;var edges=app.edges.data;var nodeid=this.props.match.params.nodeid;var edgeid=this.props.match.params.edgeid;var tag=this.props.match.params.tag;var country=this.props.match.params.country;if(edgeid){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["g" /* setDetail */])({nodeid:0,edgeid:edgeid}));try{var network=this._network;setTimeout(function(){network.selectEdges([edgeid]);var filtered_nodes=[];var nodes=app.nodes.data;var connected_nodes=network.getConnectedNodes(edgeid);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=nodes[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var node=_step.value;var node_id=node.id;if(connected_nodes.indexOf(node_id)!==-1||nodeid==node_id){filtered_nodes.push(node);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(filtered_nodes.length>0){network.setData({nodes:filtered_nodes,edges:edges});}},3000);}catch(e){console.error(e);}}else if(nodeid){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["g" /* setDetail */])({nodeid:nodeid,edgeid:0}));try{var _network=this._network;setTimeout(function(){var filtered_nodes=[];var nodes=app.nodes.data;var connected_nodes=_network.getConnectedNodes(nodeid);var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=nodes[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var node=_step2.value;var node_id=node.id;if(connected_nodes.indexOf(node_id)!==-1||nodeid==node_id){filtered_nodes.push(node);}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}if(filtered_nodes.length>0){_network.setData({nodes:filtered_nodes,edges:edges});_network.selectNodes([nodeid],true);}},3000);}catch(e){console.log(e);}}else if(tag){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["f" /* infoDrawerStatusChange */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["d" /* getNodes */])(tag));this._network.setData({nodes:this.props.app.nodes.data,edges:this.props.app.edges.data});var nodes=this.filterNodes(this.props.app.nodes.data);this._network.setData({nodes:nodes,edges:this.props.app.edges.data});this._network.redraw();}else if(country){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["e" /* getNodesByCountry */])(country));this._network.setData({nodes:this.props.app.nodes.data,edges:this.props.app.edges.data});var _nodes=this.filterNodes(this.props.app.nodes.data);this._network.setData({nodes:_nodes,edges:this.props.app.edges.data});this._network.redraw();}else{this._network.setData({nodes:this.props.app.nodes.data,edges:this.props.app.edges.data});this._network.redraw();}if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){}else{this._network.on('hoverNode',this.hoverNode);}this._network.on('blurNode',this.blurNode);}},{key:'filterNodes',value:function filterNodes(nodes){var result=[];var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=nodes[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var node=_step3.value;var connected_nodes=this._network.getConnectedNodes(node.id);if(connected_nodes.length>0){result.push(node);}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}this.setState({nodes:result});return result;}},{key:'hoverNode',value:function hoverNode(params){this.showHoverPanel(params);}},{key:'blurNode',value:function blurNode(){this.setState({showHover:false});}},{key:'showHoverPanel',value:function showHoverPanel(params){var id=params.node;var app=this.props.app;var nodes=app.nodes.data;var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=nodes[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var node=_step4.value;if(node.id===id){this.setState({selectedNode:node,showHover:true,x:params.event.clientX,y:params.event.clientY});}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}},{key:'showDetailPanel',value:function showDetailPanel(id,type){if(id){window.nodeorlink=true;}this.setState({htmlopened:false});var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["f" /* infoDrawerStatusChange */])(false));var app=this.props.app;var nodes=app.nodes.data;var edges=app.edges.data;if(type===0){var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=nodes[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var node=_step5.value;if(node.id===id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["g" /* setDetail */])({nodeid:id,edgeid:0}));this.props.history.push('/node/'+id);}}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}else if(type===1){var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=edges[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var edge=_step6.value;if(edge.id===id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["g" /* setDetail */])({nodeid:edge.from,edgeid:id}));this.props.history.push('/edge/'+id);}}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["g" /* setDetail */])({nodeid:0,edgeid:0}));this.props.history.push('/');}}},{key:'getNetwork',value:function getNetwork(network){this._network=network;}},{key:'animateFit',value:function animateFit(){var network=this._network;var options={offset:{x:0,y:0},duration:1000,easingFunction:'linear'};network.fit({animation:options});}},{key:'scaleIn',value:function scaleIn(){var network=this._network;var scale=network.getScale();var options={position:{x:0,y:0},scale:scale*1.5,offset:{x:0,y:0},animation:true};network.moveTo(options);}},{key:'scaleOut',value:function scaleOut(){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["c" /* getEdges */])());var network=this._network;var scale=network.getScale();var options={position:{x:0,y:0},scale:scale/1.5,offset:{x:0,y:0},animation:true};network.moveTo(options);}},{key:'handleMenuClick',value:function handleMenuClick(){this.setState({menuopened:!this.state.menuopened});}},{key:'handleSidebarClick',value:function handleSidebarClick(){var tag=this.props.app.tag;if(tag){this.setState({htmlopened:!this.state.htmlopened});}}},{key:'handleTagClick',value:function handleTagClick(tag){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["d" /* getNodes */])(tag.tag));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["f" /* infoDrawerStatusChange */])(true));this.props.history.push('/tags/'+tag.tag);}},{key:'handleFilter',value:function handleFilter(tag){var _props2=this.props,app=_props2.app,dispatch=_props2.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["d" /* getNodes */])(tag));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["a" /* closeIntro */])());this.props.history.push('/tags/'+tag);}},{key:'htmlopen',value:function htmlopen(selectedTag){var app=this.props.app;if(selectedTag==='qatar-charity'){if(app.infodraweropened&&!app.isfirstvisit){return true;}return false;}return app.infodraweropened;}},{key:'gotoHome',value:function gotoHome(){var dispatch=this.props.dispatch;this.props.history.push('/');dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["f" /* infoDrawerStatusChange */])(false));}},{key:'handleFlagClick',value:function handleFlagClick(country){var app=this.props.app;var nodes=app.nodes.data;var selected_nodes=[];if(country==='brotherhood'){var findNodes=this._network.findNode(48);if(findNodes.length>0){selected_nodes.push(48);}}else{var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=nodes[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var node=_step7.value;var node_country=node.country+'';node_country=node_country.toLowerCase();if(node_country===country.toLowerCase()){var _findNodes=this._network.findNode(node.id);if(_findNodes.length>0){selected_nodes.push(node.id);}}}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}}var network=this._network;network.selectNodes(selected_nodes,true);}},{key:'handleMouseOut',value:function handleMouseOut(){this._network.selectNodes([],true);}},{key:'onSelectNode',value:function onSelectNode(nodeid){var _props3=this.props,app=_props3.app,dispatch=_props3.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(true));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["f" /* infoDrawerStatusChange */])(false));var nodes=app.allnodes.data;var network=this._network;network.setData({nodes:nodes,edges:app.edges.data});var _iteratorNormalCompletion8=true;var _didIteratorError8=false;var _iteratorError8=undefined;try{for(var _iterator8=nodes[Symbol.iterator](),_step8;!(_iteratorNormalCompletion8=(_step8=_iterator8.next()).done);_iteratorNormalCompletion8=true){var node=_step8.value;if(node.id===nodeid){var filtered_nodes=[];var connected_nodes=network.getConnectedNodes(nodeid);var _iteratorNormalCompletion9=true;var _didIteratorError9=false;var _iteratorError9=undefined;try{for(var _iterator9=nodes[Symbol.iterator](),_step9;!(_iteratorNormalCompletion9=(_step9=_iterator9.next()).done);_iteratorNormalCompletion9=true){var nodeitem=_step9.value;var node_id=nodeitem.id;if(connected_nodes.indexOf(node_id)!==-1||nodeid===node_id){filtered_nodes.push(nodeitem);}}}catch(err){_didIteratorError9=true;_iteratorError9=err;}finally{try{if(!_iteratorNormalCompletion9&&_iterator9.return){_iterator9.return();}}finally{if(_didIteratorError9){throw _iteratorError9;}}}if(filtered_nodes.length>0){network.setData({nodes:filtered_nodes,edges:app.edges.data});network.selectNodes([nodeid],true);dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["h" /* setNodes */])({filtered_nodes:filtered_nodes}));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["g" /* setDetail */])({nodeid:nodeid,edgeid:0}));this.props.history.push('/node/'+nodeid);}}}}catch(err){_didIteratorError8=true;_iteratorError8=err;}finally{try{if(!_iteratorNormalCompletion8&&_iterator8.return){_iterator8.return();}}finally{if(_didIteratorError8){throw _iteratorError8;}}}}},{key:'handleHTMLClick',value:function handleHTMLClick(event){event.preventDefault();var el=event.target;var url=parse(el.href);if(el.href){if(location.origin===url.origin){this.props.history.push(url.pathname);var split=url.pathname;split=split.split('/');if(split[1]==='tags'){this.handleFilter(split[2]);}else{var nodeid=split[split.length-1];this._network.selectNodes([nodeid],true);}}else{window.open(el.href,'_new');}}}},{key:'onClick',value:function onClick(){if(window.nodeorlink){window.nodeorlink=false;}else{var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["f" /* infoDrawerStatusChange */])(false));}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,app=_props4.app,dispatch=_props4.dispatch;var nodes=app.nodes.data;var edges=app.edges.data;var selectedTag=app.tag;function isEmpty(obj){for(var key in obj){if(obj.hasOwnProperty(key)){return false;}}return true;}//Graph
var graph={nodes:nodes,edges:edges};var selectedNode={};var selectedEdge={};var selectInfo=app.info.data;if(!isEmpty(selectInfo)){var _iteratorNormalCompletion10=true;var _didIteratorError10=false;var _iteratorError10=undefined;try{for(var _iterator10=nodes[Symbol.iterator](),_step10;!(_iteratorNormalCompletion10=(_step10=_iterator10.next()).done);_iteratorNormalCompletion10=true){var node=_step10.value;if(node.id+''===selectInfo.nodeid+''){selectedNode=node;}}}catch(err){_didIteratorError10=true;_iteratorError10=err;}finally{try{if(!_iteratorNormalCompletion10&&_iterator10.return){_iterator10.return();}}finally{if(_didIteratorError10){throw _iteratorError10;}}}var _iteratorNormalCompletion11=true;var _didIteratorError11=false;var _iteratorError11=undefined;try{for(var _iterator11=edges[Symbol.iterator](),_step11;!(_iteratorNormalCompletion11=(_step11=_iterator11.next()).done);_iteratorNormalCompletion11=true){var edge=_step11.value;if(edge.id+''===selectInfo.edgeid+''){selectedEdge=edge;}}}catch(err){_didIteratorError11=true;_iteratorError11=err;}finally{try{if(!_iteratorNormalCompletion11&&_iterator11.return){_iterator11.return();}}finally{if(_didIteratorError11){throw _iteratorError11;}}}}return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_Header__["a" /* default */],{gotoHome:function gotoHome(){return _this2.gotoHome();},handleFilterClick:function handleFilterClick(tag){return _this2.handleFilter(tag);},onSelectNode:function onSelectNode(nodeid){return _this2.onSelectNode(nodeid);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_RightMenu__["a" /* default */],{handleItemClick:function handleItemClick(flag){return _this2.handleFlagClick(flag);},handleMouseOut:function handleMouseOut(){return _this2.handleMouseOut();}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_Menu__["a" /* default */],{isopen:this.state.menuopened,handleCloseClick:function handleCloseClick(){return _this2.setState({menuopened:false});},handleFilterClick:function handleFilterClick(tag){return _this2.handleFilter(tag);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_LoadHtml__["a" /* default */],{isopen:this.htmlopen(selectedTag),handleCloseClick:function handleCloseClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["f" /* infoDrawerStatusChange */])(false));},tag:selectedTag,handleHTMLClick:function handleHTMLClick(event){return _this2.handleHTMLClick(event);}}),(!isEmpty(selectedNode)||!isEmpty(selectedEdge))&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Drawer___default.a,{open:app.draweropened,className:'left-drawer',type:'persistent'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null,!isEmpty(selectedEdge)?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_EdgeDetail__["a" /* default */],{handleCloseDetailClick:function handleCloseDetailClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(false));},edge:selectedEdge,nodes:nodes}):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_NodeDetail__["a" /* default */],{handleCloseDetailClick:function handleCloseDetailClick(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_17_actions__["b" /* drawerStatusChange */])(false));},handleTagClick:function handleTagClick(tag){return _this2.handleTagClick(tag);},node:selectedNode}))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'right-panel'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{className:'zoom-panel'},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_ZoomControl__["a" /* default */],{handleInClick:this.scaleIn,handleOutClick:this.scaleOut,handleFitClick:this.animateFit})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',{onClick:this.onClick},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_graph_vis___default.a,{graph:graph,options:this.state.options,events:this.events,style:{height:'100vh'},getNetwork:function getNetwork(network){return _this2.getNetwork(network);}}))),this.state.showHover?__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_Hover__["a" /* default */],{handleCloseDetailClick:function handleCloseDetailClick(){return _this2.setState({showHover:false});},node:this.state.selectedNode,top:this.state.y,left:this.state.x}):__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div',null));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent);/* istanbul ignore next */Home.propTypes={app:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,dispatch:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};function mapStateToProps(state){return{app:state.app};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps)(Home));

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _Modal = __webpack_require__(370);

var _Modal2 = _interopRequireDefault(_Modal);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Slide = __webpack_require__(897);

var _Slide2 = _interopRequireDefault(_Slide);

var _Paper = __webpack_require__(112);

var _Paper2 = _interopRequireDefault(_Paper);

var _helpers = __webpack_require__(81);

var _transitions = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSlideDirection(anchor) {
  if (anchor === 'left') {
    return 'right';
  } else if (anchor === 'right') {
    return 'left';
  } else if (anchor === 'top') {
    return 'down';
  }

  // (anchor === 'bottom')
  return 'up';
} // @inheritedComponent Modal

var styles = exports.styles = function styles(theme) {
  return {
    docked: {
      flex: '0 0 auto'
    },
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch', // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      '&:focus': {
        outline: 'none'
      }
    },
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },
    paperAnchorDockedLeft: {
      borderRight: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedTop: {
      borderBottom: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedRight: {
      borderLeft: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedBottom: {
      borderTop: '1px solid ' + theme.palette.divider
    },
    modal: {} // Just here so people can override the style.
  };
};

var Drawer = function (_React$Component) {
  (0, _inherits3.default)(Drawer, _React$Component);

  function Drawer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Drawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // Let's assume that the Drawer will always be rendered on user space.
      // We use that state is order to skip the appear transition during the
      // initial mount of the component.
      firstMount: true
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Drawer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({
        firstMount: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          anchorProp = _props.anchor,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          elevation = _props.elevation,
          ModalProps = _props.ModalProps,
          onClose = _props.onClose,
          open = _props.open,
          SlideProps = _props.SlideProps,
          theme = _props.theme,
          transitionDuration = _props.transitionDuration,
          type = _props.type,
          other = (0, _objectWithoutProperties3.default)(_props, ['anchor', 'children', 'classes', 'className', 'elevation', 'ModalProps', 'onClose', 'open', 'SlideProps', 'theme', 'transitionDuration', 'type']);


      var anchor = anchorProp;
      if (theme.direction === 'rtl' && ['left', 'right'].includes(anchor)) {
        anchor = anchor === 'left' ? 'right' : 'left';
      }

      var drawer = _react2.default.createElement(
        _Paper2.default,
        {
          elevation: type === 'temporary' ? elevation : 0,
          square: true,
          className: (0, _classnames2.default)(classes.paper, classes['paperAnchor' + (0, _helpers.capitalizeFirstLetter)(anchor)], (0, _defineProperty3.default)({}, classes['paperAnchorDocked' + (0, _helpers.capitalizeFirstLetter)(anchor)], type !== 'temporary'))
        },
        children
      );

      if (type === 'permanent') {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.docked, className) }, other),
          drawer
        );
      }

      var slidingDrawer = _react2.default.createElement(
        _Slide2.default,
        (0, _extends3.default)({
          'in': open,
          direction: getSlideDirection(anchor),
          timeout: transitionDuration,
          appear: !this.state.firstMount
        }, SlideProps),
        drawer
      );

      if (type === 'persistent') {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.docked, className) }, other),
          slidingDrawer
        );
      }

      // type === temporary
      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({
          BackdropProps: {
            transitionDuration: transitionDuration
          },
          className: (0, _classnames2.default)(classes.modal, className),
          open: open,
          onClose: onClose
        }, other, ModalProps),
        slidingDrawer
      );
    }
  }]);
  return Drawer;
}(_react2.default.Component);

Drawer.propTypes =  false ? {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes2.default.oneOf(['left', 'top', 'right', 'bottom']),
  /**
   * The contents of the drawer.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes2.default.number,
  /**
   * Properties applied to the `Modal` element.
   */
  ModalProps: _propTypes2.default.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes2.default.bool,
  /**
   * Properties applied to the `Slide` element.
   */
  SlideProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })]),
  /**
   * The type of drawer.
   */
  type: _propTypes2.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};

Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: { enter: _transitions.duration.enteringScreen, exit: _transitions.duration.leavingScreen },
  type: 'temporary' // Mobile first.
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDrawer', flip: false, withTheme: true })(Drawer);

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(817);
module.exports = __webpack_require__(23).Object.getPrototypeOf;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(88);
var $getPrototypeOf = __webpack_require__(350);

__webpack_require__(369)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(35);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _keycode = __webpack_require__(109);

var _keycode2 = _interopRequireDefault(_keycode);

var _activeElement = __webpack_require__(371);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(150);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(151);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _ownerDocument = __webpack_require__(90);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _RefHolder = __webpack_require__(819);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _Portal = __webpack_require__(820);

var _Portal2 = _interopRequireDefault(_Portal);

var _addEventListener = __webpack_require__(372);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _helpers = __webpack_require__(81);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ModalManager = __webpack_require__(389);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Backdrop = __webpack_require__(392);

var _Backdrop2 = _interopRequireDefault(_Backdrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
} // @inheritedComponent Portal

function getOwnerDocument(element) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      width: '100%',
      height: '100%',
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      top: 0,
      left: 0
    },
    hidden: {
      visibility: 'hidden'
    }
  };
};

var Modal = function (_React$Component) {
  (0, _inherits3.default)(Modal, _React$Component);

  function Modal(props, context) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props, context));

    _this.dialogNode = null;
    _this.modalNode = null;
    _this.mounted = false;
    _this.mountNode = null;

    _this.handleRendered = function () {
      _this.autoFocus();

      if (_this.props.onRendered) {
        _this.props.onRendered();
      }
    };

    _this.handleOpen = function () {
      var doc = getOwnerDocument(_this);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add(_this, container);
      _this.onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this.handleDocumentKeyDown);
      _this.onFocusinListener = (0, _addEventListener2.default)(document, 'focus', _this.enforceFocus, true);
    };

    _this.handleClose = function () {
      _this.props.manager.remove(_this);
      _this.onDocumentKeydownListener.remove();
      _this.onFocusinListener.remove();
      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({ exited: true });
      _this.handleClose();
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (!_this.isTopModal() || (0, _keycode2.default)(event) !== 'esc') {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.checkForFocus = function () {
      if (_inDOM2.default) {
        _this.lastFocus = (0, _activeElement2.default)();
      }
    };

    _this.enforceFocus = function () {
      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
        return;
      }

      var dialogElement = _this.getDialogElement();
      var currentActiveElement = (0, _activeElement2.default)(getOwnerDocument(_this));

      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
        dialogElement.focus();
      }
    };

    _this.state = {
      exited: !_this.props.open
    };
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open) {
        this.setState({ exited: false });
      } else if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (!this.props.open && nextProps.open) {
        this.checkForFocus();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: 'getDialogElement',
    value: function getDialogElement() {
      return _reactDom2.default.findDOMNode(this.dialogNode);
    }
  }, {
    key: 'autoFocus',
    value: function autoFocus() {
      if (this.props.disableAutoFocus) {
        return;
      }

      var dialogElement = this.getDialogElement();
      var currentActiveElement = (0, _activeElement2.default)(getOwnerDocument(this));

      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!dialogElement.hasAttribute('tabIndex')) {
           false ? (0, _warning2.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          dialogElement.setAttribute('tabIndex', -1);
        }

        dialogElement.focus();
      }
    }
  }, {
    key: 'restoreLastFocus',
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus) {
        return;
      }

      if (this.lastFocus) {
        this.lastFocus.focus();
        this.lastFocus = null;
      }
    }
  }, {
    key: 'isTopModal',
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          BackdropComponent = _props.BackdropComponent,
          BackdropProps = _props.BackdropProps,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          container = _props.container,
          disableAutoFocus = _props.disableAutoFocus,
          disableBackdropClick = _props.disableBackdropClick,
          disableEnforceFocus = _props.disableEnforceFocus,
          disableEscapeKeyDown = _props.disableEscapeKeyDown,
          disableRestoreFocus = _props.disableRestoreFocus,
          hideBackdrop = _props.hideBackdrop,
          keepMounted = _props.keepMounted,
          onBackdropClick = _props.onBackdropClick,
          onClose = _props.onClose,
          onEscapeKeyDown = _props.onEscapeKeyDown,
          onRendered = _props.onRendered,
          open = _props.open,
          manager = _props.manager,
          other = (0, _objectWithoutProperties3.default)(_props, ['BackdropComponent', 'BackdropProps', 'children', 'classes', 'className', 'container', 'disableAutoFocus', 'disableBackdropClick', 'disableEnforceFocus', 'disableEscapeKeyDown', 'disableRestoreFocus', 'hideBackdrop', 'keepMounted', 'onBackdropClick', 'onClose', 'onEscapeKeyDown', 'onRendered', 'open', 'manager']);
      var exited = this.state.exited;

      var hasTransition = getHasTransition(this.props);
      var childProps = {};

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      }

      // It's a Transition like component
      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react2.default.createElement(
        _Portal2.default,
        {
          ref: function ref(node) {
            _this2.mountNode = node ? node.getMountNode() : node;
          },
          container: container,
          onRendered: this.handleRendered
        },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({
            ref: function ref(node) {
              _this2.modalNode = node;
            },
            className: (0, _classnames2.default)(classes.root, className, (0, _defineProperty3.default)({}, classes.hidden, exited))
          }, other),
          hideBackdrop ? null : _react2.default.createElement(BackdropComponent, (0, _extends3.default)({ open: open, onClick: this.handleBackdropClick }, BackdropProps)),
          _react2.default.createElement(
            _RefHolder2.default,
            {
              ref: function ref(node) {
                _this2.dialogNode = node;
              }
            },
            _react2.default.cloneElement(children, childProps)
          )
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. Useful for custom backdrop rendering.
   */
  BackdropComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the `Backdrop` element.
   */
  BackdropProps: _propTypes2.default.object,
  /**
   * A single child content element.
   */
  children: _propTypes2.default.element,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes2.default.bool,
  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes2.default.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes2.default.bool,
  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes2.default.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes2.default.bool,
  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes2.default.bool,
  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes2.default.bool,
  /**
   * A modal manager used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container.
   */
  manager: _propTypes2.default.object.isRequired,
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes2.default.func,
  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes2.default.func,
  /**
   * If `true`, the modal is open.
   */
  open: _propTypes2.default.bool.isRequired
} : {};

Modal.defaultProps = {
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager2.default(),
  BackdropComponent: _Backdrop2.default
};

exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiModal' })(Modal);

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 *
 * Internal helper component to allow attaching a ref to a
 * child element that may not accept refs (functional component).
 */
var RefHolder = function (_React$Component) {
  (0, _inherits3.default)(RefHolder, _React$Component);

  function RefHolder() {
    (0, _classCallCheck3.default)(this, RefHolder);
    return (0, _possibleConstructorReturn3.default)(this, (RefHolder.__proto__ || (0, _getPrototypeOf2.default)(RefHolder)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefHolder, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes =  false ? {
  children: _propTypes2.default.node
} : {};

exports.default = RefHolder;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = __webpack_require__(35);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Portal = __webpack_require__(821);

var _Portal2 = _interopRequireDefault(_Portal);

var _LegacyPortal = __webpack_require__(824);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reactDom2.default.createPortal ? _Portal2.default : _LegacyPortal2.default;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(35);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ownerDocument = __webpack_require__(90);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _exactProp = __webpack_require__(239);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
}

/**
 * This component shares many concepts with
 * [react-overlays](https://react-bootstrap.github.io/react-overlays/#portals)
 * But has been fork in order to fix some bugs, reduce the number of dependencies
 * and take the control of our destiny.
 */

var Portal = function (_React$Component) {
  (0, _inherits3.default)(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Portal.__proto__ || (0, _getPrototypeOf2.default)(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
      return _this.mountNode;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setContainer(this.props.container);
      this.forceUpdate(this.props.onRendered);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.container !== this.props.container) {
        this.setContainer(nextProps.container);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: 'setContainer',
    value: function setContainer(container) {
      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }

    /**
     * @public
     */

  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return this.mountNode ? _reactDom2.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react2.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it's using the body of the the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes2.default.func
} : {};

Portal.propTypes =  false ? (0, _exactProp2.default)(Portal.propTypes, 'Portal') : {};

exports.default = Portal;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(823);
module.exports = __webpack_require__(23).Object.keys;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(88);
var $keys = __webpack_require__(99);

__webpack_require__(369)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(35);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ownerDocument = __webpack_require__(90);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _exactProp = __webpack_require__(239);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
}

/**
 * @ignore - internal component.
 *
 * This module will soon be gone. We should drop it as soon as React@15.x support stop.
 */

var LegacyPortal = function (_React$Component) {
  (0, _inherits3.default)(LegacyPortal, _React$Component);

  function LegacyPortal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LegacyPortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LegacyPortal.__proto__ || (0, _getPrototypeOf2.default)(LegacyPortal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
      return _this.mountNode;
    }, _this.mountOverlayTarget = function () {
      if (!_this.overlayTarget) {
        _this.overlayTarget = document.createElement('div');
        _this.mountNode = getContainer(_this.props.container, getOwnerDocument(_this).body);
        _this.mountNode.appendChild(_this.overlayTarget);
      }
    }, _this.unmountOverlayTarget = function () {
      if (_this.overlayTarget) {
        _this.mountNode.removeChild(_this.overlayTarget);
        _this.overlayTarget = null;
      }
      _this.mountNode = null;
    }, _this.unrenderOverlay = function () {
      if (_this.overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this.overlayTarget);
        _this.overlayInstance = null;
      }
    }, _this.renderOverlay = function () {
      var overlay = _this.props.children;
      _this.mountOverlayTarget();
      var initialRender = !_this.overlayInstance;
      _this.overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this.overlayTarget, function () {
        if (initialRender && _this.props.onRendered) {
          _this.props.onRendered();
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LegacyPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.renderOverlay();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.overlayTarget && nextProps.container !== this.props.container) {
        this.mountNode.removeChild(this.overlayTarget);
        this.mountNode = getContainer(nextProps.container, getOwnerDocument(this).body);
        this.mountNode.appendChild(this.overlayTarget);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderOverlay();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this.unrenderOverlay();
      this.unmountOverlayTarget();
    }

    /**
     * @public
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return LegacyPortal;
}(_react2.default.Component);

LegacyPortal.propTypes =  false ? {
  children: _propTypes2.default.element.isRequired,
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  onRendered: _propTypes2.default.func
} : {};

LegacyPortal.propTypes =  false ? (0, _exactProp2.default)(LegacyPortal.propTypes, 'LegacyPortal') : {};

exports.default = LegacyPortal;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(826), __esModule: true };

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
__webpack_require__(144);
__webpack_require__(227);
__webpack_require__(827);
__webpack_require__(833);
__webpack_require__(836);
__webpack_require__(838);
module.exports = __webpack_require__(23).Map;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(828);
var validate = __webpack_require__(373);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(829)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(45).f;
var create = __webpack_require__(146);
var redefineAll = __webpack_require__(231);
var ctx = __webpack_require__(56);
var anInstance = __webpack_require__(229);
var forOf = __webpack_require__(107);
var $iterDefine = __webpack_require__(226);
var step = __webpack_require__(351);
var setSpecies = __webpack_require__(359);
var DESCRIPTORS = __webpack_require__(52);
var fastKey = __webpack_require__(233).fastKey;
var validate = __webpack_require__(373);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(28);
var $export = __webpack_require__(24);
var meta = __webpack_require__(233);
var fails = __webpack_require__(75);
var hide = __webpack_require__(61);
var redefineAll = __webpack_require__(231);
var forOf = __webpack_require__(107);
var anInstance = __webpack_require__(229);
var isObject = __webpack_require__(46);
var setToStringTag = __webpack_require__(106);
var dP = __webpack_require__(45).f;
var each = __webpack_require__(830)(0);
var DESCRIPTORS = __webpack_require__(52);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(56);
var IObject = __webpack_require__(210);
var toObject = __webpack_require__(88);
var toLength = __webpack_require__(137);
var asc = __webpack_require__(831);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(832);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(46);
var isArray = __webpack_require__(361);
var SPECIES = __webpack_require__(29)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(24);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(834)('Map') });


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(228);
var from = __webpack_require__(835);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(107);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(837)('Map');


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(24);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(839)('Map');


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(24);
var aFunction = __webpack_require__(97);
var ctx = __webpack_require__(56);
var forOf = __webpack_require__(107);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(841), __esModule: true };

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(842);
module.exports = -0x1fffffffffffff;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(24);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(2);

var _ns = __webpack_require__(375);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(844);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(2);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Extracts a styles object with only props that contain function values.
 */
exports['default'] = function (styles) {
  // eslint-disable-next-line no-shadow
  function extract(styles) {
    var to = null;

    for (var key in styles) {
      var value = styles[key];
      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

      if (type === 'function') {
        if (!to) to = {};
        to[key] = value;
      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
        var extracted = extract(value);
        if (extracted) {
          if (!to) to = {};
          to[key] = extracted;
        }
      }
    }

    return to;
  }

  return extract(styles);
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, 'SheetsManager: can\'t find sheet to unmanage');
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(378);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(155);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(381);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(851);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(852);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(858);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(859);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(241);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(91);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(380);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(154);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(861);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(862);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.5.1";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(853);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(854);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(855);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(856);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(857);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
exports['default'] = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new classes[key](name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(110);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(110);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(240);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(240);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(91);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(154);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(378);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(110);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(91);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _kebabCase = __webpack_require__(860);

var _kebabCase2 = _interopRequireDefault(_kebabCase);

var _createRule = __webpack_require__(154);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();
var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[(0, _kebabCase2['default'])(prop)] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var regExp = /([A-Z])/g;
var replace = function replace(str) {
  return "-" + str.toLowerCase();
};

exports["default"] = function (str) {
  return str.replace(regExp, replace);
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(241);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(91);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(153);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Get a style property.
 */
function getStyle(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setStyle(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = function () {
  var head = void 0;
  return function () {
    if (!head) head = document.head || document.getElementsByTagName('head')[0];
    return head;
  };
}();

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getStyle = getStyle;
    this.setStyle = setStyle;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.type = 'text/css';
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    // eslint-disable-next-line no-underscore-dangle
    var nonce = global.__webpack_nonce__;
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setStyle',
    value: function setStyle() {
      return true;
    }
  }, {
    key: 'getStyle',
    value: function getStyle() {
      return '';
    }
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(376);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = camelCase;
var regExp = /([A-Z])/g;

/**
 * Replace a string passed from String#replace.
 * @param {String} str
 * @return {String}
 */
function replace(str) {
  return "-" + str.toLowerCase();
}

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[prop.replace(regExp, replace)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(867);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(869);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(242);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(870);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(872);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(155);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(242);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(871);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(155);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(242);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createTypography;

var _deepmerge = __webpack_require__(156);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === undefined ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === undefined ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === undefined ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === undefined ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === undefined ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === undefined ? 16 : _ref$htmlFontSize,
      other = (0, _objectWithoutProperties3.default)(_ref, ['fontFamily', 'fontSize', 'fontWeightLight', 'fontWeightRegular', 'fontWeightMedium', 'htmlFontSize']);

  function pxToRem(value) {
    return value / htmlFontSize + 'rem';
  }

  return (0, _deepmerge2.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    display4: {
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: round(128 / 112) + 'em',
      marginLeft: '-.06em',
      color: palette.text.secondary
    },
    display3: {
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: round(73 / 56) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    display2: {
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(48 / 45) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    display1: {
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(41 / 34) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    headline: {
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(32.5 / 24) + 'em',
      color: palette.text.primary
    },
    title: {
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: round(24.5 / 21) + 'em',
      color: palette.text.primary
    },
    subheading: {
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(24 / 16) + 'em',
      color: palette.text.primary
    },
    body2: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: round(24 / 14) + 'em',
      color: palette.text.primary
    },
    body1: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(20.5 / 14) + 'em',
      color: palette.text.primary
    },
    caption: {
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(16.5 / 12) + 'em',
      color: palette.text.secondary
    },
    button: {
      fontSize: pxToRem(fontSize),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily
    }
  }, other, {
    clone: false // No need to clone deep
  });
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keys = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createBreakpoints;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = exports.keys = ['xs', 'sm', 'md', 'lg', 'xl'];

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === undefined ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === undefined ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === undefined ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties3.default)(breakpoints, ['values', 'unit', 'step']);


  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return '@media (min-width:' + value + unit + ')';
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return '@media (max-width:' + (value - step / 100) + unit + ')';
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return '@media (min-width:' + values[start] + unit + ') and ' + ('(max-width:' + (values[keys[endIndex]] - step / 100) + unit + ')');
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends3.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dark = exports.light = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createPalette;

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _deepmerge = __webpack_require__(156);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _indigo = __webpack_require__(383);

var _indigo2 = _interopRequireDefault(_indigo);

var _pink = __webpack_require__(384);

var _pink2 = _interopRequireDefault(_pink);

var _grey = __webpack_require__(385);

var _grey2 = _interopRequireDefault(_grey);

var _red = __webpack_require__(386);

var _red2 = _interopRequireDefault(_red);

var _common = __webpack_require__(387);

var _common2 = _interopRequireDefault(_common);

var _colorManipulator = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = exports.light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common2.default.white,
    default: _grey2.default[50],
    appBar: _grey2.default[100],
    chip: _grey2.default[300],
    avatar: _grey2.default[400]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.14)',
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};

var dark = exports.dark = {
  text: {
    primary: _common2.default.fullWhite,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey2.default[800],
    default: '#303030',
    appBar: _grey2.default[900],
    chip: _grey2.default[700],
    avatar: _grey2.default[600]
  },
  action: {
    active: _common2.default.fullWhite,
    hover: 'rgba(255, 255, 255, 0.14)',
    selected: 'rgba(255, 255, 255, 0.8)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === undefined ? {
    light: _indigo2.default[300],
    main: _indigo2.default[500],
    dark: _indigo2.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === undefined ? {
    light: _pink2.default.A200,
    main: _pink2.default.A400,
    dark: _pink2.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === undefined ? {
    main: _red2.default[500]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === undefined ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === undefined ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === undefined ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties3.default)(palette, ['primary', 'secondary', 'error', 'type', 'contrastThreshold', 'tonalOffset']);


  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(contrast >= 3, ['Material-UI: the contrast ratio of ' + contrast + ':1 for ' + contrastText + ' on ' + background, 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color, mainShade, lightShade, darkShade) {
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
  }

  augmentColor(primary, 500, 300, 700);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error, 500, 300, 700);

  var types = { dark: dark, light: light };

   false ? (0, _warning2.default)(types[type], 'Material-UI: the palette type `' + type + '` is not supported.') : void 0;

  var paletteOutput = (0, _deepmerge2.default)((0, _extends3.default)({
    // A collection of common colors.
    common: _common2.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey color.
    grey: _grey2.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset,
    // The light and dark type object.
    types: types
  }, types[type]), other, {
    clone: false // No need to clone deep
  });

  return paletteOutput;
}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(3);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = createMixins;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends4.default)({
    gutters: function gutters(styles) {
      return (0, _extends4.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty3.default)({}, breakpoints.up('sm'), (0, _extends4.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty3.default)(_toolbar, breakpoints.up('xs') + ' and (orientation: landscape)', {
      minHeight: 48
    }), (0, _defineProperty3.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return [(arguments.length <= 0 ? undefined : arguments[0]) + 'px ' + (arguments.length <= 1 ? undefined : arguments[1]) + 'px ' + (arguments.length <= 2 ? undefined : arguments[2]) + 'px ' + (arguments.length <= 3 ? undefined : arguments[3]) + 'px rgba(0, 0, 0, ' + shadowKeyUmbraOpacity + ')', (arguments.length <= 4 ? undefined : arguments[4]) + 'px ' + (arguments.length <= 5 ? undefined : arguments[5]) + 'px ' + (arguments.length <= 6 ? undefined : arguments[6]) + 'px ' + (arguments.length <= 7 ? undefined : arguments[7]) + 'px rgba(0, 0, 0, ' + shadowKeyPenumbraOpacity + ')', (arguments.length <= 8 ? undefined : arguments[8]) + 'px ' + (arguments.length <= 9 ? undefined : arguments[9]) + 'px ' + (arguments.length <= 10 ? undefined : arguments[10]) + 'px ' + (arguments.length <= 11 ? undefined : arguments[11]) + 'px rgba(0, 0, 0, ' + shadowAmbientShadowOpacity + ')'].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

exports.default = shadows;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(880), __esModule: true };

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(881);
module.exports = __webpack_require__(23).Number.isNaN;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(24);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

exports.default = zIndex;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/guidelines/layout/metrics-keylines.html#metrics-keylines-baseline-grids
  unit: 8
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(80);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _deepmerge = __webpack_require__(156);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!theme.overrides || !name || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends3.default)({}, styles);

    (0, _keys2.default)(overrides).forEach(function (key) {
       false ? (0, _warning2.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', 'Fix the `' + key + '` key of `theme.overrides.' + name + '`.'].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge2.default)(stylesWithOverrides[key], overrides[key]);
    });

    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

exports.default = getStylesCreator;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(390);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(887);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(889);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(890);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(891);

var _isTransform = __webpack_require__(892);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(888);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(390);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(151);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(894);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(90);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

// Do we have a scroll bar?
function isOverflowing(container) {
  var doc = (0, _ownerDocument2.default)(container);
  var win = (0, _isWindow2.default)(doc);

  /* istanbul ignore next */
  if (!win && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  }

  // Takes in account potential non zero margin on the body.
  var style = window.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);

  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, callback) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign
  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(158);

var _Transition2 = _interopRequireDefault(_Transition);

var _transitions = __webpack_require__(157);

var _withTheme = __webpack_require__(159);

var _withTheme2 = _interopRequireDefault(_withTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reflow = function reflow(node) {
  return node.scrollTop;
};

/**
 * The Fade transition is used by the Modal component.
 * It's using [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
// @inheritedComponent Transition

var Fade = function (_React$Component) {
  (0, _inherits3.default)(Fade, _React$Component);

  function Fade() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Fade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Fade.__proto__ || (0, _getPrototypeOf2.default)(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mounted: false
    }, _this.handleEnter = function (node) {
      node.style.opacity = '0';
      reflow(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;

      node.style.transition = theme.transitions.create('opacity', {
        duration: typeof timeout === 'number' ? timeout : timeout.enter
      });
      node.style.webkitTransition = theme.transitions.create('opacity', {
        duration: typeof timeout === 'number' ? timeout : timeout.enter
      });
      node.style.opacity = '1';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;

      node.style.transition = theme.transitions.create('opacity', {
        duration: typeof timeout === 'number' ? timeout : timeout.exit
      });
      node.style.webkitTransition = theme.transitions.create('opacity', {
        duration: typeof timeout === 'number' ? timeout : timeout.exit
      });
      node.style.opacity = '0';

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Fade, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ mounted: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          appear = _props.appear,
          children = _props.children,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['appear', 'children', 'onEnter', 'onEntering', 'onExit', 'style', 'theme']);


      var style = {};

      // For server side rendering.
      if (!this.props.in && !this.state.mounted && appear) {
        style.opacity = '0';
      }

      style = (0, _extends3.default)({}, style, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({
          appear: appear,
          style: style,
          onEnter: this.handleEnter,
          onEntering: this.handleEntering,
          onExit: this.handleExit
        }, other),
        children
      );
    }
  }]);
  return Fade;
}(_react2.default.Component);

Fade.propTypes =  false ? {
  /**
   * @ignore
   */
  appear: _propTypes2.default.bool,
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Fade.defaultProps = {
  appear: true,
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withTheme2.default)()(Fade);

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.setTranslateValue = setTranslateValue;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _reactEventListener = __webpack_require__(246);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(247);

var _debounce2 = _interopRequireDefault(_debounce);

var _Transition = __webpack_require__(158);

var _Transition2 = _interopRequireDefault(_Transition);

var _withTheme = __webpack_require__(159);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _transitions = __webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Transition

var GUTTER = 24;

// Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`
function getTranslateValue(props, node) {
  var direction = props.direction;

  var rect = node.getBoundingClientRect();

  var transform = void 0;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return 'translateX(100vw) translateX(-' + (rect.left - offsetX) + 'px)';
  } else if (direction === 'right') {
    return 'translateX(-' + (rect.left + rect.width + GUTTER - offsetX) + 'px)';
  } else if (direction === 'up') {
    return 'translateY(100vh) translateY(-' + (rect.top - offsetY) + 'px)';
  }

  // direction === 'down
  return 'translate3d(0, ' + (0 - (rect.top + rect.height)) + 'px, 0)';
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.transform = transform;
    node.style.webkitTransform = transform;
  }
}

var reflow = function reflow(node) {
  return node.scrollTop;
};

var Slide = function (_React$Component) {
  (0, _inherits3.default)(Slide, _React$Component);

  function Slide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Slide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mounted: false
    }, _this.transition = null, _this.handleResize = (0, _debounce2.default)(function () {
      // Skip configuration where the position is screen size invariant.
      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
        return;
      }

      var node = (0, _reactDom.findDOMNode)(_this.transition);
      if (node instanceof HTMLElement) {
        setTranslateValue(_this.props, node);
      }
    }, 166), _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      reflow(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;

      node.style.transition = theme.transitions.create('transform', {
        duration: typeof timeout === 'number' ? timeout : timeout.enter,
        easing: theme.transitions.easing.easeOut
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
        duration: typeof timeout === 'number' ? timeout : timeout.enter,
        easing: theme.transitions.easing.easeOut
      });
      node.style.transform = 'translate3d(0, 0, 0)';
      node.style.webkitTransform = 'translate3d(0, 0, 0)';
      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;

      node.style.transition = theme.transitions.create('transform', {
        duration: typeof timeout === 'number' ? timeout : timeout.exit,
        easing: theme.transitions.easing.sharp
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
        duration: typeof timeout === 'number' ? timeout : timeout.exit,
        easing: theme.transitions.easing.sharp
      });
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.transition = '';
      node.style.webkitTransition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Slide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.
      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var element = (0, _reactDom.findDOMNode)(this.transition);
      if (element instanceof HTMLElement) {
        element.style.visibility = 'inherit';
        setTranslateValue(this.props, element);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExited = _props.onExited,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onEntering', 'onExit', 'onExited', 'style', 'theme']);


      var style = {};

      // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.
      if (!this.props.in && !this.state.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _extends3.default)({}, style, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _reactEventListener2.default,
        { target: 'window', onResize: this.handleResize },
        _react2.default.createElement(
          _Transition2.default,
          (0, _extends3.default)({
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onExit: this.handleExit,
            onExited: this.handleExited,
            appear: true,
            style: style,
            ref: function ref(node) {
              _this2.transition = node;
            }
          }, other),
          children
        )
      );
    }
  }]);
  return Slide;
}(_react2.default.Component);

Slide.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Slide.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withTheme2.default)()(Slide);

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passiveOption = undefined;

var _defineProperty = __webpack_require__(235);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defineProperty(object, property, attr) {
  return (0, _defineProperty2.default)(object, property, attr);
}

// Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
var passiveOption = exports.passiveOption = function () {
  var cache = null;

  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {
      //
    }

    cache = supportsPassiveOption;

    return supportsPassiveOption;
  }();
}();

exports.default = {};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(26);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 901 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var shadows = {};
  theme.shadows.forEach(function (shadow, index) {
    shadows['shadow' + index] = {
      boxShadow: shadow
    };
  });

  return (0, _extends3.default)({
    root: {
      backgroundColor: theme.palette.background.paper
    },
    rounded: {
      borderRadius: 2
    }
  }, shadows);
};

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'square', 'elevation']);


   false ? (0, _warning2.default)(elevation >= 0 && elevation < 25, 'Material-UI: this elevation `' + elevation + '` is not implemented.') : void 0;

  var className = (0, _classnames2.default)(classes.root, classes['shadow' + (elevation >= 0 ? elevation : 0)], (0, _defineProperty3.default)({}, classes.rounded, !square), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes2.default.number,
  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes2.default.bool
} : {};

Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPaper' })(Paper);

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _defaultsDeep = __webpack_require__(904);

var _defaultsDeep2 = _interopRequireDefault(_defaultsDeep);

var _isEqual = __webpack_require__(1022);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _differenceWith = __webpack_require__(1023);

var _differenceWith2 = _interopRequireDefault(_differenceWith);

var _vis = __webpack_require__(1027);

var _vis2 = _interopRequireDefault(_vis);

var _uuid = __webpack_require__(1028);

var _uuid2 = _interopRequireDefault(_uuid);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Graph = function (_Component) {
  _inherits(Graph, _Component);

  function Graph(props) {
    _classCallCheck(this, Graph);

    var _this = _possibleConstructorReturn(this, (Graph.__proto__ || Object.getPrototypeOf(Graph)).call(this, props));

    var identifier = props.identifier;

    _this.updateGraph = _this.updateGraph.bind(_this);
    _this.state = {
      identifier: identifier !== undefined ? identifier : _uuid2.default.v4()
    };
    return _this;
  }

  _createClass(Graph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.edges = new _vis2.default.DataSet();
      this.edges.add(this.props.graph.edges);
      this.nodes = new _vis2.default.DataSet();
      this.nodes.add(this.props.graph.nodes);
      this.updateGraph();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var nodesChange = !(0, _isEqual2.default)(this.props.graph.nodes, nextProps.graph.nodes);
      var edgesChange = !(0, _isEqual2.default)(this.props.graph.edges, nextProps.graph.edges);
      var optionsChange = !(0, _isEqual2.default)(this.props.options, nextProps.options);
      var eventsChange = !(0, _isEqual2.default)(this.props.events, nextProps.events);

      if (nodesChange) {
        var idIsEqual = function idIsEqual(n1, n2) {
          return n1.id === n2.id;
        };
        var nodesRemoved = (0, _differenceWith2.default)(this.props.graph.nodes, nextProps.graph.nodes, idIsEqual);
        var nodesAdded = (0, _differenceWith2.default)(nextProps.graph.nodes, this.props.graph.nodes, idIsEqual);
        var nodesChanged = (0, _differenceWith2.default)((0, _differenceWith2.default)(nextProps.graph.nodes, this.props.graph.nodes, _isEqual2.default), nodesAdded);
        this.patchNodes({ nodesRemoved: nodesRemoved, nodesAdded: nodesAdded, nodesChanged: nodesChanged });
      }

      if (edgesChange) {
        var edgesRemoved = (0, _differenceWith2.default)(this.props.graph.edges, nextProps.graph.edges, _isEqual2.default);
        var edgesAdded = (0, _differenceWith2.default)(nextProps.graph.edges, this.props.graph.edges, _isEqual2.default);
        this.patchEdges({ edgesRemoved: edgesRemoved, edgesAdded: edgesAdded });
      }

      if (optionsChange) {
        this.Network.setOptions(nextProps.options);
      }

      if (eventsChange) {
        var events = this.props.events || {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var eventName = _step.value;
            this.Network.off(eventName, events[eventName]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        events = nextProps.events || {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = Object.keys(events)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _eventName = _step2.value;
            this.Network.on(_eventName, events[_eventName]);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateGraph();
    }
  }, {
    key: "patchEdges",
    value: function patchEdges(_ref) {
      var edgesRemoved = _ref.edgesRemoved,
          edgesAdded = _ref.edgesAdded;

      this.edges.remove(edgesRemoved);
      this.edges.add(edgesAdded);
    }
  }, {
    key: "patchNodes",
    value: function patchNodes(_ref2) {
      var nodesRemoved = _ref2.nodesRemoved,
          nodesAdded = _ref2.nodesAdded,
          nodesChanged = _ref2.nodesChanged;

      this.nodes.remove(nodesRemoved);
      this.nodes.add(nodesAdded);
      this.nodes.update(nodesChanged);
    }
  }, {
    key: "updateGraph",
    value: function updateGraph() {
      var container = document.getElementById(this.state.identifier);
      var defaultOptions = {
        physics: {
          stabilization: false
        },
        autoResize: false,
        edges: {
          smooth: false,
          color: "#000000",
          width: 0.5,
          arrows: {
            to: {
              enabled: true,
              scaleFactor: 0.5
            }
          }
        }
      };

      // merge user provied options with our default ones
      var options = (0, _defaultsDeep2.default)(defaultOptions, this.props.options);

      this.Network = new _vis2.default.Network(container, Object.assign({}, this.props.graph, {
        edges: this.edges,
        nodes: this.nodes
      }), options);

      if (this.props.getNetwork) {
        this.props.getNetwork(this.Network);
      }

      if (this.props.getNodes) {
        this.props.getNodes(this.nodes);
      }

      // Add user provied events to network
      var events = this.props.events || {};
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = Object.keys(events)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var eventName = _step3.value;

          this.Network.on(eventName, events[eventName]);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var identifier = this.state.identifier;
      var style = this.props.style;

      return _react2.default.createElement("div", {
        id: identifier,
        style: style
      }, identifier);
    }
  }]);

  return Graph;
}(_react.Component);

Graph.defaultProps = {
  graph: {},
  style: { width: "100%", height: "100%" }
};
Graph.propTypes = {
  graph: _propTypes2.default.object,
  style: _propTypes2.default.object,
  getNetwork: _propTypes2.default.func,
  getNodes: _propTypes2.default.func
};

exports.default = Graph;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(905),
    func = convert('defaultsDeep', __webpack_require__(1012));

func.placeholder = __webpack_require__(396);
module.exports = func;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(906),
    util = __webpack_require__(908);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(907),
    fallbackHolder = __webpack_require__(396);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isFunction': util.isFunction,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isFunction = helpers.isFunction,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null) {
        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 907 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(909),
  'assign': __webpack_require__(414),
  'clone': __webpack_require__(942),
  'curry': __webpack_require__(984),
  'forEach': __webpack_require__(252),
  'isArray': __webpack_require__(30),
  'isFunction': __webpack_require__(161),
  'iteratee': __webpack_require__(985),
  'keys': __webpack_require__(418),
  'rearg': __webpack_require__(1007),
  'toInteger': __webpack_require__(413),
  'toPath': __webpack_require__(1011)
};


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(248);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(161),
    isMasked = __webpack_require__(911),
    isObject = __webpack_require__(37),
    toSource = __webpack_require__(400);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(912);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(26);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 913 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(162),
    root = __webpack_require__(26);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(164),
    createCtor = __webpack_require__(162),
    createHybrid = __webpack_require__(401),
    createRecurry = __webpack_require__(404),
    getHolder = __webpack_require__(412),
    replaceHolders = __webpack_require__(253),
    root = __webpack_require__(26);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(249),
    getData = __webpack_require__(405),
    getFuncName = __webpack_require__(919),
    lodash = __webpack_require__(921);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 918 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(920);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(249),
    LodashWrapper = __webpack_require__(406),
    baseLodash = __webpack_require__(250),
    isArray = __webpack_require__(30),
    isObjectLike = __webpack_require__(62),
    wrapperClone = __webpack_require__(922);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(249),
    LodashWrapper = __webpack_require__(406),
    copyArray = __webpack_require__(113);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 923 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 924 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(926),
    defineProperty = __webpack_require__(410),
    identity = __webpack_require__(160);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 926 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(252),
    arrayIncludes = __webpack_require__(411);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(929),
    baseIsNaN = __webpack_require__(930),
    strictIndexOf = __webpack_require__(931);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 929 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 930 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 931 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(113),
    isIndex = __webpack_require__(165);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(164),
    createCtor = __webpack_require__(162),
    root = __webpack_require__(26);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(402),
    composeArgsRight = __webpack_require__(403),
    replaceHolders = __webpack_require__(253);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(395);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 936 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(92),
    isObjectLike = __webpack_require__(62);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 938 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(92),
    isLength = __webpack_require__(256),
    isObjectLike = __webpack_require__(62);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(394);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)(module)))

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(419);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(420);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 943 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(172);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(172);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(172);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(172);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(171);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 951 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(171),
    Map = __webpack_require__(258),
    MapCache = __webpack_require__(259);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(954),
    ListCache = __webpack_require__(171),
    Map = __webpack_require__(258);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(955),
    hashDelete = __webpack_require__(956),
    hashGet = __webpack_require__(957),
    hashHas = __webpack_require__(958),
    hashSet = __webpack_require__(959);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 956 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(173);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(174);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 961 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(174);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(174);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(174);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(114),
    keysIn = __webpack_require__(175);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37),
    isPrototype = __webpack_require__(257),
    nativeKeysIn = __webpack_require__(967);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 967 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(114),
    getSymbols = __webpack_require__(260);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 969 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(114),
    getSymbolsIn = __webpack_require__(423);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(425),
    getSymbolsIn = __webpack_require__(423),
    keysIn = __webpack_require__(175);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(82),
    root = __webpack_require__(26);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(82),
    root = __webpack_require__(26);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(82),
    root = __webpack_require__(26);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 975 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(263),
    cloneDataView = __webpack_require__(977),
    cloneMap = __webpack_require__(978),
    cloneRegExp = __webpack_require__(980),
    cloneSet = __webpack_require__(981),
    cloneSymbol = __webpack_require__(983),
    cloneTypedArray = __webpack_require__(431);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(263);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(979),
    arrayReduce = __webpack_require__(428),
    mapToArray = __webpack_require__(429);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 979 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 980 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(982),
    arrayReduce = __webpack_require__(428),
    setToArray = __webpack_require__(430);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 982 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(248);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(420),
    baseIteratee = __webpack_require__(986);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(987),
    baseMatchesProperty = __webpack_require__(996),
    identity = __webpack_require__(160),
    isArray = __webpack_require__(30),
    property = __webpack_require__(1004);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(988),
    getMatchData = __webpack_require__(995),
    matchesStrictComparable = __webpack_require__(437);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(170),
    baseIsEqual = __webpack_require__(264);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(170),
    equalArrays = __webpack_require__(433),
    equalByTag = __webpack_require__(993),
    equalObjects = __webpack_require__(994),
    getTag = __webpack_require__(426),
    isArray = __webpack_require__(30),
    isBuffer = __webpack_require__(168),
    isTypedArray = __webpack_require__(255);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 991 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 992 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93),
    Uint8Array = __webpack_require__(427),
    eq = __webpack_require__(115),
    equalArrays = __webpack_require__(433),
    mapToArray = __webpack_require__(429),
    setToArray = __webpack_require__(430);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(424);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(436),
    keys = __webpack_require__(166);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(264),
    get = __webpack_require__(997),
    hasIn = __webpack_require__(1001),
    isKey = __webpack_require__(265),
    isStrictComparable = __webpack_require__(436),
    matchesStrictComparable = __webpack_require__(437),
    toKey = __webpack_require__(116);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(438);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(999);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(259);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93),
    arrayMap = __webpack_require__(266),
    isArray = __webpack_require__(30),
    isSymbol = __webpack_require__(111);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1002),
    hasPath = __webpack_require__(1003);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(439),
    isArguments = __webpack_require__(167),
    isArray = __webpack_require__(30),
    isIndex = __webpack_require__(165),
    isLength = __webpack_require__(256),
    toKey = __webpack_require__(116);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1005),
    basePropertyDeep = __webpack_require__(1006),
    isKey = __webpack_require__(265),
    toKey = __webpack_require__(116);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1005 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(438);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(248),
    flatRest = __webpack_require__(1008);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1009),
    overRest = __webpack_require__(443),
    setToString = __webpack_require__(251);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(442);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93),
    isArguments = __webpack_require__(167),
    isArray = __webpack_require__(30);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(266),
    copyArray = __webpack_require__(113),
    isArray = __webpack_require__(30),
    isSymbol = __webpack_require__(111),
    stringToPath = __webpack_require__(440),
    toKey = __webpack_require__(116),
    toString = __webpack_require__(441);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(164),
    baseRest = __webpack_require__(267),
    customDefaultsMerge = __webpack_require__(1013),
    mergeWith = __webpack_require__(1019);

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(444),
    isObject = __webpack_require__(37);

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1015);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(445),
    cloneBuffer = __webpack_require__(421),
    cloneTypedArray = __webpack_require__(431),
    copyArray = __webpack_require__(113),
    initCloneObject = __webpack_require__(432),
    isArguments = __webpack_require__(167),
    isArray = __webpack_require__(30),
    isArrayLikeObject = __webpack_require__(446),
    isBuffer = __webpack_require__(168),
    isFunction = __webpack_require__(161),
    isObject = __webpack_require__(37),
    isPlainObject = __webpack_require__(1017),
    isTypedArray = __webpack_require__(255),
    toPlainObject = __webpack_require__(1018);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(92),
    getPrototype = __webpack_require__(262),
    isObjectLike = __webpack_require__(62);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(114),
    keysIn = __webpack_require__(175);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(444),
    createAssigner = __webpack_require__(1020);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(267),
    isIterateeCall = __webpack_require__(1021);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(115),
    isArrayLike = __webpack_require__(169),
    isIndex = __webpack_require__(165),
    isObject = __webpack_require__(37);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(264);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1024),
    baseFlatten = __webpack_require__(442),
    baseRest = __webpack_require__(267),
    isArrayLikeObject = __webpack_require__(446),
    last = __webpack_require__(1026);

/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = baseRest(function(array, values) {
  var comparator = last(values);
  if (isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
    : [];
});

module.exports = differenceWith;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(434),
    arrayIncludes = __webpack_require__(411),
    arrayIncludesWith = __webpack_require__(1025),
    arrayMap = __webpack_require__(266),
    baseUnary = __webpack_require__(417),
    cacheHas = __webpack_require__(435);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1026 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * vis.js
 * https://github.com/almende/vis
 *
 * A dynamic, browser-based visualization library.
 *
 * @version 4.21.0
 * @date    2017-10-12
 *
 * @license
 * Copyright (C) 2011-2017 Almende B.V, http://almende.com
 *
 * Vis.js is dual licensed under both
 *
 * * The Apache 2.0 License
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * and
 *
 * * The MIT License
 *   http://opensource.org/licenses/MIT
 *
 * Vis.js may be distributed under either license.
 */



(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vis"] = factory();
	else
		root["vis"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 123);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(169);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _getIterator2 = __webpack_require__(77);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _create = __webpack_require__(29);

var _create2 = _interopRequireDefault(_create);

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// utility functions

// first check if moment.js is already loaded in the browser window, if so,
// use this instance. Else, load via commonjs.


var moment = __webpack_require__(9);
var uuid = __webpack_require__(157);

/**
 * Test whether given object is a number
 * @param {*} object
 * @return {Boolean} isNumber
 */
exports.isNumber = function (object) {
  return object instanceof Number || typeof object == 'number';
};

/**
 * Remove everything in the DOM object
 * @param {Element} DOMobject
 */
exports.recursiveDOMDelete = function (DOMobject) {
  if (DOMobject) {
    while (DOMobject.hasChildNodes() === true) {
      exports.recursiveDOMDelete(DOMobject.firstChild);
      DOMobject.removeChild(DOMobject.firstChild);
    }
  }
};

/**
 * this function gives you a range between 0 and 1 based on the min and max values in the set, the total sum of all values and the current value.
 *
 * @param {number} min
 * @param {number} max
 * @param {number} total
 * @param {number} value
 * @returns {number}
 */
exports.giveRange = function (min, max, total, value) {
  if (max == min) {
    return 0.5;
  } else {
    var scale = 1 / (max - min);
    return Math.max(0, (value - min) * scale);
  }
};

/**
 * Test whether given object is a string
 * @param {*} object
 * @return {Boolean} isString
 */
exports.isString = function (object) {
  return object instanceof String || typeof object == 'string';
};

/**
 * Test whether given object is a Date, or a String containing a Date
 * @param {Date | String} object
 * @return {Boolean} isDate
 */
exports.isDate = function (object) {
  if (object instanceof Date) {
    return true;
  } else if (exports.isString(object)) {
    // test whether this string contains a date
    var match = ASPDateRegex.exec(object);
    if (match) {
      return true;
    } else if (!isNaN(Date.parse(object))) {
      return true;
    }
  }

  return false;
};

/**
 * Create a semi UUID
 * source: http://stackoverflow.com/a/105074/1262753
 * @return {string} uuid
 */
exports.randomUUID = function () {
  return uuid.v4();
};

/**
 * assign all keys of an object that are not nested objects to a certain value (used for color objects).
 * @param {object} obj
 * @param {number} value
 */
exports.assignAllKeys = function (obj, value) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      if ((0, _typeof3['default'])(obj[prop]) !== 'object') {
        obj[prop] = value;
      }
    }
  }
};

/**
 * Copy property from b to a if property present in a.
 * If property in b explicitly set to null, delete it if `allowDeletion` set.
 *
 * Internal helper routine, should not be exported. Not added to `exports` for that reason.
 *
 * @param {object} a  target object
 * @param {object} b  source object
 * @param {string} prop  name of property to copy to a
 * @param {boolean} allowDeletion  if true, delete property in a if explicitly set to null in b 
 * @private
 */
function copyOrDelete(a, b, prop, allowDeletion) {
  var doDeletion = false;
  if (allowDeletion === true) {
    doDeletion = b[prop] === null && a[prop] !== undefined;
  }

  if (doDeletion) {
    delete a[prop];
  } else {
    a[prop] = b[prop]; // Remember, this is a reference copy!
  }
}

/**
 * Fill an object with a possibly partially defined other object.
 *
 * Only copies values for the properties already present in a.
 * That means an object is not created on a property if only the b object has it.
 *
 * @param {object} a
 * @param {object} b
 * @param {boolean} [allowDeletion=false]  if true, delete properties in a that are explicitly set to null in b 
 */
exports.fillIfDefined = function (a, b) {
  var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // NOTE: iteration of properties of a
  // NOTE: prototype properties iterated over as well
  for (var prop in a) {
    if (b[prop] !== undefined) {
      if (b[prop] === null || (0, _typeof3['default'])(b[prop]) !== 'object') {
        // Note: typeof null === 'object'
        copyOrDelete(a, b, prop, allowDeletion);
      } else {
        if ((0, _typeof3['default'])(a[prop]) === 'object') {
          exports.fillIfDefined(a[prop], b[prop], allowDeletion);
        }
      }
    }
  }
};

/**
 * Extend object a with the properties of object b or a series of objects
 * Only properties with defined values are copied
 * @param {Object} a
 * @param {...Object} b
 * @return {Object} a
 */
exports.extend = function (a, b) {
  // eslint-disable-line no-unused-vars
  for (var i = 1; i < arguments.length; i++) {
    var other = arguments[i];
    for (var prop in other) {
      if (other.hasOwnProperty(prop)) {
        a[prop] = other[prop];
      }
    }
  }
  return a;
};

/**
 * Extend object a with selected properties of object b or a series of objects
 * Only properties with defined values are copied
 * @param {Array.<string>} props
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 */
exports.selectiveExtend = function (props, a, b) {
  // eslint-disable-line no-unused-vars
  if (!Array.isArray(props)) {
    throw new Error('Array with property names expected as first argument');
  }

  for (var i = 2; i < arguments.length; i++) {
    var other = arguments[i];

    for (var p = 0; p < props.length; p++) {
      var prop = props[p];
      if (other && other.hasOwnProperty(prop)) {
        a[prop] = other[prop];
      }
    }
  }
  return a;
};

/**
 * Extend object a with selected properties of object b.
 * Only properties with defined values are copied.
 *
 * **Note:** Previous version of this routine implied that multiple source objects
 *           could be used; however, the implementation was **wrong**.
 *           Since multiple (>1) sources weren't used anywhere in the `vis.js` code,
 *           this has been removed
 *
 * @param {Array.<string>} props names of first-level properties to copy over
 * @param {object} a  target object
 * @param {object} b  source object
 * @param {boolean} [allowDeletion=false]  if true, delete property in a if explicitly set to null in b 
 * @returns {Object} a
 */
exports.selectiveDeepExtend = function (props, a, b) {
  var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  // TODO: add support for Arrays to deepExtend
  if (Array.isArray(b)) {
    throw new TypeError('Arrays are not supported by deepExtend');
  }

  for (var p = 0; p < props.length; p++) {
    var prop = props[p];
    if (b.hasOwnProperty(prop)) {
      if (b[prop] && b[prop].constructor === Object) {
        if (a[prop] === undefined) {
          a[prop] = {};
        }
        if (a[prop].constructor === Object) {
          exports.deepExtend(a[prop], b[prop], false, allowDeletion);
        } else {
          copyOrDelete(a, b, prop, allowDeletion);
        }
      } else if (Array.isArray(b[prop])) {
        throw new TypeError('Arrays are not supported by deepExtend');
      } else {
        copyOrDelete(a, b, prop, allowDeletion);
      }
    }
  }
  return a;
};

/**
 * Extend object `a` with properties of object `b`, ignoring properties which are explicitly 
 * specified to be excluded.
 * 
 * The properties of `b` are considered for copying.
 * Properties which are themselves objects are are also extended.
 * Only properties with defined values are copied
 *
 * @param {Array.<string>} propsToExclude  names of properties which should *not* be copied
 * @param {Object}                      a  object to extend
 * @param {Object}                      b  object to take properties from for extension
 * @param {boolean} [allowDeletion=false]  if true, delete properties in a that are explicitly set to null in b 
 * @return {Object} a
 */
exports.selectiveNotDeepExtend = function (propsToExclude, a, b) {
  var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  // TODO: add support for Arrays to deepExtend
  // NOTE: array properties have an else-below; apparently, there is a problem here. 
  if (Array.isArray(b)) {
    throw new TypeError('Arrays are not supported by deepExtend');
  }

  for (var prop in b) {
    if (!b.hasOwnProperty(prop)) continue; // Handle local properties only 
    if (propsToExclude.indexOf(prop) !== -1) continue; // In exclusion list, skip

    if (b[prop] && b[prop].constructor === Object) {
      if (a[prop] === undefined) {
        a[prop] = {};
      }
      if (a[prop].constructor === Object) {
        exports.deepExtend(a[prop], b[prop]); // NOTE: allowDeletion not propagated!
      } else {
        copyOrDelete(a, b, prop, allowDeletion);
      }
    } else if (Array.isArray(b[prop])) {
      a[prop] = [];
      for (var i = 0; i < b[prop].length; i++) {
        a[prop].push(b[prop][i]);
      }
    } else {
      copyOrDelete(a, b, prop, allowDeletion);
    }
  }

  return a;
};

/**
 * Deep extend an object a with the properties of object b
 *
 * @param {Object} a
 * @param {Object} b
 * @param {boolean} [protoExtend=false]  If true, the prototype values will also be extended.
 *                          (ie. the options objects that inherit from others will also get the inherited options)
 * @param {boolean} [allowDeletion=false] If true, the values of fields that are null will be deleted
 * @returns {Object}
 */
exports.deepExtend = function (a, b) {
  var protoExtend = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var allowDeletion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  for (var prop in b) {
    if (b.hasOwnProperty(prop) || protoExtend === true) {
      if (b[prop] && b[prop].constructor === Object) {
        if (a[prop] === undefined) {
          a[prop] = {};
        }
        if (a[prop].constructor === Object) {
          exports.deepExtend(a[prop], b[prop], protoExtend); // NOTE: allowDeletion not propagated!
        } else {
          copyOrDelete(a, b, prop, allowDeletion);
        }
      } else if (Array.isArray(b[prop])) {
        a[prop] = [];
        for (var i = 0; i < b[prop].length; i++) {
          a[prop].push(b[prop][i]);
        }
      } else {
        copyOrDelete(a, b, prop, allowDeletion);
      }
    }
  }
  return a;
};

/**
 * Test whether all elements in two arrays are equal.
 * @param {Array} a
 * @param {Array} b
 * @return {boolean} Returns true if both arrays have the same length and same
 *                   elements.
 */
exports.equalArray = function (a, b) {
  if (a.length != b.length) return false;

  for (var i = 0, len = a.length; i < len; i++) {
    if (a[i] != b[i]) return false;
  }

  return true;
};

/**
 * Convert an object to another type
 * @param {boolean | number | string | Date | Moment | Null | undefined} object
 * @param {string | undefined} type   Name of the type. Available types:
 *                                    'Boolean', 'Number', 'String',
 *                                    'Date', 'Moment', ISODate', 'ASPDate'.
 * @return {*} object
 * @throws Error
 */
exports.convert = function (object, type) {
  var match;

  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }

  if (!type) {
    return object;
  }
  if (!(typeof type === 'string') && !(type instanceof String)) {
    throw new Error('Type must be a string');
  }

  //noinspection FallthroughInSwitchStatementJS
  switch (type) {
    case 'boolean':
    case 'Boolean':
      return Boolean(object);

    case 'number':
    case 'Number':
      if (exports.isString(object) && !isNaN(Date.parse(object))) {
        return moment(object).valueOf();
      } else {
        return Number(object.valueOf());
      }
    case 'string':
    case 'String':
      return String(object);

    case 'Date':
      if (exports.isNumber(object)) {
        return new Date(object);
      }
      if (object instanceof Date) {
        return new Date(object.valueOf());
      } else if (moment.isMoment(object)) {
        return new Date(object.valueOf());
      }
      if (exports.isString(object)) {
        match = ASPDateRegex.exec(object);
        if (match) {
          // object is an ASP date
          return new Date(Number(match[1])); // parse number
        } else {
          return moment(new Date(object)).toDate(); // parse string
        }
      } else {
        throw new Error('Cannot convert object of type ' + exports.getType(object) + ' to type Date');
      }

    case 'Moment':
      if (exports.isNumber(object)) {
        return moment(object);
      }
      if (object instanceof Date) {
        return moment(object.valueOf());
      } else if (moment.isMoment(object)) {
        return moment(object);
      }
      if (exports.isString(object)) {
        match = ASPDateRegex.exec(object);
        if (match) {
          // object is an ASP date
          return moment(Number(match[1])); // parse number
        } else {
          return moment(object); // parse string
        }
      } else {
        throw new Error('Cannot convert object of type ' + exports.getType(object) + ' to type Date');
      }

    case 'ISODate':
      if (exports.isNumber(object)) {
        return new Date(object);
      } else if (object instanceof Date) {
        return object.toISOString();
      } else if (moment.isMoment(object)) {
        return object.toDate().toISOString();
      } else if (exports.isString(object)) {
        match = ASPDateRegex.exec(object);
        if (match) {
          // object is an ASP date
          return new Date(Number(match[1])).toISOString(); // parse number
        } else {
          return moment(object).format(); // ISO 8601
        }
      } else {
        throw new Error('Cannot convert object of type ' + exports.getType(object) + ' to type ISODate');
      }

    case 'ASPDate':
      if (exports.isNumber(object)) {
        return '/Date(' + object + ')/';
      } else if (object instanceof Date) {
        return '/Date(' + object.valueOf() + ')/';
      } else if (exports.isString(object)) {
        match = ASPDateRegex.exec(object);
        var value;
        if (match) {
          // object is an ASP date
          value = new Date(Number(match[1])).valueOf(); // parse number
        } else {
          value = new Date(object).valueOf(); // parse string
        }
        return '/Date(' + value + ')/';
      } else {
        throw new Error('Cannot convert object of type ' + exports.getType(object) + ' to type ASPDate');
      }

    default:
      throw new Error('Unknown type "' + type + '"');
  }
};

// parse ASP.Net Date pattern,
// for example '/Date(1198908717056)/' or '/Date(1198908717056-0700)/'
// code from http://momentjs.com/
var ASPDateRegex = /^\/?Date\((\-?\d+)/i;

/**
 * Get the type of an object, for example exports.getType([]) returns 'Array'
 * @param {*} object
 * @return {string} type
 */
exports.getType = function (object) {
  var type = typeof object === 'undefined' ? 'undefined' : (0, _typeof3['default'])(object);

  if (type == 'object') {
    if (object === null) {
      return 'null';
    }
    if (object instanceof Boolean) {
      return 'Boolean';
    }
    if (object instanceof Number) {
      return 'Number';
    }
    if (object instanceof String) {
      return 'String';
    }
    if (Array.isArray(object)) {
      return 'Array';
    }
    if (object instanceof Date) {
      return 'Date';
    }
    return 'Object';
  } else if (type == 'number') {
    return 'Number';
  } else if (type == 'boolean') {
    return 'Boolean';
  } else if (type == 'string') {
    return 'String';
  } else if (type === undefined) {
    return 'undefined';
  }

  return type;
};

/**
 * Used to extend an array and copy it. This is used to propagate paths recursively.
 *
 * @param {Array} arr
 * @param {*} newValue
 * @returns {Array}
 */
exports.copyAndExtendArray = function (arr, newValue) {
  var newArr = [];
  for (var i = 0; i < arr.length; i++) {
    newArr.push(arr[i]);
  }
  newArr.push(newValue);
  return newArr;
};

/**
 * Used to extend an array and copy it. This is used to propagate paths recursively.
 *
 * @param {Array} arr
 * @returns {Array}
 */
exports.copyArray = function (arr) {
  var newArr = [];
  for (var i = 0; i < arr.length; i++) {
    newArr.push(arr[i]);
  }
  return newArr;
};

/**
 * Retrieve the absolute left value of a DOM element
 * @param {Element} elem        A dom element, for example a div
 * @return {number} left        The absolute left position of this element
 *                              in the browser page.
 */
exports.getAbsoluteLeft = function (elem) {
  return elem.getBoundingClientRect().left;
};

exports.getAbsoluteRight = function (elem) {
  return elem.getBoundingClientRect().right;
};

/**
 * Retrieve the absolute top value of a DOM element
 * @param {Element} elem        A dom element, for example a div
 * @return {number} top        The absolute top position of this element
 *                              in the browser page.
 */
exports.getAbsoluteTop = function (elem) {
  return elem.getBoundingClientRect().top;
};

/**
 * add a className to the given elements style
 * @param {Element} elem
 * @param {string} classNames
 */
exports.addClassName = function (elem, classNames) {
  var classes = elem.className.split(' ');
  var newClasses = classNames.split(' ');
  classes = classes.concat(newClasses.filter(function (className) {
    return classes.indexOf(className) < 0;
  }));
  elem.className = classes.join(' ');
};

/**
 * add a className to the given elements style
 * @param {Element} elem
 * @param {string} classNames
 */
exports.removeClassName = function (elem, classNames) {
  var classes = elem.className.split(' ');
  var oldClasses = classNames.split(' ');
  classes = classes.filter(function (className) {
    return oldClasses.indexOf(className) < 0;
  });
  elem.className = classes.join(' ');
};

/**
 * For each method for both arrays and objects.
 * In case of an array, the built-in Array.forEach() is applied. (**No, it's not!**)
 * In case of an Object, the method loops over all properties of the object.
 * @param {Object | Array} object   An Object or Array
 * @param {function} callback       Callback method, called for each item in
 *                                  the object or array with three parameters:
 *                                  callback(value, index, object)
 */
exports.forEach = function (object, callback) {
  var i, len;
  if (Array.isArray(object)) {
    // array
    for (i = 0, len = object.length; i < len; i++) {
      callback(object[i], i, object);
    }
  } else {
    // object
    for (i in object) {
      if (object.hasOwnProperty(i)) {
        callback(object[i], i, object);
      }
    }
  }
};

/**
 * Convert an object into an array: all objects properties are put into the
 * array. The resulting array is unordered.
 * @param {Object} object
 * @returns {Array} array
 */
exports.toArray = function (object) {
  var array = [];

  for (var prop in object) {
    if (object.hasOwnProperty(prop)) array.push(object[prop]);
  }

  return array;
};

/**
 * Update a property in an object
 * @param {Object} object
 * @param {string} key
 * @param {*} value
 * @return {Boolean} changed
 */
exports.updateProperty = function (object, key, value) {
  if (object[key] !== value) {
    object[key] = value;
    return true;
  } else {
    return false;
  }
};

/**
 * Throttle the given function to be only executed once per animation frame
 * @param {function} fn
 * @returns {function} Returns the throttled function
 */
exports.throttle = function (fn) {
  var scheduled = false;

  return function throttled() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        fn();
      });
    }
  };
};

/**
 * Add and event listener. Works for all browsers
 * @param {Element}     element    An html element
 * @param {string}      action     The action, for example "click",
 *                                 without the prefix "on"
 * @param {function}    listener   The callback function to be executed
 * @param {boolean}     [useCapture]
 */
exports.addEventListener = function (element, action, listener, useCapture) {
  if (element.addEventListener) {
    if (useCapture === undefined) useCapture = false;

    if (action === "mousewheel" && navigator.userAgent.indexOf("Firefox") >= 0) {
      action = "DOMMouseScroll"; // For Firefox
    }

    element.addEventListener(action, listener, useCapture);
  } else {
    element.attachEvent("on" + action, listener); // IE browsers
  }
};

/**
 * Remove an event listener from an element
 * @param {Element}     element         An html dom element
 * @param {string}      action          The name of the event, for example "mousedown"
 * @param {function}    listener        The listener function
 * @param {boolean}     [useCapture]
 */
exports.removeEventListener = function (element, action, listener, useCapture) {
  if (element.removeEventListener) {
    // non-IE browsers
    if (useCapture === undefined) useCapture = false;

    if (action === "mousewheel" && navigator.userAgent.indexOf("Firefox") >= 0) {
      action = "DOMMouseScroll"; // For Firefox
    }

    element.removeEventListener(action, listener, useCapture);
  } else {
    // IE browsers
    element.detachEvent("on" + action, listener);
  }
};

/**
 * Cancels the event if it is cancelable, without stopping further propagation of the event.
 * @param {Event} event
 */
exports.preventDefault = function (event) {
  if (!event) event = window.event;

  if (event.preventDefault) {
    event.preventDefault(); // non-IE browsers
  } else {
    event.returnValue = false; // IE browsers
  }
};

/**
 * Get HTML element which is the target of the event
 * @param {Event} event
 * @return {Element} target element
 */
exports.getTarget = function (event) {
  // code from http://www.quirksmode.org/js/events_properties.html
  if (!event) {
    event = window.event;
  }

  var target;

  if (event.target) {
    target = event.target;
  } else if (event.srcElement) {
    target = event.srcElement;
  }

  if (target.nodeType != undefined && target.nodeType == 3) {
    // defeat Safari bug
    target = target.parentNode;
  }

  return target;
};

/**
 * Check if given element contains given parent somewhere in the DOM tree
 * @param {Element} element
 * @param {Element} parent
 * @returns {boolean}
 */
exports.hasParent = function (element, parent) {
  var e = element;

  while (e) {
    if (e === parent) {
      return true;
    }
    e = e.parentNode;
  }

  return false;
};

exports.option = {};

/**
 * Convert a value into a boolean
 * @param {Boolean | function | undefined} value
 * @param {boolean} [defaultValue]
 * @returns {Boolean} bool
 */
exports.option.asBoolean = function (value, defaultValue) {
  if (typeof value == 'function') {
    value = value();
  }

  if (value != null) {
    return value != false;
  }

  return defaultValue || null;
};

/**
 * Convert a value into a number
 * @param {Boolean | function | undefined} value
 * @param {number} [defaultValue]
 * @returns {number} number
 */
exports.option.asNumber = function (value, defaultValue) {
  if (typeof value == 'function') {
    value = value();
  }

  if (value != null) {
    return Number(value) || defaultValue || null;
  }

  return defaultValue || null;
};

/**
 * Convert a value into a string
 * @param {string | function | undefined} value
 * @param {string} [defaultValue]
 * @returns {String} str
 */
exports.option.asString = function (value, defaultValue) {
  if (typeof value == 'function') {
    value = value();
  }

  if (value != null) {
    return String(value);
  }

  return defaultValue || null;
};

/**
 * Convert a size or location into a string with pixels or a percentage
 * @param {string | number | function | undefined} value
 * @param {string} [defaultValue]
 * @returns {String} size
 */
exports.option.asSize = function (value, defaultValue) {
  if (typeof value == 'function') {
    value = value();
  }

  if (exports.isString(value)) {
    return value;
  } else if (exports.isNumber(value)) {
    return value + 'px';
  } else {
    return defaultValue || null;
  }
};

/**
 * Convert a value into a DOM element
 * @param {HTMLElement | function | undefined} value
 * @param {HTMLElement} [defaultValue]
 * @returns {HTMLElement | null} dom
 */
exports.option.asElement = function (value, defaultValue) {
  if (typeof value == 'function') {
    value = value();
  }

  return value || defaultValue || null;
};

/**
 * http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
 *
 * @param {string} hex
 * @returns {{r: *, g: *, b: *}} | 255 range
 */
exports.hexToRGB = function (hex) {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

/**
 * This function takes color in hex format or rgb() or rgba() format and overrides the opacity. Returns rgba() string.
 * @param {string} color
 * @param {number} opacity
 * @returns {String}
 */
exports.overrideOpacity = function (color, opacity) {
  var rgb;
  if (color.indexOf("rgba") != -1) {
    return color;
  } else if (color.indexOf("rgb") != -1) {
    rgb = color.substr(color.indexOf("(") + 1).replace(")", "").split(",");
    return "rgba(" + rgb[0] + "," + rgb[1] + "," + rgb[2] + "," + opacity + ")";
  } else {
    rgb = exports.hexToRGB(color);
    if (rgb == null) {
      return color;
    } else {
      return "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + opacity + ")";
    }
  }
};

/**
 *
 * @param {number} red     0 -- 255
 * @param {number} green   0 -- 255
 * @param {number} blue    0 -- 255
 * @returns {String}
 * @constructor
 */
exports.RGBToHex = function (red, green, blue) {
  return "#" + ((1 << 24) + (red << 16) + (green << 8) + blue).toString(16).slice(1);
};

/**
 * Parse a color property into an object with border, background, and
 * highlight colors
 * @param {Object | String} color
 * @return {Object} colorObject
 */
exports.parseColor = function (color) {
  var c;
  if (exports.isString(color) === true) {
    if (exports.isValidRGB(color) === true) {
      var rgb = color.substr(4).substr(0, color.length - 5).split(',').map(function (value) {
        return parseInt(value);
      });
      color = exports.RGBToHex(rgb[0], rgb[1], rgb[2]);
    }
    if (exports.isValidHex(color) === true) {
      var hsv = exports.hexToHSV(color);
      var lighterColorHSV = { h: hsv.h, s: hsv.s * 0.8, v: Math.min(1, hsv.v * 1.02) };
      var darkerColorHSV = { h: hsv.h, s: Math.min(1, hsv.s * 1.25), v: hsv.v * 0.8 };
      var darkerColorHex = exports.HSVToHex(darkerColorHSV.h, darkerColorHSV.s, darkerColorHSV.v);
      var lighterColorHex = exports.HSVToHex(lighterColorHSV.h, lighterColorHSV.s, lighterColorHSV.v);
      c = {
        background: color,
        border: darkerColorHex,
        highlight: {
          background: lighterColorHex,
          border: darkerColorHex
        },
        hover: {
          background: lighterColorHex,
          border: darkerColorHex
        }
      };
    } else {
      c = {
        background: color,
        border: color,
        highlight: {
          background: color,
          border: color
        },
        hover: {
          background: color,
          border: color
        }
      };
    }
  } else {
    c = {};
    c.background = color.background || undefined;
    c.border = color.border || undefined;

    if (exports.isString(color.highlight)) {
      c.highlight = {
        border: color.highlight,
        background: color.highlight
      };
    } else {
      c.highlight = {};
      c.highlight.background = color.highlight && color.highlight.background || undefined;
      c.highlight.border = color.highlight && color.highlight.border || undefined;
    }

    if (exports.isString(color.hover)) {
      c.hover = {
        border: color.hover,
        background: color.hover
      };
    } else {
      c.hover = {};
      c.hover.background = color.hover && color.hover.background || undefined;
      c.hover.border = color.hover && color.hover.border || undefined;
    }
  }

  return c;
};

/**
 * http://www.javascripter.net/faq/rgb2hsv.htm
 *
 * @param {number} red
 * @param {number} green
 * @param {number} blue
 * @returns {{h: number, s: number, v: number}}
 * @constructor
 */
exports.RGBToHSV = function (red, green, blue) {
  red = red / 255;green = green / 255;blue = blue / 255;
  var minRGB = Math.min(red, Math.min(green, blue));
  var maxRGB = Math.max(red, Math.max(green, blue));

  // Black-gray-white
  if (minRGB == maxRGB) {
    return { h: 0, s: 0, v: minRGB };
  }

  // Colors other than black-gray-white:
  var d = red == minRGB ? green - blue : blue == minRGB ? red - green : blue - red;
  var h = red == minRGB ? 3 : blue == minRGB ? 1 : 5;
  var hue = 60 * (h - d / (maxRGB - minRGB)) / 360;
  var saturation = (maxRGB - minRGB) / maxRGB;
  var value = maxRGB;
  return { h: hue, s: saturation, v: value };
};

var cssUtil = {
  // split a string with css styles into an object with key/values
  split: function split(cssText) {
    var styles = {};

    cssText.split(';').forEach(function (style) {
      if (style.trim() != '') {
        var parts = style.split(':');
        var key = parts[0].trim();
        var value = parts[1].trim();
        styles[key] = value;
      }
    });

    return styles;
  },

  // build a css text string from an object with key/values
  join: function join(styles) {
    return (0, _keys2['default'])(styles).map(function (key) {
      return key + ': ' + styles[key];
    }).join('; ');
  }
};

/**
 * Append a string with css styles to an element
 * @param {Element} element
 * @param {string} cssText
 */
exports.addCssText = function (element, cssText) {
  var currentStyles = cssUtil.split(element.style.cssText);
  var newStyles = cssUtil.split(cssText);
  var styles = exports.extend(currentStyles, newStyles);

  element.style.cssText = cssUtil.join(styles);
};

/**
 * Remove a string with css styles from an element
 * @param {Element} element
 * @param {string} cssText
 */
exports.removeCssText = function (element, cssText) {
  var styles = cssUtil.split(element.style.cssText);
  var removeStyles = cssUtil.split(cssText);

  for (var key in removeStyles) {
    if (removeStyles.hasOwnProperty(key)) {
      delete styles[key];
    }
  }

  element.style.cssText = cssUtil.join(styles);
};

/**
 * https://gist.github.com/mjijackson/5311256
 * @param {number} h
 * @param {number} s
 * @param {number} v
 * @returns {{r: number, g: number, b: number}}
 * @constructor
 */
exports.HSVToRGB = function (h, s, v) {
  var r, g, b;

  var i = Math.floor(h * 6);
  var f = h * 6 - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);

  switch (i % 6) {
    case 0:
      r = v, g = t, b = p;break;
    case 1:
      r = q, g = v, b = p;break;
    case 2:
      r = p, g = v, b = t;break;
    case 3:
      r = p, g = q, b = v;break;
    case 4:
      r = t, g = p, b = v;break;
    case 5:
      r = v, g = p, b = q;break;
  }

  return { r: Math.floor(r * 255), g: Math.floor(g * 255), b: Math.floor(b * 255) };
};

exports.HSVToHex = function (h, s, v) {
  var rgb = exports.HSVToRGB(h, s, v);
  return exports.RGBToHex(rgb.r, rgb.g, rgb.b);
};

exports.hexToHSV = function (hex) {
  var rgb = exports.hexToRGB(hex);
  return exports.RGBToHSV(rgb.r, rgb.g, rgb.b);
};

exports.isValidHex = function (hex) {
  var isOk = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex);
  return isOk;
};

exports.isValidRGB = function (rgb) {
  rgb = rgb.replace(" ", "");
  var isOk = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/i.test(rgb);
  return isOk;
};
exports.isValidRGBA = function (rgba) {
  rgba = rgba.replace(" ", "");
  var isOk = /rgba\((\d{1,3}),(\d{1,3}),(\d{1,3}),(.{1,3})\)/i.test(rgba);
  return isOk;
};

/**
 * This recursively redirects the prototype of JSON objects to the referenceObject
 * This is used for default options.
 *
 * @param {Array.<string>} fields
 * @param {Object} referenceObject
 * @returns {*}
 */
exports.selectiveBridgeObject = function (fields, referenceObject) {
  if (referenceObject !== null && (typeof referenceObject === 'undefined' ? 'undefined' : (0, _typeof3['default'])(referenceObject)) === "object") {
    // !!! typeof null === 'object'
    var objectTo = (0, _create2['default'])(referenceObject);
    for (var i = 0; i < fields.length; i++) {
      if (referenceObject.hasOwnProperty(fields[i])) {
        if ((0, _typeof3['default'])(referenceObject[fields[i]]) == "object") {
          objectTo[fields[i]] = exports.bridgeObject(referenceObject[fields[i]]);
        }
      }
    }
    return objectTo;
  } else {
    return null;
  }
};

/**
 * This recursively redirects the prototype of JSON objects to the referenceObject
 * This is used for default options.
 *
 * @param {Object} referenceObject
 * @returns {*}
 */
exports.bridgeObject = function (referenceObject) {
  if (referenceObject !== null && (typeof referenceObject === 'undefined' ? 'undefined' : (0, _typeof3['default'])(referenceObject)) === "object") {
    // !!! typeof null === 'object'
    var objectTo = (0, _create2['default'])(referenceObject);
    if (referenceObject instanceof Element) {
      // Avoid bridging DOM objects
      objectTo = referenceObject;
    } else {
      objectTo = (0, _create2['default'])(referenceObject);
      for (var i in referenceObject) {
        if (referenceObject.hasOwnProperty(i)) {
          if ((0, _typeof3['default'])(referenceObject[i]) == "object") {
            objectTo[i] = exports.bridgeObject(referenceObject[i]);
          }
        }
      }
    }
    return objectTo;
  } else {
    return null;
  }
};

/**
 * This method provides a stable sort implementation, very fast for presorted data
 *
 * @param {Array} a the array
 * @param {function} compare an order comparator
 * @returns {Array}
 */
exports.insertSort = function (a, compare) {
  for (var i = 0; i < a.length; i++) {
    var k = a[i];
    for (var j = i; j > 0 && compare(k, a[j - 1]) < 0; j--) {
      a[j] = a[j - 1];
    }
    a[j] = k;
  }
  return a;
};

/**
 * This is used to set the options of subobjects in the options object.
 *
 * A requirement of these subobjects is that they have an 'enabled' element
 * which is optional for the user but mandatory for the program.
 *
 * The added value here of the merge is that option 'enabled' is set as required.
 *
 *
 * @param {object} mergeTarget   | either this.options or the options used for the groups.
 * @param {object} options       | options
 * @param {string} option        | option key in the options argument
 * @param {object} globalOptions | global options, passed in to determine value of option 'enabled'
 */
exports.mergeOptions = function (mergeTarget, options, option) {
  var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Local helpers
  var isPresent = function isPresent(obj) {
    return obj !== null && obj !== undefined;
  };

  var isObject = function isObject(obj) {
    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3['default'])(obj)) === 'object';
  };

  // https://stackoverflow.com/a/34491287/1223531
  var isEmpty = function isEmpty(obj) {
    for (var x in obj) {
      if (obj.hasOwnProperty(x)) return false;
    }
    return true;
  };

  // Guards
  if (!isObject(mergeTarget)) {
    throw new Error('Parameter mergeTarget must be an object');
  }

  if (!isObject(options)) {
    throw new Error('Parameter options must be an object');
  }

  if (!isPresent(option)) {
    throw new Error('Parameter option must have a value');
  }

  if (!isObject(globalOptions)) {
    throw new Error('Parameter globalOptions must be an object');
  }

  //
  // Actual merge routine, separated from main logic
  // Only a single level of options is merged. Deeper levels are ref'd. This may actually be an issue.
  //
  var doMerge = function doMerge(target, options, option) {
    if (!isObject(target[option])) {
      target[option] = {};
    }

    var src = options[option];
    var dst = target[option];
    for (var prop in src) {
      if (src.hasOwnProperty(prop)) {
        dst[prop] = src[prop];
      }
    }
  };

  // Local initialization
  var srcOption = options[option];
  var globalPassed = isObject(globalOptions) && !isEmpty(globalOptions);
  var globalOption = globalPassed ? globalOptions[option] : undefined;
  var globalEnabled = globalOption ? globalOption.enabled : undefined;

  /////////////////////////////////////////
  // Main routine
  /////////////////////////////////////////
  if (srcOption === undefined) {
    return; // Nothing to do
  }

  if (typeof srcOption === 'boolean') {
    if (!isObject(mergeTarget[option])) {
      mergeTarget[option] = {};
    }

    mergeTarget[option].enabled = srcOption;
    return;
  }

  if (srcOption === null && !isObject(mergeTarget[option])) {
    // If possible, explicit copy from globals
    if (isPresent(globalOption)) {
      mergeTarget[option] = (0, _create2['default'])(globalOption);
    } else {
      return; // Nothing to do
    }
  }

  if (!isObject(srcOption)) {
    return;
  }

  //
  // Ensure that 'enabled' is properly set. It is required internally
  // Note that the value from options will always overwrite the existing value
  //
  var enabled = true; // default value

  if (srcOption.enabled !== undefined) {
    enabled = srcOption.enabled;
  } else {
    // Take from globals, if present
    if (globalEnabled !== undefined) {
      enabled = globalOption.enabled;
    }
  }

  doMerge(mergeTarget, options, option);
  mergeTarget[option].enabled = enabled;
};

/**
 * This function does a binary search for a visible item in a sorted list. If we find a visible item, the code that uses
 * this function will then iterate in both directions over this sorted list to find all visible items.
 *
 * @param {Item[]} orderedItems       | Items ordered by start
 * @param {function} comparator       | -1 is lower, 0 is equal, 1 is higher
 * @param {string} field
 * @param {string} field2
 * @returns {number}
 * @private
 */
exports.binarySearchCustom = function (orderedItems, comparator, field, field2) {
  var maxIterations = 10000;
  var iteration = 0;
  var low = 0;
  var high = orderedItems.length - 1;

  while (low <= high && iteration < maxIterations) {
    var middle = Math.floor((low + high) / 2);

    var item = orderedItems[middle];
    var value = field2 === undefined ? item[field] : item[field][field2];

    var searchResult = comparator(value);
    if (searchResult == 0) {
      // jihaa, found a visible item!
      return middle;
    } else if (searchResult == -1) {
      // it is too small --> increase low
      low = middle + 1;
    } else {
      // it is too big --> decrease high
      high = middle - 1;
    }

    iteration++;
  }

  return -1;
};

/**
 * This function does a binary search for a specific value in a sorted array. If it does not exist but is in between of
 * two values, we return either the one before or the one after, depending on user input
 * If it is found, we return the index, else -1.
 *
 * @param {Array} orderedItems
 * @param {{start: number, end: number}} target
 * @param {string} field
 * @param {string} sidePreference   'before' or 'after'
 * @param {function} comparator an optional comparator, returning -1,0,1 for <,==,>.
 * @returns {number}
 * @private
 */
exports.binarySearchValue = function (orderedItems, target, field, sidePreference, comparator) {
  var maxIterations = 10000;
  var iteration = 0;
  var low = 0;
  var high = orderedItems.length - 1;
  var prevValue, value, nextValue, middle;

  comparator = comparator != undefined ? comparator : function (a, b) {
    return a == b ? 0 : a < b ? -1 : 1;
  };

  while (low <= high && iteration < maxIterations) {
    // get a new guess
    middle = Math.floor(0.5 * (high + low));
    prevValue = orderedItems[Math.max(0, middle - 1)][field];
    value = orderedItems[middle][field];
    nextValue = orderedItems[Math.min(orderedItems.length - 1, middle + 1)][field];

    if (comparator(value, target) == 0) {
      // we found the target
      return middle;
    } else if (comparator(prevValue, target) < 0 && comparator(value, target) > 0) {
      // target is in between of the previous and the current
      return sidePreference == 'before' ? Math.max(0, middle - 1) : middle;
    } else if (comparator(value, target) < 0 && comparator(nextValue, target) > 0) {
      // target is in between of the current and the next
      return sidePreference == 'before' ? middle : Math.min(orderedItems.length - 1, middle + 1);
    } else {
      // didnt find the target, we need to change our boundaries.
      if (comparator(value, target) < 0) {
        // it is too small --> increase low
        low = middle + 1;
      } else {
        // it is too big --> decrease high
        high = middle - 1;
      }
    }
    iteration++;
  }

  // didnt find anything. Return -1.
  return -1;
};

/*
 * Easing Functions - inspired from http://gizma.com/easing/
 * only considering the t value for the range [0, 1] => [0, 1]
 * https://gist.github.com/gre/1650294
 */
exports.easingFunctions = {
  // no easing, no acceleration
  linear: function linear(t) {
    return t;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(t) {
    return t * t;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(t) {
    return t * (2 - t);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(t) {
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  // accelerating from zero velocity
  easeInCubic: function easeInCubic(t) {
    return t * t * t;
  },
  // decelerating to zero velocity
  easeOutCubic: function easeOutCubic(t) {
    return --t * t * t + 1;
  },
  // acceleration until halfway, then deceleration
  easeInOutCubic: function easeInOutCubic(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  // accelerating from zero velocity
  easeInQuart: function easeInQuart(t) {
    return t * t * t * t;
  },
  // decelerating to zero velocity
  easeOutQuart: function easeOutQuart(t) {
    return 1 - --t * t * t * t;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(t) {
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(t) {
    return t * t * t * t * t;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(t) {
    return 1 + --t * t * t * t * t;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuint: function easeInOutQuint(t) {
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  }
};

exports.getScrollBarWidth = function () {
  var inner = document.createElement('p');
  inner.style.width = "100%";
  inner.style.height = "200px";

  var outer = document.createElement('div');
  outer.style.position = "absolute";
  outer.style.top = "0px";
  outer.style.left = "0px";
  outer.style.visibility = "hidden";
  outer.style.width = "200px";
  outer.style.height = "150px";
  outer.style.overflow = "hidden";
  outer.appendChild(inner);

  document.body.appendChild(outer);
  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  if (w1 == w2) w2 = outer.clientWidth;

  document.body.removeChild(outer);

  return w1 - w2;
};

exports.topMost = function (pile, accessors) {
  var candidate = void 0;
  if (!Array.isArray(accessors)) {
    accessors = [accessors];
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3['default'])(pile), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var member = _step.value;

      if (member) {
        candidate = member[accessors[0]];
        for (var i = 1; i < accessors.length; i++) {
          if (candidate) {
            candidate = candidate[accessors[i]];
          } else {
            continue;
          }
        }
        if (typeof candidate != 'undefined') {
          break;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator['return']) {
        _iterator['return']();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return candidate;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(194), __esModule: true };

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(196);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(29);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(142);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(144);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(140), __esModule: true };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// first check if moment.js is already loaded in the browser window, if so,
// use this instance. Else, load via commonjs.
module.exports = typeof window !== 'undefined' && window['moment'] || __webpack_require__(154);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Setup a mock hammer.js object, for unit testing.
 *
 * Inspiration: https://github.com/uber/deck.gl/pull/658
 *
 * @returns {{on: noop, off: noop, destroy: noop, emit: noop, get: get}}
 */
function hammerMock() {
  var noop = function noop() {};

  return {
    on: noop,
    off: noop,
    destroy: noop,
    emit: noop,

    get: function get(m) {
      //eslint-disable-line no-unused-vars
      return {
        set: noop
      };
    }
  };
}

if (typeof window !== 'undefined') {
  var propagating = __webpack_require__(175);
  var Hammer = window['Hammer'] || __webpack_require__(176);
  module.exports = propagating(Hammer, {
    preventDefault: 'mouse'
  });
} else {
  module.exports = function () {
    // hammer.js is only available in a browser, not in node.js. Replacing it with a mock object.
    return hammerMock();
  };
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(19);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var Queue = __webpack_require__(43);

/**
 * DataSet
 * // TODO: add a DataSet constructor DataSet(data, options)
 *
 * Usage:
 *     var dataSet = new DataSet({
 *         fieldId: '_id',
 *         type: {
 *             // ...
 *         }
 *     });
 *
 *     dataSet.add(item);
 *     dataSet.add(data);
 *     dataSet.update(item);
 *     dataSet.update(data);
 *     dataSet.remove(id);
 *     dataSet.remove(ids);
 *     var data = dataSet.get();
 *     var data = dataSet.get(id);
 *     var data = dataSet.get(ids);
 *     var data = dataSet.get(ids, options, data);
 *     dataSet.clear();
 *
 * A data set can:
 * - add/remove/update data
 * - gives triggers upon changes in the data
 * - can  import/export data in various data formats
 *
 * @param {Array} [data]    Optional array with initial data
 * @param {Object} [options]   Available options:
 *                             {string} fieldId Field name of the id in the
 *                                              items, 'id' by default.
 *                             {Object.<string, string} type
 *                                              A map with field names as key,
 *                                              and the field type as value.
 *                             {Object} queue   Queue changes to the DataSet,
 *                                              flush them all at once.
 *                                              Queue options:
 *                                              - {number} delay  Delay in ms, null by default
 *                                              - {number} max    Maximum number of entries in the queue, Infinity by default
 * @constructor DataSet
 */
function DataSet(data, options) {
  // correctly read optional arguments
  if (data && !Array.isArray(data)) {
    options = data;
    data = null;
  }

  this._options = options || {};
  this._data = {}; // map with data indexed by id
  this.length = 0; // number of items in the DataSet
  this._fieldId = this._options.fieldId || 'id'; // name of the field containing id
  this._type = {}; // internal field types (NOTE: this can differ from this._options.type)

  // all variants of a Date are internally stored as Date, so we can convert
  // from everything to everything (also from ISODate to Number for example)
  if (this._options.type) {
    var fields = (0, _keys2['default'])(this._options.type);
    for (var i = 0, len = fields.length; i < len; i++) {
      var field = fields[i];
      var value = this._options.type[field];
      if (value == 'Date' || value == 'ISODate' || value == 'ASPDate') {
        this._type[field] = 'Date';
      } else {
        this._type[field] = value;
      }
    }
  }

  this._subscribers = {}; // event subscribers

  // add initial data when provided
  if (data) {
    this.add(data);
  }

  this.setOptions(options);
}

/**
 * @param {Object} options   Available options:
 *                             {Object} queue   Queue changes to the DataSet,
 *                                              flush them all at once.
 *                                              Queue options:
 *                                              - {number} delay  Delay in ms, null by default
 *                                              - {number} max    Maximum number of entries in the queue, Infinity by default
 */
DataSet.prototype.setOptions = function (options) {
  if (options && options.queue !== undefined) {
    if (options.queue === false) {
      // delete queue if loaded
      if (this._queue) {
        this._queue.destroy();
        delete this._queue;
      }
    } else {
      // create queue and update its options
      if (!this._queue) {
        this._queue = Queue.extend(this, {
          replace: ['add', 'update', 'remove']
        });
      }

      if ((0, _typeof3['default'])(options.queue) === 'object') {
        this._queue.setOptions(options.queue);
      }
    }
  }
};

/**
 * Subscribe to an event, add an event listener
 * @param {string} event        Event name. Available events: 'add', 'update',
 *                              'remove'
 * @param {function} callback   Callback method. Called with three parameters:
 *                                  {string} event
 *                                  {Object | null} params
 *                                  {string | number} senderId
 */
DataSet.prototype.on = function (event, callback) {
  var subscribers = this._subscribers[event];
  if (!subscribers) {
    subscribers = [];
    this._subscribers[event] = subscribers;
  }

  subscribers.push({
    callback: callback
  });
};

/**
 * Unsubscribe from an event, remove an event listener
 * @param {string} event
 * @param {function} callback
 */
DataSet.prototype.off = function (event, callback) {
  var subscribers = this._subscribers[event];
  if (subscribers) {
    this._subscribers[event] = subscribers.filter(function (listener) {
      return listener.callback != callback;
    });
  }
};

/**
 * Trigger an event
 * @param {string} event
 * @param {Object | null} params
 * @param {string} [senderId]       Optional id of the sender.
 * @private
 */
DataSet.prototype._trigger = function (event, params, senderId) {
  if (event == '*') {
    throw new Error('Cannot trigger event *');
  }

  var subscribers = [];
  if (event in this._subscribers) {
    subscribers = subscribers.concat(this._subscribers[event]);
  }
  if ('*' in this._subscribers) {
    subscribers = subscribers.concat(this._subscribers['*']);
  }

  for (var i = 0, len = subscribers.length; i < len; i++) {
    var subscriber = subscribers[i];
    if (subscriber.callback) {
      subscriber.callback(event, params, senderId || null);
    }
  }
};

/**
 * Add data.
 * Adding an item will fail when there already is an item with the same id.
 * @param {Object | Array} data
 * @param {string} [senderId] Optional sender id
 * @return {Array.<string|number>} addedIds      Array with the ids of the added items
 */
DataSet.prototype.add = function (data, senderId) {
  var addedIds = [],
      id,
      me = this;

  if (Array.isArray(data)) {
    // Array
    for (var i = 0, len = data.length; i < len; i++) {
      id = me._addItem(data[i]);
      addedIds.push(id);
    }
  } else if (data && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3['default'])(data)) === 'object') {
    // Single item
    id = me._addItem(data);
    addedIds.push(id);
  } else {
    throw new Error('Unknown dataType');
  }

  if (addedIds.length) {
    this._trigger('add', { items: addedIds }, senderId);
  }

  return addedIds;
};

/**
 * Update existing items. When an item does not exist, it will be created
 * @param {Object | Array} data
 * @param {string} [senderId] Optional sender id
 * @return {Array.<string|number>} updatedIds     The ids of the added or updated items
 * @throws {Error} Unknown Datatype
 */
DataSet.prototype.update = function (data, senderId) {
  var addedIds = [];
  var updatedIds = [];
  var oldData = [];
  var updatedData = [];
  var me = this;
  var fieldId = me._fieldId;

  var addOrUpdate = function addOrUpdate(item) {
    var id = item[fieldId];
    if (me._data[id]) {
      var oldItem = util.extend({}, me._data[id]);
      // update item
      id = me._updateItem(item);
      updatedIds.push(id);
      updatedData.push(item);
      oldData.push(oldItem);
    } else {
      // add new item
      id = me._addItem(item);
      addedIds.push(id);
    }
  };

  if (Array.isArray(data)) {
    // Array
    for (var i = 0, len = data.length; i < len; i++) {
      if (data[i] && (0, _typeof3['default'])(data[i]) === 'object') {
        addOrUpdate(data[i]);
      } else {
        console.warn('Ignoring input item, which is not an object at index ' + i);
      }
    }
  } else if (data && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3['default'])(data)) === 'object') {
    // Single item
    addOrUpdate(data);
  } else {
    throw new Error('Unknown dataType');
  }

  if (addedIds.length) {
    this._trigger('add', { items: addedIds }, senderId);
  }
  if (updatedIds.length) {
    var props = { items: updatedIds, oldData: oldData, data: updatedData };
    // TODO: remove deprecated property 'data' some day
    //Object.defineProperty(props, 'data', {
    //  'get': (function() {
    //    console.warn('Property data is deprecated. Use DataSet.get(ids) to retrieve the new data, use the oldData property on this object to get the old data');
    //    return updatedData;
    //  }).bind(this)
    //});
    this._trigger('update', props, senderId);
  }

  return addedIds.concat(updatedIds);
};

/**
 * Get a data item or multiple items.
 *
 * Usage:
 *
 *     get()
 *     get(options: Object)
 *
 *     get(id: number | string)
 *     get(id: number | string, options: Object)
 *
 *     get(ids: number[] | string[])
 *     get(ids: number[] | string[], options: Object)
 *
 * Where:
 *
 * {number | string} id         The id of an item
 * {number[] | string{}} ids    An array with ids of items
 * {Object} options             An Object with options. Available options:
 * {string} [returnType]        Type of data to be returned.
 *                              Can be 'Array' (default) or 'Object'.
 * {Object.<string, string>} [type]
 * {string[]} [fields]          field names to be returned
 * {function} [filter]          filter items
 * {string | function} [order]  Order the items by a field name or custom sort function.
 * @param {Array} args
 * @returns {DataSet}
 * @throws Error
 */
DataSet.prototype.get = function (args) {
  // eslint-disable-line no-unused-vars
  var me = this;

  // parse the arguments
  var id, ids, options;
  var firstType = util.getType(arguments[0]);
  if (firstType == 'String' || firstType == 'Number') {
    // get(id [, options])
    id = arguments[0];
    options = arguments[1];
  } else if (firstType == 'Array') {
    // get(ids [, options])
    ids = arguments[0];
    options = arguments[1];
  } else {
    // get([, options])
    options = arguments[0];
  }

  // determine the return type
  var returnType;
  if (options && options.returnType) {
    var allowedValues = ['Array', 'Object'];
    returnType = allowedValues.indexOf(options.returnType) == -1 ? 'Array' : options.returnType;
  } else {
    returnType = 'Array';
  }

  // build options
  var type = options && options.type || this._options.type;
  var filter = options && options.filter;
  var items = [],
      item,
      itemIds,
      itemId,
      i,
      len;

  // convert items
  if (id != undefined) {
    // return a single item
    item = me._getItem(id, type);
    if (item && filter && !filter(item)) {
      item = null;
    }
  } else if (ids != undefined) {
    // return a subset of items
    for (i = 0, len = ids.length; i < len; i++) {
      item = me._getItem(ids[i], type);
      if (!filter || filter(item)) {
        items.push(item);
      }
    }
  } else {
    // return all items
    itemIds = (0, _keys2['default'])(this._data);
    for (i = 0, len = itemIds.length; i < len; i++) {
      itemId = itemIds[i];
      item = me._getItem(itemId, type);
      if (!filter || filter(item)) {
        items.push(item);
      }
    }
  }

  // order the results
  if (options && options.order && id == undefined) {
    this._sort(items, options.order);
  }

  // filter fields of the items
  if (options && options.fields) {
    var fields = options.fields;
    if (id != undefined) {
      item = this._filterFields(item, fields);
    } else {
      for (i = 0, len = items.length; i < len; i++) {
        items[i] = this._filterFields(items[i], fields);
      }
    }
  }

  // return the results
  if (returnType == 'Object') {
    var result = {},
        resultant;
    for (i = 0, len = items.length; i < len; i++) {
      resultant = items[i];
      result[resultant.id] = resultant;
    }
    return result;
  } else {
    if (id != undefined) {
      // a single item
      return item;
    } else {
      // just return our array
      return items;
    }
  }
};

/**
 * Get ids of all items or from a filtered set of items.
 * @param {Object} [options]    An Object with options. Available options:
 *                              {function} [filter] filter items
 *                              {string | function} [order] Order the items by
 *                                  a field name or custom sort function.
 * @return {Array.<string|number>} ids
 */
DataSet.prototype.getIds = function (options) {
  var data = this._data,
      filter = options && options.filter,
      order = options && options.order,
      type = options && options.type || this._options.type,
      itemIds = (0, _keys2['default'])(data),
      i,
      len,
      id,
      item,
      items,
      ids = [];

  if (filter) {
    // get filtered items
    if (order) {
      // create ordered list
      items = [];
      for (i = 0, len = itemIds.length; i < len; i++) {
        id = itemIds[i];
        item = this._getItem(id, type);
        if (filter(item)) {
          items.push(item);
        }
      }

      this._sort(items, order);

      for (i = 0, len = items.length; i < len; i++) {
        ids.push(items[i][this._fieldId]);
      }
    } else {
      // create unordered list
      for (i = 0, len = itemIds.length; i < len; i++) {
        id = itemIds[i];
        item = this._getItem(id, type);
        if (filter(item)) {
          ids.push(item[this._fieldId]);
        }
      }
    }
  } else {
    // get all items
    if (order) {
      // create an ordered list
      items = [];
      for (i = 0, len = itemIds.length; i < len; i++) {
        id = itemIds[i];
        items.push(data[id]);
      }

      this._sort(items, order);

      for (i = 0, len = items.length; i < len; i++) {
        ids.push(items[i][this._fieldId]);
      }
    } else {
      // create unordered list
      for (i = 0, len = itemIds.length; i < len; i++) {
        id = itemIds[i];
        item = data[id];
        ids.push(item[this._fieldId]);
      }
    }
  }

  return ids;
};

/**
 * Returns the DataSet itself. Is overwritten for example by the DataView,
 * which returns the DataSet it is connected to instead.
 * @returns {DataSet}
 */
DataSet.prototype.getDataSet = function () {
  return this;
};

/**
 * Execute a callback function for every item in the dataset.
 * @param {function} callback
 * @param {Object} [options]    Available options:
 *                              {Object.<string, string>} [type]
 *                              {string[]} [fields] filter fields
 *                              {function} [filter] filter items
 *                              {string | function} [order] Order the items by
 *                                  a field name or custom sort function.
 */
DataSet.prototype.forEach = function (callback, options) {
  var filter = options && options.filter,
      type = options && options.type || this._options.type,
      data = this._data,
      itemIds = (0, _keys2['default'])(data),
      i,
      len,
      item,
      id;

  if (options && options.order) {
    // execute forEach on ordered list
    var items = this.get(options);

    for (i = 0, len = items.length; i < len; i++) {
      item = items[i];
      id = item[this._fieldId];
      callback(item, id);
    }
  } else {
    // unordered
    for (i = 0, len = itemIds.length; i < len; i++) {
      id = itemIds[i];
      item = this._getItem(id, type);
      if (!filter || filter(item)) {
        callback(item, id);
      }
    }
  }
};

/**
 * Map every item in the dataset.
 * @param {function} callback
 * @param {Object} [options]    Available options:
 *                              {Object.<string, string>} [type]
 *                              {string[]} [fields] filter fields
 *                              {function} [filter] filter items
 *                              {string | function} [order] Order the items by
 *                                  a field name or custom sort function.
 * @return {Object[]} mappedItems
 */
DataSet.prototype.map = function (callback, options) {
  var filter = options && options.filter,
      type = options && options.type || this._options.type,
      mappedItems = [],
      data = this._data,
      itemIds = (0, _keys2['default'])(data),
      i,
      len,
      id,
      item;

  // convert and filter items
  for (i = 0, len = itemIds.length; i < len; i++) {
    id = itemIds[i];
    item = this._getItem(id, type);
    if (!filter || filter(item)) {
      mappedItems.push(callback(item, id));
    }
  }

  // order items
  if (options && options.order) {
    this._sort(mappedItems, options.order);
  }

  return mappedItems;
};

/**
 * Filter the fields of an item
 * @param {Object | null} item
 * @param {string[]} fields     Field names
 * @return {Object | null} filteredItem or null if no item is provided
 * @private
 */
DataSet.prototype._filterFields = function (item, fields) {
  if (!item) {
    // item is null
    return item;
  }

  var filteredItem = {},
      itemFields = (0, _keys2['default'])(item),
      len = itemFields.length,
      i,
      field;

  if (Array.isArray(fields)) {
    for (i = 0; i < len; i++) {
      field = itemFields[i];
      if (fields.indexOf(field) != -1) {
        filteredItem[field] = item[field];
      }
    }
  } else {
    for (i = 0; i < len; i++) {
      field = itemFields[i];
      if (fields.hasOwnProperty(field)) {
        filteredItem[fields[field]] = item[field];
      }
    }
  }

  return filteredItem;
};

/**
 * Sort the provided array with items
 * @param {Object[]} items
 * @param {string | function} order      A field name or custom sort function.
 * @private
 */
DataSet.prototype._sort = function (items, order) {
  if (util.isString(order)) {
    // order by provided field name
    var name = order; // field name
    items.sort(function (a, b) {
      var av = a[name];
      var bv = b[name];
      return av > bv ? 1 : av < bv ? -1 : 0;
    });
  } else if (typeof order === 'function') {
    // order by sort function
    items.sort(order);
  }
  // TODO: extend order by an Object {field:string, direction:string}
  //       where direction can be 'asc' or 'desc'
  else {
      throw new TypeError('Order must be a function or a string');
    }
};

/**
 * Remove an object by pointer or by id
 * @param {string | number | Object | Array.<string|number>} id Object or id, or an array with
 *                                              objects or ids to be removed
 * @param {string} [senderId] Optional sender id
 * @return {Array.<string|number>} removedIds
 */
DataSet.prototype.remove = function (id, senderId) {
  var removedIds = [],
      removedItems = [],
      ids = [],
      i,
      len,
      itemId,
      item;

  // force everything to be an array for simplicity
  ids = Array.isArray(id) ? id : [id];

  for (i = 0, len = ids.length; i < len; i++) {
    item = this._remove(ids[i]);
    if (item) {
      itemId = item[this._fieldId];
      if (itemId != undefined) {
        removedIds.push(itemId);
        removedItems.push(item);
      }
    }
  }

  if (removedIds.length) {
    this._trigger('remove', { items: removedIds, oldData: removedItems }, senderId);
  }

  return removedIds;
};

/**
 * Remove an item by its id
 * @param {number | string | Object} id   id or item
 * @returns {number | string | null} id
 * @private
 */
DataSet.prototype._remove = function (id) {
  var item, ident;

  // confirm the id to use based on the args type
  if (util.isNumber(id) || util.isString(id)) {
    ident = id;
  } else if (id && (typeof id === 'undefined' ? 'undefined' : (0, _typeof3['default'])(id)) === 'object') {
    ident = id[this._fieldId]; // look for the identifier field using _fieldId
  }

  // do the remove if the item is found
  if (ident !== undefined && this._data[ident]) {
    item = this._data[ident];
    delete this._data[ident];
    this.length--;
    return item;
  }
  return null;
};

/**
 * Clear the data
 * @param {string} [senderId] Optional sender id
 * @return {Array.<string|number>} removedIds    The ids of all removed items
 */
DataSet.prototype.clear = function (senderId) {
  var i, len;
  var ids = (0, _keys2['default'])(this._data);
  var items = [];

  for (i = 0, len = ids.length; i < len; i++) {
    items.push(this._data[ids[i]]);
  }

  this._data = {};
  this.length = 0;

  this._trigger('remove', { items: ids, oldData: items }, senderId);

  return ids;
};

/**
 * Find the item with maximum value of a specified field
 * @param {string} field
 * @return {Object | null} item  Item containing max value, or null if no items
 */
DataSet.prototype.max = function (field) {
  var data = this._data,
      itemIds = (0, _keys2['default'])(data),
      max = null,
      maxField = null,
      i,
      len;

  for (i = 0, len = itemIds.length; i < len; i++) {
    var id = itemIds[i];
    var item = data[id];
    var itemField = item[field];
    if (itemField != null && (!max || itemField > maxField)) {
      max = item;
      maxField = itemField;
    }
  }

  return max;
};

/**
 * Find the item with minimum value of a specified field
 * @param {string} field
 * @return {Object | null} item  Item containing max value, or null if no items
 */
DataSet.prototype.min = function (field) {
  var data = this._data,
      itemIds = (0, _keys2['default'])(data),
      min = null,
      minField = null,
      i,
      len;

  for (i = 0, len = itemIds.length; i < len; i++) {
    var id = itemIds[i];
    var item = data[id];
    var itemField = item[field];
    if (itemField != null && (!min || itemField < minField)) {
      min = item;
      minField = itemField;
    }
  }

  return min;
};

/**
 * Find all distinct values of a specified field
 * @param {string} field
 * @return {Array} values  Array containing all distinct values. If data items
 *                         do not contain the specified field are ignored.
 *                         The returned array is unordered.
 */
DataSet.prototype.distinct = function (field) {
  var data = this._data;
  var itemIds = (0, _keys2['default'])(data);
  var values = [];
  var fieldType = this._options.type && this._options.type[field] || null;
  var count = 0;
  var i, j, len;

  for (i = 0, len = itemIds.length; i < len; i++) {
    var id = itemIds[i];
    var item = data[id];
    var value = item[field];
    var exists = false;
    for (j = 0; j < count; j++) {
      if (values[j] == value) {
        exists = true;
        break;
      }
    }
    if (!exists && value !== undefined) {
      values[count] = value;
      count++;
    }
  }

  if (fieldType) {
    for (i = 0, len = values.length; i < len; i++) {
      values[i] = util.convert(values[i], fieldType);
    }
  }

  return values;
};

/**
 * Add a single item. Will fail when an item with the same id already exists.
 * @param {Object} item
 * @return {string} id
 * @private
 */
DataSet.prototype._addItem = function (item) {
  var id = item[this._fieldId];

  if (id != undefined) {
    // check whether this id is already taken
    if (this._data[id]) {
      // item already exists
      throw new Error('Cannot add item: item with id ' + id + ' already exists');
    }
  } else {
    // generate an id
    id = util.randomUUID();
    item[this._fieldId] = id;
  }

  var d = {},
      fields = (0, _keys2['default'])(item),
      i,
      len;
  for (i = 0, len = fields.length; i < len; i++) {
    var field = fields[i];
    var fieldType = this._type[field]; // type may be undefined
    d[field] = util.convert(item[field], fieldType);
  }
  this._data[id] = d;
  this.length++;

  return id;
};

/**
 * Get an item. Fields can be converted to a specific type
 * @param {string} id
 * @param {Object.<string, string>} [types]  field types to convert
 * @return {Object | null} item
 * @private
 */
DataSet.prototype._getItem = function (id, types) {
  var field, value, i, len;

  // get the item from the dataset
  var raw = this._data[id];
  if (!raw) {
    return null;
  }

  // convert the items field types
  var converted = {},
      fields = (0, _keys2['default'])(raw);

  if (types) {
    for (i = 0, len = fields.length; i < len; i++) {
      field = fields[i];
      value = raw[field];
      converted[field] = util.convert(value, types[field]);
    }
  } else {
    // no field types specified, no converting needed
    for (i = 0, len = fields.length; i < len; i++) {
      field = fields[i];
      value = raw[field];
      converted[field] = value;
    }
  }

  if (!converted[this._fieldId]) {
    converted[this._fieldId] = raw.id;
  }

  return converted;
};

/**
 * Update a single item: merge with existing item.
 * Will fail when the item has no id, or when there does not exist an item
 * with the same id.
 * @param {Object} item
 * @return {string} id
 * @private
 */
DataSet.prototype._updateItem = function (item) {
  var id = item[this._fieldId];
  if (id == undefined) {
    throw new Error('Cannot update item: item has no id (item: ' + (0, _stringify2['default'])(item) + ')');
  }
  var d = this._data[id];
  if (!d) {
    // item doesn't exist
    throw new Error('Cannot update item: no item with id ' + id + ' found');
  }

  // merge with current item
  var fields = (0, _keys2['default'])(item);
  for (var i = 0, len = fields.length; i < len; i++) {
    var field = fields[i];
    var fieldType = this._type[field]; // type may be undefined
    d[field] = util.convert(item[field], fieldType);
  }

  return id;
};

module.exports = DataSet;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var DataSet = __webpack_require__(11);

/**
 * DataView
 *
 * a dataview offers a filtered view on a dataset or an other dataview.
 *
 * @param {DataSet | DataView} data
 * @param {Object} [options]   Available options: see method get
 *
 * @constructor DataView
 */
function DataView(data, options) {
  this._data = null;
  this._ids = {}; // ids of the items currently in memory (just contains a boolean true)
  this.length = 0; // number of items in the DataView
  this._options = options || {};
  this._fieldId = 'id'; // name of the field containing id
  this._subscribers = {}; // event subscribers

  var me = this;
  this.listener = function () {
    me._onEvent.apply(me, arguments);
  };

  this.setData(data);
}

// TODO: implement a function .config() to dynamically update things like configured filter
// and trigger changes accordingly

/**
 * Set a data source for the view
 * @param {DataSet | DataView} data
 */
DataView.prototype.setData = function (data) {
  var ids, id, i, len, items;

  if (this._data) {
    // unsubscribe from current dataset
    if (this._data.off) {
      this._data.off('*', this.listener);
    }

    // trigger a remove of all items in memory
    ids = this._data.getIds({ filter: this._options && this._options.filter });
    items = [];

    for (i = 0, len = ids.length; i < len; i++) {
      items.push(this._data._data[ids[i]]);
    }

    this._ids = {};
    this.length = 0;
    this._trigger('remove', { items: ids, oldData: items });
  }

  this._data = data;

  if (this._data) {
    // update fieldId
    this._fieldId = this._options.fieldId || this._data && this._data.options && this._data.options.fieldId || 'id';

    // trigger an add of all added items
    ids = this._data.getIds({ filter: this._options && this._options.filter });
    for (i = 0, len = ids.length; i < len; i++) {
      id = ids[i];
      this._ids[id] = true;
    }
    this.length = ids.length;
    this._trigger('add', { items: ids });

    // subscribe to new dataset
    if (this._data.on) {
      this._data.on('*', this.listener);
    }
  }
};

/**
 * Refresh the DataView. Useful when the DataView has a filter function
 * containing a variable parameter.
 */
DataView.prototype.refresh = function () {
  var id, i, len;
  var ids = this._data.getIds({ filter: this._options && this._options.filter }),
      oldIds = (0, _keys2['default'])(this._ids),
      newIds = {},
      addedIds = [],
      removedIds = [],
      removedItems = [];

  // check for additions
  for (i = 0, len = ids.length; i < len; i++) {
    id = ids[i];
    newIds[id] = true;
    if (!this._ids[id]) {
      addedIds.push(id);
      this._ids[id] = true;
    }
  }

  // check for removals
  for (i = 0, len = oldIds.length; i < len; i++) {
    id = oldIds[i];
    if (!newIds[id]) {
      removedIds.push(id);
      removedItems.push(this._data._data[id]);
      delete this._ids[id];
    }
  }

  this.length += addedIds.length - removedIds.length;

  // trigger events
  if (addedIds.length) {
    this._trigger('add', { items: addedIds });
  }
  if (removedIds.length) {
    this._trigger('remove', { items: removedIds, oldData: removedItems });
  }
};

/**
 * Get data from the data view
 *
 * Usage:
 *
 *     get()
 *     get(options: Object)
 *     get(options: Object, data: Array | DataTable)
 *
 *     get(id: Number)
 *     get(id: Number, options: Object)
 *     get(id: Number, options: Object, data: Array | DataTable)
 *
 *     get(ids: Number[])
 *     get(ids: Number[], options: Object)
 *     get(ids: Number[], options: Object, data: Array | DataTable)
 *
 * Where:
 *
 * {number | string} id         The id of an item
 * {number[] | string{}} ids    An array with ids of items
 * {Object} options             An Object with options. Available options:
 *                              {string} [type] Type of data to be returned. Can
 *                                              be 'DataTable' or 'Array' (default)
 *                              {Object.<string, string>} [convert]
 *                              {string[]} [fields] field names to be returned
 *                              {function} [filter] filter items
 *                              {string | function} [order] Order the items by
 *                                  a field name or custom sort function.
 * {Array | DataTable} [data]   If provided, items will be appended to this
 *                              array or table. Required in case of Google
 *                              DataTable.
 * @param {Array} args
 * @return {DataSet|DataView}
 */
DataView.prototype.get = function (args) {
  // eslint-disable-line no-unused-vars
  var me = this;

  // parse the arguments
  var ids, options, data;
  var firstType = util.getType(arguments[0]);
  if (firstType == 'String' || firstType == 'Number' || firstType == 'Array') {
    // get(id(s) [, options] [, data])
    ids = arguments[0]; // can be a single id or an array with ids
    options = arguments[1];
    data = arguments[2];
  } else {
    // get([, options] [, data])
    options = arguments[0];
    data = arguments[1];
  }

  // extend the options with the default options and provided options
  var viewOptions = util.extend({}, this._options, options);

  // create a combined filter method when needed
  if (this._options.filter && options && options.filter) {
    viewOptions.filter = function (item) {
      return me._options.filter(item) && options.filter(item);
    };
  }

  // build up the call to the linked data set
  var getArguments = [];
  if (ids != undefined) {
    getArguments.push(ids);
  }
  getArguments.push(viewOptions);
  getArguments.push(data);

  return this._data && this._data.get.apply(this._data, getArguments);
};

/**
 * Get ids of all items or from a filtered set of items.
 * @param {Object} [options]    An Object with options. Available options:
 *                              {function} [filter] filter items
 *                              {string | function} [order] Order the items by
 *                                  a field name or custom sort function.
 * @return {Array.<string|number>} ids
 */
DataView.prototype.getIds = function (options) {
  var ids;

  if (this._data) {
    var defaultFilter = this._options.filter;
    var filter;

    if (options && options.filter) {
      if (defaultFilter) {
        filter = function filter(item) {
          return defaultFilter(item) && options.filter(item);
        };
      } else {
        filter = options.filter;
      }
    } else {
      filter = defaultFilter;
    }

    ids = this._data.getIds({
      filter: filter,
      order: options && options.order
    });
  } else {
    ids = [];
  }

  return ids;
};

/**
 * Map every item in the dataset.
 * @param {function} callback
 * @param {Object} [options]    Available options:
 *                              {Object.<string, string>} [type]
 *                              {string[]} [fields] filter fields
 *                              {function} [filter] filter items
 *                              {string | function} [order] Order the items by
 *                                  a field name or custom sort function.
 * @return {Object[]} mappedItems
 */
DataView.prototype.map = function (callback, options) {
  var mappedItems = [];
  if (this._data) {
    var defaultFilter = this._options.filter;
    var filter;

    if (options && options.filter) {
      if (defaultFilter) {
        filter = function filter(item) {
          return defaultFilter(item) && options.filter(item);
        };
      } else {
        filter = options.filter;
      }
    } else {
      filter = defaultFilter;
    }

    mappedItems = this._data.map(callback, {
      filter: filter,
      order: options && options.order
    });
  } else {
    mappedItems = [];
  }

  return mappedItems;
};

/**
 * Get the DataSet to which this DataView is connected. In case there is a chain
 * of multiple DataViews, the root DataSet of this chain is returned.
 * @return {DataSet} dataSet
 */
DataView.prototype.getDataSet = function () {
  var dataSet = this;
  while (dataSet instanceof DataView) {
    dataSet = dataSet._data;
  }
  return dataSet || null;
};

/**
 * Event listener. Will propagate all events from the connected data set to
 * the subscribers of the DataView, but will filter the items and only trigger
 * when there are changes in the filtered data set.
 * @param {string} event
 * @param {Object | null} params
 * @param {string} senderId
 * @private
 */
DataView.prototype._onEvent = function (event, params, senderId) {
  var i, len, id, item;
  var ids = params && params.items;
  var addedIds = [],
      updatedIds = [],
      removedIds = [],
      oldItems = [],
      updatedItems = [],
      removedItems = [];

  if (ids && this._data) {
    switch (event) {
      case 'add':
        // filter the ids of the added items
        for (i = 0, len = ids.length; i < len; i++) {
          id = ids[i];
          item = this.get(id);
          if (item) {
            this._ids[id] = true;
            addedIds.push(id);
          }
        }

        break;

      case 'update':
        // determine the event from the views viewpoint: an updated
        // item can be added, updated, or removed from this view.
        for (i = 0, len = ids.length; i < len; i++) {
          id = ids[i];
          item = this.get(id);

          if (item) {
            if (this._ids[id]) {
              updatedIds.push(id);
              updatedItems.push(params.data[i]);
              oldItems.push(params.oldData[i]);
            } else {
              this._ids[id] = true;
              addedIds.push(id);
            }
          } else {
            if (this._ids[id]) {
              delete this._ids[id];
              removedIds.push(id);
              removedItems.push(params.oldData[i]);
            } else {
              // nothing interesting for me :-(
            }
          }
        }

        break;

      case 'remove':
        // filter the ids of the removed items
        for (i = 0, len = ids.length; i < len; i++) {
          id = ids[i];
          if (this._ids[id]) {
            delete this._ids[id];
            removedIds.push(id);
            removedItems.push(params.oldData[i]);
          }
        }

        break;
    }

    this.length += addedIds.length - removedIds.length;

    if (addedIds.length) {
      this._trigger('add', { items: addedIds }, senderId);
    }
    if (updatedIds.length) {
      this._trigger('update', { items: updatedIds, oldData: oldItems, data: updatedItems }, senderId);
    }
    if (removedIds.length) {
      this._trigger('remove', { items: removedIds, oldData: removedItems }, senderId);
    }
  }
};

// copy subscription functionality from DataSet
DataView.prototype.on = DataSet.prototype.on;
DataView.prototype.off = DataSet.prototype.off;
DataView.prototype._trigger = DataSet.prototype._trigger;

// TODO: make these functions deprecated (replaced with `on` and `off` since version 0.5)
DataView.prototype.subscribe = DataView.prototype.on;
DataView.prototype.unsubscribe = DataView.prototype.off;

module.exports = DataView;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(57)('wks');
var uid = __webpack_require__(40);
var Symbol = __webpack_require__(18).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// DOM utility methods

/**
 * this prepares the JSON container for allocating SVG elements
 * @param {Object} JSONcontainer
 * @private
 */
exports.prepareElements = function (JSONcontainer) {
  // cleanup the redundant svgElements;
  for (var elementType in JSONcontainer) {
    if (JSONcontainer.hasOwnProperty(elementType)) {
      JSONcontainer[elementType].redundant = JSONcontainer[elementType].used;
      JSONcontainer[elementType].used = [];
    }
  }
};

/**
 * this cleans up all the unused SVG elements. By asking for the parentNode, we only need to supply the JSON container from
 * which to remove the redundant elements.
 *
 * @param {Object} JSONcontainer
 * @private
 */
exports.cleanupElements = function (JSONcontainer) {
  // cleanup the redundant svgElements;
  for (var elementType in JSONcontainer) {
    if (JSONcontainer.hasOwnProperty(elementType)) {
      if (JSONcontainer[elementType].redundant) {
        for (var i = 0; i < JSONcontainer[elementType].redundant.length; i++) {
          JSONcontainer[elementType].redundant[i].parentNode.removeChild(JSONcontainer[elementType].redundant[i]);
        }
        JSONcontainer[elementType].redundant = [];
      }
    }
  }
};

/**
 * Ensures that all elements are removed first up so they can be recreated cleanly
 * @param {Object} JSONcontainer
 */
exports.resetElements = function (JSONcontainer) {
  exports.prepareElements(JSONcontainer);
  exports.cleanupElements(JSONcontainer);
  exports.prepareElements(JSONcontainer);
};

/**
 * Allocate or generate an SVG element if needed. Store a reference to it in the JSON container and draw it in the svgContainer
 * the JSON container and the SVG container have to be supplied so other svg containers (like the legend) can use this.
 *
 * @param {string} elementType
 * @param {Object} JSONcontainer
 * @param {Object} svgContainer
 * @returns {Element}
 * @private
 */
exports.getSVGElement = function (elementType, JSONcontainer, svgContainer) {
  var element;
  // allocate SVG element, if it doesnt yet exist, create one.
  if (JSONcontainer.hasOwnProperty(elementType)) {
    // this element has been created before
    // check if there is an redundant element
    if (JSONcontainer[elementType].redundant.length > 0) {
      element = JSONcontainer[elementType].redundant[0];
      JSONcontainer[elementType].redundant.shift();
    } else {
      // create a new element and add it to the SVG
      element = document.createElementNS('http://www.w3.org/2000/svg', elementType);
      svgContainer.appendChild(element);
    }
  } else {
    // create a new element and add it to the SVG, also create a new object in the svgElements to keep track of it.
    element = document.createElementNS('http://www.w3.org/2000/svg', elementType);
    JSONcontainer[elementType] = { used: [], redundant: [] };
    svgContainer.appendChild(element);
  }
  JSONcontainer[elementType].used.push(element);
  return element;
};

/**
 * Allocate or generate an SVG element if needed. Store a reference to it in the JSON container and draw it in the svgContainer
 * the JSON container and the SVG container have to be supplied so other svg containers (like the legend) can use this.
 *
 * @param {string} elementType
 * @param {Object} JSONcontainer
 * @param {Element} DOMContainer
 * @param {Element} insertBefore
 * @returns {*}
 */
exports.getDOMElement = function (elementType, JSONcontainer, DOMContainer, insertBefore) {
  var element;
  // allocate DOM element, if it doesnt yet exist, create one.
  if (JSONcontainer.hasOwnProperty(elementType)) {
    // this element has been created before
    // check if there is an redundant element
    if (JSONcontainer[elementType].redundant.length > 0) {
      element = JSONcontainer[elementType].redundant[0];
      JSONcontainer[elementType].redundant.shift();
    } else {
      // create a new element and add it to the SVG
      element = document.createElement(elementType);
      if (insertBefore !== undefined) {
        DOMContainer.insertBefore(element, insertBefore);
      } else {
        DOMContainer.appendChild(element);
      }
    }
  } else {
    // create a new element and add it to the SVG, also create a new object in the svgElements to keep track of it.
    element = document.createElement(elementType);
    JSONcontainer[elementType] = { used: [], redundant: [] };
    if (insertBefore !== undefined) {
      DOMContainer.insertBefore(element, insertBefore);
    } else {
      DOMContainer.appendChild(element);
    }
  }
  JSONcontainer[elementType].used.push(element);
  return element;
};

/**
 * Draw a point object. This is a separate function because it can also be called by the legend.
 * The reason the JSONcontainer and the target SVG svgContainer have to be supplied is so the legend can use these functions
 * as well.
 *
 * @param {number} x
 * @param {number} y
 * @param {Object} groupTemplate: A template containing the necessary information to draw the datapoint e.g., {style: 'circle', size: 5, className: 'className' }
 * @param {Object} JSONcontainer
 * @param {Object} svgContainer
 * @param {Object} labelObj
 * @returns {vis.PointItem}
 */
exports.drawPoint = function (x, y, groupTemplate, JSONcontainer, svgContainer, labelObj) {
  var point;
  if (groupTemplate.style == 'circle') {
    point = exports.getSVGElement('circle', JSONcontainer, svgContainer);
    point.setAttributeNS(null, "cx", x);
    point.setAttributeNS(null, "cy", y);
    point.setAttributeNS(null, "r", 0.5 * groupTemplate.size);
  } else {
    point = exports.getSVGElement('rect', JSONcontainer, svgContainer);
    point.setAttributeNS(null, "x", x - 0.5 * groupTemplate.size);
    point.setAttributeNS(null, "y", y - 0.5 * groupTemplate.size);
    point.setAttributeNS(null, "width", groupTemplate.size);
    point.setAttributeNS(null, "height", groupTemplate.size);
  }

  if (groupTemplate.styles !== undefined) {
    point.setAttributeNS(null, "style", groupTemplate.styles);
  }
  point.setAttributeNS(null, "class", groupTemplate.className + " vis-point");
  //handle label


  if (labelObj) {
    var label = exports.getSVGElement('text', JSONcontainer, svgContainer);
    if (labelObj.xOffset) {
      x = x + labelObj.xOffset;
    }

    if (labelObj.yOffset) {
      y = y + labelObj.yOffset;
    }
    if (labelObj.content) {
      label.textContent = labelObj.content;
    }

    if (labelObj.className) {
      label.setAttributeNS(null, "class", labelObj.className + " vis-label");
    }
    label.setAttributeNS(null, "x", x);
    label.setAttributeNS(null, "y", y);
  }

  return point;
};

/**
 * draw a bar SVG element centered on the X coordinate
 *
 * @param {number} x
 * @param {number} y
 * @param {number} width
 * @param {number} height
 * @param {string} className
 * @param {Object} JSONcontainer
 * @param {Object} svgContainer
 * @param {string} style
 */
exports.drawBar = function (x, y, width, height, className, JSONcontainer, svgContainer, style) {
  if (height != 0) {
    if (height < 0) {
      height *= -1;
      y -= height;
    }
    var rect = exports.getSVGElement('rect', JSONcontainer, svgContainer);
    rect.setAttributeNS(null, "x", x - 0.5 * width);
    rect.setAttributeNS(null, "y", y);
    rect.setAttributeNS(null, "width", width);
    rect.setAttributeNS(null, "height", height);
    rect.setAttributeNS(null, "class", className);
    if (style) {
      rect.setAttributeNS(null, "style", style);
    }
  }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printStyle = undefined;

var _stringify = __webpack_require__(19);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);

var errorFound = false;
var allOptions = void 0;
var printStyle = 'background: #FFeeee; color: #dd0000';
/**
 *  Used to validate options.
 */

var Validator = function () {
  /**
   * @ignore
   */
  function Validator() {
    (0, _classCallCheck3['default'])(this, Validator);
  }

  /**
   * Main function to be called
   * @param {Object} options
   * @param {Object} referenceOptions
   * @param {Object} subObject
   * @returns {boolean}
   * @static
   */


  (0, _createClass3['default'])(Validator, null, [{
    key: 'validate',
    value: function validate(options, referenceOptions, subObject) {
      errorFound = false;
      allOptions = referenceOptions;
      var usedOptions = referenceOptions;
      if (subObject !== undefined) {
        usedOptions = referenceOptions[subObject];
      }
      Validator.parse(options, usedOptions, []);
      return errorFound;
    }

    /**
     * Will traverse an object recursively and check every value
     * @param {Object} options
     * @param {Object} referenceOptions
     * @param {array} path    | where to look for the actual option
     * @static
     */

  }, {
    key: 'parse',
    value: function parse(options, referenceOptions, path) {
      for (var option in options) {
        if (options.hasOwnProperty(option)) {
          Validator.check(option, options, referenceOptions, path);
        }
      }
    }

    /**
     * Check every value. If the value is an object, call the parse function on that object.
     * @param {string} option
     * @param {Object} options
     * @param {Object} referenceOptions
     * @param {array} path    | where to look for the actual option
     * @static
     */

  }, {
    key: 'check',
    value: function check(option, options, referenceOptions, path) {
      if (referenceOptions[option] === undefined && referenceOptions.__any__ === undefined) {
        Validator.getSuggestion(option, referenceOptions, path);
        return;
      }

      var referenceOption = option;
      var is_object = true;

      if (referenceOptions[option] === undefined && referenceOptions.__any__ !== undefined) {
        // NOTE: This only triggers if the __any__ is in the top level of the options object.
        //       THAT'S A REALLY BAD PLACE TO ALLOW IT!!!!
        // TODO: Examine if needed, remove if possible

        // __any__ is a wildcard. Any value is accepted and will be further analysed by reference.
        referenceOption = '__any__';

        // if the any-subgroup is not a predefined object in the configurator,
        // we do not look deeper into the object.
        is_object = Validator.getType(options[option]) === 'object';
      } else {
        // Since all options in the reference are objects, we can check whether 
        // they are supposed to be the object to look for the __type__ field.
        // if this is an object, we check if the correct type has been supplied to account for shorthand options.
      }

      var refOptionObj = referenceOptions[referenceOption];
      if (is_object && refOptionObj.__type__ !== undefined) {
        refOptionObj = refOptionObj.__type__;
      }

      Validator.checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path);
    }

    /**
     *
     * @param {string}  option           | the option property
     * @param {Object}  options          | The supplied options object
     * @param {Object}  referenceOptions | The reference options containing all options and their allowed formats
     * @param {string}  referenceOption  | Usually this is the same as option, except when handling an __any__ tag.
     * @param {string}  refOptionObj     | This is the type object from the reference options
     * @param {Array}   path             | where in the object is the option
     * @static
     */

  }, {
    key: 'checkFields',
    value: function checkFields(option, options, referenceOptions, referenceOption, refOptionObj, path) {
      var log = function log(message) {
        console.log('%c' + message + Validator.printLocation(path, option), printStyle);
      };

      var optionType = Validator.getType(options[option]);
      var refOptionType = refOptionObj[optionType];

      if (refOptionType !== undefined) {
        // if the type is correct, we check if it is supposed to be one of a few select values
        if (Validator.getType(refOptionType) === 'array' && refOptionType.indexOf(options[option]) === -1) {
          log('Invalid option detected in "' + option + '".' + ' Allowed values are:' + Validator.print(refOptionType) + ' not "' + options[option] + '". ');
          errorFound = true;
        } else if (optionType === 'object' && referenceOption !== "__any__") {
          path = util.copyAndExtendArray(path, option);
          Validator.parse(options[option], referenceOptions[referenceOption], path);
        }
      } else if (refOptionObj['any'] === undefined) {
        // type of the field is incorrect and the field cannot be any
        log('Invalid type received for "' + option + '". Expected: ' + Validator.print((0, _keys2['default'])(refOptionObj)) + '. Received [' + optionType + '] "' + options[option] + '"');
        errorFound = true;
      }
    }

    /**
     *
     * @param {Object|boolean|number|string|Array.<number>|Date|Node|Moment|undefined|null} object
     * @returns {string}
     * @static
     */

  }, {
    key: 'getType',
    value: function getType(object) {
      var type = typeof object === 'undefined' ? 'undefined' : (0, _typeof3['default'])(object);

      if (type === 'object') {
        if (object === null) {
          return 'null';
        }
        if (object instanceof Boolean) {
          return 'boolean';
        }
        if (object instanceof Number) {
          return 'number';
        }
        if (object instanceof String) {
          return 'string';
        }
        if (Array.isArray(object)) {
          return 'array';
        }
        if (object instanceof Date) {
          return 'date';
        }
        if (object.nodeType !== undefined) {
          return 'dom';
        }
        if (object._isAMomentObject === true) {
          return 'moment';
        }
        return 'object';
      } else if (type === 'number') {
        return 'number';
      } else if (type === 'boolean') {
        return 'boolean';
      } else if (type === 'string') {
        return 'string';
      } else if (type === undefined) {
        return 'undefined';
      }
      return type;
    }

    /**
     * @param {string} option
     * @param {Object} options
     * @param {Array.<string>} path
     * @static
     */

  }, {
    key: 'getSuggestion',
    value: function getSuggestion(option, options, path) {
      var localSearch = Validator.findInOptions(option, options, path, false);
      var globalSearch = Validator.findInOptions(option, allOptions, [], true);

      var localSearchThreshold = 8;
      var globalSearchThreshold = 4;

      var msg = void 0;
      if (localSearch.indexMatch !== undefined) {
        msg = ' in ' + Validator.printLocation(localSearch.path, option, '') + 'Perhaps it was incomplete? Did you mean: "' + localSearch.indexMatch + '"?\n\n';
      } else if (globalSearch.distance <= globalSearchThreshold && localSearch.distance > globalSearch.distance) {
        msg = ' in ' + Validator.printLocation(localSearch.path, option, '') + 'Perhaps it was misplaced? Matching option found at: ' + Validator.printLocation(globalSearch.path, globalSearch.closestMatch, '');
      } else if (localSearch.distance <= localSearchThreshold) {
        msg = '. Did you mean "' + localSearch.closestMatch + '"?' + Validator.printLocation(localSearch.path, option);
      } else {
        msg = '. Did you mean one of these: ' + Validator.print((0, _keys2['default'])(options)) + Validator.printLocation(path, option);
      }

      console.log('%cUnknown option detected: "' + option + '"' + msg, printStyle);
      errorFound = true;
    }

    /**
     * traverse the options in search for a match.
     * @param {string} option
     * @param {Object} options
     * @param {Array} path    | where to look for the actual option
     * @param {boolean} [recursive=false]
     * @returns {{closestMatch: string, path: Array, distance: number}}
     * @static
     */

  }, {
    key: 'findInOptions',
    value: function findInOptions(option, options, path) {
      var recursive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var min = 1e9;
      var closestMatch = '';
      var closestMatchPath = [];
      var lowerCaseOption = option.toLowerCase();
      var indexMatch = undefined;
      for (var op in options) {
        // eslint-disable-line guard-for-in
        var distance = void 0;
        if (options[op].__type__ !== undefined && recursive === true) {
          var result = Validator.findInOptions(option, options[op], util.copyAndExtendArray(path, op));
          if (min > result.distance) {
            closestMatch = result.closestMatch;
            closestMatchPath = result.path;
            min = result.distance;
            indexMatch = result.indexMatch;
          }
        } else {
          if (op.toLowerCase().indexOf(lowerCaseOption) !== -1) {
            indexMatch = op;
          }
          distance = Validator.levenshteinDistance(option, op);
          if (min > distance) {
            closestMatch = op;
            closestMatchPath = util.copyArray(path);
            min = distance;
          }
        }
      }
      return { closestMatch: closestMatch, path: closestMatchPath, distance: min, indexMatch: indexMatch };
    }

    /**
     * @param {Array.<string>} path
     * @param {Object} option
     * @param {string} prefix
     * @returns {String}
     * @static
     */

  }, {
    key: 'printLocation',
    value: function printLocation(path, option) {
      var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Problem value found at: \n';

      var str = '\n\n' + prefix + 'options = {\n';
      for (var i = 0; i < path.length; i++) {
        for (var j = 0; j < i + 1; j++) {
          str += '  ';
        }
        str += path[i] + ': {\n';
      }
      for (var _j = 0; _j < path.length + 1; _j++) {
        str += '  ';
      }
      str += option + '\n';
      for (var _i = 0; _i < path.length + 1; _i++) {
        for (var _j2 = 0; _j2 < path.length - _i; _j2++) {
          str += '  ';
        }
        str += '}\n';
      }
      return str + '\n\n';
    }

    /**
     * @param {Object} options
     * @returns {String}
     * @static
     */

  }, {
    key: 'print',
    value: function print(options) {
      return (0, _stringify2['default'])(options).replace(/(\")|(\[)|(\])|(,"__type__")/g, "").replace(/(\,)/g, ', ');
    }

    /**
     *  Compute the edit distance between the two given strings
     * http://en.wikibooks.org/wiki/Algorithm_Implementation/Strings/Levenshtein_distance#JavaScript
     *
     * Copyright (c) 2011 Andrei Mackenzie
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
     *
     * @param {string} a
     * @param {string} b
     * @returns {Array.<Array.<number>>}}
     * @static
     */

  }, {
    key: 'levenshteinDistance',
    value: function levenshteinDistance(a, b) {
      if (a.length === 0) return b.length;
      if (b.length === 0) return a.length;

      var matrix = [];

      // increment along the first column of each row
      var i;
      for (i = 0; i <= b.length; i++) {
        matrix[i] = [i];
      }

      // increment each column in the first row
      var j;
      for (j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
      }

      // Fill in the rest of the matrix
      for (i = 1; i <= b.length; i++) {
        for (j = 1; j <= a.length; j++) {
          if (b.charAt(i - 1) == a.charAt(j - 1)) {
            matrix[i][j] = matrix[i - 1][j - 1];
          } else {
            matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
            Math.min(matrix[i][j - 1] + 1, // insertion
            matrix[i - 1][j] + 1)); // deletion
          }
        }
      }

      return matrix[b.length][a.length];
    }
  }]);
  return Validator;
}();

exports['default'] = Validator;
exports.printStyle = printStyle;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(2);

/**
 * Prototype for visual components
 * @param {{dom: Object, domProps: Object, emitter: Emitter, range: Range}} [body]
 * @param {Object} [options]
 */
function Component(body, options) {
  // eslint-disable-line no-unused-vars
  this.options = null;
  this.props = null;
}

/**
 * Set options for the component. The new options will be merged into the
 * current options.
 * @param {Object} options
 */
Component.prototype.setOptions = function (options) {
  if (options) {
    util.extend(this.options, options);
  }
};

/**
 * Repaint the component
 * @return {boolean} Returns true if the component is resized
 */
Component.prototype.redraw = function () {
  // should be implemented by the component
  return false;
};

/**
 * Destroy the component. Cleanup DOM and event listeners
 */
Component.prototype.destroy = function () {
  // should be implemented by the component
};

/**
 * Test whether the component is resized since the last time _isResized() was
 * called.
 * @return {Boolean} Returns true if the component is resized
 * @protected
 */
Component.prototype._isResized = function () {
  var resized = this.props._previousWidth !== this.props.width || this.props._previousHeight !== this.props.height;

  this.props._previousWidth = this.props.width;
  this.props._previousHeight = this.props.height;

  return resized;
};

module.exports = Component;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(7);
var ctx = __webpack_require__(80);
var hide = __webpack_require__(26);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(160), __esModule: true };

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(27);
var IE8_DOM_DEFINE = __webpack_require__(81);
var toPrimitive = __webpack_require__(53);
var dP = Object.defineProperty;

exports.f = __webpack_require__(21) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(28)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 22 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * The Base class for all Nodes.
 */
var NodeBase = function () {
  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function NodeBase(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, NodeBase);

    this.body = body;
    this.labelModule = labelModule;
    this.setOptions(options);
    this.top = undefined;
    this.left = undefined;
    this.height = undefined;
    this.width = undefined;
    this.radius = undefined;
    this.margin = undefined;
    this.refreshNeeded = true;
    this.boundingBox = { top: 0, left: 0, right: 0, bottom: 0 };
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3['default'])(NodeBase, [{
    key: 'setOptions',
    value: function setOptions(options) {
      this.options = options;
    }

    /**
     *
     * @param {Label} labelModule
     * @private
     */

  }, {
    key: '_setMargins',
    value: function _setMargins(labelModule) {
      this.margin = {};
      if (this.options.margin) {
        if ((0, _typeof3['default'])(this.options.margin) == 'object') {
          this.margin.top = this.options.margin.top;
          this.margin.right = this.options.margin.right;
          this.margin.bottom = this.options.margin.bottom;
          this.margin.left = this.options.margin.left;
        } else {
          this.margin.top = this.options.margin;
          this.margin.right = this.options.margin;
          this.margin.bottom = this.options.margin;
          this.margin.left = this.options.margin;
        }
      }
      labelModule.adjustSizes(this.margin);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     * @private
     */

  }, {
    key: '_distanceToBorder',
    value: function _distanceToBorder(ctx, angle) {
      var borderWidth = this.options.borderWidth;
      this.resize(ctx);
      return Math.min(Math.abs(this.width / 2 / Math.cos(angle)), Math.abs(this.height / 2 / Math.sin(angle))) + borderWidth;
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'enableShadow',
    value: function enableShadow(ctx, values) {
      if (values.shadow) {
        ctx.shadowColor = values.shadowColor;
        ctx.shadowBlur = values.shadowSize;
        ctx.shadowOffsetX = values.shadowX;
        ctx.shadowOffsetY = values.shadowY;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'disableShadow',
    value: function disableShadow(ctx, values) {
      if (values.shadow) {
        ctx.shadowColor = 'rgba(0,0,0,0)';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'enableBorderDashes',
    value: function enableBorderDashes(ctx, values) {
      if (values.borderDashes !== false) {
        if (ctx.setLineDash !== undefined) {
          var dashes = values.borderDashes;
          if (dashes === true) {
            dashes = [5, 15];
          }
          ctx.setLineDash(dashes);
        } else {
          console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used.");
          this.options.shapeProperties.borderDashes = false;
          values.borderDashes = false;
        }
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'disableBorderDashes',
    value: function disableBorderDashes(ctx, values) {
      if (values.borderDashes !== false) {
        if (ctx.setLineDash !== undefined) {
          ctx.setLineDash([0]);
        } else {
          console.warn("setLineDash is not supported in this browser. The dashed borders cannot be used.");
          this.options.shapeProperties.borderDashes = false;
          values.borderDashes = false;
        }
      }
    }

    /**
     * Determine if the shape of a node needs to be recalculated.
     *
     * @param {boolean} selected
     * @param {boolean} hover
     * @returns {boolean}
     * @protected
     */

  }, {
    key: 'needsRefresh',
    value: function needsRefresh(selected, hover) {
      if (this.refreshNeeded === true) {
        // This is probably not the best location to reset this member.
        // However, in the current logic, it is the most convenient one.
        this.refreshNeeded = false;
        return true;
      }

      return this.width === undefined || this.labelModule.differentState(selected, hover);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'initContextForDraw',
    value: function initContextForDraw(ctx, values) {
      var borderWidth = values.borderWidth / this.body.view.scale;

      ctx.lineWidth = Math.min(this.width, borderWidth);
      ctx.strokeStyle = values.borderColor;
      ctx.fillStyle = values.color;
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'performStroke',
    value: function performStroke(ctx, values) {
      var borderWidth = values.borderWidth / this.body.view.scale;

      //draw dashed border if enabled, save and restore is required for firefox not to crash on unix.
      ctx.save();
      // if borders are zero width, they will be drawn with width 1 by default. This prevents that
      if (borderWidth > 0) {
        this.enableBorderDashes(ctx, values);
        //draw the border
        ctx.stroke();
        //disable dashed border for other elements
        this.disableBorderDashes(ctx, values);
      }
      ctx.restore();
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'performFill',
    value: function performFill(ctx, values) {
      // draw shadow if enabled
      this.enableShadow(ctx, values);
      // draw the background
      ctx.fill();
      // disable shadows for other elements.
      this.disableShadow(ctx, values);

      this.performStroke(ctx, values);
    }

    /**
     *
     * @param {number} margin
     * @private
     */

  }, {
    key: '_addBoundingBoxMargin',
    value: function _addBoundingBoxMargin(margin) {
      this.boundingBox.left -= margin;
      this.boundingBox.top -= margin;
      this.boundingBox.bottom += margin;
      this.boundingBox.right += margin;
    }

    /**
     * Actual implementation of this method call.
     *
     * Doing it like this makes it easier to override
     * in the child classes.
     *
     * @param {number} x width
     * @param {number} y height
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} selected
     * @param {boolean} hover
     * @private
     */

  }, {
    key: '_updateBoundingBox',
    value: function _updateBoundingBox(x, y, ctx, selected, hover) {
      if (ctx !== undefined) {
        this.resize(ctx, selected, hover);
      }

      this.left = x - this.width / 2;
      this.top = y - this.height / 2;

      this.boundingBox.left = this.left;
      this.boundingBox.top = this.top;
      this.boundingBox.bottom = this.top + this.height;
      this.boundingBox.right = this.left + this.width;
    }

    /**
     * Default implementation of this method call.
     * This acts as a stub which can be overridden.
     *
     * @param {number} x width
     * @param {number} y height
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} selected
     * @param {boolean} hover
     */

  }, {
    key: 'updateBoundingBox',
    value: function updateBoundingBox(x, y, ctx, selected, hover) {
      this._updateBoundingBox(x, y, ctx, selected, hover);
    }

    /**
     * Determine the dimensions to use for nodes with an internal label
     *
     * Currently, these are: Circle, Ellipse, Database, Box
     * The other nodes have external labels, and will not call this method
     *
     * If there is no label, decent default values are supplied.
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} [selected]
     * @param {boolean} [hover]
     * @returns {{width:number, height:number}}
     */

  }, {
    key: 'getDimensionsFromLabel',
    value: function getDimensionsFromLabel(ctx, selected, hover) {
      // NOTE: previously 'textSize' was not put in 'this' for Ellipse
      // TODO: examine the consequences.
      this.textSize = this.labelModule.getTextSize(ctx, selected, hover);
      var width = this.textSize.width;
      var height = this.textSize.height;

      var DEFAULT_SIZE = 14;
      if (width === 0) {
        // This happens when there is no label text set
        width = DEFAULT_SIZE; // use a decent default
        height = DEFAULT_SIZE; // if width zero, then height also always zero
      }

      return { width: width, height: height };
    }
  }]);
  return NodeBase;
}();

exports['default'] = NodeBase;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NodeBase2 = __webpack_require__(23);

var _NodeBase3 = _interopRequireDefault(_NodeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Base class for constructing Node/Cluster Shapes.
 *
 * @extends NodeBase
 */
var ShapeBase = function (_NodeBase) {
  (0, _inherits3['default'])(ShapeBase, _NodeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function ShapeBase(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, ShapeBase);
    return (0, _possibleConstructorReturn3['default'])(this, (ShapeBase.__proto__ || (0, _getPrototypeOf2['default'])(ShapeBase)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   * @param {Object} [values={size: this.options.size}]
   */


  (0, _createClass3['default'])(ShapeBase, [{
    key: 'resize',
    value: function resize(ctx) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
      var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;
      var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { size: this.options.size };

      if (this.needsRefresh(selected, hover)) {
        this.labelModule.getTextSize(ctx, selected, hover);
        var size = 2 * values.size;
        this.width = size;
        this.height = size;
        this.radius = 0.5 * this.width;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {string} shape
     * @param {number} sizeMultiplier - Unused! TODO: Remove next major release
     * @param {number} x
     * @param {number} y
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     * @private
     */

  }, {
    key: '_drawShape',
    value: function _drawShape(ctx, shape, sizeMultiplier, x, y, selected, hover, values) {
      this.resize(ctx, selected, hover, values);
      this.left = x - this.width / 2;
      this.top = y - this.height / 2;

      this.initContextForDraw(ctx, values);
      ctx[shape](x, y, values.size);
      this.performFill(ctx, values);

      if (this.options.label !== undefined) {
        // Need to call following here in order to ensure value for `this.labelModule.size.height`
        this.labelModule.calculateLabelSize(ctx, selected, hover, x, y, 'hanging');
        var yLabel = y + 0.5 * this.height + 0.5 * this.labelModule.size.height;
        this.labelModule.draw(ctx, x, yLabel, selected, hover, 'hanging');
      }

      this.updateBoundingBox(x, y);
    }

    /**
     *
     * @param {number} x
     * @param {number} y
     */

  }, {
    key: 'updateBoundingBox',
    value: function updateBoundingBox(x, y) {
      this.boundingBox.top = y - this.options.size;
      this.boundingBox.left = x - this.options.size;
      this.boundingBox.right = x + this.options.size;
      this.boundingBox.bottom = y + this.options.size;

      if (this.options.label !== undefined && this.labelModule.size.width > 0) {
        this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
        this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
        this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height);
      }
    }
  }]);
  return ShapeBase;
}(_NodeBase3['default']);

exports['default'] = ShapeBase;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(78);
var defined = __webpack_require__(51);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var createDesc = __webpack_require__(39);
module.exports = __webpack_require__(21) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(138), __esModule: true };

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(188);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(77);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(84);
var enumBugKeys = __webpack_require__(58);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @prototype Point3d
 * @param {number} [x]
 * @param {number} [y]
 * @param {number} [z]
 */
function Point3d(x, y, z) {
  this.x = x !== undefined ? x : 0;
  this.y = y !== undefined ? y : 0;
  this.z = z !== undefined ? z : 0;
}

/**
 * Subtract the two provided points, returns a-b
 * @param {Point3d} a
 * @param {Point3d} b
 * @return {Point3d} a-b
 */
Point3d.subtract = function (a, b) {
  var sub = new Point3d();
  sub.x = a.x - b.x;
  sub.y = a.y - b.y;
  sub.z = a.z - b.z;
  return sub;
};

/**
 * Add the two provided points, returns a+b
 * @param {Point3d} a
 * @param {Point3d} b
 * @return {Point3d} a+b
 */
Point3d.add = function (a, b) {
  var sum = new Point3d();
  sum.x = a.x + b.x;
  sum.y = a.y + b.y;
  sum.z = a.z + b.z;
  return sum;
};

/**
 * Calculate the average of two 3d points
 * @param {Point3d} a
 * @param {Point3d} b
 * @return {Point3d} The average, (a+b)/2
 */
Point3d.avg = function (a, b) {
  return new Point3d((a.x + b.x) / 2, (a.y + b.y) / 2, (a.z + b.z) / 2);
};

/**
 * Calculate the cross product of the two provided points, returns axb
 * Documentation: http://en.wikipedia.org/wiki/Cross_product
 * @param {Point3d} a
 * @param {Point3d} b
 * @return {Point3d} cross product axb
 */
Point3d.crossProduct = function (a, b) {
  var crossproduct = new Point3d();

  crossproduct.x = a.y * b.z - a.z * b.y;
  crossproduct.y = a.z * b.x - a.x * b.z;
  crossproduct.z = a.x * b.y - a.y * b.x;

  return crossproduct;
};

/**
 * Rtrieve the length of the vector (or the distance from this point to the origin
 * @return {number}  length
 */
Point3d.prototype.length = function () {
  return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
};

module.exports = Point3d;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
/**
 * Created by Alex on 11/6/2014.
 */

// https://github.com/umdjs/umd/blob/master/returnExports.js#L40-L60
// if the module has no dependencies, the above pattern can be simplified to
(function (root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.keycharm = factory();
  }
}(this, function () {

  function keycharm(options) {
    var preventDefault = options && options.preventDefault || false;

    var container = options && options.container || window;

    var _exportFunctions = {};
    var _bound = {keydown:{}, keyup:{}};
    var _keys = {};
    var i;

    // a - z
    for (i = 97; i <= 122; i++) {_keys[String.fromCharCode(i)] = {code:65 + (i - 97), shift: false};}
    // A - Z
    for (i = 65; i <= 90; i++) {_keys[String.fromCharCode(i)] = {code:i, shift: true};}
    // 0 - 9
    for (i = 0;  i <= 9;   i++) {_keys['' + i] = {code:48 + i, shift: false};}
    // F1 - F12
    for (i = 1;  i <= 12;   i++) {_keys['F' + i] = {code:111 + i, shift: false};}
    // num0 - num9
    for (i = 0;  i <= 9;   i++) {_keys['num' + i] = {code:96 + i, shift: false};}

    // numpad misc
    _keys['num*'] = {code:106, shift: false};
    _keys['num+'] = {code:107, shift: false};
    _keys['num-'] = {code:109, shift: false};
    _keys['num/'] = {code:111, shift: false};
    _keys['num.'] = {code:110, shift: false};
    // arrows
    _keys['left']  = {code:37, shift: false};
    _keys['up']    = {code:38, shift: false};
    _keys['right'] = {code:39, shift: false};
    _keys['down']  = {code:40, shift: false};
    // extra keys
    _keys['space'] = {code:32, shift: false};
    _keys['enter'] = {code:13, shift: false};
    _keys['shift'] = {code:16, shift: undefined};
    _keys['esc']   = {code:27, shift: false};
    _keys['backspace'] = {code:8, shift: false};
    _keys['tab']       = {code:9, shift: false};
    _keys['ctrl']      = {code:17, shift: false};
    _keys['alt']       = {code:18, shift: false};
    _keys['delete']    = {code:46, shift: false};
    _keys['pageup']    = {code:33, shift: false};
    _keys['pagedown']  = {code:34, shift: false};
    // symbols
    _keys['=']     = {code:187, shift: false};
    _keys['-']     = {code:189, shift: false};
    _keys[']']     = {code:221, shift: false};
    _keys['[']     = {code:219, shift: false};



    var down = function(event) {handleEvent(event,'keydown');};
    var up = function(event) {handleEvent(event,'keyup');};

    // handle the actualy bound key with the event
    var handleEvent = function(event,type) {
      if (_bound[type][event.keyCode] !== undefined) {
        var bound = _bound[type][event.keyCode];
        for (var i = 0; i < bound.length; i++) {
          if (bound[i].shift === undefined) {
            bound[i].fn(event);
          }
          else if (bound[i].shift == true && event.shiftKey == true) {
            bound[i].fn(event);
          }
          else if (bound[i].shift == false && event.shiftKey == false) {
            bound[i].fn(event);
          }
        }

        if (preventDefault == true) {
          event.preventDefault();
        }
      }
    };

    // bind a key to a callback
    _exportFunctions.bind = function(key, callback, type) {
      if (type === undefined) {
        type = 'keydown';
      }
      if (_keys[key] === undefined) {
        throw new Error("unsupported key: " + key);
      }
      if (_bound[type][_keys[key].code] === undefined) {
        _bound[type][_keys[key].code] = [];
      }
      _bound[type][_keys[key].code].push({fn:callback, shift:_keys[key].shift});
    };


    // bind all keys to a call back (demo purposes)
    _exportFunctions.bindAll = function(callback, type) {
      if (type === undefined) {
        type = 'keydown';
      }
      for (var key in _keys) {
        if (_keys.hasOwnProperty(key)) {
          _exportFunctions.bind(key,callback,type);
        }
      }
    };

    // get the key label from an event
    _exportFunctions.getKey = function(event) {
      for (var key in _keys) {
        if (_keys.hasOwnProperty(key)) {
          if (event.shiftKey == true && _keys[key].shift == true && event.keyCode == _keys[key].code) {
            return key;
          }
          else if (event.shiftKey == false && _keys[key].shift == false && event.keyCode == _keys[key].code) {
            return key;
          }
          else if (event.keyCode == _keys[key].code && key == 'shift') {
            return key;
          }
        }
      }
      return "unknown key, currently not supported";
    };

    // unbind either a specific callback from a key or all of them (by leaving callback undefined)
    _exportFunctions.unbind = function(key, callback, type) {
      if (type === undefined) {
        type = 'keydown';
      }
      if (_keys[key] === undefined) {
        throw new Error("unsupported key: " + key);
      }
      if (callback !== undefined) {
        var newBindings = [];
        var bound = _bound[type][_keys[key].code];
        if (bound !== undefined) {
          for (var i = 0; i < bound.length; i++) {
            if (!(bound[i].fn == callback && bound[i].shift == _keys[key].shift)) {
              newBindings.push(_bound[type][_keys[key].code][i]);
            }
          }
        }
        _bound[type][_keys[key].code] = newBindings;
      }
      else {
        _bound[type][_keys[key].code] = [];
      }
    };

    // reset all bound variables.
    _exportFunctions.reset = function() {
      _bound = {keydown:{}, keyup:{}};
    };

    // unbind all listeners and reset all variables.
    _exportFunctions.destroy = function() {
      _bound = {keydown:{}, keyup:{}};
      container.removeEventListener('keydown', down, true);
      container.removeEventListener('keyup', up, true);
    };

    // create listeners.
    container.addEventListener('keydown',down,true);
    container.addEventListener('keyup',up,true);

    // return the public functions.
    return _exportFunctions;
  }

  return keycharm;
}));




/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * used in Core to convert the options into a volatile variable
 * 
 * @param {function} moment
 * @param {Object} body
 * @param {Array | Object} hiddenDates
 * @returns {number}
 */
exports.convertHiddenOptions = function (moment, body, hiddenDates) {
  if (hiddenDates && !Array.isArray(hiddenDates)) {
    return exports.convertHiddenOptions(moment, body, [hiddenDates]);
  }

  body.hiddenDates = [];
  if (hiddenDates) {
    if (Array.isArray(hiddenDates) == true) {
      for (var i = 0; i < hiddenDates.length; i++) {
        if (hiddenDates[i].repeat === undefined) {
          var dateItem = {};
          dateItem.start = moment(hiddenDates[i].start).toDate().valueOf();
          dateItem.end = moment(hiddenDates[i].end).toDate().valueOf();
          body.hiddenDates.push(dateItem);
        }
      }
      body.hiddenDates.sort(function (a, b) {
        return a.start - b.start;
      }); // sort by start time
    }
  }
};

/**
 * create new entrees for the repeating hidden dates
 *
 * @param {function} moment
 * @param {Object} body
 * @param {Array | Object} hiddenDates
 * @returns {null}
 */
exports.updateHiddenDates = function (moment, body, hiddenDates) {
  if (hiddenDates && !Array.isArray(hiddenDates)) {
    return exports.updateHiddenDates(moment, body, [hiddenDates]);
  }

  if (hiddenDates && body.domProps.centerContainer.width !== undefined) {
    exports.convertHiddenOptions(moment, body, hiddenDates);

    var start = moment(body.range.start);
    var end = moment(body.range.end);

    var totalRange = body.range.end - body.range.start;
    var pixelTime = totalRange / body.domProps.centerContainer.width;

    for (var i = 0; i < hiddenDates.length; i++) {
      if (hiddenDates[i].repeat !== undefined) {
        var startDate = moment(hiddenDates[i].start);
        var endDate = moment(hiddenDates[i].end);

        if (startDate._d == "Invalid Date") {
          throw new Error("Supplied start date is not valid: " + hiddenDates[i].start);
        }
        if (endDate._d == "Invalid Date") {
          throw new Error("Supplied end date is not valid: " + hiddenDates[i].end);
        }

        var duration = endDate - startDate;
        if (duration >= 4 * pixelTime) {

          var offset = 0;
          var runUntil = end.clone();
          switch (hiddenDates[i].repeat) {
            case "daily":
              // case of time
              if (startDate.day() != endDate.day()) {
                offset = 1;
              }
              startDate.dayOfYear(start.dayOfYear());
              startDate.year(start.year());
              startDate.subtract(7, 'days');

              endDate.dayOfYear(start.dayOfYear());
              endDate.year(start.year());
              endDate.subtract(7 - offset, 'days');

              runUntil.add(1, 'weeks');
              break;
            case "weekly":
              var dayOffset = endDate.diff(startDate, 'days');
              var day = startDate.day();

              // set the start date to the range.start
              startDate.date(start.date());
              startDate.month(start.month());
              startDate.year(start.year());
              endDate = startDate.clone();

              // force
              startDate.day(day);
              endDate.day(day);
              endDate.add(dayOffset, 'days');

              startDate.subtract(1, 'weeks');
              endDate.subtract(1, 'weeks');

              runUntil.add(1, 'weeks');
              break;
            case "monthly":
              if (startDate.month() != endDate.month()) {
                offset = 1;
              }
              startDate.month(start.month());
              startDate.year(start.year());
              startDate.subtract(1, 'months');

              endDate.month(start.month());
              endDate.year(start.year());
              endDate.subtract(1, 'months');
              endDate.add(offset, 'months');

              runUntil.add(1, 'months');
              break;
            case "yearly":
              if (startDate.year() != endDate.year()) {
                offset = 1;
              }
              startDate.year(start.year());
              startDate.subtract(1, 'years');
              endDate.year(start.year());
              endDate.subtract(1, 'years');
              endDate.add(offset, 'years');

              runUntil.add(1, 'years');
              break;
            default:
              console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", hiddenDates[i].repeat);
              return;
          }
          while (startDate < runUntil) {
            body.hiddenDates.push({ start: startDate.valueOf(), end: endDate.valueOf() });
            switch (hiddenDates[i].repeat) {
              case "daily":
                startDate.add(1, 'days');
                endDate.add(1, 'days');
                break;
              case "weekly":
                startDate.add(1, 'weeks');
                endDate.add(1, 'weeks');
                break;
              case "monthly":
                startDate.add(1, 'months');
                endDate.add(1, 'months');
                break;
              case "yearly":
                startDate.add(1, 'y');
                endDate.add(1, 'y');
                break;
              default:
                console.log("Wrong repeat format, allowed are: daily, weekly, monthly, yearly. Given:", hiddenDates[i].repeat);
                return;
            }
          }
          body.hiddenDates.push({ start: startDate.valueOf(), end: endDate.valueOf() });
        }
      }
    }
    // remove duplicates, merge where possible
    exports.removeDuplicates(body);
    // ensure the new positions are not on hidden dates
    var startHidden = exports.isHidden(body.range.start, body.hiddenDates);
    var endHidden = exports.isHidden(body.range.end, body.hiddenDates);
    var rangeStart = body.range.start;
    var rangeEnd = body.range.end;
    if (startHidden.hidden == true) {
      rangeStart = body.range.startToFront == true ? startHidden.startDate - 1 : startHidden.endDate + 1;
    }
    if (endHidden.hidden == true) {
      rangeEnd = body.range.endToFront == true ? endHidden.startDate - 1 : endHidden.endDate + 1;
    }
    if (startHidden.hidden == true || endHidden.hidden == true) {
      body.range._applyRange(rangeStart, rangeEnd);
    }
  }
};

/**
 * remove duplicates from the hidden dates list. Duplicates are evil. They mess everything up.
 * Scales with N^2
 *
 * @param {Object} body
 */
exports.removeDuplicates = function (body) {
  var hiddenDates = body.hiddenDates;
  var safeDates = [];
  for (var i = 0; i < hiddenDates.length; i++) {
    for (var j = 0; j < hiddenDates.length; j++) {
      if (i != j && hiddenDates[j].remove != true && hiddenDates[i].remove != true) {
        // j inside i
        if (hiddenDates[j].start >= hiddenDates[i].start && hiddenDates[j].end <= hiddenDates[i].end) {
          hiddenDates[j].remove = true;
        }
        // j start inside i
        else if (hiddenDates[j].start >= hiddenDates[i].start && hiddenDates[j].start <= hiddenDates[i].end) {
            hiddenDates[i].end = hiddenDates[j].end;
            hiddenDates[j].remove = true;
          }
          // j end inside i
          else if (hiddenDates[j].end >= hiddenDates[i].start && hiddenDates[j].end <= hiddenDates[i].end) {
              hiddenDates[i].start = hiddenDates[j].start;
              hiddenDates[j].remove = true;
            }
      }
    }
  }

  for (i = 0; i < hiddenDates.length; i++) {
    if (hiddenDates[i].remove !== true) {
      safeDates.push(hiddenDates[i]);
    }
  }

  body.hiddenDates = safeDates;
  body.hiddenDates.sort(function (a, b) {
    return a.start - b.start;
  }); // sort by start time
};

exports.printDates = function (dates) {
  for (var i = 0; i < dates.length; i++) {
    console.log(i, new Date(dates[i].start), new Date(dates[i].end), dates[i].start, dates[i].end, dates[i].remove);
  }
};

/**
 * Used in TimeStep to avoid the hidden times.
 * @param {function} moment
 * @param {TimeStep} timeStep
 * @param {Date} previousTime
 */
exports.stepOverHiddenDates = function (moment, timeStep, previousTime) {
  var stepInHidden = false;
  var currentValue = timeStep.current.valueOf();
  for (var i = 0; i < timeStep.hiddenDates.length; i++) {
    var startDate = timeStep.hiddenDates[i].start;
    var endDate = timeStep.hiddenDates[i].end;
    if (currentValue >= startDate && currentValue < endDate) {
      stepInHidden = true;
      break;
    }
  }

  if (stepInHidden == true && currentValue < timeStep._end.valueOf() && currentValue != previousTime) {
    var prevValue = moment(previousTime);
    var newValue = moment(endDate);
    //check if the next step should be major
    if (prevValue.year() != newValue.year()) {
      timeStep.switchedYear = true;
    } else if (prevValue.month() != newValue.month()) {
      timeStep.switchedMonth = true;
    } else if (prevValue.dayOfYear() != newValue.dayOfYear()) {
      timeStep.switchedDay = true;
    }

    timeStep.current = newValue;
  }
};

///**
// * Used in TimeStep to avoid the hidden times.
// * @param timeStep
// * @param previousTime
// */
//exports.checkFirstStep = function(timeStep) {
//  var stepInHidden = false;
//  var currentValue = timeStep.current.valueOf();
//  for (var i = 0; i < timeStep.hiddenDates.length; i++) {
//    var startDate = timeStep.hiddenDates[i].start;
//    var endDate = timeStep.hiddenDates[i].end;
//    if (currentValue >= startDate && currentValue < endDate) {
//      stepInHidden = true;
//      break;
//    }
//  }
//
//  if (stepInHidden == true && currentValue <= timeStep._end.valueOf()) {
//    var newValue = moment(endDate);
//    timeStep.current = newValue.toDate();
//  }
//};

/**
 * replaces the Core toScreen methods
 *
 * @param {vis.Core} Core
 * @param {Date} time
 * @param {number} width
 * @returns {number}
 */
exports.toScreen = function (Core, time, width) {
  var conversion;
  if (Core.body.hiddenDates.length == 0) {
    conversion = Core.range.conversion(width);
    return (time.valueOf() - conversion.offset) * conversion.scale;
  } else {
    var hidden = exports.isHidden(time, Core.body.hiddenDates);
    if (hidden.hidden == true) {
      time = hidden.startDate;
    }

    var duration = exports.getHiddenDurationBetween(Core.body.hiddenDates, Core.range.start, Core.range.end);
    if (time < Core.range.start) {
      conversion = Core.range.conversion(width, duration);
      var hiddenBeforeStart = exports.getHiddenDurationBeforeStart(Core.body.hiddenDates, time, conversion.offset);
      time = Core.options.moment(time).toDate().valueOf();
      time = time + hiddenBeforeStart;
      return -(conversion.offset - time.valueOf()) * conversion.scale;
    } else if (time > Core.range.end) {
      var rangeAfterEnd = { start: Core.range.start, end: time };
      time = exports.correctTimeForHidden(Core.options.moment, Core.body.hiddenDates, rangeAfterEnd, time);
      conversion = Core.range.conversion(width, duration);
      return (time.valueOf() - conversion.offset) * conversion.scale;
    } else {
      time = exports.correctTimeForHidden(Core.options.moment, Core.body.hiddenDates, Core.range, time);
      conversion = Core.range.conversion(width, duration);
      return (time.valueOf() - conversion.offset) * conversion.scale;
    }
  }
};

/**
 * Replaces the core toTime methods
 *
 * @param {vis.Core} Core
 * @param {number} x
 * @param {number} width
 * @returns {Date}
 */
exports.toTime = function (Core, x, width) {
  if (Core.body.hiddenDates.length == 0) {
    var conversion = Core.range.conversion(width);
    return new Date(x / conversion.scale + conversion.offset);
  } else {
    var hiddenDuration = exports.getHiddenDurationBetween(Core.body.hiddenDates, Core.range.start, Core.range.end);
    var totalDuration = Core.range.end - Core.range.start - hiddenDuration;
    var partialDuration = totalDuration * x / width;
    var accumulatedHiddenDuration = exports.getAccumulatedHiddenDuration(Core.body.hiddenDates, Core.range, partialDuration);

    return new Date(accumulatedHiddenDuration + partialDuration + Core.range.start);
  }
};

/**
 * Support function
 *
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {number} start
 * @param {number} end
 * @returns {number}
 */
exports.getHiddenDurationBetween = function (hiddenDates, start, end) {
  var duration = 0;
  for (var i = 0; i < hiddenDates.length; i++) {
    var startDate = hiddenDates[i].start;
    var endDate = hiddenDates[i].end;
    // if time after the cutout, and the
    if (startDate >= start && endDate < end) {
      duration += endDate - startDate;
    }
  }
  return duration;
};

/**
 * Support function
 *
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {number} start
 * @param {number} end
 * @returns {number}
 */
exports.getHiddenDurationBeforeStart = function (hiddenDates, start, end) {
  var duration = 0;
  for (var i = 0; i < hiddenDates.length; i++) {
    var startDate = hiddenDates[i].start;
    var endDate = hiddenDates[i].end;

    if (startDate >= start && endDate <= end) {
      duration += endDate - startDate;
    }
  }
  return duration;
};

/**
 * Support function
 * @param {function} moment
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {{start: number, end: number}} range
 * @param {Date} time
 * @returns {number}
 */
exports.correctTimeForHidden = function (moment, hiddenDates, range, time) {
  time = moment(time).toDate().valueOf();
  time -= exports.getHiddenDurationBefore(moment, hiddenDates, range, time);
  return time;
};

exports.getHiddenDurationBefore = function (moment, hiddenDates, range, time) {
  var timeOffset = 0;
  time = moment(time).toDate().valueOf();

  for (var i = 0; i < hiddenDates.length; i++) {
    var startDate = hiddenDates[i].start;
    var endDate = hiddenDates[i].end;
    // if time after the cutout, and the
    if (startDate >= range.start && endDate < range.end) {
      if (time >= endDate) {
        timeOffset += endDate - startDate;
      }
    }
  }
  return timeOffset;
};

/**
 * sum the duration from start to finish, including the hidden duration,
 * until the required amount has been reached, return the accumulated hidden duration
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {{start: number, end: number}} range
 * @param {number} [requiredDuration=0]
 * @returns {number}
 */
exports.getAccumulatedHiddenDuration = function (hiddenDates, range, requiredDuration) {
  var hiddenDuration = 0;
  var duration = 0;
  var previousPoint = range.start;
  //exports.printDates(hiddenDates)
  for (var i = 0; i < hiddenDates.length; i++) {
    var startDate = hiddenDates[i].start;
    var endDate = hiddenDates[i].end;
    // if time after the cutout, and the
    if (startDate >= range.start && endDate < range.end) {
      duration += startDate - previousPoint;
      previousPoint = endDate;
      if (duration >= requiredDuration) {
        break;
      } else {
        hiddenDuration += endDate - startDate;
      }
    }
  }

  return hiddenDuration;
};

/**
 * used to step over to either side of a hidden block. Correction is disabled on tablets, might be set to true
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @param {Date} time
 * @param {number} direction
 * @param {boolean} correctionEnabled
 * @returns {Date|number}
 */
exports.snapAwayFromHidden = function (hiddenDates, time, direction, correctionEnabled) {
  var isHidden = exports.isHidden(time, hiddenDates);
  if (isHidden.hidden == true) {
    if (direction < 0) {
      if (correctionEnabled == true) {
        return isHidden.startDate - (isHidden.endDate - time) - 1;
      } else {
        return isHidden.startDate - 1;
      }
    } else {
      if (correctionEnabled == true) {
        return isHidden.endDate + (time - isHidden.startDate) + 1;
      } else {
        return isHidden.endDate + 1;
      }
    }
  } else {
    return time;
  }
};

/**
 * Check if a time is hidden
 *
 * @param {Date} time
 * @param {Array.<{start: Window.start, end: *}>} hiddenDates
 * @returns {{hidden: boolean, startDate: Window.start, endDate: *}}
 */
exports.isHidden = function (time, hiddenDates) {
  for (var i = 0; i < hiddenDates.length; i++) {
    var startDate = hiddenDates[i].start;
    var endDate = hiddenDates[i].end;

    if (time >= startDate && time < endDate) {
      // if the start is entering a hidden zone
      return { hidden: true, startDate: startDate, endDate: endDate };
    }
  }
  return { hidden: false, startDate: startDate, endDate: endDate };
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Register a touch event, taking place before a gesture
 * @param {Hammer} hammer       A hammer instance
 * @param {function} callback   Callback, called as callback(event)
 */
exports.onTouch = function (hammer, callback) {
  callback.inputHandler = function (event) {
    if (event.isFirst) {
      callback(event);
    }
  };

  hammer.on('hammer.input', callback.inputHandler);
};

/**
 * Register a release event, taking place after a gesture
 * @param {Hammer} hammer       A hammer instance
 * @param {function} callback   Callback, called as callback(event)
 * @returns {*}
 */
exports.onRelease = function (hammer, callback) {
  callback.inputHandler = function (event) {
    if (event.isFinal) {
      callback(event);
    }
  };

  return hammer.on('hammer.input', callback.inputHandler);
};

/**
 * Unregister a touch event, taking place before a gesture
 * @param {Hammer} hammer       A hammer instance
 * @param {function} callback   Callback, called as callback(event)
 */
exports.offTouch = function (hammer, callback) {
  hammer.off('hammer.input', callback.inputHandler);
};

/**
 * Unregister a release event, taking place before a gesture
 * @param {Hammer} hammer       A hammer instance
 * @param {function} callback   Callback, called as callback(event)
 */
exports.offRelease = exports.offTouch;

/**
 * Hack the PinchRecognizer such that it doesn't prevent default behavior
 * for vertical panning.
 *
 * Yeah ... this is quite a hack ... see https://github.com/hammerjs/hammer.js/issues/932
 *
 * @param {Hammer.Pinch} pinchRecognizer
 * @return {Hammer.Pinch} returns the pinchRecognizer
 */
exports.disablePreventDefaultVertically = function (pinchRecognizer) {
  var TOUCH_ACTION_PAN_Y = 'pan-y';

  pinchRecognizer.getTouchAction = function () {
    // default method returns [TOUCH_ACTION_NONE]
    return [TOUCH_ACTION_PAN_Y];
  };

  return pinchRecognizer;
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Hammer = __webpack_require__(10);
var util = __webpack_require__(2);
var moment = __webpack_require__(9);

/**
 * @constructor Item
 * @param {Object} data             Object containing (optional) parameters type,
 *                                  start, end, content, group, className.
 * @param {{toScreen: function, toTime: function}} conversion
 *                                  Conversion functions from time to screen and vice versa
 * @param {Object} options          Configuration options
 *                                  // TODO: describe available options
 */
function Item(data, conversion, options) {
  this.id = null;
  this.parent = null;
  this.data = data;
  this.dom = null;
  this.conversion = conversion || {};
  this.options = options || {};
  this.selected = false;
  this.displayed = false;
  this.groupShowing = true;
  this.dirty = true;

  this.top = null;
  this.right = null;
  this.left = null;
  this.width = null;
  this.height = null;

  this.editable = null;
  this._updateEditStatus();
}

Item.prototype.stack = true;

/**
 * Select current item
 */
Item.prototype.select = function () {
  this.selected = true;
  this.dirty = true;
  if (this.displayed) this.redraw();
};

/**
 * Unselect current item
 */
Item.prototype.unselect = function () {
  this.selected = false;
  this.dirty = true;
  if (this.displayed) this.redraw();
};

/**
 * Set data for the item. Existing data will be updated. The id should not
 * be changed. When the item is displayed, it will be redrawn immediately.
 * @param {Object} data
 */
Item.prototype.setData = function (data) {
  var groupChanged = data.group != undefined && this.data.group != data.group;
  if (groupChanged && this.parent != null) {
    this.parent.itemSet._moveToGroup(this, data.group);
  }

  if (this.parent) {
    this.parent.stackDirty = true;
  }

  var subGroupChanged = data.subgroup != undefined && this.data.subgroup != data.subgroup;
  if (subGroupChanged && this.parent != null) {
    this.parent.changeSubgroup(this, this.data.subgroup, data.subgroup);
  }

  this.data = data;
  this._updateEditStatus();
  this.dirty = true;
  if (this.displayed) this.redraw();
};

/**
 * Set a parent for the item
 * @param {Group} parent
 */
Item.prototype.setParent = function (parent) {
  if (this.displayed) {
    this.hide();
    this.parent = parent;
    if (this.parent) {
      this.show();
    }
  } else {
    this.parent = parent;
  }
};

/**
 * Check whether this item is visible inside given range
 * @param {vis.Range} range with a timestamp for start and end
 * @returns {boolean} True if visible
 */
Item.prototype.isVisible = function (range) {
  // eslint-disable-line no-unused-vars
  return false;
};

/**
 * Show the Item in the DOM (when not already visible)
 * @return {Boolean} changed
 */
Item.prototype.show = function () {
  return false;
};

/**
 * Hide the Item from the DOM (when visible)
 * @return {Boolean} changed
 */
Item.prototype.hide = function () {
  return false;
};

/**
 * Repaint the item
 */
Item.prototype.redraw = function () {
  // should be implemented by the item
};

/**
 * Reposition the Item horizontally
 */
Item.prototype.repositionX = function () {
  // should be implemented by the item
};

/**
 * Reposition the Item vertically
 */
Item.prototype.repositionY = function () {
  // should be implemented by the item
};

/**
 * Repaint a drag area on the center of the item when the item is selected
 * @protected
 */
Item.prototype._repaintDragCenter = function () {
  if (this.selected && this.options.editable.updateTime && !this.dom.dragCenter) {
    var me = this;
    // create and show drag area
    var dragCenter = document.createElement('div');
    dragCenter.className = 'vis-drag-center';
    dragCenter.dragCenterItem = this;
    var hammer = new Hammer(dragCenter);

    hammer.on('tap', function (event) {
      me.parent.itemSet.body.emitter.emit('click', {
        event: event,
        item: me.id
      });
    });
    hammer.on('doubletap', function (event) {
      event.stopPropagation();
      me.parent.itemSet._onUpdateItem(me);
      me.parent.itemSet.body.emitter.emit('doubleClick', {
        event: event,
        item: me.id
      });
    });

    if (this.dom.box) {
      if (this.dom.dragLeft) {
        this.dom.box.insertBefore(dragCenter, this.dom.dragLeft);
      } else {
        this.dom.box.appendChild(dragCenter);
      }
    } else if (this.dom.point) {
      this.dom.point.appendChild(dragCenter);
    }

    this.dom.dragCenter = dragCenter;
  } else if (!this.selected && this.dom.dragCenter) {
    // delete drag area
    if (this.dom.dragCenter.parentNode) {
      this.dom.dragCenter.parentNode.removeChild(this.dom.dragCenter);
    }
    this.dom.dragCenter = null;
  }
};

/**
 * Repaint a delete button on the top right of the item when the item is selected
 * @param {HTMLElement} anchor
 * @protected
 */
Item.prototype._repaintDeleteButton = function (anchor) {
  var editable = (this.options.editable.overrideItems || this.editable == null) && this.options.editable.remove || !this.options.editable.overrideItems && this.editable != null && this.editable.remove;

  if (this.selected && editable && !this.dom.deleteButton) {
    // create and show button
    var me = this;

    var deleteButton = document.createElement('div');

    if (this.options.rtl) {
      deleteButton.className = 'vis-delete-rtl';
    } else {
      deleteButton.className = 'vis-delete';
    }
    deleteButton.title = 'Delete this item';

    // TODO: be able to destroy the delete button
    new Hammer(deleteButton).on('tap', function (event) {
      event.stopPropagation();
      me.parent.removeFromDataSet(me);
    });

    anchor.appendChild(deleteButton);
    this.dom.deleteButton = deleteButton;
  } else if (!this.selected && this.dom.deleteButton) {
    // remove button
    if (this.dom.deleteButton.parentNode) {
      this.dom.deleteButton.parentNode.removeChild(this.dom.deleteButton);
    }
    this.dom.deleteButton = null;
  }
};

/**
 * Repaint a onChange tooltip on the top right of the item when the item is selected
 * @param {HTMLElement} anchor
 * @protected
 */
Item.prototype._repaintOnItemUpdateTimeTooltip = function (anchor) {
  if (!this.options.tooltipOnItemUpdateTime) return;

  var editable = (this.options.editable.updateTime || this.data.editable === true) && this.data.editable !== false;

  if (this.selected && editable && !this.dom.onItemUpdateTimeTooltip) {
    var onItemUpdateTimeTooltip = document.createElement('div');

    onItemUpdateTimeTooltip.className = 'vis-onUpdateTime-tooltip';
    anchor.appendChild(onItemUpdateTimeTooltip);
    this.dom.onItemUpdateTimeTooltip = onItemUpdateTimeTooltip;
  } else if (!this.selected && this.dom.onItemUpdateTimeTooltip) {
    // remove button
    if (this.dom.onItemUpdateTimeTooltip.parentNode) {
      this.dom.onItemUpdateTimeTooltip.parentNode.removeChild(this.dom.onItemUpdateTimeTooltip);
    }
    this.dom.onItemUpdateTimeTooltip = null;
  }

  // position onChange tooltip
  if (this.dom.onItemUpdateTimeTooltip) {

    // only show when editing
    this.dom.onItemUpdateTimeTooltip.style.visibility = this.parent.itemSet.touchParams.itemIsDragging ? 'visible' : 'hidden';

    // position relative to item's content
    if (this.options.rtl) {
      this.dom.onItemUpdateTimeTooltip.style.right = this.dom.content.style.right;
    } else {
      this.dom.onItemUpdateTimeTooltip.style.left = this.dom.content.style.left;
    }

    // position above or below the item depending on the item's position in the window
    var tooltipOffset = 50; // TODO: should be tooltip height (depends on template)
    var scrollTop = this.parent.itemSet.body.domProps.scrollTop;

    // TODO: this.top for orientation:true is actually the items distance from the bottom... 
    // (should be this.bottom)
    var itemDistanceFromTop;
    if (this.options.orientation.item == 'top') {
      itemDistanceFromTop = this.top;
    } else {
      itemDistanceFromTop = this.parent.height - this.top - this.height;
    }
    var isCloseToTop = itemDistanceFromTop + this.parent.top - tooltipOffset < -scrollTop;

    if (isCloseToTop) {
      this.dom.onItemUpdateTimeTooltip.style.bottom = "";
      this.dom.onItemUpdateTimeTooltip.style.top = this.height + 2 + "px";
    } else {
      this.dom.onItemUpdateTimeTooltip.style.top = "";
      this.dom.onItemUpdateTimeTooltip.style.bottom = this.height + 2 + "px";
    }

    // handle tooltip content
    var content;
    var templateFunction;

    if (this.options.tooltipOnItemUpdateTime && this.options.tooltipOnItemUpdateTime.template) {
      templateFunction = this.options.tooltipOnItemUpdateTime.template.bind(this);
      content = templateFunction(this.data);
    } else {
      content = 'start: ' + moment(this.data.start).format('MM/DD/YYYY hh:mm');
      if (this.data.end) {
        content += '<br> end: ' + moment(this.data.end).format('MM/DD/YYYY hh:mm');
      }
    }
    this.dom.onItemUpdateTimeTooltip.innerHTML = content;
  }
};

/**
 * Set HTML contents for the item
 * @param {Element} element   HTML element to fill with the contents
 * @private
 */
Item.prototype._updateContents = function (element) {
  var content;
  var changed;
  var templateFunction;
  var itemVisibleFrameContent;
  var visibleFrameTemplateFunction;
  var itemData = this.parent.itemSet.itemsData.get(this.id); // get a clone of the data from the dataset

  var frameElement = this.dom.box || this.dom.point;
  var itemVisibleFrameContentElement = frameElement.getElementsByClassName('vis-item-visible-frame')[0];

  if (this.options.visibleFrameTemplate) {
    visibleFrameTemplateFunction = this.options.visibleFrameTemplate.bind(this);
    itemVisibleFrameContent = visibleFrameTemplateFunction(itemData, frameElement);
  } else {
    itemVisibleFrameContent = '';
  }

  if (itemVisibleFrameContentElement) {
    if (itemVisibleFrameContent instanceof Object && !(itemVisibleFrameContent instanceof Element)) {
      visibleFrameTemplateFunction(itemData, itemVisibleFrameContentElement);
    } else {
      changed = this._contentToString(this.itemVisibleFrameContent) !== this._contentToString(itemVisibleFrameContent);
      if (changed) {
        // only replace the content when changed
        if (itemVisibleFrameContent instanceof Element) {
          itemVisibleFrameContentElement.innerHTML = '';
          itemVisibleFrameContentElement.appendChild(itemVisibleFrameContent);
        } else if (itemVisibleFrameContent != undefined) {
          itemVisibleFrameContentElement.innerHTML = itemVisibleFrameContent;
        } else {
          if (!(this.data.type == 'background' && this.data.content === undefined)) {
            throw new Error('Property "content" missing in item ' + this.id);
          }
        }

        this.itemVisibleFrameContent = itemVisibleFrameContent;
      }
    }
  }

  if (this.options.template) {
    templateFunction = this.options.template.bind(this);
    content = templateFunction(itemData, element, this.data);
  } else {
    content = this.data.content;
  }

  if (content instanceof Object && !(content instanceof Element)) {
    templateFunction(itemData, element);
  } else {
    changed = this._contentToString(this.content) !== this._contentToString(content);
    if (changed) {
      // only replace the content when changed
      if (content instanceof Element) {
        element.innerHTML = '';
        element.appendChild(content);
      } else if (content != undefined) {
        element.innerHTML = content;
      } else {
        if (!(this.data.type == 'background' && this.data.content === undefined)) {
          throw new Error('Property "content" missing in item ' + this.id);
        }
      }
      this.content = content;
    }
  }
};

/**
 * Process dataAttributes timeline option and set as data- attributes on dom.content
 * @param {Element} element   HTML element to which the attributes will be attached
 * @private
 */
Item.prototype._updateDataAttributes = function (element) {
  if (this.options.dataAttributes && this.options.dataAttributes.length > 0) {
    var attributes = [];

    if (Array.isArray(this.options.dataAttributes)) {
      attributes = this.options.dataAttributes;
    } else if (this.options.dataAttributes == 'all') {
      attributes = (0, _keys2['default'])(this.data);
    } else {
      return;
    }

    for (var i = 0; i < attributes.length; i++) {
      var name = attributes[i];
      var value = this.data[name];

      if (value != null) {
        element.setAttribute('data-' + name, value);
      } else {
        element.removeAttribute('data-' + name);
      }
    }
  }
};

/**
 * Update custom styles of the element
 * @param {Element} element
 * @private
 */
Item.prototype._updateStyle = function (element) {
  // remove old styles
  if (this.style) {
    util.removeCssText(element, this.style);
    this.style = null;
  }

  // append new styles
  if (this.data.style) {
    util.addCssText(element, this.data.style);
    this.style = this.data.style;
  }
};

/**
 * Stringify the items contents
 * @param {string | Element | undefined} content
 * @returns {string | undefined}
 * @private
 */
Item.prototype._contentToString = function (content) {
  if (typeof content === 'string') return content;
  if (content && 'outerHTML' in content) return content.outerHTML;
  return content;
};

/**
 * Update the editability of this item.
 */
Item.prototype._updateEditStatus = function () {
  if (this.options) {
    if (typeof this.options.editable === 'boolean') {
      this.editable = {
        updateTime: this.options.editable,
        updateGroup: this.options.editable,
        remove: this.options.editable
      };
    } else if ((0, _typeof3['default'])(this.options.editable) === 'object') {
      this.editable = {};
      util.selectiveExtend(['updateTime', 'updateGroup', 'remove'], this.editable, this.options.editable);
    }
  }
  // Item data overrides, except if options.editable.overrideItems is set.
  if (!this.options || !this.options.editable || this.options.editable.overrideItems !== true) {
    if (this.data) {
      if (typeof this.data.editable === 'boolean') {
        this.editable = {
          updateTime: this.data.editable,
          updateGroup: this.data.editable,
          remove: this.data.editable
        };
      } else if ((0, _typeof3['default'])(this.data.editable) === 'object') {
        // TODO: in vis.js 5.0, we should change this to not reset options from the timeline configuration.
        // Basically just remove the next line...
        this.editable = {};
        util.selectiveExtend(['updateTime', 'updateGroup', 'remove'], this.editable, this.data.editable);
      }
    }
  }
};

/**
 * Return the width of the item left from its start date
 * @return {number}
 */
Item.prototype.getWidthLeft = function () {
  return 0;
};

/**
 * Return the width of the item right from the max of its start and end date
 * @return {number}
 */
Item.prototype.getWidthRight = function () {
  return 0;
};

/**
 * Return the title of the item
 * @return {string | undefined}
 */
Item.prototype.getTitle = function () {
  return this.data.title;
};

module.exports = Item;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(51);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A queue
 * @param {Object} options
 *            Available options:
 *            - delay: number    When provided, the queue will be flushed
 *                               automatically after an inactivity of this delay
 *                               in milliseconds.
 *                               Default value is null.
 *            - max: number      When the queue exceeds the given maximum number
 *                               of entries, the queue is flushed automatically.
 *                               Default value of max is Infinity.
 * @constructor Queue
 */
function Queue(options) {
  // options
  this.delay = null;
  this.max = Infinity;

  // properties
  this._queue = [];
  this._timeout = null;
  this._extended = null;

  this.setOptions(options);
}

/**
 * Update the configuration of the queue
 * @param {Object} options
 *            Available options:
 *            - delay: number    When provided, the queue will be flushed
 *                               automatically after an inactivity of this delay
 *                               in milliseconds.
 *                               Default value is null.
 *            - max: number      When the queue exceeds the given maximum number
 *                               of entries, the queue is flushed automatically.
 *                               Default value of max is Infinity.
 */
Queue.prototype.setOptions = function (options) {
  if (options && typeof options.delay !== 'undefined') {
    this.delay = options.delay;
  }
  if (options && typeof options.max !== 'undefined') {
    this.max = options.max;
  }

  this._flushIfNeeded();
};

/**
 * Extend an object with queuing functionality.
 * The object will be extended with a function flush, and the methods provided
 * in options.replace will be replaced with queued ones.
 * @param {Object} object
 * @param {Object} options
 *            Available options:
 *            - replace: Array.<string>
 *                               A list with method names of the methods
 *                               on the object to be replaced with queued ones.
 *            - delay: number    When provided, the queue will be flushed
 *                               automatically after an inactivity of this delay
 *                               in milliseconds.
 *                               Default value is null.
 *            - max: number      When the queue exceeds the given maximum number
 *                               of entries, the queue is flushed automatically.
 *                               Default value of max is Infinity.
 * @return {Queue} Returns the created queue
 */
Queue.extend = function (object, options) {
  var queue = new Queue(options);

  if (object.flush !== undefined) {
    throw new Error('Target object already has a property flush');
  }
  object.flush = function () {
    queue.flush();
  };

  var methods = [{
    name: 'flush',
    original: undefined
  }];

  if (options && options.replace) {
    for (var i = 0; i < options.replace.length; i++) {
      var name = options.replace[i];
      methods.push({
        name: name,
        original: object[name]
      });
      queue.replace(object, name);
    }
  }

  queue._extended = {
    object: object,
    methods: methods
  };

  return queue;
};

/**
 * Destroy the queue. The queue will first flush all queued actions, and in
 * case it has extended an object, will restore the original object.
 */
Queue.prototype.destroy = function () {
  this.flush();

  if (this._extended) {
    var object = this._extended.object;
    var methods = this._extended.methods;
    for (var i = 0; i < methods.length; i++) {
      var method = methods[i];
      if (method.original) {
        object[method.name] = method.original;
      } else {
        delete object[method.name];
      }
    }
    this._extended = null;
  }
};

/**
 * Replace a method on an object with a queued version
 * @param {Object} object   Object having the method
 * @param {string} method   The method name
 */
Queue.prototype.replace = function (object, method) {
  var me = this;
  var original = object[method];
  if (!original) {
    throw new Error('Method ' + method + ' undefined');
  }

  object[method] = function () {
    // create an Array with the arguments
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    // add this call to the queue
    me.queue({
      args: args,
      fn: original,
      context: this
    });
  };
};

/**
 * Queue a call
 * @param {function | {fn: function, args: Array} | {fn: function, args: Array, context: Object}} entry
 */
Queue.prototype.queue = function (entry) {
  if (typeof entry === 'function') {
    this._queue.push({ fn: entry });
  } else {
    this._queue.push(entry);
  }

  this._flushIfNeeded();
};

/**
 * Check whether the queue needs to be flushed
 * @private
 */
Queue.prototype._flushIfNeeded = function () {
  // flush when the maximum is exceeded.
  if (this._queue.length > this.max) {
    this.flush();
  }

  // flush after a period of inactivity when a delay is configured
  clearTimeout(this._timeout);
  if (this.queue.length > 0 && typeof this.delay === 'number') {
    var me = this;
    this._timeout = setTimeout(function () {
      me.flush();
    }, this.delay);
  }
};

/**
 * Flush all queued calls
 */
Queue.prototype.flush = function () {
  while (this._queue.length > 0) {
    var entry = this._queue.shift();
    entry.fn.apply(entry.context || entry.fn, entry.args || []);
  }
};

module.exports = Queue;

/***/ }),
/* 44 */
/***/ (function(module, exports) {


/**
 * Expose `Emitter`.
 */

module.exports = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks[event] = this._callbacks[event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  var self = this;
  this._callbacks = this._callbacks || {};

  function on() {
    self.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks[event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks[event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks[event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks[event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var Component = __webpack_require__(16);
var TimeStep = __webpack_require__(66);
var DateUtil = __webpack_require__(36);
var moment = __webpack_require__(9);

/**
 * A horizontal time axis
 * @param {{dom: Object, domProps: Object, emitter: Emitter, range: Range}} body
 * @param {Object} [options]        See TimeAxis.setOptions for the available
 *                                  options.
 * @constructor TimeAxis
 * @extends Component
 */
function TimeAxis(body, options) {
  this.dom = {
    foreground: null,
    lines: [],
    majorTexts: [],
    minorTexts: [],
    redundant: {
      lines: [],
      majorTexts: [],
      minorTexts: []
    }
  };
  this.props = {
    range: {
      start: 0,
      end: 0,
      minimumStep: 0
    },
    lineTop: 0
  };

  this.defaultOptions = {
    orientation: {
      axis: 'bottom'
    }, // axis orientation: 'top' or 'bottom'
    showMinorLabels: true,
    showMajorLabels: true,
    maxMinorChars: 7,
    format: TimeStep.FORMAT,
    moment: moment,
    timeAxis: null
  };
  this.options = util.extend({}, this.defaultOptions);

  this.body = body;

  // create the HTML DOM
  this._create();

  this.setOptions(options);
}

TimeAxis.prototype = new Component();

/**
 * Set options for the TimeAxis.
 * Parameters will be merged in current options.
 * @param {Object} options  Available options:
 *                          {string} [orientation.axis]
 *                          {boolean} [showMinorLabels]
 *                          {boolean} [showMajorLabels]
 */
TimeAxis.prototype.setOptions = function (options) {
  if (options) {
    // copy all options that we know
    util.selectiveExtend(['showMinorLabels', 'showMajorLabels', 'maxMinorChars', 'hiddenDates', 'timeAxis', 'moment', 'rtl'], this.options, options);

    // deep copy the format options
    util.selectiveDeepExtend(['format'], this.options, options);

    if ('orientation' in options) {
      if (typeof options.orientation === 'string') {
        this.options.orientation.axis = options.orientation;
      } else if ((0, _typeof3['default'])(options.orientation) === 'object' && 'axis' in options.orientation) {
        this.options.orientation.axis = options.orientation.axis;
      }
    }

    // apply locale to moment.js
    // TODO: not so nice, this is applied globally to moment.js
    if ('locale' in options) {
      if (typeof moment.locale === 'function') {
        // moment.js 2.8.1+
        moment.locale(options.locale);
      } else {
        moment.lang(options.locale);
      }
    }
  }
};

/**
 * Create the HTML DOM for the TimeAxis
 */
TimeAxis.prototype._create = function () {
  this.dom.foreground = document.createElement('div');
  this.dom.background = document.createElement('div');

  this.dom.foreground.className = 'vis-time-axis vis-foreground';
  this.dom.background.className = 'vis-time-axis vis-background';
};

/**
 * Destroy the TimeAxis
 */
TimeAxis.prototype.destroy = function () {
  // remove from DOM
  if (this.dom.foreground.parentNode) {
    this.dom.foreground.parentNode.removeChild(this.dom.foreground);
  }
  if (this.dom.background.parentNode) {
    this.dom.background.parentNode.removeChild(this.dom.background);
  }

  this.body = null;
};

/**
 * Repaint the component
 * @return {boolean} Returns true if the component is resized
 */
TimeAxis.prototype.redraw = function () {
  var props = this.props;
  var foreground = this.dom.foreground;
  var background = this.dom.background;

  // determine the correct parent DOM element (depending on option orientation)
  var parent = this.options.orientation.axis == 'top' ? this.body.dom.top : this.body.dom.bottom;
  var parentChanged = foreground.parentNode !== parent;

  // calculate character width and height
  this._calculateCharSize();

  // TODO: recalculate sizes only needed when parent is resized or options is changed
  var showMinorLabels = this.options.showMinorLabels && this.options.orientation.axis !== 'none';
  var showMajorLabels = this.options.showMajorLabels && this.options.orientation.axis !== 'none';

  // determine the width and height of the elemens for the axis
  props.minorLabelHeight = showMinorLabels ? props.minorCharHeight : 0;
  props.majorLabelHeight = showMajorLabels ? props.majorCharHeight : 0;
  props.height = props.minorLabelHeight + props.majorLabelHeight;
  props.width = foreground.offsetWidth;

  props.minorLineHeight = this.body.domProps.root.height - props.majorLabelHeight - (this.options.orientation.axis == 'top' ? this.body.domProps.bottom.height : this.body.domProps.top.height);
  props.minorLineWidth = 1; // TODO: really calculate width
  props.majorLineHeight = props.minorLineHeight + props.majorLabelHeight;
  props.majorLineWidth = 1; // TODO: really calculate width

  //  take foreground and background offline while updating (is almost twice as fast)
  var foregroundNextSibling = foreground.nextSibling;
  var backgroundNextSibling = background.nextSibling;
  foreground.parentNode && foreground.parentNode.removeChild(foreground);
  background.parentNode && background.parentNode.removeChild(background);

  foreground.style.height = this.props.height + 'px';

  this._repaintLabels();

  // put DOM online again (at the same place)
  if (foregroundNextSibling) {
    parent.insertBefore(foreground, foregroundNextSibling);
  } else {
    parent.appendChild(foreground);
  }
  if (backgroundNextSibling) {
    this.body.dom.backgroundVertical.insertBefore(background, backgroundNextSibling);
  } else {
    this.body.dom.backgroundVertical.appendChild(background);
  }
  return this._isResized() || parentChanged;
};

/**
 * Repaint major and minor text labels and vertical grid lines
 * @private
 */
TimeAxis.prototype._repaintLabels = function () {
  var orientation = this.options.orientation.axis;

  // calculate range and step (step such that we have space for 7 characters per label)
  var start = util.convert(this.body.range.start, 'Number');
  var end = util.convert(this.body.range.end, 'Number');
  var timeLabelsize = this.body.util.toTime((this.props.minorCharWidth || 10) * this.options.maxMinorChars).valueOf();
  var minimumStep = timeLabelsize - DateUtil.getHiddenDurationBefore(this.options.moment, this.body.hiddenDates, this.body.range, timeLabelsize);
  minimumStep -= this.body.util.toTime(0).valueOf();

  var step = new TimeStep(new Date(start), new Date(end), minimumStep, this.body.hiddenDates, this.options);
  step.setMoment(this.options.moment);
  if (this.options.format) {
    step.setFormat(this.options.format);
  }
  if (this.options.timeAxis) {
    step.setScale(this.options.timeAxis);
  }
  this.step = step;

  // Move all DOM elements to a "redundant" list, where they
  // can be picked for re-use, and clear the lists with lines and texts.
  // At the end of the function _repaintLabels, left over elements will be cleaned up
  var dom = this.dom;
  dom.redundant.lines = dom.lines;
  dom.redundant.majorTexts = dom.majorTexts;
  dom.redundant.minorTexts = dom.minorTexts;
  dom.lines = [];
  dom.majorTexts = [];
  dom.minorTexts = [];

  var current; // eslint-disable-line no-unused-vars
  var next;
  var x;
  var xNext;
  var isMajor;
  var nextIsMajor; // eslint-disable-line no-unused-vars
  var showMinorGrid;
  var width = 0,
      prevWidth;
  var line;
  var labelMinor;
  var xFirstMajorLabel = undefined;
  var count = 0;
  var MAX = 1000;
  var className;

  step.start();
  next = step.getCurrent();
  xNext = this.body.util.toScreen(next);
  while (step.hasNext() && count < MAX) {
    count++;

    isMajor = step.isMajor();
    className = step.getClassName();
    labelMinor = step.getLabelMinor();

    current = next;
    x = xNext;

    step.next();
    next = step.getCurrent();
    nextIsMajor = step.isMajor();
    xNext = this.body.util.toScreen(next);

    prevWidth = width;
    width = xNext - x;
    switch (step.scale) {
      case 'week':
        showMinorGrid = true;break;
      default:
        showMinorGrid = width >= prevWidth * 0.4;break; // prevent displaying of the 31th of the month on a scale of 5 days
    }

    if (this.options.showMinorLabels && showMinorGrid) {
      var label = this._repaintMinorText(x, labelMinor, orientation, className);
      label.style.width = width + 'px'; // set width to prevent overflow
    }

    if (isMajor && this.options.showMajorLabels) {
      if (x > 0) {
        if (xFirstMajorLabel == undefined) {
          xFirstMajorLabel = x;
        }
        label = this._repaintMajorText(x, step.getLabelMajor(), orientation, className);
      }
      line = this._repaintMajorLine(x, width, orientation, className);
    } else {
      // minor line
      if (showMinorGrid) {
        line = this._repaintMinorLine(x, width, orientation, className);
      } else {
        if (line) {
          // adjust the width of the previous grid
          line.style.width = parseInt(line.style.width) + width + 'px';
        }
      }
    }
  }

  if (count === MAX && !warnedForOverflow) {
    console.warn('Something is wrong with the Timeline scale. Limited drawing of grid lines to ' + MAX + ' lines.');
    warnedForOverflow = true;
  }

  // create a major label on the left when needed
  if (this.options.showMajorLabels) {
    var leftTime = this.body.util.toTime(0),
        leftText = step.getLabelMajor(leftTime),
        widthText = leftText.length * (this.props.majorCharWidth || 10) + 10; // upper bound estimation

    if (xFirstMajorLabel == undefined || widthText < xFirstMajorLabel) {
      this._repaintMajorText(0, leftText, orientation, className);
    }
  }

  // Cleanup leftover DOM elements from the redundant list
  util.forEach(this.dom.redundant, function (arr) {
    while (arr.length) {
      var elem = arr.pop();
      if (elem && elem.parentNode) {
        elem.parentNode.removeChild(elem);
      }
    }
  });
};

/**
 * Create a minor label for the axis at position x
 * @param {number} x
 * @param {string} text
 * @param {string} orientation   "top" or "bottom" (default)
 * @param {string} className
 * @return {Element} Returns the HTML element of the created label
 * @private
 */
TimeAxis.prototype._repaintMinorText = function (x, text, orientation, className) {
  // reuse redundant label
  var label = this.dom.redundant.minorTexts.shift();

  if (!label) {
    // create new label
    var content = document.createTextNode('');
    label = document.createElement('div');
    label.appendChild(content);
    this.dom.foreground.appendChild(label);
  }
  this.dom.minorTexts.push(label);
  label.innerHTML = text;

  label.style.top = orientation == 'top' ? this.props.majorLabelHeight + 'px' : '0';

  if (this.options.rtl) {
    label.style.left = "";
    label.style.right = x + 'px';
  } else {
    label.style.left = x + 'px';
  }
  label.className = 'vis-text vis-minor ' + className;
  //label.title = title;  // TODO: this is a heavy operation

  return label;
};

/**
 * Create a Major label for the axis at position x
 * @param {number} x
 * @param {string} text
 * @param {string} orientation   "top" or "bottom" (default)
 * @param {string} className
 * @return {Element} Returns the HTML element of the created label
 * @private
 */
TimeAxis.prototype._repaintMajorText = function (x, text, orientation, className) {
  // reuse redundant label
  var label = this.dom.redundant.majorTexts.shift();

  if (!label) {
    // create label
    var content = document.createElement('div');
    label = document.createElement('div');
    label.appendChild(content);
    this.dom.foreground.appendChild(label);
  }

  label.childNodes[0].innerHTML = text;
  label.className = 'vis-text vis-major ' + className;
  //label.title = title; // TODO: this is a heavy operation

  label.style.top = orientation == 'top' ? '0' : this.props.minorLabelHeight + 'px';
  if (this.options.rtl) {
    label.style.left = "";
    label.style.right = x + 'px';
  } else {
    label.style.left = x + 'px';
  }

  this.dom.majorTexts.push(label);
  return label;
};

/**
 * Create a minor line for the axis at position x
 * @param {number} x
 * @param {number} width
 * @param {string} orientation   "top" or "bottom" (default)
 * @param {string} className
 * @return {Element} Returns the created line
 * @private
 */
TimeAxis.prototype._repaintMinorLine = function (x, width, orientation, className) {
  // reuse redundant line
  var line = this.dom.redundant.lines.shift();
  if (!line) {
    // create vertical line
    line = document.createElement('div');
    this.dom.background.appendChild(line);
  }
  this.dom.lines.push(line);

  var props = this.props;
  if (orientation == 'top') {
    line.style.top = props.majorLabelHeight + 'px';
  } else {
    line.style.top = this.body.domProps.top.height + 'px';
  }
  line.style.height = props.minorLineHeight + 'px';
  if (this.options.rtl) {
    line.style.left = "";
    line.style.right = x - props.minorLineWidth / 2 + 'px';
    line.className = 'vis-grid vis-vertical-rtl vis-minor ' + className;
  } else {
    line.style.left = x - props.minorLineWidth / 2 + 'px';
    line.className = 'vis-grid vis-vertical vis-minor ' + className;
  }
  line.style.width = width + 'px';

  return line;
};

/**
 * Create a Major line for the axis at position x
 * @param {number} x
 * @param {number} width
 * @param {string} orientation   "top" or "bottom" (default)
 * @param {string} className
 * @return {Element} Returns the created line
 * @private
 */
TimeAxis.prototype._repaintMajorLine = function (x, width, orientation, className) {
  // reuse redundant line
  var line = this.dom.redundant.lines.shift();
  if (!line) {
    // create vertical line
    line = document.createElement('div');
    this.dom.background.appendChild(line);
  }
  this.dom.lines.push(line);

  var props = this.props;
  if (orientation == 'top') {
    line.style.top = '0';
  } else {
    line.style.top = this.body.domProps.top.height + 'px';
  }

  if (this.options.rtl) {
    line.style.left = "";
    line.style.right = x - props.majorLineWidth / 2 + 'px';
    line.className = 'vis-grid vis-vertical-rtl vis-major ' + className;
  } else {
    line.style.left = x - props.majorLineWidth / 2 + 'px';
    line.className = 'vis-grid vis-vertical vis-major ' + className;
  }

  line.style.height = props.majorLineHeight + 'px';
  line.style.width = width + 'px';

  return line;
};

/**
 * Determine the size of text on the axis (both major and minor axis).
 * The size is calculated only once and then cached in this.props.
 * @private
 */
TimeAxis.prototype._calculateCharSize = function () {
  // Note: We calculate char size with every redraw. Size may change, for
  // example when any of the timelines parents had display:none for example.

  // determine the char width and height on the minor axis
  if (!this.dom.measureCharMinor) {
    this.dom.measureCharMinor = document.createElement('DIV');
    this.dom.measureCharMinor.className = 'vis-text vis-minor vis-measure';
    this.dom.measureCharMinor.style.position = 'absolute';

    this.dom.measureCharMinor.appendChild(document.createTextNode('0'));
    this.dom.foreground.appendChild(this.dom.measureCharMinor);
  }
  this.props.minorCharHeight = this.dom.measureCharMinor.clientHeight;
  this.props.minorCharWidth = this.dom.measureCharMinor.clientWidth;

  // determine the char width and height on the major axis
  if (!this.dom.measureCharMajor) {
    this.dom.measureCharMajor = document.createElement('DIV');
    this.dom.measureCharMajor.className = 'vis-text vis-major vis-measure';
    this.dom.measureCharMajor.style.position = 'absolute';

    this.dom.measureCharMajor.appendChild(document.createTextNode('0'));
    this.dom.foreground.appendChild(this.dom.measureCharMajor);
  }
  this.props.majorCharHeight = this.dom.measureCharMajor.clientHeight;
  this.props.majorCharWidth = this.dom.measureCharMajor.clientWidth;
};

var warnedForOverflow = false;

module.exports = TimeAxis;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Hammer = __webpack_require__(10);
var util = __webpack_require__(2);
var Component = __webpack_require__(16);
var moment = __webpack_require__(9);
var locales = __webpack_require__(98);

/**
 * A custom time bar
 * @param {{range: Range, dom: Object}} body
 * @param {Object} [options]        Available parameters:
 *                                  {number | string} id
 *                                  {string} locales
 *                                  {string} locale
 * @constructor CustomTime
 * @extends Component
 */
function CustomTime(body, options) {
  this.body = body;

  // default options
  this.defaultOptions = {
    moment: moment,
    locales: locales,
    locale: 'en',
    id: undefined,
    title: undefined
  };
  this.options = util.extend({}, this.defaultOptions);

  if (options && options.time) {
    this.customTime = options.time;
  } else {
    this.customTime = new Date();
  }

  this.eventParams = {}; // stores state parameters while dragging the bar

  this.setOptions(options);

  // create the DOM
  this._create();
}

CustomTime.prototype = new Component();

/**
 * Set options for the component. Options will be merged in current options.
 * @param {Object} options  Available parameters:
 *                                  {number | string} id
 *                                  {string} locales
 *                                  {string} locale
 */
CustomTime.prototype.setOptions = function (options) {
  if (options) {
    // copy all options that we know
    util.selectiveExtend(['moment', 'locale', 'locales', 'id'], this.options, options);
  }
};

/**
 * Create the DOM for the custom time
 * @private
 */
CustomTime.prototype._create = function () {
  var bar = document.createElement('div');
  bar['custom-time'] = this;
  bar.className = 'vis-custom-time ' + (this.options.id || '');
  bar.style.position = 'absolute';
  bar.style.top = '0px';
  bar.style.height = '100%';
  this.bar = bar;

  var drag = document.createElement('div');
  drag.style.position = 'relative';
  drag.style.top = '0px';
  drag.style.left = '-10px';
  drag.style.height = '100%';
  drag.style.width = '20px';

  /**
   *
   * @param {WheelEvent} e
   */
  function onMouseWheel(e) {
    this.body.range._onMouseWheel(e);
  }

  if (drag.addEventListener) {
    // IE9, Chrome, Safari, Opera
    drag.addEventListener("mousewheel", onMouseWheel.bind(this), false);
    // Firefox
    drag.addEventListener("DOMMouseScroll", onMouseWheel.bind(this), false);
  } else {
    // IE 6/7/8
    drag.attachEvent("onmousewheel", onMouseWheel.bind(this));
  }

  bar.appendChild(drag);
  // attach event listeners
  this.hammer = new Hammer(drag);
  this.hammer.on('panstart', this._onDragStart.bind(this));
  this.hammer.on('panmove', this._onDrag.bind(this));
  this.hammer.on('panend', this._onDragEnd.bind(this));
  this.hammer.get('pan').set({ threshold: 5, direction: Hammer.DIRECTION_HORIZONTAL });
};

/**
 * Destroy the CustomTime bar
 */
CustomTime.prototype.destroy = function () {
  this.hide();

  this.hammer.destroy();
  this.hammer = null;

  this.body = null;
};

/**
 * Repaint the component
 * @return {boolean} Returns true if the component is resized
 */
CustomTime.prototype.redraw = function () {
  var parent = this.body.dom.backgroundVertical;
  if (this.bar.parentNode != parent) {
    // attach to the dom
    if (this.bar.parentNode) {
      this.bar.parentNode.removeChild(this.bar);
    }
    parent.appendChild(this.bar);
  }

  var x = this.body.util.toScreen(this.customTime);

  var locale = this.options.locales[this.options.locale];
  if (!locale) {
    if (!this.warned) {
      console.log('WARNING: options.locales[\'' + this.options.locale + '\'] not found. See http://visjs.org/docs/timeline/#Localization');
      this.warned = true;
    }
    locale = this.options.locales['en']; // fall back on english when not available
  }

  var title = this.options.title;
  // To hide the title completely use empty string ''.
  if (title === undefined) {
    title = locale.time + ': ' + this.options.moment(this.customTime).format('dddd, MMMM Do YYYY, H:mm:ss');
    title = title.charAt(0).toUpperCase() + title.substring(1);
  } else if (typeof title === "function") {
    title = title.call(this.customTime);
  }

  this.bar.style.left = x + 'px';
  this.bar.title = title;

  return false;
};

/**
 * Remove the CustomTime from the DOM
 */
CustomTime.prototype.hide = function () {
  // remove the line from the DOM
  if (this.bar.parentNode) {
    this.bar.parentNode.removeChild(this.bar);
  }
};

/**
 * Set custom time.
 * @param {Date | number | string} time
 */
CustomTime.prototype.setCustomTime = function (time) {
  this.customTime = util.convert(time, 'Date');
  this.redraw();
};

/**
 * Retrieve the current custom time.
 * @return {Date} customTime
 */
CustomTime.prototype.getCustomTime = function () {
  return new Date(this.customTime.valueOf());
};

/**
  * Set custom title.
  * @param {Date | number | string} title
  */
CustomTime.prototype.setCustomTitle = function (title) {
  this.options.title = title;
};

/**
 * Start moving horizontally
 * @param {Event} event
 * @private
 */
CustomTime.prototype._onDragStart = function (event) {
  this.eventParams.dragging = true;
  this.eventParams.customTime = this.customTime;

  event.stopPropagation();
};

/**
 * Perform moving operating.
 * @param {Event} event
 * @private
 */
CustomTime.prototype._onDrag = function (event) {
  if (!this.eventParams.dragging) return;

  var x = this.body.util.toScreen(this.eventParams.customTime) + event.deltaX;
  var time = this.body.util.toTime(x);

  this.setCustomTime(time);

  // fire a timechange event
  this.body.emitter.emit('timechange', {
    id: this.options.id,
    time: new Date(this.customTime.valueOf()),
    event: event
  });

  event.stopPropagation();
};

/**
 * Stop moving operating.
 * @param {Event} event
 * @private
 */
CustomTime.prototype._onDragEnd = function (event) {
  if (!this.eventParams.dragging) return;

  // fire a timechanged event
  this.body.emitter.emit('timechanged', {
    id: this.options.id,
    time: new Date(this.customTime.valueOf()),
    event: event
  });

  event.stopPropagation();
};

/**
 * Find a custom time from an event target:
 * searches for the attribute 'custom-time' in the event target's element tree
 * @param {Event} event
 * @return {CustomTime | null} customTime
 */
CustomTime.customTimeFromTarget = function (event) {
  var target = event.target;
  while (target) {
    if (target.hasOwnProperty('custom-time')) {
      return target['custom-time'];
    }
    target = target.parentNode;
  }

  return null;
};

module.exports = CustomTime;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);

var Label = __webpack_require__(117)['default'];
var ComponentUtil = __webpack_require__(48)['default'];
var Box = __webpack_require__(193)['default'];
var Circle = __webpack_require__(200)['default'];
var CircularImage = __webpack_require__(201)['default'];
var Database = __webpack_require__(202)['default'];
var Diamond = __webpack_require__(203)['default'];
var Dot = __webpack_require__(204)['default'];
var Ellipse = __webpack_require__(205)['default'];
var Icon = __webpack_require__(206)['default'];
var Image = __webpack_require__(207)['default'];
var Square = __webpack_require__(208)['default'];
var Hexagon = __webpack_require__(209)['default'];
var Star = __webpack_require__(210)['default'];
var Text = __webpack_require__(211)['default'];
var Triangle = __webpack_require__(212)['default'];
var TriangleDown = __webpack_require__(213)['default'];

var _require = __webpack_require__(15),
    printStyle = _require.printStyle;

/**
 * A node. A node can be connected to other nodes via one or multiple edges.
 */


var Node = function () {
  /**
   *
   * @param {object} options An object containing options for the node. All
   *                            options are optional, except for the id.
   *                              {number} id     Id of the node. Required
   *                              {string} label  Text label for the node
   *                              {number} x      Horizontal position of the node
   *                              {number} y      Vertical position of the node
   *                              {string} shape  Node shape
   *                              {string} image  An image url
   *                              {string} title  A title text, can be HTML
   *                              {anytype} group A group name or number
   *
   * @param {Object} body               Shared state of current network instance
   * @param {Network.Images} imagelist  A list with images. Only needed when the node has an image
   * @param {Groups} grouplist          A list with groups. Needed for retrieving group options
   * @param {Object} globalOptions      Current global node options; these serve as defaults for the node instance
   * @param {Object} defaultOptions     Global default options for nodes; note that this is also the prototype
   *                                    for parameter `globalOptions`.
   */
  function Node(options, body, imagelist, grouplist, globalOptions, defaultOptions) {
    (0, _classCallCheck3['default'])(this, Node);

    this.options = util.bridgeObject(globalOptions);
    this.globalOptions = globalOptions;
    this.defaultOptions = defaultOptions;
    this.body = body;

    this.edges = []; // all edges connected to this node

    // set defaults for the options
    this.id = undefined;
    this.imagelist = imagelist;
    this.grouplist = grouplist;

    // state options
    this.x = undefined;
    this.y = undefined;
    this.baseSize = this.options.size;
    this.baseFontSize = this.options.font.size;
    this.predefinedPosition = false; // used to check if initial fit should just take the range or approximate
    this.selected = false;
    this.hover = false;

    this.labelModule = new Label(this.body, this.options, false /* Not edge label */);
    this.setOptions(options);
  }

  /**
   * Attach a edge to the node
   * @param {Edge} edge
   */


  (0, _createClass3['default'])(Node, [{
    key: 'attachEdge',
    value: function attachEdge(edge) {
      if (this.edges.indexOf(edge) === -1) {
        this.edges.push(edge);
      }
    }

    /**
     * Detach a edge from the node
     *
     * @param {Edge} edge
     */

  }, {
    key: 'detachEdge',
    value: function detachEdge(edge) {
      var index = this.edges.indexOf(edge);
      if (index != -1) {
        this.edges.splice(index, 1);
      }
    }

    /**
     * Set or overwrite options for the node
     *
     * @param {Object} options an object with options
     * @returns {null|boolean}
     */

  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      var currentShape = this.options.shape;
      if (!options) {
        return; // Note that the return value will be 'undefined'! This is OK.
      }

      // basic options
      if (options.id !== undefined) {
        this.id = options.id;
      }

      if (this.id === undefined) {
        throw new Error("Node must have an id");
      }

      Node.checkMass(options, this.id);

      // set these options locally
      // clear x and y positions
      if (options.x !== undefined) {
        if (options.x === null) {
          this.x = undefined;this.predefinedPosition = false;
        } else {
          this.x = parseInt(options.x);this.predefinedPosition = true;
        }
      }
      if (options.y !== undefined) {
        if (options.y === null) {
          this.y = undefined;this.predefinedPosition = false;
        } else {
          this.y = parseInt(options.y);this.predefinedPosition = true;
        }
      }
      if (options.size !== undefined) {
        this.baseSize = options.size;
      }
      if (options.value !== undefined) {
        options.value = parseFloat(options.value);
      }

      // this transforms all shorthands into fully defined options
      Node.parseOptions(this.options, options, true, this.globalOptions, this.grouplist);

      var pile = [options, this.options, this.defaultOptions];
      this.chooser = ComponentUtil.choosify('node', pile);

      this._load_images();
      this.updateLabelModule(options);
      this.updateShape(currentShape);

      return options.hidden !== undefined || options.physics !== undefined;
    }

    /**
     * Load the images from the options, for the nodes that need them.
     *
     * TODO: The imageObj members should be moved to CircularImageBase.
     *       It's the only place where they are required.
     *
     * @private
     */

  }, {
    key: '_load_images',
    value: function _load_images() {
      // Don't bother loading for nodes without images
      if (this.options.shape !== 'circularImage' && this.options.shape !== 'image') {
        return;
      }

      if (this.options.image === undefined) {
        throw new Error("Option image must be defined for node type '" + this.options.shape + "'");
      }

      if (this.imagelist === undefined) {
        throw new Error("Internal Error: No images provided");
      }

      if (typeof this.options.image === 'string') {
        this.imageObj = this.imagelist.load(this.options.image, this.options.brokenImage, this.id);
      } else {
        if (this.options.image.unselected === undefined) {
          throw new Error("No unselected image provided");
        }

        this.imageObj = this.imagelist.load(this.options.image.unselected, this.options.brokenImage, this.id);

        if (this.options.image.selected !== undefined) {
          this.imageObjAlt = this.imagelist.load(this.options.image.selected, this.options.brokenImage, this.id);
        } else {
          this.imageObjAlt = undefined;
        }
      }
    }

    /**
     * Copy group option values into the node options.
     *
     * The group options override the global node options, so the copy of group options
     *  must happen *after* the global node options have been set.
     *
     * This method must also be called also if the global node options have changed and the group options did not.
     *
     * @param {Object} parentOptions
     * @param {Object} newOptions  new values for the options, currently only passed in for check
     * @param {Object} groupList
     */

  }, {
    key: 'getFormattingValues',


    /**
     *
     * @returns {{color: *, borderWidth: *, borderColor: *, size: *, borderDashes: (boolean|Array|allOptions.nodes.shapeProperties.borderDashes|{boolean, array}), borderRadius: (number|allOptions.nodes.shapeProperties.borderRadius|{number}|Array), shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *}}
     */
    value: function getFormattingValues() {
      var values = {
        color: this.options.color.background,
        borderWidth: this.options.borderWidth,
        borderColor: this.options.color.border,
        size: this.options.size,
        borderDashes: this.options.shapeProperties.borderDashes,
        borderRadius: this.options.shapeProperties.borderRadius,
        shadow: this.options.shadow.enabled,
        shadowColor: this.options.shadow.color,
        shadowSize: this.options.shadow.size,
        shadowX: this.options.shadow.x,
        shadowY: this.options.shadow.y
      };
      if (this.selected || this.hover) {
        if (this.chooser === true) {
          if (this.selected) {
            values.borderWidth *= 2;
            values.color = this.options.color.highlight.background;
            values.borderColor = this.options.color.highlight.border;
            values.shadow = this.options.shadow.enabled;
          } else if (this.hover) {
            values.color = this.options.color.hover.background;
            values.borderColor = this.options.color.hover.border;
            values.shadow = this.options.shadow.enabled;
          }
        } else if (typeof this.chooser === 'function') {
          this.chooser(values, this.options.id, this.selected, this.hover);
          if (values.shadow === false) {
            if (values.shadowColor !== this.options.shadow.color || values.shadowSize !== this.options.shadow.size || values.shadowX !== this.options.shadow.x || values.shadowY !== this.options.shadow.y) {
              values.shadow = true;
            }
          }
        }
      } else {
        values.shadow = this.options.shadow.enabled;
      }
      return values;
    }

    /**
     *
     * @param {Object} options
     */

  }, {
    key: 'updateLabelModule',
    value: function updateLabelModule(options) {
      if (this.options.label === undefined || this.options.label === null) {
        this.options.label = '';
      }

      Node.updateGroupOptions(this.options, options, this.grouplist);

      //
      // Note:The prototype chain for this.options is:
      //
      // this.options ->    NodesHandler.options    -> NodesHandler.defaultOptions
      //                 (also: this.globalOptions)
      //
      // Note that the prototypes are mentioned explicitly in the pile list below;
      // WE DON'T WANT THE ORDER OF THE PROTOTYPES!!!! At least, not for font handling of labels.
      // This is a good indication that the prototype usage of options is deficient.
      //
      var currentGroup = this.grouplist.get(this.options.group, false);
      var pile = [options, // new options
      this.options, // current node options, see comment above for prototype
      currentGroup, // group options, if any
      this.globalOptions, // Currently set global node options
      this.defaultOptions // Default global node options
      ];
      this.labelModule.update(this.options, pile);

      if (this.labelModule.baseSize !== undefined) {
        this.baseFontSize = this.labelModule.baseSize;
      }
    }

    /**
     *
     * @param {string} currentShape
     */

  }, {
    key: 'updateShape',
    value: function updateShape(currentShape) {
      if (currentShape === this.options.shape && this.shape) {
        this.shape.setOptions(this.options, this.imageObj, this.imageObjAlt);
      } else {
        // choose draw method depending on the shape
        switch (this.options.shape) {
          case 'box':
            this.shape = new Box(this.options, this.body, this.labelModule);
            break;
          case 'circle':
            this.shape = new Circle(this.options, this.body, this.labelModule);
            break;
          case 'circularImage':
            this.shape = new CircularImage(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
            break;
          case 'database':
            this.shape = new Database(this.options, this.body, this.labelModule);
            break;
          case 'diamond':
            this.shape = new Diamond(this.options, this.body, this.labelModule);
            break;
          case 'dot':
            this.shape = new Dot(this.options, this.body, this.labelModule);
            break;
          case 'ellipse':
            this.shape = new Ellipse(this.options, this.body, this.labelModule);
            break;
          case 'icon':
            this.shape = new Icon(this.options, this.body, this.labelModule);
            break;
          case 'image':
            this.shape = new Image(this.options, this.body, this.labelModule, this.imageObj, this.imageObjAlt);
            break;
          case 'square':
            this.shape = new Square(this.options, this.body, this.labelModule);
            break;
          case 'hexagon':
            this.shape = new Hexagon(this.options, this.body, this.labelModule);
            break;
          case 'star':
            this.shape = new Star(this.options, this.body, this.labelModule);
            break;
          case 'text':
            this.shape = new Text(this.options, this.body, this.labelModule);
            break;
          case 'triangle':
            this.shape = new Triangle(this.options, this.body, this.labelModule);
            break;
          case 'triangleDown':
            this.shape = new TriangleDown(this.options, this.body, this.labelModule);
            break;
          default:
            this.shape = new Ellipse(this.options, this.body, this.labelModule);
            break;
        }
      }
      this.needsRefresh();
    }

    /**
     * select this node
     */

  }, {
    key: 'select',
    value: function select() {
      this.selected = true;
      this.needsRefresh();
    }

    /**
     * unselect this node
     */

  }, {
    key: 'unselect',
    value: function unselect() {
      this.selected = false;
      this.needsRefresh();
    }

    /**
     * Reset the calculated size of the node, forces it to recalculate its size
     */

  }, {
    key: 'needsRefresh',
    value: function needsRefresh() {
      this.shape.refreshNeeded = true;
    }

    /**
     * get the title of this node.
     * @return {string} title    The title of the node, or undefined when no title
     *                           has been set.
     */

  }, {
    key: 'getTitle',
    value: function getTitle() {
      return this.options.title;
    }

    /**
     * Calculate the distance to the border of the Node
     * @param {CanvasRenderingContext2D}   ctx
     * @param {number} angle        Angle in radians
     * @returns {number} distance   Distance to the border in pixels
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this.shape.distanceToBorder(ctx, angle);
    }

    /**
     * Check if this node has a fixed x and y position
     * @return {boolean}      true if fixed, false if not
     */

  }, {
    key: 'isFixed',
    value: function isFixed() {
      return this.options.fixed.x && this.options.fixed.y;
    }

    /**
     * check if this node is selecte
     * @return {boolean} selected   True if node is selected, else false
     */

  }, {
    key: 'isSelected',
    value: function isSelected() {
      return this.selected;
    }

    /**
     * Retrieve the value of the node. Can be undefined
     * @return {number} value
     */

  }, {
    key: 'getValue',
    value: function getValue() {
      return this.options.value;
    }

    /**
     * Get the current dimensions of the label
     *
     * @return {rect}
     */

  }, {
    key: 'getLabelSize',
    value: function getLabelSize() {
      return this.labelModule.size();
    }

    /**
     * Adjust the value range of the node. The node will adjust it's size
     * based on its value.
     * @param {number} min
     * @param {number} max
     * @param {number} total
     */

  }, {
    key: 'setValueRange',
    value: function setValueRange(min, max, total) {
      if (this.options.value !== undefined) {
        var scale = this.options.scaling.customScalingFunction(min, max, total, this.options.value);
        var sizeDiff = this.options.scaling.max - this.options.scaling.min;
        if (this.options.scaling.label.enabled === true) {
          var fontDiff = this.options.scaling.label.max - this.options.scaling.label.min;
          this.options.font.size = this.options.scaling.label.min + scale * fontDiff;
        }
        this.options.size = this.options.scaling.min + scale * sizeDiff;
      } else {
        this.options.size = this.baseSize;
        this.options.font.size = this.baseFontSize;
      }

      this.updateLabelModule();
    }

    /**
     * Draw this node in the given canvas
     * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
     * @param {CanvasRenderingContext2D}   ctx
     */

  }, {
    key: 'draw',
    value: function draw(ctx) {
      var values = this.getFormattingValues();
      this.shape.draw(ctx, this.x, this.y, this.selected, this.hover, values);
    }

    /**
     * Update the bounding box of the shape
     * @param {CanvasRenderingContext2D}   ctx
     */

  }, {
    key: 'updateBoundingBox',
    value: function updateBoundingBox(ctx) {
      this.shape.updateBoundingBox(this.x, this.y, ctx);
    }

    /**
     * Recalculate the size of this node in the given canvas
     * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
     * @param {CanvasRenderingContext2D}   ctx
     */

  }, {
    key: 'resize',
    value: function resize(ctx) {
      var values = this.getFormattingValues();
      this.shape.resize(ctx, this.selected, this.hover, values);
    }

    /**
     * Determine all visual elements of this node instance, in which the given
     * point falls within the bounding shape.
     *
     * @param {point} point
     * @returns {Array.<nodeClickItem|nodeLabelClickItem>} list with the items which are on the point
     */

  }, {
    key: 'getItemsOnPoint',
    value: function getItemsOnPoint(point) {
      var ret = [];

      if (this.labelModule.visible()) {
        if (ComponentUtil.pointInRect(this.labelModule.getSize(), point)) {
          ret.push({ nodeId: this.id, labelId: 0 });
        }
      }

      if (ComponentUtil.pointInRect(this.shape.boundingBox, point)) {
        ret.push({ nodeId: this.id });
      }

      return ret;
    }

    /**
     * Check if this object is overlapping with the provided object
     * @param {Object} obj   an object with parameters left, top, right, bottom
     * @return {boolean}     True if location is located on node
     */

  }, {
    key: 'isOverlappingWith',
    value: function isOverlappingWith(obj) {
      return this.shape.left < obj.right && this.shape.left + this.shape.width > obj.left && this.shape.top < obj.bottom && this.shape.top + this.shape.height > obj.top;
    }

    /**
     * Check if this object is overlapping with the provided object
     * @param {Object} obj   an object with parameters left, top, right, bottom
     * @return {boolean}     True if location is located on node
     */

  }, {
    key: 'isBoundingBoxOverlappingWith',
    value: function isBoundingBoxOverlappingWith(obj) {
      return this.shape.boundingBox.left < obj.right && this.shape.boundingBox.right > obj.left && this.shape.boundingBox.top < obj.bottom && this.shape.boundingBox.bottom > obj.top;
    }

    /**
    * Check valid values for mass
    *
    * The mass may not be negative or zero. If it is, reset to 1
    *
    * @param {object} options
    * @param {Node.id} id
     * @static
    */

  }], [{
    key: 'updateGroupOptions',
    value: function updateGroupOptions(parentOptions, newOptions, groupList) {
      if (groupList === undefined) return; // No groups, nothing to do

      var group = parentOptions.group;

      // paranoia: the selected group is already merged into node options, check.
      if (newOptions !== undefined && newOptions.group !== undefined && group !== newOptions.group) {
        throw new Error("updateGroupOptions: group values in options don't match.");
      }

      var hasGroup = typeof group === 'number' || typeof group === 'string' && group != '';
      if (!hasGroup) return; // current node has no group, no need to merge

      var groupObj = groupList.get(group);

      // Skip merging of group font options into parent; these are required to be distinct for labels
      // TODO: It might not be a good idea either to merge the rest of the options, investigate this. 
      util.selectiveNotDeepExtend(['font'], parentOptions, groupObj);

      // the color object needs to be completely defined.
      // Since groups can partially overwrite the colors, we parse it again, just in case.
      parentOptions.color = util.parseColor(parentOptions.color);
    }

    /**
     * This process all possible shorthands in the new options and makes sure that the parentOptions are fully defined.
     * Static so it can also be used by the handler.
     *
     * @param {Object} parentOptions
     * @param {Object} newOptions
     * @param {boolean} [allowDeletion=false]
     * @param {Object} [globalOptions={}]
     * @param {Object} [groupList]
     * @static
     */

  }, {
    key: 'parseOptions',
    value: function parseOptions(parentOptions, newOptions) {
      var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var groupList = arguments[4];


      var fields = ['color', 'fixed', 'shadow'];
      util.selectiveNotDeepExtend(fields, parentOptions, newOptions, allowDeletion);

      Node.checkMass(newOptions);

      // merge the shadow options into the parent.
      util.mergeOptions(parentOptions, newOptions, 'shadow', globalOptions);

      // individual shape newOptions
      if (newOptions.color !== undefined && newOptions.color !== null) {
        var parsedColor = util.parseColor(newOptions.color);
        util.fillIfDefined(parentOptions.color, parsedColor);
      } else if (allowDeletion === true && newOptions.color === null) {
        parentOptions.color = util.bridgeObject(globalOptions.color); // set the object back to the global options
      }

      // handle the fixed options
      if (newOptions.fixed !== undefined && newOptions.fixed !== null) {
        if (typeof newOptions.fixed === 'boolean') {
          parentOptions.fixed.x = newOptions.fixed;
          parentOptions.fixed.y = newOptions.fixed;
        } else {
          if (newOptions.fixed.x !== undefined && typeof newOptions.fixed.x === 'boolean') {
            parentOptions.fixed.x = newOptions.fixed.x;
          }
          if (newOptions.fixed.y !== undefined && typeof newOptions.fixed.y === 'boolean') {
            parentOptions.fixed.y = newOptions.fixed.y;
          }
        }
      }

      if (allowDeletion === true && newOptions.font === null) {
        parentOptions.font = util.bridgeObject(globalOptions.font); // set the object back to the global options
      }

      Node.updateGroupOptions(parentOptions, newOptions, groupList);

      // handle the scaling options, specifically the label part
      if (newOptions.scaling !== undefined) {
        util.mergeOptions(parentOptions.scaling, newOptions.scaling, 'label', globalOptions.scaling);
      }
    }
  }, {
    key: 'checkMass',
    value: function checkMass(options, id) {
      if (options.mass !== undefined && options.mass <= 0) {
        var strId = '';
        if (id !== undefined) {
          strId = ' in node id: ' + id;
        }
        console.log('%cNegative or zero mass disallowed' + strId + ', setting mass to 1.', printStyle);
        options.mass = 1;
      }
    }
  }]);
  return Node;
}();

exports['default'] = Node;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Definitions for param's in jsdoc.
 * These are more or less global within Network. Putting them here until I can figure out
 * where to really put them
 * 
 * @typedef {string|number} Id
 * @typedef {Id} NodeId
 * @typedef {Id} EdgeId
 * @typedef {Id} LabelId
 *
 * @typedef {{x: number, y: number}} point
 * @typedef {{left: number, top: number, width: number, height: number}} rect
 * @typedef {{x: number, y:number, angle: number}} rotationPoint
 *   - point to rotate around and the angle in radians to rotate. angle == 0 means no rotation
 * @typedef {{nodeId:NodeId}} nodeClickItem
 * @typedef {{nodeId:NodeId, labelId:LabelId}} nodeLabelClickItem
 * @typedef {{edgeId:EdgeId}} edgeClickItem
 * @typedef {{edgeId:EdgeId, labelId:LabelId}} edgeLabelClickItem
 */

var util = __webpack_require__(2);

/**
 * Helper functions for components
 * @class
 */

var ComponentUtil = function () {
  function ComponentUtil() {
    (0, _classCallCheck3['default'])(this, ComponentUtil);
  }

  (0, _createClass3['default'])(ComponentUtil, null, [{
    key: 'choosify',

    /**
     * Determine values to use for (sub)options of 'chosen'.
     *
     * This option is either a boolean or an object whose values should be examined further.
     * The relevant structures are:
     *
     * - chosen: <boolean value>
     * - chosen: { subOption: <boolean or function> }
     *
     * Where subOption is 'node', 'edge' or 'label'.
     *
     * The intention of this method appears to be to set a specific priority to the options;
     * Since most properties are either bridged or merged into the local options objects, there
     * is not much point in handling them separately.
     * TODO: examine if 'most' in previous sentence can be replaced with 'all'. In that case, we
     *       should be able to get rid of this method.
     *
     * @param {string}  subOption  option within object 'chosen' to consider; either 'node', 'edge' or 'label'
     * @param {Object}  pile       array of options objects to consider
     * 
     * @return {boolean|function}  value for passed subOption of 'chosen' to use
     */
    value: function choosify(subOption, pile) {
      // allowed values for subOption
      var allowed = ['node', 'edge', 'label'];
      var value = true;

      var chosen = util.topMost(pile, 'chosen');
      if (typeof chosen === 'boolean') {
        value = chosen;
      } else if ((typeof chosen === 'undefined' ? 'undefined' : (0, _typeof3['default'])(chosen)) === 'object') {
        if (allowed.indexOf(subOption) === -1) {
          throw new Error('choosify: subOption \'' + subOption + '\' should be one of ' + "'" + allowed.join("', '") + "'");
        }

        var chosenEdge = util.topMost(pile, ['chosen', subOption]);
        if (typeof chosenEdge === 'boolean' || typeof chosenEdge === 'function') {
          value = chosenEdge;
        }
      }

      return value;
    }

    /**
     * Check if the point falls within the given rectangle.
     *
     * @param {rect} rect
     * @param {point} point
     * @param {rotationPoint} [rotationPoint] if specified, the rotation that applies to the rectangle.
     * @returns {boolean}  true if point within rectangle, false otherwise
     * @static
     */

  }, {
    key: 'pointInRect',
    value: function pointInRect(rect, point, rotationPoint) {
      if (rect.width <= 0 || rect.height <= 0) {
        return false; // early out
      }

      if (rotationPoint !== undefined) {
        // Rotate the point the same amount as the rectangle
        var tmp = {
          x: point.x - rotationPoint.x,
          y: point.y - rotationPoint.y
        };

        if (rotationPoint.angle !== 0) {
          // In order to get the coordinates the same, you need to 
          // rotate in the reverse direction
          var angle = -rotationPoint.angle;

          var tmp2 = {
            x: Math.cos(angle) * tmp.x - Math.sin(angle) * tmp.y,
            y: Math.sin(angle) * tmp.x + Math.cos(angle) * tmp.y
          };
          point = tmp2;
        } else {
          point = tmp;
        }

        // Note that if a rotation is specified, the rectangle coordinates
        // are **not* the full canvas coordinates. They are relative to the
        // rotationPoint. Hence, the point coordinates need not be translated
        // back in this case.
      }

      var right = rect.x + rect.width;
      var bottom = rect.y + rect.width;

      return rect.left < point.x && right > point.x && rect.top < point.y && bottom > point.y;
    }

    /**
     * Check if given value is acceptable as a label text.
     *
     * @param {*} text value to check; can be anything at this point
     * @returns {boolean} true if valid label value, false otherwise
     */

  }, {
    key: 'isValidLabel',
    value: function isValidLabel(text) {
      // Note that this is quite strict: types that *might* be converted to string are disallowed
      return typeof text === 'string' && text !== '';
    }
  }]);
  return ComponentUtil;
}();

exports['default'] = ComponentUtil;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(125);
var global = __webpack_require__(18);
var hide = __webpack_require__(26);
var Iterators = __webpack_require__(31);
var TO_STRING_TAG = __webpack_require__(13)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 50 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(32);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(27);
var dPs = __webpack_require__(130);
var enumBugKeys = __webpack_require__(58);
var IE_PROTO = __webpack_require__(56)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(82)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(134).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(57)('keys');
var uid = __webpack_require__(40);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(20).f;
var has = __webpack_require__(22);
var TAG = __webpack_require__(13)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(135)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(79)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(13);


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(18);
var core = __webpack_require__(7);
var LIBRARY = __webpack_require__(52);
var wksExt = __webpack_require__(61);
var defineProperty = __webpack_require__(20).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(19);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var moment = __webpack_require__(9);
var Component = __webpack_require__(16);
var DateUtil = __webpack_require__(36);

/**
 * A Range controls a numeric range with a start and end value.
 * The Range adjusts the range based on mouse events or programmatic changes,
 * and triggers events when the range is changing or has been changed.
 * @param {{dom: Object, domProps: Object, emitter: Emitter}} body
 * @param {Object} [options]    See description at Range.setOptions
 * @constructor Range
 * @extends Component
 */
function Range(body, options) {
  var now = moment().hours(0).minutes(0).seconds(0).milliseconds(0);
  var start = now.clone().add(-3, 'days').valueOf();
  var end = now.clone().add(3, 'days').valueOf();
  this.millisecondsPerPixelCache = undefined;

  if (options === undefined) {
    this.start = start;
    this.end = end;
  } else {
    this.start = options.start || start;
    this.end = options.end || end;
  }

  this.rolling = false;

  this.body = body;
  this.deltaDifference = 0;
  this.scaleOffset = 0;
  this.startToFront = false;
  this.endToFront = true;

  // default options
  this.defaultOptions = {
    rtl: false,
    start: null,
    end: null,
    moment: moment,
    direction: 'horizontal', // 'horizontal' or 'vertical'
    moveable: true,
    zoomable: true,
    min: null,
    max: null,
    zoomMin: 10, // milliseconds
    zoomMax: 1000 * 60 * 60 * 24 * 365 * 10000, // milliseconds
    rollingMode: {
      follow: false,
      offset: 0.5
    }
  };
  this.options = util.extend({}, this.defaultOptions);
  this.props = {
    touch: {}
  };
  this.animationTimer = null;

  // drag listeners for dragging
  this.body.emitter.on('panstart', this._onDragStart.bind(this));
  this.body.emitter.on('panmove', this._onDrag.bind(this));
  this.body.emitter.on('panend', this._onDragEnd.bind(this));

  // mouse wheel for zooming
  this.body.emitter.on('mousewheel', this._onMouseWheel.bind(this));

  // pinch to zoom
  this.body.emitter.on('touch', this._onTouch.bind(this));
  this.body.emitter.on('pinch', this._onPinch.bind(this));

  // on click of rolling mode button
  this.body.dom.rollingModeBtn.addEventListener('click', this.startRolling.bind(this));

  this.setOptions(options);
}

Range.prototype = new Component();

/**
 * Set options for the range controller
 * @param {Object} options      Available options:
 *                              {number | Date | String} start  Start date for the range
 *                              {number | Date | String} end    End date for the range
 *                              {number} min    Minimum value for start
 *                              {number} max    Maximum value for end
 *                              {number} zoomMin    Set a minimum value for
 *                                                  (end - start).
 *                              {number} zoomMax    Set a maximum value for
 *                                                  (end - start).
 *                              {boolean} moveable Enable moving of the range
 *                                                 by dragging. True by default
 *                              {boolean} zoomable Enable zooming of the range
 *                                                 by pinching/scrolling. True by default
 */
Range.prototype.setOptions = function (options) {
  if (options) {
    // copy the options that we know
    var fields = ['animation', 'direction', 'min', 'max', 'zoomMin', 'zoomMax', 'moveable', 'zoomable', 'moment', 'activate', 'hiddenDates', 'zoomKey', 'rtl', 'showCurrentTime', 'rollingMode', 'horizontalScroll'];
    util.selectiveExtend(fields, this.options, options);

    if (options.rollingMode && options.rollingMode.follow) {
      this.startRolling();
    }
    if ('start' in options || 'end' in options) {
      // apply a new range. both start and end are optional
      this.setRange(options.start, options.end);
    }
  }
};

/**
 * Test whether direction has a valid value
 * @param {string} direction    'horizontal' or 'vertical'
 */
function validateDirection(direction) {
  if (direction != 'horizontal' && direction != 'vertical') {
    throw new TypeError('Unknown direction "' + direction + '". ' + 'Choose "horizontal" or "vertical".');
  }
}

/**
 * Start auto refreshing the current time bar
 */
Range.prototype.startRolling = function () {
  var me = this;

  /**
   *  Updates the current time.
   */
  function update() {
    me.stopRolling();
    me.rolling = true;

    var interval = me.end - me.start;
    var t = util.convert(new Date(), 'Date').valueOf();

    var start = t - interval * me.options.rollingMode.offset;
    var end = t + interval * (1 - me.options.rollingMode.offset);

    var options = {
      animation: false
    };
    me.setRange(start, end, options);

    // determine interval to refresh
    var scale = me.conversion(me.body.domProps.center.width).scale;
    interval = 1 / scale / 10;
    if (interval < 30) interval = 30;
    if (interval > 1000) interval = 1000;

    me.body.dom.rollingModeBtn.style.visibility = "hidden";
    // start a renderTimer to adjust for the new time
    me.currentTimeTimer = setTimeout(update, interval);
  }

  update();
};

/**
 * Stop auto refreshing the current time bar
 */
Range.prototype.stopRolling = function () {
  if (this.currentTimeTimer !== undefined) {
    clearTimeout(this.currentTimeTimer);
    this.rolling = false;
    this.body.dom.rollingModeBtn.style.visibility = "visible";
  }
};

/**
 * Set a new start and end range
 * @param {Date | number | string} [start]
 * @param {Date | number | string} [end]
 * @param {Object} options      Available options:
 *                              {boolean | {duration: number, easingFunction: string}} [animation=false]
 *                                    If true, the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 *                              {boolean} [byUser=false]
 *                              {Event}  event  Mouse event
 * @param {Function} callback     a callback function to be executed at the end of this function  
 * @param {Function} frameCallback    a callback function executed each frame of the range animation.
 *                                    The callback will be passed three parameters:
 *                                    {number} easeCoefficient    an easing coefficent
 *                                    {boolean} willDraw          If true the caller will redraw after the callback completes
 *                                    {boolean} done              If true then animation is ending after the current frame
 */

Range.prototype.setRange = function (start, end, options, callback, frameCallback) {
  if (!options) {
    options = {};
  }
  if (options.byUser !== true) {
    options.byUser = false;
  }
  var me = this;
  var finalStart = start != undefined ? util.convert(start, 'Date').valueOf() : null;
  var finalEnd = end != undefined ? util.convert(end, 'Date').valueOf() : null;
  this._cancelAnimation();
  this.millisecondsPerPixelCache = undefined;

  if (options.animation) {
    // true or an Object
    var initStart = this.start;
    var initEnd = this.end;
    var duration = (0, _typeof3['default'])(options.animation) === 'object' && 'duration' in options.animation ? options.animation.duration : 500;
    var easingName = (0, _typeof3['default'])(options.animation) === 'object' && 'easingFunction' in options.animation ? options.animation.easingFunction : 'easeInOutQuad';
    var easingFunction = util.easingFunctions[easingName];
    if (!easingFunction) {
      throw new Error('Unknown easing function ' + (0, _stringify2['default'])(easingName) + '. ' + 'Choose from: ' + (0, _keys2['default'])(util.easingFunctions).join(', '));
    }

    var initTime = new Date().valueOf();
    var anyChanged = false;

    var next = function next() {
      if (!me.props.touch.dragging) {
        var now = new Date().valueOf();
        var time = now - initTime;
        var ease = easingFunction(time / duration);
        var done = time > duration;
        var s = done || finalStart === null ? finalStart : initStart + (finalStart - initStart) * ease;
        var e = done || finalEnd === null ? finalEnd : initEnd + (finalEnd - initEnd) * ease;

        changed = me._applyRange(s, e);
        DateUtil.updateHiddenDates(me.options.moment, me.body, me.options.hiddenDates);
        anyChanged = anyChanged || changed;

        var params = {
          start: new Date(me.start),
          end: new Date(me.end),
          byUser: options.byUser,
          event: options.event
        };

        if (frameCallback) {
          frameCallback(ease, changed, done);
        }

        if (changed) {
          me.body.emitter.emit('rangechange', params);
        }

        if (done) {
          if (anyChanged) {
            me.body.emitter.emit('rangechanged', params);
            if (callback) {
              return callback();
            }
          }
        } else {
          // animate with as high as possible frame rate, leave 20 ms in between
          // each to prevent the browser from blocking
          me.animationTimer = setTimeout(next, 20);
        }
      }
    };

    return next();
  } else {
    var changed = this._applyRange(finalStart, finalEnd);
    DateUtil.updateHiddenDates(this.options.moment, this.body, this.options.hiddenDates);
    if (changed) {
      var params = {
        start: new Date(this.start),
        end: new Date(this.end),
        byUser: options.byUser,
        event: options.event
      };

      this.body.emitter.emit('rangechange', params);
      clearTimeout(me.timeoutID);
      me.timeoutID = setTimeout(function () {
        me.body.emitter.emit('rangechanged', params);
      }, 200);
      if (callback) {
        return callback();
      }
    }
  }
};

/**
 * Get the number of milliseconds per pixel.
 *
 * @returns {undefined|number}
 */
Range.prototype.getMillisecondsPerPixel = function () {
  if (this.millisecondsPerPixelCache === undefined) {
    this.millisecondsPerPixelCache = (this.end - this.start) / this.body.dom.center.clientWidth;
  }
  return this.millisecondsPerPixelCache;
};

/**
 * Stop an animation
 * @private
 */
Range.prototype._cancelAnimation = function () {
  if (this.animationTimer) {
    clearTimeout(this.animationTimer);
    this.animationTimer = null;
  }
};

/**
 * Set a new start and end range. This method is the same as setRange, but
 * does not trigger a range change and range changed event, and it returns
 * true when the range is changed
 * @param {number} [start]
 * @param {number} [end]
 * @return {boolean} changed
 * @private
 */
Range.prototype._applyRange = function (start, end) {
  var newStart = start != null ? util.convert(start, 'Date').valueOf() : this.start,
      newEnd = end != null ? util.convert(end, 'Date').valueOf() : this.end,
      max = this.options.max != null ? util.convert(this.options.max, 'Date').valueOf() : null,
      min = this.options.min != null ? util.convert(this.options.min, 'Date').valueOf() : null,
      diff;

  // check for valid number
  if (isNaN(newStart) || newStart === null) {
    throw new Error('Invalid start "' + start + '"');
  }
  if (isNaN(newEnd) || newEnd === null) {
    throw new Error('Invalid end "' + end + '"');
  }

  // prevent end < start
  if (newEnd < newStart) {
    newEnd = newStart;
  }

  // prevent start < min
  if (min !== null) {
    if (newStart < min) {
      diff = min - newStart;
      newStart += diff;
      newEnd += diff;

      // prevent end > max
      if (max != null) {
        if (newEnd > max) {
          newEnd = max;
        }
      }
    }
  }

  // prevent end > max
  if (max !== null) {
    if (newEnd > max) {
      diff = newEnd - max;
      newStart -= diff;
      newEnd -= diff;

      // prevent start < min
      if (min != null) {
        if (newStart < min) {
          newStart = min;
        }
      }
    }
  }

  // prevent (end-start) < zoomMin
  if (this.options.zoomMin !== null) {
    var zoomMin = parseFloat(this.options.zoomMin);
    if (zoomMin < 0) {
      zoomMin = 0;
    }
    if (newEnd - newStart < zoomMin) {
      // compensate for a scale of 0.5 ms
      var compensation = 0.5;
      if (this.end - this.start === zoomMin && newStart >= this.start - compensation && newEnd <= this.end) {
        // ignore this action, we are already zoomed to the minimum
        newStart = this.start;
        newEnd = this.end;
      } else {
        // zoom to the minimum
        diff = zoomMin - (newEnd - newStart);
        newStart -= diff / 2;
        newEnd += diff / 2;
      }
    }
  }

  // prevent (end-start) > zoomMax
  if (this.options.zoomMax !== null) {
    var zoomMax = parseFloat(this.options.zoomMax);
    if (zoomMax < 0) {
      zoomMax = 0;
    }

    if (newEnd - newStart > zoomMax) {
      if (this.end - this.start === zoomMax && newStart < this.start && newEnd > this.end) {
        // ignore this action, we are already zoomed to the maximum
        newStart = this.start;
        newEnd = this.end;
      } else {
        // zoom to the maximum
        diff = newEnd - newStart - zoomMax;
        newStart += diff / 2;
        newEnd -= diff / 2;
      }
    }
  }

  var changed = this.start != newStart || this.end != newEnd;

  // if the new range does NOT overlap with the old range, emit checkRangedItems to avoid not showing ranged items (ranged meaning has end time, not necessarily of type Range)
  if (!(newStart >= this.start && newStart <= this.end || newEnd >= this.start && newEnd <= this.end) && !(this.start >= newStart && this.start <= newEnd || this.end >= newStart && this.end <= newEnd)) {
    this.body.emitter.emit('checkRangedItems');
  }

  this.start = newStart;
  this.end = newEnd;
  return changed;
};

/**
 * Retrieve the current range.
 * @return {Object} An object with start and end properties
 */
Range.prototype.getRange = function () {
  return {
    start: this.start,
    end: this.end
  };
};

/**
 * Calculate the conversion offset and scale for current range, based on
 * the provided width
 * @param {number} width
 * @param {number} [totalHidden=0]
 * @returns {{offset: number, scale: number}} conversion
 */
Range.prototype.conversion = function (width, totalHidden) {
  return Range.conversion(this.start, this.end, width, totalHidden);
};

/**
 * Static method to calculate the conversion offset and scale for a range,
 * based on the provided start, end, and width
 * @param {number} start
 * @param {number} end
 * @param {number} width
 * @param {number} [totalHidden=0]
 * @returns {{offset: number, scale: number}} conversion
 */
Range.conversion = function (start, end, width, totalHidden) {
  if (totalHidden === undefined) {
    totalHidden = 0;
  }
  if (width != 0 && end - start != 0) {
    return {
      offset: start,
      scale: width / (end - start - totalHidden)
    };
  } else {
    return {
      offset: 0,
      scale: 1
    };
  }
};

/**
 * Start dragging horizontally or vertically
 * @param {Event} event
 * @private
 */
Range.prototype._onDragStart = function (event) {
  this.deltaDifference = 0;
  this.previousDelta = 0;

  // only allow dragging when configured as movable
  if (!this.options.moveable) return;

  // only start dragging when the mouse is inside the current range
  if (!this._isInsideRange(event)) return;

  // refuse to drag when we where pinching to prevent the timeline make a jump
  // when releasing the fingers in opposite order from the touch screen
  if (!this.props.touch.allowDragging) return;

  this.stopRolling();

  this.props.touch.start = this.start;
  this.props.touch.end = this.end;
  this.props.touch.dragging = true;

  if (this.body.dom.root) {
    this.body.dom.root.style.cursor = 'move';
  }
};

/**
 * Perform dragging operation
 * @param {Event} event
 * @private
 */
Range.prototype._onDrag = function (event) {
  if (!event) return;

  if (!this.props.touch.dragging) return;

  // only allow dragging when configured as movable
  if (!this.options.moveable) return;

  // TODO: this may be redundant in hammerjs2
  // refuse to drag when we where pinching to prevent the timeline make a jump
  // when releasing the fingers in opposite order from the touch screen
  if (!this.props.touch.allowDragging) return;

  var direction = this.options.direction;
  validateDirection(direction);
  var delta = direction == 'horizontal' ? event.deltaX : event.deltaY;
  delta -= this.deltaDifference;
  var interval = this.props.touch.end - this.props.touch.start;

  // normalize dragging speed if cutout is in between.
  var duration = DateUtil.getHiddenDurationBetween(this.body.hiddenDates, this.start, this.end);
  interval -= duration;

  var width = direction == 'horizontal' ? this.body.domProps.center.width : this.body.domProps.center.height;
  var diffRange;
  if (this.options.rtl) {
    diffRange = delta / width * interval;
  } else {
    diffRange = -delta / width * interval;
  }

  var newStart = this.props.touch.start + diffRange;
  var newEnd = this.props.touch.end + diffRange;

  // snapping times away from hidden zones
  var safeStart = DateUtil.snapAwayFromHidden(this.body.hiddenDates, newStart, this.previousDelta - delta, true);
  var safeEnd = DateUtil.snapAwayFromHidden(this.body.hiddenDates, newEnd, this.previousDelta - delta, true);
  if (safeStart != newStart || safeEnd != newEnd) {
    this.deltaDifference += delta;
    this.props.touch.start = safeStart;
    this.props.touch.end = safeEnd;
    this._onDrag(event);
    return;
  }

  this.previousDelta = delta;
  this._applyRange(newStart, newEnd);

  var startDate = new Date(this.start);
  var endDate = new Date(this.end);

  // fire a rangechange event
  this.body.emitter.emit('rangechange', {
    start: startDate,
    end: endDate,
    byUser: true,
    event: event
  });

  // fire a panmove event
  this.body.emitter.emit('panmove');
};

/**
 * Stop dragging operation
 * @param {event} event
 * @private
 */
Range.prototype._onDragEnd = function (event) {
  if (!this.props.touch.dragging) return;

  // only allow dragging when configured as movable
  if (!this.options.moveable) return;

  // TODO: this may be redundant in hammerjs2
  // refuse to drag when we where pinching to prevent the timeline make a jump
  // when releasing the fingers in opposite order from the touch screen
  if (!this.props.touch.allowDragging) return;

  this.props.touch.dragging = false;
  if (this.body.dom.root) {
    this.body.dom.root.style.cursor = 'auto';
  }

  // fire a rangechanged event
  this.body.emitter.emit('rangechanged', {
    start: new Date(this.start),
    end: new Date(this.end),
    byUser: true,
    event: event
  });
};

/**
 * Event handler for mouse wheel event, used to zoom
 * Code from http://adomas.org/javascript-mouse-wheel/
 * @param {Event} event
 * @private
 */
Range.prototype._onMouseWheel = function (event) {
  // retrieve delta
  var delta = 0;
  if (event.wheelDelta) {
    /* IE/Opera. */
    delta = event.wheelDelta / 120;
  } else if (event.detail) {
    /* Mozilla case. */
    // In Mozilla, sign of delta is different than in IE.
    // Also, delta is multiple of 3.
    delta = -event.detail / 3;
  }

  // don't allow zoom when the according key is pressed and the zoomKey option or not zoomable but movable
  if (this.options.zoomKey && !event[this.options.zoomKey] && this.options.zoomable || !this.options.zoomable && this.options.moveable) {
    return;
  }

  // only allow zooming when configured as zoomable and moveable
  if (!(this.options.zoomable && this.options.moveable)) return;

  // only zoom when the mouse is inside the current range
  if (!this._isInsideRange(event)) return;

  // If delta is nonzero, handle it.
  // Basically, delta is now positive if wheel was scrolled up,
  // and negative, if wheel was scrolled down.
  if (delta) {
    // perform the zoom action. Delta is normally 1 or -1

    // adjust a negative delta such that zooming in with delta 0.1
    // equals zooming out with a delta -0.1
    var scale;
    if (delta < 0) {
      scale = 1 - delta / 5;
    } else {
      scale = 1 / (1 + delta / 5);
    }

    // calculate center, the date to zoom around
    var pointerDate;
    if (this.rolling) {
      pointerDate = this.start + (this.end - this.start) * this.options.rollingMode.offset;
    } else {
      var pointer = this.getPointer({ x: event.clientX, y: event.clientY }, this.body.dom.center);
      pointerDate = this._pointerToDate(pointer);
    }
    this.zoom(scale, pointerDate, delta, event);

    // Prevent default actions caused by mouse wheel
    // (else the page and timeline both scroll)
    event.preventDefault();
  }
};

/**
 * Start of a touch gesture
 * @param {Event} event
 * @private
 */
Range.prototype._onTouch = function (event) {
  // eslint-disable-line no-unused-vars
  this.props.touch.start = this.start;
  this.props.touch.end = this.end;
  this.props.touch.allowDragging = true;
  this.props.touch.center = null;
  this.scaleOffset = 0;
  this.deltaDifference = 0;
  // Disable the browser default handling of this event.
  util.preventDefault(event);
};

/**
 * Handle pinch event
 * @param {Event} event
 * @private
 */
Range.prototype._onPinch = function (event) {
  // only allow zooming when configured as zoomable and moveable
  if (!(this.options.zoomable && this.options.moveable)) return;

  // Disable the browser default handling of this event.
  util.preventDefault(event);

  this.props.touch.allowDragging = false;

  if (!this.props.touch.center) {
    this.props.touch.center = this.getPointer(event.center, this.body.dom.center);
  }

  this.stopRolling();

  var scale = 1 / (event.scale + this.scaleOffset);
  var centerDate = this._pointerToDate(this.props.touch.center);

  var hiddenDuration = DateUtil.getHiddenDurationBetween(this.body.hiddenDates, this.start, this.end);
  var hiddenDurationBefore = DateUtil.getHiddenDurationBefore(this.options.moment, this.body.hiddenDates, this, centerDate);
  var hiddenDurationAfter = hiddenDuration - hiddenDurationBefore;

  // calculate new start and end
  var newStart = centerDate - hiddenDurationBefore + (this.props.touch.start - (centerDate - hiddenDurationBefore)) * scale;
  var newEnd = centerDate + hiddenDurationAfter + (this.props.touch.end - (centerDate + hiddenDurationAfter)) * scale;

  // snapping times away from hidden zones
  this.startToFront = 1 - scale <= 0; // used to do the right auto correction with periodic hidden times
  this.endToFront = scale - 1 <= 0; // used to do the right auto correction with periodic hidden times

  var safeStart = DateUtil.snapAwayFromHidden(this.body.hiddenDates, newStart, 1 - scale, true);
  var safeEnd = DateUtil.snapAwayFromHidden(this.body.hiddenDates, newEnd, scale - 1, true);
  if (safeStart != newStart || safeEnd != newEnd) {
    this.props.touch.start = safeStart;
    this.props.touch.end = safeEnd;
    this.scaleOffset = 1 - event.scale;
    newStart = safeStart;
    newEnd = safeEnd;
  }

  var options = {
    animation: false,
    byUser: true,
    event: event
  };
  this.setRange(newStart, newEnd, options);

  this.startToFront = false; // revert to default
  this.endToFront = true; // revert to default
};

/**
 * Test whether the mouse from a mouse event is inside the visible window,
 * between the current start and end date
 * @param {Object} event
 * @return {boolean} Returns true when inside the visible window
 * @private
 */
Range.prototype._isInsideRange = function (event) {
  // calculate the time where the mouse is, check whether inside
  // and no scroll action should happen.
  var clientX = event.center ? event.center.x : event.clientX;
  var x;
  if (this.options.rtl) {
    x = clientX - util.getAbsoluteLeft(this.body.dom.centerContainer);
  } else {
    x = util.getAbsoluteRight(this.body.dom.centerContainer) - clientX;
  }
  var time = this.body.util.toTime(x);

  return time >= this.start && time <= this.end;
};

/**
 * Helper function to calculate the center date for zooming
 * @param {{x: number, y: number}} pointer
 * @return {number} date
 * @private
 */
Range.prototype._pointerToDate = function (pointer) {
  var conversion;
  var direction = this.options.direction;

  validateDirection(direction);

  if (direction == 'horizontal') {
    return this.body.util.toTime(pointer.x).valueOf();
  } else {
    var height = this.body.domProps.center.height;
    conversion = this.conversion(height);
    return pointer.y / conversion.scale + conversion.offset;
  }
};

/**
 * Get the pointer location relative to the location of the dom element
 * @param {{x: number, y: number}} touch
 * @param {Element} element   HTML DOM element
 * @return {{x: number, y: number}} pointer
 * @private
 */
Range.prototype.getPointer = function (touch, element) {
  if (this.options.rtl) {
    return {
      x: util.getAbsoluteRight(element) - touch.x,
      y: touch.y - util.getAbsoluteTop(element)
    };
  } else {
    return {
      x: touch.x - util.getAbsoluteLeft(element),
      y: touch.y - util.getAbsoluteTop(element)
    };
  }
};

/**
 * Zoom the range the given scale in or out. Start and end date will
 * be adjusted, and the timeline will be redrawn. You can optionally give a
 * date around which to zoom.
 * For example, try scale = 0.9 or 1.1
 * @param {number} scale      Scaling factor. Values above 1 will zoom out,
 *                            values below 1 will zoom in.
 * @param {number} [center]   Value representing a date around which will
 *                            be zoomed.
 * @param {number} delta
 * @param {Event} event
 */
Range.prototype.zoom = function (scale, center, delta, event) {
  // if centerDate is not provided, take it half between start Date and end Date
  if (center == null) {
    center = (this.start + this.end) / 2;
  }

  var hiddenDuration = DateUtil.getHiddenDurationBetween(this.body.hiddenDates, this.start, this.end);
  var hiddenDurationBefore = DateUtil.getHiddenDurationBefore(this.options.moment, this.body.hiddenDates, this, center);
  var hiddenDurationAfter = hiddenDuration - hiddenDurationBefore;

  // calculate new start and end
  var newStart = center - hiddenDurationBefore + (this.start - (center - hiddenDurationBefore)) * scale;
  var newEnd = center + hiddenDurationAfter + (this.end - (center + hiddenDurationAfter)) * scale;

  // snapping times away from hidden zones
  this.startToFront = delta > 0 ? false : true; // used to do the right autocorrection with periodic hidden times
  this.endToFront = -delta > 0 ? false : true; // used to do the right autocorrection with periodic hidden times
  var safeStart = DateUtil.snapAwayFromHidden(this.body.hiddenDates, newStart, delta, true);
  var safeEnd = DateUtil.snapAwayFromHidden(this.body.hiddenDates, newEnd, -delta, true);
  if (safeStart != newStart || safeEnd != newEnd) {
    newStart = safeStart;
    newEnd = safeEnd;
  }

  var options = {
    animation: false,
    byUser: true,
    event: event
  };
  this.setRange(newStart, newEnd, options);

  this.startToFront = false; // revert to default
  this.endToFront = true; // revert to default
};

/**
 * Move the range with a given delta to the left or right. Start and end
 * value will be adjusted. For example, try delta = 0.1 or -0.1
 * @param {number}  delta     Moving amount. Positive value will move right,
 *                            negative value will move left
 */
Range.prototype.move = function (delta) {
  // zoom start Date and end Date relative to the centerDate
  var diff = this.end - this.start;

  // apply new values
  var newStart = this.start + diff * delta;
  var newEnd = this.end + diff * delta;

  // TODO: reckon with min and max range

  this.start = newStart;
  this.end = newEnd;
};

/**
 * Move the range to a new center point
 * @param {number} moveTo      New center point of the range
 */
Range.prototype.moveTo = function (moveTo) {
  var center = (this.start + this.end) / 2;

  var diff = center - moveTo;

  // calculate new start and end
  var newStart = this.start - diff;
  var newEnd = this.end - diff;

  var options = {
    animation: false,
    byUser: true,
    event: null
  };
  this.setRange(newStart, newEnd, options);
};

module.exports = Range;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__(19);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Emitter = __webpack_require__(44);
var Hammer = __webpack_require__(10);
var hammerUtil = __webpack_require__(37);
var util = __webpack_require__(2);
var TimeAxis = __webpack_require__(45);
var Activator = __webpack_require__(97);
var DateUtil = __webpack_require__(36);
var CustomTime = __webpack_require__(46);

/**
 * Create a timeline visualization
 * @constructor Core
 */
function Core() {}

// turn Core into an event emitter
Emitter(Core.prototype);

/**
 * Create the main DOM for the Core: a root panel containing left, right,
 * top, bottom, content, and background panel.
 * @param {Element} container  The container element where the Core will
 *                             be attached.
 * @protected
 */
Core.prototype._create = function (container) {
  this.dom = {};

  this.dom.container = container;

  this.dom.root = document.createElement('div');
  this.dom.background = document.createElement('div');
  this.dom.backgroundVertical = document.createElement('div');
  this.dom.backgroundHorizontal = document.createElement('div');
  this.dom.centerContainer = document.createElement('div');
  this.dom.leftContainer = document.createElement('div');
  this.dom.rightContainer = document.createElement('div');
  this.dom.center = document.createElement('div');
  this.dom.left = document.createElement('div');
  this.dom.right = document.createElement('div');
  this.dom.top = document.createElement('div');
  this.dom.bottom = document.createElement('div');
  this.dom.shadowTop = document.createElement('div');
  this.dom.shadowBottom = document.createElement('div');
  this.dom.shadowTopLeft = document.createElement('div');
  this.dom.shadowBottomLeft = document.createElement('div');
  this.dom.shadowTopRight = document.createElement('div');
  this.dom.shadowBottomRight = document.createElement('div');
  this.dom.rollingModeBtn = document.createElement('div');

  this.dom.root.className = 'vis-timeline';
  this.dom.background.className = 'vis-panel vis-background';
  this.dom.backgroundVertical.className = 'vis-panel vis-background vis-vertical';
  this.dom.backgroundHorizontal.className = 'vis-panel vis-background vis-horizontal';
  this.dom.centerContainer.className = 'vis-panel vis-center';
  this.dom.leftContainer.className = 'vis-panel vis-left';
  this.dom.rightContainer.className = 'vis-panel vis-right';
  this.dom.top.className = 'vis-panel vis-top';
  this.dom.bottom.className = 'vis-panel vis-bottom';
  this.dom.left.className = 'vis-content';
  this.dom.center.className = 'vis-content';
  this.dom.right.className = 'vis-content';
  this.dom.shadowTop.className = 'vis-shadow vis-top';
  this.dom.shadowBottom.className = 'vis-shadow vis-bottom';
  this.dom.shadowTopLeft.className = 'vis-shadow vis-top';
  this.dom.shadowBottomLeft.className = 'vis-shadow vis-bottom';
  this.dom.shadowTopRight.className = 'vis-shadow vis-top';
  this.dom.shadowBottomRight.className = 'vis-shadow vis-bottom';
  this.dom.rollingModeBtn.className = 'vis-rolling-mode-btn';

  this.dom.root.appendChild(this.dom.background);
  this.dom.root.appendChild(this.dom.backgroundVertical);
  this.dom.root.appendChild(this.dom.backgroundHorizontal);
  this.dom.root.appendChild(this.dom.centerContainer);
  this.dom.root.appendChild(this.dom.leftContainer);
  this.dom.root.appendChild(this.dom.rightContainer);
  this.dom.root.appendChild(this.dom.top);
  this.dom.root.appendChild(this.dom.bottom);
  this.dom.root.appendChild(this.dom.bottom);
  this.dom.root.appendChild(this.dom.rollingModeBtn);

  this.dom.centerContainer.appendChild(this.dom.center);
  this.dom.leftContainer.appendChild(this.dom.left);
  this.dom.rightContainer.appendChild(this.dom.right);
  this.dom.centerContainer.appendChild(this.dom.shadowTop);
  this.dom.centerContainer.appendChild(this.dom.shadowBottom);
  this.dom.leftContainer.appendChild(this.dom.shadowTopLeft);
  this.dom.leftContainer.appendChild(this.dom.shadowBottomLeft);
  this.dom.rightContainer.appendChild(this.dom.shadowTopRight);
  this.dom.rightContainer.appendChild(this.dom.shadowBottomRight);

  // size properties of each of the panels
  this.props = {
    root: {},
    background: {},
    centerContainer: {},
    leftContainer: {},
    rightContainer: {},
    center: {},
    left: {},
    right: {},
    top: {},
    bottom: {},
    border: {},
    scrollTop: 0,
    scrollTopMin: 0
  };

  this.on('rangechange', function () {
    if (this.initialDrawDone === true) {
      this._redraw();
    }
  }.bind(this));
  this.on('rangechanged', function () {
    if (!this.initialRangeChangeDone) {
      this.initialRangeChangeDone = true;
    }
  }.bind(this));
  this.on('touch', this._onTouch.bind(this));
  this.on('panmove', this._onDrag.bind(this));

  var me = this;
  this._origRedraw = this._redraw.bind(this);
  this._redraw = util.throttle(this._origRedraw);

  this.on('_change', function (properties) {
    if (me.itemSet && me.itemSet.initialItemSetDrawn && properties && properties.queue == true) {
      me._redraw();
    } else {
      me._origRedraw();
    }
  });

  // create event listeners for all interesting events, these events will be
  // emitted via emitter
  this.hammer = new Hammer(this.dom.root);
  var pinchRecognizer = this.hammer.get('pinch').set({ enable: true });
  hammerUtil.disablePreventDefaultVertically(pinchRecognizer);
  this.hammer.get('pan').set({ threshold: 5, direction: Hammer.DIRECTION_HORIZONTAL });
  this.listeners = {};

  var events = ['tap', 'doubletap', 'press', 'pinch', 'pan', 'panstart', 'panmove', 'panend'
  // TODO: cleanup
  //'touch', 'pinch',
  //'tap', 'doubletap', 'hold',
  //'dragstart', 'drag', 'dragend',
  //'mousewheel', 'DOMMouseScroll' // DOMMouseScroll is needed for Firefox
  ];
  events.forEach(function (type) {
    var listener = function listener(event) {
      if (me.isActive()) {
        me.emit(type, event);
      }
    };
    me.hammer.on(type, listener);
    me.listeners[type] = listener;
  });

  // emulate a touch event (emitted before the start of a pan, pinch, tap, or press)
  hammerUtil.onTouch(this.hammer, function (event) {
    me.emit('touch', event);
  }.bind(this));

  // emulate a release event (emitted after a pan, pinch, tap, or press)
  hammerUtil.onRelease(this.hammer, function (event) {
    me.emit('release', event);
  }.bind(this));

  /**
   *
   * @param {WheelEvent} event
   */
  function onMouseWheel(event) {
    if (this.isActive()) {
      this.emit('mousewheel', event);
    }

    // deltaX and deltaY normalization from jquery.mousewheel.js
    var deltaX = 0;
    var deltaY = 0;

    // Old school scrollwheel delta
    if ('detail' in event) {
      deltaY = event.detail * -1;
    }
    if ('wheelDelta' in event) {
      deltaY = event.wheelDelta;
    }
    if ('wheelDeltaY' in event) {
      deltaY = event.wheelDeltaY;
    }
    if ('wheelDeltaX' in event) {
      deltaX = event.wheelDeltaX * -1;
    }

    // Firefox < 17 horizontal scrolling related to DOMMouseScroll event
    if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
      deltaX = deltaY * -1;
      deltaY = 0;
    }

    // New school wheel delta (wheel event)
    if ('deltaY' in event) {
      deltaY = event.deltaY * -1;
    }
    if ('deltaX' in event) {
      deltaX = event.deltaX;
    }

    // prevent scrolling when zoomKey defined or activated
    if (!this.options.zoomKey || event[this.options.zoomKey]) return;

    // Prevent default actions caused by mouse wheel
    // (else the page and timeline both scroll)
    event.preventDefault();

    if (this.options.verticalScroll && Math.abs(deltaY) >= Math.abs(deltaX)) {
      var current = this.props.scrollTop;
      var adjusted = current + deltaY;

      if (this.isActive()) {
        this._setScrollTop(adjusted);
        this._redraw();
        this.emit('scroll', event);
      }
    } else if (this.options.horizontalScroll) {
      var delta = Math.abs(deltaX) >= Math.abs(deltaY) ? deltaX : deltaY;

      // calculate a single scroll jump relative to the range scale
      var diff = delta / 120 * (this.range.end - this.range.start) / 20;
      // calculate new start and end
      var newStart = this.range.start + diff;
      var newEnd = this.range.end + diff;

      var options = {
        animation: false,
        byUser: true,
        event: event
      };
      this.range.setRange(newStart, newEnd, options);
    }
  }

  if (this.dom.centerContainer.addEventListener) {
    // IE9, Chrome, Safari, Opera
    this.dom.centerContainer.addEventListener("mousewheel", onMouseWheel.bind(this), false);
    // Firefox
    this.dom.centerContainer.addEventListener("DOMMouseScroll", onMouseWheel.bind(this), false);
  } else {
    // IE 6/7/8
    this.dom.centerContainer.attachEvent("onmousewheel", onMouseWheel.bind(this));
  }

  /**
   *
   * @param {scroll} event
   */
  function onMouseScrollSide(event) {
    if (!me.options.verticalScroll) return;
    event.preventDefault();
    if (me.isActive()) {
      var adjusted = -event.target.scrollTop;
      me._setScrollTop(adjusted);
      me._redraw();
      me.emit('scrollSide', event);
    }
  }

  this.dom.left.parentNode.addEventListener('scroll', onMouseScrollSide.bind(this));
  this.dom.right.parentNode.addEventListener('scroll', onMouseScrollSide.bind(this));

  var itemAddedToTimeline = false;

  /**
   *
   * @param {dragover} event
   * @returns {boolean}
   */
  function handleDragOver(event) {
    if (event.preventDefault) {
      event.preventDefault(); // Necessary. Allows us to drop.
    }

    // make sure your target is a vis element
    if (!event.target.className.indexOf("vis") > -1) return;

    // make sure only one item is added every time you're over the timeline
    if (itemAddedToTimeline) return;

    event.dataTransfer.dropEffect = 'move';
    itemAddedToTimeline = true;
    return false;
  }

  /**
   *
   * @param {drop} event
   * @returns {boolean}
   */
  function handleDrop(event) {
    // prevent redirect to blank page - Firefox
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    // return when dropping non-vis items
    try {
      var itemData = JSON.parse(event.dataTransfer.getData("text"));
      if (!itemData || !itemData.content) return;
    } catch (err) {
      return false;
    }

    itemAddedToTimeline = false;
    event.center = {
      x: event.clientX,
      y: event.clientY
    };

    if (itemData.target !== 'item') {
      me.itemSet._onAddItem(event);
    } else {
      me.itemSet._onDropObjectOnItem(event);
    }
    me.emit('drop', me.getEventProperties(event));
    return false;
  }

  this.dom.center.addEventListener('dragover', handleDragOver.bind(this), false);
  this.dom.center.addEventListener('drop', handleDrop.bind(this), false);

  this.customTimes = [];

  // store state information needed for touch events
  this.touch = {};

  this.redrawCount = 0;
  this.initialDrawDone = false;
  this.initialRangeChangeDone = false;

  // attach the root panel to the provided container
  if (!container) throw new Error('No container provided');
  container.appendChild(this.dom.root);
};

/**
 * Set options. Options will be passed to all components loaded in the Timeline.
 * @param {Object} [options]
 *                           {String} orientation
 *                              Vertical orientation for the Timeline,
 *                              can be 'bottom' (default) or 'top'.
 *                           {string | number} width
 *                              Width for the timeline, a number in pixels or
 *                              a css string like '1000px' or '75%'. '100%' by default.
 *                           {string | number} height
 *                              Fixed height for the Timeline, a number in pixels or
 *                              a css string like '400px' or '75%'. If undefined,
 *                              The Timeline will automatically size such that
 *                              its contents fit.
 *                           {string | number} minHeight
 *                              Minimum height for the Timeline, a number in pixels or
 *                              a css string like '400px' or '75%'.
 *                           {string | number} maxHeight
 *                              Maximum height for the Timeline, a number in pixels or
 *                              a css string like '400px' or '75%'.
 *                           {number | Date | string} start
 *                              Start date for the visible window
 *                           {number | Date | string} end
 *                              End date for the visible window
 */
Core.prototype.setOptions = function (options) {
  if (options) {
    // copy the known options
    var fields = ['width', 'height', 'minHeight', 'maxHeight', 'autoResize', 'start', 'end', 'clickToUse', 'dataAttributes', 'hiddenDates', 'locale', 'locales', 'moment', 'rtl', 'zoomKey', 'horizontalScroll', 'verticalScroll'];
    util.selectiveExtend(fields, this.options, options);

    this.dom.rollingModeBtn.style.visibility = 'hidden';

    if (this.options.rtl) {
      this.dom.container.style.direction = "rtl";
      this.dom.backgroundVertical.className = 'vis-panel vis-background vis-vertical-rtl';
    }

    if (this.options.verticalScroll) {
      if (this.options.rtl) {
        this.dom.rightContainer.className = 'vis-panel vis-right vis-vertical-scroll';
      } else {
        this.dom.leftContainer.className = 'vis-panel vis-left vis-vertical-scroll';
      }
    }

    if ((0, _typeof3['default'])(this.options.orientation) !== 'object') {
      this.options.orientation = { item: undefined, axis: undefined };
    }
    if ('orientation' in options) {
      if (typeof options.orientation === 'string') {
        this.options.orientation = {
          item: options.orientation,
          axis: options.orientation
        };
      } else if ((0, _typeof3['default'])(options.orientation) === 'object') {
        if ('item' in options.orientation) {
          this.options.orientation.item = options.orientation.item;
        }
        if ('axis' in options.orientation) {
          this.options.orientation.axis = options.orientation.axis;
        }
      }
    }

    if (this.options.orientation.axis === 'both') {
      if (!this.timeAxis2) {
        var timeAxis2 = this.timeAxis2 = new TimeAxis(this.body);
        timeAxis2.setOptions = function (options) {
          var _options = options ? util.extend({}, options) : {};
          _options.orientation = 'top'; // override the orientation option, always top
          TimeAxis.prototype.setOptions.call(timeAxis2, _options);
        };
        this.components.push(timeAxis2);
      }
    } else {
      if (this.timeAxis2) {
        var index = this.components.indexOf(this.timeAxis2);
        if (index !== -1) {
          this.components.splice(index, 1);
        }
        this.timeAxis2.destroy();
        this.timeAxis2 = null;
      }
    }

    // if the graph2d's drawPoints is a function delegate the callback to the onRender property
    if (typeof options.drawPoints == 'function') {
      options.drawPoints = {
        onRender: options.drawPoints
      };
    }

    if ('hiddenDates' in this.options) {
      DateUtil.convertHiddenOptions(this.options.moment, this.body, this.options.hiddenDates);
    }

    if ('clickToUse' in options) {
      if (options.clickToUse) {
        if (!this.activator) {
          this.activator = new Activator(this.dom.root);
        }
      } else {
        if (this.activator) {
          this.activator.destroy();
          delete this.activator;
        }
      }
    }

    if ('showCustomTime' in options) {
      throw new Error('Option `showCustomTime` is deprecated. Create a custom time bar via timeline.addCustomTime(time [, id])');
    }

    // enable/disable autoResize
    this._initAutoResize();
  }

  // propagate options to all components
  this.components.forEach(function (component) {
    return component.setOptions(options);
  });

  // enable/disable configure
  if ('configure' in options) {
    if (!this.configurator) {
      this.configurator = this._createConfigurator();
    }

    this.configurator.setOptions(options.configure);

    // collect the settings of all components, and pass them to the configuration system
    var appliedOptions = util.deepExtend({}, this.options);
    this.components.forEach(function (component) {
      util.deepExtend(appliedOptions, component.options);
    });
    this.configurator.setModuleOptions({ global: appliedOptions });
  }

  this._redraw();
};

/**
 * Returns true when the Timeline is active.
 * @returns {boolean}
 */
Core.prototype.isActive = function () {
  return !this.activator || this.activator.active;
};

/**
 * Destroy the Core, clean up all DOM elements and event listeners.
 */
Core.prototype.destroy = function () {
  // unbind datasets
  this.setItems(null);
  this.setGroups(null);

  // remove all event listeners
  this.off();

  // stop checking for changed size
  this._stopAutoResize();

  // remove from DOM
  if (this.dom.root.parentNode) {
    this.dom.root.parentNode.removeChild(this.dom.root);
  }
  this.dom = null;

  // remove Activator
  if (this.activator) {
    this.activator.destroy();
    delete this.activator;
  }

  // cleanup hammer touch events
  for (var event in this.listeners) {
    if (this.listeners.hasOwnProperty(event)) {
      delete this.listeners[event];
    }
  }
  this.listeners = null;
  this.hammer = null;

  // give all components the opportunity to cleanup
  this.components.forEach(function (component) {
    return component.destroy();
  });

  this.body = null;
};

/**
 * Set a custom time bar
 * @param {Date} time
 * @param {number} [id=undefined] Optional id of the custom time bar to be adjusted.
 */
Core.prototype.setCustomTime = function (time, id) {
  var customTimes = this.customTimes.filter(function (component) {
    return id === component.options.id;
  });

  if (customTimes.length === 0) {
    throw new Error('No custom time bar found with id ' + (0, _stringify2['default'])(id));
  }

  if (customTimes.length > 0) {
    customTimes[0].setCustomTime(time);
  }
};

/**
 * Retrieve the current custom time.
 * @param {number} [id=undefined]    Id of the custom time bar.
 * @return {Date | undefined} customTime
 */
Core.prototype.getCustomTime = function (id) {
  var customTimes = this.customTimes.filter(function (component) {
    return component.options.id === id;
  });

  if (customTimes.length === 0) {
    throw new Error('No custom time bar found with id ' + (0, _stringify2['default'])(id));
  }
  return customTimes[0].getCustomTime();
};

/**
 * Set a custom title for the custom time bar.
 * @param {string} [title] Custom title
 * @param {number} [id=undefined]    Id of the custom time bar.
 * @returns {*}
 */
Core.prototype.setCustomTimeTitle = function (title, id) {
  var customTimes = this.customTimes.filter(function (component) {
    return component.options.id === id;
  });

  if (customTimes.length === 0) {
    throw new Error('No custom time bar found with id ' + (0, _stringify2['default'])(id));
  }
  if (customTimes.length > 0) {
    return customTimes[0].setCustomTitle(title);
  }
};

/**
 * Retrieve meta information from an event.
 * Should be overridden by classes extending Core
 * @param {Event} event
 * @return {Object} An object with related information.
 */
Core.prototype.getEventProperties = function (event) {
  return { event: event };
};

/**
 * Add custom vertical bar
 * @param {Date | string | number} [time]  A Date, unix timestamp, or
 *                                         ISO date string. Time point where
 *                                         the new bar should be placed.
 *                                         If not provided, `new Date()` will
 *                                         be used.
 * @param {number | string} [id=undefined] Id of the new bar. Optional
 * @return {number | string}               Returns the id of the new bar
 */
Core.prototype.addCustomTime = function (time, id) {
  var timestamp = time !== undefined ? util.convert(time, 'Date').valueOf() : new Date();

  var exists = this.customTimes.some(function (customTime) {
    return customTime.options.id === id;
  });
  if (exists) {
    throw new Error('A custom time with id ' + (0, _stringify2['default'])(id) + ' already exists');
  }

  var customTime = new CustomTime(this.body, util.extend({}, this.options, {
    time: timestamp,
    id: id
  }));

  this.customTimes.push(customTime);
  this.components.push(customTime);
  this._redraw();

  return id;
};

/**
 * Remove previously added custom bar
 * @param {int} id ID of the custom bar to be removed
 * [at]returns {boolean} True if the bar exists and is removed, false otherwise
 */
Core.prototype.removeCustomTime = function (id) {
  var customTimes = this.customTimes.filter(function (bar) {
    return bar.options.id === id;
  });

  if (customTimes.length === 0) {
    throw new Error('No custom time bar found with id ' + (0, _stringify2['default'])(id));
  }

  customTimes.forEach(function (customTime) {
    this.customTimes.splice(this.customTimes.indexOf(customTime), 1);
    this.components.splice(this.components.indexOf(customTime), 1);
    customTime.destroy();
  }.bind(this));
};

/**
 * Get the id's of the currently visible items.
 * @returns {Array} The ids of the visible items
 */
Core.prototype.getVisibleItems = function () {
  return this.itemSet && this.itemSet.getVisibleItems() || [];
};

/**
 * Set Core window such that it fits all items
 * @param {Object} [options]  Available options:
 *                                `animation: boolean | {duration: number, easingFunction: string}`
 *                                    If true (default), the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 * @param {function} [callback] a callback funtion to be executed at the end of this function
 */
Core.prototype.fit = function (options, callback) {
  var range = this.getDataRange();

  // skip range set if there is no min and max date
  if (range.min === null && range.max === null) {
    return;
  }

  // apply a margin of 1% left and right of the data
  var interval = range.max - range.min;
  var min = new Date(range.min.valueOf() - interval * 0.01);
  var max = new Date(range.max.valueOf() + interval * 0.01);
  var animation = options && options.animation !== undefined ? options.animation : true;
  this.range.setRange(min, max, { animation: animation }, callback);
};

/**
 * Calculate the data range of the items start and end dates
 * [at]returns {{min: [Date], max: [Date]}}
 * @protected
 */
Core.prototype.getDataRange = function () {
  // must be implemented by Timeline and Graph2d
  throw new Error('Cannot invoke abstract method getDataRange');
};

/**
 * Set the visible window. Both parameters are optional, you can change only
 * start or only end. Syntax:
 *
 *     TimeLine.setWindow(start, end)
 *     TimeLine.setWindow(start, end, options)
 *     TimeLine.setWindow(range)
 *
 * Where start and end can be a Date, number, or string, and range is an
 * object with properties start and end.
 *
 * @param {Date | number | string | Object} [start] Start date of visible window
 * @param {Date | number | string} [end]            End date of visible window
 * @param {Object} [options]  Available options:
 *                                `animation: boolean | {duration: number, easingFunction: string}`
 *                                    If true (default), the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 * @param {function} [callback] a callback funtion to be executed at the end of this function
 */
Core.prototype.setWindow = function (start, end, options, callback) {
  if (typeof arguments[2] == "function") {
    callback = arguments[2];
    options = {};
  }
  var animation;
  var range;
  if (arguments.length == 1) {
    range = arguments[0];
    animation = range.animation !== undefined ? range.animation : true;
    this.range.setRange(range.start, range.end, { animation: animation });
  } else if (arguments.length == 2 && typeof arguments[1] == "function") {
    range = arguments[0];
    callback = arguments[1];
    animation = range.animation !== undefined ? range.animation : true;
    this.range.setRange(range.start, range.end, { animation: animation }, callback);
  } else {
    animation = options && options.animation !== undefined ? options.animation : true;
    this.range.setRange(start, end, { animation: animation }, callback);
  }
};

/**
 * Move the window such that given time is centered on screen.
 * @param {Date | number | string} time
 * @param {Object} [options]  Available options:
 *                                `animation: boolean | {duration: number, easingFunction: string}`
 *                                    If true (default), the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 * @param {function} [callback] a callback funtion to be executed at the end of this function
 */
Core.prototype.moveTo = function (time, options, callback) {
  if (typeof arguments[1] == "function") {
    callback = arguments[1];
    options = {};
  }
  var interval = this.range.end - this.range.start;
  var t = util.convert(time, 'Date').valueOf();

  var start = t - interval / 2;
  var end = t + interval / 2;
  var animation = options && options.animation !== undefined ? options.animation : true;

  this.range.setRange(start, end, { animation: animation }, callback);
};

/**
 * Get the visible window
 * @return {{start: Date, end: Date}}   Visible range
 */
Core.prototype.getWindow = function () {
  var range = this.range.getRange();
  return {
    start: new Date(range.start),
    end: new Date(range.end)
  };
};

/**
 * Zoom in the window such that given time is centered on screen.
 * @param {number} percentage - must be between [0..1]
 * @param {Object} [options]  Available options:
 *                                `animation: boolean | {duration: number, easingFunction: string}`
 *                                    If true (default), the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 * @param {function} [callback] a callback funtion to be executed at the end of this function
 */
Core.prototype.zoomIn = function (percentage, options, callback) {
  if (!percentage || percentage < 0 || percentage > 1) return;
  if (typeof arguments[1] == "function") {
    callback = arguments[1];
    options = {};
  }
  var range = this.getWindow();
  var start = range.start.valueOf();
  var end = range.end.valueOf();
  var interval = end - start;
  var newInterval = interval / (1 + percentage);
  var distance = (interval - newInterval) / 2;
  var newStart = start + distance;
  var newEnd = end - distance;

  this.setWindow(newStart, newEnd, options, callback);
};

/**
 * Zoom out the window such that given time is centered on screen.
 * @param {number} percentage - must be between [0..1]
 * @param {Object} [options]  Available options:
 *                                `animation: boolean | {duration: number, easingFunction: string}`
 *                                    If true (default), the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 * @param {function} [callback] a callback funtion to be executed at the end of this function
 */
Core.prototype.zoomOut = function (percentage, options, callback) {
  if (!percentage || percentage < 0 || percentage > 1) return;
  if (typeof arguments[1] == "function") {
    callback = arguments[1];
    options = {};
  }
  var range = this.getWindow();
  var start = range.start.valueOf();
  var end = range.end.valueOf();
  var interval = end - start;
  var newStart = start - interval * percentage / 2;
  var newEnd = end + interval * percentage / 2;

  this.setWindow(newStart, newEnd, options, callback);
};

/**
 * Force a redraw. Can be overridden by implementations of Core
 *
 * Note: this function will be overridden on construction with a trottled version
 */
Core.prototype.redraw = function () {
  this._redraw();
};

/**
 * Redraw for internal use. Redraws all components. See also the public
 * method redraw.
 * @protected
 */
Core.prototype._redraw = function () {
  this.redrawCount++;
  var resized = false;
  var options = this.options;
  var props = this.props;
  var dom = this.dom;

  if (!dom || !dom.container || dom.root.offsetWidth == 0) return; // when destroyed, or invisible

  DateUtil.updateHiddenDates(this.options.moment, this.body, this.options.hiddenDates);

  // update class names
  if (options.orientation == 'top') {
    util.addClassName(dom.root, 'vis-top');
    util.removeClassName(dom.root, 'vis-bottom');
  } else {
    util.removeClassName(dom.root, 'vis-top');
    util.addClassName(dom.root, 'vis-bottom');
  }

  // update root width and height options
  dom.root.style.maxHeight = util.option.asSize(options.maxHeight, '');
  dom.root.style.minHeight = util.option.asSize(options.minHeight, '');
  dom.root.style.width = util.option.asSize(options.width, '');

  // calculate border widths
  props.border.left = (dom.centerContainer.offsetWidth - dom.centerContainer.clientWidth) / 2;
  props.border.right = props.border.left;
  props.border.top = (dom.centerContainer.offsetHeight - dom.centerContainer.clientHeight) / 2;
  props.border.bottom = props.border.top;
  props.borderRootHeight = dom.root.offsetHeight - dom.root.clientHeight;
  props.borderRootWidth = dom.root.offsetWidth - dom.root.clientWidth;

  // workaround for a bug in IE: the clientWidth of an element with
  // a height:0px and overflow:hidden is not calculated and always has value 0
  if (dom.centerContainer.clientHeight === 0) {
    props.border.left = props.border.top;
    props.border.right = props.border.left;
  }
  if (dom.root.clientHeight === 0) {
    props.borderRootWidth = props.borderRootHeight;
  }

  // calculate the heights. If any of the side panels is empty, we set the height to
  // minus the border width, such that the border will be invisible
  props.center.height = dom.center.offsetHeight;
  props.left.height = dom.left.offsetHeight;
  props.right.height = dom.right.offsetHeight;
  props.top.height = dom.top.clientHeight || -props.border.top;
  props.bottom.height = dom.bottom.clientHeight || -props.border.bottom;

  // TODO: compensate borders when any of the panels is empty.

  // apply auto height
  // TODO: only calculate autoHeight when needed (else we cause an extra reflow/repaint of the DOM)
  var contentHeight = Math.max(props.left.height, props.center.height, props.right.height);
  var autoHeight = props.top.height + contentHeight + props.bottom.height + props.borderRootHeight + props.border.top + props.border.bottom;
  dom.root.style.height = util.option.asSize(options.height, autoHeight + 'px');

  // calculate heights of the content panels
  props.root.height = dom.root.offsetHeight;
  props.background.height = props.root.height - props.borderRootHeight;
  var containerHeight = props.root.height - props.top.height - props.bottom.height - props.borderRootHeight;
  props.centerContainer.height = containerHeight;
  props.leftContainer.height = containerHeight;
  props.rightContainer.height = props.leftContainer.height;

  // calculate the widths of the panels
  props.root.width = dom.root.offsetWidth;
  props.background.width = props.root.width - props.borderRootWidth;

  if (!this.initialDrawDone) {
    props.scrollbarWidth = util.getScrollBarWidth();
  }

  if (options.verticalScroll) {
    if (options.rtl) {
      props.left.width = dom.leftContainer.clientWidth || -props.border.left;
      props.right.width = dom.rightContainer.clientWidth + props.scrollbarWidth || -props.border.right;
    } else {
      props.left.width = dom.leftContainer.clientWidth + props.scrollbarWidth || -props.border.left;
      props.right.width = dom.rightContainer.clientWidth || -props.border.right;
    }
  } else {
    props.left.width = dom.leftContainer.clientWidth || -props.border.left;
    props.right.width = dom.rightContainer.clientWidth || -props.border.right;
  }

  this._setDOM();

  // update the scrollTop, feasible range for the offset can be changed
  // when the height of the Core or of the contents of the center changed
  var offset = this._updateScrollTop();

  // reposition the scrollable contents
  if (options.orientation.item != 'top') {
    offset += Math.max(props.centerContainer.height - props.center.height - props.border.top - props.border.bottom, 0);
  }
  dom.center.style.top = offset + 'px';

  // show shadows when vertical scrolling is available
  var visibilityTop = props.scrollTop == 0 ? 'hidden' : '';
  var visibilityBottom = props.scrollTop == props.scrollTopMin ? 'hidden' : '';
  dom.shadowTop.style.visibility = visibilityTop;
  dom.shadowBottom.style.visibility = visibilityBottom;
  dom.shadowTopLeft.style.visibility = visibilityTop;
  dom.shadowBottomLeft.style.visibility = visibilityBottom;
  dom.shadowTopRight.style.visibility = visibilityTop;
  dom.shadowBottomRight.style.visibility = visibilityBottom;

  if (options.verticalScroll) {
    dom.rightContainer.className = 'vis-panel vis-right vis-vertical-scroll';
    dom.leftContainer.className = 'vis-panel vis-left vis-vertical-scroll';

    dom.shadowTopRight.style.visibility = "hidden";
    dom.shadowBottomRight.style.visibility = "hidden";
    dom.shadowTopLeft.style.visibility = "hidden";
    dom.shadowBottomLeft.style.visibility = "hidden";

    dom.left.style.top = '0px';
    dom.right.style.top = '0px';
  }

  if (!options.verticalScroll || props.center.height < props.centerContainer.height) {
    dom.left.style.top = offset + 'px';
    dom.right.style.top = offset + 'px';
    dom.rightContainer.className = dom.rightContainer.className.replace(new RegExp('(?:^|\\s)' + 'vis-vertical-scroll' + '(?:\\s|$)'), ' ');
    dom.leftContainer.className = dom.leftContainer.className.replace(new RegExp('(?:^|\\s)' + 'vis-vertical-scroll' + '(?:\\s|$)'), ' ');
    props.left.width = dom.leftContainer.clientWidth || -props.border.left;
    props.right.width = dom.rightContainer.clientWidth || -props.border.right;
    this._setDOM();
  }

  // enable/disable vertical panning
  var contentsOverflow = props.center.height > props.centerContainer.height;
  this.hammer.get('pan').set({
    direction: contentsOverflow ? Hammer.DIRECTION_ALL : Hammer.DIRECTION_HORIZONTAL
  });

  // redraw all components
  this.components.forEach(function (component) {
    resized = component.redraw() || resized;
  });
  var MAX_REDRAW = 5;
  if (resized) {
    if (this.redrawCount < MAX_REDRAW) {
      this.body.emitter.emit('_change');
      return;
    } else {
      console.log('WARNING: infinite loop in redraw?');
    }
  } else {
    this.redrawCount = 0;
  }

  //Emit public 'changed' event for UI updates, see issue #1592
  this.body.emitter.emit("changed");
};

Core.prototype._setDOM = function () {
  var props = this.props;
  var dom = this.dom;

  props.leftContainer.width = props.left.width;
  props.rightContainer.width = props.right.width;
  var centerWidth = props.root.width - props.left.width - props.right.width - props.borderRootWidth;
  props.center.width = centerWidth;
  props.centerContainer.width = centerWidth;
  props.top.width = centerWidth;
  props.bottom.width = centerWidth;

  // resize the panels
  dom.background.style.height = props.background.height + 'px';
  dom.backgroundVertical.style.height = props.background.height + 'px';
  dom.backgroundHorizontal.style.height = props.centerContainer.height + 'px';
  dom.centerContainer.style.height = props.centerContainer.height + 'px';
  dom.leftContainer.style.height = props.leftContainer.height + 'px';
  dom.rightContainer.style.height = props.rightContainer.height + 'px';

  dom.background.style.width = props.background.width + 'px';
  dom.backgroundVertical.style.width = props.centerContainer.width + 'px';
  dom.backgroundHorizontal.style.width = props.background.width + 'px';
  dom.centerContainer.style.width = props.center.width + 'px';
  dom.top.style.width = props.top.width + 'px';
  dom.bottom.style.width = props.bottom.width + 'px';

  // reposition the panels
  dom.background.style.left = '0';
  dom.background.style.top = '0';
  dom.backgroundVertical.style.left = props.left.width + props.border.left + 'px';
  dom.backgroundVertical.style.top = '0';
  dom.backgroundHorizontal.style.left = '0';
  dom.backgroundHorizontal.style.top = props.top.height + 'px';
  dom.centerContainer.style.left = props.left.width + 'px';
  dom.centerContainer.style.top = props.top.height + 'px';
  dom.leftContainer.style.left = '0';
  dom.leftContainer.style.top = props.top.height + 'px';
  dom.rightContainer.style.left = props.left.width + props.center.width + 'px';
  dom.rightContainer.style.top = props.top.height + 'px';
  dom.top.style.left = props.left.width + 'px';
  dom.top.style.top = '0';
  dom.bottom.style.left = props.left.width + 'px';
  dom.bottom.style.top = props.top.height + props.centerContainer.height + 'px';
  dom.center.style.left = '0';
  dom.left.style.left = '0';
  dom.right.style.left = '0';
};

// TODO: deprecated since version 1.1.0, remove some day
Core.prototype.repaint = function () {
  throw new Error('Function repaint is deprecated. Use redraw instead.');
};

/**
 * Set a current time. This can be used for example to ensure that a client's
 * time is synchronized with a shared server time.
 * Only applicable when option `showCurrentTime` is true.
 * @param {Date | string | number} time     A Date, unix timestamp, or
 *                                          ISO date string.
 */
Core.prototype.setCurrentTime = function (time) {
  if (!this.currentTime) {
    throw new Error('Option showCurrentTime must be true');
  }

  this.currentTime.setCurrentTime(time);
};

/**
 * Get the current time.
 * Only applicable when option `showCurrentTime` is true.
 * @return {Date} Returns the current time.
 */
Core.prototype.getCurrentTime = function () {
  if (!this.currentTime) {
    throw new Error('Option showCurrentTime must be true');
  }

  return this.currentTime.getCurrentTime();
};

/**
 * Convert a position on screen (pixels) to a datetime
 * @param {int}     x    Position on the screen in pixels
 * @return {Date}   time The datetime the corresponds with given position x
 * @protected
 */
// TODO: move this function to Range
Core.prototype._toTime = function (x) {
  return DateUtil.toTime(this, x, this.props.center.width);
};

/**
 * Convert a position on the global screen (pixels) to a datetime
 * @param {int}     x    Position on the screen in pixels
 * @return {Date}   time The datetime the corresponds with given position x
 * @protected
 */
// TODO: move this function to Range
Core.prototype._toGlobalTime = function (x) {
  return DateUtil.toTime(this, x, this.props.root.width);
  //var conversion = this.range.conversion(this.props.root.width);
  //return new Date(x / conversion.scale + conversion.offset);
};

/**
 * Convert a datetime (Date object) into a position on the screen
 * @param {Date}   time A date
 * @return {int}   x    The position on the screen in pixels which corresponds
 *                      with the given date.
 * @protected
 */
// TODO: move this function to Range
Core.prototype._toScreen = function (time) {
  return DateUtil.toScreen(this, time, this.props.center.width);
};

/**
 * Convert a datetime (Date object) into a position on the root
 * This is used to get the pixel density estimate for the screen, not the center panel
 * @param {Date}   time A date
 * @return {int}   x    The position on root in pixels which corresponds
 *                      with the given date.
 * @protected
 */
// TODO: move this function to Range
Core.prototype._toGlobalScreen = function (time) {
  return DateUtil.toScreen(this, time, this.props.root.width);
  //var conversion = this.range.conversion(this.props.root.width);
  //return (time.valueOf() - conversion.offset) * conversion.scale;
};

/**
 * Initialize watching when option autoResize is true
 * @private
 */
Core.prototype._initAutoResize = function () {
  if (this.options.autoResize == true) {
    this._startAutoResize();
  } else {
    this._stopAutoResize();
  }
};

/**
 * Watch for changes in the size of the container. On resize, the Panel will
 * automatically redraw itself.
 * @private
 */
Core.prototype._startAutoResize = function () {
  var me = this;

  this._stopAutoResize();

  this._onResize = function () {
    if (me.options.autoResize != true) {
      // stop watching when the option autoResize is changed to false
      me._stopAutoResize();
      return;
    }

    if (me.dom.root) {
      // check whether the frame is resized
      // Note: we compare offsetWidth here, not clientWidth. For some reason,
      // IE does not restore the clientWidth from 0 to the actual width after
      // changing the timeline's container display style from none to visible
      if (me.dom.root.offsetWidth != me.props.lastWidth || me.dom.root.offsetHeight != me.props.lastHeight) {
        me.props.lastWidth = me.dom.root.offsetWidth;
        me.props.lastHeight = me.dom.root.offsetHeight;
        me.props.scrollbarWidth = util.getScrollBarWidth();

        me.body.emitter.emit('_change');
      }
    }
  };

  // add event listener to window resize
  util.addEventListener(window, 'resize', this._onResize);

  //Prevent initial unnecessary redraw
  if (me.dom.root) {
    me.props.lastWidth = me.dom.root.offsetWidth;
    me.props.lastHeight = me.dom.root.offsetHeight;
  }

  this.watchTimer = setInterval(this._onResize, 1000);
};

/**
 * Stop watching for a resize of the frame.
 * @private
 */
Core.prototype._stopAutoResize = function () {
  if (this.watchTimer) {
    clearInterval(this.watchTimer);
    this.watchTimer = undefined;
  }

  // remove event listener on window.resize
  if (this._onResize) {
    util.removeEventListener(window, 'resize', this._onResize);
    this._onResize = null;
  }
};

/**
 * Start moving the timeline vertically
 * @param {Event} event
 * @private
 */
Core.prototype._onTouch = function (event) {
  // eslint-disable-line no-unused-vars
  this.touch.allowDragging = true;
  this.touch.initialScrollTop = this.props.scrollTop;
};

/**
 * Start moving the timeline vertically
 * @param {Event} event
 * @private
 */
Core.prototype._onPinch = function (event) {
  // eslint-disable-line no-unused-vars
  this.touch.allowDragging = false;
};

/**
 * Move the timeline vertically
 * @param {Event} event
 * @private
 */
Core.prototype._onDrag = function (event) {
  if (!event) return;
  // refuse to drag when we where pinching to prevent the timeline make a jump
  // when releasing the fingers in opposite order from the touch screen
  if (!this.touch.allowDragging) return;

  var delta = event.deltaY;

  var oldScrollTop = this._getScrollTop();
  var newScrollTop = this._setScrollTop(this.touch.initialScrollTop + delta);

  if (this.options.verticalScroll) {
    this.dom.left.parentNode.scrollTop = -this.props.scrollTop;
    this.dom.right.parentNode.scrollTop = -this.props.scrollTop;
  }

  if (newScrollTop != oldScrollTop) {
    this.emit("verticalDrag");
  }
};

/**
 * Apply a scrollTop
 * @param {number} scrollTop
 * @returns {number} scrollTop  Returns the applied scrollTop
 * @private
 */
Core.prototype._setScrollTop = function (scrollTop) {
  this.props.scrollTop = scrollTop;
  this._updateScrollTop();
  return this.props.scrollTop;
};

/**
 * Update the current scrollTop when the height of  the containers has been changed
 * @returns {number} scrollTop  Returns the applied scrollTop
 * @private
 */
Core.prototype._updateScrollTop = function () {
  // recalculate the scrollTopMin
  var scrollTopMin = Math.min(this.props.centerContainer.height - this.props.center.height, 0); // is negative or zero
  if (scrollTopMin != this.props.scrollTopMin) {
    // in case of bottom orientation, change the scrollTop such that the contents
    // do not move relative to the time axis at the bottom
    if (this.options.orientation.item != 'top') {
      this.props.scrollTop += scrollTopMin - this.props.scrollTopMin;
    }
    this.props.scrollTopMin = scrollTopMin;
  }

  // limit the scrollTop to the feasible scroll range
  if (this.props.scrollTop > 0) this.props.scrollTop = 0;
  if (this.props.scrollTop < scrollTopMin) this.props.scrollTop = scrollTopMin;

  if (this.options.verticalScroll) {
    this.dom.left.parentNode.scrollTop = -this.props.scrollTop;
    this.dom.right.parentNode.scrollTop = -this.props.scrollTop;
  }

  return this.props.scrollTop;
};

/**
 * Get the current scrollTop
 * @returns {number} scrollTop
 * @private
 */
Core.prototype._getScrollTop = function () {
  return this.props.scrollTop;
};

/**
 * Load a configurator
 * [at]returns {Object}
 * @private
 */
Core.prototype._createConfigurator = function () {
  throw new Error('Cannot invoke abstract method _createConfigurator');
};

module.exports = Core;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(9);
var DateUtil = __webpack_require__(36);
var util = __webpack_require__(2);

/**
 * The class TimeStep is an iterator for dates. You provide a start date and an
 * end date. The class itself determines the best scale (step size) based on the
 * provided start Date, end Date, and minimumStep.
 *
 * If minimumStep is provided, the step size is chosen as close as possible
 * to the minimumStep but larger than minimumStep. If minimumStep is not
 * provided, the scale is set to 1 DAY.
 * The minimumStep should correspond with the onscreen size of about 6 characters
 *
 * Alternatively, you can set a scale by hand.
 * After creation, you can initialize the class by executing first(). Then you
 * can iterate from the start date to the end date via next(). You can check if
 * the end date is reached with the function hasNext(). After each step, you can
 * retrieve the current date via getCurrent().
 * The TimeStep has scales ranging from milliseconds, seconds, minutes, hours,
 * days, to years.
 *
 * Version: 1.2
 *
 * @param {Date} [start]         The start date, for example new Date(2010, 9, 21)
 *                               or new Date(2010, 9, 21, 23, 45, 00)
 * @param {Date} [end]           The end date
 * @param {number} [minimumStep] Optional. Minimum step size in milliseconds
 * @param {Date|Array.<Date>} [hiddenDates] Optional.
 * @param {{showMajorLabels: boolean}} [options] Optional.
 * @constructor  TimeStep
 */
function TimeStep(start, end, minimumStep, hiddenDates, options) {
  this.moment = moment;

  // variables
  this.current = this.moment();
  this._start = this.moment();
  this._end = this.moment();

  this.autoScale = true;
  this.scale = 'day';
  this.step = 1;

  // initialize the range
  this.setRange(start, end, minimumStep);

  // hidden Dates options
  this.switchedDay = false;
  this.switchedMonth = false;
  this.switchedYear = false;
  if (Array.isArray(hiddenDates)) {
    this.hiddenDates = hiddenDates;
  } else if (hiddenDates != undefined) {
    this.hiddenDates = [hiddenDates];
  } else {
    this.hiddenDates = [];
  }

  this.format = TimeStep.FORMAT; // default formatting
  this.options = options ? options : {};
}

// Time formatting
TimeStep.FORMAT = {
  minorLabels: {
    millisecond: 'SSS',
    second: 's',
    minute: 'HH:mm',
    hour: 'HH:mm',
    weekday: 'ddd D',
    day: 'D',
    week: 'w',
    month: 'MMM',
    year: 'YYYY'
  },
  majorLabels: {
    millisecond: 'HH:mm:ss',
    second: 'D MMMM HH:mm',
    minute: 'ddd D MMMM',
    hour: 'ddd D MMMM',
    weekday: 'MMMM YYYY',
    day: 'MMMM YYYY',
    week: 'MMMM YYYY',
    month: 'YYYY',
    year: ''
  }
};

/**
 * Set custom constructor function for moment. Can be used to set dates
 * to UTC or to set a utcOffset.
 * @param {function} moment
 */
TimeStep.prototype.setMoment = function (moment) {
  this.moment = moment;

  // update the date properties, can have a new utcOffset
  this.current = this.moment(this.current.valueOf());
  this._start = this.moment(this._start.valueOf());
  this._end = this.moment(this._end.valueOf());
};

/**
 * Set custom formatting for the minor an major labels of the TimeStep.
 * Both `minorLabels` and `majorLabels` are an Object with properties:
 * 'millisecond', 'second', 'minute', 'hour', 'weekday', 'day', 'week', 'month', 'year'.
 * @param {{minorLabels: Object, majorLabels: Object}} format
 */
TimeStep.prototype.setFormat = function (format) {
  var defaultFormat = util.deepExtend({}, TimeStep.FORMAT);
  this.format = util.deepExtend(defaultFormat, format);
};

/**
 * Set a new range
 * If minimumStep is provided, the step size is chosen as close as possible
 * to the minimumStep but larger than minimumStep. If minimumStep is not
 * provided, the scale is set to 1 DAY.
 * The minimumStep should correspond with the onscreen size of about 6 characters
 * @param {Date} [start]      The start date and time.
 * @param {Date} [end]        The end date and time.
 * @param {int} [minimumStep] Optional. Minimum step size in milliseconds
 */
TimeStep.prototype.setRange = function (start, end, minimumStep) {
  if (!(start instanceof Date) || !(end instanceof Date)) {
    throw "No legal start or end date in method setRange";
  }

  this._start = start != undefined ? this.moment(start.valueOf()) : new Date();
  this._end = end != undefined ? this.moment(end.valueOf()) : new Date();

  if (this.autoScale) {
    this.setMinimumStep(minimumStep);
  }
};

/**
 * Set the range iterator to the start date.
 */
TimeStep.prototype.start = function () {
  this.current = this._start.clone();
  this.roundToMinor();
};

/**
 * Round the current date to the first minor date value
 * This must be executed once when the current date is set to start Date
 */
TimeStep.prototype.roundToMinor = function () {
  // round to floor
  // to prevent year & month scales rounding down to the first day of week we perform this separately
  if (this.scale == 'week') {
    this.current.weekday(0);
  }
  // IMPORTANT: we have no breaks in this switch! (this is no bug)
  // noinspection FallThroughInSwitchStatementJS
  switch (this.scale) {
    case 'year':
      this.current.year(this.step * Math.floor(this.current.year() / this.step));
      this.current.month(0);
    case 'month':
      this.current.date(1); // eslint-disable-line no-fallthrough
    case 'week': // eslint-disable-line no-fallthrough
    case 'day': // eslint-disable-line no-fallthrough
    case 'weekday':
      this.current.hours(0); // eslint-disable-line no-fallthrough
    case 'hour':
      this.current.minutes(0); // eslint-disable-line no-fallthrough
    case 'minute':
      this.current.seconds(0); // eslint-disable-line no-fallthrough
    case 'second':
      this.current.milliseconds(0); // eslint-disable-line no-fallthrough
    //case 'millisecond': // nothing to do for milliseconds
  }

  if (this.step != 1) {
    // round down to the first minor value that is a multiple of the current step size
    switch (this.scale) {
      case 'millisecond':
        this.current.subtract(this.current.milliseconds() % this.step, 'milliseconds');break;
      case 'second':
        this.current.subtract(this.current.seconds() % this.step, 'seconds');break;
      case 'minute':
        this.current.subtract(this.current.minutes() % this.step, 'minutes');break;
      case 'hour':
        this.current.subtract(this.current.hours() % this.step, 'hours');break;
      case 'weekday': // intentional fall through
      case 'day':
        this.current.subtract((this.current.date() - 1) % this.step, 'day');break;
      case 'week':
        this.current.subtract(this.current.week() % this.step, 'week');break;
      case 'month':
        this.current.subtract(this.current.month() % this.step, 'month');break;
      case 'year':
        this.current.subtract(this.current.year() % this.step, 'year');break;
      default:
        break;
    }
  }
};

/**
 * Check if the there is a next step
 * @return {boolean}  true if the current date has not passed the end date
 */
TimeStep.prototype.hasNext = function () {
  return this.current.valueOf() <= this._end.valueOf();
};

/**
 * Do the next step
 */
TimeStep.prototype.next = function () {
  var prev = this.current.valueOf();

  // Two cases, needed to prevent issues with switching daylight savings
  // (end of March and end of October)
  switch (this.scale) {
    case 'millisecond':
      this.current.add(this.step, 'millisecond');break;
    case 'second':
      this.current.add(this.step, 'second');break;
    case 'minute':
      this.current.add(this.step, 'minute');break;
    case 'hour':
      this.current.add(this.step, 'hour');

      if (this.current.month() < 6) {
        this.current.subtract(this.current.hours() % this.step, 'hour');
      } else {
        if (this.current.hours() % this.step !== 0) {
          this.current.add(this.step - this.current.hours() % this.step, 'hour');
        }
      }
      break;
    case 'weekday': // intentional fall through
    case 'day':
      this.current.add(this.step, 'day');break;
    case 'week':
      if (this.current.weekday() !== 0) {
        // we had a month break not correlating with a week's start before
        this.current.weekday(0); // switch back to week cycles
        this.current.add(this.step, 'week');
      } else if (this.options.showMajorLabels === false) {
        this.current.add(this.step, 'week'); // the default case
      } else {
        // first day of the week
        var nextWeek = this.current.clone();
        nextWeek.add(1, 'week');
        if (nextWeek.isSame(this.current, 'month')) {
          // is the first day of the next week in the same month?
          this.current.add(this.step, 'week'); // the default case
        } else {
          // inject a step at each first day of the month
          this.current.add(this.step, 'week');
          this.current.date(1);
        }
      }
      break;
    case 'month':
      this.current.add(this.step, 'month');break;
    case 'year':
      this.current.add(this.step, 'year');break;
    default:
      break;
  }

  if (this.step != 1) {
    // round down to the correct major value
    switch (this.scale) {
      case 'millisecond':
        if (this.current.milliseconds() > 0 && this.current.milliseconds() < this.step) this.current.milliseconds(0);break;
      case 'second':
        if (this.current.seconds() > 0 && this.current.seconds() < this.step) this.current.seconds(0);break;
      case 'minute':
        if (this.current.minutes() > 0 && this.current.minutes() < this.step) this.current.minutes(0);break;
      case 'hour':
        if (this.current.hours() > 0 && this.current.hours() < this.step) this.current.hours(0);break;
      case 'weekday': // intentional fall through
      case 'day':
        if (this.current.date() < this.step + 1) this.current.date(1);break;
      case 'week':
        if (this.current.week() < this.step) this.current.week(1);break; // week numbering starts at 1, not 0
      case 'month':
        if (this.current.month() < this.step) this.current.month(0);break;
      case 'year':
        break; // nothing to do for year
      default:
        break;
    }
  }

  // safety mechanism: if current time is still unchanged, move to the end
  if (this.current.valueOf() == prev) {
    this.current = this._end.clone();
  }

  // Reset switches for year, month and day. Will get set to true where appropriate in DateUtil.stepOverHiddenDates
  this.switchedDay = false;
  this.switchedMonth = false;
  this.switchedYear = false;

  DateUtil.stepOverHiddenDates(this.moment, this, prev);
};

/**
 * Get the current datetime
 * @return {Moment}  current The current date
 */
TimeStep.prototype.getCurrent = function () {
  return this.current;
};

/**
 * Set a custom scale. Autoscaling will be disabled.
 * For example setScale('minute', 5) will result
 * in minor steps of 5 minutes, and major steps of an hour.
 *
 * @param {{scale: string, step: number}} params
 *                               An object containing two properties:
 *                               - A string 'scale'. Choose from 'millisecond', 'second',
 *                                 'minute', 'hour', 'weekday', 'day', 'week', 'month', 'year'.
 *                               - A number 'step'. A step size, by default 1.
 *                                 Choose for example 1, 2, 5, or 10.
 */
TimeStep.prototype.setScale = function (params) {
  if (params && typeof params.scale == 'string') {
    this.scale = params.scale;
    this.step = params.step > 0 ? params.step : 1;
    this.autoScale = false;
  }
};

/**
 * Enable or disable autoscaling
 * @param {boolean} enable  If true, autoascaling is set true
 */
TimeStep.prototype.setAutoScale = function (enable) {
  this.autoScale = enable;
};

/**
 * Automatically determine the scale that bests fits the provided minimum step
 * @param {number} [minimumStep]  The minimum step size in milliseconds
 */
TimeStep.prototype.setMinimumStep = function (minimumStep) {
  if (minimumStep == undefined) {
    return;
  }

  //var b = asc + ds;

  var stepYear = 1000 * 60 * 60 * 24 * 30 * 12;
  var stepMonth = 1000 * 60 * 60 * 24 * 30;
  var stepDay = 1000 * 60 * 60 * 24;
  var stepHour = 1000 * 60 * 60;
  var stepMinute = 1000 * 60;
  var stepSecond = 1000;
  var stepMillisecond = 1;

  // find the smallest step that is larger than the provided minimumStep
  if (stepYear * 1000 > minimumStep) {
    this.scale = 'year';this.step = 1000;
  }
  if (stepYear * 500 > minimumStep) {
    this.scale = 'year';this.step = 500;
  }
  if (stepYear * 100 > minimumStep) {
    this.scale = 'year';this.step = 100;
  }
  if (stepYear * 50 > minimumStep) {
    this.scale = 'year';this.step = 50;
  }
  if (stepYear * 10 > minimumStep) {
    this.scale = 'year';this.step = 10;
  }
  if (stepYear * 5 > minimumStep) {
    this.scale = 'year';this.step = 5;
  }
  if (stepYear > minimumStep) {
    this.scale = 'year';this.step = 1;
  }
  if (stepMonth * 3 > minimumStep) {
    this.scale = 'month';this.step = 3;
  }
  if (stepMonth > minimumStep) {
    this.scale = 'month';this.step = 1;
  }
  if (stepDay * 5 > minimumStep) {
    this.scale = 'day';this.step = 5;
  }
  if (stepDay * 2 > minimumStep) {
    this.scale = 'day';this.step = 2;
  }
  if (stepDay > minimumStep) {
    this.scale = 'day';this.step = 1;
  }
  if (stepDay / 2 > minimumStep) {
    this.scale = 'weekday';this.step = 1;
  }
  if (stepHour * 4 > minimumStep) {
    this.scale = 'hour';this.step = 4;
  }
  if (stepHour > minimumStep) {
    this.scale = 'hour';this.step = 1;
  }
  if (stepMinute * 15 > minimumStep) {
    this.scale = 'minute';this.step = 15;
  }
  if (stepMinute * 10 > minimumStep) {
    this.scale = 'minute';this.step = 10;
  }
  if (stepMinute * 5 > minimumStep) {
    this.scale = 'minute';this.step = 5;
  }
  if (stepMinute > minimumStep) {
    this.scale = 'minute';this.step = 1;
  }
  if (stepSecond * 15 > minimumStep) {
    this.scale = 'second';this.step = 15;
  }
  if (stepSecond * 10 > minimumStep) {
    this.scale = 'second';this.step = 10;
  }
  if (stepSecond * 5 > minimumStep) {
    this.scale = 'second';this.step = 5;
  }
  if (stepSecond > minimumStep) {
    this.scale = 'second';this.step = 1;
  }
  if (stepMillisecond * 200 > minimumStep) {
    this.scale = 'millisecond';this.step = 200;
  }
  if (stepMillisecond * 100 > minimumStep) {
    this.scale = 'millisecond';this.step = 100;
  }
  if (stepMillisecond * 50 > minimumStep) {
    this.scale = 'millisecond';this.step = 50;
  }
  if (stepMillisecond * 10 > minimumStep) {
    this.scale = 'millisecond';this.step = 10;
  }
  if (stepMillisecond * 5 > minimumStep) {
    this.scale = 'millisecond';this.step = 5;
  }
  if (stepMillisecond > minimumStep) {
    this.scale = 'millisecond';this.step = 1;
  }
};

/**
 * Snap a date to a rounded value.
 * The snap intervals are dependent on the current scale and step.
 * Static function
 * @param {Date} date    the date to be snapped.
 * @param {string} scale Current scale, can be 'millisecond', 'second',
 *                       'minute', 'hour', 'weekday, 'day', 'week', 'month', 'year'.
 * @param {number} step  Current step (1, 2, 4, 5, ...
 * @return {Date} snappedDate
 */
TimeStep.snap = function (date, scale, step) {
  var clone = moment(date);

  if (scale == 'year') {
    var year = clone.year() + Math.round(clone.month() / 12);
    clone.year(Math.round(year / step) * step);
    clone.month(0);
    clone.date(0);
    clone.hours(0);
    clone.minutes(0);
    clone.seconds(0);
    clone.milliseconds(0);
  } else if (scale == 'month') {
    if (clone.date() > 15) {
      clone.date(1);
      clone.add(1, 'month');
      // important: first set Date to 1, after that change the month.
    } else {
      clone.date(1);
    }

    clone.hours(0);
    clone.minutes(0);
    clone.seconds(0);
    clone.milliseconds(0);
  } else if (scale == 'week') {
    if (clone.weekday() > 2) {
      // doing it the momentjs locale aware way
      clone.weekday(0);
      clone.add(1, 'week');
    } else {
      clone.weekday(0);
    }

    clone.hours(0);
    clone.minutes(0);
    clone.seconds(0);
    clone.milliseconds(0);
  } else if (scale == 'day') {
    //noinspection FallthroughInSwitchStatementJS
    switch (step) {
      case 5:
      case 2:
        clone.hours(Math.round(clone.hours() / 24) * 24);break;
      default:
        clone.hours(Math.round(clone.hours() / 12) * 12);break;
    }
    clone.minutes(0);
    clone.seconds(0);
    clone.milliseconds(0);
  } else if (scale == 'weekday') {
    //noinspection FallthroughInSwitchStatementJS
    switch (step) {
      case 5:
      case 2:
        clone.hours(Math.round(clone.hours() / 12) * 12);break;
      default:
        clone.hours(Math.round(clone.hours() / 6) * 6);break;
    }
    clone.minutes(0);
    clone.seconds(0);
    clone.milliseconds(0);
  } else if (scale == 'hour') {
    switch (step) {
      case 4:
        clone.minutes(Math.round(clone.minutes() / 60) * 60);break;
      default:
        clone.minutes(Math.round(clone.minutes() / 30) * 30);break;
    }
    clone.seconds(0);
    clone.milliseconds(0);
  } else if (scale == 'minute') {
    //noinspection FallthroughInSwitchStatementJS
    switch (step) {
      case 15:
      case 10:
        clone.minutes(Math.round(clone.minutes() / 5) * 5);
        clone.seconds(0);
        break;
      case 5:
        clone.seconds(Math.round(clone.seconds() / 60) * 60);break;
      default:
        clone.seconds(Math.round(clone.seconds() / 30) * 30);break;
    }
    clone.milliseconds(0);
  } else if (scale == 'second') {
    //noinspection FallthroughInSwitchStatementJS
    switch (step) {
      case 15:
      case 10:
        clone.seconds(Math.round(clone.seconds() / 5) * 5);
        clone.milliseconds(0);
        break;
      case 5:
        clone.milliseconds(Math.round(clone.milliseconds() / 1000) * 1000);break;
      default:
        clone.milliseconds(Math.round(clone.milliseconds() / 500) * 500);break;
    }
  } else if (scale == 'millisecond') {
    var _step = step > 5 ? step / 2 : 1;
    clone.milliseconds(Math.round(clone.milliseconds() / _step) * _step);
  }

  return clone;
};

/**
 * Check if the current value is a major value (for example when the step
 * is DAY, a major value is each first day of the MONTH)
 * @return {boolean} true if current date is major, else false.
 */
TimeStep.prototype.isMajor = function () {
  if (this.switchedYear == true) {
    switch (this.scale) {
      case 'year':
      case 'month':
      case 'week':
      case 'weekday':
      case 'day':
      case 'hour':
      case 'minute':
      case 'second':
      case 'millisecond':
        return true;
      default:
        return false;
    }
  } else if (this.switchedMonth == true) {
    switch (this.scale) {
      case 'week':
      case 'weekday':
      case 'day':
      case 'hour':
      case 'minute':
      case 'second':
      case 'millisecond':
        return true;
      default:
        return false;
    }
  } else if (this.switchedDay == true) {
    switch (this.scale) {
      case 'millisecond':
      case 'second':
      case 'minute':
      case 'hour':
        return true;
      default:
        return false;
    }
  }

  var date = this.moment(this.current);
  switch (this.scale) {
    case 'millisecond':
      return date.milliseconds() == 0;
    case 'second':
      return date.seconds() == 0;
    case 'minute':
      return date.hours() == 0 && date.minutes() == 0;
    case 'hour':
      return date.hours() == 0;
    case 'weekday': // intentional fall through
    case 'day':
      return date.date() == 1;
    case 'week':
      return date.date() == 1;
    case 'month':
      return date.month() == 0;
    case 'year':
      return false;
    default:
      return false;
  }
};

/**
 * Returns formatted text for the minor axislabel, depending on the current
 * date and the scale. For example when scale is MINUTE, the current time is
 * formatted as "hh:mm".
 * @param {Date} [date=this.current] custom date. if not provided, current date is taken
 * @returns {String}
 */
TimeStep.prototype.getLabelMinor = function (date) {
  if (date == undefined) {
    date = this.current;
  }
  if (date instanceof Date) {
    date = this.moment(date);
  }

  if (typeof this.format.minorLabels === "function") {
    return this.format.minorLabels(date, this.scale, this.step);
  }

  var format = this.format.minorLabels[this.scale];
  // noinspection FallThroughInSwitchStatementJS
  switch (this.scale) {
    case 'week':
      if (this.isMajor() && date.weekday() !== 0) {
        return "";
      }
    default:
      // eslint-disable-line no-fallthrough
      return format && format.length > 0 ? this.moment(date).format(format) : '';
  }
};

/**
 * Returns formatted text for the major axis label, depending on the current
 * date and the scale. For example when scale is MINUTE, the major scale is
 * hours, and the hour will be formatted as "hh".
 * @param {Date} [date=this.current] custom date. if not provided, current date is taken
 * @returns {String}
 */
TimeStep.prototype.getLabelMajor = function (date) {
  if (date == undefined) {
    date = this.current;
  }
  if (date instanceof Date) {
    date = this.moment(date);
  }

  if (typeof this.format.majorLabels === "function") {
    return this.format.majorLabels(date, this.scale, this.step);
  }

  var format = this.format.majorLabels[this.scale];
  return format && format.length > 0 ? this.moment(date).format(format) : '';
};

TimeStep.prototype.getClassName = function () {
  var _moment = this.moment;
  var m = this.moment(this.current);
  var current = m.locale ? m.locale('en') : m.lang('en'); // old versions of moment have .lang() function
  var step = this.step;
  var classNames = [];

  /**
   *
   * @param {number} value
   * @returns {String}
   */
  function even(value) {
    return value / step % 2 == 0 ? ' vis-even' : ' vis-odd';
  }

  /**
   *
   * @param {Date} date
   * @returns {String}
   */
  function today(date) {
    if (date.isSame(new Date(), 'day')) {
      return ' vis-today';
    }
    if (date.isSame(_moment().add(1, 'day'), 'day')) {
      return ' vis-tomorrow';
    }
    if (date.isSame(_moment().add(-1, 'day'), 'day')) {
      return ' vis-yesterday';
    }
    return '';
  }

  /**
   *
   * @param {Date} date
   * @returns {String}
   */
  function currentWeek(date) {
    return date.isSame(new Date(), 'week') ? ' vis-current-week' : '';
  }

  /**
   *
   * @param {Date} date
   * @returns {String}
   */
  function currentMonth(date) {
    return date.isSame(new Date(), 'month') ? ' vis-current-month' : '';
  }

  /**
   *
   * @param {Date} date
   * @returns {String}
   */
  function currentYear(date) {
    return date.isSame(new Date(), 'year') ? ' vis-current-year' : '';
  }

  switch (this.scale) {
    case 'millisecond':
      classNames.push(today(current));
      classNames.push(even(current.milliseconds()));
      break;
    case 'second':
      classNames.push(today(current));
      classNames.push(even(current.seconds()));
      break;
    case 'minute':
      classNames.push(today(current));
      classNames.push(even(current.minutes()));
      break;
    case 'hour':
      classNames.push('vis-h' + current.hours() + (this.step == 4 ? '-h' + (current.hours() + 4) : ''));
      classNames.push(today(current));
      classNames.push(even(current.hours()));
      break;
    case 'weekday':
      classNames.push('vis-' + current.format('dddd').toLowerCase());
      classNames.push(today(current));
      classNames.push(currentWeek(current));
      classNames.push(even(current.date()));
      break;
    case 'day':
      classNames.push('vis-day' + current.date());
      classNames.push('vis-' + current.format('MMMM').toLowerCase());
      classNames.push(today(current));
      classNames.push(currentMonth(current));
      classNames.push(this.step <= 2 ? today(current) : '');
      classNames.push(this.step <= 2 ? 'vis-' + current.format('dddd').toLowerCase() : '');
      classNames.push(even(current.date() - 1));
      break;
    case 'week':
      classNames.push('vis-week' + current.format('w'));
      classNames.push(currentWeek(current));
      classNames.push(even(current.week()));
      break;
    case 'month':
      classNames.push('vis-' + current.format('MMMM').toLowerCase());
      classNames.push(currentMonth(current));
      classNames.push(even(current.month()));
      break;
    case 'year':
      classNames.push('vis-year' + current.year());
      classNames.push(currentYear(current));
      classNames.push(even(current.year()));
      break;
  }
  return classNames.filter(String).join(" ");
};

module.exports = TimeStep;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(2);
var Component = __webpack_require__(16);
var moment = __webpack_require__(9);
var locales = __webpack_require__(98);

/**
 * A current time bar
 * @param {{range: Range, dom: Object, domProps: Object}} body
 * @param {Object} [options]        Available parameters:
 *                                  {Boolean} [showCurrentTime]
 * @constructor CurrentTime
 * @extends Component
 */
function CurrentTime(body, options) {
  this.body = body;

  // default options
  this.defaultOptions = {
    rtl: false,
    showCurrentTime: true,

    moment: moment,
    locales: locales,
    locale: 'en'
  };
  this.options = util.extend({}, this.defaultOptions);
  this.offset = 0;

  this._create();

  this.setOptions(options);
}

CurrentTime.prototype = new Component();

/**
 * Create the HTML DOM for the current time bar
 * @private
 */
CurrentTime.prototype._create = function () {
  var bar = document.createElement('div');
  bar.className = 'vis-current-time';
  bar.style.position = 'absolute';
  bar.style.top = '0px';
  bar.style.height = '100%';

  this.bar = bar;
};

/**
 * Destroy the CurrentTime bar
 */
CurrentTime.prototype.destroy = function () {
  this.options.showCurrentTime = false;
  this.redraw(); // will remove the bar from the DOM and stop refreshing

  this.body = null;
};

/**
 * Set options for the component. Options will be merged in current options.
 * @param {Object} options  Available parameters:
 *                          {boolean} [showCurrentTime]
 */
CurrentTime.prototype.setOptions = function (options) {
  if (options) {
    // copy all options that we know
    util.selectiveExtend(['rtl', 'showCurrentTime', 'moment', 'locale', 'locales'], this.options, options);
  }
};

/**
 * Repaint the component
 * @return {boolean} Returns true if the component is resized
 */
CurrentTime.prototype.redraw = function () {
  if (this.options.showCurrentTime) {
    var parent = this.body.dom.backgroundVertical;
    if (this.bar.parentNode != parent) {
      // attach to the dom
      if (this.bar.parentNode) {
        this.bar.parentNode.removeChild(this.bar);
      }
      parent.appendChild(this.bar);

      this.start();
    }

    var now = this.options.moment(new Date().valueOf() + this.offset);
    var x = this.body.util.toScreen(now);

    var locale = this.options.locales[this.options.locale];
    if (!locale) {
      if (!this.warned) {
        console.log('WARNING: options.locales[\'' + this.options.locale + '\'] not found. See http://visjs.org/docs/timeline/#Localization');
        this.warned = true;
      }
      locale = this.options.locales['en']; // fall back on english when not available
    }
    var title = locale.current + ' ' + locale.time + ': ' + now.format('dddd, MMMM Do YYYY, H:mm:ss');
    title = title.charAt(0).toUpperCase() + title.substring(1);

    if (this.options.rtl) {
      this.bar.style.right = x + 'px';
    } else {
      this.bar.style.left = x + 'px';
    }
    this.bar.title = title;
  } else {
    // remove the line from the DOM
    if (this.bar.parentNode) {
      this.bar.parentNode.removeChild(this.bar);
    }
    this.stop();
  }

  return false;
};

/**
 * Start auto refreshing the current time bar
 */
CurrentTime.prototype.start = function () {
  var me = this;

  /**
   *  Updates the current time.
   */
  function update() {
    me.stop();

    // determine interval to refresh
    var scale = me.body.range.conversion(me.body.domProps.center.width).scale;
    var interval = 1 / scale / 10;
    if (interval < 30) interval = 30;
    if (interval > 1000) interval = 1000;

    me.redraw();
    me.body.emitter.emit('currentTimeTick');

    // start a renderTimer to adjust for the new time
    me.currentTimeTimer = setTimeout(update, interval);
  }

  update();
};

/**
 * Stop auto refreshing the current time bar
 */
CurrentTime.prototype.stop = function () {
  if (this.currentTimeTimer !== undefined) {
    clearTimeout(this.currentTimeTimer);
    delete this.currentTimeTimer;
  }
};

/**
 * Set a current time. This can be used for example to ensure that a client's
 * time is synchronized with a shared server time.
 * @param {Date | string | number} time     A Date, unix timestamp, or
 *                                          ISO date string.
 */
CurrentTime.prototype.setCurrentTime = function (time) {
  var t = util.convert(time, 'Date').valueOf();
  var now = new Date().valueOf();
  this.offset = t - now;
  this.redraw();
};

/**
 * Get the current time.
 * @return {Date} Returns the current time.
 */
CurrentTime.prototype.getCurrentTime = function () {
  return new Date(new Date().valueOf() + this.offset);
};

module.exports = CurrentTime;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var stack = __webpack_require__(100);

/**
 * @param {number | string} groupId
 * @param {Object} data
 * @param {ItemSet} itemSet
 * @constructor Group
 */
function Group(groupId, data, itemSet) {
  this.groupId = groupId;
  this.subgroups = {};
  this.subgroupStack = {};
  this.subgroupStackAll = false;
  this.doInnerStack = false;
  this.subgroupIndex = 0;
  this.subgroupOrderer = data && data.subgroupOrder;
  this.itemSet = itemSet;
  this.isVisible = null;
  this.stackDirty = true; // if true, items will be restacked on next redraw

  if (data && data.nestedGroups) {
    this.nestedGroups = data.nestedGroups;
    if (data.showNested == false) {
      this.showNested = false;
    } else {
      this.showNested = true;
    }
  }

  if (data && data.subgroupStack) {
    if (typeof data.subgroupStack === "boolean") {
      this.doInnerStack = data.subgroupStack;
      this.subgroupStackAll = data.subgroupStack;
    } else {
      // We might be doing stacking on specific sub groups, but only
      // if at least one is set to do stacking
      for (var key in data.subgroupStack) {
        this.subgroupStack[key] = data.subgroupStack[key];
        this.doInnerStack = this.doInnerStack || data.subgroupStack[key];
      }
    }
  }

  this.nestedInGroup = null;

  this.dom = {};
  this.props = {
    label: {
      width: 0,
      height: 0
    }
  };
  this.className = null;

  this.items = {}; // items filtered by groupId of this group
  this.visibleItems = []; // items currently visible in window
  this.itemsInRange = []; // items currently in range
  this.orderedItems = {
    byStart: [],
    byEnd: []
  };
  this.checkRangedItems = false; // needed to refresh the ranged items if the window is programatically changed with NO overlap.
  var me = this;
  this.itemSet.body.emitter.on("checkRangedItems", function () {
    me.checkRangedItems = true;
  });

  this._create();

  this.setData(data);
}

/**
 * Create DOM elements for the group
 * @private
 */
Group.prototype._create = function () {
  var label = document.createElement('div');
  if (this.itemSet.options.groupEditable.order) {
    label.className = 'vis-label draggable';
  } else {
    label.className = 'vis-label';
  }
  this.dom.label = label;

  var inner = document.createElement('div');
  inner.className = 'vis-inner';
  label.appendChild(inner);
  this.dom.inner = inner;

  var foreground = document.createElement('div');
  foreground.className = 'vis-group';
  foreground['timeline-group'] = this;
  this.dom.foreground = foreground;

  this.dom.background = document.createElement('div');
  this.dom.background.className = 'vis-group';

  this.dom.axis = document.createElement('div');
  this.dom.axis.className = 'vis-group';

  // create a hidden marker to detect when the Timelines container is attached
  // to the DOM, or the style of a parent of the Timeline is changed from
  // display:none is changed to visible.
  this.dom.marker = document.createElement('div');
  this.dom.marker.style.visibility = 'hidden';
  this.dom.marker.style.position = 'absolute';
  this.dom.marker.innerHTML = '';
  this.dom.background.appendChild(this.dom.marker);
};

/**
 * Set the group data for this group
 * @param {Object} data   Group data, can contain properties content and className
 */
Group.prototype.setData = function (data) {
  // update contents
  var content;
  var templateFunction;

  if (this.itemSet.options && this.itemSet.options.groupTemplate) {
    templateFunction = this.itemSet.options.groupTemplate.bind(this);
    content = templateFunction(data, this.dom.inner);
  } else {
    content = data && data.content;
  }

  if (content instanceof Element) {
    this.dom.inner.appendChild(content);
    while (this.dom.inner.firstChild) {
      this.dom.inner.removeChild(this.dom.inner.firstChild);
    }
    this.dom.inner.appendChild(content);
  } else if (content instanceof Object) {
    templateFunction(data, this.dom.inner);
  } else if (content !== undefined && content !== null) {
    this.dom.inner.innerHTML = content;
  } else {
    this.dom.inner.innerHTML = this.groupId || ''; // groupId can be null
  }

  // update title
  this.dom.label.title = data && data.title || '';
  if (!this.dom.inner.firstChild) {
    util.addClassName(this.dom.inner, 'vis-hidden');
  } else {
    util.removeClassName(this.dom.inner, 'vis-hidden');
  }

  if (data && data.nestedGroups) {
    if (!this.nestedGroups || this.nestedGroups != data.nestedGroups) {
      this.nestedGroups = data.nestedGroups;
    }

    if (data.showNested !== undefined || this.showNested === undefined) {
      if (data.showNested == false) {
        this.showNested = false;
      } else {
        this.showNested = true;
      }
    }

    util.addClassName(this.dom.label, 'vis-nesting-group');
    var collapsedDirClassName = this.itemSet.options.rtl ? 'collapsed-rtl' : 'collapsed';
    if (this.showNested) {
      util.removeClassName(this.dom.label, collapsedDirClassName);
      util.addClassName(this.dom.label, 'expanded');
    } else {
      util.removeClassName(this.dom.label, 'expanded');
      util.addClassName(this.dom.label, collapsedDirClassName);
    }
  } else if (this.nestedGroups) {
    this.nestedGroups = null;
    collapsedDirClassName = this.itemSet.options.rtl ? 'collapsed-rtl' : 'collapsed';
    util.removeClassName(this.dom.label, collapsedDirClassName);
    util.removeClassName(this.dom.label, 'expanded');
    util.removeClassName(this.dom.label, 'vis-nesting-group');
  }

  if (data && data.nestedInGroup) {
    util.addClassName(this.dom.label, 'vis-nested-group');
    if (this.itemSet.options && this.itemSet.options.rtl) {
      this.dom.inner.style.paddingRight = '30px';
    } else {
      this.dom.inner.style.paddingLeft = '30px';
    }
  }

  // update className
  var className = data && data.className || null;
  if (className != this.className) {
    if (this.className) {
      util.removeClassName(this.dom.label, this.className);
      util.removeClassName(this.dom.foreground, this.className);
      util.removeClassName(this.dom.background, this.className);
      util.removeClassName(this.dom.axis, this.className);
    }
    util.addClassName(this.dom.label, className);
    util.addClassName(this.dom.foreground, className);
    util.addClassName(this.dom.background, className);
    util.addClassName(this.dom.axis, className);
    this.className = className;
  }

  // update style
  if (this.style) {
    util.removeCssText(this.dom.label, this.style);
    this.style = null;
  }
  if (data && data.style) {
    util.addCssText(this.dom.label, data.style);
    this.style = data.style;
  }
};

/**
 * Get the width of the group label
 * @return {number} width
 */
Group.prototype.getLabelWidth = function () {
  return this.props.label.width;
};

Group.prototype._didMarkerHeightChange = function () {
  var markerHeight = this.dom.marker.clientHeight;
  if (markerHeight != this.lastMarkerHeight) {
    this.lastMarkerHeight = markerHeight;
    var redrawQueue = {};
    var redrawQueueLength = 0;

    util.forEach(this.items, function (item, key) {
      item.dirty = true;
      if (item.displayed) {
        var returnQueue = true;
        redrawQueue[key] = item.redraw(returnQueue);
        redrawQueueLength = redrawQueue[key].length;
      }
    });

    var needRedraw = redrawQueueLength > 0;
    if (needRedraw) {
      // redraw all regular items
      for (var i = 0; i < redrawQueueLength; i++) {
        util.forEach(redrawQueue, function (fns) {
          fns[i]();
        });
      }
    }
    return true;
  }
};

Group.prototype._calculateGroupSizeAndPosition = function () {
  var offsetTop = this.dom.foreground.offsetTop;
  var offsetLeft = this.dom.foreground.offsetLeft;
  var offsetWidth = this.dom.foreground.offsetWidth;
  this.top = offsetTop;
  this.right = offsetLeft;
  this.width = offsetWidth;
};

Group.prototype._redrawItems = function (forceRestack, lastIsVisible, margin, range) {
  var restack = forceRestack || this.stackDirty || this.isVisible && !lastIsVisible;

  // if restacking, reposition visible items vertically
  if (restack) {
    var visibleSubgroups = {};
    var subgroup = null;

    if (typeof this.itemSet.options.order === 'function') {
      // a custom order function
      // brute force restack of all items

      // show all items
      var me = this;
      var limitSize = false;

      var redrawQueue = {};
      var redrawQueueLength = 0;

      util.forEach(this.items, function (item, key) {
        if (!item.displayed) {
          var returnQueue = true;
          redrawQueue[key] = item.redraw(returnQueue);
          redrawQueueLength = redrawQueue[key].length;
          me.visibleItems.push(item);
        }
      });

      var needRedraw = redrawQueueLength > 0;
      if (needRedraw) {
        // redraw all regular items
        for (var i = 0; i < redrawQueueLength; i++) {
          util.forEach(redrawQueue, function (fns) {
            fns[i]();
          });
        }
      }

      util.forEach(this.items, function (item) {
        item.repositionX(limitSize);
      });

      if (this.doInnerStack && this.itemSet.options.stackSubgroups) {
        // Order the items within each subgroup
        for (subgroup in this.subgroups) {
          visibleSubgroups[subgroup] = this.subgroups[subgroup].items.slice().sort(function (a, b) {
            return me.itemSet.options.order(a.data, b.data);
          });
        }

        stack.stackSubgroupsWithInnerStack(visibleSubgroups, margin, this.subgroups);
      } else {
        // order all items and force a restacking
        var customOrderedItems = this.orderedItems.byStart.slice().sort(function (a, b) {
          return me.itemSet.options.order(a.data, b.data);
        });
        stack.stack(customOrderedItems, margin, true /* restack=true */);
      }

      this.visibleItems = this._updateItemsInRange(this.orderedItems, this.visibleItems, range);
    } else {
      // no custom order function, lazy stacking
      this.visibleItems = this._updateItemsInRange(this.orderedItems, this.visibleItems, range);

      if (this.itemSet.options.stack) {
        if (this.doInnerStack && this.itemSet.options.stackSubgroups) {
          for (subgroup in this.subgroups) {
            visibleSubgroups[subgroup] = this.subgroups[subgroup].items;
          }

          stack.stackSubgroupsWithInnerStack(visibleSubgroups, margin, this.subgroups);
        } else {
          // TODO: ugly way to access options...
          stack.stack(this.visibleItems, margin, true /* restack=true */);
        }
      } else {
        // no stacking
        stack.nostack(this.visibleItems, margin, this.subgroups, this.itemSet.options.stackSubgroups);
      }
    }

    this.stackDirty = false;
  }
};

Group.prototype._didResize = function (resized, height) {
  resized = util.updateProperty(this, 'height', height) || resized;
  // recalculate size of label
  var labelWidth = this.dom.inner.clientWidth;
  var labelHeight = this.dom.inner.clientHeight;
  resized = util.updateProperty(this.props.label, 'width', labelWidth) || resized;
  resized = util.updateProperty(this.props.label, 'height', labelHeight) || resized;
  return resized;
};

Group.prototype._applyGroupHeight = function (height) {
  this.dom.background.style.height = height + 'px';
  this.dom.foreground.style.height = height + 'px';
  this.dom.label.style.height = height + 'px';
};

// update vertical position of items after they are re-stacked and the height of the group is calculated
Group.prototype._updateItemsVerticalPosition = function (margin) {
  for (var i = 0, ii = this.visibleItems.length; i < ii; i++) {
    var item = this.visibleItems[i];
    item.repositionY(margin);
    if (!this.isVisible && this.groupId != "__background__") {
      if (item.displayed) item.hide();
    }
  }
};

/**
 * Repaint this group
 * @param {{start: number, end: number}} range
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 * @param {boolean} [forceRestack=false]  Force restacking of all items
 * @param {boolean} [returnQueue=false]  return the queue or if the group resized
 * @return {boolean} Returns true if the group is resized or the redraw queue if returnQueue=true
 */
Group.prototype.redraw = function (range, margin, forceRestack, returnQueue) {
  var resized = false;
  var lastIsVisible = this.isVisible;
  var height;

  var queue = [
  // force recalculation of the height of the items when the marker height changed
  // (due to the Timeline being attached to the DOM or changed from display:none to visible)
  function () {
    forceRestack = this._didMarkerHeightChange.bind(this);
  }.bind(this),

  // recalculate the height of the subgroups
  this._updateSubGroupHeights.bind(this, margin),

  // calculate actual size and position
  this._calculateGroupSizeAndPosition.bind(this),

  // check if group is visible
  function () {
    this.isVisible = this._isGroupVisible.bind(this)(range, margin);
  }.bind(this),

  // redraw Items if needed
  function () {
    this._redrawItems.bind(this)(forceRestack, lastIsVisible, margin, range);
  }.bind(this),

  // update subgroups
  this._updateSubgroupsSizes.bind(this),

  // recalculate the height of the group
  function () {
    height = this._calculateHeight.bind(this)(margin);
  }.bind(this),

  // calculate actual size and position again
  this._calculateGroupSizeAndPosition.bind(this),

  // check if resized
  function () {
    resized = this._didResize.bind(this)(resized, height);
  }.bind(this),

  // apply group height
  function () {
    this._applyGroupHeight.bind(this)(height);
  }.bind(this),

  // update vertical position of items after they are re-stacked and the height of the group is calculated
  function () {
    this._updateItemsVerticalPosition.bind(this)(margin);
  }.bind(this), function () {
    if (!this.isVisible && this.height) {
      resized = false;
    }
    return resized;
  }];

  if (returnQueue) {
    return queue;
  } else {
    var result;
    queue.forEach(function (fn) {
      result = fn();
    });
    return result;
  }
};

/**
 * recalculate the height of the subgroups
 *
 * @param {{item: vis.Item}} margin
 * @private
 */
Group.prototype._updateSubGroupHeights = function (margin) {
  if ((0, _keys2['default'])(this.subgroups).length > 0) {
    var me = this;

    this.resetSubgroups();

    util.forEach(this.visibleItems, function (item) {
      if (item.data.subgroup !== undefined) {
        me.subgroups[item.data.subgroup].height = Math.max(me.subgroups[item.data.subgroup].height, item.height + margin.item.vertical);
        me.subgroups[item.data.subgroup].visible = true;
      }
    });
  }
};

/**
 * check if group is visible
 *
 * @param {vis.Range} range
 * @param {{axis: vis.DataAxis}} margin
 * @returns {boolean} is visible
 * @private
 */
Group.prototype._isGroupVisible = function (range, margin) {
  return this.top <= range.body.domProps.centerContainer.height - range.body.domProps.scrollTop + margin.axis && this.top + this.height + margin.axis >= -range.body.domProps.scrollTop;
};

/**
 * recalculate the height of the group
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 * @returns {number} Returns the height
 * @private
 */
Group.prototype._calculateHeight = function (margin) {
  // recalculate the height of the group
  var height;
  var itemsInRange = this.visibleItems;
  if (itemsInRange.length > 0) {
    var min = itemsInRange[0].top;
    var max = itemsInRange[0].top + itemsInRange[0].height;
    util.forEach(itemsInRange, function (item) {
      min = Math.min(min, item.top);
      max = Math.max(max, item.top + item.height);
    });
    if (min > margin.axis) {
      // there is an empty gap between the lowest item and the axis
      var offset = min - margin.axis;
      max -= offset;
      util.forEach(itemsInRange, function (item) {
        item.top -= offset;
      });
    }
    height = max + margin.item.vertical / 2;
  } else {
    height = 0;
  }
  height = Math.max(height, this.props.label.height);

  return height;
};

/**
 * Show this group: attach to the DOM
 */
Group.prototype.show = function () {
  if (!this.dom.label.parentNode) {
    this.itemSet.dom.labelSet.appendChild(this.dom.label);
  }

  if (!this.dom.foreground.parentNode) {
    this.itemSet.dom.foreground.appendChild(this.dom.foreground);
  }

  if (!this.dom.background.parentNode) {
    this.itemSet.dom.background.appendChild(this.dom.background);
  }

  if (!this.dom.axis.parentNode) {
    this.itemSet.dom.axis.appendChild(this.dom.axis);
  }
};

/**
 * Hide this group: remove from the DOM
 */
Group.prototype.hide = function () {
  var label = this.dom.label;
  if (label.parentNode) {
    label.parentNode.removeChild(label);
  }

  var foreground = this.dom.foreground;
  if (foreground.parentNode) {
    foreground.parentNode.removeChild(foreground);
  }

  var background = this.dom.background;
  if (background.parentNode) {
    background.parentNode.removeChild(background);
  }

  var axis = this.dom.axis;
  if (axis.parentNode) {
    axis.parentNode.removeChild(axis);
  }
};

/**
 * Add an item to the group
 * @param {Item} item
 */
Group.prototype.add = function (item) {
  this.items[item.id] = item;
  item.setParent(this);
  this.stackDirty = true;
  // add to
  if (item.data.subgroup !== undefined) {
    this._addToSubgroup(item);
    this.orderSubgroups();
  }

  if (this.visibleItems.indexOf(item) == -1) {
    var range = this.itemSet.body.range; // TODO: not nice accessing the range like this
    this._checkIfVisible(item, this.visibleItems, range);
  }
};

Group.prototype._addToSubgroup = function (item, subgroupId) {
  subgroupId = subgroupId || item.data.subgroup;
  if (subgroupId != undefined && this.subgroups[subgroupId] === undefined) {
    this.subgroups[subgroupId] = {
      height: 0,
      top: 0,
      start: item.data.start,
      end: item.data.end || item.data.start,
      visible: false,
      index: this.subgroupIndex,
      items: [],
      stack: this.subgroupStackAll || this.subgroupStack[subgroupId] || false
    };
    this.subgroupIndex++;
  }

  if (new Date(item.data.start) < new Date(this.subgroups[subgroupId].start)) {
    this.subgroups[subgroupId].start = item.data.start;
  }

  var itemEnd = item.data.end || item.data.start;
  if (new Date(itemEnd) > new Date(this.subgroups[subgroupId].end)) {
    this.subgroups[subgroupId].end = itemEnd;
  }

  this.subgroups[subgroupId].items.push(item);
};

Group.prototype._updateSubgroupsSizes = function () {
  var me = this;
  if (me.subgroups) {
    for (var subgroup in me.subgroups) {
      var initialEnd = me.subgroups[subgroup].items[0].data.end || me.subgroups[subgroup].items[0].data.start;
      var newStart = me.subgroups[subgroup].items[0].data.start;
      var newEnd = initialEnd - 1;

      me.subgroups[subgroup].items.forEach(function (item) {
        if (new Date(item.data.start) < new Date(newStart)) {
          newStart = item.data.start;
        }

        var itemEnd = item.data.end || item.data.start;
        if (new Date(itemEnd) > new Date(newEnd)) {
          newEnd = itemEnd;
        }
      });

      me.subgroups[subgroup].start = newStart;
      me.subgroups[subgroup].end = new Date(newEnd - 1); // -1 to compensate for colliding end to start subgroups;
    }
  }
};

Group.prototype.orderSubgroups = function () {
  if (this.subgroupOrderer !== undefined) {
    var sortArray = [];
    var subgroup;
    if (typeof this.subgroupOrderer == 'string') {
      for (subgroup in this.subgroups) {
        sortArray.push({ subgroup: subgroup, sortField: this.subgroups[subgroup].items[0].data[this.subgroupOrderer] });
      }
      sortArray.sort(function (a, b) {
        return a.sortField - b.sortField;
      });
    } else if (typeof this.subgroupOrderer == 'function') {
      for (subgroup in this.subgroups) {
        sortArray.push(this.subgroups[subgroup].items[0].data);
      }
      sortArray.sort(this.subgroupOrderer);
    }

    if (sortArray.length > 0) {
      for (var i = 0; i < sortArray.length; i++) {
        this.subgroups[sortArray[i].subgroup].index = i;
      }
    }
  }
};

Group.prototype.resetSubgroups = function () {
  for (var subgroup in this.subgroups) {
    if (this.subgroups.hasOwnProperty(subgroup)) {
      this.subgroups[subgroup].visible = false;
      this.subgroups[subgroup].height = 0;
    }
  }
};

/**
 * Remove an item from the group
 * @param {Item} item
 */
Group.prototype.remove = function (item) {
  delete this.items[item.id];
  item.setParent(null);
  this.stackDirty = true;

  // remove from visible items
  var index = this.visibleItems.indexOf(item);
  if (index != -1) this.visibleItems.splice(index, 1);

  if (item.data.subgroup !== undefined) {
    this._removeFromSubgroup(item);
    this.orderSubgroups();
  }
};

Group.prototype._removeFromSubgroup = function (item, subgroupId) {
  subgroupId = subgroupId || item.data.subgroup;
  if (subgroupId != undefined) {
    var subgroup = this.subgroups[subgroupId];
    if (subgroup) {
      var itemIndex = subgroup.items.indexOf(item);
      //  Check the item is actually in this subgroup. How should items not in the group be handled?
      if (itemIndex >= 0) {
        subgroup.items.splice(itemIndex, 1);
        if (!subgroup.items.length) {
          delete this.subgroups[subgroupId];
        } else {
          this._updateSubgroupsSizes();
        }
      }
    }
  }
};

/**
 * Remove an item from the corresponding DataSet
 * @param {Item} item
 */
Group.prototype.removeFromDataSet = function (item) {
  this.itemSet.removeItem(item.id);
};

/**
 * Reorder the items
 */
Group.prototype.order = function () {
  var array = util.toArray(this.items);
  var startArray = [];
  var endArray = [];

  for (var i = 0; i < array.length; i++) {
    if (array[i].data.end !== undefined) {
      endArray.push(array[i]);
    }
    startArray.push(array[i]);
  }
  this.orderedItems = {
    byStart: startArray,
    byEnd: endArray
  };

  stack.orderByStart(this.orderedItems.byStart);
  stack.orderByEnd(this.orderedItems.byEnd);
};

/**
 * Update the visible items
 * @param {{byStart: Item[], byEnd: Item[]}} orderedItems   All items ordered by start date and by end date
 * @param {Item[]} oldVisibleItems                          The previously visible items.
 * @param {{start: number, end: number}} range              Visible range
 * @return {Item[]} visibleItems                            The new visible items.
 * @private
 */
Group.prototype._updateItemsInRange = function (orderedItems, oldVisibleItems, range) {
  var visibleItems = [];
  var visibleItemsLookup = {}; // we keep this to quickly look up if an item already exists in the list without using indexOf on visibleItems

  var interval = (range.end - range.start) / 4;
  var lowerBound = range.start - interval;
  var upperBound = range.end + interval;

  // this function is used to do the binary search.
  var searchFunction = function searchFunction(value) {
    if (value < lowerBound) {
      return -1;
    } else if (value <= upperBound) {
      return 0;
    } else {
      return 1;
    }
  };

  // first check if the items that were in view previously are still in view.
  // IMPORTANT: this handles the case for the items with startdate before the window and enddate after the window!
  // also cleans up invisible items.
  if (oldVisibleItems.length > 0) {
    for (var i = 0; i < oldVisibleItems.length; i++) {
      this._checkIfVisibleWithReference(oldVisibleItems[i], visibleItems, visibleItemsLookup, range);
    }
  }

  // we do a binary search for the items that have only start values.
  var initialPosByStart = util.binarySearchCustom(orderedItems.byStart, searchFunction, 'data', 'start');

  // trace the visible items from the inital start pos both ways until an invisible item is found, we only look at the start values.
  this._traceVisible(initialPosByStart, orderedItems.byStart, visibleItems, visibleItemsLookup, function (item) {
    return item.data.start < lowerBound || item.data.start > upperBound;
  });

  // if the window has changed programmatically without overlapping the old window, the ranged items with start < lowerBound and end > upperbound are not shown.
  // We therefore have to brute force check all items in the byEnd list
  if (this.checkRangedItems == true) {
    this.checkRangedItems = false;
    for (i = 0; i < orderedItems.byEnd.length; i++) {
      this._checkIfVisibleWithReference(orderedItems.byEnd[i], visibleItems, visibleItemsLookup, range);
    }
  } else {
    // we do a binary search for the items that have defined end times.
    var initialPosByEnd = util.binarySearchCustom(orderedItems.byEnd, searchFunction, 'data', 'end');

    // trace the visible items from the inital start pos both ways until an invisible item is found, we only look at the end values.
    this._traceVisible(initialPosByEnd, orderedItems.byEnd, visibleItems, visibleItemsLookup, function (item) {
      return item.data.end < lowerBound || item.data.end > upperBound;
    });
  }

  var redrawQueue = {};
  var redrawQueueLength = 0;

  for (i = 0; i < visibleItems.length; i++) {
    var item = visibleItems[i];
    if (!item.displayed) {
      var returnQueue = true;
      redrawQueue[i] = item.redraw(returnQueue);
      redrawQueueLength = redrawQueue[i].length;
    }
  }

  var needRedraw = redrawQueueLength > 0;
  if (needRedraw) {
    // redraw all regular items
    for (var j = 0; j < redrawQueueLength; j++) {
      util.forEach(redrawQueue, function (fns) {
        fns[j]();
      });
    }
  }

  for (i = 0; i < visibleItems.length; i++) {
    visibleItems[i].repositionX();
  }
  return visibleItems;
};

Group.prototype._traceVisible = function (initialPos, items, visibleItems, visibleItemsLookup, breakCondition) {
  if (initialPos != -1) {
    var i, item;
    for (i = initialPos; i >= 0; i--) {
      item = items[i];
      if (breakCondition(item)) {
        break;
      } else {
        if (visibleItemsLookup[item.id] === undefined) {
          visibleItemsLookup[item.id] = true;
          visibleItems.push(item);
        }
      }
    }

    for (i = initialPos + 1; i < items.length; i++) {
      item = items[i];
      if (breakCondition(item)) {
        break;
      } else {
        if (visibleItemsLookup[item.id] === undefined) {
          visibleItemsLookup[item.id] = true;
          visibleItems.push(item);
        }
      }
    }
  }
};

/**
 * this function is very similar to the _checkIfInvisible() but it does not
 * return booleans, hides the item if it should not be seen and always adds to
 * the visibleItems.
 * this one is for brute forcing and hiding.
 *
 * @param {Item} item
 * @param {Array} visibleItems
 * @param {{start:number, end:number}} range
 * @private
 */
Group.prototype._checkIfVisible = function (item, visibleItems, range) {
  if (item.isVisible(range)) {
    if (!item.displayed) item.show();
    // reposition item horizontally
    item.repositionX();
    visibleItems.push(item);
  } else {
    if (item.displayed) item.hide();
  }
};

/**
 * this function is very similar to the _checkIfInvisible() but it does not
 * return booleans, hides the item if it should not be seen and always adds to
 * the visibleItems.
 * this one is for brute forcing and hiding.
 *
 * @param {Item} item
 * @param {Array.<vis.Item>} visibleItems
 * @param {Object<number, boolean>} visibleItemsLookup
 * @param {{start:number, end:number}} range
 * @private
 */
Group.prototype._checkIfVisibleWithReference = function (item, visibleItems, visibleItemsLookup, range) {
  if (item.isVisible(range)) {
    if (visibleItemsLookup[item.id] === undefined) {
      visibleItemsLookup[item.id] = true;
      visibleItems.push(item);
    }
  } else {
    if (item.displayed) item.hide();
  }
};

Group.prototype.changeSubgroup = function (item, oldSubgroup, newSubgroup) {
  this._removeFromSubgroup(item, oldSubgroup);
  this._addToSubgroup(item, newSubgroup);
  this.orderSubgroups();
};

module.exports = Group;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _create = __webpack_require__(29);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Group = __webpack_require__(68);

/**
 * @constructor BackgroundGroup
 * @param {number | string} groupId
 * @param {Object} data
 * @param {ItemSet} itemSet
 * @extends Group
 */
function BackgroundGroup(groupId, data, itemSet) {
  Group.call(this, groupId, data, itemSet);

  this.width = 0;
  this.height = 0;
  this.top = 0;
  this.left = 0;
}

BackgroundGroup.prototype = (0, _create2['default'])(Group.prototype);

/**
 * Repaint this group
 * @param {{start: number, end: number}} range
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 * @param {boolean} [forceRestack=false]  Force restacking of all items
 * @return {boolean} Returns true if the group is resized
 */
BackgroundGroup.prototype.redraw = function (range, margin, forceRestack) {
  // eslint-disable-line no-unused-vars
  var resized = false;

  this.visibleItems = this._updateItemsInRange(this.orderedItems, this.visibleItems, range);

  // calculate actual size
  this.width = this.dom.background.offsetWidth;

  // apply new height (just always zero for BackgroundGroup
  this.dom.background.style.height = '0';

  // update vertical position of items after they are re-stacked and the height of the group is calculated
  for (var i = 0, ii = this.visibleItems.length; i < ii; i++) {
    var item = this.visibleItems[i];
    item.repositionY(margin);
  }

  return resized;
};

/**
 * Show this group: attach to the DOM
 */
BackgroundGroup.prototype.show = function () {
  if (!this.dom.background.parentNode) {
    this.itemSet.dom.background.appendChild(this.dom.background);
  }
};

module.exports = BackgroundGroup;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Item = __webpack_require__(38);

/**
 * @constructor RangeItem
 * @extends Item
 * @param {Object} data             Object containing parameters start, end
 *                                  content, className.
 * @param {{toScreen: function, toTime: function}} conversion
 *                                  Conversion functions from time to screen and vice versa
 * @param {Object} [options]        Configuration options
 *                                  // TODO: describe options
 */
function RangeItem(data, conversion, options) {
  this.props = {
    content: {
      width: 0
    }
  };
  this.overflow = false; // if contents can overflow (css styling), this flag is set to true
  this.options = options;
  // validate data
  if (data) {
    if (data.start == undefined) {
      throw new Error('Property "start" missing in item ' + data.id);
    }
    if (data.end == undefined) {
      throw new Error('Property "end" missing in item ' + data.id);
    }
  }

  Item.call(this, data, conversion, options);
}

RangeItem.prototype = new Item(null, null, null);

RangeItem.prototype.baseClassName = 'vis-item vis-range';

/**
 * Check whether this item is visible inside given range
 *
 * @param {vis.Range} range with a timestamp for start and end
 * @returns {boolean} True if visible
 */
RangeItem.prototype.isVisible = function (range) {
  // determine visibility
  return this.data.start < range.end && this.data.end > range.start;
};

RangeItem.prototype._createDomElement = function () {
  if (!this.dom) {
    // create DOM
    this.dom = {};

    // background box
    this.dom.box = document.createElement('div');
    // className is updated in redraw()

    // frame box (to prevent the item contents from overflowing)
    this.dom.frame = document.createElement('div');
    this.dom.frame.className = 'vis-item-overflow';
    this.dom.box.appendChild(this.dom.frame);

    // visible frame box (showing the frame that is always visible)
    this.dom.visibleFrame = document.createElement('div');
    this.dom.visibleFrame.className = 'vis-item-visible-frame';
    this.dom.box.appendChild(this.dom.visibleFrame);

    // contents box
    this.dom.content = document.createElement('div');
    this.dom.content.className = 'vis-item-content';
    this.dom.frame.appendChild(this.dom.content);

    // attach this item as attribute
    this.dom.box['timeline-item'] = this;

    this.dirty = true;
  }
};

RangeItem.prototype._appendDomElement = function () {
  if (!this.parent) {
    throw new Error('Cannot redraw item: no parent attached');
  }
  if (!this.dom.box.parentNode) {
    var foreground = this.parent.dom.foreground;
    if (!foreground) {
      throw new Error('Cannot redraw item: parent has no foreground container element');
    }
    foreground.appendChild(this.dom.box);
  }
  this.displayed = true;
};

RangeItem.prototype._updateDirtyDomComponents = function () {
  // update dirty DOM. An item is marked dirty when:
  // - the item is not yet rendered
  // - the item's data is changed
  // - the item is selected/deselected
  if (this.dirty) {
    this._updateContents(this.dom.content);
    this._updateDataAttributes(this.dom.box);
    this._updateStyle(this.dom.box);

    var editable = this.editable.updateTime || this.editable.updateGroup;

    // update class
    var className = (this.data.className ? ' ' + this.data.className : '') + (this.selected ? ' vis-selected' : '') + (editable ? ' vis-editable' : ' vis-readonly');
    this.dom.box.className = this.baseClassName + className;

    // turn off max-width to be able to calculate the real width
    // this causes an extra browser repaint/reflow, but so be it
    this.dom.content.style.maxWidth = 'none';
  }
};

RangeItem.prototype._getDomComponentsSizes = function () {
  // determine from css whether this box has overflow
  this.overflow = window.getComputedStyle(this.dom.frame).overflow !== 'hidden';
  return {
    content: {
      width: this.dom.content.offsetWidth
    },
    box: {
      height: this.dom.box.offsetHeight
    }
  };
};

RangeItem.prototype._updateDomComponentsSizes = function (sizes) {
  this.props.content.width = sizes.content.width;
  this.height = sizes.box.height;
  this.dom.content.style.maxWidth = '';
  this.dirty = false;
};

RangeItem.prototype._repaintDomAdditionals = function () {
  this._repaintOnItemUpdateTimeTooltip(this.dom.box);
  this._repaintDeleteButton(this.dom.box);
  this._repaintDragCenter();
  this._repaintDragLeft();
  this._repaintDragRight();
};

/**
 * Repaint the item
 * @param {boolean} [returnQueue=false]  return the queue
 * @return {boolean} the redraw queue if returnQueue=true
 */
RangeItem.prototype.redraw = function (returnQueue) {
  var sizes;
  var queue = [
  // create item DOM
  this._createDomElement.bind(this),

  // append DOM to parent DOM
  this._appendDomElement.bind(this),

  // update dirty DOM 
  this._updateDirtyDomComponents.bind(this), function () {
    if (this.dirty) {
      sizes = this._getDomComponentsSizes.bind(this)();
    }
  }.bind(this), function () {
    if (this.dirty) {
      this._updateDomComponentsSizes.bind(this)(sizes);
    }
  }.bind(this),

  // repaint DOM additionals
  this._repaintDomAdditionals.bind(this)];

  if (returnQueue) {
    return queue;
  } else {
    var result;
    queue.forEach(function (fn) {
      result = fn();
    });
    return result;
  }
};

/**
 * Show the item in the DOM (when not already visible). The items DOM will
 * be created when needed.
 */
RangeItem.prototype.show = function () {
  if (!this.displayed) {
    this.redraw();
  }
};

/**
 * Hide the item from the DOM (when visible)
 */
RangeItem.prototype.hide = function () {
  if (this.displayed) {
    var box = this.dom.box;

    if (box.parentNode) {
      box.parentNode.removeChild(box);
    }

    this.displayed = false;
  }
};

/**
 * Reposition the item horizontally
 * @param {boolean} [limitSize=true] If true (default), the width of the range
 *                                   item will be limited, as the browser cannot
 *                                   display very wide divs. This means though
 *                                   that the applied left and width may
 *                                   not correspond to the ranges start and end
 * @Override
 */
RangeItem.prototype.repositionX = function (limitSize) {
  var parentWidth = this.parent.width;
  var start = this.conversion.toScreen(this.data.start);
  var end = this.conversion.toScreen(this.data.end);
  var align = this.data.align === undefined ? this.options.align : this.data.align;
  var contentStartPosition;
  var contentWidth;

  // limit the width of the range, as browsers cannot draw very wide divs
  // unless limitSize: false is explicitly set in item data
  if (this.data.limitSize !== false && (limitSize === undefined || limitSize === true)) {
    if (start < -parentWidth) {
      start = -parentWidth;
    }
    if (end > 2 * parentWidth) {
      end = 2 * parentWidth;
    }
  }

  // add 0.5 to compensate floating-point values rounding
  var boxWidth = Math.max(end - start + 0.5, 1);

  if (this.overflow) {
    if (this.options.rtl) {
      this.right = start;
    } else {
      this.left = start;
    }
    this.width = boxWidth + this.props.content.width;
    contentWidth = this.props.content.width;

    // Note: The calculation of width is an optimistic calculation, giving
    //       a width which will not change when moving the Timeline
    //       So no re-stacking needed, which is nicer for the eye;
  } else {
    if (this.options.rtl) {
      this.right = start;
    } else {
      this.left = start;
    }
    this.width = boxWidth;
    contentWidth = Math.min(end - start, this.props.content.width);
  }

  if (this.options.rtl) {
    this.dom.box.style.right = this.right + 'px';
  } else {
    this.dom.box.style.left = this.left + 'px';
  }
  this.dom.box.style.width = boxWidth + 'px';

  switch (align) {
    case 'left':
      if (this.options.rtl) {
        this.dom.content.style.right = '0';
      } else {
        this.dom.content.style.left = '0';
      }
      break;

    case 'right':
      if (this.options.rtl) {
        this.dom.content.style.right = Math.max(boxWidth - contentWidth, 0) + 'px';
      } else {
        this.dom.content.style.left = Math.max(boxWidth - contentWidth, 0) + 'px';
      }
      break;

    case 'center':
      if (this.options.rtl) {
        this.dom.content.style.right = Math.max((boxWidth - contentWidth) / 2, 0) + 'px';
      } else {
        this.dom.content.style.left = Math.max((boxWidth - contentWidth) / 2, 0) + 'px';
      }

      break;

    default:
      // 'auto'
      // when range exceeds left of the window, position the contents at the left of the visible area
      if (this.overflow) {
        if (end > 0) {
          contentStartPosition = Math.max(-start, 0);
        } else {
          contentStartPosition = -contentWidth; // ensure it's not visible anymore
        }
      } else {
        if (start < 0) {
          contentStartPosition = -start;
        } else {
          contentStartPosition = 0;
        }
      }
      if (this.options.rtl) {
        this.dom.content.style.right = contentStartPosition + 'px';
      } else {
        this.dom.content.style.left = contentStartPosition + 'px';
        this.dom.content.style.width = 'calc(100% - ' + contentStartPosition + 'px)';
      }
  }
};

/**
 * Reposition the item vertically
 * @Override
 */
RangeItem.prototype.repositionY = function () {
  var orientation = this.options.orientation.item;
  var box = this.dom.box;

  if (orientation == 'top') {
    box.style.top = this.top + 'px';
  } else {
    box.style.top = this.parent.height - this.top - this.height + 'px';
  }
};

/**
 * Repaint a drag area on the left side of the range when the range is selected
 * @protected
 */
RangeItem.prototype._repaintDragLeft = function () {
  if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.options.editable.updateTime && !this.dom.dragLeft) {
    // create and show drag area
    var dragLeft = document.createElement('div');
    dragLeft.className = 'vis-drag-left';
    dragLeft.dragLeftItem = this;

    this.dom.box.appendChild(dragLeft);
    this.dom.dragLeft = dragLeft;
  } else if (!this.selected && !this.options.itemsAlwaysDraggable.range && this.dom.dragLeft) {
    // delete drag area
    if (this.dom.dragLeft.parentNode) {
      this.dom.dragLeft.parentNode.removeChild(this.dom.dragLeft);
    }
    this.dom.dragLeft = null;
  }
};

/**
 * Repaint a drag area on the right side of the range when the range is selected
 * @protected
 */
RangeItem.prototype._repaintDragRight = function () {
  if ((this.selected || this.options.itemsAlwaysDraggable.range) && this.options.editable.updateTime && !this.dom.dragRight) {
    // create and show drag area
    var dragRight = document.createElement('div');
    dragRight.className = 'vis-drag-right';
    dragRight.dragRightItem = this;

    this.dom.box.appendChild(dragRight);
    this.dom.dragRight = dragRight;
  } else if (!this.selected && !this.options.itemsAlwaysDraggable.range && this.dom.dragRight) {
    // delete drag area
    if (this.dom.dragRight.parentNode) {
      this.dom.dragRight.parentNode.removeChild(this.dom.dragRight);
    }
    this.dom.dragRight = null;
  }
};

module.exports = RangeItem;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(19);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);

var ColorPicker = __webpack_require__(179)['default'];

/**
 * The way this works is for all properties of this.possible options, you can supply the property name in any form to list the options.
 * Boolean options are recognised as Boolean
 * Number options should be written as array: [default value, min value, max value, stepsize]
 * Colors should be written as array: ['color', '#ffffff']
 * Strings with should be written as array: [option1, option2, option3, ..]
 *
 * The options are matched with their counterparts in each of the modules and the values used in the configuration are
 */

var Configurator = function () {
  /**
   * @param {Object} parentModule        | the location where parentModule.setOptions() can be called
   * @param {Object} defaultContainer    | the default container of the module
   * @param {Object} configureOptions    | the fully configured and predefined options set found in allOptions.js
   * @param {number} pixelRatio          | canvas pixel ratio
   */
  function Configurator(parentModule, defaultContainer, configureOptions) {
    var pixelRatio = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    (0, _classCallCheck3['default'])(this, Configurator);

    this.parent = parentModule;
    this.changedOptions = [];
    this.container = defaultContainer;
    this.allowCreation = false;

    this.options = {};
    this.initialized = false;
    this.popupCounter = 0;
    this.defaultOptions = {
      enabled: false,
      filter: true,
      container: undefined,
      showButton: true
    };
    util.extend(this.options, this.defaultOptions);

    this.configureOptions = configureOptions;
    this.moduleOptions = {};
    this.domElements = [];
    this.popupDiv = {};
    this.popupLimit = 5;
    this.popupHistory = {};
    this.colorPicker = new ColorPicker(pixelRatio);
    this.wrapper = undefined;
  }

  /**
   * refresh all options.
   * Because all modules parse their options by themselves, we just use their options. We copy them here.
   *
   * @param {Object} options
   */


  (0, _createClass3['default'])(Configurator, [{
    key: 'setOptions',
    value: function setOptions(options) {
      if (options !== undefined) {
        // reset the popup history because the indices may have been changed.
        this.popupHistory = {};
        this._removePopup();

        var enabled = true;
        if (typeof options === 'string') {
          this.options.filter = options;
        } else if (options instanceof Array) {
          this.options.filter = options.join();
        } else if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3['default'])(options)) === 'object') {
          if (options.container !== undefined) {
            this.options.container = options.container;
          }
          if (options.filter !== undefined) {
            this.options.filter = options.filter;
          }
          if (options.showButton !== undefined) {
            this.options.showButton = options.showButton;
          }
          if (options.enabled !== undefined) {
            enabled = options.enabled;
          }
        } else if (typeof options === 'boolean') {
          this.options.filter = true;
          enabled = options;
        } else if (typeof options === 'function') {
          this.options.filter = options;
          enabled = true;
        }
        if (this.options.filter === false) {
          enabled = false;
        }

        this.options.enabled = enabled;
      }
      this._clean();
    }

    /**
     *
     * @param {Object} moduleOptions
     */

  }, {
    key: 'setModuleOptions',
    value: function setModuleOptions(moduleOptions) {
      this.moduleOptions = moduleOptions;
      if (this.options.enabled === true) {
        this._clean();
        if (this.options.container !== undefined) {
          this.container = this.options.container;
        }
        this._create();
      }
    }

    /**
     * Create all DOM elements
     * @private
     */

  }, {
    key: '_create',
    value: function _create() {
      var _this = this;

      this._clean();
      this.changedOptions = [];

      var filter = this.options.filter;
      var counter = 0;
      var show = false;
      for (var option in this.configureOptions) {
        if (this.configureOptions.hasOwnProperty(option)) {
          this.allowCreation = false;
          show = false;
          if (typeof filter === 'function') {
            show = filter(option, []);
            show = show || this._handleObject(this.configureOptions[option], [option], true);
          } else if (filter === true || filter.indexOf(option) !== -1) {
            show = true;
          }

          if (show !== false) {
            this.allowCreation = true;

            // linebreak between categories
            if (counter > 0) {
              this._makeItem([]);
            }
            // a header for the category
            this._makeHeader(option);

            // get the sub options
            this._handleObject(this.configureOptions[option], [option]);
          }
          counter++;
        }
      }

      if (this.options.showButton === true) {
        var generateButton = document.createElement('div');
        generateButton.className = 'vis-configuration vis-config-button';
        generateButton.innerHTML = 'generate options';
        generateButton.onclick = function () {
          _this._printOptions();
        };
        generateButton.onmouseover = function () {
          generateButton.className = 'vis-configuration vis-config-button hover';
        };
        generateButton.onmouseout = function () {
          generateButton.className = 'vis-configuration vis-config-button';
        };

        this.optionsContainer = document.createElement('div');
        this.optionsContainer.className = 'vis-configuration vis-config-option-container';

        this.domElements.push(this.optionsContainer);
        this.domElements.push(generateButton);
      }

      this._push();
      //~ this.colorPicker.insertTo(this.container);
    }

    /**
     * draw all DOM elements on the screen
     * @private
     */

  }, {
    key: '_push',
    value: function _push() {
      this.wrapper = document.createElement('div');
      this.wrapper.className = 'vis-configuration-wrapper';
      this.container.appendChild(this.wrapper);
      for (var i = 0; i < this.domElements.length; i++) {
        this.wrapper.appendChild(this.domElements[i]);
      }

      this._showPopupIfNeeded();
    }

    /**
     * delete all DOM elements
     * @private
     */

  }, {
    key: '_clean',
    value: function _clean() {
      for (var i = 0; i < this.domElements.length; i++) {
        this.wrapper.removeChild(this.domElements[i]);
      }

      if (this.wrapper !== undefined) {
        this.container.removeChild(this.wrapper);
        this.wrapper = undefined;
      }
      this.domElements = [];

      this._removePopup();
    }

    /**
     * get the value from the actualOptions if it exists
     * @param {array} path    | where to look for the actual option
     * @returns {*}
     * @private
     */

  }, {
    key: '_getValue',
    value: function _getValue(path) {
      var base = this.moduleOptions;
      for (var i = 0; i < path.length; i++) {
        if (base[path[i]] !== undefined) {
          base = base[path[i]];
        } else {
          base = undefined;
          break;
        }
      }
      return base;
    }

    /**
     * all option elements are wrapped in an item
     * @param {Array} path    | where to look for the actual option
     * @param {Array.<Element>} domElements
     * @returns {number}
     * @private
     */

  }, {
    key: '_makeItem',
    value: function _makeItem(path) {
      if (this.allowCreation === true) {
        var item = document.createElement('div');
        item.className = 'vis-configuration vis-config-item vis-config-s' + path.length;

        for (var _len = arguments.length, domElements = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          domElements[_key - 1] = arguments[_key];
        }

        domElements.forEach(function (element) {
          item.appendChild(element);
        });
        this.domElements.push(item);
        return this.domElements.length;
      }
      return 0;
    }

    /**
     * header for major subjects
     * @param {string} name
     * @private
     */

  }, {
    key: '_makeHeader',
    value: function _makeHeader(name) {
      var div = document.createElement('div');
      div.className = 'vis-configuration vis-config-header';
      div.innerHTML = name;
      this._makeItem([], div);
    }

    /**
     * make a label, if it is an object label, it gets different styling.
     * @param {string} name
     * @param {array} path    | where to look for the actual option
     * @param {string} objectLabel
     * @returns {HTMLElement}
     * @private
     */

  }, {
    key: '_makeLabel',
    value: function _makeLabel(name, path) {
      var objectLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var div = document.createElement('div');
      div.className = 'vis-configuration vis-config-label vis-config-s' + path.length;
      if (objectLabel === true) {
        div.innerHTML = '<i><b>' + name + ':</b></i>';
      } else {
        div.innerHTML = name + ':';
      }
      return div;
    }

    /**
     * make a dropdown list for multiple possible string optoins
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */

  }, {
    key: '_makeDropdown',
    value: function _makeDropdown(arr, value, path) {
      var select = document.createElement('select');
      select.className = 'vis-configuration vis-config-select';
      var selectedValue = 0;
      if (value !== undefined) {
        if (arr.indexOf(value) !== -1) {
          selectedValue = arr.indexOf(value);
        }
      }

      for (var i = 0; i < arr.length; i++) {
        var option = document.createElement('option');
        option.value = arr[i];
        if (i === selectedValue) {
          option.selected = 'selected';
        }
        option.innerHTML = arr[i];
        select.appendChild(option);
      }

      var me = this;
      select.onchange = function () {
        me._update(this.value, path);
      };

      var label = this._makeLabel(path[path.length - 1], path);
      this._makeItem(path, label, select);
    }

    /**
     * make a range object for numeric options
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */

  }, {
    key: '_makeRange',
    value: function _makeRange(arr, value, path) {
      var defaultValue = arr[0];
      var min = arr[1];
      var max = arr[2];
      var step = arr[3];
      var range = document.createElement('input');
      range.className = 'vis-configuration vis-config-range';
      try {
        range.type = 'range'; // not supported on IE9
        range.min = min;
        range.max = max;
      }
      // TODO: Add some error handling and remove this lint exception
      catch (err) {} // eslint-disable-line no-empty
      range.step = step;

      // set up the popup settings in case they are needed.
      var popupString = '';
      var popupValue = 0;

      if (value !== undefined) {
        var factor = 1.20;
        if (value < 0 && value * factor < min) {
          range.min = Math.ceil(value * factor);
          popupValue = range.min;
          popupString = 'range increased';
        } else if (value / factor < min) {
          range.min = Math.ceil(value / factor);
          popupValue = range.min;
          popupString = 'range increased';
        }
        if (value * factor > max && max !== 1) {
          range.max = Math.ceil(value * factor);
          popupValue = range.max;
          popupString = 'range increased';
        }
        range.value = value;
      } else {
        range.value = defaultValue;
      }

      var input = document.createElement('input');
      input.className = 'vis-configuration vis-config-rangeinput';
      input.value = range.value;

      var me = this;
      range.onchange = function () {
        input.value = this.value;me._update(Number(this.value), path);
      };
      range.oninput = function () {
        input.value = this.value;
      };

      var label = this._makeLabel(path[path.length - 1], path);
      var itemIndex = this._makeItem(path, label, range, input);

      // if a popup is needed AND it has not been shown for this value, show it.
      if (popupString !== '' && this.popupHistory[itemIndex] !== popupValue) {
        this.popupHistory[itemIndex] = popupValue;
        this._setupPopup(popupString, itemIndex);
      }
    }

    /**
     * prepare the popup
     * @param {string} string
     * @param {number} index
     * @private
     */

  }, {
    key: '_setupPopup',
    value: function _setupPopup(string, index) {
      var _this2 = this;

      if (this.initialized === true && this.allowCreation === true && this.popupCounter < this.popupLimit) {
        var div = document.createElement("div");
        div.id = "vis-configuration-popup";
        div.className = "vis-configuration-popup";
        div.innerHTML = string;
        div.onclick = function () {
          _this2._removePopup();
        };
        this.popupCounter += 1;
        this.popupDiv = { html: div, index: index };
      }
    }

    /**
     * remove the popup from the dom
     * @private
     */

  }, {
    key: '_removePopup',
    value: function _removePopup() {
      if (this.popupDiv.html !== undefined) {
        this.popupDiv.html.parentNode.removeChild(this.popupDiv.html);
        clearTimeout(this.popupDiv.hideTimeout);
        clearTimeout(this.popupDiv.deleteTimeout);
        this.popupDiv = {};
      }
    }

    /**
     * Show the popup if it is needed.
     * @private
     */

  }, {
    key: '_showPopupIfNeeded',
    value: function _showPopupIfNeeded() {
      var _this3 = this;

      if (this.popupDiv.html !== undefined) {
        var correspondingElement = this.domElements[this.popupDiv.index];
        var rect = correspondingElement.getBoundingClientRect();
        this.popupDiv.html.style.left = rect.left + "px";
        this.popupDiv.html.style.top = rect.top - 30 + "px"; // 30 is the height;
        document.body.appendChild(this.popupDiv.html);
        this.popupDiv.hideTimeout = setTimeout(function () {
          _this3.popupDiv.html.style.opacity = 0;
        }, 1500);
        this.popupDiv.deleteTimeout = setTimeout(function () {
          _this3._removePopup();
        }, 1800);
      }
    }

    /**
     * make a checkbox for boolean options.
     * @param {number} defaultValue
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */

  }, {
    key: '_makeCheckbox',
    value: function _makeCheckbox(defaultValue, value, path) {
      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'vis-configuration vis-config-checkbox';
      checkbox.checked = defaultValue;
      if (value !== undefined) {
        checkbox.checked = value;
        if (value !== defaultValue) {
          if ((typeof defaultValue === 'undefined' ? 'undefined' : (0, _typeof3['default'])(defaultValue)) === 'object') {
            if (value !== defaultValue.enabled) {
              this.changedOptions.push({ path: path, value: value });
            }
          } else {
            this.changedOptions.push({ path: path, value: value });
          }
        }
      }

      var me = this;
      checkbox.onchange = function () {
        me._update(this.checked, path);
      };

      var label = this._makeLabel(path[path.length - 1], path);
      this._makeItem(path, label, checkbox);
    }

    /**
     * make a text input field for string options.
     * @param {number} defaultValue
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */

  }, {
    key: '_makeTextInput',
    value: function _makeTextInput(defaultValue, value, path) {
      var checkbox = document.createElement('input');
      checkbox.type = 'text';
      checkbox.className = 'vis-configuration vis-config-text';
      checkbox.value = value;
      if (value !== defaultValue) {
        this.changedOptions.push({ path: path, value: value });
      }

      var me = this;
      checkbox.onchange = function () {
        me._update(this.value, path);
      };

      var label = this._makeLabel(path[path.length - 1], path);
      this._makeItem(path, label, checkbox);
    }

    /**
     * make a color field with a color picker for color fields
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */

  }, {
    key: '_makeColorField',
    value: function _makeColorField(arr, value, path) {
      var _this4 = this;

      var defaultColor = arr[1];
      var div = document.createElement('div');
      value = value === undefined ? defaultColor : value;

      if (value !== 'none') {
        div.className = 'vis-configuration vis-config-colorBlock';
        div.style.backgroundColor = value;
      } else {
        div.className = 'vis-configuration vis-config-colorBlock none';
      }

      value = value === undefined ? defaultColor : value;
      div.onclick = function () {
        _this4._showColorPicker(value, div, path);
      };

      var label = this._makeLabel(path[path.length - 1], path);
      this._makeItem(path, label, div);
    }

    /**
     * used by the color buttons to call the color picker.
     * @param {number} value
     * @param {HTMLElement} div
     * @param {array} path    | where to look for the actual option
     * @private
     */

  }, {
    key: '_showColorPicker',
    value: function _showColorPicker(value, div, path) {
      var _this5 = this;

      // clear the callback from this div
      div.onclick = function () {};

      this.colorPicker.insertTo(div);
      this.colorPicker.show();

      this.colorPicker.setColor(value);
      this.colorPicker.setUpdateCallback(function (color) {
        var colorString = 'rgba(' + color.r + ',' + color.g + ',' + color.b + ',' + color.a + ')';
        div.style.backgroundColor = colorString;
        _this5._update(colorString, path);
      });

      // on close of the colorpicker, restore the callback.
      this.colorPicker.setCloseCallback(function () {
        div.onclick = function () {
          _this5._showColorPicker(value, div, path);
        };
      });
    }

    /**
     * parse an object and draw the correct items
     * @param {Object} obj
     * @param {array} [path=[]]    | where to look for the actual option
     * @param {boolean} [checkOnly=false]
     * @returns {boolean}
     * @private
     */

  }, {
    key: '_handleObject',
    value: function _handleObject(obj) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var checkOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var show = false;
      var filter = this.options.filter;
      var visibleInSet = false;
      for (var subObj in obj) {
        if (obj.hasOwnProperty(subObj)) {
          show = true;
          var item = obj[subObj];
          var newPath = util.copyAndExtendArray(path, subObj);
          if (typeof filter === 'function') {
            show = filter(subObj, path);

            // if needed we must go deeper into the object.
            if (show === false) {
              if (!(item instanceof Array) && typeof item !== 'string' && typeof item !== 'boolean' && item instanceof Object) {
                this.allowCreation = false;
                show = this._handleObject(item, newPath, true);
                this.allowCreation = checkOnly === false;
              }
            }
          }

          if (show !== false) {
            visibleInSet = true;
            var value = this._getValue(newPath);

            if (item instanceof Array) {
              this._handleArray(item, value, newPath);
            } else if (typeof item === 'string') {
              this._makeTextInput(item, value, newPath);
            } else if (typeof item === 'boolean') {
              this._makeCheckbox(item, value, newPath);
            } else if (item instanceof Object) {
              // collapse the physics options that are not enabled
              var draw = true;
              if (path.indexOf('physics') !== -1) {
                if (this.moduleOptions.physics.solver !== subObj) {
                  draw = false;
                }
              }

              if (draw === true) {
                // initially collapse options with an disabled enabled option.
                if (item.enabled !== undefined) {
                  var enabledPath = util.copyAndExtendArray(newPath, 'enabled');
                  var enabledValue = this._getValue(enabledPath);
                  if (enabledValue === true) {
                    var label = this._makeLabel(subObj, newPath, true);
                    this._makeItem(newPath, label);
                    visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                  } else {
                    this._makeCheckbox(item, enabledValue, newPath);
                  }
                } else {
                  var _label = this._makeLabel(subObj, newPath, true);
                  this._makeItem(newPath, _label);
                  visibleInSet = this._handleObject(item, newPath) || visibleInSet;
                }
              }
            } else {
              console.error('dont know how to handle', item, subObj, newPath);
            }
          }
        }
      }
      return visibleInSet;
    }

    /**
     * handle the array type of option
     * @param {Array.<number>} arr
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */

  }, {
    key: '_handleArray',
    value: function _handleArray(arr, value, path) {
      if (typeof arr[0] === 'string' && arr[0] === 'color') {
        this._makeColorField(arr, value, path);
        if (arr[1] !== value) {
          this.changedOptions.push({ path: path, value: value });
        }
      } else if (typeof arr[0] === 'string') {
        this._makeDropdown(arr, value, path);
        if (arr[0] !== value) {
          this.changedOptions.push({ path: path, value: value });
        }
      } else if (typeof arr[0] === 'number') {
        this._makeRange(arr, value, path);
        if (arr[0] !== value) {
          this.changedOptions.push({ path: path, value: Number(value) });
        }
      }
    }

    /**
     * called to update the network with the new settings.
     * @param {number} value
     * @param {array} path    | where to look for the actual option
     * @private
     */

  }, {
    key: '_update',
    value: function _update(value, path) {
      var options = this._constructOptions(value, path);

      if (this.parent.body && this.parent.body.emitter && this.parent.body.emitter.emit) {
        this.parent.body.emitter.emit("configChange", options);
      }
      this.initialized = true;
      this.parent.setOptions(options);
    }

    /**
     *
     * @param {string|Boolean} value
     * @param {Array.<string>} path
     * @param {{}} optionsObj
     * @returns {{}}
     * @private
     */

  }, {
    key: '_constructOptions',
    value: function _constructOptions(value, path) {
      var optionsObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var pointer = optionsObj;

      // when dropdown boxes can be string or boolean, we typecast it into correct types
      value = value === 'true' ? true : value;
      value = value === 'false' ? false : value;

      for (var i = 0; i < path.length; i++) {
        if (path[i] !== 'global') {
          if (pointer[path[i]] === undefined) {
            pointer[path[i]] = {};
          }
          if (i !== path.length - 1) {
            pointer = pointer[path[i]];
          } else {
            pointer[path[i]] = value;
          }
        }
      }
      return optionsObj;
    }

    /**
     * @private
     */

  }, {
    key: '_printOptions',
    value: function _printOptions() {
      var options = this.getOptions();
      this.optionsContainer.innerHTML = '<pre>var options = ' + (0, _stringify2['default'])(options, null, 2) + '</pre>';
    }

    /**
     *
     * @returns {{}} options
     */

  }, {
    key: 'getOptions',
    value: function getOptions() {
      var options = {};
      for (var i = 0; i < this.changedOptions.length; i++) {
        this._constructOptions(this.changedOptions[i].value, this.changedOptions[i].path, options);
      }
      return options;
    }
  }]);
  return Configurator;
}();

exports['default'] = Configurator;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DOMutil = __webpack_require__(14);

/**
 *
 * @param {number | string} groupId
 * @param {Object} options   // TODO: Describe options
 *
 * @constructor Points
 */
function Points(groupId, options) {} // eslint-disable-line no-unused-vars


/**
 * draw the data points
 *
 * @param {Array} dataset
 * @param {GraphGroup} group
 * @param {Object} framework            | SVG DOM element
 * @param {number} [offset]
 */
Points.draw = function (dataset, group, framework, offset) {
  offset = offset || 0;
  var callback = getCallback(framework, group);

  for (var i = 0; i < dataset.length; i++) {
    if (!callback) {
      // draw the point the simple way.
      DOMutil.drawPoint(dataset[i].screen_x + offset, dataset[i].screen_y, getGroupTemplate(group), framework.svgElements, framework.svg, dataset[i].label);
    } else {
      var callbackResult = callback(dataset[i], group); // result might be true, false or an object
      if (callbackResult === true || (typeof callbackResult === 'undefined' ? 'undefined' : (0, _typeof3['default'])(callbackResult)) === 'object') {
        DOMutil.drawPoint(dataset[i].screen_x + offset, dataset[i].screen_y, getGroupTemplate(group, callbackResult), framework.svgElements, framework.svg, dataset[i].label);
      }
    }
  }
};

Points.drawIcon = function (group, x, y, iconWidth, iconHeight, framework) {
  var fillHeight = iconHeight * 0.5;

  var outline = DOMutil.getSVGElement("rect", framework.svgElements, framework.svg);
  outline.setAttributeNS(null, "x", x);
  outline.setAttributeNS(null, "y", y - fillHeight);
  outline.setAttributeNS(null, "width", iconWidth);
  outline.setAttributeNS(null, "height", 2 * fillHeight);
  outline.setAttributeNS(null, "class", "vis-outline");

  //Don't call callback on icon
  DOMutil.drawPoint(x + 0.5 * iconWidth, y, getGroupTemplate(group), framework.svgElements, framework.svg);
};

/**
 *
 * @param {vis.Group} group
 * @param {any} callbackResult
 * @returns {{style: *, styles: (*|string), size: *, className: *}}
 */
function getGroupTemplate(group, callbackResult) {
  callbackResult = typeof callbackResult === 'undefined' ? {} : callbackResult;
  return {
    style: callbackResult.style || group.options.drawPoints.style,
    styles: callbackResult.styles || group.options.drawPoints.styles,
    size: callbackResult.size || group.options.drawPoints.size,
    className: callbackResult.className || group.className
  };
}

/**
 *
 * @param {Object} framework            | SVG DOM element
 * @param {vis.Group} group
 * @returns {function}
 */
function getCallback(framework, group) {
  var callback = undefined;
  // check for the graph2d onRender
  if (framework.options && framework.options.drawPoints && framework.options.drawPoints.onRender && typeof framework.options.drawPoints.onRender == 'function') {
    callback = framework.options.drawPoints.onRender;
  }

  // override it with the group onRender if defined
  if (group.group.options && group.group.options.drawPoints && group.group.options.drawPoints.onRender && typeof group.group.options.drawPoints.onRender == 'function') {
    callback = group.group.options.drawPoints.onRender;
  }
  return callback;
}

module.exports = Points;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NodeBase2 = __webpack_require__(23);

var _NodeBase3 = _interopRequireDefault(_NodeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * NOTE: This is a bad base class
 *
 * Child classes are:
 *
 *   Image       - uses *only* image methods
 *   Circle      - uses *only* _drawRawCircle
 *   CircleImage - uses all
 *
 * TODO: Refactor, move _drawRawCircle to different module, derive Circle from NodeBase
 *       Rename this to ImageBase
 *       Consolidate common code in Image and CircleImage to base class
 *
 * @extends NodeBase
 */
var CircleImageBase = function (_NodeBase) {
  (0, _inherits3['default'])(CircleImageBase, _NodeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function CircleImageBase(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, CircleImageBase);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (CircleImageBase.__proto__ || (0, _getPrototypeOf2['default'])(CircleImageBase)).call(this, options, body, labelModule));

    _this.labelOffset = 0;
    _this.selected = false;
    return _this;
  }

  /**
   *
   * @param {Object} options
   * @param {Object} [imageObj]
   * @param {Object} [imageObjAlt]
   */


  (0, _createClass3['default'])(CircleImageBase, [{
    key: 'setOptions',
    value: function setOptions(options, imageObj, imageObjAlt) {
      this.options = options;

      if (!(imageObj === undefined && imageObjAlt === undefined)) {
        this.setImages(imageObj, imageObjAlt);
      }
    }

    /**
     * Set the images for this node.
     *
     * The images can be updated after the initial setting of options;
     * therefore, this method needs to be reentrant. 
     *
     * For correct working in error cases, it is necessary to properly set
     * field 'nodes.brokenImage' in the options.
     *
     * @param {Image} imageObj  required; main image to show for this node
     * @param {Image|undefined} imageObjAlt optional; image to show when node is selected
     */

  }, {
    key: 'setImages',
    value: function setImages(imageObj, imageObjAlt) {
      if (imageObjAlt && this.selected) {
        this.imageObj = imageObjAlt;
        this.imageObjAlt = imageObj;
      } else {
        this.imageObj = imageObj;
        this.imageObjAlt = imageObjAlt;
      }
    }

    /**
     * Set selection and switch between the base and the selected image.
     *
     * Do the switch only if imageObjAlt exists.
     *
     * @param {boolean} selected value of new selected state for current node
     */

  }, {
    key: 'switchImages',
    value: function switchImages(selected) {
      var selection_changed = selected && !this.selected || !selected && this.selected;
      this.selected = selected; // Remember new selection

      if (this.imageObjAlt !== undefined && selection_changed) {
        var imageTmp = this.imageObj;
        this.imageObj = this.imageObjAlt;
        this.imageObjAlt = imageTmp;
      }
    }

    /**
     * Adjust the node dimensions for a loaded image.
     *
     * Pre: this.imageObj is valid
     */

  }, {
    key: '_resizeImage',
    value: function _resizeImage() {
      var width, height;

      if (this.options.shapeProperties.useImageSize === false) {
        // Use the size property
        var ratio_width = 1;
        var ratio_height = 1;

        // Only calculate the proper ratio if both width and height not zero
        if (this.imageObj.width && this.imageObj.height) {
          if (this.imageObj.width > this.imageObj.height) {
            ratio_width = this.imageObj.width / this.imageObj.height;
          } else {
            ratio_height = this.imageObj.height / this.imageObj.width;
          }
        }

        width = this.options.size * 2 * ratio_width;
        height = this.options.size * 2 * ratio_height;
      } else {
        // Use the image size
        width = this.imageObj.width;
        height = this.imageObj.height;
      }

      this.width = width;
      this.height = height;
      this.radius = 0.5 * this.width;
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     * @private
     */

  }, {
    key: '_drawRawCircle',
    value: function _drawRawCircle(ctx, x, y, values) {
      this.initContextForDraw(ctx, values);
      ctx.circle(x, y, values.size);
      this.performFill(ctx, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     * @private
     */

  }, {
    key: '_drawImageAtPosition',
    value: function _drawImageAtPosition(ctx, values) {
      if (this.imageObj.width != 0) {
        // draw the image
        ctx.globalAlpha = 1.0;

        // draw shadow if enabled
        this.enableShadow(ctx, values);

        var factor = 1;
        if (this.options.shapeProperties.interpolation === true) {
          factor = this.imageObj.width / this.width / this.body.view.scale;
        }

        this.imageObj.drawImageAtPosition(ctx, factor, this.left, this.top, this.width, this.height);

        // disable shadows for other elements.
        this.disableShadow(ctx, values);
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @private
     */

  }, {
    key: '_drawImageLabel',
    value: function _drawImageLabel(ctx, x, y, selected, hover) {
      var yLabel;
      var offset = 0;

      if (this.height !== undefined) {
        offset = this.height * 0.5;
        var labelDimensions = this.labelModule.getTextSize(ctx, selected, hover);
        if (labelDimensions.lineCount >= 1) {
          offset += labelDimensions.height / 2;
        }
      }

      yLabel = y + offset;

      if (this.options.label) {
        this.labelOffset = offset;
      }
      this.labelModule.draw(ctx, x, yLabel, selected, hover, 'hanging');
    }
  }]);
  return CircleImageBase;
}(_NodeBase3['default']);

exports['default'] = CircleImageBase;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(19);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _create = __webpack_require__(29);

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var Label = __webpack_require__(117)['default'];
var ComponentUtil = __webpack_require__(48)['default'];
var CubicBezierEdge = __webpack_require__(215)['default'];
var BezierEdgeDynamic = __webpack_require__(217)['default'];
var BezierEdgeStatic = __webpack_require__(218)['default'];
var StraightEdge = __webpack_require__(219)['default'];

/**
 * An edge connects two nodes and has a specific direction.
 */

var Edge = function () {
  /**
   * @param {Object} options        values specific to this edge, must contain at least 'from' and 'to'
   * @param {Object} body           shared state from Network instance
   * @param {Object} globalOptions  options from the EdgesHandler instance
   * @param {Object} defaultOptions default options from the EdgeHandler instance. Value and reference are constant
   */
  function Edge(options, body, globalOptions, defaultOptions) {
    (0, _classCallCheck3['default'])(this, Edge);

    if (body === undefined) {
      throw new Error("No body provided");
    }

    // Since globalOptions is constant in values as well as reference,
    // Following needs to be done only once.

    this.options = util.bridgeObject(globalOptions);
    this.globalOptions = globalOptions;
    this.defaultOptions = defaultOptions;
    this.body = body;

    // initialize variables
    this.id = undefined;
    this.fromId = undefined;
    this.toId = undefined;
    this.selected = false;
    this.hover = false;
    this.labelDirty = true;

    this.baseWidth = this.options.width;
    this.baseFontSize = this.options.font.size;

    this.from = undefined; // a node
    this.to = undefined; // a node

    this.edgeType = undefined;

    this.connected = false;

    this.labelModule = new Label(this.body, this.options, true /* It's an edge label */);
    this.setOptions(options);
  }

  /**
   * Set or overwrite options for the edge
   * @param {Object} options  an object with options
   * @returns {null|boolean} null if no options, boolean if date changed
   */


  (0, _createClass3['default'])(Edge, [{
    key: 'setOptions',
    value: function setOptions(options) {
      if (!options) {
        return;
      }

      Edge.parseOptions(this.options, options, true, this.globalOptions);

      if (options.id !== undefined) {
        this.id = options.id;
      }
      if (options.from !== undefined) {
        this.fromId = options.from;
      }
      if (options.to !== undefined) {
        this.toId = options.to;
      }
      if (options.title !== undefined) {
        this.title = options.title;
      }
      if (options.value !== undefined) {
        options.value = parseFloat(options.value);
      }

      var pile = [options, this.options, this.defaultOptions];
      this.chooser = ComponentUtil.choosify('edge', pile);

      // update label Module
      this.updateLabelModule(options);

      var dataChanged = this.updateEdgeType();

      // if anything has been updates, reset the selection width and the hover width
      this._setInteractionWidths();

      // A node is connected when it has a from and to node that both exist in the network.body.nodes.
      this.connect();

      if (options.hidden !== undefined || options.physics !== undefined) {
        dataChanged = true;
      }

      return dataChanged;
    }

    /**
     *
     * @param {Object} parentOptions
     * @param {Object} newOptions
     * @param {boolean} [allowDeletion=false]
     * @param {Object} [globalOptions={}]
     * @param {boolean} [copyFromGlobals=false]
     */

  }, {
    key: 'getFormattingValues',


    /**
     *
     * @returns {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}}
     */
    value: function getFormattingValues() {
      var toArrow = this.options.arrows.to === true || this.options.arrows.to.enabled === true;
      var fromArrow = this.options.arrows.from === true || this.options.arrows.from.enabled === true;
      var middleArrow = this.options.arrows.middle === true || this.options.arrows.middle.enabled === true;
      var inheritsColor = this.options.color.inherit;
      var values = {
        toArrow: toArrow,
        toArrowScale: this.options.arrows.to.scaleFactor,
        toArrowType: this.options.arrows.to.type,
        middleArrow: middleArrow,
        middleArrowScale: this.options.arrows.middle.scaleFactor,
        middleArrowType: this.options.arrows.middle.type,
        fromArrow: fromArrow,
        fromArrowScale: this.options.arrows.from.scaleFactor,
        fromArrowType: this.options.arrows.from.type,
        arrowStrikethrough: this.options.arrowStrikethrough,
        color: inheritsColor ? undefined : this.options.color.color,
        inheritsColor: inheritsColor,
        opacity: this.options.color.opacity,
        hidden: this.options.hidden,
        length: this.options.length,
        shadow: this.options.shadow.enabled,
        shadowColor: this.options.shadow.color,
        shadowSize: this.options.shadow.size,
        shadowX: this.options.shadow.x,
        shadowY: this.options.shadow.y,
        dashes: this.options.dashes,
        width: this.options.width
      };
      if (this.selected || this.hover) {
        if (this.chooser === true) {
          if (this.selected) {
            var selectedWidth = this.options.selectionWidth;
            if (typeof selectedWidth === 'function') {
              values.width = selectedWidth(values.width);
            } else if (typeof selectedWidth === 'number') {
              values.width += selectedWidth;
            }
            values.width = Math.max(values.width, 0.3 / this.body.view.scale);
            values.color = this.options.color.highlight;
            values.shadow = this.options.shadow.enabled;
          } else if (this.hover) {
            var hoverWidth = this.options.hoverWidth;
            if (typeof hoverWidth === 'function') {
              values.width = hoverWidth(values.width);
            } else if (typeof hoverWidth === 'number') {
              values.width += hoverWidth;
            }
            values.width = Math.max(values.width, 0.3 / this.body.view.scale);
            values.color = this.options.color.hover;
            values.shadow = this.options.shadow.enabled;
          }
        } else if (typeof this.chooser === 'function') {
          this.chooser(values, this.options.id, this.selected, this.hover);
          if (values.color !== undefined) {
            values.inheritsColor = false;
          }
          if (values.shadow === false) {
            if (values.shadowColor !== this.options.shadow.color || values.shadowSize !== this.options.shadow.size || values.shadowX !== this.options.shadow.x || values.shadowY !== this.options.shadow.y) {
              values.shadow = true;
            }
          }
        }
      } else {
        values.shadow = this.options.shadow.enabled;
        values.width = Math.max(values.width, 0.3 / this.body.view.scale);
      }
      return values;
    }

    /**
     * update the options in the label module
     *
     * @param {Object} options
     */

  }, {
    key: 'updateLabelModule',
    value: function updateLabelModule(options) {
      var pile = [options, this.options, this.globalOptions, // Currently set global edge options
      this.defaultOptions];

      this.labelModule.update(this.options, pile);

      if (this.labelModule.baseSize !== undefined) {
        this.baseFontSize = this.labelModule.baseSize;
      }
    }

    /**
     * update the edge type, set the options
     * @returns {boolean}
     */

  }, {
    key: 'updateEdgeType',
    value: function updateEdgeType() {
      var smooth = this.options.smooth;
      var dataChanged = false;
      var changeInType = true;
      if (this.edgeType !== undefined) {
        if (this.edgeType instanceof BezierEdgeDynamic && smooth.enabled === true && smooth.type === 'dynamic' || this.edgeType instanceof CubicBezierEdge && smooth.enabled === true && smooth.type === 'cubicBezier' || this.edgeType instanceof BezierEdgeStatic && smooth.enabled === true && smooth.type !== 'dynamic' && smooth.type !== 'cubicBezier' || this.edgeType instanceof StraightEdge && smooth.type.enabled === false) {
          changeInType = false;
        }
        if (changeInType === true) {
          dataChanged = this.cleanup();
        }
      }
      if (changeInType === true) {
        if (smooth.enabled === true) {
          if (smooth.type === 'dynamic') {
            dataChanged = true;
            this.edgeType = new BezierEdgeDynamic(this.options, this.body, this.labelModule);
          } else if (smooth.type === 'cubicBezier') {
            this.edgeType = new CubicBezierEdge(this.options, this.body, this.labelModule);
          } else {
            this.edgeType = new BezierEdgeStatic(this.options, this.body, this.labelModule);
          }
        } else {
          this.edgeType = new StraightEdge(this.options, this.body, this.labelModule);
        }
      } else {
        // if nothing changes, we just set the options.
        this.edgeType.setOptions(this.options);
      }
      return dataChanged;
    }

    /**
     * Connect an edge to its nodes
     */

  }, {
    key: 'connect',
    value: function connect() {
      this.disconnect();

      this.from = this.body.nodes[this.fromId] || undefined;
      this.to = this.body.nodes[this.toId] || undefined;
      this.connected = this.from !== undefined && this.to !== undefined;

      if (this.connected === true) {
        this.from.attachEdge(this);
        this.to.attachEdge(this);
      } else {
        if (this.from) {
          this.from.detachEdge(this);
        }
        if (this.to) {
          this.to.detachEdge(this);
        }
      }

      this.edgeType.connect();
    }

    /**
     * Disconnect an edge from its nodes
     */

  }, {
    key: 'disconnect',
    value: function disconnect() {
      if (this.from) {
        this.from.detachEdge(this);
        this.from = undefined;
      }
      if (this.to) {
        this.to.detachEdge(this);
        this.to = undefined;
      }

      this.connected = false;
    }

    /**
     * get the title of this edge.
     * @return {string} title    The title of the edge, or undefined when no title
     *                           has been set.
     */

  }, {
    key: 'getTitle',
    value: function getTitle() {
      return this.title;
    }

    /**
     * check if this node is selecte
     * @return {boolean} selected   True if node is selected, else false
     */

  }, {
    key: 'isSelected',
    value: function isSelected() {
      return this.selected;
    }

    /**
     * Retrieve the value of the edge. Can be undefined
     * @return {number} value
     */

  }, {
    key: 'getValue',
    value: function getValue() {
      return this.options.value;
    }

    /**
     * Adjust the value range of the edge. The edge will adjust it's width
     * based on its value.
     * @param {number} min
     * @param {number} max
     * @param {number} total
     */

  }, {
    key: 'setValueRange',
    value: function setValueRange(min, max, total) {
      if (this.options.value !== undefined) {
        var scale = this.options.scaling.customScalingFunction(min, max, total, this.options.value);
        var widthDiff = this.options.scaling.max - this.options.scaling.min;
        if (this.options.scaling.label.enabled === true) {
          var fontDiff = this.options.scaling.label.max - this.options.scaling.label.min;
          this.options.font.size = this.options.scaling.label.min + scale * fontDiff;
        }
        this.options.width = this.options.scaling.min + scale * widthDiff;
      } else {
        this.options.width = this.baseWidth;
        this.options.font.size = this.baseFontSize;
      }

      this._setInteractionWidths();
      this.updateLabelModule();
    }

    /**
     *
     * @private
     */

  }, {
    key: '_setInteractionWidths',
    value: function _setInteractionWidths() {
      if (typeof this.options.hoverWidth === 'function') {
        this.edgeType.hoverWidth = this.options.hoverWidth(this.options.width);
      } else {
        this.edgeType.hoverWidth = this.options.hoverWidth + this.options.width;
      }
      if (typeof this.options.selectionWidth === 'function') {
        this.edgeType.selectionWidth = this.options.selectionWidth(this.options.width);
      } else {
        this.edgeType.selectionWidth = this.options.selectionWidth + this.options.width;
      }
    }

    /**
     * Redraw a edge
     * Draw this edge in the given canvas
     * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
     * @param {CanvasRenderingContext2D}   ctx
     */

  }, {
    key: 'draw',
    value: function draw(ctx) {
      var values = this.getFormattingValues();
      if (values.hidden) {
        return;
      }

      // get the via node from the edge type
      var viaNode = this.edgeType.getViaNode();
      var arrowData = {};

      // restore edge targets to defaults
      this.edgeType.fromPoint = this.edgeType.from;
      this.edgeType.toPoint = this.edgeType.to;

      // from and to arrows give a different end point for edges. we set them here
      if (values.fromArrow) {
        arrowData.from = this.edgeType.getArrowData(ctx, 'from', viaNode, this.selected, this.hover, values);
        if (values.arrowStrikethrough === false) this.edgeType.fromPoint = arrowData.from.core;
      }
      if (values.toArrow) {
        arrowData.to = this.edgeType.getArrowData(ctx, 'to', viaNode, this.selected, this.hover, values);
        if (values.arrowStrikethrough === false) this.edgeType.toPoint = arrowData.to.core;
      }

      // the middle arrow depends on the line, which can depend on the to and from arrows so we do this one lastly.
      if (values.middleArrow) {
        arrowData.middle = this.edgeType.getArrowData(ctx, 'middle', viaNode, this.selected, this.hover, values);
      }

      // draw everything
      this.edgeType.drawLine(ctx, values, this.selected, this.hover, viaNode);
      this.drawArrows(ctx, arrowData, values);
      this.drawLabel(ctx, viaNode);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {Object} arrowData
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'drawArrows',
    value: function drawArrows(ctx, arrowData, values) {
      if (values.fromArrow) {
        this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.from);
      }
      if (values.middleArrow) {
        this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.middle);
      }
      if (values.toArrow) {
        this.edgeType.drawArrowHead(ctx, values, this.selected, this.hover, arrowData.to);
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {Node} viaNode
     */

  }, {
    key: 'drawLabel',
    value: function drawLabel(ctx, viaNode) {
      if (this.options.label !== undefined) {
        // set style
        var node1 = this.from;
        var node2 = this.to;

        if (this.labelModule.differentState(this.selected, this.hover)) {
          this.labelModule.getTextSize(ctx, this.selected, this.hover);
        }

        if (node1.id != node2.id) {
          this.labelModule.pointToSelf = false;
          var point = this.edgeType.getPoint(0.5, viaNode);
          ctx.save();

          var rotationPoint = this._getRotation(ctx);
          if (rotationPoint.angle != 0) {
            ctx.translate(rotationPoint.x, rotationPoint.y);
            ctx.rotate(rotationPoint.angle);
          }

          // draw the label
          this.labelModule.draw(ctx, point.x, point.y, this.selected, this.hover);

          /*
                  // Useful debug code: draw a border around the label
                  // This should **not** be enabled in production!
                  var size = this.labelModule.getSize();; // ;; intentional so lint catches it
                  ctx.strokeStyle = "#ff0000";
                  ctx.strokeRect(size.left, size.top, size.width, size.height);
                  // End  debug code
          */

          ctx.restore();
        } else {
          // Ignore the orientations.
          this.labelModule.pointToSelf = true;
          var x, y;
          var radius = this.options.selfReferenceSize;
          if (node1.shape.width > node1.shape.height) {
            x = node1.x + node1.shape.width * 0.5;
            y = node1.y - radius;
          } else {
            x = node1.x + radius;
            y = node1.y - node1.shape.height * 0.5;
          }
          point = this._pointOnCircle(x, y, radius, 0.125);
          this.labelModule.draw(ctx, point.x, point.y, this.selected, this.hover);
        }
      }
    }

    /**
     * Determine all visual elements of this edge instance, in which the given
     * point falls within the bounding shape.
     *
     * @param {point} point
     * @returns {Array.<edgeClickItem|edgeLabelClickItem>} list with the items which are on the point
     */

  }, {
    key: 'getItemsOnPoint',
    value: function getItemsOnPoint(point) {
      var ret = [];

      if (this.labelModule.visible()) {
        var rotationPoint = this._getRotation();
        if (ComponentUtil.pointInRect(this.labelModule.getSize(), point, rotationPoint)) {
          ret.push({ edgeId: this.id, labelId: 0 });
        }
      }

      var obj = {
        left: point.x,
        top: point.y
      };

      if (this.isOverlappingWith(obj)) {
        ret.push({ edgeId: this.id });
      }

      return ret;
    }

    /**
     * Check if this object is overlapping with the provided object
     * @param {Object} obj   an object with parameters left, top
     * @return {boolean}     True if location is located on the edge
     */

  }, {
    key: 'isOverlappingWith',
    value: function isOverlappingWith(obj) {
      if (this.connected) {
        var distMax = 10;
        var xFrom = this.from.x;
        var yFrom = this.from.y;
        var xTo = this.to.x;
        var yTo = this.to.y;
        var xObj = obj.left;
        var yObj = obj.top;

        var dist = this.edgeType.getDistanceToEdge(xFrom, yFrom, xTo, yTo, xObj, yObj);

        return dist < distMax;
      } else {
        return false;
      }
    }

    /** 
     * Determine the rotation point, if any.
     *
     * @param {CanvasRenderingContext2D} [ctx] if passed, do a recalculation of the label size
     * @returns {rotationPoint} the point to rotate around and the angle in radians to rotate
     * @private
     */

  }, {
    key: '_getRotation',
    value: function _getRotation(ctx) {
      var viaNode = this.edgeType.getViaNode();
      var point = this.edgeType.getPoint(0.5, viaNode);

      if (ctx !== undefined) {
        this.labelModule.calculateLabelSize(ctx, this.selected, this.hover, point.x, point.y);
      }

      var ret = {
        x: point.x,
        y: this.labelModule.size.yLine,
        angle: 0
      };

      if (!this.labelModule.visible()) {
        return ret; // Don't even bother doing the atan2, there's nothing to draw
      }

      if (this.options.font.align === "horizontal") {
        return ret; // No need to calculate angle
      }

      var dy = this.from.y - this.to.y;
      var dx = this.from.x - this.to.x;
      var angle = Math.atan2(dy, dx); // radians

      // rotate so that label is readable
      if (angle < -1 && dx < 0 || angle > 0 && dx < 0) {
        angle += Math.PI;
      }
      ret.angle = angle;

      return ret;
    }

    /**
     * Get a point on a circle
     * @param {number} x
     * @param {number} y
     * @param {number} radius
     * @param {number} percentage Value between 0 (line start) and 1 (line end)
     * @return {Object} point
     * @private
     */

  }, {
    key: '_pointOnCircle',
    value: function _pointOnCircle(x, y, radius, percentage) {
      var angle = percentage * 2 * Math.PI;
      return {
        x: x + radius * Math.cos(angle),
        y: y - radius * Math.sin(angle)
      };
    }

    /**
     * Sets selected state to true
     */

  }, {
    key: 'select',
    value: function select() {
      this.selected = true;
    }

    /**
     * Sets selected state to false
     */

  }, {
    key: 'unselect',
    value: function unselect() {
      this.selected = false;
    }

    /**
     * cleans all required things on delete
     * @returns {*}
     */

  }, {
    key: 'cleanup',
    value: function cleanup() {
      return this.edgeType.cleanup();
    }

    /**
     * Remove edge from the list and perform necessary cleanup.
     */

  }, {
    key: 'remove',
    value: function remove() {
      this.cleanup();
      this.disconnect();
      delete this.body.edges[this.id];
    }

    /**
     * Check if both connecting nodes exist
     * @returns {boolean}
     */

  }, {
    key: 'endPointsValid',
    value: function endPointsValid() {
      return this.body.nodes[this.fromId] !== undefined && this.body.nodes[this.toId] !== undefined;
    }
  }], [{
    key: 'parseOptions',
    value: function parseOptions(parentOptions, newOptions) {
      var allowDeletion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var globalOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var copyFromGlobals = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var fields = ['arrowStrikethrough', 'id', 'from', 'hidden', 'hoverWidth', 'labelHighlightBold', 'length', 'line', 'opacity', 'physics', 'scaling', 'selectionWidth', 'selfReferenceSize', 'to', 'title', 'value', 'width', 'font', 'chosen', 'widthConstraint'];

      // only deep extend the items in the field array. These do not have shorthand.
      util.selectiveDeepExtend(fields, parentOptions, newOptions, allowDeletion);

      // Only copy label if it's a legal value.
      if (ComponentUtil.isValidLabel(newOptions.label)) {
        parentOptions.label = newOptions.label;
      } else {
        parentOptions.label = undefined;
      }

      util.mergeOptions(parentOptions, newOptions, 'smooth', globalOptions);
      util.mergeOptions(parentOptions, newOptions, 'shadow', globalOptions);

      if (newOptions.dashes !== undefined && newOptions.dashes !== null) {
        parentOptions.dashes = newOptions.dashes;
      } else if (allowDeletion === true && newOptions.dashes === null) {
        parentOptions.dashes = (0, _create2['default'])(globalOptions.dashes); // this sets the pointer of the option back to the global option.
      }

      // set the scaling newOptions
      if (newOptions.scaling !== undefined && newOptions.scaling !== null) {
        if (newOptions.scaling.min !== undefined) {
          parentOptions.scaling.min = newOptions.scaling.min;
        }
        if (newOptions.scaling.max !== undefined) {
          parentOptions.scaling.max = newOptions.scaling.max;
        }
        util.mergeOptions(parentOptions.scaling, newOptions.scaling, 'label', globalOptions.scaling);
      } else if (allowDeletion === true && newOptions.scaling === null) {
        parentOptions.scaling = (0, _create2['default'])(globalOptions.scaling); // this sets the pointer of the option back to the global option.
      }

      // handle multiple input cases for arrows
      if (newOptions.arrows !== undefined && newOptions.arrows !== null) {
        if (typeof newOptions.arrows === 'string') {
          var arrows = newOptions.arrows.toLowerCase();
          parentOptions.arrows.to.enabled = arrows.indexOf("to") != -1;
          parentOptions.arrows.middle.enabled = arrows.indexOf("middle") != -1;
          parentOptions.arrows.from.enabled = arrows.indexOf("from") != -1;
        } else if ((0, _typeof3['default'])(newOptions.arrows) === 'object') {
          util.mergeOptions(parentOptions.arrows, newOptions.arrows, 'to', globalOptions.arrows);
          util.mergeOptions(parentOptions.arrows, newOptions.arrows, 'middle', globalOptions.arrows);
          util.mergeOptions(parentOptions.arrows, newOptions.arrows, 'from', globalOptions.arrows);
        } else {
          throw new Error("The arrow newOptions can only be an object or a string. Refer to the documentation. You used:" + (0, _stringify2['default'])(newOptions.arrows));
        }
      } else if (allowDeletion === true && newOptions.arrows === null) {
        parentOptions.arrows = (0, _create2['default'])(globalOptions.arrows); // this sets the pointer of the option back to the global option.
      }

      // handle multiple input cases for color
      if (newOptions.color !== undefined && newOptions.color !== null) {
        var fromColor = newOptions.color;
        var toColor = parentOptions.color;

        // If passed, fill in values from default options - required in the case of no prototype bridging
        if (copyFromGlobals) {
          util.deepExtend(toColor, globalOptions.color, false, allowDeletion);
        } else {
          // Clear local properties - need to do it like this in order to retain prototype bridges
          for (var i in toColor) {
            if (toColor.hasOwnProperty(i)) {
              delete toColor[i];
            }
          }
        }

        if (util.isString(toColor)) {
          toColor.color = toColor;
          toColor.highlight = toColor;
          toColor.hover = toColor;
          toColor.inherit = false;
          if (fromColor.opacity === undefined) {
            toColor.opacity = 1.0; // set default
          }
        } else {
          var colorsDefined = false;
          if (fromColor.color !== undefined) {
            toColor.color = fromColor.color;colorsDefined = true;
          }
          if (fromColor.highlight !== undefined) {
            toColor.highlight = fromColor.highlight;colorsDefined = true;
          }
          if (fromColor.hover !== undefined) {
            toColor.hover = fromColor.hover;colorsDefined = true;
          }
          if (fromColor.inherit !== undefined) {
            toColor.inherit = fromColor.inherit;
          }
          if (fromColor.opacity !== undefined) {
            toColor.opacity = Math.min(1, Math.max(0, fromColor.opacity));
          }

          if (colorsDefined === true) {
            toColor.inherit = false;
          } else {
            if (toColor.inherit === undefined) {
              toColor.inherit = 'from'; // Set default
            }
          }
        }
      } else if (allowDeletion === true && newOptions.color === null) {
        parentOptions.color = util.bridgeObject(globalOptions.color); // set the object back to the global options
      }

      if (allowDeletion === true && newOptions.font === null) {
        parentOptions.font = util.bridgeObject(globalOptions.font); // set the object back to the global options
      }
    }
  }]);
  return Edge;
}();

exports['default'] = Edge;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _EdgeBase2 = __webpack_require__(118);

var _EdgeBase3 = _interopRequireDefault(_EdgeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * The Base Class for all Bezier edges. Bezier curves are used to model smooth
 * gradual curves in paths between nodes.
 *
 * @extends EdgeBase
 */
var BezierEdgeBase = function (_EdgeBase) {
  (0, _inherits3['default'])(BezierEdgeBase, _EdgeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function BezierEdgeBase(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, BezierEdgeBase);
    return (0, _possibleConstructorReturn3['default'])(this, (BezierEdgeBase.__proto__ || (0, _getPrototypeOf2['default'])(BezierEdgeBase)).call(this, options, body, labelModule));
  }

  /**
   * This function uses binary search to look for the point where the bezier curve crosses the border of the node.
   *
   * @param {Node} nearNode
   * @param {CanvasRenderingContext2D} ctx
   * @param {Node} viaNode
   * @returns {*}
   * @private
   */


  (0, _createClass3['default'])(BezierEdgeBase, [{
    key: '_findBorderPositionBezier',
    value: function _findBorderPositionBezier(nearNode, ctx) {
      var viaNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._getViaCoordinates();

      var maxIterations = 10;
      var iteration = 0;
      var low = 0;
      var high = 1;
      var pos, angle, distanceToBorder, distanceToPoint, difference;
      var threshold = 0.2;
      var node = this.to;
      var from = false;
      if (nearNode.id === this.from.id) {
        node = this.from;
        from = true;
      }

      while (low <= high && iteration < maxIterations) {
        var middle = (low + high) * 0.5;

        pos = this.getPoint(middle, viaNode);
        angle = Math.atan2(node.y - pos.y, node.x - pos.x);
        distanceToBorder = node.distanceToBorder(ctx, angle);
        distanceToPoint = Math.sqrt(Math.pow(pos.x - node.x, 2) + Math.pow(pos.y - node.y, 2));
        difference = distanceToBorder - distanceToPoint;
        if (Math.abs(difference) < threshold) {
          break; // found
        } else if (difference < 0) {
          // distance to nodes is larger than distance to border --> t needs to be bigger if we're looking at the to node.
          if (from === false) {
            low = middle;
          } else {
            high = middle;
          }
        } else {
          if (from === false) {
            high = middle;
          } else {
            low = middle;
          }
        }

        iteration++;
      }
      pos.t = middle;

      return pos;
    }

    /**
     * Calculate the distance between a point (x3,y3) and a line segment from
     * (x1,y1) to (x2,y2).
     * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
     * @param {number} x1 from x
     * @param {number} y1 from y
     * @param {number} x2 to x
     * @param {number} y2 to y
     * @param {number} x3 point to check x
     * @param {number} y3 point to check y
     * @param {Node} via
     * @returns {number}
     * @private
     */

  }, {
    key: '_getDistanceToBezierEdge',
    value: function _getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, via) {
      // x3,y3 is the point
      var minDistance = 1e9;
      var distance = void 0;
      var i = void 0,
          t = void 0,
          x = void 0,
          y = void 0;
      var lastX = x1;
      var lastY = y1;
      for (i = 1; i < 10; i++) {
        t = 0.1 * i;
        x = Math.pow(1 - t, 2) * x1 + 2 * t * (1 - t) * via.x + Math.pow(t, 2) * x2;
        y = Math.pow(1 - t, 2) * y1 + 2 * t * (1 - t) * via.y + Math.pow(t, 2) * y2;
        if (i > 0) {
          distance = this._getDistanceToLine(lastX, lastY, x, y, x3, y3);
          minDistance = distance < minDistance ? distance : minDistance;
        }
        lastX = x;
        lastY = y;
      }

      return minDistance;
    }

    /**
     * Draw a bezier curve between two nodes
     *
     * The method accepts zero, one or two control points.
     * Passing zero control points just draws a straight line
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {Object}           values   | options for shadow drawing
     * @param {Object|undefined} viaNode1 | first control point for curve drawing
     * @param {Object|undefined} viaNode2 | second control point for curve drawing
     *
     * @protected
     */

  }, {
    key: '_bezierCurve',
    value: function _bezierCurve(ctx, values, viaNode1, viaNode2) {
      var hasNode1 = viaNode1 !== undefined && viaNode1.x !== undefined;
      var hasNode2 = viaNode2 !== undefined && viaNode2.x !== undefined;

      ctx.beginPath();
      ctx.moveTo(this.fromPoint.x, this.fromPoint.y);

      if (hasNode1 && hasNode2) {
        ctx.bezierCurveTo(viaNode1.x, viaNode1.y, viaNode2.x, viaNode2.y, this.toPoint.x, this.toPoint.y);
      } else if (hasNode1) {
        ctx.quadraticCurveTo(viaNode1.x, viaNode1.y, this.toPoint.x, this.toPoint.y);
      } else {
        // fallback to normal straight edge
        ctx.lineTo(this.toPoint.x, this.toPoint.y);
      }

      // draw shadow if enabled
      this.enableShadow(ctx, values);
      ctx.stroke();
      this.disableShadow(ctx, values);
    }

    /**
     *
     * @returns {*|{x, y}|{x: undefined, y: undefined}}
     */

  }, {
    key: 'getViaNode',
    value: function getViaNode() {
      return this._getViaCoordinates();
    }
  }]);
  return BezierEdgeBase;
}(_EdgeBase3['default']);

exports['default'] = BezierEdgeBase;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var util = __webpack_require__(2);

/**
 * Utility Class
 */

var NetworkUtil = function () {
  /**
   * @ignore
   */
  function NetworkUtil() {
    (0, _classCallCheck3["default"])(this, NetworkUtil);
  }

  /**
   * Find the center position of the network considering the bounding boxes
   *
   * @param {Array.<Node>} allNodes
   * @param {Array.<Node>} [specificNodes=[]]
   * @returns {{minX: number, maxX: number, minY: number, maxY: number}}
   * @static
   */


  (0, _createClass3["default"])(NetworkUtil, null, [{
    key: "getRange",
    value: function getRange(allNodes) {
      var specificNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var minY = 1e9,
          maxY = -1e9,
          minX = 1e9,
          maxX = -1e9,
          node;
      if (specificNodes.length > 0) {
        for (var i = 0; i < specificNodes.length; i++) {
          node = allNodes[specificNodes[i]];
          if (minX > node.shape.boundingBox.left) {
            minX = node.shape.boundingBox.left;
          }
          if (maxX < node.shape.boundingBox.right) {
            maxX = node.shape.boundingBox.right;
          }
          if (minY > node.shape.boundingBox.top) {
            minY = node.shape.boundingBox.top;
          } // top is negative, bottom is positive
          if (maxY < node.shape.boundingBox.bottom) {
            maxY = node.shape.boundingBox.bottom;
          } // top is negative, bottom is positive
        }
      }

      if (minX === 1e9 && maxX === -1e9 && minY === 1e9 && maxY === -1e9) {
        minY = 0, maxY = 0, minX = 0, maxX = 0;
      }
      return { minX: minX, maxX: maxX, minY: minY, maxY: maxY };
    }

    /**
     * Find the center position of the network
     *
     * @param {Array.<Node>} allNodes
     * @param {Array.<Node>} [specificNodes=[]]
     * @returns {{minX: number, maxX: number, minY: number, maxY: number}}
     * @static
     */

  }, {
    key: "getRangeCore",
    value: function getRangeCore(allNodes) {
      var specificNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var minY = 1e9,
          maxY = -1e9,
          minX = 1e9,
          maxX = -1e9,
          node;
      if (specificNodes.length > 0) {
        for (var i = 0; i < specificNodes.length; i++) {
          node = allNodes[specificNodes[i]];
          if (minX > node.x) {
            minX = node.x;
          }
          if (maxX < node.x) {
            maxX = node.x;
          }
          if (minY > node.y) {
            minY = node.y;
          } // top is negative, bottom is positive
          if (maxY < node.y) {
            maxY = node.y;
          } // top is negative, bottom is positive
        }
      }

      if (minX === 1e9 && maxX === -1e9 && minY === 1e9 && maxY === -1e9) {
        minY = 0, maxY = 0, minX = 0, maxX = 0;
      }
      return { minX: minX, maxX: maxX, minY: minY, maxY: maxY };
    }

    /**
     * @param {object} range = {minX: minX, maxX: maxX, minY: minY, maxY: maxY};
     * @returns {{x: number, y: number}}
     * @static
     */

  }, {
    key: "findCenter",
    value: function findCenter(range) {
      return { x: 0.5 * (range.maxX + range.minX),
        y: 0.5 * (range.maxY + range.minY) };
    }

    /**
     * This returns a clone of the options or options of the edge or node to be used for construction of new edges or check functions for new nodes.
     * @param {vis.Item} item
     * @param {'node'|undefined} type
     * @returns {{}}
     * @static
     */

  }, {
    key: "cloneOptions",
    value: function cloneOptions(item, type) {
      var clonedOptions = {};
      if (type === undefined || type === 'node') {
        util.deepExtend(clonedOptions, item.options, true);
        clonedOptions.x = item.x;
        clonedOptions.y = item.y;
        clonedOptions.amountOfConnections = item.edges.length;
      } else {
        util.deepExtend(clonedOptions, item.options, true);
      }
      return clonedOptions;
    }
  }]);
  return NetworkUtil;
}();

exports["default"] = NetworkUtil;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(124), __esModule: true };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(50);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(52);
var $export = __webpack_require__(17);
var redefine = __webpack_require__(83);
var hide = __webpack_require__(26);
var has = __webpack_require__(22);
var Iterators = __webpack_require__(31);
var $iterCreate = __webpack_require__(129);
var setToStringTag = __webpack_require__(59);
var getPrototypeOf = __webpack_require__(85);
var ITERATOR = __webpack_require__(13)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(128);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(21) && !__webpack_require__(28)(function () {
  return Object.defineProperty(__webpack_require__(82)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(32);
var document = __webpack_require__(18).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(26);


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(22);
var toIObject = __webpack_require__(25);
var arrayIndexOf = __webpack_require__(131)(false);
var IE_PROTO = __webpack_require__(56)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(22);
var toObject = __webpack_require__(41);
var IE_PROTO = __webpack_require__(56)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(50);
var TAG = __webpack_require__(13)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(17);
var core = __webpack_require__(7);
var fails = __webpack_require__(28);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(84);
var hiddenKeys = __webpack_require__(58).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(42);
var createDesc = __webpack_require__(39);
var toIObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(53);
var has = __webpack_require__(22);
var IE8_DOM_DEFINE = __webpack_require__(81);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(21) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(162), __esModule: true };

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @prototype Point2d
 * @param {number} [x]
 * @param {number} [y]
 */
function Point2d(x, y) {
  this.x = x !== undefined ? x : 0;
  this.y = y !== undefined ? y : 0;
}

module.exports = Point2d;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(2);

/**
 * An html slider control with start/stop/prev/next buttons
 *
 * @constructor Slider
 * @param {Element} container  The element where the slider will be created
 * @param {Object} options   Available options:
 *                 {boolean} visible   If true (default) the
 *                           slider is visible.
 */
function Slider(container, options) {
  if (container === undefined) {
    throw new Error('No container element defined');
  }
  this.container = container;
  this.visible = options && options.visible != undefined ? options.visible : true;

  if (this.visible) {
    this.frame = document.createElement('DIV');
    //this.frame.style.backgroundColor = '#E5E5E5';
    this.frame.style.width = '100%';
    this.frame.style.position = 'relative';
    this.container.appendChild(this.frame);

    this.frame.prev = document.createElement('INPUT');
    this.frame.prev.type = 'BUTTON';
    this.frame.prev.value = 'Prev';
    this.frame.appendChild(this.frame.prev);

    this.frame.play = document.createElement('INPUT');
    this.frame.play.type = 'BUTTON';
    this.frame.play.value = 'Play';
    this.frame.appendChild(this.frame.play);

    this.frame.next = document.createElement('INPUT');
    this.frame.next.type = 'BUTTON';
    this.frame.next.value = 'Next';
    this.frame.appendChild(this.frame.next);

    this.frame.bar = document.createElement('INPUT');
    this.frame.bar.type = 'BUTTON';
    this.frame.bar.style.position = 'absolute';
    this.frame.bar.style.border = '1px solid red';
    this.frame.bar.style.width = '100px';
    this.frame.bar.style.height = '6px';
    this.frame.bar.style.borderRadius = '2px';
    this.frame.bar.style.MozBorderRadius = '2px';
    this.frame.bar.style.border = '1px solid #7F7F7F';
    this.frame.bar.style.backgroundColor = '#E5E5E5';
    this.frame.appendChild(this.frame.bar);

    this.frame.slide = document.createElement('INPUT');
    this.frame.slide.type = 'BUTTON';
    this.frame.slide.style.margin = '0px';
    this.frame.slide.value = ' ';
    this.frame.slide.style.position = 'relative';
    this.frame.slide.style.left = '-100px';
    this.frame.appendChild(this.frame.slide);

    // create events
    var me = this;
    this.frame.slide.onmousedown = function (event) {
      me._onMouseDown(event);
    };
    this.frame.prev.onclick = function (event) {
      me.prev(event);
    };
    this.frame.play.onclick = function (event) {
      me.togglePlay(event);
    };
    this.frame.next.onclick = function (event) {
      me.next(event);
    };
  }

  this.onChangeCallback = undefined;

  this.values = [];
  this.index = undefined;

  this.playTimeout = undefined;
  this.playInterval = 1000; // milliseconds
  this.playLoop = true;
}

/**
 * Select the previous index
 */
Slider.prototype.prev = function () {
  var index = this.getIndex();
  if (index > 0) {
    index--;
    this.setIndex(index);
  }
};

/**
 * Select the next index
 */
Slider.prototype.next = function () {
  var index = this.getIndex();
  if (index < this.values.length - 1) {
    index++;
    this.setIndex(index);
  }
};

/**
 * Select the next index
 */
Slider.prototype.playNext = function () {
  var start = new Date();

  var index = this.getIndex();
  if (index < this.values.length - 1) {
    index++;
    this.setIndex(index);
  } else if (this.playLoop) {
    // jump to the start
    index = 0;
    this.setIndex(index);
  }

  var end = new Date();
  var diff = end - start;

  // calculate how much time it to to set the index and to execute the callback
  // function.
  var interval = Math.max(this.playInterval - diff, 0);
  // document.title = diff // TODO: cleanup

  var me = this;
  this.playTimeout = setTimeout(function () {
    me.playNext();
  }, interval);
};

/**
 * Toggle start or stop playing
 */
Slider.prototype.togglePlay = function () {
  if (this.playTimeout === undefined) {
    this.play();
  } else {
    this.stop();
  }
};

/**
 * Start playing
 */
Slider.prototype.play = function () {
  // Test whether already playing
  if (this.playTimeout) return;

  this.playNext();

  if (this.frame) {
    this.frame.play.value = 'Stop';
  }
};

/**
 * Stop playing
 */
Slider.prototype.stop = function () {
  clearInterval(this.playTimeout);
  this.playTimeout = undefined;

  if (this.frame) {
    this.frame.play.value = 'Play';
  }
};

/**
 * Set a callback function which will be triggered when the value of the
 * slider bar has changed.
 *
 * @param {function} callback
 */
Slider.prototype.setOnChangeCallback = function (callback) {
  this.onChangeCallback = callback;
};

/**
 * Set the interval for playing the list
 * @param {number} interval   The interval in milliseconds
 */
Slider.prototype.setPlayInterval = function (interval) {
  this.playInterval = interval;
};

/**
 * Retrieve the current play interval
 * @return {number} interval   The interval in milliseconds
 */
Slider.prototype.getPlayInterval = function () {
  return this.playInterval;
};

/**
 * Set looping on or off
 * @param {boolean} doLoop  If true, the slider will jump to the start when
 *               the end is passed, and will jump to the end
 *               when the start is passed.
 *
 */
Slider.prototype.setPlayLoop = function (doLoop) {
  this.playLoop = doLoop;
};

/**
 * Execute the onchange callback function
 */
Slider.prototype.onChange = function () {
  if (this.onChangeCallback !== undefined) {
    this.onChangeCallback();
  }
};

/**
 * redraw the slider on the correct place
 */
Slider.prototype.redraw = function () {
  if (this.frame) {
    // resize the bar
    this.frame.bar.style.top = this.frame.clientHeight / 2 - this.frame.bar.offsetHeight / 2 + 'px';
    this.frame.bar.style.width = this.frame.clientWidth - this.frame.prev.clientWidth - this.frame.play.clientWidth - this.frame.next.clientWidth - 30 + 'px';

    // position the slider button
    var left = this.indexToLeft(this.index);
    this.frame.slide.style.left = left + 'px';
  }
};

/**
 * Set the list with values for the slider
 * @param {Array} values   A javascript array with values (any type)
 */
Slider.prototype.setValues = function (values) {
  this.values = values;

  if (this.values.length > 0) this.setIndex(0);else this.index = undefined;
};

/**
 * Select a value by its index
 * @param {number} index
 */
Slider.prototype.setIndex = function (index) {
  if (index < this.values.length) {
    this.index = index;

    this.redraw();
    this.onChange();
  } else {
    throw new Error('Index out of range');
  }
};

/**
 * retrieve the index of the currently selected vaue
 * @return {number} index
 */
Slider.prototype.getIndex = function () {
  return this.index;
};

/**
 * retrieve the currently selected value
 * @return {*} value
 */
Slider.prototype.get = function () {
  return this.values[this.index];
};

Slider.prototype._onMouseDown = function (event) {
  // only react on left mouse button down
  var leftButtonDown = event.which ? event.which === 1 : event.button === 1;
  if (!leftButtonDown) return;

  this.startClientX = event.clientX;
  this.startSlideX = parseFloat(this.frame.slide.style.left);

  this.frame.style.cursor = 'move';

  // add event listeners to handle moving the contents
  // we store the function onmousemove and onmouseup in the graph, so we can
  // remove the eventlisteners lateron in the function mouseUp()
  var me = this;
  this.onmousemove = function (event) {
    me._onMouseMove(event);
  };
  this.onmouseup = function (event) {
    me._onMouseUp(event);
  };
  util.addEventListener(document, 'mousemove', this.onmousemove);
  util.addEventListener(document, 'mouseup', this.onmouseup);
  util.preventDefault(event);
};

Slider.prototype.leftToIndex = function (left) {
  var width = parseFloat(this.frame.bar.style.width) - this.frame.slide.clientWidth - 10;
  var x = left - 3;

  var index = Math.round(x / width * (this.values.length - 1));
  if (index < 0) index = 0;
  if (index > this.values.length - 1) index = this.values.length - 1;

  return index;
};

Slider.prototype.indexToLeft = function (index) {
  var width = parseFloat(this.frame.bar.style.width) - this.frame.slide.clientWidth - 10;

  var x = index / (this.values.length - 1) * width;
  var left = x + 3;

  return left;
};

Slider.prototype._onMouseMove = function (event) {
  var diff = event.clientX - this.startClientX;
  var x = this.startSlideX + diff;

  var index = this.leftToIndex(x);

  this.setIndex(index);

  util.preventDefault();
};

Slider.prototype._onMouseUp = function (event) {
  // eslint-disable-line no-unused-vars
  this.frame.style.cursor = 'auto';

  // remove event listeners
  util.removeEventListener(document, 'mousemove', this.onmousemove);
  util.removeEventListener(document, 'mouseup', this.onmouseup);

  util.preventDefault();
};

module.exports = Slider;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @prototype StepNumber
 * The class StepNumber is an iterator for Numbers. You provide a start and end
 * value, and a best step size. StepNumber itself rounds to fixed values and
 * a finds the step that best fits the provided step.
 *
 * If prettyStep is true, the step size is chosen as close as possible to the
 * provided step, but being a round value like 1, 2, 5, 10, 20, 50, ....
 *
 * Example usage:
 *   var step = new StepNumber(0, 10, 2.5, true);
 *   step.start();
 *   while (!step.end()) {
 *   alert(step.getCurrent());
 *   step.next();
 *   }
 *
 * Version: 1.0
 *
 * @param {number} start     The start value
 * @param {number} end     The end value
 * @param {number} step    Optional. Step size. Must be a positive value.
 * @param {boolean} prettyStep Optional. If true, the step size is rounded
 *               To a pretty step size (like 1, 2, 5, 10, 20, 50, ...)
 */
function StepNumber(start, end, step, prettyStep) {
  // set default values
  this._start = 0;
  this._end = 0;
  this._step = 1;
  this.prettyStep = true;
  this.precision = 5;

  this._current = 0;
  this.setRange(start, end, step, prettyStep);
}

/**
 * Check for input values, to prevent disasters from happening
 *
 * Source: http://stackoverflow.com/a/1830844
 *
 * @param {string} n
 * @returns {boolean}
 */
StepNumber.prototype.isNumeric = function (n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

/**
 * Set a new range: start, end and step.
 *
 * @param {number} start     The start value
 * @param {number} end     The end value
 * @param {number} step    Optional. Step size. Must be a positive value.
 * @param {boolean} prettyStep Optional. If true, the step size is rounded
 *               To a pretty step size (like 1, 2, 5, 10, 20, 50, ...)
 */
StepNumber.prototype.setRange = function (start, end, step, prettyStep) {
  if (!this.isNumeric(start)) {
    throw new Error('Parameter \'start\' is not numeric; value: ' + start);
  }
  if (!this.isNumeric(end)) {
    throw new Error('Parameter \'end\' is not numeric; value: ' + start);
  }
  if (!this.isNumeric(step)) {
    throw new Error('Parameter \'step\' is not numeric; value: ' + start);
  }

  this._start = start ? start : 0;
  this._end = end ? end : 0;

  this.setStep(step, prettyStep);
};

/**
 * Set a new step size
 * @param {number} step    New step size. Must be a positive value
 * @param {boolean} prettyStep Optional. If true, the provided step is rounded
 *               to a pretty step size (like 1, 2, 5, 10, 20, 50, ...)
 */
StepNumber.prototype.setStep = function (step, prettyStep) {
  if (step === undefined || step <= 0) return;

  if (prettyStep !== undefined) this.prettyStep = prettyStep;

  if (this.prettyStep === true) this._step = StepNumber.calculatePrettyStep(step);else this._step = step;
};

/**
 * Calculate a nice step size, closest to the desired step size.
 * Returns a value in one of the ranges 1*10^n, 2*10^n, or 5*10^n, where n is an
 * integer Number. For example 1, 2, 5, 10, 20, 50, etc...
 * @param {number}  step  Desired step size
 * @return {number}     Nice step size
 */
StepNumber.calculatePrettyStep = function (step) {
  var log10 = function log10(x) {
    return Math.log(x) / Math.LN10;
  };

  // try three steps (multiple of 1, 2, or 5
  var step1 = Math.pow(10, Math.round(log10(step))),
      step2 = 2 * Math.pow(10, Math.round(log10(step / 2))),
      step5 = 5 * Math.pow(10, Math.round(log10(step / 5)));

  // choose the best step (closest to minimum step)
  var prettyStep = step1;
  if (Math.abs(step2 - step) <= Math.abs(prettyStep - step)) prettyStep = step2;
  if (Math.abs(step5 - step) <= Math.abs(prettyStep - step)) prettyStep = step5;

  // for safety
  if (prettyStep <= 0) {
    prettyStep = 1;
  }

  return prettyStep;
};

/**
 * returns the current value of the step
 * @return {number} current value
 */
StepNumber.prototype.getCurrent = function () {
  return parseFloat(this._current.toPrecision(this.precision));
};

/**
 * returns the current step size
 * @return {number} current step size
 */
StepNumber.prototype.getStep = function () {
  return this._step;
};

/**
 * Set the current to its starting value.
 *
 * By default, this will be the largest value smaller than start, which
 * is a multiple of the step size.
 *
 * Parameters checkFirst is optional, default false.
 * If set to true, move the current value one step if smaller than start.
 *
 * @param {boolean} [checkFirst=false]
 */
StepNumber.prototype.start = function (checkFirst) {
  if (checkFirst === undefined) {
    checkFirst = false;
  }

  this._current = this._start - this._start % this._step;

  if (checkFirst) {
    if (this.getCurrent() < this._start) {
      this.next();
    }
  }
};

/**
 * Do a step, add the step size to the current value
 */
StepNumber.prototype.next = function () {
  this._current += this._step;
};

/**
 * Returns true whether the end is reached
 * @return {boolean}  True if the current value has passed the end value.
 */
StepNumber.prototype.end = function () {
  return this._current > this._end;
};

module.exports = StepNumber;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

////////////////////////////////////////////////////////////////////////////////
// This modules handles the options for Graph3d.
//
////////////////////////////////////////////////////////////////////////////////
var util = __webpack_require__(2);
var Camera = __webpack_require__(95);
var Point3d = __webpack_require__(34);

// enumerate the available styles
var STYLE = {
  BAR: 0,
  BARCOLOR: 1,
  BARSIZE: 2,
  DOT: 3,
  DOTLINE: 4,
  DOTCOLOR: 5,
  DOTSIZE: 6,
  GRID: 7,
  LINE: 8,
  SURFACE: 9
};

// The string representations of the styles
var STYLENAME = {
  'dot': STYLE.DOT,
  'dot-line': STYLE.DOTLINE,
  'dot-color': STYLE.DOTCOLOR,
  'dot-size': STYLE.DOTSIZE,
  'line': STYLE.LINE,
  'grid': STYLE.GRID,
  'surface': STYLE.SURFACE,
  'bar': STYLE.BAR,
  'bar-color': STYLE.BARCOLOR,
  'bar-size': STYLE.BARSIZE
};

/**
 * Field names in the options hash which are of relevance to the user.
 *
 * Specifically, these are the fields which require no special handling,
 * and can be directly copied over.
 */
var OPTIONKEYS = ['width', 'height', 'filterLabel', 'legendLabel', 'xLabel', 'yLabel', 'zLabel', 'xValueLabel', 'yValueLabel', 'zValueLabel', 'showXAxis', 'showYAxis', 'showZAxis', 'showGrid', 'showPerspective', 'showShadow', 'keepAspectRatio', 'verticalRatio', 'dotSizeRatio', 'dotSizeMinFraction', 'dotSizeMaxFraction', 'showAnimationControls', 'animationInterval', 'animationPreload', 'animationAutoStart', 'axisColor', 'gridColor', 'xCenter', 'yCenter'];

/**
 * Field names in the options hash which are of relevance to the user.
 *
 * Same as OPTIONKEYS, but internally these fields are stored with 
 * prefix 'default' in the name.
 */
var PREFIXEDOPTIONKEYS = ['xBarWidth', 'yBarWidth', 'valueMin', 'valueMax', 'xMin', 'xMax', 'xStep', 'yMin', 'yMax', 'yStep', 'zMin', 'zMax', 'zStep'];

// Placeholder for DEFAULTS reference
var DEFAULTS = undefined;

/**
 * Check if given hash is empty.
 *
 * Source: http://stackoverflow.com/a/679937
 *
 * @param {object} obj
 * @returns {boolean}
 */
function isEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }

  return true;
}

/**
 * Make first letter of parameter upper case.
 *
 * Source: http://stackoverflow.com/a/1026087
 *
 * @param {string} str
 * @returns {string}
 */
function capitalize(str) {
  if (str === undefined || str === "" || typeof str != "string") {
    return str;
  }

  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Add a prefix to a field name, taking style guide into account
 *
 * @param {string} prefix
 * @param {string} fieldName
 * @returns {string}
 */
function prefixFieldName(prefix, fieldName) {
  if (prefix === undefined || prefix === "") {
    return fieldName;
  }

  return prefix + capitalize(fieldName);
}

/**
 * Forcibly copy fields from src to dst in a controlled manner.
 *
 * A given field in dst will always be overwitten. If this field
 * is undefined or not present in src, the field in dst will 
 * be explicitly set to undefined.
 * 
 * The intention here is to be able to reset all option fields.
 * 
 * Only the fields mentioned in array 'fields' will be handled.
 *
 * @param {object} src
 * @param {object} dst
 * @param {array<string>} fields array with names of fields to copy
 * @param {string} [prefix] prefix to use for the target fields.
 */
function forceCopy(src, dst, fields, prefix) {
  var srcKey;
  var dstKey;

  for (var i = 0; i < fields.length; ++i) {
    srcKey = fields[i];
    dstKey = prefixFieldName(prefix, srcKey);

    dst[dstKey] = src[srcKey];
  }
}

/**
 * Copy fields from src to dst in a safe and controlled manner.
 *
 * Only the fields mentioned in array 'fields' will be copied over,
 * and only if these are actually defined.
 *
 * @param {object} src
 * @param {object} dst
 * @param {array<string>} fields array with names of fields to copy
 * @param {string} [prefix] prefix to use for the target fields.
 */
function safeCopy(src, dst, fields, prefix) {
  var srcKey;
  var dstKey;

  for (var i = 0; i < fields.length; ++i) {
    srcKey = fields[i];
    if (src[srcKey] === undefined) continue;

    dstKey = prefixFieldName(prefix, srcKey);

    dst[dstKey] = src[srcKey];
  }
}

/**
 * Initialize dst with the values in src.
 *
 * src is the hash with the default values. 
 * A reference DEFAULTS to this hash is stored locally for 
 * further handling.
 *
 * For now, dst is assumed to be a Graph3d instance.
 * @param {object} src
 * @param {object} dst
 */
function setDefaults(src, dst) {
  if (src === undefined || isEmpty(src)) {
    throw new Error('No DEFAULTS passed');
  }
  if (dst === undefined) {
    throw new Error('No dst passed');
  }

  // Remember defaults for future reference
  DEFAULTS = src;

  // Handle the defaults which can be simply copied over
  forceCopy(src, dst, OPTIONKEYS);
  forceCopy(src, dst, PREFIXEDOPTIONKEYS, 'default');

  // Handle the more complex ('special') fields
  setSpecialSettings(src, dst);

  // Following are internal fields, not part of the user settings
  dst.margin = 10; // px
  dst.showGrayBottom = false; // TODO: this does not work correctly
  dst.showTooltip = false;
  dst.onclick_callback = null;
  dst.eye = new Point3d(0, 0, -1); // TODO: set eye.z about 3/4 of the width of the window?
}

/**
 *
 * @param {object} options
 * @param {object} dst
 */
function setOptions(options, dst) {
  if (options === undefined) {
    return;
  }
  if (dst === undefined) {
    throw new Error('No dst passed');
  }

  if (DEFAULTS === undefined || isEmpty(DEFAULTS)) {
    throw new Error('DEFAULTS not set for module Settings');
  }

  // Handle the parameters which can be simply copied over
  safeCopy(options, dst, OPTIONKEYS);
  safeCopy(options, dst, PREFIXEDOPTIONKEYS, 'default');

  // Handle the more complex ('special') fields
  setSpecialSettings(options, dst);
}

/**
 * Special handling for certain parameters
 *
 * 'Special' here means: setting requires more than a simple copy
 *
 * @param {object} src
 * @param {object} dst
 */
function setSpecialSettings(src, dst) {
  if (src.backgroundColor !== undefined) {
    setBackgroundColor(src.backgroundColor, dst);
  }

  setDataColor(src.dataColor, dst);
  setStyle(src.style, dst);
  setShowLegend(src.showLegend, dst);
  setCameraPosition(src.cameraPosition, dst);

  // As special fields go, this is an easy one; just a translation of the name.
  // Can't use this.tooltip directly, because that field exists internally
  if (src.tooltip !== undefined) {
    dst.showTooltip = src.tooltip;
  }
  if (src.onclick != undefined) {
    dst.onclick_callback = src.onclick;
  }

  if (src.tooltipStyle !== undefined) {
    util.selectiveDeepExtend(['tooltipStyle'], dst, src);
  }
}

/**
 * Set the value of setting 'showLegend'
 *
 * This depends on the value of the style fields, so it must be called
 * after the style field has been initialized.
 *
 * @param {boolean} showLegend
 * @param {object} dst
 */
function setShowLegend(showLegend, dst) {
  if (showLegend === undefined) {
    // If the default was auto, make a choice for this field
    var isAutoByDefault = DEFAULTS.showLegend === undefined;

    if (isAutoByDefault) {
      // these styles default to having legends
      var isLegendGraphStyle = dst.style === STYLE.DOTCOLOR || dst.style === STYLE.DOTSIZE;

      dst.showLegend = isLegendGraphStyle;
    } else {
      // Leave current value as is
    }
  } else {
    dst.showLegend = showLegend;
  }
}

/**
 * Retrieve the style index from given styleName
 * @param {string} styleName  Style name such as 'dot', 'grid', 'dot-line'
 * @return {number} styleNumber Enumeration value representing the style, or -1
 *                when not found
 */
function getStyleNumberByName(styleName) {
  var number = STYLENAME[styleName];

  if (number === undefined) {
    return -1;
  }

  return number;
}

/**
 * Check if given number is a valid style number.
 *
 * @param {string | number} style
 * @return {boolean} true if valid, false otherwise
 */
function checkStyleNumber(style) {
  var valid = false;

  for (var n in STYLE) {
    if (STYLE[n] === style) {
      valid = true;
      break;
    }
  }

  return valid;
}

/**
 *
 * @param {string | number} style
 * @param {Object} dst
 */
function setStyle(style, dst) {
  if (style === undefined) {
    return; // Nothing to do
  }

  var styleNumber;

  if (typeof style === 'string') {
    styleNumber = getStyleNumberByName(style);

    if (styleNumber === -1) {
      throw new Error('Style \'' + style + '\' is invalid');
    }
  } else {
    // Do a pedantic check on style number value
    if (!checkStyleNumber(style)) {
      throw new Error('Style \'' + style + '\' is invalid');
    }

    styleNumber = style;
  }

  dst.style = styleNumber;
}

/**
 * Set the background styling for the graph
 * @param {string | {fill: string, stroke: string, strokeWidth: string}} backgroundColor
 * @param {Object} dst
 */
function setBackgroundColor(backgroundColor, dst) {
  var fill = 'white';
  var stroke = 'gray';
  var strokeWidth = 1;

  if (typeof backgroundColor === 'string') {
    fill = backgroundColor;
    stroke = 'none';
    strokeWidth = 0;
  } else if ((typeof backgroundColor === 'undefined' ? 'undefined' : (0, _typeof3['default'])(backgroundColor)) === 'object') {
    if (backgroundColor.fill !== undefined) fill = backgroundColor.fill;
    if (backgroundColor.stroke !== undefined) stroke = backgroundColor.stroke;
    if (backgroundColor.strokeWidth !== undefined) strokeWidth = backgroundColor.strokeWidth;
  } else {
    throw new Error('Unsupported type of backgroundColor');
  }

  dst.frame.style.backgroundColor = fill;
  dst.frame.style.borderColor = stroke;
  dst.frame.style.borderWidth = strokeWidth + 'px';
  dst.frame.style.borderStyle = 'solid';
}

/**
 *
 * @param {string | Object} dataColor
 * @param {Object} dst
 */
function setDataColor(dataColor, dst) {
  if (dataColor === undefined) {
    return; // Nothing to do
  }

  if (dst.dataColor === undefined) {
    dst.dataColor = {};
  }

  if (typeof dataColor === 'string') {
    dst.dataColor.fill = dataColor;
    dst.dataColor.stroke = dataColor;
  } else {
    if (dataColor.fill) {
      dst.dataColor.fill = dataColor.fill;
    }
    if (dataColor.stroke) {
      dst.dataColor.stroke = dataColor.stroke;
    }
    if (dataColor.strokeWidth !== undefined) {
      dst.dataColor.strokeWidth = dataColor.strokeWidth;
    }
  }
}

/**
 *
 * @param {Object} cameraPosition
 * @param {Object} dst
 */
function setCameraPosition(cameraPosition, dst) {
  var camPos = cameraPosition;
  if (camPos === undefined) {
    return;
  }

  if (dst.camera === undefined) {
    dst.camera = new Camera();
  }

  dst.camera.setArmRotation(camPos.horizontal, camPos.vertical);
  dst.camera.setArmLength(camPos.distance);
}

module.exports.STYLE = STYLE;
module.exports.setDefaults = setDefaults;
module.exports.setOptions = setOptions;
module.exports.setCameraPosition = setCameraPosition;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _sign = __webpack_require__(165);

var _sign2 = _interopRequireDefault(_sign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Point3d = __webpack_require__(34);

/**
 * The camera is mounted on a (virtual) camera arm. The camera arm can rotate
 * The camera is always looking in the direction of the origin of the arm.
 * This way, the camera always rotates around one fixed point, the location
 * of the camera arm.
 *
 * Documentation:
 *   http://en.wikipedia.org/wiki/3D_projection
 * @class Camera
 */
function Camera() {
  this.armLocation = new Point3d();
  this.armRotation = {};
  this.armRotation.horizontal = 0;
  this.armRotation.vertical = 0;
  this.armLength = 1.7;
  this.cameraOffset = new Point3d();
  this.offsetMultiplier = 0.6;

  this.cameraLocation = new Point3d();
  this.cameraRotation = new Point3d(0.5 * Math.PI, 0, 0);

  this.calculateCameraOrientation();
}

/**
 * Set offset camera in camera coordinates
 * @param {number} x offset by camera horisontal
 * @param {number} y offset by camera vertical
 */
Camera.prototype.setOffset = function (x, y) {
  var abs = Math.abs,
      sign = _sign2['default'],
      mul = this.offsetMultiplier,
      border = this.armLength * mul;

  if (abs(x) > border) {
    x = sign(x) * border;
  }
  if (abs(y) > border) {
    y = sign(y) * border;
  }
  this.cameraOffset.x = x;
  this.cameraOffset.y = y;
  this.calculateCameraOrientation();
};

/**
 * Get camera offset by horizontal and vertical
 * @returns {number}
 */
Camera.prototype.getOffset = function () {
  return this.cameraOffset;
};

/**
 * Set the location (origin) of the arm
 * @param {number} x  Normalized value of x
 * @param {number} y  Normalized value of y
 * @param {number} z  Normalized value of z
 */
Camera.prototype.setArmLocation = function (x, y, z) {
  this.armLocation.x = x;
  this.armLocation.y = y;
  this.armLocation.z = z;

  this.calculateCameraOrientation();
};

/**
 * Set the rotation of the camera arm
 * @param {number} horizontal   The horizontal rotation, between 0 and 2*PI.
 *                Optional, can be left undefined.
 * @param {number} vertical   The vertical rotation, between 0 and 0.5*PI
 *                if vertical=0.5*PI, the graph is shown from the
 *                top. Optional, can be left undefined.
 */
Camera.prototype.setArmRotation = function (horizontal, vertical) {
  if (horizontal !== undefined) {
    this.armRotation.horizontal = horizontal;
  }

  if (vertical !== undefined) {
    this.armRotation.vertical = vertical;
    if (this.armRotation.vertical < 0) this.armRotation.vertical = 0;
    if (this.armRotation.vertical > 0.5 * Math.PI) this.armRotation.vertical = 0.5 * Math.PI;
  }

  if (horizontal !== undefined || vertical !== undefined) {
    this.calculateCameraOrientation();
  }
};

/**
 * Retrieve the current arm rotation
 * @return {object}   An object with parameters horizontal and vertical
 */
Camera.prototype.getArmRotation = function () {
  var rot = {};
  rot.horizontal = this.armRotation.horizontal;
  rot.vertical = this.armRotation.vertical;

  return rot;
};

/**
 * Set the (normalized) length of the camera arm.
 * @param {number} length A length between 0.71 and 5.0
 */
Camera.prototype.setArmLength = function (length) {
  if (length === undefined) return;

  this.armLength = length;

  // Radius must be larger than the corner of the graph,
  // which has a distance of sqrt(0.5^2+0.5^2) = 0.71 from the center of the
  // graph
  if (this.armLength < 0.71) this.armLength = 0.71;
  if (this.armLength > 5.0) this.armLength = 5.0;

  this.setOffset(this.cameraOffset.x, this.cameraOffset.y);
  this.calculateCameraOrientation();
};

/**
 * Retrieve the arm length
 * @return {number} length
 */
Camera.prototype.getArmLength = function () {
  return this.armLength;
};

/**
 * Retrieve the camera location
 * @return {Point3d} cameraLocation
 */
Camera.prototype.getCameraLocation = function () {
  return this.cameraLocation;
};

/**
 * Retrieve the camera rotation
 * @return {Point3d} cameraRotation
 */
Camera.prototype.getCameraRotation = function () {
  return this.cameraRotation;
};

/**
 * Calculate the location and rotation of the camera based on the
 * position and orientation of the camera arm
 */
Camera.prototype.calculateCameraOrientation = function () {
  // calculate location of the camera
  this.cameraLocation.x = this.armLocation.x - this.armLength * Math.sin(this.armRotation.horizontal) * Math.cos(this.armRotation.vertical);
  this.cameraLocation.y = this.armLocation.y - this.armLength * Math.cos(this.armRotation.horizontal) * Math.cos(this.armRotation.vertical);
  this.cameraLocation.z = this.armLocation.z + this.armLength * Math.sin(this.armRotation.vertical);

  // calculate rotation of the camera
  this.cameraRotation.x = Math.PI / 2 - this.armRotation.vertical;
  this.cameraRotation.y = 0;
  this.cameraRotation.z = -this.armRotation.horizontal;

  var xa = this.cameraRotation.x;
  var za = this.cameraRotation.z;
  var dx = this.cameraOffset.x;
  var dy = this.cameraOffset.y;
  var sin = Math.sin,
      cos = Math.cos;

  this.cameraLocation.x = this.cameraLocation.x + dx * cos(za) + dy * -sin(za) * cos(xa);
  this.cameraLocation.y = this.cameraLocation.y + dx * sin(za) + dy * cos(za) * cos(xa);
  this.cameraLocation.z = this.cameraLocation.z + dy * sin(xa);
};

module.exports = Camera;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DataView = __webpack_require__(12);

/**
 * @class Filter
 *
 * @param {DataGroup} dataGroup the data group 
 * @param {number}  column             The index of the column to be filtered
 * @param {Graph3d} graph              The graph
 */
function Filter(dataGroup, column, graph) {
  this.dataGroup = dataGroup;
  this.column = column;
  this.graph = graph; // the parent graph

  this.index = undefined;
  this.value = undefined;

  // read all distinct values and select the first one
  this.values = dataGroup.getDistinctValues(this.column);

  if (this.values.length > 0) {
    this.selectValue(0);
  }

  // create an array with the filtered datapoints. this will be loaded afterwards
  this.dataPoints = [];

  this.loaded = false;
  this.onLoadCallback = undefined;

  if (graph.animationPreload) {
    this.loaded = false;
    this.loadInBackground();
  } else {
    this.loaded = true;
  }
}

/**
 * Return the label
 * @return {string} label
 */
Filter.prototype.isLoaded = function () {
  return this.loaded;
};

/**
 * Return the loaded progress
 * @return {number} percentage between 0 and 100
 */
Filter.prototype.getLoadedProgress = function () {
  var len = this.values.length;

  var i = 0;
  while (this.dataPoints[i]) {
    i++;
  }

  return Math.round(i / len * 100);
};

/**
 * Return the label
 * @return {string} label
 */
Filter.prototype.getLabel = function () {
  return this.graph.filterLabel;
};

/**
 * Return the columnIndex of the filter
 * @return {number} columnIndex
 */
Filter.prototype.getColumn = function () {
  return this.column;
};

/**
 * Return the currently selected value. Returns undefined if there is no selection
 * @return {*} value
 */
Filter.prototype.getSelectedValue = function () {
  if (this.index === undefined) return undefined;

  return this.values[this.index];
};

/**
 * Retrieve all values of the filter
 * @return {Array} values
 */
Filter.prototype.getValues = function () {
  return this.values;
};

/**
 * Retrieve one value of the filter
 * @param {number}  index
 * @return {*} value
 */
Filter.prototype.getValue = function (index) {
  if (index >= this.values.length) throw new Error('Index out of range');

  return this.values[index];
};

/**
 * Retrieve the (filtered) dataPoints for the currently selected filter index
 * @param {number} [index] (optional)
 * @return {Array} dataPoints
 */
Filter.prototype._getDataPoints = function (index) {
  if (index === undefined) index = this.index;

  if (index === undefined) return [];

  var dataPoints;
  if (this.dataPoints[index]) {
    dataPoints = this.dataPoints[index];
  } else {
    var f = {};
    f.column = this.column;
    f.value = this.values[index];

    var dataView = new DataView(this.dataGroup.getDataSet(), { filter: function filter(item) {
        return item[f.column] == f.value;
      } }).get();
    dataPoints = this.dataGroup._getDataPoints(dataView);

    this.dataPoints[index] = dataPoints;
  }

  return dataPoints;
};

/**
 * Set a callback function when the filter is fully loaded.
 *
 * @param {function} callback
 */
Filter.prototype.setOnLoadCallback = function (callback) {
  this.onLoadCallback = callback;
};

/**
 * Add a value to the list with available values for this filter
 * No double entries will be created.
 * @param {number} index
 */
Filter.prototype.selectValue = function (index) {
  if (index >= this.values.length) throw new Error('Index out of range');

  this.index = index;
  this.value = this.values[index];
};

/**
 * Load all filtered rows in the background one by one
 * Start this method without providing an index!
 *
 * @param {number} [index=0]
 */
Filter.prototype.loadInBackground = function (index) {
  if (index === undefined) index = 0;

  var frame = this.graph.frame;

  if (index < this.values.length) {
    // create a progress box
    if (frame.progress === undefined) {
      frame.progress = document.createElement('DIV');
      frame.progress.style.position = 'absolute';
      frame.progress.style.color = 'gray';
      frame.appendChild(frame.progress);
    }
    var progress = this.getLoadedProgress();
    frame.progress.innerHTML = 'Loading animation... ' + progress + '%';
    // TODO: this is no nice solution...
    frame.progress.style.bottom = 60 + 'px'; // TODO: use height of slider
    frame.progress.style.left = 10 + 'px';

    var me = this;
    setTimeout(function () {
      me.loadInBackground(index + 1);
    }, 10);
    this.loaded = false;
  } else {
    this.loaded = true;

    // remove the progress box
    if (frame.progress !== undefined) {
      frame.removeChild(frame.progress);
      frame.progress = undefined;
    }

    if (this.onLoadCallback) this.onLoadCallback();
  }
};

module.exports = Filter;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keycharm = __webpack_require__(35);
var Emitter = __webpack_require__(44);
var Hammer = __webpack_require__(10);
var util = __webpack_require__(2);

/**
 * Turn an element into an clickToUse element.
 * When not active, the element has a transparent overlay. When the overlay is
 * clicked, the mode is changed to active.
 * When active, the element is displayed with a blue border around it, and
 * the interactive contents of the element can be used. When clicked outside
 * the element, the elements mode is changed to inactive.
 * @param {Element} container
 * @constructor Activator
 */
function Activator(container) {
  this.active = false;

  this.dom = {
    container: container
  };

  this.dom.overlay = document.createElement('div');
  this.dom.overlay.className = 'vis-overlay';

  this.dom.container.appendChild(this.dom.overlay);

  this.hammer = Hammer(this.dom.overlay);
  this.hammer.on('tap', this._onTapOverlay.bind(this));

  // block all touch events (except tap)
  var me = this;
  var events = ['tap', 'doubletap', 'press', 'pinch', 'pan', 'panstart', 'panmove', 'panend'];
  events.forEach(function (event) {
    me.hammer.on(event, function (event) {
      event.stopPropagation();
    });
  });

  // attach a click event to the window, in order to deactivate when clicking outside the timeline
  if (document && document.body) {
    this.onClick = function (event) {
      if (!_hasParent(event.target, container)) {
        me.deactivate();
      }
    };
    document.body.addEventListener('click', this.onClick);
  }

  if (this.keycharm !== undefined) {
    this.keycharm.destroy();
  }
  this.keycharm = keycharm();

  // keycharm listener only bounded when active)
  this.escListener = this.deactivate.bind(this);
}

// turn into an event emitter
Emitter(Activator.prototype);

// The currently active activator
Activator.current = null;

/**
 * Destroy the activator. Cleans up all created DOM and event listeners
 */
Activator.prototype.destroy = function () {
  this.deactivate();

  // remove dom
  this.dom.overlay.parentNode.removeChild(this.dom.overlay);

  // remove global event listener
  if (this.onClick) {
    document.body.removeEventListener('click', this.onClick);
  }

  // cleanup hammer instances
  this.hammer.destroy();
  this.hammer = null;
  // FIXME: cleaning up hammer instances doesn't work (Timeline not removed from memory)
};

/**
 * Activate the element
 * Overlay is hidden, element is decorated with a blue shadow border
 */
Activator.prototype.activate = function () {
  // we allow only one active activator at a time
  if (Activator.current) {
    Activator.current.deactivate();
  }
  Activator.current = this;

  this.active = true;
  this.dom.overlay.style.display = 'none';
  util.addClassName(this.dom.container, 'vis-active');

  this.emit('change');
  this.emit('activate');

  // ugly hack: bind ESC after emitting the events, as the Network rebinds all
  // keyboard events on a 'change' event
  this.keycharm.bind('esc', this.escListener);
};

/**
 * Deactivate the element
 * Overlay is displayed on top of the element
 */
Activator.prototype.deactivate = function () {
  this.active = false;
  this.dom.overlay.style.display = '';
  util.removeClassName(this.dom.container, 'vis-active');
  this.keycharm.unbind('esc', this.escListener);

  this.emit('change');
  this.emit('deactivate');
};

/**
 * Handle a tap event: activate the container
 * @param {Event}  event   The event
 * @private
 */
Activator.prototype._onTapOverlay = function (event) {
  // activate the container
  this.activate();
  event.stopPropagation();
};

/**
 * Test whether the element has the requested parent element somewhere in
 * its chain of parent nodes.
 * @param {HTMLElement} element
 * @param {HTMLElement} parent
 * @returns {boolean} Returns true when the parent is found somewhere in the
 *                    chain of parent nodes.
 * @private
 */
function _hasParent(element, parent) {
  while (element) {
    if (element === parent) {
      return true;
    }
    element = element.parentNode;
  }
  return false;
}

module.exports = Activator;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// English
exports['en'] = {
  current: 'current',
  time: 'time'
};
exports['en_EN'] = exports['en'];
exports['en_US'] = exports['en'];

// Italiano
exports['it'] = {
  current: 'attuale',
  time: 'tempo'
};
exports['it_IT'] = exports['it'];
exports['it_CH'] = exports['it'];

// Dutch
exports['nl'] = {
  current: 'huidige',
  time: 'tijd'
};
exports['nl_NL'] = exports['nl'];
exports['nl_BE'] = exports['nl'];

// German
exports['de'] = {
  current: 'Aktuelle',
  time: 'Zeit'
};
exports['de_DE'] = exports['de'];

// French
exports['fr'] = {
  current: 'actuel',
  time: 'heure'
};
exports['fr_FR'] = exports['fr'];
exports['fr_CA'] = exports['fr'];
exports['fr_BE'] = exports['fr'];

// Espanol
exports['es'] = {
  current: 'corriente',
  time: 'hora'
};
exports['es_ES'] = exports['es'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _create = __webpack_require__(29);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Hammer = __webpack_require__(10);
var util = __webpack_require__(2);
var DataSet = __webpack_require__(11);
var DataView = __webpack_require__(12);
var TimeStep = __webpack_require__(66);
var Component = __webpack_require__(16);
var Group = __webpack_require__(68);
var BackgroundGroup = __webpack_require__(69);
var BoxItem = __webpack_require__(101);
var PointItem = __webpack_require__(102);
var RangeItem = __webpack_require__(70);
var BackgroundItem = __webpack_require__(103);
var Popup = __webpack_require__(104)['default'];

var UNGROUPED = '__ungrouped__'; // reserved group id for ungrouped items
var BACKGROUND = '__background__'; // reserved group id for background items without group

/**
 * An ItemSet holds a set of items and ranges which can be displayed in a
 * range. The width is determined by the parent of the ItemSet, and the height
 * is determined by the size of the items.
 * @param {{dom: Object, domProps: Object, emitter: Emitter, range: Range}} body
 * @param {Object} [options]      See ItemSet.setOptions for the available options.
 * @constructor ItemSet
 * @extends Component
 */
function ItemSet(body, options) {
  this.body = body;
  this.defaultOptions = {
    type: null, // 'box', 'point', 'range', 'background'
    orientation: {
      item: 'bottom' // item orientation: 'top' or 'bottom'
    },
    align: 'auto', // alignment of box items
    stack: true,
    stackSubgroups: true,
    groupOrderSwap: function groupOrderSwap(fromGroup, toGroup, groups) {
      // eslint-disable-line no-unused-vars
      var targetOrder = toGroup.order;
      toGroup.order = fromGroup.order;
      fromGroup.order = targetOrder;
    },
    groupOrder: 'order',

    selectable: true,
    multiselect: false,
    itemsAlwaysDraggable: {
      item: false,
      range: false
    },

    editable: {
      updateTime: false,
      updateGroup: false,
      add: false,
      remove: false,
      overrideItems: false
    },

    groupEditable: {
      order: false,
      add: false,
      remove: false
    },

    snap: TimeStep.snap,

    // Only called when `objectData.target === 'item'.
    onDropObjectOnItem: function onDropObjectOnItem(objectData, item, callback) {
      callback(item);
    },
    onAdd: function onAdd(item, callback) {
      callback(item);
    },
    onUpdate: function onUpdate(item, callback) {
      callback(item);
    },
    onMove: function onMove(item, callback) {
      callback(item);
    },
    onRemove: function onRemove(item, callback) {
      callback(item);
    },
    onMoving: function onMoving(item, callback) {
      callback(item);
    },
    onAddGroup: function onAddGroup(item, callback) {
      callback(item);
    },
    onMoveGroup: function onMoveGroup(item, callback) {
      callback(item);
    },
    onRemoveGroup: function onRemoveGroup(item, callback) {
      callback(item);
    },

    margin: {
      item: {
        horizontal: 10,
        vertical: 10
      },
      axis: 20
    },

    showTooltips: true,

    tooltip: {
      followMouse: false,
      overflowMethod: 'flip'
    },

    tooltipOnItemUpdateTime: false
  };

  // options is shared by this ItemSet and all its items
  this.options = util.extend({}, this.defaultOptions);
  this.options.rtl = options.rtl;

  // options for getting items from the DataSet with the correct type
  this.itemOptions = {
    type: { start: 'Date', end: 'Date' }
  };

  this.conversion = {
    toScreen: body.util.toScreen,
    toTime: body.util.toTime
  };
  this.dom = {};
  this.props = {};
  this.hammer = null;

  var me = this;
  this.itemsData = null; // DataSet
  this.groupsData = null; // DataSet

  // listeners for the DataSet of the items
  this.itemListeners = {
    'add': function add(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onAdd(params.items);
    },
    'update': function update(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onUpdate(params.items);
    },
    'remove': function remove(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onRemove(params.items);
    }
  };

  // listeners for the DataSet of the groups
  this.groupListeners = {
    'add': function add(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onAddGroups(params.items);

      if (me.groupsData && me.groupsData.length > 0) {
        var groupsData = me.groupsData.getDataSet();
        groupsData.get().forEach(function (groupData) {
          if (groupData.nestedGroups) {
            if (groupData.showNested != false) {
              groupData.showNested = true;
            }
            var updatedGroups = [];
            groupData.nestedGroups.forEach(function (nestedGroupId) {
              var updatedNestedGroup = groupsData.get(nestedGroupId);
              if (!updatedNestedGroup) {
                return;
              }
              updatedNestedGroup.nestedInGroup = groupData.id;
              if (groupData.showNested == false) {
                updatedNestedGroup.visible = false;
              }
              updatedGroups = updatedGroups.concat(updatedNestedGroup);
            });
            groupsData.update(updatedGroups, senderId);
          }
        });
      }
    },
    'update': function update(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onUpdateGroups(params.items);
    },
    'remove': function remove(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onRemoveGroups(params.items);
    }
  };

  this.items = {}; // object with an Item for every data item
  this.groups = {}; // Group object for every group
  this.groupIds = [];

  this.selection = []; // list with the ids of all selected nodes

  this.popup = null;

  this.touchParams = {}; // stores properties while dragging
  this.groupTouchParams = {};
  // create the HTML DOM

  this._create();

  this.setOptions(options);
}

ItemSet.prototype = new Component();

// available item types will be registered here
ItemSet.types = {
  background: BackgroundItem,
  box: BoxItem,
  range: RangeItem,
  point: PointItem
};

/**
 * Create the HTML DOM for the ItemSet
 */
ItemSet.prototype._create = function () {
  var frame = document.createElement('div');
  frame.className = 'vis-itemset';
  frame['timeline-itemset'] = this;
  this.dom.frame = frame;

  // create background panel
  var background = document.createElement('div');
  background.className = 'vis-background';
  frame.appendChild(background);
  this.dom.background = background;

  // create foreground panel
  var foreground = document.createElement('div');
  foreground.className = 'vis-foreground';
  frame.appendChild(foreground);
  this.dom.foreground = foreground;

  // create axis panel
  var axis = document.createElement('div');
  axis.className = 'vis-axis';
  this.dom.axis = axis;

  // create labelset
  var labelSet = document.createElement('div');
  labelSet.className = 'vis-labelset';
  this.dom.labelSet = labelSet;

  // create ungrouped Group
  this._updateUngrouped();

  // create background Group
  var backgroundGroup = new BackgroundGroup(BACKGROUND, null, this);
  backgroundGroup.show();
  this.groups[BACKGROUND] = backgroundGroup;

  // attach event listeners
  // Note: we bind to the centerContainer for the case where the height
  //       of the center container is larger than of the ItemSet, so we
  //       can click in the empty area to create a new item or deselect an item.
  this.hammer = new Hammer(this.body.dom.centerContainer);

  // drag items when selected
  this.hammer.on('hammer.input', function (event) {
    if (event.isFirst) {
      this._onTouch(event);
    }
  }.bind(this));
  this.hammer.on('panstart', this._onDragStart.bind(this));
  this.hammer.on('panmove', this._onDrag.bind(this));
  this.hammer.on('panend', this._onDragEnd.bind(this));
  this.hammer.get('pan').set({ threshold: 5, direction: Hammer.DIRECTION_HORIZONTAL });

  // single select (or unselect) when tapping an item
  this.hammer.on('tap', this._onSelectItem.bind(this));

  // multi select when holding mouse/touch, or on ctrl+click
  this.hammer.on('press', this._onMultiSelectItem.bind(this));

  // add item on doubletap
  this.hammer.on('doubletap', this._onAddItem.bind(this));

  if (this.options.rtl) {
    this.groupHammer = new Hammer(this.body.dom.rightContainer);
  } else {
    this.groupHammer = new Hammer(this.body.dom.leftContainer);
  }

  this.groupHammer.on('tap', this._onGroupClick.bind(this));
  this.groupHammer.on('panstart', this._onGroupDragStart.bind(this));
  this.groupHammer.on('panmove', this._onGroupDrag.bind(this));
  this.groupHammer.on('panend', this._onGroupDragEnd.bind(this));
  this.groupHammer.get('pan').set({ threshold: 5, direction: Hammer.DIRECTION_VERTICAL });

  this.body.dom.centerContainer.addEventListener('mouseover', this._onMouseOver.bind(this));
  this.body.dom.centerContainer.addEventListener('mouseout', this._onMouseOut.bind(this));
  this.body.dom.centerContainer.addEventListener('mousemove', this._onMouseMove.bind(this));
  // right-click on timeline 
  this.body.dom.centerContainer.addEventListener('contextmenu', this._onDragEnd.bind(this));

  this.body.dom.centerContainer.addEventListener('mousewheel', this._onMouseWheel.bind(this));

  // attach to the DOM
  this.show();
};

/**
 * Set options for the ItemSet. Existing options will be extended/overwritten.
 * @param {Object} [options] The following options are available:
 *                           {string} type
 *                              Default type for the items. Choose from 'box'
 *                              (default), 'point', 'range', or 'background'.
 *                              The default style can be overwritten by
 *                              individual items.
 *                           {string} align
 *                              Alignment for the items, only applicable for
 *                              BoxItem. Choose 'center' (default), 'left', or
 *                              'right'.
 *                           {string} orientation.item
 *                              Orientation of the item set. Choose 'top' or
 *                              'bottom' (default).
 *                           {Function} groupOrder
 *                              A sorting function for ordering groups
 *                           {boolean} stack
 *                              If true (default), items will be stacked on
 *                              top of each other.
 *                           {number} margin.axis
 *                              Margin between the axis and the items in pixels.
 *                              Default is 20.
 *                           {number} margin.item.horizontal
 *                              Horizontal margin between items in pixels.
 *                              Default is 10.
 *                           {number} margin.item.vertical
 *                              Vertical Margin between items in pixels.
 *                              Default is 10.
 *                           {number} margin.item
 *                              Margin between items in pixels in both horizontal
 *                              and vertical direction. Default is 10.
 *                           {number} margin
 *                              Set margin for both axis and items in pixels.
 *                           {boolean} selectable
 *                              If true (default), items can be selected.
 *                           {boolean} multiselect
 *                              If true, multiple items can be selected.
 *                              False by default.
 *                           {boolean} editable
 *                              Set all editable options to true or false
 *                           {boolean} editable.updateTime
 *                              Allow dragging an item to an other moment in time
 *                           {boolean} editable.updateGroup
 *                              Allow dragging an item to an other group
 *                           {boolean} editable.add
 *                              Allow creating new items on double tap
 *                           {boolean} editable.remove
 *                              Allow removing items by clicking the delete button
 *                              top right of a selected item.
 *                           {Function(item: Item, callback: Function)} onAdd
 *                              Callback function triggered when an item is about to be added:
 *                              when the user double taps an empty space in the Timeline.
 *                           {Function(item: Item, callback: Function)} onUpdate
 *                              Callback function fired when an item is about to be updated.
 *                              This function typically has to show a dialog where the user
 *                              change the item. If not implemented, nothing happens.
 *                           {Function(item: Item, callback: Function)} onMove
 *                              Fired when an item has been moved. If not implemented,
 *                              the move action will be accepted.
 *                           {Function(item: Item, callback: Function)} onRemove
 *                              Fired when an item is about to be deleted.
 *                              If not implemented, the item will be always removed.
 */
ItemSet.prototype.setOptions = function (options) {
  if (options) {
    // copy all options that we know
    var fields = ['type', 'rtl', 'align', 'order', 'stack', 'stackSubgroups', 'selectable', 'multiselect', 'multiselectPerGroup', 'groupOrder', 'dataAttributes', 'template', 'groupTemplate', 'visibleFrameTemplate', 'hide', 'snap', 'groupOrderSwap', 'showTooltips', 'tooltip', 'tooltipOnItemUpdateTime'];
    util.selectiveExtend(fields, this.options, options);

    if ('itemsAlwaysDraggable' in options) {
      if (typeof options.itemsAlwaysDraggable === 'boolean') {
        this.options.itemsAlwaysDraggable.item = options.itemsAlwaysDraggable;
        this.options.itemsAlwaysDraggable.range = false;
      } else if ((0, _typeof3['default'])(options.itemsAlwaysDraggable) === 'object') {
        util.selectiveExtend(['item', 'range'], this.options.itemsAlwaysDraggable, options.itemsAlwaysDraggable);
        // only allow range always draggable when item is always draggable as well
        if (!this.options.itemsAlwaysDraggable.item) {
          this.options.itemsAlwaysDraggable.range = false;
        }
      }
    }

    if ('orientation' in options) {
      if (typeof options.orientation === 'string') {
        this.options.orientation.item = options.orientation === 'top' ? 'top' : 'bottom';
      } else if ((0, _typeof3['default'])(options.orientation) === 'object' && 'item' in options.orientation) {
        this.options.orientation.item = options.orientation.item;
      }
    }

    if ('margin' in options) {
      if (typeof options.margin === 'number') {
        this.options.margin.axis = options.margin;
        this.options.margin.item.horizontal = options.margin;
        this.options.margin.item.vertical = options.margin;
      } else if ((0, _typeof3['default'])(options.margin) === 'object') {
        util.selectiveExtend(['axis'], this.options.margin, options.margin);
        if ('item' in options.margin) {
          if (typeof options.margin.item === 'number') {
            this.options.margin.item.horizontal = options.margin.item;
            this.options.margin.item.vertical = options.margin.item;
          } else if ((0, _typeof3['default'])(options.margin.item) === 'object') {
            util.selectiveExtend(['horizontal', 'vertical'], this.options.margin.item, options.margin.item);
          }
        }
      }
    }

    if ('editable' in options) {
      if (typeof options.editable === 'boolean') {
        this.options.editable.updateTime = options.editable;
        this.options.editable.updateGroup = options.editable;
        this.options.editable.add = options.editable;
        this.options.editable.remove = options.editable;
        this.options.editable.overrideItems = false;
      } else if ((0, _typeof3['default'])(options.editable) === 'object') {
        util.selectiveExtend(['updateTime', 'updateGroup', 'add', 'remove', 'overrideItems'], this.options.editable, options.editable);
      }
    }

    if ('groupEditable' in options) {
      if (typeof options.groupEditable === 'boolean') {
        this.options.groupEditable.order = options.groupEditable;
        this.options.groupEditable.add = options.groupEditable;
        this.options.groupEditable.remove = options.groupEditable;
      } else if ((0, _typeof3['default'])(options.groupEditable) === 'object') {
        util.selectiveExtend(['order', 'add', 'remove'], this.options.groupEditable, options.groupEditable);
      }
    }

    // callback functions
    var addCallback = function (name) {
      var fn = options[name];
      if (fn) {
        if (!(fn instanceof Function)) {
          throw new Error('option ' + name + ' must be a function ' + name + '(item, callback)');
        }
        this.options[name] = fn;
      }
    }.bind(this);
    ['onDropObjectOnItem', 'onAdd', 'onUpdate', 'onRemove', 'onMove', 'onMoving', 'onAddGroup', 'onMoveGroup', 'onRemoveGroup'].forEach(addCallback);

    // force the itemSet to refresh: options like orientation and margins may be changed
    this.markDirty();
  }
};

/**
 * Mark the ItemSet dirty so it will refresh everything with next redraw.
 * Optionally, all items can be marked as dirty and be refreshed.
 * @param {{refreshItems: boolean}} [options]
 */
ItemSet.prototype.markDirty = function (options) {
  this.groupIds = [];

  if (options && options.refreshItems) {
    util.forEach(this.items, function (item) {
      item.dirty = true;
      if (item.displayed) item.redraw();
    });
  }
};

/**
 * Destroy the ItemSet
 */
ItemSet.prototype.destroy = function () {
  this.hide();
  this.setItems(null);
  this.setGroups(null);

  this.hammer = null;

  this.body = null;
  this.conversion = null;
};

/**
 * Hide the component from the DOM
 */
ItemSet.prototype.hide = function () {
  // remove the frame containing the items
  if (this.dom.frame.parentNode) {
    this.dom.frame.parentNode.removeChild(this.dom.frame);
  }

  // remove the axis with dots
  if (this.dom.axis.parentNode) {
    this.dom.axis.parentNode.removeChild(this.dom.axis);
  }

  // remove the labelset containing all group labels
  if (this.dom.labelSet.parentNode) {
    this.dom.labelSet.parentNode.removeChild(this.dom.labelSet);
  }
};

/**
 * Show the component in the DOM (when not already visible).
 */
ItemSet.prototype.show = function () {
  // show frame containing the items
  if (!this.dom.frame.parentNode) {
    this.body.dom.center.appendChild(this.dom.frame);
  }

  // show axis with dots
  if (!this.dom.axis.parentNode) {
    this.body.dom.backgroundVertical.appendChild(this.dom.axis);
  }

  // show labelset containing labels
  if (!this.dom.labelSet.parentNode) {
    if (this.options.rtl) {
      this.body.dom.right.appendChild(this.dom.labelSet);
    } else {
      this.body.dom.left.appendChild(this.dom.labelSet);
    }
  }
};

/**
 * Set selected items by their id. Replaces the current selection
 * Unknown id's are silently ignored.
 * @param {string[] | string} [ids] An array with zero or more id's of the items to be
 *                                  selected, or a single item id. If ids is undefined
 *                                  or an empty array, all items will be unselected.
 */
ItemSet.prototype.setSelection = function (ids) {
  var i, ii, id, item;

  if (ids == undefined) ids = [];
  if (!Array.isArray(ids)) ids = [ids];

  // unselect currently selected items
  for (i = 0, ii = this.selection.length; i < ii; i++) {
    id = this.selection[i];
    item = this.items[id];
    if (item) item.unselect();
  }

  // select items
  this.selection = [];
  for (i = 0, ii = ids.length; i < ii; i++) {
    id = ids[i];
    item = this.items[id];
    if (item) {
      this.selection.push(id);
      item.select();
    }
  }
};

/**
 * Get the selected items by their id
 * @return {Array} ids  The ids of the selected items
 */
ItemSet.prototype.getSelection = function () {
  return this.selection.concat([]);
};

/**
 * Get the id's of the currently visible items.
 * @returns {Array} The ids of the visible items
 */
ItemSet.prototype.getVisibleItems = function () {
  var range = this.body.range.getRange();
  var right, left;

  if (this.options.rtl) {
    right = this.body.util.toScreen(range.start);
    left = this.body.util.toScreen(range.end);
  } else {
    left = this.body.util.toScreen(range.start);
    right = this.body.util.toScreen(range.end);
  }

  var ids = [];
  for (var groupId in this.groups) {
    if (this.groups.hasOwnProperty(groupId)) {
      var group = this.groups[groupId];
      var rawVisibleItems = group.isVisible ? group.visibleItems : [];

      // filter the "raw" set with visibleItems into a set which is really
      // visible by pixels
      for (var i = 0; i < rawVisibleItems.length; i++) {
        var item = rawVisibleItems[i];
        // TODO: also check whether visible vertically
        if (this.options.rtl) {
          if (item.right < left && item.right + item.width > right) {
            ids.push(item.id);
          }
        } else {
          if (item.left < right && item.left + item.width > left) {
            ids.push(item.id);
          }
        }
      }
    }
  }

  return ids;
};

/**
 * Deselect a selected item
 * @param {string | number} id
 * @private
 */
ItemSet.prototype._deselect = function (id) {
  var selection = this.selection;
  for (var i = 0, ii = selection.length; i < ii; i++) {
    if (selection[i] == id) {
      // non-strict comparison!
      selection.splice(i, 1);
      break;
    }
  }
};

/**
 * Repaint the component
 * @return {boolean} Returns true if the component is resized
 */
ItemSet.prototype.redraw = function () {
  var margin = this.options.margin,
      range = this.body.range,
      asSize = util.option.asSize,
      options = this.options,
      orientation = options.orientation.item,
      resized = false,
      frame = this.dom.frame;

  // recalculate absolute position (before redrawing groups)
  this.props.top = this.body.domProps.top.height + this.body.domProps.border.top;

  if (this.options.rtl) {
    this.props.right = this.body.domProps.right.width + this.body.domProps.border.right;
  } else {
    this.props.left = this.body.domProps.left.width + this.body.domProps.border.left;
  }

  // update class name
  frame.className = 'vis-itemset';

  // reorder the groups (if needed)
  resized = this._orderGroups() || resized;

  // check whether zoomed (in that case we need to re-stack everything)
  // TODO: would be nicer to get this as a trigger from Range
  var visibleInterval = range.end - range.start;
  var zoomed = visibleInterval != this.lastVisibleInterval || this.props.width != this.props.lastWidth;
  var scrolled = range.start != this.lastRangeStart;
  var changedStackOption = options.stack != this.lastStack;
  var changedStackSubgroupsOption = options.stackSubgroups != this.lastStackSubgroups;
  var forceRestack = zoomed || scrolled || changedStackOption || changedStackSubgroupsOption;
  this.lastVisibleInterval = visibleInterval;
  this.lastRangeStart = range.start;
  this.lastStack = options.stack;
  this.lastStackSubgroups = options.stackSubgroups;

  this.props.lastWidth = this.props.width;

  var firstGroup = this._firstGroup();
  var firstMargin = {
    item: margin.item,
    axis: margin.axis
  };
  var nonFirstMargin = {
    item: margin.item,
    axis: margin.item.vertical / 2
  };
  var height = 0;
  var minHeight = margin.axis + margin.item.vertical;

  // redraw the background group
  this.groups[BACKGROUND].redraw(range, nonFirstMargin, forceRestack);

  var redrawQueue = {};
  var redrawQueueLength = 0;

  // collect redraw functions
  util.forEach(this.groups, function (group, key) {
    if (key === BACKGROUND) return;
    var groupMargin = group == firstGroup ? firstMargin : nonFirstMargin;
    var returnQueue = true;
    redrawQueue[key] = group.redraw(range, groupMargin, forceRestack, returnQueue);
    redrawQueueLength = redrawQueue[key].length;
  });

  var needRedraw = redrawQueueLength > 0;
  if (needRedraw) {
    var redrawResults = {};

    for (var i = 0; i < redrawQueueLength; i++) {
      util.forEach(redrawQueue, function (fns, key) {
        redrawResults[key] = fns[i]();
      });
    }

    // redraw all regular groups
    util.forEach(this.groups, function (group, key) {
      if (key === BACKGROUND) return;
      var groupResized = redrawResults[key];
      resized = groupResized || resized;
      height += group.height;
    });
    height = Math.max(height, minHeight);
  }

  height = Math.max(height, minHeight);

  // update frame height
  frame.style.height = asSize(height);

  // calculate actual size
  this.props.width = frame.offsetWidth;
  this.props.height = height;

  // reposition axis
  this.dom.axis.style.top = asSize(orientation == 'top' ? this.body.domProps.top.height + this.body.domProps.border.top : this.body.domProps.top.height + this.body.domProps.centerContainer.height);
  if (this.options.rtl) {
    this.dom.axis.style.right = '0';
  } else {
    this.dom.axis.style.left = '0';
  }

  this.initialItemSetDrawn = true;
  // check if this component is resized
  resized = this._isResized() || resized;

  return resized;
};

/**
 * Get the first group, aligned with the axis
 * @return {Group | null} firstGroup
 * @private
 */
ItemSet.prototype._firstGroup = function () {
  var firstGroupIndex = this.options.orientation.item == 'top' ? 0 : this.groupIds.length - 1;
  var firstGroupId = this.groupIds[firstGroupIndex];
  var firstGroup = this.groups[firstGroupId] || this.groups[UNGROUPED];

  return firstGroup || null;
};

/**
 * Create or delete the group holding all ungrouped items. This group is used when
 * there are no groups specified.
 * @protected
 */
ItemSet.prototype._updateUngrouped = function () {
  var ungrouped = this.groups[UNGROUPED];
  var item, itemId;

  if (this.groupsData) {
    // remove the group holding all ungrouped items
    if (ungrouped) {
      ungrouped.hide();
      delete this.groups[UNGROUPED];

      for (itemId in this.items) {
        if (this.items.hasOwnProperty(itemId)) {
          item = this.items[itemId];
          item.parent && item.parent.remove(item);
          var groupId = this._getGroupId(item.data);
          var group = this.groups[groupId];
          group && group.add(item) || item.hide();
        }
      }
    }
  } else {
    // create a group holding all (unfiltered) items
    if (!ungrouped) {
      var id = null;
      var data = null;
      ungrouped = new Group(id, data, this);
      this.groups[UNGROUPED] = ungrouped;

      for (itemId in this.items) {
        if (this.items.hasOwnProperty(itemId)) {
          item = this.items[itemId];
          ungrouped.add(item);
        }
      }

      ungrouped.show();
    }
  }
};

/**
 * Get the element for the labelset
 * @return {HTMLElement} labelSet
 */
ItemSet.prototype.getLabelSet = function () {
  return this.dom.labelSet;
};

/**
 * Set items
 * @param {vis.DataSet | null} items
 */
ItemSet.prototype.setItems = function (items) {
  var me = this,
      ids,
      oldItemsData = this.itemsData;

  // replace the dataset
  if (!items) {
    this.itemsData = null;
  } else if (items instanceof DataSet || items instanceof DataView) {
    this.itemsData = items;
  } else {
    throw new TypeError('Data must be an instance of DataSet or DataView');
  }

  if (oldItemsData) {
    // unsubscribe from old dataset
    util.forEach(this.itemListeners, function (callback, event) {
      oldItemsData.off(event, callback);
    });

    // remove all drawn items
    ids = oldItemsData.getIds();
    this._onRemove(ids);
  }

  if (this.itemsData) {
    // subscribe to new dataset
    var id = this.id;
    util.forEach(this.itemListeners, function (callback, event) {
      me.itemsData.on(event, callback, id);
    });

    // add all new items
    ids = this.itemsData.getIds();
    this._onAdd(ids);

    // update the group holding all ungrouped items
    this._updateUngrouped();
  }

  this.body.emitter.emit('_change', { queue: true });
};

/**
 * Get the current items
 * @returns {vis.DataSet | null}
 */
ItemSet.prototype.getItems = function () {
  return this.itemsData;
};

/**
 * Set groups
 * @param {vis.DataSet} groups
 */
ItemSet.prototype.setGroups = function (groups) {
  var me = this,
      ids;

  // unsubscribe from current dataset
  if (this.groupsData) {
    util.forEach(this.groupListeners, function (callback, event) {
      me.groupsData.off(event, callback);
    });

    // remove all drawn groups
    ids = this.groupsData.getIds();
    this.groupsData = null;
    this._onRemoveGroups(ids); // note: this will cause a redraw
  }

  // replace the dataset
  if (!groups) {
    this.groupsData = null;
  } else if (groups instanceof DataSet || groups instanceof DataView) {
    this.groupsData = groups;
  } else {
    throw new TypeError('Data must be an instance of DataSet or DataView');
  }

  if (this.groupsData) {
    // go over all groups nesting
    var groupsData = this.groupsData;
    if (this.groupsData instanceof DataView) {
      groupsData = this.groupsData.getDataSet();
    }

    groupsData.get().forEach(function (group) {
      if (group.nestedGroups) {
        group.nestedGroups.forEach(function (nestedGroupId) {
          var updatedNestedGroup = groupsData.get(nestedGroupId);
          updatedNestedGroup.nestedInGroup = group.id;
          if (group.showNested == false) {
            updatedNestedGroup.visible = false;
          }
          groupsData.update(updatedNestedGroup);
        });
      }
    });

    // subscribe to new dataset
    var id = this.id;
    util.forEach(this.groupListeners, function (callback, event) {
      me.groupsData.on(event, callback, id);
    });

    // draw all ms
    ids = this.groupsData.getIds();
    this._onAddGroups(ids);
  }

  // update the group holding all ungrouped items
  this._updateUngrouped();

  // update the order of all items in each group
  this._order();

  this.body.emitter.emit('_change', { queue: true });
};

/**
 * Get the current groups
 * @returns {vis.DataSet | null} groups
 */
ItemSet.prototype.getGroups = function () {
  return this.groupsData;
};

/**
 * Remove an item by its id
 * @param {string | number} id
 */
ItemSet.prototype.removeItem = function (id) {
  var item = this.itemsData.get(id),
      dataset = this.itemsData.getDataSet();

  if (item) {
    // confirm deletion
    this.options.onRemove(item, function (item) {
      if (item) {
        // remove by id here, it is possible that an item has no id defined
        // itself, so better not delete by the item itself
        dataset.remove(id);
      }
    });
  }
};

/**
 * Get the time of an item based on it's data and options.type
 * @param {Object} itemData
 * @returns {string} Returns the type
 * @private
 */
ItemSet.prototype._getType = function (itemData) {
  return itemData.type || this.options.type || (itemData.end ? 'range' : 'box');
};

/**
 * Get the group id for an item
 * @param {Object} itemData
 * @returns {string} Returns the groupId
 * @private
 */
ItemSet.prototype._getGroupId = function (itemData) {
  var type = this._getType(itemData);
  if (type == 'background' && itemData.group == undefined) {
    return BACKGROUND;
  } else {
    return this.groupsData ? itemData.group : UNGROUPED;
  }
};

/**
 * Handle updated items
 * @param {number[]} ids
 * @protected
 */
ItemSet.prototype._onUpdate = function (ids) {
  var me = this;

  ids.forEach(function (id) {
    var itemData = me.itemsData.get(id, me.itemOptions);
    var item = me.items[id];
    var type = itemData ? me._getType(itemData) : null;

    var constructor = ItemSet.types[type];
    var selected;

    if (item) {
      // update item   	
      if (!constructor || !(item instanceof constructor)) {
        // item type has changed, delete the item and recreate it
        selected = item.selected; // preserve selection of this item
        me._removeItem(item);
        item = null;
      } else {
        me._updateItem(item, itemData);
      }
    }

    if (!item && itemData) {
      // create item
      if (constructor) {
        item = new constructor(itemData, me.conversion, me.options);
        item.id = id; // TODO: not so nice setting id afterwards

        me._addItem(item);
        if (selected) {
          this.selection.push(id);
          item.select();
        }
      } else if (type == 'rangeoverflow') {
        // TODO: deprecated since version 2.1.0 (or 3.0.0?). cleanup some day
        throw new TypeError('Item type "rangeoverflow" is deprecated. Use css styling instead: ' + '.vis-item.vis-range .vis-item-content {overflow: visible;}');
      } else {
        throw new TypeError('Unknown item type "' + type + '"');
      }
    }
  }.bind(this));

  this._order();
  this.body.emitter.emit('_change', { queue: true });
};

/**
 * Handle added items
 * @param {number[]} ids
 * @protected
 */
ItemSet.prototype._onAdd = ItemSet.prototype._onUpdate;

/**
 * Handle removed items
 * @param {number[]} ids
 * @protected
 */
ItemSet.prototype._onRemove = function (ids) {
  var count = 0;
  var me = this;
  ids.forEach(function (id) {
    var item = me.items[id];
    if (item) {
      count++;
      me._removeItem(item);
    }
  });

  if (count) {
    // update order
    this._order();
    this.body.emitter.emit('_change', { queue: true });
  }
};

/**
 * Update the order of item in all groups
 * @private
 */
ItemSet.prototype._order = function () {
  // reorder the items in all groups
  // TODO: optimization: only reorder groups affected by the changed items
  util.forEach(this.groups, function (group) {
    group.order();
  });
};

/**
 * Handle updated groups
 * @param {number[]} ids
 * @private
 */
ItemSet.prototype._onUpdateGroups = function (ids) {
  this._onAddGroups(ids);
};

/**
 * Handle changed groups (added or updated)
 * @param {number[]} ids
 * @private
 */
ItemSet.prototype._onAddGroups = function (ids) {
  var me = this;

  ids.forEach(function (id) {
    var groupData = me.groupsData.get(id);
    var group = me.groups[id];

    if (!group) {
      // check for reserved ids
      if (id == UNGROUPED || id == BACKGROUND) {
        throw new Error('Illegal group id. ' + id + ' is a reserved id.');
      }

      var groupOptions = (0, _create2['default'])(me.options);
      util.extend(groupOptions, {
        height: null
      });

      group = new Group(id, groupData, me);
      me.groups[id] = group;

      // add items with this groupId to the new group
      for (var itemId in me.items) {
        if (me.items.hasOwnProperty(itemId)) {
          var item = me.items[itemId];
          if (item.data.group == id) {
            group.add(item);
          }
        }
      }

      group.order();
      group.show();
    } else {
      // update group
      group.setData(groupData);
    }
  });

  this.body.emitter.emit('_change', { queue: true });
};

/**
 * Handle removed groups
 * @param {number[]} ids
 * @private
 */
ItemSet.prototype._onRemoveGroups = function (ids) {
  var groups = this.groups;
  ids.forEach(function (id) {
    var group = groups[id];

    if (group) {
      group.hide();
      delete groups[id];
    }
  });

  this.markDirty();

  this.body.emitter.emit('_change', { queue: true });
};

/**
 * Reorder the groups if needed
 * @return {boolean} changed
 * @private
 */
ItemSet.prototype._orderGroups = function () {
  if (this.groupsData) {
    // reorder the groups
    var groupIds = this.groupsData.getIds({
      order: this.options.groupOrder
    });

    groupIds = this._orderNestedGroups(groupIds);

    var changed = !util.equalArray(groupIds, this.groupIds);
    if (changed) {
      // hide all groups, removes them from the DOM
      var groups = this.groups;
      groupIds.forEach(function (groupId) {
        groups[groupId].hide();
      });

      // show the groups again, attach them to the DOM in correct order
      groupIds.forEach(function (groupId) {
        groups[groupId].show();
      });

      this.groupIds = groupIds;
    }

    return changed;
  } else {
    return false;
  }
};

/**
 * Reorder the nested groups
 *
 * @param {Array.<number>} groupIds
 * @returns {Array.<number>}
 * @private
 */
ItemSet.prototype._orderNestedGroups = function (groupIds) {
  var newGroupIdsOrder = [];

  groupIds.forEach(function (groupId) {
    var groupData = this.groupsData.get(groupId);
    if (!groupData.nestedInGroup) {
      newGroupIdsOrder.push(groupId);
    }
    if (groupData.nestedGroups) {
      var nestedGroups = this.groupsData.get({
        filter: function filter(nestedGroup) {
          return nestedGroup.nestedInGroup == groupId;
        },
        order: this.options.groupOrder
      });
      var nestedGroupIds = nestedGroups.map(function (nestedGroup) {
        return nestedGroup.id;
      });
      newGroupIdsOrder = newGroupIdsOrder.concat(nestedGroupIds);
    }
  }, this);
  return newGroupIdsOrder;
};

/**
 * Add a new item
 * @param {Item} item
 * @private
 */
ItemSet.prototype._addItem = function (item) {
  this.items[item.id] = item;

  // add to group
  var groupId = this._getGroupId(item.data);
  var group = this.groups[groupId];

  if (!group) {
    item.groupShowing = false;
  } else if (group && group.data && group.data.showNested) {
    item.groupShowing = true;
  }

  if (group) group.add(item);
};

/**
 * Update an existing item
 * @param {Item} item
 * @param {Object} itemData
 * @private
 */
ItemSet.prototype._updateItem = function (item, itemData) {
  // update the items data (will redraw the item when displayed)
  item.setData(itemData);

  var groupId = this._getGroupId(item.data);
  var group = this.groups[groupId];
  if (!group) {
    item.groupShowing = false;
  } else if (group && group.data && group.data.showNested) {
    item.groupShowing = true;
  }
};

/**
 * Delete an item from the ItemSet: remove it from the DOM, from the map
 * with items, and from the map with visible items, and from the selection
 * @param {Item} item
 * @private
 */
ItemSet.prototype._removeItem = function (item) {
  // remove from DOM
  item.hide();

  // remove from items
  delete this.items[item.id];

  // remove from selection
  var index = this.selection.indexOf(item.id);
  if (index != -1) this.selection.splice(index, 1);

  // remove from group
  item.parent && item.parent.remove(item);
};

/**
 * Create an array containing all items being a range (having an end date)
 * @param {Array.<Object>} array
 * @returns {Array}
 * @private
 */
ItemSet.prototype._constructByEndArray = function (array) {
  var endArray = [];

  for (var i = 0; i < array.length; i++) {
    if (array[i] instanceof RangeItem) {
      endArray.push(array[i]);
    }
  }
  return endArray;
};

/**
 * Register the clicked item on touch, before dragStart is initiated.
 *
 * dragStart is initiated from a mousemove event, AFTER the mouse/touch is
 * already moving. Therefore, the mouse/touch can sometimes be above an other
 * DOM element than the item itself.
 *
 * @param {Event} event
 * @private
 */
ItemSet.prototype._onTouch = function (event) {
  // store the touched item, used in _onDragStart
  this.touchParams.item = this.itemFromTarget(event);
  this.touchParams.dragLeftItem = event.target.dragLeftItem || false;
  this.touchParams.dragRightItem = event.target.dragRightItem || false;
  this.touchParams.itemProps = null;
};

/**
 * Given an group id, returns the index it has.
 *
 * @param {number} groupId
 * @returns {number} index / groupId
 * @private
 */
ItemSet.prototype._getGroupIndex = function (groupId) {
  for (var i = 0; i < this.groupIds.length; i++) {
    if (groupId == this.groupIds[i]) return i;
  }
};

/**
 * Start dragging the selected events
 * @param {Event} event
 * @private
 */
ItemSet.prototype._onDragStart = function (event) {
  if (this.touchParams.itemIsDragging) {
    return;
  }
  var item = this.touchParams.item || null;
  var me = this;
  var props;

  if (item && (item.selected || this.options.itemsAlwaysDraggable.item)) {

    if (this.options.editable.overrideItems && !this.options.editable.updateTime && !this.options.editable.updateGroup) {
      return;
    }

    // override options.editable
    if (item.editable != null && !item.editable.updateTime && !item.editable.updateGroup && !this.options.editable.overrideItems) {
      return;
    }

    var dragLeftItem = this.touchParams.dragLeftItem;
    var dragRightItem = this.touchParams.dragRightItem;
    this.touchParams.itemIsDragging = true;
    this.touchParams.selectedItem = item;

    if (dragLeftItem) {
      props = {
        item: dragLeftItem,
        initialX: event.center.x,
        dragLeft: true,
        data: this._cloneItemData(item.data)
      };

      this.touchParams.itemProps = [props];
    } else if (dragRightItem) {
      props = {
        item: dragRightItem,
        initialX: event.center.x,
        dragRight: true,
        data: this._cloneItemData(item.data)
      };

      this.touchParams.itemProps = [props];
    } else if (this.options.editable.add && (event.srcEvent.ctrlKey || event.srcEvent.metaKey)) {
      // create a new range item when dragging with ctrl key down
      this._onDragStartAddItem(event);
    } else {
      if (this.groupIds.length < 1) {
        // Mitigates a race condition if _onDragStart() is
        // called after markDirty() without redraw() being called between.
        this.redraw();
      }

      var baseGroupIndex = this._getGroupIndex(item.data.group);

      var itemsToDrag = this.options.itemsAlwaysDraggable.item && !item.selected ? [item.id] : this.getSelection();

      this.touchParams.itemProps = itemsToDrag.map(function (id) {
        var item = me.items[id];
        var groupIndex = me._getGroupIndex(item.data.group);
        return {
          item: item,
          initialX: event.center.x,
          groupOffset: baseGroupIndex - groupIndex,
          data: this._cloneItemData(item.data)
        };
      }.bind(this));
    }

    event.stopPropagation();
  } else if (this.options.editable.add && (event.srcEvent.ctrlKey || event.srcEvent.metaKey)) {
    // create a new range item when dragging with ctrl key down
    this._onDragStartAddItem(event);
  }
};

/**
 * Start creating a new range item by dragging.
 * @param {Event} event
 * @private
 */
ItemSet.prototype._onDragStartAddItem = function (event) {
  var xAbs;
  var x;
  var snap = this.options.snap || null;

  if (this.options.rtl) {
    xAbs = util.getAbsoluteRight(this.dom.frame);
    x = xAbs - event.center.x + 10; // plus 10 to compensate for the drag starting as soon as you've moved 10px
  } else {
    xAbs = util.getAbsoluteLeft(this.dom.frame);
    x = event.center.x - xAbs - 10; // minus 10 to compensate for the drag starting as soon as you've moved 10px
  }

  var time = this.body.util.toTime(x);
  var scale = this.body.util.getScale();
  var step = this.body.util.getStep();
  var start = snap ? snap(time, scale, step) : time;
  var end = start;

  var itemData = {
    type: 'range',
    start: start,
    end: end,
    content: 'new item'
  };

  var id = util.randomUUID();
  itemData[this.itemsData._fieldId] = id;

  var group = this.groupFromTarget(event);
  if (group) {
    itemData.group = group.groupId;
  }
  var newItem = new RangeItem(itemData, this.conversion, this.options);
  newItem.id = id; // TODO: not so nice setting id afterwards
  newItem.data = this._cloneItemData(itemData);
  this._addItem(newItem);
  this.touchParams.selectedItem = newItem;

  var props = {
    item: newItem,
    initialX: event.center.x,
    data: newItem.data
  };

  if (this.options.rtl) {
    props.dragLeft = true;
  } else {
    props.dragRight = true;
  }
  this.touchParams.itemProps = [props];

  event.stopPropagation();
};

/**
 * Drag selected items
 * @param {Event} event
 * @private
 */
ItemSet.prototype._onDrag = function (event) {
  if (this.touchParams.itemProps) {
    event.stopPropagation();

    var me = this;
    var snap = this.options.snap || null;
    var xOffset;

    if (this.options.rtl) {
      xOffset = this.body.dom.root.offsetLeft + this.body.domProps.right.width;
    } else {
      xOffset = this.body.dom.root.offsetLeft + this.body.domProps.left.width;
    }

    var scale = this.body.util.getScale();
    var step = this.body.util.getStep();

    //only calculate the new group for the item that's actually dragged
    var selectedItem = this.touchParams.selectedItem;
    var updateGroupAllowed = (this.options.editable.overrideItems || selectedItem.editable == null) && this.options.editable.updateGroup || !this.options.editable.overrideItems && selectedItem.editable != null && selectedItem.editable.updateGroup;
    var newGroupBase = null;
    if (updateGroupAllowed && selectedItem) {
      if (selectedItem.data.group != undefined) {
        // drag from one group to another
        var group = me.groupFromTarget(event);
        if (group) {
          //we know the offset for all items, so the new group for all items
          //will be relative to this one.
          newGroupBase = this._getGroupIndex(group.groupId);
        }
      }
    }

    // move
    this.touchParams.itemProps.forEach(function (props) {
      var current = me.body.util.toTime(event.center.x - xOffset);
      var initial = me.body.util.toTime(props.initialX - xOffset);
      var offset;
      var initialStart;
      var initialEnd;
      var start;
      var end;

      if (this.options.rtl) {
        offset = -(current - initial); // ms
      } else {
        offset = current - initial; // ms
      }

      var itemData = this._cloneItemData(props.item.data); // clone the data
      if (props.item.editable != null && !props.item.editable.updateTime && !props.item.editable.updateGroup && !me.options.editable.overrideItems) {
        return;
      }

      var updateTimeAllowed = (this.options.editable.overrideItems || selectedItem.editable == null) && this.options.editable.updateTime || !this.options.editable.overrideItems && selectedItem.editable != null && selectedItem.editable.updateTime;
      if (updateTimeAllowed) {
        if (props.dragLeft) {
          // drag left side of a range item
          if (this.options.rtl) {
            if (itemData.end != undefined) {
              initialEnd = util.convert(props.data.end, 'Date');
              end = new Date(initialEnd.valueOf() + offset);
              // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
              itemData.end = snap ? snap(end, scale, step) : end;
            }
          } else {
            if (itemData.start != undefined) {
              initialStart = util.convert(props.data.start, 'Date');
              start = new Date(initialStart.valueOf() + offset);
              // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
              itemData.start = snap ? snap(start, scale, step) : start;
            }
          }
        } else if (props.dragRight) {
          // drag right side of a range item
          if (this.options.rtl) {
            if (itemData.start != undefined) {
              initialStart = util.convert(props.data.start, 'Date');
              start = new Date(initialStart.valueOf() + offset);
              // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
              itemData.start = snap ? snap(start, scale, step) : start;
            }
          } else {
            if (itemData.end != undefined) {
              initialEnd = util.convert(props.data.end, 'Date');
              end = new Date(initialEnd.valueOf() + offset);
              // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
              itemData.end = snap ? snap(end, scale, step) : end;
            }
          }
        } else {
          // drag both start and end
          if (itemData.start != undefined) {

            initialStart = util.convert(props.data.start, 'Date').valueOf();
            start = new Date(initialStart + offset);

            if (itemData.end != undefined) {
              initialEnd = util.convert(props.data.end, 'Date');
              var duration = initialEnd.valueOf() - initialStart.valueOf();

              // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
              itemData.start = snap ? snap(start, scale, step) : start;
              itemData.end = new Date(itemData.start.valueOf() + duration);
            } else {
              // TODO: pass a Moment instead of a Date to snap(). (Breaking change)
              itemData.start = snap ? snap(start, scale, step) : start;
            }
          }
        }
      }

      if (updateGroupAllowed && !props.dragLeft && !props.dragRight && newGroupBase != null) {
        if (itemData.group != undefined) {
          var newOffset = newGroupBase - props.groupOffset;

          //make sure we stay in bounds
          newOffset = Math.max(0, newOffset);
          newOffset = Math.min(me.groupIds.length - 1, newOffset);
          itemData.group = me.groupIds[newOffset];
        }
      }

      // confirm moving the item
      itemData = this._cloneItemData(itemData); // convert start and end to the correct type
      me.options.onMoving(itemData, function (itemData) {
        if (itemData) {
          props.item.setData(this._cloneItemData(itemData, 'Date'));
        }
      }.bind(this));
    }.bind(this));

    this.body.emitter.emit('_change');
  }
};

/**
 * Move an item to another group
 * @param {Item} item
 * @param {string | number} groupId
 * @private
 */
ItemSet.prototype._moveToGroup = function (item, groupId) {
  var group = this.groups[groupId];
  if (group && group.groupId != item.data.group) {
    var oldGroup = item.parent;
    oldGroup.remove(item);
    oldGroup.order();

    item.data.group = group.groupId;

    group.add(item);
    group.order();
  }
};

/**
 * End of dragging selected items
 * @param {Event} event
 * @private
 */
ItemSet.prototype._onDragEnd = function (event) {
  this.touchParams.itemIsDragging = false;
  if (this.touchParams.itemProps) {
    event.stopPropagation();

    var me = this;
    var dataset = this.itemsData.getDataSet();
    var itemProps = this.touchParams.itemProps;
    this.touchParams.itemProps = null;

    itemProps.forEach(function (props) {
      var id = props.item.id;
      var exists = me.itemsData.get(id, me.itemOptions) != null;

      if (!exists) {
        // add a new item
        me.options.onAdd(props.item.data, function (itemData) {
          me._removeItem(props.item); // remove temporary item
          if (itemData) {
            me.itemsData.getDataSet().add(itemData);
          }

          // force re-stacking of all items next redraw
          me.body.emitter.emit('_change');
        });
      } else {
        // update existing item
        var itemData = this._cloneItemData(props.item.data); // convert start and end to the correct type
        me.options.onMove(itemData, function (itemData) {
          if (itemData) {
            // apply changes
            itemData[dataset._fieldId] = id; // ensure the item contains its id (can be undefined)
            dataset.update(itemData);
          } else {
            // restore original values
            props.item.setData(props.data);

            me.body.emitter.emit('_change');
          }
        });
      }
    }.bind(this));
  }
};

ItemSet.prototype._onGroupClick = function (event) {
  var group = this.groupFromTarget(event);

  if (!group || !group.nestedGroups) return;

  var groupsData = this.groupsData.getDataSet();

  var nestingGroup = groupsData.get(group.groupId);
  if (nestingGroup.showNested == undefined) {
    nestingGroup.showNested = true;
  }
  nestingGroup.showNested = !nestingGroup.showNested;

  var nestedGroups = groupsData.get(group.nestedGroups).map(function (nestedGroup) {
    nestedGroup.visible = nestingGroup.showNested;
    return nestedGroup;
  });

  groupsData.update(nestedGroups.concat(nestingGroup));

  if (nestingGroup.showNested) {
    util.removeClassName(group.dom.label, 'collapsed');
    util.addClassName(group.dom.label, 'expanded');
  } else {
    util.removeClassName(group.dom.label, 'expanded');
    var collapsedDirClassName = this.options.rtl ? 'collapsed-rtl' : 'collapsed';
    util.addClassName(group.dom.label, collapsedDirClassName);
  }
};

ItemSet.prototype._onGroupDragStart = function (event) {
  if (this.options.groupEditable.order) {
    this.groupTouchParams.group = this.groupFromTarget(event);

    if (this.groupTouchParams.group) {
      event.stopPropagation();

      this.groupTouchParams.originalOrder = this.groupsData.getIds({
        order: this.options.groupOrder
      });
    }
  }
};

ItemSet.prototype._onGroupDrag = function (event) {
  if (this.options.groupEditable.order && this.groupTouchParams.group) {
    event.stopPropagation();

    var groupsData = this.groupsData;
    if (this.groupsData instanceof DataView) {
      groupsData = this.groupsData.getDataSet();
    }
    // drag from one group to another
    var group = this.groupFromTarget(event);

    // try to avoid toggling when groups differ in height
    if (group && group.height != this.groupTouchParams.group.height) {
      var movingUp = group.top < this.groupTouchParams.group.top;
      var clientY = event.center ? event.center.y : event.clientY;
      var targetGroupTop = util.getAbsoluteTop(group.dom.foreground);
      var draggedGroupHeight = this.groupTouchParams.group.height;
      if (movingUp) {
        // skip swapping the groups when the dragged group is not below clientY afterwards
        if (targetGroupTop + draggedGroupHeight < clientY) {
          return;
        }
      } else {
        var targetGroupHeight = group.height;
        // skip swapping the groups when the dragged group is not below clientY afterwards
        if (targetGroupTop + targetGroupHeight - draggedGroupHeight > clientY) {
          return;
        }
      }
    }

    if (group && group != this.groupTouchParams.group) {
      var targetGroup = groupsData.get(group.groupId);
      var draggedGroup = groupsData.get(this.groupTouchParams.group.groupId);

      // switch groups
      if (draggedGroup && targetGroup) {
        this.options.groupOrderSwap(draggedGroup, targetGroup, groupsData);
        groupsData.update(draggedGroup);
        groupsData.update(targetGroup);
      }

      // fetch current order of groups
      var newOrder = groupsData.getIds({
        order: this.options.groupOrder
      });

      // in case of changes since _onGroupDragStart
      if (!util.equalArray(newOrder, this.groupTouchParams.originalOrder)) {
        var origOrder = this.groupTouchParams.originalOrder;
        var draggedId = this.groupTouchParams.group.groupId;
        var numGroups = Math.min(origOrder.length, newOrder.length);
        var curPos = 0;
        var newOffset = 0;
        var orgOffset = 0;
        while (curPos < numGroups) {
          // as long as the groups are where they should be step down along the groups order
          while (curPos + newOffset < numGroups && curPos + orgOffset < numGroups && newOrder[curPos + newOffset] == origOrder[curPos + orgOffset]) {
            curPos++;
          }

          // all ok
          if (curPos + newOffset >= numGroups) {
            break;
          }

          // not all ok
          // if dragged group was move upwards everything below should have an offset
          if (newOrder[curPos + newOffset] == draggedId) {
            newOffset = 1;
          }
          // if dragged group was move downwards everything above should have an offset
          else if (origOrder[curPos + orgOffset] == draggedId) {
              orgOffset = 1;
            }
            // found a group (apart from dragged group) that has the wrong position -> switch with the 
            // group at the position where other one should be, fix index arrays and continue
            else {
                var slippedPosition = newOrder.indexOf(origOrder[curPos + orgOffset]);
                var switchGroup = groupsData.get(newOrder[curPos + newOffset]);
                var shouldBeGroup = groupsData.get(origOrder[curPos + orgOffset]);
                this.options.groupOrderSwap(switchGroup, shouldBeGroup, groupsData);
                groupsData.update(switchGroup);
                groupsData.update(shouldBeGroup);

                var switchGroupId = newOrder[curPos + newOffset];
                newOrder[curPos + newOffset] = origOrder[curPos + orgOffset];
                newOrder[slippedPosition] = switchGroupId;

                curPos++;
              }
        }
      }
    }
  }
};

ItemSet.prototype._onGroupDragEnd = function (event) {
  if (this.options.groupEditable.order && this.groupTouchParams.group) {
    event.stopPropagation();

    // update existing group
    var me = this;
    var id = me.groupTouchParams.group.groupId;
    var dataset = me.groupsData.getDataSet();
    var groupData = util.extend({}, dataset.get(id)); // clone the data
    me.options.onMoveGroup(groupData, function (groupData) {
      if (groupData) {
        // apply changes
        groupData[dataset._fieldId] = id; // ensure the group contains its id (can be undefined)
        dataset.update(groupData);
      } else {

        // fetch current order of groups
        var newOrder = dataset.getIds({
          order: me.options.groupOrder
        });

        // restore original order
        if (!util.equalArray(newOrder, me.groupTouchParams.originalOrder)) {
          var origOrder = me.groupTouchParams.originalOrder;
          var numGroups = Math.min(origOrder.length, newOrder.length);
          var curPos = 0;
          while (curPos < numGroups) {
            // as long as the groups are where they should be step down along the groups order
            while (curPos < numGroups && newOrder[curPos] == origOrder[curPos]) {
              curPos++;
            }

            // all ok
            if (curPos >= numGroups) {
              break;
            }

            // found a group that has the wrong position -> switch with the
            // group at the position where other one should be, fix index arrays and continue
            var slippedPosition = newOrder.indexOf(origOrder[curPos]);
            var switchGroup = dataset.get(newOrder[curPos]);
            var shouldBeGroup = dataset.get(origOrder[curPos]);
            me.options.groupOrderSwap(switchGroup, shouldBeGroup, dataset);
            dataset.update(switchGroup);
            dataset.update(shouldBeGroup);

            var switchGroupId = newOrder[curPos];
            newOrder[curPos] = origOrder[curPos];
            newOrder[slippedPosition] = switchGroupId;

            curPos++;
          }
        }
      }
    });

    me.body.emitter.emit('groupDragged', { groupId: id });
  }
};

/**
 * Handle selecting/deselecting an item when tapping it
 * @param {Event} event
 * @private
 */
ItemSet.prototype._onSelectItem = function (event) {
  if (!this.options.selectable) return;

  var ctrlKey = event.srcEvent && (event.srcEvent.ctrlKey || event.srcEvent.metaKey);
  var shiftKey = event.srcEvent && event.srcEvent.shiftKey;
  if (ctrlKey || shiftKey) {
    this._onMultiSelectItem(event);
    return;
  }

  var oldSelection = this.getSelection();

  var item = this.itemFromTarget(event);
  var selection = item ? [item.id] : [];
  this.setSelection(selection);

  var newSelection = this.getSelection();

  // emit a select event,
  // except when old selection is empty and new selection is still empty
  if (newSelection.length > 0 || oldSelection.length > 0) {
    this.body.emitter.emit('select', {
      items: newSelection,
      event: event
    });
  }
};

/**
 * Handle hovering an item
 * @param {Event} event
 * @private
 */
ItemSet.prototype._onMouseOver = function (event) {
  var item = this.itemFromTarget(event);
  if (!item) return;

  // Item we just left
  var related = this.itemFromRelatedTarget(event);
  if (item === related) {
    // We haven't changed item, just element in the item
    return;
  }

  var title = item.getTitle();
  if (this.options.showTooltips && title) {
    if (this.popup == null) {
      this.popup = new Popup(this.body.dom.root, this.options.tooltip.overflowMethod || 'flip');
    }

    this.popup.setText(title);
    var container = this.body.dom.centerContainer;
    this.popup.setPosition(event.clientX - util.getAbsoluteLeft(container) + container.offsetLeft, event.clientY - util.getAbsoluteTop(container) + container.offsetTop);
    this.popup.show();
  } else {
    // Hovering over item without a title, hide popup
    // Needed instead of _just_ in _onMouseOut due to #2572
    if (this.popup != null) {
      this.popup.hide();
    }
  }

  this.body.emitter.emit('itemover', {
    item: item.id,
    event: event
  });
};
ItemSet.prototype._onMouseOut = function (event) {
  var item = this.itemFromTarget(event);
  if (!item) return;

  // Item we are going to
  var related = this.itemFromRelatedTarget(event);
  if (item === related) {
    // We aren't changing item, just element in the item
    return;
  }

  if (this.popup != null) {
    this.popup.hide();
  }

  this.body.emitter.emit('itemout', {
    item: item.id,
    event: event
  });
};
ItemSet.prototype._onMouseMove = function (event) {
  var item = this.itemFromTarget(event);
  if (!item) return;

  if (this.options.showTooltips && this.options.tooltip.followMouse) {
    if (this.popup) {
      if (!this.popup.hidden) {
        var container = this.body.dom.centerContainer;
        this.popup.setPosition(event.clientX - util.getAbsoluteLeft(container) + container.offsetLeft, event.clientY - util.getAbsoluteTop(container) + container.offsetTop);
        this.popup.show(); // Redraw
      }
    }
  }
};

/**
 * Handle mousewheel
 * @param {Event}  event   The event
 * @private
 */
ItemSet.prototype._onMouseWheel = function (event) {
  if (this.touchParams.itemIsDragging) {
    this._onDragEnd(event);
  }
};

/**
 * Handle updates of an item on double tap
 * @param {vis.Item}  item   The item
 * @private
 */
ItemSet.prototype._onUpdateItem = function (item) {
  if (!this.options.selectable) return;
  if (!this.options.editable.add) return;

  var me = this;

  if (item) {
    // execute async handler to update the item (or cancel it)
    var itemData = me.itemsData.get(item.id); // get a clone of the data from the dataset
    this.options.onUpdate(itemData, function (itemData) {
      if (itemData) {
        me.itemsData.getDataSet().update(itemData);
      }
    });
  }
};

/**
 * Handle drop event of data on item
 * Only called when `objectData.target === 'item'.
 * @param {Event} event The event 
 * @private
 */
ItemSet.prototype._onDropObjectOnItem = function (event) {
  var item = this.itemFromTarget(event);
  var objectData = JSON.parse(event.dataTransfer.getData("text"));
  this.options.onDropObjectOnItem(objectData, item);
};

/**
 * Handle creation of an item on double tap or drop of a drag event
 * @param {Event} event   The event
 * @private
 */
ItemSet.prototype._onAddItem = function (event) {
  if (!this.options.selectable) return;
  if (!this.options.editable.add) return;

  var me = this;
  var snap = this.options.snap || null;
  var xAbs;
  var x;
  // add item
  if (this.options.rtl) {
    xAbs = util.getAbsoluteRight(this.dom.frame);
    x = xAbs - event.center.x;
  } else {
    xAbs = util.getAbsoluteLeft(this.dom.frame);
    x = event.center.x - xAbs;
  }
  // var xAbs = util.getAbsoluteLeft(this.dom.frame);
  // var x = event.center.x - xAbs;
  var start = this.body.util.toTime(x);
  var scale = this.body.util.getScale();
  var step = this.body.util.getStep();
  var end;

  var newItemData;
  if (event.type == 'drop') {
    newItemData = JSON.parse(event.dataTransfer.getData("text"));
    newItemData.content = newItemData.content ? newItemData.content : 'new item';
    newItemData.start = newItemData.start ? newItemData.start : snap ? snap(start, scale, step) : start;
    newItemData.type = newItemData.type || 'box';
    newItemData[this.itemsData._fieldId] = newItemData.id || util.randomUUID();

    if (newItemData.type == 'range' && !newItemData.end) {
      end = this.body.util.toTime(x + this.props.width / 5);
      newItemData.end = snap ? snap(end, scale, step) : end;
    }
  } else {
    newItemData = {
      start: snap ? snap(start, scale, step) : start,
      content: 'new item'
    };
    newItemData[this.itemsData._fieldId] = util.randomUUID();

    // when default type is a range, add a default end date to the new item
    if (this.options.type === 'range') {
      end = this.body.util.toTime(x + this.props.width / 5);
      newItemData.end = snap ? snap(end, scale, step) : end;
    }
  }

  var group = this.groupFromTarget(event);
  if (group) {
    newItemData.group = group.groupId;
  }

  // execute async handler to customize (or cancel) adding an item
  newItemData = this._cloneItemData(newItemData); // convert start and end to the correct type
  this.options.onAdd(newItemData, function (item) {
    if (item) {
      me.itemsData.getDataSet().add(item);
      if (event.type == 'drop') {
        me.setSelection([item.id]);
      }
      // TODO: need to trigger a redraw?
    }
  });
};

/**
 * Handle selecting/deselecting multiple items when holding an item
 * @param {Event} event
 * @private
 */
ItemSet.prototype._onMultiSelectItem = function (event) {
  if (!this.options.selectable) return;

  var item = this.itemFromTarget(event);

  if (item) {
    // multi select items (if allowed)

    var selection = this.options.multiselect ? this.getSelection() // take current selection
    : []; // deselect current selection

    var shiftKey = event.srcEvent && event.srcEvent.shiftKey || false;

    if (shiftKey && this.options.multiselect) {
      // select all items between the old selection and the tapped item
      var itemGroup = this.itemsData.get(item.id).group;

      // when filtering get the group of the last selected item
      var lastSelectedGroup = undefined;
      if (this.options.multiselectPerGroup) {
        if (selection.length > 0) {
          lastSelectedGroup = this.itemsData.get(selection[0]).group;
        }
      }

      // determine the selection range
      if (!this.options.multiselectPerGroup || lastSelectedGroup == undefined || lastSelectedGroup == itemGroup) {
        selection.push(item.id);
      }
      var range = ItemSet._getItemRange(this.itemsData.get(selection, this.itemOptions));

      if (!this.options.multiselectPerGroup || lastSelectedGroup == itemGroup) {
        // select all items within the selection range
        selection = [];
        for (var id in this.items) {
          if (this.items.hasOwnProperty(id)) {
            var _item = this.items[id];
            var start = _item.data.start;
            var end = _item.data.end !== undefined ? _item.data.end : start;

            if (start >= range.min && end <= range.max && (!this.options.multiselectPerGroup || lastSelectedGroup == this.itemsData.get(_item.id).group) && !(_item instanceof BackgroundItem)) {
              selection.push(_item.id); // do not use id but item.id, id itself is stringified
            }
          }
        }
      }
    } else {
      // add/remove this item from the current selection
      var index = selection.indexOf(item.id);
      if (index == -1) {
        // item is not yet selected -> select it
        selection.push(item.id);
      } else {
        // item is already selected -> deselect it
        selection.splice(index, 1);
      }
    }

    this.setSelection(selection);

    this.body.emitter.emit('select', {
      items: this.getSelection(),
      event: event
    });
  }
};

/**
 * Calculate the time range of a list of items
 * @param {Array.<Object>} itemsData
 * @return {{min: Date, max: Date}} Returns the range of the provided items
 * @private
 */
ItemSet._getItemRange = function (itemsData) {
  var max = null;
  var min = null;

  itemsData.forEach(function (data) {
    if (min == null || data.start < min) {
      min = data.start;
    }

    if (data.end != undefined) {
      if (max == null || data.end > max) {
        max = data.end;
      }
    } else {
      if (max == null || data.start > max) {
        max = data.start;
      }
    }
  });

  return {
    min: min,
    max: max
  };
};

/**
 * Find an item from an element:
 * searches for the attribute 'timeline-item' in the element's tree
 * @param {HTMLElement} element
 * @return {Item | null} item
 */
ItemSet.prototype.itemFromElement = function (element) {
  var cur = element;
  while (cur) {
    if (cur.hasOwnProperty('timeline-item')) {
      return cur['timeline-item'];
    }
    cur = cur.parentNode;
  }

  return null;
};

/**
 * Find an item from an event target:
 * searches for the attribute 'timeline-item' in the event target's element tree
 * @param {Event} event
 * @return {Item | null} item
 */
ItemSet.prototype.itemFromTarget = function (event) {
  return this.itemFromElement(event.target);
};

/**
 * Find an item from an event's related target:
 * searches for the attribute 'timeline-item' in the related target's element tree
 * @param {Event} event
 * @return {Item | null} item
 */
ItemSet.prototype.itemFromRelatedTarget = function (event) {
  return this.itemFromElement(event.relatedTarget);
};

/**
 * Find the Group from an event target:
 * searches for the attribute 'timeline-group' in the event target's element tree
 * @param {Event} event
 * @return {Group | null} group
 */
ItemSet.prototype.groupFromTarget = function (event) {
  var clientY = event.center ? event.center.y : event.clientY;
  var groupIds = this.groupIds;

  if (groupIds.length <= 0 && this.groupsData) {
    groupIds = this.groupsData.getIds({
      order: this.options.groupOrder
    });
  }

  for (var i = 0; i < groupIds.length; i++) {
    var groupId = groupIds[i];
    var group = this.groups[groupId];
    var foreground = group.dom.foreground;
    var top = util.getAbsoluteTop(foreground);
    if (clientY > top && clientY < top + foreground.offsetHeight) {
      return group;
    }

    if (this.options.orientation.item === 'top') {
      if (i === this.groupIds.length - 1 && clientY > top) {
        return group;
      }
    } else {
      if (i === 0 && clientY < top + foreground.offset) {
        return group;
      }
    }
  }

  return null;
};

/**
 * Find the ItemSet from an event target:
 * searches for the attribute 'timeline-itemset' in the event target's element tree
 * @param {Event} event
 * @return {ItemSet | null} item
 */
ItemSet.itemSetFromTarget = function (event) {
  var target = event.target;
  while (target) {
    if (target.hasOwnProperty('timeline-itemset')) {
      return target['timeline-itemset'];
    }
    target = target.parentNode;
  }

  return null;
};

/**
 * Clone the data of an item, and "normalize" it: convert the start and end date
 * to the type (Date, Moment, ...) configured in the DataSet. If not configured,
 * start and end are converted to Date.
 * @param {Object} itemData, typically `item.data`
 * @param {string} [type]  Optional Date type. If not provided, the type from the DataSet is taken
 * @return {Object} The cloned object
 * @private
 */
ItemSet.prototype._cloneItemData = function (itemData, type) {
  var clone = util.extend({}, itemData);

  if (!type) {
    // convert start and end date to the type (Date, Moment, ...) configured in the DataSet
    type = this.itemsData.getDataSet()._options.type;
  }

  if (clone.start != undefined) {
    clone.start = util.convert(clone.start, type && type.start || 'Date');
  }
  if (clone.end != undefined) {
    clone.end = util.convert(clone.end, type && type.end || 'Date');
  }

  return clone;
};

module.exports = ItemSet;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Utility functions for ordering and stacking of items
var EPSILON = 0.001; // used when checking collisions, to prevent round-off errors

/**
 * Order items by their start data
 * @param {Item[]} items
 */
exports.orderByStart = function (items) {
  items.sort(function (a, b) {
    return a.data.start - b.data.start;
  });
};

/**
 * Order items by their end date. If they have no end date, their start date
 * is used.
 * @param {Item[]} items
 */
exports.orderByEnd = function (items) {
  items.sort(function (a, b) {
    var aTime = 'end' in a.data ? a.data.end : a.data.start,
        bTime = 'end' in b.data ? b.data.end : b.data.start;

    return aTime - bTime;
  });
};

/**
 * Adjust vertical positions of the items such that they don't overlap each
 * other.
 * @param {Item[]} items
 *            All visible items
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 *            Margins between items and between items and the axis.
 * @param {boolean} [force=false]
 *            If true, all items will be repositioned. If false (default), only
 *            items having a top===null will be re-stacked
 */
exports.stack = function (items, margin, force) {
  if (force) {
    // reset top position of all items
    for (var i = 0; i < items.length; i++) {
      items[i].top = null;
    }
  }

  // calculate new, non-overlapping positions
  for (var i = 0; i < items.length; i++) {
    // eslint-disable-line no-redeclare
    var item = items[i];
    if (item.stack && item.top === null) {
      // initialize top position
      item.top = margin.axis;

      do {
        // TODO: optimize checking for overlap. when there is a gap without items,
        //       you only need to check for items from the next item on, not from zero
        var collidingItem = null;
        for (var j = 0, jj = items.length; j < jj; j++) {
          var other = items[j];
          if (other.top !== null && other !== item && other.stack && exports.collision(item, other, margin.item, other.options.rtl)) {
            collidingItem = other;
            break;
          }
        }

        if (collidingItem != null) {
          // There is a collision. Reposition the items above the colliding element
          item.top = collidingItem.top + collidingItem.height + margin.item.vertical;
        }
      } while (collidingItem);
    }
  }
};

/**
 * Adjust vertical positions of the items within a single subgroup such that they 
 * don't overlap each other.
 * @param {Item[]} items
 *            All items withina subgroup
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 *            Margins between items and between items and the axis.
 * @param {subgroup} subgroup
 *            The subgroup that is being stacked 
 */
exports.substack = function (items, margin, subgroup) {
  for (var i = 0; i < items.length; i++) {
    items[i].top = null;
  }

  // Set the initial height
  var subgroupHeight = subgroup.height;

  // calculate new, non-overlapping positions
  for (i = 0; i < items.length; i++) {
    var item = items[i];

    if (item.stack && item.top === null) {
      // initialize top position
      item.top = item.baseTop; //margin.axis + item.baseTop;

      do {
        // TODO: optimize checking for overlap. when there is a gap without items,
        //       you only need to check for items from the next item on, not from zero
        var collidingItem = null;
        for (var j = 0, jj = items.length; j < jj; j++) {
          var other = items[j];
          if (other.top !== null && other !== item /*&& other.stack*/ && exports.collision(item, other, margin.item, other.options.rtl)) {
            collidingItem = other;
            break;
          }
        }

        if (collidingItem != null) {
          // There is a collision. Reposition the items above the colliding element
          item.top = collidingItem.top + collidingItem.height + margin.item.vertical; // + item.baseTop;
        }

        if (item.top + item.height > subgroupHeight) {
          subgroupHeight = item.top + item.height;
        }
      } while (collidingItem);
    }
  }

  // Set the new height
  subgroup.height = subgroupHeight - subgroup.top + 0.5 * margin.item.vertical;
};

/**
 * Adjust vertical positions of the items without stacking them
 * @param {Item[]} items
 *            All visible items
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 *            Margins between items and between items and the axis.
 * @param {subgroups[]} subgroups
 *            All subgroups
 * @param {boolean} stackSubgroups
 */
exports.nostack = function (items, margin, subgroups, stackSubgroups) {
  for (var i = 0; i < items.length; i++) {
    if (items[i].data.subgroup == undefined) {
      items[i].top = margin.item.vertical;
    } else if (items[i].data.subgroup !== undefined && stackSubgroups) {
      var newTop = 0;
      for (var subgroup in subgroups) {
        if (subgroups.hasOwnProperty(subgroup)) {
          if (subgroups[subgroup].visible == true && subgroups[subgroup].index < subgroups[items[i].data.subgroup].index) {
            newTop += subgroups[subgroup].height;
            subgroups[items[i].data.subgroup].top = newTop;
          }
        }
      }
      items[i].top = newTop + 0.5 * margin.item.vertical;
    }
  }
  if (!stackSubgroups) {
    exports.stackSubgroups(items, margin, subgroups);
  }
};

/**
 * Adjust vertical positions of the subgroups such that they don't overlap each
 * other.
 * @param {Array.<vis.Item>} items
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin Margins between items and between items and the axis.
 * @param {subgroups[]} subgroups
 *            All subgroups
 */
exports.stackSubgroups = function (items, margin, subgroups) {
  for (var subgroup in subgroups) {
    if (subgroups.hasOwnProperty(subgroup)) {

      subgroups[subgroup].top = 0;
      do {
        // TODO: optimize checking for overlap. when there is a gap without items,
        //       you only need to check for items from the next item on, not from zero
        var collidingItem = null;
        for (var otherSubgroup in subgroups) {
          if (subgroups[otherSubgroup].top !== null && otherSubgroup !== subgroup && subgroups[subgroup].index > subgroups[otherSubgroup].index && exports.collisionByTimes(subgroups[subgroup], subgroups[otherSubgroup])) {
            collidingItem = subgroups[otherSubgroup];
            break;
          }
        }

        if (collidingItem != null) {
          // There is a collision. Reposition the subgroups above the colliding element
          subgroups[subgroup].top = collidingItem.top + collidingItem.height;
        }
      } while (collidingItem);
    }
  }
  for (var i = 0; i < items.length; i++) {
    if (items[i].data.subgroup !== undefined) {
      items[i].top = subgroups[items[i].data.subgroup].top + 0.5 * margin.item.vertical;
    }
  }
};

/**
 * Adjust vertical positions of the subgroups such that they don't overlap each
 * other, then stacks the contents of each subgroup individually.
 * @param {Item[]} subgroupItems
 *            All the items in a subgroup
 * @param {{item: {horizontal: number, vertical: number}, axis: number}} margin
 *            Margins between items and between items and the axis.
 * @param {subgroups[]} subgroups
 *            All subgroups 
 */
exports.stackSubgroupsWithInnerStack = function (subgroupItems, margin, subgroups) {
  var doSubStack = false;

  // Run subgroups in their order (if any)
  var subgroupOrder = [];

  for (var subgroup in subgroups) {
    if (subgroups[subgroup].hasOwnProperty("index")) {
      subgroupOrder[subgroups[subgroup].index] = subgroup;
    } else {
      subgroupOrder.push(subgroup);
    }
  }

  for (var j = 0; j < subgroupOrder.length; j++) {
    subgroup = subgroupOrder[j];
    if (subgroups.hasOwnProperty(subgroup)) {

      doSubStack = doSubStack || subgroups[subgroup].stack;
      subgroups[subgroup].top = 0;

      for (var otherSubgroup in subgroups) {
        if (subgroups[otherSubgroup].visible && subgroups[subgroup].index > subgroups[otherSubgroup].index) {
          subgroups[subgroup].top += subgroups[otherSubgroup].height;
        }
      }

      var items = subgroupItems[subgroup];
      for (var i = 0; i < items.length; i++) {
        if (items[i].data.subgroup !== undefined) {
          items[i].top = subgroups[items[i].data.subgroup].top + 0.5 * margin.item.vertical;

          if (subgroups[subgroup].stack) {
            items[i].baseTop = items[i].top;
          }
        }
      }

      if (doSubStack && subgroups[subgroup].stack) {
        exports.substack(subgroupItems[subgroup], margin, subgroups[subgroup]);
      }
    }
  }
};

/**
 * Test if the two provided items collide
 * The items must have parameters left, width, top, and height.
 * @param {Item} a          The first item
 * @param {Item} b          The second item
 * @param {{horizontal: number, vertical: number}} margin
 *                          An object containing a horizontal and vertical
 *                          minimum required margin.
 * @param {boolean} rtl
 * @return {boolean}        true if a and b collide, else false
 */
exports.collision = function (a, b, margin, rtl) {
  if (rtl) {
    return a.right - margin.horizontal + EPSILON < b.right + b.width && a.right + a.width + margin.horizontal - EPSILON > b.right && a.top - margin.vertical + EPSILON < b.top + b.height && a.top + a.height + margin.vertical - EPSILON > b.top;
  } else {
    return a.left - margin.horizontal + EPSILON < b.left + b.width && a.left + a.width + margin.horizontal - EPSILON > b.left && a.top - margin.vertical + EPSILON < b.top + b.height && a.top + a.height + margin.vertical - EPSILON > b.top;
  }
};

/**
 * Test if the two provided objects collide
 * The objects must have parameters start, end, top, and height.
 * @param {Object} a          The first Object
 * @param {Object} b          The second Object
 * @return {boolean}        true if a and b collide, else false
 */
exports.collisionByTimes = function (a, b) {
  return a.start <= b.start && a.end >= b.start && a.top < b.top + b.height && a.top + a.height > b.top || b.start <= a.start && b.end >= a.start && b.top < a.top + a.height && b.top + b.height > a.top;
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Item = __webpack_require__(38);

/**
 * @constructor BoxItem
 * @extends Item
 * @param {Object} data             Object containing parameters start
 *                                  content, className.
 * @param {{toScreen: function, toTime: function}} conversion
 *                                  Conversion functions from time to screen and vice versa
 * @param {Object} [options]        Configuration options
 *                                  // TODO: describe available options
 */
function BoxItem(data, conversion, options) {
  this.props = {
    dot: {
      width: 0,
      height: 0
    },
    line: {
      width: 0,
      height: 0
    }
  };
  this.options = options;
  // validate data
  if (data) {
    if (data.start == undefined) {
      throw new Error('Property "start" missing in item ' + data);
    }
  }

  Item.call(this, data, conversion, options);
}

BoxItem.prototype = new Item(null, null, null);

/**
 * Check whether this item is visible inside given range
 * @param {{start: number, end: number}} range with a timestamp for start and end
 * @returns {boolean} True if visible
 */
BoxItem.prototype.isVisible = function (range) {
  // determine visibility
  var isVisible;
  var align = this.options.align;
  var widthInMs = this.width * range.getMillisecondsPerPixel();

  if (align == 'right') {
    isVisible = this.data.start.getTime() > range.start && this.data.start.getTime() - widthInMs < range.end;
  } else if (align == 'left') {
    isVisible = this.data.start.getTime() + widthInMs > range.start && this.data.start.getTime() < range.end;
  } else {
    // default or 'center'
    isVisible = this.data.start.getTime() + widthInMs / 2 > range.start && this.data.start.getTime() - widthInMs / 2 < range.end;
  }
  return isVisible;
};

BoxItem.prototype._createDomElement = function () {
  if (!this.dom) {
    // create DOM
    this.dom = {};

    // create main box
    this.dom.box = document.createElement('DIV');

    // contents box (inside the background box). used for making margins
    this.dom.content = document.createElement('DIV');
    this.dom.content.className = 'vis-item-content';
    this.dom.box.appendChild(this.dom.content);

    // line to axis
    this.dom.line = document.createElement('DIV');
    this.dom.line.className = 'vis-line';

    // dot on axis
    this.dom.dot = document.createElement('DIV');
    this.dom.dot.className = 'vis-dot';

    // attach this item as attribute
    this.dom.box['timeline-item'] = this;

    this.dirty = true;
  }
};

BoxItem.prototype._appendDomElement = function () {
  if (!this.parent) {
    throw new Error('Cannot redraw item: no parent attached');
  }
  if (!this.dom.box.parentNode) {
    var foreground = this.parent.dom.foreground;
    if (!foreground) throw new Error('Cannot redraw item: parent has no foreground container element');
    foreground.appendChild(this.dom.box);
  }
  if (!this.dom.line.parentNode) {
    var background = this.parent.dom.background;
    if (!background) throw new Error('Cannot redraw item: parent has no background container element');
    background.appendChild(this.dom.line);
  }
  if (!this.dom.dot.parentNode) {
    var axis = this.parent.dom.axis;
    if (!background) throw new Error('Cannot redraw item: parent has no axis container element');
    axis.appendChild(this.dom.dot);
  }
  this.displayed = true;
};

BoxItem.prototype._updateDirtyDomComponents = function () {
  // An item is marked dirty when:
  // - the item is not yet rendered
  // - the item's data is changed
  // - the item is selected/deselected
  if (this.dirty) {
    this._updateContents(this.dom.content);
    this._updateDataAttributes(this.dom.box);
    this._updateStyle(this.dom.box);

    var editable = this.editable.updateTime || this.editable.updateGroup;

    // update class
    var className = (this.data.className ? ' ' + this.data.className : '') + (this.selected ? ' vis-selected' : '') + (editable ? ' vis-editable' : ' vis-readonly');
    this.dom.box.className = 'vis-item vis-box' + className;
    this.dom.line.className = 'vis-item vis-line' + className;
    this.dom.dot.className = 'vis-item vis-dot' + className;
  }
};

BoxItem.prototype._getDomComponentsSizes = function () {
  return {
    previous: {
      right: this.dom.box.style.right,
      left: this.dom.box.style.left
    },
    dot: {
      height: this.dom.dot.offsetHeight,
      width: this.dom.dot.offsetWidth
    },
    line: {
      width: this.dom.line.offsetWidth
    },
    box: {
      width: this.dom.box.offsetWidth,
      height: this.dom.box.offsetHeight
    }
  };
};

BoxItem.prototype._updateDomComponentsSizes = function (sizes) {
  if (this.options.rtl) {
    this.dom.box.style.right = "0px";
  } else {
    this.dom.box.style.left = "0px";
  }

  // recalculate size
  this.props.dot.height = sizes.dot.height;
  this.props.dot.width = sizes.dot.width;
  this.props.line.width = sizes.line.width;
  this.width = sizes.box.width;
  this.height = sizes.box.height;

  // restore previous position
  if (this.options.rtl) {
    this.dom.box.style.right = sizes.previous.right;
  } else {
    this.dom.box.style.left = sizes.previous.left;
  }

  this.dirty = false;
};

BoxItem.prototype._repaintDomAdditionals = function () {
  this._repaintOnItemUpdateTimeTooltip(this.dom.box);
  this._repaintDragCenter();
  this._repaintDeleteButton(this.dom.box);
};

/**
 * Repaint the item
 * @param {boolean} [returnQueue=false]  return the queue
 * @return {boolean} the redraw queue if returnQueue=true
 */
BoxItem.prototype.redraw = function (returnQueue) {
  var sizes;
  var queue = [
  // create item DOM
  this._createDomElement.bind(this),

  // append DOM to parent DOM
  this._appendDomElement.bind(this),

  // update dirty DOM
  this._updateDirtyDomComponents.bind(this), function () {
    if (this.dirty) {
      sizes = this._getDomComponentsSizes();
    }
  }.bind(this), function () {
    if (this.dirty) {
      this._updateDomComponentsSizes.bind(this)(sizes);
    }
  }.bind(this),

  // repaint DOM additionals
  this._repaintDomAdditionals.bind(this)];

  if (returnQueue) {
    return queue;
  } else {
    var result;
    queue.forEach(function (fn) {
      result = fn();
    });
    return result;
  }
};

/**
 * Show the item in the DOM (when not already displayed). The items DOM will
 * be created when needed.
 */
BoxItem.prototype.show = function () {
  if (!this.displayed) {
    this.redraw();
  }
};

/**
 * Hide the item from the DOM (when visible)
 */
BoxItem.prototype.hide = function () {
  if (this.displayed) {
    var dom = this.dom;

    if (dom.box.parentNode) dom.box.parentNode.removeChild(dom.box);
    if (dom.line.parentNode) dom.line.parentNode.removeChild(dom.line);
    if (dom.dot.parentNode) dom.dot.parentNode.removeChild(dom.dot);

    this.displayed = false;
  }
};

/**
 * Reposition the item horizontally
 * @Override
 */
BoxItem.prototype.repositionX = function () {
  var start = this.conversion.toScreen(this.data.start);
  var align = this.options.align;

  // calculate left position of the box
  if (align == 'right') {
    if (this.options.rtl) {
      this.right = start - this.width;

      // reposition box, line, and dot
      this.dom.box.style.right = this.right + 'px';
      this.dom.line.style.right = start - this.props.line.width + 'px';
      this.dom.dot.style.right = start - this.props.line.width / 2 - this.props.dot.width / 2 + 'px';
    } else {
      this.left = start - this.width;

      // reposition box, line, and dot
      this.dom.box.style.left = this.left + 'px';
      this.dom.line.style.left = start - this.props.line.width + 'px';
      this.dom.dot.style.left = start - this.props.line.width / 2 - this.props.dot.width / 2 + 'px';
    }
  } else if (align == 'left') {
    if (this.options.rtl) {
      this.right = start;

      // reposition box, line, and dot
      this.dom.box.style.right = this.right + 'px';
      this.dom.line.style.right = start + 'px';
      this.dom.dot.style.right = start + this.props.line.width / 2 - this.props.dot.width / 2 + 'px';
    } else {
      this.left = start;

      // reposition box, line, and dot
      this.dom.box.style.left = this.left + 'px';
      this.dom.line.style.left = start + 'px';
      this.dom.dot.style.left = start + this.props.line.width / 2 - this.props.dot.width / 2 + 'px';
    }
  } else {
    // default or 'center'
    if (this.options.rtl) {
      this.right = start - this.width / 2;

      // reposition box, line, and dot
      this.dom.box.style.right = this.right + 'px';
      this.dom.line.style.right = start - this.props.line.width + 'px';
      this.dom.dot.style.right = start - this.props.dot.width / 2 + 'px';
    } else {
      this.left = start - this.width / 2;

      // reposition box, line, and dot
      this.dom.box.style.left = this.left + 'px';
      this.dom.line.style.left = start - this.props.line.width / 2 + 'px';
      this.dom.dot.style.left = start - this.props.dot.width / 2 + 'px';
    }
  }
};

/**
 * Reposition the item vertically
 * @Override
 */
BoxItem.prototype.repositionY = function () {
  var orientation = this.options.orientation.item;
  var box = this.dom.box;
  var line = this.dom.line;
  var dot = this.dom.dot;

  if (orientation == 'top') {
    box.style.top = (this.top || 0) + 'px';

    line.style.top = '0';
    line.style.height = this.parent.top + this.top + 1 + 'px';
    line.style.bottom = '';
  } else {
    // orientation 'bottom'
    var itemSetHeight = this.parent.itemSet.props.height; // TODO: this is nasty
    var lineHeight = itemSetHeight - this.parent.top - this.parent.height + this.top;

    box.style.top = (this.parent.height - this.top - this.height || 0) + 'px';
    line.style.top = itemSetHeight - lineHeight + 'px';
    line.style.bottom = '0';
  }

  dot.style.top = -this.props.dot.height / 2 + 'px';
};

/**
 * Return the width of the item left from its start date
 * @return {number}
 */
BoxItem.prototype.getWidthLeft = function () {
  return this.width / 2;
};

/**
 * Return the width of the item right from its start date
 * @return {number}
 */
BoxItem.prototype.getWidthRight = function () {
  return this.width / 2;
};

module.exports = BoxItem;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Item = __webpack_require__(38);

/**
 * @constructor PointItem
 * @extends Item
 * @param {Object} data             Object containing parameters start
 *                                  content, className.
 * @param {{toScreen: function, toTime: function}} conversion
 *                                  Conversion functions from time to screen and vice versa
 * @param {Object} [options]        Configuration options
 *                                  // TODO: describe available options
 */
function PointItem(data, conversion, options) {
  this.props = {
    dot: {
      top: 0,
      width: 0,
      height: 0
    },
    content: {
      height: 0,
      marginLeft: 0,
      marginRight: 0
    }
  };
  this.options = options;
  // validate data
  if (data) {
    if (data.start == undefined) {
      throw new Error('Property "start" missing in item ' + data);
    }
  }

  Item.call(this, data, conversion, options);
}

PointItem.prototype = new Item(null, null, null);

/**
 * Check whether this item is visible inside given range
 * @param {{start: number, end: number}} range with a timestamp for start and end
 * @returns {boolean} True if visible
 */
PointItem.prototype.isVisible = function (range) {
  // determine visibility
  var widthInMs = this.width * range.getMillisecondsPerPixel();

  return this.data.start.getTime() + widthInMs > range.start && this.data.start < range.end;
};

PointItem.prototype._createDomElement = function () {
  if (!this.dom) {
    // create DOM
    this.dom = {};

    // background box
    this.dom.point = document.createElement('div');
    // className is updated in redraw()

    // contents box, right from the dot
    this.dom.content = document.createElement('div');
    this.dom.content.className = 'vis-item-content';
    this.dom.point.appendChild(this.dom.content);

    // dot at start
    this.dom.dot = document.createElement('div');
    this.dom.point.appendChild(this.dom.dot);

    // attach this item as attribute
    this.dom.point['timeline-item'] = this;

    this.dirty = true;
  }
};

PointItem.prototype._appendDomElement = function () {
  if (!this.parent) {
    throw new Error('Cannot redraw item: no parent attached');
  }
  if (!this.dom.point.parentNode) {
    var foreground = this.parent.dom.foreground;
    if (!foreground) {
      throw new Error('Cannot redraw item: parent has no foreground container element');
    }
    foreground.appendChild(this.dom.point);
  }
  this.displayed = true;
};

PointItem.prototype._updateDirtyDomComponents = function () {
  // An item is marked dirty when:
  // - the item is not yet rendered
  // - the item's data is changed
  // - the item is selected/deselected
  if (this.dirty) {
    this._updateContents(this.dom.content);
    this._updateDataAttributes(this.dom.point);
    this._updateStyle(this.dom.point);

    var editable = this.editable.updateTime || this.editable.updateGroup;
    // update class
    var className = (this.data.className ? ' ' + this.data.className : '') + (this.selected ? ' vis-selected' : '') + (editable ? ' vis-editable' : ' vis-readonly');
    this.dom.point.className = 'vis-item vis-point' + className;
    this.dom.dot.className = 'vis-item vis-dot' + className;
  }
};

PointItem.prototype._getDomComponentsSizes = function () {
  return {
    dot: {
      width: this.dom.dot.offsetWidth,
      height: this.dom.dot.offsetHeight
    },
    content: {
      width: this.dom.content.offsetWidth,
      height: this.dom.content.offsetHeight
    },
    point: {
      width: this.dom.point.offsetWidth,
      height: this.dom.point.offsetHeight
    }
  };
};

PointItem.prototype._updateDomComponentsSizes = function (sizes) {
  // recalculate size of dot and contents
  this.props.dot.width = sizes.dot.width;
  this.props.dot.height = sizes.dot.height;
  this.props.content.height = sizes.content.height;

  // resize contents
  if (this.options.rtl) {
    this.dom.content.style.marginRight = 2 * this.props.dot.width + 'px';
  } else {
    this.dom.content.style.marginLeft = 2 * this.props.dot.width + 'px';
  }
  //this.dom.content.style.marginRight = ... + 'px'; // TODO: margin right

  // recalculate size
  this.width = sizes.point.width;
  this.height = sizes.point.height;

  // reposition the dot
  this.dom.dot.style.top = (this.height - this.props.dot.height) / 2 + 'px';
  if (this.options.rtl) {
    this.dom.dot.style.right = this.props.dot.width / 2 + 'px';
  } else {
    this.dom.dot.style.left = this.props.dot.width / 2 + 'px';
  }

  this.dirty = false;
};

PointItem.prototype._repaintDomAdditionals = function () {
  this._repaintOnItemUpdateTimeTooltip(this.dom.point);
  this._repaintDragCenter();
  this._repaintDeleteButton(this.dom.point);
};

/**
 * Repaint the item
 * @param {boolean} [returnQueue=false]  return the queue
 * @return {boolean} the redraw queue if returnQueue=true
 */
PointItem.prototype.redraw = function (returnQueue) {
  var sizes;
  var queue = [
  // create item DOM
  this._createDomElement.bind(this),

  // append DOM to parent DOM
  this._appendDomElement.bind(this),

  // update dirty DOM
  this._updateDirtyDomComponents.bind(this), function () {
    if (this.dirty) {
      sizes = this._getDomComponentsSizes();
    }
  }.bind(this), function () {
    if (this.dirty) {
      this._updateDomComponentsSizes.bind(this)(sizes);
    }
  }.bind(this),

  // repaint DOM additionals
  this._repaintDomAdditionals.bind(this)];

  if (returnQueue) {
    return queue;
  } else {
    var result;
    queue.forEach(function (fn) {
      result = fn();
    });
    return result;
  }
};

/**
 * Show the item in the DOM (when not already visible). The items DOM will
 * be created when needed.
 */
PointItem.prototype.show = function () {
  if (!this.displayed) {
    this.redraw();
  }
};

/**
 * Hide the item from the DOM (when visible)
 */
PointItem.prototype.hide = function () {
  if (this.displayed) {
    if (this.dom.point.parentNode) {
      this.dom.point.parentNode.removeChild(this.dom.point);
    }

    this.displayed = false;
  }
};

/**
 * Reposition the item horizontally
 * @Override
 */
PointItem.prototype.repositionX = function () {
  var start = this.conversion.toScreen(this.data.start);

  if (this.options.rtl) {
    this.right = start - this.props.dot.width;

    // reposition point
    this.dom.point.style.right = this.right + 'px';
  } else {
    this.left = start - this.props.dot.width;

    // reposition point
    this.dom.point.style.left = this.left + 'px';
  }
};

/**
 * Reposition the item vertically
 * @Override
 */
PointItem.prototype.repositionY = function () {
  var orientation = this.options.orientation.item;
  var point = this.dom.point;
  if (orientation == 'top') {
    point.style.top = this.top + 'px';
  } else {
    point.style.top = this.parent.height - this.top - this.height + 'px';
  }
};

/**
 * Return the width of the item left from its start date
 * @return {number}
 */
PointItem.prototype.getWidthLeft = function () {
  return this.props.dot.width;
};

/**
 * Return the width of the item right from  its start date
 * @return {number}
 */
PointItem.prototype.getWidthRight = function () {
  return this.props.dot.width;
};

module.exports = PointItem;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Item = __webpack_require__(38);
var BackgroundGroup = __webpack_require__(69);
var RangeItem = __webpack_require__(70);

/**
 * @constructor BackgroundItem
 * @extends Item
 * @param {Object} data             Object containing parameters start, end
 *                                  content, className.
 * @param {{toScreen: function, toTime: function}} conversion
 *                                  Conversion functions from time to screen and vice versa
 * @param {Object} [options]        Configuration options
 *                                  // TODO: describe options
 * // TODO: implement support for the BackgroundItem just having a start, then being displayed as a sort of an annotation
 */
function BackgroundItem(data, conversion, options) {
  this.props = {
    content: {
      width: 0
    }
  };
  this.overflow = false; // if contents can overflow (css styling), this flag is set to true

  // validate data
  if (data) {
    if (data.start == undefined) {
      throw new Error('Property "start" missing in item ' + data.id);
    }
    if (data.end == undefined) {
      throw new Error('Property "end" missing in item ' + data.id);
    }
  }

  Item.call(this, data, conversion, options);
}

BackgroundItem.prototype = new Item(null, null, null);

BackgroundItem.prototype.baseClassName = 'vis-item vis-background';

BackgroundItem.prototype.stack = false;

/**
 * Check whether this item is visible inside given range
 * @param {vis.Range} range with a timestamp for start and end
 * @returns {boolean} True if visible
 */
BackgroundItem.prototype.isVisible = function (range) {
  // determine visibility
  return this.data.start < range.end && this.data.end > range.start;
};

BackgroundItem.prototype._createDomElement = function () {
  if (!this.dom) {
    // create DOM
    this.dom = {};

    // background box
    this.dom.box = document.createElement('div');
    // className is updated in redraw()

    // frame box (to prevent the item contents from overflowing
    this.dom.frame = document.createElement('div');
    this.dom.frame.className = 'vis-item-overflow';
    this.dom.box.appendChild(this.dom.frame);

    // contents box
    this.dom.content = document.createElement('div');
    this.dom.content.className = 'vis-item-content';
    this.dom.frame.appendChild(this.dom.content);

    // Note: we do NOT attach this item as attribute to the DOM,
    //       such that background items cannot be selected
    //this.dom.box['timeline-item'] = this;

    this.dirty = true;
  }
};

BackgroundItem.prototype._appendDomElement = function () {
  if (!this.parent) {
    throw new Error('Cannot redraw item: no parent attached');
  }
  if (!this.dom.box.parentNode) {
    var background = this.parent.dom.background;
    if (!background) {
      throw new Error('Cannot redraw item: parent has no background container element');
    }
    background.appendChild(this.dom.box);
  }
  this.displayed = true;
};

BackgroundItem.prototype._updateDirtyDomComponents = function () {
  // update dirty DOM. An item is marked dirty when:
  // - the item is not yet rendered
  // - the item's data is changed
  // - the item is selected/deselected
  if (this.dirty) {
    this._updateContents(this.dom.content);
    this._updateDataAttributes(this.dom.content);
    this._updateStyle(this.dom.box);

    // update class
    var className = (this.data.className ? ' ' + this.data.className : '') + (this.selected ? ' vis-selected' : '');
    this.dom.box.className = this.baseClassName + className;
  }
};

BackgroundItem.prototype._getDomComponentsSizes = function () {
  // determine from css whether this box has overflow
  this.overflow = window.getComputedStyle(this.dom.content).overflow !== 'hidden';
  return {
    content: {
      width: this.dom.content.offsetWidth
    }
  };
};

BackgroundItem.prototype._updateDomComponentsSizes = function (sizes) {
  // recalculate size
  this.props.content.width = sizes.content.width;
  this.height = 0; // set height zero, so this item will be ignored when stacking items

  this.dirty = false;
};

BackgroundItem.prototype._repaintDomAdditionals = function () {};

/**
 * Repaint the item
 * @param {boolean} [returnQueue=false]  return the queue
 * @return {boolean} the redraw result or the redraw queue if returnQueue=true
 */
BackgroundItem.prototype.redraw = function (returnQueue) {
  var sizes;
  var queue = [
  // create item DOM
  this._createDomElement.bind(this),

  // append DOM to parent DOM
  this._appendDomElement.bind(this), this._updateDirtyDomComponents.bind(this), function () {
    if (this.dirty) {
      sizes = this._getDomComponentsSizes.bind(this)();
    }
  }.bind(this), function () {
    if (this.dirty) {
      this._updateDomComponentsSizes.bind(this)(sizes);
    }
  }.bind(this),

  // repaint DOM additionals
  this._repaintDomAdditionals.bind(this)];

  if (returnQueue) {
    return queue;
  } else {
    var result;
    queue.forEach(function (fn) {
      result = fn();
    });
    return result;
  }
};

/**
 * Show the item in the DOM (when not already visible). The items DOM will
 * be created when needed.
 */
BackgroundItem.prototype.show = RangeItem.prototype.show;

/**
 * Hide the item from the DOM (when visible)
 * @return {Boolean} changed
 */
BackgroundItem.prototype.hide = RangeItem.prototype.hide;

/**
 * Reposition the item horizontally
 * @Override
 */
BackgroundItem.prototype.repositionX = RangeItem.prototype.repositionX;

/**
 * Reposition the item vertically
 * @Override
 */
BackgroundItem.prototype.repositionY = function (margin) {
  // eslint-disable-line no-unused-vars
  var height;
  var orientation = this.options.orientation.item;

  // special positioning for subgroups
  if (this.data.subgroup !== undefined) {
    // TODO: instead of calculating the top position of the subgroups here for every BackgroundItem, calculate the top of the subgroup once in Itemset
    var itemSubgroup = this.data.subgroup;

    this.dom.box.style.height = this.parent.subgroups[itemSubgroup].height + 'px';

    if (orientation == 'top') {
      this.dom.box.style.top = this.parent.top + this.parent.subgroups[itemSubgroup].top + 'px';
    } else {
      this.dom.box.style.top = this.parent.top + this.parent.height - this.parent.subgroups[itemSubgroup].top - this.parent.subgroups[itemSubgroup].height + 'px';
    }
    this.dom.box.style.bottom = '';
  }
  // and in the case of no subgroups:
  else {
      // we want backgrounds with groups to only show in groups.
      if (this.parent instanceof BackgroundGroup) {
        // if the item is not in a group:
        height = Math.max(this.parent.height, this.parent.itemSet.body.domProps.center.height, this.parent.itemSet.body.domProps.centerContainer.height);
        this.dom.box.style.bottom = orientation == 'bottom' ? '0' : '';
        this.dom.box.style.top = orientation == 'top' ? '0' : '';
      } else {
        height = this.parent.height;
        // same alignment for items when orientation is top or bottom
        this.dom.box.style.top = this.parent.top + 'px';
        this.dom.box.style.bottom = '';
      }
    }
  this.dom.box.style.height = height + 'px';
};

module.exports = BackgroundItem;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Popup is a class to create a popup window with some text
 */
var Popup = function () {
  /**
   * @param {Element} container       The container object.
   * @param {string}  overflowMethod  How the popup should act to overflowing ('flip' or 'cap')
   */
  function Popup(container, overflowMethod) {
    (0, _classCallCheck3['default'])(this, Popup);

    this.container = container;
    this.overflowMethod = overflowMethod || 'cap';

    this.x = 0;
    this.y = 0;
    this.padding = 5;
    this.hidden = false;

    // create the frame
    this.frame = document.createElement('div');
    this.frame.className = 'vis-tooltip';
    this.container.appendChild(this.frame);
  }

  /**
   * @param {number} x   Horizontal position of the popup window
   * @param {number} y   Vertical position of the popup window
   */


  (0, _createClass3['default'])(Popup, [{
    key: 'setPosition',
    value: function setPosition(x, y) {
      this.x = parseInt(x);
      this.y = parseInt(y);
    }

    /**
     * Set the content for the popup window. This can be HTML code or text.
     * @param {string | Element} content
     */

  }, {
    key: 'setText',
    value: function setText(content) {
      if (content instanceof Element) {
        this.frame.innerHTML = '';
        this.frame.appendChild(content);
      } else {
        this.frame.innerHTML = content; // string containing text or HTML
      }
    }

    /**
     * Show the popup window
     * @param {boolean} [doShow]    Show or hide the window
     */

  }, {
    key: 'show',
    value: function show(doShow) {
      if (doShow === undefined) {
        doShow = true;
      }

      if (doShow === true) {
        var height = this.frame.clientHeight;
        var width = this.frame.clientWidth;
        var maxHeight = this.frame.parentNode.clientHeight;
        var maxWidth = this.frame.parentNode.clientWidth;

        var left = 0,
            top = 0;

        if (this.overflowMethod == 'flip') {
          var isLeft = false,
              isTop = true; // Where around the position it's located

          if (this.y - height < this.padding) {
            isTop = false;
          }

          if (this.x + width > maxWidth - this.padding) {
            isLeft = true;
          }

          if (isLeft) {
            left = this.x - width;
          } else {
            left = this.x;
          }

          if (isTop) {
            top = this.y - height;
          } else {
            top = this.y;
          }
        } else {
          top = this.y - height;
          if (top + height + this.padding > maxHeight) {
            top = maxHeight - height - this.padding;
          }
          if (top < this.padding) {
            top = this.padding;
          }

          left = this.x;
          if (left + width + this.padding > maxWidth) {
            left = maxWidth - width - this.padding;
          }
          if (left < this.padding) {
            left = this.padding;
          }
        }

        this.frame.style.left = left + "px";
        this.frame.style.top = top + "px";
        this.frame.style.visibility = "visible";
        this.hidden = false;
      } else {
        this.hide();
      }
    }

    /**
     * Hide the popup window
     */

  }, {
    key: 'hide',
    value: function hide() {
      this.hidden = true;
      this.frame.style.left = "0";
      this.frame.style.top = "0";
      this.frame.style.visibility = "hidden";
    }

    /**
     * Remove the popup window
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this.frame.parentNode.removeChild(this.frame); // Remove element from DOM
    }
  }]);
  return Popup;
}();

exports['default'] = Popup;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This object contains all possible options. It will check if the types are correct, if required if the option is one
 * of the allowed values.
 *
 * __any__ means that the name of the property does not matter.
 * __type__ is a required field for all objects and contains the allowed types of all objects
 */
var string = 'string';
var bool = 'boolean';
var number = 'number';
var array = 'array';
var date = 'date';
var object = 'object'; // should only be in a __type__ property
var dom = 'dom';
var moment = 'moment';
var any = 'any';

var allOptions = {
  configure: {
    enabled: { 'boolean': bool },
    filter: { 'boolean': bool, 'function': 'function' },
    container: { dom: dom },
    __type__: { object: object, 'boolean': bool, 'function': 'function' }
  },

  //globals :
  align: { string: string },
  rtl: { 'boolean': bool, 'undefined': 'undefined' },
  rollingMode: {
    follow: { 'boolean': bool },
    offset: { number: number, 'undefined': 'undefined' },
    __type__: { object: object }
  },
  verticalScroll: { 'boolean': bool, 'undefined': 'undefined' },
  horizontalScroll: { 'boolean': bool, 'undefined': 'undefined' },
  autoResize: { 'boolean': bool },
  throttleRedraw: { number: number }, // TODO: DEPRICATED see https://github.com/almende/vis/issues/2511
  clickToUse: { 'boolean': bool },
  dataAttributes: { string: string, array: array },
  editable: {
    add: { 'boolean': bool, 'undefined': 'undefined' },
    remove: { 'boolean': bool, 'undefined': 'undefined' },
    updateGroup: { 'boolean': bool, 'undefined': 'undefined' },
    updateTime: { 'boolean': bool, 'undefined': 'undefined' },
    overrideItems: { 'boolean': bool, 'undefined': 'undefined' },
    __type__: { 'boolean': bool, object: object }
  },
  end: { number: number, date: date, string: string, moment: moment },
  format: {
    minorLabels: {
      millisecond: { string: string, 'undefined': 'undefined' },
      second: { string: string, 'undefined': 'undefined' },
      minute: { string: string, 'undefined': 'undefined' },
      hour: { string: string, 'undefined': 'undefined' },
      weekday: { string: string, 'undefined': 'undefined' },
      day: { string: string, 'undefined': 'undefined' },
      week: { string: string, 'undefined': 'undefined' },
      month: { string: string, 'undefined': 'undefined' },
      year: { string: string, 'undefined': 'undefined' },
      __type__: { object: object, 'function': 'function' }
    },
    majorLabels: {
      millisecond: { string: string, 'undefined': 'undefined' },
      second: { string: string, 'undefined': 'undefined' },
      minute: { string: string, 'undefined': 'undefined' },
      hour: { string: string, 'undefined': 'undefined' },
      weekday: { string: string, 'undefined': 'undefined' },
      day: { string: string, 'undefined': 'undefined' },
      week: { string: string, 'undefined': 'undefined' },
      month: { string: string, 'undefined': 'undefined' },
      year: { string: string, 'undefined': 'undefined' },
      __type__: { object: object, 'function': 'function' }
    },
    __type__: { object: object }
  },
  moment: { 'function': 'function' },
  groupOrder: { string: string, 'function': 'function' },
  groupEditable: {
    add: { 'boolean': bool, 'undefined': 'undefined' },
    remove: { 'boolean': bool, 'undefined': 'undefined' },
    order: { 'boolean': bool, 'undefined': 'undefined' },
    __type__: { 'boolean': bool, object: object }
  },
  groupOrderSwap: { 'function': 'function' },
  height: { string: string, number: number },
  hiddenDates: {
    start: { date: date, number: number, string: string, moment: moment },
    end: { date: date, number: number, string: string, moment: moment },
    repeat: { string: string },
    __type__: { object: object, array: array }
  },
  itemsAlwaysDraggable: {
    item: { 'boolean': bool, 'undefined': 'undefined' },
    range: { 'boolean': bool, 'undefined': 'undefined' },
    __type__: { 'boolean': bool, object: object }
  },
  limitSize: { 'boolean': bool },
  locale: { string: string },
  locales: {
    __any__: { any: any },
    __type__: { object: object }
  },
  margin: {
    axis: { number: number },
    item: {
      horizontal: { number: number, 'undefined': 'undefined' },
      vertical: { number: number, 'undefined': 'undefined' },
      __type__: { object: object, number: number }
    },
    __type__: { object: object, number: number }
  },
  max: { date: date, number: number, string: string, moment: moment },
  maxHeight: { number: number, string: string },
  maxMinorChars: { number: number },
  min: { date: date, number: number, string: string, moment: moment },
  minHeight: { number: number, string: string },
  moveable: { 'boolean': bool },
  multiselect: { 'boolean': bool },
  multiselectPerGroup: { 'boolean': bool },
  onAdd: { 'function': 'function' },
  onDropObjectOnItem: { 'function': 'function' },
  onUpdate: { 'function': 'function' },
  onMove: { 'function': 'function' },
  onMoving: { 'function': 'function' },
  onRemove: { 'function': 'function' },
  onAddGroup: { 'function': 'function' },
  onMoveGroup: { 'function': 'function' },
  onRemoveGroup: { 'function': 'function' },
  onInitialDrawComplete: { 'function': 'function' },
  order: { 'function': 'function' },
  orientation: {
    axis: { string: string, 'undefined': 'undefined' },
    item: { string: string, 'undefined': 'undefined' },
    __type__: { string: string, object: object }
  },
  selectable: { 'boolean': bool },
  showCurrentTime: { 'boolean': bool },
  showMajorLabels: { 'boolean': bool },
  showMinorLabels: { 'boolean': bool },
  stack: { 'boolean': bool },
  stackSubgroups: { 'boolean': bool },
  snap: { 'function': 'function', 'null': 'null' },
  start: { date: date, number: number, string: string, moment: moment },
  template: { 'function': 'function' },
  groupTemplate: { 'function': 'function' },
  visibleFrameTemplate: { string: string, 'function': 'function' },
  showTooltips: { 'boolean': bool },
  tooltip: {
    followMouse: { 'boolean': bool },
    overflowMethod: { 'string': ['cap', 'flip'] },
    __type__: { object: object }
  },
  tooltipOnItemUpdateTime: {
    template: { 'function': 'function' },
    __type__: { 'boolean': bool, object: object }
  },
  timeAxis: {
    scale: { string: string, 'undefined': 'undefined' },
    step: { number: number, 'undefined': 'undefined' },
    __type__: { object: object }
  },
  type: { string: string },
  width: { string: string, number: number },
  zoomable: { 'boolean': bool },
  zoomKey: { string: ['ctrlKey', 'altKey', 'metaKey', ''] },
  zoomMax: { number: number },
  zoomMin: { number: number },

  __type__: { object: object }
};

var configureOptions = {
  global: {
    align: ['center', 'left', 'right'],
    direction: false,
    autoResize: true,
    clickToUse: false,
    // dataAttributes: ['all'], // FIXME: can be 'all' or string[]
    editable: {
      add: false,
      remove: false,
      updateGroup: false,
      updateTime: false
    },
    end: '',
    format: {
      minorLabels: {
        millisecond: 'SSS',
        second: 's',
        minute: 'HH:mm',
        hour: 'HH:mm',
        weekday: 'ddd D',
        day: 'D',
        week: 'w',
        month: 'MMM',
        year: 'YYYY'
      },
      majorLabels: {
        millisecond: 'HH:mm:ss',
        second: 'D MMMM HH:mm',
        minute: 'ddd D MMMM',
        hour: 'ddd D MMMM',
        weekday: 'MMMM YYYY',
        day: 'MMMM YYYY',
        week: 'MMMM YYYY',
        month: 'YYYY',
        year: ''
      }
    },

    //groupOrder: {string, 'function': 'function'},
    groupsDraggable: false,
    height: '',
    //hiddenDates: {object, array},
    locale: '',
    margin: {
      axis: [20, 0, 100, 1],
      item: {
        horizontal: [10, 0, 100, 1],
        vertical: [10, 0, 100, 1]
      }
    },
    max: '',
    maxHeight: '',
    maxMinorChars: [7, 0, 20, 1],
    min: '',
    minHeight: '',
    moveable: false,
    multiselect: false,
    multiselectPerGroup: false,
    //onAdd: {'function': 'function'},
    //onUpdate: {'function': 'function'},
    //onMove: {'function': 'function'},
    //onMoving: {'function': 'function'},
    //onRename: {'function': 'function'},
    //order: {'function': 'function'},
    orientation: {
      axis: ['both', 'bottom', 'top'],
      item: ['bottom', 'top']
    },
    selectable: true,
    showCurrentTime: false,
    showMajorLabels: true,
    showMinorLabels: true,
    stack: true,
    stackSubgroups: true,
    //snap: {'function': 'function', nada},
    start: '',
    //template: {'function': 'function'},
    //timeAxis: {
    //  scale: ['millisecond', 'second', 'minute', 'hour', 'weekday', 'day', 'week', 'month', 'year'],
    //  step: [1, 1, 10, 1]
    //},
    showTooltips: true,
    tooltip: {
      followMouse: false,
      overflowMethod: 'flip'
    },
    tooltipOnItemUpdateTime: false,
    type: ['box', 'point', 'range', 'background'],
    width: '100%',
    zoomable: true,
    zoomKey: ['ctrlKey', 'altKey', 'metaKey', ''],
    zoomMax: [315360000000000, 10, 315360000000000, 1],
    zoomMin: [10, 10, 315360000000000, 1]
  }
};

exports.allOptions = allOptions;
exports.configureOptions = configureOptions;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var DOMutil = __webpack_require__(14);
var DataSet = __webpack_require__(11);
var DataView = __webpack_require__(12);
var Component = __webpack_require__(16);
var DataAxis = __webpack_require__(107);
var GraphGroup = __webpack_require__(109);
var Legend = __webpack_require__(112);
var Bars = __webpack_require__(110);
var Lines = __webpack_require__(111);
var Points = __webpack_require__(72);

var UNGROUPED = '__ungrouped__'; // reserved group id for ungrouped items

/**
 * This is the constructor of the LineGraph. It requires a Timeline body and options.
 *
 * @param {vis.Timeline.body} body
 * @param {Object} options
 * @constructor LineGraph
 * @extends Component
 */
function LineGraph(body, options) {
  this.id = util.randomUUID();
  this.body = body;

  this.defaultOptions = {
    yAxisOrientation: 'left',
    defaultGroup: 'default',
    sort: true,
    sampling: true,
    stack: false,
    graphHeight: '400px',
    shaded: {
      enabled: false,
      orientation: 'bottom' // top, bottom, zero
    },
    style: 'line', // line, bar
    barChart: {
      width: 50,
      sideBySide: false,
      align: 'center' // left, center, right
    },
    interpolation: {
      enabled: true,
      parametrization: 'centripetal', // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
      alpha: 0.5
    },
    drawPoints: {
      enabled: true,
      size: 6,
      style: 'square' // square, circle
    },
    dataAxis: {}, //Defaults are done on DataAxis level
    legend: {}, //Defaults are done on Legend level
    groups: {
      visibility: {}
    }
  };

  // options is shared by this lineGraph and all its items
  this.options = util.extend({}, this.defaultOptions);
  this.dom = {};
  this.props = {};
  this.hammer = null;
  this.groups = {};
  this.abortedGraphUpdate = false;
  this.updateSVGheight = false;
  this.updateSVGheightOnResize = false;
  this.forceGraphUpdate = true;

  var me = this;
  this.itemsData = null; // DataSet
  this.groupsData = null; // DataSet

  // listeners for the DataSet of the items
  this.itemListeners = {
    'add': function add(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onAdd(params.items);
    },
    'update': function update(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onUpdate(params.items);
    },
    'remove': function remove(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onRemove(params.items);
    }
  };

  // listeners for the DataSet of the groups
  this.groupListeners = {
    'add': function add(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onAddGroups(params.items);
    },
    'update': function update(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onUpdateGroups(params.items);
    },
    'remove': function remove(event, params, senderId) {
      // eslint-disable-line no-unused-vars
      me._onRemoveGroups(params.items);
    }
  };

  this.items = {}; // object with an Item for every data item
  this.selection = []; // list with the ids of all selected nodes
  this.lastStart = this.body.range.start;
  this.touchParams = {}; // stores properties while dragging

  this.svgElements = {};
  this.setOptions(options);
  this.groupsUsingDefaultStyles = [0];
  this.body.emitter.on('rangechanged', function () {
    me.lastStart = me.body.range.start;
    me.svg.style.left = util.option.asSize(-me.props.width);

    me.forceGraphUpdate = true;
    //Is this local redraw necessary? (Core also does a change event!)
    me.redraw.call(me);
  });

  // create the HTML DOM
  this._create();
  this.framework = { svg: this.svg, svgElements: this.svgElements, options: this.options, groups: this.groups };
}

LineGraph.prototype = new Component();

/**
 * Create the HTML DOM for the ItemSet
 */
LineGraph.prototype._create = function () {
  var frame = document.createElement('div');
  frame.className = 'vis-line-graph';
  this.dom.frame = frame;

  // create svg element for graph drawing.
  this.svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  this.svg.style.position = 'relative';
  this.svg.style.height = ('' + this.options.graphHeight).replace('px', '') + 'px';
  this.svg.style.display = 'block';
  frame.appendChild(this.svg);

  // data axis
  this.options.dataAxis.orientation = 'left';
  this.yAxisLeft = new DataAxis(this.body, this.options.dataAxis, this.svg, this.options.groups);

  this.options.dataAxis.orientation = 'right';
  this.yAxisRight = new DataAxis(this.body, this.options.dataAxis, this.svg, this.options.groups);
  delete this.options.dataAxis.orientation;

  // legends
  this.legendLeft = new Legend(this.body, this.options.legend, 'left', this.options.groups);
  this.legendRight = new Legend(this.body, this.options.legend, 'right', this.options.groups);

  this.show();
};

/**
 * set the options of the LineGraph. the mergeOptions is used for subObjects that have an enabled element.
 * @param {object} options
 */
LineGraph.prototype.setOptions = function (options) {
  if (options) {
    var fields = ['sampling', 'defaultGroup', 'stack', 'height', 'graphHeight', 'yAxisOrientation', 'style', 'barChart', 'dataAxis', 'sort', 'groups'];
    if (options.graphHeight === undefined && options.height !== undefined) {
      this.updateSVGheight = true;
      this.updateSVGheightOnResize = true;
    } else if (this.body.domProps.centerContainer.height !== undefined && options.graphHeight !== undefined) {
      if (parseInt((options.graphHeight + '').replace("px", '')) < this.body.domProps.centerContainer.height) {
        this.updateSVGheight = true;
      }
    }
    util.selectiveDeepExtend(fields, this.options, options);
    util.mergeOptions(this.options, options, 'interpolation');
    util.mergeOptions(this.options, options, 'drawPoints');
    util.mergeOptions(this.options, options, 'shaded');
    util.mergeOptions(this.options, options, 'legend');

    if (options.interpolation) {
      if ((0, _typeof3['default'])(options.interpolation) == 'object') {
        if (options.interpolation.parametrization) {
          if (options.interpolation.parametrization == 'uniform') {
            this.options.interpolation.alpha = 0;
          } else if (options.interpolation.parametrization == 'chordal') {
            this.options.interpolation.alpha = 1.0;
          } else {
            this.options.interpolation.parametrization = 'centripetal';
            this.options.interpolation.alpha = 0.5;
          }
        }
      }
    }

    if (this.yAxisLeft) {
      if (options.dataAxis !== undefined) {
        this.yAxisLeft.setOptions(this.options.dataAxis);
        this.yAxisRight.setOptions(this.options.dataAxis);
      }
    }

    if (this.legendLeft) {
      if (options.legend !== undefined) {
        this.legendLeft.setOptions(this.options.legend);
        this.legendRight.setOptions(this.options.legend);
      }
    }

    if (this.groups.hasOwnProperty(UNGROUPED)) {
      this.groups[UNGROUPED].setOptions(options);
    }
  }

  // this is used to redraw the graph if the visibility of the groups is changed.
  if (this.dom.frame) {
    //not on initial run?
    this.forceGraphUpdate = true;
    this.body.emitter.emit("_change", { queue: true });
  }
};

/**
 * Hide the component from the DOM
 */
LineGraph.prototype.hide = function () {
  // remove the frame containing the items
  if (this.dom.frame.parentNode) {
    this.dom.frame.parentNode.removeChild(this.dom.frame);
  }
};

/**
 * Show the component in the DOM (when not already visible).
 */
LineGraph.prototype.show = function () {
  // show frame containing the items
  if (!this.dom.frame.parentNode) {
    this.body.dom.center.appendChild(this.dom.frame);
  }
};

/**
 * Set items
 * @param {vis.DataSet | null} items
 */
LineGraph.prototype.setItems = function (items) {
  var me = this,
      ids,
      oldItemsData = this.itemsData;

  // replace the dataset
  if (!items) {
    this.itemsData = null;
  } else if (items instanceof DataSet || items instanceof DataView) {
    this.itemsData = items;
  } else {
    throw new TypeError('Data must be an instance of DataSet or DataView');
  }

  if (oldItemsData) {
    // unsubscribe from old dataset
    util.forEach(this.itemListeners, function (callback, event) {
      oldItemsData.off(event, callback);
    });

    // remove all drawn items
    ids = oldItemsData.getIds();
    this._onRemove(ids);
  }

  if (this.itemsData) {
    // subscribe to new dataset
    var id = this.id;
    util.forEach(this.itemListeners, function (callback, event) {
      me.itemsData.on(event, callback, id);
    });

    // add all new items
    ids = this.itemsData.getIds();
    this._onAdd(ids);
  }
};

/**
 * Set groups
 * @param {vis.DataSet} groups
 */
LineGraph.prototype.setGroups = function (groups) {
  var me = this;
  var ids;

  // unsubscribe from current dataset
  if (this.groupsData) {
    util.forEach(this.groupListeners, function (callback, event) {
      me.groupsData.off(event, callback);
    });

    // remove all drawn groups
    ids = this.groupsData.getIds();
    this.groupsData = null;
    for (var i = 0; i < ids.length; i++) {
      this._removeGroup(ids[i]);
    }
  }

  // replace the dataset
  if (!groups) {
    this.groupsData = null;
  } else if (groups instanceof DataSet || groups instanceof DataView) {
    this.groupsData = groups;
  } else {
    throw new TypeError('Data must be an instance of DataSet or DataView');
  }

  if (this.groupsData) {
    // subscribe to new dataset
    var id = this.id;
    util.forEach(this.groupListeners, function (callback, event) {
      me.groupsData.on(event, callback, id);
    });

    // draw all ms
    ids = this.groupsData.getIds();
    this._onAddGroups(ids);
  }
};

LineGraph.prototype._onUpdate = function (ids) {
  this._updateAllGroupData(ids);
};
LineGraph.prototype._onAdd = function (ids) {
  this._onUpdate(ids);
};
LineGraph.prototype._onRemove = function (ids) {
  this._onUpdate(ids);
};
LineGraph.prototype._onUpdateGroups = function (groupIds) {
  this._updateAllGroupData(null, groupIds);
};
LineGraph.prototype._onAddGroups = function (groupIds) {
  this._onUpdateGroups(groupIds);
};

/**
 * this cleans the group out off the legends and the dataaxis, updates the ungrouped and updates the graph
 * @param {Array} groupIds
 * @private
 */
LineGraph.prototype._onRemoveGroups = function (groupIds) {
  for (var i = 0; i < groupIds.length; i++) {
    this._removeGroup(groupIds[i]);
  }
  this.forceGraphUpdate = true;
  this.body.emitter.emit("_change", { queue: true });
};

/**
 * this cleans the group out off the legends and the dataaxis
 * @param {vis.GraphGroup.id} groupId
 * @private
 */
LineGraph.prototype._removeGroup = function (groupId) {
  if (this.groups.hasOwnProperty(groupId)) {
    if (this.groups[groupId].options.yAxisOrientation == 'right') {
      this.yAxisRight.removeGroup(groupId);
      this.legendRight.removeGroup(groupId);
      this.legendRight.redraw();
    } else {
      this.yAxisLeft.removeGroup(groupId);
      this.legendLeft.removeGroup(groupId);
      this.legendLeft.redraw();
    }
    delete this.groups[groupId];
  }
};

/**
 * update a group object with the group dataset entree
 *
 * @param {vis.GraphGroup} group
 * @param {vis.GraphGroup.id} groupId
 * @private
 */
LineGraph.prototype._updateGroup = function (group, groupId) {
  if (!this.groups.hasOwnProperty(groupId)) {
    this.groups[groupId] = new GraphGroup(group, groupId, this.options, this.groupsUsingDefaultStyles);
    if (this.groups[groupId].options.yAxisOrientation == 'right') {
      this.yAxisRight.addGroup(groupId, this.groups[groupId]);
      this.legendRight.addGroup(groupId, this.groups[groupId]);
    } else {
      this.yAxisLeft.addGroup(groupId, this.groups[groupId]);
      this.legendLeft.addGroup(groupId, this.groups[groupId]);
    }
  } else {
    this.groups[groupId].update(group);
    if (this.groups[groupId].options.yAxisOrientation == 'right') {
      this.yAxisRight.updateGroup(groupId, this.groups[groupId]);
      this.legendRight.updateGroup(groupId, this.groups[groupId]);
      //If yAxisOrientation changed, clean out the group from the other axis.
      this.yAxisLeft.removeGroup(groupId);
      this.legendLeft.removeGroup(groupId);
    } else {
      this.yAxisLeft.updateGroup(groupId, this.groups[groupId]);
      this.legendLeft.updateGroup(groupId, this.groups[groupId]);
      //If yAxisOrientation changed, clean out the group from the other axis.
      this.yAxisRight.removeGroup(groupId);
      this.legendRight.removeGroup(groupId);
    }
  }
  this.legendLeft.redraw();
  this.legendRight.redraw();
};

/**
 * this updates all groups, it is used when there is an update the the itemset.
 *
 * @param  {Array} ids
 * @param  {Array} groupIds
 * @private
 */
LineGraph.prototype._updateAllGroupData = function (ids, groupIds) {
  if (this.itemsData != null) {
    var groupsContent = {};
    var items = this.itemsData.get();
    var fieldId = this.itemsData._fieldId;
    var idMap = {};
    if (ids) {
      ids.map(function (id) {
        idMap[id] = id;
      });
    }

    //pre-Determine array sizes, for more efficient memory claim
    var groupCounts = {};
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var groupId = item.group;
      if (groupId === null || groupId === undefined) {
        groupId = UNGROUPED;
      }
      groupCounts.hasOwnProperty(groupId) ? groupCounts[groupId]++ : groupCounts[groupId] = 1;
    }

    //Pre-load arrays from existing groups if items are not changed (not in ids)
    var existingItemsMap = {};
    if (!groupIds && ids) {
      for (groupId in this.groups) {
        if (this.groups.hasOwnProperty(groupId)) {
          group = this.groups[groupId];
          var existing_items = group.getItems();

          groupsContent[groupId] = existing_items.filter(function (item) {
            existingItemsMap[item[fieldId]] = item[fieldId];
            return item[fieldId] !== idMap[item[fieldId]];
          });
          var newLength = groupCounts[groupId];
          groupCounts[groupId] -= groupsContent[groupId].length;
          if (groupsContent[groupId].length < newLength) {
            groupsContent[groupId][newLength - 1] = {};
          }
        }
      }
    }

    //Now insert data into the arrays.
    for (i = 0; i < items.length; i++) {
      item = items[i];
      groupId = item.group;
      if (groupId === null || groupId === undefined) {
        groupId = UNGROUPED;
      }
      if (!groupIds && ids && item[fieldId] !== idMap[item[fieldId]] && existingItemsMap.hasOwnProperty(item[fieldId])) {
        continue;
      }
      if (!groupsContent.hasOwnProperty(groupId)) {
        groupsContent[groupId] = new Array(groupCounts[groupId]);
      }
      //Copy data (because of unmodifiable DataView input.
      var extended = util.bridgeObject(item);
      extended.x = util.convert(item.x, 'Date');
      extended.end = util.convert(item.end, 'Date');
      extended.orginalY = item.y; //real Y
      extended.y = Number(item.y);
      extended[fieldId] = item[fieldId];

      var index = groupsContent[groupId].length - groupCounts[groupId]--;
      groupsContent[groupId][index] = extended;
    }

    //Make sure all groups are present, to allow removal of old groups
    for (groupId in this.groups) {
      if (this.groups.hasOwnProperty(groupId)) {
        if (!groupsContent.hasOwnProperty(groupId)) {
          groupsContent[groupId] = new Array(0);
        }
      }
    }

    //Update legendas, style and axis
    for (groupId in groupsContent) {
      if (groupsContent.hasOwnProperty(groupId)) {
        if (groupsContent[groupId].length == 0) {
          if (this.groups.hasOwnProperty(groupId)) {
            this._removeGroup(groupId);
          }
        } else {
          var group = undefined;
          if (this.groupsData != undefined) {
            group = this.groupsData.get(groupId);
          }
          if (group == undefined) {
            group = { id: groupId, content: this.options.defaultGroup + groupId };
          }
          this._updateGroup(group, groupId);
          this.groups[groupId].setItems(groupsContent[groupId]);
        }
      }
    }
    this.forceGraphUpdate = true;
    this.body.emitter.emit("_change", { queue: true });
  }
};

/**
 * Redraw the component, mandatory function
 * @return {boolean} Returns true if the component is resized
 */
LineGraph.prototype.redraw = function () {
  var resized = false;

  // calculate actual size and position
  this.props.width = this.dom.frame.offsetWidth;
  this.props.height = this.body.domProps.centerContainer.height - this.body.domProps.border.top - this.body.domProps.border.bottom;

  // check if this component is resized
  resized = this._isResized() || resized;

  // check whether zoomed (in that case we need to re-stack everything)
  var visibleInterval = this.body.range.end - this.body.range.start;
  var zoomed = visibleInterval != this.lastVisibleInterval;
  this.lastVisibleInterval = visibleInterval;

  // the svg element is three times as big as the width, this allows for fully dragging left and right
  // without reloading the graph. the controls for this are bound to events in the constructor
  if (resized == true) {
    this.svg.style.width = util.option.asSize(3 * this.props.width);
    this.svg.style.left = util.option.asSize(-this.props.width);

    // if the height of the graph is set as proportional, change the height of the svg
    if ((this.options.height + '').indexOf("%") != -1 || this.updateSVGheightOnResize == true) {
      this.updateSVGheight = true;
    }
  }

  // update the height of the graph on each redraw of the graph.
  if (this.updateSVGheight == true) {
    if (this.options.graphHeight != this.props.height + 'px') {
      this.options.graphHeight = this.props.height + 'px';
      this.svg.style.height = this.props.height + 'px';
    }
    this.updateSVGheight = false;
  } else {
    this.svg.style.height = ('' + this.options.graphHeight).replace('px', '') + 'px';
  }

  // zoomed is here to ensure that animations are shown correctly.
  if (resized == true || zoomed == true || this.abortedGraphUpdate == true || this.forceGraphUpdate == true) {
    resized = this._updateGraph() || resized;
    this.forceGraphUpdate = false;
  } else {
    // move the whole svg while dragging
    if (this.lastStart != 0) {
      var offset = this.body.range.start - this.lastStart;
      var range = this.body.range.end - this.body.range.start;
      if (this.props.width != 0) {
        var rangePerPixelInv = this.props.width / range;
        var xOffset = offset * rangePerPixelInv;
        this.svg.style.left = -this.props.width - xOffset + 'px';
      }
    }
  }
  this.legendLeft.redraw();
  this.legendRight.redraw();
  return resized;
};

LineGraph.prototype._getSortedGroupIds = function () {
  // getting group Ids
  var grouplist = [];
  for (var groupId in this.groups) {
    if (this.groups.hasOwnProperty(groupId)) {
      var group = this.groups[groupId];
      if (group.visible == true && (this.options.groups.visibility[groupId] === undefined || this.options.groups.visibility[groupId] == true)) {
        grouplist.push({ id: groupId, zIndex: group.options.zIndex });
      }
    }
  }
  util.insertSort(grouplist, function (a, b) {
    var az = a.zIndex;
    var bz = b.zIndex;
    if (az === undefined) az = 0;
    if (bz === undefined) bz = 0;
    return az == bz ? 0 : az < bz ? -1 : 1;
  });
  var groupIds = new Array(grouplist.length);
  for (var i = 0; i < grouplist.length; i++) {
    groupIds[i] = grouplist[i].id;
  }
  return groupIds;
};

/**
 * Update and redraw the graph.
 *
 * @returns {boolean}
 * @private
 */
LineGraph.prototype._updateGraph = function () {
  // reset the svg elements
  DOMutil.prepareElements(this.svgElements);
  if (this.props.width != 0 && this.itemsData != null) {
    var group, i;
    var groupRanges = {};
    var changeCalled = false;
    // this is the range of the SVG canvas
    var minDate = this.body.util.toGlobalTime(-this.body.domProps.root.width);
    var maxDate = this.body.util.toGlobalTime(2 * this.body.domProps.root.width);

    // getting group Ids
    var groupIds = this._getSortedGroupIds();
    if (groupIds.length > 0) {
      var groupsData = {};

      // fill groups data, this only loads the data we require based on the timewindow
      this._getRelevantData(groupIds, groupsData, minDate, maxDate);

      // apply sampling, if disabled, it will pass through this function.
      this._applySampling(groupIds, groupsData);

      // we transform the X coordinates to detect collisions
      for (i = 0; i < groupIds.length; i++) {
        this._convertXcoordinates(groupsData[groupIds[i]]);
      }

      // now all needed data has been collected we start the processing.
      this._getYRanges(groupIds, groupsData, groupRanges);

      // update the Y axis first, we use this data to draw at the correct Y points
      changeCalled = this._updateYAxis(groupIds, groupRanges);

      //  at changeCalled, abort this update cycle as the graph needs another update with new Width input from the Redraw container.
      //  Cleanup SVG elements on abort.
      if (changeCalled == true) {
        DOMutil.cleanupElements(this.svgElements);
        this.abortedGraphUpdate = true;
        return true;
      }
      this.abortedGraphUpdate = false;

      // With the yAxis scaled correctly, use this to get the Y values of the points.
      var below = undefined;
      for (i = 0; i < groupIds.length; i++) {
        group = this.groups[groupIds[i]];
        if (this.options.stack === true && this.options.style === 'line') {
          if (group.options.excludeFromStacking == undefined || !group.options.excludeFromStacking) {
            if (below != undefined) {
              this._stack(groupsData[group.id], groupsData[below.id]);
              if (group.options.shaded.enabled == true && group.options.shaded.orientation !== "group") {
                if (group.options.shaded.orientation == "top" && below.options.shaded.orientation !== "group") {
                  below.options.shaded.orientation = "group";
                  below.options.shaded.groupId = group.id;
                } else {
                  group.options.shaded.orientation = "group";
                  group.options.shaded.groupId = below.id;
                }
              }
            }
            below = group;
          }
        }
        this._convertYcoordinates(groupsData[groupIds[i]], group);
      }

      //Precalculate paths and draw shading if appropriate. This will make sure the shading is always behind any lines.
      var paths = {};
      for (i = 0; i < groupIds.length; i++) {
        group = this.groups[groupIds[i]];
        if (group.options.style === 'line' && group.options.shaded.enabled == true) {
          var dataset = groupsData[groupIds[i]];
          if (dataset == null || dataset.length == 0) {
            continue;
          }
          if (!paths.hasOwnProperty(groupIds[i])) {
            paths[groupIds[i]] = Lines.calcPath(dataset, group);
          }
          if (group.options.shaded.orientation === "group") {
            var subGroupId = group.options.shaded.groupId;
            if (groupIds.indexOf(subGroupId) === -1) {
              console.log(group.id + ": Unknown shading group target given:" + subGroupId);
              continue;
            }
            if (!paths.hasOwnProperty(subGroupId)) {
              paths[subGroupId] = Lines.calcPath(groupsData[subGroupId], this.groups[subGroupId]);
            }
            Lines.drawShading(paths[groupIds[i]], group, paths[subGroupId], this.framework);
          } else {
            Lines.drawShading(paths[groupIds[i]], group, undefined, this.framework);
          }
        }
      }

      // draw the groups, calculating paths if still necessary.
      Bars.draw(groupIds, groupsData, this.framework);
      for (i = 0; i < groupIds.length; i++) {
        group = this.groups[groupIds[i]];
        if (groupsData[groupIds[i]].length > 0) {
          switch (group.options.style) {
            case "line":
              if (!paths.hasOwnProperty(groupIds[i])) {
                paths[groupIds[i]] = Lines.calcPath(groupsData[groupIds[i]], group);
              }
              Lines.draw(paths[groupIds[i]], group, this.framework);
            // eslint-disable-line no-fallthrough
            case "point":
            // eslint-disable-line no-fallthrough
            case "points":
              if (group.options.style == "point" || group.options.style == "points" || group.options.drawPoints.enabled == true) {
                Points.draw(groupsData[groupIds[i]], group, this.framework);
              }
              break;
            case "bar":
            // bar needs to be drawn enmasse
            // eslint-disable-line no-fallthrough
            default:
            //do nothing...
          }
        }
      }
    }
  }

  // cleanup unused svg elements
  DOMutil.cleanupElements(this.svgElements);
  return false;
};

LineGraph.prototype._stack = function (data, subData) {
  var index, dx, dy, subPrevPoint, subNextPoint;
  index = 0;
  // for each data point we look for a matching on in the set below
  for (var j = 0; j < data.length; j++) {
    subPrevPoint = undefined;
    subNextPoint = undefined;
    // we look for time matches or a before-after point
    for (var k = index; k < subData.length; k++) {
      // if times match exactly
      if (subData[k].x === data[j].x) {
        subPrevPoint = subData[k];
        subNextPoint = subData[k];
        index = k;
        break;
      } else if (subData[k].x > data[j].x) {
        // overshoot
        subNextPoint = subData[k];
        if (k == 0) {
          subPrevPoint = subNextPoint;
        } else {
          subPrevPoint = subData[k - 1];
        }
        index = k;
        break;
      }
    }
    // in case the last data point has been used, we assume it stays like this.
    if (subNextPoint === undefined) {
      subPrevPoint = subData[subData.length - 1];
      subNextPoint = subData[subData.length - 1];
    }
    // linear interpolation
    dx = subNextPoint.x - subPrevPoint.x;
    dy = subNextPoint.y - subPrevPoint.y;
    if (dx == 0) {
      data[j].y = data[j].orginalY + subNextPoint.y;
    } else {
      data[j].y = data[j].orginalY + dy / dx * (data[j].x - subPrevPoint.x) + subPrevPoint.y; // ax + b where b is data[j].y
    }
  }
};

/**
 * first select and preprocess the data from the datasets.
 * the groups have their preselection of data, we now loop over this data to see
 * what data we need to draw. Sorted data is much faster.
 * more optimization is possible by doing the sampling before and using the binary search
 * to find the end date to determine the increment.
 *
 * @param {array}  groupIds
 * @param {object} groupsData
 * @param {date}   minDate
 * @param {date}   maxDate
 * @private
 */
LineGraph.prototype._getRelevantData = function (groupIds, groupsData, minDate, maxDate) {
  var group, i, j, item;
  if (groupIds.length > 0) {
    for (i = 0; i < groupIds.length; i++) {
      group = this.groups[groupIds[i]];
      var itemsData = group.getItems();
      // optimization for sorted data
      if (group.options.sort == true) {
        var dateComparator = function dateComparator(a, b) {
          return a.getTime() == b.getTime() ? 0 : a < b ? -1 : 1;
        };
        var first = Math.max(0, util.binarySearchValue(itemsData, minDate, 'x', 'before', dateComparator));
        var last = Math.min(itemsData.length, util.binarySearchValue(itemsData, maxDate, 'x', 'after', dateComparator) + 1);
        if (last <= 0) {
          last = itemsData.length;
        }
        var dataContainer = new Array(last - first);
        for (j = first; j < last; j++) {
          item = group.itemsData[j];
          dataContainer[j - first] = item;
        }
        groupsData[groupIds[i]] = dataContainer;
      } else {
        // If unsorted data, all data is relevant, just returning entire structure
        groupsData[groupIds[i]] = group.itemsData;
      }
    }
  }
};

/**
 *
 * @param {Array.<vis.GraphGroup.id>} groupIds
 * @param {vis.DataSet} groupsData
 * @private
 */
LineGraph.prototype._applySampling = function (groupIds, groupsData) {
  var group;
  if (groupIds.length > 0) {
    for (var i = 0; i < groupIds.length; i++) {
      group = this.groups[groupIds[i]];
      if (group.options.sampling == true) {
        var dataContainer = groupsData[groupIds[i]];
        if (dataContainer.length > 0) {
          var increment = 1;
          var amountOfPoints = dataContainer.length;

          // the global screen is used because changing the width of the yAxis may affect the increment, resulting in an endless loop
          // of width changing of the yAxis.
          //TODO: This assumes sorted data, but that's not guaranteed!
          var xDistance = this.body.util.toGlobalScreen(dataContainer[dataContainer.length - 1].x) - this.body.util.toGlobalScreen(dataContainer[0].x);
          var pointsPerPixel = amountOfPoints / xDistance;
          increment = Math.min(Math.ceil(0.2 * amountOfPoints), Math.max(1, Math.round(pointsPerPixel)));

          var sampledData = new Array(amountOfPoints);
          for (var j = 0; j < amountOfPoints; j += increment) {
            var idx = Math.round(j / increment);
            sampledData[idx] = dataContainer[j];
          }
          groupsData[groupIds[i]] = sampledData.splice(0, Math.round(amountOfPoints / increment));
        }
      }
    }
  }
};

/**
 *
 * @param {Array.<vis.GraphGroup.id>} groupIds
 * @param {vis.DataSet} groupsData
 * @param {object} groupRanges  | this is being filled here
 * @private
 */
LineGraph.prototype._getYRanges = function (groupIds, groupsData, groupRanges) {
  var groupData, group, i;
  var combinedDataLeft = [];
  var combinedDataRight = [];
  var options;
  if (groupIds.length > 0) {
    for (i = 0; i < groupIds.length; i++) {
      groupData = groupsData[groupIds[i]];
      options = this.groups[groupIds[i]].options;
      if (groupData.length > 0) {
        group = this.groups[groupIds[i]];
        // if bar graphs are stacked, their range need to be handled differently and accumulated over all groups.
        if (options.stack === true && options.style === 'bar') {
          if (options.yAxisOrientation === 'left') {
            combinedDataLeft = combinedDataLeft.concat(groupData);
          } else {
            combinedDataRight = combinedDataRight.concat(groupData);
          }
        } else {
          groupRanges[groupIds[i]] = group.getYRange(groupData, groupIds[i]);
        }
      }
    }

    // if bar graphs are stacked, their range need to be handled differently and accumulated over all groups.
    Bars.getStackedYRange(combinedDataLeft, groupRanges, groupIds, '__barStackLeft', 'left');
    Bars.getStackedYRange(combinedDataRight, groupRanges, groupIds, '__barStackRight', 'right');
  }
};

/**
 * this sets the Y ranges for the Y axis. It also determines which of the axis should be shown or hidden.
 * @param {Array.<vis.GraphGroup.id>} groupIds
 * @param {Object} groupRanges
 * @returns {boolean} resized
 * @private
 */
LineGraph.prototype._updateYAxis = function (groupIds, groupRanges) {
  var resized = false;
  var yAxisLeftUsed = false;
  var yAxisRightUsed = false;
  var minLeft = 1e9,
      minRight = 1e9,
      maxLeft = -1e9,
      maxRight = -1e9,
      minVal,
      maxVal;
  // if groups are present
  if (groupIds.length > 0) {
    // this is here to make sure that if there are no items in the axis but there are groups, that there is no infinite draw/redraw loop.
    for (var i = 0; i < groupIds.length; i++) {
      var group = this.groups[groupIds[i]];
      if (group && group.options.yAxisOrientation != 'right') {
        yAxisLeftUsed = true;
        minLeft = 1e9;
        maxLeft = -1e9;
      } else if (group && group.options.yAxisOrientation) {
        yAxisRightUsed = true;
        minRight = 1e9;
        maxRight = -1e9;
      }
    }

    // if there are items:
    for (i = 0; i < groupIds.length; i++) {
      if (groupRanges.hasOwnProperty(groupIds[i])) {
        if (groupRanges[groupIds[i]].ignore !== true) {
          minVal = groupRanges[groupIds[i]].min;
          maxVal = groupRanges[groupIds[i]].max;

          if (groupRanges[groupIds[i]].yAxisOrientation != 'right') {
            yAxisLeftUsed = true;
            minLeft = minLeft > minVal ? minVal : minLeft;
            maxLeft = maxLeft < maxVal ? maxVal : maxLeft;
          } else {
            yAxisRightUsed = true;
            minRight = minRight > minVal ? minVal : minRight;
            maxRight = maxRight < maxVal ? maxVal : maxRight;
          }
        }
      }
    }

    if (yAxisLeftUsed == true) {
      this.yAxisLeft.setRange(minLeft, maxLeft);
    }
    if (yAxisRightUsed == true) {
      this.yAxisRight.setRange(minRight, maxRight);
    }
  }
  resized = this._toggleAxisVisiblity(yAxisLeftUsed, this.yAxisLeft) || resized;
  resized = this._toggleAxisVisiblity(yAxisRightUsed, this.yAxisRight) || resized;

  if (yAxisRightUsed == true && yAxisLeftUsed == true) {
    this.yAxisLeft.drawIcons = true;
    this.yAxisRight.drawIcons = true;
  } else {
    this.yAxisLeft.drawIcons = false;
    this.yAxisRight.drawIcons = false;
  }
  this.yAxisRight.master = !yAxisLeftUsed;
  this.yAxisRight.masterAxis = this.yAxisLeft;

  if (this.yAxisRight.master == false) {
    if (yAxisRightUsed == true) {
      this.yAxisLeft.lineOffset = this.yAxisRight.width;
    } else {
      this.yAxisLeft.lineOffset = 0;
    }

    resized = this.yAxisLeft.redraw() || resized;
    resized = this.yAxisRight.redraw() || resized;
  } else {
    resized = this.yAxisRight.redraw() || resized;
  }

  // clean the accumulated lists
  var tempGroups = ['__barStackLeft', '__barStackRight', '__lineStackLeft', '__lineStackRight'];
  for (i = 0; i < tempGroups.length; i++) {
    if (groupIds.indexOf(tempGroups[i]) != -1) {
      groupIds.splice(groupIds.indexOf(tempGroups[i]), 1);
    }
  }

  return resized;
};

/**
 * This shows or hides the Y axis if needed. If there is a change, the changed event is emitted by the updateYAxis function
 *
 * @param {boolean} axisUsed
 * @param {vis.DataAxis}  axis
 * @returns {boolean}
 * @private
 */
LineGraph.prototype._toggleAxisVisiblity = function (axisUsed, axis) {
  var changed = false;
  if (axisUsed == false) {
    if (axis.dom.frame.parentNode && axis.hidden == false) {
      axis.hide();
      changed = true;
    }
  } else {
    if (!axis.dom.frame.parentNode && axis.hidden == true) {
      axis.show();
      changed = true;
    }
  }
  return changed;
};

/**
 * This uses the DataAxis object to generate the correct X coordinate on the SVG window. It uses the
 * util function toScreen to get the x coordinate from the timestamp. It also pre-filters the data and get the minMax ranges for
 * the yAxis.
 *
 * @param {Array.<Object>} datapoints
 * @private
 */
LineGraph.prototype._convertXcoordinates = function (datapoints) {
  var toScreen = this.body.util.toScreen;
  for (var i = 0; i < datapoints.length; i++) {
    datapoints[i].screen_x = toScreen(datapoints[i].x) + this.props.width;
    datapoints[i].screen_y = datapoints[i].y; //starting point for range calculations
    if (datapoints[i].end != undefined) {
      datapoints[i].screen_end = toScreen(datapoints[i].end) + this.props.width;
    } else {
      datapoints[i].screen_end = undefined;
    }
  }
};

/**
 * This uses the DataAxis object to generate the correct X coordinate on the SVG window. It uses the
 * util function toScreen to get the x coordinate from the timestamp. It also pre-filters the data and get the minMax ranges for
 * the yAxis.
 *
 * @param {Array.<Object>} datapoints
 * @param {vis.GraphGroup} group
 * @private
 */
LineGraph.prototype._convertYcoordinates = function (datapoints, group) {
  var axis = this.yAxisLeft;
  var svgHeight = Number(this.svg.style.height.replace('px', ''));
  if (group.options.yAxisOrientation == 'right') {
    axis = this.yAxisRight;
  }
  for (var i = 0; i < datapoints.length; i++) {
    datapoints[i].screen_y = Math.round(axis.convertValue(datapoints[i].y));
  }
  group.setZeroPosition(Math.min(svgHeight, axis.convertValue(0)));
};

module.exports = LineGraph;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var DOMutil = __webpack_require__(14);
var Component = __webpack_require__(16);
var DataScale = __webpack_require__(108);
/**
 * A horizontal time axis
 * @param {Object} body
 * @param {Object} [options]        See DataAxis.setOptions for the available
 *                                  options.
 * @param {SVGElement} svg
 * @param {vis.LineGraph.options} linegraphOptions
 * @constructor DataAxis
 * @extends Component
 */
function DataAxis(body, options, svg, linegraphOptions) {
  this.id = util.randomUUID();
  this.body = body;

  this.defaultOptions = {
    orientation: 'left', // supported: 'left', 'right'
    showMinorLabels: true,
    showMajorLabels: true,
    icons: false,
    majorLinesOffset: 7,
    minorLinesOffset: 4,
    labelOffsetX: 10,
    labelOffsetY: 2,
    iconWidth: 20,
    width: '40px',
    visible: true,
    alignZeros: true,
    left: {
      range: { min: undefined, max: undefined },
      format: function format(value) {
        return '' + parseFloat(value.toPrecision(3));
      },
      title: { text: undefined, style: undefined }
    },
    right: {
      range: { min: undefined, max: undefined },
      format: function format(value) {
        return '' + parseFloat(value.toPrecision(3));
      },
      title: { text: undefined, style: undefined }
    }
  };

  this.linegraphOptions = linegraphOptions;
  this.linegraphSVG = svg;
  this.props = {};
  this.DOMelements = { // dynamic elements
    lines: {},
    labels: {},
    title: {}
  };

  this.dom = {};
  this.scale = undefined;
  this.range = { start: 0, end: 0 };

  this.options = util.extend({}, this.defaultOptions);
  this.conversionFactor = 1;

  this.setOptions(options);
  this.width = Number(('' + this.options.width).replace("px", ""));
  this.minWidth = this.width;
  this.height = this.linegraphSVG.getBoundingClientRect().height;
  this.hidden = false;

  this.stepPixels = 25;
  this.zeroCrossing = -1;
  this.amountOfSteps = -1;

  this.lineOffset = 0;
  this.master = true;
  this.masterAxis = null;
  this.svgElements = {};
  this.iconsRemoved = false;

  this.groups = {};
  this.amountOfGroups = 0;

  // create the HTML DOM
  this._create();
  this.framework = { svg: this.svg, svgElements: this.svgElements, options: this.options, groups: this.groups };

  var me = this;
  this.body.emitter.on("verticalDrag", function () {
    me.dom.lineContainer.style.top = me.body.domProps.scrollTop + 'px';
  });
}

DataAxis.prototype = new Component();

DataAxis.prototype.addGroup = function (label, graphOptions) {
  if (!this.groups.hasOwnProperty(label)) {
    this.groups[label] = graphOptions;
  }
  this.amountOfGroups += 1;
};

DataAxis.prototype.updateGroup = function (label, graphOptions) {
  if (!this.groups.hasOwnProperty(label)) {
    this.amountOfGroups += 1;
  }
  this.groups[label] = graphOptions;
};

DataAxis.prototype.removeGroup = function (label) {
  if (this.groups.hasOwnProperty(label)) {
    delete this.groups[label];
    this.amountOfGroups -= 1;
  }
};

DataAxis.prototype.setOptions = function (options) {
  if (options) {
    var redraw = false;
    if (this.options.orientation != options.orientation && options.orientation !== undefined) {
      redraw = true;
    }
    var fields = ['orientation', 'showMinorLabels', 'showMajorLabels', 'icons', 'majorLinesOffset', 'minorLinesOffset', 'labelOffsetX', 'labelOffsetY', 'iconWidth', 'width', 'visible', 'left', 'right', 'alignZeros'];
    util.selectiveDeepExtend(fields, this.options, options);

    this.minWidth = Number(('' + this.options.width).replace("px", ""));
    if (redraw === true && this.dom.frame) {
      this.hide();
      this.show();
    }
  }
};

/**
 * Create the HTML DOM for the DataAxis
 */
DataAxis.prototype._create = function () {
  this.dom.frame = document.createElement('div');
  this.dom.frame.style.width = this.options.width;
  this.dom.frame.style.height = this.height;

  this.dom.lineContainer = document.createElement('div');
  this.dom.lineContainer.style.width = '100%';
  this.dom.lineContainer.style.height = this.height;
  this.dom.lineContainer.style.position = 'relative';

  // create svg element for graph drawing.
  this.svg = document.createElementNS('http://www.w3.org/2000/svg', "svg");
  this.svg.style.position = "absolute";
  this.svg.style.top = '0px';
  this.svg.style.height = '100%';
  this.svg.style.width = '100%';
  this.svg.style.display = "block";
  this.dom.frame.appendChild(this.svg);
};

DataAxis.prototype._redrawGroupIcons = function () {
  DOMutil.prepareElements(this.svgElements);

  var x;
  var iconWidth = this.options.iconWidth;
  var iconHeight = 15;
  var iconOffset = 4;
  var y = iconOffset + 0.5 * iconHeight;

  if (this.options.orientation === 'left') {
    x = iconOffset;
  } else {
    x = this.width - iconWidth - iconOffset;
  }

  var groupArray = (0, _keys2['default'])(this.groups);
  groupArray.sort(function (a, b) {
    return a < b ? -1 : 1;
  });

  for (var i = 0; i < groupArray.length; i++) {
    var groupId = groupArray[i];
    if (this.groups[groupId].visible === true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] === true)) {
      this.groups[groupId].getLegend(iconWidth, iconHeight, this.framework, x, y);
      y += iconHeight + iconOffset;
    }
  }

  DOMutil.cleanupElements(this.svgElements);
  this.iconsRemoved = false;
};

DataAxis.prototype._cleanupIcons = function () {
  if (this.iconsRemoved === false) {
    DOMutil.prepareElements(this.svgElements);
    DOMutil.cleanupElements(this.svgElements);
    this.iconsRemoved = true;
  }
};

/**
 * Create the HTML DOM for the DataAxis
 */
DataAxis.prototype.show = function () {
  this.hidden = false;
  if (!this.dom.frame.parentNode) {
    if (this.options.orientation === 'left') {
      this.body.dom.left.appendChild(this.dom.frame);
    } else {
      this.body.dom.right.appendChild(this.dom.frame);
    }
  }

  if (!this.dom.lineContainer.parentNode) {
    this.body.dom.backgroundHorizontal.appendChild(this.dom.lineContainer);
  }
};

/**
 * Create the HTML DOM for the DataAxis
 */
DataAxis.prototype.hide = function () {
  this.hidden = true;
  if (this.dom.frame.parentNode) {
    this.dom.frame.parentNode.removeChild(this.dom.frame);
  }

  if (this.dom.lineContainer.parentNode) {
    this.dom.lineContainer.parentNode.removeChild(this.dom.lineContainer);
  }
};

/**
 * Set a range (start and end)
 * @param {number} start
 * @param {number} end
 */
DataAxis.prototype.setRange = function (start, end) {
  this.range.start = start;
  this.range.end = end;
};

/**
 * Repaint the component
 * @return {boolean} Returns true if the component is resized
 */
DataAxis.prototype.redraw = function () {
  var resized = false;
  var activeGroups = 0;

  // Make sure the line container adheres to the vertical scrolling.
  this.dom.lineContainer.style.top = this.body.domProps.scrollTop + 'px';

  for (var groupId in this.groups) {
    if (this.groups.hasOwnProperty(groupId)) {
      if (this.groups[groupId].visible === true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] === true)) {
        activeGroups++;
      }
    }
  }
  if (this.amountOfGroups === 0 || activeGroups === 0) {
    this.hide();
  } else {
    this.show();
    this.height = Number(this.linegraphSVG.style.height.replace("px", ""));

    // svg offsetheight did not work in firefox and explorer...
    this.dom.lineContainer.style.height = this.height + 'px';
    this.width = this.options.visible === true ? Number(('' + this.options.width).replace("px", "")) : 0;

    var props = this.props;
    var frame = this.dom.frame;

    // update classname
    frame.className = 'vis-data-axis';

    // calculate character width and height
    this._calculateCharSize();

    var orientation = this.options.orientation;
    var showMinorLabels = this.options.showMinorLabels;
    var showMajorLabels = this.options.showMajorLabels;

    // determine the width and height of the elements for the axis
    props.minorLabelHeight = showMinorLabels ? props.minorCharHeight : 0;
    props.majorLabelHeight = showMajorLabels ? props.majorCharHeight : 0;

    props.minorLineWidth = this.body.dom.backgroundHorizontal.offsetWidth - this.lineOffset - this.width + 2 * this.options.minorLinesOffset;
    props.minorLineHeight = 1;
    props.majorLineWidth = this.body.dom.backgroundHorizontal.offsetWidth - this.lineOffset - this.width + 2 * this.options.majorLinesOffset;
    props.majorLineHeight = 1;

    //  take frame offline while updating (is almost twice as fast)
    if (orientation === 'left') {
      frame.style.top = '0';
      frame.style.left = '0';
      frame.style.bottom = '';
      frame.style.width = this.width + 'px';
      frame.style.height = this.height + "px";
      this.props.width = this.body.domProps.left.width;
      this.props.height = this.body.domProps.left.height;
    } else {
      // right
      frame.style.top = '';
      frame.style.bottom = '0';
      frame.style.left = '0';
      frame.style.width = this.width + 'px';
      frame.style.height = this.height + "px";
      this.props.width = this.body.domProps.right.width;
      this.props.height = this.body.domProps.right.height;
    }

    resized = this._redrawLabels();
    resized = this._isResized() || resized;

    if (this.options.icons === true) {
      this._redrawGroupIcons();
    } else {
      this._cleanupIcons();
    }

    this._redrawTitle(orientation);
  }
  return resized;
};

/**
 * Repaint major and minor text labels and vertical grid lines
 *
 * @returns {boolean}
 * @private
 */
DataAxis.prototype._redrawLabels = function () {
  var _this = this;

  var resized = false;
  DOMutil.prepareElements(this.DOMelements.lines);
  DOMutil.prepareElements(this.DOMelements.labels);
  var orientation = this.options['orientation'];
  var customRange = this.options[orientation].range != undefined ? this.options[orientation].range : {};

  //Override range with manual options:
  var autoScaleEnd = true;
  if (customRange.max != undefined) {
    this.range.end = customRange.max;
    autoScaleEnd = false;
  }
  var autoScaleStart = true;
  if (customRange.min != undefined) {
    this.range.start = customRange.min;
    autoScaleStart = false;
  }

  this.scale = new DataScale(this.range.start, this.range.end, autoScaleStart, autoScaleEnd, this.dom.frame.offsetHeight, this.props.majorCharHeight, this.options.alignZeros, this.options[orientation].format);

  if (this.master === false && this.masterAxis != undefined) {
    this.scale.followScale(this.masterAxis.scale);
  }

  //Is updated in side-effect of _redrawLabel():
  this.maxLabelSize = 0;

  var lines = this.scale.getLines();
  lines.forEach(function (line) {
    var y = line.y;
    var isMajor = line.major;
    if (_this.options['showMinorLabels'] && isMajor === false) {
      _this._redrawLabel(y - 2, line.val, orientation, 'vis-y-axis vis-minor', _this.props.minorCharHeight);
    }
    if (isMajor) {
      if (y >= 0) {
        _this._redrawLabel(y - 2, line.val, orientation, 'vis-y-axis vis-major', _this.props.majorCharHeight);
      }
    }
    if (_this.master === true) {
      if (isMajor) {
        _this._redrawLine(y, orientation, 'vis-grid vis-horizontal vis-major', _this.options.majorLinesOffset, _this.props.majorLineWidth);
      } else {
        _this._redrawLine(y, orientation, 'vis-grid vis-horizontal vis-minor', _this.options.minorLinesOffset, _this.props.minorLineWidth);
      }
    }
  });

  // Note that title is rotated, so we're using the height, not width!
  var titleWidth = 0;
  if (this.options[orientation].title !== undefined && this.options[orientation].title.text !== undefined) {
    titleWidth = this.props.titleCharHeight;
  }
  var offset = this.options.icons === true ? Math.max(this.options.iconWidth, titleWidth) + this.options.labelOffsetX + 15 : titleWidth + this.options.labelOffsetX + 15;

  // this will resize the yAxis to accommodate the labels.
  if (this.maxLabelSize > this.width - offset && this.options.visible === true) {
    this.width = this.maxLabelSize + offset;
    this.options.width = this.width + "px";
    DOMutil.cleanupElements(this.DOMelements.lines);
    DOMutil.cleanupElements(this.DOMelements.labels);
    this.redraw();
    resized = true;
  }
  // this will resize the yAxis if it is too big for the labels.
  else if (this.maxLabelSize < this.width - offset && this.options.visible === true && this.width > this.minWidth) {
      this.width = Math.max(this.minWidth, this.maxLabelSize + offset);
      this.options.width = this.width + "px";
      DOMutil.cleanupElements(this.DOMelements.lines);
      DOMutil.cleanupElements(this.DOMelements.labels);
      this.redraw();
      resized = true;
    } else {
      DOMutil.cleanupElements(this.DOMelements.lines);
      DOMutil.cleanupElements(this.DOMelements.labels);
      resized = false;
    }

  return resized;
};

DataAxis.prototype.convertValue = function (value) {
  return this.scale.convertValue(value);
};

DataAxis.prototype.screenToValue = function (x) {
  return this.scale.screenToValue(x);
};

/**
 * Create a label for the axis at position x
 *
 * @param {number} y
 * @param {string} text
 * @param {'top'|'right'|'bottom'|'left'} orientation
 * @param {string} className
 * @param {number} characterHeight
 * @private
 */
DataAxis.prototype._redrawLabel = function (y, text, orientation, className, characterHeight) {
  // reuse redundant label
  var label = DOMutil.getDOMElement('div', this.DOMelements.labels, this.dom.frame); //this.dom.redundant.labels.shift();
  label.className = className;
  label.innerHTML = text;
  if (orientation === 'left') {
    label.style.left = '-' + this.options.labelOffsetX + 'px';
    label.style.textAlign = "right";
  } else {
    label.style.right = '-' + this.options.labelOffsetX + 'px';
    label.style.textAlign = "left";
  }

  label.style.top = y - 0.5 * characterHeight + this.options.labelOffsetY + 'px';

  text += '';

  var largestWidth = Math.max(this.props.majorCharWidth, this.props.minorCharWidth);
  if (this.maxLabelSize < text.length * largestWidth) {
    this.maxLabelSize = text.length * largestWidth;
  }
};

/**
 * Create a minor line for the axis at position y
 * @param {number} y
 * @param {'top'|'right'|'bottom'|'left'} orientation
 * @param {string} className
 * @param {number} offset
 * @param {number} width
 */
DataAxis.prototype._redrawLine = function (y, orientation, className, offset, width) {
  if (this.master === true) {
    var line = DOMutil.getDOMElement('div', this.DOMelements.lines, this.dom.lineContainer); //this.dom.redundant.lines.shift();
    line.className = className;
    line.innerHTML = '';

    if (orientation === 'left') {
      line.style.left = this.width - offset + 'px';
    } else {
      line.style.right = this.width - offset + 'px';
    }

    line.style.width = width + 'px';
    line.style.top = y + 'px';
  }
};

/**
 * Create a title for the axis
 * @private
 * @param {'top'|'right'|'bottom'|'left'} orientation
 */
DataAxis.prototype._redrawTitle = function (orientation) {
  DOMutil.prepareElements(this.DOMelements.title);

  // Check if the title is defined for this axes
  if (this.options[orientation].title !== undefined && this.options[orientation].title.text !== undefined) {
    var title = DOMutil.getDOMElement('div', this.DOMelements.title, this.dom.frame);
    title.className = 'vis-y-axis vis-title vis-' + orientation;
    title.innerHTML = this.options[orientation].title.text;

    // Add style - if provided
    if (this.options[orientation].title.style !== undefined) {
      util.addCssText(title, this.options[orientation].title.style);
    }

    if (orientation === 'left') {
      title.style.left = this.props.titleCharHeight + 'px';
    } else {
      title.style.right = this.props.titleCharHeight + 'px';
    }

    title.style.width = this.height + 'px';
  }

  // we need to clean up in case we did not use all elements.
  DOMutil.cleanupElements(this.DOMelements.title);
};

/**
 * Determine the size of text on the axis (both major and minor axis).
 * The size is calculated only once and then cached in this.props.
 * @private
 */
DataAxis.prototype._calculateCharSize = function () {
  // determine the char width and height on the minor axis
  if (!('minorCharHeight' in this.props)) {
    var textMinor = document.createTextNode('0');
    var measureCharMinor = document.createElement('div');
    measureCharMinor.className = 'vis-y-axis vis-minor vis-measure';
    measureCharMinor.appendChild(textMinor);
    this.dom.frame.appendChild(measureCharMinor);

    this.props.minorCharHeight = measureCharMinor.clientHeight;
    this.props.minorCharWidth = measureCharMinor.clientWidth;

    this.dom.frame.removeChild(measureCharMinor);
  }

  if (!('majorCharHeight' in this.props)) {
    var textMajor = document.createTextNode('0');
    var measureCharMajor = document.createElement('div');
    measureCharMajor.className = 'vis-y-axis vis-major vis-measure';
    measureCharMajor.appendChild(textMajor);
    this.dom.frame.appendChild(measureCharMajor);

    this.props.majorCharHeight = measureCharMajor.clientHeight;
    this.props.majorCharWidth = measureCharMajor.clientWidth;

    this.dom.frame.removeChild(measureCharMajor);
  }

  if (!('titleCharHeight' in this.props)) {
    var textTitle = document.createTextNode('0');
    var measureCharTitle = document.createElement('div');
    measureCharTitle.className = 'vis-y-axis vis-title vis-measure';
    measureCharTitle.appendChild(textTitle);
    this.dom.frame.appendChild(measureCharTitle);

    this.props.titleCharHeight = measureCharTitle.clientHeight;
    this.props.titleCharWidth = measureCharTitle.clientWidth;

    this.dom.frame.removeChild(measureCharTitle);
  }
};

module.exports = DataAxis;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *
 * @param {number} start
 * @param {number} end
 * @param {boolean} autoScaleStart
 * @param {boolean} autoScaleEnd
 * @param {number} containerHeight
 * @param {number} majorCharHeight
 * @param {boolean} zeroAlign
 * @param {function} formattingFunction
 * @constructor DataScale
 */
function DataScale(start, end, autoScaleStart, autoScaleEnd, containerHeight, majorCharHeight) {
  var zeroAlign = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  var formattingFunction = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

  this.majorSteps = [1, 2, 5, 10];
  this.minorSteps = [0.25, 0.5, 1, 2];
  this.customLines = null;

  this.containerHeight = containerHeight;
  this.majorCharHeight = majorCharHeight;
  this._start = start;
  this._end = end;

  this.scale = 1;
  this.minorStepIdx = -1;
  this.magnitudefactor = 1;
  this.determineScale();

  this.zeroAlign = zeroAlign;
  this.autoScaleStart = autoScaleStart;
  this.autoScaleEnd = autoScaleEnd;

  this.formattingFunction = formattingFunction;

  if (autoScaleStart || autoScaleEnd) {
    var me = this;
    var roundToMinor = function roundToMinor(value) {
      var rounded = value - value % (me.magnitudefactor * me.minorSteps[me.minorStepIdx]);
      if (value % (me.magnitudefactor * me.minorSteps[me.minorStepIdx]) > 0.5 * (me.magnitudefactor * me.minorSteps[me.minorStepIdx])) {
        return rounded + me.magnitudefactor * me.minorSteps[me.minorStepIdx];
      } else {
        return rounded;
      }
    };
    if (autoScaleStart) {
      this._start -= this.magnitudefactor * 2 * this.minorSteps[this.minorStepIdx];
      this._start = roundToMinor(this._start);
    }

    if (autoScaleEnd) {
      this._end += this.magnitudefactor * this.minorSteps[this.minorStepIdx];
      this._end = roundToMinor(this._end);
    }
    this.determineScale();
  }
}

DataScale.prototype.setCharHeight = function (majorCharHeight) {
  this.majorCharHeight = majorCharHeight;
};

DataScale.prototype.setHeight = function (containerHeight) {
  this.containerHeight = containerHeight;
};

DataScale.prototype.determineScale = function () {
  var range = this._end - this._start;
  this.scale = this.containerHeight / range;
  var minimumStepValue = this.majorCharHeight / this.scale;
  var orderOfMagnitude = range > 0 ? Math.round(Math.log(range) / Math.LN10) : 0;

  this.minorStepIdx = -1;
  this.magnitudefactor = Math.pow(10, orderOfMagnitude);

  var start = 0;
  if (orderOfMagnitude < 0) {
    start = orderOfMagnitude;
  }

  var solutionFound = false;
  for (var l = start; Math.abs(l) <= Math.abs(orderOfMagnitude); l++) {
    this.magnitudefactor = Math.pow(10, l);
    for (var j = 0; j < this.minorSteps.length; j++) {
      var stepSize = this.magnitudefactor * this.minorSteps[j];
      if (stepSize >= minimumStepValue) {
        solutionFound = true;
        this.minorStepIdx = j;
        break;
      }
    }
    if (solutionFound === true) {
      break;
    }
  }
};

DataScale.prototype.is_major = function (value) {
  return value % (this.magnitudefactor * this.majorSteps[this.minorStepIdx]) === 0;
};

DataScale.prototype.getStep = function () {
  return this.magnitudefactor * this.minorSteps[this.minorStepIdx];
};

DataScale.prototype.getFirstMajor = function () {
  var majorStep = this.magnitudefactor * this.majorSteps[this.minorStepIdx];
  return this.convertValue(this._start + (majorStep - this._start % majorStep) % majorStep);
};

DataScale.prototype.formatValue = function (current) {
  var returnValue = current.toPrecision(5);
  if (typeof this.formattingFunction === 'function') {
    returnValue = this.formattingFunction(current);
  }

  if (typeof returnValue === 'number') {
    return '' + returnValue;
  } else if (typeof returnValue === 'string') {
    return returnValue;
  } else {
    return current.toPrecision(5);
  }
};

DataScale.prototype.getLines = function () {
  var lines = [];
  var step = this.getStep();
  var bottomOffset = (step - this._start % step) % step;
  for (var i = this._start + bottomOffset; this._end - i > 0.00001; i += step) {
    if (i != this._start) {
      //Skip the bottom line
      lines.push({ major: this.is_major(i), y: this.convertValue(i), val: this.formatValue(i) });
    }
  }
  return lines;
};

DataScale.prototype.followScale = function (other) {
  var oldStepIdx = this.minorStepIdx;
  var oldStart = this._start;
  var oldEnd = this._end;

  var me = this;
  var increaseMagnitude = function increaseMagnitude() {
    me.magnitudefactor *= 2;
  };
  var decreaseMagnitude = function decreaseMagnitude() {
    me.magnitudefactor /= 2;
  };

  if (other.minorStepIdx <= 1 && this.minorStepIdx <= 1 || other.minorStepIdx > 1 && this.minorStepIdx > 1) {
    //easy, no need to change stepIdx nor multiplication factor
  } else if (other.minorStepIdx < this.minorStepIdx) {
    //I'm 5, they are 4 per major.
    this.minorStepIdx = 1;
    if (oldStepIdx == 2) {
      increaseMagnitude();
    } else {
      increaseMagnitude();
      increaseMagnitude();
    }
  } else {
    //I'm 4, they are 5 per major
    this.minorStepIdx = 2;
    if (oldStepIdx == 1) {
      decreaseMagnitude();
    } else {
      decreaseMagnitude();
      decreaseMagnitude();
    }
  }

  //Get masters stats:
  var otherZero = other.convertValue(0);
  var otherStep = other.getStep() * other.scale;

  var done = false;
  var count = 0;
  //Loop until magnitude is correct for given constrains.
  while (!done && count++ < 5) {

    //Get my stats:
    this.scale = otherStep / (this.minorSteps[this.minorStepIdx] * this.magnitudefactor);
    var newRange = this.containerHeight / this.scale;

    //For the case the magnitudefactor has changed:
    this._start = oldStart;
    this._end = this._start + newRange;

    var myOriginalZero = this._end * this.scale;
    var majorStep = this.magnitudefactor * this.majorSteps[this.minorStepIdx];
    var majorOffset = this.getFirstMajor() - other.getFirstMajor();

    if (this.zeroAlign) {
      var zeroOffset = otherZero - myOriginalZero;
      this._end += zeroOffset / this.scale;
      this._start = this._end - newRange;
    } else {
      if (!this.autoScaleStart) {
        this._start += majorStep - majorOffset / this.scale;
        this._end = this._start + newRange;
      } else {
        this._start -= majorOffset / this.scale;
        this._end = this._start + newRange;
      }
    }
    if (!this.autoScaleEnd && this._end > oldEnd + 0.00001) {
      //Need to decrease magnitude to prevent scale overshoot! (end)
      decreaseMagnitude();
      done = false;
      continue;
    }
    if (!this.autoScaleStart && this._start < oldStart - 0.00001) {
      if (this.zeroAlign && oldStart >= 0) {
        console.warn("Can't adhere to given 'min' range, due to zeroalign");
      } else {
        //Need to decrease magnitude to prevent scale overshoot! (start)
        decreaseMagnitude();
        done = false;
        continue;
      }
    }
    if (this.autoScaleStart && this.autoScaleEnd && newRange < oldEnd - oldStart) {
      increaseMagnitude();
      done = false;
      continue;
    }
    done = true;
  }
};

DataScale.prototype.convertValue = function (value) {
  return this.containerHeight - (value - this._start) * this.scale;
};

DataScale.prototype.screenToValue = function (pixels) {
  return (this.containerHeight - pixels) / this.scale + this._start;
};

module.exports = DataScale;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var Bars = __webpack_require__(110);
var Lines = __webpack_require__(111);
var Points = __webpack_require__(72);

/**
 * /**
 * @param {object} group            | the object of the group from the dataset
 * @param {string} groupId          | ID of the group
 * @param {object} options          | the default options
 * @param {array} groupsUsingDefaultStyles  | this array has one entree.
 *                                            It is passed as an array so it is passed by reference.
 *                                            It enumerates through the default styles
 * @constructor GraphGroup
 */
function GraphGroup(group, groupId, options, groupsUsingDefaultStyles) {
  this.id = groupId;
  var fields = ['sampling', 'style', 'sort', 'yAxisOrientation', 'barChart', 'drawPoints', 'shaded', 'interpolation', 'zIndex', 'excludeFromStacking', 'excludeFromLegend'];
  this.options = util.selectiveBridgeObject(fields, options);
  this.usingDefaultStyle = group.className === undefined;
  this.groupsUsingDefaultStyles = groupsUsingDefaultStyles;
  this.zeroPosition = 0;
  this.update(group);
  if (this.usingDefaultStyle == true) {
    this.groupsUsingDefaultStyles[0] += 1;
  }
  this.itemsData = [];
  this.visible = group.visible === undefined ? true : group.visible;
}

/**
 * this loads a reference to all items in this group into this group.
 * @param {array} items
 */
GraphGroup.prototype.setItems = function (items) {
  if (items != null) {
    this.itemsData = items;
    if (this.options.sort == true) {
      util.insertSort(this.itemsData, function (a, b) {
        return a.x > b.x ? 1 : -1;
      });
    }
  } else {
    this.itemsData = [];
  }
};

GraphGroup.prototype.getItems = function () {
  return this.itemsData;
};

/**
 * this is used for barcharts and shading, this way, we only have to calculate it once.
 * @param {number} pos
 */
GraphGroup.prototype.setZeroPosition = function (pos) {
  this.zeroPosition = pos;
};

/**
 * set the options of the graph group over the default options.
 * @param {Object} options
 */
GraphGroup.prototype.setOptions = function (options) {
  if (options !== undefined) {
    var fields = ['sampling', 'style', 'sort', 'yAxisOrientation', 'barChart', 'zIndex', 'excludeFromStacking', 'excludeFromLegend'];
    util.selectiveDeepExtend(fields, this.options, options);

    // if the group's drawPoints is a function delegate the callback to the onRender property
    if (typeof options.drawPoints == 'function') {
      options.drawPoints = {
        onRender: options.drawPoints
      };
    }

    util.mergeOptions(this.options, options, 'interpolation');
    util.mergeOptions(this.options, options, 'drawPoints');
    util.mergeOptions(this.options, options, 'shaded');

    if (options.interpolation) {
      if ((0, _typeof3['default'])(options.interpolation) == 'object') {
        if (options.interpolation.parametrization) {
          if (options.interpolation.parametrization == 'uniform') {
            this.options.interpolation.alpha = 0;
          } else if (options.interpolation.parametrization == 'chordal') {
            this.options.interpolation.alpha = 1.0;
          } else {
            this.options.interpolation.parametrization = 'centripetal';
            this.options.interpolation.alpha = 0.5;
          }
        }
      }
    }
  }
};

/**
 * this updates the current group class with the latest group dataset entree, used in _updateGroup in linegraph
 * @param {vis.Group} group
 */
GraphGroup.prototype.update = function (group) {
  this.group = group;
  this.content = group.content || 'graph';
  this.className = group.className || this.className || 'vis-graph-group' + this.groupsUsingDefaultStyles[0] % 10;
  this.visible = group.visible === undefined ? true : group.visible;
  this.style = group.style;
  this.setOptions(group.options);
};

/**
 * return the legend entree for this group.
 *
 * @param {number} iconWidth
 * @param {number} iconHeight
 * @param {{svg: (*|Element), svgElements: Object, options: Object, groups: Array.<Object>}} framework
 * @param {number} x
 * @param {number} y
 * @returns {{icon: (*|Element), label: (*|string), orientation: *}}
 */
GraphGroup.prototype.getLegend = function (iconWidth, iconHeight, framework, x, y) {
  if (framework == undefined || framework == null) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', "svg");
    framework = { svg: svg, svgElements: {}, options: this.options, groups: [this] };
  }
  if (x == undefined || x == null) {
    x = 0;
  }
  if (y == undefined || y == null) {
    y = 0.5 * iconHeight;
  }
  switch (this.options.style) {
    case "line":
      Lines.drawIcon(this, x, y, iconWidth, iconHeight, framework);
      break;
    case "points": //explicit no break
    case "point":
      Points.drawIcon(this, x, y, iconWidth, iconHeight, framework);
      break;
    case "bar":
      Bars.drawIcon(this, x, y, iconWidth, iconHeight, framework);
      break;
  }
  return { icon: framework.svg, label: this.content, orientation: this.options.yAxisOrientation };
};

GraphGroup.prototype.getYRange = function (groupData) {
  var yMin = groupData[0].y;
  var yMax = groupData[0].y;
  for (var j = 0; j < groupData.length; j++) {
    yMin = yMin > groupData[j].y ? groupData[j].y : yMin;
    yMax = yMax < groupData[j].y ? groupData[j].y : yMax;
  }
  return { min: yMin, max: yMax, yAxisOrientation: this.options.yAxisOrientation };
};

module.exports = GraphGroup;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOMutil = __webpack_require__(14);
var Points = __webpack_require__(72);

/**
 *
 * @param {vis.GraphGroup.id} groupId
 * @param {Object} options   // TODO: Describe options
 * @constructor Bargraph
 */
function Bargraph(groupId, options) {// eslint-disable-line no-unused-vars
}

Bargraph.drawIcon = function (group, x, y, iconWidth, iconHeight, framework) {
  var fillHeight = iconHeight * 0.5;
  var outline = DOMutil.getSVGElement("rect", framework.svgElements, framework.svg);
  outline.setAttributeNS(null, "x", x);
  outline.setAttributeNS(null, "y", y - fillHeight);
  outline.setAttributeNS(null, "width", iconWidth);
  outline.setAttributeNS(null, "height", 2 * fillHeight);
  outline.setAttributeNS(null, "class", "vis-outline");

  var barWidth = Math.round(0.3 * iconWidth);
  var originalWidth = group.options.barChart.width;
  var scale = originalWidth / barWidth;
  var bar1Height = Math.round(0.4 * iconHeight);
  var bar2Height = Math.round(0.75 * iconHeight);

  var offset = Math.round((iconWidth - 2 * barWidth) / 3);

  DOMutil.drawBar(x + 0.5 * barWidth + offset, y + fillHeight - bar1Height - 1, barWidth, bar1Height, group.className + ' vis-bar', framework.svgElements, framework.svg, group.style);
  DOMutil.drawBar(x + 1.5 * barWidth + offset + 2, y + fillHeight - bar2Height - 1, barWidth, bar2Height, group.className + ' vis-bar', framework.svgElements, framework.svg, group.style);

  if (group.options.drawPoints.enabled == true) {
    var groupTemplate = {
      style: group.options.drawPoints.style,
      styles: group.options.drawPoints.styles,
      size: group.options.drawPoints.size / scale,
      className: group.className
    };
    DOMutil.drawPoint(x + 0.5 * barWidth + offset, y + fillHeight - bar1Height - 1, groupTemplate, framework.svgElements, framework.svg);
    DOMutil.drawPoint(x + 1.5 * barWidth + offset + 2, y + fillHeight - bar2Height - 1, groupTemplate, framework.svgElements, framework.svg);
  }
};

/**
 * draw a bar graph
 *
 * @param {Array.<vis.GraphGroup.id>} groupIds
 * @param {Object} processedGroupData
 * @param {{svg: Object, svgElements: Array.<Object>, options: Object, groups: Array.<vis.Group>}} framework
 */
Bargraph.draw = function (groupIds, processedGroupData, framework) {
  var combinedData = [];
  var intersections = {};
  var coreDistance;
  var key, drawData;
  var group;
  var i, j;
  var barPoints = 0;

  // combine all barchart data
  for (i = 0; i < groupIds.length; i++) {
    group = framework.groups[groupIds[i]];
    if (group.options.style === 'bar') {
      if (group.visible === true && (framework.options.groups.visibility[groupIds[i]] === undefined || framework.options.groups.visibility[groupIds[i]] === true)) {
        for (j = 0; j < processedGroupData[groupIds[i]].length; j++) {
          combinedData.push({
            screen_x: processedGroupData[groupIds[i]][j].screen_x,
            screen_end: processedGroupData[groupIds[i]][j].screen_end,
            screen_y: processedGroupData[groupIds[i]][j].screen_y,
            x: processedGroupData[groupIds[i]][j].x,
            end: processedGroupData[groupIds[i]][j].end,
            y: processedGroupData[groupIds[i]][j].y,
            groupId: groupIds[i],
            label: processedGroupData[groupIds[i]][j].label
          });
          barPoints += 1;
        }
      }
    }
  }

  if (barPoints === 0) {
    return;
  }

  // sort by time and by group
  combinedData.sort(function (a, b) {
    if (a.screen_x === b.screen_x) {
      return a.groupId < b.groupId ? -1 : 1;
    } else {
      return a.screen_x - b.screen_x;
    }
  });

  // get intersections
  Bargraph._getDataIntersections(intersections, combinedData);

  // plot barchart
  for (i = 0; i < combinedData.length; i++) {
    group = framework.groups[combinedData[i].groupId];
    var minWidth = group.options.barChart.minWidth != undefined ? group.options.barChart.minWidth : 0.1 * group.options.barChart.width;

    key = combinedData[i].screen_x;
    var heightOffset = 0;
    if (intersections[key] === undefined) {
      if (i + 1 < combinedData.length) {
        coreDistance = Math.abs(combinedData[i + 1].screen_x - key);
      }
      drawData = Bargraph._getSafeDrawData(coreDistance, group, minWidth);
    } else {
      var nextKey = i + (intersections[key].amount - intersections[key].resolved);
      if (nextKey < combinedData.length) {
        coreDistance = Math.abs(combinedData[nextKey].screen_x - key);
      }
      drawData = Bargraph._getSafeDrawData(coreDistance, group, minWidth);
      intersections[key].resolved += 1;

      if (group.options.stack === true && group.options.excludeFromStacking !== true) {
        if (combinedData[i].screen_y < group.zeroPosition) {
          heightOffset = intersections[key].accumulatedNegative;
          intersections[key].accumulatedNegative += group.zeroPosition - combinedData[i].screen_y;
        } else {
          heightOffset = intersections[key].accumulatedPositive;
          intersections[key].accumulatedPositive += group.zeroPosition - combinedData[i].screen_y;
        }
      } else if (group.options.barChart.sideBySide === true) {
        drawData.width = drawData.width / intersections[key].amount;
        drawData.offset += intersections[key].resolved * drawData.width - 0.5 * drawData.width * (intersections[key].amount + 1);
      }
    }

    var dataWidth = drawData.width;
    var start = combinedData[i].screen_x;

    // are we drawing explicit boxes? (we supplied an end value)
    if (combinedData[i].screen_end != undefined) {
      dataWidth = combinedData[i].screen_end - combinedData[i].screen_x;
      start += dataWidth * 0.5;
    } else {
      start += drawData.offset;
    }

    DOMutil.drawBar(start, combinedData[i].screen_y - heightOffset, dataWidth, group.zeroPosition - combinedData[i].screen_y, group.className + ' vis-bar', framework.svgElements, framework.svg, group.style);

    // draw points
    if (group.options.drawPoints.enabled === true) {
      var pointData = {
        screen_x: combinedData[i].screen_x,
        screen_y: combinedData[i].screen_y - heightOffset,
        x: combinedData[i].x,
        y: combinedData[i].y,
        groupId: combinedData[i].groupId,
        label: combinedData[i].label
      };
      Points.draw([pointData], group, framework, drawData.offset);
      //DOMutil.drawPoint(combinedData[i].x + drawData.offset, combinedData[i].y, group, framework.svgElements, framework.svg);
    }
  }
};

/**
 * Fill the intersections object with counters of how many datapoints share the same x coordinates
 * @param {Object} intersections
 * @param {Array.<Object>} combinedData
 * @private
 */
Bargraph._getDataIntersections = function (intersections, combinedData) {
  // get intersections
  var coreDistance;
  for (var i = 0; i < combinedData.length; i++) {
    if (i + 1 < combinedData.length) {
      coreDistance = Math.abs(combinedData[i + 1].screen_x - combinedData[i].screen_x);
    }
    if (i > 0) {
      coreDistance = Math.min(coreDistance, Math.abs(combinedData[i - 1].screen_x - combinedData[i].screen_x));
    }
    if (coreDistance === 0) {
      if (intersections[combinedData[i].screen_x] === undefined) {
        intersections[combinedData[i].screen_x] = {
          amount: 0,
          resolved: 0,
          accumulatedPositive: 0,
          accumulatedNegative: 0
        };
      }
      intersections[combinedData[i].screen_x].amount += 1;
    }
  }
};

/**
 * Get the width and offset for bargraphs based on the coredistance between datapoints
 *
 * @param {number} coreDistance
 * @param {vis.Group} group
 * @param {number} minWidth
 * @returns {{width: number, offset: number}}
 * @private
 */
Bargraph._getSafeDrawData = function (coreDistance, group, minWidth) {
  var width, offset;
  if (coreDistance < group.options.barChart.width && coreDistance > 0) {
    width = coreDistance < minWidth ? minWidth : coreDistance;

    offset = 0; // recalculate offset with the new width;
    if (group.options.barChart.align === 'left') {
      offset -= 0.5 * coreDistance;
    } else if (group.options.barChart.align === 'right') {
      offset += 0.5 * coreDistance;
    }
  } else {
    // default settings
    width = group.options.barChart.width;
    offset = 0;
    if (group.options.barChart.align === 'left') {
      offset -= 0.5 * group.options.barChart.width;
    } else if (group.options.barChart.align === 'right') {
      offset += 0.5 * group.options.barChart.width;
    }
  }

  return { width: width, offset: offset };
};

Bargraph.getStackedYRange = function (combinedData, groupRanges, groupIds, groupLabel, orientation) {
  if (combinedData.length > 0) {
    // sort by time and by group
    combinedData.sort(function (a, b) {
      if (a.screen_x === b.screen_x) {
        return a.groupId < b.groupId ? -1 : 1;
      } else {
        return a.screen_x - b.screen_x;
      }
    });
    var intersections = {};

    Bargraph._getDataIntersections(intersections, combinedData);
    groupRanges[groupLabel] = Bargraph._getStackedYRange(intersections, combinedData);
    groupRanges[groupLabel].yAxisOrientation = orientation;
    groupIds.push(groupLabel);
  }
};

Bargraph._getStackedYRange = function (intersections, combinedData) {
  var key;
  var yMin = combinedData[0].screen_y;
  var yMax = combinedData[0].screen_y;
  for (var i = 0; i < combinedData.length; i++) {
    key = combinedData[i].screen_x;
    if (intersections[key] === undefined) {
      yMin = yMin > combinedData[i].screen_y ? combinedData[i].screen_y : yMin;
      yMax = yMax < combinedData[i].screen_y ? combinedData[i].screen_y : yMax;
    } else {
      if (combinedData[i].screen_y < 0) {
        intersections[key].accumulatedNegative += combinedData[i].screen_y;
      } else {
        intersections[key].accumulatedPositive += combinedData[i].screen_y;
      }
    }
  }
  for (var xpos in intersections) {
    if (intersections.hasOwnProperty(xpos)) {
      yMin = yMin > intersections[xpos].accumulatedNegative ? intersections[xpos].accumulatedNegative : yMin;
      yMin = yMin > intersections[xpos].accumulatedPositive ? intersections[xpos].accumulatedPositive : yMin;
      yMax = yMax < intersections[xpos].accumulatedNegative ? intersections[xpos].accumulatedNegative : yMax;
      yMax = yMax < intersections[xpos].accumulatedPositive ? intersections[xpos].accumulatedPositive : yMax;
    }
  }

  return { min: yMin, max: yMax };
};

module.exports = Bargraph;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOMutil = __webpack_require__(14);

/**
 *
 * @param {vis.GraphGroup.id} groupId
 * @param {Object} options   // TODO: Describe options
 * @constructor Line
 */
function Line(groupId, options) {// eslint-disable-line no-unused-vars
}

Line.calcPath = function (dataset, group) {
    if (dataset != null) {
        if (dataset.length > 0) {
            var d = [];

            // construct path from dataset
            if (group.options.interpolation.enabled == true) {
                d = Line._catmullRom(dataset, group);
            } else {
                d = Line._linear(dataset);
            }
            return d;
        }
    }
};

Line.drawIcon = function (group, x, y, iconWidth, iconHeight, framework) {
    var fillHeight = iconHeight * 0.5;
    var path, fillPath;

    var outline = DOMutil.getSVGElement("rect", framework.svgElements, framework.svg);
    outline.setAttributeNS(null, "x", x);
    outline.setAttributeNS(null, "y", y - fillHeight);
    outline.setAttributeNS(null, "width", iconWidth);
    outline.setAttributeNS(null, "height", 2 * fillHeight);
    outline.setAttributeNS(null, "class", "vis-outline");

    path = DOMutil.getSVGElement("path", framework.svgElements, framework.svg);
    path.setAttributeNS(null, "class", group.className);
    if (group.style !== undefined) {
        path.setAttributeNS(null, "style", group.style);
    }

    path.setAttributeNS(null, "d", "M" + x + "," + y + " L" + (x + iconWidth) + "," + y + "");
    if (group.options.shaded.enabled == true) {
        fillPath = DOMutil.getSVGElement("path", framework.svgElements, framework.svg);
        if (group.options.shaded.orientation == 'top') {
            fillPath.setAttributeNS(null, "d", "M" + x + ", " + (y - fillHeight) + "L" + x + "," + y + " L" + (x + iconWidth) + "," + y + " L" + (x + iconWidth) + "," + (y - fillHeight));
        } else {
            fillPath.setAttributeNS(null, "d", "M" + x + "," + y + " " + "L" + x + "," + (y + fillHeight) + " " + "L" + (x + iconWidth) + "," + (y + fillHeight) + "L" + (x + iconWidth) + "," + y);
        }
        fillPath.setAttributeNS(null, "class", group.className + " vis-icon-fill");
        if (group.options.shaded.style !== undefined && group.options.shaded.style !== "") {
            fillPath.setAttributeNS(null, "style", group.options.shaded.style);
        }
    }

    if (group.options.drawPoints.enabled == true) {
        var groupTemplate = {
            style: group.options.drawPoints.style,
            styles: group.options.drawPoints.styles,
            size: group.options.drawPoints.size,
            className: group.className
        };
        DOMutil.drawPoint(x + 0.5 * iconWidth, y, groupTemplate, framework.svgElements, framework.svg);
    }
};

Line.drawShading = function (pathArray, group, subPathArray, framework) {
    // append shading to the path
    if (group.options.shaded.enabled == true) {
        var svgHeight = Number(framework.svg.style.height.replace('px', ''));
        var fillPath = DOMutil.getSVGElement('path', framework.svgElements, framework.svg);
        var type = "L";
        if (group.options.interpolation.enabled == true) {
            type = "C";
        }
        var dFill;
        var zero = 0;
        if (group.options.shaded.orientation == 'top') {
            zero = 0;
        } else if (group.options.shaded.orientation == 'bottom') {
            zero = svgHeight;
        } else {
            zero = Math.min(Math.max(0, group.zeroPosition), svgHeight);
        }
        if (group.options.shaded.orientation == 'group' && subPathArray != null && subPathArray != undefined) {
            dFill = 'M' + pathArray[0][0] + "," + pathArray[0][1] + " " + this.serializePath(pathArray, type, false) + ' L' + subPathArray[subPathArray.length - 1][0] + "," + subPathArray[subPathArray.length - 1][1] + " " + this.serializePath(subPathArray, type, true) + subPathArray[0][0] + "," + subPathArray[0][1] + " Z";
        } else {
            dFill = 'M' + pathArray[0][0] + "," + pathArray[0][1] + " " + this.serializePath(pathArray, type, false) + ' V' + zero + ' H' + pathArray[0][0] + " Z";
        }

        fillPath.setAttributeNS(null, 'class', group.className + ' vis-fill');
        if (group.options.shaded.style !== undefined) {
            fillPath.setAttributeNS(null, 'style', group.options.shaded.style);
        }
        fillPath.setAttributeNS(null, 'd', dFill);
    }
};

/**
 * draw a line graph
 *
 * @param {Array.<Object>} pathArray
 * @param {vis.Group} group
 * @param {{svg: Object, svgElements: Array.<Object>, options: Object, groups: Array.<vis.Group>}} framework
 */
Line.draw = function (pathArray, group, framework) {
    if (pathArray != null && pathArray != undefined) {
        var path = DOMutil.getSVGElement('path', framework.svgElements, framework.svg);
        path.setAttributeNS(null, "class", group.className);
        if (group.style !== undefined) {
            path.setAttributeNS(null, "style", group.style);
        }

        var type = "L";
        if (group.options.interpolation.enabled == true) {
            type = "C";
        }
        // copy properties to path for drawing.
        path.setAttributeNS(null, 'd', 'M' + pathArray[0][0] + "," + pathArray[0][1] + " " + this.serializePath(pathArray, type, false));
    }
};

Line.serializePath = function (pathArray, type, inverse) {
    if (pathArray.length < 2) {
        //Too little data to create a path.
        return "";
    }
    var d = type;
    var i;
    if (inverse) {
        for (i = pathArray.length - 2; i > 0; i--) {
            d += pathArray[i][0] + "," + pathArray[i][1] + " ";
        }
    } else {
        for (i = 1; i < pathArray.length; i++) {
            d += pathArray[i][0] + "," + pathArray[i][1] + " ";
        }
    }
    return d;
};

/**
 * This uses an uniform parametrization of the interpolation algorithm:
 * 'On the Parameterization of Catmull-Rom Curves' by Cem Yuksel et al.
 * @param {Array.<Object>} data
 * @returns {string}
 * @private
 */
Line._catmullRomUniform = function (data) {
    // catmull rom
    var p0, p1, p2, p3, bp1, bp2;
    var d = [];
    d.push([Math.round(data[0].screen_x), Math.round(data[0].screen_y)]);
    var normalization = 1 / 6;
    var length = data.length;
    for (var i = 0; i < length - 1; i++) {

        p0 = i == 0 ? data[0] : data[i - 1];
        p1 = data[i];
        p2 = data[i + 1];
        p3 = i + 2 < length ? data[i + 2] : p2;

        // Catmull-Rom to Cubic Bezier conversion matrix
        //    0       1       0       0
        //  -1/6      1      1/6      0
        //    0      1/6      1     -1/6
        //    0       0       1       0

        //    bp0 = { x: p1.x,                               y: p1.y };
        bp1 = {
            screen_x: (-p0.screen_x + 6 * p1.screen_x + p2.screen_x) * normalization,
            screen_y: (-p0.screen_y + 6 * p1.screen_y + p2.screen_y) * normalization
        };
        bp2 = {
            screen_x: (p1.screen_x + 6 * p2.screen_x - p3.screen_x) * normalization,
            screen_y: (p1.screen_y + 6 * p2.screen_y - p3.screen_y) * normalization
        };
        //    bp0 = { x: p2.x,                               y: p2.y };

        d.push([bp1.screen_x, bp1.screen_y]);
        d.push([bp2.screen_x, bp2.screen_y]);
        d.push([p2.screen_x, p2.screen_y]);
    }

    return d;
};

/**
 * This uses either the chordal or centripetal parameterization of the catmull-rom algorithm.
 * By default, the centripetal parameterization is used because this gives the nicest results.
 * These parameterizations are relatively heavy because the distance between 4 points have to be calculated.
 *
 * One optimization can be used to reuse distances since this is a sliding window approach.
 * @param {Array.<Object>} data
 * @param {vis.GraphGroup} group
 * @returns {string}
 * @private
 */
Line._catmullRom = function (data, group) {
    var alpha = group.options.interpolation.alpha;
    if (alpha == 0 || alpha === undefined) {
        return this._catmullRomUniform(data);
    } else {
        var p0, p1, p2, p3, bp1, bp2, d1, d2, d3, A, B, N, M;
        var d3powA, d2powA, d3pow2A, d2pow2A, d1pow2A, d1powA;
        var d = [];
        d.push([Math.round(data[0].screen_x), Math.round(data[0].screen_y)]);
        var length = data.length;
        for (var i = 0; i < length - 1; i++) {

            p0 = i == 0 ? data[0] : data[i - 1];
            p1 = data[i];
            p2 = data[i + 1];
            p3 = i + 2 < length ? data[i + 2] : p2;

            d1 = Math.sqrt(Math.pow(p0.screen_x - p1.screen_x, 2) + Math.pow(p0.screen_y - p1.screen_y, 2));
            d2 = Math.sqrt(Math.pow(p1.screen_x - p2.screen_x, 2) + Math.pow(p1.screen_y - p2.screen_y, 2));
            d3 = Math.sqrt(Math.pow(p2.screen_x - p3.screen_x, 2) + Math.pow(p2.screen_y - p3.screen_y, 2));

            // Catmull-Rom to Cubic Bezier conversion matrix

            // A = 2d1^2a + 3d1^a * d2^a + d3^2a
            // B = 2d3^2a + 3d3^a * d2^a + d2^2a

            // [   0             1            0          0          ]
            // [   -d2^2a /N     A/N          d1^2a /N   0          ]
            // [   0             d3^2a /M     B/M        -d2^2a /M  ]
            // [   0             0            1          0          ]

            d3powA = Math.pow(d3, alpha);
            d3pow2A = Math.pow(d3, 2 * alpha);
            d2powA = Math.pow(d2, alpha);
            d2pow2A = Math.pow(d2, 2 * alpha);
            d1powA = Math.pow(d1, alpha);
            d1pow2A = Math.pow(d1, 2 * alpha);

            A = 2 * d1pow2A + 3 * d1powA * d2powA + d2pow2A;
            B = 2 * d3pow2A + 3 * d3powA * d2powA + d2pow2A;
            N = 3 * d1powA * (d1powA + d2powA);
            if (N > 0) {
                N = 1 / N;
            }
            M = 3 * d3powA * (d3powA + d2powA);
            if (M > 0) {
                M = 1 / M;
            }

            bp1 = {
                screen_x: (-d2pow2A * p0.screen_x + A * p1.screen_x + d1pow2A * p2.screen_x) * N,
                screen_y: (-d2pow2A * p0.screen_y + A * p1.screen_y + d1pow2A * p2.screen_y) * N
            };

            bp2 = {
                screen_x: (d3pow2A * p1.screen_x + B * p2.screen_x - d2pow2A * p3.screen_x) * M,
                screen_y: (d3pow2A * p1.screen_y + B * p2.screen_y - d2pow2A * p3.screen_y) * M
            };

            if (bp1.screen_x == 0 && bp1.screen_y == 0) {
                bp1 = p1;
            }
            if (bp2.screen_x == 0 && bp2.screen_y == 0) {
                bp2 = p2;
            }
            d.push([bp1.screen_x, bp1.screen_y]);
            d.push([bp2.screen_x, bp2.screen_y]);
            d.push([p2.screen_x, p2.screen_y]);
        }

        return d;
    }
};

/**
 * this generates the SVG path for a linear drawing between datapoints.
 * @param {Array.<Object>} data
 * @returns {string}
 * @private
 */
Line._linear = function (data) {
    // linear
    var d = [];
    for (var i = 0; i < data.length; i++) {
        d.push([data[i].screen_x, data[i].screen_y]);
    }
    return d;
};

module.exports = Line;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var DOMutil = __webpack_require__(14);
var Component = __webpack_require__(16);

/**
 * Legend for Graph2d
 *
 * @param {vis.Graph2d.body} body
 * @param {vis.Graph2d.options} options
 * @param {number} side
 * @param {vis.LineGraph.options} linegraphOptions
 * @constructor Legend
 * @extends Component
 */
function Legend(body, options, side, linegraphOptions) {
  this.body = body;
  this.defaultOptions = {
    enabled: false,
    icons: true,
    iconSize: 20,
    iconSpacing: 6,
    left: {
      visible: true,
      position: 'top-left' // top/bottom - left,center,right
    },
    right: {
      visible: true,
      position: 'top-right' // top/bottom - left,center,right
    }
  };

  this.side = side;
  this.options = util.extend({}, this.defaultOptions);
  this.linegraphOptions = linegraphOptions;

  this.svgElements = {};
  this.dom = {};
  this.groups = {};
  this.amountOfGroups = 0;
  this._create();
  this.framework = { svg: this.svg, svgElements: this.svgElements, options: this.options, groups: this.groups };

  this.setOptions(options);
}

Legend.prototype = new Component();

Legend.prototype.clear = function () {
  this.groups = {};
  this.amountOfGroups = 0;
};

Legend.prototype.addGroup = function (label, graphOptions) {

  // Include a group only if the group option 'excludeFromLegend: false' is not set.
  if (graphOptions.options.excludeFromLegend != true) {
    if (!this.groups.hasOwnProperty(label)) {
      this.groups[label] = graphOptions;
    }
    this.amountOfGroups += 1;
  }
};

Legend.prototype.updateGroup = function (label, graphOptions) {
  this.groups[label] = graphOptions;
};

Legend.prototype.removeGroup = function (label) {
  if (this.groups.hasOwnProperty(label)) {
    delete this.groups[label];
    this.amountOfGroups -= 1;
  }
};

Legend.prototype._create = function () {
  this.dom.frame = document.createElement('div');
  this.dom.frame.className = 'vis-legend';
  this.dom.frame.style.position = "absolute";
  this.dom.frame.style.top = "10px";
  this.dom.frame.style.display = "block";

  this.dom.textArea = document.createElement('div');
  this.dom.textArea.className = 'vis-legend-text';
  this.dom.textArea.style.position = "relative";
  this.dom.textArea.style.top = "0px";

  this.svg = document.createElementNS('http://www.w3.org/2000/svg', "svg");
  this.svg.style.position = 'absolute';
  this.svg.style.top = 0 + 'px';
  this.svg.style.width = this.options.iconSize + 5 + 'px';
  this.svg.style.height = '100%';

  this.dom.frame.appendChild(this.svg);
  this.dom.frame.appendChild(this.dom.textArea);
};

/**
 * Hide the component from the DOM
 */
Legend.prototype.hide = function () {
  // remove the frame containing the items
  if (this.dom.frame.parentNode) {
    this.dom.frame.parentNode.removeChild(this.dom.frame);
  }
};

/**
 * Show the component in the DOM (when not already visible).
 */
Legend.prototype.show = function () {
  // show frame containing the items
  if (!this.dom.frame.parentNode) {
    this.body.dom.center.appendChild(this.dom.frame);
  }
};

Legend.prototype.setOptions = function (options) {
  var fields = ['enabled', 'orientation', 'icons', 'left', 'right'];
  util.selectiveDeepExtend(fields, this.options, options);
};

Legend.prototype.redraw = function () {
  var activeGroups = 0;
  var groupArray = (0, _keys2['default'])(this.groups);
  groupArray.sort(function (a, b) {
    return a < b ? -1 : 1;
  });

  for (var i = 0; i < groupArray.length; i++) {
    var groupId = groupArray[i];
    if (this.groups[groupId].visible == true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] == true)) {
      activeGroups++;
    }
  }

  if (this.options[this.side].visible == false || this.amountOfGroups == 0 || this.options.enabled == false || activeGroups == 0) {
    this.hide();
  } else {
    this.show();
    if (this.options[this.side].position == 'top-left' || this.options[this.side].position == 'bottom-left') {
      this.dom.frame.style.left = '4px';
      this.dom.frame.style.textAlign = "left";
      this.dom.textArea.style.textAlign = "left";
      this.dom.textArea.style.left = this.options.iconSize + 15 + 'px';
      this.dom.textArea.style.right = '';
      this.svg.style.left = 0 + 'px';
      this.svg.style.right = '';
    } else {
      this.dom.frame.style.right = '4px';
      this.dom.frame.style.textAlign = "right";
      this.dom.textArea.style.textAlign = "right";
      this.dom.textArea.style.right = this.options.iconSize + 15 + 'px';
      this.dom.textArea.style.left = '';
      this.svg.style.right = 0 + 'px';
      this.svg.style.left = '';
    }

    if (this.options[this.side].position == 'top-left' || this.options[this.side].position == 'top-right') {
      this.dom.frame.style.top = 4 - Number(this.body.dom.center.style.top.replace("px", "")) + 'px';
      this.dom.frame.style.bottom = '';
    } else {
      var scrollableHeight = this.body.domProps.center.height - this.body.domProps.centerContainer.height;
      this.dom.frame.style.bottom = 4 + scrollableHeight + Number(this.body.dom.center.style.top.replace("px", "")) + 'px';
      this.dom.frame.style.top = '';
    }

    if (this.options.icons == false) {
      this.dom.frame.style.width = this.dom.textArea.offsetWidth + 10 + 'px';
      this.dom.textArea.style.right = '';
      this.dom.textArea.style.left = '';
      this.svg.style.width = '0px';
    } else {
      this.dom.frame.style.width = this.options.iconSize + 15 + this.dom.textArea.offsetWidth + 10 + 'px';
      this.drawLegendIcons();
    }

    var content = '';
    for (i = 0; i < groupArray.length; i++) {
      groupId = groupArray[i];
      if (this.groups[groupId].visible == true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] == true)) {
        content += this.groups[groupId].content + '<br />';
      }
    }
    this.dom.textArea.innerHTML = content;
    this.dom.textArea.style.lineHeight = 0.75 * this.options.iconSize + this.options.iconSpacing + 'px';
  }
};

Legend.prototype.drawLegendIcons = function () {
  if (this.dom.frame.parentNode) {
    var groupArray = (0, _keys2['default'])(this.groups);
    groupArray.sort(function (a, b) {
      return a < b ? -1 : 1;
    });

    // this resets the elements so the order is maintained
    DOMutil.resetElements(this.svgElements);

    var padding = window.getComputedStyle(this.dom.frame).paddingTop;
    var iconOffset = Number(padding.replace('px', ''));
    var x = iconOffset;
    var iconWidth = this.options.iconSize;
    var iconHeight = 0.75 * this.options.iconSize;
    var y = iconOffset + 0.5 * iconHeight + 3;

    this.svg.style.width = iconWidth + 5 + iconOffset + 'px';

    for (var i = 0; i < groupArray.length; i++) {
      var groupId = groupArray[i];
      if (this.groups[groupId].visible == true && (this.linegraphOptions.visibility[groupId] === undefined || this.linegraphOptions.visibility[groupId] == true)) {
        this.groups[groupId].getLegend(iconWidth, iconHeight, this.framework, x, y);
        y += iconHeight + this.options.iconSpacing;
      }
    }
  }
};

module.exports = Legend;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This object contains all possible options. It will check if the types are correct, if required if the option is one
 * of the allowed values.
 *
 * __any__ means that the name of the property does not matter.
 * __type__ is a required field for all objects and contains the allowed types of all objects
 */
var string = 'string';
var bool = 'boolean';
var number = 'number';
var array = 'array';
var date = 'date';
var object = 'object'; // should only be in a __type__ property
var dom = 'dom';
var moment = 'moment';
var any = 'any';

var allOptions = {
  configure: {
    enabled: { 'boolean': bool },
    filter: { 'boolean': bool, 'function': 'function' },
    container: { dom: dom },
    __type__: { object: object, 'boolean': bool, 'function': 'function' }
  },

  //globals :
  yAxisOrientation: { string: ['left', 'right'] },
  defaultGroup: { string: string },
  sort: { 'boolean': bool },
  sampling: { 'boolean': bool },
  stack: { 'boolean': bool },
  graphHeight: { string: string, number: number },
  shaded: {
    enabled: { 'boolean': bool },
    orientation: { string: ['bottom', 'top', 'zero', 'group'] }, // top, bottom, zero, group
    groupId: { object: object },
    __type__: { 'boolean': bool, object: object }
  },
  style: { string: ['line', 'bar', 'points'] }, // line, bar
  barChart: {
    width: { number: number },
    minWidth: { number: number },
    sideBySide: { 'boolean': bool },
    align: { string: ['left', 'center', 'right'] },
    __type__: { object: object }
  },
  interpolation: {
    enabled: { 'boolean': bool },
    parametrization: { string: ['centripetal', 'chordal', 'uniform'] }, // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
    alpha: { number: number },
    __type__: { object: object, 'boolean': bool }
  },
  drawPoints: {
    enabled: { 'boolean': bool },
    onRender: { 'function': 'function' },
    size: { number: number },
    style: { string: ['square', 'circle'] }, // square, circle
    __type__: { object: object, 'boolean': bool, 'function': 'function' }
  },
  dataAxis: {
    showMinorLabels: { 'boolean': bool },
    showMajorLabels: { 'boolean': bool },
    icons: { 'boolean': bool },
    width: { string: string, number: number },
    visible: { 'boolean': bool },
    alignZeros: { 'boolean': bool },
    left: {
      range: { min: { number: number, 'undefined': 'undefined' }, max: { number: number, 'undefined': 'undefined' }, __type__: { object: object } },
      format: { 'function': 'function' },
      title: { text: { string: string, number: number, 'undefined': 'undefined' }, style: { string: string, 'undefined': 'undefined' }, __type__: { object: object } },
      __type__: { object: object }
    },
    right: {
      range: { min: { number: number, 'undefined': 'undefined' }, max: { number: number, 'undefined': 'undefined' }, __type__: { object: object } },
      format: { 'function': 'function' },
      title: { text: { string: string, number: number, 'undefined': 'undefined' }, style: { string: string, 'undefined': 'undefined' }, __type__: { object: object } },
      __type__: { object: object }
    },
    __type__: { object: object }
  },
  legend: {
    enabled: { 'boolean': bool },
    icons: { 'boolean': bool },
    left: {
      visible: { 'boolean': bool },
      position: { string: ['top-right', 'bottom-right', 'top-left', 'bottom-left'] },
      __type__: { object: object }
    },
    right: {
      visible: { 'boolean': bool },
      position: { string: ['top-right', 'bottom-right', 'top-left', 'bottom-left'] },
      __type__: { object: object }
    },
    __type__: { object: object, 'boolean': bool }
  },
  groups: {
    visibility: { any: any },
    __type__: { object: object }
  },

  autoResize: { 'boolean': bool },
  throttleRedraw: { number: number }, // TODO: DEPRICATED see https://github.com/almende/vis/issues/2511
  clickToUse: { 'boolean': bool },
  end: { number: number, date: date, string: string, moment: moment },
  format: {
    minorLabels: {
      millisecond: { string: string, 'undefined': 'undefined' },
      second: { string: string, 'undefined': 'undefined' },
      minute: { string: string, 'undefined': 'undefined' },
      hour: { string: string, 'undefined': 'undefined' },
      weekday: { string: string, 'undefined': 'undefined' },
      day: { string: string, 'undefined': 'undefined' },
      month: { string: string, 'undefined': 'undefined' },
      year: { string: string, 'undefined': 'undefined' },
      __type__: { object: object }
    },
    majorLabels: {
      millisecond: { string: string, 'undefined': 'undefined' },
      second: { string: string, 'undefined': 'undefined' },
      minute: { string: string, 'undefined': 'undefined' },
      hour: { string: string, 'undefined': 'undefined' },
      weekday: { string: string, 'undefined': 'undefined' },
      day: { string: string, 'undefined': 'undefined' },
      month: { string: string, 'undefined': 'undefined' },
      year: { string: string, 'undefined': 'undefined' },
      __type__: { object: object }
    },
    __type__: { object: object }
  },
  moment: { 'function': 'function' },
  height: { string: string, number: number },
  hiddenDates: {
    start: { date: date, number: number, string: string, moment: moment },
    end: { date: date, number: number, string: string, moment: moment },
    repeat: { string: string },
    __type__: { object: object, array: array }
  },
  locale: { string: string },
  locales: {
    __any__: { any: any },
    __type__: { object: object }
  },
  max: { date: date, number: number, string: string, moment: moment },
  maxHeight: { number: number, string: string },
  maxMinorChars: { number: number },
  min: { date: date, number: number, string: string, moment: moment },
  minHeight: { number: number, string: string },
  moveable: { 'boolean': bool },
  multiselect: { 'boolean': bool },
  orientation: { string: string },
  showCurrentTime: { 'boolean': bool },
  showMajorLabels: { 'boolean': bool },
  showMinorLabels: { 'boolean': bool },
  start: { date: date, number: number, string: string, moment: moment },
  timeAxis: {
    scale: { string: string, 'undefined': 'undefined' },
    step: { number: number, 'undefined': 'undefined' },
    __type__: { object: object }
  },
  width: { string: string, number: number },
  zoomable: { 'boolean': bool },
  zoomKey: { string: ['ctrlKey', 'altKey', 'metaKey', ''] },
  zoomMax: { number: number },
  zoomMin: { number: number },
  zIndex: { number: number },
  __type__: { object: object }
};

var configureOptions = {
  global: {
    //yAxisOrientation: ['left','right'], // TDOO: enable as soon as Grahp2d doesn't crash when changing this on the fly
    sort: true,
    sampling: true,
    stack: false,
    shaded: {
      enabled: false,
      orientation: ['zero', 'top', 'bottom', 'group'] // zero, top, bottom
    },
    style: ['line', 'bar', 'points'], // line, bar
    barChart: {
      width: [50, 5, 100, 5],
      minWidth: [50, 5, 100, 5],
      sideBySide: false,
      align: ['left', 'center', 'right'] // left, center, right
    },
    interpolation: {
      enabled: true,
      parametrization: ['centripetal', 'chordal', 'uniform'] // uniform (alpha = 0.0), chordal (alpha = 1.0), centripetal (alpha = 0.5)
    },
    drawPoints: {
      enabled: true,
      size: [6, 2, 30, 1],
      style: ['square', 'circle'] // square, circle
    },
    dataAxis: {
      showMinorLabels: true,
      showMajorLabels: true,
      icons: false,
      width: [40, 0, 200, 1],
      visible: true,
      alignZeros: true,
      left: {
        //range: {min:'undefined': 'undefined'ined,max:'undefined': 'undefined'ined},
        //format: function (value) {return value;},
        title: { text: '', style: '' }
      },
      right: {
        //range: {min:'undefined': 'undefined'ined,max:'undefined': 'undefined'ined},
        //format: function (value) {return value;},
        title: { text: '', style: '' }
      }
    },
    legend: {
      enabled: false,
      icons: true,
      left: {
        visible: true,
        position: ['top-right', 'bottom-right', 'top-left', 'bottom-left'] // top/bottom - left,right
      },
      right: {
        visible: true,
        position: ['top-right', 'bottom-right', 'top-left', 'bottom-left'] // top/bottom - left,right
      }
    },

    autoResize: true,
    clickToUse: false,
    end: '',
    format: {
      minorLabels: {
        millisecond: 'SSS',
        second: 's',
        minute: 'HH:mm',
        hour: 'HH:mm',
        weekday: 'ddd D',
        day: 'D',
        month: 'MMM',
        year: 'YYYY'
      },
      majorLabels: {
        millisecond: 'HH:mm:ss',
        second: 'D MMMM HH:mm',
        minute: 'ddd D MMMM',
        hour: 'ddd D MMMM',
        weekday: 'MMMM YYYY',
        day: 'MMMM YYYY',
        month: 'YYYY',
        year: ''
      }
    },

    height: '',
    locale: '',
    max: '',
    maxHeight: '',
    maxMinorChars: [7, 0, 20, 1],
    min: '',
    minHeight: '',
    moveable: true,
    orientation: ['both', 'bottom', 'top'],
    showCurrentTime: false,
    showMajorLabels: true,
    showMinorLabels: true,
    start: '',
    width: '100%',
    zoomable: true,
    zoomKey: ['ctrlKey', 'altKey', 'metaKey', ''],
    zoomMax: [315360000000000, 10, 315360000000000, 1],
    zoomMin: [10, 10, 315360000000000, 1],
    zIndex: 0
  }
};

exports.allOptions = allOptions;
exports.configureOptions = configureOptions;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _create = __webpack_require__(29);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Parse a text source containing data in DOT language into a JSON object.
 * The object contains two lists: one with nodes and one with edges.
 *
 * DOT language reference: http://www.graphviz.org/doc/info/lang.html
 *
 * DOT language attributes: http://graphviz.org/content/attrs
 *
 * @param {string} data     Text containing a graph in DOT-notation
 * @return {Object} graph   An object containing two parameters:
 *                          {Object[]} nodes
 *                          {Object[]} edges
 *
 * -------------------------------------------
 * TODO
 * ====
 *
 * For label handling, this is an incomplete implementation. From docs (quote #3015):
 * 
 * > the escape sequences "\n", "\l" and "\r" divide the label into lines, centered, 
 * > left-justified, and right-justified, respectively.
 *
 * Source: http://www.graphviz.org/content/attrs#kescString
 *
 * > As another aid for readability, dot allows double-quoted strings to span multiple physical
 * > lines using the standard C convention of a backslash immediately preceding a newline
 * > character
 * > In addition, double-quoted strings can be concatenated using a '+' operator.
 * > As HTML strings can contain newline characters, which are used solely for formatting,
 * > the language does not allow escaped newlines or concatenation operators to be used
 * > within them.
 *
 * - Currently, only '\\n' is handled
 * - Note that text explicitly says 'labels'; the dot parser currently handles escape
 *   sequences in **all** strings.
 */
function parseDOT(data) {
  dot = data;
  return parseGraph();
}

// mapping of attributes from DOT (the keys) to vis.js (the values)
var NODE_ATTR_MAPPING = {
  'fontsize': 'font.size',
  'fontcolor': 'font.color',
  'labelfontcolor': 'font.color',
  'fontname': 'font.face',
  'color': ['color.border', 'color.background'],
  'fillcolor': 'color.background',
  'tooltip': 'title',
  'labeltooltip': 'title'
};
var EDGE_ATTR_MAPPING = (0, _create2['default'])(NODE_ATTR_MAPPING);
EDGE_ATTR_MAPPING.color = 'color.color';
EDGE_ATTR_MAPPING.style = 'dashes';

// token types enumeration
var TOKENTYPE = {
  NULL: 0,
  DELIMITER: 1,
  IDENTIFIER: 2,
  UNKNOWN: 3
};

// map with all delimiters
var DELIMITERS = {
  '{': true,
  '}': true,
  '[': true,
  ']': true,
  ';': true,
  '=': true,
  ',': true,

  '->': true,
  '--': true
};

var dot = ''; // current dot file
var index = 0; // current index in dot file
var c = ''; // current token character in expr
var token = ''; // current token
var tokenType = TOKENTYPE.NULL; // type of the token

/**
 * Get the first character from the dot file.
 * The character is stored into the char c. If the end of the dot file is
 * reached, the function puts an empty string in c.
 */
function first() {
  index = 0;
  c = dot.charAt(0);
}

/**
 * Get the next character from the dot file.
 * The character is stored into the char c. If the end of the dot file is
 * reached, the function puts an empty string in c.
 */
function next() {
  index++;
  c = dot.charAt(index);
}

/**
 * Preview the next character from the dot file.
 * @return {string} cNext
 */
function nextPreview() {
  return dot.charAt(index + 1);
}

var regexAlphaNumeric = /[a-zA-Z_0-9.:#]/;
/**
 * Test whether given character is alphabetic or numeric
 * @param {string} c
 * @return {Boolean} isAlphaNumeric
 */
function isAlphaNumeric(c) {
  return regexAlphaNumeric.test(c);
}

/**
 * Merge all options of object b into object b
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 */
function merge(a, b) {
  if (!a) {
    a = {};
  }

  if (b) {
    for (var name in b) {
      if (b.hasOwnProperty(name)) {
        a[name] = b[name];
      }
    }
  }
  return a;
}

/**
 * Set a value in an object, where the provided parameter name can be a
 * path with nested parameters. For example:
 *
 *     var obj = {a: 2};
 *     setValue(obj, 'b.c', 3);     // obj = {a: 2, b: {c: 3}}
 *
 * @param {Object} obj
 * @param {string} path  A parameter name or dot-separated parameter path,
 *                      like "color.highlight.border".
 * @param {*} value
 */
function setValue(obj, path, value) {
  var keys = path.split('.');
  var o = obj;
  while (keys.length) {
    var key = keys.shift();
    if (keys.length) {
      // this isn't the end point
      if (!o[key]) {
        o[key] = {};
      }
      o = o[key];
    } else {
      // this is the end point
      o[key] = value;
    }
  }
}

/**
 * Add a node to a graph object. If there is already a node with
 * the same id, their attributes will be merged.
 * @param {Object} graph
 * @param {Object} node
 */
function addNode(graph, node) {
  var i, len;
  var current = null;

  // find root graph (in case of subgraph)
  var graphs = [graph]; // list with all graphs from current graph to root graph
  var root = graph;
  while (root.parent) {
    graphs.push(root.parent);
    root = root.parent;
  }

  // find existing node (at root level) by its id
  if (root.nodes) {
    for (i = 0, len = root.nodes.length; i < len; i++) {
      if (node.id === root.nodes[i].id) {
        current = root.nodes[i];
        break;
      }
    }
  }

  if (!current) {
    // this is a new node
    current = {
      id: node.id
    };
    if (graph.node) {
      // clone default attributes
      current.attr = merge(current.attr, graph.node);
    }
  }

  // add node to this (sub)graph and all its parent graphs
  for (i = graphs.length - 1; i >= 0; i--) {
    var g = graphs[i];

    if (!g.nodes) {
      g.nodes = [];
    }
    if (g.nodes.indexOf(current) === -1) {
      g.nodes.push(current);
    }
  }

  // merge attributes
  if (node.attr) {
    current.attr = merge(current.attr, node.attr);
  }
}

/**
 * Add an edge to a graph object
 * @param {Object} graph
 * @param {Object} edge
 */
function addEdge(graph, edge) {
  if (!graph.edges) {
    graph.edges = [];
  }
  graph.edges.push(edge);
  if (graph.edge) {
    var attr = merge({}, graph.edge); // clone default attributes
    edge.attr = merge(attr, edge.attr); // merge attributes
  }
}

/**
 * Create an edge to a graph object
 * @param {Object} graph
 * @param {string | number | Object} from
 * @param {string | number | Object} to
 * @param {string} type
 * @param {Object | null} attr
 * @return {Object} edge
 */
function createEdge(graph, from, to, type, attr) {
  var edge = {
    from: from,
    to: to,
    type: type
  };

  if (graph.edge) {
    edge.attr = merge({}, graph.edge); // clone default attributes
  }
  edge.attr = merge(edge.attr || {}, attr); // merge attributes

  return edge;
}

/**
 * Get next token in the current dot file.
 * The token and token type are available as token and tokenType
 */
function getToken() {
  tokenType = TOKENTYPE.NULL;
  token = '';

  // skip over whitespaces
  while (c === ' ' || c === '\t' || c === '\n' || c === '\r') {
    // space, tab, enter
    next();
  }

  do {
    var isComment = false;

    // skip comment
    if (c === '#') {
      // find the previous non-space character
      var i = index - 1;
      while (dot.charAt(i) === ' ' || dot.charAt(i) === '\t') {
        i--;
      }
      if (dot.charAt(i) === '\n' || dot.charAt(i) === '') {
        // the # is at the start of a line, this is indeed a line comment
        while (c != '' && c != '\n') {
          next();
        }
        isComment = true;
      }
    }
    if (c === '/' && nextPreview() === '/') {
      // skip line comment
      while (c != '' && c != '\n') {
        next();
      }
      isComment = true;
    }
    if (c === '/' && nextPreview() === '*') {
      // skip block comment
      while (c != '') {
        if (c === '*' && nextPreview() === '/') {
          // end of block comment found. skip these last two characters
          next();
          next();
          break;
        } else {
          next();
        }
      }
      isComment = true;
    }

    // skip over whitespaces
    while (c === ' ' || c === '\t' || c === '\n' || c === '\r') {
      // space, tab, enter
      next();
    }
  } while (isComment);

  // check for end of dot file
  if (c === '') {
    // token is still empty
    tokenType = TOKENTYPE.DELIMITER;
    return;
  }

  // check for delimiters consisting of 2 characters
  var c2 = c + nextPreview();
  if (DELIMITERS[c2]) {
    tokenType = TOKENTYPE.DELIMITER;
    token = c2;
    next();
    next();
    return;
  }

  // check for delimiters consisting of 1 character
  if (DELIMITERS[c]) {
    tokenType = TOKENTYPE.DELIMITER;
    token = c;
    next();
    return;
  }

  // check for an identifier (number or string)
  // TODO: more precise parsing of numbers/strings (and the port separator ':')
  if (isAlphaNumeric(c) || c === '-') {
    token += c;
    next();

    while (isAlphaNumeric(c)) {
      token += c;
      next();
    }
    if (token === 'false') {
      token = false; // convert to boolean
    } else if (token === 'true') {
      token = true; // convert to boolean
    } else if (!isNaN(Number(token))) {
      token = Number(token); // convert to number
    }
    tokenType = TOKENTYPE.IDENTIFIER;
    return;
  }

  // check for a string enclosed by double quotes
  if (c === '"') {
    next();
    while (c != '' && (c != '"' || c === '"' && nextPreview() === '"')) {
      if (c === '"') {
        // skip the escape character
        token += c;
        next();
      } else if (c === '\\' && nextPreview() === 'n') {
        // Honor a newline escape sequence
        token += '\n';
        next();
      } else {
        token += c;
      }
      next();
    }
    if (c != '"') {
      throw newSyntaxError('End of string " expected');
    }
    next();
    tokenType = TOKENTYPE.IDENTIFIER;
    return;
  }

  // something unknown is found, wrong characters, a syntax error
  tokenType = TOKENTYPE.UNKNOWN;
  while (c != '') {
    token += c;
    next();
  }
  throw new SyntaxError('Syntax error in part "' + chop(token, 30) + '"');
}

/**
 * Parse a graph.
 * @returns {Object} graph
 */
function parseGraph() {
  var graph = {};

  first();
  getToken();

  // optional strict keyword
  if (token === 'strict') {
    graph.strict = true;
    getToken();
  }

  // graph or digraph keyword
  if (token === 'graph' || token === 'digraph') {
    graph.type = token;
    getToken();
  }

  // optional graph id
  if (tokenType === TOKENTYPE.IDENTIFIER) {
    graph.id = token;
    getToken();
  }

  // open angle bracket
  if (token != '{') {
    throw newSyntaxError('Angle bracket { expected');
  }
  getToken();

  // statements
  parseStatements(graph);

  // close angle bracket
  if (token != '}') {
    throw newSyntaxError('Angle bracket } expected');
  }
  getToken();

  // end of file
  if (token !== '') {
    throw newSyntaxError('End of file expected');
  }
  getToken();

  // remove temporary default options
  delete graph.node;
  delete graph.edge;
  delete graph.graph;

  return graph;
}

/**
 * Parse a list with statements.
 * @param {Object} graph
 */
function parseStatements(graph) {
  while (token !== '' && token != '}') {
    parseStatement(graph);
    if (token === ';') {
      getToken();
    }
  }
}

/**
 * Parse a single statement. Can be a an attribute statement, node
 * statement, a series of node statements and edge statements, or a
 * parameter.
 * @param {Object} graph
 */
function parseStatement(graph) {
  // parse subgraph
  var subgraph = parseSubgraph(graph);
  if (subgraph) {
    // edge statements
    parseEdge(graph, subgraph);

    return;
  }

  // parse an attribute statement
  var attr = parseAttributeStatement(graph);
  if (attr) {
    return;
  }

  // parse node
  if (tokenType != TOKENTYPE.IDENTIFIER) {
    throw newSyntaxError('Identifier expected');
  }
  var id = token; // id can be a string or a number
  getToken();

  if (token === '=') {
    // id statement
    getToken();
    if (tokenType != TOKENTYPE.IDENTIFIER) {
      throw newSyntaxError('Identifier expected');
    }
    graph[id] = token;
    getToken();
    // TODO: implement comma separated list with "a_list: ID=ID [','] [a_list] "
  } else {
    parseNodeStatement(graph, id);
  }
}

/**
 * Parse a subgraph
 * @param {Object} graph    parent graph object
 * @return {Object | null} subgraph
 */
function parseSubgraph(graph) {
  var subgraph = null;

  // optional subgraph keyword
  if (token === 'subgraph') {
    subgraph = {};
    subgraph.type = 'subgraph';
    getToken();

    // optional graph id
    if (tokenType === TOKENTYPE.IDENTIFIER) {
      subgraph.id = token;
      getToken();
    }
  }

  // open angle bracket
  if (token === '{') {
    getToken();

    if (!subgraph) {
      subgraph = {};
    }
    subgraph.parent = graph;
    subgraph.node = graph.node;
    subgraph.edge = graph.edge;
    subgraph.graph = graph.graph;

    // statements
    parseStatements(subgraph);

    // close angle bracket
    if (token != '}') {
      throw newSyntaxError('Angle bracket } expected');
    }
    getToken();

    // remove temporary default options
    delete subgraph.node;
    delete subgraph.edge;
    delete subgraph.graph;
    delete subgraph.parent;

    // register at the parent graph
    if (!graph.subgraphs) {
      graph.subgraphs = [];
    }
    graph.subgraphs.push(subgraph);
  }

  return subgraph;
}

/**
 * parse an attribute statement like "node [shape=circle fontSize=16]".
 * Available keywords are 'node', 'edge', 'graph'.
 * The previous list with default attributes will be replaced
 * @param {Object} graph
 * @returns {String | null} keyword Returns the name of the parsed attribute
 *                                  (node, edge, graph), or null if nothing
 *                                  is parsed.
 */
function parseAttributeStatement(graph) {
  // attribute statements
  if (token === 'node') {
    getToken();

    // node attributes
    graph.node = parseAttributeList();
    return 'node';
  } else if (token === 'edge') {
    getToken();

    // edge attributes
    graph.edge = parseAttributeList();
    return 'edge';
  } else if (token === 'graph') {
    getToken();

    // graph attributes
    graph.graph = parseAttributeList();
    return 'graph';
  }

  return null;
}

/**
 * parse a node statement
 * @param {Object} graph
 * @param {string | number} id
 */
function parseNodeStatement(graph, id) {
  // node statement
  var node = {
    id: id
  };
  var attr = parseAttributeList();
  if (attr) {
    node.attr = attr;
  }
  addNode(graph, node);

  // edge statements
  parseEdge(graph, id);
}

/**
 * Parse an edge or a series of edges
 * @param {Object} graph
 * @param {string | number} from        Id of the from node
 */
function parseEdge(graph, from) {
  while (token === '->' || token === '--') {
    var to;
    var type = token;
    getToken();

    var subgraph = parseSubgraph(graph);
    if (subgraph) {
      to = subgraph;
    } else {
      if (tokenType != TOKENTYPE.IDENTIFIER) {
        throw newSyntaxError('Identifier or subgraph expected');
      }
      to = token;
      addNode(graph, {
        id: to
      });
      getToken();
    }

    // parse edge attributes
    var attr = parseAttributeList();

    // create edge
    var edge = createEdge(graph, from, to, type, attr);
    addEdge(graph, edge);

    from = to;
  }
}

/**
 * Parse a set with attributes,
 * for example [label="1.000", shape=solid]
 * @return {Object | null} attr
 */
function parseAttributeList() {
  var attr = null;

  // edge styles of dot and vis
  var edgeStyles = {
    'dashed': true,
    'solid': false,
    'dotted': [1, 5]
  };

  while (token === '[') {
    getToken();
    attr = {};
    while (token !== '' && token != ']') {
      if (tokenType != TOKENTYPE.IDENTIFIER) {
        throw newSyntaxError('Attribute name expected');
      }
      var name = token;

      getToken();
      if (token != '=') {
        throw newSyntaxError('Equal sign = expected');
      }
      getToken();

      if (tokenType != TOKENTYPE.IDENTIFIER) {
        throw newSyntaxError('Attribute value expected');
      }
      var value = token;

      // convert from dot style to vis
      if (name === 'style') {
        value = edgeStyles[value];
      }

      setValue(attr, name, value); // name can be a path

      getToken();
      if (token == ',') {
        getToken();
      }
    }

    if (token != ']') {
      throw newSyntaxError('Bracket ] expected');
    }
    getToken();
  }

  return attr;
}

/**
 * Create a syntax error with extra information on current token and index.
 * @param {string} message
 * @returns {SyntaxError} err
 */
function newSyntaxError(message) {
  return new SyntaxError(message + ', got "' + chop(token, 30) + '" (char ' + index + ')');
}

/**
 * Chop off text after a maximum length
 * @param {string} text
 * @param {number} maxLength
 * @returns {String}
 */
function chop(text, maxLength) {
  return text.length <= maxLength ? text : text.substr(0, 27) + '...';
}

/**
 * Execute a function fn for each pair of elements in two arrays
 * @param {Array | *} array1
 * @param {Array | *} array2
 * @param {function} fn
 */
function forEach2(array1, array2, fn) {
  if (Array.isArray(array1)) {
    array1.forEach(function (elem1) {
      if (Array.isArray(array2)) {
        array2.forEach(function (elem2) {
          fn(elem1, elem2);
        });
      } else {
        fn(elem1, array2);
      }
    });
  } else {
    if (Array.isArray(array2)) {
      array2.forEach(function (elem2) {
        fn(array1, elem2);
      });
    } else {
      fn(array1, array2);
    }
  }
}

/**
 * Set a nested property on an object
 * When nested objects are missing, they will be created.
 * For example setProp({}, 'font.color', 'red') will return {font: {color: 'red'}}
 * @param {Object} object
 * @param {string} path   A dot separated string like 'font.color'
 * @param {*} value       Value for the property
 * @return {Object} Returns the original object, allows for chaining.
 */
function setProp(object, path, value) {
  var names = path.split('.');
  var prop = names.pop();

  // traverse over the nested objects
  var obj = object;
  for (var i = 0; i < names.length; i++) {
    var name = names[i];
    if (!(name in obj)) {
      obj[name] = {};
    }
    obj = obj[name];
  }

  // set the property value
  obj[prop] = value;

  return object;
}

/**
 * Convert an object with DOT attributes to their vis.js equivalents.
 * @param {Object} attr     Object with DOT attributes
 * @param {Object} mapping
 * @return {Object}         Returns an object with vis.js attributes
 */
function convertAttr(attr, mapping) {
  var converted = {};

  for (var prop in attr) {
    if (attr.hasOwnProperty(prop)) {
      var visProp = mapping[prop];
      if (Array.isArray(visProp)) {
        visProp.forEach(function (visPropI) {
          setProp(converted, visPropI, attr[prop]);
        });
      } else if (typeof visProp === 'string') {
        setProp(converted, visProp, attr[prop]);
      } else {
        setProp(converted, prop, attr[prop]);
      }
    }
  }

  return converted;
}

/**
 * Convert a string containing a graph in DOT language into a map containing
 * with nodes and edges in the format of graph.
 * @param {string} data         Text containing a graph in DOT-notation
 * @return {Object} graphData
 */
function DOTToGraph(data) {
  // parse the DOT file
  var dotData = parseDOT(data);
  var graphData = {
    nodes: [],
    edges: [],
    options: {}
  };

  // copy the nodes
  if (dotData.nodes) {
    dotData.nodes.forEach(function (dotNode) {
      var graphNode = {
        id: dotNode.id,
        label: String(dotNode.label || dotNode.id)
      };
      merge(graphNode, convertAttr(dotNode.attr, NODE_ATTR_MAPPING));
      if (graphNode.image) {
        graphNode.shape = 'image';
      }
      graphData.nodes.push(graphNode);
    });
  }

  // copy the edges
  if (dotData.edges) {
    /**
     * Convert an edge in DOT format to an edge with VisGraph format
     * @param {Object} dotEdge
     * @returns {Object} graphEdge
     */
    var convertEdge = function convertEdge(dotEdge) {
      var graphEdge = {
        from: dotEdge.from,
        to: dotEdge.to
      };
      merge(graphEdge, convertAttr(dotEdge.attr, EDGE_ATTR_MAPPING));
      graphEdge.arrows = dotEdge.type === '->' ? 'to' : undefined;

      return graphEdge;
    };

    dotData.edges.forEach(function (dotEdge) {
      var from, to;
      if (dotEdge.from instanceof Object) {
        from = dotEdge.from.nodes;
      } else {
        from = {
          id: dotEdge.from
        };
      }

      // TODO: support for attributes 'dir' and 'arrowhead' (edge arrows)

      if (dotEdge.to instanceof Object) {
        to = dotEdge.to.nodes;
      } else {
        to = {
          id: dotEdge.to
        };
      }

      if (dotEdge.from instanceof Object && dotEdge.from.edges) {
        dotEdge.from.edges.forEach(function (subEdge) {
          var graphEdge = convertEdge(subEdge);
          graphData.edges.push(graphEdge);
        });
      }

      forEach2(from, to, function (from, to) {
        var subEdge = createEdge(graphData, from.id, to.id, dotEdge.type, dotEdge.attr);
        var graphEdge = convertEdge(subEdge);
        graphData.edges.push(graphEdge);
      });

      if (dotEdge.to instanceof Object && dotEdge.to.edges) {
        dotEdge.to.edges.forEach(function (subEdge) {
          var graphEdge = convertEdge(subEdge);
          graphData.edges.push(graphEdge);
        });
      }
    });
  }

  // copy the options
  if (dotData.attr) {
    graphData.options = dotData.attr;
  }

  return graphData;
}

// exports
exports.parseDOT = parseDOT;
exports.DOTToGraph = DOTToGraph;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *
 * @param {json} gephiJSON
 * @param {obj} optionsObj
 * @returns {{nodes: Array, edges: Array}}
 */
function parseGephi(gephiJSON, optionsObj) {
  var edges = [];
  var nodes = [];
  var options = {
    edges: {
      inheritColor: false
    },
    nodes: {
      fixed: false,
      parseColor: false
    }
  };

  if (optionsObj !== undefined) {
    if (optionsObj.fixed !== undefined) {
      options.nodes.fixed = optionsObj.fixed;
    }
    if (optionsObj.parseColor !== undefined) {
      options.nodes.parseColor = optionsObj.parseColor;
    }
    if (optionsObj.inheritColor !== undefined) {
      options.edges.inheritColor = optionsObj.inheritColor;
    }
  }

  var gEdges = gephiJSON.edges;
  var gNodes = gephiJSON.nodes;
  for (var i = 0; i < gEdges.length; i++) {
    var edge = {};
    var gEdge = gEdges[i];
    edge['id'] = gEdge.id;
    edge['from'] = gEdge.source;
    edge['to'] = gEdge.target;
    edge['attributes'] = gEdge.attributes;
    edge['label'] = gEdge.label;
    edge['title'] = gEdge.attributes !== undefined ? gEdge.attributes.title : undefined;
    if (gEdge['type'] === 'Directed') {
      edge['arrows'] = 'to';
    }
    //    edge['value'] = gEdge.attributes !== undefined ? gEdge.attributes.Weight : undefined;
    //    edge['width'] = edge['value'] !== undefined ? undefined : edgegEdge.size;
    if (gEdge.color && options.inheritColor === false) {
      edge['color'] = gEdge.color;
    }
    edges.push(edge);
  }

  for (var j = 0; j < gNodes.length; j++) {
    var node = {};
    var gNode = gNodes[j];
    node['id'] = gNode.id;
    node['attributes'] = gNode.attributes;
    node['x'] = gNode.x;
    node['y'] = gNode.y;
    node['label'] = gNode.label;
    node['title'] = gNode.attributes !== undefined ? gNode.attributes.title : gNode.title;
    if (options.nodes.parseColor === true) {
      node['color'] = gNode.color;
    } else {
      node['color'] = gNode.color !== undefined ? { background: gNode.color, border: gNode.color, highlight: { background: gNode.color, border: gNode.color }, hover: { background: gNode.color, border: gNode.color } } : undefined;
    }
    node['size'] = gNode.size;
    node['fixed'] = options.nodes.fixed && gNode.x !== undefined && gNode.y !== undefined;
    nodes.push(node);
  }

  return { nodes: nodes, edges: edges };
}

exports.parseGephi = parseGephi;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _CachedImage = __webpack_require__(185);

var _CachedImage2 = _interopRequireDefault(_CachedImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * This callback is a callback that accepts an Image.
 * @callback ImageCallback
 * @param {Image} image
 */

/**
 * This class loads images and keeps them stored.
 *
 * @param {ImageCallback} callback
 */
var Images = function () {
    /**
     * @param {ImageCallback} callback
     */
    function Images(callback) {
        (0, _classCallCheck3["default"])(this, Images);

        this.images = {};
        this.imageBroken = {};
        this.callback = callback;
    }

    /**
     * @param {string} url                      The original Url that failed to load, if the broken image is successfully loaded it will be added to the cache using this Url as the key so that subsequent requests for this Url will return the broken image
     * @param {string} brokenUrl                Url the broken image to try and load
     * @param {Image} imageToLoadBrokenUrlOn   The image object
     */


    (0, _createClass3["default"])(Images, [{
        key: "_tryloadBrokenUrl",
        value: function _tryloadBrokenUrl(url, brokenUrl, imageToLoadBrokenUrlOn) {
            //If these parameters aren't specified then exit the function because nothing constructive can be done
            if (url === undefined || imageToLoadBrokenUrlOn === undefined) return;
            if (brokenUrl === undefined) {
                console.warn("No broken url image defined");
                return;
            }

            //Clear the old subscription to the error event and put a new in place that only handle errors in loading the brokenImageUrl
            imageToLoadBrokenUrlOn.onerror = function () {
                console.error("Could not load brokenImage:", brokenUrl);
                // cache item will contain empty image, this should be OK for default
            };

            //Set the source of the image to the brokenUrl, this is actually what kicks off the loading of the broken image
            imageToLoadBrokenUrlOn.image.src = brokenUrl;
        }

        /**
         *
         * @param {vis.Image} imageToRedrawWith
         * @private
         */

    }, {
        key: "_redrawWithImage",
        value: function _redrawWithImage(imageToRedrawWith) {
            if (this.callback) {
                this.callback(imageToRedrawWith);
            }
        }

        /**
         * @param {string} url          Url of the image
         * @param {string} brokenUrl    Url of an image to use if the url image is not found
         * @return {Image} img          The image object
         */

    }, {
        key: "load",
        value: function load(url, brokenUrl) {
            var _this = this;

            //Try and get the image from the cache, if successful then return the cached image   
            var cachedImage = this.images[url];
            if (cachedImage) return cachedImage;

            //Create a new image
            var img = new _CachedImage2["default"]();

            // Need to add to cache here, otherwise final return will spawn different copies of the same image,
            // Also, there will be multiple loads of the same image.
            this.images[url] = img;

            //Subscribe to the event that is raised if the image loads successfully 
            img.image.onload = function () {
                // Properly init the cached item and then request a redraw
                _this._fixImageCoordinates(img.image);
                img.init();
                _this._redrawWithImage(img);
            };

            //Subscribe to the event that is raised if the image fails to load
            img.image.onerror = function () {
                console.error("Could not load image:", url);
                //Try and load the image specified by the brokenUrl using
                _this._tryloadBrokenUrl(url, brokenUrl, img);
            };

            //Set the source of the image to the url, this is what actually kicks off the loading of the image
            img.image.src = url;

            //Return the new image
            return img;
        }

        /**
         * IE11 fix -- thanks dponch!
         *
         * Local helper function
         * @param {vis.Image} imageToCache
         * @private
         */

    }, {
        key: "_fixImageCoordinates",
        value: function _fixImageCoordinates(imageToCache) {
            if (imageToCache.width === 0) {
                document.body.appendChild(imageToCache);
                imageToCache.width = imageToCache.offsetWidth;
                imageToCache.height = imageToCache.offsetHeight;
                document.body.removeChild(imageToCache);
            }
        }
    }]);
    return Images;
}();

exports["default"] = Images;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var ComponentUtil = __webpack_require__(48)['default'];
var LabelSplitter = __webpack_require__(191)['default'];

/**
 * @typedef {'bold'|'ital'|'boldital'|'mono'|'normal'} MultiFontStyle
 *
 * The allowed specifiers of multi-fonts.
 */

/**
 * @typedef {{color:string, size:number, face:string, mod:string, vadjust:number}} MultiFontOptions
 *
 * The full set of options of a given multi-font.
 */

/**
 * @typedef {Array.<object>} Pile
 *
 * Sequence of option objects, the order is significant.
 * The sequence is used to determine the value of a given option.
 *
 * Usage principles:
 *
 *  - All search is done in the sequence of the pile.
 *  - As soon as a value is found, the searching stops.
 *  - prototypes are totally ignored. The idea is to add option objects used as prototypes
 *    to the pile, in the correct order.
 */

/**
 * List of special styles for multi-fonts
 * @private
 */
var multiFontStyle = ['bold', 'ital', 'boldital', 'mono'];

/**
 * A Label to be used for Nodes or Edges.
 */

var Label = function () {

  /**
   * @param {Object} body
   * @param {Object} options
   * @param {boolean} [edgelabel=false]
   */
  function Label(body, options) {
    var edgelabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    (0, _classCallCheck3['default'])(this, Label);

    this.body = body;
    this.pointToSelf = false;
    this.baseSize = undefined;
    this.fontOptions = {}; // instance variable containing the *instance-local* font options
    this.setOptions(options);
    this.size = { top: 0, left: 0, width: 0, height: 0, yLine: 0 };
    this.isEdgeLabel = edgelabel;
  }

  /**
   * @param {Object} options the options of the parent Node-instance
   */


  (0, _createClass3['default'])(Label, [{
    key: 'setOptions',
    value: function setOptions(options) {
      this.elementOptions = options; // Reference to the options of the parent Node-instance 

      this.initFontOptions(options.font);

      if (ComponentUtil.isValidLabel(options.label)) {
        this.labelDirty = true;
      } else {
        // Bad label! Change the option value to prevent bad stuff happening
        options.label = '';
      }

      if (options.font !== undefined && options.font !== null) {
        // font options can be deleted at various levels
        if (typeof options.font === 'string') {
          this.baseSize = this.fontOptions.size;
        } else if ((0, _typeof3['default'])(options.font) === 'object') {
          var size = options.font.size;

          if (size !== undefined) {
            this.baseSize = size;
          }
        }
      }
    }

    /**
     * Init the font Options structure.
     *
     * Member fontOptions serves as an accumulator for the current font options.
     * As such, it needs to be completely separated from the node options.
     *
     * @param {Object} newFontOptions the new font options to process
     * @private
     */

  }, {
    key: 'initFontOptions',
    value: function initFontOptions(newFontOptions) {
      var _this = this;

      // Prepare the multi-font option objects.
      // These will be filled in propagateFonts(), if required
      util.forEach(multiFontStyle, function (style) {
        _this.fontOptions[style] = {};
      });

      // Handle shorthand option, if present
      if (Label.parseFontString(this.fontOptions, newFontOptions)) {
        this.fontOptions.vadjust = 0;
        return;
      }

      // Copy over the non-multifont options, if specified
      util.forEach(newFontOptions, function (prop, n) {
        if (prop !== undefined && prop !== null && (typeof prop === 'undefined' ? 'undefined' : (0, _typeof3['default'])(prop)) !== 'object') {
          _this.fontOptions[n] = prop;
        }
      });
    }

    /**
     * If in-variable is a string, parse it as a font specifier.
     *
     * Note that following is not done here and have to be done after the call:
     * - No number conversion (size)
     * - Not all font options are set (vadjust, mod)
     *
     * @param {Object} outOptions  out-parameter, object in which to store the parse results (if any)
     * @param {Object} inOptions  font options to parse
     * @return {boolean} true if font parsed as string, false otherwise
     * @static
     */

  }, {
    key: 'constrain',


    /**
     * Set the width and height constraints based on 'nearest' value
     *
     * @param {Array} pile array of option objects to consider
     * @returns {object} the actual constraint values to use
     * @private
     */
    value: function constrain(pile) {
      // NOTE: constrainWidth and  constrainHeight never set!
      // NOTE: for edge labels, only 'maxWdt' set
      // Node labels can set all the fields
      var fontOptions = {
        constrainWidth: false,
        maxWdt: -1,
        minWdt: -1,
        constrainHeight: false,
        minHgt: -1,
        valign: 'middle'
      };

      var widthConstraint = util.topMost(pile, 'widthConstraint');
      if (typeof widthConstraint === 'number') {
        fontOptions.maxWdt = Number(widthConstraint);
        fontOptions.minWdt = Number(widthConstraint);
      } else if ((typeof widthConstraint === 'undefined' ? 'undefined' : (0, _typeof3['default'])(widthConstraint)) === 'object') {
        var widthConstraintMaximum = util.topMost(pile, ['widthConstraint', 'maximum']);
        if (typeof widthConstraintMaximum === 'number') {
          fontOptions.maxWdt = Number(widthConstraintMaximum);
        }
        var widthConstraintMinimum = util.topMost(pile, ['widthConstraint', 'minimum']);
        if (typeof widthConstraintMinimum === 'number') {
          fontOptions.minWdt = Number(widthConstraintMinimum);
        }
      }

      var heightConstraint = util.topMost(pile, 'heightConstraint');
      if (typeof heightConstraint === 'number') {
        fontOptions.minHgt = Number(heightConstraint);
      } else if ((typeof heightConstraint === 'undefined' ? 'undefined' : (0, _typeof3['default'])(heightConstraint)) === 'object') {
        var heightConstraintMinimum = util.topMost(pile, ['heightConstraint', 'minimum']);
        if (typeof heightConstraintMinimum === 'number') {
          fontOptions.minHgt = Number(heightConstraintMinimum);
        }
        var heightConstraintValign = util.topMost(pile, ['heightConstraint', 'valign']);
        if (typeof heightConstraintValign === 'string') {
          if (heightConstraintValign === 'top' || heightConstraintValign === 'bottom') {
            fontOptions.valign = heightConstraintValign;
          }
        }
      }

      return fontOptions;
    }

    /**
     * Set options and update internal state
     *
     * @param {Object} options  options to set
     * @param {Array}  pile     array of option objects to consider for option 'chosen'
     */

  }, {
    key: 'update',
    value: function update(options, pile) {
      this.setOptions(options, true);
      this.propagateFonts(pile);
      util.deepExtend(this.fontOptions, this.constrain(pile));
      this.fontOptions.chooser = ComponentUtil.choosify('label', pile);
    }

    /**
     * When margins are set in an element, adjust sizes is called to remove them
     * from the width/height constraints. This must be done prior to label sizing.
     *
     * @param {{top: number, right: number, bottom: number, left: number}} margins
     */

  }, {
    key: 'adjustSizes',
    value: function adjustSizes(margins) {
      var widthBias = margins ? margins.right + margins.left : 0;
      if (this.fontOptions.constrainWidth) {
        this.fontOptions.maxWdt -= widthBias;
        this.fontOptions.minWdt -= widthBias;
      }
      var heightBias = margins ? margins.top + margins.bottom : 0;
      if (this.fontOptions.constrainHeight) {
        this.fontOptions.minHgt -= heightBias;
      }
    }

    /////////////////////////////////////////////////////////
    // Methods for handling options piles
    // Eventually, these will be moved to a separate class
    /////////////////////////////////////////////////////////

    /**
     * Add the font members of the passed list of option objects to the pile.
     *
     * @param {Pile} dstPile  pile of option objects add to 
     * @param {Pile} srcPile  pile of option objects to take font options from
     * @private
     */

  }, {
    key: 'addFontOptionsToPile',
    value: function addFontOptionsToPile(dstPile, srcPile) {
      for (var i = 0; i < srcPile.length; ++i) {
        this.addFontToPile(dstPile, srcPile[i]);
      }
    }

    /**
     * Add given font option object to the list of objects (the 'pile') to consider for determining
     * multi-font option values.
     *
     * @param {Pile} pile  pile of option objects to use
     * @param {object} options  instance to add to pile
     * @private
     */

  }, {
    key: 'addFontToPile',
    value: function addFontToPile(pile, options) {
      if (options === undefined) return;
      if (options.font === undefined || options.font === null) return;

      var item = options.font;
      pile.push(item);
    }

    /**
     * Collect all own-property values from the font pile that aren't multi-font option objectss.
     *
     * @param {Pile} pile  pile of option objects to use
     * @returns {object} object with all current own basic font properties
     * @private
     */

  }, {
    key: 'getBasicOptions',
    value: function getBasicOptions(pile) {
      var ret = {};

      // Scans the whole pile to get all options present
      for (var n = 0; n < pile.length; ++n) {
        var fontOptions = pile[n];

        // Convert shorthand if necessary
        var tmpShorthand = {};
        if (Label.parseFontString(tmpShorthand, fontOptions)) {
          fontOptions = tmpShorthand;
        }

        util.forEach(fontOptions, function (opt, name) {
          if (opt === undefined) return; // multi-font option need not be present 
          if (ret.hasOwnProperty(name)) return; // Keep first value we encounter

          if (multiFontStyle.indexOf(name) !== -1) {
            // Skip multi-font properties but we do need the structure
            ret[name] = {};
          } else {
            ret[name] = opt;
          }
        });
      }

      return ret;
    }

    /**
     * Return the value for given option for the given multi-font.
     *
     * All available option objects are trawled in the set order to construct the option values.
     *
     * ---------------------------------------------------------------------
     * ## Traversal of pile for multi-fonts
     *
     * The determination of multi-font option values is a special case, because any values not
     * present in the multi-font options should by definition be taken from the main font options,
     * i.e. from the current 'parent' object of the multi-font option.
     *
     * ### Search order for multi-fonts
     *
     * 'bold' used as example:
     *
     *   - search in option group 'bold' in local properties
     *   - search in main font option group in local properties
     *
     * ---------------------------------------------------------------------
     *
     * @param {Pile} pile  pile of option objects to use
     * @param {MultiFontStyle} multiName sub path for the multi-font
     * @param {string} option  the option to search for, for the given multi-font
     * @returns {string|number} the value for the given option
     * @private
     */

  }, {
    key: 'getFontOption',
    value: function getFontOption(pile, multiName, option) {
      var multiFont = void 0;

      // Search multi font in local properties
      for (var n = 0; n < pile.length; ++n) {
        var fontOptions = pile[n];

        if (fontOptions.hasOwnProperty(multiName)) {
          multiFont = fontOptions[multiName];
          if (multiFont === undefined || multiFont === null) continue;

          // Convert shorthand if necessary
          // TODO: inefficient to do this conversion every time; find a better way.
          var tmpShorthand = {};
          if (Label.parseFontString(tmpShorthand, multiFont)) {
            multiFont = tmpShorthand;
          }

          if (multiFont.hasOwnProperty(option)) {
            return multiFont[option];
          }
        }
      }

      // Option is not mentioned in the multi font options; take it from the parent font options.
      // These have already been converted with getBasicOptions(), so use the converted values.
      if (this.fontOptions.hasOwnProperty(option)) {
        return this.fontOptions[option];
      }

      // A value **must** be found; you should never get here.
      throw new Error("Did not find value for multi-font for property: '" + option + "'");
    }

    /**
     * Return all options values for the given multi-font.
     *
     * All available option objects are trawled in the set order to construct the option values.
     *
     * @param {Pile} pile  pile of option objects to use
     * @param {MultiFontStyle} multiName sub path for the mod-font
     * @returns {MultiFontOptions}
     * @private
     */

  }, {
    key: 'getFontOptions',
    value: function getFontOptions(pile, multiName) {
      var result = {};
      var optionNames = ['color', 'size', 'face', 'mod', 'vadjust']; // List of allowed options per multi-font

      for (var i = 0; i < optionNames.length; ++i) {
        var mod = optionNames[i];
        result[mod] = this.getFontOption(pile, multiName, mod);
      }

      return result;
    }

    /////////////////////////////////////////////////////////
    // End methods for handling options piles
    /////////////////////////////////////////////////////////


    /**
     * Collapse the font options for the multi-font to single objects, from
     * the chain of option objects passed (the 'pile').
     *
     * @param {Pile} pile  sequence of option objects to consider.
     *                     First item in list assumed to be the newly set options.
     */

  }, {
    key: 'propagateFonts',
    value: function propagateFonts(pile) {
      var _this2 = this;

      var fontPile = []; // sequence of font objects to consider, order important

      // Note that this.elementOptions is not used here.
      this.addFontOptionsToPile(fontPile, pile);
      this.fontOptions = this.getBasicOptions(fontPile);

      // We set multifont values even if multi === false, for consistency (things break otherwise)

      var _loop = function _loop(i) {
        var mod = multiFontStyle[i];
        var modOptions = _this2.fontOptions[mod];
        var tmpMultiFontOptions = _this2.getFontOptions(fontPile, mod);

        // Copy over found values
        util.forEach(tmpMultiFontOptions, function (option, n) {
          modOptions[n] = option;
        });

        modOptions.size = Number(modOptions.size);
        modOptions.vadjust = Number(modOptions.vadjust);
      };

      for (var i = 0; i < multiFontStyle.length; ++i) {
        _loop(i);
      }
    }

    /**
     * Main function. This is called from anything that wants to draw a label.
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x
     * @param {number} y
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {string} [baseline='middle']
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover) {
      var baseline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'middle';

      // if no label, return
      if (this.elementOptions.label === undefined) return;

      // check if we have to render the label
      var viewFontSize = this.fontOptions.size * this.body.view.scale;
      if (this.elementOptions.label && viewFontSize < this.elementOptions.scaling.label.drawThreshold - 1) return;

      // This ensures that there will not be HUGE letters on screen
      // by setting an upper limit on the visible text size (regardless of zoomLevel)
      if (viewFontSize >= this.elementOptions.scaling.label.maxVisible) {
        viewFontSize = Number(this.elementOptions.scaling.label.maxVisible) / this.body.view.scale;
      }

      // update the size cache if required
      this.calculateLabelSize(ctx, selected, hover, x, y, baseline);
      this._drawBackground(ctx);
      this._drawText(ctx, x, this.size.yLine, baseline, viewFontSize);
    }

    /**
     * Draws the label background
     * @param {CanvasRenderingContext2D} ctx
     * @private
     */

  }, {
    key: '_drawBackground',
    value: function _drawBackground(ctx) {
      if (this.fontOptions.background !== undefined && this.fontOptions.background !== "none") {
        ctx.fillStyle = this.fontOptions.background;
        var size = this.getSize();
        ctx.fillRect(size.left, size.top, size.width, size.height);
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x
     * @param {number} y
     * @param {string} [baseline='middle']
     * @param {number} viewFontSize 
     * @private
     */

  }, {
    key: '_drawText',
    value: function _drawText(ctx, x, y) {
      var baseline = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'middle';
      var viewFontSize = arguments[4];

      var _setAlignment2 = this._setAlignment(ctx, x, y, baseline);

      var _setAlignment3 = (0, _slicedToArray3['default'])(_setAlignment2, 2);

      x = _setAlignment3[0];
      y = _setAlignment3[1];


      ctx.textAlign = 'left';
      x = x - this.size.width / 2; // Shift label 1/2-distance to the left
      if (this.fontOptions.valign && this.size.height > this.size.labelHeight) {
        if (this.fontOptions.valign === 'top') {
          y -= (this.size.height - this.size.labelHeight) / 2;
        }
        if (this.fontOptions.valign === 'bottom') {
          y += (this.size.height - this.size.labelHeight) / 2;
        }
      }

      // draw the text
      for (var i = 0; i < this.lineCount; i++) {
        var line = this.lines[i];
        if (line && line.blocks) {
          var width = 0;
          if (this.isEdgeLabel || this.fontOptions.align === 'center') {
            width += (this.size.width - line.width) / 2;
          } else if (this.fontOptions.align === 'right') {
            width += this.size.width - line.width;
          }
          for (var j = 0; j < line.blocks.length; j++) {
            var block = line.blocks[j];
            ctx.font = block.font;

            var _getColor2 = this._getColor(block.color, viewFontSize, block.strokeColor),
                _getColor3 = (0, _slicedToArray3['default'])(_getColor2, 2),
                fontColor = _getColor3[0],
                strokeColor = _getColor3[1];

            if (block.strokeWidth > 0) {
              ctx.lineWidth = block.strokeWidth;
              ctx.strokeStyle = strokeColor;
              ctx.lineJoin = 'round';
            }
            ctx.fillStyle = fontColor;

            if (block.strokeWidth > 0) {
              ctx.strokeText(block.text, x + width, y + block.vadjust);
            }
            ctx.fillText(block.text, x + width, y + block.vadjust);
            width += block.width;
          }
          y += line.height;
        }
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x
     * @param {number} y
     * @param {string} baseline
     * @returns {Array.<number>}
     * @private
     */

  }, {
    key: '_setAlignment',
    value: function _setAlignment(ctx, x, y, baseline) {
      // check for label alignment (for edges)
      // TODO: make alignment for nodes
      if (this.isEdgeLabel && this.fontOptions.align !== 'horizontal' && this.pointToSelf === false) {
        x = 0;
        y = 0;

        var lineMargin = 2;
        if (this.fontOptions.align === 'top') {
          ctx.textBaseline = 'alphabetic';
          y -= 2 * lineMargin; // distance from edge, required because we use alphabetic. Alphabetic has less difference between browsers
        } else if (this.fontOptions.align === 'bottom') {
          ctx.textBaseline = 'hanging';
          y += 2 * lineMargin; // distance from edge, required because we use hanging. Hanging has less difference between browsers
        } else {
          ctx.textBaseline = 'middle';
        }
      } else {
        ctx.textBaseline = baseline;
      }
      return [x, y];
    }

    /**
     * fade in when relative scale is between threshold and threshold - 1.
     * If the relative scale would be smaller than threshold -1 the draw function would have returned before coming here.
     *
     * @param {string} color  The font color to use
     * @param {number} viewFontSize
     * @param {string} initialStrokeColor
     * @returns {Array.<string>} An array containing the font color and stroke color
     * @private
     */

  }, {
    key: '_getColor',
    value: function _getColor(color, viewFontSize, initialStrokeColor) {
      var fontColor = color || '#000000';
      var strokeColor = initialStrokeColor || '#ffffff';
      if (viewFontSize <= this.elementOptions.scaling.label.drawThreshold) {
        var opacity = Math.max(0, Math.min(1, 1 - (this.elementOptions.scaling.label.drawThreshold - viewFontSize)));
        fontColor = util.overrideOpacity(fontColor, opacity);
        strokeColor = util.overrideOpacity(strokeColor, opacity);
      }
      return [fontColor, strokeColor];
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} selected
     * @param {boolean} hover
     * @returns {{width: number, height: number}}
     */

  }, {
    key: 'getTextSize',
    value: function getTextSize(ctx) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      this._processLabel(ctx, selected, hover);
      return {
        width: this.size.width,
        height: this.size.height,
        lineCount: this.lineCount
      };
    }

    /**
     * Get the current dimensions of the label
     *
     * @return {rect}
     */

  }, {
    key: 'getSize',
    value: function getSize() {
      var lineMargin = 2;
      var x = this.size.left; // default values which might be overridden below
      var y = this.size.top - 0.5 * lineMargin; // idem

      if (this.isEdgeLabel) {
        var x2 = -this.size.width * 0.5;

        switch (this.fontOptions.align) {
          case 'middle':
            x = x2;
            y = -this.size.height * 0.5;
            break;
          case 'top':
            x = x2;
            y = -(this.size.height + lineMargin);
            break;
          case 'bottom':
            x = x2;
            y = lineMargin;
            break;
        }
      }

      var ret = {
        left: x,
        top: y,
        width: this.size.width,
        height: this.size.height
      };

      return ret;
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {number} [x=0]
     * @param {number} [y=0]
     * @param {'middle'|'hanging'} [baseline='middle']
     */

  }, {
    key: 'calculateLabelSize',
    value: function calculateLabelSize(ctx, selected, hover) {
      var x = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var y = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var baseline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'middle';

      this._processLabel(ctx, selected, hover);
      this.size.left = x - this.size.width * 0.5;
      this.size.top = y - this.size.height * 0.5;
      this.size.yLine = y + (1 - this.lineCount) * 0.5 * this.fontOptions.size;
      if (baseline === "hanging") {
        this.size.top += 0.5 * this.fontOptions.size;
        this.size.top += 4; // distance from node, required because we use hanging. Hanging has less difference between browsers
        this.size.yLine += 4; // distance from node
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {string} mod
     * @returns {{color, size, face, mod, vadjust, strokeWidth: *, strokeColor: (*|string|allOptions.edges.font.strokeColor|{string}|allOptions.nodes.font.strokeColor|Array)}}
     */

  }, {
    key: 'getFormattingValues',
    value: function getFormattingValues(ctx, selected, hover, mod) {
      var getValue = function getValue(fontOptions, mod, option) {
        if (mod === "normal") {
          if (option === 'mod') return "";
          return fontOptions[option];
        }

        if (fontOptions[mod][option] !== undefined) {
          // Grumbl leaving out test on undefined equals false for "" 
          return fontOptions[mod][option];
        } else {
          // Take from parent font option
          return fontOptions[option];
        }
      };

      var values = {
        color: getValue(this.fontOptions, mod, 'color'),
        size: getValue(this.fontOptions, mod, 'size'),
        face: getValue(this.fontOptions, mod, 'face'),
        mod: getValue(this.fontOptions, mod, 'mod'),
        vadjust: getValue(this.fontOptions, mod, 'vadjust'),
        strokeWidth: this.fontOptions.strokeWidth,
        strokeColor: this.fontOptions.strokeColor
      };
      if (selected || hover) {
        if (mod === "normal" && this.fontOptions.chooser === true && this.elementOptions.labelHighlightBold) {
          values.mod = 'bold';
        } else {
          if (typeof this.fontOptions.chooser === 'function') {
            this.fontOptions.chooser(values, this.elementOptions.id, selected, hover);
          }
        }
      }

      var fontString = "";
      if (values.mod !== undefined && values.mod !== "") {
        // safeguard for undefined - this happened
        fontString += values.mod + " ";
      }
      fontString += values.size + "px " + values.face;

      ctx.font = fontString.replace(/"/g, "");
      values.font = ctx.font;
      values.height = values.size;
      return values;
    }

    /**
     *
     * @param {boolean} selected
     * @param {boolean} hover
     * @returns {boolean}
     */

  }, {
    key: 'differentState',
    value: function differentState(selected, hover) {
      return selected !== this.selectedState || hover !== this.hoverState;
    }

    /**
     * This explodes the passed text into lines and determines the width, height and number of lines.
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {string} inText  the text to explode
     * @returns {{width, height, lines}|*}
     * @private
     */

  }, {
    key: '_processLabelText',
    value: function _processLabelText(ctx, selected, hover, inText) {
      var splitter = new LabelSplitter(ctx, this, selected, hover);
      return splitter.process(inText);
    }

    /**
     * This explodes the label string into lines and sets the width, height and number of lines.
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} selected
     * @param {boolean} hover
     * @private
     */

  }, {
    key: '_processLabel',
    value: function _processLabel(ctx, selected, hover) {

      if (this.labelDirty === false && !this.differentState(selected, hover)) return;

      var state = this._processLabelText(ctx, selected, hover, this.elementOptions.label);

      if (this.fontOptions.minWdt > 0 && state.width < this.fontOptions.minWdt) {
        state.width = this.fontOptions.minWdt;
      }

      this.size.labelHeight = state.height;
      if (this.fontOptions.minHgt > 0 && state.height < this.fontOptions.minHgt) {
        state.height = this.fontOptions.minHgt;
      }

      this.lines = state.lines;
      this.lineCount = state.lines.length;
      this.size.width = state.width;
      this.size.height = state.height;
      this.selectedState = selected;
      this.hoverState = hover;

      this.labelDirty = false;
    }

    /**
     * Check if this label is visible
     *
     * @return {boolean} true if this label will be show, false otherwise
     */

  }, {
    key: 'visible',
    value: function visible() {
      if (this.size.width === 0 || this.size.height === 0 || this.elementOptions.label === undefined) {
        return false; // nothing to display
      }

      var viewFontSize = this.fontOptions.size * this.body.view.scale;
      if (viewFontSize < this.elementOptions.scaling.label.drawThreshold - 1) {
        return false; // Too small or too far away to show
      }

      return true;
    }
  }], [{
    key: 'parseFontString',
    value: function parseFontString(outOptions, inOptions) {
      if (!inOptions || typeof inOptions !== 'string') return false;

      var newOptionsArray = inOptions.split(" ");

      outOptions.size = newOptionsArray[0].replace("px", '');
      outOptions.face = newOptionsArray[1];
      outOptions.color = newOptionsArray[2];

      return true;
    }
  }]);
  return Label;
}();

exports['default'] = Label;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var util = __webpack_require__(2);
var EndPoints = __webpack_require__(119)["default"];

/**
 * The Base Class for all edges.
 *
 */

var EdgeBase = function () {
  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function EdgeBase(options, body, labelModule) {
    (0, _classCallCheck3["default"])(this, EdgeBase);

    this.body = body;
    this.labelModule = labelModule;
    this.options = {};
    this.setOptions(options);
    this.colorDirty = true;
    this.color = {};
    this.selectionWidth = 2;
    this.hoverWidth = 1.5;
    this.fromPoint = this.from;
    this.toPoint = this.to;
  }

  /**
   * Connects a node to itself
   */


  (0, _createClass3["default"])(EdgeBase, [{
    key: "connect",
    value: function connect() {
      this.from = this.body.nodes[this.options.from];
      this.to = this.body.nodes[this.options.to];
    }

    /**
     *
     * @returns {boolean} always false
     */

  }, {
    key: "cleanup",
    value: function cleanup() {
      return false;
    }

    /**
     *
     * @param {Object} options
     */

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
      this.from = this.body.nodes[this.options.from];
      this.to = this.body.nodes[this.options.to];
      this.id = this.options.id;
    }

    /**
     * Redraw a edge as a line
     * Draw this edge in the given canvas
     * The 2d context of a HTML canvas can be retrieved by canvas.getContext("2d");
     *
     * @param {CanvasRenderingContext2D}   ctx
     * @param {Array} values
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {Node} viaNode
     * @private
     */

  }, {
    key: "drawLine",
    value: function drawLine(ctx, values, selected, hover, viaNode) {
      // set style
      ctx.strokeStyle = this.getColor(ctx, values, selected, hover);
      ctx.lineWidth = values.width;

      if (values.dashes !== false) {
        this._drawDashedLine(ctx, values, viaNode);
      } else {
        this._drawLine(ctx, values, viaNode);
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D}   ctx
     * @param {Array} values
     * @param {Node} viaNode
     * @param {{x: number, y: number}} [fromPoint]
     * @param {{x: number, y: number}} [toPoint]
     * @private
     */

  }, {
    key: "_drawLine",
    value: function _drawLine(ctx, values, viaNode, fromPoint, toPoint) {
      if (this.from != this.to) {
        // draw line
        this._line(ctx, values, viaNode, fromPoint, toPoint);
      } else {
        var _getCircleData2 = this._getCircleData(ctx),
            _getCircleData3 = (0, _slicedToArray3["default"])(_getCircleData2, 3),
            x = _getCircleData3[0],
            y = _getCircleData3[1],
            radius = _getCircleData3[2];

        this._circle(ctx, values, x, y, radius);
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array} values
     * @param {Node} viaNode
     * @param {{x: number, y: number}} [fromPoint]  TODO: Remove in next major release
     * @param {{x: number, y: number}} [toPoint]    TODO: Remove in next major release
     * @private
     */

  }, {
    key: "_drawDashedLine",
    value: function _drawDashedLine(ctx, values, viaNode, fromPoint, toPoint) {
      // eslint-disable-line no-unused-vars
      ctx.lineCap = 'round';
      var pattern = [5, 5];
      if (Array.isArray(values.dashes) === true) {
        pattern = values.dashes;
      }

      // only firefox and chrome support this method, else we use the legacy one.
      if (ctx.setLineDash !== undefined) {
        ctx.save();

        // set dash settings for chrome or firefox
        ctx.setLineDash(pattern);
        ctx.lineDashOffset = 0;

        // draw the line
        if (this.from != this.to) {
          // draw line
          this._line(ctx, values, viaNode);
        } else {
          var _getCircleData4 = this._getCircleData(ctx),
              _getCircleData5 = (0, _slicedToArray3["default"])(_getCircleData4, 3),
              x = _getCircleData5[0],
              y = _getCircleData5[1],
              radius = _getCircleData5[2];

          this._circle(ctx, values, x, y, radius);
        }

        // restore the dash settings.
        ctx.setLineDash([0]);
        ctx.lineDashOffset = 0;
        ctx.restore();
      } else {
        // unsupporting smooth lines
        if (this.from != this.to) {
          // draw line
          ctx.dashedLine(this.from.x, this.from.y, this.to.x, this.to.y, pattern);
        } else {
          var _getCircleData6 = this._getCircleData(ctx),
              _getCircleData7 = (0, _slicedToArray3["default"])(_getCircleData6, 3),
              _x = _getCircleData7[0],
              _y = _getCircleData7[1],
              _radius = _getCircleData7[2];

          this._circle(ctx, values, _x, _y, _radius);
        }
        // draw shadow if enabled
        this.enableShadow(ctx, values);

        ctx.stroke();

        // disable shadows for other elements.
        this.disableShadow(ctx, values);
      }
    }

    /**
     *
     * @param {Node} nearNode
     * @param {CanvasRenderingContext2D} ctx
     * @param {Object} options
     * @returns {{x: number, y: number}}
     */

  }, {
    key: "findBorderPosition",
    value: function findBorderPosition(nearNode, ctx, options) {
      if (this.from != this.to) {
        return this._findBorderPosition(nearNode, ctx, options);
      } else {
        return this._findBorderPositionCircle(nearNode, ctx, options);
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @returns {{from: ({x: number, y: number, t: number}|*), to: ({x: number, y: number, t: number}|*)}}
     */

  }, {
    key: "findBorderPositions",
    value: function findBorderPositions(ctx) {
      var from = {};
      var to = {};
      if (this.from != this.to) {
        from = this._findBorderPosition(this.from, ctx);
        to = this._findBorderPosition(this.to, ctx);
      } else {
        var _getCircleData$slice = this._getCircleData(ctx).slice(0, 2),
            _getCircleData$slice2 = (0, _slicedToArray3["default"])(_getCircleData$slice, 2),
            x = _getCircleData$slice2[0],
            y = _getCircleData$slice2[1];

        from = this._findBorderPositionCircle(this.from, ctx, { x: x, y: y, low: 0.25, high: 0.6, direction: -1 });
        to = this._findBorderPositionCircle(this.from, ctx, { x: x, y: y, low: 0.6, high: 0.8, direction: 1 });
      }
      return { from: from, to: to };
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @returns {Array.<number>} x, y, radius
     * @private
     */

  }, {
    key: "_getCircleData",
    value: function _getCircleData(ctx) {
      var x = void 0,
          y = void 0;
      var node = this.from;
      var radius = this.options.selfReferenceSize;

      if (ctx !== undefined) {
        if (node.shape.width === undefined) {
          node.shape.resize(ctx);
        }
      }

      // get circle coordinates
      if (node.shape.width > node.shape.height) {
        x = node.x + node.shape.width * 0.5;
        y = node.y - radius;
      } else {
        x = node.x + radius;
        y = node.y - node.shape.height * 0.5;
      }
      return [x, y, radius];
    }

    /**
     * Get a point on a circle
     * @param {number} x
     * @param {number} y
     * @param {number} radius
     * @param {number} percentage - Value between 0 (line start) and 1 (line end)
     * @return {Object} point
     * @private
     */

  }, {
    key: "_pointOnCircle",
    value: function _pointOnCircle(x, y, radius, percentage) {
      var angle = percentage * 2 * Math.PI;
      return {
        x: x + radius * Math.cos(angle),
        y: y - radius * Math.sin(angle)
      };
    }

    /**
     * This function uses binary search to look for the point where the circle crosses the border of the node.
     * @param {Node} node
     * @param {CanvasRenderingContext2D} ctx
     * @param {Object} options
     * @returns {*}
     * @private
     */

  }, {
    key: "_findBorderPositionCircle",
    value: function _findBorderPositionCircle(node, ctx, options) {
      var x = options.x;
      var y = options.y;
      var low = options.low;
      var high = options.high;
      var direction = options.direction;

      var maxIterations = 10;
      var iteration = 0;
      var radius = this.options.selfReferenceSize;
      var pos = void 0,
          angle = void 0,
          distanceToBorder = void 0,
          distanceToPoint = void 0,
          difference = void 0;
      var threshold = 0.05;
      var middle = (low + high) * 0.5;

      while (low <= high && iteration < maxIterations) {
        middle = (low + high) * 0.5;

        pos = this._pointOnCircle(x, y, radius, middle);
        angle = Math.atan2(node.y - pos.y, node.x - pos.x);
        distanceToBorder = node.distanceToBorder(ctx, angle);
        distanceToPoint = Math.sqrt(Math.pow(pos.x - node.x, 2) + Math.pow(pos.y - node.y, 2));
        difference = distanceToBorder - distanceToPoint;
        if (Math.abs(difference) < threshold) {
          break; // found
        } else if (difference > 0) {
          // distance to nodes is larger than distance to border --> t needs to be bigger if we're looking at the to node.
          if (direction > 0) {
            low = middle;
          } else {
            high = middle;
          }
        } else {
          if (direction > 0) {
            high = middle;
          } else {
            low = middle;
          }
        }
        iteration++;
      }
      pos.t = middle;

      return pos;
    }

    /**
     * Get the line width of the edge. Depends on width and whether one of the
     * connected nodes is selected.
     * @param {boolean} selected
     * @param {boolean} hover
     * @returns {number} width
     * @private
     */

  }, {
    key: "getLineWidth",
    value: function getLineWidth(selected, hover) {
      if (selected === true) {
        return Math.max(this.selectionWidth, 0.3 / this.body.view.scale);
      } else {
        if (hover === true) {
          return Math.max(this.hoverWidth, 0.3 / this.body.view.scale);
        } else {
          return Math.max(this.options.width, 0.3 / this.body.view.scale);
        }
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     * @param {boolean} selected - Unused
     * @param {boolean} hover - Unused
     * @returns {string}
     */

  }, {
    key: "getColor",
    value: function getColor(ctx, values, selected, hover) {
      // eslint-disable-line no-unused-vars
      if (values.inheritsColor !== false) {
        // when this is a loop edge, just use the 'from' method
        if (values.inheritsColor === 'both' && this.from.id !== this.to.id) {
          var grd = ctx.createLinearGradient(this.from.x, this.from.y, this.to.x, this.to.y);
          var fromColor = void 0,
              toColor = void 0;
          fromColor = this.from.options.color.highlight.border;
          toColor = this.to.options.color.highlight.border;

          if (this.from.selected === false && this.to.selected === false) {
            fromColor = util.overrideOpacity(this.from.options.color.border, values.opacity);
            toColor = util.overrideOpacity(this.to.options.color.border, values.opacity);
          } else if (this.from.selected === true && this.to.selected === false) {
            toColor = this.to.options.color.border;
          } else if (this.from.selected === false && this.to.selected === true) {
            fromColor = this.from.options.color.border;
          }
          grd.addColorStop(0, fromColor);
          grd.addColorStop(1, toColor);

          // -------------------- this returns -------------------- //
          return grd;
        }

        if (values.inheritsColor === "to") {
          return util.overrideOpacity(this.to.options.color.border, values.opacity);
        } else {
          // "from"
          return util.overrideOpacity(this.from.options.color.border, values.opacity);
        }
      } else {
        return util.overrideOpacity(values.color, values.opacity);
      }
    }

    /**
     * Draw a line from a node to itself, a circle
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array} values
     * @param {number} x
     * @param {number} y
     * @param {number} radius
     * @private
     */

  }, {
    key: "_circle",
    value: function _circle(ctx, values, x, y, radius) {
      // draw shadow if enabled
      this.enableShadow(ctx, values);

      // draw a circle
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, 2 * Math.PI, false);
      ctx.stroke();

      // disable shadows for other elements.
      this.disableShadow(ctx, values);
    }

    /**
     * Calculate the distance between a point (x3,y3) and a line segment from (x1,y1) to (x2,y2).
     * (x3,y3) is the point.
     *
     * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
     *
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @param {number} x3
     * @param {number} y3
     * @param {Node} via
     * @param {Array} values
     * @returns {number}
     */

  }, {
    key: "getDistanceToEdge",
    value: function getDistanceToEdge(x1, y1, x2, y2, x3, y3, via, values) {
      // eslint-disable-line no-unused-vars
      var returnValue = 0;
      if (this.from != this.to) {
        returnValue = this._getDistanceToEdge(x1, y1, x2, y2, x3, y3, via);
      } else {
        var _getCircleData8 = this._getCircleData(undefined),
            _getCircleData9 = (0, _slicedToArray3["default"])(_getCircleData8, 3),
            x = _getCircleData9[0],
            y = _getCircleData9[1],
            radius = _getCircleData9[2];

        var dx = x - x3;
        var dy = y - y3;
        returnValue = Math.abs(Math.sqrt(dx * dx + dy * dy) - radius);
      }

      return returnValue;
    }

    /**
     *
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @param {number} x3
     * @param {number} y3
     * @returns {number}
     * @private
     */

  }, {
    key: "_getDistanceToLine",
    value: function _getDistanceToLine(x1, y1, x2, y2, x3, y3) {
      var px = x2 - x1;
      var py = y2 - y1;
      var something = px * px + py * py;
      var u = ((x3 - x1) * px + (y3 - y1) * py) / something;

      if (u > 1) {
        u = 1;
      } else if (u < 0) {
        u = 0;
      }

      var x = x1 + u * px;
      var y = y1 + u * py;
      var dx = x - x3;
      var dy = y - y3;

      //# Note: If the actual distance does not matter,
      //# if you only want to compare what this function
      //# returns to other results of this function, you
      //# can just return the squared distance instead
      //# (i.e. remove the sqrt) to gain a little performance

      return Math.sqrt(dx * dx + dy * dy);
    }

    /**
     * @param {CanvasRenderingContext2D} ctx
     * @param {string} position
     * @param {Node} viaNode
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {Array} values
     * @returns {{point: *, core: {x: number, y: number}, angle: *, length: number, type: *}}
     */

  }, {
    key: "getArrowData",
    value: function getArrowData(ctx, position, viaNode, selected, hover, values) {
      // set lets
      var angle = void 0;
      var arrowPoint = void 0;
      var node1 = void 0;
      var node2 = void 0;
      var guideOffset = void 0;
      var scaleFactor = void 0;
      var type = void 0;
      var lineWidth = values.width;

      if (position === 'from') {
        node1 = this.from;
        node2 = this.to;
        guideOffset = 0.1;
        scaleFactor = values.fromArrowScale;
        type = values.fromArrowType;
      } else if (position === 'to') {
        node1 = this.to;
        node2 = this.from;
        guideOffset = -0.1;
        scaleFactor = values.toArrowScale;
        type = values.toArrowType;
      } else {
        node1 = this.to;
        node2 = this.from;
        scaleFactor = values.middleArrowScale;
        type = values.middleArrowType;
      }

      // if not connected to itself
      if (node1 != node2) {
        if (position !== 'middle') {
          // draw arrow head
          if (this.options.smooth.enabled === true) {
            arrowPoint = this.findBorderPosition(node1, ctx, { via: viaNode });
            var guidePos = this.getPoint(Math.max(0.0, Math.min(1.0, arrowPoint.t + guideOffset)), viaNode);
            angle = Math.atan2(arrowPoint.y - guidePos.y, arrowPoint.x - guidePos.x);
          } else {
            angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
            arrowPoint = this.findBorderPosition(node1, ctx);
          }
        } else {
          angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
          arrowPoint = this.getPoint(0.5, viaNode); // this is 0.6 to account for the size of the arrow.
        }
      } else {
        // draw circle
        var _getCircleData10 = this._getCircleData(ctx),
            _getCircleData11 = (0, _slicedToArray3["default"])(_getCircleData10, 3),
            x = _getCircleData11[0],
            y = _getCircleData11[1],
            radius = _getCircleData11[2];

        if (position === 'from') {
          arrowPoint = this.findBorderPosition(this.from, ctx, { x: x, y: y, low: 0.25, high: 0.6, direction: -1 });
          angle = arrowPoint.t * -2 * Math.PI + 1.5 * Math.PI + 0.1 * Math.PI;
        } else if (position === 'to') {
          arrowPoint = this.findBorderPosition(this.from, ctx, { x: x, y: y, low: 0.6, high: 1.0, direction: 1 });
          angle = arrowPoint.t * -2 * Math.PI + 1.5 * Math.PI - 1.1 * Math.PI;
        } else {
          arrowPoint = this._pointOnCircle(x, y, radius, 0.175);
          angle = 3.9269908169872414; // === 0.175 * -2 * Math.PI + 1.5 * Math.PI + 0.1 * Math.PI;
        }
      }

      if (position === 'middle' && scaleFactor < 0) lineWidth *= -1; // reversed middle arrow
      var length = 15 * scaleFactor + 3 * lineWidth; // 3* lineWidth is the width of the edge.

      var xi = arrowPoint.x - length * 0.9 * Math.cos(angle);
      var yi = arrowPoint.y - length * 0.9 * Math.sin(angle);
      var arrowCore = { x: xi, y: yi };

      return { point: arrowPoint, core: arrowCore, angle: angle, length: length, type: type };
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {Object} arrowData
     */

  }, {
    key: "drawArrowHead",
    value: function drawArrowHead(ctx, values, selected, hover, arrowData) {
      // set style
      ctx.strokeStyle = this.getColor(ctx, values, selected, hover);
      ctx.fillStyle = ctx.strokeStyle;
      ctx.lineWidth = values.width;

      EndPoints.draw(ctx, arrowData);

      // draw shadow if enabled
      this.enableShadow(ctx, values);
      ctx.fill();
      // disable shadows for other elements.
      this.disableShadow(ctx, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: "enableShadow",
    value: function enableShadow(ctx, values) {
      if (values.shadow === true) {
        ctx.shadowColor = values.shadowColor;
        ctx.shadowBlur = values.shadowSize;
        ctx.shadowOffsetX = values.shadowX;
        ctx.shadowOffsetY = values.shadowY;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: "disableShadow",
    value: function disableShadow(ctx, values) {
      if (values.shadow === true) {
        ctx.shadowColor = 'rgba(0,0,0,0)';
        ctx.shadowBlur = 0;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
      }
    }
  }]);
  return EdgeBase;
}();

exports["default"] = EdgeBase;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/** ============================================================================
 * Location of all the endpoint drawing routines.
 *
 * Every endpoint has its own drawing routine, which contains an endpoint definition.
 *
 * The endpoint definitions must have the following properies:
 *
 * - (0,0) is the connection point to the node it attaches to
 * - The endpoints are orientated to the positive x-direction
 * - The length of the endpoint is at most 1
 *
 * As long as the endpoint classes remain simple and not too numerous, they will
 * be contained within this module.
 * All classes here except `EndPoints` should be considered as private to this module.
 *
 * -----------------------------------------------------------------------------
 * ### Further Actions
 *
 * After adding a new endpoint here, you also need to do the following things:
 *
 * - Add the new endpoint name to `network/options.js` in array `endPoints`.
 * - Add the new endpoint name to the documentation.
 *   Scan for 'arrows.to.type` and add it to the description.
 * - Add the endpoint to the examples. At the very least, add it to example
 *   `edgeStyles/arrowTypes`.
 * ============================================================================= */

// NOTE: When a typedef is isolated in a separate comment block, an actual description is generated for it,
//       using the rest of the commenting in the code block. Usage of typedef in other comments then
//       link to there. TIL.
//
//       Also noteworthy, all typedef's set up in this manner are collected in a single, global page 'global.html'.
//       In other words, it doesn't matter *where* the typedef's are defined in the code.
//
//
// TODO: add descriptive commenting to given typedef's

/**
 * @typedef {{type:string, point:Point, angle:number, length:number}} ArrowData
 *
 * Object containing instantiation data for a given endpoint.
 */

/**
 * @typedef {{x:number, y:number}} Point
 * 
 * A point in view-coordinates.
 */

/**
 * Common methods for endpoints
 *
 * @class
 */
var EndPoint = function () {
  function EndPoint() {
    (0, _classCallCheck3['default'])(this, EndPoint);
  }

  (0, _createClass3['default'])(EndPoint, null, [{
    key: 'transform',


    /**
     * Apply transformation on points for display.
     *
     * The following is done:
     * - rotate by the specified angle
     * - multiply the (normalized) coordinates by the passed length
     * - offset by the target coordinates
     *
     * @param {Array<Point>} points
     * @param {ArrowData} arrowData
     * @static
     */
    value: function transform(points, arrowData) {
      if (!(points instanceof Array)) {
        points = [points];
      }

      var x = arrowData.point.x;
      var y = arrowData.point.y;
      var angle = arrowData.angle;
      var length = arrowData.length;

      for (var i = 0; i < points.length; ++i) {
        var p = points[i];
        var xt = p.x * Math.cos(angle) - p.y * Math.sin(angle);
        var yt = p.x * Math.sin(angle) + p.y * Math.cos(angle);

        p.x = x + length * xt;
        p.y = y + length * yt;
      }
    }

    /**
     * Draw a closed path using the given real coordinates.
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array.<Point>} points
     * @static
     */

  }, {
    key: 'drawPath',
    value: function drawPath(ctx, points) {
      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);
      for (var i = 1; i < points.length; ++i) {
        ctx.lineTo(points[i].x, points[i].y);
      }
      ctx.closePath();
    }
  }]);
  return EndPoint;
}();

/**
 * Drawing methods for the arrow endpoint.
 * @extends EndPoint
 */


var Arrow = function (_EndPoint) {
  (0, _inherits3['default'])(Arrow, _EndPoint);

  function Arrow() {
    (0, _classCallCheck3['default'])(this, Arrow);
    return (0, _possibleConstructorReturn3['default'])(this, (Arrow.__proto__ || (0, _getPrototypeOf2['default'])(Arrow)).apply(this, arguments));
  }

  (0, _createClass3['default'])(Arrow, null, [{
    key: 'draw',


    /**
     * Draw this shape at the end of a line.
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {ArrowData} arrowData
     * @static
     */
    value: function draw(ctx, arrowData) {
      // Normalized points of closed path, in the order that they should be drawn.
      // (0, 0) is the attachment point, and the point around which should be rotated
      var points = [{ x: 0, y: 0 }, { x: -1, y: 0.3 }, { x: -0.9, y: 0 }, { x: -1, y: -0.3 }];

      EndPoint.transform(points, arrowData);
      EndPoint.drawPath(ctx, points);
    }
  }]);
  return Arrow;
}(EndPoint);

/**
 * Drawing methods for the circle endpoint.
 */


var Circle = function () {
  function Circle() {
    (0, _classCallCheck3['default'])(this, Circle);
  }

  (0, _createClass3['default'])(Circle, null, [{
    key: 'draw',


    /**
     * Draw this shape at the end of a line.
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {ArrowData} arrowData
     * @static
     */
    value: function draw(ctx, arrowData) {
      var point = { x: -0.4, y: 0 };

      EndPoint.transform(point, arrowData);
      ctx.circle(point.x, point.y, arrowData.length * 0.4);
    }
  }]);
  return Circle;
}();

/**
 * Drawing methods for the bar endpoint.
 */


var Bar = function () {
  function Bar() {
    (0, _classCallCheck3['default'])(this, Bar);
  }

  (0, _createClass3['default'])(Bar, null, [{
    key: 'draw',


    /**
     * Draw this shape at the end of a line.
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {ArrowData} arrowData
     * @static
     */
    value: function draw(ctx, arrowData) {
      /*
          var points = [
            {x:0, y:0.5},
            {x:0, y:-0.5}
          ];
      
          EndPoint.transform(points, arrowData);
          ctx.beginPath();
          ctx.moveTo(points[0].x, points[0].y);
          ctx.lineTo(points[1].x, points[1].y);
          ctx.stroke();
      */

      var points = [{ x: 0, y: 0.5 }, { x: 0, y: -0.5 }, { x: -0.15, y: -0.5 }, { x: -0.15, y: 0.5 }];

      EndPoint.transform(points, arrowData);
      EndPoint.drawPath(ctx, points);
    }
  }]);
  return Bar;
}();

/**
 * Drawing methods for the endpoints.
 */


var EndPoints = function () {
  function EndPoints() {
    (0, _classCallCheck3['default'])(this, EndPoints);
  }

  (0, _createClass3['default'])(EndPoints, null, [{
    key: 'draw',


    /**
     * Draw an endpoint
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {ArrowData} arrowData
     * @static
     */
    value: function draw(ctx, arrowData) {
      var type;
      if (arrowData.type) {
        type = arrowData.type.toLowerCase();
      }

      switch (type) {
        case 'circle':
          Circle.draw(ctx, arrowData);
          break;
        case 'bar':
          Bar.draw(ctx, arrowData);
          break;
        case 'arrow': // fall-through
        default:
          Arrow.draw(ctx, arrowData);
      }
    }
  }]);
  return EndPoints;
}();

exports['default'] = EndPoints;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Barnes Hut Solver
 */
var BarnesHutSolver = function () {
  /**
   * @param {Object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {Object} options
   */
  function BarnesHutSolver(body, physicsBody, options) {
    (0, _classCallCheck3["default"])(this, BarnesHutSolver);

    this.body = body;
    this.physicsBody = physicsBody;
    this.barnesHutTree;
    this.setOptions(options);
    this.randomSeed = 5;

    // debug: show grid
    // this.body.emitter.on("afterDrawing", (ctx) => {this._debug(ctx,'#ff0000')})
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3["default"])(BarnesHutSolver, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
      this.thetaInversed = 1 / this.options.theta;

      // if 1 then min distance = 0.5, if 0.5 then min distance = 0.5 + 0.5*node.shape.radius
      this.overlapAvoidanceFactor = 1 - Math.max(0, Math.min(1, this.options.avoidOverlap));
    }

    /**
     *
     * @returns {number} random integer
     */

  }, {
    key: "seededRandom",
    value: function seededRandom() {
      var x = Math.sin(this.randomSeed++) * 10000;
      return x - Math.floor(x);
    }

    /**
     * This function calculates the forces the nodes apply on each other based on a gravitational model.
     * The Barnes Hut method is used to speed up this N-body simulation.
     *
     * @private
     */

  }, {
    key: "solve",
    value: function solve() {
      if (this.options.gravitationalConstant !== 0 && this.physicsBody.physicsNodeIndices.length > 0) {
        var node = void 0;
        var nodes = this.body.nodes;
        var nodeIndices = this.physicsBody.physicsNodeIndices;
        var nodeCount = nodeIndices.length;

        // create the tree
        var barnesHutTree = this._formBarnesHutTree(nodes, nodeIndices);

        // for debugging
        this.barnesHutTree = barnesHutTree;

        // place the nodes one by one recursively
        for (var i = 0; i < nodeCount; i++) {
          node = nodes[nodeIndices[i]];
          if (node.options.mass > 0) {
            // starting with root is irrelevant, it never passes the BarnesHutSolver condition
            this._getForceContributions(barnesHutTree.root, node);
          }
        }
      }
    }

    /**
     * @param {Object} parentBranch
     * @param {Node} node
     * @private
     */

  }, {
    key: "_getForceContributions",
    value: function _getForceContributions(parentBranch, node) {
      this._getForceContribution(parentBranch.children.NW, node);
      this._getForceContribution(parentBranch.children.NE, node);
      this._getForceContribution(parentBranch.children.SW, node);
      this._getForceContribution(parentBranch.children.SE, node);
    }

    /**
     * This function traverses the barnesHutTree. It checks when it can approximate distant nodes with their center of mass.
     * If a region contains a single node, we check if it is not itself, then we apply the force.
     *
     * @param {Object} parentBranch
     * @param {Node} node
     * @private
     */

  }, {
    key: "_getForceContribution",
    value: function _getForceContribution(parentBranch, node) {
      // we get no force contribution from an empty region
      if (parentBranch.childrenCount > 0) {
        var dx = void 0,
            dy = void 0,
            distance = void 0;

        // get the distance from the center of mass to the node.
        dx = parentBranch.centerOfMass.x - node.x;
        dy = parentBranch.centerOfMass.y - node.y;
        distance = Math.sqrt(dx * dx + dy * dy);

        // BarnesHutSolver condition
        // original condition : s/d < theta = passed  ===  d/s > 1/theta = passed
        // calcSize = 1/s --> d * 1/s > 1/theta = passed
        if (distance * parentBranch.calcSize > this.thetaInversed) {
          this._calculateForces(distance, dx, dy, node, parentBranch);
        } else {
          // Did not pass the condition, go into children if available
          if (parentBranch.childrenCount === 4) {
            this._getForceContributions(parentBranch, node);
          } else {
            // parentBranch must have only one node, if it was empty we wouldnt be here
            if (parentBranch.children.data.id != node.id) {
              // if it is not self
              this._calculateForces(distance, dx, dy, node, parentBranch);
            }
          }
        }
      }
    }

    /**
     * Calculate the forces based on the distance.
     *
     * @param {number} distance
     * @param {number} dx
     * @param {number} dy
     * @param {Node} node
     * @param {Object} parentBranch
     * @private
     */

  }, {
    key: "_calculateForces",
    value: function _calculateForces(distance, dx, dy, node, parentBranch) {
      if (distance === 0) {
        distance = 0.1;
        dx = distance;
      }

      if (this.overlapAvoidanceFactor < 1 && node.shape.radius) {
        distance = Math.max(0.1 + this.overlapAvoidanceFactor * node.shape.radius, distance - node.shape.radius);
      }

      // the dividing by the distance cubed instead of squared allows us to get the fx and fy components without sines and cosines
      // it is shorthand for gravityforce with distance squared and fx = dx/distance * gravityForce
      var gravityForce = this.options.gravitationalConstant * parentBranch.mass * node.options.mass / Math.pow(distance, 3);
      var fx = dx * gravityForce;
      var fy = dy * gravityForce;

      this.physicsBody.forces[node.id].x += fx;
      this.physicsBody.forces[node.id].y += fy;
    }

    /**
     * This function constructs the barnesHut tree recursively. It creates the root, splits it and starts placing the nodes.
     *
     * @param {Array.<Node>} nodes
     * @param {Array.<number>} nodeIndices
     * @returns {{root: {centerOfMass: {x: number, y: number}, mass: number, range: {minX: number, maxX: number, minY: number, maxY: number}, size: number, calcSize: number, children: {data: null}, maxWidth: number, level: number, childrenCount: number}}} BarnesHutTree
     * @private
     */

  }, {
    key: "_formBarnesHutTree",
    value: function _formBarnesHutTree(nodes, nodeIndices) {
      var node = void 0;
      var nodeCount = nodeIndices.length;

      var minX = nodes[nodeIndices[0]].x;
      var minY = nodes[nodeIndices[0]].y;
      var maxX = nodes[nodeIndices[0]].x;
      var maxY = nodes[nodeIndices[0]].y;

      // get the range of the nodes
      for (var i = 1; i < nodeCount; i++) {
        var _node = nodes[nodeIndices[i]];
        var x = _node.x;
        var y = _node.y;
        if (_node.options.mass > 0) {
          if (x < minX) {
            minX = x;
          }
          if (x > maxX) {
            maxX = x;
          }
          if (y < minY) {
            minY = y;
          }
          if (y > maxY) {
            maxY = y;
          }
        }
      }
      // make the range a square
      var sizeDiff = Math.abs(maxX - minX) - Math.abs(maxY - minY); // difference between X and Y
      if (sizeDiff > 0) {
        minY -= 0.5 * sizeDiff;
        maxY += 0.5 * sizeDiff;
      } // xSize > ySize
      else {
          minX += 0.5 * sizeDiff;
          maxX -= 0.5 * sizeDiff;
        } // xSize < ySize


      var minimumTreeSize = 1e-5;
      var rootSize = Math.max(minimumTreeSize, Math.abs(maxX - minX));
      var halfRootSize = 0.5 * rootSize;
      var centerX = 0.5 * (minX + maxX),
          centerY = 0.5 * (minY + maxY);

      // construct the barnesHutTree
      var barnesHutTree = {
        root: {
          centerOfMass: { x: 0, y: 0 },
          mass: 0,
          range: {
            minX: centerX - halfRootSize, maxX: centerX + halfRootSize,
            minY: centerY - halfRootSize, maxY: centerY + halfRootSize
          },
          size: rootSize,
          calcSize: 1 / rootSize,
          children: { data: null },
          maxWidth: 0,
          level: 0,
          childrenCount: 4
        }
      };
      this._splitBranch(barnesHutTree.root);

      // place the nodes one by one recursively
      for (var _i = 0; _i < nodeCount; _i++) {
        node = nodes[nodeIndices[_i]];
        if (node.options.mass > 0) {
          this._placeInTree(barnesHutTree.root, node);
        }
      }

      // make global
      return barnesHutTree;
    }

    /**
     * this updates the mass of a branch. this is increased by adding a node.
     *
     * @param {Object} parentBranch
     * @param {Node} node
     * @private
     */

  }, {
    key: "_updateBranchMass",
    value: function _updateBranchMass(parentBranch, node) {
      var centerOfMass = parentBranch.centerOfMass;
      var totalMass = parentBranch.mass + node.options.mass;
      var totalMassInv = 1 / totalMass;

      centerOfMass.x = centerOfMass.x * parentBranch.mass + node.x * node.options.mass;
      centerOfMass.x *= totalMassInv;

      centerOfMass.y = centerOfMass.y * parentBranch.mass + node.y * node.options.mass;
      centerOfMass.y *= totalMassInv;

      parentBranch.mass = totalMass;
      var biggestSize = Math.max(Math.max(node.height, node.radius), node.width);
      parentBranch.maxWidth = parentBranch.maxWidth < biggestSize ? biggestSize : parentBranch.maxWidth;
    }

    /**
     * determine in which branch the node will be placed.
     *
     * @param {Object} parentBranch
     * @param {Node} node
     * @param {boolean} skipMassUpdate
     * @private
     */

  }, {
    key: "_placeInTree",
    value: function _placeInTree(parentBranch, node, skipMassUpdate) {
      if (skipMassUpdate != true || skipMassUpdate === undefined) {
        // update the mass of the branch.
        this._updateBranchMass(parentBranch, node);
      }

      var range = parentBranch.children.NW.range;
      var region = void 0;
      if (range.maxX > node.x) {
        // in NW or SW
        if (range.maxY > node.y) {
          region = "NW";
        } else {
          region = "SW";
        }
      } else {
        // in NE or SE
        if (range.maxY > node.y) {
          region = "NE";
        } else {
          region = "SE";
        }
      }

      this._placeInRegion(parentBranch, node, region);
    }

    /**
     * actually place the node in a region (or branch)
     *
     * @param {Object} parentBranch
     * @param {Node} node
     * @param {'NW'| 'NE' | 'SW' | 'SE'} region
     * @private
     */

  }, {
    key: "_placeInRegion",
    value: function _placeInRegion(parentBranch, node, region) {
      var children = parentBranch.children[region];

      switch (children.childrenCount) {
        case 0:
          // place node here
          children.children.data = node;
          children.childrenCount = 1;
          this._updateBranchMass(children, node);
          break;
        case 1:
          // convert into children
          // if there are two nodes exactly overlapping (on init, on opening of cluster etc.)
          // we move one node a little bit and we do not put it in the tree.
          if (children.children.data.x === node.x && children.children.data.y === node.y) {
            node.x += this.seededRandom();
            node.y += this.seededRandom();
          } else {
            this._splitBranch(children);
            this._placeInTree(children, node);
          }
          break;
        case 4:
          // place in branch
          this._placeInTree(children, node);
          break;
      }
    }

    /**
     * this function splits a branch into 4 sub branches. If the branch contained a node, we place it in the subbranch
     * after the split is complete.
     *
     * @param {Object} parentBranch
     * @private
     */

  }, {
    key: "_splitBranch",
    value: function _splitBranch(parentBranch) {
      // if the branch is shaded with a node, replace the node in the new subset.
      var containedNode = null;
      if (parentBranch.childrenCount === 1) {
        containedNode = parentBranch.children.data;
        parentBranch.mass = 0;
        parentBranch.centerOfMass.x = 0;
        parentBranch.centerOfMass.y = 0;
      }
      parentBranch.childrenCount = 4;
      parentBranch.children.data = null;
      this._insertRegion(parentBranch, "NW");
      this._insertRegion(parentBranch, "NE");
      this._insertRegion(parentBranch, "SW");
      this._insertRegion(parentBranch, "SE");

      if (containedNode != null) {
        this._placeInTree(parentBranch, containedNode);
      }
    }

    /**
     * This function subdivides the region into four new segments.
     * Specifically, this inserts a single new segment.
     * It fills the children section of the parentBranch
     *
     * @param {Object} parentBranch
     * @param {'NW'| 'NE' | 'SW' | 'SE'} region
     * @private
     */

  }, {
    key: "_insertRegion",
    value: function _insertRegion(parentBranch, region) {
      var minX = void 0,
          maxX = void 0,
          minY = void 0,
          maxY = void 0;
      var childSize = 0.5 * parentBranch.size;
      switch (region) {
        case "NW":
          minX = parentBranch.range.minX;
          maxX = parentBranch.range.minX + childSize;
          minY = parentBranch.range.minY;
          maxY = parentBranch.range.minY + childSize;
          break;
        case "NE":
          minX = parentBranch.range.minX + childSize;
          maxX = parentBranch.range.maxX;
          minY = parentBranch.range.minY;
          maxY = parentBranch.range.minY + childSize;
          break;
        case "SW":
          minX = parentBranch.range.minX;
          maxX = parentBranch.range.minX + childSize;
          minY = parentBranch.range.minY + childSize;
          maxY = parentBranch.range.maxY;
          break;
        case "SE":
          minX = parentBranch.range.minX + childSize;
          maxX = parentBranch.range.maxX;
          minY = parentBranch.range.minY + childSize;
          maxY = parentBranch.range.maxY;
          break;
      }

      parentBranch.children[region] = {
        centerOfMass: { x: 0, y: 0 },
        mass: 0,
        range: { minX: minX, maxX: maxX, minY: minY, maxY: maxY },
        size: 0.5 * parentBranch.size,
        calcSize: 2 * parentBranch.calcSize,
        children: { data: null },
        maxWidth: 0,
        level: parentBranch.level + 1,
        childrenCount: 0
      };
    }

    //---------------------------  DEBUGGING BELOW  ---------------------------//


    /**
     * This function is for debugging purposed, it draws the tree.
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {string} color
     * @private
     */

  }, {
    key: "_debug",
    value: function _debug(ctx, color) {
      if (this.barnesHutTree !== undefined) {

        ctx.lineWidth = 1;

        this._drawBranch(this.barnesHutTree.root, ctx, color);
      }
    }

    /**
     * This function is for debugging purposes. It draws the branches recursively.
     *
     * @param {Object} branch
     * @param {CanvasRenderingContext2D} ctx
     * @param {string} color
     * @private
     */

  }, {
    key: "_drawBranch",
    value: function _drawBranch(branch, ctx, color) {
      if (color === undefined) {
        color = "#FF0000";
      }

      if (branch.childrenCount === 4) {
        this._drawBranch(branch.children.NW, ctx);
        this._drawBranch(branch.children.NE, ctx);
        this._drawBranch(branch.children.SE, ctx);
        this._drawBranch(branch.children.SW, ctx);
      }
      ctx.strokeStyle = color;
      ctx.beginPath();
      ctx.moveTo(branch.range.minX, branch.range.minY);
      ctx.lineTo(branch.range.maxX, branch.range.minY);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(branch.range.maxX, branch.range.minY);
      ctx.lineTo(branch.range.maxX, branch.range.maxY);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(branch.range.maxX, branch.range.maxY);
      ctx.lineTo(branch.range.minX, branch.range.maxY);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(branch.range.minX, branch.range.maxY);
      ctx.lineTo(branch.range.minX, branch.range.minY);
      ctx.stroke();

      /*
       if (branch.mass > 0) {
       ctx.circle(branch.centerOfMass.x, branch.centerOfMass.y, 3*branch.mass);
       ctx.stroke();
       }
       */
    }
  }]);
  return BarnesHutSolver;
}();

exports["default"] = BarnesHutSolver;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Central Gravity Solver
 */
var CentralGravitySolver = function () {
  /**
   * @param {Object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {Object} options
   */
  function CentralGravitySolver(body, physicsBody, options) {
    (0, _classCallCheck3["default"])(this, CentralGravitySolver);

    this.body = body;
    this.physicsBody = physicsBody;
    this.setOptions(options);
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3["default"])(CentralGravitySolver, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
    }

    /**
     * Calculates forces for each node
     */

  }, {
    key: "solve",
    value: function solve() {
      var dx = void 0,
          dy = void 0,
          distance = void 0,
          node = void 0;
      var nodes = this.body.nodes;
      var nodeIndices = this.physicsBody.physicsNodeIndices;
      var forces = this.physicsBody.forces;

      for (var i = 0; i < nodeIndices.length; i++) {
        var nodeId = nodeIndices[i];
        node = nodes[nodeId];
        dx = -node.x;
        dy = -node.y;
        distance = Math.sqrt(dx * dx + dy * dy);

        this._calculateForces(distance, dx, dy, forces, node);
      }
    }

    /**
     * Calculate the forces based on the distance.
     * @param {number} distance
     * @param {number} dx
     * @param {number} dy
     * @param {Object<Node.id, vis.Node>} forces
     * @param {Node} node
     * @private
     */

  }, {
    key: "_calculateForces",
    value: function _calculateForces(distance, dx, dy, forces, node) {
      var gravityForce = distance === 0 ? 0 : this.options.centralGravity / distance;
      forces[node.id].x = dx * gravityForce;
      forces[node.id].y = dy * gravityForce;
    }
  }]);
  return CentralGravitySolver;
}();

exports["default"] = CentralGravitySolver;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This object contains all possible options. It will check if the types are correct, if required if the option is one
 * of the allowed values.
 *
 * __any__ means that the name of the property does not matter.
 * __type__ is a required field for all objects and contains the allowed types of all objects
 */
var string = 'string';
var bool = 'boolean';
var number = 'number';
var array = 'array';
var object = 'object'; // should only be in a __type__ property
var dom = 'dom';
var any = 'any';

// List of endpoints
var endPoints = ['arrow', 'circle', 'bar'];

var allOptions = {
  configure: {
    enabled: { boolean: bool },
    filter: { boolean: bool, string: string, array: array, 'function': 'function' },
    container: { dom: dom },
    showButton: { boolean: bool },
    __type__: { object: object, boolean: bool, string: string, array: array, 'function': 'function' }
  },
  edges: {
    arrows: {
      to: { enabled: { boolean: bool }, scaleFactor: { number: number }, type: { string: endPoints }, __type__: { object: object, boolean: bool } },
      middle: { enabled: { boolean: bool }, scaleFactor: { number: number }, type: { string: endPoints }, __type__: { object: object, boolean: bool } },
      from: { enabled: { boolean: bool }, scaleFactor: { number: number }, type: { string: endPoints }, __type__: { object: object, boolean: bool } },
      __type__: { string: ['from', 'to', 'middle'], object: object }
    },
    arrowStrikethrough: { boolean: bool },
    chosen: {
      label: { boolean: bool, 'function': 'function' },
      edge: { boolean: bool, 'function': 'function' },
      __type__: { object: object, boolean: bool }
    },
    color: {
      color: { string: string },
      highlight: { string: string },
      hover: { string: string },
      inherit: { string: ['from', 'to', 'both'], boolean: bool },
      opacity: { number: number },
      __type__: { object: object, string: string }
    },
    dashes: { boolean: bool, array: array },
    font: {
      color: { string: string },
      size: { number: number }, // px
      face: { string: string },
      background: { string: string },
      strokeWidth: { number: number }, // px
      strokeColor: { string: string },
      align: { string: ['horizontal', 'top', 'middle', 'bottom'] },
      vadjust: { number: number },
      multi: { boolean: bool, string: string },
      bold: {
        color: { string: string },
        size: { number: number }, // px
        face: { string: string },
        mod: { string: string },
        vadjust: { number: number },
        __type__: { object: object, string: string }
      },
      boldital: {
        color: { string: string },
        size: { number: number }, // px
        face: { string: string },
        mod: { string: string },
        vadjust: { number: number },
        __type__: { object: object, string: string }
      },
      ital: {
        color: { string: string },
        size: { number: number }, // px
        face: { string: string },
        mod: { string: string },
        vadjust: { number: number },
        __type__: { object: object, string: string }
      },
      mono: {
        color: { string: string },
        size: { number: number }, // px
        face: { string: string },
        mod: { string: string },
        vadjust: { number: number },
        __type__: { object: object, string: string }
      },
      __type__: { object: object, string: string }
    },
    hidden: { boolean: bool },
    hoverWidth: { 'function': 'function', number: number },
    label: { string: string, 'undefined': 'undefined' },
    labelHighlightBold: { boolean: bool },
    length: { number: number, 'undefined': 'undefined' },
    physics: { boolean: bool },
    scaling: {
      min: { number: number },
      max: { number: number },
      label: {
        enabled: { boolean: bool },
        min: { number: number },
        max: { number: number },
        maxVisible: { number: number },
        drawThreshold: { number: number },
        __type__: { object: object, boolean: bool }
      },
      customScalingFunction: { 'function': 'function' },
      __type__: { object: object }
    },
    selectionWidth: { 'function': 'function', number: number },
    selfReferenceSize: { number: number },
    shadow: {
      enabled: { boolean: bool },
      color: { string: string },
      size: { number: number },
      x: { number: number },
      y: { number: number },
      __type__: { object: object, boolean: bool }
    },
    smooth: {
      enabled: { boolean: bool },
      type: { string: ['dynamic', 'continuous', 'discrete', 'diagonalCross', 'straightCross', 'horizontal', 'vertical', 'curvedCW', 'curvedCCW', 'cubicBezier'] },
      roundness: { number: number },
      forceDirection: { string: ['horizontal', 'vertical', 'none'], boolean: bool },
      __type__: { object: object, boolean: bool }
    },
    title: { string: string, 'undefined': 'undefined' },
    width: { number: number },
    widthConstraint: {
      maximum: { number: number },
      __type__: { object: object, boolean: bool, number: number }
    },
    value: { number: number, 'undefined': 'undefined' },
    __type__: { object: object }
  },
  groups: {
    useDefaultGroups: { boolean: bool },
    __any__: 'get from nodes, will be overwritten below',
    __type__: { object: object }
  },
  interaction: {
    dragNodes: { boolean: bool },
    dragView: { boolean: bool },
    hideEdgesOnDrag: { boolean: bool },
    hideNodesOnDrag: { boolean: bool },
    hover: { boolean: bool },
    keyboard: {
      enabled: { boolean: bool },
      speed: { x: { number: number }, y: { number: number }, zoom: { number: number }, __type__: { object: object } },
      bindToWindow: { boolean: bool },
      __type__: { object: object, boolean: bool }
    },
    multiselect: { boolean: bool },
    navigationButtons: { boolean: bool },
    selectable: { boolean: bool },
    selectConnectedEdges: { boolean: bool },
    hoverConnectedEdges: { boolean: bool },
    tooltipDelay: { number: number },
    zoomView: { boolean: bool },
    __type__: { object: object }
  },
  layout: {
    randomSeed: { 'undefined': 'undefined', number: number },
    improvedLayout: { boolean: bool },
    hierarchical: {
      enabled: { boolean: bool },
      levelSeparation: { number: number },
      nodeSpacing: { number: number },
      treeSpacing: { number: number },
      blockShifting: { boolean: bool },
      edgeMinimization: { boolean: bool },
      parentCentralization: { boolean: bool },
      direction: { string: ['UD', 'DU', 'LR', 'RL'] }, // UD, DU, LR, RL
      sortMethod: { string: ['hubsize', 'directed'] }, // hubsize, directed
      __type__: { object: object, boolean: bool }
    },
    __type__: { object: object }
  },
  manipulation: {
    enabled: { boolean: bool },
    initiallyActive: { boolean: bool },
    addNode: { boolean: bool, 'function': 'function' },
    addEdge: { boolean: bool, 'function': 'function' },
    editNode: { 'function': 'function' },
    editEdge: {
      editWithoutDrag: { 'function': 'function' },
      __type__: { object: object, boolean: bool, 'function': 'function' }
    },
    deleteNode: { boolean: bool, 'function': 'function' },
    deleteEdge: { boolean: bool, 'function': 'function' },
    controlNodeStyle: 'get from nodes, will be overwritten below',
    __type__: { object: object, boolean: bool }
  },
  nodes: {
    borderWidth: { number: number },
    borderWidthSelected: { number: number, 'undefined': 'undefined' },
    brokenImage: { string: string, 'undefined': 'undefined' },
    chosen: {
      label: { boolean: bool, 'function': 'function' },
      node: { boolean: bool, 'function': 'function' },
      __type__: { object: object, boolean: bool }
    },
    color: {
      border: { string: string },
      background: { string: string },
      highlight: {
        border: { string: string },
        background: { string: string },
        __type__: { object: object, string: string }
      },
      hover: {
        border: { string: string },
        background: { string: string },
        __type__: { object: object, string: string }
      },
      __type__: { object: object, string: string }
    },
    fixed: {
      x: { boolean: bool },
      y: { boolean: bool },
      __type__: { object: object, boolean: bool }
    },
    font: {
      align: { string: string },
      color: { string: string },
      size: { number: number }, // px
      face: { string: string },
      background: { string: string },
      strokeWidth: { number: number }, // px
      strokeColor: { string: string },
      vadjust: { number: number },
      multi: { boolean: bool, string: string },
      bold: {
        color: { string: string },
        size: { number: number }, // px
        face: { string: string },
        mod: { string: string },
        vadjust: { number: number },
        __type__: { object: object, string: string }
      },
      boldital: {
        color: { string: string },
        size: { number: number }, // px
        face: { string: string },
        mod: { string: string },
        vadjust: { number: number },
        __type__: { object: object, string: string }
      },
      ital: {
        color: { string: string },
        size: { number: number }, // px
        face: { string: string },
        mod: { string: string },
        vadjust: { number: number },
        __type__: { object: object, string: string }
      },
      mono: {
        color: { string: string },
        size: { number: number }, // px
        face: { string: string },
        mod: { string: string },
        vadjust: { number: number },
        __type__: { object: object, string: string }
      },
      __type__: { object: object, string: string }
    },
    group: { string: string, number: number, 'undefined': 'undefined' },
    heightConstraint: {
      minimum: { number: number },
      valign: { string: string },
      __type__: { object: object, boolean: bool, number: number }
    },
    hidden: { boolean: bool },
    icon: {
      face: { string: string },
      code: { string: string }, //'\uf007',
      size: { number: number }, //50,
      color: { string: string },
      __type__: { object: object }
    },
    id: { string: string, number: number },
    image: {
      selected: { string: string, 'undefined': 'undefined' }, // --> URL
      unselected: { string: string, 'undefined': 'undefined' }, // --> URL
      __type__: { object: object, string: string }
    },
    label: { string: string, 'undefined': 'undefined' },
    labelHighlightBold: { boolean: bool },
    level: { number: number, 'undefined': 'undefined' },
    margin: {
      top: { number: number },
      right: { number: number },
      bottom: { number: number },
      left: { number: number },
      __type__: { object: object, number: number }
    },
    mass: { number: number },
    physics: { boolean: bool },
    scaling: {
      min: { number: number },
      max: { number: number },
      label: {
        enabled: { boolean: bool },
        min: { number: number },
        max: { number: number },
        maxVisible: { number: number },
        drawThreshold: { number: number },
        __type__: { object: object, boolean: bool }
      },
      customScalingFunction: { 'function': 'function' },
      __type__: { object: object }
    },
    shadow: {
      enabled: { boolean: bool },
      color: { string: string },
      size: { number: number },
      x: { number: number },
      y: { number: number },
      __type__: { object: object, boolean: bool }
    },
    shape: { string: ['ellipse', 'circle', 'database', 'box', 'text', 'image', 'circularImage', 'diamond', 'dot', 'star', 'triangle', 'triangleDown', 'square', 'icon', 'hexagon'] },
    shapeProperties: {
      borderDashes: { boolean: bool, array: array },
      borderRadius: { number: number },
      interpolation: { boolean: bool },
      useImageSize: { boolean: bool },
      useBorderWithImage: { boolean: bool },
      __type__: { object: object }
    },
    size: { number: number },
    title: { string: string, dom: dom, 'undefined': 'undefined' },
    value: { number: number, 'undefined': 'undefined' },
    widthConstraint: {
      minimum: { number: number },
      maximum: { number: number },
      __type__: { object: object, boolean: bool, number: number }
    },
    x: { number: number },
    y: { number: number },
    __type__: { object: object }
  },
  physics: {
    enabled: { boolean: bool },
    barnesHut: {
      gravitationalConstant: { number: number },
      centralGravity: { number: number },
      springLength: { number: number },
      springConstant: { number: number },
      damping: { number: number },
      avoidOverlap: { number: number },
      __type__: { object: object }
    },
    forceAtlas2Based: {
      gravitationalConstant: { number: number },
      centralGravity: { number: number },
      springLength: { number: number },
      springConstant: { number: number },
      damping: { number: number },
      avoidOverlap: { number: number },
      __type__: { object: object }
    },
    repulsion: {
      centralGravity: { number: number },
      springLength: { number: number },
      springConstant: { number: number },
      nodeDistance: { number: number },
      damping: { number: number },
      __type__: { object: object }
    },
    hierarchicalRepulsion: {
      centralGravity: { number: number },
      springLength: { number: number },
      springConstant: { number: number },
      nodeDistance: { number: number },
      damping: { number: number },
      __type__: { object: object }
    },
    maxVelocity: { number: number },
    minVelocity: { number: number }, // px/s
    solver: { string: ['barnesHut', 'repulsion', 'hierarchicalRepulsion', 'forceAtlas2Based'] },
    stabilization: {
      enabled: { boolean: bool },
      iterations: { number: number }, // maximum number of iteration to stabilize
      updateInterval: { number: number },
      onlyDynamicEdges: { boolean: bool },
      fit: { boolean: bool },
      __type__: { object: object, boolean: bool }
    },
    timestep: { number: number },
    adaptiveTimestep: { boolean: bool },
    __type__: { object: object, boolean: bool }
  },

  //globals :
  autoResize: { boolean: bool },
  clickToUse: { boolean: bool },
  locale: { string: string },
  locales: {
    __any__: { any: any },
    __type__: { object: object }
  },
  height: { string: string },
  width: { string: string },
  __type__: { object: object }
};

allOptions.groups.__any__ = allOptions.nodes;
allOptions.manipulation.controlNodeStyle = allOptions.nodes;

var configureOptions = {
  nodes: {
    borderWidth: [1, 0, 10, 1],
    borderWidthSelected: [2, 0, 10, 1],
    color: {
      border: ['color', '#2B7CE9'],
      background: ['color', '#97C2FC'],
      highlight: {
        border: ['color', '#2B7CE9'],
        background: ['color', '#D2E5FF']
      },
      hover: {
        border: ['color', '#2B7CE9'],
        background: ['color', '#D2E5FF']
      }
    },
    fixed: {
      x: false,
      y: false
    },
    font: {
      color: ['color', '#343434'],
      size: [14, 0, 100, 1], // px
      face: ['arial', 'verdana', 'tahoma'],
      background: ['color', 'none'],
      strokeWidth: [0, 0, 50, 1], // px
      strokeColor: ['color', '#ffffff']
    },
    //group: 'string',
    hidden: false,
    labelHighlightBold: true,
    //icon: {
    //  face: 'string',  //'FontAwesome',
    //  code: 'string',  //'\uf007',
    //  size: [50, 0, 200, 1],  //50,
    //  color: ['color','#2B7CE9']   //'#aa00ff'
    //},
    //image: 'string', // --> URL
    physics: true,
    scaling: {
      min: [10, 0, 200, 1],
      max: [30, 0, 200, 1],
      label: {
        enabled: false,
        min: [14, 0, 200, 1],
        max: [30, 0, 200, 1],
        maxVisible: [30, 0, 200, 1],
        drawThreshold: [5, 0, 20, 1]
      }
    },
    shadow: {
      enabled: false,
      color: 'rgba(0,0,0,0.5)',
      size: [10, 0, 20, 1],
      x: [5, -30, 30, 1],
      y: [5, -30, 30, 1]
    },
    shape: ['ellipse', 'box', 'circle', 'database', 'diamond', 'dot', 'square', 'star', 'text', 'triangle', 'triangleDown', 'hexagon'],
    shapeProperties: {
      borderDashes: false,
      borderRadius: [6, 0, 20, 1],
      interpolation: true,
      useImageSize: false
    },
    size: [25, 0, 200, 1]
  },
  edges: {
    arrows: {
      to: { enabled: false, scaleFactor: [1, 0, 3, 0.05], type: 'arrow' },
      middle: { enabled: false, scaleFactor: [1, 0, 3, 0.05], type: 'arrow' },
      from: { enabled: false, scaleFactor: [1, 0, 3, 0.05], type: 'arrow' }
    },
    arrowStrikethrough: true,
    color: {
      color: ['color', '#848484'],
      highlight: ['color', '#848484'],
      hover: ['color', '#848484'],
      inherit: ['from', 'to', 'both', true, false],
      opacity: [1, 0, 1, 0.05]
    },
    dashes: false,
    font: {
      color: ['color', '#343434'],
      size: [14, 0, 100, 1], // px
      face: ['arial', 'verdana', 'tahoma'],
      background: ['color', 'none'],
      strokeWidth: [2, 0, 50, 1], // px
      strokeColor: ['color', '#ffffff'],
      align: ['horizontal', 'top', 'middle', 'bottom']
    },
    hidden: false,
    hoverWidth: [1.5, 0, 5, 0.1],
    labelHighlightBold: true,
    physics: true,
    scaling: {
      min: [1, 0, 100, 1],
      max: [15, 0, 100, 1],
      label: {
        enabled: true,
        min: [14, 0, 200, 1],
        max: [30, 0, 200, 1],
        maxVisible: [30, 0, 200, 1],
        drawThreshold: [5, 0, 20, 1]
      }
    },
    selectionWidth: [1.5, 0, 5, 0.1],
    selfReferenceSize: [20, 0, 200, 1],
    shadow: {
      enabled: false,
      color: 'rgba(0,0,0,0.5)',
      size: [10, 0, 20, 1],
      x: [5, -30, 30, 1],
      y: [5, -30, 30, 1]
    },
    smooth: {
      enabled: true,
      type: ['dynamic', 'continuous', 'discrete', 'diagonalCross', 'straightCross', 'horizontal', 'vertical', 'curvedCW', 'curvedCCW', 'cubicBezier'],
      forceDirection: ['horizontal', 'vertical', 'none'],
      roundness: [0.5, 0, 1, 0.05]
    },
    width: [1, 0, 30, 1]
  },
  layout: {
    //randomSeed: [0, 0, 500, 1],
    //improvedLayout: true,
    hierarchical: {
      enabled: false,
      levelSeparation: [150, 20, 500, 5],
      nodeSpacing: [100, 20, 500, 5],
      treeSpacing: [200, 20, 500, 5],
      blockShifting: true,
      edgeMinimization: true,
      parentCentralization: true,
      direction: ['UD', 'DU', 'LR', 'RL'], // UD, DU, LR, RL
      sortMethod: ['hubsize', 'directed'] // hubsize, directed
    }
  },
  interaction: {
    dragNodes: true,
    dragView: true,
    hideEdgesOnDrag: false,
    hideNodesOnDrag: false,
    hover: false,
    keyboard: {
      enabled: false,
      speed: { x: [10, 0, 40, 1], y: [10, 0, 40, 1], zoom: [0.02, 0, 0.1, 0.005] },
      bindToWindow: true
    },
    multiselect: false,
    navigationButtons: false,
    selectable: true,
    selectConnectedEdges: true,
    hoverConnectedEdges: true,
    tooltipDelay: [300, 0, 1000, 25],
    zoomView: true
  },
  manipulation: {
    enabled: false,
    initiallyActive: false
  },
  physics: {
    enabled: true,
    barnesHut: {
      //theta: [0.5, 0.1, 1, 0.05],
      gravitationalConstant: [-2000, -30000, 0, 50],
      centralGravity: [0.3, 0, 10, 0.05],
      springLength: [95, 0, 500, 5],
      springConstant: [0.04, 0, 1.2, 0.005],
      damping: [0.09, 0, 1, 0.01],
      avoidOverlap: [0, 0, 1, 0.01]
    },
    forceAtlas2Based: {
      //theta: [0.5, 0.1, 1, 0.05],
      gravitationalConstant: [-50, -500, 0, 1],
      centralGravity: [0.01, 0, 1, 0.005],
      springLength: [95, 0, 500, 5],
      springConstant: [0.08, 0, 1.2, 0.005],
      damping: [0.4, 0, 1, 0.01],
      avoidOverlap: [0, 0, 1, 0.01]
    },
    repulsion: {
      centralGravity: [0.2, 0, 10, 0.05],
      springLength: [200, 0, 500, 5],
      springConstant: [0.05, 0, 1.2, 0.005],
      nodeDistance: [100, 0, 500, 5],
      damping: [0.09, 0, 1, 0.01]
    },
    hierarchicalRepulsion: {
      centralGravity: [0.2, 0, 10, 0.05],
      springLength: [100, 0, 500, 5],
      springConstant: [0.01, 0, 1.2, 0.005],
      nodeDistance: [120, 0, 500, 5],
      damping: [0.09, 0, 1, 0.01]
    },
    maxVelocity: [50, 0, 150, 1],
    minVelocity: [0.1, 0.01, 0.5, 0.01],
    solver: ['barnesHut', 'forceAtlas2Based', 'repulsion', 'hierarchicalRepulsion'],
    timestep: [0.5, 0.01, 1, 0.01]
    //adaptiveTimestep: true
  }
};

exports.allOptions = allOptions;
exports.configureOptions = configureOptions;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(2);

// Graph3d
util.extend(exports, __webpack_require__(159));

// Timeline & Graph2d
util.extend(exports, __webpack_require__(177));

// Network
util.extend(exports, __webpack_require__(181));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
__webpack_require__(60);
module.exports = __webpack_require__(136);


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(126);
var step = __webpack_require__(127);
var Iterators = __webpack_require__(31);
var toIObject = __webpack_require__(25);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(79)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(54);
var descriptor = __webpack_require__(39);
var setToStringTag = __webpack_require__(59);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(26)(IteratorPrototype, __webpack_require__(13)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var anObject = __webpack_require__(27);
var getKeys = __webpack_require__(33);

module.exports = __webpack_require__(21) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(25);
var toLength = __webpack_require__(132);
var toAbsoluteIndex = __webpack_require__(133);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(55);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(55);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(18).document;
module.exports = document && document.documentElement;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(55);
var defined = __webpack_require__(51);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(27);
var get = __webpack_require__(137);
module.exports = __webpack_require__(7).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(86);
var ITERATOR = __webpack_require__(13)('iterator');
var Iterators = __webpack_require__(31);
module.exports = __webpack_require__(7).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(139);
var $Object = __webpack_require__(7).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(54) });


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(141);
module.exports = __webpack_require__(7).Object.keys;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(41);
var $keys = __webpack_require__(33);

__webpack_require__(87)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(143), __esModule: true };

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60);
__webpack_require__(49);
module.exports = __webpack_require__(61).f('iterator');


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(145), __esModule: true };

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146);
__webpack_require__(151);
__webpack_require__(152);
__webpack_require__(153);
module.exports = __webpack_require__(7).Symbol;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(18);
var has = __webpack_require__(22);
var DESCRIPTORS = __webpack_require__(21);
var $export = __webpack_require__(17);
var redefine = __webpack_require__(83);
var META = __webpack_require__(147).KEY;
var $fails = __webpack_require__(28);
var shared = __webpack_require__(57);
var setToStringTag = __webpack_require__(59);
var uid = __webpack_require__(40);
var wks = __webpack_require__(13);
var wksExt = __webpack_require__(61);
var wksDefine = __webpack_require__(62);
var enumKeys = __webpack_require__(148);
var isArray = __webpack_require__(149);
var anObject = __webpack_require__(27);
var toIObject = __webpack_require__(25);
var toPrimitive = __webpack_require__(53);
var createDesc = __webpack_require__(39);
var _create = __webpack_require__(54);
var gOPNExt = __webpack_require__(150);
var $GOPD = __webpack_require__(89);
var $DP = __webpack_require__(20);
var $keys = __webpack_require__(33);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(88).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(42).f = $propertyIsEnumerable;
  __webpack_require__(63).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(52)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(40)('meta');
var isObject = __webpack_require__(32);
var has = __webpack_require__(22);
var setDesc = __webpack_require__(20).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(28)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(33);
var gOPS = __webpack_require__(63);
var pIE = __webpack_require__(42);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(50);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(25);
var gOPN = __webpack_require__(88).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 151 */
/***/ (function(module, exports) {



/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62)('asyncIterator');


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62)('observable');


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year())) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155)(module)))

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 156;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/* eslint-disable require-jsdoc */

var _rng;

var globalVar = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : null;

if (globalVar && globalVar.crypto && crypto.getRandomValues) {
  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
  // Moderately fast, high quality
  var _rnds8 = new Uint8Array(16);
  _rng = function whatwgRNG() {
    crypto.getRandomValues(_rnds8);
    return _rnds8;
  };
}

if (!_rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var _rnds = new Array(16);
  _rng = function _rng() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return _rnds;
  };
}

//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required

//var _rng = require('./rng');

// Maps for number <-> hex string conversion
var _byteToHex = [];
var _hexToByte = {};
for (var i = 0; i < 256; i++) {
  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
  _hexToByte[_byteToHex[i]] = i;
}

// **`parse()` - Parse a UUID into it's component bytes**
function parse(s, buf, offset) {
  var i = buf && offset || 0,
      ii = 0;

  buf = buf || [];
  s.toLowerCase().replace(/[0-9a-f]{2}/g, function (oct) {
    if (ii < 16) {
      // Don't overflow!
      buf[i + ii++] = _hexToByte[oct];
    }
  });

  // Zero out remaining bytes if string was short
  while (ii < 16) {
    buf[i + ii++] = 0;
  }

  return buf;
}

// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function unparse(buf, offset) {
  var i = offset || 0,
      bth = _byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = _rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0,
    _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; n++) {
    b[i + n] = node[n];
  }

  return buf ? buf : unparse(b);
}

// **`v4()` - Generate random UUID**

// See https://github.com/broofa/node-uuid for API details
function v4(options, buf, offset) {
  // Deprecated - 'format' argument, as supported in v1.2
  var i = buf && offset || 0;

  if (typeof options == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || _rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ii++) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || unparse(rnds);
}

// Export public API
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
uuid.parse = parse;
uuid.unparse = unparse;

module.exports = uuid;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(158)))

/***/ }),
/* 158 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// utils
exports.util = __webpack_require__(2);
exports.DOMutil = __webpack_require__(14);

// data
exports.DataSet = __webpack_require__(11);
exports.DataView = __webpack_require__(12);
exports.Queue = __webpack_require__(43);

// Graph3d
exports.Graph3d = __webpack_require__(161);
exports.graph3d = {
  Camera: __webpack_require__(95),
  Filter: __webpack_require__(96),
  Point2d: __webpack_require__(91),
  Point3d: __webpack_require__(34),
  Slider: __webpack_require__(92),
  StepNumber: __webpack_require__(93)
};

// bundled external libraries
exports.moment = __webpack_require__(9);
exports.Hammer = __webpack_require__(10);
exports.keycharm = __webpack_require__(35);

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(7);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(90);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Emitter = __webpack_require__(44);
var util = __webpack_require__(2);
var Point3d = __webpack_require__(34);
var Point2d = __webpack_require__(91);
var Slider = __webpack_require__(92);
var StepNumber = __webpack_require__(93);
var Settings = __webpack_require__(94);
var Validator = __webpack_require__(15)['default'];

var _require = __webpack_require__(15),
    printStyle = _require.printStyle;

var _require2 = __webpack_require__(172),
    allOptions = _require2.allOptions;

var DataGroup = __webpack_require__(173);

/// enumerate the available styles
Graph3d.STYLE = Settings.STYLE;

/**
 * Following label is used in the settings to describe values which should be
 * determined by the code while running, from the current data and graph style.
 *
 * Using 'undefined' directly achieves the same thing, but this is more
 * descriptive by describing the intent.
 */
var autoByDefault = undefined;

/**
 * Default values for option settings.
 *
 * These are the values used when a Graph3d instance is initialized without
 * custom settings.
 *
 * If a field is not in this list, a default value of 'autoByDefault' is assumed,
 * which is just an alias for 'undefined'.
 */
Graph3d.DEFAULTS = {
  width: '400px',
  height: '400px',
  filterLabel: 'time',
  legendLabel: 'value',
  xLabel: 'x',
  yLabel: 'y',
  zLabel: 'z',
  xValueLabel: function xValueLabel(v) {
    return v;
  },
  yValueLabel: function yValueLabel(v) {
    return v;
  },
  zValueLabel: function zValueLabel(v) {
    return v;
  },
  showXAxis: true,
  showYAxis: true,
  showZAxis: true,
  showGrid: true,
  showPerspective: true,
  showShadow: false,
  keepAspectRatio: true,
  verticalRatio: 0.5, // 0.1 to 1.0, where 1.0 results in a 'cube'

  dotSizeRatio: 0.02, // size of the dots as a fraction of the graph width
  dotSizeMinFraction: 0.5, // size of min-value dot as a fraction of dotSizeRatio	
  dotSizeMaxFraction: 2.5, // size of max-value dot as a fraction of dotSizeRatio	

  showAnimationControls: autoByDefault,
  animationInterval: 1000, // milliseconds
  animationPreload: false,
  animationAutoStart: autoByDefault,

  axisColor: '#4D4D4D',
  gridColor: '#D3D3D3',
  xCenter: '55%',
  yCenter: '50%',

  style: Graph3d.STYLE.DOT,
  tooltip: false,

  tooltipStyle: {
    content: {
      padding: '10px',
      border: '1px solid #4d4d4d',
      color: '#1a1a1a',
      background: 'rgba(255,255,255,0.7)',
      borderRadius: '2px',
      boxShadow: '5px 5px 10px rgba(128,128,128,0.5)'
    },
    line: {
      height: '40px',
      width: '0',
      borderLeft: '1px solid #4d4d4d'
    },
    dot: {
      height: '0',
      width: '0',
      border: '5px solid #4d4d4d',
      borderRadius: '5px'
    }
  },

  dataColor: {
    fill: '#7DC1FF',
    stroke: '#3267D2',
    strokeWidth: 1 // px
  },

  cameraPosition: {
    horizontal: 1.0,
    vertical: 0.5,
    distance: 1.7
  },

  /*
    The following fields are 'auto by default', see above.
   */
  showLegend: autoByDefault, // determined by graph style
  backgroundColor: autoByDefault,

  xBarWidth: autoByDefault,
  yBarWidth: autoByDefault,
  valueMin: autoByDefault,
  valueMax: autoByDefault,
  xMin: autoByDefault,
  xMax: autoByDefault,
  xStep: autoByDefault,
  yMin: autoByDefault,
  yMax: autoByDefault,
  yStep: autoByDefault,
  zMin: autoByDefault,
  zMax: autoByDefault,
  zStep: autoByDefault
};

// -----------------------------------------------------------------------------
// Class Graph3d
// -----------------------------------------------------------------------------


/**
 * Graph3d displays data in 3d.
 *
 * Graph3d is developed in javascript as a Google Visualization Chart.
 *
 * @constructor Graph3d
 * @param {Element} container   The DOM element in which the Graph3d will
 *                              be created. Normally a div element.
 * @param {DataSet | DataView | Array} [data]
 * @param {Object} [options]
 */
function Graph3d(container, data, options) {
  if (!(this instanceof Graph3d)) {
    throw new SyntaxError('Constructor must be called with the new operator');
  }

  // create variables and set default values
  this.containerElement = container;

  this.dataGroup = new DataGroup();
  this.dataPoints = null; // The table with point objects

  // create a frame and canvas
  this.create();

  Settings.setDefaults(Graph3d.DEFAULTS, this);

  // the column indexes
  this.colX = undefined;
  this.colY = undefined;
  this.colZ = undefined;
  this.colValue = undefined;

  // TODO: customize axis range

  // apply options (also when undefined)
  this.setOptions(options);

  // apply data
  this.setData(data);
}

// Extend Graph3d with an Emitter mixin
Emitter(Graph3d.prototype);

/**
 * Calculate the scaling values, dependent on the range in x, y, and z direction
 */
Graph3d.prototype._setScale = function () {
  this.scale = new Point3d(1 / this.xRange.range(), 1 / this.yRange.range(), 1 / this.zRange.range());

  // keep aspect ration between x and y scale if desired
  if (this.keepAspectRatio) {
    if (this.scale.x < this.scale.y) {
      //noinspection JSSuspiciousNameCombination
      this.scale.y = this.scale.x;
    } else {
      //noinspection JSSuspiciousNameCombination
      this.scale.x = this.scale.y;
    }
  }

  // scale the vertical axis
  this.scale.z *= this.verticalRatio;
  // TODO: can this be automated? verticalRatio?

  // determine scale for (optional) value
  if (this.valueRange !== undefined) {
    this.scale.value = 1 / this.valueRange.range();
  }

  // position the camera arm
  var xCenter = this.xRange.center() * this.scale.x;
  var yCenter = this.yRange.center() * this.scale.y;
  var zCenter = this.zRange.center() * this.scale.z;
  this.camera.setArmLocation(xCenter, yCenter, zCenter);
};

/**
 * Convert a 3D location to a 2D location on screen
 * Source: ttp://en.wikipedia.org/wiki/3D_projection
 *
 * @param   {Point3d} point3d  A 3D point with parameters x, y, z
 * @returns {Point2d} point2d  A 2D point with parameters x, y
 */
Graph3d.prototype._convert3Dto2D = function (point3d) {
  var translation = this._convertPointToTranslation(point3d);
  return this._convertTranslationToScreen(translation);
};

/**
 * Convert a 3D location its translation seen from the camera
 * Source: http://en.wikipedia.org/wiki/3D_projection
 *
 * @param   {Point3d} point3d     A 3D point with parameters x, y, z
 * @returns {Point3d} translation A 3D point with parameters x, y, z This is
 *                                the translation of the point, seen from the
 *                                camera.
 */
Graph3d.prototype._convertPointToTranslation = function (point3d) {
  var cameraLocation = this.camera.getCameraLocation(),
      cameraRotation = this.camera.getCameraRotation(),
      ax = point3d.x * this.scale.x,
      ay = point3d.y * this.scale.y,
      az = point3d.z * this.scale.z,
      cx = cameraLocation.x,
      cy = cameraLocation.y,
      cz = cameraLocation.z,


  // calculate angles
  sinTx = Math.sin(cameraRotation.x),
      cosTx = Math.cos(cameraRotation.x),
      sinTy = Math.sin(cameraRotation.y),
      cosTy = Math.cos(cameraRotation.y),
      sinTz = Math.sin(cameraRotation.z),
      cosTz = Math.cos(cameraRotation.z),


  // calculate translation
  dx = cosTy * (sinTz * (ay - cy) + cosTz * (ax - cx)) - sinTy * (az - cz),
      dy = sinTx * (cosTy * (az - cz) + sinTy * (sinTz * (ay - cy) + cosTz * (ax - cx))) + cosTx * (cosTz * (ay - cy) - sinTz * (ax - cx)),
      dz = cosTx * (cosTy * (az - cz) + sinTy * (sinTz * (ay - cy) + cosTz * (ax - cx))) - sinTx * (cosTz * (ay - cy) - sinTz * (ax - cx));

  return new Point3d(dx, dy, dz);
};

/**
 * Convert a translation point to a point on the screen
 *
 * @param   {Point3d} translation A 3D point with parameters x, y, z This is
 *                                the translation of the point, seen from the
 *                                camera.
 * @returns {Point2d} point2d     A 2D point with parameters x, y
 */
Graph3d.prototype._convertTranslationToScreen = function (translation) {
  var ex = this.eye.x,
      ey = this.eye.y,
      ez = this.eye.z,
      dx = translation.x,
      dy = translation.y,
      dz = translation.z;

  // calculate position on screen from translation
  var bx;
  var by;
  if (this.showPerspective) {
    bx = (dx - ex) * (ez / dz);
    by = (dy - ey) * (ez / dz);
  } else {
    bx = dx * -(ez / this.camera.getArmLength());
    by = dy * -(ez / this.camera.getArmLength());
  }

  // shift and scale the point to the center of the screen
  // use the width of the graph to scale both horizontally and vertically.
  return new Point2d(this.currentXCenter + bx * this.frame.canvas.clientWidth, this.currentYCenter - by * this.frame.canvas.clientWidth);
};

/**
 * Calculate the translations and screen positions of all points
 *
 * @param {Array.<Point3d>} points
 * @private
 */
Graph3d.prototype._calcTranslations = function (points) {
  for (var i = 0; i < points.length; i++) {
    var point = points[i];
    point.trans = this._convertPointToTranslation(point.point);
    point.screen = this._convertTranslationToScreen(point.trans);

    // calculate the translation of the point at the bottom (needed for sorting)
    var transBottom = this._convertPointToTranslation(point.bottom);
    point.dist = this.showPerspective ? transBottom.length() : -transBottom.z;
  }

  // sort the points on depth of their (x,y) position (not on z)
  var sortDepth = function sortDepth(a, b) {
    return b.dist - a.dist;
  };
  points.sort(sortDepth);
};

/**
 * Transfer min/max values to the Graph3d instance.
 */
Graph3d.prototype._initializeRanges = function () {
  // TODO: later on, all min/maxes of all datagroups will be combined here
  var dg = this.dataGroup;
  this.xRange = dg.xRange;
  this.yRange = dg.yRange;
  this.zRange = dg.zRange;
  this.valueRange = dg.valueRange;

  // Values currently needed but which need to be sorted out for
  // the multiple graph case.
  this.xStep = dg.xStep;
  this.yStep = dg.yStep;
  this.zStep = dg.zStep;
  this.xBarWidth = dg.xBarWidth;
  this.yBarWidth = dg.yBarWidth;
  this.colX = dg.colX;
  this.colY = dg.colY;
  this.colZ = dg.colZ;
  this.colValue = dg.colValue;

  // set the scale dependent on the ranges.
  this._setScale();
};

/**
 * Return all data values as a list of Point3d objects
 *
 * @param {vis.DataSet} data
 * @returns {Array.<Object>}
 */
Graph3d.prototype.getDataPoints = function (data) {
  var dataPoints = [];

  for (var i = 0; i < data.length; i++) {
    var point = new Point3d();
    point.x = data[i][this.colX] || 0;
    point.y = data[i][this.colY] || 0;
    point.z = data[i][this.colZ] || 0;
    point.data = data[i];

    if (this.colValue !== undefined) {
      point.value = data[i][this.colValue] || 0;
    }

    var obj = {};
    obj.point = point;
    obj.bottom = new Point3d(point.x, point.y, this.zRange.min);
    obj.trans = undefined;
    obj.screen = undefined;

    dataPoints.push(obj);
  }

  return dataPoints;
};

/**
 * Filter the data based on the current filter
 *
 * @param   {Array} data
 * @returns {Array} dataPoints Array with point objects which can be drawn on
 *                             screen
 */
Graph3d.prototype._getDataPoints = function (data) {
  // TODO: store the created matrix dataPoints in the filters instead of
  //       reloading each time.
  var x, y, i, obj;

  var dataPoints = [];

  if (this.style === Graph3d.STYLE.GRID || this.style === Graph3d.STYLE.SURFACE) {
    // copy all values from the data table to a matrix
    // the provided values are supposed to form a grid of (x,y) positions

    // create two lists with all present x and y values
    var dataX = this.dataGroup.getDistinctValues(this.colX, data);
    var dataY = this.dataGroup.getDistinctValues(this.colY, data);

    dataPoints = this.getDataPoints(data);

    // create a grid, a 2d matrix, with all values.
    var dataMatrix = []; // temporary data matrix
    for (i = 0; i < dataPoints.length; i++) {
      obj = dataPoints[i];

      // TODO: implement Array().indexOf() for Internet Explorer
      var xIndex = dataX.indexOf(obj.point.x);
      var yIndex = dataY.indexOf(obj.point.y);

      if (dataMatrix[xIndex] === undefined) {
        dataMatrix[xIndex] = [];
      }

      dataMatrix[xIndex][yIndex] = obj;
    }

    // fill in the pointers to the neighbors.
    for (x = 0; x < dataMatrix.length; x++) {
      for (y = 0; y < dataMatrix[x].length; y++) {
        if (dataMatrix[x][y]) {
          dataMatrix[x][y].pointRight = x < dataMatrix.length - 1 ? dataMatrix[x + 1][y] : undefined;
          dataMatrix[x][y].pointTop = y < dataMatrix[x].length - 1 ? dataMatrix[x][y + 1] : undefined;
          dataMatrix[x][y].pointCross = x < dataMatrix.length - 1 && y < dataMatrix[x].length - 1 ? dataMatrix[x + 1][y + 1] : undefined;
        }
      }
    }
  } else {
    // 'dot', 'dot-line', etc.
    this._checkValueField(data);
    dataPoints = this.getDataPoints(data);

    if (this.style === Graph3d.STYLE.LINE) {
      // Add next member points for line drawing
      for (i = 0; i < dataPoints.length; i++) {
        if (i > 0) {
          dataPoints[i - 1].pointNext = dataPoints[i];
        }
      }
    }
  }

  return dataPoints;
};

/**
 * Create the main frame for the Graph3d.
 *
 * This function is executed once when a Graph3d object is created. The frame
 * contains a canvas, and this canvas contains all objects like the axis and
 * nodes.
 */
Graph3d.prototype.create = function () {
  // remove all elements from the container element.
  while (this.containerElement.hasChildNodes()) {
    this.containerElement.removeChild(this.containerElement.firstChild);
  }

  this.frame = document.createElement('div');
  this.frame.style.position = 'relative';
  this.frame.style.overflow = 'hidden';

  // create the graph canvas (HTML canvas element)
  this.frame.canvas = document.createElement('canvas');
  this.frame.canvas.style.position = 'relative';
  this.frame.appendChild(this.frame.canvas);
  //if (!this.frame.canvas.getContext) {
  {
    var noCanvas = document.createElement('DIV');
    noCanvas.style.color = 'red';
    noCanvas.style.fontWeight = 'bold';
    noCanvas.style.padding = '10px';
    noCanvas.innerHTML = 'Error: your browser does not support HTML canvas';
    this.frame.canvas.appendChild(noCanvas);
  }

  this.frame.filter = document.createElement('div');
  this.frame.filter.style.position = 'absolute';
  this.frame.filter.style.bottom = '0px';
  this.frame.filter.style.left = '0px';
  this.frame.filter.style.width = '100%';
  this.frame.appendChild(this.frame.filter);

  // add event listeners to handle moving and zooming the contents
  var me = this;
  var onmousedown = function onmousedown(event) {
    me._onMouseDown(event);
  };
  var ontouchstart = function ontouchstart(event) {
    me._onTouchStart(event);
  };
  var onmousewheel = function onmousewheel(event) {
    me._onWheel(event);
  };
  var ontooltip = function ontooltip(event) {
    me._onTooltip(event);
  };
  var onclick = function onclick(event) {
    me._onClick(event);
  };
  // TODO: these events are never cleaned up... can give a 'memory leakage'

  util.addEventListener(this.frame.canvas, 'mousedown', onmousedown);
  util.addEventListener(this.frame.canvas, 'touchstart', ontouchstart);
  util.addEventListener(this.frame.canvas, 'mousewheel', onmousewheel);
  util.addEventListener(this.frame.canvas, 'mousemove', ontooltip);
  util.addEventListener(this.frame.canvas, 'click', onclick);

  // add the new graph to the container element
  this.containerElement.appendChild(this.frame);
};

/**
 * Set a new size for the graph
 *
 * @param {number} width
 * @param {number} height
 * @private
 */
Graph3d.prototype._setSize = function (width, height) {
  this.frame.style.width = width;
  this.frame.style.height = height;

  this._resizeCanvas();
};

/**
 * Resize the canvas to the current size of the frame
 */
Graph3d.prototype._resizeCanvas = function () {
  this.frame.canvas.style.width = '100%';
  this.frame.canvas.style.height = '100%';

  this.frame.canvas.width = this.frame.canvas.clientWidth;
  this.frame.canvas.height = this.frame.canvas.clientHeight;

  // adjust with for margin
  this.frame.filter.style.width = this.frame.canvas.clientWidth - 2 * 10 + 'px';
};

/**
 * Start playing the animation, if requested and filter present. Only applicable
 * when animation data is available.
 */
Graph3d.prototype.animationStart = function () {
  // start animation when option is true
  if (!this.animationAutoStart || !this.dataGroup.dataFilter) return;

  if (!this.frame.filter || !this.frame.filter.slider) throw new Error('No animation available');

  this.frame.filter.slider.play();
};

/**
 * Stop animation
 */
Graph3d.prototype.animationStop = function () {
  if (!this.frame.filter || !this.frame.filter.slider) return;

  this.frame.filter.slider.stop();
};

/**
 * Resize the center position based on the current values in this.xCenter
 * and this.yCenter (which are strings with a percentage or a value
 * in pixels). The center positions are the variables this.currentXCenter
 * and this.currentYCenter
 */
Graph3d.prototype._resizeCenter = function () {
  // calculate the horizontal center position
  if (this.xCenter.charAt(this.xCenter.length - 1) === '%') {
    this.currentXCenter = parseFloat(this.xCenter) / 100 * this.frame.canvas.clientWidth;
  } else {
    this.currentXCenter = parseFloat(this.xCenter); // supposed to be in px
  }

  // calculate the vertical center position
  if (this.yCenter.charAt(this.yCenter.length - 1) === '%') {
    this.currentYCenter = parseFloat(this.yCenter) / 100 * (this.frame.canvas.clientHeight - this.frame.filter.clientHeight);
  } else {
    this.currentYCenter = parseFloat(this.yCenter); // supposed to be in px
  }
};

/**
 * Retrieve the current camera rotation
 *
 * @returns {object} An object with parameters horizontal, vertical, and
 *                   distance
 */
Graph3d.prototype.getCameraPosition = function () {
  var pos = this.camera.getArmRotation();
  pos.distance = this.camera.getArmLength();
  return pos;
};

/**
 * Load data into the 3D Graph
 *
 * @param {vis.DataSet} data
 * @private
 */
Graph3d.prototype._readData = function (data) {
  // read the data
  this.dataPoints = this.dataGroup.initializeData(this, data, this.style);

  this._initializeRanges();
  this._redrawFilter();
};

/**
 * Replace the dataset of the Graph3d
 *
 * @param {Array | DataSet | DataView} data
 */
Graph3d.prototype.setData = function (data) {
  if (data === undefined || data === null) return;

  this._readData(data);
  this.redraw();
  this.animationStart();
};

/**
 * Update the options. Options will be merged with current options
 *
 * @param {Object} options
 */
Graph3d.prototype.setOptions = function (options) {
  if (options === undefined) return;

  var errorFound = Validator.validate(options, allOptions);
  if (errorFound === true) {
    console.log('%cErrors have been found in the supplied options object.', printStyle);
  }

  this.animationStop();

  Settings.setOptions(options, this);
  this.setPointDrawingMethod();
  this._setSize(this.width, this.height);

  this.setData(this.dataGroup.getDataTable());
  this.animationStart();
};

/**
 * Determine which point drawing method to use for the current graph style.
 */
Graph3d.prototype.setPointDrawingMethod = function () {
  var method = undefined;

  switch (this.style) {
    case Graph3d.STYLE.BAR:
      method = Graph3d.prototype._redrawBarGraphPoint;
      break;
    case Graph3d.STYLE.BARCOLOR:
      method = Graph3d.prototype._redrawBarColorGraphPoint;
      break;
    case Graph3d.STYLE.BARSIZE:
      method = Graph3d.prototype._redrawBarSizeGraphPoint;
      break;
    case Graph3d.STYLE.DOT:
      method = Graph3d.prototype._redrawDotGraphPoint;
      break;
    case Graph3d.STYLE.DOTLINE:
      method = Graph3d.prototype._redrawDotLineGraphPoint;
      break;
    case Graph3d.STYLE.DOTCOLOR:
      method = Graph3d.prototype._redrawDotColorGraphPoint;
      break;
    case Graph3d.STYLE.DOTSIZE:
      method = Graph3d.prototype._redrawDotSizeGraphPoint;
      break;
    case Graph3d.STYLE.SURFACE:
      method = Graph3d.prototype._redrawSurfaceGraphPoint;
      break;
    case Graph3d.STYLE.GRID:
      method = Graph3d.prototype._redrawGridGraphPoint;
      break;
    case Graph3d.STYLE.LINE:
      method = Graph3d.prototype._redrawLineGraphPoint;
      break;
    default:
      throw new Error('Can not determine point drawing method ' + 'for graph style \'' + this.style + '\'');
  }

  this._pointDrawingMethod = method;
};

/**
 * Redraw the Graph.
 */
Graph3d.prototype.redraw = function () {
  if (this.dataPoints === undefined) {
    throw new Error('Graph data not initialized');
  }

  this._resizeCanvas();
  this._resizeCenter();
  this._redrawSlider();
  this._redrawClear();
  this._redrawAxis();

  this._redrawDataGraph();

  this._redrawInfo();
  this._redrawLegend();
};

/**
 * Get drawing context without exposing canvas
 *
 * @returns {CanvasRenderingContext2D}
 * @private
 */
Graph3d.prototype._getContext = function () {
  var canvas = this.frame.canvas;
  var ctx = canvas.getContext('2d');

  ctx.lineJoin = 'round';
  ctx.lineCap = 'round';

  return ctx;
};

/**
 * Clear the canvas before redrawing
 */
Graph3d.prototype._redrawClear = function () {
  var canvas = this.frame.canvas;
  var ctx = canvas.getContext('2d');

  ctx.clearRect(0, 0, canvas.width, canvas.height);
};

Graph3d.prototype._dotSize = function () {
  return this.frame.clientWidth * this.dotSizeRatio;
};

/**
 * Get legend width
 *
 * @returns {*}
 * @private
 */
Graph3d.prototype._getLegendWidth = function () {
  var width;

  if (this.style === Graph3d.STYLE.DOTSIZE) {
    var dotSize = this._dotSize();
    //width =  dotSize / 2 + dotSize * 2;
    width = dotSize * this.dotSizeMaxFraction;
  } else if (this.style === Graph3d.STYLE.BARSIZE) {
    width = this.xBarWidth;
  } else {
    width = 20;
  }
  return width;
};

/**
 * Redraw the legend based on size, dot color, or surface height
 */
Graph3d.prototype._redrawLegend = function () {

  //Return without drawing anything, if no legend is specified
  if (this.showLegend !== true) {
    return;
  }

  // Do not draw legend when graph style does not support
  if (this.style === Graph3d.STYLE.LINE || this.style === Graph3d.STYLE.BARSIZE //TODO add legend support for BARSIZE
  ) {
      return;
    }

  // Legend types - size and color. Determine if size legend.
  var isSizeLegend = this.style === Graph3d.STYLE.BARSIZE || this.style === Graph3d.STYLE.DOTSIZE;

  // Legend is either tracking z values or style values. This flag if false means use z values.
  var isValueLegend = this.style === Graph3d.STYLE.DOTSIZE || this.style === Graph3d.STYLE.DOTCOLOR || this.style === Graph3d.STYLE.BARCOLOR;

  var height = Math.max(this.frame.clientHeight * 0.25, 100);
  var top = this.margin;
  var width = this._getLegendWidth(); // px - overwritten by size legend
  var right = this.frame.clientWidth - this.margin;
  var left = right - width;
  var bottom = top + height;

  var ctx = this._getContext();
  ctx.lineWidth = 1;
  ctx.font = '14px arial'; // TODO: put in options

  if (isSizeLegend === false) {
    // draw the color bar
    var ymin = 0;
    var ymax = height; // Todo: make height customizable
    var y;

    for (y = ymin; y < ymax; y++) {
      var f = (y - ymin) / (ymax - ymin);
      var hue = f * 240;
      var color = this._hsv2rgb(hue, 1, 1);

      ctx.strokeStyle = color;
      ctx.beginPath();
      ctx.moveTo(left, top + y);
      ctx.lineTo(right, top + y);
      ctx.stroke();
    }
    ctx.strokeStyle = this.axisColor;
    ctx.strokeRect(left, top, width, height);
  } else {

    // draw the size legend box
    var widthMin;
    if (this.style === Graph3d.STYLE.DOTSIZE) {
      // Get the proportion to max and min right
      widthMin = width * (this.dotSizeMinFraction / this.dotSizeMaxFraction);
    } else if (this.style === Graph3d.STYLE.BARSIZE) {
      //widthMin = this.xBarWidth * 0.2 this is wrong - barwidth measures in terms of xvalues
    }
    ctx.strokeStyle = this.axisColor;
    ctx.fillStyle = this.dataColor.fill;
    ctx.beginPath();
    ctx.moveTo(left, top);
    ctx.lineTo(right, top);
    ctx.lineTo(left + widthMin, bottom);
    ctx.lineTo(left, bottom);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }

  // print value text along the legend edge
  var gridLineLen = 5; // px

  var legendMin = isValueLegend ? this.valueRange.min : this.zRange.min;
  var legendMax = isValueLegend ? this.valueRange.max : this.zRange.max;
  var step = new StepNumber(legendMin, legendMax, (legendMax - legendMin) / 5, true);
  step.start(true);

  var from;
  var to;
  while (!step.end()) {
    y = bottom - (step.getCurrent() - legendMin) / (legendMax - legendMin) * height;
    from = new Point2d(left - gridLineLen, y);
    to = new Point2d(left, y);
    this._line(ctx, from, to);

    ctx.textAlign = 'right';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = this.axisColor;
    ctx.fillText(step.getCurrent(), left - 2 * gridLineLen, y);

    step.next();
  }

  ctx.textAlign = 'right';
  ctx.textBaseline = 'top';
  var label = this.legendLabel;
  ctx.fillText(label, right, bottom + this.margin);
};

/**
 * Redraw the filter
 */
Graph3d.prototype._redrawFilter = function () {
  var dataFilter = this.dataGroup.dataFilter;
  var filter = this.frame.filter;
  filter.innerHTML = '';

  if (!dataFilter) {
    filter.slider = undefined;
    return;
  }

  var options = {
    'visible': this.showAnimationControls
  };
  var slider = new Slider(filter, options);
  filter.slider = slider;

  // TODO: css here is not nice here...
  filter.style.padding = '10px';
  //this.frame.filter.style.backgroundColor = '#EFEFEF';

  slider.setValues(dataFilter.values);
  slider.setPlayInterval(this.animationInterval);

  // create an event handler
  var me = this;
  var onchange = function onchange() {
    var dataFilter = me.dataGroup.dataFilter;
    var index = slider.getIndex();

    dataFilter.selectValue(index);
    me.dataPoints = dataFilter._getDataPoints();

    me.redraw();
  };

  slider.setOnChangeCallback(onchange);
};

/**
 * Redraw the slider
 */
Graph3d.prototype._redrawSlider = function () {
  if (this.frame.filter.slider !== undefined) {
    this.frame.filter.slider.redraw();
  }
};

/**
 * Redraw common information
 */
Graph3d.prototype._redrawInfo = function () {
  var info = this.dataGroup.getInfo();
  if (info === undefined) return;

  var ctx = this._getContext();

  ctx.font = '14px arial'; // TODO: put in options
  ctx.lineStyle = 'gray';
  ctx.fillStyle = 'gray';
  ctx.textAlign = 'left';
  ctx.textBaseline = 'top';

  var x = this.margin;
  var y = this.margin;
  ctx.fillText(info, x, y);
};

/**
 * Draw a line between 2d points 'from' and 'to'.
 *
 * If stroke style specified, set that as well.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {vis.Point2d} from
 * @param {vis.Point2d} to
 * @param {string} [strokeStyle]
 * @private
 */
Graph3d.prototype._line = function (ctx, from, to, strokeStyle) {
  if (strokeStyle !== undefined) {
    ctx.strokeStyle = strokeStyle;
  }

  ctx.beginPath();
  ctx.moveTo(from.x, from.y);
  ctx.lineTo(to.x, to.y);
  ctx.stroke();
};

/**
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {vis.Point3d} point3d
 * @param {string} text
 * @param {number} armAngle
 * @param {number} [yMargin=0]
 */
Graph3d.prototype.drawAxisLabelX = function (ctx, point3d, text, armAngle, yMargin) {
  if (yMargin === undefined) {
    yMargin = 0;
  }

  var point2d = this._convert3Dto2D(point3d);

  if (Math.cos(armAngle * 2) > 0) {
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    point2d.y += yMargin;
  } else if (Math.sin(armAngle * 2) < 0) {
    ctx.textAlign = 'right';
    ctx.textBaseline = 'middle';
  } else {
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
  }

  ctx.fillStyle = this.axisColor;
  ctx.fillText(text, point2d.x, point2d.y);
};

/**
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {vis.Point3d} point3d
 * @param {string} text
 * @param {number} armAngle
 * @param {number} [yMargin=0]
 */
Graph3d.prototype.drawAxisLabelY = function (ctx, point3d, text, armAngle, yMargin) {
  if (yMargin === undefined) {
    yMargin = 0;
  }

  var point2d = this._convert3Dto2D(point3d);

  if (Math.cos(armAngle * 2) < 0) {
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    point2d.y += yMargin;
  } else if (Math.sin(armAngle * 2) > 0) {
    ctx.textAlign = 'right';
    ctx.textBaseline = 'middle';
  } else {
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
  }

  ctx.fillStyle = this.axisColor;
  ctx.fillText(text, point2d.x, point2d.y);
};

/**
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {vis.Point3d} point3d
 * @param {string} text
 * @param {number} [offset=0]
 */
Graph3d.prototype.drawAxisLabelZ = function (ctx, point3d, text, offset) {
  if (offset === undefined) {
    offset = 0;
  }

  var point2d = this._convert3Dto2D(point3d);
  ctx.textAlign = 'right';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = this.axisColor;
  ctx.fillText(text, point2d.x - offset, point2d.y);
};

/**


/**
 * Draw a line between 2d points 'from' and 'to'.
 *
 * If stroke style specified, set that as well.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {vis.Point2d} from
 * @param {vis.Point2d} to
 * @param {string} [strokeStyle]
 * @private
 */
Graph3d.prototype._line3d = function (ctx, from, to, strokeStyle) {
  var from2d = this._convert3Dto2D(from);
  var to2d = this._convert3Dto2D(to);

  this._line(ctx, from2d, to2d, strokeStyle);
};

/**
 * Redraw the axis
 */
Graph3d.prototype._redrawAxis = function () {
  var ctx = this._getContext(),
      from,
      to,
      step,
      prettyStep,
      text,
      xText,
      yText,
      zText,
      offset,
      xOffset,
      yOffset;

  // TODO: get the actual rendered style of the containerElement
  //ctx.font = this.containerElement.style.font;
  ctx.font = 24 / this.camera.getArmLength() + 'px arial';

  // calculate the length for the short grid lines
  var gridLenX = 0.025 / this.scale.x;
  var gridLenY = 0.025 / this.scale.y;
  var textMargin = 5 / this.camera.getArmLength(); // px
  var armAngle = this.camera.getArmRotation().horizontal;
  var armVector = new Point2d(Math.cos(armAngle), Math.sin(armAngle));

  var xRange = this.xRange;
  var yRange = this.yRange;
  var zRange = this.zRange;
  var point3d;

  // draw x-grid lines
  ctx.lineWidth = 1;
  prettyStep = this.defaultXStep === undefined;
  step = new StepNumber(xRange.min, xRange.max, this.xStep, prettyStep);
  step.start(true);

  while (!step.end()) {
    var x = step.getCurrent();

    if (this.showGrid) {
      from = new Point3d(x, yRange.min, zRange.min);
      to = new Point3d(x, yRange.max, zRange.min);
      this._line3d(ctx, from, to, this.gridColor);
    } else if (this.showXAxis) {
      from = new Point3d(x, yRange.min, zRange.min);
      to = new Point3d(x, yRange.min + gridLenX, zRange.min);
      this._line3d(ctx, from, to, this.axisColor);

      from = new Point3d(x, yRange.max, zRange.min);
      to = new Point3d(x, yRange.max - gridLenX, zRange.min);
      this._line3d(ctx, from, to, this.axisColor);
    }

    if (this.showXAxis) {
      yText = armVector.x > 0 ? yRange.min : yRange.max;
      point3d = new Point3d(x, yText, zRange.min);
      var msg = '  ' + this.xValueLabel(x) + '  ';
      this.drawAxisLabelX(ctx, point3d, msg, armAngle, textMargin);
    }

    step.next();
  }

  // draw y-grid lines
  ctx.lineWidth = 1;
  prettyStep = this.defaultYStep === undefined;
  step = new StepNumber(yRange.min, yRange.max, this.yStep, prettyStep);
  step.start(true);

  while (!step.end()) {
    var y = step.getCurrent();

    if (this.showGrid) {
      from = new Point3d(xRange.min, y, zRange.min);
      to = new Point3d(xRange.max, y, zRange.min);
      this._line3d(ctx, from, to, this.gridColor);
    } else if (this.showYAxis) {
      from = new Point3d(xRange.min, y, zRange.min);
      to = new Point3d(xRange.min + gridLenY, y, zRange.min);
      this._line3d(ctx, from, to, this.axisColor);

      from = new Point3d(xRange.max, y, zRange.min);
      to = new Point3d(xRange.max - gridLenY, y, zRange.min);
      this._line3d(ctx, from, to, this.axisColor);
    }

    if (this.showYAxis) {
      xText = armVector.y > 0 ? xRange.min : xRange.max;
      point3d = new Point3d(xText, y, zRange.min);
      var _msg = '  ' + this.yValueLabel(y) + '  ';
      this.drawAxisLabelY(ctx, point3d, _msg, armAngle, textMargin);
    }

    step.next();
  }

  // draw z-grid lines and axis
  if (this.showZAxis) {
    ctx.lineWidth = 1;
    prettyStep = this.defaultZStep === undefined;
    step = new StepNumber(zRange.min, zRange.max, this.zStep, prettyStep);
    step.start(true);

    xText = armVector.x > 0 ? xRange.min : xRange.max;
    yText = armVector.y < 0 ? yRange.min : yRange.max;

    while (!step.end()) {
      var z = step.getCurrent();

      // TODO: make z-grid lines really 3d?
      var from3d = new Point3d(xText, yText, z);
      var from2d = this._convert3Dto2D(from3d);
      to = new Point2d(from2d.x - textMargin, from2d.y);
      this._line(ctx, from2d, to, this.axisColor);

      var _msg2 = this.zValueLabel(z) + ' ';
      this.drawAxisLabelZ(ctx, from3d, _msg2, 5);

      step.next();
    }

    ctx.lineWidth = 1;
    from = new Point3d(xText, yText, zRange.min);
    to = new Point3d(xText, yText, zRange.max);
    this._line3d(ctx, from, to, this.axisColor);
  }

  // draw x-axis
  if (this.showXAxis) {
    var xMin2d;
    var xMax2d;
    ctx.lineWidth = 1;

    // line at yMin
    xMin2d = new Point3d(xRange.min, yRange.min, zRange.min);
    xMax2d = new Point3d(xRange.max, yRange.min, zRange.min);
    this._line3d(ctx, xMin2d, xMax2d, this.axisColor);
    // line at ymax
    xMin2d = new Point3d(xRange.min, yRange.max, zRange.min);
    xMax2d = new Point3d(xRange.max, yRange.max, zRange.min);
    this._line3d(ctx, xMin2d, xMax2d, this.axisColor);
  }

  // draw y-axis
  if (this.showYAxis) {
    ctx.lineWidth = 1;
    // line at xMin
    from = new Point3d(xRange.min, yRange.min, zRange.min);
    to = new Point3d(xRange.min, yRange.max, zRange.min);
    this._line3d(ctx, from, to, this.axisColor);
    // line at xMax
    from = new Point3d(xRange.max, yRange.min, zRange.min);
    to = new Point3d(xRange.max, yRange.max, zRange.min);
    this._line3d(ctx, from, to, this.axisColor);
  }

  // draw x-label
  var xLabel = this.xLabel;
  if (xLabel.length > 0 && this.showXAxis) {
    yOffset = 0.1 / this.scale.y;
    xText = (xRange.max + 3 * xRange.min) / 4;
    yText = armVector.x > 0 ? yRange.min - yOffset : yRange.max + yOffset;
    text = new Point3d(xText, yText, zRange.min);
    this.drawAxisLabelX(ctx, text, xLabel, armAngle);
  }

  // draw y-label
  var yLabel = this.yLabel;
  if (yLabel.length > 0 && this.showYAxis) {
    xOffset = 0.1 / this.scale.x;
    xText = armVector.y > 0 ? xRange.min - xOffset : xRange.max + xOffset;
    yText = (yRange.max + 3 * yRange.min) / 4;
    text = new Point3d(xText, yText, zRange.min);

    this.drawAxisLabelY(ctx, text, yLabel, armAngle);
  }

  // draw z-label
  var zLabel = this.zLabel;
  if (zLabel.length > 0 && this.showZAxis) {
    offset = 30; // pixels.  // TODO: relate to the max width of the values on the z axis?
    xText = armVector.x > 0 ? xRange.min : xRange.max;
    yText = armVector.y < 0 ? yRange.min : yRange.max;
    zText = (zRange.max + 3 * zRange.min) / 4;
    text = new Point3d(xText, yText, zText);

    this.drawAxisLabelZ(ctx, text, zLabel, offset);
  }
};

/**
 * Calculate the color based on the given value.
 * @param {number} H   Hue, a value be between 0 and 360
 * @param {number} S   Saturation, a value between 0 and 1
 * @param {number} V   Value, a value between 0 and 1
 * @returns {string}
 * @private
 */
Graph3d.prototype._hsv2rgb = function (H, S, V) {
  var R, G, B, C, Hi, X;

  C = V * S;
  Hi = Math.floor(H / 60); // hi = 0,1,2,3,4,5
  X = C * (1 - Math.abs(H / 60 % 2 - 1));

  switch (Hi) {
    case 0:
      R = C;G = X;B = 0;break;
    case 1:
      R = X;G = C;B = 0;break;
    case 2:
      R = 0;G = C;B = X;break;
    case 3:
      R = 0;G = X;B = C;break;
    case 4:
      R = X;G = 0;B = C;break;
    case 5:
      R = C;G = 0;B = X;break;

    default:
      R = 0;G = 0;B = 0;break;
  }

  return 'RGB(' + parseInt(R * 255) + ',' + parseInt(G * 255) + ',' + parseInt(B * 255) + ')';
};

/**
 *
 * @param {vis.Point3d} point
 * @returns {*}
 * @private
 */
Graph3d.prototype._getStrokeWidth = function (point) {
  if (point !== undefined) {
    if (this.showPerspective) {
      return 1 / -point.trans.z * this.dataColor.strokeWidth;
    } else {
      return -(this.eye.z / this.camera.getArmLength()) * this.dataColor.strokeWidth;
    }
  }

  return this.dataColor.strokeWidth;
};

// -----------------------------------------------------------------------------
// Drawing primitives for the graphs
// -----------------------------------------------------------------------------


/**
 * Draw a bar element in the view with the given properties.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @param {number} xWidth
 * @param {number} yWidth
 * @param {string} color
 * @param {string} borderColor
 * @private
 */
Graph3d.prototype._redrawBar = function (ctx, point, xWidth, yWidth, color, borderColor) {
  var surface;

  // calculate all corner points
  var me = this;
  var point3d = point.point;
  var zMin = this.zRange.min;
  var top = [{ point: new Point3d(point3d.x - xWidth, point3d.y - yWidth, point3d.z) }, { point: new Point3d(point3d.x + xWidth, point3d.y - yWidth, point3d.z) }, { point: new Point3d(point3d.x + xWidth, point3d.y + yWidth, point3d.z) }, { point: new Point3d(point3d.x - xWidth, point3d.y + yWidth, point3d.z) }];
  var bottom = [{ point: new Point3d(point3d.x - xWidth, point3d.y - yWidth, zMin) }, { point: new Point3d(point3d.x + xWidth, point3d.y - yWidth, zMin) }, { point: new Point3d(point3d.x + xWidth, point3d.y + yWidth, zMin) }, { point: new Point3d(point3d.x - xWidth, point3d.y + yWidth, zMin) }];

  // calculate screen location of the points
  top.forEach(function (obj) {
    obj.screen = me._convert3Dto2D(obj.point);
  });
  bottom.forEach(function (obj) {
    obj.screen = me._convert3Dto2D(obj.point);
  });

  // create five sides, calculate both corner points and center points
  var surfaces = [{ corners: top, center: Point3d.avg(bottom[0].point, bottom[2].point) }, { corners: [top[0], top[1], bottom[1], bottom[0]], center: Point3d.avg(bottom[1].point, bottom[0].point) }, { corners: [top[1], top[2], bottom[2], bottom[1]], center: Point3d.avg(bottom[2].point, bottom[1].point) }, { corners: [top[2], top[3], bottom[3], bottom[2]], center: Point3d.avg(bottom[3].point, bottom[2].point) }, { corners: [top[3], top[0], bottom[0], bottom[3]], center: Point3d.avg(bottom[0].point, bottom[3].point) }];
  point.surfaces = surfaces;

  // calculate the distance of each of the surface centers to the camera
  for (var j = 0; j < surfaces.length; j++) {
    surface = surfaces[j];
    var transCenter = this._convertPointToTranslation(surface.center);
    surface.dist = this.showPerspective ? transCenter.length() : -transCenter.z;
    // TODO: this dept calculation doesn't work 100% of the cases due to perspective,
    //     but the current solution is fast/simple and works in 99.9% of all cases
    //     the issue is visible in example 14, with graph.setCameraPosition({horizontal: 2.97, vertical: 0.5, distance: 0.9})
  }

  // order the surfaces by their (translated) depth
  surfaces.sort(function (a, b) {
    var diff = b.dist - a.dist;
    if (diff) return diff;

    // if equal depth, sort the top surface last
    if (a.corners === top) return 1;
    if (b.corners === top) return -1;

    // both are equal
    return 0;
  });

  // draw the ordered surfaces
  ctx.lineWidth = this._getStrokeWidth(point);
  ctx.strokeStyle = borderColor;
  ctx.fillStyle = color;
  // NOTE: we start at j=2 instead of j=0 as we don't need to draw the two surfaces at the backside
  for (var _j = 2; _j < surfaces.length; _j++) {
    surface = surfaces[_j];
    this._polygon(ctx, surface.corners);
  }
};

/**
 * Draw a polygon using the passed points and fill it with the passed style and stroke.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Array.<vis.Point3d>} points      an array of points.
 * @param {string} [fillStyle] the fill style to set
 * @param {string} [strokeStyle] the stroke style to set
 */
Graph3d.prototype._polygon = function (ctx, points, fillStyle, strokeStyle) {
  if (points.length < 2) {
    return;
  }

  if (fillStyle !== undefined) {
    ctx.fillStyle = fillStyle;
  }
  if (strokeStyle !== undefined) {
    ctx.strokeStyle = strokeStyle;
  }
  ctx.beginPath();
  ctx.moveTo(points[0].screen.x, points[0].screen.y);

  for (var i = 1; i < points.length; ++i) {
    var point = points[i];
    ctx.lineTo(point.screen.x, point.screen.y);
  }

  ctx.closePath();
  ctx.fill();
  ctx.stroke(); // TODO: only draw stroke when strokeWidth > 0
};

/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {object} point
 * @param {string} color
 * @param {string} borderColor
 * @param {number} [size=this._dotSize()]
 * @private
 */
Graph3d.prototype._drawCircle = function (ctx, point, color, borderColor, size) {
  var radius = this._calcRadius(point, size);

  ctx.lineWidth = this._getStrokeWidth(point);
  ctx.strokeStyle = borderColor;
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.arc(point.screen.x, point.screen.y, radius, 0, Math.PI * 2, true);
  ctx.fill();
  ctx.stroke();
};

/**
 * Determine the colors for the 'regular' graph styles.
 *
 * @param {object} point
 * @returns {{fill, border}}
 * @private
 */
Graph3d.prototype._getColorsRegular = function (point) {
  // calculate Hue from the current value. At zMin the hue is 240, at zMax the hue is 0
  var hue = (1 - (point.point.z - this.zRange.min) * this.scale.z / this.verticalRatio) * 240;
  var color = this._hsv2rgb(hue, 1, 1);
  var borderColor = this._hsv2rgb(hue, 1, 0.8);

  return {
    fill: color,
    border: borderColor
  };
};

/**
 * Get the colors for the 'color' graph styles.
 * These styles are currently: 'bar-color' and 'dot-color'
 * Color may be set as a string representation of HTML color, like #ff00ff,
 * or calculated from a number, for example, distance from this point
 * The first option is useful when we have some pre-given legend, to which we have to adjust ourselves
 * The second option is useful when we are interested in automatically setting the color, from some value,
 * using some color scale
 * @param {object} point
 * @returns {{fill: *, border: *}}
 * @private
 */
Graph3d.prototype._getColorsColor = function (point) {
  // calculate the color based on the value
  var color, borderColor;

  if (typeof point.point.value === "string") {
    color = point.point.value;
    borderColor = point.point.value;
  } else {
    var hue = (1 - (point.point.value - this.valueRange.min) * this.scale.value) * 240;
    color = this._hsv2rgb(hue, 1, 1);
    borderColor = this._hsv2rgb(hue, 1, 0.8);
  }
  return {
    fill: color,
    border: borderColor
  };
};

/**
 * Get the colors for the 'size' graph styles.
 * These styles are currently: 'bar-size' and 'dot-size'
 *
 * @returns {{fill: *, border: (string|colorOptions.stroke|{string, undefined}|string|colorOptions.stroke|{string}|*)}}
 * @private
 */
Graph3d.prototype._getColorsSize = function () {
  return {
    fill: this.dataColor.fill,
    border: this.dataColor.stroke
  };
};

/**
 * Determine the size of a point on-screen, as determined by the
 * distance to the camera.
 *
 * @param {Object} point
 * @param {number} [size=this._dotSize()] the size that needs to be translated to screen coordinates.
 *             optional; if not passed, use the default point size.
 * @returns {number}
 * @private
 */
Graph3d.prototype._calcRadius = function (point, size) {
  if (size === undefined) {
    size = this._dotSize();
  }

  var radius;
  if (this.showPerspective) {
    radius = size / -point.trans.z;
  } else {
    radius = size * -(this.eye.z / this.camera.getArmLength());
  }
  if (radius < 0) {
    radius = 0;
  }

  return radius;
};

// -----------------------------------------------------------------------------
// Methods for drawing points per graph style.
// -----------------------------------------------------------------------------


/**
 * Draw single datapoint for graph style 'bar'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawBarGraphPoint = function (ctx, point) {
  var xWidth = this.xBarWidth / 2;
  var yWidth = this.yBarWidth / 2;
  var colors = this._getColorsRegular(point);

  this._redrawBar(ctx, point, xWidth, yWidth, colors.fill, colors.border);
};

/**
 * Draw single datapoint for graph style 'bar-color'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawBarColorGraphPoint = function (ctx, point) {
  var xWidth = this.xBarWidth / 2;
  var yWidth = this.yBarWidth / 2;
  var colors = this._getColorsColor(point);

  this._redrawBar(ctx, point, xWidth, yWidth, colors.fill, colors.border);
};

/**
 * Draw single datapoint for graph style 'bar-size'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawBarSizeGraphPoint = function (ctx, point) {
  // calculate size for the bar
  var fraction = (point.point.value - this.valueRange.min) / this.valueRange.range();
  var xWidth = this.xBarWidth / 2 * (fraction * 0.8 + 0.2);
  var yWidth = this.yBarWidth / 2 * (fraction * 0.8 + 0.2);

  var colors = this._getColorsSize();

  this._redrawBar(ctx, point, xWidth, yWidth, colors.fill, colors.border);
};

/**
 * Draw single datapoint for graph style 'dot'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawDotGraphPoint = function (ctx, point) {
  var colors = this._getColorsRegular(point);

  this._drawCircle(ctx, point, colors.fill, colors.border);
};

/**
 * Draw single datapoint for graph style 'dot-line'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawDotLineGraphPoint = function (ctx, point) {
  // draw a vertical line from the XY-plane to the graph value
  var from = this._convert3Dto2D(point.bottom);
  ctx.lineWidth = 1;
  this._line(ctx, from, point.screen, this.gridColor);

  this._redrawDotGraphPoint(ctx, point);
};

/**
 * Draw single datapoint for graph style 'dot-color'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawDotColorGraphPoint = function (ctx, point) {
  var colors = this._getColorsColor(point);

  this._drawCircle(ctx, point, colors.fill, colors.border);
};

/**
 * Draw single datapoint for graph style 'dot-size'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawDotSizeGraphPoint = function (ctx, point) {
  var dotSize = this._dotSize();
  var fraction = (point.point.value - this.valueRange.min) / this.valueRange.range();

  var sizeMin = dotSize * this.dotSizeMinFraction;
  var sizeRange = dotSize * this.dotSizeMaxFraction - sizeMin;
  var size = sizeMin + sizeRange * fraction;

  var colors = this._getColorsSize();

  this._drawCircle(ctx, point, colors.fill, colors.border, size);
};

/**
 * Draw single datapoint for graph style 'surface'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawSurfaceGraphPoint = function (ctx, point) {
  var right = point.pointRight;
  var top = point.pointTop;
  var cross = point.pointCross;

  if (point === undefined || right === undefined || top === undefined || cross === undefined) {
    return;
  }

  var topSideVisible = true;
  var fillStyle;
  var strokeStyle;

  if (this.showGrayBottom || this.showShadow) {
    // calculate the cross product of the two vectors from center
    // to left and right, in order to know whether we are looking at the
    // bottom or at the top side. We can also use the cross product
    // for calculating light intensity
    var aDiff = Point3d.subtract(cross.trans, point.trans);
    var bDiff = Point3d.subtract(top.trans, right.trans);
    var crossproduct = Point3d.crossProduct(aDiff, bDiff);
    var len = crossproduct.length();
    // FIXME: there is a bug with determining the surface side (shadow or colored)

    topSideVisible = crossproduct.z > 0;
  }

  if (topSideVisible) {

    // calculate Hue from the current value. At zMin the hue is 240, at zMax the hue is 0
    var zAvg = (point.point.z + right.point.z + top.point.z + cross.point.z) / 4;
    var h = (1 - (zAvg - this.zRange.min) * this.scale.z / this.verticalRatio) * 240;
    var s = 1; // saturation
    var v;

    if (this.showShadow) {
      v = Math.min(1 + crossproduct.x / len / 2, 1); // value. TODO: scale
      fillStyle = this._hsv2rgb(h, s, v);
      strokeStyle = fillStyle;
    } else {
      v = 1;
      fillStyle = this._hsv2rgb(h, s, v);
      strokeStyle = this.axisColor; // TODO: should be customizable
    }
  } else {
    fillStyle = 'gray';
    strokeStyle = this.axisColor;
  }

  ctx.lineWidth = this._getStrokeWidth(point);
  // TODO: only draw stroke when strokeWidth > 0

  var points = [point, right, cross, top];
  this._polygon(ctx, points, fillStyle, strokeStyle);
};

/**
 * Helper method for _redrawGridGraphPoint()
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} from
 * @param {Object} to
 * @private
 */
Graph3d.prototype._drawGridLine = function (ctx, from, to) {
  if (from === undefined || to === undefined) {
    return;
  }

  // calculate Hue from the current value. At zMin the hue is 240, at zMax the hue is 0
  var zAvg = (from.point.z + to.point.z) / 2;
  var h = (1 - (zAvg - this.zRange.min) * this.scale.z / this.verticalRatio) * 240;

  ctx.lineWidth = this._getStrokeWidth(from) * 2;
  ctx.strokeStyle = this._hsv2rgb(h, 1, 1);
  this._line(ctx, from.screen, to.screen);
};

/**
 * Draw single datapoint for graph style 'Grid'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawGridGraphPoint = function (ctx, point) {
  this._drawGridLine(ctx, point, point.pointRight);
  this._drawGridLine(ctx, point, point.pointTop);
};

/**
 * Draw single datapoint for graph style 'line'.
 *
 * @param {CanvasRenderingContext2D} ctx
 * @param {Object} point
 * @private
 */
Graph3d.prototype._redrawLineGraphPoint = function (ctx, point) {
  if (point.pointNext === undefined) {
    return;
  }

  ctx.lineWidth = this._getStrokeWidth(point);
  ctx.strokeStyle = this.dataColor.stroke;

  this._line(ctx, point.screen, point.pointNext.screen);
};

/**
 * Draw all datapoints for currently selected graph style.
 *
 */
Graph3d.prototype._redrawDataGraph = function () {
  var ctx = this._getContext();
  var i;

  if (this.dataPoints === undefined || this.dataPoints.length <= 0) return; // TODO: throw exception?

  this._calcTranslations(this.dataPoints);

  for (i = 0; i < this.dataPoints.length; i++) {
    var point = this.dataPoints[i];

    // Using call() ensures that the correct context is used
    this._pointDrawingMethod.call(this, ctx, point);
  }
};

// -----------------------------------------------------------------------------
// End methods for drawing points per graph style.
// -----------------------------------------------------------------------------

/**
 * Store startX, startY and startOffset for mouse operations
 *
 * @param {Event}     event     The event that occurred
 */
Graph3d.prototype._storeMousePosition = function (event) {
  // get mouse position (different code for IE and all other browsers)
  this.startMouseX = getMouseX(event);
  this.startMouseY = getMouseY(event);

  this._startCameraOffset = this.camera.getOffset();
};

/**
 * Start a moving operation inside the provided parent element
 * @param {Event}     event     The event that occurred (required for
 *                  retrieving the  mouse position)
 */
Graph3d.prototype._onMouseDown = function (event) {
  event = event || window.event;

  // check if mouse is still down (may be up when focus is lost for example
  // in an iframe)
  if (this.leftButtonDown) {
    this._onMouseUp(event);
  }

  // only react on left mouse button down
  this.leftButtonDown = event.which ? event.which === 1 : event.button === 1;
  if (!this.leftButtonDown && !this.touchDown) return;

  this._storeMousePosition(event);

  this.startStart = new Date(this.start);
  this.startEnd = new Date(this.end);
  this.startArmRotation = this.camera.getArmRotation();

  this.frame.style.cursor = 'move';

  // add event listeners to handle moving the contents
  // we store the function onmousemove and onmouseup in the graph, so we can
  // remove the eventlisteners lateron in the function mouseUp()
  var me = this;
  this.onmousemove = function (event) {
    me._onMouseMove(event);
  };
  this.onmouseup = function (event) {
    me._onMouseUp(event);
  };
  util.addEventListener(document, 'mousemove', me.onmousemove);
  util.addEventListener(document, 'mouseup', me.onmouseup);
  util.preventDefault(event);
};

/**
 * Perform moving operating.
 * This function activated from within the funcion Graph.mouseDown().
 * @param {Event}   event  Well, eehh, the event
 */
Graph3d.prototype._onMouseMove = function (event) {
  this.moving = true;
  event = event || window.event;

  // calculate change in mouse position
  var diffX = parseFloat(getMouseX(event)) - this.startMouseX;
  var diffY = parseFloat(getMouseY(event)) - this.startMouseY;

  // move with ctrl or rotate by other
  if (event && event.ctrlKey === true) {
    // calculate change in mouse position
    var scaleX = this.frame.clientWidth * 0.5;
    var scaleY = this.frame.clientHeight * 0.5;

    var offXNew = (this._startCameraOffset.x || 0) - diffX / scaleX * this.camera.armLength * 0.8;
    var offYNew = (this._startCameraOffset.y || 0) + diffY / scaleY * this.camera.armLength * 0.8;

    this.camera.setOffset(offXNew, offYNew);
    this._storeMousePosition(event);
  } else {
    var horizontalNew = this.startArmRotation.horizontal + diffX / 200;
    var verticalNew = this.startArmRotation.vertical + diffY / 200;

    var snapAngle = 4; // degrees
    var snapValue = Math.sin(snapAngle / 360 * 2 * Math.PI);

    // snap horizontally to nice angles at 0pi, 0.5pi, 1pi, 1.5pi, etc...
    // the -0.001 is to take care that the vertical axis is always drawn at the left front corner
    if (Math.abs(Math.sin(horizontalNew)) < snapValue) {
      horizontalNew = Math.round(horizontalNew / Math.PI) * Math.PI - 0.001;
    }
    if (Math.abs(Math.cos(horizontalNew)) < snapValue) {
      horizontalNew = (Math.round(horizontalNew / Math.PI - 0.5) + 0.5) * Math.PI - 0.001;
    }

    // snap vertically to nice angles
    if (Math.abs(Math.sin(verticalNew)) < snapValue) {
      verticalNew = Math.round(verticalNew / Math.PI) * Math.PI;
    }
    if (Math.abs(Math.cos(verticalNew)) < snapValue) {
      verticalNew = (Math.round(verticalNew / Math.PI - 0.5) + 0.5) * Math.PI;
    }
    this.camera.setArmRotation(horizontalNew, verticalNew);
  }

  this.redraw();

  // fire a cameraPositionChange event
  var parameters = this.getCameraPosition();
  this.emit('cameraPositionChange', parameters);

  util.preventDefault(event);
};

/**
 * Stop moving operating.
 * This function activated from within the funcion Graph.mouseDown().
 * @param {Event}  event   The event
 */
Graph3d.prototype._onMouseUp = function (event) {
  this.frame.style.cursor = 'auto';
  this.leftButtonDown = false;

  // remove event listeners here
  util.removeEventListener(document, 'mousemove', this.onmousemove);
  util.removeEventListener(document, 'mouseup', this.onmouseup);
  util.preventDefault(event);
};

/**
 * @param {Event}  event   The event
 */
Graph3d.prototype._onClick = function (event) {
  if (!this.onclick_callback) return;
  if (!this.moving) {
    var boundingRect = this.frame.getBoundingClientRect();
    var mouseX = getMouseX(event) - boundingRect.left;
    var mouseY = getMouseY(event) - boundingRect.top;
    var dataPoint = this._dataPointFromXY(mouseX, mouseY);
    if (dataPoint) this.onclick_callback(dataPoint.point.data);
  } else {
    // disable onclick callback, if it came immediately after rotate/pan
    this.moving = false;
  }
  util.preventDefault(event);
};

/**
 * After having moved the mouse, a tooltip should pop up when the mouse is resting on a data point
 * @param {Event}  event   A mouse move event
 */
Graph3d.prototype._onTooltip = function (event) {
  var delay = 300; // ms
  var boundingRect = this.frame.getBoundingClientRect();
  var mouseX = getMouseX(event) - boundingRect.left;
  var mouseY = getMouseY(event) - boundingRect.top;

  if (!this.showTooltip) {
    return;
  }

  if (this.tooltipTimeout) {
    clearTimeout(this.tooltipTimeout);
  }

  // (delayed) display of a tooltip only if no mouse button is down
  if (this.leftButtonDown) {
    this._hideTooltip();
    return;
  }

  if (this.tooltip && this.tooltip.dataPoint) {
    // tooltip is currently visible
    var dataPoint = this._dataPointFromXY(mouseX, mouseY);
    if (dataPoint !== this.tooltip.dataPoint) {
      // datapoint changed
      if (dataPoint) {
        this._showTooltip(dataPoint);
      } else {
        this._hideTooltip();
      }
    }
  } else {
    // tooltip is currently not visible
    var me = this;
    this.tooltipTimeout = setTimeout(function () {
      me.tooltipTimeout = null;

      // show a tooltip if we have a data point
      var dataPoint = me._dataPointFromXY(mouseX, mouseY);
      if (dataPoint) {
        me._showTooltip(dataPoint);
      }
    }, delay);
  }
};

/**
 * Event handler for touchstart event on mobile devices
 * @param {Event}  event   The event
 */
Graph3d.prototype._onTouchStart = function (event) {
  this.touchDown = true;

  var me = this;
  this.ontouchmove = function (event) {
    me._onTouchMove(event);
  };
  this.ontouchend = function (event) {
    me._onTouchEnd(event);
  };
  util.addEventListener(document, 'touchmove', me.ontouchmove);
  util.addEventListener(document, 'touchend', me.ontouchend);

  this._onMouseDown(event);
};

/**
 * Event handler for touchmove event on mobile devices
 * @param {Event}  event   The event
 */
Graph3d.prototype._onTouchMove = function (event) {
  this._onMouseMove(event);
};

/**
 * Event handler for touchend event on mobile devices
 * @param {Event}  event   The event
 */
Graph3d.prototype._onTouchEnd = function (event) {
  this.touchDown = false;

  util.removeEventListener(document, 'touchmove', this.ontouchmove);
  util.removeEventListener(document, 'touchend', this.ontouchend);

  this._onMouseUp(event);
};

/**
 * Event handler for mouse wheel event, used to zoom the graph
 * Code from http://adomas.org/javascript-mouse-wheel/
 * @param {Event}  event   The event
 */
Graph3d.prototype._onWheel = function (event) {
  if (!event) /* For IE. */
    event = window.event;

  // retrieve delta
  var delta = 0;
  if (event.wheelDelta) {
    /* IE/Opera. */
    delta = event.wheelDelta / 120;
  } else if (event.detail) {
    /* Mozilla case. */
    // In Mozilla, sign of delta is different than in IE.
    // Also, delta is multiple of 3.
    delta = -event.detail / 3;
  }

  // If delta is nonzero, handle it.
  // Basically, delta is now positive if wheel was scrolled up,
  // and negative, if wheel was scrolled down.
  if (delta) {
    var oldLength = this.camera.getArmLength();
    var newLength = oldLength * (1 - delta / 10);

    this.camera.setArmLength(newLength);
    this.redraw();

    this._hideTooltip();
  }

  // fire a cameraPositionChange event
  var parameters = this.getCameraPosition();
  this.emit('cameraPositionChange', parameters);

  // Prevent default actions caused by mouse wheel.
  // That might be ugly, but we handle scrolls somehow
  // anyway, so don't bother here..
  util.preventDefault(event);
};

/**
 * Test whether a point lies inside given 2D triangle
 *
 * @param   {vis.Point2d}   point
 * @param   {vis.Point2d[]} triangle
 * @returns {boolean}   true if given point lies inside or on the edge of the
 *                      triangle, false otherwise
 * @private
 */
Graph3d.prototype._insideTriangle = function (point, triangle) {
  var a = triangle[0],
      b = triangle[1],
      c = triangle[2];

  /**
   *
   * @param {number} x
   * @returns {number}
   */
  function sign(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }

  var as = sign((b.x - a.x) * (point.y - a.y) - (b.y - a.y) * (point.x - a.x));
  var bs = sign((c.x - b.x) * (point.y - b.y) - (c.y - b.y) * (point.x - b.x));
  var cs = sign((a.x - c.x) * (point.y - c.y) - (a.y - c.y) * (point.x - c.x));

  // each of the three signs must be either equal to each other or zero
  return (as == 0 || bs == 0 || as == bs) && (bs == 0 || cs == 0 || bs == cs) && (as == 0 || cs == 0 || as == cs);
};

/**
 * Find a data point close to given screen position (x, y)
 *
 * @param   {number} x
 * @param   {number} y
 * @returns {Object | null} The closest data point or null if not close to any
 *                          data point
 * @private
 */
Graph3d.prototype._dataPointFromXY = function (x, y) {
  var i,
      distMax = 100,
      // px
  dataPoint = null,
      closestDataPoint = null,
      closestDist = null,
      center = new Point2d(x, y);

  if (this.style === Graph3d.STYLE.BAR || this.style === Graph3d.STYLE.BARCOLOR || this.style === Graph3d.STYLE.BARSIZE) {
    // the data points are ordered from far away to closest
    for (i = this.dataPoints.length - 1; i >= 0; i--) {
      dataPoint = this.dataPoints[i];
      var surfaces = dataPoint.surfaces;
      if (surfaces) {
        for (var s = surfaces.length - 1; s >= 0; s--) {
          // split each surface in two triangles, and see if the center point is inside one of these
          var surface = surfaces[s];
          var corners = surface.corners;
          var triangle1 = [corners[0].screen, corners[1].screen, corners[2].screen];
          var triangle2 = [corners[2].screen, corners[3].screen, corners[0].screen];
          if (this._insideTriangle(center, triangle1) || this._insideTriangle(center, triangle2)) {
            // return immediately at the first hit
            return dataPoint;
          }
        }
      }
    }
  } else {
    // find the closest data point, using distance to the center of the point on 2d screen
    for (i = 0; i < this.dataPoints.length; i++) {
      dataPoint = this.dataPoints[i];
      var point = dataPoint.screen;
      if (point) {
        var distX = Math.abs(x - point.x);
        var distY = Math.abs(y - point.y);
        var dist = Math.sqrt(distX * distX + distY * distY);

        if ((closestDist === null || dist < closestDist) && dist < distMax) {
          closestDist = dist;
          closestDataPoint = dataPoint;
        }
      }
    }
  }

  return closestDataPoint;
};

/**
 * Determine if the given style has bars
 *
 * @param   {number} style the style to check
 * @returns {boolean} true if bar style, false otherwise
 */
Graph3d.prototype.hasBars = function (style) {
  return style == Graph3d.STYLE.BAR || style == Graph3d.STYLE.BARCOLOR || style == Graph3d.STYLE.BARSIZE;
};

/**
 * Display a tooltip for given data point
 * @param {Object} dataPoint
 * @private
 */
Graph3d.prototype._showTooltip = function (dataPoint) {
  var content, line, dot;

  if (!this.tooltip) {
    content = document.createElement('div');
    (0, _assign2['default'])(content.style, {}, this.tooltipStyle.content);
    content.style.position = 'absolute';

    line = document.createElement('div');
    (0, _assign2['default'])(line.style, {}, this.tooltipStyle.line);
    line.style.position = 'absolute';

    dot = document.createElement('div');
    (0, _assign2['default'])(dot.style, {}, this.tooltipStyle.dot);
    dot.style.position = 'absolute';

    this.tooltip = {
      dataPoint: null,
      dom: {
        content: content,
        line: line,
        dot: dot
      }
    };
  } else {
    content = this.tooltip.dom.content;
    line = this.tooltip.dom.line;
    dot = this.tooltip.dom.dot;
  }

  this._hideTooltip();

  this.tooltip.dataPoint = dataPoint;
  if (typeof this.showTooltip === 'function') {
    content.innerHTML = this.showTooltip(dataPoint.point);
  } else {
    content.innerHTML = '<table>' + '<tr><td>' + this.xLabel + ':</td><td>' + dataPoint.point.x + '</td></tr>' + '<tr><td>' + this.yLabel + ':</td><td>' + dataPoint.point.y + '</td></tr>' + '<tr><td>' + this.zLabel + ':</td><td>' + dataPoint.point.z + '</td></tr>' + '</table>';
  }

  content.style.left = '0';
  content.style.top = '0';
  this.frame.appendChild(content);
  this.frame.appendChild(line);
  this.frame.appendChild(dot);

  // calculate sizes
  var contentWidth = content.offsetWidth;
  var contentHeight = content.offsetHeight;
  var lineHeight = line.offsetHeight;
  var dotWidth = dot.offsetWidth;
  var dotHeight = dot.offsetHeight;

  var left = dataPoint.screen.x - contentWidth / 2;
  left = Math.min(Math.max(left, 10), this.frame.clientWidth - 10 - contentWidth);

  line.style.left = dataPoint.screen.x + 'px';
  line.style.top = dataPoint.screen.y - lineHeight + 'px';
  content.style.left = left + 'px';
  content.style.top = dataPoint.screen.y - lineHeight - contentHeight + 'px';
  dot.style.left = dataPoint.screen.x - dotWidth / 2 + 'px';
  dot.style.top = dataPoint.screen.y - dotHeight / 2 + 'px';
};

/**
 * Hide the tooltip when displayed
 * @private
 */
Graph3d.prototype._hideTooltip = function () {
  if (this.tooltip) {
    this.tooltip.dataPoint = null;

    for (var prop in this.tooltip.dom) {
      if (this.tooltip.dom.hasOwnProperty(prop)) {
        var elem = this.tooltip.dom[prop];
        if (elem && elem.parentNode) {
          elem.parentNode.removeChild(elem);
        }
      }
    }
  }
};

/**--------------------------------------------------------------------------**/

/**
 * Get the horizontal mouse position from a mouse event
 *
 * @param   {Event}  event
 * @returns {number} mouse x
 */
function getMouseX(event) {
  if ('clientX' in event) return event.clientX;
  return event.targetTouches[0] && event.targetTouches[0].clientX || 0;
}

/**
 * Get the vertical mouse position from a mouse event
 *
 * @param   {Event}  event
 * @returns {number} mouse y
 */
function getMouseY(event) {
  if ('clientY' in event) return event.clientY;
  return event.targetTouches[0] && event.targetTouches[0].clientY || 0;
}

// -----------------------------------------------------------------------------
//  Public methods for specific settings
// -----------------------------------------------------------------------------

/**
 * Set the rotation and distance of the camera
 *
 * @param {Object}  pos            An object with the camera position
 * @param {number} [pos.horizontal] The horizontal rotation, between 0 and 2*PI.
 *                                 Optional, can be left undefined.
 * @param {number} [pos.vertical]  The vertical rotation, between 0 and 0.5*PI.
 *                                 if vertical=0.5*PI, the graph is shown from
 *                                 the top. Optional, can be left undefined.
 * @param {number} [pos.distance]  The (normalized) distance of the camera to the
 *                                 center of the graph, a value between 0.71 and
 *                                 5.0. Optional, can be left undefined.
 */
Graph3d.prototype.setCameraPosition = function (pos) {
  Settings.setCameraPosition(pos, this);
  this.redraw();
};

/**
 * Set a new size for the graph
 *
 * @param {string} width  Width in pixels or percentage (for example '800px'
 *                        or '50%')
 * @param {string} height Height in pixels or percentage  (for example '400px'
 *                        or '30%')
 */
Graph3d.prototype.setSize = function (width, height) {
  this._setSize(width, height);
  this.redraw();
};

// -----------------------------------------------------------------------------
//  End public methods for specific settings
// -----------------------------------------------------------------------------


module.exports = Graph3d;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(163);
module.exports = __webpack_require__(7).Object.assign;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(17);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(164) });


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(33);
var gOPS = __webpack_require__(63);
var pIE = __webpack_require__(42);
var toObject = __webpack_require__(41);
var IObject = __webpack_require__(78);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(28)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(166), __esModule: true };

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(167);
module.exports = __webpack_require__(7).Math.sign;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(17);

$export($export.S, 'Math', { sign: __webpack_require__(168) });


/***/ }),
/* 168 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(170), __esModule: true };

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(171);
var $Object = __webpack_require__(7).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This object contains all possible options. It will check if the types are correct, if required if the option is one
 * of the allowed values.
 *
 * __any__ means that the name of the property does not matter.
 * __type__ is a required field for all objects and contains the allowed types of all objects
 */
var string = 'string';
var bool = 'boolean';
var number = 'number';
var object = 'object'; // should only be in a __type__ property
// Following not used here, but useful for reference
//let array    = 'array';
//let dom      = 'dom';
//let any      = 'any';


var colorOptions = {
  fill: { string: string },
  stroke: { string: string },
  strokeWidth: { number: number },
  __type__: { string: string, object: object, 'undefined': 'undefined' }
};

/**
 * Order attempted to be alphabetical.
 *   - x/y/z-prefixes ignored in sorting
 *   - __type__ always at end
 *   - globals at end
 */
var allOptions = {
  animationAutoStart: { boolean: bool, 'undefined': 'undefined' },
  animationInterval: { number: number },
  animationPreload: { boolean: bool },
  axisColor: { string: string },
  backgroundColor: colorOptions,
  xBarWidth: { number: number, 'undefined': 'undefined' },
  yBarWidth: { number: number, 'undefined': 'undefined' },
  cameraPosition: {
    distance: { number: number },
    horizontal: { number: number },
    vertical: { number: number },
    __type__: { object: object }
  },
  xCenter: { string: string },
  yCenter: { string: string },
  dataColor: colorOptions,
  dotSizeMinFraction: { number: number },
  dotSizeMaxFraction: { number: number },
  dotSizeRatio: { number: number },
  filterLabel: { string: string },
  gridColor: { string: string },
  onclick: { 'function': 'function' },
  keepAspectRatio: { boolean: bool },
  xLabel: { string: string },
  yLabel: { string: string },
  zLabel: { string: string },
  legendLabel: { string: string },
  xMin: { number: number, 'undefined': 'undefined' },
  yMin: { number: number, 'undefined': 'undefined' },
  zMin: { number: number, 'undefined': 'undefined' },
  xMax: { number: number, 'undefined': 'undefined' },
  yMax: { number: number, 'undefined': 'undefined' },
  zMax: { number: number, 'undefined': 'undefined' },
  showAnimationControls: { boolean: bool, 'undefined': 'undefined' },
  showGrid: { boolean: bool },
  showLegend: { boolean: bool, 'undefined': 'undefined' },
  showPerspective: { boolean: bool },
  showShadow: { boolean: bool },
  showXAxis: { boolean: bool },
  showYAxis: { boolean: bool },
  showZAxis: { boolean: bool },
  xStep: { number: number, 'undefined': 'undefined' },
  yStep: { number: number, 'undefined': 'undefined' },
  zStep: { number: number, 'undefined': 'undefined' },
  style: {
    number: number, // TODO: either Graph3d.DEFAULT has string, or number allowed in documentation
    string: ['bar', 'bar-color', 'bar-size', 'dot', 'dot-line', 'dot-color', 'dot-size', 'line', 'grid', 'surface']
  },
  tooltip: { boolean: bool, 'function': 'function' },
  tooltipStyle: {
    content: {
      color: { string: string },
      background: { string: string },
      border: { string: string },
      borderRadius: { string: string },
      boxShadow: { string: string },
      padding: { string: string },
      __type__: { object: object }
    },
    line: {
      borderLeft: { string: string },
      height: { string: string },
      width: { string: string },
      __type__: { object: object }
    },
    dot: {
      border: { string: string },
      borderRadius: { string: string },
      height: { string: string },
      width: { string: string },
      __type__: { object: object }
    },
    __type__: { object: object }
  },
  xValueLabel: { 'function': 'function' },
  yValueLabel: { 'function': 'function' },
  zValueLabel: { 'function': 'function' },
  valueMax: { number: number, 'undefined': 'undefined' },
  valueMin: { number: number, 'undefined': 'undefined' },
  verticalRatio: { number: number },

  //globals :
  height: { string: string },
  width: { string: string },
  __type__: { object: object }
};

exports.allOptions = allOptions;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DataSet = __webpack_require__(11);
var DataView = __webpack_require__(12);
var Range = __webpack_require__(174);
var Filter = __webpack_require__(96);
var Settings = __webpack_require__(94);
var Point3d = __webpack_require__(34);

/**
 * Creates a container for all data of one specific 3D-graph.
 *
 * On construction, the container is totally empty; the data
 * needs to be initialized with method initializeData().
 * Failure to do so will result in the following exception begin thrown
 * on instantiation of Graph3D:
 *
 *     Error: Array, DataSet, or DataView expected
 *
 * @constructor DataGroup
 */
function DataGroup() {
  this.dataTable = null; // The original data table
}

/**
 * Initializes the instance from the passed data.
 *
 * Calculates minimum and maximum values and column index values.
 *
 * The graph3d instance is used internally to access the settings for
 * the given instance.
 * TODO: Pass settings only instead.
 *
 * @param {vis.Graph3d}  graph3d Reference to the calling Graph3D instance.
 * @param {Array | DataSet | DataView} rawData The data containing the items for
 *                                             the Graph.
 * @param {number}   style   Style Number
 * @returns {Array.<Object>}
 */
DataGroup.prototype.initializeData = function (graph3d, rawData, style) {
  if (rawData === undefined) return;

  if (Array.isArray(rawData)) {
    rawData = new DataSet(rawData);
  }

  var data;
  if (rawData instanceof DataSet || rawData instanceof DataView) {
    data = rawData.get();
  } else {
    throw new Error('Array, DataSet, or DataView expected');
  }

  if (data.length == 0) return;

  this.style = style;

  // unsubscribe from the dataTable
  if (this.dataSet) {
    this.dataSet.off('*', this._onChange);
  }

  this.dataSet = rawData;
  this.dataTable = data;

  // subscribe to changes in the dataset
  var me = this;
  this._onChange = function () {
    graph3d.setData(me.dataSet);
  };
  this.dataSet.on('*', this._onChange);

  // determine the location of x,y,z,value,filter columns
  this.colX = 'x';
  this.colY = 'y';
  this.colZ = 'z';

  var withBars = graph3d.hasBars(style);

  // determine barWidth from data
  if (withBars) {
    if (graph3d.defaultXBarWidth !== undefined) {
      this.xBarWidth = graph3d.defaultXBarWidth;
    } else {
      this.xBarWidth = this.getSmallestDifference(data, this.colX) || 1;
    }

    if (graph3d.defaultYBarWidth !== undefined) {
      this.yBarWidth = graph3d.defaultYBarWidth;
    } else {
      this.yBarWidth = this.getSmallestDifference(data, this.colY) || 1;
    }
  }

  // calculate minima and maxima
  this._initializeRange(data, this.colX, graph3d, withBars);
  this._initializeRange(data, this.colY, graph3d, withBars);
  this._initializeRange(data, this.colZ, graph3d, false);

  if (data[0].hasOwnProperty('style')) {
    this.colValue = 'style';
    var valueRange = this.getColumnRange(data, this.colValue);
    this._setRangeDefaults(valueRange, graph3d.defaultValueMin, graph3d.defaultValueMax);
    this.valueRange = valueRange;
  }

  // Initialize data filter if a filter column is provided
  var table = this.getDataTable();
  if (table[0].hasOwnProperty('filter')) {
    if (this.dataFilter === undefined) {
      this.dataFilter = new Filter(this, 'filter', graph3d);
      this.dataFilter.setOnLoadCallback(function () {
        graph3d.redraw();
      });
    }
  }

  var dataPoints;
  if (this.dataFilter) {
    // apply filtering
    dataPoints = this.dataFilter._getDataPoints();
  } else {
    // no filtering. load all data
    dataPoints = this._getDataPoints(this.getDataTable());
  }
  return dataPoints;
};

/**
 * Collect the range settings for the given data column.
 *
 * This internal method is intended to make the range 
 * initalization more generic.
 *
 * TODO: if/when combined settings per axis defined, get rid of this.
 *
 * @private
 *
 * @param {'x'|'y'|'z'} column  The data column to process
 * @param {vis.Graph3d} graph3d Reference to the calling Graph3D instance;
 *                              required for access to settings
 * @returns {Object}
 */
DataGroup.prototype._collectRangeSettings = function (column, graph3d) {
  var index = ['x', 'y', 'z'].indexOf(column);

  if (index == -1) {
    throw new Error('Column \'' + column + '\' invalid');
  }

  var upper = column.toUpperCase();

  return {
    barWidth: this[column + 'BarWidth'],
    min: graph3d['default' + upper + 'Min'],
    max: graph3d['default' + upper + 'Max'],
    step: graph3d['default' + upper + 'Step'],
    range_label: column + 'Range', // Name of instance field to write to
    step_label: column + 'Step' // Name of instance field to write to
  };
};

/**
 * Initializes the settings per given column.
 *
 * TODO: if/when combined settings per axis defined, rewrite this.
 *
 * @private
 *
 * @param {DataSet | DataView} data     The data containing the items for the Graph
 * @param {'x'|'y'|'z'}        column   The data column to process
 * @param {vis.Graph3d}        graph3d  Reference to the calling Graph3D instance;
 *                                      required for access to settings
 * @param {boolean}            withBars True if initializing for bar graph
 */
DataGroup.prototype._initializeRange = function (data, column, graph3d, withBars) {
  var NUMSTEPS = 5;
  var settings = this._collectRangeSettings(column, graph3d);

  var range = this.getColumnRange(data, column);
  if (withBars && column != 'z') {
    // Safeguard for 'z'; it doesn't have a bar width
    range.expand(settings.barWidth / 2);
  }

  this._setRangeDefaults(range, settings.min, settings.max);
  this[settings.range_label] = range;
  this[settings.step_label] = settings.step !== undefined ? settings.step : range.range() / NUMSTEPS;
};

/**
 * Creates a list with all the different values in the data for the given column.
 *
 * If no data passed, use the internal data of this instance.
 *
 * @param {'x'|'y'|'z'}                column The data column to process
 * @param {DataSet|DataView|undefined} data   The data containing the items for the Graph
 *
 * @returns {Array} All distinct values in the given column data, sorted ascending.
 */
DataGroup.prototype.getDistinctValues = function (column, data) {
  if (data === undefined) {
    data = this.dataTable;
  }

  var values = [];

  for (var i = 0; i < data.length; i++) {
    var value = data[i][column] || 0;
    if (values.indexOf(value) === -1) {
      values.push(value);
    }
  }

  return values.sort(function (a, b) {
    return a - b;
  });
};

/**
 * Determine the smallest difference between the values for given
 * column in the passed data set.
 *
 * @param {DataSet|DataView|undefined} data   The data containing the items for the Graph
 * @param {'x'|'y'|'z'}                column The data column to process
 *
 * @returns {number|null} Smallest difference value or
 *                        null, if it can't be determined.
 */
DataGroup.prototype.getSmallestDifference = function (data, column) {
  var values = this.getDistinctValues(data, column);

  // Get all the distinct diffs
  // Array values is assumed to be sorted here
  var smallest_diff = null;

  for (var i = 1; i < values.length; i++) {
    var diff = values[i] - values[i - 1];

    if (smallest_diff == null || smallest_diff > diff) {
      smallest_diff = diff;
    }
  }

  return smallest_diff;
};

/**
 * Get the absolute min/max values for the passed data column.
 *
 * @param {DataSet|DataView|undefined} data   The data containing the items for the Graph
 * @param {'x'|'y'|'z'}                column The data column to process
 *
 * @returns {Range} A Range instance with min/max members properly set.
 */
DataGroup.prototype.getColumnRange = function (data, column) {
  var range = new Range();

  // Adjust the range so that it covers all values in the passed data elements.
  for (var i = 0; i < data.length; i++) {
    var item = data[i][column];
    range.adjust(item);
  }

  return range;
};

/**
 * Determines the number of rows in the current data.
 *
 * @returns {number}
 */
DataGroup.prototype.getNumberOfRows = function () {
  return this.dataTable.length;
};

/**
 * Set default values for range
 *
 * The default values override the range values, if defined.
 *
 * Because it's possible that only defaultMin or defaultMax is set, it's better
 * to pass in a range already set with the min/max set from the data. Otherwise,
 * it's quite hard to process the min/max properly.
 *
 * @param {vis.Range} range
 * @param {number} [defaultMin=range.min]
 * @param {number} [defaultMax=range.max]
 * @private
 */
DataGroup.prototype._setRangeDefaults = function (range, defaultMin, defaultMax) {
  if (defaultMin !== undefined) {
    range.min = defaultMin;
  }

  if (defaultMax !== undefined) {
    range.max = defaultMax;
  }

  // This is the original way that the default min/max values were adjusted.
  // TODO: Perhaps it's better if an error is thrown if the values do not agree.
  //       But this will change the behaviour.
  if (range.max <= range.min) range.max = range.min + 1;
};

DataGroup.prototype.getDataTable = function () {
  return this.dataTable;
};

DataGroup.prototype.getDataSet = function () {
  return this.dataSet;
};

/**
 * Return all data values as a list of Point3d objects
 * @param {Array.<Object>} data
 * @returns {Array.<Object>}
 */
DataGroup.prototype.getDataPoints = function (data) {
  var dataPoints = [];

  for (var i = 0; i < data.length; i++) {
    var point = new Point3d();
    point.x = data[i][this.colX] || 0;
    point.y = data[i][this.colY] || 0;
    point.z = data[i][this.colZ] || 0;
    point.data = data[i];

    if (this.colValue !== undefined) {
      point.value = data[i][this.colValue] || 0;
    }

    var obj = {};
    obj.point = point;
    obj.bottom = new Point3d(point.x, point.y, this.zRange.min);
    obj.trans = undefined;
    obj.screen = undefined;

    dataPoints.push(obj);
  }

  return dataPoints;
};

/**
 * Copy all values from the data table to a matrix.
 *
 * The provided values are supposed to form a grid of (x,y) positions.
 * @param {Array.<Object>} data
 * @returns {Array.<Object>}
 * @private
 */
DataGroup.prototype.initDataAsMatrix = function (data) {
  // TODO: store the created matrix dataPoints in the filters instead of
  //       reloading each time.
  var x, y, i, obj;

  // create two lists with all present x and y values
  var dataX = this.getDistinctValues(this.colX, data);
  var dataY = this.getDistinctValues(this.colY, data);

  var dataPoints = this.getDataPoints(data);

  // create a grid, a 2d matrix, with all values.
  var dataMatrix = []; // temporary data matrix
  for (i = 0; i < dataPoints.length; i++) {
    obj = dataPoints[i];

    // TODO: implement Array().indexOf() for Internet Explorer
    var xIndex = dataX.indexOf(obj.point.x);
    var yIndex = dataY.indexOf(obj.point.y);

    if (dataMatrix[xIndex] === undefined) {
      dataMatrix[xIndex] = [];
    }

    dataMatrix[xIndex][yIndex] = obj;
  }

  // fill in the pointers to the neighbors.
  for (x = 0; x < dataMatrix.length; x++) {
    for (y = 0; y < dataMatrix[x].length; y++) {
      if (dataMatrix[x][y]) {
        dataMatrix[x][y].pointRight = x < dataMatrix.length - 1 ? dataMatrix[x + 1][y] : undefined;
        dataMatrix[x][y].pointTop = y < dataMatrix[x].length - 1 ? dataMatrix[x][y + 1] : undefined;
        dataMatrix[x][y].pointCross = x < dataMatrix.length - 1 && y < dataMatrix[x].length - 1 ? dataMatrix[x + 1][y + 1] : undefined;
      }
    }
  }

  return dataPoints;
};

/**
 * Return common information, if present
 *
 * @returns {string}
 */
DataGroup.prototype.getInfo = function () {
  var dataFilter = this.dataFilter;
  if (!dataFilter) return undefined;

  return dataFilter.getLabel() + ': ' + dataFilter.getSelectedValue();
};

/**
 * Reload the data
 */
DataGroup.prototype.reload = function () {
  if (this.dataTable) {
    this.setData(this.dataTable);
  }
};

/**
 * Filter the data based on the current filter
 *
 * @param   {Array} data
 * @returns {Array} dataPoints Array with point objects which can be drawn on
 *                             screen
 */
DataGroup.prototype._getDataPoints = function (data) {
  var dataPoints = [];

  if (this.style === Settings.STYLE.GRID || this.style === Settings.STYLE.SURFACE) {
    dataPoints = this.initDataAsMatrix(data);
  } else {
    // 'dot', 'dot-line', etc.
    this._checkValueField(data);
    dataPoints = this.getDataPoints(data);

    if (this.style === Settings.STYLE.LINE) {
      // Add next member points for line drawing
      for (var i = 0; i < dataPoints.length; i++) {
        if (i > 0) {
          dataPoints[i - 1].pointNext = dataPoints[i];
        }
      }
    }
  }

  return dataPoints;
};

/**
 * Check if the state is consistent for the use of the value field.
 *
 * Throws if a problem is detected.
 *
 * @param {Array.<Object>} data
 * @private
 */
DataGroup.prototype._checkValueField = function (data) {

  var hasValueField = this.style === Settings.STYLE.BARCOLOR || this.style === Settings.STYLE.BARSIZE || this.style === Settings.STYLE.DOTCOLOR || this.style === Settings.STYLE.DOTSIZE;

  if (!hasValueField) {
    return; // No need to check further
  }

  // Following field must be present for the current graph style
  if (this.colValue === undefined) {
    throw new Error('Expected data to have ' + ' field \'style\' ' + ' for graph style \'' + this.style + '\'');
  }

  // The data must also contain this field.
  // Note that only first data element is checked.
  if (data[0][this.colValue] === undefined) {
    throw new Error('Expected data to have ' + ' field \'' + this.colValue + '\' ' + ' for graph style \'' + this.style + '\'');
  }
};

module.exports = DataGroup;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @prototype Range
 *
 * Helper class to make working with related min and max values easier.
 *
 * The range is inclusive; a given value is considered part of the range if:
 *
 *    this.min <= value <= this.max
 */
function Range() {
  this.min = undefined;
  this.max = undefined;
}

/**
 * Adjust the range so that the passed value fits in it.
 *
 * If the value is outside of the current extremes, adjust
 * the min or max so that the value is within the range.
 *
 * @param {number} value Numeric value to fit in range
 */
Range.prototype.adjust = function (value) {
  if (value === undefined) return;

  if (this.min === undefined || this.min > value) {
    this.min = value;
  }

  if (this.max === undefined || this.max < value) {
    this.max = value;
  }
};

/**
 * Adjust the current range so that the passed range fits in it.
 *
 * @param {Range} range Range instance to fit in current instance
 */
Range.prototype.combine = function (range) {
  this.add(range.min);
  this.add(range.max);
};

/**
 * Expand the range by the given value
 *
 * min will be lowered by given value;
 * max will be raised by given value
 *
 * Shrinking by passing a negative value is allowed.
 *
 * @param {number} val Amount by which to expand or shrink current range with
 */
Range.prototype.expand = function (val) {
  if (val === undefined) {
    return;
  }

  var newMin = this.min - val;
  var newMax = this.max + val;

  // Note that following allows newMin === newMax.
  // This should be OK, since method expand() allows this also.
  if (newMin > newMax) {
    throw new Error('Passed expansion value makes range invalid');
  }

  this.min = newMin;
  this.max = newMax;
};

/**
 * Determine the full range width of current instance.
 *
 * @returns {num} The calculated width of this range
 */
Range.prototype.range = function () {
  return this.max - this.min;
};

/**
 * Determine the central point of current instance.
 *
 * @returns {number} the value in the middle of min and max
 */
Range.prototype.center = function () {
  return (this.min + this.max) / 2;
};

module.exports = Range;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function (factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    window.propagating = factory();
  }
}(function () {
  var _firstTarget = null; // singleton, will contain the target element where the touch event started

  /**
   * Extend an Hammer.js instance with event propagation.
   *
   * Features:
   * - Events emitted by hammer will propagate in order from child to parent
   *   elements.
   * - Events are extended with a function `event.stopPropagation()` to stop
   *   propagation to parent elements.
   * - An option `preventDefault` to stop all default browser behavior.
   *
   * Usage:
   *   var hammer = propagatingHammer(new Hammer(element));
   *   var hammer = propagatingHammer(new Hammer(element), {preventDefault: true});
   *
   * @param {Hammer.Manager} hammer   An hammer instance.
   * @param {Object} [options]        Available options:
   *                                  - `preventDefault: true | false | 'mouse' | 'touch' | 'pen'`.
   *                                    Enforce preventing the default browser behavior.
   *                                    Cannot be set to `false`.
   * @return {Hammer.Manager} Returns the same hammer instance with extended
   *                          functionality
   */
  return function propagating(hammer, options) {
    var _options = options || {
      preventDefault: false
    };

    if (hammer.Manager) {
      // This looks like the Hammer constructor.
      // Overload the constructors with our own.
      var Hammer = hammer;

      var PropagatingHammer = function(element, options) {
        var o = Object.create(_options);
        if (options) Hammer.assign(o, options);
        return propagating(new Hammer(element, o), o);
      };
      Hammer.assign(PropagatingHammer, Hammer);

      PropagatingHammer.Manager = function (element, options) {
        var o = Object.create(_options);
        if (options) Hammer.assign(o, options);
        return propagating(new Hammer.Manager(element, o), o);
      };

      return PropagatingHammer;
    }

    // create a wrapper object which will override the functions
    // `on`, `off`, `destroy`, and `emit` of the hammer instance
    var wrapper = Object.create(hammer);

    // attach to DOM element
    var element = hammer.element;

    if(!element.hammer) element.hammer = [];
    element.hammer.push(wrapper);

    // register an event to catch the start of a gesture and store the
    // target in a singleton
    hammer.on('hammer.input', function (event) {
      if (_options.preventDefault === true || (_options.preventDefault === event.pointerType)) {
        event.preventDefault();
      }
      if (event.isFirst) {
        _firstTarget = event.target;
      }
    });

    /** @type {Object.<String, Array.<function>>} */
    wrapper._handlers = {};

    /**
     * Register a handler for one or multiple events
     * @param {String} events    A space separated string with events
     * @param {function} handler A callback function, called as handler(event)
     * @returns {Hammer.Manager} Returns the hammer instance
     */
    wrapper.on = function (events, handler) {
      // register the handler
      split(events).forEach(function (event) {
        var _handlers = wrapper._handlers[event];
        if (!_handlers) {
          wrapper._handlers[event] = _handlers = [];

          // register the static, propagated handler
          hammer.on(event, propagatedHandler);
        }
        _handlers.push(handler);
      });

      return wrapper;
    };

    /**
     * Unregister a handler for one or multiple events
     * @param {String} events      A space separated string with events
     * @param {function} [handler] Optional. The registered handler. If not
     *                             provided, all handlers for given events
     *                             are removed.
     * @returns {Hammer.Manager}   Returns the hammer instance
     */
    wrapper.off = function (events, handler) {
      // unregister the handler
      split(events).forEach(function (event) {
        var _handlers = wrapper._handlers[event];
        if (_handlers) {
          _handlers = handler ? _handlers.filter(function (h) {
            return h !== handler;
          }) : [];

          if (_handlers.length > 0) {
            wrapper._handlers[event] = _handlers;
          }
          else {
            // remove static, propagated handler
            hammer.off(event, propagatedHandler);
            delete wrapper._handlers[event];
          }
        }
      });

      return wrapper;
    };

    /**
     * Emit to the event listeners
     * @param {string} eventType
     * @param {Event} event
     */
    wrapper.emit = function(eventType, event) {
      _firstTarget = event.target;
      hammer.emit(eventType, event);
    };

    wrapper.destroy = function () {
      // Detach from DOM element
      var hammers = hammer.element.hammer;
      var idx = hammers.indexOf(wrapper);
      if(idx !== -1) hammers.splice(idx,1);
      if(!hammers.length) delete hammer.element.hammer;

      // clear all handlers
      wrapper._handlers = {};

      // call original hammer destroy
      hammer.destroy();
    };

    // split a string with space separated words
    function split(events) {
      return events.match(/[^ ]+/g);
    }

    /**
     * A static event handler, applying event propagation.
     * @param {Object} event
     */
    function propagatedHandler(event) {
      // let only a single hammer instance handle this event
      if (event.type !== 'hammer.input') {
        // it is possible that the same srcEvent is used with multiple hammer events,
        // we keep track on which events are handled in an object _handled
        if (!event.srcEvent._handled) {
          event.srcEvent._handled = {};
        }

        if (event.srcEvent._handled[event.type]) {
          return;
        }
        else {
          event.srcEvent._handled[event.type] = true;
        }
      }

      // attach a stopPropagation function to the event
      var stopped = false;
      event.stopPropagation = function () {
        stopped = true;
      };

      //wrap the srcEvent's stopPropagation to also stop hammer propagation:
      var srcStop = event.srcEvent.stopPropagation.bind(event.srcEvent);
      if(typeof srcStop == "function") {
        event.srcEvent.stopPropagation = function(){
          srcStop();
          event.stopPropagation();
        }
      }

      // attach firstTarget property to the event
      event.firstTarget = _firstTarget;

      // propagate over all elements (until stopped)
      var elem = _firstTarget;
      while (elem && !stopped) {
        var elemHammer = elem.hammer;
        if(elemHammer){
          var _handlers;
          for(var k = 0; k < elemHammer.length; k++){
            _handlers = elemHammer[k]._handlers[event.type];
            if(_handlers) for (var i = 0; i < _handlers.length && !stopped; i++) {
              _handlers[i](event);
            }
          }
        }
        elem = elem.parentNode;
      }
    }

    return wrapper;
  };
}));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// utils
exports.util = __webpack_require__(2);
exports.DOMutil = __webpack_require__(14);

// data
exports.DataSet = __webpack_require__(11);
exports.DataView = __webpack_require__(12);
exports.Queue = __webpack_require__(43);

// Timeline
exports.Timeline = __webpack_require__(178);
exports.Graph2d = __webpack_require__(180);
exports.timeline = {
  Core: __webpack_require__(65),
  DateUtil: __webpack_require__(36),
  Range: __webpack_require__(64),
  stack: __webpack_require__(100),
  TimeStep: __webpack_require__(66),

  components: {
    items: {
      Item: __webpack_require__(38),
      BackgroundItem: __webpack_require__(103),
      BoxItem: __webpack_require__(101),
      PointItem: __webpack_require__(102),
      RangeItem: __webpack_require__(70)
    },

    BackgroundGroup: __webpack_require__(69),
    Component: __webpack_require__(16),
    CurrentTime: __webpack_require__(67),
    CustomTime: __webpack_require__(46),
    DataAxis: __webpack_require__(107),
    DataScale: __webpack_require__(108),
    GraphGroup: __webpack_require__(109),
    Group: __webpack_require__(68),
    ItemSet: __webpack_require__(99),
    Legend: __webpack_require__(112),
    LineGraph: __webpack_require__(106),
    TimeAxis: __webpack_require__(45)
  }
};

// bundled external libraries
exports.moment = __webpack_require__(9);
exports.Hammer = __webpack_require__(10);
exports.keycharm = __webpack_require__(35);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(9);
var util = __webpack_require__(2);
var DataSet = __webpack_require__(11);
var DataView = __webpack_require__(12);
var Range = __webpack_require__(64);
var Core = __webpack_require__(65);
var TimeAxis = __webpack_require__(45);
var CurrentTime = __webpack_require__(67);
var CustomTime = __webpack_require__(46);
var ItemSet = __webpack_require__(99);

var printStyle = __webpack_require__(15).printStyle;
var allOptions = __webpack_require__(105).allOptions;
var configureOptions = __webpack_require__(105).configureOptions;

var Configurator = __webpack_require__(71)['default'];
var Validator = __webpack_require__(15)['default'];

/**
 * Create a timeline visualization
 * @param {HTMLElement} container
 * @param {vis.DataSet | vis.DataView | Array} [items]
 * @param {vis.DataSet | vis.DataView | Array} [groups]
 * @param {Object} [options]  See Timeline.setOptions for the available options.
 * @constructor Timeline
 * @extends Core
 */
function Timeline(container, items, groups, options) {

  if (!(this instanceof Timeline)) {
    throw new SyntaxError('Constructor must be called with the new operator');
  }

  // if the third element is options, the forth is groups (optionally);
  if (!(Array.isArray(groups) || groups instanceof DataSet || groups instanceof DataView) && groups instanceof Object) {
    var forthArgument = options;
    options = groups;
    groups = forthArgument;
  }

  // TODO: REMOVE THIS in the next MAJOR release
  // see https://github.com/almende/vis/issues/2511
  if (options && options.throttleRedraw) {
    console.warn("Timeline option \"throttleRedraw\" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.");
  }

  var me = this;
  this.defaultOptions = {
    start: null,
    end: null,
    autoResize: true,
    orientation: {
      axis: 'bottom', // axis orientation: 'bottom', 'top', or 'both'
      item: 'bottom' // not relevant
    },
    moment: moment,
    width: null,
    height: null,
    maxHeight: null,
    minHeight: null
  };
  this.options = util.deepExtend({}, this.defaultOptions);

  // Create the DOM, props, and emitter
  this._create(container);
  if (!options || options && typeof options.rtl == "undefined") {
    this.dom.root.style.visibility = 'hidden';
    var directionFromDom,
        domNode = this.dom.root;
    while (!directionFromDom && domNode) {
      directionFromDom = window.getComputedStyle(domNode, null).direction;
      domNode = domNode.parentElement;
    }
    this.options.rtl = directionFromDom && directionFromDom.toLowerCase() == "rtl";
  } else {
    this.options.rtl = options.rtl;
  }

  this.options.rollingMode = options && options.rollingMode;
  this.options.onInitialDrawComplete = options && options.onInitialDrawComplete;

  // all components listed here will be repainted automatically
  this.components = [];

  this.body = {
    dom: this.dom,
    domProps: this.props,
    emitter: {
      on: this.on.bind(this),
      off: this.off.bind(this),
      emit: this.emit.bind(this)
    },
    hiddenDates: [],
    util: {
      getScale: function getScale() {
        return me.timeAxis.step.scale;
      },
      getStep: function getStep() {
        return me.timeAxis.step.step;
      },

      toScreen: me._toScreen.bind(me),
      toGlobalScreen: me._toGlobalScreen.bind(me), // this refers to the root.width
      toTime: me._toTime.bind(me),
      toGlobalTime: me._toGlobalTime.bind(me)
    }
  };

  // range
  this.range = new Range(this.body, this.options);
  this.components.push(this.range);
  this.body.range = this.range;

  // time axis
  this.timeAxis = new TimeAxis(this.body, this.options);
  this.timeAxis2 = null; // used in case of orientation option 'both'
  this.components.push(this.timeAxis);

  // current time bar
  this.currentTime = new CurrentTime(this.body, this.options);
  this.components.push(this.currentTime);

  // item set
  this.itemSet = new ItemSet(this.body, this.options);
  this.components.push(this.itemSet);

  this.itemsData = null; // DataSet
  this.groupsData = null; // DataSet

  this.dom.root.onclick = function (event) {
    me.emit('click', me.getEventProperties(event));
  };
  this.dom.root.ondblclick = function (event) {
    me.emit('doubleClick', me.getEventProperties(event));
  };
  this.dom.root.oncontextmenu = function (event) {
    me.emit('contextmenu', me.getEventProperties(event));
  };
  this.dom.root.onmouseover = function (event) {
    me.emit('mouseOver', me.getEventProperties(event));
  };
  if (window.PointerEvent) {
    this.dom.root.onpointerdown = function (event) {
      me.emit('mouseDown', me.getEventProperties(event));
    };
    this.dom.root.onpointermove = function (event) {
      me.emit('mouseMove', me.getEventProperties(event));
    };
    this.dom.root.onpointerup = function (event) {
      me.emit('mouseUp', me.getEventProperties(event));
    };
  } else {
    this.dom.root.onmousemove = function (event) {
      me.emit('mouseMove', me.getEventProperties(event));
    };
    this.dom.root.onmousedown = function (event) {
      me.emit('mouseDown', me.getEventProperties(event));
    };
    this.dom.root.onmouseup = function (event) {
      me.emit('mouseUp', me.getEventProperties(event));
    };
  }

  //Single time autoscale/fit
  this.initialFitDone = false;
  this.on('changed', function () {
    if (this.itemsData == null || this.options.rollingMode) return;
    if (!me.initialFitDone) {
      me.initialFitDone = true;
      if (me.options.start != undefined || me.options.end != undefined) {
        if (me.options.start == undefined || me.options.end == undefined) {
          var range = me.getItemRange();
        }

        var start = me.options.start != undefined ? me.options.start : range.min;
        var end = me.options.end != undefined ? me.options.end : range.max;
        me.setWindow(start, end, { animation: false });
      } else {
        me.fit({ animation: false });
      }
    }

    if (!me.initialDrawDone && me.initialRangeChangeDone) {
      me.initialDrawDone = true;
      me.dom.root.style.visibility = 'visible';
      if (me.options.onInitialDrawComplete) {
        setTimeout(function () {
          return me.options.onInitialDrawComplete();
        }, 0);
      }
    }
  });

  // apply options
  if (options) {
    this.setOptions(options);
  }

  // IMPORTANT: THIS HAPPENS BEFORE SET ITEMS!
  if (groups) {
    this.setGroups(groups);
  }

  // create itemset
  if (items) {
    this.setItems(items);
  }

  // draw for the first time
  this._redraw();
}

// Extend the functionality from Core
Timeline.prototype = new Core();

/**
 * Load a configurator
 * @return {Object}
 * @private
 */
Timeline.prototype._createConfigurator = function () {
  return new Configurator(this, this.dom.container, configureOptions);
};

/**
 * Force a redraw. The size of all items will be recalculated.
 * Can be useful to manually redraw when option autoResize=false and the window
 * has been resized, or when the items CSS has been changed.
 *
 * Note: this function will be overridden on construction with a trottled version
 */
Timeline.prototype.redraw = function () {
  this.itemSet && this.itemSet.markDirty({ refreshItems: true });
  this._redraw();
};

Timeline.prototype.setOptions = function (options) {
  // validate options
  var errorFound = Validator.validate(options, allOptions);

  if (errorFound === true) {
    console.log('%cErrors have been found in the supplied options object.', printStyle);
  }
  Core.prototype.setOptions.call(this, options);

  if ('type' in options) {
    if (options.type !== this.options.type) {
      this.options.type = options.type;

      // force recreation of all items
      var itemsData = this.itemsData;
      if (itemsData) {
        var selection = this.getSelection();
        this.setItems(null); // remove all
        this.setItems(itemsData); // add all
        this.setSelection(selection); // restore selection
      }
    }
  }
};

/**
 * Set items
 * @param {vis.DataSet | Array | null} items
 */
Timeline.prototype.setItems = function (items) {
  // convert to type DataSet when needed
  var newDataSet;
  if (!items) {
    newDataSet = null;
  } else if (items instanceof DataSet || items instanceof DataView) {
    newDataSet = items;
  } else {
    // turn an array into a dataset
    newDataSet = new DataSet(items, {
      type: {
        start: 'Date',
        end: 'Date'
      }
    });
  }

  // set items
  this.itemsData = newDataSet;
  this.itemSet && this.itemSet.setItems(newDataSet);
};

/**
 * Set groups
 * @param {vis.DataSet | Array} groups
 */
Timeline.prototype.setGroups = function (groups) {
  // convert to type DataSet when needed
  var newDataSet;
  if (!groups) {
    newDataSet = null;
  } else {
    var filter = function filter(group) {
      return group.visible !== false;
    };
    if (groups instanceof DataSet || groups instanceof DataView) {
      newDataSet = new DataView(groups, { filter: filter });
    } else {
      // turn an array into a dataset
      newDataSet = new DataSet(groups.filter(filter));
    }
  }

  this.groupsData = newDataSet;
  this.itemSet.setGroups(newDataSet);
};

/**
 * Set both items and groups in one go
 * @param {{items: (Array | vis.DataSet), groups: (Array | vis.DataSet)}} data
 */
Timeline.prototype.setData = function (data) {
  if (data && data.groups) {
    this.setGroups(data.groups);
  }

  if (data && data.items) {
    this.setItems(data.items);
  }
};

/**
 * Set selected items by their id. Replaces the current selection
 * Unknown id's are silently ignored.
 * @param {string[] | string} [ids]  An array with zero or more id's of the items to be
 *                                selected. If ids is an empty array, all items will be
 *                                unselected.
 * @param {Object} [options]      Available options:
 *                                `focus: boolean`
 *                                    If true, focus will be set to the selected item(s)
 *                                `animation: boolean | {duration: number, easingFunction: string}`
 *                                    If true (default), the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 *                                    Only applicable when option focus is true.
 */
Timeline.prototype.setSelection = function (ids, options) {
  this.itemSet && this.itemSet.setSelection(ids);

  if (options && options.focus) {
    this.focus(ids, options);
  }
};

/**
 * Get the selected items by their id
 * @return {Array} ids  The ids of the selected items
 */
Timeline.prototype.getSelection = function () {
  return this.itemSet && this.itemSet.getSelection() || [];
};

/**
 * Adjust the visible window such that the selected item (or multiple items)
 * are centered on screen.
 * @param {string | String[]} id     An item id or array with item ids
 * @param {Object} [options]      Available options:
 *                                `animation: boolean | {duration: number, easingFunction: string}`
 *                                    If true (default), the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 */
Timeline.prototype.focus = function (id, options) {
  if (!this.itemsData || id == undefined) return;

  var ids = Array.isArray(id) ? id : [id];

  // get the specified item(s)
  var itemsData = this.itemsData.getDataSet().get(ids, {
    type: {
      start: 'Date',
      end: 'Date'
    }
  });

  // calculate minimum start and maximum end of specified items
  var start = null;
  var end = null;
  itemsData.forEach(function (itemData) {
    var s = itemData.start.valueOf();
    var e = 'end' in itemData ? itemData.end.valueOf() : itemData.start.valueOf();

    if (start === null || s < start) {
      start = s;
    }

    if (end === null || e > end) {
      end = e;
    }
  });

  if (start !== null && end !== null) {
    var me = this;
    // Use the first item for the vertical focus
    var item = this.itemSet.items[ids[0]];
    var startPos = this._getScrollTop() * -1;
    var initialVerticalScroll = null;

    // Setup a handler for each frame of the vertical scroll
    var verticalAnimationFrame = function verticalAnimationFrame(ease, willDraw, done) {
      var verticalScroll = getItemVerticalScroll(me, item);

      if (!initialVerticalScroll) {
        initialVerticalScroll = verticalScroll;
      }

      if (initialVerticalScroll.itemTop == verticalScroll.itemTop && !initialVerticalScroll.shouldScroll) {
        return; // We don't need to scroll, so do nothing
      } else if (initialVerticalScroll.itemTop != verticalScroll.itemTop && verticalScroll.shouldScroll) {
        // The redraw shifted elements, so reset the animation to correct
        initialVerticalScroll = verticalScroll;
        startPos = me._getScrollTop() * -1;
      }

      var from = startPos;
      var to = initialVerticalScroll.scrollOffset;
      var scrollTop = done ? to : from + (to - from) * ease;

      me._setScrollTop(-scrollTop);

      if (!willDraw) {
        me._redraw();
      }
    };

    // Enforces the final vertical scroll position
    var setFinalVerticalPosition = function setFinalVerticalPosition() {
      var finalVerticalScroll = getItemVerticalScroll(me, item);

      if (finalVerticalScroll.shouldScroll && finalVerticalScroll.itemTop != initialVerticalScroll.itemTop) {
        me._setScrollTop(-finalVerticalScroll.scrollOffset);
        me._redraw();
      }
    };

    // Perform one last check at the end to make sure the final vertical
    // position is correct
    var finalVerticalCallback = function finalVerticalCallback() {
      // Double check we ended at the proper scroll position
      setFinalVerticalPosition();

      // Let the redraw settle and finalize the position.      
      setTimeout(setFinalVerticalPosition, 100);
    };

    // calculate the new middle and interval for the window
    var middle = (start + end) / 2;
    var interval = Math.max(this.range.end - this.range.start, (end - start) * 1.1);

    var animation = options && options.animation !== undefined ? options.animation : true;

    if (!animation) {
      // We aren't animating so set a default so that the final callback forces the vertical location
      initialVerticalScroll = { shouldScroll: false, scrollOffset: -1, itemTop: -1 };
    }

    this.range.setRange(middle - interval / 2, middle + interval / 2, { animation: animation }, finalVerticalCallback, verticalAnimationFrame);
  }
};

/**
 * Set Timeline window such that it fits all items
 * @param {Object} [options]  Available options:
 *                                `animation: boolean | {duration: number, easingFunction: string}`
 *                                    If true (default), the range is animated
 *                                    smoothly to the new window. An object can be
 *                                    provided to specify duration and easing function.
 *                                    Default duration is 500 ms, and default easing
 *                                    function is 'easeInOutQuad'.
 * @param {function} [callback]
 */
Timeline.prototype.fit = function (options, callback) {
  var animation = options && options.animation !== undefined ? options.animation : true;
  var range;

  var dataset = this.itemsData && this.itemsData.getDataSet();
  if (dataset.length === 1 && dataset.get()[0].end === undefined) {
    // a single item -> don't fit, just show a range around the item from -4 to +3 days
    range = this.getDataRange();
    this.moveTo(range.min.valueOf(), { animation: animation }, callback);
  } else {
    // exactly fit the items (plus a small margin)
    range = this.getItemRange();
    this.range.setRange(range.min, range.max, { animation: animation }, callback);
  }
};

/**
 *
 * @param {vis.Item} item
 * @returns {number}
 */
function getStart(item) {
  return util.convert(item.data.start, 'Date').valueOf();
}

/**
 *
 * @param {vis.Item} item
 * @returns {number}
 */
function getEnd(item) {
  var end = item.data.end != undefined ? item.data.end : item.data.start;
  return util.convert(end, 'Date').valueOf();
}

/**
 * @param {vis.Timeline} timeline
 * @param {vis.Item} item
 * @return {{shouldScroll: bool, scrollOffset: number, itemTop: number}}
 */
function getItemVerticalScroll(timeline, item) {
  var leftHeight = timeline.props.leftContainer.height;
  var contentHeight = timeline.props.left.height;

  var group = item.parent;
  var offset = group.top;
  var shouldScroll = true;
  var orientation = timeline.timeAxis.options.orientation.axis;

  var itemTop = function itemTop() {
    if (orientation == "bottom") {
      return group.height - item.top - item.height;
    } else {
      return item.top;
    }
  };

  var currentScrollHeight = timeline._getScrollTop() * -1;
  var targetOffset = offset + itemTop();
  var height = item.height;

  if (targetOffset < currentScrollHeight) {
    if (offset + leftHeight <= offset + itemTop() + height) {
      offset += itemTop() - timeline.itemSet.options.margin.item.vertical;
    }
  } else if (targetOffset + height > currentScrollHeight + leftHeight) {
    offset += itemTop() + height - leftHeight + timeline.itemSet.options.margin.item.vertical;
  } else {
    shouldScroll = false;
  }

  offset = Math.min(offset, contentHeight - leftHeight);

  return { shouldScroll: shouldScroll, scrollOffset: offset, itemTop: targetOffset };
}

/**
 * Determine the range of the items, taking into account their actual width
 * and a margin of 10 pixels on both sides.
 *
 * @returns {{min: Date, max: Date}}
 */
Timeline.prototype.getItemRange = function () {
  // get a rough approximation for the range based on the items start and end dates
  var range = this.getDataRange();
  var min = range.min !== null ? range.min.valueOf() : null;
  var max = range.max !== null ? range.max.valueOf() : null;
  var minItem = null;
  var maxItem = null;

  if (min != null && max != null) {
    var interval = max - min; // ms
    if (interval <= 0) {
      interval = 10;
    }
    var factor = interval / this.props.center.width;

    var redrawQueue = {};
    var redrawQueueLength = 0;

    // collect redraw functions
    util.forEach(this.itemSet.items, function (item, key) {
      if (item.groupShowing) {
        var returnQueue = true;
        redrawQueue[key] = item.redraw(returnQueue);
        redrawQueueLength = redrawQueue[key].length;
      }
    });

    var needRedraw = redrawQueueLength > 0;
    if (needRedraw) {
      // redraw all regular items
      for (var i = 0; i < redrawQueueLength; i++) {
        util.forEach(redrawQueue, function (fns) {
          fns[i]();
        });
      }
    }

    // calculate the date of the left side and right side of the items given
    util.forEach(this.itemSet.items, function (item) {
      var start = getStart(item);
      var end = getEnd(item);
      var startSide;
      var endSide;

      if (this.options.rtl) {
        startSide = start - (item.getWidthRight() + 10) * factor;
        endSide = end + (item.getWidthLeft() + 10) * factor;
      } else {
        startSide = start - (item.getWidthLeft() + 10) * factor;
        endSide = end + (item.getWidthRight() + 10) * factor;
      }

      if (startSide < min) {
        min = startSide;
        minItem = item;
      }
      if (endSide > max) {
        max = endSide;
        maxItem = item;
      }
    }.bind(this));

    if (minItem && maxItem) {
      var lhs = minItem.getWidthLeft() + 10;
      var rhs = maxItem.getWidthRight() + 10;
      var delta = this.props.center.width - lhs - rhs; // px

      if (delta > 0) {
        if (this.options.rtl) {
          min = getStart(minItem) - rhs * interval / delta; // ms
          max = getEnd(maxItem) + lhs * interval / delta; // ms
        } else {
          min = getStart(minItem) - lhs * interval / delta; // ms
          max = getEnd(maxItem) + rhs * interval / delta; // ms
        }
      }
    }
  }

  return {
    min: min != null ? new Date(min) : null,
    max: max != null ? new Date(max) : null
  };
};

/**
 * Calculate the data range of the items start and end dates
 * @returns {{min: Date, max: Date}}
 */
Timeline.prototype.getDataRange = function () {
  var min = null;
  var max = null;

  var dataset = this.itemsData && this.itemsData.getDataSet();
  if (dataset) {
    dataset.forEach(function (item) {
      var start = util.convert(item.start, 'Date').valueOf();
      var end = util.convert(item.end != undefined ? item.end : item.start, 'Date').valueOf();
      if (min === null || start < min) {
        min = start;
      }
      if (max === null || end > max) {
        max = end;
      }
    });
  }

  return {
    min: min != null ? new Date(min) : null,
    max: max != null ? new Date(max) : null
  };
};

/**
 * Generate Timeline related information from an event
 * @param {Event} event
 * @return {Object} An object with related information, like on which area
 *                  The event happened, whether clicked on an item, etc.
 */
Timeline.prototype.getEventProperties = function (event) {
  var clientX = event.center ? event.center.x : event.clientX;
  var clientY = event.center ? event.center.y : event.clientY;
  var x;
  if (this.options.rtl) {
    x = util.getAbsoluteRight(this.dom.centerContainer) - clientX;
  } else {
    x = clientX - util.getAbsoluteLeft(this.dom.centerContainer);
  }
  var y = clientY - util.getAbsoluteTop(this.dom.centerContainer);

  var item = this.itemSet.itemFromTarget(event);
  var group = this.itemSet.groupFromTarget(event);
  var customTime = CustomTime.customTimeFromTarget(event);

  var snap = this.itemSet.options.snap || null;
  var scale = this.body.util.getScale();
  var step = this.body.util.getStep();
  var time = this._toTime(x);
  var snappedTime = snap ? snap(time, scale, step) : time;

  var element = util.getTarget(event);
  var what = null;
  if (item != null) {
    what = 'item';
  } else if (customTime != null) {
    what = 'custom-time';
  } else if (util.hasParent(element, this.timeAxis.dom.foreground)) {
    what = 'axis';
  } else if (this.timeAxis2 && util.hasParent(element, this.timeAxis2.dom.foreground)) {
    what = 'axis';
  } else if (util.hasParent(element, this.itemSet.dom.labelSet)) {
    what = 'group-label';
  } else if (util.hasParent(element, this.currentTime.bar)) {
    what = 'current-time';
  } else if (util.hasParent(element, this.dom.center)) {
    what = 'background';
  }

  return {
    event: event,
    item: item ? item.id : null,
    group: group ? group.groupId : null,
    what: what,
    pageX: event.srcEvent ? event.srcEvent.pageX : event.pageX,
    pageY: event.srcEvent ? event.srcEvent.pageY : event.pageY,
    x: x,
    y: y,
    time: time,
    snappedTime: snappedTime
  };
};

/**
 * Toggle Timeline rolling mode
 */

Timeline.prototype.toggleRollingMode = function () {
  if (this.range.rolling) {
    this.range.stopRolling();
  } else {
    if (this.options.rollingMode == undefined) {
      this.setOptions(this.options);
    }
    this.range.startRolling();
  }
};

module.exports = Timeline;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(19);

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Hammer = __webpack_require__(10);
var hammerUtil = __webpack_require__(37);
var util = __webpack_require__(2);

/**
 * @param {number} [pixelRatio=1]
 */

var ColorPicker = function () {
  /**
   * @param {number} [pixelRatio=1]
   */
  function ColorPicker() {
    var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    (0, _classCallCheck3['default'])(this, ColorPicker);

    this.pixelRatio = pixelRatio;
    this.generated = false;
    this.centerCoordinates = { x: 289 / 2, y: 289 / 2 };
    this.r = 289 * 0.49;
    this.color = { r: 255, g: 255, b: 255, a: 1.0 };
    this.hueCircle = undefined;
    this.initialColor = { r: 255, g: 255, b: 255, a: 1.0 };
    this.previousColor = undefined;
    this.applied = false;

    // bound by
    this.updateCallback = function () {};
    this.closeCallback = function () {};

    // create all DOM elements
    this._create();
  }

  /**
   * this inserts the colorPicker into a div from the DOM
   * @param {Element} container
   */


  (0, _createClass3['default'])(ColorPicker, [{
    key: 'insertTo',
    value: function insertTo(container) {
      if (this.hammer !== undefined) {
        this.hammer.destroy();
        this.hammer = undefined;
      }
      this.container = container;
      this.container.appendChild(this.frame);
      this._bindHammer();

      this._setSize();
    }

    /**
     * the callback is executed on apply and save. Bind it to the application
     * @param {function} callback
     */

  }, {
    key: 'setUpdateCallback',
    value: function setUpdateCallback(callback) {
      if (typeof callback === 'function') {
        this.updateCallback = callback;
      } else {
        throw new Error("Function attempted to set as colorPicker update callback is not a function.");
      }
    }

    /**
     * the callback is executed on apply and save. Bind it to the application
     * @param {function} callback
     */

  }, {
    key: 'setCloseCallback',
    value: function setCloseCallback(callback) {
      if (typeof callback === 'function') {
        this.closeCallback = callback;
      } else {
        throw new Error("Function attempted to set as colorPicker closing callback is not a function.");
      }
    }

    /**
     *
     * @param {string} color
     * @returns {String}
     * @private
     */

  }, {
    key: '_isColorString',
    value: function _isColorString(color) {
      var htmlColors = { black: '#000000', navy: '#000080', darkblue: '#00008B', mediumblue: '#0000CD', blue: '#0000FF', darkgreen: '#006400', green: '#008000', teal: '#008080', darkcyan: '#008B8B', deepskyblue: '#00BFFF', darkturquoise: '#00CED1', mediumspringgreen: '#00FA9A', lime: '#00FF00', springgreen: '#00FF7F', aqua: '#00FFFF', cyan: '#00FFFF', midnightblue: '#191970', dodgerblue: '#1E90FF', lightseagreen: '#20B2AA', forestgreen: '#228B22', seagreen: '#2E8B57', darkslategray: '#2F4F4F', limegreen: '#32CD32', mediumseagreen: '#3CB371', turquoise: '#40E0D0', royalblue: '#4169E1', steelblue: '#4682B4', darkslateblue: '#483D8B', mediumturquoise: '#48D1CC', indigo: '#4B0082', darkolivegreen: '#556B2F', cadetblue: '#5F9EA0', cornflowerblue: '#6495ED', mediumaquamarine: '#66CDAA', dimgray: '#696969', slateblue: '#6A5ACD', olivedrab: '#6B8E23', slategray: '#708090', lightslategray: '#778899', mediumslateblue: '#7B68EE', lawngreen: '#7CFC00', chartreuse: '#7FFF00', aquamarine: '#7FFFD4', maroon: '#800000', purple: '#800080', olive: '#808000', gray: '#808080', skyblue: '#87CEEB', lightskyblue: '#87CEFA', blueviolet: '#8A2BE2', darkred: '#8B0000', darkmagenta: '#8B008B', saddlebrown: '#8B4513', darkseagreen: '#8FBC8F', lightgreen: '#90EE90', mediumpurple: '#9370D8', darkviolet: '#9400D3', palegreen: '#98FB98', darkorchid: '#9932CC', yellowgreen: '#9ACD32', sienna: '#A0522D', brown: '#A52A2A', darkgray: '#A9A9A9', lightblue: '#ADD8E6', greenyellow: '#ADFF2F', paleturquoise: '#AFEEEE', lightsteelblue: '#B0C4DE', powderblue: '#B0E0E6', firebrick: '#B22222', darkgoldenrod: '#B8860B', mediumorchid: '#BA55D3', rosybrown: '#BC8F8F', darkkhaki: '#BDB76B', silver: '#C0C0C0', mediumvioletred: '#C71585', indianred: '#CD5C5C', peru: '#CD853F', chocolate: '#D2691E', tan: '#D2B48C', lightgrey: '#D3D3D3', palevioletred: '#D87093', thistle: '#D8BFD8', orchid: '#DA70D6', goldenrod: '#DAA520', crimson: '#DC143C', gainsboro: '#DCDCDC', plum: '#DDA0DD', burlywood: '#DEB887', lightcyan: '#E0FFFF', lavender: '#E6E6FA', darksalmon: '#E9967A', violet: '#EE82EE', palegoldenrod: '#EEE8AA', lightcoral: '#F08080', khaki: '#F0E68C', aliceblue: '#F0F8FF', honeydew: '#F0FFF0', azure: '#F0FFFF', sandybrown: '#F4A460', wheat: '#F5DEB3', beige: '#F5F5DC', whitesmoke: '#F5F5F5', mintcream: '#F5FFFA', ghostwhite: '#F8F8FF', salmon: '#FA8072', antiquewhite: '#FAEBD7', linen: '#FAF0E6', lightgoldenrodyellow: '#FAFAD2', oldlace: '#FDF5E6', red: '#FF0000', fuchsia: '#FF00FF', magenta: '#FF00FF', deeppink: '#FF1493', orangered: '#FF4500', tomato: '#FF6347', hotpink: '#FF69B4', coral: '#FF7F50', darkorange: '#FF8C00', lightsalmon: '#FFA07A', orange: '#FFA500', lightpink: '#FFB6C1', pink: '#FFC0CB', gold: '#FFD700', peachpuff: '#FFDAB9', navajowhite: '#FFDEAD', moccasin: '#FFE4B5', bisque: '#FFE4C4', mistyrose: '#FFE4E1', blanchedalmond: '#FFEBCD', papayawhip: '#FFEFD5', lavenderblush: '#FFF0F5', seashell: '#FFF5EE', cornsilk: '#FFF8DC', lemonchiffon: '#FFFACD', floralwhite: '#FFFAF0', snow: '#FFFAFA', yellow: '#FFFF00', lightyellow: '#FFFFE0', ivory: '#FFFFF0', white: '#FFFFFF' };
      if (typeof color === 'string') {
        return htmlColors[color];
      }
    }

    /**
     * Set the color of the colorPicker
     * Supported formats:
     * 'red'                   --> HTML color string
     * '#ffffff'               --> hex string
     * 'rbg(255,255,255)'      --> rgb string
     * 'rgba(255,255,255,1.0)' --> rgba string
     * {r:255,g:255,b:255}     --> rgb object
     * {r:255,g:255,b:255,a:1.0} --> rgba object
     * @param {string|Object} color
     * @param {boolean} [setInitial=true]
     */

  }, {
    key: 'setColor',
    value: function setColor(color) {
      var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (color === 'none') {
        return;
      }

      var rgba = void 0;

      // if a html color shorthand is used, convert to hex
      var htmlColor = this._isColorString(color);
      if (htmlColor !== undefined) {
        color = htmlColor;
      }

      // check format
      if (util.isString(color) === true) {
        if (util.isValidRGB(color) === true) {
          var rgbaArray = color.substr(4).substr(0, color.length - 5).split(',');
          rgba = { r: rgbaArray[0], g: rgbaArray[1], b: rgbaArray[2], a: 1.0 };
        } else if (util.isValidRGBA(color) === true) {
          var _rgbaArray = color.substr(5).substr(0, color.length - 6).split(',');
          rgba = { r: _rgbaArray[0], g: _rgbaArray[1], b: _rgbaArray[2], a: _rgbaArray[3] };
        } else if (util.isValidHex(color) === true) {
          var rgbObj = util.hexToRGB(color);
          rgba = { r: rgbObj.r, g: rgbObj.g, b: rgbObj.b, a: 1.0 };
        }
      } else {
        if (color instanceof Object) {
          if (color.r !== undefined && color.g !== undefined && color.b !== undefined) {
            var alpha = color.a !== undefined ? color.a : '1.0';
            rgba = { r: color.r, g: color.g, b: color.b, a: alpha };
          }
        }
      }

      // set color
      if (rgba === undefined) {
        throw new Error("Unknown color passed to the colorPicker. Supported are strings: rgb, hex, rgba. Object: rgb ({r:r,g:g,b:b,[a:a]}). Supplied: " + (0, _stringify2['default'])(color));
      } else {
        this._setColor(rgba, setInitial);
      }
    }

    /**
     * this shows the color picker.
     * The hue circle is constructed once and stored.
     */

  }, {
    key: 'show',
    value: function show() {
      if (this.closeCallback !== undefined) {
        this.closeCallback();
        this.closeCallback = undefined;
      }

      this.applied = false;
      this.frame.style.display = 'block';
      this._generateHueCircle();
    }

    // ------------------------------------------ PRIVATE ----------------------------- //

    /**
     * Hide the picker. Is called by the cancel button.
     * Optional boolean to store the previous color for easy access later on.
     * @param {boolean} [storePrevious=true]
     * @private
     */

  }, {
    key: '_hide',
    value: function _hide() {
      var _this = this;

      var storePrevious = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      // store the previous color for next time;
      if (storePrevious === true) {
        this.previousColor = util.extend({}, this.color);
      }

      if (this.applied === true) {
        this.updateCallback(this.initialColor);
      }

      this.frame.style.display = 'none';

      // call the closing callback, restoring the onclick method.
      // this is in a setTimeout because it will trigger the show again before the click is done.
      setTimeout(function () {
        if (_this.closeCallback !== undefined) {
          _this.closeCallback();
          _this.closeCallback = undefined;
        }
      }, 0);
    }

    /**
     * bound to the save button. Saves and hides.
     * @private
     */

  }, {
    key: '_save',
    value: function _save() {
      this.updateCallback(this.color);
      this.applied = false;
      this._hide();
    }

    /**
     * Bound to apply button. Saves but does not close. Is undone by the cancel button.
     * @private
     */

  }, {
    key: '_apply',
    value: function _apply() {
      this.applied = true;
      this.updateCallback(this.color);
      this._updatePicker(this.color);
    }

    /**
     * load the color from the previous session.
     * @private
     */

  }, {
    key: '_loadLast',
    value: function _loadLast() {
      if (this.previousColor !== undefined) {
        this.setColor(this.previousColor, false);
      } else {
        alert("There is no last color to load...");
      }
    }

    /**
     * set the color, place the picker
     * @param {Object} rgba
     * @param {boolean} [setInitial=true]
     * @private
     */

  }, {
    key: '_setColor',
    value: function _setColor(rgba) {
      var setInitial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // store the initial color
      if (setInitial === true) {
        this.initialColor = util.extend({}, rgba);
      }

      this.color = rgba;
      var hsv = util.RGBToHSV(rgba.r, rgba.g, rgba.b);

      var angleConvert = 2 * Math.PI;
      var radius = this.r * hsv.s;
      var x = this.centerCoordinates.x + radius * Math.sin(angleConvert * hsv.h);
      var y = this.centerCoordinates.y + radius * Math.cos(angleConvert * hsv.h);

      this.colorPickerSelector.style.left = x - 0.5 * this.colorPickerSelector.clientWidth + 'px';
      this.colorPickerSelector.style.top = y - 0.5 * this.colorPickerSelector.clientHeight + 'px';

      this._updatePicker(rgba);
    }

    /**
     * bound to opacity control
     * @param {number} value
     * @private
     */

  }, {
    key: '_setOpacity',
    value: function _setOpacity(value) {
      this.color.a = value / 100;
      this._updatePicker(this.color);
    }

    /**
     * bound to brightness control
     * @param {number} value
     * @private
     */

  }, {
    key: '_setBrightness',
    value: function _setBrightness(value) {
      var hsv = util.RGBToHSV(this.color.r, this.color.g, this.color.b);
      hsv.v = value / 100;
      var rgba = util.HSVToRGB(hsv.h, hsv.s, hsv.v);
      rgba['a'] = this.color.a;
      this.color = rgba;
      this._updatePicker();
    }

    /**
     * update the color picker. A black circle overlays the hue circle to mimic the brightness decreasing.
     * @param {Object} rgba
     * @private
     */

  }, {
    key: '_updatePicker',
    value: function _updatePicker() {
      var rgba = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.color;

      var hsv = util.RGBToHSV(rgba.r, rgba.g, rgba.b);
      var ctx = this.colorPickerCanvas.getContext('2d');
      if (this.pixelRation === undefined) {
        this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
      }
      ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);

      // clear the canvas
      var w = this.colorPickerCanvas.clientWidth;
      var h = this.colorPickerCanvas.clientHeight;
      ctx.clearRect(0, 0, w, h);

      ctx.putImageData(this.hueCircle, 0, 0);
      ctx.fillStyle = 'rgba(0,0,0,' + (1 - hsv.v) + ')';
      ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
      ctx.fill();

      this.brightnessRange.value = 100 * hsv.v;
      this.opacityRange.value = 100 * rgba.a;

      this.initialColorDiv.style.backgroundColor = 'rgba(' + this.initialColor.r + ',' + this.initialColor.g + ',' + this.initialColor.b + ',' + this.initialColor.a + ')';
      this.newColorDiv.style.backgroundColor = 'rgba(' + this.color.r + ',' + this.color.g + ',' + this.color.b + ',' + this.color.a + ')';
    }

    /**
     * used by create to set the size of the canvas.
     * @private
     */

  }, {
    key: '_setSize',
    value: function _setSize() {
      this.colorPickerCanvas.style.width = '100%';
      this.colorPickerCanvas.style.height = '100%';

      this.colorPickerCanvas.width = 289 * this.pixelRatio;
      this.colorPickerCanvas.height = 289 * this.pixelRatio;
    }

    /**
     * create all dom elements
     * TODO: cleanup, lots of similar dom elements
     * @private
     */

  }, {
    key: '_create',
    value: function _create() {
      this.frame = document.createElement('div');
      this.frame.className = 'vis-color-picker';

      this.colorPickerDiv = document.createElement('div');
      this.colorPickerSelector = document.createElement('div');
      this.colorPickerSelector.className = 'vis-selector';
      this.colorPickerDiv.appendChild(this.colorPickerSelector);

      this.colorPickerCanvas = document.createElement('canvas');
      this.colorPickerDiv.appendChild(this.colorPickerCanvas);

      if (!this.colorPickerCanvas.getContext) {
        var noCanvas = document.createElement('DIV');
        noCanvas.style.color = 'red';
        noCanvas.style.fontWeight = 'bold';
        noCanvas.style.padding = '10px';
        noCanvas.innerHTML = 'Error: your browser does not support HTML canvas';
        this.colorPickerCanvas.appendChild(noCanvas);
      } else {
        var ctx = this.colorPickerCanvas.getContext("2d");
        this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);

        this.colorPickerCanvas.getContext("2d").setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      }

      this.colorPickerDiv.className = 'vis-color';

      this.opacityDiv = document.createElement('div');
      this.opacityDiv.className = 'vis-opacity';

      this.brightnessDiv = document.createElement('div');
      this.brightnessDiv.className = 'vis-brightness';

      this.arrowDiv = document.createElement('div');
      this.arrowDiv.className = 'vis-arrow';

      this.opacityRange = document.createElement('input');
      try {
        this.opacityRange.type = 'range'; // Not supported on IE9
        this.opacityRange.min = '0';
        this.opacityRange.max = '100';
      }
      // TODO: Add some error handling and remove this lint exception
      catch (err) {} // eslint-disable-line no-empty
      this.opacityRange.value = '100';
      this.opacityRange.className = 'vis-range';

      this.brightnessRange = document.createElement('input');
      try {
        this.brightnessRange.type = 'range'; // Not supported on IE9
        this.brightnessRange.min = '0';
        this.brightnessRange.max = '100';
      }
      // TODO: Add some error handling and remove this lint exception
      catch (err) {} // eslint-disable-line no-empty
      this.brightnessRange.value = '100';
      this.brightnessRange.className = 'vis-range';

      this.opacityDiv.appendChild(this.opacityRange);
      this.brightnessDiv.appendChild(this.brightnessRange);

      var me = this;
      this.opacityRange.onchange = function () {
        me._setOpacity(this.value);
      };
      this.opacityRange.oninput = function () {
        me._setOpacity(this.value);
      };
      this.brightnessRange.onchange = function () {
        me._setBrightness(this.value);
      };
      this.brightnessRange.oninput = function () {
        me._setBrightness(this.value);
      };

      this.brightnessLabel = document.createElement("div");
      this.brightnessLabel.className = "vis-label vis-brightness";
      this.brightnessLabel.innerHTML = 'brightness:';

      this.opacityLabel = document.createElement("div");
      this.opacityLabel.className = "vis-label vis-opacity";
      this.opacityLabel.innerHTML = 'opacity:';

      this.newColorDiv = document.createElement("div");
      this.newColorDiv.className = "vis-new-color";
      this.newColorDiv.innerHTML = 'new';

      this.initialColorDiv = document.createElement("div");
      this.initialColorDiv.className = "vis-initial-color";
      this.initialColorDiv.innerHTML = 'initial';

      this.cancelButton = document.createElement("div");
      this.cancelButton.className = "vis-button vis-cancel";
      this.cancelButton.innerHTML = 'cancel';
      this.cancelButton.onclick = this._hide.bind(this, false);

      this.applyButton = document.createElement("div");
      this.applyButton.className = "vis-button vis-apply";
      this.applyButton.innerHTML = 'apply';
      this.applyButton.onclick = this._apply.bind(this);

      this.saveButton = document.createElement("div");
      this.saveButton.className = "vis-button vis-save";
      this.saveButton.innerHTML = 'save';
      this.saveButton.onclick = this._save.bind(this);

      this.loadButton = document.createElement("div");
      this.loadButton.className = "vis-button vis-load";
      this.loadButton.innerHTML = 'load last';
      this.loadButton.onclick = this._loadLast.bind(this);

      this.frame.appendChild(this.colorPickerDiv);
      this.frame.appendChild(this.arrowDiv);
      this.frame.appendChild(this.brightnessLabel);
      this.frame.appendChild(this.brightnessDiv);
      this.frame.appendChild(this.opacityLabel);
      this.frame.appendChild(this.opacityDiv);
      this.frame.appendChild(this.newColorDiv);
      this.frame.appendChild(this.initialColorDiv);

      this.frame.appendChild(this.cancelButton);
      this.frame.appendChild(this.applyButton);
      this.frame.appendChild(this.saveButton);
      this.frame.appendChild(this.loadButton);
    }

    /**
     * bind hammer to the color picker
     * @private
     */

  }, {
    key: '_bindHammer',
    value: function _bindHammer() {
      var _this2 = this;

      this.drag = {};
      this.pinch = {};
      this.hammer = new Hammer(this.colorPickerCanvas);
      this.hammer.get('pinch').set({ enable: true });

      hammerUtil.onTouch(this.hammer, function (event) {
        _this2._moveSelector(event);
      });
      this.hammer.on('tap', function (event) {
        _this2._moveSelector(event);
      });
      this.hammer.on('panstart', function (event) {
        _this2._moveSelector(event);
      });
      this.hammer.on('panmove', function (event) {
        _this2._moveSelector(event);
      });
      this.hammer.on('panend', function (event) {
        _this2._moveSelector(event);
      });
    }

    /**
     * generate the hue circle. This is relatively heavy (200ms) and is done only once on the first time it is shown.
     * @private
     */

  }, {
    key: '_generateHueCircle',
    value: function _generateHueCircle() {
      if (this.generated === false) {
        var ctx = this.colorPickerCanvas.getContext('2d');
        if (this.pixelRation === undefined) {
          this.pixelRatio = (window.devicePixelRatio || 1) / (ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1);
        }
        ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);

        // clear the canvas
        var w = this.colorPickerCanvas.clientWidth;
        var h = this.colorPickerCanvas.clientHeight;
        ctx.clearRect(0, 0, w, h);

        // draw hue circle
        var x = void 0,
            y = void 0,
            hue = void 0,
            sat = void 0;
        this.centerCoordinates = { x: w * 0.5, y: h * 0.5 };
        this.r = 0.49 * w;
        var angleConvert = 2 * Math.PI / 360;
        var hfac = 1 / 360;
        var sfac = 1 / this.r;
        var rgb = void 0;
        for (hue = 0; hue < 360; hue++) {
          for (sat = 0; sat < this.r; sat++) {
            x = this.centerCoordinates.x + sat * Math.sin(angleConvert * hue);
            y = this.centerCoordinates.y + sat * Math.cos(angleConvert * hue);
            rgb = util.HSVToRGB(hue * hfac, sat * sfac, 1);
            ctx.fillStyle = 'rgb(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ')';
            ctx.fillRect(x - 0.5, y - 0.5, 2, 2);
          }
        }
        ctx.strokeStyle = 'rgba(0,0,0,1)';
        ctx.circle(this.centerCoordinates.x, this.centerCoordinates.y, this.r);
        ctx.stroke();

        this.hueCircle = ctx.getImageData(0, 0, w, h);
      }
      this.generated = true;
    }

    /**
     * move the selector. This is called by hammer functions.
     *
     * @param {Event}  event   The event
     * @private
     */

  }, {
    key: '_moveSelector',
    value: function _moveSelector(event) {
      var rect = this.colorPickerDiv.getBoundingClientRect();
      var left = event.center.x - rect.left;
      var top = event.center.y - rect.top;

      var centerY = 0.5 * this.colorPickerDiv.clientHeight;
      var centerX = 0.5 * this.colorPickerDiv.clientWidth;

      var x = left - centerX;
      var y = top - centerY;

      var angle = Math.atan2(x, y);
      var radius = 0.98 * Math.min(Math.sqrt(x * x + y * y), centerX);

      var newTop = Math.cos(angle) * radius + centerY;
      var newLeft = Math.sin(angle) * radius + centerX;

      this.colorPickerSelector.style.top = newTop - 0.5 * this.colorPickerSelector.clientHeight + 'px';
      this.colorPickerSelector.style.left = newLeft - 0.5 * this.colorPickerSelector.clientWidth + 'px';

      // set color
      var h = angle / (2 * Math.PI);
      h = h < 0 ? h + 1 : h;
      var s = radius / this.r;
      var hsv = util.RGBToHSV(this.color.r, this.color.g, this.color.b);
      hsv.h = h;
      hsv.s = s;
      var rgba = util.HSVToRGB(hsv.h, hsv.s, hsv.v);
      rgba['a'] = this.color.a;
      this.color = rgba;

      // update previews
      this.initialColorDiv.style.backgroundColor = 'rgba(' + this.initialColor.r + ',' + this.initialColor.g + ',' + this.initialColor.b + ',' + this.initialColor.a + ')';
      this.newColorDiv.style.backgroundColor = 'rgba(' + this.color.r + ',' + this.color.g + ',' + this.color.b + ',' + this.color.a + ')';
    }
  }]);
  return ColorPicker;
}();

exports['default'] = ColorPicker;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var moment = __webpack_require__(9);
var util = __webpack_require__(2);
var DataSet = __webpack_require__(11);
var DataView = __webpack_require__(12);
var Range = __webpack_require__(64);
var Core = __webpack_require__(65);
var TimeAxis = __webpack_require__(45);
var CurrentTime = __webpack_require__(67);
var CustomTime = __webpack_require__(46);
var LineGraph = __webpack_require__(106);

var printStyle = __webpack_require__(15).printStyle;
var allOptions = __webpack_require__(113).allOptions;
var configureOptions = __webpack_require__(113).configureOptions;

var Configurator = __webpack_require__(71)['default'];
var Validator = __webpack_require__(15)['default'];

/**
 * Create a timeline visualization
 * @param {HTMLElement} container
 * @param {vis.DataSet | Array} [items]
 * @param {vis.DataSet | Array | vis.DataView | Object} [groups]
 * @param {Object} [options]  See Graph2d.setOptions for the available options.
 * @constructor Graph2d
 * @extends Core
 */
function Graph2d(container, items, groups, options) {
  // if the third element is options, the forth is groups (optionally);
  if (!(Array.isArray(groups) || groups instanceof DataSet || groups instanceof DataView) && groups instanceof Object) {
    var forthArgument = options;
    options = groups;
    groups = forthArgument;
  }

  // TODO: REMOVE THIS in the next MAJOR release
  // see https://github.com/almende/vis/issues/2511
  if (options && options.throttleRedraw) {
    console.warn("Graph2d option \"throttleRedraw\" is DEPRICATED and no longer supported. It will be removed in the next MAJOR release.");
  }

  var me = this;
  this.defaultOptions = {
    start: null,
    end: null,

    autoResize: true,

    orientation: {
      axis: 'bottom', // axis orientation: 'bottom', 'top', or 'both'
      item: 'bottom' // not relevant for Graph2d
    },

    moment: moment,

    width: null,
    height: null,
    maxHeight: null,
    minHeight: null
  };
  this.options = util.deepExtend({}, this.defaultOptions);

  // Create the DOM, props, and emitter
  this._create(container);

  // all components listed here will be repainted automatically
  this.components = [];

  this.body = {
    dom: this.dom,
    domProps: this.props,
    emitter: {
      on: this.on.bind(this),
      off: this.off.bind(this),
      emit: this.emit.bind(this)
    },
    hiddenDates: [],
    util: {
      toScreen: me._toScreen.bind(me),
      toGlobalScreen: me._toGlobalScreen.bind(me), // this refers to the root.width
      toTime: me._toTime.bind(me),
      toGlobalTime: me._toGlobalTime.bind(me)
    }
  };

  // range
  this.range = new Range(this.body);
  this.components.push(this.range);
  this.body.range = this.range;

  // time axis
  this.timeAxis = new TimeAxis(this.body);
  this.components.push(this.timeAxis);
  //this.body.util.snap = this.timeAxis.snap.bind(this.timeAxis);

  // current time bar
  this.currentTime = new CurrentTime(this.body);
  this.components.push(this.currentTime);

  // item set
  this.linegraph = new LineGraph(this.body);

  this.components.push(this.linegraph);

  this.itemsData = null; // DataSet
  this.groupsData = null; // DataSet


  this.on('tap', function (event) {
    me.emit('click', me.getEventProperties(event));
  });
  this.on('doubletap', function (event) {
    me.emit('doubleClick', me.getEventProperties(event));
  });
  this.dom.root.oncontextmenu = function (event) {
    me.emit('contextmenu', me.getEventProperties(event));
  };

  // apply options
  if (options) {
    this.setOptions(options);
  }

  // IMPORTANT: THIS HAPPENS BEFORE SET ITEMS!
  if (groups) {
    this.setGroups(groups);
  }

  // create itemset
  if (items) {
    this.setItems(items);
  }

  // draw for the first time
  this._redraw();
}

// Extend the functionality from Core
Graph2d.prototype = new Core();

Graph2d.prototype.setOptions = function (options) {
  // validate options
  var errorFound = Validator.validate(options, allOptions);
  if (errorFound === true) {
    console.log('%cErrors have been found in the supplied options object.', printStyle);
  }

  Core.prototype.setOptions.call(this, options);
};

/**
 * Set items
 * @param {vis.DataSet | Array | null} items
 */
Graph2d.prototype.setItems = function (items) {
  var initialLoad = this.itemsData == null;

  // convert to type DataSet when needed
  var newDataSet;
  if (!items) {
    newDataSet = null;
  } else if (items instanceof DataSet || items instanceof DataView) {
    newDataSet = items;
  } else {
    // turn an array into a dataset
    newDataSet = new DataSet(items, {
      type: {
        start: 'Date',
        end: 'Date'
      }
    });
  }

  // set items
  this.itemsData = newDataSet;
  this.linegraph && this.linegraph.setItems(newDataSet);

  if (initialLoad) {
    if (this.options.start != undefined || this.options.end != undefined) {
      var start = this.options.start != undefined ? this.options.start : null;
      var end = this.options.end != undefined ? this.options.end : null;
      this.setWindow(start, end, { animation: false });
    } else {
      this.fit({ animation: false });
    }
  }
};

/**
 * Set groups
 * @param {vis.DataSet | Array} groups
 */
Graph2d.prototype.setGroups = function (groups) {
  // convert to type DataSet when needed
  var newDataSet;
  if (!groups) {
    newDataSet = null;
  } else if (groups instanceof DataSet || groups instanceof DataView) {
    newDataSet = groups;
  } else {
    // turn an array into a dataset
    newDataSet = new DataSet(groups);
  }

  this.groupsData = newDataSet;
  this.linegraph.setGroups(newDataSet);
};

/**
 * Returns an object containing an SVG element with the icon of the group (size determined by iconWidth and iconHeight), the label of the group (content) and the yAxisOrientation of the group (left or right).
 * @param {vis.GraphGroup.id} groupId
 * @param {number} width
 * @param {number} height
 * @returns {{icon: SVGElement, label: string, orientation: string}|string}
 */
Graph2d.prototype.getLegend = function (groupId, width, height) {
  if (width === undefined) {
    width = 15;
  }
  if (height === undefined) {
    height = 15;
  }
  if (this.linegraph.groups[groupId] !== undefined) {
    return this.linegraph.groups[groupId].getLegend(width, height);
  } else {
    return "cannot find group:'" + groupId + "'";
  }
};

/**
 * This checks if the visible option of the supplied group (by ID) is true or false.
 * @param {vis.GraphGroup.id} groupId
 * @returns {boolean}
 */
Graph2d.prototype.isGroupVisible = function (groupId) {
  if (this.linegraph.groups[groupId] !== undefined) {
    return this.linegraph.groups[groupId].visible && (this.linegraph.options.groups.visibility[groupId] === undefined || this.linegraph.options.groups.visibility[groupId] == true);
  } else {
    return false;
  }
};

/**
 * Get the data range of the item set.
 * @returns {{min: Date, max: Date}} range  A range with a start and end Date.
 *                                          When no minimum is found, min==null
 *                                          When no maximum is found, max==null
 */
Graph2d.prototype.getDataRange = function () {
  var min = null;
  var max = null;

  // calculate min from start filed
  for (var groupId in this.linegraph.groups) {
    if (this.linegraph.groups.hasOwnProperty(groupId)) {
      if (this.linegraph.groups[groupId].visible == true) {
        for (var i = 0; i < this.linegraph.groups[groupId].itemsData.length; i++) {
          var item = this.linegraph.groups[groupId].itemsData[i];
          var value = util.convert(item.x, 'Date').valueOf();
          min = min == null ? value : min > value ? value : min;
          max = max == null ? value : max < value ? value : max;
        }
      }
    }
  }

  return {
    min: min != null ? new Date(min) : null,
    max: max != null ? new Date(max) : null
  };
};

/**
 * Generate Timeline related information from an event
 * @param {Event} event
 * @return {Object} An object with related information, like on which area
 *                  The event happened, whether clicked on an item, etc.
 */
Graph2d.prototype.getEventProperties = function (event) {
  var clientX = event.center ? event.center.x : event.clientX;
  var clientY = event.center ? event.center.y : event.clientY;
  var x = clientX - util.getAbsoluteLeft(this.dom.centerContainer);
  var y = clientY - util.getAbsoluteTop(this.dom.centerContainer);
  var time = this._toTime(x);

  var customTime = CustomTime.customTimeFromTarget(event);

  var element = util.getTarget(event);
  var what = null;
  if (util.hasParent(element, this.timeAxis.dom.foreground)) {
    what = 'axis';
  } else if (this.timeAxis2 && util.hasParent(element, this.timeAxis2.dom.foreground)) {
    what = 'axis';
  } else if (util.hasParent(element, this.linegraph.yAxisLeft.dom.frame)) {
    what = 'data-axis';
  } else if (util.hasParent(element, this.linegraph.yAxisRight.dom.frame)) {
    what = 'data-axis';
  } else if (util.hasParent(element, this.linegraph.legendLeft.dom.frame)) {
    what = 'legend';
  } else if (util.hasParent(element, this.linegraph.legendRight.dom.frame)) {
    what = 'legend';
  } else if (customTime != null) {
    what = 'custom-time';
  } else if (util.hasParent(element, this.currentTime.bar)) {
    what = 'current-time';
  } else if (util.hasParent(element, this.dom.center)) {
    what = 'background';
  }

  var value = [];
  var yAxisLeft = this.linegraph.yAxisLeft;
  var yAxisRight = this.linegraph.yAxisRight;
  if (!yAxisLeft.hidden && this.itemsData.length > 0) {
    value.push(yAxisLeft.screenToValue(y));
  }
  if (!yAxisRight.hidden && this.itemsData.length > 0) {
    value.push(yAxisRight.screenToValue(y));
  }

  return {
    event: event,
    what: what,
    pageX: event.srcEvent ? event.srcEvent.pageX : event.pageX,
    pageY: event.srcEvent ? event.srcEvent.pageY : event.pageY,
    x: x,
    y: y,
    time: time,
    value: value
  };
};

/**
 * Load a configurator
 * @return {Object}
 * @private
 */
Graph2d.prototype._createConfigurator = function () {
  return new Configurator(this, this.dom.container, configureOptions);
};

module.exports = Graph2d;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// utils
exports.util = __webpack_require__(2);
exports.DOMutil = __webpack_require__(14);

// data
exports.DataSet = __webpack_require__(11);
exports.DataView = __webpack_require__(12);
exports.Queue = __webpack_require__(43);

// Network
exports.Network = __webpack_require__(182);
exports.network = {
  Images: __webpack_require__(116),
  dotparser: __webpack_require__(114),
  gephiParser: __webpack_require__(115),
  allOptions: __webpack_require__(122)
};
exports.network.convertDot = function (input) {
  return exports.network.dotparser.DOTToGraph(input);
};
exports.network.convertGephi = function (input, options) {
  return exports.network.gephiParser.parseGephi(input, options);
};

// bundled external libraries
exports.moment = __webpack_require__(9);
exports.Hammer = __webpack_require__(10);
exports.keycharm = __webpack_require__(35);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Load custom shapes into CanvasRenderingContext2D
__webpack_require__(183);

var Emitter = __webpack_require__(44);
var util = __webpack_require__(2);
var dotparser = __webpack_require__(114);
var gephiParser = __webpack_require__(115);
var Activator = __webpack_require__(97);
var locales = __webpack_require__(184);

var Images = __webpack_require__(116)['default'];
var Groups = __webpack_require__(186)['default'];
var NodesHandler = __webpack_require__(187)['default'];
var EdgesHandler = __webpack_require__(214)['default'];
var PhysicsEngine = __webpack_require__(220)['default'];
var ClusterEngine = __webpack_require__(227)['default'];
var CanvasRenderer = __webpack_require__(229)['default'];
var Canvas = __webpack_require__(230)['default'];
var View = __webpack_require__(231)['default'];
var InteractionHandler = __webpack_require__(232)['default'];
var SelectionHandler = __webpack_require__(234)['default'];
var LayoutEngine = __webpack_require__(235)['default'];
var ManipulationSystem = __webpack_require__(237)['default'];
var Configurator = __webpack_require__(71)['default'];
var Validator = __webpack_require__(15)['default'];

var _require = __webpack_require__(15),
    printStyle = _require.printStyle;

var _require2 = __webpack_require__(122),
    allOptions = _require2.allOptions,
    configureOptions = _require2.configureOptions;

var KamadaKawai = __webpack_require__(238)['default'];

/**
 * Create a network visualization, displaying nodes and edges.
 *
 * @param {Element} container   The DOM element in which the Network will
 *                                  be created. Normally a div element.
 * @param {Object} data         An object containing parameters
 *                              {Array} nodes
 *                              {Array} edges
 * @param {Object} options      Options
 * @constructor Network
 */
function Network(container, data, options) {
  var _this = this;

  if (!(this instanceof Network)) {
    throw new SyntaxError('Constructor must be called with the new operator');
  }

  // set constant values
  this.options = {};
  this.defaultOptions = {
    locale: 'en',
    locales: locales,
    clickToUse: false
  };
  util.extend(this.options, this.defaultOptions);

  /**
   * Containers for nodes and edges.
   *
   * 'edges' and 'nodes' contain the full definitions of all the network elements.
   * 'nodeIndices' and 'edgeIndices' contain the id's of the active elements.
   *
   * The distinction is important, because a defined node need not be active, i.e.
   * visible on the canvas. This happens in particular when clusters are defined, in
   * that case there will be nodes and edges not displayed.
   * The bottom line is that all code with actions related to visibility, *must* use
   * 'nodeIndices' and 'edgeIndices', not 'nodes' and 'edges' directly.
   */
  this.body = {
    container: container,

    // See comment above for following fields
    nodes: {},
    nodeIndices: [],
    edges: {},
    edgeIndices: [],

    emitter: {
      on: this.on.bind(this),
      off: this.off.bind(this),
      emit: this.emit.bind(this),
      once: this.once.bind(this)
    },
    eventListeners: {
      onTap: function onTap() {},
      onTouch: function onTouch() {},
      onDoubleTap: function onDoubleTap() {},
      onHold: function onHold() {},
      onDragStart: function onDragStart() {},
      onDrag: function onDrag() {},
      onDragEnd: function onDragEnd() {},
      onMouseWheel: function onMouseWheel() {},
      onPinch: function onPinch() {},
      onMouseMove: function onMouseMove() {},
      onRelease: function onRelease() {},
      onContext: function onContext() {}
    },
    data: {
      nodes: null, // A DataSet or DataView
      edges: null // A DataSet or DataView
    },
    functions: {
      createNode: function createNode() {},
      createEdge: function createEdge() {},
      getPointer: function getPointer() {}
    },
    modules: {},
    view: {
      scale: 1,
      translation: { x: 0, y: 0 }
    }
  };

  // bind the event listeners
  this.bindEventListeners();

  // setting up all modules
  this.images = new Images(function () {
    return _this.body.emitter.emit("_requestRedraw");
  }); // object with images
  this.groups = new Groups(); // object with groups
  this.canvas = new Canvas(this.body); // DOM handler
  this.selectionHandler = new SelectionHandler(this.body, this.canvas); // Selection handler
  this.interactionHandler = new InteractionHandler(this.body, this.canvas, this.selectionHandler); // Interaction handler handles all the hammer bindings (that are bound by canvas), key
  this.view = new View(this.body, this.canvas); // camera handler, does animations and zooms
  this.renderer = new CanvasRenderer(this.body, this.canvas); // renderer, starts renderloop, has events that modules can hook into
  this.physics = new PhysicsEngine(this.body); // physics engine, does all the simulations
  this.layoutEngine = new LayoutEngine(this.body); // layout engine for inital layout and hierarchical layout
  this.clustering = new ClusterEngine(this.body); // clustering api
  this.manipulation = new ManipulationSystem(this.body, this.canvas, this.selectionHandler); // data manipulation system

  this.nodesHandler = new NodesHandler(this.body, this.images, this.groups, this.layoutEngine); // Handle adding, deleting and updating of nodes as well as global options
  this.edgesHandler = new EdgesHandler(this.body, this.images, this.groups); // Handle adding, deleting and updating of edges as well as global options

  this.body.modules["kamadaKawai"] = new KamadaKawai(this.body, 150, 0.05); // Layouting algorithm.
  this.body.modules["clustering"] = this.clustering;

  // create the DOM elements
  this.canvas._create();

  // apply options
  this.setOptions(options);

  // load data (the disable start variable will be the same as the enabled clustering)
  this.setData(data);
}

// Extend Network with an Emitter mixin
Emitter(Network.prototype);

/**
 * Set options
 * @param {Object} options
 */
Network.prototype.setOptions = function (options) {
  var _this2 = this;

  if (options !== undefined) {
    var errorFound = Validator.validate(options, allOptions);
    if (errorFound === true) {
      console.log('%cErrors have been found in the supplied options object.', printStyle);
    }

    // copy the global fields over
    var fields = ['locale', 'locales', 'clickToUse'];
    util.selectiveDeepExtend(fields, this.options, options);

    // the hierarchical system can adapt the edges and the physics to it's own options because not all combinations work with the hierarichical system.
    options = this.layoutEngine.setOptions(options.layout, options);

    this.canvas.setOptions(options); // options for canvas are in globals

    // pass the options to the modules
    this.groups.setOptions(options.groups);
    this.nodesHandler.setOptions(options.nodes);
    this.edgesHandler.setOptions(options.edges);
    this.physics.setOptions(options.physics);
    this.manipulation.setOptions(options.manipulation, options, this.options); // manipulation uses the locales in the globals

    this.interactionHandler.setOptions(options.interaction);
    this.renderer.setOptions(options.interaction); // options for rendering are in interaction
    this.selectionHandler.setOptions(options.interaction); // options for selection are in interaction

    // reload the settings of the nodes to apply changes in groups that are not referenced by pointer.
    if (options.groups !== undefined) {
      this.body.emitter.emit("refreshNodes");
    }
    // these two do not have options at the moment, here for completeness
    //this.view.setOptions(options.view);
    //this.clustering.setOptions(options.clustering);

    if ('configure' in options) {
      if (!this.configurator) {
        this.configurator = new Configurator(this, this.body.container, configureOptions, this.canvas.pixelRatio);
      }

      this.configurator.setOptions(options.configure);
    }

    // if the configuration system is enabled, copy all options and put them into the config system
    if (this.configurator && this.configurator.options.enabled === true) {
      var networkOptions = { nodes: {}, edges: {}, layout: {}, interaction: {}, manipulation: {}, physics: {}, global: {} };
      util.deepExtend(networkOptions.nodes, this.nodesHandler.options);
      util.deepExtend(networkOptions.edges, this.edgesHandler.options);
      util.deepExtend(networkOptions.layout, this.layoutEngine.options);
      // load the selectionHandler and render default options in to the interaction group
      util.deepExtend(networkOptions.interaction, this.selectionHandler.options);
      util.deepExtend(networkOptions.interaction, this.renderer.options);

      util.deepExtend(networkOptions.interaction, this.interactionHandler.options);
      util.deepExtend(networkOptions.manipulation, this.manipulation.options);
      util.deepExtend(networkOptions.physics, this.physics.options);

      // load globals into the global object
      util.deepExtend(networkOptions.global, this.canvas.options);
      util.deepExtend(networkOptions.global, this.options);

      this.configurator.setModuleOptions(networkOptions);
    }

    // handle network global options
    if (options.clickToUse !== undefined) {
      if (options.clickToUse === true) {
        if (this.activator === undefined) {
          this.activator = new Activator(this.canvas.frame);
          this.activator.on('change', function () {
            _this2.body.emitter.emit("activate");
          });
        }
      } else {
        if (this.activator !== undefined) {
          this.activator.destroy();
          delete this.activator;
        }
        this.body.emitter.emit("activate");
      }
    } else {
      this.body.emitter.emit("activate");
    }

    this.canvas.setSize();
    // start the physics simulation. Can be safely called multiple times.
    this.body.emitter.emit("startSimulation");
  }
};

/**
 * Update the visible nodes and edges list with the most recent node state.
 *
 * Visible nodes are stored in this.body.nodeIndices.
 * Visible edges are stored in this.body.edgeIndices.
 * A node or edges is visible if it is not hidden or clustered.
 *
 * @private
 */
Network.prototype._updateVisibleIndices = function () {
  var nodes = this.body.nodes;
  var edges = this.body.edges;
  this.body.nodeIndices = [];
  this.body.edgeIndices = [];

  for (var nodeId in nodes) {
    if (nodes.hasOwnProperty(nodeId)) {
      if (!this.clustering._isClusteredNode(nodeId) && nodes[nodeId].options.hidden === false) {
        this.body.nodeIndices.push(nodes[nodeId].id);
      }
    }
  }

  for (var edgeId in edges) {
    if (edges.hasOwnProperty(edgeId)) {
      var edge = edges[edgeId];

      // It can happen that this is executed *after* a node edge has been removed,
      // but *before* the edge itself has been removed. Taking this into account.
      var fromNode = nodes[edge.fromId];
      var toNode = nodes[edge.toId];
      var edgeNodesPresent = fromNode !== undefined && toNode !== undefined;

      var isVisible = !this.clustering._isClusteredEdge(edgeId) && edge.options.hidden === false && edgeNodesPresent && fromNode.options.hidden === false // Also hidden if any of its connecting nodes are hidden
      && toNode.options.hidden === false; // idem

      if (isVisible) {
        this.body.edgeIndices.push(edge.id);
      }
    }
  }
};

/**
 * Bind all events
 */
Network.prototype.bindEventListeners = function () {
  var _this3 = this;

  // This event will trigger a rebuilding of the cache everything.
  // Used when nodes or edges have been added or removed.
  this.body.emitter.on("_dataChanged", function () {
    _this3.edgesHandler._updateState();
    _this3.body.emitter.emit("_dataUpdated");
  });

  // this is called when options of EXISTING nodes or edges have changed.
  this.body.emitter.on("_dataUpdated", function () {
    // Order important in following block
    _this3.clustering._updateState();
    _this3._updateVisibleIndices();

    _this3._updateValueRange(_this3.body.nodes);
    _this3._updateValueRange(_this3.body.edges);
    // start simulation (can be called safely, even if already running)
    _this3.body.emitter.emit("startSimulation");
    _this3.body.emitter.emit("_requestRedraw");
  });
};

/**
 * Set nodes and edges, and optionally options as well.
 *
 * @param {Object} data              Object containing parameters:
 *                                   {Array | DataSet | DataView} [nodes] Array with nodes
 *                                   {Array | DataSet | DataView} [edges] Array with edges
 *                                   {String} [dot] String containing data in DOT format
 *                                   {String} [gephi] String containing data in gephi JSON format
 *                                   {Options} [options] Object with options
 */
Network.prototype.setData = function (data) {
  // reset the physics engine.
  this.body.emitter.emit("resetPhysics");
  this.body.emitter.emit("_resetData");

  // unselect all to ensure no selections from old data are carried over.
  this.selectionHandler.unselectAll();

  if (data && data.dot && (data.nodes || data.edges)) {
    throw new SyntaxError('Data must contain either parameter "dot" or ' + ' parameter pair "nodes" and "edges", but not both.');
  }

  // set options
  this.setOptions(data && data.options);
  // set all data
  if (data && data.dot) {
    console.log('The dot property has been deprecated. Please use the static convertDot method to convert DOT into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertDot(dotString);');
    // parse DOT file
    var dotData = dotparser.DOTToGraph(data.dot);
    this.setData(dotData);
    return;
  } else if (data && data.gephi) {
    // parse DOT file
    console.log('The gephi property has been deprecated. Please use the static convertGephi method to convert gephi into vis.network format and use the normal data format with nodes and edges. This converter is used like this: var data = vis.network.convertGephi(gephiJson);');
    var gephiData = gephiParser.parseGephi(data.gephi);
    this.setData(gephiData);
    return;
  } else {
    this.nodesHandler.setData(data && data.nodes, true);
    this.edgesHandler.setData(data && data.edges, true);
  }

  // emit change in data
  this.body.emitter.emit("_dataChanged");

  // emit data loaded
  this.body.emitter.emit("_dataLoaded");

  // find a stable position or start animating to a stable position
  this.body.emitter.emit("initPhysics");
};

/**
 * Cleans up all bindings of the network, removing it fully from the memory IF the variable is set to null after calling this function.
 * var network = new vis.Network(..);
 * network.destroy();
 * network = null;
 */
Network.prototype.destroy = function () {
  this.body.emitter.emit("destroy");
  // clear events
  this.body.emitter.off();
  this.off();

  // delete modules
  delete this.groups;
  delete this.canvas;
  delete this.selectionHandler;
  delete this.interactionHandler;
  delete this.view;
  delete this.renderer;
  delete this.physics;
  delete this.layoutEngine;
  delete this.clustering;
  delete this.manipulation;
  delete this.nodesHandler;
  delete this.edgesHandler;
  delete this.configurator;
  delete this.images;

  for (var nodeId in this.body.nodes) {
    if (!this.body.nodes.hasOwnProperty(nodeId)) continue;
    delete this.body.nodes[nodeId];
  }

  for (var edgeId in this.body.edges) {
    if (!this.body.edges.hasOwnProperty(edgeId)) continue;
    delete this.body.edges[edgeId];
  }

  // remove the container and everything inside it recursively
  util.recursiveDOMDelete(this.body.container);
};

/**
 * Update the values of all object in the given array according to the current
 * value range of the objects in the array.
 * @param {Object} obj    An object containing a set of Edges or Nodes
 *                        The objects must have a method getValue() and
 *                        setValueRange(min, max).
 * @private
 */
Network.prototype._updateValueRange = function (obj) {
  var id;

  // determine the range of the objects
  var valueMin = undefined;
  var valueMax = undefined;
  var valueTotal = 0;
  for (id in obj) {
    if (obj.hasOwnProperty(id)) {
      var value = obj[id].getValue();
      if (value !== undefined) {
        valueMin = valueMin === undefined ? value : Math.min(value, valueMin);
        valueMax = valueMax === undefined ? value : Math.max(value, valueMax);
        valueTotal += value;
      }
    }
  }

  // adjust the range of all objects
  if (valueMin !== undefined && valueMax !== undefined) {
    for (id in obj) {
      if (obj.hasOwnProperty(id)) {
        obj[id].setValueRange(valueMin, valueMax, valueTotal);
      }
    }
  }
};

/**
 * Returns true when the Network is active.
 * @returns {boolean}
 */
Network.prototype.isActive = function () {
  return !this.activator || this.activator.active;
};

Network.prototype.setSize = function () {
  return this.canvas.setSize.apply(this.canvas, arguments);
};
Network.prototype.canvasToDOM = function () {
  return this.canvas.canvasToDOM.apply(this.canvas, arguments);
};
Network.prototype.DOMtoCanvas = function () {
  return this.canvas.DOMtoCanvas.apply(this.canvas, arguments);
};
Network.prototype.findNode = function () {
  return this.clustering.findNode.apply(this.clustering, arguments);
};
Network.prototype.isCluster = function () {
  return this.clustering.isCluster.apply(this.clustering, arguments);
};
Network.prototype.openCluster = function () {
  return this.clustering.openCluster.apply(this.clustering, arguments);
};
Network.prototype.cluster = function () {
  return this.clustering.cluster.apply(this.clustering, arguments);
};
Network.prototype.getNodesInCluster = function () {
  return this.clustering.getNodesInCluster.apply(this.clustering, arguments);
};
Network.prototype.clusterByConnection = function () {
  return this.clustering.clusterByConnection.apply(this.clustering, arguments);
};
Network.prototype.clusterByHubsize = function () {
  return this.clustering.clusterByHubsize.apply(this.clustering, arguments);
};
Network.prototype.clusterOutliers = function () {
  return this.clustering.clusterOutliers.apply(this.clustering, arguments);
};
Network.prototype.getSeed = function () {
  return this.layoutEngine.getSeed.apply(this.layoutEngine, arguments);
};
Network.prototype.enableEditMode = function () {
  return this.manipulation.enableEditMode.apply(this.manipulation, arguments);
};
Network.prototype.disableEditMode = function () {
  return this.manipulation.disableEditMode.apply(this.manipulation, arguments);
};
Network.prototype.addNodeMode = function () {
  return this.manipulation.addNodeMode.apply(this.manipulation, arguments);
};
Network.prototype.editNode = function () {
  return this.manipulation.editNode.apply(this.manipulation, arguments);
};
Network.prototype.editNodeMode = function () {
  console.log("Deprecated: Please use editNode instead of editNodeMode.");return this.manipulation.editNode.apply(this.manipulation, arguments);
};
Network.prototype.addEdgeMode = function () {
  return this.manipulation.addEdgeMode.apply(this.manipulation, arguments);
};
Network.prototype.editEdgeMode = function () {
  return this.manipulation.editEdgeMode.apply(this.manipulation, arguments);
};
Network.prototype.deleteSelected = function () {
  return this.manipulation.deleteSelected.apply(this.manipulation, arguments);
};
Network.prototype.getPositions = function () {
  return this.nodesHandler.getPositions.apply(this.nodesHandler, arguments);
};
Network.prototype.storePositions = function () {
  return this.nodesHandler.storePositions.apply(this.nodesHandler, arguments);
};
Network.prototype.moveNode = function () {
  return this.nodesHandler.moveNode.apply(this.nodesHandler, arguments);
};
Network.prototype.getBoundingBox = function () {
  return this.nodesHandler.getBoundingBox.apply(this.nodesHandler, arguments);
};
Network.prototype.getConnectedNodes = function (objectId) {
  if (this.body.nodes[objectId] !== undefined) {
    return this.nodesHandler.getConnectedNodes.apply(this.nodesHandler, arguments);
  } else {
    return this.edgesHandler.getConnectedNodes.apply(this.edgesHandler, arguments);
  }
};
Network.prototype.getConnectedEdges = function () {
  return this.nodesHandler.getConnectedEdges.apply(this.nodesHandler, arguments);
};
Network.prototype.startSimulation = function () {
  return this.physics.startSimulation.apply(this.physics, arguments);
};
Network.prototype.stopSimulation = function () {
  return this.physics.stopSimulation.apply(this.physics, arguments);
};
Network.prototype.stabilize = function () {
  return this.physics.stabilize.apply(this.physics, arguments);
};
Network.prototype.getSelection = function () {
  return this.selectionHandler.getSelection.apply(this.selectionHandler, arguments);
};
Network.prototype.setSelection = function () {
  return this.selectionHandler.setSelection.apply(this.selectionHandler, arguments);
};
Network.prototype.getSelectedNodes = function () {
  return this.selectionHandler.getSelectedNodes.apply(this.selectionHandler, arguments);
};
Network.prototype.getSelectedEdges = function () {
  return this.selectionHandler.getSelectedEdges.apply(this.selectionHandler, arguments);
};
Network.prototype.getNodeAt = function () {
  var node = this.selectionHandler.getNodeAt.apply(this.selectionHandler, arguments);
  if (node !== undefined && node.id !== undefined) {
    return node.id;
  }
  return node;
};
Network.prototype.getEdgeAt = function () {
  var edge = this.selectionHandler.getEdgeAt.apply(this.selectionHandler, arguments);
  if (edge !== undefined && edge.id !== undefined) {
    return edge.id;
  }
  return edge;
};
Network.prototype.selectNodes = function () {
  return this.selectionHandler.selectNodes.apply(this.selectionHandler, arguments);
};
Network.prototype.selectEdges = function () {
  return this.selectionHandler.selectEdges.apply(this.selectionHandler, arguments);
};
Network.prototype.unselectAll = function () {
  this.selectionHandler.unselectAll.apply(this.selectionHandler, arguments);
  this.redraw();
};
Network.prototype.redraw = function () {
  return this.renderer.redraw.apply(this.renderer, arguments);
};
Network.prototype.getScale = function () {
  return this.view.getScale.apply(this.view, arguments);
};
Network.prototype.getViewPosition = function () {
  return this.view.getViewPosition.apply(this.view, arguments);
};
Network.prototype.fit = function () {
  return this.view.fit.apply(this.view, arguments);
};
Network.prototype.moveTo = function () {
  return this.view.moveTo.apply(this.view, arguments);
};
Network.prototype.focus = function () {
  return this.view.focus.apply(this.view, arguments);
};
Network.prototype.releaseNode = function () {
  return this.view.releaseNode.apply(this.view, arguments);
};
Network.prototype.getOptionsFromConfigurator = function () {
  var options = {};
  if (this.configurator) {
    options = this.configurator.getOptions.apply(this.configurator);
  }
  return options;
};

module.exports = Network;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Canvas shapes used by Network
 */
if (typeof CanvasRenderingContext2D !== 'undefined') {

  /**
   * Draw a circle shape
   *
   * @param {number} x
   * @param {number} y
   * @param {number} r
   */
  CanvasRenderingContext2D.prototype.circle = function (x, y, r) {
    this.beginPath();
    this.arc(x, y, r, 0, 2 * Math.PI, false);
    this.closePath();
  };

  /**
   * Draw a square shape
   * @param {number} x horizontal center
   * @param {number} y vertical center
   * @param {number} r   size, width and height of the square
   */
  CanvasRenderingContext2D.prototype.square = function (x, y, r) {
    this.beginPath();
    this.rect(x - r, y - r, r * 2, r * 2);
    this.closePath();
  };

  /**
   * Draw a triangle shape
   * @param {number} x horizontal center
   * @param {number} y vertical center
   * @param {number} r   radius, half the length of the sides of the triangle
   */
  CanvasRenderingContext2D.prototype.triangle = function (x, y, r) {
    // http://en.wikipedia.org/wiki/Equilateral_triangle
    this.beginPath();

    // the change in radius and the offset is here to center the shape
    r *= 1.15;
    y += 0.275 * r;

    var s = r * 2;
    var s2 = s / 2;
    var ir = Math.sqrt(3) / 6 * s; // radius of inner circle
    var h = Math.sqrt(s * s - s2 * s2); // height


    this.moveTo(x, y - (h - ir));
    this.lineTo(x + s2, y + ir);
    this.lineTo(x - s2, y + ir);
    this.lineTo(x, y - (h - ir));
    this.closePath();
  };

  /**
   * Draw a triangle shape in downward orientation
   * @param {number} x horizontal center
   * @param {number} y vertical center
   * @param {number} r radius
   */
  CanvasRenderingContext2D.prototype.triangleDown = function (x, y, r) {
    // http://en.wikipedia.org/wiki/Equilateral_triangle
    this.beginPath();

    // the change in radius and the offset is here to center the shape
    r *= 1.15;
    y -= 0.275 * r;

    var s = r * 2;
    var s2 = s / 2;
    var ir = Math.sqrt(3) / 6 * s; // radius of inner circle
    var h = Math.sqrt(s * s - s2 * s2); // height

    this.moveTo(x, y + (h - ir));
    this.lineTo(x + s2, y - ir);
    this.lineTo(x - s2, y - ir);
    this.lineTo(x, y + (h - ir));
    this.closePath();
  };

  /**
   * Draw a star shape, a star with 5 points
   * @param {number} x horizontal center
   * @param {number} y vertical center
   * @param {number} r   radius, half the length of the sides of the triangle
   */
  CanvasRenderingContext2D.prototype.star = function (x, y, r) {
    // http://www.html5canvastutorials.com/labs/html5-canvas-star-spinner/
    this.beginPath();

    // the change in radius and the offset is here to center the shape
    r *= 0.82;
    y += 0.1 * r;

    for (var n = 0; n < 10; n++) {
      var radius = n % 2 === 0 ? r * 1.3 : r * 0.5;
      this.lineTo(x + radius * Math.sin(n * 2 * Math.PI / 10), y - radius * Math.cos(n * 2 * Math.PI / 10));
    }

    this.closePath();
  };

  /**
   * Draw a Diamond shape
   * @param {number} x horizontal center
   * @param {number} y vertical center
   * @param {number} r   radius, half the length of the sides of the triangle
   */
  CanvasRenderingContext2D.prototype.diamond = function (x, y, r) {
    // http://www.html5canvastutorials.com/labs/html5-canvas-star-spinner/
    this.beginPath();

    this.lineTo(x, y + r);
    this.lineTo(x + r, y);
    this.lineTo(x, y - r);
    this.lineTo(x - r, y);

    this.closePath();
  };

  /**
   * http://stackoverflow.com/questions/1255512/how-to-draw-a-rounded-rectangle-on-html-canvas
   *
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   * @param {number} r
   */
  CanvasRenderingContext2D.prototype.roundRect = function (x, y, w, h, r) {
    var r2d = Math.PI / 180;
    if (w - 2 * r < 0) {
      r = w / 2;
    } //ensure that the radius isn't too large for x
    if (h - 2 * r < 0) {
      r = h / 2;
    } //ensure that the radius isn't too large for y
    this.beginPath();
    this.moveTo(x + r, y);
    this.lineTo(x + w - r, y);
    this.arc(x + w - r, y + r, r, r2d * 270, r2d * 360, false);
    this.lineTo(x + w, y + h - r);
    this.arc(x + w - r, y + h - r, r, 0, r2d * 90, false);
    this.lineTo(x + r, y + h);
    this.arc(x + r, y + h - r, r, r2d * 90, r2d * 180, false);
    this.lineTo(x, y + r);
    this.arc(x + r, y + r, r, r2d * 180, r2d * 270, false);
    this.closePath();
  };

  /**
   * http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
   *
   * Postfix '_vis' added to discern it from standard method ellipse().
   *
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   */
  CanvasRenderingContext2D.prototype.ellipse_vis = function (x, y, w, h) {
    var kappa = .5522848,
        ox = w / 2 * kappa,
        // control point offset horizontal
    oy = h / 2 * kappa,
        // control point offset vertical
    xe = x + w,
        // x-end
    ye = y + h,
        // y-end
    xm = x + w / 2,
        // x-middle
    ym = y + h / 2; // y-middle

    this.beginPath();
    this.moveTo(x, ym);
    this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
    this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
    this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
    this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
    this.closePath();
  };

  /**
   * http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
   *
   * @param {number} x
   * @param {number} y
   * @param {number} w
   * @param {number} h
   */
  CanvasRenderingContext2D.prototype.database = function (x, y, w, h) {
    var f = 1 / 3;
    var wEllipse = w;
    var hEllipse = h * f;

    var kappa = .5522848,
        ox = wEllipse / 2 * kappa,
        // control point offset horizontal
    oy = hEllipse / 2 * kappa,
        // control point offset vertical
    xe = x + wEllipse,
        // x-end
    ye = y + hEllipse,
        // y-end
    xm = x + wEllipse / 2,
        // x-middle
    ym = y + hEllipse / 2,
        // y-middle
    ymb = y + (h - hEllipse / 2),
        // y-midlle, bottom ellipse
    yeb = y + h; // y-end, bottom ellipse

    this.beginPath();
    this.moveTo(xe, ym);

    this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
    this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);

    this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
    this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);

    this.lineTo(xe, ymb);

    this.bezierCurveTo(xe, ymb + oy, xm + ox, yeb, xm, yeb);
    this.bezierCurveTo(xm - ox, yeb, x, ymb + oy, x, ymb);

    this.lineTo(x, ym);
  };

  /**
   * Sets up the dashedLine functionality for drawing
   * Original code came from http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas
   * @author David Jordan
   * @date 2012-08-08
   *
   * @param {number} x
   * @param {number} y
   * @param {number} x2
   * @param {number} y2
   * @param {string} pattern
   */
  CanvasRenderingContext2D.prototype.dashedLine = function (x, y, x2, y2, pattern) {
    this.beginPath();
    this.moveTo(x, y);

    var patternLength = pattern.length;
    var dx = x2 - x;
    var dy = y2 - y;
    var slope = dy / dx;
    var distRemaining = Math.sqrt(dx * dx + dy * dy);
    var patternIndex = 0;
    var draw = true;
    var xStep = 0;
    var dashLength = pattern[0];

    while (distRemaining >= 0.1) {
      dashLength = pattern[patternIndex++ % patternLength];
      if (dashLength > distRemaining) {
        dashLength = distRemaining;
      }

      xStep = Math.sqrt(dashLength * dashLength / (1 + slope * slope));
      xStep = dx < 0 ? -xStep : xStep;
      x += xStep;
      y += slope * xStep;

      if (draw === true) {
        this.lineTo(x, y);
      } else {
        this.moveTo(x, y);
      }

      distRemaining -= dashLength;
      draw = !draw;
    }
  };

  /**
   * Draw a Hexagon shape with 6 sides
   * @param {Number} x horizontal center
   * @param {Number} y vertical center
   * @param {Number} r   radius
   */
  CanvasRenderingContext2D.prototype.hexagon = function (x, y, r) {
    this.beginPath();
    var sides = 6;
    var a = Math.PI * 2 / sides;
    this.moveTo(x + r, y);
    for (var i = 1; i < sides; i++) {
      this.lineTo(x + r * Math.cos(a * i), y + r * Math.sin(a * i));
    }
    this.closePath();
  };
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// English
exports['en'] = {
  edit: 'Edit',
  del: 'Delete selected',
  back: 'Back',
  addNode: 'Add Node',
  addEdge: 'Add Edge',
  editNode: 'Edit Node',
  editEdge: 'Edit Edge',
  addDescription: 'Click in an empty space to place a new node.',
  edgeDescription: 'Click on a node and drag the edge to another node to connect them.',
  editEdgeDescription: 'Click on the control points and drag them to a node to connect to it.',
  createEdgeError: 'Cannot link edges to a cluster.',
  deleteClusterError: 'Clusters cannot be deleted.',
  editClusterError: 'Clusters cannot be edited.'
};
exports['en_EN'] = exports['en'];
exports['en_US'] = exports['en'];

// German
exports['de'] = {
  edit: 'Editieren',
  del: 'L\xF6sche Auswahl',
  back: 'Zur\xFCck',
  addNode: 'Knoten hinzuf\xFCgen',
  addEdge: 'Kante hinzuf\xFCgen',
  editNode: 'Knoten editieren',
  editEdge: 'Kante editieren',
  addDescription: 'Klicke auf eine freie Stelle, um einen neuen Knoten zu plazieren.',
  edgeDescription: 'Klicke auf einen Knoten und ziehe die Kante zu einem anderen Knoten, um diese zu verbinden.',
  editEdgeDescription: 'Klicke auf die Verbindungspunkte und ziehe diese auf einen Knoten, um sie zu verbinden.',
  createEdgeError: 'Es ist nicht m\xF6glich, Kanten mit Clustern zu verbinden.',
  deleteClusterError: 'Cluster k\xF6nnen nicht gel\xF6scht werden.',
  editClusterError: 'Cluster k\xF6nnen nicht editiert werden.'
};
exports['de_DE'] = exports['de'];

// Spanish
exports['es'] = {
  edit: 'Editar',
  del: 'Eliminar selecci\xF3n',
  back: '\xC1tras',
  addNode: 'A\xF1adir nodo',
  addEdge: 'A\xF1adir arista',
  editNode: 'Editar nodo',
  editEdge: 'Editar arista',
  addDescription: 'Haga clic en un lugar vac\xEDo para colocar un nuevo nodo.',
  edgeDescription: 'Haga clic en un nodo y arrastre la arista hacia otro nodo para conectarlos.',
  editEdgeDescription: 'Haga clic en un punto de control y arrastrelo a un nodo para conectarlo.',
  createEdgeError: 'No se puede conectar una arista a un grupo.',
  deleteClusterError: 'No es posible eliminar grupos.',
  editClusterError: 'No es posible editar grupos.'
};
exports['es_ES'] = exports['es'];

//Italiano
exports['it'] = {
  edit: 'Modifica',
  del: 'Cancella la selezione',
  back: 'Indietro',
  addNode: 'Aggiungi un nodo',
  addEdge: 'Aggiungi un vertice',
  editNode: 'Modifica il nodo',
  editEdge: 'Modifica il vertice',
  addDescription: 'Clicca per aggiungere un nuovo nodo',
  edgeDescription: 'Clicca su un nodo e trascinalo ad un altro nodo per connetterli.',
  editEdgeDescription: 'Clicca sui Punti di controllo e trascinali ad un nodo per connetterli.',
  createEdgeError: 'Non si possono collegare vertici ad un cluster',
  deleteClusterError: 'I cluster non possono essere cancellati',
  editClusterError: 'I clusters non possono essere modificati.'
};
exports['it_IT'] = exports['it'];

// Dutch
exports['nl'] = {
  edit: 'Wijzigen',
  del: 'Selectie verwijderen',
  back: 'Terug',
  addNode: 'Node toevoegen',
  addEdge: 'Link toevoegen',
  editNode: 'Node wijzigen',
  editEdge: 'Link wijzigen',
  addDescription: 'Klik op een leeg gebied om een nieuwe node te maken.',
  edgeDescription: 'Klik op een node en sleep de link naar een andere node om ze te verbinden.',
  editEdgeDescription: 'Klik op de verbindingspunten en sleep ze naar een node om daarmee te verbinden.',
  createEdgeError: 'Kan geen link maken naar een cluster.',
  deleteClusterError: 'Clusters kunnen niet worden verwijderd.',
  editClusterError: 'Clusters kunnen niet worden aangepast.'
};
exports['nl_NL'] = exports['nl'];
exports['nl_BE'] = exports['nl'];

// Portuguese Brazil
exports['pt-br'] = {
  edit: 'Editar',
  del: 'Remover selecionado',
  back: 'Voltar',
  addNode: 'Adicionar nó',
  addEdge: 'Adicionar aresta',
  editNode: 'Editar nó',
  editEdge: 'Editar aresta',
  addDescription: 'Clique em um espaço em branco para adicionar um novo nó',
  edgeDescription: 'Clique em um nó e arraste a aresta até outro nó para conectá-los',
  editEdgeDescription: 'Clique nos pontos de controle e os arraste para um nó para conectá-los',
  createEdgeError: 'Não foi possível linkar arestas a um cluster.',
  deleteClusterError: 'Clusters não puderam ser removidos.',
  editClusterError: 'Clusters não puderam ser editados.'
};
exports['pt-BR'] = exports['pt-br'];
exports['pt_BR'] = exports['pt-br'];
exports['pt_br'] = exports['pt-br'];

// Russian
exports['ru'] = {
  edit: 'Редактировать',
  del: 'Удалить выбранное',
  back: 'Назад',
  addNode: 'Добавить узел',
  addEdge: 'Добавить ребро',
  editNode: 'Редактировать узел',
  editEdge: 'Редактировать ребро',
  addDescription: 'Кликните в свободное место, чтобы добавить новый узел.',
  edgeDescription: 'Кликните на узел и протяните ребро к другому узлу, чтобы соединить их.',
  editEdgeDescription: 'Кликните на контрольные точки и перетащите их в узел, чтобы подключиться к нему.',
  createEdgeError: 'Невозможно соединить ребра в кластер.',
  deleteClusterError: 'Кластеры не могут быть удалены',
  editClusterError: 'Кластеры недоступны для редактирования.'
};
exports['ru_RU'] = exports['ru'];

// Chinese
exports['cn'] = {
  edit: '编辑',
  del: '删除选定',
  back: '返回',
  addNode: '添加节点',
  addEdge: '添加连接线',
  editNode: '编辑节点',
  editEdge: '编辑连接线',
  addDescription: '单击空白处放置新节点。',
  edgeDescription: '单击某个节点并将该连接线拖动到另一个节点以连接它们。',
  editEdgeDescription: '单击控制节点并将它们拖到节点上连接。',
  createEdgeError: '无法将连接线连接到群集。',
  deleteClusterError: '无法删除群集。',
  editClusterError: '无法编辑群集。'
};
exports['zh_CN'] = exports['cn'];

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Associates a canvas to a given image, containing a number of renderings
 * of the image at various sizes.
 *
 * This technique is known as 'mipmapping'.
 *
 * NOTE: Images can also be of type 'data:svg+xml`. This code also works
 *       for svg, but the mipmapping may not be necessary.
 *
 * @param {Image} image
 */
var CachedImage = function () {
  /**
   * @ignore
   */
  function CachedImage() {
    (0, _classCallCheck3['default'])(this, CachedImage);
    // eslint-disable-line no-unused-vars
    this.NUM_ITERATIONS = 4; // Number of items in the coordinates array

    this.image = new Image();
    this.canvas = document.createElement('canvas');
  }

  /**
   * Called when the image has been successfully loaded.
   */


  (0, _createClass3['default'])(CachedImage, [{
    key: 'init',
    value: function init() {
      if (this.initialized()) return;

      this.src = this.image.src; // For same interface with Image
      var w = this.image.width;
      var h = this.image.height;

      // Ease external access
      this.width = w;
      this.height = h;

      var h2 = Math.floor(h / 2);
      var h4 = Math.floor(h / 4);
      var h8 = Math.floor(h / 8);
      var h16 = Math.floor(h / 16);

      var w2 = Math.floor(w / 2);
      var w4 = Math.floor(w / 4);
      var w8 = Math.floor(w / 8);
      var w16 = Math.floor(w / 16);

      // Make canvas as small as possible
      this.canvas.width = 3 * w4;
      this.canvas.height = h2;

      // Coordinates and sizes of images contained in the canvas
      // Values per row:  [top x, left y, width, height]

      this.coordinates = [[0, 0, w2, h2], [w2, 0, w4, h4], [w2, h4, w8, h8], [5 * w8, h4, w16, h16]];

      this._fillMipMap();
    }

    /**
     * @return {Boolean} true if init() has been called, false otherwise.
     */

  }, {
    key: 'initialized',
    value: function initialized() {
      return this.coordinates !== undefined;
    }

    /**
     * Redraw main image in various sizes to the context.
     *
     * The rationale behind this is to reduce artefacts due to interpolation
     * at differing zoom levels.
     *
     * Source: http://stackoverflow.com/q/18761404/1223531
     *
     * This methods takes the resizing out of the drawing loop, in order to
     * reduce performance overhead.
     *
     * TODO: The code assumes that a 2D context can always be gotten. This is
     *       not necessarily true! OTOH, if not true then usage of this class
     *       is senseless.
     *
     * @private
     */

  }, {
    key: '_fillMipMap',
    value: function _fillMipMap() {
      var ctx = this.canvas.getContext('2d');

      // First zoom-level comes from the image
      var to = this.coordinates[0];
      ctx.drawImage(this.image, to[0], to[1], to[2], to[3]);

      // The rest are copy actions internal to the canvas/context
      for (var iterations = 1; iterations < this.NUM_ITERATIONS; iterations++) {
        var from = this.coordinates[iterations - 1];
        var _to = this.coordinates[iterations];

        ctx.drawImage(this.canvas, from[0], from[1], from[2], from[3], _to[0], _to[1], _to[2], _to[3]);
      }
    }

    /**
     * Draw the image, using the mipmap if necessary.
     *
     * MipMap is only used if param factor > 2; otherwise, original bitmap
     * is resized. This is also used to skip mipmap usage, e.g. by setting factor = 1
     *
     * Credits to 'Alex de Mulder' for original implementation.
     *
     * @param {CanvasRenderingContext2D} ctx  context on which to draw zoomed image
     * @param {Float} factor scale factor at which to draw
     * @param {number} left
     * @param {number} top
     * @param {number} width
     * @param {number} height
     */

  }, {
    key: 'drawImageAtPosition',
    value: function drawImageAtPosition(ctx, factor, left, top, width, height) {

      if (!this.initialized()) return; //can't draw image yet not intialized

      if (factor > 2) {
        // Determine which zoomed image to use
        factor *= 0.5;
        var iterations = 0;
        while (factor > 2 && iterations < this.NUM_ITERATIONS) {
          factor *= 0.5;
          iterations += 1;
        }

        if (iterations >= this.NUM_ITERATIONS) {
          iterations = this.NUM_ITERATIONS - 1;
        }
        //console.log("iterations: " + iterations);

        var from = this.coordinates[iterations];
        ctx.drawImage(this.canvas, from[0], from[1], from[2], from[3], left, top, width, height);
      } else {
        // Draw image directly
        ctx.drawImage(this.image, left, top, width, height);
      }
    }
  }]);
  return CachedImage;
}();

exports['default'] = CachedImage;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var util = __webpack_require__(2);

/**
 * This class can store groups and options specific for groups.
 */

var Groups = function () {
  /**
   * @ignore
   */
  function Groups() {
    (0, _classCallCheck3["default"])(this, Groups);

    this.clear();
    this.defaultIndex = 0;
    this.groupsArray = [];
    this.groupIndex = 0;

    this.defaultGroups = [{ border: "#2B7CE9", background: "#97C2FC", highlight: { border: "#2B7CE9", background: "#D2E5FF" }, hover: { border: "#2B7CE9", background: "#D2E5FF" } }, // 0: blue
    { border: "#FFA500", background: "#FFFF00", highlight: { border: "#FFA500", background: "#FFFFA3" }, hover: { border: "#FFA500", background: "#FFFFA3" } }, // 1: yellow
    { border: "#FA0A10", background: "#FB7E81", highlight: { border: "#FA0A10", background: "#FFAFB1" }, hover: { border: "#FA0A10", background: "#FFAFB1" } }, // 2: red
    { border: "#41A906", background: "#7BE141", highlight: { border: "#41A906", background: "#A1EC76" }, hover: { border: "#41A906", background: "#A1EC76" } }, // 3: green
    { border: "#E129F0", background: "#EB7DF4", highlight: { border: "#E129F0", background: "#F0B3F5" }, hover: { border: "#E129F0", background: "#F0B3F5" } }, // 4: magenta
    { border: "#7C29F0", background: "#AD85E4", highlight: { border: "#7C29F0", background: "#D3BDF0" }, hover: { border: "#7C29F0", background: "#D3BDF0" } }, // 5: purple
    { border: "#C37F00", background: "#FFA807", highlight: { border: "#C37F00", background: "#FFCA66" }, hover: { border: "#C37F00", background: "#FFCA66" } }, // 6: orange
    { border: "#4220FB", background: "#6E6EFD", highlight: { border: "#4220FB", background: "#9B9BFD" }, hover: { border: "#4220FB", background: "#9B9BFD" } }, // 7: darkblue
    { border: "#FD5A77", background: "#FFC0CB", highlight: { border: "#FD5A77", background: "#FFD1D9" }, hover: { border: "#FD5A77", background: "#FFD1D9" } }, // 8: pink
    { border: "#4AD63A", background: "#C2FABC", highlight: { border: "#4AD63A", background: "#E6FFE3" }, hover: { border: "#4AD63A", background: "#E6FFE3" } }, // 9: mint

    { border: "#990000", background: "#EE0000", highlight: { border: "#BB0000", background: "#FF3333" }, hover: { border: "#BB0000", background: "#FF3333" } }, // 10:bright red

    { border: "#FF6000", background: "#FF6000", highlight: { border: "#FF6000", background: "#FF6000" }, hover: { border: "#FF6000", background: "#FF6000" } }, // 12: real orange
    { border: "#97C2FC", background: "#2B7CE9", highlight: { border: "#D2E5FF", background: "#2B7CE9" }, hover: { border: "#D2E5FF", background: "#2B7CE9" } }, // 13: blue
    { border: "#399605", background: "#255C03", highlight: { border: "#399605", background: "#255C03" }, hover: { border: "#399605", background: "#255C03" } }, // 14: green
    { border: "#B70054", background: "#FF007E", highlight: { border: "#B70054", background: "#FF007E" }, hover: { border: "#B70054", background: "#FF007E" } }, // 15: magenta
    { border: "#AD85E4", background: "#7C29F0", highlight: { border: "#D3BDF0", background: "#7C29F0" }, hover: { border: "#D3BDF0", background: "#7C29F0" } }, // 16: purple
    { border: "#4557FA", background: "#000EA1", highlight: { border: "#6E6EFD", background: "#000EA1" }, hover: { border: "#6E6EFD", background: "#000EA1" } }, // 17: darkblue
    { border: "#FFC0CB", background: "#FD5A77", highlight: { border: "#FFD1D9", background: "#FD5A77" }, hover: { border: "#FFD1D9", background: "#FD5A77" } }, // 18: pink
    { border: "#C2FABC", background: "#74D66A", highlight: { border: "#E6FFE3", background: "#74D66A" }, hover: { border: "#E6FFE3", background: "#74D66A" } }, // 19: mint

    { border: "#EE0000", background: "#990000", highlight: { border: "#FF3333", background: "#BB0000" }, hover: { border: "#FF3333", background: "#BB0000" } // 20:bright red
    }];

    this.options = {};
    this.defaultOptions = {
      useDefaultGroups: true
    };
    util.extend(this.options, this.defaultOptions);
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3["default"])(Groups, [{
    key: "setOptions",
    value: function setOptions(options) {
      var optionFields = ['useDefaultGroups'];

      if (options !== undefined) {
        for (var groupName in options) {
          if (options.hasOwnProperty(groupName)) {
            if (optionFields.indexOf(groupName) === -1) {
              var group = options[groupName];
              this.add(groupName, group);
            }
          }
        }
      }
    }

    /**
     * Clear all groups
     */

  }, {
    key: "clear",
    value: function clear() {
      this.groups = {};
      this.groupsArray = [];
    }

    /**
     * Get group options of a groupname.
     * If groupname is not found, a new group may be created.
     *
     * @param {*}       groupname     Can be a number, string, Date, etc.
     * @param {boolean} [shouldCreate=true] If true, create a new group
     * @return {Object} The found or created group
     */

  }, {
    key: "get",
    value: function get(groupname) {
      var shouldCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var group = this.groups[groupname];

      if (group === undefined && shouldCreate) {
        if (this.options.useDefaultGroups === false && this.groupsArray.length > 0) {
          // create new group
          var index = this.groupIndex % this.groupsArray.length;
          this.groupIndex++;
          group = {};
          group.color = this.groups[this.groupsArray[index]];
          this.groups[groupname] = group;
        } else {
          // create new group
          var _index = this.defaultIndex % this.defaultGroups.length;
          this.defaultIndex++;
          group = {};
          group.color = this.defaultGroups[_index];
          this.groups[groupname] = group;
        }
      }

      return group;
    }

    /**
     * Add a custom group style
     * @param {string} groupName
     * @param {Object} style       An object containing borderColor,
     *                             backgroundColor, etc.
     * @return {Object} group      The created group object
     */

  }, {
    key: "add",
    value: function add(groupName, style) {
      this.groups[groupName] = style;
      this.groupsArray.push(groupName);
      return style;
    }
  }]);
  return Groups;
}();

exports["default"] = Groups;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var DataSet = __webpack_require__(11);
var DataView = __webpack_require__(12);
var Node = __webpack_require__(47)['default'];

/**
 * Handler for Nodes
 */

var NodesHandler = function () {
  /**
   * @param {Object} body
   * @param {Images} images
   * @param {Array.<Group>} groups
   * @param {LayoutEngine} layoutEngine
   */
  function NodesHandler(body, images, groups, layoutEngine) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, NodesHandler);

    this.body = body;
    this.images = images;
    this.groups = groups;
    this.layoutEngine = layoutEngine;

    // create the node API in the body container
    this.body.functions.createNode = this.create.bind(this);

    this.nodesListeners = {
      add: function add(event, params) {
        _this.add(params.items);
      },
      update: function update(event, params) {
        _this.update(params.items, params.data, params.oldData);
      },
      remove: function remove(event, params) {
        _this.remove(params.items);
      }
    };

    this.defaultOptions = {
      borderWidth: 1,
      borderWidthSelected: 2,
      brokenImage: undefined,
      color: {
        border: '#2B7CE9',
        background: '#97C2FC',
        highlight: {
          border: '#2B7CE9',
          background: '#D2E5FF'
        },
        hover: {
          border: '#2B7CE9',
          background: '#D2E5FF'
        }
      },
      fixed: {
        x: false,
        y: false
      },
      font: {
        color: '#343434',
        size: 14, // px
        face: 'arial',
        background: 'none',
        strokeWidth: 0, // px
        strokeColor: '#ffffff',
        align: 'center',
        vadjust: 0,
        multi: false,
        bold: {
          mod: 'bold'
        },
        boldital: {
          mod: 'bold italic'
        },
        ital: {
          mod: 'italic'
        },
        mono: {
          mod: '',
          size: 15, // px
          face: 'monospace',
          vadjust: 2
        }
      },
      group: undefined,
      hidden: false,
      icon: {
        face: 'FontAwesome', //'FontAwesome',
        code: undefined, //'\uf007',
        size: 50, //50,
        color: '#2B7CE9' //'#aa00ff'
      },
      image: undefined, // --> URL
      label: undefined,
      labelHighlightBold: true,
      level: undefined,
      margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
      },
      mass: 1,
      physics: true,
      scaling: {
        min: 10,
        max: 30,
        label: {
          enabled: false,
          min: 14,
          max: 30,
          maxVisible: 30,
          drawThreshold: 5
        },
        customScalingFunction: function customScalingFunction(min, max, total, value) {
          if (max === min) {
            return 0.5;
          } else {
            var scale = 1 / (max - min);
            return Math.max(0, (value - min) * scale);
          }
        }
      },
      shadow: {
        enabled: false,
        color: 'rgba(0,0,0,0.5)',
        size: 10,
        x: 5,
        y: 5
      },
      shape: 'ellipse',
      shapeProperties: {
        borderDashes: false, // only for borders
        borderRadius: 6, // only for box shape
        interpolation: true, // only for image and circularImage shapes
        useImageSize: false, // only for image and circularImage shapes
        useBorderWithImage: false // only for image shape
      },
      size: 25,
      title: undefined,
      value: undefined,
      x: undefined,
      y: undefined
    };

    // Protect from idiocy
    if (this.defaultOptions.mass <= 0) {
      throw 'Internal error: mass in defaultOptions of NodesHandler may not be zero or negative';
    }

    this.options = util.bridgeObject(this.defaultOptions);

    this.bindEventListeners();
  }

  /**
   * Binds event listeners
   */


  (0, _createClass3['default'])(NodesHandler, [{
    key: 'bindEventListeners',
    value: function bindEventListeners() {
      var _this2 = this;

      // refresh the nodes. Used when reverting from hierarchical layout
      this.body.emitter.on('refreshNodes', this.refresh.bind(this));
      this.body.emitter.on('refresh', this.refresh.bind(this));
      this.body.emitter.on('destroy', function () {
        util.forEach(_this2.nodesListeners, function (callback, event) {
          if (_this2.body.data.nodes) _this2.body.data.nodes.off(event, callback);
        });
        delete _this2.body.functions.createNode;
        delete _this2.nodesListeners.add;
        delete _this2.nodesListeners.update;
        delete _this2.nodesListeners.remove;
        delete _this2.nodesListeners;
      });
    }

    /**
     *
     * @param {Object} options
     */

  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      if (options !== undefined) {
        Node.parseOptions(this.options, options);

        // update the shape in all nodes
        if (options.shape !== undefined) {
          for (var nodeId in this.body.nodes) {
            if (this.body.nodes.hasOwnProperty(nodeId)) {
              this.body.nodes[nodeId].updateShape();
            }
          }
        }

        // update the font in all nodes
        if (options.font !== undefined) {
          for (var _nodeId in this.body.nodes) {
            if (this.body.nodes.hasOwnProperty(_nodeId)) {
              this.body.nodes[_nodeId].updateLabelModule();
              this.body.nodes[_nodeId].needsRefresh();
            }
          }
        }

        // update the shape size in all nodes
        if (options.size !== undefined) {
          for (var _nodeId2 in this.body.nodes) {
            if (this.body.nodes.hasOwnProperty(_nodeId2)) {
              this.body.nodes[_nodeId2].needsRefresh();
            }
          }
        }

        // update the state of the variables if needed
        if (options.hidden !== undefined || options.physics !== undefined) {
          this.body.emitter.emit('_dataChanged');
        }
      }
    }

    /**
     * Set a data set with nodes for the network
     * @param {Array | DataSet | DataView} nodes         The data containing the nodes.
     * @param {boolean} [doNotEmit=false]
     * @private
     */

  }, {
    key: 'setData',
    value: function setData(nodes) {
      var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var oldNodesData = this.body.data.nodes;

      if (nodes instanceof DataSet || nodes instanceof DataView) {
        this.body.data.nodes = nodes;
      } else if (Array.isArray(nodes)) {
        this.body.data.nodes = new DataSet();
        this.body.data.nodes.add(nodes);
      } else if (!nodes) {
        this.body.data.nodes = new DataSet();
      } else {
        throw new TypeError('Array or DataSet expected');
      }

      if (oldNodesData) {
        // unsubscribe from old dataset
        util.forEach(this.nodesListeners, function (callback, event) {
          oldNodesData.off(event, callback);
        });
      }

      // remove drawn nodes
      this.body.nodes = {};

      if (this.body.data.nodes) {
        // subscribe to new dataset
        var me = this;
        util.forEach(this.nodesListeners, function (callback, event) {
          me.body.data.nodes.on(event, callback);
        });

        // draw all new nodes
        var ids = this.body.data.nodes.getIds();
        this.add(ids, true);
      }

      if (doNotEmit === false) {
        this.body.emitter.emit("_dataChanged");
      }
    }

    /**
     * Add nodes
     * @param {number[] | string[]} ids
     * @param {boolean} [doNotEmit=false]
     * @private
     */

  }, {
    key: 'add',
    value: function add(ids) {
      var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var id = void 0;
      var newNodes = [];
      for (var i = 0; i < ids.length; i++) {
        id = ids[i];
        var properties = this.body.data.nodes.get(id);
        var node = this.create(properties);
        newNodes.push(node);
        this.body.nodes[id] = node; // note: this may replace an existing node
      }

      this.layoutEngine.positionInitially(newNodes);

      if (doNotEmit === false) {
        this.body.emitter.emit("_dataChanged");
      }
    }

    /**
     * Update existing nodes, or create them when not yet existing
     * @param {number[] | string[]} ids id's of changed nodes
     * @param {Array} changedData array with changed data
     * @param {Array|undefined} oldData optional; array with previous data
     * @private
     */

  }, {
    key: 'update',
    value: function update(ids, changedData, oldData) {
      var nodes = this.body.nodes;
      var dataChanged = false;
      for (var i = 0; i < ids.length; i++) {
        var id = ids[i];
        var node = nodes[id];
        var data = changedData[i];
        if (node !== undefined) {
          // update node
          if (node.setOptions(data)) {
            dataChanged = true;
          }
        } else {
          dataChanged = true;
          // create node
          node = this.create(data);
          nodes[id] = node;
        }
      }

      if (!dataChanged && oldData !== undefined) {
        // Check for any changes which should trigger a layout recalculation
        // For now, this is just 'level' for hierarchical layout
        // Assumption: old and new data arranged in same order; at time of writing, this holds.
        dataChanged = changedData.some(function (newValue, index) {
          var oldValue = oldData[index];
          return oldValue && oldValue.level !== newValue.level;
        });
      }

      if (dataChanged === true) {
        this.body.emitter.emit("_dataChanged");
      } else {
        this.body.emitter.emit("_dataUpdated");
      }
    }

    /**
     * Remove existing nodes. If nodes do not exist, the method will just ignore it.
     * @param {number[] | string[]} ids
     * @private
     */

  }, {
    key: 'remove',
    value: function remove(ids) {
      var nodes = this.body.nodes;

      for (var i = 0; i < ids.length; i++) {
        var id = ids[i];
        delete nodes[id];
      }

      this.body.emitter.emit("_dataChanged");
    }

    /**
     * create a node
     * @param {Object} properties
     * @param {class} [constructorClass=Node.default]
     * @returns {*}
     */

  }, {
    key: 'create',
    value: function create(properties) {
      var constructorClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Node;

      return new constructorClass(properties, this.body, this.images, this.groups, this.options, this.defaultOptions);
    }

    /**
     *
     * @param {boolean} [clearPositions=false]
     */

  }, {
    key: 'refresh',
    value: function refresh() {
      var _this3 = this;

      var clearPositions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      util.forEach(this.body.nodes, function (node, nodeId) {
        var data = _this3.body.data.nodes.get(nodeId);
        if (data !== undefined) {
          if (clearPositions === true) {
            node.setOptions({ x: null, y: null });
          }
          node.setOptions({ fixed: false });
          node.setOptions(data);
        }
      });
    }

    /**
     * Returns the positions of the nodes.
     * @param {Array.<Node.id>|String} [ids]  --> optional, can be array of nodeIds, can be string
     * @returns {{}}
     */

  }, {
    key: 'getPositions',
    value: function getPositions(ids) {
      var dataArray = {};
      if (ids !== undefined) {
        if (Array.isArray(ids) === true) {
          for (var i = 0; i < ids.length; i++) {
            if (this.body.nodes[ids[i]] !== undefined) {
              var node = this.body.nodes[ids[i]];
              dataArray[ids[i]] = { x: Math.round(node.x), y: Math.round(node.y) };
            }
          }
        } else {
          if (this.body.nodes[ids] !== undefined) {
            var _node = this.body.nodes[ids];
            dataArray[ids] = { x: Math.round(_node.x), y: Math.round(_node.y) };
          }
        }
      } else {
        for (var _i = 0; _i < this.body.nodeIndices.length; _i++) {
          var _node2 = this.body.nodes[this.body.nodeIndices[_i]];
          dataArray[this.body.nodeIndices[_i]] = { x: Math.round(_node2.x), y: Math.round(_node2.y) };
        }
      }
      return dataArray;
    }

    /**
     * Load the XY positions of the nodes into the dataset.
     */

  }, {
    key: 'storePositions',
    value: function storePositions() {
      // todo: add support for clusters and hierarchical.
      var dataArray = [];
      var dataset = this.body.data.nodes.getDataSet();

      for (var nodeId in dataset._data) {
        if (dataset._data.hasOwnProperty(nodeId)) {
          var node = this.body.nodes[nodeId];
          if (dataset._data[nodeId].x != Math.round(node.x) || dataset._data[nodeId].y != Math.round(node.y)) {
            dataArray.push({ id: node.id, x: Math.round(node.x), y: Math.round(node.y) });
          }
        }
      }
      dataset.update(dataArray);
    }

    /**
     * get the bounding box of a node.
     * @param {Node.id} nodeId
     * @returns {j|*}
     */

  }, {
    key: 'getBoundingBox',
    value: function getBoundingBox(nodeId) {
      if (this.body.nodes[nodeId] !== undefined) {
        return this.body.nodes[nodeId].shape.boundingBox;
      }
    }

    /**
     * Get the Ids of nodes connected to this node.
     * @param {Node.id} nodeId
     * @param {'to'|'from'|undefined} direction values 'from' and 'to' select respectively parent and child nodes only.
     *                                          Any other value returns both parent and child nodes.
     * @returns {Array}
     */

  }, {
    key: 'getConnectedNodes',
    value: function getConnectedNodes(nodeId, direction) {
      var nodeList = [];
      if (this.body.nodes[nodeId] !== undefined) {
        var node = this.body.nodes[nodeId];
        var nodeObj = {}; // used to quickly check if node already exists
        for (var i = 0; i < node.edges.length; i++) {
          var edge = node.edges[i];
          if (direction !== 'to' && edge.toId == node.id) {
            // these are double equals since ids can be numeric or string
            if (nodeObj[edge.fromId] === undefined) {
              nodeList.push(edge.fromId);
              nodeObj[edge.fromId] = true;
            }
          } else if (direction !== 'from' && edge.fromId == node.id) {
            // these are double equals since ids can be numeric or string
            if (nodeObj[edge.toId] === undefined) {
              nodeList.push(edge.toId);
              nodeObj[edge.toId] = true;
            }
          }
        }
      }
      return nodeList;
    }

    /**
     * Get the ids of the edges connected to this node.
     * @param {Node.id} nodeId
     * @returns {*}
     */

  }, {
    key: 'getConnectedEdges',
    value: function getConnectedEdges(nodeId) {
      var edgeList = [];
      if (this.body.nodes[nodeId] !== undefined) {
        var node = this.body.nodes[nodeId];
        for (var i = 0; i < node.edges.length; i++) {
          edgeList.push(node.edges[i].id);
        }
      } else {
        console.log("NodeId provided for getConnectedEdges does not exist. Provided: ", nodeId);
      }
      return edgeList;
    }

    /**
     * Move a node.
     *
     * @param {Node.id} nodeId
     * @param {number} x
     * @param {number} y
     */

  }, {
    key: 'moveNode',
    value: function moveNode(nodeId, x, y) {
      var _this4 = this;

      if (this.body.nodes[nodeId] !== undefined) {
        this.body.nodes[nodeId].x = Number(x);
        this.body.nodes[nodeId].y = Number(y);
        setTimeout(function () {
          _this4.body.emitter.emit("startSimulation");
        }, 0);
      } else {
        console.log("Node id supplied to moveNode does not exist. Provided: ", nodeId);
      }
    }
  }]);
  return NodesHandler;
}();

exports['default'] = NodesHandler;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(189), __esModule: true };

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
__webpack_require__(60);
module.exports = __webpack_require__(190);


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(86);
var ITERATOR = __webpack_require__(13)('iterator');
var Iterators = __webpack_require__(31);
module.exports = __webpack_require__(7).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LabelAccumulator = __webpack_require__(192)['default'];
var ComponentUtil = __webpack_require__(48)['default'];

/**
 * Helper class for Label which explodes the label text into lines and blocks within lines
 *
 * @private
 */

var LabelSplitter = function () {

  /**
   * @param {CanvasRenderingContext2D} ctx Canvas rendering context
   * @param {Label} parent reference to the Label instance using current instance
   * @param {boolean} selected 
   * @param {boolean} hover
   */
  function LabelSplitter(ctx, parent, selected, hover) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, LabelSplitter);

    this.ctx = ctx;
    this.parent = parent;

    /**
     * Callback to determine text width; passed to LabelAccumulator instance
     *
     * @param  {String} text string to determine width of
     * @param  {String} mod  font type to use for this text
     * @return {Object} { width, values} width in pixels and font attributes
     */
    var textWidth = function textWidth(text, mod) {
      if (text === undefined) return 0;

      // TODO: This can be done more efficiently with caching
      var values = _this.parent.getFormattingValues(ctx, selected, hover, mod);

      var width = 0;
      if (text !== '') {
        // NOTE: The following may actually be *incorrect* for the mod fonts!
        //       This returns the size with a regular font, bold etc. may
        //       have different sizes.
        var measure = _this.ctx.measureText(text);
        width = measure.width;
      }

      return { width: width, values: values };
    };

    this.lines = new LabelAccumulator(textWidth);
  }

  /**
   * Split passed text of a label into lines and blocks.
   *
   * # NOTE
   *
   * The handling of spacing is option dependent:
   *
   * - if `font.multi : false`, all spaces are retained
   * - if `font.multi : true`, every sequence of spaces is compressed to a single space
   *
   * This might not be the best way to do it, but this is as it has been working till now.
   * In order not to break existing functionality, for the time being this behaviour will
   * be retained in any code changes. 
   *
   * @param {string} text  text to split
   * @returns {Array<line>}
   */


  (0, _createClass3['default'])(LabelSplitter, [{
    key: 'process',
    value: function process(text) {
      if (!ComponentUtil.isValidLabel(text)) {
        return this.lines.finalize();
      }

      var font = this.parent.fontOptions;

      // Normalize the end-of-line's to a single representation - order important
      text = text.replace(/\r\n/g, '\n'); // Dos EOL's
      text = text.replace(/\r/g, '\n'); // Mac EOL's

      // Note that at this point, there can be no \r's in the text.
      // This is used later on splitStringIntoLines() to split multifont texts.

      var nlLines = String(text).split('\n');
      var lineCount = nlLines.length;

      if (font.multi) {
        // Multi-font case: styling tags active
        for (var i = 0; i < lineCount; i++) {
          var blocks = this.splitBlocks(nlLines[i], font.multi);
          // Post: Sequences of tabs and spaces are reduced to single space

          if (blocks === undefined) continue;

          if (blocks.length === 0) {
            this.lines.newLine("");
            continue;
          }

          if (font.maxWdt > 0) {
            // widthConstraint.maximum defined
            //console.log('Running widthConstraint multi, max: ' + this.fontOptions.maxWdt);
            for (var j = 0; j < blocks.length; j++) {
              var mod = blocks[j].mod;
              var _text = blocks[j].text;
              this.splitStringIntoLines(_text, mod, true);
            }
          } else {
            // widthConstraint.maximum NOT defined
            for (var _j = 0; _j < blocks.length; _j++) {
              var _mod = blocks[_j].mod;
              var _text2 = blocks[_j].text;
              this.lines.append(_text2, _mod);
            }
          }

          this.lines.newLine();
        }
      } else {
        // Single-font case
        if (font.maxWdt > 0) {
          // widthConstraint.maximum defined
          // console.log('Running widthConstraint normal, max: ' + this.fontOptions.maxWdt);
          for (var _i = 0; _i < lineCount; _i++) {
            this.splitStringIntoLines(nlLines[_i]);
          }
        } else {
          // widthConstraint.maximum NOT defined
          for (var _i2 = 0; _i2 < lineCount; _i2++) {
            this.lines.newLine(nlLines[_i2]);
          }
        }
      }

      return this.lines.finalize();
    }

    /**
     * normalize the markup system
     *
     * @param {boolean|'md'|'markdown'|'html'} markupSystem
     * @returns {string}
     */

  }, {
    key: 'decodeMarkupSystem',
    value: function decodeMarkupSystem(markupSystem) {
      var system = 'none';
      if (markupSystem === 'markdown' || markupSystem === 'md') {
        system = 'markdown';
      } else if (markupSystem === true || markupSystem === 'html') {
        system = 'html';
      }
      return system;
    }

    /**
     *
     * @param {string} text
     * @returns {Array}
     */

  }, {
    key: 'splitHtmlBlocks',
    value: function splitHtmlBlocks(text) {
      var blocks = [];

      // TODO: consolidate following + methods/closures with splitMarkdownBlocks()
      // NOTE: sequences of tabs and spaces are reduced to single space; scan usage of `this.spacing` within method
      var s = {
        bold: false,
        ital: false,
        mono: false,
        spacing: false,
        position: 0,
        buffer: "",
        modStack: []
      };

      s.mod = function () {
        return this.modStack.length === 0 ? 'normal' : this.modStack[0];
      };

      s.modName = function () {
        if (this.modStack.length === 0) return 'normal';else if (this.modStack[0] === 'mono') return 'mono';else {
          if (s.bold && s.ital) {
            return 'boldital';
          } else if (s.bold) {
            return 'bold';
          } else if (s.ital) {
            return 'ital';
          }
        }
      };

      s.emitBlock = function () {
        var override = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        // eslint-disable-line no-unused-vars
        if (this.spacing) {
          this.add(" ");
          this.spacing = false;
        }
        if (this.buffer.length > 0) {
          blocks.push({ text: this.buffer, mod: this.modName() });
          this.buffer = "";
        }
      };

      s.add = function (text) {
        if (text === " ") {
          s.spacing = true;
        }
        if (s.spacing) {
          this.buffer += " ";
          this.spacing = false;
        }
        if (text != " ") {
          this.buffer += text;
        }
      };

      while (s.position < text.length) {
        var ch = text.charAt(s.position);
        if (/[ \t]/.test(ch)) {
          if (!s.mono) {
            s.spacing = true;
          } else {
            s.add(ch);
          }
        } else if (/</.test(ch)) {
          if (!s.mono && !s.bold && /<b>/.test(text.substr(s.position, 3))) {
            s.emitBlock();
            s.bold = true;
            s.modStack.unshift("bold");
            s.position += 2;
          } else if (!s.mono && !s.ital && /<i>/.test(text.substr(s.position, 3))) {
            s.emitBlock();
            s.ital = true;
            s.modStack.unshift("ital");
            s.position += 2;
          } else if (!s.mono && /<code>/.test(text.substr(s.position, 6))) {
            s.emitBlock();
            s.mono = true;
            s.modStack.unshift("mono");
            s.position += 5;
          } else if (!s.mono && s.mod() === 'bold' && /<\/b>/.test(text.substr(s.position, 4))) {
            s.emitBlock();
            s.bold = false;
            s.modStack.shift();
            s.position += 3;
          } else if (!s.mono && s.mod() === 'ital' && /<\/i>/.test(text.substr(s.position, 4))) {
            s.emitBlock();
            s.ital = false;
            s.modStack.shift();
            s.position += 3;
          } else if (s.mod() === 'mono' && /<\/code>/.test(text.substr(s.position, 7))) {
            s.emitBlock();
            s.mono = false;
            s.modStack.shift();
            s.position += 6;
          } else {
            s.add(ch);
          }
        } else if (/&/.test(ch)) {
          if (/&lt;/.test(text.substr(s.position, 4))) {
            s.add("<");
            s.position += 3;
          } else if (/&amp;/.test(text.substr(s.position, 5))) {
            s.add("&");
            s.position += 4;
          } else {
            s.add("&");
          }
        } else {
          s.add(ch);
        }
        s.position++;
      }
      s.emitBlock();
      return blocks;
    }

    /**
     *
     * @param {string} text
     * @returns {Array}
     */

  }, {
    key: 'splitMarkdownBlocks',
    value: function splitMarkdownBlocks(text) {
      var blocks = [];

      // TODO: consolidate following + methods/closures with splitHtmlBlocks()
      // NOTE: sequences of tabs and spaces are reduced to single space; scan usage of `this.spacing` within method
      var s = {
        bold: false,
        ital: false,
        mono: false,
        beginable: true,
        spacing: false,
        position: 0,
        buffer: "",
        modStack: []
      };

      s.mod = function () {
        return this.modStack.length === 0 ? 'normal' : this.modStack[0];
      };

      s.modName = function () {
        if (this.modStack.length === 0) return 'normal';else if (this.modStack[0] === 'mono') return 'mono';else {
          if (s.bold && s.ital) {
            return 'boldital';
          } else if (s.bold) {
            return 'bold';
          } else if (s.ital) {
            return 'ital';
          }
        }
      };

      s.emitBlock = function () {
        var override = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        // eslint-disable-line no-unused-vars
        if (this.spacing) {
          this.add(" ");
          this.spacing = false;
        }
        if (this.buffer.length > 0) {
          blocks.push({ text: this.buffer, mod: this.modName() });
          this.buffer = "";
        }
      };

      s.add = function (text) {
        if (text === " ") {
          s.spacing = true;
        }
        if (s.spacing) {
          this.buffer += " ";
          this.spacing = false;
        }
        if (text != " ") {
          this.buffer += text;
        }
      };

      while (s.position < text.length) {
        var ch = text.charAt(s.position);
        if (/[ \t]/.test(ch)) {
          if (!s.mono) {
            s.spacing = true;
          } else {
            s.add(ch);
          }
          s.beginable = true;
        } else if (/\\/.test(ch)) {
          if (s.position < text.length + 1) {
            s.position++;
            ch = text.charAt(s.position);
            if (/ \t/.test(ch)) {
              s.spacing = true;
            } else {
              s.add(ch);
              s.beginable = false;
            }
          }
        } else if (!s.mono && !s.bold && (s.beginable || s.spacing) && /\*/.test(ch)) {
          s.emitBlock();
          s.bold = true;
          s.modStack.unshift("bold");
        } else if (!s.mono && !s.ital && (s.beginable || s.spacing) && /\_/.test(ch)) {
          s.emitBlock();
          s.ital = true;
          s.modStack.unshift("ital");
        } else if (!s.mono && (s.beginable || s.spacing) && /`/.test(ch)) {
          s.emitBlock();
          s.mono = true;
          s.modStack.unshift("mono");
        } else if (!s.mono && s.mod() === "bold" && /\*/.test(ch)) {
          if (s.position === text.length - 1 || /[.,_` \t\n]/.test(text.charAt(s.position + 1))) {
            s.emitBlock();
            s.bold = false;
            s.modStack.shift();
          } else {
            s.add(ch);
          }
        } else if (!s.mono && s.mod() === "ital" && /\_/.test(ch)) {
          if (s.position === text.length - 1 || /[.,*` \t\n]/.test(text.charAt(s.position + 1))) {
            s.emitBlock();
            s.ital = false;
            s.modStack.shift();
          } else {
            s.add(ch);
          }
        } else if (s.mono && s.mod() === "mono" && /`/.test(ch)) {
          if (s.position === text.length - 1 || /[.,*_ \t\n]/.test(text.charAt(s.position + 1))) {
            s.emitBlock();
            s.mono = false;
            s.modStack.shift();
          } else {
            s.add(ch);
          }
        } else {
          s.add(ch);
          s.beginable = false;
        }
        s.position++;
      }
      s.emitBlock();
      return blocks;
    }

    /**
     * Explodes a piece of text into single-font blocks using a given markup
     *
     * @param {string} text
     * @param {boolean|'md'|'markdown'|'html'} markupSystem
     * @returns {Array.<{text: string, mod: string}>}
     * @private
     */

  }, {
    key: 'splitBlocks',
    value: function splitBlocks(text, markupSystem) {
      var system = this.decodeMarkupSystem(markupSystem);
      if (system === 'none') {
        return [{
          text: text,
          mod: 'normal'
        }];
      } else if (system === 'markdown') {
        return this.splitMarkdownBlocks(text);
      } else if (system === 'html') {
        return this.splitHtmlBlocks(text);
      }
    }

    /**
     * @param {string} text
     * @returns {boolean} true if text length over the current max with
     * @private
     */

  }, {
    key: 'overMaxWidth',
    value: function overMaxWidth(text) {
      var width = this.ctx.measureText(text).width;
      return this.lines.curWidth() + width > this.parent.fontOptions.maxWdt;
    }

    /**
     * Determine the longest part of the sentence which still fits in the 
     * current max width.
     * 
     * @param {Array} words  Array of strings signifying a text lines
     * @return {number}      index of first item in string making string go over max
     * @private
     */

  }, {
    key: 'getLongestFit',
    value: function getLongestFit(words) {
      var text = '';
      var w = 0;

      while (w < words.length) {
        var pre = text === '' ? '' : ' ';
        var newText = text + pre + words[w];

        if (this.overMaxWidth(newText)) break;
        text = newText;
        w++;
      }

      return w;
    }

    /**
     * Determine the longest part of the string which still fits in the
     * current max width.
     * 
     * @param {Array} words Array of strings signifying a text lines
     * @return {number} index of first item in string making string go over max
     */

  }, {
    key: 'getLongestFitWord',
    value: function getLongestFitWord(words) {
      var w = 0;

      while (w < words.length) {
        if (this.overMaxWidth(words.slice(0, w))) break;
        w++;
      }

      return w;
    }

    /**
     * Split the passed text into lines, according to width constraint (if any).
     * 
     * The method assumes that the input string is a single line, i.e. without lines break.
     *
     * This method retains spaces, if still present (case `font.multi: false`).
     * A space which falls on an internal line break, will be replaced by a newline.
     * There is no special handling of tabs; these go along with the flow.
     * 
     * @param {string} str
     * @param {string} [mod='normal']
     * @param {boolean} [appendLast=false]
     * @private
     */

  }, {
    key: 'splitStringIntoLines',
    value: function splitStringIntoLines(str) {
      var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'normal';
      var appendLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // Still-present spaces are relevant, retain them
      str = str.replace(/^( +)/g, '$1\r');
      str = str.replace(/([^\r][^ ]*)( +)/g, '$1\r$2\r');
      var words = str.split('\r');

      while (words.length > 0) {
        var w = this.getLongestFit(words);

        if (w === 0) {
          // Special case: the first word is already larger than the max width.
          var word = words[0];

          // Break the word to the largest part that fits the line
          var x = this.getLongestFitWord(word);
          this.lines.newLine(word.slice(0, x), mod);

          // Adjust the word, so that the rest will be done next iteration
          words[0] = word.slice(x);
        } else {
          // skip any space that is replaced by a newline
          var newW = w;
          if (words[w - 1] === ' ') {
            w--;
          } else if (words[newW] === ' ') {
            newW++;
          }

          var text = words.slice(0, w).join("");

          if (w == words.length && appendLast) {
            this.lines.append(text, mod);
          } else {
            this.lines.newLine(text, mod);
          }

          // Adjust the word, so that the rest will be done next iteration
          words = words.slice(newW);
        }
      }
    }
  }]);
  return LabelSplitter;
}();

exports['default'] = LabelSplitter;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(90);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Callback to determine text dimensions, using the parent label settings.
 * @callback MeasureText
 * @param {text} text
 * @param {text} mod
 * @return {Object} { width, values} width in pixels and font attributes
 */

/**
 * Helper class for Label which collects results of splitting labels into lines and blocks.
 *
 * @private
 */
var LabelAccumulator = function () {

  /**
   * @param {MeasureText} measureText
   */
  function LabelAccumulator(measureText) {
    (0, _classCallCheck3["default"])(this, LabelAccumulator);

    this.measureText = measureText;
    this.current = 0;
    this.width = 0;
    this.height = 0;
    this.lines = [];
  }

  /**
   * Append given text to the given line.
   *
   * @param {number}  l    index of line to add to
   * @param {string}  text string to append to line
   * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
   * @private
   */


  (0, _createClass3["default"])(LabelAccumulator, [{
    key: "_add",
    value: function _add(l, text) {
      var mod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'normal';


      if (this.lines[l] === undefined) {
        this.lines[l] = {
          width: 0,
          height: 0,
          blocks: []
        };
      }

      // We still need to set a block for undefined and empty texts, hence return at this point
      // This is necessary because we don't know at this point if we're at the
      // start of an empty line or not.
      // To compensate, empty blocks are removed in `finalize()`.
      //
      // Empty strings should still have a height
      var tmpText = text;
      if (text === undefined || text === "") tmpText = " ";

      // Determine width and get the font properties
      var result = this.measureText(tmpText, mod);
      var block = (0, _assign2["default"])({}, result.values);
      block.text = text;
      block.width = result.width;
      block.mod = mod;

      if (text === undefined || text === "") {
        block.width = 0;
      }

      this.lines[l].blocks.push(block);

      // Update the line width. We need this for determining if a string goes over max width
      this.lines[l].width += block.width;
    }

    /**
     * Returns the width in pixels of the current line.
     *
     * @returns {number}
     */

  }, {
    key: "curWidth",
    value: function curWidth() {
      var line = this.lines[this.current];
      if (line === undefined) return 0;

      return line.width;
    }

    /**
     * Add text in block to current line
     *
     * @param {string} text
     * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
     */

  }, {
    key: "append",
    value: function append(text) {
      var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'normal';

      this._add(this.current, text, mod);
    }

    /**
     * Add text in block to current line and start a new line
     *
     * @param {string} text
     * @param {'bold'|'ital'|'boldital'|'mono'|'normal'} [mod='normal']
     */

  }, {
    key: "newLine",
    value: function newLine(text) {
      var mod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'normal';

      this._add(this.current, text, mod);
      this.current++;
    }

    /**
     * Determine and set the heights of all the lines currently contained in this instance
     *
     * Note that width has already been set.
     * 
     * @private
     */

  }, {
    key: "determineLineHeights",
    value: function determineLineHeights() {
      for (var k = 0; k < this.lines.length; k++) {
        var line = this.lines[k];

        // Looking for max height of blocks in line
        var height = 0;

        if (line.blocks !== undefined) {
          // Can happen if text contains e.g. '\n '
          for (var l = 0; l < line.blocks.length; l++) {
            var block = line.blocks[l];

            if (height < block.height) {
              height = block.height;
            }
          }
        }

        line.height = height;
      }
    }

    /**
     * Determine the full size of the label text, as determined by current lines and blocks
     * 
     * @private
     */

  }, {
    key: "determineLabelSize",
    value: function determineLabelSize() {
      var width = 0;
      var height = 0;
      for (var k = 0; k < this.lines.length; k++) {
        var line = this.lines[k];

        if (line.width > width) {
          width = line.width;
        }
        height += line.height;
      }

      this.width = width;
      this.height = height;
    }

    /**
     * Remove all empty blocks and empty lines we don't need
     * 
     * This must be done after the width/height determination,
     * so that these are set properly for processing here.
     *
     * @returns {Array<Line>} Lines with empty blocks (and some empty lines) removed
     * @private
     */

  }, {
    key: "removeEmptyBlocks",
    value: function removeEmptyBlocks() {
      var tmpLines = [];
      for (var k = 0; k < this.lines.length; k++) {
        var line = this.lines[k];

        // Note: an empty line in between text has width zero but is still relevant to layout.
        // So we can't use width for testing empty line here
        if (line.blocks.length === 0) continue;

        // Discard final empty line always
        if (k === this.lines.length - 1) {
          if (line.width === 0) continue;
        }

        var tmpLine = {};
        (0, _assign2["default"])(tmpLine, line);
        tmpLine.blocks = [];

        var firstEmptyBlock = void 0;
        var tmpBlocks = [];
        for (var l = 0; l < line.blocks.length; l++) {
          var block = line.blocks[l];
          if (block.width !== 0) {
            tmpBlocks.push(block);
          } else {
            if (firstEmptyBlock === undefined) {
              firstEmptyBlock = block;
            }
          }
        }

        // Ensure that there is *some* text present
        if (tmpBlocks.length === 0 && firstEmptyBlock !== undefined) {
          tmpBlocks.push(firstEmptyBlock);
        }

        tmpLine.blocks = tmpBlocks;

        tmpLines.push(tmpLine);
      }

      return tmpLines;
    }

    /**
     * Set the sizes for all lines and the whole thing.
     *
     * @returns {{width: (number|*), height: (number|*), lines: Array}}
     */

  }, {
    key: "finalize",
    value: function finalize() {
      //console.log(JSON.stringify(this.lines, null, 2));

      this.determineLineHeights();
      this.determineLabelSize();
      var tmpLines = this.removeEmptyBlocks();

      // Return a simple hash object for further processing.
      return {
        width: this.width,
        height: this.height,
        lines: tmpLines
      };
    }
  }]);
  return LabelAccumulator;
}();

exports["default"] = LabelAccumulator;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NodeBase2 = __webpack_require__(23);

var _NodeBase3 = _interopRequireDefault(_NodeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Box Node/Cluster shape.
 *
 * @extends NodeBase
 */
var Box = function (_NodeBase) {
  (0, _inherits3['default'])(Box, _NodeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Box(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Box);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Box.__proto__ || (0, _getPrototypeOf2['default'])(Box)).call(this, options, body, labelModule));

    _this._setMargins(labelModule);
    return _this;
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */


  (0, _createClass3['default'])(Box, [{
    key: 'resize',
    value: function resize(ctx) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
      var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

      if (this.needsRefresh(selected, hover)) {
        var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);

        this.width = dimensions.width + this.margin.right + this.margin.left;
        this.height = dimensions.height + this.margin.top + this.margin.bottom;
        this.radius = this.width / 2;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this.resize(ctx, selected, hover);
      this.left = x - this.width / 2;
      this.top = y - this.height / 2;

      this.initContextForDraw(ctx, values);
      ctx.roundRect(this.left, this.top, this.width, this.height, values.borderRadius);
      this.performFill(ctx, values);

      this.updateBoundingBox(x, y, ctx, selected, hover);
      this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
    }

    /**
     *
     * @param {number} x width
     * @param {number} y height
     * @param {CanvasRenderingContext2D} ctx
     * @param {boolean} selected
     * @param {boolean} hover
     */

  }, {
    key: 'updateBoundingBox',
    value: function updateBoundingBox(x, y, ctx, selected, hover) {
      this._updateBoundingBox(x, y, ctx, selected, hover);

      var borderRadius = this.options.shapeProperties.borderRadius; // only effective for box
      this._addBoundingBoxMargin(borderRadius);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      this.resize(ctx);
      var borderWidth = this.options.borderWidth;

      return Math.min(Math.abs(this.width / 2 / Math.cos(angle)), Math.abs(this.height / 2 / Math.sin(angle))) + borderWidth;
    }
  }]);
  return Box;
}(_NodeBase3['default']);

exports['default'] = Box;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(195);
module.exports = __webpack_require__(7).Object.getPrototypeOf;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(41);
var $getPrototypeOf = __webpack_require__(85);

__webpack_require__(87)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(197), __esModule: true };

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
module.exports = __webpack_require__(7).Object.setPrototypeOf;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(17);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(199).set });


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(32);
var anObject = __webpack_require__(27);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(80)(Function.call, __webpack_require__(89).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CircleImageBase2 = __webpack_require__(73);

var _CircleImageBase3 = _interopRequireDefault(_CircleImageBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Circle Node/Cluster shape.
 *
 * @extends CircleImageBase
 */
var Circle = function (_CircleImageBase) {
  (0, _inherits3['default'])(Circle, _CircleImageBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Circle(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Circle);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Circle.__proto__ || (0, _getPrototypeOf2['default'])(Circle)).call(this, options, body, labelModule));

    _this._setMargins(labelModule);
    return _this;
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */


  (0, _createClass3['default'])(Circle, [{
    key: 'resize',
    value: function resize(ctx) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
      var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

      if (this.needsRefresh(selected, hover)) {
        var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);

        var diameter = Math.max(dimensions.width + this.margin.right + this.margin.left, dimensions.height + this.margin.top + this.margin.bottom);

        this.options.size = diameter / 2; // NOTE: this size field only set here, not in Ellipse, Database, Box
        this.width = diameter;
        this.height = diameter;
        this.radius = this.width / 2;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this.resize(ctx, selected, hover);
      this.left = x - this.width / 2;
      this.top = y - this.height / 2;

      this._drawRawCircle(ctx, x, y, values);

      this.updateBoundingBox(x, y);
      this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, y, selected, hover);
    }

    /**
     *
     * @param {number} x width
     * @param {number} y height
     */

  }, {
    key: 'updateBoundingBox',
    value: function updateBoundingBox(x, y) {
      this.boundingBox.top = y - this.options.size;
      this.boundingBox.left = x - this.options.size;
      this.boundingBox.right = x + this.options.size;
      this.boundingBox.bottom = y + this.options.size;
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle - Unused
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      // eslint-disable-line no-unused-vars
      this.resize(ctx);
      return this.width * 0.5;
    }
  }]);
  return Circle;
}(_CircleImageBase3['default']);

exports['default'] = Circle;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CircleImageBase2 = __webpack_require__(73);

var _CircleImageBase3 = _interopRequireDefault(_CircleImageBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A CircularImage Node/Cluster shape.
 *
 * @extends CircleImageBase
 */
var CircularImage = function (_CircleImageBase) {
  (0, _inherits3['default'])(CircularImage, _CircleImageBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   * @param {Image} imageObj
   * @param {Image} imageObjAlt
   */
  function CircularImage(options, body, labelModule, imageObj, imageObjAlt) {
    (0, _classCallCheck3['default'])(this, CircularImage);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (CircularImage.__proto__ || (0, _getPrototypeOf2['default'])(CircularImage)).call(this, options, body, labelModule));

    _this.setImages(imageObj, imageObjAlt);
    return _this;
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */


  (0, _createClass3['default'])(CircularImage, [{
    key: 'resize',
    value: function resize(ctx) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
      var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

      var imageAbsent = this.imageObj.src === undefined || this.imageObj.width === undefined || this.imageObj.height === undefined;

      if (imageAbsent) {
        var diameter = this.options.size * 2;
        this.width = diameter;
        this.height = diameter;
        this.radius = 0.5 * this.width;
        return;
      }

      // At this point, an image is present, i.e. this.imageObj is valid.
      if (this.needsRefresh(selected, hover)) {
        this._resizeImage();
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this.switchImages(selected);
      this.resize();
      this.left = x - this.width / 2;
      this.top = y - this.height / 2;

      // draw the background circle. IMPORTANT: the stroke in this method is used by the clip method below.
      this._drawRawCircle(ctx, x, y, values);

      // now we draw in the circle, we save so we can revert the clip operation after drawing.
      ctx.save();
      // clip is used to use the stroke in drawRawCircle as an area that we can draw in.
      ctx.clip();
      // draw the image
      this._drawImageAtPosition(ctx, values);
      // restore so we can again draw on the full canvas
      ctx.restore();

      this._drawImageLabel(ctx, x, y, selected, hover);

      this.updateBoundingBox(x, y);
    }

    // TODO: compare with Circle.updateBoundingBox(), consolidate? More stuff is happening here
    /**
     *
     * @param {number} x width
     * @param {number} y height
     */

  }, {
    key: 'updateBoundingBox',
    value: function updateBoundingBox(x, y) {
      this.boundingBox.top = y - this.options.size;
      this.boundingBox.left = x - this.options.size;
      this.boundingBox.right = x + this.options.size;
      this.boundingBox.bottom = y + this.options.size;

      // TODO: compare with Image.updateBoundingBox(), consolidate?
      this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
      this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
      this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle - Unused
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      // eslint-disable-line no-unused-vars
      this.resize(ctx);
      return this.width * 0.5;
    }
  }]);
  return CircularImage;
}(_CircleImageBase3['default']);

exports['default'] = CircularImage;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NodeBase2 = __webpack_require__(23);

var _NodeBase3 = _interopRequireDefault(_NodeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Database Node/Cluster shape.
 *
 * @extends NodeBase
 */
var Database = function (_NodeBase) {
  (0, _inherits3['default'])(Database, _NodeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Database(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Database);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Database.__proto__ || (0, _getPrototypeOf2['default'])(Database)).call(this, options, body, labelModule));

    _this._setMargins(labelModule);
    return _this;
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */


  (0, _createClass3['default'])(Database, [{
    key: 'resize',
    value: function resize(ctx, selected, hover) {
      if (this.needsRefresh(selected, hover)) {
        var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);
        var size = dimensions.width + this.margin.right + this.margin.left;

        this.width = size;
        this.height = size;
        this.radius = this.width / 2;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this.resize(ctx, selected, hover);
      this.left = x - this.width / 2;
      this.top = y - this.height / 2;

      this.initContextForDraw(ctx, values);
      ctx.database(x - this.width / 2, y - this.height / 2, this.width, this.height);
      this.performFill(ctx, values);

      this.updateBoundingBox(x, y, ctx, selected, hover);
      this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);
    }
    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Database;
}(_NodeBase3['default']);

exports['default'] = Database;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShapeBase2 = __webpack_require__(24);

var _ShapeBase3 = _interopRequireDefault(_ShapeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Diamond Node/Cluster shape.
 *
 * @extends ShapeBase
 */
var Diamond = function (_ShapeBase) {
  (0, _inherits3['default'])(Diamond, _ShapeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Diamond(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Diamond);
    return (0, _possibleConstructorReturn3['default'])(this, (Diamond.__proto__ || (0, _getPrototypeOf2['default'])(Diamond)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   */


  (0, _createClass3['default'])(Diamond, [{
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this._drawShape(ctx, 'diamond', 4, x, y, selected, hover, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Diamond;
}(_ShapeBase3['default']);

exports['default'] = Diamond;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShapeBase2 = __webpack_require__(24);

var _ShapeBase3 = _interopRequireDefault(_ShapeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Dot Node/Cluster shape.
 *
 * @extends ShapeBase
 */
var Dot = function (_ShapeBase) {
  (0, _inherits3['default'])(Dot, _ShapeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Dot(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Dot);
    return (0, _possibleConstructorReturn3['default'])(this, (Dot.__proto__ || (0, _getPrototypeOf2['default'])(Dot)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   */


  (0, _createClass3['default'])(Dot, [{
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this._drawShape(ctx, 'circle', 2, x, y, selected, hover, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      // eslint-disable-line no-unused-vars
      this.resize(ctx);
      return this.options.size;
    }
  }]);
  return Dot;
}(_ShapeBase3['default']);

exports['default'] = Dot;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NodeBase2 = __webpack_require__(23);

var _NodeBase3 = _interopRequireDefault(_NodeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Am Ellipse Node/Cluster shape.
 *
 * @extends NodeBase
 */
var Ellipse = function (_NodeBase) {
  (0, _inherits3['default'])(Ellipse, _NodeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Ellipse(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Ellipse);
    return (0, _possibleConstructorReturn3['default'])(this, (Ellipse.__proto__ || (0, _getPrototypeOf2['default'])(Ellipse)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */


  (0, _createClass3['default'])(Ellipse, [{
    key: 'resize',
    value: function resize(ctx) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
      var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

      if (this.needsRefresh(selected, hover)) {
        var dimensions = this.getDimensionsFromLabel(ctx, selected, hover);

        this.height = dimensions.height * 2;
        this.width = dimensions.width + dimensions.height;
        this.radius = 0.5 * this.width;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this.resize(ctx, selected, hover);
      this.left = x - this.width * 0.5;
      this.top = y - this.height * 0.5;

      this.initContextForDraw(ctx, values);
      ctx.ellipse_vis(this.left, this.top, this.width, this.height);
      this.performFill(ctx, values);

      this.updateBoundingBox(x, y, ctx, selected, hover);
      this.labelModule.draw(ctx, x, y, selected, hover);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      this.resize(ctx);
      var a = this.width * 0.5;
      var b = this.height * 0.5;
      var w = Math.sin(angle) * a;
      var h = Math.cos(angle) * b;
      return a * b / Math.sqrt(w * w + h * h);
    }
  }]);
  return Ellipse;
}(_NodeBase3['default']);

exports['default'] = Ellipse;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NodeBase2 = __webpack_require__(23);

var _NodeBase3 = _interopRequireDefault(_NodeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * An icon replacement for the default Node shape.
 *
 * @extends NodeBase
 */
var Icon = function (_NodeBase) {
  (0, _inherits3['default'])(Icon, _NodeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Icon(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Icon);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Icon.__proto__ || (0, _getPrototypeOf2['default'])(Icon)).call(this, options, body, labelModule));

    _this._setMargins(labelModule);
    return _this;
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx - Unused.
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */


  (0, _createClass3['default'])(Icon, [{
    key: 'resize',
    value: function resize(ctx, selected, hover) {
      if (this.needsRefresh(selected, hover)) {
        this.iconSize = {
          width: Number(this.options.icon.size),
          height: Number(this.options.icon.size)
        };
        this.width = this.iconSize.width + this.margin.right + this.margin.left;
        this.height = this.iconSize.height + this.margin.top + this.margin.bottom;
        this.radius = 0.5 * this.width;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this.resize(ctx, selected, hover);
      this.options.icon.size = this.options.icon.size || 50;

      this.left = x - this.width / 2;
      this.top = y - this.height / 2;
      this._icon(ctx, x, y, selected, hover, values);

      if (this.options.label !== undefined) {
        var iconTextSpacing = 5;
        this.labelModule.draw(ctx, this.left + this.iconSize.width / 2 + this.margin.left, y + this.height / 2 + iconTextSpacing, selected);
      }

      this.updateBoundingBox(x, y);
    }

    /**
     *
     * @param {number} x
     * @param {number} y
     */

  }, {
    key: 'updateBoundingBox',
    value: function updateBoundingBox(x, y) {
      this.boundingBox.top = y - this.options.icon.size * 0.5;
      this.boundingBox.left = x - this.options.icon.size * 0.5;
      this.boundingBox.right = x + this.options.icon.size * 0.5;
      this.boundingBox.bottom = y + this.options.icon.size * 0.5;

      if (this.options.label !== undefined && this.labelModule.size.width > 0) {
        var iconTextSpacing = 5;
        this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
        this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
        this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelModule.size.height + iconTextSpacing);
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover - Unused
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: '_icon',
    value: function _icon(ctx, x, y, selected, hover, values) {
      var iconSize = Number(this.options.icon.size);

      if (this.options.icon.code !== undefined) {
        ctx.font = (selected ? "bold " : "") + iconSize + "px " + this.options.icon.face;

        // draw icon
        ctx.fillStyle = this.options.icon.color || "black";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        // draw shadow if enabled
        this.enableShadow(ctx, values);
        ctx.fillText(this.options.icon.code, x, y);

        // disable shadows for other elements.
        this.disableShadow(ctx, values);
      } else {
        console.error('When using the icon shape, you need to define the code in the icon options object. This can be done per node or globally.');
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Icon;
}(_NodeBase3['default']);

exports['default'] = Icon;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CircleImageBase2 = __webpack_require__(73);

var _CircleImageBase3 = _interopRequireDefault(_CircleImageBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * An image-based replacement for the default Node shape.
 *
 * @extends CircleImageBase
 */
var Image = function (_CircleImageBase) {
  (0, _inherits3['default'])(Image, _CircleImageBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   * @param {Image} imageObj
   * @param {Image} imageObjAlt
   */
  function Image(options, body, labelModule, imageObj, imageObjAlt) {
    (0, _classCallCheck3['default'])(this, Image);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Image.__proto__ || (0, _getPrototypeOf2['default'])(Image)).call(this, options, body, labelModule));

    _this.setImages(imageObj, imageObjAlt);
    return _this;
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx - Unused.
   * @param {boolean} [selected]
   * @param {boolean} [hover]
   */


  (0, _createClass3['default'])(Image, [{
    key: 'resize',
    value: function resize(ctx) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
      var hover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.hover;

      var imageAbsent = this.imageObj.src === undefined || this.imageObj.width === undefined || this.imageObj.height === undefined;

      if (imageAbsent) {
        var side = this.options.size * 2;
        this.width = side;
        this.height = side;
        return;
      }

      if (this.needsRefresh(selected, hover)) {
        this._resizeImage();
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this.switchImages(selected);
      this.resize();
      this.left = x - this.width / 2;
      this.top = y - this.height / 2;

      if (this.options.shapeProperties.useBorderWithImage === true) {
        var neutralborderWidth = this.options.borderWidth;
        var selectionLineWidth = this.options.borderWidthSelected || 2 * this.options.borderWidth;
        var borderWidth = (selected ? selectionLineWidth : neutralborderWidth) / this.body.view.scale;
        ctx.lineWidth = Math.min(this.width, borderWidth);

        ctx.beginPath();

        // setup the line properties.
        ctx.strokeStyle = selected ? this.options.color.highlight.border : hover ? this.options.color.hover.border : this.options.color.border;

        // set a fillstyle
        ctx.fillStyle = selected ? this.options.color.highlight.background : hover ? this.options.color.hover.background : this.options.color.background;

        // draw a rectangle to form the border around. This rectangle is filled so the opacity of a picture (in future vis releases?) can be used to tint the image
        ctx.rect(this.left - 0.5 * ctx.lineWidth, this.top - 0.5 * ctx.lineWidth, this.width + ctx.lineWidth, this.height + ctx.lineWidth);
        ctx.fill();

        this.performStroke(ctx, values);

        ctx.closePath();
      }

      this._drawImageAtPosition(ctx, values);

      this._drawImageLabel(ctx, x, y, selected, hover);

      this.updateBoundingBox(x, y);
    }

    /**
     *
     * @param {number} x
     * @param {number} y
     */

  }, {
    key: 'updateBoundingBox',
    value: function updateBoundingBox(x, y) {
      this.resize();
      this._updateBoundingBox(x, y);

      if (this.options.label !== undefined && this.labelModule.size.width > 0) {
        this.boundingBox.left = Math.min(this.boundingBox.left, this.labelModule.size.left);
        this.boundingBox.right = Math.max(this.boundingBox.right, this.labelModule.size.left + this.labelModule.size.width);
        this.boundingBox.bottom = Math.max(this.boundingBox.bottom, this.boundingBox.bottom + this.labelOffset);
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Image;
}(_CircleImageBase3['default']);

exports['default'] = Image;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShapeBase2 = __webpack_require__(24);

var _ShapeBase3 = _interopRequireDefault(_ShapeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Square Node/Cluster shape.
 *
 * @extends ShapeBase
 */
var Square = function (_ShapeBase) {
  (0, _inherits3['default'])(Square, _ShapeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Square(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Square);
    return (0, _possibleConstructorReturn3['default'])(this, (Square.__proto__ || (0, _getPrototypeOf2['default'])(Square)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   */


  (0, _createClass3['default'])(Square, [{
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this._drawShape(ctx, 'square', 2, x, y, selected, hover, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Square;
}(_ShapeBase3['default']);

exports['default'] = Square;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShapeBase2 = __webpack_require__(24);

var _ShapeBase3 = _interopRequireDefault(_ShapeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Hexagon Node/Cluster shape.
 *
 * @extends ShapeBase
 */
var Hexagon = function (_ShapeBase) {
  (0, _inherits3['default'])(Hexagon, _ShapeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Hexagon(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Hexagon);
    return (0, _possibleConstructorReturn3['default'])(this, (Hexagon.__proto__ || (0, _getPrototypeOf2['default'])(Hexagon)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   */


  (0, _createClass3['default'])(Hexagon, [{
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this._drawShape(ctx, 'hexagon', 4, x, y, selected, hover, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Hexagon;
}(_ShapeBase3['default']);

exports['default'] = Hexagon;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShapeBase2 = __webpack_require__(24);

var _ShapeBase3 = _interopRequireDefault(_ShapeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Star Node/Cluster shape.
 *
 * @extends ShapeBase
 */
var Star = function (_ShapeBase) {
  (0, _inherits3['default'])(Star, _ShapeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Star(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Star);
    return (0, _possibleConstructorReturn3['default'])(this, (Star.__proto__ || (0, _getPrototypeOf2['default'])(Star)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x width
   * @param {number} y height
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   */


  (0, _createClass3['default'])(Star, [{
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this._drawShape(ctx, 'star', 4, x, y, selected, hover, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Star;
}(_ShapeBase3['default']);

exports['default'] = Star;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _NodeBase2 = __webpack_require__(23);

var _NodeBase3 = _interopRequireDefault(_NodeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A text-based replacement for the default Node shape.
 *
 * @extends NodeBase
 */
var Text = function (_NodeBase) {
  (0, _inherits3['default'])(Text, _NodeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Text(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Text);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Text.__proto__ || (0, _getPrototypeOf2['default'])(Text)).call(this, options, body, labelModule));

    _this._setMargins(labelModule);
    return _this;
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {boolean} selected
   * @param {boolean} hover
   */


  (0, _createClass3['default'])(Text, [{
    key: 'resize',
    value: function resize(ctx, selected, hover) {
      if (this.needsRefresh(selected, hover)) {
        this.textSize = this.labelModule.getTextSize(ctx, selected, hover);
        this.width = this.textSize.width + this.margin.right + this.margin.left;
        this.height = this.textSize.height + this.margin.top + this.margin.bottom;
        this.radius = 0.5 * this.width;
      }
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} x width
     * @param {number} y height
     * @param {boolean} selected
     * @param {boolean} hover
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     */

  }, {
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this.resize(ctx, selected, hover);
      this.left = x - this.width / 2;
      this.top = y - this.height / 2;

      // draw shadow if enabled
      this.enableShadow(ctx, values);
      this.labelModule.draw(ctx, this.left + this.textSize.width / 2 + this.margin.left, this.top + this.textSize.height / 2 + this.margin.top, selected, hover);

      // disable shadows for other elements.
      this.disableShadow(ctx, values);

      this.updateBoundingBox(x, y, ctx, selected, hover);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Text;
}(_NodeBase3['default']);

exports['default'] = Text;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShapeBase2 = __webpack_require__(24);

var _ShapeBase3 = _interopRequireDefault(_ShapeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Triangle Node/Cluster shape.
 *
 * @extends ShapeBase
 */
var Triangle = function (_ShapeBase) {
  (0, _inherits3['default'])(Triangle, _ShapeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function Triangle(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, Triangle);
    return (0, _possibleConstructorReturn3['default'])(this, (Triangle.__proto__ || (0, _getPrototypeOf2['default'])(Triangle)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x
   * @param {number} y
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   */


  (0, _createClass3['default'])(Triangle, [{
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this._drawShape(ctx, 'triangle', 3, x, y, selected, hover, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return Triangle;
}(_ShapeBase3['default']);

exports['default'] = Triangle;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ShapeBase2 = __webpack_require__(24);

var _ShapeBase3 = _interopRequireDefault(_ShapeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A downward facing Triangle Node/Cluster shape.
 *
 * @extends ShapeBase
 */
var TriangleDown = function (_ShapeBase) {
  (0, _inherits3['default'])(TriangleDown, _ShapeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function TriangleDown(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, TriangleDown);
    return (0, _possibleConstructorReturn3['default'])(this, (TriangleDown.__proto__ || (0, _getPrototypeOf2['default'])(TriangleDown)).call(this, options, body, labelModule));
  }

  /**
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {number} x
   * @param {number} y
   * @param {boolean} selected
   * @param {boolean} hover
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   */


  (0, _createClass3['default'])(TriangleDown, [{
    key: 'draw',
    value: function draw(ctx, x, y, selected, hover, values) {
      this._drawShape(ctx, 'triangleDown', 3, x, y, selected, hover, values);
    }

    /**
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {number} angle
     * @returns {number}
     */

  }, {
    key: 'distanceToBorder',
    value: function distanceToBorder(ctx, angle) {
      return this._distanceToBorder(ctx, angle);
    }
  }]);
  return TriangleDown;
}(_ShapeBase3['default']);

exports['default'] = TriangleDown;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var DataSet = __webpack_require__(11);
var DataView = __webpack_require__(12);
var Edge = __webpack_require__(74)['default'];

/**
 * Handler for Edges
 */

var EdgesHandler = function () {
  /**
   * @param {Object} body
   * @param {Array.<Image>} images
   * @param {Array.<Group>} groups
   */
  function EdgesHandler(body, images, groups) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, EdgesHandler);

    this.body = body;
    this.images = images;
    this.groups = groups;

    // create the edge API in the body container
    this.body.functions.createEdge = this.create.bind(this);

    this.edgesListeners = {
      add: function add(event, params) {
        _this.add(params.items);
      },
      update: function update(event, params) {
        _this.update(params.items);
      },
      remove: function remove(event, params) {
        _this.remove(params.items);
      }
    };

    this.options = {};
    this.defaultOptions = {
      arrows: {
        to: { enabled: false, scaleFactor: 1, type: 'arrow' }, // boolean / {arrowScaleFactor:1} / {enabled: false, arrowScaleFactor:1}
        middle: { enabled: false, scaleFactor: 1, type: 'arrow' },
        from: { enabled: false, scaleFactor: 1, type: 'arrow' }
      },
      arrowStrikethrough: true,
      color: {
        color: '#848484',
        highlight: '#848484',
        hover: '#848484',
        inherit: 'from',
        opacity: 1.0
      },
      dashes: false,
      font: {
        color: '#343434',
        size: 14, // px
        face: 'arial',
        background: 'none',
        strokeWidth: 2, // px
        strokeColor: '#ffffff',
        align: 'horizontal',
        multi: false,
        vadjust: 0,
        bold: {
          mod: 'bold'
        },
        boldital: {
          mod: 'bold italic'
        },
        ital: {
          mod: 'italic'
        },
        mono: {
          mod: '',
          size: 15, // px
          face: 'courier new',
          vadjust: 2
        }
      },
      hidden: false,
      hoverWidth: 1.5,
      label: undefined,
      labelHighlightBold: true,
      length: undefined,
      physics: true,
      scaling: {
        min: 1,
        max: 15,
        label: {
          enabled: true,
          min: 14,
          max: 30,
          maxVisible: 30,
          drawThreshold: 5
        },
        customScalingFunction: function customScalingFunction(min, max, total, value) {
          if (max === min) {
            return 0.5;
          } else {
            var scale = 1 / (max - min);
            return Math.max(0, (value - min) * scale);
          }
        }
      },
      selectionWidth: 1.5,
      selfReferenceSize: 20,
      shadow: {
        enabled: false,
        color: 'rgba(0,0,0,0.5)',
        size: 10,
        x: 5,
        y: 5
      },
      smooth: {
        enabled: true,
        type: "dynamic",
        forceDirection: 'none',
        roundness: 0.5
      },
      title: undefined,
      width: 1,
      value: undefined
    };

    util.deepExtend(this.options, this.defaultOptions);

    this.bindEventListeners();
  }

  /**
   * Binds event listeners
   */


  (0, _createClass3['default'])(EdgesHandler, [{
    key: 'bindEventListeners',
    value: function bindEventListeners() {
      var _this2 = this;

      // this allows external modules to force all dynamic curves to turn static.
      this.body.emitter.on("_forceDisableDynamicCurves", function (type) {
        var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (type === 'dynamic') {
          type = 'continuous';
        }
        var dataChanged = false;
        for (var edgeId in _this2.body.edges) {
          if (_this2.body.edges.hasOwnProperty(edgeId)) {
            var edge = _this2.body.edges[edgeId];
            var edgeData = _this2.body.data.edges._data[edgeId];

            // only forcibly remove the smooth curve if the data has been set of the edge has the smooth curves defined.
            // this is because a change in the global would not affect these curves.
            if (edgeData !== undefined) {
              var smoothOptions = edgeData.smooth;
              if (smoothOptions !== undefined) {
                if (smoothOptions.enabled === true && smoothOptions.type === 'dynamic') {
                  if (type === undefined) {
                    edge.setOptions({ smooth: false });
                  } else {
                    edge.setOptions({ smooth: { type: type } });
                  }
                  dataChanged = true;
                }
              }
            }
          }
        }
        if (emit === true && dataChanged === true) {
          _this2.body.emitter.emit("_dataChanged");
        }
      });

      // this is called when options of EXISTING nodes or edges have changed.
      //
      // NOTE: Not true, called when options have NOT changed, for both existing as well as new nodes.
      //       See update() for logic.
      // TODO: Verify and examine the consequences of this. It might still trigger when
      //       non-option fields have changed, but then reconnecting edges is still useless.
      //       Alternatively, it might also be called when edges are removed.
      //
      this.body.emitter.on("_dataUpdated", function () {
        _this2.reconnectEdges();
      });

      // refresh the edges. Used when reverting from hierarchical layout
      this.body.emitter.on("refreshEdges", this.refresh.bind(this));
      this.body.emitter.on("refresh", this.refresh.bind(this));
      this.body.emitter.on("destroy", function () {
        util.forEach(_this2.edgesListeners, function (callback, event) {
          if (_this2.body.data.edges) _this2.body.data.edges.off(event, callback);
        });
        delete _this2.body.functions.createEdge;
        delete _this2.edgesListeners.add;
        delete _this2.edgesListeners.update;
        delete _this2.edgesListeners.remove;
        delete _this2.edgesListeners;
      });
    }

    /**
     *
     * @param {Object} options
     */

  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      if (options !== undefined) {
        // use the parser from the Edge class to fill in all shorthand notations
        Edge.parseOptions(this.options, options, true, this.defaultOptions, true);

        // update smooth settings in all edges
        var dataChanged = false;
        if (options.smooth !== undefined) {
          for (var edgeId in this.body.edges) {
            if (this.body.edges.hasOwnProperty(edgeId)) {
              dataChanged = this.body.edges[edgeId].updateEdgeType() || dataChanged;
            }
          }
        }

        // update fonts in all edges
        if (options.font !== undefined) {
          for (var _edgeId in this.body.edges) {
            if (this.body.edges.hasOwnProperty(_edgeId)) {
              this.body.edges[_edgeId].updateLabelModule();
            }
          }
        }

        // update the state of the variables if needed
        if (options.hidden !== undefined || options.physics !== undefined || dataChanged === true) {
          this.body.emitter.emit('_dataChanged');
        }
      }
    }

    /**
     * Load edges by reading the data table
     * @param {Array | DataSet | DataView} edges    The data containing the edges.
     * @param {boolean} [doNotEmit=false]
     * @private
     */

  }, {
    key: 'setData',
    value: function setData(edges) {
      var _this3 = this;

      var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var oldEdgesData = this.body.data.edges;

      if (edges instanceof DataSet || edges instanceof DataView) {
        this.body.data.edges = edges;
      } else if (Array.isArray(edges)) {
        this.body.data.edges = new DataSet();
        this.body.data.edges.add(edges);
      } else if (!edges) {
        this.body.data.edges = new DataSet();
      } else {
        throw new TypeError('Array or DataSet expected');
      }

      // TODO: is this null or undefined or false?
      if (oldEdgesData) {
        // unsubscribe from old dataset
        util.forEach(this.edgesListeners, function (callback, event) {
          oldEdgesData.off(event, callback);
        });
      }

      // remove drawn edges
      this.body.edges = {};

      // TODO: is this null or undefined or false?
      if (this.body.data.edges) {
        // subscribe to new dataset
        util.forEach(this.edgesListeners, function (callback, event) {
          _this3.body.data.edges.on(event, callback);
        });

        // draw all new nodes
        var ids = this.body.data.edges.getIds();
        this.add(ids, true);
      }

      this.body.emitter.emit('_adjustEdgesForHierarchicalLayout');
      if (doNotEmit === false) {
        this.body.emitter.emit("_dataChanged");
      }
    }

    /**
     * Add edges
     * @param {number[] | string[]} ids
     * @param {boolean} [doNotEmit=false]
     * @private
     */

  }, {
    key: 'add',
    value: function add(ids) {
      var doNotEmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var edges = this.body.edges;
      var edgesData = this.body.data.edges;

      for (var i = 0; i < ids.length; i++) {
        var id = ids[i];

        var oldEdge = edges[id];
        if (oldEdge) {
          oldEdge.disconnect();
        }

        var data = edgesData.get(id, { "showInternalIds": true });
        edges[id] = this.create(data);
      }

      this.body.emitter.emit('_adjustEdgesForHierarchicalLayout');

      if (doNotEmit === false) {
        this.body.emitter.emit("_dataChanged");
      }
    }

    /**
     * Update existing edges, or create them when not yet existing
     * @param {number[] | string[]} ids
     * @private
     */

  }, {
    key: 'update',
    value: function update(ids) {
      var edges = this.body.edges;
      var edgesData = this.body.data.edges;
      var dataChanged = false;
      for (var i = 0; i < ids.length; i++) {
        var id = ids[i];
        var data = edgesData.get(id);
        var edge = edges[id];
        if (edge !== undefined) {
          // update edge
          edge.disconnect();
          dataChanged = edge.setOptions(data) || dataChanged; // if a support node is added, data can be changed.
          edge.connect();
        } else {
          // create edge
          this.body.edges[id] = this.create(data);
          dataChanged = true;
        }
      }

      if (dataChanged === true) {
        this.body.emitter.emit('_adjustEdgesForHierarchicalLayout');
        this.body.emitter.emit("_dataChanged");
      } else {
        this.body.emitter.emit("_dataUpdated");
      }
    }

    /**
     * Remove existing edges. Non existing ids will be ignored
     * @param {number[] | string[]} ids
     * @param {boolean} [emit=true]
     * @private
     */

  }, {
    key: 'remove',
    value: function remove(ids) {
      var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (ids.length === 0) return; // early out

      var edges = this.body.edges;
      util.forEach(ids, function (id) {
        var edge = edges[id];
        if (edge !== undefined) {
          edge.remove();
        }
      });

      if (emit) {
        this.body.emitter.emit("_dataChanged");
      }
    }

    /**
     * Refreshes Edge Handler
     */

  }, {
    key: 'refresh',
    value: function refresh() {
      var _this4 = this;

      util.forEach(this.body.edges, function (edge, edgeId) {
        var data = _this4.body.data.edges._data[edgeId];
        if (data !== undefined) {
          edge.setOptions(data);
        }
      });
    }

    /**
     *
     * @param {Object} properties
     * @returns {Edge}
     */

  }, {
    key: 'create',
    value: function create(properties) {
      return new Edge(properties, this.body, this.options, this.defaultOptions);
    }

    /**
     * Reconnect all edges
     * @private
     */

  }, {
    key: 'reconnectEdges',
    value: function reconnectEdges() {
      var id;
      var nodes = this.body.nodes;
      var edges = this.body.edges;

      for (id in nodes) {
        if (nodes.hasOwnProperty(id)) {
          nodes[id].edges = [];
        }
      }

      for (id in edges) {
        if (edges.hasOwnProperty(id)) {
          var edge = edges[id];
          edge.from = null;
          edge.to = null;
          edge.connect();
        }
      }
    }

    /**
     *
     * @param {Edge.id} edgeId
     * @returns {Array}
     */

  }, {
    key: 'getConnectedNodes',
    value: function getConnectedNodes(edgeId) {
      var nodeList = [];
      if (this.body.edges[edgeId] !== undefined) {
        var edge = this.body.edges[edgeId];
        if (edge.fromId !== undefined) {
          nodeList.push(edge.fromId);
        }
        if (edge.toId !== undefined) {
          nodeList.push(edge.toId);
        }
      }
      return nodeList;
    }

    /**
     * There is no direct relation between the nodes and the edges DataSet,
     * so the right place to do call this is in the handler for event `_dataUpdated`.
     */

  }, {
    key: '_updateState',
    value: function _updateState() {
      this._addMissingEdges();
      this._removeInvalidEdges();
    }

    /**
     * Scan for missing nodes and remove corresponding edges, if any.
     * @private
     */

  }, {
    key: '_removeInvalidEdges',
    value: function _removeInvalidEdges() {
      var _this5 = this;

      var edgesToDelete = [];

      util.forEach(this.body.edges, function (edge, id) {
        var toNode = _this5.body.nodes[edge.toId];
        var fromNode = _this5.body.nodes[edge.fromId];

        // Skip clustering edges here, let the Clustering module handle those
        if (toNode !== undefined && toNode.isCluster === true || fromNode !== undefined && fromNode.isCluster === true) {
          return;
        }

        if (toNode === undefined || fromNode === undefined) {
          edgesToDelete.push(id);
        }
      });

      this.remove(edgesToDelete, false);
    }

    /**
     * add all edges from dataset that are not in the cached state
     * @private
     */

  }, {
    key: '_addMissingEdges',
    value: function _addMissingEdges() {
      var edges = this.body.edges;
      var edgesData = this.body.data.edges;
      var addIds = [];

      edgesData.forEach(function (edgeData, edgeId) {
        var edge = edges[edgeId];
        if (edge === undefined) {
          addIds.push(edgeId);
        }
      });

      this.add(addIds, true);
    }
  }]);
  return EdgesHandler;
}();

exports['default'] = EdgesHandler;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CubicBezierEdgeBase2 = __webpack_require__(216);

var _CubicBezierEdgeBase3 = _interopRequireDefault(_CubicBezierEdgeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Cubic Bezier Edge. Bezier curves are used to model smooth gradual
 * curves in paths between nodes.
 *
 * @extends CubicBezierEdgeBase
 */
var CubicBezierEdge = function (_CubicBezierEdgeBase) {
  (0, _inherits3['default'])(CubicBezierEdge, _CubicBezierEdgeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function CubicBezierEdge(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, CubicBezierEdge);
    return (0, _possibleConstructorReturn3['default'])(this, (CubicBezierEdge.__proto__ || (0, _getPrototypeOf2['default'])(CubicBezierEdge)).call(this, options, body, labelModule));
  }

  /**
   * Draw a line between two nodes
   * @param {CanvasRenderingContext2D} ctx
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   * @param {Array.<Node>} viaNodes
   * @private
   */


  (0, _createClass3['default'])(CubicBezierEdge, [{
    key: '_line',
    value: function _line(ctx, values, viaNodes) {
      // get the coordinates of the support points.
      var via1 = viaNodes[0];
      var via2 = viaNodes[1];
      this._bezierCurve(ctx, values, via1, via2);
    }

    /**
     *
     * @returns {Array.<{x: number, y: number}>}
     * @private
     */

  }, {
    key: '_getViaCoordinates',
    value: function _getViaCoordinates() {
      var dx = this.from.x - this.to.x;
      var dy = this.from.y - this.to.y;

      var x1 = void 0,
          y1 = void 0,
          x2 = void 0,
          y2 = void 0;
      var roundness = this.options.smooth.roundness;

      // horizontal if x > y or if direction is forced or if direction is horizontal
      if ((Math.abs(dx) > Math.abs(dy) || this.options.smooth.forceDirection === true || this.options.smooth.forceDirection === 'horizontal') && this.options.smooth.forceDirection !== 'vertical') {
        y1 = this.from.y;
        y2 = this.to.y;
        x1 = this.from.x - roundness * dx;
        x2 = this.to.x + roundness * dx;
      } else {
        y1 = this.from.y - roundness * dy;
        y2 = this.to.y + roundness * dy;
        x1 = this.from.x;
        x2 = this.to.x;
      }

      return [{ x: x1, y: y1 }, { x: x2, y: y2 }];
    }

    /**
     *
     * @returns {Array.<{x: number, y: number}>}
     */

  }, {
    key: 'getViaNode',
    value: function getViaNode() {
      return this._getViaCoordinates();
    }

    /**
     *
     * @param {Node} nearNode
     * @param {CanvasRenderingContext2D} ctx
     * @returns {{x: number, y: number, t: number}}
     * @private
     */

  }, {
    key: '_findBorderPosition',
    value: function _findBorderPosition(nearNode, ctx) {
      return this._findBorderPositionBezier(nearNode, ctx);
    }

    /**
     *
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @param {number} x3
     * @param {number} y3
     * @param {Node} via1
     * @param {Node} via2
     * @returns {number}
     * @private
     */

  }, {
    key: '_getDistanceToEdge',
    value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
      var _ref = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this._getViaCoordinates(),
          _ref2 = (0, _slicedToArray3['default'])(_ref, 2),
          via1 = _ref2[0],
          via2 = _ref2[1];

      // x3,y3 is the point
      return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, via1, via2);
    }

    /**
     * Combined function of pointOnLine and pointOnBezier. This gives the coordinates of a point on the line at a certain percentage of the way
     * @param {number} percentage
     * @param {{x: number, y: number}} [via1=this._getViaCoordinates()[0]]
     * @param {{x: number, y: number}} [via2=this._getViaCoordinates()[1]]
     * @returns {{x: number, y: number}}
     * @private
     */

  }, {
    key: 'getPoint',
    value: function getPoint(percentage) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getViaCoordinates(),
          _ref4 = (0, _slicedToArray3['default'])(_ref3, 2),
          via1 = _ref4[0],
          via2 = _ref4[1];

      var t = percentage;
      var vec = [];
      vec[0] = Math.pow(1 - t, 3);
      vec[1] = 3 * t * Math.pow(1 - t, 2);
      vec[2] = 3 * Math.pow(t, 2) * (1 - t);
      vec[3] = Math.pow(t, 3);
      var x = vec[0] * this.fromPoint.x + vec[1] * via1.x + vec[2] * via2.x + vec[3] * this.toPoint.x;
      var y = vec[0] * this.fromPoint.y + vec[1] * via1.y + vec[2] * via2.y + vec[3] * this.toPoint.y;

      return { x: x, y: y };
    }
  }]);
  return CubicBezierEdge;
}(_CubicBezierEdgeBase3['default']);

exports['default'] = CubicBezierEdge;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BezierEdgeBase2 = __webpack_require__(75);

var _BezierEdgeBase3 = _interopRequireDefault(_BezierEdgeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Base Class for all Cubic Bezier Edges. Bezier curves are used to model
 * smooth gradual curves in paths between nodes.
 *
 * @extends BezierEdgeBase
 */
var CubicBezierEdgeBase = function (_BezierEdgeBase) {
  (0, _inherits3['default'])(CubicBezierEdgeBase, _BezierEdgeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function CubicBezierEdgeBase(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, CubicBezierEdgeBase);
    return (0, _possibleConstructorReturn3['default'])(this, (CubicBezierEdgeBase.__proto__ || (0, _getPrototypeOf2['default'])(CubicBezierEdgeBase)).call(this, options, body, labelModule));
  }

  /**
   * Calculate the distance between a point (x3,y3) and a line segment from
   * (x1,y1) to (x2,y2).
   * http://stackoverflow.com/questions/849211/shortest-distancae-between-a-point-and-a-line-segment
   * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
   * @param {number} x1 from x
   * @param {number} y1 from y
   * @param {number} x2 to x
   * @param {number} y2 to y
   * @param {number} x3 point to check x
   * @param {number} y3 point to check y
   * @param {Node} via1
   * @param {Node} via2
   * @returns {number}
   * @private
   */


  (0, _createClass3['default'])(CubicBezierEdgeBase, [{
    key: '_getDistanceToBezierEdge',
    value: function _getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, via1, via2) {
      // x3,y3 is the point
      var minDistance = 1e9;
      var distance = void 0;
      var i = void 0,
          t = void 0,
          x = void 0,
          y = void 0;
      var lastX = x1;
      var lastY = y1;
      var vec = [0, 0, 0, 0];
      for (i = 1; i < 10; i++) {
        t = 0.1 * i;
        vec[0] = Math.pow(1 - t, 3);
        vec[1] = 3 * t * Math.pow(1 - t, 2);
        vec[2] = 3 * Math.pow(t, 2) * (1 - t);
        vec[3] = Math.pow(t, 3);
        x = vec[0] * x1 + vec[1] * via1.x + vec[2] * via2.x + vec[3] * x2;
        y = vec[0] * y1 + vec[1] * via1.y + vec[2] * via2.y + vec[3] * y2;
        if (i > 0) {
          distance = this._getDistanceToLine(lastX, lastY, x, y, x3, y3);
          minDistance = distance < minDistance ? distance : minDistance;
        }
        lastX = x;
        lastY = y;
      }

      return minDistance;
    }
  }]);
  return CubicBezierEdgeBase;
}(_BezierEdgeBase3['default']);

exports['default'] = CubicBezierEdgeBase;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BezierEdgeBase2 = __webpack_require__(75);

var _BezierEdgeBase3 = _interopRequireDefault(_BezierEdgeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * A Dynamic Bezier Edge. Bezier curves are used to model smooth gradual
 * curves in paths between nodes. The Dynamic piece refers to how the curve
 * reacts to physics changes.
 *
 * @extends BezierEdgeBase
 */
var BezierEdgeDynamic = function (_BezierEdgeBase) {
  (0, _inherits3["default"])(BezierEdgeDynamic, _BezierEdgeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function BezierEdgeDynamic(options, body, labelModule) {
    (0, _classCallCheck3["default"])(this, BezierEdgeDynamic);

    // --> this calls the setOptions below
    var _this = (0, _possibleConstructorReturn3["default"])(this, (BezierEdgeDynamic.__proto__ || (0, _getPrototypeOf2["default"])(BezierEdgeDynamic)).call(this, options, body, labelModule));
    //this.via = undefined; // Here for completeness but not allowed to defined before super() is invoked.


    _this._boundFunction = function () {
      _this.positionBezierNode();
    };
    _this.body.emitter.on("_repositionBezierNodes", _this._boundFunction);
    return _this;
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3["default"])(BezierEdgeDynamic, [{
    key: "setOptions",
    value: function setOptions(options) {
      // check if the physics has changed.
      var physicsChange = false;
      if (this.options.physics !== options.physics) {
        physicsChange = true;
      }

      // set the options and the to and from nodes
      this.options = options;
      this.id = this.options.id;
      this.from = this.body.nodes[this.options.from];
      this.to = this.body.nodes[this.options.to];

      // setup the support node and connect
      this.setupSupportNode();
      this.connect();

      // when we change the physics state of the edge, we reposition the support node.
      if (physicsChange === true) {
        this.via.setOptions({ physics: this.options.physics });
        this.positionBezierNode();
      }
    }

    /**
     * Connects an edge to node(s)
     */

  }, {
    key: "connect",
    value: function connect() {
      this.from = this.body.nodes[this.options.from];
      this.to = this.body.nodes[this.options.to];
      if (this.from === undefined || this.to === undefined || this.options.physics === false) {
        this.via.setOptions({ physics: false });
      } else {
        // fix weird behaviour where a self referencing node has physics enabled
        if (this.from.id === this.to.id) {
          this.via.setOptions({ physics: false });
        } else {
          this.via.setOptions({ physics: true });
        }
      }
    }

    /**
     * remove the support nodes
     * @returns {boolean}
     */

  }, {
    key: "cleanup",
    value: function cleanup() {
      this.body.emitter.off("_repositionBezierNodes", this._boundFunction);
      if (this.via !== undefined) {
        delete this.body.nodes[this.via.id];
        this.via = undefined;
        return true;
      }
      return false;
    }

    /**
     * Bezier curves require an anchor point to calculate the smooth flow. These points are nodes. These nodes are invisible but
     * are used for the force calculation.
     *
     * The changed data is not called, if needed, it is returned by the main edge constructor.
     * @private
     */

  }, {
    key: "setupSupportNode",
    value: function setupSupportNode() {
      if (this.via === undefined) {
        var nodeId = "edgeId:" + this.id;
        var node = this.body.functions.createNode({
          id: nodeId,
          shape: 'circle',
          physics: true,
          hidden: true
        });
        this.body.nodes[nodeId] = node;
        this.via = node;
        this.via.parentEdgeId = this.id;
        this.positionBezierNode();
      }
    }

    /**
     * Positions bezier node
     */

  }, {
    key: "positionBezierNode",
    value: function positionBezierNode() {
      if (this.via !== undefined && this.from !== undefined && this.to !== undefined) {
        this.via.x = 0.5 * (this.from.x + this.to.x);
        this.via.y = 0.5 * (this.from.y + this.to.y);
      } else if (this.via !== undefined) {
        this.via.x = 0;
        this.via.y = 0;
      }
    }

    /**
     * Draw a line between two nodes
     * @param {CanvasRenderingContext2D} ctx
     * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
     * @param {Node} viaNode
     * @private
     */

  }, {
    key: "_line",
    value: function _line(ctx, values, viaNode) {
      this._bezierCurve(ctx, values, viaNode);
    }

    /**
     *
     * @returns {Node|undefined|*|{index, line, column}}
     */

  }, {
    key: "getViaNode",
    value: function getViaNode() {
      return this.via;
    }

    /**
     * Combined function of pointOnLine and pointOnBezier. This gives the coordinates of a point on the line at a certain percentage of the way
     *
     * @param {number} percentage
     * @param {Node} viaNode
     * @returns {{x: number, y: number}}
     * @private
     */

  }, {
    key: "getPoint",
    value: function getPoint(percentage) {
      var viaNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.via;

      var t = percentage;
      var x = void 0,
          y = void 0;
      if (this.from === this.to) {
        var _getCircleData = this._getCircleData(this.from),
            _getCircleData2 = (0, _slicedToArray3["default"])(_getCircleData, 3),
            cx = _getCircleData2[0],
            cy = _getCircleData2[1],
            cr = _getCircleData2[2];

        var a = 2 * Math.PI * (1 - t);
        x = cx + cr * Math.sin(a);
        y = cy + cr - cr * (1 - Math.cos(a));
      } else {
        x = Math.pow(1 - t, 2) * this.fromPoint.x + 2 * t * (1 - t) * viaNode.x + Math.pow(t, 2) * this.toPoint.x;
        y = Math.pow(1 - t, 2) * this.fromPoint.y + 2 * t * (1 - t) * viaNode.y + Math.pow(t, 2) * this.toPoint.y;
      }

      return { x: x, y: y };
    }

    /**
     *
     * @param {Node} nearNode
     * @param {CanvasRenderingContext2D} ctx
     * @returns {*}
     * @private
     */

  }, {
    key: "_findBorderPosition",
    value: function _findBorderPosition(nearNode, ctx) {
      return this._findBorderPositionBezier(nearNode, ctx, this.via);
    }

    /**
     *
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @param {number} x3
     * @param {number} y3
     * @returns {number}
     * @private
     */

  }, {
    key: "_getDistanceToEdge",
    value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
      // x3,y3 is the point
      return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, this.via);
    }
  }]);
  return BezierEdgeDynamic;
}(_BezierEdgeBase3["default"]);

exports["default"] = BezierEdgeDynamic;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BezierEdgeBase2 = __webpack_require__(75);

var _BezierEdgeBase3 = _interopRequireDefault(_BezierEdgeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Static Bezier Edge. Bezier curves are used to model smooth gradual
 * curves in paths between nodes.
 *
 * @extends BezierEdgeBase
 */
var BezierEdgeStatic = function (_BezierEdgeBase) {
  (0, _inherits3['default'])(BezierEdgeStatic, _BezierEdgeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function BezierEdgeStatic(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, BezierEdgeStatic);
    return (0, _possibleConstructorReturn3['default'])(this, (BezierEdgeStatic.__proto__ || (0, _getPrototypeOf2['default'])(BezierEdgeStatic)).call(this, options, body, labelModule));
  }

  /**
   * Draw a line between two nodes
   * @param {CanvasRenderingContext2D} ctx
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   * @param {Node} viaNode
   * @private
   */


  (0, _createClass3['default'])(BezierEdgeStatic, [{
    key: '_line',
    value: function _line(ctx, values, viaNode) {
      this._bezierCurve(ctx, values, viaNode);
    }

    /**
     *
     * @returns {Array.<{x: number, y: number}>}
     */

  }, {
    key: 'getViaNode',
    value: function getViaNode() {
      return this._getViaCoordinates();
    }

    /**
     * We do not use the to and fromPoints here to make the via nodes the same as edges without arrows.
     * @returns {{x: undefined, y: undefined}}
     * @private
     */

  }, {
    key: '_getViaCoordinates',
    value: function _getViaCoordinates() {
      // Assumption: x/y coordinates in from/to always defined
      var xVia = undefined;
      var yVia = undefined;
      var factor = this.options.smooth.roundness;
      var type = this.options.smooth.type;
      var dx = Math.abs(this.from.x - this.to.x);
      var dy = Math.abs(this.from.y - this.to.y);
      if (type === 'discrete' || type === 'diagonalCross') {
        var stepX = void 0;
        var stepY = void 0;

        if (dx <= dy) {
          stepX = stepY = factor * dy;
        } else {
          stepX = stepY = factor * dx;
        }

        if (this.from.x > this.to.x) stepX = -stepX;
        if (this.from.y >= this.to.y) stepY = -stepY;

        xVia = this.from.x + stepX;
        yVia = this.from.y + stepY;

        if (type === "discrete") {
          if (dx <= dy) {
            xVia = dx < factor * dy ? this.from.x : xVia;
          } else {
            yVia = dy < factor * dx ? this.from.y : yVia;
          }
        }
      } else if (type === "straightCross") {
        var _stepX = (1 - factor) * dx;
        var _stepY = (1 - factor) * dy;

        if (dx <= dy) {
          // up - down
          _stepX = 0;
          if (this.from.y < this.to.y) _stepY = -_stepY;
        } else {
          // left - right
          if (this.from.x < this.to.x) _stepX = -_stepX;
          _stepY = 0;
        }
        xVia = this.to.x + _stepX;
        yVia = this.to.y + _stepY;
      } else if (type === 'horizontal') {
        var _stepX2 = (1 - factor) * dx;
        if (this.from.x < this.to.x) _stepX2 = -_stepX2;
        xVia = this.to.x + _stepX2;
        yVia = this.from.y;
      } else if (type === 'vertical') {
        var _stepY2 = (1 - factor) * dy;
        if (this.from.y < this.to.y) _stepY2 = -_stepY2;
        xVia = this.from.x;
        yVia = this.to.y + _stepY2;
      } else if (type === 'curvedCW') {
        dx = this.to.x - this.from.x;
        dy = this.from.y - this.to.y;
        var radius = Math.sqrt(dx * dx + dy * dy);
        var pi = Math.PI;

        var originalAngle = Math.atan2(dy, dx);
        var myAngle = (originalAngle + (factor * 0.5 + 0.5) * pi) % (2 * pi);

        xVia = this.from.x + (factor * 0.5 + 0.5) * radius * Math.sin(myAngle);
        yVia = this.from.y + (factor * 0.5 + 0.5) * radius * Math.cos(myAngle);
      } else if (type === 'curvedCCW') {
        dx = this.to.x - this.from.x;
        dy = this.from.y - this.to.y;
        var _radius = Math.sqrt(dx * dx + dy * dy);
        var _pi = Math.PI;

        var _originalAngle = Math.atan2(dy, dx);
        var _myAngle = (_originalAngle + (-factor * 0.5 + 0.5) * _pi) % (2 * _pi);

        xVia = this.from.x + (factor * 0.5 + 0.5) * _radius * Math.sin(_myAngle);
        yVia = this.from.y + (factor * 0.5 + 0.5) * _radius * Math.cos(_myAngle);
      } else {
        // continuous
        var _stepX3 = void 0;
        var _stepY3 = void 0;

        if (dx <= dy) {
          _stepX3 = _stepY3 = factor * dy;
        } else {
          _stepX3 = _stepY3 = factor * dx;
        }

        if (this.from.x > this.to.x) _stepX3 = -_stepX3;
        if (this.from.y >= this.to.y) _stepY3 = -_stepY3;

        xVia = this.from.x + _stepX3;
        yVia = this.from.y + _stepY3;

        if (dx <= dy) {
          if (this.from.x <= this.to.x) {
            xVia = this.to.x < xVia ? this.to.x : xVia;
          } else {
            xVia = this.to.x > xVia ? this.to.x : xVia;
          }
        } else {
          if (this.from.y >= this.to.y) {
            yVia = this.to.y > yVia ? this.to.y : yVia;
          } else {
            yVia = this.to.y < yVia ? this.to.y : yVia;
          }
        }
      }
      return { x: xVia, y: yVia };
    }

    /**
     *
     * @param {Node} nearNode
     * @param {CanvasRenderingContext2D} ctx
     * @param {Object} options
     * @returns {*}
     * @private
     */

  }, {
    key: '_findBorderPosition',
    value: function _findBorderPosition(nearNode, ctx) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this._findBorderPositionBezier(nearNode, ctx, options.via);
    }

    /**
     *
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @param {number} x3
     * @param {number} y3
     * @param {Node} viaNode
     * @returns {number}
     * @private
     */

  }, {
    key: '_getDistanceToEdge',
    value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
      var viaNode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : this._getViaCoordinates();
      // x3,y3 is the point
      return this._getDistanceToBezierEdge(x1, y1, x2, y2, x3, y3, viaNode);
    }

    /**
     * Combined function of pointOnLine and pointOnBezier. This gives the coordinates of a point on the line at a certain percentage of the way
     * @param {number} percentage
     * @param {Node} viaNode
     * @returns {{x: number, y: number}}
     * @private
     */

  }, {
    key: 'getPoint',
    value: function getPoint(percentage) {
      var viaNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getViaCoordinates();

      var t = percentage;
      var x = Math.pow(1 - t, 2) * this.fromPoint.x + 2 * t * (1 - t) * viaNode.x + Math.pow(t, 2) * this.toPoint.x;
      var y = Math.pow(1 - t, 2) * this.fromPoint.y + 2 * t * (1 - t) * viaNode.y + Math.pow(t, 2) * this.toPoint.y;

      return { x: x, y: y };
    }
  }]);
  return BezierEdgeStatic;
}(_BezierEdgeBase3['default']);

exports['default'] = BezierEdgeStatic;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _EdgeBase2 = __webpack_require__(118);

var _EdgeBase3 = _interopRequireDefault(_EdgeBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * A Straight Edge.
 *
 * @extends EdgeBase
 */
var StraightEdge = function (_EdgeBase) {
  (0, _inherits3['default'])(StraightEdge, _EdgeBase);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Label} labelModule
   */
  function StraightEdge(options, body, labelModule) {
    (0, _classCallCheck3['default'])(this, StraightEdge);
    return (0, _possibleConstructorReturn3['default'])(this, (StraightEdge.__proto__ || (0, _getPrototypeOf2['default'])(StraightEdge)).call(this, options, body, labelModule));
  }

  /**
   * Draw a line between two nodes
   * @param {CanvasRenderingContext2D} ctx
   * @param {{toArrow: boolean, toArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), toArrowType: *, middleArrow: boolean, middleArrowScale: (number|allOptions.edges.arrows.middle.scaleFactor|{number}|Array), middleArrowType: (allOptions.edges.arrows.middle.type|{string}|string|*), fromArrow: boolean, fromArrowScale: (allOptions.edges.arrows.to.scaleFactor|{number}|allOptions.edges.arrows.middle.scaleFactor|allOptions.edges.arrows.from.scaleFactor|Array|number), fromArrowType: *, arrowStrikethrough: (*|boolean|allOptions.edges.arrowStrikethrough|{boolean}), color: undefined, inheritsColor: (string|string|string|allOptions.edges.color.inherit|{string, boolean}|Array|*), opacity: *, hidden: *, length: *, shadow: *, shadowColor: *, shadowSize: *, shadowX: *, shadowY: *, dashes: (*|boolean|Array|allOptions.edges.dashes|{boolean, array}), width: *}} values
   * @private
   */


  (0, _createClass3['default'])(StraightEdge, [{
    key: '_line',
    value: function _line(ctx, values) {
      // draw a straight line
      ctx.beginPath();
      ctx.moveTo(this.fromPoint.x, this.fromPoint.y);
      ctx.lineTo(this.toPoint.x, this.toPoint.y);
      // draw shadow if enabled
      this.enableShadow(ctx, values);
      ctx.stroke();
      this.disableShadow(ctx, values);
    }

    /**
     *
     * @returns {undefined}
     */

  }, {
    key: 'getViaNode',
    value: function getViaNode() {
      return undefined;
    }

    /**
     * Combined function of pointOnLine and pointOnBezier. This gives the coordinates of a point on the line at a certain percentage of the way
     *
     * @param {number} percentage
     * @returns {{x: number, y: number}}
     * @private
     */

  }, {
    key: 'getPoint',
    value: function getPoint(percentage) {
      return {
        x: (1 - percentage) * this.fromPoint.x + percentage * this.toPoint.x,
        y: (1 - percentage) * this.fromPoint.y + percentage * this.toPoint.y
      };
    }

    /**
     *
     * @param {Node} nearNode
     * @param {CanvasRenderingContext2D} ctx
     * @returns {{x: number, y: number}}
     * @private
     */

  }, {
    key: '_findBorderPosition',
    value: function _findBorderPosition(nearNode, ctx) {
      var node1 = this.to;
      var node2 = this.from;
      if (nearNode.id === this.from.id) {
        node1 = this.from;
        node2 = this.to;
      }

      var angle = Math.atan2(node1.y - node2.y, node1.x - node2.x);
      var dx = node1.x - node2.x;
      var dy = node1.y - node2.y;
      var edgeSegmentLength = Math.sqrt(dx * dx + dy * dy);
      var toBorderDist = nearNode.distanceToBorder(ctx, angle);
      var toBorderPoint = (edgeSegmentLength - toBorderDist) / edgeSegmentLength;

      var borderPos = {};
      borderPos.x = (1 - toBorderPoint) * node2.x + toBorderPoint * node1.x;
      borderPos.y = (1 - toBorderPoint) * node2.y + toBorderPoint * node1.y;

      return borderPos;
    }

    /**
     *
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @param {number} x3
     * @param {number} y3
     * @returns {number}
     * @private
     */

  }, {
    key: '_getDistanceToEdge',
    value: function _getDistanceToEdge(x1, y1, x2, y2, x3, y3) {
      // x3,y3 is the point
      return this._getDistanceToLine(x1, y1, x2, y2, x3, y3);
    }
  }]);
  return StraightEdge;
}(_EdgeBase3['default']);

exports['default'] = StraightEdge;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var BarnesHutSolver = __webpack_require__(120)['default'];
var Repulsion = __webpack_require__(221)['default'];
var HierarchicalRepulsion = __webpack_require__(222)['default'];
var SpringSolver = __webpack_require__(223)['default'];
var HierarchicalSpringSolver = __webpack_require__(224)['default'];
var CentralGravitySolver = __webpack_require__(121)['default'];
var ForceAtlas2BasedRepulsionSolver = __webpack_require__(225)['default'];
var ForceAtlas2BasedCentralGravitySolver = __webpack_require__(226)['default'];
var util = __webpack_require__(2);
var EndPoints = __webpack_require__(119)['default']; // for debugging with _drawForces()


/**
 * The physics engine
 */

var PhysicsEngine = function () {
  /**
   * @param {Object} body
   */
  function PhysicsEngine(body) {
    (0, _classCallCheck3['default'])(this, PhysicsEngine);

    this.body = body;
    this.physicsBody = { physicsNodeIndices: [], physicsEdgeIndices: [], forces: {}, velocities: {} };

    this.physicsEnabled = true;
    this.simulationInterval = 1000 / 60;
    this.requiresTimeout = true;
    this.previousStates = {};
    this.referenceState = {};
    this.freezeCache = {};
    this.renderTimer = undefined;

    // parameters for the adaptive timestep
    this.adaptiveTimestep = false;
    this.adaptiveTimestepEnabled = false;
    this.adaptiveCounter = 0;
    this.adaptiveInterval = 3;

    this.stabilized = false;
    this.startedStabilization = false;
    this.stabilizationIterations = 0;
    this.ready = false; // will be set to true if the stabilize

    // default options
    this.options = {};
    this.defaultOptions = {
      enabled: true,
      barnesHut: {
        theta: 0.5,
        gravitationalConstant: -2000,
        centralGravity: 0.3,
        springLength: 95,
        springConstant: 0.04,
        damping: 0.09,
        avoidOverlap: 0
      },
      forceAtlas2Based: {
        theta: 0.5,
        gravitationalConstant: -50,
        centralGravity: 0.01,
        springConstant: 0.08,
        springLength: 100,
        damping: 0.4,
        avoidOverlap: 0
      },
      repulsion: {
        centralGravity: 0.2,
        springLength: 200,
        springConstant: 0.05,
        nodeDistance: 100,
        damping: 0.09,
        avoidOverlap: 0
      },
      hierarchicalRepulsion: {
        centralGravity: 0.0,
        springLength: 100,
        springConstant: 0.01,
        nodeDistance: 120,
        damping: 0.09
      },
      maxVelocity: 50,
      minVelocity: 0.75, // px/s
      solver: 'barnesHut',
      stabilization: {
        enabled: true,
        iterations: 1000, // maximum number of iteration to stabilize
        updateInterval: 50,
        onlyDynamicEdges: false,
        fit: true
      },
      timestep: 0.5,
      adaptiveTimestep: true
    };
    util.extend(this.options, this.defaultOptions);
    this.timestep = 0.5;
    this.layoutFailed = false;

    this.bindEventListeners();
  }

  /**
   * Binds event listeners
   */


  (0, _createClass3['default'])(PhysicsEngine, [{
    key: 'bindEventListeners',
    value: function bindEventListeners() {
      var _this = this;

      this.body.emitter.on('initPhysics', function () {
        _this.initPhysics();
      });
      this.body.emitter.on('_layoutFailed', function () {
        _this.layoutFailed = true;
      });
      this.body.emitter.on('resetPhysics', function () {
        _this.stopSimulation();_this.ready = false;
      });
      this.body.emitter.on('disablePhysics', function () {
        _this.physicsEnabled = false;_this.stopSimulation();
      });
      this.body.emitter.on('restorePhysics', function () {
        _this.setOptions(_this.options);
        if (_this.ready === true) {
          _this.startSimulation();
        }
      });
      this.body.emitter.on('startSimulation', function () {
        if (_this.ready === true) {
          _this.startSimulation();
        }
      });
      this.body.emitter.on('stopSimulation', function () {
        _this.stopSimulation();
      });
      this.body.emitter.on('destroy', function () {
        _this.stopSimulation(false);
        _this.body.emitter.off();
      });
      this.body.emitter.on("_dataChanged", function () {
        // Nodes and/or edges have been added or removed, update shortcut lists.
        _this.updatePhysicsData();
      });

      // debug: show forces
      // this.body.emitter.on("afterDrawing", (ctx) => {this._drawForces(ctx);});
    }

    /**
     * set the physics options
     * @param {Object} options
     */

  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      if (options !== undefined) {
        if (options === false) {
          this.options.enabled = false;
          this.physicsEnabled = false;
          this.stopSimulation();
        } else if (options === true) {
          this.options.enabled = true;
          this.physicsEnabled = true;
          this.startSimulation();
        } else {
          this.physicsEnabled = true;
          util.selectiveNotDeepExtend(['stabilization'], this.options, options);
          util.mergeOptions(this.options, options, 'stabilization');

          if (options.enabled === undefined) {
            this.options.enabled = true;
          }

          if (this.options.enabled === false) {
            this.physicsEnabled = false;
            this.stopSimulation();
          }

          // set the timestep
          this.timestep = this.options.timestep;
        }
      }
      this.init();
    }

    /**
     * configure the engine.
     */

  }, {
    key: 'init',
    value: function init() {
      var options;
      if (this.options.solver === 'forceAtlas2Based') {
        options = this.options.forceAtlas2Based;
        this.nodesSolver = new ForceAtlas2BasedRepulsionSolver(this.body, this.physicsBody, options);
        this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
        this.gravitySolver = new ForceAtlas2BasedCentralGravitySolver(this.body, this.physicsBody, options);
      } else if (this.options.solver === 'repulsion') {
        options = this.options.repulsion;
        this.nodesSolver = new Repulsion(this.body, this.physicsBody, options);
        this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
        this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
      } else if (this.options.solver === 'hierarchicalRepulsion') {
        options = this.options.hierarchicalRepulsion;
        this.nodesSolver = new HierarchicalRepulsion(this.body, this.physicsBody, options);
        this.edgesSolver = new HierarchicalSpringSolver(this.body, this.physicsBody, options);
        this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
      } else {
        // barnesHut
        options = this.options.barnesHut;
        this.nodesSolver = new BarnesHutSolver(this.body, this.physicsBody, options);
        this.edgesSolver = new SpringSolver(this.body, this.physicsBody, options);
        this.gravitySolver = new CentralGravitySolver(this.body, this.physicsBody, options);
      }

      this.modelOptions = options;
    }

    /**
     * initialize the engine
     */

  }, {
    key: 'initPhysics',
    value: function initPhysics() {
      if (this.physicsEnabled === true && this.options.enabled === true) {
        if (this.options.stabilization.enabled === true) {
          this.stabilize();
        } else {
          this.stabilized = false;
          this.ready = true;
          this.body.emitter.emit('fit', {}, this.layoutFailed); // if the layout failed, we use the approximation for the zoom
          this.startSimulation();
        }
      } else {
        this.ready = true;
        this.body.emitter.emit('fit');
      }
    }

    /**
     * Start the simulation
     */

  }, {
    key: 'startSimulation',
    value: function startSimulation() {
      if (this.physicsEnabled === true && this.options.enabled === true) {
        this.stabilized = false;

        // when visible, adaptivity is disabled.
        this.adaptiveTimestep = false;

        // this sets the width of all nodes initially which could be required for the avoidOverlap
        this.body.emitter.emit("_resizeNodes");
        if (this.viewFunction === undefined) {
          this.viewFunction = this.simulationStep.bind(this);
          this.body.emitter.on('initRedraw', this.viewFunction);
          this.body.emitter.emit('_startRendering');
        }
      } else {
        this.body.emitter.emit('_redraw');
      }
    }

    /**
     * Stop the simulation, force stabilization.
     * @param {boolean} [emit=true]
     */

  }, {
    key: 'stopSimulation',
    value: function stopSimulation() {
      var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.stabilized = true;
      if (emit === true) {
        this._emitStabilized();
      }
      if (this.viewFunction !== undefined) {
        this.body.emitter.off('initRedraw', this.viewFunction);
        this.viewFunction = undefined;
        if (emit === true) {
          this.body.emitter.emit('_stopRendering');
        }
      }
    }

    /**
     * The viewFunction inserts this step into each render loop. It calls the physics tick and handles the cleanup at stabilized.
     *
     */

  }, {
    key: 'simulationStep',
    value: function simulationStep() {
      // check if the physics have settled
      var startTime = Date.now();
      this.physicsTick();
      var physicsTime = Date.now() - startTime;

      // run double speed if it is a little graph
      if ((physicsTime < 0.4 * this.simulationInterval || this.runDoubleSpeed === true) && this.stabilized === false) {
        this.physicsTick();

        // this makes sure there is no jitter. The decision is taken once to run it at double speed.
        this.runDoubleSpeed = true;
      }

      if (this.stabilized === true) {
        this.stopSimulation();
      }
    }

    /**
     * trigger the stabilized event.
     *
     * @param {number} [amountOfIterations=this.stabilizationIterations]
     * @private
     */

  }, {
    key: '_emitStabilized',
    value: function _emitStabilized() {
      var _this2 = this;

      var amountOfIterations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.stabilizationIterations;

      if (this.stabilizationIterations > 1 || this.startedStabilization === true) {
        setTimeout(function () {
          _this2.body.emitter.emit('stabilized', { iterations: amountOfIterations });
          _this2.startedStabilization = false;
          _this2.stabilizationIterations = 0;
        }, 0);
      }
    }

    /**
     * Calculate the forces for one physics iteration and move the nodes.
     * @private
     */

  }, {
    key: 'physicsStep',
    value: function physicsStep() {
      this.gravitySolver.solve();
      this.nodesSolver.solve();
      this.edgesSolver.solve();
      this.moveNodes();
    }

    /**
     * Make dynamic adjustments to the timestep, based on current state.
     *
     * Helper function for physicsTick().
     * @private
     */

  }, {
    key: 'adjustTimeStep',
    value: function adjustTimeStep() {
      var factor = 1.2; // Factor for increasing the timestep on success.

      // we compare the two steps. if it is acceptable we double the step.
      if (this._evaluateStepQuality() === true) {
        this.timestep = factor * this.timestep;
      } else {
        // if not, we decrease the step to a minimum of the options timestep.
        // if the decreased timestep is smaller than the options step, we do not reset the counter
        // we assume that the options timestep is stable enough.
        if (this.timestep / factor < this.options.timestep) {
          this.timestep = this.options.timestep;
        } else {
          // if the timestep was larger than 2 times the option one we check the adaptivity again to ensure
          // that large instabilities do not form.
          this.adaptiveCounter = -1; // check again next iteration
          this.timestep = Math.max(this.options.timestep, this.timestep / factor);
        }
      }
    }

    /**
     * A single simulation step (or 'tick') in the physics simulation
     *
     * @private
     */

  }, {
    key: 'physicsTick',
    value: function physicsTick() {
      this._startStabilizing(); // this ensures that there is no start event when the network is already stable.
      if (this.stabilized === true) return;

      // adaptivity means the timestep adapts to the situation, only applicable for stabilization
      if (this.adaptiveTimestep === true && this.adaptiveTimestepEnabled === true) {
        // timestep remains stable for "interval" iterations.
        var doAdaptive = this.adaptiveCounter % this.adaptiveInterval === 0;

        if (doAdaptive) {
          // first the big step and revert.
          this.timestep = 2 * this.timestep;
          this.physicsStep();
          this.revert(); // saves the reference state

          // now the normal step. Since this is the last step, it is the more stable one and we will take this.
          this.timestep = 0.5 * this.timestep;

          // since it's half the step, we do it twice.
          this.physicsStep();
          this.physicsStep();

          this.adjustTimeStep();
        } else {
          this.physicsStep(); // normal step, keeping timestep constant
        }

        this.adaptiveCounter += 1;
      } else {
        // case for the static timestep, we reset it to the one in options and take a normal step.
        this.timestep = this.options.timestep;
        this.physicsStep();
      }

      if (this.stabilized === true) this.revert();
      this.stabilizationIterations++;
    }

    /**
     * Nodes and edges can have the physics toggles on or off. A collection of indices is created here so we can skip the check all the time.
     *
     * @private
     */

  }, {
    key: 'updatePhysicsData',
    value: function updatePhysicsData() {
      this.physicsBody.forces = {};
      this.physicsBody.physicsNodeIndices = [];
      this.physicsBody.physicsEdgeIndices = [];
      var nodes = this.body.nodes;
      var edges = this.body.edges;

      // get node indices for physics
      for (var nodeId in nodes) {
        if (nodes.hasOwnProperty(nodeId)) {
          if (nodes[nodeId].options.physics === true) {
            this.physicsBody.physicsNodeIndices.push(nodes[nodeId].id);
          }
        }
      }

      // get edge indices for physics
      for (var edgeId in edges) {
        if (edges.hasOwnProperty(edgeId)) {
          if (edges[edgeId].options.physics === true) {
            this.physicsBody.physicsEdgeIndices.push(edges[edgeId].id);
          }
        }
      }

      // get the velocity and the forces vector
      for (var i = 0; i < this.physicsBody.physicsNodeIndices.length; i++) {
        var _nodeId = this.physicsBody.physicsNodeIndices[i];
        this.physicsBody.forces[_nodeId] = { x: 0, y: 0 };

        // forces can be reset because they are recalculated. Velocities have to persist.
        if (this.physicsBody.velocities[_nodeId] === undefined) {
          this.physicsBody.velocities[_nodeId] = { x: 0, y: 0 };
        }
      }

      // clean deleted nodes from the velocity vector
      for (var _nodeId2 in this.physicsBody.velocities) {
        if (nodes[_nodeId2] === undefined) {
          delete this.physicsBody.velocities[_nodeId2];
        }
      }
    }

    /**
     * Revert the simulation one step. This is done so after stabilization, every new start of the simulation will also say stabilized.
     */

  }, {
    key: 'revert',
    value: function revert() {
      var nodeIds = (0, _keys2['default'])(this.previousStates);
      var nodes = this.body.nodes;
      var velocities = this.physicsBody.velocities;
      this.referenceState = {};

      for (var i = 0; i < nodeIds.length; i++) {
        var nodeId = nodeIds[i];
        if (nodes[nodeId] !== undefined) {
          if (nodes[nodeId].options.physics === true) {
            this.referenceState[nodeId] = {
              positions: { x: nodes[nodeId].x, y: nodes[nodeId].y }
            };
            velocities[nodeId].x = this.previousStates[nodeId].vx;
            velocities[nodeId].y = this.previousStates[nodeId].vy;
            nodes[nodeId].x = this.previousStates[nodeId].x;
            nodes[nodeId].y = this.previousStates[nodeId].y;
          }
        } else {
          delete this.previousStates[nodeId];
        }
      }
    }

    /**
     * This compares the reference state to the current state
     *
     * @returns {boolean}
     * @private
     */

  }, {
    key: '_evaluateStepQuality',
    value: function _evaluateStepQuality() {
      var dx = void 0,
          dy = void 0,
          dpos = void 0;
      var nodes = this.body.nodes;
      var reference = this.referenceState;
      var posThreshold = 0.3;

      for (var nodeId in this.referenceState) {
        if (this.referenceState.hasOwnProperty(nodeId) && nodes[nodeId] !== undefined) {
          dx = nodes[nodeId].x - reference[nodeId].positions.x;
          dy = nodes[nodeId].y - reference[nodeId].positions.y;

          dpos = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));

          if (dpos > posThreshold) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * move the nodes one timestep and check if they are stabilized
     */

  }, {
    key: 'moveNodes',
    value: function moveNodes() {
      var nodeIndices = this.physicsBody.physicsNodeIndices;
      var maxNodeVelocity = 0;
      var averageNodeVelocity = 0;

      // the velocity threshold (energy in the system) for the adaptivity toggle
      var velocityAdaptiveThreshold = 5;

      for (var i = 0; i < nodeIndices.length; i++) {
        var nodeId = nodeIndices[i];
        var nodeVelocity = this._performStep(nodeId);
        // stabilized is true if stabilized is true and velocity is smaller than vmin --> all nodes must be stabilized
        maxNodeVelocity = Math.max(maxNodeVelocity, nodeVelocity);
        averageNodeVelocity += nodeVelocity;
      }

      // evaluating the stabilized and adaptiveTimestepEnabled conditions
      this.adaptiveTimestepEnabled = averageNodeVelocity / nodeIndices.length < velocityAdaptiveThreshold;
      this.stabilized = maxNodeVelocity < this.options.minVelocity;
    }

    /**
     * Calculate new velocity for a coordinate direction
     *
     * @param {number} v  velocity for current coordinate
     * @param {number} f  regular force for current coordinate
     * @param {number} m  mass of current node
     * @returns {number} new velocity for current coordinate
     * @private
     */

  }, {
    key: 'calculateComponentVelocity',
    value: function calculateComponentVelocity(v, f, m) {
      var df = this.modelOptions.damping * v; // damping force
      var a = (f - df) / m; // acceleration

      v += a * this.timestep;

      // Put a limit on the velocities if it is really high
      var maxV = this.options.maxVelocity || 1e9;
      if (Math.abs(v) > maxV) {
        v = v > 0 ? maxV : -maxV;
      }

      return v;
    }

    /**
     * Perform the actual step
     *
     * @param {Node.id} nodeId
     * @returns {number} the new velocity of given node
     * @private
     */

  }, {
    key: '_performStep',
    value: function _performStep(nodeId) {
      var node = this.body.nodes[nodeId];
      var force = this.physicsBody.forces[nodeId];
      var velocity = this.physicsBody.velocities[nodeId];

      // store the state so we can revert
      this.previousStates[nodeId] = { x: node.x, y: node.y, vx: velocity.x, vy: velocity.y };

      if (node.options.fixed.x === false) {
        velocity.x = this.calculateComponentVelocity(velocity.x, force.x, node.options.mass);
        node.x += velocity.x * this.timestep;
      } else {
        force.x = 0;
        velocity.x = 0;
      }

      if (node.options.fixed.y === false) {
        velocity.y = this.calculateComponentVelocity(velocity.y, force.y, node.options.mass);
        node.y += velocity.y * this.timestep;
      } else {
        force.y = 0;
        velocity.y = 0;
      }

      var totalVelocity = Math.sqrt(Math.pow(velocity.x, 2) + Math.pow(velocity.y, 2));
      return totalVelocity;
    }

    /**
     * When initializing and stabilizing, we can freeze nodes with a predefined position.
     * This greatly speeds up stabilization because only the supportnodes for the smoothCurves have to settle.
     *
     * @private
     */

  }, {
    key: '_freezeNodes',
    value: function _freezeNodes() {
      var nodes = this.body.nodes;
      for (var id in nodes) {
        if (nodes.hasOwnProperty(id)) {
          if (nodes[id].x && nodes[id].y) {
            var fixed = nodes[id].options.fixed;
            this.freezeCache[id] = { x: fixed.x, y: fixed.y };
            fixed.x = true;
            fixed.y = true;
          }
        }
      }
    }

    /**
     * Unfreezes the nodes that have been frozen by _freezeDefinedNodes.
     *
     * @private
     */

  }, {
    key: '_restoreFrozenNodes',
    value: function _restoreFrozenNodes() {
      var nodes = this.body.nodes;
      for (var id in nodes) {
        if (nodes.hasOwnProperty(id)) {
          if (this.freezeCache[id] !== undefined) {
            nodes[id].options.fixed.x = this.freezeCache[id].x;
            nodes[id].options.fixed.y = this.freezeCache[id].y;
          }
        }
      }
      this.freezeCache = {};
    }

    /**
     * Find a stable position for all nodes
     *
     * @param {number} [iterations=this.options.stabilization.iterations]
     */

  }, {
    key: 'stabilize',
    value: function stabilize() {
      var _this3 = this;

      var iterations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.stabilization.iterations;

      if (typeof iterations !== 'number') {
        iterations = this.options.stabilization.iterations;
        console.log('The stabilize method needs a numeric amount of iterations. Switching to default: ', iterations);
      }

      if (this.physicsBody.physicsNodeIndices.length === 0) {
        this.ready = true;
        return;
      }

      // enable adaptive timesteps
      this.adaptiveTimestep = true && this.options.adaptiveTimestep;

      // this sets the width of all nodes initially which could be required for the avoidOverlap
      this.body.emitter.emit("_resizeNodes");

      this.stopSimulation(); // stop the render loop
      this.stabilized = false;

      // block redraw requests
      this.body.emitter.emit('_blockRedraw');
      this.targetIterations = iterations;

      // start the stabilization
      if (this.options.stabilization.onlyDynamicEdges === true) {
        this._freezeNodes();
      }
      this.stabilizationIterations = 0;

      setTimeout(function () {
        return _this3._stabilizationBatch();
      }, 0);
    }

    /**
     * If not already stabilizing, start it and emit a start event.
     *
     * @returns {boolean} true if stabilization started with this call
     * @private
     */

  }, {
    key: '_startStabilizing',
    value: function _startStabilizing() {
      if (this.startedStabilization === true) return false;

      this.body.emitter.emit('startStabilizing');
      this.startedStabilization = true;
      return true;
    }

    /**
     * One batch of stabilization
     * @private
     */

  }, {
    key: '_stabilizationBatch',
    value: function _stabilizationBatch() {
      var _this4 = this;

      var running = function running() {
        return _this4.stabilized === false && _this4.stabilizationIterations < _this4.targetIterations;
      };

      var sendProgress = function sendProgress() {
        _this4.body.emitter.emit('stabilizationProgress', {
          iterations: _this4.stabilizationIterations,
          total: _this4.targetIterations
        });
      };

      if (this._startStabilizing()) {
        sendProgress(); // Ensure that there is at least one start event.
      }

      var count = 0;
      while (running() && count < this.options.stabilization.updateInterval) {
        this.physicsTick();
        count++;
      }

      sendProgress();

      if (running()) {
        setTimeout(this._stabilizationBatch.bind(this), 0);
      } else {
        this._finalizeStabilization();
      }
    }

    /**
     * Wrap up the stabilization, fit and emit the events.
     * @private
     */

  }, {
    key: '_finalizeStabilization',
    value: function _finalizeStabilization() {
      this.body.emitter.emit('_allowRedraw');
      if (this.options.stabilization.fit === true) {
        this.body.emitter.emit('fit');
      }

      if (this.options.stabilization.onlyDynamicEdges === true) {
        this._restoreFrozenNodes();
      }

      this.body.emitter.emit('stabilizationIterationsDone');
      this.body.emitter.emit('_requestRedraw');

      if (this.stabilized === true) {
        this._emitStabilized();
      } else {
        this.startSimulation();
      }

      this.ready = true;
    }

    //---------------------------  DEBUGGING BELOW  ---------------------------//


    /**
     * Debug function that display arrows for the forces currently active in the network.
     *
     * Use this when debugging only.
     *
     * @param {CanvasRenderingContext2D} ctx
     * @private
     */

  }, {
    key: '_drawForces',
    value: function _drawForces(ctx) {
      for (var i = 0; i < this.physicsBody.physicsNodeIndices.length; i++) {
        var index = this.physicsBody.physicsNodeIndices[i];
        var node = this.body.nodes[index];
        var force = this.physicsBody.forces[index];
        var factor = 20;
        var colorFactor = 0.03;
        var forceSize = Math.sqrt(Math.pow(force.x, 2) + Math.pow(force.x, 2));

        var size = Math.min(Math.max(5, forceSize), 15);
        var arrowSize = 3 * size;

        var color = util.HSVToHex((180 - Math.min(1, Math.max(0, colorFactor * forceSize)) * 180) / 360, 1, 1);

        var point = {
          x: node.x + factor * force.x,
          y: node.y + factor * force.y
        };

        ctx.lineWidth = size;
        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.moveTo(node.x, node.y);
        ctx.lineTo(point.x, point.y);
        ctx.stroke();

        var angle = Math.atan2(force.y, force.x);
        ctx.fillStyle = color;
        EndPoints.draw(ctx, { type: 'arrow', point: point, angle: angle, length: arrowSize });
        ctx.fill();
      }
    }
  }]);
  return PhysicsEngine;
}();

exports['default'] = PhysicsEngine;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Repulsion Solver
 */
var RepulsionSolver = function () {
  /**
   * @param {Object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {Object} options
   */
  function RepulsionSolver(body, physicsBody, options) {
    (0, _classCallCheck3["default"])(this, RepulsionSolver);

    this.body = body;
    this.physicsBody = physicsBody;
    this.setOptions(options);
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3["default"])(RepulsionSolver, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
    }

    /**
     * Calculate the forces the nodes apply on each other based on a repulsion field.
     * This field is linearly approximated.
     *
     * @private
     */

  }, {
    key: "solve",
    value: function solve() {
      var dx, dy, distance, fx, fy, repulsingForce, node1, node2;

      var nodes = this.body.nodes;
      var nodeIndices = this.physicsBody.physicsNodeIndices;
      var forces = this.physicsBody.forces;

      // repulsing forces between nodes
      var nodeDistance = this.options.nodeDistance;

      // approximation constants
      var a = -2 / 3 / nodeDistance;
      var b = 4 / 3;

      // we loop from i over all but the last entree in the array
      // j loops from i+1 to the last. This way we do not double count any of the indices, nor i === j
      for (var i = 0; i < nodeIndices.length - 1; i++) {
        node1 = nodes[nodeIndices[i]];
        for (var j = i + 1; j < nodeIndices.length; j++) {
          node2 = nodes[nodeIndices[j]];

          dx = node2.x - node1.x;
          dy = node2.y - node1.y;
          distance = Math.sqrt(dx * dx + dy * dy);

          // same condition as BarnesHutSolver, making sure nodes are never 100% overlapping.
          if (distance === 0) {
            distance = 0.1 * Math.random();
            dx = distance;
          }

          if (distance < 2 * nodeDistance) {
            if (distance < 0.5 * nodeDistance) {
              repulsingForce = 1.0;
            } else {
              repulsingForce = a * distance + b; // linear approx of  1 / (1 + Math.exp((distance / nodeDistance - 1) * steepness))
            }
            repulsingForce = repulsingForce / distance;

            fx = dx * repulsingForce;
            fy = dy * repulsingForce;

            forces[node1.id].x -= fx;
            forces[node1.id].y -= fy;
            forces[node2.id].x += fx;
            forces[node2.id].y += fy;
          }
        }
      }
    }
  }]);
  return RepulsionSolver;
}();

exports["default"] = RepulsionSolver;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Hierarchical Repulsion Solver
 */
var HierarchicalRepulsionSolver = function () {
  /**
   * @param {Object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {Object} options
   */
  function HierarchicalRepulsionSolver(body, physicsBody, options) {
    (0, _classCallCheck3["default"])(this, HierarchicalRepulsionSolver);

    this.body = body;
    this.physicsBody = physicsBody;
    this.setOptions(options);
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3["default"])(HierarchicalRepulsionSolver, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
    }

    /**
     * Calculate the forces the nodes apply on each other based on a repulsion field.
     * This field is linearly approximated.
     *
     * @private
     */

  }, {
    key: "solve",
    value: function solve() {
      var dx, dy, distance, fx, fy, repulsingForce, node1, node2, i, j;

      var nodes = this.body.nodes;
      var nodeIndices = this.physicsBody.physicsNodeIndices;
      var forces = this.physicsBody.forces;

      // repulsing forces between nodes
      var nodeDistance = this.options.nodeDistance;

      // we loop from i over all but the last entree in the array
      // j loops from i+1 to the last. This way we do not double count any of the indices, nor i === j
      for (i = 0; i < nodeIndices.length - 1; i++) {
        node1 = nodes[nodeIndices[i]];
        for (j = i + 1; j < nodeIndices.length; j++) {
          node2 = nodes[nodeIndices[j]];

          // nodes only affect nodes on their level
          if (node1.level === node2.level) {
            dx = node2.x - node1.x;
            dy = node2.y - node1.y;
            distance = Math.sqrt(dx * dx + dy * dy);

            var steepness = 0.05;
            if (distance < nodeDistance) {
              repulsingForce = -Math.pow(steepness * distance, 2) + Math.pow(steepness * nodeDistance, 2);
            } else {
              repulsingForce = 0;
            }
            // normalize force with
            if (distance === 0) {
              distance = 0.01;
            } else {
              repulsingForce = repulsingForce / distance;
            }
            fx = dx * repulsingForce;
            fy = dy * repulsingForce;

            forces[node1.id].x -= fx;
            forces[node1.id].y -= fy;
            forces[node2.id].x += fx;
            forces[node2.id].y += fy;
          }
        }
      }
    }
  }]);
  return HierarchicalRepulsionSolver;
}();

exports["default"] = HierarchicalRepulsionSolver;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Spring Solver
 */
var SpringSolver = function () {
  /**
   * @param {Object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {Object} options
   */
  function SpringSolver(body, physicsBody, options) {
    (0, _classCallCheck3["default"])(this, SpringSolver);

    this.body = body;
    this.physicsBody = physicsBody;
    this.setOptions(options);
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3["default"])(SpringSolver, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
    }

    /**
     * This function calculates the springforces on the nodes, accounting for the support nodes.
     *
     * @private
     */

  }, {
    key: "solve",
    value: function solve() {
      var edgeLength = void 0,
          edge = void 0;
      var edgeIndices = this.physicsBody.physicsEdgeIndices;
      var edges = this.body.edges;
      var node1 = void 0,
          node2 = void 0,
          node3 = void 0;

      // forces caused by the edges, modelled as springs
      for (var i = 0; i < edgeIndices.length; i++) {
        edge = edges[edgeIndices[i]];
        if (edge.connected === true && edge.toId !== edge.fromId) {
          // only calculate forces if nodes are in the same sector
          if (this.body.nodes[edge.toId] !== undefined && this.body.nodes[edge.fromId] !== undefined) {
            if (edge.edgeType.via !== undefined) {
              edgeLength = edge.options.length === undefined ? this.options.springLength : edge.options.length;
              node1 = edge.to;
              node2 = edge.edgeType.via;
              node3 = edge.from;

              this._calculateSpringForce(node1, node2, 0.5 * edgeLength);
              this._calculateSpringForce(node2, node3, 0.5 * edgeLength);
            } else {
              // the * 1.5 is here so the edge looks as large as a smooth edge. It does not initially because the smooth edges use
              // the support nodes which exert a repulsive force on the to and from nodes, making the edge appear larger.
              edgeLength = edge.options.length === undefined ? this.options.springLength * 1.5 : edge.options.length;
              this._calculateSpringForce(edge.from, edge.to, edgeLength);
            }
          }
        }
      }
    }

    /**
     * This is the code actually performing the calculation for the function above.
     *
     * @param {Node} node1
     * @param {Node} node2
     * @param {number} edgeLength
     * @private
     */

  }, {
    key: "_calculateSpringForce",
    value: function _calculateSpringForce(node1, node2, edgeLength) {
      var dx = node1.x - node2.x;
      var dy = node1.y - node2.y;
      var distance = Math.max(Math.sqrt(dx * dx + dy * dy), 0.01);

      // the 1/distance is so the fx and fy can be calculated without sine or cosine.
      var springForce = this.options.springConstant * (edgeLength - distance) / distance;

      var fx = dx * springForce;
      var fy = dy * springForce;

      // handle the case where one node is not part of the physcis
      if (this.physicsBody.forces[node1.id] !== undefined) {
        this.physicsBody.forces[node1.id].x += fx;
        this.physicsBody.forces[node1.id].y += fy;
      }

      if (this.physicsBody.forces[node2.id] !== undefined) {
        this.physicsBody.forces[node2.id].x -= fx;
        this.physicsBody.forces[node2.id].y -= fy;
      }
    }
  }]);
  return SpringSolver;
}();

exports["default"] = SpringSolver;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Hierarchical Spring Solver
 */
var HierarchicalSpringSolver = function () {
  /**
   * @param {Object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {Object} options
   */
  function HierarchicalSpringSolver(body, physicsBody, options) {
    (0, _classCallCheck3["default"])(this, HierarchicalSpringSolver);

    this.body = body;
    this.physicsBody = physicsBody;
    this.setOptions(options);
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3["default"])(HierarchicalSpringSolver, [{
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
    }

    /**
     * This function calculates the springforces on the nodes, accounting for the support nodes.
     *
     * @private
     */

  }, {
    key: "solve",
    value: function solve() {
      var edgeLength, edge;
      var dx, dy, fx, fy, springForce, distance;
      var edges = this.body.edges;
      var factor = 0.5;

      var edgeIndices = this.physicsBody.physicsEdgeIndices;
      var nodeIndices = this.physicsBody.physicsNodeIndices;
      var forces = this.physicsBody.forces;

      // initialize the spring force counters
      for (var i = 0; i < nodeIndices.length; i++) {
        var nodeId = nodeIndices[i];
        forces[nodeId].springFx = 0;
        forces[nodeId].springFy = 0;
      }

      // forces caused by the edges, modelled as springs
      for (var _i = 0; _i < edgeIndices.length; _i++) {
        edge = edges[edgeIndices[_i]];
        if (edge.connected === true) {
          edgeLength = edge.options.length === undefined ? this.options.springLength : edge.options.length;

          dx = edge.from.x - edge.to.x;
          dy = edge.from.y - edge.to.y;
          distance = Math.sqrt(dx * dx + dy * dy);
          distance = distance === 0 ? 0.01 : distance;

          // the 1/distance is so the fx and fy can be calculated without sine or cosine.
          springForce = this.options.springConstant * (edgeLength - distance) / distance;

          fx = dx * springForce;
          fy = dy * springForce;

          if (edge.to.level != edge.from.level) {
            if (forces[edge.toId] !== undefined) {
              forces[edge.toId].springFx -= fx;
              forces[edge.toId].springFy -= fy;
            }
            if (forces[edge.fromId] !== undefined) {
              forces[edge.fromId].springFx += fx;
              forces[edge.fromId].springFy += fy;
            }
          } else {
            if (forces[edge.toId] !== undefined) {
              forces[edge.toId].x -= factor * fx;
              forces[edge.toId].y -= factor * fy;
            }
            if (forces[edge.fromId] !== undefined) {
              forces[edge.fromId].x += factor * fx;
              forces[edge.fromId].y += factor * fy;
            }
          }
        }
      }

      // normalize spring forces
      springForce = 1;
      var springFx, springFy;
      for (var _i2 = 0; _i2 < nodeIndices.length; _i2++) {
        var _nodeId = nodeIndices[_i2];
        springFx = Math.min(springForce, Math.max(-springForce, forces[_nodeId].springFx));
        springFy = Math.min(springForce, Math.max(-springForce, forces[_nodeId].springFy));

        forces[_nodeId].x += springFx;
        forces[_nodeId].y += springFy;
      }

      // retain energy balance
      var totalFx = 0;
      var totalFy = 0;
      for (var _i3 = 0; _i3 < nodeIndices.length; _i3++) {
        var _nodeId2 = nodeIndices[_i3];
        totalFx += forces[_nodeId2].x;
        totalFy += forces[_nodeId2].y;
      }
      var correctionFx = totalFx / nodeIndices.length;
      var correctionFy = totalFy / nodeIndices.length;

      for (var _i4 = 0; _i4 < nodeIndices.length; _i4++) {
        var _nodeId3 = nodeIndices[_i4];
        forces[_nodeId3].x -= correctionFx;
        forces[_nodeId3].y -= correctionFy;
      }
    }
  }]);
  return HierarchicalSpringSolver;
}();

exports["default"] = HierarchicalSpringSolver;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BarnesHutSolver2 = __webpack_require__(120);

var _BarnesHutSolver3 = _interopRequireDefault(_BarnesHutSolver2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @extends BarnesHutSolver
 */
var ForceAtlas2BasedRepulsionSolver = function (_BarnesHutSolver) {
  (0, _inherits3["default"])(ForceAtlas2BasedRepulsionSolver, _BarnesHutSolver);

  /**
   * @param {Object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {Object} options
   */
  function ForceAtlas2BasedRepulsionSolver(body, physicsBody, options) {
    (0, _classCallCheck3["default"])(this, ForceAtlas2BasedRepulsionSolver);
    return (0, _possibleConstructorReturn3["default"])(this, (ForceAtlas2BasedRepulsionSolver.__proto__ || (0, _getPrototypeOf2["default"])(ForceAtlas2BasedRepulsionSolver)).call(this, body, physicsBody, options));
  }

  /**
   * Calculate the forces based on the distance.
   *
   * @param {number} distance
   * @param {number} dx
   * @param {number} dy
   * @param {Node} node
   * @param {Object} parentBranch
   * @private
   */


  (0, _createClass3["default"])(ForceAtlas2BasedRepulsionSolver, [{
    key: "_calculateForces",
    value: function _calculateForces(distance, dx, dy, node, parentBranch) {
      if (distance === 0) {
        distance = 0.1 * Math.random();
        dx = distance;
      }

      if (this.overlapAvoidanceFactor < 1 && node.shape.radius) {
        distance = Math.max(0.1 + this.overlapAvoidanceFactor * node.shape.radius, distance - node.shape.radius);
      }

      var degree = node.edges.length + 1;
      // the dividing by the distance cubed instead of squared allows us to get the fx and fy components without sines and cosines
      // it is shorthand for gravityforce with distance squared and fx = dx/distance * gravityForce
      var gravityForce = this.options.gravitationalConstant * parentBranch.mass * node.options.mass * degree / Math.pow(distance, 2);
      var fx = dx * gravityForce;
      var fy = dy * gravityForce;

      this.physicsBody.forces[node.id].x += fx;
      this.physicsBody.forces[node.id].y += fy;
    }
  }]);
  return ForceAtlas2BasedRepulsionSolver;
}(_BarnesHutSolver3["default"]);

exports["default"] = ForceAtlas2BasedRepulsionSolver;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _CentralGravitySolver2 = __webpack_require__(121);

var _CentralGravitySolver3 = _interopRequireDefault(_CentralGravitySolver2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @extends CentralGravitySolver
 */
var ForceAtlas2BasedCentralGravitySolver = function (_CentralGravitySolver) {
  (0, _inherits3["default"])(ForceAtlas2BasedCentralGravitySolver, _CentralGravitySolver);

  /**
   * @param {Object} body
   * @param {{physicsNodeIndices: Array, physicsEdgeIndices: Array, forces: {}, velocities: {}}} physicsBody
   * @param {Object} options
   */
  function ForceAtlas2BasedCentralGravitySolver(body, physicsBody, options) {
    (0, _classCallCheck3["default"])(this, ForceAtlas2BasedCentralGravitySolver);
    return (0, _possibleConstructorReturn3["default"])(this, (ForceAtlas2BasedCentralGravitySolver.__proto__ || (0, _getPrototypeOf2["default"])(ForceAtlas2BasedCentralGravitySolver)).call(this, body, physicsBody, options));
  }

  /**
   * Calculate the forces based on the distance.
   *
   * @param {number} distance
   * @param {number} dx
   * @param {number} dy
   * @param {Object<Node.id, Node>} forces
   * @param {Node} node
   * @private
   */


  (0, _createClass3["default"])(ForceAtlas2BasedCentralGravitySolver, [{
    key: "_calculateForces",
    value: function _calculateForces(distance, dx, dy, forces, node) {
      if (distance > 0) {
        var degree = node.edges.length + 1;
        var gravityForce = this.options.centralGravity * degree * node.options.mass;
        forces[node.id].x = dx * gravityForce;
        forces[node.id].y = dy * gravityForce;
      }
    }
  }]);
  return ForceAtlas2BasedCentralGravitySolver;
}(_CentralGravitySolver3["default"]);

exports["default"] = ForceAtlas2BasedCentralGravitySolver;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* ===========================================================================

# TODO

- `edgeReplacedById` not cleaned up yet on cluster edge removal
- allowSingleNodeCluster could be a global option as well; currently needs to always
  be passed to clustering methods

----------------------------------------------

# State Model for Clustering

The total state for clustering is non-trivial. It is useful to have a model
available as to how it works. The following documents the relevant state items.


## Network State

The following `network`-members are relevant to clustering:

- `body.nodes`       - all nodes actively participating in the network
- `body.edges`       - same for edges
- `body.nodeIndices` - id's of nodes that are visible at a given moment
- `body.edgeIndices` - same for edges

This includes:

- helper nodes for dragging in `manipulation`
- helper nodes for edge type `dynamic`
- cluster nodes and edges
- there may be more than this.

A node/edge may be missing in the `Indices` member if:

- it is a helper node
- the node or edge state has option `hidden` set
- It is not visible due to clustering


## Clustering State

For the hashes, the id's of the nodes/edges are used as key.

Member `network.clustering` contains the following items:

- `clusteredNodes` - hash with values: { clusterId: <id of cluster>, node: <node instance>}
- `clusteredEdges` - hash with values: restore information for given edge


Due to nesting of clusters, these members can contain cluster nodes and edges as well.

The important thing to note here, is that the clustered nodes and edges also
appear in the members of the cluster nodes. For data update, it is therefore 
important to scan these lists as well as the cluster nodes.


### Cluster Node

A cluster node has the following extra fields:

- `isCluster : true` - indication that this is a cluster node
- `containedNodes`   - hash of nodes contained in this cluster
- `containedEdges`   - same for edges
- `edges`            - array of cluster edges for this node 


**NOTE:**

- `containedEdges` can also contain edges which are not clustered; e.g. an edge
   connecting two nodes in the same cluster.


### Cluster Edge

These are the items in the `edges` member of a clustered node. They have the
following relevant members:

- 'clusteringEdgeReplacingIds` - array of id's of edges replaced by this edge

Note that it's possible to nest clusters, so that `clusteringEdgeReplacingIds`
can contain edge id's of other clusters.


### Clustered Edge

This is any edge contained by a cluster edge. It gets the following additional
member:

- `edgeReplacedById` - id of the cluster edge in which current edge is clustered


   =========================================================================== */
var util = __webpack_require__(2);
var NetworkUtil = __webpack_require__(76)['default'];
var Cluster = __webpack_require__(228)['default'];
var Edge = __webpack_require__(74)['default']; // Only needed for check on type!
var Node = __webpack_require__(47)['default']; // Only needed for check on type!

/**
 * The clustering engine
 */

var ClusterEngine = function () {
  /**
   * @param {Object} body
   */
  function ClusterEngine(body) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, ClusterEngine);

    this.body = body;
    this.clusteredNodes = {}; // key: node id, value: { clusterId: <id of cluster>, node: <node instance>}
    this.clusteredEdges = {}; // key: edge id, value: restore information for given edge

    this.options = {};
    this.defaultOptions = {};
    util.extend(this.options, this.defaultOptions);

    this.body.emitter.on('_resetData', function () {
      _this.clusteredNodes = {};_this.clusteredEdges = {};
    });
  }

  /**
  *
  * @param {number} hubsize
  * @param {Object} options
  */


  (0, _createClass3['default'])(ClusterEngine, [{
    key: 'clusterByHubsize',
    value: function clusterByHubsize(hubsize, options) {
      if (hubsize === undefined) {
        hubsize = this._getHubSize();
      } else if ((typeof hubsize === 'undefined' ? 'undefined' : (0, _typeof3['default'])(hubsize)) === "object") {
        options = this._checkOptions(hubsize);
        hubsize = this._getHubSize();
      }

      var nodesToCluster = [];
      for (var i = 0; i < this.body.nodeIndices.length; i++) {
        var node = this.body.nodes[this.body.nodeIndices[i]];
        if (node.edges.length >= hubsize) {
          nodesToCluster.push(node.id);
        }
      }

      for (var _i = 0; _i < nodesToCluster.length; _i++) {
        this.clusterByConnection(nodesToCluster[_i], options, true);
      }

      this.body.emitter.emit('_dataChanged');
    }

    /**
     * loop over all nodes, check if they adhere to the condition and cluster if needed.
     * @param {Object} options
     * @param {boolean} [refreshData=true]
     */

  }, {
    key: 'cluster',
    value: function cluster() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (options.joinCondition === undefined) {
        throw new Error("Cannot call clusterByNodeData without a joinCondition function in the options.");
      }

      // check if the options object is fine, append if needed
      options = this._checkOptions(options);

      var childNodesObj = {};
      var childEdgesObj = {};

      // collect the nodes that will be in the cluster
      util.forEach(this.body.nodes, function (node, nodeId) {
        var clonedOptions = NetworkUtil.cloneOptions(node);
        if (options.joinCondition(clonedOptions) === true) {
          childNodesObj[nodeId] = node;

          // collect the edges that will be in the cluster
          util.forEach(node.edges, function (edge) {
            if (_this2.clusteredEdges[edge.id] === undefined) {
              childEdgesObj[edge.id] = edge;
            }
          });
        }
      });

      this._cluster(childNodesObj, childEdgesObj, options, refreshData);
    }

    /**
     * Cluster all nodes in the network that have only X edges
     * @param {number} edgeCount
     * @param {Object} options
     * @param {boolean} [refreshData=true]
     */

  }, {
    key: 'clusterByEdgeCount',
    value: function clusterByEdgeCount(edgeCount, options) {
      var _this3 = this;

      var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      options = this._checkOptions(options);
      var clusters = [];
      var usedNodes = {};
      var edge = void 0,
          edges = void 0,
          relevantEdgeCount = void 0;
      // collect the nodes that will be in the cluster

      var _loop = function _loop(i) {
        var childNodesObj = {};
        var childEdgesObj = {};
        var nodeId = _this3.body.nodeIndices[i];
        var node = _this3.body.nodes[nodeId];

        // if this node is already used in another cluster this session, we do not have to re-evaluate it.
        if (usedNodes[nodeId] === undefined) {
          relevantEdgeCount = 0;
          edges = [];
          for (var j = 0; j < node.edges.length; j++) {
            edge = node.edges[j];
            if (_this3.clusteredEdges[edge.id] === undefined) {
              if (edge.toId !== edge.fromId) {
                relevantEdgeCount++;
              }
              edges.push(edge);
            }
          }

          // this node qualifies, we collect its neighbours to start the clustering process.
          if (relevantEdgeCount === edgeCount) {
            checkJoinCondition = function checkJoinCondition(node) {
              if (options.joinCondition === undefined || options.joinCondition === null) {
                return true;
              }

              var clonedOptions = NetworkUtil.cloneOptions(node);
              return options.joinCondition(clonedOptions);
            };

            var gatheringSuccessful = true;
            for (var _j = 0; _j < edges.length; _j++) {
              edge = edges[_j];
              var childNodeId = _this3._getConnectedId(edge, nodeId);
              // add the nodes to the list by the join condition.
              if (checkJoinCondition(node)) {
                childEdgesObj[edge.id] = edge;
                childNodesObj[nodeId] = node;
                childNodesObj[childNodeId] = _this3.body.nodes[childNodeId];
                usedNodes[nodeId] = true;
              } else {
                // this node does not qualify after all.
                gatheringSuccessful = false;
                break;
              }
            }

            // add to the cluster queue
            if ((0, _keys2['default'])(childNodesObj).length > 0 && (0, _keys2['default'])(childEdgesObj).length > 0 && gatheringSuccessful === true) {
              /**
               * Search for cluster data that contains any of the node id's
               * @returns {Boolean} true if no joinCondition, otherwise return value of joinCondition
               */
              findClusterData = function findClusterData() {
                for (var n = 0; n < clusters.length; ++n) {
                  // Search for a cluster containing any of the node id's
                  for (var m in childNodesObj) {
                    if (clusters[n].nodes[m] !== undefined) {
                      return clusters[n];
                    }
                  }
                }

                return undefined;
              };

              // If any of the found nodes is part of a cluster found in this method,
              // add the current values to that cluster


              foundCluster = findClusterData();

              if (foundCluster !== undefined) {
                // Add nodes to found cluster if not present
                for (var m in childNodesObj) {
                  if (foundCluster.nodes[m] === undefined) {
                    foundCluster.nodes[m] = childNodesObj[m];
                  }
                }

                // Add edges to found cluster, if not present
                for (var _m in childEdgesObj) {
                  if (foundCluster.edges[_m] === undefined) {
                    foundCluster.edges[_m] = childEdgesObj[_m];
                  }
                }
              } else {
                // Create a new cluster group
                clusters.push({ nodes: childNodesObj, edges: childEdgesObj });
              }
            }
          }
        }
      };

      for (var i = 0; i < this.body.nodeIndices.length; i++) {
        var checkJoinCondition;
        var findClusterData;
        var foundCluster;

        _loop(i);
      }

      for (var i = 0; i < clusters.length; i++) {
        this._cluster(clusters[i].nodes, clusters[i].edges, options, false);
      }

      if (refreshData === true) {
        this.body.emitter.emit('_dataChanged');
      }
    }

    /**
     * Cluster all nodes in the network that have only 1 edge
     * @param {Object} options
     * @param {boolean} [refreshData=true]
     */

  }, {
    key: 'clusterOutliers',
    value: function clusterOutliers(options) {
      var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.clusterByEdgeCount(1, options, refreshData);
    }

    /**
     * Cluster all nodes in the network that have only 2 edge
     * @param {Object} options
     * @param {boolean} [refreshData=true]
     */

  }, {
    key: 'clusterBridges',
    value: function clusterBridges(options) {
      var refreshData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      this.clusterByEdgeCount(2, options, refreshData);
    }

    /**
    * suck all connected nodes of a node into the node.
    * @param {Node.id} nodeId
    * @param {Object} options
    * @param {boolean} [refreshData=true]
    */

  }, {
    key: 'clusterByConnection',
    value: function clusterByConnection(nodeId, options) {
      var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      // kill conditions
      if (nodeId === undefined) {
        throw new Error("No nodeId supplied to clusterByConnection!");
      }
      if (this.body.nodes[nodeId] === undefined) {
        throw new Error("The nodeId given to clusterByConnection does not exist!");
      }

      var node = this.body.nodes[nodeId];
      options = this._checkOptions(options, node);
      if (options.clusterNodeProperties.x === undefined) {
        options.clusterNodeProperties.x = node.x;
      }
      if (options.clusterNodeProperties.y === undefined) {
        options.clusterNodeProperties.y = node.y;
      }
      if (options.clusterNodeProperties.fixed === undefined) {
        options.clusterNodeProperties.fixed = {};
        options.clusterNodeProperties.fixed.x = node.options.fixed.x;
        options.clusterNodeProperties.fixed.y = node.options.fixed.y;
      }

      var childNodesObj = {};
      var childEdgesObj = {};
      var parentNodeId = node.id;
      var parentClonedOptions = NetworkUtil.cloneOptions(node);
      childNodesObj[parentNodeId] = node;

      // collect the nodes that will be in the cluster
      for (var i = 0; i < node.edges.length; i++) {
        var edge = node.edges[i];
        if (this.clusteredEdges[edge.id] === undefined) {
          var childNodeId = this._getConnectedId(edge, parentNodeId);

          // if the child node is not in a cluster
          if (this.clusteredNodes[childNodeId] === undefined) {
            if (childNodeId !== parentNodeId) {
              if (options.joinCondition === undefined) {
                childEdgesObj[edge.id] = edge;
                childNodesObj[childNodeId] = this.body.nodes[childNodeId];
              } else {
                // clone the options and insert some additional parameters that could be interesting.
                var childClonedOptions = NetworkUtil.cloneOptions(this.body.nodes[childNodeId]);
                if (options.joinCondition(parentClonedOptions, childClonedOptions) === true) {
                  childEdgesObj[edge.id] = edge;
                  childNodesObj[childNodeId] = this.body.nodes[childNodeId];
                }
              }
            } else {
              // swallow the edge if it is self-referencing.
              childEdgesObj[edge.id] = edge;
            }
          }
        }
      }
      var childNodeIDs = (0, _keys2['default'])(childNodesObj).map(function (childNode) {
        return childNodesObj[childNode].id;
      });

      for (childNode in childNodesObj) {
        if (!childNodesObj.hasOwnProperty(childNode)) continue;

        var childNode = childNodesObj[childNode];
        for (var y = 0; y < childNode.edges.length; y++) {
          var childEdge = childNode.edges[y];
          if (childNodeIDs.indexOf(this._getConnectedId(childEdge, childNode.id)) > -1) {
            childEdgesObj[childEdge.id] = childEdge;
          }
        }
      }
      this._cluster(childNodesObj, childEdgesObj, options, refreshData);
    }

    /**
    * This function creates the edges that will be attached to the cluster
    * It looks for edges that are connected to the nodes from the "outside' of the cluster.
    *
    * @param {{Node.id: vis.Node}} childNodesObj
    * @param {{vis.Edge.id: vis.Edge}} childEdgesObj
    * @param {Object} clusterNodeProperties
    * @param {Object} clusterEdgeProperties
    * @private
    */

  }, {
    key: '_createClusterEdges',
    value: function _createClusterEdges(childNodesObj, childEdgesObj, clusterNodeProperties, clusterEdgeProperties) {
      var edge = void 0,
          childNodeId = void 0,
          childNode = void 0,
          toId = void 0,
          fromId = void 0,
          otherNodeId = void 0;

      // loop over all child nodes and their edges to find edges going out of the cluster
      // these edges will be replaced by clusterEdges.
      var childKeys = (0, _keys2['default'])(childNodesObj);
      var createEdges = [];
      for (var i = 0; i < childKeys.length; i++) {
        childNodeId = childKeys[i];
        childNode = childNodesObj[childNodeId];

        // construct new edges from the cluster to others
        for (var j = 0; j < childNode.edges.length; j++) {
          edge = childNode.edges[j];
          // we only handle edges that are visible to the system, not the disabled ones from the clustering process.
          if (this.clusteredEdges[edge.id] === undefined) {
            // self-referencing edges will be added to the "hidden" list
            if (edge.toId == edge.fromId) {
              childEdgesObj[edge.id] = edge;
            } else {
              // set up the from and to.
              if (edge.toId == childNodeId) {
                // this is a double equals because ints and strings can be interchanged here.
                toId = clusterNodeProperties.id;
                fromId = edge.fromId;
                otherNodeId = fromId;
              } else {
                toId = edge.toId;
                fromId = clusterNodeProperties.id;
                otherNodeId = toId;
              }
            }

            // Only edges from the cluster outwards are being replaced.
            if (childNodesObj[otherNodeId] === undefined) {
              createEdges.push({ edge: edge, fromId: fromId, toId: toId });
            }
          }
        }
      }

      //
      // Here we actually create the replacement edges.
      //
      // We could not do this in the loop above as the creation process
      // would add an edge to the edges array we are iterating over.
      //
      // NOTE: a clustered edge can have multiple base edges!
      //
      var newEdges = [];

      /**
       * Find a cluster edge which matches the given created edge.
       * @param {vis.Edge} createdEdge
       * @returns {vis.Edge}
       */
      var getNewEdge = function getNewEdge(createdEdge) {
        for (var _j2 = 0; _j2 < newEdges.length; _j2++) {
          var newEdge = newEdges[_j2];

          // We replace both to and from edges with a single cluster edge
          var matchToDirection = createdEdge.fromId === newEdge.fromId && createdEdge.toId === newEdge.toId;
          var matchFromDirection = createdEdge.fromId === newEdge.toId && createdEdge.toId === newEdge.fromId;

          if (matchToDirection || matchFromDirection) {
            return newEdge;
          }
        }

        return null;
      };

      for (var _j3 = 0; _j3 < createEdges.length; _j3++) {
        var createdEdge = createEdges[_j3];
        var _edge = createdEdge.edge;
        var newEdge = getNewEdge(createdEdge);

        if (newEdge === null) {
          // Create a clustered edge for this connection
          newEdge = this._createClusteredEdge(createdEdge.fromId, createdEdge.toId, _edge, clusterEdgeProperties);

          newEdges.push(newEdge);
        } else {
          newEdge.clusteringEdgeReplacingIds.push(_edge.id);
        }

        // also reference the new edge in the old edge
        this.body.edges[_edge.id].edgeReplacedById = newEdge.id;

        // hide the replaced edge
        this._backupEdgeOptions(_edge);
        _edge.setOptions({ physics: false });
      }
    }

    /**
    * This function checks the options that can be supplied to the different cluster functions
    * for certain fields and inserts defaults if needed
    * @param {Object} options
    * @returns {*}
    * @private
    */

  }, {
    key: '_checkOptions',
    value: function _checkOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.clusterEdgeProperties === undefined) {
        options.clusterEdgeProperties = {};
      }
      if (options.clusterNodeProperties === undefined) {
        options.clusterNodeProperties = {};
      }

      return options;
    }

    /**
    *
    * @param {Object}    childNodesObj         | object with node objects, id as keys, same as childNodes except it also contains a source node
    * @param {Object}    childEdgesObj         | object with edge objects, id as keys
    * @param {Array}     options               | object with {clusterNodeProperties, clusterEdgeProperties, processProperties}
    * @param {boolean}   refreshData | when true, do not wrap up
    * @private
    */

  }, {
    key: '_cluster',
    value: function _cluster(childNodesObj, childEdgesObj, options) {
      var refreshData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      // Remove nodes which are already clustered
      var tmpNodesToRemove = [];
      for (var _nodeId in childNodesObj) {
        if (childNodesObj.hasOwnProperty(_nodeId)) {
          if (this.clusteredNodes[_nodeId] !== undefined) {
            tmpNodesToRemove.push(_nodeId);
          }
        }
      }

      for (var n = 0; n < tmpNodesToRemove.length; ++n) {
        delete childNodesObj[tmpNodesToRemove[n]];
      }

      // kill condition: no nodes don't bother
      if ((0, _keys2['default'])(childNodesObj).length == 0) {
        return;
      }

      // allow clusters of 1 if options allow
      if ((0, _keys2['default'])(childNodesObj).length == 1 && options.clusterNodeProperties.allowSingleNodeCluster != true) {
        return;
      }

      var clusterNodeProperties = util.deepExtend({}, options.clusterNodeProperties);

      // construct the clusterNodeProperties
      if (options.processProperties !== undefined) {
        // get the childNode options
        var childNodesOptions = [];
        for (var _nodeId2 in childNodesObj) {
          if (childNodesObj.hasOwnProperty(_nodeId2)) {
            var clonedOptions = NetworkUtil.cloneOptions(childNodesObj[_nodeId2]);
            childNodesOptions.push(clonedOptions);
          }
        }

        // get cluster properties based on childNodes
        var childEdgesOptions = [];
        for (var edgeId in childEdgesObj) {
          if (childEdgesObj.hasOwnProperty(edgeId)) {
            // these cluster edges will be removed on creation of the cluster.
            if (edgeId.substr(0, 12) !== "clusterEdge:") {
              var _clonedOptions = NetworkUtil.cloneOptions(childEdgesObj[edgeId], 'edge');
              childEdgesOptions.push(_clonedOptions);
            }
          }
        }

        clusterNodeProperties = options.processProperties(clusterNodeProperties, childNodesOptions, childEdgesOptions);
        if (!clusterNodeProperties) {
          throw new Error("The processProperties function does not return properties!");
        }
      }

      // check if we have an unique id;
      if (clusterNodeProperties.id === undefined) {
        clusterNodeProperties.id = 'cluster:' + util.randomUUID();
      }
      var clusterId = clusterNodeProperties.id;

      if (clusterNodeProperties.label === undefined) {
        clusterNodeProperties.label = 'cluster';
      }

      // give the clusterNode a position if it does not have one.
      var pos = undefined;
      if (clusterNodeProperties.x === undefined) {
        pos = this._getClusterPosition(childNodesObj);
        clusterNodeProperties.x = pos.x;
      }
      if (clusterNodeProperties.y === undefined) {
        if (pos === undefined) {
          pos = this._getClusterPosition(childNodesObj);
        }
        clusterNodeProperties.y = pos.y;
      }

      // force the ID to remain the same
      clusterNodeProperties.id = clusterId;

      // create the cluster Node
      // Note that allowSingleNodeCluster, if present, is stored in the options as well
      var clusterNode = this.body.functions.createNode(clusterNodeProperties, Cluster);
      clusterNode.containedNodes = childNodesObj;
      clusterNode.containedEdges = childEdgesObj;
      // cache a copy from the cluster edge properties if we have to reconnect others later on
      clusterNode.clusterEdgeProperties = options.clusterEdgeProperties;

      // finally put the cluster node into global
      this.body.nodes[clusterNodeProperties.id] = clusterNode;

      this._clusterEdges(childNodesObj, childEdgesObj, clusterNodeProperties, options.clusterEdgeProperties);

      // set ID to undefined so no duplicates arise
      clusterNodeProperties.id = undefined;

      // wrap up
      if (refreshData === true) {
        this.body.emitter.emit('_dataChanged');
      }
    }

    /**
     *
     * @param {Edge} edge
     * @private
     */

  }, {
    key: '_backupEdgeOptions',
    value: function _backupEdgeOptions(edge) {
      if (this.clusteredEdges[edge.id] === undefined) {
        this.clusteredEdges[edge.id] = { physics: edge.options.physics };
      }
    }

    /**
     *
     * @param {Edge} edge
     * @private
     */

  }, {
    key: '_restoreEdge',
    value: function _restoreEdge(edge) {
      var originalOptions = this.clusteredEdges[edge.id];
      if (originalOptions !== undefined) {
        edge.setOptions({ physics: originalOptions.physics });
        delete this.clusteredEdges[edge.id];
      }
    }

    /**
    * Check if a node is a cluster.
    * @param {Node.id} nodeId
    * @returns {*}
    */

  }, {
    key: 'isCluster',
    value: function isCluster(nodeId) {
      if (this.body.nodes[nodeId] !== undefined) {
        return this.body.nodes[nodeId].isCluster === true;
      } else {
        console.log("Node does not exist.");
        return false;
      }
    }

    /**
    * get the position of the cluster node based on what's inside
    * @param {object} childNodesObj    | object with node objects, id as keys
    * @returns {{x: number, y: number}}
    * @private
    */

  }, {
    key: '_getClusterPosition',
    value: function _getClusterPosition(childNodesObj) {
      var childKeys = (0, _keys2['default'])(childNodesObj);
      var minX = childNodesObj[childKeys[0]].x;
      var maxX = childNodesObj[childKeys[0]].x;
      var minY = childNodesObj[childKeys[0]].y;
      var maxY = childNodesObj[childKeys[0]].y;
      var node = void 0;
      for (var i = 1; i < childKeys.length; i++) {
        node = childNodesObj[childKeys[i]];
        minX = node.x < minX ? node.x : minX;
        maxX = node.x > maxX ? node.x : maxX;
        minY = node.y < minY ? node.y : minY;
        maxY = node.y > maxY ? node.y : maxY;
      }

      return { x: 0.5 * (minX + maxX), y: 0.5 * (minY + maxY) };
    }

    /**
     * Open a cluster by calling this function.
     * @param {vis.Edge.id}  clusterNodeId | the ID of the cluster node
     * @param {Object} options
     * @param {boolean} refreshData | wrap up afterwards if not true
     */

  }, {
    key: 'openCluster',
    value: function openCluster(clusterNodeId, options) {
      var refreshData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      // kill conditions
      if (clusterNodeId === undefined) {
        throw new Error("No clusterNodeId supplied to openCluster.");
      }

      var clusterNode = this.body.nodes[clusterNodeId];

      if (clusterNode === undefined) {
        throw new Error("The clusterNodeId supplied to openCluster does not exist.");
      }
      if (clusterNode.isCluster !== true || clusterNode.containedNodes === undefined || clusterNode.containedEdges === undefined) {
        throw new Error("The node:" + clusterNodeId + " is not a valid cluster.");
      }

      // Check if current cluster is clustered itself
      var stack = this.findNode(clusterNodeId);
      var parentIndex = stack.indexOf(clusterNodeId) - 1;
      if (parentIndex >= 0) {
        // Current cluster is clustered; transfer contained nodes and edges to parent
        var parentClusterNodeId = stack[parentIndex];
        var parentClusterNode = this.body.nodes[parentClusterNodeId];

        // clustering.clusteredNodes and clustering.clusteredEdges remain unchanged
        parentClusterNode._openChildCluster(clusterNodeId);

        // All components of child cluster node have been transferred. It can die now.
        delete this.body.nodes[clusterNodeId];
        if (refreshData === true) {
          this.body.emitter.emit('_dataChanged');
        }

        return;
      }

      // main body 
      var containedNodes = clusterNode.containedNodes;
      var containedEdges = clusterNode.containedEdges;

      // allow the user to position the nodes after release.
      if (options !== undefined && options.releaseFunction !== undefined && typeof options.releaseFunction === 'function') {
        var positions = {};
        var clusterPosition = { x: clusterNode.x, y: clusterNode.y };
        for (var _nodeId3 in containedNodes) {
          if (containedNodes.hasOwnProperty(_nodeId3)) {
            var containedNode = this.body.nodes[_nodeId3];
            positions[_nodeId3] = { x: containedNode.x, y: containedNode.y };
          }
        }
        var newPositions = options.releaseFunction(clusterPosition, positions);

        for (var _nodeId4 in containedNodes) {
          if (containedNodes.hasOwnProperty(_nodeId4)) {
            var _containedNode = this.body.nodes[_nodeId4];
            if (newPositions[_nodeId4] !== undefined) {
              _containedNode.x = newPositions[_nodeId4].x === undefined ? clusterNode.x : newPositions[_nodeId4].x;
              _containedNode.y = newPositions[_nodeId4].y === undefined ? clusterNode.y : newPositions[_nodeId4].y;
            }
          }
        }
      } else {
        // copy the position from the cluster
        util.forEach(containedNodes, function (containedNode) {
          // inherit position
          if (containedNode.options.fixed.x === false) {
            containedNode.x = clusterNode.x;
          }
          if (containedNode.options.fixed.y === false) {
            containedNode.y = clusterNode.y;
          }
        });
      }

      // release nodes
      for (var _nodeId5 in containedNodes) {
        if (containedNodes.hasOwnProperty(_nodeId5)) {
          var _containedNode2 = this.body.nodes[_nodeId5];

          // inherit speed
          _containedNode2.vx = clusterNode.vx;
          _containedNode2.vy = clusterNode.vy;

          _containedNode2.setOptions({ physics: true });

          delete this.clusteredNodes[_nodeId5];
        }
      }

      // copy the clusterNode edges because we cannot iterate over an object that we add or remove from.
      var edgesToBeDeleted = [];
      for (var i = 0; i < clusterNode.edges.length; i++) {
        edgesToBeDeleted.push(clusterNode.edges[i]);
      }

      // actually handling the deleting.
      for (var _i2 = 0; _i2 < edgesToBeDeleted.length; _i2++) {
        var edge = edgesToBeDeleted[_i2];
        var otherNodeId = this._getConnectedId(edge, clusterNodeId);
        var otherNode = this.clusteredNodes[otherNodeId];

        for (var j = 0; j < edge.clusteringEdgeReplacingIds.length; j++) {
          var transferId = edge.clusteringEdgeReplacingIds[j];
          var transferEdge = this.body.edges[transferId];
          if (transferEdge === undefined) continue;

          // if the other node is in another cluster, we transfer ownership of this edge to the other cluster
          if (otherNode !== undefined) {
            // transfer ownership:
            var otherCluster = this.body.nodes[otherNode.clusterId];
            otherCluster.containedEdges[transferEdge.id] = transferEdge;

            // delete local reference
            delete containedEdges[transferEdge.id];

            // get to and from
            var fromId = transferEdge.fromId;
            var toId = transferEdge.toId;
            if (transferEdge.toId == otherNodeId) {
              toId = otherNode.clusterId;
            } else {
              fromId = otherNode.clusterId;
            }

            // create new cluster edge from the otherCluster
            this._createClusteredEdge(fromId, toId, transferEdge, otherCluster.clusterEdgeProperties, { hidden: false, physics: true });
          } else {
            this._restoreEdge(transferEdge);
          }
        }

        edge.remove();
      }

      // handle the releasing of the edges
      for (var edgeId in containedEdges) {
        if (containedEdges.hasOwnProperty(edgeId)) {
          this._restoreEdge(containedEdges[edgeId]);
        }
      }

      // remove clusterNode
      delete this.body.nodes[clusterNodeId];

      if (refreshData === true) {
        this.body.emitter.emit('_dataChanged');
      }
    }

    /**
     *
     * @param {Cluster.id} clusterId
     * @returns {Array.<Node.id>}
     */

  }, {
    key: 'getNodesInCluster',
    value: function getNodesInCluster(clusterId) {
      var nodesArray = [];
      if (this.isCluster(clusterId) === true) {
        var containedNodes = this.body.nodes[clusterId].containedNodes;
        for (var _nodeId6 in containedNodes) {
          if (containedNodes.hasOwnProperty(_nodeId6)) {
            nodesArray.push(this.body.nodes[_nodeId6].id);
          }
        }
      }

      return nodesArray;
    }

    /**
    * Get the stack clusterId's that a certain node resides in. cluster A -> cluster B -> cluster C -> node
    *
    * If a node can't be found in the chain, return an empty array.
    *
    * @param {string|number} nodeId
    * @returns {Array}
    */

  }, {
    key: 'findNode',
    value: function findNode(nodeId) {
      var stack = [];
      var max = 100;
      var counter = 0;
      var node = void 0;

      while (this.clusteredNodes[nodeId] !== undefined && counter < max) {
        node = this.body.nodes[nodeId];
        if (node === undefined) return [];
        stack.push(node.id);

        nodeId = this.clusteredNodes[nodeId].clusterId;
        counter++;
      }

      node = this.body.nodes[nodeId];
      if (node === undefined) return [];
      stack.push(node.id);

      stack.reverse();
      return stack;
    }

    /**
    * Using a clustered nodeId, update with the new options
    * @param {vis.Edge.id} clusteredNodeId
    * @param {object} newOptions
    */

  }, {
    key: 'updateClusteredNode',
    value: function updateClusteredNode(clusteredNodeId, newOptions) {
      if (clusteredNodeId === undefined) {
        throw new Error("No clusteredNodeId supplied to updateClusteredNode.");
      }
      if (newOptions === undefined) {
        throw new Error("No newOptions supplied to updateClusteredNode.");
      }
      if (this.body.nodes[clusteredNodeId] === undefined) {
        throw new Error("The clusteredNodeId supplied to updateClusteredNode does not exist.");
      }

      this.body.nodes[clusteredNodeId].setOptions(newOptions);
      this.body.emitter.emit('_dataChanged');
    }

    /**
    * Using a base edgeId, update all related clustered edges with the new options
    * @param {vis.Edge.id} startEdgeId
    * @param {object} newOptions
    */

  }, {
    key: 'updateEdge',
    value: function updateEdge(startEdgeId, newOptions) {
      if (startEdgeId === undefined) {
        throw new Error("No startEdgeId supplied to updateEdge.");
      }
      if (newOptions === undefined) {
        throw new Error("No newOptions supplied to updateEdge.");
      }
      if (this.body.edges[startEdgeId] === undefined) {
        throw new Error("The startEdgeId supplied to updateEdge does not exist.");
      }

      var allEdgeIds = this.getClusteredEdges(startEdgeId);
      for (var i = 0; i < allEdgeIds.length; i++) {
        var edge = this.body.edges[allEdgeIds[i]];
        edge.setOptions(newOptions);
      }
      this.body.emitter.emit('_dataChanged');
    }

    /**
    * Get a stack of clusterEdgeId's (+base edgeid) that a base edge is the same as. cluster edge C -> cluster edge B -> cluster edge A -> base edge(edgeId)
    * @param {vis.Edge.id} edgeId
    * @returns {Array.<vis.Edge.id>}
    */

  }, {
    key: 'getClusteredEdges',
    value: function getClusteredEdges(edgeId) {
      var stack = [];
      var max = 100;
      var counter = 0;

      while (edgeId !== undefined && this.body.edges[edgeId] !== undefined && counter < max) {
        stack.push(this.body.edges[edgeId].id);
        edgeId = this.body.edges[edgeId].edgeReplacedById;
        counter++;
      }
      stack.reverse();
      return stack;
    }

    /**
    * Get the base edge id of clusterEdgeId. cluster edge (clusteredEdgeId) -> cluster edge B -> cluster edge C -> base edge
    * @param {vis.Edge.id} clusteredEdgeId
    * @returns {vis.Edge.id} baseEdgeId
    *
    * TODO: deprecate in 5.0.0. Method getBaseEdges() is the correct one to use.
    */

  }, {
    key: 'getBaseEdge',
    value: function getBaseEdge(clusteredEdgeId) {
      // Just kludge this by returning the first base edge id found
      return this.getBaseEdges(clusteredEdgeId)[0];
    }

    /**
     * Get all regular edges for this clustered edge id.
     *
     * @param {vis.Edge.id} clusteredEdgeId
     * @returns {Array.<vis.Edge.id>} all baseEdgeId's under this clustered edge
     */

  }, {
    key: 'getBaseEdges',
    value: function getBaseEdges(clusteredEdgeId) {
      var IdsToHandle = [clusteredEdgeId];
      var doneIds = [];
      var foundIds = [];
      var max = 100;
      var counter = 0;

      while (IdsToHandle.length > 0 && counter < max) {
        var nextId = IdsToHandle.pop();
        if (nextId === undefined) continue; // Paranoia here and onwards
        var nextEdge = this.body.edges[nextId];
        if (nextEdge === undefined) continue;
        counter++;

        var replacingIds = nextEdge.clusteringEdgeReplacingIds;
        if (replacingIds === undefined) {
          // nextId is a base id
          foundIds.push(nextId);
        } else {
          // Another cluster edge, unravel this one as well
          for (var i = 0; i < replacingIds.length; ++i) {
            var replacingId = replacingIds[i];

            // Don't add if already handled
            // TODO: never triggers; find a test-case which does
            if (IdsToHandle.indexOf(replacingIds) !== -1 || doneIds.indexOf(replacingIds) !== -1) {
              continue;
            }

            IdsToHandle.push(replacingId);
          }
        }

        doneIds.push(nextId);
      }

      return foundIds;
    }

    /**
    * Get the Id the node is connected to
    * @param {vis.Edge} edge
    * @param {Node.id} nodeId
    * @returns {*}
    * @private
    */

  }, {
    key: '_getConnectedId',
    value: function _getConnectedId(edge, nodeId) {
      if (edge.toId != nodeId) {
        return edge.toId;
      } else if (edge.fromId != nodeId) {
        return edge.fromId;
      } else {
        return edge.fromId;
      }
    }

    /**
    * We determine how many connections denote an important hub.
    * We take the mean + 2*std as the important hub size. (Assuming a normal distribution of data, ~2.2%)
    *
    * @returns {number}
    * @private
    */

  }, {
    key: '_getHubSize',
    value: function _getHubSize() {
      var average = 0;
      var averageSquared = 0;
      var hubCounter = 0;
      var largestHub = 0;

      for (var i = 0; i < this.body.nodeIndices.length; i++) {
        var _node = this.body.nodes[this.body.nodeIndices[i]];
        if (_node.edges.length > largestHub) {
          largestHub = _node.edges.length;
        }
        average += _node.edges.length;
        averageSquared += Math.pow(_node.edges.length, 2);
        hubCounter += 1;
      }
      average = average / hubCounter;
      averageSquared = averageSquared / hubCounter;

      var variance = averageSquared - Math.pow(average, 2);
      var standardDeviation = Math.sqrt(variance);

      var hubThreshold = Math.floor(average + 2 * standardDeviation);

      // always have at least one to cluster
      if (hubThreshold > largestHub) {
        hubThreshold = largestHub;
      }

      return hubThreshold;
    }

    /**
     * Create an edge for the cluster representation.
     *
     * @param {Node.id} fromId
     * @param {Node.id} toId
     * @param {vis.Edge} baseEdge
     * @param {Object} clusterEdgeProperties
     * @param {Object} extraOptions
     * @returns {Edge} newly created clustered edge
     * @private
     */

  }, {
    key: '_createClusteredEdge',
    value: function _createClusteredEdge(fromId, toId, baseEdge, clusterEdgeProperties, extraOptions) {
      // copy the options of the edge we will replace
      var clonedOptions = NetworkUtil.cloneOptions(baseEdge, 'edge');
      // make sure the properties of clusterEdges are superimposed on it
      util.deepExtend(clonedOptions, clusterEdgeProperties);

      // set up the edge
      clonedOptions.from = fromId;
      clonedOptions.to = toId;
      clonedOptions.id = 'clusterEdge:' + util.randomUUID();

      // apply the edge specific options to it if specified
      if (extraOptions !== undefined) {
        util.deepExtend(clonedOptions, extraOptions);
      }

      var newEdge = this.body.functions.createEdge(clonedOptions);
      newEdge.clusteringEdgeReplacingIds = [baseEdge.id];
      newEdge.connect();

      // Register the new edge
      this.body.edges[newEdge.id] = newEdge;

      return newEdge;
    }

    /**
     * Add the passed child nodes and edges to the given cluster node.
     *
     * @param {Object|Node} childNodes  hash of nodes or single node to add in cluster
     * @param {Object|Edge} childEdges  hash of edges or single edge to take into account when clustering
     * @param {Node} clusterNode  cluster node to add nodes and edges to
     * @param {Object} [clusterEdgeProperties]
     * @private
     */

  }, {
    key: '_clusterEdges',
    value: function _clusterEdges(childNodes, childEdges, clusterNode, clusterEdgeProperties) {
      if (childEdges instanceof Edge) {
        var edge = childEdges;
        var obj = {};
        obj[edge.id] = edge;
        childEdges = obj;
      }

      if (childNodes instanceof Node) {
        var _node2 = childNodes;
        var _obj = {};
        _obj[_node2.id] = _node2;
        childNodes = _obj;
      }

      if (clusterNode === undefined || clusterNode === null) {
        throw new Error("_clusterEdges: parameter clusterNode required");
      }

      if (clusterEdgeProperties === undefined) {
        // Take the required properties from the cluster node
        clusterEdgeProperties = clusterNode.clusterEdgeProperties;
      }

      // create the new edges that will connect to the cluster.
      // All self-referencing edges will be added to childEdges here.
      this._createClusterEdges(childNodes, childEdges, clusterNode, clusterEdgeProperties);

      // disable the childEdges
      for (var edgeId in childEdges) {
        if (childEdges.hasOwnProperty(edgeId)) {
          if (this.body.edges[edgeId] !== undefined) {
            var _edge2 = this.body.edges[edgeId];
            // cache the options before changing
            this._backupEdgeOptions(_edge2);
            // disable physics and hide the edge
            _edge2.setOptions({ physics: false });
          }
        }
      }

      // disable the childNodes
      for (var _nodeId7 in childNodes) {
        if (childNodes.hasOwnProperty(_nodeId7)) {
          this.clusteredNodes[_nodeId7] = { clusterId: clusterNode.id, node: this.body.nodes[_nodeId7] };
          this.body.nodes[_nodeId7].setOptions({ physics: false });
        }
      }
    }

    /**
     * Determine in which cluster given nodeId resides.
     *
     * If not in cluster, return undefined.
     *
     * NOTE: If you know a cleaner way to do this, please enlighten me (wimrijnders).
     *
     * @param {Node.id} nodeId
     * @returns {Node|undefined} Node instance for cluster, if present
     * @private
     */

  }, {
    key: '_getClusterNodeForNode',
    value: function _getClusterNodeForNode(nodeId) {
      if (nodeId === undefined) return undefined;
      var clusteredNode = this.clusteredNodes[nodeId];

      // NOTE: If no cluster info found, it should actually be an error
      if (clusteredNode === undefined) return undefined;
      var clusterId = clusteredNode.clusterId;
      if (clusterId === undefined) return undefined;

      return this.body.nodes[clusterId];
    }

    /**
     * Internal helper function for conditionally removing items in array
     *
     * Done like this because Array.filter() is not fully supported by all IE's.
     *
     * @param {Array} arr
     * @param {function} callback
     * @returns {Array}
     * @private
     */

  }, {
    key: '_filter',
    value: function _filter(arr, callback) {
      var ret = [];

      util.forEach(arr, function (item) {
        if (callback(item)) {
          ret.push(item);
        }
      });

      return ret;
    }

    /**
     * Scan all edges for changes in clustering and adjust this if necessary.
     *
     * Call this (internally) after there has been a change in node or edge data.
     *
     * Pre: States of this.body.nodes and this.body.edges consistent
     * Pre: this.clusteredNodes and this.clusteredEdge consistent with containedNodes and containedEdges
     *      of cluster nodes.
     */

  }, {
    key: '_updateState',
    value: function _updateState() {
      var _this4 = this;

      var nodeId = void 0;
      var deletedNodeIds = [];
      var deletedEdgeIds = [];

      /**
       * Utility function to iterate over clustering nodes only
       *
       * @param {Function} callback  function to call for each cluster node
       */
      var eachClusterNode = function eachClusterNode(callback) {
        util.forEach(_this4.body.nodes, function (node) {
          if (node.isCluster === true) {
            callback(node);
          }
        });
      };

      //
      // Remove deleted regular nodes from clustering
      //

      // Determine the deleted nodes
      for (nodeId in this.clusteredNodes) {
        if (!this.clusteredNodes.hasOwnProperty(nodeId)) continue;
        var _node3 = this.body.nodes[nodeId];

        if (_node3 === undefined) {
          deletedNodeIds.push(nodeId);
        }
      }

      // Remove nodes from cluster nodes
      eachClusterNode(function (clusterNode) {
        for (var n = 0; n < deletedNodeIds.length; n++) {
          delete clusterNode.containedNodes[deletedNodeIds[n]];
        }
      });

      // Remove nodes from cluster list
      for (var n = 0; n < deletedNodeIds.length; n++) {
        delete this.clusteredNodes[deletedNodeIds[n]];
      }

      //
      // Remove deleted edges from clustering
      //

      // Add the deleted clustered edges to the list
      util.forEach(this.clusteredEdges, function (edgeId) {
        var edge = _this4.body.edges[edgeId];
        if (edge === undefined || !edge.endPointsValid()) {
          deletedEdgeIds.push(edgeId);
        }
      });

      // Cluster nodes can also contain edges which are not clustered, 
      // i.e. nodes 1-2 within cluster with an edge in between.
      // So the cluster nodes also need to be scanned for invalid edges
      eachClusterNode(function (clusterNode) {
        util.forEach(clusterNode.containedEdges, function (edge, edgeId) {
          if (!edge.endPointsValid() && deletedEdgeIds.indexOf(edgeId) === -1) {
            deletedEdgeIds.push(edgeId);
          }
        });
      });

      // Also scan for cluster edges which need to be removed in the active list.
      // Regular edges have been removed beforehand, so this only picks up the cluster edges.
      util.forEach(this.body.edges, function (edge, edgeId) {
        // Explicitly scan the contained edges for validity
        var isValid = true;
        var replacedIds = edge.clusteringEdgeReplacingIds;
        if (replacedIds !== undefined) {
          var numValid = 0;

          util.forEach(replacedIds, function (containedEdgeId) {
            var containedEdge = _this4.body.edges[containedEdgeId];

            if (containedEdge !== undefined && containedEdge.endPointsValid()) {
              numValid += 1;
            }
          });

          isValid = numValid > 0;
        }

        if (!edge.endPointsValid() || !isValid) {
          deletedEdgeIds.push(edgeId);
        }
      });

      // Remove edges from cluster nodes
      eachClusterNode(function (clusterNode) {
        util.forEach(deletedEdgeIds, function (deletedEdgeId) {
          delete clusterNode.containedEdges[deletedEdgeId];

          util.forEach(clusterNode.edges, function (edge, m) {
            if (edge.id === deletedEdgeId) {
              clusterNode.edges[m] = null; // Don't want to directly delete here, because in the loop
              return;
            }

            edge.clusteringEdgeReplacingIds = _this4._filter(edge.clusteringEdgeReplacingIds, function (id) {
              return deletedEdgeIds.indexOf(id) === -1;
            });
          });

          // Clean up the nulls
          clusterNode.edges = _this4._filter(clusterNode.edges, function (item) {
            return item !== null;
          });
        });
      });

      // Remove from cluster list
      util.forEach(deletedEdgeIds, function (edgeId) {
        delete _this4.clusteredEdges[edgeId];
      });

      // Remove cluster edges from active list (this.body.edges).
      // deletedEdgeIds still contains id of regular edges, but these should all
      // be gone when you reach here.
      util.forEach(deletedEdgeIds, function (edgeId) {
        delete _this4.body.edges[edgeId];
      });

      //
      // Check changed cluster state of edges
      //

      // Iterating over keys here, because edges may be removed in the loop
      var ids = (0, _keys2['default'])(this.body.edges);
      util.forEach(ids, function (edgeId) {
        var edge = _this4.body.edges[edgeId];

        var shouldBeClustered = _this4._isClusteredNode(edge.fromId) || _this4._isClusteredNode(edge.toId);
        if (shouldBeClustered === _this4._isClusteredEdge(edge.id)) {
          return; // all is well
        }

        if (shouldBeClustered) {
          // add edge to clustering
          var clusterFrom = _this4._getClusterNodeForNode(edge.fromId);
          if (clusterFrom !== undefined) {
            _this4._clusterEdges(_this4.body.nodes[edge.fromId], edge, clusterFrom);
          }

          var clusterTo = _this4._getClusterNodeForNode(edge.toId);
          if (clusterTo !== undefined) {
            _this4._clusterEdges(_this4.body.nodes[edge.toId], edge, clusterTo);
          }

          // TODO: check that it works for both edges clustered
          //       (This might be paranoia)
        } else {
          // This should not be happening, the state should
          // be properly updated at this point.
          // 
          // If it *is* reached during normal operation, then we have to implement
          // undo clustering for this edge here.
          throw new Error('remove edge from clustering not implemented!');
        }
      });

      // Clusters may be nested to any level. Keep on opening until nothing to open
      var changed = false;
      var continueLoop = true;

      var _loop2 = function _loop2() {
        var clustersToOpen = [];

        // Determine the id's of clusters that need opening
        eachClusterNode(function (clusterNode) {
          var numNodes = (0, _keys2['default'])(clusterNode.containedNodes).length;
          var allowSingle = clusterNode.options.allowSingleNodeCluster === true;
          if (allowSingle && numNodes < 1 || !allowSingle && numNodes < 2) {
            clustersToOpen.push(clusterNode.id);
          }
        });

        // Open them
        for (var _n = 0; _n < clustersToOpen.length; ++_n) {
          _this4.openCluster(clustersToOpen[_n], {}, false /* Don't refresh, we're in an refresh/update already */);
        }

        continueLoop = clustersToOpen.length > 0;
        changed = changed || continueLoop;
      };

      while (continueLoop) {
        _loop2();
      }

      if (changed) {
        this._updateState(); // Redo this method (recursion possible! should be safe)
      }
    }

    /**
     * Determine if node with given id is part of a cluster.
     *
     * @param {Node.id} nodeId
     * @return {boolean} true if part of a cluster.
     */

  }, {
    key: '_isClusteredNode',
    value: function _isClusteredNode(nodeId) {
      return this.clusteredNodes[nodeId] !== undefined;
    }

    /**
     * Determine if edge with given id is not visible due to clustering.
     *
     * An edge is considered clustered if:
     * - it is directly replaced by a clustering edge
     * - any of its connecting nodes is in a cluster
     *
     * @param {vis.Edge.id} edgeId
     * @return {boolean} true if part of a cluster.
     */

  }, {
    key: '_isClusteredEdge',
    value: function _isClusteredEdge(edgeId) {
      return this.clusteredEdges[edgeId] !== undefined;
    }
  }]);
  return ClusterEngine;
}();

exports['default'] = ClusterEngine;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var util = __webpack_require__(2);
var Node = __webpack_require__(47)["default"];

/**
 * A Cluster is a special Node that allows a group of Nodes positioned closely together
 * to be represented by a single Cluster Node.
 *
 * @extends Node
 */

var Cluster = function (_Node) {
  (0, _inherits3["default"])(Cluster, _Node);

  /**
   * @param {Object} options
   * @param {Object} body
   * @param {Array.<HTMLImageElement>}imagelist
   * @param {Array} grouplist
   * @param {Object} globalOptions
   * @param {Object} defaultOptions     Global default options for nodes
   */
  function Cluster(options, body, imagelist, grouplist, globalOptions, defaultOptions) {
    (0, _classCallCheck3["default"])(this, Cluster);

    var _this = (0, _possibleConstructorReturn3["default"])(this, (Cluster.__proto__ || (0, _getPrototypeOf2["default"])(Cluster)).call(this, options, body, imagelist, grouplist, globalOptions, defaultOptions));

    _this.isCluster = true;
    _this.containedNodes = {};
    _this.containedEdges = {};
    return _this;
  }

  /**
   * Transfer child cluster data to current and disconnect the child cluster.
   *
   * Please consult the header comment in 'Clustering.js' for the fields set here.
   *
   * @param {string|number} childClusterId  id of child cluster to open
   */


  (0, _createClass3["default"])(Cluster, [{
    key: "_openChildCluster",
    value: function _openChildCluster(childClusterId) {
      var _this2 = this;

      var childCluster = this.body.nodes[childClusterId];
      if (this.containedNodes[childClusterId] === undefined) {
        throw new Error('node with id: ' + childClusterId + ' not in current cluster');
      }
      if (!childCluster.isCluster) {
        throw new Error('node with id: ' + childClusterId + ' is not a cluster');
      }

      // Disconnect child cluster from current cluster
      delete this.containedNodes[childClusterId];
      util.forEach(childCluster.edges, function (edge) {
        delete _this2.containedEdges[edge.id];
      });

      // Transfer nodes and edges
      util.forEach(childCluster.containedNodes, function (node, nodeId) {
        _this2.containedNodes[nodeId] = node;
      });
      childCluster.containedNodes = {};

      util.forEach(childCluster.containedEdges, function (edge, edgeId) {
        _this2.containedEdges[edgeId] = edge;
      });
      childCluster.containedEdges = {};

      // Transfer edges within cluster edges which are clustered
      util.forEach(childCluster.edges, function (clusterEdge) {
        util.forEach(_this2.edges, function (parentClusterEdge) {
          // Assumption: a clustered edge can only be present in a single clustering edge
          // Not tested here
          var index = parentClusterEdge.clusteringEdgeReplacingIds.indexOf(clusterEdge.id);
          if (index === -1) return;

          util.forEach(clusterEdge.clusteringEdgeReplacingIds, function (srcId) {
            parentClusterEdge.clusteringEdgeReplacingIds.push(srcId);

            // Maintain correct bookkeeping for transferred edge
            _this2.body.edges[srcId].edgeReplacedById = parentClusterEdge.id;
          });

          // Remove cluster edge from parent cluster edge
          parentClusterEdge.clusteringEdgeReplacingIds.splice(index, 1);
        });
      });
      childCluster.edges = [];
    }
  }]);
  return Cluster;
}(Node);

exports["default"] = Cluster;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Initializes window.requestAnimationFrame() to a usable form.
 *
 * Specifically, set up this method for the case of running on node.js with jsdom enabled.
 *
 * NOTES:
 *
 * * On node.js, when calling this directly outside of this class, `window` is not defined.
 *   This happens even if jsdom is used.
 * * For node.js + jsdom, `window` is available at the moment the constructor is called.
 *   For this reason, the called is placed within the constructor.
 * * Even then, `window.requestAnimationFrame()` is not defined, so it still needs to be added.
 * * During unit testing, it happens that the window object is reset during execution, causing
 *   a runtime error due to missing `requestAnimationFrame()`. This needs to be compensated for,
 *   see `_requestNextFrame()`.
 * * Since this is a global object, it may affect other modules besides `Network`. With normal
 *   usage, this does not cause any problems. During unit testing, errors may occur. These have
 *   been compensated for, see comment block in _requestNextFrame().
 *
 * @private
 */
function _initRequestAnimationFrame() {
  var func;

  if (window !== undefined) {
    func = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  }

  if (func === undefined) {
    // window or method not present, setting mock requestAnimationFrame
    window.requestAnimationFrame = function (callback) {
      //console.log("Called mock requestAnimationFrame");
      callback();
    };
  } else {
    window.requestAnimationFrame = func;
  }
}

var util = __webpack_require__(2);

/**
 * The canvas renderer
 */

var CanvasRenderer = function () {
  /**
   * @param {Object} body
   * @param {Canvas} canvas
   */
  function CanvasRenderer(body, canvas) {
    (0, _classCallCheck3["default"])(this, CanvasRenderer);

    _initRequestAnimationFrame();
    this.body = body;
    this.canvas = canvas;

    this.redrawRequested = false;
    this.renderTimer = undefined;
    this.requiresTimeout = true;
    this.renderingActive = false;
    this.renderRequests = 0;
    this.allowRedraw = true;

    this.dragging = false;
    this.options = {};
    this.defaultOptions = {
      hideEdgesOnDrag: false,
      hideNodesOnDrag: false
    };
    util.extend(this.options, this.defaultOptions);

    this._determineBrowserMethod();
    this.bindEventListeners();
  }

  /**
   * Binds event listeners
   */


  (0, _createClass3["default"])(CanvasRenderer, [{
    key: "bindEventListeners",
    value: function bindEventListeners() {
      var _this = this;

      this.body.emitter.on("dragStart", function () {
        _this.dragging = true;
      });
      this.body.emitter.on("dragEnd", function () {
        _this.dragging = false;
      });
      this.body.emitter.on("_resizeNodes", function () {
        _this._resizeNodes();
      });
      this.body.emitter.on("_redraw", function () {
        if (_this.renderingActive === false) {
          _this._redraw();
        }
      });
      this.body.emitter.on("_blockRedraw", function () {
        _this.allowRedraw = false;
      });
      this.body.emitter.on("_allowRedraw", function () {
        _this.allowRedraw = true;_this.redrawRequested = false;
      });
      this.body.emitter.on("_requestRedraw", this._requestRedraw.bind(this));
      this.body.emitter.on("_startRendering", function () {
        _this.renderRequests += 1;
        _this.renderingActive = true;
        _this._startRendering();
      });
      this.body.emitter.on("_stopRendering", function () {
        _this.renderRequests -= 1;
        _this.renderingActive = _this.renderRequests > 0;
        _this.renderTimer = undefined;
      });
      this.body.emitter.on('destroy', function () {
        _this.renderRequests = 0;
        _this.allowRedraw = false;
        _this.renderingActive = false;
        if (_this.requiresTimeout === true) {
          clearTimeout(_this.renderTimer);
        } else {
          window.cancelAnimationFrame(_this.renderTimer);
        }
        _this.body.emitter.off();
      });
    }

    /**
     *
     * @param {Object} options
     */

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      if (options !== undefined) {
        var fields = ['hideEdgesOnDrag', 'hideNodesOnDrag'];
        util.selectiveDeepExtend(fields, this.options, options);
      }
    }

    /**
     * Prepare the drawing of the next frame.
     *
     * Calls the callback when the next frame can or will be drawn.
     *
     * @param {function} callback
     * @param {number} delay - timeout case only, wait this number of milliseconds
     * @returns {function|undefined}
     * @private
     */

  }, {
    key: "_requestNextFrame",
    value: function _requestNextFrame(callback, delay) {
      // During unit testing, it happens that the mock window object is reset while
      // the next frame is still pending. Then, either 'window' is not present, or
      // 'requestAnimationFrame()' is not present because it is not defined on the
      // mock window object.
      //
      // As a consequence, unrelated unit tests may appear to fail, even if the problem
      // described happens in the current unit test.
      //
      // This is not something that will happen in normal operation, but we still need
      // to take it into account.
      //
      if (typeof window === 'undefined') return; // Doing `if (window === undefined)` does not work here!

      var timer = void 0;

      var myWindow = window; // Grab a reference to reduce the possibility that 'window' is reset
      // while running this method.

      if (this.requiresTimeout === true) {
        // wait given number of milliseconds and perform the animation step function
        timer = myWindow.setTimeout(callback, delay);
      } else {
        if (myWindow.requestAnimationFrame) {
          timer = myWindow.requestAnimationFrame(callback);
        }
      }

      return timer;
    }

    /**
     *
     * @private
     */

  }, {
    key: "_startRendering",
    value: function _startRendering() {
      if (this.renderingActive === true) {
        if (this.renderTimer === undefined) {
          this.renderTimer = this._requestNextFrame(this._renderStep.bind(this), this.simulationInterval);
        }
      }
    }

    /**
     *
     * @private
     */

  }, {
    key: "_renderStep",
    value: function _renderStep() {
      if (this.renderingActive === true) {
        // reset the renderTimer so a new scheduled animation step can be set
        this.renderTimer = undefined;

        if (this.requiresTimeout === true) {
          // this schedules a new simulation step
          this._startRendering();
        }

        this._redraw();

        if (this.requiresTimeout === false) {
          // this schedules a new simulation step
          this._startRendering();
        }
      }
    }

    /**
     * Redraw the network with the current data
     * chart will be resized too.
     */

  }, {
    key: "redraw",
    value: function redraw() {
      this.body.emitter.emit('setSize');
      this._redraw();
    }

    /**
     * Redraw the network with the current data
     * @private
     */

  }, {
    key: "_requestRedraw",
    value: function _requestRedraw() {
      var _this2 = this;

      if (this.redrawRequested !== true && this.renderingActive === false && this.allowRedraw === true) {
        this.redrawRequested = true;
        this._requestNextFrame(function () {
          _this2._redraw(false);
        }, 0);
      }
    }

    /**
     * Redraw the network with the current data
     * @param {boolean} [hidden=false] | Used to get the first estimate of the node sizes.
     *                                   Only the nodes are drawn after which they are quickly drawn over.
     * @private
     */

  }, {
    key: "_redraw",
    value: function _redraw() {
      var hidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.allowRedraw === true) {
        this.body.emitter.emit("initRedraw");

        this.redrawRequested = false;

        // when the container div was hidden, this fixes it back up!
        if (this.canvas.frame.canvas.width === 0 || this.canvas.frame.canvas.height === 0) {
          this.canvas.setSize();
        }

        this.canvas.setTransform();

        var ctx = this.canvas.getContext();

        // clear the canvas
        var w = this.canvas.frame.canvas.clientWidth;
        var h = this.canvas.frame.canvas.clientHeight;
        ctx.clearRect(0, 0, w, h);

        // if the div is hidden, we stop the redraw here for performance.
        if (this.canvas.frame.clientWidth === 0) {
          return;
        }

        // set scaling and translation
        ctx.save();
        ctx.translate(this.body.view.translation.x, this.body.view.translation.y);
        ctx.scale(this.body.view.scale, this.body.view.scale);

        ctx.beginPath();
        this.body.emitter.emit("beforeDrawing", ctx);
        ctx.closePath();

        if (hidden === false) {
          if (this.dragging === false || this.dragging === true && this.options.hideEdgesOnDrag === false) {
            this._drawEdges(ctx);
          }
        }

        if (this.dragging === false || this.dragging === true && this.options.hideNodesOnDrag === false) {
          this._drawNodes(ctx, hidden);
        }

        ctx.beginPath();
        this.body.emitter.emit("afterDrawing", ctx);
        ctx.closePath();

        // restore original scaling and translation
        ctx.restore();
        if (hidden === true) {
          ctx.clearRect(0, 0, w, h);
        }
      }
    }

    /**
     * Redraw all nodes
     *
     * @param {CanvasRenderingContext2D}   ctx
     * @param {boolean} [alwaysShow]
     * @private
     */

  }, {
    key: "_resizeNodes",
    value: function _resizeNodes() {
      this.canvas.setTransform();
      var ctx = this.canvas.getContext();
      ctx.save();
      ctx.translate(this.body.view.translation.x, this.body.view.translation.y);
      ctx.scale(this.body.view.scale, this.body.view.scale);

      var nodes = this.body.nodes;
      var node = void 0;

      // resize all nodes
      for (var nodeId in nodes) {
        if (nodes.hasOwnProperty(nodeId)) {
          node = nodes[nodeId];
          node.resize(ctx);
          node.updateBoundingBox(ctx, node.selected);
        }
      }

      // restore original scaling and translation
      ctx.restore();
    }

    /**
     * Redraw all nodes
     *
     * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
     * @param {boolean} [alwaysShow]
     * @private
     */

  }, {
    key: "_drawNodes",
    value: function _drawNodes(ctx) {
      var alwaysShow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var nodes = this.body.nodes;
      var nodeIndices = this.body.nodeIndices;
      var node = void 0;
      var selected = [];
      var margin = 20;
      var topLeft = this.canvas.DOMtoCanvas({ x: -margin, y: -margin });
      var bottomRight = this.canvas.DOMtoCanvas({
        x: this.canvas.frame.canvas.clientWidth + margin,
        y: this.canvas.frame.canvas.clientHeight + margin
      });
      var viewableArea = { top: topLeft.y, left: topLeft.x, bottom: bottomRight.y, right: bottomRight.x };

      // draw unselected nodes;
      for (var i = 0; i < nodeIndices.length; i++) {
        node = nodes[nodeIndices[i]];
        // set selected nodes aside
        if (node.isSelected()) {
          selected.push(nodeIndices[i]);
        } else {
          if (alwaysShow === true) {
            node.draw(ctx);
          } else if (node.isBoundingBoxOverlappingWith(viewableArea) === true) {
            node.draw(ctx);
          } else {
            node.updateBoundingBox(ctx, node.selected);
          }
        }
      }

      // draw the selected nodes on top
      for (var _i = 0; _i < selected.length; _i++) {
        node = nodes[selected[_i]];
        node.draw(ctx);
      }
    }

    /**
     * Redraw all edges
     * @param {CanvasRenderingContext2D} ctx  2D context of a HTML canvas
     * @private
     */

  }, {
    key: "_drawEdges",
    value: function _drawEdges(ctx) {
      var edges = this.body.edges;
      var edgeIndices = this.body.edgeIndices;
      var edge = void 0;

      for (var i = 0; i < edgeIndices.length; i++) {
        edge = edges[edgeIndices[i]];
        if (edge.connected === true) {
          edge.draw(ctx);
        }
      }
    }

    /**
     * Determine if the browser requires a setTimeout or a requestAnimationFrame. This was required because
     * some implementations (safari and IE9) did not support requestAnimationFrame
     * @private
     */

  }, {
    key: "_determineBrowserMethod",
    value: function _determineBrowserMethod() {
      if (typeof window !== 'undefined') {
        var browserType = navigator.userAgent.toLowerCase();
        this.requiresTimeout = false;
        if (browserType.indexOf('msie 9.0') != -1) {
          // IE 9
          this.requiresTimeout = true;
        } else if (browserType.indexOf('safari') != -1) {
          // safari
          if (browserType.indexOf('chrome') <= -1) {
            this.requiresTimeout = true;
          }
        }
      } else {
        this.requiresTimeout = true;
      }
    }
  }]);
  return CanvasRenderer;
}();

exports["default"] = CanvasRenderer;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Hammer = __webpack_require__(10);
var hammerUtil = __webpack_require__(37);

var util = __webpack_require__(2);

/**
 * Create the main frame for the Network.
 * This function is executed once when a Network object is created. The frame
 * contains a canvas, and this canvas contains all objects like the axis and
 * nodes.
 */

var Canvas = function () {
  /**
   * @param {Object} body
   */
  function Canvas(body) {
    (0, _classCallCheck3['default'])(this, Canvas);

    this.body = body;
    this.pixelRatio = 1;
    this.resizeTimer = undefined;
    this.resizeFunction = this._onResize.bind(this);
    this.cameraState = {};
    this.initialized = false;
    this.canvasViewCenter = {};

    this.options = {};
    this.defaultOptions = {
      autoResize: true,
      height: '100%',
      width: '100%'
    };
    util.extend(this.options, this.defaultOptions);

    this.bindEventListeners();
  }

  /**
   * Binds event listeners
   */


  (0, _createClass3['default'])(Canvas, [{
    key: 'bindEventListeners',
    value: function bindEventListeners() {
      var _this = this;

      // bind the events
      this.body.emitter.once("resize", function (obj) {
        if (obj.width !== 0) {
          _this.body.view.translation.x = obj.width * 0.5;
        }
        if (obj.height !== 0) {
          _this.body.view.translation.y = obj.height * 0.5;
        }
      });
      this.body.emitter.on("setSize", this.setSize.bind(this));
      this.body.emitter.on("destroy", function () {
        _this.hammerFrame.destroy();
        _this.hammer.destroy();
        _this._cleanUp();
      });
    }

    /**
     * @param {Object} options
     */

  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      var _this2 = this;

      if (options !== undefined) {
        var fields = ['width', 'height', 'autoResize'];
        util.selectiveDeepExtend(fields, this.options, options);
      }

      if (this.options.autoResize === true) {
        // automatically adapt to a changing size of the browser.
        this._cleanUp();
        this.resizeTimer = setInterval(function () {
          var changed = _this2.setSize();
          if (changed === true) {
            _this2.body.emitter.emit("_requestRedraw");
          }
        }, 1000);
        this.resizeFunction = this._onResize.bind(this);
        util.addEventListener(window, 'resize', this.resizeFunction);
      }
    }

    /**
     * @private
     */

  }, {
    key: '_cleanUp',
    value: function _cleanUp() {
      // automatically adapt to a changing size of the browser.
      if (this.resizeTimer !== undefined) {
        clearInterval(this.resizeTimer);
      }
      util.removeEventListener(window, 'resize', this.resizeFunction);
      this.resizeFunction = undefined;
    }

    /**
     * @private
     */

  }, {
    key: '_onResize',
    value: function _onResize() {
      this.setSize();
      this.body.emitter.emit("_redraw");
    }

    /**
     * Get and store the cameraState
     *
     * @param {number} [pixelRatio=this.pixelRatio]
     * @private
     */

  }, {
    key: '_getCameraState',
    value: function _getCameraState() {
      var pixelRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.pixelRatio;

      if (this.initialized === true) {
        this.cameraState.previousWidth = this.frame.canvas.width / pixelRatio;
        this.cameraState.previousHeight = this.frame.canvas.height / pixelRatio;
        this.cameraState.scale = this.body.view.scale;
        this.cameraState.position = this.DOMtoCanvas({
          x: 0.5 * this.frame.canvas.width / pixelRatio,
          y: 0.5 * this.frame.canvas.height / pixelRatio
        });
      }
    }

    /**
     * Set the cameraState
     * @private
     */

  }, {
    key: '_setCameraState',
    value: function _setCameraState() {
      if (this.cameraState.scale !== undefined && this.frame.canvas.clientWidth !== 0 && this.frame.canvas.clientHeight !== 0 && this.pixelRatio !== 0 && this.cameraState.previousWidth > 0) {

        var widthRatio = this.frame.canvas.width / this.pixelRatio / this.cameraState.previousWidth;
        var heightRatio = this.frame.canvas.height / this.pixelRatio / this.cameraState.previousHeight;
        var newScale = this.cameraState.scale;

        if (widthRatio != 1 && heightRatio != 1) {
          newScale = this.cameraState.scale * 0.5 * (widthRatio + heightRatio);
        } else if (widthRatio != 1) {
          newScale = this.cameraState.scale * widthRatio;
        } else if (heightRatio != 1) {
          newScale = this.cameraState.scale * heightRatio;
        }

        this.body.view.scale = newScale;
        // this comes from the view module.
        var currentViewCenter = this.DOMtoCanvas({
          x: 0.5 * this.frame.canvas.clientWidth,
          y: 0.5 * this.frame.canvas.clientHeight
        });

        var distanceFromCenter = { // offset from view, distance view has to change by these x and y to center the node
          x: currentViewCenter.x - this.cameraState.position.x,
          y: currentViewCenter.y - this.cameraState.position.y
        };
        this.body.view.translation.x += distanceFromCenter.x * this.body.view.scale;
        this.body.view.translation.y += distanceFromCenter.y * this.body.view.scale;
      }
    }

    /**
     *
     * @param {number|string} value
     * @returns {string}
     * @private
     */

  }, {
    key: '_prepareValue',
    value: function _prepareValue(value) {
      if (typeof value === 'number') {
        return value + 'px';
      } else if (typeof value === 'string') {
        if (value.indexOf('%') !== -1 || value.indexOf('px') !== -1) {
          return value;
        } else if (value.indexOf('%') === -1) {
          return value + 'px';
        }
      }
      throw new Error('Could not use the value supplied for width or height:' + value);
    }

    /**
     * Create the HTML
     */

  }, {
    key: '_create',
    value: function _create() {
      // remove all elements from the container element.
      while (this.body.container.hasChildNodes()) {
        this.body.container.removeChild(this.body.container.firstChild);
      }

      this.frame = document.createElement('div');
      this.frame.className = 'vis-network';
      this.frame.style.position = 'relative';
      this.frame.style.overflow = 'hidden';
      this.frame.tabIndex = 900; // tab index is required for keycharm to bind keystrokes to the div instead of the window

      //////////////////////////////////////////////////////////////////

      this.frame.canvas = document.createElement("canvas");
      this.frame.canvas.style.position = 'relative';
      this.frame.appendChild(this.frame.canvas);

      if (!this.frame.canvas.getContext) {
        var noCanvas = document.createElement('DIV');
        noCanvas.style.color = 'red';
        noCanvas.style.fontWeight = 'bold';
        noCanvas.style.padding = '10px';
        noCanvas.innerHTML = 'Error: your browser does not support HTML canvas';
        this.frame.canvas.appendChild(noCanvas);
      } else {
        this._setPixelRatio();
        this.setTransform();
      }

      // add the frame to the container element
      this.body.container.appendChild(this.frame);

      this.body.view.scale = 1;
      this.body.view.translation = { x: 0.5 * this.frame.canvas.clientWidth, y: 0.5 * this.frame.canvas.clientHeight };

      this._bindHammer();
    }

    /**
     * This function binds hammer, it can be repeated over and over due to the uniqueness check.
     * @private
     */

  }, {
    key: '_bindHammer',
    value: function _bindHammer() {
      var _this3 = this;

      if (this.hammer !== undefined) {
        this.hammer.destroy();
      }
      this.drag = {};
      this.pinch = {};

      // init hammer
      this.hammer = new Hammer(this.frame.canvas);
      this.hammer.get('pinch').set({ enable: true });
      // enable to get better response, todo: test on mobile.
      this.hammer.get('pan').set({ threshold: 5, direction: Hammer.DIRECTION_ALL });

      hammerUtil.onTouch(this.hammer, function (event) {
        _this3.body.eventListeners.onTouch(event);
      });
      this.hammer.on('tap', function (event) {
        _this3.body.eventListeners.onTap(event);
      });
      this.hammer.on('doubletap', function (event) {
        _this3.body.eventListeners.onDoubleTap(event);
      });
      this.hammer.on('press', function (event) {
        _this3.body.eventListeners.onHold(event);
      });
      this.hammer.on('panstart', function (event) {
        _this3.body.eventListeners.onDragStart(event);
      });
      this.hammer.on('panmove', function (event) {
        _this3.body.eventListeners.onDrag(event);
      });
      this.hammer.on('panend', function (event) {
        _this3.body.eventListeners.onDragEnd(event);
      });
      this.hammer.on('pinch', function (event) {
        _this3.body.eventListeners.onPinch(event);
      });

      // TODO: neatly cleanup these handlers when re-creating the Canvas, IF these are done with hammer, event.stopPropagation will not work?
      this.frame.canvas.addEventListener('mousewheel', function (event) {
        _this3.body.eventListeners.onMouseWheel(event);
      });
      this.frame.canvas.addEventListener('DOMMouseScroll', function (event) {
        _this3.body.eventListeners.onMouseWheel(event);
      });

      this.frame.canvas.addEventListener('mousemove', function (event) {
        _this3.body.eventListeners.onMouseMove(event);
      });
      this.frame.canvas.addEventListener('contextmenu', function (event) {
        _this3.body.eventListeners.onContext(event);
      });

      this.hammerFrame = new Hammer(this.frame);
      hammerUtil.onRelease(this.hammerFrame, function (event) {
        _this3.body.eventListeners.onRelease(event);
      });
    }

    /**
     * Set a new size for the network
     * @param {string} width   Width in pixels or percentage (for example '800px'
     *                         or '50%')
     * @param {string} height  Height in pixels or percentage  (for example '400px'
     *                         or '30%')
     * @returns {boolean}
     */

  }, {
    key: 'setSize',
    value: function setSize() {
      var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.width;
      var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.height;

      width = this._prepareValue(width);
      height = this._prepareValue(height);

      var emitEvent = false;
      var oldWidth = this.frame.canvas.width;
      var oldHeight = this.frame.canvas.height;

      // update the pixel ratio
      //
      // NOTE: Comment in following is rather inconsistent; this is the ONLY place in the code
      //       where it is assumed that the pixel ratio could change at runtime.
      //       The only way I can think of this happening is a rotating screen or tablet; but then
      //       there should be a mechanism for reloading the data (TODO: check if this is present).
      //
      //       If the assumption is true (i.e. pixel ratio can change at runtime), then *all* usage
      //       of pixel ratio must be overhauled for this.
      //
      //       For the time being, I will humor the assumption here, and in the rest of the code assume it is
      //       constant.
      var previousRatio = this.pixelRatio; // we cache this because the camera state storage needs the old value
      this._setPixelRatio();

      if (width != this.options.width || height != this.options.height || this.frame.style.width != width || this.frame.style.height != height) {
        this._getCameraState(previousRatio);

        this.frame.style.width = width;
        this.frame.style.height = height;

        this.frame.canvas.style.width = '100%';
        this.frame.canvas.style.height = '100%';

        this.frame.canvas.width = Math.round(this.frame.canvas.clientWidth * this.pixelRatio);
        this.frame.canvas.height = Math.round(this.frame.canvas.clientHeight * this.pixelRatio);

        this.options.width = width;
        this.options.height = height;

        this.canvasViewCenter = {
          x: 0.5 * this.frame.clientWidth,
          y: 0.5 * this.frame.clientHeight
        };

        emitEvent = true;
      } else {
        // this would adapt the width of the canvas to the width from 100% if and only if
        // there is a change.

        var newWidth = Math.round(this.frame.canvas.clientWidth * this.pixelRatio);
        var newHeight = Math.round(this.frame.canvas.clientHeight * this.pixelRatio);

        // store the camera if there is a change in size.
        if (this.frame.canvas.width !== newWidth || this.frame.canvas.height !== newHeight) {
          this._getCameraState(previousRatio);
        }

        if (this.frame.canvas.width !== newWidth) {
          this.frame.canvas.width = newWidth;
          emitEvent = true;
        }
        if (this.frame.canvas.height !== newHeight) {
          this.frame.canvas.height = newHeight;
          emitEvent = true;
        }
      }

      if (emitEvent === true) {
        this.body.emitter.emit('resize', {
          width: Math.round(this.frame.canvas.width / this.pixelRatio),
          height: Math.round(this.frame.canvas.height / this.pixelRatio),
          oldWidth: Math.round(oldWidth / this.pixelRatio),
          oldHeight: Math.round(oldHeight / this.pixelRatio)
        });

        // restore the camera on change.
        this._setCameraState();
      }

      // set initialized so the get and set camera will work from now on.
      this.initialized = true;
      return emitEvent;
    }

    /**
     *
     * @returns {CanvasRenderingContext2D}
     */

  }, {
    key: 'getContext',
    value: function getContext() {
      return this.frame.canvas.getContext("2d");
    }

    /**
     * Determine the pixel ratio for various browsers.
     *
     * @returns {number}
     * @private
     */

  }, {
    key: '_determinePixelRatio',
    value: function _determinePixelRatio() {
      var ctx = this.getContext();
      if (ctx === undefined) {
        throw new Error("Could not get canvax context");
      }

      var numerator = 1;
      if (typeof window !== 'undefined') {
        // (window !== undefined) doesn't work here!
        // Protection during unit tests, where 'window' can be missing
        numerator = window.devicePixelRatio || 1;
      }

      var denominator = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;

      return numerator / denominator;
    }

    /**
     * Lazy determination of pixel ratio.
     *
     * @private
     */

  }, {
    key: '_setPixelRatio',
    value: function _setPixelRatio() {
      this.pixelRatio = this._determinePixelRatio();
    }

    /**
     * Set the transform in the contained context, based on its pixelRatio
     */

  }, {
    key: 'setTransform',
    value: function setTransform() {
      var ctx = this.getContext();
      if (ctx === undefined) {
        throw new Error("Could not get canvax context");
      }

      ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
    }

    /**
     * Convert the X coordinate in DOM-space (coordinate point in browser relative to the container div) to
     * the X coordinate in canvas-space (the simulation sandbox, which the camera looks upon)
     * @param {number} x
     * @returns {number}
     * @private
     */

  }, {
    key: '_XconvertDOMtoCanvas',
    value: function _XconvertDOMtoCanvas(x) {
      return (x - this.body.view.translation.x) / this.body.view.scale;
    }

    /**
     * Convert the X coordinate in canvas-space (the simulation sandbox, which the camera looks upon) to
     * the X coordinate in DOM-space (coordinate point in browser relative to the container div)
     * @param {number} x
     * @returns {number}
     * @private
     */

  }, {
    key: '_XconvertCanvasToDOM',
    value: function _XconvertCanvasToDOM(x) {
      return x * this.body.view.scale + this.body.view.translation.x;
    }

    /**
     * Convert the Y coordinate in DOM-space (coordinate point in browser relative to the container div) to
     * the Y coordinate in canvas-space (the simulation sandbox, which the camera looks upon)
     * @param {number} y
     * @returns {number}
     * @private
     */

  }, {
    key: '_YconvertDOMtoCanvas',
    value: function _YconvertDOMtoCanvas(y) {
      return (y - this.body.view.translation.y) / this.body.view.scale;
    }

    /**
     * Convert the Y coordinate in canvas-space (the simulation sandbox, which the camera looks upon) to
     * the Y coordinate in DOM-space (coordinate point in browser relative to the container div)
     * @param {number} y
     * @returns {number}
     * @private
     */

  }, {
    key: '_YconvertCanvasToDOM',
    value: function _YconvertCanvasToDOM(y) {
      return y * this.body.view.scale + this.body.view.translation.y;
    }

    /**
     * @param {point} pos
     * @returns {point}
     */

  }, {
    key: 'canvasToDOM',
    value: function canvasToDOM(pos) {
      return { x: this._XconvertCanvasToDOM(pos.x), y: this._YconvertCanvasToDOM(pos.y) };
    }

    /**
     *
     * @param {point} pos
     * @returns {point}
     */

  }, {
    key: 'DOMtoCanvas',
    value: function DOMtoCanvas(pos) {
      return { x: this._XconvertDOMtoCanvas(pos.x), y: this._YconvertDOMtoCanvas(pos.y) };
    }
  }]);
  return Canvas;
}();

exports['default'] = Canvas;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);

var NetworkUtil = __webpack_require__(76)['default'];

/**
 * The view
 */

var View = function () {
  /**
   * @param {Object} body
   * @param {Canvas} canvas
   */
  function View(body, canvas) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, View);

    this.body = body;
    this.canvas = canvas;

    this.animationSpeed = 1 / this.renderRefreshRate;
    this.animationEasingFunction = "easeInOutQuint";
    this.easingTime = 0;
    this.sourceScale = 0;
    this.targetScale = 0;
    this.sourceTranslation = 0;
    this.targetTranslation = 0;
    this.lockedOnNodeId = undefined;
    this.lockedOnNodeOffset = undefined;
    this.touchTime = 0;

    this.viewFunction = undefined;

    this.body.emitter.on("fit", this.fit.bind(this));
    this.body.emitter.on("animationFinished", function () {
      _this.body.emitter.emit("_stopRendering");
    });
    this.body.emitter.on("unlockNode", this.releaseNode.bind(this));
  }

  /**
   *
   * @param {Object} [options={}]
   */


  (0, _createClass3['default'])(View, [{
    key: 'setOptions',
    value: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.options = options;
    }

    /**
     * This function zooms out to fit all data on screen based on amount of nodes
     * @param {Object} [options={{nodes=Array}}]
     * @param {boolean} [initialZoom=false]  | zoom based on fitted formula or range, true = fitted, default = false;
     */

  }, {
    key: 'fit',
    value: function fit() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { nodes: [] };
      var initialZoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var range = void 0;
      var zoomLevel = void 0;
      if (options.nodes === undefined || options.nodes.length === 0) {
        options.nodes = this.body.nodeIndices;
      }

      if (initialZoom === true) {
        // check if more than half of the nodes have a predefined position. If so, we use the range, not the approximation.
        var positionDefined = 0;
        for (var nodeId in this.body.nodes) {
          if (this.body.nodes.hasOwnProperty(nodeId)) {
            var node = this.body.nodes[nodeId];
            if (node.predefinedPosition === true) {
              positionDefined += 1;
            }
          }
        }
        if (positionDefined > 0.5 * this.body.nodeIndices.length) {
          this.fit(options, false);
          return;
        }

        range = NetworkUtil.getRange(this.body.nodes, options.nodes);

        var numberOfNodes = this.body.nodeIndices.length;
        zoomLevel = 12.662 / (numberOfNodes + 7.4147) + 0.0964822; // this is obtained from fitting a dataset from 5 points with scale levels that looked good.

        // correct for larger canvasses.
        var factor = Math.min(this.canvas.frame.canvas.clientWidth / 600, this.canvas.frame.canvas.clientHeight / 600);
        zoomLevel *= factor;
      } else {
        this.body.emitter.emit("_resizeNodes");
        range = NetworkUtil.getRange(this.body.nodes, options.nodes);

        var xDistance = Math.abs(range.maxX - range.minX) * 1.1;
        var yDistance = Math.abs(range.maxY - range.minY) * 1.1;

        var xZoomLevel = this.canvas.frame.canvas.clientWidth / xDistance;
        var yZoomLevel = this.canvas.frame.canvas.clientHeight / yDistance;

        zoomLevel = xZoomLevel <= yZoomLevel ? xZoomLevel : yZoomLevel;
      }

      if (zoomLevel > 1.0) {
        zoomLevel = 1.0;
      } else if (zoomLevel === 0) {
        zoomLevel = 1.0;
      }

      var center = NetworkUtil.findCenter(range);
      var animationOptions = { position: center, scale: zoomLevel, animation: options.animation };
      this.moveTo(animationOptions);
    }

    // animation

    /**
     * Center a node in view.
     *
     * @param {number} nodeId
     * @param {number} [options]
     */

  }, {
    key: 'focus',
    value: function focus(nodeId) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.body.nodes[nodeId] !== undefined) {
        var nodePosition = { x: this.body.nodes[nodeId].x, y: this.body.nodes[nodeId].y };
        options.position = nodePosition;
        options.lockedOnNode = nodeId;

        this.moveTo(options);
      } else {
        console.log("Node: " + nodeId + " cannot be found.");
      }
    }

    /**
     *
     * @param {Object} options  |  options.offset   = {x:number, y:number}   // offset from the center in DOM pixels
     *                          |  options.scale    = number                 // scale to move to
     *                          |  options.position = {x:number, y:number}   // position to move to
     *                          |  options.animation = {duration:number, easingFunction:String} || Boolean   // position to move to
     */

  }, {
    key: 'moveTo',
    value: function moveTo(options) {
      if (options === undefined) {
        options = {};
        return;
      }
      if (options.offset === undefined) {
        options.offset = { x: 0, y: 0 };
      }
      if (options.offset.x === undefined) {
        options.offset.x = 0;
      }
      if (options.offset.y === undefined) {
        options.offset.y = 0;
      }
      if (options.scale === undefined) {
        options.scale = this.body.view.scale;
      }
      if (options.position === undefined) {
        options.position = this.getViewPosition();
      }
      if (options.animation === undefined) {
        options.animation = { duration: 0 };
      }
      if (options.animation === false) {
        options.animation = { duration: 0 };
      }
      if (options.animation === true) {
        options.animation = {};
      }
      if (options.animation.duration === undefined) {
        options.animation.duration = 1000;
      } // default duration
      if (options.animation.easingFunction === undefined) {
        options.animation.easingFunction = "easeInOutQuad";
      } // default easing function

      this.animateView(options);
    }

    /**
     *
     * @param {Object} options  |  options.offset   = {x:number, y:number}   // offset from the center in DOM pixels
     *                          |  options.time     = number                 // animation time in milliseconds
     *                          |  options.scale    = number                 // scale to animate to
     *                          |  options.position = {x:number, y:number}   // position to animate to
     *                          |  options.easingFunction = String           // linear, easeInQuad, easeOutQuad, easeInOutQuad,
     *                                                                       // easeInCubic, easeOutCubic, easeInOutCubic,
     *                                                                       // easeInQuart, easeOutQuart, easeInOutQuart,
     *                                                                       // easeInQuint, easeOutQuint, easeInOutQuint
     */

  }, {
    key: 'animateView',
    value: function animateView(options) {
      if (options === undefined) {
        return;
      }
      this.animationEasingFunction = options.animation.easingFunction;
      // release if something focussed on the node
      this.releaseNode();
      if (options.locked === true) {
        this.lockedOnNodeId = options.lockedOnNode;
        this.lockedOnNodeOffset = options.offset;
      }

      // forcefully complete the old animation if it was still running
      if (this.easingTime != 0) {
        this._transitionRedraw(true); // by setting easingtime to 1, we finish the animation.
      }

      this.sourceScale = this.body.view.scale;
      this.sourceTranslation = this.body.view.translation;
      this.targetScale = options.scale;

      // set the scale so the viewCenter is based on the correct zoom level. This is overridden in the transitionRedraw
      // but at least then we'll have the target transition
      this.body.view.scale = this.targetScale;
      var viewCenter = this.canvas.DOMtoCanvas({ x: 0.5 * this.canvas.frame.canvas.clientWidth, y: 0.5 * this.canvas.frame.canvas.clientHeight });

      var distanceFromCenter = { // offset from view, distance view has to change by these x and y to center the node
        x: viewCenter.x - options.position.x,
        y: viewCenter.y - options.position.y
      };
      this.targetTranslation = {
        x: this.sourceTranslation.x + distanceFromCenter.x * this.targetScale + options.offset.x,
        y: this.sourceTranslation.y + distanceFromCenter.y * this.targetScale + options.offset.y
      };

      // if the time is set to 0, don't do an animation
      if (options.animation.duration === 0) {
        if (this.lockedOnNodeId != undefined) {
          this.viewFunction = this._lockedRedraw.bind(this);
          this.body.emitter.on("initRedraw", this.viewFunction);
        } else {
          this.body.view.scale = this.targetScale;
          this.body.view.translation = this.targetTranslation;
          this.body.emitter.emit("_requestRedraw");
        }
      } else {
        this.animationSpeed = 1 / (60 * options.animation.duration * 0.001) || 1 / 60; // 60 for 60 seconds, 0.001 for milli's
        this.animationEasingFunction = options.animation.easingFunction;

        this.viewFunction = this._transitionRedraw.bind(this);
        this.body.emitter.on("initRedraw", this.viewFunction);
        this.body.emitter.emit("_startRendering");
      }
    }

    /**
     * used to animate smoothly by hijacking the redraw function.
     * @private
     */

  }, {
    key: '_lockedRedraw',
    value: function _lockedRedraw() {
      var nodePosition = { x: this.body.nodes[this.lockedOnNodeId].x, y: this.body.nodes[this.lockedOnNodeId].y };
      var viewCenter = this.canvas.DOMtoCanvas({ x: 0.5 * this.canvas.frame.canvas.clientWidth, y: 0.5 * this.canvas.frame.canvas.clientHeight });
      var distanceFromCenter = { // offset from view, distance view has to change by these x and y to center the node
        x: viewCenter.x - nodePosition.x,
        y: viewCenter.y - nodePosition.y
      };
      var sourceTranslation = this.body.view.translation;
      var targetTranslation = {
        x: sourceTranslation.x + distanceFromCenter.x * this.body.view.scale + this.lockedOnNodeOffset.x,
        y: sourceTranslation.y + distanceFromCenter.y * this.body.view.scale + this.lockedOnNodeOffset.y
      };

      this.body.view.translation = targetTranslation;
    }

    /**
     * Resets state of a locked on Node
     */

  }, {
    key: 'releaseNode',
    value: function releaseNode() {
      if (this.lockedOnNodeId !== undefined && this.viewFunction !== undefined) {
        this.body.emitter.off("initRedraw", this.viewFunction);
        this.lockedOnNodeId = undefined;
        this.lockedOnNodeOffset = undefined;
      }
    }

    /**
     * @param {boolean} [finished=false]
     * @private
     */

  }, {
    key: '_transitionRedraw',
    value: function _transitionRedraw() {
      var finished = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.easingTime += this.animationSpeed;
      this.easingTime = finished === true ? 1.0 : this.easingTime;

      var progress = util.easingFunctions[this.animationEasingFunction](this.easingTime);

      this.body.view.scale = this.sourceScale + (this.targetScale - this.sourceScale) * progress;
      this.body.view.translation = {
        x: this.sourceTranslation.x + (this.targetTranslation.x - this.sourceTranslation.x) * progress,
        y: this.sourceTranslation.y + (this.targetTranslation.y - this.sourceTranslation.y) * progress
      };

      // cleanup
      if (this.easingTime >= 1.0) {
        this.body.emitter.off("initRedraw", this.viewFunction);
        this.easingTime = 0;
        if (this.lockedOnNodeId != undefined) {
          this.viewFunction = this._lockedRedraw.bind(this);
          this.body.emitter.on("initRedraw", this.viewFunction);
        }
        this.body.emitter.emit("animationFinished");
      }
    }

    /**
     *
     * @returns {number}
     */

  }, {
    key: 'getScale',
    value: function getScale() {
      return this.body.view.scale;
    }

    /**
     *
     * @returns {{x: number, y: number}}
     */

  }, {
    key: 'getViewPosition',
    value: function getViewPosition() {
      return this.canvas.DOMtoCanvas({ x: 0.5 * this.canvas.frame.canvas.clientWidth, y: 0.5 * this.canvas.frame.canvas.clientHeight });
    }
  }]);
  return View;
}();

exports['default'] = View;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var NavigationHandler = __webpack_require__(233)['default'];
var Popup = __webpack_require__(104)['default'];

/**
 * Handler for interactions
 */

var InteractionHandler = function () {
  /**
   * @param {Object} body
   * @param {Canvas} canvas
   * @param {SelectionHandler} selectionHandler
   */
  function InteractionHandler(body, canvas, selectionHandler) {
    (0, _classCallCheck3['default'])(this, InteractionHandler);

    this.body = body;
    this.canvas = canvas;
    this.selectionHandler = selectionHandler;
    this.navigationHandler = new NavigationHandler(body, canvas);

    // bind the events from hammer to functions in this object
    this.body.eventListeners.onTap = this.onTap.bind(this);
    this.body.eventListeners.onTouch = this.onTouch.bind(this);
    this.body.eventListeners.onDoubleTap = this.onDoubleTap.bind(this);
    this.body.eventListeners.onHold = this.onHold.bind(this);
    this.body.eventListeners.onDragStart = this.onDragStart.bind(this);
    this.body.eventListeners.onDrag = this.onDrag.bind(this);
    this.body.eventListeners.onDragEnd = this.onDragEnd.bind(this);
    this.body.eventListeners.onMouseWheel = this.onMouseWheel.bind(this);
    this.body.eventListeners.onPinch = this.onPinch.bind(this);
    this.body.eventListeners.onMouseMove = this.onMouseMove.bind(this);
    this.body.eventListeners.onRelease = this.onRelease.bind(this);
    this.body.eventListeners.onContext = this.onContext.bind(this);

    this.touchTime = 0;
    this.drag = {};
    this.pinch = {};
    this.popup = undefined;
    this.popupObj = undefined;
    this.popupTimer = undefined;

    this.body.functions.getPointer = this.getPointer.bind(this);

    this.options = {};
    this.defaultOptions = {
      dragNodes: true,
      dragView: true,
      hover: false,
      keyboard: {
        enabled: false,
        speed: { x: 10, y: 10, zoom: 0.02 },
        bindToWindow: true
      },
      navigationButtons: false,
      tooltipDelay: 300,
      zoomView: true
    };
    util.extend(this.options, this.defaultOptions);

    this.bindEventListeners();
  }

  /**
   * Binds event listeners
   */


  (0, _createClass3['default'])(InteractionHandler, [{
    key: 'bindEventListeners',
    value: function bindEventListeners() {
      var _this = this;

      this.body.emitter.on('destroy', function () {
        clearTimeout(_this.popupTimer);
        delete _this.body.functions.getPointer;
      });
    }

    /**
     *
     * @param {Object} options
     */

  }, {
    key: 'setOptions',
    value: function setOptions(options) {
      if (options !== undefined) {
        // extend all but the values in fields
        var fields = ['hideEdgesOnDrag', 'hideNodesOnDrag', 'keyboard', 'multiselect', 'selectable', 'selectConnectedEdges'];
        util.selectiveNotDeepExtend(fields, this.options, options);

        // merge the keyboard options in.
        util.mergeOptions(this.options, options, 'keyboard');

        if (options.tooltip) {
          util.extend(this.options.tooltip, options.tooltip);
          if (options.tooltip.color) {
            this.options.tooltip.color = util.parseColor(options.tooltip.color);
          }
        }
      }

      this.navigationHandler.setOptions(this.options);
    }

    /**
     * Get the pointer location from a touch location
     * @param {{x: number, y: number}} touch
     * @return {{x: number, y: number}} pointer
     * @private
     */

  }, {
    key: 'getPointer',
    value: function getPointer(touch) {
      return {
        x: touch.x - util.getAbsoluteLeft(this.canvas.frame.canvas),
        y: touch.y - util.getAbsoluteTop(this.canvas.frame.canvas)
      };
    }

    /**
     * On start of a touch gesture, store the pointer
     * @param {Event}  event   The event
     * @private
     */

  }, {
    key: 'onTouch',
    value: function onTouch(event) {
      if (new Date().valueOf() - this.touchTime > 50) {
        this.drag.pointer = this.getPointer(event.center);
        this.drag.pinched = false;
        this.pinch.scale = this.body.view.scale;
        // to avoid double fireing of this event because we have two hammer instances. (on canvas and on frame)
        this.touchTime = new Date().valueOf();
      }
    }

    /**
     * handle tap/click event: select/unselect a node
     * @param {Event} event
     * @private
     */

  }, {
    key: 'onTap',
    value: function onTap(event) {
      var pointer = this.getPointer(event.center);
      var multiselect = this.selectionHandler.options.multiselect && (event.changedPointers[0].ctrlKey || event.changedPointers[0].metaKey);

      this.checkSelectionChanges(pointer, event, multiselect);
      this.selectionHandler._generateClickEvent('click', event, pointer);
    }

    /**
     * handle doubletap event
     * @param {Event} event
     * @private
     */

  }, {
    key: 'onDoubleTap',
    value: function onDoubleTap(event) {
      var pointer = this.getPointer(event.center);
      this.selectionHandler._generateClickEvent('doubleClick', event, pointer);
    }

    /**
     * handle long tap event: multi select nodes
     * @param {Event} event
     * @private
     */

  }, {
    key: 'onHold',
    value: function onHold(event) {
      var pointer = this.getPointer(event.center);
      var multiselect = this.selectionHandler.options.multiselect;

      this.checkSelectionChanges(pointer, event, multiselect);

      this.selectionHandler._generateClickEvent('click', event, pointer);
      this.selectionHandler._generateClickEvent('hold', event, pointer);
    }

    /**
     * handle the release of the screen
     *
     * @param {Event} event
     * @private
     */

  }, {
    key: 'onRelease',
    value: function onRelease(event) {
      if (new Date().valueOf() - this.touchTime > 10) {
        var pointer = this.getPointer(event.center);
        this.selectionHandler._generateClickEvent('release', event, pointer);
        // to avoid double fireing of this event because we have two hammer instances. (on canvas and on frame)
        this.touchTime = new Date().valueOf();
      }
    }

    /**
     *
     * @param {Event} event
     */

  }, {
    key: 'onContext',
    value: function onContext(event) {
      var pointer = this.getPointer({ x: event.clientX, y: event.clientY });
      this.selectionHandler._generateClickEvent('oncontext', event, pointer);
    }

    /**
     * Select and deselect nodes depending current selection change.
     *
     * For changing nodes, select/deselect events are fired.
     *
     * NOTE: For a given edge, if one connecting node is deselected and with the same
     *       click the other node is selected, no events for the edge will fire.
     *       It was selected and it will remain selected.
     *
     * TODO: This is all SelectionHandler calls; the method should be moved to there.
     *
     * @param {{x: number, y: number}} pointer
     * @param {Event} event
     * @param {boolean} [add=false]
     */

  }, {
    key: 'checkSelectionChanges',
    value: function checkSelectionChanges(pointer, event) {
      var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var previousSelection = this.selectionHandler.getSelection();
      var selected = false;
      if (add === true) {
        selected = this.selectionHandler.selectAdditionalOnPoint(pointer);
      } else {
        selected = this.selectionHandler.selectOnPoint(pointer);
      }
      var currentSelection = this.selectionHandler.getSelection();

      // See NOTE in method comment for the reason to do it like this
      var deselectedItems = this._determineDifference(previousSelection, currentSelection);
      var selectedItems = this._determineDifference(currentSelection, previousSelection);

      if (deselectedItems.edges.length > 0) {
        this.selectionHandler._generateClickEvent('deselectEdge', event, pointer, previousSelection);
        selected = true;
      }

      if (deselectedItems.nodes.length > 0) {
        this.selectionHandler._generateClickEvent('deselectNode', event, pointer, previousSelection);
        selected = true;
      }

      if (selectedItems.nodes.length > 0) {
        this.selectionHandler._generateClickEvent('selectNode', event, pointer);
        selected = true;
      }

      if (selectedItems.edges.length > 0) {
        this.selectionHandler._generateClickEvent('selectEdge', event, pointer);
        selected = true;
      }

      // fire the select event if anything has been selected or deselected
      if (selected === true) {
        // select or unselect
        this.selectionHandler._generateClickEvent('select', event, pointer);
      }
    }

    /**
     * Remove all node and edge id's from the first set that are present in the second one.
     *
     * @param {{nodes: Array.<Node>, edges: Array.<vis.Edge>}} firstSet
     * @param {{nodes: Array.<Node>, edges: Array.<vis.Edge>}} secondSet
     * @returns {{nodes: Array.<Node>, edges: Array.<vis.Edge>}}
     * @private
     */

  }, {
    key: '_determineDifference',
    value: function _determineDifference(firstSet, secondSet) {
      var arrayDiff = function arrayDiff(firstArr, secondArr) {
        var result = [];

        for (var i = 0; i < firstArr.length; i++) {
          var value = firstArr[i];
          if (secondArr.indexOf(value) === -1) {
            result.push(value);
          }
        }

        return result;
      };

      return {
        nodes: arrayDiff(firstSet.nodes, secondSet.nodes),
        edges: arrayDiff(firstSet.edges, secondSet.edges)
      };
    }

    /**
     * This function is called by onDragStart.
     * It is separated out because we can then overload it for the datamanipulation system.
     *
     * @param {Event} event
     * @private
     */

  }, {
    key: 'onDragStart',
    value: function onDragStart(event) {
      //in case the touch event was triggered on an external div, do the initial touch now.
      if (this.drag.pointer === undefined) {
        this.onTouch(event);
      }

      // note: drag.pointer is set in onTouch to get the initial touch location
      var node = this.selectionHandler.getNodeAt(this.drag.pointer);

      this.drag.dragging = true;
      this.drag.selection = [];
      this.drag.translation = util.extend({}, this.body.view.translation); // copy the object
      this.drag.nodeId = undefined;

      if (node !== undefined && this.options.dragNodes === true) {
        this.drag.nodeId = node.id;
        // select the clicked node if not yet selected
        if (node.isSelected() === false) {
          this.selectionHandler.unselectAll();
          this.selectionHandler.selectObject(node);
        }

        // after select to contain the node
        this.selectionHandler._generateClickEvent('dragStart', event, this.drag.pointer);

        var selection = this.selectionHandler.selectionObj.nodes;
        // create an array with the selected nodes and their original location and status
        for (var nodeId in selection) {
          if (selection.hasOwnProperty(nodeId)) {
            var object = selection[nodeId];
            var s = {
              id: object.id,
              node: object,

              // store original x, y, xFixed and yFixed, make the node temporarily Fixed
              x: object.x,
              y: object.y,
              xFixed: object.options.fixed.x,
              yFixed: object.options.fixed.y
            };

            object.options.fixed.x = true;
            object.options.fixed.y = true;

            this.drag.selection.push(s);
          }
        }
      } else {
        // fallback if no node is selected and thus the view is dragged.
        this.selectionHandler._generateClickEvent('dragStart', event, this.drag.pointer, undefined, true);
      }
    }

    /**
     * handle drag event
     * @param {Event} event
     * @private
     */

  }, {
    key: 'onDrag',
    value: function onDrag(event) {
      var _this2 = this;

      if (this.drag.pinched === true) {
        return;
      }

      // remove the focus on node if it is focussed on by the focusOnNode
      this.body.emitter.emit('unlockNode');

      var pointer = this.getPointer(event.center);

      var selection = this.drag.selection;
      if (selection && selection.length && this.options.dragNodes === true) {
        this.selectionHandler._generateClickEvent('dragging', event, pointer);

        // calculate delta's and new location
        var deltaX = pointer.x - this.drag.pointer.x;
        var deltaY = pointer.y - this.drag.pointer.y;

        // update position of all selected nodes
        selection.forEach(function (selection) {
          var node = selection.node;
          // only move the node if it was not fixed initially
          if (selection.xFixed === false) {
            node.x = _this2.canvas._XconvertDOMtoCanvas(_this2.canvas._XconvertCanvasToDOM(selection.x) + deltaX);
          }
          // only move the node if it was not fixed initially
          if (selection.yFixed === false) {
            node.y = _this2.canvas._YconvertDOMtoCanvas(_this2.canvas._YconvertCanvasToDOM(selection.y) + deltaY);
          }
        });

        // start the simulation of the physics
        this.body.emitter.emit('startSimulation');
      } else {
        // move the network
        if (this.options.dragView === true) {
          this.selectionHandler._generateClickEvent('dragging', event, pointer, undefined, true);

          // if the drag was not started properly because the click started outside the network div, start it now.
          if (this.drag.pointer === undefined) {
            this.onDragStart(event);
            return;
          }
          var diffX = pointer.x - this.drag.pointer.x;
          var diffY = pointer.y - this.drag.pointer.y;

          this.body.view.translation = { x: this.drag.translation.x + diffX, y: this.drag.translation.y + diffY };
          this.body.emitter.emit('_requestRedraw');
        }
      }
    }

    /**
     * handle drag start event
     * @param {Event} event
     * @private
     */

  }, {
    key: 'onDragEnd',
    value: function onDragEnd(event) {
      this.drag.dragging = false;
      var selection = this.drag.selection;
      if (selection && selection.length) {
        selection.forEach(function (s) {
          // restore original xFixed and yFixed
          s.node.options.fixed.x = s.xFixed;
          s.node.options.fixed.y = s.yFixed;
        });
        this.selectionHandler._generateClickEvent('dragEnd', event, this.getPointer(event.center));
        this.body.emitter.emit('startSimulation');
      } else {
        this.selectionHandler._generateClickEvent('dragEnd', event, this.getPointer(event.center), undefined, true);
        this.body.emitter.emit('_requestRedraw');
      }
    }

    /**
     * Handle pinch event
     * @param {Event}  event   The event
     * @private
     */

  }, {
    key: 'onPinch',
    value: function onPinch(event) {
      var pointer = this.getPointer(event.center);

      this.drag.pinched = true;
      if (this.pinch['scale'] === undefined) {
        this.pinch.scale = 1;
      }

      // TODO: enabled moving while pinching?
      var scale = this.pinch.scale * event.scale;
      this.zoom(scale, pointer);
    }

    /**
     * Zoom the network in or out
     * @param {number} scale a number around 1, and between 0.01 and 10
     * @param {{x: number, y: number}} pointer    Position on screen
     * @private
     */

  }, {
    key: 'zoom',
    value: function zoom(scale, pointer) {
      if (this.options.zoomView === true) {
        var scaleOld = this.body.view.scale;
        if (scale < 0.00001) {
          scale = 0.00001;
        }
        if (scale > 10) {
          scale = 10;
        }

        var preScaleDragPointer = undefined;
        if (this.drag !== undefined) {
          if (this.drag.dragging === true) {
            preScaleDragPointer = this.canvas.DOMtoCanvas(this.drag.pointer);
          }
        }
        // + this.canvas.frame.canvas.clientHeight / 2
        var translation = this.body.view.translation;

        var scaleFrac = scale / scaleOld;
        var tx = (1 - scaleFrac) * pointer.x + translation.x * scaleFrac;
        var ty = (1 - scaleFrac) * pointer.y + translation.y * scaleFrac;

        this.body.view.scale = scale;
        this.body.view.translation = { x: tx, y: ty };

        if (preScaleDragPointer != undefined) {
          var postScaleDragPointer = this.canvas.canvasToDOM(preScaleDragPointer);
          this.drag.pointer.x = postScaleDragPointer.x;
          this.drag.pointer.y = postScaleDragPointer.y;
        }

        this.body.emitter.emit('_requestRedraw');

        if (scaleOld < scale) {
          this.body.emitter.emit('zoom', { direction: '+', scale: this.body.view.scale, pointer: pointer });
        } else {
          this.body.emitter.emit('zoom', { direction: '-', scale: this.body.view.scale, pointer: pointer });
        }
      }
    }

    /**
     * Event handler for mouse wheel event, used to zoom the timeline
     * See http://adomas.org/javascript-mouse-wheel/
     *     https://github.com/EightMedia/hammer.js/issues/256
     * @param {MouseEvent}  event
     * @private
     */

  }, {
    key: 'onMouseWheel',
    value: function onMouseWheel(event) {
      if (this.options.zoomView === true) {
        // retrieve delta
        var delta = 0;
        if (event.wheelDelta) {
          /* IE/Opera. */
          delta = event.wheelDelta / 120;
        } else if (event.detail) {
          /* Mozilla case. */
          // In Mozilla, sign of delta is different than in IE.
          // Also, delta is multiple of 3.
          delta = -event.detail / 3;
        }

        // If delta is nonzero, handle it.
        // Basically, delta is now positive if wheel was scrolled up,
        // and negative, if wheel was scrolled down.
        if (delta !== 0) {

          // calculate the new scale
          var scale = this.body.view.scale;
          var zoom = delta / 10;
          if (delta < 0) {
            zoom = zoom / (1 - zoom);
          }
          scale *= 1 + zoom;

          // calculate the pointer location
          var pointer = this.getPointer({ x: event.clientX, y: event.clientY });

          // apply the new scale
          this.zoom(scale, pointer);
        }

        // Prevent default actions caused by mouse wheel.
        event.preventDefault();
      }
    }

    /**
     * Mouse move handler for checking whether the title moves over a node with a title.
     * @param  {Event} event
     * @private
     */

  }, {
    key: 'onMouseMove',
    value: function onMouseMove(event) {
      var _this3 = this;

      var pointer = this.getPointer({ x: event.clientX, y: event.clientY });
      var popupVisible = false;

      // check if the previously selected node is still selected
      if (this.popup !== undefined) {
        if (this.popup.hidden === false) {
          this._checkHidePopup(pointer);
        }

        // if the popup was not hidden above
        if (this.popup.hidden === false) {
          popupVisible = true;
          this.popup.setPosition(pointer.x + 3, pointer.y - 5);
          this.popup.show();
        }
      }

      // if we bind the keyboard to the div, we have to highlight it to use it. This highlights it on mouse over.
      if (this.options.keyboard.bindToWindow === false && this.options.keyboard.enabled === true) {
        this.canvas.frame.focus();
      }

      // start a timeout that will check if the mouse is positioned above an element
      if (popupVisible === false) {
        if (this.popupTimer !== undefined) {
          clearInterval(this.popupTimer); // stop any running calculationTimer
          this.popupTimer = undefined;
        }
        if (!this.drag.dragging) {
          this.popupTimer = setTimeout(function () {
            return _this3._checkShowPopup(pointer);
          }, this.options.tooltipDelay);
        }
      }

      // adding hover highlights
      if (this.options.hover === true) {
        this.selectionHandler.hoverObject(event, pointer);
      }
    }

    /**
     * Check if there is an element on the given position in the network
     * (a node or edge). If so, and if this element has a title,
     * show a popup window with its title.
     *
     * @param {{x:number, y:number}} pointer
     * @private
     */

  }, {
    key: '_checkShowPopup',
    value: function _checkShowPopup(pointer) {
      var x = this.canvas._XconvertDOMtoCanvas(pointer.x);
      var y = this.canvas._YconvertDOMtoCanvas(pointer.y);
      var pointerObj = {
        left: x,
        top: y,
        right: x,
        bottom: y
      };

      var previousPopupObjId = this.popupObj === undefined ? undefined : this.popupObj.id;
      var nodeUnderCursor = false;
      var popupType = 'node';

      // check if a node is under the cursor.
      if (this.popupObj === undefined) {
        // search the nodes for overlap, select the top one in case of multiple nodes
        var nodeIndices = this.body.nodeIndices;
        var nodes = this.body.nodes;
        var node = void 0;
        var overlappingNodes = [];
        for (var i = 0; i < nodeIndices.length; i++) {
          node = nodes[nodeIndices[i]];
          if (node.isOverlappingWith(pointerObj) === true) {
            if (node.getTitle() !== undefined) {
              overlappingNodes.push(nodeIndices[i]);
            }
          }
        }

        if (overlappingNodes.length > 0) {
          // if there are overlapping nodes, select the last one, this is the one which is drawn on top of the others
          this.popupObj = nodes[overlappingNodes[overlappingNodes.length - 1]];
          // if you hover over a node, the title of the edge is not supposed to be shown.
          nodeUnderCursor = true;
        }
      }

      if (this.popupObj === undefined && nodeUnderCursor === false) {
        // search the edges for overlap
        var edgeIndices = this.body.edgeIndices;
        var edges = this.body.edges;
        var edge = void 0;
        var overlappingEdges = [];
        for (var _i = 0; _i < edgeIndices.length; _i++) {
          edge = edges[edgeIndices[_i]];
          if (edge.isOverlappingWith(pointerObj) === true) {
            if (edge.connected === true && edge.getTitle() !== undefined) {
              overlappingEdges.push(edgeIndices[_i]);
            }
          }
        }

        if (overlappingEdges.length > 0) {
          this.popupObj = edges[overlappingEdges[overlappingEdges.length - 1]];
          popupType = 'edge';
        }
      }

      if (this.popupObj !== undefined) {
        // show popup message window
        if (this.popupObj.id !== previousPopupObjId) {
          if (this.popup === undefined) {
            this.popup = new Popup(this.canvas.frame);
          }

          this.popup.popupTargetType = popupType;
          this.popup.popupTargetId = this.popupObj.id;

          // adjust a small offset such that the mouse cursor is located in the
          // bottom left location of the popup, and you can easily move over the
          // popup area
          this.popup.setPosition(pointer.x + 3, pointer.y - 5);
          this.popup.setText(this.popupObj.getTitle());
          this.popup.show();
          this.body.emitter.emit('showPopup', this.popupObj.id);
        }
      } else {
        if (this.popup !== undefined) {
          this.popup.hide();
          this.body.emitter.emit('hidePopup');
        }
      }
    }

    /**
     * Check if the popup must be hidden, which is the case when the mouse is no
     * longer hovering on the object
     * @param {{x:number, y:number}} pointer
     * @private
     */

  }, {
    key: '_checkHidePopup',
    value: function _checkHidePopup(pointer) {
      var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);

      var stillOnObj = false;
      if (this.popup.popupTargetType === 'node') {
        if (this.body.nodes[this.popup.popupTargetId] !== undefined) {
          stillOnObj = this.body.nodes[this.popup.popupTargetId].isOverlappingWith(pointerObj);

          // if the mouse is still one the node, we have to check if it is not also on one that is drawn on top of it.
          // we initially only check stillOnObj because this is much faster.
          if (stillOnObj === true) {
            var overNode = this.selectionHandler.getNodeAt(pointer);
            stillOnObj = overNode === undefined ? false : overNode.id === this.popup.popupTargetId;
          }
        }
      } else {
        if (this.selectionHandler.getNodeAt(pointer) === undefined) {
          if (this.body.edges[this.popup.popupTargetId] !== undefined) {
            stillOnObj = this.body.edges[this.popup.popupTargetId].isOverlappingWith(pointerObj);
          }
        }
      }

      if (stillOnObj === false) {
        this.popupObj = undefined;
        this.popup.hide();
        this.body.emitter.emit('hidePopup');
      }
    }
  }]);
  return InteractionHandler;
}();

exports['default'] = InteractionHandler;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Hammer = __webpack_require__(10);
var hammerUtil = __webpack_require__(37);
var keycharm = __webpack_require__(35);

/**
 * Navigation Handler
 */

var NavigationHandler = function () {
  /**
   * @param {Object} body
   * @param {Canvas} canvas
   */
  function NavigationHandler(body, canvas) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, NavigationHandler);

    this.body = body;
    this.canvas = canvas;

    this.iconsCreated = false;
    this.navigationHammers = [];
    this.boundFunctions = {};
    this.touchTime = 0;
    this.activated = false;

    this.body.emitter.on("activate", function () {
      _this.activated = true;_this.configureKeyboardBindings();
    });
    this.body.emitter.on("deactivate", function () {
      _this.activated = false;_this.configureKeyboardBindings();
    });
    this.body.emitter.on("destroy", function () {
      if (_this.keycharm !== undefined) {
        _this.keycharm.destroy();
      }
    });

    this.options = {};
  }

  /**
   *
   * @param {Object} options
   */


  (0, _createClass3['default'])(NavigationHandler, [{
    key: 'setOptions',
    value: function setOptions(options) {
      if (options !== undefined) {
        this.options = options;
        this.create();
      }
    }

    /**
     * Creates or refreshes navigation and sets key bindings
     */

  }, {
    key: 'create',
    value: function create() {
      if (this.options.navigationButtons === true) {
        if (this.iconsCreated === false) {
          this.loadNavigationElements();
        }
      } else if (this.iconsCreated === true) {
        this.cleanNavigation();
      }

      this.configureKeyboardBindings();
    }

    /**
     * Cleans up previous navigation items
     */

  }, {
    key: 'cleanNavigation',
    value: function cleanNavigation() {
      // clean hammer bindings
      if (this.navigationHammers.length != 0) {
        for (var i = 0; i < this.navigationHammers.length; i++) {
          this.navigationHammers[i].destroy();
        }
        this.navigationHammers = [];
      }

      // clean up previous navigation items
      if (this.navigationDOM && this.navigationDOM['wrapper'] && this.navigationDOM['wrapper'].parentNode) {
        this.navigationDOM['wrapper'].parentNode.removeChild(this.navigationDOM['wrapper']);
      }

      this.iconsCreated = false;
    }

    /**
     * Creation of the navigation controls nodes. They are drawn over the rest of the nodes and are not affected by scale and translation
     * they have a triggerFunction which is called on click. If the position of the navigation controls is dependent
     * on this.frame.canvas.clientWidth or this.frame.canvas.clientHeight, we flag horizontalAlignLeft and verticalAlignTop false.
     * This means that the location will be corrected by the _relocateNavigation function on a size change of the canvas.
     *
     * @private
     */

  }, {
    key: 'loadNavigationElements',
    value: function loadNavigationElements() {
      var _this2 = this;

      this.cleanNavigation();

      this.navigationDOM = {};
      var navigationDivs = ['up', 'down', 'left', 'right', 'zoomIn', 'zoomOut', 'zoomExtends'];
      var navigationDivActions = ['_moveUp', '_moveDown', '_moveLeft', '_moveRight', '_zoomIn', '_zoomOut', '_fit'];

      this.navigationDOM['wrapper'] = document.createElement('div');
      this.navigationDOM['wrapper'].className = 'vis-navigation';
      this.canvas.frame.appendChild(this.navigationDOM['wrapper']);

      for (var i = 0; i < navigationDivs.length; i++) {
        this.navigationDOM[navigationDivs[i]] = document.createElement('div');
        this.navigationDOM[navigationDivs[i]].className = 'vis-button vis-' + navigationDivs[i];
        this.navigationDOM['wrapper'].appendChild(this.navigationDOM[navigationDivs[i]]);

        var hammer = new Hammer(this.navigationDOM[navigationDivs[i]]);
        if (navigationDivActions[i] === "_fit") {
          hammerUtil.onTouch(hammer, this._fit.bind(this));
        } else {
          hammerUtil.onTouch(hammer, this.bindToRedraw.bind(this, navigationDivActions[i]));
        }

        this.navigationHammers.push(hammer);
      }

      // use a hammer for the release so we do not require the one used in the rest of the network
      // the one the rest uses can be overloaded by the manipulation system.
      var hammerFrame = new Hammer(this.canvas.frame);
      hammerUtil.onRelease(hammerFrame, function () {
        _this2._stopMovement();
      });
      this.navigationHammers.push(hammerFrame);

      this.iconsCreated = true;
    }

    /**
     *
     * @param {string} action
     */

  }, {
    key: 'bindToRedraw',
    value: function bindToRedraw(action) {
      if (this.boundFunctions[action] === undefined) {
        this.boundFunctions[action] = this[action].bind(this);
        this.body.emitter.on("initRedraw", this.boundFunctions[action]);
        this.body.emitter.emit("_startRendering");
      }
    }

    /**
     *
     * @param {string} action
     */

  }, {
    key: 'unbindFromRedraw',
    value: function unbindFromRedraw(action) {
      if (this.boundFunctions[action] !== undefined) {
        this.body.emitter.off("initRedraw", this.boundFunctions[action]);
        this.body.emitter.emit("_stopRendering");
        delete this.boundFunctions[action];
      }
    }

    /**
     * this stops all movement induced by the navigation buttons
     *
     * @private
     */

  }, {
    key: '_fit',
    value: function _fit() {
      if (new Date().valueOf() - this.touchTime > 700) {
        // TODO: fix ugly hack to avoid hammer's double fireing of event (because we use release?)
        this.body.emitter.emit("fit", { duration: 700 });
        this.touchTime = new Date().valueOf();
      }
    }

    /**
     * this stops all movement induced by the navigation buttons
     *
     * @private
     */

  }, {
    key: '_stopMovement',
    value: function _stopMovement() {
      for (var boundAction in this.boundFunctions) {
        if (this.boundFunctions.hasOwnProperty(boundAction)) {
          this.body.emitter.off("initRedraw", this.boundFunctions[boundAction]);
          this.body.emitter.emit("_stopRendering");
        }
      }
      this.boundFunctions = {};
    }
    /**
     *
     * @private
     */

  }, {
    key: '_moveUp',
    value: function _moveUp() {
      this.body.view.translation.y += this.options.keyboard.speed.y;
    }
    /**
     *
     * @private
     */

  }, {
    key: '_moveDown',
    value: function _moveDown() {
      this.body.view.translation.y -= this.options.keyboard.speed.y;
    }
    /**
     *
     * @private
     */

  }, {
    key: '_moveLeft',
    value: function _moveLeft() {
      this.body.view.translation.x += this.options.keyboard.speed.x;
    }
    /**
     *
     * @private
     */

  }, {
    key: '_moveRight',
    value: function _moveRight() {
      this.body.view.translation.x -= this.options.keyboard.speed.x;
    }
    /**
     *
     * @private
     */

  }, {
    key: '_zoomIn',
    value: function _zoomIn() {
      var scaleOld = this.body.view.scale;
      var scale = this.body.view.scale * (1 + this.options.keyboard.speed.zoom);
      var translation = this.body.view.translation;
      var scaleFrac = scale / scaleOld;
      var tx = (1 - scaleFrac) * this.canvas.canvasViewCenter.x + translation.x * scaleFrac;
      var ty = (1 - scaleFrac) * this.canvas.canvasViewCenter.y + translation.y * scaleFrac;

      this.body.view.scale = scale;
      this.body.view.translation = { x: tx, y: ty };
      this.body.emitter.emit('zoom', { direction: '+', scale: this.body.view.scale, pointer: null });
    }

    /**
     *
     * @private
     */

  }, {
    key: '_zoomOut',
    value: function _zoomOut() {
      var scaleOld = this.body.view.scale;
      var scale = this.body.view.scale / (1 + this.options.keyboard.speed.zoom);
      var translation = this.body.view.translation;
      var scaleFrac = scale / scaleOld;
      var tx = (1 - scaleFrac) * this.canvas.canvasViewCenter.x + translation.x * scaleFrac;
      var ty = (1 - scaleFrac) * this.canvas.canvasViewCenter.y + translation.y * scaleFrac;

      this.body.view.scale = scale;
      this.body.view.translation = { x: tx, y: ty };
      this.body.emitter.emit('zoom', { direction: '-', scale: this.body.view.scale, pointer: null });
    }

    /**
     * bind all keys using keycharm.
     */

  }, {
    key: 'configureKeyboardBindings',
    value: function configureKeyboardBindings() {
      var _this3 = this;

      if (this.keycharm !== undefined) {
        this.keycharm.destroy();
      }

      if (this.options.keyboard.enabled === true) {
        if (this.options.keyboard.bindToWindow === true) {
          this.keycharm = keycharm({ container: window, preventDefault: true });
        } else {
          this.keycharm = keycharm({ container: this.canvas.frame, preventDefault: true });
        }

        this.keycharm.reset();

        if (this.activated === true) {
          this.keycharm.bind("up", function () {
            _this3.bindToRedraw("_moveUp");
          }, "keydown");
          this.keycharm.bind("down", function () {
            _this3.bindToRedraw("_moveDown");
          }, "keydown");
          this.keycharm.bind("left", function () {
            _this3.bindToRedraw("_moveLeft");
          }, "keydown");
          this.keycharm.bind("right", function () {
            _this3.bindToRedraw("_moveRight");
          }, "keydown");
          this.keycharm.bind("=", function () {
            _this3.bindToRedraw("_zoomIn");
          }, "keydown");
          this.keycharm.bind("num+", function () {
            _this3.bindToRedraw("_zoomIn");
          }, "keydown");
          this.keycharm.bind("num-", function () {
            _this3.bindToRedraw("_zoomOut");
          }, "keydown");
          this.keycharm.bind("-", function () {
            _this3.bindToRedraw("_zoomOut");
          }, "keydown");
          this.keycharm.bind("[", function () {
            _this3.bindToRedraw("_zoomOut");
          }, "keydown");
          this.keycharm.bind("]", function () {
            _this3.bindToRedraw("_zoomIn");
          }, "keydown");
          this.keycharm.bind("pageup", function () {
            _this3.bindToRedraw("_zoomIn");
          }, "keydown");
          this.keycharm.bind("pagedown", function () {
            _this3.bindToRedraw("_zoomOut");
          }, "keydown");

          this.keycharm.bind("up", function () {
            _this3.unbindFromRedraw("_moveUp");
          }, "keyup");
          this.keycharm.bind("down", function () {
            _this3.unbindFromRedraw("_moveDown");
          }, "keyup");
          this.keycharm.bind("left", function () {
            _this3.unbindFromRedraw("_moveLeft");
          }, "keyup");
          this.keycharm.bind("right", function () {
            _this3.unbindFromRedraw("_moveRight");
          }, "keyup");
          this.keycharm.bind("=", function () {
            _this3.unbindFromRedraw("_zoomIn");
          }, "keyup");
          this.keycharm.bind("num+", function () {
            _this3.unbindFromRedraw("_zoomIn");
          }, "keyup");
          this.keycharm.bind("num-", function () {
            _this3.unbindFromRedraw("_zoomOut");
          }, "keyup");
          this.keycharm.bind("-", function () {
            _this3.unbindFromRedraw("_zoomOut");
          }, "keyup");
          this.keycharm.bind("[", function () {
            _this3.unbindFromRedraw("_zoomOut");
          }, "keyup");
          this.keycharm.bind("]", function () {
            _this3.unbindFromRedraw("_zoomIn");
          }, "keyup");
          this.keycharm.bind("pageup", function () {
            _this3.unbindFromRedraw("_zoomIn");
          }, "keyup");
          this.keycharm.bind("pagedown", function () {
            _this3.unbindFromRedraw("_zoomOut");
          }, "keyup");
        }
      }
    }
  }]);
  return NavigationHandler;
}();

exports['default'] = NavigationHandler;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Node = __webpack_require__(47)['default'];
var Edge = __webpack_require__(74)['default'];

var util = __webpack_require__(2);

/**
 * The handler for selections
 */

var SelectionHandler = function () {
  /**
   * @param {Object} body
   * @param {Canvas} canvas
   */
  function SelectionHandler(body, canvas) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, SelectionHandler);

    this.body = body;
    this.canvas = canvas;
    this.selectionObj = { nodes: [], edges: [] };
    this.hoverObj = { nodes: {}, edges: {} };

    this.options = {};
    this.defaultOptions = {
      multiselect: false,
      selectable: true,
      selectConnectedEdges: true,
      hoverConnectedEdges: true
    };
    util.extend(this.options, this.defaultOptions);

    this.body.emitter.on("_dataChanged", function () {
      _this.updateSelection();
    });
  }

  /**
   *
   * @param {Object} [options]
   */


  (0, _createClass3['default'])(SelectionHandler, [{
    key: 'setOptions',
    value: function setOptions(options) {
      if (options !== undefined) {
        var fields = ['multiselect', 'hoverConnectedEdges', 'selectable', 'selectConnectedEdges'];
        util.selectiveDeepExtend(fields, this.options, options);
      }
    }

    /**
     * handles the selection part of the tap;
     *
     * @param {{x: number, y: number}} pointer
     * @returns {boolean}
     */

  }, {
    key: 'selectOnPoint',
    value: function selectOnPoint(pointer) {
      var selected = false;
      if (this.options.selectable === true) {
        var obj = this.getNodeAt(pointer) || this.getEdgeAt(pointer);

        // unselect after getting the objects in order to restore width and height.
        this.unselectAll();

        if (obj !== undefined) {
          selected = this.selectObject(obj);
        }
        this.body.emitter.emit("_requestRedraw");
      }
      return selected;
    }

    /**
     *
     * @param {{x: number, y: number}} pointer
     * @returns {boolean}
     */

  }, {
    key: 'selectAdditionalOnPoint',
    value: function selectAdditionalOnPoint(pointer) {
      var selectionChanged = false;
      if (this.options.selectable === true) {
        var obj = this.getNodeAt(pointer) || this.getEdgeAt(pointer);

        if (obj !== undefined) {
          selectionChanged = true;
          if (obj.isSelected() === true) {
            this.deselectObject(obj);
          } else {
            this.selectObject(obj);
          }

          this.body.emitter.emit("_requestRedraw");
        }
      }
      return selectionChanged;
    }

    /**
     * Create an object containing the standard fields for an event.
     *
     * @param {Event} event
     * @param {{x: number, y: number}} pointer Object with the x and y screen coordinates of the mouse
     * @returns {{}}
     * @private
     */

  }, {
    key: '_initBaseEvent',
    value: function _initBaseEvent(event, pointer) {
      var properties = {};

      properties['pointer'] = {
        DOM: { x: pointer.x, y: pointer.y },
        canvas: this.canvas.DOMtoCanvas(pointer)
      };
      properties['event'] = event;

      return properties;
    }

    /**
     * Generate an event which the user can catch.
     *
     * This adds some extra data to the event with respect to cursor position and
     * selected nodes and edges.
     *
     * @param {string} eventType                          Name of event to send
     * @param {Event}  event
     * @param {{x: number, y: number}} pointer            Object with the x and y screen coordinates of the mouse
     * @param {Object|undefined} oldSelection             If present, selection state before event occured
     * @param {boolean|undefined} [emptySelection=false]  Indicate if selection data should be passed
     */

  }, {
    key: '_generateClickEvent',
    value: function _generateClickEvent(eventType, event, pointer, oldSelection) {
      var emptySelection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var properties = this._initBaseEvent(event, pointer);

      if (emptySelection === true) {
        properties.nodes = [];
        properties.edges = [];
      } else {
        var tmp = this.getSelection();
        properties.nodes = tmp.nodes;
        properties.edges = tmp.edges;
      }

      if (oldSelection !== undefined) {
        properties['previousSelection'] = oldSelection;
      }

      if (eventType == 'click') {
        // For the time being, restrict this functionality to
        // just the click event.
        properties.items = this.getClickedItems(pointer);
      }

      this.body.emitter.emit(eventType, properties);
    }

    /**
     *
     * @param {Object} obj
     * @param {boolean} [highlightEdges=this.options.selectConnectedEdges]
     * @returns {boolean}
     */

  }, {
    key: 'selectObject',
    value: function selectObject(obj) {
      var highlightEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.selectConnectedEdges;

      if (obj !== undefined) {
        if (obj instanceof Node) {
          if (highlightEdges === true) {
            this._selectConnectedEdges(obj);
          }
        }
        obj.select();
        this._addToSelection(obj);
        return true;
      }
      return false;
    }

    /**
     *
     * @param {Object} obj
     */

  }, {
    key: 'deselectObject',
    value: function deselectObject(obj) {
      if (obj.isSelected() === true) {
        obj.selected = false;
        this._removeFromSelection(obj);
      }
    }

    /**
     * retrieve all nodes overlapping with given object
     * @param {Object} object  An object with parameters left, top, right, bottom
     * @return {number[]}   An array with id's of the overlapping nodes
     * @private
     */

  }, {
    key: '_getAllNodesOverlappingWith',
    value: function _getAllNodesOverlappingWith(object) {
      var overlappingNodes = [];
      var nodes = this.body.nodes;
      for (var i = 0; i < this.body.nodeIndices.length; i++) {
        var nodeId = this.body.nodeIndices[i];
        if (nodes[nodeId].isOverlappingWith(object)) {
          overlappingNodes.push(nodeId);
        }
      }
      return overlappingNodes;
    }

    /**
     * Return a position object in canvasspace from a single point in screenspace
     *
     * @param {{x: number, y: number}} pointer
     * @returns {{left: number, top: number, right: number, bottom: number}}
     * @private
     */

  }, {
    key: '_pointerToPositionObject',
    value: function _pointerToPositionObject(pointer) {
      var canvasPos = this.canvas.DOMtoCanvas(pointer);
      return {
        left: canvasPos.x - 1,
        top: canvasPos.y + 1,
        right: canvasPos.x + 1,
        bottom: canvasPos.y - 1
      };
    }

    /**
     * Get the top node at the passed point (like a click)
     *
     * @param {{x: number, y: number}} pointer
     * @param {boolean} [returnNode=true]
     * @return {Node | undefined} node
     */

  }, {
    key: 'getNodeAt',
    value: function getNodeAt(pointer) {
      var returnNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // we first check if this is an navigation controls element
      var positionObject = this._pointerToPositionObject(pointer);
      var overlappingNodes = this._getAllNodesOverlappingWith(positionObject);
      // if there are overlapping nodes, select the last one, this is the
      // one which is drawn on top of the others
      if (overlappingNodes.length > 0) {
        if (returnNode === true) {
          return this.body.nodes[overlappingNodes[overlappingNodes.length - 1]];
        } else {
          return overlappingNodes[overlappingNodes.length - 1];
        }
      } else {
        return undefined;
      }
    }

    /**
     * retrieve all edges overlapping with given object, selector is around center
     * @param {Object} object  An object with parameters left, top, right, bottom
     * @param {number[]} overlappingEdges An array with id's of the overlapping nodes
     * @private
     */

  }, {
    key: '_getEdgesOverlappingWith',
    value: function _getEdgesOverlappingWith(object, overlappingEdges) {
      var edges = this.body.edges;
      for (var i = 0; i < this.body.edgeIndices.length; i++) {
        var edgeId = this.body.edgeIndices[i];
        if (edges[edgeId].isOverlappingWith(object)) {
          overlappingEdges.push(edgeId);
        }
      }
    }

    /**
     * retrieve all nodes overlapping with given object
     * @param {Object} object  An object with parameters left, top, right, bottom
     * @return {number[]}   An array with id's of the overlapping nodes
     * @private
     */

  }, {
    key: '_getAllEdgesOverlappingWith',
    value: function _getAllEdgesOverlappingWith(object) {
      var overlappingEdges = [];
      this._getEdgesOverlappingWith(object, overlappingEdges);
      return overlappingEdges;
    }

    /**
     * Get the edges nearest to the passed point (like a click)
     *
     * @param {{x: number, y: number}} pointer
     * @param {boolean} [returnEdge=true]
     * @return {Edge | undefined} node
     */

  }, {
    key: 'getEdgeAt',
    value: function getEdgeAt(pointer) {
      var returnEdge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      // Iterate over edges, pick closest within 10
      var canvasPos = this.canvas.DOMtoCanvas(pointer);
      var mindist = 10;
      var overlappingEdge = null;
      var edges = this.body.edges;
      for (var i = 0; i < this.body.edgeIndices.length; i++) {
        var edgeId = this.body.edgeIndices[i];
        var edge = edges[edgeId];
        if (edge.connected) {
          var xFrom = edge.from.x;
          var yFrom = edge.from.y;
          var xTo = edge.to.x;
          var yTo = edge.to.y;
          var dist = edge.edgeType.getDistanceToEdge(xFrom, yFrom, xTo, yTo, canvasPos.x, canvasPos.y);
          if (dist < mindist) {
            overlappingEdge = edgeId;
            mindist = dist;
          }
        }
      }
      if (overlappingEdge !== null) {
        if (returnEdge === true) {
          return this.body.edges[overlappingEdge];
        } else {
          return overlappingEdge;
        }
      } else {
        return undefined;
      }
    }

    /**
     * Add object to the selection array.
     *
     * @param {Object} obj
     * @private
     */

  }, {
    key: '_addToSelection',
    value: function _addToSelection(obj) {
      if (obj instanceof Node) {
        this.selectionObj.nodes[obj.id] = obj;
      } else {
        this.selectionObj.edges[obj.id] = obj;
      }
    }

    /**
     * Add object to the selection array.
     *
     * @param {Object} obj
     * @private
     */

  }, {
    key: '_addToHover',
    value: function _addToHover(obj) {
      if (obj instanceof Node) {
        this.hoverObj.nodes[obj.id] = obj;
      } else {
        this.hoverObj.edges[obj.id] = obj;
      }
    }

    /**
     * Remove a single option from selection.
     *
     * @param {Object} obj
     * @private
     */

  }, {
    key: '_removeFromSelection',
    value: function _removeFromSelection(obj) {
      if (obj instanceof Node) {
        delete this.selectionObj.nodes[obj.id];
        this._unselectConnectedEdges(obj);
      } else {
        delete this.selectionObj.edges[obj.id];
      }
    }

    /**
     * Unselect all. The selectionObj is useful for this.
     */

  }, {
    key: 'unselectAll',
    value: function unselectAll() {
      for (var nodeId in this.selectionObj.nodes) {
        if (this.selectionObj.nodes.hasOwnProperty(nodeId)) {
          this.selectionObj.nodes[nodeId].unselect();
        }
      }
      for (var edgeId in this.selectionObj.edges) {
        if (this.selectionObj.edges.hasOwnProperty(edgeId)) {
          this.selectionObj.edges[edgeId].unselect();
        }
      }

      this.selectionObj = { nodes: {}, edges: {} };
    }

    /**
     * return the number of selected nodes
     *
     * @returns {number}
     * @private
     */

  }, {
    key: '_getSelectedNodeCount',
    value: function _getSelectedNodeCount() {
      var count = 0;
      for (var nodeId in this.selectionObj.nodes) {
        if (this.selectionObj.nodes.hasOwnProperty(nodeId)) {
          count += 1;
        }
      }
      return count;
    }

    /**
     * return the selected node
     *
     * @returns {number}
     * @private
     */

  }, {
    key: '_getSelectedNode',
    value: function _getSelectedNode() {
      for (var nodeId in this.selectionObj.nodes) {
        if (this.selectionObj.nodes.hasOwnProperty(nodeId)) {
          return this.selectionObj.nodes[nodeId];
        }
      }
      return undefined;
    }

    /**
     * return the selected edge
     *
     * @returns {number}
     * @private
     */

  }, {
    key: '_getSelectedEdge',
    value: function _getSelectedEdge() {
      for (var edgeId in this.selectionObj.edges) {
        if (this.selectionObj.edges.hasOwnProperty(edgeId)) {
          return this.selectionObj.edges[edgeId];
        }
      }
      return undefined;
    }

    /**
     * return the number of selected edges
     *
     * @returns {number}
     * @private
     */

  }, {
    key: '_getSelectedEdgeCount',
    value: function _getSelectedEdgeCount() {
      var count = 0;
      for (var edgeId in this.selectionObj.edges) {
        if (this.selectionObj.edges.hasOwnProperty(edgeId)) {
          count += 1;
        }
      }
      return count;
    }

    /**
     * return the number of selected objects.
     *
     * @returns {number}
     * @private
     */

  }, {
    key: '_getSelectedObjectCount',
    value: function _getSelectedObjectCount() {
      var count = 0;
      for (var nodeId in this.selectionObj.nodes) {
        if (this.selectionObj.nodes.hasOwnProperty(nodeId)) {
          count += 1;
        }
      }
      for (var edgeId in this.selectionObj.edges) {
        if (this.selectionObj.edges.hasOwnProperty(edgeId)) {
          count += 1;
        }
      }
      return count;
    }

    /**
     * Check if anything is selected
     *
     * @returns {boolean}
     * @private
     */

  }, {
    key: '_selectionIsEmpty',
    value: function _selectionIsEmpty() {
      for (var nodeId in this.selectionObj.nodes) {
        if (this.selectionObj.nodes.hasOwnProperty(nodeId)) {
          return false;
        }
      }
      for (var edgeId in this.selectionObj.edges) {
        if (this.selectionObj.edges.hasOwnProperty(edgeId)) {
          return false;
        }
      }
      return true;
    }

    /**
     * check if one of the selected nodes is a cluster.
     *
     * @returns {boolean}
     * @private
     */

  }, {
    key: '_clusterInSelection',
    value: function _clusterInSelection() {
      for (var nodeId in this.selectionObj.nodes) {
        if (this.selectionObj.nodes.hasOwnProperty(nodeId)) {
          if (this.selectionObj.nodes[nodeId].clusterSize > 1) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * select the edges connected to the node that is being selected
     *
     * @param {Node} node
     * @private
     */

  }, {
    key: '_selectConnectedEdges',
    value: function _selectConnectedEdges(node) {
      for (var i = 0; i < node.edges.length; i++) {
        var edge = node.edges[i];
        edge.select();
        this._addToSelection(edge);
      }
    }

    /**
     * select the edges connected to the node that is being selected
     *
     * @param {Node} node
     * @private
     */

  }, {
    key: '_hoverConnectedEdges',
    value: function _hoverConnectedEdges(node) {
      for (var i = 0; i < node.edges.length; i++) {
        var edge = node.edges[i];
        edge.hover = true;
        this._addToHover(edge);
      }
    }

    /**
     * unselect the edges connected to the node that is being selected
     *
     * @param {Node} node
     * @private
     */

  }, {
    key: '_unselectConnectedEdges',
    value: function _unselectConnectedEdges(node) {
      for (var i = 0; i < node.edges.length; i++) {
        var edge = node.edges[i];
        edge.unselect();
        this._removeFromSelection(edge);
      }
    }

    /**
     * Remove the highlight from a node or edge, in response to mouse movement
     *
     * @param {Event}  event
     * @param {{x: number, y: number}} pointer object with the x and y screen coordinates of the mouse
     * @param {Node|vis.Edge} object
     * @private
     */

  }, {
    key: 'emitBlurEvent',
    value: function emitBlurEvent(event, pointer, object) {
      var properties = this._initBaseEvent(event, pointer);

      if (object.hover === true) {
        object.hover = false;
        if (object instanceof Node) {
          properties.node = object.id;
          this.body.emitter.emit("blurNode", properties);
        } else {
          properties.edge = object.id;
          this.body.emitter.emit("blurEdge", properties);
        }
      }
    }

    /**
     * Create the highlight for a node or edge, in response to mouse movement
     *
     * @param {Event}  event
     * @param {{x: number, y: number}} pointer object with the x and y screen coordinates of the mouse
     * @param {Node|vis.Edge} object
     * @returns {boolean} hoverChanged
     * @private
     */

  }, {
    key: 'emitHoverEvent',
    value: function emitHoverEvent(event, pointer, object) {
      var properties = this._initBaseEvent(event, pointer);
      var hoverChanged = false;

      if (object.hover === false) {
        object.hover = true;
        this._addToHover(object);
        hoverChanged = true;
        if (object instanceof Node) {
          properties.node = object.id;
          this.body.emitter.emit("hoverNode", properties);
        } else {
          properties.edge = object.id;
          this.body.emitter.emit("hoverEdge", properties);
        }
      }

      return hoverChanged;
    }

    /**
     * Perform actions in response to a mouse movement.
     *
     * @param {Event}  event
     * @param {{x: number, y: number}} pointer | object with the x and y screen coordinates of the mouse
     */

  }, {
    key: 'hoverObject',
    value: function hoverObject(event, pointer) {
      var object = this.getNodeAt(pointer);
      if (object === undefined) {
        object = this.getEdgeAt(pointer);
      }

      var hoverChanged = false;
      // remove all node hover highlights
      for (var nodeId in this.hoverObj.nodes) {
        if (this.hoverObj.nodes.hasOwnProperty(nodeId)) {
          if (object === undefined || object instanceof Node && object.id != nodeId || object instanceof Edge) {
            this.emitBlurEvent(event, pointer, this.hoverObj.nodes[nodeId]);
            delete this.hoverObj.nodes[nodeId];
            hoverChanged = true;
          }
        }
      }

      // removing all edge hover highlights
      for (var edgeId in this.hoverObj.edges) {
        if (this.hoverObj.edges.hasOwnProperty(edgeId)) {
          // if the hover has been changed here it means that the node has been hovered over or off
          // we then do not use the emitBlurEvent method here.
          if (hoverChanged === true) {
            this.hoverObj.edges[edgeId].hover = false;
            delete this.hoverObj.edges[edgeId];
          }
          // if the blur remains the same and the object is undefined (mouse off) or another
          // edge has been hovered, or another node has been hovered we blur the edge.
          else if (object === undefined || object instanceof Edge && object.id != edgeId || object instanceof Node && !object.hover) {
              this.emitBlurEvent(event, pointer, this.hoverObj.edges[edgeId]);
              delete this.hoverObj.edges[edgeId];
              hoverChanged = true;
            }
        }
      }

      if (object !== undefined) {
        hoverChanged = hoverChanged || this.emitHoverEvent(event, pointer, object);
        if (object instanceof Node && this.options.hoverConnectedEdges === true) {
          this._hoverConnectedEdges(object);
        }
      }

      if (hoverChanged === true) {
        this.body.emitter.emit('_requestRedraw');
      }
    }

    /**
     *
     * retrieve the currently selected objects
     * @return {{nodes: Array.<string>, edges: Array.<string>}} selection
     */

  }, {
    key: 'getSelection',
    value: function getSelection() {
      var nodeIds = this.getSelectedNodes();
      var edgeIds = this.getSelectedEdges();
      return { nodes: nodeIds, edges: edgeIds };
    }

    /**
     *
     * retrieve the currently selected nodes
     * @return {string[]} selection    An array with the ids of the
     *                                            selected nodes.
     */

  }, {
    key: 'getSelectedNodes',
    value: function getSelectedNodes() {
      var idArray = [];
      if (this.options.selectable === true) {
        for (var nodeId in this.selectionObj.nodes) {
          if (this.selectionObj.nodes.hasOwnProperty(nodeId)) {
            idArray.push(this.selectionObj.nodes[nodeId].id);
          }
        }
      }
      return idArray;
    }

    /**
     *
     * retrieve the currently selected edges
     * @return {Array} selection    An array with the ids of the
     *                                            selected nodes.
     */

  }, {
    key: 'getSelectedEdges',
    value: function getSelectedEdges() {
      var idArray = [];
      if (this.options.selectable === true) {
        for (var edgeId in this.selectionObj.edges) {
          if (this.selectionObj.edges.hasOwnProperty(edgeId)) {
            idArray.push(this.selectionObj.edges[edgeId].id);
          }
        }
      }
      return idArray;
    }

    /**
     * Updates the current selection
     * @param {{nodes: Array.<string>, edges: Array.<string>}} selection
     * @param {Object} options                                 Options
     */

  }, {
    key: 'setSelection',
    value: function setSelection(selection) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var i = void 0,
          id = void 0;

      if (!selection || !selection.nodes && !selection.edges) throw 'Selection must be an object with nodes and/or edges properties';
      // first unselect any selected node, if option is true or undefined
      if (options.unselectAll || options.unselectAll === undefined) {
        this.unselectAll();
      }
      if (selection.nodes) {
        for (i = 0; i < selection.nodes.length; i++) {
          id = selection.nodes[i];

          var node = this.body.nodes[id];
          if (!node) {
            throw new RangeError('Node with id "' + id + '" not found');
          }
          // don't select edges with it
          this.selectObject(node, options.highlightEdges);
        }
      }

      if (selection.edges) {
        for (i = 0; i < selection.edges.length; i++) {
          id = selection.edges[i];

          var edge = this.body.edges[id];
          if (!edge) {
            throw new RangeError('Edge with id "' + id + '" not found');
          }
          this.selectObject(edge);
        }
      }
      this.body.emitter.emit('_requestRedraw');
    }

    /**
     * select zero or more nodes with the option to highlight edges
     * @param {number[] | string[]} selection     An array with the ids of the
     *                                            selected nodes.
     * @param {boolean} [highlightEdges]
     */

  }, {
    key: 'selectNodes',
    value: function selectNodes(selection) {
      var highlightEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!selection || selection.length === undefined) throw 'Selection must be an array with ids';

      this.setSelection({ nodes: selection }, { highlightEdges: highlightEdges });
    }

    /**
     * select zero or more edges
     * @param {number[] | string[]} selection     An array with the ids of the
     *                                            selected nodes.
     */

  }, {
    key: 'selectEdges',
    value: function selectEdges(selection) {
      if (!selection || selection.length === undefined) throw 'Selection must be an array with ids';

      this.setSelection({ edges: selection });
    }

    /**
     * Validate the selection: remove ids of nodes which no longer exist
     * @private
     */

  }, {
    key: 'updateSelection',
    value: function updateSelection() {
      for (var nodeId in this.selectionObj.nodes) {
        if (this.selectionObj.nodes.hasOwnProperty(nodeId)) {
          if (!this.body.nodes.hasOwnProperty(nodeId)) {
            delete this.selectionObj.nodes[nodeId];
          }
        }
      }
      for (var edgeId in this.selectionObj.edges) {
        if (this.selectionObj.edges.hasOwnProperty(edgeId)) {
          if (!this.body.edges.hasOwnProperty(edgeId)) {
            delete this.selectionObj.edges[edgeId];
          }
        }
      }
    }

    /**
     * Determine all the visual elements clicked which are on the given point.
     *
     * All elements are returned; this includes nodes, edges and their labels.
     * The order returned is from highest to lowest, i.e. element 0 of the return
     * value is the topmost item clicked on.
     *
     * The return value consists of an array of the following possible elements:
     *
     * - `{nodeId:number}`             - node with given id clicked on
     * - `{nodeId:number, labelId:0}`  - label of node with given id clicked on
     * - `{edgeId:number}`             - edge with given id clicked on
     * - `{edge:number, labelId:0}`    - label of edge with given id clicked on
     *
     * ## NOTES
     *
     * - Currently, there is only one label associated with a node or an edge,
     *   but this is expected to change somewhere in the future.
     * - Since there is no z-indexing yet, it is not really possible to set the nodes and
     *   edges in the correct order. For the time being, nodes come first.
     *
     * @param {point} pointer  mouse position in screen coordinates
     * @returns {Array.<nodeClickItem|nodeLabelClickItem|edgeClickItem|edgeLabelClickItem>}
     * @private
     */

  }, {
    key: 'getClickedItems',
    value: function getClickedItems(pointer) {
      var point = this.canvas.DOMtoCanvas(pointer);
      var items = [];

      // Note reverse order; we want the topmost clicked items to be first in the array
      // Also note that selected nodes are disregarded here; these normally display on top
      var nodeIndices = this.body.nodeIndices;
      var nodes = this.body.nodes;
      for (var i = nodeIndices.length - 1; i >= 0; i--) {
        var node = nodes[nodeIndices[i]];
        var ret = node.getItemsOnPoint(point);
        items.push.apply(items, ret); // Append the return value to the running list.
      }

      var edgeIndices = this.body.edgeIndices;
      var edges = this.body.edges;
      for (var _i = edgeIndices.length - 1; _i >= 0; _i--) {
        var edge = edges[edgeIndices[_i]];
        var _ret = edge.getItemsOnPoint(point);
        items.push.apply(items, _ret); // Append the return value to the running list.
      }

      return items;
    }
  }]);
  return SelectionHandler;
}();

exports['default'] = SelectionHandler;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * There's a mix-up with terms in the code. Following are the formal definitions:
 *
 *   tree   - a strict hierarchical network, i.e. every node has at most one parent
 *   forest - a collection of trees. These distinct trees are thus not connected.
 *
 * So:
 * - in a network that is not a tree, there exist nodes with multiple parents.
 * - a network consisting of unconnected sub-networks, of which at least one
 *   is not a tree, is not a forest.
 *
 * In the code, the definitions are:
 *
 *   tree   - any disconnected sub-network, strict hierarchical or not.
 *   forest - a bunch of these sub-networks
 *
 * The difference between tree and not-tree is important in the code, notably within
 * to the block-shifting algorithm. The algorithm assumes formal trees and fails
 * for not-trees, often in a spectacular manner (search for 'exploding network' in the issues).
 *
 * In order to distinguish the definitions in the following code, the adjective 'formal' is
 * used. If 'formal' is absent, you must assume the non-formal definition.
 *
 * ----------------------------------------------------------------------------------
 * NOTES
 * =====
 *
 * A hierarchical layout is a different thing from a hierarchical network.
 * The layout is a way to arrange the nodes in the view; this can be done
 * on non-hierarchical networks as well. The converse is also possible.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var NetworkUtil = __webpack_require__(76)['default'];

var _require = __webpack_require__(236),
    HorizontalStrategy = _require.HorizontalStrategy,
    VerticalStrategy = _require.VerticalStrategy;

/**
 * Container for derived data on current network, relating to hierarchy.
 *
 * @private
 */


var HierarchicalStatus = function () {
  /**
   * @ignore
   */
  function HierarchicalStatus() {
    (0, _classCallCheck3['default'])(this, HierarchicalStatus);

    this.childrenReference = {}; // child id's per node id
    this.parentReference = {}; // parent id's per node id
    this.trees = {}; // tree id per node id; i.e. to which tree does given node id belong

    this.distributionOrdering = {}; // The nodes per level, in the display order
    this.levels = {}; // hierarchy level per node id
    this.distributionIndex = {}; // The position of the node in the level sorting order, per node id.

    this.isTree = false; // True if current network is a formal tree 
    this.treeIndex = -1; // Highest tree id in current network.
  }

  /**
   * Add the relation between given nodes to the current state.
   *
   * @param {Node.id} parentNodeId
   * @param {Node.id} childNodeId
   */


  (0, _createClass3['default'])(HierarchicalStatus, [{
    key: 'addRelation',
    value: function addRelation(parentNodeId, childNodeId) {
      if (this.childrenReference[parentNodeId] === undefined) {
        this.childrenReference[parentNodeId] = [];
      }
      this.childrenReference[parentNodeId].push(childNodeId);

      if (this.parentReference[childNodeId] === undefined) {
        this.parentReference[childNodeId] = [];
      }
      this.parentReference[childNodeId].push(parentNodeId);
    }

    /**
     * Check if the current state is for a formal tree or formal forest.
     *
     * This is the case if every node has at most one parent.
     *
     * Pre: parentReference init'ed properly for current network
     */

  }, {
    key: 'checkIfTree',
    value: function checkIfTree() {
      for (var i in this.parentReference) {
        if (this.parentReference[i].length > 1) {
          this.isTree = false;
          return;
        }
      }

      this.isTree = true;
    }

    /**
     * Return the number of separate trees in the current network.
     * @returns {number}
     */

  }, {
    key: 'numTrees',
    value: function numTrees() {
      return this.treeIndex + 1; // This assumes the indexes are assigned consecitively
    }

    /**
     * Assign a tree id to a node
     * @param {Node} node
     * @param {string|number} treeId
     */

  }, {
    key: 'setTreeIndex',
    value: function setTreeIndex(node, treeId) {
      if (treeId === undefined) return; // Don't bother

      if (this.trees[node.id] === undefined) {
        this.trees[node.id] = treeId;
        this.treeIndex = Math.max(treeId, this.treeIndex);
      }
    }

    /**
     * Ensure level for given id is defined.
     *
     * Sets level to zero for given node id if not already present
     *
     * @param {Node.id} nodeId
     */

  }, {
    key: 'ensureLevel',
    value: function ensureLevel(nodeId) {
      if (this.levels[nodeId] === undefined) {
        this.levels[nodeId] = 0;
      }
    }

    /**
     * get the maximum level of a branch.
     *
     * TODO: Never entered; find a test case to test this!
     * @param {Node.id} nodeId
     * @returns {number}
     */

  }, {
    key: 'getMaxLevel',
    value: function getMaxLevel(nodeId) {
      var _this = this;

      var accumulator = {};

      var _getMaxLevel = function _getMaxLevel(nodeId) {
        if (accumulator[nodeId] !== undefined) {
          return accumulator[nodeId];
        }
        var level = _this.levels[nodeId];
        if (_this.childrenReference[nodeId]) {
          var children = _this.childrenReference[nodeId];
          if (children.length > 0) {
            for (var i = 0; i < children.length; i++) {
              level = Math.max(level, _getMaxLevel(children[i]));
            }
          }
        }
        accumulator[nodeId] = level;
        return level;
      };

      return _getMaxLevel(nodeId);
    }

    /**
     *
     * @param {Node} nodeA
     * @param {Node} nodeB
     */

  }, {
    key: 'levelDownstream',
    value: function levelDownstream(nodeA, nodeB) {
      if (this.levels[nodeB.id] === undefined) {
        // set initial level
        if (this.levels[nodeA.id] === undefined) {
          this.levels[nodeA.id] = 0;
        }
        // set level
        this.levels[nodeB.id] = this.levels[nodeA.id] + 1;
      }
    }

    /**
     * Small util method to set the minimum levels of the nodes to zero.
     *
     * @param {Array.<Node>} nodes
     */

  }, {
    key: 'setMinLevelToZero',
    value: function setMinLevelToZero(nodes) {
      var minLevel = 1e9;
      // get the minimum level
      for (var nodeId in nodes) {
        if (nodes.hasOwnProperty(nodeId)) {
          if (this.levels[nodeId] !== undefined) {
            minLevel = Math.min(this.levels[nodeId], minLevel);
          }
        }
      }

      // subtract the minimum from the set so we have a range starting from 0
      for (var _nodeId in nodes) {
        if (nodes.hasOwnProperty(_nodeId)) {
          if (this.levels[_nodeId] !== undefined) {
            this.levels[_nodeId] -= minLevel;
          }
        }
      }
    }

    /**
     * Get the min and max xy-coordinates of a given tree
     *
     * @param {Array.<Node>} nodes
     * @param {number} index
     * @returns {{min_x: number, max_x: number, min_y: number, max_y: number}}
     */

  }, {
    key: 'getTreeSize',
    value: function getTreeSize(nodes, index) {
      var min_x = 1e9;
      var max_x = -1e9;
      var min_y = 1e9;
      var max_y = -1e9;

      for (var nodeId in this.trees) {
        if (this.trees.hasOwnProperty(nodeId)) {
          if (this.trees[nodeId] === index) {
            var node = nodes[nodeId];
            min_x = Math.min(node.x, min_x);
            max_x = Math.max(node.x, max_x);
            min_y = Math.min(node.y, min_y);
            max_y = Math.max(node.y, max_y);
          }
        }
      }

      return {
        min_x: min_x,
        max_x: max_x,
        min_y: min_y,
        max_y: max_y
      };
    }

    /**
     * Check if two nodes have the same parent(s)
     *
     * @param {Node} node1
     * @param {Node} node2
     * @return {boolean} true if the two nodes have a same ancestor node, false otherwise
     */

  }, {
    key: 'hasSameParent',
    value: function hasSameParent(node1, node2) {
      var parents1 = this.parentReference[node1.id];
      var parents2 = this.parentReference[node2.id];
      if (parents1 === undefined || parents2 === undefined) {
        return false;
      }

      for (var i = 0; i < parents1.length; i++) {
        for (var j = 0; j < parents2.length; j++) {
          if (parents1[i] == parents2[j]) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * Check if two nodes are in the same tree.
     *
     * @param {Node} node1
     * @param {Node} node2
     * @return {Boolean} true if this is so, false otherwise
     */

  }, {
    key: 'inSameSubNetwork',
    value: function inSameSubNetwork(node1, node2) {
      return this.trees[node1.id] === this.trees[node2.id];
    }

    /**
     * Get a list of the distinct levels in the current network
     *
     * @returns {Array}
     */

  }, {
    key: 'getLevels',
    value: function getLevels() {
      return (0, _keys2['default'])(this.distributionOrdering);
    }

    /**
     * Add a node to the ordering per level
     *
     * @param {Node} node
     * @param {number} level
     */

  }, {
    key: 'addToOrdering',
    value: function addToOrdering(node, level) {
      if (this.distributionOrdering[level] === undefined) {
        this.distributionOrdering[level] = [];
      }

      var isPresent = false;
      var curLevel = this.distributionOrdering[level];
      for (var n in curLevel) {
        //if (curLevel[n].id === node.id) {
        if (curLevel[n] === node) {
          isPresent = true;
          break;
        }
      }

      if (!isPresent) {
        this.distributionOrdering[level].push(node);
        this.distributionIndex[node.id] = this.distributionOrdering[level].length - 1;
      }
    }
  }]);
  return HierarchicalStatus;
}();

/**
 * The Layout Engine
 */


var LayoutEngine = function () {
  /**
   * @param {Object} body
   */
  function LayoutEngine(body) {
    (0, _classCallCheck3['default'])(this, LayoutEngine);

    this.body = body;

    this.initialRandomSeed = Math.round(Math.random() * 1000000);
    this.randomSeed = this.initialRandomSeed;
    this.setPhysics = false;
    this.options = {};
    this.optionsBackup = { physics: {} };

    this.defaultOptions = {
      randomSeed: undefined,
      improvedLayout: true,
      hierarchical: {
        enabled: false,
        levelSeparation: 150,
        nodeSpacing: 100,
        treeSpacing: 200,
        blockShifting: true,
        edgeMinimization: true,
        parentCentralization: true,
        direction: 'UD', // UD, DU, LR, RL
        sortMethod: 'hubsize' // hubsize, directed
      }
    };
    util.extend(this.options, this.defaultOptions);
    this.bindEventListeners();
  }

  /**
   * Binds event listeners
   */


  (0, _createClass3['default'])(LayoutEngine, [{
    key: 'bindEventListeners',
    value: function bindEventListeners() {
      var _this2 = this;

      this.body.emitter.on('_dataChanged', function () {
        _this2.setupHierarchicalLayout();
      });
      this.body.emitter.on('_dataLoaded', function () {
        _this2.layoutNetwork();
      });
      this.body.emitter.on('_resetHierarchicalLayout', function () {
        _this2.setupHierarchicalLayout();
      });
      this.body.emitter.on('_adjustEdgesForHierarchicalLayout', function () {
        if (_this2.options.hierarchical.enabled !== true) {
          return;
        }
        // get the type of static smooth curve in case it is required
        var type = _this2.direction.curveType();

        // force all edges into static smooth curves.
        _this2.body.emitter.emit('_forceDisableDynamicCurves', type, false);
      });
    }

    /**
     *
     * @param {Object} options
     * @param {Object} allOptions
     * @returns {Object}
     */

  }, {
    key: 'setOptions',
    value: function setOptions(options, allOptions) {
      if (options !== undefined) {
        var hierarchical = this.options.hierarchical;
        var prevHierarchicalState = hierarchical.enabled;
        util.selectiveDeepExtend(["randomSeed", "improvedLayout"], this.options, options);
        util.mergeOptions(this.options, options, 'hierarchical');
        if (options.randomSeed !== undefined) {
          this.initialRandomSeed = options.randomSeed;
        }

        if (hierarchical.enabled === true) {
          if (prevHierarchicalState === true) {
            // refresh the overridden options for nodes and edges.
            this.body.emitter.emit('refresh', true);
          }

          // make sure the level separation is the right way up
          if (hierarchical.direction === 'RL' || hierarchical.direction === 'DU') {
            if (hierarchical.levelSeparation > 0) {
              hierarchical.levelSeparation *= -1;
            }
          } else {
            if (hierarchical.levelSeparation < 0) {
              hierarchical.levelSeparation *= -1;
            }
          }

          this.setDirectionStrategy();

          this.body.emitter.emit('_resetHierarchicalLayout');
          // because the hierarchical system needs it's own physics and smooth curve settings,
          // we adapt the other options if needed.
          return this.adaptAllOptionsForHierarchicalLayout(allOptions);
        } else {
          if (prevHierarchicalState === true) {
            // refresh the overridden options for nodes and edges.
            this.body.emitter.emit('refresh');
            return util.deepExtend(allOptions, this.optionsBackup);
          }
        }
      }
      return allOptions;
    }

    /**
     *
     * @param {Object} allOptions
     * @returns {Object}
     */

  }, {
    key: 'adaptAllOptionsForHierarchicalLayout',
    value: function adaptAllOptionsForHierarchicalLayout(allOptions) {
      if (this.options.hierarchical.enabled === true) {
        var backupPhysics = this.optionsBackup.physics;

        // set the physics
        if (allOptions.physics === undefined || allOptions.physics === true) {
          allOptions.physics = {
            enabled: backupPhysics.enabled === undefined ? true : backupPhysics.enabled,
            solver: 'hierarchicalRepulsion'
          };
          backupPhysics.enabled = backupPhysics.enabled === undefined ? true : backupPhysics.enabled;
          backupPhysics.solver = backupPhysics.solver || 'barnesHut';
        } else if ((0, _typeof3['default'])(allOptions.physics) === 'object') {
          backupPhysics.enabled = allOptions.physics.enabled === undefined ? true : allOptions.physics.enabled;
          backupPhysics.solver = allOptions.physics.solver || 'barnesHut';
          allOptions.physics.solver = 'hierarchicalRepulsion';
        } else if (allOptions.physics !== false) {
          backupPhysics.solver = 'barnesHut';
          allOptions.physics = { solver: 'hierarchicalRepulsion' };
        }

        // get the type of static smooth curve in case it is required
        var type = this.direction.curveType();

        // disable smooth curves if nothing is defined. If smooth curves have been turned on,
        // turn them into static smooth curves.
        if (allOptions.edges === undefined) {
          this.optionsBackup.edges = { smooth: { enabled: true, type: 'dynamic' } };
          allOptions.edges = { smooth: false };
        } else if (allOptions.edges.smooth === undefined) {
          this.optionsBackup.edges = { smooth: { enabled: true, type: 'dynamic' } };
          allOptions.edges.smooth = false;
        } else {
          if (typeof allOptions.edges.smooth === 'boolean') {
            this.optionsBackup.edges = { smooth: allOptions.edges.smooth };
            allOptions.edges.smooth = { enabled: allOptions.edges.smooth, type: type };
          } else {
            var smooth = allOptions.edges.smooth;

            // allow custom types except for dynamic
            if (smooth.type !== undefined && smooth.type !== 'dynamic') {
              type = smooth.type;
            }

            // TODO: this is options merging; see if the standard routines can be used here.
            this.optionsBackup.edges = {
              smooth: smooth.enabled === undefined ? true : smooth.enabled,
              type: smooth.type === undefined ? 'dynamic' : smooth.type,
              roundness: smooth.roundness === undefined ? 0.5 : smooth.roundness,
              forceDirection: smooth.forceDirection === undefined ? false : smooth.forceDirection
            };

            // NOTE: Copying an object to self; this is basically setting defaults for undefined variables
            allOptions.edges.smooth = {
              enabled: smooth.enabled === undefined ? true : smooth.enabled,
              type: type,
              roundness: smooth.roundness === undefined ? 0.5 : smooth.roundness,
              forceDirection: smooth.forceDirection === undefined ? false : smooth.forceDirection
            };
          }
        }

        // Force all edges into static smooth curves.
        // Only applies to edges that do not use the global options for smooth.
        this.body.emitter.emit('_forceDisableDynamicCurves', type);
      }

      return allOptions;
    }

    /**
     *
     * @returns {number}
     */

  }, {
    key: 'seededRandom',
    value: function seededRandom() {
      var x = Math.sin(this.randomSeed++) * 10000;
      return x - Math.floor(x);
    }

    /**
     *
     * @param {Array.<Node>} nodesArray
     */

  }, {
    key: 'positionInitially',
    value: function positionInitially(nodesArray) {
      if (this.options.hierarchical.enabled !== true) {
        this.randomSeed = this.initialRandomSeed;
        var radius = nodesArray.length + 50;
        for (var i = 0; i < nodesArray.length; i++) {
          var node = nodesArray[i];
          var angle = 2 * Math.PI * this.seededRandom();
          if (node.x === undefined) {
            node.x = radius * Math.cos(angle);
          }
          if (node.y === undefined) {
            node.y = radius * Math.sin(angle);
          }
        }
      }
    }

    /**
     * Use Kamada Kawai to position nodes. This is quite a heavy algorithm so if there are a lot of nodes we
     * cluster them first to reduce the amount.
     */

  }, {
    key: 'layoutNetwork',
    value: function layoutNetwork() {
      if (this.options.hierarchical.enabled !== true && this.options.improvedLayout === true) {
        var indices = this.body.nodeIndices;

        // first check if we should Kamada Kawai to layout. The threshold is if less than half of the visible
        // nodes have predefined positions we use this.
        var positionDefined = 0;
        for (var i = 0; i < indices.length; i++) {
          var node = this.body.nodes[indices[i]];
          if (node.predefinedPosition === true) {
            positionDefined += 1;
          }
        }

        // if less than half of the nodes have a predefined position we continue
        if (positionDefined < 0.5 * indices.length) {
          var MAX_LEVELS = 10;
          var level = 0;
          var clusterThreshold = 150; // TODO add this to options

          //
          // Define the options for the hidden cluster nodes
          // These options don't propagate outside the clustering phase.
          //
          // Some options are explicitly disabled, because they may be set in group or default node options.
          // The clusters are never displayed, so most explicit settings here serve as performance optimizations.
          //
          // The explicit setting of 'shape' is to avoid `shape: 'image'`; images are not passed to the hidden
          // cluster nodes, leading to an exception on creation.
          //
          // All settings here are performance related, except when noted otherwise.
          //
          var clusterOptions = {
            clusterNodeProperties: {
              shape: 'ellipse', // Bugfix: avoid type 'image', no images supplied
              label: '', // avoid label handling
              group: '', // avoid group handling
              font: { multi: false } // avoid font propagation
            },
            clusterEdgeProperties: {
              label: '', // avoid label handling
              font: { multi: false }, // avoid font propagation
              smooth: {
                enabled: false // avoid drawing penalty for complex edges
              }
            }
          };

          // if there are a lot of nodes, we cluster before we run the algorithm.
          // NOTE: this part fails to find clusters for large scale-free networks, which should
          //       be easily clusterable.
          // TODO: examine why this is so
          if (indices.length > clusterThreshold) {
            var startLength = indices.length;
            while (indices.length > clusterThreshold && level <= MAX_LEVELS) {
              //console.time("clustering")
              level += 1;
              var before = indices.length;
              // if there are many nodes we do a hubsize cluster
              if (level % 3 === 0) {
                this.body.modules.clustering.clusterBridges(clusterOptions);
              } else {
                this.body.modules.clustering.clusterOutliers(clusterOptions);
              }
              var after = indices.length;
              if (before == after && level % 3 !== 0) {
                this._declusterAll();
                this.body.emitter.emit("_layoutFailed");
                console.info("This network could not be positioned by this version of the improved layout algorithm." + " Please disable improvedLayout for better performance.");
                return;
              }
              //console.timeEnd("clustering")
              //console.log(before,level,after);
            }
            // increase the size of the edges
            this.body.modules.kamadaKawai.setOptions({ springLength: Math.max(150, 2 * startLength) });
          }
          if (level > MAX_LEVELS) {
            console.info("The clustering didn't succeed within the amount of interations allowed," + " progressing with partial result.");
          }

          // position the system for these nodes and edges
          this.body.modules.kamadaKawai.solve(indices, this.body.edgeIndices, true);

          // shift to center point
          this._shiftToCenter();

          // perturb the nodes a little bit to force the physics to kick in
          var offset = 70;
          for (var _i = 0; _i < indices.length; _i++) {
            // Only perturb the nodes that aren't fixed
            var _node = this.body.nodes[indices[_i]];
            if (_node.predefinedPosition === false) {
              _node.x += (0.5 - this.seededRandom()) * offset;
              _node.y += (0.5 - this.seededRandom()) * offset;
            }
          }

          // uncluster all clusters
          this._declusterAll();

          // reposition all bezier nodes.
          this.body.emitter.emit("_repositionBezierNodes");
        }
      }
    }

    /**
     * Move all the nodes towards to the center so gravitational pull wil not move the nodes away from view
     * @private
     */

  }, {
    key: '_shiftToCenter',
    value: function _shiftToCenter() {
      var range = NetworkUtil.getRangeCore(this.body.nodes, this.body.nodeIndices);
      var center = NetworkUtil.findCenter(range);
      for (var i = 0; i < this.body.nodeIndices.length; i++) {
        var node = this.body.nodes[this.body.nodeIndices[i]];
        node.x -= center.x;
        node.y -= center.y;
      }
    }

    /**
     * Expands all clusters
     * @private
     */

  }, {
    key: '_declusterAll',
    value: function _declusterAll() {
      var clustersPresent = true;
      while (clustersPresent === true) {
        clustersPresent = false;
        for (var i = 0; i < this.body.nodeIndices.length; i++) {
          if (this.body.nodes[this.body.nodeIndices[i]].isCluster === true) {
            clustersPresent = true;
            this.body.modules.clustering.openCluster(this.body.nodeIndices[i], {}, false);
          }
        }
        if (clustersPresent === true) {
          this.body.emitter.emit('_dataChanged');
        }
      }
    }

    /**
     *
     * @returns {number|*}
     */

  }, {
    key: 'getSeed',
    value: function getSeed() {
      return this.initialRandomSeed;
    }

    /**
     * This is the main function to layout the nodes in a hierarchical way.
     * It checks if the node details are supplied correctly
     *
     * @private
     */

  }, {
    key: 'setupHierarchicalLayout',
    value: function setupHierarchicalLayout() {
      if (this.options.hierarchical.enabled === true && this.body.nodeIndices.length > 0) {
        // get the size of the largest hubs and check if the user has defined a level for a node.
        var node = void 0,
            nodeId = void 0;
        var definedLevel = false;
        var undefinedLevel = false;
        this.lastNodeOnLevel = {};
        this.hierarchical = new HierarchicalStatus();

        for (nodeId in this.body.nodes) {
          if (this.body.nodes.hasOwnProperty(nodeId)) {
            node = this.body.nodes[nodeId];
            if (node.options.level !== undefined) {
              definedLevel = true;
              this.hierarchical.levels[nodeId] = node.options.level;
            } else {
              undefinedLevel = true;
            }
          }
        }

        // if the user defined some levels but not all, alert and run without hierarchical layout
        if (undefinedLevel === true && definedLevel === true) {
          throw new Error('To use the hierarchical layout, nodes require either no predefined levels' + ' or levels have to be defined for all nodes.');
        } else {
          // define levels if undefined by the users. Based on hubsize.
          if (undefinedLevel === true) {
            var sortMethod = this.options.hierarchical.sortMethod;
            if (sortMethod === 'hubsize') {
              this._determineLevelsByHubsize();
            } else if (sortMethod === 'directed') {
              this._determineLevelsDirected();
            } else if (sortMethod === 'custom') {
              this._determineLevelsCustomCallback();
            }
          }

          // fallback for cases where there are nodes but no edges
          for (var _nodeId2 in this.body.nodes) {
            if (this.body.nodes.hasOwnProperty(_nodeId2)) {
              this.hierarchical.ensureLevel(_nodeId2);
            }
          }
          // check the distribution of the nodes per level.
          var distribution = this._getDistribution();

          // get the parent children relations.
          this._generateMap();

          // place the nodes on the canvas.
          this._placeNodesByHierarchy(distribution);

          // condense the whitespace.
          this._condenseHierarchy();

          // shift to center so gravity does not have to do much
          this._shiftToCenter();
        }
      }
    }

    /**
     * @private
     */

  }, {
    key: '_condenseHierarchy',
    value: function _condenseHierarchy() {
      var _this3 = this;

      // Global var in this scope to define when the movement has stopped.
      var stillShifting = false;
      var branches = {};
      // first we have some methods to help shifting trees around.
      // the main method to shift the trees
      var shiftTrees = function shiftTrees() {
        var treeSizes = getTreeSizes();
        var shiftBy = 0;
        for (var i = 0; i < treeSizes.length - 1; i++) {
          var diff = treeSizes[i].max - treeSizes[i + 1].min;
          shiftBy += diff + _this3.options.hierarchical.treeSpacing;
          shiftTree(i + 1, shiftBy);
        }
      };

      // shift a single tree by an offset
      var shiftTree = function shiftTree(index, offset) {
        var trees = _this3.hierarchical.trees;

        for (var nodeId in trees) {
          if (trees.hasOwnProperty(nodeId)) {
            if (trees[nodeId] === index) {
              _this3.direction.shift(nodeId, offset);
            }
          }
        }
      };

      // get the width of all trees
      var getTreeSizes = function getTreeSizes() {
        var treeWidths = [];
        for (var i = 0; i < _this3.hierarchical.numTrees(); i++) {
          treeWidths.push(_this3.direction.getTreeSize(i));
        }
        return treeWidths;
      };

      // get a map of all nodes in this branch
      var getBranchNodes = function getBranchNodes(source, map) {
        if (map[source.id]) {
          return;
        }
        map[source.id] = true;
        if (_this3.hierarchical.childrenReference[source.id]) {
          var children = _this3.hierarchical.childrenReference[source.id];
          if (children.length > 0) {
            for (var i = 0; i < children.length; i++) {
              getBranchNodes(_this3.body.nodes[children[i]], map);
            }
          }
        }
      };

      // get a min max width as well as the maximum movement space it has on either sides
      // we use min max terminology because width and height can interchange depending on the direction of the layout
      var getBranchBoundary = function getBranchBoundary(branchMap) {
        var maxLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1e9;

        var minSpace = 1e9;
        var maxSpace = 1e9;
        var min = 1e9;
        var max = -1e9;
        for (var branchNode in branchMap) {
          if (branchMap.hasOwnProperty(branchNode)) {
            var node = _this3.body.nodes[branchNode];
            var level = _this3.hierarchical.levels[node.id];
            var position = _this3.direction.getPosition(node);

            // get the space around the node.

            var _getSpaceAroundNode2 = _this3._getSpaceAroundNode(node, branchMap),
                _getSpaceAroundNode3 = (0, _slicedToArray3['default'])(_getSpaceAroundNode2, 2),
                minSpaceNode = _getSpaceAroundNode3[0],
                maxSpaceNode = _getSpaceAroundNode3[1];

            minSpace = Math.min(minSpaceNode, minSpace);
            maxSpace = Math.min(maxSpaceNode, maxSpace);

            // the width is only relevant for the levels two nodes have in common. This is why we filter on this.
            if (level <= maxLevel) {
              min = Math.min(position, min);
              max = Math.max(position, max);
            }
          }
        }

        return [min, max, minSpace, maxSpace];
      };

      // check what the maximum level is these nodes have in common.
      var getCollisionLevel = function getCollisionLevel(node1, node2) {
        var maxLevel1 = _this3.hierarchical.getMaxLevel(node1.id);
        var maxLevel2 = _this3.hierarchical.getMaxLevel(node2.id);
        return Math.min(maxLevel1, maxLevel2);
      };

      /**
       * Condense elements. These can be nodes or branches depending on the callback.
       *
       * @param {function} callback
       * @param {Array.<number>} levels
       * @param {*} centerParents
       */
      var shiftElementsCloser = function shiftElementsCloser(callback, levels, centerParents) {
        var hier = _this3.hierarchical;

        for (var i = 0; i < levels.length; i++) {
          var level = levels[i];
          var levelNodes = hier.distributionOrdering[level];
          if (levelNodes.length > 1) {
            for (var j = 0; j < levelNodes.length - 1; j++) {
              var node1 = levelNodes[j];
              var node2 = levelNodes[j + 1];

              // NOTE: logic maintained as it was; if nodes have same ancestor,
              //       then of course they are in the same sub-network.
              if (hier.hasSameParent(node1, node2) && hier.inSameSubNetwork(node1, node2)) {
                callback(node1, node2, centerParents);
              }
            }
          }
        }
      };

      // callback for shifting branches
      var branchShiftCallback = function branchShiftCallback(node1, node2) {
        var centerParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        //window.CALLBACKS.push(() => {
        var pos1 = _this3.direction.getPosition(node1);
        var pos2 = _this3.direction.getPosition(node2);
        var diffAbs = Math.abs(pos2 - pos1);
        var nodeSpacing = _this3.options.hierarchical.nodeSpacing;
        //console.log("NOW CHECKING:", node1.id, node2.id, diffAbs);
        if (diffAbs > nodeSpacing) {
          var branchNodes1 = {};
          var branchNodes2 = {};

          getBranchNodes(node1, branchNodes1);
          getBranchNodes(node2, branchNodes2);

          // check the largest distance between the branches
          var maxLevel = getCollisionLevel(node1, node2);
          var branchNodeBoundary1 = getBranchBoundary(branchNodes1, maxLevel);
          var branchNodeBoundary2 = getBranchBoundary(branchNodes2, maxLevel);
          var max1 = branchNodeBoundary1[1];
          var min2 = branchNodeBoundary2[0];
          var minSpace2 = branchNodeBoundary2[2];

          //console.log(node1.id, getBranchBoundary(branchNodes1, maxLevel), node2.id,
          //            getBranchBoundary(branchNodes2, maxLevel), maxLevel);
          var diffBranch = Math.abs(max1 - min2);
          if (diffBranch > nodeSpacing) {
            var offset = max1 - min2 + nodeSpacing;
            if (offset < -minSpace2 + nodeSpacing) {
              offset = -minSpace2 + nodeSpacing;
              //console.log("RESETTING OFFSET", max1 - min2 + this.options.hierarchical.nodeSpacing, -minSpace2, offset);
            }
            if (offset < 0) {
              //console.log("SHIFTING", node2.id, offset);
              _this3._shiftBlock(node2.id, offset);
              stillShifting = true;

              if (centerParent === true) _this3._centerParent(node2);
            }
          }
        }
        //this.body.emitter.emit("_redraw");})
      };

      var minimizeEdgeLength = function minimizeEdgeLength(iterations, node) {
        //window.CALLBACKS.push(() => {
        //  console.log("ts",node.id);
        var nodeId = node.id;
        var allEdges = node.edges;
        var nodeLevel = _this3.hierarchical.levels[node.id];

        // gather constants
        var C2 = _this3.options.hierarchical.levelSeparation * _this3.options.hierarchical.levelSeparation;
        var referenceNodes = {};
        var aboveEdges = [];
        for (var i = 0; i < allEdges.length; i++) {
          var edge = allEdges[i];
          if (edge.toId != edge.fromId) {
            var otherNode = edge.toId == nodeId ? edge.from : edge.to;
            referenceNodes[allEdges[i].id] = otherNode;
            if (_this3.hierarchical.levels[otherNode.id] < nodeLevel) {
              aboveEdges.push(edge);
            }
          }
        }

        // differentiated sum of lengths based on only moving one node over one axis
        var getFx = function getFx(point, edges) {
          var sum = 0;
          for (var _i2 = 0; _i2 < edges.length; _i2++) {
            if (referenceNodes[edges[_i2].id] !== undefined) {
              var a = _this3.direction.getPosition(referenceNodes[edges[_i2].id]) - point;
              sum += a / Math.sqrt(a * a + C2);
            }
          }
          return sum;
        };

        // doubly differentiated sum of lengths based on only moving one node over one axis
        var getDFx = function getDFx(point, edges) {
          var sum = 0;
          for (var _i3 = 0; _i3 < edges.length; _i3++) {
            if (referenceNodes[edges[_i3].id] !== undefined) {
              var a = _this3.direction.getPosition(referenceNodes[edges[_i3].id]) - point;
              sum -= C2 * Math.pow(a * a + C2, -1.5);
            }
          }
          return sum;
        };

        var getGuess = function getGuess(iterations, edges) {
          var guess = _this3.direction.getPosition(node);
          // Newton's method for optimization
          var guessMap = {};
          for (var _i4 = 0; _i4 < iterations; _i4++) {
            var fx = getFx(guess, edges);
            var dfx = getDFx(guess, edges);

            // we limit the movement to avoid instability.
            var limit = 40;
            var ratio = Math.max(-limit, Math.min(limit, Math.round(fx / dfx)));
            guess = guess - ratio;
            // reduce duplicates
            if (guessMap[guess] !== undefined) {
              break;
            }
            guessMap[guess] = _i4;
          }
          return guess;
        };

        var moveBranch = function moveBranch(guess) {
          // position node if there is space
          var nodePosition = _this3.direction.getPosition(node);

          // check movable area of the branch
          if (branches[node.id] === undefined) {
            var branchNodes = {};
            getBranchNodes(node, branchNodes);
            branches[node.id] = branchNodes;
          }
          var branchBoundary = getBranchBoundary(branches[node.id]);
          var minSpaceBranch = branchBoundary[2];
          var maxSpaceBranch = branchBoundary[3];

          var diff = guess - nodePosition;

          // check if we are allowed to move the node:
          var branchOffset = 0;
          if (diff > 0) {
            branchOffset = Math.min(diff, maxSpaceBranch - _this3.options.hierarchical.nodeSpacing);
          } else if (diff < 0) {
            branchOffset = -Math.min(-diff, minSpaceBranch - _this3.options.hierarchical.nodeSpacing);
          }

          if (branchOffset != 0) {
            //console.log("moving branch:",branchOffset, maxSpaceBranch, minSpaceBranch)
            _this3._shiftBlock(node.id, branchOffset);
            //this.body.emitter.emit("_redraw");
            stillShifting = true;
          }
        };

        var moveNode = function moveNode(guess) {
          var nodePosition = _this3.direction.getPosition(node);

          // position node if there is space

          var _getSpaceAroundNode4 = _this3._getSpaceAroundNode(node),
              _getSpaceAroundNode5 = (0, _slicedToArray3['default'])(_getSpaceAroundNode4, 2),
              minSpace = _getSpaceAroundNode5[0],
              maxSpace = _getSpaceAroundNode5[1];

          var diff = guess - nodePosition;
          // check if we are allowed to move the node:
          var newPosition = nodePosition;
          if (diff > 0) {
            newPosition = Math.min(nodePosition + (maxSpace - _this3.options.hierarchical.nodeSpacing), guess);
          } else if (diff < 0) {
            newPosition = Math.max(nodePosition - (minSpace - _this3.options.hierarchical.nodeSpacing), guess);
          }

          if (newPosition !== nodePosition) {
            //console.log("moving Node:",diff, minSpace, maxSpace);
            _this3.direction.setPosition(node, newPosition);
            //this.body.emitter.emit("_redraw");
            stillShifting = true;
          }
        };

        var guess = getGuess(iterations, aboveEdges);
        moveBranch(guess);
        guess = getGuess(iterations, allEdges);
        moveNode(guess);
        //})
      };

      // method to remove whitespace between branches. Because we do bottom up, we can center the parents.
      var minimizeEdgeLengthBottomUp = function minimizeEdgeLengthBottomUp(iterations) {
        var levels = _this3.hierarchical.getLevels();
        levels = levels.reverse();
        for (var i = 0; i < iterations; i++) {
          stillShifting = false;
          for (var j = 0; j < levels.length; j++) {
            var level = levels[j];
            var levelNodes = _this3.hierarchical.distributionOrdering[level];
            for (var k = 0; k < levelNodes.length; k++) {
              minimizeEdgeLength(1000, levelNodes[k]);
            }
          }
          if (stillShifting !== true) {
            //console.log("FINISHED minimizeEdgeLengthBottomUp IN " + i);
            break;
          }
        }
      };

      // method to remove whitespace between branches. Because we do bottom up, we can center the parents.
      var shiftBranchesCloserBottomUp = function shiftBranchesCloserBottomUp(iterations) {
        var levels = _this3.hierarchical.getLevels();
        levels = levels.reverse();
        for (var i = 0; i < iterations; i++) {
          stillShifting = false;
          shiftElementsCloser(branchShiftCallback, levels, true);
          if (stillShifting !== true) {
            //console.log("FINISHED shiftBranchesCloserBottomUp IN " + (i+1));
            break;
          }
        }
      };

      // center all parents
      var centerAllParents = function centerAllParents() {
        for (var nodeId in _this3.body.nodes) {
          if (_this3.body.nodes.hasOwnProperty(nodeId)) _this3._centerParent(_this3.body.nodes[nodeId]);
        }
      };

      // center all parents
      var centerAllParentsBottomUp = function centerAllParentsBottomUp() {
        var levels = _this3.hierarchical.getLevels();
        levels = levels.reverse();
        for (var i = 0; i < levels.length; i++) {
          var level = levels[i];
          var levelNodes = _this3.hierarchical.distributionOrdering[level];
          for (var j = 0; j < levelNodes.length; j++) {
            _this3._centerParent(levelNodes[j]);
          }
        }
      };

      // the actual work is done here.
      if (this.options.hierarchical.blockShifting === true) {
        shiftBranchesCloserBottomUp(5);
        centerAllParents();
      }

      // minimize edge length
      if (this.options.hierarchical.edgeMinimization === true) {
        minimizeEdgeLengthBottomUp(20);
      }

      if (this.options.hierarchical.parentCentralization === true) {
        centerAllParentsBottomUp();
      }

      shiftTrees();
    }

    /**
     * This gives the space around the node. IF a map is supplied, it will only check against nodes NOT in the map.
     * This is used to only get the distances to nodes outside of a branch.
     * @param {Node} node
     * @param {{Node.id: vis.Node}} map
     * @returns {number[]}
     * @private
     */

  }, {
    key: '_getSpaceAroundNode',
    value: function _getSpaceAroundNode(node, map) {
      var useMap = true;
      if (map === undefined) {
        useMap = false;
      }
      var level = this.hierarchical.levels[node.id];
      if (level !== undefined) {
        var index = this.hierarchical.distributionIndex[node.id];
        var position = this.direction.getPosition(node);
        var ordering = this.hierarchical.distributionOrdering[level];
        var minSpace = 1e9;
        var maxSpace = 1e9;
        if (index !== 0) {
          var prevNode = ordering[index - 1];
          if (useMap === true && map[prevNode.id] === undefined || useMap === false) {
            var prevPos = this.direction.getPosition(prevNode);
            minSpace = position - prevPos;
          }
        }

        if (index != ordering.length - 1) {
          var nextNode = ordering[index + 1];
          if (useMap === true && map[nextNode.id] === undefined || useMap === false) {
            var nextPos = this.direction.getPosition(nextNode);
            maxSpace = Math.min(maxSpace, nextPos - position);
          }
        }

        return [minSpace, maxSpace];
      } else {
        return [0, 0];
      }
    }

    /**
     * We use this method to center a parent node and check if it does not cross other nodes when it does.
     * @param {Node} node
     * @private
     */

  }, {
    key: '_centerParent',
    value: function _centerParent(node) {
      if (this.hierarchical.parentReference[node.id]) {
        var parents = this.hierarchical.parentReference[node.id];
        for (var i = 0; i < parents.length; i++) {
          var parentId = parents[i];
          var parentNode = this.body.nodes[parentId];
          var children = this.hierarchical.childrenReference[parentId];

          if (children !== undefined) {
            // get the range of the children
            var newPosition = this._getCenterPosition(children);

            var position = this.direction.getPosition(parentNode);

            var _getSpaceAroundNode6 = this._getSpaceAroundNode(parentNode),
                _getSpaceAroundNode7 = (0, _slicedToArray3['default'])(_getSpaceAroundNode6, 2),
                minSpace = _getSpaceAroundNode7[0],
                maxSpace = _getSpaceAroundNode7[1];

            var diff = position - newPosition;
            if (diff < 0 && Math.abs(diff) < maxSpace - this.options.hierarchical.nodeSpacing || diff > 0 && Math.abs(diff) < minSpace - this.options.hierarchical.nodeSpacing) {
              this.direction.setPosition(parentNode, newPosition);
            }
          }
        }
      }
    }

    /**
     * This function places the nodes on the canvas based on the hierarchial distribution.
     *
     * @param {Object} distribution | obtained by the function this._getDistribution()
     * @private
     */

  }, {
    key: '_placeNodesByHierarchy',
    value: function _placeNodesByHierarchy(distribution) {
      this.positionedNodes = {};
      // start placing all the level 0 nodes first. Then recursively position their branches.
      for (var level in distribution) {
        if (distribution.hasOwnProperty(level)) {
          // sort nodes in level by position:
          var nodeArray = (0, _keys2['default'])(distribution[level]);
          nodeArray = this._indexArrayToNodes(nodeArray);
          this.direction.sort(nodeArray);
          var handledNodeCount = 0;

          for (var i = 0; i < nodeArray.length; i++) {
            var node = nodeArray[i];
            if (this.positionedNodes[node.id] === undefined) {
              var spacing = this.options.hierarchical.nodeSpacing;
              var pos = spacing * handledNodeCount;
              // We get the X or Y values we need and store them in pos and previousPos.
              // The get and set make sure we get X or Y
              if (handledNodeCount > 0) {
                pos = this.direction.getPosition(nodeArray[i - 1]) + spacing;
              }
              this.direction.setPosition(node, pos, level);
              this._validatePositionAndContinue(node, level, pos);

              handledNodeCount++;
            }
          }
        }
      }
    }

    /**
     * This is a recursively called function to enumerate the branches from the largest hubs and place the nodes
     * on a X position that ensures there will be no overlap.
     *
     * @param {Node.id} parentId
     * @param {number} parentLevel
     * @private
     */

  }, {
    key: '_placeBranchNodes',
    value: function _placeBranchNodes(parentId, parentLevel) {
      var childRef = this.hierarchical.childrenReference[parentId];

      // if this is not a parent, cancel the placing. This can happen with multiple parents to one child.
      if (childRef === undefined) {
        return;
      }

      // get a list of childNodes
      var childNodes = [];
      for (var i = 0; i < childRef.length; i++) {
        childNodes.push(this.body.nodes[childRef[i]]);
      }

      // use the positions to order the nodes.
      this.direction.sort(childNodes);

      // position the childNodes
      for (var _i5 = 0; _i5 < childNodes.length; _i5++) {
        var childNode = childNodes[_i5];
        var childNodeLevel = this.hierarchical.levels[childNode.id];
        // check if the child node is below the parent node and if it has already been positioned.
        if (childNodeLevel > parentLevel && this.positionedNodes[childNode.id] === undefined) {
          // get the amount of space required for this node. If parent the width is based on the amount of children.
          var spacing = this.options.hierarchical.nodeSpacing;
          var pos = void 0;

          // we get the X or Y values we need and store them in pos and previousPos.
          // The get and set make sure we get X or Y
          if (_i5 === 0) {
            pos = this.direction.getPosition(this.body.nodes[parentId]);
          } else {
            pos = this.direction.getPosition(childNodes[_i5 - 1]) + spacing;
          }
          this.direction.setPosition(childNode, pos, childNodeLevel);
          this._validatePositionAndContinue(childNode, childNodeLevel, pos);
        } else {
          return;
        }
      }

      // center the parent nodes.
      var center = this._getCenterPosition(childNodes);
      this.direction.setPosition(this.body.nodes[parentId], center, parentLevel);
    }

    /**
     * This method checks for overlap and if required shifts the branch. It also keeps records of positioned nodes.
     * Finally it will call _placeBranchNodes to place the branch nodes.
     * @param {Node} node
     * @param {number} level
     * @param {number} pos
     * @private
     */

  }, {
    key: '_validatePositionAndContinue',
    value: function _validatePositionAndContinue(node, level, pos) {
      // This method only works for formal trees and formal forests
      // Early exit if this is not the case
      if (!this.hierarchical.isTree) return;

      // if overlap has been detected, we shift the branch
      if (this.lastNodeOnLevel[level] !== undefined) {
        var previousPos = this.direction.getPosition(this.body.nodes[this.lastNodeOnLevel[level]]);
        if (pos - previousPos < this.options.hierarchical.nodeSpacing) {
          var diff = previousPos + this.options.hierarchical.nodeSpacing - pos;
          var sharedParent = this._findCommonParent(this.lastNodeOnLevel[level], node.id);
          this._shiftBlock(sharedParent.withChild, diff);
        }
      }

      this.lastNodeOnLevel[level] = node.id; // store change in position.
      this.positionedNodes[node.id] = true;
      this._placeBranchNodes(node.id, level);
    }

    /**
     * Receives an array with node indices and returns an array with the actual node references.
     * Used for sorting based on node properties.
     * @param {Array.<Node.id>} idArray
     * @returns {Array.<Node>}
     */

  }, {
    key: '_indexArrayToNodes',
    value: function _indexArrayToNodes(idArray) {
      var array = [];
      for (var i = 0; i < idArray.length; i++) {
        array.push(this.body.nodes[idArray[i]]);
      }
      return array;
    }

    /**
     * This function get the distribution of levels based on hubsize
     *
     * @returns {Object}
     * @private
     */

  }, {
    key: '_getDistribution',
    value: function _getDistribution() {
      var distribution = {};
      var nodeId = void 0,
          node = void 0;

      // we fix Y because the hierarchy is vertical,
      // we fix X so we do not give a node an x position for a second time.
      // the fix of X is removed after the x value has been set.
      for (nodeId in this.body.nodes) {
        if (this.body.nodes.hasOwnProperty(nodeId)) {
          node = this.body.nodes[nodeId];
          var level = this.hierarchical.levels[nodeId] === undefined ? 0 : this.hierarchical.levels[nodeId];
          this.direction.fix(node, level);
          if (distribution[level] === undefined) {
            distribution[level] = {};
          }
          distribution[level][nodeId] = node;
        }
      }
      return distribution;
    }

    /**
     * Return the active (i.e. visible) edges for this node
     *
     * @param {Node} node
     * @returns {Array.<vis.Edge>} Array of edge instances
     * @private
     */

  }, {
    key: '_getActiveEdges',
    value: function _getActiveEdges(node) {
      var _this4 = this;

      var result = [];

      util.forEach(node.edges, function (edge) {
        if (_this4.body.edgeIndices.indexOf(edge.id) !== -1) {
          result.push(edge);
        }
      });

      return result;
    }

    /**
     * Get the hubsizes for all active nodes.
     *
     * @returns {number}
     * @private
     */

  }, {
    key: '_getHubSizes',
    value: function _getHubSizes() {
      var _this5 = this;

      var hubSizes = {};
      var nodeIds = this.body.nodeIndices;

      util.forEach(nodeIds, function (nodeId) {
        var node = _this5.body.nodes[nodeId];
        var hubSize = _this5._getActiveEdges(node).length;
        hubSizes[hubSize] = true;
      });

      // Make an array of the size sorted descending
      var result = [];
      util.forEach(hubSizes, function (size) {
        result.push(Number(size));
      });

      result.sort(function (a, b) {
        return b - a;
      });

      return result;
    }

    /**
     * this function allocates nodes in levels based on the recursive branching from the largest hubs.
     *
     * @private
     */

  }, {
    key: '_determineLevelsByHubsize',
    value: function _determineLevelsByHubsize() {
      var _this6 = this;

      var levelDownstream = function levelDownstream(nodeA, nodeB) {
        _this6.hierarchical.levelDownstream(nodeA, nodeB);
      };

      var hubSizes = this._getHubSizes();

      var _loop = function _loop(i) {
        var hubSize = hubSizes[i];
        if (hubSize === 0) return 'break';

        util.forEach(_this6.body.nodeIndices, function (nodeId) {
          var node = _this6.body.nodes[nodeId];

          if (hubSize === _this6._getActiveEdges(node).length) {
            _this6._crawlNetwork(levelDownstream, nodeId);
          }
        });
      };

      for (var i = 0; i < hubSizes.length; ++i) {
        var _ret = _loop(i);

        if (_ret === 'break') break;
      }
    }

    /**
     * TODO: release feature
     * TODO: Determine if this feature is needed at all
     *
     * @private
     */

  }, {
    key: '_determineLevelsCustomCallback',
    value: function _determineLevelsCustomCallback() {
      var _this7 = this;

      var minLevel = 100000;

      // TODO: this should come from options.
      var customCallback = function customCallback(nodeA, nodeB, edge) {// eslint-disable-line no-unused-vars

      };

      // TODO: perhaps move to HierarchicalStatus.
      //       But I currently don't see the point, this method is not used.
      var levelByDirection = function levelByDirection(nodeA, nodeB, edge) {
        var levelA = _this7.hierarchical.levels[nodeA.id];
        // set initial level
        if (levelA === undefined) {
          levelA = _this7.hierarchical.levels[nodeA.id] = minLevel;
        }

        var diff = customCallback(NetworkUtil.cloneOptions(nodeA, 'node'), NetworkUtil.cloneOptions(nodeB, 'node'), NetworkUtil.cloneOptions(edge, 'edge'));

        _this7.hierarchical.levels[nodeB.id] = levelA + diff;
      };

      this._crawlNetwork(levelByDirection);
      this.hierarchical.setMinLevelToZero(this.body.nodes);
    }

    /**
     * Allocate nodes in levels based on the direction of the edges.
     *
     * @private
     */

  }, {
    key: '_determineLevelsDirected',
    value: function _determineLevelsDirected() {
      var _this8 = this;

      var minLevel = 10000;

      /**
       * Check if there is an edge going the opposite direction for given edge
       *
       * @param {Edge} edge  edge to check
       * @returns {boolean} true if there's another edge going into the opposite direction
       */
      var isBidirectional = function isBidirectional(edge) {
        util.forEach(_this8.body.edges, function (otherEdge) {
          if (otherEdge.toId === edge.fromId && otherEdge.fromId === edge.toId) {
            return true;
          }
        });

        return false;
      };

      var levelByDirection = function levelByDirection(nodeA, nodeB, edge) {
        var levelA = _this8.hierarchical.levels[nodeA.id];
        var levelB = _this8.hierarchical.levels[nodeB.id];

        if (isBidirectional(edge) && levelA !== undefined && levelB !== undefined) {
          // Don't redo the level determination if already done in this case.
          return;
        }

        // set initial level
        if (levelA === undefined) {
          levelA = _this8.hierarchical.levels[nodeA.id] = minLevel;
        }
        if (edge.toId == nodeB.id) {
          _this8.hierarchical.levels[nodeB.id] = levelA + 1;
        } else {
          _this8.hierarchical.levels[nodeB.id] = levelA - 1;
        }
      };

      this._crawlNetwork(levelByDirection);
      this.hierarchical.setMinLevelToZero(this.body.nodes);
    }

    /**
     * Update the bookkeeping of parent and child.
     * @private
     */

  }, {
    key: '_generateMap',
    value: function _generateMap() {
      var _this9 = this;

      var fillInRelations = function fillInRelations(parentNode, childNode) {
        if (_this9.hierarchical.levels[childNode.id] > _this9.hierarchical.levels[parentNode.id]) {
          _this9.hierarchical.addRelation(parentNode.id, childNode.id);
        }
      };

      this._crawlNetwork(fillInRelations);
      this.hierarchical.checkIfTree();
    }

    /**
     * Crawl over the entire network and use a callback on each node couple that is connected to each other.
     * @param {function} [callback=function(){}]          | will receive nodeA, nodeB and the connecting edge. A and B are distinct.
     * @param {Node.id} startingNodeId
     * @private
     */

  }, {
    key: '_crawlNetwork',
    value: function _crawlNetwork() {
      var _this10 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var startingNodeId = arguments[1];

      var progress = {};

      var crawler = function crawler(node, tree) {
        if (progress[node.id] === undefined) {
          _this10.hierarchical.setTreeIndex(node, tree);

          progress[node.id] = true;
          var childNode = void 0;
          var edges = _this10._getActiveEdges(node);
          for (var i = 0; i < edges.length; i++) {
            var edge = edges[i];
            if (edge.connected === true) {
              if (edge.toId == node.id) {
                // Not '===' because id's can be string and numeric
                childNode = edge.from;
              } else {
                childNode = edge.to;
              }

              if (node.id != childNode.id) {
                // Not '!==' because id's can be string and numeric
                callback(node, childNode, edge);
                crawler(childNode, tree);
              }
            }
          }
        }
      };

      if (startingNodeId === undefined) {
        // Crawl over all nodes
        var treeIndex = 0; // Serves to pass a unique id for the current distinct tree

        for (var i = 0; i < this.body.nodeIndices.length; i++) {
          var nodeId = this.body.nodeIndices[i];

          if (progress[nodeId] === undefined) {
            var node = this.body.nodes[nodeId];
            crawler(node, treeIndex);
            treeIndex += 1;
          }
        }
      } else {
        // Crawl from the given starting node
        var _node2 = this.body.nodes[startingNodeId];
        if (_node2 === undefined) {
          console.error("Node not found:", startingNodeId);
          return;
        }
        crawler(_node2);
      }
    }

    /**
     * Shift a branch a certain distance
     * @param {Node.id} parentId
     * @param {number} diff
     * @private
     */

  }, {
    key: '_shiftBlock',
    value: function _shiftBlock(parentId, diff) {
      var _this11 = this;

      var progress = {};
      var shifter = function shifter(parentId) {
        if (progress[parentId]) {
          return;
        }
        progress[parentId] = true;
        _this11.direction.shift(parentId, diff);

        var childRef = _this11.hierarchical.childrenReference[parentId];
        if (childRef !== undefined) {
          for (var i = 0; i < childRef.length; i++) {
            shifter(childRef[i]);
          }
        }
      };
      shifter(parentId);
    }

    /**
     * Find a common parent between branches.
     * @param {Node.id} childA
     * @param {Node.id} childB
     * @returns {{foundParent, withChild}}
     * @private
     */

  }, {
    key: '_findCommonParent',
    value: function _findCommonParent(childA, childB) {
      var _this12 = this;

      var parents = {};
      var iterateParents = function iterateParents(parents, child) {
        var parentRef = _this12.hierarchical.parentReference[child];
        if (parentRef !== undefined) {
          for (var i = 0; i < parentRef.length; i++) {
            var parent = parentRef[i];
            parents[parent] = true;
            iterateParents(parents, parent);
          }
        }
      };
      var findParent = function findParent(parents, child) {
        var parentRef = _this12.hierarchical.parentReference[child];
        if (parentRef !== undefined) {
          for (var i = 0; i < parentRef.length; i++) {
            var parent = parentRef[i];
            if (parents[parent] !== undefined) {
              return { foundParent: parent, withChild: child };
            }
            var branch = findParent(parents, parent);
            if (branch.foundParent !== null) {
              return branch;
            }
          }
        }
        return { foundParent: null, withChild: child };
      };

      iterateParents(parents, childA);
      return findParent(parents, childB);
    }

    /**
     * Set the strategy pattern for handling the coordinates given the current direction.
     *
     * The individual instances contain all the operations and data specific to a layout direction.
     *
     * @param {Node} node
     * @param {{x: number, y: number}} position
     * @param {number} level
     * @param {boolean} [doNotUpdate=false]
     * @private
     */

  }, {
    key: 'setDirectionStrategy',
    value: function setDirectionStrategy() {
      var isVertical = this.options.hierarchical.direction === 'UD' || this.options.hierarchical.direction === 'DU';

      if (isVertical) {
        this.direction = new VerticalStrategy(this);
      } else {
        this.direction = new HorizontalStrategy(this);
      }
    }

    /**
     * Determine the center position of a branch from the passed list of child nodes
     *
     * This takes into account the positions of all the child nodes.
     * @param {Array.<Node|vis.Node.id>} childNodes  Array of either child nodes or node id's
     * @return {number}
     * @private
     */

  }, {
    key: '_getCenterPosition',
    value: function _getCenterPosition(childNodes) {
      var minPos = 1e9;
      var maxPos = -1e9;

      for (var i = 0; i < childNodes.length; i++) {
        var childNode = void 0;
        if (childNodes[i].id !== undefined) {
          childNode = childNodes[i];
        } else {
          var childNodeId = childNodes[i];
          childNode = this.body.nodes[childNodeId];
        }

        var position = this.direction.getPosition(childNode);
        minPos = Math.min(minPos, position);
        maxPos = Math.max(maxPos, position);
      }

      return 0.5 * (minPos + maxPos);
    }
  }]);
  return LayoutEngine;
}();

exports['default'] = LayoutEngine;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalStrategy = exports.HorizontalStrategy = undefined;

var _getPrototypeOf = __webpack_require__(3);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Helper classes for LayoutEngine.
 *
 * Strategy pattern for usage of direction methods for hierarchical layouts.
 */

/**
 * Interface definition for direction strategy classes.
 *
 * This class describes the interface for the Strategy
 * pattern classes used to differentiate horizontal and vertical
 * direction of hierarchical results.
 *
 * For a given direction, one coordinate will be 'fixed', meaning that it is
 * determined by level.
 * The other coordinate is 'unfixed', meaning that the nodes on a given level
 * can still move along that coordinate. So:
 *
 * - `vertical` layout: `x` unfixed, `y` fixed per level
 * - `horizontal` layout: `x` fixed per level, `y` unfixed
 *
 * The local methods are stubs and should be regarded as abstract.
 * Derived classes **must** implement all the methods themselves.
 *
 * @private
 */
var DirectionInterface = function () {
  function DirectionInterface() {
    (0, _classCallCheck3['default'])(this, DirectionInterface);
  }

  (0, _createClass3['default'])(DirectionInterface, [{
    key: 'abstract',

    /** @ignore **/
    value: function abstract() {
      throw new Error("Can't instantiate abstract class!");
    }

    /**
     * This is a dummy call which is used to suppress the jsdoc errors of type:
     *
     *   "'param' is assigned a value but never used"
     *
     * @ignore
     **/

  }, {
    key: 'fake_use',
    value: function fake_use() {}
    // Do nothing special


    /**
     * Type to use to translate dynamic curves to, in the case of hierarchical layout.
     * Dynamic curves do not work for these.
     *
     * The value should be perpendicular to the actual direction of the layout.
     *
     * @return {string} Direction, either 'vertical' or 'horizontal'
     */

  }, {
    key: 'curveType',
    value: function curveType() {
      return this.abstract();
    }

    /**
     * Return the value of the coordinate that is not fixed for this direction.
     *
     * @param {Node} node The node to read
     * @return {number} Value of the unfixed coordinate
     */

  }, {
    key: 'getPosition',
    value: function getPosition(node) {
      this.fake_use(node);return this.abstract();
    }

    /**
     * Set the value of the coordinate that is not fixed for this direction.
     *
     * @param {Node} node The node to adjust
     * @param {number} position
     * @param {number} [level] if specified, the hierarchy level that this node should be fixed to
     */

  }, {
    key: 'setPosition',
    value: function setPosition(node, position) {
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      this.fake_use(node, position, level);this.abstract();
    }

    /**
     * Get the width of a tree.
     *
     * A `tree` here is a subset of nodes within the network which are not connected to other nodes,
     * only among themselves. In essence, it is a sub-network.
     *
     * @param {number} index The index number of a tree
     * @return {number} the width of a tree in the view coordinates
     */

  }, {
    key: 'getTreeSize',
    value: function getTreeSize(index) {
      this.fake_use(index);return this.abstract();
    }

    /**
     * Sort array of nodes on the unfixed coordinates.
     *
     * @param {Array.<Node>} nodeArray array of nodes to sort
     */

  }, {
    key: 'sort',
    value: function sort(nodeArray) {
      this.fake_use(nodeArray);this.abstract();
    }

    /**
     * Assign the fixed coordinate of the node to the given level
     *
     * @param {Node} node The node to adjust
     * @param {number} level The level to fix to
     */

  }, {
    key: 'fix',
    value: function fix(node, level) {
      this.fake_use(node, level);this.abstract();
    }

    /**
     * Add an offset to the unfixed coordinate of the given node. 
     *
     * @param {NodeId} nodeId Id of the node to adjust
     * @param {number} diff Offset to add to the unfixed coordinate
     */

  }, {
    key: 'shift',
    value: function shift(nodeId, diff) {
      this.fake_use(nodeId, diff);this.abstract();
    }
  }]);
  return DirectionInterface;
}();

/**
 * Vertical Strategy
 *
 * Coordinate `y` is fixed on levels, coordinate `x` is unfixed.
 *
 * @extends DirectionInterface
 * @private
 */


var VerticalStrategy = function (_DirectionInterface) {
  (0, _inherits3['default'])(VerticalStrategy, _DirectionInterface);

  /**
   * Constructor
   *
   * @param {Object} layout reference to the parent LayoutEngine instance.
   */
  function VerticalStrategy(layout) {
    (0, _classCallCheck3['default'])(this, VerticalStrategy);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (VerticalStrategy.__proto__ || (0, _getPrototypeOf2['default'])(VerticalStrategy)).call(this));

    _this.layout = layout;
    return _this;
  }

  /** @inheritdoc */


  (0, _createClass3['default'])(VerticalStrategy, [{
    key: 'curveType',
    value: function curveType() {
      return 'horizontal';
    }

    /** @inheritdoc */

  }, {
    key: 'getPosition',
    value: function getPosition(node) {
      return node.x;
    }

    /** @inheritdoc */

  }, {
    key: 'setPosition',
    value: function setPosition(node, position) {
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      if (level !== undefined) {
        this.layout.hierarchical.addToOrdering(node, level);
      }
      node.x = position;
    }

    /** @inheritdoc */

  }, {
    key: 'getTreeSize',
    value: function getTreeSize(index) {
      var res = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, index);
      return { min: res.min_x, max: res.max_x };
    }

    /** @inheritdoc */

  }, {
    key: 'sort',
    value: function sort(nodeArray) {
      nodeArray.sort(function (a, b) {
        // Test on 'undefined' takes care of divergent behaviour in chrome
        if (a.x === undefined || b.x === undefined) return 0; // THIS HAPPENS
        return a.x - b.x;
      });
    }

    /** @inheritdoc */

  }, {
    key: 'fix',
    value: function fix(node, level) {
      node.y = this.layout.options.hierarchical.levelSeparation * level;
      node.options.fixed.y = true;
    }

    /** @inheritdoc */

  }, {
    key: 'shift',
    value: function shift(nodeId, diff) {
      this.layout.body.nodes[nodeId].x += diff;
    }
  }]);
  return VerticalStrategy;
}(DirectionInterface);

/**
 * Horizontal Strategy
 *
 * Coordinate `x` is fixed on levels, coordinate `y` is unfixed.
 *
 * @extends DirectionInterface
 * @private
 */


var HorizontalStrategy = function (_DirectionInterface2) {
  (0, _inherits3['default'])(HorizontalStrategy, _DirectionInterface2);

  /**
   * Constructor
   *
   * @param {Object} layout reference to the parent LayoutEngine instance.
   */
  function HorizontalStrategy(layout) {
    (0, _classCallCheck3['default'])(this, HorizontalStrategy);

    var _this2 = (0, _possibleConstructorReturn3['default'])(this, (HorizontalStrategy.__proto__ || (0, _getPrototypeOf2['default'])(HorizontalStrategy)).call(this));

    _this2.layout = layout;
    return _this2;
  }

  /** @inheritdoc */


  (0, _createClass3['default'])(HorizontalStrategy, [{
    key: 'curveType',
    value: function curveType() {
      return 'vertical';
    }

    /** @inheritdoc */

  }, {
    key: 'getPosition',
    value: function getPosition(node) {
      return node.y;
    }

    /** @inheritdoc */

  }, {
    key: 'setPosition',
    value: function setPosition(node, position) {
      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      if (level !== undefined) {
        this.layout.hierarchical.addToOrdering(node, level);
      }
      node.y = position;
    }

    /** @inheritdoc */

  }, {
    key: 'getTreeSize',
    value: function getTreeSize(index) {
      var res = this.layout.hierarchical.getTreeSize(this.layout.body.nodes, index);
      return { min: res.min_y, max: res.max_y };
    }

    /** @inheritdoc */

  }, {
    key: 'sort',
    value: function sort(nodeArray) {
      nodeArray.sort(function (a, b) {
        // Test on 'undefined' takes care of divergent behaviour in chrome
        if (a.y === undefined || b.y === undefined) return 0; // THIS HAPPENS
        return a.y - b.y;
      });
    }

    /** @inheritdoc */

  }, {
    key: 'fix',
    value: function fix(node, level) {
      node.x = this.layout.options.hierarchical.levelSeparation * level;
      node.options.fixed.x = true;
    }

    /** @inheritdoc */

  }, {
    key: 'shift',
    value: function shift(nodeId, diff) {
      this.layout.body.nodes[nodeId].y += diff;
    }
  }]);
  return HorizontalStrategy;
}(DirectionInterface);

exports.HorizontalStrategy = HorizontalStrategy;
exports.VerticalStrategy = VerticalStrategy;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(19);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(6);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var util = __webpack_require__(2);
var Hammer = __webpack_require__(10);
var hammerUtil = __webpack_require__(37);

/**
 * Clears the toolbar div element of children
 *
 * @private
 */

var ManipulationSystem = function () {
  /**
   * @param {Object} body
   * @param {Canvas} canvas
   * @param {SelectionHandler} selectionHandler
   */
  function ManipulationSystem(body, canvas, selectionHandler) {
    var _this = this;

    (0, _classCallCheck3['default'])(this, ManipulationSystem);

    this.body = body;
    this.canvas = canvas;
    this.selectionHandler = selectionHandler;

    this.editMode = false;
    this.manipulationDiv = undefined;
    this.editModeDiv = undefined;
    this.closeDiv = undefined;

    this.manipulationHammers = [];
    this.temporaryUIFunctions = {};
    this.temporaryEventFunctions = [];

    this.touchTime = 0;
    this.temporaryIds = { nodes: [], edges: [] };
    this.guiEnabled = false;
    this.inMode = false;
    this.selectedControlNode = undefined;

    this.options = {};
    this.defaultOptions = {
      enabled: false,
      initiallyActive: false,
      addNode: true,
      addEdge: true,
      editNode: undefined,
      editEdge: true,
      deleteNode: true,
      deleteEdge: true,
      controlNodeStyle: {
        shape: 'dot',
        size: 6,
        color: { background: '#ff0000', border: '#3c3c3c', highlight: { background: '#07f968', border: '#3c3c3c' } },
        borderWidth: 2,
        borderWidthSelected: 2
      }
    };
    util.extend(this.options, this.defaultOptions);

    this.body.emitter.on('destroy', function () {
      _this._clean();
    });
    this.body.emitter.on('_dataChanged', this._restore.bind(this));
    this.body.emitter.on('_resetData', this._restore.bind(this));
  }

  /**
   * If something changes in the data during editing, switch back to the initial datamanipulation state and close all edit modes.
   * @private
   */


  (0, _createClass3['default'])(ManipulationSystem, [{
    key: '_restore',
    value: function _restore() {
      if (this.inMode !== false) {
        if (this.options.initiallyActive === true) {
          this.enableEditMode();
        } else {
          this.disableEditMode();
        }
      }
    }

    /**
     * Set the Options
     *
     * @param {Object} options
     * @param {Object} allOptions
     * @param {Object} globalOptions
     */

  }, {
    key: 'setOptions',
    value: function setOptions(options, allOptions, globalOptions) {
      if (allOptions !== undefined) {
        if (allOptions.locale !== undefined) {
          this.options.locale = allOptions.locale;
        } else {
          this.options.locale = globalOptions.locale;
        }
        if (allOptions.locales !== undefined) {
          this.options.locales = allOptions.locales;
        } else {
          this.options.locales = globalOptions.locales;
        }
      }

      if (options !== undefined) {
        if (typeof options === 'boolean') {
          this.options.enabled = options;
        } else {
          this.options.enabled = true;
          util.deepExtend(this.options, options);
        }
        if (this.options.initiallyActive === true) {
          this.editMode = true;
        }
        this._setup();
      }
    }

    /**
     * Enable or disable edit-mode. Draws the DOM required and cleans up after itself.
     *
     * @private
     */

  }, {
    key: 'toggleEditMode',
    value: function toggleEditMode() {
      if (this.editMode === true) {
        this.disableEditMode();
      } else {
        this.enableEditMode();
      }
    }

    /**
     * Enables Edit Mode
     */

  }, {
    key: 'enableEditMode',
    value: function enableEditMode() {
      this.editMode = true;

      this._clean();
      if (this.guiEnabled === true) {
        this.manipulationDiv.style.display = 'block';
        this.closeDiv.style.display = 'block';
        this.editModeDiv.style.display = 'none';
        this.showManipulatorToolbar();
      }
    }

    /**
     * Disables Edit Mode
     */

  }, {
    key: 'disableEditMode',
    value: function disableEditMode() {
      this.editMode = false;

      this._clean();
      if (this.guiEnabled === true) {
        this.manipulationDiv.style.display = 'none';
        this.closeDiv.style.display = 'none';
        this.editModeDiv.style.display = 'block';
        this._createEditButton();
      }
    }

    /**
     * Creates the main toolbar. Removes functions bound to the select event. Binds all the buttons of the toolbar.
     *
     * @private
     */

  }, {
    key: 'showManipulatorToolbar',
    value: function showManipulatorToolbar() {
      // restore the state of any bound functions or events, remove control nodes, restore physics
      this._clean();

      // reset global variables
      this.manipulationDOM = {};

      // if the gui is enabled, draw all elements.
      if (this.guiEnabled === true) {
        // a _restore will hide these menus
        this.editMode = true;
        this.manipulationDiv.style.display = 'block';
        this.closeDiv.style.display = 'block';

        var selectedNodeCount = this.selectionHandler._getSelectedNodeCount();
        var selectedEdgeCount = this.selectionHandler._getSelectedEdgeCount();
        var selectedTotalCount = selectedNodeCount + selectedEdgeCount;
        var locale = this.options.locales[this.options.locale];
        var needSeperator = false;

        if (this.options.addNode !== false) {
          this._createAddNodeButton(locale);
          needSeperator = true;
        }
        if (this.options.addEdge !== false) {
          if (needSeperator === true) {
            this._createSeperator(1);
          } else {
            needSeperator = true;
          }
          this._createAddEdgeButton(locale);
        }

        if (selectedNodeCount === 1 && typeof this.options.editNode === 'function') {
          if (needSeperator === true) {
            this._createSeperator(2);
          } else {
            needSeperator = true;
          }
          this._createEditNodeButton(locale);
        } else if (selectedEdgeCount === 1 && selectedNodeCount === 0 && this.options.editEdge !== false) {
          if (needSeperator === true) {
            this._createSeperator(3);
          } else {
            needSeperator = true;
          }
          this._createEditEdgeButton(locale);
        }

        // remove buttons
        if (selectedTotalCount !== 0) {
          if (selectedNodeCount > 0 && this.options.deleteNode !== false) {
            if (needSeperator === true) {
              this._createSeperator(4);
            }
            this._createDeleteButton(locale);
          } else if (selectedNodeCount === 0 && this.options.deleteEdge !== false) {
            if (needSeperator === true) {
              this._createSeperator(4);
            }
            this._createDeleteButton(locale);
          }
        }

        // bind the close button
        this._bindHammerToDiv(this.closeDiv, this.toggleEditMode.bind(this));

        // refresh this bar based on what has been selected
        this._temporaryBindEvent('select', this.showManipulatorToolbar.bind(this));
      }

      // redraw to show any possible changes
      this.body.emitter.emit('_redraw');
    }

    /**
     * Create the toolbar for adding Nodes
     */

  }, {
    key: 'addNodeMode',
    value: function addNodeMode() {
      // when using the gui, enable edit mode if it wasnt already.
      if (this.editMode !== true) {
        this.enableEditMode();
      }

      // restore the state of any bound functions or events, remove control nodes, restore physics
      this._clean();

      this.inMode = 'addNode';
      if (this.guiEnabled === true) {
        var locale = this.options.locales[this.options.locale];
        this.manipulationDOM = {};
        this._createBackButton(locale);
        this._createSeperator();
        this._createDescription(locale['addDescription'] || this.options.locales['en']['addDescription']);

        // bind the close button
        this._bindHammerToDiv(this.closeDiv, this.toggleEditMode.bind(this));
      }

      this._temporaryBindEvent('click', this._performAddNode.bind(this));
    }

    /**
     * call the bound function to handle the editing of the node. The node has to be selected.
     */

  }, {
    key: 'editNode',
    value: function editNode() {
      var _this2 = this;

      // when using the gui, enable edit mode if it wasnt already.
      if (this.editMode !== true) {
        this.enableEditMode();
      }

      // restore the state of any bound functions or events, remove control nodes, restore physics
      this._clean();
      var node = this.selectionHandler._getSelectedNode();
      if (node !== undefined) {
        this.inMode = 'editNode';
        if (typeof this.options.editNode === 'function') {
          if (node.isCluster !== true) {
            var data = util.deepExtend({}, node.options, false);
            data.x = node.x;
            data.y = node.y;

            if (this.options.editNode.length === 2) {
              this.options.editNode(data, function (finalizedData) {
                if (finalizedData !== null && finalizedData !== undefined && _this2.inMode === 'editNode') {
                  // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
                  _this2.body.data.nodes.getDataSet().update(finalizedData);
                }
                _this2.showManipulatorToolbar();
              });
            } else {
              throw new Error('The function for edit does not support two arguments (data, callback)');
            }
          } else {
            alert(this.options.locales[this.options.locale]['editClusterError'] || this.options.locales['en']['editClusterError']);
          }
        } else {
          throw new Error('No function has been configured to handle the editing of nodes.');
        }
      } else {
        this.showManipulatorToolbar();
      }
    }

    /**
     * create the toolbar to connect nodes
     */

  }, {
    key: 'addEdgeMode',
    value: function addEdgeMode() {
      // when using the gui, enable edit mode if it wasnt already.
      if (this.editMode !== true) {
        this.enableEditMode();
      }

      // restore the state of any bound functions or events, remove control nodes, restore physics
      this._clean();

      this.inMode = 'addEdge';
      if (this.guiEnabled === true) {
        var locale = this.options.locales[this.options.locale];
        this.manipulationDOM = {};
        this._createBackButton(locale);
        this._createSeperator();
        this._createDescription(locale['edgeDescription'] || this.options.locales['en']['edgeDescription']);

        // bind the close button
        this._bindHammerToDiv(this.closeDiv, this.toggleEditMode.bind(this));
      }

      // temporarily overload functions
      this._temporaryBindUI('onTouch', this._handleConnect.bind(this));
      this._temporaryBindUI('onDragEnd', this._finishConnect.bind(this));
      this._temporaryBindUI('onDrag', this._dragControlNode.bind(this));
      this._temporaryBindUI('onRelease', this._finishConnect.bind(this));
      this._temporaryBindUI('onDragStart', this._dragStartEdge.bind(this));
      this._temporaryBindUI('onHold', function () {});
    }

    /**
     * create the toolbar to edit edges
     */

  }, {
    key: 'editEdgeMode',
    value: function editEdgeMode() {
      // when using the gui, enable edit mode if it wasn't already.
      if (this.editMode !== true) {
        this.enableEditMode();
      }

      // restore the state of any bound functions or events, remove control nodes, restore physics
      this._clean();

      this.inMode = 'editEdge';
      if ((0, _typeof3['default'])(this.options.editEdge) === 'object' && typeof this.options.editEdge.editWithoutDrag === "function") {
        this.edgeBeingEditedId = this.selectionHandler.getSelectedEdges()[0];
        if (this.edgeBeingEditedId !== undefined) {
          var edge = this.body.edges[this.edgeBeingEditedId];
          this._performEditEdge(edge.from, edge.to);
          return;
        }
      }
      if (this.guiEnabled === true) {
        var locale = this.options.locales[this.options.locale];
        this.manipulationDOM = {};
        this._createBackButton(locale);
        this._createSeperator();
        this._createDescription(locale['editEdgeDescription'] || this.options.locales['en']['editEdgeDescription']);

        // bind the close button
        this._bindHammerToDiv(this.closeDiv, this.toggleEditMode.bind(this));
      }

      this.edgeBeingEditedId = this.selectionHandler.getSelectedEdges()[0];
      if (this.edgeBeingEditedId !== undefined) {
        var _edge = this.body.edges[this.edgeBeingEditedId];

        // create control nodes
        var controlNodeFrom = this._getNewTargetNode(_edge.from.x, _edge.from.y);
        var controlNodeTo = this._getNewTargetNode(_edge.to.x, _edge.to.y);

        this.temporaryIds.nodes.push(controlNodeFrom.id);
        this.temporaryIds.nodes.push(controlNodeTo.id);

        this.body.nodes[controlNodeFrom.id] = controlNodeFrom;
        this.body.nodeIndices.push(controlNodeFrom.id);
        this.body.nodes[controlNodeTo.id] = controlNodeTo;
        this.body.nodeIndices.push(controlNodeTo.id);

        // temporarily overload UI functions, cleaned up automatically because of _temporaryBindUI
        this._temporaryBindUI('onTouch', this._controlNodeTouch.bind(this)); // used to get the position
        this._temporaryBindUI('onTap', function () {}); // disabled
        this._temporaryBindUI('onHold', function () {}); // disabled
        this._temporaryBindUI('onDragStart', this._controlNodeDragStart.bind(this)); // used to select control node
        this._temporaryBindUI('onDrag', this._controlNodeDrag.bind(this)); // used to drag control node
        this._temporaryBindUI('onDragEnd', this._controlNodeDragEnd.bind(this)); // used to connect or revert control nodes
        this._temporaryBindUI('onMouseMove', function () {}); // disabled

        // create function to position control nodes correctly on movement
        // automatically cleaned up because we use the temporary bind
        this._temporaryBindEvent('beforeDrawing', function (ctx) {
          var positions = _edge.edgeType.findBorderPositions(ctx);
          if (controlNodeFrom.selected === false) {
            controlNodeFrom.x = positions.from.x;
            controlNodeFrom.y = positions.from.y;
          }
          if (controlNodeTo.selected === false) {
            controlNodeTo.x = positions.to.x;
            controlNodeTo.y = positions.to.y;
          }
        });

        this.body.emitter.emit('_redraw');
      } else {
        this.showManipulatorToolbar();
      }
    }

    /**
     * delete everything in the selection
     */

  }, {
    key: 'deleteSelected',
    value: function deleteSelected() {
      var _this3 = this;

      // when using the gui, enable edit mode if it wasnt already.
      if (this.editMode !== true) {
        this.enableEditMode();
      }

      // restore the state of any bound functions or events, remove control nodes, restore physics
      this._clean();

      this.inMode = 'delete';
      var selectedNodes = this.selectionHandler.getSelectedNodes();
      var selectedEdges = this.selectionHandler.getSelectedEdges();
      var deleteFunction = undefined;
      if (selectedNodes.length > 0) {
        for (var i = 0; i < selectedNodes.length; i++) {
          if (this.body.nodes[selectedNodes[i]].isCluster === true) {
            alert(this.options.locales[this.options.locale]['deleteClusterError'] || this.options.locales['en']['deleteClusterError']);
            return;
          }
        }

        if (typeof this.options.deleteNode === 'function') {
          deleteFunction = this.options.deleteNode;
        }
      } else if (selectedEdges.length > 0) {
        if (typeof this.options.deleteEdge === 'function') {
          deleteFunction = this.options.deleteEdge;
        }
      }

      if (typeof deleteFunction === 'function') {
        var data = { nodes: selectedNodes, edges: selectedEdges };
        if (deleteFunction.length === 2) {
          deleteFunction(data, function (finalizedData) {
            if (finalizedData !== null && finalizedData !== undefined && _this3.inMode === 'delete') {
              // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
              _this3.body.data.edges.getDataSet().remove(finalizedData.edges);
              _this3.body.data.nodes.getDataSet().remove(finalizedData.nodes);
              _this3.body.emitter.emit('startSimulation');
              _this3.showManipulatorToolbar();
            } else {
              _this3.body.emitter.emit('startSimulation');
              _this3.showManipulatorToolbar();
            }
          });
        } else {
          throw new Error('The function for delete does not support two arguments (data, callback)');
        }
      } else {
        this.body.data.edges.getDataSet().remove(selectedEdges);
        this.body.data.nodes.getDataSet().remove(selectedNodes);
        this.body.emitter.emit('startSimulation');
        this.showManipulatorToolbar();
      }
    }

    //********************************************** PRIVATE ***************************************//

    /**
     * draw or remove the DOM
     * @private
     */

  }, {
    key: '_setup',
    value: function _setup() {
      if (this.options.enabled === true) {
        // Enable the GUI
        this.guiEnabled = true;

        this._createWrappers();
        if (this.editMode === false) {
          this._createEditButton();
        } else {
          this.showManipulatorToolbar();
        }
      } else {
        this._removeManipulationDOM();

        // disable the gui
        this.guiEnabled = false;
      }
    }

    /**
     * create the div overlays that contain the DOM
     * @private
     */

  }, {
    key: '_createWrappers',
    value: function _createWrappers() {
      // load the manipulator HTML elements. All styling done in css.
      if (this.manipulationDiv === undefined) {
        this.manipulationDiv = document.createElement('div');
        this.manipulationDiv.className = 'vis-manipulation';
        if (this.editMode === true) {
          this.manipulationDiv.style.display = 'block';
        } else {
          this.manipulationDiv.style.display = 'none';
        }
        this.canvas.frame.appendChild(this.manipulationDiv);
      }

      // container for the edit button.
      if (this.editModeDiv === undefined) {
        this.editModeDiv = document.createElement('div');
        this.editModeDiv.className = 'vis-edit-mode';
        if (this.editMode === true) {
          this.editModeDiv.style.display = 'none';
        } else {
          this.editModeDiv.style.display = 'block';
        }
        this.canvas.frame.appendChild(this.editModeDiv);
      }

      // container for the close div button
      if (this.closeDiv === undefined) {
        this.closeDiv = document.createElement('div');
        this.closeDiv.className = 'vis-close';
        this.closeDiv.style.display = this.manipulationDiv.style.display;
        this.canvas.frame.appendChild(this.closeDiv);
      }
    }

    /**
     * generate a new target node. Used for creating new edges and editing edges
     *
     * @param {number} x
     * @param {number} y
     * @returns {Node}
     * @private
     */

  }, {
    key: '_getNewTargetNode',
    value: function _getNewTargetNode(x, y) {
      var controlNodeStyle = util.deepExtend({}, this.options.controlNodeStyle);

      controlNodeStyle.id = 'targetNode' + util.randomUUID();
      controlNodeStyle.hidden = false;
      controlNodeStyle.physics = false;
      controlNodeStyle.x = x;
      controlNodeStyle.y = y;

      // we have to define the bounding box in order for the nodes to be drawn immediately
      var node = this.body.functions.createNode(controlNodeStyle);
      node.shape.boundingBox = { left: x, right: x, top: y, bottom: y };

      return node;
    }

    /**
     * Create the edit button
     */

  }, {
    key: '_createEditButton',
    value: function _createEditButton() {
      // restore everything to it's original state (if applicable)
      this._clean();

      // reset the manipulationDOM
      this.manipulationDOM = {};

      // empty the editModeDiv
      util.recursiveDOMDelete(this.editModeDiv);

      // create the contents for the editMode button
      var locale = this.options.locales[this.options.locale];
      var button = this._createButton('editMode', 'vis-button vis-edit vis-edit-mode', locale['edit'] || this.options.locales['en']['edit']);
      this.editModeDiv.appendChild(button);

      // bind a hammer listener to the button, calling the function toggleEditMode.
      this._bindHammerToDiv(button, this.toggleEditMode.bind(this));
    }

    /**
     * this function cleans up after everything this module does. Temporary elements, functions and events are removed, physics restored, hammers removed.
     * @private
     */

  }, {
    key: '_clean',
    value: function _clean() {
      // not in mode
      this.inMode = false;

      // _clean the divs
      if (this.guiEnabled === true) {
        util.recursiveDOMDelete(this.editModeDiv);
        util.recursiveDOMDelete(this.manipulationDiv);

        // removes all the bindings and overloads
        this._cleanManipulatorHammers();
      }

      // remove temporary nodes and edges
      this._cleanupTemporaryNodesAndEdges();

      // restore overloaded UI functions
      this._unbindTemporaryUIs();

      // remove the temporaryEventFunctions
      this._unbindTemporaryEvents();

      // restore the physics if required
      this.body.emitter.emit('restorePhysics');
    }

    /**
     * Each dom element has it's own hammer. They are stored in this.manipulationHammers. This cleans them up.
     * @private
     */

  }, {
    key: '_cleanManipulatorHammers',
    value: function _cleanManipulatorHammers() {
      // _clean hammer bindings
      if (this.manipulationHammers.length != 0) {
        for (var i = 0; i < this.manipulationHammers.length; i++) {
          this.manipulationHammers[i].destroy();
        }
        this.manipulationHammers = [];
      }
    }

    /**
     * Remove all DOM elements created by this module.
     * @private
     */

  }, {
    key: '_removeManipulationDOM',
    value: function _removeManipulationDOM() {
      // removes all the bindings and overloads
      this._clean();

      // empty the manipulation divs
      util.recursiveDOMDelete(this.manipulationDiv);
      util.recursiveDOMDelete(this.editModeDiv);
      util.recursiveDOMDelete(this.closeDiv);

      // remove the manipulation divs
      if (this.manipulationDiv) {
        this.canvas.frame.removeChild(this.manipulationDiv);
      }
      if (this.editModeDiv) {
        this.canvas.frame.removeChild(this.editModeDiv);
      }
      if (this.closeDiv) {
        this.canvas.frame.removeChild(this.closeDiv);
      }

      // set the references to undefined
      this.manipulationDiv = undefined;
      this.editModeDiv = undefined;
      this.closeDiv = undefined;
    }

    /**
     * create a seperator line. the index is to differentiate in the manipulation dom
     * @param {number} [index=1]
     * @private
     */

  }, {
    key: '_createSeperator',
    value: function _createSeperator() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.manipulationDOM['seperatorLineDiv' + index] = document.createElement('div');
      this.manipulationDOM['seperatorLineDiv' + index].className = 'vis-separator-line';
      this.manipulationDiv.appendChild(this.manipulationDOM['seperatorLineDiv' + index]);
    }

    // ----------------------    DOM functions for buttons    --------------------------//

    /**
     *
     * @param {Locale} locale
     * @private
     */

  }, {
    key: '_createAddNodeButton',
    value: function _createAddNodeButton(locale) {
      var button = this._createButton('addNode', 'vis-button vis-add', locale['addNode'] || this.options.locales['en']['addNode']);
      this.manipulationDiv.appendChild(button);
      this._bindHammerToDiv(button, this.addNodeMode.bind(this));
    }

    /**
     *
     * @param {Locale} locale
     * @private
     */

  }, {
    key: '_createAddEdgeButton',
    value: function _createAddEdgeButton(locale) {
      var button = this._createButton('addEdge', 'vis-button vis-connect', locale['addEdge'] || this.options.locales['en']['addEdge']);
      this.manipulationDiv.appendChild(button);
      this._bindHammerToDiv(button, this.addEdgeMode.bind(this));
    }

    /**
     *
     * @param {Locale} locale
     * @private
     */

  }, {
    key: '_createEditNodeButton',
    value: function _createEditNodeButton(locale) {
      var button = this._createButton('editNode', 'vis-button vis-edit', locale['editNode'] || this.options.locales['en']['editNode']);
      this.manipulationDiv.appendChild(button);
      this._bindHammerToDiv(button, this.editNode.bind(this));
    }

    /**
     *
     * @param {Locale} locale
     * @private
     */

  }, {
    key: '_createEditEdgeButton',
    value: function _createEditEdgeButton(locale) {
      var button = this._createButton('editEdge', 'vis-button vis-edit', locale['editEdge'] || this.options.locales['en']['editEdge']);
      this.manipulationDiv.appendChild(button);
      this._bindHammerToDiv(button, this.editEdgeMode.bind(this));
    }

    /**
     *
     * @param {Locale} locale
     * @private
     */

  }, {
    key: '_createDeleteButton',
    value: function _createDeleteButton(locale) {
      var deleteBtnClass;
      if (this.options.rtl) {
        deleteBtnClass = 'vis-button vis-delete-rtl';
      } else {
        deleteBtnClass = 'vis-button vis-delete';
      }
      var button = this._createButton('delete', deleteBtnClass, locale['del'] || this.options.locales['en']['del']);
      this.manipulationDiv.appendChild(button);
      this._bindHammerToDiv(button, this.deleteSelected.bind(this));
    }

    /**
     *
     * @param {Locale} locale
     * @private
     */

  }, {
    key: '_createBackButton',
    value: function _createBackButton(locale) {
      var button = this._createButton('back', 'vis-button vis-back', locale['back'] || this.options.locales['en']['back']);
      this.manipulationDiv.appendChild(button);
      this._bindHammerToDiv(button, this.showManipulatorToolbar.bind(this));
    }

    /**
     *
     * @param {number|string} id
     * @param {string} className
     * @param {label} label
     * @param {string} labelClassName
     * @returns {HTMLElement}
     * @private
     */

  }, {
    key: '_createButton',
    value: function _createButton(id, className, label) {
      var labelClassName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'vis-label';


      this.manipulationDOM[id + 'Div'] = document.createElement('div');
      this.manipulationDOM[id + 'Div'].className = className;
      this.manipulationDOM[id + 'Label'] = document.createElement('div');
      this.manipulationDOM[id + 'Label'].className = labelClassName;
      this.manipulationDOM[id + 'Label'].innerHTML = label;
      this.manipulationDOM[id + 'Div'].appendChild(this.manipulationDOM[id + 'Label']);
      return this.manipulationDOM[id + 'Div'];
    }

    /**
     *
     * @param {Label} label
     * @private
     */

  }, {
    key: '_createDescription',
    value: function _createDescription(label) {
      this.manipulationDiv.appendChild(this._createButton('description', 'vis-button vis-none', label));
    }

    // -------------------------- End of DOM functions for buttons ------------------------------//

    /**
     * this binds an event until cleanup by the clean functions.
     * @param {Event}  event   The event
     * @param {function} newFunction
     * @private
     */

  }, {
    key: '_temporaryBindEvent',
    value: function _temporaryBindEvent(event, newFunction) {
      this.temporaryEventFunctions.push({ event: event, boundFunction: newFunction });
      this.body.emitter.on(event, newFunction);
    }

    /**
     * this overrides an UI function until cleanup by the clean function
     * @param {string} UIfunctionName
     * @param {function} newFunction
     * @private
     */

  }, {
    key: '_temporaryBindUI',
    value: function _temporaryBindUI(UIfunctionName, newFunction) {
      if (this.body.eventListeners[UIfunctionName] !== undefined) {
        this.temporaryUIFunctions[UIfunctionName] = this.body.eventListeners[UIfunctionName];
        this.body.eventListeners[UIfunctionName] = newFunction;
      } else {
        throw new Error('This UI function does not exist. Typo? You tried: ' + UIfunctionName + ' possible are: ' + (0, _stringify2['default'])((0, _keys2['default'])(this.body.eventListeners)));
      }
    }

    /**
     * Restore the overridden UI functions to their original state.
     *
     * @private
     */

  }, {
    key: '_unbindTemporaryUIs',
    value: function _unbindTemporaryUIs() {
      for (var functionName in this.temporaryUIFunctions) {
        if (this.temporaryUIFunctions.hasOwnProperty(functionName)) {
          this.body.eventListeners[functionName] = this.temporaryUIFunctions[functionName];
          delete this.temporaryUIFunctions[functionName];
        }
      }
      this.temporaryUIFunctions = {};
    }

    /**
     * Unbind the events created by _temporaryBindEvent
     * @private
     */

  }, {
    key: '_unbindTemporaryEvents',
    value: function _unbindTemporaryEvents() {
      for (var i = 0; i < this.temporaryEventFunctions.length; i++) {
        var eventName = this.temporaryEventFunctions[i].event;
        var boundFunction = this.temporaryEventFunctions[i].boundFunction;
        this.body.emitter.off(eventName, boundFunction);
      }
      this.temporaryEventFunctions = [];
    }

    /**
     * Bind an hammer instance to a DOM element.
     *
     * @param {Element} domElement
     * @param {function} boundFunction
     */

  }, {
    key: '_bindHammerToDiv',
    value: function _bindHammerToDiv(domElement, boundFunction) {
      var hammer = new Hammer(domElement, {});
      hammerUtil.onTouch(hammer, boundFunction);
      this.manipulationHammers.push(hammer);
    }

    /**
     * Neatly clean up temporary edges and nodes
     * @private
     */

  }, {
    key: '_cleanupTemporaryNodesAndEdges',
    value: function _cleanupTemporaryNodesAndEdges() {
      // _clean temporary edges
      for (var i = 0; i < this.temporaryIds.edges.length; i++) {
        this.body.edges[this.temporaryIds.edges[i]].disconnect();
        delete this.body.edges[this.temporaryIds.edges[i]];
        var indexTempEdge = this.body.edgeIndices.indexOf(this.temporaryIds.edges[i]);
        if (indexTempEdge !== -1) {
          this.body.edgeIndices.splice(indexTempEdge, 1);
        }
      }

      // _clean temporary nodes
      for (var _i = 0; _i < this.temporaryIds.nodes.length; _i++) {
        delete this.body.nodes[this.temporaryIds.nodes[_i]];
        var indexTempNode = this.body.nodeIndices.indexOf(this.temporaryIds.nodes[_i]);
        if (indexTempNode !== -1) {
          this.body.nodeIndices.splice(indexTempNode, 1);
        }
      }

      this.temporaryIds = { nodes: [], edges: [] };
    }

    // ------------------------------------------ EDIT EDGE FUNCTIONS -----------------------------------------//

    /**
     * the touch is used to get the position of the initial click
     * @param {Event}  event   The event
     * @private
     */

  }, {
    key: '_controlNodeTouch',
    value: function _controlNodeTouch(event) {
      this.selectionHandler.unselectAll();
      this.lastTouch = this.body.functions.getPointer(event.center);
      this.lastTouch.translation = util.extend({}, this.body.view.translation); // copy the object
    }

    /**
     * the drag start is used to mark one of the control nodes as selected.
     * @param {Event}  event   The event
     * @private
     */

  }, {
    key: '_controlNodeDragStart',
    value: function _controlNodeDragStart(event) {
      // eslint-disable-line no-unused-vars
      var pointer = this.lastTouch;
      var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);
      var from = this.body.nodes[this.temporaryIds.nodes[0]];
      var to = this.body.nodes[this.temporaryIds.nodes[1]];
      var edge = this.body.edges[this.edgeBeingEditedId];
      this.selectedControlNode = undefined;

      var fromSelect = from.isOverlappingWith(pointerObj);
      var toSelect = to.isOverlappingWith(pointerObj);

      if (fromSelect === true) {
        this.selectedControlNode = from;
        edge.edgeType.from = from;
      } else if (toSelect === true) {
        this.selectedControlNode = to;
        edge.edgeType.to = to;
      }

      // we use the selection to find the node that is being dragged. We explicitly select it here.
      if (this.selectedControlNode !== undefined) {
        this.selectionHandler.selectObject(this.selectedControlNode);
      }

      this.body.emitter.emit('_redraw');
    }

    /**
     * dragging the control nodes or the canvas
     * @param {Event}  event   The event
     * @private
     */

  }, {
    key: '_controlNodeDrag',
    value: function _controlNodeDrag(event) {
      this.body.emitter.emit('disablePhysics');
      var pointer = this.body.functions.getPointer(event.center);
      var pos = this.canvas.DOMtoCanvas(pointer);
      if (this.selectedControlNode !== undefined) {
        this.selectedControlNode.x = pos.x;
        this.selectedControlNode.y = pos.y;
      } else {
        // if the drag was not started properly because the click started outside the network div, start it now.
        var diffX = pointer.x - this.lastTouch.x;
        var diffY = pointer.y - this.lastTouch.y;
        this.body.view.translation = { x: this.lastTouch.translation.x + diffX, y: this.lastTouch.translation.y + diffY };
      }
      this.body.emitter.emit('_redraw');
    }

    /**
     * connecting or restoring the control nodes.
     * @param {Event}  event   The event
     * @private
     */

  }, {
    key: '_controlNodeDragEnd',
    value: function _controlNodeDragEnd(event) {
      var pointer = this.body.functions.getPointer(event.center);
      var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);
      var edge = this.body.edges[this.edgeBeingEditedId];
      // if the node that was dragged is not a control node, return
      if (this.selectedControlNode === undefined) {
        return;
      }

      // we use the selection to find the node that is being dragged. We explicitly DEselect the control node here.
      this.selectionHandler.unselectAll();
      var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);
      var node = undefined;
      for (var i = overlappingNodeIds.length - 1; i >= 0; i--) {
        if (overlappingNodeIds[i] !== this.selectedControlNode.id) {
          node = this.body.nodes[overlappingNodeIds[i]];
          break;
        }
      }
      // perform the connection
      if (node !== undefined && this.selectedControlNode !== undefined) {
        if (node.isCluster === true) {
          alert(this.options.locales[this.options.locale]['createEdgeError'] || this.options.locales['en']['createEdgeError']);
        } else {
          var from = this.body.nodes[this.temporaryIds.nodes[0]];
          if (this.selectedControlNode.id === from.id) {
            this._performEditEdge(node.id, edge.to.id);
          } else {
            this._performEditEdge(edge.from.id, node.id);
          }
        }
      } else {
        edge.updateEdgeType();
        this.body.emitter.emit('restorePhysics');
      }

      this.body.emitter.emit('_redraw');
    }

    // ------------------------------------ END OF EDIT EDGE FUNCTIONS -----------------------------------------//


    // ------------------------------------------- ADD EDGE FUNCTIONS -----------------------------------------//
    /**
     * the function bound to the selection event. It checks if you want to connect a cluster and changes the description
     * to walk the user through the process.
     *
     * @param {Event} event
     * @private
     */

  }, {
    key: '_handleConnect',
    value: function _handleConnect(event) {
      // check to avoid double fireing of this function.
      if (new Date().valueOf() - this.touchTime > 100) {
        this.lastTouch = this.body.functions.getPointer(event.center);
        this.lastTouch.translation = util.extend({}, this.body.view.translation); // copy the object

        var pointer = this.lastTouch;
        var node = this.selectionHandler.getNodeAt(pointer);

        if (node !== undefined) {
          if (node.isCluster === true) {
            alert(this.options.locales[this.options.locale]['createEdgeError'] || this.options.locales['en']['createEdgeError']);
          } else {
            // create a node the temporary line can look at
            var targetNode = this._getNewTargetNode(node.x, node.y);
            this.body.nodes[targetNode.id] = targetNode;
            this.body.nodeIndices.push(targetNode.id);

            // create a temporary edge
            var connectionEdge = this.body.functions.createEdge({
              id: 'connectionEdge' + util.randomUUID(),
              from: node.id,
              to: targetNode.id,
              physics: false,
              smooth: {
                enabled: true,
                type: 'continuous',
                roundness: 0.5
              }
            });
            this.body.edges[connectionEdge.id] = connectionEdge;
            this.body.edgeIndices.push(connectionEdge.id);

            this.temporaryIds.nodes.push(targetNode.id);
            this.temporaryIds.edges.push(connectionEdge.id);
          }
        }
        this.touchTime = new Date().valueOf();
      }
    }

    /**
     *
     * @param {Event} event
     * @private
     */

  }, {
    key: '_dragControlNode',
    value: function _dragControlNode(event) {
      var pointer = this.body.functions.getPointer(event.center);
      if (this.temporaryIds.nodes[0] !== undefined) {
        var targetNode = this.body.nodes[this.temporaryIds.nodes[0]]; // there is only one temp node in the add edge mode.
        targetNode.x = this.canvas._XconvertDOMtoCanvas(pointer.x);
        targetNode.y = this.canvas._YconvertDOMtoCanvas(pointer.y);
        this.body.emitter.emit('_redraw');
      } else {
        var diffX = pointer.x - this.lastTouch.x;
        var diffY = pointer.y - this.lastTouch.y;
        this.body.view.translation = { x: this.lastTouch.translation.x + diffX, y: this.lastTouch.translation.y + diffY };
      }
    }

    /**
     * Connect the new edge to the target if one exists, otherwise remove temp line
     * @param {Event}  event   The event
     * @private
     */

  }, {
    key: '_finishConnect',
    value: function _finishConnect(event) {
      var pointer = this.body.functions.getPointer(event.center);
      var pointerObj = this.selectionHandler._pointerToPositionObject(pointer);

      // remember the edge id
      var connectFromId = undefined;
      if (this.temporaryIds.edges[0] !== undefined) {
        connectFromId = this.body.edges[this.temporaryIds.edges[0]].fromId;
      }

      // get the overlapping node but NOT the temporary node;
      var overlappingNodeIds = this.selectionHandler._getAllNodesOverlappingWith(pointerObj);
      var node = undefined;
      for (var i = overlappingNodeIds.length - 1; i >= 0; i--) {
        // if the node id is NOT a temporary node, accept the node.
        if (this.temporaryIds.nodes.indexOf(overlappingNodeIds[i]) === -1) {
          node = this.body.nodes[overlappingNodeIds[i]];
          break;
        }
      }

      // clean temporary nodes and edges.
      this._cleanupTemporaryNodesAndEdges();

      // perform the connection
      if (node !== undefined) {
        if (node.isCluster === true) {
          alert(this.options.locales[this.options.locale]['createEdgeError'] || this.options.locales['en']['createEdgeError']);
        } else {
          if (this.body.nodes[connectFromId] !== undefined && this.body.nodes[node.id] !== undefined) {
            this._performAddEdge(connectFromId, node.id);
          }
        }
      }

      // No need to do _generateclickevent('dragEnd') here, the regular dragEnd event fires.
      this.body.emitter.emit('_redraw');
    }

    /**
     *
     * @param {Event} event
     * @private
     */

  }, {
    key: '_dragStartEdge',
    value: function _dragStartEdge(event) {
      var pointer = this.lastTouch;
      this.selectionHandler._generateClickEvent('dragStart', event, pointer, undefined, true);
    }

    // --------------------------------------- END OF ADD EDGE FUNCTIONS -------------------------------------//


    // ------------------------------ Performing all the actual data manipulation ------------------------//

    /**
     * Adds a node on the specified location
     *
     * @param {Object} clickData
     * @private
     */

  }, {
    key: '_performAddNode',
    value: function _performAddNode(clickData) {
      var _this4 = this;

      var defaultData = {
        id: util.randomUUID(),
        x: clickData.pointer.canvas.x,
        y: clickData.pointer.canvas.y,
        label: 'new'
      };

      if (typeof this.options.addNode === 'function') {
        if (this.options.addNode.length === 2) {
          this.options.addNode(defaultData, function (finalizedData) {
            if (finalizedData !== null && finalizedData !== undefined && _this4.inMode === 'addNode') {
              // if for whatever reason the mode has changes (due to dataset change) disregard the callback
              _this4.body.data.nodes.getDataSet().add(finalizedData);
              _this4.showManipulatorToolbar();
            }
          });
        } else {
          this.showManipulatorToolbar();
          throw new Error('The function for add does not support two arguments (data,callback)');
        }
      } else {
        this.body.data.nodes.getDataSet().add(defaultData);
        this.showManipulatorToolbar();
      }
    }

    /**
     * connect two nodes with a new edge.
     *
     * @param {Node.id} sourceNodeId
     * @param {Node.id} targetNodeId
     * @private
     */

  }, {
    key: '_performAddEdge',
    value: function _performAddEdge(sourceNodeId, targetNodeId) {
      var _this5 = this;

      var defaultData = { from: sourceNodeId, to: targetNodeId };
      if (typeof this.options.addEdge === 'function') {
        if (this.options.addEdge.length === 2) {
          this.options.addEdge(defaultData, function (finalizedData) {
            if (finalizedData !== null && finalizedData !== undefined && _this5.inMode === 'addEdge') {
              // if for whatever reason the mode has changes (due to dataset change) disregard the callback
              _this5.body.data.edges.getDataSet().add(finalizedData);
              _this5.selectionHandler.unselectAll();
              _this5.showManipulatorToolbar();
            }
          });
        } else {
          throw new Error('The function for connect does not support two arguments (data,callback)');
        }
      } else {
        this.body.data.edges.getDataSet().add(defaultData);
        this.selectionHandler.unselectAll();
        this.showManipulatorToolbar();
      }
    }

    /**
     * connect two nodes with a new edge.
     *
     * @param {Node.id} sourceNodeId
     * @param {Node.id} targetNodeId
     * @private
     */

  }, {
    key: '_performEditEdge',
    value: function _performEditEdge(sourceNodeId, targetNodeId) {
      var _this6 = this;

      var defaultData = { id: this.edgeBeingEditedId, from: sourceNodeId, to: targetNodeId, label: this.body.data.edges._data[this.edgeBeingEditedId].label };
      var eeFunct = this.options.editEdge;
      if ((typeof eeFunct === 'undefined' ? 'undefined' : (0, _typeof3['default'])(eeFunct)) === 'object') {
        eeFunct = eeFunct.editWithoutDrag;
      }
      if (typeof eeFunct === 'function') {
        if (eeFunct.length === 2) {
          eeFunct(defaultData, function (finalizedData) {
            if (finalizedData === null || finalizedData === undefined || _this6.inMode !== 'editEdge') {
              // if for whatever reason the mode has changes (due to dataset change) disregard the callback) {
              _this6.body.edges[defaultData.id].updateEdgeType();
              _this6.body.emitter.emit('_redraw');
              _this6.showManipulatorToolbar();
            } else {
              _this6.body.data.edges.getDataSet().update(finalizedData);
              _this6.selectionHandler.unselectAll();
              _this6.showManipulatorToolbar();
            }
          });
        } else {
          throw new Error('The function for edit does not support two arguments (data, callback)');
        }
      } else {
        this.body.data.edges.getDataSet().update(defaultData);
        this.selectionHandler.unselectAll();
        this.showManipulatorToolbar();
      }
    }
  }]);
  return ManipulationSystem;
}();

exports['default'] = ManipulationSystem;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(30);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _FloydWarshall = __webpack_require__(239);

var _FloydWarshall2 = _interopRequireDefault(_FloydWarshall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * KamadaKawai positions the nodes initially based on
 *
 * "AN ALGORITHM FOR DRAWING GENERAL UNDIRECTED GRAPHS"
 * -- Tomihisa KAMADA and Satoru KAWAI in 1989
 *
 * Possible optimizations in the distance calculation can be implemented.
 */
var KamadaKawai = function () {
  /**
   * @param {Object} body
   * @param {number} edgeLength
   * @param {number} edgeStrength
   */
  function KamadaKawai(body, edgeLength, edgeStrength) {
    (0, _classCallCheck3["default"])(this, KamadaKawai);

    this.body = body;
    this.springLength = edgeLength;
    this.springConstant = edgeStrength;
    this.distanceSolver = new _FloydWarshall2["default"]();
  }

  /**
   * Not sure if needed but can be used to update the spring length and spring constant
   * @param {Object} options
   */


  (0, _createClass3["default"])(KamadaKawai, [{
    key: "setOptions",
    value: function setOptions(options) {
      if (options) {
        if (options.springLength) {
          this.springLength = options.springLength;
        }
        if (options.springConstant) {
          this.springConstant = options.springConstant;
        }
      }
    }

    /**
     * Position the system
     * @param {Array.<Node>} nodesArray
     * @param {Array.<vis.Edge>} edgesArray
     * @param {boolean} [ignoreClusters=false]
     */

  }, {
    key: "solve",
    value: function solve(nodesArray, edgesArray) {
      var ignoreClusters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // get distance matrix
      var D_matrix = this.distanceSolver.getDistances(this.body, nodesArray, edgesArray); // distance matrix

      // get the L Matrix
      this._createL_matrix(D_matrix);

      // get the K Matrix
      this._createK_matrix(D_matrix);

      // initial E Matrix
      this._createE_matrix();

      // calculate positions
      var threshold = 0.01;
      var innerThreshold = 1;
      var iterations = 0;
      var maxIterations = Math.max(1000, Math.min(10 * this.body.nodeIndices.length, 6000));
      var maxInnerIterations = 5;

      var maxEnergy = 1e9;
      var highE_nodeId = 0,
          dE_dx = 0,
          dE_dy = 0,
          delta_m = 0,
          subIterations = 0;

      while (maxEnergy > threshold && iterations < maxIterations) {
        iterations += 1;

        var _getHighestEnergyNode2 = this._getHighestEnergyNode(ignoreClusters);

        var _getHighestEnergyNode3 = (0, _slicedToArray3["default"])(_getHighestEnergyNode2, 4);

        highE_nodeId = _getHighestEnergyNode3[0];
        maxEnergy = _getHighestEnergyNode3[1];
        dE_dx = _getHighestEnergyNode3[2];
        dE_dy = _getHighestEnergyNode3[3];

        delta_m = maxEnergy;
        subIterations = 0;
        while (delta_m > innerThreshold && subIterations < maxInnerIterations) {
          subIterations += 1;
          this._moveNode(highE_nodeId, dE_dx, dE_dy);

          var _getEnergy2 = this._getEnergy(highE_nodeId);

          var _getEnergy3 = (0, _slicedToArray3["default"])(_getEnergy2, 3);

          delta_m = _getEnergy3[0];
          dE_dx = _getEnergy3[1];
          dE_dy = _getEnergy3[2];
        }
      }
    }

    /**
     * get the node with the highest energy
     * @param {boolean} ignoreClusters
     * @returns {number[]}
     * @private
     */

  }, {
    key: "_getHighestEnergyNode",
    value: function _getHighestEnergyNode(ignoreClusters) {
      var nodesArray = this.body.nodeIndices;
      var nodes = this.body.nodes;
      var maxEnergy = 0;
      var maxEnergyNodeId = nodesArray[0];
      var dE_dx_max = 0,
          dE_dy_max = 0;

      for (var nodeIdx = 0; nodeIdx < nodesArray.length; nodeIdx++) {
        var m = nodesArray[nodeIdx];
        // by not evaluating nodes with predefined positions we should only move nodes that have no positions.
        if (nodes[m].predefinedPosition === false || nodes[m].isCluster === true && ignoreClusters === true || nodes[m].options.fixed.x === true || nodes[m].options.fixed.y === true) {
          var _getEnergy4 = this._getEnergy(m),
              _getEnergy5 = (0, _slicedToArray3["default"])(_getEnergy4, 3),
              delta_m = _getEnergy5[0],
              dE_dx = _getEnergy5[1],
              dE_dy = _getEnergy5[2];

          if (maxEnergy < delta_m) {
            maxEnergy = delta_m;
            maxEnergyNodeId = m;
            dE_dx_max = dE_dx;
            dE_dy_max = dE_dy;
          }
        }
      }

      return [maxEnergyNodeId, maxEnergy, dE_dx_max, dE_dy_max];
    }

    /**
     * calculate the energy of a single node
     * @param {Node.id} m
     * @returns {number[]}
     * @private
     */

  }, {
    key: "_getEnergy",
    value: function _getEnergy(m) {
      var _E_sums$m = (0, _slicedToArray3["default"])(this.E_sums[m], 2),
          dE_dx = _E_sums$m[0],
          dE_dy = _E_sums$m[1];

      var delta_m = Math.sqrt(Math.pow(dE_dx, 2) + Math.pow(dE_dy, 2));
      return [delta_m, dE_dx, dE_dy];
    }

    /**
     * move the node based on it's energy
     * the dx and dy are calculated from the linear system proposed by Kamada and Kawai
     * @param {number} m
     * @param {number} dE_dx
     * @param {number} dE_dy
     * @private
     */

  }, {
    key: "_moveNode",
    value: function _moveNode(m, dE_dx, dE_dy) {
      var nodesArray = this.body.nodeIndices;
      var nodes = this.body.nodes;
      var d2E_dx2 = 0;
      var d2E_dxdy = 0;
      var d2E_dy2 = 0;

      var x_m = nodes[m].x;
      var y_m = nodes[m].y;
      var km = this.K_matrix[m];
      var lm = this.L_matrix[m];

      for (var iIdx = 0; iIdx < nodesArray.length; iIdx++) {
        var i = nodesArray[iIdx];
        if (i !== m) {
          var x_i = nodes[i].x;
          var y_i = nodes[i].y;
          var kmat = km[i];
          var lmat = lm[i];
          var denominator = 1.0 / Math.pow(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2), 1.5);
          d2E_dx2 += kmat * (1 - lmat * Math.pow(y_m - y_i, 2) * denominator);
          d2E_dxdy += kmat * (lmat * (x_m - x_i) * (y_m - y_i) * denominator);
          d2E_dy2 += kmat * (1 - lmat * Math.pow(x_m - x_i, 2) * denominator);
        }
      }
      // make the variable names easier to make the solving of the linear system easier to read
      var A = d2E_dx2,
          B = d2E_dxdy,
          C = dE_dx,
          D = d2E_dy2,
          E = dE_dy;

      // solve the linear system for dx and dy
      var dy = (C / A + E / B) / (B / A - D / B);
      var dx = -(B * dy + C) / A;

      // move the node
      nodes[m].x += dx;
      nodes[m].y += dy;

      // Recalculate E_matrix (should be incremental)
      this._updateE_matrix(m);
    }

    /**
     * Create the L matrix: edge length times shortest path
     * @param {Object} D_matrix
     * @private
     */

  }, {
    key: "_createL_matrix",
    value: function _createL_matrix(D_matrix) {
      var nodesArray = this.body.nodeIndices;
      var edgeLength = this.springLength;

      this.L_matrix = [];
      for (var i = 0; i < nodesArray.length; i++) {
        this.L_matrix[nodesArray[i]] = {};
        for (var j = 0; j < nodesArray.length; j++) {
          this.L_matrix[nodesArray[i]][nodesArray[j]] = edgeLength * D_matrix[nodesArray[i]][nodesArray[j]];
        }
      }
    }

    /**
     * Create the K matrix: spring constants times shortest path
     * @param {Object} D_matrix
     * @private
     */

  }, {
    key: "_createK_matrix",
    value: function _createK_matrix(D_matrix) {
      var nodesArray = this.body.nodeIndices;
      var edgeStrength = this.springConstant;

      this.K_matrix = [];
      for (var i = 0; i < nodesArray.length; i++) {
        this.K_matrix[nodesArray[i]] = {};
        for (var j = 0; j < nodesArray.length; j++) {
          this.K_matrix[nodesArray[i]][nodesArray[j]] = edgeStrength * Math.pow(D_matrix[nodesArray[i]][nodesArray[j]], -2);
        }
      }
    }

    /**
     *  Create matrix with all energies between nodes
     *  @private
     */

  }, {
    key: "_createE_matrix",
    value: function _createE_matrix() {
      var nodesArray = this.body.nodeIndices;
      var nodes = this.body.nodes;
      this.E_matrix = {};
      this.E_sums = {};
      for (var mIdx = 0; mIdx < nodesArray.length; mIdx++) {
        this.E_matrix[nodesArray[mIdx]] = [];
      }
      for (var _mIdx = 0; _mIdx < nodesArray.length; _mIdx++) {
        var m = nodesArray[_mIdx];
        var x_m = nodes[m].x;
        var y_m = nodes[m].y;
        var dE_dx = 0;
        var dE_dy = 0;
        for (var iIdx = _mIdx; iIdx < nodesArray.length; iIdx++) {
          var i = nodesArray[iIdx];
          if (i !== m) {
            var x_i = nodes[i].x;
            var y_i = nodes[i].y;
            var denominator = 1.0 / Math.sqrt(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2));
            this.E_matrix[m][iIdx] = [this.K_matrix[m][i] * (x_m - x_i - this.L_matrix[m][i] * (x_m - x_i) * denominator), this.K_matrix[m][i] * (y_m - y_i - this.L_matrix[m][i] * (y_m - y_i) * denominator)];
            this.E_matrix[i][_mIdx] = this.E_matrix[m][iIdx];
            dE_dx += this.E_matrix[m][iIdx][0];
            dE_dy += this.E_matrix[m][iIdx][1];
          }
        }
        //Store sum
        this.E_sums[m] = [dE_dx, dE_dy];
      }
    }

    /**
     * Update method, just doing single column (rows are auto-updated) (update all sums)
     *
     * @param {number} m
     * @private
     */

  }, {
    key: "_updateE_matrix",
    value: function _updateE_matrix(m) {
      var nodesArray = this.body.nodeIndices;
      var nodes = this.body.nodes;
      var colm = this.E_matrix[m];
      var kcolm = this.K_matrix[m];
      var lcolm = this.L_matrix[m];
      var x_m = nodes[m].x;
      var y_m = nodes[m].y;
      var dE_dx = 0;
      var dE_dy = 0;
      for (var iIdx = 0; iIdx < nodesArray.length; iIdx++) {
        var i = nodesArray[iIdx];
        if (i !== m) {
          //Keep old energy value for sum modification below
          var cell = colm[iIdx];
          var oldDx = cell[0];
          var oldDy = cell[1];

          //Calc new energy:
          var x_i = nodes[i].x;
          var y_i = nodes[i].y;
          var denominator = 1.0 / Math.sqrt(Math.pow(x_m - x_i, 2) + Math.pow(y_m - y_i, 2));
          var dx = kcolm[i] * (x_m - x_i - lcolm[i] * (x_m - x_i) * denominator);
          var dy = kcolm[i] * (y_m - y_i - lcolm[i] * (y_m - y_i) * denominator);
          colm[iIdx] = [dx, dy];
          dE_dx += dx;
          dE_dy += dy;

          //add new energy to sum of each column
          var sum = this.E_sums[i];
          sum[0] += dx - oldDx;
          sum[1] += dy - oldDy;
        }
      }
      //Store sum at -1 index
      this.E_sums[m] = [dE_dx, dE_dy];
    }
  }]);
  return KamadaKawai;
}(); // distance finding algorithm


exports["default"] = KamadaKawai;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 *  The Floyd–Warshall algorithm is an algorithm for finding shortest paths in
 *  a weighted graph with positive or negative edge weights (but with no negative
 *  cycles). - https://en.wikipedia.org/wiki/Floyd–Warshall_algorithm
 */
var FloydWarshall = function () {
  /**
   * @ignore
   */
  function FloydWarshall() {
    (0, _classCallCheck3["default"])(this, FloydWarshall);
  }

  /**
   *
   * @param {Object} body
   * @param {Array.<Node>} nodesArray
   * @param {Array.<Edge>} edgesArray
   * @returns {{}}
   */


  (0, _createClass3["default"])(FloydWarshall, [{
    key: "getDistances",
    value: function getDistances(body, nodesArray, edgesArray) {
      var D_matrix = {};
      var edges = body.edges;

      // prepare matrix with large numbers
      for (var i = 0; i < nodesArray.length; i++) {
        var node = nodesArray[i];
        var cell = {};
        D_matrix[node] = cell;
        for (var j = 0; j < nodesArray.length; j++) {
          cell[nodesArray[j]] = i == j ? 0 : 1e9;
        }
      }

      // put the weights for the edges in. This assumes unidirectionality.
      for (var _i = 0; _i < edgesArray.length; _i++) {
        var edge = edges[edgesArray[_i]];
        // edge has to be connected if it counts to the distances. If it is connected to inner clusters it will crash so we also check if it is in the D_matrix
        if (edge.connected === true && D_matrix[edge.fromId] !== undefined && D_matrix[edge.toId] !== undefined) {
          D_matrix[edge.fromId][edge.toId] = 1;
          D_matrix[edge.toId][edge.fromId] = 1;
        }
      }

      var nodeCount = nodesArray.length;

      // Adapted FloydWarshall based on unidirectionality to greatly reduce complexity.
      for (var k = 0; k < nodeCount; k++) {
        var knode = nodesArray[k];
        var kcolm = D_matrix[knode];
        for (var _i2 = 0; _i2 < nodeCount - 1; _i2++) {
          var inode = nodesArray[_i2];
          var icolm = D_matrix[inode];
          for (var _j = _i2 + 1; _j < nodeCount; _j++) {
            var jnode = nodesArray[_j];
            var jcolm = D_matrix[jnode];

            var val = Math.min(icolm[jnode], icolm[knode] + kcolm[jnode]);
            icolm[jnode] = val;
            jcolm[inode] = val;
          }
        }
      }

      return D_matrix;
    }
  }]);
  return FloydWarshall;
}();

exports["default"] = FloydWarshall;

/***/ })
/******/ ]);
});

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1029);
var v4 = __webpack_require__(449);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(447);
var bytesToUuid = __webpack_require__(448);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Icon__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Icon__);
var ZoomControl=function ZoomControl(_ref){var handleInClick=_ref.handleInClick,handleOutClick=_ref.handleOutClick,handleFitClick=_ref.handleFitClick;var output={};if(handleInClick){output.zoomin=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Icon___default.a,{color:'action',onClick:handleInClick},'zoom_in'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltiptext'},'Zoom In'));}if(handleOutClick){output.zoomout=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Icon___default.a,{color:'action',onClick:handleOutClick},'zoom_out'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltiptext'},'Zoom Out'));}if(handleFitClick){output.zoomfit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tooltip'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Icon___default.a,{color:'action',onClick:handleFitClick},'fullscreen_exit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltiptext'},'Zoom Fit'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'zoom-control'},output.zoomin,output.zoomout,output.zoomfit);};ZoomControl.propTypes={handleInClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleOutClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleFitClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (ZoomControl);

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      userSelect: 'none'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
};

function Icon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color']);


  var className = (0, _classnames2.default)('material-icons', classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'inherit'), classNameProp);

  return _react2.default.createElement(
    'span',
    (0, _extends3.default)({ className: className, 'aria-hidden': 'true' }, other),
    children
  );
}

Icon.propTypes =  false ? {
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   */
  color: _propTypes2.default.oneOf(['inherit', 'secondary', 'action', 'disabled', 'error', 'primary'])
} : {};

Icon.defaultProps = {
  color: 'inherit'
};

Icon.muiName = 'Icon';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIcon' })(Icon);

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Icon__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Icon__);
var CONFIG=__webpack_require__(79);function extractHostname(url){var hostname=void 0;if(url.indexOf("://")>-1){hostname=url.split('/')[2];}else{hostname=url.split('/')[0];}hostname=hostname.split(':')[0];hostname=hostname.split('?')[0];return hostname;}var EdgeDetail=function EdgeDetail(_ref){var handleCloseDetailClick=_ref.handleCloseDetailClick,edge=_ref.edge,nodes=_ref.nodes;var output={};if(handleCloseDetailClick){output.button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Icon___default.a,{color:'action',onClick:handleCloseDetailClick,className:'close-icon'},'close');}var from_node={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=nodes[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var node=_step.value;if(node.id===edge.from)from_node=node;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var to_node={};var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=nodes[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _node=_step2.value;if(_node.id===edge.to)to_node=_node;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}output.references=[];var references=[];if(edge.reference){references.push(edge.reference);}if(edge.references){references.push(edge.references);}var index=0;var key=new Date().getTime();var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=references[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var reference=_step3.value;key+=index;output.references.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'reference',href:reference,target:'_blank'},extractHostname(reference))));index++;}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}var page=CONFIG.reportPageOffset+edge.page;output.report=[];if(edge.page){var _key=new Date().getTime();output.report.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:_key,href:CONFIG.reportPDFLink+'#page='+page,target:'_blank'},'View full report: page ',edge.page));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edge_detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'FROM')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,from_node.label))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'photo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:from_node.image,alt:'photo',width:'100',height:'100'})),output.button,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'connection-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Connection: ',edge.type))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'lead'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'To')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,to_node.label))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'photo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:to_node.image,alt:'photo',width:'100',height:'100'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},edge.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report'},output.report),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'references'},output.references));};EdgeDetail.propTypes={edge:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,nodes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,handleCloseDetailClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (EdgeDetail);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Icon__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_world_flags__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_world_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_world_flags__);
var countries=__webpack_require__(1035).countries;var CONFIG=__webpack_require__(79);function extractHostname(url){var hostname=void 0;if(url.indexOf("://")>-1){hostname=url.split('/')[2];}else{hostname=url.split('/')[0];}hostname=hostname.split(':')[0];hostname=hostname.split('?')[0];return hostname;}var NodeDetail=function NodeDetail(_ref){var handleCloseDetailClick=_ref.handleCloseDetailClick,handleTagClick=_ref.handleTagClick,node=_ref.node;var output={};if(handleCloseDetailClick){output.button=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Icon___default.a,{color:'action',onClick:handleCloseDetailClick,className:'close-icon'},'close');}if(node.country){node.country=node.country.toUpperCase();output.country=node.country;if(countries[output.country]){output.country=countries[output.country].name;}output.flag=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_world_flags___default.a,{code:node.country,height:'16',className:'flag'});}output.tags=[];var tags=[];if(node.tags){tags=node.tags;tags=tags.split(',');}var index=0;var key=new Date().getTime();var _loop=function _loop(tag){key+=index;output.tags.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tag',key:key,onClick:function onClick(){return handleTagClick({tag:tag});}},tag));index++;};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=tags[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var tag=_step.value;_loop(tag);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}output.references=[];var references=[];if(node.reference){references.push(node.reference);}if(node.references){references.push(node.references);}index=0;key=new Date().getTime();var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=references[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var reference=_step2.value;key+=index;output.references.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'reference',href:reference,target:'_blank'},extractHostname(reference))));index++;}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}var page=node.page+'';if(page){var splits=page.split(',');var pages=[];var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=splits[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var split=_step3.value;pages.push(split);}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}output.report=[];key=new Date().getTime();index=0;var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=pages[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var item=_step4.value;var page_index=CONFIG.reportPageOffset+Number(item.trim());var str='';if(index===0){str='View full report: page '+item;}else{str=item;}if(index!==pages.length-1)str+=', ';output.report.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:key,href:CONFIG.reportPDFLink+'#page='+page_index,target:'_blank'},str));key+=1;index++;}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'node-panel'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,node.label)),node.alias?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'alias'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Alias : ',node.alias)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'photo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:node.image,alt:'photo',width:'100',height:'100'})),output.button),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'info-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'type'},'Type : ',node.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country'},'Country : ',output.country,' ',output.flag)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},node.description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'report'},output.report),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'references'},output.references));};NodeDetail.propTypes={node:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,handleCloseDetailClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleTagClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (NodeDetail);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["react-world-flags"] = factory(require("react"));
	else
		root["react-world-flags"] = factory(root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlphaTwoCode = undefined;

var _worldCountries = __webpack_require__(239);

var _worldCountries2 = _interopRequireDefault(_worldCountries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAlphaTwoCode = exports.getAlphaTwoCode = function getAlphaTwoCode(code) {
  var uc = String(code).toUpperCase();
  var country = _worldCountries2.default.find(function (c) {
    return c.cca2 === uc || c.ccn3 === uc || c.cca3 == uc;
  });
  return country && country.cca2;
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ad = __webpack_require__(4);

var _ad2 = _interopRequireDefault(_ad);

var _ae = __webpack_require__(5);

var _ae2 = _interopRequireDefault(_ae);

var _af = __webpack_require__(6);

var _af2 = _interopRequireDefault(_af);

var _ag = __webpack_require__(7);

var _ag2 = _interopRequireDefault(_ag);

var _ai = __webpack_require__(8);

var _ai2 = _interopRequireDefault(_ai);

var _al = __webpack_require__(9);

var _al2 = _interopRequireDefault(_al);

var _am = __webpack_require__(10);

var _am2 = _interopRequireDefault(_am);

var _ao = __webpack_require__(11);

var _ao2 = _interopRequireDefault(_ao);

var _ar = __webpack_require__(12);

var _ar2 = _interopRequireDefault(_ar);

var _as = __webpack_require__(13);

var _as2 = _interopRequireDefault(_as);

var _at = __webpack_require__(14);

var _at2 = _interopRequireDefault(_at);

var _au = __webpack_require__(15);

var _au2 = _interopRequireDefault(_au);

var _aw = __webpack_require__(16);

var _aw2 = _interopRequireDefault(_aw);

var _ax = __webpack_require__(17);

var _ax2 = _interopRequireDefault(_ax);

var _az = __webpack_require__(18);

var _az2 = _interopRequireDefault(_az);

var _ba = __webpack_require__(19);

var _ba2 = _interopRequireDefault(_ba);

var _bb = __webpack_require__(20);

var _bb2 = _interopRequireDefault(_bb);

var _bd = __webpack_require__(21);

var _bd2 = _interopRequireDefault(_bd);

var _be = __webpack_require__(22);

var _be2 = _interopRequireDefault(_be);

var _bf = __webpack_require__(23);

var _bf2 = _interopRequireDefault(_bf);

var _bg = __webpack_require__(24);

var _bg2 = _interopRequireDefault(_bg);

var _bh = __webpack_require__(25);

var _bh2 = _interopRequireDefault(_bh);

var _bi = __webpack_require__(26);

var _bi2 = _interopRequireDefault(_bi);

var _bj = __webpack_require__(27);

var _bj2 = _interopRequireDefault(_bj);

var _bm = __webpack_require__(28);

var _bm2 = _interopRequireDefault(_bm);

var _bn = __webpack_require__(29);

var _bn2 = _interopRequireDefault(_bn);

var _bo = __webpack_require__(30);

var _bo2 = _interopRequireDefault(_bo);

var _br = __webpack_require__(31);

var _br2 = _interopRequireDefault(_br);

var _bs = __webpack_require__(32);

var _bs2 = _interopRequireDefault(_bs);

var _bt = __webpack_require__(33);

var _bt2 = _interopRequireDefault(_bt);

var _bw = __webpack_require__(34);

var _bw2 = _interopRequireDefault(_bw);

var _by = __webpack_require__(35);

var _by2 = _interopRequireDefault(_by);

var _bz = __webpack_require__(36);

var _bz2 = _interopRequireDefault(_bz);

var _ca = __webpack_require__(37);

var _ca2 = _interopRequireDefault(_ca);

var _cc = __webpack_require__(38);

var _cc2 = _interopRequireDefault(_cc);

var _cd = __webpack_require__(39);

var _cd2 = _interopRequireDefault(_cd);

var _cf = __webpack_require__(40);

var _cf2 = _interopRequireDefault(_cf);

var _cg = __webpack_require__(41);

var _cg2 = _interopRequireDefault(_cg);

var _ch = __webpack_require__(42);

var _ch2 = _interopRequireDefault(_ch);

var _ci = __webpack_require__(43);

var _ci2 = _interopRequireDefault(_ci);

var _ck = __webpack_require__(44);

var _ck2 = _interopRequireDefault(_ck);

var _cl = __webpack_require__(45);

var _cl2 = _interopRequireDefault(_cl);

var _cm = __webpack_require__(46);

var _cm2 = _interopRequireDefault(_cm);

var _cn = __webpack_require__(47);

var _cn2 = _interopRequireDefault(_cn);

var _co = __webpack_require__(48);

var _co2 = _interopRequireDefault(_co);

var _cr = __webpack_require__(49);

var _cr2 = _interopRequireDefault(_cr);

var _cu = __webpack_require__(50);

var _cu2 = _interopRequireDefault(_cu);

var _cv = __webpack_require__(51);

var _cv2 = _interopRequireDefault(_cv);

var _cw = __webpack_require__(52);

var _cw2 = _interopRequireDefault(_cw);

var _cx = __webpack_require__(53);

var _cx2 = _interopRequireDefault(_cx);

var _cy = __webpack_require__(54);

var _cy2 = _interopRequireDefault(_cy);

var _cz = __webpack_require__(55);

var _cz2 = _interopRequireDefault(_cz);

var _de = __webpack_require__(56);

var _de2 = _interopRequireDefault(_de);

var _dj = __webpack_require__(57);

var _dj2 = _interopRequireDefault(_dj);

var _dk = __webpack_require__(58);

var _dk2 = _interopRequireDefault(_dk);

var _dm = __webpack_require__(59);

var _dm2 = _interopRequireDefault(_dm);

var _do = __webpack_require__(60);

var _do2 = _interopRequireDefault(_do);

var _dz = __webpack_require__(61);

var _dz2 = _interopRequireDefault(_dz);

var _ec = __webpack_require__(62);

var _ec2 = _interopRequireDefault(_ec);

var _ee = __webpack_require__(63);

var _ee2 = _interopRequireDefault(_ee);

var _eg = __webpack_require__(64);

var _eg2 = _interopRequireDefault(_eg);

var _er = __webpack_require__(65);

var _er2 = _interopRequireDefault(_er);

var _es = __webpack_require__(66);

var _es2 = _interopRequireDefault(_es);

var _et = __webpack_require__(67);

var _et2 = _interopRequireDefault(_et);

var _fi = __webpack_require__(68);

var _fi2 = _interopRequireDefault(_fi);

var _fj = __webpack_require__(69);

var _fj2 = _interopRequireDefault(_fj);

var _fk = __webpack_require__(70);

var _fk2 = _interopRequireDefault(_fk);

var _fm = __webpack_require__(71);

var _fm2 = _interopRequireDefault(_fm);

var _fo = __webpack_require__(72);

var _fo2 = _interopRequireDefault(_fo);

var _fr = __webpack_require__(73);

var _fr2 = _interopRequireDefault(_fr);

var _ga = __webpack_require__(74);

var _ga2 = _interopRequireDefault(_ga);

var _gb = __webpack_require__(75);

var _gb2 = _interopRequireDefault(_gb);

var _gd = __webpack_require__(76);

var _gd2 = _interopRequireDefault(_gd);

var _ge = __webpack_require__(77);

var _ge2 = _interopRequireDefault(_ge);

var _gg = __webpack_require__(78);

var _gg2 = _interopRequireDefault(_gg);

var _gh = __webpack_require__(79);

var _gh2 = _interopRequireDefault(_gh);

var _gi = __webpack_require__(80);

var _gi2 = _interopRequireDefault(_gi);

var _gl = __webpack_require__(81);

var _gl2 = _interopRequireDefault(_gl);

var _gm = __webpack_require__(82);

var _gm2 = _interopRequireDefault(_gm);

var _gn = __webpack_require__(83);

var _gn2 = _interopRequireDefault(_gn);

var _gq = __webpack_require__(84);

var _gq2 = _interopRequireDefault(_gq);

var _gr = __webpack_require__(85);

var _gr2 = _interopRequireDefault(_gr);

var _gs = __webpack_require__(86);

var _gs2 = _interopRequireDefault(_gs);

var _gt = __webpack_require__(87);

var _gt2 = _interopRequireDefault(_gt);

var _gu = __webpack_require__(88);

var _gu2 = _interopRequireDefault(_gu);

var _gw = __webpack_require__(89);

var _gw2 = _interopRequireDefault(_gw);

var _gy = __webpack_require__(90);

var _gy2 = _interopRequireDefault(_gy);

var _hk = __webpack_require__(91);

var _hk2 = _interopRequireDefault(_hk);

var _hn = __webpack_require__(92);

var _hn2 = _interopRequireDefault(_hn);

var _hr = __webpack_require__(93);

var _hr2 = _interopRequireDefault(_hr);

var _ht = __webpack_require__(94);

var _ht2 = _interopRequireDefault(_ht);

var _hu = __webpack_require__(95);

var _hu2 = _interopRequireDefault(_hu);

var _id = __webpack_require__(96);

var _id2 = _interopRequireDefault(_id);

var _ie = __webpack_require__(97);

var _ie2 = _interopRequireDefault(_ie);

var _il = __webpack_require__(98);

var _il2 = _interopRequireDefault(_il);

var _im = __webpack_require__(99);

var _im2 = _interopRequireDefault(_im);

var _in = __webpack_require__(100);

var _in2 = _interopRequireDefault(_in);

var _io = __webpack_require__(101);

var _io2 = _interopRequireDefault(_io);

var _iq = __webpack_require__(102);

var _iq2 = _interopRequireDefault(_iq);

var _ir = __webpack_require__(103);

var _ir2 = _interopRequireDefault(_ir);

var _is = __webpack_require__(104);

var _is2 = _interopRequireDefault(_is);

var _it = __webpack_require__(105);

var _it2 = _interopRequireDefault(_it);

var _je = __webpack_require__(106);

var _je2 = _interopRequireDefault(_je);

var _jm = __webpack_require__(107);

var _jm2 = _interopRequireDefault(_jm);

var _jo = __webpack_require__(108);

var _jo2 = _interopRequireDefault(_jo);

var _jp = __webpack_require__(109);

var _jp2 = _interopRequireDefault(_jp);

var _ke = __webpack_require__(110);

var _ke2 = _interopRequireDefault(_ke);

var _kg = __webpack_require__(111);

var _kg2 = _interopRequireDefault(_kg);

var _kh = __webpack_require__(112);

var _kh2 = _interopRequireDefault(_kh);

var _ki = __webpack_require__(113);

var _ki2 = _interopRequireDefault(_ki);

var _km = __webpack_require__(114);

var _km2 = _interopRequireDefault(_km);

var _kn = __webpack_require__(115);

var _kn2 = _interopRequireDefault(_kn);

var _kp = __webpack_require__(116);

var _kp2 = _interopRequireDefault(_kp);

var _kr = __webpack_require__(117);

var _kr2 = _interopRequireDefault(_kr);

var _kw = __webpack_require__(118);

var _kw2 = _interopRequireDefault(_kw);

var _ky = __webpack_require__(119);

var _ky2 = _interopRequireDefault(_ky);

var _kz = __webpack_require__(120);

var _kz2 = _interopRequireDefault(_kz);

var _la = __webpack_require__(121);

var _la2 = _interopRequireDefault(_la);

var _lb = __webpack_require__(122);

var _lb2 = _interopRequireDefault(_lb);

var _lc = __webpack_require__(123);

var _lc2 = _interopRequireDefault(_lc);

var _li = __webpack_require__(124);

var _li2 = _interopRequireDefault(_li);

var _lk = __webpack_require__(125);

var _lk2 = _interopRequireDefault(_lk);

var _lr = __webpack_require__(126);

var _lr2 = _interopRequireDefault(_lr);

var _ls = __webpack_require__(127);

var _ls2 = _interopRequireDefault(_ls);

var _lt = __webpack_require__(128);

var _lt2 = _interopRequireDefault(_lt);

var _lu = __webpack_require__(129);

var _lu2 = _interopRequireDefault(_lu);

var _lv = __webpack_require__(130);

var _lv2 = _interopRequireDefault(_lv);

var _ly = __webpack_require__(131);

var _ly2 = _interopRequireDefault(_ly);

var _ma = __webpack_require__(132);

var _ma2 = _interopRequireDefault(_ma);

var _mc = __webpack_require__(133);

var _mc2 = _interopRequireDefault(_mc);

var _md = __webpack_require__(134);

var _md2 = _interopRequireDefault(_md);

var _me = __webpack_require__(135);

var _me2 = _interopRequireDefault(_me);

var _mg = __webpack_require__(136);

var _mg2 = _interopRequireDefault(_mg);

var _mh = __webpack_require__(137);

var _mh2 = _interopRequireDefault(_mh);

var _mk = __webpack_require__(138);

var _mk2 = _interopRequireDefault(_mk);

var _ml = __webpack_require__(139);

var _ml2 = _interopRequireDefault(_ml);

var _mm = __webpack_require__(140);

var _mm2 = _interopRequireDefault(_mm);

var _mn = __webpack_require__(141);

var _mn2 = _interopRequireDefault(_mn);

var _mo = __webpack_require__(142);

var _mo2 = _interopRequireDefault(_mo);

var _mp = __webpack_require__(143);

var _mp2 = _interopRequireDefault(_mp);

var _mz = __webpack_require__(152);

var _mz2 = _interopRequireDefault(_mz);

var _mr = __webpack_require__(144);

var _mr2 = _interopRequireDefault(_mr);

var _ms = __webpack_require__(145);

var _ms2 = _interopRequireDefault(_ms);

var _mt = __webpack_require__(146);

var _mt2 = _interopRequireDefault(_mt);

var _mu = __webpack_require__(147);

var _mu2 = _interopRequireDefault(_mu);

var _mv = __webpack_require__(148);

var _mv2 = _interopRequireDefault(_mv);

var _mw = __webpack_require__(149);

var _mw2 = _interopRequireDefault(_mw);

var _mx = __webpack_require__(150);

var _mx2 = _interopRequireDefault(_mx);

var _my = __webpack_require__(151);

var _my2 = _interopRequireDefault(_my);

var _na = __webpack_require__(153);

var _na2 = _interopRequireDefault(_na);

var _nc = __webpack_require__(154);

var _nc2 = _interopRequireDefault(_nc);

var _ne = __webpack_require__(155);

var _ne2 = _interopRequireDefault(_ne);

var _nf = __webpack_require__(156);

var _nf2 = _interopRequireDefault(_nf);

var _ng = __webpack_require__(157);

var _ng2 = _interopRequireDefault(_ng);

var _ni = __webpack_require__(158);

var _ni2 = _interopRequireDefault(_ni);

var _nl = __webpack_require__(159);

var _nl2 = _interopRequireDefault(_nl);

var _no = __webpack_require__(160);

var _no2 = _interopRequireDefault(_no);

var _np = __webpack_require__(161);

var _np2 = _interopRequireDefault(_np);

var _nr = __webpack_require__(162);

var _nr2 = _interopRequireDefault(_nr);

var _nu = __webpack_require__(163);

var _nu2 = _interopRequireDefault(_nu);

var _nz = __webpack_require__(164);

var _nz2 = _interopRequireDefault(_nz);

var _om = __webpack_require__(165);

var _om2 = _interopRequireDefault(_om);

var _pa = __webpack_require__(166);

var _pa2 = _interopRequireDefault(_pa);

var _pe = __webpack_require__(167);

var _pe2 = _interopRequireDefault(_pe);

var _pf = __webpack_require__(168);

var _pf2 = _interopRequireDefault(_pf);

var _ps = __webpack_require__(175);

var _ps2 = _interopRequireDefault(_ps);

var _pg = __webpack_require__(169);

var _pg2 = _interopRequireDefault(_pg);

var _ph = __webpack_require__(170);

var _ph2 = _interopRequireDefault(_ph);

var _pk = __webpack_require__(171);

var _pk2 = _interopRequireDefault(_pk);

var _pl = __webpack_require__(172);

var _pl2 = _interopRequireDefault(_pl);

var _pn = __webpack_require__(173);

var _pn2 = _interopRequireDefault(_pn);

var _pr = __webpack_require__(174);

var _pr2 = _interopRequireDefault(_pr);

var _pt = __webpack_require__(176);

var _pt2 = _interopRequireDefault(_pt);

var _pw = __webpack_require__(177);

var _pw2 = _interopRequireDefault(_pw);

var _py = __webpack_require__(178);

var _py2 = _interopRequireDefault(_py);

var _qa = __webpack_require__(179);

var _qa2 = _interopRequireDefault(_qa);

var _re = __webpack_require__(180);

var _re2 = _interopRequireDefault(_re);

var _ro = __webpack_require__(181);

var _ro2 = _interopRequireDefault(_ro);

var _rs = __webpack_require__(182);

var _rs2 = _interopRequireDefault(_rs);

var _ru = __webpack_require__(183);

var _ru2 = _interopRequireDefault(_ru);

var _rw = __webpack_require__(184);

var _rw2 = _interopRequireDefault(_rw);

var _sa = __webpack_require__(185);

var _sa2 = _interopRequireDefault(_sa);

var _sb = __webpack_require__(186);

var _sb2 = _interopRequireDefault(_sb);

var _sc = __webpack_require__(187);

var _sc2 = _interopRequireDefault(_sc);

var _sd = __webpack_require__(188);

var _sd2 = _interopRequireDefault(_sd);

var _se = __webpack_require__(189);

var _se2 = _interopRequireDefault(_se);

var _sg = __webpack_require__(190);

var _sg2 = _interopRequireDefault(_sg);

var _sh = __webpack_require__(191);

var _sh2 = _interopRequireDefault(_sh);

var _si = __webpack_require__(192);

var _si2 = _interopRequireDefault(_si);

var _sk = __webpack_require__(193);

var _sk2 = _interopRequireDefault(_sk);

var _sl = __webpack_require__(194);

var _sl2 = _interopRequireDefault(_sl);

var _sm = __webpack_require__(195);

var _sm2 = _interopRequireDefault(_sm);

var _sn = __webpack_require__(196);

var _sn2 = _interopRequireDefault(_sn);

var _so = __webpack_require__(197);

var _so2 = _interopRequireDefault(_so);

var _sr = __webpack_require__(198);

var _sr2 = _interopRequireDefault(_sr);

var _ss = __webpack_require__(199);

var _ss2 = _interopRequireDefault(_ss);

var _st = __webpack_require__(200);

var _st2 = _interopRequireDefault(_st);

var _sv = __webpack_require__(201);

var _sv2 = _interopRequireDefault(_sv);

var _sx = __webpack_require__(202);

var _sx2 = _interopRequireDefault(_sx);

var _sy = __webpack_require__(203);

var _sy2 = _interopRequireDefault(_sy);

var _sz = __webpack_require__(204);

var _sz2 = _interopRequireDefault(_sz);

var _tc = __webpack_require__(205);

var _tc2 = _interopRequireDefault(_tc);

var _td = __webpack_require__(206);

var _td2 = _interopRequireDefault(_td);

var _tf = __webpack_require__(207);

var _tf2 = _interopRequireDefault(_tf);

var _tg = __webpack_require__(208);

var _tg2 = _interopRequireDefault(_tg);

var _th = __webpack_require__(209);

var _th2 = _interopRequireDefault(_th);

var _tj = __webpack_require__(210);

var _tj2 = _interopRequireDefault(_tj);

var _tk = __webpack_require__(211);

var _tk2 = _interopRequireDefault(_tk);

var _tl = __webpack_require__(212);

var _tl2 = _interopRequireDefault(_tl);

var _tm = __webpack_require__(213);

var _tm2 = _interopRequireDefault(_tm);

var _tn = __webpack_require__(214);

var _tn2 = _interopRequireDefault(_tn);

var _to = __webpack_require__(215);

var _to2 = _interopRequireDefault(_to);

var _tr = __webpack_require__(216);

var _tr2 = _interopRequireDefault(_tr);

var _tt = __webpack_require__(217);

var _tt2 = _interopRequireDefault(_tt);

var _tv = __webpack_require__(218);

var _tv2 = _interopRequireDefault(_tv);

var _tz = __webpack_require__(220);

var _tz2 = _interopRequireDefault(_tz);

var _tw = __webpack_require__(219);

var _tw2 = _interopRequireDefault(_tw);

var _ua = __webpack_require__(221);

var _ua2 = _interopRequireDefault(_ua);

var _ug = __webpack_require__(222);

var _ug2 = _interopRequireDefault(_ug);

var _us = __webpack_require__(223);

var _us2 = _interopRequireDefault(_us);

var _uy = __webpack_require__(224);

var _uy2 = _interopRequireDefault(_uy);

var _uz = __webpack_require__(225);

var _uz2 = _interopRequireDefault(_uz);

var _va = __webpack_require__(226);

var _va2 = _interopRequireDefault(_va);

var _vc = __webpack_require__(227);

var _vc2 = _interopRequireDefault(_vc);

var _ve = __webpack_require__(228);

var _ve2 = _interopRequireDefault(_ve);

var _vg = __webpack_require__(229);

var _vg2 = _interopRequireDefault(_vg);

var _vi = __webpack_require__(230);

var _vi2 = _interopRequireDefault(_vi);

var _vn = __webpack_require__(231);

var _vn2 = _interopRequireDefault(_vn);

var _vu = __webpack_require__(232);

var _vu2 = _interopRequireDefault(_vu);

var _ws = __webpack_require__(233);

var _ws2 = _interopRequireDefault(_ws);

var _ye = __webpack_require__(234);

var _ye2 = _interopRequireDefault(_ye);

var _za = __webpack_require__(235);

var _za2 = _interopRequireDefault(_za);

var _zm = __webpack_require__(236);

var _zm2 = _interopRequireDefault(_zm);

var _zw = __webpack_require__(237);

var _zw2 = _interopRequireDefault(_zw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { flag_AD: _ad2.default, flag_AE: _ae2.default, flag_AF: _af2.default, flag_AG: _ag2.default, flag_AI: _ai2.default, flag_AL: _al2.default, flag_AM: _am2.default, flag_AO: _ao2.default, flag_AR: _ar2.default, flag_AS: _as2.default, flag_AT: _at2.default, flag_AU: _au2.default, flag_AW: _aw2.default, flag_AX: _ax2.default, flag_AZ: _az2.default, flag_BA: _ba2.default, flag_BB: _bb2.default, flag_BD: _bd2.default, flag_BE: _be2.default, flag_BF: _bf2.default, flag_BG: _bg2.default, flag_BH: _bh2.default, flag_BI: _bi2.default, flag_BJ: _bj2.default, flag_BM: _bm2.default, flag_BN: _bn2.default, flag_BO: _bo2.default, flag_BR: _br2.default, flag_BS: _bs2.default, flag_BT: _bt2.default, flag_BW: _bw2.default, flag_BY: _by2.default, flag_BZ: _bz2.default, flag_CA: _ca2.default, flag_CC: _cc2.default, flag_CD: _cd2.default, flag_CF: _cf2.default, flag_CG: _cg2.default, flag_CH: _ch2.default, flag_CI: _ci2.default, flag_CK: _ck2.default, flag_CL: _cl2.default, flag_CM: _cm2.default, flag_CN: _cn2.default, flag_CO: _co2.default, flag_CR: _cr2.default, flag_CU: _cu2.default, flag_CV: _cv2.default, flag_CW: _cw2.default, flag_CX: _cx2.default, flag_CY: _cy2.default, flag_CZ: _cz2.default, flag_DE: _de2.default, flag_DJ: _dj2.default, flag_DK: _dk2.default, flag_DM: _dm2.default, flag_DO: _do2.default, flag_DZ: _dz2.default, flag_EC: _ec2.default, flag_EE: _ee2.default, flag_EG: _eg2.default, flag_ER: _er2.default, flag_ES: _es2.default, flag_ET: _et2.default, flag_FI: _fi2.default, flag_FJ: _fj2.default, flag_FK: _fk2.default, flag_FM: _fm2.default, flag_FO: _fo2.default, flag_FR: _fr2.default, flag_GA: _ga2.default, flag_GB: _gb2.default, flag_GD: _gd2.default, flag_GE: _ge2.default, flag_GG: _gg2.default, flag_GH: _gh2.default, flag_GI: _gi2.default, flag_GL: _gl2.default, flag_GM: _gm2.default, flag_GN: _gn2.default, flag_GQ: _gq2.default, flag_GR: _gr2.default, flag_GS: _gs2.default, flag_GT: _gt2.default, flag_GU: _gu2.default, flag_GW: _gw2.default, flag_GY: _gy2.default, flag_HK: _hk2.default, flag_HN: _hn2.default, flag_HR: _hr2.default, flag_HT: _ht2.default, flag_HU: _hu2.default, flag_ID: _id2.default, flag_IE: _ie2.default, flag_IL: _il2.default, flag_IM: _im2.default, flag_IN: _in2.default, flag_IO: _io2.default, flag_IQ: _iq2.default, flag_IR: _ir2.default, flag_IS: _is2.default, flag_IT: _it2.default, flag_JE: _je2.default, flag_JM: _jm2.default, flag_JO: _jo2.default, flag_JP: _jp2.default, flag_KE: _ke2.default, flag_KG: _kg2.default, flag_KH: _kh2.default, flag_KI: _ki2.default, flag_KM: _km2.default, flag_KN: _kn2.default, flag_KP: _kp2.default, flag_KR: _kr2.default, flag_KW: _kw2.default, flag_KY: _ky2.default, flag_KZ: _kz2.default, flag_LA: _la2.default, flag_LB: _lb2.default, flag_LC: _lc2.default, flag_LI: _li2.default, flag_LK: _lk2.default, flag_LR: _lr2.default, flag_LS: _ls2.default, flag_LT: _lt2.default, flag_LU: _lu2.default, flag_LV: _lv2.default, flag_LY: _ly2.default, flag_MA: _ma2.default, flag_MC: _mc2.default, flag_MD: _md2.default, flag_ME: _me2.default, flag_MG: _mg2.default, flag_MH: _mh2.default, flag_MK: _mk2.default, flag_ML: _ml2.default, flag_MM: _mm2.default, flag_MN: _mn2.default, flag_MO: _mo2.default, flag_MP: _mp2.default, flag_MZ: _mz2.default, flag_MR: _mr2.default, flag_MS: _ms2.default, flag_MT: _mt2.default, flag_MU: _mu2.default, flag_MV: _mv2.default, flag_MW: _mw2.default, flag_MX: _mx2.default, flag_MY: _my2.default, flag_NA: _na2.default, flag_NC: _nc2.default, flag_NE: _ne2.default, flag_NF: _nf2.default, flag_NG: _ng2.default, flag_NI: _ni2.default, flag_NL: _nl2.default, flag_NO: _no2.default, flag_NP: _np2.default, flag_NR: _nr2.default, flag_NU: _nu2.default, flag_NZ: _nz2.default, flag_OM: _om2.default, flag_PA: _pa2.default, flag_PE: _pe2.default, flag_PF: _pf2.default, flag_PS: _ps2.default, flag_PG: _pg2.default, flag_PH: _ph2.default, flag_PK: _pk2.default, flag_PL: _pl2.default, flag_PN: _pn2.default, flag_PR: _pr2.default, flag_PT: _pt2.default, flag_PW: _pw2.default, flag_PY: _py2.default, flag_QA: _qa2.default, flag_RE: _re2.default, flag_RO: _ro2.default, flag_RS: _rs2.default, flag_RU: _ru2.default, flag_RW: _rw2.default, flag_SA: _sa2.default, flag_SB: _sb2.default, flag_SC: _sc2.default, flag_SD: _sd2.default, flag_SE: _se2.default, flag_SG: _sg2.default, flag_SH: _sh2.default, flag_SI: _si2.default, flag_SK: _sk2.default, flag_SL: _sl2.default, flag_SM: _sm2.default, flag_SN: _sn2.default, flag_SO: _so2.default, flag_SR: _sr2.default, flag_SS: _ss2.default, flag_ST: _st2.default, flag_SV: _sv2.default, flag_SX: _sx2.default, flag_SY: _sy2.default, flag_SZ: _sz2.default, flag_TC: _tc2.default, flag_TD: _td2.default, flag_TF: _tf2.default, flag_TG: _tg2.default, flag_TH: _th2.default, flag_TJ: _tj2.default, flag_TK: _tk2.default, flag_TL: _tl2.default, flag_TM: _tm2.default, flag_TN: _tn2.default, flag_TO: _to2.default, flag_TR: _tr2.default, flag_TT: _tt2.default, flag_TV: _tv2.default, flag_TZ: _tz2.default, flag_TW: _tw2.default, flag_UA: _ua2.default, flag_UG: _ug2.default, flag_US: _us2.default, flag_UY: _uy2.default, flag_UZ: _uz2.default, flag_VA: _va2.default, flag_VC: _vc2.default, flag_VE: _ve2.default, flag_VG: _vg2.default, flag_VI: _vi2.default, flag_VN: _vn2.default, flag_VU: _vu2.default, flag_WS: _ws2.default, flag_YE: _ye2.default, flag_ZA: _za2.default, flag_ZM: _zm2.default, flag_ZW: _zw2.default };

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _flags = __webpack_require__(1);

var _flags2 = _interopRequireDefault(_flags);

var _country = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function (props) {
  var code = props.code,
      rest = _objectWithoutProperties(props, ['code']);

  var alphaTwo = (0, _country.getAlphaTwoCode)(code);
  return !!alphaTwo && _react2.default.createElement('img', _extends({}, rest, { src: _flags2.default['flag_' + alphaTwo] }));
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='700'%3E %3Crect width='1000' height='700' fill='%23d0103a'/%3E %3Crect width='680' height='700' fill='%23fedf00'/%3E %3Crect width='320' height='700' fill='%230018a8'/%3E %3Cg%3E %3Cpath fill='%23c7b37f' d='m469.37,188.48c12.051,0,16.979,10.338,29.029,10.338,7.4391,0,11.777-2.4293,18.261-6.087,4.5235-2.5618,7.4098-3.9272,12.605-3.9272,5.3188,0,8.5799,1.608,11.301,6.1669,1.5373,2.5796,2.814,7.6282,2.1378,10.525-1.2815,5.4935-2.0711,7.8814-4.2621,12.953-1.0426,2.4383-2.0278,3.8979-2.0278,6.5661,0,6.3963,8.704,8.5937,14.622,8.6852,1.2899,0.02,12.139,0.1981,18.815-6.5609-3.6222-0.1594-7.6754-2.9642-7.6754-6.5867,0-4.0992,2.8804-6.8735,6.7854-8.0573,0.74205-0.2119,2.0058,0.4432,2.6775,0.09,0.95395-0.4947,0.50765-1.5685,1.3558-2.24,1.9436-1.5547,3.2071-2.5253,5.6986-2.5253,1.6254,0,2.5779,0.2291,3.8853,1.1656,0.68913,0.4947,0.94268,1.107,1.7908,1.107,1.7846,0,2.6682-1.1309,4.4529-1.1309,1.4489,0,2.3325,0.1945,3.6044,0.8481,1.0603,0.5479,1.0367,2.3489,2.2382,2.3489,0.6008,0,3.7786-1.2953,5.4395-1.2953,3.4458,0,5.2852,1.2474,7.5117,3.8625,0.60107,0.7068,0.9852,2.1369,1.5961,2.1369,1.2303,0,4.0651,0.7924,5.832,2.5594,0.75978,0.7597,1.0966,1.1194,1.6797,2.0381,0.40663,0.654,1.0299,2.2493,1.7484,2.5256,0.84194,0.3239,1.548,0.2617,2.655,0.9714,2.5256,1.6189,4.4684,4.6622,4.3774,7.611-0.0304,0.9888-0.48176,2.3677-0.75105,3.3096-2.9409,10.284-9.9399,13.548-17.008,22.382-3.004,3.7637-5.3747,6.7673-5.3747,11.591,0,1.1664,1.436,3.3019,2.0722,4.2739-0.38862-2.2664,0.64749-5.0508,3.0433-5.1803,3.282-0.1776,5.8168,2.3176,6.2586,5.5689,0.0882,0.7598-0.19451,2.0723-0.51807,2.8492,1.7669-1.1661,4.0961-1.9543,6.2164-2.2017,1.1487-0.1238,1.813-0.1585,2.9789-0.1294,5.2453,0.1294,11.034,3.0802,14.547,6.0639,10.749,9.1305,12.049,22.492,11.462,26.203-1.3043,8.2462-0.4837,23.168-21.56,29.117,3.8977,1.6412,6.5493,4.5731,6.5493,8.1778,0,3.9227-3.0037,7.2798-6.9264,7.2798-2.2442,0-3.7992-0.5479-5.3717-2.1203-4.3822,4.3819-5.2304,8.8525-5.2304,15.054,0,3.7108,0.70688,5.9018,2.2619,9.2589,1.6431,3.5518,2.8269,5.6367,5.7957,8.1988,1.5725-2.3677,3.2336-4.0994,6.0782-4.0994,2.7566,0,5.0891,0.8836,6.2198,3.3926,0.33573,0.7598,0.0353,1.3783,0.42408,2.1203,0.49471,0.9542,1.3254,1.1664,1.8378,2.1206,0.79496,1.4664,0.018,2.7209,0.7066,4.2405,0.4418,0.9896,1.4138,1.1309,1.8378,2.1203,0.67142,1.5198,0.84815,2.5621,0.84815,4.2407,0,4.7002-4.2762,8.0576-8.9764,8.0576-1.4135,0-2.191-0.5656-3.6047-0.4241,2.686,2.6857,4.7357,3.8518,6.7854,7.0677,2.9685,4.6473,3.7105,7.9515,4.382,13.429,0.12381,1.0249,0.1416,1.6434,0.1416,2.686,0,7.0324-1.0955,11.238-4.2407,17.528-3.004,6.0253-5.5661,9.365-11.026,13.287-8.5168,6.1314-14.719,7.8986-25.02,9.8951-6.6087,1.2722-10.39,1.8378-17.105,2.2616-8.5875,0.5479-13.482,0.5657-22.052,1.131-11.238,0.7598-19.03,2.3499-26.999,10.319,3.7637,2.7563,6.361,5.4597,6.361,10.107,0,4.7706-2.9508,8.1809-7.492,9.683-1.06,0.3531-1.8375,0.035-2.8272,0.5653-1.1838,0.6185-1.1309,1.9788-2.2616,2.6857-1.9968,1.2722-3.5516,1.555-5.937,1.555-4.2055,0-7.0682-0.9894-10.037-3.9582-3.4455,2.8627-4.6118,5.4426-8.4814,7.6336-1.2725,0.7066-1.9262,1.6962-3.3926,1.6962-2.3148,0-3.3751-1.4666-5.2304-2.8272-2.9508-2.1558-4.5235-3.587-6.9267-6.361-3.5161,2.1026-5.6719,3.8166-9.7536,3.8166-2.5093,0-4.0994-0.3534-6.2198-1.6963-1.1132-0.6891-1.2899-1.714-2.4032-2.4031-1.1661-0.7243-2.1381-0.4593-3.3926-0.9894-4.718-2.032-7.7748-5.5307-7.7748-10.672,0-4.5058,2.845-7.3684,6.9266-9.2592-7.828-7.8274-15.532-9.188-26.576-9.8948-8.5343-0.5476-13.394-0.5653-21.911-1.131-6.7674-0.4592-10.531-1.1484-17.246-2.2616-5.0714-0.8304-8.075-1.0955-12.722-3.2513-15.991-7.4565-26.187-17.687-28.272-35.198-0.17671-1.5019-0.14114-2.3677-0.14114-3.8873,0-9.1176,3.5867-14.683,10.036-21.133-1.6611-0.3889-2.774,0.1589-4.3822-0.4241-4.0288-1.4666-6.9264-4.2584-6.9264-8.5523,0-1.5902,0.0707-2.6505,0.84814-4.0285,0.5476-0.9719,1.5902-1.1664,1.8375-2.2619,0.31798-1.4487-0.10603-2.4735,0.56562-3.8166,0.4415-0.9011,1.2722-1.0778,1.6963-1.9791,1.3957-2.8976,3.1452-5.2301,6.361-5.2301,2.7563,0,4.5235,1.4489,5.937,3.8166,2.686-1.2367,3.428-3.2513,4.9476-5.7954,2.5267-4.2232,3.6754-7.174,3.6754-12.086,0-3.428-0.33572-5.4423-1.4135-8.6936-0.7775-2.3322-1.0958-3.9224-2.8272-5.6541-1.5728,1.5724-3.1278,2.1203-5.3717,2.1203-4.4883,0-7.916-3.8521-7.916-8.3401,0-3.3397,1.6431-5.8132,4.6648-7.2092-2.4209-2.0849-4.5235-2.2619-7.2092-3.9579-4.082-2.5799-5.5129-5.301-8.1989-9.3298-1.7495-2.6328-2.2087-4.4703-3.11-7.4917-1.0778-3.6399-1.6963-5.8134-1.6963-9.6123,0-0.9894,0.018-1.5725,0.14115-2.5444,1.0074-7.6687,2.3857-12.475,7.2095-18.518,2.8624-3.587,4.8063-5.7957,9.047-7.6333,3.6044-1.555,5.7602-2.686,9.683-2.686,1.1838,0,1.873,0,3.0394,0.1416,1.8021,0.2297,2.9508,0.3887,4.5232,1.2723,0.6008,0.3357,1.6963,1.3428,1.6963,0.6359,0-0.8126-0.42405-1.2367-0.42405-2.0497,0-3.251,2.3325-6.2195,5.5838-6.2195,2.35,0,3.3042,2.0672,4.4529,4.0995,0.74206-1.2371,1.1307-2.0852,1.1307-3.5342,0-5.3716-2.8801-8.1102-6.2195-12.298-7.2801-9.0999-16.398-13.358-16.398-25.02,0-3.4809,1.6786-5.8488,4.6648-7.6332,0.86585-0.5127,2.0297,0,2.8779-0.5425,0.72432-0.4596,0.64133-1.395,1.1008-2.137,0.72433-1.1484,1.3656-1.6419,2.3731-2.5256,1.6608-1.4486,3.1193-1.0147,4.9568-2.2869,0.91878-0.6362,1.1357-1.4624,1.8426-2.3106,2.0497-2.4737,3.8895-3.668,7.1231-3.668,1.6256,0,2.5377,0.01,4.0395,0.607,0.51244,0.1945,1.4698,0.9669,1.5942,0.8174,0.32387-0.3883,1.2013-1.3183,2.2436-1.813,1.3606-0.6537,1.9124-0.9067,3.4322-0.9067,1.7314,0,2.866,0.9714,4.5975,0.9714,0.63624,0,0.78286-0.6354,1.2953-0.9714,1.5373-1.0423,2.422-1.6315,4.295-1.6315,1.8024,0,2.7979,0.5951,4.3175,1.5668,1.4312,0.9013,1.6372,2.1082,3.1038,2.9564,0.81268,0.4772,1.5018,0.2651,2.4032,0.5656,4.0285,1.3428,7.0679,4.0285,7.0679,8.2692,0,2.2971-0.5479,3.9404-2.2619,5.4423-1.3606,1.2015-2.6505,0.9896-4.382,1.555,5.619,4.488,10.508,5.6012,17.682,5.6012,6.5732,0,14.612-2.6868,14.612-9.2597,0-3.0571-1.6898-4.6994-2.8914-7.5089-2.1558-5.0004-3.3253-7.9422-3.3253-13.384,0-4.3116,0.46964-6.9272,2.9789-10.426,2.5796-3.6045,5.7316-4.445,10.167-4.445z'/%3E %3Cg fill='none' stroke='%23703d29'%3E %3Cpath stroke-width='1.041' stroke-linejoin='round' d='m425.59,223.46c0.43223,1.6315,1.7517,3.1604,3.8197,3.8068,1.2441,0.3886,4.1208,0.233,5.9868-2.177,1.5125-1.9537,1.3969-4.3735,0.83211-6.2968-0.36581-1.2447-1.3707-2.4457-2.6981-3.4683l-7.9374,8.0568-0.002,0.079z'/%3E %3Cpath stroke-width='1.037' stroke-linecap='round' d='m626.61,343.94c-1.866-4.5092-6.6863-2.4879-6.9827,0-0.68323,5.7321,4.3395,7.4638,7.9158,6.5307,1.7714-0.4621,3.0673-1.5778,3.8957-3.0313,0.93454-1.64,1.2171-3.7797,0.61008-5.8235-0.27492-0.9269-0.66242-1.7073-1.3254-2.581-0.66579-0.878-1.3544-1.4791-1.9993-1.8905-1.3755-0.8779-2.8739-0.9646-5.2239-0.9646-8.7079,0-16.327,10.289-18.886,20.977-0.84278,3.52-2.0013,11.371-0.39592,18.815,1.7104,7.9301,5.1381,13.42,9.1598,17.585,2.1769,2.2546,5.1457,4.2618,8.9896,6.4351,1.1856,0.6705,4.3198,2.0609,6.4967,2.6831,2.2357,0.6388,4.3,0.5454,6.1582,0.1418,5.1598-1.1205,7.559-5.9189,4.9597-10.829-2.1279-4.0201-8.3967-6.2198-11.351-1.0885-0.25071,0.4353-0.64103,1.3836-0.62835,2.4107,0.0158,1.3682,0.58418,3.0172,1.5612,3.6391,2.2458,1.4292,5.8382,1.0251,5.6713-2.9401'/%3E %3Cpath stroke-width='1.276' d='m599.69,403.07c1.7478-2.0561,5.7569-5.1403,10.343-5.7034,4.6541-0.5718,8.6986,0.7837,12.828,3.0048,8.0596,4.3347,12.554,8.9947,15.549,17.641,0.76063,2.1952,1.3915,5.5055,1.3037,9.0211-0.14025,5.604-1.5629,11.73-3.0917,14.692-1.3336,2.5835-4.8204,13.994-23.946,21.868-11.161,4.5949-28.3,5.6538-40.118,6.1204-16.256,0.6416-31.254,1.2438-39.962,11.973'/%3E %3Cg stroke-width='1.121'%3E %3Cpath d='m603.75,421.45c-0.46629-1.7104-0.0349-3.3501,1.3217-5.209,1.8139-2.4856,5.6756-3.3431,9.1745-1.3994,1.1703,0.6503,2.6378,1.5066,3.9649,3.2653,0.50202,0.6653,1.3504,1.7391,1.7883,2.4879,1.0586,1.8108,1.494,3.2927,1.703,3.8875,3.8453,10.928-2.2655,22.771-10.255,27.522-6.2062,3.6906-13.608,5.3357-22.469,6.3751-3.9826,0.4674-6.2569,0.4368-10.263,0.6222-3.2237,0.1493-6.0082,0.096-8.63,0.064-2.1575-0.027-4.2049-0.016-6.2969-0.064-3.4156-0.079-6.9497-0.1589-11.274,0.1556-4.5497,0.3309-7.9729,0.4477-11.818,1.0884-2.5118,0.4187-5.4558,0.8226-8.5422,1.5151-0.92609,0.2075-1.8651,0.3773-2.8092,0.6618-0.63398,0.1912-1.2604,0.3853-1.8811,0.5746-5.5717,1.6994-10.985,3.7697-15.257,6.5209-1.3198,0.8501-2.8106,1.7011-3.8771,2.7079-0.66466,0.627-1.472,1.2565-2.1237,1.8978-2.9899,2.9415-6.0473,6.1261-6.7623,10.438-0.13192,0.7955-0.13169,1.6293-0.13169,2.507,0,2.7988,2.2774,6.6084,8.4195,7.8524'/%3E %3Cpath d='m516.37,229.11c1.2852,2.3241,1.992,3.7378,1.2441,6.1421-0.84731,2.7231-2.7783,4.3538-5.5202,4.3538-6.2198,0-9.8782-7.3642-7.075-12.051,4.976-8.3187,14.539-3.6466,23.402,0.4739-0.42746-2.1338-1.1734-2.8278-1.0958-5.4712,0.19315-6.5642,5.061-9.5412,7.0046-15.605,1.1577-3.6124,1.6183-6.7497-1.0251-9.3155-2.3078-2.2396-4.9819-2.2056-7.9937-1.0248-6.0174,2.3587-13.246,9.1373-25.97,9.3256-12.724-0.1883-20.012-6.9669-26.03-9.3256-3.0115-1.1808-5.686-1.2148-7.9934,1.0248-2.6435,2.5658-2.1831,5.7031-1.0252,9.3155,1.9436,6.0641,6.8116,9.0411,7.0043,15.605,0.0779,2.6434-0.66833,3.3374-1.0955,5.4712,8.8633-4.1205,18.798-9.2119,23.402-0.4739,2.5652,4.8688-0.85519,12.051-7.0752,12.051-2.7417,0-4.6673-1.7481-5.5199-4.3538-0.76005-2.3227,0-4.3538,1.2441-6.1421'/%3E %3Cpath stroke-linecap='round' d='m491.5,224.79c2.4029,1.8378,4.0994,4.0994,3.8166,7.7748-0.30645,3.9863-1.2722,4.9476-4.382,7.0679'/%3E %3Cpath stroke-linecap='round' d='m494.68,233.7c-0.14115,2.4029-1.1307,3.9579-3.5338,4.9473'/%3E %3C/g%3E %3Cpath fill='%23c7b37f' stroke='none' d='m432.4,214.49,1.0884,0.7775,1.1661,1.2441,0.7775,1.555,0.38862,1.3217,0.0779,1.7104-0.0779,1.1661-0.38862,1.3217-0.7775,0.9328-0.93312,1.0109-1.3214,0.6998-1.7106,0.3886-1.477,0.2333-1.555-0.6999-1.3994-1.0105-0.85517-1.244-0.62218-1.555,0-0.6219,7.6195-7.2306z'/%3E %3Cpath stroke-width='1.041' stroke-linecap='round' d='m430.01,220.57c-0.47838-2.5813-3.4958-3.1109-4.6648-1.586-1.8001,2.3478-0.48513,6.2572,3.1759,7.4014,1.2438,0.3889,4.1205,0.2333,5.9865-2.1769,1.5125-1.9537,1.3969-4.3735,0.83208-6.2969-0.36552-1.2446-1.3642-2.3294-2.6981-3.3435-4.2511-3.2333-11.118-2.4879-13.373,2.9541-2.9086,7.0203,3.421,12.284,9.2522,16.249,7.3409,4.9918,15.705,5.8996,22.003,5.8312,14.306-0.1556,25.19-6.9973,32.265-10.884,1.6482-0.9056,3.3453-0.7207,4.1982,0.3109,0.96295,1.1644,0.94748,3.0428-0.38861,4.2759'/%3E %3Cpath stroke-width='1.057' d='m387.6,414.35-3.1877,1.1663-3.2654,2.4879-1.3994,1.9436-1.7883,3.1098-0.7775,2.3325-0.6219,2.8768-0.31096,2.1766'/%3E %3Cpath stroke-width='1.057' d='m405.95,414.66-0.23327,2.7991-0.46629,1.9436-1.3997,3.343-2.1769,2.8768-2.3325,1.8659-1.7104,0.8552-2.4102,0.5443'/%3E %3Cpath stroke-width='1.197' d='m499.6,489.23c-0.57969,2.5878-3.0039,5.5484-8.279,6.6169,0,0-0.62556,0.1292-1.0254,0.2118'/%3E %3Cpath stroke-width='1.356' d='m631.59,406.57c3.3394,3.114,5.6851,6.905,7.488,12.109,0.76064,2.1952,1.3912,5.5056,1.3034,9.0211-0.1398,5.6041-1.5626,11.73-3.0917,14.692-1.3333,2.5838-4.8201,13.994-23.946,21.868-11.161,4.5953-28.3,5.6539-40.118,6.1205-16.022,0.6326-30.822,1.2266-39.582,11.516'/%3E %3Cpath stroke-width='0.929' d='m605.45,416.95c1.1881-1.6211,5.5174-3.6734,9.0163-1.7295,1.1515,0.6397,2.5163,1.4487,3.7136,3.2426'/%3E %3Cpath stroke-width='1.356' d='m627.51,402.79c0.78229,0.3008,1.5604,0.5718,2.2436,0.7671,2.236,0.6387,4.3372,0.6883,6.1584,0.1418,4.4225-1.3265,7.2612-5.4589,4.9597-10.829-0.53383-1.2452-1.5556-2.4392-2.7164-3.3335'/%3E %3Cpath stroke-width='1.041' stroke-linecap='round' d='m375.44,287.13c-2.9685,1.8378-5.1823,2.2728-7.492,4.9475-2.2994,4.5531-3.2034,6.9991-4.1002,10.65'/%3E %3Cpath stroke-width='1.041' stroke-linecap='round' d='m435.88,221.96c0,2.6856-1.9791,4.3819-4.6648,4.9475'/%3E %3Cpath stroke-width='0.997' d='m620.49,275.03c7.3898-0.1509,28.859,5.6392,29.012,30.876,0.15083,24.925-15.383,28.997-21.607,30.656'/%3E %3Cpath stroke-width='1.037' d='m622.43,275.03c12.743-0.5541,25.892,8.8261,26.472,32.236,0.45249,18.289-12.517,26.584-18.742,28.243'/%3E %3Cg stroke-width='0.881'%3E %3Cpath d='m615.33,363.16,0.19608-2.5022,0.83407-3.9739,1.1774-3.0909,1.3245-2.5512,1.7171-2.0606'/%3E %3Cpath d='m632.74,343.67-0.19451,2.449-0.69985,1.6718-1.0884,1.5939-1.2438,0.9328-1.9048,0.6996-1.6715,0.1168-1.2441-0.1945'/%3E %3Cpath d='m602.33,268.42,0.54422-2.6435,1.1661-2.449,1.5162-2.4491,2.6046-3.343,2.0601-2.2937,3.343-3.3818,2.8767-2.9156,1.8271-2.0993,2.4102-2.9153,2.1381-3.2265,1.2829-2.6435,0.69955-3.4207,0.21252-4.2418-0.3886-1.2302'/%3E %3Cpath d='m605.44,429.44,2.527-0.5054,1.9048-1.0108,1.0496-1.0496,0.73867-1.205,0.5054-1.9436,0.0388-1.3606'/%3E %3Cpath d='m364.94,403.38,1.8662,0.1555,2.4099-0.1945,2.4102-0.8552'/%3E %3Cpath d='m379.44,345.38-0.31093,2.1769-0.50539,0.9717-0.73869,0.9331-1.0108,0.7773-1.1273,0.5054-1.4773,0.2332-1.0108,0.078'/%3E %3Cpath d='m388.73,326.65-0.54424,3.3819-0.66072,1.4774-1.3606,1.8659-1.8271,1.3994-1.866,0.9328-3.6154,0.8941'/%3E %3Cpath d='m402.76,274.48-0.69956,2.0213-0.85516,1.4774-1.1664,1.6326-1.6327,1.4771-1.9436,0.9331-1.6327,0.3886-1.0108-0.078'/%3E %3Cpath d='m394.41,272.65,0.0391,1.555'/%3E %3C/g%3E %3Cg stroke-width='0.987'%3E %3Cpath stroke-linecap='round' d='m397.32,325.09c-1.1273,1.0105-2.2503,1.6304-3.2654,2.0289'/%3E %3Cpath stroke-linecap='round' d='m629.24,397.16c0.1335,0.1447,0.58137,0.2172,0.73866,0.3109,2.2157,1.3217,6.5774-0.3264,5.2945-3.7474'/%3E %3Cpath d='m621.54,349.38c1.5725,2.0547,4.5384,2.588,6.8827,1.9765,1.7717-0.4621,3.0676-1.5781,3.8957-3.0312,0.93454-1.64,1.2173-3.7798,0.61038-5.8239-0.27522-0.9266-0.66242-1.7069-1.3254-2.581-0.66608-0.8777-1.492-1.8111-2.1322-2.2298-0.16974-0.111-0.33908-0.2614-0.51834-0.383'/%3E %3Cpath d='m638.99,390.46c0.0678-0.365,0.10333-0.7409,0.10333-1.125,0-1.8105-0.75725-3.468-2.0092-4.5857-0.42746-0.3816-0.84138-0.9736-1.3594-1.2328'/%3E %3Cpath d='m636.47,384.25c-0.0727-2.9123-2.456-4.9954-5.4099-5.5135'/%3E %3Cpath d='m624.54,383.17c-0.67874-0.5544-1.4064-1.0246-2.0418-1.6895-3.8259-4.0044-6.7038-9.9242-6.7423-16.677-0.0369-6.4737,2.5658-13.062,5.5979-15.627'/%3E %3Cpath d='m533.07,481.44,2.7988-2.5658,1.9439-1.4771,3.654-2.2546,3.421-1.6326,2.4102-0.6222,4.8204-1.0882,5.5979-0.8554'/%3E %3Cpath d='m511.61,501.2c-2.0216,3.11-6.842,7.7747-11.896,9.6407-5.0536-1.866-9.8738-6.5307-11.895-9.6407'/%3E %3Cpath stroke-linecap='round' d='m491.28,494.73c-0.63372,2.3489-1.7852,4.626-3.4677,6.4511'/%3E %3Cpath d='m491.78,491.47-0.69983,3.4206'/%3E %3Cpath d='m487.43,501.42-1.4771,1.4773-2.6435,1.4771-3.0321,0.9331'/%3E %3Cpath d='m471.46,227.45c0.37933-1.1821,0.7671-2.0719,0.70996-4.0144-0.19315-6.5642-5.0607-9.5412-7.0046-15.606-1.1577-3.612-1.618-6.7494,1.0254-9.3152,2.3075-2.2396,4.9816-2.2058,7.9934-1.0251,6.0174,2.359,13.308,9.1376,26.032,9.3259-12.724-0.1882-20.015-6.9669-26.032-9.3259-3.0118-1.1807-5.9347-1.5255-8.2425,0.7142-2.6432,2.5658-1.9341,6.0141-0.77639,9.6261,1.9439,6.0644,6.5628,9.0414,6.7558,15.606,0.0572,1.9425-0.45501,2.8323-0.83406,4.0144'/%3E %3Cpath d='m500.18,206.37c12.517-0.661,23.245-9.0712,26.706-9.7573,3.0856-0.612,4.8086-0.3354,7.0721,1.7213-2.2636-2.0567-4.8418-1.9931-7.7706-0.845-6.0175,2.359-13.246,9.1376-25.97,9.3259'/%3E %3Cpath d='m624.59,383.2c-5.209-3.7319-9.672-10.856-9.7184-19.274-0.036-6.4739,2.5655-13.061,5.5976-15.627'/%3E %3Cpath d='m511.17,500.76c-2.0213,3.1097-6.8416,7.7748-11.895,9.6404-5.0536-1.8656-9.874-6.5307-11.895-9.6404'/%3E %3Cpath stroke-linecap='round' d='m479.17,230.74c1.3018-0.7209,2.5101-1.4064,3.6244-2.0184,1.6482-0.9056,3.6292-0.7157,4.4821,0.316,0.96266,1.1644,1.1104,3.1826-0.22542,4.416'/%3E %3Cpath d='m460.48,239.49c8.5875-1.7922,15.585-5.6381,20.875-8.5967'/%3E %3Cpath d='m531.78,487.43c0.70997,0.4843,1.1661,1.4926,1.1661,1.4926,0.19675,0.4685,0.45052,0.9114,0.52088,1.3268,0.40352,2.3784-1.156,3.8605-3.0828,4.0848-2.6477,0.3078-4.6352-1.2652-5.4825-3.17'/%3E %3Cpath d='m460.04,239.05c8.5875-1.7925,15.585-5.6384,20.875-8.5968'/%3E %3Cpath d='m633.38,397.49c-1.6327,0.6292-2.5258,0.544-4.557-0.3579-0.8338-0.3703-1.7883-0.9435-2.9066-1.5784-3.9807-2.2607-8.7079-5.8238-13.139-14.143-1.3105-2.4602-2.1246-4.7432-2.6728-6.9922-0.42266-1.7354-0.71587-3.4505-0.7792-5.2112-0.10783-3,0.21499-6.1323,0.96381-9.721,1.2365-5.9254,2.7251-9.1432,6.3754-14.15,1.7953-2.4622,3.3433-3.9649,6.6863-4.0425'/%3E %3Cpath d='m398.83,279.88c2.7794,2.3623,4.1208,5.2866,4.1208,8.9409,0,4.8409-4.0502,12.75-14.002,15.549-3.8138,1.0724-7.5882,0.2073-9.8706-1.1807'/%3E %3Cpath d='m400.46,296.28c1.7883,1.2438,2.4881,2.6406,2.4881,5.0697,0,1.6647-1.0763,3.8228-2.9074,5.8666-2.9977,3.3461-8.0821,6.1897-13.716,6.2603-3.0563,0.038-6.2294-0.6008-9.4218-2.7358-3.4131-2.2821-5.2093-5.3643-5.9868-8.3967'/%3E %3Cpath d='m400.3,306.71c2.0258,1.8623,2.648,4.1932,2.648,7.129,0,4.2891-1.7424,7.5998-5.7493,11.107-0.89598,0.784-1.9048,1.5187-3.0329,2.1783'/%3E %3Cpath d='m596.4,292.63,0,5.5188'/%3E %3Cpath d='m595.96,291.27,0,7.774'/%3E %3Cpath d='m596.4,274.44,0,10.185'/%3E %3Cpath d='m595.96,272.19,0,13.918'/%3E %3Cpath d='m592.99,414.17c-1.9304,3.8352-3.4727,5.8492-6.5307,8.8632-3.0855,3.0408-5.2239,4.4343-9.0965,6.3751-3.7719,1.8905-6.1477,2.4916-10.263,3.421-4.1124,0.9286-6.5175,1.131-10.729,1.3215-3.8619,0.1751-6.0529,0.014-9.9095-0.2544-4.1276-0.2856-6.4168-0.8608-10.538-1.2227-3.4038-0.2988-5.3263-0.5741-8.7434-0.5656-3.5122,0.01-5.5247,0.031-8.9831,0.6433-3.2234,0.5709-5.052,1.0257-8.0857,2.2548-4.1976,1.7005-8.9412,4.6648-9.9517,5.9865-1.0108-1.3217-5.7541-4.286-9.952-5.9865-3.0338-1.2291-4.8623-1.6839-8.0855-2.2548-3.459-0.6124-5.471-0.6346-8.9834-0.6433-3.417-0.01-5.3395,0.2668-8.7434,0.5656-4.1211,0.3619-6.4106,0.9371-10.538,1.2227-3.8566,0.2668-6.0473,0.4294-9.9092,0.2544-4.212-0.1905-6.6174-0.3903-10.729-1.3215-4.1149-0.9317-6.4888-1.5347-10.263-3.421-3.8752-1.9368-6.011-3.3343-9.0965-6.3751-0.33318-0.3286-0.64864-0.6452-0.94832-0.9536'/%3E %3Cpath d='m478.8,505.47,2.7988-0.3497'/%3E %3Cpath d='m528.9,501.44,2.825-0.269,2.6907-1.0763,1.8834-1.1437,2.5562-3.027,0.53774-1.1436,0.40382-2.6235,0.13462-1.2108'/%3E %3Cpath d='m613.23,277.36c1.2131-4.1276-0.2676-8.4831-4.2663-8.3657'/%3E %3Cpath d='m402.79,341.75c-1.0136,3.4281-3.1939,5.7702-5.6198,7.2934'/%3E %3Cpath d='m402.86,276.05c-0.99953,2.8889-2.8289,4.953-5.7237,6.2604-2.8866,1.3037-6.2274,0.086-8.014-1.2922'/%3E %3Cpath stroke-linecap='round' d='m380.95,291.2c2.3922,1.2526,4.8195-0.5836,4.3217-3.6959-0.23329-1.4576-1.8052-3.2988-3.9328-3.4333'/%3E %3Cpath d='m390.87,422.86c0.51553,0.4852,0.62583,1.1149,1.3218,1.2438,1.0496,0.1945,1.866,0.5831,2.9156-0.8163,1.2939-1.725,0.59855-4.4082-0.7474-6.0974-1.4405-1.808-5.6134-3.4055-9.112-1.4616-1.1706,0.6503-2.6381,1.5063-3.9652,3.2654-0.50172,0.6649-1.3504,1.739-1.788,2.4878-1.0589,1.8108-1.494,3.2924-1.7033,3.8873-3.2012,9.0979,0.59995,18.664,6.4885,24.493'/%3E %3Cpath stroke-linecap='round' d='m531.59,487.23c0.63794,0.6647,1.0105,1.2441,1.0105,1.2441,0.19675,0.4682,0.35708,0.9112,0.42773,1.3268,0.40323,2.3784-1.156,3.8605-3.083,4.0845-2.6477,0.3082-4.4197-1.2519-5.2672-3.1567'/%3E %3Cpath d='m608.5,216.81c5.2278,0.6376,9.7837,5.6277,9.7837,10.992,0,6.9194-2.3311,9.4961-5.9741,14.446-3.8985,5.2973-16.638,15.005-16.638,26.045,0,6.6864,1.866,10.962,6.6863,13.139,3.1081,1.4036,6.7423-0.1157,8.3967-1.6107,4.0429-3.6543,2.4265-10.062-1.788-10.828-5.1316-0.9332-6.096,7.145-1.0885,6.6083'/%3E %3Cpath d='m635.73,383.51c-0.45954-2.7701-2.8132-4.8795-5.648-4.8795-3.1638,0-5.7287,2.628-5.7287,5.87,0,1.5877,0.61514,3.0281,1.6147,4.0848'/%3E %3Cpath d='m599.79,279.88c-2.7794,2.3623-4.1208,5.2866-4.1208,8.9409,0,4.8409,4.0502,12.75,14.002,15.549,3.8135,1.0724,7.4574,0.9714,9.7398-0.4168'/%3E %3Cpath d='m375.61,287.8c-2.3784,0.7938-5.3486,2.2774-7.5497,5.3953-1.8561,2.6297-2.9384,6.2856-3.6087,9.4846-0.29321,1.3999-0.64301,5.832,0.2524,10.41,0.6613,3.3805,2.0573,6.5271,3.6016,8.8064,0.5535,0.8169,1.0558,1.3671,1.6206,1.9318,0.51778,0.5178,1.2528,0.9751,1.7737,1.3727'/%3E %3Cpath d='m471.72,469.02c7.5764,3.3588,13.13,5.8745,17.839,13.31,1.4771,2.3325,1.866,5.6756,1.866,7.6192,0,4.1982-1.7106,8.9409-5.2093,11.895-3.2462,2.7414-6.4531,3.5763-10.418,3.1877-3.007-0.2949-5.8309-2.4878-6.2974-4.0428'/%3E %3Cpath d='m396.88,325.2c4.2762,3.3431,6.0644,6.5862,6.0644,11.74,0,5.9085-2.8767,9.5627-6.2201,11.662'/%3E %3Cpath stroke-linecap='round' d='m392.99,344.41c6.3751,7.9301,9.7578,12.637,9.9517,22.08,0.18146,8.8627-2.6435,14.927-7.9304,21.303'/%3E %3Cpath d='m515.23,239.57c1.1591-0.7609,2.0098-1.9791,2.4974-3.4848,0.75302-2.3252,0.76908-4.3077-0.47471-6.0957,1.5345,2.0081,1.6757,3.7043,1.2438,6.1418-0.27465,1.5522-1.2644,2.3685-2.4974,3.4849'/%3E %3Cpath d='m596.4,374.24,0,25.241,0.0668,0c0,0.018-0.009,2.3888-0.21183,3.8872-0.13305,0.9824-0.27155,1.8705-0.42857,2.7023'/%3E %3Cpath d='m595.96,371.81,0,27.223,0.0673,0.0003c0,0.018-0.009,2.3885-0.21183,3.8872-0.21184,1.5624-0.43701,2.8869-0.72939,4.1245'/%3E %3Cpath d='m595.96,339.94,0,22.702'/%3E %3Cpath d='m596.4,341.73,0,18.463'/%3E %3Cpath d='m596.4,318.25,0,13.841'/%3E %3Cpath d='m595.96,316.62,0,17.064'/%3E %3Cpath d='m596.4,304.1,0,5.3693'/%3E %3Cpath d='m595.96,303.01,0,7.7762'/%3E %3Cpath d='m593.08,412.65c-0.16546,0.3503-0.34189,0.7108-0.5296,1.0842-1.9304,3.8352-3.473,5.8492-6.531,8.863-3.0853,3.0411-5.2236,4.4343-9.0965,6.3754-3.7716,1.8901-6.1475,2.4915-10.263,3.421-4.1121,0.9286-6.5175,1.1309-10.729,1.3214-3.8617,0.1747-6.0529,0.011-9.9092-0.2547-4.1276-0.2853-6.4168-0.8605-10.538-1.2224-3.4038-0.2991-5.3263-0.5743-8.7431-0.5656-3.5124,0.01-5.5244,0.031-8.9831,0.6433-3.2234,0.5707-5.052,1.0254-8.086,2.2546-4.1976,1.7007-8.9409,4.6647-9.9517,5.9865-1.0108-1.3218-5.7538-4.2858-9.9517-5.9865-3.0338-1.2292-4.8623-1.6839-8.0857-2.2546-3.4587-0.6123-5.471-0.6345-8.9834-0.6433-3.4168-0.01-5.3393,0.2665-8.7431,0.5656-4.1214,0.3619-6.4108,0.9371-10.538,1.2224-3.8566,0.2668-6.0473,0.4294-9.9095,0.2547-4.212-0.1904-6.6171-0.39-10.729-1.3214-4.1146-0.9323-6.4891-1.534-10.263-3.421-3.8749-1.9378-6.0113-3.3343-9.0965-6.3754-1.6155-1.5922-2.8081-2.9055-3.8583-4.3555'/%3E %3Cpath d='m406.42,413.26c0.66553,4.9422-1.4129,9.7995-3.5228,12.034-1.3217,1.3994-4.2005,4.0736-7.7748,4.1205-5.9088,0.078-7.6726-3.9863-8.0306-4.9757'/%3E %3Cpath d='m399.4,410.7c1.0966,1.0829,2.07,2.4049,2.8934,3.965,1.4771,2.7988,1.022,7.4801-0.14834,9.6407-0.12856,0.2375-0.28789,0.4894-0.47474,0.7482'/%3E %3Cpath d='m370.04,453.2c3.5136,3.6874,8.8275,7.692,16.99,11.052,11.161,4.5953,28.3,5.6539,40.118,6.1205,15.715,0.6204,30.193,1.266,39.01,10.998'/%3E %3Cpath d='m493.29,475.01c2.5982,2.556,5.247,5.2954,6.3658,8.798'/%3E %3Cpath d='m488.18,501.7c-0.33966,0.3625-0.70069,0.7066-1.0831,1.0297-3.2462,2.7411-6.4531,3.5763-10.418,3.1874-3.007-0.2947-5.9077-2.5478-6.6852-4.0252'/%3E %3Cpath d='m461.63,497.35c0.14498,0.1981,0.29742,0.3906,0.45726,0.5766,1.8876,2.1983,4.8674,3.576,7.9777,3.8332'/%3E %3Cpath d='m512.05,501.64c-2.0216,3.1098-6.842,7.7745-11.895,9.6405-5.0537-1.866-9.874-6.5307-11.896-9.6405-0.16344-0.2518-0.3208-0.4938-0.4719-0.7266'/%3E %3Cpath d='m512.13,501.62c0.36074,0.3917,0.74626,0.7624,1.1562,1.1088,3.2462,2.7411,6.4531,3.5763,10.418,3.1874,3.007-0.2947,5.395-2.3036,6.3596-4.0429,0,0,0.54113-0.5816,0.69252-1.1366'/%3E %3Cpath d='m529.75,500.99-1.1605,1.8666-1.7655,1.4633-2.6739,1.1098-2.4214,0.1011'/%3E %3Cpath d='m536.03,483.22c1.4306,1.0969,2.8354,2.7594,3.5985,4.5342,0.49076,1.1411,0.71813,2.3956,0.78792,3.6976,0.13215,2.4682-0.73502,4.7413-2.2228,6.4739-1.9974,2.326-5.113,3.7336-8.4288,3.8664-0.24679,0.01-0.49188,0.011-0.73445,0'/%3E %3Cpath d='m529.32,501.35,0,0c-3.1706,0.1271-6.0037-1.2312-8.0925-3.3754'/%3E %3Cpath d='m620.72,391.93c-2.4738-2.2799-5.0362-5.4397-7.5069-10.077-1.3105-2.4603-2.1246-4.7433-2.6725-6.9925-0.42292-1.7354-0.71587-3.4505-0.77917-5.211-0.10784-3.0002,0.21498-6.1322,0.96378-9.7212,1.2362-5.9251,3.4426-10.509,6.3754-14.15,0.99982-1.2418,2.1544-2.7915,3.2507-3.4879'/%3E %3Cpath d='m618.2,223.83c3.9652,0.3109,7.6386,4.5792,7.5902,8.7639-0.0703,6.0782-2.1082,8.5894-6.8906,14.545-4.1205,5.1313-16.482,14.15-16.171,22.78,0.0551,1.5316,0.88023,3.1154,1.8021,4.3895'/%3E %3Cpath d='m599.59,279.72c0.87826,0.8672,1.9405,1.5839,3.2068,2.1558,2.2613,1.0212,4.8012,0.4952,6.6543-0.4432'/%3E %3Cpath d='m576.37,213.9c1.3276,0.9044,2.6814,2.2909,3.4151,4.0614,2.9082,7.0204-3.421,12.284-9.2522,16.249-4.181,2.8429-8.6941,4.3614-12.968,5.1288'/%3E %3Cpath d='m569.69,227.43c-1.4138-0.014-3.0945-0.417-4.9203-2.3393-0.42041-0.4426-0.91259-1.0276-1.1053-1.553'/%3E %3Cpath d='m540.45,231.2c-0.73839-0.3703-1.5314-0.9092-2.0626-1.5038-1.3864-1.5505-2.3103-3.6498-1.2424-6.8532,0.98742-2.9626,5.7462-11.274,5.9794-17.027,0.35626-8.7895-3.0242-13.977-8.312-16'/%3E %3Cpath stroke-linecap='round' d='m542.68,203.85-0.20644,3.3051-0.89485,3.374-1.7213,4.6129-1.3082,2.9606-1.3769,2.9609-0.68858,2.0658-0.2755,1.5148,0.20688,1.4458'/%3E %3Cpath stroke-linecap='round' d='m595.81,423.4c0.27211,0.6607,0.93284,1.3059,0.93284,1.3059,1.0108,1.6873,4.9402,4.6547,8.5146,4.7016,5.9088,0.078,7.3119-4.0572,7.4638-4.9757,0.746-4.5088-0.79607-5.7425-3.11-7.0127,0,0-1.3617-0.7055-2.9944-0.4334'/%3E %3Cpath d='m370.23,403.67c-2.086,0.5341-4.0454,0.547-5.7574,0.033-4.4228-1.3265-8.0067-5.5636-6.1795-10.829'/%3E %3Cpath d='m379.21,343.15c0.44292,0.4446,0.58559,1.1076,0.65284,1.6701,0.68324,5.7318-4.3395,7.4016-7.9158,6.4685-1.7714-0.462-3.8824-2.1068-4.7106-3.56-0.59713-1.0473-0.95902-2.2987-0.9621-3.5988'/%3E %3Cpath d='m400.74,307.15c0.89571,0.8234,1.517,1.7382,1.9315,2.7566'/%3E %3Cpath d='m400.9,296.6c0.82957,0.5771,1.425,1.3116,1.8249,2.0424'/%3E %3Cpath stroke-linecap='round' d='m402.91,303.94c-0.48316,1.1906-1.3172,2.4752-2.4304,3.7178-2.9978,3.3459-8.0821,6.1894-13.716,6.26-3.0563,0.038-6.2294-0.6007-9.4218-2.7354-3.4131-2.2825-5.6381-5.5281-6.3768-8.7158'/%3E %3Cpath d='m399.11,280.13c1.7306,1.4711,3.0594,3.3467,3.6982,5.2945'/%3E %3Cpath stroke-linecap='round' d='m402.86,292.56c-1.3842,4.5739-5.5104,10.231-13.473,12.248-3.8037,0.9638-8.702-0.2412-10.374-1.6639'/%3E %3Cpath d='m375.06,291.49c0.41674,4.1205,3.1742,7.2089,8.4012,7.3077,7.3502,0.1386,11.818-10.574,5.2869-18.094'/%3E %3Cpath stroke-linecap='round' d='m358.52,327.39c1.0738,1.3471,2.3373,2.561,3.6298,3.6365,2.6212,2.1814,5.7118,4.1014,9.2721,5.1528'/%3E %3Cpath stroke-linecap='round' d='m379.67,336.95c6.569-0.789,10.272-5.6837,9.538-11.41-0.55941-4.3633-4.5629-7.7182-7.2849-7.9123'/%3E %3Cpath d='m390.39,268.92c2.8494-0.1053,4.4703,2.4831,4.4444,4.6645'/%3E %3Cpath stroke-linecap='round' d='m389.72,229.81c1.5609,4.0831,4.6034,7.2753,7.8606,9.099'/%3E %3Cpath stroke-linecap='round' d='m622.86,287.29c2.6862,3.6785,0.92722,10.932-6.379,11.07-2.854,0.054-5.4291-1.5283-6.9385-3.9244'/%3E %3Cpath d='m596.4,239.25,0,24.686'/%3E %3Cpath stroke-linecap='round' d='m380.87,291.14c2.2548,1.6324,5.1502-1.1239,4.0296-4.0493-0.75614-1.9752-3.5631-4.1071-7.4504-1.4636-4.2933,2.9192-3.11,12.129,5.1313,12.284,7.3499,0.1387,11.818-10.574,5.2869-18.093-6.2828-7.2342-17.727-5.5419-25.19,0.3959-3.1762,2.5264-9.1745,9.1452-11.04,18.164-0.5811,2.8081-0.9562,5.1122-0.91203,7.9301,0.0292,1.8567,0.20058,3.9365,0.7564,6.5307,1.1231,5.2403,2.9679,9.0797,4.8055,11.745,0.70406,1.0218,1.347,1.871,2.0365,2.5605,1.279,1.2789,1.662,1.9565,2.9541,3.032,4.2235,3.5147,9.665,6.2699,16.327,5.9865,7.3082-0.3112,11.507-5.4422,10.729-11.507-0.75359-5.879-6.6903-8.8052-10.574-6.0641-2.6435,1.8659-3.5839,7.6445,1.0884,9.0185,2.6435,0.7776,4.9757-2.5655,3.1098-4.5091'/%3E %3Cpath stroke-linecap='round' d='m584.4,210.68c4.2179-2.2909,7.4692-1.8668,9.874,1.47,2.6134,3.6262,2.9862,8.4525,2.4102,11.28-0.85519,4.1985-2.0686,5.942-5.4074,8.9876'/%3E %3Cpath stroke-linecap='round' d='m594.58,212.55c4.8204-3.1874,10.041-1.8336,12.906,2.4102,2.0992,3.1097,2.6358,5.7121,2.4878,9.5627-0.25353,6.6003-4.3839,11.832-8.9409,14.383'/%3E %3Cpath d='m617.28,223.67c3.9649,0.3109,7.1526,3.9007,7.1526,8.0857,0,5.9865-1.6707,8.5836-6.4531,14.539-4.1205,5.1313-16.482,14.15-16.171,22.78,0.11774,3.2634,2.8686,6.3383,5.2419,6.5094'/%3E %3Cpath stroke-linecap='round' d='m617.75,291.14c-2.2546,1.6324-5.1313-1.0035-3.8873-3.8026,0.85884-1.9326,3.421-4.3538,7.3082-1.7103,4.2933,2.9192,3.11,12.129-5.1313,12.284-7.3502,0.1387-12.317-10.297-5.2869-18.093,6.4165-7.1158,18.315-5.7234,25.778,0.2141,3.1761,2.5267,9.5659,9.466,10.936,18.573,1.658,11.02,1.4455,24.575-9.9365,32.922-4.5767,3.356-10.918,4.8817-16.516,4.6364-7.308-0.3205-11.506-5.4423-10.729-11.507,0.75386-5.8791,6.4153-8.3675,10.574-6.0642,4.3192,2.3924,3.565,8.4659-1.0884,9.0186-2.7361,0.325-4.976-2.5655-3.11-4.5092'/%3E %3Cpath d='m613.86,287.34c1.212-5.4543,5.8846-5.9623,9.6576-5.9068,10.296,0.1508,17.416,12.364,17.535,24.178,0.15083,14.923-6.334,23.711-17.241,24.178-2.8221,0.1211-7.6839-1.2213-7.7675-4.6648'/%3E %3Cpath stroke-linecap='square' d='m620.2,284.9c10.858,2.413,14.67,12.196,14.67,21.532,0,7.6158-0.75416,18.022-15.575,21.682'/%3E %3Cpath d='m638.11,389.58c0.0677-0.3647,0.10356-0.7406,0.10356-1.125,0-3.3706-2.7327-6.103-6.1033-6.103-3.3709,0-6.1033,2.7324-6.1033,6.103,0,1.9394,0.90469,3.6675,2.3151,4.7854'/%3E %3Cpath stroke-linecap='round' d='m616.33,380.33c2.0432,3.0321,4.5165,6.4035,9.7401,9.2375'/%3E %3Cpath stroke-linecap='round' d='m624.11,406.05c-5.1195-3.3587-14.838-7.7615-23.624-3.4277-3.2589,1.6077-5.4423,3.5963-6.6751,6.8397-2.2197,5.8393,0.26143,12.275,2.7878,14.949,1.3217,1.3994,4.2004,4.0735,7.7748,4.1208,5.9086,0.078,7.3133-4.0572,7.4636-4.976,0.69983-4.2759-1.788-5.9865-3.1098-6.453-1.0139-0.3577-4.3122-0.2662-5.012,2.0654-0.233,0.7773-0.27494,2.133,0.34725,3.1438'/%3E %3Cpath stroke-linecap='round' d='m531.99,488.16c1.6327,3.343-0.22422,5.0235-2.4878,5.2866-3.343,0.3887-5.1313-2.2545-5.3646-4.6647-0.37819-3.9081,2.9159-7.4492,6.842-7.3859,3.5352,0.057,6.4145,2.3376,7.7644,5.4766,0.49047,1.1411,0.71783,2.3952,0.78763,3.6976,0.13259,2.4678-0.73473,4.7413-2.2228,6.4736-1.9974,2.326-5.1128,3.7336-8.4285,3.8664-6.6002,0.2648-11.74-5.9085-11.74-12.206,0-12.051,17.872-18.623,24.957-20.314,8.7076-2.0775,14.006-2.8553,27.989-3.6323,5.5979-0.3109,9.6973-0.1531,15.861-0.7921,5.5152-0.5715,8.3967-0.8405,14.072-2.1623,7.0828-1.6493,13.684-4.5871,19.592-9.9517,4.5502-4.1309,7.1529-7.0749,9.2592-12.75,1.8178-4.8975,2.653-14.596-1.9509-21.769-4.0688-6.3399-9.7184-9.6331-16.171-10.566-5.8292-0.8428-10.942,1.6726-13.995,7.4565-1.4771,2.7988-1.022,7.4799,0.14836,9.6404,1.0108,1.866,3.8968,4.6178,7.4712,4.6651,5.9086,0.078,7.3133-4.0572,7.4636-4.976,0.69983-4.2759-1.788-5.9865-3.1098-6.453-1.0139-0.3577-4.3122-0.2662-5.012,2.0654-0.233,0.7773-0.27494,2.133,0.34725,3.1438'/%3E %3Cpath stroke-linecap='round' d='m526.9,469.02c-7.5764,3.3588-13.13,5.8745-17.839,13.31-1.4774,2.3325-1.866,5.6756-1.866,7.6192,0,4.1982,1.7103,8.9409,5.2093,11.895,3.2462,2.7414,6.4528,3.5763,10.418,3.1877,3.007-0.2949,5.8312-2.4878,6.2977-4.0428'/%3E %3Cpath d='m601.73,325.2c-3.5448,1.1825-6.0644,6.5862-6.0644,11.74,0,5.9085,2.8767,9.5627,6.2198,11.662'/%3E %3Cpath stroke-linecap='round' d='m605.62,344.41c-6.3754,7.9301-9.7578,12.637-9.9517,22.08-0.1819,8.8627,2.6435,14.927,7.9304,21.303'/%3E %3Cpath d='m571.64,212.58c0.16411-0.2443,0.34557-0.513,0.54731-0.8096,2.6435-3.8873,7.3116-4.9116,10.729-2.3323,4.1206,3.1098,5.1612,8.4023,4.0429,13.994-0.69985,3.4987-3.0732,6.4128-6.325,8.5211'/%3E %3Cpath stroke-linecap='round' d='m414.22,210.68c-4.0432-1.8657-7.371-1.5066-9.874,1.47-2.8768,3.421-2.9865,8.4525-2.4102,11.28,0.8552,4.1985,2.0683,5.942,5.4074,8.9876'/%3E %3Cpath d='m404.03,212.55c-4.8201-3.1874-10.041-1.8336-12.906,2.4102-2.0992,3.1097-2.6358,5.7121-2.4881,9.5627,0.25382,6.6003,4.3842,11.832,8.9412,14.383'/%3E %3Cpath d='m390.12,216.81c-5.2278,0.6376-9.4004,5.0688-9.4004,10.433,0,6.9196,1.7033,9.7184,5.5906,15.005,3.8965,5.299,16.638,15.005,16.638,26.045,0,6.6864-1.866,10.962-6.6863,13.139-3.1083,1.4036-6.7423-0.1157-8.3967-1.6107-4.0432-3.6543-2.4265-10.062,1.788-10.828,5.1313-0.9332,6.0957,7.145,1.0884,6.6083'/%3E %3Cpath d='m381.33,223.67c-3.9652,0.3109-7.8665,3.7229-7.8665,7.9079,0,5.9865,2.3846,8.7614,7.1667,14.716,4.1208,5.1313,15.762,13.972,15.451,22.602-0.11729,3.2634-2.3111,7.2531-4.488,6.7865'/%3E %3Cpath stroke-linecap='round' d='m372,343.94c1.866-4.5092,6.6864-2.4879,6.9829,0,0.68324,5.7321-4.3395,7.4638-7.9158,6.5307-1.7714-0.4621-3.0676-1.5778-3.8957-3.0313-0.93454-1.64-1.2171-3.7797-0.61037-5.8235,0.27521-0.9269,0.66271-1.7073,1.3257-2.581,0.6658-0.878,1.3541-1.4791,1.9991-1.8905,1.3755-0.8779,2.8742-0.9646,5.2242-0.9646,8.7076,0,16.327,10.289,18.886,20.977,0.84278,3.52,2.0013,11.371,0.39592,18.815-1.7106,7.9301-5.1384,13.42-9.1598,17.585-2.1769,2.2546-5.146,4.2618-8.9896,6.4351-1.1856,0.6705-4.3198,2.0609-6.4967,2.6831-2.236,0.6388-4.3369,0.688-6.1582,0.1418-4.4225-1.3268-7.2612-5.4591-4.9596-10.829,1.7916-4.1808,8.3967-6.2198,11.351-1.0885,0.25071,0.4353,0.64073,1.3836,0.62836,2.4107-0.0158,1.3682-0.58419,3.0172-1.5615,3.6391-2.2459,1.4292-5.8382,1.0251-5.6711-2.9401'/%3E %3Cpath d='m365.24,397.49c1.6327,0.6292,2.5258,0.544,4.5573-0.3579,0.8335-0.3703,1.7883-0.9435,2.9066-1.5784,3.9804-2.2607,8.7076-5.8238,13.139-14.143,1.3105-2.4602,2.1246-4.7432,2.6725-6.9922,0.42293-1.7354,0.71588-3.4505,0.77919-5.2112,0.10805-3-0.215-6.1323-0.96378-9.721-1.2362-5.9254-2.7251-9.1432-6.3754-14.15-1.7951-2.4622-3.343-3.9649-6.6864-4.0425'/%3E %3Cpath d='m360.51,389.58c-0.0678-0.3647-0.10332-0.7406-0.10332-1.125,0-3.3706,2.7324-6.103,6.1033-6.103,3.3706,0,6.103,2.7324,6.103,6.103,0,1.9394-0.90442,3.6675-2.3148,4.7854'/%3E %3Cpath d='m362.88,383.51c0.45954-2.7701,2.8132-4.8795,5.6477-4.8795,3.1641,0,5.729,2.628,5.729,5.87,0,1.5877-0.61514,3.0281-1.6147,4.0848'/%3E %3Cpath d='m374.02,383.2c5.209-3.7319,9.672-10.856,9.7184-19.274,0.0358-6.4739-2.5658-13.061-5.5976-15.627'/%3E %3Cpath stroke-linecap='round' d='m382.29,380.33c-2.0432,3.0321-4.5165,6.4035-9.7404,9.2375'/%3E %3Cpath d='m397.81,402.63c-1.4489-3.4089-4.3288-4.9853-9.0189-5.4856-4.6625-0.4978-8.6986,0.7837-12.828,3.0048-8.0598,4.3346-12.554,8.9946-15.55,17.641-0.76034,2.1952-1.3912,5.5056-1.3034,9.0211,0.14025,5.6041,1.5629,11.73,3.0917,14.692,1.3336,2.5835,4.8204,13.994,23.946,21.868,11.161,4.5949,28.3,5.6539,40.118,6.1201,16.256,0.6419,31.255,1.2441,39.962,11.973'/%3E %3Cpath stroke-linecap='round' d='m374.5,406.05c5.1198-3.3587,14.838-7.7615,23.624-3.4277,3.2589,1.6077,5.4423,3.5963,6.6751,6.8397,2.2197,5.8393-0.2617,12.275-2.7878,14.949-1.3217,1.3994-4.2004,4.0735-7.7748,4.1208-5.9088,0.078-7.3133-4.0572-7.4636-4.976-0.69983-4.2759,1.788-5.9865,3.1098-6.453,1.0139-0.3577,4.3122-0.2662,5.0117,2.0654,0.23327,0.7773,0.27491,2.133-0.34698,3.1438'/%3E %3Cpath d='m394.86,421.45c0.46656-1.7104,0.22651-3.5063-1.3215-5.209-1.555-1.7104-5.6756-3.3431-9.1745-1.3994-1.1703,0.6503-2.6381,1.5066-3.9649,3.2653-0.50202,0.6653-1.3504,1.7391-1.7883,2.4879-1.0589,1.8108-1.494,3.2927-1.7033,3.8875-3.845,10.928,2.413,22.532,10.256,27.522,6.8416,4.3538,13.839,5.5979,22.469,6.3751,3.9936,0.3599,6.2566,0.4368,10.263,0.6222,3.2237,0.1493,6.0082,0.096,8.63,0.064,2.1575-0.027,4.2049-0.016,6.2969-0.064,3.4156-0.079,6.9494-0.1589,11.274,0.1556,4.5497,0.3309,7.9729,0.4477,11.818,1.0884,2.5115,0.4187,5.4558,0.8226,8.5422,1.5151,0.92609,0.2075,1.8651,0.3773,2.8089,0.6618,0.63427,0.1912,1.2604,0.3853,1.8814,0.5746,5.5714,1.6994,10.985,3.7697,15.257,6.5209,1.3198,0.8501,2.8402,1.6707,3.8771,2.7079,0.7958,0.7956,1.472,1.2565,2.1234,1.8978,2.9902,2.9415,6.0476,6.1261,6.7626,10.438,0.13191,0.7955,0.1317,1.6293,0.1317,2.507,0,2.7988-2.2774,6.6084-8.4195,7.8524'/%3E %3Cpath d='m466.62,488.16c-1.6327,3.343,0.22422,5.0235,2.4878,5.2866,3.343,0.3887,5.1313-2.2545,5.3646-4.6647,0.37821-3.9081-2.9159-7.4492-6.842-7.3859-3.5352,0.057-6.4145,2.3376-7.7644,5.4766-0.49075,1.1411-0.71784,2.3952-0.78791,3.6976-0.13237,2.4678,0.73501,4.7413,2.2228,6.4736,1.9974,2.326,5.113,3.7336,8.4288,3.8664,6.6002,0.2648,11.74-5.9085,11.74-12.206,0-12.051-17.873-18.623-24.957-20.314-8.7079-2.0775-14.006-2.8553-27.989-3.6323-5.5979-0.3109-9.6973-0.1531-15.861-0.7921-5.5152-0.5715-8.3967-0.8405-14.073-2.1623-7.0826-1.6493-13.684-4.5871-19.592-9.9517-4.55-4.1309-7.1526-7.0749-9.2592-12.75-1.8176-4.8975-2.6527-14.596,1.951-21.769,4.069-6.3399,9.7184-9.6331,16.172-10.566,5.8292-0.8428,10.942,1.6726,13.995,7.4565,1.4771,2.7988,1.0218,7.4799-0.14835,9.6404-1.0108,1.866-3.8968,4.6178-7.4712,4.6651-5.9088,0.078-7.3133-4.0572-7.4636-4.976-0.69983-4.2759,1.788-5.9865,3.1098-6.453,1.0139-0.3577,4.3122-0.2662,5.0117,2.0654,0.23327,0.7773,0.27491,2.133-0.34698,3.1438'/%3E %3Cpath stroke-linecap='round' d='m426.97,212.58c-0.16411-0.2443-0.34583-0.513-0.54732-0.8096-2.6435-3.8873-7.3116-4.9116-10.729-2.3323-4.1206,3.1098-5.1612,8.4023-4.0429,13.994,0.69955,3.4987,3.0732,6.4128,6.3247,8.5211'/%3E %3Cpath d='m573.04,224.37c-6.2975,6.8417-12.595,9.0262-22.003,9.3296-2.9376,0.095-8.5523-0.9329-11.818-3.2581-2.0976-1.4936-4.4315-4.0502-2.9544-8.4817,0.98746-2.9622,5.7462-11.273,5.9795-17.027,0.35626-8.7892-3.025-13.606-8.312-15.472-9.7739-3.4497-20.267,6.2113-26.589,8.319-3.3053,1.1017-4.9903,1.2319-8.0081,1.2429-3.0177-0.011-4.7627-0.1411-8.068-1.2429-6.3228-2.1077-16.816-11.769-26.59-8.319-5.2867,1.8659-8.668,6.6824-8.3117,15.472,0.2333,5.7532,4.9918,14.064,5.9792,17.027,1.4774,4.4315-0.85658,6.9881-2.9541,8.4817-3.2656,2.3252-8.8801,3.3529-11.818,3.2581-9.4072-0.3034-15.705-2.4879-22.003-9.3296'/%3E %3Cpath stroke-linecap='round' d='m464.58,466.27c1.246,0.4868,0.30336-0.2952,8.1947,3.2032,7.5764,3.3585,12.954,6.2999,17.663,13.736,1.4774,2.3323,1.866,5.6756,1.866,7.6192,0,1.2528-0.15217,2.554-0.45867,3.8417'/%3E %3Cpath d='m465.09,500.06c1.5362,0.7682,3.2792,1.2167,5.081,1.2891,6.6002,0.2648,11.74-5.9089,11.74-12.206,0-4.3662-2.377-8.0441-5.7062-11'/%3E %3Cpath stroke-linecap='round' d='m466.52,488.15c-1.5938,3.5532,0.67678,5.4749,2.9401,5.738,3.3433,0.3889,5.2248-2.2546,5.458-4.6647,0.25355-2.6213-1.145-5.171-3.278-6.4852'/%3E %3Cpath d='m609.53,216.87c5.0182,0,9.394,5.5855,9.394,11.317,0,6.605-3.5127,10.648-6.0869,13.705-2.0722,2.4608-4.3158,4.6625-6.9824,7.3482'/%3E %3Cpath stroke-linecap='round' d='m603.58,211.58c1.7064,0.7901,3.2037,2.1276,4.3456,3.8188,2.099,3.1101,2.6331,5.7121,2.4879,9.5631-0.24905,6.6-4.998,11.17-9.2462,13.959'/%3E %3Cpath stroke-linecap='round' d='m593.71,211.58c0.34695,0.2961,0.68042,0.6338,1.0004,1.0142,2.8768,3.421,3.0993,8.4775,2.4102,11.281-1.0353,4.2128-2.4276,6.0287-5.8464,8.5483'/%3E %3Cpath stroke-linecap='round' d='m583.36,209.85c4.1206,3.1098,5.3458,8.4887,3.9807,14.026-0.9756,3.9567-3.4635,6.3281-6.5656,8.2174'/%3E %3Cpath stroke-linecap='round' d='m598.16,296.28c0.49301,1.4472,1.3065,1.9486,2.3317,3.0225,2.229,2.335,5.4963,4.3434,9.623,5.5039,3.8138,1.0727,7.2494,0.2662,9.8706-1.3671'/%3E %3Cpath stroke-linecap='round' d='m365.29,387.87c1.9372-0.035,3.869,1.273,5.1325,3.4677,0.25072,0.4356,0.64103,1.3836,0.62835,2.4107-0.0158,1.3682-0.6154,2.8309-1.5924,3.4525-2.2456,1.4292-6.2327,0.8149-6.0659-3.15'/%3E %3Cpath d='m377.33,336.4c7.7033,1.4379,15.119,10.729,17.546,20.865,0.84279,3.5201,2.0016,11.371,0.39592,18.815-1.7103,7.9301-5.1381,13.42-9.1598,17.585-0.95338,0.9875-2.0587,1.9276-3.3231,2.8548l-1.6428,1.1135'/%3E %3Cpath d='m368.76,378.67c3.1641,0,5.9336,3.0316,5.9336,6.2733,0,1.5876-0.61515,3.0281-1.6147,4.0848'/%3E %3Cpath d='m366.62,382.35c3.2966,0,6.4325,3.1758,6.4325,6.5464,0,1.9397-0.90469,3.6678-2.3151,4.7855'/%3E %3Cpath stroke-linecap='round' d='m396.84,349.2c3.0273,4.0629,5.0252,7.5612,5.9544,12.07'/%3E %3Cpath stroke-linecap='round' d='m402.69,374.53c-0.4995,2.2459-1.2593,4.3246-2.2639,6.3222-1.2731,2.5304-3.4919,5.3478-5.5523,7.2525'/%3E %3Cpath d='m397.32,325.52c2.9187,2.2816,4.678,4.6412,5.5011,7.4687'/%3E %3Cpath stroke-linecap='round' d='m402.9,317.92c-0.76653,2.6592-2.5059,4.6738-5.2661,7.1926'/%3E %3Cpath stroke-linecap='round' d='m383.33,298.27,3.3686-0.8865,1.9943-1.5071,1.2854-1.8176,1.1081-2.8368,0.4432-2.3049'/%3E %3Cpath d='m376.51,286.41c-1.0634,0.26582-2.4109,0.65948-3.8239,1.3328-1.8928,0.90191-3.9033,2.3056-5.506,4.5758-1.8561,2.6296-2.9384,6.2859-3.6084,9.4848-0.29322,1.3997-0.64328,5.832,0.25214,10.41,0.66128,3.3801,2.0573,6.527,3.6016,8.8061,0.55379,0.8172,1.0561,1.5226,1.6206,2.0874,2.0216,2.0213,3.8875,3.2654,6.9973,2.6432'/%3E %3Cpath stroke-linecap='round' d='m395.38,271.58c-0.54618,2.0066-1.6248,4.4933-4.7737,4.2213'/%3E %3Cpath d='m383.87,285.2c-3.0236-2.9558-9.4292-3.7263-15.798,0.3022-0.81858,0.5181-1.6372,1.183-2.4479,1.8587-0.87628,0.7299-1.5753,1.5693-2.2506,2.4819-0.73419,0.9925-1.6361,2.6801-2.1811,3.8009-0.75022,1.5438-1.0609,2.5579-1.4742,4.1408-1.163,4.4554-1.158,8.5959-1.0209,9.7761,0.17626,1.5131,0.32023,2.9035,0.56757,4.1822,0.84505,4.3715,2.1381,7.439,3.4753,9.6565,1.4067,2.3325,4.9054,7.6898,12.058,8.3967,2.8112,0.278,7.6121-1.0106,7.7675-4.6648'/%3E %3Cpath stroke-linecap='round' d='m568.38,220.42c0.47838-2.5813,3.5892-3.0796,4.7582-1.555,1.8001,2.348,0.60952,6.3818-3.0515,7.526-1.2441,0.3889-4.1205,0.2333-5.9865-2.1769-1.5125-1.9537-1.3969-4.3735-0.83208-6.2969,0.36553-1.2446,1.3642-2.3294,2.6981-3.3435,4.2511-3.2333,11.118-2.4879,13.372,2.9541,2.9086,7.0203-3.4207,12.284-9.2519,16.249-7.3409,4.9918-15.705,5.8996-22.003,5.8312-14.306-0.1556-25.19-6.9973-32.265-10.884-1.6482-0.9056-3.3456-0.7207-4.1982,0.3109-0.96295,1.1644-0.94749,3.0428,0.38861,4.2759'/%3E %3Cpath stroke-linecap='round' d='m571.26,218c1.5162,0.07,1.922,0.6616,2.3868,1.2674,1.7998,2.348,0.48487,6.3821-3.1761,7.526'/%3E %3Cpath stroke-linecap='round' d='m598.34,307.33c-5.4504,5.9325-0.43701,16.116,3.6365,18.418,1.4101,1.0966,2.0126,0.5153,3.1404,1.1749'/%3E %3Cpath d='m598.63,295.99c-1.7883,1.2441-2.4184,2.6415-2.4879,5.0697-0.0583,2.032,0.29603,4.2883,2.2034,6.2727,2.9713,3.0917,8.7859,5.7836,14.42,5.8542,3.0563,0.038,6.2294-0.6007,9.4218-2.7354,3.4131-2.2825,5.2093-5.3646,5.9868-8.3967'/%3E %3Cpath d='m595.58,398.6c0,0.018-0.009,2.3885-0.21183,3.8873-0.59151,4.3631-1.2857,6.8737-3.2654,10.807-1.9304,3.8354-3.4728,5.8491-6.5307,8.8632-3.0853,3.0411-5.2236,4.4343-9.0965,6.3754-3.7716,1.8902-6.1477,2.4912-10.263,3.4207-4.1121,0.9286-6.5175,1.1312-10.729,1.3217-3.8619,0.1747-6.0529,0.011-9.9095-0.2546-4.1273-0.2857-6.4167-0.8606-10.538-1.2224-3.4038-0.2992-5.3263-0.5744-8.7431-0.5659-3.5124,0.01-5.525,0.031-8.9834,0.6435-3.2232,0.5707-5.0517,1.0254-8.0857,2.2546-4.1979,1.7008-8.9409,4.6648-9.9517,5.9865-1.0108-1.3217-5.7541-4.286-9.9517-5.9865-3.034-1.2292-4.8626-1.6839-8.0857-2.2546-3.4584-0.6123-5.471-0.6345-8.9834-0.6435-3.417-0.01-5.3396,0.2667-8.7431,0.5659-4.1217,0.3618-6.4108,0.9367-10.538,1.2224-3.8568,0.2667-6.0475,0.4294-9.9095,0.2546-4.2117-0.1904-6.6171-0.3931-10.729-1.3217-4.1149-0.9295-6.4911-1.5305-10.263-3.4207-3.8729-1.9411-6.0112-3.3343-9.0965-6.3754-3.058-3.0141-4.6006-5.0278-6.5307-8.8632-1.9796-3.9329-2.6739-6.4435-3.2656-10.807-0.20329-1.4988-0.21162-3.8687-0.21162-3.8873v-0.0003-159.02h192.55v159.02l0.0668,0.0003z'/%3E %3C/g%3E %3Cg fill='%23c7b37f' stroke='%23c7b37f'%3E %3Cpath stroke-width='0.51271021' d='m387.41,421.32c0-2.1575,1.7492-3.9067,3.907-3.9067,2.1575,0,3.9067,1.7492,3.9067,3.9067,0,2.1578-1.7492,3.9067-3.9067,3.9067-2.1578,0-3.907-1.7489-3.907-3.9067z'/%3E %3Cpath stroke-width='0.51271021' d='m363.42,393.71c0-1.9321,1.2356-3.4986,2.76-3.4986s2.7602,1.5665,2.7602,3.4986c0,1.9324-1.2359,3.4987-2.7602,3.4987s-2.76-1.5663-2.76-3.4987z'/%3E %3Cpath stroke='none' d='m377.05,324.36c0-1.5871,1.1931-2.8734,2.6649-2.8734,1.4717,0,2.6648,1.2863,2.6648,2.8734,0,1.5868-1.1931,2.8733-2.6648,2.8733s-2.6649-1.2865-2.6649-2.8733z'/%3E %3Cpath stroke='none' d='m424.91,221.81c-0.16816-1.5919,0.78762-2.9969,2.135-3.1379,1.3473-0.1409,2.5762,1.035,2.7445,2.6271,0.16839,1.5919-0.78765,2.9967-2.1353,3.1379-1.3473,0.141-2.5759-1.0349-2.7442-2.6271z'/%3E %3C/g%3E %3Cg stroke='%23c7b37f' stroke-width='0.987' stroke-linecap='round'%3E %3Cpath d='m373.92,340.54c-0.57379,0.2499-0.89064,0.4561-1.3218,0.9098-0.41197,0.4333-0.49752,0.5906-0.81633,1.2983-0.23329,0.5178-0.29463,1.118-0.38102,1.8581'/%3E %3Cpath d='m378.77,386.4c0.54255-0.6579,0.87039-1.0119,1.3915-1.687,0.43363-0.5616,0.69168-0.8709,1.073-1.4694,0.34361-0.5392,0.49752-0.8676,0.80087-1.4307,0.42746-0.7938,0.64019-1.2567,1.0496-2.0601'/%3E %3Cpath d='m381.11,401.53c-0.92495,0.4246-1.4723,0.6123-2.3713,1.0884-0.68354,0.3622-1.0547,0.5935-1.7106,1.0029-0.77441,0.484-1.2069,0.7666-1.9436,1.3063-0.76739,0.5622-1.1619,0.9297-1.9048,1.5237'/%3E %3Cpath d='m396.56,347.25c-0.50033-0.5152-0.77189-0.8169-1.2829-1.3214-0.53437-0.5274-0.82507-0.8386-1.3994-1.3218-0.55717-0.4685-0.9109-0.6829-1.4928-1.1197'/%3E %3Cpath stroke-linecap='butt' d='m397.17,326.47c-0.7429,0.3306-1.1326,0.5932-1.9048,0.8476-0.885,0.2915-1.4849,0.4431-2.3401,0.482'/%3E %3Cpath d='m371,300.68c0.25468,0.9067,0.3104,1.4478,0.65314,2.3246,0.43082,1.102,0.79101,1.6817,1.4461,2.6668,0.68296,1.0266,1.1096,1.5939,1.9904,2.4569,0.77356,0.7576,1.2638,1.14,2.1693,1.7337,0.8597,0.5637,1.418,0.7587,2.3247,1.2438'/%3E %3Cpath d='m378.04,301.95c0.75809,0.4061,1.1495,0.7119,1.9439,1.0417,0.71899,0.2986,1.1456,0.4247,1.9045,0.5986,1.0268,0.2355,1.6293,0.2946,2.6826,0.3188,1.1402,0.027,1.477,0,2.9156-0.2333'/%3E %3Cpath d='m398.69,240.15c-1.2463-0.7277-2.0081-1.046-3.1956-1.866-1.2078-0.8341-1.8733-1.3453-2.9232-2.3713-0.75725-0.7395-1.1816-1.1707-1.8116-2.0213-0.56224-0.7595-0.77779-1.257-1.275-2.0604'/%3E %3Cpath d='m401.2,224.72c0.39114,1.0459,0.50285,1.6839,1.0029,2.6823,0.67873,1.3552,1.2027,2.0671,2.2236,3.1877,1.4149,1.5525,2.6131,1.9917,4.2837,3.2653'/%3E %3Cpath d='m410.98,224.61c0.38806,0.9398,0.50651,1.5181,0.99532,2.4099,0.43193,0.7885,0.72965,1.2083,1.2984,1.9048,0.72516,0.8886,1.1968,1.3521,2.0992,2.0604,1.049,0.8236,1.7925,1.0671,2.9386,1.7492'/%3E %3C/g%3E %3Cpath fill='%23703d29' stroke-width='0.27661592' d='m520.78,211.91c-0.0802-2.6489-2.6896-2.9243-3.6894-2.9243-2.8855,0-3.6661,1.7998-7.2657,3.7327-4.512,2.4231-6.4553,2.9615-10.466,2.9975-4.0102-0.036-6.0048-0.5744-10.517-2.9975-3.5994-1.9329-4.2052-3.6748-7.091-3.6748-1.5663,0-3.5895,1.353-3.5127,3.8327,0,0-0.0301,0.8031,0.0932,1.3465,0.0463,0.2046,0.29518,0.1407,0.3734,0.3199-0.0371-1.2024,0.20757-1.8251,0.80003-2.6327,0.76061-1.0378,2.0244-1.3133,2.5396-1.3133,2.8855,0,3.9537,1.8516,7.5533,3.7845,4.512,2.4231,6.4534,2.9615,10.464,2.9975,4.0102-0.036,6.0068-0.5744,10.519-2.9975,3.5997-1.9329,4.6341-3.9379,7.5198-3.9379,0.99981,0,1.7053,0.6472,2.0328,1.6665,0.20171,0.6269,0.088,1.0451,0.14026,1.2932,0.0254,0.1212,0.17379,0.1088,0.20643,0.2398,0.10018-0.4665,0.33345-0.6331,0.29998-1.7328z'/%3E %3C/g%3E %3Cg fill='%23703d29'%3E %3Cpath d='m413.12,434.42c0.81016-0.8724,1.4225-0.5439,1.5728-0.9458,0.11098-0.2971-0.129-0.327-0.45898-0.4505-0.44038-0.1646-0.90694-0.2592-1.3473-0.4241-0.45614-0.1704-0.87036-0.4049-1.3265-0.5754-0.18887-0.071-0.62527-0.2935-0.74964,0.039-0.2285,0.6114,1.6017,0.5588,0.9877,2.2016-0.10467,0.2794-0.36469,0.8794-1.2744,1.8738l-4.1411,4.5072c-0.0929,0.1047-0.24737,0.3259-0.34162,0.2904-0.0945-0.035-0.0817-0.3092-0.083-0.4494l0.0592-6.3917c0.005-1.2128,0.10807-2.1107,0.30421-2.635,0.27435-0.7339,1.12-0.1191,1.2964-0.5909,0.11121-0.2969,0.0259-0.309-0.47725-0.4973-0.25185-0.094-0.73389-0.1947-1.7404-0.5709-0.53495-0.2002-1.0434-0.47-1.5626-0.6638-0.23581-0.088-0.67113-0.4103-0.82787,0.01-0.0459,0.1224,0.11931,0.3036,0.16006,0.3388,0.57939,0.4159,0.7277,0.6902,0.74035,1.4719l0.11346,11.635c0.009,0.8397,0.10063,1.0732,0.25803,1.132,0.17312,0.065,0.29097-0.011,0.63371-0.4004l8.205-8.9035z'/%3E %3Cpath d='m417.95,436.22c0.53324-1.6904,1.5322-0.6712,1.723-1.2762,0.0673-0.2136-0.00098-0.2744-0.48203-0.4258-0.91259-0.2878-1.5117-0.3984-2.0883-0.5802-0.56056-0.1767-1.1625-0.4449-1.7872-0.6416-0.14408-0.046-0.52764-0.2254-0.62303,0.077-0.19652,0.6228,1.7703,0.6951,1.2598,2.3142l-2.693,8.5411c-0.53298,1.6904-1.5401,0.8642-1.7365,1.4869-0.0282,0.089-0.0355,0.2238,0.10897,0.2693,0.4162,0.1313,1.1273,0.2772,1.8159,0.4941,1.2491,0.394,1.8192,0.652,2.4119,0.8389,0.36807,0.1161,0.53495,0.09,0.59657-0.1054,0.17942-0.5695-1.8721-0.3165-1.1821-2.5053l2.6761-8.4875z'/%3E %3Cpath d='m423.73,437.93c0.31798-1.0733,0.81689-0.9256,1.4126-0.7491,1.6262,0.4817,2.1355,2.0725,1.6164,3.8256-0.31264,1.0555-0.70604,2.0289-3.1534,1.3037-0.48288-0.1429-1.0786-0.3194-0.94607-0.7665l1.0704-3.6137zm-4.4337,7.696c-0.66777,2.254-1.797,1.2775-1.9664,1.8499-0.10604,0.3577,0.2479,0.4044,0.42491,0.4567,0.80507,0.2383,1.6313,0.4055,2.5005,0.663,0.67619,0.2001,1.0898,0.4007,1.3637,0.4817,0.37003,0.1095,0.53072,0.04,0.57856-0.1206,0.19067-0.6439-1.6206-0.3827-1.0536-2.2968l0.91681-3.0948c0.1855-0.6261,0.12584-0.7801,0.97927-0.5271,0.80507,0.2383,1.0471,0.4851,1.1841,1.382l0.51524,3.227c0.19157,1.1856,0.37313,2.4651,1.6451,2.8419,0.64384,0.1907,1.8232,0.1119,1.9875-0.4426,0.0423-0.143-0.0225-0.2789-0.16749-0.322-0.16096-0.048-0.35371,0.011-0.51467-0.036-0.12899-0.038-0.43478-0.129-0.49499-0.4578-0.49133-2.5973-1.0915-5.5968-1.0598-5.7043,0.0529-0.1787,0.56759-0.2014,1.1563-0.4747,0.59402-0.291,1.257-0.8144,1.5961-1.9594,0.24396-0.8228,0.66917-3.4406-2.8568-4.4849-1.0789-0.3197-2.1949-0.5724-3.2735-0.892-1.0142-0.3003-1.1219-0.4101-1.8626-0.6296-0.19292-0.057-0.38075-0.016-0.43365,0.1635-0.19068,0.6438,1.7604,0.502,1.1667,2.5053l-2.3314,7.8713z'/%3E %3Cpath d='m432.46,449.48c-0.51835,2.1589-2.1541,0.8453-2.3241,1.5524-0.0959,0.3994,0.18595,0.4478,0.48007,0.5184,0.65312,0.1567,1.2092,0.2136,2.3032,0.4764,1.0938,0.2625,1.6152,0.4646,2.2684,0.6213,0.47357,0.1137,0.78705,0.2465,0.89147-0.1888,0.12224-0.508-2.0942-0.4838-1.5584-2.7153l1.9687-8.2002c0.20914-0.8707,0.39422-0.9222,1.0637-0.7615l1.3876,0.3332c1.8952,0.3782,0.88922,2.2667,1.5424,2.4234,0.42463,0.102,0.41478-0.6486,0.43448-0.8743l0.22129-1.7123c0.027-0.1851,0.088-0.4393-0.15668-0.4978-1.5184-0.3647-2.63-0.5549-5.0137-1.1273-2.384-0.5724-3.4604-0.9075-4.9788-1.2719-0.24482-0.059-0.30587,0.1949-0.36582,0.3725l-0.83602,2.332c-0.0896,0.2279-0.28309,0.6036,0.0597,0.686,0.73473,0.1763,0.8155-2.3178,2.6606-1.8749l1.3715,0.3292c0.66917,0.161,0.81073,0.2907,0.60164,1.1616l-2.021,8.4178z'/%3E %3Cpath d='m452.3,444.42c0.64638-0.9996,1.3062-0.7823,1.3848-1.2044,0.0576-0.3118-0.1837-0.2997-0.53045-0.3639-0.46233-0.086-0.93819-0.098-1.4005-0.1837-0.47868-0.089-0.9275-0.2479-1.4062-0.3366-0.19811-0.037-0.66692-0.1803-0.73135,0.168-0.11908,0.6421,1.6743,0.2724,1.3547,1.9968-0.0543,0.2938-0.20643,0.9297-0.92948,2.0669l-3.2958,5.1578c-0.0732,0.119-0.18685,0.3638-0.2859,0.3452-0.099-0.018-0.13395-0.2904-0.15984-0.428l-1.0516-6.3047c-0.20553-1.1957-0.26-2.0979-0.15803-2.648,0.14295-0.7705,1.0825-0.3118,1.1743-0.8073,0.0576-0.3118-0.0282-0.3087-0.55632-0.4067-0.26424-0.049-0.75669-0.064-1.8133-0.26-0.56139-0.104-1.1093-0.2814-1.6541-0.3824-0.24764-0.046-0.73221-0.2876-0.81381,0.1524-0.0239,0.1285,0.17041,0.2783,0.21656,0.3059,0.64272,0.309,0.8366,0.5535,0.98461,1.3209l2.1322,11.439c0.15443,0.8256,0.28561,1.0397,0.4508,1.0704,0.18145,0.034,0.28448-0.061,0.55463-0.5045l6.5341-10.193z'/%3E %3Cpath d='m453.23,454.93c0.009,0.4556-0.0324,0.6,0.36301,0.7795,0.92073,0.4001,1.6915,0.9832,2.7017,1.152,2.1693,0.363,3.9672-1.0198,4.3704-3.4302,0.39114-2.3371-0.56957-3.3113-2.1969-4.4726-2.0373-1.4571-2.9083-1.8488-2.702-3.0816,0.20622-1.2328,1.0685-1.8074,2.1617-1.6245,2.8486,0.4767,2.5242,3.941,2.9049,4.0046,0.36443,0.061,0.4511-0.1515,0.4857-0.5617l0.23048-2.4966c0.0378-0.4285,0.13372-0.6964-0.11481-0.7378-0.21521-0.036-0.67874,0.1891-0.89373,0.1531-0.49694-0.083-1.0724-0.9174-2.4305-1.1445-1.9377-0.3244-3.5214,0.9996-3.8754,3.1159-0.32332,1.9321,0.53382,2.8132,1.8409,3.7508,2.4479,1.7529,3.4511,2.1665,3.1894,3.7308-0.24651,1.472-1.3879,2.189-2.6798,1.9729-1.8381-0.3078-2.5847-2.1541-2.8191-4.0094-0.0261-0.2501-0.0315-0.4212-0.29659-0.4657-0.41422-0.069-0.33768,0.4922-0.33122,0.7581l0.0919,2.6069z'/%3E %3Cpath d='m477.95,447.96c0.53833-1.062,1.2173-0.9148,1.2511-1.3426,0.0247-0.3163-0.21386-0.2791-0.56561-0.3067-0.46852-0.037-0.94325,0.0009-1.4121-0.036-0.48539-0.038-0.94802-0.1497-1.4337-0.188-0.20081-0.016-0.68184-0.1096-0.70969,0.2437-0.0511,0.6509,1.6937,0.096,1.5561,1.8443-0.0235,0.2977-0.10806,0.9461-0.70857,2.1527l-2.7383,5.4738c-0.0605,0.1263-0.1479,0.3813-0.24847,0.3734-0.10039-0.01-0.16343-0.2749-0.2035-0.4088l-1.7047-6.1604c-0.32924-1.1678-0.47808-2.059-0.43419-2.6171,0.0612-0.7811,1.044-0.4232,1.0834-0.9255,0.0247-0.316-0.0602-0.3039-0.59599-0.3461-0.2679-0.02-0.75895,0.016-1.8305-0.069-0.56899-0.045-1.1324-0.1641-1.6847-0.2073-0.25101-0.02-0.75838-0.2096-0.79354,0.2367-0.0113,0.1303,0.19877,0.2591,0.24733,0.2816,0.67171,0.2401,0.88979,0.4632,1.1174,1.2109l3.3163,11.153c0.23975,0.8051,0.39256,1.004,0.55998,1.0172,0.18393,0.014,0.27663-0.091,0.49894-0.5597l5.433-10.82z'/%3E %3Cpath d='m480.6,457c-0.0158,1.9028-1.6256,1.5531-1.6321,2.2993-0.002,0.3172,0.33373,0.2268,0.51863,0.2285,0.45332,0,0.90723-0.067,1.4444-0.062,0.58785,0.01,1.158,0.085,1.9808,0.092,0.21837,0,0.63793,0.024,0.64018-0.2369,0.007-0.8769-2.1527,0.3728-2.1215-3.2091l0.0553-6.3433c0.00098-0.1679,0.036-0.2983,0.13687-0.2975,0.0842,0.0009,0.18392,0.095,0.30026,0.2454l7.992,9.7719c0.11617,0.1504,0.19924,0.2628,0.43422,0.2651,0.20148,0,0.20283-0.1475,0.20643-0.558l0.0912-10.466c0.0158-1.9588,1.4402-1.4987,1.4453-2.0584,0.00056-0.056,0.002-0.2426-0.31685-0.2454-0.15105,0-0.73952,0.068-1.7973,0.059-1.1588-0.011-1.645-0.089-1.9138-0.091-0.21813,0-0.27014,0.1843-0.27126,0.3148-0.005,0.6157,2.046,0.2978,2.0311,1.9955l-0.0541,6.2127c-0.005,0.4663-0.0396,0.69-0.14047,0.6891-0.10063-0.0008-0.30024-0.2265-0.51635-0.4896l-6.6782-8.2866c-0.29914-0.3571-0.0966-0.486-0.63371-0.4905-0.89007-0.01-1.3274,0.063-1.7638,0.059-0.31911,0-0.62077-0.08-0.9396-0.083-0.20149,0-0.28674,0.1465-0.28816,0.3146-0.009,0.8954,1.8831-0.3008,1.8519,3.2814l-0.0617,7.0896z'/%3E %3Cpath d='m496.86,448.6c0.0158-1.7725,1.2691-1.0898,1.2745-1.7241,0.002-0.224-0.0814-0.262-0.58531-0.2665-0.95706-0.01-1.5623,0.061-2.1665,0.056-0.58783,0-1.2421-0.086-1.8969-0.091-0.15105-0.001-0.57041-0.061-0.57322,0.2564-0.005,0.6528,1.8029,0.1472,1.788,1.8448l0.0158,8.9553c-0.0158,1.7722-1.2202,1.2767-1.2258,1.9298-0.00084,0.093,0.0315,0.224,0.18257,0.2254,0.43673,0.01,1.1594-0.064,1.8814-0.058,1.3096,0.011,1.9304,0.091,2.5514,0.097,0.38637,0,0.53804-0.07,0.53973-0.2752,0.005-0.5971-1.8828,0.2448-1.8629-2.05l0.0776-8.8992z'/%3E %3Cpath d='m503.9,457.27c0.0202,2.2203-1.8859,1.3412-1.8794,2.0689,0.005,0.4106,0.28871,0.3894,0.59121,0.3866,0.67141-0.01,1.2249-0.085,2.35-0.095,1.125-0.01,1.6797,0.06,2.3514,0.054,0.48682,0,0.82338,0.049,0.81943-0.399-0.005-0.5226-2.149,0.037-2.1693-2.2574l-0.0734-8.433c-0.007-0.8954,0.1594-0.9902,0.84758-0.9961l1.4273-0.011c1.9304-0.091,1.4112,1.9841,2.0829,1.9782,0.43644,0,0.24539-0.7299,0.20981-0.9534l-0.19967-1.7148c-0.0181-0.1866-0.0202-0.4477-0.2724-0.4455-1.5618,0.014-2.686,0.098-5.1375,0.1195-2.4516,0.02-3.5772-0.044-5.1389-0.03-0.25184,0-0.24959,0.2634-0.26479,0.4503l-0.24706,2.465c-0.0315,0.2429-0.12854,0.654,0.22399,0.6512,0.75584-0.01,0.23075-2.4462,2.1279-2.4628l1.4104-0.014c0.68857-0.01,0.85714,0.086,0.86502,0.9812l0.0757,8.6567z'/%3E %3Cpath d='m513.68,453.74c-0.30139,0.024-0.53439,0.061-0.54902-0.1252-0.0202-0.2603,0.0639-0.4728,0.12989-0.7027l1.0299-3.3933c0.0675-0.2114,0.13304-0.2353,0.16658-0.2378,0.0835-0.01,0.0336,0,0.14543,0.1382l1.6378,3.2586c0.1013,0.2165,0.21769,0.4133,0.23833,0.6737,0.0135,0.1859-0.22128,0.1857-0.52255,0.2095l-2.2765,0.179zm2.8745,0.7845c0.43534-0.034,0.53353,0.1452,1.2002,1.5525,0.22377,0.4877,0.36722,0.8132,0.3993,1.2224,0.0896,1.1346-1.1152,1.0234-1.0727,1.5629,0.0202,0.2606,0.23525,0.2062,0.53635,0.1823,0.48569-0.038,1.0992-0.1611,1.8356-0.2192,1.105-0.087,1.5626-0.048,2.1654-0.096,0.45193-0.035,0.60557-0.011,0.5808-0.3265-0.0484-0.6137-0.89512,0.1828-1.535-1.0954l-5.4156-11.028c-0.2617-0.5409-0.29798-0.5755-0.44882-0.5637-0.21746,0.018-0.27352,0.3771-0.36724,0.6841l-3.6509,11.61c-0.33625,1.0744-1.1988,1.0299-1.1652,1.4577,0.0202,0.242,0.28391,0.1834,0.51833,0.1652,0.4854-0.038,0.9652-0.1508,1.4672-0.1905,0.53578-0.042,1.0437-0.01,1.5795-0.049,0.35148-0.028,0.88079,0.062,0.85012-0.3289-0.0396-0.502-1.8243-0.062-1.9296-1.4014-0.0351-0.4466,0.14791-1.116,0.23581-1.497,0.28845-1.2582,0.63428-1.36,0.91879-1.3825l3.2977-0.2595z'/%3E %3Cpath d='m529.53,446.79c-0.16838-1.2764-0.10422-1.3037,1.9104-1.5688,3.213-0.4232,2.1994,1.9121,2.982,1.8092,0.3827-0.05,0.21926-0.6498,0.17086-0.8882l-0.30756-1.8226c-0.0225-0.1666-0.16299-0.336-0.37933-0.3075-1.465,0.1927-2.6041,0.4181-3.786,0.5737-2.5472,0.3352-3.7556,0.419-4.438,0.5088-0.23326,0.031-0.34695,0.1963-0.32501,0.363,0.0974,0.7398,1.9008-0.1,2.1201,1.5649l1.1397,8.6572c0.29686,2.2566-1.0997,1.4245-0.98772,2.2751,0.0158,0.1113,0.12675,0.1905,0.34302,0.1621,0.91567-0.1206,1.6051-0.2867,2.1212-0.3545,0.73277-0.097,1.3583-0.1036,1.9909-0.1869,0.41618-0.055,0.77554-0.027,0.72684-0.397-0.0657-0.4992-1.8859,0.2107-2.1564-1.8424l-0.36048-2.7377c-0.14115-1.073-0.23694-1.286,0.52876-1.387l1.232-0.1621c1.7314-0.2279,1.5235,1.7942,2.0562,1.7241,0.39959-0.053,0.21184-0.7054,0.16389-0.9438l-0.55013-3.2771c-0.0824-0.4973-0.26057-0.4362-0.37707-0.421-0.33318,0.044-0.15894,1.7522-1.5908,1.9408l-1.0488,0.1382c-0.71588,0.094-0.73276-0.035-0.83774-0.8307l-0.34076-2.5897z'/%3E %3Cpath d='m535.67,451.03c0.69026,3.724,3.3782,5.7875,6.6968,5.1724,5.2669-0.9759,5.4408-5.6573,4.965-8.2253-0.72095-3.8893-3.6197-5.8-6.8324-5.1665-3.939,0.7679-5.574,4.2018-4.8294,8.2194zm1.837-1.422c-0.49301-2.66-0.13688-5.3449,2.6435-5.917,2.1229-0.4313,4.5316,1.3235,5.283,5.3776,0.56449,3.0453,0.0957,5.675-2.7341,6.2564-2.9451,0.6027-4.696-3.0386-5.1924-5.717z'/%3E %3Cpath d='m550.53,443.11c-0.26114-1.0887,0.24509-1.21,0.84897-1.3552,1.6493-0.3959,2.886,0.7272,3.3126,2.505,0.2572,1.0705,0.40297,2.11-2.0787,2.7057-0.48992,0.1177-1.0941,0.2625-1.203-0.1907l-0.87993-3.6646zm0.009,8.8818c0.54873,2.2859-0.91737,2.0045-0.77808,2.585,0.0869,0.363,0.41676,0.2262,0.59657,0.1832,0.81635-0.196,1.6152-0.4646,2.4971-0.6762,0.6855-0.1645,1.1439-0.1981,1.4214-0.2645,0.37566-0.09,0.48007-0.2305,0.44094-0.3937-0.15668-0.6531-1.5947,0.4787-2.0607-1.4624l-0.75358-3.1385c-0.15219-0.6351-0.28085-0.7386,0.58444-0.9463,0.81635-0.1959,1.1495-0.1033,1.7168,0.6047l2.0596,2.5374c0.75895,0.9306,1.5559,1.9481,2.8455,1.6386,0.65314-0.1567,1.6349-0.8147,1.5001-1.3772-0.0348-0.1449-0.15893-0.2304-0.30616-0.1949-0.16321,0.039-0.30026,0.1871-0.46374,0.2265-0.13058,0.031-0.44068,0.1056-0.65735-0.1495-1.7244-2.0035-3.7438-4.3009-3.7699-4.4098-0.0437-0.1814,0.39058-0.4584,0.76402-0.9894,0.36919-0.549,0.68155-1.3338,0.40267-2.4949-0.20036-0.8346-1.1411-3.3143-4.7168-2.4557-1.0941,0.2625-2.1867,0.6016-3.2808,0.8641-1.0285,0.2471-1.1766,0.2058-1.9279,0.3861-0.19586,0.047-0.33739,0.177-0.29378,0.3585,0.15668,0.6532,1.7754-0.4454,2.2633,1.5866l1.9163,7.9824z'/%3E %3Cpath d='m564.01,448.98c0.55604,2.1496-1.5052,1.7576-1.3232,2.462,0.10265,0.3976,0.37456,0.3081,0.66721,0.2324,0.6503-0.1682,1.1681-0.3793,2.2574-0.661,1.089-0.2817,1.6442-0.3481,2.2945-0.5164,0.47133-0.1218,0.81043-0.1517,0.69844-0.5853-0.13079-0.5057-2.0762,0.5563-2.6508-1.6656l-2.1116-8.1645c-0.22422-0.867-0.0851-0.9993,0.58137-1.1718l1.3819-0.3573c1.8508-0.5558,1.8491,1.5837,2.4994,1.4157,0.42266-0.1094,0.0617-0.7677-0.027-0.9759l-0.60866-1.6155c-0.0628-0.1765-0.12831-0.4295-0.372-0.3664-1.512,0.3911-2.5824,0.7451-4.956,1.3589-2.3733,0.6137-3.4812,0.8231-4.9932,1.2142-0.2437,0.063-0.17852,0.316-0.14813,0.5006l0.35652,2.4518c0.0284,0.2432,0.0336,0.6658,0.37482,0.5775,0.73165-0.1891-0.36807-2.4293,1.4689-2.9043l1.3656-0.3532c0.66663-0.1724,0.85236-0.124,1.0766,0.7429l2.1676,8.3812z'/%3E %3Cpath d='m572.6,437.52c-0.47387-1.7079,0.91935-1.3972,0.74995-2.0087-0.0599-0.2156-0.15083-0.229-0.63626-0.095-0.92242,0.2558-1.4849,0.4894-2.0674,0.6509-0.56618,0.1569-1.2173,0.26-1.8482,0.435-0.14588,0.04-0.56534,0.098-0.48063,0.4044,0.17469,0.6292,1.8634-0.3813,2.317,1.2548l2.3936,8.6299c0.47358,1.7079-0.82113,1.5635-0.64666,2.193,0.025,0.09,0.0923,0.2069,0.23806,0.1664,0.42042-0.1169,1.0963-0.3816,1.7922-0.5746,1.2621-0.3501,1.8806-0.4441,2.4794-0.6101,0.37228-0.1034,0.49779-0.2155,0.44293-0.4134-0.15961-0.5752-1.7424,0.7544-2.3556-1.4571l-2.3784-8.5759z'/%3E %3Cpath d='m576.18,441.69c1.2018,3.5918,4.1509,5.2611,7.3516,4.1901,5.0796-1.6994,4.6006-6.3594,3.7716-8.8365-1.255-3.7508-4.3912-5.2394-7.4847-4.1651-3.7938,1.3088-4.9349,4.9366-3.6385,8.8115zm1.6214-1.6639c-0.85856-2.5652-0.87938-5.2734,1.7939-6.2271,2.0424-0.7226,4.6718,0.6799,5.9803,4.5899,0.98265,2.9373,0.88416,5.6064-1.837,6.5761-2.8326,1.0065-5.0731-2.3557-5.9372-4.9389z'/%3E %3Cpath d='m589.72,431.56c-0.41027-1.0414,0.0741-1.2322,0.65229-1.4599,1.5781-0.6216,2.9589,0.3183,3.6289,2.0193,0.40353,1.0243,0.69254,2.0334-1.6819,2.9688-0.46881,0.1846-1.0468,0.4123-1.2179-0.023l-1.3814-3.5065zm1.2446,8.7943c0.86165,2.1871-0.62977,2.1128-0.41085,2.6683,0.13666,0.3472,0.44433,0.1661,0.61627,0.098,0.78117-0.3076,1.535-0.6847,2.3784-1.017,0.65622-0.2586,1.1056-0.3551,1.371-0.4601,0.35963-0.1412,0.44348-0.2946,0.38185-0.4511-0.24621-0.625-1.5125,0.6962-2.2442-1.1613l-1.183-3.0031c-0.23919-0.6076-0.38101-0.6923,0.44714-1.0184,0.78116-0.3076,1.1239-0.2623,1.7841,0.3599l2.3928,2.2259c0.88105,0.816,1.8117,1.7128,3.0459,1.2266,0.62497-0.2462,1.5058-1.0341,1.2936-1.5725-0.0545-0.1387-0.18933-0.206-0.3298-0.1506-0.15646,0.062-0.27154,0.2271-0.42773,0.2887-0.12494,0.049-0.42181,0.1662-0.67198-0.056-1.9864-1.7441-4.306-3.7381-4.3468-3.8422-0.0687-0.1736,0.32305-0.5082,0.61878-1.0859,0.28901-0.5952,0.48908-1.416,0.0515-2.527-0.31461-0.7986-1.5913-3.123-5.0129-1.7753-1.0468,0.4125-2.0818,0.9002-3.1286,1.3127-0.98406,0.3877-1.1363,0.3675-1.8553,0.6506-0.18752,0.074-0.30954,0.2219-0.24115,0.3956,0.24621,0.625,1.6963-0.688,2.4622,1.2562l3.0087,7.638z'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%23fedf00'%3E %3Cpath fill='%23d52b1e' d='m412.66,249.25h82.179v82.023h-82.179z'/%3E %3Cpath id='mits' fill='%23fff' d='m451.2,313.83s-0.048,2.9314-0.85518,5.2867c-0.93313,2.7214-0.94016,2.7214-1.7956,4.0429-1.1524,1.7809-2.5571,3.0827-3.8096,3.8875-1.9583,1.2584-3.9483,1.8876-5.9482,1.7103-5.491-0.4865-8.0382-6.4401-9.2831-11.273-1.3217-5.131-5.0733-7.9231-7.4638-6.0642-1.3994,1.0885-1.4782,2.9142-0.31093,4.6651,1.2441,1.8657,4.0991,2.7988,4.0991,2.7988l-2.9328,3.7319s-6.3019-0.8205-7.5345-7.3932c-0.46629-2.4881,0.74177-7.1335,4.891-8.5222,5.2968-1.7731,8.686,2.0041,10.318,5.1916,2.2456,4.3836,3.2096,12.434,9.4294,11.19,3.3838-0.6768,4.976-5.5979,4.976-7.8525l2.467-2.6434,3.6542,1.1664,0.0986,0.078z'/%3E %3Cuse xlink:href='%23mits' transform='matrix(-1,0,0,1,907.5206,0)'/%3E %3Cpath d='m461.12,278.95,10.76-11.643s1.624-1.3096,1.6096-3.4015l-2.2186,0.3452-0.49694-1.1416-0.11054-1.1473,2.9817-0.6292c0.0473-0.4843,0.007-0.8507,0.092-1.385,0.0795-0.4939,0.19-0.7587,0.31123-1.2441l-3.2656,0.2188c0.16592-0.5715,0.1281-0.8754,0.31094-1.4067,0.15399-0.4469,0.19675-0.6177,0.50287-1.1028,0.60641-0.091,1.158-0.2279,1.9073-0.3039,0.7277-0.073,1.1433-0.039,1.8733-0.085,1.781-3.3214,9.1894-6.3732,14.454-0.9042,3.8096,3.9582,2.9876,11.219-1.9509,13.139-2.7988,1.0885-5.0534,0.4449-6.8617-1.1101l1.9709-3.8656c2.7211,1.6254,4.9757-0.3959,4.8204-2.4952-0.19676-2.6535-1.9186-4.2966-4.3538-4.5094-2.2543-0.197-3.8726,1.093-4.8983,3.1101-0.62583,1.2305-0.33627,2.1332-0.54423,3.4986-0.22568,1.4833-0.0988,2.3109-0.53691,3.8096-0.31825,1.0882-1.1549,2.4341-2.3697,3.5926l-11.03,11.935-42.941,46.445-3.2268-2.9831,43.211-46.737z'/%3E %3Cpath fill='%23fff' d='m429.51,283.04s2.6994,13.372,11.874,33.431c4.665-1.7103,7.4191-2.7991,12.362-2.7991,4.9431,0,7.6971,0.9331,12.362,2.7991,9.1742-20.059,11.874-33.431,11.874-33.431l-24.236-31.177-24.236,31.177z'/%3E %3Cpath d='m456.12,262.41,16.82,21.637s-2.2433,10.52-9.0782,26.354c-2.646-0.6025-4.9158-1.1276-7.7323-1.3195l-0.009-46.671z'/%3E %3Cpath d='m451.38,262.41-16.82,21.637s2.2433,10.52,9.0782,26.354c2.646-0.6025,4.9158-1.1276,7.7323-1.3195l0.009-46.671z'/%3E %3C/g%3E %3Cg fill='%23d52b1e'%3E %3Cpath fill='%23fedf00' d='m503.6,249.25h82.179v82.023h-82.179z'/%3E %3Cpath d='m515.11,249.25h12.253v82.023h-12.253z'/%3E %3Cpath d='m538.59,249.25h12.253v82.023h-12.253z'/%3E %3Cpath d='m562.07,249.25h12.253v82.023h-12.253z'/%3E %3C/g%3E %3Cg fill='%23d52b1e' stroke='%23d52b1e' stroke-width='0.513'%3E %3Cpath fill='%23fedf00' stroke='none' d='m412.97,402.41c0.23327,1.4774,0.75922,4.0119,2.1625,6.6087,1.4771,2.3322,0.93285,2.2689,4.2762,6.0008,1.6456,1.837,4.2137,3.4109,6.2271,4.4948,2.0213,1.0885,3.5169,1.6229,6.8417,2.4952,6.5175,1.7104,11.091,1.817,16.574,1.5984,4.2781-0.1709,7.5443-0.6973,10.249-1.0615,3.8574-0.5189,6.7305-0.8278,11.118-1.0105,2.1333-0.089,4.149-0.1101,6.1421,0,2.4057,0.1326,4.7818,0.5054,7.3085,1.0105,5.442,1.0885,10.962,3.1877,10.962,3.1877l0.0135-85.655-82.193-0.023v58.543s0.16862,2.8599,0.31828,3.8096z'/%3E %3Cpath d='m422.51,417.43,3.8518,2.2412,5.2782,1.8989-0.005-81.527h-9.1264z'/%3E %3Cpath d='m468.17,421.14,0.0113-81.099h-9.1435v82.396s6.2572-0.80203,9.1312-0.98833z'/%3E %3Cpath d='m486.41,340.05h-9.1134v81.381c2.9699,0.3213,6.0236,0.85177,9.1311,1.6825l-0.018-83.064z'/%3E %3Cpath d='m449.92,340.05v83.331c-0.0903,0.01-6.1007,0.31515-9.1733-0.003l0.002-83.314z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fedf00' d='m585.48,402.39c-0.23327,1.4771-0.75921,4.0116-2.1626,6.6084-1.4771,2.3325-0.93285,2.2692-4.2759,6.0009-1.6456,1.8369-4.214,3.4108-6.2271,4.495-2.0216,1.0885-3.5169,1.6226-6.8417,2.4952-6.5178,1.7103-11.091,1.817-16.574,1.5981-4.2778-0.1707-7.544-0.6973-10.249-1.0612-3.8574-0.5189-6.7305-0.8279-11.118-1.0108-2.133-0.089-4.149-0.1096-6.1421,0-2.4057,0.1326-4.7815,0.5054-7.3082,1.0108-5.4423,1.0885-11.033,3.1877-11.033,3.1877l0.0565-85.655,82.193-0.023v58.543s-0.16815,2.8596-0.31826,3.8096z'/%3E %3Cg id='cow'%3E %3Cpath fill='%23d52b1e' d='m524.62,346.91s-0.36638,0.1753-0.59375,0.2813c-0.29828,0.3273-0.44752,0.519-0.78125,0.8125-0.44293,0.3892-0.76881,0.503-1.25,0.8437-0.23045,0.163-0.41928,0.2156-0.59375,0.4375-0.25219,0.3208-0.0791,0.6292-0.25,1-0.18658,0.405-0.36896,0.5965-0.65625,0.9375-0.36612,0.4348-0.64912,0.6098-1.0625,1-0.41817,0.3951-0.58752,0.7265-1.0938,1-0.1339,0.072-0.19832,0.1425-0.34375,0.1875-0.21554,0.067-0.34931-0.011-0.5625,0.062-0.38806,0.1343-0.51024,0.5626-0.78125,0.7188,0.11196,0.2178,0.10686,0.3725,0.21875,0.5937,0.15785,0.3234,0.70512,1.2154,0.8125,1.4375,0.20907,0.3051,0.27011,0.6996,0.53125,0.7813,0.53775,0.1681,0.8586,0.1532,1.3125,0.125,0.79213,0.1818,1.2805,0.1578,2.0312,0.4687,0.61288,0.2539,0.86262,0.575,1.4688,0.8438,0.47418,0.2102,0.77191,0.3394,1.2812,0.4375,0.38665,0.074,0.60802,0.132,1,0.094,0.24961-0.024,0.37681-0.1197,0.625-0.1562,0.0488-0.01,0.0809,0,0.125,0l-0.0312,0.375c-0.005,0,0.005,0.028,0,0.031v0.062h0.0625l2.0625,0.9063c-0.0738,0.1176-0.1515,0.2566-0.1875,0.375-0.0981,0.3205-0.114,0.6886-0.0625,0.8437,0.62922,1.8877,1.1592,3.0684,1.4688,3.1875,0.6154,0.2364,0.80591,0.8649,1.1562,1.5-0.12367,0.1321-0.22734,0.2008-0.34375,0.3125-0.61493,0.5902-1.152,1.0093-1.6562,1.8125-0.74541,1.1879-1.2487,1.2038-0.3125,2.7813,0.54902,0.9247,0.81425,1.0994,1.5312,2.4062,0.36161,0.6591,0.56221,1.1733,0.78125,1.9688,0.20712,0.7519,0.2779,1.1895,0.3125,1.9687l0.96875,0.375,0.65625-0.6562,0.625-1.1875,0.0312-0.9063c-0.23861-0.2026-0.3076-0.4733-0.25-0.7812,0.0695-0.3686,0.51434-0.2913,0.71875-0.625,0.28309-0.4615-0.33152-0.7344-0.65625-1.0938-0.60558-0.6697-1.4305-0.8329-1.625-1.8437-0.0523-0.2732,0.0776-0.4267,0.375-0.7188,0.85519-0.8399,1.1299-0.9736,1.9688-1.8125,0.242,0.142,0.61054,0.1932,0.96875,0.125,0.27914-0.053,0.52914,0.1252,1.4062,0.375,0.60951,0.1736,0.8732,0.086,1.2188,0.031l0.375-0.094c0.0504,0.2114,0.1115,0.4157,0.125,0.6875,0.0531,1.0604-0.15471,2.9947,0.15625,3.5,0.13118,0.2131,0.18605,0.3315,0.28125,0.5625,0.0986,0.2406,0.21375,0.3963,0.21875,0.6563,0.0112,0.6956,0.0471,1.1405,0,1.875-0.0441,0.6911-0.10304,1.042-0.21875,1.75-0.074,0.4511-0.16594,0.7136-0.4375,1.0625-0.28336,0.3639-0.59506,0.4174-0.96875,0.6875l-0.0937,1,1.125,0.4687,1.2812,0.3125,0.6875-0.2812c0-0.2544,0.0399-0.399,0.15625-0.625,0.12748-0.2465,0.23181-0.4386,0.46875-0.5313,0.36244-0.1423,0.75947,0.1292,0.90625-0.094,0.15946-0.242,0.0594-0.3375,0.0312-0.75-0.0453-0.6621-0.18355-0.9888-0.28125-1.6563-0.16416-1.1107-0.20985-1.6865-0.15625-2.75,0.0311-0.6165,0.0383-0.9563,0.15625-1.5625,0.17195-0.8824,0.48556-1.3112,0.6875-2.1875,0.22541-0.9775,0.2647-1.6062,0.375-2.4687,3.1694,0.4528,5.8074,0.3972,9.3438-0.375,0.16911-0.037,0.75-0.25,0.75-0.25,0.79947,0.6889,1.706,1.2642,2.7188,1.625-0.006,0.1016-0.0158,0.8456,0,0.9687,0.0365,0.2876-0.0414,0.4813,0.125,0.7188,0.10551,0.1506,0.19603,0.2396,0.375,0.2812,0.26255,0.061,0.45476,0.023,0.65625-0.1562,0.22633-0.2015,0.1843-0.4545,0.25-0.75,0.032-0.1407,0.007-0.5644,0-0.6875,0.36667,0.055,0.49117,0.062,0.875,0.062,0.35765,0,0.52944,0.014,0.875-0.031,0.005,0.081,0.0199,0.3689,0.0312,0.4688,0.0268,0.2443-0.0757,0.4347,0.0312,0.6562,0.11087,0.2296,0.24955,0.3592,0.5,0.4063,0.20599,0.039,0.35363,0.018,0.53125-0.094,0.29551-0.1851,0.2632-0.4984,0.3125-0.8437,0.0146-0.11,0.0113-0.6919,0-0.7813,0.21161-0.067,0.82729-0.2917,1.0312-0.375-0.005,0.2426-0.0388,0.5168-0.0937,0.8125-0.0699,0.376-0.11965,0.5785-0.25,0.9375-0.20598,0.5676-0.44159,0.8561-0.75,1.375-0.37681,0.6338-0.57286,0.9854-1.0312,1.5625-0.21105,0.266-0.35764,0.3856-0.5625,0.6563-0.25522,0.3374-0.34218,0.5663-0.59375,0.9062-0.32418,0.4382-0.51034,0.724-0.9375,1.0625-0.69364,0.5499-1.1499,0.1099-2.0938,0.8438l-0.21875,1.0312,1.4375,0.5313,1.2812,0.25,0.4375-0.25c-0.0118-0.3011,0.0319-0.5139,0.21875-0.75,0.21357-0.2698,0.44159-0.3511,0.78125-0.4063,0.36132-0.059,0.74677,0.034,1.0312-0.2187,0.35006-0.3109,0.34867-0.9141,0.625-1.4688,0.85827-1.7235,1.6208-2.5628,3-3.9062,0.6126-0.5966,1.1374-0.7579,1.6562-1.4375,0.24651-0.3225,0.51995-0.4692,0.53125-0.875,0.008-0.2828-0.14395-0.4151-0.21875-0.6875-0.10357-0.3771-0.1875-1-0.1875-1,1.5218,0.7446,0.97085,0.6462,1.25,1.4062,0.22555,0.6149-0.0325,1.0395,0.0625,1.6875,0.11114,0.7559,0.46615,1.1139,0.53125,1.875,0.0777,0.9048-0.14299,1.4205-0.3125,2.3125-0.14886,0.7846-0.12995,1.2768-0.46875,2-0.32248,0.6889-0.57094,1.0769-1.1562,1.5625-0.21105,0.175-0.36836,0.2503-0.59375,0.4063l-0.125,1.0312,1.125,0.375,1.625,0.4375,0.375-0.3437c0.16348-0.6545-0.0547-1.6165,0.40625-1.6875,0.40606-0.062,0.69275,0.0001,0.78125-0.3125,0.0367-0.1314,0.0589-0.3259,0.0937-0.625,0.22118-1.8859,0.42149-3.6454,0.625-4.5,0.23012-0.9677,0.21445-1.178,0.40625-1.9063,0.17532-0.6641-0.0853-0.2824,0.40625-1.6875,0.73418-2.0972-0.20816-2.375-1.0625-3.6562-0.46205-0.6931-0.6218-0.9442-0.6875-1.5-0.097-0.8169,0.1647-1.4947,0.125-2.75-0.041-1.3198-0.0225-2.1591,0-2.875,0.11538-0.053,0.22175-0.1207,0.34375-0.1875,1.1706-0.6427,1.6363-0.8361,2.375-2.4688,0.22389-0.4955,0.3195-0.9937,0.3125-1.4687-0.005-0.3321-0.0648-0.6522-0.0937-1.0313-0.0304-0.399-0.19094-0.6375-0.3125-0.9375-0.12945-0.3182-0.32443-0.5586-0.5625-0.8437-0.77243-0.9247-1.7789-1.1319-2.7188-1.4688-1.4835-0.5317-2.505-0.4346-4.125-0.5625-1.6721-0.1321-2.6064-0.1577-4.2812-0.062-2.0067,0.1143-3.1279,0.519-5.125,0.75-1.9158,0.2217-2.9778,0.3701-4.9062,0.4063-2.2602,0.042-4.4207-0.4606-5.7812-0.3438-2.451,0.21-2.493,0.7612-6.1875,1.0625-1.927,0.1574-3.8438,0.1875-3.8438,0.1875l-2.1562-0.6875c0.85659-0.3061,1.0661-0.4881,1.4688-1.0312,0.27183-0.3661,0.23326-0.6784,0.5625-1.0625,0.26677-0.3118,0.443-0.6224,0.78125-0.9688-0.3101-0.2491-0.64289-0.3763-0.9375-0.4375-0.36386-0.076-0.57336-0.042-0.9375,0-0.49414,0.056-0.77245,0.1243-1.2188,0.3438-0.35934,0.177-0.62403,0.3574-0.84375,0.5937,0,0-1.2856-0.8287-2.1875-1.2187-1.1186-0.4843-1.6006-0.7117-3-0.9063zm1.9688,11.906h0.0625c-0.0123,0.01-0.019,0.022-0.0312,0.031l-0.0312-0.031z'/%3E %3Cg fill='none' stroke='%23fedf00' stroke-width='0.987' stroke-linecap='round'%3E %3Cpath d='m568.77,359.52-0.76315,0.244c-0.86699,0.4021-1.5778,0.4178-2.6001,0.4961-2.6437,0.2021-4.2714-1.0572-6.9976-0.8476-1.4039,0.108-2.0252,1.1909-3.4598,1.5483-0.65256,0.1625-1.0313,0.2254-1.7016,0.2819l0.51272-1.0333s-1.284,0.2617-2.1153,0.2634c-0.59629,0.001-0.93595-0.028-1.5235-0.1301l1.0181-0.9506s-0.81351-0.1319-1.2936-0.3351c-0.44265-0.1871-0.68353-0.3301-1.06-0.6292,0.66327-0.1139,1.0358-0.1921,1.6893-0.3535,1.5561-0.3849,2.0398-1.147,3.8909-1.3254,1.149-0.1112,3.0321-0.046,7.6428,0.7168,3.0357,0.502,4.3822,0.267,5.5354-0.2572,0.7609-0.3459,1.0108-1.0108,1.1031-1.7883,0.0925-0.7764-0.40408-1.4045-0.87376-1.81-0.12268-0.106-0.44404-0.3351-1.1129-0.363'/%3E %3Cpath fill='%23fcd900' stroke-width='0.513' stroke-linecap='butt' d='m524.8,350.61c-0.53042-0.066-0.88442,0.011-1.3397,0.2915-0.48036,0.2958-0.5417,0.6965-0.88809,1.142,0.44517,0.099,0.69843,0.3607,1.1419,0.2538,0.34668-0.084,0.52677-0.2386,0.76117-0.5076,0.31546-0.3625,0.4314-0.6754,0.42746-1.156l-0.10266-0.024z'/%3E %3Cpath d='m536.04,363.79s0.26396,0.4801,0.40661,0.7992c0.24793,0.5552,0.37624,0.8785,0.52426,1.468,0.20036,0.7987,0.11369,1.2838,0.24088,2.0973,0.0225,0.1432,0.0498,0.2634,0.0767,0.3768l-0.0511,1.1287'/%3E %3Cpath d='m544.04,362.71s-0.21881,0.8122-0.354,1.3325c-0.35201,1.3538-0.67648,2.0871-0.94381,3.4601-0.0448,0.2302-0.0777,0.4429-0.10356,0.6444'/%3E %3Cpath d='m531.78,364.17c0.79018,0.1756,0.54424,3.3602,1.7888,4.0904'/%3E %3Cpath stroke-linecap='butt' d='m560.12,369.78,0.3844-0.249c1.0139-0.4146,1.9251-1.0271,2.6857-1.7897'/%3E %3Cpath d='m552.38,368.02c0.002-0.0005,0.005-0.0009,0.007,0,3.533-0.883,5.8849-2.6476,7.5786-2.8688'/%3E %3Cpath d='m555.97,363.61c0.29885-0.011,0.58475-0.033,0.82928-0.068,1.4681-0.2096,1.7042,0.6869,2.7262,1.2584,1.8564,1.0381,2.0973,2.307,4.299,3.3555,0.11638,0.055,0.22331,0.1069,0.32135,0.1551l0.84729,0.4288'/%3E %3Cpath fill='%23fcd900' stroke-width='0.513' stroke-linecap='butt' d='m517.7,354.53c0.26819,0.067,0.43196,0.08,0.70745,0.054,0.33148-0.031,0.48373-0.2378,0.81635-0.2488,0.27097-0.01,0.46261-0.032,0.68407,0.1245,0.14092,0.099,0.1999,0.1894,0.27999,0.3419,0.0871,0.1668,0.163,0.2823,0.1245,0.4666-0.0595,0.2842-0.32417,0.4173-0.61431,0.4198-0.23721,0-0.43391-0.062-0.54422-0.2721-0.0707-0.1348-0.0815-0.2425-0.0388-0.3886-0.28393,0.1067-0.48964,0.1108-0.7775,0.016-0.30308-0.1002-0.47473-0.2386-0.63738-0.513z'/%3E %3C/g%3E %3Cg fill='%230065bd'%3E %3Cpath d='m525.13,364.17c-0.79692-0.2375-1.9658-0.8259-1.9658-0.8259,0.32277-0.251,0.58672-0.2651,0.86276-0.5547,0.38919-0.4083,0.37287-0.7885,0.59264-1.3192,0.21566-0.52,0.18459-0.9545,0.67142-1.3428,0.28956-0.231,0.76232-0.269,1.1177-0.1652,0.35287,0.1127,0.75921,0.4012,0.84843,0.7662,0.13732,0.5611-0.15984,0.8853-0.24595,1.454-0.0858,0.5679-0.29295,0.894-0.19473,1.4599,0.0651,0.3743,0.22625,0.5186,0.35344,0.9072,0,0-1.2643-0.1488-2.0399-0.3796z'/%3E %3Cpath d='m524.14,365.12c-0.007-0.3473,0.2707-0.634,0.61795-0.6399,0.34754-0.01,0.634,0.2707,0.64019,0.6179,0.007,0.3475-0.2707,0.634-0.61795,0.6399-0.34754,0.01-0.634-0.2704-0.64019-0.6179z'/%3E %3Cpath d='m522.38,348.61s-0.0898-0.06-0.14362-0.1036c-0.38326-0.3098-0.41985-0.6531-0.60164-1.111-0.17221-0.4333-0.25692-0.6908-0.3146-1.1534-0.0506-0.4058,0-0.6396,0-1.0485,0-0.3681,0.0396-0.5777,0-0.9435-0.0405-0.3751-0.0306-0.6121-0.21003-0.9438-0.097-0.1801-0.39453-0.3374-0.31435-0.4196,0.0946-0.097,0.25694-0.02,0.4193,0,0.39987,0.048,0.63089,0.1657,0.94381,0.4196,0.37707,0.3058,0.52651,0.5709,0.67171,1.0485,0.16681,0.5481,0.24847,0.8982,0.40774,1.468,0.0826,0.2955,0.12877,0.4688,0.28365,0.7339,0.16096,0.2758,0.31967,0.3838,0.52425,0.6292l-0.0113,0.023c-0.29828,0.327-0.44378,0.5394-0.77666,0.8338-0.30504,0.2699-0.55998,0.4033-0.84674,0.5729l-0.0324-0.01z'/%3E %3Cpath d='m525.98,359.25,2.2309,1.0311c1.1481-0.6348,2.4732-1.9239,3.4964-3.9191,0.88079-1.7176,1.0206-2.6505,1.3639-4.3127l-1.7891-0.5817-0.35709,0.073c-0.55239,1.7233-0.69253,2.704-1.6178,4.1926-0.80226,1.2911-1.7185,2.3049-2.6491,3.0338l-0.67817,0.4834z'/%3E %3Cpath d='m530.92,377.37c0.35963-0.4928,0.51327-0.8107,0.92214-1.2635,0.45616-0.5051,0.80003-0.7021,1.3116-1.151,0.15556,0.016,0.33544-0.011,0.4812,0.072-0.0284,0.5448-0.0563,0.9487-0.1801,1.5407-0.10041,0.4804-0.1864,0.746-0.34698,1.2097-0.13462,0.3881-0.15848,0.6391-0.38973,0.979-0.1542,0.2266-0.29013,0.3158-0.47585,0.5178-0.51046-0.7418-1.3302-1.2967-1.3223-1.9053z'/%3E %3Cpath d='m563.93,379.22c0.57264,0.2103,0.92075,0.2702,1.4686,0.5384,0.6112,0.2994,0.89541,0.5757,1.4678,0.9438,0.0268,0.154,0.10379,0.3188,0.063,0.4823-0.53155,0.1229-0.92749,0.2076-1.5308,0.2516-0.48935,0.036-0.76849,0.027-1.2584,0-0.41028-0.023-0.65818,0.024-1.0485-0.1047-0.26058-0.086-0.38383-0.192-0.62891-0.3146,0.57236-0.6954,0.87992-1.6364,1.4672-1.7968z'/%3E %3Cpath d='m554.17,377.18c0.57265,0.21,0.92047,0.2699,1.4683,0.538,0.6112,0.2994,0.89571,0.5758,1.4681,0.9438,0.0263,0.154,0.10378,0.3189,0.063,0.4826-0.53157,0.1227-0.92749,0.2074-1.5311,0.2513-0.48934,0.036-0.76821,0.027-1.2581,0-0.41029-0.023-0.65821,0.024-1.0485-0.1046-0.26058-0.086-0.38383-0.1918-0.62921-0.3146,0.57263-0.6954,0.87992-1.6364,1.4675-1.7965z'/%3E %3Cpath d='m536.83,379.31c0.57292,0.21,0.92073,0.2701,1.4686,0.5383,0.6112,0.2991,0.89571,0.5758,1.4681,0.9438,0.0266,0.154,0.10378,0.3189,0.063,0.4824-0.53157,0.1227-0.92749,0.2075-1.5311,0.2515-0.48934,0.036-0.76821,0.027-1.2581,0-0.41028-0.022-0.65821,0.024-1.0485-0.1049-0.26058-0.086-0.38383-0.1915-0.62922-0.3143,0.57237-0.6953,0.87993-1.6363,1.4672-1.7967z'/%3E %3Cpath d='m527.85,349.51c-0.61259-0.2781-1.0493-1.0446-0.66072-1.5939,0.15555-0.2197,0.41309-0.1736,0.56617-0.3951,0.18866-0.2726,0.14161-0.5076,0.13597-0.8388-0.007-0.3771-0.14385-0.5727-0.20957-0.9438-0.072-0.4058-0.13913-0.6363-0.13598-1.0485,0.005-0.6281-0.0378-1.0756,0.34555-1.5728,0.24454-0.3171,0.66044-0.5923,0.82421-0.6123,0.14746,0.1364-0.0565,0.502-0.0322,0.822,0.0353,0.462,0.13056,0.7173,0.28758,1.1534,0.20239,0.5625,0.47867,0.8085,0.70267,1.3631,0.20847,0.5156,0.39986,0.8074,0.41956,1.3631,0.0158,0.4567-0.0241,0.7356-0.20959,1.1535-0.16434,0.3695-0.2997,0.5791-0.60951,0.8388-0.26931,0.2252-0.45841,0.3251-0.79637,0.4193-0.24735,0.02-0.40157-0.01-0.62781-0.108z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23cow' y='36.590756'/%3E %3C/g%3E %3Cg fill='none' stroke='%23703d29' stroke-width='0.797'%3E %3Cpath d='m412.66,249.25h82.179v82.023h-82.179z'/%3E %3Cpath d='m503.6,249.25h82.179v82.023h-82.179z'/%3E %3Cpath d='m412.97,402.41c0.23327,1.4774,0.75922,4.0119,2.1625,6.6087,1.4771,2.3322,0.93285,2.2689,4.2762,6.0008,1.6456,1.837,4.2137,3.4109,6.2271,4.4948,2.0213,1.0885,3.5169,1.6229,6.8417,2.4952,6.5175,1.7104,11.091,1.817,16.574,1.5984,4.2781-0.1709,7.5443-0.6973,10.249-1.0615,3.8574-0.5189,6.7305-0.8278,11.118-1.0105,2.1333-0.089,4.149-0.1101,6.1421,0,2.4057,0.1326,4.7818,0.5054,7.3085,1.0105,5.442,1.0885,10.962,3.1877,10.962,3.1877l0.0135-85.655-82.193-0.023v58.543s0.16862,2.8599,0.31828,3.8096z'/%3E %3Cpath d='m585.48,402.39c-0.23327,1.4771-0.75921,4.0116-2.1626,6.6084-1.4771,2.3325-0.93285,2.2692-4.2759,6.0009-1.6456,1.8369-4.214,3.4108-6.2271,4.495-2.0216,1.0885-3.5169,1.6226-6.8417,2.4952-6.5178,1.7103-11.091,1.817-16.574,1.5981-4.2778-0.1707-7.544-0.6973-10.249-1.0612-3.8574-0.5189-6.7305-0.8279-11.118-1.0108-2.133-0.089-4.149-0.1096-6.1421,0-2.4057,0.1326-4.7815,0.5054-7.3082,1.0108-5.4423,1.0885-11.033,3.1877-11.033,3.1877l0.0565-85.655,82.193-0.023v58.543s-0.16815,2.8596-0.31826,3.8096z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 12 6'%3E %3Crect width='12' height='2' fill='%2300732f' id='green'/%3E %3Crect width='12' height='2' y='2' fill='%23fff'/%3E %3Crect width='12' height='2' y='4'/%3E %3Crect width='3' height='6' fill='%23f00' id='red'/%3E%3C/svg%3E"

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg width='600' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' height='400'%3E %3Crect width='600' fill='%23090' height='400'/%3E %3Crect width='400' fill='%23bf0000' height='400'/%3E %3Crect width='200' height='400'/%3E %3Cg stroke-width='.5' stroke='%23bd6b00' fill-rule='evenodd' fill='%23fff'%3E %3Cpath d='m319.5 225.84 8.354 0.001c0.0311 3.1574 1.8815 6.5489 4.4798 8.4926h-16.008c2.5051-2.271 3.1897-4.9625 3.1741-8.4938z'/%3E %3Cpath stroke='none' d='m266.71 178.53 4.5742 5.0402 56.934 0.0932 4.6674-5.0402-14.56-0.18636-7.0937-4.947-22.868-0.0932-6.6266 5.1333h-15.027z'/%3E %3Cpath d='m290.02 172.74 19.66-0.0203c2.6616-1.4073 3.4919-5.9014 3.4788-8.4161-0.037-7.4282-5.2325-10.991-10.447-11.18-0.78128-0.0394-1.688-0.64749-1.8947-1.3595-0.51368-1.6128-0.38108-2.6411-0.94375-2.5838-0.50055-0.007-0.35361 0.93999-0.79921 2.4524-0.24489 0.75261-1.0907 1.4945-1.9341 1.5375-6.4904 0.32374-10.676 5.0616-10.513 11.134 0.1099 4.0151 0.577 6.4127 3.3927 8.4364z'/%3E %3Cpath stroke='none' d='m257.66 242.83h84.469l-7.5608-6.1607h-69.348l-7.5596 6.1607z'/%3E %3Cpath d='m296.39 219.69 1.5399 4.6196h3.4991l-2.799-4.6208-2.2399 0.001zm-1.9592 4.6196 0.88641 4.573 4.1059 0.0466-1.4933-4.6208-3.4991 0.001zm6.9527 0.0466 2.8468 4.5264h5.8334l-4.573-4.5742-4.1071 0.0478zm-34.441 10.36c3.0953-2.8778 5.0712-5.3352 5.0867-8.8665h7.5596c0.0155 1.9759 0.73111 3.1574 1.8206 3.0797l7.654-0.0466-0.0466-4.5264h-5.5538l-0.001-24.688c-0.2019-8.7267 10.609-13.813 15.028-13.767l-26.275-0.0466v-0.79324h55.255l0.0466 0.79324-26.647 0.0466c7.9025 0.0155 15.524 7.4987 15.587 13.815v6.9993h-1.0274l-0.0466-6.9061c0-6.9073-8.6993-13.363-15.681-13.161-6.0364 0.17322-15.4 5.9277-15.307 13.115v2.1467l14.327 0.0932-0.13978 2.4729 2.2495 1.4359 4.487 1.43-0.0657 3.7093 3.2136 0.94734 0.0275 3.7057 3.8551 1.6546v3.8359l2.4454 1.5064-0.1123 3.8957 3.3139 2.3331h-7.8403l4.9004 5.4606h-7.2335l-3.5946-5.4606h-4.7594l2.1467 5.4128-5.0855-0.0466-1.2149-5.3662h-6.2061l0.0466 5.7856-22.214 0.001zm22.168-14.981v4.573h5.3209l-1.0752-4.573h-4.2457z'/%3E %3Crect y='211.66' x='289.39' height='7.6068' fill='none' width='3.3134'/%3E %3Cpath d='m284.71 219.8h3.2339l-0.0203-5.5968c-0.0418-2.4329 2.142-4.8854 3.1873-4.967 1.1588-0.0439 2.8671 2.2965 2.9244 4.7757l0.0466 5.8064 3.431-0.007v-14.411l-12.803 0.0682v14.332z' fill='none'/%3E %3Crect y='223.14' x='310.3' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='217.77' x='307.92' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='212.4' x='304.05' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='207.88' x='300.74' height='3.1268' fill='none' width='4.0135'/%3E %3Cpath d='m298.08 219.82 4.1059 0.13977 7.3266 6.4868v-3.8264l-2.4729-1.7728v-3.0344l-3.5934-2.0524v-3.2673l-3.5002-1.166v-4.4344l-1.774-1.4467-0.092 14.374z' fill='none'/%3E %3Crect y='210.35' x='315.43' height='7.0468' width='.98004'/%3E %3Cg id='c'%3E %3Cpath d='m257.32 186.53c-1.234-1.9819-2.7118 2.7488-7.7878 6.2706-2.363 1.608-4.0092 5.8931-4.0247 8.7124-0.0777 1.9365 0.21503 3.8682-0.001 5.7414-0.13619 1.1851-1.3714 3.8156-0.52683 4.4882 2.234 1.6605 5.1261 5.4308 6.4677 6.7317 1.16 1.0166 2.1647-5.248 3.0355-8.0518 0.93301-3.0045 0.51489-6.5955 3.1024-9.3718 1.8338-1.8744 6.4594-3.7189 5.9397-4.5539l-6.2049-9.9668z'/%3E %3Cpath d='m257.06 201.88c-0.38526-0.88581-0.95754-1.8017-1.6562-2.5938-0.69871-0.79204-1.5248-1.4569-2.4375-1.7812-0.88164-0.32494-1.7792-0.75131-2.4062-1.5312-0.31351-0.38997-0.58408-0.88198-0.71875-1.4688-0.12477-0.54363-0.12348-1.2104-0.0312-1.9688-0.10986 0.0798-0.16783 0.17131-0.28125 0.25-2.363 1.608-4.0157 5.8994-4.0312 8.7188-0.0312 0.77881-0.0314 1.5387 0 2.3125 0.17489 0.48532 0.34357 0.95597 0.59375 1.25 0.32596 0.3831 0.71323 0.63629 1.125 0.8125 0.82354 0.35241 1.7746 0.42507 2.6562 0.75 0.9127 0.32434 1.8518 1.058 2.6562 1.9375 0.76683 0.83843 1.3575 1.8005 1.75 2.6562 0.0663-0.2425 0.15395-0.60389 0.21875-0.8125 0.84505-2.7212 0.69713-5.8888 2.5625-8.5312z' fill='%23bf0000'/%3E %3Cpath d='m249.82 192.39c-0.48382 3.3557 1.3846 4.4727 3.1478 5.1226 1.8254 0.64868 3.3223 2.6067 4.0928 4.3783' fill='none'/%3E %3Cpath d='m245.3 203.44c0.77054 2.8934 2.7978 2.5314 4.5611 3.1813 1.8254 0.64868 3.7452 2.9567 4.5157 4.7283' fill='none'/%3E %3Cpath d='m255.61 184.48 0.92464-0.59373 17.752 29.898-0.92345 0.59373-17.753-29.898z'/%3E %3Cpath d='m257.52 183.29a2.0459 2.0459 0 1 1 -4.0919 0 2.0459 2.0459 0 1 1 4.0919 0z'/%3E %3Crect y='159.27' x='272.7' height='1.6499' width='7.1937'/%3E %3Crect y='162.4' x='272.7' height='13.784' width='7.1937'/%3E %3Cpath d='m272.26 157.39 7.9801 0.0466c0.3118-2.7058-2.3893-5.6291-3.9662-5.5992-1.559 0.0753-4.0761 2.9555-4.014 5.5526z'/%3E %3Cpath stroke='none' d='m292.62 155.76c-1.5214 0.63988-2.6876 2.3773-3.4062 4.375-0.71863 1.9977-0.99146 4.2674-0.65625 6.0938v0.0312c0.12767 0.63033 0.30087 1.0828 0.5 1.4062s0.42233 0.51338 0.6875 0.5625c0.26517 0.0491 0.51389-0.0929 0.65625-0.3125 0.14236-0.21963 0.21213-0.50902 0.1875-0.84375-0.14424-1.8787-0.13498-3.7323 0.3125-5.4062 0.44748-1.674 1.3381-3.1644 2.9688-4.375 0.29479-0.21603 0.46415-0.46321 0.5-0.71875 0.0358-0.25554-0.0995-0.47402-0.28125-0.625-0.36346-0.30196-0.93739-0.40779-1.4688-0.1875zm0.15625 0.4375c0.37058-0.15363 0.84219-0.0633 1.0312 0.0937 0.0945 0.0785 0.10575 0.13319 0.0937 0.21875-0.012 0.0856-0.0775 0.23402-0.3125 0.40625-1.7131 1.2718-2.6562 2.8713-3.125 4.625s-0.45856 3.6602-0.3125 5.5625c0.019 0.2578-0.0553 0.45499-0.125 0.5625s-0.10683 0.13994-0.1875 0.125c-0.0807-0.0149-0.24759-0.11733-0.40625-0.375s-0.31728-0.65644-0.4375-1.25c-0.31467-1.7145-0.0372-3.9474 0.65625-5.875 0.69341-1.9276 1.8032-3.5378 3.125-4.0938z' fill='%23bd6b00'/%3E %3Cpath stroke='none' d='m295.19 157.73c-1.5192 0.63893-2.5013 2.292-3.0312 4.1875-0.52999 1.8955-0.61336 4.0655-0.28125 5.875 0.26002 1.2838 0.9344 1.9611 1.5938 2.0625 0.32968 0.0507 0.64783-0.0795 0.84375-0.34375 0.19592-0.26429 0.26001-0.61887 0.15625-1.0625-0.37233-1.4981-0.51562-3.366-0.25-5.0625s0.94019-3.2115 2.2188-4.125c0.29553-0.21508 0.46393-0.46314 0.5-0.71875 0.0361-0.25561-0.0995-0.50509-0.28125-0.65625-0.36357-0.30232-0.93709-0.37666-1.4688-0.15625zm0.1875 0.4375c0.37028-0.15351 0.81045-0.0639 1 0.0937 0.0948 0.0788 0.13702 0.13359 0.125 0.21875-0.012 0.0852-0.10826 0.23486-0.34375 0.40625-1.4117 1.0086-2.1286 2.6642-2.4062 4.4375-0.27764 1.7733-0.105 3.6646 0.28125 5.2188 0.0826 0.35318 0.00066 0.59139-0.0937 0.71875-0.0944 0.12736-0.21432 0.18576-0.40625 0.15625-0.38385-0.059-0.98301-0.5548-1.2188-1.7188-0.31777-1.7314-0.22749-3.868 0.28125-5.6875s1.4572-3.2869 2.7812-3.8438z' fill='%23bd6b00'/%3E %3Crect y='187.39' x='272.31' height='11.107' width='8.0268'/%3E %3Crect y='204.85' x='272.78' height='2.3334' width='7.7468'/%3E %3Crect y='208.95' x='272.59' height='8.6802' width='7.9335'/%3E %3Crect y='219.41' x='272.03' height='4.8534' width='8.6802'/%3E %3Cpath d='m273.1 202.76h6.9946l1.387-2.3092h-9.6359l1.2544 2.3092z'/%3E %3Cpath d='m282.53 194.25 0.0657-6.0711h4.8179c-1.8923 1.5614-3.652 3.4537-4.8836 6.0711z'/%3E %3Cpath d='m273.56 196.74c0.0478 1.2986 1.5184 0.71916 1.5184 0.0657 0-2.0034 0.0263-4.1693-0.0538-5.5873-0.01-1.0453 2.4908-0.78368 2.4765-0.13978 0.01 1.6916 0.0287 4.0116 0.0382 5.9911-0.0179 0.96407 1.6151 0.88045 1.5924 0-0.01-2.2113-0.0108-5.4248 0-7.0519 0.0143-2.0954-5.5013-2.05-5.5443-0.0466 0.002 1.645-0.0299 4.5898-0.0275 6.7688z' fill='none'/%3E %3Crect y='209.98' x='273.57' height='7.0935' fill='none' width='5.6935'/%3E %3Crect y='212.92' x='277.21' height='1.1667' width='2.0067'/%3E %3Crect y='212.92' x='273.71' height='1.1667' width='1.96'/%3E %3Crect y='210.07' x='275.67' height='2.8934' width='1.54'/%3E %3Crect y='214.04' x='275.67' height='3.0801' width='1.54'/%3E %3Cpath d='m243.99 138.97c0.356 5.567-1.3714 8.6228-4.3198 8.1581-0.81235-3.0881 1.0357-5.1596 4.3198-8.1581z'/%3E %3Cpath d='m237.52 151.31c-2.621-1.3332-0.72992-11.513 0.27596-15.78 0.74425 5.4965 1.9891 13.309-0.27596 15.78z'/%3E %3Cpath d='m238.45 151.79c4.4058 1.5327 7.8941-3.2124 9.0732-8.7077-3.6364 5.0186-9.5546 5.0246-9.0732 8.7077z'/%3E %3Cpath d='m235.11 156.93c-3.4453-0.9103-1.3702-11.71-0.74425-16.03 0.75739 4.4619 3.1323 14.552 0.74425 16.03z'/%3E %3Cpath d='m236.29 156.59c0.19233-3.7248 3.9052-2.6485 6.4677-4.6364-0.41812 1.8612-1.9938 5.1596-6.4677 4.6364z'/%3E %3Cpath d='m232.07 161.58c-3.4142-0.92106-1.3619-12.544-1.5554-17.329 1.0011 4.1346 4.1705 16.209 1.5554 17.329z'/%3E %3Cpath d='m233.66 161.08c2.7966 0.90911 6.5012-0.90792 6.7927-4.2386-2.4084 1.6343-6.2539 0.38467-6.7927 4.2386z'/%3E %3Cpath d='m229.52 166.71c-3.2649 0.26043-1.8039-9.6383-1.8015-18.857 1.1994 8.6169 4.4667 16.505 1.8015 18.857z'/%3E %3Cpath d='m230.65 166.26c2.2053 1.1062 6.1559-0.66182 7.2837-4.3867-3.9841 1.7322-6.6481 0.0394-7.2837 4.3867z'/%3E %3Cpath d='m256.28 144.13c-0.58059 4.8287-2.5541 7.6385-5.5025 7.1738-0.81235-3.0881 1.5781-5.0616 5.5025-7.1738z'/%3E %3Cpath d='m248.48 156.52c4.898 0.69527 6.6624-3.0642 9.9596-7.8702-4.6208 3.3438-10.146 4.039-9.9596 7.8702z'/%3E %3Cpath d='m247.09 155.97c-2.67-3.204-0.0896-7.2275 1.9508-10.657-0.43842 5.1023 1.2998 7.9407-1.9508 10.657z'/%3E %3Cpath d='m245.91 161.26c-0.30105-3.1335 5.0378-3.83 7.4521-5.5718-0.81235 1.811-2.0428 6.6863-7.4521 5.5718z'/%3E %3Cpath d='m244.79 161.33c-3.6914-0.41812-2.1587-6.6863 0.4874-10.17-1.1146 4.8072 1.9496 8.1498-0.4874 10.17z'/%3E %3Cpath d='m242.01 166.55c-4.2015-1.8576-1.5088-7.1272 0.0705-10.238-0.67377 4.0856 2.6927 7.1964-0.0705 10.238z'/%3E %3Cpath d='m242.84 166.06c2.2053 2.879 6.5012-0.85894 7.3828-5.2241-3.738 3.112-6.5 2.6007-7.3828 5.2241z'/%3E %3Cpath d='m233.24 186.32c-0.43166-4.2875 2.7929-12.084 0.50438-16.24-0.31201-0.57103 0.68503-2.087 1.329-1.1672 1.0064 1.4682 2.041 5.6518 2.4738 4.1071 0.45863-1.6796 0.52901-4.6507 2.0164-5.2277 0.94895-0.33808 2.2908-0.55909 1.9249 0.9342-0.36362 1.4359-1.1777 3.419-0.27565 3.5469 0.52315 0.0776 2.0304-1.9544 3.2996-2.8934 1.0228-0.83743 2.5489 0.47308 1.0533 1.7262-4.8608 4.0367-9.5704 5.8537-12.326 15.214z'/%3E %3Cpath d='m224.51 250.85c-0.57042-0.10939-1.3518-0.30325-0.64081 0.58385 5.6789 6.9961 7.3221 8.924 15.603 7.9397 8.3647-1.1012 10.357-3.3637 16.214-6.6504 3.1284-1.8351 7.7026-2.2426 11.17-1.1055 1.6142 0.52834 2.5906 0.56022 1.4336-0.59826-1.1575-1.1569-2.5249-2.7312-3.9485-3.8153-3.1181-2.3942-8.4069-3.4322-12.723-2.6616-6.1044 0.95734-11.148 4.8442-17.176 6.3123-3.1669 0.72294-6.6407 0.61388-9.9317-0.005z'/%3E %3Cpath d='m272.3 263.35c1.056 0.13141 1.725 2.1766 2.2447 0.79204 0.88164-2.2423 0.26401-4.0259-0.72633-3.8288-1.1696 0.3118-3.1478 2.934-1.5184 3.0368z'/%3E %3Cpath stroke='none' d='m220.6 182.92c-1.2149-1.2687-0.86372-1.7537 0.933-1.774 1.4252-0.0896 4.2493 0.87328 5.3209 0.0932 0.98198-0.71319 0.59134-3.738 1.0274-5.1333 0.18994-0.77771 0.7347-1.9986 1.9592-0.0932 3.6221 5.8047 8.1462 12.773 10.08 19.6 1.0572 3.8264 0.0621 9.7996-3.4537 13.814 0.12425-3.4226-1.1516-5.7247-2.707-8.587-1.921-3.7619-9.0565-13.951-13.16-17.919z'/%3E %3Cpath d='m235.53 213.44c3.9829 0.0191 4.6674-5.3197 4.6674-6.813-1.9604 0.37272-5.4141 3.64-4.6674 6.813z'/%3E %3Cpath d='m269.95 265.26c2.8326 0.64461 2.7937-6.1781-0.0995-9.0701 1.274 4.3824-2.1286 8.3884 0.0995 9.0701z'/%3E %3Cpath d='m268.85 265.2c0.18688 3.2427-7.9586-0.42377-10.052-2.9462 4.8125 2.0445 9.8145 0.35216 10.052 2.9462z'/%3E %3Cpath d='m265.28 260.57c0.29129 3.1414-7.0638 0.37929-9.2378-2.074 4.83 1.5602 8.9164-0.51099 9.2378 2.074z'/%3E %3Cpath d='m266.63 261.01c2.8326 0.64461 2.3737-6.412-0.37932-8.8369 1.3211 4.7091-1.8488 8.1552 0.37932 8.8369z'/%3E %3Cpath d='m263.65 256.72c2.8326 0.64461 1.207-5.4312-0.89265-7.8575 0.34096 4.4298-1.055 7.5021 0.89265 7.8575z'/%3E %3Cpath d='m262.15 256.7c0.29185 3.2349-5.4301 0.75147-7.6509-2.3088 4.783 1.561 7.3296-0.27617 7.6509 2.3088z'/%3E %3Cpath d='m260.59 254.24c1.8558-1.3343-0.11294-4.8633-3.645-4.6447 0.34557 2.1312 1.5659 5.88 3.645 4.6447z'/%3E %3Cpath d='m274.54 268.87c0.18688 3.2427-7.9595 1.6298-10.519-1.8255 5.1387 0.97109 10.281-0.76847 10.519 1.8255z'/%3E %3Cpath d='m242.18 263.07c0.29185 3.2349-8.6024-0.32249-10.823-3.3827 4.783 1.561 10.502 0.79778 10.823 3.3827z'/%3E %3Cpath d='m247.63 264.45c1.8558-1.3343-1.9327-4.7703-4.951-5.578 0.34558 2.1312 2.8719 6.8132 4.951 5.578z'/%3E %3Cpath d='m248.2 266.69c0.1986 2.9084-9.5373 1.3132-12.084-1.3741 8.3771 1.5142 11.81-1.1172 12.084 1.3741z'/%3E %3Cpath d='m252.76 268.63c1.0806 2.7015-8.2641 2.0422-11.545 0.4715 5.3012-0.0461 10.802-2.3534 11.545-0.4715z'/%3E %3Cpath d='m257.13 270.6c1.0345 2.421-7.6104 2.3687-11.824 1.0303 5.5812-0.0458 10.801-3.4259 11.824-1.0303z'/%3E %3Cpath d='m263.42 271.9c1.531 2.8646-7.5878 3.1435-10.547 1.7331 5.2725-0.72515 9.2422-3.9877 10.547-1.7331z'/%3E %3Cpath d='m252.74 267c-2.9011 1.8295-2.7458-3.5643-5.0532-7.2996 3.6255 3.3017 7.0194 5.5553 5.0532 7.2996z'/%3E %3Cpath d='m257.88 268.94c-2.4335 2.156-4.379-5.2459-6.594-9.399 3.5805 3.9539 8.8395 7.6085 6.594 9.399z'/%3E %3Cpath d='m264.68 271c-2.0609 2.3888-8.0196-7.0181-10.187-11.919 3.2992 3.8152 11.826 9.895 10.187 11.919z'/%3E %3Cpath d='m258.88 278.18c-1.028 3.6318-16.192-3.4234-17.885-7.0785 8.6768 4.5975 18.092 3.6359 17.885 7.0785z'/%3E %3Cpath d='m210.15 204.38c-0.35481-0.45993-1.3738 0.012-1.1194 1.1206 0.23653 1.5004 2.449 9.2034 6.2515 11.853 2.7118 1.9544 16.965 5.1023 23.427 6.439 3.5564 0.71558 6.5346 2.4896 8.8677 5.3209-0.96526-3.7022-1.7406-6.445-2.9866-9.7996-1.2114-2.9483-4.4213-6.1738-7.746-6.3471-6.175-0.2222-14.167-0.74783-19.974-3.2673-2.9973-1.252-4.7917-2.9436-6.7198-5.3197z'/%3E %3Cpath d='m245.54 234.87c1.9469 1.4336 4.0958-3.704 1.6225-8.588-0.0776 4.7012-3.8141 6.2791-1.6225 8.588z'/%3E %3Cpath d='m247.41 239.58c2.6927 0.82665 3.536-3.937 1.7626-7.7474 0.2957 4.0938-4.2336 6.5596-1.7626 7.7474z'/%3E %3Cpath d='m249.46 243.36c2.6006 1.2948 3.5848-3.5179 1.7159-7.0917 0.2039 4.5593-3.7203 5.9035-1.7159 7.0917z'/%3E %3Cpath d='m248.39 243.65c-1.0304 3.0802-7.0069-2.6554-8.0141-5.7748 3.7094 3.6852 8.7568 3.278 8.0141 5.7748z'/%3E %3Cpath d='m245.68 238.94c-1.171 3.0797-8.6865-4.8497-10.348-8.6679 3.7094 3.6852 11.184 6.4975 10.348 8.6679z'/%3E %3Cpath d='m244.19 234.32c-1.1706 3.5001-9.3403-5.829-11.654-9.1352 3.8968 3.6388 12.537 6.5919 11.654 9.1352z'/%3E %3Cpath d='m243.93 230.86c2.8765-0.55945-0.1633-2.9553-3.6892-6.849-0.16487 4.0999 0.50799 6.9664 3.6892 6.849z'/%3E %3Cpath d='m239.08 228.53c1.2422-1.3529-1.1906-1.9289-4.203-5.3096-0.44441 2.2798 2.7942 6.4535 4.203 5.3096z'/%3E %3Cpath d='m253 243.73c1.5742 0.92123 2.6516-2.3045 0.68982-5.225-0.44888 3.1594-2.1332 4.0368-0.68982 5.225z'/%3E %3Cpath d='m218.81 223.38c-3.3424 2.004-8.6516-5.992-10.068-9.2817 2.9329 3.7754 10.699 7.2242 10.068 9.2817z'/%3E %3Cpath d='m221.65 228.04c-1.8496 2.0506-7.6713-3.5187-9.6942-6.3413 3.1204 2.7022 10.512 3.0236 9.6942 6.3413z'/%3E %3Cpath d='m224.82 232.22c-0.61034 2.801-9.1062-3.4952-11.092-6.4756 3.6626 3.4518 11.649 3.1398 11.092 6.4756z'/%3E %3Cpath d='m223.52 235.25c-1.3106 2.5218-8.2206-3.7268-9.8794-6.9868 4.222 3.6843 10.949 4.4926 9.8794 6.9868z'/%3E %3Cpath d='m219.97 222.97c2.1805-2.2988 1.2516-3.3763-0.338-6.9994-0.8689 3.7206-2.1793 5.2055 0.338 6.9994z'/%3E %3Cpath d='m222.86 227.31c3.9544 0.17418 0.0381-4.6378-0.89693-8.6793 0.3439 4.6062-1.0136 8.2375 0.89693 8.6793z'/%3E %3Cpath d='m225.38 231.13c2.7405-0.61933 1.95-4.4971-0.15066-9.1933 0.43644 5.0738-2.3203 8.0055 0.15066 9.1933z'/%3E %3Cpath d='m224.45 238.8c-1.0304 3.0802-8.8265-4.0555-10.067-6.7554 3.9426 3.3119 10.763 4.4456 10.067 6.7554z'/%3E %3Cpath d='m229.12 243.61c-1.1698 3.0817-9.3391-3.1669-11.839-6.5678 4.9223 3.8722 12.443 3.5126 11.839 6.5678z'/%3E %3Cpath d='m233.88 248.46c-1.3096 4.2937-9.8528-2.5609-12.399-5.9148 5.4358 4.1511 13.096 2.859 12.399 5.9148z'/%3E %3Cpath d='m225.85 237.43c2.3206 1.201 3.2577-5.3837 1.9487-10.033 0.0175 5.0736-4.6535 8.8452-1.9487 10.033z'/%3E %3Cpath d='m229.81 242.66c2.7876 0.82809 1.904-6.2694-0.47802-10.873-0.30875 4.561-2.3662 8.8924 0.47802 10.873z'/%3E %3Cpath d='m234.76 247.56c3.1142 0.17446 0.97142-6.084-1.5973-9.6132 0.4372 4.6069-1.0129 9.0788 1.5973 9.6132z'/%3E %3Cpath d='m229.3 250.23c-0.93619 1.5864-3.226-1.3475-6.9861-3.4886 3.3817 0.88442 7.4021 2.0185 6.9861 3.4886z'/%3E %3Cpath d='m227.52 197.49c2.9065-2.1503 0.6893-6.1726 0-9.9979-0.93539 3.6281-3.3975 8.3887 0 9.9979z'/%3E %3Cpath d='m227.42 202.85c-4.3664-0.52444-3.7093-6.1715-3.8407-9.7506 1.3129 4.8586 4.892 5.6793 3.8407 9.7506z'/%3E %3Cpath d='m228.11 202.12c3.6938-0.21384 3.4979-4.4166 3.695-8.6682-1.872 3.9076-4.0892 4.5145-3.695 8.6682z'/%3E %3Cpath d='m227.96 207.34c-2.8731 0.22937-4.3664-2.5935-5.0234-6.9934 2.725 4.0546 5.2038 2.7907 5.0234 6.9934z'/%3E %3Cpath d='m228.99 206.99c3.6938 0.47546 3.1036-3.8252 2.9555-6.9946-1.1325 3.0212-4.137 3.9733-2.9555 6.9946z'/%3E %3Cpath d='m223.23 205.17c0.29507 2.8074 2.0691 7.6337 4.9255 6.5502 1.1815-3.4477-2.5123-4.137-4.9255-6.5502z'/%3E %3Cpath d='m229.04 212.02c-1.2806-2.4621 2.9053-3.695 3.7918-6.8954 0.50891 4.5802 0.0824 7.5847-3.7918 6.8954z'/%3E %3Cpath d='m217.13 182.84c2.2997-2.4765 0.26879-6.4056-0.42051-10.231-0.9354 3.6281-2.5565 8.4353 0.42051 10.231z'/%3E %3Cpath d='m217.06 187.45c-4.039 0.40976-5.0162-7.8045-5.4272-11.337 1.3129 4.8586 5.9648 7.0794 5.4272 11.337z'/%3E %3Cpath d='m217.89 187.37c2.854-1.4742 2.191-4.6495 3.0881-7.0352-1.9186 2.928-3.6687 3.3474-3.0881 7.0352z'/%3E %3Cpath d='m217.09 192.75c-4.2254 0.36197-6.7425-8.7387-6.8739-12.318 1.3129 4.8586 7.3661 7.4999 6.8739 12.318z'/%3E %3Cpath d='m217.9 192.61c3.9733-0.91389 3.4979-3.4835 2.9018-7.642-1.2651 4.1884-3.4824 3.3008-2.9018 7.642z'/%3E %3Cpath d='m217.04 198c-4.6459 0.78845-4.3198-6.5609-8.0088-11.893 3.1909 3.9602 8.9358 8.9502 8.0088 11.893z'/%3E %3Cpath d='m218.09 197.75c3.5074 0.10154 3.8503-5.1787 3.6556-7.3207-0.80638 2.1336-4.9302 4.1597-3.6556 7.3207z'/%3E %3Cpath d='m209.78 192.34c1.7418 5.6542 4.2158 11.32 7.2586 10.89 1.461-3.2148-2.8862-3.6245-7.2586-10.89z'/%3E %3Cpath d='m218.14 202.4c-1.2806-2.4621 2.9053-3.695 3.7918-6.8954 0.50891 4.5802 0.0824 7.5847-3.7918 6.8954z'/%3E %3Cpath d='m210.98 198.8c2.4872 5.0939 3.609 10.948 7.0244 10.097 1.2747-3.9614-3.7714-4.7905-7.0244-10.097z'/%3E %3Cpath d='m218.71 207.93c-1.467-2.6951 2.719-3.6484 3.7452-7.3625 0.5555 4.861 0.0358 8.3314-3.7452 7.3625z'/%3E %3Cpath d='m225.87 173.45c2.4514 0.66302 5.0222-2.0894 4.131-6.2085-2.8014 0.69766-4.0868 3.241-4.131 6.2085z'/%3E %3Cpath d='m218.03 171.39c0.21384 1.1588 1.6235 1.2639 1.2137-0.37272-0.34166-1.3284-0.4002-2.3271 0-3.4071 0.54834-1.3535 0.36556-3.658-0.0466-4.6196-0.41573-1.0154-1.7931-0.42051-1.2137 0.37392 0.63793 0.92106 0.67138 2.8372 0.23295 3.732-0.577 1.3212-0.4205 3.075-0.18636 4.2935z'/%3E %3Cpath d='m240.9 187.31c-0.94705 1.3932-2.8812 0.54113-1.4078-1.3724 1.2073-1.5486 2.9282-2.8138 3.0552-4.4136 0.10028-2.0286 1.2909-5.1066 2.3726-6.1447 1.1177-1.106 2.4089 0.44989 1.2142 1.1874-1.3426 0.87203-2.2147 4.4568-2.1853 5.836-0.0453 2.0013-2.0413 3.447-3.0489 4.9072z'/%3E %3Cpath d='m237.92 185.07c-0.94705 1.3932-2.4566 0.58456-1.6013-1.6522 0.72225-1.5486 0.79972-3.4676 1.6042-4.6 1.125-1.7165 3.0307-3.1471 4.1125-4.1853 1.1177-1.106 2.0456-0.0402 1.0207 0.90749-1.2445 1.2453-2.5947 2.7953-3.345 3.9693-1.3993 2.2808-0.78335 4.1004-1.7909 5.5607z'/%3E %3Cpath d='m222.18 177.86c-0.11229 1.9667 1.4706 2.4433 1.4001-0.40889-0.0717-2.9777-2.179-5.702-0.88642-10.235 0.67975-2.2176 0.69169-6.2814 0.27955-8.4413-0.36198-2.1423-1.8863-0.74253-1.3069 0.92566 0.63793 1.9341-0.11946 5.6442-0.60687 7.5106-1.4634 5.4335 1.2066 8.0801 1.1206 10.649z'/%3E %3Cpath d='m226.5 166.98c-0.23238 1.8098-1.7642 1.974-1.319-0.58213 0.37128-2.0748 0.43489-3.6346 0-5.3213-0.59586-2.114-0.39724-5.7131 0.0506-7.2151 0.45176-1.5859 1.9486-0.65676 1.319 0.584-0.69323 1.4385-0.72958 4.4313-0.25315 5.8288 0.62702 2.0636 0.45696 4.8026 0.20252 6.7057z'/%3E %3Cpath d='m210.94 204c0.75806 0.90214 2.0358 0.29761 0.87149-0.92336-0.95298-0.98655-0.63931-1.2979-1.22-2.4999-0.57427-1.343-0.54434-2.084-1.2375-3.0436-0.61297-0.91033-1.535 0.0184-0.91733 0.78454 0.77539 0.90604 0.56133 1.5743 1.0356 2.4508 0.87626 1.4999 0.66261 2.2875 1.4678 3.2315z'/%3E %3Cpath d='m231.34 228.61c2.4394 1.1994 4.2911 4.1955 4.413 6.6361 0.20667 2.8086 0.61165 5.1799 1.8732 7.1761-2.0082-0.55909-2.9698-3.7595-3.2554-6.8249-0.2891-3.1729-1.9986-4.5491-3.0308-6.9874z'/%3E %3Cpath d='m236.42 234.49c1.688 3.1159 4.0486 4.3044 4.1692 6.6167 0.2045 2.661 0.40664 2.7968 1.1277 5.4136-1.9871-0.5297-2.4871-0.70287-3.0238-4.6847-0.33098-2.7979-2.571-4.7718-2.2732-7.3456z'/%3E %3Cpath stroke='none' d='m288.97 263.32c0.94853 1.7884 2.038 4.5109 4.0128 4.0128 0.0311-1.369-2.1312-2.3176-4.0128-4.0128z'/%3E %3Cpath stroke='none' d='m291.91 263.93c3.8353 1.5721 7.1472 1.1839 7.5598 3.5946-3.598 0.38826-4.9137-1.0895-7.5598-3.5946z'/%3E %3Cpath stroke='none' d='m275.85 251.24c2.5828 2.1157 4.2588 4.5312 5.0401 7.6528 0.81474 2.9077 1.9604 5.2265 3.6412 7.8403-2.7381-1.8672-4.4596-4.407-5.3209-7.4676-0.7562-3.0081-1.6486-5.2564-3.3605-8.0255z'/%3E %3Cpath stroke='none' d='m279.03 251.23c2.7692 2.2101 5.3794 4.7188 6.1607 7.8403 0.81474 2.9077 1.3069 5.1333 3.1741 8.0267-2.9244-1.8672-4.0856-4.6877-4.947-7.7483-0.7562-3.0069-2.4896-5.2552-4.3879-8.1187z'/%3E %3Cpath stroke='none' d='m288.17 258.47c-0.0765-0.54594 0.29746-1.0226 0.74664-1.166 0.87446-0.32733 1.7454-0.59373 2.6126-0.83982 0.98556-0.23296 1.5375 0.47068 1.5411 0.933 0.005 0.76934 0.0406 1.4228 0 2.0058-0.0538 0.72634-0.19234 0.78009-0.65347 0.88761-0.73827 0.12424-1.6844 0.25087-2.4263 0.74664-0.58776 0.36078-1.1528 0.0753-1.4467-0.55908-0.18994-0.48502-0.29387-1.4336-0.37391-2.0082z'/%3E %3Cpath stroke='none' d='m298.8 258.47c0.0683-0.54594-0.21986-1.0692-0.62115-1.2126-0.78124-0.32732-1.5593-0.40736-2.38-0.37391-0.91144-0.0143-1.1409 0.19114-1.1441 0.65346-0.004 0.76934-0.0363 1.516 0 2.099 0.048 0.72634 0.032 0.78009 0.44398 0.88761 0.65957 0.12424 1.7845 0.15769 2.4472 0.65346 0.5251 0.36078 1.1238 0.0753 1.1526-0.60568-0.0128-0.51368 0.0299-1.5267 0.10139-2.1013z'/%3E %3C/g%3E %3Cuse x='-600' xlink:href='%23c' transform='scale(-1,1)'/%3E %3Cg stroke='none'%3E %3Cpath d='m328.54 286.65c0.0466 1.1815 0.18756 2.1312 0.88761 3.0797-4.0761-1.633-9.8306-0.75859-13.767 1.074-1.7561 0.83863-3.8802-0.95809-1.8206-2.6604 2.9292-2.3737 9.7063-1.0274 14.7-1.4933zm-57.505-0.0621c0.0573 1.1134-0.0717 2.1336-0.48144 3.106 4.4309-1.8349 9.1879-0.3106 13.664 1.4945 3.0774 1.2723 3.3258-0.93061 2.7823-1.6928-0.9342-1.3523-2.7417-2.8372-5.0282-2.8695-1.522-0.0215-7.3816-0.0741-10.937-0.0382zm3.7404-21.642c-1.2364-0.5328-2.6724-0.0203-3.9602 1.3356-4.3269 4.2397-9.4041 8.3707-13.502 11.584-1.5291 1.3284-3.0917 3.7117 3.431 6.0938 0.23654 0.0896 4.9912 1.8517 8.004 1.964 1.2305-0.0346 1.2269 1.8027 0.99871 2.2925-0.51966 0.9784-0.14336 1.3523-1.1934 2.2937-1.0943 0.92345 0.11707 2.1193 0.9772 1.3069 3.6723-3.1884 9.6275-1.148 15.366 0.71797 1.3559 0.37511 3.8371 0.26999 3.8156-1.6008 0.0239-2.038 1.5004-3.4787 2.4036-3.5313 2.3427 0.40617 13.919 0.53519 17.485 0.10154 2.0786-0.26998 2.2041 2.848 3.3163 4.0773 0.76695 0.81473 3.7189 1.031 5.7426 0.13738 4.0008-1.8588 10.097-1.8588 12.582-0.0824 1.0214 0.7777 1.8278 0.14694 1.2472-0.64271-0.74784-1.0799-0.73112-1.5805-1.1026-2.4334-0.933-1.8983-0.18875-2.363 0.78965-2.5004 11.054-1.4252 14.582-5.1966 11.202-8.2716-4.364-3.8276-9.2225-7.6755-13.408-12.198-1.1349-1.1994-1.8851-1.6808-4.2469-0.69885-7.2215 3.2888-16.388 5.6864-25.358 5.862-8.3469 0.0717-19.824-3.7894-24.589-5.8071z'/%3E %3Cpath d='m326.62 265.54c-0.58023 0.0578-1.1972 0.23826-1.6562 0.40625-8.921 3.1336-17.117 5.328-25.656 5.3125-8.3351-0.0155-17.066-2.3091-24.906-5.5312-0.44624-0.19053-0.95981-0.16084-1.4688-0.0312-0.50894 0.12959-1.0125 0.36576-1.3438 0.6875-3.6409 3.6266-7.5824 7.1483-11.812 10.344-0.63909 0.48801-0.53496 1.7307 0.5 2.1562h0.0312c8.3042 2.9793 16.412 8.5315 39.625 8.3125 23.433-0.22135 31.746-5.64 39.188-8.125 0.52464-0.19981 1.0644-0.4994 1.3125-0.96875 0.12404-0.23467 0.15766-0.52598 0.0625-0.8125-0.0952-0.28652-0.28357-0.55445-0.625-0.84375h-0.0312c-4.2235-3.4524-8.7488-6.2064-11.719-10.406-0.33382-0.47902-0.91977-0.55785-1.5-0.5zm0.0312 0.4375c0.50718-0.0506 0.89476 0.027 1.0938 0.3125 3.0414 4.3011 7.621 7.0738 11.812 10.5 0.30008 0.25426 0.44154 0.48023 0.5 0.65625 0.0585 0.17602 0.0438 0.29557-0.0312 0.4375-0.15003 0.28386-0.58962 0.56991-1.0625 0.75-7.534 2.5157-15.668 7.9043-39.031 8.125-23.115 0.21804-31.094-5.3023-39.469-8.3125-0.75458-0.31029-0.68706-1.1606-0.40625-1.375 4.2421-3.2062 8.227-6.7414 11.875-10.375 0.25052-0.24332 0.65266-0.45018 1.0938-0.5625 0.44109-0.11232 0.91238-0.13081 1.2188 0 7.8791 3.2384 16.613 5.5781 25.031 5.5938 8.6179 0.0156 16.903-2.2032 25.844-5.3438 0.44524-0.16293 1.0241-0.35569 1.5312-0.40625z' fill='%23bd6b00'/%3E %3Cpath d='m269.71 114.56c-0.0681-1.3788 2.0691-1.4841 1.8242 0.41202-0.313 2.3623 4.4583 8.342 4.8538 12.029 0.2652 2.4726-1.4527 4.6371-3.1538 5.9841-2.0858 1.6157-5.2934 1.3935-6.7938 0.46662-0.90792-0.73075-1.7358-3.2334-1.056-4.224 0.24012-0.33342 1.3272 3.673 3.7213 3.6574 3.2578-0.021 5.8967-2.4682 5.9934-4.6508 0.16725-3.8014-5.3292-9.8095-5.389-13.675z'/%3E %3Cpath d='m279.24 123.95c0.53878-0.38503 1.3989 1.2959 0.79204 1.716-0.50533 0.33652-1.4921-1.2493-0.79204-1.716z'/%3E %3Cpath d='m280.69 120.54c-0.27237 0.13212-0.81354-0.0555-0.65226-0.28671 0.76217-1.0889 2.3869-2.7279 3.5648-3.3 0.36198-0.17585 0.99513 0.46303 0.77651 0.77602-0.70483 1.0071-2.4203 2.1949-3.689 2.8107z'/%3E %3Cpath d='m293.28 110.55c0.30224-0.63089 2.1169-1.3441 2.5792-1.7707 0.42767-0.43783 0.63195 0.37046 0.44917 0.75202-0.30224 0.63052-1.8684 1.6954-2.5553 1.724-0.36914 0.0154-0.65585-0.32422-0.47307-0.7053z'/%3E %3Cpath d='m297.59 110.75c0.39304-1.1074 1.6605-2.7861 2.5326-3.3387 0.44799-0.28336 1.252-0.0605 1.1014 0.364-0.3333 0.93958-1.8839 2.5812-2.9268 3.3546-0.31657 0.28169-0.79801-0.12328-0.70722-0.37989z'/%3E %3Cpath d='m293.9 113.52c-0.26282 0.13153-0.12066 0.69133 0.1326 0.77591 0.53878 0.17943 1.5196 0.21443 1.964-0.0307 0.6451-0.39757 0.35122-2.8442-0.5125-1.5372-0.57939 0.80625-1.0023 0.54726-1.5841 0.79204z'/%3E %3Cpath d='m286.61 119.14c-1.3177-1.0262 0.3548-2.4639 1.7322-1.4601 2.6831 2.024-4.0032 9.7781-7.6408 13.403-0.66541 0.70984-1.2496-1.078-0.39662-1.848 2.6079-2.2121 5.0497-4.8551 6.7472-7.5854 0.32733-0.52563 0.64032-1.6587-0.44201-2.5092z'/%3E %3Cpath d='m301.88 112.47c0.16366-0.9821-1.5889 0.0206-1.6211-1.2814-0.0167-0.68906 1.915-1.1725 2.7226-0.37989 1.3643 1.384 0.34406 3.7184-1.9245 3.8653-1.8911 0.0835-5.0461 2.685-4.5659 3.2319 0.54595 0.67532 5.4499 1.1213 8.3015 0.67472 1.7657-0.24776 1.3953 1.3314-0.41334 1.5452-1.7477 0.20142-3.1717 0.0147-4.8048 0.52803-1.9222 0.54917-2.7608 3.1292-3.8288 4.0921-0.23773 0.16737-0.87925-0.84591-0.63554-1.2268 0.76934-1.2032 1.9962-3.0449 3.3462-3.572 0.85176-0.34501-2.3486-0.45384-3.37-0.74533-0.80995-0.24418-0.57461-1.2735-0.26401-1.848 0.41215-0.89513 3.4286-3.916 4.6447-3.8666 1.1421 0.0483 2.2997-0.2842 2.4132-1.0173z'/%3E %3Cpath d='m306.96 112.73c0.56745-0.50055 0.85775-1.3381 1.4527-1.848 0.32613-0.32661 0.84699 0.0647 0.75978 0.85332-0.0729 0.62084-0.90672 1.1559-1.467 1.6227-0.45635 0.34178-0.98676-0.39638-0.74545-0.62802z'/%3E %3Cpath d='m313.43 110.43c0.8446-0.0933 1.0548 1.5372 0.13141 1.8012-0.56028 0.18672-1.0501-1.7051-0.13141-1.8012z'/%3E %3Cpath d='m311.3 115.47c-0.0131 1.4037 0.67974 1.2746 2.0022 1.2266 1.283-0.0483 2.412 0.0331 2.4072-1.2346-0.006-1.3141-0.72753-2.4637-0.93898-1.5694-0.18636 0.84006-0.33449 2.2154-0.8231 1.6161-0.46112-0.515-0.27834-0.6279-1.0716 0.2173-0.43962 0.46579-0.48979-0.22578-0.75381-0.66003-0.18397-0.2572-0.8207 0.20775-0.8219 0.40402z'/%3E %3Cpath d='m302.08 122.63c-0.31538 1.8576-0.0263 4.4587 0.92464 4.4881 1.1755 0.0382 3.6078-4.0615 4.7594-6.188 0.6905-1.1867 1.8768-1.3942 1.3822-0.15602-0.74903 1.9104-0.68213 5.9976-0.0239 7.1987 0.35361 0.64689 2.9639-0.59325 3.3856-1.5147 0.76695-1.6746 0.14335-4.7616 0.41214-6.6468 0.13022-1.2376 1.2627-1.4963 1.203-0.34919-0.11229 2.0524-0.30702 5.8151-0.16247 7.524 0.086 0.98234 2.8946 2.432 3.3462-0.54272 0.23774-1.8724 1.2018-3.7189-0.0466-5.7933-0.77411-1.297 1.1361-1.1345 2.1659 0.63733 0.72036 1.2058-0.60687 3.2015-0.56028 4.744 0.11947 2.3731-1.7262 3.7214-3.0654 3.7494-1.197 0.0241-1.9771-1.4462-2.9579-1.4668-1.0883-0.0694-2.2065 1.693-3.106 1.6307-3.4859-0.23821-1.6402-5.3335-2.7022-5.396-1.1815-0.0695-2.5744 4.994-4.0295 4.8134-1.4348-0.17227-2.9197-4.1268-2.3224-5.8 0.53998-1.5567 1.5578-1.9216 1.3977-0.93204z'/%3E %3Cpath d='m318.96 114.6c-1.7012-1.0376 0.10752-3.7361 0.93898-2.788 1.6056 1.9229 3.2243 6.487 4.3556 6.8641 0.71678 0.23905 0.68333-3.3736 1.1886-5.016 0.32614-1.2133 1.7931-0.81724 1.5124 0.73733-0.0956 0.51906-1.9162 6.4213-1.7764 6.6546 1.2615 2.522 2.5099 5.0812 3.2996 7.788 0.32613 1.1667-1.0752 0.38097-1.2424 0.1387-0.89478-1.3375-2.4609-6.452-2.4609-6.2187-0.72036 3.598-0.89 4.6599-1.6546 7.7174-0.23295 0.97995-1.6749 0.80147-1.3499-0.92393 0.31299-1.4182 2.3749-8.3926 2.259-8.5947-1.6211-2.8616-3.1036-5.1252-5.07-6.3588z'/%3E %3Cpath d='m322.03 131.2c-0.47427-0.0538-1.2102 1.055 1.1516 1.4906 3.1562 0.57127 6.6111-0.49171 7.6695-3.5866 1.2125-3.6865 2.0141-7.1765 2.6473-8.4934 0.79084-1.5347 1.8027-1.4107 1.056-3.6506-0.52683-1.6123-1.51-1.1258-1.7167-0.26402-0.55192 2.3498-2.6461 9.9521-3.2996 11.352-1.2328 2.5547-3.7177 3.5654-7.5082 3.152z'/%3E %3Cpath d='m328.35 119.07c-0.33808-0.72537-1.1265-0.1639-0.98557 0.62933 0.0836 0.71702 0.66541 1.1068 1.2496 1.0866 0.69169-0.0239 2.1551 0.0232 2.1587-1.1253 0.002-0.80685-0.63196-1.481-1.1026-0.59063-0.45037 0.80614-1.0298 0.72168-1.3201 0z'/%3E %3Cpath d='m329.14 116.03c-0.24251 0.16833-0.0251 1.0656 0.26401 1.0559 1.031-0.0344 2.492-0.36328 3.2745-0.90791 0.22937-0.15937 0.1338-0.70161-0.19233-0.69073-0.99393 0.0331-2.5756 0.007-3.3462 0.54271z'/%3E %3Cpath d='m337.9 118.29c0.74664-1.1667 2.8062-1.2855 2.0655 0.38001-0.52444 1.1476-5.6518 11.055-6.3518 12.315-0.76337 1.4167-1.3882 0.71522-0.8458-0.38802 0.72992-1.4197 4.898-11.962 5.1321-12.307z'/%3E %3Cpath d='m330.18 133.04c-0.21862-0.78845-1.4419-1.9543-1.3045 0.1547 0.2437 3.8285 5.5036 2.6184 7.0961 1.2577 1.4455-1.2811 0.19114 4.3222 2.1121 4.9218 1.0584 0.33927 3.0511-1.105 4.0307-2.3761 2.7166-3.5249 4.4452-8.5779 7.0579-12.058 0.98676-1.3608-0.53997-2.3322-1.1576-1.2493-2.2722 3.8098-5.0939 11.585-8.176 13.604-2.5123 1.608-1.768-2.0703-1.8553-3.1753-0.1099-0.81068-1.0979-2.0034-2.4155-0.9084-0.92106 0.71964-2.3522 1.305-3.6484 1.1879-0.75142-0.0418-1.3858-0.0287-1.7394-1.3586z'/%3E %3Cpath d='m339.57 125.93c0.0275-0.21611-1.1122-0.31419-1.056 0.79204 0.0394 0.81891 1.019 1.0412 1.1875 0.92404 1.5411-1.1208-0.32733-0.56183-0.13141-1.7161z'/%3E %3Cpath d='m337.33 130.42c-0.30343 0.071-0.58178 1.0397 0.13261 1.0946 0.65346 0.0466 3.2135-0.22817 3.9208-0.18672 0.45755-0.0172 0.63196-0.89191-0.34883-0.84531-1.1898 0.0596-2.7536-0.23857-3.7045-0.0626z'/%3E %3Cpath d='m275.37 113.76c0.40617 0.0194 1.5196 1.4621 1.4467 1.9133-0.0502 0.21276-1.191-0.0317-1.5399-0.32661-0.25804-0.21838-0.15411-1.5984 0.0932-1.5867zm-5.3687 10.452c-1.0178 0.55514 0.16128 1.651 0.92345 1.1879 2.8611-1.8525 7.1546-3.7984 8.0518-7.4681 0.2879-1.2429 1.4431-3.1481 2.5398-3.5732 1.0596-0.41083 2.5983 1.9171 3.603 0.0853 0.58895-1.0471 2.6533 0.68715 3.1514-0.43329 0.60687-1.3533 0.31778-2.0984 0.34286-3.3946-0.0442-0.84914-0.69288-1.1028-1.1636 0.27202-0.2449 0.62252 0.043 1.251-0.1565 1.576-0.15172 0.24705-0.62479 0.48609-0.89955 0.28002-0.25327-0.18995-0.0777-0.72036-0.68453-0.95475-0.23534-0.1179-0.61284-0.21598-0.7765 0.0853-0.72036 1.2847-1.1194 2.4826-2.1276 1.1174-0.89836-1.176-1.3535-3.2088-2.0118-0.42672-0.23653 0.98187-1.7286 2.4067-2.6091 2.4067-1.0991 0-0.8231-2.8938-3.2374-2.4534-1.2412 0.26473-1.1552 2.6396-0.97004 3.5175 0.30463 1.22 3.9315 0.34369 3.7511 1.1412-0.62001 2.7712-4.4667 5.4053-7.7268 7.0348z'/%3E %3Cpath d='m247.3 137.42c-0.15411 0.46352 0.46232 1.7227 1.1014 1.8158 0.62718 0.0466 0.94734-1.3595 0.74545-1.8158-0.14933-0.33569-1.737-0.32852-1.8469 0z'/%3E %3Cpath d='m250.63 142.3c-0.40259-0.43365-1.5889 0.72992-0.62957 1.553 0.53877 0.43604 2.5123 1.0692 3.0523 0.14814 0.73111-1.1851-0.72037-5.4881-0.0777-6.0568 0.50175-0.4444 2.8277 2.8743 3.9757 3.1132 2.6975 0.37392 2.05-4.6184 4.9565-4.2792 1.9807 0.26402 2.1981-2.2113 1.9222-3.7568-0.221-1.483-2.6222-3.6238-3.726-4.5814-1.4527-1.2093-2.1002 0.89156-1.1886 1.5841 1.1731 0.93946 3.2362 2.8371 3.5648 4.0924 0.1553 0.59253-1.4336 1.7704-2.0189 1.4515-1.3511-0.73708-2.6079-3.898-3.7894-4.62-0.40259-0.24586-1.3929 0.30977-0.91628 1.296 0.53639 1.0566 2.9053 2.6932 3.0439 3.8209 0.12543 1.0286-1.0561 3.253-1.8314 3.253-0.85297 0-3.0272-2.6879-3.7057-3.953-0.33928-0.60567-1.5148-0.54714-1.6378 0.28911-0.19473 1.2556 0.18158 3.9124 0.48143 5.5586 0.23774 1.559-0.87805 1.6378-1.4754 1.0871z'/%3E %3Cpath d='m246.56 133.73c-0.33927 0.38359 0.79204 1.1338 1.0166 0.9391 0.43604-0.37751 2.1288-2.3073 1.8027-2.9818-0.29029-0.6015-2.6186-1.9187-2.9973-1.2666-0.70244 1.1287 2.1945 1.6344 1.7406 1.9653-0.2234 0.12818-1.0202 0.67855-1.5626 1.344z'/%3E %3Cpath d='m250.73 125.27s0.72752 2.4891 1.3201 1.4521c0.47905-0.71869-1.3201-1.4521-1.3201-1.4521z'/%3E %3Cpath d='m251.92 129.23c-0.2664 0.14563-1.0166 0.73996-0.52802 1.0561 0.77292 0.45718 2.8755 0.81915 2.4215-0.67605-0.27596-0.88068 3.1706 0.0245 2.3307-2.36-0.21981-0.65991-1.2591-1.6123-1.7704-1.7468-0.32494-0.0855-1.4288 0.5199-0.73828 0.85344 0.50413 0.26103 2.0249 1.1546 1.4598 1.7399-0.64152 0.61225-1.0883-0.27477-1.8863-0.13189-0.4014 0.0763-0.13977 1.2186-0.36556 1.5294-0.12663 0.17334-0.70603-0.3824-0.92345-0.26402z'/%3E %3Cpath d='m257.4 119.77c-0.43485 0.2173-1.2138 1.3963-1.2424 1.9414-0.0155 0.2909 0.30344 0.69074 0.55192 0.56662 0.45635-0.22794 1.1612-1.3438 1.1875-1.856 0.0167-0.32386-0.22698-0.78678-0.49696-0.65203z'/%3E %3Cpath d='m260.24 119.46c-0.83982-1.0267 0.8912-2.5509 1.6701-0.49601 0.47069 1.2891 5.4881 7.8921 6.5143 10.132 0.72634 1.516-0.0263 2.1423-0.92464 1.056-2.541-3.242-4.6256-7.2831-7.2598-10.692z'/%3E %3Cpath d='m265.39 119.6c0.89478-0.96932 2.7214-2.9492 2.2292-4.0533-0.3775-0.94961-1.4873-0.85524-1.6773-0.63614-1.0859 1.2962 0.77173 0.97087 0.50413 1.4135-0.55311 1.0384-1.1038 1.61-1.3894 2.608-0.0669 0.23403 0.17203 0.84257 0.3333 0.66792z'/%3E %3Cpath d='m343.17 122.84c-0.6427-0.52062 0.63196-3.044 1.4945-2.0534 2.3678 2.74 3.468 11.636 4.1525 18.294 0 0-1.0644 0.8876-1.0728 0.74664 0-3.5468-1.4252-14.397-4.5742-16.987z'/%3E %3Cpath d='m290.07 114.18c-0.76575-1.7604 1.1492-2.412 1.436-1.1572 1.3308 5.7827 4.5169 10.161 6.942 14.093 0.72992 1.2293 0.14455 1.9618-1.6307 0.83063-1.2293-0.84281-2.4777-3.9162-3.0821-4.0374-1.0943-0.20368-3.7129 4.9927-9.0696 3.5094-1.3858-0.38718-1.2938-4.5079-1.3201-6.328-0.0585-0.85332 0.88402-1.0787 0.91628 0.0853 0.049 1.6781-0.002 5.164 2.1444 5.2813 1.7501 0.0978 5.6267-2.3765 6.4438-4.3107 0.72753-1.9887-1.952-5.9413-2.7799-7.9667z'/%3E %3Cpath d='m344.61 138.38c0.42767-1.191 6.1141-10.735 6.8607-12.835 0.38228-1.0126 2.0141 1.7366 0.42051 3.2201-1.4001 1.26-5.5311 8.0342-6.3017 10.408-0.3548 1.0716-1.4312 0.56148-0.97959-0.79323z'/%3E %3Cpath d='m354.28 129.28c1.0501-3.9348 3.5934 0.60699 1.3535 2.8469-3.4584 3.3874-4.5002 9.8539-9.9871 10.827-1.479 0.31777-4.082-0.66541-4.8538-1.2137-0.30105-0.21384 0.19472-1.6187 1.1194-0.93301 1.3368 1.0441 4.0976 1.2794 5.555 0.0932 3.118-3.0606 5.6566-7.1136 6.813-11.621z'/%3E %3Cpath d='m297.27 142.02c-0.24729 0.28432-1.0035 0.23773-1.0716 0.63674-0.29747 1.4801 0 2.2304-0.32614 3.6556-0.31179 1.3643-1.2591 1.4156-1.1946 0.30343 0.086-1.4419 1.2747-3.4776 0.43484-3.6173-0.55909-0.13141-0.99035-0.87925-0.41215-1.2484 1.0919-0.75739 1.6784-0.64151 2.4287-0.41334 0.26162 0.08 0.32852 0.46471 0.14097 0.68333z'/%3E %3Cpath d='m296.5 140.09c-1.4479 1.2663-2.7906 1.7836-4.1227 3.3844-0.54475 0.65585-0.52922 1.5697-0.85416 2.406-0.32613 0.88761-1.375 1.062-1.7 0.87685-0.54356-0.35719-0.46471-2.0034-1.0716-1.117-0.51489 0.81593-0.84699 1.9401-1.608 1.9257-0.68811-0.0143-1.9867-1.4216-1.3284-1.4897 2.2519-0.23057 2.2244-2.0332 3.0678-2.1515 0.94615-0.12663 1.0083 1.4885 1.5924 1.1648 0.45874-0.23534 0.67497-2.1169 1.1731-2.6246 1.5267-1.5602 2.7345-2.3845 4.2923-3.5313 0.78845-0.62837 1.3511 0.50533 0.55909 1.1564z'/%3E %3Cpath d='m301.78 144.94c-1.1588 0.23415-0.96168 1.7238-0.62121 1.909 0.56148 0.26163 1.43 0.37153 1.7549-1.3416 0.15172-0.70363 0.2891 3.4979 1.8314 1.8792 0.88761-0.98079 3.0869 0.17799 4.008-1.056 0.65943-0.82191 0.86252-1.3953 0.34883-2.6091-0.14933-0.36914-1.0525-0.18756-1.0011 0.70841 0.0454 0.755-0.53519 1.6868-1.2902 1.5279-0.36675-0.0669 0.20667-1.8469-0.16127-2.3295-0.20309-0.26521-0.5113-0.23654-0.71319 0.0382-0.28313 0.38467 0.28432 2.0906-0.6463 2.3152-1.1743 0.27118-0.55908-1.1409-1.056-1.3989-1.5984-0.80637-1.7525 0.20906-2.4538 0.35719z'/%3E %3Cpath d='m310.83 142.08c0.84938-0.23892 0.58418-0.24012 1.921-1.3344 0.52086-0.39423 0.6236 0.75978 0.56865 1.2161-0.0968 0.77532-1.0178 0.22818-1.3033 0.91031-0.41812 0.88641-0.24848 2.9483-0.38826 3.7882-0.0956 0.43126-0.78726 0.39423-0.85296 0.0538-0.19831-1.0238 0.13977-2.0261 0.10752-3.3067-0.0108-0.43484-0.63316-1.117-0.0526-1.3272z'/%3E %3Cpath d='m305.83 139.46c-0.20548 0.92655-0.18995 1.6899-0.18995 2.3255 0.0466 0.51369 0.98557 0.18278 0.98199 0.11707-0.0466-0.81354 0.13857-1.9389-0.10155-2.2526-0.13021-0.16928-0.64271-0.36484-0.69049-0.18995z'/%3E %3Cpath d='m299.54 130.19-1.4584 5.5938-2.029-3.75v3.8438l-4.375-5.1875 1.5218 5.5625-3.9312-3.3438 2.0924 3.7812-6.9747-4.5 4.4385 5.1875-5.5798-2.75 3.9946 3.375-9.1305-3.4375 8.8135 4.3438c3.2225-1.5882 7.6406-2.5625 12.554-2.5625 4.8962 0 9.3348 0.98435 12.554 2.5625 0.0116 0.006 0.0518-0.006 0.0634 0l8.7501-4.3438-9.0037 3.4688 3.9312-3.4062-5.5164 2.7188 4.375-5.1562-6.9747 4.5 2.0924-3.7812-3.9312 3.3438 1.5218-5.5625-4.375 5.2188 0.0634-3.875-2.029 3.75-1.4584-5.5938z'/%3E %3C/g%3E %3C/g%3E %3Cpath d='m291.82 251.63c-0.00001 0.59294-0.0892 1.4489-0.26749 2.5679h-0.41461c-0.00001-0.76234-0.0357-1.3486-0.107-1.7588-0.0669-0.41014-0.20062-0.89831-0.40124-1.4645-0.16495-0.47701-0.34551-0.88271-0.54166-1.2171-0.19617-0.33881-0.51047-0.78909-0.94291-1.3508l0.82922-2.0463c0.3834 0.4904 0.65535 0.86712 0.81585 1.1301 0.18278 0.30317 0.35442 0.68434 0.51492 1.1435 0.16495 0.4592 0.292 0.94068 0.38117 1.4444 0.0892 0.50378 0.13374 1.0209 0.13375 1.5514' fill='%23fff'/%3E %3Cpath d='m298.32 247.67c-0.00001 0.62415-0.11815 1.0923-0.35443 1.4043-0.23628 0.31208-0.63975 0.53499-1.2104 0.66873 0.16495 0.57957 0.27417 1.0321 0.32768 1.3575 0.0579 0.32546 0.0869 0.6888 0.0869 1.09 0 0.25858-0.0156 0.53498-0.0468 0.82922-0.0268 0.29424-0.078 0.69102-0.15381 1.1903h-0.37448c-0.00001-0.44582-0.0245-0.82922-0.0736-1.1502-0.0446-0.32544-0.11369-0.63083-0.20731-0.91615-0.0223-0.0713-0.14044-0.38563-0.35442-0.94291-0.20954-0.56172-0.41908-1.0276-0.62861-1.3976-0.20507-0.37448-0.54167-0.8894-1.0098-1.5448l0.64197-1.9259c0.33882 0.48595 0.63529 0.82254 0.88941 1.0098 0.25411 0.1828 0.55504 0.27419 0.90278 0.27418 0.75788 0.00001 1.1368-0.41014 1.1368-1.2304h0.38786c0 0.2675 0.007 0.49041 0.0201 0.66872 0.0134 0.17388 0.0201 0.37896 0.0201 0.61523' fill='%23fff'/%3E %3Cpath d='m304.29 252.19-0.48148 2.0062c-0.30316-0.0847-0.55059-0.32321-0.74229-0.71553-0.1605-0.32545-0.27641-0.73783-0.34774-1.2372-0.0669-0.49931-0.10031-1.0165-0.1003-1.5514-0.4057 0.107-0.72669 0.1605-0.96297 0.16049-0.46811 0.00001-0.85597-0.12259-1.1636-0.3678-0.30316-0.24965-0.45474-0.56395-0.45474-0.9429 0-0.81584 0.20954-1.5492 0.62861-2.2001 0.42352-0.65534 0.90054-0.98301 1.4311-0.98302 0.41015 0.00001 0.69547 0.11592 0.85597 0.34773 0.17832 0.25413 0.28755 0.54391 0.32767 0.86935 0.0401 0.32545 0.0602 0.95405 0.0602 1.8858-0.00001 0.83369 0.0669 1.4222 0.20062 1.7654 0.10699 0.26749 0.35665 0.58848 0.74897 0.96297m-1.8056-3.3303c-0.0803-0.50822-0.34774-0.76234-0.80247-0.76235-0.19616 0.00001-0.37672 0.0535-0.54167 0.1605s-0.24743 0.20062-0.24743 0.28086c0 0.2675 0.32099 0.40124 0.96297 0.40124 0.20507 0 0.4146-0.0267 0.6286-0.0802' fill='%23fff'/%3E %3Cpath d='m310.61 251.69-0.24074 2.4342c-0.47703-0.33436-0.91839-0.93844-1.3241-1.8122-0.42353-0.91392-0.85151-2.209-1.284-3.8853-0.37003 1.6139-0.67542 2.7975-0.91615 3.5509-0.23629 0.74898-0.47034 1.2795-0.70217 1.5916-0.15603 0.20953-0.40569 0.4213-0.74897 0.63529l0.0535-2.3272c0.44136-0.60185 0.7512-1.061 0.92953-1.3776 0.26303-0.46811 0.47925-1.0142 0.64866-1.6384 0.17387-0.6286 0.3299-1.469 0.46811-2.5211h0.44136c0.27194 1.0566 0.53498 1.897 0.7891 2.5211 0.23627 0.58848 0.51268 1.1079 0.82922 1.5581 0.2229 0.31653 0.57509 0.74006 1.0566 1.2706' fill='%23fff'/%3E %3Cpath d='m328.98 274.65c0.32497 0.38098 0.55329 0.75473 0.68495 1.1212 0.12801 0.36224 0.22048 0.87984 0.27742 1.5528l-0.72521 0.0591c-0.30903-0.60477-0.60962-1.0784-0.90172-1.4208-0.22275-0.26111-0.58253-0.63238-1.0794-1.1138-0.49683-0.48142-1.0047-0.95049-1.5236-1.4072-0.52252-0.46101-1.188-0.99369-1.9966-1.598-0.28364-0.21128-0.4638-0.36187-0.54049-0.45177-0.11319-0.13269-0.20263-0.39415-0.26833-0.78437-0.0693-0.39448-0.1128-0.88494-0.13041-1.4714l2.5326 2.0598c0.95529 0.78652 1.746 1.4811 2.3722 2.0839 0.48224 0.46431 0.91504 0.92119 1.2984 1.3706m-8.9817-5.4124-0.15174 1.8623-2.9822-0.0806 0.22403-1.9006 2.9099 0.11878m7.8445 8.3364-7.1052 2.1647-1.3076-1.8069 6.1428-1.8715c-0.27881-0.38529-0.49459-0.65466-0.64729-0.80813-0.23728-0.23579-0.50854-0.4207-0.81378-0.55472-0.0197 0.34113-0.16097 0.6409-0.42377 0.89933-0.26282 0.25845-0.60239 0.45109-1.0187 0.57793-0.54602 0.16636-1.0917 0.18937-1.6369 0.069-0.54524-0.12034-0.94606-0.35767-1.2024-0.71196-0.37818-0.52257-0.58114-1.2174-0.60891-2.0846-0.0312-0.95257 0.22954-1.5131 0.78239-1.6815 0.71666-0.21834 1.6856-0.019 2.9069 0.59805 1.2212 0.61706 2.1588 1.3773 2.8126 2.2808l2.12 2.9295m-5.457-3.7938c-0.33492-0.15199-0.60288-0.24601-0.8039-0.28207-0.1974-0.0425-0.378-0.0389-0.54181 0.011-0.20476 0.0624-0.34578 0.17832-0.42306 0.34779-0.0773 0.16949-0.0582 0.33394 0.0571 0.49337 0.0737 0.10186 0.19763 0.16951 0.37177 0.20293 0.17775 0.0269 0.3656 0.0102 0.56352-0.0501 0.15699-0.0478 0.29314-0.12444 0.40847-0.22984 0.11893-0.1119 0.24156-0.27628 0.36786-0.49314m-7.612-1.4544-0.4351 1.8434-2.9552-0.2717 0.44889-1.8622 2.9415 0.29042m7.0047 7.1968-1.5782 0.36205c-0.56162 0.12885-1.0959 0.16839-1.6029 0.11863-0.50697-0.0497-0.98121-0.20821-1.4227-0.47537-0.26101 0.47503-0.71972 0.87346-1.3761 1.1953-0.43524 0.21401-0.94077 0.38707-1.5166 0.51917l-1.1197 0.25686-1.0255-1.882 1.1197-0.25687c0.59006-0.13536 0.99233-0.2484 1.2068-0.33912 0.21909-0.097 0.49354-0.26112 0.82335-0.49247-0.36157-0.22321-0.65323-0.37685-0.87497-0.46091-0.26987-0.099-0.50788-0.12479-0.71405-0.0775-0.0782 0.0179-0.14279 0.0535-0.19377 0.10673-0.0464 0.047-0.0858 0.12867-0.11836 0.24511l-0.49183 0.0661c-0.45495-0.8349-0.5588-1.4805-0.31158-1.9368 0.25182-0.46253 0.85759-0.80388 1.8173-1.0241 0.98816-0.22668 1.8322-0.2776 2.532-0.15275 0.70446 0.11863 1.1761 0.39704 1.4148 0.83524 0.1282 0.23525 0.17671 0.4784 0.14556 0.72944-0.0337 0.24645-0.15614 0.60147-0.36737 1.0651 0.14727 0.0648 0.32005 0.10302 0.51832 0.11461 0.19826 0.0116 0.37559-0.00054 0.53199-0.0364l1.5782-0.36206 1.0255 1.882m-7.5437 1.7549-1.5392 0.2414c-0.85751 0.13449-1.5619 0.003-2.1131-0.3934-0.61288-0.43741-1.1417-1.253-1.5864-2.4466l-0.75738-2.033c-0.17186-0.46128-0.40456-0.80481-0.69812-1.0306-0.14134-0.10869-0.42766-0.25254-0.85894-0.43154l0.52296-1.9696c0.56683 0.31379 1.0036 0.64292 1.3104 0.98741 0.3591 0.40173 0.66356 0.93786 0.91337 1.6084l0.52353 1.4053c0.37027 0.99393 0.72978 1.6674 1.0785 2.0204 0.2764 0.28383 0.5905 0.39815 0.94231 0.34297l1.5391-0.2414 0.72284 1.9403m-6.5774-7.0651-0.99392 1.7499-2.812-0.64929 1.002-1.7654 2.804 0.66485m1.6358 7.9213-7.0124 0.63521-0.42537-1.977 5.8922-0.53374c-0.15305-0.32205-0.36236-0.58714-0.62792-0.79527-0.13913-0.11583-0.44742-0.31021-0.92488-0.58312l0.52396-1.811c0.6487 0.36114 1.1224 0.7579 1.421 1.1903 0.30605 0.43171 0.55448 1.0909 0.74528 1.9776l0.40816 1.897m-5.6298 0.89755c-0.84343-0.028-1.5407-0.0904-2.0917-0.18713-0.55109-0.0967-1.091-0.23959-1.6196-0.42863-0.45261 0.18581-0.85462 0.30471-1.206 0.35671-0.34389 0.0523-0.85848 0.067-1.5437 0.0442l-1.8412-0.0612c-0.50454-0.0168-0.89691-0.11555-1.1771-0.29634-0.28019-0.18078-0.52137-0.47293-0.72355-0.87648-0.4466 0.39667-0.93288 0.67443-1.4588 0.83331-0.44873 0.13694-0.97807 0.19528-1.588 0.17499l-1.6153-0.0537 0.15746-1.9935 1.6153 0.0537c0.7907 0.0263 1.461-0.0959 2.0109-0.36668 0.71498-0.35345 1.1028-0.91373 1.1634-1.6809l0.73973 0.0981c-0.0274 0.15586-0.0566 0.33371-0.0874 0.53354-0.0309 0.19983-0.056 0.4219-0.0753 0.6662-0.0197 0.2492 0.0957 0.46124 0.34614 0.63613 0.25043 0.1749 0.5451 0.26798 0.88397 0.27924l1.3894 0.0462c0.91871 0.0306 1.5804-0.0307 1.9851-0.18384 0.49023-0.18455 0.75696-0.55046 0.80019-1.0977 0.009-0.11727 0.074-0.22044 0.19433-0.30953 0.072-0.0515 0.2177-0.12747 0.43705-0.22796l0.4466-0.2056c0.008 0.0933 0.009 0.22075 0.004 0.38224-0.005 0.15661-0.009 0.25935-0.013 0.3082-0.0212 0.26874-0.10966 0.62343-0.26524 1.0641 0.27166 0.0972 0.57819 0.18334 0.91959 0.25838 0.34136 0.075 0.70273 0.13605 1.0841 0.18302 0.0131-0.16613-0.064-0.38425-0.23145-0.65436-0.16743-0.27011-0.24748-0.45158-0.24013-0.54443 0.01-0.12703 0.0441-0.22387 0.10223-0.29053 0.017-0.0239 0.10579-0.0969 0.26644-0.21895l1.0267-0.81093c0.17899 0.3146 0.29988 0.60031 0.36266 0.85714 0.0707 0.2522 0.0911 0.56641 0.0614 0.94264l-0.21882 2.7704m-10.645-8.1911-1.7712 1.2539-1.3356-0.8244-1.3149 0.9805-1.7572-1.06 1.6777-1.1935 1.4181 0.79248 1.3698-1.0018 1.7134 1.0528m-2.785 7.6352-6.8649-1.1248 0.75327-1.9354 5.7682 0.94517c0.0451-0.33575 0.005-0.63246-0.12018-0.89015-0.0617-0.1413-0.23446-0.39669-0.51839-0.76618l1.5364-1.5497c0.39138 0.49306 0.59992 0.97634 0.62562 1.4498 0.033 0.4747-0.11944 1.1461-0.45729 2.0142l-0.7228 1.8571m-5.7788-0.89598-1.4847-0.3572c-0.82718-0.19901-1.2988-0.56293-1.4148-1.0918-0.13218-0.58491 0.13072-1.4531 0.78871-2.6045l1.1207-1.9611c0.25427-0.44496 0.35675-0.81428 0.30743-1.1079-0.0238-0.14137-0.13755-0.36442-0.34138-0.66916l2.1284-1.4447c0.20032 0.46565 0.27957 0.89694 0.23771 1.2939-0.0477 0.46337-0.25632 1.0185-0.62594 1.6653l-0.77464 1.3556c-0.54789 0.95877-0.82902 1.6478-0.8434 2.067-0.0149 0.3356 0.1474 0.54422 0.48676 0.62586l1.4847 0.3572-1.0696 1.8716m-3.5159-7.43-2.4095 1.0168-1.6552-1.6116 2.4303-1.0261 1.6344 1.6209m-1.0246 6.2246c-0.50104 0.59175-0.99326 1.0359-1.4767 1.3325-0.47979 0.2923-1.0171 0.47477-1.612 0.54741-0.58829 0.075-1.3338 0.0409-2.2364-0.10218-0.89965-0.13648-1.7658-0.35312-2.5985-0.64994-1.6059-0.57245-2.6835-1.205-3.2327-1.8976-0.54624-0.68595-0.52347-1.3784 0.0683-2.0774 0.50465-0.59604 1.1045-1.0912 1.7996-1.4853 0.76509-0.43622 1.9589-0.93173 3.5815-1.4866l0.36605 0.48217c-1.2678 0.49146-2.1422 0.86363-2.623 1.1165-0.4742 0.25522-0.85833 0.55649-1.1524 0.90383-0.38122 0.45025-0.32337 0.95094 0.17355 1.5021 0.50717 0.54921 1.3654 1.0394 2.5748 1.4705 1.1896 0.42403 2.316 0.63299 3.3794 0.62687 1.0634-0.006 1.7766-0.22359 2.1397-0.65239 0.22509-0.26586 0.37567-0.55549 0.45177-0.86889 0.0827-0.31104 0.13265-0.83749 0.14995-1.5794l2.3428-1.4257c0.001 0.70949-0.032 1.186-0.10052 1.4295-0.11762 0.44373-0.41968 0.9529-0.90616 1.5275l-1.0892 1.2864' fill='%23bf0000'/%3E %3C/svg%3E"

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='690' height='460' viewBox='0 0 138 92'%3E %3Crect width='138' height='92' fill='%23fff'/%3E %3Crect width='138' height='36' fill='%23000'/%3E %3Cg transform='translate(69,36)'%3E %3Cg id='c3'%3E %3C!-- y3 = -y2 = 30*sin(11.25deg)/sqrt(5-4*cos(11.25deg)-sin%5E2(11.25deg)) --%3E %3Cpath id='c' d='M-30,0 0,-5.7423716V5.7423716z' fill='%23fcd116'/%3E %3Cuse xlink:href='%23c' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23c' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23c3' transform='rotate(67.5)'/%3E %3Cuse xlink:href='%23c3' transform='rotate(135)'/%3E %3C/g%3E %3Crect y='36' width='138' height='20' fill='%230072c6'/%3E %3Cpath d='M0,0V92H138V0L69,92z' fill='%23ce1126'/%3E %3C/svg%3E"

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H800V400H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23cc3' d='m780.583,154.039c0,148.827,11.8732,201.675,52.6064,242.479,40.7332,40.8042,56.1659,47.2313,67.5231,53.4827,13.1015-7.21148,28.1971-15.1341,65.1152-52.0521,36.513-36.515,54.173-89.15,54.173-246.452-26.559,11.3712-39.7859,15.1175-63.0119,15.0513-17.202,1.68548-43.7399-9.33789-59.6086-16.5484-10.371,6.60246-25.4152,14.4763-52.4514,15.3604-31.2252,1.30952-41.1191-3.73522-64.3451-11.3217z'/%3E %3Cpath fill='%23fff' d='m787.775,163.438c0,46.0434-2.72184,108.794,7.00639,145.1,9.77001,36.4622,12.0129,41.8034,19.3596,54.5282l171.206-1.27105c10.576-18.3181,11.1098-29.6647,18.9526-58.9348,7.8148-29.1649,9.7886-94.177,10.0167-142.6-17.216,8.72445-39.7613,14.9075-61.6436,12.1948-17.5423-1.2754-33.7513-5.09258-52.6268-15.2637-16.374,9.35261-22.0822,13.6217-49.1184,14.7138-21.0507,0.98975-38.1018,2.61503-63.1522-8.46789z'/%3E %3Cpath fill='%239cf' d='m814.51,362.056c12.1849,24.4477,69.6325,71.3032,86.433,81.0029,19.168-11.0667,69.8476-57.368,83.9727-81.0029h-170.406z'/%3E %3Cpath fill='%23f90' d='m904.221,231.606c5.41355,12.1396,22.7699,25.5448,27.5414,32.1145-6.07314,6.56934-7.28706,5.85387-6.49064,18.0587,10.5604-10.534,10.7499-11.6322,17.5423-10.0346,14.8794,14.1555,2.66292,44.5571-9.63422,51.1666-12.2936,7.05101-10.0622-0.24417-28.4886,8.59299,8.44836,6.88711,18.237-1.01015,26.2362,1.10047,4.34697,4.91697-2.06648,13.8779,1.31216,22.317,7.06953-0.6489,6.22049-14.2559,7.86595-19.1896,5.16445-18.0757,36.2143-30.6826,37.7931-47.2631,6.54677-2.93012,13.09-0.9165,21.0507,3.34487-3.96455-15.5336-17.0792-15.3664-20.5946-20.2178-8.36767-12.1907-15.7845-26.0981-33.6566-29.7059-13.5672-2.73878-12.5532,0.82385-21.2472-4.83-5.41355-4.01853-21.8612-11.6181-19.2298-5.45416z'/%3E %3Cpath fill='%23f90' d='m860.839,283.106c8.72935-10.2344,13.0534-31.1272,16.9171-38.2184,8.92956,2.05041,8.83312,3.40792,19.7799-2.96497-14.7027-3.98084-15.8096-3.62755-17.5012-10.0994,6.17695-19.1553,40.0786-23.0599,51.953-15.7817,12.2822,7.06894,4.4742,8.596,21.2779,20.0001,2.44044-10.3389-9.45634-14.9009-11.2359-22.6298,2.52932-5.96126,13.8358-4.74122,20.084-11.5316-3.90439-5.6561-16.127,1.41619-21.4712,2.33396-19.1762,4.09085-45.373-16.1931-61.4875-9.77821-5.77578-4.14976-6.96507-10.606-6.73193-19.3072-12.5539,10.5985-6.27225,21.5753-9.12921,26.805-7.39678,12.7485-16.8297,25.4974-11.8265,42.248,3.79803,12.7158,6.62838,10.1968,5.44639,20.1666-1.19785,6.44061-0.56211,23.8553,3.92513,18.7577z'/%3E %3Cpath fill='%23f90' d='m931.763,290.302c-13.7027-1.82835-34.6943,5.45107-43.0585,5.96673-2.77851-8.34642-1.51002-8.96995-12.8934-14.605,4.03197,14.0554,4.9217,14.7758-0.0129,19.5038-20.3904,4.86884-41.4321-20.7724-41.0411-34.2257-0.008-13.6779,5.40195-8.09713,6.94685-27.7067-10.5433,3.35691-8.48447,15.4235-14.502,20.8735-6.65962,1.01994-11.4131-8.83635-20.7407-10.4218-3.05765,6.11145,9.61345,12.4257,13.2018,16.3114,13.5917,13.53,8.93457,45.397,23.0288,55.2268-0.7374,6.85915-5.91783,11.1692-13.8492,15.48,16.0079,4.76053,22.612-6.04289,28.7845-6.41709,15.2702-0.5594,31.594,0.5423,44.0424-12.2046,9.45-9.67656,5.72467-10.6828,15.2857-14.8756,6.40117-2.35427,21.7049-11.8813,14.8078-12.9056z'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(3.5084546,0,0,3.3448778,6.3307176,-163.01097)'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(-1.6389991,-2.9574373,3.1020668,-1.5625831,914.32327,1224.3275)'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(-1.8069804,2.8671155,-3.007328,-1.7227325,1749.0027,-240.21318)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='700' height='500'%3E %3Crect width='700' height='500' fill='%23e41e20'/%3E %3Cpath id='half' d='m300.094,97.2043c-4.8618-0.082-12.9308,1.54998-12.75,5.2812-13.5419-2.32092-14.952,3.27267-14.1562,8.25003,1.28844-1.97532,2.85723-3.04776,4.06251-3.24999,1.80576-0.2997,3.6954,0.2835,5.625,1.46871,1.92969,1.1853,4.05558,3.09798,5.00004,4.28121-4.77945,1.14264-8.4717,0.405-12.2188-0.2502-1.84716-0.3231-4.43205-1.36224-5.96871-2.43747-1.53666-1.07541-2.0205-2.08755-4.43754-4.56246-2.84967-2.91798-5.88258-2.09637-4.93749,2.43747,2.18556,4.21092,5.83659,6.08859,10.4375,6.84378,2.214,0.3636,5.51196,1.15263,9.25,1.15623,3.73806,0.004,7.93521-0.54,10.2188-0.0625-1.37187,0.8613-2.92428,2.34621-6.00003,2.93751-3.12777,0.6012-7.88301-1.85994-10.7812-2.53125,0.3681,2.43855,3.44403,4.71816,9.49999,5.90625,9.95152,2.16693,18.2208,3.81375,23.6875,6.78123,5.46669,2.96748,8.91342,6.68268,11.375,9.59375,4.89861,5.79312,5.15628,10.2402,5.46876,11.2187,1.00782,9.2557-2.21958,14.4622-8.21871,16.0625-2.99961,0.8001-8.32788-0.7065-10.2812-2.99997-1.95345-2.29293-3.85407-6.23421-3.31254-12.4062,0.5265-2.42127,3.29526-8.72811,0.93753-10.0312-10.8616-6.00326-24.0512-12.0744-33.5938-15.6873-2.60815-0.98745-4.75675,2.55735-5.59375,3.9375-16.2111-1.97418-30.827-12.9443-37.4062-24.625-4.48101-7.95555-11.8665,0.0164-10.625,7.5312,2.0043,8.38764,8.39502,14.4519,16.0625,18.75,7.86951,4.33314,17.7059,8.59698,27.6562,8.37504,5.36067,1.01412,5.30775,7.94943-1.125,9.24999-12.5809,0.0796-22.6175-0.234-32.0938-9.375-7.18776-6.5628-11.2342,1.25694-9.15624,5.68746,3.52134,13.6583,23.0063,17.483,42.7187,13.0625,7.63344-1.26414,3.06252,6.91542,0.90621,7.00002-8.23662,5.90562-22.9827,11.6841-35.9688-0.0625-5.94243-4.55022-9.96016-0.7254-7.74999,5.84379,5.76216,17.1274,27.8037,13.5302,42.9375,5.09373,3.89529-2.17143,7.43049,2.88045,2.68749,6.71877-18.8201,13.1503-28.2298,13.2999-36.7187,8.24998-10.6275-4.1913-11.5623,7.59637-5.25,11.4688,7.01595,4.30398,24.8701,1.07703,37.9688-7.15626,5.61537-4.17483,5.86944,2.35305,2.31246,4.93749-15.5442,13.4334-21.671,16.971-37.875,14.7812-8.03511-0.6264-7.91442,9.2799-1.59372,13.1562,8.62983,5.29245,25.4827-3.49245,38.5625-14.3438,5.50521-2.94165,6.40935,1.88271,3.68748,7.59375-7.99209,10.0832-15.4932,16.0281-22.7187,18.7812-7.22556,2.75319-14.1755,2.31453-19.0938,0.6246-6.00021-2.06145-6.75261,4.17429-3.43746,9.84375,1.99836,3.41748,10.2797,4.51332,19.2187,1.34379,8.93907-3.16908,18.5358-10.6026,25.125-19.3125,5.73291-5.01894,5.01993,1.72368,2.40624,6.46875-13.1944,20.8587-25.262,28.5963-41.1562,27.2812-7.04754-1.19673-8.6481,4.28364-4.1562,9.34375,7.88742,6.54111,17.7493,6.336,26.375-0.1251,7.66818-7.39323,22.3379-23.3134,30.0312-31.8438,5.42133-4.32189,7.1532-0.0612,5.56254,8.71875-1.44666,5.02803-5.06826,10.3234-14.9375,14.1875-6.74226,3.84804-1.67904,9.15142,3.375,9.25,2.78136,0.0542,8.42922-3.19716,12.75-8.06247,5.68422-6.40053,6.02226-10.6976,9.15625-20.6562,2.96091-4.85442,8.24949-2.58858,8.25003,2.50002-2.53647,9.97519-4.71582,11.7638-9.84375,15.8438-4.90482,4.60494,3.41523,6.13962,6.21873,4.24998,8.11044-5.46678,11.0713-12.5383,13.7812-18.9688,1.95606-4.64166,7.63038-2.39148,5.00004,5.18751-6.28605,18.1128-16.6152,25.2447-34.6875,28.9062-1.83159,0.3258-2.94876,1.40661-2.31246,3.53124,2.42559,2.51811,4.85559,4.80303,7.28127,7.3125-11.1751,3.25377-20.2541,5.08171-31.4377,8.34421-5.48685-3.59721-9.9194-6.64909-15.4062-10.25-1.44684-3.38229-2.12149-8.54505-10.2188-4.90626-5.48685-2.53413-8.01783-1.60488-11.0625,0.93753,4.39542,0.1638,6.30783,1.34091,8.03124,3.34377,2.25009,5.92614,7.43877,6.49863,12.75,4.81248,3.45528,2.91078,5.29542,5.1435,8.74998,8.06247-6.44922-0.2205-10.9422-0.3348-17.375-0.531-6.1407-6.5934-11.042-6.23223-15.4375-1.06245-3.35007,0.5148-4.77018,0.5868-7.06248,4.65624,3.60513-1.4796,5.87322-1.92312,7.43751-0.3123,6.52869,3.78495,10.7938,2.94012,14.0313,0,6.29874,0.3852,11.9746,0.711,18.2812,1.125-2.3166,1.96911-5.49585,3.01365-7.81254,5.00004-9.4603-2.70648-14.3979,0.93663-16.0625,8.65629-1.26783,3.11571-1.86147,6.32349-1.31247,9.65626,0.91566-3.04839,2.38788-5.66937,5.09373-7.3125,8.43201,2.14182,11.6026-1.3005,12.0625-6.34374,4.06449-3.31632,10.1935-4.04766,14.25-7.40628,4.743,1.51839,7.03575,2.45889,11.8125,3.96873,1.6983,5.16078,5.5413,7.20423,11.7812,5.87502,7.42797,0.2331,6.11667,3.28095,6.71877,5.71878,1.97406-3.50109,1.91907-6.90588-2.65626-10-1.66464-4.52241-5.35275-6.57918-10.1875-3.96873-4.55094-1.29204-5.7474-3.1491-10.2812-4.43754,11.4681-3.65526,19.603-4.47777,31.0625-8.12502,2.86848,2.70585,5.14188,4.64841,8.03124,7.06248,1.5228,0.90891,2.98053,1.13787,3.87504,0,7.18083-10.3932,10.3879-19.5528,17.0625-26.4062,2.54997-2.83554,5.77161-6.66135,9.34375-7.59375,1.78605-0.4662,3.97638-0.1818,5.37498,1.34379,1.3986,1.52541,2.49723,4.33683,2.0313,8.53128-0.6687,6.02082-2.12337,7.9218-3.81249,11.5312-1.68912,3.60954-3.75336,5.82975-5.87502,8.59374-4.24341,5.52789-9.8424,8.74539-13.1562,10.9062-6.62769,4.3218-9.43073,2.43027-14.5625,2.15622-6.63273,0.7443-8.39754,3.97467-2.96874,8.4375,5.07492,2.64051,9.63652,2.96649,13.3438,2.28123,3.18312-0.5886,6.90831-4.6971,9.5625-6.90624,2.98764-3.4515,7.94097,0.6417,4.56246,4.65624-6.13935,7.29477-12.2738,12.1044-19.8438,12-7.95465,1.07055-6.46668,5.54004-1.18746,7.71876,9.50117,3.92121,18.0796-3.42351,22.4375-8.25003,3.36222-3.67839,5.75028-3.82185,5.15628,1.87497-3.33783,10.3136-7.89912,14.2977-15.3438,14.8125-6.03855-0.5607-6.1038,4.10058-1.6875,7.25004,10.0603,6.96321,17.3459-4.89474,20.75-12.0625,2.42568-6.46569,6.14619-3.39093,6.5313,1.93752,0.0502,7.11936-3.16674,12.9321-11.7812,20.2187,6.59115,10.5015,14.2752,21.1829,20.8749,31.7188l20.005-222.806-20-35.202c-2.08305-1.92312-9.12777-10.223-10.9686-11.375-0.6714-0.7173-1.07973-1.22409-0.0936-1.59372,0.95364-0.3573,3.18591-0.7578,4.68747-1.03122-4.2417-4.2489-7.87662-5.61159-15.9065-7.93728,1.95687-0.8334,3.86037-0.3483,9.625-0.6246-2.2886-3.24868-7.40028-8.22482-14-10.6254,4.35852-3.09852,5.20785-3.30617,9.53126-6.93749-7.48656-0.531-13.8798-1.95712-20.3125-3.90625-4.06692-1.90161-9.71539-3.51615-12.4687-3.56251zm0.7191,8.71875c3.95622,0,6.40629,1.35612,6.40629,2.99997,0,1.67238-2.45007,3.03129-6.40629,3.03129-3.93975,0-6.43752-1.48293-6.43752-3.15621,0.00071-1.64385,2.49777-2.87505,6.43752-2.87505z' fill='%23000'/%3E %3Cuse xlink:href='%23half' transform='matrix(-1,0,0,1,700,0)'/%3E %3C/svg%3E"

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3Crect fill='%23F2A800' width='1200' height='600'/%3E %3Crect fill='%230033A0' width='1200' height='400'/%3E %3Crect fill='%23D90012' width='1200' height='200'/%3E %3C/svg%3E"

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300'%3E %3Crect width='450' height='300' fill='%23000'/%3E %3Crect width='450' height='150' fill='%23ce1126'/%3E %3Cg fill='%23f9d616'%3E %3Cpath d='M231.115,91.82A58.5,58.5 0 1,1 187.916,195.244L179.358,205.685A72,72 0 1,0 232.526,78.394z'/%3E %3Cg id='s3'%3E %3Cpath id='s' d='M302.62435,142.35494C303.12516,147.43953 303.12516,152.56101 302.62435,157.6456L287.69659,156.17534C288.10106,152.06855 288.10106,147.93196 287.69659,143.82518z'/%3E %3Cuse xlink:href='%23s' transform='rotate(22.5,225,150)'/%3E %3Cuse xlink:href='%23s' transform='rotate(45,225,150)'/%3E %3C/g%3E %3Cuse xlink:href='%23s3' transform='rotate(-67.5,225,150)'/%3E %3Cuse xlink:href='%23s3' transform='rotate(67.5,225,150)'/%3E %3Cpath d='M199.32444,114.65618H250.67551L209.1325,144.84033 224.99998,96.000328 240.86746,144.84033z'/%3E %3Cpath d='M287.87869,216.3146C291.71694,220.02891 296.88529,223.69038 300.6338,227.01716C304.38231,230.34392 307.25434,233.10958 309.57908,236.88884C312.98624,242.42773 309.16023,248.7008 303.85486,245.01872C300.98581,243.02751 299.18307,237.65214 294.78788,233.20395C291.53252,230.43267 288.96764,227.52745 280.78551,226.1257C280.39268,226.05841 280.27777,225.22842 280.58665,224.86618z'/%3E %3Cpath fill='%23000' d='M231.36058,197.84505 251.60791,209.8174 256.00949,226.89558 279.24991,225.13494 289.46162,213.16262 251.60791,186.9291 231.36058,197.84505z'/%3E %3Cpath d='M279.66324,223.6894C253.62799,206.37539 237.07238,197.02622 212.12131,182.83938C202.31974,177.26634 187.0985,163.25747 199.1052,139.81914C199.86106,155.20638 260.67394,197.4423 286.3703,215.80679z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.5' stroke-linecap='round' d='M216.08561,167.51949C236.13137,186.41034 261.37565,201.82127 283.89761,218.85496'/%3E %3Ccircle id='c' cx='290.4' cy='222.297' r='1.008' fill='%23000'/%3E %3Cuse xlink:href='%23c' x='7.41957' y='6.4655991'/%3E %3Cuse xlink:href='%23c' x='13.93812' y='13.090317'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg width='800' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.0' height='500'%3E %3Crect width='800' fill='%2374acdf' height='500'/%3E %3Crect y='166.67' width='800' fill='%23fff' height='166.67'/%3E %3Cg id='rays'%3E %3Cpath id='ray1' stroke-width='1.1116' stroke='%2385340a' fill='%23f6b40e' d='m396.84 251.31l28.454 61.992s0.4896 1.185 1.28 0.8586c0.7902-0.3267 0.2988-1.5116 0.2988-1.5116l-23.715-63.956m-0.68 24.12c-0.3465 9.4278 5.4526 14.613 4.6943 23.032-0.7569 8.42 3.8673 13.18 4.9396 16.454 1.0733 3.2744-1.16 5.2323-0.198 5.6982 0.96336 0.4662 3.07-2.1207 2.3833-6.7756-0.68675-4.6549-4.2204-6.0368-3.3898-16.32 0.83-10.283-4.206-12.678-2.98-22.058'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(22.5 400,250)'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(45 400,250)'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(67.5 400,250)'/%3E %3Cpath id='ray2' fill='%2385340a' d='m404.31 274.41c0.45334 9.0538 5.5867 13.063 4.5787 21.314 2.2133-6.5249-3.1233-11.583-2.82-21.22m-7.6487-23.757l19.487 42.577-16.329-43.887'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(22.5 400,250)'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(45 400,250)'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(67.5 400,250)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays' transform='rotate(90 400,250)'/%3E %3Cuse xlink:href='%23rays' transform='rotate(180 400,250)'/%3E %3Cuse xlink:href='%23rays' transform='rotate(270 400,250)'/%3E %3Ccircle r='27.778' stroke='%2385340a' cy='250' cx='400' stroke-width='1.5' fill='%23f6b40e'/%3E %3Cpath id='loweyecontour' fill='%23843511' d='m409.47 244.06c-1.8967 0.00003-3.7131 0.82183-4.7812 2.5312 2.1367 1.9227 6.8565 2.1318 10.062-0.21875-1.3883-1.4954-3.3845-2.3125-5.2812-2.3125zm-0.0312 0.4375c1.8462-0.0335 3.5717 0.81446 3.8125 1.6562-2.1367 2.3504-5.5508 2.1463-7.6875 0.4375 0.9348-1.4957 2.4391-2.0677 3.875-2.0938z'/%3E %3Cuse xlink:href='%23uppalpebra' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cuse xlink:href='%23eyebrow_nose' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cuse xlink:href='%23pupil' transform='translate(18.862)'/%3E %3Cuse xlink:href='%23lowpalpebra' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cpath d='m395.75 253.84c-0.91341 0.16668-1.5625 0.97727-1.5625 1.9062 0 1.0614 0.87748 1.9062 1.9375 1.9062 0.62667 0 1.2025-0.2968 1.5625-0.8125 0.73952 0.55614 1.7646 0.61511 2.3125 0.625 0.0843 0.002 0.19312 0 0.25 0 0.54791-0.01 1.573-0.0689 2.3125-0.625 0.36 0.5157 0.93583 0.8125 1.5625 0.8125 1.06 0 1.9375-0.84488 1.9375-1.9062 0-0.92898-0.64918-1.7396-1.5625-1.9062 0.513 0.1809 0.84375 0.6765 0.84375 1.2188 0 0.7074-0.57124 1.2812-1.2812 1.2812-0.6804 0-1.2413-0.54015-1.2812-1.2188-0.20862 0.41637-1.0341 1.6551-2.6562 1.7188-1.6222-0.0636-2.4476-1.3024-2.6562-1.7188-0.04 0.6786-0.60085 1.2188-1.2812 1.2188-0.71001 0-1.2812-0.57385-1.2812-1.2812 0-0.54225 0.33075-1.0378 0.84375-1.2188z' fill='%2385340a'/%3E %3Cpath d='m397.84 259.53c-2.138 0-2.9829 1.9368-4.9062 3.2188 1.0687-0.42633 1.9096-1.2693 3.4062-2.125 1.496-0.85442 2.7717 0.1875 3.625 0.1875h0.0312c0.8532 0 2.129-1.0416 3.625-0.1875 1.4967 0.8559 2.3688 1.6987 3.4375 2.125-1.9233-1.282-2.7996-3.2188-4.9375-3.2188-0.4266 0-1.2716 0.23055-2.125 0.65625h-0.0312c-0.85334-0.42642-1.6983-0.65625-2.125-0.65625z' fill='%2385340a'/%3E %3Cpath d='m397.12 262.06c-0.8439 0.0374-1.9596 0.20675-3.5625 0.6875 3.8473-0.85434 4.6962 0.4375 6.4062 0.4375h0.0312c1.71 0 2.5588-1.292 6.4062-0.4375-4.2744-1.282-5.1242-0.4375-6.4062-0.4375h-0.0312c-0.80125 0-1.4372-0.3124-2.8438-0.25z' fill='%2385340a'/%3E %3Cpath d='m393.75 262.72c-0.24819 0.003-0.51871 0.005-0.8125 0.0312 4.488 0.42766 2.3306 3 7.0312 3h0.0312c4.7007 0 2.5745-2.5724 7.0625-3-4.7007-0.4266-3.2146 2.3438-7.0625 2.3438h-0.0312c-3.6075 0-2.4959-2.4215-6.2188-2.375z' fill='%2385340a'/%3E %3Cpath d='m403.85 269.66c0-2.1234-1.7233-3.8465-3.8463-3.8465-2.1233 0-3.8463 1.723-3.8463 3.8465 0.423-1.781 2.0166-3.0393 3.8463-3.0393 1.8333 0 3.424 1.2586 3.8463 3.0393v0 0z' fill='%2385340a'/%3E %3Cpath id='eyebrow_nose' fill='%2385340a' d='m382.73 244.02c4.9146-4.2729 11.11-4.9147 14.53-1.7086 0.837 1.1207 1.3733 2.319 1.5934 3.5696 0.4302 2.433-0.3303 5.0617-2.2367 7.7559 0.2151-0.001 0.6435 0.2124 0.8568 0.4266 1.6967-3.244 2.2967-6.5761 1.74-9.7454-0.1458-0.828-0.3735-1.643-0.6696-2.4357-4.7007-3.8452-11.11-4.2729-15.811 2.1377z'/%3E %3Cpath id='uppalpebra' fill='%2385340a' d='m390.42 242.74c2.7767 0 3.4186 0.6417 4.7007 1.71 1.2833 1.0683 1.9233 0.8541 2.1367 1.0683 0.2124 0.2142 0 0.8541-0.4266 0.6399s-1.2833-0.6399-2.5633-1.7086c-1.2833-1.0696-2.5633-1.0683-3.8463-1.0683-3.8463 0-5.983 3.2046-6.4094 2.9907-0.4266-0.2142 2.1367-3.6325 6.4094-3.6325z'/%3E %3Cuse xlink:href='%23loweyecontour' transform='translate(-19.181)'/%3E %3Ccircle id='pupil' cy='246.15' cx='390.54' r='1.923' fill='%2385340a'/%3E %3Cpath id='lowpalpebra' fill='%2385340a' d='m385.29 247.44c3.6327 2.7783 7.265 2.5644 9.4017 1.282 2.1367-1.282 2.1367-1.7086 1.71-1.7086-0.4266 0-0.8532 0.4266-2.5633 1.281-1.71 0.8559-4.273 0.8559-8.546-0.8541z'/%3E %3C/svg%3E"

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='500'%3E %3Crect height='500' width='1000' fill='%23006'/%3E %3Cpath d='M0,250 1000,0V500z' fill='%23bd1021'/%3E %3Cpath d='M107.14,250 1000,26.79V473.21' fill='%23fff'/%3E %3Cg stroke='%23000' stroke-width='1.72'%3E %3Cpath d='m832.04,306.06s-6.2429-5.108,1.135-13.337c-3.973-3.4049-0.2834-9.9312-0.2834-9.9312s-6.8111-2.5547,0.2834-13.054c-5.108-3.4049-2.8381-11.068-2.8381-11.068s-16.742-6.2429-0.85018-12.201c-13.054,5.6748-25.257-7.6626-25.257-7.6626l-19.012,0.56816c-3.2161-15.797-28.283-2.0814-9.6482-47.39-4.8242-0.85142-10.216-2.27-15.607,1.7027-5.3916,3.9728-20.715,12.486-29.796,3.9728-9.0806-8.5131,5.9593-20.715,6.2431-20.999,0.28367-0.2838,20.148-10.5,22.986-17.31-0.28381-5.108-6.5269-9.0806-0.85142-20.148,6.5267-10.5,46.538-20.432,64.701-23.837,8.7962-3.9728,12.769-11.635,12.769-11.635l1.9865,7.378s40.296-11.918,42.282-17.594c1.9865-5.6755,0.85156,5.1078,0.85156,5.1078,15.891-1.4189,36.038-15.04,38.876-8.7969,13.337-2.5539,38.877-13.905,38.877-13.905s8.7962-0.28364,2.5533,9.3646c3.973,6.2429-1.135,11.635-1.4184,11.635-0.28477,0,1.7017,6.2429-3.4062,9.6482,1.7045,5.3916-3.1215,9.6482-3.1215,9.6482s2.2713,6.5267-6.8097,9.932c0.85157,5.6755-5.108,6.8106-5.108,6.8106s0.85156,5.9593-3.1215,8.5131c0,4.5404-4.5398,6.8106-4.5398,6.8106s2.8367,1.7026-1.1363,4.5404c-3.9716,2.8377-45.119,28.093-45.119,27.81,0-0.28366,30.08,5.3917,32.066,6.5268,1.9865,1.1351,24.688,16.175,24.688,16.175l-22.987,28.377s-25.539-2.8367-26.673-1.4184c-1.135,1.4184,5.3914,1.9865,6.8097,4.2564,1.4197,2.2699,3.6896,7.6627,8.2294,7.0945,4.5412-0.56816-8.5129,8.2295-17.026,9.081,0,3.1215,10.783,3.4049,13.621,0.85155,2.8381-2.5547-6.8111,7.3779-7.9461,8.7962s12.771-1.9865,12.771-1.9865-2.2713,9.3644-14.472,12.202c4.8232,7.946,2.8367,13.054,2.5533,13.054-0.28339,0-7.946-7.946-15.324-6.5277,1.9865,7.6627,7.9461,14.756,9.6492,15.892,1.7017,1.135-13.337,0.85018-15.324-3.4062-1.9865-4.2564-3.6896,10.216,1.7018,14.757-6.2416,0.2834-11.634-3.4062-11.634-3.4062s-3.6882,8.5128-1.135,12.771c2.5547,4.2564-8.7962-8.5142-8.7962-8.5142l-21.567,9.081-4.8246-8.2294z' fill='%239c3900' stroke-linejoin='round'/%3E %3Cg fill='%23ffc221'%3E %3Cpath d='m665.36,289.17c0.50543,0,31.331-0.50627,45.48-8.5913,7.0747,11.117,16.676,18.697,16.676,18.697l4.5481-16.17s11.117,0.50489,12.128,3.032c-1.516,3.0307-2.0213,7.0739-2.0213,7.0739s7.58,0.50627,8.0853,1.516c0.5053,1.0111-2.0213,9.601-2.0213,9.601l32.342,7.5801s2.5266-12.633,5.0532-11.117c2.5268,1.516,13.644,17.181,29.31,18.192,15.665,1.0111,16.676-13.139,16.676-13.139l3.5369,2.0223s6.569-14.149,7.5801-14.149,2.5272,2.0209,11.117,2.0209c2.5272,3.032,3.5383,10.106,3.5383,10.106s-9.6024,9.6024-6.5704,17.183c3.032,7.5801,3.5383,5.5578,3.5383,5.5578l69.736,16.676s3.5383,5.5592-2.5258,8.5913c0,0.50489-70.242-16.171-70.242-16.171s-6.5704,7.5801-11.623,6.0641c-5.053-1.516-1.516,3.032-1.516,3.032l75.8,6.0641s5.5592,7.0752,1.516,9.0962c-5.053,0.50488-81.864-5.053-81.864-5.053s-4.5481,9.601-9.601,1.516c-3.5369,5.5578-7.5801-1.516-7.5801-1.516s-6.569,5.053-7.5801-0.50626c-5.5592,4.0432-9.0961-2.5258-9.0961-2.5258l-32.341-2.0223-2.0213,3.032s5.5587,1.516-3.032,5.0543c-8.5907,3.5369,51.544,2.0209,53.06,2.5258,1.516,0.50625-4.0418,5.0543-4.0418,5.0543s30.825,2.0209,36.383-4.5481c5.5592-6.5703-2.0209,8.5899-2.0209,8.5899s24.256-1.0098,24.256-2.0209-0.50626,7.5801-17.181,6.569c10.106,6.5704,22.739,10.612,22.739,10.612s-12.633,3.032-27.287-0.50488c2.5258,6.569,13.644,12.633,13.644,12.633s-8.0864,7.0752-26.279-10.107c5.0543,9.0962,1.0111,12.634,0.50625,11.623-0.50625-1.0111-9.0961-13.644-29.309-18.192,12.633,8.085,7.0739,11.623,7.0739,11.623s-6.569-11.623-17.181,0c-4.0432-10.612-19.708-16.676-38.911-17.687-6.064-7.0739-9.6014-5.0529-23.751-9.0961-8.0853-9.0948-19.708-19.202-19.708-19.202s0.5053-13.644,14.149-12.128c1.516,4.5481,1.516,3.032,1.516,3.032s15.16-5.5592,19.708,2.0209c6.5692-11.623,15.665-1.7375,17.181,2.3043,4.3537,0.63832,26.278,1.2326,26.278,1.2326s-2.5272-4.5481-1.0112-4.0418c1.516,0.50488,13.644-4.5481,13.139-6.0641-0.50625-1.516-1.0111-6.569,1.0098-6.0641,2.0223,0.50489-17.181-2.5272-27.793,5.5592-3.5373-3.5383-1.0106-13.139-1.0106-13.139l-31.331-6.569-1.516,8.085s-9.096,1.516-8.5907-0.50487c0.50529-2.0223-2.0213,7.0739-2.0213,7.0739s-12.128-3.0321-12.128-3.5369c0-0.50489,3.5374-18.192,3.5374-17.687,0,0.50626-10.107,1.0112-24.256,11.623-4.0426-12.633-35.879-29.309-35.879-29.814z'/%3E %3Cpath d='m704.78,247.73s-21.224,18.191,0,28.803c1.0106-7.0752,2.5268-8.085,2.5268-8.085s17.687,6.569,28.299-9.0961c-4.5481-6.569-12.633-4.0418-12.633-4.0418s-16.676-0.001-18.192-7.5801z'/%3E %3C/g%3E %3Cpath d='m722.47,255.82-14.655,12.633' fill='none'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m705.48,247.88,0,0s2.8377-2.8381,3.6891-6.2429c0.85129-3.4049-1.1351-7.0945,2.2702-10.216,3.4051-3.1215,48.241-22.134,51.93-25.823,3.6891-3.6888,10.499-11.634,11.351-13.337,0.85129-1.7027,3.4053,8.5131-4.2566,13.054,8.2293-2.2707,13.621-4.8243,17.026-3.6892-3.4058,4.8242-12.486,12.77-16.743,12.77,9.932-3.6896,19.012-6.8111,21.567-4.8246,2.5533,1.9865-12.202,11.919-18.162,12.486,9.932-2.5533,23.27-6.5263,24.971-2.2699-5.3914,1.7031-3.6896,3.1201-14.756,9.3644-1.4188,1.1363-8.5131,1.4184-8.5131,1.4184,8.5131-0.85156,20.147-4.2564,21.282,1.9865-6.8097,2.5533-9.3639,5.9595-15.039,7.3779-5.6755,1.4197-18.729,3.973-26.675,7.0945-7.9455,3.1215-19.58,12.202-19.58,12.202s-25.256,0.85155-25.256,0.56678c0-0.28339-4.824-11.634-5.1078-11.918z' stroke-linejoin='round'/%3E %3Cpath d='m921.99,230.57,49.092,9.3644s5.3928-6.2429,2.5547-9.6478c7.3779-1.7017,5.3914-11.351,5.3914-11.351s8.5128-3.6883,1.4183-12.202c4.826-4.8239-1.135-8.5128-1.135-8.5128s1.9865-8.5131-4.2564-9.3644c1.7031-6.8104-10.783-9.0807-10.783-9.0807s-25.823,7.0944-43.985,7.6618c5.9595,5.9593-2.2699,9.6482-2.2699,9.6482s4.8246,3.4053,3.4049,6.2429c-1.4183,2.8382,0.85157,5.9597-5.3914,7.9462,8.2294,3.6896-0.85156,9.9312-0.85156,9.9312s9.081,6.2429,6.8111,9.3644z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m742.17,293.72-6.5694,29.309'/%3E %3Cpath d='m748.24,304.83-2.0213,9.601'/%3E %3Cpath d='m780.58,312.41-3.032,9.0962'/%3E %3Cpath d='m836.67,374.06c-0.50489,0-16.17,2.0209-18.192,1.516-2.0209-0.50489,24.761,8.085,24.761,11.622'/%3E %3Cpath d='m808.37,377.6s-15.666-10.106-18.192-9.0961c-2.5269,1.0111,15.665-0.50489,17.181-2.0209'/%3E %3Cpath d='m776.03,365.98s-16.171,0.50488-17.687-1.0111,15.665,11.117,18.697,10.107'/%3E %3Cpath d='m744.7,358.9c-0.5053,0-11.117-4.0418-15.665-5.0543,4.0426,4.0432,7.0747,9.6024,17.181,11.623'/%3E %3Cpath d='m748.74,352.34c-0.50529-1.0111-20.213-7.0752-20.213-10.107,4.5481,1.516,11.117,3.5369,17.181,2.0209'/%3E %3Cpath d='m853.35,329.09-2.0209,9.0948'/%3E %3Cpath d='m767.6,343.56s3.3779,3.724,0.34585,8.2721'/%3E %3Cpath d='m838.69,347.28-5.5578,0.50625'/%3E %3Cpath d='m793.21,344.25,10.106,1.516'/%3E %3Cpath d='m820.4,318.26s0.2834,10.216-8.2294,9.9326c-8.5128-0.28477-5.6762,0.2834-5.6762,0.2834'/%3E %3Cpath d='m826.93,316.55s3.4049,1.135,2.5547,3.6896c-0.85155,2.5533,0.85018,9.9312-9.081,17.026-10.501,2.2699-9.3644-8.7962-9.3644-8.7962'/%3E %3Cpath d='m830.62,319.68s6.2429-3.6883,7.0945,2.2713c0.85018,5.9582-5.108,17.026-9.3644,18.729-4.2578,1.7018-9.081-0.28476-8.5142-3.1215'/%3E %3Cpath d='m838.28,322.23s5.6762-4.5412,7.3779,1.4184c1.7031,5.9596-4.5398,19.297-7.0945,19.58'/%3E %3Cpath d='m846.23,323.65s2.8381-1.4184,4.8232,0.28339'/%3E %3Cpath d='m837.15,344.08c-1.135,0.28339-5.9595,0.56678-7.6613-3.1215'/%3E %3Cpath d='m811.61,334.15c-0.28339,0-5.9582,0.28476-5.9582,0.28476'/%3E %3Cpath d='m833.46,356.57-0.56679-9.3644-2.2699-3.1215-3.973,3.973s-0.56816,9.3644-2.2699,10.216'/%3E %3Cpath d='m826.65,347.77c-0.28339-0.56678-3.1215-5.9582-3.1215-5.9582l-4.8246,5.9582s-0.5668,8.5142-2.2699,9.3658'/%3E %3Cpath d='m818.7,347.49c0-0.28339-1.9865-5.6748-1.9865-5.6748s-5.6748,3.1215-6.2429,5.3914c-0.56679,2.2699-0.85156,8.5128-2.2699,9.081'/%3E %3Cpath d='m810.47,346.07s0.56816-5.108-1.135-5.108c-1.7018,0-9.3644,7.0945-9.6478,13.337'/%3E %3Cpath d='m717.39,245.9s0.28382-5.6748,2.8377-7.6613c2.554-1.9865,15.324-6.8111,18.161-11.068,2.8377-4.2564-4.2566,7.3779-3.1215,10.499'/%3E %3Cpath d='m722.5,237.38s6.2431,2.2713,4.8242,7.0945'/%3E %3Cpath d='m57.344,126.01a3.9192,3.9192,0,1,1,-7.8384,0,3.9192,3.9192,0,1,1,7.8384,0z' transform='matrix(1.1946929,0,0,1.1946929,661.37184,90.106184)' stroke-width='1pt'/%3E %3Cpath d='m917.17,220.07,0,0s43.417,5.108,45.404,5.108c1.9865,0,9.6478,2.5547,11.068,5.108'/%3E %3Cpath d='m919.44,217.52,60.443,1.4184'/%3E %3Cpath d='m919.72,216.1s57.321-3.4049,61.294-9.3644'/%3E %3Cpath d='m921.43,203.61s57.606-6.2429,58.174-5.3916'/%3E %3Cpath d='m919.44,196.52s55.903-8.7969,56.47-7.378'/%3E %3Cpath d='m759.96,160.48s17.594,19.296,15.891,32.35'/%3E %3Cpath d='m774.72,182.61s5.6753,8.2293,7.9455,9.0806c2.2702,0.85128,22.134,1.9864,23.269,10.5,1.135,5.3916-4.2564,3.6885-3.4049,7.6616,1.4184,5.108,14.756,11.634,29.228,3.973'/%3E %3Cpath d='m818.42,217.8s11.918,17.594,29.512-1.4183'/%3E %3Cpath d='m838.85,224.05s14.472,7.6613,26.39-12.202'/%3E %3Cpath d='m849.92,225.75s7.0945,5.9596,21.852-1.9851'/%3E %3Cpath d='m892.2,215.82s21.85,4.5398,23.27,5.9596'/%3E %3Cpath d='m900.43,210.99c0.28339,0,15.324,0.56817,15.324,0.56817'/%3E %3Cpath d='m891.06,202.48s26.107-1.7026,29.513,3.6895'/%3E %3Cpath d='m879.71,194.25s36.607,1.4188,38.309,3.4053'/%3E %3Cpath d='m887.94,231.71s6.2429-1.7017,7.0945-0.85019'/%3E %3Cpath d='m873.75,247.03s8.2294,7.0945,18.73,3.973'/%3E %3Cpath d='m878.29,258.95s9.3644,4.2564,20.432,1.7018'/%3E %3Cpath d='m881.41,266.04s9.3644,6.2429,15.607,5.1066'/%3E %3Cpath d='m877.16,269.73s6.5263,4.8246,6.8097,7.3779'/%3E %3Cpath d='m868.08,275.41s1.9865,10.215,9.081,13.904'/%3E %3Cpath d='m863.25,279.95s-3.1215,13.337,4.8246,21.567'/%3E %3Cpath d='m855.02,290.45c0,0.28339-0.56679,6.2429-0.2834,6.8111'/%3E %3Cpath d='m803.94,238.8,15.324-0.85157s5.6748-2.2699,1.7017-5.9582'/%3E %3Cpath d='m822.96,235.4c0.28477,0,14.472,1.135,18.162,5.3914,3.6882,4.2564,8.2294,12.769,10.783,14.189,2.5547,1.4184,3.1215-0.56816,3.1215-0.56816'/%3E %3Cpath d='m848.78,252.14s-7.6613,13.054-1.7018,17.027'/%3E %3Cpath d='m844.52,266.61s-6.8097,9.081-1.4184,13.621'/%3E %3Cpath d='m841.69,279.1s-5.3914,8.7976,1.1363,14.756'/%3E %3Cpath d='m839.3,255.76c-0.36594,0.36594-6.591,4.7599-8.788,3.6621'/%3E %3Cpath d='m832.71,269.68s2.5629,2.5629,4.7599,2.197'/%3E %3Cpath d='m833.01,282.98,4.09,2.805'/%3E %3Cpath d='m833.56,293.17,3.5383,2.1351'/%3E %3Cpath d='m769.47,154.01s7.4602,3.8794,13.428,0c5.9688-3.8792,34.615-18.501,42.075-20.888,7.4591-2.3873,11.637-16.114,13.13-22.082'/%3E %3Cpath d='m832.44,127.15,41.777-12.235s6.8634-5.6697,7.1619-16.114'/%3E %3Cpath d='m878.39,110.14s41.776-4.1776,41.776-19.695'/%3E %3Cpath d='m913.6,101.19s43.866-11.936,48.044-16.412'/%3E %3Cpath d='m791.26,163.55s26.558-13.727,30.736-15.219c4.1766-1.4921,13.725-13.428-0.59705-13.428'/%3E %3Cpath d='m804.09,168.93c0.29852,0,21.783-14.025,28.945-15.815,3.8795-5.3712,1.7912-11.041-4.7737-9.8473'/%3E %3Cpath d='m834.82,149.53c0.59705-0.29839,11.638-0.59678,7.759,8.0569-5.6679,4.1776-30.139,16.412-30.139,16.412'/%3E %3Cpath d='m829.15,140.28,46.551-15.517s3.8795-8.0569-1.7898-9.2505'/%3E %3Cpath d='m912.71,101.49c0,0.29839,5.9692,3.5808,2.3882,8.9521-6.5648,3.8793-37.599,11.339-37.599,11.339'/%3E %3Cpath d='M959.85,96.712,915.99,108.95'/%3E %3Cpath d='m956.57,106.56-38.195,11.638'/%3E %3Cpath d='M953.29,116.11,919.57,126.25'/%3E %3Cpath d='m947.02,125.66c-0.89558,0-25.065,7.4602-25.065,7.4602'/%3E %3Cpath d='m941.65,133.12-15.518,6.2665'/%3E %3Cpath d='m937.77,141.47c-0.59705,0-13.428,5.6697-13.428,5.6697'/%3E %3Cpath d='m933.89,148.34-11.936,5.6695'/%3E %3Cpath d='m913.3,161.17s1.4926,0.59678,1.1941,2.3873'/%3E %3Cpath d='m883.16,177.58s5.0736,1.7903,0.29853,6.5649c-2.3868,3.2824-9.2502,2.3874-13.428,8.3553'/%3E %3Cpath d='m915.69,110.74s6.2677,1.4919,1.4926,9.5489c-12.534,4.7745-37.898,12.533-37.898,12.533s-1.1927,2.0889-4.4752,3.8793c-3.2824,1.7904-39.389,11.936-39.389,11.936'/%3E %3Cpath d='m917.78,119.99s6.8634,2.984,0,8.0569c-7.759,4.476-34.914,12.831-34.914,12.831s-0.29854,2.3871-1.4913,3.2824c-1.1941,0.89517-37.002,12.831-37.002,12.831'/%3E %3Cpath d='m919.57,128.04s7.1619,2.0889,0.89558,8.0568c-7.4604,4.4761-31.333,12.533-31.333,12.533s-2.3868,2.9839-6.2663,4.1776c-3.8795,1.1936-28.646,11.339-28.646,11.339'/%3E %3Cpath d='m921.36,136.1c2.0897,0.89517,7.759,1.7905,0.89559,7.1618-8.0561,3.5808-27.751,11.339-27.751,11.339l-1.7912,3.2824-31.332,13.428'/%3E %3Cpath d='m923.15,144.16s2.9839,3.581-3.581,7.7586c-7.1619,3.8792-22.678,9.8473-22.678,9.8473'/%3E %3Cpath d='m919.57,152.51s3.2824,2.0889-0.8942,5.0729c-4.7751,2.3873-23.574,12.235-23.574,12.235l-12.236,8.0569'/%3E %3Cpath d='m876.6,125.06c0,0.29839,5.0736,4.4761,3.2824,9.2505,4.4765,3.2824,3.581,6.8634,3.581,6.8634s6.2663,3.5808,5.3721,8.6537c6.2663,1.4921,5.9678,5.0729,5.9678,5.0729l-2.0897,3.2824s6.2663-0.29839,0.89558,7.7586c3.2824,1.7905,1.7912,3.8792,1.7912,3.8792'/%3E %3Cpath d='m893.61,166.24c-0.89558,0-21.783,7.7586-27.155,12.533'/%3E %3Cpath d='m843.18,156.99s6.2663-0.29839,5.3721,6.5648c7.1619-2.3873,5.6693,4.476,5.6693,4.476s8.3546-3.2824,6.8634,7.1618c5.3707-1.1936,4.4752,4.1776,4.4752,4.1776s4.7751-0.29839,4.7751,2.3873c3.2824-2.984,6.8634-1.492,6.8634-1.492s2.3868-3.2826,5.6693-2.3872'/%3E %3Cpath d='m848.85,163.26c0,0.59706-28.051,16.114-28.051,16.114'/%3E %3Cpath d='m854.22,168.33-21.187,13.13'/%3E %3Cpath d='m861.38,174.89c0,0.29839-18.502,11.041-18.502,11.041'/%3E %3Cpath d='m865.56,179.07s-13.13,10.743-16.114,10.146'/%3E %3Cpath d='m870.04,182.35s-7.4604,5.6698-13.727,8.3553'/%3E %3Cpath d='m877.79,179.97s2.3868,2.984-12.533,10.742'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23ed2939' width='900' height='600'/%3E %3Crect fill='%23fff' y='200' width='900' height='200'/%3E %3C/svg%3E"

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1280' height='640' viewBox='0 0 10080 5040'%3E %3Cdefs%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V1.5H7V3H6zM6,0H3V3.5H0V3z'/%3E %3C/clipPath%3E %3Cpath id='Star7' d='M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z'/%3E %3Cpath id='Star5' d='M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z'/%3E %3Cuse id='Cstar' xlink:href='%23Star7' transform='scale(2.1)'/%3E %3C/defs%3E %3Cg transform='scale(840)'%3E %3Crect width='12' height='6' fill='%2300008b'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23fff' stroke-width='0.6'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23f00' stroke-width='0.4' clip-path='url(%23c)'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23fff'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23f00' stroke-width='0.6'/%3E %3Cpath d='M0,3H6V0H8V4H0z' fill='%2300008b'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cuse id='Comwlth' xlink:href='%23Cstar' x='2520' y='3780'/%3E %3Cuse id='αCrucis' xlink:href='%23Star7' x='7560' y='4200'/%3E %3Cuse id='βCrucis' xlink:href='%23Star7' x='6300' y='2205'/%3E %3Cuse id='γCrucis' xlink:href='%23Star7' x='7560' y='840'/%3E %3Cuse id='δCrucis' xlink:href='%23Star7' x='8680' y='1869'/%3E %3Cuse id='εCrucis' xlink:href='%23Star5' x='8064' y='2730'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 27 18'%3E %3Cpath fill='%234189DD' d='M0,0h27v18H0V0z'/%3E %3Cpath fill='%23F9D616' d='M0,12h27v1H0v1h27v1H0V12z'/%3E %3Cpolygon fill='%23D21034' stroke='%23FFF' stroke-width='0.2' stroke-miterlimit='10' points='4.625,3.375 4,1.349609 3.375,3.375 1.349609,4 3.375,4.625 4,6.650391 4.625,4.625 6.650391,4'/%3E %3C/svg%3E"

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='520' height='340' viewBox='0 0 260 170'%3E %3Crect fill='%230053A5' width='260' height='170'/%3E %3Cg fill='%23FFCE00'%3E %3Crect x='80' width='50' height='170'/%3E %3Crect y='60' width='260' height='50'/%3E %3C/g%3E %3Cg fill='%23D21034'%3E %3Crect x='95' width='20' height='170'/%3E %3Crect y='75' width='260' height='20'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3Crect width='1200' height='600' fill='%233f9c35'/%3E %3Crect width='1200' height='400' fill='%23ed2939'/%3E %3Crect width='1200' height='200' fill='%2300b9e4'/%3E %3Ccircle cx='580' cy='300' r='90' fill='%23fff'/%3E %3Ccircle cx='600' cy='300' r='75' fill='%23ed2939'/%3E %3Cpath d='M680,250 689.567,276.903 715.355,264.645 703.097,290.433 730,300 703.097,309.567 715.355,335.355 689.567,323.097 680,350 670.433,323.097 644.645,335.355 656.903,309.567 630,300 656.903,290.433 644.645,264.645 670.433,276.903 680,250z' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='800' height='400' viewBox='0 0 16 8'%3E%3Crect width='16' height='8' fill='%23002395'/%3E%3Cpath d='m4.24,0h8v8z' fill='%23fecb00'/%3E%3Cg id='g'%3E%3Cpath d='M2.353283,0.5248529 2.8,-0.85 3.246717,0.524853 2.077197,-0.324853H3.522803z' fill='%23fff' id='s'/%3E%3Cuse xlink:href='%23s' x='1' y='1'/%3E%3Cuse xlink:href='%23s' x='2' y='2'/%3E%3C/g%3E%3Cuse xlink:href='%23g' x='3' y='3'/%3E%3Cuse xlink:href='%23g' x='6' y='6'/%3E%3C/svg%3E"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='1500' height='1000' viewBox='0 0 24000 16000'%3E %3Ctitle%3EFlag of Barbados%3C/title%3E %3Crect width='24000' height='16000' fill='%2300267f' /%3E %3Crect width='8000' height='16000' fill='%23ffc726' x='8000' /%3E %3Cpath id='h' fill='%23000' d='M 12000,4124 C 11740,4833 11475,5571 10908,6136 C 11084,6078 11392,6026 11590,6031 L 11590,9013 L 10748,9138 C 10718,9135 10708,9088 10708,9024 C 10627,8098 10408,7320 10156,6515 C 10138,6405 9819,5985 10065,6059 C 10095,6063 10424,6197 10372,6133 C 9924,5669 9269,5335 8633,5236 C 8577,5222 8544,5250 8594,5315 C 9438,6614 10144,8147 10138,9966 C 10466,9966 11261,9772 11590,9772 C 11590,9772 11590,11876 11590,11876 L 12005,11876 12100, 6000 z'/%3E %3Cuse xlink:href='%23h' transform='translate(24000,0) scale(-1,1)'/%3E %3C/svg%3E"

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='500' height='300' viewBox='0 0 20 12'%3E%3Crect width='20' height='12' fill='%23006a4e'/%3E%3Ccircle cx='9' cy='6' r='4' fill='%23f42a41'/%3E%3C/svg%3E"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='390'%3E %3Crect fill='%23ED2939' width='450' height='390'/%3E %3Crect fill='%23FAE042' width='300' height='390'/%3E %3Crect width='150' height='390'/%3E %3C/svg%3E"

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23009e49'/%3E %3Crect width='900' height='300' fill='%23ef2b2d'/%3E %3Cg transform='translate(450,300)' fill='%23fcd116'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-100 V 0 H 50' transform='rotate(18 0,-100)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='600' viewBox='0 0 5 3'%3E %3Crect width='5' height='3' fill='%23fff'/%3E %3Crect width='5' height='2' y='1' fill='%2300966E'/%3E %3Crect width='5' height='1' y='2' fill='%23D62612'/%3E %3C/svg%3E"

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1500' height='900' viewBox='0 0 150 90'%3E %3Cpath d='M0,0H150V90H0' fill='%23fff'/%3E %3Cpath fill='%23ce1126' d='M150,0 37,0l23,9 -23,9 23,9 -23,9 23,9 -23,9 23,9 -23,9 23,9 -23,9H150'/%3E %3C/svg%3E"

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='500' height='300'%3E %3Cdefs%3E %3Cg id='b' fill='%231eb53a'%3E %3Cg id='s'%3E %3Cg id='t'%3E %3Cg id='c'%3E %3Cpath id='h' d='M0,-20V0H20' transform='rotate(30,0,-20)'/%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(120)'/%3E %3Cuse xlink:href='%23c' transform='rotate(240)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' fill='%23ce1126' transform='scale(0.82)'/%3E %3C/g%3E %3Cuse id='star' xlink:href='%23b' x='250' y='106'/%3E %3C/defs%3E %3Cpath d='M0,0H500L0,300H500z' fill='%23ce1126'/%3E %3Cpath d='M0,0V300L500,0V300z' fill='%231eb53a'/%3E %3Cpath d='M0,0 500,300M500,0 0,300' stroke='%23fff' stroke-width='40'/%3E %3Ccircle cx='250' cy='150' r='85' fill='%23fff'/%3E %3Cuse xlink:href='%23star'/%3E %3Cuse xlink:href='%23star' transform='rotate(120,250,150)'/%3E %3Cuse xlink:href='%23star' transform='rotate(240,250,150)'/%3E %3C/svg%3E"

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 15 10'%3E %3Crect fill='%23E8112D' width='15' height='10'/%3E %3Crect fill='%23FCD116' width='15' height='5'/%3E %3Crect fill='%23008751' width='6' height='10'/%3E %3C/svg%3E"

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%23cf142b'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m767.32,145.154v253.639c3.0024,36.3156,78.6864,59.178,131.454,97.7484,69.2124-46.422,136.34-55.812,139.039-107.858l0.8424-243.529h-271.33z'/%3E %3Cg fill='none'%3E %3Cpath fill='%232f8f22' stroke='%23000' stroke-width='0.45648' d='m767.292,395.158,2.8344,14.4852,9.4464,11.3376,68.34,44.0856,50.0724,31.1796,97.626-53.2224,33.6972-25.8252,6.6144-33.696-4.0956-7.872,0.9456,8.1876-2.5212,6.6132-2.832-1.8912-1.8888-12.2808-0.3168,9.1308-4.7232,5.3568-0.9444-6.6168,1.26-4.722-1.89-5.3532-0.63,10.7064-2.5188,4.7256-2.2056-3.1512,0.9456-4.7256-0.3144-4.4064-1.5756-2.2068-0.3168,4.7256-0.9432,1.5732,0.3156,2.8332-1.89,1.8912-1.26-3.7776,0.6312-3.4668-0.6312-3.1464-1.26-3.4668,0.3168,5.67-3.15,6.9276-2.52,1.5744-1.5744-1.89,0.3168-6.6132-2.2056-3.7776,0.6288,8.1876-3.1476,7.2444-1.8888-2.2068-0.948-2.2032v-3.4668l3.4668-8.8164-3.4668,3.15-2.832,7.5564-1.26,2.2032-1.5744-3.7776,2.2056-8.5032-1.2612-1.572-2.8332,10.3908-2.5212,1.5744-1.8888-0.6312-1.2588,0.6312-152.425,8.5032-4.0944-5.9844-0.9432,5.9844-2.5212,2.2032-2.5176-11.0232-1.89,11.6544-2.5212-5.6688,1.2612-12.9144-1.2612-0.9432-1.8876,6.9276v9.7632l-0.9456,6.6132-1.89-1.26-2.5188-5.9832-0.3144-9.7644,0.9432-6.9276-2.5188,8.1876v10.0788l-0.3144,5.0364-3.1512-6.9276-1.5744-5.67-3.1488-6.612,1.89,8.5032v4.41l-5.3544-4.7256-2.8332-13.2252-0.63,9.7632,1.26,4.722-1.5744,1.8912-3.1488-5.67-1.8888-7.5564-2.2044-7.2444v11.6508l1.5744,6.3-1.26,1.5756-2.5188-1.26-0.9456-6.9312-0.6312-10.0752-2.5176,6.9276-0.6312,7.2408-0.9444,5.67-1.5744,3.7812-4.4088,0.3228z'/%3E %3Cpath stroke='%234dcf4a' stroke-width='0.91284' d='m876.022,472.104c-0.8184-14.8848,12.6432-29.772-23.5932-44.6604'/%3E %3Cpath stroke='%2338bb26' stroke-width='1.14108' d='m910.572,463.678c0-19.662-11.2356-28.0872-33.7068-25.2792'/%3E %3Cpath stroke='%2351c757' stroke-width='0.91284' d='m922.368,472.104c-11.8752-14.298-27.7368-12.642-46.3464,0'/%3E %3Cpath stroke='%2351c757' stroke-width='0.91284' d='m951.86,453.566c-4.5108-8.406-20.9736-2.8692-38.7612,4.2168'/%3E %3Cpath stroke='%237acb73' stroke-width='0.82164' d='m1011.69,426.602c-4.494-12.9204-12.3576-20.2248-23.5944-21.9096'/%3E %3Cpath stroke='%234cb135' stroke-width='1.14108' d='m1026.86,406.376c-2.9808-6.6744-6.1008-13.0752-13.482-10.9548'/%3E %3Cpath stroke='%2360c85a' stroke-width='1.278' d='m845.686,459.466c3.9252-13.476-0.3324-18.7692-7.5828-21.0672'/%3E %3Cpath stroke='%2371ce5b' stroke-width='1.1868' d='m781.645,409.747c7.5-3.2556,13.4892-9.5316,24.4356-5.8956'/%3E %3Cpath stroke='%2371ce5b' stroke-width='1.1868' d='m772.375,401.323c6.1248,0.1284,10.4016,2.5188,11.796,8.4252'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.45648'%3E %3Cpath fill='%23000' d='m905.36,150.642c-3.54226,3.25938-7.17643,6.25083-12.2809,4.95671-3.49269,1.43202-0.1051,9.6721-5.79256,7.97449-5.51847-4.36808-4.05772,5.21006-7.59441,7.21367-3.23212,1.03309-9.23263,2.62193-4.48171,6.4602,2.90371,2.83623,5.69451,7.76316,0.94071,10.2349-2.75484,5.18425-3.34176-4.77529-7.4259,1.07401-1.32405,5.91639,8.79055,4.62676,4.08827,9.21187-0.78856,2.74357-3.59803-6.76192-6.44736,0.79472-2.21447,3.12776-2.29966,7.74438,1.95225,9.14175,3.62127,2.07886,11.2149-1.08347,6.69187,5.02064,0.00071,3.60178-5.94797,9.58271-3.68958,2.80003,4.0639-4.71862-1.8354-6.02381-4.50767-2.80487-5.48606,3.74093-3.207,12.0658,2.15222,14.4675,1.58725,3.3247,3.19831,4.20255-0.81863,8.20386,0.54947,4.0071-0.28217,7.45192-5.56777,7.20054-2.95045,2.79703-4.93387,7.46347-10.5468,6.75851-5.38845,2.17173-6.74333-1.37286-7.75895-5.64889-1.74428-4.24891-8.86625-6.67841-11.4651-1.98322-3.11881-1.26246-7.17118-7.18853-10.3691-1.35643-2.84405,3.89495-7.34196-2.27757-10.3462,2.78933-3.49352,3.83808,2.17437,7.42167,2.99352,10.3485,4.67277,3.76705,2.15916,5.99326,1.16127,10.8641-1.69545,4.41349,6.18471,7.14548,3.74513,10.6827-3.50124,2.73566-9.13569,5.89127-7.78267,11.1306-4.96442,1.74934-4.29305,7.44363-2.75561,11.3861,2.50006,5.62804,13.0832,4.98976,12.577-1.90098,2.80156-0.3991,6.09545,5.68243,8.1378,8.63606-1.9793,2.07989-8.40314-0.42696-11.9477,1.37249-4.64835-0.47891-8.63578,4.57286-13.2739,5.25391-3.36265,1.9929-7.8415,4.58416-6.7234,9.42037,0.8343,4.06606,2.37229,8.11037,1.7734,12.29-2.22903,3.69492-4.13929,7.61192-3.95762,12.0699-1.96561,6.51342,2.42679,14.3677-3.14518,19.6989-1.57378,4.81798,2.70258,4.79602,4.60869,1.72367,2.58216,1.13252,4.21461-3.2789,3.97188-5.18394,2.26039,4.12424,3.04019-1.12915,5.08565,2.74261,4.13911-1.37458-0.94111-13.3054,1.65159-8.31367,1.97682,2.89796,3.02284,9.05703,5.87021,9.48817,3.1671-1.25364,1.55632-12.9016,3.84451-3.84111,2.47079,8.07865,3.75238,16.6026,7.83058,24.029,2.3965,6.98672,8.71819,13.5099,16.7166,12.1469,2.26668,2.14863-3.51443,6.58908-4.62453,9.62413-3.57381,2.7051-7.98711-0.78552-11.767-0.93801-3.78981,1.47298-8.14276,2.27747-10.8382,5.53593-1.72713,3.79253-3.04612,7.09939-3.4332,10.8552-0.88863,5.31036,0.13036,11.4231,5.4288,14.0472,1.32615-4.06475,0.32208-7.52903,5.988-7.1808,3.96282,2.27349-0.43644,8.10318,3.08723,11.6783,1.78178,3.71091,6.91704,8.34229,5.22056,1.031-2.01613-5.74223,3.3569-5.79493,6.61661-8.16246,4.29542-4.53022,4.97256-0.12594,4.39461,4.3024,2.40725,3.14858,7.21565-2.9313,8.38176-5.643,1.66418-3.14588,0.0985-9.92787,3.0556-8.5594,3.80813-0.98073,6.27449-4.46801,9.26253-6.94112,2.69313-5.24053,7.73558-0.0687,11.7046,0.68887,4.94459,2.13323,11.5753,1.37682,13.8037,7.37185-3.80873-1.882-8.25871,1.64004-6.864,6.3864,1.9254,4.86856,7.80907,3.45041,11.3493,2.75596,3.56187,1.46818,7.57486-3.00643,11.4073,0.29753,3.75006-0.8166,7.88442-0.30457,11.4062-2.17749,3.4679-2.8491,2.0463-9.28119-3.0312-8.2992,2.32392-3.43251,7.59164-4.39502,11.094-6.786,4.02682-0.36578,7.52934-4.83217,11.0583-4.16909,5.02567,3.47708,7.52356,9.09418,11.8431,13.1088,4.23568,0.49022,0.3119,6.3769,0.76513,9.97366-1.13344,4.34512,1.29721,10.359,4.92686,4.42063,2.18556-3.95092,8.19703-2.82151,8.52258-8.00637,1.67796-4.37996,2.81142,6.40087,7.104,5.8248,0.28878,3.34521-0.97692,11.5345,4.0692,6.1476,4.42932-4.06469,5.16729-10.2904,3.5904-15.8052,0.71023-4.51311,7.2393,2.71525,6.05479,5.95468,1.00747,4.16725,6.17809-3.60099,6.90937-5.97298,0.56765-6.08552,0.74611-13.2759-3.86336-17.9397-3.49944-1.73665-4.94891-7.1766-9.95409-6.97476-3.44514,1.89486-7.37505,5.50514-8.84411-0.82243-4.5437-4.03599,3.08055-4.31882,5.6258-6.17201,5.12321-3.23731,7.92808-8.79362,8.96725-14.5657,1.86359-5.29724,3.46296-10.6852,4.68515-16.1675,4.00765-1.44117,7.76437-4.3775,9.99505-6.80623,4.55375-8.55582,0.19862,6.4166-1.41842,9.93834,3.47934,1.53958,8.02677-1.24501,9.51677-4.9319,2.2413-2.48392,2.7348-12.2521,3.9023-4.42962,0.5192,2.70794-4.3038,10.7481-0.3951,9.32604,4.04-1.29321,7.2811-5.17916,9.1374-8.91988,1.6184-5.0203,3.2276-11.1261,1.1868-15.964,3.2478-2.22444-0.2354-11.5228-3.7512-6.4668-4.5133-0.851-3.2152-7.41982-4.0384-10.661,3.6967-5.2321,0.613-15.3666-6.5792-15.1198-3.63519-2.08391-6.535-3.01516-10.2622-4.42079-4.84246,1.51061-8.30162-3.06667-13.1193-2.27392-7.27824,0.36128,0.6124-7.96674,3.43543-5.09674,3.30081,4.25235,10.2938,6.27454,13.6909,1.07153-0.16107-3.9225-0.15243-9.32357-3.65476-12.394-0.69406-4.38556-1.86451-8.53282-4.88218-11.951-3.70561-5.44536,3.10924-6.71299,5.35331-10.1034,0.99678-4.38737-1.66522-9.19954-4.29157-12.7821,2.82357-2.82577,5.6705-8.06344,2.6352-11.652,1.12886-3.42185-6.57321-4.017-9.06677-3.68003-4.99081-0.33128-9.18147,4.22055-14.1507,4.56182-4.25118,3.46864-9.40421,5.39471-14.8732,4.01385-3.86818-0.96115-6.90044-5.20991-8.97502-7.73471-5.04291,2.76035-0.91474-5.44702-5.01013-7.84979-2.83276-3.88498-8.69936-3.05119-6.57192,2.6488-3.70572,4.52734-0.47388-6.08652-2.79033-8.26063-3.01597-7.27229-1.7811-2.05451,2.29253-0.0649,4.52782,3.1003,11.1217,1.2253,12.2539-4.33848-2.22247-3.30433,0.26012-9.82401-4.75208-9.3564-3.6689,0.56032-3.85351,9.49795-5.90822,2.19016-0.55728-4.03175-2.83103-7.38551-4.8648-10.8465,2.73143,4.79514,8.02254,9.97456,13.8913,7.01852,3.14999-2.05918,4.26721-7.17898,2.3745-10.2464,0.17684-10.6094-5.94865,5.63578-8.76097-2.75775-6.501-1.92597,12.4594-8.92611,4.68272-11.2458-2.64508,3.68241-8.39049,1.94873-8.9959-1.91707,3.27961-1.83593,6.40279-8.91899,4.23398-11.2631-4.73233-2.68508-6.56446-6.73855-5.5068-12.1777-2.7735-2.96986-9.86367,2.25059-10.2761-4.42963-0.23117-6.20499-5.88188,0.81895-8.98114-1.4233-2.33726-1.38202-4.71261-2.75526-6.92316-4.47896z'/%3E %3Cg fill='%23d40000'%3E %3Cpath d='m904.106,194.538c-0.3108,6.8796-6.2196,5.4348-7.908,3.5532-1.6236-6.2904,7.8012-8.0148,7.908-3.5532z'/%3E %3Cpath d='m907.309,194.143c0.6156,5.4336,6.8472,6.1884,8.0268,3.912,2.0592-5.1888-5.6772-8.4852-8.0268-3.912z'/%3E %3Cpath stroke-linejoin='round' d='m903.481,188.9v1.1904l-0.6552,0.12-0.2376-0.2976-0.1776-1.8468-0.3576-0.1776v-0.834l0.8328-0.0588v-0.7752h-1.0116l-0.3588,0.7752-0.18,1.0716,0.42,0.894-0.42,0.7152-0.7728,0.4164-1.0728,1.014-0.7164,0.3564-1.668,0.1788-1.3692-0.6564-1.3728-1.3104s-0.5952-0.9528-0.6552-1.1916c-0.0588-0.2376-0.4176-1.0716-0.4176-1.0716l-0.3588-0.894-0.6552-0.7152-1.0128-0.12-0.2976,1.2516-0.3564,0.4764-0.8352,0.1188-0.8916-0.774-0.5964-1.0128-0.6564-1.3116-0.5364-0.894-0.774-1.1304-0.3588-0.6552-0.3564-1.5504-0.8952-1.1316-0.5952-0.9528-0.9516-0.774-1.014-0.7752h-1.1916l-0.7752-0.5952-1.1292-1.0728-0.8352-1.1316-0.534-0.6552,0.1188-0.5964,0.4164-0.5376,0.894-0.5352,0.8928-0.06,1.014-0.2376,1.0128-0.5364,0.1788-0.7152,0.1788-1.1916,1.0716-1.9068,0.4764-1.3704,0.06-1.0716,1.5492-0.2388,1.4904,0.1788,1.0716,0.2988,1.1316,0.3564,1.3104-0.6552,1.0728-1.3716,0.3564-2.382,0.4764-2.2044,0.5376-1.2504h2.742l0.9504,0.6552,0.7752-0.3564,0.714-0.3576,1.7292,0.1776h0.8928s0.7152-1.1316,1.014-1.3104c0.2964-0.1788,1.7268-2.0856,1.7268-2.0856l1.8468-0.4764,0.9528,0.12,1.3116,1.4904,1.0716,0.6552,0.954,0.06,2.2644,1.4892s0.7152,0.5952,0.954,0.4752c0.2376-0.1188,2.2656-1.0128,2.2656-1.0128l1.7844-0.1188,1.908-0.6552,0.6552,1.488s0.954,2.2644,1.2516,2.5032c0.2988,0.2376,1.4892,2.5008,1.4892,2.5008s0.5964-0.2976,0.8952-0.3576c0.2964-0.0588,1.6668,0.2988,1.6668,0.2988l3.9324,0.1788,0.5364-0.5964,0.4152,0.7152-0.534,2.7408,0.2376,2.0856,0.7152,2.8008,0.8928,1.3104,1.1928,0.0588,1.5492,1.3116,0.06,1.3104-1.1916,0.4176-1.0728-0.3576-1.3728,0.774-2.1432,1.2504-1.7892,1.788-1.5468,2.2032-1.014,2.2044-1.0116,0.7152-0.8952-0.3576-0.894,0.0588-0.4164,1.0728-0.894,1.0716-0.7752,2.7408-1.668,1.8468-1.728,0.834-1.2504,0.954h-0.8328l-1.4304-1.3716-0.6552-0.5952-0.1776-2.1444-1.3728-1.074h-1.014l1.4904,1.1928,0.06,1.608-0.8328,0.714-0.4188-0.1188-0.4152-0.834h-0.4788l-0.06,1.608-1.7868,2.0856-1.7868-1.4892-0.06-1.9068-0.8916-0.1752z'/%3E %3Cpath d='m874.307,173.86,2.6616,0.0852,1.3752,2.0628,1.2024,1.2876,1.2012,0.9456,1.032,0.1704,1.9752,2.9208v0.3444l1.5444,1.374,0.4308,1.8024,0.1716,0.6012-0.0864,0.7728-0.8592,0.516-1.0308-0.1728-0.6012-0.4296-1.8876,1.632-1.2036,1.632-0.7728,0.1728-2.0628,2.232-1.0296,0.3444-1.632,1.2024-2.5764-0.0864-1.6308-1.9752-0.342-0.774-0.0864-1.5456,1.4604-1.0308,0.6864,0.7728-0.342,0.7728,0.084,0.9456,0.8604,0.3432,0.858-0.0864,3.0924-2.6628,0.7728-0.4296,1.8036-1.8024,1.1172-0.6012-0.0852-1.116-1.2888-1.9752-0.4284-1.374-0.3432-1.2888-0.342-0.9456-1.2036-1.3728-0.6876-0.774-0.258-0.7728-1.2012-0.9456-0.3432-0.1728v-0.5988h-0.005z'/%3E %3Cpath fill='%23a00' d='m926.009,183.908h1.3752l1.4604-0.6876,1.1172-0.9444h1.0296l0.6876,0.6864,1.1172-0.0852,0.6864-0.8592,0.258-1.0308,0.9444-1.2876,0.258-1.2888,0.8592-1.8036,0.258-1.2888-2.1468-0.0852-2.4912,2.148-1.89,0.0852-1.5456,1.632-1.2012,0.1704-1.2888,1.89-0.4284,1.1172,0.1716,1.1172,0.7692,0.5148z'/%3E %3Cpath stroke-linejoin='round' d='m899.472,201.173-1.6332,1.632-0.4284,1.4592,0.6864,1.4592,1.5468,0.258,1.1172-0.6,1.0296,1.2012,0.1716,2.0616,2.0616,2.232,0.9444,0.258,0.774-0.8592,0.858-0.8592,0.0864-0.858,1.3752-0.6012,0.3432-2.5764,0.774,0.9432,1.2864-0.7728,1.6332-0.1704v-2.148l-0.6012-1.4592-1.29-0.9456-1.974-0.8592-2.1468-0.7728-1.0308,0.0864-1.8924,1.1184-2.0604,0.6852-1.6308,0.0876z'/%3E %3Cpath stroke-linejoin='round' d='m912.4,200.641,3.1008-0.1416c2.1276-1.38,3.048-6.9996,4.512-10.7136,2.2716-2.9448,5.0604-3.8256,8.46-2.256l1.974,0.564,2.5368,1.9728h1.8312l1.2708,0.282,1.974,0.1416,3.5256-2.82-0.1404,2.9604-2.3976,2.1144-4.9344,1.8336-3.8076-2.2548-0.1404,0.564,8.178,9.0216h0.7044l1.41,1.41,0.7044-0.564,0.1416-2.3964,2.8212-2.5368,0.2808,3.6648,0.9864,1.8324v3.5244l-2.6784,3.384-4.2288,0.564-4.9344-3.1008-0.1404-1.41-4.5132-5.2164v2.256l2.6796,5.4984,0.4224,2.1144,0.9876,0.9876,0.7056,1.6932v2.1144l1.2672,2.9604,2.256,0.2808,0.5664-1.4088v-1.974l2.3964-2.3976,1.5516-0.1404,0.564,0.846-0.7056,0.7044-0.282,1.5516v0.9864l1.974,2.6784,0.5652,1.692-2.9616,4.5108-1.9752,0.5652-3.5232-0.5652-2.1156-1.4088h-1.128l-3.2436-4.9356-0.4212-2.3964-4.3716-6.9084-0.1428,1.41,1.6944,2.1156,0.8448,3.2424,0.8448,5.7804,2.538,4.9344,0.1404,9.1644,0.8472,0.9864h1.1256l1.4112-1.1268,1.1268-1.5504-0.282-5.358h1.5516l2.6784,1.5516,1.974,3.2424,0.7044,1.41v2.9604l-0.9852,0.1404-1.9752,2.1156-3.2436,1.4088h-5.6376l-1.2684-1.1268h-1.128l-0.8448-0.846h-1.5516l-4.3728-6.2028-0.1392-10.2924,0.564-2.2548v-3.102h-0.7044v3.102l-0.7068,1.9752-0.1404,2.8188,0.1404,7.7544,4.6524,7.4724,3.384,1.692,0.9876,1.128h-1.551l0.1416,1.128-1.2708-0.282-0.2808,0.564-0.7044-0.282-1.2708-0.8472-1.692,0.2832-1.1256,0.564h-2.9604l-1.2708-2.538-0.9852-1.974-3.384-3.102h-2.538l-0.564-1.8324,0.4236-3.2424,0.7068-2.9604v-7.896l-0.5664,9.024-1.5492,5.0748-0.5652,0.4236-0.1416,5.7792,0.9876,2.6796,3.9468,4.3704-2.6784,0.282-1.974-0.8448-2.1156,0.4212-3.2412-0.7044-3.6672-1.2684-2.3964-2.3964-1.128-2.6796-0.4236-2.6772-0.564-2.82,0.564-2.2548,0.282-2.256-1.1268,2.5368v6.0624l-1.5516-0.4224v-1.692l-1.2684-1.692-0.2808-2.256-0.4236-3.3828-0.1428-5.4984,0.1428-3.384,0.7044-3.8064-0.564-0.1416-0.4248,4.7952-0.2808,9.4452-0.9864,0.2832-2.2548,3.1008h-5.078l-1.974-1.6908,3.8076-4.0896-0.4224-3.2424-0.4248-3.8052-0.4224-6.486-4.3716,4.6524-4.9332,3.5256h-4.23l-2.3964-2.9616-0.4248-3.3828,0.2832-2.3976,2.5368-3.384,1.8312-0.2808,0.7068-0.7056,0.4224,0.564-0.9852,2.82-0.9876,2.1144,0.8448,1.974,2.3988,0.282,3.1008-4.7928,2.3964-5.64,1.8324-2.82v-1.5504l-1.6896,1.2684-1.9752,0.4236-5.7792,0.1416-3.3828-2.1156-0.5652-1.692,0.1404-1.5504,0.1428-2.1144,3.6648-2.3976,0.1404,5.0748,2.3988-1.974v-0.982l3.1008-4.0896,7.4724-6.6252h4.512l2.6772,1.974,1.1268,0.282,3.2436,3.102,0.1404,3.9468,3.8076,3.102-2.256,2.6784,0.138,1.4112,2.118,1.5504,1.9728-0.564,0.846,5.2164,2.3964,1.41,1.2684,0.1404,4.7952-5.64,2.1156-0.2808,1.2684-2.82-0.5664-2.256-0.5616-1.2768z'/%3E %3Cpath d='m858.209,249.643v0.8268l1.6572,2.2476-0.1188,2.3664-8.4,4.2588-3.6648,0.2376-1.8948,1.7736-4.8504,1.5384-2.1276-0.474,0.354-1.182,0.2364-2.0112-0.2364-1.1832-1.5372-0.828v-1.8948l1.8924-0.5904-0.5928-0.8268-1.0644-0.12,0.2376-2.4828,0.4728-0.9456,0.1188-0.5928-0.1188-1.1832-0.4728-1.0644-1.302-0.3564-3.7848,1.5396-0.5916-0.5928-1.7748,1.8924-0.9468,0.1188-0.1176-1.5384-1.8924-2.4852v-0.474l-3.5484-0.5904-2.4852,3.1944h-1.7748l-1.2996-0.9456h-1.0668l-1.1808,0.708-0.7116-0.2352-1.0644,1.8936h-0.5904l-0.7116-1.5396-0.9456-1.5372-0.354-0.948,0.474-1.8912,1.5372-0.9468,1.89-0.948,1.4232-0.2352,1.6548,0.9468,0.7104,1.536,2.13-2.01,2.1276-2.3664,1.7736-0.7092,2.2488,0.354,2.4852,3.3132,2.364,0.2352,2.8404-2.0112,1.0644-0.5916,2.604,0.3552,2.6028,1.4196,2.7204,4.0212,0.474,3.9036,0.5904,1.0656,4.7316-0.3564,4.968-0.9456,2.838-0.1128z'/%3E %3Cpath stroke='none' d='m861.049,244.319-1.302,5.7972,1.5372,1.656-0.1188,1.8924,0.8268,0.828,1.5384-0.828,1.5372-1.0644,1.5372-0.5928,1.7748-0.9456,0.2352-1.0656,1.8924-0.9456,2.0124-0.5928,2.6016-0.7092,2.604-0.3552-1.8924-1.302-5.442-3.5472-2.2488-0.2376-0.828,0.7092-3.192,0.1188-1.7736,0.4728-1.2996,0.7116z'/%3E %3Cpath d='m887.192,238.523-3.7848-0.1188h-2.4864l-2.01-0.8268-1.656-1.656-0.2364-1.5384-1.182-1.8924-1.1832-1.1832h-1.7748l-2.4828,1.656-1.0656,2.1288-0.2352,3.4308,1.4184,2.9568,4.7316,3.5496,2.7216,0.5904,1.8948-0.8256,4.2564-1.8936,2.7216-1.7736,0.9492-1.5384-0.5964-1.0656z'/%3E %3Cpath d='m878.083,233.08,2.1276-2.2464,0.1188-5.088-0.5916-0.4728,0.5916-2.0112,0.2364-1.656h-0.828l-4.614,4.3764-3.1944,0.4728-1.6536,0.948-0.12,1.182,1.302,0.828,2.3664-0.2364,1.2996,0.1188,2.9592,3.7848z'/%3E %3Cpath d='m879.976,246.448,4.1388-0.3552,3.3132,0.2376,1.656,0.474,3.3132,1.7736,1.8936,0.948,3.6672-0.2376-1.4196-1.7736-1.4208-1.7748-0.948-1.7748-0.2352-1.7736-0.8256,0.2364-0.948-0.2364-1.182-1.5372-0.7092-2.2488-0.4752-2.9568-0.9444-0.12-0.7116,1.4196,0.7116,0.7092,0.708,1.4196-1.1832,1.5372-0.1176,1.1844-1.5372,1.1832-2.13,0.9468-2.0112,0.8268-2.2476,0.828-0.3552,1.0644,0,0z'/%3E %3Cpath d='m910.26,241.006,0.1188,5.0868,1.7748,1.5384h1.6548l1.302-0.7092,0.3552-1.0644-1.1832-0.7092-0.474-1.4196-2.484-2.7216h-1.065v-0.001z'/%3E %3Cpath d='m929.543,245.028,5.0856,3.4308,1.5384,0.474,1.4196-0.474,2.3652-1.8924,1.182-2.6028,0.12-1.8912-1.182-0.1188-1.8924,1.302-2.7216,0.2364-2.1288,0.354h-1.6572l-1.6572,0.3552-0.4716,0.8268z'/%3E %3Cpath d='m944.21,241.126-0.9444,1.5384-0.9468,2.3652-2.13,2.2488,0.1188,1.6548h-0.948l0.1212,1.302,1.6536,1.2996,4.6152,0.7092,3.6684-4.7304v-1.302l-2.0124-2.3664-1.4208-0.354-1.7748-2.3652z'/%3E %3Cpath d='m965.74,254.375,2.3676,1.1832v0.828l-0.9468,1.302-0.5904,2.4828-0.2376,1.5384-2.8392,0.1188-2.9568-1.0644-1.6572-1.0644h-1.5372l-0.828-0.7092-1.4184-0.9468-1.776-1.1844-1.8912-2.4828-1.3008-1.656v-1.1832l1.7748-2.2476,1.7748-0.5904h7.926l3.666-1.302,2.9568-2.484,3.5496-0.7092,0.828-0.9468,2.3664-0.474,5.9148-3.0756,3.312,0.5904,3.3132-0.1176,2.838,0.8268,1.0656,0.9468-0.5916,0.3552-1.5372-0.1188-1.7748,0.9468-0.2376,3.1944,1.4196,2.6016-0.354,0.7104-1.7748-0.1188-1.182-0.5928-0.5928-1.0644v-1.0644l-1.1808-1.656-0.9468-0.354h-2.1276l-0.7104,4.494h-1.0668l-2.0088-1.7736-2.9592-0.3564-2.0112,1.7748,0.7092,2.3664,2.9592,2.8392h1.5372l1.4196,1.6548-0.12,1.3008-2.1276-0.474-2.13-0.4716-1.7736-0.8304-1.4208,0.2376-1.656-0.948-1.656-0.708-1.0644-0.474-0.714,0.9504z'/%3E %3Cpath d='m973.724,307.228-1.8816,1.7052-1.2552,2.4192-0.4476,2.508-0.8064,3.1368-0.3588,2.4192,0.3588,5.2872,0.18,2.8668,1.7016,2.6904,0.8952,0.2676,1.0752,2.1492,1.5228-4.2108,0.7188,0.5376,0.4476,3.1356,2.5092,2.1504s-2.3304-1.164-2.868-1.164-0.6264,0.6252-0.6264,0.6252l0.6264,1.344,1.4328,1.434,2.5104,0.984,4.6596,0.09-1.0752,1.0752h-3.2256l-0.8088,0.6264,1.1664,1.7028,1.4328,2.2392,2.6004,1.2552,2.6856-0.7164h0.8964l-0.4476,1.0752,1.344,0.984,1.164,1.0752,1.0764,1.1652,0.8952,0.1788v1.344l-1.6128,4.0332-0.36,1.8804-0.894,1.524-0.5376,2.328-1.6128,2.778-0.1788,0.9864h0.8064l1.164-1.5252,1.704-0.7164,2.0616-2.688s1.164,0.36,1.434-0.18c0.2676-0.5376,1.5228-4.3008,1.5228-4.3008l1.254-0.2688,0.6276-3.942,1.0752,3.6744,0.8976,4.6596-0.36,3.9432-2.3304,4.2996-0.6252,0.72,0.3576,1.4316h1.7028l1.9716-2.0628,3.4044-4.5696,1.3464-4.5696,0.7164-8.8716,1.5228,4.1232,1.434,4.0308,0.7188,3.1356-1.0764,4.122-1.344,4.8408,1.7928-1.2564,3.7644-4.212,2.9556-4.3884,0.8076-3.2256,0.7176-6.1836-0.4488-4.8384,0.1776-1.7928,0.6276-0.9852-0.09-3.2256-0.6264-1.344-2.1492,2.8668-0.8964,0.18-2.5104-1.7028-0.6252-0.18-1.434-2.0616-0.984-3.3156,0.088-3.7632h-0.5364s0.2688-3.1368,0.5364-3.9432c0.27-0.8064,0.6276-2.328,0.6276-2.328l-0.4488-3.3168-1.7016-3.1368-2.0616-1.7904-3.3144-0.9852-3.8556-1.0764-2.2392-1.7904-4.212-0.4476-2.1504,0.2688-4.032-1.8816-2.5992-0.9864-3.3144-0.0876-3.1368-0.36-1.6164,0.0936z'/%3E %3Cpath d='m829.548,307.424-8.2644-0.1644-1.3224-0.6612-1.9824,1.6512h-3.8016l-4.1328,2.3148-2.8092,2.148-1.4868-0.1644-5.7864,5.2896,0.8268,4.296,0.66,1.158,0.3312,4.1328,0.1644,5.9484-1.3212,0.9936-1.9836,4.9596-1.158,4.296-0.9912,8.43,0.8268,6.2796-1.158,3.306-2.3136,3.6372-0.4956,1.818,1.9824-1.3236-0.3288-0.6612,0.9912,1.4868,2.4768-4.4628,0.9936,1.6536,0.99,0.1644v-5.6196l-1.1556-8.76,2.8092,9.0924,0.6624,3.3048,0.4956-0.1668,0.33-7.4376,1.8168,4.1328,0.1668,3.6348,0.8256,0.6624,0.498-0.9924v-5.454l-2.9772-8.76-1.4868-8.1012,3.9672,10.5792,2.3148,2.148,2.148,5.7864,1.8204,3.3048,0.3288,2.148,1.3224-0.8256,0.498-0.8256-1.158-0.8268,0.8256-0.66-0.1668-2.9748-0.99-6.9396h-0.9912l-3.4716-7.2732,3.1404,4.464h1.3224l0.1656-1.1592-1.4868-2.9748-0.33-3.4716,2.9748,4.2984,0.99-0.4956-1.6524-4.7952-0.3288-5.454,0.9912,2.3136-0.1656,2.6448,2.1492,2.646,2.148,1.1556,1.6524-1.9812-1.158-0.828-0.4944-2.3124-1.6548-1.9836v-2.646l2.3172,4.1328,2.1468,1.488,2.1492,0.4956,2.1492-1.4868,3.6348-4.1328-0.4932-0.4968-3.804,0.1668-2.9748-1.9836-2.6436-2.478v-2.1492l0.4956,0.3288,1.1556,2.316,2.1492,2.1492,2.4792,0.3288,3.1416,0.1668,3.4692-3.1404,1.8204-5.9508,0.4956-3.306-0.6612-4.1316-2.1504-4.794-1.3224-2.1492-1.1568-0.4968z'/%3E %3Cpath d='m951.204,398.996-8.7624,9.0876-1.1568-0.3288-3.1404,2.6448-0.1644,2.8104,2.9748,2.316,1.158,2.148,0.8268-0.1668,2.9736,3.636,2.8116,3.9684,1.158,0.6624,0.8244,1.8168-1.4856,2.148,0.4956,1.3248,2.3136-0.3324,2.646,0.1668,1.6512,0.9912,0.6624,2.976v1.1544l1.818-0.99,1.488-2.1492,0.1656-5.2884-0.3288-1.4868,0.4932-3.9684,0.4956,5.2884,1.158,1.6536,0.8256-0.6624,0.9912,3.4728,2.1492,2.1492,1.158,1.9812,0.1668-1.32-0.1668-2.6448,1.158-2.976,1.3224-3.4704,1.3224-0.828,1.1556,0.4992,1.656,1.65-0.1668,0.6624,1.488-0.1668-0.3324-3.966-2.1468-2.976-3.3072-2.1456-1.6524-1.6524-1.4868-2.6448,2.3136,1.3212,2.4792,2.3148,2.3136,1.158,1.6536,0.3288,2.8116,5.4552,1.818,2.6448,0.33-3.636,1.3224-4.134,1.3236-1.8168,1.6524-0.1668,2.1492,0.6624-0.4968-2.4804-1.6524-3.1404-3.306-2.9736-3.4716-2.6448-2.9736-1.3248-2.6472,2.316-0.8256,0.3288-1.488,1.3248-1.1556-0.4956-3.8028-3.6396-0.9912-0.6588-1.6524-3.9684-2.4804-1.158-3.8016,0.3324-4.632-0.9936z'/%3E %3Cpath d='m851.863,396.848,0,0,1.158,1.9812,0.9924,3.1404,1.6512,1.8204-0.1644,0.99,2.3136,1.9824,2.3136,3.636,3.8028,3.1392-2.8104,2.4816-6.612,4.9596-2.1492,0.6624-2.8092-1.6572,0.33,3.9684,1.1568,1.8204-2.9748-0.6624-3.4728,0.3288-2.148,1.8204-0.4968,1.8168-0.8256-1.3212-1.158-1.8204-0.33-0.3288-0.66,0.4956,0.4956,0.3288,0.1644,3.306-0.8256,0.6624-0.1668,0.9912-3.8004,2.478-0.9912-2.478-1.3248-2.8104-2.3136-1.158-2.478,0.3324-2.8104,1.6524,0.8256-2.3148,1.6536-2.6448,3.1392-2.6436,3.1404-1.9824,2.4792-0.9912,0.6624-0.3324-0.828-0.8256-4.626,1.3212-3.3072,2.1492-3.4716,2.4804-2.6436,3.7992-1.3224,0.9912v-2.808l-1.4892-3.8016-0.4956-2.4816-1.488-1.8168h-1.8168l-2.4792,0.4956,1.8192-3.1392,3.6348-1.9824,1.6536-2.8104,2.9748-2.4816,2.4792-0.4956,3.6372,0.4956,1.8156,0.9948,3.474,0.1632,2.1468-0.1632,2.646-1.3248,2.1492-3.9684,2.9736-4.2948,3.474-1.8192,4.1328-0.3264z'/%3E %3C/g%3E %3Cpath fill='%23000' d='m892.877,173.292v2.0844l-0.7752,1.2504h-1.3704l-0.8328,0.894-0.2388,0.7152,1.5492,1.4292,1.4292,1.0128,0.5952,0.7164,0.3588,0.1776,5.958-0.06,0.714,0.7152,1.3116-0.9528,1.6104-2.4432,5.064,0.06,2.6796,1.9656,0.1788,1.6092,0.5964,0.2388,1.428-1.2504,1.1916-0.0588,0.5952,0.774h1.074l3.5148-3.1584,0.5964-0.834,1.3104-0.06-0.1776-1.0128-1.4292-0.3576-1.2504-1.2504-0.3588-2.0856-1.1316-0.1776-1.9656,1.0128-3.396,1.668-1.1328,0.834-1.0128,0.0588s-0.4164-0.3564-0.6552-0.3564h-1.3104l-1.074,0.894h-0.834l-0.2976-0.2988-4.5876-0.3576-3.8124-0.9528-1.968-1.3104-1.2504-1.0128-0.3588-0.3564-0.5352,0.2364z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m895.739,178.772h2.6208l0.6552,0.5364v0.714l-1.2504,0.5364-2.2056,0.1188-1.5492-0.2376-1.074-0.954-0.2364-1.9056,1.428-1.6092h1.3716l0.12,0.5364,0.12,2.2644z'/%3E %3Cpath d='m913.254,178.654-0.4164,0.3564v0.7152l0.534,0.3576,2.6232,0.12,2.8596-2.2632,0.06-0.8952-1.7256-1.4892h-1.4904l-0.2388,0.4164,0.3588,0.7752,0.4752,0.7152-0.4752,0.9528-2.5644,0.2388z'/%3E %3C/g%3E %3Cg fill='%2348489c'%3E %3Cpath fill='%235656a6' d='m819.408,249.526,1.5384,2.7192-0.1176,4.8504-0.5928,0.5928-2.2464-1.8936-1.1844-1.6548-1.1832-2.0112v-1.7736l1.1832-0.9468,1.5372-0.354,1.0656,0.4716z'/%3E %3Cpath fill='%235656a6' d='m824.141,257.33,3.4296-7.0968v-1.8924l-1.302-1.8948h-1.7748l-1.8912,1.7748v6.27l1.5384,2.8392z'/%3E %3Cpath fill='%235656a6' d='m830.054,257.33,1.8936-0.8268,4.614-4.3776,0.7092-1.3008-0.3564-1.0644-1.2996-0.9468-0.8268-0.2364-1.8936,0.828-1.0644,1.0644-2.13,3.7848,0.354,3.0756,0,0z'/%3E %3Cpath fill='%235656a6' d='m838.219,260.406-1.6572,1.1844-1.8936-0.1188-3.4284-2.3664,0.1176-0.474,2.1288-0.3552,1.8924-0.828,1.8924,0.1176,1.0668,0.9468,0.3528,1.0656-0.4716,0.828,0,0z'/%3E %3Cpath d='m970,256.975h2.7216l1.5372,0.828h3.0756v1.1844l-1.7748,1.2996-3.4308,0.9468-1.5384,0.7092-1.182-0.1188-0.828-1.0644v-1.656l0.7092-1.4196,0.7104-0.7092z'/%3E %3Cpath d='m988.808,253.31,0,0s1.8936-1.0668,2.2464-1.8924c0.3564-0.828,1.1832-2.604,1.1832-2.604l0.7116-3.0756-0.9456-2.6016-1.7748-0.4728-1.5372,0.1176-0.828,0.8268-0.2352,2.2488,0.8268,1.8924,0.7104,1.0644-0.1188,2.0112-0.2388,2.4852z'/%3E %3Cpath d='m981.71,254.255,0,0,1.8936-0.9456,1.1808-2.2476,0.1212-2.4852-0.9468-1.8936-1.302-1.4172h-1.7748l-0.474,3.3108,1.3008,1.302v4.3764h0.001z'/%3E %3Cpath d='m979.463,256.385,0.7092-0.828,0.3576-1.7748-0.7104-2.6016-1.0668-1.1832-1.2996-1.1832-1.4208-0.9456h-2.0124l-1.2996,1.0644,0.3528,2.13,2.3688,1.7736,1.8924,0.3552,2.1288,3.1932z'/%3E %3Cpath d='m988.106,250.757v2.1336l-2.1324,0.306-0.1524-2.8956,2.2848,0.456z'/%3E %3Cpath fill='%234f4d9f' d='m971.699,428.416-1.818,2.4804v4.1316l0.8256,1.9848-0.8256,7.7676,4.1328-5.784,1.4856-2.9772-0.1644-3.9648-1.158-1.8204-1.3224-1.1568-1.1556-0.6612z'/%3E %3Cpath fill='%234f4d9f' d='m985.418,419.824-1.3224,0.3288-1.488,3.1392-0.3288,4.1316,0.8256,2.148v2.9772l0.3312,1.8168,1.4856-2.1456,2.1492-3.6384,0.3288-2.6448v-3.6348l-0.9912-1.6536-0.99-0.8244z'/%3E %3Cpath fill='%234f4d9f' d='m949.384,441.308,2.1492-1.4868,1.6536-1.158,2.1504-2.808-0.3324-2.148-1.3236-0.9912-1.6524-0.6624-1.4868,0.1668-1.6536,2.3124,0.1668,4.6296,0.3288,2.1456,0,0z'/%3E %3Cpath fill='%234748a5' d='m848.724,426.766,1.6524,0.6588v4.464l-2.8092,3.1404-3.1392,2.3148,0.1632-2.976-0.8256-0.9876v-3.144l0.6624-0.8256v-1.4856l2.8092-1.4904,1.4868,0.3312z'/%3E %3Cpath fill='%234748a5' d='m827.234,429.409,2.3136-0.1656,2.4792,1.4856,0.9912,2.8116-1.4868,1.3236-0.8256,1.3212-0.4956,2.1492,0.33,3.4728,0.1656,3.1404-2.8092-3.474-2.3136-3.6348-0.1668-3.6348,0.8256-3.1404,0.9924-1.6548z'/%3E %3Cpath fill='%234748a5' d='m819.3,425.278-0.6612,2.3124-0.8256,0.4956-0.9912,1.3236v4.9572l-1.6536-0.9876-1.818-2.316-0.9912-2.4804,0.3312-6.2796,0.8256-2.6448,1.9836-0.6624,1.9836,0.6624,1.6512,3.8016,0.1656,1.818z'/%3E %3Cpath fill='%234748a5' d='m819.468,409.246-0.9924,2.4768-2.6448,1.9824c-0.4044-2.64,0.9552-4.026,3.6372-4.4592z'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.45648'%3E %3Cg%3E %3Cpath fill='%23dfda4d' d='m825.559,261.236,3.1932,2.9568,2.3676,1.5372,1.8924,0.7092,2.3664,1.302h4.9692l4.494-0.474,2.2476-0.828,4.3764-0.1188,3.5496-1.656,2.6016-1.7736,2.6016-0.1176,1.4232-1.4208h1.8912l3.7836-2.8392,5.3256-2.364,5.5596-2.0112,6.0348-1.1832,2.4828,0.1176,0.9456,0.7092,1.1844,2.0112,0.4716,0.9468-0.5904,2.0112-2.2464,1.302-0.474-1.4208,1.4184-1.1832-0.354-0.7092-2.2488-0.3552h-1.5384l-1.4172,1.4196-0.2376,3.1944,1.8924,1.6548,2.0112,1.302,1.7748,0.1188,2.13-1.2996,2.8392-2.4852,1.6548-2.8392-0.474-4.14-0.9456-2.604-2.8392-2.1288-3.5484-1.4208-6.1512,0.12-3.6672,0.9456-1.4208,0.474-3.9024,2.6016-1.7748,0.1188-3.9036,2.6016-1.5396,0.5904-1.7748,0.7092-2.7204,1.1844-5.2068,2.364-3.5472,2.13-1.7748,0.2376-4.1388,2.6016-5.916,0.474-1.0644-0.5928-2.7216-0.354-1.7748-0.7116-1.7736-0.9456-2.4828-2.9568-0.7116-0.474h-2.2476l-0.7092,0.948,0.3552,2.0136z'/%3E %3Cpath fill='%23d9d24d' d='m894.408,251.299,0.7104,5.9148-1.3008,3.666,2.7216,0.1188h3.192l2.8392-0.5928,2.7216-0.2364,2.4852,0.1188,2.0112,0.2364,2.4828-0.9456,0.1188-1.8924-0.5916-1.656,1.182-3.6684-0.474-0.828-18.0984-0.2352z'/%3E %3Cpath fill='%23d9d34a' d='m922.444,257.804-0.7092,0.474-1.0644-0.474-0.5928-1.6548,1.1832-1.0656,2.6016,0.1188,2.3664,2.1288v3.0756l-3.1944,1.5396-3.3108,0.828-3.6684-1.0656-2.2476-3.0756-0.5916-2.1288,0.474-3.6684,0.5916-2.3664,3.1944-2.3664,3.4296-1.0644,4.0212-0.5928,4.6164,1.1832,9.3432,3.5496,6.27,2.8392,6.9792,3.6684,4.1412,1.8924,5.442,2.6016,3.3132,1.1832,3.7848-0.474,1.656,0.1188,3.312-1.0644,2.2476-0.2376,4.968-5.7972,2.0112-1.1832-0.2352,2.6016-3.3132,3.6684-2.838,3.1944-1.182,0.1188-1.5384,1.2996-2.9568-0.1188-6.8616,0.3564-3.312-1.0644-5.2056-1.0656-6.1512-2.7204-4.8516-2.4852-2.3664-0.3528-3.6684-1.8936-2.2464-0.2364-1.3008-0.9468-4.0236-1.182-3.3132-1.1844-3.192-0.3552-2.4852-0.354-1.182,0.7092-1.1832,1.656-0.5904,2.2476,0.828,2.7216,1.4196,0.2376,1.302-0.5904,0.4716-0.9468-0.5916-0.2364z'/%3E %3Cpath fill='%23ddd457' d='m852.564,388.192-1.5108,1.5072-2.3736-1.5072,1.0776-2.8044,3.8832-0.648,2.1576,3.2352-0.864,3.234-3.0204,3.018-3.6672,1.08-3.666,0.4296-4.3128-0.2136-5.8248-1.2972-4.5276-5.3904-3.4512-6.9012-2.586-5.8224-3.0204-11.862-1.5108-4.9608-0.6468-4.5288-3.234-6.2544,1.2924-1.0776,11.2152-9.9204h0.648l2.3736-2.1576,4.0956-7.764,0.432-0.4308,1.2936-4.7436-0.216-8.1948-1.0776-3.882-2.5872-4.314s-0.8628-1.5096,0-1.2936c0.8616,0.216-2.3724-3.6672-2.3724-3.6672l-3.884-4.1v-0.86l-2.802-2.8044-1.9416-1.0776h-1.5096l-0.648-0.864-2.8044-0.8616-1.2924,1.2936-0.8628,2.8044v1.0788l1.9392,0.8616,0.6468-0.4308-0.6468-1.08,0.216-1.2936,1.512-1.0776,1.7244,1.2912-0.216,3.2352-1.2936,1.5108-3.234,0.2172-2.5884-1.2948-1.0776-2.1576-0.8616-3.2328,0.8616-1.9416,1.2948-1.0776,2.1564,0.4308,3.45-0.864,1.0776-0.4308,2.8044,0.4308,1.9416,1.9416,2.1552,1.2936,5.3928,6.0396,1.5084,1.5084,2.8044,4.0992,3.4512,7.764,0.8616,5.3904-0.4296,5.3928-2.8044,7.764-3.2352,4.9596-4.5276,5.6076-7.764,6.4716-1.0776,0.2148-1.7256,2.1576,3.0204,6.4692,4.7436,19.842,3.882,8.1948,5.6076,5.8224,4.3128,2.3736,5.6088,0.648,4.9596-1.296,2.1576-1.938-0.864-1.2948z'/%3E %3Cpath fill='%23dbd45d' d='m861.622,392.72-0.6468,1.0764,0.8628,1.7268,2.1576,0.4308,1.5084-1.9416v-2.1588l-1.2948-2.37-1.7244-0.4344-1.9404,0.2172-2.8044,1.9416-1.5108,1.7256-0.8628,4.0968,2.1576,6.6876,3.4512,4.5276,8.6256,5.6076,9.2748,3.45,5.8212,0.8616,4.3152,4.3152,2.1564,5.1744-1.9404,3.2376-2.5884,0.2148v-1.2936l1.0776-0.2172,1.2948-1.2936-0.6468-1.2936-2.5872-1.5108-2.1564,1.7256-0.2172,3.8832,1.9392,1.9416,2.8044,0.6444,2.1576-0.8628,2.1552-2.3736,0.2184-2.8032-0.8628-4.098-3.6684-5.1732-3.8796-1.9416-9.7056-3.4524-6.2544-2.37-4.53-3.2388-4.0968-4.3116-2.3724-6.252,1.0776-4.098,2.3736-1.7268,1.2936,0.4308-0.432,1.2984z'/%3E %3Cpath fill='%23e5dc5e' d='m939.906,392.934,1.7256,1.0788,0.2172,1.7244-1.9416,0.8628-2.5872-0.4308v-2.586l1.5084-3.2352,4.3152-0.2172,1.9404,2.3736,1.2948,4.5276-1.2948,4.746-4.9608,4.0968-6.9012,4.746-7.548,3.234-11.214,5.3904-3.2352,2.37-2.8044,5.1768,1.7268,3.0216,2.1564,0.4308v-1.0788l-0.648-0.8628,0.4308-2.3736,1.2948-1.2924,2.586,1.5108,0.6492,3.234-2.3736,2.3736-2.5884,0.4308-4.0968-1.9416-1.2948-2.1552-0.2148-3.0228,1.7256-2.8032,3.45-3.4488,5.3928-3.0228,7.764-3.234,11.4288-5.6052,7.9788-8.628v-3.4488l-1.7256-2.1564-2.1564,0.2148z'/%3E %3Cpath fill='%23d7d643' d='m949.826,386.681v1.938h1.5096l1.5108-0.2148,0.6468-2.586-1.2936-1.7244-1.7256-0.2184-2.1576,0.4308-2.3712,1.7256-0.216,3.4524,1.0764,2.37,2.1576,3.234,3.882,1.9416,3.8808,1.0788,5.8248-0.4308,6.6852-3.234,6.2544-4.5288,2.5872-6.2556,3.234-11.43,4.0968-14.448,2.5884-5.3904,2.1564-1.9428-0.6468-0.8616h-1.9404l-4.9608-3.666-5.1744-3.2352-6.6864-7.9788-3.45-6.6864-1.0788-9.4884,1.9416-9.2748,4.0968-6.9012,6.6852-5.6076,6.0396-4.3128,6.0384-0.2136,0.8604,2.3712-0.8604,1.9416-1.2948-1.0788-1.9404-0.216-0.8616,3.2352,2.154,1.0776,3.882-0.4308,1.08-2.5872-0.4308-3.666-2.8044-2.5884-4.962,0.4308-3.666,0.4308-4.53,2.5884-4.7424,4.9596-3.234,4.7448-4.0992,6.6852-1.2936,6.0384,0.216,10.5684,5.3928,11.4288,4.7436,6.0396,9.2724,6.2532,1.5108,1.0788-2.8032,6.2544-4.098,13.1556-2.5872,10.5672-2.1564,4.5288-6.9012,6.0384-7.7652,3.018-6.684-0.2136-3.2352-2.3736-0.864-2.1564-0.216-3.234,1.7268-0.4308z'/%3E %3C/g%3E %3Cg fill='%235db7d2'%3E %3Cpath fill='%2344b3cc' d='m890.873,284.615-0.33,3.3048,0.9912,7.2732,3.636,19.9992h1.8192l0.1644-3.1392-6.2808-27.438z'/%3E %3Cpath fill='%2350aece' d='m900.127,313.706-6.6108-28.926,4.9572,29.4216,1.6536-0.4956z'/%3E %3Cpath fill='%2350afce' d='m901.285,313.375,2.3136-0.8256-8.5956-27.7692,6.282,28.5948,0,0z'/%3E %3Cpath fill='%2350abce' d='m897.484,283.127,10.0824,28.926-1.9836,0.66-8.0988-29.586z'/%3E %3Cpath fill='%2350b0ce' d='m909.054,311.39-9.7524-29.2548,12.3972,28.926-2.6448,0.3288,0,0z'/%3E %3Cpath fill='%2350b3ce' d='m912.69,309.904-11.5704-27.9348,14.3796,28.266-2.8092-0.3312,0,0z'/%3E %3Cpath fill='%2364b4d1' d='m822.091,258.767-1.56,0.2388-1.9176,1.56-0.84,2.0388,0.1212,3.7176,1.3188,2.2776,2.2788,2.4,1.0788,1.7988-0.6,3.2364-3.2364,2.0388-3.4776,2.5188-1.32,2.0388-0.48,2.2776,0.1212,2.3988,0.4788,0.5988,2.6388-0.1212,1.5588-0.4776,2.3976-0.24,2.2776,0.36,3.4776,2.3988,4.9176,4.4376,2.1564,2.5188-1.5576-3.7188-0.8388-4.4376-0.6-4.4364,0.7212-2.6376,1.1988-1.68,1.3188,0.7212,1.0788-0.6,1.44,0.72,1.2-0.72,1.9176,0.6,2.3964-1.2,3.5988-2.7576h2.5176l0.7212,0.5988,1.4376-0.5988,0.84,1.2,2.9988-2.28,2.3976-1.1988,2.3976,0.9588,3.1188,0.72,1.2-1.0788,2.5176-0.1212,3.4764-0.4788,1.68,1.1988,1.6764,4.0764,1.2,1.3212,1.8,0.3576,0.9588,0.48,1.6776,4.1976,1.2,3.3576,0.6,4.0764-0.2412,1.0788,1.0788-0.1188,1.68,1.6764,1.4388,0.7212,1.1988,1.3188,0.3576,2.1576,0.9612-0.1188,0.84-1.0788,1.6788,0.36,1.4388,1.5576,1.4376,0.1212-2.52-16.6692-2.3976-1.3188-0.12-3.8364,5.6364-2.04,0.12-1.4376-0.8388-2.4-1.0788-2.1576-2.1588,0.2388,1.6776-5.3952,4.1976,4.3164-1.9188,0.2412,1.6764,6.594,7.1976-1.1988,1.3188,1.8-0.48,1.5576,0.6012,1.0788,0.3576,1.92,2.16,2.7564,5.6364,12.2304,5.3952,11.0328,2.3988-2.5176,2.5188-0.5988,2.7588-1.92,1.6776-0.6,1.1988-1.5576,3.1188-0.1212,4.6752,4.1976,0.7212-1.0788,4.4352-0.2412,1.4388,2.8776,0.2412,1.2,1.7988-0.72,4.9164,1.0776,2.9976,2.4,2.2764,0.9576,0.6012,1.2012,1.3188-1.56,0.96,0.1212,1.56,0.36,4.9152-0.36,2.52-5.0376s2.2764-4.6752,3.3588-5.8752c1.0776-1.1988,5.5152-5.9952,5.5152-5.9952l5.3952-3.5988,4.0764-2.2776,3.8376-0.48,3.5988-0.12-0.12-3.2376-1.4388-3.1176-3.5988-4.6752-0.72-3.7176v-2.28l3.1188-2.0388,3.7176-2.9976,0.1212-3.1188-1.0788-3.8376-2.16-3.2364-0.72-0.6-1.2-0.2388-1.6776,1.0776-3.3576,4.6764-3.7176,3.7188-4.5564,2.7588-5.2764,0.5988-8.3928-1.3188-5.8752-1.8-7.3164-2.7576-7.6752-3.5976-4.1964-0.8412-6.3564-3.1164-2.3976-0.1212-0.1212,1.08,1.9176,1.9176-0.4776,3.3588-1.6788,1.7976-3.1176,0.1212s0.36,0.2412-1.4388,0.72c-1.8,0.48-3.3576,0-3.3576,0l-2.9976-1.7988-2.8788-0.48h-5.7552l-6.3552,0.6012-7.1964,0.5988-3.5964,3.1188-3.1188,0.48-3.3576-0.84-3.4764-4.0764,0.12-2.2776,2.5176-3.1188-1.3188-0.12-7.9152,2.8788-4.9176,2.7564-2.6364,1.68-1.9188-0.1212-2.52,2.2788-3.1176,0.24-1.8,1.9176-0.5988-0.2388-5.0352,1.3188-4.5576,0.8388s-5.7564,0.84-6.3552,0.84c-0.6012,0-6.1152-0.72-6.1152-0.72l-4.0788-2.0388-1.9176-2.1576-1.8-1.2-2.3976-2.5164,0.1212-1.92-0.7188-0.4776z'/%3E %3Cpath d='m893.774,318.595-0.1704,3.7428,2.7228-0.678-0.3408-3.5736-2.2116,0.5088,0,0z'/%3E %3Cpath d='m897.348,317.575v3.0624h1.1916v-3.2328l-1.1916,0.1704z'/%3E %3Cpath d='m900.071,316.895v3.4032l1.7004-0.5112-0.1704-3.0624-1.53,0.1704z'/%3E %3Cpath d='m903.643,316.213,0.1716,2.5524h1.5288l0.1716-3.0624-1.872,0.51z'/%3E %3Cpath d='m907.046,315.533v2.724h2.3808l-0.3396-3.0648-2.0412,0.3408z'/%3E %3Cpath d='m910.788,314.683v2.5524l2.0424-0.5112-0.51-2.7228-1.5324,0.6816z'/%3E %3C/g%3E %3Cg fill='%23ccc'%3E %3Cpath fill='%23fffcfc' d='m973.633,345.67v2.6904l0.6276,0.3588,0.18,0.8952,2.7756,0.4488-0.27-0.8964-1.7928-1.7028-0.4476-1.2552-1.0728-0.5388z'/%3E %3Cpath d='m916.933,309.892-0.4596-0.9156,1.5264-1.6764,2.8932-0.6072,2.286-1.83,2.8956-1.8288,3.048-0.762,3.9636,3.3516-1.3716,1.0704-1.374-0.1536-2.5896,1.6752-1.98,1.2204-1.6764-0.3048-1.5252-0.4572-0.9132,0.762h-1.374l-1.068,0.6096-2.2812-0.1536z'/%3E %3Cpath d='m935.527,305.623,1.5228-0.6072h2.286l1.2204,3.3516v1.068l1.98-0.6096h3.6588l2.5896,1.2192,2.286,2.286,2.4384,1.3728h1.98v-1.068h1.9812l0.4584,0.6108,2.1324,0.3036,1.5252-0.456,0.4572,1.3716-0.3048,1.8276-0.4584,1.374,0.6096,5.7888,2.7444,9.9072,5.1816,8.3832-1.98-0.9156-4.4208-0.6096-1.3728,0.6096-1.8276-0.1524-2.1336,1.9812-1.068,0.1512-0.9132,0.7632-1.6764-2.286-6.4008-8.5344-1.6764-1.8288-3.6576-7.9236-5.0292-10.8228-0.306-4.4208-1.218-1.2192-0.6096-0.1524v-0.7632h0.001z'/%3E %3Cpath d='m933.697,364.607,2.592,1.2192-0.1524-1.2192,1.8288,1.2192s1.6752,0.306,2.5896,0.1524c0.9132-0.1524,2.8956-2.1324,2.8956-2.1324l0.6096-4.1148,3.9636-6.8592,2.8932-1.6764,0.918-0.1524,2.7408-3.0492,5.1816-2.742,2.4384-0.9156,3.9636,0.762,2.8956,1.3728,0.6096,2.4384,0.4584,6.5532,1.8276,1.374,1.5252-0.7644,1.3716-1.6752,3.3516-1.2216,2.4396,0.3036-0.1536,3.0504-1.0656,5.6388-1.6764,5.9436-2.7432,9.4476-2.5896,6.708-6.402,4.878-5.0292,3.198h-8.0784l-2.4372-2.2848,3.048-0.7644,1.0668-1.8252,0.3048-3.2016-2.742-1.9812-2.7432,0.1524-3.6576,2.1348-1.374,1.8252-0.762,2.136h-1.3704l-3.0504-0.1536-2.286,1.5252-1.6752,2.1312-0.4584,3.2016,0.7644,2.2872,1.6752,1.0668,3.048-0.1536,0.7632-0.6072h0.6096l-2.7444,3.0444-3.504,3.66-4.5732,3.048-3.048,0.9132-5.0292,1.83-3.6576,1.6764-4.116,0.1524-4.2672,3.8088-2.8956,2.2884-1.9812,2.742-0.9144,4.7256v3.5028l2.2836,3.048-0.3036,0.9168-1.3716-0.156-0.7632-0.6072h-3.3516l-0.9156-1.3728-1.6764,0.306-2.4372,0.7608-1.068,1.0692-1.8288-0.9168,1.068-2.742,0.1524-2.5896-0.762-3.5076-2.286-4.5732-1.98-2.1312-3.5076-2.1348-6.7056-1.9824-7.314-2.7384-5.334-2.5944-1.9812-3.048-0.7632-3.8088,1.2204,1.2192-1.068-4.2672,1.524,1.9788,1.0692,0.1524,3.048,3.8124,2.4384,0.4584,0.6096,0.3024h0.7608l0.1524-0.3024,2.286,1.2192,2.592,0.7608h3.6564l-3.1992-0.7608-3.9636-1.8288-4.1148-2.2884-2.286-3.0444-0.306-1.3728-1.2192-0.1524,0.1536-0.9168,0.9144-1.0668,1.2192,0.1536,0.306,0.9132,1.2192-0.4584,1.98,1.5264,3.354,0.3024,2.4372,0.306-2.1312-1.2192-3.354-1.8288-3.3528-3.0492-1.068-0.1524-3.354-5.1792-1.8276-5.0304-1.524-5.3328v-6.2508l1.98-5.0268,2.8956-4.5732,1.6764-1.5252,1.3716,0.4572,3.5052-2.5896,2.4384-0.762,3.2016,0.15,2.4384,0.7632,3.5052,1.068,1.6752,2.1324,1.6764,0.1536,0.456,1.2192-0.9132,0.3048,1.2192,1.6764-0.4572,1.0668,1.068,1.3716-0.1524,1.98-1.98,2.2872,1.3704,2.2848-0.1536,0.7644,1.6764,1.8288,1.5252,2.2836,2.5908,0.4584,6.096,0.1536,4.4184-0.4584,2.592-0.1536-1.068-1.2192,1.8288-0.4584,2.286-0.4584,4.1148-3.1968s3.2016-5.4888,3.8112-6.2508c0.6096-0.7608,1.8276-3.3528,1.8276-3.3528l5.1816-5.334,1.98-0.762,4.5732-2.2848h4.7256l1.2216,1.3728,1.98,0.3048,1.8288,2.2848,0.9132,6.2496-2.8956,1.98h-2.436l-1.6764-1.0668-0.4584,0.9144-1.9812-0.456z'/%3E %3Cpath d='m859.741,387.068s0.3588-0.7164,0.7188-0.7164c0.3588,0,1.1652-0.0876,1.1652-0.0876l0.0888-4.662s-0.6264-0.3564-0.7176-0.7164c-0.0888-0.3564-0.0888-2.0604-0.0888-2.0604l-0.6264-0.6276-0.09-18.8184-1.7928-4.8384-1.5228-2.598-1.254-0.9864-1.9728-0.1776-2.2404,1.434-1.344,0.7164-2.868-0.6252-1.074-0.7188-1.7052-0.0876-1.5228-2.778-3.1356-0.9864-1.4328-0.4476-4.3008-0.3588-1.254-0.09-1.6152,1.0764-1.8816,2.2404-1.3428,2.5968-0.1788,4.2132,0.9852,1.344v1.9704l0.4488,0.8064v1.7028l-1.434-1.7028-1.434-3.4944-0.7164-2.1504-0.6276,0.8964,0.1788,2.868,0.0888,2.328,0.8076,2.1528,0.8064,3.0444,1.344,3.8532,1.0752,4.1244,0.9864,3.9408,1.8816,3.5844,1.6128,2.2404,3.6744,3.6732,2.3292,1.6128,3.5844,1.2564,4.032-0.0876,1.2528-0.9-1.6128-1.5216s-0.2676-0.984-0.2676-1.344,0.5364-2.1516,0.5364-2.1516l1.7028-1.7928,4.9284-0.8952,1.7028,1.2552,2.2404,2.5092,1.8816,0.9816z'/%3E %3Cpath d='m913.682,313.831v2.5524l1.53-0.3408-0.3384-2.2116h-1.1916z'/%3E %3Cpath d='m916.234,313.151v2.0412h1.0224v-2.2116l-1.0224,0.1704z'/%3E %3Cpath d='m918.448,312.98,0.1692,1.8708,1.7016-0.3384-0.1704-2.2128-1.7004,0.6804,0,0z'/%3E %3Cpath d='m921.848,311.62v2.5536h1.0224l0.3396-2.5536h-1.362z'/%3E %3Cpath d='m924.743,311.11v2.2128l1.3608,0.1704-0.3408-2.382h-1.02v-0.001z'/%3E %3Cpath d='m927.466,310.429v2.5512l1.3608,0.1704v-2.2116l-1.3608-0.51z'/%3E %3Cpath d='m930.187,309.577-0.5112,2.892h1.5324l-0.1716-2.2116-0.8496-0.6804z'/%3E %3Cpath d='m932.228,309.577v2.3832l2.2128-1.0224-0.342-2.5536-1.8708,1.1928z'/%3E %3C/g%3E %3Cpath fill='%2376401b' stroke='none' d='m890.046,266.598-1.488,4.4628,5.1252-0.8268-3.6372-3.636,0,0z'/%3E %3Cg fill='%23784421'%3E %3Cpath d='m932.194,351.556-4.7916,1.3248-3.306,2.6448-4.2984,4.4616-3.4716,6.282-3.966,4.794-7.2744,2.9736-6.612,0.1668-5.124-1.4856-1.818-2.8128-0.4956-3.6348-0.6612-4.464-1.488-2.8092-2.3136-2.8116-2.6448-1.818,2.8116-11.9016,0.8256-2.6448v-3.4716l0.4956-4.626,2.4792-4.1328,2.4792-2.3136,4.2972-1.9836,7.602-1.9824,7.6044-2.4792,7.9344-1.818,8.9256-2.1492,3.8016-0.33-0.33,4.9584,0.9924,1.8192-0.1668,12.8916-0.8256,11.406-0.6612,5.946z'/%3E %3Cpath d='m934.014,351.391,4.6272,0.9924,3.636,2.1492,1.4868,2.148,1.9836-1.6524,0.8256-2.8116,3.4716-1.9812,5.2908-4.6284-4.4652-6.7776-2.3148-3.306-3.1404-3.6348-3.8016-6.942-4.2972-9.4224h-2.3148l-0.33,18.6768,0.1668,6.7764-0.8244,10.4136z'/%3E %3Cpath fill='%23a05a2c' d='m886.904,279.325,0.1668,3.4716,14.2152-4.4628v-1.3224l-14.382,2.3136z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m846.526,359.353,0.6396,3.21,2.1408,3.852,4.0632,3.528-3.4224-2.46,2.5668,3.4236-4.3836-2.7804,4.2768,2.7804-4.4928-6.4188-1.3884-5.1348,0,0z'/%3E %3Cpath d='m841.285,373.577-1.6044,1.7112-2.7816-0.4272,0.1068,3.5304,3.8496,5.67-3.8496-5.3472,0.108-3.6348,2.6748,0.21,1.4964-1.7124,0,0z'/%3E %3Cpath d='M836.686,383.419,835.83,380.958v-2.7792l0.8556,5.2404z'/%3E %3C/g%3E %3Cg fill='%23666'%3E %3Cpath d='m887.275,369.728-1.2828,1.2816-2.1384,0.5364s-2.1384-0.2136-2.5668-0.5364c-0.4272-0.3192-2.7816-1.71-2.7816-1.71l2.7816,1.4964h4.9188l1.0692-1.068z'/%3E %3Cpath d='m890.698,374.756,0.534,3.102,2.1384,3.7404,1.3896,1.8204-4.062-8.6628,0,0z'/%3E %3Cpath fill='%23808080' d='m898.078,383.525-2.034-0.6384-1.818-1.7148-2.5668-4.596,2.6736,3.4224,3.7452,3.5268,0,0z'/%3E %3Cpath stroke-width='0.13692' d='m880.217,371.011,0.3216,9.0912,0.8556,3.5304,1.2804,2.5668,1.7136,2.6748,0.4272-1.0692,1.818,1.2828,0.5364-0.5364-1.8204-1.8168-1.818-2.4612-1.0716-2.5668-1.1748-4.3848-0.4272-4.7052h1.4952l-0.4272-0.8556-1.7088-0.75z'/%3E %3Cpath fill='%23808080' stroke-width='0.13692' d='m920.644,385.344,3.4224-0.3204,3.21-2.6748,0.534-1.8204,1.4964-1.0704-0.2136,3.1032,0.7476,1.6056,2.0316,0.642,1.2828,1.1748,2.2476,0.2148,3.2076-2.0304,2.3532-2.4612,2.0328-1.8192,1.4964-0.642,0.5352-2.994h0.9624l0.2136-1.392-0.4272-2.6712-0.9624-2.568-1.2828-1.7112-2.1396-1.9248-0.9612,0.4284,2.352,2.2452,1.9248,2.46,0.1068,3.8496-0.534,1.4976-2.8884,3.3168-3.7428,4.0632-1.818,0.8556-3.8496-0.5328-1.392-1.8192-0.3204-1.2828-0.4284-1.2828v-1.4976l0.5352-1.0692-3.9564,4.4904-1.6044,0.1056-4.1712,3.5316z'/%3E %3Cpath fill='%23808080' stroke-width='0.22824' d='m972.088,357.323,0.8556-0.7488,0.9624,1.392,0.216,3.8484,0.1056,0.108v2.5668l-1.4952,2.7816-3.21,3.4224-3.7428,1.602-3.4236,0.4272-2.3532-0.5316-0.8556-1.392-0.534-1.3896v-3.2076l0.642-1.284,0.2136,0.6408-0.1068,3.5304,1.1748,1.3908,2.46,0.7464,2.2452-0.7464,2.6748-0.75,2.2452-1.2828,0.108-0.7488-0.8556-0.1068,0.2136-0.3204h1.2828l1.6044-3.21,0.534-2.6748v-2.1384l-0.6396-0.6408-0.3228-0.534v-0.75h0.001z'/%3E %3Cpath d='m887.381,406.842-5.3484,2.5668-4.9188,1.4964-2.6748-0.4272,5.2392,1.9248,2.034-1.6032,3.2076-1.6056,2.4612-2.352,0,0z'/%3E %3Cpath fill='%23999' stroke-width='0.18252' d='m891.553,417.643,2.8872,0.8556,1.3896,0.5364,2.9952,0.4272-2.2464,1.3884,2.886,0.6408s-2.778,0.3228-3.2064,0.3228-1.926,0.9612-1.926,0.9612-0.3204,1.7148,0.642,1.6056c0.9648-0.108,2.352-0.3228,2.8872-0.3228s2.2464,0.3228,2.2464,0.3228l1.0704,0.8556-0.642,0.9648-4.4928,0.1056,0.6432,0.5364h3.636l-3.528,2.352,4.2756-0.1092,3.4224,1.392v0.8556l-3.3144,0.75-0.7488-1.2864-4.278,1.1772-0.8556,1.0704-1.6044-1.0704,1.2828-2.7792-0.1068-2.8884-0.642-2.2476-1.4964-3.3132-1.176-3.1032z'/%3E %3C/g%3E %3Cg fill='%23e2d67e'%3E %3Cpath fill='%23e4cb5e' stroke-width='0.22824' d='m868.889,274.852-3.4452,0.4164-2.436,0.2976-1.6044,0.9516-1.3068-0.774-0.7728,0.4752-2.9112-1.5444-3.3876,1.8432-1.6044,1.4244h-1.008l-0.774-1.0092-1.5444,1.0716-0.8916-0.8928-0.9504-0.534-6.4164,4.6344-2.3172-0.7728-1.0104,0.8916-0.4176,0.3564-0.2352,1.0092-0.9528-2.4972-0.8304,0.594-1.4256-0.4752-1.0104,1.4268-0.2376,3.7428,0.594,4.6932,1.5468,5.1696,1.4244,2.1384,1.188,0.2376,0.3576-1.4856,0.654,2.7924,0.9504,0.9492,0.2976,5.0508,3.8616,8.6748,0.3564,4.4556,0.1776,7.7232-1.4256,1.7256-1.8408,2.7924,0.0588,0.8292-1.9008,3.6252,0.1176,5.526,0.4176,0.4752,0.12,5.2872,1.4844,0.1188,1.188,1.3068,2.6148-0.2364v-1.6044l0.3564,1.8408,2.0784,2.7348,1.7832,1.4244,1.2456,0.06,0.654-0.9504-0.06-5.9412,0.4164,6.5352,1.3068-0.06,1.6656-1.4844,2.1984-0.2976,0.7128,0.06s0.594,0.3564,0.8916,0.8904c0.2964,0.534,1.3668,1.0116,1.3668,1.0116l0.7728,1.6044,0.9504,0.3564,0.4752-1.0116-0.6528-12.6552-0.654-10.3368-0.7128-13.1292-0.714-16.7568-0.1188-5.346-0.8316-0.7128,0.06-1.7232,2.0208-0.594,1.1868-0.3564-0.5352-1.6032-0.5928-5.3472v-2.0196l0.714-0.594,1.4256-0.0588,1.0104,1.188,1.9608,8.1384,1.0104,0.3564,3.564-0.06,8.0808,12.7752,2.8512,4.278,3.9216,7.3068,5.1108,7.308,1.6044,2.1384,1.0692,0.1212,0.3564-7.7844,2.2596-1.9608-1.902-13.4268-1.5444-0.2964-2.1384-1.9608-1.188,0.1776-1.188,1.9608-1.4844-1.6632-0.18-1.902-1.3668-0.8892h-1.008l-1.3092-1.782-0.7116-0.18-0.8316,0.7728-0.1788-6.0588-1.3068-2.8512-0.2376-1.7232-2.436-3.4464-2.5536-0.594s-1.128-2.556-1.128-2.9124-0.4776-1.6044-0.4776-1.6044l-1.7904-1.8456z'/%3E %3Cpath fill='%23dcc56a' d='m871.027,356.128-1.722-2.1972-0.594-2.3172-0.2376-4.9908-0.534-4.7544-0.9516-7.3668-1.5444-9.09-1.2468-7.3668-0.4764-4.3368-1.0092-5.1108-0.4164-3.5052-0.4164-2.9112-0.3564-4.158,1.188,3.7428,1.962,8.7336,2.196,6.06,0.8916,4.0992v2.3172l1.5456,3.3252,1.0104,4.2204,2.0784,8.9112,2.1984,7.3092,1.128,5.286,0.1776,2.0208-2.3172,0.774-1.128,0.5328-1.4256,0.7728z'/%3E %3Cpath fill='%23e2cc75' d='m882.613,354.348,1.2492-6.0012,1.4856-4.5744,0.6528-3.09,0.4752-2.4948-0.12-3.7428-1.0092-2.1984-4.6332-9.3276-2.7936-5.6436-1.1292-2.9124-2.0784-3.6252-2.7924-5.8224-2.496-4.3356-2.0784-3.5652-1.9608-2.616-0.5928,0.5364,1.7808,6.654,1.4844,5.7024,1.4268,6.2976,2.376,8.2584,1.3668,5.7048,1.3668,3.5052,1.3068,4.9308,3.624,11.7648,0.714,3.0888,1.7832,3.5664,0.5916-0.06,0,0z'/%3E %3Cpath fill='%23ddd690' d='m863.999,357.562-1.8732,1.8708,0.1704,0.6816h2.2116l0.6828-1.5324-1.1916-1.02z'/%3E %3Cpath fill='%23ddd690' d='m861.785,355.008,0.3408,2.0424,1.5312-0.1704,0.8496-1.53-0.1692-1.1916-1.5312,0.3408-1.0212,0.5088z'/%3E %3Cpath fill='%23ddd690' d='m865.528,354.158,0.5112,1.3608h2.8932v-1.02l-1.1904-0.5112-2.214,0.1704z'/%3E %3Cpath fill='%23ddd690' d='m865.19,351.607,0.168,1.53h2.0436l1.02-1.3632-1.1904-1.02-2.0412,0.8532z'/%3E %3Cpath fill='%23ddd690' d='m861.104,352.116-0.3408,1.0224,1.0224,0.51,2.214-0.51v-0.852l-2.8956-0.1704z'/%3E %3Cpath fill='%23ddd690' d='m861.104,349.564v1.1916l2.2128,0.1704,0.6816-1.0212-0.852-0.6804-2.0424,0.3396z'/%3E %3Cpath fill='%23ddd690' d='m865.528,348.544-0.3372,1.02,2.04,0.5112,1.02-0.8508-1.5288-1.0224-1.194,0.342,0,0z'/%3E %3Cpath fill='%23ddd690' d='m861.276,345.821-0.3408,1.5312,1.3608,0.1704,1.1916-0.8508,0.1704-1.1892-1.362-0.1728-1.02,0.5112,0,0z'/%3E %3Cpath fill='%23ddd690' d='m865.019,345.14v1.53l2.2128,0.5088v-2.2116l-1.0212-0.3384-1.1916,0.5112z'/%3E %3Cpath fill='%23ddd690' d='m862.976,342.587h-2.0412l-0.1728,2.3808,2.3832-1.02-0.1692-1.3608z'/%3E %3Cpath fill='%23ddd690' d='m864.677,341.906-0.8496,1.7016h2.382l1.0212-2.2104-1.362-0.3408-1.1916,0.8496z'/%3E %3Cpath fill='%23ddd690' d='m864.167,339.014,0.1728,1.362,2.2128-0.3408-0.8532-1.7004-1.5324,0.6792,0,0z'/%3E %3Cpath fill='%23ddd690' d='m861.955,339.526-1.53-0.3408,0.1716,1.8732,2.2116-0.3396-0.8532-1.1928,0,0z'/%3E %3Cpath fill='%23ddd690' d='m860.425,336.462-0.1704,1.7028h2.7228l-0.5112-1.7028h-2.0412z'/%3E %3Cpath fill='%23ddd690' d='m863.658,335.611v2.0424h2.5524l-0.5124-2.0424h-2.04z'/%3E %3Cpath fill='%23ddd690' d='m862.296,334.08-1.7004,2.04-0.6816-1.7004,1.1904-2.0424,1.1916,1.7028,0,0z'/%3E %3Cpath fill='%23ddd690' d='m863.827,332.548-0.3396,1.7028h2.2104v-1.7028l-0.8484-0.51-1.0224,0.51z'/%3E %3Cpath fill='%23ddd690' d='m861.104,330.508h-1.1904l-0.1704,1.362h2.0412l-0.6804-1.362z'/%3E %3Cpath d='m863.488,329.996-0.3408,1.5312h1.7028v-1.5312h-1.362z'/%3E %3Cpath d='m862.976,326.933-0.3396,1.53h2.3808l0.1728-1.3596-2.214-0.1704z'/%3E %3Cpath d='m860.255,327.614-0.3408,2.2116,2.0412-0.8484v-1.1916l-1.7004-0.1716z'/%3E %3Cpath d='m860.084,324.552-0.6804,1.3608,1.0212,0.5112,0.852-1.1916-0.3408-1.02-0.852,0.3396,0,0z'/%3E %3Cpath d='m862.894,323.405-0.5376,1.128,0.882,1.5204,1.2264-0.2952,0.0516-1.7172-1.3764-0.6876-0.246,0.0516,0,0z'/%3E %3Cpath d='m860,321.684-0.444,1.2276,0.8844,0.7848s0.7344-0.2928,0.7344-0.5412c0-0.2436,0.246-1.0296,0.246-1.0296l-0.9804-0.5892-0.4404,0.1476z'/%3E %3Cpath d='m862.356,321.047-0.2952,1.3752,0.6876,0.4416,1.2264,0.0984s0.0492-0.9336,0.0492-1.2768c0-0.342-0.8844-0.7356-0.8844-0.7356l-0.7836,0.0972z'/%3E %3Cpath d='m859.754,319.181-0.0996,1.374,1.032,0.246s0.54-0.5376,0.54-0.7344c0-0.1956-0.492-1.08-0.492-1.08l-0.9804,0.1944z'/%3E %3Cpath d='m862.061,318.788-0.1968,1.1292s0.3936,0.5388,0.8844,0.5388c0.4896,0,0.6864-0.4896,0.6864-0.6852,0-0.198-0.1968-1.032-0.1968-1.032l-1.1772,0.0492z'/%3E %3Cpath d='m859.655,317.267-0.342,1.1304,0.9804,0.4404,0.7368-0.9816-0.786-0.5376-0.5892-0.0516z'/%3E %3Cpath d='m861.962,316.58-0.1464,1.0296s0.6852,0.4908,0.9324,0.3432c0.246-0.1464,0.5388-0.7836,0.5388-0.7836l-0.8844-0.5892h-0.4404z'/%3E %3Cpath d='m858.968,314.371-0.2448,1.2756s0.7344,0.6876,0.9312,0.5904c0.198-0.0996,1.2276-0.3936,1.2276-0.3936l-0.54-1.2756s-0.6372-0.1476-0.8328-0.1476c-0.1968,0-0.5904,0-0.5412-0.0492z'/%3E %3Cpath d='m861.521,313.733-0.2928,1.2264,1.6668,0.2952s0.246-1.3752-0.096-1.3752c-0.3468,0.001-1.1808-0.0972-1.278-0.1464z'/%3E %3Cpath d='m859.116,312.065-0.294,0.7368,0.8328,0.6372,0.6876-0.3912-0.4428-0.9336-0.7836-0.0492z'/%3E %3Cpath d='m861.618,311.574-0.636,0.9828,1.0296,0.4392,0.882-0.6852-1.2756-0.7368z'/%3E %3Cpath d='m859.165,309.415-0.4416,0.7368,0.4908,0.7836,0.786-0.6384-0.8352-0.882z'/%3E %3Cpath d='m860.932,308.924-0.3924,0.54,0.5892,0.7836,0.9804-0.5388,0.0984-0.4416-0.4416-0.54-0.834,0.1968z'/%3E %3Cpath d='m858.919,307.402-0.4416,1.0296,0.9804,0.54,0.5424-0.6852-0.3456-0.786-0.7356-0.0984z'/%3E %3Cpath d='m860.784,306.42-0.54,0.6888,0.7368,0.7356,0.9312-0.5412-0.636-0.7848-0.492-0.0984z'/%3E %3Cpath d='m858.919,305.683h-0.3924v0.834l1.128-0.0984-0.1968-0.834-0.5388,0.0984z'/%3E %3Cpath d='m860.441,304.702-0.0492,0.9324,1.0296-0.1476-0.0492-0.8328-0.9312,0.048z'/%3E %3Cpath d='m858.674,303.967-0.342,0.4896,0.5868,0.786,0.5904-0.5412s0.1956-0.7344,0-0.7344h-0.8352z'/%3E %3Cpath d='m858.772,302.347-0.4392,0.3924,0.5376,0.5388,0.6864-0.342-0.7848-0.5892,0,0z'/%3E %3Cpath d='m858.919,301.121-0.54,0.7836h0.9336l-0.3936-0.7836z'/%3E %3Cpath d='m860.146,301.561,0.0984,0.786h0.786l-0.8844-0.786z'/%3E %3Cpath d='m860.195,302.838s-0.1944,1.0296,0,1.0296c0.1968,0,0.7368-0.1476,0.7368-0.1476l-0.7368-0.882z'/%3E %3Cpath fill='%23d3c55f' d='m886.307,326.544-1.0776,1.4724,0.0972,1.5228,1.4244,1.3248,1.3248-1.866-1.7688-2.454z'/%3E %3Cpath fill='%23d3c75f' d='m888.222,324.432-1.3248,1.9164,1.2756,2.0124,1.3248-0.8328s0.1968-1.6716-0.0492-1.9668c-0.246-0.2928-1.2756-1.1784-1.2264-1.1292z'/%3E %3Cpath d='m885.767,321.733s-0.588,0.8832-0.588,1.0812c0,0.1956,0.3444,1.6176,0.3444,1.6176l0.834,1.0812s0.93-0.2952,1.0284-0.5904c0.0984-0.2916,0.4428-1.4232,0.4428-1.4232l-1.128-1.4736-0.9336-0.2928z'/%3E %3Cpath fill='%23d3c95f' d='m883.706,323.844-0.246,0.4896s-0.1452,1.1796,0.1476,1.3752c0.294,0.1968,1.1772,1.1304,1.1772,1.1304s0.7836-0.4908,0.7836-0.7368-0.588-1.7688-0.588-1.7688l-0.6852-0.6852-0.5892,0.1956z'/%3E %3Cpath d='m881.693,320.458-0.3912,0.9312,0.4896,1.2768,0.9336,0.9324s1.0296-0.1944,1.0296-0.3936v-1.374l-0.6396-1.0788-1.0788-0.4896-0.3432,0.1956z'/%3E %3Cpath d='m883.902,319.574-0.2448,0.7356s0.0984,1.032,0.294,1.128c0.1968,0.0984,0.9816,0.492,0.9816,0.492l0.6852-1.1292-0.6852-1.4232-1.0308,0.1968z'/%3E %3Cpath d='m882.824,317.22-0.492,1.0788,0.2952,0.7836,0.6876,0.3444s0.7836-0.3924,0.7836-0.5892v-1.0296l-0.882-0.5412-0.3924-0.0468z'/%3E %3Cpath d='m880.565,318.004-0.6372,0.834,0.246,1.032,1.0788,0.3432,0.7356-0.8844-0.5904-1.1772-0.8328-0.1476z'/%3E %3Cpath d='m879.728,315.794-0.5376,0.4908v0.6384l0.834,0.6396,0.7836-0.3936-0.1956-0.8844-0.3912-0.5892-0.4932,0.0984z'/%3E %3Cpath d='m881.89,315.157-0.3444,0.7848,0.4908,1.0308,0.7872-0.4416-0.15-0.8844-0.7836-0.4896,0,0z'/%3E %3Cpath d='m880.417,313.048-0.1944,1.7664,1.2252-0.1968,0.2952-0.9312-0.4404-0.6888-0.8856,0.0504,0,0z'/%3E %3Cpath d='m879.14,313.439c-0.1956,0.048-0.882,0.0984-0.882,0.0984l0.1968,1.7652,0.7836-0.096,0.2952-0.6384-0.0984-0.7848-0.2952-0.3444z'/%3E %3Cpath d='m877.669,311.672-0.588,0.7368,0.588,0.9804,0.54-0.0984,0.342-0.7344-0.882-0.8844,0,0z'/%3E %3Cpath d='m879.581,311.179-0.4896,0.5412,0.3936,0.5892,0.4908,0.0492,0.4896-0.5904-0.4404-0.5376-0.444-0.0516,0,0z'/%3E %3Cpath d='m876.442,309.906-0.3444,0.9312,0.9336,0.246,0.2436-0.5892-0.2928-0.5412-0.54-0.0468,0,0z'/%3E %3Cpath d='m878.062,309.415-0.0972,1.0788,1.0296-0.0984-0.0984-0.882-0.834-0.0984,0,0z'/%3E %3Cpath d='m875.264,308.188,0.0492,0.9312h1.0296s0.3444-1.0788-0.0984-1.0296c-0.4416,0.0492-0.882,0.1452-0.9804,0.0984z'/%3E %3Cpath d='m877.228,307.745v0.9324l1.0788-0.1476-0.2448-0.8328-0.834,0.048z'/%3E %3Cpath d='m875.803,306.764h-1.0788l0.1476,0.9324,0.9804-0.0984-0.0492-0.834z'/%3E %3Cpath d='m876.491,306.125-0.1476,0.8844,1.1304-0.0492v-0.8352h-0.9828z'/%3E %3Cpath d='m875.412,304.702-0.0492,1.0308s1.2264,0.1956,1.2264,0c0-0.1968-0.246-0.8832-0.246-0.8832l-0.9312-0.1476z'/%3E %3Cpath d='m874.724,304.8h-0.9816l0.0996,1.128h1.1772l0.1464-0.7836-0.4416-0.3444z'/%3E %3Cpath d='m872.418,301.463-0.492,0.4908,1.5228,2.4048h0.9312l-0.882-1.2264s0.1464-0.588-0.0984-0.6852c-0.2436-0.0984-0.4404-0.0984-0.4404-0.0984l-0.5412-0.8856z'/%3E %3Cpath d='m872.612,300.53-0.342,0.4416,1.8168,1.2264v1.0296l0.834,0.786,0.6852,0.1944-0.2436-0.8328-0.3432-0.9312-0.6888-0.5412-0.4884-0.882s-0.246-0.0492-0.4428-0.0984c-0.1944-0.0492-0.3912-0.3444-0.3912-0.3444l-0.396-0.048z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23000' d='m851.578,283.375-0.1728,7.9956,0.5112,2.5524v4.4256l0.1704,6.8064v4.5936l-3.9144-4.7664,4.0836,5.106,0.6804,4.9332,1.0224,1.8732-0.6804,2.5524,0.1704,4.2528v12.0804l-3.9144-9.528,0.3408,19.7376,0.3408-11.3988,1.362-2.0436,2.2116,5.6172,0.3396,2.5524-0.5112-9.5304'/%3E %3Cpath d='m835.582,282.694-0.6804,5.106,1.362,3.5712,0.1716,4.9356-0.1716-5.4444-1.362-2.7228,0.6804-5.4456z'/%3E %3Cpath d='m840.517,285.757v6.4656l1.1904,1.5312-0.3384,6.8064,1.02,2.0412v11.2296'/%3E %3Cpath d='m847.492,278.101-1.3608,2.5512,0.5112,4.5948,0.3396,3.2328-0.51,5.1024'/%3E %3Cpath d='m878.462,290.52-0.1728,7.8276,0.8508,4.2528,0.6816,4.5936'/%3E %3Cpath d='m885.776,301.921,1.5312,17.016'/%3E %3Cpath d='m842.047,327.275,0.3408,9.8688,0.6804,4.2552,0.1704,4.5924'/%3E %3C/g%3E %3Cg fill='%23d38d5f'%3E %3Cpath d='m893.264,345.481v-1.7028l7.4868-1.7028-1.1916,0.852,0.1704,5.1048'/%3E %3Cpath d='m913.682,341.226v-2.2128l7.4868-1.3608-1.7028,0.3408,0.3408,5.274'/%3E %3Cpath d='m897.518,357.731v-1.7028l6.2964-1.1892-0.1716,6.2952'/%3E %3Cpath d='m912.491,355.35v-2.724l6.8052-1.1904,0.3408,5.9532'/%3E %3Cpath d='m890.372,333.059v4.254l-1.5312,0.3408v-2.0424l1.5312-2.5524z'/%3E %3Cpath d='m893.946,332.377,0.1692,4.2552h-1.1916l-0.3396-3.744,1.362-0.5112z'/%3E %3Cpath d='m896.665,331.528-1.1892,0.6792v3.4032l1.7028-0.3408-0.5136-3.7416z'/%3E %3Cpath d='m899.9,330.337-1.1916,1.0212v3.0624l1.8708-0.1704-0.6792-3.9132z'/%3E %3Cpath d='m903.643,329.485-1.7028,0.6804v3.4032l1.8744-0.3396-0.1716-3.744z'/%3E %3Cpath d='m907.217,328.464-1.5312,0.1716v4.254l1.8732-0.3408-0.342-4.0848z'/%3E %3Cpath d='m911.81,327.614-1.7004,0.6792,0.1704,2.892,1.7004-0.5088-0.1704-3.0624z'/%3E %3Cpath d='m916.064,326.424-1.7004,0.8508v2.892h1.53l0.1704-3.7428z'/%3E %3Cpath d='m919.468,325.402-1.362,0.6804v3.2328h1.7028l-0.3408-3.9132z'/%3E %3Cpath d='m923.21,325.063-1.362,0.8496v2.5512h1.8744l-0.5124-3.4008z'/%3E %3Cpath d='m927.295,323.7-1.5324,0.6816,0.1716,2.5512,1.5312-0.3396-0.1704-2.8932,0,0z'/%3E %3Cpath d='m931.718,322.679-1.7016,0.8508v2.7228l2.0436-0.1704-0.342-3.4032z'/%3E %3C/g%3E %3Cg stroke-width='0.91284'%3E %3Cpath fill='%23fffcfc' d='m891.564,368.79,26.3712-5.9544'/%3E %3Cpath fill='%23c87137' d='m885.096,352.285,2.7252,0.3408,44.9184-10.2096'/%3E %3Cpath fill='%23c87137' stroke-width='0.86724' d='m887.65,340.717,6.9756-1.0236,38.7948-10.2084'/%3E %3Cpath fill='none' stroke-width='1.1868' d='m935.122,327.955,6.6348-1.1916'/%3E %3Cpath fill='%23fffcfc' stroke-width='1.32372' d='m935.122,341.906,14.6328-3.912'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='none' stroke='%23000' stroke-width='8.2159' d='m767.32,145.154v253.639c3.0024,36.3156,78.6864,59.178,131.454,97.7484,69.2124-46.422,136.34-55.812,139.039-107.858l0.8424-243.529h-271.33z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1440' height='720'%3E %3Crect width='1440' height='720' fill='%23f7e017'/%3E %3Cpath d='M0,50V370L1440,520V350z' fill='%23fff'/%3E %3Cpath d='M0,220V370L1440,670V520z' fill='%23000'/%3E %3Cg fill='%23cf1126'%3E %3Cpath d='M695.74,569.72c-19.36-2.57-37.11-8.73-49.44-17.17-2.39-1.64-4.64-2.98-4.99-2.98-0.36,0-0.65,1.82-0.65,4.07,0,6.37-2.56,9.58-9,11.25-6.16,1.6-15.56-1.63-23.18-7.95-7.89-6.55-17-11.55-24.71-13.55-6.35-1.66-14.78-1.39-20.87,0.65-2.83,0.95-6.05,2.29-7.17,2.98-1.11,0.69-2.36,1.25-2.76,1.25-1.08,0-0.93-6.85,0.2-9.04,1.49-2.87,5.16-5.7,9.44-7.26,2.16-0.79,3.93-1.8,3.93-2.25s-0.73-2.1-1.62-3.65c-2.9-5.08-1.71-10,3.35-13.87,5.18-3.96,13.95-4.64,21.7-1.69,1.95,0.74,3.77,1.35,4.04,1.35,1.02,0,0.4-1.43-2.41-5.52-3.24-4.74-3.88-7.08-3.48-12.72,0.52-7.14,6.34-12.98,13.47-13.5,5.82-0.42,9.44,1.54,18.03,9.72,25.65,24.46,53.54,37.94,86.07,41.59,8.21,0.92,24.73,0.43,34.42-1.03,29.27-4.41,58.76-19.13,81.79-40.82,6.38-6.01,9.45-7.6,14.68-7.62,4.55-0.02,7.74,1.45,11,5.05,2.97,3.3,3.98,6.43,3.66,11.44-0.21,3.21-0.73,4.79-2.64,7.9-2.82,4.59-2.34,5.01,3.24,2.85,7.54-2.94,16.83-1.58,21.84,3.18,4.41,4.19,4.83,8.38,1.4,14.06-1.25,2.08-2.27,4.03-2.27,4.34,0,0.57,0.95,0.84,5.53,1.58,5.99,0.96,9.42,5.41,9.42,12.21,0,2.04-0.25,3.7-0.56,3.7-0.3,0-2.57-0.83-5.04-1.85-6.98-2.88-10.95-3.62-19.11-3.57-6.21,0.04-8.35,0.33-12.68,1.74-6.63,2.17-13.72,6.35-19.5,11.5-6.37,5.68-10.38,7.47-16.58,7.42-5.76-0.06-9.7-1.73-11.78-5.02-1.11-1.76-1.27-2.83-1-6.81,0.18-2.59,0.14-4.71-0.07-4.71-0.22,0-2.46,1.42-4.99,3.17-6.64,4.56-10.87,6.82-18.47,9.83-23.18,9.17-56.63,13.14-82.24,9.75z'/%3E %3Cpath d='m706.34,525.17c-38.58-3.7033-75.494-23.798-97.939-55.657-24.37-33.235-32.05-77.117-24.611-117.24,3.9535-18.267,11.929-36.546,25.544-49.554-10.85,23.003-14.516,49.369-8.7299,74.29,8.989,49.753,51.036,91.87,101.34,99.156,19.9,5.761,40.487-0.32356,59.496-6.4934,41.935-14.779,73.879-54.583,77.777-99.079,3.3363-24.078-0.36023-49.114-11.207-70.916,6.1825,3.2692,13.987,16.087,18.589,24.707,16.003,31.003,16.734,68.155,7.3126,101.24-12.78,42.097-44.965,78.978-87.511,92.382-19.308,6.3081-39.842,8.2315-60.058,7.1679z'/%3E %3Cg id='hand'%3E %3Cpath d='m512.02,469.9c-2.5284-0.39577-5.3161,2.092-4.3628,4.6971,1.823,2.633,4.9641,3.9201,7.798,5.1795,6.7915,2.7224,14.179,3.7823,21.471,3.6055-2.5133-0.006,0.86258,0.026,1.8015-0.00068,5.774,0.0171,11.516-1.0234,16.944-2.98,3.018-1.0614,6.8641-2.0244,8.1009-5.3629,1.2069-2.1744-0.98008-4.3462-3.1859-3.9108-3.0714,0.67078-5.9433,2.064-8.9896,2.8576-6.5725,1.8534-13.494,2.5704-20.303,2.0116-4.9792-0.60782-9.8039-2.2005-14.41-4.1433-1.5972-0.70457-3.0962-1.7322-4.8648-1.9536z'/%3E %3Cpath d='m514.83,459.52c-2.5558-0.38057-4.7577,2.5607-3.6917,4.9076,1.965,2.8484,5.2671,4.3651,8.356,5.6992,5.3706,2.1486,11.204,3.0471,16.975,2.8752-2.1917-0.006,0.75258,0.026,1.5651-0.00068,4.9069,0.006,9.7882-0.96448,14.325-2.8311,2.7732-1.0787,6.1693-2.1246,7.3241-5.177,0.89621-1.6768,0.21293-4.1165-1.8997-4.2476-1.9288-0.0953-3.5928,1.1322-5.3782,1.6831-6.4849,2.6815-13.622,3.8183-20.614,3.2146-4.3567-0.56071-8.519-2.1681-12.47-4.0312-1.4847-0.71699-2.8205-1.8356-4.4909-2.092z'/%3E %3Cpath d='m518.28,449.57c-2.1908-0.26295-3.6978,2.2088-3.3288,4.1816,0.32687,1.7334,1.8824,2.8984,3.1689,3.9607,5.3292,3.8973,12.083,5.5573,18.626,5.3398-2.5415-0.009,3.4093,0.0418,1.5947-0.007,4.1442-0.0169,8.2378-1.0309,11.966-2.825,2.4889-1.0824,5.4115-2.3356,6.2502-5.1771,0.40122-1.3236,0.65233-3.227-0.84101-3.97-1.5638-0.87412-3.1169,0.47031-4.5388,1.0156-4.7891,2.4374-10.125,3.7932-15.507,3.7682-4.6507,0.15705-9.0334-1.799-13.068-3.9072-1.464-0.74578-2.6708-2.0422-4.3214-2.3798z'/%3E %3Cpath d='m481.53,302.7c-3.2575,3.2606-0.7701,9.2712-0.94626,13.543,1.6879,13.158,3.785,26.484,8.697,38.87,6.015,12.102,18.791,18.573,26.533,29.268,2.7675,5.155,1.7849,11.355,2.3681,16.994,0.45808,15.366,0.31593,30.743,0.047,46.111,6.9387,3.4817,14.474,6.9863,22.456,5.6471,4.7306-1.13,13.512-1.8326,14.496-6.5436-0.38235-26.5-0.6304-53.01-0.98289-79.506-2.6903-8.1185-10.951-12.32-17.129-17.514-5.0992-5.0259-9.844-10.435-14.188-16.099-2.6218-4.4175-12.868-6.0092-9.1612,1.6764,2.1735,6.6538,7.7204,11.61,9.1091,18.602,0.30342,3.8316,4.8776,10.879,0.97314,13.114-2.4837-4.2216-6.0823-7.815-10.682-9.9574-4.4324-3.3044-11.759-4.68-13.359-10.517-1.1745-8.2799-5.4152-15.782-10.887-21.986,1.4102-7.4368,0.005-16.737-6.4234-21.49l-0.92101-0.21254-0.00013-0.00002z'/%3E %3Cpath d='m491.44,304.19c-2.9629,0.47847-2.8621,4.2538-1.491,6.239,1.4583,4.2881,1.8554,8.9449,1.0659,13.409,5.2675,6.1665,9.3467,13.543,10.576,21.64,0.0299,3.0437,3.2327,4.0512,5.309,5.5551,4.8712,3.1016,10.348,5.3512,14.686,9.2326,0.91286,0.97602,1.6017,2.0271,0.9566,0.035-0.67695-2.5463-1.0251-5.3576-3.0207-7.2849-2.7345-2.939-6.15-5.5628-10.133-6.4593-0.33199-4.114-2.2913-7.8931-4.1017-11.532-2.0066-3.4792-4.1026-7.2065-7.5407-9.4626,0.13834-6.098,0.0385-12.495-2.5857-18.122-0.7696-1.4455-1.9032-3.163-3.7197-3.2499z'/%3E %3Cpath d='m499.73,306.62c-2.0642,0.61274-1.6695,3.1587-1.0158,4.7165,0.98881,4.3156,1.1436,8.7732,1.063,13.184,3.7911,3.0003,6.1624,7.3501,8.3216,11.586,1.3534,2.8304,2.6366,5.7518,3.1556,8.8651,3.0757,1.0188,5.7672,2.946,8.171,5.0773-0.95256-2.8824-3.0766-5.1129-4.5042-7.7441-1.5516-2.7372-3.0336-5.5913-3.6904-8.6923-2.9581-3.1576-4.5872-7.6305-3.9408-11.952,0.13267-4.7762-1.4093-9.7114-4.6059-13.311-0.8049-0.79276-1.7658-1.6692-2.954-1.7296z'/%3E %3Cpath d='m509.16,307.97c-1.1224,0.1984-1.8054,1.2662-2.4064,2.1373-0.23225,0.87316,0.83776,1.8114,1.0081,2.7596,1.3127,3.2919,1.8084,6.903,1.4162,10.426-0.0864,2.5018,0.80881,4.9458,2.0839,7.0649,0.36793-1.5628,1.8164-2.6864,3.3865-2.8406,0.57114-0.10043,1.4107,0.18835,1.0779-0.68251-0.39881-4.7853-1.128-9.5978-2.8007-14.119-0.64833-1.615-1.3844-3.3147-2.7835-4.4203-0.28367-0.20186-0.62304-0.3745-0.98205-0.32512z'/%3E %3C/g%3E %3Cuse xlink:href='%23hand' transform='matrix(-1,0,0,1,1440,0)'/%3E %3Cpath d='m715.67,475.98c-13.493-1.2846-25.667-11.12-29.829-24,0.22423-2.2187,2.9867,1.2413,4.2917,1.4741,2.4503,1.3606,5.0998,2.4802,7.9211,2.6539,3.5571,1.529,5.7565,5.0346,9.1516,6.8629,1.5764,1.2278,7.1544,3.641,6.1182-0.26421-1.307-2.04-2.2057-4.6242-1.0806-6.9613,1.8918-4.1503,4.8018-7.7638,7.7306-11.226,2.1527-0.71996,3.5939,3.5262,5.1338,4.9568,2.1308,3.2786,4.7004,7.2793,3.447,11.352-1.2198,1.5087-2.0216,6.0472,1.2409,4.5219,4.0213-1.7692,7.3158-4.7418,10.651-7.5175,2.9183-2.0384,6.6539-2.1824,9.7125-3.9699,1.4177-0.35921,4.3706-3.1946,4.9861-1.6225-1.6759,4.4876-4.4822,8.5068-7.4822,12.211-4.8588,5.5503-11.432,9.7247-18.786,10.902-4.3459,0.79562-8.806,0.96352-13.207,0.62747z'/%3E %3Cpath d='m731.53,460.22c0.29719-2.7079-0.31965-5.4735-1.703-7.9349-2.123-4.3258-5.1213-8.1663-8.0456-11.961-2.7573-1.615-4.2871,3.6582-6.1205,5.1714-2.8566,4.2769-6.4434,8.6562-6.617,14.036-1.6071,2.5012-4.6044-2.0411-5.8962-3.5357-2.4673-3.4911-4.3356-7.6206-4.0297-11.987-0.29227-7.0356,1.0571-14.041,3.6204-20.581,1.9348-5.5826,5.0755-11.006,4.7564-17.105,0.22416-4.5905-0.70745-9.6582-4.4262-12.745-3.538-2.7758,2.2916-3.3674,4.1432-1.928,3.1686,0.21257,4.8825,5.4481,7.7771,4.152,1.1532-2.7346,1.3824-5.9968,3.7595-8.1295,2.3338-3.1959,4.773,1.3562,5.5715,3.488,1.6467,1.8723-0.0931,6.5066,2.5817,6.6282,3.2062-2.2473,5.4923-6.0227,9.5918-6.8447,1.6623-0.94835,4.5034-0.12664,2.3114,1.7848-3.0339,2.8443-5.6262,6.4002-6.1786,10.631-0.92788,5.3074,0.39912,10.69,2.7124,15.47,4.4468,9.3901,7.8854,19.996,5.6361,30.444-1.0432,4.644-4.1982,8.6454-8.0313,11.341-0.4847,0.29274-1.2499,0.27192-1.4134-0.39473z'/%3E %3Cpath d='m726.73,389.63c-1.4562-2.6239-3.2238-5.2103-5.673-6.9945-2.3812-0.005-3.8508,2.9985-5.468,4.5721-1.134,2.11-2.5118,5.6386-5.3053,2.8796-4.4442-2.5928-5.2306-8.2748-5.202-12.958-0.27951-7.5908,2.777-14.674,5.4923-21.587,1.7275-4.3277,1.3019-9.1991,0.24806-13.634-1.3266-5.0918-5.4137-8.6231-8.5601-12.595,0.214-1.5365,4.235-0.69686,5.7483-0.40478,3.3588,0.85136,5.3664,3.8249,7.8703,5.9259,1.7818-0.53937,1.0545-4.1395,1.8839-5.833,0.0613-2.3821,3.233-5.5228,4.5407-2.1121,1.9588,2.1674-0.0626,6.4643,2.4686,7.8144,2.4113-0.89283,3.6009-3.5283,5.8666-4.72,2.2295-1.5204,5.3776-1.69,7.7781-0.49647,0.84484,2.2126-2.6402,4.0548-3.6496,5.9771-4.052,5.0056-5.4756,11.91-3.7401,18.112,1.3759,4.8649,3.8133,9.4058,4.6546,14.434,1.0126,5.6525,0.97903,11.589-0.48403,17.159-0.87455,3.3816-3.8021,5.6402-6.8258,7.0448-0.74602-0.69428-1.1395-1.7142-1.6436-2.583z'/%3E %3Cpath d='M711.61,326.89c-3.36-2.46-4.47-4.81-4.47-9.46,0-2.38,0.44-3.67,2.01-5.83,2.31-3.2,1.89-4.21-1.38-3.27-5.26,1.51-7.77,0.13-7.95-4.35-0.08-2.19,0.38-3.12,3.33-6.66,2.36-2.84,3.22-4.33,2.75-4.8-0.46-0.46-3.25,1.96-8.98,7.79-4.57,4.65-9.71,9.4-11.42,10.56-9.84,6.64-19.24,7.67-23.53,2.56-2.2-2.61-2.08-4.08,0.46-5.66,1.17-0.72,3.14-2.38,4.39-3.69,2.95-3.07,11.74-9.41,16.1-11.61,3.54-1.79,4.38-3,2.08-3-2.98,0-12.54,6.22-19.79,12.88-2.13,1.97-5.2,4.16-6.81,4.87-3.62,1.6-10.73,2.19-13.89,1.15-2.23-0.74-6.3-4.58-6.3-5.95,0-0.36,0.93-1.16,2.06-1.77,1.13-0.6,3.16-2.07,4.5-3.24,5.8-5.09,16.79-10.33,25.51-12.16,2.77-0.58,1.75-1.98-1.34-1.84-5.99,0.26-17.88,5.83-24.98,11.69-8.32,6.86-20.87,6.21-24.91-1.29-0.7-1.29-1.11-2.5-0.91-2.69,0.19-0.19,2.66-0.93,5.49-1.65,3.06-0.77,9.12-3.28,14.91-6.17,9.11-4.54,11.81-5.51,18.08-6.52,2.82-0.45,2.97-1.83,0.23-2.15-3.53-0.42-8.94,1.35-18.5,6.05-12.28,6.04-15.72,7.08-22.19,6.7-5.9-0.36-9.23-1.87-14.02-6.4-3.13-2.97-7.57-10.51-6.7-11.38,0.21-0.21,1.65,0,3.2,0.45,1.72,0.51,6.65,0.85,12.59,0.86,8.31,0.02,10.52-0.2,14.95-1.48,7.41-2.14,17.26-7.15,24-12.18,12.89-9.64,23.4-13.51,36.8-13.57,12.37-0.05,20.24,2.81,27.21,9.88,2.36,2.39,4.37,3.94,4.7,3.61,0.31-0.31,0.65-4.49,0.75-9.29,0,0,3.64-0.35,4.41,0.67,0,7.79,0.09,8.4,1.22,8.4,0.74,0,1.53-0.76,2.02-1.94,1.06-2.55,4.98-6.04,9.17-8.16,9.05-4.59,24.71-4.73,37.29-0.34,5.3,1.86,11.18,5.18,16.78,9.5,5.62,4.32,17.11,10.1,23.9,12.03,6.87,1.95,18.98,2.44,25.19,1.03,2.56-0.58,4.96-1.06,5.34-1.06,2.29,0-1.61,7.63-6.19,12.1-8.37,8.18-19.26,8.14-34.58-0.12-9.55-5.14-20.97-7.95-20.97-5.15,0,0.58,0.6,0.97,1.49,0.97,3.32,0,9.73,2.23,18.67,6.47,9.67,4.6,15.1,6.54,18.32,6.54,2.34,0,2.41,1.45,0.23,4.65-2.31,3.41-6.23,5.1-11.77,5.09-5.29-0.02-8.23-1.18-12.96-5.11-7.91-6.58-27.62-13.92-26.86-10,0.15,0.78,1.1,1.26,3.13,1.57,6.86,1.05,14.91,4.89,23.15,11.06,2.54,1.91,5.18,3.79,5.85,4.19,1.13,0.66,1.15,0.86,0.26,2.53-1.48,2.76-5.21,4.9-9.25,5.32-5.23,0.54-9.78-1.02-14.49-4.96-9.94-8.32-19.31-14.34-22.31-14.34-2.45,0-1.35,1.35,2.97,3.64,5.68,3.01,11.52,7.08,15.82,11.03,2.03,1.88,4.32,3.74,5.08,4.15,1.8,0.96,1.73,2.37-0.25,4.96-2.02,2.64-5.36,3.8-9.69,3.34-8.64-0.91-15.38-5.08-25.97-16.07-4.14-4.29-7.83-7.8-8.21-7.8-1.41,0-0.58,1.91,2.15,4.97,3.38,3.78,4.03,5.91,2.75,8.98-1.13,2.72-3.01,3.35-6.87,2.31-3.95-1.07-4.57-0.1-1.98,3.12,3.86,4.81,3.29,10.7-1.44,14.75-1.47,1.25-3.01,2.28-3.43,2.28-0.41,0-1.45-1.07-2.32-2.38-3.04-4.62-5.71-4.59-8.67,0.08-1.03,1.63-1.9,2.95-1.93,2.94-0.04-0.01-1.43-1.01-3.08-2.23z'/%3E %3Cpath d='M726.67,233.03,721.54,237.09,716.94,233.62,716.94,261.36,726.67,261.48z'/%3E %3Cpath d='M694.89,204.25c-1.02,13.11-4.35,22.26-8.98,32.35l11.1-10.29,7.72,9.17,8.36-9.33,8.53,7.88,8.2-8.2,8.52,9.97,7.4-8.2,12.54,9c-4.55-10.09-10.71-18.64-9.94-32.84-12.15,9.03-41.02,10.66-53.45,0.49z'/%3E %3Cpath d='M716.95,197.56c-4.46,0.08-9.16,0.14-13.39,0.97-2.93,0.58-5.59,1.53-7.81,3.1,0.36,8.53,41,12.09,51.9,0.16-2.29-1.67-5.09-2.66-8.17-3.26-4.07-0.79-8.57-0.87-12.84-0.94,0,2.34,0.02,4.69,0.02,7.04l-9.71-0.03v-7.04z'/%3E %3Cpath d='M724.9,153.97,718.59,154.02,718.59,203.4,725.03,203.43z'/%3E %3Cpath d='M724.89,155.24,722.48,178.88,746.8,190.76,734.49,174.3,751.3,168.85z'/%3E %3Cpath d='M722.18,149.08c-3.69,0-6.42,1.38-6.42,3.02s2.73,3.03,6.42,3.03,6.4-1.39,6.4-3.03-2.71-3.02-6.4-3.02z'/%3E %3C/g%3E %3Cg fill='%23f7e017'%3E %3Cpath d='M711.05,563.82c3.99-1.32,6.26-3.74,7.89-8.4,0.81-2.32,1.36-4.73,1.22-5.36-0.34-1.49-2.06-1.41-3.96,0.17-1.3,1.09-1.46,1.64-1.09,3.86,0.95,5.6-1.04,6.99-11.64,8.13-1.05,0.11-4.09-0.07-6.77-0.4-5.04-0.63-6.84-0.13-5.01,1.39,0.55,0.46,1.95,1.08,3.11,1.37,2.83,0.73,13.22,0.24,16.25-0.76z'/%3E %3Cpath d='M733.02,562.89c0.6-0.55,2.66-1.5,4.58-2.12,2.56-0.82,3.88-1.7,4.96-3.31,3.11-4.63,2.53-8.62-2.04-14-2.48-2.92-3.58-2.84-5.56,0.4-1.71,2.8-1.67,2.98,0.79,3.62,1.29,0.33,2.53,1.28,3.21,2.45,2.68,4.64,1.89,7.51-2.08,7.54-3.6,0.03-4.59,0.54-5.56,2.87-0.51,1.21-0.92,2.5-0.92,2.87,0,0.98,1.36,0.81,2.62-0.32z'/%3E %3Cpath d='M725.81,557.65c0.68-1.84,0.92-5.15,0.84-11.9-0.05-5.14-0.25-9.5-0.45-9.7-0.6-0.6-3.56,1.31-3.95,2.54-0.2,0.64,0.13,2.12,0.73,3.28,0.92,1.79,1.04,3.46,0.76,10.47-0.36,8.86,0.22,10.35,2.07,5.31z'/%3E %3Cpath d='M708.89,553.43c0.36-1.65,0.82-5.03,1.03-7.5s0.72-5.59,1.12-6.94c1.02-3.46-0.01-4.37-2.74-2.43l-2.03,1.45,0.42,4.97c0.39,4.48-0.32,12.83-1.35,16.07-0.28,0.86,0.12,0.64,1.25-0.68,0.91-1.06,1.95-3.29,2.3-4.94z'/%3E %3Cpath d='m693.88,555.84c3.6514-3.0546,3.2318-8.2704,4.04-12.52-0.0835-2.8248,1.8038-6.2116,0.58588-8.6828-3.4119,0.62408-5.5147,3.8554-3.7684,7.0746,0.14546,3.7382,0.0129,7.8076-1.9089,11.113-1.5698,2.1618-6.5419,1.6234-6.3131-1.4406,1.2477-4.6065-4.2718-2.3648-6.4264-1.1571-1.6657,1.1597-5.1825,1.2451-3.9601-1.6569-0.80663-3.8664-5.7798-1.4479-8.4816-1.4651-2.552-0.0466-0.21096-5.1708-3.8736-4.271-6.8058-0.53675-14.319,0.0602-20.21-4.0515-3.4486-1.6577-2.937-5.8052-1.1415-8.4888,2.1442-3.6651,2.7555-8.249,6.1588-11.093,3.369-3.231-3.1775-1.8666-4.6517-0.77788-3.2819,1.7962-0.23302,6.4226-2.9192,8.9886-1.5695,2.6611-3.6362,6.3361-7.2698,5.8296-5.2398-0.9908-8.2605-5.8651-12.017-9.1317-3.218-0.64222-1.4087,5.2218,0.25284,6.4543,3.2878,2.4618,7.1291,4.2558,11.092,5.3187,3.9439-0.63072,4.0717,4.5336,7.4444,5.3437,6.1873,2.883,13.083,3.7467,19.833,4.0986,2.6511,0.22107,1.16,4.9425,4.6458,4.0096,1.948,0.50493,6.3478-0.72487,6.5682,1.5381-2.9527,3.5059,2.8341,3.4276,4.9757,2.7999,2.742-0.41905,6.2461-1.4668,6.9708,2.2924,2.289,2.413,6.4921,2.057,9.2796,0.67619,0.39162-0.22691,0.75972-0.49483,1.0937-0.80043z'/%3E %3Cpath d='M634.12,525.57c1.11-1.41,2.77-4.26,3.69-6.34,0.91-2.09,2.28-4.46,3.03-5.27,1.76-1.9,0.78-3.07-2.06-2.44-1.5,0.33-2.11,0.88-2.36,2.18-0.85,4.24-2.39,8.58-3.76,10.6-2.48,3.66-2.54,3.81-1.52,3.81,0.53,0,1.87-1.14,2.98-2.54z'/%3E %3Cpath d='M596.66,502.09c-2.8,0-2.92,1.77-0.19,2.72,1.32,0.46,2.44,1.57,3.34,3.38,2.66,5.29,4.22,6.23,11.28,6.84l4.53,0.41,0.22,2.75c0.11,1.52,0.47,2.78,0.82,2.78s2.1-0.76,3.87-1.66c3.32-1.68,6.47-5.6,6.47-8.03,0-1.59-2.65-3.31-5.06-3.31-1.07,0-3.11,0.86-4.72,2.03-5.04,3.65-10.43,2.91-13.38-1.84-2.42-3.92-4.95-6.07-7.18-6.07zm24.46,9.75c1.34,0,1.67,0.99,0.94,2.88-0.5,1.3-2.13,1.34-2.62,0.06-0.58-1.51,0.23-2.94,1.68-2.94z'/%3E %3Cpath d='M810.84,505.69c-1.83,0.07-2.37,0.47-3.53,2.19-1.9,2.82-2.09,8.93-0.34,11.09,1.09,1.34,1.25,1.37,3.56,0.41,3.22-1.35,3.76-1.3,3.75,0.43-0.02,4.42-6.36,12.94-13,17.47-1.79,1.22-3.39,2.58-3.56,3.03-0.48,1.26,1.98,0.98,5-0.56,4.12-2.1,9.53-7.62,11.75-11.97,1.76-3.47,2.01-4.65,2.22-10.72,0.19-5.59,0.04-7.23-0.91-9.09-1.06-2.09-1.4-2.28-4.06-2.28-0.32,0-0.61-0.01-0.88,0zm0.22,3.9c1.38,0,1.62,0.31,1.78,2.29,0.14,1.64-0.15,2.64-1.06,3.46-1.24,1.12-1.34,1.11-2.44-0.56-1.54-2.36-0.59-5.19,1.72-5.19z'/%3E %3Cpath d='M780.7,552.27c5.85-2.88,9.3-6.12,11.52-10.81,1.05-2.23,1.91-4.33,1.91-4.69,0-0.81-2.88-2.15-4.61-2.15-1.72,0-2.07-1.19-1.33-4.48,0.72-3.21-0.15-7.23-1.56-7.23-0.51,0-1.41,0.75-2.01,1.66-0.92,1.41-0.97,2.01-0.29,4.06,1,3.04,0.21,5.31-2.51,7.25-1.29,0.92-2,1.98-2,3.01,0,0.87,0.11,1.58,0.24,1.58,0.14,0,1.56-0.74,3.16-1.63l2.92-1.63,1.72,1.35c0.94,0.74,1.72,1.95,1.72,2.69,0,3.56-10.15,9.54-17.12,10.1-3.71,0.3-4.34,0.17-5.63-1.11-1.05-1.05-1.35-1.93-1.09-3.17,0.2-0.95,0.56-2.68,0.8-3.84,0.64-3.1-0.69-2.68-2.99,0.94-1.89,2.99-2.45,6.18-1.39,7.86,0.87,1.37,6.65,2.68,10.74,2.43,2.57-0.15,5.11-0.87,7.8-2.19z'/%3E %3Cpath d='M819.74,530.49c3.68-3.67,5.24-8.14,5.26-15.05l0.01-5.19,3.04-1.44c3.95-1.88,7.69-5.62,7.69-7.7,0-2.14-0.95-2.03-2.67,0.3-1.25,1.69-2.92,2.71-9.03,5.52-1.54,0.71-1.64,1.09-1.99,7.55-0.41,7.45-1.42,10.24-5.58,15.33-2.55,3.1-2.64,3.51-0.87,3.51,0.73,0,2.59-1.27,4.14-2.83z'/%3E %3Cpath d='M779.66,526.33c0.35-1.07-1.68-1.83-2.56-0.96-0.37,0.37-0.47,1.01-0.22,1.42,0.58,0.93,2.42,0.62,2.78-0.46z'/%3E %3Cpath d='M834.93,512.02c0.36-1.07-1.68-1.83-2.55-0.96-0.38,0.38-0.48,1.02-0.23,1.43,0.58,0.93,2.42,0.62,2.78-0.47z'/%3E %3Cpath d='m768.41,473.28c-1.4296,0.68071-2.1713,2.2244-3.165,3.4028-0.71516,0.48622-0.14203,0.9405,0.26976,1.3988,2.5225,2.7171,3.5898,6.3866,4.7883,9.8088,1.177,4.0402,2.659,8.3784,1.4283,12.588-0.48423,1.6123-1.7525,3.2813-3.6466,2.746-3.0304-0.18916-6.0122-0.99351-9.0512-0.96152-2.705,0.14095-4.7956,2.6024-7.5614,2.3341-1.767,0.11638-1.6925-3.618-3.3341-2.6194-0.8128,1.9472-0.41254,4.1196-0.50932,6.1787,0.30628,0.29508,1.165,0.0377,1.6799,0.1242h5.4451c0.38492,1.8802,0.33677,4.0358,1.6875,5.5312,1.8899,0.67214,4.0159,0.0917,5.8116-0.64309,1.9256-0.89569,2.1834-3.2112,2.7274-5.0153,0.57858-1.9384,3.117-1.4302,4.6149-2.1913,3.6648-1.0697,6.0666-4.8789,5.852-8.6268-0.23686-5.722-2.4198-11.105-4.0759-16.521-0.83346-2.386-1.4104-4.875-2.377-7.2045-0.11331-0.20034-0.34573-0.36894-0.58432-0.32903zm-9.07,32.72c2.0364-0.13276,2.9212,2.3697,2.4899,4.0293-0.76215,2.2555-3.5349,0.80928-4.0958-0.81602-1.0301-1.4517-0.39353-3.4044,1.6058-3.2133z'/%3E %3Cpath d='M683.94,487.22c-0.91-0.02-1.93,0.32-2.94,1.03-5.31,3.72-6.67,8.12-3.06,9.84,2.65,1.27,1.98,2.76-2.19,4.85-5.97,2.98-11.24,2.61-21.25-1.53-2.46-1.02-3.1-0.63-2.53,1.62,0.55,2.21,2.57,3.42,7.59,4.56,5.4,1.24,11.93,0.84,16.13-0.97,2.05-0.88,4.48-2.73,6.53-4.96l3.25-3.57,3.78,0.47c4.66,0.57,4.75,0.62,4.75,2.85,0,1.77,0.1,1.81,4.38,2.21,2.41,0.23,5.58,0.44,7.06,0.44,1.89,0.01,2.96,0.34,3.59,1.22,0.84,1.17,1.34,1.23,8.38,0.6,6.58-0.6,7.87-0.55,10.84,0.46,2.11,0.72,4.43,1.01,6.19,0.82,5.04-0.57,11.99-4.69,13-7.72,0.12-0.37,1.95-1.02,4.06-1.44,5.09-1.02,5.31-2.13,0.56-2.72-2.06-0.26-5.15-1.01-6.87-1.69-1.73-0.68-4.09-1.25-5.25-1.25-2.56,0-4.97,1.6-4.97,3.25,0,1.08,0.38,1.19,3.41,0.88,2.85-0.29,3.68-0.13,5.18,1.06,0.99,0.78,1.65,1.7,1.44,2.03-0.67,1.09-6.62,3.8-9.25,4.22-1.76,0.28-3.18,0.09-4.56-0.62-2.31-1.2-5.71-1.38-6.35-0.35-0.27,0.45-1,0.16-2-0.78l-1.56-1.47-3.53,1.47c-3.59,1.49-4.91,1.43-4.91-0.28,0-0.78-1.05-0.87-6.34-0.53-5.83,0.38-6.44,0.28-7.53-0.94-1.01-1.12-1.03-1.51-0.31-2.66,0.66-1.06,0.66-1.52,0.03-2.15s-1.45-0.62-3.75,0c-5.8,1.55-7.44,0.68-7.44-3.85,0-2.72-1.56-4.37-3.56-4.4zm-1.44,4.16c0.31,0,0.57,0.19,0.97,0.59,0.51,0.51,0.78,1.4,0.56,1.97-0.52,1.35-2.98,1.3-3.5-0.06-0.25-0.66,0.07-1.4,0.81-1.94,0.52-0.38,0.85-0.57,1.16-0.56z'/%3E %3Cpath d='M672.1,495.6c3.53-2.24,3.45-2.07,3.96-8.29,0.35-4.39,0.29-4.72-0.9-4.72-1.73,0-2.63,1.9-2.63,5.52,0,2.32-0.36,3.36-1.6,4.59-2.94,2.94-10.24,1.6-11.16-2.05-0.31-1.25,0.09-2.38,1.62-4.55,3.19-4.53,2.47-5.64-1.44-2.2-2.69,2.35-3.17,2.42-2.66,0.39,0.47-1.87-0.51-2.61-2.7-2.06-1.12,0.28-1.73,0.98-2,2.34-0.26,1.33-0.87,2.07-1.93,2.33-1.77,0.45-4.79-1.23-4.79-2.66,0-1.06,4.52-6.58,10.32-12.6,2.19-2.28,3.98-4.4,3.98-4.72s-1.17-0.58-2.6-0.58c-2.09,0-2.6,0.23-2.6,1.2,0,0.66-2.92,4.49-6.5,8.52-7.46,8.4-8.08,10.15-4.39,12.39,2.97,1.82,6.78,1.68,9.77-0.35l2.42-1.65v2.99c0,3.82,0.76,5.19,3.76,6.78,3.77,1.99,8.33,1.75,12.07-0.62z'/%3E %3Cpath d='m828.66,443.69c-2.7668,1.6519-0.60168,5.1236-0.18254,7.4288-1.1299,3.146-5.1718,3.9934-8.1183,4.5774-4.1736,0.69135-7.1308,4.1827-8.7186,7.8921-0.86037,2.4089-2.9366,6.1445-5.1993,2.4767-1.9667-1.9933-5.5819-3.5732-7.9078-1.2462-1.7668,1.6824-2.2148,4.1568-2.8735,6.4025-1.0427-1.7262-1.5104-4.2966-3.7201-4.8424-3.5276,0.49628-2.2527,4.9439-0.594,6.7779,1.5076,2.1378,2.9558,4.9578,1.4779,7.4969-1.303,3.0516-5.8095,5.11-8.4565,2.4995-2.4722-1.305-0.81896-5.9649-3.254-6.221-1.204,0.86977-1.3032,5.7458-3.2303,3.1024-1.3906-2.2586-0.65318-5.3523-2.3547-7.3843-2.0106,0.24966-3.6272,3.7115-2.9583,5.5709,2.6825,3.6176,3.7849,8.1558,4.8314,12.467,0.65196,1.7264-0.0951,5.2267,1.5199,5.9106,1.1196-2.7787,0.0791-5.9306,0.96044-8.7358,2.6182-0.32901,5.5303,0.86591,8.2761,0.23077,3.9286-0.50981,6.9646-3.825,8.3424-7.3555,0.41644-2.6542-0.079-5.3476-0.15274-8.0168,3.1034,0.48084,6.3281,0.47101,9.3135,1.4788,1.4804,2.2709-0.46974,5.4485-0.87913,7.9295-1.5586,5.0524-5.5163,8.7194-9.366,12.097-1.6101,0.95299-1.8264,3.4782,0.55162,2.118,5.1735-2.2122,9.0295-6.8975,11.248-11.969,1.619-3.9019,0.31744-8.2474,1.3744-12.238,1.5617-2.9959,5.3215-2.3646,8.1035-2.3553,2.879-0.10959,5.3363-3.464,4.3747-6.2619-0.91607-3.2468,2.519-4.8109,4.8661-5.9714,3.1119-1.5702,5.4981-4.7591,5.2571-8.3583-0.12787-1.8402-0.0371-5.3318-2.5312-5.5zm-11.031,18.75c3.3336,0.88568-0.60342,7.2524-2.375,3.2188-0.54528-1.539,0.75001-3.2741,2.375-3.2188zm-15.47,4.56c4.3385-0.25338,2.7806,6.0812-0.88479,3.2048-1.9006-0.95441-1.2718-3.3229,0.88479-3.2048z'/%3E %3Cpath d='M645.1,491.48c0.12-0.63-0.2-1.08-0.77-1.08-1.21,0-1.94,1.06-1.37,1.98,0.59,0.95,1.89,0.41,2.14-0.9z'/%3E %3Cpath d='M695.94,485.8c0-0.93-0.35-1.28-1.13-1.13-1.7,0.32-1.89,2.48-0.22,2.48,0.93,0,1.35-0.42,1.35-1.35z'/%3E %3Cpath d='m633.03,455.28c-2.029-0.41667-3.3053,1.3004-4,2.9375-1.5174,2.5503-3.3705,5.1587-6.0931,6.5091-1.9578,0.54422-4.0937-0.20046-5.7819-1.2102-2.0147-1.0029-1.5567-3.4259-2.4202-5.1005-1.457-1.1443-4.0407,0.4921-3.9834,2.2714-0.16115,2.3862,2.0713,3.7641,3.9242,4.6869,1.5747,0.96445,3.8577,1.5009,4.4871,3.4529-0.0437,1.6587,0.6235,3.5571,2.6435,2.9166,2.2597-0.0372,2.8449,2.7155,1.9326,4.3671-0.92932,1.8613-1.5564,4.0416-1.1119,6.1154,1.08,0.90934,2.1827-1.5301,2.9652-2.2268,0.53138-0.70851,1.0628-1.417,1.5941-2.1255,3.9984,0.21679,7.9929,0.72673,12.001,0.5846,2.8505-0.0516,5.2778-1.8114,7.0906-3.875,2.5633-2.6802,4.6693-5.8294,7.597-8.142,2.0839-0.50859,0.96439-4.4336-1.2124-3.3001-1.9608,0.7355-2.578,2.9513-3.9368,4.3632-2.3146,2.8028-4.6762,5.6471-7.5941,7.8434-2.1245,0.8812-4.5705,0.49663-6.7532-0.00022-0.91062-0.79618,1.8087-1.445,2.188-2.33,1.252-1.2507,2.7385-2.438,3.4639-4.0814-0.69398-1.5148-2.8167-1.6373-4.3126-1.6678-3.6856,0.44249-6.5007,3.5363-10.223,3.8277-2.8253,0.099-1.355-2.9607-0.0813-4.0046,2.4916-2.9589,5.1844-5.7458,7.7858-8.6074,0.73816-0.88845,3.4086-1.732,1.7006-2.98-0.59723-0.21503-1.2431-0.21478-1.8694-0.22424zm1.8125,14.969c1.8586,1.0454-1.1858,2.7567-2.4681,2.5229-1.6823,0.50416-1.7125-1.2116-0.2183-1.5533,0.8401-0.43711,1.7274-0.89316,2.6864-0.96961zm-5.7188,3.9062c1.0579-0.0202,3.2748,0.99623,1.1931,1.6469-1.4494,1.1234-3.0867-1.1434-1.1931-1.6469z'/%3E %3Cpath d='M674.15,476.74c0-1.41-2.53-1.21-2.81,0.22-0.18,0.92,0.11,1.14,1.29,0.97,0.84-0.12,1.52-0.65,1.52-1.19z'/%3E %3Cpath d='M786.2,466.82c0.26-1.35-1.62-2.25-2.61-1.26s-0.08,2.87,1.26,2.61c0.62-0.12,1.23-0.73,1.35-1.35z'/%3E %3Cpath d='M611.82,453.09c1.76-1.51,1.78-1.61,1.02-4.93-1.08-4.65-1.01-5.15,0.76-5.59,2.24-0.57,7.93,2.48,9.19,4.92,0.98,1.89,0.95,2.02-0.71,3.56-1.79,1.65-1.78,3.58,0.01,3.58,1.48,0,5.57-3.87,5.57-5.26,0-1.93-4.54-6.49-8.13-8.16-2.22-1.04-4.44-1.52-7.01-1.53-4.6,0-5.22,0.99-3.98,6.34,1.46,6.27-0.52,7.12-5.57,2.39-3.75-3.51-5.23-7.16-5.21-12.91,0.01-6.17,2.37-9.22,7.69-9.94,3.53-0.47,3.44-1.3-0.19-1.84-5.3-0.8-9.78,2.74-11.48,9.06-1.89,7.01,2.44,15.55,10.1,19.95,4.01,2.3,5.61,2.37,7.94,0.36z'/%3E %3Cpath d='M820.66,445.4c0.43-0.43,0.78-1.4,0.78-2.15s0.73-2.36,1.62-3.57c0.9-1.21,1.63-2.45,1.63-2.75,0-1.23-2.03-1.19-3.63,0.08-1.64,1.28-2.87,1.31-2.87,0.06,0-0.31,0.78-0.95,1.74-1.42,2.38-1.16,2.58-2.31,0.57-3.23-2.58-1.17-5.17,0.97-5.44,4.5-0.17,2.36,0.02,2.77,1.84,3.84,1.66,0.98,1.97,1.5,1.69,2.9-0.48,2.43,0.53,3.28,2.07,1.74z'/%3E %3Cpath d='M840.29,443.18c1.44-1.29,2.61-2.76,2.61-3.25s1.24-1.79,2.76-2.88c4.31-3.1,5.26-6.23,3.33-11.04-0.75-1.89-3.11-4.5-8.24-9.12-3.94-3.56-7.57-6.47-8.04-6.47-1.4,0-1.15,5.15,0.27,5.6,2.56,0.82,4.11,1.87,8.14,5.5,4.68,4.23,6.84,8.18,5.66,10.38-1.13,2.13-2.63,1.47-6.76-2.96-2.17-2.33-4.32-4.23-4.76-4.23-0.48,0.01-0.82,0.85-0.82,2.03,0,1.48,0.79,2.89,2.93,5.27,3.49,3.88,3.83,6.21,1.21,8.27-0.94,0.74-1.91,1.35-2.15,1.35-0.23,0-1-1.16-1.7-2.57-1.46-2.96-10.39-12.39-11.73-12.39-0.61,0-0.91,0.76-0.91,2.26,0,1.81,0.36,2.45,1.8,3.19,1.77,0.92,6.15,5.33,10.55,10.65,1.26,1.52,2.5,2.75,2.77,2.76,0.26,0,1.65-1.06,3.08-2.35z'/%3E %3Cpath d='M849.05,418.11c-0.58-1.87-12.56-14.2-13.79-14.2-0.64,0-0.84,0.76-0.69,2.72,0.17,2.38,0.43,2.79,2.07,3.22,1.02,0.27,4.18,2.75,7.01,5.5,2.82,2.75,5.3,4.84,5.5,4.63,0.2-0.2,0.16-1.04-0.1-1.87z'/%3E %3Cpath d='m777.5,556.89a1.7806,1.6322,0,1,1,-3.5612,0,1.7806,1.6322,0,1,1,3.5612,0z'/%3E %3Cpath d='m783.79,554.79a1.7806,1.6322,0,1,1,-3.5612,0,1.7806,1.6322,0,1,1,3.5612,0z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!-- Created with Inkscape (http://www.inkscape.org/) --%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.1' width='1100' height='750' id='svg2'%3E %3Cmetadata id='metadata14'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3Cdc:title%3E%3C/dc:title%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Cdefs id='defs12' /%3E %3Crect width='1100' height='750' x='0' y='0' id='rect4' style='fill:%23007934' /%3E %3Crect width='1100' height='500' x='0' y='0' id='rect6' style='fill:%23ffe000;fill-opacity:1' /%3E %3Crect width='1100' height='250' x='0' y='0' id='rect8' style='fill:%23d52b1e' /%3E %3Cg transform='matrix(0.12820513,0,0,0.12820513,425,266.66667)' id='g8695'%3E %3Cg transform='translate(0,-33.645288)' id='g14699' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-1,0,0,1,1952.1115,3.7236016)' id='g46545' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(7.3943106,0.8910471,-1.0392097,6.3400848,-2382.5346,-1030.2797)' id='g46547' style='stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path46549' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path46551' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.3943106,-0.8910471,1.0392097,6.3400848,-2997.8599,-169.04813)' id='g46553' style='stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path46555' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path46557' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.4669838,0,0,6.4023999,-2701.2711,-602.41592)' id='g46559' style='stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path46561' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path46563' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='translate(-2.1114528,3.7236016)' id='g38441' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(7.3943106,0.8910471,-1.0392097,6.3400848,-2382.5346,-1030.2797)' id='g3476' style='stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path1717' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path3474' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.3943106,-0.8910471,1.0392097,6.3400848,-2997.8599,-169.04813)' id='g1737' style='stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path1739' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path1741' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.4669838,0,0,6.4023999,-2701.2711,-602.41592)' id='g1731' style='stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path1733' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path1735' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(-6.2056208,-2.3690086,-2.7629299,5.3208753,4182.7969,613.03001)' id='g2373' style='stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 408.42144,331.29731 c -4.14882,-7.95881 -21.27065,-18.78136 -24.22199,-19.08939 7.86928,17.3567 20.83844,23.63768 24.22199,19.08939 z' id='path2375' style='fill:%2300e519;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path2377' style='fill:%23ffe533;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path2379' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.42144,331.2203 c -4.42028,-8.46513 -22.35743,-18.93634 -24.26146,-19.12886 7.90971,17.31821 20.87791,23.67716 24.26146,19.12886 z' id='path2381' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path2383' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43509,-33.87402 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path2390' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43413,-33.87306 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path2392' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.59206,303.91605 c 4.93046,1.89826 5.78044,7.25899 0.41681,10.83796' id='path2394' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.74127,309.27679 c 1.24176,1.8636 3.10727,0.61799 3.10727,0.61799' id='path2396' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.97454,273.78078 c -2.22458,11.85061 -0.75661,21.01749 -0.798,23.61941 1.66531,5.78717 0.33403,16.66556 -0.94912,18.10272 l 1.95216,31.34815' id='path2398' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path2400' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path2402' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172 l -5.54653,-8.50172' id='path2404' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172' id='path2406' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 399.73972,310.56186 c -0.66131,0.66131 -1.70958,0.70078 -2.36993,0.0404 -0.65938,-0.65939 -0.65842,-1.74617 0.003,-2.40748 0.66034,-0.66034 1.70862,-0.6228 2.368,0.0366 0.66035,0.66035 0.65938,1.67012 -9.6e-4,2.33046 z' id='path2408' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 398.5432,302.21128 c -0.66131,0.66131 -1.74905,0.66131 -2.40844,0.002 -0.65937,-0.65938 -0.62087,-1.70862 0.0404,-2.36992 0.66034,-0.66035 1.67108,-0.66035 2.33046,-9.7e-4 0.65938,0.65938 0.69788,1.70862 0.0375,2.36897 z' id='path2410' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path2412' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path2414' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-6.2529099,-2.2757944,-2.6542057,5.3614204,4097.7489,593.25426)' id='g3429' style='stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 408.42144,331.29731 c -4.14882,-7.95881 -21.27065,-18.78136 -24.22199,-19.08939 7.86928,17.3567 20.83844,23.63768 24.22199,19.08939 z' id='path3431' style='fill:%2300e519;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3433' style='fill:%23ffe533;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3435' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.42144,331.2203 c -4.42028,-8.46513 -22.35743,-18.93634 -24.26146,-19.12886 7.90971,17.31821 20.87791,23.67716 24.26146,19.12886 z' id='path3437' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3439' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3442' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43509,-33.87402 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3446' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43413,-33.87306 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3448' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.59206,303.91605 c 4.93046,1.89826 5.78044,7.25899 0.41681,10.83796' id='path3450' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.74127,309.27679 c 1.24176,1.8636 3.10727,0.61799 3.10727,0.61799' id='path3452' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.97454,273.78078 c -2.22458,11.85061 -0.75661,21.01749 -0.798,23.61941 1.66531,5.78717 0.33403,16.66556 -0.94912,18.10272 l 1.95216,31.34815' id='path3454' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3456' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3458' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172 l -5.54653,-8.50172' id='path3460' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172' id='path3462' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 399.73972,310.56186 c -0.66131,0.66131 -1.70958,0.70078 -2.36993,0.0404 -0.65938,-0.65939 -0.65842,-1.74617 0.003,-2.40748 0.66034,-0.66034 1.70862,-0.6228 2.368,0.0366 0.66035,0.66035 0.65938,1.67012 -9.6e-4,2.33046 z' id='path3464' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 398.5432,302.21128 c -0.66131,0.66131 -1.74905,0.66131 -2.40844,0.002 -0.65937,-0.65938 -0.62087,-1.70862 0.0404,-2.36992 0.66034,-0.66035 1.67108,-0.66035 2.33046,-9.7e-4 0.65938,0.65938 0.69788,1.70862 0.0375,2.36897 z' id='path3466' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3468' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3470' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(6.2683131,-2.3929649,2.7908411,5.3746176,-2258.4183,602.88362)' id='g3472' style='stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 408.42144,331.29731 c -4.14882,-7.95881 -21.27065,-18.78136 -24.22199,-19.08939 7.86928,17.3567 20.83844,23.63768 24.22199,19.08939 z' id='path3475' style='fill:%2300e519;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3477' style='fill:%23ffe533;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3479' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.42144,331.2203 c -4.42028,-8.46513 -22.35743,-18.93634 -24.26146,-19.12886 7.90971,17.31821 20.87791,23.67716 24.26146,19.12886 z' id='path3481' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3483' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43509,-33.87402 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3489' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43413,-33.87306 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3491' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.59206,303.91605 c 4.93046,1.89826 5.78044,7.25899 0.41681,10.83796' id='path3493' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.74127,309.27679 c 1.24176,1.8636 3.10727,0.61799 3.10727,0.61799' id='path3495' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.97454,273.78078 c -2.22458,11.85061 -0.75661,21.01749 -0.798,23.61941 1.66531,5.78717 0.33403,16.66556 -0.94912,18.10272 l 1.95216,31.34815' id='path3497' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3499' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3501' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172 l -5.54653,-8.50172' id='path3503' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172' id='path3505' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 399.73972,310.56186 c -0.66131,0.66131 -1.70958,0.70078 -2.36993,0.0404 -0.65938,-0.65939 -0.65842,-1.74617 0.003,-2.40748 0.66034,-0.66034 1.70862,-0.6228 2.368,0.0366 0.66035,0.66035 0.65938,1.67012 -9.6e-4,2.33046 z' id='path3507' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 398.5432,302.21128 c -0.66131,0.66131 -1.74905,0.66131 -2.40844,0.002 -0.65937,-0.65938 -0.62087,-1.70862 0.0404,-2.36992 0.66034,-0.66035 1.67108,-0.66035 2.33046,-9.7e-4 0.65938,0.65938 0.69788,1.70862 0.0375,2.36897 z' id='path3509' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3511' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3513' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(6.2529099,-2.2757944,2.6542057,5.3614204,-2145.7489,593.25426)' id='g3515' style='stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 408.42144,331.29731 c -4.14882,-7.95881 -21.27065,-18.78136 -24.22199,-19.08939 7.86928,17.3567 20.83844,23.63768 24.22199,19.08939 z' id='path3517' style='fill:%2300e519;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3519' style='fill:%23ffe533;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3521' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.42144,331.2203 c -4.42028,-8.46513 -22.35743,-18.93634 -24.26146,-19.12886 7.90971,17.31821 20.87791,23.67716 24.26146,19.12886 z' id='path3523' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3525' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3527' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43509,-33.87402 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3531' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43413,-33.87306 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3533' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.59206,303.91605 c 4.93046,1.89826 5.78044,7.25899 0.41681,10.83796' id='path3535' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.74127,309.27679 c 1.24176,1.8636 3.10727,0.61799 3.10727,0.61799' id='path3537' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.97454,273.78078 c -2.22458,11.85061 -0.75661,21.01749 -0.798,23.61941 1.66531,5.78717 0.33403,16.66556 -0.94912,18.10272 l 1.95216,31.34815' id='path3539' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3541' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3543' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172 l -5.54653,-8.50172' id='path3545' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172' id='path3547' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 399.73972,310.56186 c -0.66131,0.66131 -1.70958,0.70078 -2.36993,0.0404 -0.65938,-0.65939 -0.65842,-1.74617 0.003,-2.40748 0.66034,-0.66034 1.70862,-0.6228 2.368,0.0366 0.66035,0.66035 0.65938,1.67012 -9.6e-4,2.33046 z' id='path3549' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 398.5432,302.21128 c -0.66131,0.66131 -1.74905,0.66131 -2.40844,0.002 -0.65937,-0.65938 -0.62087,-1.70862 0.0404,-2.36992 0.66034,-0.66035 1.67108,-0.66035 2.33046,-9.7e-4 0.65938,0.65938 0.69788,1.70862 0.0375,2.36897 z' id='path3551' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3553' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3555' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.4370353,-0.29145011,0.55781232,6.406304,670.55047,-1365.9813)' id='g2502' style='stroke:%23000000;stroke-width:0.21694411;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 5.3346094,370.91334 c 0.934977,-1.0632 62.7144166,-68.44801 63.4276096,-69.23663 -0.546422,-0.4824 -1.601054,-1.41623 -2.095078,-1.8747 -0.690782,0.74059 -62.6239996,68.19189 -63.6209946,69.24813 -0.596172,-0.33632 2.906607,2.54389 2.288463,1.8632 z' id='path2500' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694411;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(-0.404828,0.449606,-0.449606,-0.404828,194.9452,306.1962)' id='g2595' style='stroke:%23000000;stroke-width:0.35858223;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(1.450749,1.37671,-1.37671,1.450749,164.9287,-295.1823)' id='g3437' style='fill:%23dedede;fill-opacity:1;stroke:%23000000;stroke-width:0.17929105;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 146.6203,176.74359 c 1.44,1.8 4.0855,4.04754 6.2455,3.68754 0.18,3.42 -4.41,6.39 -6.03,5.67 0.99,-3.6 -3.34794,-6.5027 -3.25794,-6.5027 l 3.04244,-2.85484 z' id='path2399' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.17929105;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 125.90205,161.75608 c 0.23156,-3.51836 -0.3402,-4.51172 -0.86505,-8.85652 -0.51501,-4.26342 -8.333,-4.63039 -11.23886,-5.35429 0,0 6.85308,-8.47833 15.9642,-8.47698 9.11112,0.001 14.56445,4.29025 16.30124,9.6682 0,0 -10.75755,-0.53203 -11.66566,3.82072 -0.87997,4.21793 -0.45366,5.16579 -0.36474,8.6243' id='path720' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.35858223;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Crect width='12.37437' height='6.3639612' x='123.74368' y='158.97264' id='rect2593' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:0.35858223;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='translate(-2.1114528,3.7236016)' id='g38827' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg id='g46228' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 832.93795,1488.201 -11.24,110.162 c 0,0 17.0485,-20.8667 21.1467,-27.8 4.0981,-6.9332 18.8753,-25.4762 22.0361,-89.6894 0,0 -11.53978,-35.5079 -16.97298,-35.431 -9.0396,-4.4557 -14.96982,42.7584 -14.96982,42.7584 z m 27.0937,-245.5984 c 0,0 -29.5764,176.8817 -32.574,192.9662 0,5.5012 15.0112,20.0886 25.8539,-14.1163 l 17.8677,-128.5896 c 0,0 -8.0328,-34.2624 -11.1476,-50.2603 z' id='path2603' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 926.89285,1418.1194 c -7.2129,-9.0648 -16.2292,-20.3957 -17.1191,-24.9668 l -4.66,39.0254 c 0,0 24.6127,17.9855 21.1005,52.4112 l 4.7774,-6.9427 2.7632,-13.7895 c 0,0 5.0582,-22.9889 5.105,-36.7399 0,0 -5.199,-2.2182 -11.967,-8.9977 l 0,0 z' id='path2605' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 821.69965,1598.345 c 0,0 40.8651,-34.9544 43.1829,-117.4894 l 5.0584,-22.989 c 0,0 0.843,18.322 9.0395,4.4556 7.9856,-18.4468 7.5875,-34.4834 7.5875,-34.4834 0,0 14.777,-18.5426 19.2266,4.3114 0,0 -13.7222,107.9056 -14.6592,117.0859 -1.1708,11.4751 -3.2551,25.2548 -3.2551,25.2548 0,0 -8.1029,-13.6355 -16.2992,0.2309 -8.8755,13.8759 -22.9735,32.4092 -49.8814,23.6232 l 0,0 z m 49.4814,-305.5003 -17.8674,128.5896 c 0,0 14.2384,6.6738 16.6273,36.4323 1.3115,13.732 6.7681,6.7795 9.0395,4.4556 2.9742,-9.2091 0.7727,-27.5115 0.7727,-27.5115 l 7.7745,-89.4877 c 0,0 -15.4801,-41.0319 -16.3466,-52.4783 z' id='path2607' style='fill:%23ffe000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 857.03095,1590.9877 -2.599,32.1211 c 0,0 12.2244,-0.173 20.4208,-14.0394 9.5546,-13.8854 13.0204,-34.5601 13.0204,-34.5601 0,0 -9.461,-13.6166 -16.2994,0.2307 -6.6036,11.5519 -14.5428,16.2477 -14.5428,16.2477 z m 21.9423,-128.6473 c 6.604,-11.552 8.7116,-32.2075 7.5875,-34.4833 l -8.30828,6.9717 c 2.6698,13.7125 0.72078,27.5116 0.72078,27.5116 z' id='path2609' style='fill:%23ffe000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 919.21895,1449.3875 c -5.6205,-11.3792 -15.1052,-18.1203 -15.1052,-18.1203 l -18.1483,144.6357 c 0,0 -5.1049,36.7401 -27.7741,46.2277 0,0 12.9278,125.8624 53.7931,90.908 5.9014,-4.6669 13.278,-43.7307 10.8656,-66.614 -2.8571,-25.1685 -9.5318,-59.4499 -10.1639,-73.1915 -0.3984,-16.0364 1.86839,-32.2787 5.80269,-57.5436 1.6157,-9.1897 6.37226,-29.3331 7.28556,-31.6376 2.2715,-2.3241 -0.48985,-21 -6.55545,-34.6644 z' id='path2611' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 938.86685,1427.1532 c 0,0 11.0535,11.3021 13.0909,11.2734 2.7165,-0.039 -28.68334,235.8639 -28.68334,235.8639 0,0 1.18164,-24.728 -7.98364,-72.7565 -7.44564,-39.0171 2.16252,-91.4007 10.55711,-116.5352 0,0 9.90457,-7.3836 13.01897,-57.8456 z' id='path2613' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 886.60875,1347.682 c 0,0 -6.112,66.5468 -7.5403,87.1924 0,0 20.7017,-30.0854 26.0414,-2.6602 l 4.6601,-39.0252 c 0,0 -18.009,-29.5375 -23.1612,-45.507 z' id='path2619' style='fill:%23f7e214;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 870.75092,1457.6637 c 0,0 -6.79596,-74.5342 -42.89881,-21.8408 -1.39974,0.019 -3.31572,29.6128 -1.24048,36.699 1.1346,9.4709 11.12548,21.1882 15.30079,28.2443 7.89114,11.7471 16.3378,-2.6038 16.3378,-2.6038 0,0 8.20512,-11.9759 12.5007,-40.4987 z' id='path2621' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(1,-0.04702074,0,1,-2.2402185,26.33245)' id='g46260' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 586.92745,838.90947 c -1.3302,-42.47871 -14.6773,-113.66915 -15.3412,-162.07779 L 425.25675,520.83687 c 0,0 -18.0611,119.96174 -71.1929,186.53571 l 232.8636,131.60989' id='path236' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 597.49388,844.43331 c 6.1621,-29.21459 13.5591,-62.06604 18.4676,-123.54139 l -94.2,-97.24502 c 0.3762,38.74522 -43.4931,96.60853 -46.4621,168.83923' id='path6858' style='fill:%23ffe000;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 678.72756,937.60442 c 10.8066,-51.25367 -15.68378,-58.91622 23.71972,-129.89659 l -87.04676,-87.55809 c -16.2197,48.31751 -27.1401,79.39667 -25.727,121.87536 l 74.1618,56.26539' id='path238' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg id='g46249' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 337.90285,1241.5978 c -17.6248,-52.3867 6.303,-155.1608 3.6429,-221.0135 -1.9939,-42.48061 29.2436,-202.21617 28.5773,-250.53379 l -172.034,-107.44557 c 0,0 -7.4912,174.58162 -27.291,364.74936 -17.8157,97.674 -17.6979,186.9273 -4.8973,261.4838 18.2887,105.9774 36.2532,149.485 79.064,194.3175 75.9792,78.6255 239.5863,33.1999 239.5863,33.1999 137.8261,-28.5197 217.2142,-115.3382 217.2142,-115.3382 0,0 -44.827,10.5911 -117.4598,17.9733 -159.1864,-11.1519 -221.8825,28.632 -226.8347,-134.7009' id='path1466' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 798.94255,1347.4263 2.6601,-1.1496 c -29.8384,11.1657 -71.4524,23.4993 -71.4524,23.4993 l -96.991,7.4644 c -210.3899,4.9187 -184.0526,-125.3492 -175.7093,-335.5212 1.9963,-79.75702 17.8065,-180.20483 13.7334,-215.76778 l -141.0351,-80.79199 c -46.0025,129.96648 -31.665,220.89093 -40.8713,287.38017 -4.8068,71.6185 -20.0806,211.4811 3.1445,272.5093 32.8707,141.978 144.0394,136.1933 294.5239,123.7084 74.6517,-6.1936 114.8199,-25.3861 114.8199,-25.3861 l 97.0942,-55.8717' id='path1468' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 801.68565,1344.58 c -29.1784,15.1082 -72.1124,26.2555 -72.1124,26.2555 l -98.3108,9.7098 c -152.5209,12.9399 -241.8084,-94.194 -222.2648,-336.4513 0.1293,-85.58426 2.8724,-123.59981 32.4009,-237.61027 l 83.8245,49.18311 0,7.89215 c -4.7369,25.58935 -16.7308,85.43176 -16.7308,112.80179 0,194.50942 122.9863,343.91002 290.5333,369.27752 l 2.6601,-1.1315' id='path1470' style='fill:%23007a3d;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 244.89215,759.75096 c 14.2136,23.88513 99.0882,153.17293 146.638,177.62185' id='path1474' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 259.18875,844.21546 c 14.2158,24.45064 118.126,170.06404 164.927,178.26054' id='path1476' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 235.41365,1066.7355 c 23.7751,28.5197 47.4673,85.0303 118.1261,121.6699' id='path1478' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 268.66505,1228.6032 c 47.4671,44.2666 164.927,141.5588 278.3158,145.5548' id='path1480' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 268.66505,1301.4444 c 23.7751,28.5198 75.3153,161.8858 292.6123,101.3612' id='path1482' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 235.41365,1325.8951 c 14.2155,32.005 122.8652,210.2765 316.3874,141.4861' id='path1484' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg id='g46238' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 462.20445,1177.5906 c -17.6248,-52.3867 6.3032,-155.1608 3.6429,-221.01339 -1.9939,-42.48042 18.0434,-189.41138 17.377,-237.72899 L 322.39065,598.59776 c 0,0 -7.4908,174.58176 -27.2907,364.74945 -17.816,97.67399 -31.39661,217.31349 -18.1964,291.80029 21.603,121.9025 80.21406,156.1875 90.7984,165.6172 82.16457,73.2014 267.63002,66.0029 286.0569,59.4174 132.53569,-47.3661 190.2705,-131.5745 190.2705,-131.5745 0,0 -62.7893,-1.0062 -135.422,6.3756 -159.1867,-11.1515 -239.5838,-4.5105 -244.5361,-167.8436' id='path2419' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 923.24415,1283.4194 2.6602,-1.1497 c -29.8384,11.1654 -71.4525,23.4993 -71.4525,23.4993 l -96.9909,7.4644 c -210.3899,4.9186 -184.0524,-125.3492 -175.7091,-335.52124 1.9961,-79.75689 4.7392,-151.39372 0.666,-186.95707 l -126.101,-91.99612 c -46.0026,129.96661 -33.5317,203.28436 -42.7381,269.77366 -4.8068,71.61847 -20.0805,211.48107 3.1446,272.50907 32.8706,141.9782 144.0391,136.1933 294.5239,123.7084 74.6518,-6.1933 114.8198,-25.386 114.8198,-25.386 l 97.0943,-55.8717' id='path2421' style='fill:%23ffe000;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 926.98335,1281.5197 c -29.1782,15.1085 -72.1119,26.2559 -72.1119,26.2559 l -98.3111,9.7097 c -152.5208,12.9399 -241.8086,-94.1942 -222.2649,-336.4512 0.1293,-85.58451 -2.7276,-91.5877 26.8005,-205.59846 46.7189,30.27386 136.015,106.50937 136.015,106.50937 0,0 -24.29385,34.1993 -18.598,82.01037 0,194.50922 78.2636,293.25532 245.8102,318.62282 l 18.3773,-158.8556' id='path2423' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 369.19375,695.74391 c 14.2136,23.885 99.0882,153.17294 146.6383,177.62199' id='path2427' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.49035,780.20842 c 14.2159,24.4509 118.1261,170.06414 164.9269,178.26064' id='path2429' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.71555,1002.7285 c 23.7748,28.5195 47.4669,85.0303 118.1258,121.6696' id='path2431' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.96655,1164.5962 c 47.4674,44.2669 164.9271,141.5586 278.3161,145.5546' id='path2433' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.96655,1237.4373 c 23.7753,28.5199 75.3154,161.8858 292.6126,101.3613' id='path2435' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.71555,1261.8881 c 14.2157,32.005 122.8651,210.2764 316.3872,141.4859' id='path2437' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 199.22285,679.50793 c 0,0 -7.115,61.95089 -7.7941,73.05909 -3.2837,53.72498 -1.7729,94.37835 0.759,119.68548 -0.1671,2.73323 10.3499,67.00898 6.7286,70.44221 -12.3497,14.09212 -12.7856,15.65722 -25.7994,5.22755 -1.8677,-2.14492 5.6134,-67.96457 6.1668,-77.01703 1.2613,-9.72251 3.2972,-86.61407 4.6797,-120.14313 0.1454,-13.25869 11.542,-78.52516 11.542,-78.52516 0,0 1.5164,-13.89893 3.6452,7.09238' id='path1486' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 199.22285,679.50793 c 0,0 -7.115,61.95089 -7.7941,73.05909 -3.2837,53.72498 -1.6899,94.38193 0.759,119.68548 -0.1671,2.73323 12.5488,92.19937 8.5925,70.52608 -12.3495,14.09186 -14.884,19.40952 -27.8978,8.97971 -1.8677,-2.14492 5.8479,-71.8006 6.4013,-80.85306 1.2613,-9.72251 3.2972,-86.61407 4.6797,-120.14313 0.1454,-13.25869 11.542,-78.52516 11.542,-78.52516 0,0 1.5164,-13.89893 3.6452,7.09238 l 0,0 0.0722,0.17861 z' id='path1488' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 197.88685,657.78481 c 0,0 -14.0261,74.2259 -15.2972,116.81525 -1.8264,51.66406 -4.051,66.27651 -3.2284,96.39606 0.5409,2.06344 -5.0422,38.91192 -6.686,54.9318 -1.1718,8.25771 1.2024,2.11524 -0.1673,2.73335 -10.5508,6.45452 -17.7264,1.2646 -24.1576,-3.82635 -1.9086,-1.44519 17.0522,-46.09001 17.6056,-55.14273 10.0124,-131.10758 29.0249,-207.93792 29.0249,-207.93792 0,0 -7.587,46.51574 2.906,-3.96946' id='path1490' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 197.88685,657.78481 c 0,0 -14.0261,74.2259 -15.2146,116.81909 -1.8259,51.66393 -4.0509,66.27638 -3.2281,96.39607 0.5409,2.06343 -5.0423,38.91191 -6.6861,54.93166 -1.1717,8.25745 1.2025,2.11524 -0.167,2.7335 -10.5511,6.45437 -17.7264,1.26458 -24.1578,-3.82637 -1.9085,-1.44518 17.052,-46.09027 17.6109,-55.23019 10.0124,-131.10744 28.942,-207.94175 28.942,-207.94175 0,0 -7.587,46.51547 2.9062,-3.96932 l 0,0 -0.005,0.0873 z m -6.0728,211.03022 c 0,0 -11.13,5.04722 -12.3699,2.18494 m -0.481,-15.28238 c 0,0 9.5053,-0.25255 11.0003,-2.92615 m -0.5504,-12.78579 c 0,0 -7.0222,4.57419 -8.9239,1.66023 m 8.7437,-20.50279 -6.7602,0.28819 m 7.2091,-18.51076 -7.4252,0.25852 m 6.2629,-26.18363 c 0,0 -4.1932,1.87264 -4.6914,-0.89053 m 6.0118,-20.7132 -6.061,-0.27255 m -5.7926,116.5627 c 0,0 -10.9158,1.54853 -12.1186,-1.9259 m 12.9911,-23.22806 c 0,0 -10.8756,0.89279 -11.3309,-2.57038 m 11.7723,-15.56487 c 0,0 -8.8395,0.28262 -9.4633,-0.42506 m 11.1993,-17.05976 -8.8005,-0.39525 m 8.7511,-20.59035 -6.0194,-0.95004 m 8.4543,-17.09539 c 0,0 -5.4801,1.13514 -6.6411,-1.65785 m 7.2602,-19.38553 c 0,0 -4.9403,3.22043 -4.7306,-0.21253 m -0.5982,109.18796 c 0,0 -10.8277,0.10507 -10.6244,-3.21844' id='path1492' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 323.52465,615.50089 c 0,0 -7.115,61.95075 -7.7941,73.05883 -3.2838,53.72524 -1.7731,94.37861 0.7591,119.68547 -0.1672,2.73336 10.3498,67.00938 6.7283,70.44247 -12.3498,14.09186 -12.7854,15.6571 -25.7993,5.22757 -1.8679,-2.14493 5.6135,-67.96445 6.1667,-77.0173 1.2614,-9.72225 3.2972,-86.61406 4.6797,-120.14287 0.1455,-13.25869 11.5421,-78.52541 11.5421,-78.52541 0,0 1.5166,-13.89868 3.6455,7.0925' id='path2439' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 323.52465,615.50089 c 0,0 -7.115,61.95075 -7.7941,73.05883 -3.2838,53.72524 -1.6902,94.38232 0.7591,119.68547 -0.1672,2.73336 12.5487,92.19951 8.5925,70.52621 -12.3498,14.092 -14.8843,19.40953 -27.8981,8.97999 -1.8673,-2.14506 5.8481,-71.80061 6.4013,-80.85346 1.2614,-9.72225 3.2972,-86.61406 4.6797,-120.14287 0.1455,-13.25869 11.5421,-78.52541 11.5421,-78.52541 0,0 1.5166,-13.89868 3.6455,7.0925 l 0,0 0.072,0.17874 z' id='path2441' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 322.18865,593.77765 c 0,0 -14.0262,74.22616 -15.2976,116.81536 -1.8257,51.6638 -4.0507,66.27638 -3.2282,96.39608 0.5411,2.06357 -5.042,38.91178 -6.6861,54.93192 -1.1716,8.25745 1.2027,2.11498 -0.1669,2.73323 -10.551,6.45438 -17.7264,1.26446 -24.1579,-3.82622 -1.9083,-1.44519 17.0524,-46.09015 17.6058,-55.14288 10.0123,-131.10757 29.0246,-207.93791 29.0246,-207.93791 l 2.9063,-3.96958' id='path2443' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 322.18865,593.77765 c 0,0 -14.0262,74.22616 -15.2147,116.81908 -1.8258,51.66392 -4.0508,66.27638 -3.2279,96.39606 0.5407,2.06357 -5.0425,38.91192 -6.6865,54.93194 -1.1715,8.25731 1.2029,2.1151 -0.1669,2.73322 -10.5509,6.45465 -17.7262,1.26459 -24.1578,-3.82636 -1.9081,-1.44505 17.0526,-46.09001 17.6109,-55.23031 10.0126,-131.10745 28.9421,-207.94149 28.9421,-207.94149 l 2.9063,-3.96947 0,0 -0.005,0.0873 z m -6.073,211.03034 c 0,0 -11.1296,5.04722 -12.3696,2.1848 m -0.4813,-15.28198 c 0,0 9.5052,-0.25281 11.0002,-2.92641 m -0.5502,-12.78567 c 0,0 -7.022,4.5738 -8.9238,1.65997 m 8.7434,-20.50264 -6.76,0.28805 m 7.209,-18.51076 -7.425,0.25838 m 6.2627,-26.18349 c 0,0 -4.1933,1.87251 -4.6911,-0.89053 m 6.0117,-20.7132 -6.0608,-0.27242 m -5.7928,116.5627 c 0,0 -10.916,1.5488 -12.1186,-1.92591 m 12.991,-23.22831 c 0,0 -10.8758,0.89292 -11.331,-2.57012 m 11.7727,-15.56487 c 0,0 -8.8396,0.28262 -9.4635,-0.4252 m 11.1991,-17.05948 -8.8002,-0.39551 m 8.7509,-20.59023 -6.0195,-0.95017 m 8.4546,-17.09539 c 0,0 -5.4801,1.13514 -6.6412,-1.65798 m 7.2604,-19.38526 c 0,0 -4.9407,3.22029 -4.731,-0.21254 m -0.598,109.18796 c 0,0 -10.8279,0.10521 -10.6247,-3.21871' id='path2445' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(7.4567489,0.3350755,-0.3907918,6.3936151,-2152.8789,-980.23756)' id='g2487' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 356.46575,216.69181 c 0,0 1.2597,9.7299 1.09155,15.27315 -0.17955,6.726 0,8.63835 -0.36765,12.54855 -0.0769,0.26505 0.36765,5.08725 0.4446,7.17915 0.0798,1.08015 -0.1767,0.2679 0,0.35625 1.35945,0.9006 2.3598,0.2679 3.26325,-0.35625 0.35625,-0.1767 -1.9038,-6.09045 -1.9038,-7.27035 -0.2679,-17.1 -2.1831,-27.19755 -2.1831,-27.19755 l -0.35625,-0.53295' id='path212' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.46575,216.69181 c 0,0 1.26825,9.7299 1.08015,15.27315 -0.1767,6.726 0,8.63835 -0.36765,12.54855 -0.077,0.26505 0.36765,5.08725 0.4446,7.17915 0.0798,1.08015 -0.1767,0.2679 0,0.35625 1.35945,0.9006 2.3598,0.2679 3.26325,-0.35625 0.35625,-0.1767 -1.9038,-6.09045 -1.9038,-7.28175 -0.2679,-17.1 -2.1717,-27.19755 -2.1717,-27.19755 l -0.35625,-0.53295 0,0 z' id='path214' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.37775,244.61326 c 0,0 1.4478,0.26505 1.63875,-0.17955' id='path2469' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,241.33861 c 0,0 1.4478,0.17955 1.4478,-0.2679' id='path2467' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,238.97881 c 0,0 1.1685,0.0883 1.26825,0' id='path2465' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.46895,236.69596 1.1799,0' id='path2463' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.64565,233.96851 0.81225,-0.0884' id='path2461' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,231.60871 c 0,0 0.62415,0.17955 0.81225,-0.1767' id='path2459' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,228.86986 c 0,0 0.62415,0.44745 0.62415,0' id='path2457' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.37775,243.06571 c 0,0 1.4478,0.077 1.4478,-0.35625' id='path2455' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 806.66725,651.2808 9.7153,0.72149 c 0,0 -15.0236,-1.09434 -9.7153,-0.72149 z' id='path3079' style='fill:%23005000;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 937.21825,1074.8468 c 0,0 -4.5288,-1.9413 -5.661,0 0,0.9709 1.1322,1.9416 2.2645,1.9416 1.1319,0 3.3965,-1.9416 3.3965,-1.9416 z' id='path4435' style='fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 924.76395,1088.4376 c 0,0 19.2475,-1.9416 26.0405,-1.9416' id='path2941' style='fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='translate(45.160387,-17.433837)' id='g37871' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-0.9773238,0.02796767,0.0271617,1.0063241,4636.2403,-91.417631)' id='g4081' style='stroke:%23000000;stroke-width:1.51194298;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-8.5612132,0,0,7.1058458,6939.2223,-1935.3371)' id='g4083' style='stroke:%23000000;stroke-width:0.19384736;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(2.698228,0.188676,-0.188676,2.698228,-83.95137,198.3774)' id='g4085' style='stroke:%23000000;stroke-width:0.07166747;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 156.89937,89.492537 c -0.0326,1.927576 -3.76381,4.277709 -6.81891,0.32337 -3.19349,-2.72162 -2.73384,-7.079109 -0.32947,-7.767359 L 177.5685,47.471874 c 1.14367,-0.795862 1.2235,-1.517334 1.77636,-2.271883 1.30518,1.486191 3.98739,4.142158 5.44264,5.419584 -0.80859,0.859605 -1.46049,1.669663 -1.61792,2.323361 l -26.27021,36.549601 z' id='path4087' style='fill:%23e8a30e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.07166747;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(4.31408,0.22609,-0.22609,4.31408,-96.979953,-495.72462)' id='g4089' style='stroke:%23000000;stroke-width:0.04487207;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 123.24464,190.48427 c 0.83741,-1.42667 4.36995,2.17219 3.48803,3.32673 -0.88193,1.15455 -4.25579,-1.888 -3.48803,-3.32673 z' id='path4091' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.04487207;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 126.41817,193.54356 c -0.62839,0.58457 -3.18339,-1.82708 -2.7996,-2.76435 0.65951,-0.88378 3.48273,2.18618 2.7996,2.76435 z' id='path4093' style='fill:%23cccccf;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.04487207;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cpath d='m 3513.1548,736.63692 c 56.5472,-19.2548 95.9439,-57.2317 120,-113.0372' id='path4097' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 3934.4833,1159.2881 c 71.1276,-23.5221 118.9952,-70.3041 139.0601,-144.8889' id='path4101' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 3964.4603,1190.9305 c 71.1276,-23.5221 118.9952,-70.3041 139.0601,-144.8889' id='path4103' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4138.4935,1357.4694 c 71.1276,-23.5221 127.3222,-76.133 147.3871,-150.7178' id='path4105' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4169.3032,1389.1118 c 71.1276,-23.5221 128.1549,-76.9657 148.2198,-151.5505' id='path4107' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4338.3403,1405.7658 c 4.0114,16.3412 13.4191,21.2161 26.2299,15.8212' id='path4109' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4192.5889,1403.1357 c 28.071,40.3961 57.6604,27.1803 82.7184,26.9003' id='path4111' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4375.2216,1406.928 c 0.3123,10.999 -9.0146,20.1579 -20.8509,20.4757 -11.8364,0.3178 -21.7168,-8.3254 -22.0886,-19.3228 -0.3718,-10.9974 8.9053,-20.1998 20.7398,-20.573 11.8345,-0.3731 21.7616,11.5546 22.1929,22.5501' id='path4113' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.51194298;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0' /%3E %3Cpath d='m 4336.2403,1403.8367 c 4.0114,16.3412 13.4191,21.2161 26.2299,15.8212' id='path4127' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4192.5889,1403.1357 c 28.071,40.3961 57.6604,27.1803 82.7184,26.9003' id='path4129' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(-1,0,0,1,1952.1115,3.7236016)' id='g46565' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg id='g46567' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 832.93795,1488.201 -11.24,110.162 c 0,0 17.0485,-20.8667 21.1467,-27.8 4.0981,-6.9332 18.8753,-25.4762 22.0361,-89.6894 0,0 -11.53978,-35.5079 -16.97298,-35.431 -9.0396,-4.4557 -14.96982,42.7584 -14.96982,42.7584 z m 27.0937,-245.5984 c 0,0 -29.5764,176.8817 -32.574,192.9662 0,5.5012 15.0112,20.0886 25.8539,-14.1163 l 17.8677,-128.5896 c 0,0 -8.0328,-34.2624 -11.1476,-50.2603 z' id='path46569' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 926.89285,1418.1194 c -7.2129,-9.0648 -16.2292,-20.3957 -17.1191,-24.9668 l -4.66,39.0254 c 0,0 24.6127,17.9855 21.1005,52.4112 l 4.7774,-6.9427 2.7632,-13.7895 c 0,0 5.0582,-22.9889 5.105,-36.7399 0,0 -5.199,-2.2182 -11.967,-8.9977 l 0,0 z' id='path46571' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 821.69965,1598.345 c 0,0 40.8651,-34.9544 43.1829,-117.4894 l 5.0584,-22.989 c 0,0 0.843,18.322 9.0395,4.4556 7.9856,-18.4468 7.5875,-34.4834 7.5875,-34.4834 0,0 14.777,-18.5426 19.2266,4.3114 0,0 -13.7222,107.9056 -14.6592,117.0859 -1.1708,11.4751 -3.2551,25.2548 -3.2551,25.2548 0,0 -8.1029,-13.6355 -16.2992,0.2309 -8.8755,13.8759 -22.9735,32.4092 -49.8814,23.6232 l 0,0 z m 49.4814,-305.5003 -17.8674,128.5896 c 0,0 14.2384,6.6738 16.6273,36.4323 1.3115,13.732 6.7681,6.7795 9.0395,4.4556 2.9742,-9.2091 0.7727,-27.5115 0.7727,-27.5115 l 7.7745,-89.4877 c 0,0 -15.4801,-41.0319 -16.3466,-52.4783 z' id='path46573' style='fill:%23ffe000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 857.03095,1590.9877 -2.599,32.1211 c 0,0 12.2244,-0.173 20.4208,-14.0394 9.5546,-13.8854 13.0204,-34.5601 13.0204,-34.5601 0,0 -9.461,-13.6166 -16.2994,0.2307 -6.6036,11.5519 -14.5428,16.2477 -14.5428,16.2477 z m 21.9423,-128.6473 c 6.604,-11.552 8.7116,-32.2075 7.5875,-34.4833 l -8.30828,6.9717 c 2.6698,13.7125 0.72078,27.5116 0.72078,27.5116 z' id='path46575' style='fill:%23ffe000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 919.21895,1449.3875 c -5.6205,-11.3792 -15.1052,-18.1203 -15.1052,-18.1203 l -18.1483,144.6357 c 0,0 -5.1049,36.7401 -27.7741,46.2277 0,0 12.9278,125.8624 53.7931,90.908 5.9014,-4.6669 13.278,-43.7307 10.8656,-66.614 -2.8571,-25.1685 -9.5318,-59.4499 -10.1639,-73.1915 -0.3984,-16.0364 1.86839,-32.2787 5.80269,-57.5436 1.6157,-9.1897 6.37226,-29.3331 7.28556,-31.6376 2.2715,-2.3241 -0.48985,-21 -6.55545,-34.6644 z' id='path46577' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 938.86685,1427.1532 c 0,0 11.0535,11.3021 13.0909,11.2734 2.7165,-0.039 -28.68334,235.8639 -28.68334,235.8639 0,0 1.18164,-24.728 -7.98364,-72.7565 -7.44564,-39.0171 2.16252,-91.4007 10.55711,-116.5352 0,0 9.90457,-7.3836 13.01897,-57.8456 z' id='path46579' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 886.60875,1347.682 c 0,0 -6.112,66.5468 -7.5403,87.1924 0,0 20.7017,-30.0854 26.0414,-2.6602 l 4.6601,-39.0252 c 0,0 -18.009,-29.5375 -23.1612,-45.507 z' id='path46581' style='fill:%23f7e214;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 870.75092,1457.6637 c 0,0 -6.79596,-74.5342 -42.89881,-21.8408 -1.39974,0.019 -3.31572,29.6128 -1.24048,36.699 1.1346,9.4709 11.12548,21.1882 15.30079,28.2443 7.89114,11.7471 16.3378,-2.6038 16.3378,-2.6038 0,0 8.20512,-11.9759 12.5007,-40.4987 z' id='path46583' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(1,-0.04702074,0,1,-2.2402185,26.33245)' id='g46585' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 586.92745,838.90947 c -1.3302,-42.47871 -14.6773,-113.66915 -15.3412,-162.07779 L 425.25675,520.83687 c 0,0 -18.0611,119.96174 -71.1929,186.53571 l 232.8636,131.60989' id='path46587' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 597.49388,844.43331 c 6.1621,-29.21459 13.5591,-62.06604 18.4676,-123.54139 l -94.2,-97.24502 c 0.3762,38.74522 -43.4931,96.60853 -46.4621,168.83923' id='path46589' style='fill:%23ffe000;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 678.72756,937.60442 c 10.8066,-51.25367 -15.68378,-58.91622 23.71972,-129.89659 l -87.04676,-87.55809 c -16.2197,48.31751 -27.1401,79.39667 -25.727,121.87536 l 74.1618,56.26539' id='path46591' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg id='g46593' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 337.90285,1241.5978 c -17.6248,-52.3867 6.303,-155.1608 3.6429,-221.0135 -1.9939,-42.48061 29.2436,-202.21617 28.5773,-250.53379 l -172.034,-107.44557 c 0,0 -7.4912,174.58162 -27.291,364.74936 -17.8157,97.674 -17.6979,186.9273 -4.8973,261.4838 18.2887,105.9774 36.2532,149.485 79.064,194.3175 75.9792,78.6255 239.5863,33.1999 239.5863,33.1999 137.8261,-28.5197 217.2142,-115.3382 217.2142,-115.3382 0,0 -44.827,10.5911 -117.4598,17.9733 -159.1864,-11.1519 -221.8825,28.632 -226.8347,-134.7009' id='path46595' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 798.94255,1347.4263 2.6601,-1.1496 c -29.8384,11.1657 -71.4524,23.4993 -71.4524,23.4993 l -96.991,7.4644 c -210.3899,4.9187 -184.0526,-125.3492 -175.7093,-335.5212 1.9963,-79.75702 17.8065,-180.20483 13.7334,-215.76778 l -141.0351,-80.79199 c -46.0025,129.96648 -31.665,220.89093 -40.8713,287.38017 -4.8068,71.6185 -20.0806,211.4811 3.1445,272.5093 32.8707,141.978 144.0394,136.1933 294.5239,123.7084 74.6517,-6.1936 114.8199,-25.3861 114.8199,-25.3861 l 97.0942,-55.8717' id='path46597' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 801.68565,1344.58 c -29.1784,15.1082 -72.1124,26.2555 -72.1124,26.2555 l -98.3108,9.7098 c -152.5209,12.9399 -241.8084,-94.194 -222.2648,-336.4513 0.1293,-85.58426 2.8724,-123.59981 32.4009,-237.61027 l 83.8245,49.18311 0,7.89215 c -4.7369,25.58935 -16.7308,85.43176 -16.7308,112.80179 0,194.50942 122.9863,343.91002 290.5333,369.27752 l 2.6601,-1.1315' id='path46599' style='fill:%23007a3d;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 244.89215,759.75096 c 14.2136,23.88513 99.0882,153.17293 146.638,177.62185' id='path46601' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 259.18875,844.21546 c 14.2158,24.45064 118.126,170.06404 164.927,178.26054' id='path46603' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 235.41365,1066.7355 c 23.7751,28.5197 47.4673,85.0303 118.1261,121.6699' id='path46605' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 268.66505,1228.6032 c 47.4671,44.2666 164.927,141.5588 278.3158,145.5548' id='path46607' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 268.66505,1301.4444 c 23.7751,28.5198 75.3153,161.8858 292.6123,101.3612' id='path46609' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 235.41365,1325.8951 c 14.2155,32.005 122.8652,210.2765 316.3874,141.4861' id='path46611' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg id='g46613' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 462.20445,1177.5906 c -17.6248,-52.3867 6.3032,-155.1608 3.6429,-221.01339 -1.9939,-42.48042 18.0434,-189.41138 17.377,-237.72899 L 322.39065,598.59776 c 0,0 -7.4908,174.58176 -27.2907,364.74945 -17.816,97.67399 -31.39661,217.31349 -18.1964,291.80029 21.603,121.9025 80.21406,156.1875 90.7984,165.6172 82.16457,73.2014 267.63002,66.0029 286.0569,59.4174 132.53569,-47.3661 190.2705,-131.5745 190.2705,-131.5745 0,0 -62.7893,-1.0062 -135.422,6.3756 -159.1867,-11.1515 -239.5838,-4.5105 -244.5361,-167.8436' id='path46615' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 923.24415,1283.4194 2.6602,-1.1497 c -29.8384,11.1654 -71.4525,23.4993 -71.4525,23.4993 l -96.9909,7.4644 c -210.3899,4.9186 -184.0524,-125.3492 -175.7091,-335.52124 1.9961,-79.75689 4.7392,-151.39372 0.666,-186.95707 l -126.101,-91.99612 c -46.0026,129.96661 -33.5317,203.28436 -42.7381,269.77366 -4.8068,71.61847 -20.0805,211.48107 3.1446,272.50907 32.8706,141.9782 144.0391,136.1933 294.5239,123.7084 74.6518,-6.1933 114.8198,-25.386 114.8198,-25.386 l 97.0943,-55.8717' id='path46617' style='fill:%23ffe000;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 926.98335,1281.5197 c -29.1782,15.1085 -72.1119,26.2559 -72.1119,26.2559 l -98.3111,9.7097 c -152.5208,12.9399 -241.8086,-94.1942 -222.2649,-336.4512 0.1293,-85.58451 -2.7276,-91.5877 26.8005,-205.59846 46.7189,30.27386 136.015,106.50937 136.015,106.50937 0,0 -24.29385,34.1993 -18.598,82.01037 0,194.50922 78.2636,293.25532 245.8102,318.62282 l 18.3773,-158.8556' id='path46619' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 369.19375,695.74391 c 14.2136,23.885 99.0882,153.17294 146.6383,177.62199' id='path46621' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.49035,780.20842 c 14.2159,24.4509 118.1261,170.06414 164.9269,178.26064' id='path46623' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.71555,1002.7285 c 23.7748,28.5195 47.4669,85.0303 118.1258,121.6696' id='path46625' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.96655,1164.5962 c 47.4674,44.2669 164.9271,141.5586 278.3161,145.5546' id='path46627' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.96655,1237.4373 c 23.7753,28.5199 75.3154,161.8858 292.6126,101.3613' id='path46629' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.71555,1261.8881 c 14.2157,32.005 122.8651,210.2764 316.3872,141.4859' id='path46631' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 199.22285,679.50793 c 0,0 -7.115,61.95089 -7.7941,73.05909 -3.2837,53.72498 -1.7729,94.37835 0.759,119.68548 -0.1671,2.73323 10.3499,67.00898 6.7286,70.44221 -12.3497,14.09212 -12.7856,15.65722 -25.7994,5.22755 -1.8677,-2.14492 5.6134,-67.96457 6.1668,-77.01703 1.2613,-9.72251 3.2972,-86.61407 4.6797,-120.14313 0.1454,-13.25869 11.542,-78.52516 11.542,-78.52516 0,0 1.5164,-13.89893 3.6452,7.09238' id='path46633' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 199.22285,679.50793 c 0,0 -7.115,61.95089 -7.7941,73.05909 -3.2837,53.72498 -1.6899,94.38193 0.759,119.68548 -0.1671,2.73323 12.5488,92.19937 8.5925,70.52608 -12.3495,14.09186 -14.884,19.40952 -27.8978,8.97971 -1.8677,-2.14492 5.8479,-71.8006 6.4013,-80.85306 1.2613,-9.72251 3.2972,-86.61407 4.6797,-120.14313 0.1454,-13.25869 11.542,-78.52516 11.542,-78.52516 0,0 1.5164,-13.89893 3.6452,7.09238 l 0,0 0.0722,0.17861 z' id='path46635' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 197.88685,657.78481 c 0,0 -14.0261,74.2259 -15.2972,116.81525 -1.8264,51.66406 -4.051,66.27651 -3.2284,96.39606 0.5409,2.06344 -5.0422,38.91192 -6.686,54.9318 -1.1718,8.25771 1.2024,2.11524 -0.1673,2.73335 -10.5508,6.45452 -17.7264,1.2646 -24.1576,-3.82635 -1.9086,-1.44519 17.0522,-46.09001 17.6056,-55.14273 10.0124,-131.10758 29.0249,-207.93792 29.0249,-207.93792 0,0 -7.587,46.51574 2.906,-3.96946' id='path46637' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 197.88685,657.78481 c 0,0 -14.0261,74.2259 -15.2146,116.81909 -1.8259,51.66393 -4.0509,66.27638 -3.2281,96.39607 0.5409,2.06343 -5.0423,38.91191 -6.6861,54.93166 -1.1717,8.25745 1.2025,2.11524 -0.167,2.7335 -10.5511,6.45437 -17.7264,1.26458 -24.1578,-3.82637 -1.9085,-1.44518 17.052,-46.09027 17.6109,-55.23019 10.0124,-131.10744 28.942,-207.94175 28.942,-207.94175 0,0 -7.587,46.51547 2.9062,-3.96932 l 0,0 -0.005,0.0873 z m -6.0728,211.03022 c 0,0 -11.13,5.04722 -12.3699,2.18494 m -0.481,-15.28238 c 0,0 9.5053,-0.25255 11.0003,-2.92615 m -0.5504,-12.78579 c 0,0 -7.0222,4.57419 -8.9239,1.66023 m 8.7437,-20.50279 -6.7602,0.28819 m 7.2091,-18.51076 -7.4252,0.25852 m 6.2629,-26.18363 c 0,0 -4.1932,1.87264 -4.6914,-0.89053 m 6.0118,-20.7132 -6.061,-0.27255 m -5.7926,116.5627 c 0,0 -10.9158,1.54853 -12.1186,-1.9259 m 12.9911,-23.22806 c 0,0 -10.8756,0.89279 -11.3309,-2.57038 m 11.7723,-15.56487 c 0,0 -8.8395,0.28262 -9.4633,-0.42506 m 11.1993,-17.05976 -8.8005,-0.39525 m 8.7511,-20.59035 -6.0194,-0.95004 m 8.4543,-17.09539 c 0,0 -5.4801,1.13514 -6.6411,-1.65785 m 7.2602,-19.38553 c 0,0 -4.9403,3.22043 -4.7306,-0.21253 m -0.5982,109.18796 c 0,0 -10.8277,0.10507 -10.6244,-3.21844' id='path46639' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 323.52465,615.50089 c 0,0 -7.115,61.95075 -7.7941,73.05883 -3.2838,53.72524 -1.7731,94.37861 0.7591,119.68547 -0.1672,2.73336 10.3498,67.00938 6.7283,70.44247 -12.3498,14.09186 -12.7854,15.6571 -25.7993,5.22757 -1.8679,-2.14493 5.6135,-67.96445 6.1667,-77.0173 1.2614,-9.72225 3.2972,-86.61406 4.6797,-120.14287 0.1455,-13.25869 11.5421,-78.52541 11.5421,-78.52541 0,0 1.5166,-13.89868 3.6455,7.0925' id='path46641' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 323.52465,615.50089 c 0,0 -7.115,61.95075 -7.7941,73.05883 -3.2838,53.72524 -1.6902,94.38232 0.7591,119.68547 -0.1672,2.73336 12.5487,92.19951 8.5925,70.52621 -12.3498,14.092 -14.8843,19.40953 -27.8981,8.97999 -1.8673,-2.14506 5.8481,-71.80061 6.4013,-80.85346 1.2614,-9.72225 3.2972,-86.61406 4.6797,-120.14287 0.1455,-13.25869 11.5421,-78.52541 11.5421,-78.52541 0,0 1.5166,-13.89868 3.6455,7.0925 l 0,0 0.072,0.17874 z' id='path46643' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 322.18865,593.77765 c 0,0 -14.0262,74.22616 -15.2976,116.81536 -1.8257,51.6638 -4.0507,66.27638 -3.2282,96.39608 0.5411,2.06357 -5.042,38.91178 -6.6861,54.93192 -1.1716,8.25745 1.2027,2.11498 -0.1669,2.73323 -10.551,6.45438 -17.7264,1.26446 -24.1579,-3.82622 -1.9083,-1.44519 17.0524,-46.09015 17.6058,-55.14288 10.0123,-131.10757 29.0246,-207.93791 29.0246,-207.93791 l 2.9063,-3.96958' id='path46645' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 322.18865,593.77765 c 0,0 -14.0262,74.22616 -15.2147,116.81908 -1.8258,51.66392 -4.0508,66.27638 -3.2279,96.39606 0.5407,2.06357 -5.0425,38.91192 -6.6865,54.93194 -1.1715,8.25731 1.2029,2.1151 -0.1669,2.73322 -10.5509,6.45465 -17.7262,1.26459 -24.1578,-3.82636 -1.9081,-1.44505 17.0526,-46.09001 17.6109,-55.23031 10.0126,-131.10745 28.9421,-207.94149 28.9421,-207.94149 l 2.9063,-3.96947 0,0 -0.005,0.0873 z m -6.073,211.03034 c 0,0 -11.1296,5.04722 -12.3696,2.1848 m -0.4813,-15.28198 c 0,0 9.5052,-0.25281 11.0002,-2.92641 m -0.5502,-12.78567 c 0,0 -7.022,4.5738 -8.9238,1.65997 m 8.7434,-20.50264 -6.76,0.28805 m 7.209,-18.51076 -7.425,0.25838 m 6.2627,-26.18349 c 0,0 -4.1933,1.87251 -4.6911,-0.89053 m 6.0117,-20.7132 -6.0608,-0.27242 m -5.7928,116.5627 c 0,0 -10.916,1.5488 -12.1186,-1.92591 m 12.991,-23.22831 c 0,0 -10.8758,0.89292 -11.331,-2.57012 m 11.7727,-15.56487 c 0,0 -8.8396,0.28262 -9.4635,-0.4252 m 11.1991,-17.05948 -8.8002,-0.39551 m 8.7509,-20.59023 -6.0195,-0.95017 m 8.4546,-17.09539 c 0,0 -5.4801,1.13514 -6.6412,-1.65798 m 7.2604,-19.38526 c 0,0 -4.9407,3.22029 -4.731,-0.21254 m -0.598,109.18796 c 0,0 -10.8279,0.10521 -10.6247,-3.21871' id='path46647' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(7.4567489,0.3350755,-0.3907918,6.3936151,-2152.8789,-980.23756)' id='g46649' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 356.46575,216.69181 c 0,0 1.2597,9.7299 1.09155,15.27315 -0.17955,6.726 0,8.63835 -0.36765,12.54855 -0.0769,0.26505 0.36765,5.08725 0.4446,7.17915 0.0798,1.08015 -0.1767,0.2679 0,0.35625 1.35945,0.9006 2.3598,0.2679 3.26325,-0.35625 0.35625,-0.1767 -1.9038,-6.09045 -1.9038,-7.27035 -0.2679,-17.1 -2.1831,-27.19755 -2.1831,-27.19755 l -0.35625,-0.53295' id='path46651' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.46575,216.69181 c 0,0 1.26825,9.7299 1.08015,15.27315 -0.1767,6.726 0,8.63835 -0.36765,12.54855 -0.077,0.26505 0.36765,5.08725 0.4446,7.17915 0.0798,1.08015 -0.1767,0.2679 0,0.35625 1.35945,0.9006 2.3598,0.2679 3.26325,-0.35625 0.35625,-0.1767 -1.9038,-6.09045 -1.9038,-7.28175 -0.2679,-17.1 -2.1717,-27.19755 -2.1717,-27.19755 l -0.35625,-0.53295 0,0 z' id='path46653' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.37775,244.61326 c 0,0 1.4478,0.26505 1.63875,-0.17955' id='path46655' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,241.33861 c 0,0 1.4478,0.17955 1.4478,-0.2679' id='path46657' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,238.97881 c 0,0 1.1685,0.0883 1.26825,0' id='path46659' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.46895,236.69596 1.1799,0' id='path46661' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.64565,233.96851 0.81225,-0.0884' id='path46663' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,231.60871 c 0,0 0.62415,0.17955 0.81225,-0.1767' id='path46665' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,228.86986 c 0,0 0.62415,0.44745 0.62415,0' id='path46667' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.37775,243.06571 c 0,0 1.4478,0.077 1.4478,-0.35625' id='path46669' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 806.66725,651.2808 9.7153,0.72149 c 0,0 -15.0236,-1.09434 -9.7153,-0.72149 z' id='path46671' style='fill:%23005000;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 937.21825,1074.8468 c 0,0 -4.5288,-1.9413 -5.661,0 0,0.9709 1.1322,1.9416 2.2645,1.9416 1.1319,0 3.3965,-1.9416 3.3965,-1.9416 z' id='path46673' style='fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 924.76395,1088.4376 c 0,0 19.2475,-1.9416 26.0405,-1.9416' id='path46675' style='fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.99723987,-0.07424718,0.07424718,0.99723987,-33.971314,39.538796)' id='g46878' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 621.71166,588.00003 c 1.55124,-25.53783 26.6974,-38.51833 30.57352,-40.73782 12.386,-7.09211 20.9226,-13.39856 46.59511,-14.82978 0,0 1.34883,5.39291 0.91767,9.90624 -0.4249,4.52124 -7.12657,19.73971 -27.64814,31.49049 -20.90475,11.97003 -50.43816,14.17087 -50.43816,14.17087 z' id='path3865' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 622.15665,578.25035 325.46028,494.50865 18.37956,-15.5902 -332.1678,-502.41998 -11.67204,23.50153 z' id='path4013' style='fill:%23a05a2c;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(0.99901905,-0.0442824,0.0442824,0.99901905,-36.518183,37.578281)' id='g46862' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 639.39145,477.70486 c 0,0 39.2902,0.59415 36.8077,-22.20147 -2.8749,-22.59323 -29.0661,-25.29076 -39.8614,-27.61258 -11.1856,-2.09816 -47.7692,1.93173 -59.5934,11.26176 -12.2107,9.54028 -36.7132,25.40194 -33.1996,57.38094 3.5195,31.98736 10.1271,54.49984 19.2649,75.25145 8.9867,21.29819 3.8469,40.1481 -0.192,48.24779 -1.3531,3.47731 -6.3395,14.8341 2.8712,20.28391 13.5751,7.81261 17.1477,8.28336 31.1751,-4.03531 14.2785,-11.979 33.8714,-31.79907 36.5462,-57.25154 2.6806,-25.44409 28.3769,-37.29832 32.3475,-39.34399 12.6879,-6.53667 21.4954,-12.45891 47.2061,-12.75189 0,0 -7.2349,-15.71335 -20.8087,-16.59231 -13.8095,-1.21547 -39.6849,-16.58216 -52.5636,-32.63676 z' id='path3859' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 639.39145,477.70486 c 0,0 39.2902,0.59415 36.8077,-22.20147 -2.8749,-22.59323 -29.0661,-25.29076 -39.8614,-27.61258 -11.1856,-2.09816 -47.7692,1.93173 -59.5934,11.26176 -12.2107,9.54028 -36.7132,25.40194 -33.1996,57.38094 3.5195,31.98736 10.1271,54.49984 19.2649,75.25145 8.9867,21.29819 3.8469,40.1481 -0.192,48.24779 -1.3531,3.47731 -6.3395,14.8341 2.8712,20.28391 13.5751,7.81261 17.1477,8.28336 31.1751,-4.03531 14.2785,-11.979 33.8714,-31.79907 36.5462,-57.25154 2.6806,-25.44409 28.3769,-37.29832 32.3475,-39.34399 12.6879,-6.53667 21.4954,-12.45891 47.2061,-12.75189 0,0 -7.2349,-15.71335 -20.8087,-16.59231 -13.8095,-1.21547 -39.6849,-16.58216 -52.5636,-32.63676 z' id='path3861' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 639.39145,477.70486 c -5.2361,-0.54057 -19.9223,-9.17678 -31.1102,-6.6509 -10.9523,2.86209 -34.1151,12.94196 -32.8263,31.72934' id='path3867' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 701.95405,515.37377 c 0,0 -23.4775,6.54593 -40.5287,15.33036 -7.1474,3.68245 -31.4899,21.31532 -47.3509,34.12098 -13.9614,10.8889 -18.7124,27.22742 -47.6668,42.14454' id='path13300' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 688.23155,510.41745 c -5.088,3.5369 -10.1603,7.07704 -18.5699,10.48286 -8.0017,3.20658 -11.1807,9.4673 -16.5704,14.09765' id='path3875' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(-1,0,0,1,1904.8396,-17.433837)' id='g46509' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-0.9773238,0.02796767,0.0271617,1.0063241,4636.2403,-91.417631)' id='g46511' style='stroke:%23000000;stroke-width:1.51194298;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-8.5612132,0,0,7.1058458,6939.2223,-1935.3371)' id='g46513' style='stroke:%23000000;stroke-width:0.19384736;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(2.698228,0.188676,-0.188676,2.698228,-83.95137,198.3774)' id='g46515' style='stroke:%23000000;stroke-width:0.07166747;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 156.89937,89.492537 c -0.0326,1.927576 -3.76381,4.277709 -6.81891,0.32337 -3.19349,-2.72162 -2.73384,-7.079109 -0.32947,-7.767359 L 177.5685,47.471874 c 1.14367,-0.795862 1.2235,-1.517334 1.77636,-2.271883 1.30518,1.486191 3.98739,4.142158 5.44264,5.419584 -0.80859,0.859605 -1.46049,1.669663 -1.61792,2.323361 l -26.27021,36.549601 z' id='path46517' style='fill:%23e8a30e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.07166747;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(4.31408,0.22609,-0.22609,4.31408,-96.979953,-495.72462)' id='g46519' style='stroke:%23000000;stroke-width:0.04487207;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 123.24464,190.48427 c 0.83741,-1.42667 4.36995,2.17219 3.48803,3.32673 -0.88193,1.15455 -4.25579,-1.888 -3.48803,-3.32673 z' id='path46521' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.04487207;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 126.41817,193.54356 c -0.62839,0.58457 -3.18339,-1.82708 -2.7996,-2.76435 0.65951,-0.88378 3.48273,2.18618 2.7996,2.76435 z' id='path46523' style='fill:%23cccccf;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.04487207;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cpath d='m 3513.1548,736.63692 c 56.5472,-19.2548 95.9439,-57.2317 120,-113.0372' id='path46525' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 3934.4833,1159.2881 c 71.1276,-23.5221 118.9952,-70.3041 139.0601,-144.8889' id='path46527' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 3964.4603,1190.9305 c 71.1276,-23.5221 118.9952,-70.3041 139.0601,-144.8889' id='path46529' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4138.4935,1357.4694 c 71.1276,-23.5221 127.3222,-76.133 147.3871,-150.7178' id='path46531' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4169.3032,1389.1118 c 71.1276,-23.5221 128.1549,-76.9657 148.2198,-151.5505' id='path46533' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4338.3403,1405.7658 c 4.0114,16.3412 13.4191,21.2161 26.2299,15.8212' id='path46535' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4192.5889,1403.1357 c 28.071,40.3961 57.6604,27.1803 82.7184,26.9003' id='path46537' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4375.2216,1406.928 c 0.3123,10.999 -9.0146,20.1579 -20.8509,20.4757 -11.8364,0.3178 -21.7168,-8.3254 -22.0886,-19.3228 -0.3718,-10.9974 8.9053,-20.1998 20.7398,-20.573 11.8345,-0.3731 21.7616,11.5546 22.1929,22.5501' id='path46539' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.51194298;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0' /%3E %3Cpath d='m 4336.2403,1403.8367 c 4.0114,16.3412 13.4191,21.2161 26.2299,15.8212' id='path46541' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4192.5889,1403.1357 c 28.071,40.3961 57.6604,27.1803 82.7184,26.9003' id='path46543' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(-0.75814503,0,0,0.75814503,1187.3206,-301.79642)' id='g14289-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.97851324;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline'%3E %3Cg transform='matrix(0.9146189,0,0,0.9146189,7.9399242,38.377158)' id='g8637-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -47.847628,478.55214 c -31.189887,49.90467 -77.451952,139.94721 -90.080292,208.92023 -23.29528,127.234 13.1162,268.29966 123.956446,367.98143 90.307556,81.2159 232.039924,106.3136 291.220764,118.4577 59.0305,12.1134 101.74626,31.1032 111.50717,44.1483 0.49248,-9.1885 1.83275,-18.3768 -8.0111,-27.5652 -28.03886,-12.3568 -73.53237,-19.67 -136.95616,-32.7412 -127.44783,-26.266 -261.343435,-74.0477 -334.288819,-213.12114 -95.118921,-181.34822 -38.443081,-323.87293 43.94928,-465.34228 0,0 -1.297289,-0.73784 -1.297289,-0.73784 z' id='path30956-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.9505055,0.9172151,0.88825,0.8453266,-371.8457,472.97883)' id='path30731-5' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052171;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -169.58338,995.64452 c 18.95531,11.26108 37.7394,14.19488 52.7909,19.22078 11.63262,3.8845 31.653462,10.1918 38.545829,12.7876 6.598221,2.485 16.876215,7.1209 25.674547,11.1017 13.945413,6.3095 29.037461,23.8214 29.037461,23.8214 0,0 -21.21744,22.2597 -46.558275,19.1076 -19.870286,-2.4716 -29.887953,-7.9171 -39.855932,-12.7636 -10.36255,-5.0383 -10.12109,-10.76 -25.04645,-21.5174 -16.50364,-11.895 -28.06417,-35.3848 -34.58808,-51.75808 z' id='path30759-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -70.253644,1016.6675 c 6.077317,9.528 20.609513,8.7802 28.91506,7.4854 l 3.755291,4.7526 c -11.406268,0.1637 -26.99614,0.2925 -34.798256,-9.9804 0.192213,-1.5378 1.11311,-2.2662 2.127905,-2.2576 z' id='path30761-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -169.32579,996.50585 c 17.15921,16.71365 49.18745,35.29995 81.321128,49.02895 32.183592,13.7504 69.76834,18.151 87.87877855,18.0381 l 4.78002775,5.0441 c -26.0567653,-2.4248 -60.4166663,-7.1451 -89.5318733,-19.0925 -37.961841,-15.5775 -69.139881,-35.5942 -84.695511,-52.02413 l 0.24745,-0.99452 z' id='path30763-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -127.5252,1076.9144 c 34.223423,-1.2047 53.059733,9.4421 84.857391,16.396 29.721875,6.4999 64.486113,-8.9539 83.72249,19.6434 -77.45679,50.1926 -133.369482,16.4204 -168.579881,-36.0394 z' id='path30906-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -57.861504,1147.2458 c 14.751122,-12.6497 141.48495,-55.5304 161.723764,-7.6042 -30.148575,33.341 -118.391595,40.7863 -161.723764,7.6042 z' id='path30908-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -27.819877,1180.9893 c 13.385645,-2.1172 29.1597964,-5.2224 44.578745,-7.0054 15.487338,-1.7912 21.554942,-4.4712 33.000376,-6.0493 18.727851,-2.5822 40.164795,-28.8655 106.175076,-8.8073 -25.55384,58.8679 -112.758262,71.224 -183.754197,21.862 z' id='path30910-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -56.359348,1148.1963 c 67.519725,13.4805 146.873829,-0.043 178.246488,-18.5353 l 5.00689,3.3269 c -72.335806,30.8267 -142.616313,26.7699 -183.253378,15.2084 z' id='path30914-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -126.45638,1076.907 c 39.764273,26.6671 91.011135,46.548 200.777837,31.8425 l 1.502056,3.8021 c -150.41421,12.9008 -165.298396,-14.6713 -202.279893,-35.6446 z' id='path30916-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -27.319158,1181.4646 c 52.478273,1.8637 82.015969,25.2451 180.318158,-23.1398 8.03209,-3.9534 18.75115,-6.7081 24.96585,-9.6533 l 9.01243,3.3269 c -6.84225,3.054 -17.88709,2.9712 -24.04113,5.6867 -122.751752,54.1642 -119.314808,28.8417 -190.255308,23.7795 z' id='path30920-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='translate(6.2098842,4.5162794)' id='g3317-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(0.6662805,-1.1204105,1.1011974,0.5769506,-468.20416,995.22832)' id='path30890-7' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.68478,1119.673 c 11.32472,2.9164 14.57638,16.3815 15.55623,24.3164 l 5.84855,2.1152 c -2.98071,-10.4519 -7.15086,-24.7113 -19.70599,-28.996 -1.50417,0.5996 -1.98751,1.6408 -1.69879,2.5644 z' id='path30924-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-1.3147397,0.3128712,0.2942269,1.1607992,-105.43462,68.60708)' id='path30729-2' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052171;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -82.512219,964.25771 c 2.461617,-36.66127 20.254378,14.14787 56.195102,-67.76533 10.444589,-23.80448 10.362149,-38.9882 17.4458255,-74.72452 -19.5664995,30.89054 -52.2792025,39.22533 -65.5616105,63.09123 -13.068502,23.4816 -9.733618,61.23931 -8.079317,79.39862 z' id='path30733-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -9.5792876,824.45634 c 0,0 -17.7022104,41.3355 -43.1933824,70.57281 -25.642512,29.41102 -30.447646,65.19583 -30.447646,65.19583' id='path30735-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -27.10234,859.56181 c -22.549021,30.36379 -52.8627,66.34569 -54.286325,104.122 l -3.521401,1.31141 c 5.250217,-49.68294 34.623115,-72.62694 52.740483,-97.6916 l 5.067243,-7.74181 z' id='path30737-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -217.75674,906.45522 c 16.50525,13.57745 33.86029,18.48998 47.44176,25.20458 10.49662,5.18943 19.30761,12.0785 25.49108,15.4588 5.91965,3.23606 15.55442,4.73781 23.36688,9.74577 12.3828,7.93759 36.608678,35.71591 36.608678,35.71591 0,0 -22.967018,18.81832 -37.199848,15.73022 -41.39216,-8.0217 -53.45866,-24.44861 -74.34903,-39.6551 -16.12052,-13.20408 -17.1964,-44.54864 -21.35952,-62.20018 z' id='path30739-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -66.226302,993.83107 3.894481,5.71305 c -23.754121,-2.34136 -61.595049,-25.14088 -86.817089,-37.83684 -33.93621,-17.08237 -52.95258,-30.07418 -67.255,-54.36654 16.19624,24.28331 37.36944,38.06719 69.23438,53.47191 26.75763,12.9357 64.803128,34.81946 80.943228,33.01842 z' id='path30741-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -231.83431,826.16772 c 13.83665,16.04059 30.06081,23.67907 42.24397,32.48522 9.41574,6.80592 16.86637,15.01511 22.3554,19.34298 5.25473,4.14319 14.48098,7.17605 21.28407,13.37052 10.78303,9.81818 26.78494,38.48215 26.78494,38.48215 0,0 -11.47048,12.25334 -24.94419,6.91614 -41.72746,-5.16951 -53.99025,-24.95099 -69.50399,-60.55717 -8.68361,-18.46261 -17.2753,-31.97363 -18.2202,-50.03984 z' id='path30743-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(1.2324921,0.535398,-0.5124945,1.0903238,-15.823411,291.78404)' id='path30745-7' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -98.135231,936.69841 2.815916,6.25779 C -145.33316,920.15434 -210.94381,874.17691 -232.4226,827.34331 c 30.54195,50.51615 80.99616,83.82351 134.287369,109.3551 z' id='path30747-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -243.24309,748.88918 c 11.8865,16.69919 26.6325,25.30604 37.48342,34.78547 8.38619,7.32623 14.81771,15.89758 19.68038,20.52246 4.6552,4.42752 13.13569,8.03408 19.10254,14.58208 9.45732,10.37852 22.47169,39.62658 22.47169,39.62658 0,0 -15.26444,14.36397 -27.58347,8.20491 -12.31903,-6.15908 -28.83697,-20.14295 -37.00805,-27.43618 -8.5079,-7.59392 -10.59796,-25.91472 -20.58773,-39.88601 -11.62298,-16.25552 -13.97554,-32.58611 -13.55878,-50.39931 z' id='path30749-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -207.23421,800.53745 c 24.25936,27.63235 54.1148,53.98137 82.06478,66.02697 l 2.20232,6.33926 c -45.51129,-25.80012 -64.69608,-49.12278 -84.834,-71.48215 l 0.5669,-0.88408 z' id='path30751-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -226.03236,701.30385 c 8.28336,16.21491 20.69819,25.83071 29.278,35.63435 6.63096,7.57682 11.19487,15.94785 14.97326,20.66795 3.61721,4.51867 10.99423,8.88404 15.47629,15.43281 7.10417,10.37977 14.23715,37.64017 14.23715,37.64017 0,0 -10.34873,11.01571 -20.90239,3.87669 -10.55366,-7.13902 -25.66359,-21.71514 -32.09712,-29.23194 -6.69884,-7.82669 -10.08073,-24.76777 -17.05343,-38.34046 -8.11273,-15.79177 -7.45164,-30.29506 -3.91176,-45.67957 z' id='path30753-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -149.23788,682.08309 c 4.40142,9.50931 6.16458,18.83031 9.01243,28.63454 l 1.12657,-7.01011 c -2.34773,-7.67809 -4.22086,-15.75965 -7.88587,-22.81258 -0.75108,-0.1623 -1.50205,-0.20644 -2.25313,1.18815 z' id='path30755-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -201.12606,751.3442 c 18.04476,27.50129 41.60436,54.7069 65.88953,69.23219 l 0.96157,5.81816 c -38.45122,-29.01552 -52.46161,-52.03908 -67.54293,-74.36655 l 0.69183,-0.6838 z' id='path30757-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -102.33872,925.27463 c 2.00679,-8.76547 3.61309,-15.66551 9.369651,-23.54116 0.861646,-0.0567 1.471426,0.2152 1.666451,1.02858 -5.238969,8.49156 -7.448821,15.92559 -8.911812,26.20925 l -2.12429,-3.69667 z' id='path30765-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.7407207,-0.6718913,-0.6626821,0.6478724,343.61021,366.4895)' id='path30727-3' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -109.35883,601.78044 c 6.2605,-5.45846 14.041624,-10.33958 21.941855,-15.17545 0.902218,0.3096 1.000434,0.94628 0.738425,1.72952 -9.079622,5.73908 -17.04172,11.31445 -23.80313,17.68223 l 1.12285,-4.2363 z' id='path30767-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -206.42739,608.03309 c 19.87791,41.93134 67.67965,71.22443 48.50395,132.74407 -49.39268,44.60867 -52.56122,-79.83812 -48.50395,-132.74407 z' id='path30868-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -161.10982,516.28843 c 8.13512,42.85151 46.17604,78.29386 21.24259,135.09651 -70.02989,17.60367 -36.6531,-76.77156 -21.24259,-135.09651 z' id='path30870-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -119.68683,452.10079 c -35.18289,65.43776 -43.64243,103.28516 -2.12419,146.18652 0,0 21.79969,-20.4906 27.005302,-58.19421 4.402862,-31.8894 -21.615792,-70.06957 -24.881112,-87.99231 z' id='path30872-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -61.269626,414.1259 c -9.335807,41.48014 26.569493,60.4945 -24.783075,113.92467 -36.635619,-43.58456 -19.147529,-54.47205 24.783075,-113.92467 z' id='path30874-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -47.461996,486.71506 c 59.186036,6.32012 36.134492,-44.99185 53.0106064,-92.36038 -34.8581094,25.98143 -82.0920564,36.43178 -53.0106064,92.36038 z' id='path30876-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -86.052701,565.01728 c 16.659013,-77.17027 69.752372,-46.98582 99.132099,-80.9907 -15.1971103,49.76495 -37.512543,83.74496 -99.132099,80.9907 z' id='path30878-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -109.93346,636.81438 c 46.250019,-3.04549 83.747196,-25.8231 108.6502792,-76.99245 C -48.718815,580.999 -101.31366,583.14328 -109.93346,636.81438 z' id='path30880-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -116.94322,703.82631 c 18.246011,-20.94913 18.700735,-34.46455 25.645423,-48.43021 11.499161,-23.1247 23.705214,-43.59042 53.464045,-65.1574 -0.215713,54.58238 -7.975664,114.88753 -79.109468,113.58761 z' id='path30882-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -127.45772,760.85776 c 28.391951,-39.55445 54.705,-73.16893 97.635068,-100.75555 -17.814385,38.83921 -9.57882,110.67904 -97.635068,100.75555 z' id='path30884-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -119.44661,839.27598 c 87.127245,-2.4431 78.88873,-84.63975 79.610082,-123.09285 -15.734383,23.53452 -34.978117,43.98941 -49.313681,60.91796 -15.653141,18.48431 -30.735161,39.35151 -30.296401,62.17489 z' id='path30886-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -108.93212,888.22797 c 7.0424,-17.82139 1.63607,-25.02437 17.18979,-40.68001 16.806721,-16.91693 49.046302,-47.19021 65.925229,-81.93757 2.439423,30.71988 2.82718,78.15145 -20.968617,94.01756 -18.00449,12.00479 -33.703239,15.3832 -62.146402,28.60002 z' id='path30894-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -32.826764,1015.5982 c 68.37386,-53.18645 27.2686931,-98.05455 21.529707,-137.82599 -17.372817,44.84619 -66.280621,83.52027 -21.529707,137.82599 z' id='path30896-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -60.865617,502.79051 c 21.97439,-41.23483 35.316675,-63.81894 64.636046,-106.81838 -33.841407,48.91145 -48.446436,79.96628 -67.890518,113.47206' id='path30912-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -33.828303,1028.9055 c -2.786391,-54.15815 11.968648,-100.82358 21.529809,-149.7075 -9.034532,51.61824 -21.861813,103.56377 -17.023439,153.9849 l -4.50637,-4.2774 z' id='path30930-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -115.0012,899.06408 c 7.13248,-33.11525 72.391537,-55.10577 88.68338,-132.02791 -13.361944,76.47976 -79.52041,95.75985 -86.17989,138.80039 l -2.50349,-6.77248 z' id='path30932-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -129.59998,854.02973 1.77019,8.40151 c 9.64963,-51.84823 70.552558,-77.36503 88.156754,-146.52257 -25.727873,74.94091 -75.374464,84.83426 -89.926944,138.12106 z' id='path30934-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -141.63752,776.39964 c 29.97314,-45.7067 71.870836,-62.95541 111.523736,-116.61315 -37.088448,52.71593 -83.851636,77.44676 -112.231836,123.67043 l 0.7081,-7.05728 z' id='path30936-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -140.57533,716.24473 c 32.98559,-14.10742 67.209616,-53.68583 103.026584,-126.02286 -23.492012,53.5239 -53.269622,101.9338 -103.026584,134.08831 l 0,-8.06545 z' id='path30938-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M -125.3515,645.67193 C -86.863733,615.24109 -36.96588,595.03364 -1.0823309,559.30426 -30.900915,593.32089 -88.192356,617.09507 -126.4136,650.71283 l 1.0621,-5.0409 z' id='path30940-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -95.611853,570.05821 c 38.888666,-26.4268 76.360837,-34.6586 108.691251,-84.68736 -25.967186,48.94742 -67.298288,61.34625 -110.107444,88.38403 l 1.416193,-3.69667 z' id='path30942-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -206.42739,609.04129 c 13.93376,54.00433 25.71431,110.76478 62.66568,147.19469 l -0.3541,-7.05728 c -16.89108,-9.45471 -43.58905,-65.72009 -62.31158,-140.13741 z' id='path30944-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -161.46392,518.30482 c 2.53955,55.81503 1.57085,114.84521 30.44775,146.52257 l 2.12429,-6.38514 c -29.4442,-23.84221 -26.99213,-86.93132 -32.57204,-140.13743 z' id='path30946-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -121.81102,454.7893 c -9.87971,49.12027 -10.60207,94.55253 2.47829,168.03049 l 2.83228,-5.37699 c -8.20582,-43.28591 -17.50989,-87.63029 -5.31057,-162.6535 z' id='path30948-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -62.331821,415.80622 c -19.740135,41.66813 -34.849574,83.83857 -21.950689,129.04742 l 3.540482,-5.04091 c -15.292212,-41.3355 2.584236,-82.67101 18.410207,-124.00651 z' id='path30950-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(0.9850754,0.1721232,-0.1721232,0.9850754,184.73266,0.2731797)' id='g3281-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -2.2845182,979.003 c -13.3256908,59.3443 24.0920552,94.2107 64.0886052,111.2114 13.933836,-85.284 -42.775615,-66.0933 -64.0886052,-111.2114 z' id='path30898-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -3.285956,979.003 c 2.0342082,34.912 45.946031,66.7231 67.593537,122.6176 l 6.008225,3.8021 C 40.891792,1037.8008 0.08892556,1016.9272 -3.285956,979.003 z' id='path30918-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.9844485,0.1759721,0.1080895,0.9204363,-25.544871,106.89833)' id='path42835-7' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -115.98395,609.25633 c -0.49694,-8.29106 0.39217,-17.43331 1.38986,-26.64221 0.79628,-0.52516 1.36034,-0.21397 1.82037,0.47195 -1.0031,10.69441 -1.45312,20.40406 -0.54229,29.6472 l -2.66794,-3.47694 z' id='path42837-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.7656157,-0.3802691,-0.1729816,0.7822886,93.850308,250.49401)' id='path42841-5' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.65327358;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -109.46903,598.68249 c 1.90561,-6.79537 5.05421,-13.53086 8.30017,-20.26163 0.72399,0.006 1.04997,0.54848 1.197637,1.33149 -3.656237,7.8985 -6.640017,15.31256 -8.504377,23.07636 l -0.99343,-4.14622 z' id='path42843-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.9998418,-0.02052883,-0.07453799,0.9237588,47.838005,233.93788)' id='path42850-5' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -139.37359,708.80059 c 1.13887,-8.22749 3.8038,-17.01779 6.58829,-25.85215 0.88381,-0.35878 1.37588,0.057 1.69245,0.81982 -3.08115,10.28995 -5.42682,19.72275 -6.34655,28.96501 l -1.93419,-3.93268 z' id='path42852-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.6960369,-0.7458915,-0.622706,0.7192273,287.33872,446.81179)' id='path42856-1' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.20199919;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -138.3051,708.01702 c 5.88284,-6.05964 13.19457,-11.47835 20.61822,-16.84683 0.84779,0.3437 0.94008,1.0505 0.69388,1.92 -8.5319,6.37117 -16.01368,12.56059 -22.36721,19.6297 l 1.05511,-4.70287 z' id='path42858-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.9335968,0.3584719,0.2797353,0.8835352,-109.82582,412.55656)' id='path42862-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -103.9022,922.9561 c -2.05163,-8.04857 -2.90262,-17.19444 -3.65954,-26.42626 0.68295,-0.6659 1.29558,-0.46667 1.87671,0.12018 1.03176,10.69168 2.42096,20.31197 5.05862,29.21747 l -3.27579,-2.91139 z' id='path42864-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(0.7407207,-0.6718913,0.6626821,0.6478724,-554.7183,692.67512)' id='path42868-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -101.74926,927.96606 c -6.2605,-5.45846 -14.04162,-10.33958 -21.94186,-15.17545 -0.90221,0.3096 -1.00043,0.94628 -0.73842,1.72952 9.07962,5.73908 17.04172,11.31445 23.80313,17.68223 l -1.12285,-4.2363 z' id='path42870-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.6610817,0.7503838,0.6574118,0.6532196,-286.71184,567.55437)' id='path42874-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902582;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -44.87854,1017.0645 c -5.54865,-6.1807 -10.542067,-13.8902 -15.491965,-21.71951 0.296487,-0.90662 0.931676,-1.01405 1.718633,-0.76343 5.870112,8.99544 11.560329,16.87594 18.025466,23.54424 l -4.252134,-1.0613 z' id='path42876-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(1.346098,-0.1506978,0.1592309,1.1843181,-310.55669,437.15465)' id='path30888-7' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -43.067457,997.98027 c 4.114009,10.59703 1.17688,14.71893 -1.267363,19.33933 l 2.577407,5.4137 c 3.645326,-6.081 5.018637,-12.8067 1.799414,-25.43483 -1.512299,-0.5812 -2.628422,-0.1663 -3.109458,0.6818 z' id='path30952-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='translate(18.065117,6.2098841)' id='g3321-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 151.75914,1156.682 c 11.68715,0.9958 17.5359,-5.5201 21.35627,-12.639 l 6.25818,-0.057 c -6.6171,8.8202 -13.61752,15.7784 -26.95888,15.6605 -1.19134,-1.0578 -1.26405,-2.1934 -0.65557,-2.9646 z' id='path30954-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(0.2974956,1.2552123,1.2297151,-0.2509299,-488.57474,1103.999)' id='path30892-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 74.400955,1015.695 c -8.843312,54.1723 22.75983,98.1925 70.420865,111.8454 15.5605,-69.8336 -48.821592,-72.3333 -70.420865,-111.8454 z' id='path30900-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cpath d='m 74.313554,1016.13 c 17.496678,42.5043 41.164226,82.0662 83.570426,125.6764 l 9.12108,1.1798 C 119.80735,1105.647 93.896095,1057.1417 74.313554,1016.13 z' id='path30928-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.6093744,1.1080292,1.0046067,0.2495521,-235.48892,857.4059)' id='path42880-2' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.92317355;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cpath d='m 183.60247,1147.4269 c -8.6734,-2.7373 -17.09374,-7.2733 -25.49424,-11.9504 0.10931,-1.0476 0.86884,-1.5209 1.91973,-1.7369 9.87934,5.2672 19.21558,9.5628 29.16892,12.2376 l -5.59441,1.4497 z' transform='matrix(0.9999988,0.00155371,-0.00155371,0.9999988,11.83673,3.536214)' id='path42882-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cg transform='matrix(0.8458764,-0.2850894,0.2850894,0.8458764,-298.28817,241.35557)' id='g3299-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.42342067;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 179.12885,1032.2936 c -5.35793,23.8994 5.80888,50.8055 17.11255,72.6781 11.28705,21.8404 11.10918,28.5467 32.37509,43.5148 40.13,-44.0365 -32.36121,-79.8792 -49.48764,-116.1929 z' id='path30904-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.42342067;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 179.53121,1031.8183 c 9.36265,55.9302 41.83749,92.8226 53.51099,130.8213 l 3.21863,0.7651 c -17.50159,-52.1184 -41.60829,-69.0185 -56.72962,-131.5864 z' id='path30922-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.42342067;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(0.9146189,0,0,0.9146189,47.539065,38.377158)' id='g13596-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 598.31412,478.55214 c 31.1899,49.90467 77.452,139.94721 90.0803,208.92023 23.2953,127.234 -13.1162,268.29966 -123.9564,367.98143 -90.30758,81.2159 -232.03995,106.3136 -291.22079,118.4577 -59.0305,12.1134 -101.74626,31.1032 -111.50717,44.1483 -0.49248,-9.1885 -1.83275,-18.3768 8.0111,-27.5652 28.03886,-12.3568 73.53237,-19.67 136.95616,-32.7412 127.44783,-26.266 261.3434,-74.0477 334.2888,-213.12114 95.1189,-181.34822 38.4431,-323.87293 -43.9493,-465.34228 0,0 1.2973,-0.73784 1.2973,-0.73784 z' id='path8725-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cg transform='matrix(1.3022102,0,0,-1.240275,1150.9941,1861.2105)' id='g12828-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.70215559;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12270-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.70215559;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12272-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.70215559;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.4994531,0.771884,0.6180033,0.2437134,-250.74479,1390.7491)' id='g12848-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.7956059;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12850-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.7956059;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12852-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.7956059;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.6213959,-0.4266944,-0.5367293,0.7014285,531.44896,-179.10295)' id='g12854-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.65293002;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12856-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.65293002;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12858-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.65293002;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.2522786,-0.6942997,-0.5962581,0.2687864,806.00342,-65.264068)' id='g12860-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.11651707;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12862-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.11651707;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12864-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.11651707;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.4725685,-0.4952455,0.4182085,-0.2641216,88.279179,363.06063)' id='g12866-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.75469446;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12868-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.75469446;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12870-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.75469446;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.1226049,-0.8120892,-0.5577693,0.2026637,884.0155,-61.176303)' id='g13368-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.12948585;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13370-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.12948585;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13372-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.12948585;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.01621438,-0.8765958,-0.7728635,0.07245876,1087.9884,9.438215)' id='g13374-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.62585926;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13376-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.62585926;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13378-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.62585926;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.130198,-0.8109065,-0.5929845,0.02341862,1092.8091,122.74526)' id='g13380-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.12948608;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13382-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.12948608;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13384-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.12948608;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.5496038,-0.5215127,0.4968935,-0.4506495,16.09552,492.27995)' id='g13410-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.03860378;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13412-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.03860378;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13414-5' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.03860378;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.5857891,-0.4805111,0.4630936,-0.4853168,30.149938,571.82772)' id='g13416-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.03860402;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13418-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.03860402;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13420-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.03860402;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.6064455,-0.5390597,0.5161558,-0.4996707,3.3922791,589.89562)' id='g13422-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.83734989;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13424-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.83734989;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13426-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.83734989;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.1429591,-0.4898699,-0.4898699,-0.1429591,1056.9161,403.04795)' id='g13386-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:4.23906517;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13388-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:4.23906517;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13390-7' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.4261055;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13392-7' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.4261055;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(-0.419933,-0.2899416,0.2899416,-0.419933,225.65271,697.98936)' id='g13402-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:4.23906517;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13404-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:4.23906517;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13406-4' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.42610538;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13408-9' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.42610538;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.1887179,-0.8344005,-0.6179725,-0.01468413,1156.357,178.29599)' id='g13428-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.00443673;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13430-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.00443673;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13432-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.00443673;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.5949448,-0.6002887,0.5694516,-0.4854556,-6.8818963,592.21485)' id='g13434-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.72397423;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13436-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.72397423;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13438-5' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.72397423;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.6122539,-0.6273173,0.5413064,-0.3350423,6.2234616,537.20671)' id='g13440-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.93102407;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13442-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.93102407;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13444-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.93102407;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.2394166,-0.8562176,-0.8766131,-0.1288541,1342.3992,279.20705)' id='g13446-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.44712496;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13448-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.44712496;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13450-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.44712496;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.5023219,-0.7527747,0.610357,-0.2390198,33.380253,466.14431)' id='g13468-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.84159565;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13470-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.84159565;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13472-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.84159565;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.3791608,-0.8401911,-0.813416,-0.3008227,1392.1158,450.40441)' id='g13474-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.42235351;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13476-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.42235351;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13478-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.42235351;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.2813949,-0.4804287,-0.4804287,-0.2813949,1166.3515,646.91462)' id='g13452-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.88527322;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13454-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.88527322;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13456-5' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.30708289;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13458-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.30708277;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(-0.3673801,-0.418362,0.418362,-0.3673801,206.19155,738.10693)' id='g13460-5' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.88527274;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13462-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.88527274;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13464-6' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.30708265;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13466-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.30708265;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.5626148,-0.8431291,-0.6836172,-0.267709,1422.1156,483.04164)' id='g13480-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.53707433;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13482-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.53707433;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13484-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.53707433;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.4152512,-0.9201646,0.8908409,-0.3294565,-83.402015,470.62188)' id='g13486-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.21182156;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13488-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.21182156;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13490-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.21182156;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.3892046,-0.9406352,0.8210276,-0.2192935,-43.79711,448.95252)' id='g13492-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.33586049;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13494-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.33586049;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13496-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.33586049;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.6388382,-0.9262605,-0.9112106,-0.5389084,1583.5435,641.57676)' id='g13498-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.98443508;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13500-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.98443508;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13502-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.98443508;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.1262906,-0.9454318,0.7314131,0.05409885,105.2893,401.96935)' id='g13520-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.61431813;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13522-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.61431813;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13524-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.61431813;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.9303579,-0.7541605,-0.8080281,-0.7771551,1638.0954,995.52974)' id='g13526-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.8740406;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13528-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.8740406;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13530-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.8740406;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.8418401,-0.7879327,-0.7073185,-0.4638558,1557.7814,750.03765)' id='g13532-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.2219677;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13534-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.2219677;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13536-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.2219677;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.211981,-1.042379,0.9672414,-0.1382921,-51.806391,405.45688)' id='g13538-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.12370801;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13540-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.12370801;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13542-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.12370801;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.5038958,-0.3672631,-0.3672631,-0.5038958,1188.0468,1029.5482)' id='g13504-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.46928096;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13506-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.46928096;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13508-1' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.16713476;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13510-8' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.16713476;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(-0.1899081,-0.5939093,0.5939093,-0.1899081,159.45611,693.43989)' id='g13512-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.46928024;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13514-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.46928024;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13516-3' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.16713452;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13518-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.16713452;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.9819508,-0.4324055,-0.4067155,-0.7955344,1406.7477,1236.6902)' id='g13560-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.21122718;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13562-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.21122718;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13564-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.21122718;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.01944838,-0.8631675,0.6280074,-0.02880219,197.18609,531.98185)' id='g13566-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.93659878;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13568-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.93659878;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13570-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.93659878;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(1.1269885,-0.392778,-0.5430228,-0.8863561,1507.2123,1361.3348)' id='g13572-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.96476924;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13574-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.96476924;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13576-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.96476924;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.3993444,-0.7288053,0.8130674,0.5251965,279.79257,343.94694)' id='g13578-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.41507053;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13580-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.41507053;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13582-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.41507053;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.696387,-0.1776568,-0.1776568,-0.696387,1076.5,1401.2073)' id='g13544-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.00993133;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -596.77336,640.69848 c 0,0 11.04708,-14.32513 28.04496,-9.5109 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -18.62568,1.86414 -24.33861,3.72185 -5.71289,1.8577 -33.15682,21.45883 -33.15682,21.45883' id='path13546-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.00993133;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13548-0' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.01260042;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13550-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.01260042;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.1340534,-0.7060782,0.7060782,0.1340534,173.51639,559.83585)' id='g13552-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.00993133;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -596.77336,640.69848 c 0,0 11.04708,-14.32513 28.04496,-9.5109 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -18.62568,1.86414 -24.33861,3.72185 -5.71289,1.8577 -33.15682,21.45883 -33.15682,21.45883' id='path13554-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.00993133;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13556-7' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.01260054;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13558-8' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.01260042;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(1.2100873,-0.1517841,-0.1629134,-1.1274212,1290.461,1673.4615)' id='g13584-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.83546782;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13586-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.83546782;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13588-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.83546782;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.8253189,0.06338252,0.06338252,-0.8253189,868.37091,1695.9253)' id='g12835-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.61336493;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -596.77336,640.69848 c 0,0 11.04708,-14.32513 28.04496,-9.5109 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -18.62568,1.86414 -24.33861,3.72185 -5.71289,1.8577 -33.15682,21.45883 -33.15682,21.45883' id='path12276-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.61336493;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path12278-8' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.8791877;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path12280-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.87918764;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.5652312,-0.665172,0.8314156,0.6288832,305.03571,356.51042)' id='g13590-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.26953363;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13592-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.26953363;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13594-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.26953363;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.5034646,-0.6570327,0.6570327,0.5034646,285.79297,423.83359)' id='g12840-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.61336493;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -596.77336,640.69848 c 0,0 11.04708,-14.32513 28.04496,-9.5109 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -18.62568,1.86414 -24.33861,3.72185 -5.71289,1.8577 -33.15682,21.45883 -33.15682,21.45883' id='path12842-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.61336493;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path12844-6' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.8791877;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path12846-4' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.8791877;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(1.1428572,0,0,1.1428572,-139.28578,-99.630767)' id='g44719'%3E %3Cpath d='m 593.678,214.479 c 0,0 -8.426,19.153 -5.515,21.053 0,0 8.549,-14.868 16.052,-20.495 3.902,-3.602 6.274,0.031 6.777,-3.136 0.502,-3.167 -10.267,-7.711 -10.267,-7.711 l -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4673-8-4' style='fill:%23452c25' /%3E %3Cpath d='m 593.678,214.479 c 0,0 -8.426,19.153 -5.515,21.053 0,0 8.549,-14.868 16.052,-20.496 3.902,-3.601 6.274,0.032 6.777,-3.135 0.502,-3.168 -10.267,-7.711 -10.267,-7.711 l -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4675-9-6' style='fill:none;stroke:%23000000;stroke-width:0.58499998' /%3E %3Cpath d='m 562.943,229.062 c 0,0 -12.246,20.868 -9.035,21.113 3.211,0.246 16.305,-26.609 16.305,-26.609 l -4.464,0.748 -2.806,4.748 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4677-7-2' style='fill:%23452c25' /%3E %3Cpath d='m 562.943,229.062 c 0,0 -12.246,20.868 -9.035,21.113 3.211,0.246 16.305,-26.609 16.305,-26.609 l -4.464,0.748 -2.806,4.748 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4679-2-6' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 566.642,223.246 c 0,0 -12.8,20.532 -9.598,20.863 3.203,0.332 17.012,-26.163 17.012,-26.163 l -4.482,0.629 -2.932,4.671 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4681-2-1' style='fill:%23452c25' /%3E %3Cpath d='m 566.642,223.246 c 0,0 -12.8,20.532 -9.598,20.863 3.203,0.332 17.012,-26.163 17.012,-26.163 l -4.482,0.629 -2.932,4.671 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4683-0-6' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 569.231,219.674 c 0,0 -14.575,19.312 -11.414,19.928 3.16,0.615 19.27,-24.548 19.27,-24.548 l -4.521,0.228 -3.335,4.392 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4685-8-2' style='fill:%23452c25' /%3E %3Cpath d='m 569.231,219.674 c 0,0 -14.575,19.312 -11.414,19.928 3.16,0.615 19.27,-24.548 19.27,-24.548 l -4.521,0.228 -3.335,4.392 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4687-8-2' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 573.128,216.281 c 0,0 -17.065,17.151 -14.019,18.19 3.047,1.039 22.43,-21.698 22.43,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4689-0-1' style='fill:%23452c25' /%3E %3Cpath d='m 573.128,216.281 c 0,0 -17.065,17.151 -14.019,18.19 3.047,1.039 22.43,-21.698 22.43,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4691-05-4' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 573.737,210.044 c 0,0 -14.893,19.069 -11.743,19.736 3.15,0.667 19.674,-24.225 19.674,-24.225 l -4.523,0.153 -3.408,4.336 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4693-9-5' style='fill:%23452c25' /%3E %3Cpath d='m 573.737,210.044 c 0,0 -14.893,19.069 -11.743,19.736 3.15,0.667 19.674,-24.225 19.674,-24.225 l -4.523,0.153 -3.408,4.336 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4695-8-0' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 569.939,226.431 c 0,0 -14.575,19.312 -11.414,19.928 3.16,0.615 19.27,-24.548 19.27,-24.548 l -4.521,0.228 -3.335,4.392 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4697-1-4' style='fill:%23452c25' /%3E %3Cpath d='m 569.939,226.431 c 0,0 -14.575,19.312 -11.414,19.928 3.16,0.615 19.27,-24.548 19.27,-24.548 l -4.521,0.228 -3.335,4.392 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4699-4-4' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 578.14,222.614 c 0,0 -8.532,15.721 -7.558,16.371 0.976,0.65 11.337,-8.965 16.457,-18.32 5.12,-9.355 -9.265,1.559 -9.265,1.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4701-4-7' style='fill:%23452c25' /%3E %3Cpath d='m 578.14,222.614 c 0,0 -8.532,15.721 -7.558,16.371 0.976,0.65 11.337,-8.965 16.457,-18.32 5.12,-9.355 -9.265,1.559 -9.265,1.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4703-6-0' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 579.054,221.054 c 0,0 -8.426,19.153 -5.515,21.053 0,0 10.57,-11.555 13.329,-20.736 2.757,-9.181 0,-0.633 0,-0.633 l -0.767,-9.973 -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4709-0-4' style='fill:%23452c25' /%3E %3Cpath d='m 579.054,221.054 c 0,0 -8.426,19.153 -5.515,21.053 0,0 10.569,-11.555 13.329,-20.736 2.757,-9.181 0,-0.633 0,-0.633 l -0.767,-9.973 -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4711-6-4' style='fill:none;stroke:%23000000;stroke-width:0.58499998' /%3E %3Cpath d='m 574.678,219.38 c 0,0 -17.066,17.151 -14.02,18.19 3.046,1.039 22.431,-21.698 22.431,-21.698 l -4.511,-0.39 -3.9,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4713-9-7' style='fill:%23452c25' /%3E %3Cpath d='m 574.678,219.38 c 0,0 -17.066,17.151 -14.02,18.19 3.046,1.039 22.431,-21.698 22.431,-21.698 l -4.511,-0.39 -3.9,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4715-5-1' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 576.034,221.704 c 0,0 -17.066,17.151 -14.02,18.19 3.048,1.039 22.431,-21.698 22.431,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4717-7-9' style='fill:%23452c25' /%3E %3Cpath d='m 576.034,221.704 c 0,0 -17.066,17.151 -14.02,18.19 3.048,1.039 22.431,-21.698 22.431,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4719-3-7' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 577.389,224.415 c 0,0 -17.065,17.151 -14.019,18.19 3.046,1.039 22.43,-21.698 22.43,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4721-3-9' style='fill:%23452c25' /%3E %3Cpath d='m 577.389,224.415 c 0,0 -17.065,17.151 -14.019,18.19 3.046,1.039 22.43,-21.698 22.43,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4723-4-6' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 578.665,200.869 c 0,0 -12.678,15.852 -10.851,18.58 1.829,2.729 13.41,-7.277 17.067,-14.292 3.657,-7.016 -6.095,-4.807 -6.095,-4.807' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4725-6-8' style='fill:%23452c25' /%3E %3Cpath d='m 578.665,200.869 c 0,0 -12.678,15.851 -10.851,18.58 1.829,2.729 13.41,-7.277 17.067,-14.292 3.657,-7.016 -6.095,-4.807 -6.095,-4.807' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4727-2-4' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 578.257,217.706 c 0,0 -10.867,20.358 -8.063,19.189 2.804,-1.17 13.82,-16.48 15.039,-19.858 1.22,-3.378 0.809,-6.908 0.809,-6.908 l -8.412,5.067 0.722,3.944' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4729-6-7' style='fill:%23452c25' /%3E %3Cpath d='m 578.257,217.706 c 0,0 -10.867,20.358 -8.063,19.189 2.804,-1.17 13.82,-16.48 15.039,-19.858 1.22,-3.378 0.809,-6.908 0.809,-6.908 l -8.412,5.067 0.722,3.944' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4731-0-2' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 578.333,211.01 c 0,0 9.018,-16.228 -0.063,3.056 -9.08,19.284 -12.477,16.1 -12.477,16.1 -0.7,-1.097 7.896,-14.163 7.896,-14.163 0,0 6.383,-10.054 7.913,-11.009' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4733-2-1' style='fill:%23452c25' /%3E %3Cpath d='m 578.333,211.01 c 0,0 9.018,-16.228 -0.063,3.056 -9.08,19.284 -12.477,16.1 -12.477,16.1 -0.7,-1.097 7.896,-14.163 7.896,-14.163 0,0 6.383,-10.054 7.913,-11.009' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4735-8-1' style='fill:none;stroke:%23000000;stroke-width:0.40400001' /%3E %3Cpath d='m 588.003,208.855 c 0,0 10.029,-16.116 -0.024,3.06 -10.054,19.176 -13.976,15.935 -13.976,15.935 -0.815,-1.111 8.783,-14.066 8.783,-14.066 0,0 7.122,-9.971 8.851,-10.905' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4737-7-0' style='fill:%23452c25' /%3E %3Cpath d='m 588.003,208.855 c 0,0 10.029,-16.116 -0.024,3.06 -10.054,19.176 -13.976,15.935 -13.976,15.935 -0.815,-1.111 8.783,-14.066 8.783,-14.066 0,0 7.122,-9.971 8.851,-10.905' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4739-6-4' style='fill:none;stroke:%23000000;stroke-width:0.43099999' /%3E %3Cpath d='m 584.324,202.053 c 0,0 -12.678,15.851 -10.851,18.58 1.829,2.729 13.41,-7.277 17.067,-14.292 3.657,-7.016 -6.095,-4.807 -6.095,-4.807' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4751-1-5' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:0.47299999' /%3E %3C/g%3E %3Cg transform='translate(125,-33.395283)' id='g6782'%3E %3Cpath d='m -237.59735,1162.174 a 577.60738,643.15145 0 1 1 -1155.21475,0 577.60738,643.15145 0 1 1 1155.21475,0 z' transform='matrix(0.69251195,0,0,0.69967968,1414.539,200.25672)' id='path4790-9' style='fill:%23e8a30e;fill-opacity:1;stroke:none' /%3E %3Cpath d='m 529.4688,1013.4062 c 0,-209.05218 147.0862,-369.49997 320.5312,-369.49997 173.4451,0 320.5312,160.44799 320.5312,369.49997' id='path15610' style='font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;text-indent:0;text-align:start;text-decoration:none;line-height:normal;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;text-anchor:start;baseline-shift:baseline;color:%23000000;fill:none;stroke:%23339900;stroke-width:10;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate;font-family:Sans;-inkscape-font-specification:Sans' /%3E %3Cpath d='m 450.5409,1036.9979 c 10.908,237.5606 185.5899,426.4063 399.4688,426.4063 213.8789,0 388.5294,-188.8457 399.4375,-426.4063 l -798.9063,0 z' id='path12214-3' style='fill:%23007934;fill-opacity:1;stroke:%23eeeeee;stroke-opacity:1' /%3E %3Cpath d='m -237.59735,1162.174 a 577.60738,643.15145 0 1 1 -1155.21475,0 577.60738,643.15145 0 1 1 1155.21475,0 z' transform='matrix(0.69251195,0,0,0.69967968,1414.539,200.2458)' id='path17689' style='fill:none;stroke:%23000000;stroke-width:6.4647131;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg id='g8764'%3E %3Cg transform='matrix(0.89888361,0,0,0.89888358,602.80714,256.31033)' id='g5967-9' style='stroke:%23000000;stroke-width:1.11249113;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline'%3E %3Cpath d='m 200.51045,493.62183 c -4.87234,19.05527 0.49825,34.74179 9.81055,49.52259 7.20095,11.4296 11.93227,23.60997 11.70717,36.69681 -3.27561,1.84709 -6.39917,3.83804 -9.41431,5.98055 l -75.25773,-49.98699 50.52421,74.42746 c -0.90775,1.25334 -1.79218,2.55604 -2.6437,3.84498 -14.3304,-6.45556 -27.78276,-7.73562 -40.60162,-5.25593 -18.12127,3.50537 -33.5061,-0.28984 -49.57122,-9.86467 10.02885,16.91938 24.99118,24.20993 42.02754,28.07677 13.20014,2.9961 25.13177,8.25359 34.23728,17.70263 -0.99077,3.56052 -1.80901,7.16179 -2.43119,10.81755 l -88.58352,17.96332 88.38381,16.90213 c 0.24293,1.5206 0.53565,3.03673 0.84614,4.55477 -14.70201,5.56253 -25.15478,14.14816 -32.46731,24.96838 -10.33501,15.29233 -23.82469,23.4913 -41.95485,28.08063 19.05525,4.87238 34.7155,-0.56169 49.4963,-9.87399 11.42962,-7.20093 23.60999,-11.93227 36.69679,-11.70717 1.84709,3.27561 3.83804,6.39917 5.98055,9.41431 l -49.9607,75.32119 74.46462,-50.61396 c 1.24367,0.90012 2.50286,1.82523 3.78154,2.66997 -6.45554,14.33042 -7.70935,27.84621 -5.22966,40.66507 3.50536,18.12131 -0.31606,33.4428 -9.89094,49.50781 16.91943,-10.02872 24.20999,-24.9911 28.07677,-42.02755 2.99611,-13.20017 8.2536,-25.13179 17.70263,-34.2373 3.56771,0.99361 7.15419,1.80769 10.81755,2.43118 l 17.96333,88.58357 16.90212,-88.38386 c 1.52061,-0.24289 3.03675,-0.5356 4.55481,-0.84612 5.55935,14.70641 14.15064,25.15647 24.96834,32.46735 15.29235,10.33498 23.49134,23.82472 28.08065,41.95481 4.8724,-19.05519 -0.56168,-34.71548 -9.87398,-49.49625 -7.21495,-11.45195 -11.8934,-23.59536 -11.64374,-36.72314 3.25417,-1.83772 6.35405,-3.82477 9.35087,-5.95426 l 75.32115,49.96073 -50.5505,-74.49092 c 0.88821,-1.22858 1.77239,-2.49258 2.60658,-3.75527 14.33447,6.4742 27.83963,7.7106 40.66504,5.22967 18.12124,-3.50552 33.44273,0.3162 49.50777,9.89095 -10.02881,-16.9194 -24.96486,-24.14651 -42.00126,-28.01333 -13.1853,-2.99271 -25.10336,-8.35144 -34.20009,-17.79237 0.98835,-3.55441 1.74665,-7.14197 2.36772,-10.79126 l 88.60983,-17.89987 -88.41012,-16.96558 c -0.24291,-1.5206 -0.53564,-3.03673 -0.84614,-4.55481 14.71551,-5.55738 25.15375,-14.14668 32.46733,-24.96832 10.33498,-15.29234 23.851,-23.4279 41.9811,-28.01719 -19.05525,-4.87238 -34.74178,0.49821 -49.52254,9.8105 -11.45183,7.21495 -23.59528,11.89343 -36.72307,11.64375 -1.83777,-3.25416 -3.82482,-6.35404 -5.95429,-9.35085 l 49.98699,-75.25775 -74.51718,50.48707 c -1.2286,-0.8882 -2.49256,-1.77236 -3.75525,-2.60655 6.4655,-14.32627 7.73561,-27.78279 5.2559,-40.60162 -3.50542,-18.1213 0.28989,-33.50614 9.8647,-49.57122 -16.91939,10.02883 -24.14653,24.96487 -28.01334,42.00124 -2.99946,13.21496 -8.34866,25.18536 -17.8295,34.28984 -3.54355,-0.98412 -7.11638,-1.83833 -10.75411,-2.45745 l -17.89992,-88.60981 -16.96558,88.41009 c -1.52058,0.24292 -3.03671,0.53563 -4.55477,0.84615 -5.56153,-14.70591 -14.14651,-25.15362 -24.96836,-32.46732 -15.29233,-10.33502 -23.42787,-23.85096 -28.01719,-41.98114 z' id='path5969-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.6687367;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible' /%3E %3Cg transform='matrix(1.9336856,0,0,1.9336856,395.15964,685.49999)' id='g5971-3' style='stroke:none'%3E %3Cuse transform='matrix(0.9238795,0.3826834,-0.3826834,0.9238795,35.714286,-47.857143)' id='use5973-7' style='fill:%23fcbf49;stroke:none' x='0' y='0' width='330' height='330' /%3E %3Cuse transform='matrix(-1,0,0,1,35.714286,-47.857143)' id='use5975-0' style='fill:%23fcbf49;stroke:none' x='0' y='0' width='330' height='330' /%3E %3Cg id='g5977-4' style='fill:%23000000;stroke:none'%3E %3Cg transform='translate(-30.709165,2.1386886)' id='g5979-0' style='fill:%23000000;stroke:none'%3E %3Cpath d='m 9.571429,-21.857143 c -11.5,-10 -26,-11.5 -34,-4 -5.806373,7.76306 -5.288976,16.9037284 1.5,26.5 -0.5,0 -1.5,0.5 -2,1 -5.042555,-9.6028165 -5.909949,-19.491103 -2.5,-28.5 11,-9 26,-10 37,5' id='path5981-7' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -8.428571,-24.857143 c -6.5,0 -8,1.5 -11,4 -3,2.5 -4.5,2 -5,2.5 -0.5,0.5 0,2 1,1.5 1,-0.5 3,-1.5 6,-4 3,-2.5 6,-2.5 9,-2.5 9,0 14,7.5 15,7 1,-0.5 -5,-8.5 -15,-8.5' id='path5983-6' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m 3.071429,-16.357143 c -6.5,-7 -18.5,-7.5 -23.5,0.5 l 2,0 c 5,-8 17,-4.5 18,-1 l 0,1' id='path5985-3' style='fill:%23000000;stroke:none' /%3E %3Ccircle cx='22' cy='-9' r='4.5' transform='translate(-31.428571,-7.857143)' id='circle5987-9' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -20.428571,-15.857143 c 5,4.5 16,5 23.5,-0.5 l -3.5,-0.5 c -5,5.5 -13,5 -18,1 l 0,-1' id='path5989-6' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m 3.571429,-13.857143 c -8.5,6.5 -17,6 -22,3 -5,-3 -5,-4 -4,-4 1,0 2,1 6,3 4,2 10,2 20,-2' id='path5991-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -20.928571,1.142857 c 1.41609,0.5034893 2.241084,1.977139 1.930035,3.447534 -0.311049,1.470394 -1.66214,2.483712 -3.160813,2.370609 -1.498672,-0.113103 -2.682377,-1.31772 -2.769222,-2.818143 -0.5,1 -2.5,4 -6.5,4 l -1,0 1,1.5 c 1,0 4,0 6,-1.5 1.163388,1.669092 3.301964,2.349966 5.216194,1.660715 1.91423,-0.68925 3.127878,-2.577147 2.960205,-4.604763 -0.167673,-2.027616 -1.674951,-3.6905072 -3.676399,-4.055952' id='path5993-8' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -14.928571,22.142857 c -4.5,-3 -6.5,-7.5 -11.5,-7.5 -1,0 -3,0.5 -5,1.5 l -1,0 1,1.5 c 2,0 5,-2.5 8.5,-0.5 3.5,2 5.5,4 8,5' id='path5995-5' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -16.428571,22.142857 c -10,-3 -12,-1 -15,-1 l -1,0 1,2 c 4,0 6,-3 15,-1' id='path5997-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -14.928571,22.142857 c -11,-1 -7.5,5.5 -16.5,5.5 l -1,0 1,1.5 c 11,0 6,-6 16.5,-7' id='path5999-5' style='fill:%23000000;stroke:none' /%3E %3C/g%3E %3Cg transform='matrix(-1,0,0,1,-93.571428,2.1386886)' id='g6001-5' style='fill:%23000000;stroke:none'%3E %3Cpath d='m 9.571429,-21.857143 c -11.5,-10 -26,-11.5 -34,-4 -5.806373,7.76306 -5.288976,16.9037284 1.5,26.5 -0.5,0 -1.5,0.5 -2,1 -5.042555,-9.6028165 -5.909949,-19.491103 -2.5,-28.5 11,-9 26,-10 37,5' id='path6003-0' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -8.428571,-24.857143 c -6.5,0 -8,1.5 -11,4 -3,2.5 -4.5,2 -5,2.5 -0.5,0.5 0,2 1,1.5 1,-0.5 3,-1.5 6,-4 3,-2.5 6,-2.5 9,-2.5 9,0 14,7.5 15,7 1,-0.5 -5,-8.5 -15,-8.5' id='path6005-0' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m 3.071429,-16.357143 c -6.5,-7 -18.5,-7.5 -23.5,0.5 l 2,0 c 5,-8 17,-4.5 18,-1 l 0,1' id='path6007-8' style='fill:%23000000;stroke:none' /%3E %3Ccircle cx='22' cy='-9' r='4.5' transform='translate(-31.428571,-7.857143)' id='circle6009-7' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -20.428571,-15.857143 c 5,4.5 16,5 23.5,-0.5 l -3.5,-0.5 c -5,5.5 -13,5 -18,1 l 0,-1' id='path6011-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m 3.571429,-13.857143 c -8.5,6.5 -17,6 -22,3 -5,-3 -5,-4 -4,-4 1,0 2,1 6,3 4,2 10,2 20,-2' id='path6013-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -20.928571,1.142857 c 1.41609,0.5034893 2.241084,1.977139 1.930035,3.447534 -0.311049,1.470394 -1.66214,2.483712 -3.160813,2.370609 -1.498672,-0.113103 -2.682377,-1.31772 -2.769222,-2.818143 -0.5,1 -2.5,4 -6.5,4 l -1,0 1,1.5 c 1,0 4,0 6,-1.5 1.163388,1.669092 3.301964,2.349966 5.216194,1.660715 1.91423,-0.68925 3.127878,-2.577147 2.960205,-4.604763 -0.167673,-2.027616 -1.674951,-3.6905072 -3.676399,-4.055952' id='path6015-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -14.928571,22.142857 c -4.5,-3 -6.5,-7.5 -11.5,-7.5 -1,0 -3,0.5 -5,1.5 l -1,0 1,1.5 c 2,0 5,-2.5 8.5,-0.5 3.5,2 5.5,4 8,5' id='path6017-8' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -16.428571,22.142857 c -10,-3 -12,-1 -15,-1 l -1,0 1,2 c 4,0 6,-3 15,-1' id='path6019-3' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -14.928571,22.142857 c -11,-1 -7.5,5.5 -16.5,5.5 l -1,0 1,1.5 c 11,0 6,-6 16.5,-7' id='path6021-3' style='fill:%23000000;stroke:none' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(1.4408391,0.04809649,-0.05005259,1.4994388,-465.07439,-459.79661)' id='g3889-3-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 975.07733,1010.8917 c 13.5931,1.2193 27.74127,0.3631 39.85067,-3.6975 11.0594,-4.0995 23.1706,-6.9927 35.2798,-6.1883 0,-1.62187 3.5211,-2.88048 1.4822,-4.09979 -4.5094,-2.47791 -10.0706,-2.02361 -15.6305,-4.51462 -9.0837,-3.69752 -14.5816,-10.3266 -23.6637,-14.89305 -0.9887,-0.35047 -5.0045,-2.43924 -5.0045,-4.51493 19.6627,25.3455 63.5281,10.66947 101.3888,6.59047 3.522,0.81693 12.6042,-2.02374 20.141,-4.51478 9.0839,-3.28227 31.2598,-1.63943 36.8209,-5.38858 0.9267,-0.35026 -9.5728,-6.15742 -11.6115,-7.83116 -5.4998,-6.18309 -19.1529,-4.91565 -26.1962,-11.55553 -11.0606,-11.14801 -27.6799,-14.03708 -41.3963,-23.15838 -3.027,-1.62188 -9.0837,-0.88727 -13.593,-1.74887 -5.6619,-4.29036 -0.2829,-4.31778 -43.5042,-36.27097 -38.61337,-13.84343 -36.76217,-25.3551 -60.71157,-33.35815 -8.5257,-3.69741 -16.439,-10.54914 -23.4824,-8.46023 -12.6027,3.69741 -39.7038,18.11997 -51.8136,25.57588 -10.0709,6.18312 -22.5883,17.11553 -31.1755,24.16012 -2.2553,1.84923 -28.3101,24.55521 -58.1313,41.56176 -29.8212,17.00619 -73.024,40.38254 -76.7934,40.78811 68.4386,-5.49026 -60.6493,20.6457 247.7443,31.5185 z' id='path430-1-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 804.22467,940.41498 c 17.044,-9.61464 82.2656,-46.69393 102.0215,-71.93545 -2.8046,0.2723 5.8496,7.46703 5.2708,10.52825 6.4281,-0.42918 2.8896,-7.03656 8.2324,-7.46594 4.1175,0 7.0769,-1.71862 10.6156,-3.06231 4.1173,-0.85956 1.7343,1.71891 1.7343,3.06231 -5.273,10.09917 -17.0438,16.2228 -26.5039,24.11902 1.1553,0.85925 2.3109,1.71891 1.7341,3.06102 3.4644,0.3769 7.5815,0.3769 9.9647,-1.71901 0.5785,-0.42908 0.5785,-1.77258 0.5785,-2.63194 3.5387,1.28993 2.3114,3.92196 1.156,5.69435 -2.3113,5.26428 -12.3501,4.78024 -15.3116,9.61513 -3.4666,5.2106 -7.0052,9.61513 -12.3481,13.59086 4.1155,-3.49169 8.8094,-7.89632 14.1542,-8.32658 8.2325,-0.85976 11.1942,-6.12374 18.2716,-7.84265 7.6534,-1.71881 12.348,-7.89612 18.2713,-12.73111 -2.311,3.4916 -7.0788,6.55391 -5.2731,10.52974 0.5788,0.42889 2.48005,1.67953 4.86325,0.7662 -5.2731,7.03686 -16.05725,12.34042 -19.59585,20.66671 -3.5383,-1.28973 -5.8493,1.28864 -8.2324,1.71911 -3.4663,1.28844 -2.311,6.55252 -4.694,8.3251 -9.9668,5.69445 -14.733,14.93426 -18.8483,22.77688 -0.5788,0.85945 -8.2327,5.25974 -11.1945,6.12619 -5.2726,2.20019 -37.9068,28.14724 -38.4835,24.65427 -3.4664,-16.64765 -36.2688,14.65617 -112.7448,-8.99578' id='path436-3-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 985.94905,971.96173 c -0.5768,-0.64732 -1.7322,-0.96611 -1.7322,-1.2845 1.1554,-2.60989 -4.1172,-2.93862 -4.1172,-5.58317 8.8112,0 15.8882,9.46711 21.23125,3.5691 1.1574,-1.32508 -2.31115,-3.24873 2.8896,-4.89349 1.1554,-0.28185 -1.1554,-1.2846 -0.5787,-1.96669 -2.8876,0 -5.27095,0.32056 -7.07685,-0.28156 -2.3111,-0.6422 -3.5386,-1.28411 -6.4265,-1.9665 -2.8895,-0.6424 -4.1171,-3.57166 0,-4.57519 7.6539,-1.32479 15.88815,3.57235 21.80995,0.64191 4.6941,-2.28716 9.3881,-2.92916 14.0821,-4.5749 2.3111,-0.6427 10.0387,-0.28097 7.654,1.92621 -1.7325,1.3243 -5.8498,0.96375 -8.2328,1.60596 -4.1152,1.2843 -7.6538,3.2509 -11.7713,4.89585 2.8899,-0.32056 2.3113,2.93005 5.8498,1.96659 5.2726,-1.60496 10.6157,-3.57166 16.4651,-4.25394 -0.5768,-1.28402 1.1574,-2.28794 1.1574,-3.61263 0.5766,0 1.1535,0 1.7321,0 -2.8895,-3.89261 5.2727,-2.24688 8.2329,-5.53904 0,0.6422 0.5064,0.6422 1.1555,0.96384 -4.1157,1.60487 -2.3112,4.21367 -3.4664,6.22133 -0.5773,0.6423 -2.3112,0.96286 -1.7326,1.9665 2.3109,1.60516 2.3109,-1.28402 4.1154,-0.64221 1.7339,0.32076 4.1172,0.96287 5.2726,0.64221 2.8878,0 5.8494,-1.28402 4.0434,-3.61263 -2.3111,-1.92622 -4.6941,-3.57235 -4.6941,-6.18115 0,-0.32075 -0.5768,-0.6421 -1.7322,-0.96286 4.694,0 8.2323,1.32429 9.9649,3.2514 2.3109,1.96639 2.8895,4.89674 6.5002,5.57873 7.0047,0.96286 6.426,-2.28795 6.426,-5.57873 5.2731,0.32026 12.9287,2.28676 11.7731,4.89674 -0.5064,1.92631 -4.6938,3.57126 -8.8112,3.93289 -2.8877,0.28077 -1.1555,2.28725 -2.8877,2.60909 -3.4665,0 -7.6558,0.64211 -8.8111,1.9664 -1.1554,1.96659 0.5767,5.86384 2.8876,7.17917 3.4666,1.61294 10.5453,-0.63719 15.8883,0 0.507,-2.92838 4.1176,-3.88415 7.0771,-5.89467 3.4666,-1.92661 -1.732,-3.57274 -4.6939,-4.89703 -2.3109,-0.6423 -0.5768,-1.2847 0.5785,-2.92956 1.7327,-1.92641 7.077,-0.32144 7.6541,-1.92641 1.1557,-1.9662 -1.1555,-4.89694 1.1557,-6.22142 1.7338,-1.28412 4.117,0.96296 3.466,2.60879 2.3109,-0.28038 2.8898,-1.60575 5.2726,-1.92631 2.8877,-0.32076 4.6941,1.92631 3.4668,2.6087 -3.4668,2.28814 -6.4285,3.8933 -5.2727,7.18409 0,1.64584 -4.1151,2.28824 -2.311,3.61243 3.4663,2.28725 3.4663,4.57559 4.694,7.18557 1.1554,2.92827 7.6558,3.5755 13.5052,2.29109 -2.3108,-5.5483 11.1944,-3.25701 17.1161,-4.90107 0.5048,0 0.5048,-0.96611 0,-1.28411 -2.8899,-1.60497 -3.4665,-2.24855 -2.8899,-4.57569 0,-0.28136 -1.0834,-0.96355 -1.7324,-1.28431 8.8115,2.6088 24.4051,6.07162 30.9053,10.97082 -8.2324,1.60299 -23.828,-1.49445 -32.0606,0.4683 -9.9668,2.60959 -20.0036,5.85665 -30.6934,5.85665 -4.6938,0 -9.3879,-1.92169 -14.0817,-1.92169 m -94.96605,-2.60968 c 1.1557,0.27772 -2.8875,-0.31859 -3.466,-0.64733' id='path3090-0-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 957.98778,1017.3317 c 16.3473,-1.4162 19.3362,10.7217 29.6969,-0.3029 9.8693,1.416 18.84692,-2.0308 18.93532,-3.3913 23.0216,3.865 93.8065,-4.7323 88.9484,-9.4034 -7.598,-7.8077 -19.6047,-10.45549 -29.2273,-17.05588 -2.1406,-1.20011 -6.5436,-1.74127 -9.7984,-2.51041 -5.4327,-1.40475 -12.5427,0.0207 -17.2025,-2.13681 -7.4997,-3.73439 -15.442,-6.92921 -22.1491,-11.71445 -4.2164,-2.69672 -5.782,-7.16219 -10.413,-10.45084 -4.9488,-3.27578 -11.93872,-3.71051 -16.97382,-5.65767 -7.5713,-2.63821 -11.9273,-9.44476 -19.0401,-14.25409 -2.4668,-1.75807 -6.5607,-1.47493 -9.4036,-3.0176 -6.0646,-2.81004 -10.8625,-9.11816 -16.0922,-8.06906 -9.3563,1.8508 -14.648,9.41747 -23.8039,13.75412 -7.6138,3.59479 -10.9693,9.92129 -17.5372,14.14815 -1.725,1.1096 -21.7093,14.80664 -44.1992,24.59757 -22.4904,9.79095 -52.0176,21.71717 -54.7859,21.81167 0,0 20.6388,13.5979 67.4596,10.1829 l 28.9783,7.9584 15.9335,-3.2244 c 0,0 39.9076,-1.3118 40.6742,-1.264 z' id='path1871-3-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 860.34546,985.45434 c 10.3637,-5.19291 50.0212,-25.21684 61.9951,-38.7709 -1.7087,0.15427 3.5866,3.97284 3.2418,5.61127 3.9175,-0.24964 1.7422,-3.7704 4.9982,-4.01671 2.5097,-0.0129 4.3091,-0.9407 6.4631,-1.66998 2.5076,-0.47253 1.0617,0.9133 1.0654,1.63134 -3.187,5.41486 -10.3455,8.72505 -16.0907,12.9753 0.7064,0.45586 1.4135,0.91182 1.0651,1.63087 2.1132,0.19055 4.6229,0.17767 6.0699,-0.95011 0.3516,-0.2312 0.348,-0.94916 0.3456,-1.40857 2.1609,0.67835 1.4196,2.08902 0.7201,3.04032 -1.3945,2.82106 -7.5154,2.59385 -9.3077,5.18742 -2.0989,2.79587 -4.244,5.16129 -7.4902,7.30328 2.4994,-1.87918 5.3487,-4.24822 8.6058,-4.49517 5.016,-0.48515 6.8071,-3.30832 11.1167,-4.24893 4.6611,-0.94281 7.5057,-4.25952 11.1033,-6.86258 -1.3993,1.87348 -4.2973,3.52546 -3.1855,5.64486 0.354,0.22757 1.7689,1.39779 3.2189,0.90232 -3.1949,3.77782 -10.0069,6.13871 -12.1414,10.60045 -2.1605,-0.67851 -3.5622,0.70708 -5.0138,0.94438 -2.1095,0.69985 -1.3909,3.50993 -2.8384,4.465 -6.0603,3.07477 -8.9404,8.02892 -11.4274,12.23353 -0.3508,0.46139 -5.0045,2.83767 -6.8076,3.30989 -3.2083,1.19258 -23.0308,15.16388 -23.3923,13.29888 -2.1585,-8.8878 -21.3998,4.9511 -68.0841,-7.4528' id='path3088-3-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 850,563.40623 c -220.9139,0 -400,201.47189 -400,449.99997 0,248.5282 179.0861,450 400,450 220.9139,0 400,-201.4718 400,-450 0,-248.52808 -179.0861,-449.99997 -400,-449.99997 z m 0,100.5 c 161.0463,0 300.5312,149.75879 300.5312,349.49997 0,199.7413 -139.4849,349.4688 -300.5312,349.4688 -161.0463,0 -300.5312,-149.7274 -300.5312,-349.4688 0,-199.74108 139.4849,-349.49997 300.5312,-349.49997 z' id='path4014-9' style='font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;text-indent:0;text-align:start;text-decoration:none;line-height:normal;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;text-anchor:start;baseline-shift:baseline;color:%23000000;fill:%2300a6de;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate;font-family:Sans;-inkscape-font-specification:Sans' /%3E %3Cg transform='matrix(0.43572985,0,0,0.35330032,849.27131,1196.2863)' id='1-5-2-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline'%3E %3Cpath d='m 133.86614,24.413387 c 0.1063,6.944882 -1.98425,7.192913 -12.54331,8.964567 -10.34645,1.73622 -12.3307,1.771653 -12.47244,-4.818898 -0.1063,-6.944882 2.19685,-7.228347 12.54331,-8.964567 9.77953,-1.629922 12.33071,-2.480315 12.47244,4.818898 z' id='2-8-89-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 136.09842,24.023623 c 0.14174,4.358268 -6.62598,5.42126 -14.74015,6.767717 -8.14961,1.346456 -14.563,2.267716 -14.70473,-1.84252 -0.17716,-4.358268 6.59055,-5.42126 14.74016,-6.767717 8.11417,-1.346457 14.52756,-2.692913 14.70472,1.84252 z' id='3-1-8-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 56.905511,333.88584 C 79.15748,260.46851 85.003936,205.01575 53.149606,126.3189 106.01575,64.098427 144.81496,85.677168 179.85827,129.86221 c -33.34252,77.70473 -24.62599,133.08662 -5.563,204.55512 -41.45669,27.03544 -77.562987,26.25591 -117.389759,-0.53149 z' id='4-2-9-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 115.33464,87.625987 c -1.09842,0.03543 -2.19685,0.07087 -3.29527,0.177165 3.68504,89.255908 0.56693,177.803158 -0.0709,266.421268 1.45276,0.0709 2.94095,0.1063 4.3937,0.1063 -0.24803,-89.18504 3.93307,-175.53544 -0.81496,-266.704733 -0.0709,0 -0.14173,0 -0.2126,0 z' id='5-5-9-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 125.3622,88.547247 c -9.35433,81.248033 -12.82677,163.346463 -10.55905,265.783473 1.27559,0 2.58661,0 3.8622,-0.0354 -0.53149,-101.09056 2.33859,-183.25985 10.34646,-264.862216 -1.20472,-0.318898 -2.44488,-0.637796 -3.64961,-0.885827 z' id='6-7-9-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 143.29134,3.5787403 c -9.38977,12.7559057 -14.56299,12.6496067 -9.8504,32.4212607 10.38189,-8.716536 10.09843,-15.944882 9.8504,-32.4212607 z' id='7-4-4-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 122.45669,12.118111 c 6.12992,7.972441 15.09449,12.11811 9.38977,33.625985 -11.19685,-11.940945 -9.7441,-13.14567 -9.38977,-33.625985 z' id='8-4-2-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 120.54331,34.086615 c 8.11417,7.26378 15.55511,8.787402 9.99212,27.531497 -7.12205,-10.488189 -10.20472,-9.602362 -9.99212,-27.531497 z' id='9-4-0-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 118.31102,45.779529 c 6.16536,7.830709 15.12992,11.905512 9.46063,32.952757 -11.19685,-11.692914 -9.74409,-12.862205 -9.46063,-32.952757 z' id='10-4-8-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 114.73228,62.822837 C 121.9252,70.511813 132.34252,74.622049 125.96457,94.9252 113.52756,81.992128 119.65748,78.980317 114.73228,62.822837 z' id='11-4-7-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 113.35039,80.043309 c 6.73229,7.440946 17.36221,11.799213 11.33859,31.429131 -9.60237,-10.84252 -10.84252,-12.543303 -11.33859,-31.429131 z' id='12-2-8-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.49212,21.543308 c -4.88976,5.031496 -16.15748,4.535433 -16.61811,26.007875 13.88977,-9.850394 13.74804,-7.972442 16.61811,-26.007875 z' id='13-9-7-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.74803,36.814962 c -5.20866,4.641732 -17.2559,4.074803 -17.64567,24.200788 14.81102,-9.070867 14.66929,-7.299213 17.64567,-24.200788 z' id='14-3-3-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 146.97638,50.63386 c -5.38583,5.031496 -17.85827,4.429134 -18.28347,26.149607 15.34252,-9.814961 15.16536,-7.937008 18.28347,-26.149607 z' id='15-0-0-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 146.05512,69.625986 c -5.66929,2.586615 -18.92126,-2.551181 -19.02756,24.377954 11.33858,-3.720473 10.55905,-11.905512 19.02756,-24.377954 z' id='16-7-7-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 139.74803,86.031499 c -7.90157,4.074803 -12.36614,3.259842 -13.8189,24.909451 11.44488,-9.5315 11.30315,-7.75984 13.8189,-24.909451 z' id='17-7-6-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 148.42913,98.787405 C 128.44488,169.40552 124.22835,236.26772 126.2126,353.65749 c 1.62992,-0.2126 3.22441,-0.46063 4.85433,-0.74409 -0.99213,-116.39764 2.62205,-180.81497 20.97638,-251.53938 -1.20473,-0.92126 -2.40945,-1.771655 -3.61418,-2.586615 z' id='18-8-4-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 181.02756,20.976379 c -11.40945,9.956693 -16.44095,8.503937 -15.23622,28.984252 11.69291,-5.740157 12.6496,-12.862205 15.23622,-28.984252 z' id='19-7-2-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 159.09449,23.846457 c 4.67716,9.389764 12.7559,15.732284 3.47244,35.185041 -8.92914,-14.52756 -7.29921,-15.34252 -3.47244,-35.185041 z' id='20-3-1-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 153.46063,44.716537 c 6.73228,9.177165 13.74803,12.614173 5.06693,29.444883 -5.17323,-12.118111 -8.36221,-12.047245 -5.06693,-29.444883 z' id='21-0-9-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.27953,55.523624 c 4.67716,9.248031 12.79133,15.555118 3.57874,34.547245 -8.96457,-14.314961 -7.33465,-15.094489 -3.57874,-34.547245 z' id='22-3-1-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 142.79527,71.149608 c 5.74016,9.389764 15.27166,16.122048 5.52756,34.192912 -9.99212,-15.83858 -3.437,-17.149604 -5.52756,-34.192912 z' id='23-8-6-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 138.47244,87.555121 c 5.38583,9 15.02362,16.051179 5.74016,33.590549 -7.54725,-13.11023 -8.46851,-15.09449 -5.74016,-33.590549 z' id='24-2-0-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 184.03937,40.110237 c -5.66929,3.614174 -16.65354,0.177166 -20.79921,20.940946 15.30708,-5.917323 14.84645,-4.145669 20.79921,-20.940946 z' id='25-5-3-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 180.67323,54.779529 c -5.91733,3.153544 -17.64567,-0.602362 -21.47244,18.921261 16.08661,-4.925197 15.62598,-3.295276 21.47244,-18.921261 z' id='26-2-3-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 176.56299,67.748034 c -6.16535,3.472441 -18.28346,-0.354331 -22.46457,20.65748 16.75985,-5.527559 16.26378,-3.755905 22.46457,-20.65748 z' id='27-0-6-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 172.38189,85.996066 c -6.02362,1.027559 -18.1063,-7.440946 -22.85433,18.744094 11.76378,-0.67323 12.40157,-8.822834 22.85433,-18.744094 z' id='28-3-2-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 163.34646,100.31103 c -8.43308,1.87795 -12.68504,-0.0709 -17.82284,20.58661 12.89764,-6.23622 12.43701,-4.57086 17.82284,-20.58661 z' id='29-7-2-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 167.17323,115.15748 c -25.97244,64.20473 -31.5,122.9882 -18.56693,232.68899 1.87795,-0.70866 3.79134,-1.52363 5.70472,-2.37402 -12.8622,-104.74016 -7.79527,-163.38189 16.05118,-226.87796 -1.06299,-1.20472 -2.12598,-2.33858 -3.18897,-3.43701 z' id='30-2-1-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 210.50787,38.338584 c -12.40157,8.007874 -17.2559,5.775591 -18.2126,26.220473 12.22441,-3.826772 13.96063,-10.700788 18.2126,-26.220473 z' id='31-9-4-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 188.39764,37.629922 c 3.6496,10.02756 11.01968,17.64567 -0.24804,35.362206 -7.37007,-15.80315 -5.66929,-16.334646 0.24804,-35.362206 z' id='32-7-3-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 180.60236,57.401577 c 5.70473,10.169291 12.33071,14.669291 1.94882,29.905512 C 178.68898,74.51575 175.5,74.090553 180.60236,57.401577 z' id='33-5-2-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 175.2874,67.429136 c 3.72047,9.885827 11.09055,17.433071 -0.0354,34.724414 -7.40551,-15.590555 -5.70473,-16.086618 0.0354,-34.724414 z' id='34-3-6-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 167.24409,81.850396 c 4.7126,10.204725 13.46457,18.354334 1.87796,34.688974 -8.25591,-17.255902 -1.59449,-17.539367 -1.87796,-34.688974 z' id='35-4-0-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 161.22047,97.370082 c 4.3937,9.779528 13.25197,18.283468 2.16142,34.122048 -6.09449,-14.1378 -6.80315,-16.26378 -2.16142,-34.122048 z' id='36-3-5-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 211.46457,57.755907 c -5.98819,2.622048 -16.54725,-2.515748 -22.85434,17.362205 15.83859,-3.401574 15.20079,-1.73622 22.85434,-17.362205 z' id='37-2-4-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 206.61023,71.716538 c -6.20078,2.161417 -17.50393,-3.401575 -23.35039,15.23622 16.51181,-2.267716 15.90945,-0.708661 23.35039,-15.23622 z' id='38-1-96-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 201.15354,83.870081 c -6.48425,2.444882 -18.14173,-3.295275 -24.48425,16.830709 17.22047,-2.799212 16.54724,-1.098425 24.48425,-16.830709 z' id='39-1-0-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 195.09449,101.23229 c -6.09449,0.0709 -17.22048,-10.240161 -24.69685,14.88189 11.76378,1.24015 13.25196,-6.73229 24.69685,-14.88189 z' id='40-3-8-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 184.6063,113.95276 c -8.61024,0.5315 -12.61418,-2.05512 -19.87795,17.53937 13.46456,-4.14567 12.82677,-2.51575 19.87795,-17.53937 z' id='41-2-2-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 101.37402,89.85827 c -1.1693,0.354331 -2.374021,0.779528 -3.578745,1.204725 8.574805,81.283465 14.066925,163.346465 13.003935,263.090555 1.09843,0.0709 2.19685,0.14174 3.29528,0.14174 2.83464,-101.76379 -2.94095,-183.33072 -12.72047,-264.43702 z' id='42-5-7-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 83.338582,1.9133859 C 92.65748,15.165355 97.830708,15.34252 93.01181,34.901576 82.665354,25.582678 82.984251,18.354331 83.338582,1.9133859 z' id='43-3-4-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 104.13779,11.586615 C 97.937007,19.240158 88.937007,22.889764 94.535432,44.716537 105.76772,33.413387 104.35039,32.102363 104.13779,11.586615 z' id='44-5-0-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 105.90945,33.661418 C 97.724409,40.464568 90.283464,41.598426 95.740157,60.661419 102.93307,50.527561 105.98031,51.625986 105.90945,33.661418 z' id='45-1-7-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 108.07087,45.496064 C 101.87008,53.007876 92.870078,56.551183 98.397637,77.917325 109.70079,66.862207 108.24803,65.586616 108.07087,45.496064 z' id='46-2-6-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 111.54331,62.716537 c -7.22835,7.334646 -17.681106,10.84252 -11.40945,31.500001 12.50787,-12.22441 6.37795,-15.590551 11.40945,-31.500001 z' id='47-2-01-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 112.8189,80.043309 c -6.80315,7.051182 -17.433074,10.807087 -11.51575,30.791341 9.63779,-10.34646 10.87795,-11.976379 11.51575,-30.791341 z' id='48-2-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 77.031496,19.523623 c 4.85433,5.279527 16.122047,5.456693 16.476377,26.929134 C 79.653543,35.822836 79.795275,37.700789 77.031496,19.523623 z' id='49-6-9-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 77.669291,34.83071 c 5.173228,4.925197 17.255905,5.031496 17.503937,25.157481 C 80.397637,50.137797 80.574803,51.874017 77.669291,34.83071 z' id='50-4-3-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 79.370078,48.720474 C 84.720472,54.070868 97.192913,54.177167 97.51181,75.933073 82.240157,65.232285 82.381889,67.110238 79.370078,48.720474 z' id='51-0-8-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 80.185039,67.783467 C 85.85433,70.688978 99.106298,66.295278 99.070865,93.224412 87.732283,88.866144 88.582677,80.716538 80.185039,67.783467 z' id='52-7-5-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 86.385826,84.54331 c 7.901575,4.5 12.330709,3.968504 13.677164,25.65354 C 88.653543,100.063 88.795275,101.83465 86.385826,84.54331 z' id='53-0-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 79.370078,101.19685 c -1.169291,0.8504 -2.338582,1.77166 -3.543307,2.72835 18.496063,70.12205 25.299209,134.96457 23.669291,248.7756 1.417328,0.28346 2.870078,0.53149 4.287398,0.74409 C 106.40551,238.32284 99.318897,171.4252 79.370078,101.19685 z' id='54-3-5-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 45.496063,17.220473 C 56.870078,27.779528 61.901574,26.610237 60.590551,47.05512 48.933071,40.6063 47.976378,33.44882 45.496063,17.220473 z' id='55-4-6-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 67.429133,21.259843 C 62.716535,30.401576 54.566929,36.318899 63.744094,56.267718 72.779527,42.236222 71.149606,41.350395 67.429133,21.259843 z' id='56-0-6-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 72.921259,42.44882 C 66.153543,51.271655 59.102362,54.318899 67.677165,71.610238 72.921259,59.811025 76.110236,60.059057 72.921259,42.44882 z' id='57-0-8-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 77.066929,53.503939 c -4.748032,9 -12.897638,14.846457 -3.826772,34.334646 9.070866,-13.818898 7.440945,-14.669291 3.826772,-34.334646 z' id='58-5-8-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 83.409448,69.484254 C 77.633858,78.55512 68.066929,84.755908 77.704724,103.35827 87.767716,88.086617 81.248031,86.421262 83.409448,69.484254 z' id='59-3-9-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 87.625984,86.137798 c -5.385827,8.716536 -15.094488,15.200792 -5.917323,33.236222 7.61811,-12.64961 8.53937,-14.56299 5.917323,-33.236222 z' id='60-1-8-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 42.413386,36.177166 c 5.633858,3.897638 16.61811,1.098426 20.65748,22.074804 C 47.763779,51.484254 48.224409,53.255907 42.413386,36.177166 z' id='61-0-7-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 45.673228,51.023624 c 5.88189,3.472441 17.645669,0.389763 21.330709,20.090551 C 50.952756,65.303152 51.377952,66.968506 45.673228,51.023624 z' id='62-6-0-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 49.677165,64.204726 c 6.129921,3.826772 18.318897,0.673229 22.322834,21.933072 C 55.311023,79.653546 55.771653,81.460632 49.677165,64.204726 z' id='63-7-7-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 53.751968,82.665357 C 59.77559,84.047247 71.929133,76.251971 76.499999,102.68504 64.73622,101.37402 64.169291,93.188979 53.751968,82.665357 z' id='64-5-9-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 62.681102,97.476381 c 8.433071,2.374016 12.685039,0.673228 17.716535,21.614169 -12.862204,-6.98031 -12.401575,-5.24409 -17.716535,-21.614169 z' id='65-0-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 60.909448,117.67323 c -0.956693,0.99213 -1.913385,2.01969 -2.870078,3.08268 23.492125,65.09055 27.318897,120.86221 19.665354,224.57481 l 1.062992,0.74409 c 1.240157,0.5315 2.444882,1.063 3.685039,1.55906 8.716536,-105.20079 4.429134,-162.10631 -21.543307,-229.96064 z' id='66-0-5-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 15.944882,32.917324 C 28.27559,41.598426 33.165354,39.614174 33.980315,60.165356 21.791338,55.629923 20.090551,48.649608 15.944882,32.917324 z' id='67-4-8-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 38.055118,33.44882 c -3.720473,9.814961 -11.125984,17.007874 0.03543,35.362206 7.440945,-15.377954 5.740157,-16.015749 -0.03543,-35.362206 z' id='68-5-6-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 45.708661,53.610238 c -5.77559,9.850394 -12.437008,14.031496 -2.125984,29.834646 3.968504,-12.57874 7.122047,-12.826772 2.125984,-29.834646 z' id='69-4-3-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 50.952756,63.956695 C 47.19685,73.629923 39.755905,80.751971 50.77559,98.681105 58.322834,83.515751 56.622047,82.913388 50.952756,63.956695 z' id='70-9-94-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 58.925196,78.838585 C 54.141732,88.759845 45.35433,96.448822 56.834645,113.42126 65.19685,96.625987 58.535433,95.988192 58.925196,78.838585 z' id='71-5-5-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 64.842519,94.677168 c -4.429134,9.531492 -13.358267,17.539372 -2.374016,34.015752 6.200788,-13.8189 6.909449,-15.87402 2.374016,-34.015752 z' id='72-6-3-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 14.846457,52.263781 C 20.834646,55.240159 31.429134,50.704726 37.594488,70.901577 21.755905,66.614175 22.429134,68.314963 14.846457,52.263781 z' id='73-4-8-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 19.629921,66.472443 C 25.830708,68.988191 37.133858,64.062994 42.874015,83.055121 26.362205,79.830711 27,81.425199 19.629921,66.472443 z' id='74-8-2-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 25.015748,78.944884 C 31.464567,81.77953 43.15748,76.677168 49.3937,97.157483 32.173228,93.401578 32.846456,95.137798 25.015748,78.944884 z' id='75-2-39-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 30.968504,96.66142 c 6.094488,0.389764 17.291338,-9.283465 24.590551,16.26378 -11.76378,0.56693 -13.216536,-7.47638 -24.590551,-16.26378 z' id='76-1-4-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 41.350393,109.94882 c 8.610237,1.02756 12.614174,-1.34645 19.807087,18.6378 -13.464567,-4.85433 -12.862205,-3.22441 -19.807087,-18.6378 z' id='77-6-85-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 102.29527,0.53149608 C 111.01181,14.42126 116.14961,14.952756 110.44488,34.086615 100.55905,24.094489 101.19685,16.901575 102.29527,0.53149608 z' id='78-8-1-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 122.63386,11.657481 c -6.51969,7.192913 -15.69685,10.169291 -11.09055,32.314961 11.76378,-10.488189 10.38189,-11.870079 11.09055,-32.314961 z' id='79-3-3-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 123.41338,33.767718 c -8.4685,6.23622 -15.98031,6.838582 -11.37401,26.220473 7.61811,-9.602363 10.62992,-8.291339 11.37401,-26.220473 z' id='80-1-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 125.00787,45.708663 c -6.51968,7.051181 -15.66141,9.992126 -11.09055,31.677166 11.76378,-10.240158 10.38189,-11.622048 11.09055,-31.677166 z' id='81-4-8-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 127.73622,63.141734 c -7.58268,6.80315 -18.17717,9.56693 -12.86221,30.614174 13.07481,-11.338583 7.08662,-15.129921 12.86221,-30.614174 z' id='82-8-1-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 128.23228,80.503939 c -7.12204,6.555119 -17.92913,9.602363 -12.93307,29.905511 10.09843,-9.63779 11.44488,-11.161416 12.93307,-29.905511 z' id='83-4-6-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 95.173228,17.681103 C 99.81496,23.279528 111.04724,24.200788 110.44488,45.67323 97.086613,34.122048 97.15748,36.000001 95.173228,17.681103 z' id='84-9-4-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 95.137795,32.98819 c 4.960625,5.279528 17.007875,6.200788 16.370075,26.291339 C 97.192913,48.401576 97.263779,50.17323 95.137795,32.98819 z' id='85-2-6-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 96.200787,46.94882 c 5.102363,5.704725 17.574803,6.661418 16.901573,28.381891 C 98.326771,63.602364 98.362204,65.51575 96.200787,46.94882 z' id='86-0-77-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 96.129921,66.011813 C 101.69291,69.307089 115.12205,65.834648 113.88189,92.692916 102.7559,87.555121 103.96063,79.511813 96.129921,66.011813 z' id='87-7-9-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 101.58661,83.16142 c 7.68898,5.066929 12.15355,4.818898 12.50788,26.53937 -10.94882,-10.913385 -10.87796,-9.14173 -12.50788,-26.53937 z' id='88-0-6-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 91.098425,94.00394 c -1.311024,0.637795 -2.586615,1.346457 -3.897638,2.090551 16.370083,82.523629 20.196853,158.704729 18.779523,257.669299 0.46063,0.0354 0.92126,0.0709 1.38189,0.14173 l 1.87796,-0.42519 c 2.37401,-88.29922 0,-174.57875 -18.141735,-259.47639 z' id='89-6-4-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 63.141732,11.586615 C 73.948818,23.031497 79.051181,22.251969 76.677165,42.519686 65.338582,35.18504 64.807086,27.992127 63.141732,11.586615 z' id='90-0-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 84.826771,17.362205 C 79.653543,26.114174 71.220472,31.358269 79.334645,51.980317 89.07874,38.692915 87.519684,37.665355 84.826771,17.362205 z' id='91-7-9-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 89.255905,38.940946 c -7.228347,8.255906 -14.456693,10.736221 -6.767717,28.629922 5.846457,-11.374016 9,-10.84252 6.767717,-28.629922 z' id='92-0-2-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 92.799212,50.279529 c -5.208661,8.574803 -13.641732,13.748032 -5.598425,33.90945 9.779527,-13.039371 8.185039,-14.031497 5.598425,-33.90945 z' id='93-5-6-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 98.326771,66.720474 C 92.055117,75.295278 82.204724,80.716538 90.850393,100.02756 101.72835,85.606302 95.279527,83.374018 98.326771,66.720474 z' id='94-6-3-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 101.69291,83.62205 c -5.881887,8.255905 -15.909446,13.96063 -7.653541,32.66929 8.255901,-12.01181 9.283461,-13.85433 7.653541,-32.66929 z' id='95-7-1-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 59.066929,30.259843 c 5.42126,4.322835 16.547244,2.409449 19.488189,23.633859 C 63.637795,45.921261 63.992126,47.763781 59.066929,30.259843 z' id='96-3-5-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 61.547244,45.283466 C 67.251968,49.216537 79.15748,47.090553 81.850393,67.039372 66.082677,59.952758 66.437007,61.653545 61.547244,45.283466 z' id='97-8-9-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 64.913385,58.748033 c 5.917323,4.322835 18.212599,2.125985 21.153544,23.633859 C 69.69685,74.586616 70.086614,76.429136 64.913385,58.748033 z' id='98-4-7-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 67.996062,77.492128 c 5.952756,1.84252 18.496063,-4.96063 21.720473,21.755906 C 78.023621,97.015751 77.846456,88.795278 67.996062,77.492128 z' id='99-9-0-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 76.145669,92.976381 c 8.326771,3.011811 12.649606,1.665354 16.582677,22.925199 -12.472441,-7.97244 -12.11811,-6.23622 -16.582677,-22.925199 z' id='100-2-2-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 54.637795,124.58268 c -0.496063,0.56693 -0.992126,1.13386 -1.488189,1.73622 19.38189,47.94095 24.838582,87.23622 21.082677,127.24016 0,0 0,0.0354 0,0.0709 -0.708661,26.18504 -3.933071,54.35433 -9.354331,85.2874 1.38189,0.81496 2.76378,1.55906 4.110236,2.30315 l 0.779528,0.28347 C 85.039369,252.9567 83.586614,187.54725 54.637795,124.58268 z' id='101-6-6-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 71.114173,107.85827 c -1.204725,1.06299 -2.444882,2.16142 -3.649607,3.29528 22.181103,73.13386 25.228347,140.56299 22.03937,238.88977 l 2.940945,0.99212 c 0.425197,0.1063 0.850394,0.2126 1.275591,0.3189 4.216535,-100.06299 1.488189,-170.00788 -22.606299,-243.49607 z' id='102-5-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 31.003937,24.980316 c 12.047244,9.354331 16.972441,7.653543 17.07874,28.169292 C 36.035433,47.976379 34.61811,40.925198 31.003937,24.980316 z' id='103-7-7-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 53.07874,26.716536 C 49.03937,36.318899 41.350393,43.122049 51.874015,62.043309 59.881889,47.090553 58.181102,46.381891 53.07874,26.716536 z' id='104-7-6-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 60.059055,47.303151 c -6.129922,9.496063 -12.933071,13.287402 -3.22441,29.622048 4.429134,-12.330709 7.582677,-12.401575 3.22441,-29.622048 z' id='105-4-2-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 64.913385,57.862206 C 60.803149,67.322837 53.114173,74.05512 63.496063,92.551184 71.574803,77.811026 69.909448,77.102365 64.913385,57.862206 z' id='106-5-53-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 72.35433,73.169294 C 67.216535,82.807089 58.145669,90.000003 69.023622,107.57481 77.988188,91.275593 71.362204,90.248034 72.35433,73.169294 z' id='107-7-4-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 77.704724,89.326774 c -4.783465,9.248032 -13.96063,16.759846 -3.57874,33.803146 6.69685,-13.46456 7.476378,-15.48425 3.57874,-33.803146 z' id='108-9-0-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 29.232283,44.255907 c 5.88189,3.295276 16.61811,-0.673229 22.074803,19.84252 C 35.645669,58.925199 36.212598,60.696852 29.232283,44.255907 z' id='109-8-7-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 33.519685,58.7126 C 39.614173,61.547246 51.094488,57.224411 56.161417,76.500002 39.755905,72.389766 40.322834,74.019687 33.519685,58.7126 z' id='110-3-5-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 38.444882,71.433073 C 44.787401,74.622049 56.692913,70.157482 62.185039,90.956696 45.106299,86.244097 45.708661,88.015751 38.444882,71.433073 z' id='111-0-5-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 43.759842,89.468507 C 49.85433,90.177168 61.370078,81.106302 67.783464,107.00788 55.984252,106.93701 54.850393,98.822838 43.759842,89.468507 z' id='112-2-3-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 53.681102,103.2874 c 8.574803,1.48819 12.649606,-0.67322 19.133858,19.66536 -13.287401,-5.59843 -12.720472,-3.93307 -19.133858,-19.66536 z' id='113-2-18-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 0.49606299,46.700789 C 13.641732,53.362206 18.212598,50.63386 21.188976,70.901577 8.6456692,68.350396 6.2716535,61.688978 0.49606299,46.700789 z' id='114-3-8-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 22.429134,43.688978 c -2.657481,10.38189 -9.248032,18.708662 3.720472,35.18504 5.775591,-16.511811 4.003937,-16.866142 -3.720472,-35.18504 z' id='115-6-8-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 32.137795,62.539372 C 27.425197,73.24016 21.295275,78.448821 33.129921,92.515751 35.716535,79.370081 38.834645,78.625987 32.137795,62.539372 z' id='116-7-0-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 38.374015,71.964569 C 35.681102,82.204727 29.090551,90.460633 41.846456,106.51181 47.692913,90.212601 45.956693,89.893703 38.374015,71.964569 z' id='117-1-17-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 47.834645,85.464569 C 44.149606,96.129924 36.248031,105.16536 49.358267,120.18898 55.877952,102.15355 49.251968,102.57874 47.834645,85.464569 z' id='118-5-5-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 55.346456,100.31103 c -3.401574,10.16929 -11.374015,19.55905 1.204725,34.15748 4.677165,-14.70473 5.173228,-16.86614 -1.204725,-34.15748 z' id='119-5-0-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 1.4527559,66.082679 C 7.6889763,68.102364 17.681102,61.901577 25.901575,81.000002 9.7795275,79.263782 10.629921,80.85827 1.4527559,66.082679 z' id='120-4-5-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 7.6889763,79.47638 C 14.066929,81.000002 24.732283,74.267719 32.385827,92.232286 15.732283,91.665357 16.511811,93.188979 7.6889763,79.47638 z' id='121-0-90-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 14.279527,91.027562 c 6.696851,1.771653 17.751969,-5.173229 26.043307,14.208658 -17.43307,-0.99212 -16.582677,0.60237 -26.043307,-14.208658 z' id='122-2-9-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 22.03937,107.68111 C 28.098425,107.07874 38.161417,95.704727 48.082677,119.90552 36.496063,122.3504 34.228346,114.59055 22.03937,107.68111 z' id='123-6-3-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 33.69685,119.23229 c 8.610236,-0.35433 12.330709,-3.36614 21.543307,15.37795 -13.818897,-2.69291 -13.03937,-1.16929 -21.543307,-15.37795 z' id='124-0-5-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 139.6063,93.54331 c -18.8504,84.50788 -21.50788,171.88583 -19.66536,260.68111 1.45276,-0.0709 2.90552,-0.17717 4.35827,-0.35433 -0.77953,-99.92126 2.40945,-175.9252 19.24016,-258.200796 -1.31102,-0.744094 -2.62205,-1.488189 -3.93307,-2.125984 z' id='125-6-42-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 167.56299,14.492126 c -10.87795,10.84252 -15.94488,9.779528 -13.7126,30.188978 11.37402,-6.696851 11.97638,-13.889764 13.7126,-30.188978 z' id='126-1-7-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 145.84252,19.062993 c 5.13779,9.035433 13.53543,14.740158 5.27953,34.901576 -9.67323,-13.818899 -8.07874,-14.740158 -5.27953,-34.901576 z' id='127-1-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 141.30709,40.393702 c 7.19291,8.64567 14.38582,11.515748 6.59055,28.984253 -5.81103,-11.657481 -8.96457,-11.338583 -6.59055,-28.984253 z' id='128-1-6-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 137.69291,51.519687 c 5.1378,8.858268 13.57087,14.527559 5.38583,34.228347 -9.70866,-13.6063 -8.11417,-14.492126 -5.38583,-34.228347 z' id='129-7-7-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 132.05905,67.641734 c 6.20079,8.929134 16.05119,14.881891 7.26378,33.732286 C 128.55118,86.350396 135,84.507877 132.05905,67.641734 z' id='130-3-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 128.62205,84.366144 c 5.77559,8.610237 15.80315,14.846457 7.44094,33.094486 -8.18504,-12.47244 -9.2126,-14.38582 -7.44094,-33.094486 z' id='131-0-2-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 171.53149,33.377954 c -5.45669,4.03937 -16.54724,1.488189 -19.62992,22.570867 C 166.88976,48.79134 166.5,50.598427 171.53149,33.377954 z' id='132-0-0-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 168.94488,48.295277 c -5.70472,3.614173 -17.61024,0.814961 -20.40945,20.586615 15.80315,-6.200788 15.41339,-4.5 20.40945,-20.586615 z' id='133-4-1-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.54331,61.582679 c -5.95276,3.933071 -18.24804,1.062992 -21.33071,22.429135 16.40551,-6.874016 16.01575,-5.06693 21.33071,-22.429135 z' id='134-8-1-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 162.3189,80.114176 c -5.95276,1.523622 -18.46063,-5.98819 -21.82678,20.551184 11.69292,-1.594491 11.90552,-9.779531 21.82678,-20.551184 z' id='135-3-75-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 154.06299,95.137798 c -8.32677,2.586614 -12.64961,0.956693 -16.72441,22.003942 12.54331,-7.26378 12.18898,-5.563 16.72441,-22.003942 z' id='136-0-9-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 159.34252,107.46851 c -25.97244,72.46063 -29.44488,142.51181 -23.38583,244.38189 1.94882,-0.49606 3.89764,-1.02755 5.84646,-1.62992 -6.69685,-103.03937 -3.36614,-168.98032 20.72834,-239.77559 -1.06299,-1.02756 -2.12598,-2.01969 -3.18897,-2.97638 z' id='137-1-18-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 199.62992,29.692914 c -12.11811,8.681103 -17.00787,6.696851 -17.25591,27.2126 12.08268,-4.500001 13.53544,-11.480316 17.25591,-27.2126 z' id='138-2-1-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 177.51968,30.188977 c 4.00394,9.850394 11.65748,17.043308 1.02756,35.397639 -7.90157,-15.413386 -6.23622,-16.051181 -1.02756,-35.397639 z' id='139-9-7-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 170.4685,50.385828 c 6.05906,9.850394 12.82677,13.996064 3.01181,29.799214 C 169.15748,67.606301 165.9685,67.35827 170.4685,50.385828 z' id='140-0-8-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.50787,60.696852 c 4.03937,9.673229 11.69292,16.795276 1.20473,34.724411 -7.97244,-15.200788 -6.27166,-15.767717 -1.20473,-34.724411 z' id='141-3-6-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 157.99606,75.543309 c 5.06693,9.956694 14.10236,17.64567 3.11811,34.582681 -8.85827,-16.795279 -2.23228,-17.433074 -3.11811,-34.582681 z' id='142-8-6-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 152.53937,91.417326 c 4.7126,9.531494 13.85433,17.539374 3.36614,33.980314 -6.59055,-13.8189 -7.37008,-15.87401 -3.36614,-33.980314 z' id='143-8-9-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 201.25984,49.039372 c -5.88189,2.976378 -16.58268,-1.594489 -22.1811,18.602362 15.69685,-4.251968 15.09449,-2.551181 22.1811,-18.602362 z' id='144-5-9-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 196.90157,63.283466 c -6.09448,2.480315 -17.53937,-2.480315 -22.74803,16.511812 16.44095,-3.188977 15.83858,-1.594488 22.74803,-16.511812 z' id='145-7-2-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 191.90551,75.720475 c -6.37795,2.799212 -18.2126,-2.267717 -23.84646,18.177166 17.11418,-3.720473 16.47638,-2.019686 23.84646,-18.177166 z' id='146-7-6-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 186.48425,93.437011 c -6.09449,0.389763 -17.5748,-9.318898 -24.12992,16.228349 11.79921,0.56693 13.00394,-7.47638 24.12992,-16.228349 z' id='147-0-65-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 176.49212,106.72441 c -8.5748,0.99213 -12.68503,-1.38189 -19.24015,18.60237 13.2874,-4.85434 12.72047,-3.22441 19.24015,-18.60237 z' id='148-8-8-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 176.91732,126.17717 c -30.33071,65.62205 -27.74409,135.4252 -15.23622,215.68111 1.55906,-0.81496 3.08268,-1.66536 4.67717,-2.55118 -5.3504,-34.68898 -8.78741,-66.50788 -8.68111,-96.66142 0,-0.0709 0,-0.1063 0,-0.17717 -1.55905,-35.04331 4.14567,-70.54725 22.21654,-112.6063 -0.99213,-1.24016 -1.98425,-2.48032 -2.97638,-3.68504 z' id='149-9-40-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 229.99606,53.114175 c -13.1811,5.917323 -17.75197,2.940945 -20.83464,23.031497 12.5433,-1.84252 14.98818,-8.397638 20.83464,-23.031497 z' id='150-3-3-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 208.09842,48.897639 c 2.58662,10.48819 9.1063,19.169292 -3.9685,34.937009 -5.63386,-16.830709 -3.89764,-17.07874 3.9685,-34.937009 z' id='151-0-7-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 198.28346,67.181104 c 4.6063,10.94882 10.73622,16.511812 -1.20472,29.905513 -2.51575,-13.287402 -5.59843,-14.208662 1.20472,-29.905513 z' id='152-7-83-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 191.94094,76.251971 c 2.65748,10.38189 9.2126,18.992126 -3.6496,34.370079 -5.77559,-16.61811 -4.00394,-16.866142 3.6496,-34.370079 z' id='153-4-11-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 182.44488,89.220475 c 3.61417,10.842525 11.44488,20.338585 -1.77165,34.618115 -6.37796,-18.35433 0.24803,-17.57481 1.77165,-34.618115 z' id='154-7-25-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 174.82677,103.64174 c 3.33071,10.34645 11.26772,20.19685 -1.41732,34.08661 -4.6063,-14.95276 -5.06693,-17.14961 1.41732,-34.08661 z' id='155-8-7-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 228.93307,72.460632 C 222.69685,74.090553 212.74016,67.35827 204.37795,85.996066 220.5,85.145672 219.68504,86.704727 228.93307,72.460632 z' id='156-3-6-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 222.62598,85.464569 c -6.37795,1.169292 -17.00787,-6.129921 -24.80315,11.40945 16.68898,0.35433 15.87402,1.807086 24.80315,-11.40945 z' id='157-7-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 215.92913,96.66142 c -6.69685,1.38189 -17.6811,-6.165354 -26.11417,12.75591 17.43307,-0.0354 16.58268,1.52362 26.11417,-12.75591 z' id='158-1-1-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 208.09842,112.85433 c -6.05905,-0.92126 -16.05118,-12.862201 -26.11417,10.80709 11.55118,3.08268 13.88976,-4.57087 26.11417,-10.80709 z' id='159-0-6-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 196.33464,123.76772 c -8.61023,-0.85039 -12.29527,-4.0748 -21.61417,14.17323 13.85433,-1.94882 13.0748,-0.46063 21.61417,-14.17323 z' id='160-0-1-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 98.787401,218.16142 31.854329,0.88583 c 19.27559,0.5315 34.75984,5.95276 34.72441,12.18898 0,6.20078 -15.51968,10.77165 -34.79527,10.24016 l -31.854335,-0.88583 c -19.275591,-0.5315 -34.759843,-5.95276 -34.724409,-12.18898 0.03543,-6.20079 15.519684,-10.80709 34.795275,-10.24016 z' id='161-8-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 76.712598,217.52363 -9.531496,19.77165 c 1.488189,1.55906 3.366142,2.51575 5.456693,2.58662 l 5.740157,0.14173 10.700788,-22.14567 -12.366142,-0.35433 z m 24.803152,0.70866 -10.665357,22.14567 12.330707,0.35433 10.70079,-22.1811 -12.36614,-0.3189 z m 24.83858,0.67323 -10.70079,22.14567 12.33071,0.35433 10.70079,-22.14567 -12.33071,-0.35433 z m 24.80315,0.70866 -10.70079,22.14567 12.36614,0.35433 9.38977,-19.48819 c -1.55906,-1.73622 -3.54331,-2.79921 -5.74016,-2.87008 l -5.31496,-0.14173 z' id='162-3-5-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.46969353,-0.01273905,0.04093079,0.50219049,803.71591,468.85609)' id='g4771' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -123.17601,1511.6014 c 0.23144,-0.046 2.99626,43.3713 6.38193,64.5284 0.41442,2.5897 3.55058,4.092 4.25463,6.6183 0.76173,2.7334 -0.19697,5.6721 -0.23637,8.5093 -0.004,0.3151 0.0446,0.6335 0,0.9455 -0.55712,3.8998 -4.00031,7.4673 -3.30915,11.3456 0.39535,2.2185 3.14014,3.3612 4.01825,5.4365 5.10393,12.0625 4.03652,26.4702 6.38194,38.7643 0.98853,5.1816 -0.94899,-0.9973 8.272882,13.7093 0.92654,1.4776 4.96373,1.6546 4.96373,1.6546 l 4.01825,0.2364 3.75595,3.8794 -5.68267,5.1813 -17.549432,1.6713 -7.85545,-5.0141 c 0,0 2.47745,-4.2434 1.00282,-6.3512 -1.05729,-1.5113 -4.83543,-0.5041 -5.01412,-2.3399 -0.32732,-3.3627 -0.70146,-12.5292 -0.83569,-12.5353 -0.29976,-0.014 -0.15568,-0.5947 -0.33427,-0.8357 0,0 -12.7817,-14.6738 -17.21515,-23.2321 -2.29339,-4.4271 -2.14515,-9.9132 -4.67985,-14.2067 -1.62332,-2.7497 -5.22599,-4.0998 -6.51836,-7.0197 -10.74969,-24.2876 -21.52301,-71.1302 -21.56072,-70.8663' id='path4714-2' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -333.806,1500.4203 45.3034,11.3258 -18.0109,62.8923 c -9.68654,19.8578 -8.97583,20.5846 -6.87508,26.2701 4.41167,10.9269 7.0933,27.2799 23.61059,53.2557 5.97926,6.6123 12.86499,7.4045 15.18591,10.0906 0.97279,2.8355 6.14165,7.1141 10.6565,8.8815 l 14.519,0 c 2.68403,-3.2191 2.62922,-2.1473 3.45577,-4.5926 -0.80895,-2.9676 -7.805,-1.9463 -12.33036,-6.0217 -1.92962,-7.7089 -11.72338,-19.5628 -12.55764,-27.6732 -4.4535,-17.7184 -2.74541,-18.2363 0.12037,-36.2061 1.42758,-9.257 11.11157,-29.6689 14.98049,-40.7823 7.80135,-11.86 16.28497,-32.5258 16.47338,-47.4595 l -16.38305,-41.693 -10.19328,-16.9888' id='path4697-6' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -307.15125,1424.2896 c -75.62204,20.367 -49.74606,84.639 -28.88573,85.8659' id='path4668-3' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -80.845868,1319.762 12.8951,-22.825 1.44811,-8.4129 -0.89238,-1.7883 -21.49062,21.787 -0.37304,1.4472' id='path4634-7-4' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -41.126278,1358.0397 c 4.57429,1.7713 10.39704,3.5373 11.66777,0.9429 1.57373,-3.213 2.36186,-5.4865 -1.03125,-8.0937 -1.63062,-1.4672 1.22707,-3.6566 -0.46875,-7.8125 -12.19293,-8.8033 -21.05912,-9.2347 -23.65625,-16.0625 l -0.0937,-4.6875 c -0.1411,-5.9257 -18.51455,-8.837 -22.78125,-11.8438 0,0 -7.51511,-3.8381 -11.59375,-4.7812 -1.74301,-0.403 -5.375,-0.3438 -5.375,-0.3438 -18.854722,-0.6475 -29.122172,17.6895 -33.249992,28.9063 0,0 -8.19473,51.3768 -19.40625,74.4375 -1.02144,2.101 -2.51903,3.9937 -4.25,5.5625 -1.6829,1.5252 -3.55044,3.7976 -5.8125,3.5937 -51.97659,-4.6841 -87.39015,-7.783 -108.68751,-7.5937 -21.29735,0.1893 -46.88987,14.9836 -48.53125,16.625 0,0 -24.88611,13.8873 -32.125,37.4062 -2.41742,7.8542 -1.15612,17.2253 1.34375,26.5938 18.0636,63.0418 46.70491,0.9513 55.05988,1.9045 l 10.283,1.1731 c 12.0733,1.3773 31.41952,36.9186 64.99379,44.7758 101.33273,23.7143 134.013482,-26.0413 141.587042,-138.2646 l 1.39395,-1.5847 0,-3.8268 6.02721,-8.8016 0.0957,-12.4371 -1.33938,-5.9316 0.38268,-2.296 29.3707,-2.7745 5.1901,-2.033' id='path4656-6' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -88.423678,1324.949 14.75609,-26.1191 1.6571,-9.6269 -1.02117,-2.0465 -24.5921,24.9313 -0.42687,1.656' id='path4634-8' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -345.17726,1490.8889 c 4.98592,18.6852 15.28188,37.3886 13.84375,44.1875 -2.15919,10.2078 -8.70851,14.768 -9.25,15.7188 -0.4971,0.8728 -2.89814,2.1287 -3.6875,2.75 -3.41648,2.6888 -5.99683,8.2229 -7.78125,12.1875 -2.20066,4.8893 -3.57266,9.2813 -3.40625,14.125 0.6182,17.9942 8.41138,55.1426 8.9375,55.6875 0,0 5.94472,3.6118 7.4375,7.0625 1.52009,3.5137 0.62601,6.8382 0.0625,10.625 -0.77298,5.1939 -4.90625,16.7187 -4.90625,16.7187 0,0 0.0425,2.2538 0.6875,2.9375 1.80575,1.914 8.1875,5.3125 8.1875,5.3125 l 14,0 c 0,0 -7.1498,-7.5491 -7.59375,-9.2187 -0.49247,-1.8522 -0.68771,-3.2729 0.0313,-5.3438 1.32801,-3.8251 5.66749,-8.2962 7.15625,-10.5625 1.60322,-2.4406 0.65625,-8.9375 0.65625,-8.9375 0.0639,-2.3642 -1.87564,-3.4997 -1.9375,-4.5 -0.48155,-7.7856 -0.50724,-13.3977 -0.1875,-21.125 0.28211,-6.8181 3.28125,-27.1871 3.28125,-27.1875 0,0 3.54279,-2.5474 5,-4.1562 1.32233,-1.46 3.3125,-4.9063 3.3125,-4.9063 0,0 17.68542,-8.6651 25.46875,-14.5937 9.23057,-7.031 24.71875,-24.5 24.71875,-24.5 0,0 4.63502,-7.1263 5.59376,-11.1875 0.32527,-1.3779 0.20692,-2.8495 0,-4.25 -1.12313,-7.6017 -3.52143,-15.0922 -6.68751,-22.0938 -3.07498,-6.8002 -6.77122,-13.497 -11.8125,-19 -0.51966,-0.5672 -1.84375,-1.375 -1.84375,-1.375' id='path4683-6' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -126.06058,1534.2453 c -14.58858,8.2365 -47.98384,14.4606 -49.04788,20.6494 0,0 -4.35035,38.834 -10.43697,54.2213 -2.39884,6.0645 -5.65204,7.7702 -8.58348,13.5959 -3.05235,6.0659 -3.30483,10.7534 -6.01758,16.7989 -2.90132,6.4656 -7.60144,12.2128 -9.19609,23.5025 l -0.47317,9.4004 9.567,5.8359 -10.71504,3.0614 -15.78556,-6.5055 -0.0957,-14.3505 4.8792,-14.7332 0.38268,-2.3918 -3.25278,-9.0886 0.19134,-32.3365 4.87917,-24.0132 4.11381,-88.6861' id='path4691-0' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -83.288438,1362.8333 c 6.11313,5.096 14.4676,8.511 34.70603,3.013 3.56879,2.3579 7.33667,5.2783 16.68354,-5.3645' id='path4654-8' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -39.673538,1347.5299 c 0.13031,-0.1303 3.59581,2.4702 4.95531,2.5026 1.05939,0.025 2.55912,-1.9663 1.75188,-2.6528 -0.8853,-0.7529 -2.56781,-1.6184 -3.45371,-1.1012 -1.28631,0.751 -3.2258,1.4728 -3.25348,1.2514 z' id='path4704-5' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -75.359368,1333.3786 c 0,0 1.86715,0.1 2.42635,1.5688 1.89311,4.9735 7.51586,5.9584 12.47014,0.8886 0.6267,-0.6413 2.10846,-1.4988 2.26948,-1.5203 -0.90746,-0.094 -1.51684,-0.029 -2.18914,-0.7303 -4.60698,-4.8065 -10.13522,-0.9803 -11.89158,-0.6893 -1.15213,0.1909 -1.9682,0.3611 -3.08525,0.4825 z' id='path4706-2' style='fill:%23000000;fill-opacity:1;stroke:none' /%3E %3C/g%3E %3Cg transform='matrix(3.543307,0,0,3.543307,435.43162,920.19831)' id='g5254' style='fill-rule:evenodd;stroke:%23e3e4e5;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg id='Capa_x0020_1' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cmetadata id='CorelCorpID_0Corel-Layer' /%3E %3Cg id='_109262760' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 148.412,101.384 c 0.001,0.006 0.002,0.012 0.003,0.0182 -0.1998,1.0256 -0.1876,1.8516 -0.0488,2.5598 -0.1853,0.9301 -0.1988,1.8278 -0.0469,2.5809 -0.1564,0.8216 -0.1891,1.6404 -0.0418,2.4575 -0.1445,0.8103 -0.1567,1.5859 -0.0368,2.3266 0.8486,0.6497 3.2535,0.7263 4.329,0.1377 0.1293,-0.7389 0.1271,-1.6285 -0.007,-2.4407 0.1579,-0.8149 0.1356,-1.6339 -0.0103,-2.4578 0.1616,-0.751 0.1596,-1.6488 -0.0137,-2.5815 0.1479,-0.7062 0.1705,-1.5318 -0.016,-2.5601 0.1409,-0.7876 0.1497,-1.6597 -0.0189,-2.6656 0.142,-0.7983 0.1471,-1.6501 -0.0198,-2.5685 0.15,-0.7838 0.1417,-1.6692 -0.0221,-2.6657 10e-4,-0.0079 0.002,-0.0157 0.003,-0.0238 0.1228,-0.7907 0.1271,-1.6798 -0.0191,-2.6897 0.15,-0.9586 0.1321,-1.8479 -0.021,-2.7216 0.1313,-0.8287 0.1401,-1.709 -0.019,-2.6901 0.1541,-0.7879 0.1506,-1.658 -0.019,-2.6899 0.2222,-0.8376 0.1332,-1.8897 -0.027,-2.7197 -7e-4,-0.0033 -0.001,-0.0067 -0.002,-0.01 0.1408,-0.9741 0.131,-1.8534 -0.011,-2.6818 0.142,-0.8945 0.1418,-1.7902 -0.0191,-2.69 0.1065,-0.891 0.095,-1.7934 -0.0209,-2.7217 0.115,-0.8854 0.0978,-1.7527 -0.0298,-2.6859 0.1036,-0.8137 0.1088,-1.6953 -0.0298,-2.6872 0.1224,-0.8544 0.1602,-1.7617 5e-4,-2.7282 0.122,-0.8749 0.1114,-1.773 -0.031,-2.6936 0.1214,-0.8344 0.1278,-1.722 -0.0331,-2.6865 0.1453,-0.9655 0.117,-1.8343 -0.0293,-2.6359 0.1144,-0.8924 0.1077,-1.5449 0.004,-2.4365 0.0227,-0.2727 0.004,-0.7862 -0.0282,-1.0589 l -2.7146,-0.0391 c -0.1153,0.1874 -0.1488,0.5635 -0.0742,1.0697 -0.1343,0.3875 -0.1279,2.0617 0.0288,2.4521 -0.1565,0.7995 -0.196,1.6677 -0.0631,2.6353 -0.1733,0.9621 -0.1782,1.8498 -0.0675,2.6857 -0.1544,0.9184 -0.1765,1.8163 -0.0657,2.6929 -0.172,0.9641 -0.1459,1.8721 -0.0344,2.728 -0.1515,0.9898 -0.1575,1.8713 -0.0643,2.6865 -0.1395,0.9313 -0.1679,1.7983 -0.0644,2.6853 -0.1277,0.9263 -0.151,1.8286 -0.0558,2.721 -0.1725,0.8975 -0.184,1.793 -0.0536,2.6895 -0.1527,0.8264 -0.1736,1.7053 -0.0455,2.6815 -0.1721,0.829 -0.2762,1.8846 -0.0639,2.7289 -0.1829,1.0294 -0.1974,1.8994 -0.0536,2.6894 -0.1717,0.9787 -0.1741,1.859 -0.0536,2.6894 -0.1641,0.8715 -0.1935,1.7605 -0.056,2.7212 -0.1606,1.0177 -0.1662,1.9144 -0.0509,2.7131 -0.1766,0.9939 -0.1964,1.8792 -0.0564,2.6649 -0.1788,0.9161 -0.1847,1.7678 -0.0529,2.5681 -0.18,0.9956 -0.1838,1.862 -0.0559,2.6468 z' id='_112166136' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.382,103.934 c 1.0008,0.4629 3.5561,0.3827 4.1563,0.0749' id='_112703888' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.361,101.364 c 0.9553,0.4061 3.2354,0.3849 4.161,0.0771' id='_105428400' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.488,98.6745 c 0.9251,0.4628 3.1199,0.3438 4.0152,0.0764' id='_122805528' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.541,96.1225 c 1.0234,0.4629 3.2513,0.3361 3.9423,0.0687' id='_113328848' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.591,93.4895 c 1.0993,0.3135 3.0265,0.3013 3.873,0.0118' id='_140461728' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.643,90.7981 c 1.1325,0.2708 2.899,0.2807 3.8024,0.0133' id='_111252504' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.695,88.0713 c 1.0336,0.2638 3.0258,0.2797 3.7289,0.0185' id='_127192920' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.747,85.3975 c 0.8973,0.2881 2.7881,0.2636 3.6576,0.0024' id='_99199072' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.823,82.6992 c 1.1464,0.278 2.7328,0.3013 3.5628,0.0108' id='_57974072' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.876,79.9675 c 1.1659,0.2763 2.8197,0.2436 3.4889,0.0209' id='_139695576' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.917,77.2849 c 1.1524,0.2594 2.9598,0.1655 3.4287,0.0136' id='_108876192' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.983,74.6633 c 1.074,0.1956 2.8846,0.094 3.3441,-0.0548' id='_104468904' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.038,71.8798 c 1.0566,0.2852 2.8129,0.1544 3.2678,0.0071' id='_108959488' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.108,69.2544 c 1.0069,0.2579 2.5911,0.1525 3.1786,-0.0574' id='_109312288' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.19,66.5129 c 0.9896,0.2148 2.6421,0.1353 3.0781,-0.0058' id='_109287888' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.23,63.8084 c 0.9872,0.2041 2.5899,0.1153 3.0165,-0.0229' id='_85988992' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.324,61.1244 c 1.0745,0.1317 2.4438,0.1188 2.8517,-0.0133' id='_144371400' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.388,58.3767 c 0.8915,0.1886 2.3753,0.172 2.7692,0.0445' id='_142302024' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.446,55.7443 c 0.972,0.1544 2.3143,0.1447 2.6988,0.0201' id='_90888000' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.34,53.3045 c 0.7285,0.0748 2.5167,0.1256 2.8168,0.0284' id='_108984096' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.336,106.486 c 1.0151,0.4629 3.6068,0.3827 4.2156,0.0749' id='_59547952' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.286,108.933 c 1.0295,0.4629 3.6581,0.3827 4.2756,0.0748' id='_109262800' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg id='Capa_x0020_2' style='stroke:%23e7e7e7;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cmetadata id='CorelCorpID_1Corel-Layer' /%3E %3Cg id='_110261640' style='stroke:%23e7e7e7;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 156.59,46.9239 c 1.641,-0.3606 4.002,-0.4093 7.2607,-0.4954 -0.7856,-0.262 -1.6572,-0.5327 -2.9631,-0.8798 1.9041,-0.2637 6.4373,-0.2046 7.5997,-0.2155 -0.7872,-0.4813 -2.74,-1.2517 -3.2598,-1.3573 2.4932,-0.4114 5.4714,-0.0178 7.5678,0.3184 -0.9789,-0.549 -2.085,-1.2572 -3.4878,-1.6389 2.9929,-0.2051 4.1802,0.0358 6.9571,0.4088 -0.379,-0.3405 -1.6692,-1.275 -3.0335,-1.6643 3.3264,-0.609 5.1915,-0.7379 8.4519,-0.4753 -9.4178,-4.3096 -20.8446,-2.0676 -27.7226,2.6729 0.6897,-1.0807 2.1764,-2.7222 3.6274,-3.9598 -0.7347,-0.0585 -1.4326,-0.0406 -2.3817,0.1315 1.0076,-1.1044 2.903,-2.5798 4.1867,-3.0898 -0.9372,-0.0498 -1.7292,-0.0693 -2.5711,0.0969 1.262,-1.1721 3.1661,-2.4108 4.7833,-3.2349 -0.9599,-0.0882 -1.9404,-0.1071 -2.8922,0.0666 1.2755,-1.5013 3.5045,-3.0372 5.4747,-3.9739 -1.2831,-0.0211 -2.0731,0.0228 -3.2192,0.2485 1.6388,-1.4948 3.8304,-3.0616 6.7123,-4.5169 -11.4225,1.2793 -17.7283,9.5146 -18.2653,16.489 -3.0443,-6.5629 -11.3354,-12.8399 -22.7498,-12.3613 3.4076,1.0389 6.1151,2.3042 8.2234,3.5851 -1.268,-0.0487 -2.1115,0.0331 -3.4618,0.261 2.3172,0.6508 5.0556,1.8787 6.7816,3.2235 -1.0487,-0.0249 -2.0779,0.1516 -3.0686,0.398 1.9144,0.5912 4.2354,1.563 5.8628,2.5716 -0.9306,-0.0368 -1.7612,0.111 -2.7379,0.3135 1.4835,0.32 3.8559,1.5387 5.1986,2.5181 -1.046,-0.0249 -1.7861,0.0682 -2.5468,0.2479 3.4347,1.3395 3.6545,1.9437 4.4125,2.3979 -7.1243,-1.523 -17.4219,0.8294 -25.3393,10.0274 1.1488,-0.9686 6.0518,-2.7942 7.6088,-3.2133 -0.8115,0.9713 -1.0925,1.4813 -1.7346,2.7 1.7801,-1.4385 4.4682,-2.6258 7.0323,-3.6474 -0.5398,0.8175 -1.1256,1.8808 -1.3958,2.5614 1.8668,-1.1559 2.4358,-1.3227 6.2581,-3.1402 -0.2761,0.4672 -1.0373,1.4813 -1.4011,2.4439 1.1678,-0.6654 3.943,-1.6789 5.8244,-2.3551 0.1289,-0.0476 -1.1321,1.0325 -1.7022,2.3259 0.4294,-0.1619 3.0389,-1.1056 3.138,-1.1326 -6.0242,4.2067 -10.5157,11.2644 -9.6061,19.8489 0.3476,-1.3421 1.9393,-5.1958 2.8413,-6.7367 -0.0991,1.0222 0.1326,2.7173 0.3205,3.4753 0.8868,-2.5636 1.8619,-4.6079 3.3155,-6.8287 -0.1202,1.3703 -0.0871,2.8824 0.1013,3.5039 0.8121,-1.896 1.4526,-3.524 3.4433,-7.0339 -0.1288,0.523 -0.1565,2.0032 -0.0352,3.3112 0.6594,-1.4444 2.1905,-4.2922 3.6859,-6.3988 -0.0736,0.7753 -0.2139,2.0871 -0.1554,2.6323 0.1586,-0.2772 0.6308,-1.0536 1.1797,-1.9215 0.856,-1.3518 1.8993,-2.9246 2.2393,-3.1775 0.262,0.2642 0.5105,0.588 0.7433,0.96 0.9372,1.504 1.6085,3.8028 1.8175,6.1833 0.5003,-1.1683 0.7158,-2.3594 0.7791,-2.9891 1.0687,2.3909 2.2739,6.1309 2.36,8.1915 0.3595,-1.0937 0.5452,-1.7747 0.6746,-3.4872 1.1136,1.7877 2.0833,6.191 2.1732,8.1021 0.4331,-0.7482 0.7915,-1.6832 1.0525,-3.079 1.0903,2.4618 1.5208,5.5251 1.785,7.6387 2.7979,-10.1811 -1.2176,-16.7624 -6.1125,-21.7845 1.2312,0.6676 2.7882,2.0384 4.3101,3.6897 -0.1391,-0.7688 -0.5619,-2.2349 -0.9068,-3.0064 1.8094,1.2864 4.4763,3.9365 5.2191,4.701 -0.1278,-1.0065 -0.2718,-1.5392 -0.804,-2.8234 2.1353,1.4796 4.0416,4.0134 5.1223,5.4097 -0.0872,-0.6437 -0.2594,-1.8522 -0.7033,-3.2414 1.9479,1.4564 3.8878,4.3816 4.7714,6.0302 -0.0233,-1.1272 -0.3389,-2.3194 -0.6042,-3.5479 2.6523,2.242 3.6322,4.6139 4.4703,6.047 0.0212,-9.1931 -10.618,-17.463 -20.5056,-18.3249 z' id='_109373744' style='fill:%23007934;fill-opacity:1;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg id='g5212' style='stroke:%23e7e7e7;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 152.494,47.0175 c 10.7792,-1.5406 24.6254,7.7441 24.6017,18.2311 -0.8387,-1.4332 -1.8186,-3.8049 -4.4718,-6.0474 0.2667,1.2291 0.5817,2.4215 0.6047,3.5484 -0.8831,-1.6491 -2.8229,-4.5741 -4.7717,-6.0305 0.4442,1.3894 0.6171,2.5982 0.7045,3.2425 -1.081,-1.3973 -2.9874,-3.9313 -5.1233,-5.4106 0.5328,1.2845 0.6766,1.8168 0.8042,2.8246 -0.7428,-0.7657 -3.4095,-3.4161 -5.219,-4.7026 0.3453,0.7721 0.7678,2.2384 0.9073,3.0067 -1.5224,-1.6517 -3.0793,-3.0219 -4.3106,-3.6896' id='_57651880' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 150.079,46.8892 c -6.4528,-4.1578 -20.1473,-3.4016 -30.0886,8.1482 1.1479,-0.9684 6.051,-2.7939 7.6087,-3.2137 -0.8119,0.9714 -1.0931,1.4818 -1.7348,2.7001 1.7803,-1.4389 4.4681,-2.6253 7.0318,-3.6473 -0.5399,0.8177 -1.1256,1.8809 -1.3948,2.5612 1.8658,-1.1564 2.435,-1.3222 6.2572,-3.1401 -0.2765,0.4675 -1.0379,1.4814 -1.4005,2.4443 1.1664,-0.6654 3.9423,-1.6794 5.8234,-2.3561 0.1298,-0.0468 -1.1319,1.0335 -1.7016,2.3271 0.4289,-0.1625 3.0397,-1.1052 3.1378,-1.1332' id='_109373784' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 150.512,45.2491 c -1.3704,-7.5872 -10.4595,-16.3174 -23.8474,-15.7566 3.4078,1.0396 6.1159,2.305 8.2232,3.5854 -1.2671,-0.0487 -2.1108,0.0336 -3.4605,0.2617 2.3154,0.6502 5.0548,1.8781 6.7804,3.223 -1.0482,-0.0248 -2.0775,0.1522 -3.0682,0.3986 1.9138,0.5901 4.2352,1.5628 5.8626,2.571 -0.9302,-0.0367 -1.7612,0.1113 -2.7376,0.3137 1.4838,0.3203 3.8554,1.5387 5.1984,2.518 -1.046,-0.0248 -1.7867,0.0689 -2.5469,0.248 3.4341,1.339 3.655,1.9436 4.4116,2.3988' id='_59500704' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 150.417,48.2445 c -8.969,2.7373 -17.6366,11.5624 -16.405,23.1839 0.3472,-1.3414 1.939,-5.1962 2.8405,-6.7364 -0.0984,1.0224 0.1327,2.7171 0.3206,3.474 0.8869,-2.5625 1.862,-4.6073 3.3151,-6.8279 -0.1195,1.3709 -0.086,2.8828 0.102,3.5054 0.8123,-1.8966 1.4515,-3.5244 3.4431,-7.0351 -0.1292,0.5229 -0.1565,2.0028 -0.0352,3.3114 0.6594,-1.4442 2.1904,-4.2923 3.6858,-6.3991 -0.0737,0.7753 -0.2132,2.0876 -0.1559,2.6319 0.4074,-0.7082 2.861,-4.6842 3.4196,-5.0985' id='_114147888' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 145.367,52.8151 c -0.6246,1.7686 -1.1355,3.6773 -1.3336,4.9933' id='_109396888' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 142.088,55.0574 c -0.6088,1.577 -1.3598,4.4486 -1.6004,6.2807' id='_57647160' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 138.793,58.196 c -0.8961,2.0169 -1.7003,4.9316 -1.9405,6.496' id='_61202400' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cline y2='50.181301' x2='150.98199' y1='52.254101' x1='150.94701' class='fil1 str2' id='_108003056' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 160.236,61.2899 c 0.2745,1.6367 0.4089,2.4981 0.3102,4.8457' id='_109350400' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 156.826,55.6296 c 0.3532,1.8278 0.5013,3.0374 0.4962,5.483' id='_109347792' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 153.65,51.9621 c 0.3935,1.1276 0.6335,2.5775 0.6362,4.4475' id='_137236192' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 170.618,55.049 c 1.195,1.5373 1.7758,3.2643 2.0067,4.1521' id='_137234560' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.768,51.6804 c 1.1715,1.3802 2.3138,3.8331 2.689,5.0386' id='_137232928' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 161.695,50.3172 c 1.0078,1.3133 1.6963,2.7045 2.3433,4.2339' id='_276224976' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 127.599,51.8237 c 1.1065,-1.18 2.8274,-2.8354 5.9497,-4.1123' id='_276223488' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 132.896,50.8765 c 1.3346,-1.6887 2.0169,-2.7511 5.5171,-4.2747' id='_61025264' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 137.758,50.2977 c 1.1013,-1.4081 2.8701,-3.004 5.551,-3.9575' id='_61023680' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 142.181,50.3857 c 1.7488,-1.5959 3.361,-2.4443 5.5075,-3.3549' id='_61022688' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 134.888,33.0775 c 2.3091,0.2535 5.4957,1.056 7.4435,2.3405' id='_60098480' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 138.208,36.5622 c 2.1007,0.0371 4.9699,0.6643 6.4442,1.4664' id='_59194896' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 141.003,39.5324 c 2.0773,0.0392 4.6798,0.8954 6.8102,2.1159' id='_60493792' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 143.463,42.364 c 2.7835,0.2454 4.6914,1.2563 5.9323,2.015' id='_59289568' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 152.289,44.8741 c 6.5684,-5.5837 19.1653,-8.6301 29.3925,-3.9493 -3.2607,-0.264 -5.1252,-0.1338 -8.4512,0.4747 1.3638,0.3894 2.6545,1.3245 3.0337,1.6648 -2.7769,-0.373 -3.9638,-0.6141 -6.9572,-0.4088 1.4027,0.3813 2.5088,1.0898 3.487,1.6388 -2.0952,-0.3367 -5.0741,-0.7293 -7.5672,-0.3178 0.5198,0.1049 2.4721,0.8748 3.2596,1.3563 -1.1627,0.0117 -5.6949,-0.0473 -7.5991,0.2156 1.306,0.3473 2.1771,0.6178 2.9627,0.8803 -3.2594,0.0855 -5.6199,0.1341 -7.2607,0.4948' id='_59437040' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 173.231,41.3995 c -2.0254,-0.8195 -5.5608,-1.1901 -7.3778,-1.0743' id='_57583984' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 169.307,42.6555 c -3.58,-1.1863 -6.9823,-1.1225 -8.6907,-0.8639' id='_59158512' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.227,43.9765 c -3.1489,-0.8873 -6.8417,-0.9095 -8.5501,-0.6509' id='_56459728' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 160.888,45.5483 c -3.0306,-0.7298 -5.2028,-0.6286 -6.9111,-0.3699' id='_55106048' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 156.852,48.8592 c 1.2396,1.0509 2.1242,2.2843 2.7711,3.8137' id='_55036328' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.415,41.8546 c 0.5367,-6.9747 6.8421,-15.2098 18.265,-16.4891 -2.8811,1.4555 -5.0727,3.0221 -6.7122,4.517 1.1466,-0.2259 1.9356,-0.2693 3.2194,-0.2487 -1.9701,0.9366 -4.1987,2.4725 -5.4751,3.9734 0.952,-0.1725 1.9318,-0.154 2.8917,-0.0652 -1.6167,0.8233 -3.5203,2.0616 -4.7822,3.2342 0.8416,-0.1667 1.6337,-0.147 2.5708,-0.0972 -1.284,0.5102 -3.1788,1.9849 -4.1872,3.0901 0.9499,-0.1721 1.6475,-0.1903 2.3818,-0.1314 -1.4507,1.2373 -2.937,2.8796 -3.6268,3.9596' id='_57285408' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 160.967,29.8822 c -1.6678,0.4595 -3.7841,1.3396 -5.3197,2.4452' id='_60502904' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 158.712,33.6068 c -1.5673,0.2737 -3.5186,0.9919 -4.8137,1.7701' id='_110052216' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 156.821,36.7764 c -1.6379,0.2884 -3.4997,1.2062 -5.0569,2.3855' id='_60876664' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 155.205,39.7693 c -2.4879,0.6254 -4.0054,1.8405 -4.9697,2.7252' id='_56253864' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.679,50.7319 c -0.4875,1.2544 -0.8346,2.9194 -0.9955,3.9885' id='_141276520' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 151.706,47.8077 c 6.3601,5.5562 14.2699,12.7107 10.6267,25.9665 -0.2643,-2.1136 -0.6948,-5.1764 -1.7849,-7.6386 -0.2613,1.3966 -0.6198,2.3313 -1.0531,3.0795 -0.0892,-1.9111 -1.059,-6.3143 -2.1732,-8.1026 -0.1291,1.7125 -0.3147,2.3936 -0.6742,3.4881 -0.0864,-2.0614 -1.2914,-5.8011 -2.3599,-8.1917 -0.0635,0.6286 -0.279,1.8206 -0.7789,2.9888 -0.2605,-2.9704 -1.2412,-5.8129 -2.5613,-7.1431' id='_56765888' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='text5512' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;text-align:center;line-height:125%25;letter-spacing:60px;word-spacing:0px;text-anchor:middle;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold'%3E %3Cpath d='m 524.56397,799.32401 15.36274,8.33983 3.7273,-6.86604 c 1.91026,-3.51879 2.48407,-6.28155 1.72144,-8.28829 -0.74707,-2.03523 -2.79421,-3.96141 -6.14141,-5.77852 -3.69047,-2.00336 -6.63673,-2.75087 -8.8388,-2.24253 -2.23062,0.49294 -4.06034,2.05537 -5.48917,4.68729 -1.84808,3.40446 -2.75007,5.74831 -2.70598,7.03156 0.0597,1.25473 0.84767,2.29363 2.36388,3.1167 m 20.04023,10.87905 19.73984,10.71598 c 1.51625,0.82314 2.86861,0.89058 4.0571,0.20232 1.204,-0.71682 2.62135,-2.57719 4.25205,-5.5811 1.55303,-2.86082 2.5809,-5.26597 3.08361,-7.21547 0.48961,-1.99356 0.42136,-3.64182 -0.20474,-4.94478 -0.6106,-1.33148 -1.34788,-2.36138 -2.21184,-3.08972 -0.87706,-0.77239 -2.23106,-1.65558 -4.06199,-2.64957 -9.21193,-5.00074 -15.95454,-3.5311 -20.22786,4.40892 l -4.42617,8.15342 m -31.6696,-9.41392 c 1.11824,-2.05976 2.53518,-4.77225 4.25084,-8.13748 1.71575,-3.36511 2.79102,-5.44822 3.22583,-6.24931 2.09665,-3.86208 4.34283,-6.97631 6.73856,-9.34271 2.38272,-2.41039 4.68529,-3.95688 6.90774,-4.63946 2.19389,-0.69797 4.2067,-0.99426 6.03844,-0.88889 1.83178,0.10552 3.563,0.60086 5.19367,1.48602 2.28869,1.24251 4.03094,3.35504 5.22675,6.33762 1.21137,2.9541 1.73572,5.97965 1.57304,9.07666 3.51314,-3.53757 7.27148,-5.92351 11.27504,-7.15782 4.00355,-1.23417 7.96501,-0.78746 11.88438,1.34014 4.34847,2.36069 7.10264,6.43004 8.26251,12.20809 1.13123,5.76262 -0.48517,12.66339 -4.84919,20.70233 -1.49094,2.74644 -3.10242,5.6126 -4.83446,8.59848 -1.71653,2.95732 -3.11835,5.43726 -4.20547,7.43984 l -3.79596,7.60658 -0.30407,-0.0539 c -4.36074,-3.29325 -10.03134,-6.83458 -17.01181,-10.62402 l -21.49927,-11.6711 c -6.75155,-3.66514 -12.81041,-6.49127 -18.1766,-8.47839 l -0.16429,-0.31142 c 1.7558,-2.82484 3.17724,-5.23857 4.26432,-7.24121' id='path7858' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 621.17915,668.83074 c -8.74694,7.3005 -7.22792,18.01076 4.55707,32.13078 5.94464,7.12256 11.87456,11.33174 17.78976,12.62758 5.89432,1.27089 11.24064,-0.0961 16.039,-4.10092 4.34845,-3.62933 6.18731,-8.00491 5.51658,-13.12674 -0.67081,-5.12175 -3.87422,-11.11895 -9.61025,-17.99161 -6.61213,-7.92217 -12.62577,-12.61268 -18.04093,-14.07155 -5.41105,-1.50456 -10.82812,0.006 -16.25123,4.53246 m 45.44263,-2.24781 c 6.44521,7.72237 9.24402,16.02887 8.39643,24.91953 -0.84354,8.8449 -5.33886,16.66724 -13.48598,23.46705 -7.62237,6.36183 -15.87663,9.35024 -24.76281,8.96522 -8.88618,-0.38498 -16.32245,-4.16373 -22.30883,-11.33625 -6.36179,-7.62231 -9.18362,-16.058 -8.46549,-25.30709 0.71818,-9.24898 4.9384,-17.09613 12.66069,-23.54144 8.14717,-6.79976 16.5868,-9.92168 25.31891,-9.36577 8.73622,0.51024 16.28524,4.57648 22.64708,12.19875' id='path7860' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 764.17011,634.81851 c 1.82535,6.55395 3.22909,10.6234 4.21121,12.20837 3.85707,-1.07425 8.02676,-2.42143 12.50906,-4.04153 4.51359,-1.62881 8.05074,-3.00256 10.61145,-4.12126 l 3.85411,-1.63098 0.29295,0.3239 c 0.16274,1.06979 0.61095,2.92173 1.34465,5.55582 0.25323,0.90942 0.6915,2.24037 1.31482,3.99285 l -0.10955,0.33463 c -1.58902,0.23982 -3.54377,0.68288 -5.86425,1.32917 l -29.30456,8.1618 -7.87078,2.49626 -0.21972,-0.24292 c -0.58684,-4.53351 -2.04802,-11.05371 -4.38353,-19.56062 l -6.5635,-23.56594 c -2.18346,-7.83958 -4.33453,-14.16763 -6.4532,-18.98418 l 0.15659,-0.34773 c 2.93739,-0.6153 5.48795,-1.2243 7.65169,-1.827 l 7.91782,-2.50937 0.17268,0.25603 c 0.55189,4.40814 2.02875,10.92398 4.43057,19.54752 l 6.30149,22.62518' id='path7862' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 876.85306,599.92361 c 0.83195,-7.63706 1.1663,-14.31329 1.00306,-20.0287 l 0.22589,-0.27009 c 3.15017,0.5397 5.85789,0.9329 8.12315,1.17961 -2e-5,6e-5 2.76121,0.20263 8.28369,0.6077 l 0.0654,0.30182 c -1.38014,5.15435 -2.50733,11.74421 -3.38157,19.76959 l -2.64925,24.31902 c -0.82141,7.54004 -1.13958,14.21803 -0.95452,20.03399 l -0.22589,0.27009 c -3.15021,-0.53964 -5.85793,-0.93285 -8.12315,-1.17962 -2e-5,0 -2.76124,-0.20256 -8.28369,-0.6077 l -0.0653,-0.30182 c 1.3942,-5.28373 2.50521,-11.87535 3.33302,-19.77488 l 2.64925,-24.31901' id='path7864' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 996.90213,663.72858 c 20.12567,-15.94374 32.91677,-26.82901 38.37327,-32.65585 0.6245,0.55709 2.2847,1.55939 4.9806,3.0069 2.1222,1.13958 3.5737,1.80811 4.3545,2.00559 -27.953,21.16265 -46.9394,35.74144 -56.95921,43.73642 l -6.06566,-3.25696 c 0.54025,-5.54769 1.39579,-13.91885 2.56664,-25.11352 1.17079,-11.19464 2.14071,-20.74215 2.90975,-28.64254 0.78438,-7.929 1.23967,-13.55925 1.36588,-16.89076 0.91134,0.71111 3.83344,2.39098 8.7663,5.03962 3.4701,1.86337 5.739,2.97078 6.8065,3.32224 -2.9296,13.57564 -5.29581,30.05857 -7.09857,49.44886' id='path7866' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 1100.0879,710.59152 c 5.6797,-5.17285 10.3503,-9.95503 14.0118,-14.34656 l 0.3481,-0.0529 c 2.0036,2.49007 3.7726,4.57741 5.307,6.26203 0,3e-5 1.9353,1.97993 5.806,5.93969 l -0.1509,0.26948 c -4.4468,2.94923 -9.6544,7.14178 -15.6229,12.57766 l -18.0859,16.4721 c -5.6076,5.10711 -10.2672,9.90132 -13.979,14.38265 l -0.3481,0.0529 c -2.0037,-2.49005 -3.7727,-4.57739 -5.307,-6.26203 0,-10e-6 -1.9353,-1.97991 -5.8059,-5.93969 l 0.1508,-0.26947 c 4.543,-3.03689 9.7397,-7.24147 15.59,-12.61377 l 18.086,-16.47209' id='path7868' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 1160.8469,832.54062 c 6.3149,-6.49146 11.6987,-12.24465 16.1515,-17.25959 l -0.2677,-0.57555 -23.7234,0.74873 c 1.0763,2.62275 2.4862,5.80837 4.2297,9.55686 0.8786,1.88897 2.0819,4.39882 3.6099,7.52955 m -13.9638,-16.82278 c -10.384,0.52174 -18.2108,1.25421 -23.4804,2.19739 -0.1661,-0.82027 -0.709,-2.21917 -1.6288,-4.1967 -1.2356,-2.65641 -2.1135,-4.31236 -2.6338,-4.96788 33.7933,-0.20895 57.759,-0.51391 71.897,-0.91489 l 3.7891,8.1463 c -24.5102,25.72478 -40.4722,43.23729 -47.886,52.53758 -0.3034,-1.11548 -1.4985,-3.91636 -3.5852,-8.40267 -1.7985,-3.86659 -3.0265,-6.27519 -3.684,-7.22581 4.5515,-3.87625 10.2377,-9.24951 17.0585,-16.11981 -1.6138,-3.70114 -2.9698,-6.73232 -4.0681,-9.09354 -1.5925,-3.42382 -3.5186,-7.41047 -5.7783,-11.95997' id='path7870' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3C/g%3E %3Cg id='g8752' style='fill:%23e8a30e;fill-opacity:1;stroke-width:1.5;stroke-miterlimit:4;stroke-dasharray:none'%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1443.2499,469.16955)' id='path6841' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1554.5953,421.73669)' id='path6843' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1726.5714,117.53384)' id='path6845' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,578.4198,334.55701)' id='path6847' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,636.1068,235.33423)' id='path6849' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,256.7501,469.16955)' id='path6853' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,145.4047,421.73669)' id='path6855' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,-26.5714,117.53384)' id='path6857' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1121.5802,334.55701)' id='path6859' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1063.8932,235.33423)' id='path6861' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(3,0,0,3,-2015.2607,-1836.6377)' id='g4397'%3E %3Cg id='g45422'%3E %3Cg transform='matrix(0.4945295,0,0,0.4407188,780.5066,844.55531)' id='g4979' style='fill:%23e7e7e7;fill-opacity:1'%3E %3Cpath d='m 361.87949,211.77963 -0.0229,-4.44419 0.54752,0 -6.79287,-4.38776 -5.46601,-0.003 -6.75627,4.38181 0.5399,0.003 0.0229,4.44129 17.92622,0.0122' id='path190' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 361.87949,211.77963 -0.0229,-4.44419 0.54752,0 -6.79287,-4.38776 -0.51493,-6.68341 -4.43052,0 -0.52056,6.68036 -6.75627,4.38181 0.5399,0.003 0.0229,4.44129 17.92622,0.0122 0.002,-0.003 z' id='path192' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 363.96737,217.61792 0.002,1.39076 -21.88389,-0.0244 -0.009,-1.3848 21.89304,0.0185' id='path198' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 363.96737,217.61792 0.002,1.39076 -21.88389,-0.0244 -0.009,-1.3848 21.89304,0.0185 -0.002,0 z' id='path200' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 343.53845,217.53404 -0.0183,-4.70651 0.88604,-0.002 -0.0487,4.76142 0.0534,-4.72314 -1.2765,-0.0366 0,-1.00978 19.55809,0.0215 0.009,1.00047 -1.20637,0 0.0229,4.76599 -0.0427,-4.76599 0.89829,0 0.0198,4.71246' id='path202' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 343.53845,217.53404 -0.0183,-4.70651 0.88604,-0.002 -0.0487,4.76142 0.0534,-4.72314 -1.2765,-0.0366 0,-1.00978 19.55809,0.0215 0.009,1.00047 -1.20637,0 0.0229,4.76599 -0.0427,-4.76599 0.89829,0 0.0198,4.71246' id='path204' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 347.74319,216.37495 -0.0137,-3.28205 -2.62625,0 0.0153,3.27885 2.62472,0.003' id='path206' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 345.81849,213.77753 0.008,1.90639 1.20179,0 -0.006,-1.90639 -1.20332,0' id='path208' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 360.58162,216.38395 -0.0152,-3.27885 -2.6171,-0.003 0.0122,3.2819 2.62015,0' id='path210' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.65692,213.78973 0.0137,1.90029 1.20026,0 -0.0107,-1.90029 -1.20332,0' id='path2319' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 360.56179,211.0401 -0.0152,-3.2822 -2.62015,0 0.009,3.2822 2.62778,0 -0.002,0 z' id='path2321' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.63709,208.44877 0.008,1.90335 1.20027,0 -0.002,-1.90335 -1.20637,0' id='path216' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 347.72184,211.0279 -0.0183,-3.27595 -2.62168,-0.003 0.0122,3.27748 2.62778,0 0,0.002 z' id='path218' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 345.79714,208.43657 0.006,1.90045 1.20332,0.003 -0.009,-1.90335 -1.20027,0' id='path220' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 352.4741,211.03384 -0.0122,-3.27594 -2.6232,-0.003 0.0107,3.27884 2.62472,0' id='path222' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 350.55093,208.43962 0.006,1.9003 1.20179,0.006 -0.008,-1.9064 -1.20027,0' id='path224' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.13743,211.0401 -0.0183,-3.2822 -2.62168,-0.003 0.0122,3.27884 2.62778,0.006' id='path226' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 354.21121,208.44283 0.009,1.90639 1.20179,0 -0.006,-1.90639 -1.20484,0' id='path228' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.78713,210.03337 0.029,7.5661 -7.59966,-0.0122 -0.0274,-7.55985 7.5966,0.006' id='path230' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.78713,210.03337 0.029,7.5661 -7.59966,-0.0122 -0.0274,-7.55985 7.5966,0.006 0.002,0 z' id='path232' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 349.14325,212.19293 7.6515,0.006' id='path234' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 350.09797,217.59642 -0.0259,-5.34706' id='path2333' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 355.89189,217.59947 -0.0259,-5.34385' id='path2335' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.56131,206.81095 -4.27947,-3.12511 -4.80869,-0.006 -4.24592,3.11901 13.33408,0.0122' id='path240' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 350.85138,202.99816 4.0446,0.003' id='path2338' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 351.94031,201.56455 0.006,0.95 1.85759,0 -0.006,-0.95 -1.85759,0' id='path244' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 349.54435,210.24551 0.55362,0 -0.16166,0.29725 c 0,0 0.26689,0.3433 0.005,0.73663 l 0.14489,0.27315 -0.53379,0 0.14488,-0.25943 c 0,0 -0.27299,-0.45585 0.0122,-0.75035 l -0.16472,-0.29725' id='path252' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 350.67294,210.24551 0.55362,0 -0.16014,0.29725 c 0,0 0.26689,0.33415 0.002,0.73663 l 0.14336,0.27315 -0.53226,0 0.14336,-0.25943 c 0,0 -0.2669,-0.45585 0.0137,-0.75035 l -0.16319,-0.29725' id='path254' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 351.90371,210.24551 0.55209,0 -0.16471,0.29725 c 0,0 0.26994,0.3433 0.005,0.73663 l 0.14489,0.27909 -0.52922,-0.006 0.14184,-0.25943 c 0,0 -0.26995,-0.45295 0.0107,-0.75035 l -0.16166,-0.29725 0.002,0 z' id='path256' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 353.29309,210.24841 0.55667,0 -0.16319,0.30045 c 0,0 0.26689,0.3372 0.002,0.73205 l 0.14946,0.27757 -0.53684,0 0.14336,-0.25927 c 0,0 -0.26689,-0.45905 0.0183,-0.75035 l -0.16777,-0.30045 -0.002,0 z' id='path258' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 354.52843,210.24841 0.55209,0 -0.16318,0.30045 c 0,0 0.26842,0.3372 0.003,0.73053 l 0.14641,0.27909 -0.53227,0 0.13879,-0.25927 c 0,0 -0.26842,-0.456 0.0213,-0.75035 l -0.16624,-0.30045' id='path260' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 355.75615,210.25146 0.55209,-0.003 -0.16319,0.30045 c 0,0 0.273,0.3372 0.008,0.73205 l 0.13879,0.27757 -0.53379,0 0.14336,-0.25927 c 0,0 -0.2669,-0.456 0.0183,-0.75035 l -0.16319,-0.2974' id='path262' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 954.4347,929.4981 1.30438,0 0,1.52247 -1.30438,0 0,-1.52247 z' id='path13722' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.13021348;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 955.09984,927.63497 -0.0259,1.94455' id='path14693' style='fill:none;stroke:%23000000;stroke-width:0.30000001;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 954.37609,928.36033 1.42159,0.0197' id='path14695' style='fill:none;stroke:%23000000;stroke-width:0.37895805;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(1.1428572,0,0,1.1428572,-139.28578,-99.630767)' id='g44354'%3E %3Cpath d='m 586.607,219.117 c 0,0 -8.426,19.153 -5.515,21.053 0,0 10.57,-11.555 13.329,-20.736 2.757,-9.181 0,-0.633 0,-0.633 l -0.767,-9.973 -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4705-8-5' style='fill:%23452c25' /%3E %3Cpath d='m 586.607,219.117 c 0,0 -8.426,19.153 -5.515,21.053 0,0 10.569,-11.555 13.329,-20.736 2.757,-9.181 0,-0.633 0,-0.633 l -0.767,-9.973 -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4707-6-4' style='fill:none;stroke:%23000000;stroke-width:0.58499998' /%3E %3Cpath d='m 588.388,209.963 c 0,0 -10.125,21.095 -7.809,22.654 0,0 8.411,-9.485 10.605,-17.02 2.193,-7.536 0,-0.52 0,-0.52 l 2.812,-13.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4741-0-0' style='fill:%23452c25' /%3E %3Cpath d='m 588.388,209.963 c 0,0 -10.125,21.095 -7.809,22.654 0,0 8.411,-9.485 10.605,-17.02 2.193,-7.536 0,-0.52 0,-0.52 l 2.812,-13.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4743-9-3' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 598.819,205.264 c 0,0 -10.125,21.095 -7.81,22.654 0,0 8.411,-9.485 10.606,-17.021 2.194,-7.536 0,-0.52 0,-0.52 l 2.811,-13.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4745-4-0' style='fill:%23452c25' /%3E %3Cpath d='m 598.819,205.264 c 0,0 -10.125,21.095 -7.81,22.654 0,0 8.411,-9.485 10.606,-17.021 2.194,-7.536 0,-0.52 0,-0.52 l 2.811,-13.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4747-0-4' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 1367.8396,353.13405 35.6189,20.2092 c 0,0 8.6875,7.20462 -10.3854,2.96357 -19.0733,-4.24102 -59.7471,-18.27786 -136.5847,-67.72631 -34.7387,-22.3585 -45.7021,-21.72886 -45.7021,-21.72886 l 48.4223,1.31376 108.631,64.96861 z' id='path6051-6-0' style='fill:%23452c25' /%3E %3Cpath d='m 1367.8396,353.13405 35.6189,20.2092 c 0,0 8.6875,7.20462 -10.3854,2.96357 -19.0733,-4.24102 -59.7471,-18.27786 -136.5847,-67.72631 -34.7387,-22.3585 -45.7021,-21.72886 -45.7021,-21.72886 l 48.4223,1.31376 108.631,64.96861 z' id='path6053-6-2' style='fill:none;stroke:%23000000;stroke-width:1.27883279' /%3E %3Cpath d='m 1379.6118,344.34622 35.6189,20.20923 c 0,0 8.6878,7.2046 -10.3886,2.96358 -19.0701,-4.241 -59.7437,-18.2779 -136.5815,-67.72634 -34.7388,-22.35848 -6.7914,18.44443 -6.7914,18.44443 l 5.8875,-26.82963 112.2551,52.93873 z' id='path6055-6-5' style='fill:%23452c25' /%3E %3Cpath d='m 1379.6118,344.34622 35.6189,20.20923 c 0,0 8.6878,7.2046 -10.3886,2.96358 -19.0701,-4.241 -59.7437,-18.2779 -136.5815,-67.72634 -34.7388,-22.35848 -6.7914,18.44443 -6.7914,18.44443 l 5.8875,-26.82963 112.2551,52.93873 z' id='path6057-6-3' style='fill:none;stroke:%23000000;stroke-width:1.27883279' /%3E %3Cpath d='m 1438.861,363.80169 c 0,0 -42.5317,-7.90384 -58.0166,-19.23747 0,0 2.7202,4.89183 -18.0804,-4.58012 0,0 8.0181,18.23556 -50.5348,-21.65918 -58.5558,-39.88874 -38.084,-19.83995 -38.084,-19.83995 l 16.3797,-4.2259 c 0,0 89.8959,35.91712 99.7541,39.67379 9.861,3.7567 48.582,29.86883 48.582,29.86883' id='path6059-6-8' style='fill:%23452c25' /%3E %3Cpath d='m 1438.861,363.80169 c 0,0 -42.5317,-7.90384 -58.0166,-19.23747 0,0 2.7202,4.89183 -18.0804,-4.58012 0,0 8.0181,18.23556 -50.5348,-21.65918 -58.5558,-39.88874 -38.084,-19.83995 -38.084,-19.83995 l 16.3797,-4.2259 c 0,0 89.8959,35.91712 99.7541,39.67379 9.861,3.7567 48.582,29.86883 48.582,29.86883 z' id='path6061-0-0' style='fill:none;stroke:%23000000;stroke-width:1.24588883' /%3E %3Cpath d='m 1216.4843,379.7366 14.2494,20.32123 c 0,0 -4.7381,19.04982 -54.2031,-18.01759 -49.465,-37.06435 -46.8547,-33.99785 -46.8547,-33.99785 l 27.3193,-3.81116 59.9929,34.04627' id='path6063-0-3' style='fill:%23452c25' /%3E %3Cpath d='m 1216.4843,379.7366 14.2494,20.32123 c 0,0 -4.7381,19.04982 -54.2031,-18.01759 -49.465,-37.06435 -46.8547,-33.99785 -46.8547,-33.99785 l 27.3193,-3.81116 59.9929,34.04627' id='path6065-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1152.2365,389.92297 c 0,0 22.9756,30.05648 17.8584,33.79504 -5.1142,3.73547 -32.244,2.12806 -51.6163,-27.28671 -19.3723,-29.41475 -0.4061,-1.49842 -0.4061,-1.49842 l 1.7987,-47.55645 32.8662,41.08741' id='path6067-4-8' style='fill:%23452c25' /%3E %3Cpath d='m 1152.2365,389.92297 c 0,0 22.9756,30.05648 17.8584,33.79504 -5.1142,3.73547 -32.244,2.12806 -51.6163,-27.28671 -19.3723,-29.41475 -0.4061,-1.49842 -0.4061,-1.49842 l 1.7987,-47.55645 32.8662,41.08741' id='path6069-1-9' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1175.8283,376.08888 c 0,0 22.1191,28.53994 19.7013,32.88089 -2.4118,4.34392 -33.589,1.5832 -58.4402,-26.57834 -24.8509,-28.15851 -3.6948,-37.15826 -3.6948,-37.15826 l 42.0339,29.36031' id='path6071-0-0' style='fill:%23452c25' /%3E %3Cpath d='m 1175.6285,375.34119 c 0,0 22.3189,29.28763 19.9011,33.62858 -2.4118,4.34392 -33.589,1.5832 -58.4402,-26.57834 -24.8509,-28.15851 -3.6948,-37.15826 -3.6948,-37.15826 l 42.2339,30.10802 z' id='path6073-1-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1301.8644,359.2398 c 0,0 63.0359,27.11415 16.2851,25.34025 0,0 -91.5791,-24.6652 -138.961,-65.24714 l 13.399,-17.71783 108.5452,56.04457' id='path6075-1-0' style='fill:%23452c25' /%3E %3Cpath d='m 1301.8644,359.2398 c 0,0 63.0359,27.11415 16.2851,25.34025 0,0 -91.5791,-24.6652 -138.961,-65.24714 l 13.399,-17.71783 108.5452,56.04457' id='path6077-7-9' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1334.9469,351.41763 c 0,0 34.1194,20.69963 36.6558,28.56721 2.5424,7.86756 -106.0238,-20.27886 -163.2993,-67.96852 l 25.58,-12.52328 101.0635,51.92459 z' id='path6079-0-3' style='fill:%23452c25' /%3E %3Cpath d='m 1334.9469,351.41763 c 0,0 34.1194,20.69963 36.6558,28.56721 2.5424,7.86756 -106.0238,-20.27886 -163.2993,-67.96852 l 25.58,-12.52328 101.0635,51.92459 z' id='path6081-6-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1235.8478,370.1678 c 0,0 24.6733,20.25764 21.8733,22.60975 -2.7972,2.35208 -52.8402,-5.13402 -92.1211,-35.36614 l 4.7053,-18.06297 66.0284,29.85066' id='path6083-7-5' style='fill:%23452c25' /%3E %3Cpath d='m 1235.8478,370.1678 c 0,0 24.6733,20.25764 21.8733,22.60975 -2.7972,2.35208 -52.8402,-5.13402 -92.1211,-35.36614 l 4.7022,-18.06297 66.0315,29.85066' id='path6085-7-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1278.0505,368.45139 c 0,0 24.3383,16.78857 19.2953,18.5564 -5.049,1.76482 -24.1429,16.77039 -114.7468,-36.2985 l -10.6759,-5.86662 14.3827,-22.59759 91.792,44.72906' id='path6087-6-1' style='fill:%23452c25' /%3E %3Cpath d='m 1278.0743,367.71278 c 0,0 24.3145,17.52718 19.2715,19.29501 -5.049,1.76482 -24.1429,16.77039 -114.7468,-36.2985 l -10.6759,-5.86662 14.3827,-22.59759 91.7685,45.4677 z' id='path6089-0-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1185.0641,318.73961 c 0,0 29.4468,26.37552 25.6927,30.16853 -3.7603,3.79302 -38.8159,-4.55582 -54.2741,-16.04691 -15.4583,-11.49103 -26.7179,-26.2181 -26.7179,-26.2181 l 32.8574,-7.0835 22.4419,19.17998 z' id='path6091-6-3' style='fill:%23452c25' /%3E %3Cpath d='m 1185.0641,318.73961 c 0,0 29.4468,26.37552 25.6927,30.16853 -3.7603,3.79302 -38.8159,-4.55582 -54.2741,-16.04691 -15.4583,-11.49103 -26.7179,-26.2181 -26.7179,-26.2181 l 32.8574,-7.0835 22.4419,19.17998 z' id='path6093-2-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1149.958,274.69765 53.6518,31.97877 c 0,0 43.785,30.91019 39.1628,33.68004 -4.6314,2.76985 -39.1419,-8.02194 -63.6048,-21.36561 -24.4601,-13.34062 -52.8342,-42.07126 -52.8342,-42.07126' id='path6095-1-9' style='fill:%23452c25' /%3E %3Cpath d='m 1149.958,274.69765 53.6518,31.97877 c 0,0 43.785,30.91019 39.1628,33.68004 -4.6314,2.76985 -39.1419,-8.02194 -63.6048,-21.36561 -24.4601,-13.34062 -52.8342,-42.07126 -52.8342,-42.07126' id='path6097-2-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1116.0962,425.93689 c 0,0 9.9916,25.57332 4.0209,27.79526 -5.9705,2.22494 -20.765,-2.33089 -32.6498,-25.51883 -11.8846,-23.1849 10.3515,-13.38402 10.3515,-13.38402 l 18.2774,11.10762 z' id='path6099-5-7' style='fill:%23452c25' /%3E %3Cpath d='m 1116.0962,425.93689 c 0,0 9.9916,25.57332 4.0209,27.79526 -5.9705,2.22494 -20.765,-2.33089 -32.6498,-25.51883 -11.8846,-23.1849 8.0589,-12.87454 8.0589,-12.87454 l 20.57,10.59814 z' id='path6101-9-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1133.8924,409.39958 c 0,0 14.9989,24.79237 11.7308,27.61968 -3.2713,2.82736 -23.0527,11.38814 -44.6058,-20.58458 -21.5473,-31.96967 22.1755,-25.24033 22.1755,-25.24033 l 10.6995,18.20523 z' id='path6103-1-8' style='fill:%23452c25' /%3E %3Cpath d='m 1133.8924,409.39958 c 0,0 14.9989,24.79237 11.7308,27.61968 -3.2713,2.82736 -23.0527,11.38814 -44.6058,-20.58458 -21.5473,-31.96967 22.1755,-25.24033 22.1755,-25.24033 l 10.6995,18.20523 z' id='path6105-1-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1089.0584,297.52839 c 0,0 51.1748,98.80911 46.917,104.0612 -4.2638,5.25512 -24.4717,-0.0181 -35.7967,-26.13942 -11.3307,-26.12728 -20.5902,-60.04646 -20.5902,-60.04646 l 9.4699,-17.87529 z' id='path6107-7-4' style='fill:%23452c25' /%3E %3Cpath d='m 1089.0584,297.52839 c 0,0 51.1748,98.80911 46.917,104.0612 -4.2638,5.25512 -24.4717,-0.0181 -35.7967,-26.13942 -11.3307,-26.12728 -20.5902,-60.04346 -20.5902,-60.04346 l 9.4699,-17.87829 z' id='path6109-7-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1148.6781,322.67187 c 0,0 42.6974,36.29547 33.9297,40.86646 -8.7705,4.57704 -25.7548,-2.0433 -50.7302,-26.75391 -24.9727,-24.71059 16.3975,-15.60795 16.3975,-15.60795' id='path6111-7-5' style='fill:%23452c25' /%3E %3Cpath d='m 1148.4767,321.92416 c 0,0 42.8988,37.04318 34.1311,41.61417 -8.7705,4.57704 -25.7548,-2.0433 -50.7302,-26.75391 -24.9727,-24.71059 16.5991,-14.86026 16.5991,-14.86026 z' id='path6113-4-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1127.978,323.28334 c 0,0 30.5194,56.04159 26.7119,61.31486 -3.8073,5.27026 -26.706,-13.9279 -37.9922,-28.20995 -11.2862,-14.27906 -19.8285,-35.0362 -19.8285,-35.0362' id='path6115-3-8' style='fill:%23452c25' /%3E %3Cpath d='m 1127.978,323.28334 c 0,0 30.5194,56.04159 26.7119,61.31486 -3.8073,5.27026 -26.706,-13.9279 -37.9922,-28.20995 -11.2862,-14.27906 -19.8285,-35.0362 -19.8285,-35.0362' id='path6117-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 899.2785,438.36939 c 0,0 -1.80751,33.03523 0,35.50238 1.81034,2.46408 18.56921,2.46408 19.46999,-22.189 0.90672,-24.6561 -3.62069,-25.6399 -3.62069,-25.6399 l -16.30267,11.33965' id='path6119-2-2' style='fill:%23452c25' /%3E %3Cpath d='m 899.2785,438.36939 c 0,0 -1.80751,33.03523 0,35.50238 1.81034,2.46408 18.56921,2.46408 19.46999,-22.189 0.90672,-24.6561 -3.62069,-25.6399 -3.62069,-25.6399 l -16.30267,11.33965' id='path6121-2-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 909.30544,398.55938 c 0,0 -11.77215,36.97963 -0.45052,44.37798 11.31879,7.3953 20.37698,-36.48923 20.82724,-46.34865 0.45336,-9.86243 -20.37672,1.97067 -20.37672,1.97067' id='path6123-8-3' style='fill:%23452c25' /%3E %3Cpath d='m 909.30544,398.55938 c 0,0 -11.77215,36.97963 -0.45052,44.37798 11.31879,7.3953 20.37698,-36.48923 20.82724,-46.34865 0.45336,-9.86243 -20.37672,1.97067 -20.37672,1.97067 z' id='path6125-3-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 917.39151,445.76469 c 0,0 2.2637,34.51553 8.60456,35.99278 6.33802,1.48028 16.75034,-9.8594 16.75034,-18.735 0,-8.87558 -10.86568,-29.5843 -10.86568,-29.5843 l -14.94543,10.84927' id='path6127-7-1' style='fill:%23452c25' /%3E %3Cpath d='m 917.39151,445.76469 c 0,0 2.2637,34.51553 8.60172,35.99278 6.34086,1.48028 16.75318,-9.8594 16.75318,-18.735 0,-8.87558 -10.86853,-29.5843 -10.86853,-29.5843 l -14.94258,10.84927' id='path6129-2-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 917.69366,404.43207 c 0,0 -11.77215,36.97963 -0.45336,44.3749 11.32189,7.39836 20.37982,-36.48618 20.83034,-46.34558 0.45336,-9.86242 -20.37698,1.97068 -20.37698,1.97068 z' id='path6133-6-6' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 918.60943,345.08791 c 0,0 -17.20939,17.75115 -16.75318,27.6136 0.45026,9.8594 25.35775,-13.3134 27.62145,-17.7542 2.26087,-4.43477 -10.86827,-9.8594 -10.86827,-9.8594' id='path6135-9-1' style='fill:%23452c25' /%3E %3Cpath d='m 918.60943,345.08791 c 0,0 -17.20939,17.75115 -16.75318,27.6136 0.45026,9.8594 25.35465,-13.3134 27.62145,-17.7542 2.26087,-4.43477 -10.86827,-9.8594 -10.86827,-9.8594 z' id='path6137-6-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 906.77783,335.14068 c 0,0 -13.5856,25.1465 -9.96181,33.03523 3.62379,7.88877 16.75319,-5.915 23.09405,-14.79063 6.34086,-8.87557 -13.13224,-18.2446 -13.13224,-18.2446' id='path6139-8-7' style='fill:%23452c25' /%3E %3Cpath d='m 906.77783,335.14068 c 0,0 -13.5856,25.1465 -9.96181,33.03523 3.62379,7.88877 16.75319,-5.915 23.09405,-14.79063 6.34086,-8.87557 -13.13224,-18.2446 -13.13224,-18.2446 z' id='path6141-8-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1097.7431,301.82695 c 0,0 21.6926,40.86039 15.7278,43.08236 -5.9645,2.22188 -15.1292,-8.02497 -24.2199,-20.23952 -9.0965,-12.21753 8.4921,-22.84284 8.4921,-22.84284' id='path6143-6-6' style='fill:%23452c25' /%3E %3Cpath d='m 1097.7431,301.82695 c 0,0 21.6926,40.86039 15.7278,43.08236 -5.9645,2.22188 -15.1292,-8.02497 -24.2199,-20.23952 -9.0965,-12.21753 8.4921,-22.84284 8.4921,-22.84284 z' id='path6145-6-9' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1098.244,385.39132 c 0,0 7.8698,34.37019 0.9628,37.53964 -13.5173,6.20262 -21.0495,-24.43209 -21.8642,-35.93222 -0.9155,-12.86539 20.9014,-1.60742 20.9014,-1.60742 z' id='path6149-6-7' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1071.2062,439.88296 c 0,0 1.8282,25.73376 -1.8786,28.04954 -3.7039,2.31274 -12.7885,2.92726 -22.9134,-18.70776 -10.1274,-21.63197 -5.4194,-13.54344 -5.4194,-13.54344 l 24.8928,-12.29928 5.4044,14.03989' id='path6153-5-3' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1096.1031,433.9997 c 0,0 2.9083,27.25792 -2.5586,28.0208 -5.4639,0.76281 -19.9999,-8.45147 -26.3296,-24.76815 -7.2975,-18.81166 25.3843,-13.26494 25.3843,-13.26494 l 3.5039,10.01229 z' id='path6157-2-2' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1070.4714,350.40656 c 0,0 27.9799,62.60139 23.476,71.51633 -8.8121,17.4515 -34.229,-38.13294 -41.9062,-59.82242 -8.5839,-24.26862 18.4302,-11.69391 18.4302,-11.69391 z' id='path6161-8-8' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1057.502,360.86234 c 0,0 38.1405,68.90086 22.0511,70.50525 -16.0804,1.6044 -45.3256,-49.97213 -50.2296,-61.95962 -4.9069,-11.99051 28.1785,-8.54563 28.1785,-8.54563 z' id='path6165-4-8' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1055.2204,375.16559 c 0,0 18.7652,66.03416 6.6759,60.19484 -12.0893,-5.8394 -26.6465,-55.57541 -28.6319,-66.30967 -1.9853,-10.73728 21.956,6.11483 21.956,6.11483 z' id='path6169-4-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1121.1512,281.27569 c 0,0 28.9283,44.19024 19.5473,45.50099 -9.3839,1.31077 -43.6871,-29.52374 -44.0043,-34.63052 -0.3112,-5.10376 24.457,-10.8705 24.457,-10.8705 z' id='path6173-9-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1103.0676,283.13736 c 0,0 36.8873,50.34749 25.7608,52.90544 -11.1263,2.55488 -11.9588,-5.3157 -11.9588,-5.3157 0,0 -29.4349,-26.5299 -31.4084,-33.24105 -1.9762,-6.71425 16.5222,-14.9965 16.5222,-14.9965' id='path6177-8-3' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1139.6111,283.91834 c 0,0 25.3665,26.16667 18.7085,35.02105 -6.652,8.85743 -41.8884,-33.12908 -46.6856,-38.46288 -4.7973,-5.33989 30.7298,2.41564 30.7298,2.41564' id='path6185-2-8' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1078.1131,320.27133 c 0,0 40.8426,79.56855 33.3224,87.6571 -7.5172,8.09155 -52.9141,-59.656 -54.4965,-69.47909 -1.5762,-9.82308 21.5918,-19.66736 21.5918,-19.66736' id='path6189-1-0' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1054.6221,327.4699 c 0,0 16.338,24.89524 15.4106,38.31157 -0.9245,13.40722 -24.6971,-19.19816 -26.7444,-25.33723 -2.0533,-6.14207 11.3338,-12.97434 11.3338,-12.97434 z' id='path6193-9-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.65319824' /%3E %3Cpath d='m 1088.2199,314.57424 c 0,0 12.7055,25.68837 8.8093,33.42276 -3.8905,7.73129 -21.2007,-15.60497 -27.2275,-24.73481 -6.03,-9.12988 18.4182,-8.68792 18.4182,-8.68792 z' id='path6197-3-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1029.2881,339.8237 c 0,0 19.9352,22.11634 18.9781,33.90703 -0.9571,11.79073 -29.9058,-17.20022 -32.4422,-22.63094 -2.5336,-5.42465 13.4641,-11.27609 13.4641,-11.27609 z' id='path6201-8-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.70111728' /%3E %3Cpath d='m 1158.1508,276.00842 c 0,0 30.1786,27.07479 25.4971,31.32186 -4.6817,4.2471 -45.5065,-24.98906 -51.6548,-30.67102 -6.1454,-5.67894 26.1577,-0.65084 26.1577,-0.65084 z' id='path6205-9-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1132.6359,274.05289 23.6038,19.87929 c 0,0 21.9265,14.65438 18.1724,18.4474 -3.7543,3.79301 -38.102,-11.92995 -44.1968,-19.08614 -6.0981,-7.15921 -5.3899,-14.53032 -5.3899,-14.53032 l 7.8105,-4.71023 z' id='path6209-2-6' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1210.4159,280.31001 c 0,0 89.3714,36.23796 85.896,44.97732 -3.4757,8.73936 -93.6975,-29.0152 -107.8551,-38.97147 -14.1545,-9.95933 20.6199,-6.55682 20.6199,-6.55682' id='path6213-4-3' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1213.6427,291.78892 c 0,0 67.113,37.7909 59.2846,41.4174 -7.8284,3.62653 -55.8681,-9.20554 -80.6598,-26.01225 -24.7948,-16.80972 -35.3522,-26.12426 -35.3522,-26.12426 l 30.6081,-7.13196 26.1193,17.85107 z' id='path6217-4-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1048.4234,337.71983 c 0,0 12.7055,25.68836 8.8121,33.42273 -3.8937,7.73434 -16.5369,-6.60226 -22.5637,-15.72907 -6.0327,-9.13291 13.7516,-17.69366 13.7516,-17.69366 z' id='path6221-9-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1051.4426,395.64727 c 0,0 10.4834,37.43674 -1.0846,44.36283 -11.5674,6.9261 -19.0967,-37.29744 -19.2063,-47.16899 -0.1138,-9.87455 20.2909,2.80616 20.2909,2.80616 z' id='path6225-7-7' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 999.48563,333.97523 c 0,0 37.31657,-16.3829 43.93317,-15.07216 0,0 7.8281,-1.96762 12.0386,-5.24302 4.2137,-3.27537 13.8436,-11.13987 13.8436,-11.13987 0,0 -6.6195,-45.21952 40.9256,-40.63038 47.5479,4.58614 110.1364,10.48604 122.7767,12.45067 12.6373,1.9646 58.9794,15.07215 69.8123,20.31517 10.8328,5.24303 81.4216,37.19455 95.8663,42.43755 8.5544,3.10284 27.4261,14.90265 41.394,24.01433 9.6208,6.27229 -0.2965,1.783 -0.2965,1.783 0,0 -114.3203,-60.68821 -154.7302,-68.80401 -10.113,-2.03121 0.6932,11.57884 0.6932,11.57884 0,0 -26.2614,-10.35585 -37.0942,-14.94196 -10.836,-4.58614 -19.8613,-6.55379 -30.0927,-5.89993 -10.2314,0.65691 -18.0539,-1.30772 -24.0719,-3.27537 -6.0209,-1.9646 -40.3241,-3.27537 -46.3419,-3.93225 -6.018,-0.65389 -10.8331,-1.96463 -10.8331,-1.96463 l 2.4061,3.93228 -16.8509,-2.62154 -4.8148,7.20765 c 0,0 -16.2494,3.27537 -17.4555,-1.96762 -1.2,-5.24003 -9.6299,23.59357 -13.8433,32.11196 -4.2133,8.52141 -19.8613,8.51839 -24.6761,13.76441 -4.812,5.24302 -7.8227,8.51839 -10.2257,9.82916 -2.4087,1.31074 -14.4448,8.51839 -18.661,8.51839 -4.2136,0 -30.0868,1.96762 -30.0868,1.96762 l -6.62256,-10.48601 3.00759,-3.93228 z' id='path6229-6-7' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1048.5477,439.93747 c 0,0 0.6666,33.08667 -1.2296,35.47509 -1.8992,2.39147 -18.6374,1.70432 -18.6909,-22.96996 -0.049,-24.6743 4.5067,-25.47342 4.5067,-25.47342 l 15.8938,11.99956' id='path6233-7-5' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1052.5685,414.55788 c 0,0 -3.1673,-14.3245 -5.4341,-16.30122 -2.2638,-1.97673 0.9067,-3.95042 0.9067,-3.95042 0,0 -5.8847,-14.32745 -9.5085,-16.79457 -3.6238,-2.47015 0.4505,-4.4469 0.4505,-4.4469 0,0 -6.338,-9.88062 -10.8656,-12.84117 -4.5275,-2.9666 0,-3.46002 0,-3.46002 0,0 -4.7319,-13.26494 -15.7664,-19.34345 0,0 -7.3155,-7.695 -14.77662,-9.81401 -7.46987,-2.12204 -25.97395,-4.08967 -48.34505,-3.68102 -23.56808,0.42987 -33.55961,16.76435 -33.55961,16.76435 l -1.50509,18.95295 3.39556,-2.31274 -4.98388,23.59357 c -0.78808,5.3974 4.22552,14.7755 4.5039,26.05464 0.0853,3.569 0.3081,7.3045 0.71131,11.13083 1.07241,10.11974 3.44002,20.86611 8.03567,30.76488 0.36445,0.781 0.69917,3.0756 1.1378,2.33088 1.15253,-1.97974 3.73648,6.68094 6.06248,9.78678 0,0 1.3955,11.77559 2.50952,7.41044 0.43268,-1.69519 4.21362,6.66881 6.54841,11.91486 0.84753,1.91012 5.30671,14.87235 5.13793,8.96943 -0.1861,-6.45689 3.91715,13.75536 3.91715,16.65535 l 5.43414,-7.90387 2.71707,8.89374 4.52483,-0.49645 -1.35725,8.3973 c 0,0 12.67888,-10.371 13.13534,-14.32444 0.44742,-3.95043 0.90362,-6.914 0.90362,-6.914 l 4.07431,-3.95345 6.34086,-9.88059 c 0,0 15.8522,12.35074 17.6597,16.79761 1.8103,4.44385 3.6268,8.3973 3.6268,8.3973 l 4.0741,-3.95345 3.6209,8.89072 2.2669,-4.44385 2.1985,6.17237 0.1913,-0.37841 1.4487,4.07152 c 1.0934,1.02619 3.6298,1.54383 8.3826,-6.40845 6.7914,-11.3609 6.3439,-20.25162 6.7914,-22.22834 0.4533,-1.9767 3.1704,3.457 3.1704,3.457 0,0 5.8875,-10.86747 4.9808,-17.78147 -0.9068,-6.91702 3.6266,-4.44687 3.6266,-4.44687 0,0 0.9039,-18.27788 0,-22.72175 -0.9096,-4.44687 3.1647,-3.457 3.1647,-3.457 0,0 -1.3572,-21.73491 -2.7173,-24.20506 -1.3598,-2.47015 3.1676,-2.96358 3.1676,-2.96358 z' id='path6257-2-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41959441' /%3E %3Cpath d='m 1020.8373,364.27092 c 3.1942,0.95659 4.7559,4.56192 6.1248,7.35899 -0.085,-0.17266 0.2016,-0.98383 0.036,-1.32891 -1.3689,-2.79707 -2.9601,-6.44785 -6.1602,-7.40745 0.026,0.005 -0.2145,1.31382 0,1.37737' id='path6259-5-8' /%3E %3Cpath d='m 1023.7263,377.92939 c 5.9053,4.99481 6.4122,11.8089 6.0831,19.26779 0,0.22409 0.08,1.54383 0.1163,0.69625 0.3497,-7.89178 0.2559,-15.88345 -6.1987,-21.34137 0.1474,0.12717 -0.2696,1.14729 0,1.37733' id='path6261-2-6' /%3E %3Cpath d='m 1035.9962,384.91607 c 3.2506,5.34897 3.5558,11.24585 3.5618,17.42423 0,0.78403 0.137,0.78403 0.137,0 0,-6.56286 -0.168,-12.99856 -3.6654,-18.75315 0.088,0.14216 -0.2275,1.01407 -0.034,1.32892' id='path6263-0-2' /%3E %3Cpath d='m 1040.3016,410.71338 c -0.3673,3.82028 -1.0577,7.5739 -1.7925,11.33665 -0.054,0.26943 0.046,1.31079 0.067,1.18667 0.7496,-3.82933 1.4459,-7.65868 1.8191,-11.55162 0.026,-0.17266 -0.047,-1.51054 -0.096,-0.9717' id='path6265-5-1' /%3E %3Cpath d='m 1036.3253,430.51393 c 0.3081,2.50344 0.6281,4.98574 0.3613,7.51945 -0.026,0.1755 0.039,1.51054 0.096,0.9717 0.3379,-3.18454 0.028,-6.30253 -0.3613,-9.46285 -0.065,-0.54186 -0.1163,0.7931 -0.096,0.9717' id='path6267-8-0' /%3E %3Cpath d='m 1028.7192,405.66408 c 0,4.22893 0.034,8.45181 0.3792,12.66864 0.046,0.53881 0.1137,-0.79312 0.098,-0.97475 -0.32,-3.89292 -0.3407,-7.78885 -0.3407,-11.69389 0,-0.781 -0.137,-0.781 -0.137,0' id='path6269-8-9' /%3E %3Cpath d='m 1025.4865,433.09913 c 0.3287,4.01398 0.3406,8.03706 0.3406,12.06317 0,0.78402 0.137,0.78402 0.137,0 0,-4.35 -0.026,-8.70002 -0.3823,-13.03488 -0.046,-0.53886 -0.1085,0.7931 -0.096,0.97171' id='path6271-3-4' /%3E %3Cpath d='m 1043.5995,429.60884 c 1.748,1.84655 2.8207,4.01398 3.2177,6.55074 0.041,0.26635 0.088,-0.20575 0.093,-0.24814 0.026,-0.30877 0.026,-0.63266 -0.026,-0.94143 -0.4117,-2.59732 -1.4991,-4.84647 -3.286,-6.73842 0.1629,0.1755 -0.2636,1.09882 0,1.37733' id='path6273-6-6' /%3E %3Cpath d='m 1042.5152,401.92253 c 1.7953,1.5015 3.2562,3.32383 4.699,5.16734 -0.168,-0.21505 0.2482,-1.05946 0,-1.3743 -1.4428,-1.84351 -2.9006,-3.66892 -4.699,-5.17039 0.1499,0.12407 -0.2699,1.15036 0,1.37735' id='path6275-4-1' /%3E %3Cpath d='m 1027.6315,422.64335 c -0.026,3.77485 -0.3554,7.51037 -1.0489,11.21864 -0.057,0.26938 0.044,1.31071 0.065,1.18964 0.7705,-4.09873 1.0905,-8.23686 1.1171,-12.40828 0,-0.781 -0.1267,-0.781 -0.1344,0' id='path6277-9-3' /%3E %3Cpath d='m 1019.7055,430.88324 c 0.3081,3.37224 0.3081,6.73237 0,10.10159 0,0.1786 0.052,1.51054 0.096,0.97173 0.3644,-4.02006 0.3644,-8.02799 0,-12.045 -0.047,-0.53886 -0.1086,0.79307 -0.096,0.97168' id='path6279-2-0' /%3E %3Cpath d='m 876.24364,339.48768 c 0,0 -9.05793,34.02208 -2.2637,37.47303 13.29223,6.75359 21.87922,-23.55121 23.09404,-35.00893 1.35698,-12.81995 -20.83034,-2.4641 -20.83034,-2.4641' id='path6281-8-3' style='fill:%23452c25' /%3E %3Cpath d='m 876.24364,339.48768 c 0,0 -9.05793,34.02208 -2.2637,37.47303 13.29223,6.75359 21.87922,-23.55121 23.09404,-35.00893 1.35698,-12.81995 -20.83034,-2.4641 -20.83034,-2.4641 z' id='path6283-8-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 895.83822,339.21522 c 0,0 -17.20629,17.75118 -16.75008,27.61363 0.44741,9.8594 25.35775,-13.3134 27.61861,-17.75422 2.26681,-4.43476 -10.86853,-9.85941 -10.86853,-9.85941' id='path6285-8-0' style='fill:%23452c25' /%3E %3Cpath d='m 895.83822,339.21522 c 0,0 -17.20629,17.75118 -16.75008,27.61363 0.44741,9.8594 25.3549,-13.3134 27.61861,-17.75422 2.26681,-4.43476 -10.86853,-9.85941 -10.86853,-9.85941 z' id='path6287-5-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 602.35455,341.71564 c 0,0 -35.55373,17.84503 -38.66497,25.47952 -3.11692,7.63444 107.23863,-11.56675 167.87148,-54.42203 l -24.59319,-14.56361 -104.61332,43.50612 z' id='path6289-9-1' style='fill:%23452c25' /%3E %3Cpath d='m 602.35455,341.71564 c 0,0 -35.55373,17.84503 -38.66497,25.47952 -3.11692,7.63444 107.23863,-11.56675 167.87148,-54.42203 l -24.59319,-14.56361 -104.61332,43.50612 z' id='path6291-6-3' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 643.91416,348.88695 c 0,0 -64.35149,23.40592 -17.5591,24.35035 0,0 92.72873,-19.30408 142.12861,-57.06169 l -12.47753,-18.46559 -111.28012,49.64219' id='path6293-7-5' style='fill:%23452c25' /%3E %3Cpath d='m 644.32022,348.11957 c 0,0 -64.75755,24.1733 -17.96516,25.11773 0,0 92.72873,-19.30408 142.12861,-57.06169 l -12.47753,-18.46559 -111.68592,50.40955 z' id='path6295-2-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 739.43389,283.54299 c 0,0 -68.37231,35.00895 -60.67731,38.95332 7.695,3.94435 56.14964,-6.90492 81.50765,-22.68242 25.36059,-15.77748 36.22912,-24.65308 36.22912,-24.65308 l -30.33878,-8.38215 -26.72068,16.76433 z' id='path6297-7-6' style='fill:%23452c25' /%3E %3Cpath d='m 739.43389,283.54299 c 0,0 -68.37231,35.00895 -60.67731,38.95332 7.695,3.94435 56.14964,-6.90492 81.50765,-22.68242 25.36059,-15.77748 36.22912,-24.65308 36.22912,-24.65308 l -30.33878,-8.38215 -26.72068,16.76433 z' id='path6299-2-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 713.61399,360.3326 c 0,0 -24.42751,20.44839 -21.59775,22.77625 2.82976,2.33088 52.77786,-5.54575 91.69149,-36.07751 l -4.92469,-18.02665 -65.66997,30.36528' id='path6301-3-8' style='fill:%23452c25' /%3E %3Cpath d='m 713.61399,360.3326 c 0,0 -24.42751,20.44839 -21.59775,22.77625 2.82976,2.33088 52.77786,-5.54575 91.69149,-36.07751 l -4.92469,-18.02665 -65.66997,30.36528' id='path6303-6-5' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 671.10009,357.1571 c 0,0 -23.47038,17.92376 -18.34409,19.4464 5.12888,1.52571 24.96953,15.59887 112.81183,-41.69891 l 10.36477,-6.36608 -15.49675,-21.88328 -89.46008,49.02467' id='path6305-4-4' style='fill:%23452c25' /%3E %3Cpath d='m 671.0378,356.41849 c 0,0 -23.40809,18.66237 -18.2818,20.18501 5.12888,1.52571 24.96953,15.59887 112.81183,-41.69891 l 10.36477,-6.36608 -15.49675,-21.88328 -89.39805,49.76326 z' id='path6307-7-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 652.96614,289.00395 c -73.87441,25.84275 -147.9507,77.31935 -147.9507,77.31935 7.24164,-2.46712 190.09136,-76.07519 190.09136,-76.07519' id='path6309-1-4' style='fill:%23452c25' /%3E %3Cpath d='m 815.05378,404.34429 c 0,0 -15.84646,24.15963 -12.67888,27.12018 3.17043,2.95752 22.64353,12.32652 45.28137,-18.73805 22.64353,-31.06153 -21.2837,-26.13333 -21.2837,-26.13333 l -11.31879,17.75118 z' id='path6313-6-4' style='fill:%23452c25' /%3E %3Cpath d='m 815.05378,404.34429 c 0,0 -15.84646,24.15963 -12.67888,27.12018 3.17043,2.95752 22.64353,12.32652 45.28137,-18.73805 22.64353,-31.06153 -21.2837,-26.13333 -21.2837,-26.13333 l -11.31879,17.75118 z' id='path6315-9-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 832.26317,421.60507 c 0,0 -10.86853,25.14647 -4.98078,27.6136 5.8844,2.4641 20.82724,-1.48028 33.50896,-24.16265 12.67888,-22.68243 -5.8875,-11.33973 -5.8875,-11.33973 l -22.64068,7.88875 z' id='path6337-3-3' style='fill:%23452c25' /%3E %3Cpath d='m 797.39413,384.13201 c 0,0 -24.00077,29.09086 -19.01999,33.03526 4.98387,3.94437 32.15507,3.45395 52.53205,-25.14653 20.37672,-28.5974 0.45026,-1.47725 0.45026,-1.47725 l -5.88466,-26.1333 -28.53102,18.24457' id='path6317-8-9' style='fill:%23452c25' /%3E %3Cpath d='m 832.26317,421.60507 c 0,0 -10.86853,25.14647 -4.98078,27.6136 5.8844,2.4641 20.82724,-1.48028 33.50896,-24.16265 12.67888,-22.68243 -5.8875,-11.33973 -5.8875,-11.33973 l -22.64068,7.88875 z' id='path6339-5-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 797.39413,384.13201 c 0,0 -24.00077,29.09086 -19.01999,33.03526 4.98387,3.94437 32.15507,3.45395 52.53205,-25.14653 20.37672,-28.5974 0.45026,-1.47725 0.45026,-1.47725 l -5.88466,-26.1333 -28.53102,18.24457' id='path6319-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 774.30008,369.33836 c 0,0 -23.09404,27.6136 -20.83033,32.04838 2.2668,4.44083 33.51205,2.96058 59.32317,-24.15965 25.81111,-27.1202 4.98103,-36.97963 4.98103,-36.97963 l -43.01766,27.61063' id='path6321-1-7' style='fill:%23452c25' /%3E %3Cpath d='m 774.30008,369.33836 c 0,0 -23.09404,27.6136 -20.83033,32.04838 2.2668,4.44083 33.51205,2.96058 59.32317,-24.15965 25.81111,-27.1202 4.98103,-36.97963 4.98103,-36.97963 l -43.01766,27.61063' id='path6323-0-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 733.54639,371.31206 -14.94258,19.72183 c 0,0 4.07405,19.22848 54.78955,-15.77745 50.7155,-35.00898 48.00128,-32.04843 48.00128,-32.04843 l -27.17404,-4.9312 -61.13067,31.55495' id='path6325-3-5' style='fill:%23452c25' /%3E %3Cpath d='m 733.31816,370.5719 -14.71435,20.46199 c 0,0 4.07405,19.22848 54.78955,-15.77745 50.7155,-35.00898 48.00128,-32.04843 48.00128,-32.04843 l -27.17404,-4.9312 -60.90244,32.29509 z' id='path6327-9-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 571.7878,341.10717 -32.14629,14.44861 c 0,0 -7.26541,6.36909 11.61526,6.84434 18.88042,0.47526 57.88605,-4.74349 125.74581,-43.22159 30.68229,-17.39999 50.11404,-33.98274 50.11404,-33.98274 l -24.72088,-9.18437 -130.60794,65.09575 z' id='path6329-5-8' style='fill:%23452c25' /%3E %3Cpath d='m 571.7878,341.10717 -32.14629,14.44861 c 0,0 -7.26541,6.36909 11.61526,6.84434 18.88042,0.47526 57.88605,-4.74349 125.74581,-43.22159 30.68229,-17.39999 50.11404,-33.98274 50.11404,-33.98274 l -24.72088,-9.18437 -130.60794,65.09575 z' id='path6331-1-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 516.73434,361.37998 c 0,0 46.25013,-5.0281 64.62988,-17.07914 0,0 -3.75716,5.6214 19.88794,-3.61139 0,0 -11.77214,21.17791 57.18973,-20.79953 68.96215,-41.98348 0.56296,-0.84758 0.56296,-0.84758 l 76.5889,-43.87848 -4.47701,-8.75148 c 0,0 -146.33602,62.67401 -157.4059,66.1643 -11.07298,3.49337 -56.9765,28.8033 -56.9765,28.8033' id='path6333-6-4' style='fill:%23452c25' /%3E %3Cpath d='m 658.72337,319.46613 76.87038,-44.30227 -4.47701,-8.75148 c 0,0 -146.33602,62.67401 -157.4059,66.1643 -11.07298,3.49337 -56.9765,28.8033 -56.9765,28.8033 0,0 46.25013,-5.0281 64.62988,-17.07914 0,0 -3.75716,5.6214 19.88794,-3.61139 0,0 -11.49067,20.75412 57.47121,-21.22332 z' id='path6335-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 852.64015,420.53949 c 0,0 -4.52767,36.65876 0.90646,38.01489 5.4344,1.35921 20.8275,-10.18027 27.16836,-32.5842 6.34085,-22.40387 -24.90155,-19.68553 -24.90155,-19.68553 l -4.52741,12.89566' id='path6341-5-4' style='fill:%23452c25' /%3E %3Cpath d='m 852.64015,420.53949 c 0,0 -4.52767,36.65876 0.90646,38.01489 5.4344,1.35921 20.8275,-10.18027 27.16836,-32.5842 6.34085,-22.40387 -24.90155,-19.68553 -24.90155,-19.68553 l -4.52741,12.89566' id='path6343-6-6' style='fill:none;stroke:%23000000;stroke-width:1.66218317' /%3E %3Cpath d='m 876.63781,437.38254 c 0,0 -2.71706,25.63991 0.90673,28.10401 3.62379,2.46715 12.67887,3.454 23.5443,-17.74816 10.86853,-21.2021 5.8875,-13.31337 5.8875,-13.31337 l -24.45103,-13.31338 -5.8875,13.8068' id='path6345-5-5' style='fill:%23452c25' /%3E %3Cpath d='m 876.63781,436.15051 c 0,0 -2.71706,26.87194 0.90673,29.33604 3.62379,2.46715 12.67887,3.454 23.5443,-17.74816 10.86853,-21.2021 5.8875,-13.31337 5.8875,-13.31337 l -24.45103,-13.31338 -5.8875,15.03887 z' id='path6347-3-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 883.42893,389.55664 c 0,0 -19.92335,43.39113 -8.60172,42.8977 11.32189,-0.49342 26.71783,-33.03827 28.9787,-40.4336 2.26681,-7.39832 -20.37698,-2.4641 -20.37698,-2.4641' id='path6349-1-8' style='fill:%23452c25' /%3E %3Cpath d='m 883.42893,389.55664 c 0,0 -19.92335,43.39113 -8.59862,42.8977 11.31595,-0.49342 26.71473,-33.03827 28.9756,-40.4336 2.26681,-7.39832 -20.37698,-2.4641 -20.37698,-2.4641 z' id='path6351-6-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 881.70156,389.17221 c 0,0 -7.49649,47.81981 3.2061,43.76951 10.69948,-4.05033 16.75602,-40.06127 16.95143,-47.85312 0.19644,-7.79795 -20.15753,4.08361 -20.15753,4.08361' id='path6353-9-0' style='fill:%23452c25' /%3E %3Cpath d='m 881.70156,389.17221 c 0,0 -7.49649,47.81981 3.2061,43.76951 10.69948,-4.05033 16.75602,-40.06127 16.95143,-47.85312 0.19644,-7.79795 -20.15753,4.08361 -20.15753,4.08361 z' id='path6355-0-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 897.92125,393.99142 c 0,0 -11.77215,36.97962 -0.45336,44.37495 11.32189,7.39832 20.37698,-36.4862 20.83034,-46.34865 0.45336,-9.85941 -20.37698,1.9737 -20.37698,1.9737' id='path6357-9-6' style='fill:%23452c25' /%3E %3Cpath d='m 897.92125,393.99142 c 0,0 -11.77215,36.97962 -0.45336,44.37495 11.32189,7.39832 20.37698,-36.4862 20.83034,-46.34563 0.45336,-9.86243 -20.37698,1.97068 -20.37698,1.97068 z' id='path6359-7-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 851.51114,381.81928 c 0,0 -11.32706,34.02207 -4.53284,37.47302 13.29223,6.75359 24.14809,-23.55118 25.36007,-35.00892 1.35699,-12.81995 -20.82723,-2.4641 -20.82723,-2.4641 z' id='path6363-2-0' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 767.05845,311.65006 c 0,0 -30.33879,25.14648 -26.72094,29.09083 3.62689,3.94437 38.94645,-2.9575 54.79265,-13.80378 15.84957,-10.84927 22.18733,-16.76732 22.18733,-16.76732 l -27.1681,-16.76433 -23.09094,18.2446 z' id='path6367-4-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 793.77318,286.01011 c 0,0 -19.46715,15.7775 -15.8493,19.72188 3.62379,3.9474 38.48998,-10.35283 44.828,-17.25778 6.34086,-6.9019 5.8875,-14.29723 5.8875,-14.29723 l -34.8662,11.83313 z' id='path6371-5-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 813.6968,283.54299 c 0,0 -26.26448,21.69557 -19.92646,29.5843 6.34086,7.88875 43.02024,-27.1202 47.99817,-31.55498 4.98104,-4.44082 -30.79188,0.98383 -30.79188,0.98383' id='path6375-8-6' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 801.92464,273.68356 -52.97946,25.1465 c 0,0 -44.83085,29.09088 -40.30318,32.0484 4.52741,2.96055 39.39645,-6.40845 64.3011,-18.73497 24.90439,-12.32658 52.52869,-33.03528 52.52869,-33.03528' id='path6379-1-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 816.68655,302.30223 c 0,0 -57.32905,49.28496 -48.72138,54.21618 8.59862,4.92815 46.93663,-15.71073 72.74464,-39.37998' id='path6383-8-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 823.94887,318.53379 c 0,0 -32.4394,54.74895 -28.81871,60.17055 3.62405,5.42465 27.16836,-12.81998 38.94336,-26.62375 11.77525,-13.8068 21.03168,-34.19763 21.03168,-34.19763' id='path6387-4-2' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 842.59821,323.36509 c 0,0 -35.15052,65.3228 -31.07646,70.74742 4.07715,5.42163 24.45413,0.98685 36.68248,-24.65308 12.22267,-25.64295 11.17379,-42.18026 11.17379,-42.18026 l -16.77981,-3.91408 z' id='path6391-0-3' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 863.01965,326.49817 c 0,0 -39.06199,80.62199 -31.36389,88.51072 7.70094,7.88875 50.95252,-61.1453 52.93475,-70.89573 3.48163,-17.14881 -22.02422,-19.09526 -22.02422,-19.09526' id='path6395-8-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 780.64094,273.19013 c 0,0 -35.31955,16.76433 -28.07482,20.21533 7.24164,3.45095 40.30034,-11.33972 44.82801,-12.82 4.53336,-1.48027 -16.75319,-7.39533 -16.75319,-7.39533 z' id='path6399-7-6' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 786.07534,278.61478 c 0,0 -21.73422,17.25776 -17.20655,21.69561 4.52457,4.43777 37.58327,-13.31343 43.92128,-18.73808 6.33802,-5.42465 -26.71473,-2.95753 -26.71473,-2.95753 z' id='path6403-8-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 831.67644,279.99214 c 0,0 -29.70165,39.94015 -20.60211,41.51732 9.10549,1.57413 43.60129,-25.75192 44.07843,-30.48032 0.47999,-4.73145 -23.47632,-11.037 -23.47632,-11.037 z' id='path6407-3-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.50345206' /%3E %3Cpath d='m 844.94205,288.96761 c 0,0 -31.69577,39.93715 -22.64353,42.40428 9.05793,2.4641 9.96181,-3.94438 9.96181,-3.94438 0,0 24.90439,-20.70867 26.71473,-26.13335 1.81345,-5.42465 -13.12939,-12.81995 -13.12939,-12.81995' id='path6411-2-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 854.9067,298.33664 c 0,0 -23.09689,39.94017 -17.20939,42.40425 5.88775,2.46712 15.3962,-7.3953 24.90439,-19.23143 9.50844,-11.83007 -7.695,-23.17282 -7.695,-23.17282 z' id='path6415-9-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 860.79135,316.58126 c 0,0 -13.5856,25.14648 -9.96181,33.03523 3.62095,7.88877 16.75319,-5.91505 23.09405,-14.79063 6.34086,-8.87557 -13.13224,-18.2446 -13.13224,-18.2446 z' id='path6419-5-0' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 866.48939,386.38724 c 0,0 -9.05819,34.0221 -2.26397,37.47303 13.28939,6.75359 21.87922,-23.55121 23.09405,-35.00893 1.35724,-12.81995 -20.83008,-2.4641 -20.83008,-2.4641 z' id='path6423-7-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 928.7134,340.37463 c 0,0 -9.05819,-2.95752 -15.84956,-2.95752 0,0 -19.92336,-15.77751 -30.79189,-17.25778 -10.86543,-1.48028 -1.58522,-1.72546 -1.58522,-1.72546 0,0 -1.13185,-25.88817 -4.30228,-27.85882 0,0 -1.81034,-26.62677 -18.56353,-28.59747 -16.75603,-1.97368 -54.34239,1.47725 -61.13351,-0.98685 -6.79138,-2.46713 -27.60389,-11.14895 -67.01533,-0.4934 -40.3329,10.90376 -119.68333,46.53328 -123.75764,47.52013 -4.07716,0.98685 91.15541,-20.89336 117.87014,-32.72951 0,0 26.71474,-1.97067 34.8662,-4.43477 0,0 -30.33568,14.79065 -2.26397,8.38217 28.07508,-6.4115 21.73422,0 21.73422,0 0,0 -2.71732,6.40848 13.13198,2.95753 15.85241,-3.45398 15.85241,0 15.85241,0 0,0 18.11301,6.40847 32.14913,-1.9737 0,0 7.24448,25.14952 16.30267,28.59745 0,0 10.76178,23.04263 33.40246,27.48041 0,0 10.75583,7.62237 13.01954,9.10267 l 12.79157,4.19861 13.68925,-10.70396' id='path6429-1-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 743.05484,272.20328 c 0,0 -90.55964,32.54186 -87.39515,41.41743 3.17043,8.8756 94.63963,-25.1465 109.12911,-34.51552 14.49516,-9.36601 -20.37698,-7.3953 -20.37698,-7.3953' id='path6433-0-8' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 993.76407,342.37857 c 2.07115,0.34512 3.82514,1.2805 5.6802,2.23709 0.0569,0.0274 0.85043,0.52066 0.99253,0.31787 0.1448,-0.20291 -0.557,-0.82642 -0.60146,-0.86884 -1.11712,-1.10184 -2.46531,-2.14623 -3.85486,-2.86367 -2.36761,-1.21994 -4.67888,-2.49132 -7.33055,-2.93331 -0.5247,-0.0848 1.4309,1.78603 1.56427,1.89502 0.95118,0.76286 2.30532,2.01002 3.54987,2.21584' id='path6735-8-5' /%3E %3Cpath d='m 923.25833,410.75882 c 1.34225,2.57304 1.54954,5.54871 2.89489,8.12179 -0.0853,-0.16646 0.20678,-0.9929 0.0362,-1.32892 -1.34225,-2.57307 -1.54954,-5.54877 -2.8918,-8.12184 0.0827,0.16336 -0.21453,0.99295 -0.0388,1.32897' id='path6737-9-7' /%3E %3Cpath d='m 935.56087,341.01334 c 3.03111,-1.07462 6.24031,-1.10187 9.39575,-1.47722 0.14733,-0.0181 0.0543,-1.38343 0,-1.37738 -3.1526,0.37538 -6.36154,0.40263 -9.39575,1.47725 -0.22229,0.0788 0.0413,1.36223 0,1.37735' id='path6739-7-0' /%3E %3Cpath d='m 953.62968,339.53612 c 2.87112,-1.35918 5.92006,-1.47423 9.03415,-1.47423 0.1008,0 0.1008,-1.3804 0,-1.3804 -3.11409,0.003 -6.16303,0.11812 -9.03415,1.47728 -0.24555,0.11812 0.0775,1.34103 0,1.37735' id='path6741-4-2' /%3E %3Cpath d='m 922.19161,355.51034 c -0.37634,0.0667 -0.39986,0.37236 -0.4208,0.7114 -0.0258,0.30877 -0.031,0.63571 0.0284,0.94146 0.0413,0.26333 0.0853,-0.20574 0.0905,-0.24813 -0.0258,0.25744 0.13699,0.003 0.30216,-0.0274 0.17317,-0.0305 0.0284,-1.38043 0,-1.37735' id='path6743-7-5' /%3E %3Cpath d='m 920.31897,404.18688 c 0,2.54581 0.0258,5.08859 0.39417,7.6072 0.0439,0.26641 0.0931,-0.20575 0.0956,-0.24529 0.0258,-0.3118 0.0258,-0.63267 -0.0284,-0.94449 -0.32309,-2.12808 -0.32594,-4.26827 -0.32594,-6.41752 -0.002,-0.78103 -0.13699,-0.78103 -0.13699,0' id='path6745-4-7' /%3E %3Cpath d='m 938.60103,548.15487 c 0,0 -10.24019,7.92507 -11.39582,11.66057 -1.15279,3.7355 -1.47562,7.33174 -1.47562,7.33174 0,0 9.16752,-1.10792 8.04755,3.9474 0,0 2.97477,1.71334 7.70379,-9.26308 4.72334,-10.97944 9.1944,-15.71694 12.54576,-15.39604 3.35111,0.31482 7.62082,3.57504 9.77209,5.86661 2.15696,2.29457 5.12294,4.00491 8.85658,2.93026 0,0 -3.92026,-5.97257 -1.44616,-7.27726 2.47436,-1.30469 6.24316,-1.05343 6.24316,-1.05343 0,0 -3.12597,-7.44074 -9.84317,-8.51537 -6.7172,-1.07768 -11.36919,-2.94845 -9.77519,-5.87266 1.5971,-2.92424 10.19004,-25.61871 10.19004,-25.61871 l -11.38703,-16.72198 -4.56308,14.54848 c 0,0 1.48441,8.6001 1.54386,10.80387 0.0594,2.20074 -9.05509,21.00232 -10.2818,22.0921 -1.22387,1.09279 -25.63923,10.53145 -28.54601,11.46077 -2.898,0.93236 -8.97522,8.15815 -8.97522,8.15815 l -0.69322,5.42465 c 0,0 4.09188,-3.34497 5.40156,-1.35615 0,0 2.82977,-3.57507 5.37211,-2.23404 2.54234,1.34104 2.14222,1.84958 2.14222,1.84958 0,0 4.51578,-2.97567 5.31576,-4.43475 0.79713,-1.46515 1.01347,-1.2805 1.01347,-1.2805 0,0 2.28128,-0.60542 5.61196,-1.16848' id='path6811-7-8' style='fill:%23bd8759' /%3E %3Cpath d='m 938.60103,548.15487 c 0,0 -10.24019,7.92507 -11.39582,11.66057 -1.15279,3.7355 -1.47562,7.33174 -1.47562,7.33174 0,0 9.16752,-1.10792 8.04755,3.9474 0,0 2.97477,1.71334 7.70379,-9.26308 4.72334,-10.97944 9.1944,-15.71694 12.54576,-15.39907 3.35111,0.31785 7.62082,3.57807 9.77209,5.86964 2.15696,2.29457 5.12294,4.00491 8.85658,2.93026 0,0 -3.92026,-5.97559 -1.44616,-7.27726 2.47436,-1.30469 6.24316,-1.05343 6.24316,-1.05343 0,0 -3.12597,-7.44074 -9.84317,-8.51537 -6.7172,-1.07768 -11.36919,-2.94845 -9.77519,-5.87266 1.5971,-2.92424 10.19004,-25.61873 10.19004,-25.61873 l -11.38703,-16.72196 -4.56308,14.54848 c 0,0 1.48441,8.6001 1.54386,10.80387 0.0594,2.20074 -9.05509,21.00232 -10.2818,22.0921 -1.22387,1.09279 -25.63923,10.53145 -28.54601,11.46077 -2.898,0.93236 -8.97522,8.15815 -8.97522,8.15815 l -0.69322,5.42465 c 0,0 4.09188,-3.34497 5.40156,-1.35615 0,0 2.82977,-3.57507 5.37211,-2.23404 2.54234,1.34104 2.14222,1.84958 2.14222,1.84958 0,0 4.51578,-2.97567 5.31576,-4.43475 0.79713,-1.46515 1.01347,-1.2805 1.01347,-1.2805 0,0 2.28128,-0.60542 5.61196,-1.16848' id='path6813-9-3' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1008.2445,497.78621 c 0,0 0.4149,19.25867 0.4149,22.83979 0,3.58414 -0.4149,8.95733 -2.4713,12.09043 -2.0533,3.13611 -4.1128,4.92818 -7.40164,4.92818 -3.29191,0 -11.92646,-0.44801 -13.57087,2.68509 -1.65035,3.13611 -2.883,4.92818 -2.883,4.92818 0,0 5.34832,-3.13611 6.16897,0 0.82091,3.1331 -2.05331,5.8212 -2.05331,5.8212 0,0 4.93658,0.89605 9.4552,-1.79207 4.52455,-2.68507 6.99275,-3.13308 9.05195,-3.13308 2.0593,0 3.704,2.23705 3.704,2.23705 0,0 1.2324,6.71725 0.8178,10.74941 -0.412,4.02912 -1.2327,12.09343 3.2919,12.09343 0,0 1.6415,-4.03215 3.2888,-4.48019 1.6446,-0.44801 6.1692,4.02915 5.3483,5.37319 0,0 0.8209,-8.50929 -0.8237,-13.43447 -1.6445,-4.92515 -2.4682,-10.30137 -2.4682,-10.30137 0,0 13.9857,4.92821 15.2184,6.71725 1.2355,1.79207 4.5243,4.92818 5.7569,4.48017 1.2327,-0.44801 0,-4.48017 2.4654,-5.37319 2.4712,-0.89602 3.7036,1.34103 3.7036,1.34103 0,0 -4.1126,-9.40231 -10.2815,-12.53844 -6.1693,-3.13308 -10.2818,-3.13613 -12.75,-5.8212 -2.4684,-2.6881 -2.883,-5.8212 -3.2891,-8.95733 -0.4117,-3.13611 0.1086,-30.20787 0.1086,-30.20787 l -10.3914,-2.03726' id='path6815-1-8' style='fill:%23bd8759' /%3E %3Cpath d='m 1008.4502,496.37242 c 0,0 0.2094,20.67246 0.2094,24.25358 0,3.58414 -0.4146,8.95733 -2.471,12.09043 -2.0536,3.13611 -4.1128,4.92818 -7.40188,4.92818 -3.29191,0 -11.9262,-0.44801 -13.57061,2.68509 -1.6444,3.13611 -2.88301,4.92818 -2.88301,4.92818 0,0 5.34833,-3.13611 6.16898,0 0.82375,3.1331 -2.05331,5.8212 -2.05331,5.8212 0,0 4.93632,0.89605 9.45494,-1.79207 4.52459,-2.68507 6.99299,-3.13308 9.05229,-3.13308 2.0592,0 3.7036,2.23705 3.7036,2.23705 0,0 1.2327,6.71725 0.8178,10.74941 -0.4117,4.02912 -1.2324,12.09343 3.2922,12.09343 0,0 1.6413,-4.03215 3.2888,-4.48019 1.6447,-0.44801 6.1692,4.02915 5.3483,5.37319 0,0 0.8209,-8.50929 -0.8237,-13.43447 -1.6444,-4.92515 -2.4682,-10.30137 -2.4682,-10.30137 0,0 13.9855,4.92821 15.2181,6.71725 1.2358,1.79207 4.5246,4.92818 5.7573,4.48017 1.2326,-0.44801 0,-4.48017 2.4653,-5.37319 2.4712,-0.89602 3.7036,1.34103 3.7036,1.34103 0,0 -4.1125,-9.40231 -10.2815,-12.53844 -6.1692,-3.13308 -10.2818,-3.13613 -12.75,-5.8212 -2.4684,-2.6881 -2.8832,-5.8212 -3.289,-8.95733 -0.412,-3.13611 0.1085,-30.20787 0.1085,-30.20787 l -10.5974,-1.65898 z' id='path6817-9-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 922.41079,371.40891 c 0,0 -1.35698,-13.71899 2.4891,-15.19927 0,0 1.36008,-12.57479 18.11611,-10.84932 0,0 5.65927,-9.369 14.71435,-4.4378 0,0 8.60483,-4.18954 13.5856,-1.72544 4.98388,2.46712 11.09366,6.65666 11.54702,7.64351 0,0 7.24164,-1.48027 10.6403,1.23206 3.39866,2.71232 1.81345,11.58794 1.81345,11.58794 0,0 8.14838,6.23895 8.82688,11.74832 0.6785,5.50941 0.6785,7.7283 -1.135,9.20555 0,0 3.6238,2.96055 2.9453,7.15011 -0.6813,4.19264 -4.0771,10.27112 -4.7556,10.27112 -0.6785,0 0.4533,10.93106 -3.16761,14.63019 -3.6238,3.69916 -7.01936,4.4378 -8.60147,4.93123 -1.58547,0.49342 -5.66262,6.4085 -9.51155,7.15014 -3.84892,0.73858 -9.05508,-5.91808 -9.50844,-7.89178 -0.45336,-1.9707 -5.65927,-4.18959 -5.65927,-4.18959 0,0 -11.77525,12.57479 -19.69538,10.60109 -7.92633,-1.97067 -11.77526,-8.63041 -12.4509,-9.86245 -0.68134,-1.23206 -2.94504,-10.35283 -2.94504,-10.35283 0,0 -8.82996,-5.17946 -8.15147,-10.10763 0.67849,-4.93123 4.30229,-10.8493 4.30229,-10.8493 l -3.39867,-10.68585 z' id='path6819-9-5' style='fill:%23dcddde' /%3E %3Cpath d='m 951.84285,527.33112 c -1.07266,0.19386 -1.82223,0.0333 -2.52166,-0.45708' id='path6821-2-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 955.76001,517.37787 c -1.27427,-0.18171 -2.42085,-0.5903 -3.38082,-1.19875' id='path6823-8-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 951.71258,522.4877 c 0.75836,0.42984 1.63536,0.59937 2.52141,0.46013' id='path6825-2-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 943.34788,538.06235 c 0.48593,0.33904 1.06077,0.55096 1.68886,0.59938' id='path6827-6-3' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1013.5928,528.6873 c 1.677,0.29363 3.209,1.18663 4.9363,1.34404' id='path6829-3-5' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1016.4727,523.7591 c -1.3303,0.32997 -2.4681,0.0667 -3.2888,-0.89605' id='path6831-2-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1017.2936,517.9379 c -1.5319,0.19076 -3.1823,0.10288 -4.5245,-0.44801' id='path6833-9-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1011.5364,537.64158 c 1.5646,0.21195 3.0133,0.98081 4.5246,1.34406' id='path6835-2-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1011.9482,543.91082 c 0.7526,-0.1755 1.4668,-0.0364 2.0564,0.44801' id='path6837-6-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1013.1839,560.92943 c 1.0251,-0.1817 2.0236,-0.0333 2.8771,0.44801' id='path6839-9-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 961.76899,538.93116 c -1.29469,0.1998 -2.32884,0.98685 -2.86517,2.25523' id='path6841-03-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 970.15153,539.72426 c -1.8044,1.04133 -3.40745,2.50346 -3.64163,4.59823' id='path6843-85-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 918.13513,548.95707 c 1.40455,1.26837 3.4669,2.01908 4.68173,3.19061' id='path6845-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1028.3961,542.12177 c -1.0636,0.4904 -1.7749,1.45606 -2.0533,2.6881' id='path6847-90-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1034.1562,543.91082 c -0.7289,0.29363 -1.1732,0.93234 -1.2324,1.79207' id='path6849-2-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 905.16005,560.7387 5.86682,-1.51659 0.56605,0.23005 c 0,0 -3.84918,7.43469 -2.80314,9.23583 1.04889,1.80117 -5.24751,-3.26325 -3.62973,-7.94929' id='path6851-2-5' style='fill:%23d9c0b9' /%3E %3Cpath d='m 905.16005,560.7387 5.86966,-1.51659 0.56321,0.23005 c 0,0 -3.84918,7.43469 -2.80314,9.23583 1.04889,1.80117 -5.24751,-3.26325 -3.62973,-7.94929 z' id='path6853-2-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 927.49263,565.13414 c 0,0 -6.49206,10.84323 1.92873,16.2709 0,0 -0.52134,-10.11673 6.08032,-12.29023 l -8.00905,-3.98067 z' id='path6855-3-8' style='fill:%23d9c0b9' /%3E %3Cpath d='m 927.49263,565.13414 c 0,0 -6.49206,10.84323 1.92873,16.2709 0,0 -0.52134,-10.11673 6.08032,-12.29023 l -8.00905,-3.98067 z' id='path6857-3-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 970.593,555.0174 -1.96155,-5.86056 2.28154,-3.08464 4.60754,-0.0514 1.95561,0.92024 c 0,0 3.70986,8.46088 0.46525,12.89566 0,0 -1.37198,-4.77382 -2.9453,-5.4307 0,0 -3.43407,-0.53884 -4.40309,0.61147' id='path6859-0-9' style='fill:%23d9c0b9' /%3E %3Cpath d='m 970.593,555.0174 -1.96155,-5.86056 2.28154,-3.08464 4.60754,-0.0514 1.95561,0.92024 c 0,0 3.70986,8.46088 0.46525,12.89566 0,0 -1.37198,-4.77382 -2.9453,-5.4307 0,0 -3.43407,-0.53884 -4.40309,0.61147 z' id='path6861-7-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 985.00235,542.6152 3.85771,0 1.46684,3.59926 -0.54822,3.33291 -3.33043,1.53171 c 0,0 -5.49048,-1.39852 -4.13944,5.13405 0,0 -2.57491,-11.99961 2.69354,-13.59793' id='path6863-1-5' style='fill:%23d9c0b9' /%3E %3Cpath d='m 985.00235,542.6152 3.85771,0 1.46684,3.59926 -0.54822,3.33291 -3.33043,1.53171 c 0,0 -5.48764,-1.39852 -4.13944,5.13405 0,0 -2.57491,-11.99961 2.69354,-13.59793 z' id='path6865-4-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1012.2415,569.47809 3.9823,-4.39846 4.2816,2.26433 c 0,0 -1.7746,11.60001 -2.4475,12.46579 -0.6725,0.86575 -0.7968,0.99892 -0.7968,1.33193 0,0.33297 -0.6757,-2.19771 -1.9587,-3.66589 -1.2831,-1.46513 -2.6313,-7.86451 -3.0609,-7.9977' id='path6867-6-8' style='fill:%23d9c0b9' /%3E %3Cpath d='m 1012.2415,569.47809 3.9823,-4.39846 4.2816,2.26433 c 0,0 -1.7746,11.60001 -2.4475,12.46579 -0.6725,0.86575 -0.7968,0.99892 -0.7968,1.33193 0,0.33297 -0.6757,-2.19771 -1.9587,-3.66589 -1.2831,-1.46513 -2.6313,-7.86451 -3.0609,-7.9977 z' id='path6869-0-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1038.1979,557.8145 c 0,0 6.4267,7.99769 5.6298,10.59804 0,0 6.6105,-6.66579 -1.8993,-16.12864 l -3.7305,5.5306 z' id='path6871-7-0' style='fill:%23d9c0b9' /%3E %3Cpath d='m 1038.1979,557.8145 c 0,0 6.4267,7.99769 5.6298,10.59804 0,0 6.6105,-6.66579 -1.8993,-16.12864 l -3.7305,5.5306 z' id='path6873-7-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1009.9957,356.14911 c 1.2799,0.36628 2.077,1.30164 2.5126,2.55792 0.026,0.0576 0.08,-0.42079 0.08,-0.4783 0,-0.26033 0.039,-0.59635 -0.046,-0.84758 -0.4356,-1.27446 -1.2446,-2.23406 -2.5452,-2.60942 0.026,0.005 -0.2042,1.31984 0,1.37738' id='path6875-1-3' /%3E %3Cpath d='m 1011.4416,378.29567 c 2.006,2.10387 3.4904,4.54677 4.3201,7.35898 -0.065,-0.22409 0.1525,-0.94443 0.036,-1.32891 -0.8357,-2.83036 -2.3408,-5.29446 -4.3558,-7.40742 0.1628,0.17266 -0.2637,1.10492 0,1.37735' id='path6877-9-0' /%3E %3Cpath d='m 1006.7451,362.05504 c 1.9587,1.69522 3.6178,3.67799 5.4194,5.53664 -0.1654,-0.16956 0.2665,-1.10492 0,-1.37732 -1.8016,-1.85563 -3.4607,-3.84148 -5.4194,-5.53668 0.1473,0.13312 -0.2696,1.14426 0,1.37736' id='path6879-5-9' /%3E %3Cpath d='m 1012.1291,398.8742 c 0.5689,3.31474 -0.1913,6.14515 -1.4252,9.07845 -0.1551,0.36018 0.1163,1.13514 0.039,1.32892 1.5734,-3.7537 2.1482,-7.56791 1.4578,-11.59402 -0.026,-0.12096 -0.1189,0.91725 -0.072,1.18665' id='path6881-5-1' /%3E %3Cpath d='m 1017.1869,410.31985 c 0.2608,1.70427 0.3081,3.38434 0,5.08864 -0.054,0.30272 -0.041,0.63269 -0.026,0.94146 0,0.0424 0.044,0.50854 0.093,0.24529 0.4386,-2.4641 0.3732,-4.99786 0,-7.46193 -0.039,-0.26636 -0.088,0.2029 -0.093,0.24529 -0.026,0.30877 -0.026,0.62961 0.026,0.94141' id='path6883-7-7' /%3E %3Cpath d='m 1036.7163,450.62631 c 1.289,4.61638 1.3927,9.33266 1.3955,14.10043 0,0.78405 0.137,0.78405 0.137,0 0,-5.20668 -0.085,-10.38615 -1.4963,-15.42934 0.065,0.23004 -0.1421,0.94143 -0.036,1.32891' id='path6885-9-3' /%3E %3Cpath d='m 1033.4658,460.00439 c -1.0636,3.25722 -2.1391,6.50837 -3.6148,9.59912 -0.1654,0.34508 0.1215,1.1503 0.036,1.32589 1.4785,-3.08772 2.5483,-6.3419 3.6119,-9.5961 0.1267,-0.37838 -0.1034,-1.11399 -0.034,-1.32891' id='path6887-8-9' /%3E %3Cpath d='m 924.36046,428.8702 c 3.02542,3.94133 4.66104,8.65766 7.21217,12.89566 -0.0853,-0.14527 0.22228,-1.01107 0.0362,-1.32892 -2.56017,-4.25012 -4.20742,-8.98759 -7.24474,-12.94407 0.16801,0.221 -0.24813,1.05644 -0.002,1.37733' id='path6889-7-1' /%3E %3Cpath d='m 943.51382,429.33941 c -2.75868,0.36325 -3.43433,-3.60229 -5.78101,-4.42871 0.0388,0.0129 -0.22228,1.29865 0,1.3743 2.33479,0.82642 3.02517,4.79504 5.78101,4.43176 0.15509,-0.0207 0.0414,-1.3834 0,-1.37735' id='path6891-1-8' /%3E %3Cpath d='m 932.65408,447.67181 c 1.98223,3.47819 3.28622,7.31357 5.4194,10.70397 -0.0853,-0.13622 0.23004,-1.01712 0.0388,-1.32889 -2.13628,-3.39042 -3.44001,-7.22278 -5.42224,-10.70399 0.0853,0.15146 -0.21971,1.00502 -0.0362,1.32891' id='path6893-4-3' /%3E %3Cpath d='m 945.31822,452.12775 c 2.2283,2.67903 4.24309,5.49734 5.39873,8.83627 -0.0672,-0.21195 0.168,-0.95358 0.0388,-1.32891 -1.16753,-3.35713 -3.20016,-6.19356 -5.43724,-8.88471 0.16801,0.2029 -0.25589,1.07161 0,1.37735' id='path6895-6-5' /%3E %3Cpath d='m 944.21583,465.3897 c 1.12307,2.31879 2.1275,4.69508 3.25366,7.01387 -0.0827,-0.17266 0.20161,-0.9838 0.0362,-1.32891 -1.12617,-2.31879 -2.13059,-4.69509 -3.25366,-7.01387 0.0827,0.1786 -0.20161,0.98685 -0.0362,1.32891' id='path6897-3-9' /%3E %3Cpath d='m 956.14229,467.97489 c 0.65187,2.43384 1.01322,4.93123 1.03416,7.45584 0,0.781 0.14216,0.78402 0.13699,0 -0.0284,-2.97265 -0.36471,-5.91203 -1.13496,-8.78475 0.0594,0.23625 -0.14216,0.94144 -0.0362,1.32891' id='path6899-8-1' /%3E %3Cpath d='m 951.0664,478.98158 c 0.7824,3.50543 1.8075,6.93821 3.62974,10.038 -0.0827,-0.14836 0.22228,-1.01107 0.0388,-1.32891 -1.79561,-3.05742 -2.82692,-6.43872 -3.59717,-9.89572 -0.0362,-0.12716 -0.13182,0.92022 -0.0724,1.18663' id='path6901-6-3' /%3E %3Cpath d='m 953.99102,432.19403 c 2.85639,1.09278 5.71588,2.17043 8.67281,2.95445 0,-0.003 0.19902,-1.32589 0,-1.37732 -2.95693,-0.78405 -5.81642,-1.86168 -8.67281,-2.9545 0.0517,0.0207 -0.22745,1.28954 0,1.37737' id='path6903-8-7' /%3E %3Cpath d='m 956.15703,444.37527 c 3.40745,1.89799 6.99867,3.41156 10.4772,5.16729 -0.0853,-0.0424 0.2533,-1.25018 0,-1.3743 -3.47853,-1.75576 -7.06975,-3.27235 -10.4772,-5.17039 0.10339,0.0574 -0.25848,1.23209 0,1.3774' id='path6905-5-6' /%3E %3Cpath d='m 959.41043,458.03371 c 1.76304,2.14021 3.68298,4.10481 5.781,5.90598 -0.1525,-0.13027 0.26959,-1.14426 0,-1.37732 -2.09802,-1.80117 -4.01796,-3.76275 -5.781,-5.90601 0.168,0.20575 -0.25072,1.07163 0,1.37735' id='path6907-8-6' /%3E %3Cpath d='m 963.00475,474.98877 c 1.46658,2.34303 2.15696,4.94332 2.51546,7.68292 0.0362,0.26641 0.0879,-0.20884 0.093,-0.24813 0.0258,-0.3118 0.0258,-0.62969 -0.0284,-0.94146 -0.36445,-2.77895 -1.04888,-5.43677 -2.54234,-7.82214 0.0827,0.13931 -0.23004,1.01709 -0.0388,1.32891' id='path6909-0-7' /%3E %3Cpath d='m 973.10562,432.83574 c 0.32309,1.63466 0.70511,3.25118 1.09928,4.86767 -0.0594,-0.23909 0.13441,-0.93539 0.0388,-1.32589 -0.38513,-1.5711 -0.75552,-3.14215 -1.06957,-4.7284 -0.0517,-0.26338 -0.0853,0.1998 -0.0879,0.24529 -0.0258,0.30877 -0.0388,0.64176 0.0258,0.94146' id='path6911-0-0' /%3E %3Cpath d='m 998.41607,422.71906 c -0.71106,1.79507 -1.56169,3.50541 -2.53045,5.16731 -0.1861,0.32087 0.12148,1.18058 0.0362,1.32892 0.96876,-1.66493 1.8194,-3.37225 2.52735,-5.16732 0.1525,-0.36631 -0.11372,-1.13219 -0.0336,-1.32891' id='path6913-2-3' /%3E %3Cpath d='m 1008.846,422.27407 c 0,2.90302 -0.047,5.79091 -0.6876,8.63944 -0.062,0.2664 0.039,1.31079 0.065,1.18667 0.7288,-3.22393 0.7555,-6.52957 0.7586,-9.82308 0,-0.78406 -0.137,-0.78406 -0.137,-0.003' id='path6915-2-8' /%3E %3Cpath d='m 1011.0327,438.26644 c 0.2639,2.49137 0,4.94338 -0.3467,7.4105 -0.039,0.27246 0.057,1.30167 0.067,1.18662 0.4356,-3.18454 0.7111,-6.36003 0.3733,-9.56882 -0.057,-0.53884 -0.1137,0.79315 -0.096,0.9717' id='path6917-3-0' /%3E %3Cpath d='m 1018.9944,453.42942 c -0.4712,3.42677 -2.5392,6.1663 -5.0224,8.39731 -0.2696,0.23908 0.1525,1.23813 0,1.37737 2.5423,-2.28549 4.6075,-5.08256 5.0904,-8.58803 0.041,-0.27245 -0.054,-1.30167 -0.067,-1.18665' id='path6919-6-1' /%3E %3Cpath d='m 993.35801,438.59036 c -0.71985,1.43486 -1.65319,2.72746 -2.53045,4.0594 -0.12148,0.18455 -0.0543,0.64781 -0.0465,0.85063 0,0.0455 0.0388,0.54794 0.0775,0.47828 0.8801,-1.33194 1.8106,-2.62756 2.53045,-4.0594 0.10856,-0.21479 0.0543,-0.61751 0.0465,-0.84761 0.002,-0.0486 -0.0439,-0.54486 -0.0775,-0.4813' id='path6921-4-9' /%3E %3Cpath d='m 996.2679,458.87225 c -1.08171,1.47118 -2.17789,2.92723 -3.615,4.0594 -0.27269,0.21479 0.14474,1.26538 0,1.37737 1.434,-1.13219 2.53045,-2.58822 3.615,-4.05939 0.11373,-0.15431 0.0646,-0.5116 0.0646,-0.69023 0,-0.0757 -0.0931,-0.65386 -0.0646,-0.68715' id='path6923-2-6' /%3E %3Cpath d='m 987.23349,469.57626 c -3.52893,-3.49336 -5.18522,-7.97353 -3.59432,-13.04399 0.1189,-0.3814 -0.10598,-1.10795 -0.0388,-1.3259 -1.77184,5.6426 -0.60147,11.56065 3.63284,15.74722 -0.16284,-0.16051 0.26648,-1.11397 0,-1.37733' id='path6925-9-6' /%3E %3Cpath d='m 975.27472,458.30922 c 0.27243,2.08869 0.25848,4.11388 -0.34377,6.1239 -0.11631,0.38442 0.10081,1.10492 0.0362,1.32891 0.83849,-2.80012 0.75267,-5.76671 0.37918,-8.63949 -0.0388,-0.26635 -0.0879,0.20575 -0.0905,0.24529 -0.0258,0.3118 -0.0258,0.62964 0.0258,0.94144' id='path6927-1-0' /%3E %3Cpath d='m 1002.7509,471.81632 c -0.7496,2.50344 -2.0977,4.69813 -3.25338,7.0139 -0.16801,0.34206 0.12148,1.15638 0.0388,1.32891 1.15558,-2.31576 2.50668,-4.51348 3.25048,-7.0139 0.1164,-0.38442 -0.1008,-1.10492 -0.036,-1.32891' id='path6929-8-6' /%3E %3Cpath d='m 1020.4581,479.19952 c -1.5288,2.69117 -3.2919,5.22485 -5.0609,7.75254 -0.2016,0.29057 0.1215,1.20782 0.039,1.32591 1.7718,-2.52771 3.5289,-5.05837 5.055,-7.74953 0.1861,-0.32689 -0.1215,-1.17753 -0.034,-1.32892' id='path6931-1-6' /%3E %3Cpath d='m 1029.1103,488.49589 c -0.738,4.73145 -1.1084,9.50222 -1.4697,14.27298 -0.026,0.22694 0.057,1.54389 0.1189,0.69625 0.3466,-4.61033 0.7082,-9.21159 1.4192,-13.78258 0.047,-0.26943 -0.052,-1.30167 -0.067,-1.18665' id='path6933-0-2' /%3E %3Cpath d='m 1040.2838,471.92532 c 0.028,1.60742 0.335,3.19361 0.3616,4.79801 0.026,0.96565 0.137,0.0726 0.1266,-0.36629 -0.026,-1.60741 -0.3349,-3.19361 -0.3585,-4.798 -0.026,-0.96566 -0.137,-0.0695 -0.1292,0.36628' id='path6935-8-7' /%3E %3Cpath d='m 921.43894,419.83719 c -0.67255,4.7496 -0.0879,9.2843 1.46088,13.80985 -0.0698,-0.21195 0.16543,-0.95356 0.0362,-1.32891 -1.27427,-3.70824 -2.00316,-7.22882 -1.42832,-11.29429 0.0388,-0.26943 -0.0569,-1.30472 -0.0672,-1.18665' id='path6937-2-2' /%3E %3Cpath d='m 962.38829,361.02277 c 7.62987,-7.00177 17.70721,-14.3759 28.52819,-11.79678 0,0 0.18868,-1.33194 0,-1.37735 -10.82098,-2.57913 -20.89832,4.79501 -28.52819,11.79678 -0.26958,0.24813 0.15767,1.23206 0,1.37735' id='path6955-0-2' style='fill:%23ffffff' /%3E %3Cpath d='m 999.06794,369.36258 c -7.65649,-5.2067 -21.02885,-7.1108 -28.52818,-0.6932 -0.27269,0.23005 0.14991,1.24714 0,1.37733 7.49933,-6.41755 20.87169,-4.51346 28.52818,0.6932 -0.12665,-0.0879 0.26648,-1.19875 0,-1.37733' id='path6957-3-8' style='fill:%23ffffff' /%3E %3Cpath d='m 969.84343,381.12305 c 3.13476,10.15608 7.18839,20.49681 5.4163,31.35515 -0.0439,0.27246 0.0491,1.30772 0.0672,1.18968 1.91709,-11.76649 -2.02953,-22.7914 -5.45198,-33.87374 0.0698,0.2241 -0.15249,0.94746 -0.0336,1.32891' id='path6959-0-5' style='fill:%23ffffff' /%3E %3Cpath d='m 957.60008,387.29844 c 1.87548,10.27409 0.67565,20.65114 -0.0259,30.97675 -0.0258,0.22693 0.062,1.54385 0.11632,0.69627 0.74078,-10.95222 1.96439,-21.97106 -0.0258,-32.8597 -0.0258,-0.12096 -0.1189,0.91725 -0.0672,1.18668' id='path6961-9-2' style='fill:%23ffffff' /%3E %3Cpath d='m 973.93532,379.75777 c 9.97964,2.36725 19.73984,9.02092 25.11194,18.01759 -0.0853,-0.14527 0.22487,-1.01107 0.0388,-1.32892 -5.38683,-9.02393 -15.1354,-15.68967 -25.14761,-18.06599 0,0.003 -0.19644,1.33496 -0.002,1.37732' id='path6963-2-1' style='fill:%23ffffff' /%3E %3Cpath d='m 965.03738,393.6433 c 0.0362,6.31465 0.52729,12.6353 -1.30968,18.76527 -0.11114,0.38445 0.10339,1.10495 0.0362,1.32892 1.96749,-6.56282 1.4459,-13.3255 1.41333,-20.09419 0,-0.781 -0.14216,-0.78402 -0.13958,0' id='path6965-0-4' style='fill:%23ffffff' /%3E %3Cpath d='m 980.72669,392.25083 c 6.26978,5.18246 11.23583,13.0167 12.17796,21.30808 0.062,0.54186 0.11631,-0.7931 0.0905,-0.97171 -0.95997,-8.46695 -5.84899,-16.40409 -12.27282,-21.71374 0.14733,0.12406 -0.2639,1.15335 0.002,1.37737' id='path6967-6-5' style='fill:%23ffffff' /%3E %3Cpath d='m 934.55644,409.57214 c 2.07709,-2.96357 4.652,-6.34486 8.13363,-7.60719 0.22487,-0.0848 -0.0439,-1.36221 0,-1.38041 -3.50541,1.27443 -6.07438,4.67392 -8.1693,7.65869 -0.20419,0.29665 0.12148,1.20782 0.0362,1.32891' id='path6969-5-0' style='fill:%23ffffff' /%3E %3Cpath d='m 949.49902,355.57998 c -1.32441,-5.64262 -5.55872,-8.97248 -10.09802,-12.00871 0.10856,0.0726 -0.24038,1.06558 0,1.22601 4.50673,3.01504 8.74698,6.34795 10.06261,11.9663 -0.0465,-0.21479 0.1189,-0.83244 0.0362,-1.1836' id='path6971-4-9' style='fill:%23ffffff' /%3E %3Cpath d='m 940.65433,355.4831 c -5.22684,-2.48224 -10.63125,-2.77287 -16.30551,-2.7759 -0.0982,0 -0.0982,1.37738 0,1.37738 5.67426,0.005 11.07867,0.29365 16.30551,2.7759 -0.0801,-0.0393 0.24297,-1.25931 0,-1.37738' id='path6973-5-0' style='fill:%23ffffff' /%3E %3Cpath d='m 956.98673,354.6113 c 0.69038,-5.42163 -0.11115,-10.54353 -4.78537,-13.88856 0.11631,0.0848 -0.23521,1.03834 0,1.2048 3.9231,2.80921 5.35711,6.71727 4.72618,11.6424 -0.0336,0.23908 0.0439,1.13821 0.0594,1.04136' id='path6975-8-1' style='fill:%23ffffff' /%3E %3Cpath d='m 976.64954,361.02277 c 4.91254,-2.60939 10.26396,-2.12201 15.62108,-2.08267 0.0982,0 0.10597,-1.3743 0,-1.3743 -5.36022,-0.0424 -10.70854,-0.52974 -15.62108,2.07962 -0.2533,0.13622 0.0982,1.32592 0,1.37735' id='path6977-4-0' style='fill:%23ffffff' /%3E %3Cpath d='m 985.48234,374.20296 c 7.57946,0.80219 13.35737,4.69511 18.33816,10.41038 -0.3347,-0.38448 0.5156,-2.16742 0,-2.75472 -4.98364,-5.71223 -10.76154,-9.60817 -18.33816,-10.41037 -0.11373,-0.0129 -0.28742,2.72444 0,2.75471' id='path6979-3-5' style='fill:%23ffffff' /%3E %3Cpath d='m 952.16569,395.09029 c -1.79251,7.24696 -0.42054,16.41014 -8.79713,19.37976 -0.44457,0.15741 0.0827,2.72446 0,2.75473 8.48308,-3.00594 7.06096,-12.16609 8.86536,-19.47969 0.19644,-0.78405 -0.1861,-2.17955 -0.0672,-2.65483' id='path6981-8-0' style='fill:%23ffffff' /%3E %3Cpath d='m 969.8256,389.42042 c 2.90678,7.61935 6.963,15.39608 5.39872,23.85393 -0.0982,0.53882 0.0905,2.61849 0.13699,2.3763 1.91994,-10.41941 -1.81344,-19.31925 -5.46696,-28.88503 0.1525,0.40265 -0.35256,1.91924 -0.0672,2.6548' id='path6983-2-6' style='fill:%23ffffff' /%3E %3Cpath d='m 980.72669,388.07941 c 7.38975,0.94144 13.8937,7.51942 14.87435,15.07821 0.0698,0.53281 0.18352,-0.4147 0.1861,-0.49343 0.0336,-0.62661 0.031,-1.26233 -0.0543,-1.88592 -0.99848,-7.69198 -7.4342,-14.4879 -15.00772,-15.45353 -0.0956,-0.0129 -0.30525,2.71836 0,2.75467' id='path6985-3-2' style='fill:%23ffffff' /%3E %3Cpath d='m 980.6613,398.99532 c 1.15874,6.32972 2.95125,12.66557 0.70822,18.99534 -0.26365,0.74468 0.22228,2.23703 0.0724,2.6548 2.79435,-7.89482 0.80902,-16.0681 -0.64592,-24.02951 -0.0439,-0.23909 -0.23005,1.83751 -0.13441,2.37937' id='path6987-8-8' style='fill:%23ffffff' /%3E %3Cpath d='m 976.64954,371.42711 c 8.13053,-1.37435 16.73509,-2.60032 23.77256,2.77585 -0.2787,-0.21505 0.5392,-2.34301 0,-2.75471 -7.03747,-5.37316 -15.64203,-4.15017 -23.77256,-2.77584 -0.33188,0.0574 -0.0569,2.76377 0,2.7547' id='path6989-2-8' style='fill:%23ffffff' /%3E %3Cpath d='m 961.77804,355.27725 c 0.9747,-6.72327 6.89477,-11.52738 12.83887,-13.69178 0.45026,-0.16335 -0.093,-2.71836 0,-2.75165 -6.13356,2.23099 -11.97376,7.17431 -12.97534,14.06409 -0.0905,0.62056 -0.0827,1.26233 -0.0517,1.88592 0,0.0848 0.10856,1.02621 0.1861,0.49342' id='path6991-6-5' style='fill:%23ffffff' /%3E %3Cpath d='m 954.35263,359.31545 c -0.19903,-7.45281 -3.4638,-13.45258 -6.67584,-19.97003 0.14733,0.30272 -0.36445,1.7436 -0.0646,2.35205 2.88016,5.83335 6.33491,11.53645 6.5099,18.2658 0.0465,1.71339 0.2533,0.13311 0.23004,-0.64782' id='path6993-3-8' style='fill:%23ffffff' /%3E %3Cpath d='m 947.51085,363.30829 c -1.449,-6.63552 -5.82831,-11.03398 -11.61526,-14.06716 0.1861,0.0998 -0.50661,2.4883 0,2.75471 5.59154,2.92725 10.06545,7.23486 11.47904,13.6918 0.0594,0.24813 0.25331,-1.84356 0.13699,-2.37935' id='path6995-5-9' style='fill:%23ffffff' /%3E %3Cpath d='m 936.57718,360.65047 c -3.79567,-2.64273 -7.78391,-5.13105 -12.40024,-5.8394 -0.062,-0.0103 -0.25072,2.10994 0,2.14626 4.61633,0.70834 8.60172,3.19366 12.40024,5.83937 -0.20161,-0.14216 0.4208,-1.85566 0,-2.14623' id='path6997-2-7' style='fill:%23ffffff' /%3E %3Cpath d='m 960.25486,391.84216 c 0.65187,7.05021 1.52912,14.17008 -1.97913,20.59973 -0.35876,0.65688 0.24555,2.33998 0.0724,2.6548 4.20148,-7.70712 2.87396,-16.81581 2.09777,-25.20096 -0.0982,-1.0807 -0.22229,1.58922 -0.18869,1.94643' id='path6999-9-7' style='fill:%23ffffff' /%3E %3Cpath d='m 968.46551,388.03098 c 2.35572,6.62944 5.13793,13.68268 4.67268,20.87518 -0.0284,0.45408 0.12406,3.08769 0.23521,1.39252 0.56605,-8.7636 -1.93493,-16.77042 -4.83552,-24.92253 0.14733,0.41474 -0.33498,1.90712 -0.0698,2.65483' id='path7001-7-7' style='fill:%23ffffff' /%3E %3Cpath d='m 973.93532,378.3653 c 6.74097,2.07055 13.43155,4.27737 18.3353,9.71411 -0.33188,-0.3693 0.52159,-2.17954 0,-2.75165 -4.90375,-5.43982 -11.59433,-7.64661 -18.3353,-9.71716 0.0491,0.0155 -0.42364,2.62453 0,2.7547' id='path7003-1-5' style='fill:%23ffffff' /%3E %3Cpath d='m 955.69178,363.39 c 0.71416,-5.86662 1.34225,-11.71201 1.39859,-17.62706 0.0258,-1.56808 -0.25588,-1.56503 -0.26958,0 -0.0517,5.25817 -0.68444,10.47092 -1.32158,15.6806 -0.0413,0.35724 0.062,3.02413 0.19386,1.94646' id='path7005-0-9' style='fill:%23ffffff' /%3E %3Cpath d='m 943.3714,359.65147 c -4.97793,-2.26428 -9.40169,-5.49426 -13.5856,-9.01784 0.29957,0.25124 -0.54201,2.29762 0,2.75468 4.18391,3.52663 8.60767,6.75661 13.5856,9.02094 -0.14991,-0.0695 0.48309,-2.53679 0,-2.75778' id='path7007-7-6' style='fill:%23ffffff' /%3E %3Cpath d='m 941.32998,395.04188 c -3.19705,2.02211 -5.39872,4.84339 -6.82679,8.3761 -0.19385,0.47825 -0.10855,1.19569 -0.0956,1.69517 0.002,0.10597 0.1189,1.08072 0.16801,0.95963 1.41023,-3.49332 3.60001,-6.28133 6.7526,-8.2762 0.53349,-0.33602 -0.23779,-2.60642 0,-2.7547' id='path7009-2-4' style='fill:%23ffffff' /%3E %3Cpath d='m 950.03251,400.21524 c -0.12407,4.83135 -2.7853,8.83321 -5.98546,12.17214 -0.52728,0.55096 0.32594,2.41264 0,2.7547 3.85797,-4.02611 6.0979,-8.51534 6.24316,-14.19428 0.0258,-0.87788 -0.20678,-2.6639 -0.25848,-0.73256' id='path7011-1-1' style='fill:%23ffffff' /%3E %3Cpath d='m 972.83319,362.21849 c 4.00891,-6.33277 13.69803,-6.85951 20.16942,-8.62733 0.4058,-0.10908 -0.0258,-2.74563 0,-2.75168 -6.55436,1.78905 -16.18713,2.31879 -20.24076,8.72421 -0.39107,0.61755 0.24296,2.38542 0.0698,2.6548' id='path7013-5-3' style='fill:%23ffffff' /%3E %3Cpath d='m 928.28356,362.1156 c -1.55265,-0.46619 -2.97477,-1.26233 -4.3881,-2.05546 0.12407,0.0695 -0.31999,1.51964 0,1.7013 1.41618,0.79307 2.83545,1.59224 4.3881,2.05842 -0.0284,-0.0103 0.25847,-1.62559 0,-1.70426' id='path7015-6-6' style='fill:%23ffffff' /%3E %3Cpath d='m 929.16366,394.51813 c -1.3986,0.57216 -2.84165,1.15638 -3.80757,2.3945 -0.22745,0.29062 -0.1344,1.03526 -0.1344,1.37737 0,0.32387 0,0.65084 0.0388,0.97168 0,-0.0455 0.0646,0.43894 0.0956,0.40262 0.96592,-1.23508 2.40897,-1.82234 3.80757,-2.39147 0.21453,-0.0879 0.13441,-1.20779 0.13441,-1.37732 0,-0.0695 -0.062,-1.40765 -0.13441,-1.37738' id='path7017-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 935.02169,396.01053 c -2.87422,1.28652 -4.96604,3.77484 -6.76475,6.32067 -0.31689,0.45711 0.18868,1.89802 0.0594,2.08572 1.78088,-2.51856 3.86676,-4.97361 6.70841,-6.24196 0.37634,-0.17266 -0.11631,-2.11294 -0.002,-2.16443' id='path7019-9-3' style='fill:%23ffffff' /%3E %3Cpath d='m 946.11225,398.75618 c -2.50977,6.11483 -9.34845,12.87142 -4.3881,19.70973 -0.17317,-0.23004 0.48593,-2.08569 0.0672,-2.65483 -3.43123,-4.73744 2.61342,-10.06222 4.39119,-14.40009 0.29621,-0.72352 -0.23004,-2.26736 -0.0698,-2.65481' id='path7021-8-1' style='fill:%23ffffff' /%3E %3Cpath d='m 953.92589,398.65326 c 0.19127,6.2329 -0.90957,12.38401 -1.99128,18.48976 -0.0931,0.54189 0.0905,2.61546 0.13958,2.37935 1.26833,-7.16224 2.33194,-14.30328 2.11276,-21.60173 -0.062,-1.92828 -0.28768,-0.14526 -0.2608,0.73262' id='path7023-4-7' style='fill:%23ffffff' /%3E %3Cpath d='m 973.97099,391.2882 c 4.54214,5.94832 8.56321,12.34772 10.50382,19.69763 -0.12148,-0.46618 0.27838,-1.87685 0.0698,-2.6548 -1.95251,-7.39227 -6.00898,-13.81592 -10.57491,-19.79753 0.33473,0.44196 -0.49187,2.10991 0,2.7547' id='path7025-3-4' style='fill:%23ffffff' /%3E %3Cpath d='m 976.31172,386.49924 c 7.46987,5.69103 15.78701,11.04303 21.04952,19.09826 -0.17576,-0.26034 0.46499,-2.04938 0.0672,-2.6548 -5.28913,-8.09763 -13.61222,-13.47686 -21.1206,-19.19814 0.28122,0.21505 -0.53349,2.34601 0.002,2.75468' id='path7027-8-7' style='fill:%23ffffff' /%3E %3Cpath d='m 980.70576,376.67008 c 2.7853,-0.26938 5.3721,-0.16335 8.01809,0.81132 2.36761,0.8748 4.3289,2.83038 6.48328,4.12903 2.17169,1.30772 4.36457,2.49434 6.13637,4.36209 2.3201,2.43988 2.3408,6.59915 3.0252,9.73831 0.044,0.21195 0.2094,-1.57108 0.1163,-2.02819 -0.557,-2.57609 -0.8504,-5.18243 -1.7302,-7.6738 -0.8535,-2.43383 -2.95719,-3.9292 -5.01076,-5.24 -2.45627,-1.57107 -4.86808,-3.16337 -7.30393,-4.76472 -2.8918,-1.90104 -6.42667,-2.00396 -9.73358,-1.68309 -0.24038,0.0233 -0.10597,2.35815 0,2.34905' id='path7029-3-2' style='fill:%23ffffff' /%3E %3Cpath d='m 998.99376,391.9693 c 0.82091,2.41262 1.78964,4.77077 2.61654,7.18041 -0.096,-0.27551 0.2093,-1.23814 0.046,-1.72552 -0.8238,-2.41263 -1.78966,-4.77076 -2.61652,-7.18035 0.0956,0.27848 -0.21453,1.24111 -0.0465,1.72546' id='path7031-1-6' style='fill:%23ffffff' /%3E %3Cpath d='m 978.06882,353.89086 c 5.26225,-1.44699 10.64314,-2.40357 15.81363,-4.18959 0.44147,-0.15147 -0.0749,-2.72749 0,-2.75171 -5.17049,1.783 -10.55138,2.73961 -15.81363,4.18659 -0.40296,0.11192 0.0284,2.74861 0,2.75471' id='path7033-3-6' style='fill:%23ffffff' /%3E %3Cpath d='m 956.14229,356.53351 c 0.73769,-2.79102 1.92899,-5.06442 3.51989,-7.44374 1.95871,-2.92423 2.23424,-6.59008 4.64037,-9.26308 0.51849,-0.57515 -0.32904,-2.38234 0,-2.75165 -1.98223,2.19769 -2.66977,5.02508 -3.81067,7.71015 -1.36293,3.22086 -3.50231,5.6002 -4.42067,9.09352 -0.20677,0.77798 0.19644,2.18862 0.0698,2.6548' id='path7035-8-5' style='fill:%23ffffff' /%3E %3Cpath d='m 938.17429,405.7761 c -0.93619,4.53166 -0.76147,9.26006 0.90956,13.58583 -0.15508,-0.39959 0.35566,-1.91918 0.0698,-2.6548 -1.09334,-2.83945 -1.46968,-5.52152 -0.84443,-8.55168 0.12407,-0.59937 0.0801,-1.27745 0.0465,-1.88592 0,-0.0938 -0.0775,-1.01409 -0.18351,-0.49343' id='path7037-9-0' style='fill:%23ffffff' /%3E %3Cpath d='m 949.07823,414.34596 c -1.88453,2.56702 -1.91115,6.47808 -0.91551,9.42653 0.0388,0.0998 0.15766,-0.79615 0.16025,-0.90512 0.0258,-0.4934 0.0672,-1.11699 -0.0879,-1.5923 -0.55701,-1.64673 -0.14475,-2.99384 0.84443,-4.3379 0.20936,-0.28757 0.12665,-0.96565 0.12665,-1.29562 0,-0.14526 -0.18093,-1.22899 -0.12665,-1.29559' id='path7039-9-6' style='fill:%23ffffff' /%3E %3Cpath d='m 957.18213,409.99294 c -0.0853,2.60938 -1.47846,5.0886 -2.5687,7.3832 -0.23521,0.5025 0.17576,1.66188 0.0569,1.91616 1.35104,-2.84855 2.59559,-5.56689 2.70208,-8.77265 0.0258,-0.63269 -0.13958,-1.91616 -0.18869,-0.52671' id='path7041-3-0' style='fill:%23ffffff' /%3E %3Cpath d='m 957.43414,394.69674 0,3.29054 c 0,0.0969 -0.0258,1.37732 0.13441,1.37732 0.16025,0 0.13699,-1.28047 0.13699,-1.37732 l 0,-3.29054 c 0,-0.0938 0.0258,-1.37735 -0.13699,-1.37735 -0.15509,0 -0.13441,1.28654 -0.13441,1.37735' id='path7043-8-0' style='fill:%23ffffff' /%3E %3Cpath d='m 953.72738,396.62505 c 0.20936,0.3875 0.38513,0.77495 0.52729,1.19877 0.093,0.58118 0.13699,0.61144 0.1344,0.0907 -0.0284,0.23004 -0.062,0.45706 -0.10597,0.68111 -0.11115,0.60842 -0.0801,1.27137 -0.0465,1.88589 0.002,0.0879 0.0827,1.02017 0.18352,0.49345 0.41485,-2.25825 0.50971,-4.94639 -0.6193,-7.00482 -0.0672,-0.13311 -0.16284,0.86575 -0.16542,0.9626 0,0.44197 -0.12924,1.2835 0.0956,1.6922' id='path7045-1-5' style='fill:%23ffffff' /%3E %3Cpath d='m 948.45608,394.86932 c -0.54512,1.71031 -0.90956,3.45095 -1.20293,5.22482 -0.1008,0.6115 -0.0853,1.26536 -0.0465,1.8829 0.002,0.0848 0.0956,1.02317 0.18352,0.49343 0.27838,-1.67703 0.62215,-3.32379 1.14064,-4.94635 0.16284,-0.51464 0.10339,-1.16246 0.093,-1.6922 0,-0.12406 -0.1344,-1.0716 -0.16542,-0.9626' id='path7047-7-2' style='fill:%23ffffff' /%3E %3Cpath d='m 944.39366,395.11753 c -2.46221,3.01506 -5.74533,5.016 -9.0786,6.88071 -0.51566,0.2906 0.20419,2.63965 0,2.7547 3.33327,-1.8647 6.61639,-3.86567 9.0786,-6.88071 0.22487,-0.28153 0.13441,-1.04438 0.13441,-1.37732 0,-0.13932 -0.17835,-1.32594 -0.13441,-1.37738' id='path7049-8-0' style='fill:%23ffffff' /%3E %3Cpath d='m 937.36552,396.31325 c -1.5025,1.19575 -3.18232,2.06148 -4.98103,2.69115 -0.44147,0.15741 0.0801,2.72743 0,2.75467 1.79561,-0.62961 3.47853,-1.49842 4.98103,-2.69112 0.23521,-0.18765 0.13441,-1.12611 0.13441,-1.37735 0,-0.0907 -0.12407,-1.38342 -0.13441,-1.37735' id='path7051-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 927.40656,393.86427 c -1.45184,0.64479 -2.93935,1.20482 -4.3912,1.85263 -0.38822,0.16956 0.11373,2.15836 0,2.20982 1.45185,-0.64479 2.93936,-1.2048 4.3912,-1.85261 0.38823,-0.17266 -0.11631,-2.15835 0,-2.20984' id='path7053-3-0' style='fill:%23ffffff' /%3E %3Cpath d='m 957.73345,392.66855 c 0.0284,1.80117 0.3081,3.55088 0.64877,5.31268 0.10081,0.52067 0.18093,-0.40265 0.1861,-0.49645 0.0336,-0.60847 0.0646,-1.2805 -0.0465,-1.88292 -0.2378,-1.2078 -0.50971,-2.43079 -0.52729,-3.66585 -0.002,-0.11502 -0.12665,-1.07163 -0.16542,-0.9596 -0.17835,0.49947 -0.10081,1.17452 -0.0956,1.69214' id='path7055-3-8' style='fill:%23ffffff' /%3E %3Cpath d='m 962.41492,390.51022 c 0.0258,2.10689 0.22745,4.13505 0.9778,6.11483 0.0414,0.11502 0.16284,-0.85366 0.16542,-0.96266 0.0258,-0.50854 0.0879,-1.20479 -0.0956,-1.69217 -0.41485,-1.09582 -0.76741,-2.27337 -0.7793,-3.46 0,-0.0938 0.0258,-1.37735 -0.13699,-1.37735 -0.15508,0 -0.1344,1.28353 -0.1344,1.37735' id='path7057-0-2' style='fill:%23ffffff' /%3E %3Cpath d='m 966.02398,390.04099 c 0.62808,0.88695 1.34225,2.09782 1.37197,3.22696 0.002,0.11502 0.12407,1.07463 0.16284,0.96263 0.18351,-0.4995 0.10597,-1.17758 0.0956,-1.69522 -0.0439,-1.89497 -0.45336,-3.59319 -1.55575,-5.14917 -0.0956,-0.13622 -0.16542,0.86575 -0.168,0.96266 0,0.38745 -0.14733,1.35008 0.0956,1.69214' id='path7059-7-7' style='fill:%23ffffff' /%3E %3Cpath d='m 970.45679,388.29736 c 1.5467,0.33604 2.94814,0.96565 4.10067,2.09479 -0.0258,-0.0181 0.13441,-1.26838 0.13441,-1.37735 0,-0.2906 0.1008,-1.14728 -0.13441,-1.37732 -1.15253,-1.12917 -2.55113,-1.75878 -4.10067,-2.0948 -0.0258,-0.005 -0.36755,2.67597 0,2.75468' id='path7061-3-5' style='fill:%23ffffff' /%3E %3Cpath d='m 972.80036,384.70719 c 1.81061,1.51055 3.81067,2.63966 6.14546,2.99082 0.0749,0.0129 0.32309,-2.70326 0,-2.75473 -2.33479,-0.35113 -4.33485,-1.48027 -6.14546,-2.99079 -0.002,-0.003 -0.13699,1.28348 -0.13699,1.37733 0,0.26036 -0.1008,1.18057 0.13699,1.37737' id='path7063-7-2' style='fill:%23ffffff' /%3E %3Cpath d='m 977.77545,372.73783 c 1.58806,0.0181 3.13192,0.28153 4.68456,0.59937 0.0336,0.005 0.36161,-2.68202 0,-2.7547 -1.55264,-0.31782 -3.0965,-0.5812 -4.68456,-0.59935 -0.19644,-0.003 -0.21453,2.75468 0,2.75468' id='path7065-0-2' style='fill:%23ffffff' /%3E %3Cpath d='m 975.47013,367.00441 c 0.95118,-1.55896 2.38519,-2.70624 3.76905,-3.84143 0.23521,-0.19075 0.13699,-1.11702 0.13699,-1.3743 0,-0.0938 -0.1344,-1.38043 -0.13699,-1.37735 -1.41927,1.16238 -2.86517,2.33998 -3.84297,3.93827 -0.23521,0.38146 -0.10598,1.27141 -0.0956,1.6922 0.002,0.0938 0.0853,1.0958 0.16801,0.96261' id='path7067-5-4' style='fill:%23ffffff' /%3E %3Cpath d='m 971.10866,361.48293 c 0.27553,-1.82234 0.86821,-3.43583 1.98223,-4.89793 0.22487,-0.29668 0.13699,-1.03224 0.13699,-1.37738 0,-0.14836 -0.1861,-1.31374 -0.13699,-1.37735 -1.20009,1.57718 -1.82224,3.30871 -2.11871,5.27329 -0.093,0.61754 -0.0827,1.26233 -0.0491,1.88595 0,0.0788 0.10598,1.02314 0.1861,0.49342' id='path7069-7-8' style='fill:%23ffffff' /%3E %3Cpath d='m 967.56189,358.928 c 1.8044,-2.53975 3.01328,-5.44887 4.68456,-8.07642 0.2378,-0.37236 0.10598,-1.28353 0.0956,-1.69523 -0.002,-0.0938 -0.0801,-1.09579 -0.16801,-0.9596 -1.66818,2.62758 -2.88016,5.5367 -4.68456,8.07645 -0.24297,0.34206 -0.10339,1.3047 -0.093,1.69215 0.002,0.0938 0.0698,1.09584 0.16542,0.96265' id='path7071-4-6' style='fill:%23ffffff' /%3E %3Cpath d='m 959.48745,349.88894 c 0.0672,3.09072 0.28458,6.17841 0.93929,9.1995 0.11632,0.51767 0.18093,-0.39353 0.1861,-0.49343 0.0388,-0.60237 0.0801,-1.28957 -0.0465,-1.88287 -0.54512,-2.49137 -0.76431,-5.00691 -0.81781,-7.55579 -0.0414,-1.93128 -0.27553,-0.14526 -0.2608,0.73259' id='path7073-8-7' style='fill:%23ffffff' /%3E %3Cpath d='m 946.40562,352.0473 c 0.47404,1.12004 1.09334,2.17045 1.65035,3.24812 0.34971,0.67808 0.66376,1.36826 0.93929,2.07968 0.1008,0.26938 0.1861,0.54183 0.2639,0.82034 -0.16801,-0.56003 0.12148,-0.41167 -0.2197,0.17266 -0.37324,0.64176 0.24555,2.35813 0.075,2.6548 0.79403,-1.36825 0.66971,-3.58716 0.31121,-5.08259 -0.56296,-2.37632 -2.01196,-4.33485 -2.95125,-6.54771 0.16284,0.37838 -0.37323,1.93738 -0.0672,2.6548' id='path7075-2-1' style='fill:%23ffffff' /%3E %3Cpath d='m 943.80409,357.42049 c -1.78967,-1.79815 -3.81946,-3.29959 -5.85493,-4.78592 -0.0258,-0.0129 -0.13699,1.2926 -0.13699,1.37733 0,0.23624 -0.0982,1.20484 0.13699,1.37433 2.03547,1.48937 4.06242,2.99084 5.85493,4.78896 -0.0258,-0.0207 0.1344,-1.26838 0.1344,-1.37733 0,-0.29367 0.10339,-1.14126 -0.1344,-1.37737' id='path7077-2-4' style='fill:%23ffffff' /%3E %3Cpath d='m 952.3673,360.28419 c 1.21198,-6.0422 0.98064,-12.09047 -1.4963,-17.77543 0.16283,0.37234 -0.38229,1.94344 -0.075,2.65481 1.8044,4.14115 2.34668,8.20052 1.43401,12.74124 -0.12148,0.60243 -0.0827,1.27748 -0.0517,1.88595 0,0.0907 0.0827,1.01712 0.1861,0.49343' id='path7079-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 965.18239,352.39541 c 0.20161,0 0.20161,-2.75468 0,-2.75468 -0.20161,0 -0.20161,2.75468 0,2.75468' id='path7081-3-6' style='fill:%23ffffff' /%3E %3Cpath d='m 950.68438,360.55659 c 0.31689,-3.41461 1.12281,-6.75959 1.46373,-10.17422 0.0982,-0.95961 0.0905,-1.95858 0,-2.91819 -0.0646,-0.69924 -0.21453,-0.69622 -0.28768,0 -0.34351,3.41161 -1.14374,6.75357 -1.46373,10.17123 -0.0879,0.96565 -0.0931,1.95855 0,2.92118 0.0672,0.69322 0.22229,0.69927 0.28768,0' id='path7083-1-7' style='fill:%23ffffff' /%3E %3Cpath d='m 987.73416,381.80416 c 2.96313,0.9717 5.88775,2.98171 7.26541,5.90897 0.0905,0.19076 0.24555,-1.2926 0.24814,-1.44396 0.0258,-0.70832 0.17576,-1.87075 -0.13958,-2.53978 -1.41333,-2.99082 -4.3439,-5.06139 -7.37501,-6.05731 0.0982,0.0333 -0.64902,3.92015 0,4.13208' id='path7085-8-0' style='fill:%23ffffff' /%3E %3Cpath d='m 977.7222,402.37359 c 0.53039,1.7618 0.57485,3.38434 0.24555,5.20063 -0.16542,0.91117 -0.12406,1.90407 -0.075,2.82434 0,0.13311 0.13699,1.53176 0.28122,0.74166 0.74672,-4.11691 0.87131,-8.71514 -0.34067,-12.75034 -0.0465,-0.15147 -0.24555,1.2593 -0.25072,1.44396 -0.0258,0.80219 -0.0956,1.75877 0.13957,2.53975' id='path7087-9-0' style='fill:%23ffffff' /%3E %3Cpath d='m 969.37223,396.79153 c 0,3.41763 0.20161,6.81412 -0.48592,10.18332 -0.18352,0.89907 -0.12407,1.91619 -0.0672,2.82738 0,0.13932 0.11632,1.52264 0.27553,0.74161 0.92741,-4.5316 0.70538,-9.15407 0.68444,-13.75231 0,-0.14216 0.0336,-2.06453 -0.20161,-2.06453 -0.23004,0.003 -0.20419,1.92224 -0.20419,2.06453' id='path7089-9-4' style='fill:%23ffffff' /%3E %3Cpath d='m 965.12914,400.48467 c -1.17941,4.53468 -2.34667,9.07232 -3.27123,13.67056 -0.17835,0.90212 -0.12407,1.91619 -0.0698,2.82736 0,0.13931 0.12148,1.52266 0.28148,0.74166 0.89199,-4.45897 2.02384,-8.85743 3.16758,-13.25589 0.305,-1.16845 -0.29052,-3.28142 -0.10597,-3.98369' id='path7091-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 970.83881,403.37556 c 0.0388,3.89291 0.48903,7.82519 0.0595,11.70296 -0.10597,0.95661 -0.0931,1.96463 0,2.92118 0.0672,0.70233 0.20678,0.69021 0.28458,0 0.54822,-4.88881 0.10856,-9.7262 0.062,-14.62414 0,-0.14216 0.0336,-2.06447 -0.20161,-2.06447 -0.23521,0 -0.20419,1.92223 -0.20419,2.06447' id='path7093-0-9' style='fill:%23ffffff' /%3E %3Cpath d='m 943.41302,405.45826 c 0.0801,-1.22901 0.0672,-1.47423 -0.0362,-0.73861 -0.0543,0.26938 -0.12924,0.53579 -0.21712,0.79312 -0.14474,0.44194 -0.35566,0.85363 -0.57794,1.25623 -0.34067,0.6115 -0.16026,1.87685 -0.14216,2.53981 0,0.14216 0.13957,1.64373 0.24813,1.44391 1.43711,-2.59427 1.33062,-5.99978 0.9274,-8.86046 -0.11114,-0.79912 -0.26958,0.61755 -0.27553,0.74166 -0.0569,0.93542 -0.0594,1.89503 0.0698,2.82434' id='path7095-4-2' style='fill:%23ffffff' /%3E %3Cpath d='m 955.46665,397.28798 c 0.79997,1.54688 0.74078,2.89397 0.73173,4.59219 -0.002,0.13931 -0.031,2.06452 0.19903,2.06452 0.23004,0 0.19902,-1.92528 0.20161,-2.06452 0.0258,-2.85158 0.31999,-5.96649 -1.02795,-8.57591 -0.10081,-0.19385 -0.24297,1.29865 -0.24813,1.44396 -0.0258,0.68413 -0.18352,1.90407 0.14474,2.53976' id='path7097-1-0' style='fill:%23ffffff' /%3E %3Cpath d='m 958.74072,395.86827 c 0.44458,0.3572 0.82376,0.7507 1.12901,1.24413 0.13441,0.21789 0.22746,0.45408 0.31715,0.69325 0.0956,0.25124 0.12924,1.002 0.11114,0.13621 0,0.4087 0.0284,0.82944 0.0931,1.23509 -0.002,-0.0207 0.0672,0.45709 0.15767,0.20885 0.26959,-0.75076 0.16026,-1.76183 0.14475,-2.54283 -0.0414,-2.01002 -0.32904,-3.81116 -1.95277,-5.10678 -0.0646,-0.0514 -0.14733,0.66898 -0.14216,0.60539 -0.0491,0.48738 -0.062,0.97478 -0.062,1.46216 0,0.4843 0,0.9747 0.062,1.45908 0.0258,0.12122 0.0258,0.49945 0.14216,0.60539' id='path7099-9-9' style='fill:%23ffffff' /%3E %3Cpath d='m 962.78841,392.20237 c 0.65187,1.31379 1.3986,2.57612 2.05047,3.88989 0.10339,0.21195 0.14991,-0.17551 0.15767,-0.20885 0.062,-0.40562 0.0775,-0.82339 0.0905,-1.23509 0,-0.52974 0,-1.05948 -0.0258,-1.59224 -0.0258,-0.26036 0.002,-0.6993 -0.12148,-0.94751 -0.65187,-1.31379 -1.3986,-2.57612 -2.04762,-3.88989 -0.10598,-0.21195 -0.14733,0.1755 -0.15767,0.20885 -0.0646,0.40567 -0.0801,0.82339 -0.093,1.23508 0,0.52974 0,1.06251 0.0258,1.58928 0.0258,0.26333 -0.002,0.70229 0.12148,0.95048' id='path7101-4-1' style='fill:%23ffffff' /%3E %3Cpath d='m 971.86417,388.91188 c 1.59995,2.27942 3.25625,4.51953 5.03118,6.65671 -0.0594,-0.0726 0.20161,-1.86173 0.20161,-2.06455 0,-0.49645 0.14474,-1.65281 -0.20161,-2.0675 -1.73927,-2.09177 -3.36015,-4.27739 -4.92469,-6.50838 -0.13957,-0.2029 -0.24555,1.30167 -0.24813,1.44396 -0.0258,0.5842 -0.22229,2.02211 0.14216,2.53976' id='path7103-6-0' style='fill:%23ffffff' /%3E %3Cpath d='m 976.55158,381.13213 c 1.21508,2.13713 2.61342,4.15019 4.15134,6.05728 -0.062,-0.0786 0.2016,-1.85865 0.2016,-2.0645 0,-0.50249 0.14216,-1.64071 -0.2016,-2.06755 -1.50225,-1.85865 -2.86233,-3.82328 -4.04743,-5.90895 -0.10856,-0.1998 -0.24297,1.30164 -0.24814,1.44391 -0.0258,0.65388 -0.19902,1.93738 0.14475,2.53981' id='path7105-9-1' style='fill:%23ffffff' /%3E %3Cpath d='m 930.92076,360.3205 c -1.35414,-1.0898 -2.79409,-2.02216 -4.3912,-2.69114 -0.10597,-0.0483 -0.20161,1.96157 -0.20161,2.06452 0,0.25744 -0.12148,1.93129 0.20161,2.06453 1.59711,0.67201 3.03706,1.60132 4.3912,2.69414 0,0.005 0.20161,-1.93133 0.20161,-2.06752 0,-0.38146 0.14991,-1.78 -0.20161,-2.06453' id='path7107-7-6' style='fill:%23ffffff' /%3E %3Cpath d='m 945.21742,355.4014 c 0.1008,0.23314 0.18868,0.46618 0.27579,0.70529 0.0569,0.17266 0.10339,0.34811 0.14216,0.52672 0.0465,0.32694 0.0569,0.33299 0.0284,0.0181 0,0.4087 0.031,0.83247 0.0956,1.23512 0,-0.0233 0.0646,0.45705 0.15509,0.20574 0.26959,-0.75071 0.15767,-1.75878 0.14216,-2.53976 -0.0258,-1.41974 -0.16025,-2.82738 -0.72605,-4.13507 -0.0982,-0.22694 -0.15767,0.1967 -0.15767,0.20884 -0.0646,0.40565 -0.0801,0.82337 -0.0905,1.23509 -0.0284,0.73257 -0.16542,1.84656 0.13958,2.53976' id='path7109-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 956.49769,344.68526 c 0.0672,2.71536 -0.22228,5.56389 -1.61468,7.93117 -0.34687,0.58722 -0.16283,1.89799 -0.14216,2.53973 0.002,0.14216 0.12924,1.64376 0.24814,1.44093 2.18952,-3.72035 2.01169,-8.82111 1.89926,-13.01067 0,-0.16956 -0.18869,-1.61042 -0.24814,-1.44091 -0.26648,0.74768 -0.16283,1.76485 -0.14216,2.53975' id='path7111-0-2' style='fill:%23ffffff' /%3E %3Cpath d='m 959.03409,359.96327 c 2.40018,-1.61045 4.04174,-4.08057 5.32454,-6.65667 0.3231,-0.64781 0.16026,-1.84655 0.14216,-2.5398 -0.002,-0.14527 -0.14991,-1.63769 -0.24813,-1.44391 -1.25928,2.53066 -2.86233,4.92817 -5.21779,6.50832 -0.34662,0.23599 -0.20161,1.72549 -0.20161,2.06755 0,0.12097 0.16025,2.0948 0.20161,2.06451' id='path7113-3-1' style='fill:%23ffffff' /%3E %3Cpath d='m 966.05964,359.66664 c 0.8235,-0.85971 1.52293,-1.83141 2.34358,-2.69117 0.12407,-0.13311 0.12407,-0.44798 0.14474,-0.60539 0.0465,-0.48436 0.0594,-0.97473 0.0594,-1.46211 0,-0.48737 0,-0.97475 -0.0594,-1.4591 0,0.0667 -0.0879,-0.66293 -0.14474,-0.60545 -0.82065,0.85971 -1.52008,1.83144 -2.34358,2.69117 -0.12665,0.13311 -0.12665,0.44798 -0.14216,0.60539 -0.0491,0.48738 -0.0594,0.97476 -0.0594,1.46211 0,0.48435 0,0.97475 0.0594,1.4591 0,-0.0695 0.0905,0.65991 0.14216,0.60545' id='path7115-8-3' style='fill:%23ffffff' /%3E %3Cpath d='m 976.60508,361.5162 c -2.64004,-0.0103 -5.27724,-0.0362 -7.90539,-0.29968 -0.18093,-0.0181 -0.42984,4.08967 0,4.13208 2.62815,0.26031 5.26535,0.29058 7.90539,0.29965 0.29621,0.003 0.30526,-4.13205 0,-4.13205' id='path7117-3-2' style='fill:%23ffffff' /%3E %3Cpath d='m 974.26125,371.03356 c 3.5111,2.10689 6.9157,4.39239 10.54544,6.28131 -0.27837,-0.14526 0.75862,-3.73243 0,-4.12903 -3.62974,-1.89197 -7.03434,-4.17442 -10.54544,-6.28433 0.33472,0.2029 -0.78808,3.65979 0,4.13205' id='path7119-3-6' style='fill:%23ffffff' /%3E %3Cpath d='m 974.55462,378.21696 c 3.12881,1.99187 6.54841,3.52364 9.37197,5.98466 0,-0.003 0.19902,-1.92224 0.19902,-2.06752 0,-0.40263 0.1525,-1.75576 -0.19902,-2.06453 -2.82356,-2.46105 -6.24316,-3.99279 -9.37197,-5.98463 -0.0543,-0.0305 -0.20161,1.95248 -0.20161,2.06752 0,0.32389 -0.14475,1.84049 0.20161,2.0645' id='path7121-5-2' style='fill:%23ffffff' /%3E %3Cpath d='m 954.40303,363.18112 c 0.45026,-1.50749 0.44147,-3.124 0.44147,-4.68296 0,-0.14216 0.031,-2.06452 -0.20161,-2.06452 -0.23521,0 -0.20419,1.92223 -0.20419,2.06452 0,0.56606 0,0.0879 0.0258,0.005 -0.0258,0.23625 -0.0853,0.46618 -0.15509,0.69325 -0.23521,0.78403 -0.16284,1.73451 -0.14216,2.53973 0.0258,0.4117 0.0258,0.82944 0.0931,1.23512 0,-0.0486 0.075,0.47825 0.15767,0.20884' id='path7123-8-8' style='fill:%23ffffff' /%3E %3Cpath d='m 929.74729,352.18654 c 2.7499,3.36622 6.23437,5.80303 9.62114,8.43971 2.50977,1.95248 4.36458,5.27631 7.0757,6.81709 -0.31405,-0.1755 0.77645,-3.68704 0,-4.129 -2.44154,-1.38947 -4.07121,-4.33182 -6.24006,-6.14811 -3.57649,-2.99995 -7.45798,-5.44285 -10.45368,-9.11172 0.50377,0.62057 -0.75862,3.20571 -0.002,4.13203' id='path7125-1-8' style='fill:%23ffffff' /%3E %3Cpath d='m 935.60817,363.31434 c -1.65914,-1.70729 -3.17922,-3.53875 -4.68431,-5.38531 -0.0465,-0.0545 -0.15508,0.67203 -0.14733,0.60545 -0.0439,0.48435 -0.0594,0.97173 -0.0594,1.45908 0,0.4995 -0.14216,1.64376 0.2042,2.06752 1.50508,1.84656 3.02516,3.67497 4.68456,5.38529 -0.0362,-0.0362 0.19902,-1.89494 0.19902,-2.0675 0.002,-0.44804 0.15509,-1.7013 -0.19644,-2.06453' id='path7127-7-4' style='fill:%23ffffff' /%3E %3Cpath d='m 932.33125,390.61315 c -1.10523,2.00396 -2.03858,4.11083 -3.46096,5.909 -0.34066,0.43284 -0.20161,1.55895 -0.20161,2.0675 0,0.21195 0.26959,1.97975 0.20161,2.06453 1.45779,-1.85263 2.42965,-3.99886 3.5646,-6.05732 0.33783,-0.61149 0.16284,-1.87685 0.14475,-2.53978 -0.002,-0.14216 -0.13958,-1.64371 -0.24814,-1.44393' id='path7129-6-4' style='fill:%23ffffff' /%3E %3Cpath d='m 935.40966,394.74822 c -0.0517,2.2976 -0.83539,4.58917 -1.11996,6.86556 -0.1189,0.95354 -0.0905,1.97065 0,2.92421 0.0724,0.70837 0.2016,0.6811 0.28768,0 0.36134,-2.9333 1.15847,-5.71522 1.22361,-8.69089 0.0258,-0.77801 0.12406,-1.79207 -0.14216,-2.54284 -0.0569,-0.16645 -0.24555,1.27446 -0.24814,1.44396' id='path7131-8-6' style='fill:%23ffffff' /%3E %3Cpath d='m 946.20116,413.74356 c 1.95277,-6.53257 1.73927,-13.43749 1.6059,-20.19108 -0.0569,-2.89999 -0.41485,-0.2179 -0.39107,1.09582 0.1008,5.11285 0.15508,10.17122 -1.32157,15.11152 -0.34067,1.15031 0.30835,3.31174 0.10597,3.98374' id='path7133-1-3' style='fill:%23ffffff' /%3E %3Cpath d='m 952.53918,397.88735 c 0.74363,2.26735 0.89483,4.33185 0.53918,6.69608 -0.14216,0.92632 -0.12666,1.89195 -0.0698,2.82733 0,0.12123 0.15508,1.53479 0.27579,0.73864 0.70821,-4.67696 0.85916,-9.70809 -0.63429,-14.24574 -0.0543,-0.16051 -0.24297,1.26838 -0.24814,1.44391 -0.0284,0.78403 -0.11114,1.77395 0.13958,2.53978' id='path7135-4-4' style='fill:%23ffffff' /%3E %3Cpath d='m 958.74072,395.56554 c 2.28154,2.79104 2.97193,6.49628 2.75274,10.05618 -0.0388,0.67505 0.19127,4.6285 0.34971,2.08572 0.32594,-5.38229 0.47094,-11.90276 -3.10245,-16.27393 0.062,0.0757 -0.20161,1.85866 -0.20161,2.0675 0,0.49645 -0.14216,1.64379 0.20161,2.06453' id='path7137-2-9' style='fill:%23ffffff' /%3E %3Cpath d='m 960.44458,392.80177 c 1.42522,5.93924 2.52735,11.92997 3.13502,18.01755 0.16025,1.61652 0.33472,-2.38539 0.28742,-2.92118 -0.64593,-6.44479 -1.80156,-12.78971 -3.31285,-19.08011 0.17059,0.72046 -0.39107,2.80619 -0.10856,3.98374' id='path7139-4-9' style='fill:%23ffffff' /%3E %3Cpath d='m 966.30261,391.30332 c 2.60153,3.58719 4.87402,7.36808 6.1483,11.66964 0.0465,0.14837 0.24296,-1.2593 0.24555,-1.44396 0.0284,-0.80522 0.093,-1.7557 -0.14216,-2.53973 -1.27428,-4.29858 -3.54393,-8.08252 -6.1483,-11.66969 0.2533,0.34816 -0.7289,3.13011 -0.10339,3.98374' id='path7141-8-7' style='fill:%23ffffff' /%3E %3Cpath d='m 978.41543,381.33795 c -1.20293,-2.08872 -3.76001,-2.34601 -5.91128,-2.1674 -0.40606,0.0333 -0.19644,4.14715 0,4.13202 2.03574,-0.16955 4.652,0.0207 5.80169,2.01909 0.11631,0.1998 0.24555,-1.30167 0.25072,-1.44391 0.0258,-0.65083 0.2016,-1.94343 -0.14216,-2.5398' id='path7143-6-5' style='fill:%23ffffff' /%3E %3Cpath d='m 972.21078,379.70936 c 3.79284,-0.55093 7.5973,-0.59632 11.4196,-0.5994 0.3081,0 0.3081,-4.129 0,-4.129 -3.81946,0 -7.62392,0.0455 -11.4196,0.59635 -0.47714,0.0695 -0.11889,4.15322 0,4.13205' id='path7145-7-7' style='fill:%23ffffff' /%3E %3Cpath d='m 979.23918,348.35418 c -3.03421,3.62956 -4.64321,8.55773 -5.66547,13.1469 -0.19902,0.88695 -0.12406,1.92528 -0.0698,2.8243 0,0.15147 0.10338,1.51662 0.27579,0.74169 0.97185,-4.35912 2.58679,-9.13896 5.46386,-12.58083 0.34661,-0.4147 0.20161,-1.57413 0.20161,-2.06756 0,-0.19979 -0.26391,-1.99489 -0.2042,-2.0645' id='path7147-8-9' style='fill:%23ffffff' /%3E %3Cpath d='m 962.73801,351.90501 c 0.5658,3.49034 2.00006,6.70815 2.97787,10.08042 0.0439,0.14836 0.24296,-1.25628 0.24555,-1.44396 0.0258,-0.80827 0.0879,-1.75273 -0.13958,-2.53976 -0.93645,-3.233 -2.33789,-6.32069 -2.88016,-9.66265 -0.12666,-0.79615 -0.26959,0.61452 -0.27554,0.74161 -0.0543,0.92634 -0.0775,1.9011 0.0698,2.82434' id='path7149-7-7' style='fill:%23ffffff' /%3E %3Cpath d='m 959.61798,357.92601 c -1.36913,-1.69822 -2.53045,-3.49332 -3.16474,-5.60928 -0.0801,-0.26943 -0.16543,0.25434 -0.15767,0.20574 -0.0646,0.40565 -0.0801,0.82642 -0.0905,1.23509 -0.0258,0.80522 -0.0931,1.75878 0.14216,2.54278 0.64903,2.17655 1.8698,4.01401 3.27124,5.75767 0.0465,0.0545 0.14733,-0.67508 0.14216,-0.60545 0.0517,-0.48735 0.062,-0.97473 0.062,-1.4621 0,-0.49948 0.14216,-1.63466 -0.20419,-2.06453' id='path7151-6-3' style='fill:%23ffffff' /%3E %3Cpath d='m 954.05616,360.6202 c -4.59565,-1.4894 -8.99564,-3.32383 -12.88927,-6.28136 0.42389,0.31785 -0.80592,3.51151 0,4.12906 3.89053,2.96055 8.29362,4.79193 12.88927,6.28435 -0.0956,-0.0305 0.64592,-3.9232 0,-4.13205' id='path7153-1-4' style='fill:%23ffffff' /%3E %3Cpath d='m 959.11422,359.46079 c 0,0 -18.21976,3.11794 -23.02581,4.21981 -4.80605,1.10189 -15.68647,2.20376 -19.47904,2.20376 -3.79568,0 -9.6152,-3.03015 -13.66263,-3.85657 -4.04768,-0.82641 -17.20344,-2.20374 -22.00949,2.7547 -4.8063,4.95847 -7.84336,6.61128 -9.36034,8.26411 -1.51723,1.65283 -7.61203,7.05934 -7.85215,9.45378 -0.24038,2.39147 1.52887,5.97256 4.56308,5.97256 3.03706,0 9.41669,6.45994 9.40764,7.81002 -0.0258,2.25223 8.33214,4.67694 16.20212,4.63155 14.18991,-0.0786 21.17385,-7.23791 42.44541,-4.72837 11.58269,1.36522 32.88706,-7.7132 36.68558,-13.2226 3.79284,-5.50941 6.07128,-11.29429 2.2756,-17.63011 -3.79568,-6.33582 -15.17081,-5.68499 -16.18997,-5.87266' id='path7155-7-8' style='fill:%23dba05f' /%3E %3Cpath d='m 959.11422,359.46079 c 0,0 -18.21976,3.11794 -23.02581,4.21981 -4.80605,1.10189 -15.68647,2.20376 -19.47904,2.20376 -3.79568,0 -9.6152,-3.03015 -13.66263,-3.85657 -4.04768,-0.82641 -17.20344,-2.20374 -22.00949,2.7547 -4.8063,4.95847 -7.84336,6.61128 -9.36034,8.26411 -1.51723,1.65283 -7.61203,7.05934 -7.85215,9.45378 -0.24038,2.39147 1.52887,5.97256 4.56308,5.97256 3.03706,0 9.41669,6.45994 9.40764,7.81002 -0.0258,2.25223 8.33214,4.67694 16.20212,4.63155 14.18991,-0.0786 21.17385,-7.23791 42.44541,-4.72837 11.58269,1.36522 32.88706,-7.7132 36.68558,-13.2226 3.79284,-5.50941 6.07128,-11.29429 2.2756,-17.63011 -3.79568,-6.33582 -15.17081,-5.68499 -16.18997,-5.87266 z' id='path7157-1-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 882.83935,379.89401 c 0.002,0 -0.0465,0.40263 -0.12923,-0.22099 l -0.10598,-0.48738 -0.12665,-0.33601 -0.0258,-0.37236 c -0.0827,-0.13027 0.38228,0.0907 1.85195,-1.35615 0,0.0274 0.44458,-0.69323 1.24145,-1.88892 -0.0853,0.0545 1.8106,-2.35516 4.59565,-2.9939 2.77652,-0.64781 5.34548,-0.1817 5.70088,-0.16051 0.1189,-0.15431 -6.2964,-0.2241 -6.7172,0.52672 0.0258,-0.50253 6.18707,-0.7144 6.51585,-0.28456 0.0801,-0.14526 -5.81047,-0.19385 -6.2491,0.6145 0,-0.36626 5.34522,-0.62359 5.92601,-0.13027 0,0 -0.99538,-0.11192 -1.26497,-0.0848 l 0.46499,0.0817 -0.74957,-0.0103 -0.43268,-0.0424 c 0,-0.0129 1.17347,0.14216 1.25049,0.24813 0,0.0181 0.52729,-0.14836 -1.56738,-0.0362 0,0.005 -1.28306,-0.23625 -3.36919,0.42986 -2.74059,0.39957 -2.65478,4.11996 -6.80896,6.5023' id='path7159-4-4' /%3E %3Cpath d='m 882.3772,378.34413 c 0.24297,0.0207 2.02953,-0.70232 3.74218,-3.87477 -0.48567,-0.86575 6.43597,-3.56292 7.15298,-2.69716 0.031,-0.0274 1.88737,0 2.97192,0.1755' id='path7161-8-9' style='fill:none;stroke:%23939598;stroke-width:0.00299493' /%3E %3Cpath d='m 889.23372,372.35337 c -0.70537,-0.0969 -4.21932,2.86368 -3.89933,3.03021 -0.75861,1.81932 -2.73206,3.00896 -2.96029,2.96055' id='path7163-7-7' style='fill:none;stroke:%23000000;stroke-width:0.00299493' /%3E %3Cpath d='m 889.52993,372.77112 c 0,-0.23004 4.7528,-0.68413 5.69209,-0.32992' id='path7165-2-5' style='fill:none;stroke:%23000000;stroke-width:0.00299493' /%3E %3Cpath d='m 888.64698,374.04252 c -0.12923,-0.49645 4.94821,-1.18662 5.41941,-0.84153' id='path7167-0-1' style='fill:none;stroke:%23939598;stroke-width:0.00299493' /%3E %3Cpath d='m 893.95085,377.2725 c 0,0 0.21453,0.13027 -0.0775,-0.15741 l -0.21712,-0.24813 -0.12665,-0.21195 -0.18093,-0.15741 c 0,0 -0.16026,0.0667 -1.43401,1.19572 0,-0.0103 -0.55727,0.4147 -1.21482,1.03224 -0.0258,-0.0545 -1.23576,1.02619 -2.60179,1.77393 -1.45469,0.21479 -3.5615,1.15938 -3.5615,1.53473 -0.12665,-0.56303 4.17796,-1.69214 4.11566,-1.76178 0.3081,0.20291 -3.81635,0.95959 -3.89337,1.7981 -0.14733,-0.5055 3.78378,-1.49235 3.94662,-1.5045 0.20161,0.23004 -3.46664,0.83549 -3.57623,1.62862 0,0.0207 0.50376,-0.49948 0.70511,-0.50855 l -0.25847,0.19386 c 0.12665,-0.12717 0.29931,-0.15147 0.4593,-0.21195 l 0.26959,-0.12407 c 0,0.005 -0.73174,0.32389 -0.70821,0.47525 0.0362,0.0817 -0.4177,-0.0455 0.94833,-0.41469 0.0258,0.13027 3.46974,-0.69927 7.40448,-4.33188' id='path7169-4-5' /%3E %3Cpath d='m 893.30777,376.3916 c -0.0258,-0.0574 -1.52292,1.49542 -3.0903,2.60034 0.0258,0.26031 -3.21205,2.15228 -4.05648,1.92524 -0.0543,-0.0998 -1.37792,0.55701 -1.92898,1.23206' id='path7171-6-8' style='fill:none;stroke:%23939598;stroke-width:0.00299493' /%3E %3Cpath d='m 888.51361,380.23305 c 0.24555,-0.24219 2.2787,-1.62861 2.2787,-1.64376 0.72295,-0.76885 2.51546,-2.19769 2.51856,-2.20071' id='path7173-0-5' style='fill:none;stroke:%23000000;stroke-width:0.00299493' /%3E %3Cpath d='m 888.58779,380.58721 c 0.16801,0.16646 -3.02542,0.60545 -3.53487,1.37436' id='path7175-9-6' style='fill:none;stroke:%23000000;stroke-width:0.00299493' /%3E %3Cpath d='m 889.50925,380.49641 c 0.20419,0.41172 -3.4165,1.37735 -3.5646,1.48632' id='path7177-6-3' style='fill:none;stroke:%23939598;stroke-width:0.00299493' /%3E %3Cpath d='m 898.98513,362.53331 c 0,0 -0.25589,-5.78485 -5.81952,-7.9886 -5.56467,-2.20379 -11.89363,-2.47927 -14.16639,-2.20379 -2.27844,0.27548 -2.65477,1.2926 -5.49927,1.74971 -2.8476,0.45408 -5.88181,1.83141 -5.88181,1.83141 0,0 0,-0.27543 -1.51982,2.47925 -1.52008,2.7547 -4.04459,4.13202 -2.77936,6.6113 1.26212,2.47922 0.42364,2.91208 1.98223,3.38431 1.55859,0.47226 -0.77335,-0.84456 -0.77335,-0.84456 0,0 -9.75141,3.14218 -7.37811,9.11472 2.37355,5.97561 4.7497,3.74155 5.45791,3.6205 0.71132,-0.12406 5.51737,-2.60336 5.51737,-2.60336 l 7.89945,-7.38018 c 0,0 9.30089,-3.63863 10.31126,-3.91408 1.01631,-0.27551 5.4194,0.10287 5.4194,0.10287 l 7.23001,-3.9595 z' id='path7179-5-9' style='fill:%23c6262c' /%3E %3Cpath d='m 898.98513,362.53331 c 0,0 -0.25589,-5.78485 -5.81952,-7.9886 -5.56467,-2.20379 -11.89363,-2.47927 -14.16639,-2.20379 -2.27844,0.27548 -2.65477,1.2926 -5.49927,1.74971 -2.8476,0.45408 -5.88181,1.83141 -5.88181,1.83141 0,0 0,-0.27543 -1.51982,2.47925 -1.52008,2.7547 -4.04459,4.13202 -2.77936,6.6113 1.26212,2.47922 0.42364,2.91208 1.98223,3.38431 1.55859,0.47226 -0.77335,-0.84456 -0.77335,-0.84456 0,0 -9.75141,3.14218 -7.37811,9.11472 2.37355,5.97561 4.7497,3.74155 5.45791,3.6205 0.71132,-0.12406 5.51737,-2.60336 5.51737,-2.60336 l 7.89945,-7.3832 c 0,0 9.30089,-3.63563 10.31126,-3.91106 1.01631,-0.27551 5.4194,0.10287 5.4194,0.10287 l 7.23001,-3.9595 z' id='path7181-3-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 891.91512,376.10705 c 0,1.44093 -1.46374,3.30261 -3.27098,4.15627 -1.8106,0.85061 -3.27718,0.37538 -3.27718,-1.06555 0,-1.44396 1.46373,-3.30564 3.27124,-4.15927 1.80724,-0.85067 3.27692,-0.37541 3.27692,1.06855' id='path7183-4-5' /%3E %3Cpath d='m 853.27108,402.52495 c 0,0 -7.63271,-13.13479 13.54114,-19.57049 0,0 6.40031,3.48422 7.87877,5.89688 0,0 -3.69202,6.16629 -15.75754,7.77673 0,0 -5.4163,1.60742 -5.66237,5.89688' id='path7185-6-7' style='fill:%23d9c0b9' /%3E %3Cpath d='m 853.27108,402.52495 c 0,0 -7.63271,-13.13479 13.54114,-19.57049 0,0 6.40031,3.48422 7.87877,5.89688 0,0 -3.69202,6.16629 -15.75754,7.77673 0,0 -5.4163,1.60742 -5.66237,5.89688 z' id='path7187-6-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 855.48749,400.3787 c 0,0 8.52185,1.79812 14.27598,-2.41264 4.71713,-3.45095 6.40315,-1.87683 7.63296,-1.60742 0,0 0.24814,-4.28946 -2.70828,-7.5073 0,0 -5.98236,4.9403 -10.41517,6.28131 -4.42686,1.34104 -7.42541,0.89608 -8.78549,5.24605' id='path7189-1-1' style='fill:%23d9c0b9' /%3E %3Cpath d='m 855.48749,400.3787 c 0,0 8.52185,1.79812 14.27598,-2.41264 4.71713,-3.45095 6.40315,-1.87683 7.63296,-1.60742 0,0 0.24814,-4.28946 -2.70828,-7.5073 0,0 -5.98236,4.9403 -10.41517,6.28131 -4.42686,1.34104 -7.42541,0.89608 -8.78549,5.24605 z' id='path7191-2-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 879.183,396.06806 c 1.58831,0 3.19705,0.0181 4.75564,-0.34811 0.1861,-0.0424 0,-1.37737 0,-1.37435 -1.55859,0.36328 -3.16733,0.34509 -4.75564,0.34509 -0.10081,-0.003 -0.10081,1.37737 0,1.37737' id='path7193-6-0' style='fill:%237a2e26' /%3E %3Cpath d='m 876.19634,374.00621 c -1.30968,0.005 -0.91577,1.57715 -1.70101,2.23708 -0.1189,0.0969 -0.0672,0.55696 -0.0672,0.68715 0,0.0483 0.0646,0.69017 0.0672,0.69017 0.78524,-0.65688 0.4239,-2.23098 1.70101,-2.23703 0.10339,0 0.0982,-1.37737 0,-1.37737' id='path7195-5-6' style='fill:%237a2e26' /%3E %3Cpath d='m 880.59038,376.97583 c 0.66092,-1.23811 1.9675,-1.74361 3.14381,-2.33696 0.25072,-0.12407 -0.0853,-1.33194 0,-1.3743 -1.19699,0.60242 -2.50383,1.12001 -3.17638,2.38235 -0.10855,0.20884 -0.0569,0.62359 -0.0491,0.84763 0.002,0.0483 0.0491,0.54791 0.0827,0.48128' id='path7197-6-0' style='fill:%237a2e26' /%3E %3Cpath d='m 886.28842,384.57703 c 1.0755,0.0848 1.91399,-0.37541 2.55423,-1.24419 0.10597,-0.15146 0.0646,-0.51159 0.0646,-0.68715 0,-0.0757 -0.0956,-0.65386 -0.0646,-0.69017 -0.64308,0.86878 -1.47873,1.32891 -2.55423,1.24413 -0.0672,-0.005 -0.13441,1.36523 0,1.37738' id='path7199-8-9' style='fill:%237a2e26' /%3E %3Cpath d='m 890.78921,382.96354 c 1.73926,-0.73254 3.07273,-1.84049 4.02675,-3.50239 0.11631,-0.1998 0.0569,-0.62964 0.0517,-0.84764 0,-0.0455 -0.0465,-0.54791 -0.0827,-0.4813 -0.94808,1.64978 -2.27249,2.73048 -3.99418,3.45397 -0.2378,0.10003 0.062,1.35014 0,1.37736' id='path7201-1-6' style='fill:%237a2e26' /%3E %3Cpath d='m 883.71635,375.5228 c -0.99538,1.67707 -2.8799,2.53071 -4.01175,4.09876 -0.20678,0.28763 0.11889,1.21389 0.0362,1.32891 1.13185,-1.57108 3.01328,-2.41866 4.01176,-4.09876 0.11631,-0.1967 0.0569,-0.63566 0.0517,-0.84759 0,-0.0483 -0.0465,-0.54791 -0.0853,-0.48132' id='path7203-6-7' style='fill:%237a2e26' /%3E %3Cpath d='m 886.77435,397.49688 c 3.60906,0.19385 7.09353,-0.29363 10.578,-1.24114 0.19903,-0.0574 -0.0258,-1.37432 0,-1.37735 -3.48757,0.94751 -6.97205,1.43489 -10.578,1.24111 -0.0801,-0.003 -0.12407,1.37133 0,1.37738' id='path7205-6-6' style='fill:%237a2e26' /%3E %3Cpath d='m 903.43267,396.87631 c 4.71403,-3.42068 8.69064,-6.34794 10.2314,-12.3235 0.1008,-0.39053 -0.0956,-1.09283 -0.0362,-1.32589 -1.53481,5.93017 -5.53494,8.8877 -10.19598,12.27201 -0.26649,0.1936 0.1344,1.28053 0,1.37738' id='path7207-8-5' style='fill:%237a2e26' /%3E %3Cpath d='m 906.23271,388.67879 c 3.3511,-1.99487 5.74818,-5.14312 7.06975,-8.84531 0.13441,-0.37233 -0.10855,-1.12007 -0.0362,-1.32891 -1.31253,3.68704 -3.70366,6.81407 -7.03434,8.79689 -0.26649,0.15431 0.10855,1.31072 0,1.37733' id='path7209-6-6' style='fill:%237a2e26' /%3E %3Cpath d='m 904.65034,367.8066 c 2.56896,-0.30877 5.3721,1.82542 7.17366,3.47822 -0.15767,-0.14216 0.26959,-1.12911 0,-1.37738 -1.79871,-1.65283 -4.6047,-3.78696 -7.17366,-3.47816 -0.14733,0.0181 -0.0517,1.38337 0,1.37732' id='path7211-3-6' style='fill:%237a2e26' /%3E %3Cpath d='m 971.42554,378.21696 c 2.92463,-4.72537 1.32752,-10.63737 -1.70075,-14.86933 0.0827,0.11813 -0.24296,1.04136 -0.0362,1.32892 2.56017,3.57806 4.25782,8.08852 1.70385,12.21153 -0.19644,0.31179 0.1189,1.18964 0.0336,1.32888' id='path7213-6-8' style='fill:%237a2e26' /%3E %3Cpath d='m 920.45829,371.53606 c 2.95124,2.14018 11.07867,7.58907 8.85942,12.06319 -0.17318,0.34206 0.1189,1.15938 0.0362,1.32891 3.04015,-6.12389 -4.80889,-11.80585 -8.89509,-14.76943 0.12923,0.0938 -0.26959,1.17755 0,1.37733' id='path7215-9-3' style='fill:%237a2e26' /%3E %3Cpath d='m 943.3714,393.52523 c 0.46525,-1.25925 0.62835,-2.57304 0.75862,-3.90498 0.0336,-0.32087 0.0336,-0.65084 0,-0.97176 -0.0284,-0.23314 -0.0698,-0.23314 -0.0956,0 -0.1189,1.21392 -0.27269,2.40055 -0.69917,3.54783 -0.0905,0.24529 -0.0543,0.59335 -0.0465,0.84761 0.002,0.0545 0.0594,0.53884 0.0827,0.4813' id='path7217-2-4' style='fill:%237a2e26' /%3E %3Cpath d='m 952.16569,391.36083 c 1.76614,-0.2997 3.52609,-1.20177 5.28913,-2.40054' id='path7219-7-6' style='fill:%235e3f17' /%3E %3Cpath d='m 867.25679,386.38724 c -3.46379,2.11902 -8.91576,2.14626 -9.99747,6.92912 -0.0258,0.0667 0,0.32694 0.0258,0.29668 1.0786,-4.76472 6.54557,-4.77989 9.97964,-6.88071 0.0646,-0.0455 -0.031,-0.32692 0,-0.34509' id='path7221-5-7' style='fill:%235e3f17' /%3E %3Cpath d='m 864.91891,371.085 c 1.49035,0.0274 3.23866,0.81129 3.01043,2.63968 -0.0414,0.31784 -0.0336,0.65688 0,0.97475 0.0258,0.23624 0.0646,0.22694 0.0956,0 0.13957,-1.11699 0.19127,-2.40052 -0.2378,-3.46005 -0.47714,-1.1715 -1.73926,-1.51054 -2.86827,-1.53171 -0.0956,0 -0.10856,1.37733 0,1.37733' id='path7223-1-6' style='fill:%23842116' /%3E %3Cpath d='m 872.06879,373.83667 c 0.71416,-2.02211 0.54512,-4.4166 -0.6785,-6.18445 0.0827,0.12096 -0.24038,1.03229 -0.0362,1.32589 0.75836,1.09584 1.15253,2.20074 0.67849,3.52965 -0.13441,0.37541 0.10856,1.12007 0.0362,1.32891' id='path7225-6-3' style='fill:%23842116' /%3E %3Cpath d='m 877.85858,367.72187 c -0.36755,-2.40964 -1.21198,-5.08863 -3.43123,-6.33886 0.10339,0.0574 -0.25847,1.22903 0,1.37737 2.16006,1.21689 3.01044,3.80209 3.3661,6.14812 0.0413,0.26635 0.0853,-0.2029 0.0879,-0.24529 0.0258,-0.30877 0.0258,-0.63269 -0.0259,-0.94146' id='path7227-8-2' style='fill:%23842116' /%3E %3Cpath d='m 882.95205,366.48071 c 0.3112,-2.24308 0.1189,-4.63757 -1.73332,-6.13901 0.14733,0.11812 -0.27269,1.15635 0,1.37732 1.02795,0.83246 1.86075,2.1735 1.66508,3.57507 -0.0439,0.30877 -0.0414,0.62662 -0.0258,0.93841 0.002,0.0424 0.0569,0.51462 0.0905,0.24814' id='path7229-1-7' style='fill:%23842116' /%3E %3Cpath d='m 874.42735,358.9401 c 4.97793,-2.52464 15.11731,-3.64468 19.01974,1.38642 -0.1706,-0.21479 0.24555,-1.05645 0,-1.37432 -3.90243,-5.0341 -14.04181,-3.91409 -19.01974,-1.38943 -0.2533,0.12717 0.0905,1.33497 0,1.37733' id='path7231-1-8' style='fill:%23842116' /%3E %3Cpath d='m 862.56034,379.73355 c 1.12901,-1.674 0.76741,-3.91708 -0.33782,-5.4912 0.0827,0.11812 -0.24038,1.03526 -0.0388,1.32891 0.29621,0.41167 0.54227,0.82944 0.73794,1.29865 0.24038,0.57512 -0.0853,1.07462 -0.39728,1.53473 -0.12148,0.17861 -0.0543,0.64781 -0.0465,0.84761 0.002,0.0486 0.0388,0.54794 0.0827,0.4813' id='path7233-6-2' style='fill:%237a2e26' /%3E %3Cpath d='m 913.40017,394.33348 c 1.60305,-1.02317 2.72611,-2.54581 3.08461,-4.45897 0.0594,-0.30272 0.0439,-0.63572 0.0258,-0.94141 0,-0.0455 -0.0413,-0.5086 -0.0879,-0.24529 -0.34377,1.82841 -1.49036,3.29351 -3.01922,4.26827 -0.2639,0.16955 0.11889,1.30167 0,1.37737' id='path7235-3-4' style='fill:%237a2e26' /%3E %3Cpath d='m 921.02719,393.70989 c 0.68728,-0.75978 0.94213,-1.674 0.98064,-2.6881 0,-0.25433 0.0414,-0.59937 -0.0465,-0.84456 -0.0258,-0.0574 -0.0827,0.42382 -0.0827,0.47828 -0.0258,0.58725 -0.48283,1.27143 -0.85038,1.67703 -0.11631,0.13027 -0.0646,0.53279 -0.0646,0.6902 -0.002,0.0605 0.0801,0.669 0.0646,0.68715' id='path7237-2-7' style='fill:%237a2e26' /%3E %3Cpath d='m 967.0788,368.43929 c 1.25334,2.22194 1.45779,4.66784 0.89794,7.15619 -0.0594,0.26938 0.0414,1.31377 0.0672,1.18965 0.71106,-3.15125 0.68134,-6.81408 -0.9336,-9.67478 0.0879,0.15431 -0.21712,1.00502 -0.0336,1.32894' id='path7239-2-5' style='fill:%237a2e26' /%3E %3Cpath d='m 962.50099,373.11321 c 0.90672,2.2431 0.83848,4.57706 0.58079,6.95333 -0.0258,0.17861 0.0362,1.51362 0.0956,0.97173 0.34351,-3.14822 0.5658,-6.25711 -0.64024,-9.254 0.0801,0.1967 -0.18093,0.96571 -0.0362,1.32894' id='path7241-0-3' style='fill:%237a2e26' /%3E %3Cpath d='m 958.18087,377.12417 c 0,1.67707 0.0258,3.3541 -0.55701,4.94634 -0.13957,0.37238 0.10856,1.12309 0.0362,1.32891 0.72295,-1.99184 0.65755,-4.18348 0.66065,-6.27525 -0.002,-0.78101 -0.13957,-0.78101 -0.13957,0' id='path7243-5-1' style='fill:%237a2e26' /%3E %3Cpath d='m 1020.3545,511.6263 0.9687,2.71534 c 0,0 0.2068,0.52977 0.6757,0.9687 l -1.4459,-4.06242 -0.199,0.37838 z' id='path7245-6-2' style='fill:%23452c25' /%3E %3Cpath d='m 915.83886,346.12922 c -18.28205,1.05041 -36.30925,-11.09449 -36.30925,-11.09449 -22.64663,-4.4378 -23.9651,-24.91341 -23.9651,-24.91341 -9.06103,-3.45095 -16.85373,-26.7176 -16.85373,-26.7176 -14.03586,8.37915 -31.60091,0.091 -31.60091,0.091 0,0 0,-3.45095 -15.84931,0 -15.8524,3.45098 -13.13533,-2.95752 -13.13533,-2.95752 0,0 6.34111,-6.4115 -21.73371,0 -28.07507,6.4085 2.26655,-8.38218 2.26655,-8.38218 -8.1512,2.4641 -34.86904,4.4378 -34.86904,4.4378 -9.80465,0.44197 -19.75457,5.27934 -30.59053,8.36703 -6.74382,1.92226 -18.28206,4.16235 -24.11631,6.65369 -15.56472,6.65364 -46.75983,20.95086 -72.52337,31.06155 -33.87056,13.29221 -60.71298,23.40587 -58.94684,22.97905 2.11561,-0.51157 36.78019,-22.46745 80.1977,-42.15301 40.31532,-18.28397 86.59207,-35.20268 109.92314,-41.8291 30.27649,-10.03198 55.07413,-5.24 69.13971,-0.13622 6.79138,2.4641 44.25911,-1.15335 61.00919,0.81732 16.75603,1.97068 18.50124,29.52379 18.50124,29.52379 3.17043,1.97365 4.30228,27.85882 4.30228,27.85882 0,0 -9.28331,0.24813 1.58522,1.72543 10.86853,1.48028 30.79214,17.25781 30.79214,17.25781 6.79112,0 7.56163,-0.23909 7.56163,-0.23909 0,0 3.94662,-4.97661 9.38386,-7.05629 5.43129,-2.08267 10.41517,-4.16532 16.52495,-4.62545 6.11289,-0.46621 14.74408,-0.52069 20.85386,0.17266 6.11289,0.69622 13.33075,0.75071 21.93557,2.37022 8.60457,1.61954 9.50845,2.0827 12.22553,3.00599 2.7171,0.92627 5.1498,0.32689 5.1498,0.32689 11.1883,-4.67691 31.9387,-12.94104 36.7151,-11.99353 0,0 7.8283,-1.96765 12.0386,-5.24302 4.2105,-3.27537 13.8404,-11.14293 13.8404,-11.14293 0,0 -6.6461,-46.79969 40.899,-42.21355 47.5451,4.58914 110.5838,10.69189 123.2242,12.65952 12.6344,1.96463 57.9039,14.8966 68.7367,20.13962 10.8329,5.24302 41.9629,19.18909 55.8149,25.31601 5.6239,2.48532 27.0438,11.97539 42.8962,18.23555 23.7873,9.39322 41.5627,25.04055 41.5627,25.04055 -14.9071,-6.30557 -26.9579,-13.51622 -38.7657,-18.6442 -9.5498,-4.1472 -19.5383,-6.07551 -27.3103,-9.52646 -16.4805,-7.32264 -29.1772,-13.99145 -39.1656,-18.64415 -36.8218,-17.1488 -36.484,-17.83595 -51.4,-19.00443 -10.2818,-0.80824 7.3869,12.54145 7.3869,12.54145 0,0 -33.7018,-13.10756 -44.5346,-17.69367 -10.83,-4.58916 -19.8582,-6.55379 -30.0896,-5.89993 -10.2314,0.65691 -18.057,-1.30772 -24.0719,-3.27534 -6.018,-1.96765 -40.3241,-3.2754 -46.345,-3.93228 -6.0149,-0.65386 -10.83,-1.96463 -10.83,-1.96463 l 2.4061,3.92926 -16.8508,-2.61849 -4.8151,7.20762 c 0,0 -16.2492,3.2754 -17.4552,-1.96762 -1.203,-5.24 -9.63,23.59054 -13.8433,32.11196 -4.2137,8.51839 -23.4379,5.69405 -28.2527,10.93707 -4.8151,5.24303 -15.0847,8.75146 -17.4878,10.06223 -2.4092,1.31077 -9.71,0.69325 -13.9234,0.69325 -6.2698,0 -0.9274,0.0938 -11.2123,2.04935 0,0 -8.8832,-0.0848 -12.2787,-1.4712 -3.3956,-1.3864 -10.86857,-3.53873 -14.63168,-4.61335 -5.13792,-1.46818 -33.72245,-2.11902 -37.7965,-1.88895 -4.07715,0.23004 -10.96934,2.34001 -15.49675,4.18956 -4.52457,1.84958 -12.45375,6.70818 -12.45375,7.86453' id='path7253-6-3' style='fill:%23dcddde' /%3E %3Cpath d='m 915.83886,346.12922 c -18.28205,1.05041 -36.30925,-11.09449 -36.30925,-11.09449 -22.64663,-4.4378 -23.9651,-24.91341 -23.9651,-24.91341 -9.06103,-3.45095 -16.85373,-26.7176 -16.85373,-26.7176 -14.03586,8.37915 -31.60091,0.091 -31.60091,0.091 0,0 0,-3.45095 -15.84931,0 -15.8524,3.45098 -13.13533,-2.95752 -13.13533,-2.95752 0,0 6.34111,-6.4115 -21.73371,0 -28.07507,6.4085 2.26655,-8.38218 2.26655,-8.38218 -8.1512,2.4641 -34.86904,4.4378 -34.86904,4.4378 -9.80465,0.44197 -19.75457,5.27934 -30.59053,8.36703 -6.74382,1.92226 -18.28206,4.16235 -24.11631,6.65369 -15.56472,6.65364 -46.75983,20.95086 -72.52337,31.06155 -33.87056,13.29221 -60.71298,23.40587 -58.94684,22.97905 2.11561,-0.51157 36.78019,-22.46745 80.1977,-42.15301 40.31532,-18.28397 86.59207,-35.20268 109.92314,-41.8291 30.27649,-10.03198 55.07413,-5.24 69.13971,-0.13622 6.79138,2.4641 44.25911,-1.15335 61.00919,0.81732 16.75603,1.97068 18.50124,29.52379 18.50124,29.52379 3.17043,1.97365 4.30228,27.85882 4.30228,27.85882 0,0 -9.28331,0.24529 1.58522,1.72543 10.86853,1.48028 30.79214,17.25781 30.79214,17.25781 6.79112,0 7.56163,-0.24219 7.56163,-0.24219 0,0 3.94662,-4.97362 9.38386,-7.05324 5.43129,-2.0827 10.41517,-4.16537 16.52495,-4.6255 6.11289,-0.46616 14.74408,-0.52067 20.85386,0.17266 6.11289,0.69627 13.33075,0.75073 21.93557,2.37027 8.60457,1.61952 9.50845,2.08265 12.22553,3.00594 2.7171,0.92631 5.1498,0.32692 5.1498,0.32692 11.1883,-4.67692 31.9387,-12.94105 36.7151,-11.99354 0,0 7.8283,-1.96765 12.0386,-5.24302 4.2105,-3.27537 13.8404,-11.14293 13.8404,-11.14293 0,0 -6.6461,-46.79966 40.899,-42.21355 47.5451,4.58917 110.5838,10.69187 123.2242,12.65955 12.6344,1.9646 57.9039,14.8966 68.7367,20.13962 10.8329,5.24297 41.9629,19.18906 55.8149,25.31598 5.6239,2.48529 27.0438,11.97539 42.8962,18.23553 23.7873,9.39327 41.5627,25.04055 41.5627,25.04055 -14.9071,-6.30553 -26.9579,-13.51617 -38.7657,-18.6442 -9.5498,-4.14717 -19.5383,-6.07548 -27.3075,-9.52641 -16.4833,-7.32264 -29.18,-13.99145 -39.1684,-18.6442 -36.8218,-17.1488 -36.484,-17.83595 -51.4,-19.00443 -10.2818,-0.80825 7.3869,12.54147 7.3869,12.54147 0,0 -33.7018,-13.10753 -44.5346,-17.69669 -10.83,-4.58611 -19.8582,-6.55074 -30.0896,-5.89688 -10.2314,0.65691 -18.057,-1.30772 -24.0719,-3.27537 -6.018,-1.96765 -40.3241,-3.27537 -46.345,-3.93228 -6.0149,-0.65386 -10.83,-1.96463 -10.83,-1.96463 l 2.4061,3.92926 -16.8508,-2.61849 -4.8151,7.20765 c 0,0 -16.2492,3.27537 -17.4552,-1.96765 -1.203,-5.24 -9.63,23.59054 -13.8433,32.11196 -4.2137,8.51839 -23.4379,5.69408 -28.2527,10.9371 -4.8151,5.24302 -15.0847,8.75146 -17.4878,10.0622 -2.4092,1.31077 -9.71,0.69323 -13.9234,0.69323 -6.2698,0 -0.9274,0.0938 -11.2123,2.0494 0,0 -8.8832,-0.0848 -12.2787,-1.4712 -3.3956,-1.38947 -10.86857,-3.53875 -14.63168,-4.61335 -5.13792,-1.47121 -33.72245,-2.12204 -37.7965,-1.88898 -4.07715,0.23004 -10.96934,2.33998 -15.49675,4.18959 -4.52457,1.84958 -12.45375,6.70815 -12.45375,7.86453' id='path7255-1-6' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.68883264' /%3E %3Cpath d='m 917.7115,340.65918 c 0,0 -1.9171,1.47121 -2.40018,5.14917 -0.47999,3.681 -0.24038,2.20984 -0.24038,2.20984' id='path7257-0-6' style='fill:%23452c25' /%3E %3Cpath d='m 1010.0962,335.26783 c 2.424,1.80721 4.9218,3.64467 7.0729,5.79698 0.07,0.0757 0.7645,0.70837 0.5275,0.1998 -0.2639,-0.55701 -0.7142,-1.07466 -1.1409,-1.50452 -2.3852,-2.3884 -5.117,-4.45598 -7.8134,-6.46294 -0.4446,-0.33299 0.044,0.47828 0.1008,0.56606 0.3466,0.50249 0.7584,1.03833 1.2534,1.40459' id='path7259-8-9' style='fill:%23574f4c' /%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' height='504' width='720' version='1.0' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-2100 -1470 4200 2940'%3E %3Cdefs%3E %3Cpath id='D' fill-rule='evenodd' d='m-31.5 0h33a30 30 0 0 0 30 -30v-10a30 30 0 0 0 -30 -30h-33zm13-13h19a19 19 0 0 0 19 -19v-6a19 19 0 0 0 -19 -19h-19z'/%3E %3Cpath id='E' transform='translate(-31.5)' d='m0 0h63v-13h-51v-18h40v-12h-40v-14h48v-13h-60z'/%3E %3Cpath id='e' d='m-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11h39.25v-12h-51.25z'/%3E %3Cg id='G'%3E %3CclipPath id='gcut'%3E %3Cpath d='m-31.5 0v-70h63v70zm31.5-47v12h31.5v-12z'/%3E %3C/clipPath%3E %3Cuse xlink:href='%23O' clip-path='url(%23gcut)'/%3E %3Crect y='-35' x='5' height='10' width='26.5'/%3E %3Crect y='-35' x='21.5' height='35' width='10'/%3E %3C/g%3E %3Cpath id='M' d='m-31.5 0h12v-48l14 48h11l14-48v48h12v-70h-17.5l-14 48-14-48h-17.5z'/%3E %3Cpath id='O' fill-rule='evenodd' d='m0 0a31.5 35 0 0 0 0 -70 31.5 35 0 0 0 0 70m0-13a18.5 22 0 0 0 0 -44 18.5 22 0 0 0 0 44'/%3E %3Cpath id='P' fill-rule='evenodd' d='m-31.5 0h13v-26h28a22 22 0 0 0 0 -44h-40zm13-39h27a9 9 0 0 0 0 -18h-27z'/%3E %3Cg id='R'%3E %3Cuse xlink:href='%23P'/%3E %3Cpath d='m28 0c0-10 0-32-15-32h-19c22 0 22 22 22 32'/%3E %3C/g%3E %3Cpath id='S' d='m-15.75-22c0 7 6.75 10.5 16.75 10.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25 0.25-21.5 24.75-20.5 33.75-20.5s26 4 25.75 21.25h-15.25c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-0.25 11.75 46.25 4 46.25 28.75 0 18.25-18 21.75-31.5 21.75-11.5 0-31.55-4.5-31.5-22z'/%3E %3Cg id='star' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' transform='rotate(18 0,-1)' d='m0-1v1h0.5'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3C/g%3E %3Cuse id='star1' xlink:href='%23star' transform='scale(31.5)'/%3E %3Cuse id='star2' xlink:href='%23star' transform='scale(26.25)'/%3E %3Cuse id='star3' xlink:href='%23star' transform='scale(21)'/%3E %3Cuse id='star4' xlink:href='%23star' transform='scale(15)'/%3E %3Cuse id='star5' xlink:href='%23star' transform='scale(10.5)'/%3E %3C/defs%3E %3Crect y='-50%25' x='-50%25' height='100%25' fill='%23009b3a' width='100%25'/%3E %3Cpath d='m-1743 0 1743 1113 1743-1113-1743-1113z' fill='%23fedf00'/%3E %3Ccircle r='735' fill='%23002776'/%3E %3CclipPath id='band'%3E %3Ccircle r='735'/%3E %3C/clipPath%3E %3Cpath fill='%23fff' d='m-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0 -3360 0z' clip-path='url(%23band)'/%3E %3Cg transform='translate(-420,1470)' fill='%23009b3a'%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(-7)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(-4)'/%3E %3Cuse y='-1697.5' xlink:href='%23D' transform='rotate(-1)'/%3E %3Cuse y='-1697.5' xlink:href='%23E' transform='rotate(2)'/%3E %3Cuse y='-1697.5' xlink:href='%23M' transform='rotate(5)'/%3E %3Cuse y='-1697.5' xlink:href='%23e' transform='rotate(9.75)'/%3E %3Cuse y='-1697.5' xlink:href='%23P' transform='rotate(14.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(17.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(20.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23G' transform='rotate(23.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(26.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23E' transform='rotate(29.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23S' transform='rotate(32.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23S' transform='rotate(35.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(38.5)'/%3E %3C/g%3E %3Cuse id='αCMi' y='-132' x='-600' xlink:href='%23star1'/%3E %3Cuse id='αCMa' y='177' x='-535' xlink:href='%23star1'/%3E %3Cuse id='βCMa' y='243' x='-625' xlink:href='%23star2'/%3E %3Cuse id='γCMa' y='132' x='-463' xlink:href='%23star4'/%3E %3Cuse id='δCMa' y='250' x='-382' xlink:href='%23star2'/%3E %3Cuse id='εCMa' y='323' x='-404' xlink:href='%23star3'/%3E %3Cuse id='αVir' y='-228' x='228' xlink:href='%23star1'/%3E %3Cuse id='αSco' y='258' x='515' xlink:href='%23star1'/%3E %3Cuse id='βSco' y='265' x='617' xlink:href='%23star3'/%3E %3Cuse id='εSco' y='323' x='545' xlink:href='%23star2'/%3E %3Cuse id='θSco' y='477' x='368' xlink:href='%23star2'/%3E %3Cuse id='ιSco' y='551' x='367' xlink:href='%23star3'/%3E %3Cuse id='κSco' y='419' x='441' xlink:href='%23star3'/%3E %3Cuse id='λSco' y='382' x='500' xlink:href='%23star2'/%3E %3Cuse id='μSco' y='405' x='365' xlink:href='%23star3'/%3E %3Cuse id='αHya' y='30' x='-280' xlink:href='%23star2'/%3E %3Cuse id='γHya' y='-37' x='200' xlink:href='%23star3'/%3E %3Cuse id='αCru' y='330' xlink:href='%23star1'/%3E %3Cuse id='βCru' y='184' x='85' xlink:href='%23star2'/%3E %3Cuse id='γCru' y='118' xlink:href='%23star2'/%3E %3Cuse id='δCru' y='184' x='-74' xlink:href='%23star3'/%3E %3Cuse id='εCru' y='235' x='-37' xlink:href='%23star4'/%3E %3Cuse id='αTrA' y='495' x='220' xlink:href='%23star2'/%3E %3Cuse id='βTrA' y='430' x='283' xlink:href='%23star3'/%3E %3Cuse id='γTrA' y='412' x='162' xlink:href='%23star3'/%3E %3Cuse id='αCar' y='390' x='-295' xlink:href='%23star1'/%3E %3Cuse id='σOct' y='575' xlink:href='%23star5'/%3E %3C/svg%3E"

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='300'%3E %3Crect width='600' height='300' fill='%2300abc9'/%3E %3Crect width='600' height='100' y='100' fill='%23fae042'/%3E %3Cpath d='M0,0V300L259.8076,150z' fill='%23000'/%3E %3C/svg%3E"

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23ffd520'/%3E %3Cpath d='M0,600H900V0z' fill='%23ff4e12'/%3E %3Cg stroke='%23000' stroke-width='0.5208'%3E %3Cg fill='%23fff'%3E %3Cpath d='m481.74,187.59c-4.9875-1.7708-8.2083,0.805-8.0458,7.2442,0.15833,6.4392,3.5417,10.142,8.5292,7.7271l-0.48334-14.971z'/%3E %3Cpath d='m486.12,175.53c-4.1542-3.28-8.0292-1.8738-9.9458,4.2758-1.9167,6.1492,0.0958,10.742,5.5958,10.058l4.35-14.333z'/%3E %3Cpath d='m493.04,163.86c-3.5792-3.9046-7.6292-3.1383-10.508,2.6246-2.875,5.7633-1.625,10.618,3.9167,10.825l6.5917-13.45z'/%3E %3Cpath d='m488.5,220.59c-6.1167,2.2538-6.7625,10.625-2.8958,15.776,3.8625,5.1512,10.946,6.1171,14.808,0l-11.91-15.78z'/%3E %3Cpath d='m481.42,202.88c-5.7958-1.9317-11.017,5.8525-11.913,12.878-1.125,8.8538-13.683,11.751-6.7583,25.113,1.4458-8.5317,7.0833-13.2,11.588-13.522,4.5083-0.32208,11.271-1.2879,14.167-6.7613l-7.0833-17.708z'/%3E %3Cpath d='m499.77,237.33c-6.7625,1.6096-7.7292,10.625-2.9,17.064,4.1333,5.5129,17.063,4.1854,16.742-1.2879l-13.842-15.776z'/%3E %3Cpath d='m518.93,291.58c0.32084-5.795-9.0125-8.0488-13.521-6.9221-4.5083,1.1271-13.121-0.16083-15.133-4.9904-1.6083,3.8638,0.72501,8.0492,7.2458,10.142,4.9333,1.5846,4.8292,5.1512,3.3792,6.7613,3.7042,0.64375,14.65,0.64375,18.029-4.9904z'/%3E %3Cpath d='m513.62,254.56c-6.6-2.8975-10.513,1.5158-13.038,5.795-3.7042,6.2783-15.133-1.7704-18.996,6.6004,5.2333-2.2538,10.558,2.5525,13.038,4.1854,7.0833,4.6683,20.767,3.2196,22.7-7.7271l-3.7042-8.8538z'/%3E %3Cpath d='m517.48,262.28c-6.6,4.99-9.175,10.946-9.0125,14.971,0.1625,4.0246,5.7958,12.878,11.913,13.361,3.5417-7.2442,5.3125-22.537-2.9-28.332z'/%3E %3Cpath d='m490.12,293.35c0-2.4146,3.5417-3.3804,5.9542-2.5758,2.4167,0.805,6.1167,3.2196,4.8292,5.7954l-10.783-3.2196z'/%3E %3Cpath d='m453.73,280.15c-0.64167-2.8975,4.025-7.8879,10.304-5.1513,6.275,2.7367,7.0833,8.0492,4.5042,10.142l-14.808-4.9904z'/%3E %3Cpath d='m469.02,285.46c-0.48333-1.61,4.0375-4.8254,11.754-2.8979,7.725,1.9321,9.6208,6.9067,9.3375,10.786l-21.092-7.8879z'/%3E %3Cpath d='m452.93,280.15c4.025-3.0583,2.5-8.855-1.1292-10.625-6.6-3.2196-4.1833-11.59-8.3708-13.2-4.1833-1.61-8.2083-4.5075-8.3708-7.405-2.0917,4.0242-0.80417,7.7271,2.0958,10.303,2.8958,2.5758-2.2542,13.039,1.4458,15.776l14.329,5.1513z'/%3E %3Cpath d='m366.64,277.9c-3.3804-5.3121-11.43-4.3463-14.81-0.64375-3.3804,3.7025-2.8975,9.1758,0.32208,11.59l14.488-10.947z'/%3E %3Cpath d='m385.96,270.01c-1.2879-7.0829-9.82-7.8879-14.488-6.1171-4.6683,1.7708-7.8879,8.8538-4.8292,14.005l19.318-7.8879z'/%3E %3Cpath d='m398.84,269.04c3.0583-5.9563-2.8975-14.81-9.6588-16.098-5.6446-1.0738-12.315-1.0462-14.488-6.6-1.3683,4.8296,2.2542,7.8879,6.4396,10.625,4.185,2.7367-0.80542,9.82,5.9558,13.844l11.752-1.7708z'/%3E %3Cpath d='m398.2,269.25c-1.4088-4.2667,1.4488-9.9434,7.2325-9.5454,5.7842,0.39792,9.08,4.6013,6.53,9.8558l-13.763-0.31041z'/%3E %3Cpath d='m411.07,269.57c-0.79583-4.4221,2.83-9.6404,8.5008-8.435s8.3417,5.83,5.0833,10.675l-13.584-2.2396z'/%3E %3Cpath d='m423.86,271.6c-0.575-4.4575,3.3083-9.4875,8.9125-8.0013,5.6042,1.4871,8.0417,6.2404,4.5417,10.915l-13.454-2.9142z'/%3E %3Cpath d='m326.72,345.35c-10.786,0-13.42,2.5679-14.971,13.683-1.9317,13.844,16.903,15.454,14.971-13.683z'/%3E %3Cpath d='m331.55,330.86c-16.581-6.2783-25.595,19.961-42.015,15.293,5.8754,9.3367,20.118,0.0167,25.434,0.96583,9.015,1.61,28.493-1.7708,16.581-16.259z'/%3E %3Cpath d='m320.76,366.76c-8.21-3.7021-17.064,8.8542-15.454,14.327,2.0438,6.9521,20.766,1.2879,15.454-14.327z'/%3E %3Cpath d='m282.45,420.85c4.5075,1.2833,9.9804,3.8625,9.0146,12.554-0.96583,8.6917-17.385,26.4-32.195,27.367-14.81,0.96667-20.123,18.833-32.84,13.842,11.912-2.25,11.912-15.775,21.249-19.958-6.7612-2.4167-10.303,12.879-18.995,12.879-8.6929,0-12.878,13.842-23.503,12.875-10.625-0.9625-11.743,16.854-33,17.067-16.259,0.15834-36.381,19.154-43.625,10.946,15.776-2.2542,22.142-10.996,31.552-20.608,15.132-15.45,32.196-8.5292,37.991-22.213-6.9225,4.6667-14.971,6.9208-22.859,6.7625-9.9017-0.20417-20.766,15.775-31.874,8.6917,6.4392-0.80416,10.625-3.5417,17.386-10.625,6.9238-7.2542,17.083-2.5667,25.113-9.9792,12.556-11.592,23.342-1.9333,35.415-16.421-3.3808-1.6083-10.625-0.48334-17.386,3.0583-6.7613,3.5417-15.454-2.4167-23.181,1.7708,0.96583-9.4958,18.995-4.0625,30.264-10.625,12.718-7.4042,23.262-5.2333,33.323-4.3458-14.005-0.0792-19.478-13.363-38.795-9.5-8.425,1.6875-15.132-11.588-23.503-4.8292,0.24125-4.9875,9.015-9.0134,18.03-4.1833,9.0146,4.8292,12.648-4.2258,30.586,7.0833,7.405,4.6667,20.122-2.9,28.171,2.0917-1.0462-3.0583-5.6346-4.9917-11.027-4.5875,3.3808-6.9208,25.193-6.0375,34.691,0.8875z'/%3E %3Cpath d='m296.78,410.38c-7.0829-5.4733-16.903,1.1283-23.664-1.4488,0,4.5062,2.2538,11.269,9.6588,13.844,2.2538-1.6083,12.395-10.463,14.005-12.395z'/%3E %3Cpath d='m307.89,394.77c-11.108-5.6342-13.039,8.3708-21.732,5.4733,0.32209,4.0246,3.5417,9.015,10.625,10.142l11.108-15.615z'/%3E %3Cpath d='m314.49,382.05c-16.42-6.4392-18.513,9.3367-28.171,6.2779,2.2538,5.4733,16.098,8.3708,23.181,6.4392l4.9904-12.717z'/%3E %3Cpath d='m337.02,312.99c-4.3467-6.1171-13.522-1.1267-14.971,6.1171-1.4488,7.2442,2.0925,17.386,8.21,15.132l6.7608-21.249z'/%3E %3Cpath d='m348.13,293.67c-7.5658-1.7704-16.259-0.96584-15.293,6.4392-2.8979,1.2879-3.7025,10.786,4.1854,12.878l11.108-19.318z'/%3E %3Cpath d='m353.12,288.68c-7.405-8.6929-15.663-8.4908-20.283-4.8296-8.5321,6.7613-16.823,2.8979-17.064,9.6588,5.1517-3.9438,9.6588,0.805,13.844-0.64375,4.1854-1.4488,7.2442,6.6,18.835,3.2196l4.6683-7.405z'/%3E %3Cpath d='m335.25,418.6c1.1271,2.0917,8.0488,3.0583,11.43-0.48334,4.4804-4.6958-0.48291-17.709-7.5663-18.675-7.0829-0.96583-7.7267,14.65-3.8633,19.158z'/%3E %3Cpath d='m327.2,418.92c10.141,3.7,14.488-4.6708,9.0146-9.9813-1.4488,1.7708-6.7613,8.2104-9.0146,9.9813z'/%3E %3Cpath d='m289.21,432.76c-1.9321,5.7958-11.913,6.7625-23.181,24.792-11.269,18.029-22.054,10.463-24.791,22.858,13.522-10.946,24.142-3.675,32.195-14.488,12.235-16.421,22.309-14.063,27.045-25.113,6.7608-15.775,36.381-15.454,37.991-40.244-9.9808-1.9321-41.533,24.79-49.259,32.194z'/%3E %3Cpath d='m543.24,189.36c12.879,4.1854,13.2,20.927,28.008,26.4,14.813,5.4733,16.263,18.673,28.333,15.454-11.267-3.0588-10.463-16.098-22.213-19.318-13.783-3.7758-18.996-24.791-29.946-28.01'/%3E %3Cpath d='m602.32,276.77c2.2542,5.1512,1.9333,14.327-6.1167,16.742,4.3458,2.7367,10.783,0.16084,14.325-5.795-5.3125,11.751-1.7708,22.376,6.6,24.469-4.025-8.21,4.9917-12.074,2.0958-17.386,5.3125,2.2538,9.9792,9.4979,9.8167,14.005,6.925-7.7271-5.15-18.03-2.8958-25.273l-23.825-6.7613z'/%3E %3Cpath d='m518.93,359.51c-7.8875-6.9221-11.254,1.8096-15.133-1.2075-3.6208-2.8171-8.45-3.2196-10.3-0.4025,6.7625,0.24167,3.4583,5.4733,16.579,6.7613-13.121,0.88541-10.704,15.535-19.479,14.81,9.3375,8.8538,14.167-7.8879,21.733-5.1512-2.2542,0.64375,3.5417,5.9562-0.48333,13.039,6.5208-0.16084,9.175-9.1758,9.9833-13.844l-2.9-14.005z'/%3E %3Cpath d='m345.23,434.69c-2.8979-2.4125-11.269-3.5417-14.488-1.6083-3.2192,1.9292-2.0925,2.4125,1.7708,2.7375,3.8638,0.32084,8.8525,6.5708,0.48291,6.9208-3.8633,0.15834-2.5754,9.4958-10.625,10.142,3.3,4.025,12.718,1.3667,16.098-3.0583-0.64375,3.6208,4.1854,6.9208,2.2538,11.267,5.9562,0.64584,2.495-12.071,11.913-11.429-3.8638,0.48334-2.2538,9.175,4.5071,6.9208-4.0242,1.9333-1.9317,6.6,2.5758,5.475-2.8975,0.96667-3.8638,4.6667,0.16084,6.7625,3.8638-5.3125-0.48292-24.308-14.649-34.129z'/%3E %3Cpath d='m695.85,257.07c12.321,0,22.308-9.9896,22.308-22.312,0-12.32-9.9875-22.31-22.308-22.31-12.325,0-22.313,9.99-22.313,22.31,0,12.322,9.9875,22.312,22.313,22.312z'/%3E %3Cpath d='m579.3,284.02c6.7625-6.4392,17.067-9.6588,24.146-4.8296,7.0833,4.8296,30.588,10.625,42.179,2.5758,11.588-8.0492,17.063-12.235,22.213-11.269,3.8667,5.7954,8.5334,8.5321,14.329,9.015,1.7708,1.9317,8.05,3.5417,11.592,3.0583,5.15,1.2879,11.429-0.32166,16.417-5.795,7.7292,1.1267,14.971-4.6683,17.708-13.361,8.2083-0.96583,8.6917-10.142,3.5417-16.259-4.8292-0.96584-1.125-17.225-18.675-14.005,7.4083,4.5071,1.7708,13.522,7.8917,17.708-4.1875,0-9.5792,1.7708-10.867,8.0488,1.6083-4.3462-0.24167-7.2438-1.3708-8.2096,0.1625-3.7025-8.0458-12.798-15.775-9.4979,5.5542,1.2075,2.4167,10.142,6.4417,13.522-2.9,0.16125-5.9583,1.61-7.7292,4.1854-2.0917-3.7025-9.4958-7.5658-14.004-7.8879,0-1.2879-0.24166-3.8633-0.80416-5.1512-2.0125-3.8633-3.7042-8.4508-2.9-14.327-3.8625,4.1854-7.0833,9.9808-9.0125,14.166-6.1167-4.1854-21.25,1.9317-28.333,3.5412-7.0833,1.61-30.908-2.2533-36.383-8.0488-5.4708-5.795-16.096-9.3367-26.075-12.234-13.725-3.9833-13.846-18.995-28.979-29.298-0.32083,18.674,28.013,77.914,34.45,84.353z'/%3E %3Cpath d='m421.54,426.32c11.913,0,21.571-9.6583,21.571-21.571s-9.6583-21.57-21.571-21.57-21.571,9.6575-21.571,21.57c0,11.913,9.6575,21.571,21.571,21.571z'/%3E %3Cpath d='m370.02,409.74c4.3462,5.6346,11.751,5.3138,14.81,4.8304,2.5758,6.7583,10.785,6.6,14.327,10.3,3.5417,3.7042,15.613,3.3833,19.155,1.2875-3.2167-0.32083-7.4033-2.25-11.428-5.6333-4.8579-4.0792-2.5758-12.234-6.4392-15.131,2.8975-3.2196,3.3804-8.5317,2.7367-10.625,3.0588-1.7708,5.3121-4.6683,5.6342-6.1171,5.3129-0.32208,9.9796-3.0588,11.913-5.1512,2.7375,2.5754,9.6583-0.805,13.363,3.5412,0.80417-10.625-9.3375-16.259-16.1-12.717-2.7375-1.4488-9.9804-0.48292-11.268,1.4488-2.2538-0.96584-8.5321,2.2538-11.43,4.3462,3.2196-1.7704,3.7025-7.0829,2.4146-9.0146,2.7367-1.1267,5.7954-4.8292,6.1171-7.5658,3.8638,0.64375,9.6575-1.9321,12.233-1.2879-4.1833-5.4733-11.105-7.405-18.189-6.9221-7.325,0.40292-10.463,5.5542-11.429,11.108-4.3467,2.5754-5.7954,11.268-4.1854,14.327-2.4958-0.08-4.8296,2.3346-5.7954,3.7025-3.3804-1.4488-8.21-2.4946-11.671-2.4946'/%3E %3Cpath d='m366.32,373.2c-1.4488-4.1854,0.47-7.9533,1.4488-11.268,2.495-8.4508,0.96584-10.625-6.6-9.4975-0.64375,4.0242,3.2196,17.225,5.1513,20.766z'/%3E %3Cpath d='m360.77,352.91c1.9317,1.9317,8.7738,2.8175,9.4979-3.2996,0.83167-7.0225-2.0121-9.74-8.1292-7.0033-0.48292,1.61-1.0471,8.21-1.3688,10.303z'/%3E %3Cpath d='m362.22,342.37c2.5758,1.0458,8.13,3.1388,11.188-2.8175,2.5658-4.9954-0.80458-8.8538-6.1167-8.5321-1.2883,1.4488-3.8638,6.6004-5.0717,11.35z'/%3E %3Cpath d='m366.97,330.54c0.64375,1.9317,7.2442,8.3708,12.073,3.7025,4.8296-4.6683,4.8296-11.59-2.4146-14.166-1.9321,0.32166-7.7271,7.0829-9.6588,10.463z'/%3E %3Cpath d='m376.62,320.08c1.4488,4.0242,5.9558,10.946,14.327,7.7267,8.3713-3.2196,4.8296-13.683,0.96625-15.776-2.2538,0.16125-11.43,4.3467-15.293,8.0492z'/%3E %3Cpath d='m391.92,312.03c-0.64417,3.5417,0,13.2,11.429,13.039,11.428-0.16083,8.2113-13.522,5.3125-15.454-4.6683,0-12.556,0.16083-16.742,2.4146z'/%3E %3Cpath d='m409.14,310.09c-1.2879,2.7367-4.1896,20.75,18.191,15.776,2.8958-0.64375,10.463-17.225-18.191-15.776z'/%3E %3Cpath d='m421.37,311.7c-2.25,2.2533,3.5417,20.444,18.675,17.385,15.133-3.0588,2.4167-20.283-18.675-17.385z'/%3E %3Cpath d='m434.25,314.44c-2.4125,4.9904,1.2125,19.8,19.883,19.8,16.921,0-0.8875-19.478-19.883-19.8z'/%3E %3Cpath d='m448.9,318.79c-1.2125,2.7662-2.6958,18.468,19.317,19.8,15.938,0.96583,12.075-21.571-19.317-19.8z'/%3E %3Cpath d='m472.57,325.39c-2.7333,4.8296-5.6333,16.903,18.513,17.869,15.471,0.61917,5.9583-17.547-18.513-17.869z'/%3E %3Cpath d='m492.69,329.09c-3.5417,4.8296-0.93333,14.303,8.0458,16.098,11.271,2.2538,12.879-8.3708,5.1542-13.522-7.7292-5.1513-13.2-2.5758-13.2-2.5758z'/%3E %3Cpath d='m503.64,331.34c-2.575,4.5075-0.97917,15.454,16.096,15.454,3.5417,0,17.067-13.844-16.096-15.454z'/%3E %3Cpath d='m371.48,541.27c13.83,0,25.042-11.213,25.042-25.042,0-13.833-11.212-25.046-25.042-25.046-13.831,0-25.043,11.213-25.043,25.046,0,13.829,11.212,25.042,25.043,25.042z'/%3E %3Cpath d='m555.15,177.13c-1.9333,1.9317-5.9542,7.7267-6.7625,9.9804-8.3708,25.113,13.975,43.871,27.046,70.83,10.304,21.249,9.0167,54.733-7.0833,75.982-5.5083,7.2683-3.8625,9.3367-10.946,16.742-2.7167,2.8408-5.7958,6.4392-4.8292,16.742,4.5083-1.61,10.946,2.5758,12.233,6.1171,3.2208-1.6096,7.7292-0.96584,9.3375,0.96583,5.4708-2.5754,9.9792-1.2879,14.808,3.8638,4.1875-0.64416,8.6958,0,12.879,4.5071,2.2542-4.5071,6.7625-6.1171,9.9792-5.1512-0.32083-5.795,5.475-9.9804,10.625-7.7267-1.6083-7.7271,5.475-13.523,12.238-11.269,5.7917-4.5075,17.383-4.8292,23.179,1.9317-10.304-2.8975-9.9792,8.0492-18.675,7.0833,2.2542,6.4392-3.5417,10.142-9.3334,12.234,3.7-1.7708,7.725-3.8633,9.0125-1.6096,3.2208-2.8167,9.6584-1.7708,11.271-0.32208,4.2625-1.3679,8.3708-0.32208,10.3,4.8292,5.7958,3.5417,9.6583,12.556,5.475,19.318-1.2875-7.0829-6.1167-6.7613-8.05-9.6588-4.5083,1.61-9.0167,1.61-10.304-1.2879-2.575,2.5758-11.267,4.8296-15.129,0.96584-1.45,5.7954-6.4417,10.625-12.238,10.625,1.6125,4.5071-2.8958,12.236-6.4375,16.098,5.475,2.8958,3.8625,9.3375,2.575,13.2,8.3708,1.2875,1.2875,8.6917,15.775,13.521-7.0792,2.2542-20.925,0-22.858-8.6917-7.0833-0.32083-11.913-7.4042-11.588-14.813-5.475-5.15-6.2792-12.554,1.2875-17.705-6.4417,1.9317-9.9834-8.3708-19.321-4.1854-4.6417,2.0825-16.9-1.4488-16.738-5.7954-1.9333,3.2196-13.683,1.9321-15.296-3.5412-3.8625,2.0925-12.879-1.4488-12.717-6.7613-4.9917,2.2538-11.75-1.7708-11.429-6.9221-4.6667-0.64375-5.15-4.8292-4.8292-8.3708-4.1875-1.9317-3.0583-5.9563-1.45-10.785-2.8958-3.2196-1.6083-7.7271,0.64583-11.913-3.2208-3.2196-2.575-7.0829-1.6125-11.59-15.454-1.2879-34.813-5.015-79.2-18.673-66.967-20.605-84.997,27.688-70.187,57.952,17.087,34.919-1.9317,42.5,3.8638,68.579,6.1171,1.2875,9.3367,6.4375,9.015,11.913,3.6208,0.15834,6.1967,3.5375,4.9088,9.9792,3.0588-0.5625,7.0034,0.32083,9.5788,2.8958,2.2538-4.1833,9.6588-5.15,13.523-0.32084,8.3688-0.64583,12.556,6.1167,12.235,14.488,4.5042,8.05,2.8958,17.871-1.9333,24.146,0.48334-3.3792,0-8.2084-0.15833-11.104-0.3-5.3292-7.7292-6.4417-6.9242-10.788-3.8633,0.32083-7.5663-1.7708-8.8538-4.6667-2.2538,1.9292-5.4733,2.575-8.21,1.6083,4.3462,1.9333,7.7271,9.6583,6.4392,14.808,2.2538,3.8667,1.7708,10.95-0.96583,14.008-1.2879,6.275-6.1171,8.5292-12.395,5.7917,3.5417-2.25,4.8292-6.275,4.6683-9.6583-2.2538-1.9292-3.3804-5.6333-3.5417-7.8875-6.2779,0.96667-14.971-4.3458-16.574-6.4458-13.831,0-25.043,11.213-25.043,25.046-0.64375-5.1542-7.1588-10.229-6.3542-14.575-3.8633-11.913,1.61-23.021,17.386-25.271-1.9317-4.5083,4.8292-9.1792,2.2538-14.329-3.2904-6.5792-9.3367-15.133-18.351-25.113,5.4733-9.3375,3.8633-21.892,0.64375-29.62-4.6233-11.096-9.015-8.3708-25.435,9.6579-26.76,29.383-62.46,21.25-94.012,40.567-8.3838,5.1333-16.741,7.0833-7.7267-1.9292,9.015-9.0167,32.84-18.029,48.293-25.758,28.94-14.471,53.445-38.635,63.104-85.64,22.697-110.46,106.24-74.05,159.04-53.445,49.571,19.346,40.567-24.469,15.454-50.869-30.183-31.732-24.146-56.664-9.9792-76.626,25.433-3.5412,74.213,5.3125,64.392,13.845z'/%3E %3Cpath d='m644.82,448.48c15.217,0,27.554-12.333,27.554-27.55,0-15.218-12.338-27.554-27.554-27.554-15.217,0-27.554,12.336-27.554,27.554,0,15.217,12.338,27.55,27.554,27.55z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m539.7,178.41c-6.1167,27.045-0.96667,39.279,8.05,51.191,18.629,24.621,33.483,80.811,12.233,117.51'/%3E %3Cg stroke-linecap='round'%3E %3Cpath d='m571.89,315.41c2.575-0.96583,7.4042-4.0242,8.5333-9.3367'/%3E %3Cpath d='m573.82,303.66c0.80417-4.6683,8.0458-6.68,8.2083-11.67'/%3E %3Cpath d='m573.98,285.46c-0.48334-4.8296,7.2458-9.1758,6.1167-14.005'/%3E %3Cpath d='m569.8,268.08c-0.64584-2.7367,6.4375-7.8879,4.5083-12.234'/%3E %3Cpath d='m564.49,251.18c-1.45-3.0588,3.3792-6.6004,1.2875-9.82'/%3E %3Cpath d='m556.76,237.65c-0.48334-2.0925,2.4958-6.68,0.8875-9.4163'/%3E %3Cpath d='m549.03,221.72c0.64167-0.805,3.2208-2.7367,2.1708-5.1513'/%3E %3Cpath d='m543.72,210.05c1.0458-0.56375,4.1833-1.53,3.7833-3.8633'/%3E %3Cpath stroke-linejoin='round' d='m382.58,513.57c-6.4392-2.2542-14.488,0.96667-16.098,6.4417'/%3E %3Cpath stroke-linejoin='round' d='m371.31,525c0.805-5.4708,9.1758-7.8875,11.751-5.3125-5.3121-2.8958-7.8879,7.4042-3.2196,7.7292'/%3E %3Cpath stroke-linejoin='round' d='m423.15,397.67c-3.8625,1.9321-4.9875,9.015,0,14.329'/%3E %3Cpath stroke-linejoin='round' d='m428.94,399.28c-2.7333,2.2538-2.575,9.0146,1.45,10.625-3.3792-2.4146,0-6.6,2.4167-6.7612,2.4125-0.16084,4.0208,2.7367,1.125,5.6342'/%3E %3Cpath stroke-linejoin='round' d='m655.12,415.21c-9.0125-2.4125-16.258,8.05-8.05,17.388-0.15833-9.0167,6.2792-14.971,14.167-13.363'/%3E %3Cpath stroke-linejoin='round' d='m657.61,425.47c-2.2167,0-3.4625,1.7333-3.4625,3.4208,0,1.7708,1.5292,3.4625,4.025,3.4625,1.6125,0,2.9-1.85,2.9-3.3'/%3E %3Cpath stroke-linejoin='round' d='m689.4,227.83c1.45,5.4733,9.0167,7.7271,14.971,6.4392'/%3E %3Cpath stroke-linejoin='round' d='m704.37,230.73c-4.6667,0.16125-8.5292-4.1854-8.2083-7.8879,0,2.7367,6.2792,4.0246,8.2083,2.2538'/%3E %3Cpath d='m384.83,414.57c-1.2875-3.2208,3.8638-6.4404,4.0246-9.4992,0.16125-3.0583,5.795-5.4729,11.59,0.32209'/%3E %3Cpath d='m397.71,371.11c-1.1267,0.48292-2.0929,1.1267-3.0588,1.4488'/%3E %3Cpath d='m408.82,388.65c-1.3688,0.0813-4.1854-0.08-5.715-1.1271'/%3E %3Cpath d='m403.19,394.77c-1.1267,0.56417-3.6229,1.53-5.0717,1.8521'/%3E %3Cpath d='m347.97,492c-0.16125,2.9,2.7367,7.0833,4.3462,8.3708'/%3E %3Cpath d='m360.53,485.08c-1.61,2.4125-2.5754,6.6-1.61,9.4958'/%3E %3Cpath d='m384.51,494.74c-2.8979-1.9333-0.96583-6.925-1.2879-10.142-0.32208-3.2208,3.3808-8.3708,10.625-4.025'/%3E %3Cpath d='m357.47,476.39c2.8979-0.48333,5.9563-0.325,7.8879,0.47917'/%3E %3Cpath d='m394.17,467.21c-1.2875,1.7708-1.6096,3.7042-1.7704,4.9917'/%3E %3Cpath d='m407.69,466.89c-2.2538,0-4.1854,1.6083-5.1513,3.2208'/%3E %3Cpath d='m376.46,384.47c2.5758,0.88584,9.2558,4.9904,9.4979,9.2567'/%3E %3Cpath d='m403.83,363.54c-7.8875-0.16125-10.946-8.21-4.99-8.21'/%3E %3Cpath d='m418,374.32c-3.0583,1.2879-1.6083,6.6,2.7375,9.1758'/%3E %3Cpath d='m399.16,424.87c-1.5296-1.9292,0.48291-7.5625,5.4733-5.875'/%3E %3Cpath d='m410.91,483.63c0.32-4.9083,6.52-7.8083,9.0158-2.2542'/%3E %3Cpath d='m388.05,497.63c-0.40292-5.3917,2.3338-7.1625,4.7483-7.4833,2.4146-0.32084,5.8767,1.6875,7.4863,5.2292'/%3E %3Cpath d='m340.08,501.66c0.32208-3.2208,3.0588-6.6,5.9562-6.1167'/%3E %3Cpath d='m634.67,358.71c-2.0958,1.53-3.4625,8.3708,4.5042,9.015'/%3E %3Cpath d='m622.44,369.98c0,0.80459,1.0458,1.9317,1.6917,2.4146'/%3E %3Cpath d='m660.43,382.86c-2.0917-1.6096-7.4875,4.9104-2.575,9.6588'/%3E %3Cpath d='m609.24,436.95c-1.2083-4.5875,3.0583-5.7958,7.0833-4.8292'/%3E %3Cpath d='m598.94,404.43c2.4125-1.6096,4.8292-3.3804,7.8875-4.1854'/%3E %3Cpath d='m597.65,422.13c0-3.8625,1.9292-7.0792,3.7-8.0458'/%3E %3Cpath d='m611.81,377.71c-0.32083,4.6683,1.6125,9.1758,3.0625,11.59'/%3E %3Cpath d='m650.13,378.03c-2.3375,0.725-4.4292,1.6096-5.3125,3.5417'/%3E %3Cpath d='m647.55,391.23c1.1292-0.96583,2.4167-2.0925,2.9792-2.8975'/%3E %3Cpath d='m708.4,250.69c0,4.5071-5.6333,6.9217-9.3333,4.0242'/%3E %3Cpath d='m720.64,250.85c2.4917,1.9317,11.104,0.0812,9.0917-4.9092'/%3E %3Cpath d='m710.17,276.77c-1.7708-0.32209-4.8292-2.2538-6.1167-3.8633'/%3E %3Cpath d='m727.88,263.41c-2.8958,0.64375-4.8292,0-6.2792-0.64375'/%3E %3Cpath d='m682.16,279.51c1.6083,0,5.4708-0.64417,8.1292-2.0117'/%3E %3Cpath d='m677.33,251.02c-2.0917-0.24083-3.625,0.16125-4.8292,0.96584'/%3E %3Cpath d='m709.77,258.9c-0.5625,2.0129-2.0125,5.1512-3.7833,6.5204'/%3E %3Cpath stroke-linejoin='round' d='m671.86,265.99c4.025-1.7708,9.0167,11.912,18.675,7.0829'/%3E %3Cpath stroke-linejoin='round' d='m691.34,258.9c-1.2875,1.7708-2.0917,4.5075-2.2542,6.9221'/%3E %3C/g%3E %3Cpath d='m498.81,237.98c1.2875-0.16083,3.5417-0.64375,4.025-2.2538'/%3E %3Cpath d='m333.16,387.85c4.8296,2.7367,8.2104,7.405,6.1175,14.327'/%3E %3Cpath d='m554.5,223.17c1.45,0.96583,6.925,0.96583,9.9833-0.16083'/%3E %3Cpath d='m568.35,226.39c-0.1625,2.2538,0.48333,10.785-3.8625,12.556'/%3E %3Cpath d='m566.1,237.82c4.025,1.2879,12.075,0.80459,14.65-6.6'/%3E %3Cpath d='m575.11,237.49c2.0917,3.2196,2.7333,9.4979-3.5417,12.878'/%3E %3Cpath d='m576.72,242.81c4.6667,1.6096,15.454,1.7704,14.325-7.405'/%3E %3Cpath d='m587.35,242.81c3.2208,4.5071,17.388,9.8196,15.133,0.48292'/%3E %3Cpath d='m574.31,255.84c5.4708,1.2879,13.2-2.415,9.9792-12.073'/%3E %3Cpath d='m599.74,248.6c0.80416,3.7025,18.833,7.5658,16.421-0.805'/%3E %3Cpath d='m612.78,252.63c3.3833,7.7267,21.25,7.0829,15.617-3.2196'/%3E %3Cpath d='m625.5,257.45c3.5417,4.3467,19.321,1.7708,13.042-8.6929'/%3E %3Cpath d='m638.37,257.29c9.8208,7.405,21.25-3.2196,8.8542-10.947'/%3E %3Cpath d='m652.86,254.88c8.6958,6.9221,19.321-5.6346,11.754-9.1758'/%3E %3Cpath d='m584.12,251.98c2.7375,0.805,8.5333,0.48292,9.8208-4.5071'/%3E %3Cpath d='m591.77,250.85c-0.32083,7.325,11.996,10.142,15.133,1.6908'/%3E %3Cpath d='m602.8,257.13c2.2542,4.8292,13.038,6.7608,14.808-0.16125'/%3E %3Cpath d='m615.84,260.19c1.7708,4.8296,11.108,4.3467,13.683-0.64375'/%3E %3Cpath d='m626.14,262.77c2.8958,6.2779,14.808,6.2779,17.546-2.8979'/%3E %3Cpath d='m641.6,263.89c4.6667,2.8979,14.65,1.7708,13.842-7.2438'/%3E %3Cpath d='m653.51,263.09c6.9208,5.6346,16.742,0.16125,11.913-9.3367'/%3E %3Cpath d='m664.94,270.49c3.7042-0.64375,5.6333-8.0488,1.7708-9.9804'/%3E %3Cpath d='m579.14,271.78c7.725-4.1854,9.175-11.268,3.8625-18.19'/%3E %3Cpath d='m585.74,264.7c4.8292,2.8975,14.004-0.16083,15.613-7.2442'/%3E %3Cpath d='m592.34,265.5c2.7333,3.5413,3.2167,7.8879-0.325,11.912'/%3E %3Cpath d='m594.59,270.01c8.5292-5.3121,19.154,4.5075,11.267,10.464'/%3E %3Cpath d='m604.41,269.53c1.9333-0.48291,5.3125-4.0242,5.6333-8.0488'/%3E %3Cpath d='m608.27,273.23c3.5417-3.7025,27.692,3.8638,12.396,11.59'/%3E %3Cpath d='m619.54,263.09c4.6667,1.7708,7.0833,8.3713,0,10.625'/%3E %3Cpath d='m625.66,279.19c5.15-5.3121,21.25-1.9317,15.454,4.8296'/%3E %3Cpath d='m637.25,277.09c2.8958-9.82,20.121-3.7025,14.488,0.32167'/%3E %3Cpath d='m633.71,267.27c0.48333,1.9321,0.64166,6.7613-2.575,9.3371'/%3E %3Cpath d='m648.2,265.34c0.64167,1.61,0.48334,4.6683-0.96667,6.6004'/%3E %3Cpath d='m659.14,265.5c0.96666,1.7704,2.575,5.1513-0.96667,7.8879'/%3E %3Cpath d='m521.35,191.45c0.15833,9.1754,3.3792,15.293,15.775,9.4975'/%3E %3Cpath d='m525.21,202.4c-6.1167,8.21,0.80417,17.064,12.879,8.21'/%3E %3Cpath d='m506.37,206.42c8.3708,9.0146,23.342,2.4146,13.683-11.269'/%3E %3Cpath d='m530.2,214.15c-1.6125,8.8538,5.6333,10.625,11.588,6.6'/%3E %3Cpath d='m498.97,207.87c1.525,8.9013,10.625,15.937,19.479,10.464'/%3E %3Cpath d='m509.92,220.11c0,12.718,17.546,14.166,21.571,0.96625'/%3E %3Cpath d='m525.21,229.12c5.6333,11.59,17.867,6.9221,21.892-0.16084'/%3E %3Cpath d='m512.81,210.61c2.2542,5.6342,6.7625,11.913,17.225,7.2442'/%3E %3Cpath d='m480.62,207.87c1.45,4.6683,9.8208,10.303,19.479,3.8633'/%3E %3Cpath d='m486.57,213.83c-5.1542,7.5658,5.15,14.649,17.546,3.3804'/%3E %3Cpath d='m492.69,223.17c2.0917,10.625,6.275,19.157,21.408,5.4733'/%3E %3Cpath d='m506.53,234.11c5.475,6.7608,13.846,10.946,21.733-0.48292'/%3E %3Cpath d='m534.06,236.04c-0.48333,8.0488,1.125,12.073,7.4042,11.751,4.95-0.25334,9.6584-4.1854,12.396-8.3708'/%3E %3Cpath d='m540.34,247.8c-0.1625,9.1758,7.0792,16.42,20.604,7.0833'/%3E %3Cpath d='m545.97,258.58c-2.575,6.9221,5.15,18.19,20.283,12.395'/%3E %3Cpath d='m513.94,240.23c-0.9625,8.8538,7.2458,14.81,20.446,3.3804'/%3E %3Cpath d='m520.38,250.05c0.48334,7.2442,8.6917,15.937,20.767,3.3804'/%3E %3Cpath d='m526.17,259.23c-0.96667,12.395,10.463,15.937,20.121,6.4392'/%3E %3Cpath d='m508.95,250.05c2.575,0.16125,4.6667-2.0925,5.9542-3.7025'/%3E %3Cpath d='m514.42,259.06c2.2542,0.48292,6.1208-1.61,7.4083-4.1854'/%3E %3Cpath d='m520.06,273.71c2.575,2.7367,11.267,0.805,12.392-2.8975'/%3E %3Cpath d='m529.72,273.55c4.8292,11.268,17.704,10.785,23.017-1.9317'/%3E %3Cpath d='m550.32,276.13c2.4125,6.6,8.5333,10.785,18.513,8.5317'/%3E %3Cpath d='m555.15,282.89c-5.6333,9.1758,1.7708,19.961,14.325,9.3367'/%3E %3Cpath d='m558.21,296.57c-0.64167,5.795,4.6708,12.395,11.913,13.2'/%3E %3Cpath d='m534.38,279.67c-1.9333,13.039,7.4042,19.318,19.158,12.395'/%3E %3Cpath d='m520.7,285.95c3.0583,2.4146,8.5333,2.7367,13.683,0.805'/%3E %3Cpath d='m540.66,294.32c-2.9,10.947,8.3708,18.835,18.029,6.6'/%3E %3Cpath d='m525.05,287.72c0.1625,5.6342,5.6375,11.751,15.133,9.9804'/%3E %3Cpath d='m566.74,308.97c-6.4417,4.3462-7.7292,12.073,1.2875,17.063'/%3E %3Cpath d='m550.96,306.71c0.325,6.6,3.3833,10.303,10.625,10.946'/%3E %3Cpath d='m541.47,303.33c-9.6583,8.8542-0.1625,19.157,11.267,10.464'/%3E %3Cpath d='m548.23,316.53c-3.2208,10.142,8.8542,16.259,15.292,5.9562'/%3E %3Cpath d='m528.27,294.96c-3.5417,9.9808,0.96667,16.581,9.175,15.937'/%3E %3Cpath d='m515.55,293.03c0.48334,5.9562,5.6333,8.0488,11.429,6.7612'/%3E %3Cpath d='m519.25,299.31c-4.3458,8.3708,2.2542,12.878,10.95,9.6588'/%3E %3Cpath d='m556.6,327.64c-1.45,5.3121-0.64583,9.1758,7.2417,10.947'/%3E %3Cpath d='m557.08,335.21c-9.5,4.3467-10.304,13.523-2.9,19.478'/%3E %3Cpath d='m549.43,324.99c-4.9875,4.5075-4.025,12.314,1.45,15.373'/%3E %3Cpath d='m507.18,295.61c-5.475,5.3933-0.24167,20.283,11.829,12.155'/%3E %3Cpath d='m538.57,314.44c-7.4083,6.1175-4.025,17.225,8.2083,14.166'/%3E %3Cpath d='m526.33,309.77c-3.8625,10.947-0.15834,14.81,8.5333,14.971'/%3E %3Cpath d='m499.13,295.12c-6.6,4.99-4.8292,12.073-1.9292,15.293,2.8958,3.2196,8.3667,1.7708,10.138-2.4146'/%3E %3Cpath d='m485.28,290.78c-7.4042,9.4979,0,20.766,10.467,17.386'/%3E %3Cpath d='m524.89,318.95c-7.5667,2.7367-13.338,9.6071-8.6958,15.615,2.7375,3.5417,14.65,4.0246,18.029-9.6588'/%3E %3Cpath d='m511.2,310.09c-4.3458,6.2783-2.9,12.235,5.15,15.293'/%3E %3Cpath d='m510.72,321.85c-4.6708,2.5758-7.7292,5.6346-6.6,11.269'/%3E %3Cpath d='m500.26,312.03c-1.7708,7.5663,0.32083,12.235,4.9875,14.488'/%3E %3Cpath d='m500.1,321.04c-7.2458-0.48292-10.946,2.5754-8.5333,9.6588'/%3E %3Cpath d='m492.21,322.81c-7.0833-2.5758-8.2125-8.6929-5.1542-15.132'/%3E %3Cpath d='m486.09,317.18c-7.7292,0.32208-11.108,4.1854-11.108,9.4979'/%3E %3Cpath d='m475.62,287.07c-5.6333,2.4146-7.4042,9.9808-5.3125,14.166,2.0958,4.1854,8.6958,4.5075,12.721,1.7708'/%3E %3Cpath d='m459.85,281.12c-5.15,5.7954,0.80417,17.064,9.9834,14.327'/%3E %3Cpath d='m446.65,276.61c-4.8292,6.7608,0.48333,18.03,12.879,14.81'/%3E %3Cpath d='m460.17,322.81c-1.2875-8.0492,7.0833-13.361,17.388-2.8979'/%3E %3Cpath d='m472.57,303.66c-3.0583,2.7367-4.5042,7.0829-4.025,10.625'/%3E %3Cpath d='m433.45,272.75c-5.3125,9.015,1.1292,17.225,12.558,14.005'/%3E %3Cpath d='m463.23,295.12c-7.5667,7.5658-4.9917,15.132,0.64167,19.478'/%3E %3Cpath d='m458.4,303.98c-11.429,0.16084-12.071,13.361-2.7333,17.547'/%3E %3Cpath d='m449.71,290.78c-4.6667,3.2196-6.1167,12.073,1.9333,15.615'/%3E %3Cpath d='m449.39,310.58c-4.8292-2.2538-10.625,0.48292-10.142,6.1171'/%3E %3Cpath d='m442.14,310.74c-4.3458-10.303-17.063-8.5317-15.933,2.0929'/%3E %3Cpath d='m445.68,298.02c-2.7333,0.48291-8.2083,2.0925-10.3,6.2783'/%3E %3Cpath d='m436.19,286.43c-5.15,5.795-1.1292,12.717,3.0583,14.166'/%3E %3Cpath d='m420.9,270.17c-0.96667,6.9221,1.7708,10.303,10.463,9.6588'/%3E %3Cpath d='m423.95,279.03c-3.3833,8.3708,1.125,12.073,9.8167,11.59'/%3E %3Cpath d='m425.88,289.33c-5.15,6.1171-1.6083,12.718,3.3792,15.454'/%3E %3Cpath d='m423.47,297.06c-9.175-1.1271-10.625,9.4975-7.5667,14.488'/%3E %3Cpath d='m416.06,269.37c-5.6321,2.4146-8.8517,9.4975-5.7933,13.844,3.06,4.3463,9.1767,2.8975,12.556,0.64375'/%3E %3Cpath d='m412.2,285.14c-4.6675,7.0829-0.48333,12.395,4.5083,14.488'/%3E %3Cpath d='m394.17,268.56c-3.7021,3.8633-1.4488,11.752,7.5663,11.913,7.2579,0.13,10.946-6.7612,8.6929-11.59'/%3E %3Cpath d='m400.45,280.47c-2.8975,6.4392-1.1267,13.361,9.8196,12.234'/%3E %3Cpath d='m414.94,302.85c-6.7608-3.0583-15.776,0-11.912,8.0492'/%3E %3Cpath d='m402.06,291.42c-2.7367,3.8633-1.7708,9.3367,1.2875,12.717'/%3E %3Cpath d='m401.58,301.72c-4.5075,0.805-8.8542,3.2196-6.1175,10.303'/%3E %3Cpath d='m394.81,306.23c-5.795-1.7708-13.2,2.4146-8.6929,8.3708'/%3E %3Cpath d='m385.16,308.97c-4.9904-0.80501-10.946,4.5071-6.1171,9.8196'/%3E %3Cpath d='m377.11,314.44c-4.5075,1.1271-9.8196,6.2783-5.1517,10.303'/%3E %3Cpath d='m399.81,289.17c-6.4392,2.8975-7.0833,10.142-4.0246,15.454'/%3E %3Cpath d='m393.04,275.81c-9.6588,3.7025-9.4975,16.581,1.1267,20.605'/%3E %3Cpath d='m389.66,293.51c-5.795,3.3804-6.9221,9.8196-3.0583,14.005'/%3E %3Cpath d='m379.52,270.98c-3.8638,1.2879-3.5417,13.2,6.7613,12.878'/%3E %3Cpath d='m368.9,275c-7.7271,5.1513,1.6096,18.19,14.166,8.8538'/%3E %3Cpath d='m376.14,287.07c-1.1267,5.3125,0.32209,11.108,8.8542,11.752'/%3E %3Cpath d='m376.62,294.16c-6.1175,2.2533-7.2442,14.81,3.8633,15.776'/%3E %3Cpath d='m357.15,282.73c-7.8879,7.2442,6.4392,13.522,11.752,3.0588'/%3E %3Cpath d='m346.2,294.8c-3.8638,4.6683,9.6583,16.903,15.615-3.5417'/%3E %3Cpath d='m363.26,290.94c0.32167,4.8292,3.2196,7.7267,9.1754,8.0488'/%3E %3Cpath d='m372.28,303.66c-9.4975,1.4488-12.556,13.361-1.9317,15.937'/%3E %3Cpath d='m354.73,302.05c-0.32208,4.5071,4.3463,8.2096,9.6588,7.405'/%3E %3Cpath d='m369.22,319.27c-8.6925,1.9317-9.8196,13.2-2.0925,12.556'/%3E %3Cpath d='m363.1,342.29c-7.2446-2.1729-7.4054-10.786-0.96625-14.005'/%3E %3Cpath d='m357.15,334.72c-6.1167,3.7025-3.7021,12.556-0.48292,13.844,3.2196,1.2879,5.7954-0.32166,6.1175-3.0583'/%3E %3Cpath d='m362.3,357.9c0.64417,4.1854-14.891,2.5758-6.9217-10.463'/%3E %3Cpath d='m355.29,358.63c-5.2313,8.21,3.3008,14.89,8.6929,7.8883'/%3E %3Cpath d='m356.02,368.53c-2.0929,6.6004,5.875,11.35,11.026,6.1983'/%3E %3Cpath d='m338.63,306.71c-2.8979,5.9563,11.59,8.2096,12.556-4.0246'/%3E %3Cpath d='m334.61,315.57c-2.8975,11.59,18.995,9.1758,13.361-5.7954'/%3E %3Cpath d='m348.45,317.5c3.0583,1.7708,12.235,1.9317,14.488-7.8879'/%3E %3Cpath d='m356.34,317.82c0.64375,3.0583,3.3804,6.7608,5.9558,7.8879'/%3E %3Cpath d='m345.88,320.88c-0.96583,6.2783,5.3121,11.43,12.556,10.947'/%3E %3Cpath d='m347,327c-3.5412,4.8296-4.6683,14.166,6.4396,14.81'/%3E %3Cpath d='m330.1,328.61c-1.7708,4.9904,8.6929,10.142,14.81,1.9317'/%3E %3Cpath d='m326.88,341.32c-0.88625,3.7838,8.5317,8.8542,13.844-7.2438'/%3E %3Cpath d='m336.54,342.29c2.2538,4.0242,9.8196,7.2438,14.488-0.64417'/%3E %3Cpath d='m343.46,346.48c-1.9317,5.6342,3.3808,10.946,9.8196,9.3367'/%3E %3Cpath d='m331.39,345.19c-1.2879,8.0488,8.0488,12.717,13.844,8.5317'/%3E %3Cpath d='m325.27,348.73c-2.7362,10.303,10.464,14.166,15.454,6.4388'/%3E %3Cpath d='m337.35,358.23c0.48333,5.7954,9.4983,10.785,16.581,5.9563'/%3E %3Cpath d='m321.25,363.06c-0.64375,2.5754,10.142,5.1513,11.751-3.8638'/%3E %3Cpath d='m327.53,365.31c2.5754,6.6004,11.268,8.21,16.259,0.16125'/%3E %3Cpath d='m340.89,368.69c1.1271,6.1171,9.015,9.4975,15.937,5.3121'/%3E %3Cpath d='m359.72,376.42c-1.7704,8.21,6.7613,14.81,12.073,10.303'/%3E %3Cpath d='m346.04,374.97c-2.5754,9.015,8.6929,14.166,14.971,9.1758'/%3E %3Cpath d='m332.52,370.46c-0.64375,8.3708,5.9562,13.361,13.522,9.6583'/%3E %3Cpath d='m318.19,371.27c-2.2542,5.4733,9.6588,9.9808,15.293,5.3125'/%3E %3Cpath d='m310.78,386.24c3.0588,3.5412,13.683,0,14.649-7.8879'/%3E %3Cpath d='m322.54,384.14c3.8633,4.5075,13.039,6.9221,16.742-2.7367'/%3E %3Cpath d='m336.06,386.4c-0.16125,6.9221,12.235,11.913,16.259-0.805'/%3E %3Cpath d='m366.88,388.09c-1.1271,3.3808,1.53,8.7729,7.0829,9.4167'/%3E %3Cpath d='m356.66,386c-0.805,3.8633,4.8296,9.2554,10.786,7.0829'/%3E %3Cpath d='m368.58,394.69c-1.6096,4.1854-0.24208,10.221,5.3921,10.141'/%3E %3Cpath d='m369.14,402.5c-4.1854,3.5412-2.415,9.8204,3.6229,10.062'/%3E %3Cpath d='m366.97,408.45c-5.9563,4.0225-3.8633,12.877,4.0242,12.398'/%3E %3Cpath d='m348.94,391.39c0,8.6929,10.785,9.9804,12.878,1.9317'/%3E %3Cpath d='m357.63,398.47c-1.61,5.1512,2.5754,10.142,9.1754,8.6929'/%3E %3Cpath d='m358.92,460.61c1.4492,2.0958,7.405-1.4458,5.7954-4.9875s-7.9192-1.6167-7.2442,2.0917'/%3E %3Cpath d='m363.26,454.17c0.80459-7.0833-7.5663-8.2083-9.6588-2.0917'/%3E %3Cpath d='m356.66,448.54c2.0929-3.5417-4.99-8.3708-7.8879-3.2208'/%3E %3Cpath d='m351.35,443.22c1.9317-5.1542-6.1171-7.4042-6.7613-2.7375'/%3E %3Cpath d='m342.82,433.72c0.96625-2.575,9.9808-0.96667,6.1175,4.3458'/%3E %3Cpath d='m355.86,444.51c3.5417-3.2208-2.4142-9.8208-6.1171-7.4042'/%3E %3Cpath d='m379.68,454.33c-2.8179,0.32084-5.7158,2.1708-3.6229,8.1292,1.4512,4.1333,7.6471,4.3458,8.5317,1.85'/%3E %3Cpath d='m375.58,457.31c-2.7367-1.7708-8.6929,1.2083-5.9562,7.0042,2.0604,4.3625,7.2442,2.575,8.0488,0.32083'/%3E %3Cpath d='m360.2,465.6c1.3675,2.4125,8.2088,1.3708,9.4167-1.2875'/%3E %3Cpath d='m364.87,457.63c1.4488-0.96667,4.1042,0.2375,4.6683,1.4458'/%3E %3Cpath d='m364.39,417.95c-4.6683,3.0583-1.7708,12.396,5.4733,9.9792'/%3E %3Cpath d='m362.94,425.52c-3.7025,2.8958-0.32208,11.913,6.6,8.5333'/%3E %3Cpath d='m364.07,434.05c-2.5754,2.575-0.0808,9.7375,6.6004,8.3708'/%3E %3Cpath d='m363.1,437.59c-1.4492-0.64584-5.2325-0.1625-6.8425,2.25'/%3E %3Cpath d='m358.92,404.99c-3.5412,3.3804-1.8517,10.304,4.7483,10.866'/%3E %3Cpath d='m357.63,412.07c-5.0717,2.4958-5.0717,12.554,5.07,12.958'/%3E %3Cpath d='m357.23,423.42c-2.8167,2.2542-1.4488,10.946,5.7954,9.8167'/%3E %3Cpath d='m359.56,432.92c-1.0471,1.0458-1.2083,3.7042-0.32208,4.8292'/%3E %3Cpath d='m356.34,429.62c-2.5754,0.0792-5.9562,1.9333-6.8425,4.5875'/%3E %3Cpath d='m344.83,424.87c0.96583-2.575,8.9354-2.4125,9.4979,5.1542'/%3E %3Cpath d='m355.13,421.01c-1.1271,0.24167-3.2996,1.2875-3.8633,3.4625'/%3E %3Cpath d='m351.67,397.43c-3.4617,3.1388-5.1512,13.04,5.3921,14.97'/%3E %3Cpath d='m344.67,417.87c0-2.6583,7.1642-4.9125,9.6588-0.96666'/%3E %3Cpath d='m340.08,403.46c1.0458,2.0129,6.0362,4.7496,9.095,2.4958'/%3E %3Cpath d='m314.16,387.69c-0.16042,4.6683,3.7029,8.8538,9.015,8.21,5.3121-0.64417,6.4392-5.3125,4.8292-8.3713'/%3E %3Cpath d='m323.98,396.06c-3.5417,4.3463,0.805,10.464,4.8292,8.6929'/%3E %3Cpath d='m328.01,393c2.0929-0.805,9.015-1.7708,11.108,1.4488'/%3E %3Cpath d='m305.63,394.29c-1.61,2.4146,8.3712,4.8296,11.751,0.16083'/%3E %3Cpath d='m314,396.86c-0.3225,3.2196,1.2875,8.6925,9.4975,6.4392'/%3E %3Cpath d='m324.79,408.29c1.2875-2.7367-4.8296-7.2438-9.4979-2.2538-4.6683,4.9904,0.64375,10.625,3.5417,8.6917'/%3E %3Cpath d='m303.38,397.51c-2.4146,4.1854,6.9221,11.833,12.235,4.7496'/%3E %3Cpath d='m297.18,404.75c-3.3804,3.4617,0.805,9.8208,5.8763,7.8875,5.0704-1.9313,4.5875-7.2438,3.3808-8.6113'/%3E %3Cpath d='m290.66,411.19c-2.7367,2.4942-0.0813,8.3692,3.7025,8.3692,3.7821,0,6.1171-2.975,5.3921-6.7583'/%3E %3Cpath d='m306.03,410.71c-0.48333,3.7021,4.99,6.2771,8.5317,2.8188'/%3E %3Cpath d='m314.73,406.76c0.48292-0.805,0.0813-2.1742-0.72334-2.8179'/%3E %3Cpath d='m284.79,416.18c-3.1383,2.4958,3.6229,9.4167,7.8879,3.0583'/%3E %3Cpath d='m309.01,414.81c-2.0129,1.9292,1.2067,7,4.4262,5.4708'/%3E %3Cpath d='m297.99,418.35c0.48292,3.4583,7.2442,6.0333,11.51,0.725'/%3E %3Cpath d='m301.69,421.81c-1.0458,2.175,1.0471,5.6375,3.6225,5.1542'/%3E %3Cpath d='m365.76,441.7c-2.4942,4.9083,5.4733,10.625,11.269,4.6667'/%3E %3Cpath d='m371.55,449.02c-1.2067,2.6542,0.24209,6.3583,2.4146,7.725'/%3E %3Cpath d='m363.99,454.57c0.56417-2.4167,4.0242-4.6708,7.1642-3.5417'/%3E %3Cpath d='m359.8,448.21c0.48292-2.1708,3.3804-4.3458,5.5542-3.7792'/%3E %3Cpath d='m549.35,347.76c-11.429,0.16125-6.6,18.513,3.2208,14.81'/%3E %3Cpath d='m545.65,361.29c-2.2542,3.7025,2.0917,9.5788,6.9208,6.1171'/%3E %3Cpath d='m551.29,368.13c-3.3833,5.6342,8.6917,14.246,13.521,5.3921'/%3E %3Cpath d='m560.95,376.9c0.15834,5.3125,15.613,8.6929,13.363-1.9317'/%3E %3Cpath d='m572.86,380.76c3.7,6.2779,17.546,6.9221,16.096-2.4146'/%3E %3Cpath d='m585.9,384.79c2.9,4.1854,16.421,6.7608,15.938-1.9321'/%3E %3Cpath d='m531,331.83c1.9292,4.9904,8.5292,6.7613,15.775,3.8633'/%3E %3Cpath d='m526.82,335.37c4.5083,2.8975-2.0917,16.098-9.0125,10.785'/%3E %3Cpath d='m526.82,343.58c4.9917,2.415,11.108,0.64417,12.879-6.4392'/%3E %3Cpath d='m536.64,342.61c0.48334,3.7025,5.7958,6.6004,12.717,5.1512'/%3E %3Cpath d='m524.24,346.48c6.4417,5.4733-2.8958,16.742-7.0833,11.59'/%3E %3Cpath d='m526.66,350.66c3.0583,2.2538,10.946,0.96584,11.75-4.9904'/%3E %3Cpath d='m534.87,350.66c0.64583,3.8633,3.7042,5.3121,8.05,5.4733'/%3E %3Cpath d='m524.89,355.97c3.2167,4.5075,11.267,5.7954,14.808-0.16083'/%3E %3Cpath d='m536.15,359.19c-0.32083,4.3467,4.5083,7.8879,9.5,6.9221'/%3E %3Cpath d='m518.61,368.85c4.1833,2.0925,8.6917-5.795,5.15-11.268'/%3E %3Cpath d='m523.44,377.22c4.9917,0.32208,5.6333-7.2438,0.96667-11.43'/%3E %3Cpath d='m534.87,384.14c4.1875-0.96583,2.8958-10.142-7.2458-10.947'/%3E %3Cpath d='m547.58,390.91c4.025-1.1271,0.80417-11.269-10.3-10.625'/%3E %3Cpath d='m562.88,394.45c2.7333-4.1854-6.2792-11.268-13.683-7.5658'/%3E %3Cpath d='m570.44,400.24c4.9917,1.4488,8.3708-11.751-7.4042-9.6588'/%3E %3Cpath d='m579.62,400.24c4.35-1.1267,7.4084-9.015-5.3083-6.4392'/%3E %3Cpath d='m589.28,400.89c3.8625,1.9321,5.6333-9.3367-6.1208-6.2779'/%3E %3Cpath d='m524.4,365.79c4.8292,2.7367,12.396-0.48291,11.75-6.6'/%3E %3Cpath d='m534.22,364.51c1.6125,2.8975,0.96667,8.5317-2.0917,9.9804'/%3E %3Cpath d='m534.7,371.27c3.2208,1.2879,7.5667,0.16125,10.142-4.99'/%3E %3Cpath d='m540.34,371.27c0.9625,2.2538,1.2875,6.7613-0.80833,9.015'/%3E %3Cpath d='m541.15,375.13c3.5417,1.9317,7.725-0.64417,9.4958-4.3467'/%3E %3Cpath d='m548.39,374c2.575,1.61,4.8292,9.1758,0.48333,12.235'/%3E %3Cpath d='m551.29,382.7c3.0583,0.16083,7.5667,0.16083,10.463-3.7025'/%3E %3Cpath d='m559.66,381.09c2.7375,0.805,5.9542,5.3125,4.8292,9.3371'/%3E %3Cpath d='m564.65,388.97c3.0625-0.32209,8.3708-2.415,9.8208-6.1175'/%3E %3Cpath d='m573.02,385.27c2.5792,1.4488,4.35,4.5071,4.025,8.0488'/%3E %3Cpath d='m577.04,390.74c3.0583-0.16084,5.7958-1.7704,6.6-5.1513'/%3E %3Cpath d='m582.84,387.85c2.2542,0.805,4.9917,3.3804,5.1542,6.4392'/%3E %3Cpath d='m587.67,392.35c2.2542-0.32209,3.8625-1.7708,5.3125-4.0246'/%3E %3Cpath d='m599.1,388.01c2.9,2.8979-0.9625,12.557-6.9208,10.786'/%3E %3Cpath d='m537.28,192.9c-5.9583,3.5412-22.863,2.4146-14.492-11.59'/%3E %3Cpath d='m538.89,183.4c-11.75,4.6683-26.242-4.3462-11.108-14.166'/%3E %3Cpath d='m523.76,166.02c-9.8208,0-16.421,15.776-3.2167,21.249'/%3E %3Cpath d='m485.61,172.62c-2.575,4.99,6.6,10.463,12.879,5.4733,4.8625-3.8662,4.5042-14.327,1.6083-18.352'/%3E %3Cpath d='m480.62,184.53c-3.2208,10.624,20.446,11.268,16.742-5.6346'/%3E %3Cpath d='m479.33,200.31c0.80417,8.0488,22.7,5.4733,15.613-10.786'/%3E %3Cpath d='m497.52,185.01c1.7708,2.4146,6.6,6.6,14.808,5.795'/%3E %3Cpath d='m501.38,173.58c0.725,2.8975,5.6333,5.1512,11.913,2.9788'/%3E %3Cpath d='m281.73,418.51c-5.5533,3.9458,2.9788,10.142,6.1171,3.3'/%3E %3Cpath d='m277.38,421.57c-5.5529,3.9417,2.9788,10.138,6.1175,3.2958'/%3E %3Cpath d='m272.79,424.55c-5.5546,3.9458,2.9775,10.142,6.1171,3.3'/%3E %3Cpath d='m267.96,427.29c-5.3125,2.8167,0.88458,9.7375,6.2779,3.6208'/%3E %3Cpath d='m262.73,429.95c-5.3125,2.8125,0.88584,9.7375,6.2783,3.6208'/%3E %3Cpath d='m289.7,421.65c-0.0813,4.1042,7.7271,5.7958,10.543-0.325'/%3E %3Cpath d='m294.61,425.44c-2.4146,3.0583,2.0129,6.8417,4.4275,5.4708'/%3E %3Cpath d='m284.22,424.87c-0.24208,3.4625,6.5188,5.475,9.8196,1.6917'/%3E %3Cpath d='m287.93,428.5c-2.1738,2.8167,2.0925,6.6,4.8292,5.4708'/%3E %3Cpath d='m279.72,428.01c0.24083,2.7375,4.1042,5.875,8.29,4.1042'/%3E %3Cpath d='m282.21,431.71c-1.61,1.45-0.80459,4.8333,1.4488,5.8792'/%3E %3Cpath d='m273.84,431.47c-0.64375,2.4958,3.6225,6.925,7.9688,4.025'/%3E %3Cpath d='m274.72,434.37c-2.5754,2.0125-2.2538,5.0708,1.0458,5.4708'/%3E %3Cpath d='m268.53,434.05c-0.32167,1.6875,1.8521,4.425,4.5888,4.1042'/%3E %3Cpath d='m254.76,433.89c-2.5754,1.3667,4.0246,8.3708,8.1288,1.85'/%3E %3Cpath d='m248.4,436.78c-3.2196,1.5333,4.7492,9.2584,8.2913,1.3708'/%3E %3Cpath d='m269.25,436.46c-2.4958,0.5625-4.1054,4.1875-2.0129,5.6333'/%3E %3Cpath d='m261.12,437.75c-0.32208,1.45,2.7367,3.8625,5.2329,2.9792'/%3E %3Cpath d='m259.03,438.4c-2.4146,1.5292-1.1271,5.7917,1.6908,5.15'/%3E %3Cpath d='m250.42,441.21c-2.2538,1.6875-0.725,5.0708,2.4146,4.2667'/%3E %3Cpath d='m254.52,440.97c0.0813,0.88333,2.0929,2.2542,3.7838,1.6917'/%3E %3Cpath d='m242.61,439.52c-2.8162,1.2083-2.6554,8.2917,6.8425,4.4292'/%3E %3Cpath d='m236.25,442.34c-3.9446,1.9333-2.6567,7.2458,5.9562,2.175'/%3E %3Cpath d='m242.93,444.92c-1.0458,0.80416-2.1725,4.3458,1.7708,2.975'/%3E %3Cpath d='m235.69,446.6c-1.6096,1.45-0.5625,4.4292,2.9792,3.3'/%3E %3Cpath d='m227.4,447.09c-2.8975,1.6917,3.4604,3.9458,7.7271-0.5625'/%3E %3Cpath d='m229.33,449.18c-1.2883,1.2875-1.2883,5.0708,2.0925,3.7042'/%3E %3Cpath d='m221.12,450.71c-1.9317,1.45,1.3679,3.3833,7.405,0.725'/%3E %3Cpath d='m223.53,452.8c-2.2538,1.85-2.0129,4.1833,1.2875,3.4583'/%3E %3Cpath d='m216.85,453.85c-2.4946,2.2542,1.1267,3.7833,5.4733,1.9292'/%3E %3Cpath d='m216.93,456.35c-4.2667,1.9292-2.415,5.4708,0.24084,4.1042'/%3E %3Cpath d='m359.4,468.66c-0.98917,2.1292,2.2538,3.8625,5.3125,3.3792,2.9379-0.4625,5.7483-2.8833,3.5413-6.275'/%3E %3Cpath d='m368.41,469.95c2.8975,2.2542,8.0488-0.32083,8.0488-3.7042'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m545.97,128.83c-12.879-6.4392-39.6-18.352-47.167-8.6929,6.9208-2.8975,27.204,0.16125,43.946,15.615l3.2208-6.9221z'/%3E %3Cpath d='m553.78,128.15c-14.892-17.347-23.663-13.464-34.371-19.439-10.058-5.6142-26.079-6.7612-29.183,2.1671,14.696-7.1575,28.188,3.8488,36.475,5.1804,11.383,1.8279,17.808,10.628,21.138,14.675l5.9417-2.5833z'/%3E %3Cpath d='m609.88,125.93c-7.7292-17.708-24.254-13.083-31.554-20.605-10.621-10.946-37.504-21.088-48.613-13.522,24.467-1.2879,34.888,16.865,47.971,23.181,9.3375,4.5075,19.317,14.166,32.196,10.947z'/%3E %3Cpath d='m580.91,124c-13.2-16.42-33.488-30.908-42.821-25.435,12.233,0.64375,16.096,9.1758,24.792,14.649,8.6917,5.4733,4.8292,13.361,18.029,10.786z'/%3E %3Cpath d='m518.12,152.98c-13.846-5.1513-40.888-7.7267-53.446,8.0492,20.929,3.5413,52.479,1.6096,53.446-8.0492z'/%3E %3Cpath d='m515.55,159.1c-13.846-6.4392-24.658,2.555-37.671,1.2875-24.788-2.4146-42.496-0.96584-44.75,10.947,14.167-12.717,37.992-2.2538,47.65-4.8292,9.6584-2.5758,45.396-0.32208,56.663,4.5071-5.7958-7.0829-14.808-9.0146-21.892-11.912z'/%3E %3Cpath d='m559.01,122.23c-3.2167-10.625-3.0583-21.893,12.879-21.088-4.025-4.9904-18.833-7.5658-21.25,11.108-17.546-12.878-36.704-15.132-40.242-4.0242,9.0125-7.7271,23.017-2.0929,39.758,16.903,1.45-0.805,5.3125-2.4146,8.8542-2.8975z'/%3E %3Cpath d='m534.87,136.88c-9.9792-6.4388-23.504-16.903,0.1625-21.088-10.142-5.4733-24.954-3.0588-23.342,15.615-27.046-10.947-46.467-7.2521-50.55,3.5413-4.5083,11.913,12.238,18.513,15.133,10.947-3.0583,1.2879-13.521-2.2538-8.05-9.015,5.475-6.7608,33.525-1.6854,60.208,12.235,7.4042,3.8633,32.838,3.2196,6.4375-12.235z'/%3E %3Cpath d='m527.78,154.59c-7.7-15.722-32.679-1.4488-37.713-16.678-6.8792,22.312,35.521,9.9658,37.713,16.678z'/%3E %3Cpath d='m686.67,171.65c5.2375,2.6025,9.7667-1.4888,1.7542-4.6979,5.2417,2.6012,9.8125-1.3925,1.8-4.6029,5.2417,2.6012,9.8125-1.3921,1.8-4.6025-2.1375,2.1517-5.1958,10.04-5.3542,13.903z'/%3E %3Cpath d='m689.4,141.39c11.592-12.234-0.9625-16.42,13.2-28.976,11.592-10.273,2.2125-17.12,13.204-25.113,3.5417-2.5754,11.267-7.7267,11.913-12.878,4.6667,11.59-14.492,13.2-13.204,31.874,0.82084,11.89-7.2167,10.851-10.3,30.908-0.64583,4.1854-3.5417,13.522-14.813,4.1854z'/%3E %3Cpath d='m694.56,146.86c6.4375-13.844,13.829-13.578,17.383-18.995,6.7625-10.303,21.088,1.7708,33.163-7.405-2.0917,13.039-18.35,8.3708-25.433,16.742-7.0833,8.3708-12.879,12.235-25.113,9.6588z'/%3E %3Cpath d='m696.17,151.37c11.271-9.015,19.575-3.0008,27.367-7.7271,19.638-11.913,27.529,2.4146,45.075-3.2196-4.6708,11.268-30.588,1.61-41.854,9.9808-11.271,8.3708-50.871,16.42-30.588,0.96583z'/%3E %3Cpath d='m663.33,215.6c-0.1625-5.1513-4.9917-11.752-11.754-12.556-6.7583-0.805-9.6583-7.8883-14.808-8.21-5.15-0.32209-8.5333-10.625-15.617-10.464-7.0833,0.16125-9.9792,9.3367,6.6,17.708,16.583,8.3713,34.933,18.03,35.579,13.523z'/%3E %3Cpath d='m642.4,219.95c-7.0833,0.32209-8.05,10.625-14.808,10.947,9.3334,4.9904,16.096-2.2538,20.925-8.6929l-6.1167-2.2538z'/%3E %3Cpath d='m648.2,221.23c-6.1167,5.1513-7.8875,15.937,0.96667,18.995-5.3125-7.3246,9.3375-10.625,4.8292-17.386l-5.7958-1.6096z'/%3E %3Cpath d='m654.31,221.56c-4.8292,9.3367,7.5667,10.463,4.3458,17.547,7.0833-1.61,8.2125-14.971,1.7708-18.513l-6.1167,0.96625z'/%3E %3Cpath d='m606.98,201.59c11.592-0.64375,22.192,5.6267,29.3,15.776,4.5083,6.4388,19.638,9.0146,24.792,3.8633,5.15-5.1512,2.2542-16.098-10.625-12.556-3.2208-5.4733-12.558-3.5417-17.063-8.0492-4.5083-4.5071-21.896-17.385-26.404,0.96584z'/%3E %3Cpath stroke-linecap='round' d='m650.45,208.68c-3.0583,0.64375-4.025,5.9562-2.0958,8.6929'/%3E %3Cpath stroke-linecap='round' d='m657.05,211.9c0.96667,1.6096,0.32083,3.8633-0.1625,4.9904'/%3E %3Cpath stroke-linecap='round' d='m625.34,202.08c5.9542,0.32209,7.0833,4.6688,13.521,6.2783'/%3E %3Cpath d='m621.4,187.43c20.571,5.1512,36.892,9.6588,47.013,15.454,10.121,5.7954,25.792,7.405,39.504,3.5417,13.713-3.8633,40.154-7.405,38.85,9.6588,7.1875-8.5321-1.9583-17.708-20.242-19.318,0.32916-8.3708-8.6292-15.937-15.071-10.947,5.9583-0.80459,11.1,10.303-0.65,14.81,2.2833-8.3708-6.0417-15.937-14.692-12.234,5.55,1.6096,11.163,10.917-1.2542,14.488-7.8375,2.2538-19.263-0.64375-27.75-5.795-8.4875-5.1517-56.154-23.825-45.708-9.6588z'/%3E %3Cpath d='m673.31,179.06c-6.4375,2.8975-2.2542,9.6588-12.233,13.522-9.9833,3.8633-16.904,12.717-14.65,20.283,6.7625-14.81,18.675-14.166,22.858-19.961,4.1875-5.7954,10.304-14.327,4.025-13.844z'/%3E %3Cpath d='m675.08,180.02c-0.32083,11.751-9.5708,7.4704-5.9583,23.986,1.1292,5.1512,3.2208,13.522-0.32083,21.893,10.383-7.5658,3.7042-23.46,8.3708-29.459,2.2542-2.8975,5.15-7.405,6.2792-11.268-2.4167,6.7608-2.2542,19.318,4.3458,22.537-5.3125-12.557,14.329-22.859,0.80417-37.347-1.9292,3.5417-8.05,9.8196-13.521,9.6588z'/%3E %3Cpath d='m642.24,168.27c1.6125,2.4146,3.2208,8.5321,1.7708,11.913,3.2208-1.9317,7.8917-6.9221,9.3375-10.303,6.6,0.96584,9.175,9.1758,2.9,12.717,3.8625,0,10.463,0,14.163-4.3462-4.5042-4.9904-18.508-12.718-28.171-9.9808z'/%3E %3Cpath d='m542.11,145.18c-1.0417-0.94916-2.8-1.8517-5.9542-2.4996-9.7458-1.9988-4.7125-10.784,3.5833-10.706,17.704-19.317,27.646-4.4262,49.217-10.543,7.55-2.1404,12.733-1.5079,16.846,0.27167,9.6583-6.4392,20.988-4.64,29.2,2.9262,0.9125-1.4517,2.1375-2.5592,3.8583-3.0371,7.5625-2.1004,13.679,4.3479,15.771,12.719,5.8958-1.0921,12.629,1.8262,17.058,5.8504,6.1333-3.15,10.358-3.29,11.913-0.0512,5.475-2.5758,12.567-4.1908,16.108,4.5021,3.5417,8.6929-8.3708,6.1171-10.304,24.469-1.1917,11.321-13.842,15.776-23.825,9.015-15.967-10.817-31.55-12.557-39.279,3.8633-7.725,16.42-13.779,25.96-32.517,20.605-6.7583-1.9321-15.454,0.64375-20.925,8.0488-5.475,7.405-13.846,0.48291-23.825,1.2879,12.554-1.9317,7.7458-5.0896,18.675-5.7954,9.9792-0.64375,7.4042-9.9804,13.842-11.268-25.113,6.4392-24.146-2.8979-44.75,3.5412,9.0125-11.59,23.179-5.1513,30.263-11.912-18.675-0.32208-27.025-12.522-35.417-7.405-13.2,8.0488-7.4083,30.965-41.854,28.976-16.742-0.96583-27.367,1.2879-37.346,11.269,17.388-36.059,41.038-16.249,52.479-27.688,6.7625-6.7613,11.913-11.913,15.454-18.352,1.2458-2.2667,2.9333-3.5621,5.0417-4.0629-28.654-9.015-11.325-23.058,16.688-24.023z'/%3E %3Cpath stroke-linecap='round' d='m683.59,140.11c0.4375,0.90542,0.6625,2.08,0.6625,3.5325,0,7.0829-10.625,7.405-11.267,17.869-0.3375,5.4733-0.96666,8.5317-4.6708,7.8879-3.7-0.64417-6.9208-6.4392-3.3792-13.2'/%3E %3Cpath d='m547.42,134.63c-2.6667-1.8738-5.3333-2.635-7.725-2.6571'/%3E %3Cpath d='m605.74,121.65c8.525,3.6908,12.683,12.546,25.067,12.98,11.921,0.41833,19.321,17.708,39.279,6.4388,0.54167-0.305,1.0708-0.58959,1.5833-0.85375'/%3E %3Cpath d='m635,124.63c-1.7792,2.8292-2.1833,6.7783-1.6958,10.244'/%3E %3Cpath d='m596.04,161.03c-15.129,0-18.996,7.7267-18.996,15.132,0,7.405,7.0833,17.064,19.642,17.064,12.554,0,19.317-7.7267,19.317-16.098s-7.7292-16.098-19.963-16.098z'/%3E %3Cpath d='m598.77,192.9c-0.32084-4.1854-7.8875-3.5417-7.5667-6.7613,0.32084-3.2196,4.1875-4.5075,4.1875-9.0146,0-4.5075,6.7583-4.8296,9.0125-1.2879,2.2542,3.5412,9.0167,10.463,10.467,6.9221'/%3E %3Cpath d='m604.41,175.84c-3.5417,3.5412-5.15,10.785-0.48334,16.42'/%3E %3Cpath d='m609.24,181.31c-1.125,2.4146-1.4458,6.1171-0.15833,8.3708'/%3E %3Cpath fill='none' d='m669.36,169.48c11.833,0.96583,13.846-12.074,4.9917-12.878'/%3E %3Cpath fill='none' d='m654.8,134.31c-4.1042-5.2313-13.521-7.0021-13.683,4.1054'/%3E %3Cpath d='m639.99,151.05c-4.025-9.9808-14.329-11.43-19.804-6.4392-4.5542,4.1533-4.6667,14.971,5.1542,17.225,3.3792-4.0242,9.9792-9.3367,14.65-10.785z'/%3E %3Cpath d='m635.56,144.77c-5.7958-5.1517-14.329,4.5883-6.6,13.522'/%3E %3Cpath d='m525.31,169.16c3.8792-0.92083,9.55,0.9775,18.246,5.0675,5.475,2.5758,21.896,8.0492,32.196,2.5758-10.625,3.8633-18.671-12.235-26.721-10.303-8.05,1.9317-22.779,4.9096-28.975-0.96625,15.129,0.96625,23.267-11.021,40.563-0.64375,4.8333,2.8975,10.95,4.8296,16.421,4.5075-14.163-17.064-32.838-6.1175-34.771-19.961,8.5333,9.1758,29.379-2.0929,40.004,15.132'/%3E %3Cpath d='m545.33,152.01c-1.9917-2.4792-1.0917-4.9504-3.2292-6.9054'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m654.8,134.31c-3.5417-3.7829-11.267-0.805-9.0958,6.8421,1.6917-3.5413,5.3125-6.52,9.0958-6.8421z'/%3E %3Cpath fill='%23000' stroke='none' d='m632.91,154.93c2.4375-1.7696,4.9542-3.2233,7.075-3.8817-1.1583-2.8642-2.8292-5.0262-4.7583-6.5346-1.8417-1.2721-7.1333,5.8442-2.3167,10.416z'/%3E %3Cg fill='none' stroke-linecap='round'%3E %3Cpath d='m623.4,141.87c-5.7958-3.8633-11.108-3.5413-12.879-0.32167-4.1833-0.16125-7.6458,2.8975-7.8083,9.0146'/%3E %3Cpath d='m611.65,153.14c-6.9208-4.7483-16.421-2.9775-15.775,7.6471'/%3E %3Cpath d='m591.69,166.82c3.3792-2.7367,8.2083-4.6683,11.913,0.16125'/%3E %3Cpath d='m643.37,156.36c-1.2875,1.7704-2.2542,4.5071-0.1625,8.6929-2.575-3.3808-9.0125-3.3808-15.938,5.6338'/%3E %3Cpath d='m658.66,155.88c-8.3708,0.96583-8.2083,6.4388-1.45,8.8538'/%3E %3Cpath d='m599.1,135.43c-7.0833-1.4488-12.233,2.7367-2.4125,6.2783'/%3E %3Cpath d='m612.62,130.6c-9.9834-2.4146-14.008,0.16084-9.5,2.4146'/%3E %3Cpath d='m583.8,170.69c-0.32083,3.5417,1.6083,8.21,7.4042,2.8979'/%3E %3Cpath d='m585.74,181.31c0,0.96583-0.1625,2.0925-0.80833,2.8975'/%3E %3Cpath d='m562.55,134.14c-6.1167-1.7708-7.2417-7.405-0.15834-6.9221'/%3E %3Cpath d='m560.46,147.18c-6.7625-2.2538-6.7625-8.8538-1.1292-8.21'/%3E %3Cpath d='m573.02,143.8c-7.8875-1.9321-8.2083-7.4054-2.25-6.6004'/%3E %3Cpath d='m573.98,127.06c-4.1833-0.32166-10.625,4.3467,0.1625,7.0833'/%3E %3Cpath d='m585.74,136.4c-9.8208-1.4488-9.6583,2.5758-3.8667,5.1517'/%3E %3Cpath d='m593.14,127.06c-7.5667-1.4488-10.142,3.0588-4.9917,4.9904'/%3E %3Cpath d='m569.32,154.91c-1.8542-1.5288-3.3792-8.8542,5.4708-6.68'/%3E %3Cpath d='m587.67,152.66c-5.9542-1.61-11.588,4.1854-6.1167,7.5658'/%3E %3Cpath d='m595.55,145.74c-6.275-1.1271-11.588,0.64375-8.2083,2.8975'/%3E %3C/g%3E %3Cpath fill='%23fff' d='m654.46,134.31c-3.5375,0.65541-6.7083,2.7342-8.7625,6.8396'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800' viewBox='0 0 36 24'%3E %3Crect width='36' height='24' fill='%2375aadb'/%3E %3Crect y='9' width='36' height='6' fill='%23fff'/%3E %3Crect y='10' width='36' height='4'/%3E %3C/svg%3E"

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='450' viewBox='0 0 1098 549'%3E %3Ctitle%3EFlag of Belarus%3C/title%3E %3Crect fill='%23C8313E' width='1098' height='549'/%3E %3Crect y='366' fill='%234AA657' width='1098' height='183'/%3E %3Crect fill='%23FFF' width='122' height='549'/%3E %3Cg id='h'%3E %3Cg id='q' fill='%23C8313E' fill-rule='evenodd' transform='scale(5.304347826,9)'%3E %3Cpath d='M4,0h3v1h1v1h1v1h1v1h1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h1v-1h1v-1h1v-1h1zM5,2h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM5,4h1v1h-1zM0,1h1v1h-1zM0,7h1v1h-1zM11,0h0.6v2h-.6zM11,7h.6v2h-.6zM2,9h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM2,11h1v1h-1zM8,9h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM8,11h1v1h-1zM0,15h1v1h-1zM11,14h.6v2h-.6z'/%3E %3Cpath d='M0,18h1v-1h1v-1h1v-1h1v-1h1v-1h1v1h1v1h1v1h1v1h1v1h1v1h.6v4h-.6v1h-1v1h-1v1h-1v1h-1v1h-1v2.6h-2v-0.6h-1v-1h-1v-1h-1v-1h-1 v-3h1v1h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v-1h-1v-1h-3v1h2v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1zM0,22h1v1h-1zM11,25h.6v1h-.6zM9,27h1v1h1v1h.6v1.6h-.6v-.6h-1v-1h-1zM7,30h1v.6h-1z'/%3E %3C/g%3E %3Cuse xlink:href='%23q' transform='translate(122,0) scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='translate(0,549) scale(1,-1)'/%3E %3C/svg%3E"

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Cdefs%3E %3CradialGradient id='white_skin'%3E %3Cstop stop-color='%23ffef5d' offset='0'/%3E %3Cstop stop-color='%23ea5700' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='black_skin'%3E %3Cstop stop-color='%23952d1a' offset='0'/%3E %3Cstop stop-color='%23570a00' offset='1'/%3E %3C/radialGradient%3E %3C/defs%3E %3Crect width='750' height='500' fill='%23ce1126'/%3E %3Crect width='750' height='428.57' y='35.714' fill='%23003f87'/%3E %3Ccircle cx='375' cy='250' r='196.429' fill='%23fff'/%3E %3Cg id='leaves'%3E %3Ccircle cx='375' cy='249' r='162.812' fill='none' stroke='%23552300' stroke-width='4.103'/%3E %3Cg fill='%23007f00'%3E %3Cpath d='m356.19,76.241c14.725-15.798,28.039,2.4507,27.684,11.002-0.3554,8.551-15.207,27.416-28.646,12.234,13.922,3.5647,18.083-12.003,25.125-12.157-7.0412,0.1553-9.9194-15.259-24.163-11.078z'/%3E %3Cpath d='m202.92,200.12c-7.7422-20.102,14.644-23.856,22.208-19.751,7.5668,4.1055,18.021,25.681-1.648,30.908,9.3905-10.806-2.8239-21.409,0.15681-27.741-2.9807,6.3319-18.179,2.0599-20.717,16.585z'/%3E %3Cpath d='m533.28,180.24c20.168,7.9048,7.8468,26.827-0.31445,29.594-8.1602,2.7672-31.256-4.1438-21.861-22.074,1.6914,14.171,17.821,12.387,20.515,18.846-2.696-6.4591,10.741-14.701,1.6598-26.366z'/%3E %3Cpath d='m269.58,393.14c-21.576-2.1447-14.921-23.685-7.8322-28.556,7.091-4.8715,31.211-4.4746,27.099,15.318-5.5216-13.174-20.548-7.0918-24.915-12.576,4.3657,5.484-6.2951,17.05,5.6483,25.814z'/%3E %3Cpath d='m487.64,377.55c0.30792,21.517-22.013,17.408-27.698,10.973-5.6837-6.4355-8.0314-30.262,12.251-28.463-12.559,6.9449-4.7606,21.069-9.7539,25.998,4.9946-4.9288,17.788,4.2661,25.201-8.5071z'/%3E %3Cpath d='m218.64,159.24c-1.9676-21.431,20.606-19.029,26.768-13.044,6.1629,5.985,10.342,29.564-10.021,29.31,11.99-7.8783,3.1238-21.369,7.7226-26.663-4.5986,5.2951-18.063-2.9011-24.47,10.398z'/%3E %3Cpath d='m241.76,360.29c-21.382-3.5869-13.276-24.631-5.8711-29.018,7.4053-4.3845,31.444-2.3722,25.994,17.1-4.6126-13.517-20.019-8.4531-24.003-14.218,3.9841,5.7662-7.4394,16.593,3.8795,26.135z'/%3E %3Cpath d='m410.72,77.127c19.418-9.5784,25.333,12.174,21.94,20.043-3.3906,7.8684-24.026,20.269-31.157,1.3374,11.738,8.2404,21.201-4.8453,27.839-2.5074-6.6376-2.3379-3.812-17.762-18.622-18.873z'/%3E %3Cpath d='m452.04,404.49c-9.6263,19.283-27.594,5.5118-29.689-2.7897-2.0948-8.3027,6.78-30.564,23.996-19.769-14.369,0.4845-13.93,16.586-20.64,18.708,6.7098-2.1223,13.861,11.854,26.333,3.8502z'/%3E %3Cpath d='m546.33,218.38c16.316,14.177-1.7046,27.883-10.325,27.764-8.6232-0.11792-28.03-14.337-13.104-28.086-3.2108,13.909,12.583,17.614,12.931,24.595-0.34923-6.9808,15.097-10.257,10.498-24.273z'/%3E %3Cpath d='m272.4,105.04c4.8689-20.971,25.559-11.699,29.535-4.1028,3.9742,7.5954,0.52937,31.289-18.735,24.743,13.866-3.7717,9.6858-19.334,15.718-22.939-6.033,3.6047-16.249-8.3527-26.517,2.2992z'/%3E %3Cpath d='m208.27,284.73c-19-10.373-4.3648-27.596,4.0818-29.318,8.4457-1.7219,30.477,8.033,18.871,24.64,0.12873-14.266-16.099-14.523-17.948-21.267,1.8494,6.7447-12.528,13.235-5.0055,25.945z'/%3E %3Cpath d='m482.8,118.48c21.462-3.0857,20.24,19.412,14.544,25.837-5.6962,6.4248-29.2,11.816-30.023-8.3775,8.5614,11.464,21.665,1.9624,27.238,6.2392-5.5702-4.2766,1.9632-18.055-11.759-23.698z'/%3E %3Cpath d='m360.73,425.12c-19.798,8.7796-24.808-13.195-21.094-20.92,3.7135-7.7222,24.846-19.272,31.186-0.066-11.388-8.7111-21.384,3.9768-27.919,1.3715,6.5354,2.6044,3.0754,17.899,17.827,19.614z'/%3E %3Cpath d='m538.37,305.08c8.9398,19.606-13.18,24.682-20.979,21.034-7.7997-3.6483-19.538-24.565-0.21646-30.949-8.7227,11.342,4.1096,21.201,1.5145,27.699,2.5954-6.4987,18.024-3.1351,19.681-17.783z'/%3E %3Cpath d='m199.66,241.93c-12.438-17.629,8.355-26.675,16.7-24.519,8.3453,2.155,23.778,20.558,5.978,30.377,6.4598-12.748-7.988-20.083-6.6474-26.945-1.3413,6.8604-17.129,6.3866-16.031,21.087z'/%3E %3Cpath d='m316.63,412.08c-20.35,7.4333-23.854-14.831-19.622-22.286,4.2319-7.4571,26.1-17.562,31.12,2.0239-10.77-9.455-21.604,2.5349-27.949-0.50364,6.3434,3.0365,1.8485,18.064,16.451,20.765z'/%3E %3Cpath d='m310.76,84.939c12.058-17.887,28.08-1.9258,29.076,6.5749,0.99594,8.5009-10.703,29.437-26.369,16.525,14.312,1.3628,15.973-14.659,22.903-15.902-6.9308,1.2424-12.2-13.535-25.61-7.1978z'/%3E %3Cpath d='m519.27,347.62c1.3017,21.482-21.187,18.39-27.16,12.218-5.9754-6.171-9.4198-29.868,10.927-28.989-12.229,7.5055-3.7863,21.262-8.5468,26.412,4.7613-5.1492,17.965,3.4549,24.78-9.641z'/%3E %3Cpath d='m513.74,145.08c21.257,4.2586,12.48,25.038,4.9383,29.187-7.5416,4.1491-31.503,1.3792-25.433-17.913,4.1754,13.655,19.738,9.0811,23.535,14.969-3.7956-5.8864,7.969-16.347-3.0401-26.243z'/%3E %3Cpath d='m244.54,129.94c0.20546-21.52,22.423-16.885,27.95-10.317,5.5281,6.5692,7.3058,30.445-12.929,28.166,12.723-6.6462,5.2638-20.95,10.374-25.761-5.1098,4.811-17.679-4.6825-25.395,7.9121z'/%3E %3Cpath d='m217.66,323.91c-19.346-9.7227-5.311-27.431,3.0719-29.438,8.3832-2.0056,30.735,6.9965,19.708,23.987-0.36375-14.264-16.59-13.969-18.669-20.648,2.0802,6.6789-12.066,13.651-4.1108,26.099z'/%3E %3Cpath d='m450,94.806c20.287-7.5997,23.976,14.632,19.809,22.124-4.1688,7.4921-25.952,17.778-31.136-1.7668,10.848,9.3657,21.584-2.7129,27.952,0.27353-6.3698-2.9872-2.0005-18.051-16.625-20.631z'/%3E %3Cpath d='m406.94,422.71c-15.777,14.795-27.803-4.2965-26.862-12.805,0.94167-8.5102,17.054-26.357,29.418-10.32-13.645-4.4746-18.865,10.787-25.902,10.475,7.037,0.30977,8.8493,15.882,23.345,12.65z'/%3E %3Cpath d='m545.18,258.13c14.802,15.728-4.5106,27.572-13.077,26.598-8.567-0.97341-26.442-17.053-10.202-29.248-4.5982,13.52,10.741,18.778,10.382,25.758,0.3591-6.981,16.059-8.7056,12.897-23.108z'/%3E %3C/g%3E %3Cg fill='%23005800'%3E %3Cpath d='M355.23,99.477c13.92,3.563,17.41-11.815,24.45-11.969-4.11,4.909-14.83,17.422-24.45,11.969z'/%3E %3Cpath d='m356.19,76.241c14.725-15.798,28.039,2.4507,27.684,11.002-11.95-20.833-15.69-17.62-27.68-11.002z'/%3E %3Cpath d='m223.48,211.27c9.3905-10.806-2.9519-20.727,0.0279-27.06,2.6138,5.8324,9.1602,20.92-0.0279,27.06z'/%3E %3Cpath d='m202.92,200.12c-7.7422-20.102,14.644-23.856,22.208-19.751-24.115,1.3999-22.87,6.1503-22.208,19.751z'/%3E %3Cpath d='m511.11,187.76c1.6914,14.171,17.4,11.833,20.094,18.291-6.0994-2.0263-21.734-7.4196-20.094-18.291z'/%3E %3Cpath d='m533.28,180.24c20.168,7.9048,7.8468,26.827-0.31445,29.594,15.24-18.601,10.869-20.896,0.31445-29.594z'/%3E %3Cpath d='m288.85,379.91c-5.5212-13.175-19.992-6.6743-24.358-12.158,6.424,0.29832,22.948,1.2555,24.358,12.158z'/%3E %3Cpath d='m269.58,393.14c-21.576-2.1447-14.921-23.685-7.8322-28.556-9.5509,22.019-4.7128,23.044,7.8322,28.556z'/%3E %3Cpath d='m472.19,360.06c-12.559,6.9449-4.4041,20.473-9.3974,25.402-0.43343-6.3686-1.3565-22.769,9.3974-25.402z'/%3E %3Cpath d='m487.64,377.55c0.30792,21.517-22.013,17.408-27.698,10.973,23.133,6.9103,23.61,2.0234,27.698-10.973z'/%3E %3Cpath d='m235.39,175.5c11.99-7.8777,2.8118-20.747,7.412-26.041,0.92366,6.3177,3.1083,22.6-7.412,26.041z'/%3E %3Cpath d='m218.64,159.24c-1.9676-21.431,20.606-19.029,26.768-13.044-23.597-5.1329-23.694-0.2253-26.768,13.044z'/%3E %3Cpath d='m261.88,348.37c-4.6118-13.515-19.492-7.9979-23.476-13.762,6.3881,0.72693,22.81,2.7896,23.476,13.762z'/%3E %3Cpath d='m241.76,360.29c-21.382-3.5869-13.276-24.631-5.8711-29.018-11.026,21.332-6.2714,22.678,5.8711,29.018z'/%3E %3Cpath d='m401.51,98.508c11.738,8.2404,20.506-4.906,27.143-2.5684-5.5987,3.14-20.103,11.055-27.143,2.5684z'/%3E %3Cpath d='m410.72,77.127c19.418-9.5784,25.333,12.174,21.94,20.043-3.7188-23.688-8.364-22.003-21.94-20.043z'/%3E %3Cpath d='m446.35,381.93c-14.369,0.4845-13.339,16.217-20.048,18.338,2.544-5.8613,9.2688-20.871,20.048-18.338z'/%3E %3Cpath d='m452.04,404.49c-9.6263,19.283-27.594,5.5118-29.689-2.7897,17.401,16.631,20.072,12.501,29.689,2.7897z'/%3E %3Cpath d='m522.9,218.06c-3.2108,13.909,12.375,16.952,12.723,23.933-5.0562-3.9438-17.952-14.243-12.723-23.933z'/%3E %3Cpath d='m546.33,218.38c16.316,14.177-1.7046,27.883-10.325,27.764,20.656-12.427,17.317-16.049,10.325-27.764z'/%3E %3Cpath d='m283.2,125.68c13.866-3.7717,9.1965-18.839,15.23-22.445-1.1105,6.2874-4.1537,22.434-15.23,22.445z'/%3E %3Cpath d='m272.4,105.04c4.8689-20.971,25.559-11.699,29.535-4.1028-20.806-12.184-22.441-7.5529-29.535,4.1028z'/%3E %3Cpath d='m231.22,280.05c0.12854-14.267-15.753-13.92-17.6-20.664,5.7918,2.7734,20.614,10.085,17.6,20.664z'/%3E %3Cpath d='m208.27,284.73c-19-10.373-4.3648-27.596,4.0818-29.318-17.488,16.54-13.445,19.366-4.0818,29.318z'/%3E %3Cpath d='m467.32,135.94c8.5614,11.464,21.025,1.689,26.596,5.9648-6.3073,1.2503-22.577,4.2785-26.596-5.9648z'/%3E %3Cpath d='m482.8,118.48c21.462-3.0857,20.24,19.412,14.544,25.837,3.9152-23.657-1.0279-23.493-14.544-25.837z'/%3E %3Cpath d='m370.82,404.14c-11.388-8.7111-20.692,4.0668-27.226,1.4586,5.7249-2.9075,20.544-10.226,27.226-1.4586z'/%3E %3Cpath d='m360.73,425.12c-19.798,8.7796-24.808-13.195-21.094-20.92,2.7366,23.82,7.4485,22.324,21.094,20.92z'/%3E %3Cpath d='m517.17,295.17c-8.7224,11.344,4.1973,20.516,1.6022,27.014-2.959-5.6678-10.404-20.339-1.6022-27.014z'/%3E %3Cpath d='m538.37,305.08c8.9398,19.606-13.18,24.682-20.979,21.034,23.99-2.8304,22.459-7.4984,20.979-21.034z'/%3E %3Cpath d='m222.34,247.79c6.4598-12.748-7.9446-19.392-6.6042-26.253,3.9612,5.0267,14.011,18.08,6.6042,26.253z'/%3E %3Cpath d='m199.66,241.93c-12.438-17.629,8.355-26.675,16.7-24.519-23.048,7.1806-20.675,11.487-16.7,24.519z'/%3E %3Cpath d='m328.12,391.82c-10.77-9.455-20.921,2.6694-27.263-0.36673,5.9091-2.5197,21.192-8.8282,27.263,0.36673z'/%3E %3Cpath d='m316.63,412.08c-20.35,7.4333-23.854-14.831-19.622-22.286,1.1087,23.948,5.9109,22.773,19.622,22.286z'/%3E %3Cpath d='m313.47,108.04c14.312,1.3629,15.338-14.369,22.268-15.613-3.2857,5.4866-11.91,19.508-22.268,15.613z'/%3E %3Cpath d='m310.76,84.939c12.058-17.887,28.08-1.9258,29.076,6.5749-15.089-18.723-18.276-14.97-29.076-6.5749z'/%3E %3Cpath d='m503.03,330.85c-12.229,7.5055-3.4571,20.65-8.2188,25.801-0.72619-6.3423-2.4047-22.684,8.2188-25.801z'/%3E %3Cpath d='m519.27,347.62c1.3017,21.482-21.187,18.39-27.16,12.218,23.427,5.8525,23.677,0.95221,27.16-12.218z'/%3E %3Cpath d='m493.24,156.35c4.1763,13.654,19.227,8.6096,23.023,14.497-6.3616-0.92834-22.709-3.5075-23.023-14.497z'/%3E %3Cpath d='m513.74,145.08c21.257,4.2586,12.48,25.038,4.9383,29.187,11.708-20.971,6.9971-22.467-4.9383-29.187z'/%3E %3Cpath d='m259.57,147.78c12.723-6.6462,4.8939-20.363,10.002-25.173,0.28139,6.3765,0.81212,22.795-10.002,25.173z'/%3E %3Cpath d='m244.54,129.94c0.20546-21.52,22.423-16.885,27.95-10.317-22.959-7.4535-23.552-2.5797-27.95,10.317z'/%3E %3Cpath d='m240.44,318.46c-0.36376-14.264-16.222-13.379-18.303-20.056,5.8837,2.5758,20.949,9.3825,18.303,20.056z'/%3E %3Cpath d='m217.66,323.91c-19.346-9.7227-5.311-27.431,3.0719-29.438-16.91,17.121-12.771,19.808-3.0719,29.438z'/%3E %3Cpath d='m438.67,115.16c10.848,9.3657,20.896-2.8423,27.266,0.14355-5.8878,2.5682-21.119,9.002-27.266-0.14355z'/%3E %3Cpath d='m450,94.806c20.287-7.5997,23.976,14.632,19.809,22.124-1.3118-23.94-6.1016-22.724-19.809-22.124z'/%3E %3Cpath d='m409.5,399.59c-13.645-4.4746-18.182,10.643-25.216,10.331,4.4355-4.6275,15.994-16.407,25.216-10.331z'/%3E %3Cpath d='m406.94,422.71c-15.777,14.795-27.803-4.2965-26.862-12.805,10.497,21.576,14.446,18.617,26.862,12.805z'/%3E %3Cpath d='m521.9,255.48c-4.5972,13.52,10.602,18.098,10.242,25.078-4.6329-4.4262-16.424-15.956-10.242-25.078z'/%3E %3Cpath d='m545.18,258.13c14.802,15.728-4.5106,27.572-13.077,26.598,21.809-10.312,18.852-14.247,13.077-26.598z'/%3E %3C/g%3E %3C/g%3E %3Cg id='coa'%3E %3Cg id='tree' stroke-width='0.5087'%3E %3Cg fill='%23730000' stroke='%23000'%3E %3Cpath d='m405.26,125.34s0.61-1.426,1.73-0.61c1.018,0.812,1.321,4.375,1.321,4.375l-1.628,0.812c0.001,0.001,0.917-1.319-1.423-4.577z'/%3E %3Cpath d='m396.01,157.29s0.813-1.118-0.305-3.563l1.628-0.508s0.609,1.932-0.204,4.072l-1.119-0.001'/%3E %3Cpath d='m424.19,151.69-3.865,2.342,1.934,0.916,4.679-2.748-2.748-0.51'/%3E %3Cpath d='m372.4,166.85c-1.019,0.815-1.12,2.24-1.73,3.052-0.506,0.814-2.034,1.932-2.135,3.154-0.203,1.22-0.304,2.034,0.204,3.664,0.607,1.626,3.152,8.851,2.135,14.347-1.12,5.493-0.71,7.833-0.303,8.649,0.404,0.814,1.627,3.051,2.339,3.051,1.628-0.203,0.916-0.711,1.525-1.729,1.526-2.646,0-23.098-0.712-28.796-0.507-4.375-2.545-8.345-2.745-8.75-0.203-0.511-0.609-1.832-0.916-2.647-1.525-3.664-3.357-6.815-3.357-14.451,0,0-4.986,1.122-9.257-8.547-2.238-4.883-5.495-4.375-9.359-6.001l1.729-1.122s3.256,1.629,4.884,1.629,1.12-3.256,1.12-3.256l1.628-1.63v7.126c0,3.256,4.476,7.732,7.121,9.055,1.628,0.812,3.765-2.545,3.257-5.799-0.509-3.256,0-7.631,0-7.631l2.238,1.321s-0.814,1.424-0.61,2.238c0.303,0.816,1.422-0.813,2.236-1.629,0,0,0.203,0.205,1.018,0.205,0,0-1.628,2.745-2.44,4.172-0.812,1.324-0.812,6.514-0.812,8.447,0,1.934,0.712,6.409,0.712,7.833,0,1.021,1.931,5.19,3.46,7.736,0.507,1.016,1.728,3.661,1.728,3.661,1.221,1.933,1.321,3.256,2.035,4.886,0.406,0.812,1.12,3.153,1.628,7.225,0.204,1.016,0.406,4.883,0.714,7.425,0.304,2.442,2.34,0.511,4.779-1.219,2.442-1.832,2.442-6.207,2.442-6.207s1.934-1.628,1.628-0.712c-0.204,1.018,1.019,2.035,1.019,2.035-1.525,3.458-0.609,3.052,0.916,2.95,1.525-0.206,6.814-4.172,6.814-4.172,0.713-0.205,3.867-0.205,3.358,0-0.61,0.306-1.425,1.832-1.425,1.832l3.46-0.408c-1.221,0.916-5.801,3.561-6.815,4.172-1.12,0.714-6.611,3.361-8.952,4.274-2.34,1.016-6.919,3.256-7.122,5.596-0.103,2.342,0.304,8.649,0,10.683-0.204,2.035-1.019,11.093-1.019,11.093h-10.886s2.137-7.937-0.103-10.073c-2.136-2.238-7.122-8.752-10.377-10.992-3.257-2.135,2.135-0.505,2.135-0.505v-2.24l4.984,6.006s8.647-7.632,0-18.011c-2.746-3.256-5.494-8.241-7.629-8.752-2.238-0.61-3.358-1.119-7.123,0-3.866,1.118-13.124,1.118-16.99-4.988l3.257-0.508,2.744-1.119s-1.118,3.867,6.613,3.867c7.631,0,8.749,0,8.139-7.123l2.238-1.119,1.629,1.63s-1.12,3.866-0.509,5.493c0.509,1.627,3.257,2.748,5.393,4.375,0.916,0.713,1.628,0.815,2.238,0.815,0.915-0.102,1.118-0.102,2.339-1.324,1.832-2.035,1.424-1.933,3.256-3.559,0,0,0.916-1.426,1.12-1.63l1.12,2.952h-0.006z'/%3E %3Cpath d='m374.03,161.46c0.405-0.404,1.221-1.934,1.933-3.256,1.221-2.035,2.646-3.256,4.272-5.801,1.525-2.34,2.137-5.798,1.525-8.239l1.424,0.814,0.104,3.866s1.934-1.63,2.748-2.035l0.812,0.405s-6.104,6.31-11.802,16.485l-1.018-2.237,0.002-0.002z'/%3E %3Cpath d='m320.52,140.3c0.814,1.421,1.629,4.172,4.07,6.307l1.628-0.508s-3.764-4.375-3.764-6.307l-1.934,0.508'/%3E %3Cpath d='m330.08,137.85s0.508,5.19-0.812,7.123l1.627-0.811s1.119-3.561,0.813-5.496l-1.628-0.812v-0.004z'/%3E %3Cpath d='m383.7,121.47s-0.307,7.325,1.119,11.803l1.932-0.608s-0.304-1.327,1.322-1.937c1.629-0.508,5.494-2.135,7.426-3.765l-0.608-1.626s-2.95,2.34-4.375,2.949c-1.322,0.51-2.136,1.119-3.256,0.816-1.12-0.306-2.44-2.138-1.628-6.311l-1.932-1.321'/%3E %3Cpath d='m405.26,155.66s-0.507,5.189-0.202,7.429l1.729,0.408s-0.404-6.207,0.712-6.716l-2.239-1.121'/%3E %3Cpath d='m413,159.53s-1.933,3.358-4.17,3.664l3.561-0.714s1.019-0.508,2.544-2.135l-1.935-0.815'/%3E %3C/g%3E %3Cg fill='%23289400' stroke='%23030'%3E %3Cpath d='m381.87,144.16,1.321,0.811,1.424,0.206s1.525,1.424,3.256,2.745c1.321,1.122,1.321-0.202,1.321-0.202l0.812,3.256h1.12s-0.306,2.136-0.306,3.256l1.934-1.629,2.238,1.934s1.628-1.424,2.441-1.424c0.812,0,1.118-0.812,1.118-0.812h0.104c-5.393-2.546-7.731-5.19-6.104-7.938,2.646-4.578,7.02-1.629,8.443-1.016l19.737,10.581s1.322-0.814,0.406-1.63c-1.019-0.811-1.425-2.848-1.12-3.661,0.306-0.814,2.544,2.542,3.662,2.847,1.12,0.306,3.661,0.714,3.661,0.714l-0.102-1.018s3.256,2.237,3.256,3.358c0,0,2.341-1.221,1.525-1.934-0.813-0.71,3.562,1.731,3.866,3.055l0.915-1.021c-0.103,0,0.306-3.256,1.424-4.782,1.019-1.524,2.137-1.933,2.137-1.933s1.019-1.731,2.034-1.731c0,0-1.019-0.71-1.425-1.524-0.508-0.816-1.729-1.222-1.729-1.222s1.525-1.118,1.934-1.628c0.406-0.608,0.814-0.714,0.814-0.714s-2.342-1.932-3.97-2.235c0,0-0.102-2.648-2.136-2.85h0.916s-1.526-2.849-2.951-2.95c0,0,0.916-1.017,1.73-1.119,0,0-1.73-2.238-4.068-1.424l1.525-0.608s-1.119-1.22-4.576-0.61c0,0,0.303-1.424-1.221-2.545,0,0-1.322,0.1-1.322,1.118,0,0-1.221-1.118-2.746-1.118-1.526,0,0.508,1.629,0.508,1.629s-2.034-1.324-3.256-0.916c0,0,0.508-2.34-0.814-3.563,0,0-1.523,0.815-1.933,1.832l-0.406-1.017s-2.036,2.442-2.441,1.73c-0.305-0.406-0.609-2.135-0.609-2.135l-1.219,1.832,0.202-2.546s-1.424,0.815-2.543,3.458c0,0-1.425,1.324-1.425,2.542,0,0-1.119-1.32-2.137,0-0.916,1.424,0,1.122,0,1.122s-0.407,0.505-1.424,0.71l0.204,0.812s-1.321-0.71-2.339-0.404l0.507,1.219s-2.645,0.205-2.745-1.93c0,0-2.238-1.121-2.544,0.101l-1.628,1.018s-0.509-1.018-1.425-1.22c-1.019-0.306-0.204,1.32-0.204,1.32s-0.304-1.219-1.525-1.832c-1.219-0.505-0.203,1.122-0.203,1.122s-1.628-1.324-0.812-2.34c0,0-1.526,1.424-0.814,2.748l-1.018,0.711s-0.509-0.508-0.408-0.916c0.104-0.408-1.729,1.219-1.729,1.219s-1.119-2.643,0-2.643c0.102,0-1.933-0.102-2.237,2.24,0,0-1.322,0.101-2.544,0.505-1.322,0.408,0.916,1.324,0.916,1.324s-1.934-0.408-3.053,0.204l0.713,0.916s-0.713-0.713-2.442-0.104c-1.832,0.508,0.406,0.814,0.406,0.814s-1.832-0.406-2.747,0c-0.916,0.408,0.305,1.119,0.305,1.119s-3.357-1.017-3.866-0.71c-0.507,0.304,1.12,1.934,1.12,1.934s-2.035,0.508-2.44,2.035l1.831,0.71s-0.812,0.406-1.222,1.222c-0.403,0.814,1.222,0.405,1.222,0.405s-2.237,1.63-2.237,2.849c0,0,1.627,0.508,2.848-0.711s0.406-0.814,0.406-0.814l0.102,0.814s2.341-1.016,2.341-1.626c0-0.508-0.406,0.812-0.406,0.812l2.341-1.22,1.524,1.018v-0.002h0.001z'/%3E %3Cpath d='m379.93,112.42-0.509-2.238l5.188,0.608,0.915-2.135s2.441,1.118,3.256,1.929c0,0,4.781-1.219,6.207-0.71l-0.61,2.24s4.373,0.303,5.799,0.812c1.322,0.508-0.609,1.63-0.609,1.63s4.984,0.608,7.122,1.932c2.238,1.321,2.238,2.442,1.12,2.745l2.744,4.375s-4.373,0.508-5.187,1.626c-0.814,1.119-1.628-1.118-1.628-1.118l-0.814,3.052s-2.746-1.426-3.865-2.442c0,0-1.321,1.629-0.508,2.442l-4.986-3.256s-2.137-0.304-2.137,1.63c0,0-2.439-2.748-3.051-3.563l-2.748,0.815s-0.812-1.118-1.83-1.426c-1.12-0.201-0.306,1.426-0.306,1.426l-1.628-1.934-1.627-1.929s-1.425,1.929-2.544,1.929c-1.02,0-1.02-1.321-0.814-2.237,0.305-0.814-3.256-1.016-3.561,0,0,0-1.019-4.07,2.746-5.188,3.866-1.018,3.866-1.018,3.866-1.018l-0.001,0.003z'/%3E %3Cpath d='m360.2,126.36-1.729,1.629-1.019-0.508-2.034,2.237-0.407-1.223-1.119,1.832-1.729-0.609-0.814,1.322-1.525-0.306s-1.322,1.222-2.137,1.526c-0.813,0.206,0-1.829,0-1.829s-1.221,2.034-2.137,2.034c-0.812,0-0.507-0.916-0.507-0.916s-0.508,1.319-1.525,1.525c-0.916,0.102-0.51-1.017-0.51-1.017l-1.629,1.219v-1.017l-0.712-0.304s0.406-1.832,1.12-2.238c0.712-0.408-0.712-1.626-0.712-1.626l0.712-0.815s-2.036-0.508-2.036-0.101c0,0,1.019-2.745,2.441-3.258l0.103-3.051s1.425-1.219,2.747-1.324c1.423-0.203-0.406-2.34-0.406-2.34l3.255-1.929,0.406-2.34,4.984,0.403,1.018-2.135,3.969,1.016,3.356-1.73,2.441,2.849,3.662,0.307s-0.102,2.542-0.102,3.256c0,0,4.373,1.321,4.883,1.73,0,0-0.814,2.645-0.814,3.153,0,0,3.054-0.814,3.97-0.61,0,0,0.306,2.85,0.405,3.561,0,0,5.188,1.63,5.494,2.546,0,0-1.12,0.71-1.729,1.626,0,0,0.608,3.156,0.608,4.172l-0.406,0.61s-1.526-1.424-2.747-1.627l-1.019,2.237-1.83-1.22-1.119,0.102s-0.916-1.119-1.629-1.119l-0.103-1.018-1.424,0.916s-2.237-1.12-2.237-1.832c0-0.609,0.102-1.63,0.102-1.63l-2.34,1.63s-0.508-1.219-0.405-1.73c0.103-0.508-0.915,1.222-0.915,1.222s-1.222-2.138-1.12-2.546l-0.306,1.732s-2.441-0.812-2.745-2.442v-0.002z'/%3E %3Cpath d='m327.64,136.33s4.274,2.14,4.274,3.156c0,0,1.12-2.24,0.508-3.054l1.629,1.122s0.506-2.034-0.103-2.647c-0.509-0.508,3.66-2.235,4.576,0.51,0,0,2.545-2.645-2.339-4.885,0,0-0.405-1.626,2.544-1.219,0,0-0.203-1.018-0.916-1.424h2.849s-1.729-1.426-4.273-1.832c-2.44-0.408-0.916-0.711-1.018-1.224-0.204-0.508,0-2.34,0-2.34s-1.424-0.508-2.544,0.102l0.406-0.51s-2.646-0.71-3.661-0.101c0,0-1.526-0.61-1.322-2.24,0,0-1.526-0.1-2.236,1.526,0,0-1.425,1.629-3.357,1.629-0.406,0-1.832-0.815-1.832-0.815l-1.222,2.85-1.932-0.102,0.609,1.118s-2.95-0.811-3.866,0c0,0,1.12,1.732,0.813,2.951,0,0-2.341,0.408-2.849,0.815-0.61,0.403,0.813,0.71,0.813,0.71s-2.645,0.814-3.257,1.63l1.02,0.811-1.222,1.631,1.019,0.201s-1.729,0.51-2.644,0.815c-0.916,0.303,1.627,0.508,1.627,0.508l-1.219,1.118,1.933,0.303s-1.525,4.072-1.628,6.006c0,0,2.341-2.85,2.949-3.052l-1.83,3.052s3.46-1.118,3.766-1.631c0.304-0.608,0.609-1.117,0.609-1.117l0.103,1.73s1.322-1.832,1.525-2.545c0.103-0.71,2.136,0.713,2.136,0.713v-1.02s1.832,0.609,2.441,0.714c0.712,0.101,0.813-0.306,0.813-0.306l1.729-0.203-0.306,1.421s1.22-0.812,1.525-1.627c0.204-0.815,0.813,0,0.813,0l0.812-3.256h1.729l0.006,0.008z'/%3E %3Cpath d='m313.7,150.78,1.628,3.358c-1.322,0.1-3.256,1.626-3.256,1.626,0.304,5.597-1.118,5.291-1.118,5.291,0.403,1.018-0.259,2.905-0.259,2.905l8.092-4.837,0.102-0.508,9.564-4.48,0.303,0.508,2.748-1.524,1.933,5.085-1.933,1.119c0.103,1.73,2.137,4.784,2.137,4.784l2.544-0.608,2.747-1.021s0.103,1.526,0.103,1.021c0-0.411,2.949-1.424,2.949-1.424l1.322,1.322c1.02-0.101,2.848-2.546,2.848-2.546l2.137,0.816s0.712-1.22,0.712-2.136c0-0.814,2.645-0.814,2.645-0.814l1.832,1.321,2.34-1.931s0.712,1.424,1.628,1.626c1.019,0.102,3.561,2.034,3.561,1.63,0-0.406,1.12-2.646,1.12-2.646l4.271,1.73c-0.608-1.933-2.032-4.273-2.032-4.273s2.032-1.626,1.627-2.034-1.627,0-1.627,0l1.219-2.442h-1.627l0.507-0.608-2.645-1.118,1.423-2.85c-0.61-0.714-7.629-2.138-7.629-2.138l1.628-1.526s-0.814-1.219-1.628-1.219-5.087,0.102-5.291-0.303c-0.103-0.408-1.832-1.937-1.832-1.937l-2.646,1.937-1.322-0.408-2.34,0.916s0,1.321-0.307,0.405c-0.303-0.816-2.44-2.951-2.44-2.951-0.406,0.71-3.153,3.967-3.153,3.967s-0.406,1.732-1.322,0.508c-1.019-1.219-3.154-2.542-3.46-1.524-0.305,1.121-2.236,2.135-2.646,1.832-0.405-0.308-2.645-0.102-2.849,0.508-0.102,0.71-2.544,2.542-2.544,2.542-1.526-0.71-3.969-0.302-3.969-0.302s-0.712,1.118-0.812,2.034l-4.984,1.319h0.004v-0.002z'/%3E %3Cpath d='m359.69,191.99v-2.138l2.44,1.629,1.425-1.629,1.832,1.83,1.119-1.83v2.952l2.747-2.44,1.626,0.71v-2.34s1.935-3.258,1.12-3.866l1.628-0.508s-2.748-2.748-3.562-3.258c-0.812-0.608-1.932-0.608-1.932-0.608s-2.137-2.14-3.561-2.748c-1.322-0.508-2.138,0.608-2.138,0.608s-0.813-1.626-2.237-1.933c-1.32-0.303-1.32,1.119-1.32,1.119s-1.02-1.018-2.341-1.526c-1.322-0.608-0.407,1.22-0.407,1.22l-4.681-1.422,0.609,1.422-4.373-1.115,0.506,1.627-3.051-0.512-0.203,1.326-4.375,0.812,0.814,1.424-2.747-1.119v1.934l-3.052,1.118,1.119,1.02s-4.068,1.933-4.884,2.543c-0.812,0.508,1.629,1.626,1.629,1.626l-4.375-0.61,1.629,1.426-3.866,3.562,2.746,1.934-1.628,2.44,4.069,0.812,1.628,2.748,3.357-0.61v3.051l4.884-3.865s3.562,3.154,3.866,2.238c0.203-0.814,0.203-3.562,0.203-3.562h1.729v-2.745l1.322,1.118,2.238-3.258,2.949,4.072,2.237-5.188,3.256,0.508,0.006,0.001z'/%3E %3Cpath d='m379.63,179.68-0.508-4.68-1.423,1.424,0.607-4.375-2.235-0.408,0.812-4.272-1.627-0.816,0.404-2.034,1.629-1.219,2.95-2.85,6.814,0.105,0.813-2.24l4.885,0.815c0.812,0.916,3.355-1.832,3.355-1.832h1.019l1.12,2.134s3.561-0.508,5.188,0.61l-1.934,2.646,3.561,0.304,2.44,0.512,2.544-0.816,3.257-0.206,0.813,1.324h3.053l-1.019,1.219,3.968,1.832-0.812,0.815s2.237,0.814,3.865,0.814h0.813s0.813,1.931-0.307,2.745c0,0,1.12,2.748,3.562,3.258,2.441,0.508,2.441,0.508,2.746,1.117,0.307,0.51,0,3.258-2.746,3.258v2.748s-2.137,1.933-2.441,2.745l-1.629-1.119s-1.422,1.63-1.422,2.748c0,0-3.562-4.682-4.885-4.887-1.424-0.303-1.12,2.647-1.12,2.647l-3.864-3.256-0.509,2.237-3.256-2.745-1.934,1.319-3.46-3.559-3.357,0.408,1.321-1.731h-4.069l-0.812-3.559-0.61,2.949-2.44-1.626-3.154,3.458s-0.406-0.409-0.916-2.036c-0.507-1.628-1.933,1.932-1.933,1.932l-1.12-2.542-1.322,2.542s-1.12-1.932-2.238-2.542c-1.018-0.508-2.135,3.051-2.439,4.681l0.002,0.004z'/%3E %3Cpath d='m380.24,190.36,0.203-1.626,5.798-2.24,4.885-1.832,2.439-1.118,1.12,1.932,1.424-2.745,2.238,2.847,1.221-1.526,1.932,1.424h1.628l0.305,2.14s4.07,0.303,4.374-0.508c0.305-0.815,0.812,2.745,0.812,2.745l3.865,0.508,0.814,4.375s1.931,4.072,1.322,5.699c-0.51,1.73-2.138-2.136-2.138-2.136s-0.304,3.052-0.609,3.866c-0.203,0.812-5.188-0.814-5.188-0.814l-2.136,4.07s-2.237-3.256-3.255-3.256c-1.12,0-1.12,3.256-1.12,3.256s-3.256-3.867-4.681-5.496c-1.322-1.626-1.628,1.629-1.628,1.629s-2.136-3.562-2.136-4.578c0-1.119-1.934-2.24-1.934-2.24s-3.358,3.867-5.801,4.886c0,0,0.306-2.442-0.507-3.256-0.813-0.815-3.257,1.626-3.257,1.626s-1.729-3.764,0-7.631l0.01-0.001z'/%3E %3C/g%3E %3Cg fill='none' stroke='%23004b00'%3E %3Cpath d='m407.1,129.71,0.509,2.035s1.83-0.408,3.053-0.305c0,0-0.305,1.627-0.712,2.34,0,0,2.441-0.406,3.561,0.304l-0.509,1.219,2.849,1.222-2.645,2.136s4.271,1.524,5.087,2.748c0,0-2.746,1.932-3.154,1.832-0.406-0.206-0.102,0.811,0.61,1.727l-2.341-0.101s0.916,2.138,0.813,2.95c-0.102,0.814-3.866,0.609-3.866,0.609'/%3E %3Cpath d='m425,142.94s0.712-4.07-0.404-5.088c0,0,2.644,2.24,4.373,2.34,1.832,0.105-0.103-3.357-0.103-3.357s2.544,1.322,3.765,1.627c1.221,0.205-0.916-2.543-0.916-2.543s0.712-1.324,2.746-0.102'/%3E %3Cpath d='m387.16,119.64s0.1-0.916-0.308-1.424c-2.44-3.358,2.545,2.545,3.561,2.748'/%3E %3Cpath d='m395.09,120.96s1.628,1.219,2.442,1.219c0.813,0-0.508-3.256-0.916-3.661-0.406-0.408,2.95,1.321,4.172,1.526,1.221,0.303,1.423-2.035,1.423-2.035s3.765,0.609,4.579,1.119'/%3E %3Cpath d='m380.64,118.42s-0.305-2.136-0.405-3.052'/%3E %3Cpath d='m355.01,128.6c-0.204-0.408,1.02-2.24,0.509-3.054,0,0,0.712,0.612,1.424,0.714,0.61,0.101,0.404-2.342,0.404-2.342l0.814,0.304s2.137-1.018,1.729-1.832c-0.408-0.812,1.424,1.219,1.424,1.219s1.222-1.219,1.222-1.727c0-0.513,1.422,1.219,1.422,1.219s1.525-0.306,1.525-1.219c0-0.916,1.934,0.303,1.934,0.303s0.812-1.118,0.712-1.832' stroke-width='0.5087'/%3E %3Cpath d='m347.58,130.53s0.914-2.135-0.103-3.559'/%3E %3Cpath d='m322.86,137.24c0.103-1.016,0.609-3.764,0.103-4.172-0.508-0.403,1.019,0.408,2.238,0.713'/%3E %3Cpath d='m334.86,133.38c-1.221-1.223-1.934-1.832-3.864-1.832'/%3E %3Cpath d='m314.21,140.19c0.306-0.71,0.813-2.441,0.508-3.458'/%3E %3Cpath d='m340.76,190.66,1.322-2.748,1.628,3.866,1.118-2.442,0.406,0.815,2.441-2.645,2.646,3.968'/%3E %3Cpath d='m392.75,174.28,1.729-3.458,2.342,1.222,1.12-3.358,2.439,1.526,1.424-3.153,2.747,0.711,0.202-2.238s1.933,1.118,2.442,1.932c0.608,0.816,0-2.745,0-2.745l2.237,1.016s1.628-1.629-0.609-2.545'/%3E %3Cpath d='m399.57,169.91,2.441,3.562,2.033-2.34,1.832,3.967,2.34-1.424,3.356,1.933,1.525-1.219,3.662,2.645,1.526-3.153,3.256,1.017,2.135-3.661'/%3E %3Cpath d='m335.78,161.67s1.425-2.4453,0.91601-3.5637c-0.61133-1.1188,2.9492,1.934,2.9492,1.934s0.81249-2.443,0.30469-3.5605c-0.61055-1.1188,4.0703,3.2558,4.0703,3.2558s0.81446-3.764,0-4.5801c-0.81445-0.81406,4.4766,1.1215,4.4766,1.1215s2.1367-0.60897,1.3222-1.7305c-0.81445-1.1184,3.5586,1.6269,3.5586,1.6269s1.0184-2.7445,0-3.7656c-1.1184-1.1172,3.2566,1.3238,3.2566,1.3238l-1.6277-2.9508,3.5605,0.20273-0.30469-3.2562'/%3E %3Cpath d='m389.8,194.73,2.3398-1.1187,2.0351,2.0348,2.2383-3.5605,2.7461,2.6445,0.40625-2.6445,2.9492,1.223,0.61133-1.6312,3.2551,1.7324,0.3039-2.443,1.6277,0.50977,0.30664-1.6293'/%3E %3C/g%3E %3C/g%3E %3Cg id='shield'%3E %3Cpath fill='%239dd7ff' d='m336.59,310.53c-2.646-4.477-4.681-9.055-6.207-13.531l44.052-38.77,44.055,38.666c-1.526,4.475-3.562,9.26-6.409,13.84l-0.352,0.563c-0.812-0.303-3.312-1.276-3.312-1.276s-1.425,1.324-2.541,1.424c-1.526,0.205-2.849-1.32-2.849-1.32s-1.934,1.627-3.866,1.32c-1.934-0.201-2.748-1.424-2.748-1.424s-2.034,1.629-3.459,1.324c-1.322-0.309-2.238-1.225-2.238-1.225s-1.22,1.529-2.95,1.225c-1.627-0.309-3.153-1.225-3.153-1.225s-2.541,1.117-4.171,1.322c-1.626,0.308-3.052-1.424-3.052-1.424s-2.136,1.424-2.949,1.424c-0.814,0-3.866-1.424-3.866-1.424s-3.154,1.018-4.272,1.018c-1.019,0-4.171-1.321-4.171-1.321s-2.95,0.812-4.271,0.812c-1.426,0-3.459-0.812-3.459-0.812s-2.438,1.119-3.764,0.812c-1.424-0.303-2.544-0.812-2.544-0.812s-2.645,1.119-4.375,0.812c-1.628-0.303-3.561-1.42-3.561-1.42s-0.305,0.812-3.458,1.42h-0.104'/%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='0.7123' d='m374.44,213.66v44.566l-44.053,38.974c-4.272-12.414-4.577-23.504-4.577-28.285v-55.254h48.63'/%3E %3Cpath fill='%23ffd83c' stroke='%23000' stroke-width='0.7123' d='m374.44,213.66v44.566l43.951,38.974c4.271-12.414,4.577-23.504,4.577-28.285v-55.254h-48.528'/%3E %3Cg id='boat' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='%23730000' d='m346.02,301.27c3.312,1.795,2.19,1.229,9.055,3.66,5.597,1.937,12.106,2.849,21.567,2.849,8.278,0,12.938-0.656,15.56-1.38,2.719-0.78,3.363-1.877,3.363-1.877l-6.814,6.92s-27.394,1.479-32.354-1.729c-1.931-1.019-6.104-4.375-10.376-8.444v0.001z'/%3E %3Cg fill='none'%3E %3Cpath d='m386.21,288.35s8.75,4.984,0,14.549'/%3E %3Cpath d='m346.84,301.78,12.615-12.01-1.424,16.078'/%3E %3Cpath d='m364.64,307.27v-26.86'/%3E %3Cpath d='m386.21,307.27v-28.489'/%3E %3Cpath d='m375.32,307.78v-30.625'/%3E %3C/g%3E %3Cg fill='%23ff0018'%3E %3Cpath d='m364.64,281.84-5.698,1.832,5.698,0.61v-2.442'/%3E %3Cpath d='m375.32,277.66-6.001,2.24,6.001,0.203v-2.443'/%3E %3Cpath d='m386.21,279.29-6.002,2.24,6.002,0.303v-2.546,0.003z'/%3E %3Cpath d='m389.77,292.22c-0.305-1.222,3.562-1.118,3.562-1.118s1.12,4.068,0,6.611l-3.255-0.609s0.305-2.746-0.307-4.884z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m348.77,300.15,0,0,10.683-10.379-0.509,6.207s-5.493,3.559-5.493,6.104l-4.681-1.932'/%3E %3Cpath d='m354.46,302.29s1.12-3.256,4.171-4.883l-0.305,6.512-3.864-1.629h-0.002z'/%3E %3Cpath d='m369.83,284.28s4.373-0.61,7.63,0c0,0-0.509,4.375,0,5.188,0,0-6.003-1.425-8.443,0.812-0.001,0-0.815-4.069,0.813-6z'/%3E %3Cpath d='m360.57,285.4s4.375-0.61,7.629,0c0,0-0.812,4.886-0.305,5.699,0,0-4.885-2.748-7.324-0.512,0,0-1.629-3.355,0-5.187z'/%3E %3Cpath d='m360.26,291.09s4.374-0.508,7.631,0c0,0-0.509,4.375,0,5.191,0,0-5.698-1.324-8.141,0.812,0.001,0.001-1.119-4.069,0.51-6.003z'/%3E %3Cpath d='m369.01,290.28s6.308-0.811,9.562-0.303c0,0-1.322,3.561,0.307,6.002,0,0-6.817-1.832-9.361,0.303-0.001,0-2.135-4.069-0.508-6.002z'/%3E %3Cpath d='m359.76,297.1l8.442,0.609s-0.812,6.207-0.305,7.021c0,0-6.815-1.629-8.141,0.608,0,0-2.238-5.696,0-8.241h0.003v0.003z'/%3E %3Cpath d='m369.32,297.1s7.322-0.51,10.682,0c0,0-1.936,4.683,0.204,8.75,0,0-9.565-2.744-10.889-0.51,0,0-2.235-5.697,0-8.24h0.003z'/%3E %3Cpath d='m380.51,284.28s4.373-0.61,7.63,0c0,0-0.507,4.375,0,5.188,0,0-6.002-1.425-8.442,0.812-0.002,0-0.816-4.069,0.812-6z'/%3E %3Cpath d='m380.51,290.28s4.373-0.508,7.63,0c0,0-0.507,4.375,0,5.189,0,0-6.002-1.322-8.442,0.815-0.002,0.001-0.816-4.071,0.812-6.004z'/%3E %3Cpath d='m381.02,296.59s4.373-0.607,7.73,0c0,0-1.119,6.817-0.609,7.631,0,0-4.982-2.34-7.324-0.303,0,0-1.423-5.392,0.203-7.328z'/%3E %3Cpath d='m390.07,297.1s1.422,5.187,3.254,5.799l-2.44,2.951s-2.95-2.137-3.256-4.576c0,0,1.932-2.241,2.442-4.174z'/%3E %3C/g%3E %3C/g%3E %3Cg id='waves' stroke='%23000' stroke-width='0.6104'%3E %3Cpath fill='%23006ac8' stroke='none' d='m411.88,311.14c-7.019,11.703-18.516,22.689-37.438,29.506-19.229-6.916-30.928-18.414-37.847-30.016l0.103-0.102c3.153-0.613,3.459-1.424,3.459-1.424s1.933,1.119,3.561,1.424c1.729,0.303,4.374-0.814,4.374-0.814s1.119,0.51,2.543,0.814c1.322,0.303,3.765-0.814,3.765-0.814s2.034,0.814,3.458,0.814c1.322,0,4.273-0.814,4.273-0.814s3.153,1.32,4.17,1.32c1.12,0,4.272-1.018,4.272-1.018s3.053,1.426,3.866,1.426c0.812,0,2.95-1.426,2.95-1.426s1.423,1.729,3.051,1.426c1.628-0.203,4.171-1.321,4.171-1.321s1.525,0.916,3.154,1.22c1.729,0.307,2.95-1.22,2.95-1.22s0.916,0.916,2.238,1.22c1.424,0.307,3.458-1.322,3.458-1.322s0.813,1.222,2.748,1.424c1.933,0.306,3.866-1.32,3.866-1.32s1.32,1.525,2.848,1.32c1.12-0.102,2.542-1.424,2.542-1.424s2.544,0.812,3.459,1.121'/%3E %3Cpath fill='none' stroke-width='0.5087' d='m410.15,313.79c-1.525,0.104-1.729-0.916-1.729-0.916s-2.032,1.731-3.967,1.425c-2.034-0.303-2.95-1.627-2.95-1.627s-2.137,1.73-3.562,1.424c-1.423-0.203-2.439-1.222-2.439-1.222s-1.322,1.528-3.053,1.222c-1.729-0.203-3.257-1.222-3.257-1.222s-2.746,1.122-4.477,1.425c-1.729,0.307-3.153-1.627-3.153-1.627s-3.968,1.324-4.781,1.324c-0.916,0-3.766-1.324-3.766-1.324s-1.932,1.223-3.051,1.223c-1.22,0-4.476-1.426-4.476-1.426s-3.054,0.816-4.478,0.816c-1.425,0-3.561-0.816-3.561-0.816s-2.645,1.119-4.069,0.816c-1.424-0.307-2.544-0.816-2.544-0.816s-2.849,1.119-4.578,0.816c-1.729-0.307-3.765-1.424-3.765-1.424s-0.304,0.709-3.661,1.424h-0.103'/%3E %3Cpath fill='%235ac800' d='m346.97,317.94s-0.28444,0.66512-2.9375,1.25c-0.0568-0.004-0.71875,0.15625-0.71875,0.15625,0.24453-0.0444,0.44305-0.0788,0.65625-0.125-0.0936,0.0356-0.303,0.11225-0.75,0.25,3,4.334,7.4939,8.268,12.177,11.423,4.6833,3.1547,10.065,6.9209,19.229,9.6085,9.6351-3.7615,12.206-5.1929,18.503-9.4102,6.297-4.5987,9.5783-7.4642,13.09-12.184-2.75,1.562-2.3552,1.58-3.7812,1.375-1.424-0.303-2.4688-1.3438-2.4688-1.3438s-1.3002,1.5488-3.0312,1.3438c-1.729-0.303-3.25-1.3438-3.25-1.3438s-2.26,1.5375-4.5,1.4375c-1.73-0.104-3.1562-1.625-3.1562-1.625s-3.9692,1.3125-4.7812,1.3125c-0.916,0-3.75-1.3125-3.75-1.3125s-1.9445,1.2188-3.0625,1.2188c-1.22,0-4.4688-1.4375-4.4688-1.4375s-3.0448,0.8125-4.4688,0.8125c-1.425,0-3.5625-0.8125-3.5625-0.8125s-2.5375,1.1175-4.0625,0.8125c-1.425-0.303-2.5625-0.8125-2.5625-0.8125s-2.8345,1.1175-4.5625,0.8125c-1.73-0.303-3.7812-1.4062-3.7812-1.4062z'/%3E %3Cpath fill='%23ffd800' d='m374.63,340.51c9.953-4.143,11.751-5.27,17.771-8.951-1.05,0.029-4.104-0.957-2.999-1.272,0,0-1.224,1.103-2.444,1.103-1.12,0-4.375-1.42-4.375-1.42s-3.051,0.811-4.476,0.811-3.561-0.811-3.561-0.811-2.646,1.116-4.07,0.811c-1.425-0.303-2.544-0.811-2.544-0.811s-2.949,1.116-4.577,0.811c-1.729-0.303-3.765-1.424-3.765-1.424s-2.504,1.328-4.076,1.481c4.809,3.522,9.872,6.961,19.116,9.672z'/%3E %3C/g%3E %3Cg id='weapons' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='%23b34b00' stroke-width='0.509' d='m367.88,259.34c1.977-1.61,3.112-3.159,2.452-4.362-0.743-1.033-1.905,0.646-3.214,0.252,0,0-1.976-1.222-2.515-2.098-1.153-1.281-2.636-2.434-3.49-3.535-0.905-1.021-4.31-5.522-9.492-10.704-1.49-0.972-1.149-4.65-2.217-5.792-0.091-0.796-10.358-10.96-14.022-14.637-1.481-1.09-2.262-1.797-4.865,0.563-2.055,1.854-2.794,3.767-0.098,6.077l13.356,12.144c1.951,1.896,4.676,2.241,5.819,3.223l13.576,13.883c1.709,1.477,2.529,2.524,1.563,3.787-1.073,2.077,0.075,2.357,0.319,2.42,0.156,0.086,1.115,0.084,1.755-0.41l1.073-0.811z'/%3E %3Cpath fill='none' stroke-width='0.5' d='m334.02,222.92,13.958,13.792'/%3E %3Cpath fill='%23fff' stroke-width='0.5713' d='m352.92,229.22c0.216-0.415,0.688-1.473,1.187-2.627,0.196-0.456,3.951-6.444,5.823-6.62,0,0,11.677,8.495,11.686,8.607,0.039,0.458-5.065,8.093-5.509,7.513-0.002-0.001-13.68-5.743-13.187-6.873z'/%3E %3Cpath fill='%23ccb8c8' stroke='none' d='m360.36,231.22c-1.599-1.242-4.242-2.453-6.375-3.875l-0.958,2c0.771,0.863,10.487,5.381,12.083,6.25,0,0-1.851-2.122-4.75-4.375z'/%3E %3Cpath fill='none' stroke-width='0.4' d='m353.98,227.09c1.25,0.875,3.625,2.375,5.125,3.25,2.875,2,4.695,4.203,6.75,5.375'/%3E %3Cpath fill='%23782121' d='m330.32,263.48,26.587-32.904c0.498-0.456,2.963-0.481,3.297,2.068l-25.179,34.315c0.001,0-2.868-0.284-4.705-3.479z'/%3E %3Cpath fill='%23730000' d='m419.44,263.84c-0.916,0.715-2.473,0.9-2.473,0.9-1.729-2.035-3.156-4.172-5.597-6.816l-26.555-32.663,2.747-2.645,23.907,27.981c0.712,0.711,4.886,5.088,8.854,10.274,0.002,0.002,0.348,2.032-0.883,2.969z'/%3E %3Cpath fill='%23fff' d='m393.87,229.43-4.274-5.088s-3.255,0.406-3.864,2.138c0,0-2.341,3.867-8.547,4.274,0,0,1.729,7.223,8.953,11.089,0,0,2.646-7.429,5.188-8.752-0.001,0.001,2.644-1.934,2.544-3.661z'/%3E %3Cpath fill='%23730000' d='m383.19,252.02c-0.609-0.205-1.221,0-2.137,0.509-0.812,0.51-1.83,0.304-1.729-0.714,0.102-0.916,0-0.812,1.119-1.524,1.629-0.916,3.765-1.019,5.087-0.51l-2.34,2.239'/%3E %3Cpath fill='%23730000' d='m412.18,223.12c-0.204-0.71-0.405-1.421,0.305-2.337,0.713-0.814,0.713-2.24-1.019-1.528-1.729,0.714-2.339,2.646-0.914,5.597l1.626-1.732h0.002z'/%3E %3Cpath fill='%23fff' d='m382.58,252.63,30.114-29.915,7.425,7.937s-1.524-0.612-2.136-0.206c-0.508,0.408,0.61,1.934,0.61,1.934s-1.424-0.508-2.034-0.102c-0.712,0.405,0,2.136,0,2.136s-1.221-0.916-1.832-0.51c-0.508,0.408,0,2.339,0,2.339s-1.628-0.507-2.033-0.102c-0.408,0.408,0,2.138,0,2.138s-1.629-0.814-2.442,0c-0.812,0.812,0.406,1.934,0.406,1.934s-2.034-0.815-2.848,0.405c-0.813,1.222,0.102,2.34,0.102,2.34s-1.627-0.812-2.033-0.408c-0.407,0.408,0,2.34,0,2.34s-1.424-0.814-2.34,0.206c-0.916,1.119,0.102,2.035,0.102,2.035s-1.321-0.816-2.036-0.411c-0.712,0.411,0.204,2.34,0.204,2.34s-1.321-0.916-2.237,0c-0.916,1.021,0,2.035,0,2.035s-1.12-1.018-2.238,0c-1.019,1.121,0,2.239,0,2.239s-1.626-0.813-2.236,0c-0.712,0.812,0.202,1.935,0.202,1.935s-1.219-0.713-2.033-0.309c-0.812,0.408,0,2.24,0,2.24s-1.22-1.324-1.729-0.609c-0.61,0.711,0.102,2.441,0.102,2.441s-1.12-1.324-1.729-0.609c-0.713,0.609,0.405,2.137,0.405,2.137s-2.034-0.916-1.525-0.916z'/%3E%3C!--c0.102,0-6.207-7.022-6.207-7.022--%3E %3Cg fill='%237e4b7e' stroke='none'%3E %3Cpath d='m410.96,225.16-2.34,2.34,0.508,8.039s0.509-2.34,1.221-0.714c0,0,0.204-1.932,0.712-1.626-0.409-0.206-0.102-8.039-0.101-8.039'/%3E %3Cpath d='m406.59,229.53-1.729,1.626,0.609,8.039s0.51-3.051,1.22-0.609c0,0-0.102-2.034-0.102-2.748,0.002,0.509,0.002-6.308,0.002-6.308'/%3E %3Cpath d='m388.38,247.55-1.628,1.727,0.408,4.886s0.508-3.153,1.22-0.714c0,0-0.204-2.031-0.204-2.746,0,0.509,0.204-3.155,0.204-3.155'/%3E %3C/g%3E %3Cg fill='none' stroke='%237e4b7e' stroke-width='0.9156'%3E %3Cpath d='m386.34,227.4c1.12,1.119,4.274,5.187,4.274,5.187'/%3E %3Cpath d='m387.77,229.64c-0.202,0.612-0.607,2.34-1.523,3.256'/%3E %3Cpath d='m388.27,230.04c-0.102,0.406-0.102,1.73-1.523,3.054'/%3E %3Cpath d='m388.78,230.66c-0.204,0.71-0.305,1.22-0.812,1.731'/%3E %3Cpath d='m389.09,231.27c0,0.508-0.303,0.61-0.405,0.916'/%3E %3Cpath d='m385.33,229.33c-0.406,0.405-3.358,2.338-4.985,2.95'/%3E %3Cpath d='m384.51,230.45c-0.406,0.408-2.238,1.832-3.256,2.24'/%3E %3Cpath d='m384.21,231.67c-0.609,0.41-1.628,1.424-2.441,1.73'/%3E %3Cpath d='m383.6,232.89c-0.406,0.508-1.018,0.916-1.525,1.222'/%3E %3Cpath d='m365.94,234.01c0.332-0.613,0.911-1.816,1.667-2.917,0.959-1.397,1.372-1.633,1.875-2.125' stroke-linecap='square'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='supporters'%3E %3Cpath fill='%23289400' stroke='%23060' stroke-width='0.5087' d='m267.72,316.03c1.526,0.711,0-4.987,0.507-7.123,0.61-2.238,4.984,5.494,7.123,6.514,2.238,1.118,15.87-5.395,15.87-5.395l3.256-6.104,1.73,4.985s3.763-4.375,4.883-6.002c1.119-1.627,0,3.257-1.12,4.884-1.12,1.629,3.256,2.239,2.746,5.495-0.508,3.257,4.375-2.239,4.375-2.239l12.615,1.119s2.135-7.632,5.493-12.007l1.018,4.887,5.188-5.29c5.799,15.263,18.009,31.849,43.035,40.903,23.501-8.547,35.608-23.709,41.913-38.159l7.021,7.228s5.494-1.631,6.511-2.238c1.118-0.51,12.92,4.172,12.92,4.172s2.136,0.814,3.256,1.63c1.118,0.812,0.304-3.563,0.304-3.563s6.003,1.118,5.493,4.375c0,0,1.322-3.051,2.442-3.56s3.763,2.748,4.375,3.866c0.508,1.02,13.43,2.646,15.26,3.765,0,0,1.425,1.63,1.425,2.748,0,0,2.748-0.306,4.885-0.306,0,0-1.628,0.811-1.628,2.543,0,1.629-0.814,2.953-2.442,3.764-1.628,0.816,0,1.424,2.137,1.63,2.238,0.304,0,3.052-4.375,4.683,0,0-1.018,2.439,0.814,3.252,0,0-3.766,0.308-4.375-0.812,0,0-1.32,2.543-1.32,3.867,0,0-4.069-1.324-5.188-1.933,0,0-1.629,1.625-0.51,2.439,0,0-7.425-0.811-8.851-3.559,0,0-2.646,0.813-2.137,1.729,0,0-5.188-3.56-6.815-3.56l-1.119,1.828s-3.561-2.135-4.681-2.135c-1.02,0-0.204,1.627-0.204,1.627l-4.983-3.053-1.933,3.053s-4.07-1.935-5.188-2.746c-1.019-0.813-1.32,1.627-2.136,1.931,0,0-1.628-2.235-3.866-1.931,0,0-0.813,2.746-0.508,3.561,0,0-6.308-1.322-7.426-1.63-1.12-0.304-0.508,1.323,0,2.444,0,0-4.681-1.323-5.698-2.139l-0.305,2.139s-3.864-0.307-4.679-1.121l-2.442,3.356h-3.561l-0.812,2.95s-6.815-1.93-7.427-0.811c-0.508,1.117,0.306,2.744,0.306,2.744l-6.002-0.812-0.507,2.441s-6.919-2.138-8.547-1.121c0,0-2.137,2.24-3.562,2.748-1.319,0.61,0-0.814,0-0.814l-2.135-2.949s-2.441,1.322-3.866,0.814c-1.321-0.613-5.697,2.135-7.123,1.32,0,0,0-1.935-1.117-2.442-1.019-0.509-2.95-0.509-3.766,0.815,0,0-0.812-1.121-2.237-3.257-1.322-2.239-3.257,0.203-3.257,0.203l-0.305-2.646-3.765-0.307c-2.238-0.305-2.746-2.24-2.746-2.24s-5.799,0.611-6.613,0.308l1.423-1.324s-7.935,1.632-9.562,1.021c-1.73-0.508,1.832-2.748,1.832-2.748s-7.327-1.828-8.751-2.135c-1.321-0.305-9.258,1.318-10.378,1.318-1.119,0-1.628-1.832-1.628-1.832s-1.935,1.631-3.562,2.141c0,0-1.322-3.256-0.507-3.563,0,0-5.188,1.424-5.494,2.748,0,0-1.322-2.136-1.12-3.052,0,0-2.441,3.867-3.561,4.679-1.12,0.815-0.204-1.933-0.204-1.933s-3.05,3.865-4.17,4.172v-2.748s-8.751,4.681-11.191,4.072c0,0,0-1.936,0.813-2.442l-5.494-0.306c-1.32-0.203-2.949-0.812-4.373-1.119-1.322-0.205,1.933-1.627,4.171-1.018,0,0-6.104-2.238-7.937-1.121,0,0-0.814-2.236,2.44-3.052,0,0-4.172-4.069-6.614-3.765,0,0,2.748-1.627,4.986-0.815,0,0-2.544-6.917-4.172-7.731,0,0,5.8-1.018,7.427-0.201l0.002-0.002z'/%3E %3Cg id='axe'%3E %3Cpath fill='%23730000' stroke='%23000' stroke-width='0.5087' d='m259.27,196.67,74.064-38.361c0.355-1.982-0.771-3.54-1.932-5.088-21.18,10.387-40.456,22.992-63.992,30.628-1.322,0.51-13.022,5.393-19.025,12.619-1.903,1.908-2.043,4.724-2.043,4.724s0.146,3.231,0.825,4.104c0,0,0.176,0.887,1.282,1.596-0.012,0,0.684,0.341,1.166,0.169,0.538,0.101,1.413,0.094,2.635-2.045,1.222-2.037,5.189-6.716,7.02-8.346z'/%3E %3Cpath d='m318.89,158.72,9.562-4.58s3.257,2.442,2.951,5.19c0,0,0.712,6.307,8.547,10.682,0,0-6.615,8.241-18.211,8.955,0,0,1.33-10.876-1.11-14.032,0,0-0.406,0.389-0.23-0.15,0.347-1.058-0.235-4.688-1.72-5.487-0.181-0.099,0.118-0.396,0.211-0.578z' stroke='%23000' stroke-width='0.50870001' fill='%23FFF'/%3E %3Cg fill='none' stroke='%237e4b7e' stroke-width='0.8139'%3E %3Cpath d='m330.08,160.04c-2.034,0.814-8.647,4.272-8.647,4.272'/%3E %3Cpath d='m326.93,162.07c-0.103,1.017-0.713,3.459,0,5.189'/%3E %3Cpath d='m326.01,162.38c0,0.508-0.813,2.34,0.103,4.783'/%3E %3Cpath d='m325,162.89c-0.204,1.021-0.406,1.63,0,2.751'/%3E %3Cpath d='m324.18,163.5c-0.203,0.609,0,0.916,0,1.321'/%3E %3Cpath d='m330.18,163.19c0.304,0.812,3.052,5.086,4.68,6.816'/%3E %3Cpath d='m330.59,165.12c0.307,0.814,1.832,3.765,2.951,4.886'/%3E %3Cpath d='m330.39,166.85c0.406,1.018,1.221,2.85,2.034,3.866'/%3E %3Cpath d='m330.39,168.89c0.204,0.815,0.61,1.832,1.221,2.546'/%3E %3C/g%3E %3C/g%3E %3Cg id='paddle' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='%23b34b00' d='m398.22,154.46,27.207,13.322c5.451,2.65,7.411,0.202,10.487,1.539l53.694,27.351c4.606,2.012,7.185,2.656,6.523,5.039-0.112,3.786,1.79,3.843,2.31,3.883,0.376,0.101,2.191-0.165,2.949-1.172,0.568-0.656,0.589-0.724,0.589-0.724,0.608-0.608,0.498-0.663,0.687-0.934,2.258-3.249,3.509-6.065,1.146-7.905-2.702-1.266-3.013,1.607-5.858,1.304,0,0-5.087-1.933-6.919-3.256-3.374-1.837-8.084-4.015-9.155-5.211-3.428-0.642-29.233-15.157-43.852-22.442-1.568-1.313-2.422-6.166-5.503-7.79-0.904-1.312-20.694-10.347-31.043-15.52-3.814-1.425-5.949-2.401-8.697,2.28-2.398,4.59-1.815,7.094,5.435,10.236z'/%3E %3Cpath fill='none' d='m400.52,148.76,30.458,15.208'/%3E %3C/g%3E %3Cg id='white_man' fill='%23ffa54b' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='url(%23white_skin)' d='m309.73,165.12c-0.203,0.61-0.712,0.203-0.712,0.408-0.405,2.135-0.305,3.253-0.813,4.475-0.712,1.424-3.256,2.748-3.154,2.645-2.034,0.609-4.475,3.054-8.442,0.814-0.204-0.101-0.406-0.306-0.61-0.508,0,0,1.117,4.169-2.95,6.204-1.424,0.713-15.77,8.244-15.77,8.244s-1.526,2.748-0.509,6.512c0.103,0.61,0.305,1.118-0.305,1.526-0.916,0.71-2.646,2.748-3.662,6.004,0,0-3.053-1.324-3.053-3.256,0-1.934,1.221-2.951,1.526-4.378,0.304-1.321,1.117-4.679,0.712-5.698-0.406-1.119-2.238-1.526-2.95-1.933-0.61-0.408-1.425,0.406-1.322,1.322,0.103,1.018,0.813,0.812,1.628,1.018,0,0-0.916,1.932-0.813,3.356l-9.258,4.783s1.22,1.626,1.627,2.34c0.405,0.712,1.321,10.175,4.069,14.653,2.747,4.477,3.663,3.256,4.273,3.866,0.508,0.508,1.321,1.321,2.034,1.934,0.712,0.508,3.865,0.811,4.477-0.916,0.712-1.631,1.22-2.647,3.154-4.174,1.933-1.524,5.899-5.391,5.899-7.123,0,0,2.34,6.716,2.034,12.313,0,0,8.546,1.731,16.177,1.932,7.632,0.105,11.497-1.524,11.497-1.524s1.018-6.409,0.608-7.631c0,0,1.221,4.172,2.137,5.596,1.019,1.727,2.136,5.288,4.374,5.493,2.137,0.101,3.969-2.135,4.171-3.051v-6.716h8.647c0-0.101,3.866,1.424,5.086,1.22,1.221-0.102,1.933-1.22,0.813-1.628l-0.405-0.303c1.117,0,2.543,0.71,2.543,0.71h4.271c0.103-0.101,0-0.408-0.103-0.508-0.305-1.222-2.544-2.24-4.17-2.95-1.629-0.609-3.459-1.324-4.681-1.424-1.932-0.206-3.256-0.101-6.206,0.408-0.813,0.101-3.865,0.405-5.799,1.321-0.509,0.306-1.019,0.406-0.813-0.916,0.306-1.426,0.204-7.835-1.32-10.583-1.12-1.932-1.018-3.562-0.814-5.188,0.104-1.63,0.204-7.225,0-8.854-0.306-1.627-2.544-3.867-6.611-4.375-3.866-0.511-7.123-3.664-7.325-6.207-0.305-2.542,0.408-7.223,0.814-9.257'/%3E %3Cg fill='none'%3E %3Cpath fill='url(%23white_skin)' d='m292.44,153.63c-0.712,3.253-0.712,6.104-0.609,9.257,0.102,2.135,1.118,4.577,2.034,6.715,0.609,1.426,1.425,3.052,2.746,3.867,3.562,2.34,6.919-0.203,8.852-1.017,0.916-0.308,2.341-1.626,2.747-2.442,0.508-1.219,0.303-2.135,0.812-4.475-0.103,0.1,0.813-0.408,0.712-0.408,0.916-1.526,0.712-2.034,1.221-3.054,0.509-1.018-0.609-2.136-1.832-1.931,0.609-1.933,1.019-4.072,0.405-5.904-0.202-0.608,0.51-2.235-0.608-1.832-4.579,1.832-9.97,1.426-14.854,1.426-0.406,0-0.712-0.815-1.321-0.71-0.103,0-0.204,0.303-0.307,0.505'/%3E %3Cpath fill='%23000' d='m292.03,155.35c-0.508-0.406-0.61-1.319,0-3.256,0.712-1.929,0-2.034,1.119-3.153,1.12-1.12,0.814-1.629,1.526-1.932,0.712-0.206,2.849-0.206,3.562-0.508,0.609-0.308,1.525-0.714,2.947-0.916,1.526-0.308,4.579-0.206,6.003,0.608,1.526,0.812,2.544,2.85,3.46,3.561,1.02,0.71,1.63,3.661,1.426,7.938-0.307,4.272-1.12,3.458-1.12,3.458s-1.222-2.034-2.238-0.308c0,0,0-1.626,0.204-2.848,0.102-1.219-0.61-3.458,0.102-4.985,0,0-5.8,1.832-8.751,1.729-3.051-0.202-7.322-0.916-7.526-1.626l-0.714,2.238'/%3E %3Cpath fill='%23fff' stroke='%23fff' d='m294.98,151.8c-0.305-0.61-1.832-2.85-0.609-3.561,1.12-0.612,0.406,2.745,1.935,3.458,0,0-0.509,1.526-1.321,0.102l-0.005,0.001z'/%3E %3Cpath d='m298.34,160.14c-0.508,1.732-0.712,2.138-0.916,3.156'/%3E %3Cpath d='m308.01,164.92c0.204,0.61,0.404,0.303,0.914,0.405'/%3E %3Cpath d='m309.33,161.36c0.509-0.609,1.221-0.303,0.813,1.223'/%3E %3Cpath d='m292.44,157.7c0.916,0.303,1.832,0.608,2.748,1.02,1.526,0.61,0.61,2.845,0.204,4.271-0.204,0.714-1.019,1.933-0.609,2.546,0.508,0.811,1.119,0.303,2.035,0.403,0-0.303,0.609-0.508,0.813-0.508,0.712-0.1,1.12,0.508,1.627,0.308,0.61-0.308,0.51-1.224,0.306-1.731'/%3E %3Cpath d='m299.46,159.53c0.102-0.403,1.018-0.811,1.526-0.915,2.136-0.405,3.661-0.712,5.393,0.511'/%3E %3Cpath d='m300.68,170.21c-1.729,0.408-3.561,0.71-5.188-0.206'/%3E %3Cpath d='m295.49,169.2c0.813-0.408,1.12-0.816,2.137-0.308,0-0.101,1.12-0.405,1.12-0.405,0.812,0,1.322,0.304,2.136,0.812'/%3E %3Cpath d='m295.39,169.6c0.916-0.306,3.358-0.306,5.394,0.102'/%3E %3Cpath fill='%23fff' stroke-width='0.3052' d='m292.34,160.14c0.713-0.1,1.526-0.916,3.154,0.306,1.12,0.712-1.832,1.426-1.322,1.324-1.32,0.202-1.729-0.508-1.828-1.122,0-0.202-0.204-0.508,0-0.508h-0.004z'/%3E %3Cpath fill='%23fff' stroke-width='0.3052' d='m300.68,160.95c0.712-1.426,1.832-1.119,2.849-0.816,1.019,0.306,0.713,0.105,1.629,0.613-1.12,0.203-0.814,0.303-1.629,0.71-0.916,0.408-1.729,0.61-2.341,0.206-0.204-0.206-0.712-0.508-0.712-0.916-0.001,0.101,0.102,0.203,0.204,0.203z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m293.76,161.36c0.406,0,0.712-0.406,0.712-0.814,0-0.508-0.306-0.916-0.712-0.916-0.507,0-0.812,0.408-0.812,0.916,0,0.408,0.303,0.814,0.812,0.814z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m302.41,161.56c0.405,0,0.712-0.403,0.712-0.916,0-0.508-0.407-0.811-0.813-0.811-0.405,0-0.712,0.303-0.712,0.811-0.001,0.514,0.407,0.916,0.813,0.916z'/%3E %3C/g%3E %3Cg id='body' stroke='%23000' stroke-width='0.5087'%3E %3Cg fill='none'%3E %3Cpath d='m345.85,213.66c-0.608-0.714-1.018-1.02-1.83-1.324-0.609-0.303-1.424-0.71-2.036-1.016-0.712-0.408-1.729-0.508-2.34-0.916'/%3E %3Cpath d='m340.05,213.05c-0.306-0.203-0.508-0.304-0.812-0.51-0.306-0.101-0.712-0.101-1.02-0.203-0.102,0-0.102-0.204-0.203-0.204-0.915-0.102-1.831-0.51-2.44-1.321'/%3E %3Cpath d='m272.8,201.45c0.914,0.71,3.152,2.24,3.356,5.19,0.204,1.525,1.019,3.051,1.019,3.051'/%3E %3Cpath d='m264.05,201.86c0.51,1.727,0.61,7.425,6.003,13.43'/%3E %3Cpath d='m265.07,193.92c-0.408,1.119-0.916,2.137,0.202,2.951'/%3E %3Cpath d='m279.72,207.56c1.12-2.545,4.578-2.342,4.578-4.782'/%3E %3Cpath d='m284.81,207.25c-0.306-2.849-0.916-4.475-0.405-8.647,0.203-1.223,0.405-5.9,0-8.141,0,0,1.629,7.833-3.662,9.363'/%3E %3Cpath d='m315.13,212.34c0-3.97,0.916-6.209,0.916-6.209,1.221-5.593-1.119-7.731-0.203-9.155,0.812-1.221,2.035-3.766,0.407-8.854,0,0,2.847,10.484-4.478,10.484-7.425,0-7.121-2.748-7.121-2.748'/%3E %3Cpath d='m284.4,190.46c0,2.135,0,8.447,9.055,8.447,2.746,0,5.698-1.933,7.324-3.256'/%3E %3Cpath d='m303.02,192.9c-0.306-1.934-0.306-4.375-0.306-6.92'/%3E %3Cpath d='m289.08,182.53c2.441-0.308,4.376-0.61,8.955-0.61'/%3E %3Cpath d='m298.34,175.6c0.509,2.24-0.304,5.8,3.866,6.309'/%3E %3Cpath d='m306.58,174.79c-0.61,1.629-0.61,3.256-0.814,4.375'/%3E %3Cpath d='m305.97,181.92c1.73,0,4.985-1.121,9.054-0.306'/%3E %3Cpath d='m316.45,204.4c0.813,1.63,1.018,3.765,3.561,6.207'/%3E %3Cpath d='m288.27,199.21c0.204,1.324-1.729,5.698-0.306,9.262,1.322,3.559,1.12,7.631-1.12,11.089'/%3E %3Cpath d='m293.46,200.54c-0.813,1.626-2.238,3.256-2.544,4.68'/%3E %3Cpath d='m297.52,203.59c0,1.018-2.744,8.749-4.68,10.886,0,0,3.561,1.424,3.051,6.614'/%3E %3Cpath d='m303.22,200.03c0,1.324-0.204,1.63,0.916,2.44'/%3E %3Cpath d='m306.58,202.47c1.32,1.628,5.492,6.514,4.576,9.259'/%3E %3Cpath d='m303.83,205.22c0.306,1.018,0.306,6.309-0.61,8.955'/%3E %3Cpath d='m301.09,213.97c-1.12,0-2.746,0.814-3.052,2.747'/%3E %3Cpath d='m306.78,213.66c1.118-0.306,3.355,1.626,3.355,7.123'/%3E %3Cpath d='m325.81,210.51c-2.136,0.61-3.052,1.732-2.44,1.119-1.12,0.916-2.138,1.526-2.138,1.526'/%3E %3C/g%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m289.79,197.99c0.608,0,1.118-0.408,1.118-0.916,0-0.411-0.507-0.816-1.118-0.816-0.509,0-1.02,0.405-1.02,0.816,0,0.505,0.508,0.916,1.02,0.916z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m312.89,198.3c0.51,0,1.02-0.405,1.02-0.916,0-0.505-0.508-0.811-1.02-0.811-0.607,0-1.118,0.306-1.118,0.811-0.001,0.511,0.51,0.916,1.118,0.916z'/%3E %3Cpath fill='%23fff' d='m280.54,239.81c1.22-7.937,4.985-14.551,5.086-15.162,0,0,3.865,0.816,10.58,1.424,6.612,0.71,8.444,0.408,11.496,0.202,2.949-0.303,6.815-0.811,6.815-0.811s1.221,2.44,1.322,4.883c0.305,5.188,2.236,27.677,2.439,33.679,0,0,0.814,3.562,0.814,12.312,0,9.567,2.645,28.999,2.645,39.381l-2.645,0.51s-14.446,1.119-14.446-0.814c0-2.135-0.813-27.066,1.322-42.126,0,0-0.508-2.95-1.322-5.496-0.813-2.442-4.375-10.073-4.375-11.698,0,0-5.695,16.072-6.001,18.824-0.304,2.543-1.12,38.357-1.628,41.312,0,0-8.241,6.308-9.36,6.92-1.118,0.509-9.054-3.36-9.258-4.375-0.306-1.118,0.814-13.229,4.578-33.176,1.425-7.123,0.61-8.44,0.61-10.375,0-1.934,0.103-27.474,1.322-35.412l0.006-0.002z'/%3E %3Cg fill='none'%3E %3Cpath d='m294.27,274.92c-0.609,2.24-1.628,4.375-3.559,5.803'/%3E %3Cpath d='m287.96,227.09c-0.304,1.322-2.238,7.325-7.122,10.887'/%3E %3Cpath d='m295.08,228.21c-1.12,3.562-5.493,22.693-6.309,45.383'/%3E %3Cpath d='m288.47,280.72c-0.204,2.135-1.322,18.012-1.628,20.756'/%3E %3Cpath d='m286.03,304.53c-0.509,1.117-2.746,10.375-2.746,18.619'/%3E %3Cpath d='m315.53,287.23c-0.204,1.933-1.019,15.668,3.561,27.98'/%3E %3Cpath d='m300.58,229.23c-0.305,2.237-0.813,16.688-0.813,17.806,0,1.117,1.628,2.747,2.441,3.054,0,0-1.628,0.509-1.933,6.003'/%3E %3Cpath d='m296.2,243.17c-0.308,1.727-1.934,8.547-3.054,11.295'/%3E %3Cpath d='m306.27,229.03s4.884,1.018,5.188,0c0,0,1.628,29.512,3.866,45.891'/%3E %3Cpath d='m304.14,232.79c0,1.934-0.609,16.485-0.609,16.485'/%3E %3Cpath d='m305.97,251.41s1.931,2.745,1.425,4.066'/%3E %3Cpath d='m289.59,227.4c1.629,0.508,3.053,0.812,3.053,0.812'/%3E %3Cpath d='m297.83,229.84c-0.307,0.814-0.61,4.58-0.61,4.58'/%3E %3Cpath d='m305.97,273.29c0.61,0.814,1.425,1.936,0.814,4.377'/%3E %3C/g%3E %3Cpath fill='%239b5f00' d='m284.91,224.45s0-3.256,1.22-4.886c0,0,3.457,0.714,8.342,1.222,4.984,0.508,8.951,0.916,12.615,0.508,3.663-0.406,7.428-1.322,7.428-1.322s1.017,4.784,0.506,5.496c0,0-3.968,0.814-8.341,1.016-4.477,0.303-11.902-0.408-14.445-0.812-3.359-0.408-6.31-1.02-7.325-1.222z'/%3E %3Cpath fill='%23fff' d='m288.06,224.85,0.608-4.883,1.019,0.1-0.203,5.088-1.424-0.305'/%3E %3Cpath fill='%23fff' d='m310.14,220.78,0.103,5.496,1.221-0.206-0.102-5.597-1.222,0.307'/%3E %3Cpath fill='%23fff' d='m294.47,220.78-0.406,5.291h0.713l0.712-5.291h-1.019'/%3E %3Cg%3E %3Cpath d='m276.77,320.81c-0.305,1.322-0.812,3.154-1.018,5.496,0,0.508-0.507,3.256,1.018,3.356,1.12,0.103,1.425-2.849,1.425-2.849s-1.019,3.256,0.305,3.664c1.832,0.403,2.034-3.562,2.034-3.562-0.204,1.119-1.425,3.969,0.306,4.271,1.831,0.307,2.339-3.867,2.339-3.867s-1.525,4.174,0.305,4.275c1.729,0.1,1.729-4.072,1.729-4.072s-0.916,4.988,1.526,4.58c1.321-0.203,1.628-1.934,1.933-2.951,0.406-1.524,1.322-3.457,0.204-6.612-0.812-2.341-0.507-2.951-0.507-2.951s-2.85,2.138-5.087,3.562c-1.019,0.609-6.514-2.34-6.514-2.34z'/%3E %3Cpath d='m306.48,316.43c-0.508-0.307-0.406,1.832-0.609,2.846-0.103,1.021,0.204,3.257,3.663,3.055,3.355-0.307,6.715-1.018,8.851-0.509,2.137,0.61,5.289,0.711,7.021,0.711,1.729,0,2.849-0.202,3.661-0.509,0.713-0.303,2.238,0.408,2.95,0.408,0.713,0,1.831-1.119,1.73-1.832-0.103-1.324-1.322-1.324-3.054-1.424-1.628-0.203-3.865-0.511-4.983-0.916-1.12-0.408-3.154-1.527-5.698-2.035,0,0-4.883,0.205-5.898,0.205-1.019,0-7.022,0.303-7.634,0z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23ffb366' d='m255.71,189.85c-0.507,0.306-1.12-2.035,0.406-2.951,0,0,0.406-1.931,2.035-2.136,0,0,1.321-1.832,3.257-1.626,0,0,2.235-1.525,3.051-1.324,0.812,0.102,2.849,2.136,2.95,2.85,0.204,0.711,0,1.933-0.511,2.442-0.609,0.608-1.018-0.102-1.119-0.916,0,0,0.407,1.524-0.813,2.135-1.219,0.714-1.119,0.206-1.219-0.61,0,0-0.308,1.63-1.12,1.832-0.814,0.305-1.322-0.408-1.935-0.408,0,0,1.019,0.816,0.307,1.426-0.713,0.508-1.526,0.303-2.036-0.102-0.509-0.508-1.12-1.832-3.257-0.61l0.004-0.002z'/%3E %3Cpath d='m265.68,186.09c-0.51-1.629-2.137-3.054-4.069-2.848'/%3E %3Cpath d='m263.85,187.61c-0.306-0.408-0.408-0.816-0.712-1.22-0.916-1.528-2.849-1.424-4.477-1.832'/%3E %3Cpath d='m261.1,189.14c-0.609-0.406-0.813-1.222-1.425-1.524-1.018-0.408-2.034-0.916-3.255-0.714'/%3E %3C/g%3E %3C/g%3E %3Cg id='black_man' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='url(%23black_skin)' d='m439.14,165.12c0.712-0.306,0.51,0.61,0.61,0.916,0.306,1.321,0.306,2.748,0.813,3.967,0.608,1.119,0.812,1.526,1.83,2.035,1.627,0.916,6.407,3.562,9.767,1.424,0.204-0.101,0.508-0.306,0.712-0.508,0,0-1.221,4.172,2.95,6.207,1.321,0.71,15.668,8.241,15.668,8.241s1.525,2.748,0.609,6.512c-0.204,0.61-0.405,1.118,0.204,1.526,1.019,0.71,2.644,2.748,3.766,6.004,0,0,2.947-1.324,2.947-3.256,0-1.934-1.219-2.951-1.525-4.375-0.202-1.324-1.017-4.682-0.608-5.698,0.405-1.118,2.135-1.526,2.847-1.936,0.714-0.408,1.526,0.406,1.322,1.322-0.102,1.018-0.812,0.816-1.628,1.018,0,0,1.02,1.932,0.814,3.356l9.358,4.783s-1.221,1.629-1.628,2.34c-0.509,0.715-1.425,10.175-4.171,14.653-2.748,4.477-3.663,3.256-4.171,3.866-0.61,0.508-1.424,1.324-2.137,1.934-0.608,0.508-3.764,0.814-4.476-0.916-0.712-1.628-1.221-2.647-3.153-4.174-1.934-1.524-5.9-5.391-5.9-7.123,0,0-2.341,6.719-2.035,12.313,0,0-8.443,1.731-16.176,1.936-7.631,0.102-11.497-1.528-11.497-1.528s-1.018-6.409-0.61-7.631c0,0-1.22,4.172-2.033,5.596-1.118,1.727-2.236,5.291-4.375,5.493-2.236,0.104-3.968-2.135-4.271-3.051v-6.716h-8.646c0-0.101-3.766,1.424-5.087,1.223-1.221-0.105-1.832-1.223-0.813-1.631l0.407-0.303c-1.119,0-2.544,0.71-2.544,0.71h-4.272c0-0.101,0.103-0.408,0.103-0.508,0.307-1.219,2.545-2.24,4.272-2.95,1.628-0.609,3.356-1.324,4.578-1.424,1.933-0.203,3.256-0.101,6.206,0.408,0.812,0.101,3.967,0.408,5.798,1.322,0.508,0.304,1.118,0.405,0.813-0.915-0.305-1.426-1.221-5.598,0.307-8.346,1.018-1.933,0.916-3.559,0.813-5.189-0.204-1.729-1.118-5.598-1.118-7.325,0-5.699,4.375-8.039,8.24-9.262,4.272-1.319,7.121-2.748,6.92-5.288-0.104-2.646,0.608-7.021,0.202-9.058'/%3E %3Cg fill='none'%3E %3Cpath fill='url(%23black_skin)' d='m456.34,153.63c0.916,3.356,1.12,4.169,1.12,5.291,0,1.219-0.509,1.424-0.104,2.748,0.713,2.441-0.712,5.088-2.441,7.937-0.813,1.32-1.424,3.052-2.746,3.866-3.356,2.135-7.427-0.408-9.563-1.327-1.117-0.505-1.729-1.319-2.033-2.135-0.407-1.219-0.509-2.34-0.813-3.967,0-0.306,0.103-1.219-0.609-0.916-1.22-1.424-1.018-2.034-1.524-3.051-0.509-1.021,0.916-2.139,2.034-1.934-0.61-1.933-0.916-4.072-0.306-5.904,0.204-0.608-0.508-2.235,0.51-1.832,4.577,1.832,9.969,1.426,14.854,1.426,0.404,0,0.71-0.812,1.32-0.71,0.098-0.001,0.2,0.305,0.301,0.508'/%3E %3Cpath fill='%23000' d='m456.75,155.35c0.508-0.406,0.204-2.34-0.306-4.375-0.203-1.017-1.018-1.424-2.136-2.542-1.12-1.122-1.525-1.122-2.236-1.424-0.609-0.206-2.034-0.206-2.746-0.508-0.61-0.308-2.238-0.105-3.766,0.101-2.036,0.304-3.153,0.202-4.679,1.018-1.526,0.814-2.746,1.73-3.256,3.256-0.406,1.118-1.12,2.542-0.814,6.817,0.204,4.272,1.019,3.458,1.019,3.458s1.12-1.628,1.832-0.61c0,0-0.103-2.24-0.305-3.561-0.103-1.222,0-2.748,0.509-4.58,0,0,4.679,1.732,9.054,1.732,3.053,0,7.021-0.306,7.123-1.017l0.71,2.235h-0.003z'/%3E %3Cpath d='m450.44,160.14c0.61,1.732,0.104,1.222,0.408,2.34'/%3E %3Cpath d='m440.57,164.51c0,0.812-0.61,0.61-1.019,0.61'/%3E %3Cpath d='m456.85,158.82c-0.916-0.713-2.645-0.204-3.46,0.102-1.525,0.71-0.712,2.24-0.204,3.664,0.204,0.71,1.02,1.727,0.511,2.441-0.407,0.812-0.713,0.408-1.629,0.51,0.104-0.308-0.812,0-1.117,0-0.61-0.102-0.916,0.403-1.426,0.202-0.608-0.304-0.508-1.22-0.306-1.729'/%3E %3Cpath d='m449.32,159.53c0-0.403-1.321-0.811-2.745-0.915-2.238-0.102-2.442,0.104-4.172,1.322'/%3E %3Cpath d='m453.9,168.89c-0.405-0.608-1.018-0.916-2.137-0.405,0-0.204-1.524-0.406-1.524-0.406-0.812,0-1.321,0.303-2.136,0.71'/%3E %3Cpath d='m453.69,169.4c-0.916-0.609-3.256-0.201-5.596-0.201'/%3E %3Cpath d='m448.3,170.01c1.73,0.512,3.46,0.816,5.188,0'/%3E %3Cpath fill='%23fff' stroke-width='0.3052' d='m456.44,160.14c-0.712-0.1-1.018-0.916-3.153,0.306-1.119,0.61,1.832,1.426,1.425,1.324,1.22,0.202,1.628-0.508,1.729-1.122-0.001-0.203,0.203-0.508-0.001-0.508z'/%3E %3Cpath fill='%23fff' stroke-width='0.3052' d='m448.1,160.95c0-0.816-1.829-1.119-2.847-0.816-1.019,0.306-0.61,0.105-1.526,0.613,1.02,0.203,0.712,0.303,1.526,0.71,0.914,0.408,1.12,0.814,2.339,0.206,0.306-0.105,0.712-0.508,0.813-0.916-0.101,0.101-0.202,0.203-0.305,0.203z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m455.12,161.36c-0.508,0-0.813-0.406-0.813-0.814,0-0.508,0.307-0.916,0.813-0.916,0.405,0,0.712,0.408,0.712,0.916,0,0.408-0.307,0.814-0.712,0.814z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m446.37,161.56c-0.406,0-0.712-0.403-0.712-0.916,0-0.508,0.403-0.811,0.812-0.811s0.712,0.303,0.712,0.811c0,0.514-0.303,0.916-0.812,0.916z'/%3E %3C/g%3E %3Cuse xlink:href='%23body' fill='%23730000' transform='matrix(-1,0,0,1,748.81578,0)'/%3E %3Cg fill='none'%3E %3Cpath fill='%23730000' d='m491.64,193.51c0.508,0.206,1.934-2.033,0.508-3.051,0,0-0.508-1.932-2.136-2.034,0,0-1.322-1.933-3.257-1.63,0,0-2.136-1.524-2.948-1.421-0.916,0.202-2.951,2.237-3.053,2.95-0.102,0.609,0,1.832,0.508,2.441,0.61,0.51,1.02-0.104,1.119-1.02,0,0-0.405,1.529,0.813,2.24,1.221,0.71,1.119,0.1,1.221-0.71,0,0,0.306,1.626,1.12,1.932,0.812,0.303,1.321-0.408,1.934-0.408,0,0-1.018,0.815-0.305,1.324,0.713,0.61,1.525,0.303,2.035-0.104,0.61-0.404,0.306-1.727,2.441-0.509z'/%3E %3Cpath d='m482.49,189.75c0.506-1.73,2.235-3.153,4.067-2.849'/%3E %3Cpath d='m484.42,191.28c0.203-0.411,0.305-0.816,0.61-1.224,0.915-1.524,2.948-1.524,4.576-1.832'/%3E %3Cpath d='m487.06,192.7c0.61-0.408,0.814-1.118,1.426-1.421,1.018-0.512,2.136-0.916,3.256-0.714'/%3E %3Cpath fill='%23730000' stroke='none' d='m482.31,186.77c-0.896,0.716-1.837,1.798-1.906,2.281-0.103,0.61-0.008,1.827,0.5,2.438,0.551,0.461,0.949-0.017,1.095-0.781-0.059,0.463-0.071,1.465,0.844,2,1.22,0.71,1.118,0.095,1.219-0.719,0,0,0.312,1.635,1.125,1.938,0.813,0.306,1.325-0.406,1.938-0.406,0,0-1.026,0.804-0.312,1.312,0.712,0.61,1.522,0.309,2.031-0.094,0.61-0.408,0.3-1.722,2.438-0.5,0.267,0.106,0.804-0.452,1.031-1.156l-7.688-5.531-2.315-0.782z'/%3E %3Cpath d='m480.68,188.19c-1.502,2.582,0.5,4.132,1.164,2.619-0.193,2.386,1.606,2.292,2.285,1.538,0.658,2.512,1.83,1.395,2.909,1.164-1.223,2.29,1.479,1.609,2.12,1.081,0.924-1.362,1.356-0.277,2.036-0.416l1.164-1.247'/%3E %3Cpath d='m484.38,187.23c-1.686,0.896-2.512,2.137-2.535,3.699'/%3E %3Cpath d='m486.71,188.73c-1.687,0.896-2.512,2.137-2.535,3.699'/%3E %3Cpath d='m489.58,190.68c-1.687,0.897-1.765,1.722-2.493,2.826'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%235ac800'%3E %3Cpath d='m290.1,323.66-0.204-4.68,1.934,1.629,0.508-3.562c0.813-0.206,2.137,1.426,2.137,1.426l-0.204-3.564,2.95,3.257s-0.203-2.748,0.812-4.377c0,0,2.237,1.935,2.237,4.172,0,1.938,1.934-2.748,1.934-2.748,0.509,1.63,1.628,5.19,1.628,5.19l1.321-1.934,1.12,4.07,2.442-3.562,1.931,4.174,4.375-0.307,0.509,2.439,1.933-2.135,2.544,1.627s2.137-0.609,3.256-0.609,2.442,1.426,2.442,1.426,0.813-1.426,1.628-1.938c0.812-0.506,1.935,0.816,2.236,1.63l1.629-2.95s2.137,2.137,2.441,2.95c0,0,0.304-2.44,0.813-3.257,0.51-0.813,1.321,0.307,1.933,1.324l1.322-4.375s1.425,0.303,2.441,1.934c1.117,1.626,1.117-2.441,1.117-2.441s2.441,3.256,3.052,5.493c0,0-16.846,5.784-28.726,4.203-13.983-1.862-25.501-4.507-25.501-4.507'/%3E %3Cpath d='m405.57,323.15s0.813-2.239,1.935-3.36c0,0,2.136,2.546,2.136,3.36,0,0,0.608-0.305,1.729-1.121l1.628,1.627,1.935-1.32,1.832,1.626,3.356-1.424,1.322,1.424,5.188-0.606,1.933,0.812,1.832-2.341,1.73,1.832,2.746-2.748s1.322,1.118,1.628,1.935c0,0,2.238-1.117,2.747-1.935,0,0,2.136-0.813,2.44,0.509,0,0,1.322-1.018,1.222-2.135-0.102-1.118,1.525-0.307,2.034,1.117,0,0,0.609-2.235,2.236-2.44,0,0,1.118,1.319,0.813,3.767,0,0,2.441-1.938,3.561-2.141,0,0,0.508,2.748-0.305,5.193,0,0,2.543-4.174,3.053-2.748,0.204,0.812,0.814,3.561,0.204,5.492l2.238-1.424,0.812,2.748,2.44-0.509s-14.442,2.212-28.05,0.914c-13.607-1.298-26.376-6.104-26.375-6.104'/%3E %3Cpath d='m395.51,333.25c0.661-0.408-4.546,10.708-17.17,11.299-17.563,0.823-32.577-7.94-32.577-7.94s1.832-3.051,2.949-3.867c0,0,2.441,1.936,3.256,4.375,0,0,0.306-1.627,1.12-3.051,0,0,3.052,1.422,3.561,3.358,0,0,1.12-1.935,1.934-2.442,0.812-0.612,1.628,2.135,1.628,3.766,0,0,1.932-2.038,3.052-2.139,0,0,2.137,1.017,2.747,4.58,0,0,2.035-1.933,2.746-1.631,0,0,2.442,1.631,1.83,3.867-0.304,1.223,2.442-1.421,5.801-2.236l2.949,2.236s2.746-3.66,3.561-4.885c0,0,2.238,0.816,2.238,2.141,0,0,1.019-3.869,1.832-4.275,0.812-0.508,1.931,1.22,1.931,2.342,0,0,0.307-2.952,1.935-3.562,0,0,1.628,1.118,1.628,2.24-0.003-0.002,1.726-3.36,3.049-4.176z'/%3E %3C/g%3E %3Cg stroke-width='0.5087' stroke='%23060' fill='none'%3E %3Cpath d='m290.1,323.66-0.204-4.68,1.934,1.629,0.508-3.562c0.813-0.203,2.137,1.426,2.137,1.426l-0.204-3.561,2.95,3.256s-0.203-2.748,0.812-4.375c0,0,2.237,1.934,2.237,4.172,0,1.936,1.934-2.748,1.934-2.748,0.509,1.631,1.628,5.191,1.628,5.191l1.321-1.936,1.119,4.069,2.441-3.56,1.933,4.172,4.375-0.307,0.509,2.443,1.933-2.137,2.544,1.629s2.135-0.609,3.255-0.609,2.442,1.422,2.442,1.422,0.812-1.422,1.628-1.931c0.812-0.509,1.933,0.812,2.235,1.626l1.629-2.949s2.137,2.137,2.441,2.949c0,0,0.305-2.439,0.814-3.256,0.51-0.812,1.321,0.307,1.933,1.324l1.322-4.375s1.424,0.303,2.44,1.933c1.12,1.626,1.12-2.444,1.12-2.444s2.44,3.258,3.054,5.495'/%3E %3Cpath d='m405.57,323.15s0.812-2.235,1.933-3.356c0,0,2.136,2.545,2.136,3.356,0,0,0.61-0.305,1.73-1.117l1.628,1.626,1.933-1.32,1.832,1.627,3.358-1.424,1.319,1.424,5.188-0.608,1.935,0.812,1.83-2.337,1.73,1.828,2.746-2.744s1.322,1.115,1.628,1.932c0,0,2.238-1.119,2.747-1.932,0,0,2.135-0.814,2.439,0.505,0,0,1.322-1.017,1.221-2.135-0.103-1.118,1.525-0.304,2.034,1.122,0,0,0.609-2.24,2.238-2.445,0,0,1.118,1.323,0.812,3.766,0,0,2.441-1.932,3.561-2.137,0,0,0.509,2.745-0.304,5.189,0,0,2.544-4.172,3.052-2.747,0.204,0.812,0.814,3.562,0.204,5.493l2.238-1.424,0.813,2.748,2.44-0.51'/%3E %3Cpath d='m345.68,336.63s1.832-3.051,2.949-3.866c0,0,2.442,1.934,3.256,4.375,0,0,0.308-1.627,1.12-3.051,0,0,3.053,1.42,3.561,3.357,0,0,1.12-1.934,1.934-2.441,0.813-0.613,1.628,2.135,1.628,3.764,0,0,1.933-2.037,3.053-2.138,0,0,2.136,1.017,2.746,4.58,0,0,2.036-1.933,2.746-1.63,0,0,2.442,1.63,1.831,3.867-0.305,1.221,2.442-1.422,5.8-2.237l2.949,2.237s2.746-3.662,3.561-4.885c0,0,2.238,0.814,2.238,2.139,0,0,1.019-3.869,1.832-4.273,0.812-0.508,1.931,1.219,1.931,2.34,0,0,0.307-2.951,1.936-3.562,0,0,1.628,1.118,1.628,2.239,0,0,1.729-3.356,3.052-4.174'/%3E %3C/g%3E %3C/g%3E %3Cg id='motto'%3E %3Cg fill='%23fff'%3E %3Cpath d='m374.44,376.98c22.892,0.205,36.424-8.141,43.851-13.127,17.396-11.699,21.059-12.107,23.908-11.906,3.257,0.309,8.035,1.427,8.24,4.277,0.306,4.375-6.815,6.307-10.886,6.307-4.17,0-15.058-2.748-15.058-2.748l-2.85,1.936c1.934,0.916,24.215,8.342,28.488,1.323,4.372-7.122,8.749-18.622,8.749-18.622s-4.883-8.751-15.771-8.751c-10.987,0-21.671,6.922-28.791,12.106-7.123,5.19-16.074,12.312-39.883,12.312-23.807,0-32.86-7.122-39.981-12.312-7.121-5.188-17.805-12.106-28.689-12.106-10.987,0-15.872,8.751-15.872,8.751s4.374,11.5,8.749,18.622c4.272,7.019,26.555-0.407,28.485-1.323l-2.746-1.936s-10.987,2.748-15.058,2.748c-4.171,0-11.293-1.932-10.987-6.307,0.204-2.85,4.984-3.97,8.241-4.277,2.848-0.201,6.511,0.207,23.907,11.906,7.431,4.986,20.962,13.025,43.954,13.127'/%3E %3Cpath d='m337.61,350.01s0-1.938-0.308-4.783c-0.406-3.664-2.542-4.58-4.271-4.071-1.118,0.403-3.356,3.155-3.356,3.155v0.103c-1.018-0.715-2.034-1.323-3.154-1.935,0.814-0.916,5.494-3.764,6.613-3.764,1.019,0,15.058,5.697,19.532,9.562,1.12,1.021,1.935,7.328,1.322,9.361-7.528-1.933-12.411-4.781-16.381-7.529v-0.102'/%3E %3Cpath d='m330.89,364.26s-3.053,3.051-3.153,8.648c-0.104,6.613,4.68,6.92,7.833,6.816,3.765-0.104,6.815-2.238,6.715-9.259,0,0-6.207-2.647-11.396-6.207'/%3E %3Cpath d='m411.17,350.01s0.103-1.938,0.408-4.783c0.403-3.664,2.44-4.58,4.17-4.071,1.119,0.403,3.356,3.155,3.356,3.155v0.103c1.017-0.715,2.032-1.323,3.152-1.935-0.812-0.916-5.491-3.764-6.51-3.764-1.118,0-15.157,5.697-19.634,9.562-1.02,1.021-1.832,7.328-1.322,9.361,7.631-1.933,12.411-4.781,16.38-7.529v-0.102'/%3E %3Cpath d='m417.88,364.26s3.053,3.051,3.154,8.648c0.204,6.613-4.682,6.92-7.833,6.816-3.766-0.104-6.715-2.238-6.715-9.259,0,0,6.207-2.647,11.396-6.207'/%3E %3C/g%3E %3Cg fill='%2369f'%3E %3Cpath d='m324.28,359.78s-10.887,2.748-14.956,2.748c-4.17,0-11.293-1.93-10.987-6.308,0.204-2.85,4.985-3.967,8.241-4.272,2.441-0.207,5.595,0.101,17.702,7.832'/%3E %3Cpath d='m424.5,359.78s10.885,2.748,15.058,2.748c4.07,0,11.191-1.93,10.885-6.308-0.202-2.85-4.983-3.967-8.239-4.272-2.444-0.207-5.598,0.101-17.704,7.832'/%3E %3Cpath d='m337.61,350.11c-1.119-0.814-2.238-1.631-3.258-2.441-1.525-1.121-3.052-2.139-4.681-3.256,0,0,2.238-2.85,3.357-3.156,1.729-0.609,3.865,0.303,4.271,3.967,0.306,2.85,0.306,4.887,0.306,4.887'/%3E %3Cpath d='m330.18,378.81c1.936,1.121,4.07,1.02,5.394,0.916,3.765-0.102,6.816-2.238,6.715-9.258,0,0,4.678,2.34,12.309,4.172,0,0,1.222,1.525,1.424,4.576,0.308,2.547-1.424,5.291-3.457,5.09,0,0-10.683-1.934-17.192-3.051-3.766-0.711-5.189-2.443-5.189-2.443'/%3E %3Cpath d='m411.17,350.11c1.118-0.814,2.238-1.631,3.355-2.441,1.426-1.121,2.95-2.139,4.579-3.256,0,0-2.237-2.85-3.356-3.156-1.729-0.609-3.765,0.303-4.17,3.967-0.307,2.847-0.408,4.886-0.408,4.886'/%3E %3Cpath d='m418.59,378.81c-1.933,1.121-4.07,1.02-5.393,0.916-3.765-0.102-6.715-2.238-6.715-9.258,0,0-4.681,2.34-12.209,4.172,0,0-1.322,1.525-1.526,4.576-0.204,2.547,1.526,5.291,3.459,5.09,0,0,10.783-1.934,17.193-3.051,3.765-0.711,5.188-2.443,5.188-2.443'/%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='0.7122'%3E %3Cpath d='m374.44,376.98c22.893,0.203,36.424-8.143,43.851-13.127,17.396-11.701,21.059-12.106,23.907-11.904,3.257,0.305,8.039,1.425,8.24,4.273,0.307,4.375-6.815,6.307-10.887,6.307-4.17,0-15.057-2.743-15.057-2.743l-2.848,1.934c1.934,0.916,24.212,8.343,28.485,1.32,4.375-7.122,8.748-18.619,8.748-18.619s-4.883-8.754-15.77-8.754c-10.986,0-21.669,6.922-28.792,12.11-7.121,5.189-16.072,12.312-39.881,12.312-23.807,0-32.859-7.123-39.981-12.312-7.121-5.188-17.806-12.11-28.69-12.11-10.986,0-15.87,8.754-15.87,8.754s4.373,11.497,8.749,18.619c4.273,7.021,26.555-0.404,28.486-1.32l-2.745-1.934s-10.989,2.743-15.056,2.743c-4.173,0-11.294-1.928-10.989-6.307,0.204-2.85,4.984-3.967,8.241-4.273,2.847-0.202,6.509,0.205,23.907,11.904,7.429,4.988,20.96,13.027,43.952,13.127z'/%3E %3Cpath d='m324.28,359.78s-10.888,2.748-14.954,2.748c-4.172,0-11.293-1.933-10.989-6.308,0.204-2.85,4.985-3.97,8.241-4.272,2.439-0.207,5.595,0.101,17.702,7.832z'/%3E %3Cpath d='m424.49,359.78s10.887,2.748,15.058,2.748c4.069,0,11.191-1.933,10.886-6.308-0.204-2.85-4.983-3.97-8.238-4.272-2.442-0.207-5.598,0.102-17.702,7.832h-0.004z'/%3E %3Cpath d='m337.61,350.11c-1.12-0.814-2.238-1.631-3.258-2.441-1.523-1.121-3.051-2.139-4.679-3.256,0,0,2.238-2.85,3.356-3.156,1.729-0.609,3.865,0.303,4.271,3.971,0.31,2.843,0.31,4.882,0.31,4.882z'/%3E %3Cpath d='m337.61,350.01s0-1.936-0.308-4.783c-0.404-3.664-2.542-4.58-4.271-4.071-1.12,0.407-3.358,3.155-3.358,3.155v0.103c-1.018-0.712-2.036-1.323-3.154-1.935,0.814-0.916,5.494-3.764,6.614-3.764,1.02,0,15.057,5.697,19.533,9.565,1.12,1.019,1.933,7.325,1.322,9.362-7.529-1.937-12.413-4.785-16.383-7.53'/%3E %3Cpath d='m330.89,364.26s-3.051,3.051-3.152,8.648c-0.103,6.609,4.679,6.918,7.833,6.816,3.765-0.104,6.814-2.238,6.717-9.263,0,0-6.207-2.646-11.396-6.207l-0.002,0.006z'/%3E %3Cpath d='m333.44,365.78s-2.439,2.543-2.847,6.715c-0.204,3.257,1.932,5.086,4.679,4.883,3.866-0.201,5.394-5.492,3.562-8.443l-5.394-3.155'/%3E %3Cpath d='m330.18,378.81c1.934,1.119,4.068,1.018,5.392,0.916,3.765-0.104,6.814-2.24,6.717-9.26,0,0,4.679,2.34,12.31,4.172,0,0,1.222,1.525,1.423,4.58,0.307,2.543-1.423,5.291-3.456,5.086,0,0-10.685-1.934-17.194-3.051-3.768-0.715-5.192-2.443-5.192-2.443z'/%3E %3Cpath d='m411.17,350.11c1.12-0.814,2.238-1.631,3.357-2.441,1.425-1.121,2.95-2.139,4.578-3.256,0,0-2.237-2.85-3.357-3.156-1.729-0.609-3.765,0.303-4.17,3.971-0.306,2.846-0.406,4.883-0.406,4.883h-0.002v-0.001z'/%3E %3Cpath d='m411.17,350.01s0.103-1.936,0.408-4.783c0.405-3.664,2.44-4.58,4.17-4.071,1.12,0.407,3.356,3.155,3.356,3.155v0.103c1.019-0.712,2.035-1.323,3.154-1.935-0.814-0.916-5.493-3.764-6.512-3.764-1.119,0-15.157,5.697-19.634,9.565-1.02,1.019-1.832,7.325-1.322,9.362,7.631-1.937,12.411-4.785,16.38-7.53'/%3E %3Cpath d='m417.88,364.26s3.053,3.051,3.154,8.648c0.204,6.609-4.682,6.918-7.835,6.816-3.764-0.104-6.713-2.238-6.713-9.263,0,0,6.205-2.646,11.394-6.207v0.006z'/%3E %3Cpath d='m415.34,365.78s2.442,2.543,2.849,6.715c0.307,3.257-1.935,5.086-4.681,4.883-3.865-0.201-5.289-5.492-3.561-8.443l5.393-3.155'/%3E %3Cpath d='m418.59,378.81c-1.933,1.119-4.07,1.018-5.393,0.916-3.764-0.104-6.713-2.24-6.713-9.26,0,0-4.682,2.34-12.208,4.172,0,0-1.322,1.525-1.526,4.58-0.203,2.543,1.526,5.291,3.459,5.086,0,0,10.785-1.934,17.192-3.051,3.766-0.715,5.189-2.443,5.189-2.443z'/%3E %3C/g%3E %3Cg fill='none' stroke='%23fff' stroke-width='0.7123'%3E %3Cpath d='m353.79,376.47s3.357,2.445-0.712,5.496'/%3E %3Cpath d='m343.72,374.84,10.275,4.478'/%3E %3Cpath d='m345.44,377.18,7.526,3.254'/%3E %3Cpath d='m348.09,375.25,5.697,2.547'/%3E %3Cpath d='m395.09,376.47s-3.46,2.445,0.61,5.496'/%3E %3Cpath d='m405.06,374.84-10.276,4.478'/%3E %3Cpath d='m403.43,377.18-7.527,3.254'/%3E %3Cpath d='m400.69,375.25-5.596,2.547'/%3E %3C/g%3E %3Cg fill='%23000' stroke='%23000' stroke-width='0.7'%3E %3Cpath d='m313.56,345.17c0.146,0.236,0.239,0.48301,0.285,0.736,0.039,0.25801,0.029,0.54701-0.03,0.865-0.145,0.756-0.55,1.322-1.206,1.712-0.66,0.38801-1.417,0.495-2.254,0.33501-0.389-0.072-0.771-0.20601-1.132-0.40201-0.362-0.18999-0.675-0.395-0.924-0.619-0.112,0.13201-0.23,0.259-0.348,0.392-0.163-0.03-0.326-0.062-0.488-0.093,0.157-0.985,0.312-1.971,0.475-2.954,0.161,0.03,0.327,0.062,0.495,0.096,0.031,0.382,0.093,0.728,0.174,1.048,0.076,0.32101,0.208,0.623,0.384,0.924,0.167,0.276,0.378,0.516,0.639,0.709,0.255,0.194,0.572,0.33,0.946,0.399,0.282,0.056,0.534,0.065,0.763,0.031,0.221-0.034,0.415-0.101,0.565-0.211,0.153-0.109,0.284-0.248,0.384-0.416,0.096-0.164,0.165-0.36,0.211-0.601,0.064-0.344,0.023-0.68-0.112-1.014-0.135-0.336-0.393-0.613-0.748-0.839-0.241-0.153-0.528-0.331-0.846-0.524-0.319-0.195-0.593-0.361-0.821-0.527-0.445-0.311-0.777-0.661-0.976-1.073-0.204-0.403-0.257-0.88799-0.148-1.457,0.062-0.325,0.188-0.612,0.377-0.871,0.188-0.26199,0.428-0.46899,0.719-0.646,0.277-0.172,0.588-0.27499,0.935-0.338,0.345-0.054,0.694-0.049,1.043,0.018,0.398,0.074,0.751,0.205,1.043,0.386,0.29,0.183,0.557,0.372,0.785,0.587,0.109-0.119,0.221-0.24,0.329-0.361,0.165,0.031,0.325,0.062,0.491,0.095-0.165,0.95-0.328,1.903-0.493,2.854-0.165-0.033-0.33-0.063-0.498-0.096-0.026-0.343-0.067-0.674-0.119-0.994-0.06-0.318-0.158-0.617-0.288-0.893-0.13-0.271-0.312-0.497-0.536-0.684-0.222-0.189-0.523-0.314-0.894-0.386-0.385-0.073-0.741-0.017-1.062,0.183-0.318,0.199-0.515,0.465-0.582,0.82-0.069,0.368-0.038,0.692,0.092,0.971,0.126,0.281,0.344,0.526,0.649,0.748,0.271,0.201,0.545,0.373,0.814,0.533,0.267,0.159,0.52,0.319,0.769,0.489,0.224,0.149,0.444,0.312,0.644,0.492,0.194,0.175,0.364,0.369,0.494,0.576'/%3E %3Cpath d='m326.04,346.92c-0.105-0.053-0.268-0.11199-0.484-0.182-0.217-0.07-0.406-0.10399-0.579-0.088-0.17,0.014-0.348,0.139-0.537,0.369-0.191,0.232-0.392,0.53699-0.596,0.91-0.611,1.107-1.224,2.215-1.834,3.324-0.234,0.422-0.526,0.74-0.878,0.955-0.351,0.21699-0.729,0.34-1.129,0.38099-0.396,0.041-0.772,0.008-1.14-0.078-0.368-0.098-0.695-0.22299-0.985-0.38299-0.463-0.256-0.849-0.541-1.146-0.863-0.297-0.328-0.52-0.656-0.647-0.998-0.131-0.342-0.186-0.678-0.161-1.012,0.021-0.332,0.113-0.639,0.271-0.924,0.831-1.508,1.663-3.015,2.494-4.521,0.067-0.125,0.103-0.246,0.113-0.354,0.002-0.102-0.045-0.229-0.129-0.371-0.066-0.102-0.156-0.207-0.28-0.317-0.129-0.104-0.229-0.188-0.32-0.246,0.069-0.127,0.141-0.256,0.21-0.382,1.078,0.595,2.151,1.188,3.228,1.779-0.069,0.127-0.142,0.257-0.211,0.382-0.105-0.054-0.24-0.103-0.409-0.161-0.171-0.062-0.302-0.098-0.388-0.109-0.147-0.023-0.271,0-0.365,0.082-0.1,0.079-0.181,0.172-0.245,0.291-0.777,1.408-1.556,2.816-2.332,4.225-0.112,0.205-0.208,0.433-0.281,0.68-0.083,0.249-0.107,0.51-0.081,0.777,0.029,0.279,0.139,0.539,0.313,0.799,0.176,0.26,0.478,0.508,0.902,0.742,0.396,0.22,0.771,0.345,1.111,0.371,0.337,0.021,0.642-0.021,0.912-0.14,0.252-0.112,0.475-0.256,0.649-0.435,0.178-0.178,0.327-0.375,0.445-0.588,0.578-1.049,1.153-2.092,1.73-3.137,0.221-0.4,0.374-0.742,0.453-1.029,0.083-0.286,0.086-0.491,0.019-0.637-0.072-0.162-0.213-0.328-0.401-0.496-0.195-0.172-0.349-0.299-0.462-0.367,0.07-0.127,0.142-0.256,0.211-0.381,1.056,0.582,2.111,1.164,3.169,1.748-0.069,0.13-0.139,0.257-0.21,0.384'/%3E %3Cpath d='m330.53,354.69c0.135,0.278,0.214,0.58299,0.219,0.90599,0.006,0.326-0.087,0.662-0.287,1.01-0.201,0.35-0.452,0.611-0.76,0.783-0.304,0.174-0.629,0.264-0.975,0.289-0.337,0.031-0.677-0.006-1.029-0.094-0.356-0.094-0.696-0.23-1.021-0.41601-1.211-0.697-2.423-1.396-3.631-2.092,0.073-0.12699,0.146-0.254,0.219-0.379,0.09,0.045,0.222,0.1,0.404,0.17001,0.181,0.073,0.314,0.11299,0.402,0.125,0.142,0.018,0.257-0.011,0.356-0.066,0.093-0.055,0.176-0.146,0.253-0.279,1.044-1.812,2.088-3.627,3.132-5.439,0.069-0.12301,0.11-0.239,0.125-0.354,0.009-0.11501-0.031-0.236-0.119-0.367-0.077-0.115-0.174-0.227-0.292-0.332-0.12-0.104-0.216-0.188-0.305-0.246,0.071-0.125,0.146-0.252,0.218-0.377,1.178,0.67799,2.358,1.357,3.54,2.039,0.274,0.15801,0.521,0.33401,0.743,0.53101,0.216,0.199,0.401,0.43,0.551,0.693,0.14,0.24799,0.223,0.52099,0.231,0.80999,0.009,0.29201-0.065,0.59501-0.241,0.899-0.152,0.264-0.339,0.471-0.556,0.621-0.215,0.15601-0.457,0.254-0.721,0.303-0.251,0.051-0.505,0.055-0.773,0.029-0.273-0.02-0.548-0.08-0.828-0.172-0.01,0.017-0.02,0.032-0.028,0.049,0.207,0.156,0.422,0.348,0.647,0.586,0.224,0.245,0.403,0.499,0.526,0.77zm-0.652-1.894c0.226-0.078,0.412-0.188,0.568-0.34001,0.152-0.15199,0.305-0.34899,0.45-0.601,0.237-0.41499,0.309-0.808,0.217-1.18-0.09-0.375-0.39-0.69901-0.886-0.985-0.114-0.064-0.261-0.14801-0.437-0.24401-0.181-0.099-0.329-0.178-0.442-0.236-0.562,0.973-1.119,1.941-1.679,2.912,0.227,0.131,0.451,0.26,0.681,0.392,0.298,0.172,0.571,0.28,0.824,0.327,0.256,0.044,0.489,0.035,0.704-0.045zm-0.637,2.847c0.257-0.445,0.312-0.898,0.179-1.363-0.136-0.467-0.491-0.857-1.061-1.186-0.23-0.13301-0.427-0.245-0.584-0.33001-0.16-0.086-0.281-0.148-0.363-0.19099-0.514,0.894-1.023,1.779-1.536,2.668-0.128,0.223-0.136,0.446-0.019,0.664,0.117,0.21899,0.34,0.422,0.671,0.611,0.533,0.309,1.035,0.39599,1.498,0.25,0.464-0.15201,0.866-0.51701,1.215-1.123z'/%3E %3Cpath d='m348.94,360.14c-0.111-0.041-0.275-0.086-0.499-0.13199-0.222-0.048-0.416-0.062-0.585-0.03-0.167,0.031-0.331,0.174-0.498,0.422-0.167,0.25-0.334,0.574-0.502,0.965-0.498,1.164-0.996,2.326-1.494,3.49-0.19,0.443-0.45,0.789-0.777,1.039-0.327,0.248-0.692,0.408-1.086,0.49-0.392,0.08-0.769,0.084-1.142,0.033-0.376-0.059-0.716-0.151-1.02-0.281-0.485-0.207-0.897-0.454-1.226-0.746-0.328-0.297-0.581-0.6-0.744-0.928-0.163-0.326-0.252-0.654-0.26-0.99-0.013-0.333,0.046-0.648,0.174-0.948,0.678-1.581,1.355-3.163,2.033-4.745,0.056-0.13,0.079-0.254,0.08-0.361-0.009-0.102-0.066-0.225-0.165-0.356-0.076-0.094-0.176-0.188-0.313-0.289-0.137-0.09-0.244-0.165-0.341-0.213,0.058-0.133,0.114-0.269,0.171-0.399,1.129,0.483,2.259,0.967,3.389,1.451-0.058,0.133-0.114,0.268-0.173,0.399-0.109-0.042-0.249-0.078-0.423-0.12-0.176-0.044-0.31-0.064-0.396-0.07-0.15-0.01-0.27,0.026-0.356,0.117-0.09,0.09-0.161,0.189-0.215,0.314-0.633,1.479-1.267,2.957-1.898,4.437-0.093,0.214-0.165,0.449-0.216,0.701-0.057,0.258-0.055,0.521-0.001,0.784,0.058,0.273,0.191,0.521,0.392,0.763,0.201,0.24,0.524,0.458,0.971,0.647,0.418,0.181,0.804,0.267,1.146,0.259,0.335-0.013,0.636-0.082,0.891-0.229,0.239-0.139,0.449-0.301,0.606-0.496,0.157-0.192,0.288-0.404,0.385-0.629,0.471-1.1,0.939-2.195,1.409-3.293,0.181-0.42,0.299-0.775,0.351-1.068,0.051-0.295,0.036-0.498-0.046-0.635-0.091-0.156-0.244-0.307-0.449-0.455-0.215-0.152-0.377-0.264-0.495-0.319,0.057-0.134,0.114-0.269,0.171-0.399,1.107,0.475,2.218,0.949,3.325,1.424-0.06,0.129-0.118,0.263-0.174,0.396'/%3E %3Cpath d='m358.51,371.38c-1.251-0.361-2.504-0.725-3.755-1.086,0.041-0.14101,0.082-0.28101,0.122-0.42001,0.139,0.033,0.315,0.07,0.537,0.109,0.217,0.034,0.376,0.045,0.469,0.028,0.146-0.045,0.262-0.099,0.349-0.18299,0.08-0.078,0.147-0.188,0.189-0.33601,0.588-2.033,1.176-4.065,1.765-6.102-0.033-0.01-0.062-0.018-0.092-0.025-1.642,2.113-3.323,4.195-4.968,6.31-0.098-0.028-0.195-0.058-0.298-0.086-0.2-2.699-0.453-5.396-0.653-8.093-0.024-0.008-0.053-0.017-0.077-0.022-0.482,1.668-0.966,3.336-1.447,5.008-0.141,0.482-0.215,0.854-0.225,1.132-0.015,0.27101,0.032,0.477,0.124,0.625,0.063,0.11,0.225,0.23701,0.479,0.395,0.253,0.156,0.422,0.244,0.504,0.273-0.04,0.139-0.081,0.278-0.122,0.42001-1.142-0.33001-2.286-0.66001-3.432-0.99,0.041-0.14301,0.082-0.283,0.122-0.42201,0.185,0.033,0.385,0.062,0.595,0.074,0.209,0.017,0.378-0.002,0.514-0.062,0.169-0.073,0.312-0.207,0.436-0.42599,0.116-0.21301,0.252-0.58601,0.406-1.121,0.413-1.43,0.827-2.863,1.24-4.293,0.072-0.24801,0.101-0.457,0.087-0.63301-0.014-0.18099-0.062-0.32399-0.146-0.461-0.096-0.145-0.226-0.26299-0.388-0.36699-0.165-0.10801-0.337-0.188-0.51-0.24401,0.04-0.139,0.081-0.279,0.121-0.418,0.966,0.279,1.929,0.557,2.894,0.836,0.19,2.336,0.432,4.669,0.62,7.007,1.188-1.563,2.41-3.103,3.6-4.667,0.133-0.173,0.261-0.35401,0.374-0.55501,0.112-0.19099,0.182-0.324,0.208-0.39699,0.923,0.26699,1.85,0.534,2.771,0.802-0.04,0.139-0.081,0.279-0.121,0.418-0.114-0.027-0.258-0.047-0.439-0.068s-0.322-0.029-0.409-0.023c-0.15,0.01-0.264,0.061-0.344,0.159-0.078,0.101-0.138,0.20799-0.175,0.33899-0.583,2.018-1.166,4.032-1.748,6.049-0.039,0.135-0.049,0.26-0.03,0.368,0.021,0.109,0.089,0.21601,0.203,0.328,0.062,0.062,0.179,0.133,0.354,0.218,0.176,0.09,0.312,0.147,0.42,0.186-0.042,0.134-0.083,0.275-0.124,0.416'/%3E %3Cpath d='m367.6,368.62c0.23,0.205,0.423,0.455,0.553,0.75201,0.129,0.29899,0.179,0.64499,0.128,1.041-0.05,0.4-0.187,0.73801-0.397,1.018-0.216,0.275-0.479,0.484-0.786,0.645-0.302,0.158-0.632,0.256-0.988,0.312-0.364,0.051-0.729,0.057-1.102,0.01-1.386-0.174-2.771-0.349-4.156-0.522,0.018-0.146,0.035-0.291,0.054-0.435,0.101,0.007,0.243,0.007,0.439,0,0.193-0.002,0.336-0.017,0.422-0.041,0.136-0.039,0.233-0.106,0.301-0.198,0.063-0.086,0.107-0.201,0.127-0.355,0.262-2.075,0.521-4.15,0.783-6.227,0.019-0.14199,0.005-0.26699-0.021-0.375-0.037-0.10899-0.12-0.20499-0.252-0.293-0.118-0.076-0.248-0.14199-0.396-0.19099-0.153-0.051-0.272-0.092-0.376-0.10901,0.018-0.14499,0.035-0.289,0.054-0.43399,1.35,0.16999,2.701,0.341,4.054,0.51099,0.312,0.04,0.606,0.106,0.893,0.20401,0.275,0.1,0.533,0.23799,0.772,0.42599,0.223,0.173,0.409,0.39301,0.529,0.65601,0.121,0.266,0.164,0.572,0.12,0.922-0.038,0.303-0.129,0.56599-0.267,0.788-0.141,0.228-0.324,0.411-0.548,0.56-0.211,0.143-0.448,0.244-0.701,0.326-0.263,0.088-0.538,0.137-0.83,0.162-0.003,0.018-0.006,0.037-0.009,0.055,0.25,0.064,0.521,0.157,0.823,0.289,0.296,0.136,0.56,0.302,0.777,0.503zm-1.334-1.494c0.177-0.158,0.31-0.334,0.396-0.533,0.081-0.198,0.144-0.438,0.18-0.729,0.061-0.475-0.025-0.861-0.256-1.172-0.229-0.311-0.627-0.492-1.198-0.564-0.128-0.016-0.298-0.037-0.493-0.058-0.207-0.021-0.372-0.036-0.507-0.048-0.14,1.113-0.278,2.225-0.419,3.336,0.262,0.032,0.521,0.064,0.78,0.098,0.339,0.043,0.637,0.037,0.891-0.018,0.248-0.056,0.457-0.158,0.626-0.312zm0.514,2.873c0.063-0.513-0.06-0.951-0.36-1.328-0.308-0.377-0.786-0.6-1.437-0.682-0.267-0.033-0.487-0.061-0.668-0.078-0.183-0.019-0.317-0.029-0.412-0.037-0.129,1.021-0.256,2.037-0.384,3.056-0.032,0.254,0.05,0.46399,0.241,0.62,0.192,0.15599,0.479,0.25699,0.855,0.30399,0.613,0.078,1.106-0.035,1.476-0.351,0.372-0.321,0.602-0.814,0.689-1.504z'/%3E %3Cpath d='m378.69,372.75h-2.387c-0.519-0.82499-1.005-1.518-1.423-2.119-0.427-0.598-0.896-1.199-1.392-1.838h-0.905v2.769c0,0.142,0.026,0.271,0.068,0.374,0.045,0.111,0.145,0.195,0.295,0.25401,0.073,0.029,0.205,0.053,0.392,0.08,0.188,0.023,0.346,0.037,0.475,0.043v0.438h-3.74v-0.438c0.098-0.006,0.242-0.023,0.437-0.043,0.188-0.021,0.318-0.051,0.393-0.08,0.124-0.057,0.219-0.12901,0.272-0.23401,0.06-0.10399,0.082-0.23199,0.082-0.394v-6.313c0-0.139-0.019-0.27-0.061-0.38299-0.045-0.10801-0.14-0.19401-0.295-0.25-0.104-0.037-0.236-0.076-0.405-0.104-0.168-0.028-0.305-0.052-0.423-0.056v-0.437h4.085c0.373,0,0.723,0.034,1.055,0.11,0.329,0.082,0.623,0.199,0.89,0.371,0.255,0.166,0.466,0.371,0.617,0.639,0.152,0.264,0.231,0.584,0.231,0.959,0,0.34-0.053,0.633-0.155,0.893-0.104,0.26-0.26,0.47899-0.463,0.67-0.184,0.183-0.413,0.324-0.673,0.457-0.261,0.129-0.55,0.238-0.865,0.332,0.43,0.574,0.803,1.047,1.091,1.438,0.282,0.39,0.647,0.85801,1.059,1.421,0.182,0.249,0.353,0.42599,0.5,0.54199,0.145,0.121,0.295,0.21401,0.437,0.29101,0.105,0.058,0.244,0.093,0.405,0.12099,0.163,0.03,0.3,0.045,0.405,0.051-0.002,0.143-0.002,0.289-0.002,0.436zm-3.28-6.506c0-0.528-0.16-0.942-0.46-1.26-0.303-0.311-0.742-0.463-1.303-0.463h-1.062v3.742h0.818c0.573,0,1.058-0.173,1.434-0.542,0.375-0.36799,0.573-0.85399,0.573-1.477z'/%3E %3Cpath d='m388.88,372.1c-1.223,0.094-2.443,0.18599-3.669,0.279-0.012-0.14601-0.022-0.293-0.033-0.438,0.323-0.043,0.588-0.104,0.802-0.18401,0.205-0.08,0.307-0.15999,0.3-0.251-0.003-0.037-0.015-0.079-0.023-0.13499-0.013-0.057-0.024-0.096-0.048-0.13901-0.288-0.63299-0.592-1.261-0.882-1.895-1.034,0.078-2.063,0.156-3.098,0.234-0.095,0.297-0.172,0.549-0.223,0.771-0.057,0.22199-0.111,0.421-0.153,0.604-0.041,0.182-0.07,0.323-0.08,0.438-0.01,0.11299-0.018,0.203-0.011,0.271,0.012,0.16399,0.151,0.276,0.42,0.35099,0.269,0.073,0.565,0.099,0.897,0.093,0.011,0.145,0.022,0.29,0.033,0.438-1.106,0.084-2.216,0.168-3.323,0.252-0.011-0.146-0.021-0.293-0.033-0.438,0.107-0.014,0.239-0.047,0.398-0.102,0.159-0.053,0.287-0.111,0.387-0.187,0.159-0.125,0.276-0.248,0.359-0.381,0.085-0.124,0.159-0.293,0.229-0.517,0.351-1.127,0.767-2.387,1.188-3.793,0.421-1.403,0.824-2.651,1.153-3.746,0.165-0.012,0.33-0.024,0.498-0.036,1.152,2.437,2.354,4.848,3.511,7.282,0.073,0.156,0.156,0.277,0.24,0.373,0.089,0.094,0.202,0.181,0.352,0.261,0.099,0.052,0.226,0.09,0.384,0.114,0.158,0.031,0.285,0.041,0.392,0.037,0.012,0.151,0.023,0.298,0.033,0.444zm-3.818-3.292c-0.523-1.091-1.07-2.175-1.596-3.271-0.344,1.162-0.715,2.314-1.062,3.473,0.887-0.068,1.77-0.134,2.658-0.202z'/%3E %3Cpath d='m401.43,361.92c-0.147,0.039-0.301,0.08-0.446,0.121-0.172-0.293-0.439-0.573-0.801-0.862-0.361-0.285-0.674-0.41-0.928-0.382-0.131,0.021-0.281,0.045-0.45,0.084-0.175,0.043-0.368,0.09-0.588,0.148-0.478,0.12901-0.953,0.26-1.432,0.389,0.307,1.129,0.612,2.259,0.918,3.384,0.324-0.089,0.654-0.179,0.979-0.26701,0.295-0.08,0.525-0.17,0.671-0.28099,0.141-0.10401,0.263-0.23701,0.341-0.39301,0.056-0.11299,0.096-0.27,0.111-0.47299,0.017-0.198,0.01-0.40601-0.027-0.62301,0.152-0.042,0.305-0.083,0.451-0.12299,0.301,1.109,0.601,2.213,0.898,3.316-0.146,0.039-0.299,0.08-0.45,0.12301-0.058-0.16801-0.157-0.35701-0.283-0.56201-0.136-0.2-0.256-0.34-0.363-0.416-0.157-0.118-0.338-0.18-0.529-0.185-0.202-0.006-0.428,0.033-0.687,0.104-0.325,0.089-0.655,0.179-0.979,0.267,0.264,0.969,0.524,1.934,0.787,2.902,0.035,0.129,0.094,0.241,0.178,0.329,0.077,0.089,0.189,0.142,0.341,0.173,0.068,0.016,0.21,0.01,0.418-0.009,0.209-0.012,0.37-0.039,0.474-0.062,0.037,0.14,0.077,0.283,0.114,0.423-1.233,0.334-2.467,0.67-3.701,1.004-0.037-0.14-0.077-0.283-0.114-0.423,0.12-0.038,0.278-0.098,0.472-0.172,0.191-0.075,0.319-0.127,0.373-0.174,0.106-0.084,0.178-0.188,0.201-0.299,0.023-0.117,0.021-0.244-0.018-0.389-0.55-2.025-1.1-4.053-1.649-6.08-0.034-0.129-0.098-0.238-0.16-0.333-0.072-0.085-0.189-0.138-0.346-0.167-0.121-0.021-0.278-0.023-0.468-0.018-0.201,0.006-0.354,0.024-0.462,0.049-0.037-0.141-0.076-0.283-0.114-0.42399,2.233-0.60501,4.469-1.211,6.696-1.815,0.189,0.706,0.382,1.413,0.572,2.116'/%3E %3Cpath d='m411.29,361.17c0.324,0.80601,0.641,1.615,0.964,2.42-2.08,1.005-4.154,2.006-6.229,3.008-0.063-0.13099-0.128-0.26599-0.191-0.39499,0.088-0.049,0.209-0.125,0.375-0.229,0.156-0.099,0.265-0.181,0.315-0.241,0.091-0.104,0.144-0.212,0.148-0.333,0.004-0.114-0.027-0.241-0.099-0.386-0.906-1.877-1.812-3.754-2.719-5.631-0.062-0.129-0.138-0.225-0.223-0.303-0.089-0.074-0.212-0.11-0.372-0.104-0.104-0.01-0.247,0.006-0.425,0.039-0.178,0.031-0.316,0.068-0.419,0.111-0.062-0.12901-0.128-0.265-0.189-0.395,1.123-0.542,2.24-1.082,3.362-1.624,0.063,0.12999,0.128,0.26499,0.19,0.396-0.106,0.057-0.231,0.137-0.377,0.248-0.154,0.115-0.264,0.20299-0.32,0.268-0.112,0.107-0.16,0.225-0.15,0.352-0.001,0.13099,0.034,0.25599,0.094,0.37699,0.851,1.76,1.7,3.521,2.551,5.283,0.116,0.24,0.217,0.424,0.31,0.54501,0.093,0.127,0.199,0.207,0.324,0.23399,0.113,0.029,0.263,0.01,0.444-0.061,0.182-0.059,0.424-0.162,0.73-0.312,0.139-0.065,0.277-0.14201,0.428-0.21901,0.148-0.077,0.281-0.16599,0.404-0.24799,0.121-0.089,0.224-0.181,0.318-0.272,0.09-0.092,0.149-0.174,0.172-0.262,0.067-0.246,0.132-0.585,0.166-1.035,0.031-0.44099,0.046-0.78699,0.019-1.041,0.134-0.061,0.267-0.126,0.399-0.19001'/%3E %3Cpath d='m415.95,352.52c0.537,0.154,1.054,0.40801,1.527,0.78501,0.479,0.38799,0.896,0.867,1.247,1.461,0.354,0.598,0.571,1.195,0.67,1.795,0.098,0.6,0.062,1.173-0.07,1.723-0.129,0.537-0.369,1.021-0.697,1.469-0.328,0.447-0.742,0.812-1.245,1.107-0.529,0.312-1.073,0.51-1.642,0.572s-1.112,0.029-1.639-0.137c-0.526-0.155-1.026-0.412-1.498-0.799-0.473-0.386-0.874-0.849-1.203-1.404-0.361-0.612-0.582-1.215-0.678-1.811-0.093-0.591-0.062-1.16,0.062-1.714,0.132-0.543,0.378-1.034,0.711-1.485,0.332-0.451,0.742-0.812,1.231-1.101,0.508-0.301,1.042-0.491,1.593-0.562,0.561-0.075,1.103-0.047,1.631,0.101zm2.347,5.807c0.003-0.44201-0.051-0.895-0.206-1.354-0.148-0.459-0.37-0.937-0.666-1.438-0.306-0.516-0.635-0.959-0.989-1.334-0.354-0.369-0.729-0.643-1.104-0.832-0.374-0.188-0.764-0.269-1.158-0.265-0.391,0.001-0.787,0.124-1.169,0.349-0.426,0.252-0.737,0.562-0.918,0.939-0.182,0.375-0.282,0.781-0.277,1.213,0.008,0.418,0.084,0.857,0.245,1.326,0.16,0.471,0.374,0.934,0.646,1.395,0.299,0.506,0.621,0.937,0.949,1.295,0.332,0.355,0.701,0.629,1.083,0.832,0.382,0.201,0.763,0.287,1.163,0.293,0.396,0,0.801-0.113,1.209-0.354,0.38-0.225,0.679-0.525,0.879-0.88,0.198-0.36,0.31-0.757,0.313-1.185z'/%3E %3Cpath d='m429.27,352.37c-0.647,0.45899-1.301,0.922-1.948,1.381-0.896-0.37301-1.697-0.65601-2.383-0.904-0.696-0.246-1.43-0.46001-2.195-0.69501-0.249,0.17601-0.494,0.35-0.743,0.525,0.532,0.749,1.066,1.504,1.602,2.259,0.081,0.11301,0.181,0.19901,0.271,0.265,0.104,0.064,0.231,0.071,0.386,0.035,0.079-0.017,0.198-0.074,0.368-0.16201,0.17-0.088,0.301-0.168,0.411-0.24,0.083,0.11901,0.17,0.24,0.253,0.35701-1.017,0.723-2.034,1.442-3.051,2.163-0.084-0.116-0.17-0.239-0.254-0.356,0.079-0.062,0.186-0.157,0.332-0.287,0.138-0.125,0.229-0.223,0.274-0.295,0.067-0.112,0.103-0.229,0.083-0.346-0.012-0.117-0.063-0.236-0.156-0.367-1.219-1.717-2.437-3.437-3.652-5.152-0.081-0.113-0.172-0.206-0.271-0.273-0.099-0.066-0.226-0.082-0.381-0.037-0.111,0.033-0.24,0.078-0.393,0.146-0.16,0.074-0.281,0.141-0.378,0.203-0.084-0.11701-0.17-0.24-0.254-0.35701,1.11-0.78699,2.219-1.572,3.33-2.361,0.305-0.21499,0.613-0.389,0.924-0.51699,0.315-0.126,0.629-0.20401,0.941-0.216,0.308-0.016,0.596,0.037,0.87,0.16199,0.283,0.12701,0.529,0.346,0.745,0.65,0.198,0.278,0.329,0.547,0.389,0.81901,0.068,0.27099,0.071,0.538,0.016,0.81299-0.045,0.25401-0.149,0.498-0.287,0.76-0.14,0.257-0.307,0.513-0.516,0.771,0.686,0.221,1.262,0.389,1.724,0.54101,0.453,0.15599,1.025,0.326,1.685,0.547,0.291,0.10299,0.535,0.14599,0.724,0.15599,0.185,0.014,0.364,0.004,0.522-0.018,0.12-0.014,0.25-0.066,0.401-0.135,0.151-0.067,0.271-0.139,0.358-0.19401,0.083,0.11901,0.17,0.24001,0.253,0.35901zm-6.435-3.41c-0.306-0.432-0.68-0.678-1.105-0.76199-0.43-0.076-0.874,0.049-1.333,0.375-0.288,0.20299-0.575,0.40699-0.867,0.61399,0.723,1.021,1.442,2.035,2.166,3.056,0.224-0.158,0.446-0.315,0.67-0.475,0.468-0.331,0.761-0.755,0.852-1.271,0.094-0.52-0.024-1.032-0.383-1.537z'/%3E %3Cpath d='m436.56,346.87c0.243,0.822,0.487,1.648,0.735,2.469-2.299,0.85299-4.593,1.703-6.891,2.556-0.051-0.135-0.103-0.274-0.152-0.41,0.116-0.049,0.27-0.122,0.449-0.224,0.185-0.098,0.305-0.164,0.354-0.217,0.101-0.105,0.162-0.21499,0.178-0.321,0.015-0.113-0.002-0.233-0.057-0.379-0.729-1.964-1.454-3.923-2.184-5.888-0.047-0.125-0.114-0.23-0.189-0.315-0.08-0.079-0.201-0.119-0.359-0.136-0.122-0.012-0.279,0-0.467,0.025-0.199,0.021-0.345,0.053-0.455,0.088-0.051-0.135-0.104-0.274-0.152-0.41,2.142-0.795,4.281-1.588,6.422-2.383,0.243,0.656,0.488,1.318,0.731,1.975-0.147,0.056-0.296,0.109-0.438,0.164-0.184-0.27-0.475-0.51-0.849-0.745-0.387-0.239-0.698-0.322-0.945-0.267-0.124,0.029-0.272,0.067-0.441,0.125-0.175,0.06-0.364,0.123-0.581,0.203-0.435,0.161-0.868,0.322-1.302,0.483,0.4,1.082,0.805,2.169,1.205,3.251,0.312-0.115,0.621-0.23,0.938-0.348,0.296-0.109,0.509-0.217,0.63-0.33,0.112-0.104,0.204-0.234,0.258-0.408,0.048-0.145,0.062-0.319,0.056-0.533-0.011-0.208-0.033-0.393-0.077-0.57,0.144-0.053,0.291-0.106,0.438-0.162,0.397,1.071,0.793,2.14,1.19,3.211-0.147,0.056-0.296,0.109-0.438,0.162-0.089-0.178-0.202-0.363-0.343-0.545-0.144-0.175-0.269-0.3-0.383-0.365-0.179-0.104-0.347-0.149-0.518-0.139-0.177,0.008-0.386,0.062-0.638,0.156-0.314,0.117-0.627,0.232-0.938,0.348,0.305,0.822,0.606,1.639,0.912,2.461,0.092,0.244,0.182,0.428,0.271,0.562,0.088,0.133,0.194,0.207,0.321,0.245,0.126,0.039,0.286,0.029,0.466-0.014,0.184-0.051,0.439-0.129,0.761-0.248,0.129-0.049,0.296-0.109,0.509-0.188,0.212-0.078,0.389-0.147,0.523-0.224,0.14-0.073,0.289-0.157,0.432-0.256,0.142-0.104,0.236-0.195,0.271-0.289,0.112-0.252,0.201-0.604,0.255-1.051s0.086-0.768,0.07-0.961c0.141-0.054,0.278-0.105,0.422-0.158'/%3E %3Cpath d='m443.96,340.81c0.438,0.35299,0.814,0.78699,1.099,1.321,0.289,0.543,0.484,1.147,0.574,1.832,0.092,0.688,0.06,1.324-0.087,1.914-0.145,0.58999-0.399,1.104-0.737,1.559-0.324,0.44101-0.739,0.793-1.217,1.076-0.479,0.28301-1.001,0.45501-1.575,0.53101-0.615,0.082-1.192,0.049-1.734-0.11701-0.547-0.164-1.04-0.40599-1.459-0.76599-0.418-0.351-0.782-0.78101-1.061-1.32-0.289-0.539-0.479-1.123-0.562-1.764-0.093-0.70499-0.061-1.347,0.085-1.932,0.146-0.57999,0.402-1.094,0.734-1.553,0.334-0.448,0.749-0.80499,1.23-1.09,0.482-0.28501,1.007-0.45501,1.569-0.53,0.579-0.076,1.146-0.043,1.686,0.106,0.54,0.15199,1.028,0.391,1.455,0.733zm-0.113,6.262c0.18-0.405,0.303-0.843,0.345-1.327,0.038-0.47899,0.021-1.006-0.056-1.584-0.078-0.59401-0.208-1.131-0.389-1.613-0.18-0.47899-0.413-0.879-0.683-1.198-0.276-0.31899-0.599-0.548-0.963-0.697-0.364-0.15099-0.773-0.19399-1.212-0.13699-0.495,0.065-0.903,0.22799-1.218,0.50599-0.313,0.272-0.566,0.606-0.731,1.008-0.15,0.386-0.258,0.82-0.288,1.313-0.041,0.496-0.026,1.007,0.043,1.537,0.077,0.582,0.204,1.104,0.371,1.562,0.161,0.458,0.398,0.853,0.672,1.188,0.267,0.338,0.583,0.563,0.95,0.727,0.365,0.156,0.786,0.209,1.255,0.146,0.438-0.058,0.826-0.217,1.148-0.463,0.324-0.254,0.584-0.574,0.756-0.968z'/%3E %3C/g%3E %3C/g%3E %3Cpath d='m422.97,213.66v55.25c0,10.988-1.525,54.744-48.53,71.738-47.104-16.994-48.63-60.746-48.63-71.738v-55.25h97.16' stroke='%23000' stroke-width='1.01740003' fill='none'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='500'%3E%3Crect width='1000' height='500' fill='%23f00'/%3E%3Crect width='500' height='500' fill='%23fff' x='250'/%3E%3Cpath fill='%23ff0000' d='m 499.99228,46.875 -34.11312,63.62529 c -3.87086,6.91501 -10.80627,6.27363 -17.74169,2.41138 l -24.69699,-12.78858 18.40705,97.72711 c 3.87086,17.85419 -8.54859,17.85419 -14.67765,10.13435 l -43.10105,-48.25099 -6.99738,24.503 c -0.80692,3.21777 -4.35481,6.59744 -9.67748,5.79261 l -54.50177,-11.45912 14.31524,52.04475 c 3.06451,11.58054 5.4549,16.37528 -3.09375,19.42959 l -19.42619,9.13025 93.82127,76.20838 c 3.7135,2.88151 5.58971,8.067 4.26768,12.7621 l -8.21136,26.94707 c 32.30405,-3.72371 61.24898,-9.32594 93.56939,-12.77619 2.85323,-0.30459 7.62988,4.40408 7.61029,7.71058 l -4.28024,98.72342 15.70639,0 -2.47237,-98.5117 c -0.0197,-3.3065 4.31372,-8.22689 7.16695,-7.9223 32.32041,3.45026 61.26538,9.05248 93.56942,12.77619 l -8.21134,-26.94707 c -1.32203,-4.6951 0.55417,-9.88059 4.26767,-12.7621 l 93.82125,-76.20838 -19.42617,-9.13025 c -8.54867,-3.05431 -6.15828,-7.84905 -3.09377,-19.42959 l 14.31527,-52.04475 -54.5018,11.45912 c -5.32267,0.80483 -8.87056,-2.57484 -9.6775,-5.79261 l -6.99737,-24.503 -43.10103,48.25099 c -6.12908,7.71984 -18.54854,7.71984 -14.67768,-10.13435 l 18.40702,-97.72711 -24.69694,12.78858 c -6.93559,3.86225 -13.87083,4.50363 -17.7417,-2.41138'/%3E%3C/svg%3E"

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 10080 5040'%3E %3Cdefs%3E %3Cpath id='Star7' d='M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z'/%3E %3Cpath id='Star5' d='M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z'/%3E %3C/defs%3E %3Crect width='10080' height='5040' fill='%23008000'/%3E %3Ccircle cx='5040' cy='2520' r='1050' fill='%23ffe000'/%3E %3Ccircle cx='5367.4' cy='2520' r='864' fill='%23008000'/%3E %3Ccircle cx='1730' cy='1470' r='1100' fill='%23ffe000'/%3E %3Cpath fill='%23802000' stroke='%237b3100' stroke-width='23.333' d='m1654.1,2299.4,274.67,0s12.398-25.178-2.7658-37.767-74.229-15.36-58.271-59.892c32.807-91.555,37.385-63.326,57.985-280.77s30.518-558.49,30.518-558.49h-39.674s7.6296,106.05-15.259,244.15-29.755,150.3-54.933,256.35-28.992,115.21-51.881,177.01-25.178,64.852-61.037,122.07c-35.859,57.222-22.889,35.859-42.726,70.192-9.9186,17.166-22.126,12.589-28.802,25.082-6.6759,12.494-7.8204,42.058-7.8204,42.058z'/%3E %3Cpath fill='%23008000' d='m1863.7,668.6c2.2817,42.661-2.0069,99.138-19.688,145.1-17.928,51.216-37.423,102.27-36.458,155.31-28.502,9.6945-57.877-61.678-85.312-19.688,20.624,58.016,68.239,103.95,100.86,156.22,5.5021,16.205,52.438,58.518,25.281,68.358-68.547-23.46-85.162-110.31-127.68-163.05-49.38-88.757-141.44-151.49-244-155.82-38.524,1.0094-163.78-9.548-131.19,56.419,47.997,32.632,107.14,53.91,154.53,90.537,35.31,3.3032,99.31,62.248,95.579,84.52-62.102-25.153-91.169-55.299-158.08-81.758-90.658-35.014-216.06-13.954-266.25,76.021-9.3572,23.433-23.172,91.731,6.2547,98.238,34.384-53.685,83.569-113.7,156.45-97.6,57.244,4.4692-63.877,106.64-17.544,86.084,14.681-6.5147,48.583-28.769,72.102-31.093,23.518-2.324,36.653,15.282,54.497,17.718,35.688,4.8718,45.515,19.833,42.207,28.537-3.9027,10.269-15.241,1.5013-51.52,13.004-18.14,5.7513-27.615,21.692-48.774,28.989-21.158,7.2976-65.173,7.8148-81.621,1.3436-57.547-24.996-151.89-20.645-169.83,51.468-0.016,31.711-28.236-3.5038-41.278,10.196-9.7795,34.603-12.309,70.132-63.633,66.99-31.155,32.684-63.06,66.527-102.62,89.781,23.215,53.284,115.2-53.516,110.9-8.4838-40.21,54.832,20.689,66.37,47.348,24.166,45.088-47.64,100.93-105.63,168.21-57.618,32.044,30.169,50.664-15.951,73.857-13.481,14.612,37.475,32.998,1.8444,49.583-8.75,27.15-3.3824,19.511,33.91,51.771,10.938,64.293-42.551,143.39-6.796,206.2-48.197,66.852-30.458,9.3858,24.532-9.0659,46.028-29.373,56.97-3.8997,131.76-67.613,167.14-25.593,67.895,30.237,157.4-26.707,207.63-8.2836,31.496,73.234,27.889,96.113,40.832,40.09,1.5876-1.7229-91.758,38.054-104.27,53.344,33.019,50.846-59.049,39.831-87.447,5.1712-64.552,8.8142-135.13,40.892-193.6,34.102-71.662,65.666,29.186,27.491,57.558-21.685,65.896-53.25,148.36-3.9423,209.64,14.211,3.1803,25.879,37.625,44.279,48.212s43.531-2.6843,48.118-34.022c23.601-94.369,11.712-195.85,45.415-287.63,23.788-28.43,56.603-4.584,71.355,21.559,47.23,54.833,80.43,123.38,137.61,168.56,52.063,24.362,98.106,61.211,122.1,114.81-0.3209,41.353,117.45,47.692,82.258,1.7272-33.768-44.747-11.488-89.504,22.715-119.26,18.318,4.5181,12.904-28.289-1.4583-15.312-22.995-5.4244-24.466-47.512,7.4967-27.507,53.836,17.379-4.197-38.962-23.655-40.69-45.52-28.215-97.819-60.676-120.2-109.72,59.256,0.6043,120.77,32.564,181.32,12.74,48.538-24.937,97.769,2.0801,114.72,44.864,37.52-5.9873,21.524-43.614,0-56.146,27.443-11.325,46.422-34.805,13.147-55.515-17.574-22.934,23.566-62.052-27.001-60.422,1.6515-38.627-13.556-73.973-55.66-87.318-42.178-35.717-165.95,52.62-162.36-27.89-12.471-43.818,50.278-5.8539,67.812-27.708,18.118-46.194-86.337-41.686-51.87-77.5,22.511-14.494,128.15-35.314,45.306-50.82-41.347,11.364-76.832,2.9489-109.37-17.513-29.657,49.603-114.34-26.938-99.252,61.251-11.585,33.23-87.278,119.57-107.76,53.423,17.422-51.845,107.1-68.797,79.291-138.7-4.2682-43.636-40.446,7.5887-57.49,4.335-8.6308-27.162,26.103-59.178,50.312-65.625,48.038,36.948,49.493-46.614,95.178-39.816,33.355-7.4109-10.771-21.718-20.074-27.996,9.1407-24.416,60.346-36.892,10.136-58.094-44.302-32.872-77.138,32.72-113.68,36.218-35.072-39.595,31.842-58.628,50.312-79.479,0.9929-15.543-39.017-4.6894-26.979-18.229,10.456-18.69,81.301-20.081,48.125-48.125-49.965-17.153-114.44-12.876-162.38,9.3461-30.203,9.7774-39.089,78.069-65.122,75.237-12.24-30.398,3.9853-90.372-37.917-99.167zm236.25,667.19c38.072-6.447,0.8081,57.818-17.5,56.875,1.6178-23.092-55.065-20.869-19.897-40.988,11.405-7.3645,24.112-12.982,37.397-15.887z'/%3E %3Cg fill='%23ffe000'%3E %3Cuse xlink:href='%23Star7' x='7560' y='4200'/%3E %3Cuse xlink:href='%23Star7' x='6300' y='2205'/%3E %3Cuse xlink:href='%23Star7' x='7560' y='840'/%3E %3Cuse xlink:href='%23Star7' x='8680' y='1869'/%3E %3Cuse xlink:href='%23Star5' x='8064' y='2730'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='800' height='600'%3E %3Crect width='800' height='600' x='0' y ='0' style='fill:%23007fff' /%3E %3Cpath d='m 36,120 84,0 26,-84 26,84 84,0 -68,52 26,84 -68,-52 -68,52 26,-84 -68,-52 z M 750,0 0,450 0,600 0,600 50,600 800,150 800,0 750,0' style='fill:%23f7d618' /%3E %3Cpath d='M 800,0 0,480 0,600 0,600 0,600 800,120 800,0' style='fill:%23ce1021' /%3E %3C/svg%3E"

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 450 300'%3E %3Crect fill='%23FFCE00' width='450' height='300'/%3E %3Crect fill='%23289728' width='450' height='225'/%3E %3Crect fill='%23FFFFFF' width='450' height='150'/%3E %3Crect fill='%23003082' width='450' height='75'/%3E %3Crect x='187.5' fill='%23D21034' width='75' height='300'/%3E %3Cpath fill='%23FFCE00' d='M75.028,7.004L94.9,67.996L42.902,30.333h64.197L55.1,67.996L75.028,7.004z'/%3E %3C/svg%3E"

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 3 2'%3E %3Crect id='green_area' width='3' height='2' fill='%23009543'/%3E %3Cpath id='yellow_area' d='M 0 2 L 2 0 h 1 v 2 z' fill='%23FBDE4A'/%3E %3Cpath id='red_area' d='M 3 0 v 2 h -2 z' fill='%23DC241F'/%3E %3C/svg%3E"

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='320' height='320'%3E %3Crect fill='%23D52B1E' height='320' width='320'/%3E %3Crect fill='%23fff' height='60' width='200' x='60' y='130'/%3E %3Crect fill='%23fff' height='200' width='60' x='130' y='60'/%3E %3C/svg%3E"

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect fill='%23009E60' width='450' height='300'/%3E %3Crect fill='%23FFF' width='300' height='300'/%3E %3Crect fill='%23F77F00' width='150' height='300'/%3E %3C/svg%3E"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300'%3E %3CclipPath id='cp'%3E %3Cpath d='M0,0V75H350V150H300zM300,0H150V200H0V150z'/%3E %3C/clipPath%3E %3Crect width='600' height='300' fill='%2300247d'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23cf142b' stroke-width='30'/%3E %3Cpath d='M300,0V150H0V300H600V0z' fill='%2300247d'/%3E %3Cg transform='translate(450,150)'%3E %3Cg id='s1' transform='translate(0,-102)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-22.5V0H12' transform='rotate(18,0,-22.5)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cg id='s7'%3E %3Cuse xlink:href='%23s1' transform='rotate(24)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(48)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(72)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(96)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(120)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(144)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(168)'/%3E %3C/g%3E %3Cuse xlink:href='%23s7' transform='rotate(168)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1500' height='1000' viewBox='-4 -4 24 16'%3E %3Cpath d='M20,12H-4V-4H20z' fill='%23d52b1e'/%3E %3Cpath d='M4,4H20V-4H-4z' fill='%23fff'/%3E %3Cpath d='M4,4H-4V-4H4z' fill='%230039a6'/%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-2V0H1z' fill='%23fff' transform='rotate(18,0,-2)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/svg%3E"

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='400' viewBox='0 0 90 60'%3E %3Crect width='30' height='60' fill='%23007a5e'/%3E %3Crect x='30' width='30' height='60' fill='%23ce1126'/%3E %3Crect x='60' width='30' height='60' fill='%23fcd116'/%3E %3Cg transform='translate(45,30)' fill='%23fcd116'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-8 v 8 h 4 z' transform='rotate(18 0,-8)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 30 20'%3E %3Cdefs%3E %3Cpath id='s' d='M0,-1 0.587785,0.809017 -0.951057,-0.309017H0.951057L-0.587785,0.809017z' fill='%23ffde00'/%3E %3C/defs%3E %3Crect width='30' height='20' fill='%23de2910'/%3E %3Cuse xlink:href='%23s' transform='translate(5,5) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(10,2) rotate(23.036243)'/%3E %3Cuse xlink:href='%23s' transform='translate(12,4) rotate(45.869898)'/%3E %3Cuse xlink:href='%23s' transform='translate(12,7) rotate(69.945396)'/%3E %3Cuse xlink:href='%23s' transform='translate(10,9) rotate(20.659808)'/%3E %3C/svg%3E"

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 6 4'%3E %3Crect fill='%23CE1126' width='6' height='4'/%3E %3Crect fill='%23003893' width='6' height='3'/%3E %3Crect fill='%23FCD116' width='6' height='2'/%3E %3C/svg%3E"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='1000' height='600' viewBox='0 0 10 6'%3E %3Cpath d='M0,0h10v6H0z' fill='%23002b7f'/%3E %3Cpath d='M0,1h10v4H0z' fill='%23fff'/%3E %3Cpath d='M0,2h10v2H0z' fill='%23ce1126'/%3E %3C/svg%3E"

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.1' width='800' height='400'%3E %3Cpath d='M0,0h800v400H0z' fill='%23002a8f'/%3E %3Cpath d='M0,80h800v80H0v80h800v80H0z' fill='%23fff'/%3E %3Cpath d='M346.4,200L0,0v400z' fill='%23cf142b'/%3E %3Cpath d='M115.5,140l35.35,108.5 l-92.5-67h114.2l-92.5,67z' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='510' height='300'%3E %3Crect width='510' height='300' fill='%23003893'/%3E %3Crect width='510' height='75' y='150' fill='%23fff'/%3E %3Crect width='510' height='25' y='175' fill='%23cf2027'/%3E %3Cg fill='%23f7d116' transform='translate(191.25,187.5)'%3E %3Cg id='s2'%3E %3Cg id='s' transform='translate(0,-75)'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-15V0H7.5' transform='rotate(18,0,-15)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='150'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='rotate(72)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(144)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(216)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 54 36'%3E %3Crect width='54' height='36' fill='%23002b7f'/%3E %3Cpath d='M0,22.5H54V27H0z' fill='%23f9e814'/%3E %3Cg fill='%23fff' id='s'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='m12,8v4h2z' transform='rotate(18,12,8)' id='o'/%3E %3Cuse xlink:href='%23o' x='-24' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72,12,12)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72,12,12)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144,12,12)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' x='-4' y='-4' transform='scale(0.75)'/%3E %3C/svg%3E"

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='500'%3E %3Crect width='1000' height='500' fill='%230021ad'/%3E %3Cpath d='M0,0H1000V500z' fill='%231c8a42'/%3E %3Ccircle cx='500' cy='250' r='90.32' fill='%23ffc639'/%3E %3Cpath fill='%231c8a42' d='m444.84,209.43c6.1786,8.4767,15.542,22.689,23.072,18.979,5.8763,0.0202,8.9102,0.43341,9.7064,4.3442,13.859,2.3586,37.153-3.4875,51.647-22.366,0,0,1.2196,0.16127,0.79627-7.0152,0.0806-3.1246,4.2736-2.4997,4.3744-1.4817,0.5846,1.5522,0.4838,2.7114,1.27,2.7517,1.784-0.59468,4.2233-4.5962,6.2694-7.1362,0.55436-1.1188,0.25198-2.2981,0.38301-3.7092,1.0785-2.6509,3.7697-2.0763,4.3341-0.68539,0.51404,0.89706,0.52412,1.5825,1.0281,2.4795,2.7315,1.8244,7.6603,0.12095,8.0433,0.12095,0.48381-2.2275,1.9151-2.0159,1.9151-2.0159,1.8244-0.40317,1.1087-0.24191,2.3082,0.38302-1.0583,12.005,2.3586,12.539,2.0764,18.697,0.12095,6.8741-2.0764,8.8295-2.0764,11.45,0.69548,3.2052,10.835,3.3161,7.2672,6.0275-3.1347,1.6732,0.0101,4.8078-4.7071,6.0275-13.728,6.9648-16.359,12.942-16.359,12.942s-3.4471,6.5113-3.8302,6.5113c-2.2981,4.3442-5.211,1.9756-6.8338,4.0922-0.80635,2.661-1.7135,8.5574-0.1008,11.622,0.80635,4.2132-0.10079,6.5113-1.1087,10.724-0.90714,8.7892-4.3946,10.12-4.7978,13.204-1.6127,3.296,0.3427,18.778-1.1894,18.778-10.22,0.20159-18.052-1.9554-22.094-2.7617,3.941-16.984,2.409-31.901,2.409-33.433-1.0079-12.146-18.193-9.1924-20.824-10.805-2.1772-0.46366-3.5479-2.2376-4.314-3.0036-2.4291-0.26207-3.3363-0.81643-5.7654-1.0684-1.2095,0.60477-0.48381,1.2297-3.1851,2.0663-6.854,0.82651-9.8778-5.9771-9.8778-5.9771,0.33262-2.288-15.411,0.46365-23.969-1.522-3.5076,1.9554-5.0397,7.741-7.9123,8.4263-0.0806,1.7941-4.7272-1.4716-5.6646-3.2355-0.19151-5.1304,4.4752-7.3982,4.4752-7.3982,3.7092-2.6106,5.9065-3.0339,7.6906-4.8381,0.89706-4.4652,0.44349-7.7712,2.3485-11.128,1.6127-2.5602,3.9914-1.3607,5.6041-2.5098,1.7336-1.149,2.4694-8.6682,0.86683-10.724,0,0-6.9346-6.2593-7.3176-6.6423-2.2578-6.4709,2.6408-10.644,4.0418-10.17z'/%3E %3Cpath fill='%23ffc639' d='m877.93,97.555c-4.0922-16.194-40.721-51.071-68.247-73.265-6.5717-4.4773-10.855-1.8103-9.9987,4.573,3.427,5.716,5.9972,12,9.4242,17.716,0.95754,3.81,2.7618,6.477,3.7193,10.286,0,0,0.28222,6.5728,0.85674,7.1442,8.5675,9.4333,9.7165,17.432,9.7165,17.432,4.949,9.526,9.3335,16.478,18.002,24.29,9.7165,6.098,2.5702,25.047,2.8525,35.147,0,6.3802-4.566,5.6243-8.5674,4.8582-31.528-28.958-62.774-29.049-90.301-37.435-10.765-1.139-10.956,4.0015-7.4285,6.854,19.242,20.582,37.334,34.582,61.151,46.294,4.0015,2.4795,8.003,4.959,12.005,7.4386,4.566,3.81,9.142,7.62,13.708,11.43,10.573,6.854,11.44,13.143,11.44,13.708,0.28222,12.861-6.5818,22.86-8.5775,26.861-3.6084,13.637-10.855,16.006-10.855,16.006-58.874,39.723-89.737,50.004-185.18,37.717-1.4313-0.75595-10.573,0.76603,0,4.576,24.291,8.0937,83.961,21.076,141.69-6.2593,13.859-9.7165,23.132-6.5314,33.171-12.347,16.49-10.17,40.035-22.83,44.319-24.251,12.861-6.864,48.865-14.575,57.16-21.439,9.5149-0.76603,19.393-2.0159,20.058-10.2,3.1246-2.026,7.7006-0.54428,11.097-7.2168,7.5494-1.3103,6.2794-4.0116,6.2794-4.0116-1.905-5.332-8.9606-7.5293-14-11.43-7.4386-2.4795-12.579-3.2456-18.012-0.57452-1.7135,0.76603-3.427,1.522-5.1405,2.288,0,0-8.003-1.149-8.003-1.7135-17.78-0.9777-16.046-59.902-22.336-84.478z'/%3E %3Cpath fill='%231c8a42' d='m919.63,194.01a4.4025,2.7511,15.947,0,1,-8.3961,-2.6368,4.4025,2.7511,15.947,0,1,8.3961,2.6368z'/%3E %3Cg fill='%23fff'%3E %3Cpath id='s' d='m188.16,190.94-12.751-11.936-12.904,11.77,1.383-17.405-17.249-2.753,14.475-9.7743-8.6056-15.197,16.668,5.2197,6.5177-16.204,6.3099,16.287,16.734-5.0072-8.8005,15.086,14.348,9.959-17.283,2.5313,1.1585,17.424z'/%3E %3Cpath d='m233.39,335.53-13.752-9.1669-13.391,9.6641,4.7117-15.568-13.582-9.4155,16.667-0.44539,4.9883-15.496,5.5945,15.299,16.667-0.15537-13.21,9.9023,5.3073,15.382z'/%3E %3Cuse xlink:href='%23s' x='2.5215' y='269.0608'/%3E %3Cuse xlink:href='%23s' x='-112.0655' y='123.2228'/%3E %3Cuse xlink:href='%23s' x='108.4275' y='85.0268'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23fff'/%3E %3Cpath id='branch' fill='%23435125' d='m434.8,498.25c-0.18-0.086-0.218-0.122-0.347-0.245l-0.125-0.117c-0.324-0.297-0.861-0.822-1.582-1.643-1.332-1.513-3.119-3.728-4.69-5.685-3.115-3.883-5.689-7.228-6.174-7.858l-0.793-1.032-7.767-2.395-5.671-2.644,3.03-3.406,10.408,4.456,7.767,1.594,14.363,10.564-0.011,0.009c-0.029,0.024-2.089,1.738-4.136,3.599-0.913,0.83-2.064,1.896-2.877,2.783-0.375,0.408-0.705,0.813-0.93,1.14-0.138,0.201-0.215,0.383-0.252,0.471l0.892-0.555,0.967,0.752-1.968,0.184-0.09,0.02zm-53.34-16.02c-6.777-0.001-13.471-1.874-19.895-5.567l-0.007-0.004,0.003-0.008s0.84-1.601,2.878-3.096c1.941-1.425,5.442-3.128,11.1-3.15h0.117c6.701,0,14.901,2.278,24.373,6.771-0.32,0.212-7.756,5.054-18.566,5.054l0.01,0.01zm-29.37-6.51c-1.253,0-2.379-0.474-3.17-1.333-0.649-0.706-1.114-1.646-1.422-2.878-0.504-2.018-0.365-4.025-0.351-4.217,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.511,0,4.49,2.178,5.338,4.337,0.481,1.227,0.574,2.259,0.274,3.067-0.3,0.81-1.24,1.37-2.34,1.37zm51.68-5.99c-17.359-2.479-24.717-8.755-27.833-13.583-3.323-5.149-2.641-9.912-2.634-9.96l0.003-0.014,0.013-0.004c0.005,0,1.061-0.285,2.658-0.293,4.618,0,16.43,2.323,27.798,23.842l0.007,0.014-0.02-0.01zm-35.58-3.44c-7.416-0.001-13.062-1.28-16.782-3.804-2.138-1.45-3.184-3.043-3.686-4.125-0.47-1.014-0.577-1.856-0.594-2.023,0.196-0.09,3.232-1.438,7.765-1.65,0.383-0.018,0.769-0.029,1.174-0.03,5.732,0,14.448,1.87,23.646,10.78l0.009,0.009-0.011,0.001c-4.2,0.55-8.08,0.84-11.53,0.84zm-35.91-1.38c-7.82,0-18.563-2.388-25.263-9.087l-0.007-0.008,0.02-0.005c0.07-0.018,7.342-1.863,15.523-2.062,0.488-0.012,0.979-0.019,1.475-0.019,7.332,0,12.944,1.422,16.682,4.225,1.305,0.979,2.018,1.89,2.178,2.783,0.134,0.746-0.26,1.55-1.056,2.15-1.683,1.271-4.692,1.949-8.945,2.017l-0.6,0.02zm-25.34-13c-0.963,0-1.867-0.426-2.479-1.167-0.506-0.614-0.858-1.416-1.108-2.522-0.418-1.848-0.292-3.656-0.291-3.674l0.001-0.018c0.364-0.172,0.771-0.264,1.217-0.275h0.003c1.157,0,2.039,0.63,2.589,1.158,0.733,0.705,1.333,1.645,1.688,2.645,0.365,1.03,0.424,1.892,0.18,2.635-0.2,0.59-0.88,1.21-1.8,1.21zm58.53-1.32c-1.253,0-2.379-0.474-3.17-1.333-0.649-0.706-1.114-1.646-1.422-2.878-0.504-2.018-0.365-4.025-0.351-4.217,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.511,0,4.49,2.178,5.338,4.337,0.481,1.227,0.574,2.259,0.274,3.067-0.3,0.82-1.25,1.37-2.34,1.37zm-28.51-1.18c-15.737-0.554-23.904-5.027-27.984-8.683-2.297-2.058-3.574-4.098-4.24-5.447-0.628-1.274-0.866-2.249-0.908-2.438l0.021-0.009c0.003,0,1.489-0.532,3.885-0.579l0.368-0.004c5.307,0,16.111,2.229,28.852,17.153v0.01zm17.09-1.59c-12.661-1.928-19.834-7.363-23.622-11.585-3.971-4.425-5.16-8.546-5.213-8.738,0.023-0.007,1.57-0.41,3.9-0.469,0.169-0.005,0.345-0.007,0.524-0.007,0.181,0,0.365,0.002,0.553,0.007,6.368,0.139,17.934,3.023,23.855,20.785h0.01zm-65-6.08c-4.149,0-8.174-0.48-11.962-1.427-6.629-1.658-9.473-4.189-10.691-6.021-0.692-1.04-0.943-1.952-1.031-2.534-0.085-0.556-0.04-0.999-0.031-1.073l0.031-0.011c0.017-0.004,4.4-1.235,10.464-1.328,0.239-0.004,0.48-0.006,0.725-0.006,2.927,0,5.808,0.279,8.564,0.83,10.536,2.107,16,10.06,16.053,10.14l0.005,0.009-0.013,0.003c-0.06,0.01-5.08,1.42-12.12,1.42zm29.39-10.68c-1.269,0-2.395-0.463-3.172-1.304-0.639-0.691-1.104-1.643-1.42-2.908-0.506-2.015-0.365-4.002-0.351-4.185,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.506,0,4.488,2.179,5.339,4.338,0.468,1.188,0.55,2.208,0.243,3.034-0.31,0.84-1.22,1.38-2.31,1.38zm-22.1-3.03c-0.095-0.023-5.977-1.536-11.967-5.225-5.544-3.413-12.326-9.45-13.153-18.83v-0.005l0.014-0.004c0.001,0,0.516-0.125,1.278-0.154,0.105-0.004,0.217-0.006,0.334-0.006,1.656,0,5.046,0.466,9.147,3.584,5.22,3.98,10.04,10.92,14.35,20.65zm14.43-0.53c-0.037-0.015-4.229-1.693-9.469-6.084-4.882-4.092-11.746-11.46-16.716-23.33,0.003-0.001,1.142-0.608,2.886-0.718,0.101-0.007,0.203-0.009,0.306-0.009,0.15,0,0.305,0.005,0.463,0.009,2.411,0.068,6.083,1.07,10.154,5.463,4.676,5.047,8.85,13.34,12.404,24.651l0.01,0.032-0.03-0.01zm-37.39-1.09c-4.821,0-6.471-2.615-6.957-3.74-0.798-1.849-0.556-3.689-0.554-3.707l0.003-0.02c0.78-0.195,1.605-0.303,2.398-0.314l0.165-0.001c3.799,0,6.798,1.929,8.084,3.841,0.255,0.379,1.037,1.694,0.39,2.721-0.52,0.81-1.7,1.22-3.53,1.22zm-10.68-13.47c-2.692,0-6.811-0.165-11.141-0.952-4.294-0.781-6.728-4.432-8.013-7.356-1.399-3.185-1.794-6.223-1.798-6.254h0.012c13.282,0.39,19.555,4.271,22.478,7.457,3.018,3.29,3.197,6.706,3.206,6.922l-0.009,0.001c-0.02,0-1.89,0.18-4.74,0.18zm13.83-13.82c-0.018-0.022-1.535-1.898-3.033-4.228-1.573-2.445-3.028-4.996-3.028-7.084,0-2.016-0.474-6.266-0.757-8.619-0.358-2.985-0.72-5.54-0.75-5.757l0.013,0.004c0.337,0.123,8.308,3.114,8.308,10.591,0,7.489-0.738,15.014-0.745,15.089l-0.001,0.011h-0.01zm-10.33-0.71c-0.084,0-0.167-0.008-0.25-0.021-2.356-0.393-6.496-2.194-11.073-4.818-5.082-2.914-9.209-6.036-11.62-8.791-2.198-2.512-3.503-6.457-3.88-11.726-0.267-3.739,0.053-6.854,0.087-7.163,0.412-0.137,0.85-0.204,1.315-0.204,1.764,0.029,3.647,0.823,6.189,2.574,1.981,1.365,4.165,3.221,6.49,5.514,4.012,3.957,7.168,7.932,7.199,7.971l0.032,0.04c0.265,0.475,2.537,4.571,4.307,8.558,1.124,2.532,1.767,4.357,2.024,5.746,0.147,0.791,0.19,1.31-0.004,1.781-0.081,0.195-0.235,0.376-0.385,0.448-0.14,0.06-0.28,0.09-0.44,0.09z'/%3E %3Cuse xlink:href='%23branch' transform='matrix(-1,0,0,1,842.178,0)'/%3E %3Cpath fill='%23d47600' d='m698.83,95.476l-2.355,0.938-0.923,0.368-2.854-0.157-2.673,1.283-4.74,3.239-0.209,0.15-1.767,0.461-1.641-0.708-0.932,0.424-0.321,1.92-0.887,1.379-1.092,0.767-3.783,0.387-3.19,1.645-4.15-1.111-1.928,0.755-4.099,3.692-2.095,0.992-0.732-0.042-2.778-0.143-1.173,0.384-1.752,1.693-3.315,0.258-1.033,0.715-1.618,3.26-1.753,1.808-1.003,0.212-1.087-0.398-0.817,0.144-0.37,2.086-0.793,0.874-2.219,0.764-1.773,1.477-1.556,0.799-2.084-0.052h-0.479l-2.076,1.146-3.905,0.342-1.624,1.549-0.358,0.331-0.758,0.458-1.24,0.74-0.304,0.184-1.495-0.267-1.75,0.693-0.708-1.089-1.211,0.727-1.604,0.069-1.998-0.889-1.522-0.678-1.113,0.161-0.387,1.94-0.039,0.206-1.17,1.557-2.184,1.323-0.297,0.387-2.485,3.208-4.722,4.966-3.993,2.028-4.139,1.259-2.897,2.38-7.599,3.767-11.994,5.967-2.453,0.786-3.52,0.562-6.278,2.312-5.539,1.671-0.308,0.094-1.096,0.332-7.81,2.363-3.635-0.384-2.153,0.782-5.605-0.622-3.897,0.077-2.467,0.513-4.637,2.224-7.827,3.762-2.586,2.366-4.027,2.101-4.715,1.493,0.011-1.981-0.028-0.084-1.636,0.517-1.181,0.373-3.825,0.59h-2.128l-1.321-0.384-0.204,0.069-7.818,2.576-8.719,0.842-4.363,1.399-3.26-0.052-2.038,0.607-3.995,0.488-1.428-0.381-0.322-0.088-11.75,0.51-5.372-0.607-2.564,0.583-4.296-1.445-6.269-0.727-1.465-0.439-3.295-0.978-1.491,0.859-1.116,0.119-2.667-0.967-0.96-0.025-2.202,0.796-1.267-0.325-1.177-0.938-2.761-0.411-1.682-1.414-9.402,1.246-2.551-0.75-8.554-2.492-1.361,0.069-1.696,1.271-2.548,0.929-2.212,0.575-3.012,0.105-3.497-0.918-3.606-1.748-1.333-0.317-2.974,0.3-0.91,0.083-5.466-2.932-7.042-4.404-4.778-2.296-1.794-0.291-0.241,0.853,0.89,2.805,0.303,2.774-0.091,2.563-0.049,1.587,0.446,1.425,1.725,1.912,0.719,1.92,0.526,5.284-0.006,5.362-0.839,8.551-0.283,1.302-1.001,4.43-0.914,4.069-3.546,10.833-0.974,1.343-2.391,1.631-5.419,3.688-3.99,2.301-1.263,0.523-3.239,0.245-2.018-0.105-2.513-1.361-2.467-0.635-3.232-2.324-3.595-0.744-3.941-2.278-1.026-1.233-2.146-0.202-2.976-0.893,0.002-0.005-1.093-0.327-0.755-0.22v-0.001l-3.796-0.104-3.54-1.634-1.864-0.45-2.547-0.129-2.666,1.239-0.001-0.004-1.351,0.629-1.707-0.678-1.235,0.077-1.399,2.115-0.209,0.328-0.964,0.51-1.2-0.017-0.939-0.025-1.016,0.444-1.368,0.593v0.003l-1.208,0.527-0.59,0.255-0.01-0.01-0.363,0.073-0.645,0.112-0.8,0.153-1.41-0.824-0.75-0.442-1.257-0.256-0.677,0.489-0.133,2.301-0.618,1.378-1.961,1.734-1.993,1.755-1.389,2.047-3.676,8.39-2.303,3.385-0.715,0.789-2.408,2.656-2.136,1.657-4.922,3.815-4.659,1.741-4.013,0.82-1.951,0.008-3.696-0.492-3.323-1.02-3.65-2.282-4.003-3.217-5.794-5.724-0.82-0.493-0.171-0.114-1.825-1.167-1.354,0.035-0.53,0.874-0.29,1.263-0.245,1.12-0.664,6.367,0.049,0.369,0.349,2.622,4.401,6.15,1.358,3.267,0.223,0.373,0.908,1.525,0.691,1.163,0.069,0.118,1.504,4.488-1.057,2.534,0.534,1.697-1.336,1.037-0.245,1.465,3.951,4.953,0.862,2.185-0.963,3.029-1.536,1.671-0.429,0.457,0.216,1.28,1.818,1.635,3.089,2.75,1.647,4.086,1.253,1.096,1.456-0.31,0.81,0.618,1.228-0.021,1.208,1.208,0.782,0.379,1.236,0.616,0.977,1.272,0.216,3.911,1.822,4.86,0.028,2.635,0.01,0.374,1.134,1.948,0.356,1.538-0.604,4.069,1.445,1.306,1.567-0.32,1.012,0.16,1.626,1.354,1.969,3.001,1.926-0.282,1.222,0.589,5.902,5.334,1.339,0.676,0.074,0.042,0.963,0.483,1.197,1.208,1.856-1.232,0.206-0.021,2.018-0.178,0.886,0.597,1.704,1.149,2.234-0.029,4.844,1.485,2.119,0.543,4.261,2.648,1.811,1.12,1.072,0.871,1.424,1.161,2.845,1.224,2.44,0.584,1.322,0.314,0.995,0.384,0.025-0.062,0.014,0.004-0.024,0.063,5.284,2.023,2.862,0.668,2.648,0.975,1.927,0.703,1.414,0.023,2-1.682,1.937-0.112,1.609,0.401,1.57-0.263,2.485-1.531,0.485-0.719,1.762-0.839,5.944-0.738,1.737,0.564,4.46-1.94,2.988,0.831,2.645-0.938,5.779,1.284,1.536,1.081,1.717,1.965,0.21,0.009,1.912,0.037-0.799,1.331,2.523,2.647,2.279,3.445,0.154,0.455,1.657,4.864,1.232,1.723,0.862,2.405,0.042,1.568-1.34,1.022-0.22,0.583-0.076,0.216,0.272,0.655,0.506-0.276,0.963-0.533,1.166-0.181,2.066,0.22,1.364,0.143,2.154-1.069,1.427-0.71,2.293,0.987,2.52-0.028,1.058,0.471,2.995,1.358,1.529,0.144,0.565-0.371,0.36-0.856-0.185-0.996-1.145-1.323-2.531-2.938-1.036-1.51-0.789-2.186-0.245-2.794-0.174-1.885,0.314-2.477,0.68-0.884,0.5-1.968h0.009l0.129-0.515,1.406-1.866,3.724-2.393,4-3.582,3.162-2.085,3.26-1.412,0.087-0.396,0.363,0.146,8.292-2.819,0.137-0.016,3.692-0.643,24.92,1.755,0.924-0.279,0.004-0.006,0.83-2.33,0.447-0.432,0.297-0.282,2.74-1.206,1.281-0.183,3.556,0.878,1.456,0.359,2.332-1.307,1.654,0.028,3.417-1.866,2.111,0.053,0.803-0.321,4.112-2.955,3.961-1.135,1.03-0.548,0.363-0.199,4.06-2.144,2.579-1.981,2.226-1.183,2.438-0.629,6.38-0.449,1.283-2.138,2.744-0.366,1.657-1.87,1.896-0.771,1.359-1.958,1.139-1.641,1.591-0.921,5.1-0.32,6.045,0.749,0.799-0.485,1.366-4.875,1.43-0.915,3.851-5.612,0.013-2.045,0.004-1.708,0.633-2.432-0.43-4.391,0.51-4.446,2.394-5.65,2.109-2.279,3.401-2.301,1.729-0.753,2.449-0.412v-0.006l0.36-0.061,0.624-0.107,8.433-0.116c0.117-0.087,3.067-0.042,3.067-0.042l2.812-0.038,7.114,1.266,0.506,0.088,2.405,0.779,2.774,2.157,2.936,2.868,0.551,0.535,1.902,0.801,0.575,0.251,1.571-0.251,2.237-1.165,1.688-1.427,2.301-1.257,0.056-0.08,1.295-1.948,0.039-0.04,0.028,0.007,0.003-0.011-0.022-0.005,0.511-0.775,4.447-1.733,5.23-0.304,0.588-0.318,0.327-0.175,1.382-1.623,1.295-0.011,3.135,1.134,2.204-0.437,1.75,0.699,1.36-0.161,2.565-0.304,2.754,1.938,1.605,0.205,5.658,3.31,0.294,0.048,0.152,0.028,0.324,0.053,0.671-0.199,0.998-0.289,0.132-0.039,0.126,0.174,0.643,0.907,0.882,0.126,1.044-1.393-0.415-0.632-0.157-0.23-2.021-0.411-1.815-3.103,1.728-1.861-2.711-3.326-0.45-0.551-0.153-0.234-0.937-1.423-4.746-7.235-6.182-4.935-0.002,0.004-2.165-1.732-0.014-0.01-0.758-0.596-3.302-3.358-2.358-3.13-0.309-0.674-0.487-1.062-1.413-3.078-2.462-1.896-2.006-2.191-0.098-0.129-4.14-5.626-0.68-0.943-0.978-0.565-2.066-0.014-0.195-0.196-0.116-0.121,0.07-0.074,0.991-0.985,1.105-0.278,0.476-1.089-2.108-6.104-0.014-0.213-0.157-1.95,1.718-8.855,0.22-1.079,2.928-5.958,1.814-1.486,1.98-3.892,1.696-2.488,1.625-1.582,0.284-0.168,2.934-1.776,2.465-0.347,2.348-0.331,4.099,1.264,3.901-0.076,0.761-0.081,1.77-0.203,2.911-0.917,1.374-0.848,0.713-1.093,1.487-4.987,0.478-1.587,0.917-1.724,5.306-6.108,4.011-3.71,9.019-6.613,4.415-2.639,2.254-1.347,20.126-8.946,5.23-5.302,2.725-2.757,4.821-3.235,5.641-2.311,4.854-3.842,1.06-1.334,1.336-4.303,1.113-0.269,1.005-2.174,0.286-0.618,3.961-2.792,0.448-0.223,15.388-7.71,2.236,0.307,1.197-1.793,4.477-0.751,0.824-0.14,1.104-0.551,0.939-1.599v-0.316l0.129-4.273,0.956-1.155,0.521-2.816,0.491-0.65,0.513-0.676,1.268-0.891-0.22-0.531z'/%3E %3C/svg%3E"

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23d7141a'/%3E %3Crect width='900' height='300' fill='%23fff'/%3E %3Cpath d='M 450,300 0,0 V 600 z' fill='%2311457e'/%3E %3C/svg%3E"

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='600' viewBox='0 0 5 3'%3E %3Cdesc%3EFlag of Germany%3C/desc%3E %3Crect id='black_stripe' width='5' height='3' y='0' x='0' fill='%23000'/%3E %3Crect id='red_stripe' width='5' height='2' y='1' x='0' fill='%23D00'/%3E %3Crect id='gold_stripe' width='5' height='1' y='2' x='0' fill='%23FFCE00'/%3E %3C/svg%3E"

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 15 10'%3E %3Crect width='15' height='10' id='blue' style='fill:%236ab2e7'/%3E %3Crect width='15' height='5' y='5' id='green' style='fill:%2312ad2b'/%3E %3Cpath d='M 0,0 0,5 0,10 4.330127,7.5 8.660254,5 4.330127,2.5 0,0 z' id='path6904' style='fill:%23fff'/%3E %3Cpath d='m 3.3143278,3.75 0.3102707,0.954915 1.0040571,0 L 3.8163564,5.295085 4.126627,6.25 3.3143278,5.65983 2.5020286,6.25 2.8122992,5.295085 2,4.704915 l 1.004057,0 L 3.3143278,3.75 z' id='path6929' style='fill:%23d7141a'/%3E%3C/svg%3E"

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='370' height='280'%3E %3Crect width='370' height='280' fill='%23c60c30'/%3E %3Crect width='40' height='280' x='120' fill='%23fff'/%3E %3Crect width='370' height='40' y='120' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Ctitle%3EFlag of Dominica%3C/title%3E %3Crect height='600' width='1200' fill='%23006b3f'/%3E %3Crect width='75' height='600' x='525' fill='%23fcd116'/%3E %3Crect width='1200' height='75' y='225' fill='%23fcd116'/%3E %3Crect width='75' height='600' x='600' fill='%23fff'/%3E %3Crect width='1200' height='75' y='300' fill='%23fff'/%3E %3Crect width='50' height='600' x='575' fill='%23000'/%3E %3Crect width='1200' height='50' y='275' fill='%23000'/%3E %3Cg fill='%23006b3f' transform='translate(600,300)'%3E %3Ccircle r='150' fill='%23d41c30'/%3E %3Cg id='star2'%3E %3Cpath id='star' stroke='%23000' d='m-4.81,-118.41 4.81,-13.72 4.37,13.5 14.65,0.22 -11.59,8.85 5.25,15.05 -12.68,-9.29 -12.46,8.85 4.81,-14.61 -11.37,-8.63 14.21,-0.22z'/%3E %3Cuse xlink:href='%23star' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23star2' transform='rotate(36)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(72)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(108)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(144)'/%3E %3Cg stroke='%23000' stroke-width='2.5'%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.289553,-0.03018225,0.01658794,0.23225804,-186.11735,-75.926206)'/%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.30625538,-0.03184484,0.01668502,0.23224838,-188.73313,-74.886801)'/%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.24500433,-0.0258909,0.01789798,0.25675005,-151.94706,-90.935577)'/%3E %3Cpath fill='%239c4a00' stroke-width='0.6573' d='m-44.213085,62.564681c7.657331,-0.318514 4.332103,-4.415732 8.199242,-6.595651 3.864538,-2.177268 9.365358,-0.736785 11.015564,1.985834 1.650207,2.72262 0.327013,5.396731 2.450471,5.433299 2.12601,0.03661 59.928115,-2.387638 62.010231,-0.105265 2.084719,2.27972 2.428307,6.775972 0.269442,8.524141 -2.159263,1.769736 -75.234738,2.587907 -77.751167,0.737649 -2.516925,-1.823297 -6.202071,-9.529768 -6.193783,-9.980007z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M-3.3768912,68.194919C-3.5157446,73.97045 5.0266835,72.334565 5.1440072,77.158287 4.886691,82.271863 -9.1802916,77.470843 -9.3156063,68.11661 -8.7307374,58.771874 5.0382371,54.154377 5.208533,59.491796c0.1266662,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M1.6637058,68.261384C1.5248524,74.036915 10.067281,72.40103 10.184604,77.224752 9.927288,82.338328 -4.1396946,77.537308 -4.2750093,68.183075 -3.6901404,58.838339 10.078834,54.220842 10.24913,59.558261c0.126666,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M7.0709208,68.057753C6.9320674,73.833284 15.474496,72.197399 15.591819,77.021121 15.334503,82.134697 1.2675204,77.333677 1.1322057,67.979444 1.7170746,58.634708 15.486049,54.017211 15.656345,59.35463c0.126666,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='m12.111394,68.124255c-0.138854,5.775532 8.403575,4.139646 8.520898,8.963369C20.374976,82.2012 6.3079934,77.40018 6.1726787,68.045947 6.7575476,58.701211 20.526522,54.083714 20.696818,59.421133c0.126666,4.435124 -8.446571,2.927591 -8.585424,8.703122z'/%3E %3Cellipse fill='%239c4a00' stroke-width='0.3991' cx='478.38' cy='-41.085999' rx='3.5339' ry='3.4030001' transform='matrix(1.3799165,0.02078085,-0.03061721,1.4544413,-625.22695,117.20523)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.03129182,0.04226118,0.39513675,-119.97806,-293.41566)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.03129182,0.04226118,0.39513675,-127.33463,-293.99555)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.0312918,0.04226106,0.39513549,-132.603,-303.41129)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19942957,-0.0315355,0.04632234,0.43592867,-125.4075,-340.63478)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-112.65072,-316.23218)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-118.30405,-319.63879)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-125.43742,-324.55362)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-132.04249,-327.53171)'/%3E %3Cpath fill='%239461c9' stroke-width='0.5749' d='m-14.73408,-52.686013c0,0 -14.655341,12.719161 -13.010831,47.1436528 1.845436,34.6199222 32.3934914,50.8943372 32.3934914,50.8943372 0,0 7.7859806,-9.826932 6.8819576,-37.6434978C9.3473299,-32.960001 -5.0778778,-50.928723 -5.0778778,-50.928723l-9.6562022,-1.75729z'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617733,-0.02883923,0.39634241,-45.183498,-309.40147)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617733,-0.02883923,0.39634241,-52.318928,-311.28321)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617736,-0.02883913,0.39634115,-55.824816,-321.48715)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20185704,0.00451301,-0.03211329,0.43720504,-42.110313,-356.83224)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-33.906971,-330.54675)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-38.862639,-334.90639)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-45.005838,-341.01389)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-50.974388,-345.12149)'/%3E %3Cellipse fill='%23d41c30' stroke-width='1pt' cx='624.42' cy='606.11' rx='58.28' ry='186.49' transform='matrix(0.19786701,-0.07643491,0.08023488,0.18709671,-155.83813,-59.21337)'/%3E %3Cellipse stroke-width='1.4635' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.49827764,0.00887179,-0.00656928,0.3689586,-99.510833,-162.76931)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-84.135444,-169.29958)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-90.652069,-169.41561)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-93.887858,-166.3691)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-94.461639,-172.01688)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-96.8782,-173.22007)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-95.468785,-176.63136)'/%3E %3Cellipse stroke-width='1.4635' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.49827764,0.00887179,-0.00656928,0.3689586,-114.72518,-179.36983)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-98.157196,-179.08115)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-100.2913,-183.52126)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-110.48856,-178.90566)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-108.8569,-179.77161)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-106.80676,-183.69602)'/%3E %3Cellipse stroke-width='2.5449' cx='528.68' cy='564.48' rx='67.438' ry='205.64' transform='matrix(0.21931516,-0.07742835,0.08682875,0.20202384,-145.01539,-72.55561)'/%3E %3Cellipse cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.20574399,-0.0978521,0.09471329,0.21196041,-137.12211,-77.403485)'/%3E %3Cpath stroke-width='0.5749' d='M31.462582,7.798675C44.273286,23.396889 42.655575,33.30197 41.319929,41.68219 37.295042,32.018935 35.09747,25.935914 22.284544,10.334996 9.4716187,-5.2659225 15.867064,-16.212552 16.746886,-21.981169c1.926581,4.993077 1.90277,14.1789256 14.715696,29.779844z'/%3E %3Cpath stroke-width='0.5749' d='M32.616052,20.397765C45.426756,35.995979 43.809045,45.90106 42.473399,54.28128 38.448512,44.618025 36.25094,38.535004 23.438014,22.934086 10.625089,7.3331675 17.020534,-3.6134618 17.900356,-9.382079c1.926581,4.993077 1.90277,14.1789256 14.715696,29.779844z'/%3E %3Cpath stroke-width='0.5749' d='M33.001502,30.545466C46.121623,45.867895 44.702257,55.805012 43.534416,64.211635 39.317096,54.636146 36.998322,48.601234 23.875927,33.276148 10.753531,17.951062 16.928895,6.8711542 17.693213,1.0852029 19.719255,6.0361835 19.879107,15.22038 33.001502,30.545466z'/%3E %3Cellipse stroke-width='1.3887' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.40784061,-0.1037946,0.16693789,0.37767112,-299.57061,-196.0302)'/%3E %3Cellipse stroke-width='1.6398' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.36689221,-0.0631048,0.12978287,0.31264984,-259.00282,-166.87124)'/%3E %3Cellipse stroke-width='1.6398' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.36814797,-0.0553158,0.1232589,0.31530969,-261.52366,-166.81962)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29657862,-0.05431058,0.11151259,0.23307633,-211.06958,-135.53834)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29951522,-0.03800069,0.09680807,0.23872917,-208.27027,-143.86531)'/%3E %3Cpath stroke-width='0.5749' d='M8.6195396,-15.767835C12.407426,-6.5127711 13.940854,1.8088668 12.039861,2.8095164 10.141163,3.8089573 5.5266551,-2.8908549 1.7387689,-12.145919'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29951522,-0.03800069,0.09680807,0.23872917,-208.89375,-154.73721)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.30032211,-0.03210428,0.09144035,0.24056268,-212.194,-155.98718)'/%3E %3Cpath stroke-width='0.5749' d='m2.0257453,-28.338145c3.6779608,6.253928 5.6581289,12.09375 4.4184823,13.037247 -1.2381494,0.942356 -5.2275031,-3.368272 -8.9054639,-9.622201'/%3E %3Cpath stroke-width='0.5749' d='m4.5726443,-32.485105c3.6779608,6.253928 5.6581287,12.09375 4.4184823,13.037247 -1.2381494,0.942356 -5.2275031,-3.368272 -8.9054639,-9.622201'/%3E %3Cpath stroke-width='0.5749' d='m16.013433,-31.606808c5.124964,8.542601 7.882604,16.520579 6.153303,17.810625 -1.727212,1.288488 -7.287655,-4.598619 -12.4126197,-13.14122'/%3E %3Cpath stroke-width='0.5749' d='m8.4524006,-36.082328c3.6926974,6.904591 5.6865404,13.348237 4.4490124,14.385262 -1.236034,1.035772 -5.2356299,-3.727092 -8.9283268,-10.631682'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m8.1245845,-46.086178c-2.4652011,2.482234 -0.05083,7.123595 2.2055225,8.801039 2.530629,2.294221 16.742134,17.286089 26.768781,4.672222C29.06535,-32.759025 14.072204,-51.617449 8.1245845,-46.086178z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m6.3689905,-53.485518c-2.4652011,2.482234 -0.05083,7.123595 2.2055226,8.801039 2.5306289,2.294221 16.7421339,17.286089 26.7687809,4.672222C27.309756,-40.158365 12.31661,-59.016789 6.3689905,-53.485518z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m4.1226915,-60.575768c-2.4652011,2.482234 -0.05083,7.123595 2.2055226,8.801039 2.5306294,2.294221 16.7421339,17.286089 26.7687809,4.672222 -8.033538,-0.146108 -23.026684,-19.004532 -28.9743035,-13.473261z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m-0.75854747,-68.686568c-2.46520113,2.482234 -0.0508299,7.123595 2.20552257,8.801039 2.5306294,2.294221 16.7421339,17.286089 26.7687809,4.672222 -8.033538,-0.146108 -23.0266836,-19.004532 -28.97430347,-13.473261z'/%3E %3Cpath fill='%239461c9' stroke-width='0.6276' d='m-18.271949,-76.448224c5.080302,-3.778951 14.4116525,-4.884005 21.6814205,-1.183186 6.0553769,2.966807 16.1473035,15.072925 23.7340285,17.934947 -5.339994,0.952539 -8.588551,0.147731 -12.001308,-1.491593 -6.7388646,4.879721 -9.1401688,5.611298 -16.00788077,6.570161 -9.55160223,1.377954 -17.47968323,-1.108557 -20.26606523,-6.089426 -2.839252,-4.699505 -1.61543,-12.238734 2.859805,-15.740903z'/%3E %3Cellipse fill='%23d41c30' cx='287.23' cy='323.04' rx='14.154' ry='14.986' transform='matrix(0.30909157,0.00550335,-0.00301489,0.16932914,-95.304017,-125.19072)'/%3E %3Cellipse fill='%23fcd116' cx='204.58' cy='348.26' rx='23.254' ry='15.895' transform='matrix(0.24579207,-0.09143683,0.08132205,0.2192462,-99.445497,-116.289)'/%3E %3Cellipse fill='%23000' stroke='none' cx='283.9' cy='333.86' rx='5.828' ry='5.8279' transform='matrix(0.26990081,0.00480556,-0.00415607,0.23342269,-82.956029,-148.37388)'/%3E %3Cpath fill='%23fcd116' stroke-width='0.7318' d='m-17.127905,-65.514747c0.402078,1.948925 -1.043505,4.582316 -4.180015,5.515002 -3.195207,1.322722 -5.618416,4.322017 -7.016075,9.226342 -4.855803,-11.183796 -1.769609,-15.915544 3.387899,-17.06567 4.436579,-1.414945 7.11029,-1.235679 7.808191,2.324326z'/%3E %3Cellipse fill='%23000' stroke='none' cx='198.98' cy='362.39' rx='4.7097' ry='4.7097' transform='matrix(0.23597119,-0.0123552,0.01333585,0.24161486,-73.600709,-149.7658)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Crect width='750' height='500' fill='%23fff'/%3E %3Crect width='325' height='200' fill='%23002d62'/%3E %3Crect width='325' height='200' y='300' fill='%23ce1126'/%3E %3Crect width='325' height='200' x='425' y='300' fill='%23002d62'/%3E %3Crect width='325' height='200' x='425' fill='%23ce1126'/%3E %3Cg transform='matrix(0.8,0,0,0.8,-25,0)'%3E %3Cg%3E %3Cg%3E %3Cpath fill='%23fff' d='m474.5,281.05c0.0652,0.43268,0.0326,36.778,0.0326,40.539,0,3.5948,0.0422,5.8758,1.7514,8.1524,1.4074,1.9695,3.7673,3.5913,6.0751,4.1297,1.6305,0.33285,7.631,0.19971,9.718,0.19971,4.6352-0.21717,5.1883,0.81376,6.9424,3.1076,1.9946-3.2202,4.1878-3.2679,8.287-3.1076,2.0871,0,6.5546,0.16642,8.4136-0.233,2.217-0.52932,3.948-1.5887,5.3808-3.3617,2.348-2.696,2.2175-6.058,2.2175-9.5861v-38.312c0-1.7308-0.19568-1.2981,0.68479-2.1968l5.772-6.058-61.668,0.0333,6.3916,6.6902z'/%3E %3Cpath fill='%23002d62' d='m493.76,299.09,0-24.768-25.509,0,6.3326,6.6902,0.0597,18.078z'/%3E %3Cpath fill='%23ce1126' d='m503.98,299.09,0-24.768,25.986,0-6.631,7.108,0,17.66z'/%3E %3Cpath fill='%23ce1126' d='m493.76,309.32-19.299,0-0.0565,15.602c0.87384,6.8138,5.9126,9.1346,10.433,9.1125,3.0581,0.0321,4.0988-0.0213,8.9223-0.0552z'/%3E %3Cpath fill='%23002d62' d='m503.98,309.32,19.418,0-0.0629,15.602c-0.45606,6.7541-5.9126,9.1346-10.433,9.1125l-8.9223-0.0552z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='0.4544' d='m474.61,281.05c0.0652,0.43268,0.0326,36.778,0.0326,40.539,0,3.5948,0,5.7914,1.7936,8.3212,1.4074,1.9695,3.4297,3.5491,6.0329,3.9609,1.6305,0.33285,7.631,0.19971,9.718,0.19971,2.674,0,3.9133-0.13314,5.707,1.6642,0.55438,0.53255,0.68483,0.79883,1.1088,1.4645,0.22828-0.16642,0.22828-0.1997,0.35871-0.43268,0.58701-1.0651,1.5653-1.8972,2.674-2.3299,1.4022-0.56585,3.7502-0.36615,5.3808-0.36615,2.0871,0,6.5546,0.16643,8.4136-0.23299,2.217-0.52932,4.1801-1.9474,5.3808-3.3617,2.348-2.6961,2.2175-6.058,2.2175-9.5861v-38.312c0-1.7308-0.19567-1.2981,0.6848-2.1968l5.772-6.058-61.668,0.0333,6.3916,6.6902z'/%3E %3C/g%3E %3Cpath fill='%23eac102' stroke='%23000' stroke-width='0.2734' d='m497.92,280.41,0,2.773-2.7979,0,0,2.3456,2.7979,0,0,9.9264,2.3031,0,0-9.9264,2.8332,0,0-2.3456-2.8332,0,0-2.773z'/%3E %3Cg id='h'%3E %3Cg%3E %3Cpath fill='%23fff' d='m481.88,284.06,0.03,4.53-1.91-1.93,0.28,31.93c0,4.76,3.43,8.6,7.66,8.6,4.19,0,7.6-3.79,7.65-8.5l-0.31-16.44-2.06-2.13-0.03-1.68z'/%3E %3Cpath fill='%23002d62' d='m481.88,284.22,0.03,4.56-1.91-1.94,0.16,18.19,8.25,7.85,0.06-17.41-0.31-0.35v-2.93l-6.28-7.97z'/%3E %3Cpath fill='%23ce1126' d='m490.77,295.51,2.424,3.0788,0.016,1.0449-2.4462-2.5101z'/%3E %3Cpath fill='%23ce1126' d='m495.3,302.42,0.21797,11.442c-1.177,2.2102-3.5688,1.0123-3.5688,1.0123l0.076-15.791z'/%3E %3Cpath fill='%23002d62' d='m495.55,319.64c-3.1282,2.3386-3.9974-1.128-3.9974-1.128,2.3416-0.22719,3.4544-1.5964,3.9772-2.9779z'/%3E %3Cpath fill='%23ce1126' d='m480.21,309.72c4.2926,4.8716,7.965,7.5023,7.965,7.5023,0.96489,7.6676,5.4998,5.1206,7.1339,3.9248-0.92265,3.5955-3.8683,6.2232-7.3588,6.2232-4.2296,0-7.6595-3.8597-7.6595-8.6218z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='0.2619' d='m493.2,299.63-0.0176-1.1586-11.321-14.382,0.0293,3.9624z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='0.3168' d='m480,286.66,0.29392,31.922c0,4.7599,3.4284,8.6196,7.6562,8.6196,4.1958,0,7.6029-3.8011,7.6541-8.5113l-0.30981-16.445z'/%3E %3C/g%3E %3Cg fill='%23eac102' stroke='%23000' stroke-width='0.06394'%3E %3Cpath d='m486.17,281.23c-0.77767-1.4568-0.62186-2.0847-0.081-2.6414l-2.9334-3.0053,0.8167,4.1992c0.83917-0.21179,1.4251,0.00007,2.1978,1.4474z'/%3E %3Cpath d='m483.15,275.58,3.0021,5.6235'/%3E %3Cpath d='m498.07,300.74-0.7623,0.2925-11.924-20.421,0.70235-0.39514z'/%3E %3Cpath d='m484.98,280.59c-0.10238-0.18962,0.10746-0.50686,0.46853-0.70909,0.36106-0.20216,0.73627-0.21248,0.8387-0.0231,0.1024,0.18962-0.10747,0.50686-0.46854,0.70909-0.36105,0.20215-0.73627,0.21247-0.83869,0.0231z'/%3E %3Cpath d='m481.02,282.22c-0.95493-1.3423-0.87965-1.9856-0.4136-2.6089l-3.2879-2.5941,1.3396,4.0569c0.80541-0.32053,1.4131-0.18758,2.3619,1.146z'/%3E %3Cpath d='m477.32,277.02,3.6864,5.1816'/%3E %3Cpath d='m495.28,300.01-0.719,0.39045-14.401-18.682,0.6466-0.48435z'/%3E %3Cpath d='m479.76,281.75c-0.12544-0.17457,0.0426-0.51681,0.37514-0.76491,0.33252-0.24802,0.70328-0.30766,0.82874-0.13337,0.12546,0.17457-0.0426,0.51681-0.37514,0.76491-0.33253,0.24802-0.70329,0.30766-0.82874,0.13337z'/%3E %3Cpath d='m480.18,286.36c-1.0977-1.2238-1.0942-1.8716-0.70026-2.5446l-3.5545-2.199,1.7809,3.8767c0.76471-0.41118,1.3833-0.34903,2.4739,0.86681z'/%3E %3Cpath d='m475.93,281.61,4.2374,4.7241'/%3E %3Cpath d='m495.66,302.86-16.38-16.905,0.5889-0.5557,16.462,16.99z'/%3E %3Cpath d='m478.88,286.03c-0.144-0.15901-0.015-0.5184,0.28791-0.80319,0.30289-0.2847,0.66467-0.38664,0.80864-0.22791,0.14402,0.15901,0.015,0.51841-0.28791,0.80319-0.30289,0.28471-0.66467,0.38664-0.80864,0.22791z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='matrix(-1,0,0,1,998.257,0)'/%3E %3Cg stroke='%23000' stroke-width='0.2359'%3E %3Cpath fill='%23ce1126' d='m496.73,314.54-0.63423,10.104c-0.64064-0.0569-1.8765-0.16008-1.9693-0.98118-0.0524-0.46411,1.2625-8.7318,1.3126-9.5363,0.43648,0.12124,0.89314,0.32327,1.2909,0.41358z'/%3E %3Cpath fill='%23002d62' d='m495.77,314.12c-0.0629,0.39574-0.28285,2.8061-0.22002,3.0939,0.1886,0.97137,1.3829,0.82746,2.0429,0.86343l0.1257-5.1807c-0.22,0.21586-1.6971,1.1153-1.9486,1.2232z'/%3E %3Cpath fill='%23002d62' d='m495.88,327.04c1.664-2.0848,4.784-0.53555,4.784-0.53555,3.4147,0.76506,2.5653-3.1367,2.5653-3.1367-0.69331-7.8036-1.5204-13.144-1.5204-13.144l-4.9886,3.3317z'/%3E %3Cpath fill='%23002d62' stroke-width='0.1881' d='m495.86,327.17c-0.35961,2.317,1.9579,1.9774,1.9579,1.9774,2.7571-0.04,1.9679-2.9562,1.9679-2.9562-2.9569-0.84889-3.926,0.97874-3.926,0.97874z'/%3E %3Cpath fill='%23ce1126' d='m497.83,312.74c-0.17263,8.0717-0.24615,8.8947-0.24615,8.8947,0.11508,2.2123,2.5317,1.0164,2.5317,1.0164,0.57536-0.23917,1.2083-0.0598,1.2083-0.0598-0.11507-2.7504-0.11507-2.7504-0.11507-2.7504,4.0223-0.29834,3.0873-2.6392,3.0873-2.6392-1.6398-7.6233-1.7469-7.2905-1.7469-7.2905z'/%3E %3Cpath fill='none' stroke-width='0.2253' d='m501.31,319.81c-2.5367-0.04-3.568,0.95952-3.568,0.95952l-0.10313,0.21989'/%3E %3Cpath fill='%23fff' stroke-width='0.2094' d='m500.99,326.45-0.87502-15.193,1.7501-1.1724,1.5167,14.216,0,0.14655,0,0c0,2.6381-2.3917,2.0028-2.3917,2.0028z'/%3E %3C/g%3E %3Cg fill='%23fff' stroke='%23000'%3E %3Cpath fill='%23000' stroke-width='0.04238' d='m488.23,302.2,6.7879,12.45,14.63-9.7118-7.6204-11.249z'/%3E %3Cpath stroke-width='0.2723' d='m488.49,302.1,13.753-8.0135,7.5193,10.823-14.53,9.3466z'/%3E %3Cpath fill='%23000' stroke-width='0.03889' d='m495.43,313.53,13.697-8.8202-1.0532-1.6855-6.8618-9.3232-4.9619,4.008-6.3349,3.5098-1.116-0.69637,0.22291,1.4884z'/%3E %3Cpath stroke-width='0.1478' d='m496.18,297.77c-2.0262-0.9592-4.3793,2.0673-5.0572,2.6681-0.67812,0.60088-2.0409,0.24028-2.0409,0.24028l6.1791,11.086c1.823,0.72017,2.9988-1.6155,3.8456-2.3381,1.5531-1.3254,3.3767-1.2233,3.3767-1.2233z'/%3E %3Cpath stroke-width='0.1478' d='m496.36,297.88c0.006-2.3781,2.9517-3.1355,3.7383-3.5574,0.78651-0.42185,1.0325-1.9058,1.0325-1.9058l6.9276,10.563c-0.12673,2.0816-2.5916,2.2882-3.5502,2.8262-1.7582,0.9868-1.9975,2.5089-1.9975,2.5089z'/%3E %3Cpath stroke-width='0.105' d='m495.02,311.82c-3.9532-7.236-6.127-11.017-6.127-11.017-0.0935,1.3259-0.0192,1.2423-0.0192,1.2423,4.6102,7.429,6.4879,11.413,6.4879,11.413-0.10276-0.54832-0.22404-1.093-0.3417-1.6383z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m490.87,302.2c0.0378,0.0618,0.0755,0.12351,0.11326,0.18527,0.0317-0.0175,0.0598-0.0491,0.0544-0.0879,0.006-0.0291-0.0321-0.066-0.0164-0.0856,0.01-0.005,0.0134,0.017,0.0205,0.0234,0.0432,0.0707,0.0864,0.14136,0.12962,0.21204-0.0245,0.021-0.0359-0.0369-0.0613-0.0407-0.0304-0.0283-0.0887-0.0226-0.10916,0.007,0.0342,0.0545,0.0657,0.11096,0.10255,0.16376,0.0207,0.0238,0.0505,0.003,0.0709-0.0104,0.0553-0.0309,0.10459-0.0846,0.10468-0.15141,0.0112-0.0265-0.0263-0.0675,0.002-0.0823,0.0227,0.0525,0.0455,0.10498,0.0682,0.15747-0.12937,0.0821-0.25874,0.16419-0.38811,0.24629-0.0149-0.0125,0.00057-0.0177,0.0116-0.0245,0.042-0.0215,0.0235-0.0698,0.0003-0.0979-0.0653-0.10629-0.12962-0.21323-0.19566-0.31907-0.0165-0.0341-0.0589-0.0235-0.0827-0.004-0.0106,0.007-0.0175-0.0162-0.002-0.0166,0.1215-0.0771,0.24301-0.15421,0.36451-0.23131,0.0274,0.0449,0.0549,0.0897,0.0823,0.13459-0.0249,0.0202-0.0405-0.0342-0.067-0.0384-0.0475-0.0277-0.10365-0.005-0.14526,0.0228-0.0195,0.012-0.0383,0.0252-0.0575,0.0378z'/%3E %3Cpath d='m491.27,301.92c0.0812,0.1326,0.16202,0.26539,0.24338,0.39786,0.0108,0.0281,0.0427,0.0377,0.0657,0.023,0.008,0.009,0.005,0.0142-0.005,0.0183-0.0518,0.0329-0.10363,0.0658-0.15545,0.0986-0.0197-0.0197,0.0309-0.0294,0.0141-0.0555-0.0166-0.0377-0.041-0.0715-0.0617-0.10703-0.0528-0.0862-0.10534-0.17266-0.15837-0.25877-0.0108-0.0278-0.0424-0.0376-0.0652-0.0227-0.008-0.008-0.008-0.0142,0.003-0.018,0.0399-0.0253,0.0798-0.0505,0.11971-0.0758z'/%3E %3Cpath d='m491.79,301.56c0.0321,0.0498,0.0643,0.0996,0.0964,0.1494-0.023,0.0233-0.0372-0.0281-0.0617-0.0319-0.0566-0.0347-0.14047-0.0344-0.18523,0.0198-0.0326,0.0349-0.0193,0.10196,0.0307,0.11155,0.0585,0.0145,0.11863-0.003,0.17778-0.004,0.0565-0.003,0.12044,0.003,0.1604,0.0478,0.0495,0.0504,0.0537,0.13238,0.0188,0.19204-0.036,0.0645-0.10808,0.0997-0.17943,0.10761-0.0351,0.00096-0.0358,0.0405-0.0435,0.0603-0.01,0.0108-0.0127-0.009-0.0188-0.0151-0.031-0.0508-0.0621-0.10155-0.0931-0.15232,0.0216-0.0209,0.0355,0.0282,0.0572,0.0322,0.0587,0.0447,0.15042,0.0554,0.2084,0.004,0.0443-0.0326,0.0457-0.11263-0.009-0.13524-0.056-0.0233-0.11755-0.004-0.1756-0.003-0.0624,0.005-0.13497-0.003-0.17581-0.0567-0.0521-0.062-0.0391-0.16162,0.0211-0.21344,0.0362-0.0335,0.0847-0.0499,0.13327-0.0528,0.0356,0.003,0.0382-0.0335,0.0307-0.0549,0.003-0.002,0.005-0.004,0.008-0.006z'/%3E %3Cpath d='m492.3,301.83c-0.0146,0.0473-0.036,0.10043-0.0841,0.12212-0.0405,0.0183-0.0874-0.0116-0.0962-0.0531-0.0138-0.0523,0.0172-0.10151,0.0411-0.14569,0.0116-0.027,0.0394-0.0532,0.0438-0.0794-0.0153-0.0237-0.0278-0.0499-0.048-0.0699-0.0332-0.0225-0.0903,0.0136-0.0816,0.0529,0.0218,0.0154,0.0612,0.0215,0.0561,0.0577-0.002,0.0439-0.0638,0.068-0.0952,0.037-0.0326-0.0398-0.0122-0.0976,0.017-0.13316,0.032-0.0385,0.0748-0.0725,0.12523-0.081,0.0479-0.008,0.0911,0.0213,0.11071,0.0637,0.0326,0.052,0.0635,0.10508,0.0967,0.15669,0.009,0.0233,0.0404,0.0117,0.0361-0.0118,0.0277-0.003,0.01,0.0321,0.008,0.0478-0.0118,0.0377-0.0525,0.069-0.0928,0.0615-0.0149-0.004-0.0266-0.0145-0.0363-0.0254zm-0.015-0.0245c-0.0214-0.035-0.0428-0.07-0.0642-0.10507-0.0185,0.0376-0.0372,0.0817-0.0239,0.12389,0.0113,0.0433,0.0728,0.0362,0.0821-0.004l0.003-0.007,0.003-0.008,0.0005,0.00047z'/%3E %3Cpath d='m492.43,301.37c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10301,0.0847-0.11995,0.0449-0.0165,0.0921,0.0127,0.1142,0.0515,0.0404,0.0605,0.0755,0.1245,0.11579,0.18507,0.01,0.0249,0.0384,0.0181,0.0541,0.0147,0.01,0.009,0.00091,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0221-0.0447-0.0506-0.0859-0.0759-0.12887-0.0194-0.0305-0.0361-0.063-0.0595-0.0907-0.0422-0.0327-0.0736,0.0333-0.0665,0.0699,0.0378,0.0612,0.0746,0.1231,0.11301,0.18392,0.01,0.0239,0.0367,0.0302,0.0561,0.0242,0.01,0.009,0.00091,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14345,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0597-0.0259-0.0485-0.0565-0.0944-0.0846-0.1416-0.0209-0.0328-0.039-0.0677-0.0635-0.0981-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0419-0.0265,0.0838-0.053,0.12563-0.0794z'/%3E %3Cpath d='m492.74,301.02c0.0234,0.0383,0.0468,0.0765,0.0702,0.11477,0.0245-0.0155,0.049-0.0311,0.0735-0.0466,0.007,0.0111,0.0135,0.0221,0.0203,0.0332-0.0245,0.0156-0.049,0.0311-0.0735,0.0467,0.0433,0.0703,0.0857,0.14117,0.12956,0.21115,0.0118,0.0332,0.0609,0.028,0.062-0.008,0.003-0.0147-0.004-0.0355,0.0168-0.0287,0.0108,0.0505-0.0128,0.10799-0.0625,0.12766-0.0438,0.0206-0.0987-0.002-0.11772-0.0457-0.0408-0.0654-0.0805-0.13137-0.12087-0.19702-0.0135,0.009-0.0269,0.0171-0.0404,0.0256-0.0165-0.0183,0.01-0.0397,0.0108-0.0601,0.0173-0.0532,0.0241-0.10963,0.0209-0.16545,0.004-0.002,0.007-0.005,0.011-0.007z'/%3E %3Cpath d='m493.05,300.97c0.0543-0.0356,0.13041-0.036,0.18278,0.004,0.057,0.0409,0.0962,0.10807,0.10048,0.17841,0.004,0.058-0.025,0.11647-0.0746,0.1472-0.0431,0.0307-0.1019,0.0414-0.15078,0.0181-0.1013-0.0425-0.16122-0.16937-0.12243-0.27349,0.0124-0.0311,0.0365-0.0562,0.0645-0.0738zm0.0158,0.023c-0.0438,0.0306-0.0101,0.0848,0.009,0.12028,0.0304,0.0534,0.0592,0.10899,0.10144,0.15423,0.0296,0.0377,0.0964,0.0101,0.0848-0.0383-0.008-0.0403-0.0331-0.0747-0.0524-0.11047-0.024-0.0391-0.0457-0.0807-0.0779-0.11391-0.0167-0.0158-0.0439-0.0281-0.0645-0.0118z'/%3E %3Cpath d='m491.4,303.06c0.0378,0.0618,0.0755,0.12351,0.11326,0.18526,0.0317-0.0175,0.0598-0.0491,0.0544-0.0879,0.006-0.0291-0.0321-0.066-0.0164-0.0856,0.01-0.005,0.0134,0.017,0.0205,0.0234,0.0432,0.0707,0.0864,0.14135,0.12962,0.21203-0.0245,0.021-0.0359-0.0369-0.0613-0.0407-0.0304-0.0283-0.0888-0.0227-0.10926,0.007,0.0342,0.0546,0.0657,0.11096,0.10255,0.16377,0.0207,0.0238,0.0505,0.003,0.0709-0.0104,0.0553-0.031,0.10459-0.0846,0.10468-0.15141,0.0111-0.0265-0.0262-0.0673,0.002-0.0823,0.0227,0.0525,0.0455,0.10499,0.0682,0.15748-0.12937,0.0821-0.25875,0.16419-0.38812,0.24628-0.0149-0.0125,0.00057-0.0177,0.0116-0.0245,0.042-0.0215,0.0235-0.0698,0.0003-0.0979-0.0653-0.10628-0.12961-0.21323-0.19566-0.31906-0.0164-0.0344-0.0589-0.0232-0.0827-0.004-0.0106,0.007-0.0175-0.0162-0.002-0.0166,0.1215-0.0771,0.24301-0.1542,0.36451-0.2313,0.0274,0.0449,0.0549,0.0897,0.0823,0.13458-0.0249,0.0202-0.0405-0.0342-0.067-0.0384-0.0475-0.0277-0.10369-0.005-0.14526,0.0229-0.0194,0.012-0.0382,0.0251-0.0573,0.0376z'/%3E %3Cpath d='m492.1,303.24c-0.0915-0.0637-0.18238-0.12825-0.2742-0.19144-0.021-0.0154-0.0492-0.0303-0.0733-0.0216-0.005-0.006-0.009-0.0124,0.00091-0.0154,0.0523-0.0332,0.10461-0.0664,0.15691-0.0996,0.008,0.009,0.0104,0.0165-0.004,0.0224-0.0226,0.0324,0.0236,0.0558,0.0452,0.0725,0.0394,0.0274,0.0789,0.0548,0.11835,0.0823-0.01-0.0562-0.0177-0.11273-0.0297-0.16847-0.002-0.0279-0.0269-0.0591-0.0558-0.0376-0.005,0.006-0.0177-0.0116-0.008-0.013,0.0322-0.0204,0.0644-0.0408,0.0965-0.0613,0.0189,0.0165-0.0147,0.0282-0.0104,0.0487,0.002,0.0458,0.0115,0.0909,0.0177,0.13626,0.012,0.0789,0.0239,0.15775,0.0359,0.23663-0.005,0.003-0.0107,0.006-0.0161,0.01z'/%3E %3Cpath d='m492.43,302.94c-0.0146,0.0473-0.036,0.10044-0.0841,0.12213-0.0405,0.0183-0.0874-0.0116-0.0962-0.0531-0.0138-0.0523,0.0172-0.10144,0.0411-0.1456,0.0116-0.027,0.0394-0.0532,0.0438-0.0794-0.0153-0.0237-0.0278-0.0499-0.048-0.0699-0.0331-0.0224-0.0903,0.0135-0.0818,0.0527,0.0214,0.0157,0.0614,0.0212,0.0561,0.0577-0.002,0.0439-0.0638,0.068-0.0952,0.037-0.0326-0.0397-0.0123-0.0975,0.0171-0.13306,0.0319-0.0385,0.0747-0.0725,0.12523-0.081,0.048-0.008,0.0911,0.0213,0.11071,0.0637,0.0326,0.052,0.0635,0.10506,0.0967,0.15667,0.009,0.0234,0.0403,0.0118,0.036-0.0117,0.0277-0.003,0.01,0.032,0.008,0.0478-0.0118,0.0377-0.0525,0.069-0.0928,0.0615-0.0147-0.004-0.0267-0.014-0.036-0.0255zm-0.015-0.0245c-0.0214-0.035-0.0428-0.07-0.0642-0.10507-0.0185,0.0376-0.0372,0.0817-0.0239,0.1239,0.0113,0.0433,0.0728,0.0364,0.0822-0.004l0.003-0.007,0.003-0.008,0.0004,0.00037z'/%3E %3Cpath d='m492.57,302.49c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10302,0.0847-0.12,0.0449-0.0164,0.0921,0.0127,0.11418,0.0516,0.0404,0.0605,0.0755,0.1245,0.11579,0.18509,0.01,0.0249,0.0384,0.0181,0.0543,0.0148,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0219-0.0443-0.0501-0.0851-0.0752-0.12768-0.0197-0.0309-0.0365-0.0638-0.0602-0.0918-0.0422-0.0327-0.0736,0.0333-0.0665,0.0699,0.0378,0.0612,0.0746,0.12308,0.11299,0.18389,0.01,0.0239,0.0366,0.0303,0.0561,0.0243,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0596-0.0265-0.0493-0.0575-0.096-0.0862-0.14405-0.0204-0.032-0.038-0.066-0.0619-0.0956-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0419-0.0265,0.0837-0.0531,0.12562-0.0796z'/%3E %3Cpath d='m493.02,302.21c0.0348-0.0221,0.0695-0.0441,0.10432-0.0662,0.008,0.0123,0.0151,0.0246,0.0226,0.0369-0.0198,0.0125-0.0395,0.0251-0.0593,0.0376,0.0618,0.009,0.1023,0.0775,0.0863,0.1364-0.0136,0.053-0.0532,0.0977-0.10297,0.11989-0.0504,0.0115-0.0285,0.0997,0.0214,0.0695,0.0534-0.0303,0.10194-0.0722,0.16293-0.0863,0.0435-0.009,0.0858,0.0224,0.0974,0.0636,0.0164,0.0502-0.0107,0.10209-0.0478,0.13531-0.0496,0.046-0.11032,0.0836-0.17745,0.0963-0.0498,0.0146-0.0906-0.0467-0.0527-0.0848,0.006-0.0101,0.027-0.0251,0.003-0.0192-0.0383,0.003-0.075-0.027-0.0765-0.0659-0.004-0.0352,0.0133-0.0685,0.0329-0.0966-0.0478,0.0127-0.10446,0.004-0.13684-0.0363-0.0466-0.052-0.0336-0.1361,0.0137-0.18313,0.0285-0.0297,0.0701-0.0523,0.10922-0.0571zm-0.0526,0.0441c-0.037,0.0263-0.015,0.077,0.003,0.10811,0.0217,0.0348,0.0437,0.0845,0.0906,0.0874,0.0437-0.003,0.0503-0.0588,0.0302-0.0895-0.0196-0.0385-0.0416-0.0789-0.0773-0.10485-0.0138-0.01-0.0335-0.01-0.0468-0.001zm0.19366,0.36112c-0.0355,0.0122-0.0729,0.0694-0.0233,0.0895,0.0431,0.0123,0.0825-0.0188,0.11686-0.0404,0.0317-0.0221,0.0809-0.0665,0.0477-0.10595-0.0453-0.0188-0.0847,0.0265-0.12284,0.0446-0.006,0.004-0.0134,0.008-0.0184,0.0122z'/%3E %3Cpath d='m493.5,302.08c-0.0566,0.0359-0.11326,0.0719-0.16989,0.10781,0.0277,0.0415,0.0698,0.0802,0.12193,0.0833,0.0486,0.003,0.0829-0.0445,0.0816-0.0899-0.001-0.0121-0.002-0.0227,0.0119-0.019,0.0127-0.00013,0.002,0.0244,0.006,0.0324,0.002,0.0458-0.0111,0.0947-0.0467,0.12571-0.0399,0.0365-0.0998,0.0554-0.15145,0.0335-0.0643-0.026-0.10758-0.0874-0.12998-0.15106-0.0248-0.071-0.004-0.16136,0.0627-0.20224,0.0526-0.035,0.12575-0.0181,0.16852,0.0249,0.0173,0.016,0.0323,0.0353,0.0451,0.0545zm-0.0952,0.0292c-0.0234-0.034-0.0433-0.0803-0.0878-0.0896-0.0478-0.00017-0.0452,0.0601-0.031,0.0916,0.007,0.0198,0.018,0.0376,0.0286,0.0555,0.0301-0.0192,0.0601-0.0383,0.0902-0.0575z'/%3E %3Cpath d='m493.49,301.7c0.0812,0.1326,0.16202,0.26539,0.24338,0.39787,0.0108,0.0281,0.0427,0.0377,0.0657,0.023,0.008,0.009,0.005,0.0142-0.005,0.0183-0.0518,0.0329-0.10363,0.0658-0.15545,0.0986-0.0197-0.0196,0.0309-0.0294,0.0142-0.0555-0.0166-0.0377-0.041-0.0714-0.0617-0.10702-0.0528-0.0862-0.10534-0.17267-0.15837-0.25878-0.0107-0.0277-0.0423-0.0376-0.0651-0.0227-0.008-0.008-0.008-0.0142,0.003-0.018,0.0399-0.0253,0.0797-0.0506,0.11961-0.0758z'/%3E %3Cpath d='m493.62,301.59c0.0324-0.0229,0.0818-0.002,0.0904,0.0359,0.011,0.0395-0.0254,0.0834-0.0667,0.0768-0.0441-0.004-0.0683-0.0613-0.0417-0.0962,0.005-0.007,0.0108-0.0127,0.018-0.0164zm0.1393,0.12261c0.0524,0.0855,0.10445,0.17118,0.15701,0.25656,0.0108,0.0279,0.0426,0.0379,0.0656,0.0229,0.007,0.008,0.007,0.0137-0.004,0.0172-0.0524,0.0332-0.10479,0.0665-0.15719,0.0997-0.0197-0.019,0.0267-0.0264,0.0154-0.0508-0.0117-0.0332-0.0335-0.0616-0.0509-0.0919-0.0296-0.0479-0.0582-0.0965-0.0886-0.14391-0.0108-0.0275-0.0427-0.0249-0.0613-0.017-0.008-0.007-0.007-0.013,0.003-0.0165,0.0401-0.0254,0.0802-0.0508,0.12027-0.0762z'/%3E %3Cpath d='m493.97,301.58c0.0543-0.0356,0.13041-0.036,0.18278,0.004,0.0591,0.0425,0.0995,0.11339,0.10066,0.18675,0.002,0.0573-0.0299,0.11274-0.0791,0.14174-0.0449,0.0309-0.1059,0.0378-0.15458,0.0115-0.0963-0.0457-0.15198-0.16854-0.11424-0.26981,0.0124-0.0311,0.0365-0.0562,0.0645-0.0738zm0.0158,0.023c-0.0436,0.0307-0.01,0.085,0.009,0.12048,0.0304,0.0534,0.0592,0.109,0.10144,0.15424,0.0296,0.0378,0.0964,0.0101,0.0848-0.0383-0.008-0.0403-0.0331-0.0747-0.0524-0.11044-0.0254-0.0407-0.0472-0.0851-0.0827-0.11805-0.0161-0.0139-0.0411-0.0221-0.0598-0.008z'/%3E %3Cpath d='m492.04,303.81c0.0321,0.0498,0.0643,0.0996,0.0964,0.14939-0.023,0.0233-0.0372-0.0281-0.0617-0.0319-0.0566-0.0347-0.14047-0.0344-0.18523,0.0198-0.0326,0.0349-0.0194,0.10202,0.0307,0.11155,0.0585,0.0145,0.11863-0.003,0.17778-0.004,0.0565-0.003,0.12041,0.003,0.1604,0.0478,0.0495,0.0504,0.0537,0.13235,0.0188,0.19197-0.0361,0.0644-0.10796,0.1-0.17933,0.10781-0.0351,0.00097-0.0358,0.0404-0.0435,0.0603-0.01,0.0107-0.0126-0.009-0.0187-0.0151-0.031-0.0508-0.0621-0.10155-0.0931-0.15233,0.0216-0.0209,0.0355,0.0282,0.0572,0.0322,0.0587,0.0448,0.15046,0.0553,0.20838,0.004,0.0443-0.0326,0.0459-0.11266-0.009-0.13514-0.056-0.0233-0.11755-0.004-0.1756-0.003-0.0624,0.005-0.13494-0.004-0.1758-0.0568-0.0542-0.0643-0.0378-0.16847,0.0274-0.21884,0.0354-0.0301,0.0811-0.0447,0.12699-0.0475,0.0355,0.003,0.0383-0.0334,0.0307-0.055,0.002-0.002,0.005-0.004,0.007-0.005z'/%3E %3Cpath d='m492.57,303.89c-0.0566,0.0359-0.11326,0.0719-0.16989,0.1078,0.0278,0.0414,0.0697,0.0802,0.12193,0.0833,0.0486,0.003,0.0829-0.0445,0.0816-0.0899-0.001-0.0121-0.002-0.0227,0.0119-0.019,0.0127-0.00014,0.002,0.0244,0.006,0.0324,0.002,0.0458-0.0111,0.0947-0.0467,0.12572-0.0399,0.0365-0.0998,0.0554-0.15144,0.0335-0.0644-0.026-0.10758-0.0874-0.12998-0.15106-0.0248-0.071-0.004-0.16141,0.0627-0.20226,0.0527-0.035,0.12578-0.0181,0.16857,0.0249,0.0173,0.0161,0.0323,0.0352,0.0451,0.0546zm-0.0952,0.0292c-0.0233-0.034-0.0433-0.0803-0.0878-0.0896-0.0478-0.00017-0.0452,0.0601-0.031,0.0916,0.007,0.0198,0.018,0.0376,0.0286,0.0555,0.0301-0.0192,0.0601-0.0383,0.0902-0.0575z'/%3E %3Cpath d='m492.71,303.59c0.0348-0.0221,0.0695-0.0441,0.10432-0.0662,0.008,0.0123,0.0151,0.0246,0.0226,0.0369-0.0198,0.0125-0.0395,0.0251-0.0593,0.0376,0.0618,0.009,0.10231,0.0775,0.0863,0.1364-0.0136,0.053-0.0532,0.0976-0.1029,0.11989-0.0504,0.0115-0.0285,0.0997,0.0214,0.0695,0.0534-0.0304,0.10194-0.0722,0.16287-0.0864,0.0435-0.009,0.0858,0.0224,0.0974,0.0636,0.0164,0.0502-0.0107,0.10209-0.0478,0.13531-0.0496,0.046-0.11034,0.0835-0.17745,0.0963-0.0498,0.0146-0.0906-0.0467-0.0527-0.0848,0.006-0.01,0.027-0.025,0.003-0.0192-0.0383,0.003-0.075-0.027-0.0765-0.066-0.004-0.0352,0.0133-0.0685,0.0328-0.0965-0.0478,0.0127-0.10446,0.004-0.13684-0.0363-0.0466-0.052-0.0336-0.13609,0.0136-0.18316,0.0285-0.0297,0.0702-0.0526,0.10935-0.057zm-0.0526,0.044c-0.037,0.0263-0.015,0.077,0.003,0.10811,0.0216,0.0348,0.0437,0.0845,0.0906,0.0874,0.0438-0.003,0.0503-0.0589,0.0302-0.0895-0.0197-0.0385-0.0417-0.0788-0.0773-0.10481-0.0138-0.01-0.0335-0.01-0.0468-0.001zm0.19364,0.36113c-0.0355,0.0122-0.0729,0.0694-0.0233,0.0895,0.0431,0.0123,0.0825-0.0188,0.11686-0.0404,0.0317-0.0221,0.0809-0.0665,0.0477-0.10594-0.0454-0.0186-0.0847,0.0267-0.12284,0.0448-0.006,0.004-0.0132,0.008-0.0184,0.012z'/%3E %3Cpath d='m493.15,303.31c0.0536,0.0872,0.10624,0.17495,0.16055,0.26167,0.01,0.0244,0.0378,0.0313,0.0581,0.0198,0.008,0.009,0.005,0.0142-0.005,0.0183-0.0381,0.0242-0.0763,0.0484-0.11442,0.0726-0.009-0.014-0.0171-0.0279-0.0256-0.0419-0.005,0.0506-0.0323,0.10324-0.0829,0.12059-0.0439,0.015-0.0915-0.01-0.11375-0.0484-0.0415-0.061-0.0766-0.12606-0.1176-0.18738-0.01-0.0245-0.0381-0.0177-0.054-0.0142-0.009-0.008-0.004-0.0134,0.005-0.0175,0.0381-0.0242,0.0763-0.0484,0.11443-0.0726,0.0484,0.0786,0.0958,0.15788,0.14492,0.23602,0.0151,0.0422,0.0743,0.0298,0.0764-0.0132,0.005-0.0193,0.009-0.0404-0.005-0.0562-0.0343-0.0556-0.0677-0.11184-0.10269-0.16704-0.01-0.0245-0.0376-0.0309-0.0579-0.0195-0.008-0.008-0.008-0.0142,0.003-0.0179,0.0388-0.0244,0.0776-0.0487,0.11636-0.0731z'/%3E %3Cpath d='m493.36,303.18c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10301,0.0847-0.12,0.0449-0.0165,0.0922,0.0126,0.11428,0.0515,0.0404,0.0605,0.0755,0.1245,0.11579,0.18509,0.01,0.0249,0.0384,0.0181,0.0542,0.0148,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0221-0.0447-0.0506-0.086-0.076-0.12889-0.0194-0.0305-0.036-0.063-0.0595-0.0906-0.0422-0.0327-0.0736,0.0333-0.0665,0.0699,0.0378,0.0612,0.0746,0.12308,0.113,0.18389,0.01,0.0239,0.0366,0.0303,0.0561,0.0243,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0597-0.0265-0.0493-0.0575-0.096-0.0862-0.14404-0.0204-0.032-0.038-0.066-0.0619-0.0956-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0418-0.0265,0.0837-0.053,0.12552-0.0795z'/%3E %3Cpath d='m493.98,302.58c0.0321,0.0498,0.0643,0.0996,0.0964,0.1494-0.023,0.0233-0.0372-0.0281-0.0617-0.0319-0.0566-0.0347-0.14047-0.0344-0.18523,0.0198-0.0326,0.0349-0.0193,0.10196,0.0307,0.11155,0.0585,0.0145,0.11863-0.003,0.17778-0.004,0.0565-0.003,0.12042,0.003,0.16041,0.0478,0.0495,0.0504,0.0537,0.13235,0.0188,0.19197-0.0361,0.0644-0.10796,0.1-0.17933,0.10781-0.0351,0.00095-0.0358,0.0405-0.0435,0.0603-0.01,0.0108-0.0127-0.009-0.0188-0.0151-0.031-0.0508-0.0621-0.10155-0.0931-0.15233,0.0217-0.0209,0.0355,0.0282,0.0573,0.0322,0.0587,0.0447,0.15048,0.0553,0.2084,0.004,0.0443-0.0326,0.0458-0.11267-0.009-0.13514-0.056-0.0233-0.11755-0.004-0.1756-0.003-0.0625,0.005-0.13495-0.003-0.17581-0.0567-0.0521-0.062-0.0392-0.16164,0.0211-0.21339,0.0362-0.0335,0.0847-0.05,0.13333-0.0528,0.0355,0.003,0.0382-0.0335,0.0306-0.055,0.002-0.002,0.005-0.004,0.007-0.006z'/%3E %3Cpath d='m494.48,302.82c-0.0146,0.0473-0.036,0.10038-0.0841,0.12216-0.0404,0.0184-0.0873-0.0118-0.0962-0.0532-0.0134-0.05,0.0152-0.0976,0.038-0.14003,0.0125-0.029,0.0413-0.057,0.0469-0.0849-0.0153-0.0237-0.0278-0.0499-0.048-0.0699-0.0331-0.0223-0.0903,0.0134-0.0818,0.0527,0.0214,0.0157,0.0614,0.0212,0.0561,0.0578-0.002,0.0439-0.0638,0.068-0.0952,0.037-0.0326-0.0397-0.0123-0.0975,0.017-0.13306,0.0319-0.0385,0.0748-0.0725,0.12527-0.0809,0.048-0.008,0.091,0.0213,0.11067,0.0636,0.0326,0.052,0.0635,0.10506,0.0967,0.15666,0.009,0.0233,0.0403,0.0117,0.036-0.0118,0.0277-0.003,0.009,0.032,0.007,0.0477-0.0117,0.0378-0.0525,0.069-0.0928,0.0616-0.0147-0.004-0.0266-0.0142-0.0361-0.0254zm-0.015-0.0245c-0.0214-0.035-0.0428-0.07-0.0642-0.10505-0.0185,0.0376-0.0372,0.0817-0.0239,0.12389,0.0113,0.0433,0.0727,0.0364,0.082-0.004l0.003-0.007,0.003-0.008,0.0005,0.00035z'/%3E %3Cpath d='m494.62,302.38c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10303,0.0847-0.11996,0.0449-0.0165,0.0922,0.0126,0.11428,0.0514,0.0404,0.0605,0.0755,0.1245,0.11579,0.18509,0.01,0.0249,0.0384,0.0181,0.0542,0.0148,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14345,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0221-0.0447-0.0506-0.0859-0.0759-0.12889-0.0194-0.0305-0.0361-0.063-0.0595-0.0906-0.0422-0.0327-0.0736,0.0333-0.0665,0.0699,0.0378,0.0612,0.0746,0.12308,0.113,0.18389,0.01,0.0239,0.0366,0.0303,0.0561,0.0243,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0596-0.0265-0.0493-0.0575-0.096-0.0862-0.14405-0.0204-0.032-0.038-0.066-0.0619-0.0956-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0418-0.0265,0.0837-0.053,0.12552-0.0795z'/%3E %3Cpath d='m495.04,301.94c-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0758-0.0481,0.15164-0.0962,0.22746-0.14434,0.008,0.009,0.009,0.0155-0.003,0.0194-0.0381,0.0153-0.0432,0.0614-0.0165,0.09,0.0516,0.0849,0.10421,0.16925,0.15504,0.25464,0.0237,0.0411,0.0445,0.0913,0.0247,0.13828-0.022,0.0619-0.0822,0.10594-0.14541,0.11824-0.0482,0.008-0.1085-0.0113-0.1245-0.0621-0.0142-0.0417,0.0303-0.0875,0.0723-0.0737,0.0443,0.0111,0.0309,0.062,0.0425,0.0925,0.0403,0.0241,0.097-0.0306,0.0657-0.0714-0.0407-0.0752-0.0875-0.14688-0.13151-0.22017-0.0277-0.0442-0.0532-0.0898-0.0831-0.13247-0.0196-0.0261-0.0553-0.0126-0.0767,0.004-0.003,0.002-0.007,0.004-0.01,0.006z'/%3E %3Cpath d='m495.68,301.71c0.0536,0.0872,0.10624,0.17496,0.16055,0.26168,0.01,0.0244,0.0378,0.0313,0.058,0.0198,0.008,0.009,0.005,0.0142-0.005,0.0183-0.0381,0.0242-0.0763,0.0484-0.11443,0.0726-0.009-0.014-0.0171-0.0279-0.0256-0.0419-0.005,0.0483-0.0293,0.0982-0.076,0.11808-0.0427,0.0187-0.0941-0.002-0.11731-0.0412-0.0432-0.0621-0.0789-0.12914-0.121-0.192-0.01-0.0245-0.0381-0.0177-0.054-0.0142-0.009-0.008-0.004-0.0134,0.005-0.0175,0.0381-0.0242,0.0763-0.0484,0.11442-0.0726,0.0484,0.0786,0.0958,0.15788,0.14492,0.23602,0.0151,0.0422,0.0743,0.0298,0.0764-0.0132,0.005-0.0193,0.009-0.0404-0.005-0.0562-0.0343-0.0556-0.0677-0.11184-0.10268-0.16704-0.01-0.0245-0.0376-0.0309-0.0579-0.0195-0.008-0.008-0.008-0.0142,0.003-0.0179,0.0388-0.0244,0.0777-0.0488,0.11648-0.0732z'/%3E %3Cpath d='m496.09,301.81c-0.0146,0.0473-0.036,0.10039-0.0841,0.12214-0.0404,0.0184-0.0874-0.0117-0.0962-0.0532-0.0138-0.0523,0.0172-0.10142,0.0411-0.14559,0.0115-0.027,0.0394-0.0532,0.0438-0.0794-0.0153-0.0237-0.0278-0.0499-0.048-0.0699-0.0331-0.0223-0.0903,0.0135-0.0818,0.0527,0.0214,0.0157,0.0614,0.0212,0.0561,0.0577-0.002,0.0439-0.0638,0.0681-0.0952,0.037-0.0326-0.0397-0.0123-0.0975,0.017-0.13306,0.0319-0.0385,0.0748-0.0725,0.12527-0.0809,0.0479-0.008,0.091,0.0213,0.11067,0.0636,0.0326,0.052,0.0635,0.10508,0.0967,0.1567,0.009,0.0234,0.0403,0.0118,0.036-0.0117,0.0277-0.003,0.009,0.032,0.008,0.0477-0.0117,0.0378-0.0525,0.069-0.0928,0.0616-0.0147-0.004-0.0266-0.0141-0.0361-0.0254zm-0.015-0.0245c-0.0214-0.035-0.0428-0.07-0.0642-0.10505-0.0185,0.0377-0.0372,0.0817-0.0239,0.12399,0.0113,0.0433,0.0727,0.0362,0.0821-0.004l0.003-0.007,0.003-0.008,0.0005,0.00035z'/%3E %3Cpath d='m496.22,301.36c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10299,0.0847-0.12,0.0449-0.0165,0.0921,0.0126,0.1142,0.0515,0.0404,0.0605,0.0755,0.12449,0.11579,0.18506,0.01,0.0249,0.0384,0.0182,0.0542,0.0148,0.01,0.009,0.00091,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0221-0.0447-0.0505-0.086-0.0759-0.12889-0.0194-0.0305-0.036-0.063-0.0595-0.0906-0.0422-0.0327-0.0736,0.0333-0.0664,0.0699,0.0378,0.0612,0.0746,0.12309,0.11299,0.1839,0.01,0.0239,0.0367,0.0302,0.0561,0.0242,0.01,0.009,0.00091,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0597-0.0265-0.0492-0.0575-0.096-0.0862-0.14401-0.0204-0.032-0.038-0.0661-0.062-0.0956-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0418-0.0265,0.0836-0.053,0.12542-0.0794z'/%3E %3Cpath d='m493.52,306.1c0.035,0.0494,0.0699,0.0988,0.10486,0.1482-0.022,0.0178-0.0404-0.0301-0.0642-0.0328-0.057-0.0367-0.1341-0.0291-0.18673,0.0119-0.0508,0.0355-0.0787,0.0993-0.07,0.16073,0.009,0.0775,0.0483,0.14935,0.0979,0.20848,0.0418,0.0493,0.10732,0.0827,0.17289,0.07,0.0759-0.0129,0.14741-0.0706,0.16089-0.14896,0.0111-0.0198-0.002-0.0627,0.0162-0.0713,0.0205,0.002,0.002,0.0428,0.006,0.0581-0.006,0.073-0.0495,0.1398-0.1122,0.17698-0.065,0.0438-0.15118,0.0574-0.22415,0.0258-0.14473-0.0579-0.22323-0.2435-0.16103-0.38702,0.0377-0.0887,0.12634-0.15422,0.22338-0.15872,0.0355,0.002,0.0252-0.0395,0.0285-0.056,0.003-0.002,0.005-0.004,0.008-0.005z'/%3E %3Cpath d='m494.06,306.18c-0.058,0.0368-0.11591,0.0736-0.17386,0.11032,0.007,0.0418,0.0104,0.0842,0.0209,0.12526,0.008,0.0421,0.0568,0.0171,0.0767,0.0112,0.0119,0.01-0.00031,0.0141-0.009,0.0193-0.0421,0.0267-0.0842,0.0534-0.12626,0.0801-0.0228-0.0225,0.0335-0.0352,0.0231-0.0642,0.002-0.0509-0.011-0.10075-0.0172-0.15102-0.0198-0.13247-0.0396-0.26493-0.0594-0.39739,0.009-0.009,0.0168-0.005,0.0248,0.003,0.13049,0.0937,0.26038,0.18828,0.39126,0.28143,0.03,0.0268,0.0758,0.0322,0.10783,0.0169,0.0119,0.01-0.00031,0.0141-0.009,0.0193-0.054,0.0343-0.10801,0.0686-0.16202,0.10282-0.0233-0.0221,0.035-0.0286,0.0248-0.0574-0.008-0.0294-0.039-0.0436-0.0616-0.0617-0.0171-0.0125-0.0341-0.0249-0.0512-0.0374zm-0.0245-0.019c-0.0629-0.0452-0.12573-0.0904-0.1886-0.13559,0.0114,0.0778,0.0229,0.15568,0.0343,0.23352,0.0514-0.0326,0.10287-0.0653,0.1543-0.0979z'/%3E %3Cpath d='m494.34,305.91c0.0313,0.0505,0.0614,0.10175,0.0936,0.15164,0.0152,0.0351,0.058,0.0379,0.0844,0.0145,0.007-0.0111,0.0164-0.00002,0.0161,0.007-0.0637,0.0404-0.12741,0.0808-0.19111,0.12127-0.009-0.009-0.009-0.0157,0.004-0.0198,0.0415-0.0169,0.0404-0.067,0.0137-0.0967-0.064-0.10453-0.12741-0.2094-0.19202-0.31353-0.0144-0.0363-0.0581-0.0447-0.0861-0.0188-0.008,0.0108-0.0173,0.002-0.0171-0.007,0.0665-0.0415,0.1316-0.0852,0.19925-0.12469,0.0481-0.0279,0.10921-0.0423,0.16167-0.0175,0.0742,0.0342,0.10514,0.13869,0.0575,0.20637-0.0334,0.0497-0.0892,0.0772-0.14387,0.0973l0.0003-0.00063zm-0.0118-0.0192c0.0421-0.0153,0.0916-0.0371,0.10055-0.0866,0.0156-0.0633-0.0302-0.13153-0.0901-0.15135-0.0478-0.0141-0.095,0.0146-0.12592,0.0493,0.0385,0.0629,0.077,0.1258,0.1155,0.1887z'/%3E %3Cpath d='m494.92,305.84c0.008,0.009,0.009,0.0155-0.003,0.0196-0.0604,0.0383-0.12072,0.0766-0.18108,0.11491-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0384-0.0159,0.0429-0.0624,0.0171-0.0919-0.0649-0.10663-0.12985-0.21332-0.19549-0.31953-0.0142-0.0373-0.0597-0.042-0.0877-0.0172-0.007,0.0114-0.0179-0.004-0.0138-0.009,0.0633-0.0402,0.12659-0.0803,0.18988-0.12049,0.008,0.009,0.009,0.0155-0.003,0.0196-0.0385,0.0159-0.0428,0.0625-0.0173,0.0922,0.0631,0.10426,0.12697,0.2081,0.19059,0.31207,0.0137,0.0385,0.0595,0.0544,0.0912,0.0256,0.003-0.002,0.007-0.004,0.01-0.007z'/%3E %3Cpath d='m495.05,305.13c0.0234,0.0345,0.0468,0.069,0.0702,0.10356-0.0241,0.0215-0.0351-0.036-0.0638-0.0338-0.0435-0.0148-0.0807,0.0182-0.11567,0.0392-0.009,0.006-0.0175,0.0111-0.0262,0.0166,0.074,0.12065,0.14727,0.24181,0.22182,0.36214,0.0146,0.0369,0.0586,0.043,0.0862,0.0172,0.007-0.0129,0.021,0.006,0.0122,0.01-0.062,0.0394-0.12411,0.0788-0.18616,0.11813-0.0109-0.01-0.006-0.0165,0.006-0.0214,0.043-0.0189,0.0333-0.07,0.008-0.0993-0.0706-0.11542-0.14112-0.23084-0.21168-0.34626-0.0336,0.023-0.0722,0.0404-0.099,0.0718-0.0239,0.03-0.002,0.0738-0.00019,0.0997-0.0106,0.0122-0.0132-0.007-0.0188-0.0139-0.0165-0.0303-0.033-0.0606-0.0494-0.0908,0.12214-0.0774,0.24429-0.15488,0.36643-0.23232z'/%3E %3Cpath d='m495.41,304.93c-0.0123-0.0106-0.004-0.0169,0.007-0.0222,0.0478-0.0303,0.0957-0.0607,0.1435-0.0911,0.0123,0.0106,0.004,0.0169-0.007,0.0222-0.0419,0.022-0.0291,0.0752-0.004,0.10503,0.0445,0.0741,0.0915,0.1468,0.13397,0.22213,0.0255,0.046,0.0419,0.10158,0.0228,0.15302-0.0239,0.0751-0.0969,0.12062-0.16619,0.14868-0.068,0.0276-0.15055-0.001-0.18949-0.0627-0.0503-0.0716-0.0931-0.14802-0.13944-0.22212-0.0178-0.0266-0.0313-0.0622-0.0643-0.0722-0.0218-0.005-0.0413,0.0165-0.0578,0.0207-0.0134-0.0109,0.0003-0.0158,0.01-0.0216,0.059-0.0375,0.11805-0.0749,0.17707-0.11235,0.0123,0.0106,0.004,0.0169-0.007,0.0222-0.0422,0.0191-0.0331,0.0703-0.008,0.0997,0.0451,0.0729,0.0886,0.14674,0.13478,0.21889,0.0287,0.0403,0.0639,0.0886,0.1188,0.0886,0.0617,0.00062,0.11796-0.0422,0.14777-0.0941,0.0237-0.0385,0.023-0.0876,0.002-0.12698-0.0339-0.0682-0.077-0.13129-0.11577-0.19675-0.0209-0.0319-0.037-0.0676-0.0648-0.0942-0.0246-0.0172-0.0513,0.003-0.0729,0.0152z'/%3E %3Cpath d='m496.15,304.88c0.0131-0.0102,0.015,0.002,0.017,0.0133,0.0108,0.0432,0.0217,0.0864,0.0325,0.12962-0.11591,0.0736-0.23183,0.14711-0.34774,0.22066-0.0112-0.0101-0.005-0.0165,0.006-0.0216,0.0443-0.0195,0.0327-0.0717,0.007-0.1018-0.0628-0.10223-0.12472-0.20499-0.18807-0.30687-0.0147-0.0367-0.0591-0.0443-0.0871-0.0183-0.007,0.0131-0.0225-0.004-0.0133-0.009,0.0663-0.0421,0.13267-0.0842,0.199-0.12628,0.0222,0.023-0.0326,0.0284-0.0381,0.0509-0.0235,0.0321,0.007,0.0654,0.0225,0.0937,0.0593,0.0965,0.11779,0.19363,0.17763,0.28984,0.0216,0.0461,0.0689,0.0136,0.0973-0.007,0.0385-0.0258,0.0837-0.0469,0.10685-0.0888,0.0183-0.0368,0.0126-0.0793,0.008-0.11843z'/%3E %3Cpath d='m496.23,304.38c0.0997-0.0666,0.24302-0.0399,0.32136,0.0477,0.0674,0.0732,0.10284,0.17963,0.0757,0.27743-0.0269,0.12069-0.15301,0.20988-0.2758,0.19252-0.0851-0.009-0.15869-0.0663-0.20096-0.13907-0.048-0.0742-0.0593-0.17102-0.0254-0.25317,0.02-0.052,0.058-0.096,0.10511-0.12536zm0.009,0.0285c-0.0521,0.0299-0.077,0.0925-0.0695,0.15074,0.009,0.0814,0.0533,0.15489,0.10477,0.21688,0.0428,0.0488,0.10552,0.0929,0.17375,0.0811,0.0729-0.0137,0.12916-0.0831,0.12809-0.15725-0.001-0.0786-0.0441-0.14916-0.0883-0.21127-0.0403-0.0535-0.0971-0.10671-0.16845-0.10652-0.0287,0.00043-0.0565,0.0109-0.0804,0.0263z'/%3E %3Cpath d='m497.12,303.82c0.0213,0.0202-0.0246,0.0332-0.0203,0.0578-0.006,0.0467,0.008,0.0927,0.0138,0.13874,0.0225,0.13699,0.0451,0.27398,0.0676,0.41097-0.009,0.01-0.0173,0.007-0.0257-0.001-0.13844-0.0966-0.27636-0.19398-0.41514-0.29008-0.0254-0.0281-0.067-0.007-0.0905-0.005-0.012-0.01,0.004-0.0132,0.0112-0.0188,0.0556-0.0353,0.11128-0.0706,0.16692-0.10592,0.024,0.0235-0.0383,0.0322-0.0274,0.0619,0.009,0.0307,0.0409,0.0462,0.0651,0.0646,0.088,0.0616,0.17599,0.1233,0.26399,0.18495-0.0198-0.11767-0.0389-0.23545-0.0591-0.35304,0.002-0.0434-0.0417-0.0709-0.0774-0.0443-0.007,0.004-0.0169-0.0149-0.003-0.0156,0.0433-0.0282,0.0867-0.0564,0.13007-0.0846z'/%3E %3Cpath d='m497.61,304.13c0.008,0.009,0.009,0.0155-0.003,0.0196-0.0604,0.0383-0.12072,0.0766-0.18108,0.11491-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0384-0.0159,0.0429-0.0624,0.0171-0.0919-0.065-0.10663-0.12985-0.21331-0.1955-0.31951-0.0142-0.0373-0.0597-0.0421-0.0877-0.0172-0.007,0.0114-0.0179-0.004-0.0138-0.009,0.0633-0.0402,0.12659-0.0803,0.18989-0.12049,0.008,0.009,0.009,0.0155-0.003,0.0196-0.0385,0.0159-0.0428,0.0625-0.0173,0.0922,0.0631,0.10426,0.12697,0.2081,0.19059,0.31207,0.0137,0.0385,0.0595,0.0544,0.0912,0.0256,0.003-0.002,0.007-0.004,0.01-0.007z'/%3E %3Cpath d='m497.84,303.98c0.008,0.009,0.009,0.0155-0.003,0.0196-0.0604,0.0383-0.12072,0.0766-0.18108,0.11491-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0384-0.0159,0.0429-0.0624,0.0171-0.0919-0.065-0.10663-0.12985-0.21331-0.1955-0.31951-0.0142-0.0373-0.0597-0.042-0.0877-0.0172-0.007,0.0114-0.0179-0.004-0.0138-0.009,0.0633-0.0402,0.12659-0.0803,0.18989-0.12049,0.008,0.009,0.009,0.0155-0.003,0.0196-0.0385,0.0159-0.0428,0.0625-0.0173,0.0921,0.0631,0.10428,0.12698,0.20812,0.19059,0.3121,0.0137,0.0385,0.0595,0.0544,0.0912,0.0256,0.003-0.002,0.007-0.004,0.01-0.007z'/%3E %3Cpath d='m498.06,303.84c0.008,0.009,0.009,0.0155-0.003,0.0196-0.0604,0.0383-0.12072,0.0766-0.18108,0.11491-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0384-0.0159,0.0429-0.0624,0.0171-0.0919-0.065-0.10663-0.12986-0.21331-0.19551-0.31951-0.0142-0.0373-0.0597-0.042-0.0877-0.0172-0.007,0.0114-0.0179-0.004-0.0138-0.009,0.0633-0.0402,0.12659-0.0803,0.18989-0.12049,0.008,0.009,0.009,0.0155-0.003,0.0196-0.0385,0.0159-0.0428,0.0625-0.0173,0.0922,0.0631,0.10426,0.12697,0.2081,0.19059,0.31207,0.0137,0.0385,0.0595,0.0544,0.0912,0.0256,0.003-0.002,0.007-0.004,0.01-0.007z'/%3E %3Cpath d='m494.14,307.96c-0.009-0.0549-0.003-0.12048,0.0427-0.15826,0.0356-0.0315,0.0884-0.0494,0.1338-0.0285,0.0532,0.019,0.0713,0.0819,0.0601,0.13283,0.002,0.0144-0.018,0.0457-0.005,0.0473,0.0536-0.011,0.11311,0.0101,0.14348,0.0567,0.0488,0.0655,0.0448,0.16278-0.008,0.22465-0.0321,0.0374-0.074,0.0679-0.12114,0.0829-0.0342,0.0149-0.0691-0.0323-0.0331-0.0538,0.038-0.0209,0.0891-0.003,0.12315-0.0357,0.0472-0.037,0.0482-0.11324,0.007-0.15539-0.0287-0.0348-0.0755-0.0526-0.11983-0.0417-0.0247,0.00061-0.0494,0.0187-0.0686,0.027-0.0149-0.0175,0.025-0.0272,0.0267-0.0458,0.0297-0.0416,0.0328-0.10108,0.00055-0.14218-0.0307-0.0482-0.10484-0.0459-0.13867-0.003-0.0258,0.0232-0.0239,0.0669-0.0334,0.0915-0.003,0.00034-0.006,0.00068-0.01,0.001z'/%3E %3Cpath d='m494.5,307.67c0.0254-0.0411,0.0508-0.0822,0.0762-0.12338,0.008-0.008,0.0138-0.007,0.0173,0.004,0.0798,0.13029,0.15914,0.26089,0.23928,0.39098,0.0113,0.0313,0.0462,0.0457,0.0732,0.023,0.0107-0.0119,0.0172-0.008,0.0222,0.004-0.0563,0.0357-0.1126,0.0715-0.1689,0.10717-0.0223-0.0219,0.03-0.0262,0.0323-0.0493,0.008-0.0282-0.0174-0.0517-0.029-0.0756-0.0562-0.0912-0.11106-0.18318-0.16819-0.27376-0.0115-0.0298-0.0522-0.0525-0.0718-0.0158-0.009,0.0125-0.01,0.0201-0.0226,0.009z'/%3E %3Cpath d='m495.23,307.16c0.0522-0.0331,0.10443-0.0663,0.15664-0.0994,0.0199,0.0169-0.0147,0.0196-0.0186,0.0367-0.0324,0.0472-0.0225,0.1067-0.0251,0.16085-0.00081,0.0649-0.002,0.12972-0.002,0.19458,0.0293,0.0467,0.0563,0.095,0.0876,0.14034,0.0183,0.0336,0.0585,0.0216,0.0826,0.003,0.009-0.004,0.0164,0.0161,0.001,0.0168-0.06,0.0381-0.12005,0.0762-0.18008,0.11427-0.0121-0.0105-0.005-0.0168,0.007-0.0221,0.0434-0.0198,0.0307-0.071,0.006-0.10029-0.0213-0.0349-0.0427-0.0698-0.064-0.10464-0.0938-0.0434-0.1867-0.0889-0.28124-0.13071-0.0255-0.018-0.0651,0.004-0.0836-0.002-0.0105-0.0102,0.0118-0.0132,0.0173-0.0199,0.0569-0.0361,0.11381-0.0722,0.17071-0.10833,0.0204,0.0176-0.0162,0.0204-0.0215,0.0364-0.0289,0.038,0.0237,0.061,0.0524,0.0733,0.0579,0.0275,0.11574,0.055,0.17361,0.0825,0.0004-0.0722,0.002-0.14432,0.002-0.21647,0.009-0.0454-0.0429-0.0733-0.0748-0.045-0.002-0.003-0.004-0.007-0.005-0.01z'/%3E %3Cpath d='m496.05,307.2c-0.008,0.0518-0.0425,0.10117-0.0945,0.1154-0.0685,0.0193-0.14239-0.0196-0.1783-0.0784-0.0436-0.0652-0.0543-0.15594-0.0162-0.22606,0.0265-0.0439,0.0793-0.0795,0.1323-0.0672-0.0253-0.0402-0.048-0.0821-0.0768-0.1199-0.0173-0.0266-0.0437,0.001-0.0556,0.0106-0.0126-0.005-0.007-0.0126,0.0001-0.0203,0.0199-0.0274,0.0388-0.056,0.0593-0.0827,0.008-0.006,0.0162-0.0114,0.0197,0.002,0.0786,0.12807,0.15622,0.2568,0.23564,0.38439,0.0104,0.0266,0.0469,0.0546,0.0668,0.0201,0.005-0.0145,0.0238,0.005,0.01,0.0117-0.0206,0.0287-0.0402,0.0584-0.0614,0.0863-0.008,0.005-0.016,0.0141-0.0192,0.00041-0.007-0.012-0.0143-0.0241-0.0215-0.0361zm-0.0143-0.0235c-0.0323-0.0528-0.0646-0.10561-0.0969-0.15842-0.0249-0.0371-0.0779-0.0607-0.1189-0.0351-0.0453,0.0303-0.0441,0.0949-0.0243,0.13998,0.0257,0.059,0.0696,0.12203,0.13795,0.13234,0.0386,0.008,0.0813-0.0132,0.0941-0.0514,0.004-0.009,0.006-0.0183,0.008-0.0274z'/%3E %3Cpath d='m496.13,306.94c0.0276,0.0482,0.0749,0.0905,0.13276,0.0932,0.0542,0.005,0.11073-0.0363,0.11486-0.0922,0.005-0.0169-0.006-0.0432-0.00098-0.0546,0.023-0.005,0.0176,0.0319,0.0238,0.0458,0.007,0.0526-0.006,0.11301-0.0504,0.14615-0.0454,0.0375-0.11245,0.0401-0.16318,0.0121-0.0521-0.0287-0.0862-0.0818-0.10606-0.13652-0.0243-0.0652-0.006-0.14588,0.0512-0.18814,0.0379-0.0313,0.0927-0.0435,0.13836-0.0226,0.0267,0.0121,0.0625,0.0406,0.0657,0.0659-0.0686,0.0437-0.13729,0.0873-0.20594,0.13098zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14041-0.0891-0.0186-0.0338-0.0571-0.0608-0.0968-0.0483-0.0484,0.013-0.0691,0.0731-0.0519,0.11733,0.002,0.007,0.005,0.0136,0.008,0.0201z'/%3E %3Cpath d='m496.69,306.7c0.0218,0.0554,0.022,0.12259-0.0136,0.1724-0.0315,0.0455-0.0926,0.0655-0.14531,0.0499-0.0657-0.016-0.11195-0.0731-0.1376-0.13285-0.0334-0.0755-0.009-0.17522,0.0634-0.21874,0.0382-0.0258,0.0916-0.0331,0.13173-0.008,0.0297,0.0155,0.0272,0.0615-0.007,0.0697-0.046,0.0211-0.0551-0.0594-0.10189-0.0414-0.0479,0.0126-0.0682,0.0674-0.0561,0.11218,0.0151,0.0639,0.0618,0.12138,0.12358,0.14514,0.0492,0.0204,0.10832-0.0108,0.12597-0.0595,0.0147-0.0268,0.003-0.0648,0.007-0.0883,0.003-0.00029,0.006-0.00057,0.009-0.00086z'/%3E %3Cpath d='m496.59,306.26c0.0471-0.0324,0.0877,0.0541,0.0346,0.072-0.0448,0.0172-0.0753-0.0474-0.0346-0.072zm0.12577,0.14333c0.0532,0.0866,0.10569,0.17374,0.1594,0.26006,0.0125,0.0301,0.049,0.0388,0.0727,0.0157,0.005,0.007,0.01,0.0146-0.002,0.0178-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0206-0.0213,0.0314-0.025,0.0236-0.0512-0.003-0.0293-0.024-0.0526-0.0379-0.0778-0.0308-0.0493-0.0591-0.10025-0.0933-0.14736-0.0149-0.0264-0.0449-0.008-0.0563,0.009-0.008-0.005-0.0142-0.009-0.005-0.0167,0.0212-0.0292,0.0416-0.0592,0.0634-0.0878,0.005-0.003,0.009-0.006,0.0137-0.009z'/%3E %3Cpath d='m497.13,306.51c-0.0161,0.038-0.0243,0.0841-0.0609,0.1087-0.0422,0.0349-0.10789,0.0122-0.1288-0.0357-0.0228-0.0398-0.004-0.0869,0.0161-0.12353,0.0222-0.0383,0.049-0.0738,0.0759-0.10895-0.015-0.0258-0.0312-0.0542-0.06-0.0661-0.0416-0.0135-0.098,0.0315-0.0755,0.0755,0.0101,0.0162,0.0264,0.0338,0.0174,0.0542-0.0178,0.0388-0.0703,0.013-0.0697-0.0235-0.007-0.0522,0.0301-0.0986,0.0727-0.12403,0.0339-0.0213,0.0797-0.0412,0.11755-0.018,0.0279,0.0198,0.0425,0.0521,0.0607,0.0802,0.0283,0.0455,0.0548,0.0923,0.0856,0.13619,0.0189,0.0259,0.0416-0.005,0.0408-0.0267,0.001-0.012,0.003-0.0184,0.009-0.006,0.0153,0.0206-0.002,0.0491-0.007,0.071-0.01,0.0376-0.0629,0.058-0.085,0.0192-0.005,0.001-0.004-0.0144-0.009-0.0121zm-0.0133-0.0218c-0.0239-0.039-0.0477-0.0781-0.0716-0.11712-0.027,0.0399-0.0638,0.0791-0.0659,0.12982-0.001,0.0409,0.0412,0.0814,0.0822,0.0676,0.0317-0.0134,0.0443-0.0512,0.0552-0.0803z'/%3E %3Cpath d='m497.23,305.88c-0.006-0.008-0.0109-0.0148,0.001-0.0183,0.061-0.0387,0.12202-0.0774,0.18303-0.11614,0.006,0.008,0.0109,0.0148-0.001,0.0184-0.033,0.0141-0.0484,0.0546-0.024,0.0841,0.0515,0.0874,0.10613,0.17298,0.15785,0.26027,0.0265,0.045,0.0423,0.10013,0.0248,0.15129-0.0132,0.0442-0.0561,0.0805-0.10275,0.0815-0.0487,0.006-0.0785-0.0725-0.0234-0.0862,0.035-0.011,0.0649,0.0547,0.094,0.0211,0.0106-0.0304-0.0136-0.0562-0.0276-0.0813-0.0619-0.10087-0.12312-0.20217-0.18546-0.30277-0.0141-0.0368-0.0591-0.0422-0.0872-0.0178-0.003,0.002-0.006,0.004-0.009,0.006z'/%3E %3Cpath d='m497.65,305.97c0.0277,0.0482,0.0749,0.0905,0.1328,0.0932,0.0542,0.005,0.11067-0.0363,0.11482-0.0922,0.005-0.0169-0.006-0.0432-0.00098-0.0547,0.023-0.005,0.0176,0.0319,0.0238,0.0458,0.007,0.0526-0.006,0.11301-0.0504,0.14615-0.0431,0.0355-0.106,0.0399-0.15559,0.0158-0.0564-0.0271-0.0928-0.0831-0.11361-0.14031-0.0244-0.0652-0.006-0.14587,0.0511-0.18814,0.0378-0.0313,0.0927-0.0435,0.13836-0.0226,0.0267,0.0121,0.0625,0.0406,0.0657,0.0659-0.0686,0.0437-0.13729,0.0874-0.20593,0.13108zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14042-0.0891-0.0186-0.0338-0.0571-0.0609-0.0968-0.0483-0.0484,0.013-0.0691,0.0732-0.0519,0.11738,0.002,0.007,0.005,0.0136,0.008,0.0201z'/%3E %3Cpath d='m498.02,305.56c0.0213,0.0349,0.0427,0.0698,0.064,0.10473-0.0171,0.0178-0.0291-0.0175-0.046-0.0223-0.0366-0.031-0.0948-0.0203-0.12179,0.0178-0.0305,0.0392,0.0142,0.0893,0.058,0.0819,0.0468-0.00076,0.0931-0.014,0.13992-0.008,0.0451,0.004,0.0821,0.0426,0.0867,0.0872,0.005,0.0547-0.0328,0.10681-0.0824,0.12728-0.0254,0.0164-0.0678,0.0127-0.0775,0.0444-0.007,0.008-0.0101,0.001-0.0135-0.006-0.0203-0.0332-0.0405-0.0663-0.0608-0.0995,0.0171-0.0179,0.0276,0.0181,0.0447,0.0225,0.0403,0.0292,0.10379,0.0291,0.13679-0.0112,0.0258-0.0298,0.008-0.0796-0.0294-0.0896-0.0584-0.0136-0.11857,0.0105-0.17711-0.003-0.0566-0.0166-0.0842-0.0893-0.0578-0.14087,0.0182-0.0397,0.0602-0.061,0.10096-0.0704,0.0163-0.001,0.0282-0.0137,0.0251-0.0296,0.003-0.002,0.007-0.004,0.0103-0.006z'/%3E %3Cpath d='m498.37,305.37c0.0486,0.0787,0.0956,0.15843,0.14574,0.23619,0.0128,0.0335,0.0524,0.0268,0.0661,0.004,0.01,0.004,0.0108,0.0101,0.003,0.0172-0.0207,0.0287-0.0405,0.0584-0.0618,0.0864-0.007,0.003-0.0151,0.0137-0.0179,0.001-0.0119-0.0194-0.0238-0.0388-0.0356-0.0583-0.0101,0.045-0.0163,0.0984-0.0576,0.12682-0.0358,0.0291-0.0917,0.0195-0.11957-0.0159-0.0329-0.0388-0.0561-0.0844-0.0834-0.12708-0.0183-0.0283-0.0333-0.059-0.0553-0.0846-0.0195-0.0219-0.0491,0.006-0.0645,0.005-0.009-0.008-0.003-0.0123,0.005-0.0162,0.0317-0.0201,0.0634-0.0402,0.0951-0.0604,0.0442,0.0719,0.0877,0.14421,0.13229,0.21589,0.0178,0.0425,0.0773,0.0513,0.10349,0.0122,0.0143-0.023,0.0381-0.0569,0.0266-0.0835-0.0353-0.0575-0.0701-0.11514-0.10561-0.17244-0.0139-0.0323-0.0517-0.0237-0.0731-0.009-0.006-0.007-0.01-0.0137,0.002-0.017,0.0318-0.0202,0.0635-0.0403,0.0953-0.0605z'/%3E %3Cpath d='m498.63,305.18c0.0213,0.0349,0.0427,0.0698,0.064,0.10473-0.0171,0.0178-0.0291-0.0175-0.046-0.0223-0.0366-0.031-0.0948-0.0204-0.12176,0.0178-0.0304,0.0393,0.0143,0.0893,0.0581,0.0819,0.0468-0.00077,0.093-0.014,0.13988-0.008,0.0451,0.004,0.0821,0.0428,0.0867,0.0873,0.005,0.0547-0.0328,0.10681-0.0824,0.12728-0.0254,0.0164-0.0678,0.0127-0.0776,0.0444-0.007,0.008-0.0101,0.001-0.0135-0.006-0.0203-0.0332-0.0405-0.0663-0.0608-0.0995,0.0171-0.0179,0.0276,0.0181,0.0447,0.0225,0.0403,0.0292,0.10379,0.029,0.13679-0.0112,0.0258-0.0298,0.008-0.0796-0.0294-0.0896-0.0607-0.0144-0.12408,0.0133-0.18438-0.005-0.0536-0.0217-0.0767-0.0934-0.0481-0.14322,0.0194-0.037,0.0596-0.0564,0.0986-0.0657,0.0163-0.002,0.0281-0.0138,0.025-0.0297,0.003-0.002,0.007-0.004,0.0102-0.006z'/%3E %3Cpath d='m499.2,305.2c-0.016,0.038-0.0243,0.084-0.0609,0.1087-0.0422,0.0349-0.10789,0.0122-0.1288-0.0357-0.0228-0.0398-0.004-0.0869,0.0161-0.12353,0.0223-0.0383,0.049-0.0738,0.0759-0.10895-0.015-0.0258-0.0313-0.0542-0.06-0.0662-0.0416-0.0135-0.098,0.0315-0.0755,0.0755,0.0101,0.0162,0.0264,0.0338,0.0174,0.0542-0.0178,0.0388-0.0704,0.013-0.0697-0.0235-0.007-0.0522,0.0301-0.0987,0.0727-0.12403,0.0339-0.0213,0.0798-0.0412,0.11755-0.018,0.0279,0.0198,0.0425,0.052,0.0607,0.0802,0.0283,0.0455,0.0548,0.0923,0.0856,0.13618,0.0189,0.0259,0.0416-0.005,0.0409-0.0267,0.001-0.012,0.003-0.0184,0.009-0.006,0.0153,0.0206-0.002,0.0491-0.007,0.0709-0.01,0.0376-0.0629,0.058-0.085,0.0192l-0.004-0.006-0.004-0.006-0.0002,0.00022zm-0.0133-0.0218c-0.0239-0.039-0.0477-0.0781-0.0716-0.11712-0.027,0.0399-0.0636,0.0792-0.0659,0.12982-0.001,0.0409,0.0412,0.0814,0.0822,0.0676,0.0317-0.0134,0.0443-0.0512,0.0552-0.0803z'/%3E %3Cpath d='m494.69,308.65c0.086,0.14022,0.17122,0.28091,0.25767,0.42083,0.0129,0.0377,0.0552,0.0283,0.0771,0.0154,0.009,0.008,0.003,0.0132-0.006,0.0172-0.0457,0.029-0.0914,0.058-0.13711,0.087-0.0208-0.0209,0.0301-0.0249,0.0223-0.0504-0.004-0.0298-0.0248-0.0535-0.039-0.0792-0.0593-0.0964-0.11741-0.19349-0.17767-0.28927-0.01-0.0264-0.0444-0.0464-0.0619-0.0153-0.003,0.0122-0.0258-0.003-0.0122-0.01,0.0211-0.0292,0.0413-0.0594,0.063-0.0879,0.005-0.003,0.009-0.006,0.0138-0.009z'/%3E %3Cpath d='m495.02,308.65c0.0462-0.0315,0.10829-0.0357,0.15838-0.0109,0.0715,0.0315,0.11325,0.10884,0.11633,0.18484,0.005,0.0611-0.0267,0.12262-0.0791,0.1543-0.0463,0.0319-0.10898,0.0337-0.15806,0.007-0.0726-0.0344-0.11572-0.11469-0.11438-0.19363-0.002-0.0568,0.0296-0.1115,0.0768-0.14159zm0.003,0.0283c-0.0383,0.0235-0.0438,0.076-0.0277,0.11468,0.0251,0.0647,0.0712,0.12433,0.1346,0.15498,0.0396,0.0216,0.0961,0.008,0.11462-0.0353,0.0207-0.0455-0.005-0.0939-0.0283-0.13282-0.0309-0.0504-0.0746-0.0998-0.13475-0.11297-0.0201-0.004-0.0429,0.002-0.0584,0.0114z'/%3E %3Cpath d='m495.4,308.41c0.0213,0.0349,0.0427,0.0698,0.064,0.10473-0.0171,0.0178-0.0291-0.0175-0.046-0.0223-0.0365-0.0307-0.0948-0.0201-0.12174,0.0178-0.0304,0.0392,0.0143,0.0893,0.058,0.0819,0.0468-0.00076,0.0931-0.014,0.13992-0.008,0.0451,0.004,0.0821,0.0427,0.0867,0.0872,0.005,0.0547-0.0328,0.10681-0.0824,0.12728-0.0254,0.0164-0.0678,0.0127-0.0775,0.0444-0.007,0.008-0.0101,0.001-0.0135-0.006-0.0203-0.0332-0.0406-0.0663-0.0608-0.0995,0.0171-0.0179,0.0276,0.0181,0.0447,0.0225,0.0403,0.0292,0.10378,0.029,0.13679-0.0112,0.0258-0.0298,0.008-0.0796-0.0294-0.0896-0.0584-0.0136-0.11857,0.0105-0.17711-0.003-0.0565-0.0166-0.0841-0.0893-0.0577-0.14086,0.0183-0.0397,0.0603-0.0608,0.10096-0.0703,0.0163-0.001,0.0281-0.0138,0.025-0.0296,0.003-0.002,0.007-0.004,0.0102-0.006z'/%3E %3Cpath d='m495.62,308.06c0.0477-0.0323,0.089,0.054,0.0352,0.0728-0.0456,0.017-0.0747-0.0476-0.0352-0.0728zm0.12696,0.14301c0.0658,0.10808,0.13241,0.21571,0.19771,0.32409,0.0297,0.0505,0.0461,0.11732,0.0134,0.17047-0.0241,0.0359-0.0695,0.0748-0.11542,0.0589-0.0417-0.0271,0.008-0.0789,0.0456-0.0599,0.0369,0.0172,0.0722-0.0228,0.0483-0.0566-0.0339-0.0644-0.0744-0.12514-0.11165-0.18764-0.0316-0.05-0.0597-0.10239-0.0956-0.14951-0.0179-0.0288-0.0432,0.008-0.0561,0.01-0.0143-0.005-0.002-0.0139,0.003-0.0217,0.0197-0.0267,0.0382-0.0548,0.0586-0.0808,0.004-0.002,0.008-0.005,0.0122-0.007z'/%3E %3Cpath d='m496.11,307.99c0.0486,0.0787,0.0956,0.15843,0.14574,0.23619,0.0128,0.0335,0.0524,0.0268,0.0661,0.004,0.01,0.004,0.0108,0.0101,0.003,0.0172-0.0207,0.0287-0.0405,0.0584-0.0618,0.0864-0.007,0.003-0.015,0.0137-0.0179,0.001-0.0119-0.0194-0.0238-0.0388-0.0356-0.0583-0.0102,0.045-0.0163,0.0984-0.0576,0.12675-0.0358,0.0291-0.0917,0.0194-0.11957-0.016-0.0326-0.0384-0.0556-0.0837-0.0827-0.12604-0.0185-0.0287-0.0338-0.0598-0.056-0.0858-0.0194-0.022-0.0491,0.006-0.0645,0.005-0.009-0.008-0.003-0.0123,0.005-0.0162,0.0317-0.0201,0.0634-0.0402,0.0951-0.0603,0.0442,0.0719,0.0877,0.14421,0.1323,0.21588,0.0178,0.0425,0.0773,0.0513,0.10349,0.0122,0.0143-0.023,0.0381-0.0569,0.0266-0.0835-0.0352-0.0575-0.0701-0.11514-0.10561-0.17244-0.0139-0.0323-0.0517-0.0236-0.0731-0.009-0.006-0.007-0.01-0.0137,0.002-0.017,0.0318-0.0201,0.0635-0.0402,0.0953-0.0604z'/%3E %3Cpath d='m496.56,308.09c-0.008,0.0518-0.0425,0.1011-0.0945,0.1153-0.0685,0.0193-0.14239-0.0196-0.1783-0.0784-0.0436-0.0653-0.0543-0.15596-0.0162-0.2261,0.0266-0.0439,0.0793-0.0795,0.1323-0.0671-0.0253-0.0402-0.048-0.0821-0.0768-0.1199-0.0173-0.0266-0.0437,0.001-0.0557,0.0105-0.0125-0.005-0.007-0.0126,0.0001-0.0203,0.0199-0.0274,0.0388-0.056,0.0593-0.0827,0.008-0.006,0.0162-0.0114,0.0197,0.002,0.0786,0.12807,0.15622,0.2568,0.23564,0.38439,0.0104,0.0266,0.0469,0.0546,0.0668,0.0201,0.005-0.0145,0.0238,0.005,0.01,0.0117-0.0206,0.0287-0.0402,0.0584-0.0614,0.0863-0.008,0.005-0.016,0.0141-0.0192,0.00041-0.007-0.012-0.0143-0.0239-0.0214-0.0359zm-0.0144-0.0235c-0.0323-0.0528-0.0645-0.10561-0.0968-0.15842-0.0249-0.0371-0.0779-0.0606-0.1189-0.035-0.0453,0.0303-0.0441,0.0949-0.0243,0.13998,0.0256,0.059,0.0696,0.12197,0.13795,0.13234,0.0386,0.008,0.0813-0.0132,0.0941-0.0514,0.004-0.009,0.006-0.0182,0.008-0.0275z'/%3E %3Cpath d='m496.49,307.51c0.0471-0.0324,0.0877,0.0541,0.0346,0.072-0.0448,0.0172-0.0753-0.0474-0.0346-0.072zm0.12578,0.14333c0.0532,0.0866,0.10569,0.17374,0.15939,0.26006,0.0125,0.0301,0.0491,0.0388,0.0727,0.0157,0.005,0.007,0.01,0.0146-0.002,0.0178-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0206-0.0213,0.0315-0.0251,0.0236-0.0513-0.003-0.0294-0.024-0.0527-0.0379-0.0779-0.0308-0.0493-0.0591-0.10025-0.0933-0.14736-0.0149-0.0264-0.0449-0.008-0.0563,0.009-0.008-0.005-0.0142-0.009-0.005-0.0167,0.0213-0.0291,0.0416-0.0592,0.0634-0.0878,0.005-0.003,0.009-0.006,0.0137-0.009z'/%3E %3Cpath d='m496.84,307.5c0.0462-0.0315,0.1083-0.0357,0.15839-0.0109,0.0715,0.0315,0.11325,0.10884,0.11633,0.18484,0.005,0.0611-0.0267,0.12262-0.0791,0.1543-0.0463,0.0319-0.10896,0.0337-0.15803,0.007-0.0726-0.0344-0.11577-0.11467-0.11441-0.19363-0.002-0.0568,0.0296-0.11151,0.0768-0.14159zm0.003,0.0283c-0.0383,0.0235-0.0438,0.076-0.0277,0.11468,0.0251,0.0647,0.0713,0.1243,0.1346,0.15498,0.0397,0.0217,0.0961,0.008,0.11462-0.0353,0.0207-0.0455-0.005-0.0939-0.0283-0.13281-0.0309-0.0504-0.0746-0.0998-0.13474-0.11298-0.0201-0.005-0.0428,0.002-0.0585,0.0114z'/%3E %3Cpath d='m497.23,307.25c0.0213,0.0349,0.0427,0.0698,0.064,0.10473-0.0212,0.0178-0.0367-0.0274-0.0596-0.0306-0.045-0.0275-0.11919,0.005-0.11806,0.0612,0.007,0.0459,0.0629,0.0527,0.10041,0.0447,0.0509-0.004,0.10669-0.0194,0.15271,0.0109,0.0435,0.0294,0.0538,0.0926,0.0268,0.13653-0.0242,0.0481-0.0778,0.0684-0.12637,0.0826-0.0126,0.003-0.0219,0.0436-0.0331,0.0165-0.0201-0.0329-0.0402-0.0657-0.0602-0.0986,0.0213-0.0178,0.0357,0.0291,0.0595,0.0312,0.0433,0.0235,0.10935,0.0133,0.13047-0.0349,0.0161-0.038-0.02-0.0801-0.0593-0.0783-0.0564-0.005-0.11507,0.0171-0.16948-0.004-0.0546-0.0274-0.0713-0.10598-0.0332-0.15358,0.0248-0.0354,0.0684-0.0456,0.10677-0.0586,0.0144-0.008,0.0002-0.0251,0.0187-0.0297z'/%3E %3Cpath d='m497.73,306.93c0.0834,0.13618,0.16632,0.27273,0.25015,0.40867,0.0128,0.0361,0.0535,0.0286,0.0758,0.0122,0.01,0.009,0.005,0.0147-0.005,0.0192-0.0468,0.0297-0.0936,0.0594-0.14036,0.0891-0.0187-0.0161,0.0107-0.0208,0.0189-0.034,0.0186-0.0258-0.007-0.0535-0.0197-0.0767-0.0246-0.0403-0.0492-0.0805-0.0738-0.12074-0.006,0.0505-0.0219,0.10886-0.0723,0.13205-0.0602,0.0277-0.13267-0.004-0.17135-0.0531-0.049-0.0585-0.0743-0.14158-0.0466-0.21533,0.0202-0.0584,0.075-0.11088,0.13938-0.11081,0.0256,0.002,0.0203-0.0445,0.0453-0.0505zm0.0933,0.27666c-0.0321-0.0519-0.0631-0.10445-0.0959-0.15593-0.0206-0.0369-0.0715-0.0435-0.10463-0.0202-0.0487,0.03-0.0556,0.0986-0.0318,0.1468,0.0243,0.0538,0.064,0.11368,0.12785,0.12119,0.0479,0.007,0.0979-0.029,0.10271-0.0781-0.004,0.0006,0.007-0.0149,0.002-0.0138z'/%3E %3Cpath d='m498.08,306.74c0.0486,0.0787,0.0956,0.15843,0.14573,0.23619,0.0128,0.0335,0.0524,0.0268,0.0661,0.004,0.01,0.004,0.0108,0.0101,0.003,0.0172-0.0207,0.0287-0.0405,0.0584-0.0618,0.0864-0.007,0.003-0.015,0.0137-0.0179,0.001-0.0119-0.0194-0.0238-0.0388-0.0356-0.0583-0.0102,0.045-0.0163,0.0984-0.0576,0.12675-0.0358,0.0291-0.0916,0.0194-0.11947-0.016-0.0326-0.0384-0.0556-0.0837-0.0827-0.12603-0.0185-0.0287-0.0338-0.0598-0.056-0.0858-0.0194-0.022-0.0491,0.006-0.0645,0.005-0.009-0.008-0.003-0.0123,0.005-0.0162,0.0317-0.0201,0.0634-0.0402,0.0951-0.0604,0.0442,0.0719,0.0877,0.14421,0.1323,0.21588,0.0178,0.0425,0.0773,0.0513,0.10349,0.0122,0.0143-0.023,0.0381-0.0569,0.0266-0.0835-0.0353-0.0575-0.0701-0.11514-0.10561-0.17243-0.0138-0.0323-0.0516-0.0237-0.073-0.009-0.006-0.007-0.01-0.0137,0.002-0.017,0.0317-0.0201,0.0634-0.0402,0.0951-0.0603z'/%3E %3Cpath d='m498.27,306.76c0.0276,0.0483,0.075,0.0905,0.1329,0.0932,0.0542,0.005,0.11067-0.0363,0.11482-0.0922,0.005-0.0169-0.006-0.0432-0.00098-0.0547,0.023-0.005,0.0176,0.0319,0.0238,0.0458,0.007,0.0526-0.006,0.113-0.0504,0.14611-0.0432,0.0355-0.10602,0.0399-0.15563,0.0158-0.0564-0.0271-0.0928-0.0831-0.1136-0.14031-0.0244-0.0652-0.006-0.14587,0.0511-0.18814,0.0378-0.0313,0.0927-0.0435,0.13835-0.0226,0.0267,0.0121,0.0625,0.0406,0.0657,0.0659-0.0687,0.0437-0.13735,0.0874-0.20602,0.13108zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14042-0.0891-0.0186-0.0338-0.0571-0.0609-0.0968-0.0483-0.0484,0.013-0.0691,0.0732-0.0519,0.11738,0.002,0.007,0.005,0.0136,0.008,0.0201z'/%3E %3Cpath d='m498.63,306.15c0.086,0.14022,0.17122,0.28092,0.25767,0.42084,0.0129,0.0377,0.0552,0.0283,0.0771,0.0155,0.009,0.008,0.003,0.0132-0.006,0.0172-0.0457,0.029-0.0914,0.058-0.13711,0.087-0.0208-0.021,0.03-0.0248,0.0223-0.0503-0.004-0.0298-0.0248-0.0535-0.039-0.0792-0.0593-0.0964-0.11741-0.19349-0.17767-0.28926-0.01-0.0264-0.0444-0.0464-0.0619-0.0153-0.003,0.0122-0.0258-0.003-0.0122-0.01,0.0211-0.0292,0.0413-0.0594,0.063-0.0879,0.005-0.003,0.009-0.006,0.0138-0.009z'/%3E %3Cpath d='m498.93,306.35c0.0276,0.0483,0.0749,0.0905,0.13286,0.0932,0.0542,0.005,0.11073-0.0363,0.11486-0.0923,0.005-0.0169-0.006-0.0432-0.00098-0.0546,0.023-0.005,0.0176,0.0319,0.0238,0.0459,0.007,0.0526-0.006,0.11298-0.0504,0.14611-0.0431,0.0355-0.10601,0.0399-0.1556,0.0158-0.0564-0.0271-0.0928-0.0831-0.1136-0.14031-0.0244-0.0652-0.006-0.14588,0.0511-0.18814,0.0379-0.0313,0.0927-0.0435,0.13838-0.0226,0.0267,0.0121,0.0624,0.0406,0.0656,0.0659-0.0687,0.0437-0.13735,0.0874-0.20602,0.13108zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14042-0.0891-0.0186-0.034-0.057-0.0604-0.0968-0.0487-0.0482,0.0135-0.0691,0.0734-0.0519,0.11775,0.002,0.007,0.005,0.0136,0.008,0.0201z'/%3E %3Cpath d='m495.2,309.52c0.0458,0.075,0.0917,0.14993,0.13749,0.22489,0.009-0.0489,0.0204-0.10685,0.0687-0.13219,0.0436-0.0264,0.0967,0.002,0.12174,0.0407,0.0423,0.0593,0.076,0.12428,0.11704,0.18439,0.0138,0.0303,0.0489,0.0138,0.0657,0.008,0.0113,0.0103-0.003,0.0143-0.011,0.0198-0.0442,0.0281-0.0884,0.0561-0.13266,0.0842-0.0197-0.0197,0.0237-0.0213,0.0254-0.0415,0.009-0.027-0.0143-0.0488-0.0259-0.0712-0.0318-0.0503-0.0601-0.10305-0.0961-0.15059-0.0308-0.0432-0.0915-0.0138-0.10552,0.0285-0.007,0.0216-0.0234,0.0478-0.005,0.0672,0.0353,0.0569,0.069,0.11487,0.10564,0.17091,0.0149,0.0346,0.0539,0.004,0.0701,0.006,0.0109,0.0102-0.007,0.0134-0.0131,0.0192-0.0442,0.0281-0.0884,0.0561-0.13261,0.0841-0.0204-0.0223,0.037-0.0292,0.0239-0.0584-0.0133-0.037-0.0378-0.0688-0.0573-0.10282-0.0547-0.0885-0.10755-0.17808-0.16373-0.2656-0.0132-0.0349-0.0515-0.0241-0.0664-0.004-0.0142-0.005-0.005-0.0135,0.001-0.0215,0.0198-0.0271,0.0384-0.0553,0.0589-0.0816,0.004-0.003,0.009-0.006,0.0135-0.009z'/%3E %3Cpath d='m495.88,309.68c-0.0161,0.038-0.0243,0.084-0.0609,0.1087-0.0422,0.0349-0.10789,0.0122-0.1288-0.0357-0.0228-0.0398-0.004-0.0869,0.0161-0.12353,0.0222-0.0383,0.049-0.0738,0.0759-0.10895-0.015-0.0258-0.0313-0.0542-0.06-0.0662-0.0416-0.0135-0.098,0.0315-0.0755,0.0755,0.0101,0.0162,0.0264,0.0338,0.0174,0.0542-0.0178,0.0388-0.0704,0.013-0.0697-0.0235-0.007-0.0522,0.0301-0.0987,0.0727-0.12403,0.0339-0.0213,0.0798-0.0412,0.11755-0.018,0.0279,0.0198,0.0425,0.0521,0.0607,0.0802,0.0283,0.0455,0.0548,0.0922,0.0856,0.13618,0.0189,0.0259,0.0416-0.005,0.0409-0.0267,0.001-0.012,0.003-0.0184,0.009-0.006,0.0153,0.0206-0.002,0.0491-0.007,0.0709-0.01,0.0376-0.0629,0.058-0.085,0.0192l-0.004-0.006-0.004-0.006-0.0002,0.00022zm-0.0133-0.0218c-0.0239-0.0391-0.0477-0.0781-0.0716-0.11714-0.0269,0.0399-0.0637,0.0792-0.0658,0.12982-0.001,0.0408,0.0411,0.0814,0.0821,0.0676,0.0317-0.0133,0.0443-0.0513,0.0552-0.0803z'/%3E %3Cpath d='m495.96,309.33c0.002-0.0521,0.0223-0.11159,0.0751-0.13184,0.0634-0.0261,0.13661,0.009,0.17397,0.0622,0.0415,0.0528,0.0634,0.12446,0.0437,0.19039-0.0154,0.0657-0.0698,0.11947-0.1361,0.13261-0.0234,0.00021-0.0613,0.0183-0.0781-0.001-0.0714-0.11629-0.14183-0.23324-0.21404-0.34905-0.0106-0.0271-0.0465-0.0532-0.0665-0.0189-0.004,0.0132-0.0251-0.004-0.0114-0.0107,0.0213-0.0292,0.0416-0.0595,0.0635-0.0881,0.007-0.005,0.0157-0.0128,0.0189,0.0002,0.0437,0.0715,0.0874,0.14294,0.13106,0.21441zm0.0131,0.0215c0.0375,0.0613,0.075,0.12263,0.11245,0.18394,0.0442,0.0114,0.10361,0.00038,0.12055-0.0478,0.0227-0.0583-0.006-0.12083-0.04-0.16806-0.0276-0.0404-0.0792-0.0712-0.1288-0.056-0.0385,0.0121-0.0568,0.0514-0.0642,0.0879z'/%3E %3Cpath d='m496.17,308.9c0.0473-0.0319,0.0875,0.054,0.0346,0.072-0.0447,0.0174-0.0755-0.0479-0.0346-0.072zm0.12577,0.14333c0.0532,0.0866,0.10569,0.17374,0.1594,0.26006,0.0125,0.0301,0.049,0.0388,0.0727,0.0157,0.005,0.007,0.01,0.0146-0.002,0.0178-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0206-0.0213,0.0315-0.0251,0.0236-0.0513-0.003-0.0294-0.024-0.0527-0.0379-0.0779-0.0309-0.0493-0.0591-0.10027-0.0933-0.14738-0.0149-0.0264-0.0449-0.008-0.0563,0.009-0.008-0.005-0.0142-0.009-0.005-0.0167,0.0212-0.0292,0.0416-0.0592,0.0634-0.0878,0.005-0.003,0.009-0.006,0.0136-0.009z'/%3E %3Cpath d='m496.71,309.15c-0.0161,0.038-0.0243,0.084-0.0609,0.10867-0.0422,0.0349-0.10785,0.0122-0.1288-0.0357-0.0228-0.0397-0.004-0.0869,0.0161-0.12343,0.0222-0.0383,0.049-0.0738,0.0759-0.10895-0.015-0.0258-0.0313-0.0542-0.06-0.0662-0.0416-0.0135-0.098,0.0315-0.0755,0.0755,0.0101,0.0162,0.0263,0.0338,0.0174,0.0542-0.0178,0.0388-0.0704,0.013-0.0697-0.0235-0.007-0.0522,0.0301-0.0987,0.0727-0.12403,0.0339-0.0213,0.0798-0.0411,0.11755-0.0179,0.0279,0.0198,0.0425,0.052,0.0607,0.0802,0.0284,0.0455,0.0548,0.0922,0.0856,0.13618,0.0189,0.0259,0.0416-0.005,0.0408-0.0267,0.001-0.012,0.003-0.0184,0.009-0.006,0.0153,0.0206-0.002,0.0491-0.007,0.0709-0.01,0.0376-0.0629,0.058-0.085,0.0192-0.005,0.00049-0.004-0.0132-0.009-0.0122zm-0.0133-0.0218c-0.0239-0.039-0.0477-0.0781-0.0716-0.11715-0.0269,0.0399-0.0636,0.0792-0.0659,0.12982-0.001,0.0408,0.0411,0.0814,0.0821,0.0676,0.0317-0.0134,0.0442-0.0513,0.0553-0.0803z'/%3E %3Cpath d='m496.81,308.82c0.007-0.0516,0.0227-0.11252,0.0743-0.13645,0.0441-0.0225,0.0942,0.008,0.1185,0.0453,0.0388,0.058,0.0726,0.11922,0.1108,0.17759,0.0132,0.032,0.0512,0.0231,0.0703,0.0119,0.009,0.008,0.003,0.0132-0.006,0.0171-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0106-0.0108-0.004-0.0172,0.009-0.0228,0.0346-0.0214,0.0111-0.0606-0.006-0.0847-0.0296-0.0473-0.0571-0.096-0.0883-0.14222-0.0202-0.042-0.0775-0.047-0.10221-0.007-0.0134,0.0229-0.0382,0.0566-0.0241,0.0828,0.0355,0.0574,0.0698,0.11561,0.10621,0.1725,0.0137,0.0353,0.0537,0.018,0.073,0.009,0.009,0.008,0.003,0.0132-0.006,0.0171-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0118-0.0119-0.002-0.0169,0.0102-0.0238,0.029-0.0239,0.003-0.0596-0.0116-0.0841-0.0349-0.0559-0.0675-0.11327-0.105-0.16739-0.0149-0.0267-0.0455-0.01-0.057,0.007-0.008-0.005-0.0145-0.01-0.005-0.0171,0.0212-0.029,0.0414-0.0591,0.0632-0.0875,0.007-0.005,0.0149-0.0127,0.0181-0.00015,0.0117,0.0189,0.0234,0.0379,0.0351,0.0569z'/%3E %3Cpath d='m497.57,308.52c0.0218,0.0554,0.022,0.12256-0.0136,0.17238-0.0314,0.0455-0.0925,0.0657-0.1453,0.05-0.0656-0.016-0.11196-0.0732-0.13761-0.13289-0.0334-0.0755-0.009-0.17521,0.0634-0.21873,0.0381-0.0261,0.0916-0.0331,0.13177-0.008,0.0296,0.0155,0.0271,0.0615-0.007,0.0697-0.046,0.0211-0.055-0.0595-0.10189-0.0414-0.0479,0.0126-0.0682,0.0674-0.0561,0.11218,0.015,0.0639,0.0618,0.12138,0.12355,0.14516,0.0492,0.0204,0.10834-0.0107,0.126-0.0595,0.0147-0.0268,0.003-0.0646,0.007-0.0883,0.003-0.00034,0.006-0.00069,0.009-0.001z'/%3E %3Cpath d='m497.58,308.24c0.0141,0.023,0.0282,0.0461,0.0423,0.0691-0.001-0.0412-0.001-0.0924,0.0359-0.11873,0.0354-0.0314,0.0955,0.0197,0.0603,0.056-0.0215,0.0247-0.0731-0.0123-0.0774,0.032-0.00095,0.0224-0.01,0.0496,0.005,0.0691,0.0306,0.0495,0.0603,0.0997,0.0915,0.14879,0.0155,0.0342,0.059,0.0322,0.0829,0.0168,0.004,0.006,0.008,0.0123-0.002,0.015-0.0493,0.0313-0.0986,0.0626-0.14789,0.0939-0.0185-0.0185,0.02-0.0227,0.023-0.0413,0.01-0.0253-0.0115-0.0466-0.0229-0.0675-0.0341-0.0551-0.0667-0.11114-0.10255-0.16513-0.014-0.029-0.0492-0.014-0.061,0.006-0.004-0.005-0.014-0.009-0.006-0.0146,0.022-0.0302,0.0433-0.0613,0.0659-0.091,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m497.83,308.23c0.0277,0.0482,0.0749,0.0905,0.13276,0.0932,0.0542,0.005,0.11073-0.0363,0.11486-0.0922,0.005-0.0169-0.006-0.0432-0.00098-0.0546,0.023-0.005,0.0176,0.0319,0.0238,0.0459,0.007,0.0526-0.006,0.11298-0.0504,0.14611-0.0431,0.0355-0.10601,0.0399-0.15561,0.0158-0.0564-0.0271-0.0928-0.0831-0.11364-0.14031-0.0243-0.0652-0.006-0.14588,0.0512-0.18816,0.0379-0.0312,0.0927-0.0435,0.13839-0.0226,0.0267,0.0121,0.0624,0.0406,0.0657,0.0659-0.0686,0.0437-0.13729,0.0874-0.20593,0.13111zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14041-0.0891-0.0186-0.0338-0.0571-0.0608-0.0968-0.0483-0.0485,0.013-0.0689,0.0733-0.0518,0.11743,0.002,0.007,0.005,0.014,0.008,0.02z'/%3E %3Cpath d='m497.99,307.74c0.0473-0.0319,0.0875,0.054,0.0346,0.072-0.0448,0.0172-0.0753-0.0474-0.0346-0.072zm0.12577,0.14333c0.0532,0.0866,0.10569,0.17374,0.1594,0.26006,0.0125,0.0301,0.0491,0.0388,0.0727,0.0157,0.005,0.007,0.01,0.0146-0.002,0.0178-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0206-0.0213,0.0315-0.0251,0.0236-0.0513-0.003-0.0294-0.024-0.0527-0.0379-0.0779-0.0308-0.0493-0.0591-0.10027-0.0933-0.14739-0.0149-0.0264-0.0449-0.008-0.0563,0.008-0.008-0.005-0.0142-0.009-0.005-0.0167,0.0213-0.0291,0.0416-0.0592,0.0634-0.0878,0.005-0.003,0.009-0.006,0.0136-0.009z'/%3E %3Cpath d='m498.59,307.99c-0.008,0.0542-0.0461,0.10529-0.10132,0.11708-0.0705,0.0156-0.14265-0.0274-0.17666-0.0884-0.0391-0.0643-0.0477-0.15079-0.0111-0.21801,0.0265-0.0439,0.0793-0.0794,0.1323-0.0672-0.0253-0.0402-0.048-0.0821-0.0768-0.1199-0.0172-0.0266-0.0436,0.001-0.0556,0.0105-0.0125-0.005-0.007-0.0126,0.0001-0.0203,0.0199-0.0274,0.0388-0.056,0.0593-0.0827,0.008-0.006,0.0162-0.0114,0.0197,0.002,0.0786,0.12806,0.15623,0.25679,0.23565,0.38438,0.0104,0.0266,0.0469,0.0546,0.0668,0.0201,0.005-0.0145,0.0238,0.005,0.01,0.0117-0.0206,0.0286-0.0402,0.0584-0.0614,0.0863-0.008,0.005-0.016,0.0141-0.0192,0.00043-0.007-0.0119-0.0143-0.0239-0.0215-0.0358zm-0.0144-0.0235c-0.0323-0.0528-0.0645-0.10561-0.0968-0.15842-0.0249-0.0372-0.0779-0.0606-0.1189-0.035-0.0453,0.0303-0.044,0.0949-0.0243,0.13998,0.0256,0.059,0.0696,0.12197,0.13795,0.13234,0.0386,0.008,0.0813-0.0132,0.094-0.0514,0.004-0.009,0.006-0.0182,0.008-0.0275z'/%3E %3Cpath d='m498.69,307.54c0.0462-0.0315,0.1083-0.0357,0.15839-0.0109,0.0736,0.0325,0.11536,0.11331,0.11646,0.19146,0.003,0.0625-0.0331,0.12343-0.0879,0.15283-0.0501,0.031-0.1153,0.0249-0.16386-0.006-0.0788-0.0461-0.11613-0.1477-0.0935-0.23482,0.0113-0.0379,0.0372-0.0714,0.0704-0.0926zm0.003,0.0283c-0.0386,0.0232-0.044,0.0757-0.0279,0.11433,0.0251,0.0648,0.0712,0.12437,0.1346,0.15503,0.0397,0.0217,0.0961,0.008,0.11462-0.0353,0.0207-0.0455-0.005-0.0939-0.0283-0.13281-0.0309-0.0504-0.0746-0.0998-0.13474-0.113-0.02-0.004-0.0426,0.002-0.0583,0.0117z'/%3E %3Cpath d='m497.67,298.28c0.0275,0.0449,0.0549,0.0898,0.0824,0.1347-0.0186,0.0194-0.0279-0.0255-0.0459-0.0293-0.0492-0.0443-0.1393-0.0325-0.17128,0.0267-0.0204,0.0356-0.002,0.0895,0.0411,0.0951,0.0747,0.0128,0.15064-0.009,0.2254,0.002,0.0616,0.0111,0.10531,0.0766,0.0921,0.13771-0.011,0.0678-0.074,0.11567-0.13841,0.12855-0.0253,0.005-0.0719,0.0146-0.0536,0.0489-0.008,0.009-0.0126,0.004-0.0165-0.005-0.0248-0.0406-0.0496-0.0812-0.0744-0.12182,0.0192-0.0194,0.0301,0.0263,0.0487,0.0301,0.053,0.0444,0.13937,0.0233,0.17777-0.0303,0.0316-0.0412,0.006-0.10629-0.0459-0.11377-0.0521-0.008-0.1049,0.003-0.15731,0.0009-0.0467,0.002-0.10043-0.008-0.12794-0.0499-0.0396-0.0539-0.0187-0.13476,0.0343-0.17169,0.0326-0.0317,0.0828-0.0255,0.11866-0.0467,0.0109-0.0147-0.01-0.0296,0.0108-0.0357z'/%3E %3Cpath d='m497.79,298.17c0.0404-0.0272,0.0749,0.0464,0.0293,0.0618-0.0383,0.0141-0.0641-0.041-0.0293-0.0618zm0.10762,0.12263c0.0455,0.0741,0.0905,0.14865,0.13637,0.22254,0.0108,0.0269,0.0436,0.0305,0.0628,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11757,0.0746-0.0179-0.0183,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11995-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.0361-0.0513,0.055-0.0761,0.004-0.003,0.007-0.005,0.0113-0.008z'/%3E %3Cpath d='m498.11,298.18c0.0407-0.0258,0.0814-0.0517,0.12212-0.0775,0.002,0.005,0.0112,0.0109,0.003,0.0132-0.0294,0.0124-0.0162,0.0486,0.008,0.0586,0.0489,0.0351,0.0979,0.0702,0.14685,0.10534-0.0111-0.0662-0.0219-0.13243-0.0332-0.19859,0.00071-0.021-0.0213-0.0339-0.0378-0.0188-0.004,0.0114-0.0183-0.007-0.0108-0.009,0.0272-0.0172,0.0543-0.0345,0.0815-0.0517,0.002,0.005,0.0136,0.0128,0.00043,0.0154-0.019,0.0166-0.0118,0.0437-0.009,0.0657,0.0147,0.0909,0.0294,0.18187,0.0441,0.2728-0.005,0.001-0.0101,0.01-0.0147,0.005-0.0776-0.0555-0.15519-0.11084-0.23272-0.16636-0.0176-0.0176-0.0455-0.009-0.0631-0.007-0.002-0.002-0.004-0.005-0.005-0.007z'/%3E %3Cpath d='m498.54,297.9c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0927,0.18256-0.008,0.0774-0.0885,0.14127-0.16572,0.12365-0.0685-0.0147-0.12178-0.0757-0.13176-0.14437-0.008-0.0429-0.00081-0.09,0.0279-0.12411,0.01-0.0123,0.0217-0.0233,0.0351-0.0314zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0264,0.0495,0.0664,0.0972,0.12181,0.11427,0.0395,0.0127,0.0852-0.018,0.0872-0.0598,0.00078-0.0459-0.0266-0.0866-0.0526-0.12229-0.0308-0.0388-0.0831-0.0818-0.13528-0.0588l-0.008,0.004h-0.0001z'/%3E %3Cpath d='m498.87,297.69c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0984-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00024,0.0458,0.0157,0.0665,0.0748,0.0453,0.11725-0.019,0.0506-0.0741,0.0665-0.11952,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0232,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00044-0.0804,0.0122-0.11809-0.003-0.0464-0.0233-0.0611-0.0906-0.0284-0.13125,0.0215-0.036,0.0685-0.0345,0.0973-0.0575-0.00095-0.0122,0.00032-0.0135,0.009-0.0184z'/%3E %3Cpath d='m499.06,297.58c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0926,0.18256-0.008,0.0774-0.0885,0.14127-0.16575,0.12365-0.0685-0.0148-0.12174-0.0757-0.13172-0.14437-0.009-0.046,0.00092-0.0967,0.034-0.13134,0.009-0.009,0.0182-0.0177,0.029-0.0242zm0.003,0.0242c-0.0426,0.0262-0.0352,0.0849-0.0132,0.12226,0.0265,0.0496,0.0664,0.0972,0.12181,0.11427,0.0396,0.0127,0.0852-0.0181,0.0872-0.0599,0.00079-0.0459-0.0266-0.0866-0.0525-0.12229-0.0307-0.0388-0.0832-0.0818-0.13529-0.0588l-0.008,0.004-0.0001,0.0001z'/%3E %3Cpath d='m499.24,297.34c0.0176,0.0288,0.0352,0.0577,0.0528,0.0865,0.0202-0.0128,0.0404-0.0257,0.0606-0.0385,0.004,0.007,0.008,0.0134,0.0123,0.0201-0.0202,0.0128-0.0404,0.0257-0.0606,0.0385,0.0361,0.0589,0.0719,0.11791,0.10815,0.17668,0.01,0.0247,0.0459,0.0363,0.0601,0.009,0.0113-0.0121-0.001-0.0327,0.0168-0.038,0.011,0.0382-0.003,0.091-0.0446,0.10459-0.0372,0.0125-0.0663-0.0201-0.0816-0.0497-0.0351-0.0574-0.0702-0.11481-0.10528-0.17221-0.0137,0.009-0.0274,0.0174-0.0411,0.0261-0.0146-0.0138,0.0118-0.028,0.011-0.0444,0.0143-0.0363,0.006-0.0781,0.005-0.11346,0.002-0.002,0.004-0.003,0.006-0.005z'/%3E %3Cpath d='m499.46,297.32c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00052-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12644,0.0132,0.0296,0.0501,0.0278,0.071,0.0143,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0123-0.0251-0.0408-0.0133-0.0516,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m499.7,297.17c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0927,0.18256-0.008,0.0774-0.0885,0.14127-0.16572,0.12365-0.0685-0.0148-0.12184-0.0757-0.13177-0.14437-0.008-0.0429-0.00081-0.09,0.0279-0.12411,0.01-0.0124,0.0217-0.0232,0.0351-0.0314zm0.003,0.0242c-0.0426,0.0262-0.0352,0.0849-0.0132,0.12226,0.0265,0.0496,0.0664,0.0972,0.12181,0.11427,0.0395,0.0127,0.0852-0.018,0.0872-0.0598,0.00079-0.0459-0.0266-0.0866-0.0525-0.12229-0.0307-0.0388-0.0832-0.0818-0.13529-0.0588l-0.008,0.004h-0.0001z'/%3E %3Cpath d='m500.03,296.96c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00024,0.0458,0.0157,0.0665,0.0748,0.0453,0.11725-0.019,0.0506-0.0741,0.0665-0.11952,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0232,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00044-0.0804,0.0122-0.11809-0.003-0.0464-0.0233-0.0611-0.0906-0.0284-0.13125,0.0215-0.036,0.0685-0.0345,0.0973-0.0575-0.00095-0.0122,0.00032-0.0135,0.009-0.0184z'/%3E %3Cpath d='m497.95,299.35c0.0204-0.028,0.04-0.0568,0.061-0.0842,0.007-0.007,0.0125-0.006,0.0157,0.003,0.0105,0.0172,0.0211,0.0344,0.0316,0.0516-0.002-0.042,0.006-0.0913,0.0448-0.1153,0.0396-0.0275,0.0935-0.0153,0.12895,0.0134,0.062,0.0509,0.0984,0.14039,0.0708,0.21852-0.0166,0.0431-0.0597,0.077-0.10635,0.0789-0.014-0.002-0.025-0.005-0.0136,0.008,0.0206,0.0325,0.0389,0.0667,0.0621,0.0975,0.0161,0.0228,0.0435-0.006,0.0568-0.003,0.009,0.008-0.00019,0.0109-0.007,0.015-0.0414,0.0263-0.0828,0.0525-0.1242,0.0788-0.0105-0.01-0.004-0.0146,0.007-0.0196,0.0338-0.0208,0.009-0.0562-0.007-0.0799-0.0525-0.0854-0.10415-0.17131-0.15719-0.25636-0.0111-0.0313-0.0442-0.0175-0.0575-0.002-0.002-0.002-0.005-0.003-0.007-0.005zm0.11858-0.0119c0.0277,0.0443,0.0534,0.09,0.0832,0.13285,0.0264,0.0344,0.082,0.0276,0.10682-0.005,0.0281-0.0378,0.0119-0.0891-0.009-0.12621-0.0244-0.0424-0.0634-0.0883-0.11676-0.0871-0.0435,0.004-0.0603,0.0484-0.0641,0.0856z'/%3E %3Cpath d='m498.34,299.19c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0492,0.004,0.10025-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12507-0.0408,0.0337-0.10189,0.0341-0.14603,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11792,0.0543-0.14941,0.0332-0.0252,0.0803-0.0321,0.11774-0.0123,0.0211,0.011,0.0469,0.033,0.0516,0.0534-0.059,0.0374-0.11801,0.0748-0.17702,0.11223zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0188,0.0274-0.0164,0.0639-0.002,0.0921z'/%3E %3Cpath d='m498.56,298.9c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12654,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0133-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m498.8,298.84c0.009-0.0453,0.0207-0.0998,0.0683-0.11958,0.0298-0.0141,0.0664-0.003,0.0874,0.021,0.006-0.0461,0.021-0.0986,0.067-0.11921,0.0407-0.0204,0.0869,0.008,0.10729,0.0442,0.032,0.0494,0.0605,0.10099,0.0934,0.14978,0.0116,0.0283,0.045,0.006,0.0578,0.008,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0366,0.0232-0.0732,0.0465-0.10985,0.0697-0.0187-0.02,0.0353-0.0245,0.0228-0.0514-0.0107-0.0278-0.0293-0.0519-0.0441-0.0777-0.0217-0.0337-0.0398-0.07-0.0657-0.10063-0.0371-0.0384-0.0891,0.009-0.0971,0.0495-0.0105,0.0158-0.007,0.0306,0.005,0.0433,0.0296,0.0476,0.0576,0.0961,0.0884,0.14292,0.0126,0.0302,0.0472,0.002,0.0605,0.005,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0377,0.0239-0.0753,0.0478-0.11297,0.0717-0.0177-0.0198,0.0333-0.0249,0.0235-0.0507-0.007-0.0251-0.0246-0.0456-0.037-0.0683-0.0227-0.0355-0.0422-0.0733-0.0683-0.10645-0.0303-0.0387-0.0854-0.009-0.0968,0.031-0.009,0.0179-0.017,0.0391-0.001,0.0551,0.03,0.0481,0.0582,0.0975,0.0897,0.14468,0.0129,0.0283,0.0451,0.008,0.0597,0.004,0.0105,0.01-0.006,0.0128-0.0125,0.0184-0.0371,0.0236-0.0743,0.0472-0.11144,0.0707-0.018-0.0191,0.0318-0.0242,0.0196-0.0492-0.0127-0.035-0.0358-0.0649-0.0542-0.0971-0.0219-0.0337-0.0393-0.0712-0.0678-0.0998-0.0167-0.0136-0.0443,0.0344-0.0448,0.006,0.0192-0.0262,0.0373-0.0534,0.0571-0.0789,0.009-0.0102,0.0147-0.005,0.0192,0.006,0.009,0.0139,0.0178,0.0278,0.0267,0.0417z'/%3E %3Cpath d='m499.42,298.68c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.05,0.01-0.0951-0.0439-0.0866-0.0918,0.0107-0.055,0.0488-0.0986,0.0805-0.14279,0.0145-0.0111-0.008-0.0249-0.0115-0.0362-0.0194-0.0403-0.0776-0.0391-0.0976-0.00063-0.01,0.0163-0.003,0.0347,0.007,0.0482,0.0203,0.0196,0.005,0.0595-0.0253,0.0509-0.0445-0.0226-0.0284-0.0874,0.002-0.11585,0.0311-0.0292,0.074-0.058,0.11857-0.0485,0.0308,0.009,0.0449,0.0404,0.0612,0.0654,0.0249,0.0403,0.0488,0.0811,0.0749,0.1207,0.008,0.0219,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0349-0.0245,0.0956-0.0689,0.0745-0.01-0.005-0.0159-0.0185-0.0226-0.0238zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.033-0.0517,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m499.5,298.39c0.007-0.0439,0.0195-0.0964,0.0636-0.11676,0.0378-0.0194,0.0807,0.006,0.10141,0.0387,0.0332,0.0496,0.0622,0.10202,0.0949,0.15199,0.0112,0.0256,0.0427,0.0219,0.0596,0.009,0.006,0.007,0.006,0.0118-0.003,0.0149-0.0398,0.0253-0.0797,0.0506-0.11951,0.0759-0.009-0.009-0.003-0.0141,0.007-0.0192,0.0305-0.0187,0.009-0.0521-0.006-0.0732-0.0242-0.039-0.0472-0.0787-0.0723-0.11709-0.0158-0.0342-0.063-0.0476-0.0867-0.0139-0.0141,0.0197-0.0347,0.0498-0.0246,0.0738,0.0306,0.0495,0.0602,0.0996,0.0915,0.14858,0.0116,0.0298,0.0461,0.0153,0.0625,0.007,0.007,0.007,0.003,0.0111-0.005,0.0145-0.0395,0.0251-0.079,0.0502-0.11852,0.0753-0.007-0.008-0.006-0.0136,0.005-0.0174,0.0303-0.019,0.008-0.0535-0.006-0.0754-0.0288-0.0465-0.0562-0.0938-0.0867-0.13925-0.0124-0.0282-0.041-0.0112-0.0529,0.002-0.008-0.004-0.01-0.009-0.003-0.0151,0.0179-0.0245,0.035-0.0499,0.0534-0.0739,0.006-0.004,0.0128-0.0113,0.0155-0.00038,0.01,0.0166,0.02,0.0331,0.03,0.0496z'/%3E %3Cpath d='m499.79,298.27c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12507-0.0408,0.0337-0.10189,0.0341-0.14603,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0546,0.006-0.11792,0.0543-0.14934,0.0332-0.0251,0.0803-0.0321,0.11774-0.0123,0.0211,0.011,0.0469,0.033,0.0516,0.0534-0.059,0.0374-0.11808,0.0748-0.17712,0.11224zm-0.0102-0.0167c0.04-0.0254,0.0801-0.0508,0.12014-0.0762-0.0201-0.0459-0.0897-0.0615-0.11864-0.0159-0.0188,0.0274-0.0164,0.064-0.001,0.0921z'/%3E %3Cpath d='m500.26,298.06c0.0185,0.0474,0.0192,0.10488-0.0114,0.14747-0.0268,0.039-0.0792,0.0561-0.12433,0.0428-0.0588-0.0145-0.0998-0.0672-0.1207-0.12143-0.0241-0.0633-0.002-0.14388,0.0573-0.17938,0.0366-0.0251,0.097-0.0315,0.1261,0.008,0.0234,0.0387-0.0478,0.0692-0.0635,0.0274-0.0329-0.0469-0.0986,0.006-0.0936,0.0512-0.00059,0.0477,0.0265,0.092,0.0609,0.12318,0.028,0.0243,0.0682,0.0437,0.10503,0.0283,0.0457-0.0167,0.0643-0.07,0.0552-0.11496-0.004-0.014-0.00035-0.0102,0.009-0.0122z'/%3E %3Cpath d='m500.3,297.94c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12507-0.0408,0.0337-0.10189,0.0341-0.14603,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11797,0.0543-0.14944,0.0332-0.0251,0.0803-0.0321,0.11774-0.0123,0.0211,0.011,0.0469,0.033,0.0516,0.0534-0.059,0.0375-0.11808,0.0749-0.17712,0.11234zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.046-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.0639-0.001,0.0921z'/%3E %3Cpath d='m500.53,297.65c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00052-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12654,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0124-0.0248-0.041-0.0117-0.0515,0.007-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0188-0.0259,0.0371-0.0524,0.0563-0.0779,0.004-0.003,0.008-0.005,0.012-0.008z'/%3E %3Cpath d='m500.75,297.66c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0966-0.0434,0.12503-0.0408,0.0337-0.10189,0.0341-0.14604,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11789,0.0543-0.14942,0.0332-0.0252,0.0803-0.0321,0.11772-0.0123,0.0211,0.011,0.0468,0.0329,0.0516,0.0534-0.059,0.0374-0.11807,0.0749-0.17711,0.11234zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0188,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m500.89,297.24c0.0403-0.0272,0.075,0.0466,0.0293,0.0616-0.0386,0.014-0.0639-0.0407-0.0293-0.0616zm0.10761,0.12263c0.0455,0.0741,0.0905,0.14866,0.13639,0.22256,0.0108,0.027,0.0435,0.0304,0.0628,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0183,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11997-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0113-0.008z'/%3E %3Cpath d='m501.23,297.2c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0982-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0747,0.0454,0.11724-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00042-0.0805,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13136,0.0215-0.0359,0.0685-0.0345,0.0973-0.0575-0.0008-0.0122,0.00008-0.0135,0.009-0.0183z'/%3E %3Cpath d='m498.51,300.12c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0463,0.004,0.0949-0.0312,0.0982-0.0791,0.004-0.014-0.006-0.0377-0.00045-0.0467,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12503-0.0369,0.0304-0.0907,0.0342-0.13314,0.0135-0.0507-0.0245-0.0829-0.076-0.0997-0.12806-0.017-0.0541-0.00025-0.1188,0.0462-0.15299,0.0338-0.0282,0.0839-0.0378,0.12369-0.0167,0.0211,0.011,0.0468,0.0329,0.0516,0.0534-0.059,0.0375-0.11807,0.075-0.17711,0.11256zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m498.76,299.87c0.007-0.0439,0.0195-0.0963,0.0636-0.11673,0.0377-0.0194,0.0806,0.006,0.10131,0.0387,0.0332,0.0496,0.0621,0.10205,0.0948,0.15203,0.0112,0.0256,0.0427,0.0219,0.0596,0.009,0.006,0.007,0.005,0.0118-0.003,0.0149-0.0398,0.0253-0.0797,0.0506-0.11951,0.0759-0.009-0.009-0.003-0.0141,0.007-0.0191,0.0301-0.0187,0.009-0.0522-0.006-0.0733-0.0242-0.039-0.0472-0.0787-0.0723-0.11708-0.0158-0.0341-0.0629-0.0477-0.0866-0.0139-0.0141,0.0197-0.0347,0.0498-0.0246,0.0738,0.0306,0.0495,0.0602,0.0996,0.0915,0.14858,0.0116,0.0298,0.0461,0.0153,0.0625,0.007,0.007,0.007,0.003,0.0111-0.005,0.0145-0.0395,0.025-0.079,0.0501-0.11852,0.0752-0.007-0.008-0.006-0.0136,0.005-0.0174,0.0303-0.019,0.008-0.0535-0.006-0.0754-0.0288-0.0465-0.0562-0.0938-0.0867-0.13925-0.0125-0.0282-0.041-0.0113-0.0529,0.002-0.008-0.004-0.01-0.009-0.003-0.0151,0.0179-0.0245,0.035-0.0499,0.0534-0.0739,0.006-0.004,0.0128-0.0113,0.0154-0.00038,0.01,0.0166,0.0201,0.0332,0.0301,0.0498z'/%3E %3Cpath d='m499.19,299.6c0.009-0.0453,0.0207-0.0998,0.0683-0.11958,0.0298-0.0142,0.0663-0.003,0.0874,0.021,0.006-0.046,0.0209-0.0986,0.067-0.11921,0.0407-0.0204,0.0869,0.008,0.1073,0.0442,0.032,0.0494,0.0606,0.101,0.0934,0.14982,0.0116,0.0283,0.045,0.006,0.0578,0.008,0.009,0.009-0.009,0.012-0.0145,0.0179-0.0366,0.0232-0.0732,0.0465-0.10985,0.0697-0.0187-0.02,0.0352-0.0245,0.0229-0.0513-0.0103-0.0273-0.0287-0.0509-0.0432-0.0763-0.022-0.0341-0.0403-0.0709-0.0665-0.10198-0.0371-0.0383-0.0891,0.009-0.097,0.0495-0.0105,0.0158-0.007,0.0306,0.004,0.0433,0.0296,0.0476,0.0576,0.0962,0.0884,0.14292,0.0126,0.0302,0.0472,0.002,0.0605,0.005,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0376,0.0239-0.0753,0.0478-0.11296,0.0716-0.0177-0.0198,0.0333-0.0249,0.0234-0.0508-0.006-0.0252-0.0246-0.0457-0.037-0.0684-0.0227-0.0355-0.0422-0.0733-0.0683-0.10642-0.0302-0.0388-0.0855-0.009-0.0967,0.0311-0.009,0.0179-0.0171,0.039-0.001,0.055,0.03,0.0481,0.0582,0.0975,0.0897,0.14466,0.0129,0.0283,0.0451,0.008,0.0597,0.004,0.0105,0.01-0.006,0.0128-0.0125,0.0184-0.0371,0.0236-0.0743,0.0472-0.11145,0.0708-0.0181-0.019,0.0318-0.0241,0.0196-0.0491-0.0126-0.035-0.0358-0.0649-0.0542-0.097-0.0219-0.0337-0.0393-0.0713-0.0678-0.0998-0.0167-0.0136-0.0443,0.0344-0.0448,0.006,0.0192-0.0262,0.0373-0.0534,0.0571-0.0789,0.009-0.0102,0.0146-0.005,0.0192,0.006,0.009,0.0139,0.0177,0.0278,0.0266,0.0418z'/%3E %3Cpath d='m499.52,299.12c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0142-0.0641-0.041-0.0293-0.0618zm0.10761,0.12264c0.0455,0.0741,0.0905,0.14865,0.13637,0.22254,0.0107,0.0269,0.0435,0.0305,0.0627,0.0144,0.006,0.007,0.006,0.0117-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0272-0.0214,0.0207-0.0437-0.003-0.0259-0.0215-0.0462-0.0337-0.0685-0.025-0.0401-0.0484-0.0812-0.0753-0.11996-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.0761,0.004-0.003,0.008-0.005,0.0115-0.008z'/%3E %3Cpath d='m499.84,299.15c0.0204-0.0279,0.04-0.0567,0.061-0.0841,0.007-0.007,0.0125-0.006,0.0157,0.003,0.0105,0.0172,0.0211,0.0345,0.0316,0.0517-0.002-0.042,0.006-0.0912,0.0447-0.1153,0.0396-0.0275,0.0935-0.0153,0.12895,0.0134,0.062,0.0509,0.0984,0.1404,0.0708,0.21852-0.0166,0.0431-0.0597,0.077-0.10635,0.0789-0.014-0.002-0.025-0.005-0.0136,0.008,0.0206,0.0326,0.0389,0.0667,0.0621,0.0975,0.0159,0.0229,0.0435-0.006,0.0568-0.003,0.009,0.008-0.00019,0.0109-0.007,0.015-0.0414,0.0263-0.0828,0.0525-0.12419,0.0788-0.0105-0.009-0.004-0.0157,0.007-0.0206,0.0338-0.0208,0.009-0.0562-0.007-0.0799-0.0525-0.0854-0.10415-0.17131-0.15719-0.25636-0.0111-0.0313-0.0442-0.0176-0.0577-0.002-0.002-0.001-0.004-0.003-0.007-0.004zm0.1186-0.0119c0.0277,0.0443,0.0533,0.0899,0.0832,0.13282,0.0263,0.0344,0.082,0.0277,0.10685-0.005,0.0281-0.0378,0.0119-0.0891-0.009-0.12621-0.0244-0.0424-0.0634-0.0882-0.11676-0.087-0.0435,0.004-0.0601,0.0482-0.0641,0.0856z'/%3E %3Cpath d='m500.43,299.08c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0254,0.0324-0.0651-0.01-0.0574-0.0408,0.003-0.0501,0.0455-0.0851,0.0877-0.10449,0.0373-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0983,0.091,0.14616,0.008,0.0218,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0954-0.0685,0.0745-0.01-0.005-0.0162-0.0183-0.023-0.0239zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0223,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m500.39,298.57c0.0736,0.11999,0.14651,0.24036,0.22046,0.3601,0.0113,0.0274,0.0444,0.0303,0.0647,0.0109,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.11931,0.0757-0.0182-0.0179,0.026-0.0212,0.0195-0.0429-0.004-0.0265-0.0224-0.0478-0.0352-0.0708-0.0501-0.0815-0.0993-0.16352-0.15012-0.24455-0.008-0.0222-0.038-0.0403-0.0528-0.0136-0.001,0.0104-0.0221-0.001-0.0111-0.007,0.0183-0.0252,0.0358-0.0514,0.0546-0.0761,0.004-0.002,0.007-0.004,0.0112-0.007z'/%3E %3Cpath d='m500.85,298.81c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0993-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0504-0.0567-0.058-0.0355-0.007-0.08,0.0339-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0254,0.0324-0.0652-0.01-0.0574-0.0407,0.003-0.0502,0.0455-0.0851,0.0877-0.10452,0.0373-0.0222,0.0872-0.008,0.10532,0.0317,0.031,0.0483,0.0593,0.0983,0.0909,0.14616,0.008,0.0218,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0954-0.0685,0.0745-0.01-0.005-0.0162-0.0181-0.023-0.0239zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m500.91,298.51c0.001-0.0445,0.0193-0.0955,0.0642-0.11277,0.0514-0.0213,0.11154,0.004,0.14389,0.0465,0.0405,0.048,0.0615,0.11584,0.0401,0.17682-0.016,0.0581-0.0692,0.10208-0.12889,0.10842-0.019-0.00029-0.0489,0.0133-0.0566-0.0111-0.0604-0.0983-0.11981-0.1972-0.18102-0.29499-0.009-0.0236-0.0395-0.0395-0.0544-0.012-0.003,0.0111-0.0214-0.004-0.01-0.01,0.0182-0.025,0.0356-0.0509,0.0544-0.0753,0.006-0.004,0.0135-0.0113,0.0162-0.00011,0.0373,0.0613,0.0746,0.12267,0.1119,0.184zm0.0112,0.0184c0.0321,0.0525,0.0641,0.10493,0.0962,0.1574,0.0443,0.0128,0.1036-0.006,0.10808-0.0587,0.01-0.052-0.019-0.10239-0.0516-0.14062-0.0283-0.0331-0.0832-0.0513-0.11982-0.0209-0.0193,0.0154-0.0272,0.0403-0.0329,0.0628z'/%3E %3Cpath d='m501.18,298.28c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0391-0.006,0.0515,0.0589,0.0107,0.0629-0.0181,0.00097-0.048-0.007-0.0498,0.0202-0.002,0.0194-0.008,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12647,0.0132,0.0296,0.0502,0.0279,0.071,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0193,0.0195-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0407-0.0133-0.0515,0.006-0.003-0.004-0.0126-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m501.59,298.34c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.14362-0.0138-0.0233-0.0288-0.0505-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0254,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0501,0.0455-0.0852,0.0877-0.10459,0.0373-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0983,0.091,0.14616,0.008,0.0219,0.0362,0.0131,0.0362-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0244,0.0954-0.0685,0.0743-0.01-0.005-0.0165-0.0184-0.0229-0.0237zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0223,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.0221-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m499.01,300.66c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00024,0.0458,0.0157,0.0665,0.0748,0.0453,0.11725-0.0189,0.0507-0.0741,0.0664-0.11952,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0232,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00039-0.0805,0.013-0.11811-0.003-0.0464-0.0233-0.0611-0.0906-0.0284-0.13125,0.0215-0.0359,0.0685-0.0345,0.0973-0.0575-0.00094-0.0122,0.00031-0.0135,0.009-0.0184z'/%3E %3Cpath d='m499.18,300.7c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12511-0.0408,0.0337-0.10184,0.0341-0.14598,0.007-0.0454-0.0287-0.075-0.0782-0.0889-0.12919-0.0143-0.0547,0.006-0.1179,0.0543-0.14936,0.0347-0.0265,0.0848-0.0324,0.12289-0.01,0.0187,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0374-0.11814,0.0749-0.17721,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m499.4,300.41c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.10429,0.0543-0.10932,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0267-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0215-0.01-0.0398-0.0195-0.0576-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0132-0.0515,0.006-0.003-0.004-0.0126-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0127-0.008z'/%3E %3Cpath d='m499.63,300.42c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12506-0.0408,0.0337-0.10185,0.0341-0.14599,0.007-0.0454-0.0287-0.075-0.0782-0.0889-0.12919-0.0143-0.0547,0.006-0.1179,0.0543-0.14936,0.0347-0.0265,0.0848-0.0324,0.12289-0.01,0.0187,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0375-0.11813,0.0749-0.1772,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m499.76,300.01c0.0403-0.0272,0.075,0.0466,0.0293,0.0616-0.0386,0.014-0.0639-0.0407-0.0293-0.0616zm0.10761,0.12264c0.0455,0.0741,0.0905,0.14865,0.13637,0.22254,0.0108,0.027,0.0435,0.0306,0.0628,0.0145,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0273-0.0214,0.0207-0.0437-0.003-0.026-0.0215-0.0463-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11995-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0512,0.0549-0.076,0.004-0.003,0.008-0.005,0.0114-0.008z'/%3E %3Cpath d='m500.1,299.97c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00024,0.0458,0.0157,0.0665,0.0748,0.0453,0.11725-0.019,0.0507-0.0741,0.0664-0.11952,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0382,0.0293,0.10908,0.0231,0.1259-0.0272,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0805,0.013-0.11811-0.003-0.0465-0.0233-0.0611-0.0906-0.0284-0.13125,0.0215-0.036,0.0685-0.0345,0.0973-0.0575-0.00085-0.0123,0.00014-0.0135,0.009-0.0183z'/%3E %3Cpath d='m500.29,299.85c0.0407-0.0258,0.0814-0.0517,0.12213-0.0775,0.002,0.005,0.0112,0.0109,0.003,0.0132-0.0293,0.0125-0.0161,0.0487,0.008,0.0587,0.0489,0.0351,0.0979,0.0702,0.14685,0.10534-0.0111-0.0662-0.0219-0.13243-0.0332-0.19859,0.0007-0.0211-0.0212-0.0337-0.0377-0.0186-0.004,0.0114-0.0183-0.007-0.0108-0.009,0.0272-0.0172,0.0543-0.0345,0.0815-0.0517,0.002,0.006,0.0136,0.0128,0.00043,0.0154-0.019,0.0166-0.0118,0.0437-0.009,0.0657,0.0147,0.0909,0.0294,0.18187,0.0441,0.2728-0.005,0.001-0.0101,0.01-0.0147,0.005-0.0776-0.0555-0.15519-0.11084-0.23272-0.16636-0.0176-0.0176-0.0455-0.009-0.0631-0.007-0.002-0.003-0.004-0.005-0.005-0.008z'/%3E %3Cpath d='m500.7,299.73c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0392,0.006,0.045-0.005,0.0967-0.0433,0.12511-0.0408,0.0337-0.10185,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0782-0.089-0.12919-0.0143-0.0547,0.006-0.11796,0.0544-0.14936,0.0347-0.0264,0.0848-0.0324,0.12291-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0374-0.11814,0.0749-0.17721,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0273-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m500.93,299.44c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0404,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12654,0.0803-0.0159-0.0157,0.0169-0.0193,0.0196-0.0354,0.008-0.0215-0.01-0.0398-0.0195-0.0576-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0133-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0127-0.008z'/%3E %3Cpath d='m501.37,299.49c-0.007,0.0504-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.11672-0.0327-0.14355-0.0848-0.0296-0.054-0.0356-0.12443-0.005-0.1794,0.0196-0.0415,0.0784-0.0638,0.11139-0.0607-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.0147-0.0226-0.0377,0-0.0477,0.009-0.0101-0.004-0.007-0.0102-0.00079-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00014,0.0666,0.10865,0.13263,0.21769,0.19972,0.32606,0.009,0.0236,0.0411,0.0527,0.0597,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.006,0.004-0.0137,0.0114-0.0165-0.00012-0.006-0.01-0.012-0.0194-0.0179-0.029zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0232-0.0364-0.0798-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13131,0.0237,0.0456,0.0636,0.091,0.11846,0.0937,0.0414,0.005,0.0724-0.0298,0.0773-0.0685z'/%3E %3Cpath d='m501.63,299.33c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.14364-0.0139-0.0232-0.0288-0.0504-0.0567-0.0579-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0501,0.0455-0.0851,0.0877-0.10459,0.0374-0.0222,0.0872-0.008,0.10532,0.0317,0.031,0.0482,0.0593,0.0982,0.0909,0.14608,0.008,0.0218,0.0361,0.013,0.0362-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0349-0.0246,0.0956-0.0689,0.0743-0.009-0.005-0.0162-0.0182-0.0223-0.0236zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10024-0.0224,0.0329-0.0517,0.065-0.0562,0.1062-0.007,0.0454,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m501.92,299.14c-0.007,0.0504-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.11673-0.0327-0.14357-0.0848-0.0296-0.054-0.0356-0.12444-0.005-0.17941,0.0196-0.0415,0.0784-0.0638,0.11139-0.0607-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.0147-0.0226-0.0377,0-0.0477,0.009-0.0101-0.004-0.007-0.0102-0.00079-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00014,0.0666,0.10864,0.13263,0.21769,0.19972,0.32605,0.009,0.0236,0.0412,0.0526,0.0598,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.006,0.004-0.0137,0.0113-0.0165-0.00011-0.006-0.01-0.012-0.0194-0.018-0.029zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0232-0.0364-0.0797-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13131,0.0237,0.0455,0.0636,0.091,0.11846,0.0938,0.0414,0.005,0.0725-0.0299,0.0773-0.0686z'/%3E %3Cpath d='m501.99,298.92c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12506-0.0408,0.0337-0.10185,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0782-0.089-0.12919-0.0143-0.0547,0.006-0.1179,0.0543-0.14936,0.0347-0.0265,0.0848-0.0324,0.12289-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.059,0.0375-0.11807,0.0749-0.17711,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m502.22,298.62c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0404,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0297,0.0502,0.0279,0.071,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12654,0.0803-0.0159-0.0157,0.0168-0.0193,0.0195-0.0354,0.008-0.0215-0.01-0.0398-0.0194-0.0576-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0409-0.0133-0.0516,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0127-0.008z'/%3E %3Cpath d='m502.63,298.69c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.1436-0.0138-0.0233-0.0288-0.0504-0.0567-0.058-0.0355-0.007-0.08,0.0339-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0502,0.0455-0.0851,0.0877-0.10449,0.0374-0.0222,0.0872-0.008,0.10532,0.0317,0.031,0.0482,0.0593,0.0982,0.091,0.14608,0.008,0.0218,0.0362,0.013,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0349-0.0246,0.0956-0.0689,0.0743-0.009-0.005-0.0161-0.0184-0.0224-0.0236zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10024-0.0224,0.033-0.0517,0.065-0.0562,0.1063-0.007,0.0453,0.0555,0.0891,0.0891,0.0497,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m502.71,298.4c0.009-0.0453,0.0205-0.0998,0.0682-0.11958,0.0298-0.0142,0.0663-0.003,0.0874,0.021,0.006-0.0461,0.021-0.0986,0.067-0.11921,0.0407-0.0204,0.0869,0.008,0.10729,0.0442,0.032,0.0494,0.0606,0.101,0.0934,0.14983,0.0115,0.0284,0.045,0.006,0.0578,0.008,0.009,0.009-0.009,0.012-0.0145,0.0179-0.0366,0.0232-0.0732,0.0465-0.10986,0.0697-0.0187-0.02,0.0353-0.0246,0.0228-0.0514-0.0107-0.0277-0.0293-0.0519-0.044-0.0777-0.0217-0.0337-0.0398-0.07-0.0657-0.10062-0.037-0.0383-0.0892,0.009-0.097,0.0494-0.0105,0.0158-0.007,0.0306,0.004,0.0433,0.0296,0.0476,0.0576,0.0961,0.0884,0.14292,0.0126,0.0302,0.0472,0.002,0.0605,0.005,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0377,0.0239-0.0753,0.0478-0.11298,0.0717-0.0177-0.0198,0.0333-0.0249,0.0235-0.0508-0.006-0.0252-0.0246-0.0457-0.037-0.0684-0.0227-0.0355-0.0422-0.0733-0.0683-0.10642-0.0303-0.0388-0.0854-0.009-0.0968,0.031-0.009,0.0179-0.017,0.039-0.001,0.055,0.03,0.0481,0.0582,0.0975,0.0897,0.14467,0.0129,0.0283,0.0451,0.008,0.0597,0.004,0.0105,0.01-0.006,0.0128-0.0125,0.0184-0.0371,0.0236-0.0743,0.0472-0.11144,0.0708-0.018-0.0191,0.0318-0.0242,0.0196-0.0492-0.0127-0.0349-0.0358-0.0649-0.0542-0.097-0.0219-0.0337-0.0393-0.0713-0.0678-0.0998-0.0167-0.0136-0.0443,0.0344-0.0448,0.006,0.0192-0.0262,0.0373-0.0534,0.0571-0.0789,0.009-0.0102,0.0147-0.005,0.0192,0.006,0.009,0.014,0.0179,0.028,0.0268,0.042z'/%3E %3Cpath d='m503.15,298.18c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12506-0.0408,0.0337-0.10185,0.0341-0.14599,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12919-0.0143-0.0547,0.006-0.1179,0.0543-0.14936,0.0347-0.0265,0.0848-0.0324,0.12289-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.059,0.0375-0.11807,0.0749-0.1771,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m503.42,297.95c0.007-0.0439,0.0195-0.0963,0.0636-0.11675,0.0378-0.0194,0.0806,0.006,0.10141,0.0387,0.0332,0.0496,0.0621,0.10203,0.0948,0.15201,0.0113,0.0256,0.0427,0.0219,0.0597,0.009,0.006,0.007,0.005,0.0118-0.003,0.0149-0.0398,0.0253-0.0797,0.0506-0.11951,0.0759-0.009-0.009-0.003-0.0141,0.007-0.0192,0.0304-0.0187,0.009-0.0521-0.006-0.0733-0.0242-0.039-0.0472-0.0787-0.0723-0.11707-0.0158-0.0342-0.063-0.0476-0.0867-0.0139-0.0141,0.0197-0.0347,0.0498-0.0247,0.0738,0.0306,0.0495,0.0601,0.0996,0.0915,0.14858,0.0116,0.0299,0.046,0.0153,0.0624,0.007,0.007,0.007,0.003,0.0111-0.005,0.0145-0.0395,0.0251-0.079,0.0501-0.11852,0.0752-0.007-0.008-0.006-0.0136,0.005-0.0174,0.0303-0.0191,0.008-0.0536-0.006-0.0755-0.0288-0.0464-0.0562-0.0938-0.0867-0.13915-0.0125-0.0282-0.041-0.0113-0.0529,0.002-0.008-0.004-0.01-0.009-0.003-0.0151,0.0179-0.0245,0.035-0.0499,0.0534-0.0739,0.006-0.004,0.0128-0.0113,0.0154-0.00038,0.01,0.0166,0.0201,0.0332,0.0301,0.0498z'/%3E %3Cpath d='m503.62,297.62c0.0176,0.0288,0.0352,0.0577,0.0528,0.0865,0.0202-0.0128,0.0404-0.0257,0.0606-0.0385,0.004,0.007,0.008,0.0134,0.0123,0.0201-0.0202,0.0128-0.0404,0.0257-0.0606,0.0385,0.0361,0.0589,0.0719,0.11791,0.10815,0.17669,0.01,0.0247,0.0459,0.0363,0.0601,0.009,0.012-0.012-0.002-0.0327,0.0168-0.038,0.011,0.0382-0.003,0.091-0.0446,0.10459-0.0372,0.0125-0.0662-0.0201-0.0816-0.0497-0.0351-0.0574-0.0702-0.11481-0.10528-0.17222-0.0137,0.009-0.0274,0.0174-0.0411,0.0261-0.0146-0.0138,0.0118-0.028,0.011-0.0444,0.0143-0.0363,0.006-0.0781,0.005-0.11346,0.002-0.002,0.004-0.003,0.006-0.005z'/%3E %3Cpath d='m503.86,297.73c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0392,0.006,0.045-0.005,0.0967-0.0434,0.12511-0.0408,0.0337-0.10185,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0782-0.089-0.12919-0.0143-0.0547,0.006-0.11796,0.0544-0.14936,0.0347-0.0264,0.0848-0.0324,0.12291-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0374-0.11814,0.0749-0.17721,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.0201-0.046-0.0898-0.0615-0.11874-0.0159-0.0186,0.0273-0.0166,0.0639-0.001,0.0921z'/%3E %3Cpath d='m499.4,301.51c0.009-0.0453,0.0205-0.0998,0.0682-0.11958,0.0298-0.0141,0.0664-0.003,0.0874,0.021,0.006-0.0461,0.021-0.0986,0.067-0.11921,0.0407-0.0204,0.0869,0.008,0.10728,0.0442,0.032,0.0494,0.0605,0.10099,0.0934,0.14978,0.0116,0.0283,0.045,0.006,0.0578,0.008,0.009,0.009-0.009,0.012-0.0145,0.0179-0.0366,0.0232-0.0732,0.0465-0.10986,0.0697-0.0187-0.02,0.0352-0.0245,0.0229-0.0513-0.0104-0.0273-0.0287-0.0509-0.0432-0.0763-0.022-0.0341-0.0403-0.0709-0.0665-0.10195-0.037-0.0383-0.0892,0.009-0.097,0.0494-0.0105,0.0158-0.007,0.0306,0.004,0.0433,0.0296,0.0476,0.0577,0.0961,0.0884,0.14295,0.0126,0.0301,0.0472,0.002,0.0605,0.005,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0376,0.0239-0.0753,0.0478-0.11296,0.0716-0.0177-0.0198,0.0333-0.0248,0.0235-0.0507-0.007-0.0251-0.0246-0.0456-0.037-0.0683-0.0228-0.0355-0.0422-0.0733-0.0683-0.10646-0.0303-0.0387-0.0854-0.009-0.0968,0.031-0.009,0.0179-0.017,0.039-0.001,0.055,0.03,0.0481,0.0582,0.0975,0.0897,0.14467,0.013,0.0283,0.0451,0.007,0.0598,0.004,0.0105,0.01-0.006,0.0128-0.0125,0.0184-0.0371,0.0236-0.0743,0.0472-0.11144,0.0708-0.018-0.0191,0.0318-0.0242,0.0196-0.0492-0.01-0.0306-0.0305-0.056-0.0462-0.0839-0.0236-0.037-0.0438-0.0766-0.0723-0.1102-0.0181-0.0231-0.0437,0.0323-0.0494,0.005,0.0195-0.0266,0.0379-0.0543,0.058-0.0801,0.009-0.0102,0.0146-0.005,0.0192,0.006,0.009,0.014,0.0178,0.0279,0.0267,0.0419z'/%3E %3Cpath d='m499.72,301.04c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0141-0.0641-0.041-0.0293-0.0618zm0.10761,0.12264c0.0455,0.0741,0.0905,0.14866,0.13639,0.22256,0.0108,0.027,0.0435,0.0303,0.0628,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0273-0.0214,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11997-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0252,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0113-0.008z'/%3E %3Cpath d='m500.07,301c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0747,0.0453,0.11724-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0382,0.0293,0.10908,0.0231,0.1259-0.0272,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0804,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13136,0.0214-0.036,0.0685-0.0344,0.0973-0.0575-0.00081-0.0122,0.00013-0.0134,0.009-0.0182z'/%3E %3Cpath d='m500.61,301.01c-0.007,0.0504-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.1167-0.0327-0.14347-0.0848-0.0297-0.0539-0.0356-0.12444-0.005-0.17941,0.0196-0.0416,0.0784-0.0636,0.11139-0.0607-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.015-0.0231-0.0372,0.002-0.0476,0.009-0.0101-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00013,0.0666,0.10865,0.13263,0.2177,0.19972,0.32606,0.009,0.0235,0.041,0.0527,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.0499-0.0525,0.0738-0.006,0.004-0.0137,0.0113-0.0165-0.00015-0.006-0.01-0.012-0.0198-0.018-0.0297zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0232-0.0364-0.0798-0.0549-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13127,0.0238,0.0455,0.0636,0.091,0.11846,0.0938,0.0414,0.005,0.0724-0.0299,0.0773-0.0686z'/%3E %3Cpath d='m500.55,300.52c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0142-0.0641-0.041-0.0293-0.0618zm0.10761,0.12263c0.0455,0.0741,0.0905,0.14866,0.13639,0.22256,0.0108,0.027,0.0435,0.0303,0.0627,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11757,0.0746-0.0179-0.0182,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0463-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11998-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0114-0.008z'/%3E %3Cpath d='m500.89,300.48c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0665,0.0748,0.0453,0.11734-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0156,0.0234,0.0158,0.0379,0.0192,0.0382,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0805,0.013-0.11811-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13135,0.0214-0.036,0.0685-0.0344,0.0973-0.0575-0.00089-0.0121,0.00025-0.0135,0.009-0.0184z'/%3E %3Cpath d='m501.27,300.47c0.0185,0.0474,0.0192,0.10488-0.0114,0.14748-0.0269,0.039-0.0792,0.0561-0.12434,0.0428-0.0588-0.0145-0.0998-0.0672-0.1207-0.12143-0.0241-0.0633-0.002-0.14388,0.0573-0.17938,0.0366-0.0251,0.097-0.0315,0.1261,0.008,0.0235,0.0387-0.0481,0.0689-0.0637,0.0272-0.0331-0.0468-0.0987,0.006-0.0936,0.0512-0.00061,0.0476,0.0265,0.0919,0.0609,0.12308,0.028,0.0243,0.0682,0.0437,0.10507,0.0284,0.0457-0.0168,0.0643-0.07,0.0552-0.115-0.004-0.0143-0.00019-0.0101,0.009-0.0119z'/%3E %3Cpath d='m501.19,300.11c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0141-0.0641-0.041-0.0293-0.0618zm0.10762,0.12264c0.0455,0.0741,0.0905,0.14866,0.13638,0.22256,0.0107,0.027,0.0434,0.0303,0.0627,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11757,0.0746-0.0179-0.0182,0.0273-0.0213,0.0207-0.0437-0.003-0.0263-0.0219-0.0469-0.0343-0.0695-0.0247-0.0398-0.048-0.0805-0.0747-0.11901-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0114-0.008z'/%3E %3Cpath d='m501.37,300.23c0.0204-0.028,0.04-0.0568,0.061-0.0842,0.007-0.007,0.0125-0.006,0.0157,0.003,0.0105,0.0172,0.0211,0.0344,0.0316,0.0516-0.002-0.042,0.006-0.0913,0.0448-0.1152,0.0396-0.0275,0.0936-0.0154,0.12895,0.0133,0.062,0.0509,0.0984,0.14039,0.0708,0.21852-0.0166,0.0431-0.0597,0.077-0.10635,0.0789-0.014-0.002-0.025-0.005-0.0136,0.008,0.0206,0.0326,0.0389,0.0667,0.0621,0.0975,0.016,0.0229,0.0436-0.006,0.0568-0.003,0.009,0.008-0.00019,0.011-0.007,0.015-0.0414,0.0263-0.0828,0.0525-0.12419,0.0788-0.0105-0.009-0.004-0.0157,0.007-0.0206,0.0338-0.0208,0.009-0.0562-0.007-0.0799-0.0525-0.0854-0.10415-0.17131-0.15719-0.25637-0.0112-0.0312-0.0442-0.0177-0.0577-0.002-0.002-0.001-0.004-0.003-0.007-0.004zm0.11859-0.0119c0.0277,0.0443,0.0534,0.09,0.0832,0.13285,0.0264,0.0344,0.082,0.0276,0.10682-0.005,0.0281-0.0378,0.0119-0.0891-0.009-0.12621-0.0244-0.0424-0.0634-0.0883-0.11676-0.0871-0.0435,0.004-0.0602,0.0484-0.0641,0.0856z'/%3E %3Cpath d='m501.64,299.82c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0142-0.0641-0.041-0.0293-0.0618zm0.10762,0.12264c0.0455,0.0741,0.0905,0.14866,0.13638,0.22256,0.0107,0.027,0.0435,0.0303,0.0627,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11997-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0252,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0114-0.008z'/%3E %3Cpath d='m501.82,299.71c0.0736,0.11999,0.14652,0.24037,0.22048,0.36012,0.0113,0.0274,0.0443,0.0302,0.0646,0.0109,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.11931,0.0757-0.0182-0.0179,0.026-0.0212,0.0195-0.0429-0.004-0.0265-0.0224-0.0478-0.0352-0.0708-0.0501-0.0815-0.0993-0.16354-0.15014-0.24458-0.008-0.0222-0.0379-0.0402-0.0529-0.0137-0.002,0.0102-0.0221-0.002-0.0112-0.007,0.0183-0.0252,0.0358-0.0515,0.0546-0.0761,0.004-0.002,0.008-0.004,0.0114-0.006z'/%3E %3Cpath d='m502.1,299.71c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0926,0.18256-0.008,0.0774-0.0885,0.14127-0.16575,0.12365-0.0685-0.0147-0.12174-0.0757-0.13172-0.14437-0.008-0.0429-0.00081-0.09,0.0279-0.12411,0.01-0.0123,0.0217-0.0233,0.0351-0.0314zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0264,0.0495,0.0664,0.0972,0.12181,0.11425,0.0395,0.0126,0.0852-0.0179,0.0872-0.0598,0.00079-0.0459-0.0266-0.0866-0.0525-0.12229-0.0308-0.0389-0.0832-0.0818-0.1354-0.0588l-0.008,0.004z'/%3E %3Cpath d='m502.43,299.5c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0747,0.0453,0.11724-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0804,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13135,0.0214-0.036,0.0685-0.0344,0.0973-0.0575-0.00079-0.0122,0.00007-0.0135,0.009-0.0183z'/%3E %3Cpath d='m500.67,303.76c-0.008-0.0471-0.003-0.10287,0.0363-0.13545,0.0322-0.0293,0.0819-0.0434,0.12173-0.021,0.0458,0.0216,0.0535,0.0794,0.0418,0.1235,0.001,0.01-0.0173,0.0351,0.003,0.0264,0.0507-0.01,0.10375,0.0182,0.12664,0.0641,0.0372,0.0626,0.0207,0.14814-0.0334,0.19573-0.028,0.024-0.06,0.0496-0.0978,0.0537-0.0393,0.005-0.0361-0.053-0.0008-0.0544,0.043-0.002,0.097-0.008,0.11396-0.0555,0.0215-0.0483-0.007-0.10444-0.0516-0.1276-0.0368-0.0198-0.0833-0.0101-0.11794,0.01-0.007,0.007-0.0114,0.006-0.014-0.003,0.0355-0.0307,0.0604-0.0827,0.0412-0.1289-0.0133-0.0464-0.0721-0.0722-0.11271-0.0429-0.0357,0.0178-0.0409,0.0653-0.0477,0.0947-0.003,0.00032-0.006,0.00064-0.009,0.00096z'/%3E %3Cpath d='m501.34,303.66c0.006,0.0307,0.0126,0.0613,0.0189,0.092-0.0756,0.048-0.15113,0.0959-0.22669,0.14385-0.0176-0.0218,0.0108-0.0508,0.0102-0.0755,0.0194-0.0845,0.043-0.17235,0.0258-0.25929-0.009-0.0477-0.0444-0.0971-0.0969-0.0988-0.059-0.004-0.10573,0.0573-0.0967,0.11343,0.004,0.0118,0.005,0.0216-0.007,0.0262-0.0229-0.0475-0.0257-0.10949,0.0102-0.15152,0.037-0.045,0.10455-0.0644,0.15783-0.0376,0.0526,0.0246,0.0715,0.0873,0.0713,0.14139,0.00083,0.0817-0.0208,0.16123-0.036,0.2409-0.004,0.0131-0.008,0.0245,0.006,0.0127,0.0415-0.0268,0.0839-0.0522,0.12449-0.0804,0.0238-0.0133,0.0237-0.0442,0.0323-0.0632,0.002-0.001,0.004-0.003,0.007-0.004z'/%3E %3Cpath d='m501.45,303.62c0.0186-0.0133,0.0477-0.003,0.0542,0.0186,0.009,0.0211-0.006,0.0471-0.0283,0.0506-0.0199,0.004-0.0398-0.0112-0.0425-0.031-0.003-0.0149,0.004-0.0303,0.0166-0.0382z'/%3E %3Cpath d='m501.73,302.97c0.0447-0.0284,0.0893-0.0567,0.13403-0.0851,0.0179,0.0152-0.0151,0.0201-0.0175,0.036-0.0254,0.0418-0.0164,0.092-0.0186,0.13867-0.00053,0.0539-0.001,0.10789-0.002,0.16183,0.0251,0.0399,0.0482,0.0812,0.0749,0.12001,0.0163,0.0297,0.051,0.0178,0.0718,0.00072,0.009,0.00041,0.0111,0.0144-0.001,0.016-0.0509,0.0323-0.10185,0.0646-0.15277,0.0969-0.0103-0.009-0.004-0.0145,0.006-0.0192,0.0379-0.0172,0.026-0.0619,0.004-0.0872-0.018-0.0294-0.036-0.0588-0.054-0.0882-0.0802-0.0372-0.15977-0.076-0.2406-0.11184-0.0217-0.0163-0.0554,0.005-0.0717-0.002-0.009-0.009,0.01-0.0114,0.0147-0.0171,0.0487-0.0309,0.0974-0.0618,0.14606-0.0927,0.0175,0.0148-0.0128,0.0177-0.0176,0.0313-0.0252,0.0332,0.0214,0.0529,0.0463,0.0636,0.049,0.0233,0.0981,0.0466,0.14712,0.07,0.00023-0.0642,0.003-0.12851,0.001-0.19271,0.004-0.0373-0.0404-0.0503-0.064-0.0302-0.002-0.003-0.004-0.006-0.007-0.009z'/%3E %3Cpath d='m502.44,302.93c0.0185,0.0474,0.0192,0.10489-0.0114,0.14749-0.0268,0.039-0.0792,0.0561-0.12433,0.0428-0.0588-0.0145-0.0999-0.0672-0.1207-0.12149-0.0241-0.0633-0.002-0.14386,0.0573-0.17935,0.0367-0.0251,0.0971-0.0315,0.1262,0.008,0.0235,0.0387-0.0478,0.0691-0.0635,0.0273-0.0329-0.0469-0.0986,0.006-0.0936,0.0512-0.00061,0.0476,0.0265,0.0919,0.0609,0.12308,0.028,0.0243,0.0682,0.0437,0.10503,0.0284,0.0457-0.0168,0.0643-0.07,0.0552-0.115-0.004-0.0141-0.0005-0.0102,0.009-0.012z'/%3E %3Cpath d='m502.5,302.66c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0927,0.18256-0.008,0.0774-0.0885,0.14127-0.16572,0.12365-0.0685-0.0147-0.12184-0.0757-0.13177-0.14437-0.009-0.046,0.00092-0.0967,0.034-0.13134,0.008-0.009,0.0183-0.0176,0.029-0.0242zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0265,0.0495,0.0664,0.0972,0.12179,0.11425,0.0395,0.0126,0.0852-0.0179,0.0872-0.0598,0.00079-0.0459-0.0266-0.0865-0.0525-0.12229-0.0308-0.0388-0.0832-0.0818-0.13533-0.0588l-0.008,0.004h-0.0001z'/%3E %3Cpath d='m502.77,302.55c0.007-0.0439,0.0195-0.0963,0.0636-0.11675,0.0378-0.0194,0.0806,0.006,0.10141,0.0387,0.0332,0.0496,0.0621,0.10205,0.0948,0.15203,0.0113,0.0256,0.0427,0.0219,0.0597,0.009,0.006,0.007,0.005,0.0118-0.003,0.0149-0.0398,0.0253-0.0797,0.0506-0.11952,0.0759-0.009-0.009-0.003-0.0141,0.007-0.0191,0.0304-0.0187,0.009-0.0521-0.006-0.0733-0.0242-0.039-0.0472-0.0787-0.0723-0.11709-0.0158-0.0342-0.063-0.0476-0.0867-0.0139-0.0141,0.0197-0.0347,0.0498-0.0246,0.0738,0.0306,0.0495,0.0602,0.0996,0.0915,0.14858,0.0116,0.0298,0.046,0.0154,0.0624,0.007,0.007,0.007,0.003,0.0111-0.005,0.0145-0.0395,0.0251-0.079,0.0501-0.11853,0.0752-0.007-0.008-0.006-0.0136,0.005-0.0174,0.0303-0.019,0.008-0.0536-0.006-0.0755-0.0288-0.0464-0.0562-0.0938-0.0867-0.13915-0.0125-0.0282-0.041-0.0113-0.0529,0.002-0.008-0.004-0.01-0.009-0.003-0.0151,0.0179-0.0245,0.035-0.0499,0.0534-0.0739,0.006-0.004,0.0128-0.0113,0.0154-0.00038,0.01,0.0166,0.02,0.0332,0.03,0.0498z'/%3E %3Cpath d='m503.08,302.29c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.0645,0.0321,0.0976,0.10743,0.0933,0.17721-0.005,0.0769-0.0814,0.14263-0.15848,0.13046-0.0719-0.0116-0.12926-0.0745-0.13952-0.14583-0.009-0.046,0.00092-0.0967,0.034-0.13134,0.008-0.009,0.0182-0.0176,0.0289-0.0242zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0265,0.0495,0.0664,0.0972,0.12181,0.11425,0.0395,0.0126,0.0852-0.0179,0.0872-0.0598,0.00079-0.0459-0.0266-0.0865-0.0525-0.12229-0.0308-0.0388-0.0832-0.0818-0.13533-0.0588l-0.008,0.004h-0.0001z'/%3E %3Cpath d='m503.57,302.22c0.0185,0.0474,0.0192,0.10486-0.0114,0.14748-0.0269,0.039-0.0792,0.0561-0.12436,0.0428-0.0588-0.0145-0.0999-0.0672-0.1207-0.12149-0.0241-0.0634-0.002-0.14388,0.0573-0.17944,0.0366-0.0251,0.097-0.0315,0.1261,0.008,0.0234,0.0387-0.0478,0.0692-0.0635,0.0274-0.0329-0.0469-0.0986,0.006-0.0936,0.0512-0.00059,0.0477,0.0265,0.092,0.0609,0.12318,0.028,0.0242,0.0682,0.0437,0.10502,0.0284,0.0456-0.0168,0.0643-0.07,0.0551-0.115-0.004-0.0142-0.00027-0.0102,0.009-0.0121z'/%3E %3Cpath d='m503.61,302.1c0.0236,0.0413,0.0641,0.0774,0.11362,0.0798,0.0492,0.004,0.10025-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12507-0.0408,0.0337-0.10186,0.0341-0.14599,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11789,0.0543-0.14942,0.0332-0.0252,0.0803-0.0321,0.11772-0.0123,0.0211,0.011,0.0469,0.033,0.0516,0.0534-0.059,0.0374-0.11808,0.0748-0.17712,0.11224zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.046-0.0897-0.0616-0.11864-0.016-0.0188,0.0274-0.0163,0.064-0.001,0.0922z'/%3E %3Cpath d='m503.83,301.81c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0404,0.003-0.10429,0.0543-0.10932,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.008,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12647,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0133-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m504.06,301.82c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0491,0.004,0.10014-0.036,0.0987-0.0871,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12507-0.0408,0.0337-0.10186,0.0341-0.14599,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11789,0.0543-0.14942,0.0332-0.0252,0.0803-0.0321,0.11772-0.0123,0.0211,0.011,0.0468,0.0329,0.0516,0.0534-0.059,0.0374-0.11801,0.0748-0.17702,0.11224zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.046-0.0897-0.0616-0.11864-0.016-0.0188,0.0274-0.0163,0.064-0.002,0.0922z'/%3E %3Cpath d='m504.19,301.38c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0142-0.0641-0.041-0.0293-0.0618zm0.10761,0.12264c0.0455,0.0741,0.0905,0.14866,0.13638,0.22256,0.0108,0.027,0.0435,0.0304,0.0628,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11995-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0113-0.008z'/%3E %3Cpath d='m504.54,301.37c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0982-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0665,0.0748,0.0453,0.11734-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0156,0.0234,0.0158,0.0379,0.0193,0.0381,0.0294,0.10908,0.0231,0.1259-0.0272,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0804,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13139,0.0215-0.0359,0.0685-0.0344,0.0973-0.0574-0.00089-0.0121,0.00025-0.0135,0.009-0.0184z'/%3E %3Cpath d='m504.74,301.03c0.0736,0.11999,0.14652,0.24037,0.22048,0.36012,0.0113,0.0274,0.0444,0.0302,0.0647,0.0109,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.11931,0.0757-0.0183-0.018,0.0261-0.0212,0.0196-0.0429-0.004-0.0265-0.0224-0.0478-0.0352-0.0708-0.0501-0.0815-0.0993-0.16351-0.15013-0.24455-0.008-0.0222-0.038-0.0403-0.0528-0.0136-0.001,0.0104-0.0221-0.001-0.0111-0.007,0.0183-0.0253,0.0358-0.0515,0.0546-0.0762,0.004-0.002,0.007-0.004,0.0111-0.007z'/%3E %3Cpath d='m505.19,301.28c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.05,0.01-0.0952-0.0439-0.0865-0.0918,0.0107-0.0549,0.0488-0.0986,0.0805-0.14279,0.0145-0.0111-0.008-0.0249-0.0115-0.0362-0.0193-0.0402-0.0774-0.0391-0.0974-0.00063-0.01,0.0163-0.003,0.0347,0.007,0.0482,0.0203,0.0196,0.005,0.0595-0.0253,0.0509-0.0445-0.0226-0.0284-0.0874,0.002-0.11585,0.03-0.0284,0.0702-0.055,0.11332-0.0498,0.0329,0.006,0.0485,0.0387,0.065,0.0642,0.0254,0.0411,0.0498,0.0828,0.0764,0.12315,0.008,0.0219,0.0361,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.0119,0.0132,0.008,0.0221-0.001,0.0346-0.0243,0.0955-0.0685,0.0744-0.01-0.005-0.0162-0.019-0.0233-0.0238zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.033-0.0517,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0558z'/%3E %3Cpath d='m501.13,304.57c0.0407-0.0258,0.0814-0.0517,0.12213-0.0775,0.002,0.005,0.0112,0.0109,0.003,0.0132-0.0294,0.0124-0.0163,0.0487,0.008,0.0587,0.0489,0.0351,0.0979,0.0702,0.14684,0.10532-0.0111-0.0662-0.0219-0.13242-0.0332-0.19857,0.00087-0.0208-0.0216-0.0341-0.0379-0.0189-0.004,0.0118-0.0181-0.006-0.0105-0.008,0.0272-0.0172,0.0543-0.0345,0.0815-0.0517,0.002,0.005,0.0136,0.0128,0.00043,0.0154-0.019,0.0166-0.0118,0.0436-0.009,0.0656,0.0147,0.0909,0.0294,0.18187,0.0441,0.2728-0.005,0.001-0.0101,0.01-0.0147,0.005-0.0776-0.0555-0.15519-0.11084-0.23272-0.16636-0.0176-0.0176-0.0455-0.009-0.0631-0.007-0.002-0.003-0.004-0.005-0.005-0.008z'/%3E %3Cpath d='m501.53,304.43c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0491,0.004,0.10022-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.0321-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12511-0.0408,0.0337-0.10186,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0781-0.089-0.12919-0.0143-0.0547,0.006-0.11791,0.0543-0.14944,0.0347-0.0264,0.0848-0.0323,0.12289-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.059,0.0374-0.11807,0.0748-0.17711,0.11226zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m501.75,304.14c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.10429,0.0543-0.10932,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00051-0.048-0.008-0.0497,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12647,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0103-0.001,0.0126-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14124-0.0123-0.0251-0.0408-0.0133-0.0516,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m502.21,304.21c-0.007,0.0505-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.11677-0.0326-0.14347-0.0848-0.0297-0.0539-0.0356-0.12445-0.005-0.17944,0.0196-0.0415,0.0784-0.0638,0.11139-0.0606-0.0209-0.0333-0.0399-0.068-0.0637-0.0994-0.015-0.0231-0.0372,0.002-0.0476,0.009-0.0101-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00013,0.0666,0.10865,0.13262,0.2177,0.19972,0.32607,0.009,0.0235,0.041,0.0527,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.007,0.004-0.0138,0.0114-0.0165-0.00016-0.006-0.01-0.012-0.0199-0.018-0.0299zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0233-0.0363-0.0798-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13131,0.0237,0.0455,0.0636,0.0909,0.11846,0.0937,0.0414,0.005,0.0724-0.0298,0.0773-0.0685z'/%3E %3Cpath d='m502.45,304.03c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0993-0.0494-0.0852-0.0991,0.0144-0.0549,0.0528-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0502,0.0455-0.0851,0.0877-0.10459,0.0374-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0982,0.0909,0.14612,0.008,0.0218,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0953-0.0685,0.0744-0.01-0.005-0.0165-0.0184-0.0229-0.0237zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.0329-0.0517,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.0221-0.0362,0.0284-0.0558z'/%3E %3Cpath d='m502.75,303.86c-0.007,0.0505-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.1167-0.0327-0.14347-0.0848-0.0297-0.0539-0.0356-0.12444-0.005-0.17941,0.0196-0.0415,0.0784-0.0639,0.11139-0.0606-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.015-0.0231-0.0372,0.002-0.0477,0.009-0.01-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00013,0.0666,0.10865,0.13263,0.2177,0.19972,0.32606,0.009,0.0235,0.041,0.0527,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.007,0.004-0.0138,0.0114-0.0165-0.00016-0.006-0.01-0.012-0.0199-0.018-0.0299zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0233-0.0363-0.0798-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13131,0.0238,0.0455,0.0636,0.091,0.11846,0.0938,0.0414,0.005,0.0724-0.0299,0.0773-0.0686z'/%3E %3Cpath d='m502.95,303.91c-0.003-0.004-0.005-0.008-0.008-0.0126,0.0279-0.0315,0.041-0.0885,0.008-0.1207-0.0141-0.002-0.0131,0.0195-0.0251,0.0233-0.0271,0.0219-0.0648-0.0128-0.0535-0.0427,0.0104-0.0404,0.0666-0.0433,0.0909-0.0145,0.0341,0.0337,0.0354,0.0896,0.0122,0.12973-0.006,0.0134-0.0173,0.0254-0.0246,0.0375z'/%3E %3Cpath d='m502.99,303.38c0.0403-0.0256,0.0807-0.0512,0.12099-0.0768,0.0151,0.0129-0.006,0.0164-0.0126,0.0278-0.0112,0.0269,0.0203,0.0418,0.039,0.0546,0.0445,0.0286,0.089,0.0571,0.13353,0.0857-0.011-0.0631-0.0208-0.12647-0.0325-0.18944,0.00003-0.0282-0.0299-0.029-0.0442-0.0188-0.009-0.008-0.002-0.012,0.006-0.0161,0.0242-0.0154,0.0484-0.0307,0.0725-0.0461,0.017,0.0155-0.0171,0.0256-0.0113,0.0463,0.01,0.0684,0.0224,0.13653,0.0334,0.20481,0.009,0.0568,0.0197,0.11345,0.0276,0.17045,0.005,0.0445-0.009,0.0981-0.0514,0.11987-0.0372,0.0236-0.0787-0.0362-0.0367-0.0573,0.025-0.0106,0.0652-0.0113,0.0614-0.0496-0.00042-0.0306-0.008-0.0605-0.0129-0.0907-0.0732-0.0475-0.1463-0.0952-0.21967-0.14246-0.0202-0.0144-0.0482-0.0187-0.0689-0.0136-0.002-0.003-0.003-0.006-0.005-0.009z'/%3E %3Cpath d='m503.44,302.89c0.0736,0.11999,0.14651,0.24036,0.22047,0.3601,0.0114,0.0274,0.0444,0.0303,0.0647,0.0109,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.11931,0.0757-0.0182-0.0179,0.026-0.0212,0.0195-0.0429-0.004-0.0265-0.0224-0.0478-0.0352-0.0708-0.0501-0.0815-0.0993-0.16356-0.15018-0.24456-0.008-0.0222-0.0379-0.0402-0.0529-0.0137-0.002,0.0102-0.0221-0.002-0.0112-0.007,0.0183-0.0252,0.0358-0.0515,0.0546-0.0761,0.004-0.002,0.008-0.004,0.0114-0.006z'/%3E %3Cpath d='m503.88,303.12c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0528-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.002-0.0502,0.0455-0.0851,0.0877-0.10449,0.0374-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0482,0.0593,0.0982,0.0909,0.14608,0.008,0.0218,0.0361,0.013,0.0362-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0953-0.0685,0.0744-0.01-0.005-0.0164-0.0186-0.0229-0.0237zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0223,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0454,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m503.99,302.75c0.0407-0.0258,0.0814-0.0517,0.12213-0.0775,0.002,0.005,0.0112,0.0109,0.003,0.0132-0.0294,0.0124-0.0163,0.0486,0.008,0.0586,0.0489,0.0351,0.0979,0.0702,0.14684,0.10532-0.0111-0.0662-0.0219-0.13242-0.0332-0.19857,0.00088-0.0208-0.0216-0.0341-0.0379-0.0189-0.004,0.0118-0.018-0.006-0.0104-0.008,0.0272-0.0172,0.0543-0.0345,0.0815-0.0517,0.002,0.006,0.0136,0.0128,0.00043,0.0154-0.019,0.0166-0.0118,0.0437-0.009,0.0657,0.0147,0.0909,0.0294,0.18187,0.0441,0.2728-0.005,0.001-0.0101,0.01-0.0147,0.005-0.0776-0.0555-0.15518-0.11084-0.23271-0.16636-0.0176-0.0176-0.0455-0.009-0.0631-0.007-0.002-0.003-0.004-0.005-0.005-0.008z'/%3E %3Cpath d='m504.39,302.61c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0491,0.004,0.10022-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.0321-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12511-0.0408,0.0337-0.10185,0.0341-0.14599,0.007-0.0454-0.0287-0.075-0.0782-0.0889-0.12919-0.0143-0.0547,0.006-0.11798,0.0543-0.14946,0.0347-0.0264,0.0848-0.0322,0.12291-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0374-0.11813,0.0748-0.1772,0.11226zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m504.62,302.32c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00051-0.048-0.008-0.0497,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12647,0.0132,0.0297,0.0502,0.0279,0.071,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0133-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0126-0.008z'/%3E %3Cpath d='m505.07,302.39c-0.007,0.0505-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.1167-0.0327-0.14347-0.0848-0.0296-0.054-0.0356-0.12442-0.006-0.17941,0.0196-0.0415,0.0784-0.0639,0.11143-0.0606-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.015-0.0231-0.0371,0.002-0.0476,0.009-0.0101-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00013,0.0666,0.10865,0.13263,0.2177,0.19972,0.32606,0.009,0.0235,0.041,0.0527,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.007,0.004-0.0138,0.0113-0.0165-0.00015-0.006-0.01-0.0121-0.0199-0.0181-0.0299zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0233-0.0363-0.0798-0.0551-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13127,0.0237,0.0456,0.0636,0.0909,0.11846,0.0937,0.0414,0.005,0.0724-0.0298,0.0773-0.0685z'/%3E %3Cpath d='m505.32,302.21c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0993-0.0494-0.0852-0.0991,0.0144-0.0549,0.0528-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0504-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.002-0.0469,0.0405-0.0807,0.0795-0.10053,0.0382-0.0258,0.094-0.0166,0.11355,0.0278,0.031,0.0482,0.0593,0.0982,0.0909,0.14608,0.008,0.0218,0.0361,0.013,0.0362-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0953-0.0685,0.0744-0.01-0.005-0.0165-0.0184-0.0229-0.0237zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.0329-0.0517,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.0221-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m505.62,302.04c-0.007,0.0504-0.0463,0.0971-0.0985,0.10226-0.0601,0.007-0.11676-0.0328-0.14357-0.0849-0.0297-0.054-0.0354-0.12445-0.005-0.17941,0.0196-0.0415,0.0784-0.0639,0.11139-0.0606-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.015-0.0231-0.0372,0.002-0.0477,0.009-0.01-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0485,0.0515-0.0718,0.006-0.004,0.0135-0.0113,0.0162,0.00014,0.0666,0.10865,0.13263,0.2177,0.19972,0.32606,0.009,0.0235,0.041,0.0526,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.007,0.004-0.0138,0.0114-0.0165-0.00016-0.006-0.01-0.0119-0.0199-0.0179-0.0298zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0232-0.0364-0.0798-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13128,0.0237,0.0456,0.0636,0.091,0.11846,0.0937,0.0414,0.005,0.0724-0.0298,0.0773-0.0685z'/%3E %3Cpath d='m505.85,301.54c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0926,0.18256-0.008,0.0774-0.0885,0.14127-0.16575,0.12365-0.0685-0.0147-0.12172-0.0757-0.13172-0.14434-0.009-0.046,0.00091-0.0967,0.034-0.13137,0.009-0.009,0.0182-0.0177,0.029-0.0242zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0264,0.0495,0.0664,0.0972,0.12181,0.11427,0.0396,0.0127,0.0852-0.0181,0.0872-0.0599,0.00079-0.0459-0.0266-0.0866-0.0526-0.12229-0.0307-0.0388-0.0832-0.0818-0.13529-0.0588l-0.008,0.004-0.0001,0.0001z'/%3E %3Cpath d='m506.18,301.33c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0748,0.0453,0.11728-0.019,0.0507-0.0741,0.0665-0.11952,0.0836-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0156,0.0234,0.0158,0.0379,0.0192,0.0382,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0805,0.013-0.11811-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13135,0.0215-0.0359,0.0685-0.0345,0.0973-0.0575-0.00094-0.0122,0.00031-0.0135,0.009-0.0184z'/%3E %3Cpath d='m501.57,305.09c0.0392,0.0641,0.0784,0.12829,0.11763,0.19243,0.008-0.0417,0.017-0.0917,0.0587-0.11295,0.0391-0.0235,0.0858,0.004,0.10707,0.0387,0.0348,0.0498,0.0631,0.10372,0.0973,0.15384,0.0117,0.0249,0.0421,0.0128,0.0562,0.007,0.01,0.009-0.003,0.0121-0.009,0.0168-0.0378,0.024-0.0757,0.048-0.11352,0.072-0.0157-0.0149,0.0141-0.0181,0.019-0.0309,0.0136-0.0239-0.008-0.0458-0.0195-0.0659-0.0272-0.0431-0.0516-0.0881-0.0822-0.12878-0.0337-0.0444-0.0914,0.00043-0.0971,0.0436-0.009,0.016-0.005,0.0303,0.006,0.0433,0.0293,0.0471,0.0571,0.0952,0.0876,0.14148,0.0124,0.0297,0.0463,0.003,0.0599,0.005,0.009,0.009-0.006,0.0113-0.0113,0.0163-0.0378,0.024-0.0756,0.048-0.11347,0.072-0.0183-0.0192,0.032-0.0244,0.0199-0.0496-0.0119-0.0325-0.0333-0.0604-0.0505-0.0903-0.0463-0.0749-0.0911-0.15077-0.13861-0.22492-0.0118-0.0318-0.0434-0.0188-0.0567-0.003-0.012-0.004-0.005-0.0117,0.00089-0.0187,0.0169-0.0231,0.0328-0.0473,0.0504-0.0698,0.004-0.002,0.008-0.005,0.0119-0.008z'/%3E %3Cpath d='m502.17,305.24c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0853-0.0992,0.0144-0.0549,0.0527-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0566-0.058-0.0355-0.007-0.0797,0.0339-0.0571,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0501,0.0455-0.0851,0.0877-0.10449,0.0374-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0982,0.091,0.14612,0.008,0.0219,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0954-0.0685,0.0745-0.01-0.005-0.0163-0.0186-0.0231-0.0238zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10024-0.0223,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m502.21,304.89c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0708,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0195-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0123-0.0251-0.0408-0.0133-0.0516,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0129-0.008z'/%3E %3Cpath d='m502.61,304.96c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0853-0.0992,0.0144-0.0549,0.0527-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0566-0.058-0.0355-0.007-0.0797,0.0339-0.0571,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0254,0.0324-0.0652-0.01-0.0574-0.0407,0.003-0.0501,0.0455-0.0851,0.0877-0.10452,0.0373-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0983,0.091,0.14616,0.008,0.0218,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0955-0.0685,0.0745-0.01-0.005-0.0163-0.0186-0.0231-0.0238zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10024-0.0224,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m502.73,304.36c0.0736,0.11999,0.14651,0.24036,0.22047,0.3601,0.0114,0.0274,0.0443,0.0302,0.0648,0.0111,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.1193,0.0757-0.0182-0.0179,0.026-0.0213,0.0194-0.0431-0.003-0.0261-0.0217-0.0464-0.034-0.0688-0.0505-0.0821-0.10013-0.16484-0.15135-0.24654-0.008-0.0221-0.038-0.0403-0.0528-0.0136-0.001,0.0104-0.0221-0.001-0.0111-0.007,0.0183-0.0253,0.0358-0.0515,0.0546-0.0762,0.004-0.002,0.007-0.004,0.0112-0.007z'/%3E %3Cpath d='m502.86,304.27c0.0404-0.0273,0.075,0.0466,0.0293,0.0616-0.0386,0.014-0.0639-0.0407-0.0293-0.0616zm0.10761,0.12263c0.0455,0.0741,0.0905,0.14865,0.13638,0.22254,0.0108,0.027,0.0435,0.0306,0.0628,0.0145,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11757,0.0746-0.0179-0.0182,0.0273-0.0215,0.0206-0.0439-0.003-0.0263-0.0219-0.047-0.0343-0.0696-0.0247-0.0398-0.048-0.0805-0.0747-0.11899-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0252,0.036-0.0513,0.0549-0.076,0.004-0.002,0.008-0.005,0.0114-0.007z'/%3E %3Cpath d='m503.15,304.35c0.001-0.0445,0.0192-0.0955,0.0642-0.1128,0.0514-0.0213,0.11161,0.004,0.14391,0.0466,0.0404,0.0481,0.0614,0.11587,0.0401,0.17686-0.016,0.0581-0.0692,0.10206-0.12889,0.10841-0.019-0.00029-0.0489,0.0132-0.0566-0.0111-0.0604-0.0983-0.11978-0.19719-0.18102-0.29494-0.009-0.0236-0.0395-0.0395-0.0544-0.012-0.003,0.0111-0.0214-0.004-0.01-0.01,0.0182-0.025,0.0356-0.0509,0.0544-0.0753,0.006-0.004,0.0135-0.0113,0.0162-0.00011,0.0373,0.0613,0.0747,0.12263,0.112,0.18394zm0.0112,0.0184c0.0321,0.0525,0.0641,0.10491,0.0962,0.15737,0.0441,0.0134,0.10374-0.007,0.10818-0.0587,0.01-0.052-0.019-0.10239-0.0516-0.14062-0.0283-0.0331-0.0832-0.0513-0.11982-0.0209-0.0194,0.0154-0.027,0.0401-0.033,0.0628z'/%3E %3Cpath d='m503.42,304.12c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0404,0.003-0.10429,0.0543-0.10932,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0267-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0195-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0132-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0127-0.008z'/%3E %3Cpath d='m503.64,304.13c0.0236,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10022-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12507-0.0408,0.0337-0.10185,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0781-0.089-0.12919-0.0143-0.0547,0.006-0.11793,0.0543-0.14942,0.0332-0.0252,0.0803-0.0321,0.11774-0.0123,0.0211,0.011,0.0469,0.0329,0.0516,0.0534-0.059,0.0374-0.11807,0.0748-0.17711,0.11224zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.046-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.0639-0.002,0.0921z'/%3E %3Cpath d='m503.96,303.78c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0748,0.0453,0.11734-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0156,0.0234,0.0158,0.0379,0.0192,0.0381,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.0004-0.0804,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13135,0.0214-0.036,0.0685-0.0344,0.0973-0.0575-0.00088-0.0121,0.00024-0.0135,0.009-0.0184z'/%3E %3Cpath d='m504.2,303.92c0.0186-0.0133,0.0477-0.003,0.0542,0.0186,0.009,0.0211-0.006,0.0472-0.0283,0.0506-0.0198,0.004-0.0398-0.0112-0.0425-0.031-0.003-0.0149,0.004-0.0303,0.0166-0.0382z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23201b18' d='m484.35,254.87c-7.744-0.13352-15.563,1.6319-22.066,5.6673-2.99,1.8545-3.6925,2.4776-2.0481,5.4596-0.38869,0.26705-3.1096,1.0978-3.7822,1.3352-2.4892,0.94255-5.0162,1.8903-7.131,3.16-1.2857,0.77145-1.8239,1.35-2.8106,2.3737l6.2041-0.47474c-0.19435,0.40056-0.64282,0.97914-0.89698,1.3649-1.0614,1.5281-1.7192,2.7446-2.6461,4.3469,1.7572-1.1898,3.3387-2.3027,5.3668-3.2935,4.4399-2.2402,12.423-2.2995,15.697-6.2311,0.83718-0.99398,0.3289-1.5874-0.37374-3.2045,2.4218-0.80111,3.3337-1.3649,6.2787-2.0325,7.1161-1.5874,12.02,0.29671,15.458-0.54893,1.0764-0.26705,2.1229-0.86048,2.1976-1.988l-0.50828-3.5902,11.556-0.0148c0.0148,2.0325-1.9434,4.6434,1.6445,5.5782,3.244,0.84564,9.8069-1.0088,15.473,0.56375l6.2787,2.0325c-0.0299,0.29671-0.47841,1.0978-0.61295,1.5132-0.26908,0.72696-0.23918,1.1127,0.22426,1.6319,0.61293,0.69727,1.48,1.3945,2.4069,1.9286,1.8388,1.0533,4.2457,1.7209,6.5182,2.2699,6.533,1.5874,7.146,2.0028,12.169,5.3557-0.3289-0.97917-2.7209-4.4656-3.5131-5.697l6.1742,0.48958c-1.0614-1.6171-4.3206-3.3232-6.2041-4.0651l-7.5196-2.7446c0.68373-1.3109,1.2543-2.4034,0.56808-3.4865-1.0465-1.5874-7.3239-4.6708-8.91-5.1035-2.7092-0.73914-5.5574-1.342-8.2333-1.7697-2.676-0.42776-7.8227-0.79685-7.8227-0.79685-0.36827-0.38926,0.70904-2.4303-0.94182-3.8574-0.97172-0.77146-2.377-1.0385-3.8121-1.1869-5.7406-0.54892-13.559-0.38574-19.36,0-1.6744,0.10385-2.8554,0.28188-3.8121,1.1869-1.1661,1.0978-1.3156,1.7654-1.2109,3.8275z'/%3E %3Cg fill='%23002d62'%3E %3Cpath d='m485.96,258.96c0.85213-0.75661,0.97172-0.97917,2.3321-1.4391,2.9601-0.99399,7.6244-0.90499,10.749-0.90499,2.5414,0.0148,5.023-0.0297,7.5347,0.2077,2.5414,0.25221,4.0364,0.56375,5.7258,2.0325,0.29897-1.7654,0.68767-3.2788,0.74746-5.2221,0.0748-2.0918-1.1063-2.715-2.9601-3.0859-3.0646-0.63793-8.2073-0.57859-11.511-0.54893-2.1528,0.0148-9.8069,0.0742-11.362,0.63793-1.4202,0.50442-2.5414,1.6171-2.4218,3.5457,0.0448,0.96433,0.76244,4.1688,1.166,4.777z'/%3E %3Cpath d='m463.44,268.96c0.52324-0.47474,0.16445-0.94948,2.5863-2.2995,3.0498-1.7061,7.3254-3.2788,10.823-3.9759,3.0347-0.59342,6.1592-0.57858,9.3286-0.34121,1.4053,0.10385,3.2591,0.32637,4.6495,0.10385,0,0,1.4992-0.35087,1.9202-0.72236,0.55134-0.48647,0.51656-1.6068,0.51656-1.6068-1.0166-0.81596-3.9168,2.0028-6.5478,1.1127-0.85213-0.28187-1.0913-1.6616-1.4202-2.611l-0.85213-3.2341c-4.8138-0.62311-13.066,1.3055-17.521,3.2936-2.0182,0.89014-5.3371,2.5666-6.5777,3.8574-1.1063,1.1275,0.0299,2.7743,0.6578,3.605,0.79157,1.0274,1.8591,2.243,2.4369,2.8183z'/%3E %3Cpath d='m504.86,260.04c-0.26908,1.6913,0.97172,2.1808,2.4667,2.4034,3.0945,0.43024,7.7289-0.97916,13.873,0.22254,2.6312,0.51924,5.2024,1.3945,7.4897,2.3292,0.92688,0.38574,4.156,1.8841,4.8138,2.5369l1.1661,1.3946c0.32889-0.17803,2.1079-2.3144,2.4667-2.7743,0.68767-0.8753,1.7042-2.4479,0.65777-3.6495-0.91193-1.0533-4.8886-3.1156-6.6526-3.8722-2.3546-1.0099-6.0986-1.9134-9.003-2.4033-2.9594-0.49922-8.8576-0.92915-8.8576-0.92915s-0.37804,5.4836-1.888,5.9435c-2.945,0.8753-4.3804-1.5874-6.533-1.2017z'/%3E %3Cpath d='m528.14,266.85c-0.19436,0.84564-0.56811,0.9198,0.98667,2.2105,3.6327,2.9968,9.7471,3.1452,13.574,4.7919,1.9434,0.84564,3.0199,1.5429,4.7392,2.5814-0.16446-0.50442-2.392-3.7238-2.945-4.5694,1.7043-0.0297,3.9317,0.13352,5.6808,0.23737-0.0897-0.0593-0.13456-0.14836-0.2392-0.23737-2.5714-2.255-9.1193-4.3172-12.408-5.4001-0.94731,1.1093-1.8564,2.1881-2.9002,3.2787-0.40364,0.38574-0.65779,0.65277-1.4651,0.43024-1.0166-0.28187-1.8089-1.1572-2.4218-1.7061-0.59798-0.53409-1.8089-1.5429-2.6013-1.6171z'/%3E %3Cpath d='m504.95,259.49c1.8538,0.13352,2.1079,0.47474,3.5131,1.0978,0.56811,0.25221,1.2857,0.3709,2.0182,0.31156,1.0016-0.0742,1.1212-0.2077,1.3903-0.99399,0.3887-1.1275-1.5099-1.8693-2.3919-2.0622l-4.0812-0.60827z'/%3E %3Cpath d='m493.14,259.51-0.3887-2.2253c-1.2259-0.13353-6.9068,0.83079-6.488,2.5814,0.20929,0.81596,0.3887,0.94948,1.2857,1.0385,2.4667,0.22253,2.8553-1.3204,5.5911-1.3945z'/%3E %3Cpath d='m463.9,269.3c0.82221,1.4687,3.0199-1.1572,4.3055-2.1066,0.73254-0.54893,0.82223-0.53409,1.6445-0.8753l-0.44849-0.71211c-0.70262,0.14835-2.4667,1.1127-3.1244,1.4687-0.97172,0.53409-2.0481,1.2314-2.377,2.2254z'/%3E %3Cpath d='m528.3,266.32c0.26908,0.13353,0.53818,0.1632,0.85213,0.35606,1.8388,1.0682,4.0812,3.9315,4.9632,2.8632,0.53819-0.66761-1.465-2.0325-2.078-2.3589l-3.244-1.5578c-0.17941,0.14835-0.40364,0.44505-0.49333,0.69727z'/%3E %3Cpath d='m469.91,266.91c0.19435,0.84564,0.56811,0.9198-0.98667,2.2105-3.6327,2.9968-9.7471,3.1452-13.574,4.7919-1.9434,0.84564-3.0199,1.5429-4.7392,2.5814,0.16445-0.50442,2.392-3.7238,2.945-4.5694-1.7043-0.0297-3.9317,0.13352-5.6808,0.23737,0.0897-0.0593,0.13454-0.14836,0.2392-0.23737,2.5714-2.255,9.1193-4.3172,12.408-5.4001,0.34385,0.35606,0.6279,0.7418,0.94183,1.1127,0.38869,0.47474,1.5248,1.7506,1.9584,2.166,0.40364,0.38574,0.6578,0.65277,1.4651,0.43024,1.0166-0.28187,1.8089-1.1572,2.4218-1.7061,0.598-0.53408,1.8089-1.5429,2.6013-1.6171z'/%3E %3C/g%3E %3Cg fill='%23eac102'%3E %3Cpath d='m470.77,258.54c-0.524-0.0106-0.99379,0.24777-1.4638,0.4419-0.15079,0.0445-0.54491,0.19166-0.24419,0.33108,0.23224,0.10457,0.23273,0.40136,0.34076,0.60359,0.12548,0.34994,0.23599,0.70533,0.38133,1.0475,0.17369,0.56836,0.38561,1.1243,0.59709,1.6795,0.0372,0.13963-0.1368,0.49927,0.16035,0.35497,0.30012-0.1211,0.60858-0.22043,0.90909-0.3409,0.42579-0.13308,0.80583-0.41989,1.0159-0.81775,0.11134-0.17347,0.12288-0.38557,0.17834-0.58023,0.0375-0.16504,0.0507-0.33686-0.002-0.49969-0.0371-0.2429-0.0546-0.49515-0.17332-0.71565-0.12335-0.30842-0.25369-0.63006-0.50609-0.85692-0.21456-0.23624-0.46442-0.45156-0.77166-0.554-0.1317-0.0596-0.27515-0.1044-0.42139-0.0933zm-0.249,0.36582c0.35609-0.0199,0.61095,0.28971,0.77607,0.56693,0.14503,0.28477,0.26142,0.58404,0.39319,0.87432,0.14756,0.46176,0.31436,0.94036,0.24363,1.4326-0.0534,0.25994-0.30899,0.42687-0.51898,0.56472-0.23183,0.12834-0.45305-0.092-0.45614-0.32242-0.0832-0.23287-0.18706-0.45902-0.25975-0.69492-0.173-0.4035-0.27687-0.83317-0.45918-1.2334-0.10313-0.27361-0.19999-0.55245-0.2574-0.83943-0.0666-0.27271,0.28237-0.33685,0.4804-0.35513,0.0195,0.00036,0.0397,0.004,0.0582,0.007z'/%3E %3Cpath d='m472.57,257.89c0.0848,0.12899,0.29142,0.1532,0.28416,0.34418,0.0825,0.24126,0.17057,0.48149,0.22617,0.73016,0.0623,0.19464,0.0972,0.39586,0.17675,0.58508,0.0709,0.25623,0.14838,0.5107,0.21793,0.76734,0.0855,0.24503,0.18013,0.48788,0.22908,0.74353,0.0327,0.19386,0.18032,0.41648,0.0564,0.60112-0.0807,0.0876-0.0492,0.21888,0.0868,0.14803,0.20243-0.0149,0.37574-0.14114,0.57766-0.15028,0.11508-0.0395,0.39075-0.039,0.37866-0.17626-0.12439-0.10615-0.29226-0.17811-0.28574-0.37109-0.0871-0.29115-0.18302-0.58087-0.26264-0.87333-0.063-0.20886-0.11848-0.41948-0.19161-0.62353-0.0483-0.16106-0.0698-0.33087-0.13015-0.48955-0.1051-0.33886-0.20911-0.67822-0.30609-1.0195-0.0555-0.14081-0.0978-0.28062,0.0289-0.40393,0.0447-0.20721-0.27006-0.0231-0.38197-0.0239-0.24041,0.0491-0.46748,0.14942-0.70439,0.21193z'/%3E %3Cpath d='m475.98,256.94c-0.31031-0.0136-0.59022,0.16956-0.81073,0.36925-0.2321,0.27596-0.40037,0.6211-0.38953,0.98868-0.0176,0.32472-0.045,0.65686,0.0476,0.9735,0.10195,0.50049,0.34871,0.9612,0.65555,1.3648,0.21352,0.21039,0.47681,0.37132,0.755,0.47939,0.23744,0.0541,0.49325,0.0748,0.73021,0.0115,0.39264-0.12781,0.7002-0.46071,0.81555-0.85491,0.0961-0.27103,0.17353-0.55297,0.15867-0.84347,0.007-0.27377-0.0956-0.53424-0.14212-0.80085-0.076-0.29177-0.20963-0.56539-0.36836-0.81979-0.16929-0.22736-0.38761-0.4135-0.58953-0.60953-0.23721-0.17562-0.52893-0.26613-0.82373-0.25619l-0.0385-0.002-0.00003,0.00002zm-0.018,0.2645c0.33727,0.0506,0.56781,0.34978,0.68181,0.65063,0.22513,0.43869,0.31784,0.92694,0.46051,1.395,0.0619,0.19699,0.0453,0.40493,0.0977,0.60299,0.0397,0.27564,0.0367,0.57392-0.0807,0.83032-0.14447,0.23014-0.4977,0.30319-0.7061,0.11677-0.21525-0.14269-0.3036-0.3965-0.42789-0.61046-0.08-0.29308-0.21948-0.5661-0.27746-0.86552-0.0547-0.23872-0.15894-0.46415-0.17827-0.71009-0.0573-0.37977-0.15647-0.7852-0.0144-1.1579,0.065-0.18501,0.26363-0.25336,0.44472-0.25169l0.00001,0.00002z'/%3E %3Cpath d='m478.71,256.61c-0.14026,0.18736-0.25596,0.3891-0.28496,0.6236-0.0475,0.24011,0.034,0.47967,0.0812,0.71237,0.0795,0.22189,0.22933,0.42034,0.44245,0.52823,0.30955,0.22575,0.66616,0.37276,1.0077,0.54052,0.22844,0.0901,0.47602,0.23126,0.54767,0.48356,0.0549,0.17061,0.0787,0.36658,0.0171,0.537-0.0849,0.18978-0.26859,0.35884-0.48975,0.30008-0.20887-0.007-0.4144-0.0896-0.55417-0.24752-0.20564-0.17925-0.35997-0.41629-0.43013-0.6801-0.0894-0.17451-0.26265-0.001-0.20826,0.13601-0.0403,0.19451-0.077,0.40983-0.0336,0.60234,0.12951,0.1389,0.32091,0.202,0.47641,0.30981,0.20297,0.0933,0.42298,0.17271,0.64838,0.17368,0.21278-0.0317,0.44307-0.0177,0.63152-0.13737,0.20921-0.1042,0.3963-0.24135,0.48887-0.46452,0.12697-0.26104,0.18876-0.5696,0.098-0.85237-0.0696-0.44255-0.39007-0.83011-0.80328-0.9982-0.22401-0.12857-0.46145-0.23171-0.70277-0.32129-0.26604-0.12635-0.58046-0.28501-0.64641-0.60154-0.06-0.21647-0.002-0.50359,0.23078-0.58862,0.21742-0.0961,0.4669-0.0103,0.63301,0.14464,0.14505,0.12531,0.23818,0.29747,0.31637,0.46962-0.0432,0.22873,0.31983,0.13947,0.2011-0.0463-0.0621-0.18705,0.19836-0.46671-0.0504-0.58272-0.20038-0.11852-0.40999-0.23234-0.64567-0.25691-0.25074-0.0508-0.51799-0.024-0.74278,0.10288-0.0763,0.0372-0.15085,0.0791-0.22832,0.11315z'/%3E %3Cpath d='m491.74,251.51c-0.3478-0.00093-0.68704,0.0848-1.0282,0.14083-0.14028,0.10574-0.4801-0.0236-0.50312,0.18177,0.13779,0.13295,0.22004,0.30532,0.23586,0.4961,0.0454,0.32094-0.0349,0.65136,0.0551,0.96737,0.0162,0.22755-0.039,0.46646,0.0525,0.68385,0.0293,0.34111-0.0462,0.69378,0.0649,1.0255,0.0297,0.21259,0.0963,0.47631-0.0829,0.64364-0.19153,0.15735,0.12347,0.23923,0.24379,0.15568,0.24404-0.0265,0.49017-0.0485,0.73161-0.0833,0.18329-0.0491,0.0673-0.19817-0.0328-0.25581-0.14222-0.23806-0.10103-0.5278-0.12201-0.79255-0.003-0.20381,0.00083-0.40769-0.005-0.61147,0.23867-0.11738,0.51728-0.0888,0.76206-0.18815,0.4637-0.10671,0.91961-0.44134,1.0061-0.93335,0.0957-0.43742-0.10456-0.90486-0.44334-1.1839-0.27548-0.17891-0.60945-0.25528-0.93503-0.2462zm-0.0783,0.35887c0.2936-0.0405,0.49553,0.23976,0.58489,0.48327,0.0705,0.21267,0.0638,0.44213,0.0562,0.66343-0.0148,0.34163-0.31801,0.60392-0.64214,0.6537-0.15782,0.0193-0.44004,0.0707-0.37741-0.17272-0.0292-0.2624-0.0719-0.52518-0.0493-0.78981-0.0133-0.25143-0.14393-0.52299-0.005-0.76106,0.10546-0.13266,0.29352-0.0389,0.43243-0.0768z'/%3E %3Cpath d='m494.76,251.32c-0.22479-0.0584-0.42491,0.15777-0.39409,0.37529-0.0625,0.26833-0.0836,0.54616-0.16738,0.80919-0.0467,0.39277-0.12889,0.77948-0.21568,1.1648-0.10208,0.47818-0.17213,0.96654-0.33778,1.4283-0.007,0.13644-0.30607,0.30579-0.14001,0.39452,0.24016-0.0252,0.48263-0.0119,0.72384-0.0219,0.21563-0.0847-0.10266-0.2425-0.14106-0.35878-0.033-0.18376,0.0159-0.37462,0.0468-0.55715,0.0175-0.10082,0.0243-0.21984,0.15368-0.18292,0.30086-0.003,0.60172-0.005,0.90258-0.008,0.0205,0.24915,0.16593,0.48067,0.1423,0.73327-0.0613,0.11169-0.15032,0.36776,0.0761,0.31033,0.2828-0.005,0.55933-0.0928,0.84331-0.0735,0.23705-0.0679-0.0813-0.22749-0.10896-0.35496-0.11755-0.26252-0.18891-0.54383-0.26501-0.8206-0.0786-0.34158-0.18754-0.67457-0.2726-1.0144-0.0793-0.18568-0.10984-0.38415-0.16966-0.57662-0.1271-0.38122-0.21459-0.77506-0.29852-1.1679-0.0141-0.12834-0.2744-0.0607-0.37789-0.0789zm-0.18275,0.93745c0.17518,0.4996,0.26315,1.0256,0.44523,1.5228,0.1032,0.18078-0.0818,0.28132-0.23981,0.2338-0.17609-0.0275-0.56811,0.16588-0.57101-0.11921,0.0759-0.19535,0.10104-0.39987,0.13574-0.60537,0.0576-0.25421,0.10276-0.51096,0.13649-0.76908,0.0216-0.0907,0.0567-0.17745,0.0934-0.26295z'/%3E %3Cpath d='m497.98,251.19c-0.48387,0.006-0.96773,0.0111-1.4516,0.0167,0.006,0.16459-0.0152,0.33003-0.0749,0.45048-0.0202,0.15796-0.0404,0.31591-0.0606,0.47387,0.16044,0.0269,0.21691-0.16403,0.31375-0.25287,0.14732-0.15424,0.30527-0.34582,0.54042-0.33651,0.12168,0.006,0.31475-0.07,0.26455,0.12215,0.006,0.20027,0.0726,0.39199,0.0539,0.59435,0.01,0.89236,0.0304,1.7851,0.0136,2.6774-0.005,0.12484-0.14045,0.16928-0.18649,0.2757,0.0444,0.0589,0.28765,0.0115,0.4079,0.0284,0.23093-0.00032,0.46224,0.006,0.69292-0.005,0.1084,0.0228,0.0973-0.15997-0.0299-0.16557-0.0863-0.2045-0.0679-0.43593-0.084-0.65399-0.01-0.95692-0.041-1.9146-0.003-2.8712,0.11683-0.0701,0.26775-0.14433,0.39423-0.0548,0.10903,0.0651,0.22528,0.12033,0.3298,0.1916,0.0725,0.10568,0.14503,0.21136,0.21755,0.31704-0.0336,0.0254,0.23178,0.13703,0.16454-0.027,0.0105-0.18221-0.0791-0.34741-0.0842-0.52988-0.0336-0.14164,0.0208-0.3551-0.19495-0.29546-0.40911-0.0276-0.81505,0.0402-1.2232,0.0451z'/%3E %3Cpath d='m501.29,251.08c-0.31221-0.0177-0.61738,0.0798-0.92924,0.0567-0.10177-0.005-0.2992,0.0349-0.13592,0.13174,0.18345,0.13054,0.12619,0.35899,0.12954,0.54967-0.0216,0.9673,0.0277,1.9355-0.0222,2.9023-0.0324,0.16225-0.0611,0.33981-0.21936,0.42845,0.0322,0.12604,0.29314,0.0248,0.41185,0.0625,0.25367,0.006,0.50735,0.0109,0.76103,0.0165-0.006-0.14916-0.21974-0.21607-0.16031-0.3812,0.002-0.44788,0.004-0.89575,0.006-1.3436,0.21834-0.0665,0.37382,0.075,0.38752,0.29542,0.0296,0.20258,0.13444,0.37931,0.21626,0.56368,0.10463,0.2001,0.231,0.39029,0.37399,0.56402,0.17113,0.14045,0.31403,0.31765,0.50419,0.43308,0.14128,0.0504,0.29157,0.0741,0.43692,0.11286,0.006-0.18228-0.17693-0.28373-0.25555-0.43044-0.16291-0.27003-0.24648-0.57852-0.38199-0.86212-0.094-0.1868-0.14149-0.38681-0.18082-0.59015-0.11903-0.19131,0.12005-0.16614,0.23292-0.25179,0.208-0.11748,0.38585-0.28764,0.49-0.50457,0.12756-0.21369,0.11305-0.47059,0.10001-0.70927-0.0144-0.21683-0.15274-0.39229-0.27238-0.56304-0.1335-0.15207-0.33436-0.23811-0.51273-0.33152-0.22744-0.0655-0.45986-0.1245-0.6956-0.14679-0.0944-0.004-0.19081,0.001-0.28401-0.002zm0.28502,0.31756c0.21248-0.0149,0.40297,0.099,0.53655,0.25599,0.10274,0.13303,0.13953,0.31239,0.15704,0.48011-0.002,0.17896,0.0149,0.36378-0.0322,0.53776-0.0828,0.22906-0.26292,0.45121-0.52025,0.47854-0.18555,0.0232-0.38474,0.064-0.56672,0.0246-0.045-0.1312-0.006-0.28563-0.0191-0.42603-0.0006-0.36266-0.004-0.7255,0.0111-1.0879,0.0226-0.25365,0.2321-0.25424,0.43359-0.26302z'/%3E %3Cpath d='m504.16,251.77c-0.006,0.18073-0.0581,0.35769-0.0422,0.53959-0.008,0.31679-0.0121,0.6339-0.0519,0.94864-0.0409,0.5335-0.012,1.0694-0.0264,1.6033-0.0336,0.15641-0.0743,0.3194-0.18442,0.442-0.0639,0.0657-0.10392,0.13068,0.0204,0.1059,0.16093-0.0182,0.30789,0.0361,0.46155,0.0615,0.19171,0.001,0.38277,0.0106,0.57405,0.0134,0.1864-0.0555-0.10403-0.14391-0.079-0.26124-0.0954-0.21955-0.0433-0.46119,0.003-0.68526,0.0279-0.50474-0.02-1.0153,0.0672-1.5161,0.0261-0.30771-0.0338-0.61886,0.0232-0.92457,0.0918-0.17842-0.0332-0.42621,0.15643-0.56187,0.0413-0.0763,0.11364-0.16826-0.024-0.13988-0.23283-0.002-0.4693,0.0106-0.69684-0.0474-0.11034,0.006-0.37629-0.0862-0.38167,0.0576,0.0606,0.11987,0.21099,0.21865,0.17995,0.36401l0.00008,0.00033z'/%3E %3Cpath d='m507.09,251.63c-0.0758,0.33344-0.22414,0.64538-0.30457,0.97794-0.0598,0.20291-0.13633,0.3996-0.19054,0.60433-0.12063,0.32007-0.20561,0.65281-0.32169,0.9745-0.12687,0.40615-0.23122,0.83871-0.51167,1.1722-0.15843,0.0553-0.12999,0.3218,0.0632,0.22198,0.18991,0.0121,0.37364,0.0746,0.56587,0.0606,0.15495,0.0518,0.19704-0.10671,0.0523-0.17012-0.18363-0.1433-0.19973-0.39822-0.0854-0.58726-0.004-0.23028,0.18621-0.34512,0.39511-0.28015,0.23527,0.02,0.46884,0.0691,0.70593,0.0608,0.008,0.22421,0.10407,0.43603,0.10833,0.66077,0.0386,0.16015-0.27959,0.46127,0.008,0.44746,0.2462,0.027,0.4877,0.083,0.73677,0.0749,0.11186,0.008,0.27374-0.005,0.15115-0.13864-0.16429-0.32351-0.18027-0.69344-0.25637-1.0417-0.0121-0.3741-0.12346-0.73508-0.15413-1.1064-0.0668-0.37724-0.17054-0.74943-0.18415-1.1345-0.008-0.18768-0.0491-0.37137-0.10379-0.54938,0.0215-0.15442-0.0938-0.23252-0.23464-0.18561-0.14744-0.0142-0.28963-0.0794-0.43969-0.0616zm0.0457,0.88526c0.1121,0.23506,0.0719,0.49993,0.12988,0.74702,0.0447,0.29362,0.0568,0.59343,0.14442,0.87898,0.0839,0.3282-0.32837,0.1711-0.50202,0.1537-0.15588,0.0115-0.45505,0.001-0.30492-0.23229,0.0662-0.16995,0.10387-0.34934,0.16524-0.52238,0.0504-0.16535,0.0974-0.33173,0.14097-0.499,0.138-0.14223,0.0994-0.37209,0.20857-0.52432l0.0179-0.002-0.00004,0.00004z'/%3E %3Cpath d='m514.58,256.63c0.002,0.18376,0.26101,0.25595,0.21034,0.46433-0.0188,0.44331,0.002,0.88671,0.037,1.3286,0.0108,0.67629,0.0475,1.354,0.003,2.0298,0.001,0.10809-0.0394,0.2051-0.11977,0.27615-0.14078,0.0965,0.082,0.13708,0.16711,0.11815,0.67976-0.0238,1.3595-0.0493,2.0392-0.0737,0.0558-0.30316,0.1317-0.60596,0.14173-0.91503-0.002-0.15076-0.13336-0.0798-0.15954,0.0299-0.18234,0.25952-0.43273,0.52716-0.77191,0.5403-0.1659-0.003-0.38716,0.0604-0.51395-0.0749-0.0608-0.16255-0.0439-0.34549-0.0617-0.51698-0.0364-0.91135-0.0504-1.8245-0.0191-2.7362-0.0157-0.19361,0.088-0.35825,0.15836-0.52963-0.37015,0.0198-0.74029,0.0395-1.1104,0.0593z'/%3E %3Cpath d='m517.35,260.74,1.0972-0.005c-0.009-0.21902-0.14658-0.0913-0.16879-0.40611-0.0178-0.27835,0.0178-3.1941,0.0444-3.3903,0.0533-0.36048,0.16435-0.2099,0.16435-0.37873l-1.0794-0.0274c0.004,0.28292,0.13771,0.0274,0.14659,0.44261,0.004,0.18252-0.004,0.37417-0.004,0.55668,0,0.46998,0.009,2.4824-0.0178,2.7972-0.0222,0.27378-0.17324,0.1962-0.18212,0.41066z'/%3E %3Cpath d='m519.06,256.53c0.0422,0.16175,0.2119,0.27215,0.16,0.47,0.009,0.45514-0.087,0.90323-0.0894,1.358-0.0102,0.53396-0.0482,1.0668-0.0872,1.5993-0.0271,0.19059-0.0142,0.39753-0.10342,0.57268-0.0812,0.0348-0.26156,0.15417-0.0751,0.19,0.44818,0.0885,0.91199,0.0563,1.3571,0.16661,0.32794,0.0816,0.67016-0.0248,0.95709-0.18328,0.39483-0.26715,0.49515-0.81233,0.38185-1.2508-0.0406-0.21178-0.20653-0.35436-0.36037-0.48846-0.12775-0.11746-0.25887-0.2311-0.39058-0.34407,0.36811-0.0377,0.6936-0.31938,0.76867-0.6839,0.0698-0.29119,0.0237-0.63232-0.20007-0.84719-0.0683-0.0781-0.12781-0.16696-0.22882-0.20492-0.16653-0.096-0.33483-0.1963-0.5298-0.22036-0.51429-0.0944-1.0395-0.10031-1.56-0.13363zm0.97,0.38c0.21207,0.0153,0.46561-0.0174,0.61282,0.17302,0.26052,0.27862,0.24652,0.71447,0.0837,1.0385-0.0224,0.1433-0.1899,0.23562-0.32125,0.27856-0.172,0.0431-0.3508,0.0204-0.52531,0.01-0.0435-0.34552,0.0439-0.69148,0.0353-1.0381,0.005-0.15915,0.0174-0.32881,0.11468-0.4619zm-0.22,1.81c0.30831,0.0156,0.65531,0.0656,0.85874,0.3252,0.19192,0.24568,0.13069,0.57525,0.14413,0.86437-0.0329,0.36404-0.39111,0.70162-0.7673,0.63622-0.20059-0.0102-0.32124-0.14295-0.28338-0.34162-0.019-0.49473-0.002-0.99165,0.0478-1.4842z'/%3E %3Cpath d='m521.8,261.04c0.0869,0.14706,0.2918,0.10342,0.43219,0.16233,0.33917,0.0742,0.67826,0.14914,1.0132,0.23935,0.29025,0.0561,0.57914,0.11902,0.86888,0.17781,0.0534-0.227,0.23054-0.40838,0.25677-0.64393,0.12342-0.16565-0.13651-0.27334-0.21272-0.10118-0.28076,0.22388-0.67386,0.29962-1.0142,0.17917-0.23847-0.0101-0.40633-0.21279-0.32204-0.44416,0.0261-0.47848,0.0768-0.96175,0.20822-1.4228,0.14445-0.0525,0.33405,0.0281,0.47939,0.0866,0.20417,0.0857,0.30758,0.288,0.40042,0.47477,0.13886,0.10756,0.13087-0.22448,0.15295-0.31535,0.018-0.2823,0.0586-0.56213,0.0914-0.84292-0.22728,0.0334-0.31872,0.39779-0.59401,0.25996-0.17922-0.0709-0.58193,0.0359-0.48181-0.26256,0.0289-0.33297,0.12782-0.65376,0.20074-0.9785,0.3566-0.11266,0.75183,0.0584,0.96874,0.35018,0.12759,0.11323,0.2155,0.39395,0.3393,0.42387,0.069-0.2798,0.0208-0.57002,0.0246-0.8535-0.10774-0.17398-0.36573-0.12564-0.53748-0.20632-0.52034-0.12362-1.0363-0.27532-1.5662-0.35168-0.29648-0.0562,0.10087,0.21548,0.0317,0.36193-0.0941,0.63249-0.18683,1.2667-0.28286,1.8994-0.072,0.48894-0.11252,0.98367-0.21355,1.4676-0.0396,0.1361-0.11769,0.26784-0.24361,0.33994z'/%3E %3Cpath d='m525.31,257.72c0.12089,0.22899,0.13676,0.49712,0.0652,0.74361-0.12824,0.62002-0.29824,1.2315-0.38703,1.8594-0.0716,0.37449-0.14344,0.75018-0.21191,1.1244-0.0359,0.16775-0.44094,0.29198-0.13664,0.39782,0.25983,0.10756,0.53601,0.1684,0.80107,0.26097,0.26503,0.0101-0.0616-0.27448,0.0223-0.41948,0.0391-0.28329,0.13421-0.55607,0.16044-0.84223,0.0466-0.14705-0.00022-0.43777,0.21711-0.43857,0.2369,0.0167,0.11275,0.32651,0.17383,0.47868,0.0836,0.44981,0.21118,0.89538,0.40054,1.3122,0.13991,0.27109,0.39487,0.45438,0.64372,0.61593,0.0596-0.17088-0.14796-0.44034-0.17398-0.64738-0.0856-0.28679-0.0895-0.58571-0.10132-0.88243-0.0111-0.23111-0.0222-0.46221-0.0333-0.69332,0.23825-0.0761,0.49096-0.13168,0.68036-0.30577,0.27321-0.29777,0.37199-0.74061,0.26548-1.13-0.1011-0.41284-0.39488-0.75891-0.76407-0.96136-0.42943-0.25167-0.94291-0.26567-1.4046-0.42865-0.0712-0.0194-0.1443-0.0364-0.21722-0.0438zm0.94,0.56c0.28477-0.012,0.57665,0.1716,0.69124,0.43283,0.14839,0.40969,0.0972,0.89329-0.14706,1.2556-0.14825,0.20181-0.41567,0.21863-0.63948,0.16284-0.19209-0.009-0.44206-0.0735-0.32303-0.31729,0.0648-0.40898,0.17254-0.81026,0.23478-1.2195,0.0347-0.11776,0.10241-0.22336,0.18355-0.31449z'/%3E %3Cpath d='m528.03,259.63c0.19338,0.0193,0.31272-0.20066,0.4986-0.2379,0.16985-0.0709,0.39513-0.16099,0.54824-0.006,0.11202,0.13585,0.0352,0.33022-0.008,0.47904-0.0752,0.25549-0.12591,0.51934-0.19163,0.77807-0.1512,0.63169-0.30015,1.2645-0.45254,1.8955-0.0657,0.17288-0.0652,0.39653-0.28515,0.44465-0.0959,0.19642,0.26555,0.18872,0.38415,0.28122,0.21543,0.0936,0.43399,0.18154,0.66082,0.24373-0.0112-0.17198-0.15821-0.31786-0.0843-0.50608,0.087-0.49149,0.23309-0.97042,0.33894-1.4581,0.13916-0.59081,0.28324-1.1807,0.45181-1.7639,0.24685-0.0768,0.45085,0.14476,0.54825,0.34622,0.0927,0.18777,0.14071,0.39436,0.238,0.58007,0.15512-0.10144,0.0946-0.31832,0.11872-0.47543,0.0152-0.15485,0.0304-0.30969,0.0457-0.46453-0.31304-0.1647-0.66153-0.24833-0.97839-0.40212-0.23421-0.10598-0.4801-0.18831-0.71932-0.28456-0.2544-0.0981-0.50881-0.19622-0.76321-0.29433-0.14869,0.21099-0.19903,0.47202-0.34035,0.68786-0.0203,0.0495-0.016,0.10463-0.0107,0.15623z'/%3E %3Cpath d='m531.94,260.41c-0.16271,0.10621-0.22053,0.31112-0.32,0.47-0.11254,0.1949-0.26592,0.36296-0.37261,0.56205-0.33714,0.54561-0.66725,1.0957-1.0091,1.6384-0.14114,0.19219-0.30407,0.39241-0.52894,0.48695-0.15152,0.20048,0.20873,0.22646,0.31999,0.30686,0.10953,0.0742,0.32476,0.25919,0.40927,0.17838-0.036-0.19844-0.17904-0.39357-0.0675-0.59673,0.0893-0.15477,0.13329-0.51433,0.37585-0.35124,0.23331,0.14442,0.5003,0.24453,0.6992,0.43859,0.0649,0.17778-0.0714,0.37222-0.0378,0.56373,0.0705,0.2028-0.2648,0.33466-0.17639,0.48402,0.17528,0.13355,0.39001,0.20535,0.57612,0.32362,0.12943,0.0543,0.38207,0.25307,0.30999-0.0141-0.0105-0.27111-0.0661-0.54926-0.007-0.81697,0.10295-0.19812,0.0525-0.43767,0.0774-0.65383-0.002-0.29751,0.0705-0.58655,0.0902-0.88209,0.0501-0.48468,0.0911-0.97059,0.14753-1.4544,0.014-0.16128,0.14039-0.4454-0.0833-0.48327-0.14115-0.0465-0.24474-0.23664-0.40315-0.19986zm-0.28,0.87c0.0278,0.0668,0.0788,0.13005,0.0507,0.20561-0.0574,0.51053-0.13959,1.0185-0.17803,1.5309,0.006,0.2528-0.29329-0.0253-0.40847-0.0715-0.15363-0.0928-0.43584-0.15647-0.24917-0.37249,0.15257-0.26407,0.36848-0.48587,0.4999-0.76291,0.10207-0.17193,0.22776-0.33524,0.2851-0.52959z'/%3E %3Cpath d='m534.22,261.81c-0.0439,0.25209-0.008,0.5259-0.19284,0.73355-0.12665,0.23906-0.25368,0.47766-0.41498,0.69489-0.1486,0.26788-0.28184,0.54404-0.44896,0.80148-0.20769,0.35204-0.41742,0.70293-0.63322,1.0501-0.12473,0.0301-0.36159,0.0562-0.16831,0.21579,0.15231,0.19713,0.36399,0.3342,0.5239,0.52666,0.23791,0.21698,0.47801,0.43387,0.70592,0.6603,0.35949,0.25709,0.89441,0.3795,1.2746,0.0972,0.18196-0.17673,0.38141-0.34007,0.53918-0.5386,0.15646-0.2349,0.27043-0.49769,0.37333-0.7587,0.10407-0.34603,0.16398-0.70825,0.12088-1.0696-0.0385-0.57425-0.32726-1.107-0.7179-1.5189-0.22762-0.22684-0.47591-0.43428-0.70708-0.65535-0.096-0.0657-0.16948-0.15966-0.25448-0.23877zm0.69,1.03c0.30867,0.21593,0.50751,0.58387,0.47959,0.96465-0.0316,0.60253-0.31197,1.1613-0.6529,1.6479-0.18454,0.29997-0.39973,0.64377-0.76978,0.72365-0.28023,0.0719-0.56473-0.11609-0.69466-0.35574-0.11909-0.26651,0.0825-0.53363,0.18764-0.77031,0.30217-0.52421,0.63752-1.03,0.91057-1.5706,0.10528-0.21598,0.22963-0.43768,0.41912-0.59093,0.0368-0.0186,0.0763-0.0578,0.12042-0.0486z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23006300' d='m485.28,351.54c0.74989,0.25691,2.2844,0.97101,2.9039,1.2601,0,0,2.1485,4.007,2.1193,3.9502,0.81509,0.57807,0.68468,0.44962,1.5976,0.67442l-5.0536,2.0874c-1.4671,0.54596-0.8803,1.8306-0.19562,2.0875,0.74988,0.2248,2.3149-0.41751,2.8692-0.67442,2.5104-1.1561,4.7927-2.3444,7.0424-3.7896,0.35864-0.22481,2.0215-1.3809,2.3474-1.3168l8.9334,5.0741c0.65207,0.28904,1.9562,1.124,2.6735,0.6102,0.29343-0.1927,0.74989-0.64231,0.58687-1.1561-0.13041-0.54595-0.48905-0.64229-0.91291-0.80288-0.68468-0.28903-4.7275-2.1196-4.858-2.1196l1.076-0.28903c0.32604-0.22481-0.23638-0.89111,0.18747-0.76266l2.2252-3.6371,2.7713-0.99559c-0.0196-2.553-20.861-4.1412-26.313-0.20026z'/%3E %3Cpath fill='%23ff0' d='m486.73,360.12c-0.74988,0.2248-0.55426,1.67,0.9455,1.1883,1.0107-0.35327,0.22823-1.5737-0.9455-1.1883z'/%3E %3Cpath fill='%23ff0' d='m508.9,360.18c-0.22823,0.54595-0.19562,0.80287,0.32604,1.0277,0.55425,0.25692,0.8803,0.25692,1.2389-0.12847,0.48906-0.48171,0.0978-0.67441-0.32604-0.89921-0.45644-0.25693-0.0978-0.22481-0.45644-0.12847-0.26083,0.0964-0.45645,0.0642-0.78249,0.12847z'/%3E %3Cpath fill='%23006300' stroke='%23808000' stroke-width='0.2548' d='m530.27,277.34c-0.0659,0.10115-0.12699,0.0671,0.0706,0.40428,1.8767,3.7761,1.212,1.9907,2.7595,6.9133-0.29632-0.30345-0.69143-0.8406-0.98777-1.2452-0.82311-1.1126-1.5742-2.3278-2.2656-3.5417-0.16461-0.33717-0.26812-0.4351-0.56444-0.67113-0.1317,0.37088,0.52526,2.3552,0.68988,2.8948,0.69143,2.4276,2.5385,5.1986,3.8884,7.3902-0.39508-0.2023-0.62716-0.51321-0.95642-0.81664-1.1853-0.97776-0.85293-0.73488-1.5444-1.9486-0.65852-1.1464-1.1853-2.3668-1.6463-3.6144-0.32924-0.87662-0.65697-1.7122-1.0191-2.5551-0.1317,0.16858-0.0345-0.13639-0.13329,0.23449-0.0988,0.33717,0.0298,0.73824,0.0627,1.0754,0.16462,1.4161,0.39667,2.8371,0.62716,4.2532-0.95484-0.40459-1.8768-1.0467-2.7986-1.5524-0.19756-0.10115-0.45941-0.27217-0.68988-0.3396l-0.26654,0.0323c-0.19753,0.50574,1.6149,2.1236,1.9442,2.3934,0.42802,0.33717,2.2719,1.6222,2.4694,2.0942,0.72435,1.6858,1.3814,3.0014,2.5008,4.35l0.98778,1.2776-2.1716-2.1912c-1.5804-1.4498-2.2045-2.0527-3.9825-3.4687,0.0329,0.50574,0.65852,0.94174,0.98778,1.2452l2.7282,3.0646c0.85605,1.1126,1.8768,2.0623,2.6341,3.2423l1.7169,2.8948c-0.19756-0.33717-0.69302-0.97272-0.95642-1.3099l-2.63-3.27c-0.9219-1.1126-1.9427-1.886-3.128-2.8301-0.98775-0.80919-1.6463-1.3135-2.7986-1.8193-0.0658,0.30345,0.32612,0.5335,0.55659,0.73581,1.317,1.0789,2.4726,2.2968,3.7238,3.477,0.49388,0.47202,0.958,0.94022,1.4189,1.4797,0.46097,0.50574,0.88899,0.94832,1.317,1.4878,0.7902,1.0789,1.5742,2.321,2.2656,3.501l1.0583,1.8597c-0.82313-0.30346-4.6442-4.6512-5.5662-5.5953-0.75728-0.77547-1.0834-1.2179-2.0383-1.6899,0.0658,0.47202,2.6607,3.4426,3.2535,4.0832,0.26341,0.26971,0.36689,0.4351,0.56445,0.67112l1.1524,1.318c0.75729,0.91033,2.1386,2.522,2.6654,3.5334l0.7918,1.6252c-0.0329-0.16858-1.5491-2.1574-1.7796-2.3934-0.32924-0.43831-0.59267-0.77592-0.98778-1.1805-0.85605-0.94405-2.2719-2.5343-3.2926-3.2423l-2.6341-1.512c-0.13168,0.26974,0.43121,0.66822,0.76044,0.93794l0.98778,0.94601c1.1853,0.94405,2.7941,2.7644,3.7158,3.9782,0.62555,0.74176,1.0881,1.4548,1.6149,2.264-0.32923-0.2023-0.59269-0.50651-0.82316-0.77623-0.36217-0.37088-0.52526-0.47277-0.85449-0.77622-0.49388-0.50574-1.1524-0.97533-1.8109-1.4474l-4.2491-2.0942c0.0658,0.33717,1.4785,1.2113,1.8736,1.4474,0.82314,0.53945,2.2076,1.4158,2.9321,2.1912,0.32923,0.33716,0.49545,0.57927,0.79178,0.84898,0.62558,0.57317,1.0897,1.1759,1.5836,1.884,0.49387,0.70802,0.91881,1.2473,1.3798,1.9891,0.49388,0.77547,0.78869,1.4534,1.1838,2.2963l1.4503,5.3609c-0.46097-1.7532-1.35-3.6816-1.9756-5.4012-0.49388-1.3149-1.582-4.5109-3.2612-3.9378-0.62558,0.23601-0.92034,0.9079-1.1838,1.4474-0.39509,0.74176-0.92509-0.27158-2.2421,2.4257-0.72435,1.5172-1.2151,3.2708-1.5444,4.9565-0.0658,0.30346-0.0658,0.50512,0,0.80857,0.32926-0.13486,0.55818-1.0427,0.68988-1.4474,0.65852-1.6521,1.3202-2.6293,2.2421-4.1802l-1.2543,5.7004c0.42802-0.0674,0.56444-0.81636,0.72909-1.221,0.55972-1.4161,1.0489-2.8288,1.5757-4.2449,1.8768,1.3149,2.4726,8.3952,2.7359,10.924-0.19755-0.87662-0.92193-2.7634-1.317-3.6064l-1.9128-3.1696c-1.1194,0.13487-1.2496,1.5491-1.513,2.4257-0.32923-0.43831-0.66165-1.1752-1.4189-1.1077-0.69141,0.0337-0.95171,0.84167-1.0505,1.6171-0.0988,0.80919-0.10035,1.6812,0.0314,2.4904,0.0329,0.16858,0.23047,1.8218,0.32926,1.9567l0.23518,0.23448,0.39198-4.8514c0.72437,0.33717,2.1104,3.4731,1.9128,4.7544-0.72437,4.6866-1.1587,6.1651-3.6611,10.042-0.42803,0.67431-0.88588,1.3822-1.3798,1.9891-0.23047,0.33716-0.45785,0.64258-0.72123,0.94601l-0.82314,0.91367c1.2841-2.2253,1.8376-3.1057,2.7595-5.668,0.65849-1.9218,1.2198-3.943,1.4503-5.9997,0.0329-0.33717,0.0345-0.64121-0.0314-0.97836-0.26339,0.10115-0.3324,0.47278-0.43116,0.77623-2.1731,6.7434-2.4648,6.9762-6.0208,12.977l0.65852-3.8408c-0.32926,0.0337-0.26812,0.20321-0.39983,0.5741-0.0988,0.26974-0.19128,0.47417-0.29005,0.74388-0.49387,1.4835-0.98938,2.93-1.7796,4.2449,0.0658-0.40459,0.29163-0.9457,0.42334-1.3503,0.36217-1.2475,0.59424-2.5918,0.7918-3.8731l0.0314-0.88133c-0.39509-0.0337-0.42336,0.74084-0.58798,1.2129-0.42802,1.3824-1.0521,2.5998-1.6776,3.8811v-0.37195c0.1317-0.8429,0.36061-2.1246,0.196-2.9675,0,0,0.12856,0.20657-0.10193-0.29916-0.32924,0.10115-0.39667,0.73961-0.46252,1.043-0.0988,0.4046-0.22891,0.80963-0.36062,1.1805-0.82313,2.2927-1.8408,3.7717-3.0259,5.8621-0.69555-0.0203-0.14932,0.0487,0.15679,0.0728-0.0986-0.0249-0.16996-0.042-0.16465-0.0485,0.48297,0.0668,0.36571,0.0643,0.16465,0.0485,0.98266,0.24786,6.593,1.3099,6.593,1.3099,3.2595-0.13488,5.4282-0.40186,8.6548-0.0647,0.49388,0.0337,2.5024,0.40584,2.7986,0.1698-0.95482-0.53945-1.8706-0.77866-2.9241-1.1158l-3.0967-0.77622,8.788-0.23449-0.79178-0.43663c-1.4487-0.57316-5.367-0.81253-6.9143-0.91367,2.8975-0.26974,5.0439-0.49994,7.9414-0.53365,0.75633-0.21626,3.3342,0.61671,2.2029-0.54176-1.0207-0.70802-4.3462-0.80994-5.4327-0.77623l5.2054-0.23448c0.82745-0.21367,6.1768,1.0337,4.2802-0.20214-1.4816-0.74174-4.7461-1.4216-6.3265-1.6576,0.9219-0.53948,1.7482-1.0751,2.7359-1.4797,1.9755-0.8429,4.1488-1.4482,6.2561-2.0214,2.32-0.36074,4.0668-1.4665,1.0191-0.97836-1.8767,0.2023-4.147,0.73703-5.7935,0.9056l1.4817-0.80857c1.4487-0.74176,3.1233-1.0453,4.7037-1.5848,0.29633-0.10114,0.19914,0.003,0.29791-0.26681l-0.2587-0.097c-0.29632-0.0337-0.56602,0.0957-0.86234,0.12937,0.95484-0.57316,3.5906-1.1143,4.5783-1.3503,1.1853-0.26972,2.3738-0.60078,3.559-0.93794,0.36217-0.10115,0.85291-0.10085,1.0505-0.40429l-0.22736-0.13746c-0.36217-0.13486-6.7482,0.81116-7.4396,0.94602-0.62558,0.10115-1.8172,0.37194-2.344,0.37194,1.9426-0.80919,3.854-1.6571,5.8953-2.264,0.36218-0.10114,1.8486-0.36627,2.0461-0.70346-0.39511-0.16859-0.72595-0.0688-1.2857,0.0323-1.9096,0.30345-3.7552,0.80947-5.5662,1.3827-0.62558,0.20228-1.4848,0.53624-2.0775,0.67112,6.5521-2.5287,4.0547-1.7874,10.113-2.9675,0.69141-0.13487,1.2512-0.0697,1.317-0.54176l-3.4885-0.20214c-1.1524,0.0337-2.3378,0.30588-3.2926,0.3396l2.5949-2.1912c0.72434-0.60688,0.39513-0.77486,1.6463-0.80857,0.49388-0.0337,2.0085,0.0716,2.3048-0.097-0.88899-0.91033-1.1508-0.44167-2.0069-0.91367l1.0583-1.2856c0.26339-0.33717,0.52368-0.6371,0.72124-1.0754,0.0988-0.2023,0.0972-0.16431,0.0314-0.29916l-0.42334,0.0647-2.7046,2.2236c-0.46096,0.33717-0.35908,0.30589-1.0505,0.3396-1.1853,0.10115-2.3393,0.46882-3.4258,0.67113,1.2841-1.0115,2.1042-1.6152,3.5199-2.458,0.62558-0.4046,1.2857-0.74495,1.9442-1.1158,0.52679-0.26974,1.8454-0.70587,1.9442-1.043l-4.1784,1.0754c-0.82313,0.30346-3.0967,1.3824-3.5906,1.7869,1.8438-2.0567,4.6708-4.4121,6.8438-6.0644,0.26341-0.2023,0.9282-0.53746,1.027-0.84092-0.16464-0.0674-0.23518-0.10649-0.39983-0.0728-1.1524,0.23602-3.7519,1.99-4.641,2.5632-1.4816,0.97776-3.0967,2.0556-4.4137,3.2019,0.7902-0.8429,1.5177-1.6179,2.4067-2.3934,0.19756-0.2023,0.45941-0.43785,0.68988-0.60644,0.23049-0.2023,0.39669-0.37179,0.62716-0.5741,0.46096-0.37088,0.82474-0.73687,1.2857-1.1077,0.88899-0.74176,1.7733-1.5195,2.5636-2.3287l1.317-1.1482c0.29632-0.26971,1.1853-0.80552,1.1524-1.2775-1.8109,1.0115-3.4855,2.1189-5.1977,3.299-0.85605,0.57317-1.6464,1.1814-2.4695,1.7546-0.62558,0.40459-1.9128,1.5833-2.4067,1.8193,1.0207-1.6521,2.0775-3.3706,3.3944-4.7867,1.6133-1.787,3.6518-3.6415,5.4954-5.1588,0.49388-0.4046,0.95798-0.90803,1.4189-1.2452v-0.1698c-0.42802-0.0337-1.8502,1.0159-2.1794,1.2856-1.9755,1.4498-3.912,3.0604-5.5582,4.7464-0.29632,0.30345-0.52684,0.61161-0.82316,0.88133-0.85605,0.80919-1.6839,1.8846-2.3754,2.8622-0.92193,1.3149-1.9113,2.7318-2.7673,4.1479,0.55973-2.5624,2.3723-4.5471,3.7552-6.0644l3.1594-3.477c0.23046-0.23601,0.3355-0.40276,0.53308-0.63878,2.1101-2.317,3.1245-4.1168,3.5512-6.8324-0.35831,0.52436-0.86819,1.1396-1.6698,2.1346-0.25224,0.29523-0.46897,0.51687-0.72124,0.84899l-6.4128,7.3822c0.28832-1.0333,1.5479-3.2462,2.1245-4.1319,0.8649-1.3285,1.6234-2.4369,2.5244-3.6547,0.61263-0.84878,3.4233-4.507,4.1079-5.1345,0.0422-0.0433,0.20114-0.20182,0.2979-0.29916,0.0738-0.44941,0.43274-0.67726,0.90153-1.0673,0.52682-0.43831,0.62875-0.67356,1.2543-1.0107-0.59265-0.60691-2.8019,0.77196-3.2299,1.0754-2.7986,1.9218-4.8026,4.5502-6.8438,7.1801,0.2634-1.4161,1.9379-5.5635,2.7282-6.7434,0.65849-0.87662,1.2543-2.0208,1.9128-2.8301l1.8423-2.9028c-0.42805,0.0337-0.92035,0.6763-1.1838,0.94601-0.19756,0.2023-0.32771,0.33944-0.52526,0.54176-2.4694,2.6298-3.9245,5.5604-5.6367,8.7972,0.0988-1.6184,1.5538-4.3451,2.344-5.66,1.0207-1.7532,2.1684-3.2384,3.2221-4.9241-0.59264-0.16858-2.3378,1.9227-2.6341,2.361-0.75728,0.94405-1.513,1.8885-2.1716,2.9675-1.1853,1.9892-2.3378,4.2095-3.128,6.4686l-0.196,0.47707c0.1317-2.1241,2.2374-7.1855,3.1594-8.8376,0.55973-0.97776,1.1524-1.7526,1.8109-2.5954,0.26338-0.30345,0.42805-0.5698,0.65852-0.87326,0.46096-0.57316,0.85607-1.0844,1.317-1.6576l1.2857-1.7142c-0.82313-0.30345-3.7913,3.0679-4.351,3.7761-0.72434,0.91033-1.3813,1.9169-2.0069,2.8948,0.32923-1.6184,1.5491-3.8747,2.4381-5.2235,0.7902-1.2138,1.6118-2.1877,2.5008-3.2666,0.29632-0.33716,0.52993-0.67889,0.76042-1.0835-0.9219-0.13487-4.707,4.2861-5.4641,5.2638-0.32926,0.43831-0.59738,0.83924-0.8937,1.2775l-1.2465,1.9891c-0.0658,0.13487-0.10503,0.20336-0.20382,0.37194l-0.2587,0.3396c0.19756-1.5509,1.1211-4.7937,1.6149-6.2098,0.69141-1.8207,1.64-3.4687,2.4302-5.2556-0.65852-0.10115-1.9035,1.5871-2.2656,2.1266l-1.4816,2.8301c0.16461-1.3149,2.2014-5.8986,2.8927-7.5842-0.39508,0.10114-0.65696,0.70574-1.0191,1.2452-0.92193,1.4498-1.7467,2.8666-2.6027,4.35,0.1317-1.4835,1.0897-3.0366,1.7482-4.3179-1.2182,0.53945-3.2612,4.892-3.7552,6.2745-0.23047,0.57317-0.46251,1.2434-0.62716,1.884l-0.25869,0.6792c-0.0658-3.3378,0.61936-6.7477,1.1132-10.018-0.29632,0.0674-0.36222,0.40809-0.4939,0.71154-0.13173,0.30345-0.22891,0.53746-0.36062,0.84091-0.19755,0.60688-0.42805,1.1773-0.65852,1.8516l-0.95642,3.9782c-1.4158-1.9893-1.7718-5.6608-4.5705-9.8079-0.88899-1.3149-1.1901-1.4534-2.3754-2.2963zm1.4895,39.789c1.1524,3.203,1.6134,4.3166,2.4694,7.7219-0.16464,0.10115-0.23046,0.16293-0.32926,0.3315-0.13167,0.33717-0.26343,0.95106-0.4939,1.4231l-0.85449-2.9675c-0.32924-1.0789,0.13481-3.2757-0.22736-3.6467-0.32926,0.57317-0.23205,0.67705-0.2979,1.7222-0.19753-0.23601-0.39353-0.90803-0.52524-1.2452-0.65851-1.8207-0.75728-1.2835-0.32926-2.3287,0.13171-0.30345,0.32455-0.87584,0.58796-1.0107z'/%3E %3Cg fill='%23008f4c'%3E %3Cpath d='m540.42,311.56c0.42469-4.4486,5.9151-14.97,7.5254-15.198,0.24256-0.0321-1.8045,2.9357-3.2264,5.8711-1.4218,2.9354-2.9381,6.7757-3.4434,8.5576-0.47176,1.7637-0.90304,3.1036-0.94346,3.0252-0.0404-0.0783-0.007-1.1007,0.0877-2.2566z'/%3E %3Cpath d='m552.36,308.82c-0.0158,0.0856-1.0098,1.0722-2.254,2.1868-4.1568,3.8811-8.998,10.665-11.222,16.14-2.3608,5.8616-1.7644,4.3774-1.0684,1.5286,1.8046-6.1488,6.7392-13.944,11.333-17.739,1.615-1.3667,3.27-2.4299,3.2113-2.1162z'/%3E %3Cpath d='m538.54,298.82c0.005-4.0573,0.38754-5.4716,2.7186-10.343,1.4916-3.1269,2.0543-4.1526,2.2185-3.9176,0.10165,0.17169-0.032,0.73648-0.31265,1.2787-1.3801,2.6658-3.636,10.275-4.0239,13.601-0.13318,1.116-0.33159,2.0513-0.4292,2.0559-0.10928,0.0271-0.18569-1.1747-0.17119-2.6749z'/%3E %3Cpath d='m531.97,321.48c0.261,3.158-0.26246,6.747-1.6548,10.362-0.83809,2.1645-4.1423,7.1643-4.9295,7.4844-0.38696,0.15093-0.29253-0.0592,0.57872-1.0708,3.4587-4.0933,5.7586-10.175,5.8048-15.772-0.19934-3.0369,0.0155-3.4382,0.20087-1.0042z'/%3E %3Cpath d='m542.03,317.66c0.47323,1.4206,0.54026,4.7691,0.0271,6.496-1.2433,4.1761-4.216,7.2321-8.4524,8.7116-0.83169,0.27833-1.5471,0.48662-1.6047,0.43339-0.0384-0.0355,0.60093-0.40296,1.4526-0.78704,5.285-2.4802,8.5793-7.4758,8.6159-13.052,0.007-1.0411-0.20376-1.5475-0.26173-1.8077-0.096-0.43114-0.19136-0.76681-0.0538-0.8767,0.0727-0.0581-0.0697-0.15819,0.27688,0.88208z'/%3E %3Cpath d='m553.59,326.55c-0.0582,0.0527-2.3577,0.48271-5.1013,0.96355-2.7434,0.4632-6.299,1.1342-7.8646,1.4796-2.4158,0.51771-2.8987,0.58597-3.0518,0.37346-0.0956-0.14162-0.17182-0.28316-0.17147-0.3361,0-0.10587,7.459-1.4463,11.69-2.0787,3.0716-0.46162,4.7323-0.61242,4.4992-0.40177z'/%3E %3Cpath d='m531.89,279.97c1.761,2.1251,2.1754,3.042,3.0728,6.6683,0.57856,2.3256,0.72994,3.1225,0.54194,3.0754-0.12779-0.0428-0.30337-0.40012-0.39218-0.81359-0.4366-2.0329-2.5633-7.0572-3.8059-8.9766-0.41538-0.64551-0.71808-1.2266-0.66898-1.2741,0.0454-0.0647,0.60774,0.52879,1.2521,1.3204z'/%3E %3Cpath d='m529.98,282.57c0.83472,2.6596,1.3756,3.5036,3.9024,6.1896,1.619,1.7252,2.1982,2.2751,2.2577,2.0852,0.0315-0.13474-0.17191-0.47598-0.46711-0.77035-1.4514-1.4473-4.4905-5.9451-5.4264-8.0412-0.31609-0.70279-0.6379-1.2729-0.70282-1.2546-0.0772,0.006,0.11901,0.81084,0.43597,1.7914z'/%3E %3Cpath d='m545.76,290.82c-2.7944,2.5591-7.325,10.743-6.663,12.017,0.10112,0.19085,1.266-1.6886,2.5315-4.1986,1.2655-2.5101,3.0954-5.5467,4.0449-6.813,0.95414-1.2329,1.6422-2.222,1.5687-2.2114s-0.74798,0.55272-1.4821,1.2062z'/%3E %3Cpath d='m547.02,292.91c-3.1215,2.8588-8.1827,12.001-7.4432,13.424,0.11297,0.21319,1.4143-1.8863,2.828-4.6902,1.4137-2.804,3.4577-6.1961,4.5186-7.6106,1.0658-1.3772,1.8344-2.4822,1.7524-2.4704s-0.83555,0.61746-1.6556,1.3474z'/%3E %3Cpath d='m529.11,284.53c0.4935,2.7489,0.92384,3.6578,3.0919,6.659,1.3886,1.927,1.8938,2.5498,1.9767,2.3694,0.0481-0.1294-0.11065-0.49494-0.36638-0.82629-1.2573-1.6291-3.7055-6.4952-4.3703-8.6987-0.22513-0.73912-0.47258-1.3474-0.53929-1.3379-0.0773-0.004,0.0161,0.8199,0.20724,1.8345z'/%3E %3Cpath d='m527.1,286.46c1.9567,1.9345,2.8207,2.4134,6.2796,3.544,2.2182,0.72826,2.9808,0.92953,2.9462,0.73328-0.0342-0.13404-0.37003-0.33518-0.76519-0.45019-1.9429-0.56543-6.685-3.0415-8.4722-4.4304-0.60117-0.46449-1.1464-0.80932-1.1952-0.76145-0.0652,0.0431,0.47724,0.65594,1.2068,1.3646z'/%3E %3Cpath d='m552.36,299.7c-4.2471,2.9486-11.848,13.208-11.174,15.063,0.10353,0.27818,2.018-2.0545,4.1806-5.2245,2.1627-3.1701,5.1849-6.9485,6.6983-8.4896,1.5138-1.4944,2.623-2.708,2.5214-2.7075-0.1016,0.00078-1.1135,0.6097-2.226,1.3588z'/%3E %3Cpath d='m551.71,305.98c-1.8541,3.7282-8.9784,10.868-10.459,10.494-0.22224-0.058,1.3802-1.8327,3.5989-3.8876,2.2189-2.055,4.8219-4.8654,5.8569-6.2401,0.99959-1.3704,1.8226-2.3858,1.8318-2.3032,0.009,0.0826-0.36129,0.9621-0.82916,1.9365z'/%3E %3Cpath d='m526.67,331.71c-0.75962,3.6757-5.3088,11.577-6.675,11.611-0.20561,0.003,0.77926-1.9201,2.2343-4.2351,1.4551-2.3149,3.0713-5.3769,3.6558-6.8168,0.55464-1.4279,1.0369-2.5058,1.0636-2.4364,0.0265,0.0694-0.0946,0.9203-0.27861,1.877z'/%3E %3Cpath d='m538.31,309.63c-0.74475-2.3534-2.8373-5.1883-5.731-7.7563-2.9068-2.6123-3.7951-3.0291-1.2383-0.5813,2.3562,2.2403,5.3018,6.2316,6.3572,8.6174,0.44915,0.967,0.88698,1.7396,0.98246,1.671,0.12242-0.056-0.0436-0.92788-0.3704-1.9508z'/%3E %3Cpath d='m540.5,339.51c-3.2675-0.95323-11.656-0.85667-12.323,0.13447-0.0989,0.14987,1.8858,0.21653,4.4007,0.0983,2.5148-0.11824,5.6969-0.0478,7.1112,0.1146,1.3908,0.17935,2.4704,0.2679,2.4279,0.21979-0.0426-0.0481-0.77334-0.30902-1.6174-0.56714z'/%3E %3Cpath d='m536.91,340.96c-3.3014-0.82014-11.68-0.38382-12.308,0.63353-0.0931,0.15376,1.8926,0.13998,4.4012-0.08,2.5085-0.22002,5.6909-0.27853,7.1102-0.17356,1.3965,0.12288,2.4787,0.16764,2.4344,0.12126-0.0444-0.0463-0.7845-0.27745-1.6377-0.50118z'/%3E %3Cpath d='m533.22,342.75c-3.3207-0.73234-11.686-0.074-12.288,0.95963-0.0892,0.15618,1.8955,0.0897,4.3976-0.1967,2.5022-0.28645,5.6821-0.4293,7.1035-0.362,1.3991,0.0858,2.482,0.10187,2.4366,0.0567-0.0455-0.0451-0.79115-0.25656-1.6497-0.45761z'/%3E %3Cpath d='m531.04,344.85c-2.8157-1.0607-10.114-1.2414-10.72-0.27277-0.0901,0.14653,1.6341,0.27872,3.8244,0.24365,2.1902-0.0351,4.9556,0.14046,6.1813,0.34951,1.2046,0.22522,2.1411,0.3494,2.1055,0.29988-0.0358-0.0494-0.66417-0.33442-1.3912-0.62028z'/%3E %3Cpath d='m544.08,334.5c-6.887,1.9576-15.21,3.1507-15.686,4.7997-0.0695,0.24858,3.0397-0.25642,6.0983-1.4693,3.0585-1.2128,7.0054-2.4431,8.8053-2.8086,1.777-0.33218,3.1707-0.72609,3.1333-0.90687-0.0693-0.0487-1.2211,0.3899-2.3516,0.38498z'/%3E %3Cpath d='m553.06,330.08c-0.0693,0.0626-2.8042,0.57413-6.0674,1.146-3.263,0.55092-7.4918,1.349-9.3537,1.7598-2.8734,0.61575-3.4476,0.69695-3.6295,0.44421-0.11367-0.16845-0.20438-0.33678-0.20395-0.39976,0-0.12592,8.8716-1.7201,13.903-2.4724,3.6533-0.54902,5.6284-0.72838,5.3514-0.47787z'/%3E %3Cpath d='m550.93,328.3c-0.053,0.0583-2.3004,0.71896-4.9849,1.4751-2.6863,0.7386-6.1607,1.7662-7.6857,2.2683-2.3549,0.75969-2.829,0.87649-3.0014,0.68052-0.10857-0.13127-0.19793-0.26441-0.20262-0.31712-0.009-0.10543,7.2854-2.1941,11.435-3.2516,3.0129-0.77023,4.6513-1.0884,4.4393-0.85517z'/%3E %3Cpath d='m549.23,320.19c-4.7589,1.9473-14.305,10.3-14.03,12.26,0.0437,0.29455,2.3962-1.5637,5.1643-4.1857,2.768-2.6218,6.5014-5.6494,8.2986-6.822,1.7878-1.1273,3.1225-2.0692,3.0229-2.091-0.0994-0.0216-1.2139,0.35091-2.4557,0.83823z'/%3E %3Cpath d='m552.76,322.47c-4.7446,0.31156-15.516,5.1596-15.826,7.1095-0.0445,0.29383,2.5533-0.71071,5.733-2.3062s7.3247-3.264,9.2398-3.797c1.894-0.49285,3.3362-0.95605,3.2547-1.0089-0.0816-0.0526-1.1691-0.059-2.4013,0.003z'/%3E %3Cpath d='m552.61,323c-12.14,10.201-18.961,15.189-21.382,14.133-0.36325-0.16189,4.4606-2.9318,8.5848-5.5692,4.1242-2.6376,9.0376-6.3772,11.04-8.2792,1.9418-1.9062,3.5194-3.2933,3.5191-3.1572,0,0.13619-0.78995,1.4427-1.7617,2.8726z'/%3E %3Cpath d='m539.62,326.19c2.4465-3.9823,3.6737-5.1265,8.8946-8.4184,3.3468-2.1163,4.5168-2.7636,4.5366-2.4276-0.004,0.2337-0.47464,0.70292-1.0767,1.0558-2.96,1.735-9.7551,7.7646-12.138,10.783-0.80247,1.0109-1.5602,1.8026-1.6588,1.7446-0.12367-0.0433,0.52459-1.2728,1.4416-2.737z'/%3E %3Cpath d='m540.95,314.72c0.42469-4.4486,8.0407-19.308,9.651-19.535,0.24256-0.0321-1.8045,2.9357-3.2264,5.8711-1.4218,2.9354-2.9381,6.7757-3.4434,8.5576-0.47175,1.7637-3.2547,8.2345-3.2951,8.1561-0.0404-0.0783,0.21943-1.8936,0.31383-3.0495z'/%3E %3Cpath d='m537.74,297.58c-1.2794-3.0185-1.3208-4.1751-0.38834-8.4371,0.59354-2.7346,0.86618-3.6519,1.1148-3.5223,0.16223,0.0998,0.19921,0.55642,0.0729,1.0367-0.62101,2.3613-0.60706,8.6386,0.0339,11.218,0.21193,0.86645,0.2974,1.6164,0.19522,1.6466-0.10742,0.0502-0.56898-0.82257-1.0285-1.942z'/%3E %3Cpath d='m540.07,313.88c-0.67054-2.1189-2.5546-4.6713-5.16-6.9837-2.6173-2.3519-3.417-2.7274-1.115-0.52335,2.1215,2.0171,4.7734,5.6108,5.724,7.7589,0.4044,0.87067,0.7986,1.5663,0.88458,1.5045,0.11023-0.0504-0.0393-0.83543-0.3335-1.7565z'/%3E %3Cpath d='m528.4,317.3c2.3968-8.6291,4.2963-7.1364,4.2963-7.1364,5.2458,4.944,2.6682,21.922,2.6682,21.922-0.0452-34.749-6.9642-14.786-6.9642-14.786z'/%3E %3Cpath d='m530.34,316.7c2.3968-8.6291,3.0299-8.2557,3.0299-8.2557,4.3415,0.88622,4.07,19.916,4.07,19.916-1.8993-32.651-7.1-11.661-7.1-11.661z'/%3E %3Cpath d='m528.05,323.4c-0.0959-6.1984,1.1279-5.2706,1.1279-5.2706,3.5083,3.1391,4.8126,15.202,4.8126,15.202-5.4455-24.357-5.9405-9.9313-5.9405-9.9313z'/%3E %3Cpath d='m538.69,305.19c-1.0537-3.3298-4.0141-7.3405-8.1084-10.974-4.1127-3.6959-5.3695-4.2858-1.752-0.82241,3.3337,3.1696,7.5008,8.8169,8.9945,12.192,0.63546,1.3682,1.2549,2.4613,1.39,2.3642,0.1732-0.0792-0.0618-1.3128-0.52405-2.76z'/%3E %3Cpath d='m538.34,302.27c-0.81112-2.5632-3.0902-5.6507-6.2418-8.4477-3.1659-2.8451-4.1335-3.2992-1.3487-0.63309,2.5663,2.44,5.7741,6.7871,6.9239,9.3856,0.48918,1.0532,0.96602,1.8947,1.07,1.82,0.13334-0.061-0.0475-1.0106-0.40341-2.1247z'/%3E %3Cpath d='m520.88,336.62c-0.24888,1.8826-2.2542,6.0424-2.9416,6.1125-0.10351,0.01,0.32283-0.9982,0.97197-2.2217s1.3523-2.8299,1.5944-3.5784c0.22753-0.7414,0.43136-1.3035,0.44734-1.2695,0.0158,0.034-0.014,0.46762-0.072,0.95706z'/%3E %3Cpath d='m519.15,337.71c-0.24889,1.8826-2.2542,6.0424-2.9416,6.1125-0.10351,0.01,0.32284-0.9982,0.97198-2.2217,0.64913-1.2235,1.3523-2.8299,1.5944-3.5784,0.22754-0.7414,0.43137-1.3035,0.44735-1.2695,0.0158,0.034-0.014,0.46762-0.072,0.95706z'/%3E %3Cpath d='m521.76,337.85c-0.24889,1.8826-2.2542,6.0424-2.9416,6.1125-0.10351,0.01,0.32284-0.9982,0.97198-2.2217,0.64913-1.2235,1.3523-2.8299,1.5944-3.5784,0.22754-0.7414,0.43137-1.3035,0.44735-1.2695,0.0158,0.034-0.014,0.46762-0.072,0.95706z'/%3E %3C/g%3E %3Cpath fill='%2300873f' d='m457.76,290.38c0.0131,0.93148,0.2693,1.1727,0.68309,1.7624l0.10509-1.8227c-0.34156-0.20773-0.47291-0.0335-0.78818,0.0603z'/%3E %3Cg fill='none' stroke='%23006300' stroke-width='0.6268'%3E %3Cpath d='m455.17,303.94c-0.86564-0.69253-0.86564-0.69253-0.86564-0.69253'/%3E %3Cpath d='m456.08,298.62c-0.69253-0.99551-0.7358-0.99551-0.7358-0.99551'/%3E %3Cpath d='m453.57,311.08c-0.25969-2.1208-1.4716-2.7268-1.4716-2.7268'/%3E %3Cpath d='m463.44,338.34c-5.3999-5.9702-7.1651-16.77-7.1651-16.77,1.7652-4.5176,4.1016-5.5566,4.1016-5.5566'/%3E %3Cpath d='m456.28,321.52c-1.7654-6.9574-1.3247-14.228-1.3247-14.228,0.62303-8.9303,3.4535-16.822,3.4535-16.822'/%3E %3Cpath d='m454.9,309.78c1.4318-6.5359,6.8702-5.7462,6.8702-5.7462'/%3E %3Cpath d='m454.83,310.99c4.8829-1.9826,4.3006-6.2884,5.1767-8.0404,1.3217-2.6434,2.2762-3.4145,2.2762-3.4145'/%3E %3Cpath d='m459.7,332.37c-1.6615-4.2057,0.31153-4.9844,0.31153-4.9844'/%3E %3Cpath d='m459.03,331.02c-2.1294-2.7516-4.8293-2.5432-4.8293-2.5432'/%3E %3Cpath d='m458.09,318.2c1.298-2.3884-0.0519-4.7804-0.0519-4.7804'/%3E %3Cpath d='m458.73,329.72-3.7984-4.9251'/%3E %3Cpath d='m457.21,294.36c0.51401-1.9459-1.028-2.827-1.028-2.827'/%3E %3Cg transform='matrix(0.15669945,0,0,0.15669945,442.05165,224.217)'%3E %3Cpath id='b' fill='%23f00' stroke='%23006300' stroke-width='2' d='m91.376,425.97c0,3.2997-2.6749,5.9746-5.9746,5.9746s-5.9746-2.6749-5.9746-5.9746,2.6749-5.9746,5.9746-5.9746,5.9746,2.6749,5.9746,5.9746z'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='matrix(0.15669945,0,0,0.18127975,444.56657,235.35279)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.15669945,0,0,0.15669945,443.68543,248.31983)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.16898961,0,0,0.16898961,439.99242,252.04284)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.16898961,0,0,0.16898961,438.74414,256.22825)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.16898961,0,0,0.16898961,440.28613,257.84368)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.1228861,0,0,0.1228861,463.22156,286.0505)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.1228861,0,0,0.1228861,464.29275,287.30532)'/%3E %3Cpath d='m458.76,316.61c-0.22029-0.95456-1.1014-1.2483-1.1014-1.2483'/%3E %3Cpath d='m472.4,339.53c1.5914,1.163,2.0811,0.42848,2.0811,0.42848'/%3E %3C/g%3E %3Cg fill='%23006300'%3E %3Cpath d='m474.38,342.94c-0.97938-3.4891-0.73453-4.2848-0.73453-4.2848'/%3E %3Cpath d='m466.03,336.65s-0.58368-1.3619,0.36854-2.141c0.56415-0.46158,3.0031,0.8661,4.2574-4.5778,0,0-0.75943-0.0887-2.5052,0.70258v-0.43282s-0.38954-1.2119-0.21642-2.7267c0,0,0.83107-1.2779,0.85778-1.7925,0,0-1.5734-0.58187-4.6461,3.3712,0,0-0.28024-0.84292-2.531-2.3579,0,0-1.2209,3.4543-0.60596,5.4104,0.47746,1.5188,0.51197,2.057,2.1208,3.1597,0,0,1.2985,0.56267,1.4716,2.2939,0.60596,0,1.396-0.10292,1.396-0.10292s0.0756,0.0164,0.0323-0.80601z'/%3E %3Cpath d='m463.74,340.68c-0.49774,0.28134-0.71921,0.53616-1.6015,0.64924-3.9646,0.50814-6.1895-4.7178-6.1895-4.7178-0.12985-1.0388,0.3471-0.49052,1.1686-0.19478,1.0821,0.38954,1.4045,0.0827,2.6186-0.0649,1.6015-0.19477,3.3977,1.385,3.3977,1.385,1.0171,0.88729,1.1037,2.6618,1.1037,2.6618-0.10821,0.28134-0.49774,0.28134-0.49774,0.28134z'/%3E %3Cpath d='m459.03,331.25c-4.1471-1.7597-6.6107,0.21424-6.6107,0.21424-0.15303,0.26015,0.24484,0.38256,0.24484,0.38256,2.6015,0.32136,1.7655,0.20058,2.8463,1.6833,1.8516,2.5402,5.1264,2.0046,5.1264,2.0046,0.67332,0.15303,1.3466,0.96406,1.3466,0.96406-0.27544-2.2648-2.9535-5.2488-2.9535-5.2488z'/%3E %3Cpath d='m451.85,314.83c-0.79573-0.5509-0.61581,0.55089-0.61581,0.55089-1.714-2.9994-6.2398-3.2299-6.2398-3.2299-0.36897-0.0169-0.58537-0.29821-0.58537-0.29821-0.75744,0,0.17314,1.5149,0.17314,1.5149,1.3634,3.6357,2.6618,4.0469,2.6618,4.0469-1.545,0.88325-4.019-1.036-3.4626,0.3679,2.4022,2.532,4.0253,2.8782,4.0253,2.8782,3.0298,0.7358,4.3716,0,4.3716,0,0.69252,1.2552,1.147,1.4283,1.147,1.4283,2.7485,0.82237,3.3545,2.4022,3.3545,2.4022,0-3.0082-1.1319-6.7176-1.1319-6.7176-0.85981-1.2912-3.698-2.946-3.698-2.946z'/%3E %3Cpath d='m473.25,343.98c-1.4691,0.45908-1.5914,1.4997-1.5914,1.4997-1.4384,1.9587-6.6108,0.0918-6.6108,0.0918-1.5914-0.42848-1.2854-0.85695-1.2854-0.85695,1.4385-0.73453,1.9282-1.316,1.9282-1.316-2.7545-2.479-3.1523-5.6926-3.1523-5.6926,4.2848-0.85695,5.6008-0.0612,5.6008-0.0612-0.27545-1.6527-1.6833-1.6833-1.6833-1.6833-0.33665-0.52029,0.39788-0.5509,0.39788-0.5509,3.7644,0.36728,5.7844,2.7239,5.7844,2.7239,1.4078,1.9893,0.97937,3.948,0.97937,3.948,0.33666,1.9893-0.36727,1.8975-0.36727,1.8975z'/%3E %3Cpath d='m455.76,326.72c-2.0824-0.61308-3.2894,0.0649-3.2894,0.0649-1.0821,0.43282-3.0514-0.82236-3.0514-0.82236-2.597-2.1625-3.0948-3.5054-3.0948-3.5054,0-0.38954,2.2931-0.3019,2.2931-0.3019,3.0224-0.0727,3.711,0.54709,3.711,0.54709,1.5609,0.88756,1.4001,1.7007,1.9588,2.0275,1.3466,0.78809,1.5609,1.1554,1.5609,1.1554,0.38257,0.52029,0.55007,1.0231-0.0882,0.83517z'/%3E %3Cpath d='m459.8,327.78c1.4283-1.6447,3.3761-0.5194,3.3761-0.5194,2.9865,0.34626,3.9386-3.0298,3.9386-3.0298,0.69252-1.385,1.2119-2.0343,1.2119-2.0343,0.17312-0.77907-1.2985-0.12984-1.2985-0.12984-2.5537,0.64923-2.6402,0.90893-2.6402,0.90893,0.43282-4.0253,0.43282-4.0685,0.43282-4.0685,0.0433-0.64924-0.69251-0.17312-0.69251-0.17312-3.679,2.1208-4.1118,3.679-4.1118,3.679-1.5149-2.8566-1.5149-2.8566-1.5149-2.8566-0.47612-1.1686-0.82236,0.12984-0.82236,0.12984-0.69252,3.4626-0.43282,3.7656-0.43282,3.7656,0.47612,1.8611,0.95222,2.3806,0.95222,2.3806,0.86565,1.1254,0.86565,1.5582,0.86565,1.5582z'/%3E %3Cpath d='m481.45,337.25c-0.5815,0.15303-2.1118,2.5708-2.1118,2.5708-1.8364-3.4584-4.2848-4.0093-4.2848-4.0093-0.48969,0.21424,0.0612,1.01,0.0612,1.01,0.73453,1.8364-0.12242,3.2747-0.12242,3.2747-0.27545,1.3466,0.0306,1.6527,0.0306,1.6527-2.9076-1.4997-3.0912-1.3466-3.0912-1.3466-0.0306,1.8669,2.2035,5.356,2.2035,5.356,4.8356-1.2854,5.2029-1.1936,5.2029-1.1936,1.8056-0.27544,1.7597-0.30605,1.7597-0.30605,1.4538-4.1622,0.35196-7.0087,0.35196-7.0087z'/%3E %3Cpath d='m457.75,318.21c1.8669,0.91817,1.9893,2.1424,1.9893,2.1424,0.48968,1.5914,4.8356,1.9587,4.8356,1.9587,3.5502-0.36727,3.1829-1.01,3.1829-1.01-2.0506-1.8056-1.4611-1.6629-2.326-2.5097-1.5476-1.5152-3.5809-1.5609-3.5809-1.5609-2.7239,0.42848-3.3054-0.12242-3.3054-0.12242-0.97937,0.52029-0.79573,1.1018-0.79573,1.1018z'/%3E %3Cpath d='m453.54,311.97c-0.8773-3.1993,2.02-7.1616,2.02-7.1616,2.4179,4.499,1.9587,5.7538,1.9587,5.7538-0.85714,2.9992-2.043,5.2024-2.043,5.2024-0.44378-2.2643-1.6138-2.6216-1.9359-3.7953z'/%3E %3Cpath d='m451.99,313.22c-3.0649,0.0878-5.9878-3.3831-5.9878-3.3831,4.5695-1.1851,5.5956-0.49794,5.5956-0.49794,2.5053,1.4267,4.2242,2.9745,4.2242,2.9745-2.1308-0.0978-2.7073,0.87476-3.8318,0.90656z'/%3E %3Cpath d='m449.63,308.91c-1.9478,0.30298-3.6357-1.6015-3.6357-1.6015-2.597-3.4626-1.7314-4.588-1.7314-4.588,0.21641-0.12985,0.51939,0.30298,0.51939,0.30298,0.82238,0.7358,2.2939,0.90893,2.2939,0.90893-4.1552-2.597-1.4283-8.3535-1.4283-8.3535,0.51939-0.56267,0.69252,0.82238,0.69252,0.82238,0.56267,1.5149,2.2074,2.4238,2.2074,2.4238,0.86566,1.1686,0.86566,1.6447,0.86566,1.6447,0.43282-1.9478,0.90893-1.4283,0.90893-1.4283,0.5194,1.5582,2.2427,2.6482,2.4671,3.7222,0.60595,2.8999,0.12985,3.2894,0.12985,3.2894-0.34626,1.688-0.3679,2.9649-0.3679,2.9649-1.5798-0.58432-2.9215-0.10821-2.9215-0.10821z'/%3E %3Cpath d='m459.41,315.88c0.99549-1.3418,0-3.8522,0-3.8522-0.38954-2.6835,3.6357-5.2372,3.6357-5.2372,1.1686,2.1642,1.0388,3.4626,1.0388,3.4626,3.073-0.73579,3.7656-0.95221,3.7656-0.95221,0.12985,1.7314-1.5149,4.2417-1.5149,4.2417,2.5103,0.7358,3.3761-0.47611,3.3761-0.47611-1.2119,5.5835-6.5356,4.4581-6.5356,4.4581-2.2074-1.4283-3.7656-1.6447-3.7656-1.6447z'/%3E %3Cpath d='m451.06,299.6c0.30605-3.3665,0.91817-3.4891,0.91817-3.4891,0.36227,0.13356,0.54039,1.6302,1.0251,1.8536,2.11,0.97288,2.0966,3.2269,2.0966,3.2269-0.0612,2.6934-0.45165,2.4516-0.45165,2.4516-2.9439-0.0376-3.5883-4.0413-3.5883-4.0413z'/%3E %3Cpath d='m460.8,300.27c1.0285-3.8161,0.40679-4.1983,0.40679-4.1983-0.45142-0.00031-1.2531,1.5687-1.8752,1.6174-2.7081,0.21203-3.6069,2.6893-3.6069,2.6893-1.0242,2.9784-0.498,2.8715-0.498,2.8715,3.2441,1.1509,5.2074-1.6223,5.5733-2.98z'/%3E %3Cpath d='m451.19,293.29c0.35592-3.9361,1.0715-4.0797,1.0715-4.0797,0.42363,0.15595,0.63272,1.9055,1.1995,2.1665,2.4674,1.1362,2.4531,3.7714,2.4531,3.7714-0.07,3.1489-0.52666,2.8664-0.52666,2.8664-3.4419-0.0431-4.3241-3.3245-4.1975-4.7248z'/%3E %3Cpath d='m462.18,294.23c1.1134-3.7921,0.50037-4.1883,0.50037-4.1883-0.45129-0.0104-1.2878,1.5404-1.911,1.5751-2.7122,0.15155-3.666,2.6081-3.666,2.6081-1.0904,2.9549-0.56196,2.8598-0.56196,2.8598,3.2177,1.223,5.2424-1.5058,5.6385-2.8548z'/%3E %3Cpath d='m466.7,304.83c3.1305-2.4124,2.8676-3.0932,2.8676-3.0932-0.3589-0.27381-1.9475,0.48855-2.4719,0.15031-2.2828-1.4724-4.4988-0.0463-4.4988-0.0463-2.6196,1.7488-2.1363,1.9824-2.1363,1.9824,1.8832,2.8814,5.1256,1.865,6.2393,1.0068z'/%3E %3Cpath d='m466.6,306.9c2.981-1.3679,2.8782-1.9329,2.8782-1.9329-0.24984-0.26671-1.6855,0.072-2.0608-0.27011-1.6341-1.4893-3.6973-0.73779-3.6973-0.73779-2.4494,0.93687-2.0904,1.1922-2.0904,1.1922,1.0697,2.5113,3.9096,2.2352,4.9702,1.7484z'/%3E %3Cpath d='m456.32,288.83c-1.1871-3.5311,2.3872-8.2023,2.3872-8.2023,0.75119,2.193,1.163,3.9175,1.163,3.9175,2.8411-2.8861,5.3612-3.3308,5.3612-3.3308-0.0581,1.3466-0.0971,2.2289-0.0971,2.2289,1.8975-0.18363,2.6934-0.61209,2.6934-0.61209-0.40746,2.8306-3.9788,5.6926-3.9788,5.6926-1.3466,0.85696-2.9994,0.5509-2.9994,0.5509-2.5862,0.73452-3.1906,2.4943-3.1906,2.4943-0.25249-1.5303-0.43158-0.0401-1.339-2.7391z'/%3E %3Cpath d='m461.53,300.64c1.6015-2.1208,4.1552-1.2119,4.1552-1.2119,2.2939,0.17312,4.2417-2.2074,4.2417-2.2074,1.0388-1.688,1.688-2.0775,1.688-2.0775-0.0866-0.56268-0.64923-0.47612-0.64923-0.47612-1.385,0.30298-1.385,0.34626-1.385,0.34626,1.0388-3.8521,0.47612-4.0253,0.47612-4.0253-0.34626,0-0.56268,0.25969-0.56268,0.25969-0.60596,1.7746-3.073,1.688-3.073,1.688-0.12985-2.5537-0.69252-2.2074-0.69252-2.2074-0.38954,0.64923-1.2119,1.0388-1.2119,1.0388-2.4238,2.4238-2.4238,3.4626-2.4238,3.4626,0.12985,2.8566-0.56268,5.4104-0.56268,5.4104z'/%3E %3C/g%3E %3Cg fill='%2300863d'%3E %3Cpath d='m461.07,314.65c0.32184-0.36856,1.0509-0.92475,1.6092-1.2397,0.55831-0.32166,0.38094-0.18764,0.65024-0.79746,0.24959-0.57629,0.17734-0.44896,0.57799-0.84434l-0.35469,1.0789c0.56488-0.32165,0.77506-0.50258,1.5698-0.93148,0.0657,0.31496-0.51889,0.59642-0.99836,0.91135-0.42693,0.28816-0.79474,0.52941-1.2414,0.79746l-2.1675,1.8361c2.0493-0.47579,1.6814-0.13402,2.7061-0.30155,2.1938-0.36186,3.2316-3.4645,3.9739-5.274-1.5041,0.28145-3.0608,0.61651-4.1641,1.3604-1.4122,0.95158-1.3071,1.816-2.1609,3.4042z'/%3E %3Cpath d='m455.47,322.47c-0.13136-0.33507-0.51233-0.89126-0.72251-1.2598-0.58456-1.0454-0.65023-1.3536-1.4122-2.5464-0.48603-0.77063-0.3087-0.36856-0.62398-1.2263,0.289,0.0201,0.68966,0.89126,1.0181,1.2464l-0.007-1.2665c0.34812,0.0268,0.24959,0.33506,0.2693,0.71701,0.0657,1.2397-0.0525,1.0253,0.70937,2.3856l1.5435,2.5398c-0.0919-0.40208-0.28899-0.75724-0.40067-1.1727-0.45321-1.6552,0.58457-3.6253-3.5074-6.058l-1.0115-0.61651c0.0722,2.0104,0.29557,5.3275,2.1412,6.366,0.32184,0.18094,0.69622,0.26135,1.0443,0.40208,0.37438,0.16083,0.63711,0.34176,0.95895,0.48919z'/%3E %3Cpath d='m454.52,297.3c-0.1512-0.51424-0.39062-0.9706-0.54812-1.5491-0.14491-0.52066-0.063-0.39852-0.42844-0.65566l-0.47883-0.58493,0.60482,0.30854c-0.1071-0.33425-0.30871-0.68778-0.48513-0.94491-0.37803-0.53995-0.20791-0.17998-0.59853-0.88061,0.69933-0.0771,1.4365,1.9991,1.594,2.539,0.47883,1.6005,0.45991,1.4077,1.405,2.6933-0.006-0.21855-0.34652-0.61065-0.43473-0.93848-0.25202-0.88061,0.69933-2.0762-0.23941-3.9595-0.56072-1.1313-1.72-1.3177-2.287-2.2691l-0.49772-0.97703c-0.18271,0.34069-0.46621,1.6841-0.49143,2.1276-0.0819,1.382,0.25202,3.1947,1.2096,4.1139,0.34652,0.32782,1.2034,0.79705,1.6759,0.97703z'/%3E %3Cpath d='m459.74,287.33c0.19704-0.14073,0.57799-0.67683,0.91956-0.97167l0.99836-0.83765-0.15107-0.92478c0.19704,0.067,0.11823-0.0871,0.31527,0.6299,0.25616-0.22783,0.85385-1.233,1.1166-1.6351,0.19705,0.27475-0.38751,1.1258-0.56487,1.3938-0.289,0.4624-0.56487,0.79073-0.9918,1.1191l-1.9114,2.3454c0.40068-0.12732,0.69622-0.26804,1.1298-0.35515,1.2414-0.24795,1.7209-0.35516,2.5878-1.7423,0.82103-1.3067,1.0443-2.915,1.3727-4.4226-1.7734,0.71032-3.6454,1.4274-4.565,3.0893-0.34156,0.60982-0.19048,1.1325-0.25616,2.3119z'/%3E %3Cpath d='m448.55,304.1c-0.50576-1.3067-1.8982-2.8413-2.0493-3.5047l-0.20361-1.5547c0.289,0.0402,0.15763-0.0737,0.24302,0.20104,0,0,0.0788,0.87787,0.18391,1.1258l0.63054,1.1325c0.0263-0.75724-0.0985-0.38198,0.19705-1.032,0.30214,0.38869-0.1642,1.0588,0.289,1.816,0.23645,0.39538,0.55831,1.0186,0.85385,1.3604-0.0131-1.0789,0.72907-2.7408-0.4926-4.3155-0.42692-0.5428-0.92612-0.73045-1.4581-1.1794l-1.0246-1.615c-0.8276,1.7557-0.66996,5.3275,0.98523,6.5134,0.31528,0.22784,0.60429,0.30826,0.94582,0.49589,0.17734,0.10051,0.289,0.16083,0.45978,0.26804,0.15764,0.10052,0.27586,0.20104,0.44005,0.28816z'/%3E %3Cpath d='m456.55,297.13c0.71414-0.58738,0.48932-0.82037,2.1516-2.0703,0.41041-0.30773,0.71102-0.65465,1.0665-1.0457,0.50874-0.55767,0.33854-0.44562,1.0168-1.102,0.1689,0.2972-0.92864,1.4353-1.2724,1.8538l0.66668,0.0812c-0.10588,0.39716-0.4788,0.10292-1.0191,0.24966-0.4864,0.12266-1.7717,1.5866-2.1261,1.9576,0.32035-0.0909,0.60998-0.22368,0.99524-0.29785,1.0298-0.20213,1.6734,0.0725,2.7853-1.3467,0.9356-1.1866,1.2687-2.6793,1.7247-4.132-1.4247,0.33621-3.1455,1.0598-3.9417,1.8376-1.1417,1.1022-1.0455,2.0466-1.4775,3.0309-0.17079,0.38041-0.4141,0.63634-0.57006,0.98396z'/%3E %3Cpath d='m450.99,307.87c-0.16421-0.24124-0.72251-0.67013-0.99836-0.87116-0.57144-0.40878-0.64367-0.41548-1.4384-0.47579l-2.3843-1.3201c0.29557-0.15413,0.44665,0.19433,1.0049,0.48918l1.1166,0.48249-0.13793-0.61651c0.21018,0.0134,0.22988,0.0469,0.32184,0.27474l0.0657,0.39538c1.0706,0.0871,0.89983,0.10722,1.9639,0.78403-0.11822-0.48248-0.1839-0.45569-0.48603-0.69692-0.26273-0.20774-0.32185-0.36855-0.53202-0.65673-0.33496-0.46239,0.0394,0.21444-0.53202-0.65-0.92612-1.3938-1.9442-0.78403-2.601-0.95158l-1.7012-0.69692c0.28899,1.6418,1.156,2.8681,2.0033,3.6588,0.44665,0.41547,0.96551,0.89126,1.7865,1.032,0.25616,0.0402,2.22-0.12062,2.5485-0.18093z'/%3E %3Cpath d='m450.03,316.77c-0.33496-0.32836-0.70938-0.60311-1.11-0.89795-0.28901-0.20774-0.43349-0.18094-0.8276-0.22114l-0.76849-0.26135,0.86702-0.0335c-0.0985-0.067-0.27587-0.22783-0.40067-0.32835-0.61086-0.48919-0.72907-0.48249-1.1232-1.0722,0.17078-0.16083,0.28243,0.0402,0.51889,0.22114,0.70278,0.5495,2.069,1.6485,2.7521,2.1176l1.2742,0.70361c-0.0591-0.68352-1.2217-2.8815-2.1806-3.3037l-4.2562-1.166c0.21675,0.71702,1.2742,2.7006,1.7143,3.297,1.2414,1.6887,1.3727,1.1258,2.2726,0.99176,0.45978-0.067,0.81447-0.0335,1.2676-0.0469z'/%3E %3Cpath d='m452.07,307.18-1.6116-5.3332c0.29266,0.0967,0.25293,0.45359,0.42558,1.0509l0.42753,1.1044c0.21335-0.46367-0.0877-0.0639,0.37244-0.79126,0.2056,0.234-0.0326,0.73878-0.12041,1.037-0.16378,0.56246-0.15156,0.35416,0.0729,0.92944l0.76105,1.9709c0.0366-0.44387-0.005-0.68379,0.0772-1.1427,0.24276-1.2895,0.44695-2.0076-0.16673-3.3533-0.53544-1.181-1.4276-2.0474-2.2561-2.9698-0.12333,0.22572-0.37686,1.7637-0.42924,2.1344-0.20049,1.3685-0.087,3.2419,1.003,4.1279,0.86015,0.70664,0.36024,0.14797,1.4444,1.2355z'/%3E %3Cpath d='m455.25,314.08c0.0328-0.5495-0.0591-3.0893-0.0394-4.2418,0-0.24795,0.0131-0.48919,0.0131-0.73715,0.007-0.38868-0.0328-0.26134,0.17734-0.5495,0.0943,0.13537,0.10886,0.28932,0.1051,0.48248l-0.0263,1.749,0.50576-0.85774c0.32184,0.12062,0.046,0.44227-0.0985,0.74384-0.11822,0.23455-0.38094,0.67683-0.42036,0.89796l0.0854,2.5062c0.0131-0.0201,0.0328-0.067,0.0394-0.0536,0.0263,0.0402,0.27587-0.65004,0.42693-0.89796,0.51889-0.88457,1.1231-2.1511,0.87358-3.2836l-1.399-4.0275c-0.29557,0.49588-0.65684,1.3268-0.89984,1.8696-0.289,0.65-0.52545,1.4341-0.63711,2.2181-0.26272,1.8763,0.24303,2.2583,0.82104,3.23,0.17734,0.30155,0.3087,0.62321,0.47291,0.95157z'/%3E %3Cpath d='m457.5,290.17c0.0197-0.47579,0.21675-2.9351,0.15764-3.1429-0.0197-0.067-0.16421-0.34846-0.20361-0.46909l-0.22989-0.98507c0.34813,0.0402,0.20361,0.25465,0.40067,0.61651l0.13136,0.18764c0.0197-0.24125,0.0394-0.48919,0.0591-0.72371,0.0394-0.48919-0.0328-0.24795,0.17734-0.72372,0.19704,0.11392,0.0854-0.0804,0.13793,0.22114,0.007,0.0402-0.0197,0.32166-0.0263,0.36856-0.17078,1.6418-0.23646,3.4444-0.31528,5.0928,0.15764-0.26804,0.21675-0.69692,0.38751-1.0186,0.42693-0.83765,1.1626-2.2784,1.0903-3.2568l-0.92612-4.8182c-0.33496,0.50928-0.6634,1.3134-0.94582,1.8965-0.63054,1.2866-1.2085,3.2434-0.82103,4.7043l0.82103,1.9032c0.0591,0.10721,0.046,0.0804,0.10509,0.14742z'/%3E %3Cpath d='m444.63,317.91c0.289,0.35516,0.88014,0.87117,1.2939,1.1861,0.80787,0.60311,2.6929,1.4005,3.6387,1.3402l2.1609-0.39538-0.33496-1.0052c-0.40068,0.0134-0.70938,0.18093-1.1691,0.18763-0.45322,0.0134-0.89983-0.0335-1.3268-0.0938-0.42036-0.0603-0.83416-0.12733-1.2283-0.21444-0.72907-0.15413-0.47291-0.0402-1.0312-0.42887l2.2726,0.33506c-0.59112-0.45569-0.38094-0.22114-0.81447-0.81755,0.32841-0.0335,1.0049,0.61651,1.294,0.81755l1.9442-0.0938-0.15107-1.1459c-0.9721-0.40208-2.3383-0.38198-3.3366-0.0335-2.0164,0.69022-1.3005,0.5294-3.2118,0.36185z'/%3E %3Cpath d='m447.19,322.95c0.11823,0.37525,2.1609,2.714,2.647,2.8748l4.4796,0.18764c-0.5583-0.30826-1.3465-0.62991-1.977-0.88457-0.86041-0.34846-0.91296-0.16753-2.3054-0.0201,0.0723-0.30826,0.33497-0.24795,1.0838-0.42217-0.31527-0.16753-1.6749-0.5495-1.6946-0.5629l-0.19704-0.21444c0.0919-0.0938,0.0263-0.10722,0.22988-0.0871,0.0657,0.007,0.25616,0.0804,0.34813,0.10722,2.069,0.67682,2.6601,0.94487,4.6239,1.7557-0.63055-0.48249-0.78162-0.65001-1.2611-1.2665-1.7997-2.2851-3.6912-1.5413-5.9769-1.4676z'/%3E %3Cpath d='m462.76,297.96,0.68591-1.2526c0.33687-0.70985-0.19813-0.73138,0.0421-1.6828,0.24265,0.0764,0.16864,0.0549,0.294,0.8722l0.82964-1.9014c0.23766,0.64116-1.0735,3.0748-1.3532,3.6661l-0.444,1.2283c1.0722-1.1934,2.3815-1.7523,2.5922-2.7486l0.15749-4.8021c-0.77047,0.63393-1.815,1.6641-2.3397,2.5085-0.7786,1.246-0.70848,2.3898-0.46454,4.1122z'/%3E %3Cpath d='m460.69,326.32c0.3941-0.17423,0.68965-0.40877,1.1429-0.58972,1.7668-0.48918,1.064,0.35516,2.1872-1.2062l-0.29557,0.83095c0.80131-0.26805,1.0115-0.76394,1.6026-1.3537,0.15107,0.29485-0.3087,0.79076-0.54515,1.0186-0.9918,0.97837-1.9967,0.66343-2.5813,0.89127l-1.1626,0.57629c1.3333-0.20774,1.1823,0.0335,2.2857,0.20103,2.2463,0.34176,2.8834-1.9032,3.6454-3.23l0.53201-0.93818c-1.2742,0.13402-2.8178,0.91136-3.8031,1.4608-0.7422,0.40878-0.98524,0.62991-1.5107,1.1191-0.20362,0.18763-0.44665,0.44226-0.68965,0.61651-0.33497,0.24794-0.59113,0.31495-0.80791,0.60311z'/%3E %3Cpath d='m460.53,314.42c0.78818-0.75054,0.61742-2.5062,1.202-3.565,0.11166-0.20104,0.19705-0.30825,0.32841-0.46909,0.21675-0.27475,0.13793-0.22114,0.42036-0.21444,0.092,0.20774-0.33496,0.42887-0.49919,0.80416l-0.35469,1.1325c0.0722-0.0536,0.046-0.0335,0.11822-0.10722,0.0591-0.067,0.0788-0.0938,0.11823-0.15412,0.55174-0.78403,1.0509-0.97837,1.8456-1.481l-0.76189-2.8346-1.3925,1.2062c-0.36782,0.32165-0.88671,0.93818-1.1823,1.4542-0.99179,1.749,0.0854,2.5732,0.15764,4.2284z'/%3E %3Cpath d='m460.12,326.06,1.8408-3.0163,0-1.4157c0.2789,0.0427,0.18129-0.10671,0.36259,0.83945,0.62057-0.91058,0.18826-0.80388,0.8925-1.2592,0.0488,0.27032-0.71818,1.6575-0.81581,1.7998-0.78094,1.0956-1.1575,1.7856-1.8338,2.9452,0.43929-0.17785,1.039-0.81812,1.3527-1.1098,0.26496-0.24186,0.41139-0.36992,0.69729-0.55489,0.26496-0.17073,0.54387-0.29878,0.79488-0.46239l0.78094-4.3182c-0.70425,0.29879-2.6008,1.6291-3.1517,2.3263-1.1505,1.4655-1.2133,1.9136-0.9204,4.2257z'/%3E %3Cpath d='m464.25,315.48,2.3974-0.22114c-0.0722,0.31496-0.4138,0.32166-1.0903,0.42217-1.0772,0.16754-3.0739,0.14743-4.2298,0.16754,0.33497,0.18763,0.66997,0.30155,1.0115,0.50258,0.34813,0.20773,0.59769,0.37525,0.95238,0.55619,0.75533,0.38868,1.6683,0.35516,2.4762,0.0469l3.1396-2.9217c-1.6486,0.38198-0.7422,0.44226-2.9688-0.007-0.34156,0.29485-0.4926,0.65673-1.2085,1.1392-0.1445,0.10052-0.34813,0.19434-0.47947,0.31496z'/%3E %3Cpath d='m447.21,309.68c0.67716,1.39,2.6569,3.0539,4.4394,2.835,0.79424-0.10153,0.93885-0.35331,1.4153-0.81956-0.10374-0.12129,0.0229-0.0241-0.13234-0.10467-0.0561-0.0274-0.14563-0.0523-0.20427-0.0598-1.3629-0.26811-1.5289-0.16088-2.9191-0.007l0.63067-0.32502c-0.36547-0.0938-0.72609-0.17351-1.0842-0.27315-0.56889-0.16025-0.4924-0.137-0.92934-0.44933,0.15884-0.15542,0.12118-0.11968,0.40194-0.0367,1.8194,0.58293,2.2475,0.5496,4.2281,0.8558-0.18868-0.59823-1.749-1.3441-2.5887-1.4577-1.3227-0.16841-1.7798,0.50971-3.2574-0.15804z'/%3E %3Cpath d='m458.96,325.63-0.60428-3.8734c0.31527,0.0871,0.22332,0.20774,0.37438,1.0186l0.68965,3.5114c0.0591-1.3335,0.51233-2.2851,0.11166-3.6588l-1.3793-2.647c-0.25616,0.6299-0.44005,2.4124-0.38751,3.163,0.0854,1.1794,0.32841,1.5346,0.94582,2.2449,0.11823,0.13402,0.11166,0.14072,0.24959,0.24124z'/%3E %3Cpath d='m464.21,286.08c0.19704-0.12062,0.35468-0.32836,0.53201-0.5495l0.57144-0.44227c0.0131,0.32836-0.45978,0.71032-0.77505,1.1057-0.45322,0.57629-0.73564,0.67013-0.95895,0.94488-0.88671,1.1191-0.79474,0.93148-2.2003,1.548,2.89,0.17423,4.4531-2.8748,5.6946-4.9521-2.7324,0.38868-2.2332,0.57629-2.4959,1.3604-0.11823,0.34176-0.28243,0.66343-0.36782,0.98507z'/%3E %3Cpath d='m465.15,298.29,0.78764-1.305c0.47418-0.6917,0.78108-0.20964,1.53-0.94183-0.20069-0.18287-0.14115-0.12612-0.96246,0.19675l1.3091-1.7857c-0.71906,0.12476-2.2609,2.6403-2.6565,3.2156l-0.89501,1.0687c0.52575-1.6296,0.33885-3.1375,1.145-3.8664l4.346-2.722c-0.17145,1.051-0.56138,2.5674-1.059,3.5047-0.73175,1.3869-1.8247,1.936-3.5449,2.6351z'/%3E %3Cpath d='m454.31,303.42c-0.23646-0.71701-1.1034-1.4608-1.248-1.8562l-0.62398-2.5197c0.34812,0.0402,0.34812,0.71032,0.4138,1.0052l0.33496,1.0789c0.21018-0.77063-0.13793-0.22784,0.34156-0.97167,0.23646,0.46909-0.28243,1.2531,0.0394,1.6887,0.32184,0.44227,0.34812,0.38199,0.85385,1.1392,0.289-1.1593,0.33497-2.6336-0.36782-3.431l-2.0164-2.2114c-0.51233,0.74384-0.46635,2.848-0.10509,3.9136,0.41379,1.1928,0.87357,1.3268,1.6289,1.7289,0.29557,0.15413,0.46634,0.30826,0.74876,0.43557z'/%3E %3Cpath d='m456.06,303.14c0.5141-0.67552,1.7082-1.1485,2.0067-1.5158l1.5866-2.4496c-0.38476-0.0848-0.63031,0.6275-0.80817,0.91685l-0.75141,1.0241c0.059-0.89618,0.2301-0.19164-0.007-1.158-0.42324,0.41196-0.15898,1.4355-0.66071,1.7806-0.50419,0.35218-0.51002,0.27846-1.3251,0.89803,0.11763-1.3382,0.60898-2.9221,1.6483-3.5124l2.9538-1.6117c0.272,0.9784-0.54793,3.1982-1.3224,4.1983-0.87697,1.1163-1.4148,1.0903-2.365,1.2409-0.37067,0.0555-0.60868,0.15678-0.95553,0.18862z'/%3E %3Cpath d='m461.37,303.44c0.78818-0.0402,2.936-0.0737,3.5928-0.42217l0.9064-0.42217c0,0.24125,0,0.11392-0.34156,0.46239,0.86702-0.0402,0.48604-0.10051,1.3202,0.0469-0.0985,0.17423,0.17077,0.14743-0.68966,0.20104-0.9655,0.067-1.4778,0.16753-2.3448,0.26135l-3.2053,0.32165c2.0493,0.74384,2.3843,1.8763,4.703,1.0119,1.8456-0.69023,2.2135-1.4408,3.3825-2.848-2.8834,0.67013-3.1921-1.7691-6.0164,0.0938-0.34156,0.22784-1.1034,0.99846-1.3071,1.2933z'/%3E %3Cpath d='m465.21,305.21c0.75532,0.0938,0.44005-0.0134,1.0706,0.28145-0.29557,0.25465-1.5501-0.0603-2.0493,0.0402l-2.069-0.0402c0.6634,0.91805,1.7734,1.3604,3.3432,1.1995,1.5435-0.16753,1.9442-0.56289,3.1856-1.3201l-2.3448-0.77063z'/%3E %3Cpath d='m464.35,318.67c-0.19704-0.19434-0.70936-0.44898-1.0312-0.56961-1.3071-0.49589-2.3317-0.0268-2.9952-0.0402l-1.491-0.17424c0.39409,0.43558,1.9967,1.032,2.7783,1.1593,2.0098,0.32837,0.65682,0.85776,2.739-0.37526z'/%3E %3Cpath d='m464.56,320.15,0.5977,0.5361c-0.15764,0.0804-0.37438-0.067-0.62397-0.18764l-0.11167,1.3603,2.7258-0.34176c-0.86044-1.0856-1.4122-1.6084-2.4368-2.5598-0.0788,0.42218-0.19704,0.73044-0.15106,1.1928z'/%3E %3Cpath d='m461.06,320.92,1.6289-1.233c-0.4138-0.32166-1.1691-0.30826-1.7406-0.48248l-1.5698-0.62992c0.37439,0.52269,0.38752,0.40208,0.83416,1.1727,0.24959,0.42887,0.4335,0.88455,0.84729,1.1727z'/%3E %3Cpath d='m468.95,296.79c-0.70787,0.41387-1.206,1.058-1.9973,1.3891-1.0686,0.43326-2.2098,0.005-2.8833,0.69183,1.8033-0.10364,2.9913,0.58413,4.3888-0.70566,0.85861-0.79106,1.6086-2.0125,2.3107-3.0233-0.28383-0.0183-1.2157,0.26667-1.4028,0.4579-0.0999,0.0993-0.23421,0.41524-0.33744,0.57515-0.321,0.51387-0.10467,0.13314-0.0788,0.61494z'/%3E %3Cpath d='m463,337.81,1.3136,2.6671,1.8128,2.2181c0.37438-0.17423,0.79474-0.47578,1.2217-0.69022l1.4581-0.51601c-0.81447-0.34846-0.85386-0.75054-1.3136-0.78403-1.1232-0.0737-0.46634,0.10722-1.9573-0.14742,0.13793-0.24125,0.0723-0.12732,0.84729-0.14073l0.94581-0.0268c-0.55174-0.50928-1.2348-0.86447-1.8522-1.3134l1.9442,0.99176-0.0591-1.2933c0.47291,0.0536,0.18391,0.78406,0.40067,1.5011,0.1051,0.32836,0.72908,0.74383,1.064,0.91135,0.64367,0.32166,0.88014,0.24794,1.5435,0.41547l1.5238,0.48249c-0.62398-0.88456-0.34156,0.11392-1.399-2.0707-0.42693-0.88456-0.8276-1.4207-1.5501-1.8696-1.7603-1.0923-3.9277-0.36185-5.9441-0.33506z'/%3E %3Cpath d='m465.21,335.19c0.0197-1.0722-0.0591-2.0506,0.0263-3.1429,0.0394-0.50928-0.19704-1.8227-0.28243-2.5732,0.24959,0.0737,0.21019,0.18764,0.2693,0.50258l0.19705,0.69692c0.24959-1.1258,0.3087-1.0923,0.91956-1.9032,0.0985,0.26135-0.60429,1.1392-0.72907,2.4191l-0.1248,3.1831c0.1248-0.14742,0.13793-0.20103,0.28243-0.36186,0.11166-0.12732,0.19705-0.21443,0.31527-0.34176,0.22332-0.22783,0.38095-0.44896,0.59769-0.78403,1.5238-2.3722,0.5977-3.7257,0.62398-4.4293l0.44006-2.2985c-0.47291,0.19433-1.7734,1.1392-2.069,1.4408-1.1757,1.1928-2.3383,3.2903-1.6026,5.0861,0.17077,0.42217,0.40723,0.77733,0.59112,1.1861,0.18392,0.41548,0.32841,0.95828,0.54515,1.3201z'/%3E %3Cpath d='m464.4,344.3c0.25616,0.16083,1.7274,0.63661,2.1084,0.75054,1.399,0.43557,3.5928,0.59642,4.565-0.70362,0.53201-0.71701,0.85385-0.90466,1.5238-1.4408-1.0378,0.0201-1.7537,0.41547-2.6601,0.62321-0.67652,0.15413-0.72251,0.62991-1.2742,1.1526l-0.51233,0.35516c0.007-0.33506,0.65024-0.96497,0.95238-1.3201l-2.0361-0.0201c0.0657-0.32836,0.61085-0.16753,1.5107-0.24794,1.7603-0.14743,2.0558-0.61651,3.9672-0.84434,0.1839-0.0201,0.21674-0.0268,0.37438-0.10722-2.8506-0.0134-3.4746-1.93-6.8902,0.49588z'/%3E %3Cpath d='m477.44,342.54,0-1.4274c-0.62398-0.47579-0.62398-0.62991-1.0049-1.3604,0.33497,0.0268,0.47291,0.56289,0.98524,0.92478-0.0525-0.68352-0.33497-1.8294-0.4926-2.5598,0.32841,0.0536,0.48603,0.96497,0.56487,1.2933,0.40067,1.6686,0.0525,2.9552,0.34812,3.4913l0.81447,1.099c0.27586-1.1593,1.4713-1.9098,0.046-4.7646-0.86702-1.7423-1.5698-2.0372-3.0279-3.1362,0.17734,0.79746,0.37438,1.0789,0.24959,2.0573-0.0919,0.68353-0.36125,1.1995-0.44005,1.8696-0.18391,1.5413,0.289,1.4542,0.59113,1.6284,0.51232,0.28814,0.98523,0.59641,1.3662,0.88456z'/%3E %3Cpath d='m463.33,339.83-0.43349-0.95828c-1.202,0.0201-1.5567,0.50928-3.2316-0.61651-0.44005-0.29485-0.36781-0.26135-0.61085-0.72371l1.8522,1.0387c-0.0985-0.20774-0.32185-0.42217-0.68966-1.1794,0.0591-0.0402-0.0394-0.12732,0.17077-0.007,0.0854,0.0469,0.11823,0.11391,0.15764,0.16752l0.89984,1.1928,1.2348-0.13403c-0.0263-0.20773-0.23646-0.5562-0.32841-0.77063-0.17734-0.41547-0.092-0.48249-0.40724-0.71032-0.4138-0.30155-0.92612-0.59641-1.5567-0.65673-0.77505-0.0737-1.2348,0.19434-1.9376,0.24795l-1.8916-0.39538c0.0854,0.36855,0.79474,1.548,0.9918,1.8294,0.8013,1.1258,2.9228,2.7676,4.7224,2.064,0.26273-0.10052,0.83416-0.26805,1.0575-0.38868z'/%3E %3Cpath d='m453.48,331.06,0.0985,0.0536c0.0919,0.0469,0.0591,0.0335,0.1445,0.067,0.53858,0.22114,1.0115,0.46909,1.3925,0.90465,0.48603,0.5495,0.51888,0.81755,1.2611,1.4341,1.1954,0.99849,2.4894,0.96497,4.0854,1.1727-0.1445-0.22114-0.53858-0.67682-0.72907-0.87116-1.2742-1.3604-1.0443-1.2866-1.8588-1.1727l-1.3334,0.10722c0.0591-0.27475,0.86042-0.32836,1.445-0.4557-0.29556-0.12732-0.53201-0.21444-0.86041-0.27475-0.66997-0.12062-0.19705,0.0536-0.96551-0.23454,0.34812-0.46909,2.069,0.14743,2.8637,0.89126,0.59113,0.54281,1.3268,1.4139,1.8916,2.0774l-0.92613-1.997c-0.94581-1.7222-3.4484-2.3387-5.2874-2.0104-0.29557,0.0469-0.96551,0.15413-1.2217,0.30826z'/%3E %3Cpath d='m464.61,335.62c-0.6634-2.1042-1.7471-2.9954-2.0427-4.2753-0.19705-0.87117-0.1248-0.95158,0.0328-1.7423,0.42692,0.58299-0.36126,0.98507,0.8867,3.0759-0.0722-0.67683-0.24302-0.97837-0.12479-1.7959,0.0525-0.32836,0.45321-1.5815,0.44665-1.615-0.0591-0.34176-1.5698-1.7289-1.9836-2.1645-0.21675,1.8562-0.69622,3.5114-0.092,5.361,0.62398,1.9166,1.6486,1.4676,2.8769,3.1563z'/%3E %3Cpath d='m474.66,345.09,1.3268-0.35516c-0.19704-0.16083-0.66339-0.76393-0.86041-1.0588-0.578-0.84434-0.51233-0.91805-0.28244-1.3402,0.0722,0.12732,0.0197,0.0134,0.0525,0.17423,0.0328,0.22784-0.0197,0.29485,0.1445,0.58299,0.1248,0.21444,0.21675,0.34176,0.38095,0.5495,0.32841,0.43556,0.54514,0.69022,0.95238,1.0052-0.0263-0.66343-0.15108-0.98507,0.0328-1.3804,0.24959,0.0938,0.0854-0.0737,0.17734,0.18094l0.0788,1.1392,1.4713-0.38868c-0.9918-1.749-2.8966-2.3789-4.637-3.0692,0.15764,0.67683,0.31528,1.3804,0.47948,2.0573,0.18391,0.78403,0.40067,1.233,0.68309,1.9032z'/%3E %3Cpath d='m472.33,341.31c-0.15763-0.39538-0.44005-0.81755-0.65683-1.2732-0.47291-1.0253-0.40067-1.4944-1.353-2.4794-0.16421-0.16753-0.29557-0.33507-0.4926-0.48919-0.0985-0.0737-0.35469-0.22783-0.39411-0.32835-0.007-0.007-0.0131-0.0268-0.0131-0.0402l0.0131-0.14072c0.32841-0.067,0.98523,0.69022,1.1888,0.89126,0.57144,0.5495,1.8851,3.3305,2.3252,4.1882-0.0591-0.38199-0.25616-0.83765-0.1248-1.2062,0.38094-1.099-0.67653-2.7944-1.1954-3.1429l-4.1182-1.8227c0.4926,0.46909,0.78161,0.73714,1.1231,1.4944,0.2693,0.60312,0.39411,0.0804,1.4647,1.2263,1.1363,1.1995,1.0444,2.6939,2.2332,3.1228z'/%3E %3Cpath d='m479.89,341.3c0.0722-0.19433,0.1445-0.39538,0.21675-0.60981,0.13136-0.37529,0.0263-0.22114,0.34153-0.52941,0.15764,0.24795,0,0.38199-0.17077,0.90466-0.33497,0.9985-0.55174,1.8361-0.83416,2.8547,0.91299-0.12062,0.87358-0.14073,1.2611-0.82425,0.23645-0.41547,0.42036-0.99846,0.51232-1.5346l-0.11166-3.8734-1.1888,1.548c-0.61741,0.89126-0.22989,0.40877-0.0263,2.064z'/%3E %3Cpath d='m467.51,332.51c0.29557-0.16753,0.98524-0.99846,1.2808-1.3268,0.17078,0.31496-0.62398,1.1392-0.79474,1.3134-0.66996,0.63661-0.24959,0-1.1232,1.0454,1.7668,0.26135,2.4959-2.0707,3.0674-3.2635-0.34813,0.0201-1.4713,0.38869-1.7471,0.5562-0.23646,0.13402-0.16421,0.067-0.22989,0.36856-0.046,0.18763-0.0591,0.27475-0.1248,0.46909-0.092,0.28814-0.21675,0.56289-0.32841,0.83764z'/%3E %3C/g%3E %3Cg fill='%23ce1126' stroke='%23000'%3E %3Cpath stroke-width='0.2662' d='m483.96,354.64,2.2214,1.1526-1.2645,2.4922c0.92274-0.15578,4.272-1.3084,5.3657-1.6511-0.2734-0.77884-0.37592-0.87231-0.2734-1.838l-0.37593-1.7757-2.6999,0.90341c-1.0253,0.31153-1.8797,0.52961-2.9733,0.71652z'/%3E %3Cpath stroke-width='0.2662' d='m513.11,354.25-2.2214,1.1526,1.2645,2.4922c-0.92274-0.15578-4.272-1.3084-5.3657-1.6511,0.2734-0.77884,0.37592-0.87231,0.2734-1.838l0.37593-1.7757,2.6999,0.90342c1.0253,0.31152,1.8797,0.5296,2.9733,0.71651z'/%3E %3Cpath stroke-width='0.271' d='m492.02,358.17c2.4991-0.35282,4.7338-1.6759,4.7338-1.6759,0.38222,0.41162,2.3815,0.1176,2.3815,0.1176,0.91146-0.17641,1.3231-0.32342,1.3231-0.32342,2.4991,1.5877,4.4103,1.8229,4.4103,1.8229,2.2051-0.11761,2.2639-1.8229,2.2639-1.8229-0.0882-1.4995-0.23522-1.5583-0.23522-1.5583,1.1761-1.8523-0.0882-3.3224-0.0882-3.3224-0.58805-0.67622-3.9987,0.41162-3.9987,0.41162-2.2933,1.0878-2.4404,0.61742-2.4404,0.61742-0.65081-1.0204-3.0453-0.83992-4.0868-0.0588-2.5285-0.55864-2.8814-0.73503-2.8814-0.73503-2.558-0.97027-2.9696-0.38222-2.9696-0.38222-0.91145,1.0879-0.61741,2.2345-0.61741,2.2345,0,0.64682,0.20579,1.2055,0.20579,1.2055-0.55861,3.293,1.9993,3.4695,1.9993,3.4695z'/%3E %3Cpath stroke-width='0.2153' d='m500.45,355.39c5.4983,1.2366,5.1088,2.021,5.1088,2.021-0.33377,0.57502-1.9475-0.16399-1.9475-0.16399-4.29-1.5018-3.1613-1.857-3.1613-1.857z'/%3E %3Cpath stroke-width='0.2153' d='m497.04,355.41c-5.4983,1.2366-5.1088,2.021-5.1088,2.021,0.33376,0.57502,1.9475-0.16399,1.9475-0.16399,4.29-1.5018,3.1613-1.857,3.1613-1.857z'/%3E %3Cpath fill='%23aa241e' stroke-width='0.2008' d='m497.27,351.68c-2.3624,0.41973-0.49736,2.1826-0.41447,3.2738,0,0.58761-0.58021,1.595,0.0414,1.8468,0.58025,0.25184,1.8236-0.042,2.4867-0.042,0.9118-0.042,1.5335,0.042,1.4092-1.1333-0.0829-0.88142-0.37301-1.1752-0.37301-2.3085-0.0414-0.79745,0.12432-1.6789-0.74601-1.7628-0.53879-0.042-1.865,0.042-2.4038,0.12593z'/%3E %3Cpath fill='none' stroke-width='0.2167' d='m500.53,352.99c6.2702-0.031,5.8086-1.0336,5.8086-1.0336'/%3E %3Cpath fill='none' stroke-width='0.2167' d='m500.64,354.9c6.2079,0.83282,5.3701,1.7375,5.3701,1.7375'/%3E %3Cpath fill='none' stroke-width='0.2106' d='m496.75,354.72c-5.7825,1.2847-5.2624,2.2019-5.2624,2.2019'/%3E %3Cpath fill='none' stroke-width='0.2106' d='m496.11,352.86c-5.9079,0.42803-5.3141-0.57567-5.3141-0.57567'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23000' d='m473.93,345.8c-3.1233,1.0261-5.1969,1.7416-8.1833,3.492-1.1394-1.7118-2.6932-4.2452-3.7981-5.7174-0.6215-0.78741-1.4847-1.6433-2.5551-2.191-1.6919-0.78741-2.3134-0.54776-3.3838,0.37659l-0.75961-1.4378c-1.5193-2.6703-3.1075-3.9029-4.7994-6.0596l-1.5193-1.7802c-0.20717-0.23965-0.27622-0.41082-0.55244-0.54776,0.65455,2.1483,1.1284,4.2027,1.5538,6.5389-0.93225-0.51353-1.7954-1.027-2.7623-1.4379-0.72509-0.27387-2.5896-0.68469-3.4873-0.58198l1.1049,0.9928c1.8991,1.6775,3.1421,3.9029,3.9016,6.4019,0.82867,2.7046,2.7623,5.5804,4.7994,7.566,0.41434,0.41082,1.5883,1.4721,2.3479,1.746,2.2789,0.82163,2.1753-0.0342,3.004-0.44505,1.7528,2.9686,2.8824,4.4562,4.903,6.71,2.1753,2.2937,5.5934,2.91,8.7013,2.191,1.3811-0.34236,2.2443-0.71892,3.3147-1.3352,4.0399-2.328,2.1062-4.1423,1.6228-5.991,1.3121-0.41082,6.4501-1.9651,8.2974-2.307,6.506-1.204,18.564-1.3626,26.276-0.23964,0.69089,0.1006,8.4669,2.1712,9.2264,2.6162-0.54825,1.2883-0.76596,1.9277-0.68785,3.3426,0.13166,1.3111,1.2566,1.9969,2.258,2.5788,1.0704,0.61624,1.9336,0.9928,3.3147,1.3352,1.3466,0.30811,2.7968,0.37659,4.1778,0.17117,2.9004-0.47931,4.4196-2.1568,5.6628-3.6631,2.0663-2.3573,2.7078-3.7865,3.7636-5.4434,0,0,0.58842,0.54775,1.0073,0.68443,0.39491,0.12884,1.6859-0.10243,2.0312-0.23938,1.0013-0.37659,1.6228-1.1297,2.3134-1.7802,2.1408-2.0541,3.9364-4.7244,4.7994-7.6343,1.0358-3.4236,2.4515-5.0325,4.9722-7.2579-3.2564,0.11082-4.3815,0.99673-6.2152,2.0199l0.69055-3.355c0.20717-0.92435,0.72509-2.2937,0.82867-3.1838-1.4811,1.5773-2.7963,3.2273-4.1089,4.6902-0.6215,0.82163-1.3121,1.5063-1.9336,2.3964-1.3064,2.0152-1.0571,2.0774-1.5538,2.7388-4.5837-2.546-6.6427,3.6564-9.7371,7.4632-5.745-3.2298-10.748-4.2425-17.506-5.4776-1.5144-0.1592-2.8658-0.37659-4.1088-0.51353-8.494-0.9928-17.851-0.95857-26.311,0.30812-4.3675,0.55322-7.0688,1.355-10.91,2.2596z'/%3E %3Cg fill='%23ce1126'%3E %3Cpath d='m468.02,359.01c0.52703-1.5062,1.1845-1.8325,2.4861-2.4649,4.1778-1.9172,6.2495-2.7046,11.014-3.9712,2.5896-0.6847,5.6628-1.2667,8.3905-1.5748,1.4585-0.23639,1.8118-0.25227,4.3851-0.41083,3.7981-0.2054,6.008-0.2054,9.8061,0,1.647,0.0173,3.0526,0.19254,4.3851,0.41083,2.8313,0.34237,5.8352,0.85586,8.494,1.5748,4.2817,1.0955,7.1129,2.1226,10.98,3.937,1.761,0.82164,1.5193,0.85587,2.5206,2.4649,1.2775-0.85586,2.2098-2.7046,2.9349-3.937,0.37981-0.65047,0.93229-1.5406,1.174-2.2937,0.41434-1.2667-0.3798-1.6775-0.96678-2.1568-2.1408-1.8487-6.146-3.4578-9.5643-4.4163-14.675-4.074-34.873-4.2452-49.515-0.0342-3.5563,1.0271-7.1819,2.4649-9.5298,4.348-0.31075,0.23964-0.6215,0.51353-0.89772,0.82164-0.82867,0.95857,0.5352,2.8586,0.96681,3.6631,0.43162,0.80452,0.80456,1.5914,1.243,2.191,0.53196,0.72633,1.181,1.3492,1.6934,1.8485z'/%3E %3Cpath d='m453.52,345.94c1.6574,0.30811,2.2443,0.78738,3.3147,2.2253,2.3824,3.2866,2.486,5.6145,6.5259,10.065,0.93223,1.0271,1.6228,1.8487,3.0385,2.4649,1.4847,0.65046,3.0385,0.85587,4.7994,0.61622,1.6574-0.2054,2.9004-0.65045,4.1434-1.3694,0,0,1.4879-0.8558,1.8792-1.3808,0.39132-0.52493,0.46871-1.7689,0.46871-1.7689-1.2085-0.37658-3.3838,1.9857-4.7994,2.91-2.5896,1.7118-3.5909,1.0955-5.4209-0.51352-1.5883-1.3694-2.1753-2.8415-3.2111-4.6217-0.41434-0.71895-1.174-1.8144-0.89777-2.9442l1.9336-1.9856c-0.76386-1.2564-1.7204-2.6541-2.417-3.7317-0.96678-1.4721-1.5193-2.4649-2.7622-3.4235-0.72506-0.582-2.1753-1.4379-3.2111-0.82166-0.86731,0.67869-1.4918,1.477-2.2444,2.3964-0.41434,0.47929-0.89777,1.164-1.1394,1.883z'/%3E %3Cpath d='m450.76,339.63c-0.37981-0.13694-1.7609-1.1982-2.4861-1.5063l-3.0385-1.0271c0.41434,0.51352,0.82869,0.82166,1.6574,1.8487,1.9336,2.4649,1.9336,4.4506,3.4528,7.3947,0.51792,0.9928,1.4157,2.2937,2.1753,3.1839,0.51792,0.65046,2.2677,2.3183,2.7278,2.7045,1.0607,0.88202,2.1723,1.0074,2.7716,0.27609,0.13649-0.51939-1.2523-1.4401-2.0119-1.8167-0.93224-0.51352-1.7609-1.0613-2.417-1.6775-1.7955-1.8145-0.41434-4.0397,0.96678-5.6145l0.93224-1.0955c0.2063-0.74346-1.3022-2.8471-2.1062-3.9028-0.82868-0.99279-2.9349-3.355-3.8672-4.4163,0.13811,0.85587,0.41434,2.0199,0.58698,2.91,0.13811,0.61623,0.6215,2.2595,0.65604,2.7388z'/%3E %3Cpath d='m477.59,356.24-0.72506-1.7118c-1.0013,0.10271-5.9044,2.2595-7.0438,2.9784-0.34528,0.20541-1.7264,1.3009-1.0704,1.9857,1.8991,2.0541,4.7649-0.95859,6.4568-2.2595,0.58698-0.47929,1.3466-1.0271,2.3824-0.99279z'/%3E %3Cpath d='m458.63,352.28c-0.31075-0.1027-0.24169-0.71895-1.3466-1.5405-0.41434-0.34235-2.9132-1.643-3.342-2.122,0,0-0.81755-0.58445-0.72031-1.4251,0.0746-0.64519,0.60951-0.76652,0.60951-0.76652,2.2443,0.0685,4.903,5.5803,4.7994,5.8542z'/%3E %3Cpath d='m545.04,346.04c-1.6574,0.30811-2.2443,0.78738-3.3147,2.2253-2.3824,3.2866-2.486,5.6145-6.5259,10.065-0.93223,1.0271-1.6228,1.8487-3.0385,2.4649-1.4847,0.65046-3.0385,0.85587-4.7994,0.61622-1.6574-0.2054-2.9004-0.65045-4.1434-1.3694,0,0-1.4879-0.8558-1.8792-1.3808-0.39132-0.52493-0.46871-1.7689-0.46871-1.7689,1.2085-0.37658,3.3838,1.9857,4.7994,2.91,2.5896,1.7118,3.5909,1.0955,5.4209-0.51352,1.5883-1.3694,2.1753-2.8415,3.2111-4.6217,0.41434-0.71895,1.174-1.8144,0.89777-2.9442l-1.9336-1.9856c0.76386-1.2564,1.7204-2.6541,2.417-3.7317,0.96678-1.4721,1.5193-2.4649,2.7622-3.4235,0.72506-0.582,2.1753-1.4379,3.2111-0.82166,0.86731,0.67869,1.4918,1.477,2.2444,2.3964,0.41434,0.47929,0.89777,1.164,1.1394,1.883z'/%3E %3Cpath d='m547.81,339.74c0.37981-0.13694,1.7609-1.1982,2.4861-1.5063l3.0385-1.0271c-0.41434,0.51352-0.82869,0.82166-1.6574,1.8487-1.9336,2.4649-1.9336,4.4506-3.4528,7.3947-0.51792,0.9928-1.4157,2.2937-2.1753,3.1839-0.51792,0.65046-2.2677,2.3183-2.7278,2.7045-1.0607,0.88202-2.4374,0.87482-2.7716,0.27609-0.13649-0.51939,1.2523-1.4401,2.0119-1.8167,0.93224-0.51352,1.7609-1.0613,2.417-1.6775,1.7955-1.8145,0.41434-4.0397-0.96678-5.6145l-0.93224-1.0955c0.27983-1.4064,1.3022-2.8471,2.1062-3.9028,0.82868-0.99279,2.9349-3.355,3.8672-4.4163-0.13811,0.85587-0.41434,2.0199-0.58698,2.91-0.22386,0.91247-0.45374,1.8322-0.656,2.7388z'/%3E %3Cpath d='m520.98,356.35,0.72506-1.7118c1.0013,0.10271,5.9044,2.2595,7.0438,2.9784,0.34528,0.20541,1.7264,1.3009,1.0704,1.9857-1.8991,2.0541-4.7649-0.95859-6.4568-2.2595-0.58698-0.47929-1.3466-1.0271-2.3824-0.99279z'/%3E %3Cpath d='m539.94,352.38c0.31075-0.1027,0.24169-0.71895,1.3466-1.5405,0.41434-0.34235,2.9132-1.643,3.342-2.122,0,0,0.81755-0.58445,0.72031-1.4251-0.0746-0.64519-0.60951-0.76652-0.60951-0.76652-2.2443,0.0685-4.903,5.5803-4.7994,5.8542z'/%3E %3C/g%3E %3Cg fill='%23eac102'%3E %3Cpath d='m473.14,349.1c-0.24453,0.001-0.48146,0.089-0.7138,0.15328-0.35355,0.1448-0.70007,0.30774-1.0582,0.44046-0.14625,0.039-0.17866,0.20472-0.00042,0.22218,0.19806,0.15826,0.14739,0.44382,0.25478,0.65293,0.0677,0.24133,0.12509,0.48516,0.20417,0.7233,0.0732,0.30654,0.18124,0.60552,0.23704,0.91687,0.082,0.30128,0.18441,0.59978,0.23172,0.90873,0.0214,0.13362-0.25208,0.41238,0.0166,0.32853,0.27035-0.0615,0.50385-0.2403,0.7848-0.26222,0.10721-0.005,0.29569-0.18554,0.082-0.18806-0.24941-0.13137-0.16508-0.46907-0.29422-0.6835-0.0573-0.22726-0.13282-0.45195-0.17713-0.68129,0.0616-0.26466,0.41345-0.0846,0.4379,0.12533,0.14263,0.1921,0.32491,0.35931,0.50994,0.51283,0.22695,0.16089,0.44601,0.35394,0.7294,0.40473,0.20319,0.0455,0.42297,0.0355,0.61384-0.0521-0.27349-0.24158-0.59741-0.43435-0.8085-0.73948-0.17957-0.24218-0.33233-0.50286-0.50367-0.75081,0.26463-0.24559,0.51025-0.55153,0.56415-0.91906,0.0243-0.38974-0.17336-0.79768-0.51699-0.9915-0.18618-0.0772-0.39063-0.12677-0.59338-0.12114zm-0.32702,0.3434c0.21592,0.004,0.38962,0.15178,0.49477,0.32965,0.12066,0.22233,0.19602,0.48305,0.17549,0.73775-0.018,0.22586-0.15764,0.43049-0.36276,0.52733-0.15682,0.12326-0.55642,0.38634-0.57723,0.0327-0.10586-0.39295-0.24092-0.78004-0.31114-1.1813-0.0592-0.24642,0.19753-0.34566,0.38535-0.39956,0.0637-0.021,0.12894-0.0379,0.19552-0.0466z'/%3E %3Cpath d='m474.51,348.55c0.0328,0.18774,0.27919,0.27044,0.24817,0.48791,0.0505,0.2892,0.12302,0.57383,0.19864,0.85697,0.0214,0.26271,0.1097,0.51163,0.14581,0.77197,0.0403,0.18489,0.10309,0.36309,0.12861,0.55153,0.0449,0.25643,0.12112,0.50707,0.15632,0.76455,0.0505,0.11128-0.25305,0.34821-0.0391,0.33406,0.70395-0.19799,1.4185-0.36607,2.1213-0.56976,0.18593,0.0292,0.24204-0.10973,0.20651-0.26837,0.002-0.21391,0.003-0.42783,0.004-0.64174-0.21718-0.00069-0.20706,0.29685-0.37129,0.39089-0.25164,0.26931-0.60633,0.402-0.95178,0.50101-0.19883,0.0268-0.29871-0.17085-0.32608-0.33564-0.0673-0.16333-0.0433-0.34234-0.1041-0.50679-0.0609-0.2463-0.0998-0.49749-0.15266-0.74562,0.25217-0.10369,0.5365-0.16101,0.80683-0.10843,0.13572,0.009,0.25104,0.27418,0.36816,0.14357-0.00079-0.22166-0.0897-0.43682-0.12848-0.65502-0.046-0.0909-0.0683-0.43206-0.21201-0.33362-0.0725,0.14764-0.0942,0.3519-0.27917,0.40595-0.18308,0.0903-0.3721,0.1723-0.57782,0.1927-0.12984-0.13321-0.13108-0.422-0.15928-0.62456,0.0172-0.21804-0.13235-0.54857,0.17423-0.59697,0.29446-0.16062,0.67504-0.15752,0.95185,0.0393,0.1037,0.0759,0.34219,0.30783,0.35353,0.0473-0.13055-0.20766-0.13982-0.50047-0.3043-0.67633-0.19694-0.0274-0.37298,0.0971-0.56425,0.1235-0.56946,0.13123-1.1316,0.29863-1.6935,0.4517z'/%3E %3Cpath d='m479.22,347.26c-0.28589,0.0186-0.56593,0.0886-0.84496,0.14919-0.30613,0.0912-0.61034,0.18949-0.91552,0.28313-0.23532,0.13119,0.23292,0.22524,0.21055,0.41371,0.0334,0.19951,0.0639,0.40279,0.1151,0.59733,0.036,0.20334,0.0913,0.40282,0.11131,0.6088,0.0726,0.29416,0.12063,0.59424,0.18073,0.89069,0.0219,0.27817,0.14536,0.5387,0.14724,0.82011,0.0516,0.17722-0.0442,0.36483-0.0935,0.50081,0.3005-0.0735,0.6063-0.135,0.90248-0.22819,0.15689,0.013,0.22919-0.20422,0.0449-0.21717-0.13168-0.19608-0.13188-0.44668-0.19433-0.66844-0.0395-0.23778-0.0955-0.47236-0.14256-0.70867,0.42204-0.10019,0.85237-0.23519,1.1999-0.50263,0.23198-0.1995,0.42255-0.47199,0.42529-0.78878,0.0187-0.28434-0.071-0.57208-0.23211-0.80506-0.11344-0.13033-0.26954-0.22538-0.42471-0.29437-0.15918-0.0446-0.32594-0.0448-0.48984-0.0505zm0.52455,0.0551-0.0001,0.0001,0.0001-0.0001zm-0.85685,0.2743c0.26112,0.002,0.50366,0.18045,0.58455,0.4286,0.0981,0.24039,0.14464,0.51166,0.10189,0.76824-0.0471,0.17093-0.14369,0.33827-0.32124,0.39792-0.17401,0.0727-0.33371,0.23881-0.53545,0.20091-0.11989-0.11546-0.0358-0.34287-0.12867-0.49709-0.0707-0.30527-0.1087-0.61906-0.19955-0.91899-0.0381-0.18493,0.12129-0.3262,0.28974-0.35478,0.0682-0.0168,0.13867-0.023,0.20873-0.0248z'/%3E %3Cpath d='m482.7,346.54c0.11554,0.10637,0.23279,0.20828,0.30655,0.35058,0.10712,0.14445,0.0741,0.33407,0.13001,0.49752,0.0705,0.2424,0.0639,0.49685,0.12744,0.74065,0.0418,0.20257,0.0846,0.40699,0.0846,0.61478,0.0869,0.25369,0.0809,0.52952,0.0687,0.79378-0.0571,0.37964-0.46002,0.67043-0.83924,0.58969-0.17831-0.0214-0.32309-0.14707-0.39635-0.30693-0.12145-0.14766-0.16208-0.33342-0.19916-0.5156-0.0447-0.26535-0.10078-0.52817-0.13476-0.79528-0.0307-0.26923-0.0791-0.53512-0.1121-0.8033-0.033-0.21601-0.089-0.42725-0.12069-0.64257-0.0419-0.11776,0.27091-0.37407,0.0248-0.33282-0.31241,0.0312-0.61495,0.12327-0.92467,0.16825-0.22998,0.15365,0.16948,0.2117,0.15753,0.39702,0.0411,0.18784,0.0275,0.38411,0.0733,0.5724,0.0695,0.40851,0.16879,0.81283,0.19971,1.227,0.0269,0.19086,0.0868,0.37247,0.0972,0.56465,0.0471,0.19414,0.16212,0.36102,0.2679,0.52723,0.18025,0.16669,0.38913,0.32733,0.64413,0.34161,0.44225,0.0767,0.93508-0.0261,1.2502-0.36226,0.12972-0.16341,0.24216-0.35686,0.27638-0.56373,0.0107-0.29905,0.0127-0.60314-0.0672-0.8938-0.0298-0.29962-0.0324-0.6065-0.12891-0.89446-0.031-0.24978-0.0772-0.49758-0.10015-0.74839-0.0384-0.0616-0.058-0.25831-0.0173-0.37046-0.01-0.12877,0.22402-0.24851,0.11664-0.34374-0.19217-0.008-0.37478,0.0771-0.56769,0.0753-0.083,0.007-0.17298,0.0365-0.21679,0.11292z'/%3E %3Cpath d='m485.72,345.97c-0.41609-0.012-0.82533,0.0869-1.233,0.15203-0.1676,0.0667-0.4404,0.0482-0.53906,0.18505,0.11891,0.12734,0.25982,0.24676,0.23661,0.44369,0.0839,0.42355,0.1174,0.85472,0.19541,1.2792,0.003,0.26772,0.0966,0.52448,0.10408,0.79243,0.0256,0.31183,0.0751,0.6257,0.0674,0.93783,0.0123,0.1089-0.22318,0.3579-0.00085,0.30829,0.16915-0.07,0.34872-0.0291,0.52291-0.0912,0.22789-0.055,0.46126-0.0813,0.69347-0.1031,0.27937-0.0478,0.55965-0.10636,0.82512-0.20684,0.13971-0.10355,0.28355-0.21927,0.39969-0.3534,0.12168-0.12136,0.17762-0.28773,0.17956-0.4573,0.0215-0.28928-0.0254-0.63013-0.26567-0.82162-0.15303-0.12645-0.34717-0.17393-0.53134-0.24098-0.13272-0.035-0.2976-0.15208-0.0879-0.21113,0.21736-0.12698,0.40945-0.3161,0.47331-0.56658,0.0708-0.23406,0.0134-0.49905-0.1492-0.68165-0.089-0.21657-0.31862-0.28833-0.52919-0.32845-0.11894-0.0234-0.24069-0.0326-0.36131-0.0363zm-0.56,0.31c0.26631-0.0613,0.57215,0.0326,0.71896,0.27276,0.14358,0.1911,0.0924,0.44589,0.0696,0.66576-0.009,0.24824-0.26933,0.32881-0.45966,0.40907-0.13842,0.0832-0.48944,0.1893-0.44754-0.0892,0.0425-0.1918-0.0339-0.3734-0.0516-0.56224-0.02-0.17793-0.0212-0.35727-0.0197-0.5361,0.0633-0.0533,0.12675-0.10671,0.18997-0.16zm0.31,1.69c0.21044-0.0112,0.46557-0.0202,0.60779,0.16587,0.1985,0.17009,0.25604,0.43774,0.25456,0.68767-0.007,0.20276,0.003,0.44774-0.18257,0.57993-0.19035,0.12552-0.42924,0.22991-0.66118,0.1959-0.21631-0.0991-0.20056-0.39254-0.23136-0.59528-0.0276-0.20619-0.0826-0.41033-0.0955-0.61983-0.0524-0.15074-0.0922-0.43362,0.15385-0.38589,0.0503-0.0148,0.10192-0.0271,0.15442-0.0284z'/%3E %3Cpath d='m487.39,345.62c-0.0231,0.15181,0.21746,0.16609,0.21035,0.34234,0.0319,0.21041,0.001,0.42729,0.0679,0.63305,0.0315,0.2049,0.00063,0.41791,0.0519,0.61894,0.0655,0.24817-0.006,0.51713,0.0864,0.76186,0.0477,0.25328-0.0222,0.51815,0.0662,0.76598,0.0583,0.22516,0.0312,0.4899-0.13618,0.66288-0.0768,0.12833,0.20518,0.0734,0.28515,0.0435,0.3033-0.0235,0.60798-0.0344,0.90907-0.0821,0.17585-0.0185,0.35232-0.028,0.52376-0.0718,0.20472-0.0206,0.40943-0.0413,0.61415-0.0619,0.0623-0.25429,0.0969-0.5143,0.10469-0.77629,0.0173-0.0944,0.0262-0.25122-0.10214-0.16484-0.0612,0.16603-0.18004,0.30505-0.28033,0.44806-0.0991,0.074-0.20671,0.14534-0.33067,0.17033-0.1474,0.0429-0.29335,0.0991-0.45029,0.0854-0.17038,0.0425-0.35527-0.0262-0.36162-0.22499-0.0514-0.24167-0.0229-0.49263-0.0825-0.73292-0.0577-0.46546-0.0752-0.93477-0.10721-1.4021-0.0335-0.2804-0.0934-0.56377-0.0584-0.84672,0.0163-0.11537,0.31416-0.34188,0.059-0.29807-0.14434,0.0359-0.29139,0.0567-0.44086,0.0535-0.15918,0.0168-0.31456,0.0644-0.47661,0.06-0.0508,0.002-0.10275,0.006-0.15184,0.0159z'/%3E %3Cpath d='m490.3,345.3c-0.0352,0.13753,0.16091,0.0702,0.183,0.21759,0.0808,0.15036,0.008,0.33121,0.0774,0.48657,0.0274,0.18196,0.0308,0.36775,0.0481,0.55142,0.0446,0.58993,0.0893,1.1799,0.13388,1.7698,0.0505,0.14787,0.0466,0.3041,0.0446,0.45865,0.0226,0.13064-0.18725,0.23604-0.15636,0.33092,0.37388-0.009,0.75032-0.0242,1.1161-0.1081,0.11874-0.02-0.003-0.16246-0.0809-0.16409-0.11045-0.1214-0.10206-0.30208-0.1232-0.45581-0.0214-0.28099-0.0234-0.56467-0.0805-0.84155-0.0256-0.21909,0.0101-0.44252-0.0439-0.65835-0.0515-0.30498-0.0115-0.61878-0.0867-0.92057-0.02-0.19429-0.0635-0.40092,0.002-0.59043,0.0293-0.0703,0.25086-0.23262,0.0675-0.21597-0.34909,0.0177-0.70035,0.0438-1.0424,0.11836-0.0199,0.006-0.0402,0.0115-0.0585,0.0216z'/%3E %3Cpath d='m494.92,347.69c-0.20206-0.0201-0.27501,0.18735-0.38845,0.3129-0.12105,0.19337-0.34187,0.27657-0.55453,0.32333-0.24136,0.0627-0.4554-0.11825-0.62331-0.26675-0.14283-0.18582-0.24834-0.39937-0.31299-0.62437-0.0774-0.20252-0.0928-0.41912-0.14424-0.62771-0.0464-0.31258-0.0318-0.63331,0.00014-0.94562,0.0715-0.2178,0.14762-0.46376,0.33485-0.60983,0.24283-0.1493,0.57207-0.076,0.75809,0.1314,0.17442,0.1391,0.23102,0.35456,0.32467,0.54464,0.14041,0.21766,0.21299-0.10169,0.2184-0.22376,0.024-0.15409,0.12367-0.31698,0.0837-0.46915-0.12986-0.15963-0.34179-0.22315-0.53051-0.2851-0.44875-0.13047-0.97457-0.0568-1.3221,0.27138-0.14104,0.0997-0.23827,0.24021-0.32341,0.38749-0.10715,0.13357-0.15722,0.29351-0.20228,0.45562-0.0785,0.20712-0.0858,0.43095-0.12726,0.647-0.0358,0.47296,0.0808,0.94702,0.25842,1.3828,0.12669,0.21861,0.32316,0.38566,0.47714,0.58459,0.14261,0.19146,0.39679,0.24305,0.62067,0.27054,0.28157,0.026,0.57422-0.0351,0.80223-0.2078,0.20521-0.1307,0.34669-0.3321,0.4598-0.54301,0.0994-0.14624,0.15557-0.27517,0.18856-0.44762,0.004-0.0172,0.008-0.0435,0.002-0.0609z'/%3E %3Cpath d='m496.52,344.77c-0.16624,0.038-0.39694-0.0183-0.52412,0.0598-0.0383,0.29157-0.1131,0.57718-0.16779,0.86555-0.0445,0.20001-0.10769,0.39659-0.11342,0.6017-0.13098,0.5025-0.22723,1.0136-0.33062,1.5226-0.10151,0.23862-0.18163,0.4867-0.28664,0.72429-0.11856,0.0723-0.0888,0.23517,0.0631,0.17073,0.24058-0.006,0.48117-0.0111,0.72175-0.0168-0.014-0.16183-0.23206-0.21679-0.25221-0.39154-0.0562-0.17715,0.0194-0.34153,0.0287-0.51329,0.0134-0.21002,0.31328-0.0704,0.45258-0.11644,0.20591-0.004,0.41183-0.009,0.61774-0.0129-0.0265,0.23235,0.18003,0.4175,0.15286,0.65191,0.0419,0.12721-0.24027,0.38796,0.0131,0.36237,0.28478,0.0217,0.56218-0.0744,0.8468-0.0708,0.2615-0.0154-0.0624-0.24939-0.0836-0.37362-0.0797-0.29251-0.20029-0.57279-0.27087-0.86834-0.11724-0.41216-0.24171-0.82224-0.35317-1.2358-0.11611-0.36125-0.20044-0.73111-0.30389-1.0959-0.0347-0.12205-0.0122-0.29726-0.19053-0.26317l-0.0199-0.00038,0.00007-0.00003zm-0.38902,0.89631c0.15268,0.49659,0.29628,0.99631,0.44666,1.4932,0.077,0.20323-0.14173,0.15074-0.26567,0.16988-0.15708,0.0155-0.31659,0.0374-0.473,0.0322-0.10925-0.15392,0.0327-0.37745,0.0435-0.55549,0.0217-0.23091,0.12563-0.44824,0.12915-0.68265,0.0526-0.14904,0.008-0.32952,0.11933-0.45714z'/%3E %3Cpath d='m501.1,344.63c-0.37587,0.0236-0.75173,0.0473-1.1276,0.0709-0.0662,0.13046,0.20003,0.14871,0.14894,0.3067,0.0259,0.30293,0.006,0.60829,0.006,0.91228-0.0161,0.82389-0.042,1.6483-0.0553,2.4718-0.0123,0.11192-0.30767,0.34361-0.0556,0.32194,0.55307,0.0197,1.1191,0.0732,1.6611-0.0683,0.17522-0.0435,0.31937-0.15181,0.45062-0.27062,0.18344-0.15994,0.32197-0.3704,0.43831-0.58338,0.10473-0.24274,0.15346-0.50846,0.1839-0.76984,0.0214-0.27651,0.0288-0.55665-0.024-0.8297-0.0355-0.23449-0.13173-0.45848-0.21966-0.67662-0.11423-0.14561-0.18449-0.32166-0.31521-0.45346-0.14425-0.14414-0.32369-0.24579-0.50429-0.33711-0.20013-0.003-0.386-0.12101-0.58744-0.0946zm0.0936,0.30344c0.22949-0.008,0.47404,0.11688,0.54978,0.34348,0.0846,0.15518,0.14621,0.31414,0.16911,0.48939,0.0524,0.18329,0.01,0.3761,0.055,0.56124,0.0663,0.34659,0.003,0.69919-0.045,1.043-0.007,0.25551-0.0898,0.50194-0.21233,0.72395-0.0581,0.18431-0.26778,0.2417-0.41891,0.31915-0.19366,0.0514-0.46002,0.0377-0.50374-0.20507-0.0358-0.21719-0.0159-0.44-0.0218-0.65976,0.004-0.78803,0.007-1.5776,0.0577-2.3638-0.0138-0.22251,0.18391-0.28811,0.37009-0.2516l0.00005,0.00006z'/%3E %3Cpath d='m504.63,344.75c-0.23619-0.0176-0.47988,0.0391-0.66424,0.19243-0.22638,0.15191-0.34887,0.4033-0.50809,0.61598-0.16987,0.30153-0.23309,0.6484-0.27483,0.98799,0.0125,0.28602-0.041,0.57472,0.009,0.85875,0.091,0.20954,0.14039,0.43785,0.21537,0.65473,0.0702,0.2811,0.27925,0.50371,0.504,0.67515,0.17956,0.10556,0.36573,0.19942,0.57743,0.21379,0.39658,0.0398,0.77062-0.20901,1.0009-0.51534,0.17385-0.24971,0.36324-0.50423,0.41421-0.81207,0.0744-0.23937,0.096-0.48964,0.12122-0.73761,0.0127-0.18928-0.0304-0.37498-0.0367-0.56316-0.0278-0.25016-0.13049-0.48253-0.23643-0.70694-0.16118-0.24896-0.28904-0.54382-0.55728-0.69739-0.16786-0.10599-0.36453-0.17222-0.56451-0.16631zm-0.0112,0.24531c0.299,0.006,0.48086,0.30998,0.52141,0.57676,0.0605,0.2129,0.0825,0.43176,0.1101,0.65137-0.0163,0.35945,0.0109,0.72137-0.0294,1.08-0.0617,0.22729-0.0244,0.47121-0.11462,0.69273-0.0422,0.22381-0.12913,0.4501-0.29763,0.60867-0.15444,0.10164-0.35956,0.15965-0.50693,0.0115-0.17793-0.10323-0.1944-0.31764-0.27763-0.48538-0.1023-0.29334-0.059-0.60958-0.068-0.91421,0.007-0.43173,0.024-0.864,0.0398-1.295,0.0572-0.21837,0.0861-0.44813,0.18722-0.65228,0.0764-0.17537,0.24785-0.27435,0.43576-0.27426z'/%3E %3Cpath d='m506.12,349c0.24582-0.0236,0.48383,0.0883,0.72609,0.0797,0.17903-0.16032-0.19439-0.2921-0.14591-0.49524-0.0219-0.24655,0.0371-0.4923,0.0949-0.7307,0.037-0.22517,0.0617-0.45284,0.0981-0.67876,0.0591-0.21936,0.0576-0.45235,0.11643-0.67286,0.0259-0.18938,0.0344-0.506,0.10741-0.61136,0.12026,0.19318,0.0502,0.43299,0.1225,0.64137,0.04,0.24412,0.0499,0.48812,0.0941,0.73279,0.0465,0.2561,0.0831,0.51169,0.10174,0.77141,0.0455,0.22847,0.0744,0.46554,0.10543,0.69939,0.0515,0.1657-0.0492,0.49237,0.23065,0.42377,0.25397,0.0889,0.16856-0.24911,0.28066-0.39533,0.0874-0.35605,0.15502-0.71765,0.25126-1.0715,0.083-0.19884,0.10892-0.41703,0.17469-0.62174,0.0899-0.33647,0.16766-0.6776,0.30539-0.9986,0.00017,0.96982,0.0764,1.9407,0.006,2.9097-0.0448,0.10919-0.29778,0.28976-0.0279,0.30712,0.24662,0.0141,0.49145,0.0387,0.7339,0.0819,0.23613,0.0598,0.19967-0.14671,0.0523-0.24023-0.14843-0.24602-0.0545-0.54441-0.071-0.81406,0.01-0.4782-0.0378-0.95467-0.0315-1.4328-0.006-0.43923-0.007-0.88071,0.039-1.3174,0.0557-0.0738,0.27433-0.26092,0.0681-0.2685-0.28995-0.0135-0.57989-0.0269-0.86984-0.0404-0.0368,0.23659-0.13952,0.45711-0.17508,0.69453-0.0608,0.27767-0.13899,0.55132-0.22225,0.82242-0.0293,0.25318-0.11884,0.49142-0.1682,0.74026-0.009,0.10521-0.0949,0.21893-0.0978,0.0419,0.0167-0.22256-0.11124-0.42854-0.0793-0.65109-0.005-0.18602-0.0974-0.35551-0.0715-0.54447-0.021-0.38411-0.14514-0.75673-0.14561-1.1428-0.0507-0.18515-0.30925-0.0887-0.45748-0.16082-0.15999-0.006-0.32033-0.0114-0.48044-0.0188,0.0707,0.24667,0.13538,0.49769,0.0815,0.75407-0.0364,0.21462-0.0894,0.42606-0.10542,0.64395-0.0798,0.50126-0.19778,0.99686-0.25713,1.5009-0.0709,0.17802-0.0521,0.37643-0.13234,0.54936-0.0562,0.16295-0.0991,0.3146-0.25418,0.41008-0.0135,0.033-0.007,0.0705,0.003,0.10283z'/%3E %3Cpath d='m509.98,349.42c0.20879,0.0846,0.44143,0.0677,0.65432,0.13693,0.10895,0.001,0.36573,0.11104,0.3774-0.0394-0.0899-0.13449-0.21398-0.26007-0.15927-0.43853,0.024-0.22372,0.074-0.4453,0.0617-0.67174-0.004-0.20499,0.0735-0.39897,0.0721-0.60309,0.0224-0.45091,0.0508-0.90164,0.0968-1.3507-0.0106-0.17403,0.0266-0.33659,0.0706-0.50029-0.0139-0.13238,0.0913-0.19405,0.17403-0.25174,0.0634-0.21689-0.21486-0.12069-0.33465-0.15431-0.23718-0.016-0.46951-0.0813-0.70823-0.0781-0.0536,0.10029,0.15017,0.18093,0.13064,0.3086,0.0347,0.16753-0.0106,0.33816-0.014,0.50574-0.0739,0.24578-0.0482,0.50624-0.0734,0.75893-0.0143,0.24032-0.0428,0.47939-0.0642,0.71886-0.0736,0.17579-0.0628,0.3735-0.0655,0.56347,0.006,0.21888-0.0123,0.43765-0.0544,0.65201,0.0104,0.14336-0.0416,0.30317-0.15757,0.36652-0.002,0.0256-0.003,0.0515-0.006,0.0769z'/%3E %3Cpath d='m511.32,349.71c0.18965-0.0127,0.36997,0.0864,0.55585,0.0716,0.10228,0.0422,0.31419,0.10403,0.21023-0.0859-0.10911-0.16522-0.16215-0.35305-0.1471-0.55204-0.011-0.33851,0.0421-0.67439,0.0876-1.0081-0.0112-0.23906,0.0143-0.47675,0.0759-0.7058,0.0203-0.21874,0.0246-0.44139,0.0865-0.65378,0.11352,0.10658,0.14216,0.35129,0.22748,0.5093,0.3115,0.79286,0.60958,1.5909,0.91804,2.3849,0.0741,0.15495,0.11012,0.38773,0.29604,0.43956,0.22923,0.094,0.17243-0.17714,0.18212-0.31394,0.0157-0.20033,0.12215-0.38118,0.0753-0.59075,0.0311-0.21876,0.076-0.43638,0.0746-0.66035,0.0514-0.21502,0.0816-0.43531,0.073-0.65683,0.0394-0.21333,0.0884-0.42525,0.0736-0.64437,0.003-0.23512,0.0748-0.45929,0.12497-0.68615,0.004-0.1517,0.40296-0.31035,0.15689-0.40244-0.21691,0.006-0.50749-0.14707-0.67677-0.0689,0.0438,0.17551,0.19664,0.3173,0.1661,0.51512,0.027,0.45016-0.0945,0.89275-0.0894,1.3424-0.0492,0.22216-0.0645,0.46554-0.0955,0.67786-0.12251-0.16729-0.16656-0.42721-0.26239-0.62736-0.0953-0.2427-0.17588-0.49223-0.29312-0.72573-0.0495-0.20776-0.16041-0.39474-0.21959-0.59956-0.11195-0.27522-0.22244-0.55103-0.33398-0.82642-0.25371-0.0354-0.51052-0.072-0.75237-0.15529-0.19061,0.11168,0.1127,0.29038,0.0821,0.45422,0.0596,0.32764,0.003,0.65727-0.0436,0.98229-0.0135,0.21585-0.0289,0.43086-0.0709,0.6436-0.001,0.23128-0.003,0.46367-0.0817,0.68556-0.0161,0.241-0.0595,0.48138-0.10141,0.7207-0.008,0.2047-0.20264,0.30745-0.29767,0.44813-0.004,0.0294-0.00047,0.0595-0.00074,0.0886z'/%3E %3Cpath d='m514.84,346.34c0.02,0.14278,0.19971,0.23572,0.12033,0.40287,0.003,0.19355-0.0297,0.38346-0.0625,0.57288-0.0145,0.18071-0.0313,0.36206-0.0729,0.53838-0.0293,0.29285-0.0904,0.58244-0.0883,0.8779-0.004,0.17738-0.0753,0.34483-0.0682,0.52349-0.0132,0.13752-0.0676,0.26626-0.0767,0.40529-0.0179,0.12135-0.0351,0.24301-0.063,0.36259-0.0514,0.0652-0.0859,0.13943-0.17608,0.14673-0.0841,0.17319,0.24593,0.1545,0.35487,0.18423,0.19285,0.0406,0.38382,0.0589,0.56573,0.12663,0.1453,0.0519,0.20402-0.10965,0.0749-0.17626-0.13909-0.18146-0.0369-0.41402-0.0253-0.61799,0.0149-0.15747,0.0271-0.31454,0.0657-0.46814,0.031-0.20832,0.0178-0.42254,0.0776-0.62579,0.0209-0.16129,0.01-0.32913,0.0705-0.48288,0.0341-0.20876,0.002-0.42764,0.076-0.62959-0.008-0.17876,0.042-0.35018,0.0797-0.52106-0.003-0.16278,0.0439-0.33261,0.19025-0.41766-0.1345-0.0702-0.29351-0.10727-0.44732-0.1303-0.15969-0.014-0.30716-0.0806-0.46355-0.1062-0.0459-0.003-0.096,0.004-0.13166,0.0349z'/%3E %3Cpath d='m516.07,349.1c-0.0161,0.2163,0.008,0.43135,0.043,0.6436,0.0441,0.29168,0.18099,0.55947,0.35289,0.79592,0.10242,0.19217,0.31155,0.27445,0.48228,0.39356,0.21486,0.12952,0.49674,0.11407,0.7223,0.018,0.13462-0.0625,0.30057-0.0949,0.37686-0.23872,0.15175-0.18203,0.336-0.35215,0.40598-0.58599-0.0992-0.21165-0.24264,0.10407-0.34382,0.16379-0.22697,0.17702-0.57283,0.24053-0.8237,0.0794-0.17613-0.12231-0.26718-0.31844-0.33363-0.51425-0.0398-0.19249-0.12265-0.3744-0.10386-0.5741-0.004-0.26104,0.002-0.52238,0.023-0.78266,0.10327-0.20247,0.0437-0.44419,0.13055-0.65338,0.0808-0.17569,0.11526-0.37965,0.2471-0.52695,0.0947-0.14152,0.26243-0.2095,0.4289-0.21625,0.17528,0.0275,0.28822,0.19369,0.39799,0.31941,0.13003,0.165,0.18141,0.37585,0.17559,0.58311-0.042,0.14578,0.13535,0.33854,0.22481,0.15233,0.0563-0.21266,0.2028-0.40463,0.21743-0.6241-0.0367-0.18216-0.21654-0.27629-0.33856-0.3981-0.13104-0.0956-0.27993-0.16472-0.42466-0.23721-0.27217-0.0765-0.59966-0.11332-0.84156,0.0658-0.16179,0.0828-0.31455,0.1818-0.43226,0.32236-0.19343,0.18586-0.27943,0.44825-0.37981,0.69012-0.10447,0.25214-0.15954,0.52257-0.19795,0.79144-0.008,0.11076-0.008,0.2221-0.009,0.33293z'/%3E %3Cpath d='m520.11,347.59c-0.24662,0.5093-0.44632,1.0399-0.6867,1.5522-0.0908,0.18419-0.13558,0.38701-0.24014,0.56491-0.11861,0.27234-0.21626,0.55506-0.37517,0.80797-0.12072,0.17126-0.16001,0.42971-0.36044,0.52759-0.16464,0.0344-0.12607,0.21006,0.0364,0.20446,0.20476,0.0226,0.39125,0.15009,0.58129,0.16114,0.16256-0.0956-0.0873-0.22611-0.0626-0.3621-0.0291-0.19238,0.0518-0.3782,0.13293-0.54616,0.14379-0.14759,0.35732-0.0156,0.52306,0.0184,0.12621,0.0825,0.33793,0.0343,0.42702,0.13207-0.001,0.27519-0.003,0.55037-0.004,0.82556-0.15068,0.0743-0.11939,0.26664,0.0574,0.26356,0.1834,0.0448,0.36446,0.0942,0.54393,0.14849,0.10504,0.0484,0.31609,0.0901,0.19293-0.0841-0.1232-0.26596-0.0851-0.56457-0.0992-0.84861-0.008-0.2362,0.009-0.47877-0.0336-0.71045-0.0587-0.19374-0.0165-0.40004-0.0321-0.59909,0.004-0.43042,0.0301-0.86234-0.0187-1.2911-0.008-0.20315,0.007-0.40738-0.018-0.6097-0.16888-0.0738-0.358-0.0907-0.53395-0.14707l-0.0305-0.008,0.00021,0.00002zm-0.0807,0.85083c0.01,0.60506,0.0195,1.2101,0.0293,1.8152-0.23388-0.004-0.44813-0.10987-0.67419-0.15571-0.12675-0.18303,0.16094-0.34363,0.14701-0.53845,0.11247-0.28123,0.2552-0.55042,0.36641-0.83288,0.0579-0.0906,0.0526-0.21463,0.13147-0.28816z'/%3E %3Cpath d='m521.84,352.25c-0.01-0.23063-0.18765-0.43104-0.1141-0.67254-0.0167-0.2968,0.0841-0.57671,0.14657-0.86179,0.0114-0.20574,0.0992-0.40106,0.11033-0.61012,0.0451-0.24915,0.13866-0.48972,0.14954-0.74452,0.0908-0.22433,0.16488,0.0655,0.17583,0.17109,0.13284,0.41039,0.22529,0.83334,0.33913,1.2484,0.0519,0.18223,0.0856,0.36808,0.15836,0.5433,0.11763,0.34053,0.16946,0.70057,0.2948,1.0383-0.013,0.20999,0.10094,0.47318,0.34696,0.42157,0.10552-0.23226,0.12955-0.50047,0.19139-0.7505,0.0591-0.21887,0.0391-0.45527,0.14303-0.66121,0.0822-0.3765,0.10052-0.76961,0.23271-1.1349,0.0759-0.29945,0.15184-0.59934,0.21292-0.90164,0.0661-0.11564,0.41858-0.28675,0.15711-0.386-0.19999-0.0314-0.42486-0.21669-0.61044-0.15704,0.0343,0.16168,0.13291,0.3106,0.12557,0.48446,0.01,0.23948-0.0777,0.46928-0.083,0.70675-0.0609,0.20012-0.11618,0.40084-0.15311,0.60711-0.0495,0.2346-0.0926,0.47047-0.1342,0.70657-0.16783-0.15331-0.1017-0.41534-0.20042-0.60739-0.0742-0.27109-0.16937-0.53547-0.21784-0.81235-0.0889-0.26147-0.15318-0.5293-0.2102-0.79909-0.0858-0.19603-0.13751-0.40478-0.16999-0.61672-0.14021-0.20162-0.41362-0.20615-0.62128-0.29946-0.18693-0.10477-0.33537,0.0126-0.18422,0.18756,0.0996,0.40803,0.001,0.83034-0.0875,1.2308-0.0794,0.35242-0.19028,0.70128-0.21965,1.0622-0.09,0.22273-0.0961,0.46242-0.15719,0.69218-0.0708,0.18867-0.13802,0.40714-0.32079,0.51628-0.23355,0.19767,0.21661,0.20951,0.33792,0.26837,0.10943,0.0666,0.23267,0.12136,0.36173,0.13033z'/%3E %3Cpath d='m525.79,349.59c-0.13211,0.30034-0.30887,0.5773-0.45306,0.87126-0.11875,0.28419-0.29001,0.54366-0.43557,0.81492-0.28052,0.4892-0.57189,0.97208-0.85656,1.4589-0.1428,0.0498-0.32969,0.26045-0.0681,0.28902,0.19901,0.0692,0.37385,0.20181,0.5799,0.24922,0.14744-0.0766-0.0931-0.26998-0.0616-0.40077,0.0196-0.20455,0.0887-0.39839,0.17973-0.5814,0.12569-0.0807,0.31614,0.0943,0.46395,0.12507,0.14767,0.10796,0.49046,0.0776,0.45318,0.31546,0.0116,0.25173,0.0116,0.5109-0.078,0.75017-0.11815-0.003-0.18579,0.0971-0.0651,0.17336,0.14867,0.069,0.30879,0.11125,0.45627,0.18573,0.14391,0.0272,0.28944,0.16674,0.43436,0.0988-0.0436-0.17909-0.11594-0.37809-0.0959-0.5773,0.0182-0.3111,0.0194-0.62233,0.0208-0.93383-0.004-0.21285,0.067-0.41754,0.0546-0.63033,0.0138-0.68402,0.0268-1.368,0.0404-2.0521-0.20598,0.0178-0.36238-0.16564-0.56925-0.15621zm-0.12657,0.82211c-0.008,0.61137-0.0167,1.2227-0.025,1.8341-0.156-0.0343-0.30026-0.11123-0.44972-0.16382-0.11114-0.0863-0.41358-0.11454-0.24396-0.28858,0.12428-0.2436,0.26209-0.4811,0.38488-0.72476,0.0934-0.22725,0.21927-0.44008,0.3338-0.65694z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23fff' width='900' height='600'/%3E %3Crect fill='%23006233' width='450' height='600'/%3E %3Cpath fill='%23d21034' d='M580,225a150,150 0 1,0 0,150 120,120 0 1,1 0-150m5,75-135-44 84,115v-142l-84,115z'/%3E %3C/svg%3E"

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1440' height='960'%3E %3Cdefs%3E %3ClinearGradient id='grad1' y2='277.58' gradientUnits='userSpaceOnUse' x2='601.38' gradientTransform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' y1='342.3' x1='597.92'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%231ea8d1' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='grad2' y2='399.5' gradientUnits='userSpaceOnUse' x2='600.31' gradientTransform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' y1='326.43' x1='599.96'%3E %3Cstop stop-color='%23FFF' offset='0'/%3E %3Cstop stop-color='%23c1d3e8' offset='0.1312'/%3E %3Cstop stop-color='%2388b0d5' offset='0.2994'/%3E %3Cstop stop-color='%235998c6' offset='0.4634'/%3E %3Cstop stop-color='%232c87bc' offset='0.6191'/%3E %3Cstop stop-color='%23007db5' offset='0.7645'/%3E %3Cstop stop-color='%230077b0' offset='0.8956'/%3E %3Cstop stop-color='%230075af' offset='1'/%3E %3C/linearGradient%3E %3C/defs%3E %3Crect width='1440' height='960' fill='%23ed1c24'/%3E %3Crect width='1440' height='720' fill='%23034ea2'/%3E %3Crect width='1440' height='480' fill='%23fd0'/%3E %3Cg id='coa'%3E %3Cg id='supporters'%3E %3Cg id='flag1' stroke='%23000' stroke-width='0.458' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath fill='%23b1babf' d='m452.3,476.58c-0.046,0.094-0.086,0.165-0.111,0.179,0,0-2.727,1.422-5.709,1.624,0,0-2.696,8.413-5.89,11.002,3.717-2.491,9.801-4.766,11.332-4.928,0.078-2.351,0.51-5.128,2.017-6.002l0.218-0.048h0.001c-0.525-0.682-1.147-1.295-1.858-1.827z'/%3E %3Cpath fill='none' stroke-width='0.23' d='m442.15,487.98,10.946-10.447'/%3E %3Cpath fill='none' stroke-width='0.23' d='m451.94,484.32-5.442-6.075'/%3E %3Cpath fill='%23b1babf' d='m472.76,455.57,3.209,3.783-20.287,19.026-1.261,0-2.292-2.063,0.115-1.605z'/%3E %3Cpath fill='none' stroke-width='0.23' d='m454.08,476.66,19.829-18.339'/%3E %3Cpath fill='%23b1babf' d='m478.97,217.63,8.482,8.023-2.178,0.917-8.367-7.907,2.063-1.033'/%3E %3Cpath fill='%23034ea2' d='m509.97,317.7,11.08,10.953,5.195-12.531,0.992-7.688c-0.779-22.019-0.381-43.662-0.381-43.662l3.259,2.842c-3.621-3.623-7.897-7.904-12.438-12.452l-7.326-7.2c0.001,0-0.138,46.318-0.381,69.738z'/%3E %3Cpath fill='%23ed1c24' d='m527.24,308.43,10.998-32.694-11.379-10.967s-0.399,21.642,0.381,43.661z'/%3E %3Cpath fill='%23fd0' d='m510.36,247.96,7.324,7.2c-13.331-13.353-28.932-28.999-36.852-37.016-1.463-1.482-1.807,31.898-1.646,69.118l30.79,30.436c0.243-23.42,0.384-69.738,0.384-69.738z'/%3E %3Cpath fill='none' stroke-width='0.23' d='M534.98,272.44,475.85,212.95'/%3E %3Cpath fill='%23b1babf' stroke-width='0.344' d='m476.98,214.13c-0.115-0.059-0.199-0.111-0.215-0.143,0,0-1.674-3.449-1.857-7.196,0,0-10.173-3.55-13.254-7.607,2.951,4.712,5.591,12.39,5.757,14.315,2.857,0.145,6.223,0.741,7.256,2.649l0.053,0.274,0.003,0.002c0.838-0.644,1.597-1.413,2.257-2.294z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m484.95,223.48-2.609-2.653c-0.191,0.594-0.5,1.624-0.988,3.418-1.041,3.819-0.232,16.615-0.811,21.008s-1.618,10.409-1.733,12.987c-0.003,0.054-0.011,0.103-0.015,0.156-0.036,3.053,1.113,6.798,1.113,6.798s1.834,0.946,2.14,0.126,0.458-7.195,0.458-8.52,0.382-2.082,1.528-8.393,0.611-9.908,0.153-13.757c-0.459-3.85,0.764-11.17,0.764-11.17z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m480.06,218.04s-2.87,7.829-2.754,13.845c0.115,6.016-0.81,14.324-0.926,15.565-0.085,0.918-1.18,5.794-1.279,9.473-0.036,1.302,0.286,1.157,0.589,1.931,0,0,1.975,1.24,3.104-0.457,0.004-0.052,0.013-0.102,0.015-0.156,0.115-2.578,1.155-8.594,1.733-12.987,0.578-4.392-0.23-17.189,0.811-21.008,0.488-1.794,0.797-2.823,0.988-3.417,0.217-0.671,0.283-0.785,0.283-0.785l-2.564-2.004z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m487.82,216.7c-1.457,0.486-5.995,1.31-7.411,1.562-0.27,0.048-0.426,0.076-0.426,0.076,6.5,0.134,9.108,4.027,9.108,4.027l2.197-2.659c1.965-3.238-1.735-3.585-3.468-3.006z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.23' d='m479.99,218.34,0.175,0.332c0.763,1.393,3.938,6.644,7.584,4.731l1.35-1.035c-0.001,0-2.608-3.894-9.109-4.028z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m480.53,218.34s6.414-3.56,7.309-3.526c0.896,0.033,1.005,1.506,1.221,2.37s-0.024,1.911-3.192,1.821c-3.17-0.089-2.241-0.432-5.338-0.665z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m490.62,214.23c-0.953-4.402-5.465-3.483-5.465-3.483-4.422,0.747-4.985,6.127-5.058,7.543-0.01,0.216-0.01,0.34-0.01,0.34,10.455-8.897,9.003,0.21,9.003,0.21,1.05-1.855,1.53-4.61,1.53-4.61z'/%3E %3Cpath fill='none' stroke-width='0.23' d='m462.2,200.03,13.749,15.311'/%3E %3Cpath fill='none' stroke-width='0.23' d='m467.41,213.52,7.57-6.708'/%3E %3Cpath fill='%23b1babf' stroke-width='0.344' d='m480.04,203.82c-0.087-0.142-0.236-0.297-0.435-0.461,0.484,2.866,0.199,5.812-0.992,8.464-0.4,0.891-0.886,1.704-1.439,2.439-0.669,0.89-1.439,1.666-2.29,2.317-3.458,2.645-8.228,3.265-12.769,1.435,0.081,0.055,0.159,0.112,0.241,0.166,0.381,0.253,0.773,0.493,1.176,0.721,7.185,4.058,15.186,2.522,17.871-3.432,1.605-3.553,0.952-7.878-1.363-11.649z'/%3E %3Ccircle fill='%23e8b909' cx='477.02' cy='257.56' r='2.09'/%3E %3Cpath fill='%23e8b909' d='m479.63,269.7c-2.965-0.112-4.609-0.279-6.526-0.395,0.247-4.088,0.591-9.756,3.854-9.558,3.229,0.195,2.92,5.866,2.672,9.953z'/%3E %3Cpath fill='none' d='m475.83,263.2s-0.557,5.841-0.611,6.176'/%3E %3Cpath fill='none' d='m477.45,263.26s0.068,4.427-0.278,6.263'/%3E %3Ccircle fill='%23e8b909' cx='480.7' cy='263.46' r='2.09'/%3E %3Cpath fill='%23e8b909' d='m484.04,275.42c-2.966,0.067-4.616,0-6.537,0,0-4.095-0.001-9.774,3.269-9.774,3.234,0,3.268,5.679,3.268,9.774z'/%3E %3Cpath fill='none' d='m479.86,269.15s-0.202,5.864-0.236,6.201'/%3E %3Cpath fill='none' d='m481.48,269.12s0.337,4.415,0.101,6.269'/%3E %3C/g%3E %3Cuse xlink:href='%23flag1' transform='matrix(-1,0,0,1,1439.0324,0)'/%3E %3Cg id='laurel' stroke='%23000' stroke-width='0.344' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath fill='none' d='m529.89,257.24c-3.951,1.175-6.94,3.097-11.212,3.631'/%3E %3Cpath fill='%2339b54a' d='m511.32,264.35s-0.396-8.102-0.075-8.994c0.32-0.888,7.384-6.382,5.246-20.159,0,0-1.39-4.62-0.672-5.753,0,0-6.114,11.651-6.623,15.135-0.508,3.481,0.361,9.155,0.701,10.532,0.34,1.378,0.889,5.106,0.889,5.106'/%3E %3Cpath fill='none' d='m515.3,233.09c0.009,1.67-0.571,3.388-0.853,5.021-0.278,1.617-0.501,3.129-1.055,4.675-0.712,1.985-1.68,4.029-2.05,6.082-0.30895,1.7175-0.29754,3.4764-0.35087,5.2175'/%3E %3Cpath fill='none' d='m510.66,255.44c-0.101-1.507,1.77-3.495,2.964-4.531'/%3E %3Cpath fill='none' d='m511.26,249.28c0.439-1.087-0.95-3.337-1.102-4.538'/%3E %3Cpath fill='none' d='m511.16,251.06c-0.048-2.644,3.191-3.361,3.318-5.762'/%3E %3Cpath fill='none' d='m512.36,245.31c-0.28-1.266-2.34-2.268-1.711-3.731'/%3E %3Cpath fill='none' d='m513.32,242.88c0.26-0.806,0.92-1.607,1.41-2.346,0.448-0.671,1.325-1.16,1.641-1.859'/%3E %3Cpath fill='none' d='m514,240.05c0.057-1.665-0.477-3.007-0.422-4.618'/%3E %3Cpath fill='%2339b54a' d='m518.47,255.06c0.017-2.97,0.411-4.652,2.813-6.483,2.098-1.599,4.84-2.35,5.727-4.972-0.479,0.899-0.281,2.061-0.498,3.054-0.255,1.16-0.717,2.435-1.246,3.52-0.799,1.636-1.88,3.356-2.965,4.754'/%3E %3Cpath fill='%2339b54a' d='m508,264.51c1.627-3.748,4.271-6.778,8.075-8.458,2.905-1.284,6.025-1.721,9.152-1.885,1.911-0.099,3.671-0.116,5.527-0.73,1.333-0.441,3.665-1.043,4.523-2.193-5.329,2.983-8.409,8.88-14.194,11.254-4.563,1.873-10.604,0.947-14.616,4.055'/%3E %3Cpath fill='none' d='m508.38,264.89c2.883-2.966,6.495-4.992,10.485-6.099,3.119-0.865,6.646-1.904,9.433-3.604'/%3E %3Cpath fill='none' d='m518.98,259.15c0.911,0.463,2.995,1.463,4.085,1.277'/%3E %3Cpath fill='none' d='m522.82,257.73c0.955,0.003,2.535,0.753,3.32,0.383'/%3E %3Cpath fill='none' d='m519.74,258.51c-1.102-1.927,1.652-2.055,2.298-3.192'/%3E %3Cpath fill='%2339b54a' d='m536.73,243.83c1-1.15,0.653-4.406,1.177-5.97,0.685-2.036,2.243-3.479,3.146-5.355-0.827,1.848-0.091,4.381-0.747,6.34-0.732,2.184-2.476,4.05-3.704,6.007'/%3E %3Cpath fill='none' d='m538.26,241.27c-0.209-1.838,1.28-3.325,1.661-4.98'/%3E %3Cpath fill='%2339b54a' d='m505.23,305.87c2.208,3.341,4.85,8.697,1.846,12.422-0.646-0.961-0.711-2.817-1.75-3.483-0.747-0.478-2.115-0.265-3.007-0.645-2.387-1.017-1.929-3.593-3.525-4.88l-0.383-0.944,6.281-3.098,0.538,0.628z'/%3E %3Cpath fill='none' d='m502.38,308.56c2.804,2.082,4.737,5.504,4.469,9.065'/%3E %3Cpath fill='none' d='m502,308.43c0.804,1.921,0.111,3.375,0.281,5.203,0.075-0.116,0.136-0.247,0.229-0.352'/%3E %3Cpath fill='none' d='m503.14,308.94c1.827,1.352,3.088,2.359,4.341,4.215'/%3E %3Cpath fill='%2339b54a' d='m495.23,296.18c1.016-1.228,1.286-3.411,2.174-4.859,1.106-1.804,2.975-3.602,4.969-4.306,2.448-0.864,4.788-1.326,7.384-1.432,2.429-0.1,5.253,0.952,7.321,0.758-4.256,1.559-9.485,1.748-13.412,4.184-2.557,1.586-5.125,4.242-7.158,6.452-1.691,1.838-2.125,3.899-3.065,6.098'/%3E %3Cpath fill='none' d='m495.36,297.71c1.038-2.534,3.186-5.73,5.391-7.409,2.21-1.684,5.092-2.701,7.888-2.55'/%3E %3Cpath fill='none' d='m497.14,294.39c1.439-0.997,3.373-1.943,4.597-3.192'/%3E %3Cpath fill='%2339b54a' d='m505.44,288.1c1.352-1.517,3.247-1.388,4.979-1.629'/%3E %3Cpath fill='%2339b54a' d='m493.57,305.11c0.561-0.751,0.855-1.724,1.306-2.579,0.62-1.178,1.463-2.191,2.272-3.268,1.639-2.182,3.209-4.148,5.229-6.025,1.716-1.595,4.053-2.883,6.395-3.424,2.205-0.51,6.096,0.039,7.736-1.645-1.216,1.47-1.767,3.279-3.196,4.705-2.068,2.065-4.23,4.367-6.866,5.817-1.991,1.095-4.608,2.317-6.781,2.816-1.919,0.439-5.231,0.439-6.333,2.428,0.09,0.053,0.174,0.145,0.236,0.228,0.348-0.233,0.715-0.526,1.024-0.841'/%3E %3Cpath fill='none' d='m494.85,302.56c1.127-0.381,2.156-1.979,3.028-2.806,1.26-1.196,2.607-2.13,4.086-3.065,1.883-1.188,3.686-2.245,5.742-3.103,1.642-0.684,3.232-1.288,4.635-2.39'/%3E %3Cpath fill='none' d='m500.97,297.33c1.351-0.439,2.682-1.04,4.085-1.28,0.781-0.133,1.723,0.032,2.427-0.38'/%3E %3Cpath fill='none' d='m503.02,295.92c1.012-1.479,2.69-2.719,3.318-4.342'/%3E %3Cpath fill='%2339b54a' d='m524.72,254.04c1.745-2.375,3.823-4.09,6.165-5.933,1.567-1.234,2.775-2.908,4.66-3.679,5.015-2.049,10.551,1.902,15.695,1.817-2.225,0.963-4.186,2.363-6.602,2.979-2.396,0.61-4.771,0.961-7.271,0.986-4.41,0.043-10.245,0.102-12.775,4.468'/%3E %3Cpath fill='none' d='m527.66,251.49c2.898-0.723,5.768-2.563,8.581-3.668,2.845-1.117,5.977-0.527,8.784-1.44'/%3E %3Cpath fill='none' d='m536.15,247.91c1.854-0.684,4.49,0.759,6.513,0.766'/%3E %3Cpath fill='none' d='m533.41,249.06c0.921-0.761,1.859-1.599,2.843-2.295,0.736-0.518,1.777-1.007,2.009-1.919'/%3E %3Cpath fill='%2339b54a' d='m504.58,280.18c2.101-0.421,2.834-4.027,3.396-5.619,0.768-2.177,1.422-5.225,2.783-7.087,0.892-1.219,2.619-2.165,3.877-3.066,1.597-1.144,2.373-1.566,4.253-1.847,2.521-0.379,5.196-0.63,7.757-0.656,2.305-0.024,4.939,0.36,7.078-0.725-2.347,0.78-4.693,2.745-6.118,4.611-2.228,2.919-3.659,5.595-6.988,7.702-2.977,1.885-6.643,2.768-10.021,3.79-1.918,0.582-5.112,1.273-5.594,3.468'/%3E %3Cpath fill='none' d='m507.61,277.54c3.653-3.69,5.158-9.006,10.734-10.47,3.402-0.894,8.688-1.374,10.973-4.341'/%3E %3Cpath fill='none' d='m510.51,274.11c1.187-1.138,2.687-1.783,4.313-1.788,1.638-0.005,3.369,0.411,4.88-0.382'/%3E %3Cpath fill='none' d='m518.72,267.32c1.004-0.369,2.024,0.253,3.034,0.263,1.044,0.009,1.878-0.594,2.84-0.773'/%3E %3Cpath fill='none' d='m515.4,268.34c0.471-1.996,1.511-2.825,2.555-4.469'/%3E %3Cpath fill='%2339b54a' d='m501.48,285.78c1.622-0.106,2.352-2.107,2.855-2.977,0.688-1.187,1.332-2.877,2.458-3.848,0.738-0.634,2.099-1.062,3.102-1.495,1.271-0.548,1.883-0.737,3.33-0.778,1.938-0.055,3.99-0.027,5.944,0.121,1.758,0.132,3.747,0.518,5.431,0.039-1.826,0.293-3.708,1.26-4.884,2.23-1.837,1.515-3.055,2.944-5.692,3.93-2.359,0.88-5.196,1.149-7.819,1.514-1.491,0.209-3.958,0.398-4.43,1.614'/%3E %3Cpath fill='none' d='m503.92,284.47c2.959-1.863,4.358-4.786,8.679-5.264,2.637-0.291,6.689-0.228,8.571-1.767'/%3E %3Cpath fill='none' d='m506.92,282.53c0.958-0.571,2.131-0.841,3.371-0.741,1.25,0.101,2.551,0.447,3.74,0.093'/%3E %3Cpath fill='none' d='m512.87,279.37c0.783-0.145,1.531,0.273,2.301,0.343,0.795,0.071,1.459-0.218,2.202-0.259'/%3E %3Cpath fill='none' d='m510.29,279.74c0.453-1.105,1.285-1.509,2.159-2.376'/%3E %3Cpath fill='%2339b54a' d='m491.42,308.23s-13.454-14.308-6.193-32.034c0,0,0.215,4.911,0.642,5.552,0.426,0.641,7.9,11.853,6.833,21.57-1.067,9.718-0.533,5.767-0.533,5.767l-0.749-0.855z'/%3E %3Cpath fill='none' d='m491.42,307.05s-1.709-11.319-3.844-14.416c-2.136-3.096-2.457-9.61-2.243-10.784'/%3E %3Cpath fill='none' d='m487.57,291.36c0.585-0.728,1.211-1.507,1.28-2.456'/%3E %3Cpath fill='none' d='m489.5,296.16c0.6-0.798,0.697-1.843,0.961-2.669'/%3E %3Cpath fill='none' d='m489.28,298.4c-0.695-0.877-3.29-1.042-3.417-2.029'/%3E %3Cpath fill='none' d='m487.15,293.07c-0.522-1.085-3.155-1.356-3.203-2.67'/%3E %3Cpath fill='none' d='m485.22,286.77c-1.013-0.755-1.222-1.407-1.603-2.563'/%3E %3Cpath fill='none' d='m490.35,302.57c-1.022-1.157-2.163-1.543-3.311-2.242'/%3E %3Cpath fill='none' d='m490.46,300.11c0.198-1.01,1.215-1.997,1.175-2.99'/%3E %3Cpath fill='%2339b54a' d='m514.17,250.18s3.231-7.338,3.917-7.978c0.682-0.638,9.485-2.237,13.665-15.388,0,0,0.793-4.72,1.944-5.391,0,0-10.678,7.475-12.679,10.319-2.001,2.84-3.732,8.251-4.037,9.624-0.304,1.373-1.462,4.918-1.462,4.918'/%3E %3Cpath fill='none' d='m531.62,224.41c-0.733,1.48-2.016,2.729-2.994,4.041-0.967,1.302-1.839,2.534-3.022,3.643-1.521,1.427-3.299,2.787-4.542,4.43-1.084,1.43-1.873,3.063-2.733,4.637'/%3E %3Cpath fill='none' d='m517.52,242.01c0.577-1.378,3.145-2.273,4.681-2.637'/%3E %3Cpath fill='none' d='m520.79,236.85c0.878-0.758,0.623-3.387,1.018-4.515'/%3E %3Cpath fill='none' d='m520.32,237.5c0.81-2.346,5.548-0.331,6.518-2.322'/%3E %3Cpath fill='none' d='m523.55,233.85c0.31-1.247-1.104-3.079,0.112-4.083'/%3E %3Cpath fill='none' d='m525.49,232.15c0.591-0.593,1.542-0.996,2.312-1.424,0.701-0.384,1.707-0.413,2.301-0.886'/%3E %3Cpath fill='none' d='m527.36,229.96c0.788-1.445,0.901-2.875,1.666-4.273'/%3E %3Cpath fill='%2339b54a' d='m496.94,255.01s0.499-4.559,0.286-5.06c-0.214-0.501-5.287-3.602-3.359-11.351,0,0,1.145-2.599,0.643-3.237,0,0,4.216,6.563,4.502,8.524s-0.5,5.152-0.785,5.927c-0.286,0.775-0.787,2.872-0.787,2.872'/%3E %3Cpath fill='none' d='m494.84,237.54c-0.047,0.938,0.337,1.908,0.502,2.827,0.164,0.91,0.29,1.762,0.659,2.632,0.474,1.118,1.137,2.269,1.357,3.424,0.191,1.008,0.125,2.041,0.125,3.062'/%3E %3Cpath fill='none' d='m497.7,250.13c0.113-0.85-1.218-1.969-2.07-2.553'/%3E %3Cpath fill='none' d='m497.41,246.66c-0.296-0.613,0.787-1.877,0.931-2.554'/%3E %3Cpath fill='none' d='m497.49,247.12c0.303-1.398-3.434-1.611-3.357-2.872'/%3E %3Cpath fill='none' d='m496.7,244.43c0.239-0.713,1.786-1.272,1.357-2.097'/%3E %3Cpath fill='none' d='m496.06,243.06c-0.17-0.454-0.637-0.906-0.979-1.322-0.313-0.379-0.948-0.654-1.163-1.048'/%3E %3Cpath fill='none' d='m495.63,241.46c0-0.937,0.427-1.691,0.427-2.598'/%3E %3Cpath fill='%2339b54a' d='m496.44,275.23s0.504-9.383,0.908-10.369c0.402-0.988,7.735-6.468,7.194-22.594,0,0-0.822-5.49-0.015-6.709,0,0-7.096,12.689-7.96,16.639-0.862,3.951-0.651,10.591-0.478,12.218s0.291,5.989,0.291,5.989'/%3E %3Cpath fill='none' d='m503.64,239.7c-0.175,1.922-0.915,3.832-1.36,5.681-0.439,1.829-0.816,3.545-1.515,5.259-0.893,2.201-2.039,4.439-2.614,6.759-0.502,2.023-0.676,4.141-0.934,6.222'/%3E %3Cpath fill='none' d='m496.79,264.88c0.066-1.751,2.066-3.814,3.317-4.864'/%3E %3Cpath fill='none' d='m498.03,257.86c0.536-1.198-0.543-3.957-0.558-5.359'/%3E %3Cpath fill='none' d='m498.04,258.92c-0.038-2.902,4.84-2.714,5.06-5.299'/%3E %3Cpath fill='none' d='m499.51,253.43c-0.129-1.493-1.984-2.892-1.226-4.502'/%3E %3Cpath fill='none' d='m500.69,250.75c0.334-0.898,1.055-1.743,1.601-2.533,0.5-0.722,1.39-1.179,1.766-1.947'/%3E %3Cpath fill='none' d='m501.64,247.56c0.236-1.91-0.128-3.52,0.103-5.37'/%3E %3Cpath fill='%2339b54a' d='m495.94,265.35s-2.67-4.484-3.524-6.941c-0.854-2.456-2.349-4.805-2.883-5.232s5.874,3.309,6.301,4.378'/%3E %3Cpath fill='none' d='m495.83,261.29c-0.905-2.104-2.113-4.898-4.271-5.98'/%3E %3Cpath fill='none' d='m495.08,260.97c-0.21-0.945-1.26-1.612-1.922-2.136'/%3E %3Cpath fill='none' d='m494.87,259.26c-0.261-0.847-0.42-1.836-0.641-2.67'/%3E %3Cpath fill='%2339b54a' d='m496.36,280.08s0.748-9.717,5.126-12.28c0,0,4.271-2.136,6.086-3.844,0,0,2.563-3.524,0.961-1.281-1.603,2.242-2.669,14.735-2.776,15.483-0.106,0.747-1.709,5.552-4.699,9.183-2.988,3.631-4.378,5.873-5.018,7.155-0.641,1.281-1.175,4.697-1.175,4.697'/%3E %3Cpath fill='none' d='m495.94,291.19c1.613-1.339,1.935-3.465,2.671-5.371,0.807-2.094,1.738-4.065,2.054-6.283,0.322-2.262,0.897-4.27,1.813-6.365,0.946-2.161,2.698-3.762,3.821-5.686'/%3E %3Cpath fill='none' d='m500.72,280.47c1.396-1.926,2.959-1.976,4.725-3.191'/%3E %3Cpath fill='none' d='m498.57,286.26c0.987-1.512,3.104-1.221,3.83-3.064'/%3E %3Cpath fill='none' d='m499.32,282c0.573-2.072-1.241-3.219-1.66-5.107'/%3E %3Cpath fill='none' d='m501.41,276.03c-1.013-2.407-0.88-4.108,0-6.257'/%3E %3Cpath fill='none' d='m496.89,274.22c0.133-2.469,1.027-5.57,2.04-7.793,0.619-1.359,1.537-2.64,2.267-3.919,0.512-0.898,1.148-2.178,2.078-2.716'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m503.27,259.4c-0.094,0.482,0.596,0.772,1.127,0.489,0.039-0.117,0.02-0.228,0.041-0.349,0.652,0.191,2.151,0.198,1.299-0.78,0.607-0.108,1.575-0.673,0.741-1.176,0.487-0.478,0.527-1.325-0.016-1.771-0.085,0.062-0.175,0.164-0.263,0.222-0.043-0.579-0.546-0.823-1.123-0.703-0.02,0.104,0.014,0.225-0.009,0.318-0.396-0.271-0.867-0.297-1.267-0.048,0.038,0.075,0.154,0.15,0.189,0.229-0.354-0.063-0.524,0.128-0.826,0.144,0.054,0.104,0.063,0.397,0.115,0.498,0.098-0.007,0.098-0.013,0.002-0.016-0.404,0.145-0.674,0.435-0.765,0.874,0.147,0.036,0.307,0.139,0.463,0.182-0.757,0.22-0.739,0.871-0.081,1.128,0.098-0.003,0.1-0.008,0.005-0.016-0.747,0.677,0.558,0.847,1.004,0.264'/%3E %3Cpath fill='%23de2126' stroke='none' d='m504.11,256.99c0.426,0.258,0.197,0.998,1.036,1.061,0.164-0.431,0.295-0.565,0.388-1.005-0.245-0.006-1.247,0.145-0.685,0.314'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m504.45,265.29c-0.094,0.482,0.597,0.772,1.127,0.489,0.039-0.117,0.021-0.228,0.041-0.349,0.652,0.191,2.151,0.198,1.299-0.78,0.607-0.108,1.575-0.673,0.741-1.176,0.487-0.478,0.527-1.325-0.016-1.771-0.084,0.062-0.174,0.164-0.262,0.222-0.043-0.579-0.547-0.823-1.123-0.703-0.021,0.104,0.013,0.225-0.01,0.318-0.396-0.271-0.866-0.297-1.268-0.048,0.039,0.075,0.156,0.15,0.191,0.229-0.355-0.063-0.525,0.128-0.826,0.144,0.053,0.104,0.063,0.397,0.114,0.498,0.098-0.007,0.099-0.013,0.003-0.016-0.405,0.146-0.675,0.435-0.766,0.874,0.148,0.036,0.308,0.139,0.463,0.182-0.757,0.22-0.738,0.871-0.081,1.128,0.099-0.003,0.101-0.008,0.004-0.016-0.745,0.677,0.559,0.847,1.006,0.264'/%3E %3Cpath fill='%23de2126' stroke='none' d='m505.33,262.81c0.384,0.265,0.179,1.024,0.932,1.09,0.147-0.443,0.266-0.582,0.349-1.033-0.22-0.005-1.12,0.15-0.614,0.323'/%3E %3Cpath fill='none' d='m503.78,264.38c-4.634,2.68-8.541,7.49-7.405,13.152'/%3E %3Cpath fill='%2339b54a' d='m513.74,252.13c3.735-1.835,4.712-6.083,8.204-8.137,2.264-1.331,4.95-1.713,7.494-2.198,1.806-0.345,4.236-0.662,5.303-2.372-1.6,1.95-3.466,3.458-5.273,5.173-1.892,1.795-3.494,3.324-6.122,4.09-1.988,0.579-4.061,0.369-6.03,1.049-1.624,0.562-2.585,1.893-3.958,2.906l0.382-0.511z'/%3E %3Cpath fill='none' d='m517.45,249.44c1.898-1.179,3.117-3.058,5.206-3.925,2.306-0.958,4.909-1.177,7.179-2.203'/%3E %3Cpath fill='none' d='m520.26,247.11c1.683-0.965,4.067,0.002,5.617-1.149'/%3E %3Cpath fill='none' d='m522.94,245.36c0.848-0.723,1.896-1.336,2.682-2.043'/%3E %3Cpath fill='none' d='m514.64,261.32c-2.098,1.015-6.444,1.684-7.278,4.342'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m514.64,261.19c0.275,0.766,1.01,1.021,1.766,0.875,0.051-0.115,0.101-0.243,0.146-0.351,0.931,0.438,1.839-0.234,1.195-1.169,0.642-0.098,0.728-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.479-0.044,1.112-1.392-2.423-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.687,0.362-0.849,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m515.79,259.79c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m522.3,267.32c0.276,0.766,1.011,1.021,1.767,0.876,0.051-0.116,0.099-0.244,0.146-0.352,0.932,0.438,1.839-0.234,1.196-1.169,0.641-0.098,0.727-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.48-0.044,1.113-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.686,0.362-0.848,1.446,0.048,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m523.45,265.92c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m517.57,270.77c0.276,0.766,1.011,1.021,1.767,0.875,0.052-0.115,0.1-0.243,0.146-0.351,0.932,0.438,1.839-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.48-0.044,1.113-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.686,0.362-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m518.72,269.36c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath fill='%23ffdf4f' stroke='none' d='m511.32,271.28c0.276,0.766,1.01,1.021,1.767,0.876,0.052-0.116,0.1-0.244,0.146-0.352,0.931,0.438,1.839-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.448-1.124-0.151,0.005-0.33-0.045-0.48-0.044,1.113-1.392-2.422-2.45-2.458-0.886-0.659-0.039-1.535,0.436-0.794,0.908-0.687,0.362-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m512.47,269.87c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m506.59,276.51c0.276,0.766,1.011,1.021,1.767,0.875,0.051-0.115,0.1-0.243,0.146-0.351,0.932,0.438,1.839-0.234,1.196-1.169,0.641-0.098,0.727-0.609,0.448-1.124-0.151,0.005-0.33-0.045-0.48-0.044,1.113-1.393-2.422-2.45-2.458-0.887-0.659-0.039-1.535,0.437-0.794,0.909-0.686,0.362-0.848,1.446,0.049,1.663'/%3E %3Cpath fill='%23de2126' stroke='none' d='m507.74,275.11c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m530.08,258.51c0.276,0.766,1.012,1.021,1.767,0.875,0.052-0.115,0.1-0.243,0.145-0.351,0.932,0.438,1.84-0.235,1.197-1.169,0.642-0.099,0.727-0.609,0.448-1.124-0.15,0.005-0.331-0.045-0.48-0.044,1.113-1.393-2.422-2.45-2.458-0.887-0.659-0.039-1.535,0.437-0.794,0.908-0.686,0.363-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m531.23,257.1c0.04,2.039,1.692-1.125,0.021-0.095,0.026,0.158,0.188,0.13,0.235,0.223'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m538.64,246c0.276,0.766,1.011,1.021,1.767,0.875,0.052-0.115,0.1-0.243,0.146-0.351,0.932,0.438,1.838-0.234,1.196-1.169,0.642-0.098,0.729-0.609,0.448-1.124-0.151,0.005-0.33-0.045-0.479-0.044,1.112-1.392-2.422-2.45-2.459-0.887-0.659-0.039-1.535,0.437-0.794,0.909-0.686,0.362-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m539.79,244.59c0.039,2.039,1.69-1.125,0.02-0.095,0.026,0.158,0.189,0.13,0.235,0.223'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m531.75,245.49c0.276,0.766,1.011,1.021,1.767,0.875,0.052-0.115,0.099-0.243,0.146-0.351,0.932,0.438,1.838-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.448-1.124-0.151,0.005-0.33-0.045-0.479-0.045,1.111-1.392-2.423-2.45-2.459-0.886-0.659-0.039-1.535,0.437-0.795,0.909-0.685,0.362-0.847,1.446,0.049,1.663'/%3E %3Cpath fill='%23de2126' stroke='none' d='m532.9,244.08c0.038,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m514.12,281.11c0.276,0.766,1.01,1.021,1.767,0.875,0.052-0.115,0.1-0.243,0.146-0.351,0.931,0.438,1.839-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.447-1.124-0.149,0.005-0.329-0.045-0.479-0.044,1.113-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.687,0.362-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m515.28,279.7c0.037,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m506.98,283.54c0.276,0.766,1.01,1.021,1.766,0.875,0.052-0.115,0.101-0.243,0.146-0.351,0.931,0.438,1.839-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.447-1.124-0.15,0.005-0.329-0.045-0.479-0.044,1.113-1.393-2.422-2.45-2.458-0.887-0.659-0.039-1.535,0.437-0.794,0.909-0.687,0.362-0.848,1.446,0.049,1.663'/%3E %3Cpath fill='%23de2126' stroke='none' d='m508.12,282.13c0.039,2.039,1.691-1.125,0.021-0.096,0.026,0.159,0.188,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m506.59,294.26c0.276,0.766,1.011,1.021,1.767,0.876,0.051-0.116,0.1-0.244,0.146-0.352,0.932,0.438,1.839-0.234,1.196-1.169,0.641-0.098,0.727-0.609,0.448-1.123-0.151,0.004-0.33-0.046-0.48-0.045,1.113-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.686,0.362-0.848,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m507.74,292.86c0.039,2.039,1.69-1.125,0.02-0.095,0.026,0.158,0.189,0.13,0.235,0.223'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m500.08,298.73c0.275,0.767,1.01,1.021,1.766,0.875,0.052-0.114,0.101-0.242,0.146-0.351,0.931,0.438,1.839-0.234,1.195-1.169,0.643-0.099,0.728-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.479-0.044,1.112-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.687,0.362-0.848,1.446,0.049,1.664l0.134,0.08'/%3E %3Cpath fill='%23de2126' stroke='none' d='m501.23,297.33c0.039,2.039,1.691-1.125,0.021-0.095,0.025,0.158,0.188,0.13,0.234,0.223'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m520.13,253.4c0.275,0.766,1.01,1.021,1.766,0.875,0.051-0.115,0.1-0.243,0.146-0.351,0.932,0.438,1.84-0.234,1.196-1.169,0.643-0.098,0.728-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.48-0.045,1.113-1.392-2.422-2.449-2.458-0.886-0.658-0.039-1.534,0.437-0.794,0.909-0.686,0.362-0.847,1.446,0.05,1.663'/%3E %3Cpath fill='%23de2126' stroke='none' d='m521.28,252c0.039,2.039,1.691-1.125,0.021-0.096,0.025,0.159,0.188,0.131,0.234,0.224'/%3E %3Cpath fill='%2339b54a' d='m537.75,242.93c2.741-2.494,2.588-6.662,6.383-8.428,1.916-0.892,4.212-1.437,5.823-2.766-2.946,4.999-7.018,8.714-12.206,11.194'/%3E %3Cpath fill='%2339b54a' d='m537.11,243.19c1.866-0.68,3.247-2.276,5.042-3.117,1.997-0.936,3.686-0.266,5.793-0.451,2.11-0.185,4.03-0.723,6.018-1.395-3.801,5.194-11.868,1.362-16.598,4.708'/%3E %3Cpath fill='none' d='m539.28,241.15c1.685-0.301,2.508-2.208,3.415-3.44,1.083-1.471,2.627-1.791,4.246-2.561'/%3E %3Cpath fill='none' d='m499.22,291.68c0.955-1.316,1.789-2.826,2.937-3.958'/%3E %3Cpath fill='%2339b54a' d='m492.65,309.16c0.664-1.44,0.851-3.01,1.944-4.182,1.209-1.295,3.299-2.666,4.895-3.418,4.459-2.102,10.476-1.276,14.218-4.752-1.597,4.512-7.271,8.457-11.465,10.437-1.754,0.828-3.613,1.609-5.531,1.919-1.503,0.242-3.398-0.085-4.827,0.379'/%3E %3Cpath fill='none' d='m492.9,309.28c1.449-0.662,2.328-2.016,3.604-2.83,1.471-0.938,3.054-1.658,4.703-2.182,2.004-0.633,4.092-1.269,6.043-2.113,0.741-0.32,3.019-1.34,3.143-2.067'/%3E %3Cpath fill='none' d='m497.13,306.35c1.39,0.38,2.683,1.349,4.214,0.511'/%3E %3Cpath fill='none' d='m500.56,304.43c2.556,0.015,4.573,0.359,7.022-0.766'/%3E %3Cpath fill='none' d='m497.37,306.15c0.557-0.579,0.645-1.432,1.112-2.083,0.451-0.629,1.154-1.177,1.57-1.806'/%3E %3Cpath fill='none' d='m501.58,303.92c0.533-0.621,1.048-1.233,1.761-1.693,0.698-0.453,1.809-0.623,2.325-1.371'/%3E %3Cpath fill='none' d='m491.62,308.57c0.271-1.812,1.585-3.127,2.337-4.71,0.487-1.026,0.933-3.061,0.983-4.168'/%3E %3Cpath fill='%2339b54a' d='m493.27,305.39s0.747-10.679,0.427-11.853c-0.321-1.174-7.902-8.436-5.019-26.588,0,0,1.709-6.086,0.961-7.581,0,0,6.3,15.376,6.727,19.967,0.428,4.592-0.746,12.067-1.174,13.882-0.427,1.815-1.175,6.727-1.175,6.727'/%3E %3Cpath fill='none' d='m490.06,264.17c-0.072,2.198,0.502,4.466,0.75,6.62,0.244,2.132,0.432,4.126,0.983,6.165,0.709,2.619,1.699,5.315,2.029,8.021,0.288,2.36,0.188,4.781,0.188,7.17'/%3E %3Cpath fill='%2339b54a' d='m494.34,293.64c0.169-1.987-1.819-4.61-3.096-5.98'/%3E %3Cpath fill='none' d='m493.91,285.53c-0.445-1.434,1.175-4.395,1.388-5.979'/%3E %3Cpath fill='%2339b54a' d='m494.02,286.6c0.453-3.275-5.132-3.773-5.019-6.727'/%3E %3Cpath fill='none' d='m492.84,280.29c0.357-1.668,2.668-2.98,2.029-4.912'/%3E %3Cpath fill='none' d='m491.88,277.09c-0.255-1.063-0.954-2.122-1.466-3.096-0.468-0.888-1.416-1.534-1.737-2.456'/%3E %3Cpath fill='none' d='m491.24,273.35c0-2.195,0.64-3.962,0.64-6.087'/%3E %3C/g%3E %3Cg id='palm' stroke='%23000'%3E %3Cg fill='%23009c4f' stroke-width='0.4315' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath d='m706.69,299.29c-0.764-11.431-6.036-56.734-16.338-71.321,0,0,9.997,14.142,11.095,76.807l5.243-5.486z'/%3E %3Cpath d='m705.16,292.54c-5.615-35.752-25.082-67.015-25.082-67.015,7.349,15.128,20.257,53.835,23.641,77.449l2.328-2.238-0.887-8.196z'/%3E %3Cpath d='m674.47,227.34c16.469,29.836,23.278,73.261,24.321,80.452l5.789-5.565c-5.346-33.638-30.11-74.887-30.11-74.887'/%3E %3Cpath d='m664.8,224.38c2.815,4.744,15.4,29.582,20.514,43.938,4.141,11.628,8.347,32.79,10.206,42.734l7.125-6.849c-6.56-30.92-33.85-73.69-37.84-79.82'/%3E %3Cpath d='m654.57,221.39s21.012,32.359,27.469,54.44c2.043,6.989,8.146,28.02,10.461,37.934l8.215-6.551c-6.506-19.03-26.893-67.197-46.145-85.823'/%3E %3Cpath d='m654.81,240.03c10.932,14.653,29.603,49.287,34.662,76.938l9.453-9.088c-8.159-22.15-34.411-55.826-44.115-67.85'/%3E %3Cpath d='m661.97,260.62c13.04,17.111,23.015,45.735,23.745,59.024l8.084-6.549c-8.229-22.019-31.829-52.475-31.829-52.475'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.2665' stroke-linecap='round'%3E %3Cpath d='m823.61,452.48c-3.0012-14.104-10.055-29.283-16.957-42.468'/%3E %3Cpath d='m829.61,446.19c-6.6042-19.317-18.144-41.614-31.064-61.325'/%3E %3Cpath d='m827.66,427.33c-7.9535-20.237-24.31-59.792-36.915-75.736'/%3E %3Cpath d='m834.41,435.46c-5.702-21.771-18.308-50.745-25.061-64.391'/%3E %3Cpath d='m836.36,428.87c-6.0024-24.07-13.654-45.227-18.459-56.265'/%3E %3Cpath d='m840.26,432.09c-1.8009-19.164-11.706-51.052-19.208-67.764'/%3E %3Cpath d='m838.16,408.17c-0.7498-9.3518-3.751-28.669-5.8511-37.101'/%3E %3C/g%3E %3C/g%3E %3Cg id='flag2' fill='none' stroke='%23000' stroke-width='0.458' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath fill='%23b1babf' d='m486.92,512.12c-0.046,0.094-0.086,0.165-0.111,0.179,0,0-2.727,1.422-5.709,1.624,0,0-2.696,8.413-5.89,11.002,3.716-2.491,9.801-4.766,11.332-4.928,0.078-2.352,0.509-5.128,2.017-6.002l0.218-0.048h0.001c-0.525-0.683-1.147-1.297-1.858-1.827z'/%3E %3Cpath stroke-width='0.23' d='m476.77,523.52,10.946-10.447'/%3E %3Cpath stroke-width='0.23' d='M486.55,519.85,481.11,513.77'/%3E %3Cpath fill='%23b1babf' d='m527.78,478.26-37.48,35.647-1.26,0-2.293-2.064,0.115-1.604,37.709-35.76,3.209,3.781'/%3E %3Cpath stroke-width='0.23' d='m488.69,512.19,35.186-33.01'/%3E %3Cpath fill='%23fd0' d='m517.38,449.99c-24.757-15.589-28.807-63.192-28.425-69.688s0.61-82.524,0.61-82.524l7.326,7.2c-13.332-13.352-28.932-28.999-36.852-37.016-2.537-2.569-0.719,99.609-0.719,144.98,0,21.273,13.271,96.323,91.104,58.556,0,0,38.888-13.962,50.247-30.79-2.648,0-5.267-0.169-7.853-0.494-1.182,0.633-2.445,1.225-3.774,1.774-44.894,30.249-71.664,7.999-71.664,7.999z'/%3E %3Cpath fill='%23034ea2' d='m488.96,380.3c-0.382,6.495,3.668,54.1,28.425,69.688,0,0,26.77,22.25,71.665-7.998-13.575,5.598-24.652,6.783-31.911,4.635-21.701-6.418-44.645-31.48-48.312-56.849-3.668-25.369-2.751-75.189-2.751-75.189l3.259,2.842c-3.621-3.623-7.898-7.904-12.438-12.451l-7.326-7.2c0-0.001-0.229,76.027-0.611,82.522z'/%3E %3Cpath fill='%23ed1c24' d='m520.74,347.46c-0.217-2.3-0.384-10.479-0.392-19.398-5.119-5.118,0.969,1.162-10.954-10.77l-3.323-3.415s-0.004,1.036-0.013,1.636c-0.104,6.892-0.609,50.931,2.766,74.271,3.667,25.369,25.983,50.432,47.684,56.85,7.26,2.148,18.964,0.964,32.538-4.635,0.916-0.618,1.839-1.253,2.771-1.914-39.245-5.588-66.326-42.184-71.077-92.625z'/%3E %3Cpath stroke-width='0.23' d='M519.52,327.41,460.39,267.92'/%3E %3Cpath fill='%23b1babf' stroke-width='0.344' d='m458.98,264.71c-0.912-0.904-2.003-1.46-3.055-1.648,0.162-0.7,0.07-1.321-0.321-1.708-0.832-0.827-2.691-0.298-4.153,1.178-1.461,1.477-1.971,3.344-1.139,4.169,0.39,0.387,1.007,0.472,1.701,0.306,0.197,1.056,0.764,2.147,1.679,3.054,1.945,1.927,4.707,2.292,6.167,0.815,1.461-1.477,1.067-4.238-0.879-6.166z'/%3E %3Cpath d='m458.96,267.62-0.175-0.332c0.001,0,0.062,0.125,0.175,0.332z'/%3E %3Cpath d='m467.89,271.31-1.349,1.035c0.444-0.233,0.895-0.57,1.349-1.035z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m460.84,324.05c0.306-0.993,0.458-8.712,0.458-10.315,0-1.605,0.382-2.522,1.528-10.163,1.146-7.642,0.611-11.997,0.153-16.658-0.459-4.661,0.993-14.656,0.993-14.656l-2.839-2.08c-0.191,0.719-0.5,1.966-0.989,4.138-1.04,4.624-0.231,20.118-0.81,25.437-0.577,5.318-1.618,12.603-1.733,15.725-0.002,0.065-0.01,0.126-0.015,0.188-0.035,3.698,1.112,8.231,1.112,8.231'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m458.64,267.84s-2.658,8.44-2.544,15.724c0.116,7.285-0.809,17.344-0.925,18.847-0.115,1.503-2.081,11.794-0.924,15.378l1.387,1.965s1.769-1.112,1.952-4.089c0.003-0.063,0.011-0.123,0.013-0.188,0.116-3.122,1.156-10.406,1.735-15.726,0.578-5.319-0.231-20.813,0.809-25.437,0.489-2.172,0.798-3.418,0.989-4.138,0.216-0.812,0.283-0.95,0.283-0.95l-2.775-1.386z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m466.62,265.65c-1.457,0.486-5.995,1.31-7.411,1.562-0.27,0.048-0.427,0.076-0.425,0.076,6.5,0.134,9.107,4.027,9.107,4.027l2.197-2.659c1.965-3.237-1.735-3.584-3.468-3.006z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m458.78,267.28,0.175,0.332c0.763,1.393,3.938,6.644,7.584,4.731l1.35-1.035c-0.001,0-2.608-3.894-9.109-4.028z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m459.21,267.21s5.095-5.278,5.961-5.508c0.866-0.229,1.401,1.147,1.859,1.911,0.459,0.764,0.534,1.834-2.522,2.674-3.055,0.84-2.267,0.241-5.298,0.923z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m467.66,260.33c-2.196-3.931-6.244-1.734-6.244-1.734-4.011,2.005-2.978,7.315-2.633,8.69,0.053,0.21,0.09,0.328,0.09,0.328,7.4-11.562,8.671-2.428,8.671-2.428,0.463-2.081,0.116-4.856,0.116-4.856z'/%3E %3Cpath fill='%23e8b909' stroke-width='0.5307' d='m558.44,469.55c0.2843-4.7866,0.63967-11.427-3.0631-11.657-3.7406-0.23189-4.1338,6.4063-4.4175,11.223,2.1982,0.16631,4.0839,0.3619,7.4818,0.49307' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Ccircle fill='%23e8b909' stroke-width='0.458' cx='455.517' cy='318.822' r='2.089'/%3E %3Cpath d='m454.26,324.19s-0.558,5.841-0.611,6.176'/%3E %3Cpath d='m455.88,324.26s0.068,4.427-0.278,6.263'/%3E %3Cpath fill='%23e8b909' stroke-width='0.5307' d='m560.55,463.61s0.38633,5.1707,0.11579,7.342m-1.9718-7.3034s-0.23157,6.8677-0.2694,7.2624m5.0612,0.0797c-3.4001,0.0785-5.2928,0-7.4949,0,0-4.7959-0.001-11.447,3.7475-11.447,3.7085,0,3.7475,6.651,3.7475,11.447z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Ccircle fill='%23e8b909' cx='459.27' cy='321.64' r='2.089'/%3E %3Cellipse fill='%23c0cad0' stroke-width='0.23' cx='452.96' cy='264.03' rx='1.974' ry='3.499' transform='matrix(0.7101,0.7041,-0.7041,0.7101,317.193,-242.381)'/%3E %3Cpath fill='%23b1babf' stroke-width='0.344' d='m448.94,274.96s-2.805-1.607-3.076-4.923c-0.191-2.317,1.43-4.409,2.434-5.48,0.474,0.338,0.877,0.535,1.074,0.541l0.608-0.354,2.159-2.231,1.364-1.342c0.506-0.628,0.856-1.151,0.864-1.36l-0.196-0.492c1.751-1.917,5.711-6.564,3.937-7.736-1.513-0.985-6.032,2.679-7.56,3.983l-0.733-0.317c-0.213,0.023-0.575,0.276-1.026,0.639-0.691-1.393-2.674-5.698-3.121-10.403,0,0-15.828-4.694-20.832-10.677,4.843,6.991,9.442,18.548,9.841,21.462,4.083,0.013,8.867,0.626,10.881,3.012-0.286,0.375-0.484,0.709-0.49,0.869-0.05,0.379,0.072,0.803,0.272,1.223-0.573,0.585-2.485,2.355-4.978,2.795-2.995,0.536-5.738-2.717-5.738-2.717l-0.05-0.003c-0.339,1.074-0.521,2.22-0.521,3.41,0,6.127,4.838,11.094,10.806,11.094,1.492,0,2.913-0.31,4.206-0.872l-0.125-0.121z'/%3E %3Cpath stroke-width='0.23' d='m426.06,236.42,21.319,21.319'/%3E %3Cpath stroke-width='0.23' d='M434.65,256.4,445.53,245.69'/%3E %3Cpath stroke-width='0.344' d='m446.18,260.15c0.06-1.876,1.598-3.353,3.435-3.294,1.838,0.06,3.276,1.633,3.216,3.508s-1.598,3.352-3.434,3.293c-1.837-0.058-3.277-1.632-3.217-3.507z'/%3E %3Cpath stroke-width='0.2665' d='m533,389.88c-0.27398,2.299,0.93199,7.1781,3.3485,9.6457s6.203,4.3181,10.265,3.8133' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3C/g%3E %3Cuse xlink:href='%23flag2' transform='matrix(-1,0,0,1,1440,0)'/%3E %3Cg id='flag3' stroke='%23000' stroke-width='0.458' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath fill='%23fd0' d='m581.88,467.92c-6.188,0.174-17.652,1.607-17.652,1.607s-19.972,26.468-20.453,32.003c-0.481,5.534-0.481,10.105,12.753,8.181,0,0,6.407-1.212,11.691-1.61,5.823-1.894,6.458-0.508,7.07-0.112,0.469-2.016,1.604-6.858,2.965-12.491,2.694-11.151,6.275-25.383,7.347-26.873,0.018-0.13,0.035-0.261,0.052-0.389-0.336-0.297-1.778-0.371-3.773-0.316z'/%3E %3Cpath fill='%23ed1c24' d='m587.08,458.22s-0.287,1.865-0.729,4.964l5.302,2.495s-0.481,7.699-0.722,12.271c-0.159,3.019-2.205,23.759-3.578,37.508-0.461,4.622-0.847,8.45-1.059,10.552,0.271,4.221-3.063,8.007-3.063,8.007-2.235,2.17-3.333,3.96-3.678,5.41-0.037,0.443-0.075,0.86-0.113,1.247,0.012,0.17,0.036,0.334,0.071,0.492,0.571,2.545,4.038,3.488,6.366,3.197,3.851-0.48,11.076-5.087,11.076-5.087l0.715-73.117-10.588-7.939z'/%3E %3Cpath fill='%23034ea2' stroke-linecap='round' d='m586.35,463.18c-0.205,1.439-0.445,3.146-0.704,5.053,0.102,0.09,0.105,0.198-0.01,0.329-0.013,0.017-0.028,0.04-0.042,0.061-1.071,1.489-4.653,15.722-7.348,26.873-1.361,5.633-3.018,12.359-3.486,14.375-0.571,1.254-10.672,12.838-10.862,16.596-0.077,1.537,1.163,2.463,4.653,2.253,5.325-0.319,9.045-1.291,11.687-1.945,3.326-0.823,4.94-1.144,5.879,0.983,0,0,0.065-0.635,0.178-1.751,0.212-2.103,0.597-5.929,1.058-10.552,1.373-13.749,3.419-34.489,3.578-37.508,0.241-4.571,0.722-12.271,0.722-12.271l-5.303-2.496z'/%3E %3Cpath fill='%23ebc900' stroke-width='0.456' d='m574.87,507.48c-0.418-0.309-0.122-1.375-7.419,0.681-1.628,7.314-3.555,18.309-3.555,18.309,0.036-3.718,7.813-11.375,10.061-14.845,1.134-1.751,1.443-3.269,0.913-4.145z'/%3E %3Cpath fill='%23023f88' stroke-width='0.462' d='m585.7,529.77c0.215-0.833,0.511-2.013,0.511-2.013-0.952-2.126-2.588-1.806-5.961-0.982-0.176,4.412-0.398,9.329-0.678,12.676,0.349-1.45,1.445-3.268,3.711-5.437,0,0,1.691-1.434,2.417-4.244z'/%3E %3C/g%3E %3Cuse xlink:href='%23flag3' transform='matrix(-1,0,0,1,1435.184,0)'/%3E %3C/g%3E %3Cg id='condor_tail' fill='%23452c25' stroke='%23000' stroke-width='0.473' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath stroke-width='0.585' d='m593.68,214.48s-8.426,19.153-5.515,21.053c0,0,8.549-14.868,16.052-20.496,3.902-3.601,6.274,0.032,6.777-3.135,0.502-3.168-10.267-7.711-10.267-7.711l-6.894,9.497'/%3E %3Cpath d='m562.94,229.06s-12.246,20.868-9.035,21.113c3.211,0.246,16.305-26.609,16.305-26.609l-4.464,0.748-2.806,4.748z'/%3E %3Cpath d='m566.64,223.25s-12.8,20.532-9.598,20.863c3.203,0.332,17.012-26.163,17.012-26.163l-4.482,0.629-2.932,4.671z'/%3E %3Cpath d='m569.23,219.67s-14.575,19.312-11.414,19.928c3.16,0.615,19.27-24.548,19.27-24.548l-4.521,0.228-3.335,4.392z'/%3E %3Cpath d='m573.13,216.28s-17.065,17.151-14.019,18.19c3.047,1.039,22.43-21.698,22.43-21.698l-4.51-0.39-3.901,3.898z'/%3E %3Cpath d='m573.74,210.04s-14.893,19.069-11.743,19.736,19.674-24.225,19.674-24.225l-4.523,0.153-3.408,4.336z'/%3E %3Cpath d='m569.94,226.43s-14.575,19.312-11.414,19.928c3.16,0.615,19.27-24.548,19.27-24.548l-4.521,0.228-3.335,4.392z'/%3E %3Cpath d='m578.14,222.61s-8.532,15.721-7.558,16.371c0.976,0.65,11.337-8.965,16.457-18.32s-9.265,1.559-9.265,1.559'/%3E %3Cpath stroke-width='0.585' d='m586.61,219.12s-8.426,19.153-5.515,21.053c0,0,10.569-11.555,13.329-20.736,2.757-9.181,0-0.633,0-0.633l-0.767-9.973-6.894,9.497'/%3E %3Cpath stroke-width='0.585' d='m579.05,221.05s-8.426,19.153-5.515,21.053c0,0,10.569-11.555,13.329-20.736,2.757-9.181,0-0.633,0-0.633l-0.767-9.973-6.894,9.497'/%3E %3Cpath d='m574.68,219.38s-17.066,17.151-14.02,18.19,22.431-21.698,22.431-21.698l-4.511-0.39-3.9,3.898z'/%3E %3Cpath d='m576.03,221.7s-17.066,17.151-14.02,18.19c3.048,1.039,22.431-21.698,22.431-21.698l-4.51-0.39-3.901,3.898z'/%3E %3Cpath d='m577.39,224.42s-17.065,17.151-14.019,18.19,22.43-21.698,22.43-21.698l-4.51-0.39-3.901,3.898z'/%3E %3Cpath d='m578.66,200.87s-12.678,15.851-10.851,18.58c1.829,2.729,13.41-7.277,17.067-14.292,3.657-7.016-6.095-4.807-6.095-4.807'/%3E %3Cpath d='m578.26,217.71s-10.867,20.358-8.063,19.189c2.804-1.17,13.82-16.48,15.039-19.858,1.22-3.378,0.809-6.908,0.809-6.908l-8.412,5.067,0.722,3.944'/%3E %3Cpath stroke-width='0.404' d='m578.33,211.01s9.018-16.228-0.063,3.056c-9.08,19.284-12.477,16.1-12.477,16.1-0.7-1.097,7.896-14.163,7.896-14.163s6.383-10.054,7.913-11.009'/%3E %3Cpath stroke-width='0.431' d='m588,208.86s10.029-16.116-0.024,3.06c-10.054,19.176-13.976,15.935-13.976,15.935-0.815-1.111,8.783-14.066,8.783-14.066s7.122-9.971,8.851-10.905'/%3E %3Cpath d='m588.39,209.96s-10.125,21.095-7.809,22.654c0,0,8.411-9.485,10.605-17.02,2.193-7.536,0-0.52,0-0.52l2.812-13.559'/%3E %3Cpath d='m598.82,205.26s-10.125,21.095-7.81,22.654c0,0,8.411-9.485,10.606-17.021,2.194-7.536,0-0.52,0-0.52l2.811-13.559'/%3E %3Cpath d='m584.32,202.05s-12.678,15.851-10.851,18.58c1.829,2.729,13.41-7.277,17.067-14.292,3.657-7.016-6.095-4.807-6.095-4.807'/%3E %3C/g%3E %3Cg id='fasces' fill='%23c69024' stroke='%23000' stroke-width='0.5307'%3E %3Cpath fill='%23b1babf' stroke-width='0.458' d='m682.1,459.3c0,2.913-0.97,3.466-0.97,3.466h-149.07v-6.634h149.08s0.97,0.255,0.97,3.168z' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'/%3E %3Cpath fill='%23b87510' d='m655.42,620.46c0,1.1653,0.024,2.3236,0.0677,3.476h126.56c0.044-1.1478,0.069-2.3013,0.069-3.4631,0-1.3691-0.03-2.73-0.089-4.0803h-126.52c-0.0573,1.3468-0.0894,2.703-0.0894,4.0675z'/%3E %3Cpath fill='%23b76e11' d='m655.51,616.38,126.52,0c-0.084-1.9137-0.2235-3.8074-0.4207-5.6813h-125.68c-0.19832,1.8739-0.33818,3.7688-0.42185,5.6813z'/%3E %3Cpath fill='%23ac620e' d='m655.94,610.69,125.68,0c-0.1972-1.8821-0.454-3.7442-0.7624-5.5829h-124.15c-0.31066,1.8387-0.5663,3.7009-0.76348,5.5829z'/%3E %3Cpath fill='%23a2550b' d='m776.82,599.51-116.1,0c-2.3328,0-3.7016,3.695-4.0215,5.5829h124.15c-0.3164-1.8868-1.8112-5.5829-4.0226-5.5829z'/%3E %3Cpath fill='%23b76e11' d='m655.91,630.01,125.72,0c0.2075-2.0004,0.3462-4.0241,0.4219-6.069h-126.56c0.0734,2.046,0.21437,4.0686,0.41957,6.069z'/%3E %3Cpath fill='%23ac620e' d='m656.56,634.94,124.43,0c0.258-1.6244,0.4746-3.2664,0.6455-4.926h-125.72c0.17195,1.6596,0.38862,3.3027,0.64656,4.926z'/%3E %3Cpath fill='%23a2550b' d='m660.71,640.2,116.09,0c2.2755,0,3.9034-3.476,4.1831-5.2456h-124.43c0.28086,1.7708,1.7184,5.2456,4.1487,5.2456z'/%3E %3Cpath d='m671.4,640.34c-1.1441-3.6107-1.9534-12.013-2.0875-20.901-0.13528-8.8903,2.5598-20.276,2.5598-20.276h-6.2683s-2.6963,11.387-2.5598,20.276c0.13297,8.888,0.94231,17.29,2.0875,20.901h6.2683z'/%3E %3Cpath d='m766.43,640.4c1.1464-3.6107,1.9545-12.013,2.0898-20.902,0.133-8.8891-2.561-20.276-2.561-20.276h6.2672s2.6963,11.387,2.561,20.276c-0.1353,8.8891-0.9435,17.291-2.0887,20.902h-6.2683z'/%3E %3Cpath d='m708.86,640.34c-0.93773-5.3909-1.0455-12.527-1.0455-20.901,0-8.3738,0.88271-17.899,1.5166-20.276h-6.2683c-1.1085,3.551-1.5178,13.033-1.5178,20.276,0,7.2425,0.21209,15.684,1.0455,20.901h6.2695z'/%3E %3Cpath d='m728.44,640.34c0.93773-5.3909,1.0455-12.527,1.0455-20.901,0-8.3738-0.88384-17.899-1.5166-20.276h6.2672c1.1097,3.551,1.5178,13.033,1.5178,20.276,0,7.2425-0.20979,15.684-1.0455,20.901h-6.2683z'/%3E %3Cpath stroke-width='0.5481' d='m686.12,620.17c3.7016,6.6452,11.281,20.39,11.281,20.39l5.2962-0.157s-3.086-6.5433-11.43-20.636c-8.3444-14.093-13.942-20.821-13.942-20.821l-5.2974,0.15811s10.392,14.419,14.092,21.066z'/%3E %3Cpath stroke-width='0.5481' d='m751.71,620.17c-3.7017,6.6452-11.283,20.39-11.283,20.39l-5.2962-0.157s3.0872-6.5433,11.432-20.636c8.3421-14.093,13.942-20.821,13.942-20.821l5.2973,0.15811s-10.392,14.419-14.092,21.066z'/%3E %3Cpath stroke-width='0.5481' d='m749.23,620.17c3.7005,6.6452,11.281,20.39,11.281,20.39l5.2962-0.157s-3.0872-6.5433-11.432-20.636c-8.3444-14.093-13.942-20.821-13.942-20.821l-5.2962,0.15811c0.0009,0,10.392,14.419,14.092,21.066z'/%3E %3Cpath fill='%23b1babf' d='m634.54,627.22s2.7719-13.451-1.6313-21.006c-4.4032-7.5552-10.11-9.7675-11.414-9.2136-1.3057,0.55397,14.012-22.667,30.325-0.36892,0,0-14.346,1.6595-11.41,29.668'/%3E %3Cpath fill='%23d3dce0' stroke='none' d='m623.71,597.01c4.4536-4.9634,14.812-12.417,25.969,0.29044,1.2667-0.56918,2.1357-0.67107,2.1357-0.67107-16.312-22.297-31.628,0.92289-30.324,0.36774,0.36569-0.1546,1.0787-0.0903,2.0119,0.24479,0.0688-0.0773,0.13872-0.1546,0.2075-0.2319'/%3E %3Cpath fill='%23b1babf' d='m631.92,622.28c-1.2942,0.44621-5.1999,1.9184-8.3983,4.6202,0,0-10.853-5.9191-17.866-6.5117-0.59611-0.0504-1.1853-0.13585-1.7173-0.10308,0.54797-0.10068,1.128-0.14639,1.6989-0.27756,7.1178-1.6385,15.85-5.4471,17.754-6.9263,2.5461,2.5836,5.898,5.2292,8.6298,4.995'/%3E %3Cpath fill='none' stroke-width='0.3986' d='m605.71,620.21,26.483,0'/%3E %3Cpath fill='none' stroke-width='0.3986' d='m623.45,612.98,0.10663,13.702'/%3E %3Cpath fill='%23b1babf' d='m640.52,627.22c-0.20864,4.1729-1.3814,7.369-2.8017,7.369-1.441,0-2.6286-3.2898-2.8109-7.5552'/%3E %3Crect fill='%23b1babf' width='13.046' height='13.636' x='631.2' y='613.4'/%3E %3Crect fill='none' width='7.8274' height='8.1794' x='633.81' y='616.12'/%3E %3Crect fill='none' width='3.1307' height='3.2734' x='636.16' y='618.58'/%3E %3Cpath fill='none' d='m649.58,597.36c0.0344-0.0164,0.26481-0.0903,0.30149-0.10656,1.2094-0.52702,2.0302-0.62306,2.0302-0.62306-16.312-22.298-31.629,0.92288-30.324,0.36892,0.3462-0.14639,1.0008-0.0984,1.8606,0.19208,0.0516,0.0164,0.16508,0.0891,0.21552,0.10896'/%3E %3Cpath fill='none' stroke-width='0.2665' d='m649.56,597.28c-11.256-12.768-21.693-5.0419-26.063-0.0867'/%3E %3Cpath stroke-width='0.5481' d='m688.61,620.17c-3.7005,6.6452-11.281,20.39-11.281,20.39l-5.2962-0.157s3.0872-6.5433,11.43-20.636c8.3444-14.093,13.942-20.821,13.942-20.821l5.2974,0.15811s-10.392,14.419-14.092,21.066z'/%3E %3C/g%3E %3Cg id='shield' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'%3E %3Cpath transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)' fill='url(%23grad1)' d='m631.37,476.35c0,62.571,39.414,113.29,88.034,113.29s88.033-50.723,88.033-113.29c0-62.572-39.413-113.3-88.033-113.3s-88.034,50.723-88.034,113.3'/%3E %3Cpath fill='%23395054' stroke='%23000' stroke-width='0.458' d='m641.6,329.09c3.347-2.147,6.543-2.111,10.553-3.377,2.785-0.88,6.16-1.054,8.864-1.688,2.477-0.58,9.951,4.315,12.452,5.065l0.169,6.794s-12.391,1.301-16.815-0.371c-4.425-1.671-15.223-6.845-15.223-6.845'/%3E %3Cpath fill='%23006c3c' d='m567.06,345.54c1.395,1.133,0.231,1.621-0.579,2.547-0.463,0.53,2.663,2.894,6.02,3.936,1.399,0.435,2.084,1.273,2.548,1.968,0.463,0.694,1.505,1.39,3.126,2.548,1.619,1.156,0.347,1.505,4.168,1.62,3.819,0.115,5.324,1.042,6.83,1.39,1.505,0.347,2.431,0.579,6.136,1.042,3.704,0.463,16.832-0.035,16.484,0.081-0.347,0.116-9.199,1.942-10.01,2.407-0.81,0.463-4.97-0.521-5.781-0.058-0.81,0.463-1.62,1.157-2.547,1.853-0.926,0.694-0.23,0.926,0.695,1.157s1.968,0.464,3.589,1.273c1.62,0.81,1.62,0.926,5.209,1.389,3.589,0.464,2.2,0,5.557,0.695,3.358,0.694,2.548,0.463,6.368,0.579,3.82,0.115,0.811,0.463,5.788,0.116,4.979-0.349,3.821-0.232,5.788-0.232,1.968,0,1.969-0.347,4.168-0.463s3.746,3.279,1.547,3.279,1.727-0.689,0.223-0.573c-1.505,0.116-5.475-0.275-6.284,0.188-0.811,0.464-1.62,1.39-3.82,3.012-2.2,1.62-0.463,2.43,0.231,2.893,0.694,0.464,1.736,0.695,2.663,1.042,0.926,0.349,1.852,0.232,4.747,1.274,2.894,1.041,3.588,1.157,5.44,1.272,1.853,0.116,4.516,0.812,4.516,0.812s3.589,1.505,5.44,1.621c1.853,0.115,1.157,0.463,3.473,1.504,2.315,1.042,2.199,0.231,4.053,0.231,1.852,0,2.546,0.232,3.588,0.927,1.042,0.693,2.548,1.273,2.548,1.273s-0.811,2.199-8.452,14.587c-7.64,12.388-19.449,19.796-28.131,24.658-8.683,4.862-20.028,5.441-36.004,3.82-15.977-1.621-31.489-17.712-38.204-26.048-6.714-8.335-9.377-16.671-9.377-16.671l1.389-0.114c0.812-0.116,1.621-0.232,2.895-0.464,1.273-0.232,1.158-0.116,2.663-0.464s1.968-0.348,3.356-0.926c1.391-0.578,0.926-0.81,3.126-1.389s1.505-0.463,2.084-0.579c0.578-0.115,1.505-0.231,2.778-0.695,1.273-0.463,2.779-1.156,1.39-1.852s0-0.812,0-0.812,1.505,0.116,3.588,0.232c2.084,0.115,1.274,0.347,2.663,0.463,1.39,0.116,1.273,0,2.315-0.231,1.042-0.232-0.231-1.389-0.463-2.547-0.231-1.157-0.811-0.463-1.273-0.927-0.463-0.463-0.926-0.23-2.431-1.157-1.506-0.926-1.042-0.115-4.284-1.157-3.241-1.041-0.34,0.934-4.392-0.225s-1.801,0.813-5.157-0.229c-3.358-1.042-4.459-3.367-1.333-2.904s0.926-0.116,1.273-0.579,0.927-0.116,2.778-0.231c1.853-0.116,1.621,0,3.357-0.115,1.735-0.116,2.432-0.579,2.432-0.579s1.504,0.579,2.546,0.579,0.695-0.231,0.695-0.926,1.042,0,1.852,0.23c0.812,0.232,2.778-0.115,2.778-0.115s0.927-0.115,2.663-0.115c1.737,0,0.695-0.349,2.315-0.928,1.621-0.578,0-1.156-0.578-1.272-0.579-0.116-0.695-0.349-1.506-1.042-0.81-0.694-1.491-1.113-2.533-1.46-1.042-0.348-7.137,0.445-8.642-0.018s-1.443-2.343,1.566-2.459c3.01-0.115,1.158,0,2.663,0s1.157,0.231,1.736,0.231c0.578,0,1.157,0,3.589-0.347,2.431-0.349,1.389-0.464,3.01-1.158s3.356-0.463,4.747-1.041c1.389-0.579-0.579-1.158-2.316-1.969-1.736-0.811,0,0.464-1.272-0.811-1.273-1.272-7.747-4.99-9.716-6.726-1.813-1.602,1.563-1.004,3.27-1.77,0,0,0.737-1.683-1.157-2.313-1.893-0.632-1.683-0.632-3.682-1.368s-2.946-2.104-4.419-2.42c-1.474-0.316-2.209-0.737-2.209-0.737'/%3E %3Cpath fill='%236dbe45' d='m567.06,345.54c-0.884,0.65-0.884,1.528-0.579,2.547,0.203,0.674,1.541,3.502,4.898,4.544,1.398,0.434,3.205,0.665,3.669,1.359,0.463,0.694,1.505,1.39,3.126,2.548,1.619,1.156,0.347,1.505,4.168,1.62,3.819,0.115,5.324,1.042,6.83,1.39,1.505,0.347,2.431,0.579,6.136,1.042,3.704,0.463,16.16,0.146,15.813,0.263-0.347,0.116-11.132,2.313-11.941,2.775-0.811,0.464-2.366-1.07-3.178-0.607-0.81,0.463-1.62,1.157-2.547,1.853-0.926,0.694-0.23,0.926,0.695,1.157s1.968,0.464,3.589,1.273c1.62,0.81,1.62,0.926,5.209,1.389,3.589,0.464,2.2,0,5.557,0.695,3.358,0.694,2.548,0.463,6.368,0.579,3.82,0.115,0.768,0.908,5.746,0.561s3.305,0.076,5.272,0.076,2.538,0.575,4.738,0.459c2.198-0.116,7.378,1.404,5.178,1.404-1.365,0-3.501-0.618-5.92-0.432-1.505,0.115-2.976-0.217-3.785,0.246-0.811,0.464-1.62,1.39-3.82,3.012-2.2,1.62-0.463,2.43,0.231,2.893,0.694,0.464,1.736,0.695,2.663,1.042,0.926,0.349,1.852,0.232,4.747,1.274,2.894,1.041,3.588,1.157,5.44,1.272,1.853,0.116,4.516,0.812,4.516,0.812s3.589,1.505,5.44,1.621c1.853,0.115,1.157,0.463,3.473,1.504,2.315,1.042,2.199,0.231,4.053,0.231,1.852,0,2.546,0.232,3.588,0.927,0.653,0.435,1.489,0.824,2.021,1.056,0,0,4.775-13.075,6.628-18.759,1.854-5.685,3.831-22.119,3.831-23.108,0-0.988-2.718-2.472-3.583-2.224-0.864,0.247-4.571,0.247-5.685,0.247h-15.57c-0.988,0-1.729,0.741-3.584-0.124-1.853-0.865-5.189-1.359-6.302-1.235-1.112,0.123-5.685,0.247-6.672,0.247-0.989,0-11.987-0.495-13.841-0.371s-5.314,0.123-7.538,0c-2.225-0.124-5.066-0.124-6.179-0.248-1.112-0.123-5.189-0.37-6.179,0.372-0.989,0.741-3.707,0.988-4.942,1.235s-4.572,0.865-6.303,0.988c-1.729,0.124-6.797,1.112-8.402,0.865-1.607-0.247-7.073-0.27-7.073-0.27'/%3E %3Cpath fill='%23000' d='m567.06,345.42c-1.023,0.877-0.896,2.158-0.371,3.293,0.899,1.946,2.687,3.356,4.69,4.027,1.148,0.385,2.563,0.43,3.538,1.208,0.308,0.244,0.547,0.65,0.849,0.918,0.543,0.483,1.158,0.891,1.748,1.312,0.632,0.45,1.17,0.871,1.676,1.451,0.429,0.494,1.159,0.518,1.763,0.57,1.449,0.129,2.887,0.114,4.325,0.365,1.03,0.18,2.02,0.512,3.009,0.838,1.644,0.541,3.398,0.8,5.105,1.044,4.094,0.585,8.229,0.527,12.358,0.512,1.272-0.005,2.545-0.016,3.817-0.021,0.269-0.001,1.339-0.173,1.56,0.022v-0.229c-0.212,0.122-0.57,0.134-0.805,0.184-0.733,0.16-1.469,0.315-2.204,0.473-1.879,0.402-3.758,0.808-5.632,1.238-1.17,0.27-2.36,0.512-3.479,0.951-0.751,0.294-1.874-0.695-2.645-0.763-0.534-0.049-1.201,0.636-1.59,0.927-0.58,0.432-1.321,0.856-1.733,1.459-0.596,0.868,2.825,1.419,3.254,1.575,0.927,0.339,1.772,0.845,2.674,1.237,0.791,0.346,1.667,0.464,2.513,0.592,1.981,0.299,4.002,0.321,5.97,0.684,2.032,0.374,3.892,0.728,5.956,0.756,1.072,0.015,2.193-0.025,3.245,0.211,0.359,0.08,0.651,0.31,1.006,0.397,0.927,0.229,2.029,0.048,2.962-0.015,1.133-0.074,2.279-0.177,3.415-0.125,1.125,0.054,2.375,0.166,3.471,0.347,2.232,0.367,4.461,0.269,6.676,0.793,0.681,0.161,1.446,0.326,2.055,0.689,0.117,0.069,0.075-0.055-0.026-0.023-0.124,0.038-0.274,0.026-0.401,0.029-0.682,0.015-1.373-0.12-2.044-0.215-1.583-0.223-3.098-0.21-4.689-0.19-1.287,0.016-2.444-0.216-3.526,0.601-0.888,0.67-1.704,1.434-2.582,2.115-0.603,0.469-1.741,1.063-1.768,1.968-0.04,1.491,2.179,2.115,3.269,2.468,1.131,0.367,2.262,0.574,3.411,0.871,1.854,0.479,3.598,1.314,5.479,1.699,1.586,0.325,3.221,0.32,4.816,0.641,0.905,0.183,1.716,0.405,2.569,0.734,1.462,0.563,3.008,1.14,4.578,1.278,1.491,0.131,2.502,1.087,3.857,1.67,1.49,0.641,2.891,0.027,4.445,0.083,1.863,0.065,3.188,1.24,4.831,1.965,0.001-0.001,0.003-0.003,0.004-0.004,1.009-2.763,2.006-5.531,2.995-8.3,1.4-3.918,2.978-7.849,4.042-11.874,1.088-4.117,1.693-8.379,2.303-12.588,0.431-2.979,0.901-5.983,1.117-8.987,0.082-1.134-1.162-1.789-2.043-2.219-0.777-0.38-1.34-0.344-2.153-0.248-1.118,0.132-2.262,0.125-3.387,0.139-2.968,0.037-5.938,0.008-8.905,0.008h-5.705c-1.057,0-2.219-0.13-3.262,0.079-1.221,0.244-2.048,0.205-3.218-0.313-1.234-0.548-2.62-0.805-3.948-1.001-1.899-0.283-3.856-0.008-5.768,0.055-3.168,0.102-6.311-0.048-9.478-0.159-3.861-0.137-7.684-0.038-11.542-0.053-2.875-0.011-5.764-0.148-8.636-0.274-1.964-0.087-3.897-0.341-5.863-0.082-0.866,0.115-1.495,0.613-2.308,0.88-1.176,0.388-2.44,0.495-3.654,0.705-2.221,0.385-4.421,0.858-6.671,1.041-2.736,0.223-5.634,1.22-8.385,0.832-2.27-0.319-4.641-0.24-6.93-0.251-0.018,0-0.019,0.229,0,0.229,3.438,0.017,6.928,0.514,10.343,0.095,4.438-0.545,8.833-1.257,13.244-1.976,1.052-0.172,2.229-0.335,3.134-0.938,0.765-0.507,1.892-0.477,2.77-0.505,2.086-0.066,4.177,0.205,6.261,0.262,2.938,0.081,5.866,0.246,8.806,0.198,1.61-0.027,3.2-0.109,4.812-0.075,3.585,0.076,7.166,0.258,10.75,0.36,3.707,0.105,7.341-0.596,10.997,0.238,1.25,0.284,2.406,0.97,3.665,1.159,0.806,0.123,1.574-0.278,2.376-0.278h14.498c1.429,0,2.856,0.001,4.285-0.043,0.833-0.026,1.647-0.084,2.466-0.229,0.889-0.155,2.063,0.673,2.711,1.177,1.086,0.847,0.624,2.126,0.484,3.319-0.228,1.955-0.486,3.907-0.761,5.857-0.621,4.404-1.269,8.847-2.36,13.164-1.013,4.009-2.61,7.917-3.998,11.806-1.019,2.858-2.048,5.712-3.089,8.562-0.016,0.045-2.821-1.528-3.152-1.664-1.101-0.449-2.549-0.421-3.691-0.175-1.06,0.229-1.81,0.06-2.816-0.374-0.868-0.373-1.618-1.105-2.516-1.378-0.959-0.291-2.022-0.269-3.005-0.544-1.03-0.288-2.039-0.663-3.033-1.057-1.585-0.627-3.445-0.864-5.132-0.974-2.452-0.158-4.61-1.149-6.944-1.825-1.933-0.561-4.038-0.705-5.773-1.827-0.308-0.198-0.604-0.39-0.866-0.645-0.866-0.842,0.525-1.766,1.113-2.204,1.004-0.748,1.929-1.591,2.911-2.366,0.938-0.741,1.985-0.642,3.13-0.607,1.721,0.051,3.366-0.04,5.086,0.197,0.32,0.044,2.805,0.672,2.568-0.159-0.092-0.328-1.209-0.527-1.464-0.601-1.036-0.301-2.106-0.506-3.178-0.62-1.133-0.123-2.251,0.006-3.384-0.199-1.041-0.188-2.046-0.239-3.095-0.323-1.154-0.092-2.211-0.19-3.393-0.128-1.632,0.087-3.336,0.456-4.865-0.21-0.748-0.326-1.711-0.264-2.502-0.286-1.031-0.029-2.067,0.002-3.096-0.072-1.736-0.124-3.411-0.703-5.138-0.897-1.855-0.208-3.707-0.307-5.556-0.622-1.594-0.271-2.883-1.111-4.369-1.698-0.979-0.387-2.052-0.504-3.015-0.919-0.479-0.207,1.364-1.557,1.494-1.656,0.455-0.35,0.999-0.861,1.59-0.928,0.729-0.081,1.552,0.604,2.252,0.767,0.37,0.086,0.808-0.176,1.163-0.28,1.326-0.392,2.688-0.673,4.037-0.976,1.631-0.365,3.266-0.715,4.901-1.064,0.691-0.147,1.79-0.17,2.411-0.529,0.026-0.015,0.022-0.21,0-0.229-0.109-0.099-0.589-0.023-0.722-0.024-0.709-0.003-1.419,0.004-2.129,0.008-2.06,0.015-4.12,0.025-6.181,0.013-4.01-0.023-7.961-0.21-11.895-1.063-1.769-0.384-3.447-1.07-5.232-1.382-1.416-0.247-2.852-0.207-4.276-0.334-0.602-0.054-1.159-0.151-1.568-0.62-0.561-0.646-1.215-1.097-1.913-1.594-0.492-0.352-0.981-0.709-1.445-1.097-0.382-0.318-0.637-0.75-1.021-1.056-0.943-0.753-2.587-0.809-3.706-1.185-1.249-0.418-2.336-1.23-3.21-2.2-1.033-1.146-2.269-3.261-0.769-4.547,0.046-0.038-0.026-0.206,0-0.229'/%3E %3Cpath fill='%236dbe45' d='m564.64,348.63c1.232,1.484,0.128,0.47-2.826,2.027-2.321,1.226,10.005,7.528,11.278,8.801,1.272,1.274-0.463,0,1.272,0.812,1.737,0.81,3.705,1.389,2.316,1.968-1.39,0.578-3.126,0.347-4.746,1.042-1.621,0.694-0.579,0.81-3.011,1.157s-3.01,0.348-3.588,0.348c-0.579,0-0.442-0.216-1.948-0.216-1.505,0-0.237,0.303-3.247,0.412-0.298,0.01-4.248,0.448-4.214,0.452,1.898,0.201,6.392,0.39,8.406,0.472,1.113,0.046,2.145,0.573,3.664,1.08,1.042,0.347,1.737,0.81,2.548,1.504,0.811,0.695,0.926,0.926,1.505,1.042s2.199,0.695,0.579,1.274c-1.62,0.578-0.579,0.926-2.315,0.926-1.737,0-2.663,0.116-2.663,0.116s-1.968,0.347-2.779,0.114c-0.81-0.23-1.852-0.926-1.852-0.23s0.348,0.926-0.694,0.926-2.547-0.579-2.547-0.579-0.695,0.464-2.431,0.579c-1.737,0.116-1.505,0-3.358,0.116-1.852,0.116-2.835-0.345-2.778,0.23,0.111,1.124-1.595,0.61-1.307,1.433,0.253,0.084-2.143,0.088-1.952,0.144,3.357,1.042,4.302-0.418,8.354,0.74,4.051,1.158,1.272,0.579,4.515,1.62,3.241,1.042,2.778,0.232,4.283,1.158s1.968,0.693,2.431,1.158c0.463,0.463,1.042-0.232,1.274,0.926,0.23,1.158,1.505,2.314,0.463,2.546s-0.926,0.348-2.315,0.231c-1.39-0.115-0.579-0.347-2.663-0.463-2.084-0.114-3.589-0.23-3.589-0.23s-1.389,0.115,0,0.81c1.39,0.695-0.115,1.39-1.389,1.853-1.274,0.464-2.2,0.58-2.779,0.694-0.579,0.116,0.116,0-2.084,0.579-2.198,0.579-1.735,0.812-3.126,1.39-1.389,0.578-1.852,0.578-3.355,0.926-1.506,0.348-1.391,0.23-2.663,0.463-1.274,0.231-2.084,0.348-2.895,0.464-0.811,0.115-2.309,0.366-2.309,0.366s-5.33-8.628-7.983-19.336c-2.652-10.709-3.854-28.118-3.854-28.971,0-0.854,3.92-0.887,5.247-0.412,1.327,0.474,7.676,0.947,10.614,1.326,2.938,0.38,10.234,1.423,10.804,1.611,0.567,0.19,2.31-0.956,3.73-0.008,1.423,0.948,5.557,3.799,5.557,3.799'/%3E %3Cpath fill='%23000' d='m564.64,348.74c0.169,0.206,0.66,0.573,0.277,0.723-0.346,0.136-0.75,0.177-1.108,0.272-0.603,0.16-2.034,0.445-2.273,1.113-0.182,0.508,0.287,1.027,0.599,1.356,1.093,1.157,2.545,2.027,3.874,2.883,1.563,1.007,3.165,1.953,4.753,2.92,0.557,0.34,1.111,0.684,1.653,1.046,0.178,0.118,0.351,0.242,0.517,0.373,0.057,0.045,0.109,0.094,0.161,0.143,0.126,0.124,0.247,0.252,0.363,0.385,0.125,0.238,0.17,0.235,0.135-0.012-0.178,0.089,0.71,0.409,0.774,0.438,0.693,0.311,1.396,0.601,2.079,0.933,0.955,0.466,0.252,0.828-0.427,1.021-0.827,0.236-1.72,0.263-2.567,0.398-0.986,0.156-1.874,0.523-2.674,1.107-0.829,0.607-2.316,0.548-3.284,0.67-0.682,0.085-1.366,0.152-2.054,0.155-0.813,0.004-1.59-0.238-2.425-0.206-0.353,0.013-0.646,0.16-0.981,0.238-0.729,0.169-1.497,0.123-2.239,0.193-1.28,0.124-2.598,0.201-3.865,0.424-0.021,0.003-0.018,0.227,0,0.229,4.912,0.497,10.552-0.347,14.618,3.056,0.416,0.35,0.772,0.772,1.281,0.984,0.39,0.163,0.796,0.208,1.181,0.411,0.751,0.395-0.751,0.841-0.992,0.961-0.323,0.161-0.488,0.479-0.835,0.594-0.981,0.324-2.313,0.067-3.357,0.161-0.684,0.062-1.354,0.187-2.045,0.211-0.532,0.021-0.973-0.088-1.466-0.281-0.341-0.133-0.926-0.512-1.255-0.211-0.239,0.221,0.156,0.79-0.088,1.023-0.557,0.53-2.452-0.233-3.054-0.443-0.181-0.062-0.199-0.009-0.381,0.075-0.553,0.254-1.178,0.342-1.774,0.418-1.01,0.129-2.034,0.075-3.049,0.113-0.73,0.025-1.447,0.07-2.18,0.029-0.364-0.021-0.949-0.188-1.272,0.043-0.064,0.045-0.055,0.197-0.058,0.255-0.018,0.4-0.196,0.574-0.548,0.719-0.356,0.146-0.793,0.144-0.793,0.614,0,0.09-0.008,0.227,0.063,0.286v-0.229c-0.604,0.216-1.351-0.002-1.978,0.119-0.021,0.003-0.018,0.204-0.003,0.225,0.14,0.207,1.028,0.271,1.276,0.315,0.518,0.093,1.047,0.104,1.571,0.094,1.126-0.021,2.222-0.176,3.351-0.083,1.681,0.138,3.49,0.659,4.993,1.436,1.564,0.807,3.304,0.948,4.982,1.307,0.854,0.182,1.581,0.852,2.401,1.153,0.311,0.113,0.622,0.18,0.9,0.365,0.377,0.251,0.66,0.216,1.061,0.377,0.348,0.143,0.603,1.423,0.781,1.771,0.309,0.603,0.56,1.069-0.27,1.264-0.938,0.222-1.852,0.293-2.806,0.044-0.922-0.24-1.779-0.334-2.746-0.39-0.88-0.052-1.886-0.269-2.765-0.179-0.239,0.023-0.595,0.076-0.595,0.371,0,0.739,1.839,0.869,0.567,1.701-1.508,0.986-3.48,1.104-5.188,1.59-1.046,0.296-2.138,0.489-3.063,1.088-0.945,0.608-2.009,0.969-3.103,1.212-2.36,0.525-4.747,0.899-7.141,1.251-0.276,0.04-1.951,0.485-2.084,0.266-0.214-0.352-0.418-0.709-0.621-1.067-0.958-1.694-1.832-3.436-2.655-5.198-2.555-5.472-4.411-11.196-5.562-17.122-1.03-5.312-1.689-10.695-2.236-16.074-0.207-2.031-0.389-4.064-0.545-6.101-0.051-0.657-0.52-2.478,0.183-2.845,1.476-0.771,3.726-0.298,5.241,0.081,2.096,0.523,4.353,0.603,6.494,0.818,4.316,0.436,8.615,1.036,12.899,1.715,0.541,0.086,1.092,0.158,1.623,0.29,0.346,0.086,0.7-0.049,1.034-0.138,0.715-0.193,1.384-0.298,2.116-0.146,0.852,0.179,1.771,1.062,2.475,1.542,0.92,0.628,1.839,1.261,2.758,1.893,0.316,0.217,0.632,0.435,0.948,0.652-0.022-0.016,0.046-0.197,0-0.229-1.378-0.951-2.759-1.899-4.142-2.842-0.842-0.574-1.626-1.254-2.677-1.337-0.908-0.071-1.757,0.542-2.646,0.344-3.766-0.838-7.722-1.24-11.552-1.678-2.419-0.276-4.847-0.475-7.264-0.779-1.744-0.219-3.388-0.752-5.159-0.741-0.691,0.004-2.556-0.08-2.521,0.96,0.03,0.92,0.112,1.841,0.184,2.758,1.222,15.681,3.245,31.867,11.657,45.53l0.004,0.004c4.277-0.714,8.85-0.914,12.698-3.035,1.365-0.753,3.173-1.03,4.712-1.337,0.889-0.176,4.191-0.745,3.682-2.21-0.06-0.175-1.189-0.692-0.961-0.847,0.116-0.079,0.349-0.124,0.491-0.113,1.188,0.09,2.378,0.162,3.566,0.229,1.83,0.104,3.347,0.815,5.192,0.154,0.238-0.085,0.207-0.437,0.188-0.625-0.033-0.33-0.259-0.66-0.408-0.946-0.223-0.424-0.331-1.352-0.658-1.658-0.27-0.253-0.584-0.169-0.915-0.28-0.279-0.094-0.506-0.365-0.812-0.466-0.94-0.314-1.729-0.927-2.654-1.241-0.412-0.139-0.889-0.121-1.316-0.186-1.074-0.162-2.128-0.532-3.148-0.896-0.917-0.327-1.738-0.757-2.688-1.041-1.254-0.373-2.495-0.666-3.808-0.696-0.908-0.022-1.813,0.116-2.721,0.135-0.444,0.009-0.887-0.036-1.326-0.1-0.314-0.044-0.621-0.124-0.928-0.202-0.19-0.049-0.451,0.117-0.078,0.097,0.522-0.031,1.212,0.083,1.71-0.095,0.023-0.01,0.02-0.213,0-0.229-0.187-0.158,0.835-0.484,0.886-0.506,0.223-0.09,0.366-0.277,0.406-0.511,0.033-0.198,0.006-0.422,0.233-0.485,0.505-0.14,1.233,0.056,1.749,0.071,1.061,0.031,2.148-0.059,3.212-0.085,1.098-0.028,2.313-0.079,3.31-0.594,0.425-0.22,3.385,1.382,3.365,0.146-0.005-0.298-0.149-0.773,0.236-0.828,0.45-0.063,1.132,0.393,1.551,0.532,0.822,0.272,1.918,0.026,2.75-0.11,0.743-0.123,1.525-0.106,2.274-0.119,0.489-0.008,1.091,0.083,1.535-0.175,0.427-0.247,0.702-0.557,1.198-0.753,1.595-0.633,0.094-1.329-0.803-1.561-0.492-0.127-0.92-0.666-1.281-0.984-0.494-0.433-1.026-0.803-1.604-1.115-1.245-0.672-2.906-1.232-4.306-1.444-2.374-0.359-4.901-0.214-7.3-0.379-0.471-0.032-0.94-0.07-1.409-0.117v0.229c1.046-0.183,2.13-0.241,3.186-0.353,1.07-0.113,2.275,0.01,3.286-0.372,0.968-0.366,1.963,0.038,2.938,0.077,1.426,0.055,2.916-0.229,4.312-0.463,0.481-0.08,0.908-0.191,1.296-0.487,0.724-0.557,1.624-0.812,2.506-0.984,0.648-0.127,3.736-0.119,3.708-1.133-0.009-0.32-0.2-0.434-0.463-0.607-0.858-0.565-2.03-1.027-3.006-1.344-0.325-0.104-0.11,0.3-0.086,0.288,0.032-0.016,0.012-0.194,0.002-0.225-0.148-0.455-0.806-0.854-1.19-1.116-0.76-0.519-1.555-0.986-2.342-1.463-1.989-1.205-3.994-2.394-5.898-3.731-0.717-0.502-1.425-1.032-2.04-1.655-0.228-0.228-0.438-0.483-0.563-0.782-0.203-0.492,1.114-0.835,1.346-0.931,0.357-0.146,2.125-0.348,2.226-0.776,0.088-0.375-0.297-0.724-0.503-0.975,0.032,0.035-0.039,0.178,0.004,0.23'/%3E %3Cpath fill='%23557176' d='m525.48,343.25s0.229-1.834,4.813-1.834,3.209,0.459,8.481,1.146c5.272,0.688,9.17,0.688,11.004,0.917s5.73,0.688,7.105,1.146c1.375,0.459,3.669,1.604,3.669,1.604s-0.917,0.688,2.979,0.688c3.897,0,2.75-0.23,8.252-0.23s1.834,1.376,8.94,0c7.105-1.375,12.607-2.063,14.441-2.521,1.834-0.459-2.063-1.834,4.814-0.917s10.086,0.229,11.231,0.229c1.146,0,5.96,0.229,8.253,0.229,2.292,0,5.501,0,6.878,0.229,1.375,0.229,3.438-0.229,6.418,0.229,2.979,0.458,3.668-0.917,5.96,0.458,2.293,1.376,6.419,0.459,8.022,0.229,1.605-0.229,4.814,0,5.731,0s5.272,0.458,7.336,0.458c2.063,0,6.188-0.458,6.188-0.458l3.897,0.458s0.688-9.856,0.688-11.003c0-1.146,2.487-2.864-1.901-3.281-16.137-1.532-9.889-2.517-19.417-3.138-2.292-0.458-13.296-3.209-15.588-3.667-2.292-0.459-14.672-4.127-18.34-4.127-3.667,0-12.837,0.459-15.129,0.459s-22.235-0.459-24.985-0.459c0,0-7.336-2.521-9.17-3.209s-2.063-0.458-8.023-0.229-7.335,0.917-12.837,0.229-10.086,0-12.608,0.459c-2.521,0.458-6.188,1.834-6.188,1.834l-0.914,24.072z'/%3E %3Cpath fill='%23000' d='m525.5,343.44c0.083-0.553,0.717-0.943,1.158-1.173,1.563-0.809,3.584-0.661,5.28-0.602,1.119,0.039,2.172,0.25,3.258,0.501,2.027,0.471,4.107,0.704,6.175,0.915,3.417,0.35,6.848,0.414,10.257,0.85,1.698,0.217,3.44,0.404,5.095,0.863,1.327,0.368,2.61,1.046,3.838,1.657v-0.458c-0.208,0.165-0.167,0.65,0.029,0.802,0.589,0.456,1.848,0.326,2.522,0.341,1.008,0.023,2.021-0.001,3.027-0.053,3.234-0.168,6.445-0.414,9.606,0.363,0.506,0.125,1.046,0.073,1.559,0.025,1.448-0.138,2.882-0.459,4.309-0.73,3.063-0.583,6.143-1.086,9.222-1.581,0.979-0.157,1.959-0.314,2.936-0.487,0.562-0.099,1.255-0.145,1.763-0.423,0.183-0.1,0.217-0.283,0.222-0.474,0.006-0.214,0.058-0.756-0.059-0.37,0.101-0.332,0.941-0.243,1.165-0.241,1.481,0.02,2.959,0.296,4.428,0.466,2.501,0.289,5.027,0.397,7.543,0.248,3.558-0.212,7.076,0.04,10.642,0.051,2.532,0.007,5.023,0.157,7.543,0.291,1.225,0.065,2.459-0.067,3.687-0.03,1.557,0.049,3.033,0.406,4.596,0.19,1.019-0.141,1.861-0.246,2.842,0.156,0.563,0.229,1.045,0.565,1.63,0.756,0.679,0.22,1.413,0.267,2.121,0.292,2.274,0.079,4.485-0.592,6.754-0.611,4.152-0.034,8.296,0.721,12.44,0.522,1.131-0.056,2.26-0.157,3.387-0.264,0.479-0.045,1.072-0.211,1.552-0.154,1.293,0.151,2.587,0.304,3.88,0.456,0.017,0.002,0.021-0.109,0.021-0.113,0.211-3.014,0.417-6.03,0.595-9.046,0.072-1.219,0.087-2.093,0.601-3.204,0.372-0.805,0.268-1.613-0.585-2.004-1.275-0.585-2.983-0.482-4.354-0.628-1.397-0.148-2.791-0.316-4.182-0.514-1.516-0.214-3.031-0.469-4.513-0.858-1.811-0.478-3.492-1.052-5.37-1.271-1.54-0.179-3.026-0.27-4.54-0.62-1.99-0.461-3.977-0.944-5.963-1.425-3.145-0.758-6.316-1.428-9.448-2.231-4.095-1.052-8.162-2.208-12.3-3.09-1.608-0.344-3.244-0.679-4.896-0.668-2.218,0.012-4.437,0.106-6.653,0.188-3.22,0.119-6.441,0.302-9.665,0.25-3.628-0.058-7.256-0.139-10.884-0.213-3.655-0.075-7.311-0.155-10.967-0.21-0.854-0.013-1.518,0.001-2.318-0.274-1.824-0.629-3.646-1.26-5.466-1.897-1.976-0.692-3.798-1.554-5.921-1.505-4.159,0.095-8.294,0.53-12.446,0.723-2.277,0.105-4.506-0.199-6.767-0.413-2.527-0.24-5.079-0.182-7.603,0.068-3.403,0.336-6.674,1.17-9.875,2.364-0.028,0.012-0.021,0.148-0.022,0.17-0.305,8.022-0.611,16.046-0.917,24.068-0.005,0.146,0.032,0.443,0.045,0.122,0.212-5.574,0.424-11.146,0.636-16.72,0.092-2.391,0.184-4.78,0.274-7.171,0.002-0.056,0.004-0.111,0.006-0.167-0.01,0.246,0.143,0.096,0.351,0.021,1.09-0.395,2.192-0.753,3.305-1.081,2.336-0.688,4.76-1.037,7.184-1.237,3.316-0.276,6.526,0.076,9.823,0.358,2.414,0.207,4.798,0.002,7.204-0.197,2.799-0.23,5.613-0.327,8.421-0.438,1.183-0.047,2.233,0.025,3.349,0.438,3.033,1.124,6.103,2.155,9.161,3.207,0.278,0.097,0.75,0.009,1.044,0.013,0.664,0.009,1.328,0.02,1.993,0.03,1.817,0.032,3.634,0.068,5.45,0.104,6.665,0.133,13.351,0.458,20.015,0.218,2.419-0.087,4.837-0.186,7.256-0.266,1.798-0.06,3.646-0.217,5.438-0.025,4.184,0.445,8.336,1.73,12.389,2.803,6.668,1.766,13.408,3.398,20.15,4.854,1.465,0.315,3.035,0.253,4.523,0.497,0.836,0.136,1.646,0.354,2.45,0.613,2.857,0.918,5.815,1.327,8.79,1.678,1.574,0.186,3.165,0.286,4.734,0.512,0.884,0.127,2.093,0.425,1.592,1.509-0.451,0.977-0.479,1.671-0.537,2.739-0.175,3.18-0.401,6.357-0.623,9.534,0.01-0.128-3.229-0.436-3.737-0.495-0.396-0.046-0.821,0.056-1.217,0.095-1.187,0.119-2.376,0.221-3.567,0.293-4.227,0.257-8.483-0.5-12.722-0.506-2.272-0.004-4.475,0.63-6.754,0.611-1.255-0.011-2.377-0.296-3.466-0.91-1.016-0.573-2.027-0.462-3.127-0.294-1.426,0.218-2.788-0.071-4.209-0.171-1.358-0.095-2.715,0.042-4.073,0.011-1.027-0.025-2.055-0.207-3.087-0.245-1.484-0.053-2.971-0.047-4.456-0.047-3.565,0-7.085-0.281-10.642-0.05-2.517,0.163-5.04,0.022-7.543-0.248-1.409-0.153-2.808-0.386-4.223-0.459-0.347-0.018-1.099-0.124-1.356,0.205-0.086,0.108-0.063,0.32-0.059,0.447,0.002,0.074,0.009,0.149,0.021,0.224,0.047,0.302,0.036,0.004,0.02,0.043-0.13,0.319-0.778,0.359-1.051,0.416-0.811,0.17-1.63,0.299-2.447,0.433-2.55,0.418-5.102,0.819-7.646,1.266-2.57,0.451-5.166,1.153-7.778,1.308-0.856,0.051-1.574-0.282-2.398-0.436-2.014-0.378-4.197-0.191-6.232-0.111-1.338,0.053-2.668,0.159-4.008,0.171-1.042,0.009-2.121,0.039-3.145-0.188-0.169-0.038-0.404-0.102-0.5-0.264,0.201,0.344-0.105,0.367,0.074,0.224,0.044-0.035,0.049-0.434,0-0.458-1.24-0.618-2.513-1.245-3.838-1.658-1.719-0.536-3.614-0.673-5.393-0.901-3.584-0.458-7.201-0.513-10.793-0.898-3.188-0.342-6.3-1.298-9.506-1.353-1.297-0.021-5.251-0.155-5.555,1.861-0.017,0.09,0.015,0.434,0.021,0.395'/%3E %3Cg fill='%2399afca'%3E %3Cpath d='m655.19,337.19c-0.431,0.861-0.868,1.716-1.374,2.536-0.064,0.104,0.042,0.391,0.012,0.438,0.506-0.819,0.943-1.676,1.373-2.536,0.056-0.113-0.04-0.381-0.011-0.438'/%3E %3Cpath d='m537.59,335.71c-0.535,0.75-1.061,1.503-1.479,2.324-0.058,0.113,0.041,0.383,0.013,0.439,0.42-0.821,0.943-1.575,1.479-2.324,0.068-0.097-0.041-0.399-0.013-0.439'/%3E %3Cpath d='m540.65,334.47c-0.019,0.111-0.086,0.203-0.104,0.316-0.019,0.102-0.016,0.209-0.01,0.312,0.001,0.014,0.017,0.169,0.031,0.082,0.021-0.112,0.086-0.204,0.106-0.318,0.017-0.1,0.014-0.209,0.008-0.311-0.001-0.014-0.016-0.169-0.031-0.081'/%3E %3Cpath d='m544.35,332.96c-0.225,0.865-0.532,1.7-0.846,2.536-0.046,0.123,0.037,0.371,0.012,0.439,0.313-0.836,0.622-1.673,0.846-2.536,0.033-0.129-0.032-0.361-0.012-0.439'/%3E %3Cpath d='m545.6,332.23c-0.006,0.506-0.102,1-0.2,1.494-0.021,0.1-0.015,0.211-0.008,0.311,0.001,0.017,0.014,0.168,0.03,0.082,0.125-0.627,0.216-1.247,0.224-1.887,0.002-0.259-0.043-0.258-0.046,0'/%3E %3Cpath d='m547.94,330.54c-1.131,1.86-2.19,3.761-3.17,5.706-0.057,0.112,0.041,0.382,0.013,0.438,0.979-1.944,2.039-3.844,3.169-5.705,0.064-0.105-0.041-0.392-0.012-0.439'/%3E %3Cpath d='m549.31,329.75c-0.143,1.398-0.721,2.675-1.258,3.956-0.05,0.12,0.039,0.375,0.012,0.439,0.556-1.323,1.132-2.633,1.278-4.074,0.006-0.058-0.013-0.499-0.032-0.321'/%3E %3Cpath d='m550.57,329.74c-0.017,0.923-0.213,1.819-0.412,2.717-0.021,0.088,0.014,0.434,0.022,0.392,0.22-0.988,0.416-1.972,0.434-2.987,0.002-0.147-0.039-0.442-0.044-0.122'/%3E %3Cpath d='m552.16,329.54c0.062,0.747-0.26,1.471-0.519,2.155-0.046,0.122,0.038,0.371,0.013,0.438,0.367-0.976,0.626-1.868,0.537-2.915-0.015-0.177-0.036,0.263-0.031,0.322'/%3E %3Cpath d='m541.19,340.39c0.515-0.282,0.964-0.668,1.479-0.951,0.088-0.048-0.034-0.437,0-0.455-0.515,0.282-0.964,0.669-1.479,0.951-0.087,0.048,0.034,0.436,0,0.455'/%3E %3Cpath d='m544.24,338.78c-0.183,0.277-0.345,0.567-0.527,0.845-0.04,0.062-0.019,0.213-0.017,0.28,0,0.016,0.014,0.181,0.028,0.159,0.183-0.278,0.345-0.567,0.528-0.846,0.04-0.061,0.018-0.213,0.016-0.279,0-0.017-0.013-0.182-0.028-0.159'/%3E %3Cpath d='m561.04,326.2c-0.112,0.314-0.29,0.596-0.521,0.837-0.04,0.041-0.023,0.177-0.023,0.228,0,0.02,0.027,0.224,0.023,0.228,0.236-0.245,0.419-0.532,0.534-0.854,0.029-0.083,0.018-0.193,0.016-0.279,0-0.021-0.023-0.179-0.029-0.16'/%3E %3Cpath d='m561.9,329.71c1.107-1.308,1.82-2.945,1.71-4.675-0.019-0.28-0.044,0.155-0.039,0.229,0.09,1.421-0.784,2.943-1.671,3.99-0.086,0.102,0.057,0.389,0,0.456'/%3E %3Cpath d='m565.36,324.78c-0.013,0.962-0.205,1.89-0.412,2.823-0.02,0.088,0.014,0.435,0.023,0.393,0.227-1.025,0.418-2.042,0.433-3.095,0.002-0.145-0.039-0.44-0.044-0.121'/%3E %3Cpath d='m562.52,325.15c-0.36,1.221-1.039,2.299-1.69,3.381-0.063,0.105,0.041,0.391,0.013,0.438,0.651-1.083,1.33-2.159,1.689-3.381,0.037-0.127-0.035-0.363-0.012-0.438'/%3E %3Cpath d='m549.42,336.77c-0.229,0.572-0.466,1.139-0.74,1.691-0.056,0.114,0.041,0.381,0.012,0.438,0.274-0.553,0.512-1.12,0.74-1.69,0.048-0.121-0.038-0.373-0.012-0.439'/%3E %3Cpath d='m550.8,336.77c-0.418,0.626-0.839,1.248-1.368,1.788-0.089,0.091,0.057,0.398,0,0.455,0.534-0.544,0.959-1.172,1.381-1.804,0.067-0.101-0.041-0.395-0.013-0.439'/%3E %3Cpath d='m553.65,337.3c-0.211,0.423-0.422,0.845-0.634,1.269-0.036,0.071-0.017,0.203-0.016,0.279,0.001,0.017,0.018,0.181,0.028,0.159,0.212-0.423,0.423-0.846,0.634-1.268,0.036-0.073,0.018-0.203,0.016-0.28,0-0.015-0.016-0.179-0.028-0.159'/%3E %3Cpath d='m554.92,336.03c-0.546,1.194-1.14,2.37-2.001,3.373-0.086,0.1,0.057,0.389,0,0.455,0.865-1.007,1.464-2.189,2.013-3.39,0.053-0.116-0.041-0.378-0.012-0.438'/%3E %3Cpath d='m581.23,327.25c-0.275,0.193-0.486,0.451-0.641,0.748-0.037,0.071-0.018,0.204-0.016,0.279,0,0.016,0.017,0.181,0.028,0.159,0.15-0.292,0.358-0.541,0.628-0.731,0.039-0.027,0.022-0.188,0.022-0.228,0.001-0.012-0.018-0.228-0.021-0.227'/%3E %3Cpath d='m580.92,331.51c1.631-1.007,2.429-3.132,2.453-4.981,0.003-0.26-0.042-0.259-0.046,0-0.021,1.661-0.976,3.643-2.407,4.526-0.089,0.056,0.039,0.431,0,0.455'/%3E %3Cpath d='m568.34,334.02c-0.536,0.731-1.22,1.33-2.002,1.788-0.088,0.052,0.038,0.433,0,0.455,0.789-0.462,1.473-1.067,2.014-1.804,0.07-0.095-0.04-0.4-0.012-0.439'/%3E %3Cpath d='m564.96,339.86c2.669-0.736,4.843-2.977,6.239-5.291,0.063-0.105-0.041-0.39-0.012-0.438-1.389,2.301-3.569,4.541-6.228,5.275-0.068,0.018,0.006,0.453,0.001,0.454'/%3E %3Cpath d='m569.19,342.82c1.114-0.609,2.047-1.604,2.753-2.648,0.066-0.101-0.041-0.397-0.013-0.439-0.701,1.037-1.633,2.028-2.74,2.633-0.088,0.046,0.033,0.435,0,0.454'/%3E %3Cpath d='m575.1,338.98c-1.577,2.082-3.356,3.955-5.388,5.6-0.092,0.074,0.049,0.415,0,0.455,2.031-1.645,3.811-3.518,5.388-5.6,0.082-0.108-0.057-0.38,0-0.455'/%3E %3Cpath d='m576.7,338.26c0.328-0.662,0.666-1.336,1.155-1.895,0.086-0.099-0.057-0.39,0-0.455-0.495,0.565-0.836,1.242-1.168,1.91-0.056,0.115,0.04,0.383,0.013,0.44'/%3E %3Cpath d='m581.13,342.38c0.917-1.649,1.767-3.441,3.164-4.746,0.09-0.085-0.055-0.405,0-0.455-1.403,1.312-2.255,3.107-3.177,4.763-0.06,0.108,0.042,0.386,0.013,0.438'/%3E %3Cpath d='m584.93,338.88c-0.939,1.032-1.971,1.98-2.854,3.063-0.084,0.104,0.058,0.386,0,0.455,0.883-1.084,1.914-2.031,2.854-3.063,0.087-0.097-0.056-0.394,0-0.455'/%3E %3Cpath d='m595.71,337c0.469-1.27,0.684-2.626,0.649-3.978-0.009-0.319-0.048-0.024-0.044,0.121,0.029,1.154-0.219,2.338-0.618,3.418-0.045,0.123,0.038,0.371,0.013,0.439'/%3E %3Cpath d='m595.06,333.09c-0.297,1.346-0.417,2.749-1.051,3.992-0.058,0.112,0.041,0.383,0.012,0.438,0.642-1.258,0.763-2.678,1.063-4.039,0.019-0.087-0.014-0.432-0.024-0.391'/%3E %3Cpath d='m597.6,332.99c-0.196,1.305-0.15,2.636-0.629,3.886-0.046,0.122,0.038,0.372,0.013,0.439,0.485-1.269,0.44-2.608,0.64-3.934,0.013-0.088-0.018-0.429-0.024-0.391'/%3E %3Cpath d='m598.96,334.18c-0.027,1.302-0.413,2.567-0.935,3.751-0.053,0.118,0.04,0.376,0.012,0.438,0.57-1.291,0.938-2.652,0.967-4.067,0.003-0.146-0.037-0.441-0.044-0.122'/%3E %3Cpath d='m600.34,334.99c0.145,2.604-1.06,5.218-2.728,7.158-0.087,0.101,0.057,0.39,0,0.455,1.875-2.183,2.928-4.96,2.767-7.844-0.014-0.28-0.042,0.157-0.039,0.231'/%3E %3Cpath d='m601.72,335.61c-0.433,1.172-0.939,2.315-1.374,3.487-0.045,0.122,0.038,0.37,0.014,0.438,0.434-1.171,0.939-2.313,1.373-3.485,0.046-0.124-0.037-0.372-0.013-0.44'/%3E %3Cpath d='m602.78,334.97c-0.304,0.784-0.744,1.492-1.162,2.219-0.062,0.108,0.041,0.388,0.013,0.439,0.418-0.728,0.857-1.436,1.162-2.22,0.047-0.121-0.039-0.371-0.013-0.438'/%3E %3Cpath d='m603.62,336.45c-0.823,1.566-1.496,3.227-2.847,4.43-0.091,0.08,0.053,0.408,0,0.454,1.355-1.207,2.032-2.871,2.858-4.445,0.061-0.113-0.04-0.385-0.011-0.439'/%3E %3Cpath d='m604.57,335.74c-0.114,0.578-0.228,1.149-0.522,1.667-0.062,0.108,0.041,0.388,0.013,0.438,0.301-0.53,0.416-1.121,0.533-1.714,0.02-0.099,0.014-0.21,0.008-0.31-0.002-0.016-0.016-0.167-0.032-0.081'/%3E %3Cpath d='m606.06,335.4c-0.913,1.775-2.141,3.333-3.275,4.966-0.068,0.098,0.042,0.396,0.013,0.438,1.134-1.634,2.362-3.19,3.275-4.966,0.057-0.112-0.04-0.382-0.013-0.438'/%3E %3Cpath d='m612.17,330.81c0.068,0.651-0.27,1.357-0.518,1.943-0.051,0.12,0.039,0.375,0.012,0.439,0.372-0.877,0.639-1.746,0.538-2.704-0.018-0.177-0.038,0.262-0.032,0.322'/%3E %3Cpath d='m611.77,337.42c1.462-1.988,2.469-4.153,2.964-6.574,0.019-0.089-0.014-0.433-0.022-0.392-0.492,2.407-1.502,4.552-2.952,6.526-0.072,0.097,0.039,0.401,0.01,0.44'/%3E %3Cpath d='m616.5,330.59c-0.011,0.746-0.218,1.434-0.617,2.061-0.066,0.102,0.041,0.393,0.012,0.438,0.464-0.727,0.636-1.524,0.65-2.378,0.001-0.144-0.04-0.439-0.045-0.121'/%3E %3Cpath d='m607.44,337.08c-1.038,1.153-1.979,2.389-2.958,3.592-0.084,0.104,0.057,0.385,0,0.455,0.979-1.203,1.92-2.438,2.958-3.593,0.087-0.097-0.056-0.392,0-0.454'/%3E %3Cpath d='m608.91,337.83c-1.084,1.508-2.229,2.969-3.375,4.431-0.084,0.105,0.057,0.382,0,0.453,1.15-1.465,2.299-2.932,3.386-4.444,0.07-0.099-0.041-0.401-0.011-0.44'/%3E %3Cpath d='m609.65,339.82c-0.49,0.392-0.989,0.771-1.479,1.162-0.093,0.073,0.049,0.416,0,0.455,0.489-0.391,0.988-0.771,1.479-1.162,0.091-0.072-0.049-0.416,0-0.455'/%3E %3Cpath d='m623.7,332.96c-0.411,0.601-0.96,1.069-1.474,1.577-0.089,0.089,0.056,0.4,0,0.455,0.519-0.514,1.07-0.988,1.485-1.593,0.069-0.099-0.041-0.397-0.011-0.439'/%3E %3Cpath d='m624.24,335.42c0.79-0.549,1.06-1.574,1.079-2.491,0.002-0.145-0.038-0.44-0.044-0.12-0.017,0.799-0.362,1.689-1.035,2.157-0.091,0.063,0.045,0.424,0,0.454'/%3E %3Cpath d='m618.08,338.72c-0.006,0.383-0.098,0.782-0.302,1.109-0.039,0.063-0.018,0.21-0.016,0.279,0.001,0.016,0.014,0.182,0.028,0.159,0.261-0.42,0.325-0.94,0.333-1.427,0.001-0.086,0.014-0.197-0.017-0.28-0.004-0.017-0.026,0.142-0.026,0.16'/%3E %3Cpath d='m619.91,342.38c0.599-1.404,1.314-2.749,1.489-4.285,0.007-0.059-0.012-0.5-0.032-0.322-0.17,1.494-0.889,2.808-1.468,4.169-0.052,0.118,0.039,0.376,0.011,0.438'/%3E %3Cpath d='m619.69,337.83c-0.305,0.784-0.744,1.492-1.162,2.219-0.063,0.108,0.041,0.389,0.011,0.439,0.419-0.728,0.858-1.436,1.162-2.219,0.048-0.122-0.037-0.372-0.011-0.439'/%3E %3Cpath d='m622.31,337.58c0.042,1.139-0.965,2.15-1.463,3.102-0.059,0.111,0.041,0.383,0.012,0.438,0.642-1.225,1.548-2.204,1.495-3.66-0.012-0.321-0.049-0.026-0.044,0.12'/%3E %3Cpath d='m623.08,341.43c0.376-0.774,0.922-1.479,1.063-2.348,0.016-0.102,0.014-0.208,0.008-0.312-0.001-0.013-0.018-0.169-0.031-0.081-0.137,0.85-0.684,1.544-1.051,2.302-0.057,0.115,0.039,0.381,0.011,0.439'/%3E %3Cpath d='m626.13,333.18c-0.622,0.959-1.056,2.008-1.479,3.064-0.05,0.121,0.037,0.374,0.012,0.438,0.424-1.058,0.856-2.105,1.479-3.063,0.066-0.102-0.041-0.393-0.012-0.439'/%3E %3Cpath d='m628.56,334.15c-0.226,0.966-0.592,1.904-1.157,2.724-0.067,0.1,0.041,0.397,0.014,0.439,0.574-0.834,0.938-1.788,1.167-2.771,0.02-0.087-0.014-0.434-0.024-0.392'/%3E %3Cpath d='m630.46,334.97c-0.315,1.031-0.707,2.034-1.268,2.958-0.063,0.104,0.042,0.391,0.013,0.438,0.56-0.924,0.951-1.927,1.267-2.958,0.039-0.126-0.034-0.364-0.012-0.438'/%3E %3Cpath d='m632.06,340.17c0.516-0.767,0.438-1.663,0.439-2.544,0-0.258-0.045-0.258-0.047,0,0,0.749,0.029,1.461-0.404,2.104-0.068,0.101,0.041,0.397,0.012,0.44'/%3E %3Cpath d='m634.15,338.26c-0.082,1.816-1.508,3.264-2.624,4.564-0.077,0.09,0.051,0.348,0,0.407,1.188-1.384,2.572-2.847,2.659-4.767,0.003-0.065-0.024-0.455-0.035-0.204'/%3E %3Cpath d='m628.04,340.04c-0.427,0.426-0.857,0.844-1.374,1.162-0.089,0.055,0.04,0.431,0,0.455,0.517-0.318,0.947-0.736,1.374-1.162,0.04-0.04,0.023-0.178,0.023-0.229,0-0.017-0.027-0.222-0.023-0.226'/%3E %3Cpath d='m630.89,339.72c-0.904,0.717-1.672,1.565-2.43,2.431-0.087,0.099,0.057,0.39,0,0.455,0.758-0.865,1.525-1.715,2.43-2.431,0.091-0.073-0.049-0.416,0-0.455'/%3E %3Cpath d='m640.06,334.77c0,0.251-0.015,0.489-0.089,0.731-0.026,0.086-0.019,0.191-0.017,0.279,0,0.021,0.023,0.176,0.028,0.159,0.116-0.381,0.122-0.775,0.123-1.17,0-0.017,0.003-0.228-0.023-0.228-0.025,0.001-0.022,0.212-0.022,0.229'/%3E %3Cpath d='m641.33,333.62c0.065,1.003-0.363,1.938-0.937,2.73-0.069,0.096,0.04,0.398,0.011,0.438,0.742-1.024,1.047-2.147,0.965-3.399-0.018-0.279-0.044,0.156-0.039,0.231'/%3E %3Cpath d='m643.46,334.55c-0.64,1.177-1.239,2.374-1.796,3.592-0.055,0.117,0.038,0.378,0.011,0.439,0.558-1.218,1.158-2.415,1.796-3.592,0.06-0.111-0.04-0.386-0.011-0.439'/%3E %3Cpath d='m645.03,335.67c-0.121,1.114-0.514,2.134-1.046,3.111-0.061,0.109,0.041,0.386,0.011,0.438,0.554-1.017,0.942-2.074,1.067-3.229,0.007-0.058-0.014-0.498-0.032-0.32'/%3E %3Cpath d='m647.26,336.45c-0.74,1.374-1.48,2.747-2.22,4.121-0.06,0.109,0.041,0.385,0.013,0.438,0.738-1.373,1.479-2.747,2.218-4.12,0.059-0.111-0.04-0.386-0.011-0.439'/%3E %3Cpath d='m648.53,338.56c-0.622,1.243-1.25,2.483-2.107,3.584-0.082,0.107,0.057,0.383,0,0.456,0.861-1.107,1.494-2.351,2.118-3.601,0.057-0.114-0.041-0.381-0.011-0.439'/%3E %3Cpath d='m650.44,340.25c-1.062,1.2-1.838,2.648-3.064,3.698-0.091,0.078,0.051,0.411,0,0.455,1.227-1.05,2.003-2.499,3.064-3.698,0.087-0.098-0.057-0.391,0-0.455'/%3E %3Cpath d='m640.4,343.13c0.409-0.135,0.76-0.315,0.985-0.691,0.234-0.39,0.377-0.771,0.705-1.104,0.09-0.092-0.056-0.399,0-0.455-0.295,0.3-0.473,0.637-0.657,1.009-0.216,0.436-0.584,0.64-1.033,0.787-0.074,0.023,0.011,0.45,0,0.454'/%3E %3Cpath d='m643.44,341.05c-0.029,0.851-0.676,1.519-1.146,2.166-0.069,0.096,0.04,0.399,0.011,0.439,0.572-0.789,1.144-1.47,1.179-2.484,0.005-0.144-0.033-0.439-0.044-0.121'/%3E %3Cpath d='m644.82,341.69c-0.049,1.187-1.124,2.056-1.882,2.846-0.078,0.081,0.048,0.347,0,0.397,0.884-0.921,1.865-1.779,1.921-3.139,0.005-0.126-0.027-0.383-0.039-0.104'/%3E %3Cpath d='m656.55,335.56c-0.191,1.686-1.664,2.879-2.626,4.16-0.081,0.108,0.057,0.379,0,0.453,1.003-1.335,2.459-2.535,2.657-4.293,0.007-0.057-0.011-0.499-0.031-0.32'/%3E %3Cpath d='m657.1,339.75c0.807-0.81,1.372-1.809,1.802-2.86,0.049-0.12-0.038-0.374-0.012-0.439-0.427,1.046-0.988,2.04-1.79,2.845-0.089,0.09,0.055,0.4,0,0.454'/%3E %3Cpath d='m660.47,336.45c-0.564,1.304-1.388,2.45-2.219,3.594-0.068,0.095,0.04,0.398,0.012,0.438,0.831-1.143,1.654-2.29,2.219-3.592,0.052-0.12-0.039-0.377-0.012-0.44'/%3E %3Cpath d='m662.8,336.55c-0.948,1.164-1.854,2.357-2.958,3.382-0.091,0.084,0.053,0.404,0,0.454,1.104-1.023,2.01-2.217,2.958-3.381,0.084-0.103-0.057-0.384,0-0.455'/%3E %3Cpath d='m664.28,336.98c-0.243,0.91-0.671,1.738-1.162,2.536-0.065,0.104,0.041,0.392,0.011,0.439,0.493-0.799,0.92-1.626,1.162-2.536,0.035-0.128-0.033-0.362-0.011-0.439'/%3E %3Cpath d='m662.06,341.52c-1.031,1.303-2.538,2.062-4.016,2.747-0.083,0.039,0.027,0.443,0,0.455,1.478-0.686,2.984-1.444,4.016-2.747,0.082-0.105-0.058-0.383,0-0.455'/%3E %3Cpath d='m655.51,342.92c0.667-0.487,1.452-0.77,2.219-1.057,0.077-0.029-0.017-0.448,0-0.455-0.767,0.287-1.552,0.568-2.219,1.057-0.091,0.068,0.047,0.421,0,0.455'/%3E %3Cpath d='m664.28,341.52c-0.597,1.008-1.64,1.651-2.637,2.211-0.087,0.049,0.036,0.435,0,0.455,1.005-0.563,2.048-1.212,2.647-2.228,0.064-0.106-0.039-0.389-0.01-0.438'/%3E %3Cpath d='m632.68,328.32c-0.576,0.972-1.592,1.466-2.635,1.788-0.072,0.022,0.009,0.452,0,0.455,1.052-0.326,2.067-0.828,2.647-1.804,0.063-0.106-0.04-0.389-0.012-0.439'/%3E %3Cpath d='m590.1,332.32c0.233,1.522-0.688,2.786-1.679,3.803-0.09,0.091,0.055,0.397,0,0.455,1.282-1.316,1.983-2.811,1.701-4.65-0.005-0.04-0.035,0.301-0.022,0.392'/%3E %3Cpath d='m544.04,324.72c-1.348,0.921-2.771,1.699-4.228,2.431-0.085,0.043,0.031,0.439,0,0.455,1.456-0.732,2.88-1.512,4.228-2.431,0.09-0.061-0.044-0.424,0-0.455'/%3E %3Cpath d='m537.7,324.08c-0.956,1.051-2.007,1.985-3.276,2.643-0.086,0.044,0.032,0.438,0,0.453,1.27-0.655,2.32-1.59,3.276-2.641,0.087-0.096-0.056-0.393,0-0.455'/%3E %3C/g%3E %3Cpath transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)' fill='url(%23grad2)' d='m665.39,508.83c-0.1731-0.0469-0.26825-0.0714-0.26825-0.0714s0.094,0.0246,0.26825,0.0714m57.327-1.7005c-0.0183,0.007-0.0126,0.007,0.0138,0.005,0.0424-0.014,0.0585-0.0222,0.0516-0.0222-0.006,0.001-0.0275,0.006-0.0653,0.0176m0.90907-0.18036c0.94232-0.20144,2.5014-0.54342,4.1338-0.90297-1.4777,0.29396-2.9565,0.60315-4.1338,0.90297m4.8652-1.0646c-0.24303,0.0539-0.48835,0.10774-0.73024,0.16162,3.0195-0.60198,6.0345-1.1396,6.4575-1.4124-0.0607,0-2.89,0.6254-5.7272,1.2508m5.7272-1.2508zm-60.41-33.451c-1.1177,0.73901-5.5186,2.6866-7.8171,3.8262-2.2996,1.1419-2.3661,3.4233-1.5774,3.8274,0.7887,0.40288,6.0436,3.6248,6.438,4.2267,0.39435,0.60549-2.2354,1.7368-2.5381,1.9195-0.30264,0.18036-0.1559,0.9018-0.1559,0.9018,2.7799,3.8051,13.549,4.0288,11.825,5.2503-1.7253,1.2192-4.8709,1.0154-2.7146,3.1598,1.4421,1.4358,5.0796,4.3403,7.3562,5.5033,3.2224,1.6467,3.0516,3.0263,3.767,3.7594,1.4605,1.4909,0.6156,0.99783,2.6045,1.9465,1.9912,0.94981,4.2473,1.6291,2.655,2.3048-1.5923,0.67811-3.5835,0.40874-5.4418,1.2204-1.8583,0.81396-0.66375,0.94981-3.4506,1.355-2.7857,0.40874-3.4506,0.40874-4.1132,0.40874-0.66374,0-0.26595-0.27171-1.9912-0.27171-1.7264,0,0.39894-0.13586-3.0528,0-3.0482,0.12063-8.8935-1.348-10.214-1.69,1.4352,0.37711,8.1885,2.1561,10.082,2.6398,2.1242,0.54225,1.9901,0.27172,3.7154,0.81396,1.7253,0.54225,3.3187,0.67811,4.5132,1.0845,1.1957,0.40757,1.989,0.94982,2.9186,1.7626,0.92971,0.81279,1.0627,1.0845,1.7264,1.2192,0.66375,0.13586,2.522,0.81396,0.66375,1.4921-1.8583,0.67694-0.66375,1.0845-2.655,1.0845-1.9889,0-3.0516,0.13586-3.0516,0.13586s-2.256,0.40639-3.1835,0.13585c-0.93085-0.27171-2.1254-1.0845-2.1254-0.27171,0,0.81396,0.40009,1.0857-0.79443,1.0857-1.1968,0-2.9209-0.67693-2.9209-0.67693s-0.79558,0.54342-2.7868,0.67693c-0.9962,0.0679-1.4272,0.0679-1.8743,0.0679-0.44938,0-0.91251,0-1.9763,0.0679-0.7715,0.0492-1.3516,0.0269-1.7929,0.005-0.77609-0.0398-1.1372-0.0773-1.3905,0.26703-0.39894,0.54342,2.1231,1.2215-1.4605,0.6781-3.5835-0.54225-2.2549-0.54225,1.5946,0.67928,3.8472,1.2192,1.0615,0,5.7055,1.3539,4.6451,1.3562,1.4605,0.6781,5.177,1.8985s3.1835,0.27171,4.9099,1.3562c1.7253,1.0845,2.256,0.81279,2.788,1.355,0.53077,0.54225,1.1945-0.27054,1.4582,1.0857,0.2671,1.355,1.7253,2.7101,0.53191,2.983-1.1945,0.27054-1.0615,0.4064-2.6538,0.27054-1.5934-0.13586-0.66374-0.40757-3.0516-0.54342-2.389-0.13468-4.1143-0.27054-4.1143-0.27054s-1.5934,0.13468,0,0.94864c1.5912,0.81514-0.13298,1.6291-1.5934,2.1713-1.4605,0.54225-2.5232,0.67811-3.1846,0.81396-0.66375,0.13352,0.13183,0-2.389,0.67811-2.5209,0.67693-1.9901,0.94981-3.5824,1.6268-1.5946,0.67693-2.1254,0.67693-3.8484,1.0845-1.7264,0.40756-1.5934,0.27054-3.0539,0.54225-1.4582,0.27053-2.389,0.40873-3.3176,0.54225-0.9297,0.13585-1.5934,0.13585-1.5934,0.13585s3.0528,9.7605,10.749,19.523c7.6967,9.7617,25.483,28.608,43.796,30.505,18.315,1.8996,31.321,1.2215,41.273-4.4727,9.955-5.693,23.49-14.371,32.25-28.879,8.7617-14.507,9.3956-16.568,9.3956-16.568s-1.8101-0.8245-3.2121-0.50946c-1.3928,0.3127-1.4066-2.5812-3.5297-2.5812s-1.9912,0.94865-4.6451-0.27054c-2.6527-1.2215-1.8571-1.6279-3.9813-1.7638-2.1231-0.13351-6.2362-1.8973-6.2362-1.8973s-3.0516-0.81279-5.1758-0.94981c-2.1254-0.13469-2.9209-0.27054-6.2374-1.4921-3.3199-1.2204-4.3803-1.0845-5.4418-1.4897-1.0615-0.40756-2.2572-0.6781-3.0528-1.2204-0.79558-0.54225-2.7868-1.4909-0.26367-3.3905,2.5197-1.8985,3.4506-2.983,4.3791-3.5252,0.92856-0.54225,2.9186-1.7626,4.6439-1.8985,1.7264-0.13469,1.8583-0.54225,4.3803-0.54225,2.5208,0-1.3275-1.0857-3.8484-0.94982-2.522,0.13469-2.522,0.54342-4.7781,0.54342-2.2572,0-0.9297-0.13585-6.6352,0.26937-5.7078,0.40757-2.2572,0-6.6363-0.13351-4.3791-0.13586-3.4483,0.13351-7.2978-0.67928s-2.2572-0.27054-6.3715-0.81279-4.1143-0.6781-5.9714-1.6267c-1.8583-0.95099-3.0516-1.2204-4.1154-1.4921-1.0615-0.26937-1.8583-0.54225-0.79558-1.355,1.0615-0.81279,5.1369-3.9269,6.0631-4.4738,0.38289-0.22486,1.1578-0.47081,2.146-0.72378-0.48721,0.10424-0.80819,0.17099-0.89531,0.18505-0.0722,0.0211-0.21552,0.0574-0.44135,0.0937-0.70502,0.11477-2.2033,0.22721-4.7505-0.0984-4.2461-0.54225-5.3077-0.81162-7.033-1.2192-1.7253-0.40757-3.4517-1.4921-7.8308-1.6279-4.3791-0.13586-2.9186-0.54342-4.7769-1.8973-1.8583-1.3562-3.0516-2.169-3.5835-2.9841-0.52962-0.81279-1.316-1.7954-2.9198-2.3037-3.8484-1.2204-7.4319-3.9902-6.9023-4.612,0.93085-1.0833,2.2641-1.6548,0.66375-2.983-1.6267-1.3492-10.823-2.9513-13.407-3.7559,0,0,0.0676-0.44036,0.21666-0.49189,0.57662-0.20027,1.9018-0.56099,2.8911-1.252,1.2484-0.87252,0-1.4089-1.5109-2.217-2.0623-1.0974-5.584-2.6843-7.1602-3.825-1.6382-1.1852,1.7069-3.2207,5.0578-4.6999,3.3508-1.4757,11.759-8.7228,13.008-9.8659l-0.0653-0.40288c0.001-0.002-9.2615,7.4486-10.379,8.1853'/%3E %3Cpath fill='%23000' d='m567.95,325.42c-1.854,1.65-3.806,3.2-5.771,4.713-1.202,0.926-2.426,1.826-3.698,2.654-1.404,0.914-2.964,1.494-4.423,2.308-0.798,0.444-2.223,1.184-2.252,2.257-0.026,0.912,1.476,1.411,2.117,1.754,1.73,0.923,3.523,1.725,5.262,2.636,2.589,1.356-1.944,1.778-2.148,2.777-0.005,0.025-0.022,0.206,0.006,0.215,3.676,1.09,7.802,1.259,11.277,2.947,0.451,0.22,1.222,0.775,0.954,1.387-0.222,0.507-0.854,0.727-1.117,1.194-0.065,0.12-0.082,0.331-0.025,0.462,0.307,0.712,1.126,1.208,1.734,1.628,1.316,0.906,2.801,1.579,4.314,2.072,1.252,0.407,1.847,1.153,2.655,2.117,0.818,0.977,1.989,1.665,3.018,2.396,0.451,0.322,0.753,0.742,1.147,1.115,0.532,0.505,1.589,0.44,2.252,0.478,1.445,0.08,2.859,0.139,4.28,0.443,0.953,0.204,1.865,0.547,2.793,0.833,1.754,0.542,3.63,0.781,5.441,1.026,1.421,0.192,2.842,0.364,4.279,0.333,0.456-0.009,1.086,0.01,1.514-0.19,0.023-0.011,0.017-0.227,0-0.229-0.021-0.004-0.048,0.01-0.067,0.018-0.022,0.011-0.016,0.227,0,0.229,0.433,0.063,1.102-0.221,1.52-0.311,1.133-0.24,2.266-0.485,3.398-0.729,1.149-0.248,2.3-0.497,3.449-0.744,0.5-0.108,1.158-0.377,1.675-0.352v-0.229c-1.144,0.623-2.854,0.674-4.11,0.913-1.953,0.372-3.923,0.717-5.839,1.253-1.521,0.426-2.729,1.497-3.982,2.417-0.754,0.552-1.503,1.11-2.25,1.669-0.354,0.266-0.688,0.475-0.66,0.947,0.033,0.563,1.451,0.681,1.86,0.786,1.246,0.321,2.393,0.855,3.539,1.431,1.808,0.906,3.983,1.013,5.96,1.213,1.926,0.195,3.758,0.477,5.67,0.838,1.955,0.37,3.966,0.202,5.944,0.322,1.103,0.067,2.065,0.227,3.188,0.163,1.969-0.112,3.948-0.357,5.921-0.347,1.625,0.008,3.139-0.209,4.748-0.389,1.257-0.14,2.51-0.03,3.746,0.222,0.351,0.07,0.722,0.154,1.037,0.331-0.094-0.054,0.089-0.097-0.201-0.049-0.397,0.066-0.828,0.023-1.229,0.037-2.317,0.081-4.687,0.707-6.695,1.837-0.733,0.413-1.35,0.929-1.99,1.471-1.021,0.867-2.438,1.607-3.172,2.739-1.605,2.475,5.788,3.6,7.128,3.988,2.344,0.679,4.438,1.595,6.896,1.754,1.664,0.108,3.463,0.397,5.021,1.017,0.947,0.374,1.909,0.71,2.886,0.998,1.039,0.307,2.142,0.281,3.163,0.592,0.813,0.245,1.582,0.968,2.358,1.33,1.081,0.505,1.884,0.574,3.014,0.332,0.996-0.216,1.85-0.111,2.521,0.688,0.446,0.53,0.747,1.52,1.595,1.416,0.649-0.078,1.223-0.034,1.859,0.117,0.376,0.089,0.823,0.45,0.938,0.094-0.015,0.047-0.036,0.094-0.056,0.14-0.713,1.678-1.708,3.262-2.618,4.834-2.983,5.155-5.957,10.431-9.73,15.055-3.721,4.561-8.182,8.477-12.948,11.909-3.979,2.864-8.242,5.599-12.661,7.739-4.435,2.149-9.347,3.108-14.226,3.521-6.249,0.53-12.562,0.138-18.791-0.449-5.753-0.543-11.008-2.426-16.016-5.284-8.969-5.118-16.712-12.588-23.209-20.552-3.651-4.475-6.646-9.511-8.842-14.854-0.229-0.556-0.443-1.115-0.646-1.681-0.048-0.131-0.093-0.262-0.138-0.395-0.007-0.024-0.016-0.048-0.023-0.073,0.111,0.341,0.297,0.213,0.664,0.186,2.444-0.173,4.922-0.729,7.316-1.232,1.082-0.228,2.161-0.537,3.12-1.103,0.986-0.58,1.946-0.883,3.059-1.184,1.73-0.467,3.521-0.754,5.158-1.503,0.43-0.197,0.939-0.479,0.924-1.008-0.015-0.53-1.561-0.991-0.791-1.193,0.562-0.147,1.283,0.04,1.846,0.077,1.177,0.078,2.54-0.046,3.656,0.387,0.591,0.23,1.268,0.235,1.892,0.24,0.341,0.003,1.617-0.14,1.746-0.47,0.3-0.77-0.472-1.617-0.729-2.29-0.287-0.75-0.209-0.956-1.033-1.048-0.254-0.029-0.46-0.305-0.685-0.417-0.27-0.136-0.588-0.199-0.871-0.304-0.732-0.268-1.337-0.792-2.073-1.042-0.412-0.14-0.889-0.121-1.315-0.186-1.283-0.194-2.823-0.576-3.953-1.249-1.098-0.653-2.532-0.887-3.747-1.212-0.801-0.214-1.604-0.248-2.402-0.431-1.582-0.363-3.116-0.924-4.698-1.3v0.229c0.501,0.046,3.543,0.783,3.543,0.293,0-0.2-0.157-0.28-0.3-0.407-0.577-0.516,1.688-0.378,1.868-0.376,1.057,0.012,2.129-0.063,3.188-0.091,1.097-0.028,2.313-0.079,3.309-0.593,0.425-0.221,3.385,1.381,3.366,0.144-0.005-0.297-0.15-0.771,0.234-0.827,0.45-0.063,1.134,0.394,1.553,0.532,0.82,0.272,1.918,0.026,2.75-0.11,0.743-0.123,1.524-0.106,2.273-0.118,0.489-0.009,1.091,0.081,1.534-0.176,0.427-0.247,0.703-0.557,1.199-0.754,1.595-0.632,0.094-1.328-0.802-1.56-0.491-0.127-0.92-0.666-1.282-0.984-0.494-0.434-1.026-0.803-1.604-1.115-1.354-0.731-3.003-0.818-4.471-1.197-4.207-1.087-8.464-2.04-12.679-3.128,0.001,0-0.034,0.22,0,0.229,1.508,0.397,3.035,0.729,4.567,1.014,2.167,0.405,4.195,0.403,6.382,0.44,0.978,0.017,1.95,0.292,2.911,0.28,0.833-0.011,1.664-0.129,2.488-0.237,0.913-0.12,2.04-0.126,2.804-0.711,0.933-0.715,2.128-0.94,3.264-1.095,0.53-0.073,2.87-0.135,2.948-0.91,0.025-0.268-0.056-0.405-0.257-0.583-0.935-0.83-2.5-1.146-3.611-1.714-1.266-0.646-1.703-2.294-2.709-3.223-0.927-0.855-2.18-1.322-3.238-1.993-1.189-0.756-2.315-1.613-3.409-2.499-0.504-0.406-2.654-1.903-1.93-2.58,0.689-0.646,1.948-0.727,2.756-1.239,0.418-0.266,0.055-0.646-0.243-0.776-1.416-0.613-3.1-0.764-4.587-1.152-1.789-0.469-3.738-1.063-5.113-2.358-1.35-1.274,2.023-1.472,2.023-2.622,0-0.267-0.237-0.404-0.429-0.554-0.757-0.59-1.594-1.087-2.406-1.594-0.765-0.477-1.536-0.941-2.318-1.392-0.202-0.117-0.416-0.22-0.61-0.348-0.781-0.515,0.049-1.791,0.457-2.25,0.741-0.83,2.092-1.23,3.078-1.685,1.192-0.548,2.389-1.089,3.567-1.663,1.955-0.953,3.621-2.454,5.329-3.781,1.644-1.278,3.283-2.563,4.92-3.851,0.046-0.036-0.025-0.21,0-0.229-2.348,1.848-4.7,3.69-7.069,5.511-1.031,0.793-2.012,1.541-3.18,2.12-1.081,0.536-2.183,1.029-3.279,1.532-1.131,0.519-2.445,0.955-3.366,1.815-0.493,0.463-1.197,1.944-0.547,2.616,0.391,0.403,1.067,0.651,1.545,0.935,0.926,0.55,1.841,1.116,2.741,1.703,0.272,0.178,1.725,0.924,1.388,1.325-0.497,0.592-1.415,0.861-2.079,1.215-0.214,0.114-0.193,0.546-0.173,0.739,0.063,0.594,0.738,1,1.193,1.313,1.591,1.098,3.622,1.572,5.475,2.015,0.793,0.189,1.592,0.359,2.385,0.552,0.444,0.109,1.041,0.199,1.396,0.515,0.108,0.095-1.905,0.911-2.166,1.008-0.466,0.172-0.931,0.379-0.945,0.919-0.014,0.463,0.349,0.813,0.645,1.121,0.836,0.87,1.846,1.608,2.804,2.337,1.009,0.767,2.056,1.49,3.155,2.118,1.164,0.665,2.317,1.207,3.072,2.366,0.368,0.565,0.613,1.016,1.086,1.514,0.583,0.612,1.079,0.874,1.861,1.235,0.688,0.32,1.394,0.601,2.076,0.934,0.956,0.466,0.254,0.829-0.427,1.021-1.533,0.437-3.087,0.317-4.553,1.049-0.563,0.28-0.906,0.623-1.542,0.769-1.213,0.275-2.5,0.4-3.741,0.49-1.003,0.071-1.932-0.196-2.939-0.211-0.916-0.014-1.835,0.009-2.755,0.008-2.9-0.003-5.901-0.775-8.694-1.509v0.229c3.138,0.811,6.271,1.65,9.423,2.41,2.445,0.591,5.1,0.81,7.432,1.776,1.187,0.49,1.934,1.511,2.994,2.16,0.332,0.204,0.814,0.235,1.178,0.39,1.032,0.436-0.398,0.858-0.803,1.06-0.272,0.136-0.432,0.396-0.689,0.546-0.463,0.269-1.309,0.112-1.813,0.12-0.701,0.011-1.409,0.038-2.103,0.146-0.921,0.144-1.914,0.283-2.815-0.016-0.381-0.126-1.564-0.875-1.586-0.055-0.005,0.17,0.015,0.339,0.036,0.508,0.063,0.537-1.059,0.315-1.322,0.283-0.669-0.08-1.576-0.688-2.188-0.404-1.021,0.472-2.248,0.481-3.35,0.51-1.188,0.029-2.387,0.112-3.573,0.073-0.392-0.014-1.867-0.103-1.379,0.713,0.072,0.121,0.211,0.212,0.316,0.304,0.099,0.086,0.066-0.064-0.052-0.051-0.168,0.021-0.357-0.015-0.522-0.03-0.961-0.09-1.906-0.346-2.864-0.434-0.007-0.001-0.026,0.224,0,0.229,1.732,0.411,3.472,1.203,5.237,1.396,1.722,0.19,3.426,0.7,5.058,1.281,1.361,0.485,2.616,1.103,4.062,1.429,0.58,0.132,1.188,0.114,1.76,0.271,0.933,0.255,1.716,0.943,2.654,1.24,0.326,0.104,0.54,0.268,0.812,0.467,0.427,0.312,0.695-0.131,1.023,0.484,0.278,0.521,0.394,1.16,0.678,1.702,0.445,0.847-0.109,0.929-0.818,1.115-0.774,0.204-1.741,0.15-2.498-0.1-1.096-0.362-2.263-0.33-3.407-0.402-0.296-0.019-2.636-0.499-2.589,0.298,0.01,0.161,0.015,0.148,0.117,0.283,0.17,0.225,0.58,0.37,0.815,0.513,0.619,0.379-0.532,0.936-0.668,1.008-1.21,0.645-2.584,0.872-3.909,1.142-0.915,0.186-1.841,0.504-2.731,0.772-1.275,0.385-2.326,1.228-3.62,1.621-1.359,0.414-2.799,0.643-4.203,0.847-1.61,0.233-3.224,0.656-4.858,0.676-0.021,0-0.011,0.202-0.003,0.225,2.69,8.358,8.143,15.683,14.042,22.048,7.424,8.009,16.361,15.622,26.838,19.188,2.749,0.937,5.548,1.382,8.429,1.654,3.319,0.313,6.648,0.533,9.981,0.616,5.451,0.137,10.97-0.146,16.279-1.469,4.608-1.146,8.642-3.399,12.672-5.842,4.696-2.848,9.18-6.052,13.248-9.749,3.087-2.806,5.882-5.927,8.314-9.317,2.462-3.429,4.558-7.156,6.697-10.793,0.992-1.685,1.979-3.377,2.878-5.112,0.189-0.363,0.412-0.739,0.538-1.132,0.011-0.028,0.029-0.212-0.003-0.225-0.88-0.38-1.848-0.583-2.801-0.436-0.817,0.125-1.188-0.875-1.595-1.417-0.636-0.846-1.557-0.861-2.521-0.688-1.169,0.209-1.882,0.156-3.014-0.331-0.835-0.358-1.527-1-2.358-1.331-0.414-0.165-0.9-0.155-1.336-0.192-0.619-0.055-1.231-0.231-1.827-0.398-1.461-0.41-2.827-1.082-4.304-1.423-2.151-0.495-4.385-0.459-6.51-1.026-2.274-0.606-4.435-1.445-6.739-1.953-1.072-0.234-2.264-0.643-3.206-1.2-0.299-0.178-0.59-0.374-0.856-0.597-1.046-0.868,0.298-1.825,0.979-2.333,1.866-1.39,3.393-2.872,5.547-3.826,1.079-0.477,2.2-0.508,3.333-0.754,0.451-0.098,0.9-0.17,1.361-0.212,0.567-0.053,1.233,0.081,1.776-0.11,0.09-0.032,0.047-0.231,0.033-0.296-0.093-0.415-1.926-0.543-2.23-0.584-2.232-0.305-4.376,0.4-6.602,0.372-1.218-0.016-2.421,0.048-3.638,0.128-1.653,0.11-3.522,0.504-5.174,0.165-1.8-0.368-3.703-0.146-5.527-0.245-1.929-0.105-3.774-0.823-5.702-0.941-2.084-0.127-4.271-0.265-6.284-0.847-0.895-0.259-1.715-0.779-2.556-1.162-0.676-0.309-1.385-0.536-2.1-0.731-0.474-0.128-2.425-0.356-1.317-1.187,1.694-1.271,3.37-2.652,5.188-3.744,0.622-0.374,1.433-0.512,2.128-0.681,1.196-0.294,2.407-0.526,3.615-0.762,1.168-0.227,2.338-0.441,3.504-0.677,0.592-0.119,1.324-0.183,1.863-0.477,0.024-0.014,0.015-0.229,0-0.229-0.466-0.023-1.058,0.219-1.51,0.316-1.132,0.242-2.263,0.487-3.395,0.731-1.151,0.248-2.302,0.497-3.452,0.742-0.463,0.099-1.207,0.415-1.686,0.346v0.229c0.02-0.008,0.047-0.021,0.067-0.019v-0.229c-0.37,0.172-0.889,0.157-1.283,0.181-1.507,0.091-3.02-0.127-4.51-0.324-1.821-0.239-3.673-0.51-5.441-1.025-0.846-0.247-1.668-0.555-2.523-0.771-1.494-0.376-3.02-0.438-4.55-0.506-0.693-0.031-1.577-0.01-2.18-0.419-0.456-0.309-0.767-0.836-1.22-1.173-0.976-0.725-2.051-1.357-2.892-2.247-0.916-0.971-1.427-1.791-2.781-2.267-1.423-0.501-2.762-1.095-4.044-1.896-0.482-0.302-0.938-0.643-1.367-1.016-0.153-0.133-0.29-0.281-0.423-0.435-0.354-0.406,0.155-0.716,0.443-0.989,2.694-2.571-4.868-3.764-6.135-4.053-1.554-0.354-3.115-0.675-4.665-1.05-0.272-0.065-0.546-0.138-0.815-0.214-0.21-0.059,0.983-0.535,1.034-0.552,0.654-0.228,1.844-0.587,1.996-1.371,0.186-0.948-1.948-1.594-2.566-1.902-1.836-0.916-4.025-1.668-5.61-2.998-1.276-1.071,4.481-3.587,5.022-3.858,1.422-0.715,2.725-1.702,4-2.646,2.37-1.753,4.696-3.604,6.899-5.565,0.05-0.035-0.023-0.2,0.004-0.224'/%3E %3Cpath d='m531.57,329.37c-0.529,0.822-1.207,1.521-1.896,2.211-0.089,0.089,0.056,0.399,0,0.455,0.693-0.695,1.376-1.398,1.908-2.228,0.066-0.102-0.041-0.394-0.012-0.438'/%3E %3Cpath d='m532.52,330.32c-0.444,0.674-0.84,1.374-1.162,2.113-0.053,0.118,0.039,0.376,0.012,0.439,0.323-0.739,0.718-1.44,1.162-2.113,0.065-0.101-0.041-0.395-0.012-0.439'/%3E %3Cg fill='%234f91c5'%3E %3Cpath d='m584.28,363.1c0.815-0.563,1.559-0.303,2.448-0.091,0.809,0.192,1.456,0.067,2.216-0.238,0.038-0.016-0.012-0.223,0-0.229-0.776,0.313-1.394,0.408-2.216,0.239-0.903-0.186-1.615-0.483-2.448,0.091-0.045,0.032,0.021,0.212,0,0.228'/%3E %3Cpath d='m585.6,364.14c0.21-0.521,0.981-0.384,1.424-0.38,0.017,0,0.018-0.227,0-0.227-0.451-0.004-1.218-0.143-1.43,0.387-0.024,0.062,0.019,0.188,0.006,0.22'/%3E %3Cpath d='m583.07,362.33c0.886-0.571,1.75-0.42,2.742-0.548,0.027-0.004,0.009-0.229,0-0.229-0.992,0.13-1.856-0.022-2.742,0.55-0.046,0.027,0.02,0.214,0,0.227'/%3E %3Cpath d='m577.67,365.04c-1.93-0.817-3.919,0.564-5.871-0.22,0.011,0.004-0.04,0.211,0,0.229,1.952,0.783,3.941-0.6,5.871,0.219-0.01-0.005,0.04-0.21,0-0.228'/%3E %3Cpath d='m573.63,365.4c-1.146-0.505-2.259,0.399-3.45,0.009,0.007,0.002-0.036,0.216,0,0.229,1.191,0.389,2.304-0.514,3.45-0.01-0.011-0.005,0.041-0.209,0-0.228'/%3E %3Cpath d='m571.33,366.28c-0.862-0.677-2.25-0.072-3.237-0.109-0.015,0-0.02,0.227,0,0.228,0.987,0.036,2.375-0.566,3.237,0.109-0.024-0.02,0.046-0.192,0-0.228'/%3E %3Cpath d='m574.84,414.12c-0.94,0.361-2.849,0.492-3.626-0.293-1.021-1.033-2.098-0.461-3.404-0.318-0.023,0.003-0.009,0.228,0,0.227,1.073-0.116,2.412-0.761,3.267,0.16,0.841,0.905,2.68,0.869,3.764,0.451,0.038-0.015-0.011-0.223-0.001-0.227'/%3E %3Cpath d='m559.07,387.6c1.889-1.07,3.772,0.335,5.731-0.229,0.035-0.01-0.003-0.227,0-0.228-1.959,0.563-3.843-0.84-5.731,0.229-0.044,0.026,0.018,0.218,0,0.228'/%3E %3Cpath d='m542.91,391.73c0.779-0.291,1.458-0.405,2.263-0.164,0.747,0.224,1.41,0.556,2.192,0.672,1.928,0.287,3.931-0.464,5.859-0.508,0.02,0,0.017-0.228,0-0.227-1.965,0.045-3.886,0.669-5.859,0.507-0.769-0.063-1.477-0.416-2.192-0.672-0.776-0.278-1.514-0.115-2.263,0.165-0.039,0.014,0.009,0.224,0,0.227'/%3E %3Cpath d='m544.85,393.79c2.148-0.839,4.44,0.033,6.647-0.458,0.031-0.008,0.001-0.229,0-0.229-2.207,0.492-4.499-0.38-6.647,0.459-0.039,0.016,0.01,0.224,0,0.228'/%3E %3Cpath d='m563.08,386.11c1.901-0.733,3.654-0.266,5.616-0.229,0.016,0,0.019-0.228,0-0.229-1.962-0.037-3.715-0.505-5.616,0.23-0.039,0.016,0.009,0.224,0,0.228'/%3E %3Cpath d='m569.15,384.2c1.152-0.165,2.169-0.212,3.323-0.038,0.007,0.001,0.027-0.223,0-0.228-1.154-0.175-2.171-0.127-3.323,0.038-0.028,0.004-0.007,0.229,0,0.228'/%3E %3Cpath d='m549.44,399.87c2.347-1.294,4.945,0.808,7.221-0.572,0.044-0.027-0.02-0.217,0-0.228-2.275,1.379-4.874-0.722-7.221,0.573-0.045,0.024,0.017,0.217,0,0.227'/%3E %3Cpath d='m551.39,401.58c1.556-0.327,3.125-0.576,4.699-0.803,0.026-0.004,0.007-0.229,0-0.228-1.574,0.226-3.144,0.475-4.699,0.803-0.031,0.007-0.002,0.228,0,0.228'/%3E %3Cpath d='m556.43,395.85c1.497-0.812,3.482,0.141,4.699-1.261,0.043-0.049-0.028-0.195,0-0.227-1.217,1.4-3.202,0.448-4.699,1.261-0.044,0.023,0.017,0.217,0,0.227'/%3E %3Cpath d='m564,403.99c1.695-1.267,3.868,0.045,5.616-1.031,0.045-0.027-0.02-0.215,0-0.228-1.748,1.076-3.921-0.234-5.616,1.032-0.046,0.034,0.024,0.21,0,0.227'/%3E %3Cpath d='m563.42,399.75c1.129-0.151,2.297-0.53,3.431-0.266,1.097,0.256,1.928,0.978,3.103,0.953,0.02-0.001,0.017-0.228,0-0.228-1.026,0.021-1.853-0.481-2.779-0.848-1.197-0.475-2.538-0.003-3.754,0.16-0.026,0.005-0.007,0.23-0.001,0.229'/%3E %3Cpath d='m564.57,412.59c1.733-0.815,3.324-0.761,5.158-0.344,1.596,0.362,2.635,1.006,3.896-0.458,0.043-0.05-0.028-0.195,0-0.229-1.192,1.385-2.359,0.951-3.896,0.459-1.732-0.555-3.529-0.423-5.158,0.345-0.042,0.019,0.014,0.222,0,0.227'/%3E %3Cpath d='m580.62,407.66c1.91,0.368,3.502,0.143,5.314-0.511,0.951-0.343,1.852-0.724,2.867-0.814,0.93-0.081,1.895,0.111,2.821,0.18,0.012,0.001,0.022-0.227,0-0.229-0.941-0.067-1.876-0.205-2.821-0.178-1.001,0.029-1.943,0.474-2.867,0.813-1.805,0.663-3.411,0.879-5.314,0.513-0.004-0.002-0.031,0.22,0,0.226'/%3E %3Cpath d='m593.34,406.74c1.508-0.226,2.966-0.65,4.503-0.525,1.558,0.126,2.794,0.939,4.323,0.182,0.042-0.021-0.015-0.219,0-0.227-1.345,0.666-2.522,0.154-3.897-0.115-1.657-0.324-3.299,0.214-4.929,0.459-0.026,0.003-0.005,0.227,0,0.226'/%3E %3Cpath d='m605.49,406.51c2.968-1.084,5.166,1.517,8.023,1.72,0.012,0.001,0.021-0.226,0-0.228-2.857-0.204-5.056-2.804-8.023-1.719-0.039,0.013,0.008,0.224,0,0.227'/%3E %3Cpath d='m616.83,406.97c1.337-0.426,2.572-0.196,3.91,0.086,1.427,0.3,2.69,0.265,3.998-0.43,0.043-0.023-0.017-0.219,0-0.228-1.317,0.699-2.563,0.716-3.998,0.43-1.346-0.27-2.565-0.515-3.91-0.085-0.036,0.011,0.005,0.225,0,0.227'/%3E %3Cpath d='m626.35,408.12c2.131-1.185,4.375-0.785,6.648-1.375,0.032-0.009-0.002-0.228,0-0.229-2.273,0.59-4.518,0.192-6.648,1.376-0.044,0.025,0.017,0.217,0,0.228'/%3E %3Cpath d='m610.53,415.34c1.014-0.86,2.169-0.815,3.416-0.624,1.162,0.178,2.401,0.482,3.347-0.408,0.046-0.042-0.027-0.201,0-0.227-0.869,0.818-1.988,0.628-3.072,0.451-1.33-0.215-2.596-0.349-3.69,0.58-0.047,0.039,0.025,0.206-0.001,0.228'/%3E %3Cpath d='m612.02,417.75c1.715-1.365,3.864-0.781,5.731-1.72,0.042-0.021-0.016-0.22,0-0.228-1.867,0.938-4.017,0.354-5.731,1.72-0.046,0.036,0.025,0.207,0,0.228'/%3E %3Cpath d='m633.22,412.36c1.95-0.091,3.91,0.089,5.845-0.229,0.029-0.005,0.006-0.229,0-0.229-1.935,0.319-3.895,0.139-5.845,0.23-0.02,0.002-0.014,0.228,0,0.228'/%3E %3Cpath d='m633.91,414.54c0.71-0.358,1.405-0.613,2.207-0.63,0.68-0.014,1.352,0.09,2.034,0.058,0.021-0.002,0.013-0.229,0-0.228-0.682,0.033-1.354-0.046-2.034-0.058-0.79-0.015-1.514,0.278-2.207,0.631-0.043,0.021,0.016,0.219,0,0.227'/%3E %3Cpath d='m638.04,409.84c0.619-0.662,1.602-0.397,2.406-0.573,0.031-0.007,0.001-0.228,0-0.227-0.805,0.174-1.787-0.089-2.406,0.573-0.044,0.047,0.027,0.197,0,0.227'/%3E %3Cpath d='m583.02,413.28c1.149-0.893,2.356-0.924,3.754-0.859,1.521,0.069,2.756-0.177,3.925-1.203,0.047-0.04-0.025-0.205,0-0.228-1.175,1.033-2.4,1.263-3.925,1.203-1.401-0.054-2.599-0.038-3.754,0.86-0.046,0.035,0.024,0.208,0,0.227'/%3E %3Cpath d='m584.17,414.54c1.796-1.371,4.051-0.237,6.075-0.802,0.034-0.01-0.003-0.227,0-0.228-2.024,0.563-4.279-0.569-6.075,0.803-0.045,0.034,0.024,0.209,0,0.227'/%3E %3Cpath d='m581.53,410.07c2.642-1.442,5.954,1.508,8.252-0.802,0.046-0.045-0.026-0.2,0-0.229-2.298,2.312-5.61-0.64-8.252,0.804-0.044,0.023,0.017,0.217,0,0.227'/%3E %3Cpath d='m590.36,421.07c1.079-0.798,1.693-0.399,2.865-0.115,1.666,0.407,3.334,0.458,5.044,0.459,0.016,0,0.016-0.228,0-0.228-1.557,0-3.089-0.036-4.616-0.354-1.303-0.27-2.092-0.878-3.293,0.011-0.046,0.033,0.022,0.21,0,0.227'/%3E %3Cpath d='m590.36,422.79c2.066-1.476,4.625,0.813,6.877,0.458,0.027-0.004,0.006-0.229,0-0.228-2.252,0.355-4.811-1.934-6.877-0.458-0.045,0.032,0.022,0.211,0,0.228'/%3E %3Cpath d='m577.29,385.42c2.13-1.508,4.375,0.427,6.647-0.344,0.037-0.013-0.007-0.226,0-0.228-2.272,0.771-4.518-1.164-6.647,0.345-0.045,0.032,0.021,0.212,0,0.227'/%3E %3Cpath d='m578.55,386.57c1.452-0.37,2.902,0.256,4.354-0.115,0.034-0.008-0.001-0.228,0-0.228-1.452,0.37-2.902-0.256-4.354,0.115-0.033,0.008,0.001,0.228,0,0.228'/%3E %3Cpath d='m566.75,397.69c1.773-0.771,3.506-0.593,5.387-0.572,0.018,0,0.019-0.228,0-0.228-1.881-0.021-3.613-0.199-5.387,0.573-0.041,0.017,0.011,0.222,0,0.227'/%3E %3Cpath d='m631.04,400.9c1.28-1.485,3.415-1.064,5.158-1.262,0.024-0.003,0.009-0.228,0-0.227-1.743,0.196-3.878-0.225-5.158,1.261-0.043,0.049,0.029,0.195,0,0.228'/%3E %3Cpath d='m625.77,404.68c2.111-2.024,4.774-0.284,7.221-1.262,0.039-0.015-0.01-0.223,0-0.227-2.446,0.976-5.109-0.764-7.221,1.261-0.045,0.044,0.028,0.202,0,0.228'/%3E %3Cpath d='m573.97,408c1.358-1.756,3.362-1.221,5.272-1.719,0.034-0.009-0.001-0.227,0-0.228-1.91,0.497-3.914-0.036-5.272,1.72-0.041,0.054,0.029,0.19,0,0.227'/%3E %3Cpath d='m647.58,390.26c1.216-0.257,2.365-0.566,3.619-0.465,1.284,0.104,2.352,0.231,3.567-0.311,0.041-0.019-0.013-0.222,0-0.228-1.189,0.531-2.304,0.462-3.567,0.31-1.234-0.147-2.424,0.213-3.619,0.466-0.03,0.007-0.001,0.228,0,0.228'/%3E %3Cpath d='m646.62,392.41c0.847-0.166,1.63-0.197,2.486-0.236,0.711-0.03,1.298-0.354,1.902-0.696,0.044-0.025-0.018-0.217,0-0.228-0.55,0.312-1.073,0.598-1.707,0.682-0.902,0.121-1.774,0.073-2.682,0.252-0.03,0.005-0.002,0.226,0.001,0.226'/%3E %3Cpath d='m643.19,388.12c1.542-0.701,3.946,0.892,5.051-0.772,0.033-0.05-0.02-0.197-0.006-0.22-1.1,1.656-3.51,0.067-5.045,0.766-0.041,0.017,0.013,0.22,0,0.226'/%3E %3Cpath d='m649.47,393.58c0.848-0.293,1.568-0.513,2.473-0.484,0.782,0.023,1.474,0.174,2.191-0.229,0.044-0.024-0.019-0.218,0-0.228-0.7,0.393-1.422,0.284-2.191,0.229-0.895-0.064-1.642,0.197-2.473,0.485-0.038,0.013,0.007,0.226,0,0.227'/%3E %3Cpath d='m637.84,387.58c1.488-1.684,4.103,0.912,5.871-0.221,0.045-0.027-0.021-0.214,0-0.227-1.769,1.131-4.383-1.463-5.871,0.22-0.044,0.048,0.028,0.195,0,0.228'/%3E %3Cpath d='m634.83,386.75c0.529-0.847,1.673-0.565,2.524-0.641,0.961-0.086,1.684-0.626,2.357-1.275,0.044-0.043-0.028-0.2,0-0.228-0.697,0.673-1.385,1.142-2.357,1.275-0.874,0.118-1.984-0.225-2.53,0.648-0.033,0.054,0.02,0.199,0.006,0.221'/%3E %3Cpath d='m590.38,367.97c1.411-0.683,2.824,0.127,4.28-0.221,0.033-0.007,0-0.227,0-0.227-1.456,0.347-2.869-0.462-4.28,0.22-0.042,0.021,0.015,0.22,0,0.228'/%3E %3Cpath d='m592.13,369.24c0.718-0.587,1.581-0.027,2.358-0.384,0.042-0.019-0.013-0.222,0-0.228-0.777,0.355-1.641-0.202-2.358,0.385-0.046,0.037,0.025,0.206,0,0.227'/%3E %3Cpath d='m623.86,409.38c0.771-0.085,1.641,0.335,2.359-0.056,0.044-0.023-0.018-0.218,0-0.227-0.719,0.389-1.589-0.031-2.359,0.055-0.025,0.003-0.009,0.229,0,0.228'/%3E %3Cpath d='m567.98,373.9c-1.139-0.392-2.37-0.606-3.56-0.32-0.804,0.193-0.752,0.982-1.728,0.688,0.005,0.002-0.035,0.217,0,0.228,0.884,0.267,1.011-0.363,1.728-0.687,1.011-0.459,2.579-0.017,3.56,0.318-0.007-0.003,0.038-0.214,0-0.227'/%3E %3Cpath d='m567.27,375.11c-2.007-0.907-4.154-0.117-6.255-0.329-0.011-0.001-0.025,0.225,0,0.227,2.101,0.213,4.248-0.578,6.255,0.329-0.014-0.006,0.041-0.209,0-0.227'/%3E %3Cpath d='m564.69,376.26c-1.035-0.358-2.009-0.861-3.061-1.174-1.198-0.356-2.52-0.355-3.743-0.638,0,0-0.032,0.221,0,0.228,1.104,0.256,2.226,0.388,3.347,0.549,1.204,0.174,2.318,0.869,3.457,1.262-0.007-0.002,0.038-0.214,0-0.227'/%3E %3Cpath d='m560.3,397.45c1.412-1.768,3.505-0.529,5.377-0.933,0.032-0.006,0.002-0.228,0-0.228-1.872,0.403-3.965-0.836-5.377,0.934-0.042,0.052,0.028,0.191,0,0.227'/%3E %3Cpath d='m560.36,398.49c0.685-0.307,1.314-0.702,2.085-0.713,0.701-0.011,1.391,0.451,2.085,0.549,0.007,0.001,0.026-0.225,0-0.229-0.72-0.1-1.365-0.447-2.085-0.549-0.712-0.1-1.467,0.438-2.085,0.714-0.041,0.019,0.012,0.222,0,0.228'/%3E %3Cpath d='m561.62,401.51c0.424-0.414,0.828-0.54,1.385-0.336,0.459,0.167,0.829,0.347,1.304,0.116,0.043-0.021-0.015-0.22,0-0.227-0.467,0.227-0.853,0.061-1.304-0.116-0.549-0.218-0.971-0.069-1.385,0.336-0.045,0.045,0.027,0.201,0,0.227'/%3E %3Cpath d='m562.55,394.65c0.534-0.303,0.992-0.285,1.549-0.065,0.563,0.225,1.011,0.365,1.579,0.065,0.043-0.023-0.016-0.219,0-0.228-0.516,0.272-0.948,0.194-1.467-0.019-0.597-0.244-1.078-0.312-1.661,0.019-0.044,0.026,0.019,0.218,0,0.228'/%3E %3Cpath d='m557.06,393.99c0.909-0.22,1.606,0.283,2.488,0.41,0.689,0.101,1.454-0.34,2.121-0.466,0.03-0.006,0.004-0.228,0-0.227-0.711,0.134-1.39,0.493-2.121,0.466-0.91-0.033-1.544-0.638-2.488-0.411-0.032,0.007,0,0.228,0,0.228'/%3E %3Cpath d='m570.29,406.23c1.116-1.142,2.71-0.188,4.006-0.823,0.042-0.021-0.015-0.22,0-0.227-1.296,0.636-2.89-0.319-4.006,0.823-0.044,0.045,0.027,0.199,0,0.227'/%3E %3Cpath d='m594.76,407.93c1.488-0.882,3.056-0.268,4.664-0.275,0.019,0,0.018-0.227,0-0.227-1.608,0.007-3.176-0.607-4.664,0.274-0.044,0.027,0.02,0.216,0,0.228'/%3E %3Cpath d='m605.08,407.66c1.891-0.671,3.384,1.088,5.267,0.713,0.031-0.006,0.003-0.228,0-0.228-1.883,0.375-3.376-1.385-5.267-0.713-0.038,0.013,0.007,0.225,0,0.228'/%3E %3Cpath d='m618.08,407.98c1.521-0.273,3.807,1.175,5.049-0.11,0.044-0.045-0.028-0.199,0-0.227-1.242,1.283-3.527-0.163-5.049,0.109-0.029,0.005-0.004,0.229,0,0.228'/%3E %3Cpath d='m627.14,409.13c0.557-1.104,1.728-0.626,2.72-0.523,1.186,0.125,2.298,0.025,3.257-0.735,0.046-0.035-0.023-0.208,0-0.227-1.074,0.851-2.3,0.835-3.604,0.698-0.943-0.099-1.867-0.444-2.378,0.566-0.03,0.058,0.019,0.193,0.005,0.221'/%3E %3Cpath d='m584.88,408.42c1.011-0.047,1.864-0.449,2.806-0.772,1.042-0.354,2.162-0.021,3.175-0.435,0.04-0.017-0.011-0.223,0-0.229-0.904,0.371-1.911,0.145-2.857,0.347-1.087,0.231-1.985,0.809-3.123,0.862-0.021,0.002-0.015,0.227-0.001,0.227'/%3E %3Cpath d='m591.74,417.42c1.591-1.813,4.049-0.037,5.926-1.152,0.044-0.026-0.019-0.216,0-0.228-1.877,1.115-4.335-0.66-5.926,1.152-0.043,0.05,0.028,0.196,0,0.228'/%3E %3Cpath d='m593.94,418.03c1.511-0.534,3.944,0.372,5.048-1.043,0.042-0.053-0.029-0.189,0-0.227-1.104,1.414-3.537,0.508-5.048,1.043-0.038,0.013,0.008,0.224,0,0.227'/%3E %3Cpath d='m608.2,424.06c1.118-1.151,2.381-1.289,3.893-1.008,1.77,0.329,3.424,0.692,5.215,0.294,0.032-0.008,0.001-0.229,0-0.228-1.641,0.365-3.188,0.111-4.813-0.214-1.652-0.331-3.043-0.361-4.295,0.928-0.044,0.045,0.027,0.199,0,0.228'/%3E %3Cpath d='m608.92,424.56c0.924-0.623,1.913-0.854,3.018-0.714,0.008,0.001,0.026-0.224,0-0.227-1.104-0.143-2.094,0.091-3.018,0.714-0.045,0.031,0.022,0.213,0,0.227'/%3E %3Cpath d='m578.51,405.44c0.735-0.917,2.142-0.375,3.111-0.8,0.041-0.019-0.014-0.223,0-0.228-0.97,0.425-2.376-0.118-3.111,0.8-0.042,0.053,0.029,0.192,0,0.228'/%3E %3Cpath d='m583.85,405.52c0.236-1.287,2.084-0.613,2.927-1.14,0.045-0.028-0.021-0.216,0-0.228-0.868,0.543-2.694-0.156-2.938,1.171-0.009,0.045,0.007,0.217,0.011,0.197'/%3E %3Cpath d='m593.35,404.68c-0.761-0.045-1.453-0.319-2.223-0.268-0.851,0.058-1.682,0.468-2.488,0.712-0.036,0.011,0.005,0.227,0,0.228,0.83-0.252,1.627-0.578,2.488-0.712,0.75-0.117,1.479,0.223,2.223,0.267,0.014,0.001,0.022-0.226,0-0.227'/%3E %3Cpath d='m596.73,405.09c1.014-0.21,1.984-0.229,3.01-0.101,0.843,0.105,1.754,0.583,2.589,0.455,0.027-0.003,0.006-0.228,0-0.227-0.734,0.111-1.502-0.271-2.23-0.4-1.134-0.202-2.242-0.188-3.368,0.045-0.032,0.007-0.003,0.228-0.001,0.228'/%3E %3Cpath d='m607.49,405.44c1.293-0.134,2.641,0.276,3.732-0.622,0.045-0.038-0.024-0.207,0-0.229-1.092,0.9-2.439,0.488-3.732,0.623-0.025,0.002-0.01,0.229,0,0.228'/%3E %3Cpath d='m614.51,405.18c2.1-2.153,5.062,0.104,7.555-0.622,0.035-0.011-0.004-0.227,0-0.228-2.493,0.728-5.455-1.531-7.555,0.623-0.044,0.046,0.028,0.199,0,0.227'/%3E %3Cpath d='m569,405.18c0.979-0.767,2.153-0.775,3.289-1.156,0.037-0.012-0.007-0.225,0-0.227-1.136,0.38-2.311,0.389-3.289,1.156-0.046,0.035,0.024,0.209,0,0.227'/%3E %3Cpath d='m604.38,405.26c0.836-1.19,2.263-1.247,3.552-1.596,0.034-0.01-0.002-0.228,0-0.228-1.294,0.35-2.72,0.411-3.558,1.603-0.034,0.049,0.02,0.2,0.006,0.221'/%3E %3Cpath d='m623.13,404.56c0.839-0.847,2.038-0.65,3.111-0.89,0.03-0.007,0.001-0.227,0-0.227-1.073,0.239-2.272,0.043-3.111,0.889-0.045,0.046,0.029,0.2,0,0.228'/%3E %3Cpath d='m628.28,402.78c0.779-0.56,1.661-0.541,2.578-0.622,0.022-0.002,0.011-0.228,0-0.228-0.917,0.082-1.799,0.062-2.578,0.623-0.046,0.032,0.022,0.21,0,0.227'/%3E %3Cpath d='m628.28,400.38c0.853-0.246,1.747-0.369,2.489-0.89,0.045-0.031-0.022-0.211,0-0.227-0.742,0.52-1.637,0.643-2.489,0.889-0.035,0.012,0.004,0.227,0,0.228'/%3E %3Cpath d='m565.36,401.09c0.982-0.106,1.938-0.411,2.933-0.267,0.007,0.001,0.027-0.224,0-0.228-0.995-0.144-1.95,0.159-2.933,0.268-0.025,0.003-0.009,0.228,0,0.227'/%3E %3C/g%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='0.458' d='m523.83,317.68s8.07-0.732,7.675,0.649c-0.394,1.381,0.396,1.381,2.565,1.381s8.088-0.789,8.68,0.196c0.591,0.986,6.313-0.395,8.482-0.788,2.17-0.396,3.748-0.396,4.932-0.593,1.183-0.196,3.353-0.789,3.353,0s0.593,2.565,0.593,2.565,2.564,2.17,4.34,2.17c1.774,0,2.367,0.592,2.762,1.183,0.395,0.593,0,1.775,1.578,1.382,1.578-0.395,0.197,0.394,3.945-0.986,3.748-1.381,2.17-0.197,3.155-0.987,0.987-0.789,2.17-1.381,3.946-0.986,1.775,0.396,3.156,1.185,3.748,0.986,0.592-0.197,1.972-0.591,4.537,0.592,2.563,1.185,5.326,1.579,7.496,1.776s3.354,0.592,4.537,0,3.944-0.592,4.733-0.592c0.79,0-0.788-0.396,3.749,0.197,4.537,0.592,4.932,0.592,5.523,0s2.169-0.986,2.959-1.184c0.789-0.198,1.183-1.184,1.973-0.79,0.789,0.396,2.763,1.185,4.34,1.974,1.577,0.788,5.325,1.184,7.495,0.788,2.171-0.394,0.79-0.196,4.342,0.593,3.55,0.789,4.733,0.986,6.114,0.986s6.349-0.587,6.349-0.587l-1.813-0.417c-2.17-1.775-1.183-0.18-5.325-2.35s-2.366-1.381-8.482-2.762c-6.115-1.382-4.734-2.564-6.707-3.748-1.973-1.185-2.17,0-4.34,0-2.171,0-1.382-1.382-6.51-5.129-5.129-3.748-4.734-2.762-6.708-4.341-1.972-1.578-6.114-4.142-8.284-6.114-2.171-1.973-6.708-1.512-8.681-1.578-4.374-0.149-6.037-4.306-9.86-3.475-1.725,0.375-4.736-2.246-9.076-3.232-4.34-0.987-8.482,2.564-11.639,4.537-3.156,1.973-10.652,6.114-14.007,9.073-3.353,2.959-10.526,6.5-14.867,7.882-4.34,1.381-7.477,1.351-7.477,1.351'/%3E %3Cg fill='%23000'%3E %3Cpath d='m573.47,303.6c-0.552,0.357-1.154,0.582-1.776,0.789-0.072,0.025,0.014,0.451,0,0.455,0.622-0.207,1.225-0.432,1.776-0.789,0.09-0.057-0.042-0.428,0-0.455'/%3E %3Cpath d='m600.5,307.94c-2.096,1.107-3.716,2.894-5.721,4.144-0.089,0.055,0.041,0.429,0,0.455,2.005-1.25,3.625-3.036,5.721-4.144,0.086-0.046-0.034-0.438,0-0.455'/%3E %3Cpath d='m600.67,304.97c-1.108,1.535-2.38,2.877-4.043,3.813-0.088,0.049,0.036,0.434,0,0.454,1.668-0.938,2.943-2.29,4.056-3.828,0.069-0.096-0.041-0.4-0.013-0.439'/%3E %3Cpath d='m599.07,303.51c-0.767,0.682-1.592,1.272-2.599,1.528-0.066,0.017,0.003,0.454,0,0.455,1.007-0.256,1.832-0.848,2.599-1.528,0.091-0.081-0.053-0.408,0-0.455'/%3E %3Cpath d='m599.22,304.74c-1.146,1.157-2.228,2.451-3.743,3.133-0.083,0.037,0.024,0.444,0,0.455,1.516-0.682,2.597-1.976,3.743-3.133,0.09-0.09-0.054-0.4,0-0.455'/%3E %3Cpath d='m599.98,310.62c-1.062,1.382-1.741,3.096-3.439,3.82-0.081,0.035,0.024,0.445,0,0.455,1.705-0.727,2.375-2.436,3.439-3.82,0.083-0.108-0.058-0.381,0-0.455'/%3E %3Cpath d='m599.07,313.91c-0.625,0.72-1.123,1.641-2.063,1.987-0.077,0.028,0.016,0.448,0,0.455,0.94-0.347,1.438-1.268,2.063-1.987,0.086-0.099-0.058-0.39,0-0.455'/%3E %3Cpath d='m599.53,316.5c0.901,0.637,1.314,1.731,2.216,2.369-0.045-0.032,0.091-0.392,0-0.455-0.9-0.637-1.313-1.732-2.216-2.369,0.045,0.033-0.091,0.391,0,0.455'/%3E %3Cpath d='m601.51,321.16c0.437,0.305,0.703,0.77,1.069,1.146-0.005-0.004,0.023-0.208,0.023-0.228,0-0.05,0.016-0.187-0.023-0.228-0.366-0.376-0.633-0.842-1.069-1.146-0.004-0.003-0.023,0.214-0.023,0.229,0,0.039-0.016,0.199,0.023,0.227'/%3E %3Cpath d='m571.33,307.56c-1.21,1.263-2.615,2.316-4.203,3.057-0.083,0.039,0.028,0.442,0,0.454,1.588-0.739,2.993-1.793,4.203-3.056,0.088-0.092-0.057-0.397,0-0.455'/%3E %3Cpath d='m569.34,311c-1.938,1.647-4.256,2.582-6.648,3.362-0.073,0.023,0.012,0.451,0,0.455,2.393-0.78,4.711-1.715,6.648-3.362,0.091-0.078-0.052-0.411,0-0.455'/%3E %3Cpath d='m566.13,314.45c-1.01,1.436-2.495,3.152-4.273,3.583-0.065,0.017,0.002,0.455,0,0.455,1.787-0.434,3.27-2.154,4.285-3.599,0.069-0.096-0.041-0.398-0.012-0.439'/%3E %3Cpath d='m555.21,315.97c-1.099,0.703-2.219,1.361-3.438,1.834-0.078,0.03,0.019,0.447,0,0.455,1.22-0.473,2.34-1.131,3.438-1.834,0.089-0.057-0.041-0.427,0-0.455'/%3E %3Cpath d='m552.92,315.21c-0.289,0.078-0.559,0.207-0.84,0.306-0.076,0.026,0.014,0.449,0,0.455,0.281-0.099,0.551-0.228,0.84-0.306,0.067-0.02-0.004-0.454,0-0.455'/%3E %3Cpath d='m569.5,318.11c-0.576,0.331-1.138,0.685-1.681,1.069-0.092,0.064,0.045,0.424,0,0.455,0.543-0.385,1.104-0.738,1.681-1.069,0.087-0.051-0.038-0.435,0-0.455'/%3E %3Cpath d='m590.51,319.03c-0.81,0.37-1.603,0.768-2.369,1.223-0.088,0.052,0.039,0.433,0,0.455,0.767-0.455,1.56-0.853,2.369-1.223,0.083-0.038-0.025-0.443,0-0.455'/%3E %3Cpath d='m595.94,318.11c-0.543,0.319-0.986,0.764-1.306,1.307-0.039,0.066-0.018,0.208-0.016,0.28,0.001,0.016,0.015,0.181,0.029,0.159,0.314-0.538,0.755-0.976,1.292-1.291,0.09-0.053-0.037-0.434,0.001-0.455'/%3E %3C/g%3E %3Cg opacity='0.59' fill='%23007638'%3E %3Cpath d='m545.32,369.22c-0.088,1.037-0.089,2.198,0.518,3.091-0.028-0.043,0.08-0.339,0.013-0.439-0.469-0.687-0.568-1.508-0.498-2.33,0.004-0.059-0.019-0.499-0.033-0.322'/%3E %3Cpath d='m544.71,372.13c-0.365-0.547-0.995-1.318-0.96-2.018,0.004-0.074-0.025-0.511-0.039-0.229-0.054,1.048,0.417,1.833,0.987,2.687-0.029-0.045,0.079-0.34,0.012-0.44'/%3E %3Cpath d='m543.08,371.71c-1.221-1.464-1.811-3.356-1.928-5.24-0.017-0.28-0.044,0.154-0.039,0.229,0.122,1.965,0.689,3.935,1.967,5.467-0.058-0.069,0.085-0.353,0-0.456'/%3E %3Cpath d='m547.22,371.88c-0.149-0.164-0.225-0.362-0.318-0.56-0.01-0.021-0.028,0.143-0.028,0.159-0.002,0.079-0.02,0.206,0.015,0.279,0.099,0.203,0.179,0.407,0.332,0.576-0.006-0.006,0.022-0.207,0.022-0.228,0-0.051,0.015-0.183-0.023-0.226'/%3E %3Cpath d='m548.27,372.04c-0.188-0.066-0.375-0.135-0.479-0.316-0.014-0.021-0.028,0.144-0.028,0.158-0.003,0.072-0.022,0.214,0.015,0.28,0.11,0.188,0.295,0.264,0.493,0.333-0.015-0.005,0.074-0.43-0.001-0.455'/%3E %3Cpath d='m540.08,371.07c-0.68-1.307-0.718-2.754-0.797-4.193-0.017-0.281-0.044,0.153-0.04,0.229,0.083,1.507,0.113,3.035,0.825,4.404-0.029-0.055,0.07-0.328,0.012-0.44'/%3E %3Cpath d='m541.27,358.96c0.01,0.806,0.343,2.504-0.707,2.774-0.067,0.017,0.002,0.454,0,0.455,1.127-0.29,0.762-2.398,0.753-3.229-0.003-0.257-0.049-0.258-0.046,0'/%3E %3Cpath d='m539.51,362.27c0.225-0.235,0.387-0.513,0.493-0.819,0.029-0.083,0.019-0.193,0.016-0.279,0-0.02-0.021-0.176-0.028-0.159-0.104,0.3-0.26,0.573-0.48,0.803-0.039,0.041-0.022,0.177-0.022,0.229-0.001,0.017,0.026,0.22,0.021,0.225'/%3E %3Cpath d='m541.54,362.27c0.669-0.458,0.594-1.292,0.59-2.012-0.001-0.258-0.046-0.258-0.045,0,0.003,0.61,0.006,1.181-0.545,1.557-0.091,0.062,0.044,0.425,0,0.455'/%3E %3Cpath d='m549,360.16c0.246,0.594,0.071,1.338,0.063,1.971-0.003,0.259,0.042,0.258,0.046,0,0.009-0.769,0.208-1.674-0.098-2.41,0.027,0.065-0.062,0.319-0.011,0.439'/%3E %3Cpath d='m542.43,362.35c0.877-0.541,0.905-1.785,0.741-2.695-0.007-0.04-0.039,0.303-0.023,0.393,0.127,0.7-0.095,1.464-0.718,1.848-0.089,0.054,0.039,0.429,0,0.454'/%3E %3Cpath d='m548.36,362.18c0.184-0.296,0.249-0.625,0.259-0.97,0.002-0.085,0.014-0.197-0.017-0.28-0.006-0.018-0.027,0.141-0.027,0.159-0.006,0.229-0.108,0.462-0.228,0.651-0.039,0.064-0.018,0.21-0.016,0.28,0.001,0.018,0.014,0.182,0.029,0.16'/%3E %3Cpath d='m545.02,358.62c0.394,0.968-0.136,2.262-0.253,3.27-0.008,0.059,0.011,0.5,0.031,0.321,0.148-1.269,0.746-2.771,0.233-4.03,0.028,0.065-0.06,0.318-0.011,0.439'/%3E %3Cpath d='m549.67,362.04v-0.892c0-0.016,0.003-0.228-0.023-0.228-0.025,0-0.022,0.212-0.022,0.228v0.892c0,0.017-0.003,0.228,0.022,0.228,0.026,0,0.023-0.211,0.023-0.228'/%3E %3Cpath d='m558.25,363.25c0.538-0.587,0.509-1.425,0.509-2.174,0-0.258-0.045-0.258-0.045,0,0,0.623-0.022,1.237-0.464,1.719-0.088,0.095,0.055,0.393,0,0.455'/%3E %3Cpath d='m545.43,362.11c0.807-0.955,0.907-2.16,0.993-3.356,0.006-0.074-0.019-0.511-0.039-0.229-0.082,1.127-0.199,2.237-0.954,3.131-0.085,0.101,0.058,0.387,0,0.454'/%3E %3Cpath d='m543.32,362.27c1.449-0.467,0.84-3.089,0.66-4.155-0.006-0.039-0.038,0.304-0.023,0.394,0.17,1.008,0.656,2.89-0.637,3.307-0.073,0.023,0.01,0.45,0,0.454'/%3E %3Cpath d='m546.87,360.23c-0.039,0.584-0.106,1.23-0.629,1.59-0.091,0.063,0.044,0.425,0,0.455,0.583-0.402,0.625-1.17,0.668-1.816,0.005-0.074-0.02-0.509-0.039-0.229'/%3E %3Cpath d='m549.81,362.35c0.255-0.188,0.334-0.431,0.348-0.735,0.003-0.084,0.013-0.198-0.017-0.28-0.007-0.018-0.027,0.143-0.027,0.159-0.008,0.154-0.191,0.319-0.304,0.401-0.039,0.028-0.022,0.187-0.022,0.228,0,0.013,0.02,0.229,0.022,0.227'/%3E %3Cpath d='m547.3,362.35c0.743-0.965,0.979-2.138,0.995-3.331,0.002-0.145-0.039-0.44-0.044-0.12-0.015,1.085-0.283,2.13-0.951,2.996-0.082,0.106,0.058,0.381,0,0.455'/%3E %3Cpath d='m538.7,362.03c0.087-0.088,0.146-0.153,0.173-0.273,0.023-0.099,0.015-0.212,0.009-0.312-0.001-0.017-0.012-0.167-0.031-0.082-0.034,0.083-0.085,0.154-0.15,0.212-0.039,0.041-0.023,0.179-0.023,0.229-0.002,0.018,0.026,0.222,0.022,0.226'/%3E %3Cpath d='m541.78,371.39c-0.826-1.052-1.119-2.375-1.454-3.642,0.021,0.077-0.046,0.31-0.012,0.438,0.337,1.275,0.635,2.601,1.466,3.658-0.058-0.072,0.083-0.347,0-0.454'/%3E %3Cpath d='m538.95,371.07c-0.25-0.417-0.489-0.836-0.648-1.298-0.007-0.018-0.028,0.141-0.028,0.159-0.002,0.086-0.013,0.196,0.016,0.28,0.16,0.462,0.399,0.88,0.649,1.298,0.013,0.021,0.028-0.144,0.028-0.159,0.001-0.071,0.022-0.215-0.017-0.28'/%3E %3Cpath d='m549.47,370.88c0.027,0.296,0.085,0.585,0.172,0.87,0.005,0.017,0.027-0.14,0.027-0.159,0.003-0.089,0.012-0.194-0.016-0.28-0.076-0.247-0.127-0.495-0.152-0.752-0.007-0.077-0.023-0.077-0.031,0-0.012,0.106-0.011,0.215,0,0.321'/%3E %3Cpath d='m557.42,379.56c0.052,0.532,0.404,0.909,0.659,1.356,0.013,0.022,0.027-0.144,0.027-0.159,0.002-0.072,0.022-0.213-0.016-0.279-0.225-0.396-0.593-0.768-0.639-1.239-0.007-0.077-0.024-0.077-0.032,0-0.009,0.106-0.008,0.215,0.001,0.321'/%3E %3Cpath d='m557.36,381.12c-0.418-0.354-0.578-0.863-0.725-1.37,0.022,0.075-0.049,0.31-0.012,0.438,0.147,0.516,0.313,1.03,0.736,1.388-0.051-0.046,0.092-0.38,0.001-0.456'/%3E %3Cpath d='m603.5,362.92c0.822-0.532,1.123-1.493,1.466-2.359,0.047-0.122-0.039-0.373-0.013-0.439-0.339,0.86-0.639,1.815-1.453,2.345-0.089,0.057,0.042,0.426,0,0.453'/%3E %3Cpath d='m605.54,362.43c0.987-1.639,0.686-3.628,0.582-5.444-0.017-0.279-0.044,0.155-0.04,0.229,0.093,1.621,0.319,3.327-0.553,4.775-0.064,0.107,0.04,0.392,0.011,0.44'/%3E %3Cpath d='m648.62,367.72v-1.054c0-0.017,0.003-0.229-0.023-0.229-0.025,0-0.022,0.212-0.022,0.229v1.054c0,0.016-0.003,0.228,0.022,0.228s0.023-0.212,0.023-0.228'/%3E %3Cpath d='m653.32,367.92c0.076-0.333,0.092-0.668,0.092-1.008,0-0.015,0.003-0.227-0.023-0.227-0.025,0-0.021,0.212-0.021,0.227,0,0.21-0.022,0.411-0.07,0.615-0.023,0.097-0.014,0.212-0.008,0.311,0,0.018,0.009,0.167,0.03,0.082'/%3E %3Cpath d='m649.42,368.51c0.56-1.27,0.732-2.624,0.823-3.998,0.006-0.075-0.02-0.51-0.038-0.229-0.088,1.306-0.267,2.584-0.798,3.788-0.052,0.119,0.041,0.378,0.013,0.439'/%3E %3Cpath d='m652.11,368.21c0.011-0.922,0.15-1.836,0.162-2.758,0.003-0.258-0.042-0.258-0.046,0-0.011,0.922-0.15,1.836-0.162,2.758-0.002,0.26,0.043,0.259,0.046,0'/%3E %3Cpath d='m650.96,368.1c0.49-1.713,0.954-3.395,0.987-5.188,0.003-0.144-0.036-0.439-0.043-0.121-0.032,1.684-0.497,3.268-0.957,4.87-0.035,0.127,0.035,0.363,0.013,0.439'/%3E %3Cpath d='m647.65,368.05c0.005-0.433,0.075-0.863,0.081-1.297,0-0.017,0.003-0.229-0.022-0.229-0.026,0-0.022,0.212-0.023,0.229-0.005,0.432-0.076,0.863-0.081,1.297,0,0.016-0.003,0.227,0.023,0.227s0.022-0.211,0.022-0.227'/%3E %3Cpath d='m649.99,368.51c0.47-1.482,0.348-3.043,0.573-4.565,0.013-0.09-0.018-0.431-0.023-0.393-0.222,1.504-0.098,3.057-0.562,4.519-0.04,0.127,0.035,0.366,0.012,0.439'/%3E %3Cpath d='m648.94,368.57c0.166-0.745,0.323-1.479,0.335-2.245,0.002-0.145-0.039-0.44-0.044-0.121-0.01,0.672-0.168,1.322-0.313,1.973-0.022,0.099-0.015,0.211-0.008,0.312,0.001,0.014,0.011,0.167,0.03,0.081'/%3E %3Cpath d='m650.73,368.13c0.011-0.848,0.149-1.687,0.161-2.534,0.002-0.146-0.039-0.44-0.044-0.121-0.012,0.888-0.151,1.767-0.163,2.655-0.003,0.26,0.043,0.259,0.046,0'/%3E %3Cpath d='m604.56,362.68c0.724-0.944,1.126-2.063,1.157-3.249,0.004-0.145-0.035-0.44-0.043-0.121-0.029,1.053-0.48,2.088-1.114,2.915-0.083,0.108,0.058,0.381,0,0.455'/%3E %3Cpath d='m602.54,363.08c0.224-0.443,0.475-0.872,0.73-1.298,0.038-0.065,0.018-0.209,0.016-0.28,0-0.016-0.015-0.181-0.028-0.159-0.255,0.428-0.506,0.854-0.729,1.299-0.037,0.071-0.02,0.203-0.018,0.279,0.001,0.016,0.019,0.18,0.029,0.159'/%3E %3Cpath d='m606.84,361.84c0.08-0.604,0.092-1.211,0.092-1.819,0-0.016,0.003-0.228-0.022-0.228s-0.022,0.212-0.022,0.228c0,0.478-0.007,0.952-0.07,1.427-0.014,0.103-0.014,0.208-0.008,0.311,0,0.013,0.02,0.169,0.03,0.081'/%3E %3Cpath d='m608.7,361.29c0.312-1.211,0.496-2.446,0.736-3.673,0.018-0.09-0.016-0.434-0.023-0.393-0.237,1.21-0.417,2.432-0.724,3.626-0.034,0.13,0.03,0.361,0.011,0.44'/%3E %3Cpath d='m610.1,360.5c0.006-0.704,0.076-1.405,0.081-2.109,0.002-0.258-0.043-0.258-0.046,0-0.005,0.704-0.075,1.405-0.081,2.109-0.002,0.258,0.044,0.258,0.046,0'/%3E %3Cpath d='m611.38,359.99c0.403-1.25,0.645-2.527,0.744-3.836,0.006-0.074-0.019-0.509-0.039-0.229-0.095,1.237-0.336,2.444-0.717,3.626-0.04,0.126,0.036,0.366,0.012,0.439'/%3E %3Cpath d='m613.16,359.75c0.465-0.824,0.574-1.729,0.659-2.654,0.005-0.059-0.016-0.499-0.032-0.321-0.082,0.89-0.194,1.747-0.638,2.536-0.063,0.108,0.04,0.388,0.011,0.439'/%3E %3Cpath d='m614.62,360.16c0.546-0.826,0.727-1.766,0.82-2.735,0.007-0.059-0.015-0.499-0.031-0.321-0.092,0.934-0.278,1.826-0.802,2.618-0.067,0.1,0.041,0.394,0.013,0.438'/%3E %3Cpath d='m617.05,359.27c0.87-0.739,1.441-1.684,1.79-2.766,0.041-0.126-0.035-0.366-0.013-0.439-0.345,1.074-0.912,2.016-1.777,2.75-0.091,0.078,0.051,0.411,0,0.455'/%3E %3Cpath d='m620.38,359.34c0.742-1.005,0.587-2.334,0.662-3.511,0.005-0.075-0.021-0.511-0.039-0.23-0.071,1.124,0.07,2.347-0.635,3.302-0.07,0.095,0.041,0.401,0.012,0.439'/%3E %3Cpath d='m622.32,358.62c1.003-0.544,1.304-1.607,1.32-2.681,0.002-0.146-0.039-0.44-0.044-0.121-0.015,0.967-0.402,1.873-1.276,2.347-0.087,0.047,0.034,0.437,0,0.455'/%3E %3Cpath d='m618.78,359.37c0-0.369,0.002-0.737,0.07-1.101,0.018-0.102,0.014-0.21,0.008-0.312-0.001-0.015-0.015-0.169-0.031-0.082-0.091,0.492-0.092,0.995-0.093,1.494,0,0.017-0.003,0.228,0.023,0.228s0.023-0.211,0.023-0.227'/%3E %3Cpath d='m613.83,360.42c0-0.45,0-0.899,0.069-1.345,0.017-0.102,0.015-0.208,0.009-0.312-0.001-0.014-0.018-0.169-0.031-0.082-0.09,0.576-0.092,1.157-0.093,1.738,0,0.016-0.003,0.227,0.022,0.227,0.027,0.001,0.024-0.21,0.024-0.226'/%3E %3Cpath d='m611.45,361.54c0.58-0.542,0.587-1.356,0.665-2.094,0.006-0.059-0.014-0.5-0.032-0.321-0.074,0.698-0.085,1.447-0.633,1.961-0.09,0.083,0.053,0.404,0,0.454'/%3E %3Cpath d='m610.32,361.7c0.332-0.711,0.342-1.477,0.342-2.247,0-0.259-0.046-0.259-0.046,0-0.001,0.633-0.036,1.229-0.308,1.809-0.055,0.115,0.04,0.378,0.012,0.438'/%3E %3Cpath d='m608.8,362.37v-1.136c0-0.015,0.003-0.227-0.022-0.227-0.026,0-0.023,0.212-0.023,0.227v1.136c0,0.017-0.003,0.228,0.023,0.228,0.025-0.001,0.022-0.212,0.022-0.228'/%3E %3Cpath d='m607.32,362.83c0.42-1.224,0.961-2.399,1.223-3.673,0.019-0.089-0.015-0.433-0.023-0.393-0.259,1.257-0.797,2.419-1.21,3.627-0.046,0.125,0.034,0.368,0.01,0.439'/%3E %3Cpath d='m615.68,360.32c0.4-0.84,0.568-1.734,0.659-2.655,0.006-0.059-0.016-0.499-0.032-0.321-0.086,0.882-0.256,1.734-0.638,2.537-0.056,0.116,0.039,0.379,0.011,0.439'/%3E %3Cpath d='m617.38,359.83c0.093-0.185,0.176-0.372,0.243-0.568,0.029-0.083,0.019-0.192,0.016-0.279,0-0.02-0.021-0.176-0.027-0.158-0.067,0.195-0.15,0.382-0.243,0.567-0.036,0.072-0.019,0.202-0.017,0.279,0,0.016,0.019,0.18,0.028,0.159'/%3E %3Cpath d='m619.65,359.42c0.658-1.194,0.359-2.579,0.253-3.868-0.015-0.178-0.037,0.263-0.033,0.322,0.087,1.046,0.3,2.144-0.231,3.106-0.061,0.111,0.04,0.389,0.011,0.44'/%3E %3Cpath d='m621.6,359.18c0.637-1.275,0.736-2.678,0.824-4.079,0.005-0.073-0.021-0.509-0.039-0.229-0.084,1.333-0.192,2.657-0.797,3.869-0.056,0.115,0.04,0.383,0.012,0.439'/%3E %3Cpath d='m601.46,360.18c-0.093,0.75-0.477,1.45-0.32,2.224,0.017,0.086,0.03-0.067,0.031-0.082,0.006-0.101,0.012-0.211-0.009-0.312-0.05-0.245,0.129-0.61,0.193-0.848,0.061-0.218,0.109-0.437,0.136-0.661,0.008-0.058-0.009-0.499-0.031-0.321'/%3E %3Cpath d='m601.48,363.16c0.144-0.593,0.242-1.195,0.405-1.784,0.035-0.128-0.034-0.362-0.013-0.438-0.162,0.589-0.261,1.19-0.405,1.784-0.032,0.129,0.031,0.359,0.013,0.438'/%3E %3Cpath d='m609.53,361.4v-0.892c0-0.016,0.003-0.228-0.022-0.228-0.026,0-0.023,0.212-0.023,0.228v0.892c0,0.017-0.003,0.228,0.023,0.228,0.025,0,0.022-0.211,0.022-0.228'/%3E %3Cpath d='m612.61,360.69c-0.016-0.758-0.233-1.458-0.422-2.187,0.021,0.079-0.045,0.31-0.011,0.438,0.158,0.616,0.375,1.226,0.389,1.869,0.007,0.32,0.047,0.025,0.044-0.12'/%3E %3Cpath d='m616.24,360.07c0.563-0.929,0.811-1.962,0.979-3.024,0.014-0.09-0.018-0.431-0.023-0.393-0.167,1.049-0.414,2.063-0.967,2.979-0.066,0.104,0.04,0.39,0.011,0.438'/%3E %3Cpath d='m629.06,371.75c0.468-0.865,0.875-1.755,1.217-2.677,0.046-0.122-0.037-0.37-0.013-0.438-0.341,0.923-0.75,1.812-1.216,2.677-0.059,0.11,0.041,0.385,0.012,0.438'/%3E %3Cpath d='m631.89,371.52c0.714-0.813,1.142-1.719,1.309-2.788,0.015-0.091-0.017-0.432-0.022-0.394-0.165,1.053-0.583,1.927-1.286,2.728-0.087,0.099,0.056,0.39-0.001,0.454'/%3E %3Cpath d='m634.24,371.11c0.923-1.15,1.291-2.464,1.066-3.912-0.006-0.038-0.037,0.303-0.023,0.394,0.18,1.15-0.348,2.197-1.043,3.063-0.084,0.104,0.057,0.384,0,0.455'/%3E %3Cpath d='m636.44,370.54c0.763-1.401,0.593-3.07,0.416-4.598-0.021-0.178-0.039,0.262-0.032,0.321,0.151,1.309,0.249,2.654-0.396,3.838-0.06,0.11,0.04,0.386,0.012,0.439'/%3E %3Cpath d='m630.91,369.64c0.104,0.318,0.406,0.807,0.006,1.013-0.086,0.045,0.032,0.439,0,0.455,0.301-0.155,0.288-0.529,0.271-0.825-0.022-0.378-0.149-0.724-0.265-1.082,0.023,0.073-0.053,0.313-0.012,0.439'/%3E %3Cpath d='m632.87,371.28c0.453-0.495,0.429-1.219,0.43-1.849,0-0.017,0.002-0.229-0.023-0.229-0.026,0-0.022,0.212-0.022,0.229-0.002,0.502-0.028,1.006-0.384,1.394-0.088,0.096,0.055,0.394-0.001,0.455'/%3E %3Cpath d='m635.47,370.78c0.263-0.629,0.41-1.261,0.421-1.942,0.002-0.146-0.039-0.44-0.044-0.121-0.009,0.57-0.171,1.104-0.389,1.625-0.05,0.119,0.039,0.374,0.012,0.438'/%3E %3Cpath d='m630.21,371.13c0-0.289,0.005-0.575,0.07-0.858,0.021-0.098,0.014-0.212,0.008-0.311-0.001-0.017-0.013-0.167-0.031-0.082-0.094,0.409-0.092,0.834-0.093,1.251,0,0.016-0.003,0.228,0.022,0.228,0.027,0,0.024-0.212,0.024-0.228'/%3E %3Cpath d='m627.93,371.89c0.076-0.38,0.151-0.762,0.319-1.113,0.035-0.074,0.018-0.201,0.015-0.279,0-0.017-0.018-0.181-0.028-0.159-0.173,0.365-0.25,0.765-0.328,1.158-0.021,0.101-0.015,0.211-0.009,0.312,0.001,0.014,0.015,0.167,0.031,0.081'/%3E %3Cpath d='m634.79,366.85c-0.038,0.898-0.577,1.717-0.309,2.633-0.022-0.075,0.05-0.312,0.013-0.439-0.115-0.393,0.137-0.886,0.229-1.268,0.063-0.269,0.1-0.529,0.111-0.805,0.005-0.144-0.031-0.439-0.044-0.121'/%3E %3Cpath d='m631.9,368.9c-0.062-0.392-0.07-0.785-0.07-1.182,0-0.016,0.003-0.227-0.022-0.227-0.026,0-0.023,0.211-0.023,0.227,0,0.527,0.011,1.053,0.093,1.575,0.014,0.087,0.03-0.068,0.031-0.082,0.004-0.101,0.006-0.209-0.009-0.311'/%3E %3Cpath d='m633.69,369.22c0.081-0.568,0.162-1.136,0.243-1.703,0.015-0.102,0.015-0.208,0.009-0.311-0.001-0.015-0.02-0.17-0.032-0.082-0.081,0.566-0.162,1.135-0.243,1.703-0.015,0.102-0.014,0.208-0.008,0.311,0.001,0.014,0.019,0.17,0.031,0.082'/%3E %3Cpath d='m632.48,369.02c0-0.37,0.016-0.729,0.145-1.078,0.031-0.082,0.019-0.195,0.016-0.28,0-0.018-0.021-0.178-0.027-0.159-0.178,0.484-0.178,1.009-0.179,1.518,0,0.016-0.003,0.227,0.022,0.227,0.026-0.001,0.023-0.212,0.023-0.228'/%3E %3Cpath d='m636.3,368.86c0-0.393-0.005-0.785-0.092-1.17-0.021-0.085-0.031,0.065-0.032,0.082-0.005,0.099-0.014,0.213,0.008,0.311,0.06,0.258,0.07,0.514,0.07,0.777,0,0.016-0.003,0.227,0.023,0.227,0.026-0.001,0.023-0.211,0.023-0.227'/%3E %3Cpath d='m633.52,371.1c0.182-0.381,0.252-0.794,0.26-1.213,0.001-0.086,0.014-0.197-0.018-0.28-0.005-0.019-0.026,0.14-0.026,0.159-0.005,0.31-0.096,0.617-0.228,0.895-0.036,0.075-0.018,0.202-0.016,0.28,0.001,0.015,0.018,0.179,0.028,0.159'/%3E %3Cpath d='m631.02,368.96c-0.005-0.354-0.075-0.702-0.081-1.054-0.001-0.02-0.022-0.179-0.028-0.159-0.03,0.082-0.017,0.192-0.016,0.279,0.006,0.354,0.076,0.701,0.081,1.055,0,0.019,0.021,0.177,0.027,0.159,0.031-0.082,0.018-0.194,0.017-0.28'/%3E %3Cpath d='m657.62,378.79c0.251-1.741,1.708-2.977,2.028-4.704,0.016-0.09-0.017-0.434-0.024-0.394-0.319,1.728-1.775,2.959-2.027,4.704-0.013,0.09,0.017,0.432,0.023,0.394'/%3E %3Cpath d='m658.76,378.16c0.008-0.474,0.183-0.904,0.547-1.212,0.091-0.077-0.052-0.411,0-0.455-0.467,0.395-0.581,0.961-0.591,1.546-0.002,0.145,0.039,0.44,0.044,0.121'/%3E %3Cpath d='m656.64,378.57c0.23-0.455,0.489-0.881,0.887-1.209,0.04-0.033,0.022-0.184,0.022-0.228,0-0.016-0.022-0.227-0.022-0.227-0.402,0.333-0.666,0.763-0.897,1.224-0.037,0.072-0.019,0.203-0.017,0.28,0,0.016,0.016,0.18,0.027,0.16'/%3E %3Cpath d='m659.64,377.84c0.313-0.996,0.41-2.024,0.496-3.06,0.006-0.059-0.018-0.499-0.032-0.321-0.083,0.996-0.175,1.984-0.477,2.942-0.04,0.127,0.036,0.367,0.013,0.439'/%3E %3Cpath d='m656.06,377.96c-0.044-0.112-0.066-0.144-0.065-0.095-0.007-0.078-0.023-0.077-0.031,0-0.012,0.105-0.011,0.215,0,0.32,0.008,0.095,0.039,0.156,0.097,0.229-0.008-0.01,0.022-0.203,0.022-0.228-0.001-0.056,0.015-0.178-0.023-0.226'/%3E %3Cpath d='m660.04,378.49c1.035-1.652,1.295-3.582,1.064-5.49-0.021-0.178-0.039,0.263-0.032,0.322,0.204,1.686-0.152,3.305-1.044,4.729-0.065,0.104,0.042,0.392,0.012,0.439'/%3E %3Cpath d='m652.67,368.13c0.087-0.745,0.086-1.49-0.086-2.224-0.019-0.085-0.029,0.065-0.03,0.082-0.007,0.1-0.016,0.214,0.008,0.312,0.118,0.501,0.137,0.994,0.077,1.509-0.008,0.059,0.011,0.499,0.031,0.321'/%3E %3Cpath d='m660.77,377.92c0.793-1.271,0.65-2.927,0.821-4.356,0.007-0.06-0.01-0.5-0.032-0.322-0.168,1.408-0.023,2.993-0.8,4.24-0.065,0.104,0.04,0.392,0.011,0.438'/%3E %3Cpath d='m644.29,378.35c-0.034,0.314-0.036,0.65,0.091,0.948,0.01,0.02,0.028-0.143,0.028-0.159,0.003-0.082,0.019-0.203-0.015-0.28-0.02-0.042-0.077-0.14-0.072-0.188,0.012-0.104,0.011-0.216,0-0.32-0.007-0.078-0.023-0.077-0.032-0.001'/%3E %3Cpath d='m598.48,360.73c0.967-0.608,1.357-1.708,1.629-2.765,0.031-0.13-0.033-0.361-0.014-0.439-0.268,1.051-0.653,2.145-1.615,2.749-0.09,0.057,0.04,0.43,0,0.455'/%3E %3Cpath d='m643.43,379.32c0-0.285,0.016-0.601-0.099-0.869-0.008-0.02-0.027,0.143-0.027,0.159-0.002,0.082-0.019,0.202,0.016,0.28,0.06,0.139,0.064,0.28,0.064,0.43,0,0.017-0.003,0.228,0.022,0.228,0.027-0.001,0.024-0.212,0.024-0.228'/%3E %3Cpath d='m645.06,379.16v-2.028c0-0.258-0.046-0.258-0.046,0v2.028c0,0.258,0.046,0.258,0.046,0'/%3E %3Cpath d='m598.62,357.34c-0.084,0.961-0.119,2.135-1.038,2.691-0.09,0.054,0.038,0.432,0,0.455,0.952-0.578,0.983-1.832,1.069-2.825,0.005-0.057-0.017-0.498-0.031-0.321'/%3E %3Cpath d='m601.81,363.32c0.556-1.457,0.887-2.897,0.907-4.458,0.002-0.145-0.039-0.44-0.044-0.12-0.02,1.46-0.359,2.788-0.876,4.139-0.046,0.122,0.038,0.371,0.013,0.439'/%3E %3Cpath d='m596.86,360.48c0.146-0.229,0.239-0.474,0.324-0.73,0.028-0.085,0.019-0.192,0.017-0.279-0.002-0.02-0.022-0.177-0.028-0.159-0.085,0.256-0.179,0.501-0.324,0.729-0.04,0.063-0.018,0.212-0.016,0.28,0,0.016,0.013,0.181,0.027,0.159'/%3E %3Cpath d='m600.45,362.69v-0.568c0-0.015,0.003-0.227-0.023-0.227-0.025,0-0.022,0.212-0.022,0.227v0.568c0,0.016-0.003,0.227,0.022,0.227,0.026-0.001,0.023-0.212,0.023-0.227'/%3E %3Cpath d='m596.2,360.41c0.066-0.015,0.112-0.036,0.162-0.081,0.04-0.036,0.023-0.182,0.023-0.229,0-0.017-0.024-0.226-0.023-0.227-0.05,0.045-0.096,0.066-0.162,0.081-0.062,0.013-0.004,0.457,0,0.456'/%3E %3Cpath d='m642.94,352.73c0-0.305,0.029-0.57,0.194-0.833,0.039-0.063,0.017-0.21,0.016-0.279-0.001-0.016-0.014-0.182-0.027-0.158-0.239,0.381-0.228,0.836-0.229,1.271,0,0.017-0.003,0.228,0.023,0.228,0.026-0.002,0.023-0.212,0.023-0.229'/%3E %3Cpath d='m656.41,353.05c0.005-0.39,0.1-0.771,0.192-1.147,0.023-0.09,0.02-0.189,0.017-0.28,0-0.021-0.024-0.173-0.027-0.159-0.132,0.527-0.22,1.043-0.229,1.587,0,0.017-0.003,0.228,0.023,0.228,0.028-0.001,0.024-0.212,0.024-0.229'/%3E %3Cpath d='m649.66,353.27c0.534-1.712,0.64-3.486,0.647-5.269,0.001-0.26-0.045-0.26-0.046,0-0.007,1.639-0.124,3.258-0.614,4.829-0.04,0.129,0.035,0.366,0.013,0.44'/%3E %3Cpath d='m647.99,353.26v-1.157c0-0.016,0.003-0.228-0.022-0.228-0.026,0-0.023,0.212-0.023,0.228v1.157c0,0.016-0.003,0.227,0.023,0.227,0.025,0,0.022-0.211,0.022-0.227'/%3E %3Cpath d='m653.34,353.37c0.127-0.464,0.044-0.938-0.104-1.386-0.007-0.018-0.028,0.14-0.028,0.159-0.002,0.087-0.012,0.194,0.016,0.279,0.051,0.153,0.149,0.348,0.106,0.508-0.025,0.088-0.02,0.19-0.017,0.28,0,0.021,0.023,0.175,0.027,0.16'/%3E %3Cpath d='m646.52,352.84c0.013-1.076,0.204-2.137,0.309-3.206,0.007-0.06-0.015-0.499-0.031-0.321-0.115,1.177-0.308,2.341-0.323,3.527-0.004,0.259,0.042,0.258,0.045,0'/%3E %3Cpath d='m651.44,353.16c0.529-0.802,0.545-1.764,0.641-2.688,0.007-0.06-0.013-0.499-0.032-0.321-0.093,0.889-0.112,1.801-0.619,2.571-0.068,0.1,0.039,0.394,0.01,0.438'/%3E %3Cpath d='m644.19,353.04c0.104-0.557,0.107-1.126,0.21-1.683,0.02-0.101,0.015-0.211,0.01-0.312-0.002-0.015-0.017-0.169-0.032-0.082-0.104,0.557-0.107,1.127-0.21,1.684-0.02,0.1-0.015,0.21-0.008,0.311,0,0.014,0.014,0.169,0.03,0.082'/%3E %3Cpath d='m648.82,353.24c0.119-0.512,0.115-1.041,0.116-1.563,0-0.016,0.003-0.228-0.023-0.228s-0.022,0.212-0.022,0.228c0,0.395-0.004,0.784-0.094,1.172-0.022,0.097-0.014,0.211-0.008,0.31,0.001,0.016,0.01,0.166,0.031,0.081'/%3E %3Cpath d='m646.92,353.37c0.438-1.165,1.034-2.262,1.269-3.495,0.016-0.089-0.016-0.432-0.024-0.393-0.229,1.219-0.823,2.299-1.256,3.448-0.047,0.123,0.037,0.371,0.011,0.44'/%3E %3Cpath d='m645.13,352.51c-0.166-0.262-0.294-0.58-0.3-0.894,0-0.019-0.021-0.178-0.027-0.159-0.03,0.083-0.019,0.194-0.017,0.28,0.009,0.428,0.102,0.845,0.332,1.211,0.014,0.022,0.027-0.144,0.028-0.159,0.002-0.068,0.023-0.217-0.016-0.279'/%3E %3Cpath d='m650.81,353.16c0.092-0.204,0.12-0.427,0.21-0.631,0.034-0.076,0.02-0.199,0.018-0.28-0.001-0.017-0.02-0.179-0.028-0.158-0.091,0.203-0.12,0.427-0.21,0.631-0.035,0.076-0.019,0.199-0.017,0.279,0,0.017,0.018,0.179,0.027,0.159'/%3E %3Cpath d='m655.32,351.38c0.235,0.488,0.178,0.961,0.099,1.478-0.015,0.103-0.013,0.208-0.008,0.312,0.001,0.014,0.018,0.169,0.032,0.082,0.115-0.763,0.234-1.59-0.112-2.311,0.029,0.059-0.067,0.323-0.011,0.439'/%3E %3Cpath d='m652.07,353.49c0.35-0.25,0.53-0.656,0.638-1.061,0.023-0.088,0.019-0.188,0.016-0.279,0-0.022-0.024-0.175-0.028-0.159-0.104,0.398-0.279,0.798-0.625,1.044-0.039,0.028-0.022,0.188-0.022,0.228-0.002,0.013,0.018,0.229,0.021,0.227'/%3E %3Cpath d='m654.5,353.77c0.235-1.36,0.659-2.978-0.215-4.203,0.027,0.04-0.081,0.342-0.014,0.439,0.733,1.024,0.404,2.224,0.205,3.372-0.015,0.089,0.018,0.431,0.024,0.392'/%3E %3Cpath d='m649.98,353c0.107-0.904,0.297-1.793,0.517-2.677,0.031-0.129-0.031-0.358-0.013-0.438-0.228,0.922-0.424,1.849-0.536,2.794-0.007,0.058,0.011,0.499,0.032,0.321'/%3E %3Cpath d='m645.57,352.94v-2.104c0-0.258-0.046-0.258-0.046,0v2.104c0,0.258,0.046,0.258,0.046,0'/%3E %3Cpath d='m643.34,352.96c0.152-0.174,0.127-0.431,0.127-0.647,0-0.017,0.004-0.229-0.022-0.229-0.025,0-0.022,0.212-0.022,0.229,0,0.084-0.027,0.13-0.082,0.192-0.039,0.045-0.023,0.174-0.023,0.229-0.001,0.02,0.028,0.22,0.022,0.226'/%3E %3Cpath d='m654.2,352.84c0-0.734-0.006-1.468-0.116-2.195-0.015-0.088-0.031,0.068-0.032,0.082-0.006,0.103-0.007,0.209,0.008,0.311,0.092,0.598,0.094,1.199,0.094,1.803-0.001,0.257,0.046,0.257,0.046-0.001'/%3E %3Cpath d='m656.6,352.95c0.104-0.239,0.121-0.487,0.122-0.745,0-0.016,0.003-0.228-0.023-0.228s-0.022,0.212-0.022,0.228c0,0.106-0.047,0.21-0.088,0.306-0.034,0.077-0.019,0.2-0.017,0.28,0.001,0.017,0.018,0.178,0.028,0.159'/%3E %3Cpath d='m645.88,352.99c-0.088-0.857-0.1-1.715-0.1-2.575,0-0.258-0.045-0.258-0.045,0,0.001,0.968,0.012,1.934,0.112,2.896,0.019,0.177,0.039-0.263,0.033-0.321'/%3E %3Cpath d='m647.25,353.48c0.098-1.472,0.113-2.947,0.21-4.419,0.005-0.074-0.021-0.51-0.039-0.229-0.098,1.471-0.113,2.946-0.21,4.418-0.005,0.075,0.019,0.51,0.039,0.23'/%3E %3Cpath d='m649.24,352.95c0.24-0.781,0.24-1.657,0-2.438,0.021,0.074-0.051,0.313-0.013,0.439,0.163,0.531,0.163,1.029,0,1.56-0.038,0.126,0.034,0.364,0.013,0.439'/%3E %3Cpath d='m651.13,353.37c0.221-0.69,0.324-1.39,0.332-2.113,0.003-0.259-0.042-0.258-0.045,0-0.007,0.573-0.125,1.131-0.299,1.674-0.04,0.125,0.036,0.365,0.012,0.439'/%3E %3Cpath d='m653.22,351.58c0.176,0.555,0.563,1.238,0.516,1.829-0.005,0.06,0.019,0.5,0.032,0.322,0.075-0.934-0.258-1.714-0.536-2.59,0.023,0.074-0.052,0.313-0.012,0.439'/%3E %3Cpath d='m643.68,352.73v-0.421c0-0.015,0.003-0.227-0.022-0.227-0.026,0-0.023,0.212-0.023,0.227v0.421c0,0.017-0.003,0.228,0.023,0.228,0.025-0.001,0.022-0.211,0.022-0.228'/%3E %3Cpath d='m657.22,352.61c-0.1-0.112-0.182-0.26-0.191-0.413-0.001-0.014-0.016-0.169-0.03-0.082-0.018,0.101-0.016,0.209-0.009,0.313,0.015,0.237,0.067,0.453,0.23,0.638-0.006-0.007,0.023-0.207,0.023-0.229,0.001-0.052,0.016-0.183-0.023-0.227'/%3E %3Cpath d='m652.29,353.24c0.225-1.177,0.318-2.364,0.327-3.563,0.002-0.258-0.044-0.258-0.047,0-0.006,1.066-0.103,2.122-0.304,3.171-0.017,0.089,0.016,0.432,0.024,0.392'/%3E %3Cpath d='m647.87,368.42c0.116-0.47,0.217-0.935,0.226-1.421,0.002-0.086,0.014-0.197-0.016-0.28-0.006-0.018-0.028,0.141-0.028,0.159-0.007,0.375-0.104,0.742-0.194,1.104-0.021,0.09-0.019,0.188-0.016,0.279-0.001,0.023,0.023,0.173,0.028,0.159'/%3E %3Cpath d='m651.23,368.11c0.554-0.603,0.549-1.457,0.55-2.227,0-0.259-0.045-0.259-0.047,0,0,0.64-0.05,1.279-0.503,1.771-0.088,0.096,0.057,0.394,0,0.456'/%3E %3Cpath d='m659.42,376.78c0.03,0.386,0.066,0.771,0.105,1.156,0.008,0.077,0.024,0.077,0.033,0,0.01-0.104,0.01-0.215,0-0.32-0.04-0.386-0.075-0.771-0.106-1.157-0.006-0.078-0.024-0.076-0.032,0-0.01,0.106-0.008,0.214,0,0.321'/%3E %3Cpath d='m645.52,378.51v0.526c0,0.016-0.004,0.229,0.022,0.229s0.023-0.213,0.023-0.229v-0.526c0-0.016,0.003-0.227-0.023-0.227s-0.022,0.212-0.022,0.227'/%3E %3Cpath d='m644.68,377.25v2.209c0,0.258,0.046,0.258,0.046,0v-2.209c0-0.259-0.046-0.259-0.046,0'/%3E %3Cpath d='m636.08,370c0.431-0.777,0.633-1.587,0.646-2.473,0.002-0.146-0.039-0.44-0.044-0.121-0.012,0.776-0.243,1.481-0.615,2.155-0.06,0.109,0.042,0.387,0.013,0.439'/%3E %3Cpath d='m636.39,372.53c0.627-0.324,0.954-0.811,1.063-1.504,0.015-0.102,0.014-0.208,0.008-0.311-0.001-0.015-0.018-0.169-0.03-0.082-0.105,0.669-0.441,1.132-1.041,1.441-0.087,0.045,0.031,0.439,0,0.456'/%3E %3Cpath d='m643.88,379.5c-0.01-0.485-0.109-0.95-0.227-1.421-0.004-0.014-0.028,0.138-0.028,0.159-0.003,0.091-0.006,0.19,0.016,0.28,0.091,0.361,0.188,0.728,0.195,1.103,0,0.02,0.021,0.178,0.027,0.159,0.031-0.083,0.019-0.194,0.017-0.28'/%3E %3Cpath d='m636.07,370.42c0.128,0.41,0.089,0.831,0.089,1.253,0,0.018-0.003,0.229,0.022,0.229,0.026,0,0.022-0.211,0.022-0.229,0.001-0.567,0.049-1.141-0.122-1.691,0.024,0.072-0.05,0.311-0.011,0.438'/%3E %3Cpath d='m634.93,371.76c0.108-0.535,0.213-1.061,0.22-1.608,0.002-0.086,0.016-0.197-0.016-0.28-0.006-0.018-0.027,0.14-0.027,0.159-0.006,0.454-0.109,0.894-0.199,1.337-0.021,0.099-0.015,0.211-0.009,0.311,0.001,0.015,0.015,0.167,0.031,0.081'/%3E %3Cpath d='m629.95,365.46c0.006,1.139,0.151,2.316-0.403,3.356-0.061,0.111,0.041,0.385,0.012,0.439,0.626-1.173,0.443-2.518,0.438-3.796-0.002-0.257-0.048-0.257-0.047,0.001'/%3E %3Cpath d='m630.95,371.67c0-0.25,0.015-0.487,0.088-0.729,0.027-0.086,0.018-0.19,0.017-0.278-0.001-0.021-0.022-0.177-0.027-0.159-0.116,0.379-0.122,0.772-0.123,1.166,0,0.016-0.003,0.227,0.022,0.227,0.026,0,0.023-0.211,0.023-0.227'/%3E %3Cpath d='m637.75,368.15c0.076,0.962-0.589,2.023-1.247,2.663-0.09,0.087,0.055,0.402,0,0.455,0.939-0.913,1.383-2.146,1.278-3.439-0.014-0.178-0.037,0.262-0.031,0.321'/%3E %3Cpath d='m631.75,366.84c-0.102,0.775-0.334,1.513-0.327,2.302,0.003,0.258,0.048,0.258,0.046,0-0.006-0.646,0.221-1.273,0.304-1.908,0.014-0.104,0.014-0.208,0.008-0.312-0.001-0.013-0.02-0.17-0.031-0.082'/%3E %3Cpath d='m633.66,371.69c0.637-0.672,0.939-1.547,1.064-2.451,0.014-0.102,0.014-0.208,0.008-0.311-0.001-0.014-0.019-0.17-0.031-0.082-0.122,0.883-0.42,1.733-1.041,2.389-0.088,0.094,0.056,0.396,0,0.455'/%3E %3Cpath d='m613.23,359.74c0.006,0.283-0.197,0.586-0.398,0.765-0.04,0.035-0.022,0.182-0.022,0.228,0,0.016,0.023,0.226,0.022,0.228,0.394-0.348,0.452-0.844,0.442-1.341,0-0.019-0.022-0.177-0.028-0.158-0.031,0.082-0.018,0.192-0.016,0.278'/%3E %3Cpath d='m609.38,361.46v-1.263c0-0.016,0.003-0.228-0.023-0.228-0.025,0-0.022,0.212-0.022,0.228v1.263c0,0.016-0.003,0.227,0.022,0.227,0.026,0,0.023-0.211,0.023-0.227'/%3E %3Cpath d='m607.15,361.68c0.27-0.426,0.35-1.003,0.21-1.49-0.005-0.016-0.028,0.138-0.028,0.159-0.002,0.089-0.009,0.192,0.016,0.279,0.055,0.187-0.109,0.455-0.21,0.613-0.04,0.063-0.018,0.211-0.016,0.279,0,0.018,0.013,0.183,0.028,0.16'/%3E %3Cpath d='m603.26,362.4c0.104-0.445,0.116-0.9,0.116-1.354,0-0.016,0.004-0.228-0.022-0.228-0.027,0-0.022,0.212-0.022,0.228,0,0.325-0.021,0.643-0.095,0.961-0.022,0.097-0.014,0.212-0.008,0.311,0.001,0.017,0.011,0.167,0.031,0.082'/%3E %3Cpath d='m599.04,362.96c0.296-0.303,0.433-0.585,0.442-1.009,0.002-0.085,0.015-0.197-0.016-0.28-0.007-0.018-0.028,0.142-0.028,0.159-0.007,0.269-0.225,0.497-0.398,0.675-0.04,0.041-0.023,0.179-0.023,0.229,0,0.018,0.027,0.222,0.023,0.226'/%3E %3Cpath d='m599.88,359.9c-0.031,0.171-0.153,0.203-0.305,0.181-0.011-0.003-0.055,0.445,0,0.454,0.197,0.03,0.293-0.054,0.327-0.241,0.02-0.101,0.015-0.21,0.008-0.312,0-0.015-0.014-0.169-0.03-0.082'/%3E %3Cpath d='m602.31,362.84c0.317-0.431,0.599-0.889,0.842-1.367,0.036-0.072,0.018-0.203,0.015-0.28,0-0.017-0.017-0.18-0.027-0.158-0.242,0.479-0.523,0.937-0.842,1.367-0.071,0.095,0.039,0.4,0.012,0.438'/%3E %3Cpath d='m616.28,358.4c-0.025,0.574-0.134,1.118-0.506,1.571-0.085,0.102,0.058,0.385,0,0.455,0.424-0.516,0.517-1.15,0.545-1.798,0.004-0.073-0.026-0.508-0.039-0.228'/%3E %3Cpath d='m619.01,357.69c0.019,0.391,0.072,0.808-0.19,1.131-0.038,0.048-0.023,0.172-0.023,0.228,0,0.022,0.031,0.219,0.023,0.227,0.386-0.474,0.257-1.251,0.229-1.814-0.011-0.282-0.042,0.155-0.039,0.228'/%3E %3Cpath d='m620.93,359.05c0.12-0.242,0.208-0.466,0.224-0.735,0.007-0.103,0.01-0.211-0.008-0.312-0.015-0.088-0.03,0.067-0.031,0.082-0.012,0.184-0.116,0.364-0.196,0.526-0.036,0.072-0.019,0.203-0.017,0.279,0,0.018,0.018,0.182,0.028,0.16'/%3E %3Cpath d='m623.85,358.14c-0.006-0.058-0.033-0.079-0.083-0.062-0.04,0.001-0.029,0.456,0,0.455,0.148-0.005,0.123-0.157,0.127-0.272,0.003-0.085,0.014-0.198-0.016-0.28-0.006-0.019-0.028,0.141-0.028,0.159'/%3E %3Cpath d='m599.27,348.83c0.117-0.512,0.116-1.042,0.116-1.564,0-0.016,0.004-0.228-0.022-0.228s-0.022,0.212-0.022,0.228c0,0.395-0.005,0.786-0.094,1.172-0.023,0.098-0.015,0.211-0.009,0.311,0.001,0.015,0.012,0.166,0.031,0.081'/%3E %3Cpath d='m605.91,348c0.008-0.737,0.098-1.471,0.104-2.209,0.003-0.259-0.043-0.258-0.045,0-0.008,0.737-0.098,1.472-0.105,2.209-0.002,0.258,0.043,0.257,0.046,0'/%3E %3Cpath d='m602.61,345.25c0.088,0.492,0.357,1.283-0.199,1.575-0.086,0.045,0.033,0.438,0,0.455,0.723-0.38,0.331-1.817,0.222-2.423-0.015-0.088-0.029,0.066-0.03,0.081-0.007,0.102-0.011,0.21,0.007,0.312'/%3E %3Cpath d='m604.21,346.62c-0.073-0.241-0.088-0.479-0.088-0.729,0-0.015,0.002-0.227-0.023-0.227-0.026,0-0.022,0.212-0.022,0.227,0,0.395,0.007,0.787,0.122,1.167,0.005,0.016,0.026-0.139,0.027-0.159,0.001-0.089,0.009-0.194-0.016-0.279'/%3E %3Cpath d='m601.45,344.94c-0.031,0.699,0.021,1.464-0.303,2.105-0.057,0.112,0.041,0.382,0.013,0.438,0.352-0.697,0.295-1.555,0.328-2.313,0.005-0.075-0.026-0.51-0.038-0.23'/%3E %3Cpath d='m604.83,347.07c0.225-0.249,0.232-0.539,0.232-0.859,0-0.015,0.005-0.227-0.022-0.227-0.026,0-0.022,0.212-0.022,0.227-0.001,0.164-0.084,0.289-0.188,0.404-0.039,0.044-0.023,0.175-0.023,0.229-0.001,0.019,0.027,0.22,0.023,0.226'/%3E %3Cpath d='m599.91,348.58c0.008-0.27,0.11-0.535,0.195-0.788,0.026-0.084,0.018-0.193,0.015-0.28,0-0.019-0.021-0.176-0.028-0.159-0.12,0.366-0.215,0.72-0.226,1.106-0.003,0.085-0.014,0.198,0.016,0.28,0.007,0.018,0.028-0.14,0.028-0.159'/%3E %3Cpath d='m601.68,347.27c0.121-0.242,0.208-0.466,0.225-0.735,0.006-0.103,0.009-0.21-0.009-0.312-0.015-0.087-0.029,0.067-0.03,0.081-0.012,0.186-0.117,0.365-0.196,0.527-0.037,0.073-0.02,0.203-0.018,0.279,0,0.017,0.018,0.181,0.028,0.16'/%3E %3Cpath d='m600.22,347.74c0.008-0.282,0.095-0.558,0.105-0.842,0.004-0.085,0.014-0.198-0.017-0.279-0.006-0.019-0.026,0.14-0.027,0.158-0.013,0.282-0.098,0.557-0.105,0.842-0.002,0.085-0.014,0.198,0.017,0.28,0.007,0.017,0.027-0.141,0.027-0.159'/%3E %3Cpath d='m603.36,346.82c-0.048-0.057-0.075-0.121-0.083-0.193,0-0.016,0.004-0.228-0.022-0.228-0.025,0-0.022,0.212-0.022,0.228,0.001,0.215-0.012,0.47,0.128,0.648-0.008-0.011,0.023-0.203,0.023-0.229-0.001-0.055,0.015-0.177-0.024-0.226'/%3E %3Cpath d='m604.94,347.91c0.222-0.239,0.324-0.545,0.427-0.85,0.028-0.084,0.018-0.193,0.016-0.28-0.001-0.02-0.021-0.176-0.027-0.159-0.101,0.298-0.198,0.6-0.415,0.834-0.039,0.043-0.023,0.176-0.023,0.228-0.001,0.02,0.027,0.222,0.022,0.227'/%3E %3Cpath d='m536.58,348.21v-3.998c0-0.258-0.046-0.258-0.046,0v3.998c0,0.258,0.046,0.258,0.046,0'/%3E %3Cpath d='m532.14,348.73c-1.252-1.815-2.043-3.928-1.473-6.188,0.032-0.13-0.032-0.36-0.013-0.439-0.629,2.492,0.028,4.97,1.474,7.067-0.029-0.042,0.08-0.34,0.012-0.44'/%3E %3Cpath d='m535.3,348.41c-0.222-0.392-0.37-0.8-0.21-1.244,0.044-0.124-0.038-0.37-0.012-0.438-0.246,0.685-0.146,1.496,0.21,2.122-0.029-0.054,0.073-0.332,0.012-0.44'/%3E %3Cpath d='m537.08,348.85c0.107-0.455,0.121-0.91,0.121-1.377,0-0.015,0.004-0.227-0.022-0.227s-0.022,0.212-0.022,0.227c0,0.319-0.015,0.627-0.089,0.938-0.021,0.09-0.018,0.188-0.016,0.28,0,0.023,0.025,0.174,0.028,0.159'/%3E %3Cpath d='m533.72,348.52c-0.512-0.853-0.813-1.796-0.937-2.782-0.022-0.178-0.04,0.263-0.032,0.321,0.127,1.025,0.423,2.01,0.957,2.899-0.029-0.048,0.076-0.333,0.012-0.438'/%3E %3Cpath d='m536.04,348.54c-0.101-0.5-0.199-1-0.321-1.495,0.019,0.078-0.044,0.309-0.012,0.438,0.118,0.48,0.213,0.965,0.31,1.449,0.019,0.087,0.03-0.066,0.031-0.081,0.005-0.101,0.011-0.212-0.008-0.311'/%3E %3Cpath d='m534.14,348.3c-0.391-1.039-0.629-2.403,0.099-3.341,0.083-0.105-0.057-0.381,0-0.455-0.854,1.103-0.563,3.029-0.11,4.235-0.027-0.068,0.057-0.317,0.011-0.439'/%3E %3Cpath d='m531.93,347.46c-0.483-1.135-0.227-2.312,0.941-2.814,0.081-0.034-0.023-0.444,0-0.454-1.447,0.623-1.497,2.431-0.953,3.708-0.026-0.065,0.064-0.32,0.012-0.44'/%3E %3Cpath d='m537.72,348.1c-0.042-0.095-0.088-0.2-0.089-0.307,0-0.016,0.004-0.228-0.022-0.228-0.027,0-0.022,0.212-0.022,0.228,0.001,0.258,0.017,0.507,0.122,0.745,0.009,0.021,0.027-0.142,0.027-0.158,0.002-0.081,0.018-0.203-0.016-0.28'/%3E %3Cpath d='m534.66,345.56c-0.354,0.426-0.395,1.069-0.531,1.586-0.034,0.129,0.032,0.362,0.012,0.439,0.135-0.512,0.17-1.149,0.52-1.57,0.084-0.101-0.058-0.387-0.001-0.455'/%3E %3Cpath d='m532.77,348.41c-0.176-0.271-0.295-0.564-0.3-0.893,0-0.02-0.021-0.178-0.027-0.159-0.03,0.083-0.018,0.194-0.017,0.279,0.007,0.441,0.09,0.837,0.332,1.212,0.014,0.021,0.028-0.145,0.028-0.159,0.003-0.069,0.024-0.218-0.016-0.28'/%3E %3Cpath d='m534.88,348.3c-0.093-0.192-0.188-0.415-0.197-0.632-0.001-0.014-0.016-0.168-0.03-0.081-0.018,0.102-0.013,0.208-0.009,0.312,0.013,0.295,0.098,0.574,0.225,0.841,0.01,0.02,0.027-0.144,0.027-0.159,0.002-0.08,0.02-0.207-0.016-0.281'/%3E %3Cpath d='m537.48,348.1v0.842c0,0.016-0.003,0.228,0.022,0.228,0.026,0,0.023-0.212,0.023-0.228v-0.842c0-0.016,0.003-0.227-0.023-0.227-0.025,0-0.022,0.211-0.022,0.227'/%3E %3Cpath d='m531,348.74c-0.007-1.088-0.098-2.174-0.104-3.262-0.002-0.258-0.048-0.258-0.046,0,0.008,1.089,0.099,2.174,0.104,3.262,0.002,0.259,0.046,0.26,0.046,0'/%3E %3C/g%3E %3Cpath fill='%23999b9e' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)' d='m692.79,473.45c-0.42874,0.15576-0.80475,0.41459-1.1819,0.66991-0.0447,0.0305-0.0252,0.22134-0.0252,0.26701,0,0.0152,0.0219,0.26821,0.0252,0.26587,0.37716-0.25532,0.75317-0.51297,1.1819-0.66875,0.0872-0.034-0.0172-0.52936,0-0.53404'/%3E %3Cpath fill='%23999b9e' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)' d='m686.56,470.11c-1.0764,0.63126-2.021,1.478-2.7788,2.484-0.094,0.12414,0.0653,0.44621,0,0.53288,0.75774-1.006,1.7012-1.854,2.7788-2.484,0.1009-0.0597-0.0424-0.50945,0-0.53287'/%3E %3Cg id='sun_and_signs' fill='none' stroke='%23000' stroke-width='0.917'%3E %3Cpath fill='%23949699' stroke-width='0.23' d='m660.05,288.89c0.776,1.404,4.048,12.048,4.048,12.048-10.84-11.929-36.219-20.299-65.798-20.299-29.173,0-54.438,8.159-65.532,19.829-0.179,0.188,1.69-5.334,3.905-10.62,2.16-5.158,4.666-10.078,4.831-10.179,13.047-7.956,33.633-13.089,56.796-13.089,23.329,0,44.045,5.206,57.077,13.258,0.001,0,4.027,6.371,4.673,9.052z'/%3E %3Cg fill='%23fd0' stroke-width='0.458'%3E %3Cpath d='m597.16,284.19s1.027,5.905,1.969,7.873c0,0,2.226-6.29,2.226-7.787'/%3E %3Cpath d='m593.36,282.54s-1.476,5.808-1.423,7.99c0,0,4.603-4.83,5.215-6.197'/%3E %3Cpath d='m590.43,279.25s-3.847,4.597-4.741,6.585c0,0,6.241-2.36,7.384-3.327'/%3E %3Cpath d='m589.27,275.66s-5.286,2.828-6.858,4.338c0,0,6.67,0.143,8.091-0.328'/%3E %3Cpath d='m589.52,271.93s-5.955,0.677-7.975,1.499c0,0,6.146,2.596,7.641,2.683'/%3E %3Cpath d='m591.04,268.71s-5.811-1.472-7.991-1.418c0,0,4.832,4.601,6.199,5.21'/%3E %3Cpath d='m593.73,266.13s-4.855-3.513-6.902-4.268c0,0,2.792,6.06,3.837,7.131'/%3E %3Cpath d='m597.64,264.65s-2.98-5.199-4.537-6.73c0,0,0.052,6.673,0.564,8.079'/%3E %3Cpath d='m601.08,264.74s-1.024-5.905-1.963-7.876c0,0-2.232,6.287-2.23,7.785'/%3E %3Cpath d='m604.97,266.45s1.538-5.791,1.509-7.975c0,0-4.656,4.778-5.281,6.139'/%3E %3Cpath d='m607.56,269.24s3.603-4.789,4.398-6.822c0,0-6.113,2.675-7.203,3.701'/%3E %3Cpath d='m608.9,272.79s5.138-3.086,6.639-4.673c0,0-6.671,0.186-8.065,0.727'/%3E %3Cpath d='m608.9,276.11s5.869-1.217,7.811-2.219c0,0-6.359-2.028-7.854-1.977'/%3E %3Cpath d='m607.74,279.37s5.931,0.872,8.098,0.596c0,0-5.276-4.087-6.697-4.553'/%3E %3Cpath d='m605.43,282.12s5.23,2.927,7.354,3.442c0,0-3.475-5.699-4.638-6.64'/%3E %3Cpath d='m601.44,284.11s3.425,4.921,5.107,6.313c0,0-0.631-6.644-1.265-8.001'/%3E %3Cellipse cx='599.04' cy='274.46' rx='10.521' ry='10.096'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23000' stroke='none' d='m595.62,271.52c0,0.489-0.421,0.885-0.941,0.885s-0.942-0.396-0.942-0.885c0-0.488,0.423-0.883,0.942-0.883,0.52,0.001,0.941,0.396,0.941,0.883'/%3E %3Cpath stroke-width='0.684' d='m592.77,271.5c1.021-1.516,2.713-1.452,3.88,0'/%3E %3Cpath fill='%23000' stroke='none' d='m604.29,271.64c0,0.489-0.421,0.884-0.941,0.884s-0.941-0.395-0.941-0.884c0-0.488,0.421-0.884,0.941-0.884s0.941,0.396,0.941,0.884'/%3E %3Cpath stroke-width='0.684' d='m601.44,271.61c1.021-1.516,2.714-1.452,3.88,0'/%3E %3Cpath stroke-width='0.684' d='m597.38,275.32c0.611,0.049,1.043,0.331,1.672,0.362,0.649,0.032,1.03-0.264,1.58-0.419'/%3E %3Cellipse fill='none' stroke-width='0.684' cx='599' cy='278.37' rx='2.339' ry='0.325'/%3E %3Cpath stroke-width='0.814' d='m598.04,280.83c0.6-0.003,1.188,0.12,1.736-0.064'/%3E %3C/g%3E %3Cpath d='m557.53,278.96-0.949-2.001s-2.948,0.21-4.318,2.739c0,0-1.894-2.213-5.16-0.949l-0.106,2.95s2.215-3.054,4.529-0.948c0,0-1.053,4.423,1.581,4.213,2.632-0.211,0.841-3.897,0.316-4.108l-0.527-0.211c-0.001,0,1.474-2.527,4.634-1.685zm-4.333,3.569c0.155,0.621,0.077,1.176-0.177,1.24-0.253,0.064-0.585-0.387-0.743-1.008-0.157-0.62-0.078-1.175,0.177-1.239s0.585,0.388,0.743,1.007z'/%3E %3Cpath d='m575,271.52c-0.214-0.128-0.727-0.47-1.476-0.342,0,0,0.685,0.642,0.578,0.899,0,0-0.107,0.556-0.707,0.492,0,0-2.332-0.257-4.236,1.005,0,0-1.326,0.193-1.433-0.085,0,0-0.224-0.446-0.028-0.628,0.014-0.014,0.031-0.026,0.049-0.035,0.279-0.151-1.412,0.235-1.026,1.048,0.385,0.813,1.283,1.112,2.054,1.048,0.048-0.004,0.075-0.007,0.112-0.009,0-0.002-0.006-0.012-0.006-0.012s0.568-0.036,0.006,0.012c0.058,0.127,2.175,4.773,3.547,4.31,1.39-0.471,1.562-4.857,1.412-5.328-0.032-0.1-0.05-0.151-0.063-0.193l-0.002,0.001s-0.048-0.159,0.002-0.001c0.024-0.009,3.013-1.104,1.217-2.182zm-2.867,6.055c-1.006,0.193-2.219-2.943-2.098-3.038,1.316-1.028,2.29-0.886,2.565-0.815-0.162-0.206,0.088,0.023,0.088,0.023s-0.036-0.011-0.088-0.023c0.003,0.001,0.001,0,0.003,0.002,0.172,0.214,0.535,3.659-0.47,3.851z'/%3E %3Cpath stroke-width='1.6052' d='m626.1,274.92c0.009-0.375-0.016-0.752-0.11-1.104-0.079-0.287-0.258-0.56-0.441-0.792-0.218-0.277-0.586-0.664-0.891-0.85-0.56-0.343-1.119-0.087-1.085,0.573,0.032,0.665,0.6,1.2,1.131,1.52,0.437,0.263,0.909,0.471,1.396,0.653,1.6659,0.59675,3.3115,0.94104,4.262,1.553,0.398,0.244,0.758,0.512,1.207,0.687,0.686,0.268,1.454,0.282,2.094-0.09,0.46-0.268,1.148-0.974,0.623-1.493-0.601-0.594-1.639-0.389-2.352-0.118-0.563,0.215-1.17,0.548-1.649,0.904,0.27392,0.57761-0.096,1.1805-0.222,1.828-0.16,0.508-0.324,1.013-0.314,1.552,0.013,0.721,1.076,2.254,1.527,0.978,0.261-0.741,0.133-1.851-0.629-2.254-0.188-0.1-0.384-0.191-0.584-0.276-1.4613-0.59415-2.9766-0.85949-4.267-1.439-0.494-0.18-1.022-0.346-1.546-0.305-0.445,0.035-0.891,0.205-1.108,0.621-0.166,0.323-0.353,0.73-0.144,1.069,0.429,0.698,1.602,0.063,2.06-0.276,0.354-0.263,0.584-0.671,0.738-1.109,0.19585-0.4904,0.29381-1.2849,0.304-1.832z'/%3E %3Cpath d='m645.98,282.55s-1.348-0.707-2.247,0.727c0,0-3.357-0.364-1.219-5.498,0.06-0.144-2.161,0.919-1.69,4.193,0,0,0.429,2.76,3.595,4.022,0,0,2.652,0.578,2.546-1.99-0.001,0-0.129-1.239-0.985-1.454zm-0.77,2.246c-0.32,0-0.578-0.268-0.578-0.599s0.258-0.599,0.578-0.599c0.319,0,0.577,0.268,0.577,0.599,0.001,0.331-0.257,0.599-0.577,0.599z'/%3E %3Cpath d='m644.19,281.61s1.46,0.429,2.061-1.151c0,0,3.366-0.298,2.267,5.156-0.03,0.153,1.941-1.324,0.842-4.443,0,0-0.958-2.624-4.309-3.244,0,0-2.715-0.051-2.109,2.447-0.001,0,0.365,1.193,1.248,1.235zm0.315-2.353c0.314-0.063,0.62,0.15,0.685,0.475,0.064,0.325-0.137,0.638-0.449,0.7-0.314,0.063-0.619-0.151-0.685-0.476-0.062-0.324,0.136-0.636,0.449-0.699z'/%3E %3Cpath fill='%23fd0' stroke='none' d='m557.53,278.96-0.949-2.001s-2.948,0.21-4.318,2.739c0,0-1.894-2.213-5.16-0.949l-0.106,2.95s2.215-3.054,4.529-0.948c0,0-1.053,4.423,1.581,4.213,2.632-0.211,0.841-3.897,0.316-4.108l-0.527-0.211c-0.001,0,1.474-2.527,4.634-1.685m-4.333,3.569c0.155,0.621,0.078,1.176-0.177,1.24-0.253,0.064-0.585-0.387-0.743-1.008-0.157-0.62-0.078-1.175,0.177-1.239s0.585,0.388,0.743,1.007'/%3E %3Cpath fill='%23fd0' stroke='none' d='m575,271.52c-0.214-0.128-0.727-0.47-1.476-0.342,0,0,0.685,0.642,0.578,0.899,0,0-0.107,0.556-0.707,0.492,0,0-2.332-0.257-4.236,1.005,0,0-1.326,0.193-1.433-0.085,0,0-0.225-0.446-0.028-0.628,0.014-0.014,0.031-0.026,0.049-0.035,0.279-0.151-1.412,0.235-1.026,1.048,0.385,0.813,1.283,1.113,2.054,1.048,0.048-0.004,0.075-0.007,0.112-0.009,0-0.002-0.006-0.012-0.006-0.012s0.568-0.036,0.006,0.012c0.058,0.127,2.175,4.773,3.547,4.31,1.39-0.471,1.562-4.857,1.412-5.328-0.032-0.1-0.05-0.151-0.063-0.193l-0.002,0.001s-0.048-0.159,0.002-0.001c0.024-0.009,3.013-1.104,1.217-2.182m-2.867,6.055c-1.006,0.193-2.219-2.943-2.098-3.038,1.316-1.028,2.29-0.886,2.565-0.815-0.162-0.206,0.088,0.023,0.088,0.023s-0.036-0.011-0.088-0.023c0.003,0.001,0.001,0,0.003,0.002,0.172,0.214,0.535,3.659-0.47,3.851'/%3E %3Cpath fill='none' stroke='%23fd0' d='m626.1,274.92c0.009-0.375-0.016-0.752-0.11-1.104-0.079-0.287-0.258-0.56-0.441-0.792-0.218-0.277-0.586-0.664-0.891-0.85-0.56-0.343-1.119-0.087-1.085,0.573,0.032,0.665,0.6,1.2,1.131,1.52,0.437,0.263,0.909,0.471,1.396,0.653,1.6659,0.59675,3.3115,0.94104,4.262,1.553,0.398,0.244,0.758,0.512,1.207,0.687,0.686,0.268,1.454,0.282,2.094-0.09,0.46-0.268,1.148-0.974,0.623-1.493-0.601-0.594-1.639-0.389-2.352-0.118-0.563,0.215-1.17,0.548-1.649,0.904,0.27392,0.57761-0.096,1.1805-0.222,1.828-0.16,0.508-0.324,1.013-0.314,1.552,0.013,0.721,1.076,2.254,1.527,0.978,0.261-0.741,0.133-1.851-0.629-2.254-0.188-0.1-0.384-0.191-0.584-0.276-1.4613-0.59415-2.9766-0.85949-4.267-1.439-0.494-0.18-1.022-0.346-1.546-0.305-0.445,0.035-0.891,0.205-1.108,0.621-0.166,0.323-0.353,0.73-0.144,1.069,0.429,0.698,1.602,0.063,2.06-0.276,0.354-0.263,0.584-0.671,0.738-1.109,0.19585-0.4904,0.29381-1.2849,0.304-1.832z'/%3E %3Cpath fill='%23fd0' stroke='none' d='m645.98,282.55s-1.348-0.707-2.247,0.727c0,0-3.357-0.364-1.219-5.498,0.06-0.144-2.161,0.919-1.69,4.193,0,0,0.429,2.76,3.595,4.022,0,0,2.652,0.578,2.546-1.99-0.001,0-0.129-1.239-0.985-1.454m-0.77,2.246c-0.32,0-0.578-0.268-0.578-0.599s0.258-0.599,0.578-0.599c0.319,0,0.577,0.268,0.577,0.599,0.001,0.331-0.257,0.599-0.577,0.599'/%3E %3Cpath fill='%23fd0' stroke='none' d='m644.19,281.61s1.46,0.429,2.061-1.151c0,0,3.365-0.298,2.267,5.156-0.03,0.153,1.941-1.324,0.842-4.443,0,0-0.958-2.624-4.309-3.244,0,0-2.715-0.051-2.109,2.447-0.001,0,0.365,1.193,1.248,1.235m0.315-2.353c0.313-0.063,0.62,0.15,0.684,0.475,0.065,0.325-0.136,0.638-0.448,0.7-0.314,0.063-0.619-0.151-0.685-0.476-0.062-0.324,0.136-0.636,0.449-0.699'/%3E %3C/g%3E %3Cg id='boat' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'%3E %3Cpath fill='%23fd0' d='m716.54,549.26,0.0872-3.6435s16.092,0.70739,23.833,0.62191v2.8436s-21.137,0.35486-23.92,0.17802'/%3E %3Cg%3E %3Crect fill='%235c5342' width='6.4529' height='1.6619' x='744.34' y='543.92'/%3E %3Cg fill='%23000'%3E %3Cpath transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' d='M628.76,394.94V397.84H628.46V394.94L625.3,378.79 625.48,378.74 628.65,394.78 631.34,389.42 631.5,389.44'/%3E %3Crect width='0.34506' height='2.3037' x='740.68' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='741.29' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='742.76' y='545.91'/%3E %3Crect width='0.3462' height='2.3037' x='743.59' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='744.84' y='545.91'/%3E %3Crect width='0.3462' height='2.3037' x='746.12' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='746.95' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='747.99' y='545.91'/%3E %3Crect width='0.3462' height='2.3037' x='749.03' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='750.02' y='545.91'/%3E %3Crect width='0.34735' height='2.3037' x='751.42' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='755.06' y='545.68'/%3E %3Crect width='0.34506' height='5.3358' x='756.01' y='542.28'/%3E %3Crect width='0.34506' height='4.9716' x='751.98' y='543.24'/%3E %3Crect width='0.48262' height='0.62189' x='741.99' y='547.59'/%3E %3Cpath d='m752.88,547.84s0.01-0.007,0.029-0.0199c0.2476-0.1745,2.0898-1.4476,2.5942-1.4394,0.5411,0.012,1.1384-0.0352,1.1384-0.0352v0.38766l-1.1728,0.0364-2.0245,1.0564'/%3E %3Cpath d='m754.73,548s0.011-0.007,0.028-0.0199c0.2454-0.17918,2.0681-1.4827,2.5702-1.4804,0.5411,0.003,1.1395-0.0539,1.1395-0.0539l0.01,0.38765-1.1705,0.0551-2.0084,1.0904'/%3E %3Crect width='1.6026' height='0.29162' x='750.75' y='543.04'/%3E %3Cpath d='m752.37,541.74c-0.2086,0.0281-0.36,0.61955-0.3416,1.3211,0.019,0.70386,0.204,1.2485,0.4115,1.2204,0.2075-0.0258,0.3588-0.6172,0.3405-1.3211-0.021-0.70153-0.204-1.2473-0.4104-1.2204m0.058,2.1714c-0.1467,0.0187-0.2763-0.36774-0.2912-0.86315-0.014-0.49658,0.094-0.91585,0.2408-0.9346,0.1479-0.0199,0.2785,0.36659,0.2911,0.86316,0.015,0.49657-0.094,0.9135-0.2407,0.93459'/%3E %3Cpath d='M621.84,380.89 613.98,381.22V381.02L622.17,380.73' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='m737.14,522.23c0.0367,0.26703,4.0398,23.159,4.0398,23.159l-3.7417-12.842,0.0367-0.64882,2.8063,9.7839-3.18-17.961,0.039-1.4909z'/%3E %3Cpath d='M615.94,395.68 614.37,383.18 614.24,383.67 615.61,395.51 615.87,395.61' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='m738.15,545.43s-0.0367-5.3124-0.67407-6.7635l-0.0735,0.42045s0.56172,5.809,0.59725,6.2669c0.039,0.45793,0.15019,0.0761,0.15019,0.0761'/%3E %3Cpath d='M614.34,385.72 613.03,395.48 613.26,395.61 614.44,386.02' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='M614.01,380.93 612.32,394.6 612.48,394.83 613.98,381.22' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' d='m614.27,384.45-10.866,7.08-0.13-0.196,10.93-7.08,0,0.13'/%3E %3C/g%3E %3Cpath transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' fill='%23858d8d' d='M620.67,393.36H626.3L626,394.29H620.37z'/%3E %3Cpath fill='%23755338' d='M629.87,395.42 629.89,395.32 631.54,388.46 631.76,388.5 630.1,395.25' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23fd0' d='m761.19,540.61c-0.8231,0.3045-1.8709-1.4522-2.357-2.2931-0.486-0.84208-1.7207-0.53524-1.7207-0.53524l-0.3175,1.0576c0.2453-0.0468,1.2392-0.18739,1.6645,0.5481,0.4861,0.8409,1.5339,2.5988,2.3558,2.292l-0.454,1.334c0,0.00092,0.01,0.004,0.01,0.004l0.822-2.4067z'/%3E %3Cpath fill='%23034ea2' d='m758.46,539.39c-0.4253-0.73432-1.418-0.59495-1.6645-0.5481l-0.1697,0.56332c0.3141-0.0515,1.2129-0.13116,1.6095,0.55748,0.4861,0.8409,1.5339,2.5988,2.357,2.2932l-0.2545,0.74602c0.012,0.007,0.019,0.012,0.024,0.014l0.4539-1.3328c-0.8219,0.30568-1.8697-1.4534-2.3557-2.2932'/%3E %3Cpath fill='%23ed1c24' d='m756.52,539.77c0.021,0,0.044,0,0.068,0.00092,1.3458,0.0364,1.7207,1.0318,1.982,1.6818,0.2408,0.59848,1.5556,1.4206,1.7643,1.5483l0.2556-0.74604c-0.8219,0.30568-1.8697-1.4522-2.3558-2.2931-0.3989-0.68865-1.2965-0.609-1.6095-0.55747l-0.093,0.30802s-0.031,0.0561-0.012,0.0573'/%3E %3Cg fill='%23a37853'%3E %3Cpath d='m614.36,385.5,11.429-6.828v-0.147h-0.245l-11.208,6.534v0.319' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='m614.49,381.15,0.22,14.317-0.441,0.171-0.368-13.852,0.051-11.086,0.122,0.074,0.097,10.254z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='m736.25,545.64c0.003,0.22135,0.15934,0.40054,0.34849,0.3982l19.456-0.2846c0.1891-0.004,0.3404-0.18504,0.3382-0.40873,0-0.22254-0.1594-0.39937-0.3485-0.39703l-19.456,0.28342c-0.1903,0.004-0.34162,0.18622-0.33818,0.40874'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.1333'%3E %3Cpath fill='%23616264' stroke='none' d='m727.71,541.95s0.79673,0.0411,2.4268,0.29865c0,0-1.7906,0.2436-2.7708,0.55513-0.98016,0.31269-2.8648,2.1807-3.2614,2.5332-0.39892,0.35135-0.58349,0.5282-0.58349,0.5282l-3.0642-0.014s1.4192-1.8294,2.0302-2.2756c0.61101-0.44621,1.8158-1.2602,2.412-1.355,0.59611-0.0949,1.6966-0.3654,2.8097-0.29748'/%3E %3Cpath fill='%23a3a5a8' d='m736.66,546.21c-0.87124-2.3388-3.1456-4.0522-5.9302-3.9527-0.031,0.00092-0.0619,0.004-0.0917,0.005-4.5408,0.18737-4.7643,2.0495-6.4793,3.6118l-0.31754-0.0108c-0.024,0.0386-0.039,0.0632-0.039,0.0632s9.3131,0.28343,12.858,0.28343z'/%3E %3Cg fill='%23797a7d' stroke='none'%3E %3Cpath d='m735.41,545.57c-0.0539,0.0258-0.11687,0.00092-0.141-0.0515-0.024-0.0515-0.0009-0.11712,0.0504-0.14523,0.0516-0.0258,0.11581-0.004,0.14101,0.0515,0.0253,0.0551,0.004,0.12064-0.0504,0.14523'/%3E %3Cpath d='m735.17,545.08c-0.0504,0.0305-0.11809,0.0152-0.15018-0.0328-0.0321-0.048-0.0183-0.11364,0.0309-0.14757,0.0493-0.0317,0.11582-0.0175,0.15018,0.0328,0.0333,0.0504,0.0195,0.11592-0.031,0.14757'/%3E %3Cpath d='m734.87,544.63c-0.0482,0.034-0.11124,0.0247-0.14331-0.0245-0.0333-0.0468-0.0321-0.11005,0.0149-0.14875,0.0436-0.0387,0.11688-0.0352,0.15247,0.014,0.0321,0.0527,0.023,0.12298-0.024,0.15928'/%3E %3Cpath d='m734.52,544.22c-0.0436,0.0411-0.11123,0.0387-0.14788-0.004-0.039-0.0433-0.0379-0.11364,0.003-0.15577,0.0412-0.0421,0.10771-0.0411,0.14903,0.005,0.0412,0.0457,0.039,0.11473-0.004,0.15459'/%3E %3Cpath d='m734.14,543.84c-0.0379,0.0445-0.10666,0.0527-0.15133,0.0164-0.0458-0.0352-0.0528-0.10428-0.0161-0.15108s0.10313-0.0551,0.15132-0.0164c0.0482,0.0387,0.0549,0.10656,0.0161,0.15108'/%3E %3Cpath d='m733.73,543.51c-0.0344,0.0504-0.0951,0.0563-0.14675,0.0293-0.0493-0.0269-0.0665-0.0937-0.0344-0.14405,0.0321-0.0504,0.0997-0.0667,0.15132-0.0352,0.0551,0.0258,0.0619,0.10188,0.0298,0.1499'/%3E %3Cpath d='m733.27,543.23c-0.0286,0.0527-0.0917,0.0726-0.14216,0.0421-0.0481-0.0281-0.0698-0.096-0.0435-0.14992,0.0264-0.0539,0.0894-0.0726,0.14102-0.0421,0.0516,0.0305,0.071,0.0972,0.0447,0.1499'/%3E %3Cpath d='m732.79,543c-0.0241,0.0563-0.0848,0.0832-0.13871,0.0632-0.0549-0.0211-0.0814-0.0832-0.0619-0.14054,0.0207-0.0563,0.0814-0.0832,0.13756-0.062,0.0561,0.0211,0.0837,0.0844,0.0631,0.13938'/%3E %3Cpath d='m732.29,542.8c-0.0149,0.0563-0.0744,0.0925-0.13069,0.0809-0.0561-0.0128-0.0894-0.0691-0.0756-0.12649,0.0137-0.0573,0.0722-0.096,0.13068-0.0832,0.0585,0.014,0.0951,0.0703,0.0756,0.12881'/%3E %3Cpath d='m731.77,542.69c-0.0118,0.0585-0.0642,0.0972-0.11922,0.0855-0.0573-0.0128-0.0951-0.0714-0.0884-0.13,0.008-0.0585,0.0619-0.0972,0.12151-0.0844,0.0585,0.012,0.0986,0.0703,0.086,0.12882'/%3E %3Cpath d='m731.24,542.62c-0.005,0.0609-0.0549,0.10656-0.11347,0.10428-0.0573-0.003-0.10089-0.0539-0.0985-0.11364,0.003-0.0609,0.0516-0.10656,0.11123-0.10428,0.0607,0.004,0.10548,0.0539,0.1009,0.11364'/%3E %3Cpath d='m730.71,542.6c0.0009,0.0609-0.0447,0.10189-0.10208,0.10657-0.0585,0.003-0.10665-0.0387-0.11006-0.0996-0.003-0.0585,0.0436-0.11472,0.10208-0.11712,0.0595-0.006,0.10888,0.0515,0.11006,0.11004'/%3E %3Cpath d='m730.18,542.64c0.005,0.0597-0.039,0.11244-0.0974,0.11832-0.0585,0.005-0.11006-0.0375-0.11581-0.0984-0.005-0.0585,0.0378-0.11244,0.0963-0.11712,0.0607-0.006,0.1123,0.0387,0.11688,0.0972'/%3E %3Cpath d='m729.65,542.69c0.007,0.0597-0.0321,0.11245-0.0917,0.11713-0.0573,0.006-0.11123-0.0363-0.11922-0.0972-0.0106-0.0585,0.0321-0.11124,0.0906-0.11712,0.0607-0.006,0.11347,0.0375,0.12036,0.0972'/%3E %3Cpath d='m729.13,542.77c0.0118,0.0585-0.0241,0.11832-0.0814,0.12999-0.0573,0.012-0.11347-0.0245-0.12496-0.082-0.0118-0.0573,0.024-0.11712,0.0826-0.12999,0.0585-0.014,0.11347,0.0234,0.12381,0.082'/%3E %3Cpath d='m728.61,542.89c0.0149,0.0573-0.0183,0.11472-0.0734,0.12648-0.0573,0.0152-0.11699-0.0234-0.13413-0.0785-0.0172-0.0585,0.0172-0.11472,0.0734-0.12883,0.0596-0.0128,0.11809,0.0222,0.13414,0.0808'/%3E %3Cpath d='m728.11,543.06c0.0207,0.0563-0.006,0.11952-0.0585,0.14171-0.0528,0.0222-0.11464-0.004-0.1387-0.0597-0.024-0.0551,0.0009-0.11832,0.0573-0.14054,0.0561-0.0234,0.11807,0.003,0.13985,0.0585'/%3E %3Cpath d='m727.62,543.27c0.0263,0.0551,0.0117,0.1218-0.0379,0.1546-0.047,0.0305-0.11229,0.0152-0.14101-0.0364-0.0309-0.0504-0.0149-0.12063,0.0367-0.15225,0.0504-0.0352,0.11464-0.0187,0.14215,0.034'/%3E %3Cpath d='m727.17,543.56c0.0344,0.048,0.0241,0.11472-0.024,0.14523-0.0458,0.034-0.10771,0.0317-0.14444-0.0164-0.0379-0.0457-0.0333-0.12062,0.0161-0.15694,0.0504-0.0328,0.12037-0.0211,0.15246,0.0281'/%3E %3Cpath d='m726.76,543.91c0.0402,0.0445,0.0379,0.11244-0.006,0.14991-0.0412,0.0399-0.11006,0.0375-0.15246-0.005-0.0424-0.0421-0.039-0.11005,0.005-0.15109,0.0447-0.0411,0.11347-0.0387,0.15246,0.006'/%3E %3Cpath d='m726.39,544.29c0.0424,0.0398,0.0458,0.10896,0.008,0.15342-0.04,0.0433-0.10665,0.0468-0.15018,0.01-0.0447-0.0399-0.0482-0.11004-0.009-0.1546,0.0402-0.0457,0.10771-0.0492,0.15131-0.008'/%3E %3Cpath d='m726.03,544.7c0.0447,0.0399,0.0493,0.10896,0.0106,0.15459-0.039,0.0445-0.10548,0.0492-0.14903,0.0108-0.0447-0.0387-0.0482-0.10896-0.0106-0.15343,0.0367-0.0468,0.10431-0.0515,0.14903-0.012'/%3E %3Cpath d='m725.68,545.1c0.0436,0.0411,0.0447,0.11004,0.003,0.15224-0.0402,0.0445-0.10889,0.0457-0.15018,0.004-0.0424-0.0399-0.0424-0.11004-0.004-0.15224,0.039-0.0421,0.10771-0.0445,0.15132-0.004'/%3E %3C/g%3E %3Cpath fill='%23939598' d='m729.55,542.2c-4.6497,0.16748-4.8468,2.0554-6.5882,3.633l0.87812,0.0305,0.3164,0.0108c1.715-1.5623,1.9385-3.4245,6.4792-3.6118-0.35078-0.0492-0.71304-0.075-1.0856-0.062z'/%3E %3Cg fill='%23442c13' stroke-width='0.115' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'%3E %3Cpath d='m596.42,395.94,0.13-2.252,0.524-0.032,0,0.62,3.719-0.098-0.815,2.088-3.525-0.13-0.065-0.294'/%3E %3Cpath d='m598.22,389.02,0.099,5.579-0.457,0.033,0.227-5.612z'/%3E %3Cpath d='m600.28,388.69,0.098,5.677-0.327,0.066,0.034-5.743z'/%3E %3Cpath d='m602.59,393.2-0.228-5.416-0.131,0.032,0.098,5.416z'/%3E %3Cpath d='m605.91,392.63,0.986-4.98-0.098,0.066-1.207,4.895z'/%3E %3Cpath d='m602.23,387.81-2.251,6.494-0.359-0.065,2.349-6.461z'/%3E %3Cpath d='m602.75,387.91,0.555,4.893,0.294-0.032-0.62-4.861z'/%3E %3C/g%3E %3Cpath fill='%23a48b58' stroke-width='0.115' d='m606.8,387.71-5.091,0-3.621,1.305,4.276,0.131z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23a37853' stroke-width='0.115' d='m597.96,389.15,3.85-1.273,5.092-0.097,0.031-0.359-5.221,0.097-3.718,1.207z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23000' d='m722.38,542.35c0-0.79756,0.53421-1.4452,1.1945-1.4452,0.57777,0,1.0592,0.49657,1.1704,1.1559,0.078-0.014,0.16049-0.0293,0.24188-0.0399-0.1284-0.80576-0.71074-1.4124-1.4123-1.4124-0.79558,0-1.4398,0.77999-1.4398,1.7415,0,0.27991,0.0595,0.54108,0.15704,0.77531,0.0653-0.0445,0.13642-0.0925,0.21438-0.14171-0.078-0.19207-0.1261-0.40405-0.1261-0.6336z'/%3E %3Cpath fill='%23939598' d='m721.11,545.75c1.8949-1.594,1.9649-3.5849,6.6695-3.7794-0.35192-0.048-0.71417-0.075-1.0867-0.0608-4.7975,0.17099-4.8526,2.176-6.759,3.7817-0.047,0.0399-0.0826,0.0832-0.11229,0.12766l1.1945,0.0269c0.0275-0.0305,0.0584-0.0644,0.094-0.096z'/%3E %3C/g%3E %3Cpath fill='%23fd0' d='m743.67,548.94,0-0.24829s12.591,0.0199,12.664-0.71559c0.073-0.7472-6.1044-0.44621-15.755,0.0515'/%3E %3Cpath fill='%23696161' opacity='0.75' d='m588.68,383.14c-0.659,0.074-1.138-0.657-1.749,0.295-0.018,0.019-0.035,0.039-0.051,0.059-0.418,0.478-0.637,1.144-0.377,1.643,0.153,0.299,0.872,0.568,1.197,0.612,0.8,0.107,1.447-0.543,1.524-1.305,0.376,0.466,1.469,0.484,2.021,0.514,0.962,0.051,1.227-0.121,1.38-1.126,0.563,0.792,1.013,0.854,1.979,0.689,1.104-0.19,2.392-0.323,3.199-1.139,0.308,0.465,0.749,0.72,1.291,0.727,0.473,0.007,1.09-0.076,1.531-0.241,0.365-0.135,0.768-0.641,1.141-0.71,0.286,0.423,0.849,0.26,1.228,0.333,0.706,0.432,1.472,0.696,2.607,0.094,0.298-0.159,1.358,0.232,1.731,0.056,0.26-0.122,0.31-0.376,0.528-0.505,0.464,0.356,1.216-0.012,1.711-0.139,0.395,0.02,0.945-0.044,1.087-0.521,0.689-0.411,0.489-0.755,0.274-0.951-1.096-0.438-1.861-0.438-2.887,0.293-0.338-0.087-0.504-0.078-0.747,0.357-0.438-0.666-1.216-0.857-2.016-0.378-0.675-0.379-1.028-0.101-1.574-0.081-1.095-0.82-3.059-0.712-4.417,0.08-1.542-0.712-2.014-0.303-3.033,0.458-0.574-0.251-1.281-0.097-1.91-0.049-0.57,0.043-0.866,0.756-1.364,0.517-1.1-0.529-1.633,0.28-2.465,0.243-0.903-0.773-1.839,0.175-1.839,0.175' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cg%3E %3Cpath fill='%2384848a' d='m707.99,548.97c0,0.61017-0.48376,1.1044-1.0799,1.1044-0.59611,0-1.0787-0.49541-1.0787-1.1044v-13.587c0-0.609,0.48263-1.1021,1.0787-1.1021,0.59611,0,1.0799,0.49423,1.0799,1.1021v13.587z'/%3E %3Cpath fill='%23453717' d='m717.07,546.5s-0.70158,0.68748-0.87124,0.74602c-0.16737,0.0563-1.01,0.42864-1.1762,0.42864-0.16852,0-0.53421,0.0269-0.92742,0.0269h-0.75661l-0.67406-0.0561,0.27971,1.3468,3.7601,0.0855,0.36569-2.5777z'/%3E %3Cpath fill='%236a5e46' d='M593.02,396.59H591.8L591.78,396.71H590.72L590.48,398.64 592.97,398.62' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cg fill='%23453717'%3E %3Cpath d='m710.59,548.62c0,0.0328-0.0253,0.0573-0.0573,0.0573-0.0298,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.0253-0.0573,0.0561-0.0573,0.031,0,0.0573,0.0245,0.0573,0.0573v1.1747z'/%3E %3Cpath d='m710.9,548.62c0,0.0328-0.0253,0.0573-0.0573,0.0573-0.0298,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.0252-0.0573,0.0561-0.0573,0.031,0,0.0573,0.0245,0.0573,0.0573v1.1747z'/%3E %3Cpath d='m711.23,548.62c0,0.0328-0.0241,0.0573-0.0561,0.0573-0.0321,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.024-0.0573,0.0561-0.0573s0.0561,0.0245,0.0561,0.0573v1.1747z'/%3E %3Cpath d='m711.74,548.62c0,0.0328-0.0253,0.0573-0.0561,0.0573-0.0309,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.024-0.0573,0.0561-0.0573,0.0298,0,0.0561,0.0245,0.0561,0.0573v1.1747z'/%3E %3Cpath d='m712.21,548.62c0,0.0328-0.0241,0.0573-0.0561,0.0573-0.0321,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.024-0.0573,0.0561-0.0573s0.0561,0.0245,0.0561,0.0573v1.1747z'/%3E %3Cpath d='m712.61,548.62c0,0.0328-0.024,0.0573-0.0561,0.0573s-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.0241-0.0573,0.0561-0.0573,0.0321,0,0.0561,0.0245,0.0561,0.0573v1.1747z'/%3E %3C/g%3E %3Cpath fill='%232f2311' d='M590.11,398.57V398.47L590.16,396.25 589.92,396.32 589.89,397.45 589.65,397.54 589.55,397.28H588.96L588.76,397.37V398.42z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%232f2311' d='M582.5,397.2 582.18,397.23V397.4H581.81L581.79,397.05H581.47V396.78L581.08,396.76 581.01,395.83H580.81V394.56L580.54,394.53 580.62,397.25 580.47,397.27V397.57H580.64L580.57,398.47 584.29,398.67 584.19,397.2H583.84V397.4L582.87,397.3 582.82,397.64H582.57z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23866d46' d='M584.95,397.54 584.16,397.5 584.29,398.57 584.97,398.5z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23acacad' d='m708.09,539.94c-0.27399-0.26702-0.70158-0.44037-1.1865-0.44037-0.48607,0-0.91366,0.17335-1.1865,0.44037-0.0117,0.0457-0.0207,0.0925-0.0207,0.14053,0,0.048,0.009,0.0925,0.0195,0.13938,0.27169-0.2682,0.69928-0.44388,1.1876-0.44388,0.4872,0,0.91479,0.17451,1.1865,0.44388,0.0106-0.0468,0.0195-0.0913,0.0195-0.13938,0-0.048-0.0106-0.0948-0.0195-0.14053'/%3E %3Cpath fill='%23866d46' d='M588.03,397.2 588,396.88 588.23,396.59 587.64,396.49 587.61,396.79 587.3,396.81 587.25,396.98H587.03L586.88,397.03 586.78,397.35 586.61,397.13 586.68,398.5 588.62,398.45V397.22' transform='matrix(1.146366,0,0,1.1711652,33.178094,82.138839)'/%3E %3Cpath fill='%232f2311' d='M584.73,398.57 586.83,398.5 586.76,397.45 584.8,397.47' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23453717' d='m698.38,548.94,0.0367-1.7579-0.4872,0.0761-0.33589,0-0.26251-0.15225-0.0367,0.11472-1.2346,0.0375-0.15018-0.38178-0.74744,0.075-0.0378,0.26821-0.93429,0.0375-0.14903-0.34316-0.26252,0,0-1.9125-0.4104,0.0387-0.18801,2.2931-0.37371,0.0375,0-0.30567-0.48606-0.0387-0.0744,0.57386-0.56172-0.0761,0.0379-0.53523-0.52389,0-0.0744,0.61135-3.1789,0.075,0.15019-2.751-0.5239-0.0761,0.0367,2.7522s-2.0566-0.68748-2.3936-1.0318l1.2346,1.4886c-0.00091,0.004,4.1132,0.80575,11.931,0.88305'/%3E %3Cpath fill='%23895f33' d='m685.52,547.95s-0.67406-0.1909-5.9095-1.7966c-5.2377-1.6033-7.7448-2.7511-8.2298-2.9033-0.4872-0.15343-1.1991,0,1.01,0.99314,2.2068,0.99432,10.511,3.8602,11.895,3.8227,1.3848-0.0375,1.4972,0.0761,2.4314-0.11592,0.93543-0.1909-1.1968,0-1.1968,0'/%3E %3Cpath fill='%23fff' d='m708.02,530.86c-0.75546,0.0867-1.3046-0.76945-2.005,0.34549-0.0207,0.0223-0.0402,0.0457-0.0585,0.0691-0.47917,0.55982-0.73022,1.3398-0.43216,1.9242,0.17539,0.35018,0.99961,0.66522,1.3722,0.71675,0.9171,0.12531,1.6588-0.63594,1.7471-1.5284,0.43104,0.54577,1.684,0.56685,2.3168,0.60198,1.1028,0.0597,1.4066-0.1417,1.582-1.3187,0.6454,0.92756,1.1613,1.0002,2.2687,0.80693,1.2656-0.22252,2.7421-0.37829,3.6672-1.334,0.35308,0.54459,0.85863,0.84324,1.48,0.85143,0.54223,0.008,1.2495-0.0891,1.7551-0.28225,0.41843-0.1581,0.88041-0.75071,1.308-0.83153,0.32786,0.4954,0.97327,0.30451,1.4078,0.39,0.80934,0.50595,1.6874,0.81513,2.9886,0.11005,0.34163-0.18622,1.5568,0.27171,1.9844,0.0656,0.29806-0.14289,0.35538-0.44036,0.60528-0.59144,0.53192,0.41694,1.394-0.014,1.9614-0.16279,0.45282,0.0235,1.0833-0.0515,1.2461-0.61017,0.78984-0.48135,0.56057-0.88424,0.31411-1.1138-1.2564-0.51297-2.1334-0.51297-3.3096,0.34316-0.38748-0.10188-0.57778-0.0913-0.85633,0.41809-0.50211-0.77999-1.394-1.0037-2.3111-0.44269-0.77379-0.44388-1.1784-0.11832-1.8044-0.0948-1.2553-0.96037-3.5067-0.83387-5.0635,0.0937-1.7677-0.83386-2.3088-0.35486-3.4769,0.5364-0.65801-0.29396-1.4685-0.11365-2.1896-0.0573-0.65341,0.0504-0.99275,0.88541-1.5636,0.60549-1.261-0.61954-1.872,0.32793-2.8258,0.2846-1.0352-0.90532-2.1082,0.20494-2.1082,0.20494'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23ffe600' d='m740.68,548.21,0.61102,0.76596-24.689,0-18.028-0.22838s-7.8572-0.1909-11.71-0.57271c-3.8518-0.3818-8.2298-1.4909-8.2298-1.4909,0.0379,1.1852,0.86093,1.7966,1.5339,2.4091,0.0872,0.0785,0.2499,0.16396,0.46656,0.25062,1.4502,0.58676,5.4086,1.3129,6.6776,1.5448,1.4582,0.26821,6.6581,0.57271,10.175,0.53524,3.5148-0.0375,39.239-0.19091,39.239-0.19091v-0.34433c1.3848,0.22838,18.929-1.0693,18.929-1.0693,0.05-0.0761,0.11-0.21198,0.1742-0.37126,0.1777-0.44152,0.3852-1.0927,0.4677-1.3586,0.024-0.0737,0.037-0.11712,0.037-0.11712l-15.654,0.23774z'/%3E %3Cpath transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' fill='%23000' d='m567.16,401.22-7.701-6.005,0.587,0.197,7.114,5.546z'/%3E %3Ccircle transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' fill='%23565759' stroke='%23000' stroke-width='0.23' cx='567.74' cy='398.67' r='0.48'/%3E %3Cpath fill='%23565759' stroke='%23000' stroke-width='0.1333' d='m684.74,550.52,0.0631,0.19441c-0.35881,0.41225-0.67636,0.21784-0.67636,0.21784v-1.5822c0.0826-0.0293,0.1456-0.11124,0.1456-0.2073,0-0.12179-0.0975-0.22134-0.21781-0.22134-0.11922,0-0.21667,0.0996-0.21667,0.22134,0,0.0844,0.0493,0.15694,0.11807,0.19442v1.594s-0.31754,0.19442-0.67635-0.21782l0.0631-0.19442-0.4872,0.0655,0.19029,0.43334,0.086-0.13001s0.50555,0.43216,0.88729,0.43216h0.0436c0.38174,0,0.88957-0.43216,0.88957-0.43216l0.0837,0.13001,0.19144-0.43334-0.48721-0.0644z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m686,549.04c0-0.1827,0.14558-0.33145,0.32556-0.33145,0.17883,0,0.32443,0.14875,0.32443,0.33145,0,0.18387-0.1456,0.33261-0.32443,0.33261-0.17998,0.00092-0.32556-0.14757-0.32556-0.33261'/%3E %3Cpath d='m689.02,549.65c0-0.18271,0.14559-0.33261,0.32442-0.33261,0.17997,0,0.32557,0.1499,0.32557,0.33261,0,0.18388-0.1456,0.33261-0.32557,0.33261-0.17883,0-0.32442-0.14873-0.32442-0.33261'/%3E %3Cpath d='m692,549.76c0-0.18386,0.14674-0.33261,0.32443-0.33261,0.17997,0,0.3267,0.14875,0.3267,0.33261,0,0.1827-0.14673,0.33145-0.3267,0.33145-0.17769,0-0.32443-0.14875-0.32443-0.33145'/%3E %3Cpath d='m695.42,549.71c0-0.1827,0.14558-0.33144,0.32557-0.33144,0.17998,0,0.32556,0.14874,0.32556,0.33144,0,0.18386-0.14558,0.33261-0.32556,0.33261-0.17999,0-0.32557-0.14875-0.32557-0.33261'/%3E %3Cpath d='m698.73,549.76c0-0.18386,0.14559-0.33261,0.32556-0.33261,0.17998,0,0.32558,0.14875,0.32558,0.33261,0,0.1827-0.1456,0.33145-0.32558,0.33145-0.17997,0-0.32556-0.14875-0.32556-0.33145'/%3E %3Cpath d='m701.82,549.71c0-0.1827,0.14559-0.33144,0.32442-0.33144,0.17997,0,0.32557,0.14874,0.32557,0.33144,0,0.18386-0.1456,0.33261-0.32557,0.33261-0.17883,0-0.32442-0.14875-0.32442-0.33261'/%3E %3Cpath d='m710.57,550.05c0-0.18388,0.1456-0.33263,0.32443-0.33263,0.17998,0,0.32556,0.14875,0.32556,0.33263,0,0.18386-0.14558,0.3326-0.32556,0.3326-0.17883,0-0.32443-0.14874-0.32443-0.3326'/%3E %3Cpath d='m719.55,550.28c0-0.18387,0.14559-0.33262,0.32558-0.33262,0.17997,0,0.32556,0.14875,0.32556,0.33262,0,0.1827-0.14559,0.33143-0.32556,0.33143-0.17999,0-0.32558-0.14873-0.32558-0.33143'/%3E %3Cpath d='m722.63,550.39c0-0.18388,0.14557-0.33261,0.32556-0.33261,0.18112,0,0.32556,0.14873,0.32556,0.33261,0,0.18386-0.14444,0.3326-0.32556,0.3326-0.17999,0-0.32556-0.14874-0.32556-0.3326'/%3E %3Cpath d='m725.33,550.39c0-0.18388,0.14559-0.33261,0.32557-0.33261,0.18112,0,0.32556,0.14873,0.32556,0.33261,0,0.18386-0.14444,0.3326-0.32556,0.3326-0.17998,0-0.32557-0.14874-0.32557-0.3326'/%3E %3Cpath d='m728.08,550.39c0-0.18388,0.1456-0.33261,0.32557-0.33261,0.17998,0,0.32442,0.14873,0.32442,0.33261,0,0.18386-0.14444,0.3326-0.32442,0.3326-0.17997,0-0.32557-0.14874-0.32557-0.3326'/%3E %3Cpath d='m730.71,550.34c0-0.1827,0.14559-0.33262,0.32557-0.33262,0.17883,0,0.32442,0.14992,0.32442,0.33262s-0.14559,0.33143-0.32442,0.33143c-0.17998,0-0.32557-0.14873-0.32557-0.33143'/%3E %3Cpath d='m733.24,550.22c0-0.1827,0.14559-0.33262,0.32557-0.33262s0.32557,0.14992,0.32557,0.33262c0,0.18387-0.14559,0.33261-0.32557,0.33261s-0.32557-0.14757-0.32557-0.33261'/%3E %3Cpath d='m735.88,550.22c0-0.1827,0.14558-0.33262,0.32557-0.33262,0.17997,0,0.32442,0.14992,0.32442,0.33262,0,0.18387-0.14445,0.33261-0.32442,0.33261-0.17999,0-0.32557-0.14757-0.32557-0.33261'/%3E %3Cpath d='m704.79,549.76c0-0.18386,0.14558-0.33261,0.32557-0.33261,0.17998,0,0.32556,0.14875,0.32556,0.33261,0,0.1827-0.14558,0.33145-0.32556,0.33145-0.17999,0-0.32557-0.14875-0.32557-0.33145'/%3E %3Cpath d='m707.6,549.93c0-0.18386,0.14559-0.33261,0.32556-0.33261,0.17884,0,0.32557,0.14875,0.32557,0.33261,0,0.18388-0.14673,0.33262-0.32557,0.33262-0.17997,0-0.32556-0.14874-0.32556-0.33262'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.23' stroke='%23000' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'%3E %3Ccircle cx='622.02' cy='399.23' r='0.355'/%3E %3Ccircle cx='624.18' cy='399.04' r='0.355'/%3E %3Ccircle cx='626.28' cy='398.89' r='0.355'/%3E %3C/g%3E %3Cpath fill='%23ed1c24' d='M682.56,551.38l0.5,0.4-0.09,0.31c0.04,0.09,0.11,0.18,0.22,0.29l0.09,0.09c0.01,0,0.03-0.01,0.03,0,1.05,1.03,3.88,2.59,3.88,2.59l12.15,0.35h0.22s55.16-0.37,55.16-0.66-0.47-2.56-0.47-2.56-0.29-0.23-0.59-0.16c-0.73,0.17-4.72,0.52-7.57,0.81-0.94,0.1-1.79,0.18-2.31,0.25-2.09,0.31-0.28,0-0.28,0s-21.54,0.24-24.53,0.16c-2.99-0.07-20.38,0.09-20.38,0.09s-10.91-0.78-11.81-0.78-2.69-0.76-3.44-0.84c-0.17-0.02-0.45-0.15-0.78-0.34z'/%3E %3Cpath fill='%23034ea2' d='m755.83,549.45c-0.064,0.16162-0.1238,0.29513-0.1742,0.37126,0,0-17.544,1.2988-18.929,1.0704v0.34198s-35.722,0.15459-39.239,0.19324c-3.517,0.0375-8.717-0.26821-10.174-0.53522-1.2702-0.23307-5.2297-0.95918-6.6787-1.5459l-0.72794,0.0925s1.5717,1.293,2.647,1.9383c0.33129,0.19793,0.61789,0.3373,0.79443,0.35488,0.74628,0.0773,2.5438,0.84089,3.4414,0.84089s11.82,0.76477,11.82,0.76477,17.357-0.15343,20.349-0.0773c2.992,0.0773,24.538-0.15226,24.538-0.15226s-1.7952,0.30684,0.29921,0c2.0956-0.30685,8.9038-0.8409,9.8759-1.0704,0.3073-0.0726,0.6455-0.35955,0.963-0.71675,0.6867-0.77413,1.2816-1.8809,1.2816-1.8809-0.018,0.003-0.053,0.007-0.087,0.0108'/%3E %3Cpath fill='%23fd0' d='m716.54,549.26,0.0872-3.6435s16.092,0.70739,23.833,0.62191v2.8436s-21.137,0.35486-23.92,0.17802'/%3E %3Cg fill='%239b7e39'%3E %3Cpath d='m730.02,554.92,0.38519,0.28576,0.423-0.28459-0.1708-2.778c-0.21093-0.008-0.38748-0.014-0.52389-0.0187l-0.11347,2.7956z'/%3E %3Cpath d='m729.34,552.14-0.83342,2.4653,0.28775,0.38647,0.48607-0.14873,0.62133-2.7241c-0.0585-0.003-0.094-0.004-0.094-0.004-0.15821,0.01-0.31068,0.0164-0.46772,0.0246'/%3E %3Cpath d='m727.16,553.87,0.16965,0.45558,0.50441-0.004,1.2037-2.1667c-0.23729,0.012-0.47001,0.0223-0.70272,0.0316l-1.175,1.683z'/%3E %3Cpath d='m726.12,552.82,0.0402,0.48485,0.48835,0.13938,1.2312-1.2391c-0.35653,0.0152-0.70503,0.0258-1.0489,0.0352l-0.71075,0.57972z'/%3E %3Cpath d='m731.86,554.7,0.4574,0.13469,0.30148-0.41693-0.96179-2.2334c-0.21208-0.007-0.41154-0.0152-0.59382-0.0222l0.79673,2.5379z'/%3E %3Cpath d='m732.96,554.21,0.4746,0.0246,0.20176-0.4755-1.1315-1.5506c-0.25565-0.008-0.49752-0.0175-0.7268-0.0246l1.1819,2.0261z'/%3E %3Cpath d='m734.1,553.31,0.46542-0.10656,0.0699-0.51297-0.54567-0.42864c-0.37945-0.0128-0.74857-0.0247-1.104-0.0364l1.1143,1.0845z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='none' stroke='%23d0c9ce' stroke-width='0.1333'%3E %3Cpath fill='%23fff' stroke='%23999b9e' d='m716.79,523.61,0.11807,0.0972s0.12611-0.19324,0.24304-0.19324c0.11807,0,0.42415,0.14406,0.42415,0.14406l0.0631-0.19326,0.54223,0.14523-0.0275-0.25765s0.35308,0.0492,0.34277,0.0175c-0.008-0.0317-0.0356-0.21784-0.0356-0.21784s0.42415,0.0164,0.45167,0.0305l-0.0355-0.20027s0.61789,0.0773,0.59609,0.0328c-0.0275-0.0573-0.12724-0.23424-0.12724-0.23424s0.49753,0.0492,0.70387,0.0492c0.20635,0,0.18113,0.0632,0.18113,0.0632v-0.16045l0.79329-0.0246-0.12611-0.18504,0.59611-0.0152-0.25335-0.27407s1.2002,0.39469,1.5694,0.0411c0,0-0.5491,0.0317-1.1636-0.16981-0.61445-0.20144-1.1911-0.25649-1.4158-0.31271-0.22583-0.0573-0.74055-0.20963-1.0283-0.33846-0.28888-0.12767-0.69928-0.32441-0.66719-0.3209,0.0722,0.01,0.2075-0.007,0.2075-0.007s-1.3447-0.50712-2.0302-0.61135c0,0-0.87353-0.1827-1.2805,0.11364,0,0-0.18915,0.24008-0.34275,0.30451-0.15363,0.0655-0.47689,0.28225-0.50442,0.31503-0.0263,0.0305-0.0997-0.0656-0.49638,0.17568,0,0-0.0894,0.0352-0.11807,0.0222,0,0-0.77035-0.38531-1.684-0.0222l-0.0665,0.0317s-0.36798-0.16746-0.65802-0.16746c-0.0355,0-0.34276-0.17685-0.39663-0.21083-0.0539-0.0305-0.0275-0.008-0.0275-0.008s-0.36913-0.77062-1.0558-0.7062c-0.68439,0.0644-1.0008,0.23188-1.0994,0.25648-0.0997,0.0246-0.79329,0.26586-0.93887,0.29748-0.1433,0.0317-0.45053,0.16864-0.45053,0.16864s-0.62248,0.27288-0.76692,0.29631c-0.14329,0.0245-0.98243,0.21901-1.0191,0.21901-0.0367,0,0.0802,0.0399,0.10889,0.0399,0,0-0.64999,0.19324-1.0214,0.24126-0.36799,0.048-1.5052,0.2237-1.5957,0.20143-0.0906-0.0245-0.0367-0.008-0.0367-0.008s0.3267,0.17099,1.2725,0.0867c0.17998-0.0152,0.29805-0.008,0.36913-0.0152,0.0722-0.008,0.0906-0.008,0.0356,0.007-0.0549,0.0175-0.41384,0.19324-0.41384,0.19324,0.0253-0.008,0.99046-0.008,0.81163,0.0317-0.0722,0.0164-0.31525,0.17684-0.31525,0.17684l0.93773,0.0164-0.12611,0.12767s0.85633,0.0411,0.9469,0.0246l-0.15361,0.17802s0.44136-0.0187,0.73941-0.10656l-0.14444,0.22486s0.56859-0.0246,0.62362-0.0317l-0.22583,0.23305s0.39778,0.0563,0.49637,0.0399c0.0997-0.0164,0.0539-0.0164,0.0539-0.0164l-0.1708,0.14522h0.60413l-0.0631,0.12064,0.53192-0.10428,0.13527,0.16044s0.42415-0.18386,0.46886-0.17567l0.27054,0.19207s0.27055-0.22486,0.30723-0.23306l0.0344-0.008s0.0997,0.23189,0.21666,0.29045c0,0,0.19833-0.14523,0.25334-0.13703,0.0539,0.008,0.15362,0.15224,0.15362,0.15224l0.1433-0.12881,0.3439,0.12881s0.0722-0.19323,0.17081-0.16981c0.0986,0.0246,0.5193,0.78937,1.457,0.84676,1.1853,0.0714,1.6531-0.58091,1.6531-0.58091l0.35307-0.22485,0.0447,0.2108,0.36913-0.16981,0.0106,0.10428s0.45969-0.20144,0.47689-0.28928l0.16277,0.24829s0.30265-0.19793,0.33474-0.19208c0.0447,0.0108,0.0894,0.13703,0.3336,0.17685'/%3E %3Cpath d='m713.3,523.5c0.0195,0.0269,0.0402,0.0551,0.0631,0.0797'/%3E %3Cpath d='m713.12,523.57c0.005,0.041,0.0161,0.0797,0.0447,0.11244'/%3E %3Cpath stroke='%23fff' d='m706.23,522.25c-0.0207,0.0247-0.0539,0.0421-0.0906,0.048'/%3E %3Cpath stroke='%23fff' d='m705.93,522.31c-0.047,0.0246-0.0882,0.0597-0.1456,0.0655'/%3E %3Cpath d='m720.25,522.73s-1.371-0.35486-1.8307-0.82685c0,0,0.0447-0.0891-0.0195-0.16278-0.0631-0.0727-0.0263-0.0247-0.0263-0.0247s0.23502,0.14523,0.45053,0.12766c0,0-0.0263-0.16865-0.14329-0.24945'/%3E %3Cpath d='m719.97,521.74s-0.72107,0.0317-1.1727-0.0247'/%3E %3Cpath d='m720.57,522.06s-0.24303,0.008-0.41269,0.0399c-0.17196,0.0328-0.6947,0.0492-0.88385-0.0644-0.18915-0.11244-0.29805-0.12765-0.4425-0.16162'/%3E %3Cpath d='m719.34,522.77c-0.0447-0.008-1.01-0.33729-1.3252-0.72378'/%3E %3Cpath d='m718.89,522.99s-0.66833-0.12766-1.4524-0.91585'/%3E %3Cpath d='m718.48,523.17c-0.0367-0.0317-1.4536-0.46494-1.4983-1.1337'/%3E %3Cpath d='m718.16,523.36s-0.80131-0.16044-1.5052-1.1887'/%3E %3Cpath d='m717.64,523.46s-0.8208-0.63477-1.0444-1.1161'/%3E %3Cpath d='m717.16,523.53c-0.0183-0.0399-0.58693-0.76243-0.66719-1.2297'/%3E %3Cpath d='m716.43,523.42s-0.30837-0.89242-0.19031-1.2859'/%3E %3Cpath d='m715.94,523.38c0-0.0328-0.0447-0.0797,0.0183-0.33731,0.0631-0.25765-0.0183-0.46494-0.0447-0.51297'/%3E %3Cpath d='m715.45,523.56c0-0.0247,0-0.31388,0.0985-0.52234,0.0997-0.20847,0.14444-0.40875-0.009-0.64297'/%3E %3Cpath d='m715.03,523.53s-0.0631-0.19324,0.1261-0.44973l0.0253-0.23305s0.0642,0.0164,0.0447-0.0328c-0.0172-0.0468-0.0539-0.14405-0.0539-0.14405'/%3E %3Cpath d='m714.37,522.05c0.0802-0.0738,0.19833-0.24127,0.18916-0.27407-0.009-0.0317-0.0447-0.096-0.0447-0.096l0.071,0.096s0.0458,0.0164,0.13642-0.048c0.0906-0.0644,0.20749-0.0714,0.26253-0.13702,0.0549-0.0632,0.0985-0.11952,0.14444-0.14405,0.0447-0.0234,0.12495,0.0247,0.19717-0.008,0.0722-0.0305,0.30722-0.14405,0.3439-0.20026,0.0356-0.0561,0.0631-0.10428,0.0997-0.13703,0.0356-0.0305,0.10665-0.12063,0.10665-0.12063s0.24418,0.0644,0.41499,0.0644c0.17196,0,0.22584-0.008,0.38977-0.008,0.16164,0,0.51242-0.0246,0.64769,0,0.13528,0.0246,0.48721,0.0726,0.53307,0.0808,0.0447,0.008,0.20749,0.0563,0.32441,0.0714,0.11688,0.0164,0.31412-0.0399,0.38749-0.0551'/%3E %3Cpath d='m715.05,522.61c0.0607,0.0164,0.19603,0.0844,0.21781,0.12766-0.0504-0.11364,0.13297-0.20262,0.19374-0.27406,0.0768-0.0913,0.0826-0.19206,0.0826-0.30449'/%3E %3Cpath d='m715.39,521.98c0.21208,0.18388,0.38862,0.37829,0.55943,0.59145,0.0241-0.12063,0.0161-0.24361,0.0699-0.36657,0.0286-0.0667,0.13643-0.1347,0.11922-0.21668'/%3E %3Cpath d='m715.78,521.36c0.0424,0.11484,0.10665,0.22721,0.15361,0.33964,0.0435,0.0996,0.0837,0.22018,0.15361,0.30918,0.0595,0.0761,0.15706,0.13352,0.24418,0.18506,0.0735,0.0433,0.16049,0.11592,0.24189,0.13702,0.0573-0.0515,0.0722-0.16279,0.0734-0.23189,0.00091-0.0797-0.0951-0.20729-0.0435-0.27171'/%3E %3Cpath d='m716.39,521.32c0.0344,0.31856,0.21781,0.48487,0.50669,0.65352,0.10665,0.0597,0.31869,0.16864,0.44823,0.15107,0.17998-0.0247,0.086-0.22368,0.0906-0.3209'/%3E %3Cpath d='m716.72,521.41c0.0756,0.0785,0.2052,0.11712,0.29461,0.18388,0.0735,0.0585,0.13413,0.13467,0.21208,0.18738,0.0344-0.0258,0.0332-0.0855,0.0183-0.11364'/%3E %3Cpath d='m717.01,521.26c0.0172,0.10188,0.12036,0.24712,0.18914,0.3291,0.0975,0.11712,0.21667,0.23424,0.35881,0.31036,0.086,0.0468,0.23271,0.11952,0.33474,0.12532,0.13299,0.01,0.1284-0.13937,0.0814-0.21901,0.0745,0.13,0.33015,0.0797,0.45052,0.12765'/%3E %3Cpath d='m715.74,521.37c0.24189,0,0.45969-0.075,0.69584-0.10428,0.16393-0.0199,0.3485-0.0317,0.51243-0.0108,0.13986,0.0187,0.28086,0.0738,0.42186,0.0738,0.0355-0.0808-0.039-0.1956-0.0884-0.26352'/%3E %3Cpath d='m717.44,521.12c0.11581,0.10308,0.24304,0.18972,0.39664,0.2436,0.0607,0.0222,0.13299,0.0235,0.1903,0.0539,0.0493,0.0246,0.0814,0.0655,0.12495,0.0972'/%3E %3Cpath d='m717.56,521.41c0.13184,0.0411,0.26367,0.0785,0.29921,0.21784'/%3E %3Cpath d='m714.87,522.73c-0.0607,0.0891-0.10772,0.18036-0.17997,0.26469'/%3E %3Cpath d='m715.4,522.74c0,0.062,0.0218,0.1194,0,0.16981'/%3E %3Cpath d='m715.38,523.17c-0.0195,0.0844-0.0561,0.16982-0.0528,0.25648,0.0195,0.004,0.0207-0.007,0.0344-0.0152'/%3E %3Cpath d='m715.87,523.18c-0.009,0.034-0.0275,0.10776-0.0275,0.1218'/%3E %3Cpath d='m715.6,522.3c0.0458,0.0679,0.0722,0.14172,0.12151,0.20612,0.0412,0.0515,0.0744,0.0808,0.0872,0.14758'/%3E %3Cpath d='m716.14,522.54c-0.0229-0.0281-0.0412-0.0608-0.0458-0.0972'/%3E %3Cpath d='m716.1,522.32c0.0275,0.0364,0.0539,0.0785,0.0642,0.1218'/%3E %3Cpath d='m716.11,522.18c0.0126,0.0293,0.0253,0.0561,0.0447,0.0797'/%3E %3Cpath d='m716.31,523.31c0.0137,0.014,0.0253,0.0305,0.0355,0.048'/%3E %3Cpath d='m716.54,523.05c0.0447,0.0632,0.0412,0.12531,0.0642,0.19324'/%3E %3Cpath d='m716.86,523.41c-0.0447-0.0539-0.0172-0.11472-0.0447-0.16982'/%3E %3Cpath d='m717.63,523.25c0.039,0.0387,0.0756,0.0703,0.13526,0.0797'/%3E %3Cpath d='m717.93,523.41c0.039,0.0421,0.15819,0.0585,0.17079-0.008'/%3E %3Cpath d='m717.91,523c0.039,0.062,0.10313,0.11004,0.17082,0.13704'/%3E %3Cpath d='m718.83,522.68c0.10889-0.012,0.18113,0.0679,0.27856,0.0808'/%3E %3Cpath d='m718.86,522.27c0.0321,0.0504,0.15934,0.19559,0.22584,0.19325'/%3E %3Cpath d='m719.43,522.56c0.0241,0.0551,0.18571,0.0608,0.24417,0.0879'/%3E %3Cpath d='m717.15,520.76c0.0791,0.0269,0.12839,0.0551,0.19832,0.0925,0.0539,0.0293,0.1284,0.0691,0.18916,0.0421'/%3E %3Cpath d='m716.92,520.76c0.11006-0.006,0.19029,0.0901,0.29118,0.0867-0.0333-0.0211-0.071-0.0352-0.11241-0.048'/%3E %3Cpath d='m716.67,520.78c0.1238,0.0328,0.1238,0.0363,0.19602,0.11712,0.004-0.0108,0.00091-0.0187,0.003-0.0269'/%3E %3Cpath d='m716.43,520.72c0.0504,0.0468,0.13183,0.0737,0.16278,0.13702'/%3E %3Cpath d='m716.3,520.73c-0.005,0.0421,0.031,0.0713,0.0722,0.0891'/%3E %3Cpath d='m716,520.8c-0.0367-0.0222-0.071-0.0585-0.0802-0.0972'/%3E %3Cpath d='m716.11,521.45c0.18571,0.0984,0.22927,0.30919,0.27971,0.47433'/%3E %3Cpath d='m718.7,521.38c0.14904,0.034,0.21094,0.13468,0.33245,0.20027,0.005-0.0269-0.0149-0.0199-0.0344-0.0317'/%3E %3Cpath d='m718.24,521.29c0.11687,0.0468,0.24532,0.048,0.34047,0.13468,0.0412,0.0364,0.0665,0.0808,0.11347,0.11244,0.007-0.012,0.0137-0.0258,0.0161-0.0387'/%3E %3Cpath d='m717.34,522.2c0.0665,0.0515,0.14559,0.13352,0.19718,0.20028,0.0332,0.0411,0.0504,0.11124,0.0917,0.13702'/%3E %3Cpath d='m714.95,521.66c0.0756,0.0667,0.25678,0.0785,0.24417,0.20964-0.005,0.0468-0.0642,0.0808-0.0711,0.12765-0.008,0.0515,0.0275,0.096,0.0344,0.14406'/%3E %3Cpath d='m714.88,521.86c0.0321,0.0561,0.10089,0.10428,0.0355,0.16747,0.003-0.008,0.009-0.0128,0.0183-0.0152'/%3E %3Cpath d='m715.35,521.5c0.11688,0.0867,0.24876,0.14171,0.34849,0.24711,0.0493,0.0527,0.1043,0.1991,0.15706,0.21316'/%3E %3Cpath d='m715.19,521.16c0.18457,0.0573,0.20634-0.0984,0.31526-0.16981'/%3E %3Cpath d='m715.58,521.09c0.0698-0.0691,0.0379-0.22838,0.15362-0.25766'/%3E %3Cpath d='m715.4,520.85c0.11922-0.10189,0.16393-0.22603,0.34276-0.25063'/%3E %3Cpath d='m714.21,521.58c0.0722,0.0293,0.13871,0.0679,0.13413,0.14522'/%3E %3Cpath d='m714.16,521.73c0.0241,0.0305,0.0493,0.0609,0.0516,0.0949-0.0149-0.006-0.0275-0.0128-0.0424-0.0222'/%3E %3Cpath d='m713.95,521.65c0.024,0.0259,0.0435,0.0551,0.0631,0.0832,0.0253,0.0317,0.0137,0.048,0.0275,0.0375'/%3E %3Cpath d='m714.36,522.18c-0.0321,0.0761-0.006,0.171,0,0.23189'/%3E %3Cpath d='m714.01,523.45c0.0207,0.0411,0.0458,0.2354-0.0344,0.21667'/%3E %3Cpath d='m711.49,522.3c0.0561-0.005,0.0607-0.0468,0.10313-0.0726,0.0493-0.0293,0.0997-0.0246,0.15935-0.0246'/%3E %3Cpath d='m711.78,522.47c0.0229,0.0305,0.024,0.0632,0,0.0644'/%3E %3Cpath d='m711.62,522.49c0.004,0.0187,0.0009,0.0375-0.009,0.048'/%3E %3Cpath d='m711.5,522.48c-0.003,0.0211-0.005,0.0421-0.0106,0.0644'/%3E %3Cpath d='m712.08,521.56c-0.0493,0.0761-0.0975,0.16279-0.12037,0.24828,0.009,0.01,0.0195,0.01,0.031,0'/%3E %3Cpath d='m712.25,521.65c-0.0321,0.0363-0.0585,0.0996-0.0539,0.15225'/%3E %3Cpath d='m712.53,521.4c-0.0539,0.0363-0.11006,0.0738-0.16279,0.11364'/%3E %3Cpath d='m711.49,521.82c-0.14788-0.048-0.18343-0.0937-0.19029-0.22369-0.11923-0.005-0.30035-0.18622-0.20865-0.28928-0.0321,0.20377-0.29462,0.1218-0.42415,0.0539-0.19833-0.10068-0.35882-0.27756-0.4425-0.46378-0.0528,0.0891-0.13297,0.0797-0.23959,0.0797-0.21897-0.00093-0.42415,0.0364-0.64082,0.0468-0.2373,0.0128-0.45397-0.0714-0.68781-0.0632-0.19374,0.006-0.35538,0.10777-0.54912,0.1265-0.16508,0.0152-0.33245,0.003-0.49638,0.0175'/%3E %3Cpath d='m711.71,521.48c-0.0974,0.0164-0.22124,0.012-0.29805,0.0808,0.0137,0.0128-0.0009,0.0187-0.0009,0.0245'/%3E %3Cpath d='m705.85,521.64c0.27282,0.0108,0.53648,0.0738,0.81277,0.0644,0.13642-0.005,0.26366-0.0316,0.39664-0.0539,0.11808-0.0223,0.25679-0.0293,0.35996-0.082'/%3E %3Cpath d='m705.95,522.57c0.24075-0.0128,0.50899-0.10777,0.744-0.16749,0.26022-0.0667,0.51701-0.13586,0.74857-0.26,0.11687-0.0608,0.18343-0.13936,0.22698-0.24712,0.0379-0.096,0.11241-0.19909,0.11922-0.30684'/%3E %3Cpath d='m706.75,522.74c0.12152-0.0258,0.22928-0.17334,0.34048-0.23424,0.11123-0.0632,0.24417-0.0937,0.36569-0.13468,0.27054-0.0903,0.52159-0.23423,0.71762-0.41811'/%3E %3Cpath d='m707.33,522.84c0.10207-0.0984,0.25908-0.11484,0.38747-0.17335,0.17195-0.0773,0.33703-0.20026,0.47689-0.31737,0.17654-0.15109,0.33015-0.29748,0.46198-0.48018'/%3E %3Cpath d='m707.85,522.99c0.26251-0.13469,0.54223-0.25649,0.79557-0.40406,0.13413-0.0785,0.24877-0.16865,0.35997-0.27288,0.094-0.0879,0.13871-0.22019,0.22125-0.30333'/%3E %3Cpath d='m708.17,523.26c0.28431-0.17215,0.57432-0.35485,0.8357-0.55396,0.23271-0.17685,0.50555-0.30098,0.62706-0.57152'/%3E %3Cpath d='m708.58,523.42c0.14216-0.24945,0.37716-0.45324,0.62249-0.61954,0.18801-0.12883,0.36455-0.28459,0.38746-0.51297'/%3E %3Cpath d='m709.08,523.44c0.004-0.0879,0.0884-0.17918,0.14216-0.25062,0.0768-0.10068,0.15704-0.20496,0.22583-0.31154,0.0802-0.12297,0.13297-0.26234,0.19143-0.39469'/%3E %3Cpath d='m709.7,523.4c0.0872-0.24945,0.0997-0.54458,0.13298-0.80341,0.009-0.0703-0.0117-0.12531-0.007-0.19206,0.005-0.096,0.0458-0.18739,0.0722-0.28226'/%3E %3Cpath d='m710.27,523.33c0.0195-0.0563-0.0183-0.11244-0.0183-0.16865,0.0009-0.0597,0.0286-0.0984,0.039-0.15576,0.0172-0.0949,0.004-0.23189-0.003-0.33378-0.005-0.10068-0.0424-0.22838-0.0117-0.32911,0.0253-0.0867,0.12266-0.13233,0.20978-0.16981'/%3E %3Cpath d='m710.75,523.5c-0.0826-0.26351-0.27743-0.4954-0.26252-0.77297,0.005-0.11244,0.0149-0.28694,0.13527-0.34432'/%3E %3Cpath d='m711.02,523.53c0.0677-0.16865,0.0698-0.47432,0.0106-0.64181'/%3E %3Cpath d='m711.56,523.49c-0.0756-0.16162-0.24417-0.26117-0.19832-0.44973,0.023-0.0972,0.0791-0.17217,0.0894-0.27288'/%3E %3Cpath d='m711.3,522.71c-0.0378,0.0644-0.14444,0.1464-0.22583,0.16162-0.0928,0.0175-0.20978-0.0175-0.27168,0.062-0.0631-0.082-0.0321-0.28927-0.0333-0.39001-0.003-0.12999-0.023-0.2717,0.0264-0.39584,0.0928-0.22838,0.31526-0.35837,0.5686-0.39351'/%3E %3Cpath d='m711.18,521.61c-0.11808,0.18036-0.37371,0.0855-0.51242,0.24011-0.1284,0.1417-0.14788,0.41107-0.11123,0.5844,0.047-0.0457,0.10888-0.0585,0.16507-0.0937'/%3E %3Cpath d='m710.45,521.28c-0.0424,0.12179-0.16622,0.18387-0.24187,0.28225-0.0677,0.0855-0.0872,0.17802-0.11006,0.2764-0.024,0.10656-0.0402,0.20261,0.003,0.30567,0.0344,0.0879,0.0802,0.17568,0.0974,0.2682'/%3E %3Cpath d='m710.06,521.06c-0.0275,0.2108-0.32442,0.39584-0.47917,0.53757-0.0722,0.0691-0.13527,0.14991-0.11124,0.24944,0.0195,0.0738,0.0837,0.12298,0.11922,0.1874,0.0218,0.0411,0.0275,0.0925,0.0504,0.13117,0.0642-0.0433,0.11006-0.0726,0.18571-0.0925,0.0722-0.0222,0.18228-0.0269,0.23501-0.082'/%3E %3Cpath d='m707.94,521.14c-0.19487,0.17919-0.56514,0.27171-0.67749,0.52117'/%3E %3Cpath d='m708.67,521.72c-0.0665,0.0644-0.13987,0.14523-0.22355,0.19208-0.0928,0.0527-0.2029,0.0411-0.30837,0.0411'/%3E %3Cpath d='m707.66,521.94c0.11699-0.0585,0.54223-0.0573,0.55943-0.21667'/%3E %3Cpath d='m708.77,522.11c0.15935-0.0108,0.29462-0.0128,0.37831-0.14523'/%3E %3Cpath d='m708.21,521.71c-0.023,0.0751-0.071,0.1628-0.0814,0.23423'/%3E %3Cpath d='m708.66,521.74c0.11007,0.10536,0,0.3045,0.12611,0.38414'/%3E %3Cpath d='m709.56,521.2c-0.0802,0.096-0.1559,0.18152-0.2522,0.26819-0.0584,0.0527-0.14329,0.10776-0.1731,0.17918-0.0435,0.096,0.005,0.21082,0.0286,0.30685'/%3E %3Cpath d='m708.94,521.08c0.0768,0.0751,0.19832,0.007,0.29118,0.0175,0.0734,0.007,0.15246,0.0281,0.25449,0.0175,0.094-0.01,0.17654-0.0375,0.26252,0.0108,0.054,0.0305,0.0826,0.0972,0.1582,0.10068'/%3E %3Cpath d='m709.42,521.86c-0.0677,0.0492-0.18114,0.0984-0.26253,0.12064'/%3E %3Cpath d='m708.25,521.53c-0.0137,0.0364-0.0207,0.075-0.0367,0.11244'/%3E %3Cpath d='m708.49,521.5c0.0906-0.14874,0.20291-0.18622,0.34162-0.26469'/%3E %3Cpath d='m711,521.08c-0.005,0.0421-0.0207,0.0879,0.003,0.12414,0.008-0.014,0.004-0.0234,0.006-0.0352'/%3E %3Cpath d='m710.8,520.92c-0.005,0.0984,0.024,0.12296,0.0596,0.21314-0.0137-0.0187-0.0275-0.034-0.0402-0.0527'/%3E %3Cpath d='m710.68,520.89c-0.0137,0.0468-0.0149,0.11592,0.0106,0.14522'/%3E %3Cpath d='m710.37,520.73c0.0264-0.0411,0.0643-0.0855,0.10889-0.12064'/%3E %3Cpath d='m710.33,520.6c-0.0321,0.0468-0.0894,0.10896-0.14444,0.13703'/%3E %3Cpath d='m710.15,520.58c-0.009,0.0585-0.0607,0.12999-0.1261,0.15226'/%3E %3Cpath d='m709.94,520.64c-0.0333,0.0515-0.10207,0.0879-0.16392,0.11245'/%3E %3Cpath d='m709.63,520.66c-0.0367,0.0387-0.086,0.0713-0.13528,0.0972'/%3E %3Cpath d='m709.36,520.67c-0.0106,0.0317-0.0504,0.048-0.0894,0.048'/%3E %3Cpath d='m711.39,522.05c0.0183-0.0903,0.18456-0.0996,0.26136-0.0809'/%3E %3Cpath d='m711.2,522.18c0.0379-0.012,0.0688-0.0457,0.0723-0.0797'/%3E %3Cpath d='m710.12,522.61c0,0.0972,0.0126,0.17451-0.0551,0.25765'/%3E %3Cpath d='M709.92,523.42V523.32'/%3E %3Cpath d='m710.04,523.29c0,0.0246-0.005,0.0515-0.0183,0.0738'/%3E %3Cpath d='m709.87,523.21c-0.003,0.0199-0.009,0.0387-0.0183,0.0561'/%3E %3Cpath d='m709.32,523.42c0-0.006,0.009-0.0258,0.0183-0.0387'/%3E %3Cpath d='m709.54,523.29c0.005,0.0258,0.0009,0.0515-0.009,0.0563'/%3E %3Cpath d='m709.76,522.47c0,0.10776-0.0009,0.26468-0.0906,0.34549'/%3E %3Cpath d='m710.25,521.28c-0.0906,0.12999-0.41728,0.24009-0.40581,0.41107'/%3E %3Cpath d='m709.35,521.25c-0.0172,0.0246-0.0412,0.0457-0.0723,0.0563'/%3E %3Cpath d='m709.6,521.32c-0.0309,0.0515-0.0677,0.0972-0.0997,0.14523'/%3E %3Cpath d='m710.66,521.59c-0.14789,0.0504-0.2866,0.10536-0.3164,0.24947'/%3E %3Cpath d='m708.75,522.2c0.0195,0.14289-0.15476,0.26352-0.29002,0.3045'/%3E %3Cpath d='m709.42,522.19c-0.0505,0.0551-0.12955,0.14171-0.20979,0.16161'/%3E %3Cpath d='m708.39,522.89c-0.0161,0.0468-0.0722,0.0808-0.10771,0.11244'/%3E %3Cpath d='m708.09,523.04c-0.0447,0.0199-0.12266,0.0996-0.16393,0.0725'/%3E %3Cpath d='m707.6,522.44c-0.024,0.0585-0.094,0.0891-0.14444,0.12063'/%3E %3Cpath d='m707.11,522.67c-0.0756,0.0222-0.18114,0.0433-0.24418,0.0561'/%3E %3Cpath stroke='%23fff' d='m706.76,522.55c-0.0321,0.0504-0.0917,0.0761-0.15476,0.0891'/%3E %3Cpath d='m707.13,521.42c-0.14559,0.006-0.29577,0.0667-0.40581,0.14404'/%3E %3Cpath stroke='%23fff' d='m706.03,522.48c-0.0412,0.0234-0.11464,0.062-0.16279,0.0399'/%3E %3Cpath stroke='%23fff' d='m704.9,522.16c0.20175-0.11713,0.47918-0.17335,0.70845-0.2237,0.11006-0.0246,0.20176-0.0421,0.29919-0.096,0.0848-0.0468,0.16853-0.11004,0.25565-0.14405'/%3E %3Cpath d='M706.66,522.49H706.52'/%3E %3C/g%3E %3Cpath fill='%232f3b30' stroke='%23fff' stroke-width='0.1333' d='m711.87,544.25s0.25908-1.3703,1.2381-1.6338c0.98014-0.26351,2.0119-1.0529,2.0119-2.0554,0-1.0002-0.56629-1.5811-1.1853-1.8973,0,0,1.8571-1.2637,1.8571-3.1071,0-1.8446-1.9614-2.8471-1.9614-2.8471s2.9909-1.1583,3.1972-2.6878c0.2075-1.5272-1.3401-3.3191-1.8044-3.8449-0.46313-0.52703-1.1853-0.57973-1.1853-0.57973l0.30953,0.63243-0.61905-0.26585s0.30608,0.86549,1.1349,1.5834c0.61216,0.52819,1.7024,1.6326,1.3928,2.4747-0.30952,0.8444-3.0425,2.2147-3.0425,2.2147v1.1583s1.9591,1.211,1.9076,2.2674c-0.0516,1.054-1.7528,2.2662-1.7528,2.2662l-0.10313,1.0529s1.1854,0.79053,1.1338,1.6338c-0.0516,0.8444-1.2897,1.2648-1.2897,1.2648s-1.496,0.68396-1.2897,2.2135'/%3E %3Cpath fill='%232f3b30' stroke='%23fff' stroke-width='0.1333' d='m714.47,544.25s-0.25794-1.3703-1.2381-1.6338c-0.979-0.26351-2.0119-1.0529-2.0119-2.0554,0-1.0002,0.56745-1.5811,1.1865-1.8973,0,0-1.8571-1.2637-1.8571-3.1071,0-1.8446,1.9603-2.8471,1.9603-2.8471s-2.992-1.1583-3.1972-2.6878c-0.20634-1.5272,1.3412-3.3191,1.8044-3.8449,0.46427-0.52703,1.1865-0.57973,1.1865-0.57973l-0.31067,0.63243,0.61904-0.26585s-0.30494,0.86549-1.1349,1.5834c-0.61216,0.52819-1.7012,1.6326-1.3928,2.4747,0.31066,0.8444,3.0436,2.2147,3.0436,2.2147v1.1583s-1.9603,1.211-1.9087,2.2674c0.0528,1.054,1.7539,2.2662,1.7539,2.2662l0.10431,1.0529s-1.1876,0.79053-1.136,1.6338c0.0516,0.8444,1.2897,1.2648,1.2897,1.2648s1.496,0.68396,1.2897,2.2135'/%3E %3Crect fill='%2364472d' width='0.74743' height='27.897' x='712.67' y='520.55'/%3E %3Crect fill='%2364472d' width='0.20061' height='0.53405' x='712.94' y='520.2'/%3E %3Cpath fill='%2364472d' d='m712.32,519.45c0-0.42045,0.33474-0.76243,0.74629-0.76243,0.4127,0,0.74858,0.34198,0.74858,0.76243,0,0.42163-0.33588,0.76478-0.74858,0.76478-0.41155,0-0.74629-0.34315-0.74629-0.76478'/%3E %3C/g%3E %3C/g%3E %3Cg id='border' fill='none' stroke='%23000'%3E %3Cpath stroke-width='1.285' d='m630.79,241.91c27.114,16.283,45.968,52.392,45.968,94.323,0,49.904-26.707,91.565-62.261,101.37'/%3E %3Cpath stroke-width='0.643' d='m629.83,243.6c26.741,15.865,45.366,51.372,45.366,92.627,0,48.973-26.241,89.844-61.153,99.377'/%3E %3Cpath stroke-width='1.297' d='m581.76,438.03c5.403,1.578,11.016,2.41,16.772,2.41,5.917,0,11.682-0.878,17.226-2.544'/%3E %3Cpath stroke-width='1.291' d='m658.8,386.73c-10.246,22.965-27.379,39.604-47.497,44.598l0.188-1.006c-4.098,1.031-8.319,1.569-12.631,1.569-4.933,0-9.744-0.704-14.39-2.045l0.121,1.146c-18.509-5.085-34.389-20.058-44.538-40.696l0.524,1.049c10.167,20.097,25.82,34.648,44.014,39.647l-0.121-1.146c4.646,1.341,9.457,2.045,14.39,2.045,4.312,0,8.533-0.538,12.631-1.569l-0.188,1.006c19.75-4.903,36.622-21.026,46.929-43.342'/%3E %3Cpath fill='%23b1babf' stroke='none' d='m631.36,241.24s-14.748-8.942-33.978-8.723c-14.087,0.16-30.156,8.067-30.156,8.067-16.126,9.438-29.363,26.161-37.612,46.732-5.859,14.608-9.222,31.026-9.222,48.739,0,50.48,28.659,90.88,64.466,100.49,0,0,5.32,2.292,12.608,2.292,7.286,0,13.983-0.917,13.983-0.917,36.52-8.859,65.331-50.171,65.331-101.32,0.001-66.317-52.397-99.617-45.42-95.361m-19.88,190.13s-7.366,1.314-13.928,1.314c-6.56,0-12.836-1.648-12.836-1.648-32.236-8.8-57.854-47.072-57.854-93.285,0-16.217,3.666-32.244,8.939-45.617,7.426-18.832,20.05-33.414,34.567-42.054,0,0,14.644-8.919,27.326-9.065,17.312-0.201,30.411,9.666,30.411,9.666,24.299,15.072,41.174,48.27,41.174,86.801,0.002,46.826-24.921,85.775-57.799,93.888'/%3E %3Cg fill='%23c69024' stroke='%23080101' stroke-width='0.458'%3E %3Cpath d='m566.69,242.43c-26.899,15.875-45.662,51.71-45.662,93.374,0,49.341,26.313,90.508,61.295,100.03l-0.932,1.871c-35.39-10.02-61.93-51.84-61.93-101.89,0-41.968,18.572-78.14,45.456-94.645l1.7737,1.271z'/%3E %3Cpath d='m630.28,242.57c26.943,15.88,45.735,51.727,45.735,93.403,0,49.358-26.356,90.539-61.394,100.06l0.933,1.872c35.444-10.032,62.03-51.858,62.03-101.94,0-41.98-18.688-78.165-45.614-94.675l-0.212-0.146-1.898,1.213,0.42,0.205z'/%3E %3Cpath d='m570.08,251.03c-24.518,14.614-41.619,47.604-41.619,85.958,0,45.423,23.983,83.322,55.868,92.086l0.588,2.332-1.436-0.61c-32.256-9.232-56.449-47.724-56.449-93.808,0-38.635,17.005-71.934,41.511-87.128l0.191-0.135,1.729,1.117-0.383,0.188z'/%3E %3Cpath stroke-width='0.492' d='m631.14,240.63c0.08,0.056,0.159,0.112,0.239,0.169l-4.734,9.936c-0.05-0.031-0.101-0.062-0.153-0.094-3.839-2.371-15.169-8.52-29.127-8.333-11.096,0.149-23.563,6.608-26.468,8.199,0.921-2.253-5.0756-9.8827-5.0756-9.8827s1.3096-0.75627,1.3096-0.75627,16.038-9.154,30.098-9.339c19.191-0.253,33.911,10.1,33.911,10.1'/%3E %3Cpath d='m626.76,251.03c24.558,14.619,41.688,47.621,41.688,85.986,0,45.439-24.023,83.35-55.959,92.117l0.048,1.989c0.156-0.045,1.118-0.357,1.274-0.404,32.07-9.474,56.067-47.827,56.067-93.702,0-38.646-17.033-71.958-41.577-87.157l-0.022-0.016-1.418-0.824-0.483,1.822,0.382,0.189z'/%3E %3Cpath stroke-width='0.57' d='m758.74,365.2-0.079,0.0362c-2.5747,1.2649-4.6829,4.3076-5.5186,8.1127-0.2625,1.1887-0.4081,2.6972-0.3577,3.7618,0,0-2.8705-1.5635-2.8762-1.8012-0.022-0.98145,0.08-2.0261,0.3176-3.1059,0.932-4.2361,3.4906-7.6582,6.4036-8.5706,0.042-0.012,2.1104,1.567,2.1104,1.567z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Cpath stroke-width='0.57' d='m679.17,365.5,0.0791,0.0364c2.5748,1.2648,4.6829,4.3075,5.5198,8.1127,0.26251,1.1887,0.40696,2.6972,0.35651,3.7618,0,0,2.8705-1.5635,2.8762-1.8013,0.023-0.98143-0.0791-2.0261-0.3164-3.1059-0.93314-4.2361-3.4483-7.6313-6.3623-8.5436-0.039-0.0128-2.1529,1.5401-2.1529,1.5401z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Cpath stroke-width='0.5307' d='m738.76,595.14s-0.5984-0.46612-1.3688-1.3176c-0.56057-3.654-2.5862-5.3124-2.5862-5.3124l-0.42185,0.0433c-0.36914-1.3211-0.51817-2.8038-0.26138-4.4165l-0.21209,0.034c-4.7379,1.1325-10.137,1.9078-15.93,1.8387-4.5729-0.0551-9.3498-0.93693-13.746-2.1233-0.0435-0.012-0.80474-0.0108-0.78182,0.062,0.53536,1.5799,0.45166,3.1399,0.0607,4.5629l-0.0367-0.004s-1.809,1.4886-2.4807,4.7397c-0.77608,0.98379-1.41,1.5717-1.41,1.5717,0.38977,0.11712,0.78297,0.23071,1.1773,0.34432-0.003,0.0737-0.0106,0.1417-0.0126,0.21549-0.0826,3.1832,2.8946,3.7266,4.8686,3.7372,0.611,4.023,3.1284,3.3917,4.4594,2.7452-0.17655,0.24594-0.28315,0.38882-0.28315,0.38882,0.19717,2.703,1.59,2.9221,3.1559,4.2513,0.14102,0.12063,1.1429,0.76009,1.4674,1.2215,0.0207-0.006,0.0424-0.0199,0.0642-0.0245,1.4582,2.0425,2.5518,7.1687,4.4513,7.1687h0.49638c1.8915,0,2.984-5.0852,4.4353-7.1441,0.32212-0.46144,1.324-1.1009,1.4651-1.2215,1.5659-1.3293,2.9588-1.5483,3.1571-4.2513,0,0-0.10771-0.14289-0.28315-0.38882,1.3286,0.64648,3.8472,1.2777,4.4594-2.7452,1.9534-0.012,4.887-0.5481,4.8652-3.6458,0.41384-0.10776,0.82538-0.219,1.2312-0.33027z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Cpath stroke-width='0.5307' d='m740.44,594.56c-2.1208-1.2496-3.9034-4.1272-4.4089-7.4826-0.15704-1.0494-0.17538-2.0519-0.0734-2.9736l-2.365-0.23188c-0.27055,1.1911-0.32098,2.566-0.10207,4.0311,0.56974,3.7864,2.7696,6.9661,5.2423,7.8808l1.7069-1.2239z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Cpath stroke-width='0.5307' d='m698.03,594.44c2.1196-1.2496,3.9034-4.1272,4.4078-7.4826,0.1582-1.0494,0.17654-2.0519,0.0745-2.9736l2.3638-0.23189c0.27168,1.1911,0.32214,2.5648,0.10313,4.0311-0.56974,3.7864-2.7696,6.9661-5.2423,7.8808l-1.7069-1.2239z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'%3E %3Cpath d='m705.48,599.31c1.8204-1.3422,2.4257-3.6095,2.9038-5.7411,0.0241-0.10308-0.0149-0.50945-0.0263-0.46027-0.47115,2.1046-1.0764,4.3415-2.8774,5.6684-0.10313,0.0785,0.0528,0.49423,0,0.53287'/%3E %3Cpath d='m709.73,602.29c2.1185-0.87252,3.2224-4.1951,3.7509-6.2528,0.039-0.15108-0.0367-0.42163-0.0126-0.51297-0.53193,2.0612-1.6404,5.3674-3.7394,6.2329-0.0882,0.0364,0.0264,0.52235,0.0009,0.53288'/%3E %3Cpath d='m714.61,607.9c1.5052-2.0589,2.1701-4.324,2.3833-6.8572,0.005-0.0691-0.0195-0.58442-0.0367-0.37595-0.21092,2.4911-0.87352,4.6882-2.3466,6.7014-0.094,0.12648,0.0653,0.4427,0,0.53171'/%3E %3Cpath d='m732.58,598.77c-1.7998-1.3269-2.4051-3.5638-2.8774-5.6684-0.0118-0.048-0.0493,0.35603-0.0263,0.46026,0.47918,2.1315,1.0833,4.4001,2.9037,5.7411-0.0528-0.0387,0.1043-0.45442,0-0.53288'/%3E %3Cpath d='m728.47,601.76c-2.0978-0.86549-3.2064-4.1729-3.7372-6.2318,0.0241,0.0903-0.0528,0.36306-0.0149,0.51297,0.53077,2.0554,1.6347,5.378,3.7509,6.2517-0.0219-0.01,0.0928-0.4954,0.0009-0.53288'/%3E %3Cpath d='m723.59,607.52c-1.4731-2.0132-2.1357-4.2103-2.3466-6.7014-0.0183-0.20847-0.0424,0.30801-0.0367,0.37595,0.21436,2.5332,0.87811,4.7994,2.3833,6.8572-0.0653-0.0879,0.094-0.40407,0-0.53172'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='condor'%3E %3Cg fill='%23452c25' stroke='%23000' stroke-width='0.5481'%3E %3Cpath d='m662.23,304.61s-4.2049,9.7289-1.927,10.683c2.2767,0.95333,8.0578-0.5727,12.964-9.3482,4.9053-8.7755-2.909-5.4917-2.909-5.4917l-8.1282,4.1566z'/%3E %3Cpath d='m688.15,311.1s-0.69928,12.781,0,13.735c0.70044,0.95333,7.1843,0.95333,7.5328-8.5846,0.35078-9.5391-1.4009-9.9198-1.4009-9.9198l-6.3073,4.3872'/%3E %3Cpath d='m692.03,295.69s-4.5545,14.307-0.17425,17.169c4.3791,2.8612,7.8836-14.117,8.0578-17.932,0.17541-3.8156-7.8836,0.76243-7.8836,0.76243z'/%3E %3Cpath d='m695.16,313.96s0.87581,13.354,3.3279,13.925c2.4532,0.57269,6.4816-3.8145,6.4816-7.2484,0-3.4338-4.2049-11.446-4.2049-11.446l-5.7811,4.1974'/%3E %3Cpath d='m695.28,297.97s-4.5545,14.307-0.1754,17.168c4.3803,2.8623,7.8847-14.116,8.059-17.931,0.1754-3.8156-7.8836,0.76243-7.8836,0.76243z'/%3E %3Cpath d='m695.63,275.01s-6.6581,6.8677-6.4816,10.683c0.17425,3.8145,9.8094-5.1508,10.686-6.8689,0.87468-1.7158-4.2049-3.8145-4.2049-3.8145z'/%3E %3Cpath d='m691.06,271.16s-5.2561,9.7289-3.8541,12.781,6.4816-2.2884,8.9348-5.7223c2.4532-3.4338-5.0807-7.0586-5.0807-7.0586z'/%3E %3Cpath d='m679.24,272.84s-3.5044,13.163-0.87582,14.498c5.1426,2.6129,8.4648-9.1117,8.9348-13.545,0.52503-4.9599-8.059-0.95333-8.059-0.95333z'/%3E %3Cpath d='m686.82,272.73s-6.657,6.8677-6.4804,10.683c0.1731,3.8145,9.8094-5.1508,10.685-6.8689,0.87697-1.7158-4.2049-3.8145-4.2049-3.8145z'/%3E %3Cpath d='m573.28,273.7s-13.755,6.904-14.959,9.8577c-1.206,2.9537,41.489-4.475,64.947-21.055l-9.5148-5.6345-40.474,16.832z'/%3E %3Cpath d='m589.51,276.18s-25.054,9.3523-6.9504,9.7177c0,0,35.876-7.4685,54.988-22.076l-4.8274-7.1441-43.21,19.503z'/%3E %3Cpath d='m626.31,251.19s-26.452,13.545-23.475,15.071c2.9771,1.526,21.724-2.6714,31.534-8.7755,9.8117-6.1041,14.017-9.538,14.017-9.538l-11.738-3.243-10.338,6.4859z'/%3E %3Cpath d='m616.32,280.9s-9.4506,7.9112-8.3559,8.8118c1.0948,0.9018,20.419-2.1456,35.474-13.958l-1.9053-6.9743-25.407,11.748'/%3E %3Cpath d='m599.85,279.39s-9.0563,7.2202-7.0731,7.8093c1.9844,0.59027,9.6604,6.035,43.646-16.133l4.01-2.463-5.9955-8.4664-34.587,19.253z'/%3E %3Cpath d='m592.86,253.31c-28.581,9.9982-57.24,29.914-57.24,29.914,2.8017-0.9545,73.544-29.433,73.544-29.433'/%3E %3Cpath d='m655.57,297.93s-6.1308,9.3471-4.9053,10.492c1.2266,1.1442,8.7605,4.769,17.519-7.2495,8.7605-12.017-8.2344-10.111-8.2344-10.111l-4.3791,6.8677z'/%3E %3Cpath d='m648.65,289.83s-9.1979,11.541-7.2708,13.067c1.9282,1.526,12.44,1.3363,20.324-9.7289,7.8836-11.064,0.17425-0.57153,0.17425-0.57153l-2.2767-10.111-10.951,7.3444z'/%3E %3Cpath d='m639.8,284.39s-8.9348,10.683-8.059,12.399c0.87696,1.7181,12.965,1.1454,22.951-9.3471s1.927-14.307,1.927-14.307l-16.643,10.682'/%3E %3Cpath d='m623.95,284.87-5.6928,7.9165s1.5762,7.4392,21.197-6.1041c19.621-13.545,18.571-12.399,18.571-12.399l-10.513-1.9078-23.562,12.495z'/%3E %3Cpath d='m561.45,273.47-12.437,5.59s-2.8109,2.4641,4.4938,2.648c7.3046,0.18387,22.395-1.8352,48.649-16.722,11.871-6.7318,19.388-13.148,19.388-13.148l-9.5641-3.5533-50.531,25.185z'/%3E %3Cpath d='m540.15,281.31s17.894-1.9453,25.005-6.6077c0,0-1.4536,2.1749,7.6944-1.3972l51.975-25.351-1.7322-3.3858s-56.616,24.248-60.898,25.598c-4.284,1.3515-22.043,11.144-22.043,11.144z'/%3E %3Cpath stroke-width='0.6431' d='m670.11,304.2s-1.7516,14.183,0.35079,14.707c2.1024,0.52586,8.0578-3.9386,10.511-12.606,2.4532-8.6678-9.6341-7.6161-9.6341-7.6161l-1.7516,4.9892'/%3E %3Cpath d='m679.4,310.24s-1.0512,10.396,0.3508,11.35c1.402,0.9545,4.9053,1.3363,9.109-6.8665,4.2049-8.2028,2.2778-5.1508,2.2778-5.1508l-9.4598-5.1508-2.2778,5.8184z'/%3E %3Cpath d='m682.02,292.21s-7.7082,16.787-3.3268,16.597c4.378-0.1909,10.336-12.782,11.21-15.643,0.87697-2.8623-7.8836-0.95333-7.8836-0.95333z'/%3E %3Cpath d='m681.35,292.06s-2.9003,18.501,1.2404,16.934c4.1395-1.567,6.4827-15.499,6.5584-18.514,0.0756-3.0169-7.7987,1.5799-7.7987,1.5799z'/%3E %3Cpath d='m687.63,293.93s-4.5545,14.307-0.17539,17.168c4.3803,2.8623,7.8836-14.116,8.059-17.931,0.17539-3.8156-7.8836,0.76243-7.8836,0.76243z'/%3E %3Cpath d='m669.67,289.22s-3.5056,13.163-0.87697,14.498c5.1426,2.6129,8.4659-9.1117,8.9348-13.545,0.52503-4.9599-8.0578-0.95332-8.0578-0.95332z'/%3E %3Cpath d='m637,262.07s-11.738,9.7289-10.338,11.255c1.4031,1.526,15.068-1.1442,21.199-5.3405,6.1319-4.1974,8.584-6.4871,8.584-6.4871l-10.511-6.4859-8.9336,7.0586z'/%3E %3Cpath d='m647.34,252.15s-7.5316,6.1041-6.1319,7.6301c1.402,1.5272,14.891-4.0054,17.343-6.6768,2.4532-2.6703,2.2778-5.5314,2.2778-5.5314l-13.489,4.5781z'/%3E %3Cpath d='m654.52,251s-9.6352,8.5846-7.1831,11.637c2.4532,3.052,16.644-10.492,18.57-12.208,1.927-1.7181-11.387,0.57153-11.387,0.57153z'/%3E %3Cpath d='m650.49,247.38-20.497,9.7289s-17.345,11.255-15.593,12.399c1.7516,1.1454,15.242-2.4794,24.877-7.2483,9.6352-4.769,20.323-12.781,20.323-12.781'/%3E %3Cpath d='m656.2,258.45s-22.18,19.068-18.85,20.976c3.3268,1.9066,15.367-3.3287,25.352-12.486'/%3E %3Cpath d='m659.84,263.77s-13.383,22.143-11.982,24.24c1.402,2.0987,10.511-4.9599,15.067-10.3,4.5556-5.3417,8.1369-13.231,8.1369-13.231'/%3E %3Cpath d='m666.23,266.6s-13.599,25.273-12.023,27.371c1.5774,2.0976,9.461,0.3818,14.192-9.538,4.7288-9.9209,4.323-16.319,4.323-16.319l-6.4919-1.5143z'/%3E %3Cpath d='m674.13,267.81s-15.113,31.192-12.134,34.244c2.9794,3.0521,19.713-23.656,20.48-27.429,1.347-6.6346-8.521-7.3877-8.521-7.3877'/%3E %3Cpath d='m642.26,247.19s-13.665,6.4859-10.862,7.821c2.8017,1.3351,15.592-4.3872,17.343-4.9599,1.7539-0.5727-6.4816-2.8612-6.4816-2.8612z'/%3E %3Cpath d='m644.36,249.29s-8.4086,6.6768-6.657,8.3938c1.7505,1.7169,14.541-5.1508,16.993-7.2495,2.4521-2.0987-10.336-1.1442-10.336-1.1442z'/%3E %3Cpath stroke-width='0.5817' d='m662,249.82s-11.491,15.452-7.9707,16.063c3.5228,0.60901,16.869-9.9631,17.053-11.792,0.18571-1.8305-9.0827-4.2701-9.0827-4.2701z'/%3E %3Cpath d='m667.13,253.29s-12.263,15.451-8.7605,16.406c3.5044,0.95333,3.8541-1.526,3.8541-1.526s9.6352-8.0119,10.336-10.111c0.70158-2.0987-5.0795-4.9599-5.0795-4.9599'/%3E %3Cpath d='m670.99,256.92s-8.9359,15.452-6.6581,16.406c2.2778,0.9545,5.9565-2.8612,9.6352-7.4404,3.6787-4.5769-2.9771-8.9653-2.9771-8.9653z'/%3E %3Cpath d='m673.26,263.98s-5.2561,9.7289-3.8541,12.781c1.4009,3.0521,6.4816-2.2885,8.9348-5.7223,2.4532-3.4339-5.0807-7.0586-5.0807-7.0586z'/%3E %3Cpath d='m675.47,290.98s-3.5044,13.163-0.87582,14.498c5.1415,2.6129,8.4648-9.1117,8.9348-13.545,0.52504-4.9599-8.059-0.95332-8.059-0.95332z'/%3E %3Cpath d='m699.54,273.18s-3.5044-1.1442-6.1319-1.1442c0,0-7.7082-6.1041-11.913-6.6768-4.2037-0.5727-0.61331-0.66756-0.61331-0.66756s-0.4379-10.016-1.6645-10.778c0,0-0.70042-10.302-7.182-11.064-6.4827-0.76359-21.024,0.57153-23.652-0.3818-2.6275-0.9545-10.68-4.3134-25.927-0.19089-15.604,4.2185-46.304,18.003-47.88,18.385-1.5774,0.3818,35.267-8.0834,45.602-12.663,0,0,10.336-0.76243,13.489-1.7158,0,0-11.736,5.7223-0.87583,3.243,10.862-2.4805,8.4086,0,8.4086,0s-1.0512,2.4794,5.0807,1.1442c6.133-1.3363,6.133,0,6.133,0s7.0077,2.4794,12.438-0.7636c0,0,2.8029,9.73,6.3073,11.064,0,0,4.1636,8.9149,12.923,10.632,0,0,4.1613,2.949,5.0371,3.5217l4.9489,1.6244,5.2962-4.1412'/%3E %3Cpath d='m627.71,246.81s-35.036,12.59-33.812,16.024c1.2266,3.4338,36.615-9.7289,42.221-13.354,5.608-3.6236-7.8836-2.8612-7.8836-2.8612'/%3E %3C/g%3E %3Cg fill='%23452c25' stroke='%23000' stroke-width='0.5481'%3E %3Cpath stroke-width='0.4948' d='m869.44,278.12,13.78,7.8187s3.3611,2.7874-4.018,1.1466c-7.3792-1.6408-23.115-7.0715-52.843-26.202-13.44-8.6502-17.682-8.4066-17.682-8.4066l18.734,0.50828,42.028,25.136z'/%3E %3Cpath stroke-width='0.4948' d='m873.99,274.72,13.78,7.8187s3.3612,2.7874-4.0192,1.1466c-7.378-1.6408-23.114-7.0715-52.842-26.202-13.44-8.6502-2.6275,7.1359-2.6275,7.1359l2.2778-10.38,43.43,20.481z'/%3E %3Cpath stroke-width='0.482' d='m896.91,282.25s-16.455-3.0579-22.446-7.4428c0,0,1.0524,1.8926-6.9951-1.772,0,0,3.1021,7.0551-19.551-8.3797-22.654-15.432-14.734-7.6758-14.734-7.6758l6.3371-1.635s34.78,13.896,38.594,15.349c3.8151,1.4534,18.796,11.556,18.796,11.556z'/%3E %3Cpath d='m810.88,288.41,5.5129,7.862s-1.8331,7.3701-20.97-6.9708c-19.137-14.34-18.128-13.153-18.128-13.153l10.57-1.4745,23.21,13.172'/%3E %3Cpath d='m786.02,292.35s8.889,11.628,6.9092,13.075c-1.9786,1.4452-12.475,0.82333-19.97-10.557-7.4949-11.38-0.1571-0.57972-0.1571-0.57972l0.6959-18.399,12.716,15.896'/%3E %3Cpath d='m795.15,287s8.5576,11.042,7.6222,12.721c-0.9331,1.6806-12.995,0.61252-22.61-10.283-9.6145-10.894-1.4295-14.376-1.4295-14.376l16.262,11.359'/%3E %3Cpath d='m843.91,280.48s24.388,10.49,6.3005,9.8038c0,0-35.431-9.5426-53.762-25.243l5.1839-6.8548,41.995,21.683'/%3E %3Cpath d='m856.71,277.45s13.2,8.0084,14.182,11.052c0.9836,3.0439-41.019-7.8456-63.178-26.296l9.8966-4.8451,39.1,20.089z'/%3E %3Cpath d='m818.37,284.71s9.5458,7.8374,8.4625,8.7474c-1.0822,0.90999-20.443-1.9863-35.64-13.683l1.8192-6.9883,25.547,11.549'/%3E %3Cpath d='m834.7,284.04s9.4162,6.4953,7.4651,7.1792c-1.9534,0.68279-9.3406,6.4883-44.394-14.043l-4.1304-2.2697,5.5645-8.7427,35.513,17.305'/%3E %3Cpath d='m798.72,264.81s11.393,10.204,9.9402,11.672c-1.4548,1.4675-15.017-1.7626-20.998-6.2084-5.9806-4.4457-10.337-10.143-10.337-10.143l12.712-2.7405,8.6825,7.4205z'/%3E %3Cpath d='m785.14,247.77,20.757,12.372s16.94,11.959,15.152,13.03c-1.7918,1.0716-15.144-3.1036-24.608-8.2661-9.4633-5.1613-20.441-16.277-20.441-16.277'/%3E %3Cpath d='m772.04,306.29s3.8656,9.894,1.5556,10.754c-2.3099,0.8608-8.0337-0.9018-12.632-9.8729-4.598-8.97,2.428-4.2911,2.428-4.2911l8.6482,3.4104z'/%3E %3Cpath d='m778.92,299.89s5.8029,9.5918,4.5385,10.686c-1.2656,1.0939-8.9188,4.4059-17.257-7.9639-8.3364-12.369,8.5794-9.7652,8.5794-9.7652l4.1395,7.0434z'/%3E %3Cpath d='m761.58,256.61s19.799,38.228,18.152,40.26c-1.6496,2.0331-9.4678-0.007-13.849-10.113-4.3837-10.108-7.9661-23.23-7.9661-23.23l3.6638-6.9169z'/%3E %3Cpath d='m784.64,266.33s16.519,14.042,13.127,15.811c-3.3932,1.7708-9.9642-0.79054-19.627-10.351-9.6616-9.5602,6.344-6.0385,6.344-6.0385'/%3E %3Cpath d='m776.64,266.57s11.808,21.682,10.334,23.722c-1.473,2.039-10.332-5.3885-14.699-10.914-4.3665-5.5244-7.6714-13.555-7.6714-13.555'/%3E %3Cpath d='m764.94,258.27s8.3926,15.808,6.0849,16.668c-2.3076,0.85963-5.8533-3.1048-9.3704-7.8304-3.5193-4.7268,3.2855-8.8376,3.2855-8.8376z'/%3E %3Cpath d='m765.13,290.6s3.0447,13.297,0.3725,14.524c-5.2297,2.3997-8.1438-9.4525-8.459-13.902-0.3542-4.9774,8.0865-0.62189,8.0865-0.62189z'/%3E %3Cpath d='m754.67,311.68s0.7073,9.9561-0.7268,10.852c-1.433,0.89477-4.9477,1.1325-8.8649-7.2378-3.9183-8.3691-2.0967-5.2398-2.0967-5.2398l9.6307-4.7584,2.0909,5.4319'/%3E %3Cpath d='m764.03,309.58s1.394,10.366-0.7211,10.661c-2.1139,0.29513-7.9535-3.1903-10.187-9.5825-2.232-6.391,9.8209-5.132,9.8209-5.132l1.6244,3.6938'/%3E %3Cpath d='m754.39,277.06s10.825,24.22,9.0826,27.669c-3.4093,6.7518-13.243-14.753-16.213-23.145-3.321-9.3892,7.1304-4.5242,7.1304-4.5242z'/%3E %3Cpath d='m749.37,281.11s14.756,26.657,8.5313,27.278c-6.2213,0.62072-17.536-19.334-19.433-23.971-1.8984-4.639,10.902-3.3062,10.902-3.3062z'/%3E %3Cpath d='m748.49,286.64s7.26,25.548,2.5828,23.289c-4.6772-2.2592-10.309-21.501-11.077-25.654-0.76807-4.1541,8.4946,2.3658,8.4946,2.3658z'/%3E %3Cpath d='m773.99,250.32s11.192,17.097,7.5626,17.604c-3.6305,0.50711-16.902-11.422-17.025-13.398-0.1204-1.9746,9.4621-4.2056,9.4621-4.2056z'/%3E %3Cpath d='m767,251.04s14.271,19.479,9.9665,20.468c-4.3046,0.98846-4.6267-2.0566-4.6267-2.0566s-11.388-10.264-12.152-12.861c-0.7646-2.5976,6.3922-5.802,6.3922-5.802'/%3E %3Cpath d='m793.99,249.73s13.431,7.0434,10.582,8.2614c-2.8464,1.2204-15.429-5.0243-17.16-5.6684-1.7298-0.64415,6.5779-2.593,6.5779-2.593z'/%3E %3Cpath d='m781.14,251.34s9.814,10.124,7.2381,13.549c-2.5736,3.4268-16.206-12.817-18.062-14.881-1.856-2.0659,11.889,0.93459,11.889,0.93459'/%3E %3Cpath d='m757.34,265.4s15.802,30.784,12.892,33.913c-2.9083,3.1305-20.472-23.08-21.084-26.881-0.6098-3.8004,8.3536-7.6091,8.3536-7.6091'/%3E %3Cpath stroke-width='0.6396' d='m748.26,268.19s6.321,9.6317,5.9622,14.822c-0.3577,5.1871-9.555-7.4275-10.347-9.8026-0.79443-2.3763,4.3849-5.0196,4.3849-5.0196z'/%3E %3Cpath d='m761.25,263.2s4.9156,9.9385,3.4082,12.931c-1.5052,2.9912-8.2023-6.0374-10.534-9.5696-2.3329-3.5322,7.1258-3.3612,7.1258-3.3612z'/%3E %3Cpath stroke-width='0.6581' d='m738.45,272.97s7.7128,8.5565,7.3425,13.118c-0.3703,4.5617-11.57-6.6546-12.552-8.7556-0.98015-2.0987,5.2091-4.3626,5.2091-4.3626z'/%3E %3Cpath d='m788.31,248.28s11.676,10.475,9.8645,12.118c-1.8113,1.6432-17.606-9.668-19.985-11.866-2.3776-2.1971,10.12-0.2518,10.12-0.2518z'/%3E %3Cpath d='m778.44,247.52,9.132,7.691s8.4831,5.6696,7.0307,7.1371c-1.4525,1.4675-14.741-4.6156-17.099-7.3842-2.3593-2.7698-2.0853-5.6216-2.0853-5.6216l3.0218-1.8223z'/%3E %3Cpath d='m808.53,249.94s34.577,14.02,33.232,17.401c-1.3447,3.3812-36.25-11.226-41.728-15.078-5.4762-3.8531,7.9776-2.5368,7.9776-2.5368'/%3E %3Cpath d='m809.78,254.39s25.965,14.621,22.936,16.024c-3.0287,1.4031-21.615-3.5615-31.206-10.064-9.5928-6.5035-13.677-10.107-13.677-10.107l11.842-2.7593,10.105,6.9064z'/%3E %3Cpath d='m745.86,272.16s4.9156,9.9385,3.4093,12.931c-1.5064,2.9923-6.3979-2.5543-8.7296-6.0854-2.334-3.5334,5.3203-6.8455,5.3203-6.8455z'/%3E %3Cpath d='m747.03,294.57s4.0559,14.484-0.4196,17.163c-4.4754,2.6796-7.3883-14.43-7.4307-18.249-0.0436-3.8203,7.8503,1.0857,7.8503,1.0857z'/%3E %3Cpath d='m726.92,270.71s14.437-6.3384,16.997-5.8312c0,0,3.0286-0.76126,4.6576-2.0285,1.6302-1.2672,5.3559-4.3099,5.3559-4.3099s-2.561-17.495,15.834-15.719c18.396,1.7743,42.61,4.0569,47.501,4.817,4.8892,0.76008,22.818,5.8312,27.01,7.8597,4.1911,2.0285,31.501,14.39,37.09,16.419,3.3096,1.2004,10.611,5.7656,16.015,9.2908,3.7222,2.4267-0.1147,0.68982-0.1147,0.68982s-44.229-23.48-59.863-26.619c-3.9126-0.78585,0.2682,4.4797,0.2682,4.4797s-10.16-4.0066-14.351-5.7809c-4.1923-1.7743-7.6841-2.5356-11.642-2.2826-3.9584,0.25415-6.9848-0.50594-9.3131-1.2672-2.3294-0.76008-15.601-1.2672-17.929-1.5213-2.3283-0.25298-4.1912-0.76009-4.1912-0.76009l0.9309,1.5214-6.5194-1.0142-1.8628,2.7886s-6.2867,1.2672-6.7533-0.76126c-0.4643-2.0273-3.7257,9.1281-5.3558,12.424-1.6301,3.2968-7.6841,3.2957-9.5469,5.3253-1.8617,2.0285-3.0265,3.2957-3.9562,3.8028-0.9319,0.50712-5.5885,3.2957-7.2198,3.2957-1.6301,0-11.64,0.76126-11.64,0.76126l-2.5621-4.0569,1.1636-1.5213z'/%3E %3Cpath d='m745.91,311.7s0.2579,12.801-0.4757,13.725c-0.7348,0.92522-7.2107,0.65937-7.2313-8.8868-0.0195-9.5462,1.7436-9.8554,1.7436-9.8554l6.1491,4.6425'/%3E %3Cpath d='m742.56,296.15s4.0559,14.485-0.41956,17.163c-4.4743,2.6796-7.3872-14.43-7.4308-18.249-0.0447-3.8204,7.8503,1.0857,7.8503,1.0857z'/%3E %3Cpath d='m739.24,298.29s4.0558,14.485-0.41957,17.163c-4.4754,2.6796-7.3883-14.43-7.4319-18.249-0.0435-3.8203,7.8515,1.0857,7.8515,1.0857z'/%3E %3C/g%3E %3Cg fill='%23d9c0b9' stroke-width='0.5481' stroke='%23000'%3E %3Cpath d='m741.9,357.31s2.4865,3.0942,2.1781,4.1002c0,0,2.5576-2.5789-0.73483-6.24l-1.4433,2.1397z'/%3E %3Cpath d='m721.32,351.43,1.4926,0,0.56746,1.3925-0.21208,1.2895-1.2885,0.5926s-2.1231-0.54107-1.6015,1.9863c0,0-0.99619-4.6425,1.042-5.2609z'/%3E %3Cpath d='m731.86,361.82,1.5407-1.7017,1.6565,0.87604s-0.68667,4.4879-0.94691,4.8229c-0.26022,0.33495-0.30836,0.38647-0.30836,0.51531,0,0.12882-0.26137-0.85027-0.75775-1.4183-0.49637-0.56684-1.018-3.0427-1.1842-3.0942z'/%3E %3Cpath d='m715.75,356.23-0.75889-2.2674,0.8827-1.1934,1.7826-0.0199,0.75662,0.35603s1.4352,3.2734,0.17997,4.9892c0,0-0.53077-1.8469-1.1395-2.1011,0,0-1.3286-0.20847-1.7035,0.23657z'/%3E %3Cpath d='m699.07,360.14s-2.5117,4.1951,0.74628,6.295c0,0-0.20176-3.914,2.3524-4.7549l-3.0986-1.5401z'/%3E %3Cpath d='m690.43,358.44,2.2709-0.58675,0.21781,0.089s-1.4891,2.8764-1.0845,3.5732c0.40582,0.69685-2.0302-1.2625-1.4043-3.0755z'/%3E %3C/g%3E %3Cpath fill='%23bd8759' stroke='%23000' stroke-width='0.5481' d='m730.39,333.74s0.0808,7.7976,0.0808,9.1831c0,1.3867-0.16048,3.4655-0.95606,4.6776-0.79443,1.2133-1.5912,1.9066-2.8636,1.9066-1.2736,0-4.6141-0.17333-5.2504,1.0388-0.63624,1.2133-1.1154,1.9066-1.1154,1.9066s2.0692-1.2133,2.3867,0c0.31869,1.2122-0.79443,2.2522-0.79443,2.2522s1.9098,0.34667,3.658-0.69333c1.7505-1.0388,2.7054-1.2122,3.5022-1.2122,0.79672,0,1.433,0.86549,1.433,0.86549s0.47689,2.5988,0.31641,4.1588c-0.15934,1.5588-0.47689,4.6788,1.2736,4.6788,0,0,0.63508-1.56,1.2725-1.7333,0.63624-0.17333,2.3867,1.5588,2.0692,2.0788,0,0,0.31754-3.2921-0.3187-5.1976-0.63623-1.9055-0.95491-3.9855-0.95491-3.9855s5.4108,1.9067,5.8877,2.5988c0.47804,0.69333,1.7505,1.9066,2.2274,1.7333,0.47689-0.17333,0-1.7333,0.95378-2.0788,0.95608-0.34666,1.4329,0.51883,1.4329,0.51883s-1.5911-3.6376-3.9778-4.851c-2.3867-1.2122-3.9779-1.2133-4.9328-2.2522-0.95493-1.04-1.1154-2.2522-1.2725-3.4655-0.15935-1.2133,0.0424-11.687,0.0424-11.687l-4.1-0.44153z'/%3E %3Cpath fill='%23bd8759' stroke='%23000' stroke-width='0.5481' d='m703.37,353.57s-3.9618,3.0661-4.4089,4.5113c-0.44594,1.4452-0.57088,2.8366-0.57088,2.8366s3.5468-0.42864,3.1135,1.5272c0,0,1.151,0.66287,2.9806-3.5838,1.8273-4.2478,3.5572-6.0807,4.8537-5.9577,1.2966,0.12297,2.9484,1.3843,3.7807,2.2709,0.83456,0.88774,1.9821,1.5494,3.4265,1.1337,0,0-1.5166-2.3119-0.55942-2.8155,0.95722-0.50477,2.4154-0.40756,2.4154-0.40756s-1.2094-2.8787-3.8082-3.2945c-2.5988-0.41694-4.3986-1.1407-3.7819-2.2721,0.6179-1.1314,3.9424-9.9116,3.9424-9.9116l-4.4055-6.4695-1.7654,5.6286s0.57432,3.3273,0.59725,4.1799c0.023,0.85144-3.5033,8.1255-3.9779,8.5472-0.47344,0.42279-9.9195,4.0745-11.044,4.434-1.1211,0.36072-3.4724,3.1563-3.4724,3.1563l-0.26824,2.0987s1.5831-1.2941,2.0898-0.52468c0,0,1.0948-1.3832,2.0784-0.86432,0.98358,0.51883,0.82882,0.71558,0.82882,0.71558s1.7471-1.1512,2.0566-1.7158c0.30837-0.56685,0.39206-0.49541,0.39206-0.49541s1.5017-0.26862,2.7903-0.48646'/%3E %3Cg fill='none' stroke='%23000' stroke-width='0.5481'%3E %3Cpath d='m708.49,345.51c-0.41498,0.075-0.70502,0.0129-0.97557-0.17684'/%3E %3Cpath d='m710.01,341.66c-0.49294-0.0703-0.93658-0.22838-1.308-0.46378'/%3E %3Cpath d='m708.44,343.64c0.29348,0.1663,0.6328,0.23189,0.97557,0.17802'/%3E %3Cpath d='m705.2,349.67c0.188,0.13117,0.41039,0.21316,0.65344,0.23189'/%3E %3Cpath d='m732.38,346.04c0.64885,0.1136,1.2415,0.45909,1.9098,0.51999'/%3E %3Cpath d='m733.5,344.13c-0.51472,0.12766-0.95492,0.0258-1.2725-0.34667'/%3E %3Cpath d='m733.81,341.88c-0.59269,0.0738-1.2312,0.0398-1.7505-0.17333'/%3E %3Cpath d='m731.59,349.5c0.60528,0.082,1.1659,0.37946,1.7505,0.52'/%3E %3Cpath d='m731.75,351.93c0.29118-0.0679,0.56745-0.0141,0.79557,0.17333'/%3E %3Cpath d='m732.22,358.51c0.39664-0.0703,0.78296-0.0129,1.1131,0.17333'/%3E %3Cpath d='m712.33,350c-0.50097,0.0773-0.90106,0.3818-1.1086,0.87252'/%3E %3Cpath d='m715.57,350.31c-0.69813,0.40288-1.3183,0.96856-1.4089,1.779'/%3E %3Cpath d='m695.45,353.88c0.54339,0.49072,1.3412,0.78116,1.8113,1.2344'/%3E %3Cpath d='m738.11,351.24c-0.41154,0.18973-0.68667,0.56333-0.79443,1.04'/%3E %3Cpath d='m740.34,351.93c-0.28202,0.1136-0.45396,0.36071-0.47689,0.69333'/%3E %3C/g%3E %3Cpath fill='%23452c25' stroke='%23000' stroke-width='0.5492' d='m747.46,301.88s-1.2254-5.542-2.1024-6.3067c-0.87583-0.76477,0.3508-1.5284,0.3508-1.5284s-2.2767-5.5431-3.6787-6.4976c-1.402-0.95567,0.17425-1.7204,0.17425-1.7204s-2.4521-3.8227-4.2037-4.9681c-1.7516-1.1477,0-1.3386,0-1.3386s-1.8307-5.132-6.0998-7.4837c0,0-2.8304-2.9771-5.7169-3.7969-2.89-0.82099-10.049-1.5822-18.704-1.4241-9.1182,0.16631-12.984,6.4859-12.984,6.4859l-0.58234,7.3327,1.3137-0.89477-1.9282,9.1281c-0.30493,2.0882,1.6347,5.7165,1.7425,10.08,0.0333,1.3808,0.11922,2.826,0.27513,4.3064,0.41499,3.9152,1.3309,8.0728,3.1089,11.903,0.141,0.30216,0.27055,1.1899,0.44021,0.90179,0.44594-0.76594,1.4456,2.5848,2.3455,3.7864,0,0,0.53994,4.5558,0.97098,2.867,0.16736-0.65585,1.6301,2.5801,2.5335,4.6097,0.32785,0.739,2.0531,5.7539,1.9878,3.4702-0.0722-2.4981,1.5155,5.3218,1.5155,6.4438l2.1024-3.0579,1.0512,3.4409,1.7505-0.19207-0.52502,3.2488s4.9053-4.0124,5.0818-5.542c0.1731-1.5284,0.34965-2.6749,0.34965-2.6749l1.5762-1.5295,2.4532-3.8227s6.1331,4.7784,6.8323,6.4988c0.70042,1.7193,1.4032,3.2488,1.4032,3.2488l1.5762-1.5295,1.4009,3.4397,0.87697-1.7193,0.8506,2.388,0.0745-0.1464,0.56057,1.5752c0.42301,0.39702,1.4043,0.59729,3.2431-2.4794,2.6275-4.3954,2.4544-7.8351,2.6275-8.5999,0.17539-0.76477,1.2266,1.3375,1.2266,1.3375s2.2778-4.2045,1.927-6.8794c-0.35079-2.6761,1.4031-1.7204,1.4031-1.7204s0.3497-7.0715,0-8.7908c-0.3519-1.7204,1.2244-1.3375,1.2244-1.3375s-0.5251-8.409-1.0513-9.3646c-0.5261-0.95567,1.2255-1.1466,1.2255-1.1466z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m735.18,282.43c1.2358,0.37009,1.8399,1.765,2.3695,2.8471-0.0333-0.0668,0.078-0.38062,0.0137-0.51414-0.52961-1.0822-1.1452-2.4946-2.3833-2.8658,0.008,0.002-0.0826,0.50829,0,0.53288'/%3E %3Cpath d='m736.3,287.71c2.2847,1.9324,2.4807,4.5687,2.3535,7.4545-0.004,0.0867,0.0309,0.59729,0.0447,0.26936,0.13527-3.0532,0.0985-6.1451-2.3982-8.2567,0.0573,0.0492-0.10431,0.44387,0,0.53288'/%3E %3Cpath d='m741.05,290.41c1.2576,2.0694,1.3756,4.3509,1.3779,6.7412,0,0.30333,0.0528,0.30333,0.0528,0-0.0009-2.5391-0.0653-5.029-1.418-7.2554,0.0344,0.055-0.0884,0.39234-0.0126,0.51414'/%3E %3Cpath d='m742.71,300.4c-0.14215,1.478-0.40925,2.9302-0.69355,4.386-0.0207,0.10424,0.0183,0.50712,0.0263,0.4591,0.29003-1.4815,0.55943-2.963,0.70387-4.4692,0.007-0.0668-0.0183-0.58441-0.0367-0.37594'/%3E %3Cpath d='m741.18,308.06c0.11923,0.96855,0.24303,1.9289,0.13986,2.9092-0.007,0.0679,0.0149,0.58442,0.0367,0.37595,0.13069-1.2321,0.0106-2.4384-0.13986-3.6611-0.0253-0.20964-0.0447,0.30684-0.0367,0.37594'/%3E %3Cpath d='m738.23,298.44c0,1.6361,0.0126,3.2699,0.14674,4.9013,0.0183,0.20847,0.0436-0.30684,0.0379-0.37711-0.1238-1.5061-0.13183-3.0134-0.13183-4.5242,0-0.30216-0.0528-0.30216-0.0528,0'/%3E %3Cpath d='m736.98,309.06c0.12725,1.553,0.13185,3.1094,0.13185,4.6671,0,0.30333,0.0528,0.30333,0.0528,0-0.00091-1.683-0.009-3.3659-0.14789-5.043-0.0183-0.20847-0.0424,0.30685-0.0367,0.37595'/%3E %3Cpath d='m743.99,307.71c0.67632,0.71441,1.0913,1.553,1.2449,2.5344,0.016,0.10306,0.034-0.0796,0.036-0.096,0.01-0.11946,0.01-0.24477-0.01-0.36423-0.1593-1.0049-0.58-1.875-1.2713-2.607,0.0631,0.0679-0.10208,0.42513,0,0.53288'/%3E %3Cpath d='m743.57,296.99c0.69469,0.5809,1.2599,1.286,1.8181,1.9992-0.065-0.0832,0.096-0.4099,0-0.53171-0.5582-0.71323-1.1222-1.4194-1.8181-2.0004,0.0585,0.048-0.10431,0.44505,0,0.53288'/%3E %3Cpath d='m737.81,305.01c-0.009,1.4604-0.13757,2.9057-0.40581,4.3403-0.0217,0.10423,0.0172,0.50711,0.0253,0.46027,0.29805-1.5858,0.42186-3.1867,0.43218-4.8006,0.004-0.30216-0.0493-0.30216-0.0516,0'/%3E %3Cpath d='m734.75,308.2c0.11922,1.3047,0.11922,2.6047,0,3.9082-0.005,0.0691,0.0195,0.58441,0.0367,0.37595,0.141-1.5553,0.141-3.1059,0-4.6601-0.0183-0.20847-0.0424,0.30684-0.0367,0.37594'/%3E %3Cpath d='m724.71,273.96c0.80132,0.13352,1.48,0.49541,2.1976,0.8655,0.0217,0.0106,0.32901,0.20144,0.38403,0.12297,0.0561-0.0785-0.21552-0.31973-0.23272-0.33613-0.43217-0.4263-0.95377-0.83035-1.4914-1.1079-0.91594-0.47198-1.8101-0.96387-2.8361-1.1349-0.20292-0.0328,0.55369,0.69099,0.60528,0.73315,0.36798,0.29514,0.89187,0.77766,1.3733,0.85729'/%3E %3Cpath d='m697.43,300.41c0.5193,0.99549,0.59954,2.1467,1.12,3.1422-0.0332-0.0644,0.0802-0.38414,0.0137-0.51414-0.5193-0.99549-0.59955-2.1468-1.1188-3.1422,0.0321,0.0632-0.0826,0.38415-0.0149,0.51415'/%3E %3Cpath d='m702.19,273.43c1.1727-0.41576,2.4142-0.4263,3.6351-0.57153,0.0573-0.007,0.0207-0.53522,0-0.53288-1.2197,0.14523-2.4612,0.15577-3.6351,0.57153-0.086,0.0305,0.0161,0.52702,0,0.53288'/%3E %3Cpath d='m709.18,272.86c1.1108-0.52585,2.2904-0.57036,3.4953-0.57036,0.039,0,0.039-0.53405,0-0.53405-1.2048,0.001-2.3844,0.0457-3.4953,0.57153-0.0951,0.0457,0.0298,0.51883,0,0.53288'/%3E %3Cpath d='m697.02,279.04c-0.14558,0.0258-0.15475,0.14405-0.16279,0.27522-0.008,0.11947-0.0117,0.24595,0.0106,0.36424,0.0161,0.10189,0.0332-0.0796,0.0355-0.096-0.008,0.0996,0.0528,0.001,0.11688-0.0106,0.0665-0.0118,0.0106-0.53406,0-0.53288'/%3E %3Cpath d='m696.29,297.87c0,0.98495,0.005,1.9687,0.15247,2.9431,0.0172,0.10307,0.0355-0.0796,0.0367-0.0949,0.007-0.12063,0.008-0.24477-0.0106-0.3654-0.12495-0.82333-0.12609-1.6513-0.12609-2.4829-0.0009-0.30216-0.0528-0.30216-0.0528,0'/%3E %3Cpath d='m730.99,279.29c0.49522,0.14171,0.80361,0.5036,0.97211,0.98963,0.007,0.0223,0.031-0.16279,0.031-0.18504,0.004-0.10072,0.0149-0.23072-0.0183-0.32793-0.16852-0.49306-0.48148-0.86432-0.98472-1.0096,0.007,0.002-0.0791,0.51063,0,0.53289'/%3E %3Cpath d='m731.55,287.85c0.77609,0.81396,1.3504,1.7591,1.6714,2.8471-0.0253-0.0867,0.0585-0.3654,0.0137-0.51414-0.32327-1.095-0.90563-2.0484-1.6852-2.8658,0.0631,0.0668-0.10207,0.42748,0,0.53288'/%3E %3Cpath d='m729.73,281.57c0.75775,0.65585,1.3997,1.423,2.0967,2.1421-0.0641-0.0656,0.10313-0.42748,0-0.53288-0.69699-0.71792-1.339-1.4862-2.0967-2.1421,0.0573,0.0515-0.1043,0.4427,0,0.53288'/%3E %3Cpath d='m731.82,295.82c0.22009,1.2824-0.0745,2.3775-0.55141,3.5123-0.0595,0.13936,0.0447,0.43918,0.0149,0.51414,0.60871-1.4522,0.83111-2.9279,0.56401-4.4856-0.008-0.0468-0.0458,0.35487-0.0275,0.4591'/%3E %3Cpath d='m733.77,300.24c0.1009,0.65936,0.11922,1.3094,0,1.9687-0.0207,0.11711-0.0161,0.24477-0.009,0.36423,0.00091,0.0164,0.0172,0.19675,0.0356,0.0949,0.16966-0.95333,0.14444-1.9336,0-2.8869-0.0149-0.10306-0.0344,0.0785-0.0356,0.0949-0.007,0.11946-0.009,0.2436,0.009,0.36423'/%3E %3Cpath d='m741.33,315.84c0.49866,1.786,0.53879,3.6107,0.53993,5.4553,0.0009,0.30333,0.0528,0.30333,0.0528,0-0.00091-2.0144-0.0332-4.0183-0.57892-5.9694,0.0253,0.089-0.0551,0.36423-0.0137,0.51414'/%3E %3Cpath d='m740.07,319.47c-0.41154,1.2602-0.82767,2.518-1.3986,3.7138-0.0642,0.13351,0.047,0.44504,0.0137,0.51297,0.57204-1.1946,0.98588-2.4536,1.3974-3.7126,0.0493-0.14639-0.0402-0.43099-0.0126-0.51414'/%3E %3Cpath d='m697.86,307.42c1.1704,1.5248,1.8032,3.3495,2.7903,4.9892-0.0332-0.0562,0.086-0.39117,0.0137-0.51414-0.99046-1.6443-1.6278-3.4772-2.8029-5.0079,0.0653,0.0855-0.0963,0.40873-0.0009,0.53288'/%3E %3Cpath d='m705.27,307.6c-1.0673,0.14054-1.3286-1.3937-2.2366-1.7134,0.0149,0.005-0.086,0.50243,0,0.53171,0.90333,0.31973,1.1704,1.8551,2.2366,1.7146,0.0595-0.008,0.0161-0.53522,0-0.53288'/%3E %3Cpath d='m701.07,314.69c0.76692,1.3457,1.2713,2.8295,2.0967,4.1412-0.0333-0.0527,0.0894-0.39351,0.0149-0.51414-0.82653-1.3117-1.3309-2.7944-2.0978-4.1412,0.0333,0.0586-0.0848,0.38883-0.0137,0.51414'/%3E %3Cpath d='m705.97,316.42c0.86206,1.0365,1.6416,2.1268,2.0887,3.4186-0.0263-0.082,0.0653-0.36892,0.0149-0.51414-0.45167-1.2988-1.2381-2.3962-2.1036-3.4374,0.0653,0.0785-0.0985,0.41459,0,0.53288'/%3E %3Cpath d='m705.54,321.55c0.43447,0.89711,0.82309,1.8165,1.2587,2.7136-0.0321-0.0668,0.078-0.38062,0.0137-0.51414-0.43563-0.89711-0.82424-1.8165-1.2587-2.7136,0.0321,0.0691-0.078,0.3818-0.0137,0.51415'/%3E %3Cpath d='m710.15,322.55c0.25221,0.94162,0.39207,1.9078,0.40009,2.8846,0.004,0.30216,0.0549,0.30333,0.0528,0-0.0106-1.1501-0.14101-2.2873-0.43906-3.3987,0.023,0.0914-0.0549,0.36423-0.0137,0.51414'/%3E %3Cpath d='m708.19,326.81c0.30264,1.3562,0.69929,2.6843,1.4043,3.8836-0.0321-0.0574,0.086-0.39117,0.0149-0.51414-0.69469-1.1829-1.0936-2.4911-1.3917-3.8285-0.0137-0.0492-0.0505,0.35603-0.0275,0.4591'/%3E %3Cpath d='m709.32,308.71c1.1051,0.42279,2.2114,0.83972,3.3554,1.143-0.004-0.001,0.0768-0.51297,0-0.53288-1.1441-0.30333-2.2503-0.72026-3.3554-1.143,0.0195,0.008-0.0884,0.49891,0,0.53288'/%3E %3Cpath d='m710.16,313.42c1.3183,0.73432,2.7077,1.3199,4.0535,1.9992-0.0332-0.0164,0.0975-0.48369,0-0.5317-1.3458-0.67928-2.7352-1.266-4.0535-2.0004,0.0402,0.0222-0.0997,0.47667,0,0.53289'/%3E %3Cpath d='m711.42,318.7c0.68209,0.82802,1.4249,1.5881,2.2366,2.285-0.0595-0.0504,0.10431-0.4427,0-0.53288-0.81163-0.69685-1.5545-1.4558-2.2366-2.285,0.0653,0.0796-0.0974,0.4146,0,0.53288'/%3E %3Cpath d='m712.81,325.26c0.56745,0.90648,0.83456,1.9125,0.97327,2.9724,0.0137,0.10307,0.0344-0.0808,0.0356-0.096,0.007-0.12063,0.007-0.24361-0.0106-0.36424-0.14101-1.0751-0.40582-2.1034-0.98359-3.0263,0.0321,0.0539-0.0894,0.39351-0.0149,0.51414'/%3E %3Cpath d='m716.72,308.95c0.12496,0.63243,0.27283,1.2578,0.42531,1.8832-0.0229-0.0925,0.0516-0.36189,0.0149-0.51297-0.14902-0.60784-0.29232-1.2157-0.41384-1.8294-0.0195-0.1019-0.0333,0.0773-0.0344,0.0949-0.008,0.11946-0.0149,0.24829,0.008,0.36423'/%3E %3Cpath d='m726.51,305.04c-0.27512,0.6945-0.60413,1.3562-0.979,1.9992-0.0722,0.12414,0.047,0.45675,0.0137,0.51414,0.37487-0.64414,0.70388-1.3047,0.97786-1.9992,0.0585-0.14171-0.0436-0.43802-0.0126-0.51414'/%3E %3Cpath d='m730.54,304.87c0,1.1232-0.0183,2.2404-0.26596,3.3425-0.0241,0.10307,0.0149,0.50712,0.0253,0.4591,0.28201-1.2473,0.29232-2.5262,0.29348-3.8004,0-0.30333-0.0528-0.30333-0.0528-0.001'/%3E %3Cpath d='m731.39,311.06c0.10207,0.96387-0.004,1.9125-0.13411,2.867-0.0149,0.10541,0.0217,0.5036,0.0263,0.45909,0.16852-1.2321,0.27513-2.4606,0.14444-3.702-0.0218-0.20847-0.0436,0.30685-0.0367,0.37594'/%3E %3Cpath d='m734.47,316.92c-0.18228,1.3258-0.98244,2.3857-1.9431,3.2488-0.1043,0.0925,0.0595,0.47901,0,0.53288,0.98358-0.88423,1.7826-1.9664,1.9694-3.3226,0.0161-0.10541-0.0207-0.5036-0.0263-0.4591'/%3E %3Cpath d='m724.55,311.18c-0.27857,0.55513-0.63968,1.0552-0.979,1.5705-0.047,0.0714-0.0207,0.25063-0.0183,0.3291,0,0.0176,0.0149,0.21198,0.0298,0.18504,0.34046-0.51531,0.70042-1.0166,0.97899-1.5705,0.0424-0.0831,0.0207-0.23892,0.0183-0.32793,0.0009-0.0188-0.0172-0.21081-0.0298-0.18621'/%3E %3Cpath d='m725.68,319.03c-0.41842,0.56919-0.84257,1.1325-1.3986,1.5705-0.10548,0.0831,0.0561,0.48955,0,0.53288,0.55483-0.43802,0.97899-1.0014,1.3986-1.5705,0.0436-0.0597,0.0253-0.19793,0.0253-0.26703,0-0.0293-0.0355-0.25297-0.0253-0.26586'/%3E %3Cpath d='m722.18,323.17c-1.3653-1.3515-2.0061-3.0848-1.3905-5.0466,0.0458-0.14756-0.0412-0.42864-0.0149-0.51297-0.68552,2.1831-0.23271,4.4727,1.4054,6.0924-0.0631-0.0621,0.10313-0.43099,0-0.53288'/%3E %3Cpath d='m717.56,318.81c0.10548,0.8081,0.0997,1.5916-0.13297,2.3693-0.0447,0.14873,0.039,0.42747,0.0137,0.51414,0.32442-1.0833,0.29117-2.2311,0.14673-3.3425-0.0149-0.10306-0.0344,0.0796-0.0355,0.0949-0.008,0.12063-0.007,0.2436,0.008,0.36423'/%3E %3Cpath d='m728.19,324.04c-0.29003,0.96855-0.81162,1.8176-1.2587,2.7136-0.0653,0.13234,0.047,0.44738,0.0149,0.51414,0.4471-0.89594,0.96983-1.7462,1.2576-2.7136,0.0447-0.14874-0.039-0.42748-0.0137-0.51414'/%3E %3Cpath d='m735.04,326.89c-0.59151,1.0412-1.2736,2.0214-1.958,2.9994-0.078,0.11243,0.047,0.4673,0.0149,0.51298,0.68552-0.97793,1.3653-1.957,1.9557-2.9982,0.0723-0.12648-0.047-0.45558-0.0126-0.51414'/%3E %3Cpath d='m738.38,330.49c-0.28544,1.8305-0.42874,3.6763-0.56859,5.522-0.007,0.0878,0.0217,0.5973,0.0458,0.26937,0.13413-1.7837,0.27399-3.5639,0.54912-5.3323,0.0183-0.10424-0.0195-0.5036-0.0263-0.4591'/%3E %3Cpath d='m742.71,324.08c0.0106,0.62189,0.12954,1.2356,0.13986,1.8563,0.005,0.3736,0.0528,0.0281,0.0493-0.14171-0.009-0.62189-0.12955-1.2356-0.13872-1.8563-0.005-0.3736-0.0528-0.0269-0.0504,0.14171'/%3E %3Cpath d='m696.73,303.93c-0.26023,1.8376-0.0344,3.592,0.56515,5.3429-0.0275-0.082,0.0642-0.36892,0.0137-0.51415-0.49296-1.4347-0.77495-2.7967-0.55256-4.3696,0.0149-0.10424-0.0218-0.50478-0.0263-0.4591'/%3E %3C/g%3E %3Cpath fill='%23dcddde' d='m697.1,285.19s-0.52504-5.3077,0.96295-5.8804c0,0,0.52617-4.865,7.0089-4.1975,0,0,2.1896-3.6248,5.6929-1.7169,0,0,3.329-1.6209,5.2561-0.66756,1.9282,0.9545,4.292,2.5754,4.4674,2.9572,0,0,2.8017-0.5727,4.1166,0.47667s0.70158,4.4832,0.70158,4.4832,3.1525,2.4138,3.415,4.5453c0.26252,2.1315,0.26252,2.99-0.43905,3.5615,0,0,1.402,1.1454,1.1395,2.7663-0.26367,1.6221-1.5774,3.9738-1.8399,3.9738-0.26253,0,0.17539,4.2291-1.2255,5.6602-1.402,1.4312-2.7157,1.7169-3.3279,1.9078-0.61331,0.1909-2.1907,2.4794-3.6798,2.7663-1.4891,0.28576-3.5033-2.2896-3.6787-3.0532-0.17539-0.76243-2.1896-1.6209-2.1896-1.6209s-4.5557,4.865-7.6199,4.1014c-3.0665-0.76243-4.5557-3.339-4.817-3.8156-0.26367-0.47667-1.1395-4.0054-1.1395-4.0054s-3.4162-2.0039-3.1537-3.9105c0.26253-1.9078,1.6645-4.1975,1.6645-4.1975l-1.3149-4.1342z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m712.57,281.17c2.9519-2.7089,6.8507-5.5619,11.037-4.564,0,0,0.0735-0.51531,0-0.53288-4.1865-0.99783-8.0853,1.8551-11.037,4.564-0.1043,0.096,0.0607,0.47667,0,0.53288'/%3E %3Cpath d='m726.76,284.4c-2.9622-2.0144-8.1358-2.7511-11.037-0.26819-0.10548,0.089,0.0585,0.48251,0,0.53287,2.9014-2.4829,8.075-1.7462,11.037,0.2682-0.0493-0.034,0.10313-0.46378,0-0.53288'/%3E %3Cpath d='m715.46,288.95c1.2128,3.9293,2.7811,7.93,2.0956,12.131-0.0172,0.10541,0.0195,0.50594,0.0263,0.46027,0.74169-4.5523-0.78526-8.8177-2.1093-13.105,0.0275,0.0867-0.0585,0.36657-0.0126,0.51414'/%3E %3Cpath d='m710.72,291.34c0.72565,3.9749,0.26138,7.9897-0.009,11.985-0.006,0.0878,0.024,0.59729,0.0447,0.26937,0.2866-4.2373,0.76004-8.5003-0.009-12.713-0.008-0.0468-0.0458,0.35486-0.0263,0.4591'/%3E %3Cpath d='m717.04,288.42c3.861,0.91585,7.6371,3.4901,9.7155,6.9708-0.0332-0.0562,0.0872-0.39117,0.0149-0.51414-2.0841-3.4912-5.8556-6.0702-9.7292-6.9895-0.003,0.001-0.0756,0.51649-0.0009,0.53288'/%3E %3Cpath d='m713.6,293.79c0.0137,2.443,0.20405,4.8884-0.50669,7.26-0.0435,0.14874,0.04,0.42748,0.0137,0.51414,0.76118-2.5391,0.55943-5.1555,0.54682-7.7742-0.004-0.30216-0.0551-0.30333-0.0539,0'/%3E %3Cpath d='m719.67,293.25c2.4257,2.005,4.347,5.036,4.7116,8.2438,0.0241,0.20964,0.0447-0.30684,0.0355-0.37594-0.37142-3.2758-2.2629-6.3465-4.7482-8.4008,0.0573,0.048-0.10207,0.44622,0.00091,0.53288'/%3E %3Cpath d='m701.8,299.95c0.8036-1.1466,1.7998-2.4548,3.1468-2.9431,0.0872-0.0328-0.0172-0.52702,0-0.53405-1.3562,0.49306-2.3501,1.8083-3.1605,2.963-0.0791,0.11477,0.047,0.46729,0.0137,0.51414'/%3E %3Cpath d='m707.58,279.07c-0.51242-2.1831-2.1506-3.4713-3.9068-4.646,0.0424,0.0281-0.0928,0.41225,0,0.47433,1.7436,1.1665,3.3841,2.4559,3.8931,4.6296-0.0183-0.0831,0.0458-0.32207,0.0137-0.45792'/%3E %3Cpath d='m704.16,279.03c-2.0222-0.96036-4.1132-1.0728-6.3084-1.074-0.0379,0-0.0379,0.53288,0,0.53288,2.1953,0.002,4.2863,0.11361,6.3084,1.074-0.0309-0.0152,0.094-0.48721,0-0.53288'/%3E %3Cpath d='m710.48,278.69c0.26711-2.0976-0.0435-4.0792-1.8514-5.3733,0.0447,0.0328-0.0906,0.40171,0,0.46612,1.5178,1.0868,2.0726,2.5988,1.8285,4.5043-0.0126,0.0925,0.0172,0.44036,0.023,0.40288'/%3E %3Cpath d='m718.09,281.17c1.9007-1.0095,3.971-0.82098,6.0436-0.80576,0.0379,0,0.0412-0.53171,0-0.53171-2.0738-0.0164-4.143-0.20495-6.0436,0.80459-0.0985,0.0527,0.0379,0.51297,0,0.53288'/%3E %3Cpath d='m721.51,286.27c2.9324,0.31036,5.1678,1.8165,7.0948,4.0276-0.12953-0.14874,0.19948-0.83855,0-1.0658-1.9282-2.21-4.1636-3.7173-7.0948-4.0276-0.0436-0.005-0.11124,1.054,0,1.0658'/%3E %3Cpath d='m708.62,294.35c-0.69354,2.8038-0.16277,6.3489-3.4036,7.4978-0.17195,0.0609,0.0321,1.054,0,1.0658,3.282-1.163,2.7318-4.7069,3.4299-7.5364,0.0756-0.30334-0.0722-0.84324-0.0263-1.0271'/%3E %3Cpath d='m715.45,292.16c1.1246,2.9478,2.694,5.9566,2.0887,9.2288-0.0379,0.20847,0.0355,1.0131,0.0528,0.91937,0.74283-4.0312-0.70159-7.4744-2.115-11.175,0.0595,0.15577-0.13642,0.74252-0.0263,1.0271'/%3E %3Cpath d='m719.67,291.64c2.859,0.36423,5.3753,2.9092,5.7548,5.8336,0.0275,0.20613,0.0711-0.16045,0.0722-0.1909,0.0126-0.24243,0.0118-0.48838-0.0207-0.72964-0.38633-2.9759-2.8762-5.6052-5.8064-5.9788-0.0367-0.005-0.11808,1.0517,0,1.0658'/%3E %3Cpath d='m719.64,295.86c0.44823,2.4489,1.1418,4.9002,0.27399,7.3491-0.10207,0.28811,0.086,0.86549,0.0275,1.0271,1.081-3.0544,0.31296-6.2165-0.24991-9.2967-0.0172-0.0925-0.0894,0.7109-0.0516,0.92054'/%3E %3Cpath d='m718.09,285.2c3.1456-0.53171,6.4747-1.006,9.1973,1.074-0.10771-0.0832,0.20865-0.90648,0-1.0658-2.7226-2.0788-6.0516-1.6057-9.1973-1.074-0.12838,0.0222-0.0218,1.0693,0,1.0658'/%3E %3Cpath d='m712.33,278.95c0.37716-2.6012,2.6676-4.4598,4.9672-5.2972,0.17424-0.0632-0.0356-1.0517,0-1.0646-2.373,0.86315-4.6325,2.7757-5.02,5.4412-0.0355,0.24009-0.0321,0.48838-0.0195,0.72964,0.003,0.0328,0.0424,0.39703,0.0723,0.1909'/%3E %3Cpath d='m709.46,280.51c-0.0768-2.8834-1.3401-5.2046-2.5828-7.7262,0.0573,0.11712-0.14101,0.67459-0.0253,0.90999,1.1143,2.2568,2.4509,4.4633,2.5186,7.0668,0.0183,0.66288,0.0975,0.0515,0.0894-0.25063'/%3E %3Cpath d='m706.82,282.06c-0.56057-2.5672-2.2549-4.2689-4.4938-5.4424,0.0722,0.0386-0.19602,0.96269,0,1.0658,2.1632,1.1325,3.8942,2.7991,4.441,5.2972,0.023,0.096,0.0975-0.71324,0.0528-0.92054'/%3E %3Cpath d='m702.58,281.03c-1.4685-1.0224-3.0115-1.9851-4.7975-2.2592-0.024-0.004-0.0974,0.8163,0,0.83036,1.786,0.27405,3.3279,1.2356,4.7975,2.2592-0.078-0.055,0.1628-0.71792,0-0.83035'/%3E %3Cpath d='m711.75,293.09c0.2522,2.7276,0.59153,5.4822-0.76577,7.9698-0.13871,0.25415,0.0951,0.90531,0.0275,1.0271,1.6255-2.9818,1.112-6.5058,0.81162-9.75-0.0379-0.41811-0.086,0.61486-0.0734,0.75305'/%3E %3Cpath d='m714.92,291.62c0.91136,2.5648,1.9878,5.2937,1.8078,8.0764-0.0106,0.17568,0.0482,1.1946,0.0906,0.53874,0.21896-3.3905-0.74858-6.4883-1.8709-9.6422,0.0573,0.16046-0.12954,0.73784-0.0275,1.0271'/%3E %3Cpath d='m717.04,287.88c2.608,0.80107,5.1965,1.6548,7.0937,3.7583-0.12839-0.14289,0.20176-0.84324,0-1.0646-1.8972-2.1046-4.4857-2.9584-7.0937-3.7594,0.0195,0.006-0.16393,1.0154,0,1.0658'/%3E %3Cpath d='m709.98,282.09c0.27627-2.2697,0.5193-4.5312,0.54109-6.8197,0.005-0.60667-0.0985-0.60549-0.1043,0-0.0195,2.0343-0.26481,4.0511-0.51128,6.0666-0.0161,0.1382,0.0241,1.17,0.0745,0.75306'/%3E %3Cpath d='m705.21,280.64c-1.9259-0.87603-3.6374-2.1257-5.2561-3.4889,0.11582,0.0972-0.20978,0.88892,0,1.0658,1.6187,1.3644,3.3302,2.614,5.2561,3.4901-0.0585-0.0269,0.18686-0.98144,0-1.0669'/%3E %3Cpath d='m704.42,294.33c-1.2369,0.78233-2.0887,1.8739-2.6412,3.2406-0.0745,0.18504-0.0424,0.46261-0.0367,0.65585,0.0009,0.041,0.0458,0.41811,0.0653,0.37126,0.54568-1.3515,1.3928-2.4302,2.6126-3.202,0.20634-0.13-0.0917-1.0084,0-1.0658'/%3E %3Cpath d='m707.79,296.33c-0.0482,1.8692-1.0776,3.4175-2.3157,4.7092-0.20404,0.21316,0.12611,0.93342,0,1.0658,1.4926-1.5576,2.3592-3.2945,2.4154-5.4916,0.009-0.33964-0.0802-1.0306-0.0997-0.28342'/%3E %3Cpath d='m716.61,281.63c1.551-2.4501,5.2996-2.6539,7.8033-3.3378,0.15706-0.0422-0.009-1.0622,0-1.0646-2.5358,0.69216-6.2626,0.89711-7.8308,3.3753-0.15133,0.23892,0.094,0.92288,0.0275,1.0271'/%3E %3Cpath d='m699.38,281.59c-0.60069-0.18036-1.151-0.48837-1.6978-0.79522,0.0482,0.0269-0.12381,0.58793,0,0.6582,0.54796,0.30684,1.0971,0.61603,1.6978,0.79639-0.0106-0.004,0.0997-0.62892,0-0.65937'/%3E %3Cpath d='m699.72,294.13c-0.54108,0.22135-1.0994,0.44739-1.4731,0.9264-0.0882,0.11243-0.0516,0.40053-0.0516,0.53288,0,0.12531,0.003,0.2518,0.0149,0.37594-0.003-0.0176,0.0252,0.16982,0.0367,0.15577,0.37372-0.47784,0.932-0.70505,1.4731-0.92523,0.0826-0.034,0.0516-0.46729,0.0516-0.53287,0-0.0269-0.0241-0.5446-0.0516-0.53289'/%3E %3Cpath d='m701.98,294.71c-1.112,0.49774-1.9213,1.4604-2.6171,2.4454-0.12267,0.17685,0.0734,0.73432,0.0229,0.80694,0.68896-0.97441,1.496-1.9242,2.5954-2.415,0.14559-0.0668-0.0447-0.81747-0.0009-0.83738'/%3E %3Cpath d='m706.27,295.77c-0.97098,2.3658-3.6168,4.9798-1.6978,7.6254-0.0665-0.089,0.188-0.80693,0.0263-1.0271-1.3275-1.8329,1.0111-3.893,1.6989-5.5712,0.11464-0.27991-0.0894-0.87721-0.0275-1.0271'/%3E %3Cpath d='m709.3,295.73c0.0735,2.4114-0.35193,4.7912-0.77036,7.1535-0.0356,0.20964,0.0355,1.0119,0.0539,0.92054,0.49065-2.771,0.90219-5.5338,0.81736-8.3574-0.024-0.74603-0.11124-0.0562-0.1009,0.28343'/%3E %3Cpath d='m717.05,292.88c1.7574,2.3013,3.313,4.7772,4.0639,7.6208-0.047-0.18036,0.10771-0.72612,0.0275-1.0271-0.75545-2.86-2.3248-5.3452-4.0914-7.6594,0.12954,0.17099-0.19029,0.8163,0,1.0658'/%3E %3Cpath d='m717.96,291.03c2.89,2.2018,6.1078,4.2724,8.1438,7.3889-0.0677-0.10072,0.17998-0.79288,0.0264-1.0271-2.0463-3.1329-5.2664-5.214-8.1713-7.4275,0.10888,0.0832-0.20634,0.90765,0.0009,1.0658'/%3E %3Cpath d='m719.66,287.22c1.0776-0.10423,2.0784-0.0632,3.1021,0.31388,0.91594,0.33846,1.6748,1.095,2.5082,1.5975,0.84028,0.50594,1.6886,0.96504,2.3741,1.6876,0.8976,0.94396,0.90563,2.5531,1.1704,3.7676,0.0172,0.082,0.0814-0.60783,0.0447-0.78468-0.21553-0.99666-0.32901-2.005-0.66948-2.9689-0.33015-0.94162-1.1441-1.5202-1.9385-2.0273-0.95034-0.60783-1.8835-1.2239-2.8258-1.8434-1.1188-0.73549-2.4865-0.77531-3.7658-0.65117-0.0929,0.009-0.0412,0.91234,0,0.90882'/%3E %3Cpath d='m726.73,293.14c0.31754,0.93342,0.6924,1.8458,1.0122,2.778-0.0367-0.10658,0.0814-0.47901,0.0183-0.66757-0.3187-0.93342-0.6924-1.8458-1.0122-2.778,0.0367,0.10775-0.0826,0.48018-0.0183,0.66756'/%3E %3Cpath d='m718.64,278.41c2.036-0.55982,4.1177-0.92991,6.1182-1.6209,0.17081-0.0586-0.0286-1.0552,0-1.0646-2.0004,0.68982-4.0822,1.0599-6.1182,1.6197-0.1559,0.0433,0.0106,1.0634,0,1.0658'/%3E %3Cpath d='m710.15,279.43c0.28545-1.0798,0.74629-1.9594,1.3619-2.8799,0.75776-1.1314,0.86437-2.5496,1.7952-3.5838,0.20061-0.22252-0.12725-0.9217,0-1.0646-0.76691,0.85027-1.0329,1.9441-1.4742,2.983-0.52734,1.2461-1.355,2.1667-1.7104,3.5182-0.0802,0.30099,0.0756,0.84675,0.0275,1.0271'/%3E %3Cpath d='m703.2,298.49c-0.36225,1.7532-0.29462,3.5826,0.35193,5.2562-0.0595-0.1546,0.13757-0.74252,0.0275-1.0271-0.42301-1.0986-0.5686-2.1362-0.32671-3.3086,0.0482-0.23189,0.0309-0.49423,0.0183-0.72963-0.003-0.0363-0.0298-0.39234-0.0711-0.1909'/%3E %3Cpath d='m707.42,301.8c-0.7291,0.99314-0.73941,2.5063-0.35423,3.647,0.0149,0.0386,0.0607-0.30802,0.0619-0.35018,0.005-0.1909,0.0264-0.43216-0.0344-0.61604-0.21552-0.63711-0.0561-1.1583,0.32671-1.6783,0.0814-0.11126,0.0493-0.3736,0.0493-0.50126,0-0.0562-0.0699-0.47549-0.0493-0.50125'/%3E %3Cpath d='m710.56,300.12c-0.0332,1.0096-0.57203,1.9687-0.99389,2.8565-0.0906,0.19442,0.0677,0.64297,0.0217,0.74135,0.52274-1.1021,1.0042-2.1538,1.0455-3.394,0.008-0.24477-0.0539-0.74134-0.0734-0.20378'/%3E %3Cpath d='m710.65,294.2,0,1.2731c0,0.0375-0.008,0.53288,0.0516,0.53288,0.0619,0,0.0528-0.4954,0.0528-0.53288v-1.2731c0-0.0363,0.009-0.53288-0.0528-0.53288-0.0596,0-0.0516,0.49775-0.0516,0.53288'/%3E %3Cpath d='m709.22,294.94c0.0814,0.14991,0.14903,0.29981,0.20406,0.46378,0.0356,0.22486,0.0528,0.23657,0.0516,0.0351-0.0106,0.089-0.024,0.17684-0.0412,0.26351-0.0435,0.2354-0.0309,0.49189-0.0183,0.72964,0.0009,0.034,0.0321,0.39468,0.0711,0.1909,0.16049-0.87369,0.19718-1.9137-0.2396-2.7101-0.0263-0.0515-0.0631,0.33495-0.0642,0.37243-0.005,0.17099-0.0504,0.49657,0.0367,0.65468'/%3E %3Cpath d='m707.18,294.27c-0.21092,0.66171-0.35194,1.3351-0.46542,2.0214-0.039,0.23658-0.0333,0.48955-0.0183,0.72847,0.00091,0.0328,0.0367,0.39585,0.0711,0.1909,0.10771-0.64883,0.24073-1.2859,0.44135-1.9137,0.0631-0.1991,0.0402-0.44973,0.0356-0.65468-0.003-0.048-0.0516-0.41459-0.0642-0.37243'/%3E %3Cpath d='m705.61,294.36c-0.95263,1.1665-2.2228,1.9406-3.5125,2.662-0.19947,0.11243,0.0791,1.0213,0,1.0658,1.2897-0.72143,2.5598-1.4956,3.5125-2.662,0.0872-0.10892,0.0516-0.40406,0.0516-0.53288,0-0.0539-0.0688-0.51298-0.0516-0.53288'/%3E %3Cpath d='m702.89,294.82c-0.58121,0.46261-1.2312,0.79756-1.927,1.0412-0.17081,0.0609,0.0309,1.0552,0,1.0658,0.6947-0.2436,1.3458-0.57972,1.927-1.0412,0.0906-0.0726,0.0516-0.43568,0.0516-0.53288,0-0.0351-0.0482-0.53523-0.0516-0.53288'/%3E %3Cpath d='m699.04,293.88c-0.56172,0.24946-1.1372,0.46613-1.6989,0.71676-0.15018,0.0656,0.0436,0.83504,0,0.85495,0.56171-0.24946,1.1372-0.46613,1.6989-0.71676,0.15017-0.0668-0.0447-0.83504,0-0.85495'/%3E %3Cpath d='m710.77,293.41c0.0106,0.69685,0.11923,1.3738,0.25106,2.0554,0.039,0.20144,0.0699-0.15577,0.0722-0.19207,0.0126-0.23541,0.0253-0.49541-0.0183-0.72847-0.0917-0.46729-0.19718-0.94044-0.20406-1.4183-0.0009-0.0445-0.0493-0.41459-0.0642-0.37126-0.0688,0.19324-0.039,0.45441-0.0367,0.65468'/%3E %3Cpath d='m712.58,292.58c0.009,0.81513,0.0882,1.5998,0.37829,2.3658,0.0161,0.0445,0.0631-0.33027,0.0642-0.37244,0.006-0.19675,0.0344-0.46612-0.0367-0.65468-0.1605-0.42396-0.29692-0.87954-0.3015-1.3386,0-0.0363,0.008-0.53288-0.0528-0.53288-0.0595,0-0.0516,0.49658-0.0516,0.53288'/%3E %3Cpath d='m713.98,292.4c0.24304,0.34315,0.5193,0.81162,0.53077,1.2485,0.0009,0.0445,0.0482,0.41577,0.0631,0.37243,0.0711-0.19324,0.0412-0.45558,0.0367-0.65585-0.0172-0.73315-0.17539-1.3902-0.60184-1.9922-0.0367-0.0527-0.0642,0.33495-0.0653,0.37243-0.004,0.14991-0.0573,0.52234,0.0367,0.65468'/%3E %3Cpath d='m715.69,291.72c0.59841,0.13,1.1406,0.3736,1.5866,0.81045-0.007-0.007,0.0516-0.49072,0.0516-0.53288,0-0.11243,0.039-0.44388-0.0516-0.53288-0.44595-0.43685-0.98703-0.68045-1.5866-0.81045-0.008-0.002-0.14215,1.0353,0,1.0658'/%3E %3Cpath d='m716.6,290.33c0.70043,0.58441,1.4742,1.0212,2.3776,1.1571,0.0286,0.005,0.12495-1.0458,0-1.0658-0.90333-0.13586-1.6771-0.5727-2.3776-1.1571-0.00091-0.001-0.0528,0.49657-0.0528,0.53288,0,0.10072-0.039,0.45675,0.0528,0.53288'/%3E %3Cpath d='m718.52,285.7c0.61444,0.007,1.2117,0.10891,1.8124,0.23189,0.0126,0.002,0.13986-1.0376,0-1.0658-0.6007-0.12297-1.198-0.22486-1.8124-0.23189-0.0756-0.001-0.0826,1.0658,0,1.0658'/%3E %3Cpath d='m717.63,283.49c0.36798-0.60315,0.92283-1.047,1.4582-1.4862,0.0906-0.0738,0.0528-0.43216,0.0528-0.53171,0-0.0363-0.0516-0.53406-0.0528-0.53288-0.5491,0.44972-1.1085,0.90531-1.4868,1.5237-0.0906,0.14757-0.0412,0.49189-0.0367,0.65468,0.0009,0.0363,0.0333,0.42396,0.0653,0.37243'/%3E %3Cpath d='m715.94,281.35c0.10665-0.70504,0.33589-1.3293,0.76692-1.895,0.0872-0.11477,0.0528-0.39936,0.0528-0.53288,0-0.0574-0.0722-0.50828-0.0528-0.53288-0.46428,0.61018-0.70502,1.2801-0.81964,2.0402-0.0356,0.23892-0.0321,0.48838-0.0195,0.72964,0.004,0.0305,0.0412,0.39585,0.0722,0.1909'/%3E %3Cpath d='m714.57,280.36c0.69814-0.98261,1.1658-2.1081,1.8124-3.1247,0.0917-0.14406,0.0412-0.49658,0.0367-0.65586-0.00091-0.0363-0.031-0.42396-0.0653-0.37126-0.64541,1.0166-1.1143,2.1421-1.8124,3.1247-0.094,0.13234-0.0402,0.50477-0.0356,0.65468,0.00091,0.0363,0.0275,0.42397,0.0643,0.37244'/%3E %3Cpath d='m711.45,276.86c0.0263,1.1958,0.11007,2.3903,0.3634,3.5592,0.0447,0.20027,0.0698-0.15226,0.0722-0.1909,0.0149-0.23306,0.031-0.49892-0.0183-0.72847-0.21093-0.96387-0.29576-1.9371-0.3164-2.9232-0.0161-0.7472-0.10666-0.0562-0.1009,0.28343'/%3E %3Cpath d='m706.39,277.7c0.18342,0.43333,0.42301,0.83972,0.63853,1.2567,0.13526,0.26234,0.25678,0.52936,0.3634,0.80459,0.039,0.10423,0.0722,0.20964,0.10207,0.31738-0.0653-0.21666,0.047-0.15927-0.0848,0.0668-0.14444,0.24829,0.0951,0.91234,0.0286,1.0271,0.30723-0.52936,0.25908-1.3878,0.12037-1.9664-0.21781-0.91937-0.77839-1.6771-1.1418-2.5332,0.0631,0.14639-0.14446,0.74954-0.0264,1.0271'/%3E %3Cpath d='m705.38,279.78c-0.69242-0.69567-1.4777-1.2766-2.2652-1.8516-0.007-0.005-0.0528,0.50009-0.0528,0.53288,0,0.0914-0.0379,0.46613,0.0528,0.53171,0.78755,0.57622,1.5717,1.1571,2.2652,1.8528-0.008-0.008,0.0516-0.49071,0.0516-0.53287,0-0.11361,0.0402-0.44153-0.0516-0.53289'/%3E %3Cpath d='m708.69,280.89c0.46886-2.3376,0.37944-4.6776-0.57892-6.8771,0.0631,0.14405-0.14788,0.75188-0.0286,1.0271,0.69814,1.6022,0.90792,3.1727,0.55483,4.9294-0.047,0.23306-0.0321,0.49423-0.0195,0.72964,0.003,0.0351,0.0321,0.39351,0.0723,0.1909'/%3E %3Cpath d='m713.65,277.83c0.078,0,0.078-1.0658,0-1.0658s-0.078,1.0658,0,1.0658'/%3E %3Cpath d='m708.04,280.99c0.12266-1.3211,0.43447-2.6152,0.56631-3.9363,0.0379-0.37126,0.0355-0.75775,0-1.129-0.0253-0.27054-0.0826-0.26937-0.11123,0-0.13299,1.3199-0.4425,2.6129-0.56631,3.9351-0.0344,0.3736-0.0356,0.75774,0,1.1302,0.0263,0.2682,0.086,0.27054,0.11124,0'/%3E %3Cpath d='m722.38,289.21c1.1464,0.37595,2.2778,1.1536,2.8109,2.2861,0.0355,0.0738,0.0951-0.50009,0.0963-0.55865,0.008-0.27405,0.0677-0.72378-0.0539-0.98261-0.54682-1.1571-1.6806-1.9582-2.8533-2.3435,0.0379,0.0129-0.25106,1.5167,0,1.5986'/%3E %3Cpath d='m718.5,297.17c0.20521,0.68162,0.2224,1.3094,0.0951,2.0121-0.0642,0.35252-0.0482,0.73666-0.0286,1.0927,0.004,0.0515,0.0528,0.59261,0.10889,0.28693,0.28888-1.5928,0.33702-3.3718-0.13183-4.933-0.0183-0.0586-0.0951,0.48721-0.0975,0.55865-0.009,0.31036-0.0367,0.68045,0.0539,0.98261'/%3E %3Cpath d='m715.27,295.01c0.005,1.3222,0.078,2.6363-0.18801,3.9398-0.071,0.34784-0.0482,0.74135-0.0264,1.0939,0.004,0.0539,0.0447,0.58909,0.10665,0.28693,0.35881-1.7532,0.27285-3.5416,0.2648-5.3206,0-0.055,0.0126-0.79874-0.078-0.79874-0.0894,0.001-0.0791,0.74369-0.0791,0.79874'/%3E %3Cpath d='m713.63,296.44c-0.45625,1.7544-0.90792,3.51-1.2656,5.289-0.0688,0.34901-0.0482,0.74135-0.0275,1.0939,0.004,0.0539,0.047,0.5891,0.10889,0.28694,0.34505-1.7251,0.78297-3.4268,1.2255-5.1285,0.11808-0.45206-0.11241-1.2695-0.0412-1.5412'/%3E %3Cpath d='m715.84,297.56c0.0149,1.5061,0.18915,3.0275,0.023,4.5277-0.0412,0.37009-0.0356,0.76008,0,1.1302,0.0263,0.27171,0.0802,0.26703,0.11006,0,0.21208-1.8914,0.0424-3.763,0.0241-5.6579,0-0.055,0.0126-0.79873-0.078-0.79873s-0.0791,0.74369-0.0791,0.79873'/%3E %3Cpath d='m705.23,298.36c0.0309-0.4755,0.0263-0.57036-0.0137-0.28577-0.0207,0.10423-0.0504,0.2073-0.0838,0.30685-0.0561,0.17099-0.13757,0.33026-0.22355,0.48603-0.13182,0.23658-0.0619,0.72612-0.0551,0.98261,0.003,0.055,0.0539,0.63594,0.0963,0.55864,0.556-1.0037,0.51472-2.3212,0.35881-3.428-0.0435-0.30918-0.1043,0.23892-0.10665,0.28694-0.0219,0.36189-0.0229,0.73315,0.0275,1.0927'/%3E %3Cpath d='m709.89,295.2c0.30951,0.59847,0.28658,1.1196,0.28314,1.7767-0.00091,0.0539-0.0118,0.79873,0.0768,0.79873,0.0894,0,0.0768-0.74486,0.078-0.79873,0.008-1.1032,0.1238-2.3084-0.39779-3.3179-0.039-0.075-0.094,0.50243-0.0963,0.55864-0.005,0.26469-0.071,0.73667,0.0561,0.98261'/%3E %3Cpath d='m711.16,294.65c0.17196,0.1382,0.31868,0.29045,0.43677,0.48135,0.0516,0.0843,0.0884,0.17568,0.12265,0.2682,0.0367,0.0972,0.0504,0.38766,0.0435,0.0527,0.004,0.15811,0.0106,0.3209,0.0356,0.47784-0.0009-0.008,0.0263,0.17684,0.0607,0.0808,0.10431-0.29045,0.0619-0.68162,0.0561-0.98378-0.0161-0.77766-0.12724-1.4745-0.75545-1.9758-0.0253-0.0199-0.0573,0.25883-0.0551,0.23423-0.0195,0.18856-0.024,0.37712-0.024,0.56568,0,0.18738,0.005,0.37711,0.024,0.5645,0.005,0.0469,0.005,0.19324,0.0551,0.23423'/%3E %3Cpath d='m712.73,293.23c0.2522,0.50829,0.54108,0.99666,0.79328,1.505,0.0402,0.082,0.0585-0.0679,0.0607-0.0808,0.0241-0.15694,0.0298-0.31856,0.0355-0.47784,0.005-0.20495,0.004-0.4099-0.009-0.61603-0.006-0.10072,0.0009-0.27054-0.047-0.36657-0.25219-0.50829-0.54108-0.99667-0.79213-1.505-0.0412-0.082-0.0573,0.0679-0.0607,0.0808-0.0253,0.15694-0.031,0.31856-0.0356,0.47784-0.005,0.20495-0.004,0.41107,0.008,0.61486,0.006,0.10189-0.0009,0.27171,0.047,0.36774'/%3E %3Cpath d='m716.24,291.96c0.61904,0.88188,1.2599,1.7486,1.9465,2.5754-0.023-0.0281,0.078-0.72027,0.078-0.79874,0-0.19207,0.0561-0.63945-0.078-0.7999-0.67293-0.80928-1.3-1.6549-1.9053-2.518-0.0539-0.0785-0.0951,0.5036-0.0963,0.55865-0.006,0.22603-0.086,0.78234,0.0551,0.98261'/%3E %3Cpath d='m718.05,288.95c0.47001,0.82684,1.0111,1.6057,1.6061,2.3435-0.024-0.0304,0.078-0.71909,0.078-0.79873,0-0.19441,0.0551-0.63477-0.078-0.79991-0.58122-0.71909-1.1074-1.4792-1.5659-2.2861-0.0424-0.0773-0.094,0.5036-0.0963,0.55864-0.006,0.25298-0.0768,0.74955,0.0561,0.98261'/%3E %3Cpath d='m700.4,280.9c-0.52389-0.42162-1.081-0.78234-1.6989-1.0412-0.0412-0.0187-0.078,0.75891-0.078,0.79873,0,0.0996-0.047,0.7472,0.078,0.79874,0.6179,0.25999,1.175,0.61954,1.6989,1.0423,0.004,0.002,0.078-0.7472,0.078-0.7999,0-0.14757,0.0585-0.68865-0.078-0.79874'/%3E %3Cpath d='m705.93,279c0.039,0.0902,0.0735,0.18036,0.10666,0.27288,0.0219,0.0668,0.0402,0.13468,0.0551,0.20378,0.0183,0.12649,0.0218,0.12883,0.0106,0.007,0.003,0.15811,0.0118,0.32207,0.0367,0.47784-0.003-0.009,0.0253,0.17684,0.0596,0.0796,0.10431-0.29045,0.0607-0.68045,0.0549-0.98261-0.008-0.54928-0.0619-1.0939-0.28086-1.5998-0.0379-0.0878-0.0607,0.0761-0.0607,0.0808-0.0253,0.15693-0.0309,0.31855-0.0355,0.47783-0.0106,0.28343-0.0642,0.71441,0.0539,0.98261'/%3E %3Cpath d='m710.29,274.85c0.0263,1.0505-0.086,2.1526-0.62478,3.0685-0.13413,0.2272-0.0631,0.73432-0.0551,0.9826,0.0009,0.055,0.0504,0.63595,0.0963,0.55748,0.84717-1.4394,0.77838-3.4128,0.73482-5.0337-0.003-0.0656-0.0735-0.62306-0.0963-0.55747-0.10313,0.28927-0.0631,0.68279-0.0549,0.9826'/%3E %3Cpath d='m711.27,280.76c0.92855-0.62306,1.5636-1.5787,2.06-2.5754,0.12496-0.25063,0.0619-0.71441,0.0551-0.98261-0.00091-0.0562-0.0585-0.6336-0.0963-0.55864-0.4872,0.97909-1.1074,1.9066-2.0188,2.518-0.13412,0.0913-0.078,0.66757-0.078,0.79991,0,0.0468,0.0619,0.81045,0.078,0.79873'/%3E %3Cpath d='m713.99,280.65c0.31869-0.33261,0.58924-0.70855,0.90678-1.0412,0.0482-0.0515,0.0482-0.17333,0.0561-0.23423,0.0183-0.18739,0.023-0.37711,0.023-0.56567s-0.005-0.37712-0.023-0.5645c0.003,0.0258-0.0344-0.25649-0.0561-0.23424-0.31754,0.33261-0.58809,0.70856-0.90678,1.0412-0.0493,0.0515-0.0493,0.17333-0.0551,0.23423-0.0195,0.18856-0.0229,0.37712-0.0229,0.56567,0,0.18739,0.004,0.37712,0.0229,0.56451-0.003-0.0269,0.0355,0.25531,0.0551,0.23423'/%3E %3Cpath d='m718.07,281.36c-1.0214-0.004-2.0417-0.014-3.0585-0.11594-0.0698-0.007-0.16623,1.5822,0,1.5986,1.0168,0.10071,2.0371,0.11243,3.0585,0.11594,0.11464,0.001,0.11809-1.5986,0-1.5986'/%3E %3Cpath d='m717.16,285.04c1.3584,0.81514,2.6756,1.6994,4.0799,2.4302-0.10771-0.0562,0.29346-1.444,0-1.5975-1.4043-0.73198-2.7215-1.615-4.0799-2.4313,0.12954,0.0785-0.30492,1.4159,0,1.5986'/%3E %3Cpath d='m717.28,287.82c1.2106,0.77063,2.5335,1.3632,3.626,2.3154-0.003-0.001,0.0768-0.74369,0.0768-0.7999,0-0.15577,0.0585-0.67928-0.0768-0.79874-1.0925-0.95215-2.4154-1.5448-3.626-2.3154-0.0207-0.0118-0.078,0.7554-0.078,0.79991,0,0.12531-0.0561,0.71206,0.078,0.79873'/%3E %3Cpath d='m709.48,282.01c0.17425-0.58324,0.17081-1.2086,0.17081-1.8118,0-0.055,0.0117-0.79873-0.078-0.79873-0.0906,0-0.0791,0.74369-0.0791,0.79873,0,0.21901,0.003,0.034,0.005,0.002-0.007,0.0914-0.0333,0.18036-0.0596,0.2682-0.0906,0.30333-0.0631,0.67107-0.0551,0.9826,0.005,0.15928,0.009,0.3209,0.0356,0.47784-0.003-0.0188,0.0286,0.18504,0.0607,0.0808'/%3E %3Cpath d='m699.94,277.75c1.0638,1.3023,2.4119,2.2451,3.7222,3.2652,0.97096,0.7554,1.6886,2.0413,2.7375,2.6375-0.12152-0.0679,0.30035-1.4265,0-1.5975-0.9446-0.53756-1.5751-1.6759-2.4142-2.3786-1.3837-1.1606-2.8854-2.1058-4.0444-3.5252,0.19488,0.24009-0.29346,1.2403-0.0009,1.5986'/%3E %3Cpath d='m702.21,282.06c-0.64195-0.66053-1.23-1.3691-1.8124-2.0835-0.0183-0.0211-0.0596,0.26-0.0573,0.23423-0.0172,0.18739-0.023,0.37595-0.023,0.56451,0,0.19324-0.0549,0.63594,0.0791,0.7999,0.58234,0.71441,1.1704,1.4218,1.8124,2.0835-0.0137-0.014,0.0768-0.73314,0.0768-0.7999,0.0009-0.17333,0.0595-0.6582-0.0756-0.79874'/%3E %3Cpath d='m700.94,292.62c-0.4276,0.77531-0.78871,1.5904-1.339,2.2861-0.13183,0.16747-0.078,0.60315-0.078,0.7999,0,0.082,0.10431,0.76594,0.078,0.79874,0.56401-0.71676,0.94002-1.5471,1.3791-2.3435,0.13069-0.23657,0.0631-0.72612,0.0561-0.9826-0.0009-0.055-0.0539-0.63594-0.0963-0.55865'/%3E %3Cpath d='m702.13,294.22c-0.0195,0.88892-0.32328,1.7755-0.43333,2.6562-0.0458,0.36891-0.0355,0.76242,0,1.1313,0.0275,0.27406,0.078,0.26351,0.11124,0,0.13986-1.1349,0.44823-2.2112,0.47344-3.3624,0.007-0.30099,0.0482-0.69333-0.0551-0.98378-0.0217-0.0644-0.0951,0.49306-0.0963,0.55864'/%3E %3Cpath d='m706.31,301.57c0.75545-2.5274,0.67292-5.1988,0.62133-7.8117-0.0219-1.122-0.1605-0.0843-0.15133,0.42396,0.039,1.9781,0.0596,3.9351-0.51127,5.8465-0.13183,0.44504,0.11922,1.2813,0.0412,1.5413'/%3E %3Cpath d='m708.76,295.43c0.28774,0.8772,0.3462,1.6759,0.20864,2.5906-0.0551,0.35838-0.0493,0.73198-0.0275,1.0939,0.003,0.0469,0.0595,0.59378,0.10665,0.28576,0.27398-1.8094,0.33245-3.7559-0.24533-5.5115-0.0207-0.0621-0.094,0.49072-0.0963,0.55864-0.0106,0.30333-0.0435,0.68631,0.054,0.98261'/%3E %3Cpath d='m711.16,294.54c0.88269,1.0798,1.1498,2.5133,1.065,3.8906-0.0149,0.26117,0.0744,1.7907,0.13528,0.80693,0.12609-2.0823,0.18226-4.605-1.2002-6.2962,0.0241,0.0293-0.078,0.71909-0.078,0.7999,0,0.19207-0.0549,0.63595,0.078,0.79874'/%3E %3Cpath d='m711.82,293.47c0.5514,2.2978,0.97785,4.6156,1.2129,6.9708,0.0619,0.6254,0.12953-0.92288,0.11123-1.1302-0.24991-2.4934-0.697-4.9482-1.2816-7.3818,0.0665,0.27874-0.1513,1.0857-0.0424,1.5412'/%3E %3Cpath d='m714.09,292.89c1.0065,1.3878,1.8858,2.8506,2.3787,4.5148,0.0183,0.0574,0.094-0.48721,0.0951-0.55865,0.0106-0.31153,0.0356-0.67927-0.0549-0.9826-0.49294-1.6631-1.3711-3.127-2.3787-4.5148,0.0975,0.13469-0.282,1.211-0.0402,1.5413'/%3E %3Cpath d='m718.77,289.03c-0.46543-0.8081-1.4548-0.90765-2.287-0.83855-0.15706,0.0129-0.0756,1.6045,0,1.5986,0.78755-0.0656,1.7998,0.008,2.2446,0.78116,0.0447,0.0773,0.0951-0.5036,0.0975-0.55864,0.005-0.2518,0.078-0.75189-0.0549-0.98261'/%3E %3Cpath d='m716.37,288.4c1.4673-0.21315,2.9393-0.23071,4.4181-0.23189,0.11922,0,0.11922-1.5975,0-1.5975-1.4777,0-2.9496,0.0176-4.4181,0.23071-0.18457,0.0269-0.0458,1.6068,0,1.5986'/%3E %3Cpath d='m719.09,276.27c-1.1739,1.4042-1.7964,3.3109-2.1918,5.0864-0.0768,0.34316-0.0482,0.74487-0.0275,1.0927,0.004,0.0586,0.0402,0.58676,0.10665,0.28694,0.37601-1.6865,1.0008-3.5358,2.1139-4.8674,0.13413-0.16045,0.078-0.60901,0.078-0.79991,0-0.0773-0.10208-0.7718-0.0791-0.79873'/%3E %3Cpath d='m712.71,277.64c0.21895,1.3504,0.7738,2.5953,1.1521,3.9,0.0172,0.0574,0.094-0.48603,0.0951-0.55864,0.009-0.31271,0.0344-0.67811-0.0539-0.98261-0.36225-1.2508-0.90448-2.4454-1.1143-3.7384-0.0493-0.30802-0.10431,0.23775-0.10666,0.28693-0.0207,0.35838-0.0298,0.7355,0.0275,1.0927'/%3E %3Cpath d='m711.5,279.97c-0.52961-0.65702-0.979-1.3515-1.2243-2.1702-0.031-0.10423-0.0642,0.0984-0.0607,0.0796-0.0253,0.15694-0.031,0.31973-0.0355,0.47784-0.009,0.31152-0.0356,0.68044,0.0549,0.98377,0.25106,0.84207,0.72336,1.553,1.2656,2.2276,0.0183,0.0211,0.0573-0.26117,0.0551-0.23423,0.0195-0.18856,0.024-0.37712,0.024-0.56568,0-0.19324,0.0551-0.63243-0.0791-0.79873'/%3E %3Cpath d='m709.35,281.02c-1.778-0.57622-3.4804-1.2859-4.9867-2.4302,0.16393,0.12297-0.31182,1.3586,0,1.5975,1.5052,1.1454,3.2087,1.854,4.9867,2.4313-0.0367-0.0118,0.24991-1.5178,0-1.5986'/%3E %3C/g%3E %3Cg stroke-width='0.001159'%3E %3Cpath fill='%23d9c0b9' stroke='%23000' stroke-width='0.5481' d='m670.35,297.23s-2.953-5.0817,5.2389-7.5716c0,0,2.4762,1.348,3.0482,2.2814,0,0-1.4284,2.3857-6.0964,3.0087,0,0-2.0956,0.62189-2.1907,2.2814z'/%3E %3Cpath fill='%235e3f17' d='m675.77,290.98c-1.3401,0.81981-3.4494,0.83035-3.8678,2.6808-0.006,0.0258,0.004,0.12649,0.007,0.11477,0.41727-1.8434,2.5323-1.8493,3.861-2.6621,0.0253-0.0176-0.0118-0.12648,0-0.13351'/%3E %3Cpath fill='%23d9c0b9' stroke='%23000' stroke-width='0.5481' d='m671.21,296.4s3.297,0.69567,5.5232-0.93342c1.825-1.3351,2.4773-0.72612,2.953-0.62189,0,0,0.0963-1.6595-1.0478-2.9045,0,0-2.3145,1.9114-4.0295,2.4302-1.7127,0.51883-2.8728,0.34667-3.399,2.0296z'/%3E %3Cpath fill='%23dba05f' stroke='%23000' stroke-width='0.5481' d='m711.3,280.57s-7.049,1.2063-8.9084,1.6326c-1.8594,0.42631-6.0689,0.85261-7.5362,0.85261-1.4685,0-3.72-1.1723-5.2859-1.4921-1.5659-0.31973-6.6558-0.85261-8.5152,1.0658s-3.0344,2.5578-3.6214,3.1973c-0.58695,0.63946-2.945,2.7312-3.0379,3.6576-0.0928,0.92522,0.59153,2.3107,1.7654,2.3107,1.175,0,3.6432,2.4993,3.6397,3.0216-0.006,0.87135,3.2236,1.8094,6.2683,1.7919,5.4899-0.0304,8.1919-2.8003,16.422-1.8294,4.4812,0.52819,12.724-2.9841,14.193-5.1156,1.4674-2.1315,2.3489-4.3696,0.88042-6.8209-1.4685-2.4512-5.8694-2.1994-6.2638-2.2721z'/%3E %3Cpath fill='%23000' d='m681.79,288.47c0.00091,0-0.0183,0.15576-0.0504-0.0855l-0.0412-0.18856-0.0493-0.13-0.009-0.14405c-0.0321-0.0504,0.14787,0.0351,0.71648-0.52469,0.003,0.0106,0.17195-0.26819,0.48033-0.7308-0.0333,0.0211,0.70042-0.91117,1.778-1.1583,1.0741-0.25063,2.068-0.0703,2.2056-0.0621,0.0458-0.0597-2.436-0.0867-2.5988,0.20379,0.007-0.19442,2.3936-0.2764,2.5208-0.11009,0.0309-0.0562-2.248-0.075-2.4177,0.23774-0.003-0.14171,2.068-0.24126,2.2927-0.0504,0,0-0.38518-0.0433-0.4895-0.0328l0.17998,0.0316-0.29004-0.004-0.16737-0.0164c0-0.005,0.45397,0.055,0.48377,0.096,0.003,0.007,0.20406-0.0574-0.60642-0.014,0.003,0.002-0.49638-0.0914-1.3034,0.16631-1.0604,0.15459-1.0272,1.594-2.6344,2.5157'/%3E %3Cpath fill='none' stroke='%23939598' d='m681.62,287.87c0.094,0.008,0.78526-0.27171,1.4479-1.4991-0.18799-0.33496,2.4899-1.3785,2.7673-1.0435,0.0118-0.0106,0.73023,0,1.1498,0.0679'/%3E %3Cpath fill='none' stroke='%23000' d='m684.27,285.55c-0.27284-0.0375-1.6324,1.1079-1.5086,1.1723-0.29346,0.70387-1.057,1.1641-1.1452,1.1454'/%3E %3Cpath fill='none' stroke='%23000' d='m684.38,285.72c0-0.089,1.8388-0.26468,2.2022-0.12765'/%3E %3Cpath fill='none' stroke='%23939598' d='m684.04,286.21c-0.0504-0.19207,1.9144-0.45909,2.0967-0.32558'/%3E %3Cpath fill='%23000' d='m686.09,287.46s0.0826,0.0504-0.0298-0.0609l-0.0838-0.096-0.0493-0.082-0.0699-0.0609s-0.0619,0.0258-0.55483,0.46261c-0.003-0.004-0.21552,0.16045-0.47001,0.39936-0.006-0.0211-0.47804,0.39703-1.0065,0.68631-0.56286,0.0831-1.3779,0.44855-1.3779,0.59378-0.0493-0.21784,1.6164-0.65468,1.5923-0.68162,0.11922,0.0785-1.4765,0.37126-1.5063,0.69567-0.0573-0.19558,1.4639-0.57738,1.527-0.58207,0.078,0.089-1.3412,0.32324-1.3837,0.63009,0.003,0.008,0.19488-0.19324,0.27283-0.19676l-0.0997,0.075c0.0493-0.0492,0.11581-0.0586,0.17769-0.082l0.1043-0.048c-0.003,0.002-0.28314,0.12532-0.27398,0.18388,0.0137,0.0316-0.16164-0.0176,0.36684-0.16045,0.007,0.0504,1.3424-0.27054,2.8648-1.6759'/%3E %3Cpath fill='none' stroke='%23939598' d='m685.84,287.12c-0.009-0.0222-0.58923,0.57855-1.1957,1.006,0.005,0.10072-1.2427,0.8327-1.5694,0.74486-0.0207-0.0386-0.53305,0.21549-0.74628,0.47666'/%3E %3Cpath fill='none' stroke='%23000' d='m683.99,288.6c0.0951-0.0937,0.88155-0.63009,0.88155-0.63595,0.27971-0.29747,0.97327-0.85026,0.97442-0.85143'/%3E %3Cpath fill='none' stroke='%23000' d='m684.02,288.74c0.0653,0.0644-1.1704,0.23424-1.3676,0.53171'/%3E %3Cpath fill='none' stroke='%23939598' d='m684.37,288.71c0.0791,0.15928-1.3218,0.53288-1.3791,0.57504'/%3E %3Cpath fill='%23c6262c' stroke='%23000' stroke-width='0.5481' d='m688.04,281.76s-0.0986-2.2381-2.2515-3.0907c-2.1529-0.85261-4.6015-0.95919-5.4808-0.85261-0.88155,0.10657-1.0272,0.50009-2.1276,0.67693-1.1016,0.17568-2.2755,0.70856-2.2755,0.70856s0-0.10657-0.58807,0.95918c-0.58809,1.0658-1.5648,1.5986-1.0753,2.5578,0.48835,0.95918,0.16393,1.1267,0.76691,1.3094,0.60299,0.1827-0.29919-0.32676-0.29919-0.32676s-3.7727,1.2157-2.8544,3.5264c0.91823,2.3119,1.8376,1.4476,2.1116,1.4007,0.27513-0.048,2.1345-1.0072,2.1345-1.0072l3.0562-2.8565s3.5985-1.4066,3.9894-1.5131c0.3932-0.10658,2.0967,0.0398,2.0967,0.0398l2.7971-1.5319z'/%3E %3Cpath fill='%23000' d='m685.31,287.01c0,0.55747-0.5663,1.2777-1.2656,1.608-0.70044,0.32909-1.2679,0.14522-1.2679-0.41225,0-0.55865,0.56631-1.2789,1.2656-1.6092,0.69928-0.3291,1.2679-0.14523,1.2679,0.41342'/%3E %3Cpath fill='%235e3f17' d='m708.62,292.91c0.68323-0.11595,1.3642-0.46495,2.0463-0.92874'/%3E %3Cg fill='%23842116'%3E %3Cpath d='m674.86,285.06c0.57664,0.0106,1.253,0.31388,1.1647,1.0213-0.0161,0.12297-0.0126,0.25414,0,0.37712,0.008,0.0914,0.0253,0.0878,0.0367,0,0.0539-0.43216,0.0745-0.92874-0.0917-1.3386-0.18457-0.45324-0.67291-0.58441-1.1097-0.59261-0.0367,0-0.0424,0.53288,0,0.53288'/%3E %3Cpath d='m677.63,286.13c0.27628-0.78234,0.21094-1.7087-0.26252-2.3927,0.0321,0.0468-0.0928,0.39937-0.0137,0.51297,0.29347,0.42397,0.44594,0.85144,0.26252,1.3656-0.0516,0.14523,0.0424,0.43333,0.0137,0.51414'/%3E %3Cpath d='m679.87,283.76c-0.14216-0.93225-0.46887-1.9687-1.3275-2.4524,0.0402,0.0222-0.0997,0.47549,0,0.53288,0.8357,0.47081,1.1647,1.471,1.3023,2.3786,0.0161,0.10305,0.0333-0.0785,0.0344-0.0949,0.007-0.11946,0.009-0.24478-0.009-0.36424'/%3E %3Cpath d='m681.84,283.28c0.12038-0.86783,0.0458-1.7942-0.67061-2.3751,0.0573,0.0457-0.10548,0.44738,0,0.53288,0.39778,0.32207,0.71991,0.8409,0.64426,1.3832-0.0172,0.11946-0.0161,0.24243-0.009,0.36306,0.0009,0.0164,0.0218,0.1991,0.0355,0.096'/%3E %3Cpath d='m678.54,280.37c1.9259-0.97675,5.8488-1.4101,7.3585,0.53639-0.0665-0.0831,0.0951-0.40873,0-0.53171-1.5098-1.9476-5.4326-1.5143-7.3585-0.53756-0.0975,0.0492,0.0355,0.51648,0,0.53288'/%3E %3C/g%3E %3Cg fill='%237a2e26'%3E %3Cpath d='m680.38,294.73c0.61446,0,1.2369,0.007,1.8399-0.13468,0.0722-0.0164,0-0.53288,0-0.53171-0.603,0.14054-1.2255,0.13351-1.8399,0.13351-0.039-0.001-0.039,0.53288,0,0.53288'/%3E %3Cpath d='m679.22,286.19c-0.50671,0.002-0.35424,0.61018-0.65803,0.86549-0.0458,0.0375-0.0263,0.21549-0.0263,0.26585,0,0.0187,0.0253,0.26703,0.0263,0.26703,0.30379-0.25414,0.16395-0.86315,0.65803-0.86549,0.0402,0,0.0379-0.53288,0-0.53288'/%3E %3Cpath d='m680.92,287.34c0.25564-0.47901,0.76119-0.67459,1.2163-0.90414,0.0974-0.048-0.0333-0.51531,0-0.53171-0.46313,0.23307-0.96868,0.43333-1.2289,0.92171-0.0424,0.0808-0.0219,0.24126-0.0195,0.32793,0.0009,0.0187,0.0195,0.21198,0.0321,0.18621'/%3E %3Cpath d='m683.13,290.28c0.41614,0.0328,0.74055-0.14523,0.98817-0.48135,0.0412-0.0586,0.0253-0.19793,0.0253-0.26586,0-0.0293-0.0367-0.25297-0.0253-0.26702-0.24875,0.33612-0.57203,0.51414-0.98817,0.48135-0.0263-0.002-0.0516,0.52819,0,0.53288'/%3E %3Cpath d='m684.87,289.66c0.67292-0.28342,1.1888-0.71207,1.5579-1.355,0.0447-0.0773,0.0219-0.2436,0.0195-0.32793,0-0.0176-0.0183-0.21198-0.0321-0.18621-0.36684,0.63828-0.87925,1.0564-1.5453,1.3363-0.0917,0.0387,0.024,0.52234,0,0.53288'/%3E %3Cpath d='m682.13,286.78c-0.38517,0.64883-1.1143,0.9791-1.5522,1.5858-0.0802,0.11127,0.0458,0.46964,0.0137,0.51414,0.43791-0.60783,1.1658-0.93576,1.5522-1.5858,0.0447-0.0761,0.0217-0.24594,0.0195-0.32792-0.003-0.0187-0.0183-0.21198-0.0333-0.18622'/%3E %3Cpath d='m683.32,295.28c1.3963,0.075,2.7444-0.1136,4.0925-0.48018,0.0768-0.0222-0.005-0.53171,0-0.53288-1.3493,0.36658-2.6974,0.55514-4.0925,0.48018-0.031-0.001-0.0482,0.53054,0,0.53288'/%3E %3Cpath d='m689.76,295.04c1.8239-1.3234,3.3623-2.4559,3.9584-4.7678,0.039-0.15108-0.0367-0.42279-0.0137-0.51297-0.59382,2.2943-2.1414,3.4385-3.9447,4.7479-0.10313,0.0749,0.0516,0.49541,0,0.53288'/%3E %3Cpath d='m690.85,291.87c1.2965-0.7718,2.224-1.9898,2.7352-3.4222,0.0516-0.14405-0.0424-0.43333-0.0137-0.51414-0.50784,1.4265-1.433,2.6363-2.7215,3.4034-0.10313,0.0597,0.0424,0.50711,0,0.53288'/%3E %3Cpath d='m690.23,283.8c0.99389-0.11946,2.0784,0.70622,2.7754,1.3457-0.0607-0.055,0.10431-0.43684,0-0.53288-0.69585-0.63946-1.7815-1.4651-2.7754-1.3457-0.0573,0.007-0.0195,0.53522,0,0.53288'/%3E %3Cpath d='m716.07,287.82c1.1315-1.8282,0.51358-4.1155-0.65801-5.7528,0.0321,0.0457-0.094,0.40288-0.0137,0.51414,0.99046,1.3843,1.6473,3.1294,0.65916,4.7245-0.0756,0.12063,0.0458,0.46027,0.0126,0.51414'/%3E %3Cpath d='m696.35,285.24c1.1418,0.82801,4.2863,2.9361,3.4276,4.6671-0.0665,0.13234,0.0458,0.44856,0.0137,0.51414,1.1762-2.3693-1.8605-4.5675-3.4414-5.7141,0.0505,0.0363-0.10431,0.45558,0,0.53288'/%3E %3Cpath d='m705.21,293.75c0.17997-0.4872,0.24303-0.99549,0.29347-1.5108,0.0126-0.12414,0.0126-0.2518,0-0.37595-0.0106-0.0902-0.0275-0.0902-0.0367,0-0.0458,0.46964-0.10548,0.92874-0.27055,1.3726-0.0355,0.0949-0.0207,0.22955-0.0183,0.32793,0.00091,0.0211,0.023,0.20846,0.0321,0.18621'/%3E %3Cpath d='m673.95,288.41c0.43676-0.64765,0.2969-1.5155-0.13069-2.1245,0.0321,0.0457-0.0928,0.40054-0.0149,0.51414,0.11464,0.15928,0.2098,0.3209,0.28545,0.50243,0.0928,0.22252-0.0332,0.41577-0.15361,0.59378-0.047,0.0691-0.0207,0.25063-0.0183,0.32793,0.0009,0.0188,0.0149,0.21198,0.0321,0.18621'/%3E %3Cpath d='m693.62,294.06c0.62018-0.39585,1.0546-0.98495,1.1934-1.7251,0.023-0.11712,0.0172-0.24595,0.009-0.36423,0-0.0176-0.0161-0.19676-0.0344-0.0949-0.13297,0.70738-0.57662,1.2742-1.1681,1.6513-0.10208,0.0656,0.0458,0.5036,0,0.53288'/%3E %3Cpath d='m696.57,293.82c0.26595-0.29396,0.36453-0.64765,0.37944-1.04,0.004-0.0984,0.0161-0.23189-0.0183-0.32676-0.008-0.0222-0.0321,0.16397-0.0321,0.18505-0.008,0.2272-0.18686,0.49189-0.329,0.64882-0.0447,0.0504-0.0253,0.20613-0.0253,0.26703-0.00091,0.0234,0.031,0.25883,0.0253,0.26585'/%3E %3Cpath d='m714.39,284.04c0.48492,0.85963,0.56401,1.8059,0.34735,2.7686-0.023,0.10423,0.0161,0.50829,0.0263,0.46027,0.27512-1.2192,0.26366-2.6363-0.36111-3.743,0.0344,0.0597-0.0837,0.38883-0.0126,0.51415'/%3E %3Cpath d='m712.61,285.85c0.35078,0.86783,0.32441,1.7708,0.22469,2.6902-0.008,0.0691,0.0137,0.58559,0.0367,0.37595,0.13298-1.218,0.21896-2.4208-0.24762-3.5803,0.031,0.0761-0.0698,0.37361-0.0137,0.51415'/%3E %3Cpath d='m710.94,287.4c0,0.64883,0.007,1.2976-0.21551,1.9137-0.0539,0.14406,0.0424,0.43451,0.0137,0.51414,0.27971-0.77062,0.25448-1.6185,0.25564-2.4278-0.00091-0.30216-0.0539-0.30216-0.0539,0'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='%23dcddde' stroke='%23000' stroke-width='0.2665' d='m694.56,275.41c-7.0731,0.40639-14.048-4.2923-14.048-4.2923-8.7617-1.7169-9.2718-9.6387-9.2718-9.6387-3.5056-1.3351-6.5205-10.337-6.5205-10.337-5.4303,3.2418-12.226,0.0352-12.226,0.0352s0-1.3351-6.1319,0c-6.1331,1.3351-5.0818-1.1442-5.0818-1.1442s2.4532-2.4805-8.4086,0c-10.862,2.4794,0.87697-3.243,0.87697-3.243-3.1536,0.95333-13.49,1.7169-13.49,1.7169-3.7933,0.17099-7.6428,2.0425-11.835,3.2371-2.6091,0.7437-7.0731,1.6104-9.3303,2.5742-6.0219,2.5742-18.091,8.1056-28.058,12.017-13.104,5.1426-23.489,9.0554-22.806,8.8903,0.8185-0.19792,14.23-8.6924,31.028-16.308,15.597-7.0738,33.501-13.619,42.528-16.183,11.714-3.8812,21.307-2.0273,26.749-0.0527,2.6275,0.95333,17.123-0.44622,23.604,0.31621,6.4827,0.76243,7.1579,11.422,7.1579,11.422,1.2266,0.76359,1.6645,10.778,1.6645,10.778s-3.5916,0.0949,0.6133,0.66756c4.2049,0.5727,11.913,6.6768,11.913,6.6768,2.6275,0,2.9255-0.0937,2.9255-0.0937s1.527-1.9242,3.6305-2.7288c2.1013-0.80576,4.0295-1.6115,6.3933-1.7895,2.365-0.18036,5.7043-0.20144,8.0681,0.0668,2.365,0.26937,5.1575,0.29045,8.4865,0.91702,3.3291,0.62657,3.6787,0.80576,4.7299,1.163,1.0512,0.35837,1.9924,0.12648,1.9924,0.12648,4.3287-1.8094,12.357-5.0067,14.205-4.6402,0,0,3.0287-0.76126,4.6576-2.0285,1.629-1.2672,5.3547-4.3111,5.3547-4.3111s-2.5713-18.106,15.823-16.332c18.395,1.7755,42.784,4.1366,47.674,4.8978,4.8881,0.76008,22.402,5.7633,26.593,7.7918,4.1911,2.0284,16.235,7.424,21.594,9.7944,2.1758,0.96153,10.463,4.6331,16.596,7.0551,9.203,3.6341,16.08,9.6879,16.08,9.6879-5.7674-2.4395-10.43-5.2292-14.998-7.2132-3.6947-1.6045-7.5591-2.3505-10.565-3.6856-6.3772-2.833-11.289-5.4131-15.154-7.2132-14.246-6.6347-14.115-6.9005-19.886-7.3526-3.9779-0.3127,2.8579,4.8521,2.8579,4.8521s-13.039-5.0711-17.23-6.8466c-4.19-1.7743-7.6829-2.5344-11.641-2.2814-3.9584,0.25415-6.986-0.50594-9.3131-1.2672-2.3283-0.76125-15.601-1.2672-17.93-1.5213-2.3271-0.25297-4.19-0.76009-4.19-0.76009l0.9309,1.5202-6.5194-1.0131-1.8629,2.7886s-6.2866,1.2672-6.7532-0.76126c-0.4654-2.0273-3.7257,9.1269-5.3558,12.424-1.6302,3.2957-9.0678,2.203-10.931,4.2314-1.8629,2.0285-5.8362,3.3858-6.7659,3.893-0.93201,0.50712-3.7566,0.2682-5.3868,0.2682-2.4257,0-0.3588,0.0363-4.3378,0.79288,0,0-3.4368-0.0328-4.7505-0.56919-1.3137-0.53756-4.2049-1.3691-5.6608-1.7848-1.9878-0.56919-13.047-0.82099-14.623-0.73081-1.5774,0.089-4.2438,0.90531-5.9955,1.6209-1.7505,0.71559-4.8182,2.5953-4.8182,3.0427'/%3E %3Cpath fill='%23452c25' d='m695.29,273.29s-0.74171,0.56919-0.92856,1.9922c-0.1857,1.4241-0.0928,0.85495-0.0928,0.85495'/%3E %3Cpath fill='%23574f4c' d='m731.03,271.21c0.93774,0.69918,1.9041,1.4101,2.7364,2.2428,0.0275,0.0293,0.29575,0.27405,0.20405,0.0773-0.10207-0.21549-0.27628-0.41576-0.44136-0.58207-0.92282-0.92405-1.9798-1.724-3.023-2.5004-0.17197-0.12883,0.0172,0.18505,0.039,0.21901,0.13413,0.19441,0.29348,0.40171,0.48491,0.54342'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='990' height='630' viewBox='0 0 33 21'%3E %3Crect fill='%23FFF' width='33' height='21'/%3E %3Crect width='33' height='14'/%3E %3Crect fill='%234891D9' width='33' height='7'/%3E %3C/svg%3E"

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23000'/%3E %3Crect width='900' height='400' fill='%23fff'/%3E %3Crect width='900' height='200' fill='%23ce1126'/%3E %3Cg fill='%23fff' stroke='%23c09300'%3E %3Cpath stroke-width='1.2703' stroke-linejoin='round' d='m450.81,302.4,68.488,63.579-4.8759-115.47c-0.71638-17.5-15.924-13.485-26.971-7.1723-11.191,7.1723-23.958,7.1723-37.446,2.437-13.485,4.7353-26.253,4.7353-37.444-2.437-11.046-6.3123-26.252-10.328-26.97,7.1723l-4.8789,115.47,70.098-63.579z'/%3E %3Cg id='w' fill='%23c09300' stroke='none'%3E %3Cpath d='m393.47,246.49-4.7342,112.32-8.0347,7.168,4.8784-115.47c2.2949-1.5782,6.3132-4.0171,7.8905-4.0171z'/%3E %3Cpath d='m403.09,254.53-4.0171,93.955-8.0323,8.2204,4.8772-108.49c1.5791,1.577,6.3138,5.4498,7.1721,6.3104z'/%3E %3Cpath d='m411.84,261.7-3.1545,78.362-6.4556,6.3092,4.0177-89.405c1.5748,1.5782,4.7311,3.8734,5.5924,4.7334z'/%3E %3Cpath d='m421.31,265.72-3.1563,66.787-6.3132,5.1193,3.1563-74.344c1.5791,0.71638,4.7348,2.4376,6.3132,2.4376z'/%3E %3Cpath d='m430.06,265.72-2.2974,55.657-6.4544,6.3129,2.4392-61.252c1.576-0.00061,5.5937-0.00061,6.3126-0.7182z'/%3E %3C/g%3E %3Cuse xlink:href='%23w' transform='matrix(-1,0,0,1,900,0)'/%3E %3Cpath fill='%23c09300' stroke-width='1.0739' d='m453.16,315.06,9.6126,43.755-3.1575,3.1552-3.2993-2.4388-5.4518-39.018,2.2955,39.018-3.1569,4.0158-3.1563-4.0158,2.2962-39.018-5.4506,39.018-3.3024,2.4388-3.1545-3.1552,9.6113-43.755h6.3138z'/%3E %3Cg id='b' fill='none' stroke-width='1.2705' stroke-linejoin='round'%3E %3Cpath fill='%23fff' stroke-width='1.1888' d='m428.48,295.84-19.08,67.705,26.255,4.0177,11.188-50.924-18.363-20.799z'/%3E %3Cpath d='m422.17,318.94,2.2955,5.5928,12.405-11.848'/%3E %3Cpath d='m430.76,304.92,2.5957,24.346,7.8905-10.328'/%3E %3Cpath d='m438.09,322.95,4.31,14.875'/%3E %3Cpath d='m444.09,332.36-8.7177,13.241m2.7189,13.216-2.7902-13.198-2.4356-13.423-5.8406,7.9091-2.5613-9.1191-8.1747,8.3847,4.1575,15.251,5.7375-9.4349,3.1557,9.6123,5.8903-9.1621'/%3E %3Cpath d='m414.99,361.97,5.2997-7.4437,3.4528,11.457,4.7342-8.0323,3.1575,9.6136'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='matrix(-1,0,0,1,900,0)'/%3E %3Cg stroke-width='1.2705' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='2.3777' stroke-linejoin='round' d='m450,393.81c19.943,0,39.024-1.5776,50.213-4.734,4.7354-0.8588,4.7354-3.2976,4.7354-6.4553,4.7354-1.5776,2.2949-7.1704,5.5943-7.1704-3.2994,0.86244-4.0158-5.5941-8.0329-4.7316,0-5.5965-5.5955-6.3129-10.33-4.7377-9.4695,3.1576-26.255,3.8752-42.18,3.8752-15.924-0.71758-32.567-0.71758-42.179-3.8752-4.7342-1.5752-10.327-0.85881-10.327,4.7377-4.0183-0.86245-4.7354,5.5941-8.0341,4.7316,3.2988,0,0.85954,5.5928,5.5943,7.1704,0,3.1576,0,5.5965,4.8778,6.4553,11.045,3.1564,30.128,4.734,50.068,4.734z'/%3E %3Cpath d='m422.89,363.54c6.4544,0.86123,13.628,1.5776,19.225,0.86123,3.1533,0,5.4494,5.4504-0.86257,6.3129-5.5931,0.71515-14.345,0-19.08-0.86245-4.0171-0.71759-12.768-2.2946-18.364-3.8752-5.5949-2.4364-1.576-7.168,1.5772-6.4522,4.879,1.577,11.192,3.1564,17.505,4.0158z'/%3E %3Cpath d='m477.12,363.54c-6.4569,0.86123-13.628,1.5776-19.081,0.86123-3.3006,0-5.5961,5.4504,0.71711,6.3129,5.5955,0.71515,14.347,0,19.078-0.86245,4.0189-0.71759,12.769-2.2946,18.364-3.8752,5.5967-2.4364,1.5803-7.168-1.5772-6.4522-4.8778,1.577-11.19,3.1564-17.501,4.0158z'/%3E %3Cpath d='m403.09,360.39c-4.8771-0.86123-7.1723,4.7316-5.5928,7.8868,0.71637-1.5776,4.0164-1.5776,4.7346-3.1552,0.8582-2.437-0.7182-2.437,0.8582-4.7316z'/%3E %3Cpath d='m422.17,375.06c0-3.1528,3.1545-2.7651,3.1545-5.9215,0-1.577-0.85893-4.0171-2.4368-4.0171-1.5785,0-3.1575,1.5776-3.1575,3.1552-0.7177,3.157,2.4398,3.6312,2.4398,6.7834z'/%3E %3Cpath d='m444.88,365.98c4.7305,0,4.2618,6.3141,1.9656,9.4699,0-2.2952-4.0164-3.1558-4.0164-4.7316,0-2.4419,3.6262-2.4419,2.0508-4.7383z'/%3E %3Cpath d='m496.91,360.39c4.8777-0.86123,7.1741,4.7316,5.5953,7.8868-0.71819-1.5776-4.017-1.5776-4.734-3.1552-0.86124-2.437,0.71759-2.437-0.86124-4.7316z'/%3E %3Cpath d='m477.83,375.06c0-3.1528-3.1532-2.7651-3.1532-5.9215,0-1.577,0.85953-4.0171,2.438-4.0171,1.5772,0,3.1563,1.5776,3.1563,3.1552,0.71771,3.157-2.441,3.6312-2.441,6.7834z'/%3E %3Cpath d='m455.12,365.98c-4.7323,0-4.263,6.3141-1.9674,9.4699,0-2.2952,4.0158-3.1558,4.0158-4.7316,0.00061-2.4419-3.6262-2.4419-2.0484-4.7383z'/%3E %3Cg stroke-width='0.8915'%3E %3Cpath d='m404.67,361.97c1.58,0,4.0177,0.71758,4.7353,1.577l-4.74-1.58z'/%3E %3Cpath d='m412.55,364.41c0.86184,0,4.0183,0.71639,5.5959,1.5752l-5.6-1.58z'/%3E %3Cpath d='m441.25,367.56c-1.5776,0-4.734,0-5.5928,0.71516l5.59-0.72z'/%3E %3Cpath d='m432.5,367.56c-0.8588-0.86245-4.0165-0.86245-5.5935,0h5.59z'/%3E %3Cpath d='m495.34,361.97c-1.5776,0-3.8746,0.71758-4.7353,1.577l4.7353-1.577z'/%3E %3Cpath d='m487.45,364.41c-0.86002,0-4.0171,0.71639-5.5953,1.5752l5.6-1.58z'/%3E %3Cpath d='m458.75,367.56c1.5794,0,4.7352,0,5.5953,0.71516l-5.6-0.72z'/%3E %3Cpath d='m467.5,367.56c0.86002-0.86245,4.0183-0.86245,5.5953,0h-5.6z'/%3E %3C/g%3E %3Cg fill='%23c09300' stroke='none'%3E %3Cpath d='m403.34,374.58c-0.53406-0.10208-0.81452-0.52459-0.68011-1.0246,0.16371-0.609,0.65161-0.95739,1.1126-0.79442,0.29312,0.10362,0.82973,0.64469,0.83184,0.83874,0.003,0.22275-0.28059,0.75257-0.40266,0.75379-0.0527,0.00053-0.1342,0.0465-0.18122,0.10201-0.10001,0.11816-0.41341,0.17549-0.68041,0.12446z'/%3E %3Cpath d='m458.27,378.5c-0.19869-0.0736-0.51521-0.5185-0.51485-0.72377,0.002-0.38717,0.57418-1.0178,0.92881-1.0214,0.17516-0.001,0.65475,0.2481,0.83411,0.43462,0.32504,0.33789,0.25419,0.89278-0.15423,1.2079-0.20096,0.15505-0.80025,0.21125-1.0938,0.1026z'/%3E %3Cpath d='m458.63,380.98c-0.42018-0.14209-0.57388-0.34776-0.60803-0.8136-0.0355-0.4854,0.0116-0.56097,0.52453-0.84064l0.36556-0.19931,0.34646,0.1545c0.47988,0.21397,0.69338,0.44463,0.71031,0.76742,0.0182,0.34768-0.2397,0.70345-0.64012,0.8829-0.35162,0.15758-0.37253,0.15904-0.69871,0.0488z'/%3E %3Cpath d='m407.75,370.09c-0.34619-0.0109-0.82136,0.30729-1.0938,0.46875-0.64912,0.15215-1.4047,0.5511-2.0312,0.125-0.61719-0.19079-1.438-0.0404-1.5312,0.71875,0.15839,0.65179,1.0715,1.0243,1.625,0.59375,0.4106-0.53758,1.5312-0.8528,1.6562,0.0625-0.45705,0.69215-0.40489,1.6089-0.78125,2.3438-0.0612,0.45773-0.25176,0.8924-0.5,1.2812-0.4621,0.0464-0.95375-0.008-1.3438,0.28125-0.62601,0.0342-1.2647,0.34537-1.625,0.875-0.40338,0.57818-0.78869,1.1654-0.90625,1.875,0.10725,0.72494,0.93754,0.93275,1.5625,0.96875,0.66694,0.18359,1.3344,0.42433,2,0.625,1.0853,0.24303,2.102,0.63539,3.1875,0.875,1.5844,0.47758,3.2479,0.69739,4.8438,1.125,0.16722,0.0555,0.32405,0.1038,0.5,0.125,0.66233,0.13773,1.0079-0.58289,1.0625-1.125,0.32864-1.1596,0.57948-2.3391,0.90625-3.5,0.22487-0.46559,0.49645-1.5172-0.40625-1.2812-0.51485,0.30872-0.95182,0.7734-1.5938,0.8125-0.87392,0.0509-0.37513,0.94518-0.0312,1.3125,0.0759,0.5872-0.10989,1.2888-0.5,1.75-0.51994,0.32957-1.1716-0.0561-1.7188-0.1875-0.57469,0.01-1.7234-0.28325-1.1875-1.0625,0.19033-0.57691,0.20718-1.2083,0.4375-1.7812,0.29353-0.61455,0.33553-1.2851,0.46875-1.9375-0.36122-0.77733-0.97856,0.25585-1.4688,0.34375-0.33769,0.23455-1.6054,0.33418-0.9375,0.9375,0.57518,0.43696,0.1343,1.1967,0.0312,1.75-0.0369,0.77025-0.83781,0.95394-1.4688,0.78125-0.62768-0.0303-1.5013-0.49748-0.96875-1.1875,0.12115-0.57512,0.322-1.1402,0.4375-1.7188,0.2374-0.69777,0.43732-1.3628,0.6875-2.0625,0.10851-0.61996,0.33113-1.2079,0.625-1.75,0.0173-0.68543,0.47775-1.2752,0.46875-1.9688-0.0469-0.33876-0.19853-0.4622-0.40625-0.46875zm-3.5938,7.25c0.0817-0.0141,0.1399-0.002,0.21875,0.0312,0.24971,0.10625,0.25708,0.30938,0,0.53125-0.11238,0.097-0.23995,0.1905-0.28125,0.1875-0.46771-0.0402-0.6056-0.10974-0.625-0.28125-0.0172-0.15117,0.0307-0.19455,0.34375-0.34375,0.15556-0.0742,0.26207-0.11086,0.34375-0.125z'/%3E %3Cpath d='m403.12,382.36c-0.49596-0.46627-0.41621-0.80642,0.31729-1.3532,0.31384-0.23393,0.50421-0.20747,0.8631,0.11997,0.55237,0.50393,0.57448,0.82295,0.0869,1.2548-0.24101,0.21344-0.34645,0.25721-0.62697,0.26001-0.29347,0.003-0.3766-0.0334-0.64036-0.28155z'/%3E %3Cpath d='m406.17,383.28c-0.48488-0.11955-0.76441-0.60787-0.62254-1.0876,0.12852-0.43459,0.20285-0.47736,0.84026-0.48378,0.71478-0.007,0.85352,0.11244,0.86039,0.74185,0.004,0.35432-0.0235,0.43652-0.19971,0.60041-0.2071,0.19261-0.6052,0.29644-0.8784,0.22908z'/%3E %3Cpath d='m495.28,383.36c-0.22701-0.18894-0.27272-0.27435-0.27532-0.51479-0.003-0.41064,0.23349-0.71172,0.74605-0.94382,0.68183-0.30882,0.95981-0.26636,1.2166,0.18575,0.34158,0.60129,0.32512,0.84675-0.0839,1.252-0.22578,0.22366-0.26805,0.2367-0.78493,0.2419-0.50756,0.003-0.56562-0.0105-0.8185-0.22102z'/%3E %3Cpath d='m410.22,384.51c-0.36389-0.0971-0.5525-0.37016-0.55726-0.80675-0.004-0.33383,0.0201-0.38706,0.25362-0.56985,0.15122-0.11834,0.39018-0.21971,0.57856-0.24541,0.2669-0.0365,0.36442-0.0132,0.57916,0.13775,0.55052,0.38698,0.66746,0.76972,0.3487,1.1412-0.33953,0.39572-0.66141,0.48753-1.2028,0.34303z'/%3E %3Cpath d='m432.14,385.49c-0.0807-0.10062-0.25916-0.16012-0.2775-0.287,0.032-0.55487,0.0585-1.1167,0.23525-1.6482,0.0962-0.52301,0.012-1.0692,0.19432-1.5787,0.18698-0.92682,0.18682-1.8826,0.40217-2.8036,0.01-0.47427,0.0549-0.949,0.19241-1.4054,0.15774-0.72168,0.0136-1.4762,0.22606-2.1894-0.0228-0.26786,0.28574-0.98321,0.55658-0.55944,0.39321,0.57645,0.91139,1.0451,1.4208,1.5153,0.43771,0.25252,0.0359,0.62445-0.26658,0.74975-0.41521,0.16364-0.51613,0.62086-0.48666,1.0222-0.0582,0.41455-0.22464,0.80685-0.24153,1.23-0.0878,0.62242-0.0706,1.2546-0.15153,1.8765-0.18211,0.60901-0.11244,1.2597-0.17323,1.8875,0.008,0.39859-0.18142,0.7606-0.15525,1.1604-0.0484,0.40592-0.0665,0.89432-0.40713,1.1724-0.32888,0.16605-0.80429,0.13737-1.0682-0.14228z'/%3E %3Cpath d='m461.84,375.69c-0.48222,0.36463-0.91353,0.79527-1.3438,1.2188-0.59251,0.4489,0.48677,0.70998,0.625,1.0938,0.15716,0.58638,0.1478,1.2106,0.1875,1.8125,0.17923,0.55142,0.25835,1.1384,0.21875,1.7188-0.0519,0.6223-0.86338,0.49115-1.2188,0.84375-0.49176,0.20722-0.68789,0.69047-1.0625,1.0312-0.24625,0.48275-0.31215,1.0763-0.34375,1.625,0.0353,0.44788-0.30248,0.94931,0,1.3438,0.039,0.0557,0.0852,0.132,0.125,0.1875,0.10115,0.1452,0.3425,0.0292,0.5,0.0625,0.50368-0.0282,1.0285,0.0473,1.5-0.15625,1.21-0.20943,2.4311-0.22605,3.6562-0.28125,0.74925,0.0239,1.4701-0.23695,2.2188-0.21875,0.58681,0.12974,0.85075-0.50626,0.84375-0.96875-0.33224-0.65359-0.045-1.4285-0.3125-2.0938-0.23494-0.67246-0.14236-1.428-0.25-2.125-0.0148-0.54835-0.71068-0.75172-1.0625-0.34375-0.34144,0.34514-0.89289,0.41403-1.1562,0.84375-0.29659,0.60239,0.62745,0.60317,0.78125,1.0625,0.17589,0.4642,0.11825,0.98059,0.15625,1.4688,0.11422,0.59237-0.52919,0.6262-0.9375,0.6875-0.53675,0.20112-1.29,0.33589-1.5938-0.3125-0.1909-0.47948-0.16475-0.99286-0.21875-1.5-0.0131-0.89182-0.22755-1.7684-0.28125-2.6562-0.0514-1.0968-0.2407-2.1866-0.3125-3.2812-0.01-0.45549-0.0706-1.198-0.71875-1.0625zm-0.625,8.25,0.3125,0.0312,0.0312,0.375,0.0312,0.375-0.40625,0.125c-0.21512,0.0636-0.40325,0.0943-0.40625,0.0937-0.003-0.00085-0.088-0.0531-0.1875-0.125-0.21959-0.1586-0.16345-0.38503,0.125-0.6875,0.1626-0.17028,0.23879-0.2033,0.5-0.1875z'/%3E %3Cpath d='m431.25,374.66c-0.38018,0.13504-0.86245,0.69313-1.25,0.6875-0.88,0.0623-0.75718,0.91919-0.125,1.2188,0.0833,0.25988,0.005,0.58789,0.0312,0.875,0.12288,0.7896-0.37535,1.4249-0.28125,2.2188-0.0442,0.87031-0.30695,1.7177-0.34375,2.5938-0.24704,0.90327-0.24984,1.8321-0.40625,2.75-0.10431,0.82323-0.69963,0.53271-1.2188,0.3125-0.004-0.35689-0.0272-0.70562-0.0312-1.0625,0.21637-0.81711-0.44101-1.0556-1.0938-1.1562-0.68611,0.0649-1.0228-0.52316-0.875-1.125,0.29488-0.35103,1.036-0.2534,1.5-0.3125,0.9813,0.20342,0.9416-1.1118,0.4375-1.5625-0.34472-0.63567-1.1982-0.90926-1.4375-1.5625,0.0956-0.86642-0.47971-1.7322-1.1875-2.1562-1.0885-0.0764-1.9104,0.86306-2.3125,1.7812-0.4525,0.13085-0.90391,0.26657-1.3438,0.4375-0.70889,0.17748-1.7197,1.407-0.75,1.875,0.54424,0.14988,2.2002,0.52782,1.4688,1.2812-0.41224,0.7071-1.201,0.71914-1.9062,0.53125-0.72365,0.00063-1.5294-0.35207-1.5-1.1875-0.14765-0.74985-0.12337-1.5579-0.46875-2.25-0.14847-0.83929-1.1008-0.64297-1.1562,0.125-0.73341,0.53403-0.6357,1.3978-0.125,2.0312,0.31876,0.72891,0.003,1.5776-0.3125,2.25-0.19091,0.87497-1.1559,0.90473-1.8438,1.1875-0.33751,0.13104-1.6285-0.0779-1.1562,0.65625,0.75312,0.26578,1.6525,0.50493,2.4375,0.3125,0.82295-0.10214,1.5375-0.66484,1.9375-1.375,0.55266-0.56003,1.502-0.26685,2.2188-0.28125,0.7728-0.002,1.5626,0.54243,2.3125,0.1875,0.21739-0.56438,1.2219-1.4958,1.5312-0.53125-0.0526,0.86265,0.70932,1.3257,1.5,1.2188,0.86375-0.0494,0.54445,0.61096,0.53125,1.125,0.0571,0.93448,0.65972,1.4247,1.4375,1.8125,0.26491,0.0715,0.545,0.0474,0.8125,0,0.74793-0.23513,1.5536-0.5689,1.7812-1.4062,0.30361-0.68071,0.31071-1.4507,0.53125-2.1562,0.17722-1.1299,0.406-2.26,0.4375-3.4062,0.27617-1.0383,0.19684-2.136,0.40625-3.1875,0.13231-0.7818,0.2308-1.5634,0.3125-2.3438-0.0917-0.41735-0.27189-0.48727-0.5-0.40625zm-6.7812,4.1562c0.15144,0.0185,0.2356,0.20409,0.25,0.53125,0.016,0.36409,0.20628,0.66075,0.4375,0.71875,0.18245,0.0457,0.16681,0.23882-0.0312,0.375-0.11507,0.0791-0.3209,0.127-0.6875,0.125-0.57804-0.003-0.93643-0.15276-1.25-0.46875l-0.1875-0.1875,0.28125-0.1875c0.14178-0.10831,0.39834-0.33259,0.5625-0.5,0.28494-0.29065,0.47356-0.42473,0.625-0.40625z'/%3E %3Cpath d='m490.5,370.94c-0.56713,0.026-1.1373,0.11796-1.6562,0.25-1.0402-0.0647-1.5624,1.0271-0.5625,1.5625,0.60166,1.5343,1.5404-0.31684,2.5-0.1875,1.4375,0.27956,1.559,1.8323,1.7812,3,0.0809,1.1567,0.41439,2.2816,0.75,3.375,0.96222,1.0695-0.72072,1.7402-1.4375,0.90625-0.61128-0.66434-1.9204-1.4795-2.6562-0.5625-0.9036,0.38266-0.94069,1.5903-1.6875,1.9375-1.2091,0.36803-1.3613-1.1188-2-1.75-0.58724-0.82427-1.7103-0.89646-2.625-1.1875-0.42913-0.86865-0.20548-2.3456-1.0938-2.9375-0.7458,0.30425-2.1131,1.7022-0.96875,2.3438,1.1177,0.96067-0.48782,1.4011-1,2.0625-0.73158,0.81456-0.84849,1.936-0.96875,2.9688-1.2593,0.69566-1.5044-0.78769-1.6562-1.7188-0.0981-1.1115-1.0358-0.78521-1.6875-0.375-0.95249,0.38586-1.4281,1.2903-2.0938,2-0.0799,0.64767,0.0372,1.3567,0.0312,2.0312,0.21646,0.81142,1.2024,0.4303,1.8125,0.375,0.9788-0.40937,1.3795,0.62745,0.59375,1.2188-0.53181,0.67603-2.2198,0.32293-2.0625,1.4062,0.54395,0.0636,1.1105,0.0432,1.6562,0,1.0905-0.29799,2.2614-1.0673,2.375-2.2812,0.1436-1.0582,1.6676-0.86544,2.5-1.0938,1.0408-0.30002,2.2948-0.37704,2.5312,0.9375,0.70943,0.74499,2.2486,1.584,3.0312,0.5625,0.79451-0.48523,1.1764-1.3376,1.125-2.25-0.16203-0.78461,1.2688-0.81314,1.625-0.375,0.52141,0.85796,2.151,0.60478,2.9375,0.125,0.8361-0.61721,1.0176-1.705,2.2188-1.7188,1.7823-0.53352,3.6342-0.84122,5.375-1.5,1.4104-0.3073-0.2099-1.1977-0.5625-1.7188-1.0737-0.53098-2.0081,1.6419-3.2188,0.5625-0.93564-0.71605-0.87212-2.0766-1.2188-3.125-0.23714-1.3573-0.17721-2.9227-1.1562-4-0.67242-0.71491-1.586-0.887-2.5312-0.84375zm-6.8125,9.4688c0.12573-0.003,0.26757,0.0593,0.5,0.1875,0.43841,0.24193,0.75063,0.64294,0.75,0.96875-0.00043,0.21261-0.0545,0.22697-0.375,0.375-0.19719,0.091-0.4214,0.1885-0.5,0.1875-0.18098-0.002-0.62438-0.35688-0.625-0.5-0.00065-0.0594-0.0581-0.28649-0.125-0.46875-0.11761-0.32068-0.0994-0.31643,0.0625-0.53125,0.10347-0.13744,0.18677-0.21532,0.3125-0.21875zm6.5312,0.34375c0.37229-0.0244,0.59356,0.0918,0.75,0.375,0.18178,0.32896,0.0582,0.58095-0.40625,0.78125-0.20349,0.0878-0.407,0.15925-0.4375,0.15625-0.0306-0.003-0.19844-0.10253-0.375-0.21875-0.27012-0.17777-0.3095-0.26387-0.3125-0.46875-0.003-0.31541,0.34928-0.5967,0.78125-0.625zm-8.9375,0.0937c0.10904-0.017,0.20831,0.04,0.34375,0.15625,0.17999,0.15456,0.23685,0.27887,0.28125,0.59375,0.0314,0.21884,0.0265,0.50184,0,0.625-0.0486,0.2261-0.0532,0.21575-0.5625,0.21875-0.64029,0.006-0.6997-0.0639-0.6875-0.65625,0.008-0.37682,0.0118-0.4782,0.21875-0.6875,0.16044-0.16228,0.29721-0.23305,0.40625-0.25zm-5.5,1.4375c0.19951,0.0469,0.3879,0.19761,0.4375,0.4375,0.0656,0.3175,0.008,0.46223-0.25,0.59375-0.2221,0.1131-0.73401,0.1508-0.875,0.0625-0.0457-0.0286-0.1399-0.103-0.1875-0.1875-0.068-0.12114-0.0555-0.1794,0.0312-0.25,0.0605-0.0492,0.12539-0.11985,0.125-0.15625-0.0004-0.0364,0.0673-0.16316,0.15625-0.28125,0.14608-0.1939,0.36299-0.26563,0.5625-0.21875zm9.25,1.1875c0.17794-0.001,0.32863,0.0609,0.4375,0.15625,0.18526,0.16231,0.179,0.40039-0.0312,0.5625-0.13509,0.1044-0.87165,0.0948-1.125,0-0.11272-0.0421-0.15563-0.0987-0.15625-0.21875-0.002-0.14091,0.0375-0.22767,0.28125-0.34375,0.20425-0.0976,0.41581-0.15507,0.59375-0.15625z'/%3E %3Cpath d='m467.86,388.29c-0.0958-0.0625-0.23767-0.11699-0.0948-0.22157,0.17277-0.30247,0.51785-0.40716,0.82434-0.51974,0.54779-0.23732,1.0207-0.64036,1.3737-1.1184,0.05-0.33298,0.42384-0.51355,0.42219-0.86174,0.003-0.47487,0.0311-0.9616-0.0846-1.426-0.12837-0.4257-0.45147-0.75199-0.82649-0.97395-0.25667-0.20149-0.674-0.25712-0.76877-0.61402-0.0525-0.34279,0.25343-0.60401,0.36053-0.90935,0.22325-0.42151,0.41109-0.86364,0.6509-1.275,0.25912-0.2878,0.65892-0.0156,0.79298,0.26239,0.18915,0.27771,0.35679,0.57593,0.45076,0.89748,0.30225,0.33175,0.57024,0.72087,0.679,1.1618,0.14839,0.31056,0.38316,0.60234,0.36929,0.96609,0.0003,0.4164,0.23509,0.78738,0.22034,1.2063,0.0133,0.56042,0.0131,1.1449-0.19184,1.6741-0.14001,0.29344-0.42058,0.46964-0.60639,0.73256-0.31897,0.29554-0.67037,0.57899-1.0797,0.73615-0.28928,0.092-0.45706,0.42565-0.81934,0.34466-0.51458,0.009-1.0366,0.079-1.5472-0.004,0.0323,0.0542-0.15633-0.0915-0.12493-0.0573z'/%3E %3Cpath d='m461.01,388.74c-0.24268-0.24958-0.2952-0.35543-0.29788-0.60032-0.003-0.24747,0.0446-0.34567,0.2822-0.58569,0.43829-0.44275,0.65248-0.45344,1.4091-0.0705,0.72304,0.36598,0.9675,0.39912,1.0322,0.14002,0.0625-0.25022,0.47885-0.47916,0.87435-0.4808,0.25006-0.002,0.39157,0.0477,0.59183,0.20368,0.25136,0.19583,0.26349,0.22634,0.26989,0.67935,0.004,0.46299-0.002,0.48055-0.29042,0.73591-0.27723,0.24409-0.32183,0.25915-0.66541,0.22476-0.43718-0.0439-0.69954-0.24407-0.77073-0.58844-0.0516-0.25001-0.13942-0.3097-0.20523-0.1397-0.0209,0.0546-0.12864,0.12185-0.23894,0.1496-0.20352,0.0514-0.5488,0.26862-0.79415,0.50006-0.0927,0.0874-0.25526,0.12855-0.51863,0.13122-0.35563,0.003-0.40513-0.0183-0.67826-0.29915z'/%3E %3Cpath d='m441.19,379.84c-0.66466,0.007-1.3805,0.5662-1.4688,1.2188,0.15206,0.75226,0.77698,1.4895,0.375,2.2812,0.27756,1.0131-0.76147,1.3974-1.4688,0.8125-0.4271-0.97134-0.64349-2.0358-1.2812-2.9062-0.80411-0.22762-1.1545,1.0569-1.7188,1.5,0.27975,0.75505,1.0958,1.4324,1.1875,2.375,0.1952,0.91482-0.36128,1.9306-1.1562,2.4062-0.68584,0.65472-1.6254,0.42074-2.4688,0.5625-1.0242,0.59857,0.75182,0.81755,1.2188,0.84375,1.0477,0.10646,2.1354-0.0317,2.9062-0.8125,0.76911-0.36708,0.70971-1.6972,1.625-1.8438,1.5884-0.0709,3.1626,0.24355,4.75,0.28125,0.84936,0.20336,2.1635-0.10098,2.75,0.53125,0.002,1.1075,0.94078,1.7905,1.8438,2.2188,0.4987,0.13872,1.0241-0.47928,1.5312-0.59375,0.96531-0.30764,0.67182-1.502,1.25-1.9688,1.6504-0.0893,3.3163-0.0704,4.9688-0.0937,0.31463,0.008,0.40734-0.43988,0.625-0.625-0.0363-0.63881-0.0593-1.2726-0.15625-1.9062-0.31819-0.80653,0.0513-1.8446-0.53125-2.5312-0.83011-0.22606-1.5362,0.53355-2.375,0.59375-0.92616,0.41246-1.7065,1.2677-1.75,2.3125-0.54833,0.89658-1.4277-0.15958-1.125-0.90625-0.0346-0.32541,0.0704-0.70429-0.0312-1-0.50698-0.60814-1.3947-0.4094-2.0938-0.5-1.0184,0.0406-2.0127-0.17955-3.0312-0.15625-0.89293-0.0674-1.822,0.0777-2.6875-0.15625-1.0317-0.0293-0.88959-1.0382-1.0625-1.75-0.18299-0.13571-0.40345-0.18973-0.625-0.1875zm2,3.6875c0.34308,0.007,0.66656,0.052,1,0.0937,0.43082,0.0709,0.8899-0.14816,1.3125,0,0.97651,0.16608,1.9536,0.12685,2.9375,0.21875,0.25985-0.004,0.44579,0.18471,0.625,0.34375,0.002,0.68357,0.00066,1.3789,0,2.0625-0.0299,0.25767,0.0763,0.5982-0.15625,0.78125-0.0747,0.0513-0.1583,0.1072-0.25,0.125-0.27065-0.07-0.55731-0.2479-0.6875-0.5-0.0414-0.35742,0.0179-0.70404,0.0312-1.0625-0.007-0.0927,0.0404-0.237,0-0.3125-0.21278-0.15067-0.45387-0.249-0.71875-0.25-0.84945-0.0291-1.682-0.0916-2.5312-0.125-0.7069-0.0446-1.4333,0.0604-2.125-0.125-0.26845-0.0976-0.61789-0.0641-0.78125-0.34375-0.23417-0.27227,0.10362-0.59695,0.34375-0.71875,0.31827-0.1447,0.65692-0.19411,1-0.1875zm11.281,0.25c0.15866-0.002,0.20935,0.05,0.28125,0.34375,0.0459,0.18765,0.0996,0.4172,0.125,0.5,0.0363,0.11811-0.0218,0.15625-0.1875,0.21875-0.494,0.18646-0.98566,0.16797-1.1562-0.0625-0.0774-0.10454,0.0129-0.43451,0.15625-0.5625,0.28946-0.25851,0.60992-0.43691,0.78125-0.4375z'/%3E %3C/g%3E %3C/g%3E %3Cpath stroke-width='1.1502' d='m449.98,327.23c32.642-25.106,29.843-61.883,29.843-61.883-0.8613,0.17223-1.6795,0.25835-2.5408,0.25835-6.8471,0-23.178-3.9171-26.988-8.8926-4.0812,4.5034-20.77,8.8926-27.574,8.8926-0.86129,0-1.7225-0.0861-2.5407-0.25835,0,0-2.8422,36.776,29.8,61.883z'/%3E %3Cpath stroke-width='0.9157' d='m477.22,268.04c-0.28097,0.0176-0.5633,0.0264-0.8477,0.0264-6.2055,0-20.619-3.1838-26.175-7.9572-5.8195,4.4095-20.471,7.9572-26.576,7.9572-0.28635,0-0.56925-0.035-0.84965-0.0865-0.0142,1.3908,0.0581,2.8324,0.14448,4.1436,0.323,4.9008,1.1826,9.819,2.4876,14.552,4.1081,14.895,12.516,27.553,24.572,37.155,12.066-9.61,20.484-22.28,24.601-37.186,1.3071-4.7319,2.1694-9.6497,2.4955-14.55,0.0853-1.2845,0.15716-2.6918,0.14745-4.0545z'/%3E %3Cpath fill='%23c09300' stroke='none' d='m439.38,265.03c-5.8724,1.8448-12.229,3.0312-15.75,3.0312-0.28633,0-0.56336-0.0423-0.84375-0.0937-0.0142,1.3907,0.0699,2.8451,0.15625,4.1562,0.32298,4.9006,1.1638,9.7995,2.4688,14.531,2.765,10.025,7.5063,19.032,13.969,26.781v-48.406z'/%3E %3Cpath fill='%23c09300' stroke='none' d='m460,264.94,0,49.25c6.794-7.9213,11.733-17.206,14.594-27.562,1.307-4.7317,2.1427-9.6313,2.4688-14.531,0.0853-1.2844,0.16596-2.6999,0.15625-4.0625-0.28095,0.0176-0.55937,0.0312-0.84375,0.0312-3.7302,0-10.42-1.1704-16.375-3.125z'/%3E %3Cg stroke-width='1.2704'%3E %3Cpath stroke-width='1.2179' d='m462.31,253.09c0.66655,0.0392-0.90178-3.568-0.90178-3.568,1.7643,1.8036,8.4297,2.2349,8.4297,2.2349-3.999-1.7656-7.9979-15.096-7.528-25.721,0.4319-10.664-1.5284-14.859-3.0971-16.428-1.9995-1.9995-8.4298-3.7639-12.664-3.9991-2.3922-0.11761-1.9995,1.8036-1.9995,1.8036-4.4308-1.137-8.8606-1.5684-10.861-0.2353-1.882,1.2547-2.274,7.5278-0.90178,6.43,3.3326-2.6661,6.2341-0.23524,8.2335,2.6661,1.7644,2.5485,1.6467,9.7627-0.90178,18.192-2.6661,8.8609-9.9588,17.722-9.9588,17.722,3.96,0,9.5276-3.5287,9.5276-3.5287l-1.3331,5.5283c4.1951-1.9996,7.5278-5.0969,7.5278-5.0969l3.9992,4.1951c1.333-1.7643,3.9991-4.1951,3.9991-4.1951s3.3328,3.5286,8.4297,3.9992z'/%3E %3Cpath fill='none' d='m446.12,227.57s-2.2349,16.428-6.43,21.094'/%3E %3Cpath fill='none' d='m449.65,227.14s-0.86252,16.623-3.7639,21.956'/%3E %3Cpath fill='none' d='m452.78,227.81s0,18.192,1.0978,21.289'/%3E %3Cpath fill='none' d='m456.74,228.71s0.90178,15.291,4.6657,20.819'/%3E %3Cpath fill='%23c09300' stroke-width='0.3542' d='m442.08,219.61c-0.19598-1.4508-0.54888-2.5878-1.0586-3.3328-1.9996-2.9013-4.9009-5.3321-8.2335-2.6661,0,0,1.137-3.5287,3.5678-3.6463,1.882-0.11767,6.1556,1.4115,9.9196,7.8415,0,0-2.7837-0.62739-3.4502-0.0393-1.2546,1.0979-0.74495,1.8428-0.74495,1.8428z'/%3E %3Cpath fill='%23c09300' stroke-width='0.3542' d='m432.44,209.26c0.27439-0.90178,0.7057-1.7251,1.2546-2.078,1.9996-1.333,6.43-0.90177,10.86,0.23524,0,0-0.39205-1.9212,1.9996-1.8036,4.2344,0.23523,10.665,1.9996,12.664,3.9992,0.47046,0.50973,1.0194,1.2547,1.4899,2.3916h-0.0784c-0.98015-1.3721-3.764-1.2937-4.4308-1.2154-1.0586,0.11756-1.7251,0.0784-3.1365,0.4312-0.66655,0.15693-1.686,0.3529-2.2349,0.78422-0.43131,0.3529-0.7841,1.6467-1.4506,1.6467-1.0586,0-0.98019-0.27449-1.2547-0.58814-0.35279-0.43131-0.54888-1.0586-0.90178-1.0194-1.0978,0.19608-2.8621-0.66644-5.0969-2.4308-2.2344-1.7644-3.0971-2.1956-5.9984-1.9996-2.8622,0.23524-3.7639,1.8427-3.7639,1.8427l0.0784-0.19598z'/%3E %3Ccircle cx='448.824' cy='210.672' r='1.176' stroke='none'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='1000' height='500'%3E %3Crect width='1000' height='500' fill='%23ea0437'/%3E %3Cpath d='M 0,500 H 1000 V 250' fill='%234189dd'/%3E %3Cpath d='M 0,0 H 1000 V 250' fill='%2312ad2b'/%3E %3Cpath d='m 230.24958,369.16163 c -10.81019,2.98487 -17.00779,11.37176 -16.84908,19.28459 l 53.21067,-.21363 c .47814,-8.50288 -6.51706,-16.36688 -17.16651,-19.46365 52.09769,-1.07633 97.35688,-20.59084 105.581,-33.1122 -8.13867,-3.53218 -17.549,2.15268 -24.25731,.84438 15.92738,-7.36142 63.64648,-38.2477 55.88829,-71.3599 -6.03077,18.39137 -24.30006,33.60865 -32.08062,37.69427 17.82572,-27.0672 42.16648,-55.24736 21.04864,-77.06919 1.06617,12.64749 -8.03695,26.56668 -12.05744,27.61248 10.34017,-28.59929 20.20628,-64.50713 -2.19744,-88.17848 2.94212,8.55578 1.75387,32.69103 -2.29716,33.77551 -1.24724,-19.44736 -4.56579,-60.35236 -25.04676,-59.77044 6.50483,5.79067 9.35132,21.59597 9.49579,37.55999 -4.66752,-10.93635 -9.97191,-19.17065 -21.31722,-27.24625 -9.1784,-17.60192 -25.50865,-32.18643 -41.84094,-42.63446 1.83323,12.81231 3.3511,22.92055 21.2399,36.20897 -9.32691,-.57988 -18.65181,-18.26115 -28.61965,-18.75151 -7.9291,-.38252 -14.15112,7.18442 -27.10788,2.83023 1.43443,4.27687 7.47944,6.17115 8.75516,9.33506 -2.77528,1.91666 -9.36353,-.2991 -14.84086,-3.1517 7.53437,10.26287 19.2093,16.29769 29.12018,14.26099 11.78683,-2.26662 24.42417,-1.0682 36.47755,5.79067 -3.07847,1.58094 -15.06063,1.57076 -22.74963,.60837 6.98908,7.07657 11.67696,11.76649 23.83003,11.68917 10.85496,-.0712 16.54593,-5.79067 19.33342,-2.24831 6.80802,8.06746 11.39008,16.13085 17.08512,25.62869 -12.58035,1.38968 -8.78773,-14.22843 -22.79846,-22.21654 -7.87213,16.29363 9.05427,35.60873 20.57661,43.63753 .15464,12.24667 1.94515,22.49328 7.13964,31.81816 3.50167,6.57402 8.02882,13.30267 6.32173,28.13947 -6.89753,-5.0236 -13.63838,-21.96628 -11.15813,-35.41544 -8.6331,2.35412 -12.00862,17.53477 -7.93928,25.177 3.0398,5.81712 5.06836,16.95083 1.56263,21.92763 -3.41621,4.63701 -3.77431,4.11816 -3.72955,14.06973 .12208,5.95547 -3.2046,12.99747 -8.62293,17.90712 1.13128,-4.19549 2.42126,-11.4145 1.1679,-15.9274 -4.28297,7.26581 -15.02806,14.78391 -18.41171,22.59501 -3.32262,7.82941 -4.16498,21.39048 -20.24496,24.51776 -20.68648,4.10597 -27.82614,7.69106 -41.13694,13.13786 -1.47717,-10.11027 2.94416,-31.19351 11.39822,-29.99103 8.25464,1.46904 33.28107,-8.62292 24.32853,-29.70616 -1.76813,6.64524 -7.66663,13.12972 -14.04328,13.41661 6.88939,-8.9383 19.18489,-18.19401 13.19686,-33.17121 -3.32872,6.36648 -8.56392,14.00667 -16.5032,18.30592 8.51101,-16.30991 .98885,-21.18904 -9.11736,-7.75616 -3.81704,5.1823 -6.12232,15.56724 -8.54765,28.75598 -3.96963,-10.72678 -3.70716,-24.84738 -8.41131,-36.31274 -4.91373,-12.39928 6.52111,-15.67305 11.90282,-14.67811 13.17651,3.51795 35.19773,3.51591 33.56185,-18.25301 -5.69096,7.36346 -15.67102,9.63823 -26.44865,6.98704 12.10424,-8.83859 21.66109,-25.46387 8.17326,-34.14377 -.44966,9.20485 -7.57304,19.52469 -17.08309,24.27768 -2.22592,-7.76634 -2.22592,-16.00879 -.3174,-25.04475 -5.31048,5.58923 -9.18856,17.2194 -12.27312,30.44068 -.23196,-13.06868 2.24017,-22.48513 4.0734,-29.51491 2.77936,-10.26897 9.68706,-3.58712 20.26124,-2.83022 10.18352,.57784 24.20443,-5.05005 21.52476,-18.85935 -3.47724,5.46309 -10.61486,7.58932 -17.90712,7.01148 8.7796,-5.31863 24.07624,-14.76967 15.6873,-29.30738 -3.52405,5.50581 -4.6655,10.21606 -14.8653,11.90485 2.67152,-6.14471 3.11509,-14.83274 11.03199,-18.27539 -14.12264,-2.81192 -22.20842,6.456 -26.31845,20.97132 -1.6664,-10.06347 -3.65019,-13.7686 -4.04493,-21.13003 7.63408,-8.47848 8.43371,-25.06509 -8.0939,-28.7743 -.98072,8.55579 -.68976,10.59453 1.19027,17.56123 -7.75819,-4.60852 -18.6925,-7.15186 -25.97254,-.63481 4.93203,5.3227 12.56611,10.00854 24.3326,4.20363 -2.77936,9.09292 -10.00854,7.53641 -19.94179,4.06932 6.07146,11.40432 13.73402,13.43087 22.1901,12.11647 4.42744,11.67289 4.62277,20.54201 -8.3157,37.54168 .59819,-10.564 -.15259,-18.43411 -8.5456,-26.97565 -7.19256,-7.04402 -13.03816,.30114 -1.79865,15.96198 -6.81818,-5.02156 -14.53567,-15.21321 -16.85927,-25.40284 -2.2483,12.58849 -.22381,27.42531 6.74493,35.74304 -3.29616,3.522 -7.04403,-.37439 -12.5885,-8.99122 2.09775,27.57587 13.8622,32.89653 29.67362,26.74981 .44966,15.13589 .44966,29.1507 1.34898,47.43424 -9.21908,-13.26199 -20.90623,-23.15455 -27.42733,-25.62667 -2.02247,7.41841 5.62179,17.08308 9.89256,22.47902 -6.51909,-1.34898 -20.68242,-12.13883 -20.68242,-12.13883 -1.42427,12.28941 14.46447,23.67949 24.72938,28.77429 -12.06357,-.52495 -17.38626,-5.0948 -25.17904,-12.5885 .15057,34.09496 36.94145,28.17406 43.83694,22.92869 .89933,16.78601 2.18117,36.19065 3.0805,52.97669 -10.40123,-1.81493 -9.5833,-4.94223 -18.48295,-5.76626 -24.70088,-.9624 -44.29473,-29.65123 -50.78329,-50.75482 -1.86173,3.47317 -.38456,7.10709 -2.08757,11.3738 -4.01034,-10.3585 -9.13363,-23.73645 -16.00471,-29.96253 1.74981,6.03889 1.93497,12.17545 1.3266,23.46176 -2.35818,-7.31259 -4.55155,-9.5548 -4.71026,-18.13907 .15057,-6.59029 6.35834,-11.45316 6.01449,-20.72311 -.25434,-6.76731 -6.42752,-21.43525 -7.33499,-32.79073 -2.98893,11.68715 -4.86489,24.00707 -9.44289,31.24235 2.27476,-12.48066 1.54553,-21.09341 5.3939,-29.49253 4.44575,-8.84267 8.22617,-16.73718 5.26573,-25.66125 -2.83837,3.44674 -1.86173,6.57808 -8.99304,14.95279 -1.54899,-9.10719 9.22092,-23.68356 19.67301,-29.5434 7.37162,-3.88419 16.66394,-17.77691 10.6108,-27.29915 -6.93211,4.97883 -10.04516,11.70544 -19.83802,23.1993 6.98502,-27.30527 25.13426,-34.44899 46.8625,-34.54258 4.80792,-.0224 14.50109,-1.75796 17.22144,-8.12037 -6.12435,2.36429 -13.36574,2.66542 -19.80954,1.37544 4.68991,-6.88532 14.5662,-5.99007 23.769,-6.03076 7.219,-.0346 18.48904,-1.01327 23.04467,-11.29445 -8.80605,3.815 -22.54007,4.60853 -31.18741,1.90648 13.75232,-7.12541 35.29336,-7.89248 46.34162,-17.24382 -12.59256,-9.39813 -44.10349,2.18931 -64.00661,15.8399 5.56278,-5.08667 14.35457,-14.11043 19.20523,-21.39454 -10.88547,-5.21893 -38.41454,25.27873 -47.89814,43.39949 -9.00748,5.08666 -12.61088,13.06054 -16.10848,18.62537 4.79979,-16.21836 5.30845,-27.98688 9.31268,-41.34245 -30.87691,10.62911 -18.04263,67.6792 -24.75887,81.32776 .79047,-15.06877 .15036,-34.42661 -6.05355,-44.40869 -9.51045,7.25563 -10.27792,49.95927 -1.34898,85.51104 -3.22434,-9.51411 -9.31004,-18.39545 -11.2625,-29.97475 -14.075438,25.67142 8.25119,55.95747 26.9207,79.8811 -14.05509,-7.32073 -27.95188,-23.06704 -37.08022,-36.26796 2.51954,45.94689 50.5009,55.49356 57.94982,66.78596 -10.11027,-4.70617 -29.43881,-14.01886 -37.64056,-4.26059 13.3519,3.08253 24.00218,6.64523 32.58441,12.27109 12.45217,15.54691 36.03195,22.34677 77.09767,24.06403 z' fill='%23ffc726'/%3E %3C/svg%3E"

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' height='500' width='750'%3E %3Crect fill='%23c60b1e' height='500' width='750'/%3E %3Crect fill='%23ffc400' height='250' width='750' y='125'/%3E %3Cpath d='M167.989 222.241C167.989 222.241 167.478 222.241 167.197 222.081 166.916 221.918 166.069 221.116 166.069 221.116L165.39 220.632 164.772 219.776C164.772 219.776 164.037 218.605 164.374 217.692 164.711 216.783 165.277 216.46 165.788 216.194 166.297 215.927 167.366 215.605 167.366 215.605 167.366 215.605 168.217 215.231 168.498 215.175 168.779 215.122 169.799 214.855 169.799 214.855 169.799 214.855 170.081 214.696 170.362 214.589 170.647 214.482 171.041 214.482 171.269 214.426 171.494 214.372 172.061 214.191 172.398 214.173 172.923 214.152 173.755 214.266 174.04 214.266 174.321 214.266 175.282 214.322 175.675 214.322 176.069 214.322 177.482 214.212 177.879 214.212 178.273 214.212 178.558 214.163 179.012 214.212 179.462 214.266 180.253 214.531 180.481 214.642 180.707 214.749 182.064 215.231 182.571 215.391 183.08 215.547 184.325 215.764 184.892 216.031 185.453 216.301 185.799 216.752 186.08 217.127 186.365 217.501 186.417 217.909 186.53 218.178 186.638 218.445 186.642 219.02 186.534 219.287 186.42 219.553 186.02 220.104 186.02 220.104L185.397 221.119 184.607 221.758C184.607 221.758 184.04 222.298 183.591 222.241 183.136 222.195 178.558 221.385 175.619 221.385 172.679 221.385 167.985 222.241 167.985 222.241' fill='%23ad1519'/%3E %3Cpath d='M167.989 222.241C167.989 222.241 167.478 222.241 167.197 222.081 166.916 221.918 166.069 221.116 166.069 221.116L165.39 220.632 164.772 219.776C164.772 219.776 164.037 218.605 164.374 217.692 164.711 216.783 165.277 216.46 165.788 216.194 166.297 215.927 167.366 215.605 167.366 215.605 167.366 215.605 168.217 215.231 168.498 215.175 168.779 215.122 169.799 214.855 169.799 214.855 169.799 214.855 170.081 214.696 170.362 214.589 170.647 214.482 171.041 214.482 171.269 214.426 171.494 214.372 172.061 214.191 172.398 214.173 172.923 214.152 173.755 214.266 174.04 214.266 174.321 214.266 175.282 214.322 175.675 214.322 176.069 214.322 177.482 214.212 177.879 214.212 178.273 214.212 178.558 214.163 179.012 214.212 179.462 214.266 180.253 214.531 180.481 214.642 180.707 214.749 182.064 215.231 182.571 215.391 183.08 215.547 184.325 215.764 184.892 216.031 185.453 216.301 185.799 216.752 186.08 217.127 186.365 217.501 186.417 217.909 186.53 218.178 186.638 218.445 186.642 219.02 186.534 219.287 186.42 219.553 186.02 220.104 186.02 220.104L185.397 221.119 184.607 221.758C184.607 221.758 184.04 222.298 183.591 222.241 183.136 222.195 178.558 221.385 175.619 221.385 172.679 221.385 167.985 222.241 167.985 222.241L167.989 222.241z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.26'/%3E %3Cpath d='M174.277 215.682C174.277 214.301 174.895 213.186 175.656 213.186 176.417 213.186 177.036 214.301 177.036 215.682 177.036 217.057 176.417 218.175 175.656 218.175 174.895 218.175 174.277 217.057 174.277 215.682' fill='%23c8b100'/%3E %3Cpath d='M174.277 215.682C174.277 214.301 174.895 213.186 175.656 213.186 176.417 213.186 177.036 214.301 177.036 215.682 177.036 217.057 176.417 218.175 175.656 218.175 174.895 218.175 174.277 217.057 174.277 215.682z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.049 215.682C175.049 214.412 175.334 213.382 175.682 213.382 176.035 213.382 176.316 214.412 176.316 215.682 176.316 216.943 176.035 217.973 175.682 217.973 175.334 217.973 175.049 216.943 175.049 215.682' fill='%23c8b100'/%3E %3Cpath d='M175.049 215.682C175.049 214.412 175.334 213.382 175.682 213.382 176.035 213.382 176.316 214.412 176.316 215.682 176.316 216.943 176.035 217.973 175.682 217.973 175.334 217.973 175.049 216.943 175.049 215.682z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M174.752 213.044C174.752 212.565 175.165 212.167 175.675 212.167 176.185 212.167 176.598 212.565 176.598 213.044 176.598 213.527 176.185 213.914 175.675 213.914 175.165 213.914 174.752 213.527 174.752 213.044' fill='%23c8b100'/%3E %3Cpath d='M176.327 212.735L176.327 213.317 174.899 213.317 174.899 212.735 175.367 212.735 175.367 211.425 174.749 211.425 174.749 210.846 175.367 210.846 175.367 210.278 175.974 210.278 175.974 210.846 176.59 210.846 176.59 211.425 175.974 211.425 175.974 212.735 176.327 212.735' fill='%23c8b100'/%3E %3Cpath d='M176.327 212.735L176.327 213.317 174.899 213.317 174.899 212.735 175.367 212.735 175.367 211.425 174.749 211.425 174.749 210.846 175.367 210.846 175.367 210.278 175.974 210.278 175.974 210.846 176.59 210.846 176.59 211.425 175.974 211.425 175.974 212.735 176.327 212.735' fill='none' stroke='%23000' stroke-width='0.3'/%3E %3Cpath d='M176.965 212.735L176.965 213.317 174.43 213.317 174.43 212.735 175.367 212.735 175.367 211.425 174.749 211.425 174.749 210.846 175.367 210.846 175.367 210.278 175.974 210.278 175.974 210.846 176.59 210.846 176.59 211.425 175.974 211.425 175.974 212.735 176.965 212.735' fill='%23c8b100'/%3E %3Cpath d='M176.965 212.735L176.965 213.317 174.43 213.317 174.43 212.735 175.367 212.735 175.367 211.425 174.749 211.425 174.749 210.846 175.367 210.846 175.367 210.278 175.974 210.278 175.974 210.846 176.59 210.846 176.59 211.425 175.974 211.425 175.974 212.735 176.965 212.735' fill='none' stroke='%23000' stroke-width='0.3'/%3E %3Cpath d='M175.941 212.203C176.324 212.309 176.598 212.647 176.598 213.044 176.598 213.527 176.185 213.914 175.675 213.914 175.165 213.914 174.752 213.527 174.752 213.044 174.752 212.64 175.041 212.295 175.435 212.199' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.678 222.081L170.871 222.081 170.76 220.902 170.534 219.674 170.295 218.14C168.97 216.392 167.752 215.245 167.343 215.491 167.441 215.168 167.557 214.926 167.813 214.777 168.99 214.077 171.419 215.757 173.246 218.516 173.41 218.768 173.568 219.02 173.707 219.273L177.677 219.273C177.82 219.024 177.977 218.772 178.142 218.516 179.965 215.757 182.397 214.077 183.571 214.777 183.826 214.926 183.943 215.168 184.044 215.491 183.632 215.249 182.417 216.392 181.085 218.14L180.849 219.674 180.624 220.902 180.515 222.081 175.682 222.081' fill='%23c8b100'/%3E %3Cpath d='M175.678 222.081L170.871 222.081 170.76 220.902 170.534 219.674 170.295 218.14C168.97 216.392 167.752 215.245 167.343 215.491 167.441 215.168 167.557 214.926 167.813 214.777 168.99 214.077 171.419 215.757 173.246 218.516 173.41 218.768 173.568 219.02 173.707 219.273L177.677 219.273C177.82 219.024 177.977 218.772 178.142 218.516 179.965 215.757 182.397 214.077 183.571 214.777 183.826 214.926 183.943 215.168 184.044 215.491 183.632 215.249 182.417 216.392 181.085 218.14L180.849 219.674 180.624 220.902 180.515 222.081 175.682 222.081 175.678 222.081z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M167.554 215.445C168.457 214.912 170.568 216.585 172.281 219.183M183.83 215.445C182.923 214.912 180.816 216.585 179.102 219.183' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M168.577 224.251C168.378 223.679 168 223.168 168 223.168 169.946 222.596 172.657 222.237 175.671 222.23 178.682 222.237 181.416 222.596 183.358 223.168 183.358 223.168 183.14 223.551 182.84 224.084 182.671 224.379 182.451 224.893 182.465 224.893 180.707 224.354 178.442 224.077 175.656 224.074 172.874 224.077 170.197 224.418 168.802 224.929 168.817 224.929 168.705 224.606 168.566 224.251L168.577 224.251' fill='%23c8b100'/%3E %3Cpath d='M168.577 224.251C168.378 223.679 168 223.168 168 223.168 169.946 222.596 172.657 222.237 175.671 222.23 178.682 222.237 181.416 222.596 183.358 223.168 183.358 223.168 183.14 223.551 182.84 224.084 182.671 224.379 182.451 224.893 182.465 224.893 180.707 224.354 178.442 224.077 175.656 224.074 172.874 224.077 170.197 224.418 168.802 224.929 168.817 224.929 168.705 224.606 168.566 224.251L168.577 224.251' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.671 226.726C178.101 226.722 180.781 226.353 181.768 226.098 182.432 225.905 182.817 225.607 182.747 225.263 182.713 225.1 182.571 224.958 182.379 224.876 180.924 224.411 178.31 224.081 175.671 224.077 173.035 224.081 170.403 224.411 168.952 224.876 168.761 224.958 168.618 225.1 168.585 225.263 168.513 225.607 168.9 225.905 169.559 226.098 170.549 226.353 173.242 226.722 175.671 226.726' fill='%23c8b100'/%3E %3Cpath d='M175.671 226.726C178.101 226.722 180.781 226.353 181.768 226.098 182.432 225.905 182.817 225.607 182.747 225.263 182.713 225.1 182.571 224.958 182.379 224.876 180.924 224.411 178.31 224.081 175.671 224.077 173.035 224.081 170.403 224.411 168.952 224.876 168.761 224.958 168.618 225.1 168.585 225.263 168.513 225.607 168.9 225.905 169.559 226.098 170.549 226.353 173.242 226.722 175.671 226.726z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M183.482 222.081L182.886 221.546C182.886 221.546 182.323 221.893 181.614 221.786 180.909 221.68 180.681 220.825 180.681 220.825 180.681 220.825 179.889 221.488 179.241 221.439 178.592 221.381 178.168 220.825 178.168 220.825 178.168 220.825 177.464 221.328 176.841 221.279 176.219 221.222 175.626 220.448 175.626 220.448 175.626 220.448 175.004 221.25 174.382 221.307 173.759 221.357 173.249 220.767 173.249 220.767 173.249 220.767 172.968 221.357 172.176 221.488 171.386 221.623 170.71 220.874 170.71 220.874 170.71 220.874 170.257 221.598 169.721 221.786 169.185 221.974 168.476 221.516 168.476 221.516 168.476 221.516 168.363 221.786 168.281 221.946 168.195 222.106 167.97 222.135 167.97 222.135L168.146 222.614C170.084 222.053 172.709 221.705 175.678 221.702 178.652 221.705 181.348 222.053 183.291 222.618L183.489 222.081' fill='%23c8b100'/%3E %3Cpath d='M183.482 222.081L182.886 221.546C182.886 221.546 182.323 221.893 181.614 221.786 180.909 221.68 180.681 220.825 180.681 220.825 180.681 220.825 179.889 221.488 179.241 221.439 178.592 221.381 178.168 220.825 178.168 220.825 178.168 220.825 177.464 221.328 176.841 221.279 176.219 221.222 175.626 220.448 175.626 220.448 175.626 220.448 175.004 221.25 174.382 221.307 173.759 221.357 173.249 220.767 173.249 220.767 173.249 220.767 172.968 221.357 172.176 221.488 171.386 221.623 170.71 220.874 170.71 220.874 170.71 220.874 170.257 221.598 169.721 221.786 169.185 221.974 168.476 221.516 168.476 221.516 168.476 221.516 168.363 221.786 168.281 221.946 168.195 222.106 167.97 222.135 167.97 222.135L168.146 222.614C170.084 222.053 172.709 221.705 175.678 221.702 178.652 221.705 181.348 222.053 183.291 222.618L183.489 222.081 183.482 222.081z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.686 219.492L175.967 219.543C175.922 219.66 175.911 219.783 175.911 219.915 175.911 220.497 176.409 220.97 177.029 220.97 177.523 220.97 177.94 220.664 178.086 220.242 178.105 220.253 178.195 219.858 178.24 219.865 178.273 219.865 178.269 220.274 178.288 220.267 178.356 220.795 178.843 221.158 179.391 221.158 180.006 221.158 180.499 220.686 180.499 220.104 180.499 220.06 180.499 220.018 180.493 219.976L180.842 219.627 181.033 220.071C180.955 220.206 180.928 220.362 180.928 220.53 180.928 221.087 181.405 221.538 181.989 221.538 182.36 221.538 182.682 221.357 182.874 221.087L183.099 220.803 183.095 221.155C183.095 221.502 183.245 221.815 183.587 221.872 183.587 221.872 183.972 221.9 184.498 221.488 185.015 221.08 185.3 220.739 185.3 220.739L185.333 221.158C185.333 221.158 184.824 221.996 184.359 222.262 184.107 222.411 183.716 222.568 183.41 222.514 183.088 222.465 182.856 222.202 182.735 221.904 182.506 222.042 182.233 222.12 181.94 222.12 181.31 222.12 180.744 221.772 180.52 221.258 180.231 221.57 179.83 221.758 179.357 221.758 178.854 221.758 178.393 221.534 178.105 221.183 177.82 221.446 177.433 221.606 177.01 221.606 176.455 221.606 175.956 221.328 175.675 220.92 175.393 221.328 174.899 221.606 174.344 221.606 173.92 221.606 173.534 221.446 173.249 221.183 172.961 221.534 172.499 221.758 171.996 221.758 171.524 221.758 171.123 221.57 170.834 221.258 170.61 221.769 170.043 222.12 169.413 222.12 169.12 222.12 168.847 222.042 168.618 221.904 168.498 222.202 168.266 222.465 167.943 222.514 167.636 222.568 167.25 222.411 166.995 222.262 166.53 221.996 165.982 221.158 165.982 221.158L166.053 220.739C166.053 220.739 166.342 221.08 166.856 221.488 167.378 221.9 167.767 221.872 167.767 221.872 168.109 221.815 168.259 221.502 168.259 221.155L168.255 220.803 168.479 221.087C168.67 221.357 168.994 221.538 169.364 221.538 169.949 221.538 170.425 221.087 170.425 220.53 170.425 220.362 170.399 220.206 170.325 220.071L170.512 219.627 170.86 219.976C170.853 220.018 170.849 220.06 170.849 220.104 170.849 220.686 171.345 221.158 171.963 221.158 172.511 221.158 172.994 220.795 173.066 220.267 173.081 220.274 173.077 219.865 173.114 219.865 173.159 219.858 173.253 220.253 173.268 220.242 173.414 220.664 173.834 220.97 174.329 220.97 174.943 220.97 175.443 220.497 175.443 219.915 175.443 219.783 175.435 219.66 175.386 219.543L175.678 219.492' fill='%23c8b100'/%3E %3Cpath d='M175.686 219.492L175.967 219.543C175.922 219.66 175.911 219.783 175.911 219.915 175.911 220.497 176.409 220.97 177.029 220.97 177.523 220.97 177.94 220.664 178.086 220.242 178.105 220.253 178.195 219.858 178.24 219.865 178.273 219.865 178.269 220.274 178.288 220.267 178.356 220.795 178.843 221.158 179.391 221.158 180.006 221.158 180.499 220.686 180.499 220.104 180.499 220.06 180.499 220.018 180.493 219.976L180.842 219.627 181.033 220.071C180.955 220.206 180.928 220.362 180.928 220.53 180.928 221.087 181.405 221.538 181.989 221.538 182.36 221.538 182.682 221.357 182.874 221.087L183.099 220.803 183.095 221.155C183.095 221.502 183.245 221.815 183.587 221.872 183.587 221.872 183.972 221.9 184.498 221.488 185.015 221.08 185.3 220.739 185.3 220.739L185.333 221.158C185.333 221.158 184.824 221.996 184.359 222.262 184.107 222.411 183.716 222.568 183.41 222.514 183.088 222.465 182.856 222.202 182.735 221.904 182.506 222.042 182.233 222.12 181.94 222.12 181.31 222.12 180.744 221.772 180.52 221.258 180.231 221.57 179.83 221.758 179.357 221.758 178.854 221.758 178.393 221.534 178.105 221.183 177.82 221.446 177.433 221.606 177.01 221.606 176.455 221.606 175.956 221.328 175.675 220.92 175.393 221.328 174.899 221.606 174.344 221.606 173.92 221.606 173.534 221.446 173.249 221.183 172.961 221.534 172.499 221.758 171.996 221.758 171.524 221.758 171.123 221.57 170.834 221.258 170.61 221.769 170.043 222.12 169.413 222.12 169.12 222.12 168.847 222.042 168.618 221.904 168.498 222.202 168.266 222.465 167.943 222.514 167.636 222.568 167.25 222.411 166.995 222.262 166.53 221.996 165.982 221.158 165.982 221.158L166.053 220.739C166.053 220.739 166.342 221.08 166.856 221.488 167.378 221.9 167.767 221.872 167.767 221.872 168.109 221.815 168.259 221.502 168.259 221.155L168.255 220.803 168.479 221.087C168.67 221.357 168.994 221.538 169.364 221.538 169.949 221.538 170.425 221.087 170.425 220.53 170.425 220.362 170.399 220.206 170.325 220.071L170.512 219.627 170.86 219.976C170.853 220.018 170.849 220.06 170.849 220.104 170.849 220.686 171.345 221.158 171.963 221.158 172.511 221.158 172.994 220.795 173.066 220.267 173.081 220.274 173.077 219.865 173.114 219.865 173.159 219.858 173.253 220.253 173.268 220.242 173.414 220.664 173.834 220.97 174.329 220.97 174.943 220.97 175.443 220.497 175.443 219.915 175.443 219.783 175.435 219.66 175.386 219.543L175.678 219.492 175.686 219.492z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.671 222.234C172.657 222.237 169.946 222.596 168.004 223.172 167.872 223.214 167.711 223.114 167.67 222.997 167.628 222.874 167.722 222.721 167.85 222.678 169.803 222.081 172.581 221.705 175.671 221.702 178.757 221.705 181.547 222.081 183.5 222.678 183.628 222.721 183.721 222.874 183.68 222.997 183.643 223.114 183.478 223.214 183.35 223.172 181.405 222.596 178.682 222.237 175.671 222.234' fill='%23c8b100'/%3E %3Cpath d='M175.671 222.234C172.657 222.237 169.946 222.596 168.004 223.172 167.872 223.214 167.711 223.114 167.67 222.997 167.628 222.874 167.722 222.721 167.85 222.678 169.803 222.081 172.581 221.705 175.671 221.702 178.757 221.705 181.547 222.081 183.5 222.678 183.628 222.721 183.721 222.874 183.68 222.997 183.643 223.114 183.478 223.214 183.35 223.172 181.405 222.596 178.682 222.237 175.671 222.234z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.26'/%3E %3Cpath d='M172.754 223.303C172.754 223.076 172.949 222.891 173.192 222.891 173.433 222.891 173.627 223.076 173.627 223.303 173.627 223.533 173.433 223.714 173.192 223.714 172.949 223.714 172.754 223.533 172.754 223.303' fill='%23fff'/%3E %3Cpath d='M172.754 223.303C172.754 223.076 172.949 222.891 173.192 222.891 173.433 222.891 173.627 223.076 173.627 223.303 173.627 223.533 173.433 223.714 173.192 223.714 172.949 223.714 172.754 223.533 172.754 223.303z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.705 223.481L174.738 223.481C174.558 223.481 174.408 223.339 174.408 223.168 174.408 223 174.554 222.863 174.73 222.863L176.694 222.863C176.875 222.863 177.018 223 177.018 223.168 177.018 223.339 176.871 223.481 176.691 223.481L175.705 223.481' fill='%23ad1519'/%3E %3Cpath d='M175.705 223.481L174.738 223.481C174.558 223.481 174.408 223.339 174.408 223.168 174.408 223 174.554 222.863 174.73 222.863L176.694 222.863C176.875 222.863 177.018 223 177.018 223.168 177.018 223.339 176.871 223.481 176.691 223.481L175.705 223.481' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M170.849 223.814L170.156 223.917C169.979 223.942 169.807 223.828 169.781 223.658 169.755 223.491 169.875 223.335 170.051 223.31L170.748 223.207 171.461 223.097C171.637 223.076 171.802 223.186 171.832 223.353 171.854 223.519 171.734 223.679 171.558 223.704L170.849 223.814' fill='%23058e6e'/%3E %3Cpath d='M170.849 223.814L170.156 223.917C169.979 223.942 169.807 223.828 169.781 223.658 169.755 223.491 169.875 223.335 170.051 223.31L170.748 223.207 171.461 223.097C171.637 223.076 171.802 223.186 171.832 223.353 171.854 223.519 171.734 223.679 171.558 223.704L170.849 223.814' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M168.048 224.3L168.356 223.804 169.012 223.928 168.629 224.486 168.048 224.3' fill='%23ad1519'/%3E %3Cpath d='M168.048 224.3L168.356 223.804 169.012 223.928 168.629 224.486 168.048 224.3' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M177.718 223.303C177.718 223.076 177.914 222.891 178.157 222.891 178.397 222.891 178.592 223.076 178.592 223.303 178.592 223.533 178.397 223.714 178.157 223.714 177.914 223.714 177.718 223.533 177.718 223.303' fill='%23fff'/%3E %3Cpath d='M177.718 223.303C177.718 223.076 177.914 222.891 178.157 222.891 178.397 222.891 178.592 223.076 178.592 223.303 178.592 223.533 178.397 223.714 178.157 223.714 177.914 223.714 177.718 223.533 177.718 223.303z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M180.496 223.814L181.194 223.917C181.37 223.942 181.536 223.828 181.566 223.658 181.592 223.491 181.475 223.335 181.299 223.31L180.598 223.207 179.889 223.097C179.709 223.076 179.545 223.186 179.518 223.353 179.488 223.519 179.612 223.679 179.792 223.704L180.496 223.814' fill='%23058e6e'/%3E %3Cpath d='M180.496 223.814L181.194 223.917C181.37 223.942 181.536 223.828 181.566 223.658 181.592 223.491 181.475 223.335 181.299 223.31L180.598 223.207 179.889 223.097C179.709 223.076 179.545 223.186 179.518 223.353 179.488 223.519 179.612 223.679 179.792 223.704L180.496 223.814' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M183.241 224.329L182.994 223.8 182.319 223.856 182.641 224.449 183.241 224.329' fill='%23ad1519'/%3E %3Cpath d='M183.241 224.329L182.994 223.8 182.319 223.856 182.641 224.449 183.241 224.329' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.663 226.161C173.231 226.158 171.03 225.945 169.357 225.512 171.03 225.082 173.231 224.816 175.663 224.809 178.097 224.812 180.309 225.079 181.986 225.512 180.309 225.945 178.097 226.158 175.663 226.161' fill='%23ad1519'/%3E %3Cpath d='M175.663 226.161C173.231 226.158 171.03 225.945 169.357 225.512 171.03 225.082 173.231 224.816 175.663 224.809 178.097 224.812 180.309 225.079 181.986 225.512 180.309 225.945 178.097 226.158 175.663 226.161z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.26'/%3E %3Cpath d='M183.339 220.885C183.402 220.697 183.343 220.511 183.208 220.465 183.073 220.427 182.908 220.548 182.844 220.728 182.78 220.92 182.836 221.109 182.975 221.151 183.11 221.19 183.271 221.073 183.339 220.885' fill='%23c8b100'/%3E %3Cpath d='M183.339 220.885C183.402 220.697 183.343 220.511 183.208 220.465 183.073 220.427 182.908 220.548 182.844 220.728 182.78 220.92 182.836 221.109 182.975 221.151 183.11 221.19 183.271 221.073 183.339 220.885z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M178.495 219.948C178.517 219.752 178.423 219.578 178.281 219.56 178.138 219.543 178.003 219.692 177.981 219.887 177.955 220.082 178.049 220.256 178.191 220.274 178.334 220.288 178.469 220.139 178.495 219.948' fill='%23c8b100'/%3E %3Cpath d='M178.495 219.948C178.517 219.752 178.423 219.578 178.281 219.56 178.138 219.543 178.003 219.692 177.981 219.887 177.955 220.082 178.049 220.256 178.191 220.274 178.334 220.288 178.469 220.139 178.495 219.948z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M172.866 219.948C172.844 219.752 172.938 219.578 173.081 219.56 173.223 219.543 173.358 219.692 173.384 219.887 173.407 220.082 173.313 220.256 173.17 220.274 173.031 220.288 172.892 220.139 172.866 219.948' fill='%23c8b100'/%3E %3Cpath d='M172.866 219.948C172.844 219.752 172.938 219.578 173.081 219.56 173.223 219.543 173.358 219.692 173.384 219.887 173.407 220.082 173.313 220.256 173.17 220.274 173.031 220.288 172.892 220.139 172.866 219.948z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M168.022 220.885C167.959 220.697 168.018 220.511 168.154 220.465 168.289 220.427 168.453 220.548 168.517 220.728 168.581 220.92 168.524 221.109 168.385 221.151 168.251 221.19 168.089 221.073 168.022 220.885' fill='%23c8b100'/%3E %3Cpath d='M168.022 220.885C167.959 220.697 168.018 220.511 168.154 220.465 168.289 220.427 168.453 220.548 168.517 220.728 168.581 220.92 168.524 221.109 168.385 221.151 168.251 221.19 168.089 221.073 168.022 220.885z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.663 217.149L174.805 217.667 175.443 219.048 175.663 219.194 175.881 219.048 176.522 217.667 175.663 217.149' fill='%23c8b100'/%3E %3Cpath d='M175.663 217.149L174.805 217.667 175.443 219.048 175.663 219.194 175.881 219.048 176.522 217.667 175.663 217.149' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M173.785 219.237L174.175 219.806 175.517 219.393 175.656 219.206 175.513 219.013 174.175 218.622 173.785 219.237' fill='%23c8b100'/%3E %3Cpath d='M173.785 219.237L174.175 219.806 175.517 219.393 175.656 219.206 175.513 219.013 174.175 218.622 173.785 219.237' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M177.553 219.237L177.164 219.806 175.821 219.393 175.678 219.206 175.824 219.013 177.164 218.622 177.553 219.237' fill='%23c8b100'/%3E %3Cpath d='M177.553 219.237L177.164 219.806 175.821 219.393 175.678 219.206 175.824 219.013 177.164 218.622 177.553 219.237' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M170.084 217.764L169.409 218.399 170.271 219.536 170.501 219.627 170.669 219.453 170.969 218.08 170.084 217.764' fill='%23c8b100'/%3E %3Cpath d='M170.084 217.764L169.409 218.399 170.271 219.536 170.501 219.627 170.669 219.453 170.969 218.08 170.084 217.764' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M168.67 220.043L169.177 220.518 170.399 219.858 170.493 219.646 170.317 219.485 168.918 219.365 168.67 220.043' fill='%23c8b100'/%3E %3Cpath d='M168.67 220.043L169.177 220.518 170.399 219.858 170.493 219.646 170.317 219.485 168.918 219.365 168.67 220.043' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M172.361 219.301L172.102 219.929 170.699 219.802 170.519 219.641 170.617 219.425 171.843 218.779 172.361 219.301' fill='%23c8b100'/%3E %3Cpath d='M172.361 219.301L172.102 219.929 170.699 219.802 170.519 219.641 170.617 219.425 171.843 218.779 172.361 219.301' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M167.321 220.22L167.208 220.885 165.81 221.03 165.6 220.909 165.645 220.683 166.699 219.809 167.321 220.22' fill='%23c8b100'/%3E %3Cpath d='M167.321 220.22L167.208 220.885 165.81 221.03 165.6 220.909 165.645 220.683 166.699 219.809 167.321 220.22' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M170.021 219.649C170.021 219.39 170.242 219.18 170.512 219.18 170.782 219.18 171.003 219.39 171.003 219.649 171.003 219.904 170.782 220.114 170.512 220.114 170.242 220.114 170.021 219.904 170.021 219.649' fill='%23c8b100'/%3E %3Cpath d='M170.021 219.649C170.021 219.39 170.242 219.18 170.512 219.18 170.782 219.18 171.003 219.39 171.003 219.649 171.003 219.904 170.782 220.114 170.512 220.114 170.242 220.114 170.021 219.904 170.021 219.649z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M181.27 217.764L181.944 218.399 181.081 219.536 180.849 219.627 180.685 219.453 180.381 218.08 181.27 217.764' fill='%23c8b100'/%3E %3Cpath d='M181.27 217.764L181.944 218.399 181.081 219.536 180.849 219.627 180.685 219.453 180.381 218.08 181.27 217.764' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M182.679 220.043L182.173 220.518 180.95 219.858 180.853 219.646 181.037 219.485 182.436 219.365 182.679 220.043' fill='%23c8b100'/%3E %3Cpath d='M182.679 220.043L182.173 220.518 180.95 219.858 180.853 219.646 181.037 219.485 182.436 219.365 182.679 220.043' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M178.993 219.301L179.252 219.929 180.646 219.802 180.831 219.641 180.729 219.425 179.507 218.779 178.993 219.301' fill='%23c8b100'/%3E %3Cpath d='M178.993 219.301L179.252 219.929 180.646 219.802 180.831 219.641 180.729 219.425 179.507 218.779 178.993 219.301' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M183.837 220.22L183.954 220.885 185.353 221.03 185.562 220.909 185.514 220.683 184.461 219.809 183.837 220.22' fill='%23c8b100'/%3E %3Cpath d='M183.837 220.22L183.954 220.885 185.353 221.03 185.562 220.909 185.514 220.683 184.461 219.809 183.837 220.22' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.18 219.209C175.18 218.946 175.402 218.74 175.671 218.74 175.945 218.74 176.163 218.946 176.163 219.209 176.163 219.464 175.945 219.674 175.671 219.674 175.402 219.674 175.18 219.464 175.18 219.209' fill='%23c8b100'/%3E %3Cpath d='M175.18 219.209C175.18 218.946 175.402 218.74 175.671 218.74 175.945 218.74 176.163 218.946 176.163 219.209 176.163 219.464 175.945 219.674 175.671 219.674 175.402 219.674 175.18 219.464 175.18 219.209z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M180.358 219.649C180.358 219.39 180.579 219.18 180.849 219.18 181.123 219.18 181.34 219.39 181.34 219.649 181.34 219.904 181.123 220.114 180.849 220.114 180.579 220.114 180.358 219.904 180.358 219.649' fill='%23c8b100'/%3E %3Cpath d='M180.358 219.649C180.358 219.39 180.579 219.18 180.849 219.18 181.123 219.18 181.34 219.39 181.34 219.649 181.34 219.904 181.123 220.114 180.849 220.114 180.579 220.114 180.358 219.904 180.358 219.649z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M165.431 220.998C165.416 221.009 165.053 220.515 164.775 220.267 164.576 220.093 164.1 219.944 164.1 219.944 164.1 219.855 164.378 219.656 164.681 219.656 164.861 219.656 165.03 219.73 165.127 219.855L165.168 219.663C165.168 219.663 165.412 219.709 165.525 219.983 165.638 220.267 165.566 220.697 165.566 220.697 165.566 220.697 165.521 220.895 165.431 220.998' fill='%23c8b100'/%3E %3Cpath d='M165.431 220.998C165.416 221.009 165.053 220.515 164.775 220.267 164.576 220.093 164.1 219.944 164.1 219.944 164.1 219.855 164.378 219.656 164.681 219.656 164.861 219.656 165.03 219.73 165.127 219.855L165.168 219.663C165.168 219.663 165.412 219.709 165.525 219.983 165.638 220.267 165.566 220.697 165.566 220.697 165.566 220.697 165.521 220.895 165.431 220.998z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M165.45 220.753C165.566 220.632 165.806 220.657 165.982 220.81 166.162 220.963 166.215 221.186 166.099 221.311 165.982 221.435 165.742 221.407 165.566 221.254 165.386 221.101 165.334 220.874 165.45 220.753' fill='%23c8b100'/%3E %3Cpath d='M165.45 220.753C165.566 220.632 165.806 220.657 165.982 220.81 166.162 220.963 166.215 221.186 166.099 221.311 165.982 221.435 165.742 221.407 165.566 221.254 165.386 221.101 165.334 220.874 165.45 220.753z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M185.731 220.998C185.742 221.009 186.11 220.515 186.388 220.267 186.578 220.093 187.062 219.944 187.062 219.944 187.062 219.855 186.781 219.656 186.477 219.656 186.301 219.656 186.132 219.73 186.031 219.855L185.99 219.663C185.99 219.663 185.746 219.709 185.634 219.983 185.525 220.267 185.596 220.697 185.596 220.697 185.596 220.697 185.638 220.895 185.731 220.998' fill='%23c8b100'/%3E %3Cpath d='M185.731 220.998C185.742 221.009 186.11 220.515 186.388 220.267 186.578 220.093 187.062 219.944 187.062 219.944 187.062 219.855 186.781 219.656 186.477 219.656 186.301 219.656 186.132 219.73 186.031 219.855L185.99 219.663C185.99 219.663 185.746 219.709 185.634 219.983 185.525 220.267 185.596 220.697 185.596 220.697 185.596 220.697 185.638 220.895 185.731 220.998z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M185.742 220.753C185.627 220.632 185.386 220.657 185.207 220.81 185.026 220.963 184.974 221.186 185.09 221.311 185.207 221.435 185.446 221.407 185.627 221.254 185.806 221.101 185.855 220.874 185.742 220.753' fill='%23c8b100'/%3E %3Cpath d='M185.742 220.753C185.627 220.632 185.386 220.657 185.207 220.81 185.026 220.963 184.974 221.186 185.09 221.311 185.207 221.435 185.446 221.407 185.627 221.254 185.806 221.101 185.855 220.874 185.742 220.753z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M164.58 232.369L186.867 232.369 186.867 226.527 164.58 226.527 164.58 232.369z' fill='%23c8b100'/%3E %3Cpath d='M164.58 232.369L186.867 232.369 186.867 226.527 164.58 226.527 164.58 232.369z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M166.919 236.256C167.058 236.2 167.16 236.193 167.332 236.193L184.022 236.193C184.187 236.193 184.344 236.221 184.475 236.274 183.905 236.083 183.493 235.565 183.493 234.953 183.493 234.343 183.939 233.814 184.516 233.615 184.385 233.657 184.19 233.697 184.033 233.697L167.332 233.697C167.163 233.697 167.002 233.69 166.864 233.643L166.954 233.657C167.55 233.842 167.891 234.371 167.891 234.953 167.891 235.514 167.512 236.076 166.919 236.256' fill='%23c8b100'/%3E %3Cpath d='M166.919 236.256C167.058 236.2 167.16 236.193 167.332 236.193L184.022 236.193C184.187 236.193 184.344 236.221 184.475 236.274 183.905 236.083 183.493 235.565 183.493 234.953 183.493 234.343 183.939 233.814 184.516 233.615 184.385 233.657 184.19 233.697 184.033 233.697L167.332 233.697C167.163 233.697 167.002 233.69 166.864 233.643L166.954 233.657C167.55 233.842 167.891 234.371 167.891 234.953 167.891 235.514 167.512 236.076 166.919 236.256z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M167.332 236.193L184.022 236.193C184.587 236.193 185.045 236.544 185.045 236.974 185.045 237.407 184.587 237.759 184.022 237.759L167.332 237.759C166.766 237.759 166.308 237.407 166.308 236.974 166.308 236.544 166.766 236.193 167.332 236.193' fill='%23c8b100'/%3E %3Cpath d='M167.332 236.193L184.022 236.193C184.587 236.193 185.045 236.544 185.045 236.974 185.045 237.407 184.587 237.759 184.022 237.759L167.332 237.759C166.766 237.759 166.308 237.407 166.308 236.974 166.308 236.544 166.766 236.193 167.332 236.193z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M167.332 232.369L184.033 232.369C184.595 232.369 185.057 232.667 185.057 233.029 185.057 233.398 184.595 233.697 184.033 233.697L167.332 233.697C166.766 233.697 166.308 233.398 166.308 233.029 166.308 232.667 166.766 232.369 167.332 232.369' fill='%23c8b100'/%3E %3Cpath d='M167.332 232.369L184.033 232.369C184.595 232.369 185.057 232.667 185.057 233.029 185.057 233.398 184.595 233.697 184.033 233.697L167.332 233.697C166.766 233.697 166.308 233.398 166.308 233.029 166.308 232.667 166.766 232.369 167.332 232.369z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.28 330.676C189.74 330.676 188.367 330.353 187.354 329.813 186.349 329.302 184.989 328.989 183.489 328.989 181.982 328.989 180.587 329.306 179.582 329.82 178.573 330.35 177.179 330.676 175.656 330.676 174.115 330.676 172.743 330.317 171.73 329.778 170.734 329.287 169.398 328.989 167.936 328.989 166.425 328.989 165.083 329.277 164.078 329.799 163.065 330.336 161.663 330.676 160.126 330.676L160.126 333.09C161.663 333.09 163.065 332.739 164.078 332.206 165.083 331.688 166.425 331.394 167.936 331.394 169.394 331.394 170.73 331.695 171.73 332.189 172.739 332.725 174.115 333.09 175.656 333.09 177.179 333.09 178.573 332.757 179.582 332.232 180.587 331.71 181.982 331.394 183.489 331.394 184.989 331.394 186.349 331.71 187.354 332.225 188.367 332.764 189.717 333.09 191.262 333.09L191.28 330.676' fill='%23005bbf'/%3E %3Cpath d='M191.28 330.676C189.74 330.676 188.367 330.353 187.354 329.813 186.349 329.302 184.989 328.989 183.489 328.989 181.982 328.989 180.587 329.306 179.582 329.82 178.573 330.35 177.179 330.676 175.656 330.676 174.115 330.676 172.743 330.317 171.73 329.778 170.734 329.287 169.398 328.989 167.936 328.989 166.425 328.989 165.083 329.277 164.078 329.799 163.065 330.336 161.663 330.676 160.126 330.676L160.126 333.09C161.663 333.09 163.065 332.739 164.078 332.206 165.083 331.688 166.425 331.394 167.936 331.394 169.394 331.394 170.73 331.695 171.73 332.189 172.739 332.725 174.115 333.09 175.656 333.09 177.179 333.09 178.573 332.757 179.582 332.232 180.587 331.71 181.982 331.394 183.489 331.394 184.989 331.394 186.349 331.71 187.354 332.225 188.367 332.764 189.717 333.09 191.262 333.09L191.28 330.676z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.28 333.09C189.74 333.09 188.367 332.764 187.354 332.225 186.349 331.71 184.989 331.394 183.489 331.394 181.982 331.394 180.587 331.71 179.582 332.232 178.573 332.757 177.179 333.09 175.656 333.09 174.115 333.09 172.743 332.725 171.73 332.189 170.734 331.695 169.398 331.394 167.936 331.394 166.425 331.394 165.083 331.688 164.078 332.206 163.065 332.739 161.663 333.09 160.126 333.09L160.126 335.498C161.663 335.498 163.065 335.154 164.078 334.621 165.083 334.095 166.425 333.804 167.936 333.804 169.394 333.804 170.73 334.106 171.73 334.6 172.739 335.136 174.115 335.498 175.656 335.498 177.179 335.498 178.573 335.165 179.582 334.639 180.587 334.121 181.982 333.804 183.489 333.804 184.989 333.804 186.349 334.121 187.354 334.635 188.367 335.172 189.717 335.498 191.262 335.498L191.28 333.09' fill='%23cccccc'/%3E %3Cpath d='M191.28 333.09C189.74 333.09 188.367 332.764 187.354 332.225 186.349 331.71 184.989 331.394 183.489 331.394 181.982 331.394 180.587 331.71 179.582 332.232 178.573 332.757 177.179 333.09 175.656 333.09 174.115 333.09 172.743 332.725 171.73 332.189 170.734 331.695 169.398 331.394 167.936 331.394 166.425 331.394 165.083 331.688 164.078 332.206 163.065 332.739 161.663 333.09 160.126 333.09L160.126 335.498C161.663 335.498 163.065 335.154 164.078 334.621 165.083 334.095 166.425 333.804 167.936 333.804 169.394 333.804 170.73 334.106 171.73 334.6 172.739 335.136 174.115 335.498 175.656 335.498 177.179 335.498 178.573 335.165 179.582 334.639 180.587 334.121 181.982 333.804 183.489 333.804 184.989 333.804 186.349 334.121 187.354 334.635 188.367 335.172 189.717 335.498 191.262 335.498L191.28 333.09' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.28 335.498C189.74 335.498 188.367 335.172 187.354 334.635 186.349 334.121 184.989 333.804 183.489 333.804 181.982 333.804 180.587 334.121 179.582 334.639 178.573 335.165 177.179 335.498 175.656 335.498 174.115 335.498 172.743 335.136 171.73 334.6 170.734 334.106 169.398 333.804 167.936 333.804 166.425 333.804 165.083 334.095 164.078 334.621 163.065 335.154 161.663 335.498 160.126 335.498L160.126 337.905C161.663 337.905 163.065 337.561 164.078 337.025 165.083 336.507 166.425 336.216 167.936 336.216 169.394 336.216 170.73 336.518 171.73 337.007 172.739 337.547 174.115 337.905 175.656 337.905 177.179 337.905 178.573 337.576 179.582 337.051 180.587 336.532 181.982 336.216 183.489 336.216 184.989 336.216 186.349 336.528 187.354 337.044 188.367 337.586 189.717 337.905 191.262 337.905L191.28 335.498' fill='%23005bbf'/%3E %3Cpath d='M191.28 335.498C189.74 335.498 188.367 335.172 187.354 334.635 186.349 334.121 184.989 333.804 183.489 333.804 181.982 333.804 180.587 334.121 179.582 334.639 178.573 335.165 177.179 335.498 175.656 335.498 174.115 335.498 172.743 335.136 171.73 334.6 170.734 334.106 169.398 333.804 167.936 333.804 166.425 333.804 165.083 334.095 164.078 334.621 163.065 335.154 161.663 335.498 160.126 335.498L160.126 337.905C161.663 337.905 163.065 337.561 164.078 337.025 165.083 336.507 166.425 336.216 167.936 336.216 169.394 336.216 170.73 336.518 171.73 337.007 172.739 337.547 174.115 337.905 175.656 337.905 177.179 337.905 178.573 337.576 179.582 337.051 180.587 336.532 181.982 336.216 183.489 336.216 184.989 336.216 186.349 336.528 187.354 337.044 188.367 337.586 189.717 337.905 191.262 337.905L191.28 335.498' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.262 340.317C189.717 340.317 188.367 339.991 187.354 339.451 186.349 338.94 184.989 338.626 183.489 338.626 181.982 338.626 180.587 338.94 179.582 339.458 178.573 339.984 177.179 340.317 175.656 340.317 174.115 340.317 172.743 339.954 171.73 339.415 170.734 338.925 169.398 338.626 167.936 338.626 166.425 338.626 165.083 338.918 164.078 339.436 163.065 339.973 161.663 340.317 160.126 340.317L160.126 337.921C161.663 337.921 163.065 337.561 164.078 337.025 165.083 336.507 166.425 336.216 167.936 336.216 169.394 336.216 170.73 336.518 171.73 337.007 172.739 337.547 174.115 337.905 175.656 337.905 177.179 337.905 178.573 337.576 179.582 337.051 180.587 336.532 181.982 336.216 183.489 336.216 184.989 336.216 186.349 336.528 187.354 337.044 188.367 337.586 189.74 337.905 191.28 337.905L191.262 340.317' fill='%23cccccc'/%3E %3Cpath d='M191.262 340.317C189.717 340.317 188.367 339.991 187.354 339.451 186.349 338.94 184.989 338.626 183.489 338.626 181.982 338.626 180.587 338.94 179.582 339.458 178.573 339.984 177.179 340.317 175.656 340.317 174.115 340.317 172.743 339.954 171.73 339.415 170.734 338.925 169.398 338.626 167.936 338.626 166.425 338.626 165.083 338.918 164.078 339.436 163.065 339.973 161.663 340.317 160.126 340.317L160.126 337.921C161.663 337.921 163.065 337.561 164.078 337.025 165.083 336.507 166.425 336.216 167.936 336.216 169.394 336.216 170.73 336.518 171.73 337.007 172.739 337.547 174.115 337.905 175.656 337.905 177.179 337.905 178.573 337.576 179.582 337.051 180.587 336.532 181.982 336.216 183.489 336.216 184.989 336.216 186.349 336.528 187.354 337.044 188.367 337.586 189.74 337.905 191.28 337.905L191.262 340.317' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.262 342.728C189.717 342.728 188.367 342.401 187.354 341.866 186.349 341.347 184.989 341.031 183.489 341.031 181.982 341.031 180.587 341.35 179.582 341.869 178.573 342.394 177.179 342.728 175.656 342.728 174.115 342.728 172.743 342.362 171.73 341.826 170.734 341.333 169.398 341.031 167.936 341.031 166.425 341.031 165.083 341.326 164.078 341.847 163.065 342.38 161.663 342.728 160.126 342.728L160.126 340.338C161.663 340.338 163.065 339.973 164.078 339.436 165.083 338.918 166.425 338.63 167.936 338.63 169.394 338.63 170.73 338.928 171.73 339.419 172.739 339.954 174.115 340.317 175.656 340.317 177.179 340.317 178.573 339.984 179.582 339.458 180.587 338.94 181.982 338.63 183.489 338.63 184.989 338.63 186.349 338.94 187.354 339.454 188.367 339.991 189.732 340.317 191.276 340.317L191.262 342.728' fill='%23005bbf'/%3E %3Cpath d='M191.262 342.728C189.717 342.728 188.367 342.401 187.354 341.866 186.349 341.347 184.989 341.031 183.489 341.031 181.982 341.031 180.587 341.35 179.582 341.869 178.573 342.394 177.179 342.728 175.656 342.728 174.115 342.728 172.743 342.362 171.73 341.826 170.734 341.333 169.398 341.031 167.936 341.031 166.425 341.031 165.083 341.326 164.078 341.847 163.065 342.38 161.663 342.728 160.126 342.728L160.126 340.338C161.663 340.338 163.065 339.973 164.078 339.436 165.083 338.918 166.425 338.63 167.936 338.63 169.394 338.63 170.73 338.928 171.73 339.419 172.739 339.954 174.115 340.317 175.656 340.317 177.179 340.317 178.573 339.984 179.582 339.458 180.587 338.94 181.982 338.63 183.489 338.63 184.989 338.63 186.349 338.94 187.354 339.454 188.367 339.991 189.732 340.317 191.276 340.317L191.262 342.728z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M166.919 320.783C166.973 320.986 167.047 321.185 167.047 321.401 167.047 322.864 165.784 324.028 164.239 324.028L187.175 324.028C185.63 324.028 184.366 322.864 184.366 321.401 184.366 321.188 184.407 320.986 184.461 320.783 184.329 320.83 184.172 320.837 184.022 320.837L167.332 320.837C167.197 320.837 167.04 320.822 166.919 320.783' fill='%23c8b100'/%3E %3Cpath d='M166.919 320.783C166.973 320.986 167.047 321.185 167.047 321.401 167.047 322.864 165.784 324.028 164.239 324.028L187.175 324.028C185.63 324.028 184.366 322.864 184.366 321.401 184.366 321.188 184.407 320.986 184.461 320.783 184.329 320.83 184.172 320.837 184.022 320.837L167.332 320.837C167.197 320.837 167.04 320.822 166.919 320.783z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M167.332 319.267L184.022 319.267C184.587 319.267 185.045 319.622 185.045 320.052 185.045 320.485 184.587 320.837 184.022 320.837L167.332 320.837C166.766 320.837 166.308 320.485 166.308 320.052 166.308 319.622 166.766 319.267 167.332 319.267' fill='%23c8b100'/%3E %3Cpath d='M167.332 319.267L184.022 319.267C184.587 319.267 185.045 319.622 185.045 320.052 185.045 320.485 184.587 320.837 184.022 320.837L167.332 320.837C166.766 320.837 166.308 320.485 166.308 320.052 166.308 319.622 166.766 319.267 167.332 319.267z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M164.269 329.863L187.145 329.863 187.145 324.028 164.269 324.028 164.269 329.863z' fill='%23c8b100'/%3E %3Cpath d='M164.269 329.863L187.145 329.863 187.145 324.028 164.269 324.028 164.269 329.863z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M162.48 298.618C160.216 299.925 158.682 301.263 158.93 301.931 159.054 302.545 159.773 303.003 160.8 303.685 162.417 304.811 163.399 306.821 162.63 307.748 163.969 306.669 164.816 305.056 164.816 303.263 164.816 301.388 163.924 299.698 162.48 298.618' fill='%23ad1519'/%3E %3Cpath d='M162.48 298.618C160.216 299.925 158.682 301.263 158.93 301.931 159.054 302.545 159.773 303.003 160.8 303.685 162.417 304.811 163.399 306.821 162.63 307.748 163.969 306.669 164.816 305.056 164.816 303.263 164.816 301.388 163.924 299.698 162.48 298.618z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M167.546 318.322L183.8 318.322 183.8 238.686 167.546 238.686 167.546 318.322z' fill='%23cccccc'/%3E %3Cpath d='M179.132 238.796L179.132 318.259M180.958 238.796L180.958 318.259' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M167.546 318.322L183.8 318.322 183.8 238.686 167.546 238.686 167.546 318.322z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M200.403 268.474C196.856 267.008 190.827 265.921 183.909 265.694 181.524 265.712 178.866 265.936 176.121 266.394 166.399 268.016 158.993 271.897 159.582 275.058 159.593 275.125 159.615 275.263 159.63 275.324 159.63 275.324 155.987 267.111 155.926 266.798 155.278 263.29 163.493 258.979 174.284 257.179 177.67 256.614 180.973 256.394 183.841 256.422 190.745 256.422 196.744 257.306 200.357 258.649L200.403 268.474' fill='%23ad1519'/%3E %3Cpath d='M200.403 268.474C196.856 267.008 190.827 265.921 183.909 265.694 181.524 265.712 178.866 265.936 176.121 266.394 166.399 268.016 158.993 271.897 159.582 275.058 159.593 275.125 159.615 275.263 159.63 275.324 159.63 275.324 155.987 267.111 155.926 266.798 155.278 263.29 163.493 258.979 174.284 257.179 177.67 256.614 180.973 256.394 183.841 256.422 190.745 256.422 196.744 257.306 200.357 258.649L200.403 268.474' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M167.52 278.47C163.013 278.147 159.935 276.943 159.582 275.058 159.304 273.556 160.827 271.894 163.549 270.385 164.764 270.516 166.132 270.683 167.546 270.683L167.52 278.47' fill='%23ad1519'/%3E %3Cpath d='M167.52 278.47C163.013 278.147 159.935 276.943 159.582 275.058 159.304 273.556 160.827 271.894 163.549 270.385 164.764 270.516 166.132 270.683 167.546 270.683L167.52 278.47' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M183.83 272.384C186.646 272.81 188.761 273.509 189.814 274.369L189.908 274.542C190.41 275.573 187.936 277.764 183.804 280.21L183.83 272.384' fill='%23ad1519'/%3E %3Cpath d='M183.83 272.384C186.646 272.81 188.761 273.509 189.814 274.369L189.908 274.542C190.41 275.573 187.936 277.764 183.804 280.21L183.83 272.384' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M157.422 293.832C156.994 292.546 161.39 289.972 167.602 287.693 170.441 286.677 172.784 285.618 175.689 284.337 184.318 280.522 190.692 276.144 189.908 274.547L189.822 274.383C190.283 274.756 190.995 282.621 190.995 282.621 191.783 284.084 185.949 288.398 178.003 292.205 175.461 293.42 170.092 295.404 167.557 296.292 163.024 297.865 158.517 300.831 158.93 301.931L157.422 293.836' fill='%23ad1519'/%3E %3Cpath d='M157.422 293.832C156.994 292.546 161.39 289.972 167.602 287.693 170.441 286.677 172.784 285.618 175.689 284.337 184.318 280.522 190.692 276.144 189.908 274.547L189.822 274.383C190.283 274.756 190.995 282.621 190.995 282.621 191.783 284.084 185.949 288.398 178.003 292.205 175.461 293.42 170.092 295.404 167.557 296.292 163.024 297.865 158.517 300.831 158.93 301.931L157.422 293.836 157.422 293.832z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M166.425 264.654C168.413 263.929 169.714 263.073 169.076 261.507 168.674 260.513 167.647 260.321 166.114 260.883L163.395 261.87 165.844 267.903C166.11 267.782 166.376 267.657 166.654 267.555 166.927 267.455 167.216 267.38 167.497 267.299L166.425 264.657 166.425 264.654zM165.244 261.742L165.93 261.493C166.5 261.284 167.145 261.586 167.43 262.289 167.643 262.825 167.587 263.421 166.931 263.84 166.717 263.972 166.47 264.071 166.23 264.167L165.244 261.742' fill='%23c8b100'/%3E %3Cpath d='M172.777 259.218C172.492 259.295 172.207 259.381 171.918 259.437 171.63 259.494 171.333 259.526 171.041 259.565L172.45 265.84 176.833 264.959C176.781 264.835 176.713 264.703 176.687 264.575 176.657 264.444 176.661 264.298 176.653 264.167 175.885 264.387 175.045 264.626 174.036 264.828L172.781 259.218' fill='%23c8b100'/%3E %3Cpath d='M181.555 264.629C182.383 262.353 183.384 260.172 184.37 257.964 184.194 257.992 184.006 258.017 183.83 258.027 183.654 258.038 183.463 258.041 183.286 258.034 182.762 259.636 182.109 261.237 181.423 262.832 180.598 261.319 179.687 259.842 178.993 258.318 178.652 258.362 178.303 258.411 177.958 258.436 177.618 258.457 177.261 258.453 176.92 258.457 178.184 260.516 179.402 262.569 180.557 264.693 180.718 264.664 180.883 264.626 181.058 264.614 181.22 264.603 181.39 264.619 181.555 264.626' fill='%23c8b100'/%3E %3Cpath d='M190.718 259.8C190.871 259.494 191.026 259.195 191.198 258.911 190.962 258.688 190.238 258.362 189.39 258.276 187.602 258.099 186.575 258.894 186.455 259.974 186.203 262.232 189.769 262.037 189.605 263.535 189.533 264.182 188.847 264.444 188.12 264.373 187.306 264.291 186.714 263.844 186.608 263.18L186.388 263.159C186.271 263.553 186.099 263.933 185.914 264.312 186.435 264.65 187.115 264.842 187.763 264.905 189.586 265.087 190.977 264.356 191.108 263.156 191.345 261.01 187.745 260.886 187.883 259.622 187.943 259.09 188.352 258.741 189.282 258.834 189.949 258.901 190.362 259.263 190.542 259.781L190.718 259.8' fill='%23c8b100'/%3E %3Cpath d='M324.846 220.423C324.846 220.423 324.111 221.197 323.574 221.307 323.039 221.414 322.36 220.825 322.36 220.825 322.36 220.825 321.877 221.328 321.284 221.463 320.692 221.598 319.869 220.795 319.869 220.795 319.869 220.795 319.304 221.598 318.797 221.786 318.288 221.974 317.669 221.546 317.669 221.546 317.669 221.546 317.444 221.943 317.02 222.163 316.84 222.248 316.541 222.106 316.541 222.106L315.943 221.733 315.264 221.009 314.643 220.767C314.643 220.767 314.362 219.858 314.332 219.699 314.31 219.539 314.249 219.134 314.249 219.134 314.123 218.485 315.123 217.731 316.551 217.408 317.373 217.217 318.088 217.231 318.614 217.394 319.184 216.908 320.392 216.57 321.812 216.57 323.098 216.57 324.227 216.843 324.85 217.266 325.464 216.843 326.593 216.57 327.883 216.57 329.296 216.57 330.503 216.908 331.074 217.394 331.602 217.231 332.314 217.22 333.14 217.408 334.564 217.731 335.569 218.485 335.441 219.134 335.441 219.134 335.381 219.539 335.356 219.699 335.326 219.858 335.045 220.767 335.045 220.767L334.422 221.009 333.743 221.733 333.155 222.106C333.155 222.106 332.855 222.248 332.675 222.163 332.251 221.946 332.022 221.546 332.022 221.546 332.022 221.546 331.4 221.974 330.893 221.786 330.384 221.598 329.818 220.795 329.818 220.795 329.818 220.795 329 221.598 328.403 221.463 327.811 221.328 327.33 220.825 327.33 220.825 327.33 220.825 326.651 221.414 326.117 221.307 325.577 221.197 324.85 220.423 324.85 220.423' fill='%23ad1519'/%3E %3Cpath d='M324.846 220.423C324.846 220.423 324.111 221.197 323.574 221.307 323.039 221.414 322.36 220.825 322.36 220.825 322.36 220.825 321.877 221.328 321.284 221.463 320.692 221.598 319.869 220.795 319.869 220.795 319.869 220.795 319.304 221.598 318.797 221.786 318.288 221.974 317.669 221.546 317.669 221.546 317.669 221.546 317.444 221.943 317.02 222.163 316.84 222.248 316.541 222.106 316.541 222.106L315.943 221.733 315.264 221.009 314.643 220.767C314.643 220.767 314.362 219.858 314.332 219.699 314.31 219.539 314.249 219.134 314.249 219.134 314.123 218.485 315.123 217.731 316.551 217.408 317.373 217.217 318.088 217.231 318.614 217.394 319.184 216.908 320.392 216.57 321.812 216.57 323.098 216.57 324.227 216.843 324.85 217.266 325.464 216.843 326.593 216.57 327.883 216.57 329.296 216.57 330.503 216.908 331.074 217.394 331.602 217.231 332.314 217.22 333.14 217.408 334.564 217.731 335.569 218.485 335.441 219.134 335.441 219.134 335.381 219.539 335.356 219.699 335.326 219.858 335.045 220.767 335.045 220.767L334.422 221.009 333.743 221.733 333.155 222.106C333.155 222.106 332.855 222.248 332.675 222.163 332.251 221.946 332.022 221.546 332.022 221.546 332.022 221.546 331.4 221.974 330.893 221.786 330.384 221.598 329.818 220.795 329.818 220.795 329.818 220.795 329 221.598 328.403 221.463 327.811 221.328 327.33 220.825 327.33 220.825 327.33 220.825 326.651 221.414 326.117 221.307 325.577 221.197 324.85 220.423 324.85 220.423L324.846 220.423z' fill='none' stroke='%23000' stroke-width='0.27'/%3E %3Cpath d='M323.447 216.197C323.447 215.114 324.063 214.237 324.823 214.237 325.584 214.237 326.203 215.114 326.203 216.197 326.203 217.284 325.584 218.164 324.823 218.164 324.063 218.164 323.447 217.284 323.447 216.197' fill='%23c8b100'/%3E %3Cpath d='M323.447 216.197C323.447 215.114 324.063 214.237 324.823 214.237 325.584 214.237 326.203 215.114 326.203 216.197 326.203 217.284 325.584 218.164 324.823 218.164 324.063 218.164 323.447 217.284 323.447 216.197z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.216 216.197C324.216 215.203 324.501 214.394 324.85 214.394 325.201 214.394 325.483 215.203 325.483 216.197 325.483 217.195 325.201 218.005 324.85 218.005 324.501 218.005 324.216 217.195 324.216 216.197' fill='%23c8b100'/%3E %3Cpath d='M324.216 216.197C324.216 215.203 324.501 214.394 324.85 214.394 325.201 214.394 325.483 215.203 325.483 216.197 325.483 217.195 325.201 218.005 324.85 218.005 324.501 218.005 324.216 217.195 324.216 216.197z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.747 224.251C317.545 223.679 317.165 223.168 317.165 223.168 319.113 222.596 321.823 222.237 324.838 222.23 327.853 222.237 330.582 222.596 332.529 223.168 332.529 223.168 332.311 223.551 332.007 224.084 331.839 224.379 331.617 224.893 331.632 224.893 329.873 224.354 327.609 224.077 324.827 224.074 322.041 224.077 319.363 224.418 317.968 224.929 317.988 224.929 317.871 224.606 317.732 224.251L317.747 224.251' fill='%23c8b100'/%3E %3Cpath d='M317.747 224.251C317.545 223.679 317.165 223.168 317.165 223.168 319.113 222.596 321.823 222.237 324.838 222.23 327.853 222.237 330.582 222.596 332.529 223.168 332.529 223.168 332.311 223.551 332.007 224.084 331.839 224.379 331.617 224.893 331.632 224.893 329.873 224.354 327.609 224.077 324.827 224.074 322.041 224.077 319.363 224.418 317.968 224.929 317.988 224.929 317.871 224.606 317.732 224.251L317.747 224.251' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.838 226.726C327.271 226.722 329.949 226.353 330.939 226.098 331.598 225.905 331.985 225.607 331.913 225.263 331.88 225.1 331.737 224.958 331.545 224.876 330.094 224.411 327.478 224.081 324.838 224.077 322.203 224.081 319.574 224.411 318.118 224.876 317.932 224.958 317.785 225.1 317.754 225.263 317.68 225.607 318.067 225.905 318.73 226.098 319.717 226.353 322.407 226.722 324.838 226.726' fill='%23c8b100'/%3E %3Cpath d='M324.838 226.726C327.271 226.722 329.949 226.353 330.939 226.098 331.598 225.905 331.985 225.607 331.913 225.263 331.88 225.1 331.737 224.958 331.545 224.876 330.094 224.411 327.478 224.081 324.838 224.077 322.203 224.081 319.574 224.411 318.118 224.876 317.932 224.958 317.785 225.1 317.754 225.263 317.68 225.607 318.067 225.905 318.73 226.098 319.717 226.353 322.407 226.722 324.838 226.726z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M330.736 217.075C330.736 216.836 330.939 216.645 331.185 216.645 331.437 216.645 331.64 216.836 331.64 217.075 331.64 217.313 331.437 217.501 331.185 217.501 330.939 217.501 330.736 217.313 330.736 217.075' fill='%23fff'/%3E %3Cpath d='M330.736 217.075C330.736 216.836 330.939 216.645 331.185 216.645 331.437 216.645 331.64 216.836 331.64 217.075 331.64 217.313 331.437 217.501 331.185 217.501 330.939 217.501 330.736 217.313 330.736 217.075z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M330.482 215.576C330.482 215.338 330.683 215.147 330.932 215.147 331.181 215.147 331.385 215.338 331.385 215.576 331.385 215.81 331.181 216.003 330.932 216.003 330.683 216.003 330.482 215.81 330.482 215.576zM329.349 214.638C329.349 214.401 329.55 214.209 329.803 214.209 330.049 214.209 330.253 214.401 330.253 214.638 330.253 214.877 330.049 215.068 329.803 215.068 329.55 215.068 329.349 214.877 329.349 214.638zM327.934 214.187C327.934 213.946 328.138 213.754 328.388 213.754 328.64 213.754 328.839 213.946 328.839 214.187 328.839 214.419 328.64 214.614 328.388 214.614 328.138 214.614 327.934 214.419 327.934 214.187zM326.495 214.237C326.495 213.999 326.697 213.808 326.945 213.808 327.197 213.808 327.4 213.999 327.4 214.237 327.4 214.475 327.197 214.663 326.945 214.663 326.697 214.663 326.495 214.475 326.495 214.237z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M335.206 219.986C335.341 219.656 335.425 219.29 335.425 218.91 335.425 217.32 334.164 216.027 332.6 216.027 332.101 216.027 331.632 216.162 331.224 216.396' fill='none' stroke='%23000' stroke-linecap='round' stroke-width='0.26'/%3E %3Cpath d='M330.174 217.962C330.32 217.703 330.425 217.387 330.425 217.089 330.425 215.942 329.24 215.012 327.782 215.012 327.159 215.012 326.589 215.182 326.14 215.462' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M335.596 218.68C335.596 218.445 335.802 218.25 336.05 218.25 336.3 218.25 336.503 218.445 336.503 218.68 336.503 218.918 336.3 219.106 336.05 219.106 335.802 219.106 335.596 218.918 335.596 218.68zM335.425 217.103C335.425 216.864 335.63 216.677 335.88 216.677 336.128 216.677 336.331 216.864 336.331 217.103 336.331 217.338 336.128 217.529 335.88 217.529 335.63 217.529 335.425 217.338 335.425 217.103zM334.411 215.896C334.411 215.661 334.613 215.47 334.861 215.47 335.112 215.47 335.314 215.661 335.314 215.896 335.314 216.133 335.112 216.325 334.861 216.325 334.613 216.325 334.411 216.133 334.411 215.896zM333.053 215.252C333.053 215.019 333.256 214.827 333.506 214.827 333.755 214.827 333.957 215.019 333.957 215.252 333.957 215.491 333.755 215.686 333.506 215.686 333.256 215.686 333.053 215.491 333.053 215.252zM331.61 215.31C331.61 215.072 331.813 214.88 332.063 214.88 332.314 214.88 332.518 215.072 332.518 215.31 332.518 215.544 332.314 215.736 332.063 215.736 331.813 215.736 331.61 215.544 331.61 215.31z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M332.647 222.081L332.056 221.546C332.056 221.546 331.49 221.893 330.782 221.786 330.077 221.68 329.851 220.825 329.851 220.825 329.851 220.825 329.057 221.488 328.411 221.439 327.763 221.381 327.339 220.825 327.339 220.825 327.339 220.825 326.63 221.328 326.008 221.279 325.386 221.222 324.793 220.448 324.793 220.448 324.793 220.448 324.171 221.25 323.548 221.307 322.926 221.357 322.419 220.767 322.419 220.767 322.419 220.767 322.134 221.357 321.343 221.488 320.553 221.623 319.874 220.874 319.874 220.874 319.874 220.874 319.428 221.598 318.887 221.786 318.352 221.974 317.647 221.516 317.647 221.516 317.647 221.516 317.534 221.786 317.448 221.946 317.362 222.106 317.136 222.135 317.136 222.135L317.313 222.614C319.25 222.053 321.877 221.705 324.846 221.702 327.819 221.705 330.518 222.053 332.453 222.618L332.652 222.081' fill='%23c8b100'/%3E %3Cpath d='M332.647 222.081L332.056 221.546C332.056 221.546 331.49 221.893 330.782 221.786 330.077 221.68 329.851 220.825 329.851 220.825 329.851 220.825 329.057 221.488 328.411 221.439 327.763 221.381 327.339 220.825 327.339 220.825 327.339 220.825 326.63 221.328 326.008 221.279 325.386 221.222 324.793 220.448 324.793 220.448 324.793 220.448 324.171 221.25 323.548 221.307 322.926 221.357 322.419 220.767 322.419 220.767 322.419 220.767 322.134 221.357 321.343 221.488 320.553 221.623 319.874 220.874 319.874 220.874 319.874 220.874 319.428 221.598 318.887 221.786 318.352 221.974 317.647 221.516 317.647 221.516 317.647 221.516 317.534 221.786 317.448 221.946 317.362 222.106 317.136 222.135 317.136 222.135L317.313 222.614C319.25 222.053 321.877 221.705 324.846 221.702 327.819 221.705 330.518 222.053 332.453 222.618L332.652 222.081 332.647 222.081z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.977 217.075C317.977 216.836 318.178 216.645 318.43 216.645 318.677 216.645 318.88 216.836 318.88 217.075 318.88 217.313 318.677 217.501 318.43 217.501 318.178 217.501 317.977 217.313 317.977 217.075' fill='%23fff'/%3E %3Cpath d='M317.977 217.075C317.977 216.836 318.178 216.645 318.43 216.645 318.677 216.645 318.88 216.836 318.88 217.075 318.88 217.313 318.677 217.501 318.43 217.501 318.178 217.501 317.977 217.313 317.977 217.075z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M318.232 215.576C318.232 215.338 318.434 215.147 318.685 215.147 318.933 215.147 319.135 215.338 319.135 215.576 319.135 215.81 318.933 216.003 318.685 216.003 318.434 216.003 318.232 215.81 318.232 215.576zM319.36 214.638C319.36 214.401 319.563 214.209 319.814 214.209 320.065 214.209 320.268 214.401 320.268 214.638 320.268 214.877 320.065 215.068 319.814 215.068 319.563 215.068 319.36 214.877 319.36 214.638zM320.774 214.187C320.774 213.946 320.977 213.754 321.227 213.754 321.479 213.754 321.681 213.946 321.681 214.187 321.681 214.419 321.479 214.614 321.227 214.614 320.977 214.614 320.774 214.419 320.774 214.187zM322.217 214.237C322.217 213.999 322.419 213.808 322.667 213.808 322.919 213.808 323.121 213.999 323.121 214.237 323.121 214.475 322.919 214.663 322.667 214.663 322.419 214.663 322.217 214.475 322.217 214.237z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M314.408 219.986C314.276 219.656 314.19 219.29 314.19 218.91 314.19 217.32 315.453 216.027 317.015 216.027 317.515 216.027 317.983 216.162 318.393 216.396' fill='none' stroke='%23000' stroke-linecap='round' stroke-width='0.26'/%3E %3Cpath d='M319.476 217.927C319.33 217.671 319.19 217.387 319.19 217.089 319.19 215.942 320.376 215.012 321.834 215.012 322.453 215.012 323.027 215.182 323.477 215.462' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M313.114 218.68C313.114 218.445 313.315 218.25 313.568 218.25 313.813 218.25 314.017 218.445 314.017 218.68 314.017 218.918 313.813 219.106 313.568 219.106 313.315 219.106 313.114 218.918 313.114 218.68zM313.282 217.103C313.282 216.864 313.488 216.677 313.736 216.677 313.988 216.677 314.19 216.864 314.19 217.103 314.19 217.338 313.988 217.529 313.736 217.529 313.488 217.529 313.282 217.338 313.282 217.103zM314.302 215.896C314.302 215.661 314.504 215.47 314.756 215.47 315.004 215.47 315.206 215.661 315.206 215.896 315.206 216.133 315.004 216.325 314.756 216.325 314.504 216.325 314.302 216.133 314.302 215.896zM315.659 215.252C315.659 215.019 315.861 214.827 316.108 214.827 316.361 214.827 316.562 215.019 316.562 215.252 316.562 215.491 316.361 215.686 316.108 215.686 315.861 215.686 315.659 215.491 315.659 215.252zM317.099 215.31C317.099 215.072 317.301 214.88 317.553 214.88 317.804 214.88 318.003 215.072 318.003 215.31 318.003 215.544 317.804 215.736 317.553 215.736 317.301 215.736 317.099 215.544 317.099 215.31z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M324.853 219.492L325.134 219.543C325.09 219.66 325.081 219.783 325.081 219.915 325.081 220.497 325.581 220.97 326.195 220.97 326.691 220.97 327.111 220.664 327.254 220.242 327.271 220.253 327.361 219.858 327.406 219.865 327.448 219.865 327.441 220.274 327.451 220.267 327.525 220.795 328.009 221.158 328.557 221.158 329.172 221.158 329.67 220.686 329.67 220.104 329.67 220.06 329.667 220.018 329.66 219.976L330.012 219.627 330.199 220.071C330.124 220.206 330.094 220.362 330.094 220.53 330.094 221.087 330.571 221.538 331.156 221.538 331.528 221.538 331.854 221.357 332.041 221.087L332.266 220.803 332.262 221.155C332.262 221.502 332.413 221.815 332.752 221.872 332.752 221.872 333.146 221.9 333.664 221.488 334.186 221.08 334.471 220.739 334.471 220.739L334.501 221.158C334.501 221.158 333.99 221.996 333.529 222.262 333.275 222.411 332.887 222.568 332.581 222.514 332.254 222.465 332.026 222.202 331.905 221.904 331.674 222.042 331.4 222.12 331.107 222.12 330.478 222.12 329.912 221.772 329.69 221.258 329.4 221.57 328.996 221.758 328.523 221.758 328.022 221.758 327.561 221.534 327.271 221.183 326.987 221.446 326.601 221.606 326.176 221.606 325.622 221.606 325.123 221.328 324.842 220.92 324.56 221.328 324.069 221.606 323.51 221.606 323.086 221.606 322.701 221.446 322.416 221.183 322.127 221.534 321.67 221.758 321.164 221.758 320.692 221.758 320.29 221.57 320.002 221.258 319.779 221.769 319.21 222.12 318.584 222.12 318.292 222.12 318.021 222.042 317.789 221.904 317.669 222.202 317.437 222.465 317.114 222.514 316.807 222.568 316.42 222.411 316.166 222.262 315.7 221.996 315.15 221.158 315.15 221.158L315.221 220.739C315.221 220.739 315.505 221.08 316.024 221.488 316.544 221.9 316.938 221.872 316.938 221.872 317.279 221.815 317.424 221.502 317.424 221.155L317.424 220.803 317.647 221.087C317.838 221.357 318.163 221.538 318.531 221.538 319.121 221.538 319.596 221.087 319.596 220.53 319.596 220.362 319.566 220.206 319.491 220.071L319.679 219.627 320.027 219.976C320.02 220.018 320.02 220.06 320.02 220.104 320.02 220.686 320.515 221.158 321.125 221.158 321.677 221.158 322.161 220.795 322.232 220.267 322.247 220.274 322.242 219.865 322.28 219.865 322.33 219.858 322.419 220.253 322.434 220.242 322.58 220.664 323 220.97 323.495 220.97 324.111 220.97 324.609 220.497 324.609 219.915 324.609 219.783 324.602 219.66 324.557 219.543L324.846 219.492' fill='%23c8b100'/%3E %3Cpath d='M324.853 219.492L325.134 219.543C325.09 219.66 325.081 219.783 325.081 219.915 325.081 220.497 325.581 220.97 326.195 220.97 326.691 220.97 327.111 220.664 327.254 220.242 327.271 220.253 327.361 219.858 327.406 219.865 327.448 219.865 327.441 220.274 327.451 220.267 327.525 220.795 328.009 221.158 328.557 221.158 329.172 221.158 329.67 220.686 329.67 220.104 329.67 220.06 329.667 220.018 329.66 219.976L330.012 219.627 330.199 220.071C330.124 220.206 330.094 220.362 330.094 220.53 330.094 221.087 330.571 221.538 331.156 221.538 331.528 221.538 331.854 221.357 332.041 221.087L332.266 220.803 332.262 221.155C332.262 221.502 332.413 221.815 332.752 221.872 332.752 221.872 333.146 221.9 333.664 221.488 334.186 221.08 334.471 220.739 334.471 220.739L334.501 221.158C334.501 221.158 333.99 221.996 333.529 222.262 333.275 222.411 332.887 222.568 332.581 222.514 332.254 222.465 332.026 222.202 331.905 221.904 331.674 222.042 331.4 222.12 331.107 222.12 330.478 222.12 329.912 221.772 329.69 221.258 329.4 221.57 328.996 221.758 328.523 221.758 328.022 221.758 327.561 221.534 327.271 221.183 326.987 221.446 326.601 221.606 326.176 221.606 325.622 221.606 325.123 221.328 324.842 220.92 324.56 221.328 324.069 221.606 323.51 221.606 323.086 221.606 322.701 221.446 322.416 221.183 322.127 221.534 321.67 221.758 321.164 221.758 320.692 221.758 320.29 221.57 320.002 221.258 319.779 221.769 319.21 222.12 318.584 222.12 318.292 222.12 318.021 222.042 317.789 221.904 317.669 222.202 317.437 222.465 317.114 222.514 316.807 222.568 316.42 222.411 316.166 222.262 315.7 221.996 315.15 221.158 315.15 221.158L315.221 220.739C315.221 220.739 315.505 221.08 316.024 221.488 316.544 221.9 316.938 221.872 316.938 221.872 317.279 221.815 317.424 221.502 317.424 221.155L317.424 220.803 317.647 221.087C317.838 221.357 318.163 221.538 318.531 221.538 319.121 221.538 319.596 221.087 319.596 220.53 319.596 220.362 319.566 220.206 319.491 220.071L319.679 219.627 320.027 219.976C320.02 220.018 320.02 220.06 320.02 220.104 320.02 220.686 320.515 221.158 321.125 221.158 321.677 221.158 322.161 220.795 322.232 220.267 322.247 220.274 322.242 219.865 322.28 219.865 322.33 219.858 322.419 220.253 322.434 220.242 322.58 220.664 323 220.97 323.495 220.97 324.111 220.97 324.609 220.497 324.609 219.915 324.609 219.783 324.602 219.66 324.557 219.543L324.846 219.492 324.853 219.492z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.838 222.234C321.823 222.237 319.116 222.596 317.17 223.172 317.04 223.214 316.88 223.114 316.837 222.997 316.795 222.874 316.89 222.721 317.015 222.678 318.974 222.081 321.749 221.705 324.838 221.702 327.924 221.705 330.713 222.081 332.668 222.678 332.797 222.721 332.892 222.874 332.851 222.997 332.81 223.114 332.644 223.214 332.518 223.172 330.571 222.596 327.853 222.237 324.838 222.234' fill='%23c8b100'/%3E %3Cpath d='M324.838 222.234C321.823 222.237 319.116 222.596 317.17 223.172 317.04 223.214 316.88 223.114 316.837 222.997 316.795 222.874 316.89 222.721 317.015 222.678 318.974 222.081 321.749 221.705 324.838 221.702 327.924 221.705 330.713 222.081 332.668 222.678 332.797 222.721 332.892 222.874 332.851 222.997 332.81 223.114 332.644 223.214 332.518 223.172 330.571 222.596 327.853 222.237 324.838 222.234z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M321.921 223.303C321.921 223.076 322.116 222.891 322.36 222.891 322.6 222.891 322.795 223.076 322.795 223.303 322.795 223.533 322.6 223.714 322.36 223.714 322.116 223.714 321.921 223.533 321.921 223.303' fill='%23fff'/%3E %3Cpath d='M321.921 223.303C321.921 223.076 322.116 222.891 322.36 222.891 322.6 222.891 322.795 223.076 322.795 223.303 322.795 223.533 322.6 223.714 322.36 223.714 322.116 223.714 321.921 223.533 321.921 223.303z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.875 223.481L323.905 223.481C323.724 223.481 323.574 223.339 323.574 223.168 323.574 223 323.72 222.863 323.901 222.863L325.862 222.863C326.042 222.863 326.183 223 326.183 223.168 326.183 223.339 326.038 223.481 325.858 223.481L324.875 223.481' fill='%23ad1519'/%3E %3Cpath d='M324.875 223.481L323.905 223.481C323.724 223.481 323.574 223.339 323.574 223.168 323.574 223 323.72 222.863 323.901 222.863L325.862 222.863C326.042 222.863 326.183 223 326.183 223.168 326.183 223.339 326.038 223.481 325.858 223.481L324.875 223.481' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M320.017 223.814L319.323 223.917C319.145 223.942 318.978 223.828 318.948 223.658 318.921 223.491 319.04 223.335 319.217 223.31L319.914 223.207 320.626 223.097C320.804 223.076 320.968 223.186 320.999 223.353 321.025 223.519 320.901 223.679 320.725 223.704L320.017 223.814' fill='%23058e6e'/%3E %3Cpath d='M320.017 223.814L319.323 223.917C319.145 223.942 318.978 223.828 318.948 223.658 318.921 223.491 319.04 223.335 319.217 223.31L319.914 223.207 320.626 223.097C320.804 223.076 320.968 223.186 320.999 223.353 321.025 223.519 320.901 223.679 320.725 223.704L320.017 223.814' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.215 224.3L317.523 223.804 318.183 223.928 317.8 224.486 317.215 224.3' fill='%23ad1519'/%3E %3Cpath d='M317.215 224.3L317.523 223.804 318.183 223.928 317.8 224.486 317.215 224.3' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M326.886 223.303C326.886 223.076 327.084 222.891 327.324 222.891 327.565 222.891 327.763 223.076 327.763 223.303 327.763 223.533 327.565 223.714 327.324 223.714 327.084 223.714 326.886 223.533 326.886 223.303' fill='%23fff'/%3E %3Cpath d='M326.886 223.303C326.886 223.076 327.084 222.891 327.324 222.891 327.565 222.891 327.763 223.076 327.763 223.303 327.763 223.533 327.565 223.714 327.324 223.714 327.084 223.714 326.886 223.533 326.886 223.303z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M329.664 223.814L330.362 223.917C330.538 223.942 330.702 223.828 330.732 223.658 330.758 223.491 330.643 223.335 330.467 223.31L329.769 223.207 329.057 223.097C328.877 223.076 328.711 223.186 328.685 223.353 328.655 223.519 328.783 223.679 328.959 223.704L329.664 223.814' fill='%23058e6e'/%3E %3Cpath d='M329.664 223.814L330.362 223.917C330.538 223.942 330.702 223.828 330.732 223.658 330.758 223.491 330.643 223.335 330.467 223.31L329.769 223.207 329.057 223.097C328.877 223.076 328.711 223.186 328.685 223.353 328.655 223.519 328.783 223.679 328.959 223.704L329.664 223.814' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M332.409 224.329L332.161 223.8 331.484 223.856 331.809 224.449 332.409 224.329' fill='%23ad1519'/%3E %3Cpath d='M332.409 224.329L332.161 223.8 331.484 223.856 331.809 224.449 332.409 224.329' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.834 226.161C322.401 226.158 320.2 225.945 318.524 225.512 320.2 225.082 322.401 224.816 324.834 224.809 327.268 224.812 329.48 225.079 331.151 225.512 329.48 225.945 327.268 226.158 324.834 226.161' fill='%23ad1519'/%3E %3Cpath d='M324.834 226.161C322.401 226.158 320.2 225.945 318.524 225.512 320.2 225.082 322.401 224.816 324.834 224.809 327.268 224.812 329.48 225.079 331.151 225.512 329.48 225.945 327.268 226.158 324.834 226.161z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.26'/%3E %3Cpath d='M332.506 220.885C332.57 220.697 332.514 220.511 332.374 220.465 332.239 220.427 332.079 220.548 332.015 220.728 331.948 220.92 332.007 221.109 332.142 221.151 332.277 221.19 332.442 221.073 332.506 220.885' fill='%23c8b100'/%3E %3Cpath d='M332.506 220.885C332.57 220.697 332.514 220.511 332.374 220.465 332.239 220.427 332.079 220.548 332.015 220.728 331.948 220.92 332.007 221.109 332.142 221.151 332.277 221.19 332.442 221.073 332.506 220.885z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M327.661 219.948C327.687 219.752 327.59 219.578 327.448 219.56 327.309 219.543 327.17 219.692 327.148 219.887 327.122 220.082 327.215 220.256 327.358 220.274 327.5 220.288 327.635 220.139 327.661 219.948' fill='%23c8b100'/%3E %3Cpath d='M327.661 219.948C327.687 219.752 327.59 219.578 327.448 219.56 327.309 219.543 327.17 219.692 327.148 219.887 327.122 220.082 327.215 220.256 327.358 220.274 327.5 220.288 327.635 220.139 327.661 219.948z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M322.038 219.948C322.012 219.752 322.104 219.578 322.247 219.56 322.39 219.543 322.524 219.692 322.551 219.887 322.572 220.082 322.48 220.256 322.341 220.274 322.199 220.288 322.063 220.139 322.038 219.948' fill='%23c8b100'/%3E %3Cpath d='M322.038 219.948C322.012 219.752 322.104 219.578 322.247 219.56 322.39 219.543 322.524 219.692 322.551 219.887 322.572 220.082 322.48 220.256 322.341 220.274 322.199 220.288 322.063 220.139 322.038 219.948z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.193 220.885C317.125 220.697 317.186 220.511 317.32 220.465 317.454 220.427 317.62 220.548 317.684 220.728 317.747 220.92 317.691 221.109 317.557 221.151 317.418 221.19 317.256 221.073 317.193 220.885' fill='%23c8b100'/%3E %3Cpath d='M317.193 220.885C317.125 220.697 317.186 220.511 317.32 220.465 317.454 220.427 317.62 220.548 317.684 220.728 317.747 220.92 317.691 221.109 317.557 221.151 317.418 221.19 317.256 221.073 317.193 220.885z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.834 217.149L323.976 217.667 324.612 219.048 324.834 219.194 325.052 219.048 325.693 217.667 324.834 217.149' fill='%23c8b100'/%3E %3Cpath d='M324.834 217.149L323.976 217.667 324.612 219.048 324.834 219.194 325.052 219.048 325.693 217.667 324.834 217.149' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M322.951 219.237L323.343 219.806 324.681 219.393 324.823 219.206 324.681 219.013 323.343 218.622 322.951 219.237' fill='%23c8b100'/%3E %3Cpath d='M322.951 219.237L323.343 219.806 324.681 219.393 324.823 219.206 324.681 219.013 323.343 218.622 322.951 219.237' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M326.724 219.237L326.33 219.806 324.992 219.393 324.85 219.206 324.992 219.013 326.33 218.622 326.724 219.237' fill='%23c8b100'/%3E %3Cpath d='M326.724 219.237L326.33 219.806 324.992 219.393 324.85 219.206 324.992 219.013 326.33 218.622 326.724 219.237' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M319.25 217.764L318.577 218.399 319.439 219.536 319.668 219.627 319.837 219.453 320.14 218.08 319.25 217.764' fill='%23c8b100'/%3E %3Cpath d='M319.25 217.764L318.577 218.399 319.439 219.536 319.668 219.627 319.837 219.453 320.14 218.08 319.25 217.764' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.838 220.043L318.343 220.518 319.566 219.858 319.659 219.646 319.484 219.485 318.086 219.365 317.838 220.043' fill='%23c8b100'/%3E %3Cpath d='M317.838 220.043L318.343 220.518 319.566 219.858 319.659 219.646 319.484 219.485 318.086 219.365 317.838 220.043' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M321.527 219.301L321.269 219.929 319.869 219.802 319.687 219.641 319.783 219.425 321.01 218.779 321.527 219.301' fill='%23c8b100'/%3E %3Cpath d='M321.527 219.301L321.269 219.929 319.869 219.802 319.687 219.641 319.783 219.425 321.01 218.779 321.527 219.301' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M316.492 220.22L316.376 220.885 314.975 221.03 314.763 220.909 314.816 220.683 315.869 219.809 316.492 220.22' fill='%23c8b100'/%3E %3Cpath d='M316.492 220.22L316.376 220.885 314.975 221.03 314.763 220.909 314.816 220.683 315.869 219.809 316.492 220.22' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M319.188 219.649C319.188 219.39 319.409 219.18 319.679 219.18 319.952 219.18 320.17 219.39 320.17 219.649 320.17 219.904 319.952 220.114 319.679 220.114 319.409 220.114 319.188 219.904 319.188 219.649' fill='%23c8b100'/%3E %3Cpath d='M319.188 219.649C319.188 219.39 319.409 219.18 319.679 219.18 319.952 219.18 320.17 219.39 320.17 219.649 320.17 219.904 319.952 220.114 319.679 220.114 319.409 220.114 319.188 219.904 319.188 219.649z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M330.436 217.764L331.111 218.399 330.248 219.536 330.019 219.627 329.851 219.453 329.547 218.08 330.436 217.764' fill='%23c8b100'/%3E %3Cpath d='M330.436 217.764L331.111 218.399 330.248 219.536 330.019 219.627 329.851 219.453 329.547 218.08 330.436 217.764' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M331.85 220.043L331.344 220.518 330.121 219.858 330.023 219.646 330.204 219.485 331.602 219.365 331.85 220.043' fill='%23c8b100'/%3E %3Cpath d='M331.85 220.043L331.344 220.518 330.121 219.858 330.023 219.646 330.204 219.485 331.602 219.365 331.85 220.043' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M328.16 219.301L328.418 219.929 329.818 219.802 329.997 219.641 329.904 219.425 328.678 218.779 328.16 219.301' fill='%23c8b100'/%3E %3Cpath d='M328.16 219.301L328.418 219.929 329.818 219.802 329.997 219.641 329.904 219.425 328.678 218.779 328.16 219.301' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M333.008 220.22L333.121 220.885 334.518 221.03 334.729 220.909 334.676 220.683 333.627 219.809 333.008 220.22' fill='%23c8b100'/%3E %3Cpath d='M333.008 220.22L333.121 220.885 334.518 221.03 334.729 220.909 334.676 220.683 333.627 219.809 333.008 220.22' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.351 219.209C324.351 218.946 324.567 218.74 324.842 218.74 325.108 218.74 325.333 218.946 325.333 219.209 325.333 219.464 325.111 219.674 324.842 219.674 324.567 219.674 324.351 219.464 324.351 219.209' fill='%23c8b100'/%3E %3Cpath d='M324.351 219.209C324.351 218.946 324.567 218.74 324.842 218.74 325.108 218.74 325.333 218.946 325.333 219.209 325.333 219.464 325.111 219.674 324.842 219.674 324.567 219.674 324.351 219.464 324.351 219.209z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M329.525 219.649C329.525 219.39 329.746 219.18 330.016 219.18 330.289 219.18 330.512 219.39 330.512 219.649 330.512 219.904 330.289 220.114 330.016 220.114 329.746 220.114 329.525 219.904 329.525 219.649' fill='%23c8b100'/%3E %3Cpath d='M329.525 219.649C329.525 219.39 329.746 219.18 330.016 219.18 330.289 219.18 330.512 219.39 330.512 219.649 330.512 219.904 330.289 220.114 330.016 220.114 329.746 220.114 329.525 219.904 329.525 219.649z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M323.92 213.954C323.92 213.47 324.332 213.08 324.842 213.08 325.35 213.08 325.768 213.47 325.768 213.954 325.768 214.436 325.35 214.827 324.842 214.827 324.332 214.827 323.92 214.436 323.92 213.954' fill='%23c8b100'/%3E %3Cpath d='M325.494 213.644L325.494 214.223 324.069 214.223 324.069 213.644 324.535 213.644 324.535 212.337 323.916 212.337 323.916 211.755 324.535 211.755 324.535 211.184 325.146 211.184 325.146 211.755 325.753 211.755 325.753 212.337 325.146 212.337 325.146 213.644 325.49 213.644' fill='%23c8b100'/%3E %3Cpath d='M325.494 213.644L325.494 214.223 324.069 214.223 324.069 213.644 324.535 213.644 324.535 212.337 323.916 212.337 323.916 211.755 324.535 211.755 324.535 211.184 325.146 211.184 325.146 211.755 325.753 211.755 325.753 212.337 325.146 212.337 325.146 213.644 325.49 213.644 325.494 213.644z' fill='none' stroke='%23000' stroke-width='0.3'/%3E %3Cpath d='M326.132 213.644L326.132 214.223 323.597 214.223 323.597 213.644 324.535 213.644 324.535 212.337 323.916 212.337 323.916 211.755 324.535 211.755 324.535 211.184 325.146 211.184 325.146 211.755 325.756 211.755 325.756 212.337 325.146 212.337 325.146 213.644 326.132 213.644' fill='%23c8b100'/%3E %3Cpath d='M325.108 213.115C325.49 213.218 325.768 213.556 325.768 213.954 325.768 214.436 325.356 214.827 324.842 214.827 324.332 214.827 323.92 214.436 323.92 213.954 323.92 213.549 324.209 213.211 324.602 213.108' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M314.598 220.998C314.587 221.009 314.219 220.515 313.942 220.267 313.747 220.093 313.268 219.944 313.268 219.944 313.268 219.855 313.549 219.656 313.853 219.656 314.029 219.656 314.197 219.73 314.297 219.855L314.332 219.663C314.332 219.663 314.58 219.709 314.688 219.983 314.801 220.267 314.73 220.697 314.73 220.697 314.73 220.697 314.684 220.895 314.598 220.998' fill='%23c8b100'/%3E %3Cpath d='M314.598 220.998C314.587 221.009 314.219 220.515 313.942 220.267 313.747 220.093 313.268 219.944 313.268 219.944 313.268 219.855 313.549 219.656 313.853 219.656 314.029 219.656 314.197 219.73 314.297 219.855L314.332 219.663C314.332 219.663 314.58 219.709 314.688 219.983 314.801 220.267 314.73 220.697 314.73 220.697 314.73 220.697 314.684 220.895 314.598 220.998z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M314.617 220.753C314.734 220.632 314.973 220.657 315.15 220.81 315.33 220.963 315.382 221.186 315.264 221.311 315.15 221.435 314.913 221.407 314.734 221.254 314.553 221.101 314.501 220.874 314.617 220.753' fill='%23c8b100'/%3E %3Cpath d='M314.617 220.753C314.734 220.632 314.973 220.657 315.15 220.81 315.33 220.963 315.382 221.186 315.264 221.311 315.15 221.435 314.913 221.407 314.734 221.254 314.553 221.101 314.501 220.874 314.617 220.753z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M334.897 220.998C334.912 221.009 335.275 220.515 335.554 220.267 335.746 220.093 336.229 219.944 336.229 219.944 336.229 219.855 335.948 219.656 335.644 219.656 335.468 219.656 335.299 219.73 335.198 219.855L335.161 219.663C335.161 219.663 334.912 219.709 334.804 219.983 334.692 220.267 334.762 220.697 334.762 220.697 334.762 220.697 334.807 220.895 334.897 220.998' fill='%23c8b100'/%3E %3Cpath d='M334.897 220.998C334.912 221.009 335.275 220.515 335.554 220.267 335.746 220.093 336.229 219.944 336.229 219.944 336.229 219.855 335.948 219.656 335.644 219.656 335.468 219.656 335.299 219.73 335.198 219.855L335.161 219.663C335.161 219.663 334.912 219.709 334.804 219.983 334.692 220.267 334.762 220.697 334.762 220.697 334.762 220.697 334.807 220.895 334.897 220.998z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M334.91 220.753C334.792 220.632 334.554 220.657 334.373 220.81 334.193 220.963 334.145 221.186 334.256 221.311 334.373 221.435 334.613 221.407 334.792 221.254 334.972 221.101 335.026 220.874 334.91 220.753' fill='%23c8b100'/%3E %3Cpath d='M334.91 220.753C334.792 220.632 334.554 220.657 334.373 220.81 334.193 220.963 334.145 221.186 334.256 221.311 334.373 221.435 334.613 221.407 334.792 221.254 334.972 221.101 335.026 220.874 334.91 220.753z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M313.714 232.369L335.999 232.369 335.999 226.527 313.714 226.527 313.714 232.369z' fill='%23c8b100'/%3E %3Cpath d='M313.714 232.369L335.999 232.369 335.999 226.527 313.714 226.527 313.714 232.369z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M333.661 236.256C333.521 236.2 333.416 236.193 333.249 236.193L316.559 236.193C316.394 236.193 316.237 236.221 316.098 236.274 316.672 236.083 317.084 235.565 317.084 234.953 317.084 234.343 316.635 233.814 316.057 233.615 316.196 233.657 316.382 233.697 316.547 233.697L333.249 233.697C333.416 233.697 333.575 233.69 333.717 233.643L333.623 233.657C333.027 233.842 332.686 234.371 332.686 234.953 332.686 235.514 333.064 236.076 333.661 236.256' fill='%23c8b100'/%3E %3Cpath d='M333.661 236.256C333.521 236.2 333.416 236.193 333.249 236.193L316.559 236.193C316.394 236.193 316.237 236.221 316.098 236.274 316.672 236.083 317.084 235.565 317.084 234.953 317.084 234.343 316.635 233.814 316.057 233.615 316.196 233.657 316.382 233.697 316.547 233.697L333.249 233.697C333.416 233.697 333.575 233.69 333.717 233.643L333.623 233.657C333.027 233.842 332.686 234.371 332.686 234.953 332.686 235.514 333.064 236.076 333.661 236.256z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M316.559 236.193L333.249 236.193C333.81 236.193 334.269 236.544 334.269 236.974 334.269 237.407 333.81 237.759 333.249 237.759L316.559 237.759C315.993 237.759 315.535 237.407 315.535 236.974 315.535 236.544 315.993 236.193 316.559 236.193' fill='%23c8b100'/%3E %3Cpath d='M316.559 236.193L333.249 236.193C333.81 236.193 334.269 236.544 334.269 236.974 334.269 237.407 333.81 237.759 333.249 237.759L316.559 237.759C315.993 237.759 315.535 237.407 315.535 236.974 315.535 236.544 315.993 236.193 316.559 236.193z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M316.547 232.369L333.249 232.369C333.81 232.369 334.269 232.667 334.269 233.029 334.269 233.398 333.81 233.697 333.249 233.697L316.547 233.697C315.982 233.697 315.524 233.398 315.524 233.029 315.524 232.667 315.982 232.369 316.547 232.369' fill='%23c8b100'/%3E %3Cpath d='M316.547 232.369L333.249 232.369C333.81 232.369 334.269 232.667 334.269 233.029 334.269 233.398 333.81 233.697 333.249 233.697L316.547 233.697C315.982 233.697 315.524 233.398 315.524 233.029 315.524 232.667 315.982 232.369 316.547 232.369z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.297 330.676C310.841 330.676 312.212 330.353 313.225 329.813 314.231 329.302 315.592 328.989 317.091 328.989 318.595 328.989 319.994 329.306 320.999 329.82 322.004 330.35 323.398 330.676 324.921 330.676 326.458 330.676 327.838 330.317 328.85 329.778 329.847 329.287 331.178 328.989 332.644 328.989 334.156 328.989 335.494 329.277 336.503 329.799 337.511 330.336 338.917 330.676 340.454 330.676L340.454 333.09C338.917 333.09 337.511 332.739 336.503 332.206 335.494 331.688 334.156 331.394 332.644 331.394 331.178 331.394 329.847 331.695 328.85 332.189 327.842 332.725 326.458 333.09 324.921 333.09 323.402 333.09 322.007 332.757 320.999 332.232 319.994 331.71 318.599 331.394 317.091 331.394 315.592 331.394 314.231 331.71 313.225 332.225 312.212 332.764 310.86 333.09 309.319 333.09L309.297 330.676' fill='%23005bbf'/%3E %3Cpath d='M309.297 330.676C310.841 330.676 312.212 330.353 313.225 329.813 314.231 329.302 315.592 328.989 317.091 328.989 318.595 328.989 319.994 329.306 320.999 329.82 322.004 330.35 323.398 330.676 324.921 330.676 326.458 330.676 327.838 330.317 328.85 329.778 329.847 329.287 331.178 328.989 332.644 328.989 334.156 328.989 335.494 329.277 336.503 329.799 337.511 330.336 338.917 330.676 340.454 330.676L340.454 333.09C338.917 333.09 337.511 332.739 336.503 332.206 335.494 331.688 334.156 331.394 332.644 331.394 331.178 331.394 329.847 331.695 328.85 332.189 327.842 332.725 326.458 333.09 324.921 333.09 323.402 333.09 322.007 332.757 320.999 332.232 319.994 331.71 318.599 331.394 317.091 331.394 315.592 331.394 314.231 331.71 313.225 332.225 312.212 332.764 310.86 333.09 309.319 333.09L309.297 330.676z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.297 333.09C310.841 333.09 312.212 332.764 313.225 332.225 314.231 331.71 315.592 331.394 317.091 331.394 318.595 331.394 319.994 331.71 320.999 332.232 322.004 332.757 323.398 333.09 324.921 333.09 326.458 333.09 327.838 332.725 328.85 332.189 329.847 331.695 331.178 331.394 332.644 331.394 334.156 331.394 335.494 331.688 336.503 332.206 337.511 332.739 338.917 333.09 340.454 333.09L340.454 335.498C338.917 335.498 337.511 335.154 336.503 334.621 335.494 334.095 334.156 333.804 332.644 333.804 331.178 333.804 329.847 334.106 328.85 334.6 327.842 335.136 326.458 335.498 324.921 335.498 323.402 335.498 322.007 335.165 320.999 334.639 319.994 334.121 318.599 333.804 317.091 333.804 315.592 333.804 314.231 334.121 313.225 334.635 312.212 335.172 310.86 335.498 309.319 335.498L309.297 333.09' fill='%23cccccc'/%3E %3Cpath d='M309.297 333.09C310.841 333.09 312.212 332.764 313.225 332.225 314.231 331.71 315.592 331.394 317.091 331.394 318.595 331.394 319.994 331.71 320.999 332.232 322.004 332.757 323.398 333.09 324.921 333.09 326.458 333.09 327.838 332.725 328.85 332.189 329.847 331.695 331.178 331.394 332.644 331.394 334.156 331.394 335.494 331.688 336.503 332.206 337.511 332.739 338.917 333.09 340.454 333.09L340.454 335.498C338.917 335.498 337.511 335.154 336.503 334.621 335.494 334.095 334.156 333.804 332.644 333.804 331.178 333.804 329.847 334.106 328.85 334.6 327.842 335.136 326.458 335.498 324.921 335.498 323.402 335.498 322.007 335.165 320.999 334.639 319.994 334.121 318.599 333.804 317.091 333.804 315.592 333.804 314.231 334.121 313.225 334.635 312.212 335.172 310.86 335.498 309.319 335.498L309.297 333.09' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.297 335.498C310.841 335.498 312.212 335.172 313.225 334.635 314.231 334.121 315.592 333.804 317.091 333.804 318.595 333.804 319.994 334.121 320.999 334.639 322.004 335.165 323.398 335.498 324.921 335.498 326.458 335.498 327.838 335.136 328.85 334.6 329.847 334.106 331.178 333.804 332.644 333.804 334.156 333.804 335.494 334.095 336.503 334.621 337.511 335.154 338.917 335.498 340.454 335.498L340.454 337.905C338.917 337.905 337.511 337.561 336.503 337.025 335.494 336.507 334.156 336.216 332.644 336.216 331.178 336.216 329.847 336.518 328.85 337.007 327.842 337.547 326.458 337.905 324.921 337.905 323.402 337.905 322.007 337.576 320.999 337.051 319.994 336.532 318.599 336.216 317.091 336.216 315.592 336.216 314.231 336.528 313.225 337.044 312.212 337.586 310.86 337.905 309.319 337.905L309.297 335.498' fill='%23005bbf'/%3E %3Cpath d='M309.297 335.498C310.841 335.498 312.212 335.172 313.225 334.635 314.231 334.121 315.592 333.804 317.091 333.804 318.595 333.804 319.994 334.121 320.999 334.639 322.004 335.165 323.398 335.498 324.921 335.498 326.458 335.498 327.838 335.136 328.85 334.6 329.847 334.106 331.178 333.804 332.644 333.804 334.156 333.804 335.494 334.095 336.503 334.621 337.511 335.154 338.917 335.498 340.454 335.498L340.454 337.905C338.917 337.905 337.511 337.561 336.503 337.025 335.494 336.507 334.156 336.216 332.644 336.216 331.178 336.216 329.847 336.518 328.85 337.007 327.842 337.547 326.458 337.905 324.921 337.905 323.402 337.905 322.007 337.576 320.999 337.051 319.994 336.532 318.599 336.216 317.091 336.216 315.592 336.216 314.231 336.528 313.225 337.044 312.212 337.586 310.86 337.905 309.319 337.905L309.297 335.498' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.319 340.317C310.86 340.317 312.212 339.991 313.225 339.451 314.231 338.94 315.592 338.626 317.091 338.626 318.595 338.626 319.994 338.94 320.999 339.458 322.004 339.984 323.398 340.317 324.921 340.317 326.458 340.317 327.838 339.954 328.85 339.415 329.847 338.925 331.178 338.626 332.644 338.626 334.156 338.626 335.494 338.918 336.503 339.436 337.511 339.973 338.917 340.317 340.454 340.317L340.454 337.921C338.917 337.921 337.511 337.561 336.503 337.025 335.494 336.507 334.156 336.216 332.644 336.216 331.178 336.216 329.847 336.518 328.85 337.007 327.842 337.547 326.458 337.905 324.921 337.905 323.402 337.905 322.007 337.576 320.999 337.051 319.994 336.532 318.599 336.216 317.091 336.216 315.592 336.216 314.231 336.528 313.225 337.044 312.212 337.586 310.841 337.905 309.297 337.905L309.319 340.317' fill='%23cccccc'/%3E %3Cpath d='M309.319 340.317C310.86 340.317 312.212 339.991 313.225 339.451 314.231 338.94 315.592 338.626 317.091 338.626 318.595 338.626 319.994 338.94 320.999 339.458 322.004 339.984 323.398 340.317 324.921 340.317 326.458 340.317 327.838 339.954 328.85 339.415 329.847 338.925 331.178 338.626 332.644 338.626 334.156 338.626 335.494 338.918 336.503 339.436 337.511 339.973 338.917 340.317 340.454 340.317L340.454 337.921C338.917 337.921 337.511 337.561 336.503 337.025 335.494 336.507 334.156 336.216 332.644 336.216 331.178 336.216 329.847 336.518 328.85 337.007 327.842 337.547 326.458 337.905 324.921 337.905 323.402 337.905 322.007 337.576 320.999 337.051 319.994 336.532 318.599 336.216 317.091 336.216 315.592 336.216 314.231 336.528 313.225 337.044 312.212 337.586 310.841 337.905 309.297 337.905L309.319 340.317' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.319 342.728C310.86 342.728 312.212 342.401 313.225 341.866 314.231 341.347 315.592 341.031 317.091 341.031 318.595 341.031 319.994 341.35 320.999 341.869 322.004 342.394 323.398 342.728 324.921 342.728 326.458 342.728 327.838 342.362 328.85 341.826 329.847 341.333 331.178 341.031 332.644 341.031 334.156 341.031 335.494 341.326 336.503 341.847 337.511 342.38 338.917 342.728 340.454 342.728L340.454 340.338C338.917 340.338 337.511 339.973 336.503 339.436 335.494 338.918 334.156 338.63 332.644 338.63 331.178 338.63 329.847 338.928 328.85 339.419 327.842 339.954 326.458 340.317 324.921 340.317 323.402 340.317 322.007 339.984 320.999 339.458 319.994 338.94 318.599 338.63 317.091 338.63 315.592 338.63 314.231 338.94 313.225 339.454 312.212 339.991 310.845 340.317 309.304 340.317L309.319 342.728' fill='%23005bbf'/%3E %3Cpath d='M309.319 342.728C310.86 342.728 312.212 342.401 313.225 341.866 314.231 341.347 315.592 341.031 317.091 341.031 318.595 341.031 319.994 341.35 320.999 341.869 322.004 342.394 323.398 342.728 324.921 342.728 326.458 342.728 327.838 342.362 328.85 341.826 329.847 341.333 331.178 341.031 332.644 341.031 334.156 341.031 335.494 341.326 336.503 341.847 337.511 342.38 338.917 342.728 340.454 342.728L340.454 340.338C338.917 340.338 337.511 339.973 336.503 339.436 335.494 338.918 334.156 338.63 332.644 338.63 331.178 338.63 329.847 338.928 328.85 339.419 327.842 339.954 326.458 340.317 324.921 340.317 323.402 340.317 322.007 339.984 320.999 339.458 319.994 338.94 318.599 338.63 317.091 338.63 315.592 338.63 314.231 338.94 313.225 339.454 312.212 339.991 310.845 340.317 309.304 340.317L309.319 342.728z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M333.657 320.783C333.605 320.986 333.534 321.185 333.534 321.401 333.534 322.864 334.796 324.028 336.338 324.028L313.405 324.028C314.946 324.028 316.207 322.864 316.207 321.401 316.207 321.188 316.166 320.986 316.12 320.783 316.244 320.83 316.402 320.837 316.555 320.837L333.245 320.837C333.379 320.837 333.537 320.822 333.653 320.783' fill='%23c8b100'/%3E %3Cpath d='M333.657 320.783C333.605 320.986 333.534 321.185 333.534 321.401 333.534 322.864 334.796 324.028 336.338 324.028L313.405 324.028C314.946 324.028 316.207 322.864 316.207 321.401 316.207 321.188 316.166 320.986 316.12 320.783 316.244 320.83 316.402 320.837 316.555 320.837L333.245 320.837C333.379 320.837 333.537 320.822 333.653 320.783L333.657 320.783z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M316.559 319.267L333.249 319.267C333.81 319.267 334.269 319.622 334.269 320.052 334.269 320.485 333.81 320.837 333.249 320.837L316.559 320.837C315.993 320.837 315.535 320.485 315.535 320.052 315.535 319.622 315.993 319.267 316.559 319.267' fill='%23c8b100'/%3E %3Cpath d='M316.559 319.267L333.249 319.267C333.81 319.267 334.269 319.622 334.269 320.052 334.269 320.485 333.81 320.837 333.249 320.837L316.559 320.837C315.993 320.837 315.535 320.485 315.535 320.052 315.535 319.622 315.993 319.267 316.559 319.267z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M313.432 329.863L336.309 329.863 336.309 324.028 313.432 324.028 313.432 329.863z' fill='%23c8b100'/%3E %3Cpath d='M313.432 329.863L336.309 329.863 336.309 324.028 313.432 324.028 313.432 329.863z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M338.096 298.618C340.361 299.925 341.899 301.263 341.651 301.931 341.526 302.545 340.807 303.003 339.78 303.685 338.164 304.811 337.177 306.821 337.947 307.748 336.612 306.669 335.768 305.056 335.768 303.263 335.768 301.388 336.657 299.698 338.096 298.618' fill='%23ad1519'/%3E %3Cpath d='M338.096 298.618C340.361 299.925 341.899 301.263 341.651 301.931 341.526 302.545 340.807 303.003 339.78 303.685 338.164 304.811 337.177 306.821 337.947 307.748 336.612 306.669 335.768 305.056 335.768 303.263 335.768 301.388 336.657 299.698 338.096 298.618z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M316.777 318.322L333.031 318.322 333.031 238.686 316.777 238.686 316.777 318.322z' fill='%23cccccc'/%3E %3Cpath d='M328.568 238.657L328.568 318.123M330.395 238.657L330.395 318.123' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M316.777 318.322L333.031 318.322 333.031 238.686 316.777 238.686 316.777 318.322z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M300.174 268.474C303.723 267.008 309.754 265.921 316.672 265.694 319.055 265.712 321.714 265.936 324.459 266.394 334.178 268.016 341.584 271.897 340.995 275.058 340.983 275.125 340.965 275.263 340.946 275.324 340.946 275.324 344.593 267.111 344.647 266.798 345.299 263.29 337.087 258.979 326.297 257.179 322.911 256.614 319.604 256.394 316.739 256.422 309.833 256.422 303.833 257.306 300.219 258.649L300.174 268.474' fill='%23ad1519'/%3E %3Cpath d='M300.174 268.474C303.723 267.008 309.754 265.921 316.672 265.694 319.055 265.712 321.714 265.936 324.459 266.394 334.178 268.016 341.584 271.897 340.995 275.058 340.983 275.125 340.965 275.263 340.946 275.324 340.946 275.324 344.593 267.111 344.647 266.798 345.299 263.29 337.087 258.979 326.297 257.179 322.911 256.614 319.604 256.394 316.739 256.422 309.833 256.422 303.833 257.306 300.219 258.649L300.174 268.474' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M333.06 278.47C337.568 278.147 340.646 276.943 340.995 275.058 341.277 273.556 339.75 271.894 337.031 270.385 335.813 270.516 334.444 270.683 333.031 270.683L333.06 278.47' fill='%23ad1519'/%3E %3Cpath d='M333.06 278.47C337.568 278.147 340.646 276.943 340.995 275.058 341.277 273.556 339.75 271.894 337.031 270.385 335.813 270.516 334.444 270.683 333.031 270.683L333.06 278.47' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M316.751 272.384C313.931 272.81 311.819 273.509 310.762 274.369L310.669 274.542C310.162 275.573 312.64 277.764 316.773 280.21L316.751 272.384' fill='%23ad1519'/%3E %3Cpath d='M316.751 272.384C313.931 272.81 311.819 273.509 310.762 274.369L310.669 274.542C310.162 275.573 312.64 277.764 316.773 280.21L316.751 272.384' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M343.154 293.832C343.581 292.546 339.186 289.972 332.975 287.693 330.136 286.677 327.792 285.618 324.887 284.337 316.259 280.522 309.885 276.144 310.672 274.547L310.756 274.383C310.301 274.756 309.59 282.621 309.59 282.621 308.802 284.084 314.636 288.398 322.572 292.205 325.116 293.42 330.488 295.404 333.023 296.292 337.556 297.865 342.06 300.831 341.651 301.931L343.154 293.836' fill='%23ad1519'/%3E %3Cpath d='M343.154 293.832C343.581 292.546 339.186 289.972 332.975 287.693 330.136 286.677 327.792 285.618 324.887 284.337 316.259 280.522 309.885 276.144 310.672 274.547L310.756 274.383C310.301 274.756 309.59 282.621 309.59 282.621 308.802 284.084 314.636 288.398 322.572 292.205 325.116 293.42 330.488 295.404 333.023 296.292 337.556 297.865 342.06 300.831 341.651 301.931L343.154 293.836 343.154 293.832z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M310.304 264.984C310.92 262.651 311.714 260.396 312.494 258.113 312.322 258.159 312.135 258.195 311.962 258.223 311.787 258.248 311.598 258.265 311.419 258.272 311.048 259.913 310.545 261.561 310.005 263.208 309.045 261.767 307.999 260.367 307.167 258.911 306.834 258.979 306.487 259.06 306.147 259.111 305.813 259.16 305.456 259.185 305.112 259.218 306.563 261.163 307.965 263.109 309.312 265.129 309.473 265.087 309.629 265.033 309.807 265.008 309.968 264.987 310.136 264.991 310.304 264.984' fill='%23c8b100'/%3E %3Cpath d='M316.485 258.159C316.188 258.173 315.892 258.195 315.595 258.19 315.3 258.187 315.004 258.152 314.711 258.13L314.591 264.543 319.075 264.619C319.052 264.487 319.019 264.345 319.023 264.21 319.023 264.078 319.064 263.94 319.086 263.808 318.283 263.861 317.407 263.912 316.379 263.894L316.485 258.159' fill='%23c8b100'/%3E %3Cpath d='M323.525 259.214C324.242 259.274 324.932 259.398 325.622 259.523 325.609 259.388 325.588 259.253 325.599 259.114 325.609 258.983 325.66 258.851 325.697 258.723L319.626 258.22C319.641 258.355 319.664 258.486 319.649 258.617 319.637 258.759 319.589 258.887 319.554 259.018 320.173 259.004 320.92 258.997 321.756 259.068L321.227 264.838C321.523 264.845 321.819 264.842 322.112 264.866 322.407 264.888 322.701 264.941 322.993 264.984L323.522 259.214' fill='%23c8b100'/%3E %3Cpath d='M326.008 265.534C326.301 265.58 326.596 265.615 326.886 265.68 327.174 265.74 327.456 265.833 327.737 265.914L328.457 262.967 328.535 262.984C328.703 263.389 328.922 263.882 329.034 264.167L329.934 266.394C330.286 266.45 330.638 266.496 330.984 266.571 331.339 266.649 331.68 266.752 332.022 266.848L331.71 266.18C331.226 265.175 330.717 264.174 330.297 263.156 331.415 263.205 332.281 262.8 332.498 261.902 332.652 261.277 332.404 260.786 331.815 260.367 331.381 260.058 330.538 259.895 329.994 259.774L327.546 259.239 326.008 265.534M329.149 260.112C329.855 260.268 330.736 260.382 330.736 261.184 330.732 261.386 330.713 261.528 330.68 261.656 330.451 262.598 329.739 262.924 328.55 262.569L329.149 260.112' fill='%23c8b100'/%3E %3Cpath d='M337.57 267.455C337.516 268.151 337.392 268.826 337.257 269.557 337.564 269.703 337.868 269.834 338.164 269.997 338.46 270.161 338.733 270.342 339.019 270.52L339.619 263.29C339.476 263.233 339.348 263.173 339.214 263.102 339.078 263.028 338.963 262.953 338.838 262.864L332.464 266.912C332.632 266.994 332.807 267.068 332.971 267.157 333.136 267.25 333.275 267.348 333.44 267.441 333.975 266.99 334.538 266.624 335.183 266.145L337.568 267.452 337.57 267.455zM335.764 265.804L337.886 264.43 337.639 266.827 335.764 265.804' fill='%23c8b100'/%3E %3Cpath d='M225.199 200.449C225.199 199.312 226.17 198.393 227.366 198.393 228.558 198.393 229.533 199.312 229.533 200.449 229.533 201.582 228.562 202.501 227.366 202.501 226.17 202.501 225.199 201.582 225.199 200.449z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M249.649 182.723C256.294 182.723 262.206 183.706 266.057 185.233 268.261 186.228 271.221 186.963 274.46 187.396 276.927 187.726 279.271 187.793 281.31 187.637 284.037 187.584 287.981 188.382 291.926 190.119 295.191 191.568 297.917 193.329 299.727 195.034L298.16 196.43 297.707 200.392 293.409 205.313 291.261 207.136 286.173 211.209 283.574 211.421 282.784 213.67 249.866 209.813 216.848 213.67 216.057 211.421 213.454 211.209 208.367 207.136 206.219 205.313 201.922 200.392 201.475 196.43 199.9 195.034C201.719 193.329 204.445 191.568 207.703 190.119 211.648 188.382 215.593 187.584 218.317 187.637 220.356 187.793 222.701 187.726 225.168 187.396 228.409 186.963 231.371 186.228 233.571 185.233 237.426 183.706 243.009 182.723 249.649 182.723z' fill='%23ad1519' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M250.154 226.179C237.89 226.161 226.904 224.709 219.065 222.348 218.491 222.174 218.191 221.648 218.224 221.104 218.214 220.576 218.51 220.097 219.065 219.929 226.904 217.571 237.89 216.119 250.154 216.101 262.416 216.119 273.395 217.571 281.235 219.929 281.79 220.097 282.081 220.576 282.071 221.104 282.101 221.648 281.805 222.174 281.235 222.348 273.395 224.709 262.416 226.161 250.154 226.179' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.124 224.57C239.056 224.556 229.053 223.278 221.438 221.311 229.053 219.34 239.056 218.136 250.124 218.115 261.19 218.136 271.247 219.34 278.862 221.311 271.247 223.278 261.19 224.556 250.124 224.57' fill='%23ad1519'/%3E %3Cpath d='M250.946 224.637L250.946 218.07' fill='none' stroke='%23000' stroke-width='0.09'/%3E %3Cpath d='M249.162 224.637L249.162 218.07' fill='none' stroke='%23000' stroke-width='0.14'/%3E %3Cpath d='M247.478 224.637L247.478 218.07' fill='none' stroke='%23000' stroke-width='0.18'/%3E %3Cpath d='M245.809 224.637L245.809 218.07' fill='none' stroke='%23000' stroke-width='0.23'/%3E %3Cpath d='M244.321 224.637L244.321 218.07' fill='none' stroke='%23000' stroke-width='0.28'/%3E %3Cpath d='M241.484 224.283L241.445 218.306M242.829 224.362L242.829 218.109' fill='none' stroke='%23000' stroke-width='0.33'/%3E %3Cpath d='M238.865 224.014L238.865 218.507M240.192 224.172L240.153 218.311' fill='none' stroke='%23000' stroke-width='0.37'/%3E %3Cpath d='M235.352 223.7L235.352 218.861M236.504 223.778L236.504 218.704M237.692 223.936L237.692 218.664' fill='none' stroke='%23000' stroke-width='0.42'/%3E %3Cpath d='M234.12 223.66L234.12 218.979' fill='none' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M232.972 223.424L232.972 219.058' fill='none' stroke='%23000' stroke-width='0.51'/%3E %3Cpath d='M231.74 223.306L231.74 219.254' fill='none' stroke='%23000' stroke-width='0.56'/%3E %3Cpath d='M229.219 222.953L229.179 219.727M230.511 223.11L230.511 219.491' fill='none' stroke='%23000' stroke-width='0.6'/%3E %3Cpath d='M227.927 222.677L227.927 219.844' fill='none' stroke='%23000' stroke-width='0.63'/%3E %3Cpath d='M226.743 222.447L226.743 220.088' fill='none' stroke='%23000' stroke-width='0.68'/%3E %3Cpath d='M225.451 222.133L225.451 220.285' fill='none' stroke='%23000' stroke-width='0.73'/%3E %3Cpath d='M224.123 221.976L224.123 220.6' fill='none' stroke='%23000' stroke-width='0.77'/%3E %3Cpath d='M222.718 221.661L222.718 220.993' fill='none' stroke='%23000' stroke-width='0.91'/%3E %3Cpath d='M258.043 224.283L258.043 218.267M255.021 224.48L255.06 218.109M252.818 224.559L252.818 218.07' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M250.069 216.091C237.658 216.115 226.519 217.671 218.678 220.086 219.329 219.776 219.271 218.974 218.46 216.887 217.482 214.361 215.956 214.472 215.956 214.472 224.625 211.912 236.691 210.31 250.121 210.292 263.556 210.31 275.72 211.912 284.389 214.472 284.389 214.472 282.862 214.361 281.884 216.887 281.074 218.974 281.014 219.776 281.666 220.086 273.827 217.671 262.479 216.115 250.069 216.091' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.121 210.295C236.691 210.317 224.625 211.915 215.956 214.479 215.378 214.652 214.767 214.426 214.58 213.879 214.393 213.331 214.704 212.703 215.282 212.526 223.987 209.855 236.365 208.179 250.124 208.151 263.887 208.176 276.312 209.855 285.018 212.526 285.596 212.703 285.907 213.331 285.72 213.879 285.532 214.426 284.921 214.652 284.344 214.479 275.674 211.915 263.556 210.317 250.121 210.295' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.124 224.57C239.056 224.556 229.053 223.278 221.438 221.311 229.053 219.34 239.056 218.136 250.124 218.115 261.19 218.136 271.247 219.34 278.862 221.311 271.247 223.278 261.19 224.556 250.124 224.57z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M240.542 213.346C240.542 212.774 241.032 212.309 241.636 212.309 242.244 212.309 242.736 212.774 242.736 213.346 242.736 213.917 242.244 214.386 241.636 214.386 241.032 214.386 240.542 213.917 240.542 213.346' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.148 214.163L246.862 214.163C246.256 214.163 245.753 213.701 245.753 213.126 245.753 212.554 246.245 212.086 246.849 212.086L253.491 212.086C254.095 212.086 254.588 212.554 254.588 213.126 254.588 213.701 254.085 214.163 253.476 214.163L250.148 214.163' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M233.639 215.068L231.275 215.342C230.672 215.413 230.113 215.008 230.038 214.443 229.964 213.872 230.392 213.353 230.995 213.286L233.373 213.009 235.791 212.731C236.39 212.661 236.938 213.058 237.013 213.63 237.084 214.198 236.646 214.72 236.046 214.787L233.639 215.068' fill='%23058e6e' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M224.033 215.275C224.033 214.703 224.524 214.237 225.127 214.237 225.735 214.237 226.226 214.703 226.226 215.275 226.226 215.85 225.735 216.315 225.127 216.315 224.524 216.315 224.033 215.85 224.033 215.275' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M216.725 217.164L217.944 215.569 221.311 215.995 218.618 217.959 216.725 217.164' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M266.661 215.068L269.023 215.342C269.622 215.413 270.186 215.008 270.26 214.443 270.328 213.872 269.904 213.353 269.304 213.286L266.927 213.009 264.509 212.731C263.905 212.661 263.358 213.058 263.286 213.63 263.211 214.198 263.654 214.72 264.253 214.787L266.661 215.068' fill='%23058e6e' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M257.564 213.346C257.564 212.774 258.056 212.309 258.66 212.309 259.267 212.309 259.758 212.774 259.758 213.346 259.758 213.917 259.267 214.386 258.66 214.386 258.056 214.386 257.564 213.917 257.564 213.346' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.073 215.275C274.073 214.703 274.565 214.237 275.169 214.237 275.776 214.237 276.267 214.703 276.267 215.275 276.267 215.85 275.776 216.315 275.169 216.315 274.565 216.315 274.073 215.85 274.073 215.275' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M283.574 217.164L282.356 215.569 278.989 215.995 281.681 217.959 283.574 217.164' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M220.115 221.662C227.869 219.485 238.412 218.136 250.124 218.115 261.835 218.136 272.431 219.485 280.185 221.662' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.338 191.419L226.725 192.531 228.805 189.133C226.548 187.751 225 185.351 225 182.616 225 182.307 225.018 182.006 225.057 181.707 225.274 177.371 230.556 173.788 237.264 173.788 240.744 173.788 243.887 174.74 246.099 176.267 246.158 175.596 246.219 175.021 246.312 174.41 243.875 172.989 240.714 172.134 237.264 172.134 229.552 172.134 223.519 176.515 223.226 181.704 223.196 182.006 223.181 182.311 223.181 182.616 223.181 185.383 224.445 187.875 226.443 189.608L225.338 191.419' fill='%23c8b100'/%3E %3Cpath d='M225.338 191.419L226.725 192.531 228.805 189.133C226.548 187.751 225 185.351 225 182.616 225 182.307 225.018 182.006 225.057 181.707 225.274 177.371 230.556 173.788 237.264 173.788 240.744 173.788 243.887 174.74 246.099 176.267 246.158 175.596 246.219 175.021 246.312 174.41 243.875 172.989 240.714 172.134 237.264 172.134 229.552 172.134 223.519 176.515 223.226 181.704 223.196 182.006 223.181 182.311 223.181 182.616 223.181 185.383 224.445 187.875 226.443 189.608L225.338 191.419' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.427 191.457C222.795 189.494 221.161 186.824 221.161 183.884 221.161 180.496 223.376 177.475 226.743 175.472 224.666 177.14 223.406 179.296 223.226 181.704 223.196 182.006 223.181 182.311 223.181 182.616 223.181 185.383 224.445 187.875 226.443 189.608L225.427 191.457' fill='%23c8b100'/%3E %3Cpath d='M225.427 191.457C222.795 189.494 221.161 186.824 221.161 183.884 221.161 180.496 223.376 177.475 226.743 175.472 224.666 177.14 223.406 179.296 223.226 181.704 223.196 182.006 223.181 182.311 223.181 182.616 223.181 185.383 224.445 187.875 226.443 189.608L225.427 191.457' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M202.207 194.888C200.733 193.237 199.83 191.103 199.83 188.77 199.83 187.363 200.155 186.018 200.744 184.818 202.874 180.436 209.555 177.247 217.497 177.247 219.661 177.247 221.731 177.482 223.643 177.918 223.219 178.38 222.886 178.887 222.561 179.399 220.973 179.09 219.271 178.923 217.497 178.923 210.227 178.923 204.145 181.75 202.383 185.57 201.914 186.544 201.651 187.63 201.651 188.77 201.651 191.092 202.739 193.173 204.441 194.594L201.809 198.893 200.4 197.772 202.207 194.892' fill='%23c8b100'/%3E %3Cpath d='M202.207 194.888C200.733 193.237 199.83 191.103 199.83 188.77 199.83 187.363 200.155 186.018 200.744 184.818 202.874 180.436 209.555 177.247 217.497 177.247 219.661 177.247 221.731 177.482 223.643 177.918 223.219 178.38 222.886 178.887 222.561 179.399 220.973 179.09 219.271 178.923 217.497 178.923 210.227 178.923 204.145 181.75 202.383 185.57 201.914 186.544 201.651 187.63 201.651 188.77 201.651 191.092 202.739 193.173 204.441 194.594L201.809 198.893 200.4 197.772 202.207 194.892 202.207 194.888z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M204.903 180.482C202.99 181.686 201.543 183.167 200.744 184.818 200.155 186.018 199.83 187.363 199.83 188.77 199.83 191.103 200.733 193.237 202.207 194.888L200.609 197.481C199.08 195.516 198.191 193.223 198.191 190.783 198.191 186.582 200.864 182.911 204.903 180.482' fill='%23c8b100'/%3E %3Cpath d='M204.903 180.482C202.99 181.686 201.543 183.167 200.744 184.818 200.155 186.018 199.83 187.363 199.83 188.77 199.83 191.103 200.733 193.237 202.207 194.888L200.609 197.481C199.08 195.516 198.191 193.223 198.191 190.783 198.191 186.582 200.864 182.911 204.903 180.482z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.039 171.267C251.801 171.267 253.316 172.432 253.677 173.995 253.912 175.376 254.059 176.949 254.092 178.625 254.095 178.799 254.08 178.969 254.08 179.14 254.085 179.338 254.123 179.552 254.126 179.754 254.186 183.269 254.689 186.373 255.404 188.273L250.036 193.408 244.609 188.273C245.329 186.373 245.828 183.269 245.895 179.754 245.899 179.552 245.938 179.338 245.938 179.14 245.938 178.969 245.926 178.799 245.93 178.625 245.956 176.949 246.106 175.376 246.342 173.995 246.699 172.432 248.277 171.267 250.036 171.267' fill='%23c8b100'/%3E %3Cpath d='M250.039 171.267C251.801 171.267 253.316 172.432 253.677 173.995 253.912 175.376 254.059 176.949 254.092 178.625 254.095 178.799 254.08 178.969 254.08 179.14 254.085 179.338 254.123 179.552 254.126 179.754 254.186 183.269 254.689 186.373 255.404 188.273L250.036 193.408 244.609 188.273C245.329 186.373 245.828 183.269 245.895 179.754 245.899 179.552 245.938 179.338 245.938 179.14 245.938 178.969 245.926 178.799 245.93 178.625 245.956 176.949 246.106 175.376 246.342 173.995 246.699 172.432 248.277 171.267 250.036 171.267L250.039 171.267z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.039 172.94C250.954 172.94 251.725 173.523 251.914 174.331 252.135 175.638 252.277 177.13 252.307 178.706 252.307 178.87 252.299 179.033 252.299 179.192 252.299 179.388 252.333 179.583 252.337 179.782 252.394 183.102 252.87 186.028 253.552 187.829L250.012 191.181 246.469 187.829C247.145 186.032 247.621 183.102 247.681 179.782 247.685 179.583 247.719 179.388 247.722 179.192 247.722 179.033 247.711 178.87 247.711 178.706 247.741 177.13 247.883 175.638 248.107 174.331 248.292 173.523 249.127 172.94 250.039 172.94' fill='%23c8b100'/%3E %3Cpath d='M250.039 172.94C250.954 172.94 251.725 173.523 251.914 174.331 252.135 175.638 252.277 177.13 252.307 178.706 252.307 178.87 252.299 179.033 252.299 179.192 252.299 179.388 252.333 179.583 252.337 179.782 252.394 183.102 252.87 186.028 253.552 187.829L250.012 191.181 246.469 187.829C247.145 186.032 247.621 183.102 247.681 179.782 247.685 179.583 247.719 179.388 247.722 179.192 247.722 179.033 247.711 178.87 247.711 178.706 247.741 177.13 247.883 175.638 248.107 174.331 248.292 173.523 249.127 172.94 250.039 172.94z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.7 191.419L273.312 192.531 271.232 189.133C273.488 187.751 275.037 185.351 275.037 182.616 275.037 182.307 275.019 182.006 274.982 181.707 274.767 177.371 269.477 173.788 262.776 173.788 259.289 173.788 256.15 174.74 253.935 176.267 253.875 175.596 253.823 175.021 253.721 174.41 256.159 172.989 259.319 172.134 262.776 172.134 270.486 172.134 276.518 176.515 276.814 181.704 276.84 182.006 276.855 182.311 276.855 182.616 276.855 185.383 275.593 187.875 273.594 189.608L274.7 191.419' fill='%23c8b100'/%3E %3Cpath d='M274.7 191.419L273.312 192.531 271.232 189.133C273.488 187.751 275.037 185.351 275.037 182.616 275.037 182.307 275.019 182.006 274.982 181.707 274.767 177.371 269.477 173.788 262.776 173.788 259.289 173.788 256.15 174.74 253.935 176.267 253.875 175.596 253.823 175.021 253.721 174.41 256.159 172.989 259.319 172.134 262.776 172.134 270.486 172.134 276.518 176.515 276.814 181.704 276.84 182.006 276.855 182.311 276.855 182.616 276.855 185.383 275.593 187.875 273.594 189.608L274.7 191.419' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.61 191.457C277.242 189.494 278.877 186.824 278.877 183.884 278.877 180.496 276.66 177.475 273.298 175.472 275.371 177.14 276.63 179.296 276.814 181.704 276.84 182.006 276.855 182.311 276.855 182.616 276.855 185.383 275.593 187.875 273.594 189.608L274.61 191.457' fill='%23c8b100'/%3E %3Cpath d='M274.61 191.457C277.242 189.494 278.877 186.824 278.877 183.884 278.877 180.496 276.66 177.475 273.298 175.472 275.371 177.14 276.63 179.296 276.814 181.704 276.84 182.006 276.855 182.311 276.855 182.616 276.855 185.383 275.593 187.875 273.594 189.608L274.61 191.457' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M297.834 194.888C299.304 193.237 300.206 191.103 300.206 188.77 300.206 187.363 299.881 186.018 299.297 184.818 297.163 180.436 290.482 177.247 282.539 177.247 280.375 177.247 278.306 177.482 276.394 177.918 276.822 178.38 277.152 178.887 277.479 179.399 279.06 179.09 280.77 178.923 282.535 178.923 289.807 178.923 295.892 181.75 297.65 185.57 298.122 186.544 298.382 187.63 298.382 188.77 298.382 191.092 297.294 193.173 295.592 194.594L298.224 198.893 299.637 197.772 297.831 194.892' fill='%23c8b100'/%3E %3Cpath d='M297.834 194.888C299.304 193.237 300.206 191.103 300.206 188.77 300.206 187.363 299.881 186.018 299.297 184.818 297.163 180.436 290.482 177.247 282.539 177.247 280.375 177.247 278.306 177.482 276.394 177.918 276.822 178.38 277.152 178.887 277.479 179.399 279.06 179.09 280.77 178.923 282.535 178.923 289.807 178.923 295.892 181.75 297.65 185.57 298.122 186.544 298.382 187.63 298.382 188.77 298.382 191.092 297.294 193.173 295.592 194.594L298.224 198.893 299.637 197.772 297.831 194.892 297.834 194.888z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M295.135 180.482C297.047 181.686 298.495 183.167 299.297 184.818 299.878 186.018 300.206 187.363 300.206 188.77 300.206 191.103 299.304 193.237 297.834 194.888L299.428 197.481C300.957 195.516 301.842 193.223 301.842 190.783 301.842 186.582 299.173 182.911 295.135 180.482' fill='%23c8b100'/%3E %3Cpath d='M295.135 180.482C297.047 181.686 298.495 183.167 299.297 184.818 299.878 186.018 300.206 187.363 300.206 188.77 300.206 191.103 299.304 193.237 297.834 194.888L299.428 197.481C300.957 195.516 301.842 193.223 301.842 190.783 301.842 186.582 299.173 182.911 295.135 180.482z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.131 188.933C248.131 187.939 248.985 187.137 250.036 187.137 251.086 187.137 251.941 187.939 251.941 188.933 251.941 189.931 251.086 190.738 250.036 190.738 248.985 190.738 248.131 189.931 248.131 188.933' fill='%23fff'/%3E %3Cpath d='M248.131 188.933C248.131 187.939 248.985 187.137 250.036 187.137 251.086 187.137 251.941 187.939 251.941 188.933 251.941 189.931 251.086 190.738 250.036 190.738 248.985 190.738 248.131 189.931 248.131 188.933z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.131 185.4C248.131 184.406 248.985 183.596 250.036 183.596 251.086 183.596 251.941 184.406 251.941 185.4 251.941 186.395 251.086 187.2 250.036 187.2 248.985 187.2 248.131 186.395 248.131 185.4' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.513 181.6C248.513 180.804 249.196 180.162 250.036 180.162 250.871 180.162 251.554 180.804 251.554 181.6 251.554 182.395 250.871 183.039 250.036 183.039 249.196 183.039 248.513 182.395 248.513 181.6' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.94 178.173C248.94 177.603 249.432 177.137 250.036 177.137 250.643 177.137 251.13 177.603 251.13 178.173 251.13 178.749 250.643 179.215 250.036 179.215 249.432 179.215 248.94 178.749 248.94 178.173' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M249.158 175.177C249.158 174.715 249.55 174.346 250.036 174.346 250.519 174.346 250.913 174.715 250.913 175.177 250.913 175.635 250.519 176.008 250.036 176.008 249.55 176.008 249.158 175.635 249.158 175.177' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.197 199.777L251.434 200.005C251.235 200.505 251.194 201.052 251.194 201.628 251.194 204.195 253.399 206.283 256.113 206.283 258.292 206.283 260.148 204.934 260.785 203.07 260.857 203.119 261.254 201.386 261.46 201.408 261.632 201.426 261.614 203.208 261.677 203.176 261.993 205.523 264.137 207.111 266.552 207.111 269.262 207.111 271.46 205.033 271.46 202.462 271.46 202.271 271.449 202.079 271.423 201.894L272.964 200.367 273.791 202.313C273.462 202.924 273.331 203.61 273.331 204.345 273.331 206.799 275.431 208.783 278.022 208.783 279.652 208.783 281.084 207.999 281.925 206.809L282.911 205.555 282.904 207.093C282.904 208.637 283.556 210.023 285.064 210.267 285.064 210.267 286.794 210.374 289.087 208.574 291.382 206.773 292.645 205.282 292.645 205.282L292.843 207.085C292.843 207.085 290.939 210.03 288.866 211.23 287.733 211.89 286.012 212.582 284.644 212.359 283.196 212.124 282.165 210.963 281.633 209.625 280.601 210.232 279.383 210.586 278.078 210.586 275.274 210.586 272.753 209.049 271.756 206.734 270.467 208.126 268.67 208.981 266.564 208.981 264.325 208.981 262.273 207.974 260.988 206.425 259.724 207.576 258.006 208.286 256.113 208.286 253.634 208.286 251.423 207.071 250.17 205.239 248.918 207.071 246.709 208.286 244.234 208.286 242.342 208.286 240.62 207.576 239.356 206.425 238.075 207.974 236.02 208.981 233.781 208.981 231.674 208.981 229.878 208.126 228.587 206.734 227.591 209.049 225.072 210.586 222.266 210.586 220.961 210.586 219.747 210.232 218.716 209.625 218.179 210.963 217.148 212.124 215.705 212.359 214.336 212.582 212.615 211.89 211.48 211.23 209.405 210.03 207.503 207.085 207.503 207.085L207.703 205.282C207.703 205.282 208.967 206.773 211.258 208.574 213.553 210.377 215.282 210.267 215.282 210.267 216.789 210.023 217.44 208.637 217.44 207.093L217.433 205.555 218.419 206.809C219.259 207.999 220.696 208.783 222.323 208.783 224.914 208.783 227.013 206.799 227.013 204.345 227.013 203.61 226.881 202.924 226.552 202.313L227.379 200.367 228.922 201.894C228.899 202.079 228.885 202.271 228.885 202.462 228.885 205.033 231.08 207.111 233.792 207.111 236.211 207.111 238.352 205.523 238.667 203.176 238.734 203.208 238.716 201.426 238.887 201.408 239.091 201.386 239.491 203.119 239.559 203.07 240.2 204.934 242.053 206.283 244.239 206.283 246.953 206.283 249.151 204.195 249.151 201.628 249.151 201.052 249.116 200.505 248.914 200.005L250.197 199.777' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M283.957 205.913C284.241 205.08 283.987 204.255 283.387 204.075 282.788 203.887 282.067 204.412 281.783 205.243 281.497 206.074 281.753 206.894 282.353 207.082 282.952 207.263 283.672 206.741 283.957 205.913' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M262.582 201.773C262.693 200.903 262.277 200.144 261.651 200.072 261.025 199.998 260.425 200.64 260.313 201.507 260.2 202.373 260.616 203.137 261.242 203.212 261.869 203.282 262.469 202.64 262.582 201.773' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M237.763 201.773C237.651 200.903 238.071 200.144 238.693 200.072 239.319 199.998 239.919 200.64 240.032 201.507 240.14 202.373 239.728 203.137 239.102 203.212 238.475 203.282 237.875 202.64 237.763 201.773' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M216.391 205.913C216.106 205.08 216.361 204.255 216.961 204.075 217.561 203.887 218.277 204.412 218.562 205.243 218.843 206.074 218.588 206.894 217.992 207.082 217.392 207.263 216.676 206.741 216.391 205.913' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.675 191.65C226.736 192.32 227.662 193.436 227.984 194.683 227.984 194.683 228.108 194.427 228.692 194.089 229.282 193.759 229.78 193.769 229.78 193.769 229.78 193.769 229.612 194.739 229.529 195.087 229.444 195.428 229.436 196.469 229.211 197.406 228.985 198.344 228.577 199.093 228.577 199.093 228.161 198.751 227.591 198.581 227.002 198.677 226.417 198.777 225.945 199.121 225.675 199.575 225.675 199.575 225.018 199.004 224.471 198.198 223.92 197.391 223.545 196.418 223.335 196.123 223.128 195.825 222.622 194.966 222.622 194.966 222.622 194.966 223.088 194.792 223.759 194.916 224.429 195.041 224.64 195.243 224.64 195.243 224.498 193.962 224.922 192.622 225.675 191.65' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M226.125 201.859C225.788 201.592 225.533 201.219 225.45 200.779 225.367 200.342 225.461 199.909 225.683 199.554 225.683 199.554 224.797 199.107 223.848 198.858 223.128 198.67 221.862 198.663 221.479 198.656 221.096 198.645 220.332 198.628 220.332 198.628 220.332 198.628 220.396 198.802 220.613 199.181 220.875 199.639 221.108 199.926 221.108 199.926 219.84 200.218 218.76 201.052 218.078 202.019 219.069 202.703 220.385 203.119 221.677 202.987 221.677 202.987 221.565 203.333 221.483 203.854 221.416 204.284 221.42 204.462 221.42 204.462 221.42 204.462 222.132 204.199 222.488 204.068 222.844 203.936 224.033 203.524 224.644 203.112 225.442 202.566 226.125 201.862 226.125 201.862' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M228.967 201.382C229.188 201.028 229.294 200.594 229.211 200.154 229.128 199.714 228.888 199.341 228.551 199.075 228.551 199.075 229.218 198.368 230.017 197.825 230.625 197.413 231.816 196.997 232.172 196.87 232.529 196.739 233.242 196.472 233.242 196.472 233.242 196.472 233.245 196.653 233.177 197.083 233.096 197.602 232.982 197.946 232.982 197.946 234.277 197.811 235.595 198.244 236.586 198.933 235.904 199.895 234.816 200.715 233.553 201.007 233.553 201.007 233.781 201.294 234.047 201.752 234.265 202.136 234.329 202.306 234.329 202.306 234.329 202.306 233.564 202.289 233.181 202.282 232.799 202.275 231.532 202.271 230.812 202.079 229.864 201.826 228.967 201.386 228.967 201.386' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.199 200.449C225.199 199.312 226.17 198.393 227.366 198.393 228.558 198.393 229.533 199.312 229.533 200.449 229.533 201.582 228.562 202.501 227.366 202.501 226.17 202.501 225.199 201.582 225.199 200.449' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.114 188.365C251.156 189.31 251.959 190.722 252.061 192.175 252.061 192.175 252.248 191.913 252.972 191.65 253.695 191.387 254.25 191.49 254.25 191.49 254.25 191.49 253.864 192.545 253.695 192.913 253.527 193.283 253.309 194.441 252.858 195.439 252.42 196.444 251.809 197.2 251.809 197.2 251.411 196.746 250.812 196.451 250.136 196.451 249.465 196.451 248.866 196.746 248.468 197.2 248.468 197.2 247.857 196.444 247.415 195.439 246.968 194.441 246.747 193.283 246.582 192.913 246.414 192.545 246.023 191.49 246.023 191.49 246.023 191.49 246.582 191.387 247.302 191.65 248.025 191.913 248.217 192.175 248.217 192.175 248.318 190.722 249.076 189.31 250.114 188.365' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.498 199.831C248.176 199.472 247.97 199.007 247.97 198.503 247.97 198.002 248.161 197.534 248.483 197.182 248.483 197.182 247.591 196.514 246.586 196.06 245.825 195.712 244.411 195.471 243.987 195.392 243.56 195.311 242.712 195.151 242.712 195.151 242.712 195.151 242.747 195.353 242.911 195.818 243.11 196.383 243.309 196.746 243.309 196.746 241.84 196.834 240.455 197.565 239.495 198.514 240.455 199.454 241.835 200.168 243.309 200.265 243.309 200.265 243.11 200.623 242.911 201.191 242.747 201.649 242.712 201.855 242.712 201.855 242.712 201.855 243.56 201.699 243.987 201.621 244.411 201.535 245.825 201.298 246.586 200.946 247.591 200.491 248.498 199.835 248.498 199.835' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M251.764 199.831C252.087 199.472 252.292 199.007 252.292 198.503 252.292 198.002 252.102 197.534 251.779 197.182 251.779 197.182 252.672 196.514 253.677 196.06 254.441 195.712 255.854 195.471 256.278 195.392 256.698 195.311 257.545 195.151 257.545 195.151 257.545 195.151 257.516 195.353 257.347 195.818 257.147 196.383 256.953 196.746 256.953 196.746 258.423 196.834 259.806 197.565 260.762 198.514 259.806 199.454 258.426 200.168 256.953 200.265 256.953 200.265 257.147 200.623 257.347 201.191 257.512 201.649 257.545 201.855 257.545 201.855 257.545 201.855 256.702 201.699 256.278 201.621 255.854 201.535 254.441 201.298 253.677 200.946 252.672 200.491 251.764 199.835 251.764 199.835' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.669 191.65C273.612 192.32 272.687 193.436 272.364 194.683 272.364 194.683 272.235 194.427 271.652 194.089 271.067 193.759 270.563 193.769 270.563 193.769 270.563 193.769 270.732 194.739 270.819 195.087 270.906 195.428 270.909 196.469 271.133 197.406 271.359 198.344 271.766 199.093 271.766 199.093 272.187 198.751 272.757 198.581 273.342 198.677 273.926 198.777 274.4 199.121 274.673 199.575 274.673 199.575 275.326 199.004 275.878 198.198 276.424 197.391 276.803 196.418 277.005 196.123 277.212 195.825 277.722 194.966 277.722 194.966 277.722 194.966 277.253 194.792 276.582 194.916 275.911 195.041 275.7 195.243 275.7 195.243 275.85 193.962 275.423 192.622 274.669 191.65' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.223 201.859C274.558 201.592 274.816 201.219 274.894 200.779 274.977 200.342 274.887 199.909 274.666 199.554 274.666 199.554 275.547 199.107 276.495 198.858 277.216 198.67 278.487 198.663 278.864 198.656 279.248 198.645 280.012 198.628 280.012 198.628 280.012 198.628 279.952 198.802 279.732 199.181 279.468 199.639 279.237 199.926 279.237 199.926 280.503 200.218 281.583 201.052 282.266 202.019 281.28 202.703 279.964 203.119 278.667 202.987 278.667 202.987 278.783 203.333 278.862 203.854 278.925 204.284 278.921 204.462 278.921 204.462 278.921 204.462 278.209 204.199 277.857 204.068 277.501 203.936 276.312 203.524 275.7 203.112 274.906 202.566 274.223 201.862 274.223 201.862' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M271.378 201.382C271.156 201.028 271.056 200.594 271.133 200.154 271.217 199.714 271.46 199.341 271.797 199.075 271.797 199.075 271.126 198.368 270.328 197.825 269.72 197.413 268.527 196.997 268.172 196.87 267.815 196.739 267.107 196.472 267.107 196.472 267.107 196.472 267.104 196.653 267.17 197.083 267.25 197.602 267.362 197.946 267.362 197.946 266.068 197.811 264.748 198.244 263.762 198.933 264.445 199.895 265.529 200.715 266.792 201.007 266.792 201.007 266.564 201.294 266.3 201.752 266.08 202.136 266.02 202.306 266.02 202.306 266.02 202.306 266.78 202.289 267.163 202.282 267.542 202.275 268.817 202.271 269.532 202.079 270.478 201.826 271.374 201.386 271.374 201.386' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M270.812 200.449C270.812 199.312 271.782 198.393 272.979 198.393 274.179 198.393 275.15 199.312 275.15 200.449 275.15 201.582 274.179 202.501 272.979 202.501 271.782 202.501 270.812 201.582 270.812 200.449' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M295.052 205.008C294.541 204.469 293.484 204.582 292.694 205.257 291.902 205.928 291.673 206.915 292.183 207.451 292.694 207.991 293.751 207.874 294.541 207.203 295.333 206.525 295.562 205.541 295.052 205.008' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M291.974 206.315C292.083 205.946 292.33 205.569 292.694 205.257 293.484 204.582 294.541 204.469 295.052 205.008 295.115 205.08 295.187 205.175 295.228 205.26 295.228 205.26 296.327 203.176 297.628 202.484 298.93 201.784 301.131 201.961 301.131 201.961 301.131 200.363 299.822 199.072 298.134 199.072 297.144 199.072 296.207 199.483 295.655 200.179L295.428 199.107C295.428 199.107 294.07 199.377 293.447 200.928 292.829 202.484 293.503 204.731 293.503 204.731 293.503 204.731 293.166 203.766 292.657 203.122 292.15 202.484 290.849 201.784 290.171 201.465 289.492 201.149 288.798 200.673 288.798 200.673 288.798 200.673 288.768 200.847 288.742 201.277 288.716 201.791 288.757 202.107 288.757 202.107 287.512 201.944 286.06 202.147 284.929 202.587 285.412 203.538 286.334 204.433 287.542 204.891 287.542 204.891 287.107 205.25 286.709 205.644 286.38 205.978 286.275 206.134 286.275 206.134 286.275 206.134 287.126 206.255 287.554 206.315 287.976 206.372 289.39 206.595 290.234 206.539 290.856 206.499 291.554 206.397 291.974 206.315' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M208.371 206.315C208.263 205.946 208.017 205.569 207.651 205.257 206.86 204.582 205.806 204.469 205.292 205.008 205.225 205.08 205.157 205.175 205.116 205.26 205.116 205.26 204.013 203.176 202.713 202.484 201.416 201.784 199.215 201.961 199.215 201.961 199.215 200.363 200.524 199.072 202.21 199.072 203.204 199.072 204.134 199.483 204.692 200.179L204.918 199.107C204.918 199.107 206.275 199.377 206.897 200.928 207.518 202.484 206.841 204.731 206.841 204.731 206.841 204.731 207.178 203.766 207.689 203.122 208.198 202.484 209.499 201.784 210.177 201.465 210.853 201.149 211.55 200.673 211.55 200.673 211.55 200.673 211.576 200.847 211.603 201.277 211.63 201.791 211.588 202.107 211.588 202.107 212.829 201.944 214.284 202.147 215.417 202.587 214.932 203.538 214.013 204.433 212.803 204.891 212.803 204.891 213.238 205.25 213.634 205.644 213.966 205.978 214.073 206.134 214.073 206.134 214.073 206.134 213.218 206.255 212.796 206.315 212.367 206.372 210.958 206.595 210.114 206.539 209.492 206.499 208.794 206.397 208.371 206.315' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M205.292 205.008C205.806 204.469 206.86 204.582 207.651 205.257 208.446 205.928 208.67 206.915 208.161 207.451 207.651 207.991 206.593 207.874 205.803 207.203 205.011 206.525 204.783 205.541 205.292 205.008' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M247.97 198.503C247.97 197.367 248.94 196.451 250.136 196.451 251.333 196.451 252.307 197.367 252.307 198.503 252.307 199.639 251.337 200.559 250.136 200.559 248.94 200.559 247.97 199.639 247.97 198.503' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M245.625 167.301C245.625 164.978 247.61 163.103 250.054 163.103 252.499 163.103 254.482 164.978 254.482 167.301 254.482 169.616 252.499 171.491 250.054 171.491 247.61 171.491 245.625 169.616 245.625 167.301' fill='%23005bbf' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M248.894 155.537L248.894 157.802 246.471 157.802 246.471 160.099 248.894 160.099 248.894 163.246 248.894 166.707 245.842 166.707C245.806 166.923 245.622 167.08 245.622 167.305 245.622 167.884 245.743 168.44 245.968 168.941 245.974 168.955 245.993 168.959 245.999 168.973L254.117 168.973C254.123 168.959 254.143 168.955 254.149 168.941 254.373 168.44 254.495 167.884 254.495 167.305 254.495 167.081 254.31 166.922 254.275 166.707L251.317 166.707 251.317 163.277 251.317 160.099 253.74 160.099 253.74 157.802 251.317 157.802 251.317 155.537 248.894 155.537z' fill='%23c8b100' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M250.493 344.333C237.411 344.333 224.445 341.127 213.545 335.793 205.51 331.813 200.182 323.788 200.182 314.605L200.182 281.304 300.605 281.304 300.605 314.605C300.605 323.788 295.278 331.813 287.241 335.793 276.342 341.127 263.578 344.333 250.493 344.333' fill='%23cccccc'/%3E %3Cpath d='M250.493 344.333C237.411 344.333 224.445 341.127 213.545 335.793 205.51 331.813 200.182 323.788 200.182 314.605L200.182 281.304 300.605 281.304 300.605 314.605C300.605 323.788 295.278 331.813 287.241 335.793 276.342 341.127 263.578 344.333 250.493 344.333z' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.279 281.247L300.601 281.247 300.601 225.533 250.279 225.533 250.279 281.247z' fill='%23cccccc'/%3E %3Cpath d='M250.279 281.247L300.601 281.247 300.601 225.533 250.279 225.533 250.279 281.247z' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.317 314.566C250.317 327.726 239.165 338.393 225.274 338.393 211.378 338.393 200.115 327.726 200.115 314.566L200.115 281.215 250.317 281.215 250.317 314.566' fill='%23ad1519'/%3E %3Cpath d='M211.082 334.229C212.651 335.062 214.805 336.448 217.107 337.003L216.961 280.04 211.082 280.04 211.082 334.229z' fill='%23c8b100' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M200.032 314.117C200.185 321.145 202.975 326.369 205.765 329.791L205.765 280.317 200.103 280.317 200.032 314.117z' fill='%23c8b100' stroke='%23000' stroke-linejoin='round' stroke-width='0.5'/%3E %3Cpath d='M222.275 338.252C224.575 338.483 226.291 338.437 228.154 338.252L228.154 280.04 222.275 280.04 222.275 338.252z' fill='%23c7b500' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M233.323 337.003C235.625 336.541 238.22 335.108 239.349 334.368L239.349 280.04 233.47 280.04 233.323 337.003z' fill='%23c8b100' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M200.118 281.247L250.297 281.247 250.297 225.533 200.118 225.533 200.118 281.247z' fill='%23ad1519'/%3E %3Cpath d='M200.118 281.247L250.297 281.247 250.297 225.533 200.118 225.533 200.118 281.247z' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M244.813 329.236C247.261 327.063 249.562 322.115 250.399 316.475L250.545 280.04 244.666 280.04 244.813 329.236z' fill='%23c8b100' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.317 314.566C250.317 327.726 239.165 338.393 225.274 338.393 211.378 338.393 200.115 327.726 200.115 314.566L200.115 281.215 250.317 281.215 250.317 314.566' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M300.65 281.215L300.65 314.566C300.65 327.726 289.372 338.393 275.476 338.393 261.584 338.393 250.317 327.726 250.317 314.566L250.317 281.215 300.65 281.215' fill='%23ad1519'/%3E %3Cpath d='M300.65 281.215L300.65 314.566C300.65 327.726 289.372 338.393 275.476 338.393 261.584 338.393 250.317 327.726 250.317 314.566L250.317 281.215 300.65 281.215' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M259.472 306.388C259.552 306.558 259.597 306.729 259.597 306.91 259.597 307.524 259.076 308.014 258.426 308.014 257.781 308.014 257.257 307.524 257.257 306.91 257.257 306.729 257.302 306.558 257.384 306.409L255.75 306.388C255.716 306.555 255.696 306.729 255.696 306.91 255.696 308.067 256.496 309.048 257.6 309.378L257.598 313.391 259.312 313.401 259.315 309.36C260.111 309.101 260.737 308.504 261.011 307.744L265.614 307.744 265.614 306.388 259.472 306.388M282.052 306.388L282.052 307.744 277.913 307.755C277.849 307.936 277.746 308.103 277.647 308.262L282.454 313.724 281.164 314.768 276.38 309.3C276.292 309.328 276.248 309.363 276.155 309.388L276.143 318.425 274.449 318.425 274.445 309.349C274.373 309.332 274.313 309.296 274.246 309.264L269.266 314.768 267.976 313.724 272.953 308.199C272.866 308.06 272.803 307.908 272.746 307.744L268.468 307.744 268.468 306.388 282.056 306.388 282.052 306.388zM284.809 306.388L284.809 307.744 289.416 307.744C289.69 308.504 290.309 309.101 291.111 309.36L291.114 313.401 292.825 313.391 292.821 309.378C293.927 309.048 294.73 308.067 294.73 306.91 294.73 306.729 294.711 306.555 294.669 306.388L293.042 306.388C293.121 306.558 293.162 306.729 293.162 306.91 293.162 307.524 292.645 308.014 291.996 308.014 291.352 308.014 290.826 307.524 290.826 306.91 290.826 306.729 290.871 306.558 290.954 306.409L284.809 306.388M277.852 329.429C279.195 329.217 280.433 328.847 281.655 328.333L282.495 329.764C281.089 330.367 279.574 330.801 277.995 331.038 277.732 332.206 276.642 333.083 275.33 333.083 274.021 333.083 272.929 332.217 272.659 331.057 270.991 330.829 269.409 330.399 267.928 329.764L268.772 328.333C270.058 328.876 271.43 329.238 272.854 329.436 273.155 328.784 273.706 328.28 274.43 328.045L274.445 321.039 276.135 321.039 276.151 328.02C276.901 328.244 277.534 328.755 277.849 329.429L277.852 329.429zM266.359 327.079L265.525 328.517C264.095 327.629 262.821 326.533 261.727 325.303 260.857 325.559 259.874 325.407 259.132 324.803 257.984 323.872 257.845 322.239 258.828 321.156L258.971 321.004C258.279 319.441 257.811 317.761 257.651 316L259.361 316.007C259.495 317.51 259.87 318.941 260.454 320.283 260.935 320.215 261.449 320.272 261.91 320.443L266.188 315.709 267.477 316.75 263.226 321.476C263.8 322.349 263.777 323.475 263.121 324.334 264.065 325.379 265.149 326.309 266.359 327.079zM260.016 322.115C260.437 321.646 261.175 321.593 261.666 321.99 262.158 322.388 262.218 323.091 261.798 323.553 261.376 324.018 260.639 324.075 260.148 323.677 259.657 323.276 259.597 322.58 260.016 322.115zM257.86 317.434L256.102 317.041 255.854 312.588 257.598 312.012 257.6 314.566C257.6 315.556 257.688 316.494 257.86 317.434zM259.319 311.913L261.07 312.325C261.07 312.325 261.16 315.187 261.123 314.544 261.077 313.795 261.314 316.782 261.314 316.782L259.548 317.364C259.372 316.455 259.312 315.524 259.312 314.566L259.315 311.913 259.319 311.913zM265.092 326.159C266.567 327.31 268.281 328.244 270.133 328.836L270.523 327.143C269.001 326.663 267.59 325.961 266.349 325.048L265.092 326.159M264.245 327.622C265.741 328.748 267.452 329.65 269.285 330.275L267.976 331.5C266.506 330.957 265.124 330.24 263.856 329.387L264.245 327.622M266.53 317.808L268.202 318.518 271.261 315.123 270.256 313.678 266.53 317.808M265.233 316.76L264.23 315.308 267.291 311.913 268.958 312.626 265.233 316.76M284.066 327.079L284.902 328.517C286.33 327.629 287.606 326.533 288.7 325.303 289.566 325.559 290.553 325.407 291.294 324.803 292.442 323.872 292.574 322.239 291.597 321.156L291.452 321.004C292.146 319.441 292.615 317.761 292.768 316L291.067 316.007C290.932 317.51 290.553 318.941 289.971 320.283 289.488 320.215 288.978 320.272 288.513 320.443L284.239 315.709 282.949 316.75 287.197 321.476C286.627 322.349 286.649 323.475 287.302 324.334 286.36 325.379 285.277 326.309 284.066 327.079zM290.406 322.115C289.986 321.646 289.251 321.593 288.761 321.99 288.268 322.388 288.209 323.091 288.629 323.553 289.049 324.018 289.788 324.075 290.279 323.677 290.771 323.276 290.826 322.58 290.406 322.115zM292.563 317.434L294.321 317.041 294.569 312.588 292.829 312.012 292.825 314.566C292.825 315.556 292.738 316.494 292.563 317.434zM291.108 311.913L289.357 312.325C289.357 312.325 289.262 315.187 289.301 314.544 289.349 313.795 289.109 316.782 289.109 316.782L290.875 317.364C291.052 316.455 291.111 315.524 291.111 314.566L291.108 311.913M285.333 326.159C283.856 327.31 282.142 328.244 280.294 328.836L279.904 327.143C281.423 326.663 282.836 325.961 284.074 325.048L285.333 326.159M286.181 327.622C284.68 328.748 282.975 329.65 281.141 330.275L282.45 331.5C283.92 330.957 285.303 330.24 286.571 329.387L286.181 327.622M283.897 317.808L282.225 318.518 279.165 315.123 280.17 313.678 283.897 317.808M285.193 316.76L286.196 315.308 283.136 311.913 281.468 312.626 285.193 316.76M264.25 307.748L264.764 309.416 269.477 309.416 269.985 307.748 264.25 307.748M286.266 307.748L285.749 309.416 281.039 309.416 280.531 307.748 286.266 307.748M274.16 330.495C274.16 329.88 274.684 329.384 275.33 329.384 275.974 329.384 276.495 329.88 276.495 330.495 276.495 331.106 275.974 331.599 275.33 331.599 274.684 331.599 274.16 331.106 274.16 330.495zM276.143 322.42L277.902 321.927 277.902 317.47 276.143 316.987 276.143 322.42M274.438 322.42L272.683 321.927 272.683 317.47 274.438 316.987 274.438 322.42' fill='%23c8b100'/%3E %3Cpath d='M255.75 306.427C255.952 305.498 256.678 304.744 257.614 304.462L257.6 298.96 259.297 298.96 259.3 304.492C260.137 304.755 260.781 305.374 261.04 306.171L265.614 306.178 265.614 306.427 259.472 306.427C259.282 306.089 258.883 305.837 258.426 305.837 257.973 305.837 257.575 306.089 257.384 306.448L255.75 306.427M268.464 306.427L268.464 306.178 272.713 306.178C272.761 306.039 272.824 305.904 272.896 305.776L267.654 299.934 268.943 298.888 274.119 304.635C274.208 304.591 274.303 304.552 274.395 304.52L274.4 296.864 276.094 296.864 276.094 304.473C276.17 304.495 276.285 304.516 276.361 304.538L281.416 298.782 282.715 299.813 277.64 305.545C277.771 305.737 277.86 305.951 277.932 306.178L282.049 306.178 282.049 306.427 268.46 306.427 268.464 306.427zM290.954 306.427C291.144 306.089 291.539 305.837 291.996 305.837 292.454 305.837 292.848 306.089 293.042 306.448L294.669 306.427C294.466 305.498 293.747 304.744 292.81 304.462L292.821 298.963 291.129 298.963 291.122 304.495C290.29 304.758 289.645 305.374 289.386 306.171L284.809 306.178 284.809 306.427 290.954 306.427M259.571 290.887L265.876 297.956 267.167 296.91 260.827 289.869C260.953 289.68 261.043 289.475 261.119 289.253L265.731 289.253 265.731 287.645 261.116 287.645C260.762 286.603 259.728 285.856 258.51 285.856 257.002 285.856 255.776 287.016 255.776 288.447 255.776 289.581 256.543 290.549 257.616 290.898L257.606 296.352 259.3 296.352 259.3 290.934C259.372 290.913 259.502 290.913 259.571 290.887zM292.84 290.923L292.825 296.352 291.129 296.352 291.129 290.902C290.999 290.861 290.871 290.808 290.75 290.747L284.479 297.825 283.182 296.793 289.573 289.577C289.521 289.475 289.465 289.368 289.427 289.253L284.79 289.253 284.79 287.645 289.413 287.645C289.769 286.603 290.793 285.856 292.007 285.856 293.514 285.856 294.741 287.016 294.741 288.447 294.741 289.61 293.949 290.591 292.84 290.923zM276.113 290.902L276.098 294.245 274.404 294.245 274.408 290.93C273.564 290.68 272.899 290.055 272.622 289.253L268.486 289.253 268.486 287.645 272.622 287.645C272.979 286.603 273.998 285.856 275.213 285.856 276.428 285.856 277.455 286.603 277.812 287.645L282.03 287.645 282.03 289.253 277.801 289.253C277.534 290.026 276.92 290.642 276.113 290.902zM257.621 294.96L255.863 295.455 255.863 299.924 257.621 300.408 257.621 294.96M259.327 294.96L261.081 295.455 261.081 299.924 259.327 300.408 259.327 294.96M291.114 294.96L289.36 295.455 289.36 299.924 291.114 300.408 291.114 294.96M292.821 294.96L294.58 295.455 294.58 299.924 292.821 300.408 292.821 294.96M266.209 295.842L267.883 295.132 270.943 298.533 269.938 299.984 266.209 295.842M264.914 296.896L263.913 298.352 266.972 301.749 268.64 301.034 264.914 296.896M284.126 295.711L282.45 295.014 279.42 298.44 280.436 299.881 284.126 295.711M285.431 296.754L286.446 298.198 283.417 301.624 281.745 300.923 285.431 296.754M264.25 306.175L264.764 304.506 269.477 304.506 269.985 306.175 264.25 306.175M257.34 288.45C257.34 287.839 257.864 287.34 258.51 287.34 259.154 287.34 259.676 287.839 259.676 288.45 259.676 289.062 259.154 289.556 258.51 289.556 257.864 289.556 257.34 289.062 257.34 288.45zM269.945 289.257L269.428 290.93 264.718 290.93 264.209 289.257 269.945 289.257M269.945 287.638L269.428 285.97 264.718 285.97 264.209 287.638 269.945 287.638M286.266 306.175L285.749 304.506 281.039 304.506 280.531 306.175 286.266 306.175M290.838 288.45C290.838 287.839 291.359 287.34 292.007 287.34 292.653 287.34 293.174 287.839 293.174 288.45 293.174 289.062 292.653 289.556 292.007 289.556 291.359 289.556 290.838 289.062 290.838 288.45zM274.044 288.45C274.044 287.839 274.569 287.34 275.213 287.34 275.859 287.34 276.38 287.839 276.38 288.45 276.38 289.062 275.859 289.556 275.213 289.556 274.569 289.556 274.044 289.062 274.044 288.45zM280.571 289.257L281.089 290.93 285.798 290.93 286.308 289.257 280.571 289.257M280.571 287.638L281.089 285.97 285.798 285.97 286.308 287.638 280.571 287.638M274.419 292.858L272.664 293.352 272.664 297.821 274.419 298.305 274.419 292.858M276.106 292.858L277.86 293.352 277.86 297.821 276.106 298.305 276.106 292.858' fill='%23c8b100'/%3E %3Cpath d='M277.852 329.429C279.195 329.217 280.433 328.847 281.655 328.333L282.495 329.764C281.089 330.367 279.574 330.801 277.995 331.038 277.732 332.206 276.642 333.083 275.33 333.083 274.021 333.083 272.929 332.217 272.659 331.057 270.991 330.829 269.409 330.399 267.928 329.764L268.772 328.333C270.058 328.876 271.43 329.238 272.854 329.436 273.155 328.784 273.706 328.28 274.43 328.045L274.445 321.039 276.135 321.039 276.151 328.02C276.901 328.244 277.534 328.755 277.849 329.429L277.852 329.429zM272.949 308.202C272.863 308.06 272.799 307.908 272.742 307.744L268.464 307.744 268.464 306.139 272.713 306.139C272.761 306.004 272.829 305.869 272.899 305.741L267.654 299.907 268.943 298.863 274.123 304.598C274.212 304.555 274.303 304.517 274.4 304.485L274.404 296.843 276.094 296.843 276.094 304.438C276.17 304.459 276.285 304.481 276.361 304.506L281.416 298.756 282.715 299.79 277.64 305.508C277.771 305.699 277.86 305.912 277.932 306.139L282.049 306.139 282.049 307.744 277.909 307.755C277.849 307.936 277.744 308.103 277.647 308.262L282.454 313.728 281.164 314.772 276.38 309.3C276.292 309.332 276.248 309.367 276.151 309.392L276.139 318.429 274.445 318.429 274.44 309.353C274.369 309.332 274.31 309.296 274.242 309.264L269.262 314.772 267.974 313.728 272.949 308.202M259.571 290.877L265.876 297.933 267.167 296.889 260.827 289.861C260.953 289.673 261.043 289.468 261.119 289.247L265.731 289.247 265.731 287.642 261.116 287.642C260.762 286.602 259.728 285.856 258.51 285.856 257.002 285.856 255.776 287.014 255.776 288.442 255.776 289.574 256.543 290.54 257.616 290.887L257.606 296.332 259.3 296.332 259.3 290.924C259.372 290.903 259.502 290.903 259.571 290.877zM266.359 327.079L265.525 328.517C264.095 327.629 262.821 326.533 261.727 325.303 260.857 325.559 259.874 325.407 259.132 324.803 257.984 323.872 257.845 322.239 258.828 321.156L258.971 321.004C258.279 319.441 257.811 317.761 257.651 316L259.361 316.007C259.495 317.51 259.87 318.941 260.454 320.283 260.935 320.215 261.449 320.272 261.91 320.443L266.188 315.709 267.477 316.75 263.226 321.476C263.8 322.349 263.777 323.475 263.121 324.334 264.065 325.379 265.149 326.309 266.359 327.079zM257.598 313.391L257.6 309.378C256.496 309.051 255.693 308.067 255.693 306.91 255.693 305.755 256.507 304.761 257.614 304.427L257.6 298.938 259.297 298.938 259.3 304.459C260.137 304.722 260.781 305.336 261.04 306.132L265.614 306.139 265.614 307.744 261.011 307.744C260.737 308.504 260.111 309.101 259.315 309.36L259.312 313.401 257.598 313.391M260.016 322.115C260.437 321.646 261.175 321.593 261.666 321.99 262.158 322.388 262.218 323.091 261.798 323.553 261.376 324.018 260.639 324.075 260.148 323.677 259.657 323.276 259.597 322.58 260.016 322.115zM257.86 317.434L256.102 317.041 255.854 312.588 257.598 312.012 257.6 314.566C257.6 315.556 257.688 316.494 257.86 317.434zM259.319 311.913L261.07 312.325C261.07 312.325 261.16 315.187 261.123 314.544 261.077 313.795 261.314 316.782 261.314 316.782L259.548 317.364C259.372 316.455 259.312 315.524 259.312 314.566L259.315 311.913 259.319 311.913zM265.092 326.159C266.567 327.31 268.281 328.244 270.133 328.836L270.523 327.143C269.001 326.663 267.59 325.961 266.349 325.048L265.092 326.159M264.245 327.622C265.741 328.748 267.452 329.65 269.285 330.275L267.976 331.5C266.506 330.957 265.124 330.24 263.856 329.387L264.245 327.622' fill='none' stroke='%23c8b100' stroke-width='0.26'/%3E %3Cpath d='M266.53 317.808L268.202 318.518 271.261 315.123 270.256 313.678 266.53 317.808M265.233 316.76L264.23 315.308 267.291 311.913 268.958 312.626 265.233 316.76M257.257 306.91C257.257 306.295 257.781 305.799 258.426 305.799 259.072 305.799 259.593 306.295 259.593 306.91 259.593 307.524 259.072 308.014 258.426 308.014 257.781 308.014 257.257 307.524 257.257 306.91zM284.066 327.079L284.902 328.517C286.33 327.629 287.606 326.533 288.7 325.303 289.566 325.559 290.553 325.407 291.294 324.803 292.442 323.872 292.574 322.239 291.597 321.156L291.452 321.004C292.146 319.441 292.615 317.761 292.768 316L291.067 316.007C290.932 317.51 290.553 318.941 289.971 320.283 289.488 320.215 288.978 320.272 288.513 320.443L284.239 315.709 282.949 316.75 287.197 321.476C286.627 322.349 286.649 323.475 287.302 324.334 286.36 325.379 285.277 326.309 284.066 327.079zM292.829 313.391L292.825 309.378C293.931 309.051 294.733 308.067 294.733 306.91 294.733 305.755 293.92 304.761 292.814 304.427L292.825 298.938 291.129 298.938 291.122 304.459C290.29 304.722 289.645 305.336 289.386 306.132L284.809 306.139 284.809 307.744 289.416 307.744C289.69 308.504 290.309 309.101 291.111 309.36L291.114 313.401 292.825 313.391 292.829 313.391zM290.406 322.115C289.986 321.646 289.251 321.593 288.761 321.99 288.268 322.388 288.209 323.091 288.629 323.553 289.049 324.018 289.788 324.075 290.279 323.677 290.771 323.276 290.826 322.58 290.406 322.115zM292.563 317.434L294.321 317.041 294.569 312.588 292.829 312.012 292.825 314.566C292.825 315.556 292.738 316.494 292.563 317.434zM291.108 311.913L289.357 312.325C289.357 312.325 289.262 315.187 289.301 314.544 289.349 313.795 289.109 316.782 289.109 316.782L290.875 317.364C291.052 316.455 291.111 315.524 291.111 314.566L291.108 311.913M292.84 290.913L292.825 296.332 291.129 296.332 291.129 290.891C290.999 290.852 290.871 290.799 290.75 290.738L284.479 297.802 283.182 296.772 289.573 289.57C289.521 289.468 289.465 289.361 289.427 289.247L284.79 289.247 284.79 287.642 289.413 287.642C289.769 286.602 290.793 285.856 292.007 285.856 293.514 285.856 294.741 287.014 294.741 288.442 294.741 289.603 293.949 290.582 292.84 290.913zM276.113 290.891L276.098 294.229 274.404 294.229 274.408 290.92C273.564 290.671 272.899 290.047 272.622 289.247L268.486 289.247 268.486 287.642 272.622 287.642C272.979 286.602 273.998 285.856 275.213 285.856 276.428 285.856 277.455 286.602 277.812 287.642L282.03 287.642 282.03 289.247 277.801 289.247C277.534 290.017 276.92 290.633 276.113 290.891zM285.333 326.159C283.856 327.31 282.142 328.244 280.294 328.836L279.904 327.143C281.423 326.663 282.836 325.961 284.074 325.048L285.333 326.159M286.181 327.622C284.68 328.748 282.975 329.65 281.141 330.275L282.45 331.5C283.92 330.957 285.303 330.24 286.571 329.387L286.181 327.622M257.621 294.943L255.863 295.437 255.863 299.897 257.621 300.379 257.621 294.943M259.327 294.943L261.081 295.437 261.081 299.897 259.327 300.379 259.327 294.943M291.114 294.943L289.36 295.437 289.36 299.897 291.114 300.379 291.114 294.943' fill='none' stroke='%23c8b100' stroke-width='0.26'/%3E %3Cpath d='M292.821 294.943L294.58 295.437 294.58 299.897 292.821 300.379 292.821 294.943M283.897 317.808L282.225 318.518 279.165 315.123 280.17 313.678 283.897 317.808M285.193 316.76L286.196 315.308 283.136 311.913 281.468 312.626 285.193 316.76M266.209 295.823L267.883 295.113 270.943 298.509 269.938 299.957 266.209 295.823M264.914 296.874L263.913 298.327 266.972 301.719 268.64 301.005 264.914 296.874M284.126 295.692L282.45 294.997 279.42 298.416 280.436 299.854 284.126 295.692M285.431 296.732L286.446 298.174 283.417 301.594 281.745 300.894 285.431 296.732M264.25 306.136L264.764 304.47 269.477 304.47 269.985 306.136 264.25 306.136M264.25 307.748L264.764 309.416 269.477 309.416 269.985 307.748 264.25 307.748M257.34 288.445C257.34 287.835 257.864 287.337 258.51 287.337 259.154 287.337 259.676 287.835 259.676 288.445 259.676 289.056 259.154 289.549 258.51 289.549 257.864 289.549 257.34 289.056 257.34 288.445zM269.945 289.251L269.428 290.92 264.718 290.92 264.209 289.251 269.945 289.251M269.945 287.635L269.428 285.97 264.718 285.97 264.209 287.635 269.945 287.635M290.826 306.91C290.826 306.295 291.352 305.799 291.996 305.799 292.645 305.799 293.162 306.295 293.162 306.91 293.162 307.524 292.645 308.014 291.996 308.014 291.352 308.014 290.826 307.524 290.826 306.91zM286.266 306.136L285.749 304.47 281.039 304.47 280.531 306.136 286.266 306.136M286.266 307.748L285.749 309.416 281.039 309.416 280.531 307.748 286.266 307.748M274.16 330.495C274.16 329.88 274.684 329.384 275.33 329.384 275.974 329.384 276.495 329.88 276.495 330.495 276.495 331.106 275.974 331.599 275.33 331.599 274.684 331.599 274.16 331.106 274.16 330.495zM276.143 322.42L277.902 321.927 277.902 317.47 276.143 316.987 276.143 322.42M274.438 322.42L272.683 321.927 272.683 317.47 274.438 316.987 274.438 322.42M290.838 288.445C290.838 287.835 291.359 287.337 292.007 287.337 292.653 287.337 293.174 287.835 293.174 288.445 293.174 289.056 292.653 289.549 292.007 289.549 291.359 289.549 290.838 289.056 290.838 288.445zM274.044 288.445C274.044 287.835 274.569 287.337 275.213 287.337 275.859 287.337 276.38 287.835 276.38 288.445 276.38 289.056 275.859 289.549 275.213 289.549 274.569 289.549 274.044 289.056 274.044 288.445zM280.571 289.251L281.089 290.92 285.798 290.92 286.308 289.251 280.571 289.251M280.571 287.635L281.089 285.97 285.798 285.97 286.308 287.635 280.571 287.635' fill='none' stroke='%23c8b100' stroke-width='0.26'/%3E %3Cpath d='M274.419 292.845L272.664 293.338 272.664 297.798 274.419 298.281 274.419 292.845M276.106 292.845L277.86 293.338 277.86 297.798 276.106 298.281 276.106 292.845' fill='none' stroke='%23c8b100' stroke-width='0.26'/%3E %3Cpath d='M272.592 306.938C272.592 305.504 273.819 304.343 275.33 304.343 276.837 304.343 278.063 305.504 278.063 306.938 278.063 308.366 276.837 309.523 275.33 309.523 273.819 309.523 272.592 308.366 272.592 306.938' fill='%23058e6e'/%3E %3Cpath d='M275.929 239.261L275.985 238.643 276.071 238.298C276.071 238.298 274.46 238.43 273.612 238.192 272.764 237.951 272 237.602 271.208 236.935 270.418 236.263 270.106 235.844 269.54 235.76 268.183 235.543 267.137 236.158 267.137 236.158 267.137 236.158 268.157 236.533 268.922 237.468 269.682 238.409 270.512 238.884 270.871 238.998 271.464 239.179 273.527 239.051 274.092 239.073 274.658 239.101 275.929 239.264 275.929 239.264' fill='%23db4446'/%3E %3Cpath d='M275.929 239.261L275.985 238.643 276.071 238.298C276.071 238.298 274.46 238.43 273.612 238.192 272.764 237.951 272 237.602 271.208 236.935 270.418 236.263 270.106 235.844 269.54 235.76 268.183 235.543 267.137 236.158 267.137 236.158 267.137 236.158 268.157 236.533 268.922 237.468 269.682 238.409 270.512 238.884 270.871 238.998 271.464 239.179 273.527 239.051 274.092 239.073 274.658 239.101 275.929 239.264 275.929 239.264L275.929 239.261z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M283.463 236.995C283.463 236.995 283.467 237.716 283.537 238.405 283.605 239.066 283.324 239.644 283.432 240.01 283.537 240.38 283.589 240.671 283.732 240.936 283.867 241.203 283.942 241.878 283.942 241.878 283.942 241.878 283.556 241.604 283.199 241.338 282.847 241.068 282.595 240.901 282.595 240.901 282.595 240.901 282.667 241.622 282.7 241.931 282.739 242.24 282.919 242.822 283.211 243.167 283.5 243.504 284.078 244.058 284.256 244.502 284.441 244.95 284.404 245.937 284.404 245.937 284.404 245.937 283.935 245.187 283.532 245.053 283.136 244.914 282.266 244.431 282.266 244.431 282.266 244.431 283.064 245.223 283.064 245.976 283.064 246.728 282.739 247.584 282.739 247.584 282.739 247.584 282.378 246.902 281.91 246.455 281.438 246.011 280.785 245.564 280.785 245.564 280.785 245.564 281.295 246.728 281.295 247.513 281.295 248.305 281.153 249.984 281.153 249.984 281.153 249.984 280.755 249.335 280.357 249.019 279.957 248.714 279.488 248.44 279.341 248.237 279.199 248.032 279.815 248.884 279.881 249.398 279.952 249.914 280.196 251.749 281.801 254.093 282.739 255.464 284.19 257.86 287.298 257.072 290.41 256.287 289.255 252.105 288.603 250.151 287.95 248.202 287.624 246.039 287.662 245.283 287.696 244.534 288.239 242.308 288.168 241.892 288.096 241.484 287.927 239.893 288.314 238.611 288.712 237.276 289.042 236.758 289.255 236.207 289.468 235.66 289.648 235.351 289.72 234.872 289.792 234.393 289.792 233.497 289.792 233.497 289.792 233.497 290.369 234.563 290.515 234.939 290.658 235.319 290.658 236.445 290.658 236.445 290.658 236.445 290.766 235.319 291.637 234.772 292.507 234.218 293.518 233.639 293.772 233.33 294.025 233.018 294.099 232.816 294.099 232.816 294.099 232.816 294.025 234.737 293.484 235.493 293.125 235.983 291.708 237.581 291.708 237.581 291.708 237.581 292.435 237.304 292.94 237.276 293.447 237.237 293.807 237.276 293.807 237.276 293.807 237.276 293.192 237.756 292.397 238.92 291.602 240.081 291.926 240.184 291.348 241.143 290.766 242.101 290.297 242.137 289.573 242.72 288.486 243.593 289.072 247.065 289.214 247.581 289.36 248.092 291.239 252.345 291.276 253.372 291.309 254.402 291.494 256.696 289.682 258.169 288.516 259.125 286.608 259.132 286.173 259.405 285.737 259.675 284.875 260.531 284.875 262.314 284.875 264.1 285.521 264.37 286.027 264.817 286.537 265.264 287.186 265.023 287.331 265.368 287.478 265.708 287.549 265.914 287.767 266.12 287.985 266.322 288.131 266.564 288.056 266.936 287.985 267.317 287.152 268.173 286.863 268.794 286.571 269.404 285.993 271.02 285.993 271.258 285.993 271.5 285.925 272.253 286.173 272.632 286.173 272.632 287.077 273.688 286.461 273.893 286.064 274.028 285.675 273.644 285.487 273.688 284.947 273.83 284.665 274.163 284.509 274.135 284.148 274.067 284.148 273.89 284.111 273.382 284.078 272.87 284.096 272.661 283.935 272.661 283.717 272.661 283.608 272.839 283.571 273.109 283.532 273.382 283.532 273.996 283.282 273.996 283.028 273.996 282.667 273.552 282.45 273.453 282.232 273.349 281.618 273.247 281.583 272.974 281.546 272.7 281.944 272.118 282.341 272.014 282.739 271.911 283.102 271.709 282.847 271.504 282.593 271.297 282.341 271.297 282.09 271.504 281.835 271.709 281.295 271.535 281.329 271.227 281.366 270.918 281.438 270.544 281.399 270.371 281.366 270.204 280.931 269.859 281.505 269.546 282.086 269.241 282.337 269.824 282.915 269.72 283.496 269.622 283.785 269.408 284.002 269.071 284.22 268.73 284.182 268.009 283.785 267.566 283.387 267.118 282.99 267.047 282.843 266.773 282.697 266.5 282.484 265.85 282.484 265.85 282.484 265.85 282.589 267.047 282.517 267.221 282.447 267.392 282.484 268.108 282.484 268.108 282.484 268.108 282.086 267.664 281.76 267.324 281.438 266.98 281.111 265.954 281.111 265.954 281.111 265.954 281.077 266.912 281.077 267.292 281.077 267.664 281.508 268.009 281.366 268.148 281.22 268.283 280.535 267.427 280.354 267.292 280.17 267.154 279.593 266.71 279.338 266.227 279.087 265.747 278.902 265.066 278.832 264.821 278.759 264.582 278.641 263.514 278.759 263.244 278.94 262.835 279.23 262.114 279.23 262.114 279.23 262.114 278.58 262.114 277.819 262.114 277.062 262.114 276.518 261.877 276.229 262.388 275.941 262.903 276.083 263.933 276.444 265.268 276.807 266.599 277.02 267.253 276.916 267.494 276.81 267.732 276.339 268.283 276.159 268.382 275.974 268.489 275.468 268.453 275.25 268.354 275.037 268.25 274.677 268.076 273.987 268.076 273.301 268.076 272.866 268.108 272.615 268.048 272.361 267.978 271.745 267.668 271.452 267.736 271.163 267.806 270.664 268.062 270.8 268.457 271.021 269.074 270.586 269.213 270.294 269.178 270.005 269.142 269.758 269.039 269.39 268.939 269.031 268.833 268.486 268.939 268.559 268.524 268.629 268.112 268.776 268.08 268.955 267.775 269.138 267.462 269.206 267.264 269.003 267.242 268.749 267.217 268.494 267.189 268.296 267.352 268.104 267.512 267.793 267.857 267.538 267.729 267.282 267.594 267.084 267.299 267.084 266.652 267.084 266.01 266.405 265.449 267.028 265.477 267.65 265.506 268.442 265.961 268.584 265.612 268.723 265.261 268.637 265.105 268.3 264.831 267.96 264.565 267.538 264.405 267.991 264.057 268.442 263.712 268.554 263.712 268.727 263.521 268.896 263.336 269.138 262.733 269.455 262.882 270.076 263.177 269.484 263.606 270.106 264.298 270.729 264.994 271.123 265.24 272.169 265.129 273.214 265.023 273.5 264.888 273.5 264.593 273.5 264.298 273.413 263.766 273.383 263.549 273.357 263.336 273.527 262.558 273.527 262.558 273.527 262.558 273.046 262.856 272.904 263.147 272.768 263.442 272.483 263.947 272.483 263.947 272.483 263.947 272.368 263.347 272.401 262.856 272.42 262.569 272.522 262.068 272.511 261.969 272.483 261.703 272.285 261.032 272.285 261.032 272.285 261.032 272.115 261.756 272.004 261.969 271.891 262.182 271.835 263.042 271.835 263.042 271.835 263.042 271.171 262.463 271.356 261.49 271.494 260.74 271.242 259.75 271.467 259.427 271.689 259.104 272.225 257.793 273.527 257.736 274.827 257.687 275.843 257.793 276.298 257.769 276.75 257.736 278.36 257.445 278.36 257.445 278.36 257.445 275.392 255.922 274.715 255.464 274.036 255.013 272.99 253.834 272.649 253.298 272.31 252.761 272 251.721 272 251.721 272 251.721 271.467 251.745 270.984 252.012 270.504 252.275 270.025 252.684 269.743 252.999 269.457 253.322 269.008 254.047 269.008 254.047 269.008 254.047 269.09 253.11 269.09 252.815 269.09 252.527 269.034 251.956 269.034 251.956 269.034 251.956 268.696 253.241 268.018 253.72 267.339 254.206 266.548 254.874 266.548 254.874 266.548 254.874 266.634 254.157 266.634 253.994 266.634 253.834 266.803 253.003 266.803 253.003 266.803 253.003 266.323 253.72 265.588 253.862 264.853 253.994 263.777 253.966 263.691 254.424 263.609 254.874 263.89 255.492 263.721 255.811 263.551 256.134 263.185 256.348 263.185 256.348 263.185 256.348 262.762 255.996 262.393 255.971 262.026 255.943 261.685 256.134 261.685 256.134 261.685 256.134 261.374 255.73 261.486 255.464 261.602 255.197 262.165 254.796 262.026 254.633 261.884 254.473 261.431 254.69 261.149 254.821 260.868 254.956 260.272 255.087 260.328 254.633 260.385 254.178 260.526 253.912 260.385 253.589 260.244 253.273 260.328 253.056 260.557 252.975 260.781 252.9 261.685 252.999 261.771 252.794 261.854 252.577 261.546 252.31 260.95 252.175 260.357 252.044 260.073 251.693 260.385 251.398 260.696 251.103 260.781 251.025 260.922 250.756 261.063 250.486 261.119 250.005 261.658 250.247 262.191 250.486 262.078 251.075 262.649 251.263 263.208 251.454 264.539 251.185 264.819 251.025 265.105 250.861 266.008 250.194 266.319 250.031 266.631 249.875 267.928 248.909 267.928 248.909 267.928 248.909 267.167 248.379 266.882 248.106 266.601 247.84 266.095 247.2 265.844 247.065 265.588 246.927 264.344 246.451 263.92 246.423 263.496 246.395 262.195 245.944 262.195 245.944 262.195 245.944 262.788 245.752 262.986 245.592 263.185 245.432 263.631 245.027 263.863 245.056 264.085 245.085 264.14 245.085 264.14 245.085 264.14 245.085 262.93 245.027 262.674 244.953 262.42 244.867 261.685 244.413 261.405 244.413 261.119 244.413 260.557 244.523 260.557 244.523 260.557 244.523 261.318 244.041 261.94 243.934 262.562 243.831 263.043 243.852 263.043 243.852 263.043 243.852 262.083 243.585 261.854 243.266 261.629 242.943 261.405 242.467 261.231 242.25 261.063 242.038 260.95 241.686 260.639 241.661 260.328 241.633 259.79 242.038 259.48 242.009 259.173 241.985 258.944 241.792 258.913 241.341 258.892 240.884 258.913 241.043 258.806 240.805 258.693 240.561 258.24 239.999 258.663 239.868 259.091 239.733 259.994 239.947 260.076 239.786 260.163 239.626 259.597 239.144 259.23 238.956 258.862 238.77 258.269 238.447 258.58 238.181 258.892 237.915 259.201 237.809 259.372 237.567 259.541 237.326 259.739 236.658 260.107 236.87 260.474 237.084 260.983 238.131 261.266 238.05 261.551 237.968 261.572 237.219 261.52 236.9 261.464 236.576 261.52 236.016 261.798 236.068 262.083 236.121 262.308 236.495 262.762 236.526 263.211 236.551 263.89 236.42 263.833 236.736 263.777 237.056 263.521 237.453 263.211 237.805 262.908 238.156 262.765 238.849 262.96 239.303 263.158 239.761 263.669 240.486 264.119 240.777 264.568 241.071 265.416 241.289 265.956 241.633 266.491 241.985 267.737 242.971 268.161 243.078 268.584 243.188 269.008 243.401 269.008 243.401 269.008 243.401 269.487 243.188 270.14 243.188 270.789 243.188 272.285 243.294 272.851 243.053 273.417 242.808 274.152 242.41 273.926 241.899 273.703 241.394 272.457 240.936 272.57 240.539 272.683 240.138 273.136 240.11 273.896 240.081 274.658 240.056 275.704 240.216 275.9 239.144 276.098 238.075 276.155 237.456 275.086 237.219 274.01 236.977 273.217 236.953 273.024 236.175 272.824 235.4 272.626 235.213 272.851 234.996 273.08 234.786 273.473 234.676 274.265 234.627 275.056 234.57 275.959 234.57 276.215 234.378 276.47 234.197 276.522 233.686 276.833 233.469 277.143 233.26 278.363 233.067 278.363 233.067 278.363 233.067 279.815 233.778 281.164 234.779 282.371 235.681 283.463 237.013 283.463 237.013' fill='%23ed72aa' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M273.046 236.242C273.046 236.242 272.877 235.76 272.848 235.625 272.822 235.493 272.734 235.33 272.734 235.33 272.734 235.33 273.612 235.33 273.583 235.596 273.556 235.866 273.301 235.866 273.245 235.969 273.189 236.079 273.046 236.242 273.046 236.242'/%3E %3Cpath d='M273.046 236.242C273.046 236.242 272.877 235.76 272.848 235.625 272.822 235.493 272.734 235.33 272.734 235.33 272.734 235.33 273.612 235.33 273.583 235.596 273.556 235.866 273.301 235.866 273.245 235.969 273.189 236.079 273.046 236.242 273.046 236.242z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M277.062 234.847L277.002 234.418C277.002 234.418 277.767 234.425 278.134 234.684 278.701 235.085 279.064 235.702 279.038 235.728 278.94 235.823 278.502 235.461 278.19 235.355 278.19 235.355 277.965 235.408 277.737 235.408 277.512 235.408 277.399 235.302 277.369 235.195 277.344 235.085 277.399 234.9 277.399 234.9L277.062 234.851'/%3E %3Cpath d='M277.062 234.847L277.002 234.418C277.002 234.418 277.767 234.425 278.134 234.684 278.701 235.085 279.064 235.702 279.038 235.728 278.94 235.823 278.502 235.461 278.19 235.355 278.19 235.355 277.965 235.408 277.737 235.408 277.512 235.408 277.399 235.302 277.369 235.195 277.344 235.085 277.399 234.9 277.399 234.9L277.062 234.851 277.062 234.847z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M282.574 240.898C282.574 240.898 282.232 240.415 282.15 240.252 282.063 240.096 281.921 239.772 281.921 239.772' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M261.88 236.079C261.88 236.079 262.36 236.423 262.728 236.477 263.095 236.533 263.493 236.533 263.549 236.533 263.605 236.533 263.721 235.993 263.661 235.625 263.463 234.418 262.36 234.151 262.36 234.151 262.36 234.151 262.689 234.883 262.529 235.22 262.304 235.702 261.88 236.079 261.88 236.079' fill='%23db4446'/%3E %3Cpath d='M261.88 236.079C261.88 236.079 262.36 236.423 262.728 236.477 263.095 236.533 263.493 236.533 263.549 236.533 263.605 236.533 263.721 235.993 263.661 235.625 263.463 234.418 262.36 234.151 262.36 234.151 262.36 234.151 262.689 234.883 262.529 235.22 262.304 235.702 261.88 236.079 261.88 236.079z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M259.589 237.123C259.589 237.123 259.165 236.346 258.262 236.452 257.358 236.558 256.762 237.258 256.762 237.258 256.762 237.258 257.76 237.226 258.006 237.389 258.375 237.631 258.487 238.249 258.487 238.249 258.487 238.249 259.027 237.926 259.195 237.712 259.364 237.496 259.589 237.123 259.589 237.123' fill='%23db4446'/%3E %3Cpath d='M259.589 237.123C259.589 237.123 259.165 236.346 258.262 236.452 257.358 236.558 256.762 237.258 256.762 237.258 256.762 237.258 257.76 237.226 258.006 237.389 258.375 237.631 258.487 238.249 258.487 238.249 258.487 238.249 259.027 237.926 259.195 237.712 259.364 237.496 259.589 237.123 259.589 237.123z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M258.487 240.252C258.487 240.252 257.725 240.361 257.302 240.845 256.874 241.327 256.935 242.236 256.935 242.236 256.935 242.236 257.44 241.704 257.894 241.704 258.349 241.704 259.053 241.864 259.053 241.864 259.053 241.864 258.828 241.296 258.828 241.057 258.828 240.817 258.487 240.252 258.487 240.252' fill='%23db4446'/%3E %3Cpath d='M258.487 240.252C258.487 240.252 257.725 240.361 257.302 240.845 256.874 241.327 256.935 242.236 256.935 242.236 256.935 242.236 257.44 241.704 257.894 241.704 258.349 241.704 259.053 241.864 259.053 241.864 259.053 241.864 258.828 241.296 258.828 241.057 258.828 240.817 258.487 240.252 258.487 240.252z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M273.076 240.145L273.413 239.612 273.746 240.096 273.076 240.145'/%3E %3Cpath d='M273.076 240.145L273.413 239.612 273.746 240.096 273.076 240.145' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M273.893 240.12L274.29 239.587 274.715 240.066 273.893 240.12'/%3E %3Cpath d='M273.893 240.12L274.29 239.587 274.715 240.066 273.893 240.12' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M273.527 236.828L274.347 237.123 273.612 237.496 273.527 236.828'/%3E %3Cpath d='M273.527 236.828L274.347 237.123 273.612 237.496 273.527 236.828' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M274.515 237.098L275.25 237.283 274.658 237.737 274.515 237.098'/%3E %3Cpath d='M274.515 237.098L275.25 237.283 274.658 237.737 274.515 237.098' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M269.003 243.387C269.003 243.387 268.198 243.622 267.901 244.055 267.534 244.59 267.561 245.127 267.561 245.127 267.561 245.127 268.239 244.566 269.116 244.804 269.994 245.045 270.076 245.127 270.447 245.102 270.815 245.074 271.719 244.75 271.719 244.75 271.719 244.75 270.984 245.606 271.067 246.199 271.152 246.785 271.261 247.051 271.238 247.35 271.177 248.074 270.643 248.958 270.643 248.958 270.643 248.958 270.954 248.767 271.689 248.607 272.42 248.447 273.046 248.095 273.44 247.804 273.834 247.506 274.343 246.785 274.343 246.785 274.343 246.785 274.179 247.776 274.343 248.205 274.512 248.635 274.569 249.867 274.569 249.867 274.569 249.867 275.041 249.449 275.415 249.249 275.614 249.14 276.124 248.873 276.324 248.554 276.462 248.326 276.635 247.488 276.635 247.488 276.635 247.488 276.747 248.39 277.028 248.827 277.313 249.249 277.732 250.567 277.732 250.567 277.732 250.567 278.018 249.711 278.329 249.36 278.637 249.012 279.008 248.558 279.034 248.288 279.06 248.021 278.952 247.435 278.952 247.435L279.345 248.288M267.928 248.902C267.928 248.902 268.408 248.074 268.862 247.804 269.316 247.535 269.938 247.055 270.106 247.002 270.271 246.948 271.01 246.544 271.01 246.544M272 251.714C272 251.714 273.088 251.156 273.413 250.961 274.092 250.563 274.572 249.839 274.572 249.839' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M261.058 250.372C261.058 250.372 260.635 249.921 259.9 250.052 259.165 250.187 258.685 251.018 258.685 251.018 258.685 251.018 259.307 250.854 259.676 250.936 260.042 251.018 260.298 251.391 260.298 251.391 260.298 251.391 260.635 251.096 260.748 250.936 260.861 250.777 261.055 250.372 261.055 250.372' fill='%23db4446'/%3E %3Cpath d='M261.058 250.372C261.058 250.372 260.635 249.921 259.9 250.052 259.165 250.187 258.685 251.018 258.685 251.018 258.685 251.018 259.307 250.854 259.676 250.936 260.042 251.018 260.298 251.391 260.298 251.391 260.298 251.391 260.635 251.096 260.748 250.936 260.861 250.777 261.055 250.372 261.055 250.372L261.058 250.372z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M260.211 253.343C260.211 253.343 259.589 253.238 259.053 253.667 258.517 254.096 258.487 254.924 258.487 254.924 258.487 254.924 258.997 254.494 259.395 254.552 259.788 254.601 260.268 254.817 260.268 254.817 260.268 254.817 260.354 254.306 260.38 254.175 260.467 253.801 260.211 253.343 260.211 253.343' fill='%23db4446'/%3E %3Cpath d='M260.211 253.343C260.211 253.343 259.589 253.238 259.053 253.667 258.517 254.096 258.487 254.924 258.487 254.924 258.487 254.924 258.997 254.494 259.395 254.552 259.788 254.601 260.268 254.817 260.268 254.817 260.268 254.817 260.354 254.306 260.38 254.175 260.467 253.801 260.211 253.343 260.211 253.343z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M261.655 256.078C261.655 256.078 261.614 256.873 261.993 257.36 262.39 257.871 263.125 257.95 263.125 257.95 263.125 257.95 262.878 257.417 262.84 257.146 262.784 256.746 263.178 256.397 263.178 256.397 263.178 256.397 262.814 256.025 262.447 256.025 262.078 256.025 261.655 256.078 261.655 256.078' fill='%23db4446'/%3E %3Cpath d='M261.655 256.078C261.655 256.078 261.614 256.873 261.993 257.36 262.39 257.871 263.125 257.95 263.125 257.95 263.125 257.95 262.878 257.417 262.84 257.146 262.784 256.746 263.178 256.397 263.178 256.397 263.178 256.397 262.814 256.025 262.447 256.025 262.078 256.025 261.655 256.078 261.655 256.078z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M278.333 257.413C278.333 257.413 280.369 258.674 280.313 259.718 280.253 260.762 279.18 262.128 279.18 262.128' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M269.003 263.119C269.003 263.119 268.494 262.477 267.789 262.502 267.08 262.53 266.344 263.194 266.344 263.194 266.344 263.194 267.223 263.119 267.447 263.41 267.676 263.709 267.901 264.078 267.901 264.078 267.901 264.078 268.296 263.868 268.468 263.733 268.637 263.603 269.003 263.119 269.003 263.119' fill='%23db4446'/%3E %3Cpath d='M269.003 263.119C269.003 263.119 268.494 262.477 267.789 262.502 267.08 262.53 266.344 263.194 266.344 263.194 266.344 263.194 267.223 263.119 267.447 263.41 267.676 263.709 267.901 264.078 267.901 264.078 267.901 264.078 268.296 263.868 268.468 263.733 268.637 263.603 269.003 263.119 269.003 263.119z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M266.826 265.928C266.826 265.928 265.896 265.794 265.442 266.276 264.988 266.756 265.018 267.64 265.018 267.64 265.018 267.64 265.585 267.026 266.091 267.078 266.601 267.132 267.167 267.402 267.167 267.402 267.167 267.402 267.08 266.866 267.024 266.624 266.968 266.383 266.826 265.928 266.826 265.928' fill='%23db4446'/%3E %3Cpath d='M266.826 265.928C266.826 265.928 265.896 265.794 265.442 266.276 264.988 266.756 265.018 267.64 265.018 267.64 265.018 267.64 265.585 267.026 266.091 267.078 266.601 267.132 267.167 267.402 267.167 267.402 267.167 267.402 267.08 266.866 267.024 266.624 266.968 266.383 266.826 265.928 266.826 265.928z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M268.835 268.901C268.835 268.901 268.381 269.543 268.723 270.051 269.06 270.562 269.766 270.804 269.766 270.804 269.766 270.804 269.514 270.431 269.627 269.997 269.716 269.657 270.305 269.195 270.305 269.195L268.835 268.904' fill='%23db4446'/%3E %3Cpath d='M268.835 268.901C268.835 268.901 268.381 269.543 268.723 270.051 269.06 270.562 269.766 270.804 269.766 270.804 269.766 270.804 269.514 270.431 269.627 269.997 269.716 269.657 270.305 269.195 270.305 269.195L268.835 268.904 268.835 268.901z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M281.242 270.108C281.242 270.108 280.426 269.916 279.972 270.186 279.522 270.452 279.154 271.578 279.154 271.578 279.154 271.578 279.889 270.964 280.426 271.038 280.961 271.123 281.359 271.337 281.359 271.337 281.359 271.337 281.441 270.878 281.384 270.562 281.351 270.371 281.242 270.108 281.242 270.108' fill='%23db4446'/%3E %3Cpath d='M281.242 270.108C281.242 270.108 280.426 269.916 279.972 270.186 279.522 270.452 279.154 271.578 279.154 271.578 279.154 271.578 279.889 270.964 280.426 271.038 280.961 271.123 281.359 271.337 281.359 271.337 281.359 271.337 281.441 270.878 281.384 270.562 281.351 270.371 281.242 270.108 281.242 270.108z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M281.64 273.102C281.64 273.102 281.018 273.744 281.242 274.28 281.471 274.816 281.865 275.377 281.865 275.377 281.865 275.377 281.842 274.579 282.094 274.362 282.458 274.042 283.136 273.986 283.136 273.986 283.136 273.986 282.6 273.506 282.428 273.453 282.262 273.396 281.64 273.102 281.64 273.102' fill='%23db4446'/%3E %3Cpath d='M281.64 273.102C281.64 273.102 281.018 273.744 281.242 274.28 281.471 274.816 281.865 275.377 281.865 275.377 281.865 275.377 281.842 274.579 282.094 274.362 282.458 274.042 283.136 273.986 283.136 273.986 283.136 273.986 282.6 273.506 282.428 273.453 282.262 273.396 281.64 273.102 281.64 273.102z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M284.748 274.042C284.748 274.042 284.437 274.816 285.033 275.324 285.625 275.835 286.136 275.889 286.136 275.889 286.136 275.889 285.682 275.082 285.825 274.656 285.971 274.212 286.36 273.935 286.36 273.935 286.36 273.935 285.625 273.691 285.513 273.719 285.401 273.744 284.748 274.042 284.748 274.042' fill='%23db4446'/%3E %3Cpath d='M284.748 274.042C284.748 274.042 284.437 274.816 285.033 275.324 285.625 275.835 286.136 275.889 286.136 275.889 286.136 275.889 285.682 275.082 285.825 274.656 285.971 274.212 286.36 273.935 286.36 273.935 286.36 273.935 285.625 273.691 285.513 273.719 285.401 273.744 284.748 274.042 284.748 274.042z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M252.907 329.55C255 330.18 256.06 331.738 256.06 333.563 256.06 335.939 253.755 337.742 250.763 337.742 247.771 337.742 245.345 335.939 245.345 333.563 245.345 331.766 246.342 329.76 248.423 329.615 248.423 329.615 248.359 329.426 248.18 329.117 247.964 328.887 247.539 328.457 247.539 328.457 247.539 328.457 248.333 328.308 248.791 328.482 249.252 328.656 249.555 328.947 249.555 328.947 249.555 328.947 249.773 328.521 250.077 328.191 250.384 327.864 250.782 327.658 250.782 327.658 250.782 327.658 251.242 328.045 251.393 328.304 251.543 328.571 251.641 328.887 251.641 328.887 251.641 328.887 252.064 328.538 252.431 328.396 252.798 328.251 253.271 328.138 253.271 328.138 253.271 328.138 253.136 328.596 253.046 328.829 252.956 329.061 252.907 329.55 252.907 329.55' fill='%23ffd691' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.321 340.321C250.321 340.321 246.342 337.64 244.618 337.277 242.412 336.812 239.934 337.189 238.862 337.132 238.892 337.163 240.148 338.058 240.699 338.612 241.25 339.163 243.088 340.264 244.126 340.523 247.354 341.333 250.321 340.321 250.321 340.321' fill='%23058e6e' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M251.456 340.555C251.456 340.555 254.005 337.905 256.672 337.54 259.825 337.103 261.888 337.8 263.112 338.119 263.14 338.119 262.1 338.612 261.551 338.989 260.998 339.365 259.578 340.555 257.407 340.58 255.232 340.612 252.833 340.352 252.435 340.413 252.037 340.466 251.456 340.555 251.456 340.555' fill='%23058e6e' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.692 337.277C249.69 336.347 249.067 335.026 249.067 333.56 249.067 332.097 249.694 330.776 250.695 329.849 251.693 330.776 252.311 332.097 252.311 333.56 252.311 335.026 251.689 336.347 250.692 337.277' fill='%23ad1519' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M249.679 342.71C249.679 342.71 250.294 341.191 250.354 339.884 250.406 338.791 250.2 337.711 250.2 337.711 250.2 337.711 250.538 337.711 250.721 337.711 250.906 337.711 250.995 337.711 250.995 337.711 250.995 337.711 251.393 338.872 251.393 339.884 251.393 340.899 251.209 342.249 251.209 342.249 251.209 342.249 250.658 342.334 250.475 342.419 250.294 342.508 249.679 342.71 249.679 342.71' fill='%23058e6e' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M300.005 198.674C300.005 198.098 300.496 197.64 301.1 197.64 301.708 197.64 302.195 198.098 302.195 198.674 302.195 199.249 301.708 199.71 301.1 199.71 300.496 199.71 300.005 199.249 300.005 198.674' fill='%23fff'/%3E %3Cpath d='M300.005 198.674C300.005 198.098 300.496 197.64 301.1 197.64 301.708 197.64 302.195 198.098 302.195 198.674 302.195 199.249 301.708 199.71 301.1 199.71 300.496 199.71 300.005 199.249 300.005 198.674z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M301.504 196.018C301.504 195.446 301.992 194.984 302.6 194.984 303.203 194.984 303.694 195.446 303.694 196.018 303.694 196.597 303.203 197.058 302.6 197.058 301.992 197.058 301.504 196.597 301.504 196.018' fill='%23fff'/%3E %3Cpath d='M301.504 196.018C301.504 195.446 301.992 194.984 302.6 194.984 303.203 194.984 303.694 195.446 303.694 196.018 303.694 196.597 303.203 197.058 302.6 197.058 301.992 197.058 301.504 196.597 301.504 196.018z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M302.501 192.943C302.501 192.371 302.993 191.906 303.602 191.906 304.205 191.906 304.696 192.371 304.696 192.943 304.696 193.518 304.205 193.983 303.602 193.983 302.993 193.983 302.501 193.518 302.501 192.943' fill='%23fff'/%3E %3Cpath d='M302.501 192.943C302.501 192.371 302.993 191.906 303.602 191.906 304.205 191.906 304.696 192.371 304.696 192.943 304.696 193.518 304.205 193.983 303.602 193.983 302.993 193.983 302.501 193.518 302.501 192.943z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M302.63 189.643C302.63 189.068 303.12 188.607 303.723 188.607 304.327 188.607 304.819 189.068 304.819 189.643 304.819 190.219 304.327 190.68 303.723 190.68 303.12 190.68 302.63 190.219 302.63 189.643' fill='%23fff'/%3E %3Cpath d='M302.63 189.643C302.63 189.068 303.12 188.607 303.723 188.607 304.327 188.607 304.819 189.068 304.819 189.643 304.819 190.219 304.327 190.68 303.723 190.68 303.12 190.68 302.63 190.219 302.63 189.643z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M301.816 186.395C301.816 185.823 302.308 185.361 302.91 185.361 303.518 185.361 304.009 185.823 304.009 186.395 304.009 186.973 303.518 187.435 302.91 187.435 302.308 187.435 301.816 186.973 301.816 186.395' fill='%23fff'/%3E %3Cpath d='M301.816 186.395C301.816 185.823 302.308 185.361 302.91 185.361 303.518 185.361 304.009 185.823 304.009 186.395 304.009 186.973 303.518 187.435 302.91 187.435 302.308 187.435 301.816 186.973 301.816 186.395z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M300.129 183.447C300.129 182.872 300.62 182.41 301.224 182.41 301.831 182.41 302.321 182.872 302.321 183.447 302.321 184.023 301.831 184.488 301.224 184.488 300.62 184.488 300.129 184.023 300.129 183.447' fill='%23fff'/%3E %3Cpath d='M300.129 183.447C300.129 182.872 300.62 182.41 301.224 182.41 301.831 182.41 302.321 182.872 302.321 183.447 302.321 184.023 301.831 184.488 301.224 184.488 300.62 184.488 300.129 184.023 300.129 183.447z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M297.879 181.025C297.879 180.45 298.37 179.985 298.974 179.985 299.582 179.985 300.072 180.45 300.072 181.025 300.072 181.597 299.582 182.062 298.974 182.062 298.37 182.062 297.879 181.597 297.879 181.025' fill='%23fff'/%3E %3Cpath d='M297.879 181.025C297.879 180.45 298.37 179.985 298.974 179.985 299.582 179.985 300.072 180.45 300.072 181.025 300.072 181.597 299.582 182.062 298.974 182.062 298.37 182.062 297.879 181.597 297.879 181.025z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M295.265 179.012C295.265 178.436 295.757 177.971 296.365 177.971 296.968 177.971 297.459 178.436 297.459 179.012 297.459 179.583 296.968 180.048 296.365 180.048 295.757 180.048 295.265 179.583 295.265 179.012' fill='%23fff'/%3E %3Cpath d='M295.265 179.012C295.265 178.436 295.757 177.971 296.365 177.971 296.968 177.971 297.459 178.436 297.459 179.012 297.459 179.583 296.968 180.048 296.365 180.048 295.757 180.048 295.265 179.583 295.265 179.012z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M292.143 177.364C292.143 176.789 292.633 176.331 293.238 176.331 293.845 176.331 294.336 176.789 294.336 177.364 294.336 177.94 293.845 178.405 293.238 178.405 292.633 178.405 292.143 177.94 292.143 177.364' fill='%23fff'/%3E %3Cpath d='M292.143 177.364C292.143 176.789 292.633 176.331 293.238 176.331 293.845 176.331 294.336 176.789 294.336 177.364 294.336 177.94 293.845 178.405 293.238 178.405 292.633 178.405 292.143 177.94 292.143 177.364z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M288.903 176.189C288.903 175.617 289.394 175.152 290.001 175.152 290.604 175.152 291.097 175.617 291.097 176.189 291.097 176.764 290.604 177.229 290.001 177.229 289.394 177.229 288.903 176.764 288.903 176.189' fill='%23fff'/%3E %3Cpath d='M288.903 176.189C288.903 175.617 289.394 175.152 290.001 175.152 290.604 175.152 291.097 175.617 291.097 176.189 291.097 176.764 290.604 177.229 290.001 177.229 289.394 177.229 288.903 176.764 288.903 176.189z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M285.281 175.542C285.281 174.971 285.771 174.502 286.376 174.502 286.984 174.502 287.473 174.971 287.473 175.542 287.473 176.114 286.984 176.58 286.376 176.58 285.771 176.58 285.281 176.114 285.281 175.542' fill='%23fff'/%3E %3Cpath d='M285.281 175.542C285.281 174.971 285.771 174.502 286.376 174.502 286.984 174.502 287.473 174.971 287.473 175.542 287.473 176.114 286.984 176.58 286.376 176.58 285.771 176.58 285.281 176.114 285.281 175.542z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M281.842 175.361C281.842 174.789 282.334 174.328 282.941 174.328 283.545 174.328 284.037 174.789 284.037 175.361 284.037 175.937 283.545 176.402 282.941 176.402 282.334 176.402 281.842 175.937 281.842 175.361' fill='%23fff'/%3E %3Cpath d='M281.842 175.361C281.842 174.789 282.334 174.328 282.941 174.328 283.545 174.328 284.037 174.789 284.037 175.361 284.037 175.937 283.545 176.402 282.941 176.402 282.334 176.402 281.842 175.937 281.842 175.361z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M278.467 175.479C278.467 174.907 278.96 174.442 279.566 174.442 280.174 174.442 280.661 174.907 280.661 175.479 280.661 176.054 280.174 176.519 279.566 176.519 278.96 176.519 278.467 176.054 278.467 175.479' fill='%23fff'/%3E %3Cpath d='M278.467 175.479C278.467 174.907 278.96 174.442 279.566 174.442 280.174 174.442 280.661 174.907 280.661 175.479 280.661 176.054 280.174 176.519 279.566 176.519 278.96 176.519 278.467 176.054 278.467 175.479z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M275.097 175.479C275.097 174.907 275.588 174.442 276.192 174.442 276.795 174.442 277.286 174.907 277.286 175.479 277.286 176.054 276.795 176.519 276.192 176.519 275.588 176.519 275.097 176.054 275.097 175.479' fill='%23fff'/%3E %3Cpath d='M275.097 175.479C275.097 174.907 275.588 174.442 276.192 174.442 276.795 174.442 277.286 174.907 277.286 175.479 277.286 176.054 276.795 176.519 276.192 176.519 275.588 176.519 275.097 176.054 275.097 175.479z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M276.785 178.373C276.785 177.798 277.276 177.333 277.879 177.333 278.487 177.333 278.974 177.798 278.974 178.373 278.974 178.945 278.487 179.413 277.879 179.413 277.276 179.413 276.785 178.945 276.785 178.373' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M277.471 181.569C277.471 180.994 277.962 180.528 278.566 180.528 279.173 180.528 279.665 180.994 279.665 181.569 279.665 182.137 279.173 182.602 278.566 182.602 277.962 182.602 277.471 182.137 277.471 181.569' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M277.594 184.754C277.594 184.175 278.086 183.713 278.693 183.713 279.297 183.713 279.786 184.175 279.786 184.754 279.786 185.325 279.297 185.791 278.693 185.791 278.086 185.791 277.594 185.325 277.594 184.754' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M276.597 187.651C276.597 187.079 277.088 186.611 277.691 186.611 278.299 186.611 278.787 187.079 278.787 187.651 278.787 188.226 278.299 188.688 277.691 188.688 277.088 188.688 276.597 188.226 276.597 187.651' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.733 190.315C274.733 189.743 275.225 189.275 275.828 189.275 276.434 189.275 276.923 189.743 276.923 190.315 276.923 190.887 276.434 191.352 275.828 191.352 275.225 191.352 274.733 190.887 274.733 190.315' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M272.544 173.469C272.544 172.897 273.035 172.435 273.642 172.435 274.246 172.435 274.737 172.897 274.737 173.469 274.737 174.044 274.246 174.509 273.642 174.509 273.035 174.509 272.544 174.044 272.544 173.469' fill='%23fff'/%3E %3Cpath d='M272.544 173.469C272.544 172.897 273.035 172.435 273.642 172.435 274.246 172.435 274.737 172.897 274.737 173.469 274.737 174.044 274.246 174.509 273.642 174.509 273.035 174.509 272.544 174.044 272.544 173.469z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M269.547 171.814C269.547 171.242 270.036 170.774 270.643 170.774 271.247 170.774 271.736 171.242 271.736 171.814 271.736 172.386 271.247 172.851 270.643 172.851 270.036 172.851 269.547 172.386 269.547 171.814' fill='%23fff'/%3E %3Cpath d='M269.547 171.814C269.547 171.242 270.036 170.774 270.643 170.774 271.247 170.774 271.736 171.242 271.736 171.814 271.736 172.386 271.247 172.851 270.643 172.851 270.036 172.851 269.547 172.386 269.547 171.814z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M266.245 170.816C266.245 170.244 266.736 169.783 267.342 169.783 267.946 169.783 268.438 170.244 268.438 170.816 268.438 171.391 267.946 171.857 267.342 171.857 266.736 171.857 266.245 171.391 266.245 170.816' fill='%23fff'/%3E %3Cpath d='M266.245 170.816C266.245 170.244 266.736 169.783 267.342 169.783 267.946 169.783 268.438 170.244 268.438 170.816 268.438 171.391 267.946 171.857 267.342 171.857 266.736 171.857 266.245 171.391 266.245 170.816z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M262.81 170.227C262.81 169.655 263.302 169.19 263.905 169.19 264.512 169.19 265 169.655 265 170.227 265 170.798 264.512 171.264 263.905 171.264 263.302 171.264 262.81 170.798 262.81 170.227' fill='%23fff'/%3E %3Cpath d='M262.81 170.227C262.81 169.655 263.302 169.19 263.905 169.19 264.512 169.19 265 169.655 265 170.227 265 170.798 264.512 171.264 263.905 171.264 263.302 171.264 262.81 170.798 262.81 170.227z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M259.447 170.283C259.447 169.712 259.937 169.243 260.542 169.243 261.149 169.243 261.64 169.712 261.64 170.283 261.64 170.859 261.149 171.321 260.542 171.321 259.937 171.321 259.447 170.859 259.447 170.283' fill='%23fff'/%3E %3Cpath d='M259.447 170.283C259.447 169.712 259.937 169.243 260.542 169.243 261.149 169.243 261.64 169.712 261.64 170.283 261.64 170.859 261.149 171.321 260.542 171.321 259.937 171.321 259.447 170.859 259.447 170.283z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M255.948 170.873C255.948 170.302 256.44 169.839 257.044 169.839 257.651 169.839 258.142 170.302 258.142 170.873 258.142 171.451 257.651 171.914 257.044 171.914 256.44 171.914 255.948 171.451 255.948 170.873' fill='%23fff'/%3E %3Cpath d='M255.948 170.873C255.948 170.302 256.44 169.839 257.044 169.839 257.651 169.839 258.142 170.302 258.142 170.873 258.142 171.451 257.651 171.914 257.044 171.914 256.44 171.914 255.948 171.451 255.948 170.873z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M252.709 171.992C252.709 171.416 253.2 170.951 253.803 170.951 254.411 170.951 254.902 171.416 254.902 171.992 254.902 172.563 254.411 173.032 253.803 173.032 253.2 173.032 252.709 172.563 252.709 171.992' fill='%23fff'/%3E %3Cpath d='M252.709 171.992C252.709 171.416 253.2 170.951 253.803 170.951 254.411 170.951 254.902 171.416 254.902 171.992 254.902 172.563 254.411 173.032 253.803 173.032 253.2 173.032 252.709 172.563 252.709 171.992z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M197.842 198.674C197.842 198.098 198.334 197.64 198.937 197.64 199.545 197.64 200.032 198.098 200.032 198.674 200.032 199.249 199.545 199.71 198.937 199.71 198.334 199.71 197.842 199.249 197.842 198.674' fill='%23fff'/%3E %3Cpath d='M197.842 198.674C197.842 198.098 198.334 197.64 198.937 197.64 199.545 197.64 200.032 198.098 200.032 198.674 200.032 199.249 199.545 199.71 198.937 199.71 198.334 199.71 197.842 199.249 197.842 198.674z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M196.342 196.018C196.342 195.446 196.833 194.984 197.437 194.984 198.045 194.984 198.536 195.446 198.536 196.018 198.536 196.597 198.045 197.058 197.437 197.058 196.833 197.058 196.342 196.597 196.342 196.018' fill='%23fff'/%3E %3Cpath d='M196.342 196.018C196.342 195.446 196.833 194.984 197.437 194.984 198.045 194.984 198.536 195.446 198.536 196.018 198.536 196.597 198.045 197.058 197.437 197.058 196.833 197.058 196.342 196.597 196.342 196.018z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M195.341 192.943C195.341 192.371 195.832 191.906 196.44 191.906 197.044 191.906 197.535 192.371 197.535 192.943 197.535 193.518 197.044 193.983 196.44 193.983 195.832 193.983 195.341 193.518 195.341 192.943' fill='%23fff'/%3E %3Cpath d='M195.341 192.943C195.341 192.371 195.832 191.906 196.44 191.906 197.044 191.906 197.535 192.371 197.535 192.943 197.535 193.518 197.044 193.983 196.44 193.983 195.832 193.983 195.341 193.518 195.341 192.943z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M195.217 189.643C195.217 189.068 195.709 188.607 196.313 188.607 196.92 188.607 197.411 189.068 197.411 189.643 197.411 190.219 196.92 190.68 196.313 190.68 195.709 190.68 195.217 190.219 195.217 189.643' fill='%23fff'/%3E %3Cpath d='M195.217 189.643C195.217 189.068 195.709 188.607 196.313 188.607 196.92 188.607 197.411 189.068 197.411 189.643 197.411 190.219 196.92 190.68 196.313 190.68 195.709 190.68 195.217 190.219 195.217 189.643z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M196.031 186.395C196.031 185.823 196.522 185.361 197.125 185.361 197.729 185.361 198.221 185.823 198.221 186.395 198.221 186.973 197.729 187.435 197.125 187.435 196.522 187.435 196.031 186.973 196.031 186.395' fill='%23fff'/%3E %3Cpath d='M196.031 186.395C196.031 185.823 196.522 185.361 197.125 185.361 197.729 185.361 198.221 185.823 198.221 186.395 198.221 186.973 197.729 187.435 197.125 187.435 196.522 187.435 196.031 186.973 196.031 186.395z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M197.714 183.447C197.714 182.872 198.206 182.41 198.814 182.41 199.417 182.41 199.908 182.872 199.908 183.447 199.908 184.023 199.417 184.488 198.814 184.488 198.206 184.488 197.714 184.023 197.714 183.447' fill='%23fff'/%3E %3Cpath d='M197.714 183.447C197.714 182.872 198.206 182.41 198.814 182.41 199.417 182.41 199.908 182.872 199.908 183.447 199.908 184.023 199.417 184.488 198.814 184.488 198.206 184.488 197.714 184.023 197.714 183.447z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M199.965 181.025C199.965 180.45 200.456 179.985 201.063 179.985 201.666 179.985 202.158 180.45 202.158 181.025 202.158 181.597 201.666 182.062 201.063 182.062 200.456 182.062 199.965 181.597 199.965 181.025' fill='%23fff'/%3E %3Cpath d='M199.965 181.025C199.965 180.45 200.456 179.985 201.063 179.985 201.666 179.985 202.158 180.45 202.158 181.025 202.158 181.597 201.666 182.062 201.063 182.062 200.456 182.062 199.965 181.597 199.965 181.025z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M202.578 179.012C202.578 178.436 203.069 177.971 203.676 177.971 204.28 177.971 204.772 178.436 204.772 179.012 204.772 179.583 204.28 180.048 203.676 180.048 203.069 180.048 202.578 179.583 202.578 179.012' fill='%23fff'/%3E %3Cpath d='M202.578 179.012C202.578 178.436 203.069 177.971 203.676 177.971 204.28 177.971 204.772 178.436 204.772 179.012 204.772 179.583 204.28 180.048 203.676 180.048 203.069 180.048 202.578 179.583 202.578 179.012z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M205.701 177.364C205.701 176.789 206.192 176.331 206.8 176.331 207.404 176.331 207.895 176.789 207.895 177.364 207.895 177.94 207.404 178.405 206.8 178.405 206.192 178.405 205.701 177.94 205.701 177.364' fill='%23fff'/%3E %3Cpath d='M205.701 177.364C205.701 176.789 206.192 176.331 206.8 176.331 207.404 176.331 207.895 176.789 207.895 177.364 207.895 177.94 207.404 178.405 206.8 178.405 206.192 178.405 205.701 177.94 205.701 177.364z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M208.941 176.189C208.941 175.617 209.432 175.152 210.036 175.152 210.643 175.152 211.134 175.617 211.134 176.189 211.134 176.764 210.643 177.229 210.036 177.229 209.432 177.229 208.941 176.764 208.941 176.189' fill='%23fff'/%3E %3Cpath d='M208.941 176.189C208.941 175.617 209.432 175.152 210.036 175.152 210.643 175.152 211.134 175.617 211.134 176.189 211.134 176.764 210.643 177.229 210.036 177.229 209.432 177.229 208.941 176.764 208.941 176.189z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M212.567 175.542C212.567 174.971 213.057 174.502 213.662 174.502 214.265 174.502 214.756 174.971 214.756 175.542 214.756 176.114 214.265 176.58 213.662 176.58 213.057 176.58 212.567 176.114 212.567 175.542' fill='%23fff'/%3E %3Cpath d='M212.567 175.542C212.567 174.971 213.057 174.502 213.662 174.502 214.265 174.502 214.756 174.971 214.756 175.542 214.756 176.114 214.265 176.58 213.662 176.58 213.057 176.58 212.567 176.114 212.567 175.542z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M216.002 175.361C216.002 174.789 216.492 174.328 217.1 174.328 217.703 174.328 218.195 174.789 218.195 175.361 218.195 175.937 217.703 176.402 217.1 176.402 216.492 176.402 216.002 175.937 216.002 175.361' fill='%23fff'/%3E %3Cpath d='M216.002 175.361C216.002 174.789 216.492 174.328 217.1 174.328 217.703 174.328 218.195 174.789 218.195 175.361 218.195 175.937 217.703 176.402 217.1 176.402 216.492 176.402 216.002 175.937 216.002 175.361z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M219.375 175.479C219.375 174.907 219.867 174.442 220.47 174.442 221.078 174.442 221.569 174.907 221.569 175.479 221.569 176.054 221.078 176.519 220.47 176.519 219.867 176.519 219.375 176.054 219.375 175.479' fill='%23fff'/%3E %3Cpath d='M219.375 175.479C219.375 174.907 219.867 174.442 220.47 174.442 221.078 174.442 221.569 174.907 221.569 175.479 221.569 176.054 221.078 176.519 220.47 176.519 219.867 176.519 219.375 176.054 219.375 175.479z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M222.75 175.479C222.75 174.907 223.241 174.442 223.845 174.442 224.452 174.442 224.944 174.907 224.944 175.479 224.944 176.054 224.452 176.519 223.845 176.519 223.241 176.519 222.75 176.054 222.75 175.479' fill='%23fff'/%3E %3Cpath d='M222.75 175.479C222.75 174.907 223.241 174.442 223.845 174.442 224.452 174.442 224.944 174.907 224.944 175.479 224.944 176.054 224.452 176.519 223.845 176.519 223.241 176.519 222.75 176.054 222.75 175.479z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M221.063 178.373C221.063 177.798 221.554 177.333 222.158 177.333 222.765 177.333 223.256 177.798 223.256 178.373 223.256 178.945 222.765 179.413 222.158 179.413 221.554 179.413 221.063 178.945 221.063 178.373' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M220.377 181.569C220.377 180.994 220.864 180.528 221.472 180.528 222.075 180.528 222.567 180.994 222.567 181.569 222.567 182.137 222.075 182.602 221.472 182.602 220.864 182.602 220.377 182.137 220.377 181.569' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M220.25 184.754C220.25 184.175 220.741 183.713 221.348 183.713 221.951 183.713 222.443 184.175 222.443 184.754 222.443 185.325 221.951 185.791 221.348 185.791 220.741 185.791 220.25 185.325 220.25 184.754' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M221.251 187.651C221.251 187.079 221.742 186.611 222.345 186.611 222.953 186.611 223.444 187.079 223.444 187.651 223.444 188.226 222.953 188.688 222.345 188.688 221.742 188.688 221.251 188.226 221.251 187.651' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M223.113 190.315C223.113 189.743 223.606 189.275 224.208 189.275 224.816 189.275 225.307 189.743 225.307 190.315 225.307 190.887 224.816 191.352 224.208 191.352 223.606 191.352 223.113 190.887 223.113 190.315' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.3 173.469C225.3 172.897 225.792 172.435 226.395 172.435 227.002 172.435 227.493 172.897 227.493 173.469 227.493 174.044 227.002 174.509 226.395 174.509 225.792 174.509 225.3 174.044 225.3 173.469' fill='%23fff'/%3E %3Cpath d='M225.3 173.469C225.3 172.897 225.792 172.435 226.395 172.435 227.002 172.435 227.493 172.897 227.493 173.469 227.493 174.044 227.002 174.509 226.395 174.509 225.792 174.509 225.3 174.044 225.3 173.469z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M228.3 171.814C228.3 171.242 228.791 170.774 229.394 170.774 230.001 170.774 230.493 171.242 230.493 171.814 230.493 172.386 230.001 172.851 229.394 172.851 228.791 172.851 228.3 172.386 228.3 171.814' fill='%23fff'/%3E %3Cpath d='M228.3 171.814C228.3 171.242 228.791 170.774 229.394 170.774 230.001 170.774 230.493 171.242 230.493 171.814 230.493 172.386 230.001 172.851 229.394 172.851 228.791 172.851 228.3 172.386 228.3 171.814z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M231.598 170.816C231.598 170.244 232.091 169.783 232.697 169.783 233.301 169.783 233.792 170.244 233.792 170.816 233.792 171.391 233.301 171.857 232.697 171.857 232.091 171.857 231.598 171.391 231.598 170.816' fill='%23fff'/%3E %3Cpath d='M231.598 170.816C231.598 170.244 232.091 169.783 232.697 169.783 233.301 169.783 233.792 170.244 233.792 170.816 233.792 171.391 233.301 171.857 232.697 171.857 232.091 171.857 231.598 171.391 231.598 170.816z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M235.036 170.227C235.036 169.655 235.528 169.19 236.131 169.19 236.74 169.19 237.231 169.655 237.231 170.227 237.231 170.798 236.74 171.264 236.131 171.264 235.528 171.264 235.036 170.798 235.036 170.227' fill='%23fff'/%3E %3Cpath d='M235.036 170.227C235.036 169.655 235.528 169.19 236.131 169.19 236.74 169.19 237.231 169.655 237.231 170.227 237.231 170.798 236.74 171.264 236.131 171.264 235.528 171.264 235.036 170.798 235.036 170.227z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M238.401 170.283C238.401 169.712 238.887 169.243 239.495 169.243 240.099 169.243 240.59 169.712 240.59 170.283 240.59 170.859 240.099 171.321 239.495 171.321 238.887 171.321 238.401 170.859 238.401 170.283' fill='%23fff'/%3E %3Cpath d='M238.401 170.283C238.401 169.712 238.887 169.243 239.495 169.243 240.099 169.243 240.59 169.712 240.59 170.283 240.59 170.859 240.099 171.321 239.495 171.321 238.887 171.321 238.401 170.859 238.401 170.283z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M241.899 170.873C241.899 170.302 242.39 169.839 242.993 169.839 243.602 169.839 244.089 170.302 244.089 170.873 244.089 171.451 243.602 171.914 242.993 171.914 242.39 171.914 241.899 171.451 241.899 170.873' fill='%23fff'/%3E %3Cpath d='M241.899 170.873C241.899 170.302 242.39 169.839 242.993 169.839 243.602 169.839 244.089 170.302 244.089 170.873 244.089 171.451 243.602 171.914 242.993 171.914 242.39 171.914 241.899 171.451 241.899 170.873z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M245.135 171.992C245.135 171.416 245.625 170.951 246.233 170.951 246.837 170.951 247.328 171.416 247.328 171.992 247.328 172.563 246.837 173.032 246.233 173.032 245.625 173.032 245.135 172.563 245.135 171.992' fill='%23fff'/%3E %3Cpath d='M245.135 171.992C245.135 171.416 245.625 170.951 246.233 170.951 246.837 170.951 247.328 171.416 247.328 171.992 247.328 172.563 246.837 173.032 246.233 173.032 245.625 173.032 245.135 172.563 245.135 171.992z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M217.341 238.412L216.417 238.412 216.417 237.488 214.799 237.488 214.799 241.185 216.417 241.185 216.417 243.726 212.951 243.726 212.951 251.121 214.799 251.121 214.799 265.909 211.102 265.909 211.102 273.535 239.524 273.535 239.524 265.909 235.827 265.909 235.827 251.121 237.675 251.121 237.675 243.726 234.209 243.726 234.209 241.185 235.827 241.185 235.827 237.488 234.209 237.488 234.209 238.412 233.285 238.412 233.285 237.488 231.667 237.488 231.667 238.412 230.512 238.412 230.512 237.488 228.894 237.488 228.894 241.185 230.512 241.185 230.512 243.726 227.046 243.726 227.046 235.639 228.894 235.639 228.894 231.942 227.046 231.942 227.046 232.866 226.122 232.866 226.122 231.942 224.504 231.942 224.504 232.866 223.58 232.866 223.58 231.942 221.731 231.942 221.731 235.639 223.58 235.639 223.58 243.726 220.114 243.726 220.114 241.185 221.731 241.185 221.731 237.488 220.114 237.488 220.114 238.412 219.189 238.412 219.189 237.488 217.341 237.488 217.341 238.412zM211.102 273.535L239.524 273.535M211.102 271.686L239.524 271.686M211.102 269.837L239.524 269.837M211.102 267.989L239.524 267.989M211.102 265.909L239.524 265.909M214.799 264.292L235.827 264.292M214.799 262.443L235.827 262.443M214.799 260.364L235.827 260.364M214.799 258.515L235.827 258.515M214.799 256.666L235.827 256.666M214.799 254.818L235.827 254.818M214.799 252.969L235.827 252.969M212.951 251.121L237.675 251.121M212.951 249.272L237.675 249.272M212.951 247.424L237.675 247.424M212.951 245.575L237.675 245.575M216.417 243.726L234.209 243.726M223.58 241.878L227.046 241.878M223.58 240.029L227.046 240.029M223.58 238.181L227.046 238.181M223.58 236.332L227.046 236.332M221.731 234.022L228.894 234.022M216.417 241.878L220.114 241.878M214.799 239.567L221.731 239.567M214.799 273.535L214.799 271.686M214.799 269.837L214.799 267.989M212.951 269.837L212.951 271.686M216.417 271.686L216.417 269.837M218.265 273.535L218.265 271.686M218.265 269.837L218.265 267.989M218.265 265.909L218.265 264.292M218.265 262.443L218.265 260.364M216.417 267.989L216.417 265.909M212.951 267.989L212.951 265.909M220.114 265.909L220.114 267.989M221.731 265.909L221.731 264.292M216.417 262.443L216.417 264.292M220.114 262.443L220.114 264.292M223.58 262.443L223.58 264.292M221.731 262.443L221.731 260.364M223.58 258.515L223.58 260.364M223.58 254.818L223.58 256.666M221.731 252.969L221.731 254.818M223.58 251.121L223.58 252.969M220.114 251.121L220.114 252.969M216.417 251.121L216.417 252.969M214.799 249.272L214.799 251.121M218.265 249.272L218.265 251.121M221.731 249.272L221.731 251.121M223.58 247.424L223.58 249.272M220.114 247.424L220.114 249.272M216.417 247.424L216.417 249.272M214.799 245.575L214.799 247.424M221.731 245.575L221.731 247.424M218.265 241.878L218.265 243.726M234.209 241.878L230.512 241.878M235.827 239.567L228.894 239.567M235.827 273.535L235.827 271.686M235.827 269.837L235.827 267.989M237.675 269.837L237.675 271.686M234.209 271.686L234.209 269.837M232.36 273.535L232.36 271.686M232.36 269.837L232.36 267.989M232.36 265.909L232.36 264.292M232.36 262.443L232.36 260.364M234.209 267.989L234.209 265.909M237.675 267.989L237.675 265.909M230.512 265.909L230.512 267.989M228.894 265.909L228.894 264.292M234.209 262.443L234.209 264.292M230.512 262.443L230.512 264.292M227.046 262.443L227.046 264.292M228.894 262.443L228.894 260.364M227.046 258.515L227.046 260.364M227.046 254.818L227.046 256.666M228.894 252.969L228.894 254.818M227.046 251.121L227.046 252.969M230.512 251.121L230.512 252.969M234.209 251.121L234.209 252.969M235.827 249.272L235.827 251.121M232.36 249.272L232.36 251.121M228.894 249.272L228.894 251.121M227.046 247.424L227.046 249.272M230.512 247.424L230.512 249.272M234.209 247.424L234.209 249.272M235.827 245.575L235.827 247.424M228.894 245.575L228.894 247.424M232.36 241.878L232.36 243.726M225.197 262.443L225.197 260.364M225.197 254.818L225.197 252.969M225.197 258.515L225.197 256.666M225.197 251.121L225.197 249.272M225.197 247.424L225.197 245.575M225.197 241.878L225.197 240.029M225.197 238.181L225.197 236.332M216.417 241.185L220.114 241.185M223.58 235.639L227.046 235.639M230.512 241.185L234.209 241.185' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M230.05 273.535C230.05 271.224 230.05 269.606 230.05 268.682 230.05 267.758 229.588 264.985 225.197 264.985 221.038 264.985 220.576 267.758 220.576 268.682 220.576 269.606 220.576 271.224 220.576 273.535L230.05 273.535z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M222.193 268.913L219.883 268.682C219.883 267.758 220.114 266.371 220.807 265.909L222.887 267.527C222.656 267.758 222.193 268.451 222.193 268.913z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M228.432 268.913L230.743 268.682C230.743 267.758 230.512 266.371 229.819 265.909L227.739 267.527C227.97 267.758 228.432 268.451 228.432 268.913z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M226.122 266.602L227.277 264.523C226.815 264.292 225.89 264.061 225.197 264.061 224.735 264.061 223.811 264.292 223.349 264.523L224.504 266.602C224.966 266.602 225.659 266.602 226.122 266.602z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M221.731 260.826C221.731 260.826 221.731 257.129 221.731 255.742 221.731 254.356 220.807 253.2 219.189 253.2 217.572 253.2 216.648 254.356 216.648 255.742 216.648 257.129 216.648 260.826 216.648 260.826L221.731 260.826z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M228.894 260.826C228.894 260.826 228.894 257.129 228.894 255.742 228.894 254.356 229.819 253.2 231.436 253.2 233.054 253.2 233.978 254.356 233.978 255.742 233.978 257.129 233.978 260.826 233.978 260.826L228.894 260.826z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M227.046 248.348L227.508 243.726 223.118 243.726 223.349 248.348 227.046 248.348z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M230.512 248.348L230.05 243.726 234.671 243.726 234.209 248.348 230.512 248.348z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M220.114 248.348L220.345 243.726 215.954 243.726 216.417 248.348 220.114 248.348z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M228.432 273.535C228.432 271.686 228.432 270.068 228.432 269.375 228.432 268.682 227.97 266.602 225.197 266.602 222.656 266.602 222.193 268.682 222.193 269.375 222.193 270.068 222.193 271.686 222.193 273.535L228.432 273.535z' fill='%230039f0'/%3E %3Cpath d='M221.269 260.364C221.269 260.364 221.269 257.129 221.269 255.973 221.269 254.818 220.576 253.662 219.189 253.662 217.803 253.662 217.11 254.818 217.11 255.973 217.11 257.129 217.11 260.364 217.11 260.364L221.269 260.364z' fill='%230039f0'/%3E %3Cpath d='M229.357 260.364C229.357 260.364 229.357 257.129 229.357 255.973 229.357 254.818 230.05 253.662 231.436 253.662 232.823 253.662 233.516 254.818 233.516 255.973 233.516 257.129 233.516 260.364 233.516 260.364L229.357 260.364z' fill='%230039f0'/%3E %3Cpath d='M234.175 281.006C234.175 270.904 241.453 262.714 250.429 262.714 259.409 262.714 266.687 270.904 266.687 281.006 266.687 291.108 259.409 299.297 250.429 299.297 241.453 299.297 234.175 291.108 234.175 281.006' fill='%23ad1519'/%3E %3Cpath d='M234.175 281.006C234.175 270.904 241.453 262.714 250.429 262.714 259.409 262.714 266.687 270.904 266.687 281.006 266.687 291.108 259.409 299.297 250.429 299.297 241.453 299.297 234.175 291.108 234.175 281.006z' fill='none' stroke='%23000' stroke-width='0.61'/%3E %3Cpath d='M238.997 280.971C238.997 273.563 244.115 267.559 250.436 267.559 256.754 267.559 261.873 273.563 261.873 280.971 261.873 288.381 256.754 294.389 250.436 294.389 244.115 294.389 238.997 288.381 238.997 280.971' fill='%23005bbf'/%3E %3Cpath d='M238.997 280.971C238.997 273.563 244.115 267.559 250.436 267.559 256.754 267.559 261.873 273.563 261.873 280.971 261.873 288.381 256.754 294.389 250.436 294.389 244.115 294.389 238.997 288.381 238.997 280.971z' fill='none' stroke='%23000' stroke-width='0.61'/%3E %3Cpath d='M245.033 271.737C245.033 271.737 243.675 273.225 243.675 274.603 243.675 275.988 244.249 277.138 244.249 277.138 244.044 276.592 243.489 276.198 242.836 276.198 242.012 276.198 241.34 276.83 241.34 277.615 241.34 277.842 241.479 278.197 241.584 278.392L242.071 279.376C242.232 279.013 242.612 278.811 243.054 278.811 243.645 278.811 244.126 279.262 244.126 279.824 244.126 279.908 244.115 279.994 244.093 280.071L242.874 280.075 242.874 281.112 243.961 281.112 243.152 282.717 244.224 282.299 245.033 283.211 245.873 282.299 246.942 282.717 246.136 281.112 247.223 281.112 247.223 280.075 246.001 280.071C245.979 279.994 245.975 279.908 245.975 279.824 245.975 279.262 246.447 278.811 247.039 278.811 247.481 278.811 247.861 279.013 248.025 279.376L248.508 278.392C248.614 278.197 248.753 277.842 248.753 277.615 248.753 276.83 248.085 276.198 247.257 276.198 246.604 276.198 246.053 276.592 245.847 277.138 245.847 277.138 246.417 275.988 246.417 274.603 246.417 273.225 245.03 271.737 245.03 271.737' fill='%23c8b100'/%3E %3Cpath d='M245.033 271.737C245.033 271.737 243.675 273.225 243.675 274.603 243.675 275.988 244.249 277.138 244.249 277.138 244.044 276.592 243.489 276.198 242.836 276.198 242.012 276.198 241.34 276.83 241.34 277.615 241.34 277.842 241.479 278.197 241.584 278.392L242.071 279.376C242.232 279.013 242.612 278.811 243.054 278.811 243.645 278.811 244.126 279.262 244.126 279.824 244.126 279.908 244.115 279.994 244.093 280.071L242.874 280.075 242.874 281.112 243.961 281.112 243.152 282.717 244.224 282.299 245.033 283.211 245.873 282.299 246.942 282.717 246.136 281.112 247.223 281.112 247.223 280.075 246.001 280.071C245.979 279.994 245.975 279.908 245.975 279.824 245.975 279.262 246.447 278.811 247.039 278.811 247.481 278.811 247.861 279.013 248.025 279.376L248.508 278.392C248.614 278.197 248.753 277.842 248.753 277.615 248.753 276.83 248.085 276.198 247.257 276.198 246.604 276.198 246.053 276.592 245.847 277.138 245.847 277.138 246.417 275.988 246.417 274.603 246.417 273.225 245.03 271.737 245.03 271.737L245.033 271.737z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.34'/%3E %3Cpath d='M242.874 281.112L247.226 281.112 247.226 280.075 242.874 280.075 242.874 281.112z' fill='%23c8b100'/%3E %3Cpath d='M242.874 281.112L247.226 281.112 247.226 280.075 242.874 280.075 242.874 281.112z' fill='none' stroke='%23000' stroke-width='0.34'/%3E %3Cpath d='M255.663 271.737C255.663 271.737 254.306 273.225 254.306 274.603 254.306 275.988 254.876 277.138 254.876 277.138 254.673 276.592 254.119 276.198 253.466 276.198 252.637 276.198 251.97 276.83 251.97 277.615 251.97 277.842 252.109 278.197 252.214 278.392L252.697 279.376C252.863 279.013 253.242 278.811 253.684 278.811 254.276 278.811 254.752 279.262 254.752 279.824 254.752 279.908 254.745 279.994 254.723 280.071L253.503 280.075 253.503 281.112 254.591 281.112 253.781 282.717 254.85 282.299 255.663 283.211 256.5 282.299 257.572 282.717 256.762 281.112 257.849 281.112 257.849 280.075 256.631 280.071C256.608 279.994 256.601 279.908 256.601 279.824 256.601 279.262 257.077 278.811 257.67 278.811 258.112 278.811 258.491 279.013 258.652 279.376L259.139 278.392C259.245 278.197 259.382 277.842 259.382 277.615 259.382 276.83 258.712 276.198 257.886 276.198 257.235 276.198 256.678 276.592 256.474 277.138 256.474 277.138 257.047 275.988 257.047 274.603 257.047 273.225 255.66 271.737 255.66 271.737' fill='%23c8b100'/%3E %3Cpath d='M255.663 271.737C255.663 271.737 254.306 273.225 254.306 274.603 254.306 275.988 254.876 277.138 254.876 277.138 254.673 276.592 254.119 276.198 253.466 276.198 252.637 276.198 251.97 276.83 251.97 277.615 251.97 277.842 252.109 278.197 252.214 278.392L252.697 279.376C252.863 279.013 253.242 278.811 253.684 278.811 254.276 278.811 254.752 279.262 254.752 279.824 254.752 279.908 254.745 279.994 254.723 280.071L253.503 280.075 253.503 281.112 254.591 281.112 253.781 282.717 254.85 282.299 255.663 283.211 256.5 282.299 257.572 282.717 256.762 281.112 257.849 281.112 257.849 280.075 256.631 280.071C256.608 279.994 256.601 279.908 256.601 279.824 256.601 279.262 257.077 278.811 257.67 278.811 258.112 278.811 258.491 279.013 258.652 279.376L259.139 278.392C259.245 278.197 259.382 277.842 259.382 277.615 259.382 276.83 258.712 276.198 257.886 276.198 257.235 276.198 256.678 276.592 256.474 277.138 256.474 277.138 257.047 275.988 257.047 274.603 257.047 273.225 255.66 271.737 255.66 271.737L255.663 271.737z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.34'/%3E %3Cpath d='M253.503 281.112L257.853 281.112 257.853 280.075 253.503 280.075 253.503 281.112z' fill='%23c8b100'/%3E %3Cpath d='M253.503 281.112L257.853 281.112 257.853 280.075 253.503 280.075 253.503 281.112z' fill='none' stroke='%23000' stroke-width='0.34'/%3E %3Cpath d='M250.347 280.881C250.347 280.881 248.989 282.369 248.989 283.751 248.989 285.132 249.563 286.282 249.563 286.282 249.357 285.735 248.805 285.341 248.15 285.341 247.325 285.341 246.653 285.974 246.653 286.758 246.653 286.989 246.792 287.34 246.897 287.535L247.384 288.519C247.55 288.157 247.924 287.951 248.366 287.951 248.959 287.951 249.44 288.405 249.44 288.967 249.44 289.056 249.428 289.14 249.405 289.219L248.187 289.222 248.187 290.259 249.278 290.259 248.468 291.864 249.537 291.442 250.347 292.354 251.187 291.442 252.259 291.864 251.445 290.259 252.536 290.259 252.536 289.222 251.317 289.219C251.295 289.14 251.287 289.056 251.287 288.967 251.287 288.405 251.764 287.951 252.357 287.951 252.798 287.951 253.173 288.157 253.339 288.519L253.827 287.535C253.93 287.34 254.07 286.989 254.07 286.758 254.07 285.974 253.399 285.341 252.574 285.341 251.922 285.341 251.371 285.735 251.16 286.282 251.16 286.282 251.734 285.132 251.734 283.751 251.734 282.369 250.343 280.881 250.343 280.881' fill='%23c8b100'/%3E %3Cpath d='M250.347 280.881C250.347 280.881 248.989 282.369 248.989 283.751 248.989 285.132 249.563 286.282 249.563 286.282 249.357 285.735 248.805 285.341 248.15 285.341 247.325 285.341 246.653 285.974 246.653 286.758 246.653 286.989 246.792 287.34 246.897 287.535L247.384 288.519C247.55 288.157 247.924 287.951 248.366 287.951 248.959 287.951 249.44 288.405 249.44 288.967 249.44 289.056 249.428 289.14 249.405 289.219L248.187 289.222 248.187 290.259 249.278 290.259 248.468 291.864 249.537 291.442 250.347 292.354 251.187 291.442 252.259 291.864 251.445 290.259 252.536 290.259 252.536 289.222 251.317 289.219C251.295 289.14 251.287 289.056 251.287 288.967 251.287 288.405 251.764 287.951 252.357 287.951 252.798 287.951 253.173 288.157 253.339 288.519L253.827 287.535C253.93 287.34 254.07 286.989 254.07 286.758 254.07 285.974 253.399 285.341 252.574 285.341 251.922 285.341 251.371 285.735 251.16 286.282 251.16 286.282 251.734 285.132 251.734 283.751 251.734 282.369 250.343 280.881 250.343 280.881L250.347 280.881z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.34'/%3E %3Cpath d='M248.187 290.259L252.54 290.259 252.54 289.222 248.187 289.222 248.187 290.259z' fill='%23c8b100'/%3E %3Cpath d='M248.187 290.259L252.54 290.259 252.54 289.222 248.187 289.222 248.187 290.259z' fill='none' stroke='%23000' stroke-width='0.34'/%3E %3Cpath d='M282.882 232.706L282.593 232.727C282.58 232.762 282.45 232.969 282.327 233.083 282.071 233.327 281.685 233.355 281.468 233.15 281.362 233.043 281.31 232.894 281.329 232.741 281.16 232.827 280.984 232.827 280.818 232.734 280.56 232.585 280.495 232.23 280.684 231.935 280.714 231.878 280.744 231.804 280.789 231.761L280.77 231.438 280.421 231.52 280.32 231.711C280.103 231.957 279.78 232.02 279.619 231.875 279.541 231.808 279.483 231.62 279.488 231.612 279.491 231.62 279.405 231.697 279.315 231.718 278.78 231.85 278.566 230.671 278.554 230.366L278.378 230.615C278.378 230.615 278.536 231.32 278.456 231.918 278.378 232.514 278.167 233.111 278.167 233.111 278.914 233.302 280.032 233.909 281.141 234.765 282.251 235.614 283.124 236.537 283.485 237.184 283.485 237.184 284.059 236.863 284.662 236.672 285.259 236.477 286.019 236.473 286.019 236.473L286.236 236.26C285.917 236.307 284.655 236.36 284.68 235.83 284.685 235.746 284.748 235.653 284.759 235.653 284.752 235.66 284.55 235.642 284.459 235.586 284.276 235.465 284.28 235.156 284.483 234.9L284.659 234.772 284.67 234.432 284.332 234.478C284.301 234.52 284.224 234.57 284.178 234.613 283.913 234.844 283.53 234.861 283.32 234.644 283.193 234.52 283.153 234.353 283.208 234.179 283.054 234.225 282.893 234.211 282.757 234.133 282.499 233.977 282.45 233.611 282.649 233.327 282.742 233.188 282.926 233.025 282.958 233.008L282.889 232.709' fill='%23c8b100'/%3E %3Cpath d='M282.882 232.706L282.593 232.727C282.58 232.762 282.45 232.969 282.327 233.083 282.071 233.327 281.685 233.355 281.468 233.15 281.362 233.043 281.31 232.894 281.329 232.741 281.16 232.827 280.984 232.827 280.818 232.734 280.56 232.585 280.495 232.23 280.684 231.935 280.714 231.878 280.744 231.804 280.789 231.761L280.77 231.438 280.421 231.52 280.32 231.711C280.103 231.957 279.78 232.02 279.619 231.875 279.541 231.808 279.483 231.62 279.488 231.612 279.491 231.62 279.405 231.697 279.315 231.718 278.78 231.85 278.566 230.671 278.554 230.366L278.378 230.615C278.378 230.615 278.536 231.32 278.456 231.918 278.378 232.514 278.167 233.111 278.167 233.111 278.914 233.302 280.032 233.909 281.141 234.765 282.251 235.614 283.124 236.537 283.485 237.184 283.485 237.184 284.059 236.863 284.662 236.672 285.259 236.477 286.019 236.473 286.019 236.473L286.236 236.26C285.917 236.307 284.655 236.36 284.68 235.83 284.685 235.746 284.748 235.653 284.759 235.653 284.752 235.66 284.55 235.642 284.459 235.586 284.276 235.465 284.28 235.156 284.483 234.9L284.659 234.772 284.67 234.432 284.332 234.478C284.301 234.52 284.224 234.57 284.178 234.613 283.913 234.844 283.53 234.861 283.32 234.644 283.193 234.52 283.153 234.353 283.208 234.179 283.054 234.225 282.893 234.211 282.757 234.133 282.499 233.977 282.45 233.611 282.649 233.327 282.742 233.188 282.926 233.025 282.958 233.008L282.889 232.709 282.882 232.706z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M280.631 233.395C280.681 233.334 280.785 233.337 280.864 233.398 280.942 233.458 280.964 233.555 280.916 233.611 280.868 233.668 280.766 233.668 280.684 233.604 280.609 233.548 280.583 233.451 280.631 233.395'/%3E %3Cpath d='M280.631 233.395C280.681 233.334 280.785 233.337 280.864 233.398 280.942 233.458 280.964 233.555 280.916 233.611 280.868 233.668 280.766 233.668 280.684 233.604 280.609 233.548 280.583 233.451 280.631 233.395z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M281.58 234.193L281.253 233.941C281.194 233.895 281.175 233.821 281.213 233.778 281.25 233.739 281.329 233.739 281.389 233.781L281.715 234.037 282.049 234.29C282.105 234.332 282.126 234.407 282.09 234.453 282.049 234.492 281.97 234.488 281.91 234.446L281.58 234.193'/%3E %3Cpath d='M281.58 234.193L281.253 233.941C281.194 233.895 281.175 233.821 281.213 233.778 281.25 233.739 281.329 233.739 281.389 233.781L281.715 234.037 282.049 234.29C282.105 234.332 282.126 234.407 282.09 234.453 282.049 234.492 281.97 234.488 281.91 234.446L281.58 234.193' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M279.837 233L279.578 232.848C279.514 232.809 279.48 232.734 279.511 232.685 279.537 232.631 279.615 232.624 279.679 232.663L279.936 232.816 280.2 232.969C280.264 233.004 280.294 233.079 280.268 233.132 280.238 233.178 280.163 233.188 280.096 233.15L279.837 233'/%3E %3Cpath d='M279.837 233L279.578 232.848C279.514 232.809 279.48 232.734 279.511 232.685 279.537 232.631 279.615 232.624 279.679 232.663L279.936 232.816 280.2 232.969C280.264 233.004 280.294 233.079 280.268 233.132 280.238 233.178 280.163 233.188 280.096 233.15L279.837 233' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M278.805 232.287C278.854 232.234 278.96 232.234 279.038 232.294 279.117 232.355 279.139 232.45 279.091 232.507 279.041 232.564 278.937 232.56 278.858 232.504 278.78 232.439 278.756 232.348 278.805 232.287'/%3E %3Cpath d='M278.805 232.287C278.854 232.234 278.96 232.234 279.038 232.294 279.117 232.355 279.139 232.45 279.091 232.507 279.041 232.564 278.937 232.56 278.858 232.504 278.78 232.439 278.756 232.348 278.805 232.287z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M282.63 234.925C282.679 234.868 282.655 234.776 282.578 234.712 282.499 234.651 282.394 234.648 282.345 234.709 282.297 234.765 282.319 234.861 282.397 234.921 282.475 234.982 282.58 234.982 282.63 234.925'/%3E %3Cpath d='M282.63 234.925C282.679 234.868 282.655 234.776 282.578 234.712 282.499 234.651 282.394 234.648 282.345 234.709 282.297 234.765 282.319 234.861 282.397 234.921 282.475 234.982 282.58 234.982 282.63 234.925z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M283.204 235.582L283.417 235.788C283.47 235.837 283.552 235.856 283.598 235.816 283.643 235.781 283.637 235.71 283.586 235.66L283.376 235.451 283.158 235.237C283.106 235.188 283.024 235.174 282.978 235.213 282.93 235.244 282.937 235.323 282.993 235.372L283.204 235.582'/%3E %3Cpath d='M283.204 235.582L283.417 235.788C283.47 235.837 283.552 235.856 283.598 235.816 283.643 235.781 283.637 235.71 283.586 235.66L283.376 235.451 283.158 235.237C283.106 235.188 283.024 235.174 282.978 235.213 282.93 235.244 282.937 235.323 282.993 235.372L283.204 235.582' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M284.151 236.391C284.201 236.331 284.178 236.239 284.1 236.175 284.021 236.114 283.916 236.111 283.867 236.172 283.818 236.232 283.841 236.324 283.92 236.388 283.998 236.445 284.104 236.449 284.151 236.391'/%3E %3Cpath d='M284.151 236.391C284.201 236.331 284.178 236.239 284.1 236.175 284.021 236.114 283.916 236.111 283.867 236.172 283.818 236.232 283.841 236.324 283.92 236.388 283.998 236.445 284.104 236.449 284.151 236.391z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M281.402 230.355L280.811 230.373 280.696 231.243 280.759 231.381 280.913 231.371 281.67 230.862 281.402 230.355' fill='%23c8b100'/%3E %3Cpath d='M281.402 230.355L280.811 230.373 280.696 231.243 280.759 231.381 280.913 231.371 281.67 230.862 281.402 230.355' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M279.8 230.838L279.783 231.381 280.703 231.495 280.846 231.434 280.834 231.285 280.298 230.571 279.8 230.838' fill='%23c8b100'/%3E %3Cpath d='M279.8 230.838L279.783 231.381 280.703 231.495 280.846 231.434 280.834 231.285 280.298 230.571 279.8 230.838' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M281.7 231.921L281.209 232.194 280.672 231.478 280.661 231.332 280.804 231.271 281.727 231.381 281.7 231.921' fill='%23c8b100'/%3E %3Cpath d='M281.7 231.921L281.209 232.194 280.672 231.478 280.661 231.332 280.804 231.271 281.727 231.381 281.7 231.921' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M280.51 231.25C280.594 231.118 280.77 231.076 280.904 231.157 281.039 231.232 281.084 231.399 281.003 231.527 280.919 231.658 280.744 231.697 280.609 231.623 280.474 231.545 280.429 231.378 280.51 231.25' fill='%23c8b100'/%3E %3Cpath d='M280.51 231.25C280.594 231.118 280.77 231.076 280.904 231.157 281.039 231.232 281.084 231.399 281.003 231.527 280.919 231.658 280.744 231.697 280.609 231.623 280.474 231.545 280.429 231.378 280.51 231.25z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M278.36 230.352C278.345 230.355 278.231 229.894 278.104 229.638 278.018 229.453 277.714 229.212 277.714 229.212 277.744 229.155 278.127 229.017 278.584 229.304 278.955 229.61 278.554 230.171 278.554 230.171 278.554 230.171 278.456 230.306 278.363 230.352' fill='%23c8b100'/%3E %3Cpath d='M278.36 230.352C278.345 230.355 278.231 229.894 278.104 229.638 278.018 229.453 277.714 229.212 277.714 229.212 277.744 229.155 278.127 229.017 278.584 229.304 278.955 229.61 278.554 230.171 278.554 230.171 278.554 230.171 278.456 230.306 278.363 230.352L278.36 230.352z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M279.393 230.664L278.974 231.026 278.291 230.433 278.351 230.348 278.375 230.202 279.3 230.134 279.393 230.664' fill='%23c8b100'/%3E %3Cpath d='M279.393 230.664L278.974 231.026 278.291 230.433 278.351 230.348 278.375 230.202 279.3 230.134 279.393 230.664' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M278.236 230.294C278.288 230.145 278.419 230.057 278.524 230.089 278.628 230.127 278.671 230.273 278.621 230.419 278.569 230.568 278.438 230.653 278.333 230.625 278.224 230.585 278.183 230.44 278.236 230.294' fill='%23c8b100'/%3E %3Cpath d='M278.236 230.294C278.288 230.145 278.419 230.057 278.524 230.089 278.628 230.127 278.671 230.273 278.621 230.419 278.569 230.568 278.438 230.653 278.333 230.625 278.224 230.585 278.183 230.44 278.236 230.294z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M283.668 231.772L283.079 231.708 282.832 232.557 282.878 232.702 283.032 232.706 283.856 232.304 283.668 231.772' fill='%23c8b100'/%3E %3Cpath d='M283.668 231.772L283.079 231.708 282.832 232.557 282.878 232.702 283.032 232.706 283.856 232.304 283.668 231.772' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M282.007 232.034L281.914 232.571 282.806 232.805 282.956 232.762 282.967 232.617 282.543 231.832 282.007 232.034' fill='%23c8b100'/%3E %3Cpath d='M282.007 232.034L281.914 232.571 282.806 232.805 282.956 232.762 282.967 232.617 282.543 231.832 282.007 232.034' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M283.732 233.355L283.204 233.565 282.78 232.783 282.791 232.634 282.941 232.595 283.833 232.83 283.732 233.355' fill='%23c8b100'/%3E %3Cpath d='M283.732 233.355L283.204 233.565 282.78 232.783 282.791 232.634 282.941 232.595 283.833 232.83 283.732 233.355' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M282.652 232.539C282.75 232.418 282.934 232.408 283.054 232.5 283.178 232.592 283.196 232.762 283.099 232.88 282.997 232.997 282.817 233.011 282.693 232.918 282.574 232.827 282.55 232.656 282.652 232.539' fill='%23c8b100'/%3E %3Cpath d='M282.652 232.539C282.75 232.418 282.934 232.408 283.054 232.5 283.178 232.592 283.196 232.762 283.099 232.88 282.997 232.997 282.817 233.011 282.693 232.918 282.574 232.827 282.55 232.656 282.652 232.539z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M285.645 233.608L285.752 234.165 284.879 234.456 284.725 234.425 284.707 234.279 285.071 233.472 285.645 233.608' fill='%23c8b100'/%3E %3Cpath d='M285.645 233.608L285.752 234.165 284.879 234.456 284.725 234.425 284.707 234.279 285.071 233.472 285.645 233.608' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M285.487 235.202L284.929 235.326 284.62 234.495 284.655 234.353 284.809 234.332 285.66 234.68 285.487 235.202' fill='%23c8b100'/%3E %3Cpath d='M285.487 235.202L284.929 235.326 284.62 234.495 284.655 234.353 284.809 234.332 285.66 234.68 285.487 235.202' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M283.972 233.66L283.792 234.176 284.644 234.52 284.8 234.499 284.83 234.357 284.527 233.53 283.972 233.66' fill='%23c8b100'/%3E %3Cpath d='M283.972 233.66L283.792 234.176 284.644 234.52 284.8 234.499 284.83 234.357 284.527 233.53 283.972 233.66' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M284.914 234.627C285.029 234.52 285.033 234.35 284.929 234.239 284.82 234.133 284.635 234.126 284.52 234.225 284.407 234.332 284.4 234.499 284.509 234.613 284.613 234.723 284.798 234.726 284.914 234.627' fill='%23c8b100'/%3E %3Cpath d='M284.914 234.627C285.029 234.52 285.033 234.35 284.929 234.239 284.82 234.133 284.635 234.126 284.52 234.225 284.407 234.332 284.4 234.499 284.509 234.613 284.613 234.723 284.798 234.726 284.914 234.627z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M286.289 236.43C286.286 236.445 286.788 236.456 287.077 236.519 287.283 236.562 287.602 236.793 287.602 236.793 287.658 236.751 287.715 236.37 287.321 236.005 286.927 235.724 286.435 236.218 286.435 236.218 286.435 236.218 286.316 236.335 286.289 236.43' fill='%23c8b100'/%3E %3Cpath d='M286.289 236.43C286.286 236.445 286.788 236.456 287.077 236.519 287.283 236.562 287.602 236.793 287.602 236.793 287.658 236.751 287.715 236.37 287.321 236.005 286.927 235.724 286.435 236.218 286.435 236.218 286.435 236.218 286.316 236.335 286.289 236.43z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M285.749 235.535L285.461 236.001 286.218 236.512 286.311 236.43 286.435 236.388 286.319 235.514 285.749 235.535' fill='%23c8b100'/%3E %3Cpath d='M285.749 235.535L285.461 236.001 286.218 236.512 286.311 236.43 286.435 236.388 286.319 235.514 285.749 235.535' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M286.372 236.533C286.51 236.456 286.578 236.314 286.522 236.225 286.461 236.132 286.301 236.121 286.162 236.2 286.023 236.281 285.956 236.416 286.016 236.512 286.071 236.601 286.233 236.612 286.372 236.533' fill='%23c8b100'/%3E %3Cpath d='M286.372 236.533C286.51 236.456 286.578 236.314 286.522 236.225 286.461 236.132 286.301 236.121 286.162 236.2 286.023 236.281 285.956 236.416 286.016 236.512 286.071 236.601 286.233 236.612 286.372 236.533z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M326.132 213.644L326.132 214.223 323.597 214.223 323.597 213.644 324.535 213.644 324.535 212.337 323.916 212.337 323.916 211.755 324.535 211.755 324.535 211.184 325.146 211.184 325.146 211.755 325.756 211.755 325.756 212.337 325.146 212.337 325.146 213.644 326.132 213.644' fill='none' stroke='%23000' stroke-width='0.3'/%3E %3Cpath d='M175.435 226.15L175.435 224.883' fill='none' stroke='%23000' stroke-width='0.02'/%3E %3Cpath d='M175.091 226.15L175.091 224.883' fill='none' stroke='%23000' stroke-width='0.03'/%3E %3Cpath d='M174.766 226.15L174.766 224.883' fill='none' stroke='%23000' stroke-width='0.04'/%3E %3Cpath d='M174.443 226.15L174.443 224.883' fill='none' stroke='%23000' stroke-width='0.04'/%3E %3Cpath d='M174.156 226.15L174.156 224.883' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M173.609 226.082L173.601 224.928M173.868 226.097L173.868 224.89' fill='none' stroke='%23000' stroke-width='0.06'/%3E %3Cpath d='M173.103 226.03L173.103 224.967M173.359 226.06L173.352 224.929' fill='none' stroke='%23000' stroke-width='0.07'/%3E %3Cpath d='M172.425 225.969L172.425 225.035M172.648 225.984L172.648 225.005M172.877 226.015L172.877 224.997' fill='none' stroke='%23000' stroke-width='0.08'/%3E %3Cpath d='M172.187 225.962L172.187 225.058' fill='none' stroke='%23000' stroke-width='0.09'/%3E %3Cpath d='M171.966 225.916L171.966 225.073' fill='none' stroke='%23000' stroke-width='0.1'/%3E %3Cpath d='M171.728 225.893L171.728 225.111' fill='none' stroke='%23000' stroke-width='0.11'/%3E %3Cpath d='M171.242 225.825L171.234 225.202M171.491 225.855L171.491 225.157' fill='none' stroke='%23000' stroke-width='0.12'/%3E %3Cpath d='M170.992 225.772L170.992 225.225' fill='none' stroke='%23000' stroke-width='0.12'/%3E %3Cpath d='M170.764 225.727L170.764 225.272' fill='none' stroke='%23000' stroke-width='0.13'/%3E %3Cpath d='M170.514 225.667L170.514 225.31' fill='none' stroke='%23000' stroke-width='0.14'/%3E %3Cpath d='M170.258 225.637L170.258 225.371' fill='none' stroke='%23000' stroke-width='0.15'/%3E %3Cpath d='M169.987 225.576L169.987 225.447' fill='none' stroke='%23000' stroke-width='0.18'/%3E %3Cpath d='M176.805 226.082L176.805 224.921M176.221 226.12L176.229 224.89M175.796 226.135L175.796 224.883' fill='none' stroke='%23000' stroke-width='0.01'/%3E %3Cpath d='M324.768 226.172L324.768 224.904' fill='none' stroke='%23000' stroke-width='0.02'/%3E %3Cpath d='M324.424 226.172L324.424 224.904' fill='none' stroke='%23000' stroke-width='0.03'/%3E %3Cpath d='M324.099 226.172L324.099 224.904' fill='none' stroke='%23000' stroke-width='0.04'/%3E %3Cpath d='M323.777 226.172L323.777 224.904' fill='none' stroke='%23000' stroke-width='0.04'/%3E %3Cpath d='M323.49 226.172L323.49 224.904' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M322.942 226.103L322.934 224.949M323.202 226.118L323.202 224.912' fill='none' stroke='%23000' stroke-width='0.06'/%3E %3Cpath d='M322.436 226.051L322.436 224.988M322.693 226.082L322.685 224.95' fill='none' stroke='%23000' stroke-width='0.07'/%3E %3Cpath d='M321.758 225.991L321.758 225.057M321.981 226.006L321.981 225.026M322.21 226.036L322.21 225.019' fill='none' stroke='%23000' stroke-width='0.08'/%3E %3Cpath d='M321.521 225.983L321.521 225.08' fill='none' stroke='%23000' stroke-width='0.09'/%3E %3Cpath d='M321.299 225.938L321.299 225.095' fill='none' stroke='%23000' stroke-width='0.1'/%3E %3Cpath d='M321.061 225.915L321.061 225.133' fill='none' stroke='%23000' stroke-width='0.11'/%3E %3Cpath d='M320.575 225.846L320.567 225.224M320.824 225.877L320.824 225.178' fill='none' stroke='%23000' stroke-width='0.12'/%3E %3Cpath d='M320.325 225.793L320.325 225.246' fill='none' stroke='%23000' stroke-width='0.12'/%3E %3Cpath d='M320.097 225.749L320.097 225.294' fill='none' stroke='%23000' stroke-width='0.13'/%3E %3Cpath d='M319.847 225.688L319.847 225.332' fill='none' stroke='%23000' stroke-width='0.14'/%3E %3Cpath d='M319.591 225.658L319.591 225.392' fill='none' stroke='%23000' stroke-width='0.15'/%3E %3Cpath d='M319.32 225.597L319.32 225.468' fill='none' stroke='%23000' stroke-width='0.18'/%3E %3Cpath d='M326.138 226.103L326.138 224.942M325.555 226.141L325.562 224.912M325.13 226.156L325.13 224.904' fill='none' stroke='%23000' stroke-width='0.01'/%3E %3C/svg%3E"

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='720' height='360'%3E %3Crect fill='%23da121a' height='360' width='720'/%3E %3Crect fill='%23fcdd09' height='240' width='720'/%3E %3Crect fill='%23078930' height='120' width='720'/%3E %3Cg transform='translate(360,180)'%3E %3Ccircle fill='%230f47af' r='120'/%3E %3Cg id='t'%3E %3Cpath fill='%23fcdd09' d='M0,-96 -4.205849,-83.055728 13.141645,-29.665631H-9.987258L-12.586616,-21.665631H61.576052L72.587108,-29.665631H21.553343z'/%3E %3Cpath stroke='%23fcdd09' stroke-width='4' d='M0,44V96' transform='rotate(216)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(144)'/%3E %3Cuse xlink:href='%23t' transform='rotate(216)'/%3E %3Cuse xlink:href='%23t' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1800' height='1100'%3E %3Crect width='1800' height='1100' fill='%23fff'/%3E %3Crect width='1800' height='300' y='400' fill='%23003580'/%3E %3Crect width='300' height='1100' x='500' fill='%23003580'/%3E %3C/svg%3E"

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM0,300V400H300V0H600z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%23002868'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23ce1126' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23ce1126' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2368bfe5'/%3E %3Cg id='coa' stroke-miterlimit='4.8'%3E %3Cpath fill='%23fff' d='m778.8,143.94,0,205.09c0,67.08,121.2,106.91,121.2,106.91s121.2-39.833,121.2-106.91v-205.09z'/%3E %3Cpath fill='%23d21034' d='m883.2,216,0,92.344-104.4,0,0,33.6,104.4,0,0,107.6,16.8,6.396,16.8-6.396,0-107.6,104.4,0,0-33.6-104.4,0,0-92.344z'/%3E %3Cpath fill='%23d21034' d='m778.8,143.94,242.4,0,0,79.2-242.4,0z'/%3E %3Cg id='lion' stroke-miterlimit='3'%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='0.805'%3E %3Cellipse stroke-width='0.803' cx='798.23' cy='192.212' rx='13.623' ry='10.962'/%3E %3Cellipse cx='798.23' cy='186.525' rx='12.114' ry='6.123'/%3E %3Cellipse cx='798.23' cy='198.769' rx='12.114' ry='6.123'/%3E %3Cellipse cx='798.23' cy='192.213' rx='12.114' ry='6.123'/%3E %3C/g%3E %3Cpath fill='%23ffd100' stroke='%23000' stroke-width='1.2' d='m1015.2,207.43-1.9848-5.4756s-5.4336-2.2164-5.8476-5.1024c-0.9672-7.6944-3.714-10.578-7.83-11.678-4.1244-1.0992-6.8676,0.6888-6.8676,0.6888-1.2408,1.7868-7.4256,1.7868-10.859,1.9212-3.4344,0.1404-3.4932-1.4916-3.4932-1.4916-2.6676,0.0192-3.7896-1.9416-3.7896-1.9416-1.746-3.4872-3.0456-4.7916-3.9084-5.2332,4.4568,0.066,7.8132-1.9908,12.844-7.2696,5.4936-5.772,9.4152-3.54,9.4152-3.54-2.6664,5.3892,0.8868,4.9128,0.8868,4.9128,7.2804-3.7056,0.96-13.051-1.2372-12.638-2.1972,0.4104-2.8248-1.0692-2.8248-1.0692,0.0672,1.6776-2.4396,2.3448-2.4396,2.3448,1.8804-10.674-4.4892-13.504-4.4892-13.504-0.9636,0.9612-1.5156,2.8836-1.5156,2.8836-1.7832,6.4584-7.6908,5.4972-14.29,2.3352-6.5928-3.1584-24.179,3.3-29.672,5.4972-5.5008,2.1984-15.528,5.634-24.596,0.5496-9.0648-5.0868-11.269-4.1244-14.839-3.1608-3.5748,0.96-9.888,2.4756-12.222,1.236-2.3388-1.236-5.0028-1.3128-5.0028-1.3128,0.636-0.3552-0.3576-1.8468-0.3576-1.8468-2.7468-3.708,0.3576-5.9808,0.3576-5.9808s-5.1144,1.44-3.0804,10.169l0.9348,1.3092s0.6852,2.7456,2.2008,3.5712l-0.0552,0.6012s1.2936-0.6012,1.7004,1.1832c0.4176,1.7856,2.34,0.138,3.1644-1.3716,0,0-1.3764,7.9692,8.5188,9.8916,0,0-1.1064-1.2372-0.6924-2.0616,0.4104-0.8244-1.2336-1.5168-1.0944-2.7492,0.1356-1.2324-2.4696-1.7832-0.414-2.7492,2.058-0.9612,3.0252-2.886,7.4196-0.2748s7.8336,2.064,7.8336,2.064-2.6808-5.502-1.2036-5.4984c1.4772,0.002,8.1228,8.2296,11.394,7.8228,3.2724-0.4032,9.5928-4.1136,12.754-2.7396,0,0,0.2712-1.6488,12.36-3.7104,12.092-2.0616,27.006-8.0868,32.599-2.8068,0,0,0.654,4.182,2.9868,5.2824,0,0-0.4176,8.6544-15.385,3.8424l-5.43-1.428s-0.834-2.6292-29.304,4.6932c0,0-1.6752,0.5844-2.7744,1.4112-1.1028,0.8208-2.6148-0.414-8.2476,1.6452-5.628,2.0652-26.654,8.9352-39.564,6.4596l-0.0168,0.0348c-2.844-0.8496-5.508-0.4104-5.616-0.8592-0.1392-0.5496,1.5132,0.1392,1.5132,0.1392-0.96-1.1016-1.374-1.1904-1.374-1.1904-10.855-1.1904-8.9364-6.0936-8.9364-6.0936l0.5532,1.512c1.7868-2.334-0.6924-7.83-0.6924-7.83l-0.1044,0.018c-0.0276-0.1692-0.0588-0.3372-0.1008-0.5004l0.8976-0.6192c5.2224-4.398,11.269-5.2224,11.269-5.2224-3.5748-4.3944-11.134-2.058-11.134-2.058,0.1392-5.358-2.058-11.542-2.058-11.542-7.4232,0.8244-11.678,7.0056-11.678,7.0056-0.2748-5.4936-7.284-8.652-7.284-8.652,2.6076,3.1584,0.9636,10.714,0.9636,10.714l0.2748,0.138c-0.4344-0.0108-0.6888,0-0.6888,0l-0.156,1.62-0.2568-0.108s-2.6076,0.96-5.6292,7.83c0,0-0.306,1.6236-1.4748,3.0876-0.01-0.1896,0.0108-0.3612-0.0132-0.5592,0,0-3.3756,4.4232-11.176,0,0,0-10.598-6.288-14.323-6.0552-3.7248,0.2316-6.174,1.9788-5.9364,3.0264,0,0-8.5044-0.6996-11.413,4.1892,0,0-6.4032,2.3292-0.93,7.5696,0,0,0.7332,2.2776,2.3256,3.498,0,0-0.2256-4.7844,0.9336-3.378,0,0,0.3012,0.4716,0.8736,0.8016,0.1524,0.6708,0.666,2.5344,1.8036,3.4836l0.8196-0.2604c0.1248-1.1928,0.3828-2.7,0.648-3.3336,0.1248,0.0168,0.2244,0.0312,0.27,0.0348-0.036,0.0348-0.0696,0.0552-0.1044,0.0864l1.5132,2.3292,1.7448-0.9312c0.8172-0.1188,1.8636,0.6996,1.8636,0.6996l1.98-1.6308c-0.012-0.018-0.024-0.0216-0.036-0.0408,1.95,0.3264,2.4828-3.4536,2.4828-3.4536,1.752,0.4608,3.39-0.0552,4.7844-0.9,0.8496,3.1344,7.7916,6.4956,7.7916,6.4956s0.12-0.0108,0.2988-0.0252c-0.588,0.3756-0.9372,0.6576-0.9372,0.6576,3.1584,2.202,9.0672,1.6512,9.0672,1.6512-2.4708,0.9636-2.1252,5.5368-2.1252,5.5368-1.4436,0.5928-1.5852,2.0184-1.5852,2.0184,4.8096,1.9188,8.0952,0.33,8.0952,0.33,0.264,1.5648-0.1248,1.7316-0.1248,1.7316-1.9224,4.1208-2.7468,8.1048-2.7468,8.1048,0.042,0.018,0.0912,0.0276,0.132,0.042-0.0588,0.108-0.132,0.2124-0.1776,0.324,0,0-8.3832,2.91-12.109,6.9864,0,0-0.3504-1.1664-1.3992-1.1664-1.0476,0-4.308-2.6748-5.8224-3.1428-1.5108-0.4632-3.7248,0.468-4.308-0.2292-0.5268-0.636-0.2904-5.406-1.2984-6.1752,0.004,0,0.0192,0.004,0.0192,0.004l-1.0488-2.91c-0.6984,1.512-3.6084,1.1616-3.6084,1.1616-0.1152,0.0696-0.5628,0.396-1.1964,0.8688-0.5808,0.0312-1.2492-0.1692-1.2492-0.1692-0.2988,0.0612-0.594,0.9-0.8112,1.7148-0.1164,0.0864-0.2352,0.1764-0.3528,0.2664v-0.8172c-0.5796,0.4656-1.7448-0.2328-2.2128-0.2328-0.228,0-0.51,0.6672-0.7392,1.3524-1.1844,0.2196-2.754,0.2784-2.754,0.2784-0.4656,0.2328-0.1188,3.8424-0.1188,3.8424-3.3744,1.8648-1.746,4.6572-1.746,4.6572,1.8636,9.0828,17.35,5.0064,18.515,6.174,1.1616,1.1652,3.8424,1.3944,5.2404,1.3944,1.3944,0,3.1392,3.378,5.1216,3.7272,1.9812,0.3504,0-2.6772,9.1824-4.8708,9.1788-2.1936,12.239-5.958,12.239-5.958,2.8752-0.5544,3.6756-4.0488,3.8904-5.46,0.0276,0.6504,0.1044,1.3704,0.2088,2.19,0.414,3.1608-1.77,4.3116-1.77,4.3116l7.9548-2.388c3.1572-0.8244,2.7468-3.5748,2.7468-3.5748,3.0216,8.6568,8.5188,9.2064,8.5188,9.2064,1.0992-3.2988,0.9636-4.2612,0.9636-4.2612l2.472-0.1344c0.1008-1.8636-1.5444-3.2256-2.4972-3.8592l3.87,2.3472,1.5084-0.2748c0,1.374,2.0616,2.6076,2.0616,2.6076l0.2784-1.782c1.7868,2.3352,5.0832,1.5096,5.0832,1.5096-0.066-0.4152-0.1668-0.8448-0.2916-1.2828,7.0404,4.3452,18.286-1.1892,18.286-1.1892,3.0216,0.6864,3.4344-1.1004,3.4344-1.1004,3.4344,0.4104,4.2312-1.9368,4.2312-1.9368,8.0832-0.6996,13.772-6.4464,13.772-6.4464,3.9804-0.2748,4.11-3.1212,4.11-3.1212s3.9912,0.7872,7.8396-4.0224c8.928-12.775,22.28-6.1236,22.28-6.1236l-7.7196,0.4884c-20.194-0.1356-11.822,13.598-11.822,13.598l1.2444-0.132c1.9236,0.4116,8.5152,5.6328,6.0852,9.522-0.0384,0.0684-0.0912,0.1308-0.1356,0.1932-4.1172,5.6364-11.742,0.2604-13.915-4.4952-2.2008-4.8072-6.5988-3.7068-6.5988-3.7068s-11.401,1.9236-6.7308,10.991l0.1704,0.005c0.0864,2.2128,1.4748,4.734,5.5416,7.2396,2.2848,3.2316,9.7944,3.5688,15.31,2.3736,2.5668-0.5604,16.112-6.384,16.112-6.384,0.9936-2.9496,4.3596-2.2704,7.3812-6.5292s-4.26-5.772-5.9076-8.1048c-1.6512-2.3388,0.414-1.9248,0.414-1.9248,6.5916,3.5724,7.1412-7.8324,7.1412-7.8324,0.6888,6.5928,6.4572,8.3796,6.4572,8.3796,3.5748-3.5676,0.9672-10.852,0.9672-10.852,8.5188,15.25,13.678,12.822,13.678,12.822-4.5864-2.8392-2.2776-6.6396-2.2776-6.6396,4.1172,16.211,21.022,2.0616,21.022,2.0616-0.8244,2.3328,0.004,3.7056,1.5132,5.2176,1.5096,1.512,3.2964,2.1996,2.4756,4.9476-0.8268,2.7468-8.6532,2.1996-8.6532,2.1996s-7.698-0.4104-7.0068,6.0468c0.4032,1.5084,5.49,2.058,7.4136,1.6476,0,0-0.7932,0.1728,2.0508,0.5532,0.9528,0.1224,2.1036,0.1428,3.2748,0.1044,3.2784-0.1008,6.7704-0.6576,6.7704-0.6576,4.3908-0.9588,3.7068-2.4756,3.7068-2.4756,6.726-1.2396,7.4172-5.7756,7.4172-5.7756z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m791.954,179.295c0.005-0.007,0.3612-0.8484,1.0392-0.9492,0.5232-0.078,1.158,0.3096,1.8288,1.1244l0.3672-0.276c-0.0156-0.0276-1.8132-2.646-1.0968-4.4952,0.3192-0.8244,1.1136-1.3896,2.3568-1.6692l-0.1008-0.4524c-1.4028,0.3216-2.3052,0.9804-2.6856,1.9572-0.1416,0.3648-0.2016,0.7512-0.2016,1.1364,0,0.9036,0.318,1.8192,0.6444,2.5224-0.4068-0.2556-0.8028-0.3612-1.1832-0.3036-0.69,0.1044-1.026,0.6012-1.2084,0.9252z'/%3E %3Cpath d='m1004,215.28c-4.59,0.7284-11.328,1.1316-11.864-0.2568-0.0936-0.2472-0.1104-1.2384,3.648-3.6852l-0.438-0.6732c-3.1356,2.0424-4.398,3.5184-3.96,4.6464,0.9624,2.4996,10.799,1.0716,12.763,0.7584z'/%3E %3Cpath d='m916.2,217.93c-1.0464-1.6008-0.576-3.7932,1.398-6.5232l-0.6504-0.4692c-2.1936,3.018-2.6712,5.5236-1.422,7.434z'/%3E %3Cpath d='m910,211.02c0.1008,2.7684,2.0556,5.3388,5.7996,7.632l0.4212-0.6864c-3.5052-2.1432-5.3232-4.4904-5.418-6.9732-0.138-3.8124,3.8904-6.7524,3.9288-6.7836l-0.4692-0.654c-0.1812,0.1284-4.4184,3.216-4.2624,7.4652z'/%3E %3Cpath d='m988.29,212.05c-1.2588,1.8588-0.8376,4.11-0.8208,4.2048l0.7884-0.1548c-0.007-0.0216-0.372-2.0256,0.7032-3.6036,0.6456-0.9492,1.686-1.5648,3.0972-1.8324l-0.1452-0.7896c-1.6344,0.3096-2.85,1.0404-3.6228,2.1756z'/%3E %3Cpath d='m808.92,176.89-0.2484-0.0624-0.0336,0.2556c-0.007,0.0252-0.3576,2.4636-1.464,3.1272-0.3096,0.1848-0.6432,0.2052-1.0284,0.0648l-1.878-1.1424c-0.3744-0.33-0.696-0.5724-1.2372-0.414-0.108-0.1392-0.5388-0.7236-0.5388-1.662,0-0.1044,0.007-0.216,0.0228-0.3288,0.1332-1.1004,0.9012-2.1612,2.2896-3.1512l-0.264-0.3756c-1.5048,1.0752-2.3376,2.2428-2.484,3.48-0.168,1.4328,0.6612,2.406,0.6972,2.448l0.1116,0.1284,0.1524-0.0696c0.4176-0.1848,0.5388-0.0756,0.9456,0.2844l2.0268,1.2324c0.5148,0.1896,0.9912,0.1548,1.422-0.102,1.1448-0.6852,1.5456-2.6808,1.6392-3.2352,4.8768,1.0488,8.802-4.8792,8.9724-5.1348l-0.39-0.252c-0.0348,0.0624-4.0404,6.1344-8.7132,4.9092z'/%3E %3Cpath d='m797.23,175.98c-0.2436,0.9876-0.0768,1.9572,0.4872,2.8824,0.5388,0.8772,1.0692,1.344,1.6224,1.4172,0.6744,0.0936,1.2132-0.4068,1.6884-0.8448,0.3456-0.324,0.6744-0.6252,0.9444-0.6048l0.4188,0.2892,0.3612-0.2868-0.7476-0.4608c-0.4716-0.0348-0.8676,0.3324-1.29,0.726-0.4212,0.3864-0.8532,0.7932-1.314,0.7296-0.3996-0.0552-0.8316-0.462-1.29-1.206-0.4968-0.8148-0.6468-1.6692-0.4356-2.5308,0.5256-2.1756,3.1272-3.774,3.1548-3.7896l-0.2364-0.3924c-0.1164,0.0672-2.7912,1.7088-3.3636,4.0716z'/%3E %3Cpath d='m790.52,207.04c0.2328-0.8412,0.8796-1.5576,1.9188-2.1348-0.2052,0.0192,1.0188,1.0152,2.0688,0.9036,0,0,0.426-0.2292,0.6816-0.3684,0.2784,0.24,2.0964,1.8948,2.0964,3.9912,0,0.4416-0.0804,0.894-0.2784,1.3536l0.426,0.1788c1.3296-3.15-2.0148-5.9436-2.046-5.9736l-0.1224-0.096-0.2064,0.1332-0.5964,0.324c-0.8592,0.09-1.9788-0.8184-1.9872-0.8268-1.4112,0.6156-2.1324,1.4304-2.4,2.3988z'/%3E %3Cpath d='m806.05,199c-1.0044,0.0852-3.8016,0.6192-4.7148,2.0712-0.33,0.5268-0.3792,1.1064-0.1392,1.7328l0.3672,0.9768c0.8712,2.3436,1.776,4.7652,2.7624,5.3124l0.2232-0.4008c-0.8376-0.4644-1.7496-2.9124-2.556-5.0712l-0.3648-0.9768c-0.1872-0.4944-0.156-0.9288,0.0948-1.3284,0.75-1.1904,3.2652-1.7652,4.3656-1.8564,0.6408-0.0516,0.8496,2.3136,0.9768,3.7272l0.4572-0.042c-0.1836-2.0832-0.3768-4.236-1.4724-4.1448z'/%3E %3Cpath d='m798.38,201.3c-0.588,0.5256-0.4692,1.3176-0.462,1.3524,0.005,0.2172,0.2664,6.0672,3.0444,7.2768l0.1824-0.4212c-2.514-1.0956-2.7672-6.8448-2.7708-6.9012-0.001-0.0348-0.0828-0.6156,0.3168-0.966,0.4212-0.3744,1.2588-0.4032,2.4204-0.084l0.1224-0.4416c-1.3404-0.3696-2.3004-0.3084-2.8536,0.1848z'/%3E %3Cpath d='m796.18,201.78c-1.2288,0.8556-1.1784,3.2976-1.1772,3.3996l0.4596-0.008c0-0.0252-0.0456-2.3028,0.9804-3.0144,0.3828-0.264,0.8868-0.2748,1.5012-0.0276l0.1704-0.4248c-0.7656-0.312-1.4184-0.2868-1.9344,0.0756z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m862.33,169.49c0.0216,0.0384,1.3104,2.9448,1.3104,5.3052,0,0.4188-0.198,0.7164-0.2916,1.0812-0.0516-0.1356-0.5004-1.3668-0.5004-1.3668l-0.3888,0.9876c-0.018,0.0552-0.5256,1.3836,0.3816,2.8824,1.2,1.9776,4.1868,3.2436,8.8836,3.7584h-0.002c0,0.004,0.0588,0.0552,0.066,0.0648-0.1944,0.0264-0.3408,0.0804-0.3852,0.1224l-0.1884,0.1596,0.0252,0.4008c0.1212,0.4872,0.678,0.5112,1.7832,0.5532,0.1872,0.0108,0.4908,0.0552,0.7056,0.066,0.2748,0.0768,0.5568,0.1536,0.5568,0.1536s-0.0768-0.0888-0.0936-0.108c1.0704,0.0732,2.274,0.3372,3.5808,0.8256-0.2892,0.0756-0.9948,0.252-0.9948,0.252l1.1616,0.4584c0.0876,0.0348,8.6484,3.474,12.191,6.3024-1.0056,0.8724-5.2992,4.08-12.736,2.2476l-1.2456-0.306,0.8448,0.9648c0.0516,0.0576,4.896,5.6136,5.9004,8.9832-1.6872,0.0168-8.1852-0.042-10.456-1.9716l-0.588,0.5352c0.0312,0.0492,3.1152,4.5756,3.804,8.1048-0.8832,0.1164-3,0.2028-4.2516-1.4328l-0.5772-0.7512s-0.2328,1.5168-0.3132,2.0376c-0.6048-0.456-1.3668-1.1376-1.3668-1.8672v-0.48s-1.5924,0.2892-1.8324,0.3324c-0.2124-0.1272-2.85-1.728-3.7656-2.2824-0.324-0.21-0.5352-0.33-0.6048-0.3648-0.004-0.004-0.0348-0.0228-0.0348-0.0228l-0.0276-0.0156-0.39,0.7056s0.4488,0.2676,0.5772,0.348c0.8064,0.5256,2.1864,1.6704,2.3256,3.1884-0.5952,0.0348-2.448,0.1356-2.448,0.1356l0.0456,0.426v0.0672c0,0.252-0.0792,1.3044-0.8484,3.6792-1.158-0.276-5.3688-1.7436-7.8576-8.874l-0.7752,0.192c0.004,0.0192,0.0132,0.114,0.0132,0.2652,0,0.6492-0.2292,2.2788-2.4648,2.8596-0.0132,0.004-4.1508,1.248-6.4524,1.9368,0.4308-0.6156,0.8244-1.4604,0.8244-2.6844,0-0.2604-0.0168-0.54-0.0516-0.8376-0.1392-1.0356-0.2232-1.8984-0.2232-2.6184,0-1.5012,0.3684-2.3952,1.4052-3.0312l-0.3612-0.7164c-0.0972,0.0384-9.618,3.8196-14.339,2.25,0.216-0.9216,1.0152-4.1616,2.628-7.6152l-0.2088,0.198c0.3096-0.132,0.6252-0.6156,0.3648-2.166l-0.0864-0.528-0.4836,0.2328c-0.0312,0.0144-3.0528,1.3632-7.4172-0.2364,0.0888-0.3576,0.3204-1.0008,1.2348-1.38l0.2676-0.108-0.0252-0.2916c0-0.0108-0.0108-0.2136-0.0108-0.5316,0-1.1784,0.1848-3.9396,1.8804-4.602l-0.18-0.7764c-0.0552,0.007-5.1612,0.4152-8.2572-1.3068,0.8124-0.5604,2.5188-1.5924,4.5048-1.878l0.318-0.0456,0.0228-0.318c0.004-0.0156,0.0108-0.1092,0.0108-0.2592,0-0.4032-0.156-1.2192-0.5112-2.0412,1.1784,0.3288,2.5908,0.6252,3.0912,0.2496l0.1704-0.1284-0.1464-3.0984-0.8028,0.0384s0.0972,2.0544,0.1224,2.562c-0.504,0.0276-1.788-0.2292-3.0348-0.6252l-1.2336-0.3924,0.7944,1.0236c0.6456,0.8292,0.7272,1.8588,0.7368,2.3316-2.79,0.5184-4.9752,2.2512-5.0688,2.3292l-0.4104,0.3372,0.4344,0.3036c2.4,1.6716,6.1536,1.8168,8.0808,1.7748-1.1364,1.2792-1.3284,3.4212-1.3284,4.4916,0,0.2196,0.007,0.2784,0.0108,0.3864-1.3632,0.7356-1.5684,2.118-1.5768,2.1816l-0.03,0.3012,0.282,0.1152c4.1244,1.644,6.9408,0.8508,7.8972,0.4968,0.007,0.1284,0.0348,0.3024,0.0348,0.3936,0,0.378-0.0696,0.4932-0.0696,0.4932-2.0268,4.248-2.8752,8.286-2.886,8.3244l-0.066,0.3336,0.3132,0.1248c3.828,1.53,10.705-0.5592,13.751-1.6344-0.3996,0.6888-0.6324,1.464-0.6324,2.4288,0,0.8088,0.0972,1.7184,0.2328,2.7312,0.0348,0.2568,0.0492,0.4944,0.0492,0.7236,0,2.28-1.5408,3.1428-1.614,3.1812l0.306,0.7404,7.9548-2.3892c1.8396-0.4776,2.5308-1.5648,2.8236-2.4888,3.1392,7.4436,8.0664,8.1144,8.2848,8.1396l0.3204,0.0276,0.1008-0.3024c0.7656-2.2872,0.942-3.4488,0.9768-4.0092,0.5316-0.024,2.4624-0.132,2.4624-0.132l0.0204-0.3612c0.004-0.0624,0.004-0.1224,0.004-0.1812,0-0.6588-0.2052-1.2408-0.4896-1.764,0.4968,0.3,1.3764,0.834,1.3764,0.834s0.9108-0.1656,1.3176-0.24c0.3444,1.3296,1.9236,2.3736,2.1276,2.4984l0.5112,0.3072s0.1884-1.212,0.2676-1.74c1.9644,1.758,4.7532,1.2348,4.8852,1.2024l0.3516-0.09-0.0516-0.3576c-0.3996-2.688-2.2044-5.886-3.2652-7.596,3.4908,1.5876,9.8496,1.4712,10.163,1.4616l0.474-0.0168-0.0936-0.4644c-0.564-2.8248-4.0932-7.272-5.5704-9.0408,8.202,1.542,12.607-2.7132,12.796-2.9064l0.288-0.306-0.3168-0.2784c-2.7576-2.4012-9.1128-5.19-11.665-6.2568,0.1392-0.0348,0.894-0.2256,0.894-0.2256l-0.8832-0.4944c-2.1348-1.2-4.398-1.3488-5.928-1.4148l-0.007-0.012c-0.9708-1.1112-1.464-1.2888-1.5888-1.3164-5.5464-0.612-7.5792-2.166-8.3172-3.366-0.0624-0.0984-0.0312-0.1656-0.0768-0.2616,0.1188-0.1596,0.2436-0.318,0.2436-0.318,0.5352-0.6972,0.726-1.6296,0.726-2.6172,0-2.5464-1.2936-5.4564-1.3668-5.6244l-0.738,0.3336z'/%3E %3Cpath d='m836.8,167.86c-0.0168,0.0792-0.6084,3.1188-3.1956,4.5432-1.9476,1.0704-4.5204,0.9816-7.6392-0.2664l-0.3516-0.1392,0.0372,0.3756c0.008,0.078,0.2136,1.8636,1.8972,3.1716,1.4016,1.092,3.408,1.4748,5.922,1.2-0.8412,0.9984-3.5436,4.452-3.5436,7.8024,0,0.1764,0.0108,0.354,0.0276,0.528,0.3444,0.2472,4.5792,1.3944,6.5436-1.116,0.0696,1.0764,0.3792,4.5216,1.7244,5.8692,0.7368,0.7332,0.9108,1.8048,0.9108,2.6604,0,0.7716-0.1464,1.3668-0.1464,1.3788l-0.1524,0.6132,0.5112-0.372c0.1632-0.1188,4.0572-2.9712,5.3016-6.7068-0.004,0.01,0.6228-0.9372,1.8252-1.3248-0.0252,0.1632-0.0456,0.33-0.0456,0.5628,0,1.4436,0.6324,4.0644,4.836,5.6712l0.3444,0.132-0.0312-0.3672c-0.004-0.008-0.0276-0.2964-0.0276-0.726,0-1.0548,0.1464-2.9928,1.1508-3.9972,0.6612-0.66,0.8592-1.404,0.8592-2.0484,0-0.5076-0.1116-0.918-0.2256-1.2204,0.8484,0.2148,2.8548,0.8616,3.672,2.3904,1.1856,2.2224,5.3376,0.4536,5.5152,0.3792l-0.1428-0.4368c-0.0168,0.004-1.746,0.3912-2.8368-0.3576-0.48-0.33-0.768-0.8376-0.8688-1.5108l-0.192-2.31c-0.042-1.0464-0.1872-1.7112-0.7128-2.2704,0.5496-0.0504,1.6512-0.0312,2.118,1.0008,0.7332,1.6164,3.2508,1.7736,3.3552,1.782l0.8616,0.0456-0.7236-0.468c-0.024-0.0144-2.1972-1.4568-1.8216-3.336l0.3132-1.3764c0.5952-2.4804,1.5852-6.6324,0.7788-9.1812l-0.438,0.1404c0.1992,0.636,0.282,1.3896,0.282,2.196,0,2.2596-0.6396,4.944-1.0716,6.738l-0.3168,1.3944c-0.0384,0.1812-0.0516,0.3648-0.0516,0.5388,0,1.2168,0.7896,2.1456,1.4052,2.7048-0.7404-0.1596-1.7664-0.5124-2.1516-1.3704-0.6048-1.326-2.2284-1.3872-3.0036-1.23l-0.5424,0.1092,0.462,0.3072c0.7296,0.4872,0.7512,1.0536,0.8028,2.2932l0.1944,2.358c0.1152,0.804,0.4728,1.4184,1.0608,1.824,0.5148,0.3504,1.116,0.3996,1.6656,0.4392-1.2336,0.3216-2.9244,0.522-3.5316-0.6192-1.1448-2.1324-4.2912-2.7024-4.4232-2.7276l-0.48-0.0828,0.24,0.4212c0.0252,0.0456,0.3576,0.6516,0.3576,1.422,0,0.546-0.1668,1.1712-0.7332,1.7352-1.116,1.1256-1.2864,3.1668-1.2864,4.296,0,0.2208,0.0108,0.252,0.0144,0.3864-3.5952-1.5108-4.2312-3.7488-4.2312-5.016,0-0.5388,0.1044-0.8976,0.1188-0.9444l0.1044-0.354-0.36481,0.0612c-1.746,0.288-2.472,1.71-2.5032,1.77-0.9984,2.9916-3.7092,5.3592-4.6908,6.1488,0.0312-0.2496,0.066-0.5412,0.066-0.8952,0-0.9348-0.2016-2.1264-1.05-2.976-1.4292-1.4292-1.6236-5.9736-1.6236-6.0192l-0.0312-0.8208-0.3996,0.7128c-1.5816,2.8332-6.1992,1.4724-6.2448,1.4604-0.1944-3.5796,3.8664-8.16,3.9084-8.2068l0.4248-0.4716-0.6264,0.0924c-2.652,0.384-4.7112,0.0288-6.1224-1.0608-1.1052-0.8568-1.5024-1.9476-1.644-2.4984,3.0756,1.146,5.6556,1.2096,7.6416,0.1128,2.7744-1.5336,3.3828-4.6752,3.4068-4.8072,2.9136-6.606,5.4588-7.6488,5.4864-7.656l-0.1596-0.4308c-0.1152,0.0396-2.7396,1.0728-5.7684,7.95z'/%3E %3Cpath d='m843.45,158.07-0.1944,0.007-2.364,3.24,0.702,0.0696c12.829,1.248,19.613,8.988,19.679,9.0684l0.2964,0.3444,2.3256-2.5272-0.1704-0.2604c-6.5052-10.244-20.135-9.9468-20.274-9.942zm0.2196,0.804c1.5852,0.004,13.271,0.3648,19.189,9.3312-0.2892,0.3132-0.9348,1.0188-1.2792,1.3968-1.3872-1.4376-7.962-7.5816-19.237-8.9064,0.4368-0.6012,1.164-1.5984,1.3272-1.8216z'/%3E %3Cpath d='m841.6,164.84c-1.0956,1.4952-2.1144,3.7068-2.1144,4.7424,0,0.198,0.0384,0.354,0.1224,0.4524,0.007,0.01,0.0456,0.0132,0.0588,0.0288-1.3356,1.1976-2.1312,3.1968-2.1312,5.4564,0,1.2432,0.2196,2.538,0.6816,3.7728l0.2568,0.6948c1.2588,3.4248,2.3436,6.384,7.788,4.6416,5.244-1.6752,5.4492-2.0112,6.7704-4.1892l0.3444-0.564c0.72-1.17,1.506-1.404,2.3436-1.6524,0.9984-0.3,2.034-0.6072,2.9412-2.4l0.8832-1.3236c0.9528-1.3128,2.142-2.94,2.2848-5.0232l-0.4596-0.0312c-0.132,1.95-1.2792,3.5184-2.1972,4.7808l-0.9216,1.3872c-0.8208,1.6164-1.7148,1.884-2.664,2.1672-0.8832,0.2628-1.7904,0.534-2.604,1.8528l-0.348,0.5664c-1.2696,2.0964-1.4316,2.3664-6.5124,3.9936-5.0268,1.6068-5.946-0.9-7.218-4.3632l-0.2568-0.702c-1.4328-3.8184-0.3132-7.6692,1.5504-9.0492l0.6396-0.4752s-0.7932,0.0888-0.8868,0.1008c-0.01-0.0384-0.0204-0.072-0.0204-0.132,0-0.624,0.6816-2.6112,2.0376-4.464,1.158-1.578,3.8904-3.1416,3.9192-3.1572l-0.2292-0.3984c-0.1152,0.0684-2.8452,1.6296-4.0584,3.2868z'/%3E %3Cpath d='m839.16,178.65c0.9,0.624,2.166,0.5808,3.6924,0,0.007,0.5436,0.1284,1.6992,1.0776,2.538,1.116,0.9876,2.9652,1.1784,5.4996,0.5736l-0.108-0.4452c-2.3748,0.5664-4.0884,0.4068-5.0868-0.4692-1.0716-0.9456-0.9216-2.4504-0.918-2.4636l0.042-0.3936-0.3648,0.1548c-1.5372,0.6624-2.7396,0.702-3.5748,0.1248-1.4952-1.0392-1.3836-3.7548-1.38-3.786l-0.4596-0.0216c-0.002,0.1236-0.1272,3.0024,1.5804,4.188z'/%3E %3Cpath d='m842.07,174.99c-0.6564,0.156-0.8268,0.7056-0.8268,1.1304,0,0.102,0.0108,0.1968,0.024,0.2784,0.1152,1.182,1.398,1.9692,2.5632,2.3064,1.1328,0.3276,2.5272,0.3492,3.0768-0.3564,0.2196-0.282,0.3792-0.7896-0.1008-1.6104-1.7496-2.976-4.5804-1.8108-4.7364-1.7484zm1.8876,3.2712c-1.0188-0.2916-2.142-0.9528-2.232-1.9332-0.0216-0.0936-0.132-0.7524,0.4488-0.8904l0.0456-0.0144c0.1044-0.0468,2.6112-1.1364,4.1904,1.5504,0.2808,0.4788,0.3264,0.8448,0.132,1.092-0.3384,0.4404-1.4544,0.5268-2.5848,0.1956zm-1.9332-3.2544c0.004-0.004,0.0456-0.018,0.0456-0.018l-0.0456,0.018z'/%3E %3Cpath d='m843.65,180.98c-0.2952,2.514-0.1152,2.574,0.066,2.6304l0.1596,0.0504,0.18-0.2124,1.4568-1.92-1.8288-0.8664-0.0336,0.318zm0.4212,0.3756c0.2604,0.1224,0.5004,0.2364,0.7368,0.348-0.198,0.2532-0.5664,0.744-0.8448,1.1112,0.007-0.3792,0.0528-0.9132,0.108-1.4592z'/%3E %3Cpath d='m839.86,178.96-0.0972,2.376,1.9956-2.4132-1.8876-0.2088-0.0108,0.246zm0.4488,0.2664c0.1764,0.0204,0.3024,0.0312,0.552,0.0588-0.1944,0.234-0.324,0.3924-0.5844,0.7068,0.0192-0.3696,0.0264-0.5748,0.0324-0.7656z'/%3E %3Cpath d='m838.53,178.2c0.0168,0.0312,1.4844,2.9004,1.7448,3.9468,0.1668,0.6648,1.0152,1.422,2.0268,1.7976,1.008,0.3792,1.9536,0.318,2.6592-0.174l1.3248-1.1016c0.4416-0.4248,0.588-0.5436,0.9456-0.4824l0.0768-0.4536c-0.6012-0.1008-0.894,0.1788-1.3392,0.6036l-1.2696,1.0572c-0.7824,0.546-1.7388,0.3132-2.2392,0.1212-0.9456-0.3504-1.6308-1.0284-1.7424-1.4808-0.2748-1.0944-1.7208-3.9192-1.7796-4.0404l-0.408,0.2064z'/%3E %3Cpath d='m840.44,169.6c-1.62,0.7476-2.3052,2.7132-2.3328,2.796l0.4344,0.1512c0.007-0.0192,0.654-1.8696,2.0928-2.5308,0.702-0.3216,1.488-0.3108,2.3436,0.0252l0.1704-0.4248c-0.9732-0.3924-1.884-0.396-2.7084-0.0168z'/%3E %3Cpath d='m851.33,174.76c0.1284,0.096,3.1884,2.4144,1.4292,5.2428l0.39,0.2436c1.9848-3.1884-1.5132-5.8308-1.5444-5.8584l-0.2748,0.372z'/%3E %3Cpath d='m842.13,175.21s-0.4764,1.7292,1.9572,2.34c0,0-2.2884-0.0192-2.4336-0.6108-0.1536-0.5904,0.0132-1.8996,0.4764-1.7292z'/%3E %3Cpath d='m849.57,177.28c0,0.15-0.1224,0.2736-0.2712,0.2736-0.1464,0-0.2712-0.1236-0.2712-0.2736,0-0.1476,0.1248-0.2712,0.2712-0.2712,0.15,0,0.2712,0.1236,0.2712,0.2712z'/%3E %3Cpath d='m849.84,178.36c0,0.15-0.1224,0.2748-0.2712,0.2748s-0.2676-0.1248-0.2676-0.2748c0-0.1464,0.1188-0.27,0.2676-0.27s0.2712,0.1248,0.2712,0.27z'/%3E %3Ccircle cx='848.01' cy='177.825' r='0.27'/%3E %3Cpath d='m848.75,179.45c0,0.1464-0.1224,0.2676-0.2712,0.2676-0.1464,0-0.2676-0.1212-0.2676-0.2676,0-0.1512,0.1224-0.2748,0.2676-0.2748,0.1488,0,0.2712,0.1224,0.2712,0.2748z'/%3E %3Cpath d='m841.65,172.13c0,0.15-0.1212,0.2724-0.2748,0.2724-0.1464,0-0.2712-0.1236-0.2712-0.2724,0-0.1464,0.1248-0.2712,0.2712-0.2712,0.1536,0,0.2748,0.1248,0.2748,0.2712z'/%3E %3Ccircle cx='841.65' cy='173.22' r='0.27'/%3E %3Ccircle cx='840.09' cy='172.68' r='0.27'/%3E %3Cpath d='m840.83,174.3c0,0.1464-0.1248,0.2712-0.2748,0.2712-0.1464,0-0.2676-0.1248-0.2676-0.2712,0-0.1512,0.1224-0.2748,0.2676-0.2748,0.1488,0.001,0.2748,0.1236,0.2748,0.2748z'/%3E %3Cpath d='m845.57,164.75s3.5184,2.1648,0.132,6.228c0,0,1.6656-1.2372,1.836-3.3624,0.1776-2.1228-1.2072-3.816-1.968-2.8656z'/%3E %3Cpath d='m859.07,170.59c-1.1328,0.582-2.7636-0.4956-3.5808-1.5144-0.8136-1.0188-2.4996-1.2792-3.5496,0.5808-1.0476,1.8636-2.5596,2.562-2.5596,2.562s1.4772-0.8724,2.9976-2.5032c1.512-1.6272,2.3856-0.3204,3.87,0.4656s1.7172,0.9588,2.7636,0.552l0.0588-0.1428z'/%3E %3Cpath d='m858.78,170.86c-0.4632,0.348-1.3116,0.6396-2.2116-0.09-0.9-0.7272-1.6584-1.7148-2.7924-1.134-1.1376,0.5844-3.2928,2.2116-3.2928,2.2116s3.4944-2.4168,4.1652-1.8912c0.6672,0.5256,2.2428,1.8048,3.2016,1.4292,0.9612-0.3828,0.93-0.5256,0.93-0.5256z'/%3E %3Cpath d='m856.1,172.34c-1.1052-0.8436-2.2116,0.9888-3.1428,0.7596-0.9312-0.2364-1.6896-1.7784-1.6896-1.7784s0.876,1.6308,2.0964,1.2516c1.224-0.3768,2.0688-1.1352,2.8236-0.5544,0.7572,0.5844-0.0876,0.3216-0.0876,0.3216z'/%3E %3Cpath d='m854.37,172.57c-2.1828,0.2256-2.3988-1.8132-2.3988-1.8336,0,0,0.6888,1.7796,2.6184,1.4568l-0.2196,0.3768z'/%3E %3Cpath d='m854.3,171.18c0.1428,0.552,0.1116,0.8028-0.4728,0.8028-0.588,0-0.9876-0.1956-0.9876-0.7656,0-0.5712,1.374-0.3924,1.4604-0.0372z'/%3E %3Cpath d='m846.46,168.15c0,0.3792-0.3132,0.6852-0.6996,0.6852s-0.462-0.2604-0.462-0.636,0.0756-0.7296,0.462-0.7296,0.6996,0.306,0.6996,0.6804z'/%3E %3Cpath d='m844.05,165.71s3.7404,0.0396,1.8876,4.7196c0,0,1.4256-2.3292,0.5316-4.0056-0.8976-1.674-2.3052-1.2516-2.3052-1.2516s-0.3432,0.3168-0.114,0.5376z'/%3E %3Cpath d='m843.94,167.58c-0.0108,0.9384,0.6156,1.9068,1.8564,2.8764l0.2856-0.36c-1.1232-0.876-1.6896-1.7208-1.6824-2.5068,0.007-0.786,0.612-1.2528,0.6192-1.2588l-0.2748-0.3708c-0.0324,0.0264-0.7908,0.6036-0.804,1.62z'/%3E %3Cpath d='m844.77,168.37c0.1596,0.5388,0.5772,0.9456,1.2444,1.212l0.1704-0.4248c-0.528-0.21-0.8556-0.5184-0.9732-0.9132-0.2364-0.7956,0.4032-1.7244,0.4104-1.7316l-0.372-0.2676c-0.036,0.048-0.7788,1.1208-0.48,2.1252z'/%3E %3Cpath d='m849.9,170.97s0.696,1.512-0.3204,3.1428c-1.0188,1.6308-0.9912,1.5444-0.9912,1.5444s1.224-2.2416,0.7584-3.1752c-0.462-0.9312,0.5532-1.512,0.5532-1.512z'/%3E %3Cpath d='m864.45,186.76c3.8424,0.7236,12.51,7.5204,12.6,7.59l0.498-0.636c-0.3648-0.282-8.9148-6.9852-12.948-7.7436l-0.15,0.7896z'/%3E %3Cpath d='m867.86,196.35c0.2568,3.4092,3.9672,5.5284,4.1268,5.6136l0.3924-0.6996c-0.0384-0.018-3.4908-1.9956-3.72-4.9752l-0.7992,0.0612z'/%3E %3Cpath d='m858.65,197.06c0,3.8244,3.5844,8.4504,3.738,8.6472l0.6324-0.4968c-0.0348-0.0432-3.5676-4.602-3.5676-8.1504h-0.8028z'/%3E %3Cpath d='m846.5,197.49c0.6324,1.2624,0.5664,1.902,0.4032,2.2152-0.1908,0.3528-0.5808,0.4068-0.594,0.4104l0.0936,0.8004c0.2952-0.0348,0.8868-0.24,1.2-0.816,0.3828-0.7008,0.2532-1.6992-0.3828-2.964l-0.72,0.354z'/%3E %3C/g%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='0.36'%3E %3Cpath d='m791.86,178.63s0.2328,2.5596,2.2116,4.0788c0,0-0.2328-2.7996,0.3504-3.96,0-0.001-1.0464-1.1652-2.562-0.1188z'/%3E %3Cpath d='m795.81,180.26s0.468,2.3256,1.8648,3.3756l0.8196-0.2328s0.348-2.9136,0.8136-3.2616c0.4656-0.3468-1.9788,1.0476-3.498,0.1188z'/%3E %3Cpath d='m799.31,180.14,1.5132,2.3292,1.7448-0.9312-0.348-2.7924s-1.0464-0.2364-2.91,1.3944z'/%3E %3Cpath d='m806.41,180.61-1.98,1.6308s-1.0464-0.8172-1.8636-0.6996l0.3516-2.562s1.3968-1.0476,3.492,1.6308z'/%3E %3Cpath d='m792.32,204.71s-0.348-3.6096,0.1188-3.8424c0,0,1.3944,0.4656,1.9776-0.1188,0,0,0.816,2.9136,0.582,4.0776-0.2316,1.1628-1.6284,0.7008-2.6784-0.1164z'/%3E %3Cpath d='m801.29,200.98s-0.1152-3.0276,0.4656-3.3792c0,0,2.91,0.3504,3.6084-1.1616l1.0488,2.91s-3.2604-0.3504-5.1228,1.6308z'/%3E %3Cpath stroke-width='0.35' d='m798.15,201.56s0.5808-3.1428,1.1652-3.2592c0,0,1.5132,0.4644,1.9788-0.12l-0.1152,3.846c0-0.001,0.1152-1.632-3.0288-0.4668z'/%3E %3Cpath stroke-width='0.35' d='m794.77,202.03s0.6984-2.7948,1.1652-2.7948c0.468,0,1.632,0.6984,2.2128,0.2328v2.0964s-2.5656-0.5808-2.9112,2.91l-0.4668-2.4444z'/%3E %3C/g%3E %3C/g%3E %3Cg id='sugarcanes' fill='%2300a651' stroke='%23000' stroke-width='0.78'%3E %3Cpath d='m840.16,260s7.914,7.35,5.8452,13.758c0,0,5.0868-10.932-0.3756-14.137-5.4696-3.2028-5.6568-0.7476-5.4696,0.3792z'/%3E %3Cpath fill='%23964b36' d='m830.17,267.15s-2.07,2.8332,0.1884,4.9056c0,0-2.448,3.5748-0.5604,6.5952,0,0-1.5108,3.2028-1.1328,6.5964,0,0-1.3212,5.2752,1.5048,7.7292,0,0,3.018,1.5084,4.3392,0.1884,0,0,2.6364-3.9564,0.9384-8.1084,0,0,1.8852-3.39-0.1872-7.7256,0,0,0.5664-2.4504-1.1304-5.274,0,0,1.1304-1.8876,0.186-3.3936,0,0-3.7668-3.9612-4.146-1.5132z'/%3E %3Cpath d='m832.43,257.92s-9.4224-18.09-16.02-18.848c-6.5976-0.7548-6.972-7.1604-6.972-7.1604s0.7524,3.0156,6.0312,3.0156c5.2776,0,15.456,7.3488,16.585,13.003,1.1292,5.6532,2.2632,4.902,2.2632,4.902l-1.8876,5.088z'/%3E %3Cpath d='m832.43,256.6s3.3936-22.805,18.286-23.184c14.885-0.3792,9.9888,1.1304,13.567-1.3212,0,0-9.9852,5.2812-16.208,6.0324-6.2172,0.7536-11.308,12.812-11.119,15.079,0.1872,2.2596-3.3912,6.5964-5.088,5.0904-1.6968-1.5084,0.5628-1.6968,0.5628-1.6968z'/%3E %3Cpath d='m835.82,265.09s3.3912-9.0468,9.2352-6.0288c0,0-4.5264-8.6736-12.629-1.134,0,0,3.582,4.8996,3.3936,7.1628z'/%3E %3Cpath d='m824.51,256.03s4.902,20.17-2.6388,26.387c0,0,0.1872-10.361-4.3356-16.582-4.5204-6.2232,4.5228-13.003,6.9744-9.8052z'/%3E %3Cpath d='m825.08,259.62s8.8608,8.484,9.4272,11.31c0.5664,2.8272,2.6364-8.4804-1.5084-11.682-4.1472-3.2088-8.67-3.7728-8.67-3.7728l0.7512,4.1448z'/%3E %3Cpath fill='%23964b36' d='m808.74,281.85s0.8028,3.5604,2.988,4.2492c0,0,0.1128,2.646,2.0676,3.4488,0,0-1.0368,2.184,0.6912,3.5604,0,0-0.348,4.3668,1.2624,5.2884,0,0,3.9108-0.2292,5.2848-1.38,0,0,0.8064-2.868-1.374-5.7468,0,0,0.3408-2.7576-1.8432-4.2492,0,0,0.69-3.6816-2.0688-5.058,0,0-0.4572-2.9904-2.184-4.482,0.001-0.001-3.33,4.71-4.824,4.3692z'/%3E %3Cpath d='m813.1,277.48s-11.606-4.2516-18.042,1.8396c0,0,9.8808,1.38,11.147,3.3336,1.2636,1.95,7.3524-3.216,6.8952-5.1732z'/%3E %3Cpath d='m809.54,284.72s-0.918-0.8028-2.0664-1.6092c-1.1496-0.8028-10.916-3.4464-12.299,5.976,0,0-3.564-9.3072,1.608-10.573,5.1756-1.266,9.312,1.7244,12.757,6.2064'/%3E %3Cpath d='m801.9,265.46s3.5772,7.7256,4.8996,8.1084c1.3188,0.372,2.2596-0.942,2.2596-0.942s-4.71-6.9744-7.1592-7.1664z'/%3E %3Cpath d='m799.26,253.59s-3.018-9.9876-6.5964-7.35c-3.5808,2.6388-2.6388,9.798-2.6388,9.798s-7.1628-7.3464-3.018-13.192c4.152-5.8416,12.253,0.5664,12.253,10.744z'/%3E %3Cpath fill='%23964b36' d='m807.37,274.13s0,1.8852,1.32,2.448c1.32,0.5664,3.7692,1.5048,3.7692,0.3792,0-1.1304-1.8828-5.466-2.6412-4.8996-0.7548,0.5676-2.0688,0.5604-2.448,2.0724z'/%3E %3Cpath d='m805.11,262.45s-0.3768-8.6676,5.274-11.876c0,0,1.134,0.1944,1.7004-1.5012,0,0-4.5288,10.927-3.2076,16.393l-0.1872,0.7548'/%3E %3Cpath d='m806.24,251.89s10.177-21.112,22.618-13.762c0,0-13.004,2.64-17.714,11.876l-4.7148,6.9672-0.1884-5.082z'/%3E %3Cpath d='m800.77,259.62s-3.0168-14.134-4.9008-16.016c-1.8864-1.8864-5.0904-3.9588-8.8608-0.756,0,0,6.5988-5.8452,13.572-0.942,6.9708,4.9008,5.4636,12.628,5.4636,12.628l-0.7512,9.8016-4.7124-4.3356'/%3E %3Cpath d='m811.7,276.39s-12.44-23.552-20.542-6.78c0,0-1.512,4.332,0.1836,6.0252,0,0-4.524-3.39-2.4492-11.682,2.07-8.2896,15.828-4.524,19.79,2.2632,3.9564,6.7836,5.0904,10.18,4.524,10.552-0.5676,0.3792-1.5072-0.378-1.5072-0.378z'/%3E %3Cpath d='m846.76,283.18s9.0504-18.66,14.324-10.18c0,0,1.506,4.1448-0.7572,5.8452,0,0-3.5772-4.3356-6.78,0.942-3.2052,5.2752-1.8852,4.902-1.8852,4.902s-3.3936,0.942-4.902-1.5096z'/%3E %3Cpath d='m860.32,278.84s4.8996,2.6352,3.2088,7.9128c0,0,6.5916-12.625-2.4516-13.758,0.001,0,1.698,3.96-0.7572,5.8452z'/%3E %3Cpath d='m860.89,266.03s11.876,3.39,12.252,8.484c0,0,2.076-9.8052-4.7112-12.82,0.001,0.001-8.1072,1.3224-7.5408,4.3356z'/%3E %3Cpath d='m866.17,250.38c5.0904-9.9888,11.498,3.204,11.498,3.204s2.2596-10.364-4.1448-12.252c-6.4116-1.884-10.556,22.05-10.556,22.05l-7.5408,1.6968s2.0748-20.917,13.382-22.805l1.3176,0.1908'/%3E %3Cpath d='m857.12,256.41s-7.1592-14.7-12.061-16.206c-4.902-1.5084,2.6424-3.7704,5.6568-0.9444,3.0108,2.8248,8.6652,6.408,8.1012,13.948l-1.6968,3.2028z'/%3E %3Cpath d='m849.77,276.58s2.0724-9.9852,7.7256-13.003c5.6532-3.018,10.932-1.884,10.932-1.884s-6.7872,1.5048-7.914,4.902c-1.1328,3.39-3.018,3.5772-3.018,3.5772l-7.7256,6.408z'/%3E %3Cpath fill='%23964b36' d='m846.76,283.18s-3.2028,6.0324-2.4516,6.972c0,0-3.39,4.8996-2.0724,7.35,0,0,3.3936,2.6388,4.902,1.506,0,0,3.9528-5.4624,2.8236-8.4804,0,0,2.6388-3.5772,1.7004-5.838,0,0-3.9564,0.1872-4.902-1.5096z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m830.18,272.41c0.2124,0.108,2.1156,1.032,3.396,0.6048l0.9156-0.7824-0.72-0.3576c-0.4692,0.9312-2.5416,0.1632-3.234-0.18l-0.3576,0.7152z'/%3E %3Cpath d='m829.87,278.26-0.156,0.7896c0.162,0.0312,3.9864,0.7716,5.8104-0.8484l-0.5352-0.5988c-1.524,1.3524-5.0808,0.6684-5.1192,0.6576z'/%3E %3Cpath d='m828.9,284.92-0.4716,0.6504c0.0456,0.0348,4.4892,3.1992,7.3332-0.2568l-0.6228-0.5112c-2.3616,2.868-6.0804,0.2328-6.2388,0.1176z'/%3E %3Cpath d='m811.64,285.88,0.1668,0.4308c0.1596-0.066,3.9252-1.578,4.164-4.332l-0.4572-0.042c-0.2148,2.472-3.8376,3.9288-3.8736,3.9432z'/%3E %3Cpath d='m813.77,289.32,0.0324,0.4584c0.1464-0.0108,3.6228-0.2712,4.23-2.7012l-0.4488-0.1152c-0.5232,2.1072-3.78,2.3544-3.8136,2.358z'/%3E %3Cpath d='m814.49,292.88-0.0252,0.462c0.1668,0.007,4.0608,0.2088,5.382-1.9476l-0.3924-0.2436c-1.1796,1.9272-4.926,1.7328-4.9644,1.7292z'/%3E %3Cpath d='m844.02,290.44c0.0696,0.0732,1.7484,1.7316,3.7092,1.6584,0.96-0.0348,1.812-0.4764,2.5308-1.3032l-0.6084-0.528c-0.5664,0.6528-1.224,1.0008-1.9476,1.0284-1.6056,0.0588-3.1044-1.4076-3.1188-1.4256l-0.5652,0.57z'/%3E %3C/g%3E %3C/g%3E %3Cg id='palm'%3E %3Cg fill='%23964b36' stroke='%23000' stroke-width='0.42'%3E %3Cpath d='m961.06,304.22c-0.2088,0.0804-0.4176,0.2052-0.6084,0.4032l0.6084-0.4032z'/%3E %3Cpath d='m974.92,300.75c-0.1344-0.3444-0.222-0.1992-0.3996-0.3516-0.2532-0.2088-0.3996-0.876-0.6228-1.1256-0.132-0.1524-0.2844-0.004-0.4272-0.042-0.324-0.7128-0.7056-1.464-1.0464-2.1516,0.0528-0.0792,0.0864-0.174,0.0936-0.3204,0-0.0276-0.1596-0.5772-0.1704-0.6012-0.0972-0.1524-0.2508-0.0624-0.3444-0.2988-0.1044-0.2364-0.0252-0.702-0.0624-0.9804-0.0276-0.2328-0.1188-0.3612-0.1044-0.6888,0.0144-0.2844,0.1668-0.6156,0.1488-0.8652-0.007-0.156-0.1908-0.5076-0.246-0.6396-0.2232-0.5388-0.4104-1.0464-0.438-1.7112-0.0276-0.6012,0.0936-0.9696,0.138-1.4916,0.0564-0.62521-0.2748-0.92881-0.2748-1.506,0.004-0.4416,0.1908-0.9384,0.2436-1.3344,0.0732-0.5424,0.0792-1.3284,0.0336-1.884-0.0408-0.5316-0.1908-0.852-0.108-1.4496,0.0216-0.1464,0.0912-0.264,0.108-0.4692-0.004-0.1464-0.004-0.288-0.004-0.4308v-0.858c0-0.2784,0.0276-0.5916,0.004-0.8628-0.024-0.2256-0.156-0.4584-0.156-0.636,0-0.306,0.1944-0.4512,0.1524-0.8664-0.0264-0.2988-0.0696-0.3684-0.138-0.6288-0.132-0.4932-0.042-0.9912-0.1224-1.5192-0.0384-0.2532-0.1188-0.3336-0.1428-0.6228-0.0336-0.3408,0.0708-0.4584,0.1044-0.6996,0.0348-0.24,0.0708-0.5556,0.0384-0.81-0.0384-0.306-0.1836-0.522-0.1428-0.8556l-0.1116,3.7824c-0.0936-3.3-0.2256-6.3552-0.2256-6.3552l-5.0184-2.3568s-0.4248,9.2136-0.3168,10.496c0.1008,1.2864,0.5316,10.076,0.3168,11.147-0.216,1.0716-0.744,6.4284-0.744,6.4284s-2.454,1.7148-3.414,3.6408c-0.9636,1.9296-0.7476,2.5728-1.0716,2.5728l2.3844-0.372-1.776,1.1856c0.366-0.13801,0.7512-0.108,1.1064,0.1716,0.0408,0.0336,0.306,0.2604,0.3396,0.2604,0.0936,0,0.2232-0.2388,0.3372-0.2808,0.3696-0.1248,0.6816,0.5676,1.032,0.5148,0.1884-0.0276,0.4452-0.2256,0.5988-0.4272,0.1272-0.1704,0.1764-0.46921,0.3096-0.58321,0.1224-0.1044,0.4212,0.0168,0.5496,0.0168,0.3504,0,0.7056,0.0108,1.056,0,0.4668-0.0132,0.8448-0.6708,1.2756-1.0428,0.4008-0.3372,0.696-0.456,1.1244-0.4308,0.4692,0.0348,0.8928,0.4728,1.3704,0.5004,0.3612,0.018,0.612,0.0624,0.9036-0.3168,0.2016-0.264,0.3444-0.6564,0.5352-0.9312l1.1856-0.1836c0.2352,0.0972,0.4752,0.2052,0.6768,0.198,0.3024-0.0144,0.6156-0.0516,0.9156-0.004,0.114,0.0144,0.3396,0.282,0.4332,0.216,0.0636-0.0492,0.1716-0.4104,0.2364-0.5184-0.0264-0.1452-0.0708-0.5064-0.1236-0.6276z'/%3E %3Cpath d='m964.77,304.05c0.3024,0,0.5796-0.0696,0.834,0.15241,0.042,0.0804,0.0792,0.1572,0.1188,0.2328,0.0828,0.0564,0.1704,0.0672,0.2508,0.0348,0.1704,0.1152,0.2052,0.18,0.3924,0.2232,0.174,0.0372,0.3648-0.007,0.5388-0.004,0.2196,0.007,0.3264,0.0828,0.5316,0.1668,0.3576,0.1464,0.594,0.007,0.9036-0.216,0.3588-0.264,0.4896-0.0624,0.834,0.2688,0.258,0.246,0.2052,0.2232,0.438,0.0552,0.0348-0.0792,0.0756-0.156,0.1152-0.2232,0.1152-0.048,0.2328-0.0792,0.3504-0.1008,0.192-0.09,0.3828-0.0792,0.564-0.1488,0.1908-0.0744,0.33-0.2856,0.5316-0.2472,0.174,0.0348,0.3732,0.1764,0.5388,0.2292,0.1596,0.0552,0.2292,0.0864,0.3624,0.1836,0.2388-0.49321,0.768-0.63961,1.1052-0.87841,0.3516-0.2436,0.678,0.0516,1.0644,0.0552,0.2052,0,0.288-0.1188,0.4344-0.1668,0.1632-0.06,0.3504,0.0264,0.5076-0.0384,0.1668-0.0624,0.198-0.2232,0.38161-0.2436,0.3408-0.042,0.72,0.5136,1.0608,0.618,0.1908,0.0636,1.0752,0.26161,0.9456-0.3888-0.1248-0.6192-0.6804-0.1908-0.7992-0.6252-0.0636-0.2472,0.066-0.5988-0.0108-0.876-0.066-0.2532-0.3444-0.546-0.5112-0.6012-0.2088-0.066-0.33,0.1524-0.5076-0.018-0.1464-0.1356-0.2016-0.6432-0.33001-0.8448-0.1716,0.1248-0.2784,0.24-0.504,0.1944-0.258-0.0624-0.2328-0.15-0.4248-0.3936-0.4176-0.522-0.6576,0.3132-1.0428,0.1812-0.2928-0.0936-0.564-0.8304-0.7932-1.1304-0.1224-0.1596-0.4668-0.678-0.6432-0.5628-0.2988,0.1944-0.0276,0.7584-0.1836,1.008-0.1116,0.174-0.5076-0.004-0.6504,0.024-0.2256,0.0492-0.2676,0.108-0.4308,0.3792-0.33,0.546-0.522,0.9804-1.0356,0.918-0.2436-0.0276-0.4272-0.2748-0.6648-0.1848-0.2532,0.0972-0.396,0.3684-0.6744,0.3996-0.2016,0.0168-0.4344,0.024-0.6324-0.0516-0.1944-0.0876-0.414-0.4524-0.5916-0.5532-0.0756-0.0624-0.1524-0.0756-0.2388-0.0456-0.0216-0.0108-0.2892-0.1668-0.2928-0.1668-0.3096-0.09-0.2844-0.0792-0.4104,0.33-0.0732,0.2532-0.1008,0.5148-0.1944,0.7548-0.09,0.2016-0.288,0.4512-0.4032,0.5868-0.216,0.2328-0.3204,0.1704-0.6012,0.2544-0.2256,0.0732-0.5256,0.4248-0.6468-0.0276-0.18-0.6816,0.5004-1.7004-0.258-1.5228-0.198,0.0456-0.3168,0.0828-0.438,0.3756-0.1344,0.3372-0.0264,0.5556-0.0864,0.9252-0.0792,0.4656-0.9672,1.248-0.792,1.6692,0.1188,0.29641,0.5148-0.1596,0.6228-0.0864,0.18,0.1248,0.1284,0.42121,0.2568,0.61921,0.2688,0.4104,1.0644-0.63601,1.11-0.0696'/%3E %3Cpath d='m961.55,300.4c-0.002-0.0588-0.0132-0.1152-0.0168-0.1764-0.2124-0.0384-0.4524-0.264-0.6468-0.2676-0.1836-0.0108-0.5424,0.438-0.6684,0.6528-0.3888,0.6432-0.2808,1.5192-0.9348,1.506-0.1596-0.004-0.5352-0.1116-0.6756-0.0144-0.246,0.174-0.09,0.6888-0.09,1.0392,0,0.33,0.15,0-0.0264,0.4284-0.0528,0.1176-0.2124,0.156-0.2544,0.3132-0.132,0.55921,0.3336,0.38161,0.5388,0.37561,0.528-0.004,1.0536-0.004,1.5756,0,0.3168,0.007,0.5076-0.1044,0.8028-0.21961,0.1944-0.066,0.6084-0.0624,0.7728-0.2364,0.0588-0.066,0.2508-0.5076,0.2772-0.612,0.042-0.216-0.0408-0.4764,0.0108-0.6564,0.0828-0.3168,0.366-0.1956,0.4176-0.6228,0.1356-1.0476-0.9828-0.264-0.8064-1.2936'/%3E %3C/g%3E %3Cg fill='%23000' stroke='%23000' stroke-width='0.78'%3E %3Cpath d='m974.21,271.28c0,1.356-0.9276,2.448-2.0784,2.448-1.1364,0-2.0724-1.092-2.0724-2.448,0-1.3524,0.9348-2.4516,2.0724-2.4516,1.1496,0.001,2.0784,1.0992,2.0784,2.4516z'/%3E %3Cpath d='m967.43,268.26c0,1.3524-0.9288,2.448-2.0736,2.448-1.1472,0-2.0784-1.0956-2.0784-2.448s0.9312-2.4504,2.0784-2.4504c1.1448,0,2.0736,1.098,2.0736,2.4504z'/%3E %3Cpath d='m971.01,269.2c0,1.356-0.9288,2.448-2.0736,2.448s-2.0724-1.092-2.0724-2.448,0.9276-2.4504,2.0724-2.4504,2.0736,1.0956,2.0736,2.4504z'/%3E %3Cpath d='m967.54,271.44c0,1.356-0.9324,2.454-2.076,2.454s-2.0724-1.0992-2.0724-2.454c0-1.3524,0.9276-2.448,2.0724-2.448s2.076,1.0944,2.076,2.448z'/%3E %3Cpath d='m970.76,273.31c0,1.3524-0.9348,2.454-2.0748,2.454-1.1436,0-2.076-1.1016-2.076-2.454s0.9324-2.448,2.076-2.448c1.1388,0.001,2.0748,1.0956,2.0748,2.448z'/%3E %3C/g%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='0.78' d='m971.76,246.58s20.918-29.209,43.348,1.134c0,0,0.1872,3.018-1.8852,6.2196l-0.5664-2.448-1.3188,0.3744-0.3756-1.5072-2.4552-0.1872,0.7584-3.2052-2.6424,2.0736,0.3792-2.2632-3.0156,3.0204,0.3792-6.4116-3.2064,5.466,0.3756-3.7668-1.1292,1.6932-0.68041-2.196-1.0128,2.196-1.512-1.128v1.5072l-2.6352-2.262-0.942,3.0144-1.3188-3.2016-0.378,2.2596-1.3224-2.6388-0.1836,2.8284-4.3392-1.8864,0.942,2.6388-2.0688-1.5048,0.3756,1.5048-2.8236-0.5628,0.1848,1.6944-3.0156-0.5664,0.5676,1.506-4.1484-0.5616,1.5024,1.6956-0.4176,0.69s22.66-7.4724,24.168,20.796l-4.1472,2.0724,1.1328-2.256-1.1328-0.7572-3.39-2.6352,0.942-3.5844-1.1292,0.3792-0.1908-2.0724-0.564,0.3756-1.3224-2.0724-0.3756,0.75479-0.942-2.454-0.942,1.7004-0.5676-4.1484-1.5048,2.6424-0.192-1.5084-0.5664,0.942-1.884-2.2632-0.5604,1.5084-0.7584-1.1304-0.5628,1.3176-2.0736-1.8876v1.5132l-1.3176-1.134-0.5712,0.7548-3.198-1.6968-0.19561,1.5048-1.692-1.5048-0.5676,1.5048s20.549,11.689,14.137,30.725l-1.134,2.448-0.372-6.4044-1.884,3.39,1.3104-7.35-1.3104,1.3176-0.1944-2.8236-1.6896,2.8236-0.5748-3.2016-0.7476,0.942-1.1364-4.902-0.942,2.076-1.506-5.466-1.1292,2.2596-0.75481-4.7076-0.7548,2.826-2.2632-4.1484-0.3732,1.6932-1.3176-3.39-0.7584,1.134s-3.7692-0.192-4.8984-1.134c-1.1304-0.9384-4.3356,5.6568-4.3356,5.6568l0.378-3.96-1.3176,2.6352v-2.6352l-2.4516,7.914-0.5664-5.6532-1.3188,4.8996-0.5676-1.5048-0.3756,2.0748-0.7548-0.7572-0.6576,2.2248-1.23-0.9036v3.0144l-1.1292-1.5084-0.942,4.524-0.564-1.8804v2.0688l-0.942-1.1256-0.9456,4.524-1.3176-1.884-0.1848,3.1992,0.5604,2.454-1.506-0.7548,0.5676,3.9528s-5.844-10.927,1.1328-21.484c6.9684-10.549,16.393-13.379,16.393-13.379l-0.9456-0.9384-0.1872-0.9456-5.6532,2.826,0.1908-1.7004-1.5096,1.3212-0.3756-1.884-0.9456,1.6968-0.1836-0.7548-1.3224,2.076-0.7572-3.018-0.9396,3.5844-0.8892-2.5068-1.9368,5.3292v-3.9564l-1.5084,4.1484-0.564-4.524-1.1292,5.274v-4.7112l-1.7004,4.7112-1.1292-4.5204-0.7548,4.332-1.1292-3.39-1.134,5.0868-1.6932-4.524-0.942,6.7872-1.1292-2.6424-0.1908,4.902-1.3152-3.0144,1.3152,6.4044-1.6968-2.448,0.5676,3.9564-2.448-4.3356,0.1872,5.094-1.3212-1.7004-0.5676,1.8852s-0.5604-19.6,12.816-23.372c13.386-3.768,22.055,1.1328,22.055,1.1328l-5.0868-4.1448,0.564-1.3212h-1.884l0.7536-1.5084-3.9564,0.1908,1.1292-1.5084-3.018,0.3756v-0.9408l-1.884,1.5036,0.7548-1.6932-2.6388,1.6932-0.1608-2.5068-1.3488,2.1348-0.7476-2.2632-6.0348,6.0276,1.6956-6.2172-1.1292,1.3212-0.1872-1.3212-1.6968,2.6412-0.378-1.8864-0.7548,2.2596-0.5676-2.6364-1.314,2.6364-1.3224-2.4456-0.5628,3.2052-0.9456-1.7004-1.1304,2.4504-1.5048-1.5096-0.1908,1.5096-3.0156-1.32,0.7548,2.2632-2.2632-1.884-0.5676,3.0144-1.3152-1.5084-0.942,3.7728-0.942-3.5832-0.942,2.8272s11.786-30.286,41.605-10.526c0,0,3.2472,3.1752,4.002,5.436,0.7548,2.2632,0.1908,0.3804,0.1908,0.3804l-0.5676-20.921,1.1304,9.0468,0.7536-3.2052-0.1872,4.7124,3.012-6.5976s-3.5772,10.933-2.2608,14.89c0,0,1.3224-12.626,5.8488-14.136l-4.1484,9.0456,1.3176-0.1896-0.942,1.8876h1.1304l-1.3668,2.9904-0.7068,1.5336,0.7512,1.506,1.1388-1.1412z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m968.66,258.87,0.594,0.5352c0.0804-0.0828,1.944-2.0688,5.0736,0.5736l0.5184-0.6156c-3.7416-3.1644-6.1692-0.522-6.186-0.4932z'/%3E %3Cpath d='m967.75,248.61-0.1224,0.7248s1.0764-0.4584,1.4532-0.6204c-0.2328,0.4152-0.9984,1.7484-0.9984,1.7484s1.5816-0.5256,2.1672-0.7212c-0.9456,1.2384-2.688,3.5172-2.688,3.5172l0.6396,0.4944,4.2768-5.6016s-1.9692,0.6576-2.6568,0.8868c0.2772-0.4824,1.14-2.0052,1.14-2.0052s-1.7448,0.75-2.298,0.9876c0.1524-0.9288,0.4752-2.874,0.4752-2.874l-0.7956-0.1332-0.5928,3.5964z'/%3E %3Cpath d='m963.76,248.84s0.528,1.1688,0.9252,2.0388c-0.1716-0.0708-1.4748-0.5928-1.4748-0.5928l4.3488,7.6944s0.5256-0.6708,0.5568-0.7128c-0.438,1.1232-0.876,2.256-0.876,2.256l0.7512,0.2928,1.8744-4.8228-0.6912-0.39241s-1.0284,1.3176-1.5096,1.9332c-0.4068-0.7236-1.9116-3.3864-2.6256-4.6452,0.09,0.0336,1.2072,0.4836,1.2072,0.4836s-0.8208-1.812-1.2036-2.6532c0.5076,0.3168,1.6308,1.0188,1.6308,1.0188v-2.868h-0.804v1.4184c-0.6252-0.39-2.6628-1.662-2.6628-1.662l0.5532,1.2132z'/%3E %3Cpath d='m961.02,258.5,0.3204,0.7368c1.1772-0.504,2.148-0.588,2.8848-0.2364,0.8628,0.414,1.1232,1.3032,1.1256,1.3104l0.7752-0.2088c-0.0108-0.0516-0.3516-1.248-1.5432-1.8216-0.9516-0.4584-2.1516-0.3852-3.5628,0.2196z'/%3E %3Crect width='4.2659' height='0.80638' x='-412.82' y='911.45' transform='rotate(-98.911264)'/%3E %3Crect width='3.3937' height='0.80643' x='-559.16' y='836.26' transform='rotate(-108.438572)'/%3E %3Crect width='3.3157' height='0.80642' x='-496.74' y='877.86' transform='rotate(-104.075153)'/%3E %3C/g%3E %3C/g%3E %3Cg id='dove'%3E %3Cg stroke='%23000' stroke-width='0.78' fill='%2300a651'%3E %3Cpath d='m811.41,365.04s-3.534-1.6056-5.1432-0.4308c-1.608,1.182-1.3884,2.8932-2.7828,2.7852,0,0,5.3544,1.1784,6.5316-0.216,1.1772-1.3872,1.3944-1.8192,1.3944-1.8192'/%3E %3Cpath d='m812.06,366.52s-2.3256,3.1092-1.5216,4.9296c0.8016,1.8228,2.5224,1.9788,2.1156,3.3156,0,0,2.3016-4.974,1.1964-6.426-1.1052-1.4424-1.4748-1.7448-1.4748-1.7448'/%3E %3Cpath d='m808.14,357.91s-3.7104,1.1508-4.1256,3.0948c-0.426,1.9464,0.8784,3.0864-0.2328,3.9312,0,0,4.782-2.6796,4.7376-4.506-0.0456-1.8228-0.1632-2.2836-0.1632-2.2836'/%3E %3Cpath d='m810.32,359.19s1.7592-3.4668,0.6516-5.118c-1.1052-1.6632-2.832-1.5204-2.6616-2.904,0,0-1.4136,5.2956-0.0732,6.5364,1.3428,1.23,1.7628,1.4676,1.7628,1.4676'/%3E %3Cpath d='m806.68,357.93s0.0852-3.876-1.632-4.8888c-1.7148-1.0152-3.2088-0.1416-3.6576-1.4676,0,0,1.026,5.3892,2.7732,5.928,1.746,0.5256,2.2272,0.5568,2.2272,0.5568'/%3E %3Cpath d='m813.02,364.39s4.068-1.3968,4.392,2.9976c0.3204,4.3908-0.216,2.8932-0.216,2.8932s-2.142-4.7124-4.4964-5.4636l0.3204-0.4272z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m811.99,366.59c0,0.0936,0.426,3.414,0.426,3.414l0.5724-0.0732-0.4308-3.3216c0.0144,0.004,1.3908-7.3008,1.3908-7.3008l-0.5676-0.1044-1.3908,7.386z'/%3E %3Cpath d='m808.29,365.51-0.1896,0.5424c1.9452,0.684,4.6608-1.4544,4.7736-1.5444l-0.36-0.4476c-0.024,0.0168-2.5776,2.034-4.224,1.4496z'/%3E %3Crect width='10.201' height='0.80398' x='-888.86' y='44.844' transform='rotate(-153.165895)'/%3E %3Crect width='0.80159' height='2.574' x='-825' y='316.26' transform='rotate(-134.967588)'/%3E %3Crect width='4.6033' height='0.80282' x='-665.49' y='585.05' transform='rotate(-114.758335)'/%3E %3Cpath d='m812.67,364.42,0.0516,0.804c2.4756-0.168,3.0804,1.4352,3.084,1.4532l0.7896-0.1644c-0.0936-0.4584-1.0848-2.2836-3.9252-2.0928z'/%3E %3C/g%3E %3Cpath d='m854.43,366.27c3.0348-1.7004,3.6432-7.6572,3.6432-7.6572-0.72601,2.1912-6.3108,4.3752-6.3108,4.3752,4.1268-2.556,9.102-14.084,9.102-14.084-1.3344,4.1292-12.138,7.5264-19.061,11.411-6.9228,3.8832-3.2784,15.058-3.2784,15.058-1.9404-1.3368-5.706-7.2828-6.432-12.509-0.7332-5.2188-2.796-7.2804-7.5312-7.8888-4.7376-0.6084-7.5288,4.7316-7.5288,4.7316l-7.0404,3.6468,7.1592,0.24s5.106,1.704,5.106,5.7096c0,4.0092-4.4928,20.035,2.91,29.022,5.1528,6.2448,24.166,9.8328,24.166,9.8328' stroke='%23000' stroke-width='1' fill='%23FFF'/%3E %3Cpath d='m840.47,378.65s1.4568-7.1652,6.192-6.9216c4.7352,0.2424,6.0708-5.34,8.8632-6.192,2.7924-0.8484,17.242-4.7316,18.821-11.656,0,0-1.3356,11.416-14.568,17.122,0,0,10.681-3.5232,11.898-5.8308,0,0-4.7388,10.2-16.272,11.778,0,0,10.806-0.8484,12.385-3.7608,0,0-4.8576,6.4332-12.869,7.2852,0,0,7.4052,3.0348,9.3492,0.4836,0,0-4.008,4.7352-8.988,5.0964l1.3392,0.366s-4.7352,5.5872-9.9576,1.8216c-5.2188-3.7656-5.3436,0.9744-5.3436,0.9744' stroke='%23000' stroke-width='1' fill='%23FFF'/%3E %3Cpath d='m851.25,389.45s6.0984,10.202,6.7068,15.665c0,0,11.658,12.872,16.028,13.595,0,0-2.0652,0.8484-5.8308-2.3052,0,0,3.1572,3.2784,3.7656,3.4008,0.6048,0.12482-2.5512-0.2436-3.0384-1.0956,0,0,1.338,1.9476,2.1864,2.19,0.852,0.2436-0.8484-0.2424-0.8484-0.2424s-1.5816-0.2436-2.3088-0.852c-0.7296-0.6048-0.2436,1.5756-0.2436,1.5756s-1.8216-0.486-2.4264-1.092c-0.6084-0.6048,0.2436,1.3392,0.2436,1.3392l-1.578-0.366-1.092,0.726s-0.1224,0.7296-0.8556,0.1224c-0.7236-0.6012-2.0616,0-2.0616,0s-0.9744,0.852-1.4568,0.2436c-0.4824-0.606-2.3232,2.3352-2.3232,2.3352l-7.6452-18.455' stroke='%23000' stroke-width='1' fill='%23FFF'/%3E %3Cg fill='%23000'%3E %3Crect width='20.776' height='1.146' x='-773.68' y='563.31' transform='rotate(-117.71558)'/%3E %3Crect width='24.817' height='1.1507' x='-892.01' y='365.7' transform='rotate(-131.769152)'/%3E %3Crect width='25.786' height='1.1485' x='-923.37' y='286.33' transform='rotate(-137.017935)'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m823.44,360.84s-1.2312-2.2044-2.3028-1.3764c-1.0692,0.8256-1.6848,0.9768-1.8696,0.9192,0,0,1.0752,0.0588,1.686-0.522,0.6132-0.5856,1.656-0.216,2.4864,0.9792z'/%3E %3Cpath d='m816.78,359.83s0.6756,1.398,0.6852,1.422c-0.0684,0.004-0.7632,2.2572-0.7632,2.2572l0.5532,0.1704,0.75-2.454c-0.0132-0.2124-0.7032-1.6416-0.7032-1.6416l-0.522,0.246z'/%3E %3Cpath d='m823.16,360.5s-0.918,1.0752-2.1756,0.7656c-1.2528-0.306-1.2528-0.306-1.2528-0.306s1.0668,0.06,1.776,0.0936c0.7008,0.0288,1.6188-0.3372,1.6524-0.5532z'/%3E %3Cpath d='m822.86,360.72s-1.1316-1.1952-1.8996-0.858c0,0,1.35-0.4308,2.1156,0.7296l-0.216,0.1284z'/%3E %3Cpath d='m822.67,360.5s-1.2864,0.8868-2.6988-0.09l-0.0864-0.066,0.1836-0.0588c0.001,0.001,1.7772,0.7344,2.6016,0.2148z'/%3E %3Ccircle cx='821.5728' cy='360.2836' r='0.3828'/%3E %3C/g%3E %3Cpath d='m822.61,394.2s-0.996,1.8336-0.4752,2.9388c0.528,1.1028,2.8908,1.6752,3.2052,3.1464,0.3168,1.4748,1.1052,1.4712,2.208,1.266,1.1052-0.2124,1.314-0.264,1.314-0.264s-4.6248-2.4732-5.8344-6.4608l-0.4176-0.6264z' fill='%23000'/%3E %3C/g%3E %3Cg id='bananas'%3E %3Cg stroke='%23000' fill='%23964b36' stroke-width='0.48'%3E %3Cpath d='m972.09,356.85s8.418-11.099,15.882-8.184c7.4652,2.9172,12.316,4.3212,12.316,4.3212s0.1416,7.4748-3.828,7.4748c-3.96,0-7.7568-7.4652-11.366-5.2464-3.6156,2.2152-6.5844,5.25-6.8184,6.2964-0.2328,1.0476-9.5616,1.2828-6.1848-4.662z'/%3E %3Cpath stroke-width='0.78' d='m940.14,410.37s-2.328,2.4444-1.278,3.0312c1.0536,0.5808,3.1464-0.1224,3.1464-0.9348-0.001-0.8208-1.3956-2.3292-1.8684-2.0964z'/%3E %3Cpath stroke-width='0.78' d='m938.28,412.7s-4.3116-2.4552-7.6944,3.3756c-3.3864,5.8296-6.1812,15.277-8.1636,16.561-1.9812,1.2816,19.241-9.3288,19.475-13.759,0,0,1.3968-5.7156-0.8172-5.6016-2.2152,0.1224-2.3328,0.3564-2.7996-0.576z'/%3E %3Cpath d='m938.86,413.4s-4.4292,1.0428-5.3616,7.3368c-0.9324,6.3036-7.1148,9.5652-7.4628,9.7968'/%3E %3Cpath d='m1000.3,352.99s-6.738,2.3436-5.574,7.0104'/%3E %3C/g%3E %3Cpath fill='%23fff200' stroke='%23000' stroke-width='0.48' d='m948.54,366.64s0.2316-15.976,13.284-15.277c2.4732,0.2292,1.2936,3.1464,1.2936,3.1464s2.8236-1.9776,4.1136,1.1652c0,0,4.1172-1.8636,4.5852,2.2188,0,0,4.4688-0.5808,3.8796,3.0312,0,0,3.0564-0.6984,2.9424,1.8672,0,0,3.5256-1.4004,3.1704,2.2152,0,0,3.8808-2.5656,3.2964,2.0964,0,0,3.9984-2.7948,5.4036,1.8684,1.4112,4.662-3.9948,14.574-9.2868,17.138'/%3E %3Cg fill='%23000'%3E %3Cpath d='m984.81,367.61c0.018,0.1248,1.7592,12.498-5.2572,17.026l0.2472,0.39c7.2696-4.6908,5.4816-17.356,5.466-17.484l-0.456,0.0684z'/%3E %3Cpath d='m976.36,381.16,0.324,0.33c4.4436-4.3248,5.4-15.976,5.4336-16.469l-0.4548-0.0384c-0.0108,0.1224-0.9768,11.974-5.3028,16.177z'/%3E %3Cpath d='m972.21,378.39,0.4584,0.0372c0.5712-7.1952,6.1956-15.425,6.2556-15.509l-0.3792-0.258c-0.0588,0.0816-5.7516,8.4132-6.3348,15.73z'/%3E %3Cpath d='m968.95,376.29,0.4584,0.0456c0.8004-8.6796,6.5328-15.196,6.5892-15.258l-0.3408-0.3072c-0.06,0.0636-5.8908,6.6876-6.7068,15.52z'/%3E %3Cpath d='m964.4,373.39,0.4584,0.0168c0.456-10.249,7.1796-15.28,7.2468-15.329l-0.2724-0.372c-0.0648,0.0516-6.9672,5.2008-7.4328,15.684z'/%3E %3Cpath d='m960.2,370.84,0.462-0.0144c-0.336-9.3276,6.8352-14.912,6.9096-14.969l-0.2784-0.3648c-0.0732,0.06-7.434,5.7804-7.0932,15.348z'/%3E %3Cpath d='m952.63,367.43,0.4548,0.0564c1.2492-10.097,10.236-12.725,10.326-12.75l-0.1248-0.4416c-0.09,0.024-9.3732,2.7288-10.656,13.135z'/%3E %3C/g%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='0.48' d='m940.84,386s-2.2116-14.813,6.648-19.472c0,0,1.6368-0.3516,2.5656,1.7484,0,0,4.6668-1.9812,4.7844,1.9776,0,0,2.3292-1.8636,2.9136,0.6996,0,0,5.0136-1.0464,4.0812,2.6832,0,0,4.1964-1.1652,3.846,2.4456,0,0,4.2-1.5144,3.4968,1.6344,0,0,4.4292-1.0464,3.3828,2.5668,0,0,5.4828-0.5808,3.8496,3.2652,0,0,4.0812-1.0476,3.1464,2.1,0,0,5.3652,0.9348,2.9136,4.3152-2.448,3.378-8.6292,8.5092-14.686,10.724'/%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='0.48' d='m936.06,400.92s-3.6156-12.355,3.2688-15.509c0,0,1.2756-0.3516,1.5096,0.9348,0,0,1.5192-1.9848,2.6868-0.2328,0,0,3.4944-1.6332,4.3152,0.9312,0,0,2.3292-1.9848,3.498,0.9276,0,0,2.2152-0.9276,2.2152,1.4016,0,0,3.0312-1.2828,3.0312,1.5168,0,0,2.91-1.1652,2.3292,1.9812,0,0,4.4328,0.6984,3.15,2.7972,0,0,3.9708,1.0464,2.448,2.6832,0,0,4.3116-0.4656,1.9812,2.448,0,0,3.2652-1.0464,1.4016,2.5704-1.8684,3.612-7.6944,7.5756-11.776,8.0412'/%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='0.48' d='m940.37,410.71s-7.6944-7.4616-4.0752-9.6756c0,0,1.626,0.462,2.2116,2.0964,0,0,1.8636-2.6808,2.9172,0.1152,0,0,2.7996-0.9312,2.7996,0.9384l2.2116,1.6332s2.5692-0.2352,2.1036,1.398c0,0,2.7984-0.3516,2.6796,1.1652,0,0,2.4516,0.1152,2.2188,1.7448,0,0,4.1928,0.6996,2.3292,2.8032,0,0-7.3464,1.512-12.475-0.5844,0-0.001-2.688-0.936-2.9208-1.6344z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m966.76,398.38,0.1644,0.4272c4.5588-1.7556,12.478-12.564,12.816-13.024l-0.372-0.2748c-0.084,0.1164-8.1744,11.164-12.608,12.871z'/%3E %3Cpath d='m964.17,396.41,0.2232,0.3996c3.9672-2.2128,11.867-12.676,12.2-13.121l-0.366-0.2772c-0.0792,0.1116-8.1744,10.834-12.058,12.998z'/%3E %3Cpath d='m961.92,395.49,0.2964,0.3516c4.1892-3.4776,10.291-14.966,10.552-15.452l-0.4068-0.216c-0.0612,0.1176-6.3204,11.896-10.441,15.317z'/%3E %3Cpath d='m959.86,392.84,0.456,0.0636c0.7956-5.8068,8.9532-14.947,9.0324-15.037l-0.3408-0.3072c-0.3372,0.3792-8.334,9.336-9.1476,15.281z'/%3E %3Cpath d='m943.53,385.78,0.4596-0.0408c-0.6852-8.202,6.1812-17.237,6.2508-17.327l-0.3648-0.2772c-0.0732,0.0888-7.044,9.2616-6.3456,17.645z'/%3E %3Cpath d='m947.85,386.5,0.456-0.0792c-1.1364-6.5772,6.63-15.929,6.7104-16.02l-0.3516-0.2988c-0.3264,0.3888-7.9836,9.6048-6.8148,16.398z'/%3E %3Cpath d='m954.49,388.92,0.4596-0.0132c-0.2256-7.5072,6.9768-15.032,7.0512-15.109l-0.33-0.3204c-0.0732,0.0768-7.4148,7.7424-7.1808,15.443z'/%3E %3Cpath d='m938.65,402.52,0.4308-0.1608c-2.616-6.936,1.9248-15.818,1.9716-15.905l-0.414-0.2124c-0.0456,0.0912-4.6776,9.1488-1.9884,16.278z'/%3E %3Cpath d='m941.67,402.97,0.438-0.1416c-2.2812-7.0656,1.5852-16.535,1.626-16.628l-0.4272-0.1764c-0.0372,0.0924-3.966,9.7212-1.6368,16.946z'/%3E %3Cpath d='m954.17,410.03,0.1572,0.4344c7.44-2.676,12.305-9.4608,12.353-9.5256l-0.3756-0.2688c-0.0456,0.0672-4.8252,6.738-12.134,9.36z'/%3E %3Cpath d='m952.64,408.41,0.1872,0.4212c5.934-2.6772,11.467-10.146,11.519-10.223l-0.3684-0.2688c-0.0564,0.0744-5.5152,7.4424-11.338,10.07z'/%3E %3Cpath d='m951.2,407.85,0.2688,0.3732c4.6416-3.3624,10.604-11.982,10.667-12.07l-0.378-0.2568c-0.0612,0.0876-5.9772,8.6376-10.558,11.953z'/%3E %3Cpath d='m943.76,403.52,0.456-0.066c-1.026-7.4136,3.7728-16.208,3.8244-16.295l-0.4032-0.2232c-0.0516,0.0912-4.9236,9.018-3.8772,16.584z'/%3E %3Cpath d='m946.99,405.53,0.3096,0.3408c4.788-4.3224,6.4188-15.972,6.4848-16.465l-0.456-0.0636c-0.0144,0.1188-1.6728,11.981-6.3384,16.188z'/%3E %3Cpath d='m950.27,406.91,0.2688,0.372c6.7584-4.8876,8.5908-14.274,8.6052-14.365l-0.4488-0.0864c-0.018,0.09-1.8156,9.2952-8.4252,14.08z'/%3E %3Cpath d='m951.05,386.68c0,0.438,0.0216,0.8748,0.0624,1.3176-0.007-0.0372-5.1252,16.583-5.1252,16.583l0.438,0.1356,5.1384-16.674c-0.7932-8.0604,6.2964-16.859,6.366-16.945l-0.354-0.288c-0.0708,0.0792-6.5256,8.0928-6.5256,15.871z'/%3E %3Cpath d='m956.41,390.74c-0.0672,0.2328-1.6272,11.618-7.7676,15.818l0.2604,0.3792c6.3144-4.3188,7.848-15.544,7.9104-16.018,2.7252-3.2436,9.0048-14.614,9.0684-14.728l-0.4032-0.222c-0.0636,0.114-6.318,11.45-9.0684,14.77z'/%3E %3Cpath d='m938.28,403.18c0.0456,0.2388,1.0716,5.8956,2.2464,7.8912l0.396-0.2316c-1.1364-1.926-2.1756-7.68-2.1864-7.74l-0.456,0.0804z'/%3E %3Cpath d='m941.19,403.25c0.0492,2.8164,0.0636,7.4364-0.0936,7.8468l0.4272,0.168c0.2364-0.5916,0.1464-6.7836,0.1284-8.0184l-0.462,0.004z'/%3E %3Cpath d='m941.45,411.32,0.4176,0.1872c1.9716-4.29,2.5788-7.2492,2.586-7.2768l-0.4512-0.09c-0.007,0.024-0.6024,2.9412-2.5524,7.1796z'/%3E %3Cpath d='m941.89,411.45,0.2328,0.396c3.6576-2.1252,4.506-5.8212,4.536-5.976l-0.4476-0.1008c-0.0108,0.0372-0.8412,3.6612-4.3212,5.6808z'/%3E %3Cpath d='m942.57,411.77,0.0456,0.4548c3.5844-0.3576,6.0252-4.7112,6.1296-4.8948l-0.4044-0.2232c-0.0228,0.0456-2.4288,4.3284-5.7708,4.6632z'/%3E %3Cpath d='m942.93,412,0.0276,0.4584c5.754-0.354,8.3436-3.7932,8.448-3.9384l-0.372-0.2724c-0.024,0.0324-2.5764,3.4152-8.1036,3.7524z'/%3E %3Cpath d='m943.34,412.12-0.0936,0.4488c0.3096,0.0708,7.6416,1.6248,10.152-2.1972l-0.3852-0.2508c-2.334,3.558-9.6012,2.0136-9.6732,1.9992z'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='none' stroke='%23000' stroke-width='4.2' d='m778.8,143.94,0,205.09c0,67.08,121.2,106.91,121.2,106.91s121.2-39.833,121.2-106.91v-205.09z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Cdefs%3E %3ClinearGradient id='gradbase' gradientUnits='userSpaceOnUse'%3E %3Cstop stop-color='%23a43907' stop-opacity='0.9961' offset='0'/%3E %3Cstop stop-color='%23fff' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='grad1' xlink:href='%23gradbase' x1='826.45044' y1='419.93194' x2='786.12402' y2='396.11032'/%3E %3ClinearGradient id='grad2' xlink:href='%23gradbase' x1='851.56865' y1='436.06697' x2='763.03312' y2='419.67318'/%3E %3ClinearGradient id='grad3' xlink:href='%23gradbase' x1='1016.1496' y1='398.53933' x2='974.91928' y2='400.94143'/%3E %3ClinearGradient id='grad4' xlink:href='%23gradbase' x1='1033.33547' y1='421.21868' x2='945.904' y2='428.64452'/%3E %3ClinearGradient id='grad5' xlink:href='%23gradbase' x1='1023.35736' y1='445.13212' x2='776.64586' y2='445.13212'/%3E %3ClinearGradient id='grad6' xlink:href='%23gradbase' x1='783.43027' y1='462.50282' x2='1144.08805' y2='465.42083'/%3E %3ClinearGradient id='grad7' xlink:href='%23gradbase' x1='1032.1278' y1='442.28699' x2='1002.94064' y2='444.03323'/%3E %3ClinearGradient id='grad8' xlink:href='%23gradbase' x1='775.74733' y1='471.7178' x2='803.90792' y2='476.1845'/%3E %3ClinearGradient id='grad9' xlink:href='%23gradbase' x1='803.17707' y1='466.88819' x2='755.30821' y2='440.32034'/%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg stroke='%23000' stroke-width='1.8'%3E %3Cuse xlink:href='%23scroll' stroke='%23fff' stroke-width='12'/%3E %3Cg id='scroll' stroke-linejoin='bevel'%3E %3Cpath fill='url(%23grad1)' d='m826.45,427.735s-8.53598-13.8843-15.65-12.8926c-7.11256,0.99174-13.7516,9.91737-14.2266,10.4124-0.47347,0.49666-10.9063-11.4042-10.4329-11.9008,0.47498-0.49508,10.9078-26.2802,16.5985-27.272,5.69065-0.99174,17.9773,1.89709,17.9773,2.88882,0,0.99174,5.73375,38.7641,5.73375,38.7641z'/%3E %3Cpath fill='url(%23grad2)' d='m845.419,412.859c0,0.99174-2.84532,37.686-15.1751,50.5786-12.3297,12.8926-32.247,20.8265-39.3611,18.843-7.11255-1.98348-23.2361-39.1728-23.2361-39.1728s17.072,17.8513,29.8752,14.8761c12.8047-2.97521,20.3922-25.2901,22.7626-36.1992,2.37186-10.9091,0.47498-32.2323,0.47498-32.2323l24.6595,23.3066z'/%3E %3Cpath fill='url(%23grad3)' d='m973.576,427.735s8.53598-13.8843,15.65-12.8926c7.11256,0.99174,13.7516,9.91737,14.2266,10.4124,0.4734,0.49666,10.9063-11.4042,10.4328-11.9008-0.4749-0.49508-10.9078-26.2802-16.5984-27.272-5.69065-0.99174-17.9773,1.89709-17.9773,2.88882,0,0.99174-5.73375,38.7641-5.73375,38.7641z'/%3E %3Cpath fill='url(%23grad4)' d='m954.608,412.859c0,0.99174,2.84532,37.686,15.1751,50.5786,12.3297,12.8926,32.247,20.8265,39.361,18.843,7.1126-1.98348,23.2361-39.1728,23.2361-39.1728s-17.072,17.8513-29.8752,14.8761c-12.8047-2.97521-20.3922-25.2901-22.7626-36.1992-2.37186-10.9091-0.47498-32.2323-0.47498-32.2323l-24.6595,23.3066z'/%3E %3Cpath fill='url(%23grad5)' d='m788.945,407.482c-5.69068,6.94218-8.7289,12.308-11.1,16.275-2.3711,3.96694-0.97668,9.4873,4.5,17.3625,5.90463,8.48767,54.4484,41.6625,117.675,41.6625,63.2265,0,111.77-33.1748,117.675-41.6625,5.4766-7.87519,6.8336-13.3956,4.4625-17.3625-2.3711-3.96695-5.3719-9.33282-11.0625-16.275,0,10.4124-40.2141,48.0375-111.075,48.0375-70.8609,0.00002-111.075-37.625-111.075-48.0375z'/%3E %3Cpath fill='url(%23grad6)' d='m1008.25,476.741c0.9485-1.48681,10.9063-18.843,10.9063-18.843l-5.46-4.02724c-1.6768,4.90949-7.8182,6.50738-8.7666,12.4578s4.2688,11.9008,3.3203,10.4124z'/%3E %3Cpath fill='url(%23grad7)' d='m1018.15,471.371s1.8969-8.42897-4.2673-9.42071c-6.1656-0.99173-9.4293,4.71805-8.5359,2.47855,0.9921-2.48691,4.7422-4.95868,5.2156-13.3877,0.475-8.43056-0.4734-12.8926-0.4734-12.8926s2.3703-10.9107,12.3297-9.4223c9.9579,1.4884,10.4329,9.4223,10.4329,12.3975,0,2.97521-0.9485,4.46202-0.9485,4.46202l-13.7531,25.7852z'/%3E %3Cpath fill='url(%23grad8)' d='M791.773,476.741c-0.949-1.487-10.907-18.843-10.907-18.843l5.45999-4.02724c1.67684,4.90949,7.81819,6.50738,8.76663,12.4578s-4.26874,11.9008-3.3203,10.4124z'/%3E %3Cpath fill='url(%23grad9)' d='m781.873,471.371s-1.89688-8.42897,4.26723-9.42071c6.16563-0.99173,9.42936,4.71805,8.53597,2.47855-0.99208-2.48691-4.7422-4.95868-5.21567-13.3877-0.47498-8.43056,0.47347-12.8926,0.47347-12.8926s-2.37035-10.9107-12.3297-9.4223c-9.95788,1.4884-10.4329,9.4223-10.4329,12.3975,0,2.97521,0.94844,4.46202,0.94844,4.46202l13.7532,25.7852z'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m813.43,438.565-5.16779-3.55994-0.60012,0.95373,1.0182,0.84192,0.0874,0.5064-6.50543,10.3388-0.47909,0.11619-1.14073-0.6472-0.60011,0.95374,5.16779,3.55994c1.7705,1.21965,3.2807,1.84224,4.96633,1.66477,2.1944-0.22005,4.06492-1.49869,5.5102-3.7956,2.573-4.08915,1.85084-8.10322-2.25661-10.9327zm-2.1551,0.0781,1.02686,0.70737c2.8141,1.93856,3.06199,4.64992,0.75905,8.30989-2.30295,3.65997-4.79294,4.51187-7.60704,2.57332l-1.02686-0.70738,6.84799-10.8832z'/%3E %3Cpath d='m815.174,457.273,10.2685,5.13308,1.71686-3.76452-1.2992-0.64945-1.34262,2.06734-0.40209,0.21206-4.43568-2.21733,2.495-5.47071,2.48537,1.2424,0.1338,0.42897-0.50075,1.60932,1.12889,0.56432,2.22605-4.88099-1.12889-0.56431-0.88123,1.42089-0.4021,0.15932-2.48537-1.24239,2.2835-5.00695,3.80416,1.90164,0.12401,0.39771-0.55685,1.9961,1.33839,0.66904,1.50666-3.30361-9.63852-4.81815-0.47001,1.03059,1.11826,0.68907,0.17148,0.44781-5.11404,11.2134-0.45937,0.18343-1.21422-0.47866-0.47002,1.03059z'/%3E %3Cpath d='m828.786,462.999c1.10133,0.90962,2.37746,1.60988,3.66831,2.04514,3.30819,1.11547,5.93074-0.10665,6.74176-2.74783,0.40203-1.30927,0.12479-2.72592-0.79298-3.94194-0.93036-1.24359-1.89776-1.93807-2.39314-2.57005-0.85035-1.06996-1.21179-1.92674-0.89833-2.94757,0.37514-1.22168,1.55506-1.80204,3.02713-1.30568,0.64543,0.21763,1.07577,0.48438,1.37702,0.80593l0.18745,0.4065-0.36563,2.42474,1.45141,0.48939,1.10408-3.59557c-1.11994-0.91756-2.30851-1.61162-3.55962-2.03348-2.88374-0.97235-5.34572,0.30391-6.10202,2.7669-0.33434,1.08879-0.18493,2.33902,0.47776,3.51735,0.6348,1.1206,1.46794,1.81814,2.13759,2.53387,1.18703,1.28181,1.66823,2.32562,1.30052,3.52314-0.37514,1.22168-1.61594,1.78318-3.25016,1.23214-0.62476-0.21066-1.17546-0.51966-1.6786-0.90929l-0.16029-0.42066,0.49527-2.77265-1.53408-0.51727-1.23345,4.01689z'/%3E %3Cpath d='m839.509,467.153,6.02979,2.03315,0.33386-1.08727-1.3174-0.56586-0.21374-0.46369,3.63266-11.8302,0.41824-0.20227,1.38557,0.34388,0.33387-1.08728-6.02979-2.03316-0.33387,1.08728,1.29628,0.56041,0.22719,0.41989-3.63267,11.8302-0.43168,0.24606-1.36444-0.33842-0.33387,1.08728z'/%3E %3Cpath d='m852.462,454.82-0.23018,1.11771,1.19889,0.38514,0.26548,0.39304-2.50447,12.1613-0.40647,0.29156-1.24589-0.15694-0.23018,1.11771,5.84014,1.29106,0.23018-1.11771-1.24001-0.39261-0.25622-0.43806,1.05723-5.1337c0.12405,0.0274,0.2481,0.0549,0.35256,0.0779,2.0909,0.46223,2.42749,1.5624,2.62266,3.87132,0.10596,1.16768,0.0804,2.23648,0.9697,3.38743,0.40864,0.54317,1.11789,0.98561,2.00909,1.18263,0.64147,0.14181,1.35903,0.22902,2.10708,0.27591l0.2257-1.09598c-0.10283-0.0227-0.18607-0.0411-0.26932-0.0595-1.3874-0.3067-1.93731-0.78534-2.11449-2.13756-0.15871-1.2264-0.0697-2.49543-0.50599-3.64198-0.32473-0.83462-0.94066-1.42361-1.8829-1.89485,2.43941,0.0378,3.93433-1.01461,4.36656-3.11342,0.52174-2.53347-0.85301-4.26891-4.06362-4.97867l-6.29553-1.39173zm3.97754,2.23942,0.95323,0.21072c2.00765,0.44383,2.84759,1.72669,2.46236,3.5973-0.43255,2.10036-1.68585,2.82472-3.9008,2.33507-0.22851-0.0505-0.47661-0.10536-0.74113-0.18819l1.22634-5.9549z'/%3E %3Cpath d='m865.586,473.888,11.3628,0.56256,0.18257-4.16851-1.43933-0.0713-0.4684,2.45157-0.2915,0.35885-4.90839-0.24301,0.26531-6.0578,2.75023,0.13616,0.28257,0.3412,0.13837,1.6874,1.24753,0.0618,0.23671-5.40479-1.24753-0.0618-0.28532,1.66801-0.3111,0.31022-2.75024-0.13616,0.24282-5.54426,4.21124,0.20849,0.26193,0.31636,0.22707,2.06665,1.48102,0.0733,0.16021-3.65813-10.664-0.52797-0.05,1.14119,1.28576,0.1812,0.32426,0.34327-0.5438,12.4168-0.35488,0.35571-1.29596,0.0518-0.05,1.14119z'/%3E %3Cpath d='m885.562,460.702-0.039,4.12848,1.49873,0.0179,0.37128-2.49165,0.35057-0.29889,2.60866,0.0312-0.11983,12.6869-0.3735,0.36844-1.41418,0.0989-0.0108,1.14239,6.49852,0.0777,0.0108-1.14239-1.412-0.13272-0.36645-0.37729,0.11983-12.6869,2.60866,0.0312,0.32257,0.30694,0.3464,2.50023,1.49874,0.0179,0.039-4.12847-12.538-0.14991z'/%3E %3Cpath d='m898.767,461.149,0.0199,1.1423,1.26256,0.0954,0.35417,0.36677,0.21614,12.3829-0.34115,0.3789-1.25849,0.13782,0.0199,1.14231,6.14838-0.10732-0.0199-1.14231-1.30534-0.0931-0.35417-0.36677-0.10258-5.87653,6.27854-0.1096,0.10257,5.87654-0.31889,0.37852-1.3013,0.13857,0.0199,1.1423,6.12782-0.10696-0.0199-1.14231-1.26252-0.0938-0.35417-0.36677-0.21615-12.3829,0.34116-0.37891,1.25845-0.1394-0.0199-1.14231-6.12782,0.10696,0.0199,1.14231,1.30537,0.0947,0.33191,0.36716,0.0891,5.10707-6.27853,0.10959-0.0892-5.10707,0.34116-0.3789,1.30127-0.14016-0.0199-1.1423-6.14838,0.10732z'/%3E %3Cpath d='m916.073,476.413,11.6241-1.06432-0.3543-4.15727-1.47242,0.13481-0.15864,2.4965-0.24986,0.39724-5.02124,0.45975-0.51488-6.04148,2.81346-0.2576,0.33145,0.29782,0.35921,1.65255,1.27621-0.11685-0.45938-5.39023-1.27621,0.11685-0.074,1.69382-0.27608,0.35185-2.81346,0.25761-0.47124-5.52933,4.30807-0.39446,0.30724,0.27614,0.4985,2.01576,1.51507-0.13872-0.31092-3.64828-10.9092,0.99887,0.097,1.13811,1.33054-0.004,0.37411,0.29391,1.05536,12.3833-0.3147,0.40318-1.31073,0.23631,0.097,1.13811z'/%3E %3Cpath d='m932.555,458.353,0.1778,1.12752,1.36566-0.11428,0.41605,0.26022,1.9346,12.2681-0.30714,0.4304-1.32936,0.34448,0.1778,1.12753,6.43651-1.09951-0.1778-1.12752-1.41039,0.12352-0.42321-0.30563-0.81666-5.17879c0.13672-0.0233,0.27523-0.047,0.38857-0.0664,2.3044-0.39365,3.05412,0.49466,4.10583,2.56004,0.53928,1.04166,0.90964,2.04302,2.24033,2.76132,0.61756,0.34319,1.50472,0.47469,2.48692,0.3069,0.70698-0.12076,1.47144-0.32211,2.25213-0.57287l-0.17434-1.1056c-0.11334,0.0194-0.20508,0.035-0.29683,0.0507-1.52907,0.2612-2.26699,0.0335-2.94708-1.1514-0.6148-1.07539-0.99257-2.28777-1.85931-3.18021-0.64135-0.64629-1.48738-0.95045-2.62113-1.01731,2.50154-0.92425,3.63852-2.48866,3.30465-4.6059-0.40302-2.55573-2.44673-3.62504-5.98519-3.02059l-6.93841,1.18524zm4.88592,0.51304,1.05056-0.17946c2.21267-0.37798,3.5435,0.48182,3.84107,2.36886,0.33413,2.11881-0.6774,3.28386-3.11853,3.70086-0.25185,0.043-0.52528,0.0897-0.82581,0.11695l-0.94729-6.00721z'/%3E %3Cpath d='m951.81,470.606,6.6025-2.07914-0.32891-1.09305-1.51294,0.35511-0.46072-0.24548-3.57863-11.893,0.25926-0.42401,1.44579-0.57827-0.3289-1.09304-6.60249,2.07913,0.3289,1.09305,1.49077-0.34646,0.44747,0.20145,3.57864,11.893-0.24602,0.46803-1.42362,0.56963,0.3289,1.09305z'/%3E %3Cpath d='m965.54,457.738,0.31433,1.09468,1.67193-0.3998,0.4444,0.20245,1.30881,4.55813c-0.56356,0.22413-0.97784,0.37842-1.1996,0.44771-3.41021,1.06553-6.16697-0.62955-7.32211-4.6525-1.12284-3.91044,0.24784-6.87029,3.54979-7.902,0.64258-0.20077,1.27163-0.27637,1.94128-0.21721l0.44702,0.29773,1.10098,2.23728,1.61693-0.50522-1.09053-3.79793c-1.78108,0.0197-3.42289,0.26594-4.88616,0.72314-4.91713,1.53637-7.20583,5.58661-5.89047,10.1676,1.33457,4.64783,5.40358,6.88389,10.0553,5.43045,1.61693-0.50521,3.16663-1.33072,4.69929-2.46735l-1.49479-5.20581,0.26454-0.42396,1.25285-0.51406-0.31432-1.09468-6.46946,2.0214z'/%3E %3Cpath d='m968.961,448.387,0.49355,1.02007,1.24791-0.52701,0.49129,0.15867,5.35021,11.0578-0.16911,0.50721-1.14714,0.73527,0.49355,1.02007,5.84114-3.08282-0.49355-1.02007-1.28951,0.55074-0.49129-0.15867-2.53904-5.24769,5.96476-3.14807,2.53904,5.24769-0.14796,0.49605-1.18944,0.75759,0.49355,1.02007,5.82-3.07166-0.49355-1.02007-1.24722,0.52842-0.49129-0.15867-5.35022-11.0578,0.16912-0.50721,1.14645-0.73669-0.49355-1.02007-5.81999,3.07167,0.49355,1.02007,1.2902-0.54933,0.47014,0.16983,2.20658,4.56056-5.96477,3.14807-2.20658-4.56056,0.16912-0.50721,1.18874-0.75901-0.49355-1.02007-5.84114,3.08283z'/%3E %3Cpath d='m983.583,439.937,2.02787,3.54597,1.36886-0.85444-0.90834-2.3419,0.16871-0.45852,2.38104-1.48624,6.23168,10.8968-0.1532,0.5302-1.23374,0.9051,0.56113,0.98121,5.93381-3.70388-0.56113-0.98121-1.34597,0.70516-0.52106-0.10933-6.23169-10.8969,2.3826-1.48721,0.44609,0.0747,1.56227,1.93372,1.37042-0.85542-2.02787-3.54597-11.4515,7.14802z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230072c4' stroke='%23fff' stroke-width='6' d='m900.011,448.344s-114.465-33.7349-113.798-162.077l0.88167-169.649h225.834l0.8847,168.675c0.6677,128.342-113.802,163.051-113.802,163.051z'/%3E %3Cg fill='%23bcbcbc'%3E %3Cpath d='m802.805,155.04c0.18817,0,1.57517-1.31703,2.84532-2.47855,1.77396-0.88859,3.41438-2.13739,5.21718-2.97521,1.34299-0.77752,3.99711-1.3805,5.21566-1.98347,1.59794-0.83623,2.90147-1.79941,4.26875-3.47187,0.16389-2.21832,0.47498-3.81145,0.47498-6.4455,1.88625-0.90763,3.56006-1.7883,5.21566-2.48013,2.37338-0.66804,2.88781-1.61693,5.21718-1.98348,1.4993-0.52363,3.97738-0.49666,6.16411-0.49666,2.35972,0,3.84839,1.67723,5.96834,2.07392,2.51299,1.01395,3.68602,1.71531,5.69065,3.47187,1.13206,1.43286,1.83618,2.59756,3.76645,3.67657,1.52812,0.78387,2.95913,1.97078,4.7422,2.47855,1.95758,1.13454,3.69512,1.79147,5.21566,3.47187,1.39307,0.99015,1.96821,2.46109,3.3203,3.47028,1.56607,1.29958,3.05171,2.46903,4.74221,3.47188,2.03194,1.36145,4.04567,2.39603,7.33713,2.0993,1.7421-0.10314,3.61774-0.30307,5.69065,0.0841,2.32026,0,4.58438-0.0412,6.63908,0.49666,2.41891,0,4.37649,0.32688,6.63909,0.49508,2.11995,0.39669,4.28088,0.49666,6.63908,0.49666,2.05622,0.53633,4.31882,0.49508,6.63909,0.49508h6.63908,6.63908c2.41587,0,4.86209,0.0984,6.63909,0.49666,2.3931,0,4.45084-0.22374,6.63908-0.49666,2.57521,0,4.53886-0.47128,7.11407-0.49508h8.0625c2.06988,0.56648,4.71489,0.95524,6.16411,1.98347,1.89839,0.5411,2.8438,1.4408,4.7422,1.98348,1.45377,0.74578,3.66174,1.92635,4.7422,3.47028,1.33844,1.39954,2.7133,3.40364,3.79376,5.45535,1.32023,1.90413,1.82253,4.08119,2.84533,6.44549,0.54175,2.26592,0.9196,4.42076,0.94844,6.94216,0.51443,2.15008,0.47498,4.51597,0.47498,6.94215-0.54175,2.26116-0.66012,4.77779-1.42342,6.94216-0.082,2.41984-0.56603,4.60959-0.94844,6.44708-0.42187,2.02949-0.91809,3.33541-0.94844,5.95042v6.94215c-0.16693,2.27703-0.66467,3.9495-0.94845,6.4455-1.14723,2.16595-2.2459,4.69845-3.31878,7.43882-1.5782,1.09963-2.94699,2.6642-3.79376,3.96694-1.01218,0.62519-1.59793,1.57409-1.42342,1.98348,1.89536,0.6601,1.42342,1.97871,1.42342,4.46202,0.24583,1.91206,0.43097,4.28271,0.94844,6.44708,0.17299,2.36747,0.67984,3.81461,1.4219,5.45376,0.74813,0.97745,0.89381,0.49666-0.94844,0.49666-1.37031,1.07425-2.75731,0.51253-3.31878-1.4884-1.10626-1.33448-1.47046-2.94982-1.89688-5.45376-0.26253-2.29607-0.62977-4.53343-1.42342-5.95042-0.2428-2.79432-0.98638-2.76575-3.79377-2.97521-1.3354-1.18373-3.09874-1.4884-5.69064-1.4884-2.58128,0-2.79828-0.2634-2.84532,2.48014v6.94215c-0.44615,2.01204-1.42494,3.64325-1.89688,5.45376-1.41432,1.03617-2.15031,2.77528-3.79377,3.96695-0.78303,2.25164-1.92116,2.64357-4.26874,2.97521-0.82097-1.02506-2.15941-2.36272-2.84532-3.47029,1.32782-2.22783,2.48719-2.56423,3.3203-4.95868,1.00763-1.97395,1.59945-3.25448,2.37035-4.95868-1.01218-1.55822-1.92117-2.26116-2.84533-4.46361-0.77999-1.1996-1.86046-3.78129-2.37034-5.45376-1.55696-0.54268-4.00925-0.62995-5.21718-1.4884-2.30054-0.53474-2.94396,1.98348-5.68913,1.98348h-6.63908c-2.93637,0-3.66933,1.63914-6.16563,1.4884-0.73295,0.23801-2.51147-0.10473-5.21718,0-1.98186,0.69024-4.36889,0.49507-6.63908,0.49507-2.40525-0.0301-4.37345-0.58393-6.16411-0.99174-2.17913-0.59662-4.34613-1.20119-6.63908-1.48681-2.78462,0-3.82108,0.22215-5.69065,1.48681-1.47956,0.87749-3.6238,2.88318-5.21718,3.96695-0.67377,1.64549-1.02431,4.43029-1.89688,6.44708-0.50381,1.93428-1.32326,3.16086-1.89688,4.95868-0.6419,1.67723-1.24891,3.40364-1.4219,5.95042-0.16086,3.34176-0.89078,2.93237-2.84532,1.98348-0.8149-1.38367-2.11389-2.9054-2.84533-4.46361,0.43098-2.52298,0.91658-3.77812,0.94844-6.4455-0.46132-1.92476-1.53875-1.86287-2.84532-0.49666,0,2.59597,0.11989,4.59849-0.94844,5.95042-0.53416,2.04853-1.39307,2.93396-2.84532,3.96695-0.71019,1.84066-2.28688,2.68324-3.79376,3.47187-0.24129-0.0841,0-0.66486,0-1.98347-1.13661-2.26751-0.082-4.14943-0.082-6.94216,0.0288-2.50394-0.11381-4.16371,0.61307-6.44708,0-2.40397-1.11536-4.69052-1.47956-6.44549-0.88167-1.84225-1.39004-2.75307-3.79377-3.47188-1.68898-0.6712-4.12306-1.57884-5.21718-2.97521-1.37637-1.78512-2.25501-2.5198-4.26722-3.47028-2.18217-0.79022-3.24139-1.51379-4.7422-2.48014-1.46591-1.61692-2.65716-2.31828-3.32031-4.46202-0.98941-1.52489-1.15937-4.35729-1.89688-6.44708-0.16085-2.17706-0.78455-4.2002-1.4219-5.95042-0.28225-2.17706-0.62521-3.77018-1.42342-5.95042-0.26404-2.03901-0.85284-4.17164-1.4219-6.44549,0-2.42618,0.0394-4.79366-0.47498-6.94216v-6.94215c-0.34144-2.0041-0.46739-4.93806-0.94844-6.44708,0-2.69753-0.28681-4.22083-0.94844-5.95042-1.08502-1.75181-1.17303-2.53726-2.84532-2.97521-1.20794,1.54076-3.1989,2.16912-5.69065,2.48013-1.74058-0.39669-4.19742-0.65534-6.16562-1.4884-1.90143-0.4681-3.20194-1.22023-4.7422-1.98347-0.84222-1.2964-1.84832-2.76417-2.84532-3.96695-0.2944-2.58962-0.85891-3.92251-0.94845-6.44549,0-1.89303,0.0455-0.8886,1.89689-3.47187z'/%3E %3Cpath fill='%23fefefe' d='m830.89,172.905c3.01016-0.99728,9.58467-5.8759,13.3643-9.00378,4.30335-2.72739,13.1109,0.10252,13.4622-7.28709-0.53305,2.22171-5.62641,7.74585-8.11654,11.089-5.48978,3.48825,2.68529,7.04297,4.00373,2.05723,2.84772-5.09972,6.46988-10.277,12.1601-12.2836-1.03729,3.67567-1.80247,7.24947,0.67074,10.5203,0.88987-1.60958,1.11142-8.21765,1.01654-2.77785-1.79843,3.09405,2.65737,12.1065,2.76993,5.09501,0.71142-4.43341,0.442,4.79493,1.79515,6.18455,2.83476,5.46966,2.58586-5.03246,3.21522-7.11238,0.47597-3.93153,0.67377-2.89436,0.0994-0.0538-0.57065,3.56033,0.61326-7.43531,0.82573-1.37487,0.39079,3.16821-0.0413,11.7806,3.02049,4.94723,2.45143-4.06247,3.03655-4.12345,0.36045-0.51803-0.87211,1.35908,4.0207-7.40192,2.08539-1.2911-0.12835,4.39044,0.0335,10.9195,2.41805,13.7864,1.83004-2.2556,0.7635-13.983,2.60342-5.92305,0.70504,2.27261,0.021,8.59829,2.99262,3.74338,3.2098-3.78269,4.97961-7.06438,4.63014-12.2524,0.40126-2.64755,2.01363-6.90493,3.43146-2.21596-0.97348,6.11645,5.39407,10.007,4.61587,15.8908,2.85773-4.49568,1.57127-11.1875-0.33184-15.4883-0.40174-5.09276,7.74442-2.0564,5.71932,2.43583-0.2315,3.22891,4.39599,11.5246,4.76657,3.84607,0.62156-3.6492,2.63103-3.9712,2.19105,0.10944,0.83861,2.63565,4.4214,10.3898,4.03435,3.63695,0.31893-3.67806-0.59578-7.55212,1.0582-11.0187,1.17289,2.21486,1.29679,5.61678,2.68143,1.40272,2.83045-0.0846,1.11836,7.78332,4.69516,9.46672,1.43727,2.82372,5.01505,7.43827,4.01209,1.35967,0.55544-3.29147-2.39218-10.095-1.11413-10.9712,3.74549,4.75485,5.12978,11.0333,10.1799,14.8701,4.80966,2.44003,0.59783-6.74784,0.33537-9.11604-2.867-1.57623-5.20908-7.70196-1.15198-2.91591,2.34206,4.25118,9.46311,7.97131,11.6877,8.89564-2.12213-1.56996-4.05621-2.15463-0.45716,0.018,2.66474,1.09269-1.58101-6.64142-3.12753-7.95206-1.37513-2.47279-8.07162-6.07864-6.17271-7.7839,5.23969,1.13266,6.77331,6.86107,9.95197,10.4396,1.98126,1.65983,6.75982,5.18605,4.09075-0.0764,1.49352-0.62278,8.86655,7.55936,7.10936,0.99791-1.21487-2.82231-7.67666-7.91561-6.96393-8.22312,2.20398,3.19048,0.87344,0.90986-0.8825-0.76238,6.38867,0.70949,10.1398,7.08678,14.1572,11.1402,0.50039,1.92977,1.96129,11.3292-0.0119,5.16368-4.15457-1.77377,1.603,8.43181-2.93355,7.10807-0.20511-2.26067-4.20708-7.00283-2.27102-2.31615,3.33625,6.84409,0.82153,14.361,1.11885,21.5783,0.0883,3.55373-0.082,7.08496-0.33537,10.6211,0.24069-2.60941,0.4433-6.95281,0.0161-1.25452-0.14842,3.95896-1.6073-5.71316-3.58581-6.2059-0.41055-1.80097-1.96739-10.901-3.2803-5.47185,0.0104,5.32009,5.14076,10.9028,1.04345,15.5915-1.38269,1.28818-2.11236,4.99701-2.85006,1.1098-2.01798-4.59595-3.30949-9.46095-6.84794-13.2155-1.49315-2.92571-6.61967-10.0186-5.19949-2.5725,0.88879,3.36447,1.4857,6.77784,1.25569,10.2672-1.99097-5.1616-4.70684-9.96075-7.37811-14.7269,0.3869,2.22649,3.09039,11.7834,0.73938,5.58987-1.62661-5.08029-4.24819-10.1509-9.31077-12.4046-1.39782-0.17335,3.40031,8.93365,1.55009,8.99929-0.44381-2.93678-3.10484-9.47314-5.7487-8.28005,0.1185,5.24793,2.25357,10.1348,1.03362,15.4864,0.26607,5.219-3.21916-5.18977-4.3598-6.58553-5.12431-3.13598,0.37497,8.83935-3.68753,4.20655-3.26935-2.29695-5.01393-4.83396-4.69516-9.11605-6.08182-1.03487-3.73498,5.39502-4.02291,9.05002-0.51339,2.77358-2.01069,8.04045-3.70171,8.85003-0.70603-4.00858-0.14054-8.20487-0.32271-12.2908,0.97716-2.34563-0.0982-8.37465-2.94714-5.50964-0.48257,5.29352,2.9743,12.0158-0.95631,16.3378-2.0801,2.3795-5.9375-3.71409-9.57596-2.08571-4.62086-2.36747-2.72652-9.7724-5.86328-13.6612-3.11725-3.26284-1.65536,13.0789-3.7059,5.3359,1.47374-4.93096-7.51607-6.85911-5.75896-1.60077,2.20795,2.23726,2.60646,5.04299,2.31646,8.01757,0.62655,3.49911-1.97233,4.5372-2.57748,0.60989-0.24863-4.3276-7.65601-6.12206-6.14058-0.43021-3.88245-2.49914-0.23824,9.85086-4.99598,6.05452-5.36181-3.7405-8.80139,3.31203-14.6754,1.92791-3.33986,0.55613-11.3287,1.42615-6.48435-3.42362,4.52943-2.7321,6.44443-10.9898,12.7568-6.76537,4.82565-0.28129,9.95052-3.67983,13.8907-6.84495,3.22258-2.17258,1.7812-7.6997-2.16866-4.27267-3.27934,4.92682-12.6992,4.92224-15.524,4.53229,2.79931-2.65078,11.3625-3.04043,9.23663-7.68244-3.14315,0.25665-8.66152,4.96533-10.4304,2.22426,1.09847-1.20979,4.70733-4.56024,0.54478-3.09798-5.27085,1.71677-10.9218,1.29897-16.3532,0.86776-5.4353-5.32188,7.928-3.86431,7.73453-7.36265-1.31761-0.10864-6.52147,0.59403-4.24666-1.31787,4.39919,0.0865,8.83744,0.42098,11.992-3.75434,1.90848-1.98275,8.54789-6.5335,6.92454-8.13266-4.8995,2.82138-10.0443,7.60914-16.1838,4.81979,5.27508-3.93443-2.03747-4.27138-5.37085-3.88706-2.42534,0.74896-9.16747-2.00823-3.40053-1.83108,3.92909,0.83158,7.83231-4.61133,1.78491-3.56902-1.26541-0.38878-2.62461-0.14135-3.92934-0.21075z'/%3E %3Cpath fill='%23fefefe' d='m801.857,164.957c-0.23136-2.56198-1.26283-5.10739-0.83642-7.69477,1.26199-1.84481,3.00745-3.18724,4.63018-4.70114,2.90484-1.61981,5.66804-3.59092,8.95369-4.38807,2.28115-0.69646,4.25854-2.20213,5.7479-4.04248,0.73309-2.21398-0.56236-5.75944,1.51487-6.95213,2.55642-1.39969,5.32409-2.30112,7.92882-3.58637,2.84468-0.91895,5.92331-1.06205,8.87362-0.70987,2.36179,1.01464,4.75592,1.93853,7.09929,2.99747,2.11924,1.03086,3.67999,2.77694,5.11286,4.5868,1.67465,1.52753,3.77083,2.51915,5.7413,3.60912,1.6371,0.11322,1.09701,2.23527,0.058,2.15219-0.6743,3.14003-4.59158,0.47595-5.33677-1.37364,0.65699-1.21901,0.38844,2.78457-0.86509,2.83893-2.20894,0.97651-2.14283-2.78465-2.46626-4.2221,0.28044-1.2152-0.67864-2.65619-1.17917-0.74693-1.48609,1.6347,1.60134,5.13888-1.62587,4.173-2.39804-0.31622-5.07777-0.81085-7.16045,0.77882-1.74322,1.81824,1.88708,2.56492,3.01891,3.44643,1.52572,1.43611,3.56554,0.0173,5.34179-0.15924,2.4299-0.83935,5.16356-0.40458,7.41596,0.72101,1.041,2.24835-1.04678,4.48315-3.03758,5.39487-1.85974,1.00879-3.93569,1.44558-6.00856,1.69755-3.03896,0.13471-2.44922,3.90074-5.40932,4.20221-1.89031,0.80048-4.01961,0.9837-6.03641,0.7181-0.39697-1.08631,2.00358-2.80708,2.25276-4.46644,2.17427-2.58539-3.11509-2.11424-2.34758,0.35068,0.36642,1.67133-3.29636,4.13969-2.05854,1.29917,0.0586-1.52756,1.6414-3.89874-1.0236-2.7979-1.45836-0.0133-4.44773-0.0666-3.62523,2.20009-1.80834,0.38287-4.12631,0.42325-5.67717-0.47586-0.9259-2.4702-3.81144-3.5558-5.62049-1.31137-1.8025,2.38467-4.30551-0.74156-6.09503,0.49461-0.0237,2.23527,2.28093,3.40462,4.32116,3.38734,2.06562-0.18234,4.18492-0.56558,6.26763-0.22477,1.91711,2.28659-1.83037,3.00321-3.60897,2.6894-2.39695-0.0867-4.54102-1.45657-6.97935-1.26693-1.16492-0.16461-3.8206,1.28459-1.31556,1.4787,1.85975,0.37786,5.66791,0.25128,4.81789,3.16927-1.45811,0.67958-3.26393-0.0665-4.91285,0.63698-0.96797-0.25022-3.87338,0.5347-2.25582-0.29811-0.85609-1.48198-2.51249-2.32067-3.61455-3.60462z'/%3E %3Cpath d='m812.447,153.269c-0.11078,0-1.11233,0.6966-2.01221,1.40272-1.4735,0.78863-3.04715,2.13104-4.02442,2.80542-0.76938,0.61567-0.76482,0.88384-1.67533,1.05204,1.59794-0.22691,2.30964-0.63313,3.68754-1.40272,1.7421-0.20945,3.42956-0.57917,4.35979-1.40271,0.87257-0.30466-0.0652-1.70261-0.33537-2.45475z'/%3E %3Cpath d='m827.873,136.789c0.19272,0,0.58576,1.09647,1.33996,1.75339,0.48256,1.34559,0.92719,2.29607,1.0061,3.85746,0.41125-1.71372,1.11385-3.09104,1.34148-4.90949-0.52202-0.92351-0.55693-1.3567-2.01221-1.40271,0,0.9473,0.11077,0.32846-1.67533,0.70135z'/%3E %3Cpath d='m833.908,137.14v0.35068c0-0.94572-0.0213-0.46334,0.33537,1.40271,0.55389,1.1758,0.67073,2.43729,0.67073,4.20814,0.88016-0.65693,1.61463-1.96761,2.01222-3.1561,0-2.76893-0.37483-2.6055-3.01832-2.80543z'/%3E %3Cpath d='m846.315,177.463h0.33537c-0.98638,0-0.43097,0.0603,1.34147-1.05204,1.14724-0.79973,2.08657-1.98188,3.68906-2.45474,1.5524-1.27419,2.74668-1.87082,4.35827-2.45316,0.78607-0.37766,1.47957-1.033,2.34758-0.35068-0.24887,1.72959-0.53568,2.38334-2.01221,3.15451-0.76331,0.99967-1.96517,1.58361-3.0168,2.10407-1.09109,0.50142-2.29143,0.52681-2.68295,1.75339-1.82404,0.83941-2.04863,0.69818-4.35979-0.70135z'/%3E %3Cpath d='m852.687,187.631c0.5979-0.47286,2.69813-2.66261,3.68754-3.50519,1.11992-1.54394,2.25198-2.7245,3.35369-3.50678,0.97727-1.50427,2.22921-2.51187,3.01831-3.85746,0.93175-1.17898,1.61766-2.17706,2.68295-3.50519,0,1.53282-0.13961,3.56549,0.33385,4.55722,0,2.11835-0.23369,2.69753-1.00458,4.20814-0.76179,1.24086-1.32934,2.06281-3.01832,2.80543-1.52358,0.84416-2.43712,1.14089-3.68906,2.10248-0.95451,0.61408-1.94847,1.22499-3.01831,1.75339-0.95907,0.43001-0.51899,0.24277-2.34607-1.05204z'/%3E %3Cpath d='m842.291,195.696h0.33536c-0.98637,0-0.43248,0.0603,1.34148-1.05204,1.43101-1.49633,2.57065-2.01679,4.35979-2.80542,1.3612-0.10949,3.0077-0.46334,4.02442-1.05203,0.81035-0.14916,1.37486-0.66487,2.0107,0,1.05315,1.48839,1.34299,1.90889-0.33537,2.80542-0.80276,0.71246-2.21859,1.42969-3.35217,1.75339-0.83766,0.72198-2.49478,0.76641-4.02442,1.05203-1.37031,0-2.1321,0.16186-2.68295-0.70135l2.68295,0.70135c-1.37031,0-2.1321,0.16186-4.35979-0.70135z'/%3E %3Cpath d='m856.71,195.696v-0.35068c0,0.97904-0.041,0.46017,0.67074-1.40271,1.25649-1.96126,1.72995-3.04344,3.35368-3.50678,0.76027-0.96159,2.07747-1.21071,3.68906-1.75339,0.60396,1.05362,0.13961,2.28178,0,3.50678-0.43856,1.30909-1.63436,2.23259-2.34758,3.1561-1.04556,0.74261-1.47198,1.45666-3.01832,1.75339-1.27926,0-0.60093-0.0333-2.34758-1.40271z'/%3E %3Cpath fill='%23c4c4c2' stroke='%23000' stroke-width='1.3578' d='m817.476,151.165c-0.74964,0,1.32175-0.7807,2.01222-1.05204,0.55237-1.21706,0.99093-2.07868,2.01221-2.80384,1.67988,0.13488,2.50388,0.64106,3.35368,1.75181,1.41128,0.40304,1.91965,1.10598,3.68906,1.40271,0.65708,0.58076,1.54634,0.64741,0,1.05203-1.05163,0.58077-2.37338,0.70136-4.02443,0.70136-1.72995,0.13012-2.9652,0.5284-4.02442,1.05203-2.24439,0-1.88474,0.0778-3.01832-2.10406z'/%3E %3Cellipse fill='%23000' cx='138.108' cy='302.603' rx='1.10487' ry='1.10489' transform='matrix(1.517505,0,0,1.5867785,612.59226,-330.0498)'/%3E %3C/g%3E %3Cg fill='%23005121' stroke='%23002b0e' stroke-width='1.9397'%3E %3Cpath d='m827.872,247.944h1.34148c-4.20501,0-1.69202-0.29355,5.36438,5.60927,2.95611-2.57535,2.9212-2.92285,5.36591,1.40271,1.41128,2.46268,1.82556-0.25071,4.0229-2.80384,1.05922,5.09515,1.73755,10.4378,5.36591,5.60926,4.14431,0,8.48286-0.36019,10.7303,1.40272,2.71634,5.27604,1.82708-0.89495,4.02443,1.40271,5.90613,0.74103,5.79384-5.29667,12.2266-6.85806,3.99863,5.22526,5.74983,1.20437,10.7318-1.40113,3.69968,1.08219,7.18691,6.95168,7.89103,1.24563,3.02894-5.16656,3.29299-4.72702,5.3659,0,2.94548,2.77369,4.1868-1.38685,6.70586-2.80384,4.49031,2.74671,9.49808,3.12754,16.0962,1.40271,1.11689,4.67148,3.93338,2.64516,6.70586,1.40113,5.93345,2.60707,8.00333,3.40522,14.7547,0,3.34458-4.13198,1.45073,0.11583,4.0229,2.80542,5.0017-1.62327,3.62077-1.9676,9.39033-1.40271,5.79839,0,6.2673-0.14598,8.04734-4.20655,2.91361,3.04661,3.96676,5.24272,8.04733,1.40271,6.25213,0.192,4.31883,0.82513,8.04886-1.40271,2.75882,6.38837,3.4068,1.77243,6.70586,4.20655-2.17307,5.76159-5.51159,8.46388-9.38881,11.2201-2.57977,4.46837-4.19287,9.29377-9.38882,11.2217-3.79073,4.04311-7.83033,6.38678-12.0718,9.8174-5.81508,1.52013-12.2159,1.40271-18.7791,1.40271h-18.7776-18.7791-18.7776c-4.00622,2.09296-10.5588,3.09105-16.0962,4.20655-6.18384,0-13.1932,0.0762-17.4361-1.40271-2.87568-3.00536-7.91987-6.36457-10.7303-9.8174-2.84381-2.39762-2.92575-7.07704-5.3659-9.8174-2.24439-4.01297-2.93789-10.2918-5.36439-14.0256v-9.8174z'/%3E %3Cpath d='m957.978,260.567v1.40271c0-3.92093,0.16541-1.83749-2.68295,5.60927-0.57665,1.80893-1.83922,2.23418-4.02442,2.80542'/%3E %3Cpath d='m945.906,266.177h1.34148c-4.9668,4.90474-8.30987,7.16431-9.39033,12.6228l9.39033-12.6228c-4.9668,4.90474-8.30987,7.16431-9.39033,12.6228'/%3E %3Cpath d='m927.127,259.165c0,0.12535-0.18817,5.00311-1.34147,7.01197'/%3E %3Cpath d='m921.763,268.982v1.40271-1.40271z'/%3E %3Cpath d='m911.032,260.567h1.34148-1.34148z'/%3E %3Cpath d='m835.919,260.567c0.64039,0,3.27933,4.4525,6.70586,7.01198-0.85284,4.10341-2.16396,8.85105,0,12.6228'/%3E %3Cpath d='m846.649,268.982c0.64038,0,3.27933,4.45409,6.70737,7.01356l-6.70737-7.01356c0.64038,0,3.27933,4.45409,6.70737,7.01356v1.40272c0-4.3335-0.34447-8.87169,1.33996-11.2217,1.49171,2.63882,3.37493,6.88187,4.02443,2.80543,7.55414-0.28245,11.2007-2.50076,16.0962-4.20655,0,2.06281-0.31716,1.07107,1.34147,2.80384'/%3E %3Cpath d='m967.367,261.97h1.34148c-2.52968,2.20404-4.47057,6.69938-6.70738,9.81741'/%3E %3Cpath d='m912.374,257.762h10.7303'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m824.718,268.429c-16.1311,0-21.4775,16.8577-37.6086,16.8577-0.31034,0-0.6046-0.0255-0.90714-0.0377v1.02053c-0.0608,11.6854,0.85765,22.57,2.53244,32.7327,14.8808-1.08684,20.4088-16.8577,35.9833-16.8577,16.1311,0,21.5153,16.8955,37.6464,16.8955,16.131,0,21.5153-16.8955,37.6464-16.8955s21.5153,16.8955,37.6464,16.8955,21.5153-16.8955,37.6464-16.8955c15.5338,0,21.0768,15.6596,35.8699,16.8199,1.7721-10.4347,2.7084-21.6456,2.6458-33.6777v-0.0377c-0.3025,0.0122-0.5968,0.0377-0.9071,0.0377-16.1311,0-21.4776-16.8577-37.6086-16.8577-16.1311,0-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577c-16.1311,0-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577z'/%3E %3Cpath d='m824.718,334.234c-12.5486-0.00001-18.585,10.1721-28.2348,14.7033,3.37126,9.2945,7.44582,17.7549,11.9818,25.5134,4.58242-3.46521,9.4537-6.46339,16.253-6.46339,16.1311-0.00001,21.5153,16.8577,37.6464,16.8577,16.131,0,21.5153-16.8577,37.6464-16.8577,16.1311-0.00001,21.5153,16.8577,37.6464,16.8577s21.5153-16.8577,37.6464-16.8577c6.64925,0,11.4555,2.86935,15.9506,6.23661,4.53503-7.72309,8.62643-16.1692,12.0196-25.4-9.49735-4.59095-15.5359-14.5899-27.9702-14.5899-16.1311-0.00001-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577c-16.1311-0.00001-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577z'/%3E %3Cpath d='m900.011,400.04c-16.1311-0.00001-21.5153,16.8955-37.6464,16.8955-15.2555,0-20.902-15.1039-35.114-16.7444,18.9944,21.1594,40.5334,33.9695,55.2223,41.0104,4.96772-3.85569,10.1124,4.68691,17.5381,4.68691,7.37272,0,12.4898-8.58651,17.4247-4.7625,14.5266-7.07257,35.8026-19.9033,54.6932-40.8592-13.7469,2.00976-19.4462,16.6688-34.4714,16.6688-16.1311,0-21.5154-16.8955-37.6464-16.8955z'/%3E %3C/g%3E %3Cg stroke='%23522108'%3E %3Cg fill='none'%3E %3Cpath stroke-width='0.7371' d='m800.148,342.754c2.64653-0.92192,15.4376-5.07293,15.8792-4.61277,0.44159,0.46176,24.702,24.9077,24.702,24.9077l-20.2906,4.15101-20.2906-24.4459z'/%3E %3Cg stroke-width='0.7513'%3E %3Cpath d='m848.358,374.785c0.37408-5.78836,11.2095-38.709,11.2095-38.709'/%3E %3Cpath d='m852.095,375.177c0-0.36216,8.59483-38.7388,8.59483-38.7388'/%3E %3Cpath d='m855.039,375.237c0.37279-2.17048,7.14479-38.7986,7.14479-38.7986'/%3E %3Cpath d='m851.349,364.293c1.86783,0,5.60476-1.44741,5.60476-1.44741'/%3E %3Cpath d='m852.47,359.952c0-0.36216,5.60477-1.4474,5.60477-1.4474'/%3E %3Cpath d='m853.216,354.526,5.97884-1.08524'/%3E %3Cpath d='m855.832,349.823c0,0.36216,4.10973,0.36216,4.10973,0.36216'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m914.897,400.376c-0.44159-9.91194-13.2326-66.2848-13.2326-66.2848'/%3E %3Cpath d='m910.485,398.517c0-0.62016-10.146-63.8063-10.146-63.8063'/%3E %3Cpath d='m906.074,393.56c-0.44007-3.71671-7.498-58.8493-7.498-58.8493'/%3E %3Cpath d='m914.455,392.322c-2.20494-1.85836-8.82126-4.33687-8.82126-4.33687'/%3E %3Cpath d='m911.367,382.41c-2.20493,0-6.61632-2.47852-6.61632-2.47852'/%3E %3Cpath d='m910.044,374.977c0-0.62016-6.61633-2.47852-6.61633-2.47852'/%3E %3Cpath d='m909.162,365.685-7.05792-1.85835'/%3E %3Cpath d='m906.074,357.631c0,0.62016-4.85147,0.62016-4.85147,0.62016'/%3E %3Cpath d='m904.75,350.198c-0.88167,0-4.85147,1.23819-4.85147,1.23819'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m948.797,372.677c-2.20493,0-6.61632-1.84543-6.61632-1.84543'/%3E %3Cpath d='m952.326,386.053c-0.44159-7.38011-13.2326-49.3536-13.2326-49.3536'/%3E %3Cpath d='m947.915,384.67c0-0.46175-10.146-47.5082-10.146-47.5082'/%3E %3Cpath d='m943.504,380.979c-0.44007-2.76734-7.498-43.8173-7.498-43.8173'/%3E %3Cpath d='m947.473,367.142c0-0.46175-6.61633-1.84542-6.61633-1.84542'/%3E %3Cpath d='m946.592,360.224-7.05792-1.38367'/%3E %3Cpath d='m943.504,354.227c0,0.46176-4.85147,0.46176-4.85147,0.46176'/%3E %3Cpath d='m942.18,348.693c-0.88167,0-4.85147,0.92192-4.85147,0.92192'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23dd8b59' stroke-width='0.7371'%3E %3Cpath d='m895.426,391.646c0-0.46175,1.32326-115.771,1.32326-115.771s3.9698-0.46175,3.9698,0-0.44008,115.31-0.88167,115.771c-0.4416,0.46175-4.85299,0.92192-4.41139,0z'/%3E %3Cpath d='m938.656,280.947c0,0.92351-0.88319,97.3219-0.88319,97.3219l-3.08813,3.69085,0.88319-101.013h3.08813z'/%3E %3Cpath d='m861.903,369.507c0.44007-2.76893,0.44007-86.2526,0.44007-86.2526l-2.64653-0.46175-0.44007,85.3306,2.64653,1.38367z'/%3E %3Cpath d='m845.141,338.141c1.76486,0,31.7599-5.07293,31.7599-5.07293l-0.44159,5.07293-29.5534,3.2291-1.76486-3.2291z'/%3E %3Cpath d='m845.581,311.389c1.76486,0.46176,36.1713-9.6857,36.1713-9.6857s0,3.2291-0.4416,3.2291c-0.44007,0-35.7297,9.6857-35.7297,9.6857v-3.2291z'/%3E %3Cpath d='m846.906,298.013c-0.44159,1.84543,0.44008,4.1526,0.44008,4.1526l28.6718-10.1474s1.32327-2.30718,0-2.30718c-1.32326,0-29.5534,9.22554-29.1118,8.30203z'/%3E %3Cpath d='m884.84,291.556c0.88167,0,29.5534-9.6857,29.5534-9.6857s0.44159,4.15101,0,4.15101c-0.44008,0-26.9069,8.30203-26.9069,8.30203l-2.64653-2.76734z'/%3E %3Cpath d='m882.634,303.549s-0.88167,4.15101-0.44008,4.15101c0.44008,0,37.493-10.1474,37.493-10.1474v-2.76735l-37.053,8.76379z'/%3E %3Cpath d='m883.957,336.297,0,3.2275,31.7599-4.61118-0.88167-2.30717-30.8782,3.69085z'/%3E %3Cpath d='m920.57,338.603,0.44007,2.76734s31.7599-4.15102,31.7599-4.61277c0-0.46016,0-3.22751-0.44008-3.22751-0.44159,0-31.3198,5.53469-31.7599,5.07294z'/%3E %3Cpath d='m920.128,309.084,0.4416,3.22751,37.493-10.6076s0.88319-2.76734,0.4416-2.76734c-0.4416,0-37.4946,11.5311-38.3762,10.1474z'/%3E %3Cpath d='m924.098,294.324s-0.44008,2.76734,0,2.76734c0.44159,0,27.7901-6.91835,27.7901-7.38011,0-0.46016,2.64653-3.22909,0.44159-2.76734-2.20645,0.46175-27.3485,8.76378-28.2317,7.38011z'/%3E %3C/g%3E %3Cg fill='%23fecf3e' stroke-width='0.7371'%3E %3Cpath d='m864.108,303.549c3.9698-1.38367,1.32327-4.61277,2.20494-4.61277,0.88319,0,3.9698,2.30559,5.73466,0.46017,1.76486-1.84384,3.08812-7.37853,2.20645-6.91836-0.79468,0.41547-19.8018,7.55232-23.9258,7.63379,2.58255,0.99754,10.3417,4.63553,13.7798,3.43717z'/%3E %3Cpath d='m925.421,297.091s2.20646,5.53469,4.41139,4.61277c2.20494-0.92192,4.41139-2.76734,4.41139-2.76734s1.76486,4.61277,4.85147,3.68926c3.08813-0.92192,4.85299-5.99644,4.85299-5.99644s3.0866,0.92351,4.40987,0.46175c1.32478-0.46175,3.08812-7.84027,3.08812-7.84027l-26.0252,7.84027z'/%3E %3Cpath d='m922.775,341.832c-0.44159,0.92192,2.20646,3.2291,4.41139,3.2291,2.20494,0,3.08813-3.2291,3.52821-2.30718,0.44159,0.92351,0.44159,5.07452,6.17625,3.69085,5.73465-1.38367,5.73465-5.53469,5.73465-5.53469s-1.76486,1.38367,2.20494,1.84384c3.96979,0.46175,7.93959-5.99644,7.49951-5.99644-0.44159,0-28.6718,5.53627-29.555,5.07452z'/%3E %3Cpath d='m922.775,311.851s-4.41139,5.07293-3.08812,11.9913c1.32326,6.91994,3.08812,12.9148,3.52972,12.9148,0.44159,0,5.29306-9.22395,10.5861-9.6857,5.29306-0.46175,14.9975,5.07452,14.9975,5.07452s-1.32326-11.071-0.88167-16.1439c0.44008-5.07452,7.9396-13.8367,7.9396-13.8367l-33.0832,9.68571z'/%3E %3Cpath d='m846.464,341.832c0.44159,0,0,4.15102,3.5282,3.2291,3.52972-0.92351,4.41139-3.2291,4.41139-3.2291s0.88167,5.07293,5.73466,4.61277c4.85146-0.46175,7.49799-5.99644,7.49799-5.99644s0.4416,4.15101,3.52972,2.76734c3.08813-1.38367,3.9698-4.61276,3.9698-4.61276l-27.7901,4.15101-0.88167-0.92192z'/%3E %3Cpath d='m846.464,314.619s-3.9698,1.38367-2.64653,9.6857c1.32326,8.30203,4.41139,12.9148,4.85146,12.9148,0.4416,0,3.9698-7.84027,9.26286-9.22394,5.29458-1.38526,14.5574,4.15101,14.5574,4.15101s-0.88319-7.38011,0.44159-14.2985c1.32327-6.91994,5.73314-11.9929,5.73314-11.9929s-30.8767,8.76378-32.2,8.76378z'/%3E %3Cpath d='m885.722,292.94c1.76486,0.46175,4.85299,5.07293,6.61633,4.15101,1.76486-0.92191,4.41139-3.68926,4.41139-3.68926s-0.44159,5.53469,3.08813,4.61118c3.5282-0.92192,3.96979-4.61118,3.96979-4.61118s2.64653,1.38367,4.85147,0c2.20645-1.38367,4.41139-8.30361,3.52972-8.30361s-25.5836,8.30361-26.4668,7.84186z'/%3E %3Cpath d='m884.84,306.317c0,0.92192-4.41139,8.30203-3.08812,15.2204,1.32326,6.91835,3.96979,13.3765,4.41139,13.3765,0.44159,0,7.05792-7.38011,12.7926-8.76378,5.73313-1.38367,14.1143,4.61277,13.6742,4.61277-0.44159,0-2.20645-6.91994-2.20645-11.9929,0-5.07452,6.61633-20.7567,6.61633-20.7567l-32.2,8.30362z'/%3E %3Cpath d='m884.84,339.525c0,0.46176,1.32327,3.69085,4.41139,3.69085,3.08661,0,3.52821-3.22909,3.52821-3.22909s-0.4416,5.53468,4.41139,5.07452c4.85146-0.46176,6.61632-5.53628,6.61632-5.53628s0.4416,2.76893,4.41139,1.38526c3.9698-1.38526,9.26286-5.99644,8.82127-5.99644-0.44008,0-31.7584,5.99644-32.2,4.61118z'/%3E %3C/g%3E %3Cg fill='%23dd8b59' stroke-width='0.7371'%3E %3Cpath d='m846.464,372.734s4.41139,47.5082,55.1386,46.1245c50.7272-1.38367,64.8415-47.9683,64.8415-47.9683s-21.6138-0.92351-22.0554-0.92351c-0.44007,0-17.644,22.1403-39.6995,21.6786-22.0554-0.46175-29.1118-5.99644-33.9648-10.6076-4.85147-4.61277-9.26286-11.5311-9.26286-11.5311l-25.5836-10.6092,1.32326,10.1474,9.26286,3.68927z'/%3E %3Cpath d='m983.411,367.799c-0.4416-1.38367-1.52813-6.13449-1.52813-6.13449v-5.53468l2.44166-5.60451s-38.3762,5.74891-38.3762,6.21066c0-0.53157-0.23673,10.925-0.23673,10.925l37.6994,0.13805z'/%3E %3Cpath d='m976.149,356.13-0.88167,9.6857,6.17473,0-0.44007-9.6857-4.85299,0z'/%3E %3Cpath d='m969.532,356.592-0.44159,10.1459,3.9698-0.46017,0.44159-9.6857-3.9698,0z'/%3E %3Cpath d='m962.916,366.738,0-7.84028,3.96979-1.38367,0.4416,7.84028-4.41139,1.38367z'/%3E %3Cpath d='m955.416,366.278,0.88319-6.91836,4.40987,0.46017,0.4416,7.38011-5.73466-0.92192z'/%3E %3Cpath d='m947.035,366.278,0.4416-5.99644,4.41139-0.46175,0,6.91836-4.85299-0.46017z'/%3E %3Cpath d='m942.625,369.967,41.9044,0.92351,0.44159-3.2291-43.2292-0.46175,0.88319,2.76734z'/%3E %3Cpath d='m944.389,358.436c4.85299,0,41.4643-7.38011,41.4643-7.38011s1.32327-4.61118,0-4.61118c-1.32326,0-41.4643,8.76378-41.4643,8.76378v3.22751z'/%3E %3Cpath d='m798.825,342.294,33.5232,17.0658-0.88168,2.30559s-32.2015-15.6821-32.2015-16.1439c0-0.46016,0.4416-2.30559-0.44007-3.22751z'/%3E %3Cpath d='m814.263,337.219c0,1.38368,4.85298,29.5189,4.85298,29.5189s3.08813,0.46175,3.08813,0c0-0.46017-5.29458-29.0571-5.29458-29.0571l-2.64653-0.46176z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cg stroke-width='0.7513'%3E %3Cpath d='m882.044,389.315c0.44159-7.66848,13.2326-51.282,13.2326-51.282'/%3E %3Cpath d='m886.456,389.834c0-0.47979,10.146-51.3216,10.146-51.3216'/%3E %3Cpath d='m889.931,389.913c0.44007-2.87547,8.4343-51.4007,8.4343-51.4007'/%3E %3Cpath d='m882.486,383.084c2.20494-1.43773,8.82126-3.35527,8.82126-3.35527'/%3E %3Cpath d='m885.574,375.416c2.20493,0,6.61632-1.91753,6.61632-1.91753'/%3E %3Cpath d='m886.897,369.665c0-0.4798,6.61633-1.91753,6.61633-1.91753'/%3E %3Cpath d='M887.779,362.476,894.837,361.038'/%3E %3Cpath d='m890.867,356.245c0,0.4798,4.85147,0.4798,4.85147,0.4798'/%3E %3Cpath d='m892.19,350.494c0.88167,0,4.85147,0.95794,4.85147,0.95794'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m919.474,388.989c0.44159-7.38011,13.2326-49.3536,13.2326-49.3536'/%3E %3Cpath d='m923.885,387.605c0-0.46175,10.146-47.5082,10.146-47.5082'/%3E %3Cpath d='m928.296,383.914c0.44007-2.76734,7.498-43.8173,7.498-43.8173'/%3E %3Cpath d='m919.915,382.992c2.20494-1.38368,8.82126-3.2291,8.82126-3.2291'/%3E %3Cpath d='m923.003,375.612c2.20493,0,6.61632-1.84543,6.61632-1.84543'/%3E %3Cpath d='m924.326,370.077c0-0.46175,6.61633-1.84542,6.61633-1.84542'/%3E %3Cpath d='m925.208,363.159,7.05792-1.38367'/%3E %3Cpath d='m928.296,357.162c0,0.46176,4.85147,0.46176,4.85147,0.46176'/%3E %3Cpath d='m929.62,351.628c0.88167,0,4.85147,0.92192,4.85147,0.92192'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m877.156,384.068c-0.44159-7.42463-13.2326-49.6514-13.2326-49.6514'/%3E %3Cpath d='m872.744,382.676c0-0.46454-10.146-47.7948-10.146-47.7948'/%3E %3Cpath d='m868.333,378.963c-0.44007-2.78404-7.498-44.0817-7.498-44.0817'/%3E %3Cpath d='m876.714,378.036c-2.20494-1.39202-8.82126-3.24858-8.82126-3.24858'/%3E %3Cpath d='m873.626,370.611c-2.20493,0-6.61632-1.85656-6.61632-1.85656'/%3E %3Cpath d='m872.303,365.043c0-0.46454-6.61633-1.85656-6.61633-1.85656'/%3E %3Cpath d='m871.421,358.083-7.05792-1.39202'/%3E %3Cpath d='m868.333,352.05c0,0.46454-4.85147,0.46454-4.85147,0.46454'/%3E %3Cpath d='m867.01,346.482c-0.88167,0-4.85147,0.92748-4.85147,0.92748'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='%23b6b6b4' stroke-width='0.73708421' d='m834.995,359.359s-8.82127-1.38367-8.38119,0.92192c0.44159,2.30559,4.41139,4.61277,4.85298,5.99644,0.44008,1.38367-1.32326,6.45661,1.32327,5.99644,2.64653-0.46175,5.29306-2.30718,5.29306-3.69085s-0.44159-7.84027-0.44159-7.84027l-2.64653-1.38368z'/%3E %3Cg fill='none' stroke-width='0.7371'%3E %3Cpath d='m844.699,372.274c1.32326,0,11.4693,2.30559,11.4693,2.30559l10.5861,14.7602'/%3E %3Cpath d='m852.199,374.118c0.44008,0.46175,9.26286,31.3643,51.6089,31.3643s52.4921-35.0535,52.4921-35.0535'/%3E %3Cpath d='m962.916,371.351s-20.2906,46.1245-59.1084,42.8954c-38.8178-3.22751-44.9925-18.4495-48.0807-26.2898-3.08813-7.84186-4.85147-14.2985-4.85147-14.2985'/%3E %3Cg%3E %3Cpath d='m951.888,333.99c0.44159-1.38367,1.76486-29.0571,1.76486-29.0571'/%3E %3Cpath d='m982.765,347.828-27.3485-45.2026'/%3E %3Cpath d='m899.838,277.258c0-0.46175,13.6742,5.99644,13.6742,6.45661,0,0.46175,48.5208,67.8031,48.9623,67.8031'/%3E %3Cpath d='m938.214,283.714,12.351,5.53627,3.9698,10.1459'/%3E %3Cpath d='m861.462,282.793c-0.44159,0,13.6742,11.0694,13.6742,11.0694l1.76486,9.22553'/%3E %3Cpath d='m813.381,350.134c6.17473-2.76734,48.9623-41.9735,48.9623-41.9735'/%3E %3Cpath d='m801.912,342.754c5.29458-4.61277,48.0807-42.4336,48.0807-42.4336'/%3E %3Cpath d='m882.194,306.777,45.4341,78.8724'/%3E %3Cpath d='m922.268,339.393s5.35983,18.5828,10.6529,21.3501c5.29306,2.76734,11.4678,7.38011,11.4678,7.38011'/%3E %3Cpath d='m921.656,339.779s3.76493,21.8864,9.058,26.0375c5.29306,4.15101,10.5876,8.76378,10.5876,8.76378'/%3E %3Cpath d='m885.067,338.251s5.29306,30.4424,15.8807,37.3607c10.5861,6.91835,19.4074,12.9148,19.4074,12.9148'/%3E %3Cpath d='m884.627,337.79s11.4678,23.9858,21.1722,31.3659c9.70445,7.37852,22.9371,14.2985,22.9371,14.2985'/%3E %3Cpath d='m847.574,339.635c3.08661,5.53469,2.64653,16.1439,6.17474,19.8332,3.5282,3.69085,8.82278,11.9929,8.82278,11.9929'/%3E %3Cpath d='m848.456,340.097c1.76486,2.76735,6.68614,16.5469,9.70446,20.7551,2.20645,3.69084,24.702,27.2133,24.702,27.2133'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23000' stroke-width='0.475'%3E %3Cellipse rx='3.308315' ry='3.45929' cx='872.054473' cy='389.218617'/%3E %3Cellipse rx='2.867176' ry='2.998061' cx='888.816847' cy='396.598727'/%3E %3Cellipse rx='2.867176' ry='2.998061' cx='909.549017' cy='398.444151'/%3E %3Cellipse rx='2.646652' ry='2.536816' cx='928.074732' cy='391.294124'/%3E %3Cellipse rx='2.426128' ry='2.998045' cx='942.190575' cy='382.30026'/%3E %3C/g%3E %3Cg fill='%23ff0101' stroke-width='0.7371'%3E %3Cpath d='m859.483,283.363c-1.32326,0.92351-23.3787,6.45819-20.2906,5.99644,3.0866-0.46017,20.7322,4.61277,20.2906,3.22909-0.44159-1.38367,0-8.30202,0-9.22553z'/%3E %3Cpath d='m896.978,276.445c-0.88319,0-13.6758,5.07452-13.2342,5.07452s14.5574,4.15102,14.1158,3.22751c-0.4416-0.92192-0.4416-6.91836-0.88167-8.30203z'/%3E %3Cpath d='m935.354,281.057c-0.88319,0.46175-15.8807,4.15101-13.2342,4.61277,2.64653,0.46175,12.7926,4.15101,12.7926,3.22909,0-0.9235,0-7.38011,0.44159-7.84186z'/%3E %3C/g%3E %3Cg fill='%23be1017' stroke-width='0.5813' transform='matrix(0.04915326,-1.2962189,1.2382477,0.05145445,0,0)'%3E %3Ccircle r='1.8894' cx='-216.002142' cy='726.376815'/%3E %3Ccircle r='1.8894' cx='-212.21777' cy='739.051036'/%3E %3Ccircle r='1.8894' cx='-219.249357' cy='732.917906'/%3E %3Ccircle r='1.8894' cx='-208.970565' cy='732.509881'/%3E %3Ccircle r='1.8894' cx='-214.109961' cy='732.713893'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='760' height='400' viewBox='-19 -10 38 20'%3E %3Crect x='-19' y='-10' width='38' height='20' fill='%2375b2dd'/%3E %3Cg id='star' transform='translate(0,-6)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-2 V 0 H 1' transform='rotate(18 0,-2)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='rotate(90)'/%3E %3Cuse xlink:href='%23star' transform='rotate(180)'/%3E %3Cuse xlink:href='%23star' transform='rotate(270)'/%3E %3C/svg%3E"

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1100' height='800' viewBox='0 0 22 16'%3E %3Crect fill='%23FFF' width='22' height='16'/%3E %3Cg fill='%230065BD'%3E %3Crect x='6' width='4' height='16'/%3E %3Crect y='6' width='22' height='4'/%3E %3C/g%3E %3Cg fill='%23ED2939'%3E %3Crect x='7' width='2' height='16'/%3E %3Crect y='7' width='22' height='2'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='900' height='600'%3E%3Crect width='900' height='600' fill='%23ED2939'/%3E%3Crect width='600' height='600' fill='%23fff'/%3E%3Crect width='300' height='600' fill='%23002395'/%3E%3C/svg%3E"

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E %3Crect fill='%233a75c4' width='400' height='300'/%3E %3Crect fill='%23fcd116' width='400' height='200'/%3E %3Crect fill='%23009e60' width='400' height='100'/%3E %3C/svg%3E"

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30' width='1200' height='600'%3E %3CclipPath id='t'%3E %3Cpath d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z'/%3E %3C/clipPath%3E %3Cpath d='M0,0 v30 h60 v-30 z' fill='%2300247d'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' stroke='%23fff' stroke-width='6'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' clip-path='url(%23t)' stroke='%23cf142b' stroke-width='4'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23cf142b' stroke-width='6'/%3E %3C/svg%3E"

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='360' viewBox='0 0 500 300'%3E %3Cdefs%3E %3Cg id='s'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-1 v 1 h .5' transform='rotate(18 0,-1)' fill='%23fcd116'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/defs%3E %3Crect width='500' height='300' fill='%23ce1126'/%3E %3Crect x='42' y='42' width='416' height='216' fill='%23007a5e'/%3E %3Cpath d='M 42,42 h 416 l -416,216 h 416 z' fill='%23fcd116'/%3E %3Ccircle cx='250' cy='150' r='36' fill='%23ce1126'/%3E %3Cuse xlink:href='%23s' transform='translate(250,150) scale(33)'/%3E %3Cuse xlink:href='%23s2' x='-100'/%3E %3Cuse id='s2' xlink:href='%23s' transform='translate(250,21) scale(19.5)'/%3E %3Cuse xlink:href='%23s2' x='100'/%3E %3Cuse xlink:href='%23s2' x='-100' y='258'/%3E %3Cuse xlink:href='%23s2' y='258'/%3E %3Cuse xlink:href='%23s2' x='100' y='258'/%3E %3Cpath d='M 67.749,150.41 c 4.504,8.39 13.265,17.52 20.916,20.73 c .123,-8.52 -2.9,-19.44 -7.034,-28.14 l -13.882,7.41 z' fill='%23ce1126'/%3E %3Cpath d='M 60.112,121.63 c 6.529,13.61 -16.933,46.08 22.156,53.69 c -4.822,-6.58 -7.931,-17.44 -6.755,-26.16 c 8.201,3.12 16.83,12.25 20.317,19.23 c 10.23,-37.15 -26.24,-34.89 -35.718,-46.76 z' fill='%23fcd116'/%3E %3C/svg%3E"

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 300 200'%3E %3Cdefs%3E %3Cg id='smallcross'%3E%3CclipPath id='vclip'%3E%3Cpath d='M-109,104 a104,104 0 0,0 0,-208 H109 a104,104 0 0,0 0,208 z'/%3E%3C/clipPath%3E%3Cpath id='varm' d='M-55,74 a55,55 0 0,1 110,0 V-74 a55,55 0 0,1 -110,0 z' clip-path='url(%23vclip)'/%3E %3Cuse xlink:href='%23varm' transform='rotate(90)'/%3E%3C/g%3E %3C/defs%3E %3Crect width='300' height='200' style='fill:%23fff'/%3E %3Cpath d='m 130,0 0,80 -130,0 L 0,120 l 130,0 0,80 40,0 0,-80 130,0 0,-40 -130,0 L 170,0 130,0 z' style='fill:%23ff0000' /%3E %3Cuse xlink:href='%23smallcross' transform='translate(64.45,39.45)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(235.55,160.55)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(235.55,39.45)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(64.45,160.55)' fill='%23f00'/%3E %3C/svg%3E"

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg%3E %3Csvg width='900' height='600' viewBox='-18 -12 36 24' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Crect x='-18' y='-12' width='36' height='24' fill='white'/%3E %3Cpath d='M 0,-12 v 24 M -18,0 h 36' stroke='%23e8112d' stroke-width='6' fill='none'/%3E %3Cpath id='arm' d='M -9,2 l 1,-1 h 9 v -2 h -9 l -1,-1 z' fill='%23f9dd16'/%3E %3Cuse xlink:href='%23arm' transform='rotate(90)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(-90)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(180)'/%3E %3C/svg%3E"

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect width='450' height='300' fill='%23006b3f'/%3E %3Crect width='450' height='200' fill='%23fcd116'/%3E %3Crect width='450' height='100' fill='%23ce1126'/%3E %3Cpath d='M225,100 257.492,200 172.427,138.197H277.573L192.508,200z' fill='%23000'/%3E %3C/svg%3E"

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='500' viewBox='0 0 512 256'%3E %3Crect fill='%23da000c' width='512' height='256'/%3E %3Crect fill='%23fff' width='512' height='171.5'/%3E %3Cg stroke='%23000'%3E %3Cg id='castle_half' fill='%23da000c' stroke-linecap='square'%3E %3Crect fill='%23000' stroke='none' width='64' height='43.992859' x='196.57106' y='116.30338'/%3E %3Cpath d='M229.81889,153.86465H190.75L182.08989,159.56444V165.60411H229.81889'/%3E %3Cpath d='M213.46875,128.59375C219.09357,128.59375 223.6875,133.28303 223.6875,139.0625V153.84375H231.03125V97.84375H190.75V153.84375H203.25V139.0625C203.24999,133.50878 207.76491,128.59375 213.46875,128.59375z'/%3E %3Crect fill='%23000' stroke='none' width='18.523308' height='33.9594' x='204.5282' y='59.961655'/%3E %3Cpath d='M223,88.65625H206.79108V82.90625H194.90625V88.65625H186.84375V82.90625H182.03125V93.34375H223M186.84375,93.306038H221.81414V97.843752H186.84375z'/%3E %3Cpath d='M200.71875,47.625V82.90625H206.79108V73.21875C206.79108,69.589448 209.35314,66.619386 212.9375,66.4375C213.05312,66.431633 213.16418,66.4375 213.28125,66.4375C217.02763,66.437497 220.0625,69.472374 220.0625,73.21875V82.90625H225.84375V47.625z'/%3E %3Cpath d='M198.53125,42.84375V47.625H227.78125V42.84375z'/%3E %3Cpath d='M194.78125,33.6875V42.84375H229.875V33.6875H224.46875V38.34375H217.9375V33.6875H207.96875V38.34375H201.4375V33.6875z'/%3E %3Cpath d='M182.08989,159.56444H230'/%3E %3Cpath d='M261,156.8125H228.5625L218.78125,161.53125V168.5625H261'/%3E %3Cpath stroke-linecap='butt' d='M218.771,161.51923H262'/%3E %3C/g%3E %3Cuse xlink:href='%23castle_half' transform='matrix(-1,0,0,1,512,0)'/%3E %3Cg fill='%23f8d80e'%3E %3Cg stroke-linecap='round'%3E %3Cpath stroke-width='0.768' d='m273.297,150.031c-2.65428,0.88339-5.05329,2.369-7.46888,3.75283-3.1004,1.83163-6.10683,3.82731-8.90451,6.09885-0.98462,0.64912-1.92929,1.36065-2.68911,2.27332-1.02583,0.8776-2.06486,2.05478-1.86885,3.51297,0.0518,0.64315,0.87359-0.75523,1.41401-0.82297,0.94235-0.54095,2.0838-0.7154,3.14219-0.4713,1.27117-1.33857,2.90994-2.23563,4.3249-3.40609,3.00467-2.24222,6.23664-4.16769,9.52502-5.96082,1.1481-0.58838,2.30104-1.18568,3.52508-1.60184-0.33328-1.12498-0.66657-2.24997-0.99985-3.37495z'/%3E %3Cpath d='M260.40041,157.3913V161.3032'/%3E %3Cpath d='M262.81691,155.68544V159.56821'/%3E %3Cpath d='M265.23339,154.17984V158.03797'/%3E %3Cpath d='M267.64986,152.69367V156.67498'/%3E %3Cpath stroke-width='0.768' d='m238.891,150.156c-0.39583,1.10417-0.79167,2.20833-1.1875,3.3125,5.53699,2.10036,10.8089,4.87874,15.7978,8.06036,1.69067,1.15075,3.46718,2.26632,4.79593,3.84589,0.2927,0.81098-0.51392,1.48903-1.31413,1.24403-0.73225-0.24871-1.45351-0.53169-2.22629-0.004-1.10637,0.50311-2.10598,2.1416-0.42575,2.69112,2.31528,1.55489,6.08158,0.87915,7.19454-1.84522,0.58146-1.40134,0.61878-3.19523-0.50753-4.34456-2.06261-2.36404-4.79728-4.00804-7.4215-5.67182-4.68917-2.82023-9.57283-5.37389-14.7055-7.28801z'/%3E %3Cpath d='M254.04985,158.03521 253.73747,161.37469'/%3E %3Cpath d='M256.8319,159.73914 255.96991,163.00882'/%3E %3Cpath d='M259.80442,162.01152 257.99552,164.54884'/%3E %3Cpath d='M260.71528,168.18078 258.10512,166.78032'/%3E %3Cpath d='M261.52792,165.42898 258.53251,165.70943'/%3E %3Cpath d='M257.66497,169.7646 257.45987,167.13228'/%3E %3Cpath d='M256.56809,166.75559 254.09509,168.57779'/%3E %3Cpath d='M244.67669,152.9368V156.05184'/%3E %3Cpath d='M250.96338,156.24386V159.77805'/%3E %3Cpath d='M247.82004,154.59318V157.9121'/%3E %3C/g%3E %3Cpath d='M235.78125,227.5625V235.59375H240.8125V231.5625H247.65625V235.59375H253.0625V227.5625zM235.78125,238.625V246.6875H253.0625V238.625H247.65625V242.65625H240.8125V238.625z'/%3E %3Crect width='4.9902272' height='58.115017' x='253.05186' y='193.65144'/%3E %3Crect width='4.9902272' height='50.060368' x='253.05186' y='198.6788'/%3E %3Cpath stroke-width='1.024' d='M255.54688,179.40625 266.17188,185.59375 255.54688,191.75 244.92188,185.59375zM241.32813,183.375H238.54688V187.8125H241.32813L255.54688,196.0625 269.76563,187.8125H272.54688V183.375H269.76563L255.54688,175.125z'/%3E %3Cpath stroke-width='1.024' d='m255.344,164.281c-2.41872,0.33922-4.22593,2.73018-4.09375,5.13412,0.009,3.73773-0.0185,7.47634,0.0141,11.2135,0.12824,2.40829,2.23219,4.56615,4.6744,4.58823,1.98493,0.18804,3.97892-0.97232,4.81154-2.77961-0.57292-0.34375-1.14583-0.6875-1.71875-1.03125-0.44378,1.18388-1.72345,1.91762-2.96875,1.78125-1.63507,0.046-2.95917-1.54398-2.8125-3.13412,0.01-3.71344-0.0192-7.42801,0.0146-11.1407,0.0899-1.5151,1.53488-2.75487,3.04795-2.60016,0.6265-0.17973,1.48748,0.67715,1.8747-0.0623,0.5838-0.82944-0.41442-1.47737-0.96875-1.9374-0.61348-0.0841-1.25418-0.008-1.8747-0.0316zm5.78125,3.90625c-0.39638,0.7459-1.21626,1.18923-1.875,1.58041v7.51334c0.66667,0.38542,1.33333,0.77083,2,1.15625-0.008-3.20377,0.0153-6.40813-0.0117-9.61152-0.0315-0.19722-0.008-0.4984-0.11328-0.63848z'/%3E %3C/g%3E %3Cg fill='%23da000c'%3E %3Crect fill='%23000' stroke='none' width='29.328571' height='53.254513' x='240.80301' y='38.351128'/%3E %3Cpath d='M238.75,38.375V82.9375H248.0625V69.71875C248.0625,66.669822 250.01501,62.4375 256,62.4375C261.98499,62.4375 263.9375,66.669822 263.9375,69.71875V82.9375H273.25V38.375zM254.5625,43.375H257.4375V58.625H254.5625zM246.3125,46.375H249.21875V57.53125H246.3125zM262.78125,46.375H265.6875V57.53125H262.78125z'/%3E %3Cpath d='M235.59375,31.96875V38.3125H276.40625V31.96875z'/%3E %3Cpath d='M231.75,24.59375V31.96875H280.25V24.59375H274.15625V28.65625H267.28125V24.59375H259.4375V28.65625H252.5625V24.59375H244.71875V28.65625H237.84375V24.59375z'/%3E %3Cpath d='M222.75,97.84375V102.4375H289.25V97.84375z'/%3E %3Cpath d='M220.03125,82.90625V97.84375H291.96875V82.90625H285.15625V88.65625H276.09375V82.90625H263.9375V88.65625H248.0625V82.90625H235.90625V88.65625H226.84375V82.90625z'/%3E %3Cpath stroke-linejoin='round' d='M228.6875,102.4375V156.78125H241.53125V136.4375C241.53125,126.85477 247.92755,122.34375 256,122.34375C263.75894,122.34375 270.46875,126.85477 270.46875,136.4375V156.78125H283.3125V102.4375z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 18 12'%3E %3Crect width='18' height='12' fill='%23fff'/%3E %3Cpath fill='%23d00c33' d='m0,6h18v6H0zm3,0a4,4 0 0,0 8,0a4,4 0 0,0-8,0'/%3E %3C/svg%3E"

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 27 18'%3E %3Ctitle%3EFlag of The Gambia%3C/title%3E %3Cpath d='m0,0h27v18H0' fill='%233A7728'/%3E %3Cpath d='m0,0h27v11H0' fill='%230C1C8C'/%3E %3Cpath d='m0,0h27v6H0' fill='%23CE1126'/%3E %3Cpath d='m0,6.5h27m0,5H0' stroke='%23FFF'/%3E %3C/svg%3E"

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='450' height='300' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' fill='%23ce1126'/%3E %3Crect width='1' height='2' x='1' fill='%23fcd116'/%3E %3Crect width='1' height='2' x='2' fill='%23009460'/%3E %3C/svg%3E"

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800' viewBox='0 0 3600 2400'%3E %3Ctitle%3EFlag of Equatorial Guinea%3C/title%3E %3Crect width='3600' height='2400' fill='%23e32118'/%3E %3Crect width='3600' height='1600' fill='%23fff'/%3E %3Crect width='3600' height='800' fill='%233e9a00'/%3E %3Cpath d='M0,0V2400L900,1200z' fill='%230073ce'/%3E %3Cg stroke='%23000'%3E %3Cg id='shield'%3E %3Cpath fill='%23fff' stroke-width='4.8' d='M1608,958.8H1991V1360C1991,1495 1815,1391 1800,1463C1774,1389 1609,1496 1609,1352C1609,1212 1608,958.8 1608,958.8z'/%3E %3Cpath fill='%2373452b' d='M1827,1399C1827,1399 1822,1404 1813,1400C1804,1396 1803,1143 1803,1143C1823,1121 1839,1114 1839,1114C1839,1114 1851,1124 1851,1124C1806,1147 1810,1180 1814,1237C1815,1258 1815,1285 1820,1311C1827,1344 1841,1372 1842,1393C1843,1406 1827,1399 1827,1399z'/%3E %3Cpath fill='%2373452b' d='M1796,1108H1814C1799,1253 1812,1339 1812,1381C1812,1395 1820,1400 1819,1400C1801,1420 1792,1399 1792,1399z'/%3E %3Cpath fill='%23a36629' d='M1768,1399C1751,1407 1749,1391 1750,1389C1787,1314 1803,1149 1769,1131C1769,1131 1771,1115 1771,1115C1784,1119 1796,1136 1796,1136C1801,1321 1796,1397 1793,1400C1775,1419 1768,1397 1767,1395'/%3E %3Cpath fill='none' d='M1767,1396C1764,1380 1793,1339 1791,1296'/%3E %3Cpath fill='none' d='M1816,1331C1825,1356 1829,1378 1827,1399'/%3E %3Cpath fill='%23009a3b' d='M1855,1040C1861,1033 1861,1033 1872,1033C1874,1018 1899,1018 1901,1037C1921,1033 1925,1045 1917,1057C1936,1052 1953,1057 1948,1079C1982,1088 1969,1112 1954,1117C1952,1132 1938,1137 1919,1131C1895,1148 1881,1142 1870,1125C1843,1129 1841,1123 1829,1108C1808,1117 1804,1117 1786,1106C1785,1120 1780,1116 1771,1115C1772,1133 1765,1141 1749,1135C1761,1160 1730,1171 1715,1150C1701,1151 1700,1147 1693,1142C1687,1162 1665,1159 1661,1148C1633,1144 1636,1129 1659,1128C1661,1112 1675,1115 1684,1117C1685,1107 1691,1109 1696,1111C1693,1104 1695,1100 1704,1098C1691,1081 1699,1075 1712,1069C1705,1053 1717,1054 1726,1053C1725,1036 1730,1033 1748,1031C1746,1025 1749,1020 1759,1020C1753,1003 1761,999.1 1779,1002C1782,977.3 1835,989 1831,1023C1846,1025 1851,1028 1855,1040z'/%3E %3Cg fill='none' stroke='%23000'%3E %3Cpath d='M1748,1031C1752,1033 1757,1031 1758,1042C1766,1028 1776,1036 1776,1052'/%3E %3Cpath d='M1831,1023C1827,1029 1812,1029 1814,1045C1809,1038 1799,1036 1795,1043'/%3E %3Cpath d='M1855,1040C1855,1044 1854,1056 1850,1062'/%3E %3Cpath d='M1917,1057C1918,1058 1903,1057 1896,1062'/%3E %3Cpath d='M1954,1117C1950,1115 1942,1110 1936,1118C1936,1114 1936,1103 1925,1103'/%3E %3Cpath d='M1919,1131C1919,1121 1917,1118 1915,1115'/%3E %3Cpath d='M1886,1117C1878,1111 1870,1120 1870,1125'/%3E %3Cpath d='M1828,1108C1828,1104 1825,1096 1832,1093'/%3E %3Cpath d='M1714,1150C1716,1140 1723,1140 1722,1135C1721,1127 1712,1120 1701,1131'/%3E %3Cpath d='M1722,1135C1728,1133 1734,1134 1736,1137'/%3E %3Cpath d='M1705,1098C1709,1094 1719,1095 1725,1098'/%3E %3Cpath d='M1725,1074C1730,1074 1739,1072 1742,1081C1753,1064 1761,1066 1763,1070'/%3E %3Cpath d='M1783,1068C1791,1065 1805,1073 1813,1087C1817,1076 1823,1078 1829,1077'/%3E %3Cpath d='M1867,1087C1880,1081 1888,1093 1892,1098C1898,1090 1903,1090 1909,1090'/%3E %3Cpath d='M1746,1111C1749,1106 1756,1105 1761,1108C1760,1099 1766,1095 1770,1097'/%3E %3C/g%3E %3C/g%3E %3Cg id='stars' fill='%23ffd700' stroke-width='3.5'%3E %3Cpath d='M1787,902.6 1765,903.6 1754,923.3 1742,904.5 1720,905.4 1730,885.6 1718,866.8 1741,865.8 1751,846.1 1763,864.9 1785,864 1775,883.8z'/%3E %3Cpath d='M1693,909.9 1671,915.3 1665,936.6 1649,920.6 1628,925.8 1634,904.5 1619,888.3 1640,883 1646,861.6 1662,877.6 1684,872.4 1677,893.8z'/%3E %3Cpath d='M1602,928.6 1582,938.5 1581,960.7 1562,948.5 1542,958.3 1544,936.1 1525,923.8 1545,913.8 1547,891.6 1565,903.8 1585,894 1584,916.2z'/%3E %3Cpath d='M1816,902.6 1838,903.6 1848,923.3 1860,904.5 1882,905.4 1872,885.6 1884,866.8 1862,865.8 1851,846.1 1839,864.9 1817,864 1827,883.8z'/%3E %3Cpath d='M1910,909.9 1931,915.3 1937,936.6 1953,920.6 1974,925.8 1968,904.5 1984,888.3 1962,883 1956,861.6 1940,877.6 1919,872.4 1925,893.8z'/%3E %3Cpath d='M2000,928.6 2020,938.5 2021,960.7 2040,948.5 2060,958.3 2059,936.1 2077,923.8 2057,913.8 2056,891.6 2037,903.8 2017,894 2019,916.2z'/%3E %3C/g%3E %3Cg id='motto'%3E %3Cg fill='%23fff' stroke-width='3.5'%3E %3Cpath d='M2027,1352 2052,1388 2075,1354 2059,1325z'/%3E %3Cpath d='M1868,1457 1870,1493C1870,1493 1880,1493 1889,1490C1897,1487 1904,1481 1904,1481L1903,1462z'/%3E %3Cpath d='M1734,1457 1732,1492C1732,1492 1723,1492 1714,1490C1706,1488 1699,1483 1699,1483L1689,1459z'/%3E %3Cpath d='M1573,1352 1547,1388 1519,1342 1540,1320z'/%3E %3Cpath d='M1698,1529C1698,1563 1904,1563 1904,1529V1481C1904,1506 1698,1501 1698,1481z'/%3E %3Cpath d='M1514,1418C1532,1510 1698,1512 1698,1512C1698,1512 1698,1481 1698,1481C1694,1469 1701,1465 1728,1461C1739,1460 1734,1444 1734,1444C1734,1444 1662,1457 1611,1437C1542,1409 1532,1355 1532,1355C1532,1355 1527,1397 1514,1418z'/%3E %3Cpath d='M2087,1418C2070,1510 1904,1512 1904,1512C1904,1512 1904,1481 1904,1481C1907,1469 1900,1465 1873,1461C1862,1460 1868,1444 1868,1444C1868,1444 1940,1457 1991,1437C2059,1409 2067,1355 2067,1355C2067,1355 2074,1397 2087,1418z'/%3E %3Cpath d='M1527,1383C1481,1358 1517,1332 1521,1258C1528,1303 1579,1322 1573,1351C1552,1352 1542,1320 1532,1355C1532,1355 1527,1383 1527,1383z'/%3E %3Cpath d='M2074,1383C2120,1357 2082,1332 2078,1258C2071,1303 2021,1322 2027,1351C2047,1352 2057,1320 2067,1355C2067,1355 2074,1382 2074,1382z'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m1555,1417,5,4-11,12c-4.4031,4.8033-5.4674,7.9808-2.4093,10.905,3.7958,3.6295,6.4648,2.3682,10.409-1.905l12-13,4,4-11.989,13.989c-6.5084,7.5942-12.55,5.8563-17.618,1.1231-4.4158-4.1237-6.9466-10.102-0.4536-17.454l12.1-13.6z'/%3E %3Cpath d='m1575,1434,5,3-1,24,11-17,5,3-16,26-6-3,1-24-11,17-5-3z'/%3E %3Cpath d='m1584,1476,14-28,5,3-13,27z'/%3E %3Cpath d='m1606,1452-11.04,28.98,11.04,4.02c10.29,3.75,15.12-0.78,18.39-9.48,3.3-8.85,1.86-15.36-8.43-19.5l-9.96-4.02zm3.96,7.02c10.35,3.6,10.98,7.53,8.16,14.64-2.73,6.75-5.28,9.39-15.12,4.32l6.96-18.96z'/%3E %3Cpath d='m1639,1463-18,27,6.96,2.04,4.02-7.02,12,3,1.02,7.02,6.96,0.96-6.96-31.98-6-1.02zm1.98,7.02,1.98,12-7.98-1.02,6-10.98z'/%3E %3Cpath d='m1656.1,1465.6-1.0838,30.99,11.772,0.2309c10.941,0.2072,14.051-5.6204,14.318-14.91,0.2713-9.4506-3.2083-15.154-14.298-15.716l-10.708-0.5955zm6.0026,5.3771c10.964,0.044,12.838,3.5434,12.453,11.195-0.3657,7.273-1.9548,10.588-12.884,8.9686l0.4302-20.164z'/%3E %3Cpath d='m1761,1509v31.98h7.02v-12s6,0.36,10.98-0.96c3.93-1.02,6.66-3.54,6.75-9.75,0.09-6.09-3.45-9.27-9.57-9.27h-15.2zm7.02,4.98,7.05,0.09c5.88,0,4.77,8.91,0.18,8.91h-7.23v-9z'/%3E %3Cpath d='m1797,1509-13.02,31.98h7.02l3-7.98h13.02l3,7.98h6.96l-13-32h-7zm3,7.02,4.98,12h-9l4.02-12z'/%3E %3Cpath d='m1817,1535,17-21-15,0,0-5,24,0,0,5-18,21,18,0,0,6-26,0z'/%3E %3Cpath d='m1918,1473,6-1,3,18c1.0669,6.4013-1.8581,10.764-6.4144,12.445-5.1887,1.9138-11.806,0.1639-12.586-8.4449l5-1c1.1649,5.1523,3.2378,5.5985,5.6366,4.791,1.9038-0.6409,2.8885-3.6406,2.3634-6.791z'/%3E %3Cpath d='m1928,1471.2,5.9209-1.1228,2.7393,14.979c1.1722,6.4098,3.1827,9.1354,7.3509,8.4077,5.1735-0.9034,5.741-3.8003,4.6402-9.5106l-3.6807-15.98,6.0571-0.9143,4.0192,16.623c2.3505,9.7215-2.7285,13.578-9.5455,14.851-5.9392,1.1094-12.253-0.3988-14.322-9.9873z'/%3E %3Cpath d='m1959,1485,5-2c2.4529,4.4051,6.2799,4.1782,9.2549,2.8632,4.133-1.8269,4.6059-5.4402,2.5625-6.6628-2.9146-1.7438-9.8689,0.7328-13.615-0.6341-4.482-1.6353-6.4062-4.1562-6.1771-8.0319,0.2759-4.6664,4.3807-7.231,8.8456-8.6157,4.996-1.5495,9.9262-1.0022,13.129,5.0813l-6,2c-1.9531-3.2866-4.4662-3.1313-6.6964-2.0777-1.8668,0.882-4.784,2.5382-3.222,5.2058,1.2767,2.1802,8.6258,0.7645,12.498,0.9228,4.0034,0.1636,7.2389,2.8362,7.7805,6.6867,0.7551,5.3683-1.2338,8.2764-7.4407,10.697-7.6662,2.9898-14.582-0.3597-15.919-5.4346z'/%3E %3Cpath d='m1986,1460-8,4-2-5,22-9,2,4-8,4,9,22-5,3z'/%3E %3Cpath d='m1999,1449,5-3,14,26-5,3z'/%3E %3Cpath d='m2033,1451,6-2c2.8215,5.9317-1.4152,16.715-11.775,16.493-15.164-0.3249-16.805-17.027-14.421-22.536,4.0051-9.252,15.224-9.0747,20.196-3.957l-5,4c-3.1698-4.0667-10.212-1.5041-10.688,2.2374-0.7756,6.1053,1.9122,11.788,7.371,14.483,4.6287,2.2846,11.761-3.4602,8.3165-8.7202z'/%3E %3Cpath d='m2030,1430,5-4,18,24-5,4z'/%3E %3Cpath d='m2049,1415-4.98,4.02,10.98,30,4.98-4.98-3-6,9-8.04,6,3,5.04-3.96-28.02-14.04zm1.98,7.02,10.02,4.98-6,6-4.02-10.98z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 27 18'%3E %3Crect fill='%230D5EAF' width='27' height='18'/%3E %3Cpath fill='none' stroke-width='2' stroke='%23FFF' d='M5,0V11 M0,5H10 M10,3H27 M10,7H27 M0,11H27 M0,15H27'/%3E %3C/svg%3E"

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='375' viewBox='0 0 750 375'%3E %3Cdefs%3E %3ClinearGradient id='linearGradient795'%3E %3Cstop stop-color='%23d5dfff' offset='0'/%3E %3Cstop stop-color='%23FFF' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient783'%3E %3Cstop stop-color='%23474747' offset='0'/%3E %3Cstop stop-color='%23f50' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient746' y2='102.99' xlink:href='%23linearGradient783' gradientUnits='userSpaceOnUse' x2='228.97' gradientTransform='matrix(.74087 0 0 1.3286 40.513 .0061069)' y1='102.99' x1='215.83'/%3E %3ClinearGradient id='linearGradient747' y2='173.45' xlink:href='%23linearGradient783' gradientUnits='userSpaceOnUse' y1='218.47' gradientTransform='matrix(1.5101 0 0 .65184 40.513 .0061069)' x2='110.94' x1='109.34'/%3E %3ClinearGradient id='linearGradient748' y2='337.23' gradientUnits='userSpaceOnUse' y1='316.38' gradientTransform='matrix(1.2315 0 0 .79928 40.513 .0061069)' x2='126.02' x1='125.91'%3E %3Cstop stop-color='%23b50000' offset='0'/%3E %3Cstop stop-color='%23ffc500' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient794' y2='1003.7' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='1040.4' gradientTransform='matrix(2.5627 0 0 .38409 40.513 .0061069)' x2='78.221' x1='117.6'/%3E %3ClinearGradient id='linearGradient800' y2='226.38' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='245.98' gradientTransform='matrix(.88634 0 0 1.1105 40.513 .0061069)' x2='255.03' x1='264.72'/%3E %3ClinearGradient id='linearGradient801' y2='147.35' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='149.38' gradientTransform='matrix(.55904 0 0 1.7607 40.513 .0061069)' x2='456.4' x1='407.87'/%3E %3C/defs%3E %3Crect width='750' height='375' fill='%2300247d'/%3E %3Cg transform='matrix(.75595 0 0 .75595 0 -.000017730)'%3E %3Cg transform='matrix(8.2677 0 0 8.2677 0 .000022888)'%3E %3Cpath d='m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z' fill='%23FFF'/%3E %3Cpath d='m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z' fill='%23FFF'/%3E %3Cpath d='m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z' fill='%23cf142b'/%3E %3Cpath d='m0 30l20-10h4.472l-20 10h-4.472zm0-30l20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10l20-10h4.472l-20 10h-4.472zm24.472 20l-20-10h4.472l15.528 7.764v2.236z' fill='%23cf142b'/%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(0.621 0 0 0.621 461.4 21.482)'%3E %3Cpath d='m146.97 393.04s-3.35 8.84-5.26 8.84-8.84-3.82-8.84-3.82-5.02 8.13-7.65 8.6c-2.63 0.48-9.56-1.19-9.56-1.19s-6.69 0-6.93-0.96c-0.24-0.95 0.24-2.86 0.24-2.86s-9.558 7.64-11.709 7.16c-2.151-0.47-9.32-9.55-9.32-9.55l-1.195 4.78-13.621-0.48-11.949-7.65s-6.691 10.99-6.93 10.75-11.709 2.63-11.709 2.63l-0.717-2.15-7.647-4.54s5.974-8.36 5.974-8.6-2.868-1.2-2.868-1.2l-4.301 3.59-8.842 5.73-8.842-4.06 3.824-7.17 0.478-5.26 6.93-10.51 84.834-82.45 41.82 77.19-6.21 23.18z' stroke='%23000' stroke-width='1pt' fill='%236a4c2d'/%3E %3Cpath d='m207.24 398.04l22.08-0.8-9.4-4.64 84.14-3.17-11.89-4.53-10.53-14.27-43.6-3.28s-3.28-2.49-8.61-1.25c-0.22-3.39-4.3-7.81-4.3-7.81l-26.84-2.04-16.76 11.44 11.32 28.99 14.39 1.36z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m121.32 150.76l2.22-7.56s3.89-6.56 3.89-9.46c0-2.89 2.9-6.33 2.9-6.33s8.89-2.56 10.78 2.89c9.57-14.46 20.8-0.67 20.8-0.67l3.11-3.67 6.34-7.78s9.01 8.45 9.12 9.89c0.11 1.45 1.55 0.45 1.55 0.45l9.79-0.78s4.64 3.64 3.67 10.56c3.45 2.04 6.56 14.01 6.56 14.01l-80.73-1.55z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient747)'/%3E %3Cpath d='m207.25 240.72c1.69-1.03 7.01-2.72 6.36-10.5s-7.39-8.69-11.15-8.43c-3.77 0.26-7.14 3.5-7.14 3.5l-12.45-7.91s6.23-39.3 12.84-41.76c6.28-4.53 7.39-6.49 7.39-7.52 0-1.04-2.33-3.64-2.33-3.64l-40.6-4.8-38.39 4.54s-2.98 4.54-2.59 6.36c0.39 1.81 0.52 3.76 7.39 9.08 7.61 5.85 12.84 39.43 12.84 39.43s-10.76 5.31-11.41 4.66c-0.65-0.64-3.89-1.29-5.58-1.03-1.68 0.26-7.26 3.11-7.26 10.5 0 7.4 5.58 11.68 5.58 11.68s36.7-4.28 42.15 5.83c5.32-12.19 40.2-7.91 44.35-9.99z' stroke='%23000' stroke-width='1pt' fill='%23656263'/%3E %3Cpath stroke-linejoin='round' d='m246.79 199.87s0.41-4.27 3.45-6.3c3.05-2.03 23.36-3.05 28.24 0 4.87 3.05 6.7 18.08 6.7 18.08s3.05 5.28 3.25 9.14 0.61 6.5 0.61 6.5 16.25 21.13 16.45 40.22c1.83 13 1.42 47.73-3.65 60.93-0.21 16.46-7.11 27.22-7.11 27.22s1.62 2.84 1.42 5.89c-0.21 3.05-1.83 5.89-1.83 5.89l23.76 11.78-8.73-3.25s8.94 7.52 8.73 7.32c-0.2-0.21-9.95-4.68-9.95-4.68l5.89 5.89c-0.2-0.2-14.42-6.5-14.42-6.5s6.7 6.3 6.3 6.1c-0.41-0.2-10.77-5.08-10.77-5.08s6.5 6.91 6.3 6.5-9.34-4.06-9.34-4.06l0.4 3.45s-7.31-0.41-7.31-5.89c-3.66-2.03-6.09-4.88-6.09-4.88l-16.86-2.84-19.1-57.08 4.47-96.48 1.22-4.87-2.03-13z' stroke-opacity='.97854' stroke='%23000' stroke-width='1.25'/%3E %3Cpath stroke-width='.99323pt' d='m234.03 508.2s-9.78-20.57-14.65-20.86c-4.4-8.39 15.29-76.96 53.38-80.87 20.94 1.72 1.72 24.14-12.05 17.24 1.72 6.03 8.6 14.66 8.6 14.66s-27.25 11.78-35.28 69.83z' stroke='%23000' fill='%23fb0'/%3E %3Cpath d='m102.91 511.2s8.1-23.42 13.01-23.71c4.92-0.29-13.01-78.05-52.032-78.63-21.104 1.74-1.735 24.28 12.141 17.34-1.734 6.08-8.672 14.75-8.672 14.75s27.463 11.85 35.553 70.25z' stroke='%23000' stroke-width='1pt' fill='%23fb0'/%3E %3Cpath d='m138.71 364.93c-0.1-0.19-9.69 3.01-3.48 13.45 0.47-4.04 4.79-6.49 4.79-6.49s-6.58 7.81 0.38 14.39c0.85-6.21 4.8-8.18 4.8-8.18s-4.89 14.39 0.09 17.3c0.57-5.74 4.23-8.27 4.23-8.27s-4.42 12.88-0.47 15.79c0.47-4.88 3.76-7.05 3.76-7.05s-1.97 13.36 3.2 14.3c0.1-4.71 3.86-9.31 3.86-9.31s-1.7 10.9 6.39 11.38c0.1-4.14 1.6-8.84 1.6-8.84s3.67 11.56 9.03 9.68c-0.09-3.38 0.09-9.78 0-9.78-0.1 0 3.38 11 9.78 8.94-0.94-3.11 0.37-6.78 0.37-6.78s3.39 6.87 9.5 4.61c1.04-2.07-0.28-6.11-0.28-6.11s8.93 9.22 11.66 3.67-7.15-7.43-7.15-7.43h6.68s-2.16-5.64-11.19-6.87c3.1-1.41 6.3-0.37 6.3-0.37s-1.88-7.06-11.1-7.81c3.58-1.22 7.53-0.37 7.53-0.37s-1.23-6.68-11.38-8.56c1.6-1.79 5.92-1.22 5.92-1.22s-4.04-6.3-8.65-5.93c-4.61 0.38-46.27-4.23-46.17-4.14z' stroke='%23000' stroke-width='1pt' fill='%2300713d'/%3E %3Cg stroke-width='1.25' stroke-linecap='round' stroke='%233ec26d' fill='none'%3E %3Cg%3E %3Cpath d='m179.8 398.88s3.67 1.79 3.58 3.39'/%3E %3Cpath d='m181.97 395.97s4.7 3.29 4.61 5.73'/%3E %3Cpath d='m186.1 394.27s3.77 2.35 3.95 6.02'/%3E %3Cpath d='m192.4 395.78s1.89 4.04 1.23 4.79'/%3E %3Cpath d='m196.17 397.94c0.28 3.2-0.29 3.48-0.29 3.48'/%3E %3C/g%3E %3Cpath d='m149.8 377.72s4.42 2.82 4.05 6.77'/%3E %3Cpath d='m149.52 381.11s2.07 1.97 1.6 3.29'/%3E %3Cpath d='m154.98 377.82s2.91 4.04 1.97 6.86'/%3E %3Cpath d='m159.96 380.45s1.32 2.54 0.1 3.95'/%3E %3Cpath d='m162.31 381.67s1.6 2.54 0.19 3.39'/%3E %3Cpath d='m160.53 390.04s4.13 0.94 4.7 4.04'/%3E %3Cpath d='m162.97 387.22s4.33 0.28 4.8 4.89'/%3E %3Cpath d='m168.71 385.62c0.09 0 2.91 4.99 2.44 6.58'/%3E %3Cpath d='m174.26 386.09s1.12 4.8 0.28 6.3'/%3E %3Cpath d='m177.83 387.97c0 0.1 0.09 5.55 0.09 5.55'/%3E %3Cpath d='m172.38 380.45s2.72 1.03 2.53 3.67'/%3E %3Cpath d='m174.91 378s3.48 1.98 3.11 5.74'/%3E %3Cpath d='m178.96 376.41s3.01 3.57 1.88 7.52'/%3E %3Cpath d='m184.22 377.25s-1.12 4.42-0.66 6.21'/%3E %3Cpath d='m187.42 380.26s-1.97 1.51-0.94 3.39'/%3E %3Cpath d='m170.31 397.47s0.65 3.39 0 3.95'/%3E %3Cpath d='m165.98 395.5s2.16 3.76 1.41 5.64'/%3E %3Cpath d='m161.37 395.31s2.45 2.82 2.35 5.08'/%3E %3Cpath d='m157.61 395.87s2.26 2.17 2.07 3.39'/%3E %3Cpath d='m155.64 399.16s2.16 2.26 2.06 2.73'/%3E %3C/g%3E %3Cpath d='m108.86 244.78c10.37-0.19 20.74-0.37 31.11-0.56 0 0 20.55 0 22.77 6.67 3.89-8.89 21.66-8.33 21.66-8.33 10.74-0.37 21.48-0.74 32.21-1.11 0.19 25.92 0.37 51.84 0.56 77.76-6.29 30.17-28.14 51.47-52.21 60.54-28.7-9.26-46.84-33.51-52.76-61.1-1.12-24.62-2.23-49.25-3.34-73.87z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m119.94 244.49l45.31 120.74 40.93-123.37c-12.7 0.82-39.94-2-43.32 9.58-5.24-10.36-33.9-6.18-42.92-6.95z' stroke='%23000' stroke-width='1pt' fill='%23006b00'/%3E %3Cpath d='m150.78 309.86c1.75 0.91 1.7-32.77 3.99-33.81 0.65-2.79 0.98-4.01 1.8-6.97-1.97-3.49-10.79-3.32-14.06-0.35 1.47 4.7 2.12 6.27 2.12 6.27 4.42 7.15 3.54 35.62 6.15 34.86z' stroke='%23006b00' stroke-linecap='round' stroke-width='.68918' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m138.64 49.548s3.21-3.638 3.35-4.51c0.15-0.873 14.55-1.455 23.13-17.458 4.8-8.438 0-3.492 0-3.492l-0.29-4.074s5.97-5.673 3.79-8.729c-2.19-3.0546-1.46 3.929-4.95 3.783s-1.6-7.565-1.6-7.565-0.29-0.873-1.31-1.3094c-1.46 0.1455-1.02 2.7642-2.33 3.0551-1.31 0.291-2.47-6.1103-2.47-6.1103s-2.18-2.9096-4.08 6.2558c1.02 9.7478 7.28 7.8558 7.28 14.258 0 6.401-5.53 11.347-7.13 11.493-1.6 0.145-1.02-5.383-1.02-5.383s-0.87-2.619-1.45-2.619 3.2-0.582 2.62-7.856c-1.31-8.729-2.33 2.037-4.66 1.6-2.33-0.436-0.58-8.001 0.29-8.874s-1.02-4.51-6.11 4.801c-0.44 4.51-1.02-1.164-2.04-0.873-1.74 3.637-1.45 6.256 1.02 9.602 3.64 3.346 5.97 6.692 5.82 8.438-0.14 1.746-2.04 5.674-4.65 5.674-2.62 0 0.14-4.801 0-6.402-0.15-1.6-4.51-7.419-4.51-7.419s-3.06-4.947-2.77-5.092c0.29-0.146-0.29-0.873-1.74 4.219-1.46 5.092-3.21-3.346-3.21-3.346s-2.03 6.255 2.33 10.038c-3.34-0.436-3.63 0.873-3.63 0.873 0 1.746 4.51 2.473 5.09 5.528 0.58 3.056-4.66 4.801-4.66 4.801s2.19 3.055 8.29-2.909c0.15 3.782-2.32 6.401-2.32 6.401 2.03 0.921 3.63 0.824 3.92 3.201z' stroke='%23000' stroke-width='1.25' fill='%23cdad56'/%3E %3Cpath stroke-linejoin='round' d='m118.68 49.548s-2.72-4.037-2.84-4.832c-0.13-0.794-13.38 1.004-19.648-15.158-4.078-7.678 0-3.177 0-3.177l0.247-3.707s-4.339-5.308-2.486-8.088 1.09 3.574 3.474 3.587c2.963-0.132 1.359-6.884 1.359-6.884s0.246-0.794 1.112-1.191c1.232 0.132 1.742 4.115 2.852 4.38s3.41-4.687 4.13-5.7054c1.02-0.1457 0.98-4.1023 2.59 4.2374-0.86 8.87-8.21 7.149-8.21 12.974 0 5.824 4.69 10.325 6.05 10.458 1.36 0.132 0.87-4.898 0.87-4.898s0.74-2.383 1.23-2.383c0.5 0-4.32 0.925-3.82-5.694 1.11-6.197 3.57 0.399 5.55 0.001 1.98-0.397-0.23-6.553 0.34-7.493 0.13-0.94 3.04-4.977 4.17 3.932 0.37 4.104 2.61-3.532 3.47-3.267 1.49 3.309-0.65 7.729-2.75 10.774-3.09 3.044-4.49 6.38-4.36 7.969 0.12 1.588 0.85 3.562 3.08 3.562 2.22 0 0.75-2.768 0.87-4.224s3.83-6.17 3.83-6.17c0.73-1.163 0.12-3.337 0.89-4.342 1.21 0.013 1.71-1.667 2.94 2.966 1.24 4.633 2.72-3.045 2.72-3.045s1.73 5.693-1.98 9.135c2.84-0.397 3.09 0.794 3.09 0.794 0 1.589-1.35 2.25-1.85 5.03s1.48 4.369 1.48 4.369-1.85 2.78-7.04-2.648c-0.13 3.442 1.98 5.825 1.98 5.825-1.74 0.839-3.09 0.75-3.34 2.913z' stroke='%23000' stroke-width='1.0989' fill='%23cdad56'/%3E %3Cpath stroke-width='1pt' d='m198.62 262.5c-2.71-2.46-3.03-0.31-4.36-0.86-0.66-0.27-1.17-0.88-1.74-1.44-0.49-0.51-1.08-0.72-1.73-0.99-0.25 0.73-0.49 1.45-0.74 2.18s0.69 1.94 0.67 3.03c-0.19 1.62-0.85 2.97-2.89 3.52 0.58-1.15 0.91-1.2 0.73-2.61-0.08-0.7-2.05-1.95-1.81-2.61 0.36-1.07 0.98-2.3 0.52-3.37-0.83 0.57-1.93 0.27-2.76 0.62-0.71 0.31-0.75 1.62-1.73 2.16-1 0.47-3.21 0.24-5.06-0.81 1.13-0.85 2.06-0.28 3.19-1.13 0.56-0.43 0.54-2.26 1.1-2.69 0.57-0.43 1.92-0.88 2.48-1.31-0.51-0.58-0.48-1.49-0.99-2.07-0.5-0.58-2.75-0.46-3.26-1.03-1.02-1.16-0.82-2.68-1.84-3.83 2.63 0.94 2.25 2.22 2.91 2.12 1.24-0.6 2.48-0.71 3.13-0.44 0.66 0.28 1.9 1.9 2.55 2.17 0.25-0.73 0.61-1.65 0.85-2.38 0.25-0.73-1.1-1.99-0.86-2.72 0.5-1.45 1.72-2.74 2.21-4.2 0.18 1.41 0.41 2.59 0.59 3.99 0.09 0.7 1.47 1.07 1.56 1.77 0.09 0.71-0.72 2.33-0.64 3.04 0.76-0.15 1.85-0.05 2.6-0.2 0.76-0.15 1.26-1.9 2.01-2.05 1.51-0.3 2.6-0.21 4.13 0.08-1.13 1.05-2 0.98-2.71 1.94-0.56 0.43 0.22 1.84-1.41 2.83-0.61 0.36-2.22-0.07-2.79 0.36 0.51 0.58 1.02 1.15 1.53 1.73 0.5 0.58 2.78 0.85 3.29 1.43 1.01 1.15 1.55 2.53 1.27 3.77z' fill='%23ffc900'/%3E %3Cpath stroke-width='1pt' d='m128.95 263.69c2.71-2.46 3.03-0.31 4.37-0.86 0.65-0.28 1.16-0.89 1.73-1.44 0.49-0.51 1.08-0.72 1.73-1 0.25 0.73 0.5 1.46 0.74 2.19 0.25 0.73-0.68 1.93-0.66 3.02 0.18 1.63 0.84 2.97 2.88 3.53-0.58-1.15-0.91-1.21-0.73-2.61 0.09-0.7 2.05-1.95 1.81-2.62-0.36-1.06-0.98-2.3-0.52-3.37 0.84 0.58 1.93 0.28 2.77 0.62 0.7 0.32 0.75 1.63 1.72 2.17 1.01 0.47 3.22 0.24 5.06-0.81-1.13-0.86-2.06-0.28-3.19-1.14-0.56-0.42-0.53-2.26-1.1-2.68-0.56-0.43-1.91-0.89-2.48-1.32 0.51-0.57 0.48-1.49 0.99-2.07 0.51-0.57 2.76-0.45 3.26-1.03 1.02-1.15 0.83-2.67 1.84-3.83-2.63 0.94-2.24 2.22-2.9 2.13-1.25-0.6-2.49-0.72-3.14-0.44-0.65 0.27-1.9 1.89-2.55 2.17-0.25-0.73-0.6-1.65-0.85-2.38s1.11-1.99 0.86-2.72c-0.49-1.46-1.72-2.74-2.21-4.2-0.18 1.4-0.41 2.58-0.59 3.99-0.09 0.7-1.47 1.07-1.56 1.77-0.08 0.7 0.73 2.33 0.64 3.03-0.76-0.15-1.85-0.05-2.6-0.19-0.75-0.16-1.25-1.91-2.01-2.06-1.51-0.3-2.59-0.21-4.13 0.08 1.13 1.06 2 0.98 2.71 1.95 0.56 0.43-0.22 1.84 1.41 2.83 0.61 0.36 2.23-0.07 2.79 0.36-0.51 0.57-1.02 1.15-1.52 1.73-0.51 0.58-2.79 0.85-3.29 1.42-1.02 1.16-1.56 2.54-1.28 3.78z' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m196.19 270.28c-2.46 1.91-18.31 5.92-18.48 19.69-0.16 13.77 2.78 16.91-0.16 17.26-5.72 0-6.54-15.34-6.38-22.14 0.17-6.8 0.33-5.75 0.33-5.75s3.92 1.04 3.6 4.36c-0.33 3.31 3.92-8.2 2.45-11.33 2.61 2.61 6.05 1.57 6.05 1.39 0-0.17-1.96-2.26-2.78-3.83s2.94 0.87 2.94 0.87 0.16-2.62-3.11-2.44c-4.25 0 0.66-1.4 0.66-1.4s2.45 2.27 4.09-0.17c-1.8-1.92-4.42-2.97-4.42-2.97s-2.29-4.35-5.39-5.22c-3.6-0.88-3.11 1.56-7.2 1.22-0.81 1.56-0.81 1.74 0.82 2.26-2.78 1.92-1.31 5.75-1.31 5.75s4.42-1.91 4.25 1.22c-0.16 3.14-2.61 2.62-4.25 0.7-1.47-0.87-1.96 0.87-1.96 0.87l2.29 2.44s-4.41-0.17-5.56 2.79c2.45-0.17 3.76 0.53 3.76 0.53s-5.07 2.26-5.56 3.48-0.65-1.39-0.81-1.39c-0.17 0-4.91-1.75-4.91-1.75l-1.64 7.54s3.28 3.27 5.07 2.22c1.8-1.04 5.07-4.18 7.03-3.31-5.72 4.36-11.44 10.63-14.55 11.51-0.81-0.7-3.59-3.49-4.74-2.1-1.14 1.4-0.32 3.14 1.15 2.97 1.47-0.18-4.74 1.39-3.44 4.01 1.31 2.61 1.15 2.44 2.29 1.74 1.15-0.7-0.98-0.87 3.27-2.09s4.09-2.44 4.09-2.44-0.82 1.91-3.11 2.44c-2.29 0.52-4.08 0.52-3.59 1.22 0.49 0.69 1.47 1.91 1.14 2.61s4.74-3.66 6.05-0.17c3.43-0.18 5.72-4.36 4.09-6.8 0.16 2.61 1.8 3.49 0.81 4.71-0.98 1.22 7.69-4.01 3.44-7.15 1.14 2.61 1.31 4.71 1.31 4.71s1.96-0.18 2.45-0.88c0.49-0.69-0.98 1.92-0.33 2.44 0.65 0.53 3.76 3.49 2.45 5.58-0.81-1.22-0.98-3.14-1.96-2.96-0.98 0.17-5.07 3.14-7.52 3.31s2.94 9.07 2.94 9.07-3.76-0.53-4.25-0.18-2.94-3.14-3.43-1.04c-0.82 2.61 0.82 1.56 0.82 1.56s-2.13-1.04-3.27 0.18c-1.15 1.22-2.29 2.44-1.47 2.96 0.81 0.52 4.41 0.52 4.9 0.35s-4.09 0.35-4.41 0.87c-0.33 0.52-0.98 2.44 0 3.14s3.43-0.35 3.59-0.87c0.17-0.53 0.33 1.91 0.33 1.91s4.25 0.35 4.25-4c0-4.36 0.33 3.13 0.33 3.13s4.25 0.7 4.41-3.66c0.17-4.35 0.49 2.97 0.49 2.97s2.78-0.88 2.78-1.57c0-0.7-0.16 8.71-2.12 11.33-3.11-2.1-5.07 1.39-5.07 1.39s0.16 5.05-0.17 6.27c-0.32 1.22 2.13-0.69 2.29-1.22 0.17-0.52 3.11-1.91 3.27-2.26 0.17-0.35 0.98-2.09 0.98-2.09s-0.65 2.44-1.79 2.79c-1.15 0.34-2.29 1.56-1.8 2.61s2.29 1.74 2.94 2.79c0.65 1.04 2.94-6.1 2.94-6.1l0.17 1.57s2.94-0.7 3.27-2.09c0.32-1.4-3.11-2.62-0.33-4.88 2.78-2.27 0 2.09 0 2.09s0.98 3.31 1.63 3.31c0.66 0 2.29-6.28 0.66-7.84-1.64-1.57 2.45 1.91 2.45 1.91s2.29-6.45-0.16-7.32c-2.46-0.87-3.6-1.22-3.6-1.22s1.31-1.74 0.65-1.91c-0.65-0.18 3.44 3.83 4.09 2.78 0.66-1.04 1.64-4.18-3.1-5.92-4.75-1.74-0.17-6.63-0.17-6.63s2.95 3.49 5.07 1.57c2.12-1.91-0.16-1.91-0.16-1.91s6.04-3.84 6.21-5.76c-1.15-0.17-3.11 0.18-3.11 0.18s3.44-2.27 2.62-5.93c-1.31 1.92-3.11 1.92-3.11 1.92s2.95-2.96 2.45-5.75c-1.79 1.39-1.63 2.44-2.78 2.09-1.14-0.35-3.1-11.33 1.48-12.03 4.57-0.69 2.12 5.41 2.28 5.41 0.17 0 6.87-2.79 0-7.32 1.64-0.53 5.07 2.61 5.07 2.61s-1.47-7.67-8.83-2.96c1.8-1.92 2.95-3.14 4.42-2.79s6.7-0.18 6.7-1.74c-1.3-1.05-4.08 0.52-5.56 0-1.47-0.53 10.47-1.4 9.49-7.32z' stroke='%23006b00' stroke-linecap='round' stroke-width='.68918' fill='%23ffc900'/%3E %3Cpath d='m481.3 118.54s12.25-6.43 18.37 1.54' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m504.57 132.32c-0.31 0-4.29 3.98-5.21 3.98' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m512.84 145.18s11.32 0.92 18.67-10.41' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m525.08 141.81s0.92 6.13 2.76 6.13c1.83 0-3.06 1.53-4.9 0.3 2.14 2.76 3.37 7.66 0 9.49' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m519.26 218.97s-3.98 4.28-8.88 4.59' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath d='m523.86 199.37s-2.45-12.24-0.92-15.31c0.92-3.98 4.9-5.51 7.96-10.71' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m522.63 190.49s-3.06 7.35-16.53 4.9' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m526.31 172.12s0.91 9.8-11.33 6.13' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m511.3 128.04s-4.9 4.28-3.06 10.1' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m529.67 117.32s6.43-2.45 7.66-3.68c1.22-1.22 3.37-3.67 3.98-5.51 0.61-1.83-4.29-4.59-1.84-8.569 1.53-1.837 3.67-2.143 7.35 0 3.67 2.139-3.37-6.735-7.04-7.041-3.68-0.307-6.13 2.449-7.04 1.836-0.92-0.612 0.3 2.45-1.23 2.45s3.06 2.449 2.76 3.984c-0.31 1.53 4.89 6.73 4.59 7.96-0.31 1.22-7.66 8.26-9.19 8.57z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke-linecap='round' stroke-width='1.25' fill='%23006b00'/%3E %3Cpath stroke-linejoin='round' d='m534.27 97.112c2.79-0.636 3.24 0.07 2.75 2.449-1.31-0.66-1.79-1.217-2.75-2.449z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23ffc900' stroke-linecap='round' stroke-width='1.25' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m514.71 233.52s-1.03 6.41 1.49 6.94c-0.13-2.48 0.54-4.17 1.16-4.83-0.54-0.25-2.53-2.07-2.65-2.11z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m509.03 225.63c-2.32-0.33-6.23 1.59-5.11 3.91 1.89-1.62 3.63 0.13 4.95-1.52 0.4-0.46 0.29-1.81 0.16-2.39z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m509.01 221.05s-3.65-0.58-4.16 1.95c2.52-0.32 3.27-0.59 4.11-0.06 0.24-0.54 0.01-1.76 0.05-1.89z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m493.54 184.94s2.19 0.82 2.81 3.06c1.74-1.08 2.57-5.83-2.81-3.06z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m488.12 190.39c0.09-0.04 4.59-2.77 5.05-0.16-0.95 0.95-1.37 1.57-2.11 1.78-0.58 0-1.74-1.78-2.94-1.62z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m487.67 199.24c0.08-0.04 2.89-2.52 3.97-0.87 1.07 1.66-0.87 1.57-0.87 1.57s-0.99-0.45-3.1-0.7z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m483.7 149.96c-0.04 0-3.6-1.37-5.09 1.11 2.36 0.29 3.19 1.12 4.26 1.95-0.29-1.04-0.78-2.61 0.83-3.06z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m476.8 168.52s0.16-4.17 2.14-5.87c1.12 0.62 1.45 1.61 2.2 2.85-1.49 0.33-3.48 0.42-4.34 3.02z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m486.3 165.54s-3.92 1.82-2.64 3.81c1.28-1.37 2.69-0.95 2.69-0.99s0-2.77-0.05-2.82z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m480.64 125.6c-1.41 1.58 1.74 5.01 5.04 4.51 0.83-3.72-4.21-5.66-5.04-4.51z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m480.6 118.41c-0.69 1.75 2.05 4.21 3.64 3.52 0.64-1.8-2.92-4.91-3.64-3.52z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m484.28 122.75s0.62 2.94 3.47 2.15c-0.45-2.27-2.44-3.97-2.44-3.97-0.12 0.67 0.41 1.7-1.03 1.82z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m486.18 131.27s1.57 1.69 4.67-1.78c-1.4 0.41-3.88-0.83-3.88-0.83s0 2.4-0.79 2.61z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m480.46 118.86c-1.4 1.57 0.59 3.76 3.89 3.27 0.83-3.72-3.06-4.42-3.89-3.27z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23ffc900'/%3E %3Cpath d='m144.62 266.62s7.04-2.01 10.78 1.01c3.73 3.01 3.73 0.28 3.73 0.28s5.46 2.01 7.04 1.58-1.15 0.15 1-1.15c2.16-1.29-4.31 0.29-4.88-2.44-1.01-1.72 0.14-3.88-2.15-3.16-1.58-2.01 1-3.44 0.43-5.6-1.58 1.15-2.45-0.43-3.74 2.44-3.01-0.57-0.43-4.74-3.73-5.17 0 3.02-2.44 3.16-2.59 4.89-1.43 1-7.75 4.74-5.89 7.32z' fill='url(%23linearGradient748)'/%3E %3Cpath d='m63.624 495.58c4.566-1.1 29.306 5.47 38.846 15.69-2.03-18.21-7.072-32.16-7.072-32.16s-14.743-4.21-16.767-2.18c-2.968 3.12-11.883 12.49-15.007 18.65z' stroke='%23000' stroke-width='1pt' fill='%23c01500'/%3E %3Cpath d='m56.082 411.46c-1.734 0.29-3.469 1.45-5.203 4.34-2.024 4.91-3.469 17.34-6.36 20.23s-5.493 3.18-5.493 5.79c0 2.6 0.29 8.67 8.095 10.98 7.805 0.29 20.236-12.43 20.236-12.43s6.36-6.94 8.961-14.45c-15.032 5.2-25.728-8.68-20.236-14.46z' stroke='%23000' stroke-width='1pt' fill='%23c01500'/%3E %3Cpath stroke-width='.99323pt' d='m273.49 492.68c-4.53-1.09-29.55 5.44-39.02 15.6 2.01-18.1 7.02-31.98 7.02-31.98 1.75-0.47 14.47-4.18 16.48-2.16 2.94 3.1 12.42 12.42 15.52 18.54z' stroke='%23000' fill='%23c01500'/%3E %3Cpath stroke-width='.99323pt' d='m280.5 409.05c1.72 0.29 2.33 2.55 3.74 5.43 2 4.88 4.07 12 6.94 14.87 2.87 2.88 5.45 7.13 5.45 9.72s-0.6 6.08-8.35 8.38c-7.74 0.29-18.97-9.66-18.97-9.66s-6.31-6.89-8.89-14.37c14.92 5.18 24.58-8.14 20.08-14.37z' stroke='%23000' fill='%23c01500'/%3E %3Cpath d='m47.41 479.69s15.61 10.69 15.9 15.61c41.92-62.16 148.88-81.53 209.87-4.34 8.1-10.7 16.48-14.16 16.48-14.16-64.17-83.84-191.95-73.43-242.25 2.89z' stroke='%23000' stroke-width='1pt' fill='%23fb0'/%3E %3Cg stroke-width='1pt' transform='translate(-.0000071526 .000045776)' stroke='%23000' fill='%231e5aa6'%3E %3Cpath d='m206.44 241.88l6.11-0.15-10.91 13.82 13.09 15.28-25.75 32.44 24.3 29.24c-2.67 6.55-5.77 12.51-9.9 17.9l-13.96-15.43 25.31-31.56-20.8-23.57 12.51-37.97z'/%3E %3Cpath d='m119.15 244.64l-6.55 0.15 12.22 13.23-12.94 16.15 26.91 29.25-22.26 29.82c2.67 6.55 6.5 13.82 10.62 19.2l13.24-16.73-27.2-30.26 19.93-25.31-13.97-35.5z'/%3E %3Cpath d='m149.41 323.2l-9.6 12.8 34.33 39.72c6.06-3.06 10.82-6.55 16.01-10.76l-17.9-20.66 7.28-21.39 10.47 12.07-32.73 41.76c-5.48-2.33-11.54-5.97-17.02-10.48l17.31-21.96-8.15-21.1z'/%3E %3Cpath d='m138.79 303.27l6.26 7.86-4.08-10.62-2.18 2.76z'/%3E %3Cpath stroke-width='.96849pt' d='m183.6 310.22c0.13-0.15 5.05-6.7 5.05-6.7l-1.91-2.61-3.14 9.31z'/%3E %3C/g%3E %3Cg font-family='Timmons' font-size='14px' font-weight='bold' line-height='100%25'%3E %3Ctext y='362.39716' x='-328.34363' transform='rotate(-49.557)'%3E %3Ctspan y='362.39716' x='-328.34363'%3EL%3C/tspan%3E %3C/text%3E %3Ctext y='384.26642' x='-292.33514' transform='rotate(-45.392)'%3E %3Ctspan y='384.26642' x='-292.33514'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='451.6806' x='-239.78038' transform='matrix(.76280 -.54464 .56769 .75422 0 0)'%3E %3Ctspan y='451.6806' x='-239.78038'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='429.95776' x='-188.5262' transform='matrix(.82844 -.56007 .56007 .82844 0 0)'%3E %3Ctspan y='429.95776' x='-188.5262'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='451.47876' x='-115.42612' transform='rotate(-25.549)'%3E %3Ctspan y='451.47876' x='-115.42612'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='453.04584' x='-94.110794' transform='rotate(-23.988)'%3E %3Ctspan y='453.04584' x='-94.110794'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='454.98212' x='-68.37056' transform='rotate(-21.911)'%3E %3Ctspan y='454.98212' x='-68.37056'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='445.66595' x='112.01579' transform='rotate(-4.7626)'%3E %3Ctspan y='445.66595' x='112.01579'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='430.7926' x='180.22531' transform='rotate(.85649)'%3E %3Ctspan y='430.7926' x='180.22531'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='275.21735' x='414.75919' transform='rotate(29.645)'%3E %3Ctspan y='275.21735' x='414.75919'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='193.05025' x='483.87762' transform='rotate(39.802)'%3E %3Ctspan y='193.05025' x='483.87762'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='414.02829' x='309.11557' transform='matrix(.96356 .18112 -.15531 .95184 0 0)'%3E %3Ctspan y='414.02829' x='309.11557'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='459.27182' x='105.05786' transform='matrix(.90188 -.13160 .13648 0.975 0 0)'%3E %3Ctspan y='459.27182' x='105.05786'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='455.83463' x='-45.707756' transform='rotate(-20.292)'%3E %3Ctspan y='455.83463' x='-45.707756'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='144.72449' x='518.34955' transform='matrix(.70468 .70952 -.70952 .70468 0 0)'%3E %3Ctspan y='144.72449' x='518.34955'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='388.29758' x='271.18784' transform='matrix(.98042 .19691 -.19691 .98042 0 0)'%3E %3Ctspan y='388.29758' x='271.18784'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='455.1676' x='40.321587' transform='rotate(-10.645)'%3E %3Ctspan y='455.1676' x='40.321587'%3EM%3C/tspan%3E %3C/text%3E %3Ctext y='448.07883' x='94.428757' transform='rotate(-5.9402)'%3E %3Ctspan y='448.07883' x='94.428757'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='437.60687' x='155.08846' transform='rotate(-1.4626)'%3E %3Ctspan y='437.60687' x='155.08846'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='276.66531' x='405.13382' transform='rotate(29.499)'%3E %3Ctspan y='276.66531' x='405.13382'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='409.79309' x='232.09538' transform='matrix(.99340 .11468 -.11468 .99340 0 0)'%3E %3Ctspan y='409.79309' x='232.09538'%3EI%3C/tspan%3E %3C/text%3E %3Ctext y='132.08934' x='530.39215' transform='rotate(46.586)'%3E %3Ctspan y='132.08934' x='530.39215'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='218.51869' x='464.15771' transform='rotate(36.816)'%3E %3Ctspan y='218.51869' x='464.15771'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='361.96112' x='313.72498' transform='rotate(16.412)'%3E %3Ctspan y='361.96112' x='313.72498'%3EM%3C/tspan%3E %3C/text%3E %3Ctext y='123.24773' x='513.7041' transform='rotate(47.66)'%3E %3Ctspan y='123.24773' x='513.7041'%3EG%3C/tspan%3E %3C/text%3E %3C/g%3E %3Cg stroke='%23fff700' stroke-linecap='round' stroke-width='1pt' fill='none'%3E %3Cpath d='m255.94 200.94s6.04-5.17 10.34-5.32'/%3E %3Cpath d='m256.81 200.22c0.14-0.14 36.05-5.17 37.19-6.32'/%3E %3Cpath d='m256.95 200.51c0.14-0.15 40.21-3.45 40.21-3.45'/%3E %3Cpath d='m256.81 200.65s42.65-2.01 45.24 0.15'/%3E %3Cpath d='m256.66 200.51s41.8 0.29 42.52 1.29'/%3E %3Cpath d='m256.81 200.51l40.21 3.3'/%3E %3Cpath d='m256.38 200.8c0.14 0 40.93 3.59 44.95 8.76'/%3E %3Cpath d='m303.48 216.88c-0.14-0.14-13.93-16.52-47.25-16.23'/%3E %3Cpath d='m256.38 200.94s23.12 1.58 30.44 9.62'/%3E %3Cpath d='m256.81 200.65s14.93-2.87 30.59 15.95'/%3E %3C/g%3E %3Cpath d='m247.4 217.74s20.72 0.82 20.72 2.85-15.44 5.89-15.64 14.42 11.78 9.14 12.59 19.9c0.81 10.77-9.34 12.39-11.37 15.24-2.04 1.42-6.91 16.65-6.3 25.59s3.25 39.2 7.92 45.3c3.66 2.84 9.14 11.98 15.03 9.14 5.89-2.85 1.83-13.2 1.22-16.05-0.61-2.84 2.44-7.51 2.44-11.78s-2.24-7.72-2.03-8.73c0.2-1.02 16.45 3.86 15.43 19.9-1.01 16.05-7.51 11.17-7.51 11.17s2.03 19.71-3.05 22.35c-9.14 4.87-15.84-1.02-15.84-1.02l0.86 4.01-6.95-3.6s-8.94-12.8-10.97-18.49c-2.03-5.68-4.47-31.07-3.66-36.56 0.81-5.48 1.42-37.58 1.02-39.2-0.41-1.63-2.03-28.44-1.02-32.5 1.02-4.06 7.31-21.94 7.11-21.94z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient801)'/%3E %3Cpath d='m225.06 212.46s14.42-14.01 22.75-12.39c4.26 0 0.2 3.05 0.2 3.05s7.31 0.61 8.33 3.86c0.2 1.42-3.46 1.83-3.46 1.83s3.05 0.61 3.25 3.25c0.21 2.64-30.87 0.6-31.07 0.4z' stroke='%23000' stroke-width='1pt' fill='%23ff7000'/%3E %3Cpath d='m225.87 211.85s15.44-2.03 21.94-8.53' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m241.51 207.59s11.37-0.41 11.37 1.22' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m281.93 373.74s9.75-2.24 12.39-5.69c1.63-1.22 10.16 12.8-12.39 5.69z' stroke='%23000' stroke-width='1.25' fill='%23FFF'/%3E %3Cpath d='m279.29 293.1s1.22 7.52-2.23 12.59c-1.83 2.03-7.32 5.49-7.32 7.93 0 2.43 2.03 5.68 1.63 8.53-0.41 2.84-3.45 5.69-3.25 8.12 0 2.44 3.45 15.44 3.04 15.64' stroke='%23FFF' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m261.42 268.73s-7.72 2.64-9.35 10.36' stroke='%23FFF' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m258.16 207.59s2.65 7.31 11.18 0.4c-5.49-7.51-11.18-0.2-11.18-0.4z' stroke='%23000' stroke-width='1pt' fill='%23c75b00'/%3E %3Cpath d='m264.87 206.47c0 0.39265-0.40924 0.71095-0.91405 0.71095s-0.91405-0.3183-0.91405-0.71095c0-0.39264 0.40924-0.71094 0.91405-0.71094s0.91405 0.3183 0.91405 0.71094z' transform='translate(-.40625 .8125)'/%3E %3Cpath d='m188.41 190.62s16.18 17.51 26.65 17.32c1.9 5.14-4.76 9.92-7.42 12.2-5.33-1.71-10.15 0.31-22.52-14.91 0.77-9.71 3.48-14.23 3.29-14.61z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m210.3 149.89c2.09-6.47 6.28-11.61 9.89-12.18-0.95-4.95 7.62-26.83 32.55-35.21 1.52 11.23-10.66 22.27-10.66 22.27s36.73-6.28 44.15-15.61c-0.76 4.19-8.18 30.26-47.39 30.07 14.85 14.09-4.75 25.32-13.13 21.89 15.42-11.8-4.37-18.84-15.41-11.23z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m222.86 140.76c7.42-4.76 10.08-4.76 16.18-3.81-4.38 0.57-4.38 0.76-4.38 0.76s-0.38 0.57 2.28 3.05c-3.04-0.77-5.71-2.48-14.08 0z' stroke='%23CCC' stroke-width='1pt' fill='%23cccccd'/%3E %3Cpath d='m220 137.71s14.66-7.8 22.84-13.13' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m207.44 220.12s20.18 5.52 22.46-23.41c-4.38-12.56-10.47-39.59-1.14-47.39-8.57-5.9-17.89 0.19-17.89 0.19-0.57 1.33-8.19 12.18 2.09 31.21-24.36-6.47-14.46 16.56-14.46 16.56 0.95-3.62 13.89-7.04 17.13 11.42 1.33 4.57-8.76 11.61-8.19 11.42z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m230.09 196.9s21.32-11.42 20.74-38.25c-18.08 0.38-24.55 23.78-24.55 23.78l3.81 14.47z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m134.55 195.57s-15.79 13.7-24.74 9.32c-6.66 4-14.462-3.04-14.462-3.04s9.132 33.68 41.872 9.32c-0.57-7.42-2.29-15.03-2.67-15.6z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m109.62 204.32c1.33-7.04 6.85-10.47 11.23-3.81 5.9 1.15 11.8-23.02-9.14-19.03 5.9-31.59-11.795-43.39-11.795-43.39s-6.28 35.02-3.426 41.49c2.855 6.47-4.186-11.99-26.834-17.13-0.381 26.46 25.312 38.83 25.312 38.83s7.233 6.66 14.653 3.04z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m111.71 181.29s-9.89 8.38-7.61 19.8' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m96.68 180.15s-2.284 8.18 2.664 19.79' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m95.157 202.61s4.568-7.42 14.463 2.09' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m97.06 151.22c0-0.19-15.034 0-6.09 15.23-6.661 2.09-21.505-7.61-11.228-20.56-33.686-0.76-47.389-16.93-47.389-31.78 9.897 10.28 33.496 6.09 41.87 12.37-10.277-9.51-8.184-22.65-8.184-22.65s28.738 8.57 33.876 34.07c-1.713 4.95-2.474 13.7-2.855 13.32z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m73.942 125.82c5.546 5.64 19.795 7.33 27.028 13.61' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-width='.94781' d='m80.503 142.47s11.797-1.52 15.216 2.66c-4.616 0-6.155-1.14-12.822 1.34 1.88-0.96 1.367-2.67 2.393-2.67s-4.274-1.33-4.787-1.33z' stroke='%23CCC' fill='%23cccccd'/%3E %3Cpath d='m139.31 50.166s6.47-5.71 13.51-0.571c-3.18 9.507-14.65 5.9-14.65 5.9s0.38 4.758-0.76 7.041c2.29 1.727 4.18 7.423 4.18 7.423s11.8-2.855 14.28 2.284c4.52-0.624 7.8 0 7.8 0s9.14-2.284 12.37-2.284c3.24 0 13.51 2.664 14.46 4.567 0.96 1.903 4.38 14.655 6.67 14.464 2.28-0.19-5.52 3.045-7.62-0.19-2.09-3.236-1.52 4.187-1.52 4.187s6.47 6.851 7.23 8.373c0.76 1.52-3.99 13.89-0.38 22.46-3.17 0.29-3.42 3.61-3.42 3.61-0.18 3.77-4.95 4.76-4.95 4.76l-1.14-5.14-3.24 1.91 1.33-4s4.38-10.66 4.76-14.08c0.38-3.43-4-9.52-7.42-9.52-3.43 0-5.9 10.85-5.9 10.85s-1.71 8.18-1.14 8.94-2.29-2.66-2.29-2.66-1.52 4.95-2.66 6.47-3.62 2.09-3.62 2.09-1.71-4.95-1.14-6.85 9.33-9.32 8.57-14.65c-0.77-5.33 0-4-0.2-4.19-0.19-0.19-4.56-3.996-4.75-6.089-0.19-2.094-5.71 2.664-12.94 1.141-2.22 3.868-2.48 13.508-2.48 13.508s-0.76 11.61 0.76 12.95c1.53 1.33-3.8 4.18-3.8 4.18l-3.81 5.14s-1.33-3.23-1.33-3.04-2.67 1.9-2.67 1.9l1.53-3.81c-0.1-2.88 3.7-10.75 3.7-17.41s0.48-13.798 0.48-13.798-7.04-0.381-6.85 6.848c0.19 7.24-1.71 7.62-1.33 9.71s2.28 7.99 1.71 9.71c-0.57 1.71-2.85 2.28-2.85 2.28l-0.57 0.95s-7.04 3.24-6.85 4.57-0.19-3.81-0.19-3.81l-0.39-5.52s4.19-2.66 4.19-9.32-0.96-7.61-0.77-9.13c0.19-1.53 1.15-7.05 0.96-7.62-0.19-0.571-3.99 1.522-5.14 1.522-1.14 0 2.1-3.996 2.48-6.851s-3.81 2.664-7.23-0.571c1.59-3.514 3.99-4.568 4.37-7.232s-2.66 2.284-5.33 0.381c0.22-2.554 2.86-4.758 2.86-4.758s-2.17-0.266-3.05 0c-1.71-0.571 1.91-3.236 2.1-7.042s-2.1-5.329-2.1-5.519-3.8-3.426-4.37-4.758-0.57-2.855-0.57-2.855-6.29 4.568-13.71-5.138c6.8-5.803 14.09-1.523 14.09-1.523s1.9-5.329 10.65-4.948c8.76 0.381 10.47 5.329 10.09 4.758z' stroke='%23000' stroke-width='1pt' fill='%23923f00'/%3E %3Cpath d='m187.19 148.61c0.15 0 16.16 0.48 16.32 9.04 0.16 8.55-4.91 6.34-5.07 6.34s-11.73-1.43-11.73-1.43l0.48-13.95z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m171.65 146.23s19.97-0.15 18.86 8.56c-1.11 8.72-6.18 6.98-6.18 6.98l-9.67-0.8-3.01-14.74z' stroke='%23000' stroke-width='1pt' fill='%23fffeff'/%3E %3Cpath d='m160.4 145.28l11.57 0.95s6.97 0.95 6.66 7.61c-0.32 6.66-7.14 6.82-7.14 6.82l-11.25-0.64 0.16-14.74z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m133.3 148.61c-0.16 0-16.17 0.48-16.33 9.04-0.15 8.55 4.92 6.34 5.08 6.34s11.73-1.43 11.73-1.43l-0.48-13.95z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m148.83 146.23s-19.97-0.15-18.86 8.56c1.11 8.72 6.18 6.98 6.18 6.98l9.67-0.8 3.01-14.74z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m160.09 145.28l-11.57 0.95s-6.98 0.95-6.66 7.61 7.13 6.82 7.13 6.82l11.25-0.64-0.15-14.74z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m191.07 241.51s8.32-12.26 11.83-10.95c3.06 1.02 0.73 10.51-0.73 11.39l-11.1-0.44z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath d='m134.04 243.7c-2.62-3.65-6.42-13.72-9.92-10.95-3.07 1.02-0.73 10.51 0.73 11.39l9.19-0.44z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath d='m139.55 219.45s16.21 9.99 21.53 10.25 22.18-12.97 22.18-12.97' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m141.11 180.29l3.11-3.89 15.57 7.91 15.82-7.01 3.11 3.25-17.64 12.45-19.97-12.71z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath stroke-linejoin='round' d='m128.75 180.08c1.26 1.59 11.32 13.82 13.14 23.94 1.81 10.12-1.04-13.88-1.04-13.88s12.45 6.1 12.84 9.99 5.95-0.26 6.22-0.93l-36.05-23.41 4.89 4.29z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath stroke-linejoin='round' d='m190.26 179.38s-13.1 17.25-11.54 36.05c-2.7-9-0.52-23.86-0.52-23.86l-2.85 1.82s-2.98 12.71-6.75 14.65c-0.63-1.51-0.51-2.07-0.51-2.07s-4.02 5.18-4.8 5.7 0.26 17.51 0.26 17.51 1.35 12.32 2.9 12.19c-1.77 0.86-3.94 2.21-3.94 2.21l-1.61-32.88 3.68-3.7s4.93-5.96 5.32-11.8c-2.14 1.82-4.54 2.34-4.54 2.34s-0.65 8.3-2.59 9.46c-1.95 1.17-2 3.34-2 3.34l-0.46-10.85 29.95-20.11z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath d='m160.3 199.35l2.54 51.87' stroke='%23000' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m128.4 224.12s5.96 3.51 8.17 14.14c19.45-1.43 25.55 5.45 25.55 5.45s15.95-7.65 23.35-6.23c2.59-5.44 9.98-12.45 9.98-12.45' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m120.26 173.28l40.04 26.2 36.06-24.25s7.52-4.15 6.87-7.13c-0.64-2.99-3.24-1.82-4.54-1.3-1.29 0.52-37.74 26.33-37.74 26.33l-38.78-24.52s-2.85-0.9-3.37 0.91c-0.52 1.82 1.07 2.85 1.46 3.76z' stroke='%23000' stroke-width='1pt' fill='%23b4b6b9'/%3E %3Cpath stroke-linejoin='round' d='m191.87 166.48s-10.25-4.35-10.25-0.58c0 3.76 0.29 4.15 1.94 6.57 1.64 2.41-1.26 3.96-1.26 3.96s-0.39-1.06-0.97-2.71c-0.58-1.64-6.09-2.8-6.57-4.73-0.48-1.94 1.16-5.03-2.13-5.41-3.28-0.39-6.47 1.35-7.15 5.12s-4.93 12.56-4.93 12.56l0.58-20c7.22 0.51 20.62 2.09 30.93 3.28-3.09-0.48 1.16 0.2 1.07 1.26-0.29 0.87-1.36 0.96-1.26 0.68z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath stroke-linejoin='round' d='m155.62 161.45c-1.83 0-11.02 1.06-13.34 2.42-2.32 1.35 3.77 3.47 3 5.31s-0.87 5.51-3.77 4.74c-2.9-0.78-12.66-5.61-12.95-7.25s-2.32-1.74-2.32-1.74 28.03-3.77 29.38-3.48z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath d='m160.04 159.15l-0.07 24.58' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m141.11 130.19s-11.23 18.23-11.45 18.79' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m161.8 129.74s4.89 6.67 4.33 8.56c2 1.56 4.23 7.79 4.23 7.79' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient746)'/%3E %3Cpath d='m180.7 128.63s-10.56 14.9-10.23 16.01' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m126.5 56.748c0 0.79388-1.1339 1.4375-2.5327 1.4375s-2.5327-0.64357-2.5327-1.4375c0-0.79388 1.1339-1.4375 2.5327-1.4375s2.5327 0.64357 2.5327 1.4375z' transform='matrix(1.0161 .31118 -.30126 1.0495 15.15 -41.141)'/%3E %3Cpath d='m126.5 56.748c0 0.79388-1.1339 1.4375-2.5327 1.4375s-2.5327-0.64357-2.5327-1.4375c0-0.79388 1.1339-1.4375 2.5327-1.4375s2.5327 0.64357 2.5327 1.4375z' transform='matrix(-1.0161 .31118 .30126 1.0495 242.3 -41.435)'/%3E %3Cpath stroke-linejoin='round' d='m254.49 366.13s-3.92 0.74-3.79 1.1c0.12 0.37-11.39 0.74-11.63 0.37-0.25-0.37-1.72 1.96-1.72 1.96l1.84-1.1s2.81 2.93 3.67 2.69-0.37 1.1-0.12 1.35c0.24 0.24 1.1-0.49 1.1-0.49l19.02-0.32-8.37-5.56z' stroke='%23000' stroke-width='1pt' fill='%23ff7000'/%3E %3Cpath stroke-linejoin='round' d='m261.58 372.05l-15.54 0.45s-3.91 3.55-4.16 4.4c-0.24 0.86 2.57 1.1 2.57 1.1l0.86 2.94 1.96-0.73s13.21 1.96 25.34-0.74c6.12-2.14 7.19-4.71 2.9-6.27-4.28-1.56-13.81-1.09-13.93-1.15z' stroke='%23000' stroke-width='1.25' fill='%23ff7000'/%3E %3Cpath d='m208.37 403.93l27.97-1.25-5.21-4.42 75.65-3.05-2.61-6.01-84.7 3.4 10.19 4.76-22.88 0.68 0.68 2.38-6-0.23s6.68 2.6 6.91 3.74z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient794)'/%3E %3Cpath d='m239.73 249.42c-2.23-1.11-12-2.44-22.89 4.67l0.45 25.11s15.99-8.67 23.77-6.67c-0.45-7.78-0.45-17.77-1.33-23.11z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient800)'/%3E %3Cg stroke='%23000' stroke-width='1pt' fill='none'%3E %3Cpath d='m85.074 325.65l-65.956 65.48'/%3E %3Cpath d='m114.47 326.13l-53.532 70.5'/%3E %3Cpath d='m112.08 307.73l-71.455 86.51'/%3E %3Cpath d='m38.474 393.04l6.93-8.12'/%3E %3Cpath d='m125.7 351.22l-27.722 38.24'/%3E %3Cpath d='m96.783 394.48l0.717 14.57'/%3E %3Cpath d='m138.36 364.6l-29.39 36.81'/%3E %3Cpath d='m133.11 398.54l11.95-19.6'/%3E %3Cpath d='m137.65 375.12l-14.34 16.25'/%3E %3Cpath d='m133.35 359.83l-9.8 11.94'/%3E %3Cpath d='m120.68 342.38s-29.871 43.73-29.393 47.32'/%3E %3Cpath d='m117.57 336.65c-0.71 0.47-25.805 33.69-25.805 33.69'/%3E %3Cpath d='m90.331 380.85l-4.541 5.5'/%3E %3Cpath d='m80.055 394.72l-6.93 9.08'/%3E %3C/g%3E %3Cpath d='m81.811 225s-2.024 6.36 0 9.54c2.023 3.18 14.743 28.91 14.743 28.91s8.676-10.7 11.856-10.99c3.18-0.28 1.73 27.76 1.73 27.76s-5.2 4.91-8.38 4.62c-3.182-0.29 7.8 10.99 7.51 20.53s-14.45 56.95-19.654 57.81c-5.203 0.87 2.313-8.67 2.024-11.27s-1.735-0.87-2.891-3.76 1.735-7.23 1.156-10.12c-0.578-2.89-3.18-2.31-3.469-4.33-0.289-2.03 1.735-2.6 1.446-4.92-0.289-2.31-3.469-1.73-3.18-3.76 0.289-2.02 0.578-1.15 0.289-4.91s-0.867 2.6-4.047 2.89-5.782 7.52-5.782 7.52-6.36 8.96-12.72 4.91c3.758 8.1 0.868 11.57-0.578 11.85-1.445 0.29 1.156 6.36-2.313 6.65s2.602 13.59-1.445 14.75c4.336 2.02 0.867 4.62 0.867 4.62s-10.02 0.84-7.805 13.88c-29.487-10.41-43.941-28.33-43.652-46.54 0.2893-18.22 6.071-34.69 20.236-40.76 4.047-15.04 10.985-31.23 10.985-31.23s-1.156-6.65-0.289-10.98c0.868-4.34 4.915-8.67 4.915-8.67s-0.579-10.41-0.289-15.61c0.289-5.21 2.312-7.52 2.601-10.41s-0.867-17.64 2.024-20.24 8.383-2.31 11.274-4.04c2.891-1.74 6.649-4.92 10.407-4.63s6.938 2.89 6.938 2.89 14.166 0 15.033 5.49c0.867 5.5-2.891 7.52-2.891 7.52s2.024 7.81-6.649 15.03z' stroke='%232b2b2b' stroke-width='1pt' fill='%238a9396'/%3E %3Cpath d='m69.666 206.45c0 0.95295-1.5933 1.7255-3.5588 1.7255s-3.5588-0.77251-3.5588-1.7255c0-0.95295 1.5933-1.7255 3.5588-1.7255s3.5588 0.77251 3.5588 1.7255z' transform='matrix(.87942 -.47604 .47604 .87942 -90.31 56.579)' stroke='%232b2b2b' stroke-width='1pt' fill='%23cecfcf'/%3E %3Cpath d='m66.68 206.44c0 0.35596-0.44597 0.64453-0.99609 0.64453-0.55013 0-0.99609-0.28857-0.99609-0.64453 0-0.35597 0.44597-0.64453 0.99609-0.64453 0.55013 0 0.99609 0.28856 0.99609 0.64453z' transform='matrix(1.0784 0 0 1.4848 -5.0735 -100.09)'/%3E %3Cpath d='m87.971 216s3.511 15.68-0.687 26.5' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.051 209.14s6.85 9.06 5.966 20.33' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.714 207.15c0.221 0 5.745 4.86 5.524 8.17' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m91.04 205.16s3.757 2.65 4.64 5.3' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.272 203.61s-13.479 21.88-11.711 35.58' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m90.156 202.95s-17.899 10.61-21.213 45.3' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m88.167 209.36l-7.071 5.3' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m62.314 250.24s9.943-41.32 27.621-47.29' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m96.785 264.16s9.505-11.93 11.715-11.49 1.54 27.62 1.54 27.62-7.07 5.3-8.61 5.08c-1.551-0.22 7.95 12.82 7.73 17.68s-0.44 4.86-0.44 4.86 0-2.87-2.21-7.51-0.89-9.95-15.249-21.66c-3.536-7.29 7.071 4.42 9.279 2.65 2.21-1.76-3.976-17.01-3.755-17.23z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m79.893 196.96s-3.994 1.09-4.539 2.72c-0.545 1.64-2.905 3.27-4.176 2.72-1.271-0.54-3.632-2.54-3.632-2.54' stroke='%232b2b2b' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m57.196 210.94s-5.992 5.99-3.086 6.72c2.905 0.72 5.992-4.72 5.992-4.72s0 9.26 2.542 7.8c2.542-1.45 9.986-6.71 9.986-6.71s2.542-0.19 3.087 0c0.545 0.18 6.9 5.62 11.076 3.63-2.36 6.17-5.084 6.9-5.084 6.9s-4.358 5.63-9.986 4.35c-5.629-1.27-7.082-3.63-7.082-3.63s-4.721 0.37-6.174-1.81c-1.452-2.18-1.997-3.45-1.997-3.45s-2.723 2.72-3.45 1.45c-0.726-1.27 0-8.72 4.176-10.53z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath d='m91.151 202.59s-11.076-3.27-14.889 2.18c-3.813 5.44-2.905 8.53-0.908 9.07' stroke='%232b2b2b' stroke-width='1pt' fill='none'/%3E %3Cpath d='m92.86 202.28c0 1.3059-0.93488 2.3645-2.0881 2.3645s-2.0881-1.0586-2.0881-2.3645 0.93488-2.3645 2.0881-2.3645 2.0881 1.0586 2.0881 2.3645z'/%3E %3Cpath d='m60.624 230.54s4.517 6.95 9.902 8.86-3.735 3.56-9.12-0.08c-3.908-5.3-2.866-9.12-2.866-9.12s1.042-1.05 2.084 0.34z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m99.275 271.54s-12.681-17.63-16.329-18.59c-3.648-0.95 2.779-1.73 6.688 2 3.908 3.73-1.042-6.08-1.042-6.08l10.683 22.67z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m59.409 373.42c4.863-1.3 26.056 12.16 30.833 15.55 4.777 3.38 14.768 1.21 14.768 1.21s-4.61 2.78-7.472 3.48c-2.866 0.69 8.512 0.69 8.512 0.69s-27.099 7.47-54.632-7.03c-2.519-11.29 5.906-13.81 7.991-13.9z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath d='m90.416 275.88s-3.561-0.69-5.385-2.78c-1.824-2.08-4.43-7.21-7.122-9.38-2.693-2.17-16.155-9.55-21.019-9.03s-6.341-0.52-6.949-1.13-2.605 0.26-2.258 2.78c0.348 2.52-3.735 8.08-2.258 10.68 1.476 2.61 8.425 13.2 9.815 13.55 1.389 0.35 0.521 6.17 0.521 6.17s6.166 6.25 7.73 6.6c1.563 0.35 3.126 1.48 2.953 2.95-0.174 1.48-6.775 9.56-6.775 9.56s-7.122 3.73-7.209 5.82c-0.087 2.08 1.737 6.42 7.383 7.81 5.645 1.39 20.845 0.26 21.627-1.04 0.781-1.3 1.997-9.12 1.476-9.9s-4.256-3.13-6.167-2.78c-1.91 0.35-3.647 1.91-3.474 2.26 0.174 0.35-2.692 1.82-2.692 0.43s5.645-7.64 6.166-7.12c0.522 0.52 8.512 1.3 9.989 5.3 1.476 3.99 1.476 6.86 5.645 6.43 4.169-0.44 9.987-4.26 10.507-12.25s-4.687-13.38-5.99-14.16-5.646-3.39-5.993-4.6c-0.348-1.22-1.216-5.21-0.521-6.17z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m15.286 311.15s13.463-3.48 16.937-3.39c3.474 0.08 16.589 6.16 20.411 9.9 3.821 3.73 11.638 12.59 16.763 11.81 5.124-0.78 6.601-1.82 6.601-1.82l-1.998 3.82s-4.169 1.13-6.253 0.61c-2.085-0.52-6.167-1.83-10.249-5.82-4.082-4-16.676-14.77-27.359-13.99-10.684 0.79-16.85 11.3-16.85 11.3s0.087-5.13 0.521-6.26-2.258 2.43-2.258 2.43l3.734-8.59z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m64.88 321.57c0.087 0.08 3.388 0.95 8.946 0.95 5.559 0 8.512-2.43 8.512-2.43l-0.347-2.17 0.868-3.04s4.256 4.34 4.169 5.21-1.737 1.22-1.737 1.22l-0.608-2.09-1.476 1.83s-8.078 6.42-12.507 5.47c-4.43-0.96-8.512-3.82-7.383-4.52 1.129-0.69 1.737-0.43 1.563-0.43z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m45.251 332.95s-4.864-0.09-7.035 0.95-2.953 2.35-4.43 2.17c-1.476-0.17-2.605-2.08-2.171-2.86 0.608-1.22 3.474-2.78 8.946-2.35 5.472 0.44 4.69 2.09 4.69 2.09z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m62.275 346.15c0-0.26-0.348-7.12-3.04-9.9-2.693-2.78-5.993-2.78-7.47-2.44-1.476 0.35 5.472 3.39 6.167 5.39s2.953 7.56 2.345 8.95c-0.608 1.38-1.737-3.91-5.993-5.39s-10.162-0.69-8.946 1.22 5.993 0.17 8.425 4.25 4.256 8.43 4.256 8.43l0.782-2.96 2.171-0.6 0.26-5.65 1.043-1.3z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m58.801 368.38l-4.43-8.86s-1.39-5.64-5.124-7.21c-3.735-1.56-8.686-1.3-8.773 0.61s7.991 4.34 8.512 5.39c0.521 1.04 0.261 2.78-0.434 2.86-0.695 0.09-4.256-1.3-6.08-0.87-1.824 0.44-2.866 2.78-5.559 2.09-2.692-0.7-4.951-9.29-3.908-10.16 1.042-0.87-1.998 1.56-2.606-0.7s0.869-9.29-0.174-10.16c-1.042-0.87-6.079-3.91-6.166-4.52-0.087-0.6 0.26-34.56 28.662-6.42-12.16-14.42-16.937-12.86-19.195-12.94-1.65 0-12.681 0.95-15.46 15.02-2.78 14.07-6.08 5.3-6.08 5.3s-0.608 6.08 2.345 7.82c2.953 1.73-1.39 6.77-1.39 6.77s-5.2978-12.94-4.5161-18.59c-1.0423 4.52-0.9554 15.72 5.7321 27.97 7.817 8.25 15.2 15.9 34.829 24.49 10.336-15.8 9.815-17.71 9.815-17.89z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m40.214 368.47s5.732 0.69 7.295 3.65c1.564 2.95 2.259 7.47 2.259 7.47 0.955-1.91 1.389-3.56 3.3-4.95s3.301-1.57 3.214-2.61-6.08-7.38-9.12-7.73-8.338 3.3-8.338 3.3-0.955 1.39 1.39 0.87z' stroke='%232b2b2b' stroke-width='1.25' fill='%238a9396'/%3E %3Cg stroke-width='1.25' stroke-linecap='round' fill='none'%3E %3Cpath d='m53.307 383.41s14.856 6.77 39.324 7.21' stroke='%238a9396'/%3E %3Cpath d='m102.9 314.45s-1.27 12.47-10.861 37.07' stroke='%232b2b2b'/%3E %3Cpath d='m100.99 322.12s-2.879 8.95-10.869 15.66' stroke='%232b2b2b' stroke-linecap='butt' stroke-width='1pt'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='960' height='600'%3E %3Cdefs%3E %3CradialGradient id='rgbase'%3E %3Cstop stop-color='%23f9f0aa' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='rg1' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='447.41758' cy='308.26917' r='16.53415'/%3E %3CradialGradient id='rg2' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='451.55806' cy='312.99521' r='10.9114'/%3E %3CradialGradient id='rg3' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='454.11008' cy='308.64279' r='9.7796'/%3E %3CradialGradient id='rg4' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='458.39039' cy='307.05652' r='17.35437'/%3E %3CradialGradient id='rg5' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='445.97552' cy='252.36294' r='13.01791'/%3E %3CradialGradient id='rg6' gradientUnits='userSpaceOnUse' cx='477.85817' cy='215.26555' r='0.34463'%3E %3Cstop stop-color='%23a50a0a' offset='0.2592'/%3E %3Cstop stop-color='%234c0505' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='rg7'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%23fff' stop-opacity='0' offset='1'/%3E %3C/radialGradient%3E %3ClinearGradient id='lg1' gradientUnits='userSpaceOnUse' x1='473.90569' y1='259.17123' x2='472.35656' y2='231.96319'%3E %3Cstop stop-color='%23b07e09' stop-opacity='0' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='lg2' gradientUnits='userSpaceOnUse' x1='483.12617' y1='296.65618' x2='485.49465' y2='326.58339'%3E %3Cstop stop-color='%23b07e09' stop-opacity='0' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='lg3' gradientUnits='userSpaceOnUse' x1='451.54058' y1='249.52251' x2='455.36642' y2='240.57625'%3E %3Cstop stop-color='%23f9f0aa' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='lg4' gradientUnits='userSpaceOnUse' x1='473.31357' y1='237.24661' x2='475.92895' y2='270.44556'%3E %3Cstop stop-color='%23f9f0aa' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3C/defs%3E %3Crect width='960' height='600' fill='%234997d0'/%3E %3Crect width='320' height='600' x='320' fill='%23fff'/%3E %3Cg%3E %3Cg stroke='%2324420e'%3E %3Cg fill='none' stroke-width='0.437'%3E %3Cpath d='m452.12,377.48c2.67-0.40662,4.2078-1.1381,6.035-1.7864'/%3E %3Cpath d='m460.37,371.64c1.3468,1.4287,2.4172,2.9497,2.9932,4.6354'/%3E %3Cpath d='m455.25,371.2c1.4045,1.3127,2.3761,2.7115,3.138,4.1523'/%3E %3Cpath d='m408.81,238.77c-1.0444,1.6022-3.0921,2.7264-4.7798,3.4277'/%3E %3Cpath d='m403.69,242c0.035-1.3682-0.23597-3.0257,0.0496-4.3935'/%3E %3Cpath d='m401.76,242.63c0.11383,0.36926,0.43502,1.401,0.67602,2.0278'/%3E %3Cpath d='m404.46,245.58c-0.37821,0.0817-1.5209,0.25695-2.0278,0.33845'/%3E %3Cpath d='m398.48,245.04c-0.0127,2.5201,0.28557,5.5528,0.53116,7.8214'/%3E %3Cpath d='m397.22,251.9c0.47195,0.75686,0.94717,1.5041,1.545,1.8828'/%3E %3Cpath d='m394.18,260.25c0.48878,0.93952,0.94259,2.1224,1.3038,3.9589'/%3E %3Cpath d='m399.2,259.58c-0.41449,0.20451-1.2148,0.93057-1.9313,1.5448'/%3E %3Cpath d='m398.86,265.52c-0.97864,0.87201-2.1978,1.5043-3.428,2.1244'/%3E %3Cpath d='m391.62,308.05c1.1534,1.8935,2.4205,3.5595,3.9589,4.6836'/%3E %3Cpath d='m396.16,314.42c-1.2944-0.16606-2.1607-0.54537-2.9451-0.96575'/%3E %3Cpath d='m397.61,321.86,1.6892,0.96575'/%3E %3Cpath d='m398.86,326.3c1.2548,0.81629,2.5101,2.2826,3.7653,3.8625'/%3E %3Cpath d='m401.18,333.01c1.3853,0.29278,2.493,0.64106,3.2348,1.0621'/%3E %3Cpath d='m403.35,336.49,2.1244,0.0725'/%3E %3Cpath d='m406.68,331.18c-0.10248,1.534-0.25346,2.972-0.48266,4.2486'/%3E %3Cpath d='m407.21,337.02,0.43437-1.6418'/%3E %3Cpath d='m412.33,341.37-0.14573,3.2357'/%3E %3Cpath d='m451.39,372.51-1.1587,1.593'/%3E %3Cpath d='m447.82,370.19-0.6758-1.8343'/%3E %3C/g%3E %3Cg stroke-width='0.1639'%3E %3Cpath fill='%23406325' d='m486.11,384.93c-0.79663-1.2555-2.1076-2.0278-3.2774-2.6556-7.7262-4.0566-15.406-5.8439-24.116-7.244-2.0126-0.33757-4.0264-2.2216-6.0868-3.187-4.9633-2.3654-10.489-3.2842-15.311-5.6975-0.32796-0.14595-1.5452-0.86939-2.1076-1.5448-1.9193-2.2221-5.3848-2.899-7.5387-4.9747-8.3347-7.8713-17.184-15.116-21.772-25.547-5.5729-12.7-12.504-25.786-11.567-40.226,0.60851-9.1267-0.75031-18.35,1.4976-27.043,3.325-12.894,7.5864-25.641,15.406-36.314l-1.3112,0.82044c-7.8669,10.674-12.127,23.422-15.452,36.315-2.2479,8.6922-0.89037,17.916-1.4989,27.043-0.93647,14.439,5.9951,27.526,11.567,40.274,4.5882,10.383,13.485,17.626,21.774,25.547,2.1539,2.027,5.6195,2.7034,7.5387,4.9729,0.56218,0.62774,1.8255,1.4014,2.1067,1.5452,4.8237,2.4146,10.349,3.332,15.313,5.6505,2.0602,1.0136,4.0736,2.8481,6.087,3.1878,8.7098,1.3992,16.388,3.2348,24.115,7.2422,1.217,0.6273,2.4819,1.401,3.2783,2.6565l1.3575-0.82154'/%3E %3Cg fill='%2367923d'%3E %3Cpath d='m406.34,331.62c-2.7941-6.3005-1.3649-21.608-0.19817-23.53,6.6331,13.006,4.4252,23.741,0.19817,23.53z'/%3E %3Cpath d='m452.2,377.01c-7.0923,0.36358-20.61,9.2946-21.864,11.396,15.085,0.11624,24.02-7.3152,21.864-11.396z'/%3E %3Cpath d='m459.66,372.72c-6.8452-5.4495-14.189-23.661-14.032-26.501,15.11,10.834,18.936,24.281,14.032,26.501z'/%3E %3Cpath d='m454.61,372.78c-6.9503-4.2351-15.786-20.115-15.938-22.754,15.202,8.1944,20.198,20.129,15.938,22.754z'/%3E %3Cpath d='m439.05,366c0.9841-7.8223-5.6658-24.241-7.5855-25.979-2.9503,16.467,2.9971,27.573,7.5855,25.979z'/%3E %3Cpath d='m411.74,341.72c-2.3045-5.6455-0.61288-19.321,0.46998-20.998,5.5198,11.696,3.2645,21.218-0.46998,20.998z'/%3E %3Cpath d='m398.03,264.89c3.5892-6.6479,18.381-15.712,20.99-15.931-6.7705,14.569-18.037,19.829-20.99,15.931z'/%3E %3Cpath d='m398.74,259.33c2.1485-7.2816,14.874-19.265,17.36-20.034-3.7269,15.676-13.678,23.179-17.36,20.034z'/%3E %3Cpath d='m426.55,358.48c-4.9917-6.176-8.0115-23.865-7.2903-26.361,11.271,12.515,12.029,25.234,7.2903,26.361z'/%3E %3Cpath d='m397.9,322.02c-6.9088,1.0885-21.36-4.6362-22.921-6.3372,14.533-3.1503,24.288,2.0722,22.921,6.3372z'/%3E %3Cpath d='m395.68,312.34c0.82307-5.5775,8.6653-15.809,10.361-16.66-1.11,11.958-7.4489,18.6-10.361,16.66z'/%3E %3Cpath d='m447.01,370.88c-8.4752,0.4348-24.63,11.107-26.128,13.618,18.028,0.14334,28.705-8.7407,26.128-13.618z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='m406.41,331.47c4.2268,0.20997,6.4054-10.396-0.26853-23.379,1.2109,12.319,1.2078,22.309,0.26853,23.379z'/%3E %3Cpath d='m417.59,351.46c-4.4741-5.4704-19.381-11.328-21.712-11.141,8.8846,12.081,19.88,15.097,21.712,11.141z'/%3E %3Cpath d='m393.17,298.48c-1.1475-8.0434-12.334-22.713-14.743-23.969,1.5168,17.175,10.548,26.697,14.743,23.969z'/%3E %3Cpath d='m401.56,332.77c-4.9928-3.6812-18.971-5.3442-20.94-4.723,10.137,8.3046,20.212,8.4582,20.94,4.723z'/%3E %3Cpath d='m392.2,307.94c-2.8852-5.6898-14.812-13.482-16.892-13.701,5.5172,12.387,14.558,16.939,16.892,13.701z'/%3E %3Cpath d='m394.93,260.4c0.90544-7.573-5.5329-23.446-7.3449-25.158-2.8662,15.925,2.918,26.664,7.3449,25.158z'/%3E %3Cpath d='m399.4,245.48c2.6582-6.4958,0.756-22.429-0.52176-24.417-6.4032,13.509-3.8276,24.648,0.52176,24.417z'/%3E %3Cpath d='m404.42,237.83c3.1363-4.7713,4.1621-17.685,3.4848-19.47-7.2359,9.7147-6.9582,18.944-3.4848,19.47z'/%3E %3Cpath d='m410.37,231.69c4.4018-3.4769,9.2242-15.501,9.0837-17.433-9.7398,6.9542-12.221,15.841-9.0837,17.433z'/%3E %3Cpath d='m394.32,274.89c0.10772,0.86786-0.97776-8.1807-10.054-18.314,0.40902,14.818,6.2503,20.421,10.054,18.314z'/%3E %3Cpath d='m426.88,360.67c-6.1755-4.5593-23.385-6.7285-25.767-5.9267,12.562,10.355,24.878,10.551,25.767,5.9267z'/%3E %3Cpath d='m438.95,365.91c-4.5421,1.593-10.443-9.4167-7.5398-25.883,2.8105,13.955,6.181,25.063,7.5398,25.883z'/%3E %3Cpath d='m452.25,377.06c2.1159,4.0815-6.7004,11.436-21.787,11.315,11.952-4.8908,21.239-9.8613,21.787-11.315z'/%3E %3Cpath d='m459.64,372.59c4.8646-2.2494,1.1006-15.536-14.009-26.369,8.5947,13.214,14.455,24.609,14.009,26.369z'/%3E %3Cpath d='m454.57,372.67c4.2779-2.6663-0.68957-14.444-15.891-22.639,9.404,11.183,16.095,20.967,15.891,22.639z'/%3E %3Cpath d='m411.78,341.68c3.7347,0.22155,5.9566-9.2618,0.47698-20.924,0.71841,10.974,0.41841,19.978-0.47698,20.924z'/%3E %3Cpath d='m398.02,264.94c2.9514,3.8975,14.055-1.3092,20.837-15.923-10.165,9.3385-19.225,16.064-20.837,15.923z'/%3E %3Cpath d='m398.86,259.33c3.6818,3.1446,13.542-4.3017,17.269-19.977-8.0961,11.245-15.644,19.736-17.269,19.977z'/%3E %3Cpath d='m426.58,358.42c4.7402-1.1248,3.9539-13.784-7.2536-26.272,5.0127,13.416,8.0159,24.756,7.2536,26.272z'/%3E %3Cpath d='m397.71,321.96c1.4071-4.2401-8.2971-9.3693-22.803-6.259,12.261,2.1948,22.043,5.0424,22.803,6.259z'/%3E %3Cpath d='m395.77,312.35c2.9031,1.8871,9.1781-4.6592,10.286-16.617-4.674,9.1814-9.1663,16.265-10.286,16.617z'/%3E %3Cpath d='m446.97,371.03c2.5758,4.8764-7.9595,13.667-26.035,13.522,14.283-5.8438,25.38-11.783,26.035-13.522z'/%3E %3Cpath d='m399.36,326.3c-2.6584-6.2616-14.798-15.462-16.982-15.841,4.9458,13.638,14.248,19.146,16.982,15.841z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='m392.42,273.92c4.0745-4.6657,17.469-9.134,19.599-8.8646-8.0424,10.409-17.941,12.515-19.599,8.8646z'/%3E %3Cpath d='m417.49,351.51c-1.8072,3.9185-12.696,0.91615-21.646-11.152,10.885,6.8299,20.244,11.511,21.646,11.152z'/%3E %3Cpath d='m393.1,298.46c-4.1951,2.7268-13.128-6.7377-14.685-23.884,6.6226,13.203,13.037,23.384,14.685,23.884z'/%3E %3Cpath d='m401.52,332.8c-0.76888,3.731-10.688,3.5903-20.864-4.7173,10.729,3.4063,19.739,5.3328,20.864,4.7173z'/%3E %3Cpath d='m392.07,307.85c-2.3335,3.2394-11.289-1.2692-16.807-13.657,8.1922,7.9668,15.492,13.744,16.807,13.657z'/%3E %3Cpath d='m394.83,260.3c-4.4269,1.5557-10.16-9.0789-7.294-25.005,2.6667,13.488,5.9354,24.175,7.294,25.005z'/%3E %3Cpath d='m399.3,245.44c-4.3039,0.22724-6.8712-10.815-0.4678-24.322-0.82219,12.797-0.50691,23.234,0.4678,24.322z'/%3E %3Cpath d='m404.34,237.77c-3.4732-0.52504-3.7166-9.6555,3.5206-19.369-2.7393,9.9762-4.1512,18.366-3.5206,19.369z'/%3E %3Cpath d='m410.32,231.69c-3.1365-1.6426-0.70137-10.431,9.0376-17.337-5.5251,8.6441-9.3179,16.178-9.0376,17.337z'/%3E %3Cpath d='m394.25,274.9c-3.804,2.1063-9.5773-3.5031-9.9867-18.322,5.1018,11.684,8.6028,17.807,9.9867,18.322z'/%3E %3Cpath d='m426.82,360.7c-0.88599,4.6251-13.144,4.4011-25.678-5.895,13.168,4.2742,24.246,6.6944,25.678,5.895z'/%3E %3Cpath d='m418.65,351.22c-4.0227-4.343-7.1579-17.347-6.7467-19.242,9.0116,8.7431,10.215,18.165,6.7467,19.242z'/%3E %3Cpath d='m401.77,326.23c-3.5704-5.7862-3.8759-20.907-2.9193-22.956,8.263,11.809,7.2531,22.585,2.9193,22.956z'/%3E %3Cpath d='m399.14,326.32c-2.7356,3.3047-11.93-2.1585-16.872-15.833,8.1324,9.1108,15.474,15.812,16.872,15.833z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='m392.37,274c1.6173,3.6231,11.45,1.5297,19.493-8.8798-11.97,6.7926-16.711,9.7409-19.493,8.8798z'/%3E %3Cpath d='m401.71,326.07c4.3325-0.37079,5.3311-11.037-2.9328-22.846,2.6634,11.854,3.7909,21.678,2.9328,22.846z'/%3E %3Cpath d='m418.67,351.18c3.4697-1.0706,2.2496-10.451-6.713-19.178,4.4027,9.7272,7.2055,18.011,6.713,19.178z'/%3E %3Cpath d='m394.23,291.77c2.0582-8.3856-1.7025-22.601-4.3-25.559-4.7164,15.427-0.24471,26.599,4.3,25.559z'/%3E %3C/g%3E %3Cpath fill='%2367923d' d='m393.93,293.77c-5.8954,1.3394-8.645-12.034-4.0797-27.078,1.0708,13.546,2.8334,26.147,4.0797,27.078z'/%3E %3Cpath fill='%2367923d' d='m392.73,293.72c-0.55781-7.5274,6.9344-23.087,8.915-24.707,2.0147,15.803-4.4625,26.308-8.915,24.707z'/%3E %3Cpath fill='%23406325' d='m392.84,293.61c4.4134,1.6359,10.851-8.7614,8.8348-24.564-3.5106,13.267-7.4452,23.764-8.8348,24.564z'/%3E %3Cpath fill='%2367923d' d='m394.13,303.26c0.005-7.6093,8.4702-22.23,10.562-23.619,0.83443,16.162-6.3315,25.829-10.562,23.619z'/%3E %3Cpath fill='%23406325' d='m394.21,303.41c4.2309,2.2096,11.306-7.3639,10.471-23.525-4.4092,12.857-9.0481,22.899-10.471,23.525z'/%3E %3C/g%3E %3Cg fill='%23ba1f3e' stroke='%23511124' stroke-width='0.2185'%3E %3Ccircle stroke-width='0.1857' cx='396.835' cy='251.27' r='1.085'/%3E %3Ccircle stroke-width='0.1857' cx='405.205' cy='245.07' r='1.085'/%3E %3Ccircle stroke-width='0.1857' cx='401.564' cy='241.71' r='1.086'/%3E %3Ccircle cx='392.503' cy='313.12' r='1.277'/%3E %3Ccircle cx='395.033' cy='297.13' r='1.277'/%3E %3Ccircle cx='408.213' cy='334.46' r='1.277'/%3E %3Ccircle cx='402.393' cy='336.43' r='1.277'/%3E %3Ccircle cx='446.703' cy='367.63' r='1.277'/%3E %3Ccircle cx='449.613' cy='374.71' r='1.277'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%2324420e'%3E %3Cg fill='none' stroke-width='0.437'%3E %3Cpath d='m561.15,258.97c0.62271,0.6214,1.174,0.80799,2.2946,1.8946'/%3E %3Cpath d='m556.82,241.92c-0.035-1.3682-0.63254-3.605-0.91833-4.9729'/%3E %3Cpath d='m559.35,239.93c0.0551,1.952-0.21849,3.8094-1.0617,5.5041'/%3E %3Cpath d='m554.13,244.9c1.7526,1.5758,3.5053,3.0766,5.2576,3.8918'/%3E %3Cpath d='m563.21,250.02c0.10488,1.9802-0.14202,3.9602-0.6828,5.9404'/%3E %3Cpath d='m562.85,257.47,1.314-2.2623'/%3E %3Cpath d='m562.3,267.43c1.3997,0.29126,2.8096,1.9457,3.5053,3.4822'/%3E %3Cpath d='m566.28,269.62,1.6387-2.185'/%3E %3Cpath d='m569.63,298.16c-0.74769,1.304-1.5815,2.4353-2.4576,3.4826'/%3E %3Cpath d='m563.21,301.57c0.78942,1.456,1.5563,2.9458,2.5946,4.0288'/%3E %3Cpath d='m568.26,311.47c-1.307,1.7726-2.7661,3.1651-4.4383,4.0286'/%3E %3Cpath d='m563.96,320c-1.0925,0.7514-2.4264,2.9527-3.6871,4.7116'/%3E %3Cpath d='m568.71,304.53-2.1244,0.86896'/%3E %3Cpath d='m565.19,297.91,1.2555,1.1108'/%3E %3Cpath d='m557.15,336.41c-0.83945-0.10793-1.456,0.009-2.1244,0.0725'/%3E %3Cpath d='m553.03,334.55,0.61462,1.6387'/%3E %3Cpath d='m545.93,341.31c-0.26197,1.8662-0.0725,3.7328,0.20408,5.5989'/%3E %3Cpath d='m550.44,337.89,1.0243,2.2536'/%3E %3Cpath d='m555.29,339.94-2.5265,0.40968'/%3E %3Cpath d='m521.91,365.62-0.91702,1.7377'/%3E %3Cpath d='m532.89,363.43c-1.4923,0.18681-2.7782-0.0435-4.0968-0.20408'/%3E %3Cpath d='m523.33,369.17c-1.0835-0.42344-2.0335-0.7136-2.9361-0.95591'/%3E %3Cpath d='m505.65,370.87c-0.90588,0.77282-1.9892,2.4353-3.0727,4.0968'/%3E %3Cpath d='m502.03,370.4c-2.4334,1.2528-3.1815,3.71-4.4383,5.8041'/%3E %3Cpath d='m500.39,379.07c-1.5528-0.46081-3.4118-1.2277-5.3258-2.0484'/%3E %3Cpath d='m511.83,376.34c-2.3211-1.2052-4.7479-1.087-7.1352-1.4685'/%3E %3Cpath d='m515.45,374.53c-3.6279-0.70749-7.01-0.60982-10.276-0.137'/%3E %3Cpath d='m512.95,371.79-1.399-0.58032'/%3E %3Cpath d='m506.02,376.71-2.3226-1.2957'/%3E %3Cpath d='m561.64,326.22c-1.2555,0.81629-2.5105,2.2826-3.766,3.8626'/%3E %3Cpath d='m559.7,250.46-2.153-0.72431'/%3E %3C/g%3E %3Cg stroke-width='0.1639'%3E %3Cpath fill='%23406325' d='m474.39,384.85c0.79664-1.2555,2.1076-2.0278,3.2774-2.6556,7.7258-4.0566,15.406-5.8439,24.117-7.244,2.0126-0.33758,4.0264-2.2217,6.0866-3.187,4.9629-2.3654,10.489-3.2842,15.311-5.6975,0.32818-0.14596,1.5452-0.86939,2.1076-1.5448,1.9195-2.2221,5.385-2.899,7.5389-4.9747,8.3345-7.8713,17.184-15.116,21.772-25.546,5.5729-12.7,12.503-25.787,11.567-40.225-0.60851-9.1267,0.75031-18.35-1.4978-27.043-3.3255-12.893-7.5883-25.643-15.408-36.314l1.3114,0.82045c7.8667,10.674,12.127,23.423,15.452,36.314,2.2477,8.6922,0.89015,17.916,1.4987,27.043,0.93668,14.439-5.9951,27.526-11.566,40.275-4.5884,10.383-13.486,17.626-21.774,25.546-2.1541,2.027-5.6195,2.7034-7.5389,4.9729-0.56197,0.62774-1.8255,1.4014-2.1065,1.5452-4.8239,2.4146-10.349,3.332-15.313,5.6505-2.06,1.0136-4.0738,2.8481-6.087,3.1878-8.7094,1.3992-16.388,3.2348-24.113,7.2422-1.2174,0.6273-2.4823,1.401-3.2787,2.6565l-1.3579-0.82154'/%3E %3Cg fill='%23406325'%3E %3Cpath d='m553.65,334.6c2.741-7.4159-0.009-24.838-1.4893-26.951-6.6486,15.372-3.3412,27.502,1.4893,26.951z'/%3E %3Cpath d='m546.54,341.64c2.3045-5.6455,0.61287-19.321-0.46977-20.998-5.52,11.696-3.265,21.218,0.46977,20.998z'/%3E %3Cpath d='m563.35,267.49c-3.2932-6.1004-16.867-14.418-19.261-14.618,6.2129,13.368,16.552,18.195,19.261,14.618z'/%3E %3Cpath d='m561.76,259.47c-1.7906-6.0678-12.395-16.053-14.466-16.694,3.105,13.063,11.398,19.315,14.466,16.694z'/%3E %3Cpath d='m566.5,274.43c-3.537-4.0507-15.164-7.9285-17.013-7.6952,6.9807,9.0363,15.572,10.864,17.013,7.6952z'/%3E %3Cpath d='m563.7,320.76c6.1323,0.96619,18.959-4.1151,20.345-5.6254-12.9-2.7965-21.559,1.8395-20.345,5.6254z'/%3E %3Cpath d='m563.55,315.12c-0.0435-5.6378-6.3949-16.856-7.9563-17.933-0.5552,11.996,4.8038,19.453,7.9563,17.933z'/%3E %3Cpath d='m563.96,301.44c-0.005-7.6093-8.4697-22.23-10.562-23.619-0.83421,16.161,6.3318,25.828,10.562,23.619z'/%3E %3Cpath d='m511.07,376.71c4.4772,5.5034,19.653,11.133,22.088,10.904-8.8047-12.233-20.07-15.05-22.088-10.904z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='m553.56,334.43c-4.8235,0.55082-8.0898-11.437-1.3946-26.785-0.49074,14.192,0.2386,25.629,1.3946,26.785z'/%3E %3Cpath d='m500.19,378.09c7.0926,0.36314,20.61,9.2946,21.865,11.396-15.086,0.11689-24.021-7.3146-21.865-11.396z'/%3E %3Cpath d='m500.19,370.15c2.0984-7.9674,15.006-21.21,17.514-22.151-3.6025,17.134-13.74,25.535-17.514,22.151z'/%3E %3Cpath d='m521.46,365.92c-0.98454-7.8223,5.6651-24.24,7.585-25.979,2.9506,16.466-2.9967,27.574-7.585,25.979z'/%3E %3Cpath d='m542.92,351.38c4.4741-5.4704,19.381-11.328,21.712-11.141-8.8849,12.081-19.88,15.097-21.712,11.141z'/%3E %3Cpath d='m568.71,298.12c0.9026-6.3318,9.7097-17.881,11.606-18.87-1.1936,13.521-8.3041,21.018-11.606,18.87z'/%3E %3Cpath d='m557.02,336.18c5.817-4.2901,22.105-6.228,24.399-5.5037-11.813,9.676-23.552,9.8548-24.399,5.5037z'/%3E %3Cpath d='m567.29,311.66c3.0329-5.9791,15.566-14.169,17.754-14.399-5.7991,13.019-15.301,17.802-17.754,14.399z'/%3E %3Cpath d='m565.81,266.1c-0.0983-7.6255,7.9838-22.728,9.9655-24.24,1.1659,16.139-5.7222,26.206-9.9649,24.24z'/%3E %3Cpath d='m558.88,240.18c-2.3224-5.2808-1.101-18.414-0.0931-20.074,5.5504,10.963,3.6722,20.17,0.0931,20.074z'/%3E %3Cpath d='m554.65,238c-5.2745-4.6832-10.645-19.756-10.411-22.103,11.751,9.2631,14.386,20.361,10.411,22.103z'/%3E %3Cpath d='m566.28,272.54c-0.31659,0.81521,2.9447-7.6949,14.219-15.308-4.0118,14.271-11.044,18.279-14.219,15.308z'/%3E %3Cpath d='m532.18,362.44c7.0056-5.1726,26.532-7.634,29.232-6.7237-14.253,11.748-28.225,11.97-29.232,6.7237z'/%3E %3Cpath d='m546.51,341.6c-3.7345,0.22156-5.9566-9.2618-0.47675-20.924-0.71885,10.974-0.41842,19.978,0.47675,20.924z'/%3E %3Cpath d='m563.36,267.53c-2.7082,3.5763-12.897-1.2015-19.121-14.611,9.3275,8.5696,17.642,14.742,19.121,14.611z'/%3E %3Cpath d='m561.66,259.47c-3.0683,2.6202-11.285-3.5835-14.391-16.646,6.746,9.3701,13.036,16.446,14.391,16.646z'/%3E %3Cpath d='m566.55,274.5c-1.4045,3.145-9.9393,1.328-16.92-7.7078,10.389,5.8959,14.505,8.4546,16.92,7.7078z'/%3E %3Cpath d='m563.86,320.71c-1.2491-3.764,7.3648-8.3166,20.241-5.5559-10.884,1.9485-19.567,4.4765-20.241,5.5559z'/%3E %3Cpath d='m563.46,315.11c-3.1365,1.4672-8.4452-5.8845-7.8885-17.881,3.3598,9.74,6.8284,17.376,7.8885,17.881z'/%3E %3Cpath d='m563.88,301.59c-4.2307,2.2092-11.305-7.3641-10.471-23.525,4.4092,12.857,9.0479,22.898,10.471,23.525z'/%3E %3Cpath d='m511.19,376.66c2.0178-4.1459,13.15-1.3776,21.976,10.888-10.995-6.7493-20.482-11.305-21.976-10.888z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='m521.55,365.83c4.5423,1.593,10.443-9.4167,7.5402-25.883-2.8103,13.955-6.1816,25.064-7.5402,25.883z'/%3E %3Cpath d='m531.83,360.59c4.3386-6.6505,5.5498-24.554,4.579-26.967-9.9432,13.594-9.4086,26.324-4.579,26.967z'/%3E %3Cpath d='m500.14,378.13c-2.1163,4.081,6.7004,11.436,21.787,11.315-11.951-4.8897-21.238-9.8604-21.787-11.315z'/%3E %3Cpath d='m500.3,370.08c3.7852,3.3384,13.808-4.948,17.409-22.083-8.1269,12.423-15.723,21.799-17.409,22.083z'/%3E %3Cpath d='m543.01,351.43c1.8072,3.9185,12.696,0.91615,21.646-11.152-10.885,6.8301-20.244,11.512-21.646,11.152z'/%3E %3Cpath d='m568.76,298.1c3.3025,2.1469,10.335-5.3035,11.561-18.803-5.2139,10.395-10.263,18.409-11.561,18.803z'/%3E %3Cpath d='m557.07,336.21c0.89539,4.3476,12.454,4.1833,24.312-5.496-12.502,3.9692-23.001,6.214-24.312,5.496z'/%3E %3Cpath d='m567.43,311.57c2.4526,3.405,11.865-1.3337,17.664-14.352-8.6094,8.3729-16.281,14.445-17.664,14.352z'/%3E %3Cpath d='m565.92,266.01c4.2377,2.0156,11.064-7.9523,9.8985-24.093-4.0786,13.13-8.4597,23.412-9.8985,24.093z'/%3E %3Cpath d='m558.96,240.14c3.5416,0.0933,5.4145-9.0334-0.13393-19.995,0.94936,10.498,0.91309,19.08,0.13393,19.995z'/%3E %3Cpath d='m554.73,237.9c3.9722-1.7421,1.3306-12.711-10.422-21.972,6.4718,11.02,10.853,20.573,10.422,21.972z'/%3E %3Cpath d='m566.34,272.57c3.175,2.9709,10.143-1.0606,14.155-15.33-7.7985,10.084-12.688,15.169-14.155,15.33z'/%3E %3Cpath d='m532.25,362.48c1.0051,5.2474,14.913,4.9935,29.132-6.6879-14.94,4.849-27.508,7.5951-29.132,6.6879z'/%3E %3Cpath d='m539.14,354.75c3.272-4.9336,4.2744-18.274,3.5639-20.077-7.4878,10.079-7.1605,19.572-3.5639,20.077z'/%3E %3Cpath d='m558.74,326.14c3.5702-5.7857,3.8761-20.908,2.9191-22.957-8.2635,11.81-7.254,22.586-2.9191,22.957z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='m531.79,360.54c-4.8298-0.638-5.3313-13.312,4.5517-26.873-3.6261,13.856-5.4632,25.442-4.5517,26.873z'/%3E %3Cpath d='m566.95,292.21c-0.94346-7.7646,3.976-20.143,6.6318-22.522,2.5732,14.385-2.6602,23.949-6.6318,22.522z'/%3E %3Cpath d='m539.11,354.7c-3.5966-0.49883-3.9012-9.9535,3.5407-20.007-2.7803,10.308-4.2141,18.935-3.5407,20.007z'/%3E %3Cpath d='m562.47,250.46c-2.167-5.8812,0.0291-20.041,1.2358-21.774,5.2887,12.257,2.6381,22.116-1.2358,21.774z'/%3E %3Cpath d='m504.39,370.61c2.4738-8.0911,16.191-21.081,18.807-21.915-4.3352,17.421-15.065,25.529-18.807,21.915z'/%3E %3Cpath d='m558.92,329.02c2.6582-6.2616,14.798-15.462,16.981-15.841-4.9452,13.638-14.248,19.146-16.981,15.841z'/%3E %3Cpath d='m558.8,325.99c-4.3328-0.37078-5.3313-11.037,2.9326-22.846-2.6637,11.854-3.7907,21.678-2.9326,22.846z'/%3E %3C/g%3E %3Cpath fill='%23406325' d='m567,294.04c5.158,1.8423,9.0778-9.8897,6.5983-23.914-2.4286,12.067-5.3769,23.211-6.5983,23.914z'/%3E %3Cpath fill='%23406325' d='m567.77,293.64c0.55738-7.5274-6.9346-23.086-8.9152-24.707-2.0147,15.803,4.463,26.309,8.9152,24.707z'/%3E %3Cpath fill='%23406325' d='m562.55,250.42c3.8344,0.33692,6.4733-9.4346,1.1869-21.69,0.33015,11.446-0.28251,20.75-1.1869,21.69z'/%3E %3Cpath fill='%23406325' d='m504.5,370.53c3.7874,3.6209,14.369-4.4169,18.704-21.838-8.839,12.353-16.968,21.612-18.704,21.838z'/%3E %3Cpath fill='%23406325' d='m559.14,329.04c2.7351,3.3047,11.93-2.1581,16.872-15.833-8.133,9.111-15.474,15.812-16.872,15.833z'/%3E %3Cpath fill='%2367923d' d='m567.66,293.53c-4.4134,1.6359-10.851-8.761-8.8346-24.563,3.5099,13.267,7.445,23.763,8.8346,24.563z'/%3E %3C/g%3E %3Cg fill='%23ba1f3e' stroke='%23511124' stroke-width='0.2185'%3E %3Ccircle cx='564.625' cy='254.9' r='1.085'/%3E %3Ccircle cx='568.415' cy='266.82' r='1.085'/%3E %3Ccircle cx='569.757' cy='304.3' r='1.277'/%3E %3Ccircle cx='564.647' cy='297.29' r='1.277'/%3E %3Ccircle cx='549.907' cy='337.17' r='1.277'/%3E %3Ccircle cx='556.197' cy='339.9' r='1.277'/%3E %3Ccircle cx='513.797' cy='372.26' r='1.277'/%3E %3Ccircle cx='506.797' cy='377.29' r='1.277'/%3E %3Ccircle cx='557.054' cy='249.25' r='1.084'/%3E %3C/g%3E %3C/g%3E %3Cg id='gun' fill='%238c959d' stroke='%23485654' stroke-width='0.1092'%3E %3Cpath d='m434.25,336.27c-0.13416,1.066,0.84186,2.339,2.1284,2.0698,0.38608-0.0784,0.62359-0.58076,0.1311-0.48987-0.42497,0.10794-0.87857-0.0699-1.2017-0.37384-0.59693-0.56372-0.65527-1.3516-0.39613-1.9186-0.23073,0.24755-0.44966,0.48352-0.66051,0.71141l-0.001,0.001z'/%3E %3Cpath stroke='none' d='m437.24,338.34c-1.0156,1.165-2.568,1.6758-3.4266,0.83421-0.57311-0.56503-0.77784-1.2056-0.46845-1.9118-0.44289,0.48134-0.82241,0.89692-1.1211,1.2308,0.0468,0.0896,0.71492,1.3088,1.708,1.7582,1.2231,0.5506,2.9724-0.27946,4.0179-1.5644,0.73873-0.90894,1.5612-2.4277,0.96706-3.6087-0.36467-0.7289-1.2384-1.4246-1.9673-1.6997-0.35047,0.37515-0.69482,0.74769-1.0261,1.101,0.50888-0.23947,1.1475-0.13437,1.6949,0.31289,1.2732,1.0348,0.5364,2.4987-0.378,3.546l-0.00022,0.002z'/%3E %3Cpath fill='%23485654' stroke='none' d='m437.24,338.34c-0.32446,0.38324-0.71469,0.71775-1.162,0.95591-0.4442,0.2351-0.95679,0.39045-1.4726,0.31835-0.25521-0.0358-0.50669-0.13394-0.71186-0.2965-0.20386-0.16562-0.37035-0.35942-0.50953-0.57945-0.13656-0.2198-0.23007-0.47369-0.24734-0.73742-0.019-0.26328,0.0387-0.52875,0.14115-0.76779l0.12236,0.0798-1.1097,1.2389,0.0129-0.099c0.27574,0.47916,0.62314,0.93756,1.0418,1.2998,0.21041,0.17917,0.44158,0.33539,0.69394,0.43656,0.2493,0.10072,0.52351,0.14093,0.79663,0.1335,0.54886-0.0157,1.0879-0.20604,1.5729-0.47632,0.48681-0.27137,0.92576-0.62905,1.2981-1.0424,0.37144-0.41645,0.68979-0.88687,0.93516-1.3883,0.23968-0.50014,0.41011-1.0486,0.37384-1.5948-0.0188-0.2718-0.09-0.53465-0.22418-0.77456-0.13087-0.23685-0.30567-0.45753-0.49991-0.65505-0.39154-0.39307-0.85912-0.72584-1.3711-0.93319l0.0929-0.0218-1.0359,1.0925-0.0843-0.11602c0.23576-0.10707,0.4997-0.14509,0.75359-0.11734,0.25433,0.0291,0.49795,0.11646,0.7147,0.24494,0.42781,0.25695,0.79838,0.64914,0.92554,1.1445,0.12913,0.49424,0.002,1.0079-0.20823,1.448-0.21237,0.44594-0.51062,0.84207-0.8377,1.2052l-0.001,0.002zm0.00022-0.002c0.3142-0.37516,0.59496-0.7809,0.79336-1.2251,0.1962-0.44005,0.30196-0.94237,0.16714-1.404-0.13175-0.45993-0.49314-0.82613-0.90019-1.0625-0.40793-0.23816-0.92445-0.30545-1.3455-0.10072l-0.0843-0.11646,1.0171-1.1091,0.0389-0.0417,0.0542,0.021c0.54929,0.2091,1.033,0.5493,1.4456,0.95985,0.20495,0.20735,0.38958,0.43524,0.53597,0.69678,0.14639,0.25695,0.23095,0.55651,0.25148,0.85169,0.042,0.5978-0.13852,1.177-0.38433,1.6988-0.2528,0.52351-0.57748,1.007-0.96116,1.4429-0.38979,0.43196-0.84907,0.79925-1.3588,1.0804-0.50888,0.27858-1.0759,0.47829-1.6704,0.49293-0.29584,0.006-0.59627-0.0389-0.87572-0.15273-0.27683-0.11362-0.52308-0.28251-0.74354-0.47326-0.44027-0.38783-0.79292-0.85104-1.0735-1.363l-0.0293-0.0537,0.0415-0.0457,1.1322-1.2218,0.12258,0.0797c-0.099,0.22068-0.15448,0.45993-0.14115,0.69984,0.012,0.23947,0.0924,0.4737,0.21675,0.68192,0.12476,0.20692,0.28841,0.40247,0.47282,0.55695,0.18659,0.15447,0.41623,0.25258,0.65723,0.29365,0.48681,0.0824,0.99197-0.0524,1.4357-0.27312,0.44638-0.22461,0.84645-0.54077,1.1851-0.91177z'/%3E %3Cpath fill='%236c301e' stroke='%23351710' stroke-width='0.2185' stroke-linejoin='round' d='m515.24,249.25-40.137,39.515c-3.0526,3.0316-37.963,36.379-41.105,39.384-1.1025,1.323-4.2327,4.8584-4.5611,5.3531-2.129,2.3104-4.4389,5.3297-7.1968,8.0297-0.49118,0.61878-1.1421,0.39394-1.7344,0.73742-1.8133,1.0503-3.6965,2.8695-5.0527,4.3699l-12.208,13.506c-0.78636,0.85344-0.99568,1.38-0.4643,1.871l6.6232,8.849c1.2288,1.2142,2.6444,1.838,3.1955,0.81936,3.1463-5.4466,10.962-13.759,13.915-20.334,1.7641-3.929,3.9779-11.058,5.5581-12.782,1.9383-2.1572,7.1697-7.7301,11.806-12.705,0.31332-0.33539,0.62314-0.66881,0.92882-0.99721,0.32119-0.34434,0.63691-0.68454,0.94761-1.019,23.506-23.951,50.715-53.046,70.526-73.558-0.77784-0.775-0.28622-0.31158-1.0416-1.04z'/%3E %3Cpath d='m431.89,328.11c-1.2251,0.043-2.0215-0.70705-2.8481-1.4001,1.1687,0.34609,2.3449,0.79707,3.452,0.33845l-0.60392,1.0617z'/%3E %3Cpath fill='%23b2b6ba' stroke-width='0.2185' d='m557.05,220.1-31.804,26.219c-0.30589,0.37407-0.62358,0.26657-0.9286,0l-2.895-2.4172c0.004-0.0363,0.0138-0.0723,0.0138-0.10925,0-0.16256-0.0317-0.31878-0.0819-0.4643l1.4202-1.4475c0.17633-0.22068,0.11952-0.3096-0.12301-0.54623-0.1831-0.19053-0.34391-0.36489-0.58753-0.60086-0.22789-0.17567-0.41558-0.0354-0.64194,0.17763l-1.434,1.4748c-0.73392,0.0297-1.3311,0.63014-1.352,1.3656-19.238,18.731-35.794,35.435-54.938,53.872l-22.573,21.549c-0.80581,1.0429-4.2901,2.9075-6.5959,4.411-0.81673,0.53269-1.5233,1.0164-1.8163,1.5432l-1.8437,5.4351c-0.58207,1.1941-2.4308,4.0028-2.5127,4.1927,2.3683,2.3864,2.2479,2.2127,3.8647,3.7282,1.8179-2.0233,6.6894-7.1118,11.116-11.853,0.3568-0.38236,0.37887-0.42169,0.83312-0.96968-0.34653-0.48855-0.92751-1.2048-1.3929-1.6527-0.39613-0.37843-0.82547-0.76735-1.2013-1.0925-0.24493-0.21216-0.46758-0.39133-0.62817-0.54624-0.163-0.15622,0.24034-0.44376,0.42344-0.64194,26.464-25.579,54.962-53.695,78.276-76.595,0.12454,0.0367,0.25957,0.0546,0.39613,0.0546,0.22702,0,0.44005-0.0553,0.62817-0.15032l2.7858,3.2092c0.65417,0.6522,1.2081,0.63953,1.7346,0.39613l31.859-28.542z'/%3E %3Cpath fill='%23485654' stroke='none' d='m430.95,330.39c0.20145,0.0286,0.40509,0.0478,0.60633,0.0312,0.20079-0.0166,0.397-0.0699,0.57354-0.16256l-0.0164,0.0197c0.22832-0.79641,0.47151-1.5876,0.71404-2.3792,0.24733-0.78986,0.49795-1.5791,0.75948-2.365l0.006,0.0269c-0.19489-0.22308-0.43589-0.42126-0.73108-0.4962,0.29956,0.0573,0.55913,0.24406,0.77063,0.45971l0.0111,0.0112-0.005,0.0153c-0.22789,0.79663-0.4667,1.5887-0.70857,2.3807-0.24712,0.79029-0.49293,1.5802-0.75447,2.3663l-0.005,0.0138-0.012,0.006c-0.18725,0.0922-0.39548,0.13831-0.60086,0.14093-0.20626,0.003-0.40946-0.0284-0.60873-0.0686z'/%3E %3Ccircle fill='none' stroke-width='0.1639' cx='438.17876' cy='328.1347' r='0.61921'/%3E %3Ccircle fill='none' stroke-width='0.1639' cx='434.43594' cy='331.87751' r='0.61921'/%3E %3Cpath fill='%23485654' stroke='none' d='m440.97,322.38c-0.319-0.24078-0.61528-0.50538-0.90631-0.77544-0.28842-0.27268-0.57137-0.55126-0.83181-0.85387,0.319,0.24034,0.61484,0.50494,0.90588,0.775,0.28863,0.27312,0.57136,0.55148,0.83224,0.85431z'/%3E %3Cpath d='m502.17,259.06,3.487,3.4098,0.64521-0.58578-3.487-3.4094-0.64522,0.58534z'/%3E %3C/g%3E %3Cuse xlink:href='%23gun' transform='matrix(-0.99877061,-0.04957067,-0.04957067,0.99877061,973.59129,23.686411)'/%3E %3Cg stroke='%2324420e' stroke-width='0.1639'%3E %3Cpath fill='%2367923d' d='m433.91,365.36c-7.8658-3.3213-26.89-0.67034-29.219,0.9321,16.285,8.0113,29.54,4.5738,29.219-0.9321z'/%3E %3Cpath fill='%2367923d' d='m522.93,368.68c7.8658-3.3209,26.89-0.6699,29.219,0.93254-16.285,7.9823-29.54,4.5733-29.219-0.93254z'/%3E %3Cpath fill='%23406325' d='m433.76,365.48c0.32054,5.5058-12.789,8.8853-29.075,0.90304,15.295,0.93209,27.793,0.37843,29.075-0.90304z'/%3E %3Cpath fill='%23406325' d='m523.08,368.77c-0.32053,5.5058,12.789,8.8853,29.075,0.90304-15.295,0.93253-27.793,0.40793-29.075-0.90304z'/%3E %3C/g%3E %3Cg id='sword'%3E %3Cpath fill='%23b2b6ba' stroke='%23485654' stroke-width='0.2185' d='m508.49,359.99c-20.733-30.119-51.995-54.611-76.102-67.991,3.5569-0.16649,11.46,3.8809,14.67,5.9485,23.94,15.427,44.3,35.803,65.664,59.822-1.2579,1.2456-2.0818,1.9802-3.4461,3.0517l-0.7857-0.83006z'/%3E %3Cpath fill='%238c959d' d='m510.55,359.75-1.4506,1.3938c-23.01-29.619-55.093-57.945-76.668-69.13,30.08,13.855,55.391,41.77,78.033,67.65l0.085,0.0856z'/%3E %3Cpath fill='%23485654' d='m510.56,359.75-1.4475,1.3968-0.004,0.003-0.003-0.004c-5.3258-6.8234-10.975-13.389-16.864-19.73-5.8849-6.3453-12.012-12.466-18.368-18.337-6.3591-5.8677-12.943-11.495-19.81-16.76-3.4345-2.6296-6.9411-5.1665-10.542-7.5628-3.601-2.3932-7.2966-4.6522-11.133-6.6442l0.0957-0.19577c7.8922,3.6436,15.339,8.1949,22.375,13.281,7.0388,5.0907,13.677,10.715,20.029,16.631,6.3521,5.9199,12.422,12.135,18.328,18.497,5.902,6.3667,11.629,12.892,17.343,19.425zc-5.7401-6.5109-11.494-13.012-17.42-19.353-5.9164-6.3497-11.991-12.556-18.349-18.463-6.3573-5.9039-12.999-11.515-20.037-16.591-7.0358-5.0702-14.478-9.6039-22.36-13.229l0.0957-0.19555c3.8448,1.9999,7.5413,4.2696,11.144,6.6702,3.6014,2.4041,7.1078,4.948,10.542,7.585,6.8644,5.278,13.444,10.918,19.798,16.798,6.3512,5.8832,12.472,12.013,18.35,18.369,5.8675,6.3641,11.489,12.957,16.789,19.8l-0.006-0.00044,1.4536-1.3901z'/%3E %3Cg fill='%23fab81c' stroke='%236c301e' stroke-width='0.1092'%3E %3Cpath stroke-width='0.2185' d='m517.5,355.07c-1.9737,0.51128-3.7256,1.2533-5.2585,2.2256-0.22701,1.3973-1.9525,2.9578-3.5864,3.3115-0.29737-0.37799-0.36707-0.48855-0.5919-0.77106-0.0376-0.0496-0.10204-0.073-0.1689-0.038-0.14202,0.0756-0.33211,0.18047-0.57355,0.33932-0.60938-0.10204-1.3365,0.19796-1.6597,0.97602-0.37843,0.96924,0.38542,2.2481,1.2244,3.084,0.92402,0.72933,1.3866,1.0691,2.4572,0.91964,1.0835-0.22396,1.6813-1.2129,1.9258-1.5277,3.7196,4.503,6.517,6.9326,11.229,10.64,2.0984,0.017,3.225-1.3059,2.5203-2.8028-0.23248-0.50188-0.84121-0.83509-1.3324-0.65155,0.0406-0.15142,0.0238-0.30546,0-0.45098,2.4624-2.2643,3.5134-5.0881,0.91461-9.8733-2.2238-4.0293-4.712-5.397-7.0875-5.3804l-0.0129-0.00066zm6.2459,4.5307c0.4383,0.74091,0.69176,1.3796,1.0245,2.053,1.4829,2.9993,0.19556,6.6027-2.334,7.7065-0.12301-0.005-0.085-0.0214-0.21303,0.0218,0.41274-0.68739-0.82744-2.1537-1.4613-1.6387,0.29955-0.75883-0.66925-2.0189-1.4615-1.6938,0.4147-0.70574-0.53291-1.9059-1.4202-1.5159,0.4584-0.76648-0.32381-1.8653-1.2424-1.666,0.27662-0.81717-0.4182-1.753-1.3523-1.5978,0.0789-0.723-0.1571-1.1202-0.50691-1.4493,1.1126-0.84666,2.3475-2.1509,3.4378-2.738,2.7218-1.1788,4.4031,1.0724,5.5272,2.5173h0.001v0.00044h0.00065z'/%3E %3Cpath d='m524.89,362.77c-0.51543-0.25345-0.75577-0.76036-0.58687-1.1049,0.16846-0.34217,0.70158-0.43241,1.217-0.17764,0.51587,0.25345,0.80144,0.74376,0.63276,1.0879-0.17195,0.34304-0.74725,0.44989-1.2636,0.19556l0.00065-0.00088z'/%3E %3Cpath d='m524.59,361.75c-0.51543-0.25345-0.75577-0.76014-0.58688-1.1045,0.16846-0.3426,0.70159-0.43262,1.2175-0.17785,0.51542,0.25345,0.80143,0.74419,0.63254,1.0881-0.17196,0.34304-0.74725,0.44945-1.2636,0.19512l0.00044-0.00088z'/%3E %3Cpath d='m523.97,360.62c-0.51543-0.25346-0.75621-0.76037-0.58732-1.1049,0.16846-0.34216,0.70159-0.43262,1.2174-0.17764,0.51587,0.25346,0.80188,0.74376,0.63255,1.0879-0.17196,0.34303-0.74726,0.44988-1.2636,0.19555l0.00088-0.00087z'/%3E %3Cpath d='m523.19,359.6c-0.51586-0.25346-0.75577-0.76037-0.58731-1.1049,0.1689-0.34216,0.70159-0.4324,1.2174-0.17764,0.51587,0.25302,0.80144,0.74376,0.63254,1.0879-0.17151,0.3426-0.74725,0.44944-1.2631,0.19555l0.00043-0.00087z'/%3E %3Cpath d='m522.16,358.61c-0.51543-0.25346-0.75577-0.76015-0.58688-1.1049,0.0229-0.0465,0.007-0.13656,0.0551-0.11384,0.20998,0.10794,0.64391,0.18682,0.59628-0.13699-0.0645-0.11362-0.14596-0.22702-0.0695-0.14203,0.14858,0.004,0.4643,0.1335,0.63626,0.22156,0.51543,0.25345,0.80144,0.74375,0.63254,1.0879-0.17195,0.34304-0.74725,0.44988-1.2636,0.19556v-0.007z'/%3E %3C/g%3E %3Cg fill='%23fab81c'%3E %3Cpath d='m511.27,363.6c0.68192-1.7735,2.0468-3.414,3.5077-3.8057'/%3E %3Cpath d='m511.5,363.85c1.2629,0.26241,3.3089-1.243,3.806-2.5878'/%3E %3Cpath d='m512.69,365.3c1.6558,0.38149,3.2912-1.2175,3.9338-2.4085'/%3E %3Cpath d='m514.18,366.88c1.9566,0.064,3.1636-1.3263,3.7387-2.3901'/%3E %3Cpath d='m515.69,368.41c1.661,0.0111,3.1717-1.3597,3.6458-2.424'/%3E %3Cpath d='m517.15,369.81c1.808-0.073,3.084-0.89539,3.6196-2.0748'/%3E %3Cpath d='m518.79,371.23c1.661,0.0959,3.0026-0.89583,3.443-1.8622'/%3E %3Cpath d='m520.57,372.68c1.6614,0.0959,2.6954-0.92991,3.1363-1.8965'/%3E %3C/g%3E %3Cg fill='%236c301e'%3E %3Cpath d='m511.27,363.6c0.13961-0.42344,0.32555-0.83312,0.54405-1.224,0.21893-0.39089,0.47763-0.76014,0.76451-1.1054,0.29453-0.33845,0.6179-0.65505,0.98585-0.91506,0.36663-0.25913,0.77587-0.46649,1.2133-0.56197-0.42366,0.13962-0.81302,0.36183-1.1633,0.62992-0.35046,0.26875-0.66925,0.57858-0.95198,0.9179-0.57748,0.67274-1.0284,1.4456-1.3925,2.2586z'/%3E %3Cpath d='m511.5,363.85c0.4053,0.0572,0.80864-0.0448,1.1796-0.1925,0.37209-0.15185,0.72387-0.35374,1.0481-0.59277,0.32861-0.23292,0.63035-0.50451,0.90172-0.80188,0.2705-0.29824,0.51172-0.62817,0.67646-1.0007-0.12301,0.39001-0.35112,0.74179-0.61287,1.0562-0.26373,0.31441-0.5718,0.58972-0.90129,0.83421-0.33539,0.23598-0.69438,0.44376-1.0826,0.58251-0.38411,0.1359-0.80952,0.21784-1.2091,0.11493z'/%3E %3Cpath d='m512.69,365.3c0.40465,0.0712,0.81848,0.035,1.2035-0.0863,0.38586-0.12039,0.74769-0.31114,1.0763-0.54798,0.33321-0.23052,0.63408-0.50604,0.91156-0.80406,0.27749-0.29803,0.52701-0.62228,0.74245-0.97078-0.17589,0.37123-0.4123,0.71361-0.67974,1.0267-0.26853,0.3142-0.57573,0.59496-0.91156,0.83727-0.34063,0.23423-0.71316,0.43262-1.1154,0.53903-0.40181,0.10859-0.83247,0.12214-1.2271,0.006z'/%3E %3Cpath d='m514.18,366.88c0.39089-0.0125,0.77806-0.0653,1.1458-0.18266,0.36751-0.1169,0.71776-0.28645,1.0333-0.50691,0.32097-0.21413,0.60632-0.47763,0.86546-0.76473,0.25979-0.2871,0.48768-0.60436,0.69481-0.93582-0.3332,0.70705-0.84841,1.3378-1.4982,1.7906-0.32861,0.21937-0.68956,0.39482-1.0711,0.49664-0.38214,0.10422-0.78068,0.1359-1.17,0.10291z'/%3E %3Cpath d='m515.69,368.41c0.76691-0.0417,1.4932-0.33233,2.1128-0.76517,0.3142-0.21216,0.60086-0.46299,0.86109-0.73873,0.26023-0.27618,0.49205-0.58076,0.67121-0.92008-0.1383,0.35899-0.35723,0.68454-0.60894,0.97645-0.25214,0.29279-0.5458,0.54886-0.86153,0.77238-0.3214,0.21456-0.66706,0.39766-1.0352,0.51762-0.36795,0.12039-0.75621,0.18244-1.1394,0.15753z'/%3E %3Cpath d='m517.15,369.81c0.36489-0.0384,0.72628-0.0935,1.078-0.18681,0.35069-0.0935,0.69482-0.21631,1.0127-0.38827,0.32228-0.1643,0.6179-0.37777,0.87835-0.62904,0.25979-0.25127,0.47828-0.54668,0.65111-0.87005-0.13197,0.34304-0.33757,0.65898-0.59147,0.92991-0.25476,0.27006-0.56065,0.48987-0.88774,0.66619-0.6616,0.33933-1.4084,0.49293-2.141,0.47807z'/%3E %3Cpath d='m518.79,371.23c0.34522-0.004,0.68739-0.0398,1.0195-0.12039,0.33124-0.0815,0.65373-0.19752,0.95285-0.35965,0.30306-0.15447,0.58251-0.3533,0.83378-0.58294s0.47064-0.49598,0.63625-0.79969c-0.1241,0.32381-0.33233,0.61331-0.57791,0.86065-0.24625,0.24843-0.53466,0.45228-0.8423,0.61878-0.31157,0.15841-0.64259,0.27901-0.98585,0.34434-0.34216,0.0653-0.69328,0.0802-1.0363,0.0389z'/%3E %3Cpath d='m520.57,372.68c0.326-0.005,0.65002-0.0363,0.96051-0.11952,0.31026-0.0815,0.60981-0.2032,0.88031-0.37471,0.27487-0.16344,0.5198-0.37516,0.73698-0.61157,0.21762-0.23685,0.4016-0.50538,0.55826-0.79073-0.23008,0.612-0.67646,1.1445-1.2384,1.4954-0.28426,0.16934-0.59452,0.29694-0.91833,0.36314-0.3225,0.0677-0.65527,0.0771-0.9793,0.038z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23sword' transform='matrix(-0.99823174,-0.05944245,-0.05944245,0.99823174,979.09134,28.304721)'/%3E %3Cg stroke='%2324420e' stroke-width='0.1639'%3E %3Cpath fill='%23406325' d='m409.24,240.02c7.2105-2.3667,18.73-15.453,19.478-17.917-15.593,4.154-22.757,14.343-19.478,17.917z'/%3E %3Cpath fill='%23406325' d='m554.98,244.72c-1.7023-7.0449-13.279-19.011-15.568-19.911,2.7633,15.161,11.916,22.759,15.568,19.911z'/%3E %3Cpath fill='%2367923d' d='m409.24,240.02c-3.3248-3.5739,3.7915-13.666,19.339-17.82-10.957,8.4033-19.199,16.178-19.339,17.82z'/%3E %3Cpath fill='%2367923d' d='m554.98,244.72c-3.6558,2.8916-12.72-4.6537-15.486-19.77,7.1631,11.072,13.934,19.511,15.486,19.77z'/%3E %3C/g%3E %3Cg stroke='%23999270' stroke-width='0.1639'%3E %3Cpath fill='url(%23rg1)' d='m452.21,318.1s-6.1583,0.66182-7.8844-7.8335c-1.8458-9.0861,5.3064-10.052,5.3064-10.052s8.1033-0.78046,13.15-0.90894l2.24,17.953-12.812,0.84165z'/%3E %3Cpath fill='url(%23rg2)' d='m453.02,315.36s-3.9845,0.76167-4.8069-5.5533c-0.58272-4.4732,2.185-5.1073,2.185-5.1073l9.236,1.5636,0.0503,8.2414-6.6643,0.85562z'/%3E %3Cpath fill='url(%23rg3)' d='m450.4,304.7s5.9055-0.43022,8.9889-0.82963l1.2806,5.7108-7.1011,0.44464c-0.00022,0-0.48746-5.1552-3.1684-5.3258z'/%3E %3Cpath fill='url(%23rg4)' d='m449.16,300.36s7.5754-1.8574,8.5165,6.4886c0.24581,2.1814-0.94106,7.1673-4.6555,8.5145l13.874-1.4565-1.2563-15.007-4.6738,0.39045s-9.9225,0.34107-11.805,1.0702z'/%3E %3Cpath fill='%23f9f0aa' d='m452.2,318.1c0.0472,0,51.903-3.4913,57.217-3.2739,15.743-8.6382-0.076-42.559-13.342-61.532,1.5146-4.2757-29.858-13.892-44.047-13.024-1.782,0.10903-3.5051,0.22724-5.1541,0.35397-7.6956,0.81629-7.7754,10.694-4.6367,16.923,3.0449,6.0429,30.315,55.126,11.14,60.317l-1.1766,0.23576z'/%3E %3Cpath fill='url(%23lg1)' d='m507.79,273.34c-3.5202-7.304-7.7338-14.349-11.718-20.046,1.5142-4.2757-29.859-13.892-44.047-13.024-1.782,0.10903-3.5051,0.22724-5.1541,0.35397-7.6956,0.81629-7.7754,10.694-4.6367,16.923,0.95591,1.8976,4.3011,8.0393,7.8464,15.733'/%3E %3Cpath fill='url(%23lg2)' d='m455.04,284.95c5.5546,14.65,8.6644,30.117-1.6413,32.907l-1.1766,0.23598c0.0472,0,51.903-3.4913,57.216-3.2735,8.5377-4.6843,7.7926-16.804,3.2073-29.943'/%3E %3Cpath fill='url(%23rg5)' d='m447.4,243.49c-3.705,0-4.6563,3.5621-4.6052,5.8172,0.13371,5.9085,4.6052,6.1921,4.6052,6.1921l5.9645-0.33233,2.8577-12.163-8.8222,0.48615z'/%3E %3Cpath fill='url(%23lg3)' d='m447.4,243.53,8.8222-0.48615,0.90762,9.0857-7.696,0.33757c0,0.00022,2.4913-7.2746-2.0338-8.9371z'/%3E %3Cpath fill='url(%23lg4)' d='m496.12,253.29c6.6855-1.0741,6.5946-10.069,2.0257-13.673-15.498-0.56939-35.895-0.14311-50.63,0.95941,1.6761-0.0483,6.3372,0.37625,6.8557,6.5111,0.24187,2.8625-1.1654,5.4912-3.0609,6.9859-1.8533,1.4615-3.906,1.4615-3.906,1.4615,0.24799,0.0955,2.1622,0.007,3.5984-0.0867,0.73895-0.0485,2.5518-0.26438,3.0554-0.33058,21.012-2.7616,41.987-1.8229,41.987-1.8229l0.0797,0.003c-0.002-0.003-0.003-0.005-0.005-0.008z'/%3E %3Cg fill='%23b07e09' stroke='none'%3E %3Cpath d='m458.47,267.42c-0.14307-0.33143-0.32344-0.74904-0.72915-0.80525-0.24955,0.0146-0.64602-0.0516-0.56795-0.39173,0.23471-0.11275,0.53358-0.0411,0.79388-0.0653,0.5617,0.01,1.1134-0.1139,1.6713-0.14811,0.33714,0.0924,0.26114,0.53754-0.1051,0.46371-0.40765,0.0923-0.17515,0.56277-0.075,0.80926,0.44356,1.0343,0.87222,2.0753,1.3282,3.1041,0.12646,0.30356,0.38018,0.57176,0.72219,0.60554,0.36132,0.0353,0.75556,0.0449,1.0901-0.1161,0.31087-0.19947,0.24167-0.62374,0.20014-0.93675-0.1251-0.36343,0.53948-0.28153,0.4942,0.0441,0.12951,0.42948,0.27963,0.85338,0.4476,1.2683-0.0221,0.20027-0.27563,0.14416-0.42122,0.1692-0.99242,0.0761-1.9867,0.13132-2.9778,0.22273-0.31888-0.0172-0.79628,0.28094-0.9909-0.0956-0.11854-0.38638,0.51127-0.1693,0.59555-0.46271-0.003-0.32725-0.19548-0.6154-0.30674-0.91676-0.38977-0.91578-0.7797-1.8351-1.1694-2.7487z'/%3E %3Cpath d='m463.3,267.08c-0.1404-0.31992-0.302-0.71957-0.68686-0.79561-0.24688-0.0227-0.65282-0.0174-0.61569-0.37437,0.15627-0.16169,0.45617-0.0582,0.67049-0.0921,0.59111,0.0192,1.1738-0.0896,1.7598-0.1438,0.2904-0.0276,0.3982,0.51827,0.0255,0.44396-0.35822,0.0116-0.3836,0.40448-0.23349,0.65107,0.47033,1.1419,0.95892,2.2765,1.4375,3.415,0.10488,0.24466,0.24008,0.54794,0.54004,0.58586,0.2521,0.0492,0.64789-0.0288,0.70423,0.31605-0.0398,0.26696-0.43337,0.11891-0.62879,0.16072-0.52229-0.0363-1.0425,0.0314-1.5563,0.11861-0.22635,0.0642-0.5502,0.0273-0.55928-0.26976,0.0528-0.27221,0.58365-0.0683,0.60981-0.40128-0.0398-0.3261-0.21556-0.61575-0.3303-0.92008-0.37873-0.89791-0.75873-1.7974-1.1367-2.6943z'/%3E %3Cpath d='m467.76,267.79c0.0905,0.22743,0.40406,0.0636,0.58583,0.0752,0.26329-0.0255,0.54341-0.21507,0.51879-0.50891-0.0427-0.4512-0.26334-0.90844-0.63162-1.1828-0.34103-0.23966-0.7793-0.21343-1.172-0.1626-0.0226,0.15488,0.0979,0.30397,0.14476,0.45347,0.18473,0.44188,0.36966,0.8837,0.55426,1.3256zm0.6684,1.5962c0.16337,0.34893,0.27899,0.74478,0.56455,1.0172,0.24365,0.17131,0.5689,0.093,0.84351,0.0652,0.30167-0.0202,0.47917-0.33066,0.3856-0.60827-0.14179-0.6355-0.55438-1.3008-1.2378-1.4371-0.30016-0.0516-0.61793-0.0654-0.91565-0.001-0.0232,0.14403,0.0918,0.28859,0.13557,0.42942,0.0747,0.17817,0.1496,0.35716,0.22424,0.53482zm-2.0348-2.3717c-0.15771-0.34702-0.30945-0.76722-0.68808-0.92519-0.24435-0.0813-0.64253,0.0301-0.69582-0.32286,0.065-0.30322,0.56261-0.0904,0.80178-0.15976,0.86327-0.0225,1.7427-0.26404,2.5932-0.004,0.73402,0.18212,1.3916,0.80958,1.4496,1.5869,0.0243,0.3773-0.26107,0.6843-0.58138,0.83788-0.0394-0.13577,0.3671,0.0609,0.50625,0.082,0.58325,0.18645,1.1192,0.57568,1.3783,1.1433,0.20099,0.39775,0.35617,0.931,0.0394,1.3146-0.36178,0.39514-0.93916,0.41299-1.4376,0.43714-0.75022,0.0198-1.5053,0.0256-2.2443,0.17278-0.26712,0.0465-0.45804-0.48213-0.0897-0.44892,0.37045-0.0136,0.40329-0.41383,0.2441-0.66837-0.42527-1.0153-0.85054-2.0307-1.2758-3.0459z'/%3E %3Cpath d='m473.81,265.11c0.32718-0.0544,0.35831,0.3161,0.45793,0.53166,0.0983,0.28394,0.27637,0.54219,0.34849,0.83144-0.27729,0.27636-0.5018-0.14465-0.62456-0.3594-0.1439-0.24731-0.3827-0.47568-0.69009-0.45095-0.40636-0.002-0.81669,0.0145-1.2186,0.0722-0.14455,0.15755,0.0652,0.39285,0.11247,0.57653,0.1894,0.44547,0.36011,0.9006,0.56164,1.3398,0.27062-0.0225,0.61991,0.0146,0.81331-0.20808,0.0751-0.22898-0.26998-0.74689,0.20987-0.64006,0.29748,0.1698,0.26318,0.6021,0.41591,0.88216,0.12636,0.38776,0.38401,0.72392,0.49191,1.1148-0.26291,0.28875-0.52448-0.12967-0.61934-0.3631-0.18831-0.34686-0.62469-0.30588-0.95946-0.2961-0.24094-0.0507-0.0753,0.17151-0.041,0.28277,0.21575,0.49335,0.38321,1.0111,0.65934,1.4753,0.20678,0.34329,0.65054,0.29169,0.99357,0.28011,0.3281-0.0177,0.73213-0.0248,0.92609-0.33842,0.21559-0.25167-0.27414-0.75134,0.13115-0.83062,0.34698-0.0306,0.33749,0.37589,0.42927,0.60648,0.0734,0.28174,0.18493,0.55171,0.28456,0.82364-0.0264,0.19879-0.27783,0.14023-0.42383,0.16319-1.0195,0.065-2.0406,0.10828-3.0588,0.19006-0.30025,0.001-0.80525,0.23909-0.90167-0.19822,0.0262-0.2876,0.64599-0.13478,0.55396-0.54392-0.0732-0.34705-0.24884-0.66262-0.37267-0.99381-0.37616-0.89638-0.73147-1.8019-1.1229-2.6916-0.14057-0.2963-0.36799-0.61968-0.73047-0.62841-0.23799,0.0464-0.60085-0.12899-0.46164-0.40696,0.34613-0.067,0.71114-0.0198,1.0641-0.0569,0.92382-0.0545,1.8476-0.10915,2.7714-0.16357z'/%3E %3Cpath d='m476.12,266.43c-0.15374-0.34845-0.30185-0.76874-0.67875-0.92975-0.25693-0.0765-0.72611,0.0133-0.69679-0.39387,0.24605-0.18988,0.65923-0.0315,0.96836-0.0898,0.80068-0.0109,1.6199-0.23795,2.4073,0.00027,0.82463,0.22961,1.5151,0.97195,1.5727,1.8413,0.0267,0.41568-0.30657,0.75244-0.6847,0.86344-0.29656,0.0153,0.22879,0.10055,0.30962,0.19647,0.63275,0.30389,1.0688,0.87693,1.406,1.4737,0.0757,0.22539,0.51881,0.69649,0.58657,0.24657-0.0269-0.49,0.6373-0.075,0.48723,0.26344,0.002,0.35658-0.35128,0.58745-0.68118,0.58286-0.46451,0.0366-0.90432-0.23136-1.138-0.62365-0.42141-0.55349-0.70862-1.2243-1.2649-1.6634-0.23114-0.16553-0.55903-0.26894-0.82981-0.15171-0.0582,0.1395,0.0681,0.28041,0.10427,0.41651,0.17986,0.40844,0.30537,0.84509,0.547,1.2225,0.2006,0.30876,0.59311,0.35831,0.9303,0.35601,0.3598,0.0889,0.25929,0.57544-0.12356,0.43251-0.58509-0.001-1.1749-0.0442-1.7528,0.0764-0.26879,0.12586-0.86512,0.0102-0.64932-0.37044,0.283-0.0161,0.6752-0.17232,0.47996-0.52437-0.33128-0.87221-0.69856-1.7309-1.0447-2.5975-0.0849-0.20914-0.17-0.41822-0.25479-0.62739zm1.404,0.89347c0.13446,0.32598,0.59518,0.14488,0.86133,0.11358,0.35755-0.0786,0.34757-0.50799,0.23351-0.77734-0.16266-0.46877-0.37331-1.0295-0.89017-1.1951-0.26165-0.035-0.84451-0.20185-0.88465,0.15199,0.18883,0.53496,0.42263,1.0546,0.62982,1.5834,0.0167,0.0411,0.0334,0.0825,0.0502,0.12348z'/%3E %3Cpath d='m484.74,269.04c0.10917,0.25915,0.21273,0.60969,0.53838,0.65626,0.25495,0.0587,0.66431-0.0241,0.71644,0.32963-0.0491,0.26525-0.43911,0.10496-0.63631,0.14317-0.53793-0.0503-1.0754,0.0123-1.608,0.0839-0.23088,0.0709-0.5509-0.0297-0.51807-0.31944,0.12458-0.20956,0.64721-0.0374,0.61945-0.40227-0.0857-0.39995-0.27577-0.76838-0.41598-1.1514-0.38316-0.96139-0.76234-1.9244-1.148-2.8848-0.0945-0.30484-0.44335-0.29727-0.7022-0.2799-0.27334,0.002-0.68302,0.0613-0.68325,0.41585-0.0873,0.2297,0.21725,0.61574-0.0444,0.7351-0.3013,0.0636-0.36166-0.27486-0.42591-0.48749-0.0983-0.32057-0.26015-0.61799-0.38487-0.92568,0.0357-0.21414,0.3206-0.17639,0.49259-0.19361,1.3772-0.0572,2.7542-0.12015,4.1314-0.17371,0.30284-0.047,0.50224,0.19156,0.51743,0.47691,0.10822,0.33686,0.26985,0.65337,0.41381,0.97461-0.11306,0.33043-0.50781,0.0472-0.55333-0.19565-0.19914-0.34881-0.50948-0.69255-0.9391-0.71063-0.25705,0.0125-0.64239-0.0856-0.8153,0.14506,0.007,0.23983,0.14513,0.45279,0.21975,0.67783,0.4084,1.0285,0.81753,2.0591,1.2255,3.0862z'/%3E %3Cpath d='m488.47,268.13c-0.1915,0.001-0.0974,0.242-0.11817,0.36667,0.0118,0.28256-0.017,0.56914,0.0297,0.84837,0.13231,0.3102,0.52709,0.2343,0.78488,0.31822,0.22981,0.13123,0.17292,0.50149-0.13592,0.38771-0.42261-0.0259-0.85122-0.0688-1.2678,0.0331-0.24848,0.1327-0.71306-0.12286-0.49305-0.39157,0.2016-0.0347,0.44875-0.10136,0.49484-0.33467,0.0718-0.41378,0.0335-0.83739,0.0472-1.2559,0.007-1.238,0.015-2.476,0.0225-3.714,0.11955-0.27851,0.51386-0.0443,0.60235,0.16635,1.1921,1.516,2.3695,3.0443,3.5933,4.5348,0.19176,0.23288,0.46186,0.40029,0.76809,0.4178,0.25954,0.002,0.40172,0.53161,0.0275,0.42657-0.51126-0.0289-1.0269-0.0629-1.5353,0.0229-0.22818,0.006-0.49228,0.11148-0.69618-0.022-0.24312-0.17858-0.0701-0.43576,0.19588-0.40343,0.35203-0.10003-0.005-0.47695-0.11676-0.65245-0.1898-0.25561-0.37883-0.5135-0.58929-0.75233-0.17041-0.0841-0.37343-0.0217-0.55849-0.0313-0.35132,0.012-0.70591,0.022-1.0552,0.0352zm1.1732-0.51153c0.18229,0.0111-0.0571-0.15544-0.0868-0.23536-0.42445-0.55445-0.84889-1.1089-1.2733-1.6633,0.0839-0.0129,0.0172,0.17549,0.0386,0.25552-0.002,0.5612,0.004,1.1226-0.002,1.6837,0.44105-0.0106,0.88396-0.0264,1.3238-0.0405z'/%3E %3Cpath d='m492.7,265.77c-0.14936-0.39834-0.34992-0.88654-0.81752-0.98102-0.24305,0.0438-0.70218-0.17699-0.45279-0.43884,0.55052-0.008,1.1029,0.0301,1.6534-0.0168,0.69784-0.0604,1.416-0.0428,2.0797,0.20455,1.4601,0.49242,2.672,1.7777,2.9142,3.3212,0.10741,0.60447-0.0788,1.3034-0.62503,1.6411-0.73524,0.46702-1.6421,0.38035-2.4704,0.33336-0.46991-0.0221-0.93798,0.0398-1.4038,0.086-0.30403-0.0415-0.3372-0.51217,0.0233-0.45643,0.37223-0.0121,0.36467-0.42242,0.22829-0.66787-0.37645-1.008-0.75316-2.0193-1.1294-3.0252zm1.97,2.4936c0.14884,0.34026,0.23924,0.75541,0.56296,0.97636,0.30214,0.14269,0.6575,0.11564,0.98151,0.0803,0.43944-0.0594,0.71224-0.49285,0.71647-0.91173,0.0269-0.75326-0.28171-1.4733-0.63171-2.1243-0.37441-0.7006-1.0557-1.2335-1.8441-1.3722-0.32451-0.0534-0.66476-0.10312-0.99053-0.0491-0.0707,0.123,0.059,0.27181,0.0864,0.40147,0.373,0.99972,0.74599,1.9994,1.119,2.9991z'/%3E %3Cpath d='m473.56,280.68c0.11606,0.34963,0.43958,0.60007,0.80483,0.63405,0.25677,0.0452,0.69924-0.0156,0.7128,0.35386-0.13761,0.2344-0.52951,0.0712-0.76858,0.1225-0.51864-0.009-1.0376,0.008-1.5504,0.0922-0.27697,0.0118-0.56691,0.12559-0.8373,0.0485-0.24472-0.11624-0.19392-0.47039,0.10657-0.42647,0.24725-0.0579,0.60421-0.13495,0.622-0.44863-0.023-0.28469-0.18161-0.53458-0.27762-0.79946-0.38512-0.91649-0.76056-1.8372-1.1519-2.751-0.0861-0.32419-0.44627-0.33313-0.71537-0.28394-0.24766,0.0472-0.61627,0.1239-0.67679-0.21966,0.0302-0.29194,0.49713-0.23832,0.70232-0.38999,0.31181-0.12117,0.61996-0.25633,0.93884-0.35646,0.2159-0.0466,0.32497,0.1506,0.37916,0.32165,0.57039,1.3671,1.1415,2.7383,1.7114,4.1028z'/%3E %3Cpath d='m474.31,276.17c0.68157-0.0264,1.3667,0.0766,2.0461,0.002,0.30072-0.0289,0.0947-0.49726,0.38365-0.47016,0.37142,0.0171,0.31167,0.47765,0.33508,0.73916,0.0422,0.33127-0.23741,0.62475-0.56978,0.58312-0.53305,0.0289-1.0648-0.0493-1.598-0.0213,0.12116,0.41264,0.28802,0.80975,0.44482,1.2092,0.0275-0.13437,0.46005-0.15534,0.63873-0.1809,1.0643-0.0467,2.1676,0.56093,2.6138,1.5434,0.21451,0.47701,0.32727,1.1006-0.0285,1.5406-0.38664,0.45626-1.0303,0.54904-1.5958,0.55416-0.48924-0.006-1.0641-0.11235-1.353-0.5493-0.16678-0.21528-0.13828-0.68045,0.22108-0.64108,0.30463,0.004,0.65887,0.26426,0.60927,0.59572,0.16287,0.22213,0.52468,0.14404,0.77532,0.13986,0.29921-0.0105,0.58436-0.24171,0.56922-0.55843,0.007-0.48591-0.18499-0.96182-0.45431-1.3595-0.29162-0.42264-0.78266-0.70723-1.3024-0.69596-0.29377-0.0494-0.5476,0.1472-0.82727,0.14669-0.28405-0.0376-0.33434-0.36628-0.43468-0.58118-0.2377-0.59776-0.46117-1.2018-0.64986-1.817-0.0191-0.10564,0.0752-0.19163,0.17659-0.17909z'/%3E %3Cpath d='m481.16,277.19c-0.16047-0.39514-0.37046-0.88248-0.8414-0.96765-0.24185,0.0565-0.70339-0.16996-0.46203-0.42988,0.55717-0.022,1.1176-0.001,1.6734-0.0676,0.70408-0.0848,1.4324-0.0708,2.1052,0.17584,1.486,0.49365,2.7091,1.8179,2.9341,3.3872,0.0887,0.58373-0.11406,1.2385-0.63224,1.5634-0.71804,0.46579-1.6078,0.39631-2.4238,0.37712-0.4528-0.005-0.90098,0.0699-1.3477,0.12798-0.30094-0.0344-0.35294-0.50358,0.008-0.4612,0.3732-0.0274,0.34313-0.44024,0.20295-0.68191-0.4054-1.0075-0.81109-2.0171-1.2163-3.0233zm2.0307,2.4609c0.15813,0.33874,0.25946,0.75312,0.58863,0.9696,0.30223,0.13593,0.65449,0.098,0.97409,0.0527,0.43943-0.0753,0.68696-0.52453,0.67805-0.94167,0.003-0.76061-0.32573-1.4787-0.69458-2.1277-0.38903-0.6907-1.0775-1.2137-1.869-1.3328-0.32242-0.044-0.66071-0.0842-0.98153-0.0206-0.0653,0.12618,0.068,0.27222,0.0991,0.40236,0.40169,0.99938,0.8037,1.9988,1.2052,2.9981z'/%3E %3Cpath d='m489.63,275.39c0.31178-0.0532,0.35285,0.29338,0.437,0.50448,0.10128,0.28312,0.24535,0.54906,0.3459,0.83193-0.1893,0.31085-0.50732-0.0573-0.58803-0.28325-0.14484-0.24762-0.35587-0.519-0.67346-0.51186-0.4115-0.0205-0.82498,0.002-1.2352,0.0343-0.22517,0.10065,0.0154,0.38945,0.0539,0.56683,0.18315,0.45139,0.34635,0.91271,0.54261,1.3576,0.26528-0.009,0.57328,0.0123,0.79839-0.15157,0.17488-0.21253-0.26822-0.73665,0.21199-0.68033,0.32664,0.11904,0.27678,0.56859,0.41544,0.83786,0.12466,0.39688,0.35587,0.74837,0.4908,1.1405-0.17513,0.33071-0.54337-0.0556-0.59294-0.30249-0.14146-0.32034-0.52112-0.36204-0.82832-0.35078-0.20477-0.0355-0.37006,0.0103-0.22596,0.21599,0.21474,0.51544,0.37925,1.0551,0.65528,1.5422,0.20328,0.34681,0.64962,0.30164,0.9943,0.29753,0.33009-0.0121,0.73597-0.008,0.93997-0.31739,0.20676-0.24272-0.19639-0.65729,0.0819-0.81092,0.33772-0.0958,0.41613,0.27773,0.46617,0.5222,0.0755,0.30705,0.18428,0.60483,0.28994,0.90134-0.0315,0.19742-0.28035,0.13291-0.42657,0.15311-1.0295,0.0442-2.0601,0.0672-3.0888,0.12727-0.28711-0.0192-0.69076,0.20649-0.86993-0.11391-0.18386-0.39605,0.50285-0.17964,0.5304-0.52494,0.0206-0.30461-0.15923-0.57313-0.25097-0.8547-0.38399-0.9655-0.75106-1.938-1.1469-2.8986-0.13617-0.31314-0.36116-0.66186-0.74051-0.67914-0.23682,0.0409-0.60259-0.13649-0.45593-0.41257,0.35614-0.0589,0.72799-0.005,1.0901-0.0347,0.92646-0.0354,1.8533-0.0702,2.7795-0.10605z'/%3E %3Cpath d='m462.35,289.67c0.14889,0.48692,0.66813,0.68606,1.1115,0.81754,0.76953,0.26088,1.5999,0.5188,2.1474,1.158,0.30658,0.3717,0.51888,0.85427,0.49645,1.3425-0.0396,0.49631-0.46485,0.86901-0.92484,0.99075-0.5659,0.18399-1.1912,0.1355-1.735-0.0972-0.26579-0.1147-0.16456,0.46707-0.49617,0.27047-0.23849-0.18227-0.16339-0.5597-0.29566-0.81493-0.10452-0.33044-0.24388-0.64843-0.38522-0.96389,0.0122-0.3258,0.47952-0.15603,0.49529,0.0975,0.32751,0.59399,0.92384,1.12,1.6332,1.1256,0.35806,0.011,0.80671-0.17966,0.83786-0.58366,0.007-0.53472-0.41913-0.95354-0.86493-1.1829-0.63918-0.33173-1.3753-0.43717-1.9939-0.81201-0.55467-0.33412-0.94649-0.95389-0.9475-1.6079,0.0124-0.43668,0.36971-0.77784,0.7672-0.90267,0.50247-0.17158,1.0552-0.20067,1.5676-0.0533,0.23849,0.12524,0.34031-0.27354,0.59498-0.0757,0.11428,0.19555,0.0847,0.46072,0.19379,0.67176,0.0806,0.28622,0.27144,0.5368,0.33396,0.82495-0.15855,0.24419-0.46565,0.0144-0.51716-0.20276-0.22085-0.36611-0.51648-0.77262-0.98273-0.80483-0.34605-0.0265-0.7856-0.0294-1.0066,0.28776-0.0965,0.1537-0.0917,0.34996-0.0294,0.51496z'/%3E %3Cpath d='m469.04,288.02c0.32657-0.0589,0.33649,0.314,0.41808,0.52848,0.0813,0.27158,0.20932,0.52697,0.28887,0.79855-0.13999,0.28678-0.49293,0.0246-0.53577-0.21096-0.13686-0.26048-0.33786-0.57167-0.67348-0.55212-0.4093-0.007-0.81908,0.0304-1.2254,0.0755-0.22745,0.10072-0.007,0.39086,0.0247,0.5716,0.15781,0.4505,0.29564,0.90987,0.46654,1.3546,0.2675-0.0184,0.57594-0.01,0.79916-0.17995,0.1955-0.20067-0.19249-0.60425,0.13885-0.69572,0.37391-0.0471,0.34474,0.44123,0.43459,0.68421,0.0967,0.44975,0.33494,0.84931,0.46752,1.2862-0.14491,0.31671-0.5323,0.01-0.55108-0.24764-0.11183-0.32857-0.48297-0.39833-0.78805-0.36789-0.17891-0.0113-0.42194-0.0128-0.2756,0.21065,0.181,0.50461,0.3186,1.0269,0.54996,1.5117,0.12108,0.28359,0.45097,0.34613,0.72676,0.32248,0.39263-0.0271,0.84683,0.0151,1.1533-0.28135,0.24544-0.23384,0.0408-0.58484,0.095-0.85328,0.24945-0.19893,0.52577,0.068,0.49972,0.34236,0.0692,0.34542,0.16129,0.68631,0.26731,1.0211-0.0418,0.20112-0.29151,0.14397-0.4453,0.16981-1.0176,0.0778-2.0371,0.13304-3.0531,0.22801-0.28026-0.0136-0.68355,0.23497-0.85527-0.0871-0.15839-0.38323,0.45714-0.20653,0.53743-0.50154,0.081-0.295-0.0978-0.57443-0.17249-0.85371-0.33603-0.9796-0.65391-1.9657-1.0027-2.9407-0.11595-0.30747-0.32641-0.66035-0.69818-0.66291-0.23795,0.0555-0.59246-0.13222-0.42986-0.40217,0.3458-0.072,0.71148-0.0279,1.0643-0.0703,0.92469-0.066,1.8496-0.13171,2.7742-0.19787z'/%3E %3Cpath d='m473.22,292.16c0.091,0.30434,0.2697,0.63825,0.61206,0.6999,0.24923,0.0888,0.66447-0.0731,0.73162,0.28619-0.0121,0.32758-0.49229,0.14975-0.71215,0.20375-0.50985-0.0271-1.0209,0.008-1.5222,0.10462-0.21782,0.0315-0.54463,0.10754-0.60795-0.18878-0.0545-0.33567,0.4631-0.14679,0.57268-0.39914,0.0804-0.25911-0.0661-0.51646-0.13591-0.76453-0.33739-1.0049-0.66303-2.0138-1.0085-3.0159-0.11428-0.29175-0.27006-0.67408-0.62939-0.70776-0.23232-0.0105-0.6288-0.0315-0.55781-0.36759,0.1746-0.16557,0.48564-0.0523,0.71242-0.0825,0.73096,0.0161,1.4495-0.19235,2.1804-0.144,0.75108,0.0285,1.4823,0.50765,1.7354,1.2278,0.1648,0.40531,0.21971,0.91647-0.0793,1.2755-0.38705,0.45469-1.0216,0.5475-1.5803,0.62208-0.21194-0.0276-0.04,0.19166-0.0267,0.30158,0.10509,0.31628,0.21129,0.63246,0.31569,0.94881zm-0.57141-1.7202c0.2055,0.0293,0.46107-0.0251,0.67612-0.0833,0.31359-0.0633,0.47812-0.39914,0.39601-0.69578-0.0877-0.42243-0.22807-0.86517-0.54377-1.1743-0.30389-0.25301-0.74642-0.26101-1.112-0.16344-0.13967,0.12196,0.002,0.31915,0.0355,0.46985,0.18281,0.54879,0.36475,1.0991,0.5481,1.647z'/%3E %3Cpath d='m478.8,291.87c0.0897,0.25498,0.17001,0.61087,0.49187,0.65157,0.24649,0.0547,0.66053-0.036,0.69072,0.32033-0.0607,0.26474-0.44121,0.11529-0.64317,0.1555-0.53863-0.0414-1.0748,0.0309-1.6059,0.11158-0.22567,0.0776-0.54836-0.0218-0.49373-0.31187,0.13752-0.21281,0.64999-0.0496,0.64426-0.4153-0.0549-0.39043-0.21769-0.75577-0.3292-1.1326-0.31766-0.96675-0.63085-1.935-0.95132-2.9008-0.0762-0.30964-0.42906-0.29003-0.67893-0.26934-0.25453,0.019-0.62035,0.0473-0.69252,0.35027-0.0828,0.25442,0.0399,0.53291-0.0153,0.7784-0.23703,0.16264-0.46687-0.089-0.45654-0.33006-0.0829-0.34413-0.20809-0.6764-0.34461-1.0016-0.009-0.23925,0.30469-0.21863,0.47906-0.23639,1.3809-0.0816,2.7616-0.17001,4.1427-0.24727,0.30058-0.0552,0.49009,0.18787,0.48207,0.47102,0.0834,0.33503,0.22364,0.65237,0.3452,0.97347-0.0677,0.28279-0.4853,0.13043-0.50147-0.11884-0.17371-0.35344-0.44476-0.73357-0.87382-0.76235-0.28084-0.005-0.62542-0.0571-0.85908,0.1244-0.0529,0.20577,0.0778,0.40251,0.12516,0.59989,0.3483,1.0632,0.69586,2.1274,1.0446,3.19z'/%3E %3Cpath d='m480.9,288.58c-0.10511-0.30537-0.21974-0.69305-0.57144-0.78928-0.23567-0.0608-0.64922,0.009-0.62597-0.35547,0.0961-0.2119,0.41704-0.0804,0.60887-0.11995,0.59887,0.0268,1.1927-0.0588,1.7867-0.11794,0.26641-0.12052,0.47853,0.42109,0.15225,0.42081-0.25499-0.002-0.54577,0.18766-0.44215,0.47338,0.13157,0.53152,0.32425,1.0457,0.48566,1.5688,0.24059,0.73278,0.46742,1.4703,0.71758,2.1998,0.0665,0.22873,0.24776,0.43142,0.49851,0.44095,0.24128,0.001,0.66349,0.0343,0.58769,0.37901-0.1803,0.1561-0.47927,0.0579-0.70826,0.0802-0.53844-0.0442-1.0723,0.0478-1.6044,0.11402-0.23234,0.0989-0.53601-0.13911-0.39232-0.37822,0.20623-0.0973,0.64726-0.043,0.61705-0.38405-0.0778-0.41061-0.23705-0.80053-0.35686-1.2003-0.25102-0.77713-0.50179-1.555-0.75297-2.3317z'/%3E %3Cpath d='m486.66,286.98c0.31717-0.0569,0.33321,0.30467,0.40399,0.51705,0.0781,0.27686,0.20196,0.53879,0.27922,0.81529-0.14497,0.28325-0.49455,0.0177-0.53358-0.21905-0.13249-0.26332-0.32917-0.57588-0.66559-0.56223-0.41104-0.014-0.82341,0.0142-1.2324,0.0527-0.23041,0.0941-0.0151,0.38839,0.0135,0.56872,0.14972,0.4516,0.28011,0.91144,0.44239,1.3577,0.26893-0.0116,0.57851,0.002,0.80688-0.163,0.20002-0.19577-0.18048-0.60674,0.15397-0.68977,0.3753-0.0418,0.33671,0.44565,0.4235,0.6897,0.0859,0.45005,0.32007,0.85096,0.44274,1.2887-0.11466,0.28936-0.52699,0.0423-0.52805-0.21334-0.095-0.31925-0.42841-0.45271-0.73858-0.42294-0.1459,0.017-0.50285-0.0743-0.35829,0.1705,0.17515,0.51627,0.30659,1.0495,0.53275,1.5467,0.11732,0.28608,0.44757,0.35292,0.72429,0.33446,0.39424-0.0213,0.85017,0.0326,1.164-0.2582,0.2504-0.22688,0.0537-0.58104,0.11246-0.84692,0.2531-0.19218,0.52629,0.0749,0.4951,0.35,0.0621,0.345,0.1479,0.68566,0.24775,1.0205-0.0412,0.19413-0.28099,0.13883-0.42978,0.15928-1.0307,0.0587-2.063,0.0955-3.0926,0.1711-0.27507-0.0176-0.64413,0.20276-0.83815-0.0655-0.21721-0.38819,0.37975-0.2524,0.50742-0.48641,0.13455-0.26611-0.0422-0.5471-0.10792-0.80986-0.32143-0.99485-0.6289-1.9944-0.95988-2.986-0.11127-0.3225-0.31496-0.70295-0.7037-0.71373-0.23837,0.0517-0.59267-0.14098-0.42458-0.40838,0.34344-0.0639,0.70388-0.0156,1.0537-0.0492,0.93604-0.0492,1.8754-0.0989,2.8094-0.14777z'/%3E %3Cpath d='m488.66,287.94c-0.0657-0.35753-0.33894-0.67675-0.73368-0.62169-0.37451,0.0966-0.49968-0.57125-0.0338-0.43032,0.50848,0.003,1.0301-0.0779,1.5292,0.0357,0.24359,0.26365,0.43909,0.576,0.66317,0.85939,0.72332,0.96789,1.4466,1.9358,2.17,2.9037-0.15869,0.0356-0.0357-0.18539-0.0528-0.30101,0.11819-1.1806,0.23638-2.3613,0.35457-3.5419,0.27347-0.22599,0.73028-0.13101,1.0778-0.20207,0.28161-0.0423,0.92456-0.13543,0.745,0.34872-0.33791,0.0556-0.77046,0.22133-0.53651,0.64662,0.35919,1.1968,0.73766,2.388,1.1146,3.5793,0.0684,0.41823,0.48925,0.54588,0.85784,0.52738,0.31687,0.0176,0.33222,0.56251-0.0483,0.43054-0.59356-0.0131-1.1911-0.049-1.7788,0.0635-0.26548,0.0904-0.82078,0.0613-0.64053-0.35521,0.2974-0.0534,0.79403-0.14241,0.58654-0.57225-0.31695-1.0602-0.65767-2.1134-0.98417-3.1707,0.0684,0.095-0.0116,0.25498-0.004,0.37763-0.0959,0.98935-0.22807,1.9758-0.29215,2.9677-0.0395,0.26019,0.0492,0.57372-0.0735,0.79806-0.23587,0.11618-0.38592-0.11309-0.50374-0.27632-0.95195-1.2325-1.9039-2.465-2.8558-3.6975,0.0969-0.0356,0.0852,0.20949,0.13956,0.29186,0.3062,0.95953,0.58871,1.9272,0.91128,2.8811,0.10061,0.3878,0.4941,0.50099,0.84781,0.50431,0.37869,0.19377,0.0985,0.54795-0.23164,0.40323-0.50034-0.0717-0.99765,0.0282-1.4927,0.0846-0.31467-0.009-0.33014-0.51374,0.0285-0.44736,0.46931,0.004,0.32648-0.52269,0.21748-0.80097-0.3411-1.0914-0.68219-2.1828-1.0233-3.2742,0.0141-0.004,0.0283-0.008,0.0424-0.0118z'/%3E %3Cpath d='m497.4,288.79c0.0593,0.22476,0.36397,0.0736,0.52636,0.0972,0.28524-0.0165,0.61957-0.17486,0.63537-0.4985,0.0105-0.43614-0.15685-0.90446-0.49909-1.188-0.33014-0.25253-0.7692-0.22938-1.1607-0.19218-0.0424,0.14588,0.0624,0.3026,0.0924,0.45097,0.13509,0.44347,0.27115,0.88718,0.40563,1.3305zm0.48727,1.5984c0.1243,0.34789,0.19268,0.74271,0.45051,1.0221,0.23769,0.17962,0.56719,0.10432,0.84205,0.087,0.25743-0.0181,0.48711-0.22901,0.46145-0.49857-0.0314-0.59699-0.31608-1.2607-0.90721-1.4938-0.34005-0.12467-0.71258-0.12688-1.0689-0.0911-0.11162,0.0967,0.0379,0.28888,0.0537,0.42193,0.0561,0.18406,0.11246,0.36888,0.16841,0.55248zm-1.7731-2.4024c-0.11732-0.34452-0.22409-0.76964-0.58576-0.93399-0.23304-0.0884-0.64285,0.0181-0.66332-0.33802,0.0833-0.28874,0.54417-0.0786,0.77388-0.13791,0.88678,0.011,1.7946-0.22455,2.6611,0.0631,0.69317,0.18493,1.2838,0.81885,1.2791,1.5575-0.003,0.40874-0.3333,0.71678-0.6865,0.86554-0.0233-0.13426,0.361,0.07,0.49973,0.0951,0.52848,0.18831,1.0182,0.55649,1.225,1.0936,0.17741,0.4142,0.27983,0.9529-0.0379,1.328-0.36163,0.40228-0.94951,0.43124-1.454,0.44425-0.79021,0.003-1.5851-0.0181-2.3676,0.11407-0.28387,0.0354-0.39564-0.50222-0.0385-0.44706,0.35957-0.001,0.45947-0.37887,0.32266-0.65627-0.30878-1.0152-0.62145-2.0365-0.9278-3.0479z'/%3E %3Cpath d='m501.12,287.81c-0.11404-0.34551-0.21756-0.77042-0.57837-0.93689-0.23778-0.0893-0.68709,0.0123-0.6651-0.37022,0.1937-0.25554,0.6567-0.0412,0.95446-0.10429,0.67824,0.005,1.3575-0.13005,2.0341-0.0445,0.79087,0.0929,1.5491,0.64555,1.7414,1.4413,0.14245,0.42071,0.0486,0.95351-0.35953,1.1906-0.0865,0.0956-0.51977,0.19808-0.44425,0.19026,0.60412,0.23923,1.1193,0.69009,1.4122,1.2729,0.15965,0.26189,0.2415,0.58058,0.46616,0.7966,0.2655,0.19822,0.29658-0.1638,0.34165-0.32636,0.3514-0.17469,0.5287,0.31622,0.386,0.58035-0.14669,0.42164-0.67828,0.50437-1.06,0.40458-0.34269-0.0777-0.60222-0.34-0.75643-0.6456-0.34142-0.53715-0.55388-1.1701-1.0298-1.6109-0.2241-0.19542-0.56642-0.30903-0.85076-0.19697-0.0741,0.13476,0.0394,0.28906,0.0626,0.42985,0.12706,0.39123,0.20766,0.80039,0.38614,1.1723,0.15783,0.32729,0.5426,0.40775,0.87264,0.40953,0.3218-0.008,0.34475,0.55927-0.032,0.42881-0.61-0.003-1.224-0.0761-1.8297,0.0331-0.22134-0.005-0.5324,0.13592-0.67395-0.10107-0.21466-0.41912,0.41715-0.22783,0.55717-0.46773,0.0897-0.27847-0.0644-0.55997-0.12956-0.83138-0.26816-0.90409-0.53726-1.8139-0.80484-2.7144zm1.3126,0.91741c0.0983,0.32687,0.55572,0.14918,0.80494,0.14415,0.29054-0.0294,0.45975-0.32567,0.39805-0.59836-0.075-0.44854-0.19181-0.94321-0.54745-1.2556-0.30615-0.22447-0.72127-0.2232-1.0797-0.16157-0.1535,0.12803-0.0127,0.3413,0.0189,0.50327,0.13493,0.45593,0.27113,0.91278,0.40527,1.3681z'/%3E %3Cpath d='m509.32,286.19c0.31224-0.0488,0.32571,0.29784,0.38442,0.50986,0.0709,0.28206,0.18743,0.55093,0.25681,0.83269-0.13482,0.25829-0.48808,0.0312-0.51432-0.2046-0.12875-0.2599-0.29229-0.58898-0.62453-0.60507-0.42769-0.0352-0.85882-0.0179-1.2866,0.005-0.23408,0.0833-0.0305,0.38309-0.008,0.5622,0.13486,0.45258,0.24983,0.91319,0.39766,1.3605,0.25857,0.00033,0.53808,0.008,0.77834-0.10389,0.28143-0.15885-0.11061-0.58931,0.1868-0.70182,0.37332-0.0818,0.36884,0.39384,0.426,0.63885,0.068,0.46738,0.29585,0.8879,0.40974,1.3417-0.12441,0.28166-0.53048,0.028-0.52429-0.22846-0.0805-0.2955-0.37283-0.45338-0.66666-0.44026-0.14063,0.0268-0.55645-0.12009-0.43577,0.13659,0.16066,0.52292,0.27429,1.0625,0.48729,1.5675,0.11003,0.29024,0.44075,0.36352,0.71812,0.3554,0.3983-0.007,0.85477,0.0615,1.1832-0.2172,0.26034-0.21419,0.0738-0.57422,0.14373-0.83477,0.25814-0.18142,0.52699,0.087,0.4865,0.3627,0.0504,0.34399,0.12514,0.68435,0.21332,1.0195-0.053,0.19462-0.29552,0.12713-0.44878,0.14399-1.0382,0.0236-2.077,0.0258-3.1147,0.0658-0.26829-0.0246-0.60747,0.15841-0.81792-0.0558-0.26364-0.37823,0.29767-0.30441,0.47311-0.46745,0.1894-0.22034,0.0327-0.51217-0.0246-0.75657-0.29628-1.0238-0.57846-2.0518-0.88432-3.0728-0.10036-0.30857-0.27116-0.6801-0.6367-0.72204-0.23665,0.0117-0.6103-0.0938-0.48481-0.40469,0.30107-0.10493,0.65561-0.003,0.97706-0.0349,0.98244-0.0168,1.9704-0.0371,2.9494-0.0525z'/%3E %3Cpath d='m476.5,299.32c-0.0934-0.36829-0.21694-0.84959-0.6443-0.94876-0.23667,0.006-0.64397-0.0622-0.49975-0.39344,0.30684-0.12338,0.67358-0.0278,1.003-0.0757,0.81944-0.0426,1.6529-0.24547,2.465-0.0271,1.1924,0.27335,2.2307,1.1874,2.5821,2.3689,0.22609,0.73058,0.26116,1.602-0.23082,2.237-0.51874,0.66626-1.4103,0.85237-2.2124,0.86219-0.6166-0.006-1.2373-0.0111-1.8449,0.1133-0.23578,0.14216-0.62923-0.0921-0.42203-0.35446,0.25782-0.0745,0.66966-0.1498,0.59153-0.51787-0.0949-0.51357-0.24249-1.0168-0.3601-1.5259-0.14236-0.57881-0.28538-1.1622-0.42733-1.7381zm1.6413,2.4389c0.0991,0.32378,0.13668,0.70991,0.40472,0.94539,0.27474,0.16116,0.61568,0.0966,0.91779,0.0711,0.46892-0.0634,0.81472-0.47881,0.8889-0.93115,0.14121-0.75838-0.0791-1.5356-0.37855-2.2291-0.2592-0.60261-0.79874-1.0799-1.4469-1.2138-0.37709-0.0769-0.77868-0.11418-1.1574-0.0394-0.0844,0.11562,0.0226,0.27276,0.0359,0.40346,0.24516,0.99783,0.49037,1.9957,0.7355,2.9935z'/%3E %3Cpath d='m485.2,297.33c0.31751-0.0599,0.3103,0.30394,0.36154,0.51419,0.0564,0.27571,0.15977,0.53983,0.21483,0.81525-0.12851,0.26041-0.48747,0.0612-0.50141-0.18582-0.11291-0.2546-0.26765-0.58408-0.59289-0.58558-0.42598-0.0187-0.85316,0.0187-1.2768,0.0589-0.2345,0.0864-0.049,0.38539-0.0319,0.56853,0.1139,0.45184,0.20726,0.91087,0.3345,1.3581,0.27365-0.0154,0.58483-0.006,0.81844-0.17075,0.21328-0.18819-0.13012-0.61637,0.20804-0.69169,0.37629-0.0458,0.30263,0.44717,0.36776,0.68698,0.0505,0.44535,0.25212,0.85205,0.34087,1.2876-0.1201,0.28437-0.53015,0.0584-0.51079-0.2098-0.0687-0.3233-0.40261-0.45182-0.70361-0.41733-0.14571,0.0204-0.49528-0.0733-0.37278,0.17365,0.13438,0.51618,0.22207,1.0468,0.41064,1.5469,0.0962,0.29139,0.4297,0.34951,0.69682,0.32934,0.41639-0.0214,0.90481,0.0215,1.2204-0.30646,0.24471-0.22532,0.0177-0.60203,0.17019-0.83264,0.29085-0.16695,0.48367,0.14183,0.44323,0.40792,0.0325,0.33023,0.0931,0.65735,0.16165,0.9806-0.0589,0.19934-0.30534,0.14109-0.46594,0.16517-1.0253,0.0667-2.0522,0.11211-3.0763,0.19516-0.2567-0.009-0.55177,0.15352-0.7803,0.0117-0.2579-0.27125,0.0945-0.40864,0.32475-0.43973,0.28961-0.0955,0.26016-0.44281,0.18662-0.67677-0.26272-1.0796-0.51185-2.1627-0.78379-3.24-0.0831-0.30026-0.23842-0.67663-0.5989-0.70188-0.2364,0.0282-0.60358-0.0817-0.46308-0.38846,0.29574-0.11893,0.6518-0.0314,0.97047-0.0755,0.97561-0.0585,1.9542-0.11668,2.9278-0.17758z'/%3E %3Cpath d='m491.69,301.43c0.0446,0.30912,0.28477,0.57044,0.59589,0.62091,0.23667,0.0983,0.60539-0.0382,0.73338,0.24268,0.0925,0.35055-0.38792,0.23525-0.59032,0.2514-0.57299-0.01-1.148-0.0211-1.7165,0.066-0.28534,0.0184-0.57319,0.0958-0.85811,0.0647-0.27732-0.11669-0.15-0.50142,0.14665-0.44363,0.26817-0.0588,0.63011-0.12887,0.70639-0.44099,0.0331-0.26867-0.079-0.52694-0.12588-0.78863-0.2154-0.92095-0.42177-1.8442-0.64295-2.7637-0.0304-0.32556-0.38717-0.33441-0.63464-0.29444-0.2285,0.009-0.58736,0.16253-0.66028-0.16279-0.0359-0.33806,0.46553-0.2687,0.67085-0.4065,0.36855-0.12678,0.732-0.27248,1.1066-0.37935,0.21164-0.0481,0.30106,0.1503,0.31907,0.32049,0.31649,1.3713,0.63402,2.7426,0.94986,4.1138z'/%3E %3Cpath d='m495.38,298.11c-0.0726-0.36321-0.27901-0.7858-0.68883-0.83918-0.29181-0.0554-0.67132,0.0288-0.77688,0.34277-0.11265,0.37317,0.0381,0.80935,0.36877,1.0224,0.27207,0.19826,0.59182,0.31183,0.89418,0.4538,0.0592-0.11868,0.24697-0.34967,0.23698-0.55858,0.0137-0.14055-0.007-0.28821-0.0342-0.4212zm0.83637,2.8932c-0.10281-0.48732-0.5702-0.7696-0.99649-0.94842-0.1846-0.0322-0.44459-0.27742-0.55824-0.17656-0.30832,0.268-0.45707,0.71405-0.32031,1.1068,0.11379,0.48284,0.47947,0.96037,1.0057,1.0009,0.3479,0.0459,0.75979-0.11009,0.86327-0.47412,0.0535-0.16421,0.0442-0.34228,0.006-0.50864zm0.88943-0.20863c0.13592,0.47897-0.0601,1.0199-0.47068,1.3005-0.58142,0.40047-1.3554,0.42767-2.016,0.23143-0.58667-0.17203-1.0812-0.66342-1.185-1.2762-0.12189-0.48865,0.0785-1.0449,0.51326-1.3111,0.10093-0.10012,0.48787-0.14045,0.17512-0.21569-0.49885-0.24496-0.98962-0.64525-1.0924-1.2224-0.12081-0.48733,0.10613-1.0354,0.55173-1.2747,0.85828-0.46833,2.0876-0.192,2.5834,0.67512,0.21739,0.36862,0.25955,0.86121-0.001,1.2206-0.1401,0.19397-0.32105,0.38958-0.56398,0.44303,0.48542,0.099,0.92759,0.39815,1.2228,0.79362,0.13902,0.18823,0.2327,0.40754,0.28275,0.63563z'/%3E %3Cpath d='m500.37,301.35c0.24295,0.009,0.50439-0.13521,0.54094-0.39284,0.0851-0.19635-0.0838-0.61545,0.25474-0.59164,0.30868,0.0197,0.27738,0.37878,0.30899,0.60186,0.0259,0.39781-0.002,0.87237-0.34408,1.1374-0.24853,0.15789-0.55805,0.0922-0.83593,0.0963-0.56166-0.0186-1.123-0.13696-1.685-0.0727-0.23517,0.024-0.49487,0.28626-0.71675,0.0978-0.19209-0.22319-0.077-0.51875-0.005-0.76428,0.19446-0.61516,0.62428-1.1173,1.0997-1.5381,0.33451-0.31284,0.71044-0.65162,0.76033-1.1362,0.0412-0.41146-0.0782-0.836-0.29245-1.1863-0.28303-0.45124-0.94979-0.60823-1.3988-0.32122-0.23138,0.14903-0.41348,0.49488-0.22791,0.74502,0.21074,0.16246,0.59983,0.0174,0.70201,0.35421,0.13004,0.23361-0.005,0.59858-0.30108,0.59523-0.44024,0.068-0.83814-0.27723-0.95201-0.68516-0.18088-0.51011,0.0211-1.1303,0.49487-1.4058,0.49942-0.31245,1.1347-0.30455,1.6897-0.16948,0.56589,0.13998,1.0426,0.57886,1.2146,1.1377,0.15369,0.43258,0.16049,0.93304-0.0813,1.336-0.37581,0.71765-1.149,1.0743-1.6571,1.6769-0.14278,0.15646-0.24423,0.37142-0.18553,0.5856,0.0763-0.20325,0.39739-0.13277,0.58205-0.16726,0.3472-0.0144,0.68867,0.0763,1.0351,0.067z'/%3E %3Cpath d='m504.31,300.93c0.038,0.30996,0.27363,0.57568,0.58352,0.63192,0.22828,0.10146,0.56734-0.0157,0.71536,0.22534,0.14451,0.345-0.33305,0.28338-0.53603,0.27056-0.59094-0.0206-1.184-0.0507-1.7725,0.0266-0.28688,0.0121-0.57763,0.0817-0.86298,0.0444-0.28059-0.1282-0.1302-0.49628,0.1579-0.43846,0.26995-0.0519,0.6339-0.11286,0.7198-0.42222,0.0384-0.26561-0.0671-0.52405-0.10789-0.7845-0.19476-0.9229-0.38014-1.848-0.58094-2.7695-0.0191-0.28415-0.3155-0.34607-0.54674-0.31214-0.23597-0.0262-0.56287,0.16536-0.71312-0.0926-0.1734-0.35216,0.34436-0.34537,0.5521-0.43795,0.40776-0.1253,0.80848-0.27728,1.2211-0.38452,0.21179-0.0436,0.29799,0.15464,0.31202,0.32504,0.28623,1.3726,0.57163,2.7456,0.85839,4.118z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='%23448127' stroke='%2334541f' stroke-width='0.2185'%3E %3Cpath fill='url(%23rg6)' stroke='%234c0505' d='m475.8,219.41-3.7712,4.4831c-1.1995,5.2399,1.782,9.187,7.6495,12.614,4.7523,2.9497,13.549,3.6886,16.327,1.311l-13.714-13.071-6.4917-5.3367z'/%3E %3Cpath d='m503.58,354.27c-0.67209-0.80996-1.352-1.6173-2.0351-2.424-8.5576,11.298-19.248,21.429-32.617,28.575,15.077-4.2692,24.945-15.257,34.652-26.151z'/%3E %3Cpath d='m488.14,389.98c5.3164-10.772,11.731-21.544,18.203-32.317-0.70661-0.87988-1.4224-1.7595-2.1441-2.6357-7.3517,12.186-15.979,26.679-16.059,34.952z'/%3E %3Cpath d='m529.87,275.48c-0.98453-4.2467-2.2704-8.8375-4.3089-13.055-2.6573-5.4313-6.6232-10.831-11.832-16.804-9.3826-10.173-18.771-19.997-31.926-27.251,0.0242-0.0465,0.0452-0.0913,0.0686-0.13743l0.0774,0.0459h0.16387l-0.16125-0.20036h0.47064l-0.25481-0.255h0.43698l-0.35199-0.4005h0.46124l-0.32861-0.32775h0.49248l-0.27312-0.36423,0.39767,0.0304-0.3721-0.38695,0.54798-0.10881-0.4442-0.27946,0.48047-0.0918-0.40334-0.27552,0.58557-0.18747-0.51587-0.30568,0.65243-0.28797-0.63167-0.45644,0.66794-0.22854-0.72584-0.29541,0.61244-0.32162-0.72125-0.13023,0.48899-0.56612-0.70202,0.0371,0.31965-0.59693-0.66706,0.0555c-0.0149-0.019-0.0286-0.0389-0.0444-0.0577l0.36576-0.44945-0.67514,0.12018,0.29693-0.61092-0.64958,0.32469,0.18528-0.70705-0.62774,0.43218,0.0953-0.71906-0.57901,0.4962,0.0601-0.68739-0.50996,0.53335,0.0457-0.72453-0.50275,0.61026-0.0503-0.71273-0.4029,0.56-0.20495-0.67624-0.33452,0.67624-0.17064-0.7171-0.3166,0.7171-0.15447-0.7171-0.27312,0.7171-0.20648-0.67624-0.21456,0.67624-0.15928-0.59431-0.24079,0.71535-0.22352-0.67449-0.24078,0.76976-0.29191-0.68782-0.12629,0.82241-0.35155-0.67231-0.0406,0.79357-0.38281-0.60239-0.0247,0.78746-0.40836-0.56809,0.0323,0.69088-0.43393-0.36488,0.2126,0.74375-0.52482-0.30589,0.19708,0.65177-0.43197-0.24209,0.15404,0.63123-0.39307-0.12585,0.2056,0.4702c-0.0103,0.0212-0.0192,0.043-0.0291,0.0642l-0.30392-0.0566,0.17414,0.36598,0.001,0.00066c-0.38411,1.0385-0.41405,2.2785-0.35112,3.5147,0.0116,0.23051,0.59365,0.46409,0.68542,0.60698,0.27617,0.42912,0.2257,0.66073,0.2257,0.66073-1.5913,2.5804-3.0146,4.5731-3.1749,7.5311,1.2786-1.6184,2.6036-3.5997,4.4608-3.5997-0.92008,1.5373-1.3562,6.1718-0.32315,6.8771l0.77107-1.352c0.0282,1.0748,0.1796,1.7914,0.38914,2.3215,0.32227-0.6498,0.6415-1.271,0.96268-1.7412,0.0734,1.5056,0.26678,2.7141,0.70334,3.3115,0.42934-0.74026,1.0088-1.191,1.6182-1.5705-0.21129,0.86-0.52024,1.6721-0.38914,2.7039,0.6439-1.1014,1.2887-1.7526,1.9324-2.5127-0.37297,1.5867-0.0336,2.771,0.41688,4.5222,0.40029-2.0757,0.55738-2.2959,1.5159-3.1699,0.10619,1.9033-0.25739,3.6323,0.1429,4.6941,0.87397-1.6752,1.46-1.4357,1.9826-2.5192-0.10204,1.5795-0.41908,3.291-0.014,4.7009,0.33627-1.4128,1.2435-2.169,1.9442-2.6707,0.0572,2.1987,0.56502,1.8369-0.80144,3.7017,0.57901,0.26504,2.5413-0.3769,3.6052-0.8329-0.51455,1.1781-0.36314,2.1024-0.87835,2.9359,1.08-0.54253,2.0001-1.4204,2.9014-2.3215-0.41776,1.352-1.5251,2.7041-0.96968,4.0559,0.25171-1.2633,1.2734-2.3036,2.2422-2.493-0.15033,0.70814-0.25215,2.1742-1.2725,2.8824,2.4428,0.25193,3.4068-1.3975,4.6367-2.7039-0.15885,1.358-0.11384,2.4434,1.5522,4.3553-0.3367-2.4308,0.24144-1.9306,1.3429-3.3924,0.53182,2.1482,1.1425,4.4302,3.3821,6.0143-0.9286-2.2669-1.1001-3.435-0.57355-4.8615,0.28841,1.4722,1.6844,3.2488,2.0189,4.6441,0.20779-1.5476,0.44158-3.0454,0.96269-4.0559,0.65155,1.7569,1.1974,3.5711,1.352,5.5989,0.48812-1.0108,0.88425-2.0353,1.1611-3.0862,19.736,20.623,24.137,46.84,2.5127,74.541,7.7703-5.2493,9.7757-13.569,14.093-20.662-4.2141,9.2876-6.0923,19.737-13.513,27.421,7.1876-6.2024,8.7118-11.885,13.034-17.862-4.6067,12.501-10.982,26.2-19.821,38.742,1.5705,1.7071,3.1413,3.4409,4.7182,5.1892,1.3715-2.2839,2.7423-4.5646,4.0966-6.8489,9.3688-15.436,24.658-37.5,16.913-71.147z'/%3E %3C/g%3E %3Cpath fill='%23eac102' stroke='%23a08307' stroke-width='0.2185' d='m473.16,215.29c-0.99699,0.22614-1.392,0.64238-2.1111,1.4429,0.91746,0.20014,1.6925,0.24603,2.5212,0.26416,0.25695-0.0225,0.34348-0.34784,0.28645-0.58491l-0.1276-0.95504c-0.0227-0.2174-0.6013-0.20014-0.87354-0.0863l0.30458-0.0808z'/%3E %3Cpath fill='%23a08307' d='m471.04,216.73c0.34544-0.12301,0.69831-0.21412,1.0532-0.29781,0.35549-0.0795,0.71273-0.15141,1.0776-0.19118-0.34566,0.12323-0.69853,0.21434-1.0531,0.29781-0.35593,0.0793-0.71317,0.1512-1.0776,0.19118z'/%3E %3Cellipse fill='%23000' stroke='%23000' stroke-width='0.0978' cx='477.680' cy='215.416' rx='0.775' ry='0.811'/%3E %3Cellipse fill='url(%23rg7)' cx='477.860' cy='215.261' rx='0.337' ry='0.353'/%3E %3Cg fill='%2334541f'%3E %3Cpath d='m488.18,389.69c0.46649-1.4941,0.9782-2.9744,1.5282-4.4402,0.55695-1.4628,1.1543-2.9112,1.7825-4.3461,1.2594-2.8686,2.663-5.6715,4.1352-8.4348,1.4886-2.7554,3.0474-5.4726,4.6631-8.1534,0.80864-1.3405,1.6276-2.6744,2.4537-4.0037l2.5101-3.9674-2.4192,4.0234c-0.8069,1.3409-1.6092,2.6838-2.4004,4.0336-1.5845,2.6984-3.1439,5.4112-4.6153,8.1708-1.4864,2.7517-2.8844,5.5506-4.1741,8.3996-0.64565,1.4242-1.2594,2.8632-1.8362,4.3166-0.58273,1.451-1.1276,2.9182-1.6276,4.4016z'/%3E %3Cpath d='m469.34,380.23c1.6549-0.73392,3.2842-1.5249,4.8812-2.3748,1.6002-0.84273,3.1699-1.7436,4.7022-2.7047,3.0653-1.9177,5.9902-4.0605,8.733-6.4165,2.755-2.3416,5.3276-4.8938,7.7616-7.5693,1.2188-1.3365,2.4004-2.7074,3.5549-4.1014,1.1591-1.389,2.2892-2.8042,3.3991-4.2342-1.0818,1.4521-2.1841,2.8892-3.3163,4.3019-1.1377,1.4091-2.3071,2.7935-3.5125,4.1464-2.4128,2.703-4.993,5.2614-7.745,7.6231-2.762,2.3488-5.6942,4.5006-8.7863,6.3927-1.5465,0.94521-3.128,1.8325-4.7416,2.6569-1.6162,0.8187-3.2617,1.578-4.9303,2.28z'/%3E %3Cpath d='m506.62,350.89c0.7691-1.0741,1.4855-2.1863,2.2016-3.2962,0.71557-1.1104,1.4156-2.2315,2.0984-3.362,1.3678-2.2605,2.6897-4.549,3.9591-6.866,1.2854-2.3086,2.5208-4.6456,3.7507-6.9846l3.6773-7.0268-1.7453,3.5612-1.7825,3.5429c-1.1991,2.356-2.4367,4.6937-3.709,7.0128-1.2876,2.3104-2.608,4.6032-4.0078,6.8485-1.4054,2.2396-2.8529,4.4573-4.4424,6.5701z'/%3E %3Cpath d='m512.51,325.78c1.7073-2.0313,3.2774-4.177,4.6917-6.42,1.4237-2.2365,2.694-4.5696,3.8103-6.9735,2.235-4.8099,3.8411-9.8941,4.9751-15.071,0.14377-0.64674,0.28251-1.2948,0.41361-1.9439,0.10881-0.64631,0.20516-1.3064,0.29365-1.9619,0.17589-1.3132,0.31027-2.6316,0.40029-3.9534,0.18004-2.6431,0.17829-5.2998-0.0299-7.9416-0.20604-2.6425-0.62271-5.2675-1.2397-7.8455-0.60676-2.5811-1.4185-5.1136-2.403-7.578,1.0173,2.4511,1.8644,4.9751,2.5072,7.5525,0.63319,2.5798,1.0608,5.2107,1.2802,7.8588,0.22111,2.6484,0.23553,5.3131,0.0666,7.9654-0.0837,1.3263-0.21304,2.6495-0.38281,3.9674-0.0859,0.66007-0.17785,1.3142-0.28688,1.9763-0.12891,0.65155-0.26285,1.302-0.40618,1.9509-1.16,5.1834-2.7939,10.274-5.0566,15.084-1.1314,2.4043-2.4128,4.7378-3.8527,6.9696-1.4464,2.2289-3.0462,4.3555-4.7809,6.3636z'/%3E %3Cpath d='m510.87,320.07c1.8434-1.7624,3.4714-3.7408,4.898-5.8493,1.4364-2.1034,2.682-4.3328,3.795-6.6232,1.1143-2.2907,2.0984-4.6426,3.0272-7.015,0.4643-1.1866,0.91527-2.3788,1.3612-3.5728l0.33233-0.89605c0.10619-0.29584,0.20189-0.59933,0.29409-0.90369,0.1866-0.60851,0.35549-1.2238,0.57792-1.8297l-0.005,0.0168c0.50647-2.5236,0.7785-5.0946,0.8104-7.67,0.0323-2.5752-0.17064-5.1528-0.57136-7.6976-0.39985-2.5461-0.99568-5.0603-1.7314-7.5315-0.72541-2.4749-1.5926-4.9087-2.5538-7.3038,0.99393,2.3816,1.8952,4.8038,2.656,7.2724,0.7514,2.4714,1.3588,4.9882,1.7722,7.5396,0.41405,2.5507,0.63123,5.1364,0.61026,7.7233-0.0205,2.5861-0.27771,5.1718-0.78003,7.7102l-0.002,0.008-0.003,0.009c-0.2198,0.59081-0.39263,1.2054-0.58207,1.8148-0.0948,0.30502-0.19074,0.60982-0.30174,0.91331l-0.33801,0.89539c-0.45097,1.1928-0.90763,2.3831-1.3789,3.5693-0.94193,2.3707-1.9387,4.7214-3.0666,7.0124-1.1266,2.2896-2.3833,4.5202-3.8374,6.6193-1.4589,2.0934-3.1164,4.0522-4.9841,5.789z'/%3E %3Cpath d='m505.05,349.23c1.2017-1.6588,2.3886-3.3274,3.5733-4.9985l1.7774-2.5064c0.58972-0.83771,1.2076-1.6544,1.7331-2.5315,1.068-1.7445,1.9896-3.5748,2.8979-5.4095,0.90086-1.8393,1.8196-3.67,2.7089-5.5139,1.7816-3.6867,3.5053-7.405,4.9673-11.228,1.4681-3.8197,2.6228-7.7566,3.4511-11.763,0.84667-4.0033,1.4158-8.062,1.8854-12.129,0.42585-4.0649,0.47108-8.1798,0.0376-12.248-0.4289-4.0688-1.3617-8.0802-2.7253-11.939-1.3503-3.8647-3.1153-7.5772-5.0975-11.16,2.0134,3.565,3.8121,7.2632,5.1982,11.124,1.38,3.8608,2.3261,7.88,2.7692,11.959,0.44638,4.0791,0.41426,8.2025-0.001,12.284-0.45797,4.0716-1.0149,8.1374-1.8528,12.153-0.84208,4.0144-2.0126,7.9611-3.4946,11.784-1.477,3.8267-3.2134,7.5427-5.0066,11.226-0.89626,1.8428-1.8196,3.6705-2.7268,5.5067-0.91418,1.833-1.8406,3.6644-2.92,5.4095-0.53597,0.87748-1.1624,1.6912-1.7587,2.5221l-1.7986,2.4904c-1.2,1.6612-2.4008,3.3205-3.6172,4.9686z'/%3E %3Cpath d='m507.81,352.25c2.3617-3.8352,4.7108-7.6786,6.954-11.583,2.2498-3.9006,4.4831-7.8142,6.4653-11.856,1.9857-4.0378,3.7011-8.2136,4.9972-12.523,0.65002-2.153,1.2008-4.3362,1.6525-6.5396,0.22921-1.1023,0.42716-2.2068,0.59322-3.3192,0.17108-1.1126,0.32905-2.2262,0.47195-3.3423,0.58163-4.4617,0.92816-8.957,0.92226-13.457-0.005-4.4977-0.36576-9.0013-1.1982-13.424-0.82963-4.4206-2.141-8.756-3.9768-12.865-1.8218-4.114-4.1706-7.9958-6.9573-11.533,2.8149,3.5158,5.1965,7.3818,7.055,11.49,1.8533,4.1105,3.1776,8.4531,4.022,12.882,0.84623,4.4296,1.2196,8.943,1.2376,13.45,0.0184,4.5097-0.31529,9.0155-0.88797,13.486-0.14639,1.1167-0.3072,2.2328-0.48178,3.3458-0.16846,1.1139-0.37166,2.226-0.60392,3.3281-0.4584,2.2077-1.0169,4.3942-1.6741,6.5505-1.311,4.3161-3.0419,8.4962-5.0411,12.534-1.9964,4.0417-4.2384,7.9528-6.5033,11.846-2.2756,3.8892-4.6546,7.7142-7.0465,11.53z'/%3E %3Cpath d='m480,220.77c0.47435-0.012,0.94871,0.0402,1.4176,0.11275,0.46932,0.0736,0.9345,0.17392,1.3946,0.29409,0.91877,0.24559,1.815,0.57224,2.6864,0.95373,1.7429,0.76757,3.3718,1.774,4.9008,2.9029,1.5188,1.1449,2.9398,2.4161,4.2558,3.7854,0.65702,0.68563,1.2917,1.392,1.9038,2.117,0.60654,0.72956,1.1976,1.4718,1.7584,2.2363-0.59977-0.73415-1.2065-1.4617-1.8393-2.1664-0.62729-0.70923-1.2738-1.4008-1.9431-2.0696-1.3352-1.3394-2.7469-2.6042-4.2661-3.7282-1.5085-1.1362-3.1253-2.1314-4.8388-2.9252-0.8565-0.39701-1.7396-0.73851-2.6464-1.0038-0.90544-0.26548-1.8362-0.47217-2.7838-0.5091z'/%3E %3C/g%3E %3Cg fill='%23448127'%3E %3Cpath d='m496.38,231.57s3.0589,1.7982,4.7254,4.4385c0,0-4.7173-0.8825-8.0699-4.6513'/%3E %3Cpath fill='%2334541f' d='m496.38,231.57c0.47872,0.26111,0.93253,0.56612,1.3794,0.88032,0.44136,0.32184,0.86939,0.66269,1.2804,1.0245,0.41208,0.36074,0.79663,0.75271,1.1609,1.1628,0.36183,0.4123,0.7029,0.84623,0.9959,1.3132l0.13634,0.21719-0.24755-0.0535c-0.78418-0.16955-1.5345-0.42016-2.2728-0.71185-0.73611-0.29409-1.4539-0.63582-2.1371-1.0376-1.3693-0.7951-2.6232-1.7997-3.6397-3.008,1.0804,1.1493,2.3482,2.1072,3.7203,2.8658,0.68825,0.37603,1.3979,0.71251,2.1286,0.99699,0.72934,0.28186,1.482,0.52504,2.2404,0.68279l-0.111,0.16366c-0.28907-0.45382-0.61157-0.88775-0.96465-1.2966-0.35091-0.41099-0.73415-0.79379-1.1255-1.1681-0.39285-0.37319-0.8045-0.72737-1.2308-1.0636-0.42257-0.34217-0.86131-0.66357-1.3132-0.96794z'/%3E %3Cpath d='m489.58,230.69s7.2265,4.6109,8.2733,4.9782c0,0-1.6083-3.4784-5.0488-4.9721'/%3E %3Cpath fill='%2334541f' d='m489.58,230.69,4.1403,2.4878c0.68716,0.41886,1.3759,0.83487,2.0689,1.2428,0.34676,0.20364,0.69438,0.40553,1.0444,0.60174,0.34719,0.19402,0.70202,0.40508,1.0538,0.5482l-0.12848,0.14115c-0.25695-0.52964-0.57791-1.0414-0.92401-1.526-0.35047-0.48331-0.72759-0.9487-1.1423-1.3796-0.41361-0.43218-0.86589-0.82656-1.3462-1.1842-0.48025-0.35877-0.99895-0.66553-1.5421-0.92554,0.56022,0.22133,1.0938,0.51215,1.5957,0.84951,0.50275,0.33713,0.96683,0.73064,1.3997,1.1543,0.43197,0.42519,0.83247,0.88316,1.189,1.3739,0.35746,0.49139,0.68433,0.99983,0.95832,1.5509l0.1241,0.24952-0.25258-0.10815c-0.76801-0.32927-1.4368-0.75774-2.1351-1.1676-0.69066-0.41514-1.3763-0.83792-2.0602-1.2638-1.3588-0.86436-2.7124-1.7375-4.0432-2.6449z'/%3E %3Cpath d='m492.46,228.36s3.7596,1.5992,4.6111,4.3791c0,0-6.7528-2.8409-7.9617-4.3491'/%3E %3Cpath fill='%2334541f' d='m492.46,228.36c0.50778,0.19927,0.99218,0.45534,1.4646,0.73065,0.46779,0.2836,0.91789,0.59824,1.34,0.95089,0.42257,0.35155,0.80669,0.75206,1.1399,1.1941,0.32993,0.44311,0.60764,0.93559,0.76954,1.4718l0.0673,0.22243-0.21238-0.0913c-0.69984-0.30087-1.3925-0.61332-2.0822-0.93429-0.68914-0.32162-1.3754-0.65002-2.0495-1.0031-0.6745-0.35177-1.344-0.71447-1.9942-1.1113-0.32359-0.20058-0.64281-0.40902-0.95023-0.63407-0.30502-0.22636-0.60894-0.46496-0.84361-0.76561,0.25171,0.28558,0.56438,0.5056,0.87573,0.71951,0.31485,0.21084,0.64085,0.40487,0.97077,0.59081,0.65898,0.37471,1.3337,0.7219,2.0152,1.0544,1.3643,0.66204,2.7443,1.2976,4.142,1.8847l-0.14508,0.13109c-0.15688-0.50669-0.4088-0.98388-0.72475-1.4158-0.31419-0.43437-0.69197-0.8211-1.0909-1.1836-0.40072-0.36139-0.83334-0.68913-1.2861-0.98759-0.44922-0.30458-0.91986-0.57836-1.406-0.82373z'/%3E %3Cpath d='m486.76,231.25s6.6462,4.7577,8.6126,4.7577c0,0-1.9477-3.258-5.3876-4.7516'/%3E %3Cpath fill='%2334541f' d='m486.76,231.25c0.68826,0.45622,1.3794,0.90785,2.0761,1.3499,0.69459,0.44529,1.3955,0.8801,2.1061,1.2981,0.70661,0.42344,1.4224,0.83268,2.1565,1.2013,0.36729,0.18354,0.73938,0.35724,1.1191,0.50538,0.37668,0.14574,0.77063,0.28863,1.1547,0.29978l-0.0891,0.15666c-0.31376-0.50582-0.68236-0.99022-1.0704-1.4497-0.39198-0.45774-0.80472-0.8991-1.2476-1.3094-0.44158-0.41143-0.91528-0.78811-1.4106-1.1346-0.49532-0.34719-1.0221-0.64915-1.5699-0.9109,1.1296,0.4501,2.1657,1.1285,3.0812,1.9337,0.45884,0.40246,0.89343,0.83399,1.2913,1.2974,0.39897,0.46386,0.77281,0.94433,1.104,1.467l0.10247,0.16147-0.19118-0.005c-0.44617-0.0107-0.84361-0.15797-1.2345-0.30371-0.38826-0.15557-0.76342-0.33495-1.1329-0.52373-0.73829-0.37909-1.4532-0.79663-2.1587-1.2282-0.70136-0.43874-1.3916-0.89386-2.0744-1.3588-0.68039-0.46976-1.3544-0.94761-2.0123-1.4469z'/%3E %3Cpath d='m486.76,232.74s3.4605,2.9195,5.427,2.9195c0,0-1.9477-3.2578-5.3876-4.7514'/%3E %3Cpath fill='%2334541f' d='m486.76,232.74c0.41754,0.31179,0.84077,0.61463,1.2716,0.90479,0.42868,0.29365,0.86655,0.57333,1.3153,0.83159,0.44507,0.26394,0.90194,0.50865,1.3759,0.70792,0.23663,0.0994,0.47806,0.18638,0.72343,0.25214,0.24362,0.0688,0.49336,0.11712,0.74092,0.11952l-0.0892,0.15666c-0.31376-0.50581-0.68236-0.99022-1.0704-1.4495-0.3922-0.45775-0.80472-0.89911-1.2476-1.3094-0.44179-0.41143-0.91527-0.78811-1.4106-1.1346-0.49533-0.34719-1.0223-0.64893-1.5699-0.91091,1.1296,0.4501,2.1655,1.1285,3.0812,1.9337,0.45884,0.40247,0.89342,0.83378,1.2913,1.2974,0.39897,0.46387,0.77282,0.94434,1.1041,1.467l0.0996,0.15732-0.18834-0.00044c-0.55083-0.00087-1.0634-0.18004-1.5456-0.38848-0.48353-0.21172-0.94325-0.4667-1.3896-0.74048-0.44223-0.28076-0.86983-0.58141-1.2876-0.89495-0.4147-0.31769-0.82045-0.64653-1.2046-0.99918z'/%3E %3Cpath d='m485.03,226.18s7.2073,5.1165,8.0592,7.8964c0,0-6.5225-2.9945-7.7314-4.5025'/%3E %3Cpath fill='%2334541f' d='m485.03,226.18c0.78614,0.53378,1.5482,1.1019,2.304,1.6785,0.75031,0.58382,1.4879,1.1842,2.2053,1.8098,0.71754,0.62512,1.4075,1.2839,2.0536,1.9872,0.32185,0.35287,0.63123,0.71863,0.912,1.1091,0.27618,0.39176,0.54034,0.8045,0.68738,1.2799l0.0719,0.23292-0.22024-0.10335c-0.67974-0.31857-1.3525-0.64784-2.0224-0.98519-0.66925-0.3378-1.3352-0.68193-1.9892-1.0496-0.65439-0.3662-1.3038-0.74245-1.9339-1.1506-0.31354-0.20604-0.62293-0.4193-0.92074-0.64784-0.29584-0.22942-0.5895-0.47086-0.82023-0.76735,0.24756,0.28164,0.55083,0.50494,0.85344,0.72212,0.30546,0.21456,0.62184,0.41361,0.94237,0.60545,0.63953,0.3863,1.2946,0.74703,1.9566,1.0944,1.3252,0.69175,2.665,1.3601,4.0236,1.9826l-0.14814,0.12957c-0.14006-0.43284-0.38411-0.83859-0.65286-1.221-0.27094-0.3828-0.57311-0.74572-0.8884-1.0968-0.63167-0.70268-1.3208-1.354-2.0193-1.9938-0.70071-0.63822-1.4235-1.2533-2.1594-1.8522-0.73152-0.60414-1.4794-1.1888-2.2354-1.7639z'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%2324420e' stroke-width='0.1639'%3E %3Cpath fill='%23406325' d='m445.02,370.33c-4.8888,3.644-18.553,5.4292-20.448,4.8005,9.9428-8.2718,19.725-8.471,20.448-4.8005z'/%3E %3Cpath fill='%23406325' d='m514.78,374.77c5.2537,4.768,21.104,8.0531,23.475,7.4607-10.542-10.77-22.102-11.863-23.475-7.4607z'/%3E %3Cpath fill='%2367923d' d='m444.98,370.3c-0.72081-3.6709-10.458-3.4489-20.378,4.775,10.446-3.4422,19.238-5.4047,20.378-4.775z'/%3E %3Cpath fill='%2367923d' d='m514.89,374.71c1.3715-4.4018,12.794-3.338,23.364,7.4616-11.884-5.021-21.947-8.0983-23.364-7.4616z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='820' height='440'%3E %3Crect fill='%23c62139' width='820' height='440'/%3E %3Crect fill='%2300297b' width='780' height='400' x='20' y='20'/%3E %3Cg%3E %3Cpath fill='%23c62139' d='M410.25782,100.00041C410.25782,100.00041 330.00038,154.71073 330.00038,219.22153C330.00038,283.74266 410.25782,340.00123 410.25782,340.00123C410.25782,340.00123 490.00057,288.38227 490.00057,219.22153C490.00057,150.06596 410.25782,100.00041 410.25782,100.00041'/%3E %3Cpath fill='%2366afeb' d='M477.92277,240.56171C479.68326,233.69776 480.68341,226.5706 480.68341,219.22153C480.68341,157.29117 410.25782,111.35948 410.25782,111.35948C410.25782,111.35948 338.80284,158.84459 338.80284,219.22153C338.80284,226.47255 339.82054,233.53777 341.61613,240.38108L477.92277,240.56171'/%3E %3Cpath fill='%23007bde' d='M409.67295,328.12609C409.67295,328.12609 464.90916,291.54588 477.89938,240.38108L341.56349,240.38108C354.75257,290.56016 409.67295,328.12609 409.67295,328.12609'/%3E %3Cpath fill='%239c8431' d='M480.33833,226.4519C468.25468,235.06023 400.2505,230.92637 400.2505,230.92637L396.44877,240.56171L477.91692,240.56171C478.25615,239.24053 478.56615,237.91934 478.84689,236.58268L480.33833,226.4519'/%3E %3Cg fill='%23fff100'%3E %3Cpath d='M406.07592,287.35526C405.04068,280.14553 373.23483,272.42488 356.35514,273.05967C361.62492,281.32737 367.59656,288.8932 373.6033,295.6178C382.17767,286.41598 406.41515,289.73442 406.07592,287.35526'/%3E %3Cpath d='M470.45384,260.54973C466.4123,260.69424 459.07789,261.33935 454.05376,263.9559C446.80708,267.73882 430.58246,271.87267 423.32993,269.80316C416.08324,267.73882 404.68975,274.27763 406.07592,275.65042C408.3745,277.94701 425.05533,275.3098 425.05533,290.106C425.05533,302.49207 405.73084,296.99059 398.13323,302.15146C393.5536,305.25314 390.36015,308.62318 388.54703,310.79074C400.40842,321.7679 409.69634,328.12609 409.69634,328.12609C409.69634,328.12609 431.71713,313.54148 451.21708,289.92537L460.38802,277.75605C464.08448,272.34231 467.51188,266.59827 470.45384,260.54973'/%3E %3C/g%3E %3Cg fill='%23009270'%3E %3Cpath d='M405.85951,165.16664C405.85951,165.16664 394.85205,158.71556 379.83814,161.80692C364.82422,164.90344 361.58399,174.31686 361.58399,174.31686L366.63151,171.99963L366.76019,174.06397L371.29302,171.2255L371.42169,173.28984L375.3053,169.6824L375.94283,171.99963L379.44041,168.90311L379.70361,170.58039L385.39451,166.96779L385.39451,169.29017L389.92734,167.22067L389.54132,169.4192L398.08645,167.8761C398.08645,167.8761 377.89048,174.58006 375.3053,190.70776L379.18307,186.0733L379.57494,188.25635L382.03144,183.35869L382.68066,185.29401L384.87981,180.77826L385.52319,183.48255L388.88626,178.57973L389.14946,181.42337L393.02722,176.13348L393.02722,178.70359L397.17403,174.18783L397.04535,177.55272C397.04535,177.55272 401.05764,174.18783 402.34438,174.18783L397.56005,180.38603L399.11584,180.90212C399.11584,180.90212 395.74692,183.61157 395.48957,184.12766C395.23222,184.63858 397.69457,184.12766 397.69457,184.12766C397.69457,184.12766 394.71168,187.21902 394.583,188.12733C394.45433,189.03564 396.5248,188.12733 396.5248,188.12733C396.5248,188.12733 393.80511,191.60575 393.41909,192.90629C393.02722,194.1965 394.84034,193.15917 394.84034,193.15917C394.84034,193.15917 393.16174,197.28786 393.02722,198.44906C392.89854,199.59993 394.96902,198.18585 394.96902,198.18585L396.13879,205.28204L398.20926,196.77694L399.50185,198.71226L399.50185,192.64308L400.66576,193.6701L400.5371,189.68075L402.08704,191.22385L401.31499,186.32103L402.9936,188.24603L402.73625,184.12766L404.41486,185.8101L404.41486,180.38603L405.97065,181.79495L406.228,178.0688L408.04112,178.96679C408.04112,178.96679 408.29847,174.45104 410.3748,174.58006C412.43943,174.69876 415.03046,176.89729 413.99522,177.9243L415.80835,177.4237L415.42233,181.79495L417.10094,180.76794L416.84359,183.99348L418.26485,183.34837L417.75016,187.4719L419.43462,186.45521L419.55744,191.47157L421.4934,190.06265L421.36472,195.98732L423.30653,194.44939L423.30653,199.34705L425.11967,198.06715L427.06732,202.83579L426.67546,195.7396L428.10257,196.89564L425.50568,191.86895L427.45334,191.60575L425.37701,188.24603L427.31882,188.39053L424.4763,185.03081L426.41226,184.64891L422.13676,181.54723L424.47045,180.64924L420.06629,177.8056L421.75075,177.16049L418.65088,173.93495L421.88527,175.22517L422.91466,173.16082L426.79827,176.2625L426.79827,173.16082L430.16134,177.8056L430.55322,174.96196L433.14424,178.57973L433.65894,176.90761L435.47207,180.51505L436.37279,177.81592L438.18591,181.68657L438.70061,178.96679L440.38507,183.22967L441.94086,181.54723L442.71875,185.93912L444.26284,184.25668L445.6841,188.12733L447.49723,186.70809L449.05302,191.09999C449.05302,191.09999 453.32265,167.61289 416.69152,167.22067L405.81858,165.16664'/%3E %3Cpath d='M389.03248,144.25998L391.0971,146.83009L390.06187,147.61455L393.55946,149.54987L392.78156,150.96395L396.27916,152.25416L394.98072,153.2915L398.09228,155.08748L396.02181,155.74291L399.7709,157.54405L399.25621,159.21617L402.49059,159.99546L401.06933,161.15149L404.81843,164.12931L409.09391,167.09165L412.07096,166.06463L410.9012,160.37736C410.9012,160.37736 398.60698,143.60455 389.03248,144.24966'/%3E %3Cpath d='M400.29144,128.00326L401.71855,131.3475L399.7709,131.73973L404.17505,136.12646L400.67747,136.25548L404.95295,139.60489L402.87662,140.26031L406.76609,144.13096L404.68975,145.15797L408.70204,149.15764L405.98819,150.18466L410.52102,154.31851L407.93,154.45269L410.64385,157.92595L408.18735,158.70524C408.18735,158.70524 411.1644,164.24801 411.02986,166.57556L416.0774,166.82844C416.0774,166.82844 416.85528,151.86194 416.21192,149.92661L414.91348,150.82976L415.29951,145.41086L413.3577,146.57721L412.97752,140.12613L411.02986,142.18532L410.52102,135.86326L409.09391,138.06179L407.6668,131.86359L406.11686,133.79891L404.68975,129.8044L403.52584,131.3475L400.29144,127.99294'/%3E %3Cpath d='M413.36355,165.67757C414.79066,156.64606 424.24235,143.48585 441.97595,142.96977L437.95781,145.03411L440.2915,146.06629L435.62999,147.74873L437.95781,149.15764L432.39559,149.54987L435.23812,151.48519L431.103,152.00128L427.86276,152.64639L430.19058,154.83459L425.52909,155.34552L428.51198,156.89894C428.51198,156.89894 421.13078,159.47937 420.61608,160.25866C420.61608,160.25866 445.47354,153.9366 451.55631,165.66725L446.76028,163.6029L447.15216,165.80143L443.78908,163.35002L444.30378,165.15632L440.81204,163.35002L441.32674,165.53823L437.70046,163.47388L438.47836,165.41953L433.81685,163.221L434.59474,165.28534L430.58246,163.99513L430.97433,166.18333L426.9562,165.93045L427.34806,168.51088L414.91933,168.24768L413.36355,165.66725'/%3E %3C/g%3E %3Cg fill='%237b4800'%3E %3Cpath d='M409.56767,173.46015L412.15869,173.28984C410.94798,197.89684 412.08262,233.17651 415.43403,246.23866C421.12493,268.42521 437.71802,276.9716 441.66597,279.09788C443.90606,280.2952 443.04628,285.28575 438.5544,284.94514C434.0742,284.59936 418.41693,273.06999 413.01262,252.42653C405.77178,224.72818 409.28692,176.34508 409.56767,173.46015'/%3E %3Ccircle cx='413.755' cy='168.129' r='2.926'/%3E %3Ccircle cx='409.094' cy='167.092' r='2.739'/%3E %3Ccircle cx='409.094' cy='171.871' r='2.558'/%3E %3Ccircle cx='412.586' cy='170.58' r='2.739'/%3E %3C/g%3E %3Cg fill='%237b4800'%3E %3Cpath fill='%23000' d='M384.64001,257.16421L387.56442,257.16421L387.56442,225.68294L384.64001,225.68294L384.64001,257.16421z'/%3E %3Cpath d='M394.13849,263.0992C394.13849,263.0992 392.93949,263.3108 391.03277,263.55336L391.03277,261.09678L389.09097,261.09678L389.09097,263.76495C387.10236,263.96623 384.69266,264.13137 382.16596,264.13137C379.48136,264.13137 376.77336,263.93526 374.53911,263.70818L374.53911,261.16388L372.39844,261.16388L372.39844,263.46562C370.55022,263.23338 369.35706,263.03211 369.35706,263.03211C369.35706,263.03211 368.77218,266.25765 381.97881,266.25765C395.17957,266.25765 394.14434,263.0992 394.14434,263.0992'/%3E %3Cpath d='M381.60448,257.07131C392.30781,257.07131 401.28575,255.3579 401.28575,255.3579C401.28575,255.3579 402.66021,262.23217 381.60448,262.23217C360.54874,262.23217 362.27415,256.39008 362.27415,256.39008C362.27415,256.39008 370.90699,257.07131 381.60448,257.07131'/%3E %3Cpath fill='%23fff' d='M372.62655,227.47892C372.62655,227.47892 389.19624,233.67711 395.75861,255.3579C395.75861,255.3579 380.56924,252.26655 371.93638,255.70368L367.10526,255.70368C367.10526,255.69293 375.39303,243.65823 372.62655,227.47892'/%3E %3C/g%3E %3Cg fill='%23c62139'%3E %3Cpath d='M374.97192,211.16026L371.90129,211.16026C371.66149,209.83908 371.08246,208.91013 370.16419,208.3992C369.6495,208.10503 369.08216,207.96569 368.45634,207.96569C367.24564,207.96569 366.26304,208.53855 365.49099,209.72038C364.7131,210.88674 364.32708,212.66208 364.32708,215.01027C364.32708,217.38943 364.74819,219.06155 365.58458,220.06276C366.42095,221.03816 367.37431,221.5336 368.44465,221.5336C369.49158,221.5336 370.34551,221.14654 371.01812,220.36209C371.68489,219.58796 372.09431,218.56094 372.25807,217.28621L368.79557,217.28621L368.79557,214.07099L375.01871,214.07099L375.01871,224.42369L372.95408,224.42369L372.63825,222.01356C372.03582,222.9322 371.49773,223.5773 371.01812,223.95921C370.19344,224.61464 369.1816,224.93977 367.97674,224.93977C365.99984,224.93977 364.37387,224.0521 363.11637,222.27677C361.80039,220.50143 361.13947,218.0655 361.13947,214.9793C361.13947,211.85698 361.80624,209.34364 363.13977,207.45993C364.4616,205.57621 366.22209,204.63693 368.41541,204.63693C370.31041,204.63693 371.83696,205.2614 372.98917,206.50517C374.13554,207.74377 374.80231,209.29719 374.97192,211.16026'/%3E %3Cpath d='M389.58811,216.9972L389.58811,205.13238L392.75817,205.13238L392.75817,216.9972C392.75817,218.31838 392.88685,219.28346 393.12664,219.89761C393.50682,220.97623 394.32565,221.52328 395.6007,221.52328C396.85819,221.52328 397.68288,220.97623 398.06304,219.89761C398.3087,219.28346 398.41982,218.31838 398.41982,216.9972L398.41982,205.13238L401.59573,205.13238L401.59573,216.9972C401.59573,219.0409 401.35008,220.63561 400.85878,221.78648C399.93467,223.87147 398.18587,224.91913 395.59485,224.91913C393.00966,224.91913 391.24918,223.88179 390.32506,221.78648C389.83377,220.64593 389.58811,219.0409 389.58811,216.9972'/%3E %3Cpath d='M423.125 205.125L417.78125 224.4375L421.0625 224.4375L422.09375 220.46875L427.59375 220.46875L428.5625 224.4375L431.9375 224.4375L426.625 205.125L423.125 205.125z M424.84375 209.53125L426.71875 217.125L422.9375 217.125L424.84375 209.53125z'/%3E %3Cpath d='M451.65574,220.30015L454.35204,205.13238L458.83808,205.13238L458.83808,224.42369L455.93122,224.42369L455.93122,211.38218C455.93122,211.00028 455.93704,210.47387 455.94297,209.7978C455.94879,209.12172 455.95472,208.60048 455.95472,208.23922L453.12389,224.42369L450.09422,224.42369L447.28678,208.23922C447.28678,208.60048 447.2926,209.12172 447.29853,209.7978C447.30435,210.47387 447.31028,211.00028 447.31028,211.38218L447.31028,224.42369L444.40342,224.42369L444.40342,205.13238L448.9421,205.13238L451.65595,220.30015'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600' viewBox='-2 -3 12 6'%3E %3Crect x='-2' y='-3' width='4' height='6' fill='%23ce1126'/%3E %3Crect x='2' y='-3' width='8' height='3' fill='%23fcd116'/%3E %3Crect x='2' width='8' height='3' fill='%23009e49'/%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-1 v 1 h .5' transform='rotate(18 0,-1)' fill='%23000'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/svg%3E"

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='500' height='300'%3E %3Crect width='500' height='300' fill='%23009e49'/%3E %3Cpath d='M 0,0 L 500,150 L 0,300 z' fill='%23fff'/%3E %3Cpath d='M 0,13.05 L 456,150 L 0,286.95 z' fill='%23fcd116'/%3E %3Cpath d='M 0,0 L 250,150 L 0,300 z' fill='%23000'/%3E %3Cpath d='M 0,17.5 L 220.85,150 L 0,282.5 z' fill='%23ce1126'/%3E %3C/svg%3E"

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23de2910'/%3E %3Cg id='petal'%3E %3Cpath d='m 449.96406,299.9134 c -105.26305,-44.48626 -58.60174,-181.58185 42.06956,-174.6907 -20.36609,10.46694 -23.31775,29.99772 -11.68704,48.09021 13.02444,20.2558 -1.19897,52.84856 -18.80577,60.7674 -28.93485,13.02443 -34.72791,47.74999 -11.57675,65.83309 z' fill='%23fff'/%3E %3Cpath d='m 444.27188,200.91974 -5.91976,9.29378 -2.14454,-10.8142 -10.67812,-2.75928 9.62461,-5.3895 -0.67104,-10.99955 8.08542,7.48945 10.25578,-4.04271 -4.61053,10.00942 7.00143,8.50541 z' fill='%23de2910'/%3E %3Cpath d='m 450.56002,298.75902 c -12.73114,-6.53451 -22.9963,-20.15491 -27.46839,-36.43134 -5.11498,-18.66969 -2.17269,-38.74247 8.08308,-55.03768 l -2.20789,-1.39371 c -10.64057,16.92871 -13.69313,37.74293 -8.38575,57.11886 4.72784,17.22201 15.21355,31.09815 28.78703,38.06438 z' fill='%23de2910'/%3E %3C/g%3E %3Cuse xlink:href='%23petal' transform='rotate(72 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(144 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(216 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(288 450,300)'/%3E %3C/svg%3E"

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='500' viewBox='0 0 72 36'%3E %3Crect width='72' height='36' style='fill:%230073cf'/%3E %3Crect width='72' height='12' y='12' style='fill:%23fff' /%3E %3Cg id='star' transform='translate(36,18) scale(2)' fill='%230073cf'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E%3Cuse xlink:href='%23triangle' transform='scale(-1,1)' id='use12'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)' id='use14'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)' id='use16'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)' id='use18'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)' id='use20'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='translate(10,-3.2)'/%3E %3Cuse xlink:href='%23star' transform='translate(10,2.8)'/%3E %3Cuse xlink:href='%23star' transform='translate(-10,-3.2)'/%3E %3Cuse xlink:href='%23star' transform='translate(-10,2.8)'/%3E %3C/svg%3E"

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Crect fill='%23171796' width='1200' height='600'/%3E %3Crect fill='%23fff' width='1200' height='400'/%3E %3Crect fill='%23f00' width='1200' height='200'/%3E %3Cg transform='scale(0.00296202)'%3E %3Cg%3E %3Cpath fill='%23f00' d='m202577,153674,0,0c21658,0,39377-17720,39377-39377v-46791h-78755v46791c0,21658,17720,39377,39377,39377z'/%3E %3Cpath fill='%23fff' d='m202577,153043,0,0c21245,0,38626-17382,38626-38626v-46153h-77253v46153c0,21245,17382,38626,38627,38626z'/%3E %3Cg fill='%23f00'%3E %3Cpath d='m180254,69716-14865,0,0,16332,14865,0z'/%3E %3Cpath d='m180254,102379,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m165389,114326c0,1483,92,2946,263,4385h14602v-16332h-14865v11947z'/%3E %3Cpath d='m209985,102379-14866,0,0,16332,14866,0z'/%3E %3Cpath d='m209985,135042,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m224850,143976c3296-2488,6169-5509,8487-8933h-8487v8933z'/%3E %3Cpath d='m180255,135042,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m171754,135042c2321,3429,5199,6454,8501,8944v-8944h-8501z'/%3E %3Cpath d='m205141,151374c1645-115,3262-337,4843-661v-15671h-14865v15673c1576,323,3189,544,4829,658,1731,107,3462,101,5192,0z'/%3E %3Cpath d='m239437,118711c172-1444,264-2912,264-4400v-11931h-14852v16332h14588z'/%3E %3Cpath d='m209985,102379,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m209985,69716-14865,0,0,16332,14865,0z'/%3E %3Cpath d='m239701,86048,0-16332-14851,0,0,16332z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fff' d='m240533,67027,9217-20893-7022-11339-11634,4307-8168-9337-10763,6168-9597-7860-9597,7860-10763-6168-8169,9336-11634-4307-7024,11342,9205,20897c11599-5250,24460-8175,37983-8175,13517,0,26372,2923,37968,8169z'/%3E %3Cg%3E %3Cpath fill='%230093dd' d='m174293,40024-17,20-11537-4272-6456,10424,2473,5623,6265,14222c4678-2068,9555-3764,14594-5048l-5321-20968z'/%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='118.162625' d='m173629,50332c413,783,647,1674,647,2617,0,3106-2533,5639-5639,5639-2737,0-5029-1968-5535-4561,974,1722,2823,2888,4935,2888,3121,0,5667-2545,5667-5667,0-312-26-618-75-917z'/%3E %3Cpolygon fill='%23000' points='168461,42530,168442,42623,168049,44647,169602,46004,169673,46066,169583,46097,167634,46769,167235,48792,167216,48885,167145,48822,165589,47470,163638,48136,163547,48167,163566,48073,163959,46050,162407,44693,162335,44630,162425,44599,164374,43928,164773,41905,164792,41812,164863,41874,166419,43227,168370,42561'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m166119,45404,1455,1269,1821-627z'/%3E %3Cpath d='m166131,45340,3277,641-1450-1268z'/%3E %3Cpath d='m162613,44651,3276,641-1455-1268z'/%3E %3Cpath d='m165877,45357-3277-641,1450,1267z'/%3E %3Cpath d='m166060,45234,2194-2517-1823,622z'/%3E %3Cpath d='m163704,47937,2194-2517-1826,626z'/%3E %3Cpath d='m165948,45463-2194,2517,1823-622z'/%3E %3Cpath d='m168304,42760-2194,2517,1826-626z'/%3E %3Cpath d='m165933,45242-1083-3158-373,1890z'/%3E %3Cpath d='m167096,48634-1083-3158-371,1894z'/%3E %3Cpath d='m166075,45454,1083,3159,373-1890z'/%3E %3Cpath d='m164912,42062,1083,3159,371-1895z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23171796' d='m193069,36886-20,16-10673-6116-8083,9238,5321,20968c4938-1257,10031-2115,15242-2546l-1788-21560z'/%3E %3Cg fill='%23f00'%3E %3Cpath d='m178294,55788c5221-1329,10608-2237,16119-2692l-452-5450c-5816,481-11502,1439-17013,2841l1345,5301z'/%3E %3Cpath d='m175619,45250c5797-1476,11777-2483,17895-2989l-444-5350c-6418,530-12691,1588-18772,3135l1321,5204z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230093dd' d='m212105,36890-23,13-9517-7794-9497,7778,1788,21560c2543-210,5113-322,7709-322,2608,0,5190,113,7744,325l1795-21560z'/%3E %3Cg id='lion'%3E %3Cpath fill='%23000' d='m202545,46585c-18-2-44,10-69,45-186,250-359,469-545,720-195,61-242,180-167,348-261-26-291,193-302,432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172,74,267,434,535,868,802,1302-14,80,6,151,88,204,47,133,93,265,140,397-11,38-21,75-32,113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92,82-3,534,162,1014,599,1492-231,4-462,11-694,21-79,6-95,39-73,104,126,304,339,579,822,766-208,112-327,285-357,520-9,224-75,382-212,455-60,32-81,65-24,106,253,185,565,193,895,112-157,270-226,553-198,850,208,56,412,15,614-52-29,61-44,175-52,309-7,115-41,229-104,343-32,33-65,84,4,102,336,91,648,52,915-47,0,243,2,487,76,727,18,58,70,102,125,26,155-214,322-396,527-517,31,90,75,168,156,215,96,55,147,170,153,343,0,30-2,60,35,90,149,7,514-380,589-597,206,121,284,246,439,461,55,76,99,29,128-25,62-243,67-481,66-724,267,99,579,138,915,47,69-19,36-70,4-102-62-114-105-250-113-365-9-133-14-226-43-287,202,68,405,108,614,52,29-297-53-579-211-850,330,80,655,73,908-112,57-41,35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520,483-187,696-463,822-766,22-66,6-99-73-104-231-10-480-24-711-27,437-478,606-961,604-1495-1-108-38-146-92-82-74,87-179,137-348,146-222,15-435,24-656,128-11-38-21-75-32-113,46-132,106-260,153-393,82-53,102-123,88-204,267-434,513-868,781-1302,54-79-46-162-171-74-60,42-110,64-170,106-117,80-257,134-437,145-251,54-417,167-428,397-293-175-564-73-814,307-11-239-41-457-302-432,75-168,17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m205075,47978c-51-26-124,17-162,95s-33,170,19,196c40,20,84-6,119-56l22-36c2-3,4-6,5-9,38-78,49-163-2-188z'/%3E %3Cpath d='m200067,47978c52-26,124,17,162,95s39,165-13,191-103-24-141-102-60-158-9-184z'/%3E %3Cpath d='m204606,48883c-32,0-59,27-59,59s26,59,59,59,59-26,59-59c0-32-26-59-59-59z'/%3E %3Cpath d='m200574,48883c-32,0-59,26-59,59,0,32,26,59,59,59s59-26,59-59-26-59-59-59z'/%3E %3Cpath d='m204868,48579c-754-91-1506-133-2260-133s-1509,41-2269,115c-26,8-21,90,14,86,756-73,1507-113,2256-113,743,0,1485,40,2228,129,39,4,54-80,32-84z'/%3E %3Cpath d='m200319,48495c768-75,1530-117,2289-116,754,0,1507,42,2261,133l111-184c-32,10-62,9-90-5-76-38-92-161-36-274,56-114,164-175,240-138,39,19,62,62,68,114l446-739c-204,130-328,214-581,252-281,41-409,139-368,307,38,156-57,133-201,54-314-171-541,71-652,353-73,186-159,181-168-13-4-70,0-131-7-200-21-223-89-286-216-224-161,78-175,25-137-58,28-60,86-128,66-221-9-67-66-92-151-98-182-244-467-483-649-727-182,244-374,483-556,727-86,5-142,30-152,98-20,93,52,157,80,217,38,82,23,135-137,57-127-61-186-3-207,220-7,69-10,139-13,209-9,194-95,199-168,13-111-282-352-524-667-353-145,79-203,102-182-54,23-172-107-266-388-307-253-37-377-122-581-252l419,682c12-25,29-45,53-57,76-38,184,24,240,138,56,113,40,237-36,274-10,5-21,8-32,10l100,163z'/%3E %3Cpath d='m204708,49406c-7,3-7,4-24,11-46,19-80,66-134,124-57,60-128,125-211,188-12,10-25,19-44-6s-7-35,6-44c80-62,149-124,204-182,30-32,56-63,77-92-95-11-190-21-284-30-79,24-157,55-222,95-59,35-107,77-137,125-8,14-16,27-44,11-27-16-19-30-11-44,35-58,91-107,158-147,33-20,69-38,106-54-107-9-214-18-321-25-22,13-42,29-61,47-20,19-39,42-56,67-9,13-18,26-44,8s-18-31-8-44c19-29,41-54,64-77,3-3,6-6,9-9-80-5-161-10-241-14-2,2-5,5-8,7-21,18-40,38-55,59s-28,43-38,67c-6,15-12,29-41,18-29-12-23-26-17-41,12-29,27-55,45-81,8-11,18-22,27-33-115-5-230-9-344-12-4,5-9,8-14,11-25,15-47,32-66,51s-35,40-48,63c-8,14-16,28-43,12-28-16-20-29-12-43,16-28,35-54,59-77,7-7,14-13,21-19-122-2-244-4-365-4-120,0-240,1-360,3,8,7,15,13,22,20,23,23,42,49,59,77,8,14,16,27-12,43s-35,2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115,2-230,6-345,11,11,11,20,23,29,35,19,25,33,52,45,81,6,15,12,29-17,41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81,4-162,8-243,13,4,4,9,8,13,12,24,23,45,48,64,77,9,13,18,26-8,44s-35,5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110,7-220,14-330,23,43,18,85,38,122,61,67,40,124,89,158,147,8,14,16,27-11,44-27,16-35,3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90,7-179,15-268,24,22,33,51,68,86,106,55,58,124,120,204,182,13,9,25,19,6,44s-32,15-44,6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79,36,85,75,164,126,229,53,68,120,121,209,147,8,2,21,16,22,25,28,157,84,286,169,386,52,60,114,110,188,149-75-81-132-166-172-251-67-142-90-286-77-420,1-16,3-32,34-29,32,3,30,19,29,35-11,123,9,256,72,387,56,118,159,237,291,346,24,19,0,63-29,55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205,28,428,182,801,456,1137,61,75,165,182,255,216,92,35,95,100-20,101-34,1-69,1-105,1,84,31,164,66,233,105,127,73,217,162,224,273,1,16,2,32-29,34-32,2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154,0-312-1-459,3,39,28,80,57,131,84,82,44,188,86,343,122,89,21,166,52,233,91,71,42,130,93,177,150,10,12,20,25-5,45s-34,8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123,180,393,450,573,835,689,23,7,43,13,61,19,3,1,6,1,9,2,86,21,175,40,266,55,92,15,166,28,261,37,16,1,32,3,29,34-3,32-19,30-34,29-99-9-174-22-266-38-58-10-115-21-171-33-26,6-64,9-107,12-232,14-420,225-435,494,0,5,0,11-1,16,88-80,179-157,273-212,117-68,239-103,364-69,15,4,31,8,22,39-8,31-23,27-39,22-106-28-212,3-316,63-108,63-213,158-315,253-24,147-82,285-205,377,61,34,104,65,163,45,86-39,172-78,261-108,91-31,184-52,282-57,16-1,32-1,33,31s-14,32-31,33c-91,4-179,24-264,53-75,26-149,58-222,91,221,47,460-1,667-79,60-22,105-42,133-41,51-30,112-53,172-79,66-28,132-51,182-57,16-2,32-4,35,28,4,32-12,33-28,35-112,13-127,21-222,79,0,21-66,57-126,96-36,24-70,52-87,67-95,86-144,181-188,287-29,70-52,145-68,224,55-108,121-211,201-303,94-108,208-201,345-265,14-7,29-13,42,15,13,29-1,35-15,42-129,60-236,147-324,250-90,103-161,222-219,345-31,64-8,1-42,86,110-122,212-224,323-307,132-100,283-157,418-133,15,3,31,6,26,37s-21,28-37,26c-116-21-250,32-369,121-121,92-244,223-366,361,184,26,366-26,542-85,91-30,183-135,239-152,19-24,38-46,57-67,33-37,67-71,102-100,12-10,24-20,45,4s8,34-4,45c-33,28-65,60-96,94-32,35-62,73-92,113-6,8-13,17-24,16-60,70-151,162-172,240-57,210-25,370-122,576,71-38,128-81,175-134,53-60,94-135,128-230,37-104,95-195,167-270,75-77,165-136,261-172,15-5,30-11,41,19s-4,35-19,41c-87,32-169,86-238,157-66,68-119,151-153,247-37,102-81,183-141,250-44,50-95,91-156,127,52-3,78-10,121-7,79-6,211-66,279-119,66-51,116-120,154-206,6-15,13-29,42-16s23,27,16,42c-42,96-99,174-173,231-56,43-121,75-196,93,161-5,311-42,467-100,65-24,87-168,127-208,32-58,66-112,105-158,47-56,101-101,164-127,15-6,29-12,41,18,12,29-3,35-17,41-52,21-98,60-139,108-36,42-68,93-98,147,10,73-51,228-53,305-7,205-2,409,53,612,53-71,107-134,162-192,0-5,0-10,1-15,18-106,33-219,40-332,7-112,7-223-6-329-2-16-4-32,27-35,32-4,34,12,35,28,14,111,14,226,7,340-6,90-16,180-30,269,54-51,53-51,77-103,37-80,59-159,67-237,9-80,5-157-13-230-4-15-7-31,24-38s35,8,38,24c19,80,25,165,14,252-8,65-24,132-49,199,56-42,114-82,178-122-4-75-5-153-3-227,2-68,7-134,18-190,4-20,7-40,47-33s37,27,33,48c-9,50-14,111-16,177-2,78,0,162,4,243,5,82,49,185,125,230,103,62,158,163,186,274,16-145,17-280,3-400-17-143-55-267-114-368-8-14-16-27,12-44,27-16,35-2,43,12,63,110,104,241,122,393,17,146,13,310-13,488,102-82,381-258,352-594-7-27-16-52-28-75-7-14-14-28,14-42s35,0,42,14c17,33,30,69,39,110,5,24,8,49,11,76,13-7,45-43,51-39,24,16,58,38,80,54-21-60-35-120-42-178-10-87-5-172,14-252,4-15,7-31,38-24s27,23,24,38c-18,73-22,151-13,230,9,77,31,157,67,237,4,8,8,16,5,25,24,21,47,42,70,65-13-84-22-170-28-255-8-115-7-230,7-341,2-16,4-32,35-28s29,20,27,35c-13,106-13,217-6,329,7,113,22,225,40,332,1,2,1,5,1,7,54,59,95,120,152,196,55-203,73-407,66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41,12-29,27-24,41-18,62,26,117,71,164,127,38,45,72,98,103,154,57,7,78,179,143,212,154,57,298,94,453,100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29,16-42s35,2,42,16c38,86,88,156,154,206,85,66,289,124,400,127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247-68-71-150-124-238-157-15-6-29-11-19-41,11-29,26-24,41-19,96,36,186,94,261,172,72,74,130,166,167,270,34,95,75,169,128,230,47,54,105,98,177,135-98-207-66-367-122-577-35-129-232-277-193-320,45-51,133,88,248,127,175,59,357,111,540,85-122-138-244-269-366-361-119-90-237-140-352-120-16,3-31,6-37-26-5-31,10-34,26-37,135-24,269,32,401,132,111,84,201,175,311,298-18-47,0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42,13-28,28-22,42-15,137,65,251,157,345,265,81,93,147,198,203,307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35,4-32,19-30,35-28,50,6,115,28,182,56,33,14,66,43,98,60,53,4,139,47,208,74,206,78,446,126,666,79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31,33-31c98,4,191,26,282,57,89,30,175,69,261,108,59,27,101-7,163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15,4-31,8-39-22-8-31,7-35,22-39,125-33,247,1,364,69,94,55,186,132,274,213,0-6-1-11-1-17-15-270-203-480-435-494-78-5-189,21-186-32,4-59,97-44,234-86,385-116,655-296,836-690-54,41-110,83-186,124-86,47-198,91-358,128-82,19-154,48-216,84-64,38-117,84-159,135-10,12-20,25-45,5s-14-32-5-45c47-57,106-108,177-150,67-39,145-70,233-91,155-36,261-78,343-122,51-27,92-55,131-84-148-4-305-3-459-3-143,44-289,96-402,160-110,63-186,136-192,223-1,16-2,32-34,29-32-2-31-18-29-34,8-111,97-200,224-273,69-39,149-74,233-105-35,0-70,0-104-1-116-2-112-66-20-101,90-34,190-141,251-216,271-334,412-714,456-1130-33,72-69,140-115,198-57,73-128,131-222,164-31,160-91,293-180,397-92,108-216,185-369,230-29,8-52-35-29-55,132-109,221-226,278-344,62-131,83-264,72-387-1-16-3-32,29-35,31-3,33,13,34,29,12,134-10,278-78,420-40,85-97,170-172,251,73-39,136-89,187-149,85-100,141-229,170-386,1-8,14-22,22-25,89-27,155-79,209-147,51-65,90-143,126-228-140,69-304,64-457,78-213,19-369,68-554,152z'/%3E %3Cpath d='m204649,49231c-680-88-1359-113-2041-114-684,0-1369,40-2058,112-20,6-15,33-14,46,2,28,37,35,121,27,643-60,1285-93,1932-93,674,0,1351,21,2038,102,33,9,77-85,22-81z'/%3E %3Cpath fill-rule='evenodd' d='m200570,49160c683-71,1362-110,2038-110,675,0,1349,40,2025,127l31-127c-17,9-37,15-58,15-67,0-123-55-123-123s55-123,123-123c51,0,94,31,113,75l60-170c-724-84-1446-122-2171-122-729,0-1459,38-2193,107l58,164c22-32,59-54,101-54,68,0,123,55,123,123s-55,123-123,123c-12,0-25-2-36-6l33,94-2,7zm3067-416c-68,0-123,55-123,123s55,123,123,123,123-55,123-123-55-123-123-123zm0,64c-33,0-59,27-59,59s26,59,59,59c32,0,59-27,59-59s-26-59-59-59zm-1082-91c-67,0-123,55-123,123s55,123,123,123,123-55,123-123-55-123-123-123zm0,64c-32,0-59,26-59,59s26,59,59,59,59-26,59-59c0-32-26-59-59-59zm-1064-40c-68,0-123,55-123,123s55,123,123,123c67,0,123-55,123-123s-55-123-123-123zm0,64c-33,0-59,26-59,59s26,59,59,59c32,0,59-26,59-59,0-32-26-59-59-59z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m202601,47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68,60-20,114-67,157-133,45-69,79-157,95-256,5-34,64-35,69-1,15,84,51,153,97,208,55,66,125,112,193,138,31,12,25,63-8,68-59,9-105,42-141,87-50,62-81,145-100,221-8,33-62,31-69-2zm33-118c20-52,47-103,81-146,28-34,60-64,99-84-51-30-100-70-143-120-28-34-53-73-73-116-19,59-45,112-75,158-31,47-67,86-108,116,50,19,95,47,134,82,34,31,63,68,85,110z'/%3E %3Cpath d='m203433,52971-515,206c-17,7-35,14-48-21-14-34,4-41,21-48l515-206c17-7,35-14,48,21,14,34-4,41-21,48zm59-326-604,328c-16,9-33,18-51-15s-1-42,15-51l604-328c16-9,33-18,51,15s1,42-15,51zm-1826-65,604,328c16,9,33,18,15,51s-34,24-51,15l-604-328c-16-9-33-18-15-51s34-24,51-15zm51,322,515,206c18,7,35,14,21,48-14,35-31,28-49,21l-515-206c-17-7-34-14-21-48,14-35,31-28,48-21zm224,434c137,33,261,48,358,31,88-16,155-60,191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329,5-18,9-36,45-27s32,27,27,45c-20,82-33,194,1,284,23,60,69,110,152,133,91,25,198,38,307,38,107,0,214-13,304-40,82-24,148-69,192-123s65-117,57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94,7-142,16-25,5-50,9-77,13-19,2-37,5-42-32s14-40,32-42c23-3,48-8,73-12,52-10,105-20,159-18,60,2,121,18,168,51,42,29,72,72,80,131,11,80-16,163-73,233-53,65-131,119-229,147-83,24-178,38-274,42v483c3,5,3,11,2,16,37,82,102,125,188,141,97,18,221,2,358-31,18-5,36-9,45,27,8,37-9,41-28,45-146,35-279,51-388,32-92-17-165-58-215-132-49,74-124,115-215,132-109,20-242,4-388-32-18-4-37-8-28-45,8-36,27-32,45-27zm356,210,402-9c19,0,38-1,38,37,1,38-18,38-37,38l-402,9c-19,0-37,1-38-37s18-38,37-38z'/%3E %3Cpath d='m202890,50464c151-125,293-227,423-297,133-72,254-111,359-106,19,1,37,1,36,39-1,37-20,37-39,36-92-4-200,32-322,97-125,67-263,166-410,289-14,12-29,24-53-5s-9-41,5-53zm-605,56c-141-130-298-240-445-314-139-71-268-108-363-100-19,2-37,4-40-34-4-37,15-39,34-40,110-10,252,31,404,107,152,77,315,191,461,325,14,13,28,25,2,53-25,27-39,15-53,2zm-213,1004c37-83,83-155,136-219,53-63,112-119,174-170,14-12,29-24,52,5,24,29,9,41-5,53-59,48-114,101-164,160-49,59-91,125-125,201-8,17-15,34-49,19s-27-32-19-49zm371-1734c49,66,88,139,114,223,26,82,40,175,39,279,5,80,6,165-7,249-13,86-42,170-97,246-43,60-101,97-165,113-53,13-109,10-164-7,29,100,51,208,6,308-8,18-33,27-51,18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1,2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27,1-53s40-12,53,1c39,40,89,80,150,121,60,40,128,81,204,121,124,13,247,51,370,109,106,50,211,115,317,192,13,7,19,16,27,20,8,6,16,13,25,19,51,22,104,28,152,16,47-11,90-39,122-84,48-66,72-139,84-214,12-77,11-157,6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30,7-52s41-7,52,7zm-375,1047c-104-77-207-141-311-190-105-49-210-83-314-98,2,48,8,93,18,135,13,52,35,99,71,138l1,1c30,37,73,72,130,107,60,36,134,71,225,106l-1-1c45,16,89,34,133,54,31,14,61,28,93,44,19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44,59-79,125-102,201-24,76-36,161-35,258v2c-5,77-6,158,6,234,12,75,37,148,84,214,32,45,75,72,122,84,48,12,101,6,152-16,8-6,17-13,25-19,6-4,13-12,27-20,105-77,211-143,317-192,123-58,246-95,370-109,75-40,144-80,204-121s111-81,149-121c13-13,26-27,53-1s14,39,0,53c-43,44-97,88-161,131-57,38-122,77-194,116-2,61-8,119-22,174-16,63-44,121-88,170l1-2c-35,44-85,85-150,124-63,38-141,75-237,112l-1,1c-43,15-85,32-127,51-43,19-85,40-128,62-18,9-43,0-51-18-45-100-23-208,6-308-55,18-111,20-164,7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104,13-196,39-279,26-84,65-158,114-223,11-15,22-30,52-7,30,22,19,37,7,52zm940,715c-105,15-209,49-314,98-104,49-207,113-311,190-4,13-6,21-8,29-27,88-56,184-37,267,31-15,62-30,93-44,44-20,87-38,133-54l-1,1c91-35,165-70,225-106,58-34,100-70,131-107,0,0,1-1,1-1,35-39,57-86,71-138,11-42,16-87,19-135z'/%3E %3Cpath fill-rule='evenodd' d='m203459,50602c-119,0-216,97-216,216s97,217,216,217,216-97,216-217c0-119-97-216-216-216zm0,69c-81,0-147,66-147,147s66,147,147,147,147-66,147-147-66-147-147-147zm0,60c-48,0-87,39-87,87s39,87,87,87,87-39,87-87-39-87-87-87zm-1697-124c119,0,217,97,217,216s-97,217-217,217c-119,0-216-97-216-217,0-119,97-216,216-216zm0,69c81,0,147,66,147,147s-66,147-147,147-147-66-147-147,66-147,147-147zm0,60c48,0,87,39,87,87s-39,87-87,87-87-39-87-87,39-87,87-87z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23lion' transform='matrix(0.99928092,-0.03791625,0.03791625,0.99928092,-5965.3264,-1993.2203)'/%3E %3Cuse xlink:href='%23lion' transform='matrix(0.99927613,0.03804216,-0.03804216,0.99927613,6277.9506,-17381.167)'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23171796' d='m230880,40035-25,9-8100-9258-10650,6104-1796,21560c5212,432,10304,1293,15241,2551l5329-20965z'/%3E %3Cpath fill='%23000' d='m214206,41363c370-90,735-109,1089,108,155,64,272,146,344,251,164-127,331-246,504-348,243-180,491-339,758-428,382-194,763-309,1145-344,404-69,810-73,1214-49,337,20,663,113,974,292,282,140,563,281,845,421,298,166,596,316,894,442,378,149,803,199,1256,216,222,8,440,8,654-49,173-46,281,64,90,181-1400,859-2497,95-3433-247,343,232,645,472,900,717,356,343,754,691,1458,1012,427,194,892,347,1489,352,202,2,420-6,656-45,119-19,170-8,172,54,2,42-9,126-80,173-361,242-701,306-1080,330-722,46-1494-191-2200-570-565-304-946-674-1396-1006-449-331-837-515-1254-603-411-88-856-78-1231,38,112,22,207,75,265,142,193,114,441,164,800,205,187,22,129,151-159,306-173,223-398,343-697,314-412,273-559,108-697-71-17,113-50,224-99,331,18,58,20,122-6,180,66,102,98,201,76,310,11,58,30,114,92,166,86,78,141,168,152,278,1,73,41,133,99,187,84,69,169,130,253,233,249,90,364,281,405,528,188,61,266,197,303,359,107,45,205,99,261,194,384,1,759,1,1110,38,329,35,597,240,837,506,162,25,326,33,494-5,173-76,356-134,555-151,329-28,659-45,973,30,213,51,379,164,515,318,196,223,498,193,756,83,350-149,641-144,999,13,153-59,306-87,459-71,131-142,270-177,413-181,233-8,402,28,358,327-12,81-60,159-121,187-107,231-311,299-570,277-28,159-93,277-197,353,119,367,5,514-267,509-57,106-142,172-287,151-106,129-231,195-368,217,16,96,57,141,125,244,185,280-93,393-347,397,65,185,73,370,50,555,259,157,294,322,55,485,175,306,107,531-221,695-5,171-22,343-136,439-78,66-190,78-116,202,133,220,104,498-93,506-42-4-80,2-83,69,0,23-20,46-59,69-236,127-457,272-660,439-30,20-60,34-90,7-148,322-424,649-729,978-47,242-184,406-411,491-16,75-64,119-135,138,127,141,175,277,52,411-151,165-350,326-549,377-423,108-688,88-858-74-150-143-91-251,4-296-261,21-314-117-307-301,15-92,46-80,138-77,142,4,270-73,404-117,52-88,120-164,204-228,47-296,234-460,488-557,205-78,401-276,591-532,117-202,235-403,352-605-82-107-104-214-107-321-108-60-183-134-235-218-184-13-260-96-287-211-42,1-88-3-138-18-90,58-181,109-294,104-149,153-303,278-460,384-55,152-164,213-297,232-378,45-604,516-812,708-84,62-136,172-173,304-18,248-61,442-197,446-122-5-141-18-145-31-53-5-106-5-159,7,102,112,118,253,24,377-94,122-229,160-359,169-269,18-487-6-689-88-193-79-216-194-210-306-139-66-167-132-152-197,19-84,96-127,193-100,84-40,168-67,252-83,244-263,495-489,771-594,81-98,174-186,287-259,32-236,187-422,377-595,17-85,45-171,93-256-11-51,3-75,4-123-77-143-123-315-66-458-23-69-30-159-21-228-454,270-594,178-646-41-166,139-321,204-432,4-161,48-323,102-484,38-105,41-211,78-332,86-49,97-115,194-204,291-5,204-76,408-207,612-76,218-170,435-294,653,2,70-8,140-45,211,35,251-49,373-187,435-37,101-92,203-176,304-4,33-7,67-11,100,55,148,64,295-86,443-121,76-250,156-378,219-151,74-291,39-418-7-223-80-206-158-177-234-70,28-150,31-220-3-54-34-88-69-142-104-48-87-65-166,52-228,147-65,247-113,363-232,40-90,91-158,163-176,70-164,156-275,273-305,86-203,178-427,287-621,38-59,66-120,48-187-2-55,2-107,48-138,26-22,72-42,14-73-53-181-20-354,69-487,118-178,250-608,125-819-23-118-46-253-31-364-43-2-75,4-118-26-96-59-176-3-249,104-53,134-106,252-159,252-50,346-220,615-397,684-41,159-67,318-45,477,18,173,0,291-80,311-88,22-170,73-221,214-14,39-30,86-31,142,122,126,85,283-32,399-264,260-592,222-939,120-251-99-312-204-287-311-356-30-285-303,10-385,317-89,574-292,785-582,19-344,98-578,283-615,18-211,84-401,173-581,93-163,150-342,117-560-197-123-205-250-24-380,60-35,53-71-21-107-120-12-105-127-97-235-5-56-34-85-87-86-266-39-200-148-86-266,48-54,80-134,30-166-41-26-69-117-78-197-163-123-93-249,0-370-92-78-135-192-148-325-303-13-416-167-252-391,69-95,158-186,266-273,70-113,137-226,104-339-87-221,191-388,429-560-33-58-50-115-52-173-134-129-100-249,48-363-33-59-49-118-55-176-333,66-331-133-176-453-193-111-139-308,211-608,5-69,18-122,38-159-166,4-303,53-422,128-133,87-265,76-398,21-41-66-104-122-176-173-91-80-112-170-93-266-392,22-467-268-232-439,131-104,227-213,263-332,106-269,331-452,550-640,0-77,17-154,41-232-97-65-199-112-311-121-40-100-115-208-242-269-73-44-97-85-52-184-208-186-156-299-103-406z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m221318,51461c-23,2-47,4-74,3-101,103-222,206-334,294-97-112-241,11-100,79-24,17-48,34-72,50-46,122-88,174-224,195-21,3-42,7-63,12-1-52,1-102,6-151,6-61,16-120,29-178,2-11,5-21-16-26s-24,6-26,17c-13,60-24,121-31,183-6,55-8,111-6,167-343,110-541,467-775,721-101,87-152,207-189,333-20,67-27,374-96,379-33,1-68,0-105,0-37-56-87-57-150-4-143-3-295-4-422,16-87,94,152,59,279,137,58,35,83,104,60,200-117,279-770,189-987,74-101-53-105-114-101-201,45,0,91-3,137-10,78-11,155-34,231-77,21-12,43-24,19-67s-46-31-67-19c-64,37-130,56-196,65-68,10-138,10-205,7-6,0-12-1-17,0-38-22-67-48-51-71,16-22,79,2,91,6,101-47,189-77,298-98,230-246,464-477,781-604,95-114,198-204,322-286,44-274,177-420,376-602,24-113,52-194,108-293-12-63-3-103,0-167-76-144-121-269-61-430-37-117-32-196-18-304,4-28,3-48-1-61,62-49,125-95,187-137,57-38,114-73,171-105-9,108-5,221,16,339,0,0-1,1-1,1-34,37-63,73-83,111-21,39-33,78-31,117,0,11,0,22,22,21,22,0,22-11,21-22-1-31,8-63,26-95,18-33,45-67,77-101,3-3,6-7,8-11,105-3,208-59,311-142,93-76,186-174,278-277-1,150-2,300-4,450-90,80-167,178-227,297-5,10-10,19,9,29,20,10,25,0,29-10,55-109,125-199,206-274h4c22,0,22-11,22-22v-1c14-12,29-24,44-35,102-79,218-139,343-187-19,132-28,261-5,385,25,136,89,264,219,376,2,2,5,3,8,4z'/%3E %3Cpath d='m214786,47657c17-31,60-71,74-68,3-1,5-1,8-2,47-88,96-170,147-244,66-96,136-181,210-253,8-8,16-15,31,0,15,16,7,23,0,31-72,70-140,152-205,246-50,73-98,153-144,240,15,20,22,51,14,73,15,137,33,214,94,293,7-6,14-11,21-14,25-61,59-115,101-163,52-58,115-107,191-148,52-43,94-87,128-133,34-45,61-91,80-138,4-10,8-20,29-12,20,8,16,19,12,29-21,51-49,100-85,148-37,48-82,95-138,141,0,0-3,2-4,2-71,39-132,85-180,139-37,41-66,87-89,138,32,23,46,86,16,126-91,131-199,208-29,320-6,88,22,155,80,216,39,41,35,184-61,287-90,91-21,67,72,78,7,2,14,5,21,7v-1c34-66,74-125,118-180,43-54,90-105,138-153,67-66,120-138,158-211,37-71,59-144,63-214,1-11,1-22,24-20,22,1,21,12,20,23-5,76-28,154-68,232-40,77-96,152-166,221-47,47-92,95-134,149-42,53-80,110-113,173,112,68,76,190,93,302,22,3,41,8,58,16,1-2,2-4,4-6,22-34,44-69,66-104l104-165c6-9,12-19,30-7,19,12,13,21,7,30l-104,165c-22,35-44,69-66,104-1,2-2,4-3,5,69,56,74,158-11,236-167,126-120,165,36,265,20,147,21,265-11,390,1,3,1,7,2,11,4,41,7,83,10,124l10,125c1,11,2,22-20,24s-23-9-24-20l-10-125c-1-11-2-21-2-32-8,19-16,39-26,60-112,245-228,445-253,720-269,64-229,329-244,563-212,286-458,515-799,629-64,21-219,59-234,140-2,29,104,92,172,55,188-180,282-80,66,104-17,35-3,74,34,107,195,175,678,232,898,93,163-102,248-214,106-369,9-220,95-435,327-497,27-50,19-143,7-194-22-191,8-361,55-545,8-23,25-42,63-52,88-18,257-273,310-518,13-53,21-108,31-163,14-85,47-100,90-50,41-55,40-88,65-151,90-131,220-236,372-162-39-107-66-228-74-351-11-146,3-297,48-435,6-21,13-41,46-36,44-104,87-207,131-311s88-209,132-313c4-10,8-20,28-12s16,19,12,29c-44,104-88,208-132,313-44,104-87,207-131,310,19,14,13,32,7,50-40,125-53,263-43,398,10,146,46,287,100,402,5,11,11,22,9,33,72,42,71,52,68,148-2,75,8,149,26,239,143,264-6,706-145,927-67,107-85,229-57,352,86,83,30,169-46,227-6,20,0,43,1,63,8,86-23,158-68,229-117,211-207,436-301,657-170,47-205,146-273,305-99,28-109,57-151,148-114,115-223,184-369,250-121,55-4,108,81,166,77,57,178-67,241-161,69-104,139-73,94,8-50,89-86,217-91,284-26,72,248,127,295,129,167,8,377-155,508-238,109-111,92-208,44-343l1-9c-70,2-136-6-201-20-79-18-157-45-236-78-10-4-20-8-12-29,8-20,19-16,29-12,78,32,153,59,229,75,63,14,128,21,197,19l11-105c87-107,147-212,194-340,185-87,186-177,161-375,41-80,50-127,47-218,122-217,222-439,305-674,146-194,216-377,199-608,13-90,46-141,112-138,48-67,91-136,130-213,8,1,16,2,24,2-2-5-1-11,0-16,12-53,26-100,44-139,17-39,37-70,60-95,27-66,37-130,30-192-7-64-29-126-65-187-22-25-42-51-49-78-9-31-3-62,28-93,8-8,16-15,31,0,15,16,8,24,0,31-18,17-21,33-16,49,6,20,22,41,41,63,0,0,2,4,2,4,39,67,65,136,72,207s-3,144-35,217c0,1-4,6-4,7-21,22-39,50-55,85-16,37-30,80-41,130-1,3-1,6-2,8,103,0,194-32,293-81,2-2,4-4,6-6,50-40,103-101,147-181,37-67,67-149,84-243,2-11,4-21,26-18,21,4,19,15,18,25-18,100-50,185-89,257-34,63-74,114-114,154,160,48,299,1,451-46-22-214-19-377,4-505,25-139,72-237,131-311,7-9,13-17,31-4,17,14,11,22,4,31-55,69-99,161-122,292-22,122-26,278-5,484,2-1,5-1,8-2,64,109,98,188,229,103,48-32,98-64,138-106,15-16,10-25,22-38,125-133,251-257,376-367,126-111,252-206,378-283,9-6,19-12,30,7s2,24-7,30c-124,75-248,170-372,278-107,94-214,198-321,310,6,19,9,52,12,102,11,148,38,237,249,156,118-45,130-50,239-115,53-32,98-59,129-66,69-54,137-105,206-151,67-45,135-86,202-122,11-80,29-158,55-233,65-192,174-370,311-538,1-1,6-5,7-6,114-62,207-135,281-218,75-83,131-176,173-277,4-10,8-20,29-12,20,8,16,19,12,29-44,105-103,202-180,289-77,86-172,162-290,226-133,164-239,336-301,521-22,65-39,131-49,200,4,1,8,5,12,13,10,20,0,25-9,29-3,1-6,3-9,5-13,108-10,222,10,340,93-3,187-55,282-132,101-82,204-195,306-310,1-3,1-5,4-7,25-82,57-154,99-212,45-62,100-109,168-138,10-4,20-9,29,12,8,20-1,24-12,29-60,26-110,68-150,123-40,56-71,126-95,206-1,156-3,312-4,468,5-4,11-8,16-13,115-89,247-155,390-207,15-6,32,8,29,24-22,140-34,279-11,407,22,120,76,232,184,332,41-74,89-140,141-200,18-21,37-41,56-60,1-2,2-4,5-5,41-41,83-79,127-115,32-29,64-59,95-89,32-29,64-59,96-89,8-8,16-15,31,1s7,24-1,31c-32,30-64,59-96,89-32,29-64,59-96,89,0,0-1,1-1,1-41,33-81,68-118,106,1,41,3,81,5,122,1,22,1,44,2,66,92,25,147,26,241,24,31,185,47,214,208,218-2-66-1-130,6-193,8-72,23-142,48-208,4-10,8-20,28-13,21,8,17,18,13,28-24,62-38,128-46,197-7,61-8,124-6,189h13c64,132,140,197,276,256,38-60,66-120,84-180,20-67,28-134,24-201-1-11-1-22,20-23,22-1,23,9,24,20,5,72-4,144-26,216s-57,143-105,214c-4,6-8,12-15,12,6,77,19,134,46,192,20-43,41-86,65-126,33-58,71-110,117-156,8-8,15-15,31,0,15,15,8,23,0,31-43,42-78,93-110,147-28,48-53,100-77,153,15,26,34,52,56,82-256,439-530,1047-1035,1247-261,103-375,236-427,515-98,76-168,153-232,259-170,57-322,142-506,134,0,119,39,171,158,172,227-114,278-135,298-119,28,24-32,187-220,319-29,18-28,29-11,59,159,249,576,160,800,101,160-42,449-232,529-392,31-74-39-169-109-247-320,49-259-258,16-130,93-28,105-29,131-132,245-95,347-198,403-461,247-266,495-540,673-859,49-60,78-166,64-221,44-52,68-118,84-178,16-64,26-127,24-191,0-11-1-22,21-23s22,10,23,21c2,68-8,135-25,203-14,52-32,104-51,156,16,40,24,67,59,57,214-172,430-293,661-436,16-98,79-146,176-150,39,1,53-11,67-47,54-135-14-228-79-340-60-167,47-207,154-287,112-83,104-303,108-430h1c-4-21-8-43-13-65-9-44-22-88-38-135-4-10-7-21,13-28,21-7,24,3,28,14,17,49,30,95,40,140,4,18,7,36,11,53,107-55,219-119,261-238,37-132-35-257-99-369-27,13-55,26-84,38-52,23-108,47-167,70-10,4-20,8-28-12s2-25,12-28c57-23,112-46,165-70,44-19,86-39,125-58,48-32,97-66,132-111,77-111-130-211-202-256,0-3,1-6,1-9-104-95-207-191-311-286-8-7-16-15-1-31s23-9,31-1c96,88,192,176,288,264,16-163,18-319-33-481-16-52-35-103-53-154-4,0-8-2-12-5-88-45-150-100-190-163-41-63-61-133-67-209-1-11-1-22,21-24,22-1,22,10,24,21,5,68,22,132,59,188,37,57,93,107,174,148,87,45,270,22,376-29,147-83-45-251-90-350-32-71-40-144-54-220,13-2,26-5,40-7-19-24-39-45-59-62-25-22-52-38-79-48-10-4-21-7-13-28,7-21,18-17,28-13,33,12,64,31,93,56,28,24,54,53,79,87,14-2,29-5,43-8,145-29,225-110,313-214-48-58-101-112-158-163-59-53-119-103-180-152-8-7-17-14-3-31s22-10,31-3c62,50,124,101,182,154,59,54,115,111,166,173,5,6,10,12,6,20,133,12,155-15,222-134-17-61-45-118-80-173-37-57-82-111-133-163-8-8-15-16,0-31,16-15,24-7,31,0,52,54,100,111,138,170,38,58,67,118,85,183,62,1,129,4,182-28,116-69,18-317-12-413,2-1,3-2,5-4-15-10-31-20-46-29-27-17-55-34-82-52-9-6-18-12-7-30,12-19,21-13,30-7,27,17,55,35,82,52,20,13,40,25,60,38,9-7,18-14,27-21,85-68,115-158,141-252,40-144,48-80,216-105,181-28,279-48,386-260,56-28,85-52,95-121,18-125,8-189-135-200-200-16-322,24-457,156,18,27,36,55,54,82,6,9,12,18-6,31-18,12-24,3-30-6-17-26-34-52-51-78-182-18-328,11-498,75-17-7-34-14-51-21,36,48,64,94,85,139,29,64,44,125,46,183,0,11,1,22-21,23s-22-10-23-21c-2-53-15-108-42-167s-68-121-126-187l-1-1c-142-51-272-77-405-74,22,22,45,44,67,65,29,28,58,56,86,84,8,8,16,15,0,31-15,16-23,8-31,0-29-28-58-56-86-84-29-28-58-56-86-84-3-3-6-6-8-9-113,9-230,39-359,93-81,34-164,60-245,75,60,58,111,123,151,197,42,76,74,160,95,253,2,11,5,21-16,26s-24-6-26-16c-20-89-51-170-91-242s-90-136-149-192c-6-5-11-11-9-19-75,11-150,12-222,1l89,147c5,10,9,20-10,29-20,9-25,0-29-10l-82-172c-69-14-137-40-200-79,21,79,37,164,49,254,16,119,26,246,29,380,0,11,1,22-21,22s-22-11-22-21c-3-133-12-259-28-375-15-107-35-208-63-300-31-24-61-52-90-84-72-79-152-140-240-187,5,37,5,73,0,109-9,66-36,133-88,198-7,9-13,17-31,4-17-14-11-22-4-31,47-59,71-118,79-177,6-42,4-85-5-127-137-63-288-94-444-107,42,55,82,110,118,167,42,66,80,133,114,201,62,51,95,113,114,181,18,67,22,139,25,212,0,11,1,22-21,23s-22-10-23-21c-2-70-6-139-23-202-17-61-47-117-102-161-1-1-6-6-6-7-34-68-72-135-113-201-42-66-88-130-139-192l-2-2c-53-3-106-4-159-3,9,12,18,24,26,37,19,31,32,65,36,104,1,11,2,22-20,24s-23-9-24-20c-4-32-14-60-30-86-13-21-28-40-47-58-110,3-219,12-324,21,110,141,198,287,266,437,76,167,127,339,156,517,2,11,4,22-18,25-21,4-23-7-25-18-29-174-79-343-153-506-71-155-163-306-279-451-5,0-11,1-16,1-85,8-171,26-253,49,37,23,69,46,97,69,38,31,68,62,94,93,7,9,14,17-3,31s-24,6-31-3c-24-29-53-59-88-88-35-28-76-57-126-86-44,14-87,30-130,47-24,9-47,18-71,25,74,53,145,111,213,176,82,79,159,168,228,271,6,9,12,18-6,30s-24,3-31-6c-67-100-141-187-221-264-75-72-155-135-238-193-90,20-181,25-272,22,56,111,105,223,142,336,40,122,68,245,77,370,1,11,2,22-20,24s-23-9-24-20c-9-122-36-241-75-360-40-119-92-236-151-352-55-4-111-11-167-18,32,102,60,207,84,314,28,126,51,255,68,386,1,11,2,22-19,25-22,3-23-8-25-19-16-130-39-258-67-382-26-116-57-230-93-342-158-171-333-338-547-427,44,56,79,114,104,175,39,94,57,194,54,299,0,11-1,22-22,21-22,0-22-12-21-22,2-99-14-193-51-282-33-79-81-153-148-222-48-14-99-25-151-30-140-14-281-23-422-28,108,98,193,188,185,297-1,11-2,22-24,20s-21-13-20-24c7-101-93-192-210-296-84-3-169-4-253-5,46,47,86,94,118,141,44,64,75,128,90,192v3c9,99,33,186,77,258,43,71,105,126,190,165,10,5,20,9,11,29s-19,16-29,11c-93-42-161-104-209-182-47-77-73-169-83-274-14-58-42-117-83-176-38-55-87-111-145-167-94,0-187-1-281-1,39,111,66,225,85,341,22,142,32,287,35,434,0,11,0,22-22,22s-22-11-22-21c-2-145-12-289-34-428-19-119-47-235-88-348h-26c-61-100-118-144-206-185-1,10-2,20-5,29-7,30-19,60-40,90-6,9-13,18-31,6s-12-21-6-30c17-25,28-50,33-74,3-13,5-26,5-40-14-6-29-12-45-19-45-188-87-266-237-330-1,52-4,106-14,161-12,68-34,137-75,203-6,9-12,19-30,7-19-12-13-21-7-30,38-61,58-124,69-187,10-57,13-115,13-171-8-3-17-6-26-9-40-263-88-410-361-514,3,34,4,69,2,104-3,59-14,119-38,181-4,10-8,21-28,13s-16-18-13-28c22-57,32-113,35-168,3-52-1-104-8-155-58-66-141-129-212-199,2,97-11,193-38,290-33,117-87,235-163,352-6,9-12,19-30,7-19-12-13-21-7-30,73-113,126-227,158-340,31-108,42-217,34-326-31-34-57-71-75-110-2,5-4,10-6,14-11,24-21,48-32,72-5,10-9,20-29,12-20-9-16-19-12-29,11-24,21-48,32-72,8-19,17-39,25-58-2-12-4-24-5-37-9-84-54-149-115-204l-1-1c-8,26-18,53-30,79-19,41-44,81-76,122-7,9-13,17-31,4-17-14-10-22-4-31,30-38,53-76,71-113,15-32,26-64,34-97-28-33-48-67-64-104-10,24-24,48-42,72-21,28-48,55-82,83-8,7-17,14-31-3s-5-24,3-31c31-25,55-50,74-75s32-49,41-74c14-39,19-14,6-77,23-124-23-198-89-301,1-3,2-5,4-8-39,1-84,14-133,35-59,26-124,65-192,112-9,6-18,12-30-6-13-18-4-24,6-30,71-48,138-88,199-115,62-27,119-42,168-39,12-33,13-58,5-96-200,74-358,109-485,117-133,8-235-13-320-49-10-5-20-9-11-29,8-20,19-16,29-12,79,34,174,54,300,46,125-8,279-42,477-116-1-2-1-4-2-6,36-80,65-158,85-236-71,19-141,18-211,16h-14c-11,0-22-1-22-22,0-22,12-22,22-22h14c74,1,148,3,221-21,5-26,9-52,13-78,11-87,113-108,185-30,60,64,115,132,174,160,120,57,255,6,352-72-29-9-59-19-89-29-11-3-21-7-14-27,7-21,17-18,27-14,38,12,76,24,114,37,9-9,18-18,26-27,248,21,409-31,568-191-141,3-267-1-376-13-120-14-219-38-292-74-10-5-20-10-10-29,10-20,20-15,29-10,68,34,163,57,278,70,117,13,255,17,412,12h2c14-16,28-33,43-51,68-28,136-59,186-115-289-31-564-88-823-223-67-75-173-117-286-146-210-26-396,26-567,115-45-42-80-80-124-121-66-8-128-43-194-51-88-10-180,7-268-3-11-1-22-2-19-24,2-22,13-21,24-19,88,10,180-7,268,3,85,10,166,47,251,57,284-107,519-166,722-157,237-69,483-98,729-92-3-2-6-5-9-8-29-29-15-44,0-58,133-135,164-259,121-371-44-116-164-225-331-325-178,20-349-28-538-7-118,13-234,39-348,77,95,34,178,90,246,170,84,99,144,234,176,404,4,20,7,41-33,48-40,8-44-13-48-33-29-155-83-277-158-366-79-113-260-157-317-180-189,19-375,40-537,82-122,31-229,74-311,138,122-26,249-21,359,34,105,52,194,150,250,309,7,19,13,39-26,52s-46-6-52-26c-47-137-121-219-208-262-173-86-530-11-681,101-88,66-176,151-263,250-16,19-33,37-70,5-37-33-21-51-4-69,91-103,183-194,278-264,92-68,187-117,285-140,100-111,248-178,419-222,167-43,358-65,552-84-57-115-130-184-214-221-90-40-193-46-305-35-233,80-440,205-639,346,18,0,36,0,53,1,59,4,112-5,161,14,19,7,39,14,25,53-17,47-146,18-191,15-51-3-107,1-169,16-9,2-19,5-28,2-243,150-417,302-619,473l-34,12c-180-7-304,18-378,74-67,51-72,131-59,239-31,101-70,212-80,330-211,181-446,362-555,626-24,77-65,145-116,206,43,7,78,20,105,41,10,8,19,16,27,26,5-45,12-90,23-133,15-62,37-119,66-165,6-9,12-18,30-6,19,12,13,21,7,30-27,41-47,94-61,152-17,69-26,145-28,215-1,22-41,24-44,2-5-37-21-66-47-85-27-20-65-32-114-36-45,49-96,93-147,134-42,34-82,71-91,126-6,96,112,113,224,120,255,15,52,160,192,287,68,47,131,102,179,169,97,35,157,27,223-3,13-173-2-261,74-261h8c4-22,9-44,18-66,13-32,32-65,58-97,7-8,14-17,31-3s10,22,3,31c-23,29-40,58-51,86-9,24-15,48-18,72,13,26,10,77,9,168,145-71,277-89,425-96,277-324,395-242,152-6-14,27-27,51-39,74-42,81-69,144-78,254-71,62-419,348-289,454,91-13,148-9,113,59-43,91-173,280-130,384,16,38,72,34,127,21,4-4,8-7,12-11,91-74,187-159,277-258,89-97,172-208,239-335,9-18,18-35,44-29,27-100,59-199,95-299,37-103,79-207,124-311,7-15,28-18,38-4,38,55,75,95,112,121,33,24,66,35,98,35s65-11,98-33c36-25,72-63,109-115,6-9,13-18,31-5s12,21,5,31c-40,56-79,97-120,125s-81,42-123,41c-41,0-82-15-123-44-33-24-67-57-100-101-39,91-75,182-108,273-37,101-69,203-97,304,23,19,13,37,4,55-72,135-160,252-254,355-76,84-157,158-236,225,11,74,30,144,64,216,151-130,292-262,416-398,124-137,232-278,317-425,6-9,11-19,30-8s13,21,8,30c-44,76-94,150-148,223,10,15,2,21-6,28-16,13-25,65-29,132-6,91,0,204,10,285,1,11,3,22-19,25s-23-8-25-19c-11-85-16-201-11-293,1-24,4-46,7-66-33,39-67,78-102,117-126,139-270,273-424,405-1,1-3,2-4,3,4,8,9,16,14,24-134,97-243,131-93,261,50-36,100-72,150-108l160-115c9-6,18-13,31,5s4,24-5,31l-161,115c-52,37-103,74-155,111-3,61,11,105,38,153,13-2,24-3,33-3,112-81,224-163,336-244,9-7,18-13,31,5s4,24-5,31c-108,79-217,158-326,237-7,13-21,30-39,50-110,79-494,316-453,480v1c92-26,184-58,272-103,91-47,180-110,264-196,8-8,15-15,31,0,15,15,8,23,0,31-87,89-179,153-274,203v4c-1,15-1,30-2,45s-1,30-2,45c-1,11-1,22-23,21s-21-12-21-23c1-15,1-30,2-45,1-8,1-17,1-25-78,36-157,63-237,85,33,155-48,288-131,421-47,38-431,349-271,442,43,21,91,31,139,36z'/%3E %3Cpath d='m214960,42248c-80-48-183-107-283-127-51-98-120-177-213-237-74-48-74-44-46-97,84-9,119-32,120-55,44,1,82,7,114,18,37,13,65,32,85,59,7,9,13,18,31,4,18-13,11-22,4-31-26-33-61-58-106-74-43-15-95-22-156-20-5,0-9,0-13,2-32-15-80-25-140-23-57-54-105-117-82-195,3,3,8,4,13,5,45,13,87,26,123,43,35,15,64,34,84,56,7,8,15,16,31,1s9-23,2-31c-25-27-58-48-98-67-29-13-61-25-95-35,330-67,625-62,920,113,155,64,228,138,312,252-28,24-56,47-84,71-193-5-335,22-424,90-80,60-96,168-99,276z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m221520,51380c-65,40-118,68-185,79,3-2,6-5,8-8,43-81,93-152,149-216,7-8,15-17,22-25,1,27,2,53,3,80,1,30,2,61,3,91z'/%3E %3Cpath d='m222347,53150c-44,66-98,126-159,181-60,54-128,105-201,153-9,6-19,12-31-6s-3-24,6-30c70-46,136-96,196-149,59-53,111-110,152-173,6-9,12-18,31-6,18,12,12,21,6,30z'/%3E %3Cpath d='m222894,52498c-28,42-55,84-83,127-6,9-12,18-31,6-18-12-12-21-6-30,28-42,55-85,83-127,6-9,12-18,31-6,18,12,12,21,6,31z'/%3E %3Cpath d='m222596,52456c-14,63-37,123-77,178s-99,104-184,143c-10,5-20,9-29-11s1-25,11-29c78-36,131-80,167-129,37-49,57-104,70-162,2-11,5-21,26-16s19,15,16,26z'/%3E %3Cpath d='m223132,51802c-22,22-41,47-58,75-16,28-31,58-42,92-4,10-7,21-28,14s-18-18-14-28c12-36,27-69,46-100s40-58,64-83c8-8,15-15,31,0,15,15,8,23,0,31z'/%3E %3Cpath d='m223570,51845c-19,62-37,125-60,187-23,64-51,127-87,190-6,9-11,19-30,8s-14-21-8-30c35-61,61-122,84-182,22-61,40-123,59-185,3-11,6-21,27-15s18,16,15,27z'/%3E %3Cpath d='m223371,49282c136,200,166,406,171,613,15-75,32-151,53-226,0-1,3-7,3-7,57-80,93-160,111-239s18-159,4-238c-2-11-4-21,18-25,21-4,24,7,26,18,15,85,15,171-4,256-19,84-56,168-115,252-37,139-64,279-90,419l-5,26c-4,21-44,18-44-4,0-16,0-31,1-47,3-261,6-523-163-771-6-9-13-18,6-31,18-12,25-3,31,6z'/%3E %3Cpath d='m223038,49711c-2,17-3,34-5,50-1,17-3,34-4,51-1,11-2,22-24,20s-21-13-20-24c1-17,3-34,4-50,1-17,3-34,5-51,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m222945,50293c34,111,60,224,79,340,13,79,21,159,25,241,9-15,19-29,30-43,36-45,84-84,141-117,9-6,19-11,30,8s2,25-8,30c-53,31-96,66-128,107-32,40-53,85-62,136-4,22-44,18-44-4,1-120-9-237-27-351s-44-225-77-334c-3-11-7-21,14-27s24,4,27,14z'/%3E %3Cpath d='m223409,50501c19,90,31,176,35,259s1,164-8,243c-1,11-3,22-25,19s-20-14-19-25c9-75,12-153,8-235-4-81-15-166-34-252-2-11-5-21,17-26,21-5,24,6,26,17z'/%3E %3Cpath d='m223807,50427c15,82,23,162,19,239-4,78-19,152-51,224-27,82-29,164-15,246,14,84,46,168,84,253,5,10,9,20-11,29s-25-1-29-11c-40-87-73-175-88-263-15-90-13-179,17-269,0,0,1-2,1-2,29-66,44-136,47-209,4-74-4-151-19-229-2-11-4-21,18-25s24,7,26,18z'/%3E %3Cpath d='m223999,49767c-10,41-20,83-31,125-10,41-20,83-31,125-2,11-5,21-26,16s-19-16-16-27c10-41,20-83,31-125,10-41,20-83,31-125,3-11,5-21,27-16,21,5,19,16,16,27z'/%3E %3Cpath d='m223802,48671c12,38,23,76,35,114,3,11,6,21-15,27-21,7-24-4-27-14-12-38-23-76-35-114-4-11-7-21,14-27s24,4,27,14z'/%3E %3Cpath d='m223903,47838c1,52,1,104-3,327-47,42-81,95-99,161-18,67-20,149-3,247,2,11,4,22-18,26s-24-7-26-18c-19-105-16-193,4-266,20-75,59-135,112-182l-9-139c-1-52-1-104-2-155,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m223076,47548c128,84,238,177,314,287,77,111,121,238,116,388-1,15-17,25-31,19-72-31-145-62-217-93,48,311,36,559-32,749-72,201-205,338-395,416-17,7-35-9-29-27,37-118,59-236,68-354s4-236-16-353c-2-11-4-22,18-25,22-4,24,7,25,18,20,121,26,243,16,364-8,106-26,211-56,318,155-76,265-198,327-371,68-191,78-445,24-767-3-17,15-31,30-24,74,32,149,64,223,96-2-126-42-234-108-329-73-105-178-194-302-275-9-6-18-12-6-31,12-18,21-12,30-6z'/%3E %3Cpath d='m225241,47122c-6,14-12,29-18,43s-11,29-17,43c-4,10-8,20-28,12s-16-18-12-28c6-14,12-29,18-43s11-29,17-43c4-10,8-20,28-12s16,18,12,28z'/%3E %3Cpath d='m224732,47111c42,17,76,40,104,68,28,27,49,59,67,94,5,10,10,20-9,29-20,10-25,0-29-9-16-31-35-59-59-83s-53-44-90-58c-10-4-20-8-12-28s18-16,28-12z'/%3E %3Cpath d='m223976,47328c55,61,91,132,110,213,19,79,22,167,12,261-1,11-2,22-24,20s-21-13-19-24c9-90,7-173-11-247-18-73-50-138-100-193-7-8-15-16,2-31,16-15,24-6,31,2z'/%3E %3Cpath d='m221421,47574c-3,29-6,58-9,86-3,29-6,58-8,86-1,11-2,22-24,20s-21-13-19-24c3-29,6-58,8-86,3-29,6-58,9-86,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m221895,47324c12,41,24,82,37,123l11,37c3,11,6,21-15,27s-24-4-27-15l-11-37c-12-41-24-82-37-123-3-10-6-21,15-27s24,4,27,15z'/%3E %3Cpath d='m222867,47977c5,18,8,36,9,53,1,18,1,35,0,53-1,11-2,22-24,20s-21-13-20-24c1-15,1-31,0-46-1-16-4-31-8-46-3-11-6-21,15-27s24,5,27,16z'/%3E %3Cpath d='m223202,47237c21,21,35,44,40,66,6,24,2,48-10,71-5,10-11,20-30,9-19-10-14-20-9-30,7-14,9-27,6-41s-13-30-28-46c-8-8-15-15,0-31,15-15,23-8,31,0z'/%3E %3Cpath d='m220882,47354c0,52,8,102,25,148,17,47,44,91,82,132,51,58,77,115,91,173,14,57,15,113,18,168,0,11,1,22-21,23s-22-10-23-21c-2-54-4-108-16-160-13-52-36-103-81-155-42-45-71-94-91-146-19-52-28-107-28-164,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m221821,47986c52,97,81,192,92,288,12,95,6,192-11,293-19,117,6,231,70,338,59,100,152,195,272,283-37-129-59-256-54-379,6-144,50-283,151-414,43-56,72-114,92-173,21-59,32-119,40-177,1-11,3-22,24-19,22,2,20,13,19,24-8,62-20,124-41,186s-53,125-99,185c-95,124-136,254-142,389-6,137,24,279,70,425,6,19-17,35-33,25-151-102-266-214-337-333-69-117-97-240-75-367,16-97,21-190,10-281s-38-180-87-272c-5-9-11-19,9-29,19-11,25-1,30,9z'/%3E %3Cpath d='m221444,48563c0,104-29,208-81,312-41,82-95,163-159,244,33-13,67-26,100-42,58-27,116-59,174-103,40-30,81-65,121-107,41-42,82-91,124-149,6-9,13-18,31-5s11,22,5,31c-43,59-86,110-128,154-38,39-76,73-114,102,6,27,10,47,14,68,5,25,10,50,15,76,2,11,5,21-17,26-21,5-24-6-26-17-7-31-11-54-16-77-3-16-6-32-10-48-52,37-105,65-156,89-60,28-119,49-178,71-19,7-37-19-24-35,84-100,155-199,204-298,49-98,77-195,77-292,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m220985,48526v99c0,11,0,22-22,22s-22-11-22-22v-99c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m220697,47964c60,147,76,284,53,412-22,128-83,247-174,359,0,0-3,3-3,3-87,75-152,165-200,266-33,68-58,141-77,218,24-33,48-64,77-93,57-58,125-103,215-128,92-51,179-107,260-170,82-64,158-134,228-213,7-8,15-16,31-2s9,22,2,31c-72,81-150,153-234,218s-173,123-268,175c0,0-5,2-5,2-82,22-145,64-198,117s-95,119-136,187c-11,18-44,6-40-15,22-124,55-241,105-347s118-200,210-279c86-106,143-218,164-338s6-249-51-388c-4-10-8-20,12-29,20-8,25,2,29,12z'/%3E %3Cpath d='m221630,49460c-14,40,15,77,74,153,13,17,27,35,40,52,79,105,108,224,110,349,2,122-21,249-45,372-4,21-40,20-43-1-20-136-78-256-163-363-86-108-201-204-333-292-9-6-18-12-6-31,12-18,21-12,30-6,136,91,254,190,343,302,68,85,119,177,149,278,15-87,26-174,25-258-2-116-29-226-101-323-15-21-28-37-39-51-69-89-102-132-81-194,4-10,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m222028,49434c16,17,33,34,49,52,16,17,33,34,49,52,8,8,15,16-1,31s-24,7-31-1c-16-17-33-34-49-52-16-17-33-34-49-52-7-8-15-16,1-31s24-7,31,1z'/%3E %3Cpath d='m222516,49591c-31,98-61,195-91,293-31,98-61,195-92,293-3,11-6,21-27,14-21-6-18-17-14-27,31-98,61-195,91-293,31-98,61-195,92-293,3-11,6-21,27-15,21,7,18,17,14,28z'/%3E %3Cpath d='m222792,51228c-9,25-9,49,0,73,4,10,8,21-13,28-20,8-24-2-28-13-13-35-13-70,0-105,4-11,8-21,28-13,21,8,17,18,13,28z'/%3E %3Cpath d='m222502,50747c-13,51-27,103-40,154-13,52-26,103-40,155-3,11-6,21-27,16-21-6-19-16-16-27,13-52,27-103,40-155,13-51,27-103,40-154,3-11,5-21,27-16,21,5,19,16,16,27z'/%3E %3Cpath d='m222084,50745,38,38c8,8,15,15,0,31-16,15-24,8-31,0l-38-38c-8-8-15-15,0-31,16-15,24-8,31,0z'/%3E %3Cpath d='m221593,50510c-10,29-20,58-31,87-10,29-20,58-31,87-4,10-7,21-28,13-20-7-17-18-13-28,10-29,20-58,31-87,10-29,20-58,31-87,4-11,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m220890,51253c-27,29-45,61-58,94-13,34-20,69-26,106-2,11-4,22-25,18-22-4-20-14-18-25,7-39,15-77,29-114,14-38,35-74,66-108,7-8,15-16,31-1s9,23,1,31z'/%3E %3Cpath d='m218878,53224c-10,22-24,45-43,67-18,22-40,43-67,65-8,7-17,14-31-4-14-17-5-24,3-31,25-19,45-39,61-59,16-19,28-38,36-56,5-10,9-20,29-12,20,9,15,19,11,29z'/%3E %3Cpath d='m219193,53057c-9,22-24,41-43,57-18,15-41,28-68,39-11,4-21,8-28-13-8-21,3-25,13-28,22-8,41-19,55-31s24-26,31-41c4-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m219611,52802c-7,12-15,24-26,36s-26,24-45,36c-9,6-19,12-30-7s-2-25,8-30c16-9,27-19,36-28,8-9,15-19,21-28s11-19,30-7c19,11,13,20,8,30z'/%3E %3Cpath d='m220240,51166c-20,59-34,117-39,175s-2,116,10,173c2,11,5,21-16,26s-24-6-26-17c-14-62-17-125-11-187s20-124,41-185c4-11,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m220668,46813c-2,49-15,97-38,145s-56,95-99,142c-7,8-15,16-31,1s-9-23-1-31c40-44,71-88,92-131,20-43,32-86,33-128,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m220231,46427c38,66,61,133,74,200,13,66,16,133,12,199,0,11-1,22-23,21s-21-12-21-23c4-63,1-125-11-188-12-62-34-125-69-187-5-9-11-19,8-30s25-1,30,8z'/%3E %3Cpath d='m219652,47145c-79-58-135-117-171-176-36-61-49-122-40-184,2-11,4-21,25-18,22,4,20,14,18,25-8,52,4,103,34,155,32,54,85,108,159,163,9,6,18,13,5,31s-22,11-31,5z'/%3E %3Cpath d='m220293,48234v48,47c0,11,0,22-22,22s-22-11-22-22v-47-48c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m219474,47409c129,122,206,269,247,432,26,101,37,208,39,320,1,0,3-1,5-1,58-20,103-72,134-155,33-88,50-210,53-365,0-1,2-10,3-11,46-75,74-151,93-226s28-152,35-229c2-19,28-27,40-11,75,106,141,216,192,334s85,243,98,379c1,11,2,22-20,24s-23-9-24-20c-12-130-46-251-94-365-41-97-93-188-153-277-6,58-15,117-30,176-19,78-48,155-95,233-3,158-21,283-55,374-36,97-90,157-161,181-7,2-13,4-19,1-1,54-4,109-8,165-1,11-2,22-24,20s-21-13-20-24c15-182,11-355-29-511-39-155-113-295-235-411-8-7-16-15-1-31s23-8,31-1z'/%3E %3Cpath d='m219954,49462c-9,58-18,115-27,173-9,57-18,115-27,172-1,11-3,22-25,18-21-3-20-14-18-25,9-58,18-115,27-172,9-58,18-115,27-173,2-11,3-21,25-18,21,4,20,14,18,25z'/%3E %3Cpath d='m219032,49853c8,44,16,87,24,131,2,11,4,21-18,25-21,4-24-7-26-18-8-44-16-87-24-131-2-11-4-21,18-25,21-4,24,7,25,18z'/%3E %3Cpath d='m219829,48795c-11,87-33,171-67,252-35,81-83,160-146,235l-1,1c-79,86-117,175-129,268s1,190,27,289c3,11,5,21-16,27-21,5-24-5-27-16-27-103-41-205-28-305,13-101,55-199,140-292,60-71,106-146,139-223,33-78,54-158,64-241,1-11,3-22,24-19,22,3,20,14,19,25z'/%3E %3Cpath d='m219621,48485c15,84,2,167-33,251-35,81-91,163-163,244,0,0-2,2-2,2-75,63-128,132-170,203-42,72-73,147-104,223-4,10-8,20-29,12-20-8-16-18-12-28,31-77,63-154,107-229s100-147,178-213c68-77,121-154,154-231,32-75,44-151,30-225-2-11-4-21,18-26,21-4,24,7,26,18z'/%3E %3Cpath d='m218604,48968c24,168-2,312-65,438-62,126-161,234-282,331-8,7-17,14-31-4-14-17-5-24,4-31,116-93,211-197,270-316s84-254,61-413c-1-11-3-22,19-25s23,8,25,19z'/%3E %3Cpath d='m217305,49687c13,26,25,52,37,78,14,28,27,55,40,83,5,10,9,20-10,29-20,9-25,0-29-10-13-28-27-55-40-83-12-26-25-52-37-77-5-10-9-20,10-29,20-9,25,0,29,10z'/%3E %3Cpath d='m216790,49697c-1,99,7,197,31,291,25,94,65,185,131,272,0,0,2,4,2,4,33,67,52,134,65,202,9,50,15,100,18,150,63-67,111-135,146-206,40-82,61-167,63-255,0-11,0-22,22-21,22,0,22,11,21,22-2,94-25,185-67,273-43,88-106,172-189,253-13,13-36,4-37-15-3-65-8-130-20-193s-30-126-60-189c-68-91-111-187-137-286s-34-200-33-303c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216860,51456c4-54,12-107,25-162,13-54,29-107,51-161,4-10,8-20,28-12,21,8,16,18,13,28-21,52-37,104-49,155s-20,103-24,154c-1,11-1,22-24,20-22-1-21-12-20-23z'/%3E %3Cpath d='m216800,51946c9-65,18-130,27-195,1-11,3-22,25-19s20,14,19,25c-9,65-18,130-27,195-1,11-3,22-25,19s-20-14-19-25z'/%3E %3Cpath d='m216463,52767c32-32,63-70,92-112,30-43,58-90,86-139,5-10,11-19,30-9,19,11,14,20,8,30-28,51-58,99-88,143-31,44-63,84-98,118-8,8-16,15-31,0s-7-23,0-31z'/%3E %3Cpath d='m215976,50012v81c0,11,0,22-22,22s-22-11-22-22v-81c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m215152,51910c-1-20-2-40-4-60l-4-61c0-11-1-22,21-23s23,9,23,21l4,60c1,20,2,40,4,60,0,11,1,22-21,23s-23-9-23-21z'/%3E %3Cpath d='m217221,48534c-42,145-75,296-72,425,2,125,37,229,127,287,105,68,151,170,195,269,3,6,5,12,8,18,13-49,24-101,29-153,7-64,7-126-2-182-2-11-4-22,18-26,21-4,24,7,25,18,10,60,10,127,3,194-8,75-25,151-47,217-6,18-32,20-40,3-11-23-22-47-33-72-41-93-84-189-179-250-104-67-145-184-148-323-2-134,31-289,74-438,3-11,6-21,27-15s18,16,15,27z'/%3E %3Cpath d='m217076,47981c14,113,10,217-9,322-19,104-53,208-98,321-53,135-77,278-70,422,7,143,44,285,110,420,5,10,10,20-10,29-20,10-25,0-29-10-70-140-108-289-115-437-7-150,18-299,73-440,44-110,77-212,95-313,19-100,23-200,9-308-1-11-3-22,19-25,21-3,23,8,25,19z'/%3E %3Cpath d='m216115,49349c-30,66-36,132-25,198,12,67,41,135,82,203,6,9,11,19-7,30-19,11-25,2-30-8-43-72-75-145-87-218-13-74-6-149,28-223,5-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m215696,49199c7,39,9,85,5,131-4,40-14,79-30,114v1c-19,37-23,74-16,111,8,39,28,78,55,118,6,9,12,18-6,31s-24,4-31-6c-31-44-53-89-62-134-9-47-5-93,20-140,14-30,22-64,26-99,4-41,2-83-4-119-2-11-4-22,18-25,22-4,24,7,25,18z'/%3E %3Cpath d='m218146,45570c-13,115-7,223,16,326,23,102,62,200,116,293,6,9,11,19-8,30s-24,1-30-8c-55-96-97-198-121-305s-31-220-16-340c1-11,2-22,24-19,22,2,21,13,19,24z'/%3E %3Cpath d='m217839,45867c57,101,106,210,143,329s62,250,71,395c1,11,1,22-21,23s-22-10-23-21c-8-141-33-268-69-384s-84-221-139-320c-5-10-11-19,8-30s25-1,30,8z'/%3E %3Cpath d='m216317,45914c-147,209-211,379-223,526-12,146,27,268,85,381,0,0,1,3,1,3,40,116,58,231,55,347-2,115-26,231-67,346-4,11-7,21-28,13-21-7-17-18-13-28,40-111,62-221,65-332,2-110-14-220-52-330-61-119-102-249-89-403s79-332,231-548c6-9,13-18,31-6,18,13,12,22,5,31z'/%3E %3Cpath d='m217736,45312c13,63,7,129-22,193-26,59-71,115-138,168-68,53-108,122-126,205-19,85-15,184,6,295,2,11,4,22-18,26-21,4-24-7-26-18-21-117-25-221-5-312,20-92,65-170,142-230,61-48,101-99,125-151,25-55,30-112,19-166-2-11-5-21,17-26,21-4,24,7,26,17z'/%3E %3Cpath d='m216233,45441c29,93,30,184,3,275-26,90-80,179-162,266,0,0-2,2-2,2-79,66-127,150-157,243-31,95-42,201-48,311-1,11-1,22-23,21s-21-12-21-23c6-113,18-222,50-322s84-190,169-262c77-82,127-165,152-248,24-82,23-166-3-250-3-11-7-21,14-27s24,4,27,15z'/%3E %3Cpath d='m217093,45486c-5,34-5,66,0,98,5,31,17,61,37,90,6,9,12,18-6,31-18,12-24,4-31-6-24-35-38-71-44-107-6-37-6-74,0-111,1-11,3-22,25-19s20,14,19,25z'/%3E %3Cpath d='m217052,45260c-79,33-139,89-182,169-42,79-67,181-75,306,5,6,8,11,8,15,42,57,71,125,89,201,20,83,27,177,24,279,0,11-1,22-23,21s-21-12-21-22c3-99-4-189-23-268-16-67-41-127-76-177-163,152-243,320-248,503-6,191,69,399,213,621,6,9,12,19-6,31s-24,2-30-7c-149-230-226-446-220-646,6-197,92-377,269-539v-1c7-137,34-249,81-337,48-89,115-152,204-189,10-4,20-8,29,12,8,20-2,25-12,29z'/%3E %3Cpath d='m216808,44944c-2,18-4,32-5,47-11,104-22,221-101,292-44,39-72,85-92,134-20,51-30,106-37,164-1,11-2,22-24,19-22-2-20-13-19-25,7-61,19-120,40-175,22-56,54-107,103-151,66-59,78-168,87-263,2-18,4-35,5-48,1-11,3-22,25-19s20,14,19,25z'/%3E %3Cpath d='m219197,47493c26,54,47,110,61,167s21,116,18,177c0,11-1,22-23,21s-21-12-21-23c3-57-4-111-16-165-13-53-34-106-59-158-5-10-9-20,11-29s24,0,29,10z'/%3E %3Cpath d='m219204,48277c19,90,20,182,4,274s-50,186-100,281c-34,79-67,158-101,237-5,10-9,20-29,12s-16-19-12-29c34-79,67-159,101-238,0,0,1-2,1-2,49-91,81-180,97-268,15-87,14-174-4-258-2-11-4-22,17-26,21-5,24,6,26,17z'/%3E %3Cpath d='m218706,47547c143,159,236,327,280,504,45,177,40,363-14,557-3,11-6,21-27,15s-18-16-15-27c52-187,57-365,14-535s-133-332-271-486c-7-8-14-16,2-31s24-6,31,2z'/%3E %3Cpath d='m218662,48427c-44,93-93,186-153,279s-130,186-213,279c-48,53-92,112-130,177-38,66-71,138-97,219-6,20-44,13-42-8,4-66-4-132-22-198s-48-133-88-199v1c-80-118-114-237-108-355,7-118,54-235,138-352,48-82,82-165,106-247s36-165,39-248c0-11,1-22,23-21s21,12,21,23c-4,86-16,172-41,258s-61,172-111,258c0,0-1,2-1,2-79,111-124,221-130,330-6,110,27,219,101,329l1,1c42,70,73,140,93,211,9,33,16,66,20,99,19-43,39-84,62-122,40-68,86-130,136-185,82-91,151-183,209-274,59-92,108-183,150-274,5-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m217357,48007c-3,109,7,211,29,307,22,95,58,184,108,266,6,9,11,19-7,30-19,12-24,2-30-7-52-86-90-179-113-278-23-100-33-206-30-318,0-11,1-22,22-21,22,1,22,12,21,22z'/%3E %3Cpath d='m216614,48405v64,64c0,11,0,22-22,22s-22-11-22-22v-64-64c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216860,47726c2,75-8,148-31,218-24,70-61,137-115,200-7,8-14,17-31,2-17-14-9-22-2-31,50-59,85-121,106-186,22-65,31-133,29-203,0-11-1-22,21-22s22,11,22,21z'/%3E %3Cpath d='m216191,49044c-120-299-149-536-119-729,30-195,120-343,238-464,79-81,148-161,193-261s66-220,50-382c-1-11-2-22,20-24s22,9,24,20c16,170-6,297-54,404-47,106-119,190-201,274-112,114-197,256-226,440-29,186,0,416,117,707,4,10,8,20-12,28s-25-2-29-12z'/%3E %3Cpath d='m215805,48553c-18,48-25,97-19,145,5,48,23,97,53,146,6,9,12,19-7,30-19,12-24,2-30-7-33-54-53-109-59-164s1-110,22-165c4-10,8-20,28-13,21,8,16,18,13,28z'/%3E %3Cpath d='m217703,47205c79,111,125,226,134,346s-18,244-86,373c-5,9-10,19-29,9-20-10-14-20-9-29,64-121,90-237,81-349-8-112-52-220-126-324-7-9-13-18,5-31s24-4,31,5z'/%3E %3Cpath d='m218296,46741c48,115,73,232,78,350,5,117-12,236-48,355-6,20-42,16-43-6-4-110-27-209-68-296s-102-162-181-226c-8-7-17-14-3-31s22-10,31-3c85,68,149,148,193,241,27,57,47,119,59,185,13-73,19-146,16-219-4-112-28-224-74-334-4-10-8-20,12-29,20-8,25,2,29,12z'/%3E %3Cpath d='m218648,46260c78,77,133,179,167,305,33,124,45,270,39,437v1c-8,71-11,140-3,204,7,63,25,121,58,173,6,9,12,19-6,31-19,12-25,2-31-7-37-58-57-123-65-192-8-68-5-140,3-214v1c6-163-6-305-37-424-32-118-83-213-155-285-8-8-16-15,0-31,15-16,23-8,31,0z'/%3E %3Cpath d='m217714,46167c-51,62-82,135-97,216-15,82-13,172,2,270,2,11,4,21-18,25-21,4-23-7-25-18-16-102-18-198-2-285,16-88,51-167,106-236,7-8,14-17,31-3s10,22,3,31z'/%3E %3Cpath d='m215883,47400c-8,182-61,330-146,452-85,121-201,217-338,297-9,6-19,11-30-8s-2-24,8-30c131-77,243-169,324-285,81-115,131-255,139-428,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m215836,46770c10,68,6,134-9,200-15,65-41,130-74,197-5,10-10,19-29,10-20-10-15-20-10-29,32-64,57-126,71-187s18-121,9-184c-1-11-3-22,19-25s24,8,25,19z'/%3E %3Cpath d='m217076,46679v62c7,107,14,215,21,322l2,29c1,11,1,22-20,24h-7c-3,4-8,6-18,6-22,0-22-11-22-22v-356c-2-29-4-58-6-87-1-11-2-22,20-24,22-1,23,9,24,20v7c5,4,5,11,5,18z'/%3E %3Cpath d='m217375,46126c-88,107-123,210-125,311s29,202,75,302c104,167,138,333,127,500-10,166-65,331-138,496-5,10-9,20-29,11s-15-19-11-29c72-160,124-321,134-481,10-159-22-317-121-476,0,0-1-2-1-2-49-106-82-213-80-323,2-111,41-223,135-338,7-8,14-17,31-3s10,22,3,31z'/%3E %3Cpath d='m215452,42697c145-111,287-174,436-190,148-15,301,17,467,95,55-1,110-1,165-2,56-1,113-2,169-2,11,0,22,0,22,22s-11,22-22,22c-57,1-113,2-169,2-51,1-101,1-152,2-1,1-2,2-3,3-178,157-330,243-465,271-139,29-259-2-368-80-11-8-22-16-7-38s27-15,38-7c98,68,204,96,326,71,118-25,252-98,409-231-144-63-276-88-403-75-138,14-272,74-409,179-11,8-22,16-38-5-16-22-6-30,5-38z'/%3E %3Cpath d='m215882,42613c61,0,110,49,110,110,0,60-49,110-110,110-60,0-110-49-110-110s49-110,110-110z'/%3E %3Cpath d='m216639,43278c79-41,140-85,191-130,50-45,90-91,124-137,6-9,13-18,31-5s11,22,5,31c-36,49-78,98-130,145-53,47-117,92-200,135-10,5-20,10-29-9-10-19-1-25,9-29z'/%3E %3Cpath d='m218200,42632c41-11,81-11,122,1,40,11,79,33,118,65,8,7,17,14,3,31s-22,10-31,3c-34-28-69-47-102-56s-66-9-99-1c-11,3-21,6-27-16-6-21,5-24,15-27z'/%3E %3Cpath d='m217307,42668c35-80,88-141,161-180,72-38,163-54,274-44,11,1,22,2,20,24s-13,21-24,20c-103-9-186,5-250,39-64,33-110,87-141,159-4,10-9,20-29,11s-16-19-11-29z'/%3E %3Cpath d='m217409,42814c6-39,22-74,49-101,26-28,63-48,113-62,11-3,21-6,27,15s-5,24-15,27c-41,11-72,28-92,50-20,21-32,48-37,78-2,11-4,21-25,18s-20-14-18-25z'/%3E %3Cpath d='m215923,43308c-24,38-46,77-62,119-15,42-23,87-20,140,1,11,2,22-20,23s-23-9-24-20c-4-59,6-111,22-158,16-46,40-88,66-128,6-9,12-19,30-7,19,12,13,21,7,30z'/%3E %3Cpath d='m216349,43499v66c0,11,0,22-22,22s-22-11-22-22v-66c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216072,43023c44,16,87,24,131,25,44,0,89-6,133-16,11-2,21-5,26,16s-6,24-16,27c-48,11-96,18-144,17-49-1-97-9-146-28-11-4-21-8-13-28,8-21,18-16,28-13z'/%3E %3Cpath d='m216346,42224c-37-1-66,10-88,27-29,22-47,53-55,80-3,11-6,21-27,15s-18-17-15-27c11-35,34-74,71-102,29-22,68-37,115-36,11,0,22,1,22,22,0,22-11,22-22,22z'/%3E %3Cpath d='m215903,42269c-33,14-59,30-79,46-18,15-30,32-35,48-4,11-7,21-28,14s-17-17-14-28c8-25,25-47,49-68,23-19,53-37,91-53,10-4,20-8,28,12,9,20-1,25-12,29z'/%3E %3Cpath d='m215630,42277c-27,19-50,39-69,62s-34,49-45,77c-4,10-7,21-28,13-20-7-17-18-13-28,12-33,30-63,52-90s48-50,78-71c9-6,18-12,31,6s4,24-6,31z'/%3E %3Cpath d='m215279,42558c-29,22-57,46-84,74s-52,58-76,91c-6,9-13,18-31,5s-11-22-5-31c25-35,52-67,80-96s58-55,89-78c9-7,18-13,31,4,13,18,4,24-5,31z'/%3E %3Cpath d='m215314,42945c-21,23-42,46-63,68l-64,68c-7,8-15,16-31,1s-9-23-1-31l63-68c21-22,42-45,64-68,7-8,15-16,31-1s9,23,1,31z'/%3E %3Cpath d='m214959,43048v136c0,11,0,22-22,22s-22-11-22-22v-136c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m215414,43646c-7,74-14,148-21,223-1,7-1,14-2,21-1,11-2,22-24,20s-21-13-20-24c1-7,1-14,2-21,7-74,14-149,21-223,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m215147,43448c-1,48-3,97-5,145,0,11-1,22-23,21s-21-12-21-22c1-49,3-97,5-146,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m214899,41554c46,17,87,41,120,73,34,33,60,74,77,124,4,11,7,21-14,28s-24-4-28-14c-15-44-38-79-66-107-29-28-64-49-105-64-10-4-20-8-13-28,8-21,18-17,28-13z'/%3E %3Cpath d='m217077,44394c42,95,65,190,66,284,2,95-17,190-57,285-4,10-8,20-28,12s-16-19-12-29c37-89,55-178,53-267-1-89-22-178-62-267-5-10-9-20,11-29s25,1,29,11z'/%3E %3Cpath d='m216367,45215c31-107,76-200,128-285s111-162,170-238c68-88,113-184,137-282,26-106,27-216,8-320-2-11-4-21,18-25,21-4,24,7,25,18,20,110,19,225-8,338-25,104-72,206-145,299-58,75-116,151-167,234-50,82-94,172-123,274-3,11-6,21-27,15s-18-16-15-27z'/%3E %3Cpath d='m215454,44974c15-40,37-75,67-106s67-57,111-78c10-5,20-9,29,10,9,20,0,25-11,29-40,19-73,42-99,69-26,26-45,57-57,91-4,10-8,21-28,13-20-7-17-18-13-28z'/%3E %3Cpath d='m215277,44910c34-44,68-85,107-121,40-37,85-68,137-89,10-4,20-8,28,12,8,21-2,25-13,28-47,19-87,47-123,80-37,34-70,75-102,116-7,9-13,18-31,4-18-13-11-22-4-31z'/%3E %3Cpath d='m216223,43972c38,17,74,25,109,26s69-4,102-13c11-3,21-6,27,15s-5,24-15,27c-37,11-75,16-115,15s-81-11-125-30c-10-5-20-9-11-29s19-15,29-11z'/%3E %3Cpath d='m215752,43911c11-13,22-25,33-38l4-5c7-8,15-16,31-2,16,15,9,23,2,31l-4,5c-11,13-22,25-34,38-7,8-14,16-31,2-16-14-9-23-2-31z'/%3E %3Cpath d='m225936,46849c21,23,39,47,55,73,15,26,27,53,37,82,4,11,7,21-14,27-21,7-24-4-28-14-8-26-19-50-33-73-13-23-30-45-49-65-7-8-15-16,1-31s24-7,31,1z'/%3E %3Cpath d='m214630,52155c48,44,98,84,153,112,54,27,114,44,182,44,11,0,22,0,22,22s-11,22-22,22c-75,0-141-19-202-49-59-30-113-72-163-118-8-7-16-15-1-31s23-9,31-1z'/%3E %3C/g%3E %3Cg fill='%23f00'%3E %3Cpath d='m223164,42025c251,11,493,1,699-33-220,159-501,266-804,316,59-46,97-94,114-143,16-47,13-94-9-140z'/%3E %3Cpath d='m222565,41963c163,27,332,46,499,57,2,4,5,7,7,11,27,37,35,73,23,108-14,40-52,82-114,125-17,12-34,24-10,57-111,14-224,20-339,18-58-1-115-4-173-9,6-3,12-9,17-14,61-64,100-130,111-199,8-51,2-102-21-153z'/%3E %3Cpath d='m218139,40691c282-37,569-46,861-39,96,39,167,96,211,171,48,84,65,194,45,331-3,20-6,41,35,46,41,6,44-15,46-35,22-156,2-283-55-383-28-48-64-89-108-124,26,1,52,2,78,4,336,18,597,114,889,259,2,2,5,5,7,8,62,65,83,132,73,201-11,73-55,152-125,233-13,16-27,31,5,58,31,27,45,11,58-5,79-93,131-185,144-275,7-51,3-99-15-147,246,122,496,239,739,367,5,3,10,5,15,8,0,5,2,11,4,16,20,69,12,128-22,179-37,53-104,99-201,135-19,7-38,14-24,53,14,38,34,31,53,24,114-43,194-98,240-166,39-57,54-120,45-191,161,87,322,177,487,256l1,1c29,58,34,110,11,158-24,51-80,99-169,143-18,9-37,18-19,55s37,28,55,19c107-53,175-114,207-182,22-47,28-95,18-146,57,25,115,49,174,71,159,59,351,110,557,148,1,2,3,4,5,6,38,53,51,104,42,153-9,51-40,103-90,155-14,15-28,29,1,58,5,5,9,8,13,11-625-64-1181-363-1763-588-69-27-139-53-208-80-215-81-432-191-648-279-7-7-18-11-28-14-15-5-29-10-44-14-9-4-19-7-28-11,1,1,3,2,4,3-197-63-396-112-598-140-224-31-452-37-686-7-13-2-25-4-38-6,20-123,4-231-57-325-43-67-108-126-198-175z'/%3E %3Cpath d='m217116,40966c287-125,578-205,875-254,136,54,226,120,277,198,49,77,61,167,44,271-126-12-251-11-373,2-137,15-271,46-403,93-66-139-155-223-259-269-51-23-105-36-161-42z'/%3E %3Cpath d='m220263,42558c-77-49-155-97-236-141-389-214-835-346-1282-363,4-3,7-7,11-10,159-162,194-315,140-458-42-111-139-214-273-307,150-8,289,1,445,23,220,31,505,105,765,210,64,140,82,263,54,367-29,109-111,200-243,275-18,10-36,20-16,56s38,26,56,15c153-86,247-194,282-326,27-102,19-216-26-343,176,79,335,173,446,276,145,100,288,201,428,307,1,178-51,279-137,332-91,55-221,62-369,47-20-2-41-4-45,37v2z'/%3E %3Cpath d='m221119,43202c-260-203-514-415-787-598,151,12,286,0,388-61,99-61,164-167,175-340,163,126,320,259,469,402,75,71,150,141,227,210,0,1,1,2,1,4,18,64,24,119,19,165-5,45-21,82-47,111-27,30-66,52-115,65-73,21-168,25-285,12-19-2-39-4-44,31z'/%3E %3Cpath d='m222016,43793c-90-46-176-94-259-143-199-118-386-253-569-394,112,9,206,3,282-18,65-18,117-48,154-89,38-42,61-94,68-158,3-28,3-58-1-90,179,153,367,295,570,419,106,65,213,126,319,183-1,7,0,14,1,22,13,82-33,134-117,167-98,39-244,55-411,65-19,1-37,2-39,34z'/%3E %3Cpath d='m222974,44169c-304-83-598-199-867-330,154-11,290-29,388-68,111-44,175-112,171-221,178,90,356,168,537,232,32,71,34,129,4,178-36,60-115,110-213,153-19,8-38,17-21,54v1z'/%3E %3Cpath d='m224970,43966c26-4,186-46,103,15-588,385-1334,384-2037,203,109-49,198-108,243-182,34-55,40-118,24-187,224,73,451,125,685,155,1,36-9,72-37,107-37,46-100,91-203,136-19,8-38,16-21,54,16,38,35,29,54,21,116-51,191-105,235-160,39-49,55-98,55-149,289,31,588,27,900-14z'/%3E %3Cpath d='m220904,54095c-44,46-81,97-117,157-171,57-322,142-506,134,0,119,39,171,158,172,227-114,278-135,298-119,28,24-32,187-220,319-29,18-28,29-11,59,159,249,576,160,800,101,160-42,449-232,529-392,31-73-39-169-109-247-177,27-238-55-210-112-187-66-395-80-612-72z'/%3E %3Cpath d='m214511,52080c-130,106-275,190-444,246-64,21-219,59-234,140-2,29,104,92,172,55,188-180,282-80,66,104-17,35-3,74,34,107,195,175,678,232,898,93,163-102,248-214,106-369,1-35,5-69,11-104l-269-27-165-96-175-149z'/%3E %3Cpath d='m218719,53544c-16,2-33,4-49,7-87,94,152,59,279,137,58,35,83,104,60,200-117,279-770,189-987,74-101-53-105-114-101-201,45,0,91-3,137-10,78-11,155-34,231-77,21-12,43-25,19-67-24-43-46-31-67-19-64,36-130,56-196,65-68,10-138,10-205,7h-17c-38-22-67-48-51-71,16-22,79,2,91,6,101-47,189-77,298-98,15-15,29-31,44-46,199,17,389,47,515,93z'/%3E %3Cpath d='m215700,53373c-40,24-54,58-83,121-114,115-223,184-369,250-121,55-4,108,81,166,77,57,178-67,241-161,69-104,139-73,94,8-50,89-86,217-91,284-26,72,248,127,295,129,167,8,377-155,508-238,109-111,92-208,44-343l1-9c-70,2-136-6-201-20-79-18-157-45-236-78-10-4-20-8-12-29,5-13,11-16,18-15l-288-66z'/%3E %3Cpath d='m216869,42243c46-2,92-4,137,1,85,10,166,47,251,57,284-107,519-166,722-157,237-69,483-98,729-92-3-2-6-5-9-8-29-29-15-44,0-58,133-135,164-259,121-371-44-116-164-225-331-325-178,20-349-28-538-7-118,13-234,39-348,77,95,34,178,90,246,170,84,99,144,234,176,404,4,20,7,40-33,48s-44-13-48-33c-29-155-83-277-158-366-79-113-260-157-317-180-189,19-375,40-537,82-122,31-229,74-311,138,122-26,249-21,359,34,105,52,194,150,250,309,7,19,13,39-26,52s-46-6-52-26c-47-137-121-219-208-262-173-86-530-11-681,101-88,66-176,151-263,250-9,11-19,21-31,22,324,22,650,39,902,140zm-961-183c-7-18,5-31,16-44,91-103,183-194,278-264,92-68,187-117,285-140,100-111,248-178,420-222,167-43,358-65,551-84-57-115-130-184-214-221-90-40-194-46-305-35-233,80-440,205-639,346,18,0,36,0,53,1,59,4,112-5,161,14,20,7,39,14,25,53-17,47-146,18-191,15-51-3-107,1-169,16-10,2-19,5-28,2-209,129-367,260-536,403,128,45,228,98,293,160z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230093dd' d='m240096,66034,8752-19837-6456-10424-11513,4263-5329,20965c5022,1281,9882,2973,14545,5034z'/%3E %3Cpath fill='%23fff' d='m228935,47685c5767,1471,11350,3414,16705,5782l-3377,7657c-4934-2181-10076-3971-15390-5326z'/%3E %3Cpath fill='%23f00' d='m242806,59894,2256-5113c-5283-2336-10790-4252-16479-5704l-1330,5231c5396,1377,10620,3195,15631,5410l-78,176z'/%3E %3Cpath fill='%23000' d='m230207,53061c151-95,312-72,474-46,131-49,282-66,446-60,70-38,151-65,243-82,49-38,51-79,7-123-41-50-64-99-67-149-260-151-356-381-455-609-148-39-217-89-233-145-72-7-143-14-214-22-337,37-424-72-544-161-100-33-187-88-243-193-37-47-74-93-111-140-92-117-64-272,75-263,98,11,195,11,285-28,105-47,262-46,381-36,141-8,230-99,367-227-1-55-1-109-2-164-22-59,6-85,84-77,183,6,292,92,366,214,213,37,381,139,494,318,283,1,474,108,497,213,17,77-66,165-194,259,1,19,2,39,2,58,76,66,126,132,152,197,159,61,311,143,453,263,405-47,1088,247,2011,836,599,107,1180,273,1738,514,118,4,236,7,353,11,1001-148,1971-34,2871,654,340,41,645,148,940,270,219,90,442,125,667,146,364,35,733,125,1099,295,411,92,795,221,1033,509,169,204,128,392-87,470-130,274-389,286-777,151-267,49-561-165-828-366-371-119-712-333-1049-561-175-131-352-214-524-251-135-29-256-48-337,0-40,24-35,38,0,67,94,79,160,197,181,339,19,125-1,269,6,422,8,161,105,278,267,378,111,68,243,140,434,167,91,18,117,71,114,140,51,244,98,490,187,711,25,63,73,93,145,146,247,178,119,377-106,420-197,174-367,291-569,337-161,54-227-12-281-91-97-2-146-41-187-104-197-145-29-397,442-289,10-55,50-72,90-71-28-122-44-258,9-385-42-27-78-61-139-81-170-54-331-132-458-251-241-227-618-417-981-608-300-15-523-153-758-270-106-1-212-3-318-4-93-31-169,1-225,68-94,114-203,95-332,80-148-17-298-6-446-8-73,18-145,41-224,42-167-9-330-11-441,82-92,97-184,90-276,54-69-32-119-66-148-102-116-24-191-53-216-88-195-55-250-110-241-165-259-62-136-266,32-273,198-8,379,30,573,57,163,46,364,19,497-101,86-78,118-145,223-203-335-22-582-81-764-196-490-309-882-384-1194-122-83,47-148,66-237,32-75-29-171-29-246-12-177,40-352,18-529-46-259,65-517,79-776,26-219,115-379,128-481,40-96-54-187-109-273-168-139-21-199-56-205-102-178-20-200-85-199-156-74-85-46-150,28-205,132-55,269-75,421,3,91,43,158,85,213,128,101-12,188,0,264,28,56-88,215-92,389-82,87-58,191-99,324-111-4-21-8-42-11-62-175-46-265-173-352-301-269-5-462-118-654-236-158,13-285-39-408-113-100,8-211,12-316-15-208,57-405,53-591,0-131,12-236-1-344-11-123,141-261,166-412,94-83-105-201-174-350-213-113-37-148-86-168-139-138-85-110-169,23-233,100-48,225-57,415,37,62,23,131,39,209,45z'/%3E %3Cpath fill='%23fff' d='m236801,55071c-13-23-41-81-142-23-313-17-663-13-926-168-274-161-556-329-859-317,90-85,202-143,332-178,174-46,380-49,608-12,320,52,602,114,820,196,210,79,358,177,423,303,2,3,15,18,18,20,84,54,157,109,218,167,46,43,86,88,120,136-99,9-201,2-301-18-110-22-216-59-312-108z'/%3E %3Cpath fill='%23000' d='m237521,39962,18,94,394,2040-1567,1366-72,63,91,32,1964,679,399,2040,19,94,72-63,1570-1361,1967,674,91,31-18-94-394-2041,1567-1366,72-63-91-31-1964-680-399-2040-19-94-72,63-1571,1362-1966-675z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m236561,43439,1464-1276,1841,634z'/%3E %3Cpath d='m240110,42750,1469-1277,1835,635z'/%3E %3Cpath d='m243427,42173-1464,1276-1841-634z'/%3E %3Cpath d='m239878,42863-1469,1276-1835-634z'/%3E %3Cpath d='m237729,40150,1837,630,372,1911z'/%3E %3Cpath d='m240101,42878,1840,634,368,1907z'/%3E %3Cpath d='m242259,45462-1837-629-372-1911z'/%3E %3Cpath d='m239887,42734-1840-633-368-1907z'/%3E %3Cpath d='m241162,39516,373,1906-1469,1277z'/%3E %3Cpath d='m239985,42934,371,1911-1467,1273z'/%3E %3Cpath d='m238826,46096-373-1906,1469-1277z'/%3E %3Cpath d='m240003,42678-371-1911,1467-1272z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='500' height='300'%3E %3Ctitle%3EFlag of Haiti%3C/title%3E %3Crect width='500' height='300' fill='%23d21034'/%3E %3Crect width='500' height='150' fill='%2300209f'/%3E %3Cg id='coa' fill='%23f1b517' stroke='%23000' stroke-width='0.1826'%3E %3Crect fill='%23fff' stroke='none' width='94.6416' height='75.3413' x='202.679' y='112.284'/%3E %3Cpath fill='%23016a16' stroke='%23016a16' d='m269.047,166.766-19.3141,0.56058-19.227,0.21862s-9.8781,3.65352-13.9162,4.4734c-4.02618,0.81746-3.50263,2.14025-6.61818,2.83651-2.49547,0.55768-2.78328,0.73353-4.24748,0.82965-0.88604,0.0582-1.97735,0.73987-3.04471,1.49113v10.4491h94.6416v-9.939c-1.02588-0.55902-2.0035-0.94359-3.00404-1.28372-1.39031-0.47263-2.32725-0.9895-4.82272-1.54718-3.11555-0.69626-2.592-2.01905-6.61818-2.83651-4.03807-0.81988-13.829-5.2526-13.829-5.2526z'/%3E %3Cg id='flags'%3E %3Cg id='flags_half'%3E %3Cg%3E %3Cpath d='m244.529,143.512,1.39696-0.0329,2.55541,10.749-0.54516,3.38576-3.40721-14.1018z'/%3E %3Cpath fill='%23fff' d='m243.064,136.346,0.95402,8.2836,1.02216-0.0657-1.97618-8.21786z'/%3E %3Cpath d='m245.722,154.589-4.29308-11.5379,1.60139-0.0986,5.0086,14.1018-2.31691-2.46536z'/%3E %3Cpath fill='%23fff' d='m239.419,136.477,1.77175,8.02063,1.43103,0-3.20278-8.02063z'/%3E %3Cpath d='m241.906,150.546-2.52134-5.42379,1.09031-0.2301,4.59973,9.00677-3.1687-3.35288z'/%3E %3Cpath fill='%23fff' d='m236.08,138.778,2.79391,7.62618,1.43103,0-4.22494-7.62618z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m242.249,151.364-11.4356-12.4841c-3.57164,2.82814-2.90807,8.02116-2.90807,8.02116l12.957,10.1661,1.38665-5.70318z'/%3E %3Cpath fill='%23d20014' d='m248.861,158.235-8.4834-8.59356c-3.5866,0.12446-0.74067,5.47902-0.56005,6.15114l9.04345,7.73433v-5.29191z'/%3E %3Cpath d='m248.139,156.757-17.5394-18.7806-0.6845,0.48355,18.5612,20.6216-0.3373-2.32459z'/%3E %3Cpath d='m229.586,136.772-0.38503-0.44575,0.0385-0.89151-3.61925-2.30304,1.61711,3.6403,1.23209,0.22287,0.38503,0.44575,0.73155-0.66862z'/%3E %3Cpath d='m227.738,138.11c0.61604-0.74292,1.34759-1.48584,2.65668-2.19161l1.00107,1.44869-2.15615,1.82015-1.5016-1.07723z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m225.811,141.278s0.5879,1.02632,0.5879,1.02632c0.36393-0.13504,4.03128-3.45709,4.03128-3.45709l2.63154-0.081,0.75587-0.83726c-1.93166-2.07966-3.75134,0.29709-3.75134,0.29709l-4.25525,3.05196z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m227.911,143.007c0.13998-0.91829,1.87567-3.21402,2.12762-3.29504,1.30317,0.39117,2.51537,1.14116,3.83533-1.83658-1.1478,1.45846-3.47139-0.027-3.47139-0.027l-1.00782,0.83726,0.028,0.40513-3.05146,2.8359,1.53973,1.08034z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m237.252,154.672-14.367-11.4113c-2.45972,2.50307-0.41467,10.2317-0.41467,10.2317l14.0422,7.6072,0.73945-6.42753z'/%3E %3Cpath fill='%23d20014' d='m249.166,163.917-11.8183-9.46696c-4.03608,0.56639-0.86322,6.50618-0.62257,7.16056l12.481,6.76847-0.0402-4.46207z'/%3E %3Cpath d='m248.697,162.005-25.5539-19.1816-0.58707,0.59088,26.8371,20.9549-0.69613-2.36409z'/%3E %3Cpath d='m221.928,141.807-0.45941-0.37447-0.12254-0.88441-3.97879-1.66173,2.24776,3.31408,1.25348,0.0131,0.45941,0.37447,0.60009-0.78102z'/%3E %3Cpath d='m220.349,143.433c0.47297-0.83483,1.05969-1.68902,2.22186-2.60338l1.24661,1.25897-1.79578,2.15371-1.67269-0.8093z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m218.925,146.641s0.15919,1.06,0.15919,1.06c0.33756-0.1883,3.56107-3.72584,3.56107-3.72584l2.58599-0.47719,0.52682-0.83299c-1.79717-2.11364-3.71297,0.69754-3.71297,0.69754l-3.1201,3.27848z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m220.971,148.545c-0.12263-0.98212,1.21945-3.86265,1.45516-3.9807,1.54652,0.45977,2.8934,1.15261,3.46231-2.0687-0.89718,1.61373-3.46102,0.36219-3.46102,0.36219l-0.85966,0.97906,0.12134,0.53096-2.61004,3.36954,1.89191,0.80765z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m236.224,161.651c-0.19061-0.046-18.5172-10.4422-18.5172-10.4422-1.33424,2.25264-0.12758,5.52064,0.45732,6.02891,0.0339,1.4999-0.60253,2.30652,0.7066,5.43903,0.38609,2.03671,1.32844,3.91312,2.70015,5.02765,1.67114,6.41674,8.22234,6.84773,10.7458,1.62404l3.90743-7.67738z'/%3E %3Cpath fill='%23d20014' d='m248.352,168.512-12.5481-7.35467c-4.03608,0.56638,0.0855,8.05519,0.32619,8.70957l12.1161,4.30413,0.10579-5.65903z'/%3E %3Cpath d='m246.243,165.846-28.3496-15.0889-0.48403,0.67221,29.9045,16.6466-1.07089-2.22992z'/%3E %3Cpath d='m216.528,149.937-0.51447-0.30053-0.26444-0.85502-4.19926-1.04078,2.75747,2.93404,1.24017-0.17626,0.51447,0.30053,0.46606-0.86198z'/%3E %3Cpath d='m215.232,151.782c0.33178-0.89594,0.77277-1.82816,1.77237-2.90666l1.4354,1.05533-1.42445,2.39822-1.78332-0.54689z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m214.1,155.181s0.59329,1.16676,0.59329,1.16676c0.3071-0.2318,3.00342-4.57817,3.00342-4.57817l2.492-0.81976,0.4691-1.01389c-2.00158-1.84905-3.49738,1.34225-3.49738,1.34225l-3.06043,3.90281z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m216.772,156.836c-0.20042-0.99867,0.48376-4.19683,0.70015-4.34538,1.56074,0.46564,2.86327,0.59786,3.22314-2.62209-0.90761,1.52943-3.32789,0.95334-3.32789,0.95334l-0.71005,1.08496,0.14955,0.37953-2.05871,3.95082,2.02381,0.59882z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23flags_half' transform='matrix(-1,0,0,1,499.85852,0)'/%3E %3C/g%3E %3Cg id='tree'%3E %3Cpath fill='%23016a16' stroke='%23016a16' d='m248.757,125.603-0.46484,9.07011,2.89945,0-0.42417-8.99163,3.02233-0.42447-0.33476-3.58228-7.51056,0.28993,0.042,3.25311,2.77054,0.38523z'/%3E %3Cg id='tree_half' fill='%23016a16'%3E %3Cpath d='m249.817,121.898c-7.76384-7.77113-13.8779-3.97919-15.3336-2.90247,0.96228,0.18793,1.82599-0.41145,2.27298-0.48045-0.28013,0.35359-0.86579,1.22948-0.86579,1.22948s2.40063-1.13341,2.66882-1.02991c-0.34602,0.27599-0.72786,0.93628-0.72786,0.93628,0.1788,0.069,1.52885-1.05714,1.79539-1.07672-0.41123,0.46573-0.53888,1.52761-0.53888,1.52761l1.16969-0.54452c0.30396,0.21562-0.0845,0.63021,0.1798,0.60852,1.94414-0.15959,4.67774,1.77726,5.05322,2.37237'/%3E %3Cpath d='m247.895,123.321c-0.80914-1.85399-15.5878-5.00514-18.5596,0.24395,1.16313,0.29273,2.2757-0.97579,2.2757-0.97579l-0.10114,1.17094,1.97228-1.51246-0.708,1.56125,1.56771-1.26852-0.0506,1.26852,1.92171-2.09793-0.25285,1.21973,1.71942-0.73184-0.20229,1.02457'/%3E %3Cpath d='m247.238,123.614c-3.79284-2.53704-9.6591-0.82942-9.6591-0.82942-3.74227,2.09793-5.73699,1.71946-6.22027,5.61075,0.354-0.14637,1.36543-1.3661,1.36543-1.3661l0.75857,1.51247,0.25285-2.14673,0.60686,1.65883,0.91028-2.73219,0.20228,1.85399,1.416-1.85399,0.65742,0.53668,0.60686-1.41488,0.55628,0.92699s0.96085-0.58547,1.51714-0.24394l1.06199-1.21973,0.25286,0.8782,0.91028-1.07336,0.354,0.78063,0.91028-0.82942-0.0506,0.58547,3.13541,0.0488'/%3E %3Cpath d='m246.38,124.053c-2.64328-0.0494-10.2265,2.81155-12.1877,5.8059,0.78094-0.43617,1.26251-0.63483,1.26251-0.63483l0.38693,1.20328,0.47279-1.20328,0.10114,0.927c0.28991-0.72391,0.61743-0.80561,1.16314-0.0488,0,0,0.20228-1.12215,0.20228-1.12215l0.30343,1.07336,0.50571-1.17094s0.31812,1.26908,0.50571,1.21973c0,0,0.83854-2.19438,1.21371-2.29309l0.10114,1.36609,0.50571-1.36609,0.45515,1.02457,0.10114-1.46367,0.50571,1.12215s0.2652-1.10343,0.65743-1.31731l0.75856,0.68305,3.37743-2.42674'/%3E %3Cpath d='m246.888,124.678c-3.52111,1.34951-6.67031,6.17871-6.42914,8.22623,1.56462-1.94163,1.22764-1.67427,1.92704,0.55939,0,0,0.26458-1.95434,0.52987-2.18701l0.45923,1.44665,0.17053-1.89204,0.46972,0.0217-0.12058-1.18663,0.69939,0.53515c-0.16335-0.6785-0.33764-0.90743,0.38588-1.48911,0,0-0.91645,0.11634-0.19294-1.53564l0.67528,0.65148s-0.12058-0.72128,0.12059-1.00049l2.48407-0.86089'/%3E %3Cpath d='m247.229,125.04-1.33017,2.53368,0.68214,0.19743-1.53481,1.15167,1.29606-0.13162s-1.9782,0.72391-2.21694,2.6653l2.0123-0.88844s-1.70534,1.74397-1.94409,2.79692l1.15963-1.02005s-1.12552,1.21748-0.95499,3.06016l0.85267-0.95424c-0.20464,2.23753-0.13642,2.43496,0.88678,4.14602,0,0-0.27285-2.6324,0.0341-2.96145l2.25105,2.33625-1.26195-3.32339s1.39837,2.10591,2.25105,1.90848l-1.77356-2.6982,1.73945,1.41491-1.9782-2.96144,1.84177,0.55938s-1.33016-1.67815-1.22784-2.73111l1.26195,1.38201s-0.4775-1.57944-0.34107-2.04011l0.64803,0.13162-1.26195-1.44782,0.85267-0.16452-0.10232-0.95424,0.61392-0.19743-0.0341-1.05296'/%3E %3Cpath d='m248.559,125.797c-2.18283,2.96144-1.05731,7.53523-2.35337,9.87148'/%3E %3C/g%3E %3Cuse xlink:href='%23tree_half' transform='matrix(-1,0,0,1,499.85867,0)'/%3E %3Cg id='trunk'%3E %3Cpath d='m250.945,166.535s1.18865-9.94478,1.18579-14.2254c-0.002-3.36865-0.81392-10.8349-0.81392-10.8349h-3.41702s-0.52001,7.42903-0.44204,10.7889c0.0994,4.28179,1.18578,14.2713,1.18578,14.2713h2.30141z'/%3E %3Cpath d='m247.674,141.953,3.95963,0-0.46487-2.6659-2.87012,0-0.62464,2.6659z'/%3E %3Cpath d='m247.927,139.816,3.53853,0-0.667-2.6659-2.17951,0-0.69202,2.6659z'/%3E %3Cpath d='m248.155,137.655,2.94897,0-0.49856-2.6659-1.87631,0-0.5741,2.6659z'/%3E %3Cpath d='m250.709,134.673-2.06274,0-0.20917,0.96419,2.44041,0-0.1685-0.96419z'/%3E %3Cpath d='m251.132,164.367h-2.62035'/%3E %3Cpath d='m251.275,162.42h-2.9404'/%3E %3Cpath d='m251.664,160.444h-3.72683'/%3E %3Cpath d='m251.856,158.291h-3.90057'/%3E %3Cpath d='m251.883,156.139h-4.10175'/%3E %3Cpath d='m252.043,154.171h-4.44923'/%3E %3Cpath d='m252.053,152.38h-4.65041'/%3E %3Cpath d='m252.025,150.219h-4.65042'/%3E %3Cpath d='m251.87,148.084h-4.49496'/%3E %3Cpath d='m251.664,145.914h-4.06517'/%3E %3Cpath d='m251.467,143.955h-3.67197'/%3E %3C/g%3E %3Cg id='cap'%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m249.909,119.044c-0.68827-0.32391-2.24539-1.3126-1.78345-1.90279,0,0,0.71338-1.21454,0.71338-1.21454,1.01062-2.27664-0.0184-1.39459-0.12589-2.10521-0.10324-0.68238,3.86451-0.1495,3.92359,1.39673,0.0163,0.42592-0.2943,0.17596-0.25178,2.61126,0,0-0.75534,1.45746-0.75534,1.45746-0.56496,0.0526-1.23395-0.0139-1.72051-0.24291z'/%3E %3Cpath d='m250.392,124.934-0.98614-0.82994,0.27276-7.10507,0.96516,0.28339-0.25178,7.65162z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m251.672,119.246c0.61915-0.36236,1.02443-1.44301,0.65043-2.08496-1.01607-1.28744-1.6737-0.7562-3.37806-1.336-0.3399,0.36203-1.05561,1.05866-0.90222,1.5789,2.24222,1.05562,1.37162,0.15654,2.1135,0.28804,0.39994,0.0709,0.65837,0.54508,1.51635,1.55402z'/%3E %3C/g%3E %3C/g%3E %3Cg id='items'%3E %3Cg id='i1'%3E %3Cuse xlink:href='%23ip' transform='matrix(1,0,0,-1,-0.00226132,320.36968)'/%3E %3Cpath fill='%23016a16' stroke='%23fff' stroke-width='0.1811' stroke-linecap='round' d='m238.358,161.75c0,1.29873-0.81458,2.35278-1.81827,2.35278s-1.81827-1.05405-1.81827-2.35278v-1.27647h3.63654v1.27647z'/%3E %3Cellipse fill='%23fff' stroke='none' cx='236.539' cy='160.063' rx='1.806' ry='0.898'/%3E %3Cpath fill='%23016a16' stroke='%23f1b517' d='m236.126,161.075-0.31022-3.29722,1.38188,0-0.22561,3.29722-0.84605,0z'/%3E %3Cpath id='ip' fill='%23016a16' stroke='%23fff' stroke-width='0.2373' stroke-linecap='round' d='m238.538,160.118c-0.26498,0.49319-1.06061,0.85208-1.99881,0.85208-0.9382-0.00001-1.72802-0.35889-1.99301-0.85208-0.0611,0.11381-0.0988,0.23335-0.0988,0.35877,0,0.66892,0.93708,1.21084,2.09179,1.21084s2.09178-0.54192,2.09178-1.21084c0-0.12542-0.0318-0.24496-0.093-0.35877z'/%3E %3C/g%3E %3Cg id='items_half'%3E %3Cpath id='cannon_base' d='m246.035,172.786-7.06013-2.18936-3.0762-5.25446-10.8928-0.53517,0.3783,3.94069,9.27903,1.77619,0.88243,1.58127,10.6659,2.96795-0.17658-2.28711z'/%3E %3Cg id='i2'%3E %3Cpath fill='%23503200' d='m238.662,174.254-11.1485-16.3982-0.54716,0.41156,11.0604,16.4667,0.63525-0.48015z'/%3E %3Cpath fill='%23fff' d='m228.551,158.5-1.19022-1.99181c-0.22281-0.36812-0.56118-0.49033-1.05837-0.22832-0.48411,0.25512-0.43705,0.75928-0.23987,1.12295l1.10042,1.85207,1.38804-0.75489z'/%3E %3C/g%3E %3Cg id='cannon'%3E %3Cpath d='m239.986,164.127-22.4964-2.28644-0.54691,3.27137,22.387,2.25127,0.6563-3.2362z'/%3E %3Cpath d='m217.089,160.997-0.58337,4.5377,0.94798,0,0.6563-4.15077-1.02091-0.38693z'/%3E %3Cpath d='m220.844,161.735-0.25522,4.08042,0.58337,0.0704,0.47399-3.62314-0.80214-0.52764z'/%3E %3Cpath d='m236.085,163.494-0.54691,3.83419,1.09382-0.0352,0.43753-3.79901-0.98444,0z'/%3E %3Cpath d='m239.436,163.599-0.77861,4.43415,1.23764,0.17939,0.35444-2.33199c0.0995,0.46856,0.53095,0.82404,1.04589,0.82404,0.58851,0,1.06914-0.46369,1.06914-1.03146s-0.48063-1.02585-1.06914-1.02585c-0.40919,0-0.78043,0.23995-0.9413,0.68697l0.23242-1.66237-1.15048-0.0729z'/%3E %3Cpath d='m231.317,164.319-3.09381,3.48224,0.36095,0.42285,3.97038-2.71118-1.23752-1.19391z'/%3E %3Cpath d='m224.124,173,3.09381-3.48225-0.36094-0.42284-3.97039,2.71118,1.23752,1.19391z'/%3E %3Cpath d='m232.22,172.129-3.76413-2.91016-0.38673,0.2736,2.9649,3.75585,1.18596-1.11929z'/%3E %3Cpath d='m222.938,165.413,3.8157,2.81067,0.46407-0.34823-2.99068-3.75585-1.28909,1.29341z'/%3E %3Cpath d='m227.09,163.094,0.36461,4.57288,0.51357-0.0219,1.2071-4.45153-2.08528-0.0995z'/%3E %3Cpath d='m228.341,174.189-0.3646-4.57289-0.56515-0.0528-0.69146,4.62565,1.62121,0z'/%3E %3Cpath d='m233.401,168.026-4.79461,0.51005-0.0729,0.45729,4.84929,0.63317,0.0182-1.60051z'/%3E %3Cpath d='m221.993,169.609,4.6808-0.73994,0.0987-0.36384-4.84175-0.54096,0.0622,1.64474z'/%3E %3Cellipse cx='227.693' cy='168.548' rx='1.27' ry='1.225'/%3E %3Cpath fill-rule='evenodd' stroke-linecap='round' d='m234.438,168.548c0,3.59202-3.02175,6.50727-6.74495,6.50727-3.72321,0-6.74496-2.91525-6.74496-6.50727,0-3.592,3.02175-6.50726,6.74496-6.50726,3.7232,0,6.74495,2.91526,6.74495,6.50726zm-1.34742,0.00001c0,2.87446-2.41811,5.20734-5.39755,5.20734s-5.39754-2.33288-5.39754-5.20734c0-2.87445,2.4181-5.20734,5.39754-5.20734s5.39755,2.33289,5.39755,5.20734z'/%3E %3Cpath d='m223.48,165.264-1.05705-0.79595'/%3E %3Cpath d='m231.034,164.493,0.90236-0.92031'/%3E %3Cpath d='m232.967,172.701-1.10862-0.87056'/%3E %3Cpath d='m223.48,173.696,0.95392-1.0198'/%3E %3C/g%3E %3Cg id='axe'%3E %3Cpath d='m246.196,162.122,1.15496,5.8864-0.94208,0.4962-1.01348-6.29841,0.8006-0.0842z'/%3E %3Cpath fill='%23fff' d='m245.592,161.364c-0.53548-0.22387-1.2316,0.15498-2.37396-1.29153-1.87831,1.72203-0.10709,1.98034,0.17849,3.68515,0.53115,0.21828,0.85836-1.32283,2.30256-1.48095,0.1785-0.0172,2.29785-0.20311,2.29785-0.20311s-0.53201-0.72513-0.53201-0.72513-1.47399,0.0387-1.87293,0.0156z'/%3E %3Cpath fill='%23fff' d='m246.359,162.518-0.21419-1.75647c-0.23204-0.61993-0.99956-0.0861-0.99956,0.27552l0.19634,1.61871,1.01741-0.13776z'/%3E %3C/g%3E %3Cpath id='bugle' fill-rule='evenodd' d='m240.765,167.372,0.0188,1.63686c-0.53573,0.18339-0.454,0.58498-0.43672,1.16852l0.0188,4.77113c-0.1901,0.31678-0.77767,0.33153-1.05418,0.5797-0.2765,0.24817-0.24194,0.72975,1.01961,1.04653l0.97557,0.0349c1.48622-0.32512,1.79297-0.81731,1.0477-1.09485-0.39645-0.14764-0.91809-0.32374-1.11682-0.55716l0.033-1.1367,0.96456,0.0349c0.25923,0,0.7525-0.65168,0.76978-1.1852l0.005-2.47044c-0.0346-1.4005-1.08551-1.55803-1.3793-1.54136l0.0204-1.28978-0.88602,0.003zm1.63059,2.73012c0.0173-0.40014-0.5556-0.75694-0.78631-0.76694s-0.73447,0.46683-0.75175,0.86697v1.00036c0.0346,0.3668,0.32755,1.60924,0.91592,1.7006,0.27872,0.0433,0.63942-0.40014,0.63942-0.76694l-0.0173-2.03405z'/%3E %3Cg id='i3' fill='%23fff'%3E %3Cpath d='m234.275,172.328c-0.63643-0.25722-0.63028,1.17186-0.63028,1.17186l1.00278,0.0105c0.43862,0.19913,0.79146,0.84264,0.51178,1.1585-0.23124,0.26115-2.17731-0.44106-2.30792-0.0372,0.34401,1.94159,2.91678,2.68867,3.84773,1.83931,0.91051-0.83072,1.14108-3.04781-1.81748-3.62862l-0.60661-0.51433z'/%3E %3Cpath d='m234.87,172.856-0.29241,0.63889'/%3E %3C/g%3E %3Cg id='small_flag'%3E %3Cpath d='m214.943,173.055-0.96325-4.04912'/%3E %3Cpath d='m216.112,172.822-1.47928-3.15301'/%3E %3Cpath d='m218.658,171.993-3.33698-1.79223'/%3E %3Cpath d='m220.103,171.628-6.19232-2.68836'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m210.215,166.013s-2.25377-0.0356-2.65571,0.122c-0.16218,0.0636,0.56688,0.82456,0.41552,1.11549-0.56308,1.08226-4.3943,0.93396-4.69718,0.69717-0.51817-0.4051,3.56833-0.75265,3.59515-1.02833,0.0308-0.31645-0.60433-1.14672-0.50585-1.6558,0.12777-0.66051,1.78854-0.90633,1.78854-0.90633l2.05953,1.6558z'/%3E %3Cpath fill='%23503200' d='m213.233,168.05-5.10223-4.22211s-0.22478-0.2382-0.41282-0.0332c-0.18413,0.20074,0.0688,0.43146,0.0688,0.43146l5.26348,4.34783,0.18277-0.52399z'/%3E %3Cpath d='m218.146,172.217c-0.0903-0.0871-4.1552-3.60789-4.1552-3.60789l-0.27099-1.02833s-0.6278,0.42527-0.85814,0.64488-0.58715,0.81919-0.58715,0.81919l1.13817,0.0523,3.59515,3.29416,1.13816-0.1743z'/%3E %3C/g%3E %3Cg id='cannonballs'%3E %3Cellipse cx='232.534' cy='177.056' rx='0.740' ry='0.715'/%3E %3Cellipse cx='230.641' cy='175.716' rx='0.740' ry='0.715'/%3E %3Cellipse cx='228.091' cy='176.593' rx='0.740' ry='0.715'/%3E %3Cellipse cx='224.153' cy='177.445' rx='0.740' ry='0.715'/%3E %3Cellipse cx='222.487' cy='177.64' rx='0.740' ry='0.715'/%3E %3Cellipse cx='220.846' cy='177.64' rx='0.740' ry='0.715'/%3E %3Cellipse cx='219.18' cy='177.591' rx='0.740' ry='0.715'/%3E %3Cellipse cx='219.988' cy='176.325' rx='0.740' ry='0.715'/%3E %3Cellipse cx='221.604' cy='176.398' rx='0.740' ry='0.715'/%3E %3Cellipse cx='223.144' cy='176.203' rx='0.740' ry='0.715'/%3E %3Cellipse cx='222.361' cy='174.961' rx='0.740' ry='0.715'/%3E %3Cellipse cx='220.846' cy='174.937' rx='0.740' ry='0.715'/%3E %3C/g%3E %3Cpath id='chain' fill-rule='evenodd' d='m236.47,177.991c0-0.31649-0.76859-0.18036-0.76859-0.55072,0-0.41154,1.17217-0.10903,1.33411,0.25303,0.65964-0.59607,0.94402-0.16037,1.34812,0.0197,0.57546-0.85539,1.28698-0.82343,1.98133-0.19706,0.40146-0.44287,1.40966-0.29647,1.75664,0.19706,0.66466-0.6591,1.25491-0.49671,1.71579-0.0197,0.18538-0.34652,0.45745-0.2707,0.65363-0.0197,0.35414-0.62828,1.24209-0.43967,1.61583-0.0249,0.33231-0.36526,0.67271-0.08,1.11376,0.18982,0.29784-0.2787,0.77827-0.22616,0.77827,0.0509,0,0.28889-0.62779,0.18719-0.62779,0.4739,0,0.25579,0.45796,0.12646,0.45796,0.45,0,0.25469-0.67973,0.35017-0.78477-0.0559-0.23021,0.43971-1.06186,0.27088-1.14386-0.13794-0.27669,0.33403-0.89704,0.43568-1.24599-0.0591-0.28657,0.23315-0.6295,0.26652-0.78695,0.0311-0.51709,0.55594-1.3887,0.4417-1.68895-0.17117,0,0-0.29346,0.0125-0.29346,0.0125-0.50794,0.68971-1.30179,0.37107-1.52011-0.0104-0.8527,0.61519-1.36211,0.42145-1.83835,0.0197-0.54713,0.66665-1.38081,0.62012-1.57281,0-0.36819,0.26829-1.13636,0.33144-1.13636,0.0176,0-0.30068,0.65255-0.19137,0.65255-0.46876zm1.65458,0.14977c0,0.1432-0.19492,0.25942-0.43509,0.25942s-0.43508-0.11622-0.43508-0.25942,0.19491-0.25943,0.43508-0.25943,0.43509,0.11623,0.43509,0.25943zm1.82033-0.21792c0,0.17238-0.23462,0.31227-0.52371,0.31227-0.28908,0-0.52371-0.13989-0.52371-0.31227,0-0.17236,0.23463-0.31226,0.52371-0.31226,0.28909,0,0.52371,0.1399,0.52371,0.31226zm3.57497,0.19716c0,0.1745-0.21232,0.31611-0.47392,0.31611s-0.47392-0.14161-0.47392-0.31611c0-0.17449,0.21232-0.31611,0.47392-0.31611s0.47392,0.14162,0.47392,0.31611zm-1.90344-0.083c0,0.22051-0.20766,0.39948-0.46353,0.39948s-0.46353-0.17897-0.46353-0.39948,0.20766-0.39948,0.46353-0.39948,0.46353,0.17897,0.46353,0.39948zm4.05961,0.0104c0,0.19712-0.18564,0.35711-0.41437,0.35711s-0.41436-0.15999-0.41436-0.35711c0-0.19713,0.18563-0.35711,0.41436-0.35711s0.41437,0.15998,0.41437,0.35711zm-1.24369,0.083c0,0.12739-0.11997,0.23078-0.26778,0.23078-0.14782,0-0.26778-0.10339-0.26778-0.23078s0.11996-0.23078,0.26778-0.23078c0.14781,0,0.26778,0.10339,0.26778,0.23078zm2.42185,0.0934c0,0.183-0.13521,0.33153-0.30181,0.33153s-0.30181-0.14853-0.30181-0.33153c0-0.18301,0.13521-0.33154,0.30181-0.33154s0.30181,0.14853,0.30181,0.33154z'/%3E %3C/g%3E %3Cuse xlink:href='%23items_half' transform='matrix(-1,0,0,1,499.85853,0)'/%3E %3Cg id='drum' stroke-width='0.231'%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m249.837,165.718c-2.5116,0-4.54963,0.94401-4.54963,2.10216,0,0.19861,0.0565,0.38965,0.1685,0.57178,0.54316,0.62909,2.30675,1.08752,4.39856,1.08752,1.95672,0,3.6243-0.40275,4.27654-0.9698,0.16439-0.21675,0.25566-0.44698,0.25566-0.6895,0-1.15816-2.03804-2.10216-4.54963-2.10216z'/%3E %3Cpath stroke-width='0.1869' d='m254.427,167.981v7.05811c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-7.05811c0,0.82757,2.04845,1.49922,4.57244,1.49922,2.52398,0,4.57243-0.67165,4.57243-1.49922z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' stroke-width='0.1826' d='m245.282,167.982v1.08191l2.21961,6.84463,1.77221-5.2638,1.94652,5.46561,1.42429-5.15885,1.78311,3.46807v-1.91933l-1.65599-3.36345c-0.18576,0.0506-0.38384,0.094-0.59268,0.13454l-1.02846,3.81191-1.44681-3.6045c-0.24229-0.003-0.48334-0.008-0.7147-0.0224l-1.45263,3.62692-1.6618-4.36688c-0.37558-0.21764-0.59267-0.46661-0.59267-0.73436z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' stroke-width='0.1869' d='m254.427,173.721v1.31782c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-1.31782c0,0.82757,2.04845,1.49922,4.57244,1.49922,2.52398,0,4.57243-0.67165,4.57243-1.49922z'/%3E %3Cpath stroke-width='0.1869' d='m251.737,175.085c-0.37176,0.0553-0.76859,0.0967-1.18535,0.11772l0.0116,1.31736c0.41688-0.0214,0.81373-0.062,1.18535-0.11773l-0.0116-1.31735z'/%3E %3Cpath stroke-width='0.1869' d='m246.868,174.855-0.0116,1.31174c0.35286,0.10094,0.74975,0.18477,1.18534,0.24666v-1.31736c-0.43047-0.0611-0.82391-0.1417-1.17372-0.24104z'/%3E %3Cpath stroke-width='0.1869' d='m245.282,173.723v1.31736c0,0.24576,0.18539,0.47354,0.50551,0.67829l0.0232-1.30053c-0.33594-0.20864-0.52875-0.44293-0.52875-0.69512z'/%3E %3Cpath stroke-width='0.1869' d='m254.428,173.863-0.0232,0.006c-0.0801,0.26749-0.37874,0.51556-0.8309,0.72315l0.006,1.31174c0.53035-0.2448,0.84834-0.54036,0.84834-0.86328v-1.17721z'/%3E %3Cpath fill='none' stroke-width='0.1869' d='m254.427,168.027v7.01203c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-7.01203'/%3E %3Cpath fill='%23fff' stroke='%23fff' stroke-width='0.1916' d='m253.392,167.52c0,0.50111-1.58376,0.90734-3.53741,0.90734-1.95366,0-3.53741-0.40623-3.53741-0.90734s1.58375-0.90734,3.53741-0.90734c1.95365,0,3.53741,0.40623,3.53741,0.90734z'/%3E %3Cpath d='m248.698,168.19,0.15688,1.25008c0.30701,0.0223,0.62606,0.0382,0.95293,0.0392l0.23242-1.28932h-1.34223z'/%3E %3Cpath d='m252.801,167.887-0.91225,0.24665,0.0581,1.17721c0.3102-0.0525,0.60208-0.11708,0.86576-0.1906l-0.0116-1.23326z'/%3E %3Cpath d='m247.397,165.979c-0.25878,0.0764-0.50082,0.16525-0.7205,0.26347l0.12783,0.94417,0.58105-0.18499,0.0116-1.02265z'/%3E %3Cpath d='m249.837,165.606c-0.12168,0-0.24098,0.007-0.36025,0.0112l0.19756,1.18249,0.60429-0.0112,0.23823-1.15447c-0.22219-0.0155-0.44837-0.028-0.67983-0.028z'/%3E %3Cpath d='m252.51,166.024-0.12203,1.0337,0.69146,0.24441,0.0755-1.01464c-0.19636-0.0968-0.41236-0.18511-0.64496-0.26347z'/%3E %3Cpath stroke-width='0.1826' d='m245.993,168.8,0.18421-1.28763-0.93496-0.50634,0.0278,1.46536,0.72294,0.32861z'/%3E %3Cpath stroke-width='0.1826' d='m254.396,168.522,0.0417-1.28759-0.87584,0.26154,0.83413,1.02605z'/%3E %3C/g%3E %3Cg id='helmet'%3E %3Cpath d='m263.686,160.029c0.83083-0.11451,2.06245,1.02446,2.13643,2.4333,0.0587,1.11791-1.69134,1.0592-1.69134,1.0592-0.089,0.45803-1.0541,0.88186-1.83971,0.91606-0.76216,0.0332,0.20771-1.43135,0.20771-1.43135-0.47476-1.25959,0.14836-2.74819,0.14836-2.74819l1.03855-0.22902z'/%3E %3Cpath d='m262.499,162.948,0.80116-0.0286s0.0613,0.41314,0.20771,0.42941c0.15745,0.0175,0.3264-0.40078,0.3264-0.40078l1.21658-0.0286'/%3E %3Cpath fill='%23d20014' stroke='%23f1b517' d='m264.131,160.859c0.67974-0.49144,0.084-1.48026-0.38575-1.4886,0,0-1.09789,0.0286-1.09789,0.0286-0.51741,0.0107-1.39215,0.57267-1.27592,1.05921,0.10134,0.42425,0.38608,0.61772,0.83083,0.54391,0.20197-0.0335,0.62612-0.56336,0.83084-0.57254,0.27465-0.0123,0.87787,0.58848,1.09789,0.4294z'/%3E %3C/g%3E %3Cpath id='anchor' fill-rule='evenodd' d='m214.242,174.855c-0.61672,0.078-0.73098,0.78846-0.4997,1.44067-2.68636,0.7552-5.08627,1.73945-7.45489,2.40487-0.0953-0.4735,1.17372-1.84429,1.17372-1.84429,0.33571,0.16194,0.58686,0.93056,0.58686,0.93056,0.0839-1.57891,1.63857-2.6291,1.63857-2.6291-0.9232-0.12146-3.73165,0.96732-4.06736,1.41265,0,0,1.08722-0.12146,1.25507,0,0,0-2.14094,2.31168-2.23705,2.99907,0.33303,0.75114,4.02669,1.31175,4.02669,1.31175-0.0583,0.19445-1.08657,0.93056-1.08657,0.93056,1.4691,0.32268,3.68473-0.71797,4.34627-1.35099,0,0-1.72808-0.14248-3.07377-1.23327,0,0,0.2775,0.67919,0.1104,1.00343,0,0-2.09936-0.60528-2.31839-0.95297,0.006-0.0301,4.96602-1.31472,7.36773-2.00126,0.0889,0.42909,0.56583,1.23978,1.13886,1.04828,0.37379-0.12492,0.25537-0.8657,0.11621-1.39023,0.13517,0.11606,0.31047,0.18499,0.50551,0.18499,0.42228,0,0.76699-0.32696,0.76699-0.73435,0-0.4074-0.34471-0.73996-0.76699-0.73996-0.33769,0-0.61915,0.21145-0.7205,0.50452-0.0956-0.45275-0.34512-1.35347-0.80766-1.29493zm1.8887,1.52779c0,0.19057-0.16032,0.34523-0.35785,0.34523s-0.35784-0.15466-0.35784-0.34523,0.16031-0.34524,0.35784-0.34524,0.35785,0.15467,0.35785,0.34524z'/%3E %3Cg id='i4'%3E %3Cpath d='m293.068,177.884c0.18296-0.36659-0.16181-2.21178-0.16181-2.21178-0.37288,0.0414-0.88217,0.68114-0.88217,0.68114,0.48088-1.51138-0.86509-4.03755-0.86509-4.03755,0.91058,0.1905,3.94542,3.12828,4.103,3.65753,0,0-1.32902-0.47414-1.52981-0.4154,0.21676,1.50571,1.25802,2.20544,1.64916,2.98821,0,0-1.7257,0.37897-1.55229,1.82194l-1.12718,0.0209c-0.39017-0.48099,0.15174-1.27567,0.15174-1.27567l-7.73851-3.24146c-0.49856-0.20913-1.6204-0.71815-1.45233-1.3175,0.16946-0.6043,2.01592,0.25096,2.47112,0.39734l6.93417,2.93229z'/%3E %3Cpath d='m285.635,176.541,0.91042-1.67302c0.32514-0.43916-0.34683-0.92015-0.82371-0.35551l-1.0188,1.52662c-0.4552,0.83651,0.49856,1.06655,0.93209,0.50191z'/%3E %3C/g%3E %3C/g%3E %3Cg id='motto'%3E %3Cg fill='%23fff'%3E %3Cpath d='m231.367,180.366-0.0631-1.82484-2.20675,0.12166-0.1261,1.98705,2.3959-0.28387z'/%3E %3Cpath d='m215.237,182.924-2.9508-1.65512c12.1686,1.11518,14.6537-3.12916,17.5942-3.35618,1.80755-0.14118,2.0898,2.0019-1.41275,0.98242l0.90579,2.24135s-8.6385,4.85952-17.1292,2.85219l2.99283-1.06466z'/%3E %3Cpath d='m268.249,180.366,0.063-1.82484,2.6992,0.0623,0.1261,1.98705-2.88835-0.22448z'/%3E %3Cpath d='m284.939,182.477,2.77669-1.51514c-13.9388,0.41529-10.7652-2.28929-17.7392-3.04823-1.80213-0.1953-3.15679,2.12067,1.41275,0.98242l-0.90579,2.24135s2.1922,0.002,2.1922,0.002c4.74805,3.12663,11.156,3.40575,15.4013,2.40209l-3.13793-1.06466z'/%3E %3Cpath d='m228.418,178.908,0,3.15421s7.728,2.86747,21.5188,2.86747c13.8501,0,21.5188-2.86747,21.5188-2.86747v-3.15421s-5.84903,2.69542-21.5188,2.69542c-15.6103,0-21.5188-2.69542-21.5188-2.69542z'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m229.573,182.08,0.68194-2.30932,0.31676,0.0871-0.60146,2.0368,1.17887,0.32402-0.0805,0.27252-1.49564-0.41108zm2.23639-1.01549,0.0381-0.45359,0.10174-0.38911,0.33747,0.0821-0.10174,0.38911-0.1928,0.41593-0.18273-0.0445zm3.32525-0.15591,0.32275,0.0634-0.28686,1.35944c-0.0499,0.23647-0.11725,0.41881-0.20205,0.54702s-0.20878,0.22171-0.37192,0.28049c-0.16314,0.0588-0.36227,0.0651-0.5974,0.0189-0.22847-0.0449-0.40734-0.11956-0.5366-0.22407-0.12926-0.1045-0.20976-0.23481-0.2415-0.39093-0.0317-0.15611-0.0213-0.35882,0.0313-0.60813l0.28685-1.35945,0.32275,0.0634-0.28652,1.35784c-0.0431,0.20437-0.0552,0.35884-0.0363,0.46341s0.0708,0.19249,0.15571,0.26376c0.0849,0.0713,0.19663,0.12052,0.33527,0.14775,0.23734,0.0466,0.41743,0.0279,0.54026-0.056,0.12283-0.084,0.2154-0.27362,0.27771-0.56894l0.28652-1.35784zm0.36326,2.51013,0.40178-2.36971,0.33342,0.0526,0.97468,2.06413,0.31545-1.86053,0.31164,0.0492-0.40178,2.36971-0.33342-0.0526-0.9744-2.06574-0.31573,1.86215-0.31164-0.0492zm2.54115,0.38367,0.34172-2.37847,0.32625,0.0436-0.34173,2.37846-0.32624-0.0436zm0.9374-1.04907c0.0469-0.39598,0.19381-0.69384,0.44075-0.89358,0.24694-0.19973,0.54471-0.28038,0.89332-0.24196,0.22827,0.0252,0.42783,0.10047,0.59866,0.22591,0.17084,0.12544,0.29318,0.28758,0.36704,0.4864,0.0739,0.19883,0.0966,0.41759,0.0684,0.65626-0.0286,0.24193-0.10489,0.45279-0.22871,0.63258-0.12382,0.17978-0.28432,0.30854-0.48149,0.38627-0.19718,0.0777-0.40316,0.10475-0.61794,0.0811-0.23278-0.0257-0.43439-0.10284-0.60484-0.23154-0.17044-0.12869-0.29178-0.29209-0.36402-0.49019-0.0722-0.1981-0.0959-0.40184-0.0711-0.61123zm0.33678,0.0421c-0.0341,0.28749,0.0192,0.5228,0.15989,0.70591,0.14065,0.18311,0.33186,0.28799,0.57364,0.31464,0.24627,0.0272,0.45885-0.034,0.63776-0.18358,0.17891-0.14953,0.28654-0.37781,0.32291-0.68483,0.023-0.1942,0.009-0.36746-0.0418-0.5198-0.0509-0.15233-0.13711-0.27559-0.25867-0.36977-0.12156-0.0942-0.26387-0.15026-0.42692-0.16823-0.23166-0.0255-0.44007,0.0293-0.62524,0.16435-0.18517,0.1351-0.29903,0.38221-0.34155,0.74131zm2.30844,1.41617,0.2028-2.39322,0.33674,0.0266,1.1437,1.98175,0.15922-1.87899,0.31474,0.0248-0.20281,2.39322-0.33673-0.0266-1.14356-1.98339-0.15937,1.88062-0.31473-0.0248zm3.48923,0.24265,0.10868-2.39892,1.67748,0.0707-0.0128,0.28309-1.34843-0.0569-0.0336,0.74292,1.16694,0.0492-0.0128,0.28309-1.16694-0.0492-0.0494,1.08982-0.32905-0.0139zm1.83353,0.0783,1.00383-2.38291,0.35477,0.007,0.97029,2.41977-0.37513-0.007-0.27567-0.73253-1.04054-0.0194-0.28787,0.722-0.34968-0.007zm0.7378-0.97244,0.84363,0.0157-0.24637-0.66973c-0.0752-0.20345-0.13067-0.3705-0.16654-0.50113-0.0348,0.15334-0.0825,0.30535-0.1433,0.45603l-0.28742,0.69907zm1.9137,1.01069,0.005-2.4012,0.32936,0.00054-0.005,2.4012-0.32937-0.00054zm1.54203-0.007-0.0313-2.11763-0.81994,0.0113-0.004-0.28333,1.97259-0.0271,0.004,0.28333-0.82333,0.0113,0.0313,2.11763-0.32933,0.005zm2.44223-0.0577-0.1164-2.39858,0.32901-0.0148,0.10266,2.11553,1.22444-0.0553,0.0137,0.28305-1.55345,0.0702zm1.67472-0.073,0.77655-2.46067,0.35394-0.0243,1.19294,2.3253-0.37425,0.0257-0.34315-0.7055-1.0381,0.0714-0.21908,0.74414-0.34885,0.024zm0.6437-1.03278,0.84166-0.0579-0.30809-0.64551c-0.0939-0.19606-0.16484-0.35758-0.21279-0.48456-0.0203,0.15575-0.0536,0.3113-0.10001,0.46665l-0.22077,0.72127zm2.92174,0.75811-0.27296-2.38673,1.66896-0.17765,0.0322,0.28165-1.34158,0.14281,0.0845,0.73913,1.16102-0.12358,0.0322,0.28165-1.16101,0.12359,0.124,1.08428-0.32738,0.0349zm1.82509-1.37024c-0.0584-0.39457,0.006-0.71858,0.19234-0.97205,0.18659-0.25346,0.45356-0.40411,0.80091-0.45194,0.22746-0.0313,0.44026-0.007,0.63841,0.0726,0.19815,0.0797,0.359,0.20675,0.48255,0.38111,0.12354,0.17436,0.20291,0.38045,0.23809,0.61827,0.0357,0.24107,0.0171,0.46367-0.0556,0.66781s-0.19425,0.36785-0.36465,0.49114c-0.17041,0.12329-0.36262,0.19966-0.57664,0.22913-0.23194,0.0319-0.44722,0.006-0.64585-0.0765-0.19863-0.083-0.35884-0.21146-0.48063-0.38551-0.12178-0.17406-0.19811-0.3654-0.22897-0.57403zm0.33686-0.0414c0.0424,0.28646,0.1556,0.50113,0.33965,0.644,0.18406,0.14286,0.39654,0.19771,0.63745,0.16454,0.24538-0.0338,0.43503-0.14483,0.56896-0.33314,0.13392-0.1883,0.17825-0.43541,0.133-0.74134-0.0286-0.19349-0.0875-0.35773-0.17665-0.49271-0.0891-0.13498-0.20485-0.23321-0.34714-0.29469-0.14229-0.0615-0.29467-0.081-0.45714-0.0587-0.23082,0.0318-0.41811,0.13561-0.56188,0.31148-0.14376,0.17588-0.18918,0.44272-0.13625,0.80053zm2.61378,0.80601-0.4445-2.3626,1.0858-0.19014c0.21827-0.0382,0.38819-0.0461,0.50977-0.0235,0.12158,0.0225,0.22644,0.0816,0.31458,0.17713,0.0881,0.0956,0.14445,0.20832,0.16891,0.33832,0.0315,0.16761,0.002,0.31874-0.089,0.4534-0.0909,0.13466-0.25083,0.23814-0.47995,0.31044,0.0932,0.0247,0.16576,0.0525,0.21758,0.0834,0.11042,0.0672,0.21978,0.15629,0.32807,0.26717l0.54695,0.56843-0.40759,0.0714-0.41655-0.43479c-0.12135-0.12524-0.21972-0.2201-0.29512-0.28459-0.0754-0.0645-0.14015-0.10752-0.19425-0.12912s-0.10733-0.0339-0.15966-0.037c-0.0382-0.001-0.099,0.006-0.18254,0.0203l-0.37585,0.0658,0.19739,1.04915-0.32407,0.0568zm0.0757-1.37664,0.69658-0.12199c0.14812-0.0259,0.26116-0.061,0.33912-0.10516,0.078-0.0442,0.13255-0.10256,0.16375-0.17517,0.0312-0.0726,0.0396-0.14705,0.0253-0.22333-0.021-0.11174-0.0804-0.19624-0.17797-0.2535-0.0976-0.0573-0.2372-0.07-0.41872-0.0382l-0.7751,0.13573,0.14706,0.78163zm3.93115-0.26168,0.33959,0.009c-0.008,0.26923-0.0838,0.4897-0.22765,0.66141-0.14382,0.17171-0.34216,0.28502-0.59502,0.33993-0.2617,0.0568-0.48653,0.0517-0.67449-0.0155s-0.34748-0.18896-0.47854-0.36533c-0.13107-0.17636-0.2227-0.3764-0.2749-0.60011-0.0569-0.24395-0.0583-0.46723-0.004-0.66985,0.0542-0.20262,0.15952-0.37043,0.31585-0.50344s0.3416-0.22278,0.55582-0.2693c0.24293-0.0528,0.46112-0.0375,0.6546,0.0459,0.19347,0.0833,0.34801,0.22607,0.46362,0.42817l-0.29958,0.14061c-0.0961-0.15821-0.20676-0.26457-0.33201-0.31908-0.12525-0.0545-0.26904-0.0641-0.43136-0.0289-0.18661,0.0405-0.33251,0.11755-0.4377,0.23105-0.1052,0.11351-0.16622,0.24849-0.18309,0.40493-0.0169,0.15644-0.007,0.3119,0.0288,0.46637,0.0465,0.19921,0.11715,0.36658,0.212,0.50212,0.0949,0.13554,0.21436,0.22627,0.35849,0.2722,0.14414,0.0459,0.29018,0.0528,0.43815,0.0207,0.17998-0.0391,0.32068-0.12225,0.42209-0.24949,0.10141-0.12723,0.1512-0.29419,0.14939-0.50086zm0.91487,0.65288-0.66928-2.31277,1.73334-0.46687,0.079,0.27293-1.4161,0.38142,0.20498,0.70835,1.32617-0.3572,0.0785,0.27134-1.32617,0.3572,0.22781,0.78723,1.47171-0.3964,0.079,0.27292-1.78894,0.48185z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 6 3'%3E %3Crect fill='%23436F4D' width='6' height='3'/%3E %3Crect fill='%23FFF' width='6' height='2'/%3E %3Crect fill='%23CD2A3E' width='6' height='1'/%3E %3C/svg%3E"

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 3 2'%3E %3Crect fill='%23FFF' width='3' height='2'/%3E %3Crect fill='%23CE1126' width='3' height='1'/%3E %3C/svg%3E"

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!-- Created with Inkscape (http://www.inkscape.org/) --%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' width='600' height='300' viewBox='0 0 600 300' id='svg2' version='1.1' inkscape:version='0.91 r13725' sodipodi:docname='Ireland.svg'%3E %3Cdefs id='defs4' /%3E %3Csodipodi:namedview id='base' pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1.0' inkscape:pageopacity='0.0' inkscape:pageshadow='2' inkscape:zoom='1.348785' inkscape:cx='187.47867' inkscape:cy='143.80555' inkscape:document-units='px' inkscape:current-layer='layer1' showgrid='false' units='px' inkscape:window-width='1440' inkscape:window-height='837' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' /%3E %3Cmetadata id='metadata7'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3Cdc:title%3E%3C/dc:title%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Cg inkscape:label='Layer 1' inkscape:groupmode='layer' id='layer1' transform='translate(0,-752.36216)'%3E %3Crect style='fill:%23169b62;fill-opacity:1;stroke:none' id='rect4148' width='200' height='300' x='0' y='752.36218' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none' id='rect4150' width='200' height='300' x='200' y='752.36212' /%3E %3Crect style='fill:%23ff883e;fill-opacity:1;stroke:none' id='rect4152' width='200' height='300' x='400' y='752.36218' /%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' width='660' height='480' viewBox='0 0 220 160'%3E %3Cdesc%3EFlag of Israel%3C/desc%3E %3Cdefs%3E %3C!-- Specs are taken from 'The Provisional Council of State Proclamation of the Flag of the State of Israel,' 25 Tishrei 5709 (28 October 1948) For Magen David, the 'Israel Science and Technology Homepage' at http://www.science.co.il/Israel-flag.asp specifies each side as 60 cm. Outer radius is then 30 / cos(30) = 20 * sqrt(3) For equilateral triangles, middle radius = outer radius - width: 20 * sqrt(3) - 5.5 Coordinates for upward-pointing triangle relative to center are then: ( 0,-(20*sqrt(3) - 5.5) ) (-(20*sqrt(3) - 5.5) * cos(30), (20*sqrt(3) - 5.5) * sin(30)) ( (20*sqrt(3) - 5.5) * cos(30), (20*sqrt(3) - 5.5) * sin(30)) --%3E %3Cpolygon id='triangle' points='0,-29.1410161513775421 -25.2368602791855814, 14.5705080756887710 25.2368602791855814, 14.5705080756887710' stroke='%230038b8' stroke-width='5.5' fill-opacity='0'/%3E %3C/defs%3E %3C!-- 'The flag is 220 cm long and 160 cm wide. The background is white' --%3E %3Crect width='220' height='160' fill='white'/%3E %3C!-- '...two stripes of dark sky-blue, 25 cm broad, over the whole length of the flag, at a distance of 15 cm from the top and from the bottom...' Legislation does not specify exact shade of blue; '%230038b8' is typical of flags used in Israel --%3E %3Crect width='220' height='25' fill='%230038b8' y='15'/%3E %3Crect width='220' height='25' fill='%230038b8' y='120'/%3E %3Cuse xlink:href='%23triangle' transform='translate(110,80)'/%3E %3Cuse xlink:href='%23triangle' transform='translate(110,80) rotate(180)'/%3E %3C/svg%3E"

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!-- Created with Sodipodi ('http://www.sodipodi.com/') --%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' version='1.1' x='0' y='0' width='600' height='300' id='svg378' sodipodi:version='0.32' sodipodi:docname='AJAX1.svg' inkscape:version='0.48.2 r9819' inkscape:export-filename='C:%5CDocuments and Settings%5CJoshua.JOSHPC%5CDesktop%5Cisleofman.png' inkscape:export-xdpi='90.000000' inkscape:export-ydpi='90.000000' inkscape:output_extension='org.inkscape.output.svg.inkscape'%3E %3Cmetadata id='metadata56'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Csodipodi:namedview id='base' showguides='true' inkscape:guide-bbox='true' inkscape:zoom='1' inkscape:cx='207.11039' inkscape:cy='66.341622' inkscape:window-width='1280' inkscape:window-height='1004' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:current-layer='svg378' inkscape:showpageshadow='false' showgrid='false' fit-margin-top='0' fit-margin-left='0' fit-margin-right='0' fit-margin-bottom='0' inkscape:window-maximized='1'%3E %3C/sodipodi:namedview%3E %3Cdefs id='defs380' /%3E %3Cpath style='fill:%23cf142b;fill-opacity:1;fill-rule:nonzero;stroke:none' d='m 0,0 600,0 0,300 -600,0 z' id='rect2489' inkscape:connector-curvature='0' sodipodi:nodetypes='ccccc' /%3E %3Cg id='g4408' transform='matrix(0.3498026,0,0,0.3498026,163.24255,23.83426)'%3E %3Cpath id='path4410' d='m 419.10237,546.46443 c 0.2907,-0.8793 0.87689,-9.94616 0.58379,-9.94616 -0.29309,0 -13.74684,-15.79373 -13.45374,-15.79373 0.2931,0 17.25683,3.80308 17.25683,3.21688 0,-0.58379 6.72687,-16.67062 6.72687,-16.96372 0,-0.2907 8.18997,19.59681 8.18997,19.59681 l 16.67062,7.31307 -11.69995,9.65066 c 0,0 2.63309,18.71992 2.63309,19.01302 0,0.2907 -11.69995,-11.11615 -11.69995,-11.11615 l -12.86994,1.46309 c 0,0 -1.7538,-5.84997 -2.33759,-6.43377 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4412' d='m 328.4794,300.67417 c -11.11375,5.72264 -53.76692,54.47804 -59.6169,62.08181 -4.901,11.03928 -14.48679,25.00474 -24.36088,33.99472 -10.53956,7.97375 -16.39675,18.86648 -14.94567,29.18021 -0.11772,12.83391 7.07763,21.57163 12.80989,30.60246 3.39226,4.12501 7.95693,6.79174 12.80988,7.11607 9.95577,1.31414 10.83988,4.37967 15.82257,6.27761 19.62805,26.7249 48.90915,46.43223 69.9979,62.04337 13.44173,7.08484 22.78967,14.16968 25.99215,18.03763 6.1743,11.78884 5.03794,23.28458 4.19228,28.93275 -5.21813,19.69052 -10.43866,39.38103 -15.65679,59.07154 -2.63309,16.08683 11.34679,12.46874 12.09875,9.25185 6.30885,-8.18996 15.72407,-2.43849 29.17781,-49.81969 6.1671,-8.30288 12.3366,-16.60576 18.5037,-24.90864 0,0 7.11847,-2.84691 7.11847,-3.55803 10.82305,-12.99488 2.58264,-20.43288 -3.56044,-22.77287 -4.507,-1.66009 -9.014,-3.32259 -13.52101,-4.98268 0,0 -15.65679,-15.6568 -16.36792,-15.6568 -7.4404,-21.64371 -43.9601,-67.8501 -52.44317,-74.28388 -5.87159,-6.11905 -8.66565,-8.72571 -14.23934,-12.12999 -8.56955,-4.09858 -11.33478,-5.43194 -16.58414,-7.52688 -4.37006,-1.7538 -1.25889,-6.5515 1.52075,-8.74494 28.92555,-15.74568 51.85457,-33.24515 79.61012,-51.03773 1.42225,-0.94897 2.84691,-1.89794 4.26916,-2.84691 -3.32019,-18.97698 -6.64278,-37.95637 -9.96297,-56.93335 -15.41895,-5.45598 -30.84031,-10.91435 -46.25926,-16.37032 -2.42648,1.66009 -4.26916,3.32259 -6.40494,4.98269 z' style='font-size:12px;fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:3.71638179;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0' /%3E %3Cpath inkscape:export-ydpi='90.000000' inkscape:export-xdpi='90.000000' sodipodi:nodetypes='ccccc' id='path4414' d='m 367.18534,600.42835 c 0.14655,-0.58379 28.95437,-5.84997 28.95437,-5.84997 0,0 -3.36343,10.6765 -3.50998,10.6765 l -28.66128,8.62721 3.21689,-13.45374 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke-width:1pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cs' id='path4416' d='m 292.11345,491.95755 c 5.55688,-14.77028 20.98304,-26.46543 31.34482,-29.69193' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4418' d='m 366.14988,600.68782 c 1.8595,-0.52374 10.11673,-2.9334 12.52159,-3.30818 2.56582,-0.60062 5.11963,-1.2733 7.58695,-2.06852 2.84691,-0.58139 4.62953,-1.11714 7.58695,-1.65529 2.31596,-0.8841 4.6055,-1.48952 7.08243,-2.06851 m -39.99365,26.91229 c 0.24025,-0.32193 2.20305,-2.0565 3.61329,-2.89496 1.6601,-0.52373 7.3371,-2.93339 9.48489,-3.30818 2.29194,-0.60061 4.57187,-1.2733 6.77492,-2.06851 2.5442,-0.58139 4.13462,-1.11714 6.77732,-1.65529 2.06852,-0.8841 4.11301,-1.48952 6.32326,-2.06851' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.65663357pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4420' d='m 372.6317,496.13782 c -0.13934,0 -0.27628,0 -0.41322,0 1.29492,0 0.49971,-0.10811 -1.24207,2.06852 -0.61983,1.6721 -5.92926,5.37669 -9.92694,5.37669 -1.92917,0.20661 -4.8938,0.41322 -6.82537,0.41322 -0.55016,0 -1.30934,-0.41322 -1.8619,-0.41322' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4422' d='m 372.21848,581.34806 c 0.13694,0 0.27388,0 0.41322,0 -0.55256,0 1.10273,0 1.65289,0 2.14539,0 4.29799,0.38199 6.20554,0.41322 2.06851,0 4.13702,0.5862 6.20554,0.5862 2.08773,0.2955 4.6031,0.19941 6.7629,0.50692 2.42168,0.0817 4.36526,0.55977 6.88544,0.55977 2.03247,0.0769 3.12799,0.41563 5.37909,0.41563 l -5.37909,-0.41563 c 2.03247,0.0769 3.12799,0.41563 5.37909,0.41563' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4424' d='m 358.15451,631.80921 c 0.22103,-0.32193 2.01806,-2.0565 3.30818,-2.89496 1.52076,-0.52374 6.71967,-2.9334 8.68728,-3.30818 2.09734,-0.60061 4.18507,-1.2733 6.20313,-2.06851 2.33038,-0.5814 3.78627,-1.11714 6.20554,-1.65529 1.89554,-0.88411 3.76705,-1.48953 5.78991,-2.06852' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4426' d='m 396.88928,559.91337 c -1.17,3.39707 0.34595,4.24994 0.97299,5.71544 1.09072,1.41985 3.87516,3.58446 8.27405,4.96347 1.69614,0.45646 3.00067,0.90332 4.96347,1.65529 1.29973,0.12012 1.93878,0.44445 2.89496,0.82644' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath id='path4428' d='m 233.23651,435.33412 c 0.13694,0 0.27629,0 0.41323,0 -1.29733,0 -0.51893,0.0841 1.65529,-1.6553 1.34297,-1.50153 2.46492,-2.18142 3.7214,-3.7214' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4430' d='m 260.01907,464.80021 c 0.27628,0 24.06298,-11.98824 26.60237,-14.54926 1.79944,-1.30453 3.16163,-2.68114 5.35027,-4.16345 1.40303,-0.73275 2.40966,-1.67211 3.7238,-2.48174 1.09312,-1.58321 2.52018,-2.53939 3.30818,-3.98807 1.46069,-1.26609 0.83365,-2.63789 2.01806,-4.16345 0.55978,-1.5616 1.60725,-4.19228 1.94839,-5.62174' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccc' id='path4432' d='m 333.26509,447.62267 c 0.12973,0.85527 -0.37959,3.49076 -0.34355,5.49681 -0.0817,2.32558 -3.07274,9.50892 -6.68843,11.65431' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4434' d='m 290.53024,447.35599 c 0.13934,0 3.75984,1.17721 9.81162,3.03911 7.28424,2.61867 22.43412,12.16603 23.93805,13.48017 1.53517,1.20843 4.28117,2.28713 5.33345,3.7214 1.64568,1.42225 2.85171,3.06313 4.13702,4.55025 1.51115,1.84268 2.79886,3.40187 3.72141,4.96347 4.6007,3.73101 16.97574,29.5646 17.37214,31.02289 0.69431,1.36459 1.55439,3.26493 2.06851,4.55024 0.91774,1.05708 1.53998,2.55141 2.48174,4.13703 0.86488,2.0565 1.83307,2.99346 2.89736,4.55025 1.3694,0.95137 3.21448,2.75801 4.96347,3.7214 1.8643,1.59523 3.61329,2.24389 4.96347,3.31058 1.95079,0.82885 23.75066,14.60932 24.76209,15.29883 1.99164,1.60003 8.07225,7.90167 3.80309,12.48555 -1.81145,1.54958 -3.44272,3.60128 -4.9899,4.47818 -1.57601,1.57841 -3.76945,2.28473 -5.5809,3.10156 -9.82123,2.90217 -14.82314,1.86191 -16.75472,1.86191 -0.6895,0 -1.379,0 -2.06851,0' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4436' d='m 242.38266,398.62222 c 2.79165,1.09311 1.6649,0.28589 4.17786,1.42946 1.68893,0.73995 2.80127,0.75917 4.46136,1.36459 1.761,0.56458 6.68123,1.45108 9.04524,3.82471 1.73457,1.5664 3.05832,2.89015 4.96347,4.03372 2.2535,1.55438 3.87996,2.24629 6.67402,3.41148 2.35681,0.8817 4.9923,1.8595 7.37553,1.94359 2.47693,0.14414 3.07034,0.0216 5.44636,0.0216 1.93158,0 3.86075,0 5.79232,0 l -5.79232,0 c 1.93158,0 3.86075,0 5.79232,0' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4438' d='m 241.71718,426.23362 c 6.20313,-0.41322 16.5433,1.44868 16.74991,1.44868 0.002,0 13.65074,-0.20661 13.65074,-0.20661 7.17133,-0.69191 8.75454,-3.44752 9.92694,-5.3791 2.68835,-4.13462 4.55025,-5.5833 6.61876,-8.68487 3.30818,-2.48173 7.86083,3.30818 8.06744,3.30818 11.57983,10.9624 2.27272,24.40413 1.65289,24.81735 -5.78991,5.30942 -7.03198,5.65298 -10.54677,2.27513 -3.5172,-4.13703 -4.55025,-5.99653 -7.44521,-7.44521 -5.5833,-2.68835 -17.16553,-0.61983 -17.37455,-0.61983 -0.20661,0 -5.99652,2.27512 -5.99652,2.27512 -2.82769,1.03306 -4.61992,3.51719 -9.51372,4.34124 -4.96347,0.34595 -6.61876,-0.13694 -9.10049,-4.13463 -3.30818,-5.17008 -1.6553,-11.37562 3.31058,-11.99545 z' style='font-size:12px;fill:%23ffe606;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath id='path4440' d='m 565.56641,175.3593 c -0.90893,0.17754 -9.09957,4.11011 -8.95592,4.36559 0.14364,0.25549 -7.02986,19.72306 -7.1735,19.46758 -0.14365,-0.25549 -5.14228,-16.90618 -5.65326,-16.61889 -0.50888,0.28611 -17.8281,2.3064 -18.08358,2.45004 -0.2534,0.14247 13.06825,-16.74311 13.06825,-16.74311 l -1.79543,-18.11539 14.14621,5.46889 c 0,0 15.02723,-11.46956 15.28272,-11.61321 0.25339,-0.14247 -3.95568,15.64642 -3.95568,15.64642 l 7.58272,10.50136 c 0,0 -4.23976,4.39573 -4.46253,5.19072 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4442' d='m 395.73044,374.8114 c 10.43497,6.88298 73.83751,20.16833 83.33251,21.5411 12.02457,-1.13811 28.89576,0.3733 41.57125,4.57443 12.1158,5.27925 24.48123,5.04643 32.76029,-1.27306 11.24468,-6.1871 15.33479,-16.74134 20.39743,-26.16388 1.93317,-4.97857 2.0206,-10.26439 -0.0751,-14.65354 -3.73368,-9.32223 -1.49482,-11.59526 -2.28239,-16.86869 13.67598,-30.20677 16.50408,-65.38866 19.77662,-91.42198 -0.41193,-15.18899 1.18244,-26.80954 2.98454,-31.49668 7.25009,-11.15953 17.82755,-15.8029 23.16536,-17.83384 19.72104,-5.10154 39.44326,-10.20098 59.1643,-15.30251 15.31292,-5.58873 5.30778,-16.00146 2.13517,-15.08038 -10.23086,-1.48547 -9.83171,-12.51119 -57.72617,-1.01762 -10.25981,-1.30658 -20.5208,-2.61525 -30.78062,-3.92183 0,0 -5.97024,-4.80976 -6.59011,-4.46124 -16.63152,-3.06558 -19.07652,7.76264 -18.10559,14.2642 0.76175,4.74223 1.52142,9.48564 2.28317,14.22787 0,0 -5.97444,21.3208 -5.62593,21.94067 -15.21982,17.09288 -37.87596,71.98059 -39.32668,82.52817 -0.6867,9.9113 -4.42988,8.12142 -3.42621,17.75484 0.0376,7.52791 -0.83827,2.8278 1.67498,18.33746 0.61297,4.66878 -5.0938,4.30813 -8.36803,2.96016 -27.90111,-17.49692 -54.39214,-28.90732 -83.50407,-44.38123 -1.52422,-0.77467 -3.04962,-1.55143 -4.57384,-2.32609 -14.91456,12.19448 -29.83005,24.39223 -44.74461,36.58671 2.80078,16.1142 5.60064,32.23167 8.40142,48.34588 2.63625,1.30151 4.98848,2.09296 7.48226,3.14108 z' style='font-size:12px;fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:3.71638179;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4444' d='m 638.04917,194.1671 c -0.5807,0.15836 -19.28941,-22.37181 -19.28941,-22.37181 0,0 10.95481,-2.30058 11.02663,-2.17284 l 21.56661,20.75523 -13.30383,3.78942 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke-width:1pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cs' id='path4446' d='m 580.28966,312.76536 c -15.59823,2.39492 -33.35273,-5.32004 -41.24335,-12.77088' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4448' d='m 638.7828,194.94252 c -1.36784,-1.36421 -7.51503,-7.38089 -9.02031,-9.29346 -1.78101,-1.94221 -3.61896,-3.83863 -5.52133,-5.5996 -1.90201,-2.19665 -3.24265,-3.48795 -5.16113,-5.80212 -1.90567,-1.58548 -3.55547,-3.28451 -5.27407,-5.15983 m 43.05908,21.67211 c -0.39836,-0.0516 -2.87229,-0.91248 -4.29429,-1.73083 -1.27011,-1.19039 -6.15277,-4.95794 -7.53206,-6.64645 -1.64679,-1.70347 -3.35051,-3.36115 -5.12336,-4.89177 -1.75367,-1.93278 -3.00011,-3.05655 -4.76435,-5.09639 -1.7844,-1.36978 -3.3141,-2.8552 -4.90201,-4.49807' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.65663414pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4450' d='m 544.47263,240.53096 c 0.0683,0.12146 0.1354,0.24083 0.20251,0.3602 -0.63462,-1.12875 -0.33914,-0.3826 2.41179,0.0689 1.76131,-0.27918 7.59257,2.53334 9.55178,6.01802 1.12556,1.58035 2.75858,4.06328 3.70521,5.74699 0.26963,0.47956 0.2815,1.34383 0.5523,1.82548' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4452' d='m 618.9507,199.13082 c -0.0671,-0.11937 -0.13422,-0.23874 -0.20251,-0.3602 0.2708,0.48166 -0.54043,-0.96122 -0.81006,-1.44078 -1.05143,-1.87008 -1.77341,-3.93366 -2.68105,-5.61172 -1.01375,-1.80307 -1.51653,-3.89343 -2.53028,-5.6965 -0.76558,-1.96465 -2.0821,-4.11013 -2.87253,-6.14349 -1.11563,-2.15094 -1.65142,-4.07942 -2.88652,-6.27619 -0.92908,-1.80934 -1.1707,-2.93029 -2.27393,-4.89251 l 2.27393,4.89251 c -0.92908,-1.80934 -1.1707,-2.93029 -2.27393,-4.89251' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4454' d='m 669.82893,186.65972 c -0.38894,-0.0349 -2.78162,-0.75123 -4.14475,-1.46488 -1.20183,-1.06893 -5.85018,-4.41974 -7.14117,-5.95118 -1.55142,-1.53385 -3.16095,-3.024 -4.84314,-4.39337 -1.64887,-1.7464 -2.82938,-2.7529 -4.48412,-4.59797 -1.69963,-1.21901 -3.14455,-2.55365 -4.64062,-4.03318' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4456' d='m 588.17582,188.13075 c 3.53454,-0.645 3.53502,-2.38439 4.50515,-3.64919 0.7031,-1.6466 1.22532,-5.13457 0.27153,-9.64481 -0.43336,-1.70218 -0.68318,-3.05831 -0.98965,-5.13776 -0.53227,-1.19181 -0.56275,-1.90781 -0.69839,-2.92849' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath id='path4458' d='m 559.78723,391.83724 c -0.0671,-0.11936 -0.1354,-0.24082 -0.20251,-0.36019 0.6358,1.13084 0.32761,0.41113 -2.25411,-0.63164 -1.96702,-0.43476 -3.10952,-1.07952 -5.06766,-1.42005' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4460' d='m 572.34631,354.05065 c -0.1354,-0.24083 -22.24277,-15.09982 -25.71966,-16.05822 -2.01901,-0.9292 -3.88655,-1.44193 -6.25127,-2.62324 -1.32632,-0.86388 -2.63847,-1.28097 -3.98824,-2.02969 -1.91577,-0.17692 -3.44863,-0.95225 -5.0976,-0.92915 -1.81948,-0.65276 -2.70794,0.56612 -4.61819,0.28136 -1.63554,0.27737 -4.442,0.65358 -5.85521,1.05677' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccc' id='path4462' d='m 521.47624,298.62243 c 0.68194,-0.53224 3.22885,-1.37989 4.9598,-2.39444 2.06718,-1.06853 9.79458,-1.98176 13.43667,0.11852' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4464' d='m 542.18754,336.00401 c -0.0683,-0.12146 -0.8165,-3.85429 -2.15943,-10.04196 -1.28727,-7.63287 -0.38983,-25.51765 0.0186,-27.47264 0.30099,-1.9304 -0.10451,-4.85268 0.63,-6.47283 0.43321,-2.13153 1.27246,-3.98697 1.93883,-5.83616 0.86563,-2.2203 1.59365,-4.1069 2.50272,-5.67637 0.99749,-5.83883 17.45113,-29.28652 18.52801,-30.34674 0.84921,-1.27398 2.08417,-2.95502 2.95258,-4.03309 0.47166,-1.31802 1.46928,-2.59276 2.38988,-4.19076 1.36873,-1.76176 1.71095,-3.06489 2.54638,-4.75557 0.15816,-1.65992 0.82872,-4.15365 0.81132,-6.15033 0.47685,-2.40687 0.18512,-4.24932 0.45322,-5.949 -0.23357,-2.10667 1.0947,-27.86267 1.20004,-29.08223 0.41863,-2.52021 2.93159,-10.90887 9.01949,-9.43405 2.2385,0.81957 4.82637,1.23599 6.34899,2.15488 2.14824,0.60021 3.8389,2.16602 5.43868,3.34469 7.34299,7.13861 8.88758,12.00846 9.83422,13.69217 0.33792,0.60102 0.67583,1.20204 1.01375,1.80307' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath id='path4466' d='m 523.19361,401.02311 c -0.0671,-0.11937 -0.13541,-0.24083 -0.20252,-0.3602 0.5475,0.97378 0.24424,0.48833 -0.45104,-1.64539 -0.18272,-1.83483 -0.74862,-4.3169 -1.03448,-6.06067 -0.37092,-1.81171 -1.21985,-3.87557 -0.98966,-5.13776 -0.64874,-1.84017 -0.24065,-3.35949 -0.0667,-5.1826 0.5153,-2.27965 0.74819,-3.92922 0.81133,-6.15034 0.25051,-2.7261 0.0491,-4.65792 0.20469,-7.23419 -0.71831,-2.12077 -0.86479,-3.89605 -1.95948,-6.01466 -0.97405,-2.02659 -1.71911,-3.9008 -2.88357,-5.97192 -0.94664,-1.6837 -1.8921,-3.36531 -2.83873,-5.04902 l 2.83873,5.04902 c -0.94664,-1.6837 -1.8921,-3.36531 -2.83873,-5.04902' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4468' d='m 547.69831,388.90489 c -3.40026,-5.2046 -6.84486,-15.13035 -6.94612,-15.31045 -0.001,-0.002 -6.87013,-11.79774 -6.87013,-11.79774 -4.11769,-5.91197 -7.2956,-5.94153 -9.55387,-6.01685 -4.92157,-0.31704 -7.09684,-1.23003 -10.81414,-1.51307 -3.78456,-1.66739 -0.96883,-8.47338 -1.07009,-8.65347 3.88053,-15.46636 20.15862,-13.9412 20.82259,-13.60342 7.46564,2.44485 8.37382,3.35916 7.15199,8.07835 -1.88241,5.09334 -2.99701,6.90515 -2.841,10.13858 0.39293,6.18435 7.87229,15.26653 7.97473,15.44873 0.10125,0.18009 4.92197,4.11201 4.92197,4.11201 2.2863,1.95854 5.33001,2.30334 8.44669,6.16529 2.73408,4.15698 3.12439,5.83651 0.85598,9.95899 -2.88534,5.41744 -9.1046,7.0179 -12.0786,2.99305 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cg transform='matrix(-1.107009,2.132209,-2.132209,-1.10701,906.73765,-15.62964)' id='g4470'%3E %3Cpath id='path4472' d='m 238.862,224.504 c 0.121,-0.366 0.365,-4.14 0.243,-4.14 -0.122,0 -5.722,-6.574 -5.6,-6.574 0.122,0 7.183,1.583 7.183,1.339 0,-0.243 2.8,-6.939 2.8,-7.061 0,-0.121 3.409,8.157 3.409,8.157 l 6.939,3.044 -4.87,4.017 c 0,0 1.096,7.792 1.096,7.914 0,0.121 -4.87,-4.627 -4.87,-4.627 l -5.357,0.609 c 0,0 -0.73,-2.435 -0.973,-2.678 z' style='fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4474' d='m 201.141,122.196 c -4.626,2.382 -22.38,22.676 -24.815,25.841 -2.04,4.595 -6.03,10.408 -10.14,14.15 -4.387,3.319 -6.825,7.853 -6.221,12.146 -0.049,5.342 2.946,8.979 5.332,12.738 1.412,1.717 3.312,2.827 5.332,2.962 4.144,0.547 4.512,1.823 6.586,2.613 8.17,11.124 20.358,19.327 29.136,25.825 5.595,2.949 9.486,5.898 10.819,7.508 2.57,4.907 2.097,9.692 1.745,12.043 -2.172,8.196 -4.345,16.392 -6.517,24.588 -1.096,6.696 4.723,5.19 5.036,3.851 2.626,-3.409 6.545,-1.015 12.145,-20.737 2.567,-3.456 5.135,-6.912 7.702,-10.368 0,0 2.963,-1.185 2.963,-1.481 4.505,-5.409 1.075,-8.505 -1.482,-9.479 -1.876,-0.691 -3.752,-1.383 -5.628,-2.074 0,0 -6.517,-6.517 -6.813,-6.517 -3.097,-9.009 -18.39,-28.426 -21.921,-31.104 -3.456,-2.271 -2.043,-3.264 -5.743,-4.865 -2.739,-1.522 -0.855,-0.881 -6.995,-3.133 -1.819,-0.73 -0.524,-2.727 0.633,-3.64 12.04,-6.554 21.584,-13.838 33.137,-21.244 0.592,-0.395 1.185,-0.79 1.777,-1.185 -1.382,-7.899 -2.765,-15.799 -4.147,-23.698 -6.418,-2.271 -12.837,-4.543 -19.255,-6.814 -1.01,0.691 -1.777,1.383 -2.666,2.074 z' style='fill:%23ffffff;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.54691064;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4476' d='m 217.252,246.966 c 0.061,-0.243 12.052,-2.435 12.052,-2.435 0,0 -1.4,4.444 -1.461,4.444 l -11.93,3.591 1.339,-5.6 z' style='fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:none' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cs' id='path4478' d='m 186.004,201.816 c 2.313,-6.148 8.734,-11.016 13.047,-12.359' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4480' d='m 216.821,247.074 c 0.774,-0.218 4.211,-1.221 5.212,-1.377 1.068,-0.25 2.131,-0.53 3.158,-0.861 1.185,-0.242 1.927,-0.465 3.158,-0.689 0.964,-0.368 1.917,-0.62 2.948,-0.861 m -16.647,11.202 c 0.1,-0.134 0.917,-0.856 1.504,-1.205 0.691,-0.218 3.054,-1.221 3.948,-1.377 0.954,-0.25 1.903,-0.53 2.82,-0.861 1.059,-0.242 1.721,-0.465 2.821,-0.689 0.861,-0.368 1.712,-0.62 2.632,-0.861' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:1.10579996pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4482' d='m 219.519,203.556 c -0.058,0 -0.115,0 -0.172,0 0.539,0 0.208,-0.045 -0.517,0.861 -0.258,0.696 -2.468,2.238 -4.132,2.238 -0.803,0.086 -2.037,0.172 -2.841,0.172 -0.229,0 -0.545,-0.172 -0.775,-0.172' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4484' d='m 219.347,239.024 c 0.057,0 0.114,0 0.172,0 -0.23,0 0.459,0 0.688,0 0.893,0 1.789,0.159 2.583,0.172 0.861,0 1.722,0.244 2.583,0.244 0.869,0.123 1.916,0.083 2.815,0.211 1.008,0.034 1.817,0.233 2.866,0.233 0.846,0.032 1.302,0.173 2.239,0.173 l -2.239,-0.173 c 0.846,0.032 1.302,0.173 2.239,0.173' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4486' d='m 213.493,260.028 c 0.092,-0.134 0.84,-0.856 1.377,-1.205 0.633,-0.218 2.797,-1.221 3.616,-1.377 0.873,-0.25 1.742,-0.53 2.582,-0.861 0.97,-0.242 1.576,-0.465 2.583,-0.689 0.789,-0.368 1.568,-0.62 2.41,-0.861' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4488' d='m 229.616,230.102 c -0.487,1.414 0.144,1.769 0.405,2.379 0.454,0.591 1.613,1.492 3.444,2.066 0.706,0.19 1.249,0.376 2.066,0.689 0.541,0.05 0.807,0.185 1.205,0.344' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath id='path4490' d='m 161.497,178.247 c 0.057,0 0.115,0 0.172,0 -0.54,0 -0.216,0.035 0.689,-0.689 0.559,-0.625 1.026,-0.908 1.549,-1.549' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4492' d='m 172.645,190.512 c 0.115,0 10.016,-4.99 11.073,-6.056 0.749,-0.543 1.316,-1.116 2.227,-1.733 0.584,-0.305 1.003,-0.696 1.55,-1.033 0.455,-0.659 1.049,-1.057 1.377,-1.66 0.608,-0.527 0.347,-1.098 0.84,-1.733 0.233,-0.65 0.669,-1.745 0.811,-2.34' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccc' id='path4494' d='m 203.133,183.362 c 0.054,0.356 -0.158,1.453 -0.143,2.288 -0.034,0.968 -1.279,3.958 -2.784,4.851' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4496' d='m 185.345,183.251 c 0.058,0 1.565,0.49 4.084,1.265 3.032,1.09 9.338,5.064 9.964,5.611 0.639,0.503 1.782,0.952 2.22,1.549 0.685,0.592 1.187,1.275 1.722,1.894 0.629,0.767 1.165,1.416 1.549,2.066 1.915,1.553 7.066,12.306 7.231,12.913 0.289,0.568 0.647,1.359 0.861,1.894 0.382,0.44 0.641,1.062 1.033,1.722 0.36,0.856 0.763,1.246 1.206,1.894 0.57,0.396 1.338,1.148 2.066,1.549 0.776,0.664 1.504,0.934 2.066,1.378 0.812,0.345 9.886,6.081 10.307,6.368 0.829,0.666 3.36,3.289 1.583,5.197 -0.754,0.645 -1.433,1.499 -2.077,1.864 -0.656,0.657 -1.569,0.951 -2.323,1.291 -4.088,1.208 -6.17,0.775 -6.974,0.775 -0.287,0 -0.574,0 -0.861,0' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath id='path4498' d='m 165.629,163.096 c 0.057,0 0.115,0 0.172,0 -0.465,0 -0.227,-0.011 0.689,0.172 0.703,0.308 1.719,0.609 2.41,0.861 0.733,0.235 1.655,0.348 2.066,0.689 0.8,0.14 1.268,0.598 1.894,1.033 0.722,0.652 1.273,1.073 2.066,1.549 0.938,0.647 1.68,0.968 2.583,1.55 0.916,0.172 1.59,0.481 2.582,0.516 0.934,0.06 1.766,0.172 2.755,0.172 0.804,0 1.607,0 2.411,0 l -2.411,0 c 0.804,0 1.607,0 2.411,0' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath id='path4500' d='m 221.241,142.952 c -0.115,0 -0.23,0 -0.345,0 0.637,0 0.458,-0.023 -0.516,0.172 -1.017,0.525 -2.371,0.922 -3.272,1.377 -1.028,0.34 -2.133,0.717 -3.099,1.206 -1.094,0.641 -2.102,1.162 -3.099,1.893 -0.991,0.531 -1.965,1.185 -2.927,1.722 -0.959,0.521 -1.751,1.024 -2.582,1.722 -0.694,0.385 -1.637,0.93 -2.411,1.549 -0.727,0.261 -1.252,0.779 -1.721,1.206 -0.911,0.807 -1.469,1.226 -2.411,2.066 -0.495,0.468 -1.153,1.018 -1.894,1.721 -0.778,0.519 -1.62,1.517 -2.238,2.066 -0.396,0.517 -0.976,1.132 -1.549,1.55 -0.441,0.555 -0.952,1.285 -1.55,1.722 -0.355,0.528 -0.976,1.216 -1.55,1.894 -0.465,0.569 -1.105,1.142 -1.549,1.721 -0.598,0.662 -1.056,1.329 -1.722,1.894 -0.119,0.398 -0.369,0.604 -0.516,0.861' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4502' d='m 165.027,174.459 c 2.582,-0.172 6.886,0.603 6.972,0.603 0.001,0 5.682,-0.086 5.682,-0.086 2.985,-0.288 3.644,-1.435 4.132,-2.239 1.119,-1.721 1.894,-2.324 2.755,-3.615 1.377,-1.033 3.272,1.377 3.358,1.377 4.82,4.563 0.946,10.158 0.688,10.33 -2.41,2.21 -2.927,2.353 -4.39,0.947 -1.464,-1.722 -1.894,-2.496 -3.099,-3.099 -2.324,-1.119 -7.145,-0.258 -7.232,-0.258 -0.086,0 -2.496,0.947 -2.496,0.947 -1.177,0.43 -1.923,1.464 -3.96,1.807 -2.066,0.144 -2.755,-0.057 -3.788,-1.721 -1.377,-2.152 -0.689,-4.735 1.378,-4.993 z' style='fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3C/g%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4504' d='m 332.30165,290.148 c -2.276,-2.067 42.811,16.337 49.014,16.546 8.481,-3.102 43.433,-32.676 43.433,-32.676 0.345,2.895 1.584,10.409 4.961,11.996 -13.51,10.962 -25.782,21.508 -39.293,32.468 0.966,17.373 -2.205,35.78 6.618,55.221 0,0 -10.546,0.205 -10.546,0 -9.307,-9.307 -12.618,-54.185 -12.618,-54.185 -14.821,-6.619 -29.644,-13.029 -44.465,-19.648 2.138,-1.38 3.861,-5.652 2.896,-9.722 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98742095;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4506' d='m 375.19865,336.153 c 0.721,-0.523 -8.133,4.113 -10.407,5.277 -40.961,21.85 -62.04,53.634 -63.354,54.835 -0.708,1.354 -2.011,3.16 -3.204,4.929 -0.96,1.483 -2.338,3.018 -3.246,4.518 -1.255,1.738 -3.893,5.17 -5.334,6.694 -0.18,0.982 0.683,-0.336 0.401,0.317' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4508' d='m 403.18665,310.185 c -0.795,-0.402 7.378,5.351 9.453,6.84 38.166,26.431 76.072,30.638 77.741,31.257 1.528,0.01 3.73,0.343 5.848,0.595 1.759,0.175 3.753,0.698 5.503,0.82 2.119,0.32 6.378,1.096 8.393,1.681 0.954,-0.29 -0.611,-0.453 0.098,-0.502' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0' /%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 225 150' width='1350' height='900'%3E%3Crect width='225' height='150' fill='%23f93'/%3E%3Crect width='225' height='50' y='50' fill='%23fff'/%3E%3Crect width='225' height='50' y='100' fill='%23128807'/%3E%3Cg transform='translate(112.5,75)'%3E%3Ccircle r='20' fill='%23008'/%3E%3Ccircle r='17.5' fill='%23fff'/%3E%3Ccircle r='3.5' fill='%23008'/%3E%3Cg id='d'%3E%3Cg id='c'%3E%3Cg id='b'%3E%3Cg id='a'%3E%3Ccircle r='0.875' fill='%23008' transform='rotate(7.5) translate(17.5)'/%3E%3Cpath fill='%23008' d='M 0,17.5 0.6,7 C 0.6,7 0,2 0,2 0,2 -0.6,7 -0.6,7 L 0,17.5 z'/%3E%3C/g%3E%3Cuse xlink:href='%23a' transform='rotate(15)'/%3E%3C/g%3E%3Cuse xlink:href='%23b' transform='rotate(30)'/%3E%3C/g%3E%3Cuse xlink:href='%23c' transform='rotate(60)'/%3E%3C/g%3E%3Cuse xlink:href='%23d' transform='rotate(120)'/%3E%3Cuse xlink:href='%23d' transform='rotate(-120)'/%3E%3C/g%3E%3C/svg%3E"

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 600 300'%3E %3Cdefs%3E %3CclipPath id='cp'%3E %3Cpath d='M0 0V75H350V150H300zM300 0H150V200H0V150z'/%3E %3C/clipPath%3E %3CclipPath id='cp2'%3E %3Crect width='300' height='150'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect fill='%23FFF' width='600' height='300'/%3E %3Cpath id='wave' fill='%23002b7f' d='M600 260.881C593.277 264.926 587.501 274.379 569.64 274.379 533.929 274.379 524.999 254.477 498.213 254.477 480.357 254.477 471.428 274.379 453.572 274.379 417.857 274.379 408.929 254.477 382.143 254.477 364.286 254.477 355.357 274.379 337.5 274.379 301.786 274.379 292.857 254.477 266.072 254.477 248.214 254.477 239.286 274.379 221.429 274.379 185.715 274.379 176.786 254.477 150 254.477 132.142 254.477 123.214 274.379 105.357 274.379 69.643 274.379 60.714 254.477 33.929 254.477 16.071 254.477 10.714 268.659 0 268.659L0 294.28C10.714 294.28 16.071 280.099 33.929 280.099 60.714 280.099 69.643 300 105.357 300 123.214 300 132.142 280.099 150 280.099 176.785 280.099 185.715 300 221.429 300 239.286 300 248.214 280.099 266.072 280.099 292.857 280.099 301.786 300 337.5 300 355.357 300 364.286 280.099 382.143 280.099 408.929 280.099 417.857 300 453.572 300 471.428 300 480.357 280.099 498.213 280.099 524.999 280.099 533.929 300 569.64 300 587.501 300 593.277 294.36 600 290.316L600 260.881z'/%3E %3Cuse transform='translate(0,-49.75348)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-99.50701)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-149.26056)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-199.01404)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-248.76752)' xlink:href='%23wave'/%3E %3Crect fill='%23FFF' width='300' height='152'/%3E %3Cg clip-path='url(%23cp2)'%3E %3Crect width='300' height='150' fill='%2300247d'/%3E %3Cpath d='M0 0L300 150M300 0L0 150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0 0L300 150M300 0L0 150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150 0V200M0 75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150 0V200M0 75H350' stroke='%23cf142b' stroke-width='30'/%3E %3C/g%3E %3Cg%3E %3Cg transform='matrix(0.604762,0,0,0.604762,0,-1.160721e-4)'%3E %3Cpath d='M814.961-301.181L797.244 407.48C797.244 444.778 877.341 444.778 885.827 407.48L868.11-301.181 814.961-301.181z' transform='matrix(0.200004,0,0,0.475,575.1662,274.5648)' style='fill:%23a24300;stroke-width:6.935;stroke:%23fff'/%3E %3Cg transform='matrix(0.725195,0,0,0.6231,202.0636,41.43416)'%3E %3Cg transform='matrix(-0.314512,0.10485,-0.138292,-0.303235,1046.472,373.319)'%3E %3Cg id='t3' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M496.063 549.213L513.78 620.079 549.213 566.929 531.496 655.512 566.929 620.079 531.496 708.661 566.929 673.228 531.496 761.811 566.929 726.378 531.496 832.677 566.929 797.244 531.496 903.543 566.929 868.11 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 425.197 868.11 460.63 903.543 425.197 797.244 460.63 832.677 425.197 726.378 460.63 761.811 425.197 673.228 460.63 708.661 425.197 620.079 460.63 655.512 442.913 566.929 478.346 620.079 496.063 549.213z' transform='translate(177.1655,-224.0517)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M496.063 549.213L496.063 1045.28' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 868.11L496.063 974.409 566.929 868.11' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 797.244L496.063 903.543 566.929 797.244' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 726.378L496.063 832.677 566.929 726.378' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 673.228L496.063 761.811 566.929 673.228' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 620.079L496.063 708.661 566.929 620.079' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M442.913 566.929L496.063 673.228 549.213 566.929' transform='translate(177.1655,-224.0517)'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t3' transform='matrix(0.236516,-0.281856,0.294964,0.227618,354.5673,204.654)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(0.15164,0.335243,-0.332899,0.167308,907.5388,-153.4696)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(-0.209517,0.302465,-0.314697,-0.199448,1141.363,167.5798)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(-0.207724,-0.258384,0.236176,-0.235153,689.9856,567.2772)'/%3E %3Cg transform='matrix(-0.362184,-9.947167e-2,-0.209809,0.317733,1222.415,-24.22945)'%3E %3Cg id='t2' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M460.63 549.213L489.273 620.079 531.496 566.929 521.312 655.512 549.212 620.079 531.496 708.661 556.745 673.228 531.496 761.811 566.929 726.378 531.496 832.677 566.929 797.244 531.496 903.543 566.929 868.11 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 425.197 868.11 460.63 903.543 425.197 797.244 460.63 832.677 425.197 726.378 460.63 761.811 415.013 673.228 460.63 708.661 407.48 620.079 450.446 655.512 425.196 566.929 460.629 620.079 460.63 549.213z' transform='translate(283.4647,-124.0162)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M467.208 584.646L496.063 708.662 496.063 1045.28' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M436.23 885.827L496.063 974.409 556.745 885.827' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M434.533 814.961L496.063 903.543 556.745 814.961' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M435.381 744.095L496.063 832.677 555.896 744.095' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M432.835 690.945L496.063 761.811 549.212 690.945' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M425.197 637.796L496.063 708.661 541.469 637.796' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M436.124 593.238L489.274 680.124 524.601 584.646' transform='translate(283.4647,-124.0162)'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t2' transform='matrix(0.360878,0.10411,1.321056e-2,0.380525,452.7614,-239.2657)'/%3E %3Cg transform='matrix(4.613187e-2,-0.364743,0.326017,6.479648e-2,379.5799,479.5432)' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M354.331 531.496L442.914 620.079 460.63 566.93 460.63 655.512 496.063 620.079 478.347 708.662 513.779 673.228 496.063 761.812 531.496 726.379 513.78 832.678 549.213 797.245 513.78 903.544 549.213 868.111 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 407.48 892.115 442.914 903.544 407.481 797.245 442.914 832.678 389.764 726.379 425.197 761.812 372.047 673.228 425.197 708.662 354.331 620.079 407.48 655.512 336.614 584.646 407.48 620.079 354.331 531.496z' transform='translate(442.9136,-42.96583)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M378.962 560.015L442.914 655.512 460.63 708.662 469.489 753.867 478.347 832.678 487.662 903.544 496.063 1045.28' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M425.197 903.544L488.862 974.41 539.611 885.827' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M417.082 814.961L487.661 903.544 538.411 814.961' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M407.48 752.443L478.347 832.678 524.295 744.095' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M372.047 637.796L460.63 708.662 486.461 637.796' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M360.618 602.363L442.914 655.512 453.429 602.363' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M389.764 690.945L470.859 761.811 504.805 690.945' transform='translate(442.9136,-42.96583)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(0.253333,0,0,0.253333,412,157.1807)'%3E %3Cpath d='M52.504 257.674L151.04 239.994 253.682 257.674 206.056 277.475 118.195 278.89 52.504 257.674z' style='fill:%239d9d9d;stroke-width:1.008;stroke:%23000'/%3E %3Cpath d='M151.789 98.445C134.566 104.432 115.487 90.02 84.43 113.539 84.43 113.539 30.286 90.376 26.173 143.91 26.008 146.077 34.743 159.133 35.959 158.2 42.763 152.976 32.729 163.272 32.729 164.76 32.729 166.26 33.727 167.093 34.064 167.754 34.395 168.421 35.227 169.419 35.393 172.248 35.558 175.076 29.256 182.792 31.919 185.62 34.576 188.449 34.741 196.604 34.741 198.931 34.741 201.257 36.407 207.747 37.57 209.082 38.733 210.41 40.729 213.735 40.729 216.563 40.729 219.392 41.892 227.21 41.39 229.2 40.894 231.196 44.384 233.694 47.55 234.692 50.709 235.69 91.485 236.398 148.712 235.4 205.945 234.402 225.04 243.457 248.686 234.857 252.341 233.529 253.008 230.535 252.678 228.869 252.341 227.21 252.678 221.89 253.676 220.555 254.674 219.227 261.329 208.58 259.994 206.584 261.25 205.45 270.583 211.974 264.639 206.148 263.115 204.655 265.492 188.932 266.312 185.62 267.139 182.302 268.408 176.071 269.933 174.914 271.465 173.757 267.335 169.426 267.628 168.644 267.926 167.856 269.039 165.415 270.59 164.303 270.59 164.303 273.475 150.776 271.696 144.127 269.929 137.472 263.426 107.544 222.834 113.539 222.834 113.539 168.494 92.639 151.789 98.445z' style='fill:%23c00;stroke-width:1.629;stroke:%23000'/%3E %3Cg transform='translate(0,-2.600445e-4)'%3E %3Cg transform='matrix(1.085779,0,0,1.085779,6.91471,26.11235)'%3E %3Cg transform='matrix(0.496967,-4.459677e-2,8.946727e-2,0.726775,44.70009,100.5425)' stroke-width='1.241'%3E %3Cg id='t4'%3E %3Cpath d='M49.75 0.125C44.657 1.015 34.594 29.37 37.141 38.875 38.904 45.455 41.639 49.995 43.188 52.781 39.783 48.096 31.805 39.031 20.938 39.031 7.274 39.031 5.507 68.979 5.844 70.906 5.845 70.913 5.842 70.932 5.844 70.938 5.845 70.942 5.873 70.965 5.875 70.969 5.877 70.968 5.904 70.97 5.906 70.969 6.519 70.254 12.048 57.875 25.563 57.875 34.459 57.875 41.392 64.91 43.938 67.906 43.937 68.851 43.96 69.764 43.969 70.688 41.965 73.516 40.687 80.219 34.5 88.656 27.023 98.852 4.128 99.897 0.281 100 1.252 100 37.806 100 49.813 100 49.86 100 49.922 100.003 49.969 100 49.991 100.002 50.009 99.999 50.031 100 50.078 100.003 50.14 100 50.188 100 62.194 100 98.748 100 99.719 100 95.872 99.897 72.539 98.852 65.063 88.656 58.875 80.219 58.035 73.516 56.031 70.688 56.04 69.764 56.063 68.851 56.063 67.906 58.608 64.91 65.541 57.875 74.438 57.875 87.952 57.875 93.481 70.254 94.094 70.969 94.096 70.97 94.123 70.968 94.125 70.969 94.127 70.965 94.155 70.942 94.156 70.938 94.158 70.932 94.155 70.913 94.156 70.906 94.493 68.979 92.726 39.031 79.063 39.031 68.195 39.031 60.217 48.096 56.813 52.781 58.361 49.995 61.103 44.206 62.531 38.875 65.118 29.219 55.091 0.132 50 0.125 49.92 0.125 49.831 0.111 49.75 0.125zM43.313 52.969C43.665 53.459 43.975 53.881 44.219 54.25 44.224 54.258 44.76 57.227 44.766 57.234 44.763 57.298 47.393 67.42 47.39 67.484 47.126 67.092 43.653 53.569 43.313 52.969zM56.688 52.969C56.347 53.569 52.655 67.092 52.391 67.484 52.388 67.42 55.784 54.345 55.781 54.281 55.781 54.271 55.344 57.245 55.344 57.234 55.588 56.865 56.335 53.459 56.688 52.969z' style='fill:%23f7d917;stroke-width:1.241;stroke:%23000'/%3E %3Cpath d='M42 67.578C42 67.578 46 65.719 50 65.719 54 65.719 58 67.578 58 67.578L58 72.531C58 72.531 54 70.672 50 70.672 46 70.672 42 72.531 42 72.531L42 67.578z' style='fill:%23f7d917;stroke-width:1.241;stroke:%23000'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t4' transform='matrix(0.495379,5.970303e-2,-6.359282e-2,0.729495,168.9189,96.59048)'/%3E %3Cg style='fill:%23f7d917;stroke-width:0.715;stroke:%23000'%3E %3Cpath d='M24.308 134.56L33.998 122.746C33.998 122.746 34.901 123.914 33.998 122.746 14.132 97.065 13.127 82.331 15.363 74.87 17.599 67.409 22.072 59.326 33.998 49.377 45.924 39.429 54.154 44.958 65.334 44.958 76.515 44.958 79.497 47.445 89.186 48.689 98.876 49.932 124.964 51.176 124.964 51.176L124.964 44.336C124.964 44.336 125.993 44.528 124.964 44.336 113.446 42.189 98.876 44.336 89.186 41.849 79.497 39.362 71.297 38.741 60.862 38.741 50.427 38.741 42.942 35.698 36.234 40.051 29.525 44.403 21.326 51.864 15.363 58.082 9.4 64.3 6.419 76.735 7.164 84.818 7.91 92.901 10.891 99.741 15.363 105.958 19.836 112.176 19.09 117.15 20.581 121.502 22.072 125.855 24.308 135.181 24.308 134.56z'/%3E %3Cpath d='M239.255 134.56L229.565 122.746C229.565 122.746 228.661 123.914 229.565 122.746 249.43 97.065 250.435 82.331 248.199 74.87 245.963 67.409 241.491 59.326 229.565 49.377 217.639 39.429 209.409 44.958 198.228 44.958 187.047 44.958 184.066 47.445 174.376 48.689 164.686 49.932 138.598 51.176 138.598 51.176L138.598 44.336C138.598 44.336 137.569 44.528 138.598 44.336 150.117 42.189 164.686 44.336 174.376 41.849 184.066 39.362 192.265 38.741 202.7 38.741 213.136 38.741 220.62 35.698 227.329 40.051 234.037 44.403 242.236 51.864 248.199 58.082 254.162 64.3 257.144 76.735 256.398 84.818 255.653 92.901 252.671 99.741 248.199 105.958 243.727 112.176 244.472 117.15 242.982 121.502 241.491 125.855 239.255 135.181 239.255 134.56z'/%3E %3Crect width='34.563' height='70.894' x='115.553' y='38.701' style='stroke-width:0.835'/%3E %3C/g%3E %3Cg transform='translate(0,-8)' style='fill:%23f7d917;stroke-width:0.5;stroke:%23000'%3E %3Cpath d='M119.684-15.799C119.684-15.799 123.404-12.771 126.259-8.877 129.115-4.984 131.105-0.225 131.105-0.225 131.105-0.225 126.346-2.215 122.453-5.071 118.559-7.926 115.531-11.646 115.531-11.646L115.531 14.656C115.531 14.656 118.559 10.936 122.453 8.081 126.346 5.225 131.105 3.235 131.105 3.235 131.105 3.235 129.571 7.162 128.581 11.888 127.69 16.138 120.398 25.952 120.398 25.952L141.701 27.381C141.701 27.381 138.159 16.138 136.732 11.888 135.196 7.31 134.565 3.235 134.565 3.235 134.565 3.235 139.324 5.225 143.218 8.081 147.111 10.936 150.139 14.656 150.139 14.656L150.139-11.646C150.139-11.646 147.111-7.926 143.218-5.071 139.324-2.215 134.565-0.225 134.565-0.225 134.565-0.225 136.555-4.984 139.411-8.877 142.266-12.771 145.986-15.799 145.986-15.799L119.684-15.799z'/%3E %3Cpath d='M150 23.076A17.143 17.143 0 1 1 115.714 23.076 17.143 17.143 0 1 1 150 23.076z' transform='translate(-2.209282e-2,8)'/%3E %3Cpath d='M116.074 33.535L150.176 33.535C150.176 33.535 150.67 26.939 148.202 24.471 145.823 24.471 137.608 24.471 137.608 24.471L137.429 14.583 133.484 14.583 127.387 14.583 127.208 24.471C127.208 24.471 120.081 24.828 116.798 24.828 115.309 28.869 115.538 29.209 115.538 29.209L116.074 33.535z'/%3E %3C/g%3E %3Cg style='fill:%23f7d917;stroke-width:0.75;stroke:%23000'%3E %3Cpath d='M110.877 107.221C110.877 107.221 117.089 112.277 121.856 118.778 126.623 125.279 129.946 133.224 129.946 133.224 129.946 133.224 122 129.901 115.5 125.134 108.999 120.367 103.943 114.155 103.943 114.155L103.943 158.071C103.943 158.071 108.999 151.86 115.5 147.092 122 142.325 129.946 139.002 129.946 139.002 129.946 139.002 126.623 146.948 121.856 153.449 117.089 159.949 110.877 165.006 110.877 165.006L154.793 165.006C154.793 165.006 148.581 159.949 143.814 153.449 139.047 146.948 135.724 139.002 135.724 139.002 135.724 139.002 143.67 142.325 150.17 147.092 156.671 151.86 161.727 158.071 161.727 158.071L161.727 114.155C161.727 114.155 156.671 120.367 150.17 125.134 143.67 129.901 135.724 133.224 135.724 133.224 135.724 133.224 139.047 125.279 143.814 118.778 148.581 112.277 154.793 107.221 154.793 107.221L110.877 107.221z'/%3E %3Cpath d='M27.24 181.78L48.865 177.967C48.865 177.967 41.87 174.066 36.046 168.492 30.222 162.918 25.57 155.67 25.57 155.67 25.57 155.67 33.972 157.562 41.202 161.128 48.432 164.694 54.49 169.934 54.49 169.934L46.864 126.685C46.864 126.685 42.963 133.68 37.389 139.504 31.815 145.328 24.567 149.979 24.567 149.979 24.567 149.979 26.459 141.578 30.025 134.348 33.591 127.118 38.831 121.06 38.831 121.06L17.206 124.873 27.24 181.78z'/%3E %3Cpath d='M226.839 121.06C226.839 121.06 232.079 127.118 235.645 134.348 239.211 141.578 241.103 149.979 241.103 149.979 241.103 149.979 233.855 145.328 228.281 139.504 222.707 133.68 218.806 126.685 218.806 126.685L211.18 169.934C211.18 169.934 217.238 164.694 224.468 161.128 231.698 157.562 240.1 155.67 240.1 155.67 240.1 155.67 235.448 162.918 229.624 168.492 223.801 174.066 216.805 177.967 216.805 177.967L238.43 181.78 248.464 124.873 226.839 121.06z'/%3E %3Cpath d='M27.464 179.533L27.614 211.039C27.614 211.039 80.262 193.111 132.91 193.111 185.558 193.111 238.206 211.039 238.206 211.039L238.206 179.533C238.206 179.533 185.521 161.604 132.835 161.604 80.149 161.604 27.464 179.533 27.464 179.533z'/%3E %3C/g%3E %3Cg fill='%23FFF' store-width='1.5' stroke='%23000'%3E %3Cg transform='matrix(0.661234,0,0,0.661234,21.24618,-360.3206)'%3E %3Cpath id='c3' d='M2.02 723.052A12.122 12.122 0 1 1-22.223 723.052 12.122 12.122 0 1 1 2.02 723.052z'/%3E %3C/g%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,10.96519,-378.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,8.822333,-400.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,15.25091,-420.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,28.82233,-436.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,47.39376,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,68.10805,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,88.82233,-443.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,109.5366,-440.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,242.3163,-360.3206)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,252.5973,-378.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,254.7402,-400.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,248.3116,-420.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,234.7402,-436.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,216.1687,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,195.4544,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,174.7402,-443.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,154.0259,-440.8875)'/%3E %3Cg transform='translate(1.040326,0)'%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-378.3206)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-392.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-404.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-414.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-439.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-428.8875)'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23FFF' stroke='%23000'%3E %3Cg transform='translate(-0.457137,-2)'%3E %3Cpath id='circle1' d='M143.571 136.291A10.357 10.357 0 1 1 122.857 136.291 10.357 10.357 0 1 1 143.571 136.291z'/%3E %3C/g%3E %3Cuse xlink:href='%23circle1' transform='translate(-108.7143,16.78571)'/%3E %3Cuse xlink:href='%23circle1' transform='translate(107.2857,16.78571)'/%3E %3C/g%3E %3C/g%3E %3Crect width='34.762' height='15.153' x='134.791' y='210.096' style='fill:%23002b7f;stroke-width:0.841;stroke:%23000'/%3E %3Cpath d='M16.043 233.111A22.995 8.556 0 1 1-29.947 233.111 22.995 8.556 0 1 1 16.043 233.111z' transform='matrix(-0.678154,-6.882792e-2,2.382547e-2,0.957698,195.4766,-0.830297)' style='fill:%233e8225;stroke-width:1.5;stroke:%23000'/%3E %3Cpath d='M36.937 229.285L28.228 237.994 38.329 243.826 61.822 237.532 57.635 224.228 36.937 229.285z' style='fill:%23c00;stroke-width:1.086;stroke:%23000'/%3E %3Cpath d='M267.406 229.285L276.116 237.994 266.014 243.826 242.521 237.532 246.708 224.228 267.406 229.285z' style='fill:%23c00;stroke-width:1.086;stroke:%23000'/%3E %3Cpath d='M16.043 233.111A22.995 8.556 0 1 1-29.947 233.111 22.995 8.556 0 1 1 16.043 233.111z' transform='matrix(0.678154,-6.882792e-2,-2.382547e-2,0.957698,108.8665,-0.830297)' style='fill:%233e8225;stroke-width:1.5;stroke:%23000'/%3E %3Cg fill='%23FFF' store-width='0.7' stroke='%23000'%3E %3Cg transform='translate(1.069518,-3.475935)'%3E %3Cpath id='c2' d='M126.203 214.704A4.278 4.278 0 1 1 117.647 214.704 4.278 4.278 0 1 1 126.203 214.704z'/%3E %3C/g%3E %3Cuse xlink:href='%23c2' transform='translate(2.406416,10.16042)'/%3E %3Cuse xlink:href='%23c2' transform='translate(-52.40642,6.149728)'/%3E %3Cuse xlink:href='%23c2' transform='translate(-47.05882,18.98396)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,303.0748,-3.475943)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,301.7379,10.16041)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,356.5507,6.14972)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,351.2031,18.98395)'/%3E %3C/g%3E %3C/g%3E %3Cg transform='translate(0,-2.600445e-4)'%3E %3Cpath d='M238.538 280.603C241.805 280.036 261.515 275.35 265.665 272.843 262.987 268.015 258.181 264.238 261.921 265.825 263.935 266.68 265.528 260.026 259.682 254.94 242.709 260.507 202.002 270.679 150.853 270.679 98.509 270.679 57.291 259.972 40.318 254.406 34.472 259.492 36.293 265.27 35.94 267.429 35.937 267.446 35.943 270.154 37.009 272.308 42.763 278.559 61.403 281.64 64.671 282.208 80.023 284.874 95.376 288.905 150.819 288.905 202.108 288.905 223.185 283.27 238.538 280.603z' style='fill:%23fff;stroke-width:1.714;stroke:%23000'/%3E %3Cg transform='matrix(1.085779,0,0,1.085779,-81.34112,-69.11104)'%3E %3Cpath d='M132.906 289.655C129.897 290.178 110.759 296.956 106.938 299.265 106.941 299.279 106.935 299.31 106.938 299.326 107.263 301.314 103.616 310.577 109 315.261 124.632 310.134 168.525 294.855 215.634 294.855 263.843 294.855 303.774 310.134 319.406 315.261 324.79 310.577 321.143 301.314 321.469 299.326 321.472 299.31 321.465 299.279 321.469 299.265 317.647 296.956 298.509 290.178 295.5 289.655 281.36 287.2 266.728 278.069 215.665 278.069 168.428 278.069 147.046 287.2 132.906 289.655z' style='fill:%23fff;stroke-width:1.578;stroke:%23000'/%3E %3Cg transform='matrix(1.384389,-0.143242,0.15642,1.267764,-86.62648,-64.7552)'%3E %3Cg id='t1' fill='%23000' store-width='1.6' stroke='%23000'%3E %3Cg transform='matrix(0.4996,0,0,0.4996,56.86367,150.9007)'%3E %3Cpath id='a1' d='M115.508 301.56A1.872 1.872 0 1 1 111.765 301.56 1.872 1.872 0 1 1 115.508 301.56z'/%3E %3C/g%3E %3Cuse xlink:href='%23a1' transform='matrix(0.4996,0,0,0.4996,55.52674,153.307)'/%3E %3Cuse xlink:href='%23a1' transform='matrix(0.4996,0,0,0.4996,57.3984,154.9114)'/%3E %3Cpath stroke-width='1' d='M113.518 303.669L122.044 300.503 117.859 302.895 120.545 302.812 118.053 303.98 122.054 304.255 113.518 303.669z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,-0.143242,0.15642,1.267764,-45.03159,-76.65847)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.378425,0.192343,-0.151629,1.268346,100.1696,-120.8592)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,0.143242,0.15642,-1.267764,54.4337,659.4577)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,0.143242,0.15642,-1.267764,96.41226,670.4203)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' version='1.0' id='Layer_1' x='0px' y='0px' width='411px' height='274px' viewBox='79.461 52.641 411 274' enable-background='new 79.461 52.641 411 274' xml:space='preserve' inkscape:version='0.48.1 ' sodipodi:docname='Flag of Iraq.svg'%3E%3Cmetadata id='metadata34'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cdefs id='defs32' /%3E%3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1440' inkscape:window-height='838' id='namedview30' showgrid='false' inkscape:zoom='0.95255474' inkscape:cx='205.5' inkscape:cy='137' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:current-layer='Layer_1' /%3E %3Crect id='rect7_1_' x='79.501' y='139.356' fill='%23FFFFFF' width='410.998' height='101.287' /%3E %3Crect id='rect3' x='79.5' y='53' fill='%23CF2029' width='410.998' height='91.288' style='fill:%23ce1126;fill-opacity:1' /%3E %3Crect id='rect7' x='79.5' y='235.713' fill='%23020202' width='410.998' height='91.287' style='fill:%23000000;fill-opacity:1' /%3E %3Cg id='g6' style='fill:%23007a3d;fill-opacity:1'%3E %3Cg id='g8' style='fill:%23007a3d;fill-opacity:1'%3E %3Cg id='g10' style='fill:%23007a3d;fill-opacity:1'%3E %3Cpath fill='%23119B4A' d='M325.525,173.177c-0.558-0.294-1.186-0.767-1.395-1.053c-0.314-0.439-0.131-0.456,1.163-0.105 c2.319,0.629,3.815,0.384,5.298-0.872l1.308-1.103l1.54,0.784c0.848,0.428,1.748,0.724,2.008,0.656 c0.667-0.176,2.05-1.95,2.005-2.564c-0.054-0.759,0.587-0.569,0.896,0.263c0.615,1.631-0.281,3.503-1.865,3.918 c-0.774,0.202-1.488,0.127-2.659-0.28c-1.439-0.502-1.684-0.495-2.406,0.057C329.801,174.118,327.549,174.234,325.525,173.177z' id='path12' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M331.258,167.935c-0.563-0.716-1.239-3.423-1.02-4.088c0.192-0.575,0.39-0.69,0.914-0.526 c0.918,0.287,1.13,0.92,0.993,3.063C332.038,168.132,331.779,168.591,331.258,167.935z' id='path14' style='fill:%23007a3d;fill-opacity:1' /%3E %3C/g%3E %3Cpath fill='%23119B4A' d='M263.743,165.991c-0.185,1.31,2.325,4.567,3.458,5.157c-0.77,0.345-1.728,0.189-2.434,0.577 c-3.948,3.948-18.367,18.005-21,21.366c7.799,0.154,16.449-0.106,23.761-0.44c-0.007-5.299,5.018-5.573,8.381-7.503 c1.73,2.725,6.075,2.516,6.618,6.618c0,4.91,0.009,12.306,0.009,17.646c-22.059,0-44.566,0-66.625,0 c-1.172,5.176-5.844,9.125-12.354,7.5c2.014-2.103,5.406-2.827,6.619-5.734c1.025-6.365-2.045-10.296-4.031-13.907 c3.284-1.195,3.782-1.493,7.121-3.737c-2.343,7.12,6.091,6.338,12.353,6.175c0.211-2.417,0.089-5.271-1.766-5.624 c2.396-0.87,2.794-1.168,6.619-4.412c0,2.942,0,6.652,0,9.592c14.886,0,30.943-0.111,46.139-0.111 c0-3.002,0.795-7.824-1.581-7.824c-2.269,0-0.107,6.173-1.87,6.173s-23.719,0-35.63,0c0-1.328-0.034-4.104-0.034-6.104 c1.51-1.511,1.331-1.38,11.648-11.698C250.172,178.672,257.41,172.134,263.743,165.991z' id='path16' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M352.803,165.737c2.488,1.338,4.457,3.191,7.502,3.971c-0.353,1.26-1.475,1.759-1.769,3.087 c0,8.97,0,17.941,0,26.91c3.402,0.75,4.118-1.178,5.737-2.205c0.442,4.307,3.185,8.53,3.088,11.91c-4.851,0-9.706,0-14.559,0 C352.803,194.855,352.803,180.296,352.803,165.737z' id='path18' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M333.391,180.149c0,0,5.296-4.471,5.296-4.643c0,7.646,0,15.837,0,23.485l3.814-0.006 c0-8.948-0.118-18.023-0.118-26.338c1.548-1.549,4.58-3.792,5.338-5.359c0,15.987,0,29.519,0,42.059 c-10.746,0-30.793,0.013-33.443,0.013c-0.493-8.73-0.577-17.771,9.599-15.827c0-1.488,0-2.369,0-3.562 c-0.31-0.609-0.868,0.147-0.998-0.645c1.616-1.617,2.163-2.029,6.538-5.851c0,4.612,0.081,15.499,0.081,15.499 c1.07,0,3.153,0.004,3.857,0.004C333.356,198.979,333.391,180.75,333.391,180.149z M320.837,198.751 c0.716,1.075,3.155,1.056,3.04-0.755C323.466,196.503,320.262,197.072,320.837,198.751z' id='path20' style='fill:%23007a3d;fill-opacity:1' /%3E %3Ccircle fill='%23119B4A' cx='224.026' cy='214.369' r='2.042' id='circle22' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M341.175,199.295' id='path24' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M329.451,199.295' id='path26' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M287.048,165.779c2.488,1.339,4.457,3.191,7.502,3.971c-0.353,1.26-1.476,1.759-1.768,3.087 c0,8.97,0,17.94,0,26.911c3.401,0.749,4.117-1.179,5.736-2.206c0.441,4.307,3.185,8.529,3.088,11.91c-4.851,0-9.706,0-14.559,0 C287.048,194.897,287.048,180.338,287.048,165.779z' id='path28' style='fill:%23007a3d;fill-opacity:1' /%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='630' height='360'%3E %3Crect width='630' height='360' fill='%23da0000'/%3E %3Crect width='630' height='240' fill='%23fff'/%3E %3Crect width='630' height='120' fill='%23239f40'/%3E %3Cg transform='translate(8.4,100.4)'%3E %3Cg id='tb4'%3E %3Cg id='tb1' fill='none' stroke='%23fff' stroke-width='2'%3E %3Cpath id='tbp1' d='M0,1H26M1,10V5H9V9H17V5H12M4,9H6M26,9H21V5H29M29,0V9H37V0M33,0V9' transform='scale(1.4)'/%3E %3Cpath id='tbp2' d='M0,7H9M10,7H19' transform='scale(2.8)'/%3E %3Cuse xlink:href='%23tbp2' y='120'/%3E %3Cuse xlink:href='%23tbp1' y='145.2'/%3E %3C/g%3E %3Cg id='tb3'%3E %3Cuse xlink:href='%23tb1' x='56'/%3E %3Cuse xlink:href='%23tb1' x='112'/%3E %3Cuse xlink:href='%23tb1' x='168'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23tb3' x='168'/%3E %3Cuse xlink:href='%23tb4' x='392'/%3E %3C/g%3E %3Cg fill='%23da0000' transform='matrix(45,0,0,45,315,180)'%3E %3Cg id='emblem_half'%3E %3Cpath d='M-0.54815,0.83638A0.912046,0.912046 0 0,0 0.328544,-0.722384A1,1 0 0,1 -0.54815,0.83638'/%3E %3Cpath d='M0.618339,0.661409A0.763932,0.763932 0 0,0 0.421644,-0.741049A1,1 0 0,1 0.618339,0.661409'/%3E %3Cpath d='M0,1 -0.05,0 0,-0.787278A0.309995,0.309995 0 0,0 0.118034,-0.688191V-0.100406L0.077809,0.892905z'/%3E %3Cpath d='M-0.02,-0.85 0,-0.831217A0.14431,0.14431 0 0,0 0.252075,-0.967708A0.136408,0.136408 0 0,1 0,-0.924634'/%3E %3C/g%3E %3Cuse xlink:href='%23emblem_half' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='2500' height='1800'%3E %3Cpath d='M0,0H2500V1800H0' fill='%23003897'/%3E %3Cpath d='M700,0h400V1800h-400M0,700H2500v400H0' fill='%23fff'/%3E %3Cpath d='M800,0h200V1800h-200M0,800H2500v200H0' fill='%23d72828'/%3E %3C/svg%3E"

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1500' height='1000' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' fill='%23009246'/%3E %3Crect width='1' height='2' x='1' fill='%23fff'/%3E %3Crect width='1' height='2' x='2' fill='%23ce2b37'/%3E %3C/svg%3E"

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='600' viewBox='0 0 30 18'%3E %3Crect width='30' height='18' fill='%23fff'/%3E %3Cpath d='M0,0 30,18M0,18 30,0' stroke='%23df112d' stroke-width='2'/%3E %3Cg stroke='%23000' stroke-width='0.0153'%3E %3Cpath fill='%23e8112d' d='M16.5698,2.69297c0.3855,1.56106,0.1741,3.48906-1.5673,4.55878-1.7415-1.06972-1.9529-2.99772-1.5673-4.55878,0.410478-0.373168,2.2762-0.60328,3.13453,0z'/%3E %3Cpath fill='%23f9dd16' d='m15,2.37955c0.638439,0,1.23302,0.16898,1.58351,0.388048,0.06878-0.538251,0.312867-1.07649,0.600812-1.4833-0.300406-0.00627-0.435033,0.15333-0.438087,0.319183-0.07513-0.212788-0.369307-0.200279-0.460077-0.08449,0.328627,0.222183,0.07513,0.616473-0.222097,0.535123-0.139636-0.038201-0.213424-0.135568-0.239567-0.276926a0.161537,0.161537 0 1,0 -0.068908,-0.010714c-0.09395,0.153343-0.262412,0.199375-0.383112,0.165584-0.156495-0.043809-0.22222-0.184629-0.22222-0.3098,0-0.32545,0.312867-0.375514,0.406812-0.319183-0.0061-0.21905-0.3504-0.394295-0.4568-0.21279,0.1189-0.212791,0.1127-0.513211-0.1002-0.713486-0.2127,0.200275-0.219,0.500695-0.1,0.713486-0.106406-0.181501-0.45067-0.00625-0.4569,0.2128,0.09382-0.056331,0.406812-0.00627,0.406812,0.319183,0,0.125171-0.06572,0.265992-0.22222,0.3098-0.120699,0.033791-0.289166-0.012241-0.383234-0.165584a0.161537,0.161537 0 1,0 -0.068908,0.010714c-0.0262,0.14136-0.1001,0.23872-0.2396,0.27692-0.2972,0.08135-0.5507-0.31294-0.2222-0.53512-0.0907-0.11579-0.3848-0.1283-0.46,0.08449-0.0032-0.16585-0.1377-0.32545-0.4381-0.31918,0.287823,0.406812,0.53191,0.945051,0.600812,1.4833,0.350494-0.219068,0.945075-0.388048,1.58339-0.388048z'/%3E %3Cg id='leopard'%3E %3Cg fill='%23f9dd16'%3E %3Cpath d='m16.3243,3.91058c-0.03848,0.00917-0.03848,0.058762-0.05864,0.058762,0.100054-0.00276,0.148676-0.030297,0.178973-0.080801-0.02199,0.020194-0.0028,0.058762-0.01014,0.067937,0.07342-0.025704,0.108361-0.088131,0.08271-0.130363,0.01649,0.023859,0.06426,0.036723,0.07892,0.038556-0.05143-0.0404-0.01466-0.132208-0.09737-0.179938,0.02761-0.00184,0.08087,0.029369,0.09553,0.066104-0.01283-0.082633-0.02578-0.135885-0.0937-0.181783,0.0073,0.00826,0.04593,0.015601,0.06243,0-0.04398-0.027548-0.05693-0.073446-0.05314-0.102827,0.0051-0.041109-0.02211-0.049587-0.07354-0.036723-0.0463,0.011569-0.15234,0.018362-0.214767,0.018362-0.128519,0-0.240545,0-0.347073-0.073446,0.159793,0.066092,0.363565-0.073446,0.363565-0.189125,0-0.128543-0.15796-0.233202-0.477424-0.163421-0.319464,0.069769-0.708684,0.040388-0.708684-0.066104,0-0.106504,0.279027-0.121189,0.422327-0.09915,0.143179,0.022027,0.24592,0.036723,0.514074-0.058762-0.06609,0.025704-0.279149,0.033046-0.447982-0.014684-0.168956-0.047742-0.583953-0.047742-0.587618,0.176273-0.0037,0.224003,0.441874,0.203602,0.82633,0.146892,0.22393-0.033058,0.341454-0.011019,0.341454,0.062427,0,0.069769-0.205606,0.09915-0.363566,0.080788-0.157838-0.018349-0.319464-0.014684-0.506744,0.0404-0.156372,0.045983-0.264367,0-0.436987,0.029381-0.08368,0.01422-0.286479,0-0.386533-0.165266-0.06157,0.044078-0.24702,0.136337-0.278172,0.226312-0.0441,0.082621-0.01466,0.164802,0.04398,0.24559,0.07403,0.101679-0.03665,0.086298-0.115569,0.089975-0.108239,0.00503-0.253128-0.011496-0.328749-0.097317-0.06695-0.076048-0.156128-0.136997-0.22735-0.08063-0.03665,0.029014-0.0015,0.067204,0.02749,0.056514,0.02871-0.010567,0.06267,0.01069,0.09333,0.024116-0.04899-0.021061-0.102864-0.00472-0.123876,0.014061-0.02895,0.02596,0.0062,0.075547,0.04129,0.058029,0.02749-0.013744,0.08393-0.022906,0.120577,0.010689-0.0397-0.00764-0.081-0.00602-0.100786,0.015271-0.01979,0.021294-0.0045,0.052299,0.03824,0.050393,0.06866-0.00305,0.08625,0.045055,0.155029,0.035172-0.04227,0.00551-0.06621,0.027536-0.07721,0.044065,0.06426-0.029381,0.135238,0.049819,0.218555,0.031213-0.0325,0.013377-0.08491,0.045324-0.08442,0.069781,0.04948-0.056929,0.381891,0.044065,0.389221-0.080788,0.0092,0.025704,0.0073,0.064259-0.01832,0.097317,0.04251-0.025716,0.17995-0.03489,0.222097-0.134053,0.0037,0.029381-0.0018,0.067949-0.02749,0.077123,0.0441,0.014416,0.102131-0.018423,0.161503-0.106492,0.02358-0.034939,0.0292-0.058163,0.02517-0.084429,0.05888,0.00222,0.101519-0.012559,0.147454-0.051456,0.04777-0.040388,0.0992,0.033058,0.17995-0.018362,0.08087-0.051407,0.150631-0.00734,0.19461-0.033046,0.0441-0.025704,0.104697,0.00917,0.152463-0.020194,0.04777-0.029381,0.1218,0.014379,0.200841-0.048048,0.124365,0.045556,0.269498,0.129972,0.625489,0.064565,0.204017-0.037493,0.268032,0.031213,0.268032,0.124866,0,0.064259-0.03763,0.069854-0.06609,0.071614-0.113493,0.00698-0.162237-0.042489-0.207072-0.026632-0.03005,0.010702-0.04838,0.059568-0.0049,0.076366-0.03592,0.018325-0.03128,0.05269-0.01295,0.065285,0.01832,0.012595,0.0656,0.00115,0.09773-0.013744-0.04129,0.018704-0.08405,0.052299-0.05962,0.087422,0.01478,0.021318,0.05216,0.039386,0.0871-0.0061,0.03506-0.045824,0.0992-0.084001,0.140002-0.077942z'/%3E %3Cpath d='m14.0632,2.94108c-0.102864-0.04222-0.137559-0.043381-0.113859,0.0404,0.01014,0.035807,0.03482,0.086298,0.05962,0.109253,0.000978-0.034878,0.0138-0.131279,0.05424-0.149653z'/%3E %3Cpath d='m14.3845,2.94108c0.102864-0.04222,0.137559-0.043381,0.113859,0.0404-0.01014,0.035807-0.03494,0.086298-0.05974,0.109253-0.000855-0.034878-0.01368-0.131279-0.05412-0.149653z'/%3E %3Cpath d='m14.2243,2.88464c0.19461,0,0.218921,0.091343,0.217944,0.205178-0.000855,0.123021-0.06695,0.080788-0.104574,0.2387-0.01466,0.061743-0.06389,0.065188-0.11337,0.065188-0.0496,0-0.09871-0.00345-0.113492-0.065188-0.0374-0.15792-0.1036-0.11569-0.1045-0.23871-0.0009-0.11383,0.0234-0.20517,0.2181-0.20517z'/%3E %3Cpath d='m13.7226,3.33585c-0.0496-0.029381-0.08161-0.00905-0.101765-0.00353,0.06426,0.016517,0.06682,0.099015,0.213791,0.137571-0.03311-0.00917-0.05143,0.00919-0.08271-0.00734,0.06059,0.047742,0.128519,0.103022,0.271819,0.10466,0.0799,0.0009162,0.02468,0.042233-0.02761,0.018361,0.05424,0.056001,0.161625,0.010103,0.22955,0.112014,0.01283-0.078956-0.126686-0.203822-0.06243-0.293784-0.198153-0.00844-0.214401-0.118269-0.328626-0.205654-0.09297-0.071052-0.101276-0.143276-0.142324-0.278502-0.01869-0.06123-0.0904-0.099406-0.130106-0.084905-0.03469,0.012681-0.0474,0.04277-0.01759,0.065285,0.02981,0.022527,0.06792,0.025582,0.07611,0.082657-0.03873-0.046386-0.09675-0.063184-0.124609-0.03417-0.01698,0.017665-0.01014,0.058884,0.02639,0.062622,0.0595,0.00611,0.01674,0.064137,0.08442,0.120908-0.05998-0.06746-0.111903-0.073568-0.144033-0.036919-0.01918,0.021953,0,0.061083,0.04129,0.056893,0.05974-0.00608,0.129007,0.145463,0.218433,0.183835z'/%3E %3Cpath d='m15.32,3.90323c-0.03127,0.00551-0.02199,0.056929-0.06426,0.060606,0.101032,0,0.152341-0.023883,0.200108-0.062439-0.02199,0.012852-0.03115,0.04591-0.03299,0.064259,0.05326-0.045898,0.179951-0.049563,0.246042-0.036711,0.06609,0.012852,0.07709-0.018362,0.100909-0.060594,0.02395-0.042233-0.0092-0.066104-0.04215-0.09915-0.03311-0.033058-0.04044-0.078956-0.03311-0.156079-0.176285-0.235023-0.492084-0.121188-0.495749-0.018362,0.113859,0.132196,0.128519,0.117511,0.224052,0.135873,0.09541,0.018361,0.153929,0.018313,0.08991,0.071614-0.02199,0.018362-0.113858,0.00974-0.185447,0.012852-0.16016,0.00696-0.233459-0.110633-0.280738-0.049551-0.03897,0.050235,0.0012,0.07242,0.08063,0.069745-0.05498,0.0003909-0.127908-0.00258-0.115447,0.048622,0.02101,0.086274,0.103475-0.01604,0.135604,0.019461-0.02749-0.00649-0.07024,0.010311-0.07183,0.036271-0.0015,0.025972,0.06108,0.059556,0.129862,0.00496,0.03763-0.029931,0.08564-0.041133,0.114592-0.041377z'/%3E %3Cpath d='m15.4566,3.54488c-0.0573-0.020964-0.109827-0.033779-0.177018-0.019901'/%3E %3Cpath d='m14.5929,3.51764c-0.04716,0.101324-0.01857,0.151339-0.0116,0.198348'/%3E %3Cpath d='m14.0908,3.03734c0.03237,0.016187,0.05058-0.029564,0.0981,0.019009-0.01307-0.014171-0.02932,0.037664-0.06573,0.00326'/%3E %3Cpath d='m14.355,3.03734c-0.03237,0.016187-0.05058-0.029564-0.0981,0.019009,0.01307-0.014171,0.02932,0.037664,0.06572,0.00326'/%3E %3Cpath d='m14.2569,3.05635c-0.01112,0.00917-0.01222-0.00732-0.0038,0.036014,0.01564,0.079567,0.03408,0.116791-0.0303,0.116791-0.06573,0-0.04581-0.037224-0.0303-0.116791,0.0086-0.043332,0.0075-0.02684-0.0037-0.036014'/%3E %3C/g%3E %3Cg fill='%23ff0016' stroke-width='0.00765'%3E %3Cpath d='m14.2238,3.36157c0.05229,0,0.08258-0.0009163,0.0744-0.074362-0.0034-0.029479,0.03579-0.041219,0.02199-0.089059,0.01466,0.058749-0.09639,0.053142-0.09639,0.02651,0,0.026632-0.111049,0.032239-0.09639-0.02651-0.0138,0.04784,0.02529,0.05958,0.02199,0.089059-0.0082,0.073446,0.02211,0.074362,0.0744,0.074362z'/%3E %3Cpath d='M14.1768,3.21299,14.0512,3.17796'/%3E %3Cpath d='m14.1768,3.21952-0.140246-0.00117'/%3E %3Cpath d='m14.1781,3.2267-0.1196,0.032044'/%3E %3Cpath d='m14.2709,3.21299,0.125587-0.035037'/%3E %3Cpath d='m14.2709,3.21952,0.140246-0.00117'/%3E %3Cpath d='m14.2695,3.2267,0.119601,0.032044'/%3E %3C/g%3E %3Cg fill='%230051ba' stroke-width='0.00159'%3E %3Cpath d='m13.5733,2.83723c-0.03653-0.045482-0.12803-0.00707-0.129862,0.049355,0.03091-0.036576,0.08136,0.016114,0.108849,0.00503,0.01906-0.00767,0.0358-0.03588,0.02101-0.054388z'/%3E %3Cpath d='m13.5259,2.9449c-0.03653-0.045482-0.127908-0.00707-0.129741,0.049355,0.03079-0.036576,0.08124,0.016114,0.10885,0.00503,0.01906-0.00766,0.0358-0.03588,0.02089-0.054388z'/%3E %3Cpath d='m13.5021,3.08953c-0.04141-0.041084-0.127908,0.00737-0.123387,0.063636,0.02663-0.039814,0.08258,0.00688,0.108727-0.00724,0.01808-0.00976,0.03152-0.039667,0.01466-0.056392z'/%3E %3Cpath d='m13.5457,3.53777c-0.04593-0.036039-0.126197,0.022026-0.115324,0.077416,0.02187-0.042599,0.08283-0.00268,0.107139-0.019693,0.01686-0.011789,0.02688-0.043039,0.0082-0.057723z'/%3E %3Cpath d='m13.5434,3.63587c-0.05473-0.020182-0.11337,0.059788-0.08588,0.109131,0.0076-0.047254,0.07794-0.028025,0.0959-0.051725,0.01246-0.016395,0.01222-0.049184-0.01002-0.057406z'/%3E %3Cpath d='m13.6136,3.70918c-0.05473-0.020194-0.11337,0.059776-0.08601,0.109131,0.0077-0.047266,0.07806-0.028037,0.09602-0.051737,0.01246-0.016395,0.01222-0.049184-0.01002-0.057393z'/%3E %3Cpath d='m15.0476,3.8512c-0.05473-0.020182-0.11337,0.059788-0.08588,0.109131,0.0077-0.047254,0.07794-0.028025,0.0959-0.051725,0.01246-0.016395,0.01222-0.049184-0.01002-0.057406z'/%3E %3Cpath d='m15.1215,3.91773c-0.05669-0.013829-0.105796,0.072298-0.07293,0.118196,0.0022-0.047828,0.07428-0.036723,0.08943-0.062317,0.01051-0.017702,0.0066-0.050259-0.01649-0.055879z'/%3E %3Cpath d='m15.0695,3.75701c-0.05058-0.029198-0.121921,0.039643-0.10323,0.092932,0.01564-0.045262,0.08161-0.014355,0.103353-0.034646,0.01503-0.014049,0.0204-0.046399-0.000123-0.058285z'/%3E %3Cpath d='m16.0897,3.87191c-0.05669-0.013817-0.105796,0.072298-0.07293,0.118208,0.0023-0.047828,0.0744-0.036723,0.08943-0.062317,0.01051-0.017702,0.0066-0.050259-0.01649-0.055891z'/%3E %3Cpath d='m16.0914,3.78185c-0.05143-0.027438-0.120333,0.043821-0.09993,0.096438,0.01405-0.045776,0.08112-0.017152,0.102131-0.038189,0.01454-0.014562,0.01881-0.04707-0.0022-0.058249z'/%3E %3Cpath d='m16.1312,3.9524c-0.05717-0.011337-0.102497,0.076855-0.06768,0.121274,0.000245-0.047877,0.07269-0.039948,0.08662-0.066165,0.0098-0.018154,0.0044-0.050503-0.01894-0.055109z'/%3E %3Cpath d='m14.228,3.31754c0.03592,0,0.05045,0.010482,0.05045,0.075364,0,0.137461-0.0016,0.196565-0.04581,0.196565-0.04435,0-0.04129-0.05616-0.04129-0.157081,0-0.052653,0-0.07898-0.01063-0.074594,0-0.034353,0.01527-0.040254,0.04728-0.040254z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23leopard' transform='matrix(0.9,0,0,0.9,1.45342,1.67136)'/%3E %3Cuse xlink:href='%23leopard' transform='matrix(0.67,0,0,0.75,4.90869,3.35378)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='300' viewBox='0 0 12 6'%3E %3Cpath fill='%23009B3A' d='m0,0h12v6H0'/%3E %3Cpath stroke='%23FED100' d='m-6,9 24-12v12L-6-3'/%3E %3C/svg%3E"

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='840' height='420'%3E %3Crect width='840' height='420' fill='%23007a3d'/%3E %3Crect width='840' height='280' fill='%23fff'/%3E %3Crect width='840' height='140' fill='%23000'/%3E %3Cpath d='M0,0V420L420,210z' fill='%23ce1126'/%3E %3Cpath d='M129.787138,180 136.295394,196.485467 153.242082,191.295306 144.411056,206.662186 159.034975,216.675628 141.51461,219.352347 142.80365,237.029066 129.787138,225 116.770625,237.029066 118.059665,219.352347 100.5393,216.675628 115.163219,206.662186 106.332193,191.295306 123.278882,196.485467 129.787138,180z' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23fff' height='600' width='900'/%3E %3Ccircle fill='%23bc002d' cx='450' cy='300' r='180'/%3E %3C/svg%3E"

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg%3E %3Csvg width='900' height='600' viewBox='-120 -80 240 160' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cdefs%3E %3Cpath id='spearshape' d='M -1,55.4256258422040733928782829281879157421699 h 2 V -38 C 3,-40 3,-43 3,-46 C 3,-48 3,-56 0,-64.6632301492380856250246634162192350325315 C -3,-56 -3,-48 -3,-46 C -3,-43 -3,-40 -1,-38 z' stroke-miterlimit='10' transform='rotate(30)'/%3E%3C!-- 32*sqrt(3), -112/sqrt(3)--%3E %3C/defs%3E %3Crect x='-120' y='-80' width='240' height='160' fill='%23fff'/%3E %3Crect x='-120' y='-80' width='240' height='48'/%3E %3Crect x='-120' y='32' width='240' height='48' fill='%23060'/%3E %3Cg id='spear'%3E %3Cuse xlink:href='%23spearshape' stroke='%23000'/%3E %3Cuse xlink:href='%23spearshape' fill='%23fff'/%3E %3C/g%3E %3Cuse xlink:href='%23spear' transform='scale(-1,1)'/%3E %3Cpath fill='%23b00' d='M -120,-24 V 24 H -19 c 3,8 13,24 19,24 s 16,-16 19,-24 H 120 V -24 H 19 c -3,-8 -13,-24 -19,-24 s -16,16 -19,24 z'/%3E %3Cpath id='deco_r' d='M 19,24 c 3,-8 5,-16 5,-24 s -2,-16 -5,-24 c -3,8 -5,16 -5,24 s 2,16 5,24'/%3E %3Cuse xlink:href='%23deco_r' transform='scale(-1,1)'/%3E %3Cg fill='%23fff'%3E %3Cellipse rx='4' ry='6'/%3E %3Cpath id='deco_br' d='M 1,5.85 c 0,0 4,8 4,21 s -4,21 -4,21 z'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(-1)'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(-1,1)'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(1,-1)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='450' viewBox='0 0 250 150'%3E %3CclipPath id='c'%3E %3Ccircle r='25'/%3E %3C/clipPath%3E %3Crect width='250' height='150' fill='%23e8112d'/%3E %3Cg transform='translate(125,75)'%3E %3Cg id='r20' transform='scale(0.25)'%3E %3Cg id='r4'%3E %3Cpath id='r1' d='m-8.4,108c8.4,22 -9.6,56 8.4,72c-6,-24 14-50 8.4,-72s-25.2,-22 -16.8,0z' fill='%23ffef00'/%3E %3Cuse xlink:href='%23r1' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(18)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(36)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(54)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23r20' transform='rotate(9)'/%3E %3Ccircle r='27' fill='%23e8112d'/%3E %3Ccircle cy='-1.5' r='22.5' fill='%23ffef00'/%3E %3Cg id='x' fill='%23e8112d' clip-path='url(%23c)'%3E %3Cpath d='M-23.055236,18a37.755236,37.755236 0 1,1 75.510472,0H52.760449a36.260449,36.260449 0 1,0 -72.520898,0z'/%3E %3Cpath d='M-17.601203,18a35.301203,35.301203 0 1,1 70.602406,0H53.424578a33.924578,33.924578 0 1,0 -67.849156,0z'/%3E %3Cpath d='M20.7,-15.052356a33.052356,33.052356 0 1,0 0,66.104712L22.5,49.819805a31.819805,31.819805 0 1,1 0,-63.63961z'/%3E %3C/g%3E %3Cuse xlink:href='%23x' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='625' height='400'%3E %3Crect width='625' height='400' fill='%23032ea1'/%3E %3Crect width='625' height='200' y='100' fill='%23e00025'/%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='0.96' transform='translate(117.14286,-434.9336)'%3E %3Cg stroke-linejoin='bevel'%3E %3Cpath d='m139.02,623.46,113.8,0,0,43.788-113.8,0z'/%3E %3Crect width='3.5864' height='16.495' x='246.95' y='647.64'/%3E %3Crect width='113.8' height='5.0903' x='139.02' y='639.49'/%3E %3Crect width='113.8' height='4.489' x='139.02' y='632.59'/%3E %3Crect stroke-width='0.94545' width='113.8' height='4.354' x='139.02' y='625.7'/%3E %3Crect width='3.5864' height='16.495' x='168.98' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='217.97' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='139.92' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='146.95' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='154.45' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='161.95' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='224.77' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='232.27' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='239.77' y='647.64'/%3E %3Cpath stroke-linejoin='miter' d='m94.509,669.55c1.7604-0.89672,3.7684-2.9836,4.425-5.319h193.07c0.65665,2.3354,2.6647,4.4222,4.425,5.319z'/%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath d='m193,556.8s-0.14437-4.1125,2.2507-4.1572c2.3951,0.0447,2.2507,4.1572,2.2507,4.1572z'/%3E %3Cpath d='m180.51,611.34,0-5.5357c-0.0789-2.768-2.7591-2.9681-2.838-4.9862,0,0-0.34606-3.0266,0.45159-4.4082,1.0845,4.0474,3.0561,3.3039,3.0561,1.6397,0-1.4526-1.117-2.8031-3.408-6.3302-0.73206-1.127-0.27901-4.6597,0.74692-5.9224,0.39808,3.0709,0.85311,4.5398,2.1717,4.5398,0.80428,0,1.4612-0.52417,1.4612-2.0621,0-1.9565-1.325-2.9445-1.9762-4.725-0.76004-2.0777-0.23675-4.1957,1.0259-5.3795,0.54129,3.0293,0.38028,4.2372,1.7255,4.2372,2.7133-0.8584,0.00063-4.7866-0.57911-5.7773-0.667-1.1553,0.89682-3.4598,0.89682-3.4598,0.86209,2.6898,1.1394,2.909,2.0699,2.6597,1.1738-0.31452,1.0224-2.056-0.40996-3.4633-0.90449-0.88866-0.80857-2.2116,0.16248-3.274,0.97489,1.9056,2.2229,1.7898,2.343,0.65821l-0.78373-4.3931h17.255l-0.85683,4.2488c-0.24526,1.2162,1.396,1.4801,2.4162-0.51392,0.97105,1.0624,1.067,2.3854,0.16248,3.274-1.4323,1.4073-1.5837,3.1488-0.40996,3.4633,0.93041,0.2493,1.2078,0.0302,2.0699-2.6597,0,0,1.403,1.5708,0.89682,3.4598-0.57974,0.99071-3.2924,4.9189-0.57911,5.7773,1.3453,0,1.1842-1.2079,1.7255-4.2372,1.2627,1.1838,1.786,3.3017,1.0259,5.3795-0.65127,1.7804-1.9762,2.7685-1.9762,4.725,0,1.538,0.65688,2.0621,1.4612,2.0621,1.3186,0,1.7736-1.4689,2.1717-4.5398,1.0259,1.2627,1.479,4.7953,0.74692,5.9224-2.291,3.527-3.408,4.8776-3.408,6.3302,0,1.6641,1.9716,2.4076,3.0561-1.6397,0.79765,1.3816,0.4516,4.4082,0.4516,4.4082-0.0789,2.018-2.7591,2.2182-2.838,4.9862v5.5357z'/%3E %3Cpath d='m187.73,565.32-0.39721-3.125,15.838,0-0.39721,3.125z'/%3E %3Cpath d='m188.79,562.13-0.34117-2.5686,13.604,0-0.34117,2.5686z'/%3E %3Cpath d='m190.95,559.47-0.22717-2.5686,9.0585,0-0.22718,2.5686z'/%3E %3Cpath d='m223.97,669.55c-2.0266-0.78125-4.9773-2.9188-4.9773-5.0695v-24.297l2.6385-3.3588-52.776,0.00008,2.5293,3.3588v24.297c0,2.1508-2.0264,4.2883-4.0529,5.0695z'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='178.24' y='647.64'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='208.56' y='647.64'/%3E %3Cpath d='m167.91,609.17,0,14.648,0,7.0117,0,5.9961,54.023,0,0-5.957,0.0783-21.699c-2.2097,0.8681-2.5976,2.8711-2.5976,2.8711v11.777h-48.75v-11.777s-0.5442-2.003-2.7539-2.8711z'/%3E %3Cpath d='m214.6,669.55c-1.7655-0.78125-5.6118-2.9188-5.6118-5.0695v-27.192c0.37751-1.518,2.436-2.414,3.761-3.3588h-35.823c1.7049,0.90271,3.6054,1.6522,4.2846,3.3588v27.192c0,2.1508-3.041,4.2883-4.8065,5.0695z'/%3E %3Cpath d='m219.41,634.22-0.00027-19.587-4.9104-0.00008,0-1.9085-38.839,0,0,1.9085-4.9109-0.00018,0.00017,19.587z'/%3E %3Cpath d='m206.86,669.55c-1.7299-0.78125-4.2489-2.9186-4.2489-5.0694v-23.215l1.4205-2.1088h-17.691l1.4205,2.109v23.215c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath stroke-width='0.981' d='m190.71,639.16,8.9655-0.00005,0,30.377-8.9655,0z'/%3E %3Cpath stroke-linejoin='bevel' d='m204.38,632.48c0.0215-2.0012,5.8375-2.091,8.8318-3.7949h-35.952c2.9943,1.7039,8.6755,1.8441,8.6755,3.7949l1.2166,3.8818,14.883,0.59776z'/%3E %3Cpath d='m211.41,611.34c0-4.8986,0.20532-6.7857,1.7103-6.7857l0.00001,15.58c-3.6912,1.3393-6.3254,6.0491-6.3254,6.0491l-23.211-0.00027s-2.6342-4.7096-6.3254-6.0488v-15.58c1.856,0,1.8682,1.9717,1.8682,6.7857z'/%3E %3Cpath d='m213.12,609.33c0-5.6184,4.8512-6.2503,4.8512-6.2503v5c-1.8465-0.0789-2.7368,1.578-2.7368,4.0444,0,2.4663,1.4868,2.5056,1.4868,2.5056v14.19h-3.6012z'/%3E %3Cpath d='m177.28,609.33c0-5.6184-4.8512-6.2503-4.8512-6.2503v5c1.8465-0.0789,2.7368,1.578,2.7368,4.0444,0,2.4663-1.4868,2.5056-1.4868,2.5056v14.19h3.6012z'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.8'%3E %3Cpath d='m186.84,570.62h17.128'/%3E %3Cpath d='m184.81,575.97h20.921'/%3E %3Cpath d='m182.78,582.46h24.904'/%3E %3Cpath d='m180.66,590.39h29.536'/%3E %3Cpath d='m179.98,599.43h30.426'/%3E %3Cpath stroke-width='0.96' d='m170.75,628.92h48.661'/%3E %3Crect stroke-width='0.96' width='18.036' height='6.6291' x='186.19' y='628.93'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m183.93,614.24c2.9903,3.59,2.7128,9.6801,2.6786,13.27h17.343c-0.0342-3.59-0.31172-9.68,2.6786-13.27z'/%3E %3Cpath d='m193.68,573.11-2.3764-1.2239,0-3.4974c0.97149,0.29214,2.062,0.41142,2.1686,1.9595,0.33824-2.2099,0.94822-2.1018,1.9064-2.963,0.95814,0.86127,1.5681,0.75315,1.9064,2.963,0.10661-1.5481,1.1971-1.6674,2.1686-1.9595v3.4974l-2.3764,1.2239z'/%3E %3Cpath d='m193.52,578.85-3.9464-2.7128,0-3.2231c1.3836,0.32035,2.9366,0.45115,3.0885,2.1488,0.48172-2.4232,1.3504-3.6754,2.715-4.6198,1.3646,0.94444,2.2332,2.1966,2.715,4.6198,0.15183-1.6976,1.7049-1.8284,3.0885-2.1488v3.2231l-3.9464,2.7128z'/%3E %3Cpath d='m193.24,587.8-4.5378-3.9854,0-4.7351c1.5909,0.47062,3.3767,0.66279,3.5513,3.1567,0.55391-3.56,1.5528-5.3995,3.1218-6.787,1.569,1.3875,2.5679,3.227,3.1218,6.787,0.17458-2.4939,1.9604-2.6861,3.5513-3.1567v4.7351l-4.5378,3.9854z'/%3E %3Cpath d='m201.61,593.09-4.1037,5.6759-4.6463,0-4.1037-5.6759z'/%3E %3Cpath d='m186.39,602.62c2.0526,1.1219,2.8106,3.3568,3.0299,7.5527h11.55c0.21927-4.1959,0.97728-6.4308,3.0298-7.5527z'/%3E %3Cpath stroke-linejoin='bevel' d='m204.17,593.09,0-5.7018c-1.9498,0.53675-3.2129,1.6912-3.7755,3.2577,0-1.8927-2.4906-6.2573-5.2071-8.4294-2.7242,2.4314-5.2575,6.3801-5.2066,8.4294-0.46332-1.4918-1.8258-2.7209-3.7755-3.2577v5.702z'/%3E %3Cpath stroke-linejoin='bevel' d='m205.04,602.62-0.00021-5.7022c-2.1373,0.53675-3.522,1.6912-4.1387,3.2577,0-1.8927-2.7299-6.2573-5.7077-8.4294-2.9863,2.4314-5.7635,6.3801-5.7077,8.4294-0.50788-1.4918-2.0014-2.7209-4.1387-3.2577v5.702z'/%3E %3Cpath stroke-linejoin='bevel' d='m207.44,614.32,0-6.5765c-2.6591,0.68624-4.3124,2.653-5.1491,3.7996,0-3.5614-4.0212-8.9902-7.1011-10.768-3.1599,1.8244-7.1011,7.435-7.1011,10.768-0.85883-1.1395-2.49-3.1134-5.1491-3.7996v6.5765z'/%3E %3Cpath stroke-linejoin='bevel' d='m206,628.92,0-6.7617c-2.3465,0.9193-3.0479,3.1802-3.7862,4.7163,0.28981-6.8584-3.8614-14.23-7.0239-16.1-3.1624,1.8699-7.3926,9.3996-7.0239,16.1-0.75787-1.5265-1.4397-3.797-3.7862-4.7163v6.7618z'/%3E %3Cpath d='m204.36,639.16,0-6.7618c-2.4581,0.58449-2.61,1.491-3.3916,3.0055,0.28981-4.0963-2.6114-8.7695-5.7739-10.639-3.1624,1.8699-6.0637,6.5431-5.7739,10.639-0.78168-1.5145-0.87771-2.421-3.3916-3.0055v6.7618z'/%3E %3C/g%3E %3C/g%3E %3Cg id='tower'%3E %3Cg%3E %3Cpath d='m98.935,664.23,0-20.44c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-17.993l3.7418,2.0232,4.2712,18.811v22.965z'/%3E %3Cpath d='m98.935,664.31,0-20.519c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-19.243c2.5118,0,3.7418,3.2732,3.7418,3.2732l4.2712,18.811v22.886z'/%3E %3Cpath d='m96.275,669.55c1.7299-0.78125,4.2487-2.9188,4.2487-5.0695v-25.547l-1.1852-2.1088h43.522l-1.6983,2.1088v25.547c0,2.1508,1.7297,4.2883,3.4596,5.0695z'/%3E %3Cpath d='m135.84,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-24.297l3.619-3.359-29.588,0.00008,3.6191,3.3589v24.297c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath d='m131.69,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-21.965l2.369-3.359h-18.798l2.3688,3.359v21.965c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath d='m115.92,639.16,8.9819-0.00004-0.00002,30.393-8.9818,0z'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='103.7' y='647.64'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='134.45' y='647.64'/%3E %3Cpath stroke-linejoin='bevel' d='m100.64,619.82h4.3202v16.909h-4.3202z'/%3E %3Cpath stroke-linejoin='bevel' d='m100.64,616.64h4.2946v3.1387h-4.2946z'/%3E %3Cpath stroke-width='1.0337' stroke-linejoin='bevel' d='m136.17,623.46h6.1594v13.054h-6.1594z'/%3E %3Cpath d='m104.89,636.6,0-28.941c1.2321,0,1.4222,4.2418,4.249,4.2418,1.4716,0,1.3152-1.757,0.4889-3.1882-0.73168-1.2673-1.6372-3.0176-0.40702-6.2783,0.84298,2.4949,3.1119,3.2866,2.6927,1.722-0.72042-2.6886-2.7945-3.1298-1.2383-7.3021,0.54049,3.4806,2.7732,3.3273,2.2309,1.3034-0.61083-2.2796-1.8732-3.2139-0.3157-6.4275,0.87209,3.6492,2.0519,3.4352,2.0519,1.1711,0-3.347-0.1285-6.9568,4.2027-8.296,0,0,0.25002-3.0682,1.8123-3.0682s1.8123,3.0682,1.8123,3.0682c4.3312,1.3393,4.2027,4.949,4.2027,8.296,0,2.264,1.1798,2.4781,2.0519-1.1711,1.5574,3.2136,0.29513,4.1479-0.3157,6.4275-0.54227,2.0238,1.6904,2.1772,2.2309-1.3034,1.5562,4.1722-0.5179,4.6134-1.2383,7.3021-0.41923,1.5646,1.8497,0.77297,2.6927-1.722,1.2302,3.2606,0.32466,5.011-0.40702,6.2783-0.82627,1.4311-0.98274,3.1882,0.4889,3.1882,2.8268,0,3.0168-4.2418,4.249-4.2418v28.941z'/%3E %3Cpath d='m98.124,614.74,0.000081,22.079,2.5111,0-0.00019-22.135c-0.90498-0.45686-1.7546-0.5274-2.511,0.0558z'/%3E %3Cpath d='m98.203,629.03c3.1124,1.5914,6.1949,3.4325,6.9754,7.7931h-6.9754z'/%3E %3Cpath d='m141.37,622.42,0.00006,14.407,2.0354,0,0-14.443c-0.63587-0.2981-1.5039-0.34413-2.0354,0.0364z'/%3E %3Cpath d='m143.41,628.92c-3.1124,1.5914-6.1949,3.4325-6.9754,7.7931h6.9754z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m122.83,595.27,1.8142-1.5247,0-1.9528c-0.6637,0.0645-1.0258,0.29275-1.516,0.93531-0.41694-1.2944-1.3337-2.3051-2.5624-2.9327-1.2287,0.6276-2.1454,1.5924-2.5624,2.8867-0.49022-0.64256-0.8523-0.8249-1.516-0.88935v1.9528l1.8142,1.5247z'/%3E %3Cpath d='m123.8,600.16,0.8432-1.8253,0-2.5384c-0.6637,0.0654-1.0258,0.29688-1.516,0.94855-0.41694-1.3127-1.3337-2.3377-2.5624-2.9742-1.2287,0.63649-2.1454,1.6149-2.5624,2.9276-0.49022-0.65166-0.8523-0.83658-1.516-0.90194v2.5384l0.8432,1.8253z'/%3E %3Cpath d='m123.93,606.79,2.6948-3.2865,0-3.2432c-0.98588,0.11068-1.5237,0.50272-2.2519,1.6061-0.61934-2.2227-1.9811-2.7084-3.8062-3.7861-1.8251,1.0777-3.1869,1.4845-3.8062,3.7072-0.72818-1.1034-1.266-1.4165-2.2519-1.5272v3.2432l2.6949,3.2865z'/%3E %3Cpath d='m124.72,613.3s3.1405-2.7397,3.3269-4.2436v-3.4672c-1.2171,0.14291-2.3682,0.45834-3.2672,1.8831-0.76458-2.8701-1.9586-3.6704-4.2117-5.0621-2.2532,1.3916-3.4471,2.192-4.2117,5.0621-0.89895-1.4248-2.0501-1.7402-3.2672-1.8831v3.4672c0.3965,1.5039,3.3269,4.2436,3.3269,4.2436z'/%3E %3Cpath d='m126.06,625.32s4.3013-4.7614,4.3999-6.6164v-5.4059c-1.6097,0.22281-3.1321,1.3298-4.321,3.5513-1.0112-4.4748-2.5903-7.5949-5.5702-9.7647-2.9799,2.1698-4.559,5.2898-5.5702,9.7647-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.30884,1.8551,4.3999,6.6164,4.3999,6.6164z'/%3E %3Cpath d='m126.06,632.43s3.6763-3.7418,4.3999-5.3664v-5.4059c-1.6097,0.22281-3.1321,1.3299-4.321,3.5513-1.0112-4.4748-2.5903-7.0369-5.5702-9.2067-2.9799,2.1698-4.559,4.7318-5.5702,9.2067-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.93384,1.6247,4.3999,5.3664,4.3999,5.3664z'/%3E %3Cpath d='m127.54,636.56c-1.0733-4.6678-1.9959-8.1303-7.163-11.641-5.167,3.5104-6.0894,6.9728-7.1627,11.641z'/%3E %3Cpath d='m130.2,639.16,0-6.7618c-2.3465,0.91931-4.467,2.2802-5.2487,3.7947-0.87376-3.754-2.5569-5.4078-4.6536-7.6786-2.0967,2.2708-3.5008,3.9245-4.3746,7.6786-0.78168-1.5145-2.9024-2.8754-5.2489-3.7946l0.00022,6.7618z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23tower' transform='matrix(-1,0,0,1,390.73979,0)'/%3E %3Cg%3E %3Cpath d='m72.694,694.25,245.33,0,0.00018,12.531-245.33,0.00001z'/%3E %3Cpath d='m66.228,706.76,258.26,0,0.00018,12.512-258.26,0.00002z'/%3E %3Cpath d='m85.576,675.51,219.56,0,0.00015,8.1093-219.56,0.00001z'/%3E %3Cpath d='m79.157,683.56,232.4,0,0.00017,10.622-232.4,0.00001z'/%3E %3Cpath d='m89.412,669.28,211.89,0,0.00015,6.174-211.89,0z'/%3E %3Cpath d='m112.41,669.31h16.005v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m115.95,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3Cpath d='m187.08,669.31h16.006v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m190.73,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3Cpath d='m262.19,669.31h16.005v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m265.73,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m98.935,664.23h193.07'/%3E %3Cpath d='m115.79,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438'/%3E %3Cpath d='m190.77,712.98h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071'/%3E %3Cpath d='m265.57,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300'%3E %3Crect width='600' height='300' fill='%23ce1126'/%3E %3Cg fill='%23fcd116' stroke='%23bd9c08' stroke-width='1.2'%3E %3Cpath stroke-width='1.5' d='M349.39,141.29c8.76,2.35,22.01,1.76,27.96,8.71-8.75-2.35-19.55,11.81-27.96,8.71,7.43,5.2-108.04,0-98.78,0-8.76-2.35-22.01-1.76-27.96-8.71,8.75,2.35,19.55-11.81,27.96-8.71-7.43-5.2-20.31-9.23-23.3-17.75,7.43,5.2,22.54-4.44,29.26,1.38-5.2-7.42-16.07-15.57-15.83-24.64,5.2,7.43,22.71,3.45,27.02,11.3-2.34-8.76-9.41-20.05-6.44-28.57,2.35,8.758,19.98,10.933,21.53,19.86,0.79-9.031-2.4-22.103,3.72-29.049-0.79,9.033,15.13,17.097,13.43,26.026,3.83-8.217,5.95-21.492,13.43-26.026-3.83,8.218,8.67,21.199,3.72,29.049,6.41-6.409,12.6-18.286,21.53-19.86-6.41,6.411,0.42,22.74-6.44,28.57,8.21-3.83,17.91-12.877,27.02-11.3-8.22,3.83-7.41,21.54-15.83,24.64,9.04-0.79,21.17-5.91,29.26-1.38-9.03,0.79-14.04,17.75-23.3,17.75z'/%3E %3Cpath stroke-width='1.5' stroke-linejoin='round' d='M258.36,150l-31.59-12.91,34.1-1.33-25.27-22.94,32.5,10.42-15.9-30.198,26.98,20.898-4.61-33.809,18.2,28.869,7.23-33.353,7.23,33.353,18.2-28.869-4.61,33.809,26.97-20.898-15.89,30.198,32.49-10.42-25.26,22.94,34.09,1.33-31.58,12.91,31.58,12.91h-146.45l31.59-12.91z'/%3E %3Ccircle stroke-width='1.8' cx='300' cy='150' r='41.358'/%3E %3Cpath d='M313.6,49.862l22.18,0.147c0.14-0.938-1.9-2.805-3.65-3.078-5.61-0.882-9.82,0.936-16.64,1.006l-1.89,1.925z'/%3E %3Cpath d='M269.43,44.643c5.21,6.58,15.31,11.153,24.95,11.213,13,0.08,27.42-10.441,44.85-13.662l-56.91-1.172c-7.37-5.045-12.96-4.405-16.77-1.277l-10.88,0.329c-1.54,0.839,1.27,4.343,3.55,4.471l11.21,0.098z'/%3E %3Cpath d='M295.16,40.868c-2.07-9.518-9.71-13.62-18.89-14.837-10.61-1.406-35.02-2.847-51.24-7.505,7.02,6.901,21.71,10.346,31.92,11.904,10.81,1.65,21.33,4.054,29.67,10.351l8.54,0.087z'/%3E %3Cpath stroke-linecap='round' d='M288.27,47.221c3.39,4.354,8.65,4.108,14.31,0.309,5.64-3.786,11.77-14.447,14.73-14.622,20.69-1.202,45.72-9.936,57.66-16.681-15.14,2.143-30.14,4.573-45.41,4.633-26.05,0.104-29.13,11.968-39.75,20.286'/%3E %3Cpath fill='none' stroke-linecap='round' d='M292.31,42.103c5.55-3.536,10.06-8.151,15.26-12.006,8.61-6.382,18.55-6.569,29.23-6.701,9.46-0.116,26.04-4.069,35.04-6.178'/%3E %3Cpath fill='none' d='M286.53,40.436c-1.63-8.511-9.6-11.065-19.66-12.594-10.95-1.663-22.12-2.589-33.04-5.607-2.71-0.748-5.23-2.07-7.85-3.105'/%3E %3Cpath fill='none' stroke-linecap='round' d='M290.02,52.983c10.28,0.754,17.91-2.336,26.68-6.706'/%3E %3Cpath fill='none' stroke-linecap='round' d='M254.63,41.831h12.96'/%3E %3Ccircle fill='%23bd9c08' stroke='none' cx='271.75' cy='40.437' r='1.62'/%3E %3C/g%3E %3Crect fill='%23003f87' width='600' height='135' y='165'/%3E %3Cpath id='w' fill='%23fff' d='M0,257.14c20,0,40,12.86,60,12.86s40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86v-21.43c-20,0-40,12.86-60,12.86s-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86v21.43z'/%3E %3Cuse xlink:href='%23w' y='-42.8571'/%3E %3Cuse xlink:href='%23w' y='-85.7142'/%3E %3C/svg%3E"

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='600' viewBox='0 0 500 300'%3E %3Crect fill='%233A75C4' width='500' height='300'/%3E %3Crect fill='%23CE1126' width='500' height='225'/%3E %3Crect fill='%23FFF' width='500' height='150'/%3E %3Crect fill='%23FFC61E' width='500' height='75'/%3E %3Cpath fill='%233D8E33' d='M0,300l250-150L0,0V300z'/%3E %3Ccircle fill='%23FFF' cx='85' cy='150' r='67.5'/%3E %3Ccircle fill='%233D8E33' cx='115' cy='150' r='67.5'/%3E %3Cpath id='star' fill='%23FFF' d='M100.0104,89.1996l7.3594,22.5883L88.1125,97.8394h23.775l-19.2573,13.9486L100.0104,89.1996z'/%3E %3Cuse xlink:href='%23star' y='32.2083'/%3E %3Cuse xlink:href='%23star' y='64.4166'/%3E %3Cuse xlink:href='%23star' y='96.625'/%3E %3C/svg%3E"

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Cdefs%3E %3C/defs%3E %3Cpath d='M750,0H0V500' fill='%23009e49'/%3E %3Cpath d='M0,500H750V0' fill='%23ce1126'/%3E %3Cpath d='M0,500 750,0' stroke='%23fcd116' stroke-width='210'/%3E %3Cpath d='M0,500 750,0' stroke='%23000' stroke-width='150'/%3E %3C!-- Rotation angle should be -arctan(2/3) --%3E %3Cg id='star' transform='translate(517.5,155) rotate(-33.69)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-70V0H35' transform='rotate(18,0,-70)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='translate(-285,190)'/%3E %3C/svg%3E"

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1600' height='800' viewBox='0 0 72 36'%3E %3Crect fill='%23024FA2' width='72' height='36'/%3E %3Crect fill='%23fff' y='6' width='72' height='24'/%3E %3Crect fill='%23ED1C27' y='7' width='72' height='22'/%3E %3Ccircle fill='%23fff' cx='24' cy='18' r='8'/%3E %3Cg id='star' transform='translate(24,18) scale(7.75)' fill='%23ED1C27'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E%3Cuse xlink:href='%23triangle' transform='scale(-1,1)' id='use12'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)' id='use14'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)' id='use16'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)' id='use18'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)' id='use20'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='-36 -24 72 48'%3E %3Ctitle%3EFlag of South Korea%3C/title%3E %3Crect fill='%23fff' x='-36' y='-24' width='72' height='48'/%3E %3Cg transform='rotate(-56.3099325)'%3E%3C!--arctan(-3/2)--%3E %3Cg id='b2'%3E%3Cpath id='b' d='M-6-25H6M-6-22H6M-6-19H6' stroke='%23000' stroke-width='2'/%3E %3Cuse xlink:href='%23b' y='44'/%3E%3C/g%3E %3Cpath stroke='%23fff' stroke-width='1' d='M0,17v10'/%3E %3Ccircle fill='%23c60c30' r='12'/%3E %3Cpath fill='%23003478' d='M0-12A6,6 0 0 0 0,0A6,6 0 0 1 0,12A12,12 0 0,1 0-12Z'/%3E%3C/g%3E %3Cg transform='rotate(-123.6900675)'%3E%3Cuse xlink:href='%23b2'/%3E %3Cpath stroke='%23fff' stroke-width='1' d='M0-23.5v3M0,17v3.5M0,23.5v3'/%3E%3C/g%3E%3C/svg%3E"

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 12 6'%3E %3Crect width='12' height='2' fill='%23007a3d'/%3E %3Crect width='12' height='2' y='2' fill='%23fff'/%3E %3Crect width='12' height='2' y='4' fill='%23ce1126'/%3E %3Cpolygon points='0,0 3,2 3,4 0,6'/%3E %3C/svg%3E"

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg stroke='%23000' stroke-width='1.4377'%3E %3Cg id='border' stroke='%23fff' stroke-width='9.6' stroke-linejoin='round'%3E %3Cuse xlink:href='%23shield'/%3E %3Cuse xlink:href='%23motto1'/%3E %3Cuse xlink:href='%23motto2'/%3E %3Cuse xlink:href='%23rope'/%3E %3Cuse xlink:href='%23turtle'/%3E %3Cuse xlink:href='%23pineapple1'/%3E %3Cuse xlink:href='%23pineapple2'/%3E %3C/g%3E %3Cg id='motto'%3E %3Cg id='motto1' fill='%23fcea83'%3E %3Cpath d='m754.417,449.563c2.87535,7.66776,23.4825,17.7317,47.4443,4.79235,16.294-9.10547,26.8372-22.0448,36.9011-45.0481,2.87534-5.75082,4.31301-12.9394-2.39625-17.2525-5.27159-3.83388-13.8978-8.14701-17.7317-11.9809-1.91689-1.91694-3.83392-3.35465-5.27159-4.79236,0.95845,0.95848,1.9169,1.91695,2.87535,3.35465,9.58473,11.5016-0.47923,28.2749-11.0224,38.3388-7.66771,7.18852-21.5656,24.9202-41.6934,8.14699-4.31314-3.83388-14.3771,11.9809-9.10551,24.441z'/%3E %3Cpath d='m1045.79,449.563c-3.3547,7.66776-23.9618,17.7317-47.4443,4.79235-16.294-9.10547-26.8372-22.0448-37.3804-45.0481-2.39625-5.75082-3.83392-12.9394,2.87534-17.2525,5.27159-3.83388,13.8979-8.14701,17.7317-11.9809,1.91702-1.91694,3.35469-3.35465,5.27159-4.79236-0.95845,0.95848-1.9169,1.91695-2.87535,3.35465-9.58473,11.5016,0.47923,28.2749,10.5432,38.3388,7.66769,7.18852,22.0448,24.9202,42.1727,8.14699,4.3132-3.83388,13.8978,11.9809,9.1055,24.441z'/%3E %3Cpath d='m900.105,490.778c38.3388,0,97.2848-17.2525,128.914-77.6361,5.2716-10.0639,0-15.3355-6.23-18.6902-6.7093-2.87541-14.8564-9.58471-19.1694-13.8978,7.6677,7.66778,6.2301,12.9394,0.9585,21.5656-24.4411,40.735-57.9875,61.3421-104.473,61.3421-46.4859,0-80.0323-20.6071-104.473-61.3421-5.27159-8.62625-6.70939-13.8978,0.47922-21.5656-3.83392,4.31312-12.4602,11.0224-19.1695,13.8978-6.23004,3.35465-11.5016,8.62623-6.23004,18.6902,31.6295,60.3837,91.0547,77.6361,129.394,77.6361z'/%3E %3C/g%3E %3Cg id='motto2' fill='%23db161c'%3E %3Cpath d='m811.446,409.787c-0.95847-4.79235-7.18853-2.87541-9.10547,2.87541-2.39617-3.35464-4.79235-6.70929-6.70929-10.5432-5.75083-8.62623-6.7093-14.3771,1.4377-22.5241,3.83389-3.83388,11.5016-8.147,16.7732-3.35464,11.0224,9.10547,5.27159,23.9618-2.39618,33.5465z'/%3E %3Cpath d='m988.284,409.787c0.95847-4.79235,7.66776-2.87541,9.5847,2.87541,2.39616-3.35464,4.79236-6.70929,6.70926-10.5432,5.7509-8.62623,6.7093-14.3771-1.9169-22.5241-3.35465-3.83388-11.0224-8.147-16.7732-3.35464-10.5432,9.10547-5.27159,23.9618,2.39618,33.5465z'/%3E %3Cpath d='m754.417,449.563c-4.79236-7.18853-8.62624-25.8787-9.58471-30.6711-1.43771-4.31312-1.91694-8.147,3.35465-10.0639,5.27159-1.91694,10.0639,4.79235,12.4601,10.5432,2.39617,5.75082,6.23006,14.3771,10.5432,24.9202-10.5432-6.23006-19.1694-1.91695-16.7732,5.27158z'/%3E %3Cpath d='m1045.79,449.563c4.3131-7.18853,8.147-25.8787,9.5847-30.6711,0.9585-4.31312,1.9169-8.147-3.3547-10.0639-5.2715-1.91694-10.0639,4.79235-12.4601,10.5432-2.3962,5.75082-6.23,14.3771-10.5432,24.9202,10.5432-6.23006,18.6902-1.91695,16.7733,5.27158z'/%3E %3C/g%3E %3Cg fill='%2300493d' stroke='none'%3E %3Cpath d='m782.213,406.432-3.83389,1.91694c-0.95847,0.47924-0.95847,1.43771-0.95847,1.91695h-0.47923l-1.91694-4.31312h0.47923c0,0.47923,0.47924,0.95847,1.43771,0.47923l8.147-4.31312c0.95847-0.47923,0.95847-0.95847,0.47923-1.4377l0.47924-0.47924,2.39618,4.79236h-0.47924c-0.47923-0.47924-0.95847-0.95847-1.91694-0.47924l-3.35465,1.91694,1.43771,2.87542,3.83388-1.43771c0.95847-0.47924,0.47924-1.43771,0.47924-1.91694h0.47923l1.91694,4.31312c-0.47923-0.47924-0.95847-0.95847-1.91694-0.47924l-8.147,4.31312c-0.95847,0.47923-0.95847,0.95847-0.47923,1.4377l-0.47924,0.47924-2.39618-4.31312,0.47924-0.47923c0.47923,0.47923,0.95847,0.95847,1.91694,0.47923l3.83388-1.91694-1.4377-3.35465z'/%3E %3Cpath d='m790.36,412.662c0.95847-0.47923,0.95847-0.95847,0.47923-1.91694h0.47924l4.79235,7.18853-3.35465,2.39618v-0.47924c1.91695-1.4377,1.91695-3.35464,1.43771-3.83388-0.47923-0.47924-0.95847-0.95847-0.95847-1.43771-0.47924,0-0.47924-0.47923-1.43771,0.47924-0.47923,0.47923-3.35464,2.39618-3.35464,2.39618,0.47923,0.47923,0.95847,1.91694,3.35464,0.47923h0.47924l-5.27159,3.83388v-0.47923c2.39618-1.91694,1.43771-3.35465,0.95847-3.83388l-3.35465,2.39617c-0.95847,0.47924-0.95847,0.95847-0.95847,1.43771,0.47924,0,0.47924,0.47923,0.95847,0.95847,0.47924,0.95847,1.91695,1.91694,4.31312,0.95847l0.47924,0.47924-3.83389,1.4377-4.79235-7.66776h0.47924c0.47923,0.47923,0.95847,0.95847,1.91694,0.47923l7.18853-5.27159z'/%3E %3Cpath d='m798.027,430.873-3.35464,2.87541c-0.47924,0.47923-0.47924,1.4377,0,1.91694h-0.47924l-3.35465-3.35465,0.47924-0.47923c0.47923,0.47923,0.95847,0.95847,1.91694,0l6.23006-6.23006c0.95847-0.47924,0.95847-0.95847,0.47924-1.91694l3.35464,3.83388c-0.47923-0.47924-1.4377-0.47924-1.91694,0l-2.87541,2.87541,2.39618,2.39618,2.87541-2.39618c0.95847-0.95847,0.47923-1.43771,0-1.91694l0.47923-0.47924,3.35465,3.83389h-0.47923c-0.47924,0-0.95848-0.47924-1.91695,0.47923l-6.23006,5.75083c-0.95847,0.95847-0.95847,1.4377-0.47923,1.91694v0.47923l-3.35465-3.83388c0.47924,0,1.43771,0.47924,1.91694,0l3.35465-3.35465-2.39618-2.39617z'/%3E %3Cpath d='m805.216,440.937,1.43771,1.4377c1.91694-4.31311,1.91694-4.31311,1.91694-4.31311s-1.4377,0.47923-3.83388,1.91694l0.47923,0.95847-0.47923,0.47923-0.95847-0.95847c-0.47924,0.47924-0.95847,0.47924-1.43771,0.95847-1.4377,0.95847-0.95847,1.43771-0.47923,1.91694v0.47924l-2.39618-2.39618h0.47924l1.91694-0.47923c9.5847-5.27159,9.5847-5.27159,9.5847-5.27159l0.47924,0.47923s-0.47924,0.47924-4.79235,10.064c0,0.95847-0.47924,1.4377,0,2.39617l-3.83389-3.35464,0.47924-0.47924c0.47923,0.95847,1.4377,0.95847,1.91694,0,0-0.47923,0.47923-1.43771,0.47923-1.91694l-1.4377-1.43771,0.47923-0.47923z'/%3E %3Cpath d='m809.05,450.522,0.47923-0.47924c0.47924,0.47924,0.95847,0.47924,1.91694,0l6.23006-8.147-0.47923-0.47924c-0.95847-0.47923-2.39618-0.47923-3.83388,0.95847v-0.47923l1.91694-2.39618,7.18853,5.27159-2.39618,2.87541h-0.47924c1.43771-1.4377,0.95848-3.35464,0-3.83388v-0.47924l-6.23005,8.14701c-0.95848,0.47923-0.47924,1.4377,0,1.91694h-0.47924l-3.83388-2.87541z'/%3E %3Cpath d='m821.51,452.439-2.39618,3.35464c-0.47924,0.95847,0,1.43771,0.47923,1.91695l-0.47923,0.47923-3.83388-2.87541v-0.47924c0.95847,0.47924,1.4377,0.47924,1.91694-0.47923l5.27159-7.18853c0.47923-0.95847,0-1.43771-0.47924-1.91694l0.47924-0.47924,3.83388,2.87541v0.47924c-0.95847-0.47924-1.43771-0.47924-1.91694,0.47923l-2.39618,3.35465,2.87541,1.91694,2.39618-3.35464c0.47924-0.95848,0-1.43771-0.47924-1.91695l0.47924-0.47923,3.83388,2.87541v0.47924c-0.47923-0.47924-1.4377-0.47924-1.91694,0.47923l-4.79235,7.66777c-0.95847,0.47923-0.47924,0.95847,0,1.4377v0.47924l-4.31312-2.87541h0.47924c0.47923,0,0.95847,0,1.4377-0.47924l2.39618-3.83388-2.87541-1.91694z'/%3E %3Cpath d='m831.095,465.857,0.47924-0.47924c0.47923,0.47924,1.4377,0.47924,1.91694-0.47923l3.83388-8.14701c0.47924-0.95847,0-1.4377-0.47923-1.91694l8.147,3.83389-1.91694,3.83388-0.47924-0.47924c1.43771-1.91694,0-3.83388-0.47923-4.31311-0.47924,0-0.95847-0.47924-1.43771-0.47924s-0.47924,0-0.95847,0.95847c-0.47924,0.47924-1.91694,3.35465-1.91694,3.35465,0.47923,0.47923,1.4377,1.4377,3.35465-0.95847h0.47923l-2.87541,5.75082-0.47924-0.47923c1.43771-2.87542-0.47923-3.35465-0.95847-3.35465l-1.91694,3.83388c-0.47923,0.95847,0,1.43771,0.47924,1.43771v0.47923l-4.79236-2.39617z'/%3E %3Cpath d='m844.992,472.567c-1.43771-0.95847-1.43771-3.83388,0-6.70929,0.95847-2.87542,2.87541-5.27159,4.79235-4.31312,1.43771,0.47923,0.95847,3.35465,0,6.23006-1.4377,3.35465-3.35465,5.27159-4.79235,4.79235h-0.47924c3.35465,1.43771,5.75083-0.47923,7.18853-3.83388,1.43771-2.87541,0.95847-6.23006-1.91694-7.66777-2.87541-1.4377-5.75082,0.47924-7.18853,3.83389-1.4377,3.35464-0.95847,6.70929,1.91694,7.66776h0.47924z'/%3E %3Cpath d='m859.849,473.525,1.91695-5.75082c0.47923-0.95847,0-1.43771-0.47924-1.91694l2.39618,0.47923v0.47924c-0.47924,0-0.95847,0-1.43771,0.95847l-1.91694,5.75082c-0.95847,2.39618-2.39618,4.31312-5.27159,3.35465-1.91694-0.47924-3.35465-2.87541-2.39618-5.27159l2.39618-6.23006c0.47924-0.95847,0-1.4377-0.47923-1.91694v-0.47924l4.31311,1.91695v0.47923c-0.47923-0.47923-1.4377-0.47923-1.4377,0.47924l-2.39618,6.23006c-0.47923,1.91694-0.47923,3.83388,0.95847,4.31311,1.43771,0.47924,2.87541-0.47923,3.83388-2.87541z'/%3E %3Cpath d='m864.162,467.295c0-0.47923,0-0.47923-0.47923-0.47923l3.35464,0.47923,2.87542,9.10547,1.4377-5.75082c0.47924-0.95847,0-1.43771-0.47923-1.91694l2.87541,0.47923-0.47924,0.47924c-0.47923,0-0.95847,0-1.4377,0.95847l-2.39618,10.5432h-0.47923l-3.83389-11.5016-2.39617,7.66776c0,1.43771,0.47923,1.43771,0.95847,1.91695v0.47923l-2.87542-0.95847v-0.47923c0.47924,0.47923,1.43771,0,1.43771-0.95848l2.39618-8.62623-0.47924-1.43771z'/%3E %3Cpath d='m880.456,476.88c-0.95847,4.31312-2.87541,5.27159-3.83388,5.27159h-0.95847s-0.47923-0.47924,0-0.95847l1.43771-9.58471c0.47923-0.47923,0.47923-0.95847,0.95847-0.47923h0.95847c0.95847,0,1.91694,1.91694,1.4377,5.75082l1.43771,0.47923c0.95847-4.79235-0.95847-6.70929-3.35465-7.18853-1.91694-0.47923-4.79235-0.95847-4.79235-0.95847v0.47924c0.47923,0.47923,1.43771,0.47923,0.95847,1.91694l-1.43771,8.62624c-0.47923,0.95847-0.95847,1.4377-1.4377,1.4377h-0.47924l4.79236,0.95847c2.39617,0.47924,4.79235,0,5.75082-5.27159l-1.43771-0.47923z'/%3E %3Cpath d='m884.769,473.046c0-0.95847-0.95847-1.43771-1.4377-1.43771v-0.47923l8.62623,0.95847-0.47923,3.83388c0-2.39618-1.43771-3.35465-2.39618-3.35465-0.47923-0.47923-0.95847-0.47923-1.43771-0.47923-0.47923,0-0.47923,0-0.47923,1.4377,0,0.47924-0.47924,3.83388-0.47924,3.83388,0.47924,0,1.91695,0.47924,2.87542-2.39617l-0.47924,6.23006h-0.47923c0-2.87541-1.43771-2.87541-1.91695-2.87541l-0.47923,4.31311c0,0.95847,0,0.95847,0.47923,0.95847l0.95847,0.47924c1.43771,0,2.87542-0.47924,3.83389-3.35465h0.47923l-0.95847,3.83389-9.10547-0.95848c0.95847,0,1.43771-0.47923,1.91694-1.4377l0.95847-9.10547z'/%3E %3Cpath d='m900.584,478.797c0,4.31312-1.43771,5.75083-2.87541,5.75083-0.47924-0.47924-0.47924-0.47924-0.95847-0.47924l-0.47924-0.47924,0.47924-10.0639c0-0.47923,0-0.47923,0.47923-0.47923h0.95847c0.95847,0,2.39618,1.4377,2.39618,5.75082h1.91694c0-4.79235-2.39618-6.23006-4.79235-6.23006-1.91694-0.47923-4.79236-0.47923-4.79236-0.47923v0.47923c0.47924,0,1.43771,0.47924,1.43771,1.43771l-0.47924,9.10547c0,0.95847-0.47923,1.43771-0.95847,1.43771v0.47923h4.31312c2.39618,0,4.79235-0.95847,5.27159-6.23006h-1.91694z'/%3E %3Cpath d='m914.482,482.631c0,0.95847,0.47924,0.95847,1.43771,0.95847v0.47924l-5.27159,0.47924c0.47924-0.47924,1.43771-0.95848,1.43771-1.91695l-0.95847-9.10547c-0.47924-0.95847-0.95847-0.95847-1.91694-0.95847v-0.47923l5.27158-0.47924c-0.47923,0.47924-1.4377,0.95847-0.95847,1.91694l0.95847,9.10547z'/%3E %3Cpath d='m919.274,483.589,0-0.47923c0.47923,0,0.95847-0.47924,0.95847-1.43771l-1.91694-10.0639h-0.47924c-0.95847,0.47924-1.91694,1.43771-1.4377,3.35465h-0.47924l-0.47924-3.35465,8.62624-1.43771,0.47924,3.35465h-0.47924c0-1.91694-1.43771-2.39617-2.87541-2.39617h-0.47924l1.91694,10.0639c0,0.95847,0.47924,1.4377,1.43771,1.4377v0.47924l-4.79235,0.47923z'/%3E %3Cpath d='m939.881,474.004-1.91694-5.75083c0-0.95847-0.95847-0.95847-1.43771-0.95847v-0.47923l2.39618-0.95847v0.47923c-0.47924,0.47924-0.47924,0.47924-0.47924,1.43771l1.91694,6.23006c0.47924,1.91694,0.47924,4.79235-2.39617,5.75082-1.91695,0.47924-4.31312-0.47923-4.79236-3.35465l-1.91694-6.23006c-0.47923-0.95847-0.95847-0.95847-1.4377-0.95847l-0.47924-0.47923,4.79235-1.43771v0.47924c-0.47923,0.47923-0.95847,0.95847-0.47923,1.91694l1.4377,6.23006c0.47924,1.91694,1.91695,2.87541,3.35465,2.87541,1.43771-0.47923,1.91694-2.39618,1.43771-4.79235z'/%3E %3Cpath d='m945.153,470.65c2.39617-0.95847,1.91694-2.39618,1.4377-3.83388-0.47923-1.43771-1.4377-2.39618-2.39617-1.91694-0.47924,0-0.95848,0.47923-0.47924,0.95847l1.43771,4.79235,0.47923,0.47924,0.95847,3.83388c0.47924,0.95847,1.43771,0.95847,1.91694,0.47923v0.47924l-4.31311,1.91694-0.47924-0.47924c0.95847-0.47923,0.95847-0.95847,0.95847-1.91694l-3.35465-8.147c-0.47923-1.4377-0.95847-0.95847-1.91694-0.95847v-0.47923l4.79236-1.91694c1.91694-0.47924,3.83388,0,4.79235,1.91694,0.47923,2.39617-0.47924,3.83388-2.39618,4.79235-0.47923,0-0.95847,0.47924-0.95847,0.47924l-0.47923-0.47924z'/%3E %3Cpath d='m957.134,472.087c-1.43771,0.47923-3.35465-1.43771-4.79235-4.79236-1.43771-2.87541-1.43771-5.75082,0-6.23006,1.4377-0.47923,3.35464,1.43771,4.79235,4.31312s1.43771,5.75083,0,6.7093c2.87541-0.95847,3.83388-4.31312,2.39618-7.66777-1.43771-2.87541-4.31312-4.79235-7.18853-3.83388-2.87542,1.4377-3.83389,4.79235-2.39618,7.66776,1.43771,3.35465,4.31312,5.27159,7.18853,3.83389z'/%3E %3Cpath d='m957.613,458.669h-0.47924-0.47924l2.87542-1.91695,8.62623,4.79236-2.87541-5.27159c-0.47923-0.95847-1.43771-0.95847-1.91694-0.95847v-0.47924l2.39618-0.95847c-0.47924,0.47924-0.95847,0.95847,0,1.91694l4.79235,9.58471-0.47924,0.47924-10.5432-5.75083,3.83388,7.18853c0.47923,0.95847,1.43771,0.95847,1.91694,0.47924v0.47923l-2.39618,1.43771v-0.47924c0.47924-0.47923,0.47924-0.95847,0-1.91694l-3.83388-7.66776-1.4377-0.95847z'/%3E %3Cpath d='m979.178,460.107,0-0.47923c0-0.47924,0.47923-0.95847,0-1.91694l-5.75083-8.14701h-0.47923c-0.95847,0.47924-1.43771,2.39618,0,3.83389l-0.47924,0.47923-1.91694-3.35464,7.18853-4.79236,1.91694,2.87541c-1.4377-1.4377-2.87541-1.4377-3.83388-0.95847l-0.47924,0.47924,5.75083,8.147c0.47923,0.95847,1.4377,0.95847,1.91694,0.47923v0.47924l-3.83388,2.87541z'/%3E %3Cpath d='m984.45,448.605,2.87541,3.35465c0.47923,0.47924,1.4377,0.47924,1.91694,0v0.47924l-3.83388,3.35464v-0.47923c0.47923-0.47924,0.47923-0.95847,0-1.91694l-5.75083-7.18853c-0.47923-0.95847-0.95847-0.47924-1.91694-0.47924l3.83388-3.35465v0.47924c0,0.47923-0.47923,0.95847,0,1.91694l2.39618,2.87541,2.87541-1.91694-2.39617-3.35465c-0.47924-0.95847-1.43771-0.47923-1.91695-0.47923l3.83389-3.35465v0.47924c-0.47924,0.47923-0.47924,0.95847,0,1.91694l5.75082,7.18853c0.47924,0.47923,0.95847,0.47923,1.43771,0l0.47923,0.47923-3.83388,3.35465-0.47924-0.47923c0.47924-0.47924,0.95847-0.95847,0.47924-1.91695l-2.87541-3.35464-2.87541,2.39617z'/%3E %3Cpath d='m988.763,438.541c-0.47923-0.47923-1.4377-0.47923-1.91694,0v-0.47923l6.23006-5.75083,2.87541,2.87541h-0.47923c-1.43771-1.91694-3.35465-0.95847-4.31312-0.47923,0,0.47923-0.47924,0.47923-0.95847,0.95847,0,0,0,0.47923,0.47923,1.43771,0.47924,0.47923,2.87542,2.87541,2.87542,2.87541,0.47923-0.47924,1.91694-1.43771,0-3.83389h0.47923l3.83388,4.31312v0.47924c-2.39617-2.39618-3.35464-0.95847-3.83388-0.47924l2.87541,2.87541c0.47924,0.95848,0.95847,0.95848,0.95847,0.95848,0.47924-0.47924,0.95848-0.95848,1.43771-1.43771,0.47924-0.47924,0.95845-1.91694,0-4.79235h0.47924l1.91691,3.35464-6.23003,6.23006-0.47924-0.47923c0.47924-0.47924,0.95847-0.95847,0-1.91694l-6.23006-6.7093z'/%3E %3Cpath d='m1000.26,425.122c-0.47921,0.47924-0.47921,1.43771,0.4793,1.91694,0.9584,0.95847,1.9169,0.95847,3.8338,0,0.9585-0.47923,2.8755-0.95847,4.3132,0.47924,2.3961,2.39618,1.4377,4.31312,0.9584,5.27159-0.4792,0.47923-1.4377,0.95847-1.9169,1.4377-0.4792,0-0.4792,0-0.4792,0.47924v0.47923l-3.3547-2.87541h0.4792c1.917,0.95847,3.8339,1.43771,4.7924,0,0.9585-0.95847,0-1.91694-0.4792-2.39617-0.9585-0.95848-1.917-0.95848-3.3547,0-1.4377,0.47923-3.3546,0.47923-4.7923-0.47924-1.91698-1.91694-1.91698-3.35465-0.95851-4.79235,0.47921-0.47924,1.43771-0.95847,1.91691-1.43771,0.4793,0,0.4793,0,0-0.95847l3.3547,2.39618h-0.4793c-2.3961-0.95847-3.8338-0.47924-4.3131,0.47923z'/%3E %3Cpath d='m1004.58,421.288c-0.9584-0.47924-1.4377,0-1.9169,0.47923h-0.4792l5.2716-7.66776,3.3546,2.39618-0.4792,0.47923c-1.917-1.43771-3.8339-0.47923-4.3132,0,0,0.47924-0.4792,0.95847-0.4792,1.43771-0.4792,0-0.4792,0.47923,0.4792,0.95847,0.4793,0.47923,3.3547,2.39617,3.3547,2.39617,0.4792-0.47923,1.4377-1.4377-0.4792-3.35464v-0.47924l4.7923,3.83388c-2.8754-1.4377-3.3546,0-3.8339,0.47924l3.3547,2.39618c0.9584,0.47923,1.4377,0.47923,1.4377,0.47923,0-0.47923,0.4792-0.95847,0.9585-1.4377,0.4792-0.95848,0.9584-2.39618-0.9585-4.31312l0.4792-0.47924,2.3962,2.87541-4.7924,7.18853h-0.4792c0.4792-0.95847,0.4792-1.4377-0.4792-2.39617l-7.1886-5.27159z'/%3E %3Cpath d='m1017.52,412.662-1.4377,2.39618c-1.917-1.91694-2.8754-3.35465-2.8754-3.35465l4.3131,0.95847h0.9585c0.4792,0,1.4377,0.47924,1.9169,0.47924,1.4377,0.47923,0.9585,0.95847,0.4792,1.91694h0.4793l2.3962-4.31312c-0.9585,0.95847-1.4378,0.47924-2.3962,0.47924-10.064-1.91694-11.0224-2.39618-11.0224-2.39618v0.47924l7.6677,8.62623c0.4793,0.47924,0.4793,1.43771,0.4793,1.91694h0.4792l1.4377-2.39617-0.4792-0.47924c-0.4793,0.95847-0.9585,1.43771-1.917,0-0.4792-0.47923-0.9584-0.95847-0.9584-0.95847l1.4377-3.35465h-0.9585z'/%3E %3Cpath d='m1014.64,402.119c-0.4793,0.47924-0.4793,1.43771,0.9585,1.91695,1.4377,0.47923,1.9169,0,3.3546-0.95847,1.4377-0.95848,2.8754-1.91695,4.7924-0.95848,2.8754,1.43771,2.3961,3.83389,1.9169,4.79236-0.4792,0.47923-0.9585,1.4377-1.4377,1.91694v0.47924,0.47923l-3.8339-1.91694c2.3962,0.47923,4.3131,0,4.7924-1.43771,0.4792-0.95847-0.4793-1.91694-0.9585-2.39617-0.9585-0.47924-1.917,0-3.3547,0.95847-1.4377,1.4377-2.8754,1.91694-4.7923,0.95847-1.917-0.95847-2.8754-2.39618-1.917-3.83389,0-0.95847,0.9585-1.4377,1.4378-1.91694,0-0.47923,0-0.47923-0.4793-0.95847v-0.47923l3.8339,1.91694h-0.4792c-2.3962-0.47924-3.8339,0.47923-3.8339,1.4377z'/%3E %3C/g%3E %3C/g%3E %3Cg id='crest'%3E %3Cg id='rope' fill='%23073163'%3E %3Cpath fill='%23fff' d='m863.203,232.47c-6.23006,1.43771-10.5432,1.91694-16.294-3.35465-3.83388-3.83388-2.87541-10.5432,0.95847-12.9394,4.31312-2.87541,8.147-4.79235,13.4186-3.35465,5.27159,1.43771,19.1694,14.3771,15.8148,14.8563-3.35465,0-8.62624,3.35464-13.8978,4.79235z'/%3E %3Cpath fill='%23fff' d='m878.06,209.466c1.91694-1.4377,4.31312-2.39617,10.5432-2.87541,5.75082-0.47923,10.0639-0.47923,11.5016,3.83388,1.91694,5.27159,3.35465,11.5016,7.18853,14.3771-2.39617,1.4377-14.3771,2.87541-18.6902,0.47923-5.75083-2.87541-7.18854-13.8978-10.5432-15.8148z'/%3E %3Cpath fill='%23fff' d='m919.274,209.946c1.91694-1.43771,4.31312-1.43771,10.5432-0.95847,6.23005,0.47923,8.62623,0.95847,10.0639,5.27159,1.4377,4.79235,0,11.0224,2.87541,15.3355-2.87541,0.95847-12.4601,0.95847-15.8148-2.39618-5.27159-3.83388-4.79235-14.8563-7.66776-17.2525z'/%3E %3Cpath d='m948.028,212.821c-4.31312-0.95847-7.18853-1.4377-9.10547,0,2.39617,2.87541,0.47923,14.3771,5.27159,18.2109,3.35464,2.39618,11.9809,2.87542,13.8978-2.39617,2.39618-4.79236,2.39618-11.9809-10.0639-15.8148z'/%3E %3Cpath d='m898.667,208.029c1.4377-1.43771,4.31312-1.91694,10.0639-1.91694,6.23006,0,10.0639,0.95847,11.9809,4.79235,1.91694,4.79235,1.43771,11.0224,4.79236,14.8563-1.43771,1.91694-14.3771,1.91694-18.211-0.95847-5.27159-3.35465-5.75082-14.3771-8.62623-16.7732z'/%3E %3Cpath d='m857.932,212.342c0-2.39618,3.35465-2.87542,11.9809-3.35465,8.62623-0.95847,9.10547-0.47924,11.9809,5.75082,1.43771,3.35465,3.35465,9.10547,7.18853,11.0224-10.5432,2.39617-13.8978,3.83388-19.6486,0.47923-4.31312-2.39618-9.10547-8.147-10.0639-10.5432-0.47924-1.4377-0.47924-2.87541-1.43771-3.35464z'/%3E %3C/g%3E %3Cg fill='%23f9d050' stroke-width='0.6469'%3E %3Cg id='pineapple1'%3E %3Cpath d='m880.935,163.46c-10.0639-7.66777-22.0448-14.8563-33.0672-16.294,7.18853,4.31312,27.3164,20.1279,32.588,25.3995'/%3E %3Cpath d='m886.686,156.271c-11.9809-8.147-25.8787-17.2525-39.2973-18.2109,10.064,5.27159,24.9202,17.7317,33.0672,27.7956'/%3E %3Cpath d='m902.021,142.853c6.7093-14.8563,13.8978-23.0033,23.4825-32.1088-4.79236,10.0639-10.064,30.6711-12.4601,38.8181'/%3E %3Cpath d='m912.565,140.457c4.79236-10.5432,11.9809-19.6486,24.441-25.3995-6.23006,6.23006-15.8148,24.9202-18.211,34.9842'/%3E %3Cpath d='m916.878,150.041c5.75082-8.147,17.2525-23.4825,37.8596-31.6295-11.9809,11.9809-29.7126,34.0257-34.0257,42.6519'/%3E %3Cpath d='m923.587,160.584c8.62623-4.79236,25.8787-12.4601,38.3388-10.0639-7.66776,2.87541-30.6711,13.4186-40.735,23.0033'/%3E %3Cpath d='m921.67,157.23c8.14701-8.62624,23.0033-21.5656,38.8181-26.8372-11.5016,11.0224-35.9426,35.9426-39.2973,39.7765'/%3E %3Cpath d='m898.667,151.958c-5.75083-17.7317-14.3771-34.5049-27.3164-39.7765,7.18853,10.5432,16.294,25.8787,21.0864,48.882'/%3E %3Cpath d='m887.644,151.479c-9.5847-11.5016-22.5241-23.0033-37.3804-25.3995,10.0639,5.75083,26.8372,22.5241,33.0672,38.8181'/%3E %3Cpath d='m892.916,151c-11.9809-21.5656-21.0864-25.3995-26.3579-29.7126,4.31312,8.147,14.8563,29.7126,21.0864,38.8181'/%3E %3Cpath fill='none' d='m868.954,149.562c5.75082,3.35464,14.3771,11.5016,17.2525,16.7732'/%3E %3Cpath d='m868.954,159.626c2.87541,2.39617,8.147,5.27159,12.9394,9.5847'/%3E %3Cpath d='m925.983,166.814c4.79236-3.83388,15.3355-10.0639,20.6071-11.9809'/%3E %3Cpath d='m922.629,163.46c4.79236-6.23006,14.3771-14.8563,17.7317-17.7317'/%3E %3Cpath d='m936.047,133.747c-4.31311,4.79235-14.3771,16.7732-18.2109,22.5241'/%3E %3Cpath d='m923.587,129.434c-3.35465,4.31312-10.064,16.7732-11.9809,21.0864'/%3E %3Cpath d='m885.727,130.393c2.87542,7.66777,8.147,20.6071,10.064,25.8787'/%3E %3Cpath d='m881.414,138.54c1.91695,2.87541,5.75083,9.58471,7.18854,14.3771'/%3E %3C/g%3E %3Cg id='pineapple2'%3E %3Cpath d='m897.708,136.143c0-4.31312,2.87541-9.10548,5.75082-9.10548,3.35465,0,5.75083,5.75083,5.75083,9.10548,0,3.83388-2.87542,7.18853-5.75083,7.18853s-5.75082-2.87542-5.75082-7.18853z'/%3E %3Cpath d='m891.478,139.977c0.47923-4.79236,3.83388-8.62624,6.70929-8.147,2.87541,0.47923,4.31312,6.23006,3.83388,9.5847-0.47923,3.83389-3.83388,6.7093-6.23005,6.23006-2.39618,0-4.79236-3.35464-4.31312-7.66776z'/%3E %3Cpath d='m904.418,141.415c-0.95847-4.31311,0.95847-9.10547,3.83388-9.5847,2.87542-0.47924,5.75083,4.31312,6.23006,8.147,0.95847,3.83388-1.4377,7.66776-3.83388,7.66776-2.39618,0.47924-5.75082-1.91694-6.23006-6.23006z'/%3E %3Cpath d='m897.229,145.249c0-4.79236,2.87541-9.10547,5.75083-9.10547,3.35464,0,5.75082,5.27158,5.75082,9.10547,0,3.83388-2.87541,7.18853-5.75082,7.18853-2.87542,0-5.75083-2.87541-5.75083-7.18853z'/%3E %3Cpath d='m888.603,147.645c0-4.31311,3.35464-9.10547,6.23005-9.10547,2.87542,0,5.75083,5.75083,5.75083,9.10547,0,3.83389-3.35465,7.18853-5.75083,7.18853-2.87541,0-6.23005-2.87541-6.23005-7.18853z'/%3E %3Cpath d='m906.335,145.728c0-4.31312,2.87542-9.10547,5.75083-9.10547,3.35464,0,5.75082,5.75083,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75083-2.87541-5.75083-7.18853z'/%3E %3Cpath d='m904.418,149.562c0-4.79236,3.35465-9.10548,6.23006-9.10548s5.75083,5.27159,5.75083,9.10548c0,3.83388-2.87542,7.18853-5.75083,7.18853s-6.23006-2.87542-6.23006-7.18853z'/%3E %3Cpath d='m896.75,153.875c0-4.79235,2.87541-9.10547,5.75082-9.10547,3.35465,0,5.75082,5.75083,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75082-2.87541-5.75082-7.18853z'/%3E %3Cpath d='m884.769,153.875c0-4.79235,2.39618-9.10547,4.79236-9.10547,2.39617,0,4.31311,5.75083,4.31311,9.10547,0,3.83389-2.39617,7.18853-4.31311,7.18853-2.39618,0-4.79236-2.87541-4.79236-7.18853z'/%3E %3Cpath d='m911.606,152.917c0-4.31312,2.39618-8.62623,4.79236-8.62623,2.39617,0,4.79235,5.27159,4.79235,8.62623,0,4.31312-2.87541,7.18853-4.79235,7.18853-2.39618,0-4.79236-2.87541-4.79236-7.18853z'/%3E %3Cpath d='m914.482,161.064c0.95847-4.79235,3.83389-8.62623,5.75083-8.147,1.91694,0.47924,2.39617,6.23006,1.4377,9.58471-0.47923,4.31312-3.35464,6.70929-5.27158,6.23006-1.91695-0.47924-2.87542-3.83388-1.91695-7.66777z'/%3E %3Cpath d='m905.376,159.626c0.47924-4.31312,3.35465-8.62624,5.75083-8.147,2.87541,0,4.31311,5.75082,3.83388,9.10547-0.47924,4.31312-2.87541,7.18853-5.27159,6.70929-2.39618,0-4.79235-3.35464-4.31312-7.66776z'/%3E %3Cpath d='m891.958,161.064c-1.4377-4.79235-4.31312-8.147-6.23006-7.66776-1.91694,0.47923-2.39617,6.23006-1.4377,9.58471,0.95847,3.83388,3.83388,6.23005,5.75082,5.75082,1.43771-0.47924,2.87541-3.83388,1.91694-7.66777z'/%3E %3Cpath d='m888.603,160.105c0-4.31312,2.39617-8.62623,4.79235-8.62623,2.87541,0,4.79235,5.27159,4.79235,8.62623,0,4.31312-2.39617,7.18853-4.79235,7.18853-1.91694,0-4.79235-2.87541-4.79235-7.18853z'/%3E %3Cpath d='m895.791,162.022c0-4.79235,2.87541-9.10547,5.75082-9.10547,3.35465,0,5.75082,5.27159,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75082-2.87541-5.75082-7.18853z'/%3E %3Cpath d='m898.188,109.306c-0.95847,3.83388-4.31312,7.18853-1.91694,12.4601-4.31312-1.43771-8.147-1.91695-11.5016,1.91694,4.31312-0.47924,8.147,0.95847,10.0639,3.83388-3.83388-0.47924-5.75082,1.43771-6.70929,3.83388,3.35465-0.95847,6.70929-1.91694,8.147-1.4377-1.43771,1.4377-3.83388,3.83388-4.31312,5.75082,2.87541-2.39618,6.23006-1.91694,8.147-3.35465-1.4377,3.35465,1.43771,6.7093,3.83389,10.064-0.47924-4.79236,2.39617-8.14701,0.95847-10.5432,4.31312,0.95847,4.79235,4.79235,11.0224,4.79235-2.39618-1.43771-3.83388-6.23006-6.70929-6.23006,1.4377-0.47923,7.18853-0.95847,8.147,0-0.95847-1.91694-4.31312-3.83388-6.23006-3.83388,1.91694-1.91694,5.27159-5.75083,7.66776-6.7093-3.35465,0.47924-8.62623,0.95847-10.5432,3.83389,4.79236-3.83389,3.83389-11.0224,9.10548-11.9809-2.87542-0.47923-7.18853,1.43771-10.5432,4.79236,1.4377-2.87542,1.4377-6.7093,3.35465-7.66777-3.83389,0.95847-8.14701,5.75082-9.58471,8.147,0-2.39618-1.43771-6.23006-2.39618-7.66776z'/%3E %3Cpath d='m900.584,116.974c0,1.43771,0,4.31312-0.47924,5.27159'/%3E %3Cpath d='m906.814,116.495c-0.95847,0.95847-2.87541,4.31311-2.87541,7.18853'/%3E %3Cpath fill='none' d='m909.689,122.246c-1.43771,0.95847-2.87541,2.39618-3.35465,4.31312'/%3E %3C/g%3E %3C/g%3E %3Cg id='turtle' fill='%23059334'%3E %3Cpath d='m858.89,169.69c-3.35464,0-6.23006-1.43771-8.147-3.83388-3.35465-4.31312-12.4601-6.23006-16.294-2.39618-1.43771,0.95847-3.35465,0.95847-4.79235,1.43771-2.39618,0-5.27159,2.39617-4.31312,7.18853,1.91694-1.43771,2.39618,0,3.83388,0,0.95847-0.47924,0.47924,0.47923,0.47924,1.4377,0,2.39618,5.27159,7.18853,10.0639,6.7093,5.27159,0,7.66776,1.91694,8.62624,2.87541,1.4377,1.43771,0.47923,0.95847,1.4377,3.35465,1.43771,1.4377,1.91694,1.91694-0.47923,3.83388-3.35465,2.87541-5.75083,9.58471,0,14.8563,6.23006,4.79235,22.0448,11.9809,39.7765-1.91695,17.2525-13.4186,44.0896-5.75082,46.0066-0.95847,2.39618,4.79236,3.35465,7.66777,3.83389,10.064,0.47923,1.91694,2.87541,3.83388,6.23006,3.35464,3.35464,0,7.18853,1.43771,9.10547,2.87542,2.39617,1.4377,5.75082,0.95847,4.79235-3.35465-1.91694-13.4186-10.0639-15.3355-11.0224-21.5656,4.79235,0.47923,8.147,0.47923,10.0639-1.43771,1.43771-1.91694,3.35465-5.27159,5.27159-6.23006,1.43771-0.95847,1.43771-1.91694-0.47924-1.4377-2.39617,0.47923-3.83388,1.4377-8.147,0.95847-22.0448-2.39618-83.8662-19.1694-95.8471-15.8148z'/%3E %3Cpath fill='%23000' d='m956.654,185.984c-2.39617,1.43771-4.79235,3.83388-9.10547,9.58471-4.79235,6.23006-19.1694,12.4601-36.9011,12.4601-17.2525,0-27.7956-2.87541-35.4634-9.10547-4.31312-3.35465-7.66777-5.27159-10.5432-6.7093-5.27159-2.39618-6.23006-7.66776-4.79236-11.9809-1.4377,2.39617-2.39617,4.79235-5.27158,4.31312-1.91695,0-5.75083,0-4.79236,1.91694-0.47923-0.95847-0.47923-2.39618-0.95847-2.87541-0.47923-0.47924-0.95847-0.95848-0.95847-0.95848,1.43771,0.95848,4.79235-1.91694,7.18853-1.91694,1.91694,0.47924,4.31312-1.91694,3.83388-4.79235-0.47923-2.39618-0.95847-4.31312-1.4377-6.23006,3.83388-1.91694,54.1536,7.18853,64.2175,8.147,10.064,0.47924,38.8181,4.79235,34.9842,8.147z'/%3E %3Cpath d='m865.6,167.773c4.79235-4.79235,10.5432-7.18853,16.294-5.75083h1.43771c2.87541-2.39617,9.5847-2.87541,13.4186-0.95847h1.91694c5.75082-1.91694,16.7732,0,20.6071,3.83389l1.4377,0.95847c12.9394-0.95847,20.6071,4.79235,29.7126,13.8978,0.95847,0.95847,2.39617,2.87541,4.79235,3.35465,2.87541,0.47924,3.35465,1.91694,0.95847,3.35465-2.87541,1.4377-5.27159,3.83388-10.0639,9.10547-4.31312,5.75082-18.211,11.5016-35.4634,11.5016-16.7732,0-26.8372-2.87541-34.5049-8.62624-4.31312-3.35465-7.66777-5.27159-10.064-6.70929-2.87541-0.95847-6.70929-4.79236-5.27159-8.62624,0.95848-3.83388-1.4377-8.62624-3.35464-13.4186,1.4377-0.95847,5.27159-2.39618,7.18853-1.43771l0.95847-0.47923z'/%3E %3Cg fill='%2300493d'%3E %3Cpath d='m950.424,179.754c-9.10548-9.10547-16.7732-14.8563-29.7126-13.8978,0,0.47923,0,1.91694-0.47923,2.87541,7.66776,2.87541,18.6902,11.5016,23.4825,17.7317,1.91694-1.91694,5.27159-4.31312,6.7093-6.7093z'/%3E %3Cpath d='m919.274,164.898c-3.83389-3.83389-14.8563-5.75083-20.6071-3.83389,0,1.91695,0,4.79236-0.95847,6.7093,3.35464,1.4377,6.23006,4.79235,9.10547,8.147,1.91694-0.47924,6.70929-1.91694,9.10547-2.39618,0.95847-1.91694,2.87541-6.23006,3.35465-8.62623z'/%3E %3Cpath d='m896.75,161.064c-3.83389-1.91694-10.5432-1.4377-13.4186,0.95847-0.95847,1.91695-1.43771,5.75083-1.43771,7.66777,1.91694,0,4.79235,1.43771,5.75082,2.39618,2.87542-0.95847,6.7093-2.87542,8.14701-4.31312,0.47923-1.91694,1.4377-4.79235,0.95847-6.7093z'/%3E %3Cpath d='m865.6,167.773c4.79235-4.79235,10.5432-7.18853,16.294-5.75083-0.95847,1.43771-1.43771,4.31312-1.43771,7.18853-5.27158-0.47923-11.9809,0.95848-14.8563,2.87542v-4.31312z'/%3E %3Cpath d='m941.798,187.422c-4.31312-6.23006-14.8563-13.4186-22.0448-16.7732,0,0.47924-0.95847,2.39618-1.4377,3.83388,2.87541,4.31312,8.62623,13.8978,11.0224,19.1694,2.39618-0.95847,9.10547-3.83389,12.4601-6.23006z'/%3E %3Cpath d='m905.376,197.965c0.95847-6.7093,1.43771-16.294,1.43771-19.6486,2.39618-0.47924,7.18853-1.91694,9.10547-2.39618,2.39618,3.83388,8.147,13.8978,10.5432,18.6902-5.75083,1.4377-15.3355,3.83388-21.0864,3.35465z'/%3E %3Cpath d='m888.603,174.961c2.39617-0.95847,5.75082-2.87541,8.147-4.79235,1.91694,1.4377,5.75082,4.79235,7.18853,6.70929,0,4.31312-1.43771,16.7732-1.91695,21.0864-3.83388,0-10.0639-0.95847-13.4186-2.87542,0.47923-7.18853,0.95847-15.3355,0-20.1279z'/%3E %3Cpath d='m864.641,180.712c0.47923-0.95847,0.95847-4.31311,0.95847-5.75082,3.83388-2.39618,13.4186-4.79235,20.6071-0.95847,0.47923,4.79235,0,16.7732-0.47924,19.6486-6.23006-4.79236-16.294-11.5016-21.0864-12.9394z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23000' stroke='none' d='m840.679,172.086c-0.95847,0-1.43771-2.87542-3.35465-2.87542-0.47923,0-1.91694,0.47924-2.39617,0,0,0.95848,0.47923,1.91695,0.95847,2.39618,0.47923,1.43771,2.87541,0.47924,4.79235,0.47924z'/%3E %3Cpath d='m840.679,180.233c5.75082,0,6.70929-7.18853,9.58471-7.66777'/%3E %3Cpath d='m844.034,180.712c4.31312,1.91694,7.66776-8.147,11.0224-7.66776'/%3E %3Cpath d='m835.408,168.252c1.43771,0,2.39618-1.91694,4.79235,0.47924,0.95848,0.95847,2.39618,1.43771,3.35465,1.43771'/%3E %3Cpath d='m842.596,175.441c-1.91694,2.87542-5.27159,4.79236-7.18853,3.83389'/%3E %3Cpath d='m834.449,163.46c-1.43771,0.95847-2.39618,2.87541-3.35465,4.31312'/%3E %3Cpath d='m829.657,170.648v2.39618'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg stroke='none'%3E %3Cpath id='shield' fill='%23fff' d='m989.722,232.949v93.4509c0,80.9908-38.3388,108.786-89.617,130.831-51.2781-22.0448-90.0962-49.8405-90.0962-130.831v-93.4509h179.713z'/%3E %3Cpath fill='%23cf142b' d='m900.105,312.023c4.31315,0,11.0224-3.83388,16.7732-9.5847,6.23004-6.70929,16.7732-9.10547,27.7958,0,11.0224,9.10548,17.7317,5.27159,23.4825,0,5.75082-5.27158,10.5432-7.18853,21.5656-7.18853v-62.3006h-179.713v62.3006c11.0224,0,15.8148,1.91695,21.5656,7.18853,5.75082,5.27159,12.4602,9.10548,23.4826,0,11.5016-9.10547,21.5656-6.70929,28.2748,0,5.27159,5.75082,11.9808,9.5847,16.7732,9.5847z'/%3E %3Cg fill='%230b50a0'%3E %3Cpath d='m900.105,359.946c5.75083,0,17.2525-6.23006,20.1279-7.66776,10.5432-6.23006,18.2109-0.47924,24.441,2.39618,6.7093,2.87541,19.1694,6.23005,26.8372,0,7.66777-6.23006,11.9809-5.75083,17.2525-5.75083,0.95847-7.18853,0.95847-14.3771,0.95847-22.5241v-5.75082c-6.70929-1.43771-10.0639,0.47923-17.2525,6.70929-7.18853,6.23006-15.3355,4.79235-25.8787,0.95847-10.0639-4.31312-20.1279-11.9809-30.1918,0-2.87542,3.35465-9.58471,8.147-16.294,8.147-7.18853,0-13.4186-4.79235-16.294-8.147-10.5432-11.9809-20.1279-4.31312-30.1918,0-10.5432,3.83388-19.1694,5.27159-26.3579-0.95847-6.70929-6.23006-10.0639-8.147-17.2525-6.70929v5.75082c0,8.147,0.47923,15.3355,1.4377,22.5241,5.27159,0,9.10548-0.47923,16.7732,5.75083,7.66777,6.23005,20.6071,2.87541,26.8372,0,6.7093-2.87542,14.3771-8.62624,24.9202-2.39618,2.87541,1.4377,13.8978,7.66776,20.1279,7.66776z'/%3E %3Cpath d='m900.105,380.553c7.18853,0,15.8148-2.87541,23.4825-7.18853,9.5847-5.27158,16.294-2.87541,25.8787,1.91695,10.064,4.79235,18.211,3.35464,23.9618,0,2.87541-1.91695,5.27159-5.75083,11.5016-4.31312-2.87541,11.9809-7.18853,22.5241-12.4601,31.1503-9.58471,2.39618-14.8563,2.39618-24.9202-1.91694-10.0639-4.79235-22.5241-7.66776-29.2334-3.35464-6.23006,3.83388-12.9394,5.75082-18.211,5.75082-5.27159,0-11.9809-1.91694-18.2109-5.75082-6.70929-4.31312-19.1694-1.43771-29.2334,3.35464-10.0639,4.31312-15.3355,4.31312-24.9202,1.91694-5.27159-8.62623-9.58471-19.1694-12.4601-31.1503,6.23006-1.43771,8.62623,2.39617,11.5016,4.31312,5.27159,3.35464,13.8978,4.79235,23.4825,0,10.0639-4.79236,16.7732-7.18853,26.3579-1.91695,7.66777,4.31312,16.294,7.18853,23.4825,7.18853z'/%3E %3Cpath d='m900.105,457.231c19.1694-8.147,36.9011-17.2525,51.2782-29.7126-3.83389-1.43771-6.23006-0.47924-9.58471-2.87541-3.35465-2.39618-13.4186-3.35465-22.0448,1.4377-9.10547,4.31312-12.9394,5.27159-19.6486,5.27159-6.70929,0-10.5432-0.95847-19.6486-5.27159-8.62623-4.79235-18.6902-3.83388-22.0448-1.4377-3.35465,2.39617-5.75083,1.4377-9.58471,2.87541,14.3771,12.4601,31.6295,21.5656,51.2782,29.7126z'/%3E %3C/g%3E %3Cg id='lion' stroke='%23000' stroke-width='1.4377'%3E %3Cpath fill='%23f9d050' d='m887.644,256.432c0.47924,0.95847-0.47923,3.35465,0,4.31312,0.95848,1.91694,0.95848,2.87541,2.39618,3.83388h3.35465c10.5432,0,23.0033-4.31312,33.5465-4.31312,10.064,0,16.294,3.35465,22.0448,3.35465,3.35465,0,6.23006-2.39618,6.23006-4.79235,0-2.39618-3.83388-3.83389-11.9809-3.83389-11.5016,0-17.7317,2.87541-27.3164,2.87541-14.3771,0-16.7732-5.27158-16.7732-7.66776s2.39618-5.75083,10.064-5.75083c2.39617,0,4.31311-0.47923,5.27158-1.4377,0.47924-0.95847,1.91695-2.87541,4.79236-4.31312,3.35464-1.91694,10.0639,0,13.4186-2.39618,0,1.91695-2.87541,4.79236-5.27159,5.75083,4.79235-1.43771,10.0639-1.43771,11.0224,2.39617-2.39618-1.4377-6.23006-0.47923-7.66776,0-1.91695,0.47924-2.87542,0.95848-4.79236,1.43771,1.91694-0.47923,2.87541,3.35465,5.75083,3.35465-2.87542,2.39617-7.66777,2.39617-12.4601,0.47923-1.43771-0.47923-5.27159-1.91694-7.66777-1.91694-4.79235,0-7.66776,0.95847-7.66776,2.87541,0,2.39618,2.87541,3.83389,11.5016,3.83389,8.62624,0,13.4186-2.39618,26.358-2.39618-0.95847-1.43771,0.47923-2.87541-1.43771-4.31312,4.79236,0,10.064,1.43771,11.9809,4.79236-0.47924-3.35465,2.39617-6.23006,1.4377-9.10548,2.87541,0.47924,5.27159,3.35465,5.75083,5.75083,0-1.43771,1.91694-1.43771,1.91694-2.87541,2.87541,1.4377,4.31312,4.79235,3.83388,7.66776,1.43771-2.39618,2.87541-1.4377,3.83388-4.31312,0.95847,1.91694,0.47924,7.66777-2.87541,9.58471,2.87541-1.91694,7.18853-1.91694,10.0639,1.43771-2.87541-0.47924-4.31311,0.95847-5.75082,1.4377-5.75082,3.35465-15.3355,5.27159-22.5241,4.79236-7.66777-0.47924-8.62624-1.91695-13.4186-1.91695,2.87541,0.47924,8.62623,6.23006,13.8978,6.23006,3.35465,0,5.75083,0,7.18853-0.47923,1.43771-0.47924,3.83389,0,5.75083,0.95847,1.4377,1.43771,4.31312,2.87541,6.23006,2.39618-0.47924,1.91694-1.43771,2.87541-2.87541,3.35464,2.39617,1.43771,0.95847,2.39618,3.35464,4.31312-0.95847,0-1.91694,0.95847-3.35464,0.47924,1.4377,1.4377,1.4377,3.35464,2.87541,4.31312-0.47924,0-1.91694,0.47923-2.87541,0,1.4377,1.91694,0,4.31311,1.4377,5.27158,1.43771,1.91695-1.4377,4.31312-3.83388,2.39618,0.47923,1.43771-0.95847,2.87541-2.39618,2.39618-1.4377-0.47924-2.39617-1.91694-1.91694-2.39618,0-0.47923,0-0.47923,0.47924-0.95847-0.95847,1.43771-2.87542,1.43771-3.83389,0.95847-0.47923-0.47923-0.95847-0.95847-0.95847-1.4377-3.35464,0.95847-4.79235-1.91695-4.31312-3.35465,0.47924-1.43771,3.35465-1.91694,4.31312-1.43771,0.95847,0.47924,1.91694,0.95847,2.87541,0,0.95848-0.47923,1.43771-1.4377,1.43771-2.39618,0-1.4377-1.43771-5.75082-7.66776-5.27158-7.18854,0.47923-18.6902-1.43771-24.441-3.35465-0.47923-0.47924-0.95847-0.47924-1.4377-0.95847,0,1.91694-1.91695,2.87541-1.91695,4.79235,0,2.39618,0.95848,4.31312,3.83389,5.27159-1.43771,2.39618-3.83389,1.91694-4.79236,0.47924,0,1.4377-1.91694,2.39617-1.91694,4.31311-0.47923-0.95847-0.95847-1.4377-1.4377-2.39617-1.43771,3.35464-5.27159,5.27159-7.18853,4.31312-2.39618,1.91694-5.27159,1.4377-6.23006-0.47924-1.43771,0.95847-3.35465,0.95847-4.31312,0,0,1.43771-0.95847,0.95847-1.43771,2.87541,0,0.95847-1.91694,1.43771-2.87541,0.95847-0.95847-0.47923-1.43771-2.39617-0.47923-3.35464-1.43771,0.95847-2.87542,0.95847-3.83389,0,0-0.95848,0-2.39618,0.95847-2.87542h0.95847c-0.95847-0.47923-2.39617,0-3.35464-0.47923-0.95847-0.95847-0.95847-1.91694-0.47924-2.87541,0.47924-0.47924,1.91694-1.43771,2.87541-0.47924l0.47924,0.47924c0-0.95848,0.47923-1.91695,0.95847-1.91695,0.95847-0.47923,2.39618-0.47923,3.83388,0.95847,0.95847,1.43771,1.91694,1.43771,4.79236,0.95848,2.39617,0,6.23006-2.39618,9.10547-4.79236-8.147-1.4377-3.35465-6.70929-0.95847-8.62623-1.91694-0.47924-4.79236-0.47924-6.7093,0.47923-10.0639,5.27159-20.6071,11.5016-27.3164,9.58471,0,0.95847,0.47923,1.91694,0.95847,2.87541-1.43771,0-4.31312,0-5.27159-1.43771-0.47924,0.95847-1.43771,3.35465-0.47924,5.27159-0.95847-0.95847-3.83388-1.91694-5.27159-2.39617,0.95847,0.95847,0,2.87541,0.47924,4.31311-1.43771-1.4377-3.83388-2.39617-4.79235-1.4377s-2.87542,1.4377-4.31312,0.95847c-0.95847,1.43771-2.39618,2.39618-3.83388,2.87541,0-0.95847,0-2.39618-0.47924-2.87541-0.47924,1.43771-1.91694,3.35465-3.83388,4.31312,0-0.95847,0-2.39618-0.47924-3.35465,0,1.91694-3.83388,2.87541-4.31312,4.31312,0.47924-1.43771,0.47924-2.87541,0.47924-3.83388-0.95847,1.4377-2.39618,2.87541-4.79235,3.35464,0.47923-0.95847,0.95847-1.91694,0.47923-2.87541-0.47923,1.91694-3.35465,2.87541-5.75082,2.39618,0,0.95847-1.91694,2.39617-4.31312,0.95847-1.43771-0.47924-2.39618-1.91694-1.43771-2.87541-1.91694,0-3.83388-1.91695-2.87541-3.35465,0-0.47924,0.47924-0.95847,0.47924-1.43771-1.43771-0.95847-1.91695-2.87541-0.47924-4.31312,0.47924-0.47923,1.91694-0.47923,2.87541-0.47923,0-3.83388,3.35465-3.83388,4.79236-0.95847,0.95847,1.4377,3.83388,3.83388,6.23006,3.35465,0.95847,0,1.4377-0.47924,2.39617-0.47924,2.87541-0.95847,8.62624-3.35465,11.9809-6.23006,0.47923-1.43771,0.47923-2.39618,0.47923-3.35465-1.91694,0.95847-3.83388,1.91694-4.79235,3.35465v-1.43771c-1.43771,0-3.83389-0.47923-4.79236-0.47923,0.47924-0.47924,0.95847-2.87541,1.91695-3.35465-2.39618,0.47924-4.79236,0-6.7093-0.47923,0.95847-0.95847,0.95847-2.39618,1.43771-3.83389-0.95847,0.47924-3.35465-0.47923-5.27159,0,0.47923-1.4377,0.95847-3.35464,2.39617-3.83388-1.91694,0.47924-4.31311,0-6.70929-0.95847,1.91694,0,2.87541-2.39618,4.31312-2.39618-3.83388,0-4.79236-1.91694-6.7093-2.87541,1.43771,0.47924,2.39618-0.95847,3.83389-0.95847-1.43771-0.47923-3.83389-2.87541-2.87542-4.31312-0.47923,0.47924-0.95847,1.43771-1.91694,1.91694-0.95847,0.47924-2.87541,0-4.31312-1.4377-0.95847-1.91694-0.47923-4.31312,1.43771-4.79236-2.39618-0.47923-2.39618-2.87541-1.43771-3.83388,0.47924-0.95847,2.39618-2.39618,3.35465-0.95847,0.47924,0.47924,0.95847,1.43771,1.43771,1.91694-0.47924-0.95847-0.47924-2.87541-0.47924-4.31312,0.47924-1.4377,1.43771-1.4377,2.87541-1.91694,1.43771,0,2.39618,1.43771,2.39618,2.87541,0,1.43771,0.47924,2.39618,0.95847,4.31312,0-0.47923,0.47924-1.4377,0.47924-1.91694,0-1.91694,2.39617-1.4377,3.83388-0.95847,1.43771,0.47924,1.91694,3.35465,0,4.79235-0.95847,0.95847-0.47924,2.39618,0.47924,3.35465,3.35464,5.27159,9.10547,9.58471,13.8978,10.0639,0-1.91694,0.95847-3.83388,2.39618-5.27158,0-0.95848,0.47923-2.39618,0.95847-3.35465,0.47923-2.87541,1.91694-4.31312,3.83388-3.35465-0.47923-0.47924-0.95847-0.95847-0.95847-1.43771-1.43771-1.4377-2.87541-3.83388-1.91694-5.75082s3.83388-1.43771,4.79235-0.47924c-0.47923-2.87541,2.87541-5.27158,2.87541-6.70929,0.47924,1.43771,1.43771,3.35465,0.95847,4.79235,0.47924-1.91694,3.83389-4.31311,6.23006-5.27159-0.95847,1.43771,1.91695,3.83389,1.43771,5.27159,0.95847-2.39617,4.79235-3.83388,7.66777-3.83388-0.95847,0.95847-0.95847,2.87541-0.95847,3.83388,1.4377,0,3.83388-0.47923,4.79235-1.91694,0,1.91694-0.95847,3.83388-1.91694,4.79236,0.47923-0.47924,2.39617-0.47924,3.83388-0.47924-1.43771,1.43771-0.95847,2.87541-2.39618,3.83388,1.91695-0.95847,4.31312-0.95847,4.79236,0.95847,0.95847,1.43771-0.47924,3.83389-1.43771,5.27159-0.95847,0.47924-1.91694,1.43771-2.39618,1.43771z'/%3E %3Cg fill='none'%3E %3Cpath d='m857.932,262.182c-3.35464,1.43771-4.31312,4.79236-4.79235,6.7093'/%3E %3Cpath d='m857.453,265.537c-4.79236,2.87541-6.7093,5.27159-5.75083,10.5432'/%3E %3Cpath d='m859.849,279.914c2.87542-0.95847,4.79236-1.91694,7.18853-6.23006'/%3E %3Cpath d='m865.6,275.601c-0.95847,1.91694,0,5.27159-1.43771,6.7093,2.39618-1.43771,4.31312-3.35465,4.79236-6.7093'/%3E %3Cpath d='m866.558,280.872c1.91694-0.95847,4.79235-3.83388,6.23006-7.18853-0.47924,1.43771,0,3.83388-0.95847,5.27159,2.39617-2.39618,3.35465-3.83388,3.83388-6.23006,0,0.47924,0.47924,1.43771,0.47924,1.91694,0.95847-0.95847,1.91694-1.91694,1.91694-3.83388'/%3E %3Cpath d='m878.06,272.246v2.39617c1.91694-1.4377,2.39617-3.35465,2.39617-5.75082'/%3E %3Cpath d='m879.977,271.767c2.87541-1.91694,3.35465-4.79235,3.35465-9.10547'/%3E %3Cpath d='m883.331,267.454c1.91694-1.4377,2.39617-2.39618,2.39617-6.70929'/%3E %3Cpath d='m879.497,247.805c-0.95847,0-1.91694,0.47924-1.91694,1.91694,0,0.95847-1.4377,2.39618-1.4377,3.83389-0.47924,1.91694-1.43771,2.39617-2.87542,1.91694-1.4377-0.95847-1.4377-0.95847-1.4377-2.39618,0-1.91694,2.39617-2.39618,2.39617-4.31312,0.47924-0.95847,0.95848-2.39617,1.43771-2.39617-2.39618,1.4377-5.75082,0.47923-6.23006-2.39618'/%3E %3Cpath d='m883.811,249.243c-0.95847,0.47923-1.91694-0.95847-3.35465-0.47924-0.47923,0-1.91694,0.47924-2.39617,0'/%3E %3Cpath d='m877.101,251.639c0.47923,0.47924,2.87541,1.43771,5.27159,0.47924-1.91695,0.47924-3.35465-1.91694-1.43771-3.35465'/%3E %3Cpath d='m872.788,246.847c-1.91694,0-3.35465,1.43771-2.87541,2.87541,0.47923,1.43771,2.39617,1.43771,3.83388,0.47924'/%3E %3Cpath d='m869.433,270.809c0.47924-0.47924,0.95847-1.43771,0.95847-1.91694,0.95847,0,1.91694-0.47924,2.39618-0.95847,1.91694,0,3.35465-1.43771,3.83388-2.87542,0.95847,0,1.43771-2.39617,1.91694-3.35464,0.47924,0.47923,1.43771,0,1.91694-1.91694,0.95847,0.47923,2.39618,0,2.87542-1.43771'/%3E %3Cpath d='m863.683,254.994c0,0.47924-0.95847,1.43771-1.91694,1.91694,0.47923,0.95847,0,3.35465-0.95848,3.83389,0.47924,0.95847,0,2.39617-0.47923,3.35464,0,0.47924,0.47923,1.91695,0.47923,2.39618'/%3E %3Cpath d='m865.6,245.409c-0.95847,2.39617-0.47924,5.27158,1.4377,5.75082'/%3E %3Cpath d='m866.558,253.077c-0.47924,2.39618-0.47924,5.75083-0.95847,7.18853-0.47924,0.95847-1.43771,4.31312,2.39617,5.27159,4.31312,0.95847,6.7093,0.47924,9.10548-6.70929'/%3E %3Cpath d='m884.29,277.518c0,0.47924-0.47924,1.43771-1.43771,1.43771'/%3E %3Cpath d='m887.644,276.559c0,0.95847-0.95847,2.39618-1.4377,2.87542'/%3E %3Cpath d='m890.999,275.601c0,0.95847,0,2.39618-0.95847,2.87541'/%3E %3Cpath d='m861.766,245.888c0.47923,0,0.95847,0.95847,1.4377,1.91694-1.4377-0.95847-2.87541,1.43771-1.91694,2.87541'/%3E %3Cpath d='m860.328,254.035c-0.47924,0.47924-1.43771,0.95847-1.91694,1.43771'/%3E %3Cpath d='m858.89,258.348c-0.47923,0-0.95847,0.47924-1.4377,0.47924'/%3E %3Cpath d='m835.887,249.722c0-0.47923,0-0.47923,0.47923-0.95847'/%3E %3Cpath d='m831.574,248.284c-0.47924,0-0.47924,0-0.95847-0.47924'/%3E %3Cpath d='m832.053,254.994h0.95847'/%3E %3Cpath d='m830.136,252.118c-0.95847-0.95847-2.39617-1.43771-2.87541-1.43771'/%3E %3Cpath d='m856.494,269.85c-3.35465,2.87541-4.79236,5.27159-5.27159,8.62623'/%3E %3Cpath d='m859.849,272.246c-0.95847,1.91694-2.39617,3.35464-3.83388,4.31311'/%3E %3Cpath d='m841.159,286.623c-3.83389,0.95847-6.7093,0.47923-9.58471-1.43771-0.47924-0.47924-0.95847-0.47924-1.43771-0.95847'/%3E %3Cpath d='m855.536,279.914c-0.47924,1.91694-0.95847,4.31312-1.91695,4.79235,3.83389-1.91694,7.18853-4.79235,7.66777-9.10547'/%3E %3Cpath d='m827.74,289.02c1.4377-0.47923,2.87541,0.47924,3.83388-0.47923'/%3E %3Cpath d='m911.127,273.205c0.95847,0.47923,2.39617,0.95847,2.87541,1.4377,0.47923-0.95847,2.39618-2.39617,3.83388-2.87541'/%3E %3Cpath d='m877.101,283.269c-0.47924-1.91694,0.47923-4.31312,3.35464-5.27159'/%3E %3Cpath d='m858.411,291.416c0.47923-0.95847,0.47923-2.39618,0.95847-3.35465'/%3E %3Cpath d='m837.325,292.853c-0.47923,0.95847-1.4377,1.91694-1.4377,2.87541'/%3E %3Cpath d='m830.136,293.812s0-0.47924,0.47924-0.47924c0.95847-0.47923,2.39617-1.43771,2.87541-2.39618'/%3E %3Cpath d='m895.312,287.103c-0.95847,0.47924-1.43771,0-1.91694-0.47923'/%3E %3Cpath d='m894.833,289.499s-0.47923,0.47923-0.95847,0.47923'/%3E %3Cpath d='m897.229,291.895c-0.47923,0.47924-0.95847,0.95848-1.4377,0.95848'/%3E %3Cpath d='m911.127,292.853c0.95847-0.47924,1.4377-1.43771,1.91694-3.35465'/%3E %3Cpath d='m904.897,292.374c1.4377-0.47924,2.39617-1.43771,3.83388-2.87541'/%3E %3Cpath d='m918.315,288.54c0-0.95847,0-1.91694,0.47923-2.87542'/%3E %3Cpath d='m953.779,292.853c-0.95847-0.95848-0.95847-2.39618,0.47924-3.35465,0.95847-0.47924,1.4377-0.95847,2.39617-1.43771'/%3E %3Cpath d='m924.546,276.08c-7.66777-3.35465-7.18853-7.66777-13.4186-7.18853'/%3E %3Cpath d='m958.571,290.936c0.47923,0.47924,0,1.91695,0,2.39618'/%3E %3Cpath d='m962.884,290.936c-0.47923,1.43771-0.47923,1.91695-0.47923,3.35465'/%3E %3Cpath d='m925.983,245.888h-3.83388'/%3E %3Cpath d='m885.727,262.182c0,0.95847,1.43771,2.87541,5.27159,2.87541-0.47923,0-0.95847-0.47923-0.95847-0.47923'/%3E %3Cpath d='m887.644,256.432c-0.47923,0.47923-0.95847,0-0.95847,0-0.95847-0.95847,0.47924-2.87541,1.91695-3.83388-1.43771,0.47923-2.39618,0.47923-3.35465,0.47923-0.95847,2.87541-3.83389,4.31312-5.75083,2.39618-0.47923,1.91694-2.87541,4.31312-4.79235,3.83388-1.91694-0.95847-2.39618-2.39618-1.91694-3.83388-2.39618,2.87541-5.27159,0.95847-6.23006,0-0.47924-0.95847,0-3.35465,0.95847-6.23006'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m918.315,274.642c-1.43771,0.95847-2.87542,0-4.31312,1.43771-0.95847,0.95847,0.47923,1.4377,1.4377,1.4377-0.47923,1.43771-0.47923,1.91695,1.91695,1.91695-0.95847,1.4377,1.91694,1.91694,1.4377,3.83388,1.43771-1.43771,1.43771-3.35465,0.95847-4.79236-0.47923-1.4377-2.87541-2.39617-1.4377-3.83388z'/%3E %3Cg fill='%23073163' stroke='none'%3E %3Cpath d='m874.705,259.307c-1.91694-0.95847-2.39618-2.39618-1.91694-3.83388-0.47924,0.95847-1.43771,1.4377-2.39618,1.4377-1.91694,4.31312-4.31312,8.147-7.18853,8.147-3.35465,0.47924-2.87541,3.83389-0.47923,3.83389,5.27158,0.95847,7.66776-0.95847,11.9809-9.58471z'/%3E %3Cpath d='m827.261,247.805c1.43771-1.4377,0.47924-2.87541-0.47924-3.35465-1.4377-0.47923-4.31311,0-5.75082,2.39618,1.43771-0.47923,2.87541-0.47923,3.35465,0.47924,0.47923,0.95847,1.4377,1.91694,2.87541,0.47923z'/%3E %3Cpath d='m829.657,239.179c3.35464,0,4.31312,0.47923,4.79235,1.91694,0.47924,0.95847-0.47923,2.39617-1.43771,2.39617-1.4377,0-2.87541-0.95847-2.39617-1.4377,0.47923-0.95847,0.47923-2.39618-0.95847-2.87541z'/%3E %3Cpath d='m839.242,246.847c2.39618,0.47924,3.35465-0.95847,1.91695-2.87541-0.47924-1.43771-1.91695-2.39618-4.31312-1.91694,2.39617,1.4377,0,3.83388,2.39617,4.79235z'/%3E %3Cpath d='m821.51,254.994c1.4377,2.39618,3.83388,2.39618,4.79235,1.91694,1.43771-0.47923,1.91694-1.91694,1.43771-2.87541-0.95848-1.4377-2.39618-1.91694-2.87542,0-0.95847,1.91694-2.39617,1.43771-3.35464,0.95847z'/%3E %3Cpath d='m828.698,284.227c-0.95847-1.91694-3.83389-1.91694-6.23006,0,0.95847-0.47924,2.87541,0,3.35464,0.95847,0.47924,0.95847,1.43771,0.95847,1.91695,0.95847,0.47923-0.47924,1.4377-0.95847,0.95847-1.91694z'/%3E %3Cpath d='m832.532,281.352c0-2.39618-3.35465-2.87542-5.27159-1.91694,0.95847,0,2.39618,0.95847,2.39618,1.91694,0.47923,0.95847,1.4377,1.4377,1.91694,1.4377,0.95847-0.47923,1.4377-0.95847,0.95847-1.4377z'/%3E %3Cpath d='m827.74,289.978c-2.87542-0.47923-4.31312,2.87542-4.31312,5.27159,0.47923-1.4377,1.91694-2.39617,3.35464-1.91694,1.43771,0,1.91695-0.47923,1.91695-1.43771,0.47923-0.95847,0-1.4377-0.95847-1.91694z'/%3E %3Cpath d='m828.219,298.125c0.95847,0.47924,1.91694-0.47923,2.39618-1.91694,0-0.95847,1.91694-0.95847,2.39617-0.47923,0.95848,0.47923,0.95848,2.39617-0.47923,3.35464-0.95847,0.47924-3.35465,0.95848-4.31312-0.95847z'/%3E %3Cpath d='m894.833,283.748c-0.95847-0.47923-3.35464-1.4377-5.27158,0,1.4377-0.47923,2.39617,0.47924,2.87541,1.43771,0,0.95847,1.4377,1.43771,1.91694,0.47923,0.47923-0.47923,0.95847-1.4377,0.47923-1.91694z'/%3E %3Cpath d='m890.52,287.103c-1.91694-0.95847-4.31312,1.43771-4.79236,3.35465,0.47924-0.47924,2.39618-1.43771,3.35465-1.43771,0.95847,0.47924,1.91694,0,1.91694-0.95847,0.47924-0.47923,0.47924-0.95847-0.47923-0.95847z'/%3E %3Cpath d='m892.916,290.936c-1.4377,0-3.35464,1.91695-3.35464,3.83389,0.47923-0.95847,1.4377-1.43771,2.39617-0.95847,0.95847,0,2.39618-0.47924,2.39618-1.43771s-0.47924-1.43771-1.43771-1.43771z'/%3E %3Cpath d='m897.229,294.77c-0.95847-0.47924-2.39618,0-2.39618,1.4377,0,1.43771,0,2.87541-0.47923,3.35465,0.95847-0.95847,1.91694-1.43771,2.87541-1.91694,0.47924-0.47924,0.95847-1.91694,0-2.87541z'/%3E %3Cpath d='m951.383,290.457c-0.95847-0.95847-2.39618-0.47924-2.87542,0.47923-0.47923,0.95847-0.95847,3.35465,0,5.27159,0-0.95847,0.95847-2.39617,1.91695-2.39617,1.4377-0.47924,1.91694-2.39618,0.95847-3.35465z'/%3E %3Cpath d='m954.258,292.374c-1.91694,0.95847-1.91694,4.31312-0.47924,6.23006,0-0.95847,0.47924-2.39618,1.43771-2.87541,1.4377,0,1.91694-1.91694,1.4377-2.87541-0.95847-0.95848-1.91694-0.47924-2.39617-0.47924z'/%3E %3Cpath d='m960.009,294.291c-0.95847-0.47923-1.91694,0.47924-1.91694,1.43771-0.47923,1.4377,0.47924,3.35464,1.91694,4.31312,0-0.95848,0.47924-1.91695,0.95847-2.39618,1.43771-0.95847,0.95847-2.87541-0.95847-3.35465z'/%3E %3Cpath d='m964.322,293.812c-0.95847,0-1.91694,1.4377-0.95847,2.87541,0.47923,0.95847,1.43771,1.4377,3.35465,0.95847-0.47924,0-1.43771-1.43771-0.95847-1.91694,0.47923-0.95847,0-1.91694-1.43771-1.91694z'/%3E %3C/g%3E %3C/g%3E %3Cg id='star'%3E %3Cpath fill='%23f9d050' d='m831.095,383.429,23.9618-73.8022,23.9618,73.8022-62.7798-45.5274,77.6361,0z'/%3E %3Cpath fill='%23024919' d='m835.887,376.72,49.8405-36.4219-61.3421,0,49.3612,36.4219-18.6902-58.4667z'/%3E %3C/g%3E %3Cuse xlink:href='%23star' x='90.09665'/%3E %3Cuse xlink:href='%23star' x='45.04765' y='52.23713'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.4377' d='m989.722,232.949v93.4509c0,80.9908-38.3388,108.786-89.617,130.831-51.2781-22.0448-90.0962-49.8405-90.0962-130.831v-93.4509h179.713z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 2000 1000'%3E %3Ctitle%3EFlag of Kazakhstan%3C/title%3E %3Crect width='2000' height='1000' fill='%2300afca'/%3E %3Cg id='sun' fill='%23fec50c' transform='translate(1080.4716,420)'%3E %3Ccircle r='134.5497'/%3E %3Cg id='r16'%3E %3Cg id='r4'%3E %3Cpath id='r' d='m0,-152.9c8,-0.1 11,-5.1 11,-11.1c0,-8 -11,-46.1 -11,-46.1s-11,38.1 -11,46.1c0,6 3,11.1 11,11.1z'/%3E %3Cuse xlink:href='%23r' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(45)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(67.5)'/%3E %3C/g%3E %3Cuse xlink:href='%23r16' transform='rotate(11.25)'/%3E %3C/g%3E %3Cg id='bird' fill='%23fec50c'%3E %3Cpath d='M316.94,213.44c-1.08,0.06-2.13,0.2-3.16,0.53-1.41,0.19-2.76,0.68-4.16,0.91l-0.56,0.09-0.94,0.09c0.06,0.26,0.1,0.52,0.1,0.78,0,0.27-0.03,0.53-0.1,0.75-0.06,0.21-0.25,0.47-0.4,0.63-0.2,0.22-0.41,0.41-0.66,0.53-0.24,0.12-0.51,0.17-0.78,0.19-0.27,0.01-0.55,0-0.81-0.1-0.27-0.09-0.52-0.26-0.75-0.46-0.28,0.07-0.57,0.12-0.84,0.15-0.28,0.03-0.54,0.03-0.79,0-0.28-0.08-0.57-0.17-0.84-0.28s-0.53-0.25-0.78-0.41c-1.02,0.6-2.16,1.17-2.78,2.22-0.35,0.48-0.42,1.03-0.5,1.6-0.05,0.7,0.13,1.44,0.43,2.09,0.11,0.19,0.2-0.69,0.54-0.81,0.57-0.47,1.28-0.81,2-1,0.61-0.31,0.53,0.02,0.28,0.5-0.06,0.25-0.4,1.2,0.06,0.72,2.03-0.9,4.28-1.08,6.47-1.25,3.18-0.33,6.37-0.4,9.56-0.44,3,0.04,6,0.08,9,0.19,1.43,0.04,2.87,0.36,4.28,0.12,0.34-0.09,0.87-0.11,1.07-0.31-0.64-0.37-1.39-0.38-2.1-0.47h-5.72c-1.59-0.16-3.25-0.18-4.75-0.78-0.4-0.16-0.77-0.54-1.15-0.13-0.57,0.2-1.18,0.34-1.78,0.38-1.05,0.08-2.1-0.14-3.07-0.53,0.7-0.97,1.54-1.82,2.31-2.72-0.62-0.1-1.22-0.23-1.84-0.38,1.09-0.75,2.1-1.6,3.16-2.4z' transform='scale(3.3333333,3.3333333)'/%3E %3Cpath d='m1212.2,746.01c-7.2452,4.3503-12.775-3.3623-18.831-5.6752-4.3249,2.3488-4.7288,10.208-8.7706,13.93-4.8342,5.5019-10.76-1.5363-10.318-6.9649-5.7825,4.8741-8.7067,15.922-18.057,14.446-4.4308-3.6151-7.7219-11.201-11.106-2.5636-2.7613,4.2221-10.11,10.229-13.916,3.8533-1.1784-5.6287-4.0008-12.25-7.0634-3.3078-2.1024,6.3247-8.8507,10.978-15.379,8.2088-3.5737-2.9216,2.8649-13.727-1.6841-12.958-6.7998,4.4958-10.753,15.658-20.242,14.764-3.6847-4.1359,2.236-11.144-1.8057-15.735-4.7711,6.1235-10.063,15.089-18.315,15.735-3.9884-3.2319,0.1571-12.501-2.3893-13.873-8.4677,5.0781-17.402,14.128-28.05,11.294,4.1497-15.873,21.49-21.442,36.072-22.68,25.089-3.0835,51.484,2.5863,75.624-6.469,3.9004-2.3734,13.35-5.7392,9.9847-11.244-2.9805-4.3463,7.7529-2.647,8.7855-7.7238-0.639-6.4302,4.9265-5.5452,10.364-6.108,24.376-1.0516,48.455,4.0818,72.758,4.9546,1.8358,11.842-11.301,20.157-21.876,16.5-5.0519,0.81828-12.627-11.615-11.142-2.5698-1.0183,4.7472-0.3056,11.017-4.6433,14.188m-207.4-24.248c5.6435,5.1653,9.6005-0.97254,14.875-3.2155,17.692-6.085,33.128-16.719,48.346-27.344,9.221-7.6305,17.214-17.525,29.597-20,24.155-7.303,49.832-6.4173,74.081-13.157,18.464-25.281,49.825-34.299,76.096-48.831,5.8991-1.8316,8.1781-6.6867,10.062-12.047,10.028-15.83,23.689-29.857,39.845-39.439,7.6441-4.1767,16.764-6.5825,25.418-4.6718-0.6201,10.307-6.5329,19.442-13.672,26.57,5.842-0.12861,10.863-3.8191,16.767-3.6114,2.0233,10.578-9.4007,16.114-15.478,22.7,3.3855,0.78754,16.353,1.7684,9.2865,5.1591-9.0054,6.2497-19.289,10.541-27.602,17.799,7.6694,1.3778,8.5436,3.0082,0.7445,5.782-4.2215,2.8617-12.341,3.8616-13.126,9.4374,5.7939,3.5608-2.6685,7.0964-5.933,8.2546-6.2414,1.4535-12.798,4.1652-4.5067,8.9071-3.1365,4.7384-9.8653,5.7486-15.356,5.2805,1.6661,5.3701,4.0776,11.378-2.8919,13.747-15.624,11.811-33.96,20.402-53.601,22.367,24.536,1.8866,49.807-2.668,70.773-16.011,2.768-3.2727,17.282-6.7896,9.1636-9.5419-3.822-1.5904-12.016-3.3567-12.57-6.2707,11.355-7.006,25.664-4.514,37.88-8.6758,0.3163-3.9551-9.2914-2.8547-12.874-3.7554-8.5427-0.69975-8.0417-2.8803,0.1954-3.6882,10.422-2.759,22.226-3.3028,30.993-10.098-7.1383-3.3066-16.116-0.39512-23.732-3.0955,12.911-5.6498,28.142-6.2167,39.726-14.704,5.2763-5.871-6.7598-4.0356-10.267-3.8931-7.1509,1.2447-10.456-2.1779-2.3324-5.1489,13.871-10.227,31.433-16.871,41.176-31.697,2.3078-3.3186,5.4328-13.319-1.9277-9.7216-9.681,3.2185-18.198,14.101-29.228,10.735,21.733-16.844,42.413-36.02,57.267-59.33,0.7674-6.7232-9.7852-7.4509-12.532-2.172-13.963,13.454-26.6,29.335-44.477,37.77,17.121-16.525,31.276-36.092,43.626-56.372,2.6476-6.0321,9.7642-13.286,5.9021-19.983-6.2255-5.1532-14.013-0.43606-17.248,5.7304-10.854,14.169-19.096,30.708-33.054,42.25,12.219-23.322,24.871-48.148,25.179-75.047-0.037-5.5382-1.1493-13.694-8.6693-12.659-5.9622,1.0681-4.5464,9.9912-7.0042,14.504-5.4111,18.377-7.9508,38.279-19.05,54.371,2.4971-14.934,6.8661-30.5,3.512-45.58-1.5667-6.7396-12.45-3.8412-11.048,2.8288-13.002,65.86-57.194,123.46-114.99,156.78-26.464,14.973-56.023,24.626-86.096,29.002-8.0899,1.7718-16.839,0.73198-24.572,3.4906-18.736,14.367-30.079,38.407-53.802,45.935-10.632,5.2835-24.496,6.3556-32.098,16.233-0.658,1.2632-0.7991,2.7266-0.7739,4.1273'/%3E %3Cpath d='m1075.8,654.95c-3.5006,6.354-5.5592,13.658-10.06,19.347-13.541-12.321-33.171-11.914-50.347-12.734-14.177-0.75657-29.594-2.0646-40.563-12.176-11.539-9.452-20.958-21.724-33.852-29.393-11.769-3.2001-23.633-7.2042-33.095-15.271-20.22-16.482-31.8-40.937-51.558-57.933-3.7669-3.7078-8.209-6.5812-12.429-9.7268-4.0096,0.97695-2.1955,9.6311-7.1022,5.2194-2.6694-1.8995-9.348-2.0844-9.9492,0.56937,6.0404,7.96,12.087,17.049,12.924,27.23-4.1198,0.4224-11.445-0.87064-13.487,0.66378,5.4715,8.2003,12.484,15.473,20.452,21.263-3.8217,0.61454-11.353,0.27988-12.818,1.8198,7.9092,6.4462,16.391,13.034,26.747,14.69,2.12,2.7948-3.099,8.1901,1.2898,10.576,2.5458,1.0399,10.945,2.7801,5.1592,5.6751-3.9705,2.6755-2.4971,8.9111,2.5797,8.7706,3.2101,1.6391,10.418,2.0412,10.982,4.879-2.8453,2.8956-11.698,6.3288-4.1637,9.0409,7.039,3.904,15.067,6.4384,23.105,6.7168-4.0336,3.3936-9.004,5.3206-13.156,8.5127,18.55,10.877,39.113,18.03,59.433,24.919,8.0909,2.7031,16.274,5.2237,24.661,6.8102-24.369-1.4066-47.922-8.6212-70.116-18.495-11.503-5.0452-23.084-9.9197-34.873-14.265,5.1692-2.6897,11.148-3.3471,16.509-5.6751-11.128-2.2291-23.285-2.9605-33.067-9.0768,1.4997-2.6758,7.1829-2.8021,10.326-4.1642,5.9114-1.416,9.5779-3.1339,1.2438-3.6475-8.4057-2.2812-18.045-1.2576-25.452-6.3278,0.4769-3.04,8.2283-1.9813,11.386-3.2934,3.9751-0.683,8.3958-1.2548,11.573-3.9294-12.994-5.388-29.99-1.5707-40.168-13.046-2.3476-4.3712,7.2884-0.85006,10.033-1.5782,6.9723,0.00003,14.467,2.2158,21.107-0.59559-18.934-8.3124-39.215-16.095-53.655-31.471-1.6039-2.4716-6.4071-9.2249-2.5317-10.06,11.239,1.4869,19.374,13.753,31.396,11.844,1.5973-2.1526-6.9835-5.6809-9.1254-8.7582-17.528-15.041-34.541-31.364-46.825-51.066-0.84492-6.5792,9.4971-7.565,12.22-2.4832,13.405,12.911,25.514,27.977,42.209,36.791,5.9247,2.8724-3.4012-3.4-4.6433-5.6751-15.427-17.914-30.113-36.834-40.895-57.932-1.9299-3.8028-5.1284-10.686,0.64643-12.71,5.7722-2.8919,11.501,1.0476,14.428,6.0066,11.342,14.305,19.688,31.307,33.817,43.225-12.037-23.359-24.889-47.948-25.2-74.828,0.28226-5.2109,0.61728-13.092,7.6832-12.878,5.9331-0.89942,4.9962,6.696,6.941,10.318,5.845,19.747,8.3946,41.121,20.121,58.556-2.5904-14.649-6.4022-29.735-3.8694-44.627,0.58422-4.8898,6.0884-6.37,9.6818-3.4138,2.9046,7.11,3.5106,15.889,6.1574,23.491,15.06,51.519,48.875,96.832,92.941,127.24,36.292,24.891,79.362,39.749,123.32,42.341,3.9698,0.346,7.9556,0.46548,11.932,0.70954'/%3E %3Ccircle cx='1020' cy='720.887' r='2.367'/%3E %3Ccircle cx='1019.8' cy='720.507' r='0.965' stroke='%2300afca' stroke-width='0.38127393'/%3E %3C/g%3E %3Cg id='ornament' fill='%23fec50c'%3E %3Cg id='oh'%3E %3Cg id='oq'%3E %3Cpath d='m120,72.922s-9.6109-8.0762-12.874-4.0253c-5.2494,6.5154,16.14,38.968,16.14,50.396,0,18.759-12.517,23.861-27.973,26.539-10.371,1.7981-27.259-0.752-27.259-0.752,3.1796-4.2726,5.2478-5.5316,10.606-5.8731-5.9648-3.0968-12.039-9.8188-12.039-20.284,0-16.138,6.6434-22.789,6.6434-40.983,0-10.093-8.2759-22.941-8.2759-22.941,14.628,1.464,21.878,15.009,17.753,25.834,2.3286,0.33542,4.4428-0.18873,6.2586-1.9094,1.0706,3.0005-0.61945,6.4832-2.8834,9.4837,1.8233,0.97432,3.1624,0.39003,6.0661-0.20942-0.27536,3.0915-2.1278,6.3758-6.6597,9.4671,13.151-3.4144,21.243,5.7517,21.243,15.347,0,7.248-5.0791,12.443-10.044,12.443-1.6044,0-3.9611-0.66078-5.2908-1.6532-0.93725,1.9948-0.45429,4.6646,0.51121,6.6596-3.6388-0.96187-5.9484-3.1229-4.3043-7.6212-2.7948-0.25675-5.0181-1.2011-6.5305-3.0005,1.5323-1.9624,3.8568-3.0927,6.5305-3.0005-2.035-4.1994,0.23284-6.5505,3.5373-8.456,0,0-2.1015,8.4558,3.2654,8.4558,2.4133,0,4.6122-0.78561,4.6122-4.3421,0-3.097-2.7075-7.387-8.9659-7.1142-6.2586,0.27277-11.332,4.3152-11.332,14.306,0,9.2162,7.4334,13.8,17.229,14.096,8.8338,0.27277,15.501-4.5126,15.501-13.625,0-12.128-17.508-39.773-17.508-50.581,0-8.109,7.2922-12.635,14.427-12.635,9.2518,0,17.058,9.1612,17.058,9.1612l-5.4352,6.8146z'/%3E %3Cpath id='op' d='m122.02,292.14c0,20.27-18.198,30.688-32.498,30.688-19.266,0-29.524-11.519-29.524-26.598,0-8.5475,1.5661-13.911,5.5074-22.092,0,0,31.78-66.091,44.153-91.653,1.543-3.1882,2.0408-6.8175,2.0408-12.138,0-8.2171-7.97-14.933-16.327-15.139-7.618-0.19053-15.918,7.1022-15.918,15.412,0,10.093,5.2358,14.593,10.612,14.593,6.6157,0,9.2518-2.7198,9.2518-7.3649,0-3.2366-1.5632-4.6371-3.8095-4.6371-5.6744,0-4.0817,7.6376-4.0817,7.6376-2.8183-0.617-5.1335-3.4965-3.8095-7.0921-2.0617-0.45904-3.9929-1.5413-5.5102-3.2733,1.5211-1.4747,3.266-2.6132,5.5102-3.0005-1.3289-4.3872,0.44687-6.5308,4.2857-7.433-0.77466,1.6876-0.80131,3.2401-0.54421,4.7054,6.0436-1.7186,15.306,1.0163,15.306,11.456,0,10.365-7.1935,19.093-20.681,16.912,3.2087,1.5341,4.8407,4.6732,5.1701,8.1832-2.4491-0.9547-5.1701-1.0911-5.1701-1.0911,1.577,2.7808,3.7672,5.1776,3.6734,10.638-2.5006-1.1368-4.8227-3.2419-8.0272-1.9094,5.0294,9.8968-1.1497,23.511-16.871,26.732,5.7537-6.7443,8.5714-14.027,8.5714-21.277,0-23.496-6.5305-27.445-6.5305-43.78,0-6.8343,3.5133-14.215,10.476-19.231v0.27276c-4.6021-1.2324-7.5502-3.4985-9.2447-6.5775,10.515-2.9816,25.799-2.9269,34.006,0.30202,9.434,1.0925,16.019,8.3308,17.959,12.004,1.9406,3.6708,5.7096,16.953,0,28.912-6.2487,13.088-35.711,75.559-44.897,95.198-1.9484,4.1654-3.1293,8.5827-3.1293,13.366,0,12.03,11.02,16.23,17.279,16.23,7.4829,0,15.102-5.7008,15.102-12.82,0-4.5112-2.4491-7.2285-5.9864-7.2285-8.4587,0-7.9449,7.1957-6.2586,11.729-5.2643-2.3667-8.3243-6.5917-7.4829-11.047-2.9805-0.40822-5.8174-1.822-8.4353-4.7735,2.0598-2.601,4.5722-4.5671,8.4353-4.6371-1.6873-6.9119,2.9406-9.8352,7.4829-11.456-1.437,5.0729-2.3803,10.911,6.2586,10.911,6.2986,0,11.258,1.0911,14.15,5.1827,0.17007-5.4553,0.68027-27.005,0.68027-27.005,0.36281-8.0977-10.839-7.8662-17.959-5.4554,2.6871-9.3276,8.1979-14.371,20.952-13.093-3.0953-1.2957-6.3946-4.2084-6.3946-9.8198,0.002-7.593,6.1621-16.005,10.206-18.492l2.022,79.051z'/%3E %3Cuse xlink:href='%23op' transform='matrix(1,0,0,-1,0,645.08)'/%3E %3C/g%3E %3Cuse xlink:href='%23oq' transform='matrix(-1,0,0,1,240,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23oh' transform='matrix(1,0,0,-1,0,1000)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400'%3E %3Crect fill='%23ce1126' width='600' height='400'/%3E %3Crect fill='%23002868' y='100' width='600' height='200'/%3E %3Ccircle fill='%23fff' cx='300' cy='200' r='80'/%3E %3C/svg%3E"

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Crect fill='%23ed1c24' width='750' height='500'/%3E %3Crect fill='%23fff' y='125' width='750' height='250'/%3E %3Cpath fill='%2300a651' d='M 371.5894,125 C 366.22315,136.2997 356.11736,144.19789 346.45832,151.67157 C 344.86925,153.05938 340.91845,155.74726 343.78458,157.79271 C 346.24017,155.04836 352.97951,158.68259 349.06268,161.63346 C 345.55402,164.9176 340.72308,166.12 336.82746,168.82984 C 333.37726,170.7043 329.87796,172.66173 327.14196,175.53105 C 326.95559,180.0135 332.70358,177.53219 335.03612,179.3996 C 338.07363,182.64705 333.74816,188.12133 329.76182,186.86927 C 324.66471,187.02546 321.14438,191.51029 319.21689,195.78908 C 315.22977,201.95458 307.67448,203.78032 301.65953,207.28899 C 298.21778,209.29528 294.87854,211.51505 291.6746,213.85608 C 287.54383,216.68042 291.13754,222.27234 295.53278,220.89972 C 300.27728,220.4267 304.54592,216.69896 309.45786,217.77316 C 313.91254,219.33833 315.16278,225.16012 313.64459,229.22483 C 312.52055,232.47922 309.79569,234.77154 307.6125,237.31372 C 304.06844,240.90414 299.43359,243.23508 294.54641,244.34656 C 289.82305,245.93241 285.57789,248.826 282.47971,252.73228 C 278.88376,256.35224 275.30219,260.03085 271.1692,263.04934 C 269.86365,266.38067 273.54807,269.21835 276.6199,269.12991 C 283.09222,268.72234 287.57797,263.42506 293.09028,260.70292 C 297.66461,258.64703 303.04806,263.57727 301.92906,268.34281 C 301.57508,272.97905 297.23424,275.33164 293.37475,276.75816 C 282.02885,282.4619 272.1777,290.73284 263.43076,299.85875 C 261.62169,303.54889 256.64826,302.46257 253.97025,305.03499 C 252.22562,308.29039 256.60402,310.00685 259.21608,309.67223 C 270.44112,308.32214 280.91539,303.57761 290.83812,298.3575 C 294.52819,296.59322 297.99323,294.27138 301.82962,292.86533 C 305.43319,291.97509 310.45809,293.54159 311.10283,297.64287 C 311.09773,301.97233 306.80857,304.37035 303.4117,306.06172 C 292.93651,311.56524 281.44052,314.60765 270.24434,318.24607 C 266.05289,317.07424 262.89523,324.53141 267.49329,325.87225 C 272.3554,327.53952 277.52429,326.20279 282.49779,325.98426 C 297.87642,323.62817 311.32634,315.30653 325.70163,309.9273 C 331.67794,307.97923 338.73226,310.6978 341.68165,316.29776 C 344.64481,321.28931 344.37398,327.85334 341.24819,332.70293 C 336.30834,343.27146 328.79833,352.98464 318.7165,359.0613 C 312.38812,362.19434 305.00126,363.39297 299.57757,368.18972 C 294.56146,369.8432 302.09226,376.62136 303.18084,371.24168 C 306.19505,367.13063 311.51128,365.90189 316.33356,365.73205 C 323.58078,364.94312 331.27713,363.60631 336.9083,358.58922 C 341.95671,354.66896 346.93162,349.26076 353.78678,349.17636 C 357.57531,349.62563 361.32238,352.66984 365.17025,350.81231 C 368.53626,349.27162 373.81755,350.17444 374.69678,354.31369 C 376.30415,359.15581 381.29505,361.35894 385.25295,363.95016 C 386.68557,365.96192 391.44596,371.15043 392.54374,366.57601 C 391.65792,363.31338 392.92361,358.32091 397.20351,359.41116 C 400.94191,359.57808 404.50446,360.95653 408.23564,361.18262 C 413.20452,362.21183 417.34927,365.6135 420.17071,369.72085 C 422.11167,372.40126 426.36333,377.00677 429.52222,373.45251 C 431.48249,369.77666 427.74062,366.71103 424.69446,365.39845 C 420.25243,362.64573 416.45462,358.97987 412.57076,355.50887 C 406.84653,350.16275 401.90235,343.36292 400.99374,335.37635 C 399.76199,327.41308 400.4102,319.29095 401.44945,311.34932 C 402.75741,306.23638 409.29554,303.44506 413.86725,306.16167 C 420.30003,309.09681 426.68843,313.29666 434.06328,312.84127 C 444.72,313.07089 455.67072,311.03044 466.08536,314.11859 C 476.21984,317.31095 483.46556,325.86344 493.33765,329.56419 C 495.54761,330.90725 498.37484,329.62908 499.18462,327.26866 C 500.16303,325.1476 499.47268,322.43378 497.42896,321.22499 C 485.98778,309.67613 470.35146,304.06569 457.11353,295.04126 C 452.94587,293.98288 452.18706,287.27769 456.03973,285.34185 C 461.10528,281.66065 468.2721,283.37428 472.76607,287.16972 C 476.56118,289.39278 480.8368,291.05827 485.2894,291.06224 C 489.85029,289.63448 487.63912,283.03469 483.55544,282.53841 C 476.15622,278.36058 470.8569,271.50481 464.44632,266.0718 C 460.75559,262.94683 456.716,259.78287 451.7557,259.17634 C 449.04451,258.68263 446.27094,258.57459 443.52394,258.75896 C 440.9476,255.95914 444.38123,251.67208 447.71241,252.02262 C 451.1308,252.25288 454.52965,252.50697 457.94359,252.03127 C 461.75876,251.75176 465.57064,251.35683 469.39939,251.33063 C 472.48995,253.43534 478.66583,249.7996 475.87651,246.17083 C 472.82951,243.50085 468.42334,243.73277 464.78211,242.36257 C 458.38547,240.26395 451.87572,238.56782 445.28454,237.23756 C 440.67325,236.9626 441.242,230.89376 445.29497,230.22441 C 447.94739,229.23496 450.25279,231.27278 452.79892,231.5887 C 457.14735,232.52313 461.63683,232.51113 465.9831,233.45849 C 469.66816,231.63935 466.81948,226.2555 463.48593,225.94179 C 455.62045,223.12924 448.82304,218.05295 442.17788,213.11487 C 434.84116,207.59721 428.18494,201.21633 420.75826,195.82617 C 418.06357,194.15628 413.64683,193.67534 412.93795,189.97462 C 412.68795,186.57015 416.69529,185.01965 419.53592,185.81559 C 423.56634,187.00583 427.32195,189.07846 431.42972,190.09605 C 434.65252,190.64375 437.97545,191.59738 441.08179,191.19126 C 445.02496,188.71371 439.39058,187.13019 437.35122,186.27058 C 432.0938,183.43513 427.42242,179.65733 422.69107,176.0548 C 418.69278,172.64193 426.08234,171.13414 428.62427,172.44822 C 432.87417,174.22617 433.35847,168.03333 430.18167,166.47498 C 426.43855,164.88338 423.2196,162.24124 419.82552,159.93707 C 413.69304,155.57159 406.74727,152.1159 399.20847,151.156 C 390.75634,150.3067 382.86721,145.44628 378.38327,138.21818 C 375.60269,134.09908 373.56207,129.54384 371.5894,125 z M 343.8321,172.41771 C 348.18843,172.54695 347.51872,180.39793 343.22983,179.87413 C 339.06481,179.60609 339.31972,171.57429 343.8321,172.41771 z M 384.92234,176.64564 C 389.16127,175.88738 390.05889,183.62274 385.82379,183.98589 C 381.41121,184.77575 379.7758,176.15615 384.92234,176.64564 z M 372.88731,177.65384 C 377.18466,178.49924 376.42021,185.98556 372.08328,186.05098 C 368.91022,186.75752 365.49025,188.92314 362.28008,187.30008 C 359.66952,184.53908 363.44271,180.45635 366.35676,179.55883 C 368.59191,179.10829 370.64832,178.09344 372.88731,177.65384 z M 400.58563,177.68637 C 404.72688,179.19709 403.26629,186.50778 398.8981,186.41459 C 394.76724,186.96811 392.84357,180.07706 396.6956,178.44266 C 397.9426,178.00052 399.24903,177.62794 400.58563,177.68637 z M 353.8613,185.97958 C 356.90649,188.87754 355.10789,194.47009 351.35311,195.80715 C 348.64664,197.31266 344.95682,200.87381 342.00892,197.94369 C 340.40943,194.36455 344.42423,191.66946 346.78572,189.68283 C 348.89329,188.04409 351.21909,186.55653 353.8613,185.97958 z M 388.63905,202.14325 C 392.99893,204.2019 390.78574,212.05909 386.00062,211.57069 C 382.07061,210.57486 382.58371,203.83444 386.54227,203.29678 C 387.29055,203.01039 387.9769,202.58881 388.63905,202.14325 z M 374.80463,202.92376 C 378.88224,204.83283 375.76886,211.63754 371.6618,210.657 C 367.40345,210.15691 367.48196,202.67024 372.17815,203.34611 C 373.06305,203.30222 373.97688,203.27971 374.80463,202.92376 z M 404.62678,206.82647 C 409.096,205.43963 414.4766,210.04402 413.02612,214.71319 C 411.03543,218.33295 406.10946,218.79124 402.58121,217.43842 C 398.52983,217.23842 395.80478,211.1478 399.41404,208.56875 C 400.90756,207.44072 402.79022,206.97715 404.62678,206.82647 z M 338.611,207.99725 C 342.30631,205.98682 346.22984,212.02929 343.08717,214.69451 C 341.00551,217.75492 335.66012,219.00525 333.30317,215.60189 C 331.34505,212.27783 334.51104,206.69321 338.611,207.99725 z M 321.56135,210.85925 C 325.75319,211.43274 328.48457,215.24015 330.03376,218.86551 C 330.41193,223.28362 323.89286,225.70783 321.04899,222.49331 C 317.85114,220.48713 315.05191,216.36132 316.72839,212.53213 C 317.76131,211.0116 319.81909,210.38426 321.56135,210.85925 z M 423.56431,226.82777 C 428.11364,225.62888 431.41652,232.89939 427.51018,235.52953 C 423.93847,238.77373 416.99376,234.47573 418.85644,229.84687 C 419.78218,228.1308 421.63401,226.99026 423.56431,226.82777 z M 365.66037,235.121 C 369.47498,235.6068 368.2391,242.21814 364.71192,241.99623 C 360.92636,241.29454 361.79307,234.74813 365.66037,235.121 z M 346.3099,238.6334 C 349.42124,236.43197 353.434,241.80509 350.84595,244.3089 C 347.74396,246.49354 343.72032,241.20565 346.3099,238.6334 z M 377.07598,239.28385 C 380.68235,241.47514 382.82338,245.56095 383.27166,249.68389 C 381.54334,253.53578 374.86866,252.60724 374.11615,248.50531 C 372.79639,245.26124 374.01269,241.08758 377.07598,239.28385 z M 387.81313,245.65826 C 392.46055,244.49084 390.79279,254.20485 386.91238,250.83545 C 385.62285,249.30414 386.31349,246.78444 387.81313,245.65826 z M 320.38146,252.42293 C 323.45884,251.52156 327.94465,252.46899 328.7941,256.00085 C 329.15292,259.32013 325.5028,261.04696 322.8282,261.86956 C 318.54137,263.19231 314.34875,265.36394 309.73883,265.07221 C 306.28351,263.09729 305.04323,259.05585 303.81128,255.53103 C 307.14601,252.40445 312.05643,253.32163 316.19018,252.53906 C 317.58613,252.4675 318.98379,252.43346 320.38146,252.42293 z M 424.98018,267.64343 C 428.90575,265.71883 433.12728,271.9498 429.84137,274.86023 C 425.73054,279.59171 417.81599,280.47093 412.90065,276.49605 C 412.30974,272.3088 416.49236,269.26764 420.20768,268.66669 C 421.77056,268.22519 423.32385,267.56559 424.98018,267.64343 z M 447.04443,272.42422 C 451.50464,271.6566 455.01805,278.01951 451.83272,281.3126 C 448.81821,285.85801 441.62942,287.05014 437.51912,283.32422 C 435.91659,279.55585 439.16741,275.62934 442.62728,274.42031 C 444.11438,273.78742 445.52241,272.97626 447.04443,272.42422 z M 336.10372,279.1889 C 340.23431,278.78128 344.01843,282.87955 343.47633,286.95187 C 346.46651,289.89444 341.17144,295.37643 338.19238,292.32933 C 335.56714,289.14836 335.58095,284.83298 334.56407,281.02604 C 334.51857,280.18042 335.14459,279.08508 336.10372,279.1889 z M 367.81369,281.56305 C 372.08402,279.7168 377.60876,284.82551 375.28387,289.15052 C 373.6236,292.67309 367.14833,291.4924 367.3635,287.41217 C 367.35245,285.46035 367.19489,283.45856 367.81369,281.56305 z M 352.38642,284.32743 C 356.66836,283.34572 360.59695,288.89644 358.21743,292.60021 C 353.94846,292.97974 351.73219,287.9133 352.38642,284.32743 z'/%3E %3C/svg%3E"

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 600 300'%3E %3Crect fill='%236Cf' width='600' height='300'/%3E %3Cpolygon fill='%23FFF' points='200,274 300,260 400,274 300,27'/%3E %3Cpolygon points='213.5,274 300,260 386.5,274 300,60'/%3E %3Cpolygon fill='%23FCD116' points='200,274 400,274 300,150'/%3E %3C/svg%3E"

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' width='1000' height='600'%3E %3Crect width='1000' height='600' fill='%23002b7f'/%3E %3Crect y='300' width='1000' height='300' fill='%23ce1126'/%3E %3Cg fill='%23ffd83d' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E %3Cg id='half'%3E %3Cpath d='M 216.37706,122.2886 L 214.53882,184.7886 L 151.1197,184.7886 C 143.31716,169.62032 136.87338,156.73735 136.87338,139.29228 C 136.87338,124.69269 148.35647,113.09742 164.90647,113.09742 C 182.42619,113.09742 201.67512,119.001 216.37706,122.2886 z' stroke='none'/%3E %3Cg stroke-width='1.5'%3E %3Cpath d='M 144.45611,125.16084 V 161.23621'/%3E %3Cpath d='M 149.54956,121.47933 V 169.51333'/%3E %3Cpath d='M 154.64301,118.95176 V 176.17693'/%3E %3Cpath d='M 159.73645,117.77081 V 162.65201'/%3E %3Cpath d='M 164.82989,117.54815 V 162.87466'/%3E %3Cpath d='M 169.92335,115.96463 V 162.84973'/%3E %3Cpath d='M 175.01679,115.96463 V 162.84973'/%3E %3Cpath d='M 180.11024,116.42419 V 163.30929'/%3E %3Cpath d='M 185.20367,116.88375 V 163.76885'/%3E %3Cpath d='M 190.29712,119.87088 V 166.75598'/%3E %3Cpath d='M 195.39057,120.33044 V 173.1898'/%3E %3Cpath d='M 200.48402,120.33044 V 167.21554'/%3E %3Cpath d='M 205.57747,120.33044 V 167.21554'/%3E %3Cpath d='M 176.39544,117.92279 C 187.15891,119.69824 210.80151,130.75993 208.105,145.72611 C 204.28366,166.93537 191.89725,158.42373 175.47632,155.37684 L 163.06823,159.51287 C 158.62839,164.04466 152.09048,168.19641 147.67301,162.72978 L 140.32007,162.72978 L 140.32007,191.4522 L 221.66198,191.4522 L 221.66198,122.05882 z' fill='%23000'/%3E %3C/g%3E %3Ccircle cx='212.81549' cy='112.98255' r='4.94026'/%3E %3Ccircle cx='201.713' cy='110.31052' r='4.94026'/%3E %3Ccircle cx='190.44973' cy='107.48178' r='4.94026'/%3E %3Ccircle cx='179.14295' cy='105.59596' r='4.94026'/%3E %3Ccircle cx='167.83617' cy='104.48071' r='4.94026'/%3E %3Ccircle cx='156.74931' cy='105.11261' r='4.94026'/%3E %3Ccircle cx='146.17946' cy='108.73163' r='4.94026'/%3E %3Ccircle cx='137.27551' cy='115.28035' r='4.94026'/%3E %3Ccircle cx='130.95657' cy='124.41408' r='4.94026'/%3E %3Ccircle cx='127.912' cy='135.15627' r='4.94026'/%3E %3Ccircle cx='128.02689' cy='146.30057' r='4.94026'/%3E %3Ccircle cx='130.15236' cy='157.21509' r='4.94026'/%3E %3Cpath d='M 214.99838,119.53125 L 214.53882,125.96507 C 202.24782,124.08194 184.82391,117.23346 168.58294,117.23346 C 153.57656,117.23346 141.92853,123.23616 141.92853,138.37316 C 141.92853,153.29163 148.24631,166.85838 156.63441,180.65257 L 147.90279,184.7886 C 140.10025,169.62032 133.65647,156.73735 133.65647,139.29228 C 133.65647,124.69269 145.13956,110.34007 164.90647,110.34007 C 182.42619,110.34007 200.29644,116.24365 214.99838,119.53125 z'/%3E %3C/g%3E %3Cuse xlink:href='%23half' transform='translate(443.9375) scale(-1,1)'/%3E %3Cpath d='M 221.96875,53.125 L 216.8125,62.78125 L 221.96875,72.40625 L 227.125,62.78125 L 221.96875,53.125 z M 221.96875,77.5 L 216.8125,87.125 L 221.96875,96.78125 L 227.125,87.125 L 221.96875,77.5 z'/%3E %3Cpath d='M 203.58731,74.953125 L 211.71883,80.109375 L 219.82403,74.953125 L 211.71883,69.796875 L 203.58731,74.953125 z M 224.11347,74.953125 L 232.21867,80.109375 L 240.35019,74.953125 L 232.21867,69.796875 L 224.11347,74.953125 z'/%3E %3Ccircle cx='221.96875' cy='75.06893' r='3.90625'/%3E %3Ccircle cx='221.96875' cy='100' r='10.45496'/%3E %3Cpath d='M 219.34375,89.875 C 219.34375,92.989438 219.32163,94.799139 219.3125,96.5 C 216.79207,96.611865 214.30676,96.876712 211.875,97.28125 M 232.0625,97.28125 C 229.63074,96.876712 227.14543,96.611865 224.625,96.5 C 224.625,94.801655 224.625,92.997132 224.625,89.875 M 211.84375,102.5625 C 215.13846,102.01215 218.51788,101.71875 221.96875,101.71875 C 225.41962,101.71875 228.79904,102.01215 232.09375,102.5625' fill='none' stroke-width='1.5'/%3E %3Cpath d='M 211.75,117.6875 C 210.75812,134.76968 208.74143,152.16667 202.09375,164.8125 L 212.90625,160.4375 C 216.68272,146.10873 217.47609,127.59492 218.625,118.84375 L 211.75,117.6875 z M 232.1875,117.6875 L 225.3125,118.84375 C 226.4614,127.59492 227.25478,146.10873 231.03125,160.4375 L 241.84375,164.8125 C 235.19607,152.16667 233.17938,134.76968 232.1875,117.6875 z'/%3E %3Cpath d='M 221.95313,154.6875 C 209.03974,154.6875 199.55398,160.77412 198.98438,176.28125 C 195.82773,170.72636 182.4742,153.25552 170.01563,155.59375 C 162.60576,156.98444 156.05854,167.25962 157.17188,179.03125 C 151.037,161.40135 133.06509,158.51225 119.95313,168.9375 C 131.59529,178.51001 136.77421,206.77225 146.57813,219.03125 L 221.95313,219.03125 L 297.32813,219.03125 C 307.13204,206.77225 312.34222,178.51001 323.98438,168.9375 C 310.87241,158.51225 292.90051,161.40135 286.76563,179.03125 C 287.87896,167.25962 281.3005,156.98444 273.89063,155.59375 C 261.43205,153.25552 248.10978,170.72636 244.95313,176.28125 C 244.38354,160.77412 234.86652,154.6875 221.95313,154.6875 z'/%3E %3Cg stroke-width='1.5'%3E %3Cpath d='M 297.10662,219.02573 C 297.10662,224.60663 263.44486,230.74447 221.96875,230.74447 C 180.49265,230.74447 146.83089,224.60663 146.83089,219.02573 C 146.83089,213.44487 180.49265,210.5239 221.96875,210.5239 C 263.44486,210.5239 297.10662,213.44487 297.10662,219.02573 z' fill='%23000'/%3E %3Ccircle cx='221.96875' cy='114.44459' r='3.50414'/%3E %3Ccircle cx='221.96875' cy='122.02731' r='3.73392'/%3E %3Ccircle cx='221.96875' cy='130.18447' r='4.07859'/%3E %3Ccircle cx='221.96875' cy='139.26075' r='4.65303'/%3E %3Ccircle cx='221.96875' cy='149.37105' r='5.11259'/%3E %3Cpath d='M 219.93751,159.20588 C 219.38456,159.19901 218.86165,159.6649 219.00001,160.54963 C 219.16297,161.59315 219.36706,163.54482 219.56251,164.86213 C 219.78339,166.35532 220.65373,165.99233 220.87501,164.83088 C 221.09631,163.66986 221.00709,162.925 221.06251,160.76838 C 221.09024,159.69029 220.49047,159.21276 219.93751,159.20588 z M 224.00001,159.20588 C 223.44705,159.21276 222.8473,159.69029 222.87501,160.76838 C 222.93043,162.925 222.84123,163.66986 223.06251,164.83088 C 223.28379,165.99233 224.15415,166.35532 224.37501,164.86213 C 224.57046,163.54482 224.77457,161.59315 224.93751,160.54963 C 225.07587,159.6649 224.55298,159.19901 224.00001,159.20588 z M 216.31251,159.76838 C 215.80668,159.83874 215.2822,160.34892 215.31251,160.89338 C 215.36753,161.88856 215.64291,163.0823 215.75001,164.58088 C 215.86046,166.12907 216.95166,165.52771 217.06251,164.64338 C 217.17296,163.75866 217.29793,162.45118 217.18751,160.73713 C 217.1461,160.09422 216.8653,159.8115 216.53126,159.76838 C 216.46168,159.75941 216.38477,159.75833 216.31251,159.76838 z M 227.40626,159.76838 C 227.07222,159.8115 226.79144,160.09422 226.75001,160.73713 C 226.63959,162.45118 226.76458,163.75866 226.87501,164.64338 C 226.98586,165.52771 228.07708,166.12907 228.18751,164.58088 C 228.29461,163.0823 228.57001,161.88856 228.62501,160.89338 C 228.65532,160.34892 228.13086,159.83874 227.62501,159.76838 C 227.55275,159.75833 227.47586,159.75941 227.40626,159.76838 z M 211.96876,161.51838 C 211.50567,161.63805 211.0804,162.19494 211.21876,162.83088 C 211.49507,164.10277 211.75001,165.50899 211.75001,166.79963 C 211.75002,167.90566 212.69459,167.511 212.75001,166.73713 C 212.80503,165.96284 212.90626,164.32364 212.90626,162.83088 C 212.90627,161.71632 212.43186,161.39872 211.96876,161.51838 z M 231.65626,161.51838 C 231.32747,161.60947 231.03126,161.99496 231.03126,162.83088 C 231.03126,164.32364 231.13251,165.96284 231.18751,166.73713 C 231.24293,167.511 232.18752,167.90566 232.18751,166.79963 C 232.18751,165.50899 232.44247,164.10277 232.71876,162.83088 C 232.85712,162.19494 232.43187,161.63805 231.96876,161.51838 C 231.85299,161.48846 231.76586,161.48802 231.65626,161.51838 z M 172.56251,161.68934 C 172.00845,161.67094 171.61973,162.42254 172.00001,163.25184 C 172.60804,164.57916 173.25407,165.41659 173.87501,166.84559 C 174.42803,168.11748 175.2763,167.32448 175.00001,166.43934 C 174.7233,165.55461 174.42308,164.56923 173.59376,162.68934 C 173.28263,161.98423 172.89495,161.70039 172.56251,161.68934 z M 271.37501,161.68934 C 271.04257,161.70039 270.65489,161.98423 270.34376,162.68934 C 269.51444,164.56923 269.21422,165.55461 268.93751,166.43934 C 268.66122,167.32448 269.50949,168.11748 270.06251,166.84559 C 270.68345,165.41659 271.32948,164.57916 271.93751,163.25184 C 272.31779,162.42254 271.92907,161.67094 271.37501,161.68934 z M 176.56251,161.75184 C 176.15469,161.8763 175.90747,162.39361 176.15626,163.00184 C 176.65427,164.21831 177.37284,165.46536 177.87501,166.78309 C 178.31718,167.94413 179.3009,167.61494 178.96876,166.56434 C 178.63704,165.51375 178.53846,164.89884 177.87501,162.90809 C 177.54309,161.91293 176.97034,161.62739 176.56251,161.75184 z M 267.06251,161.75184 C 266.71381,161.82629 266.31145,162.16172 266.06251,162.90809 C 265.39906,164.89884 265.30048,165.51375 264.96876,166.56434 C 264.63662,167.61494 265.62034,167.94413 266.06251,166.78309 C 266.56468,165.46536 267.28325,164.21831 267.78126,163.00184 C 268.03005,162.39361 267.78283,161.8763 267.37501,161.75184 C 267.27305,161.72073 267.17874,161.72702 267.06251,161.75184 z M 181.56251,162.72059 C 181.04838,162.81843 180.65026,163.60277 181.00001,164.56434 C 181.4426,165.78081 182.072,166.93202 182.62501,168.31434 C 183.17803,169.69667 184.0963,169.41781 183.87501,168.53309 C 183.65374,167.64836 183.38263,166.18221 182.71876,163.97059 C 182.42851,163.00283 181.9624,162.6445 181.56251,162.72059 z M 262.37501,162.72059 C 261.97512,162.6445 261.50901,163.00283 261.21876,163.97059 C 260.55489,166.18221 260.28378,167.64836 260.06251,168.53309 C 259.84122,169.41781 260.75949,169.69667 261.31251,168.31434 C 261.86552,166.93202 262.49492,165.78081 262.93751,164.56434 C 263.28726,163.60277 262.88914,162.81843 262.37501,162.72059 z M 169.18751,163.40809 C 168.63064,163.46496 168.12339,164.37333 168.46876,165.06434 C 169.0222,166.17037 169.37242,166.54665 169.90626,167.72059 C 170.45928,168.93706 171.06504,167.99489 170.84376,167.22059 C 170.62248,166.4463 170.33882,165.54493 170.06251,164.43934 C 169.85999,163.62937 169.52164,163.37397 169.18751,163.40809 z M 274.75001,163.40809 C 274.41588,163.37397 274.07753,163.62937 273.87501,164.43934 C 273.5987,165.54493 273.31504,166.4463 273.09376,167.22059 C 272.87248,167.99489 273.47824,168.93706 274.03126,167.72059 C 274.5651,166.54665 274.91532,166.17037 275.46876,165.06434 C 275.81413,164.37333 275.30688,163.46496 274.75001,163.40809 z M 207.71876,166.20588 C 207.13501,166.20536 206.51143,166.98024 206.71876,167.70588 C 207.05049,168.86734 207.56328,169.89687 207.93751,171.39338 C 208.26924,172.72029 209.21168,172.05937 209.15626,171.17463 C 209.10085,170.28991 208.94926,169.0862 208.56251,167.20588 C 208.41734,166.50092 208.06902,166.2062 207.71876,166.20588 z M 236.21876,166.20588 C 235.8685,166.2062 235.5202,166.50092 235.37501,167.20588 C 234.98826,169.0862 234.83669,170.28991 234.78126,171.17463 C 234.72584,172.05937 235.6683,172.72029 236.00001,171.39338 C 236.37424,169.89687 236.88705,168.86734 237.21876,167.70588 C 237.42609,166.98024 236.80253,166.20536 236.21876,166.20588 z M 221.96876,167.39338 C 221.24958,167.39339 221.15023,168.35899 221.12501,169.14338 C 221.04236,171.71466 219.97517,174.21192 219.06251,175.45588 C 218.15028,176.70025 216.80689,176.36933 215.56251,175.70588 C 214.31815,175.04245 213.5769,174.54522 212.25001,173.54963 C 210.9227,172.55448 209.91641,173.13633 211.50001,175.39338 C 216.11747,181.97369 221.12501,187.5982 221.12501,198.33088 C 221.12502,199.71862 221.36747,200.14338 221.96876,200.14338 C 222.57005,200.14338 222.84374,199.71862 222.84376,198.33088 C 222.84376,187.5982 227.82007,181.97369 232.43751,175.39338 C 234.02111,173.13633 233.01484,172.55448 231.68751,173.54963 C 230.36062,174.54522 229.61939,175.04245 228.37501,175.70588 C 227.13063,176.36933 225.78726,176.70025 224.87501,175.45588 C 223.96235,174.21192 222.89518,171.71466 222.81251,169.14338 C 222.78729,168.35899 222.68796,167.39339 221.96876,167.39338 z M 186.68751,165.78309 C 186.62459,165.78137 186.55597,165.79672 186.50001,165.81434 C 186.23143,165.89895 186.05249,166.22315 186.15626,166.78309 C 186.34172,167.78535 187.03621,169.7496 187.31251,170.68934 C 187.58924,171.62952 188.74506,171.42956 188.46876,170.15809 C 188.19206,168.88621 188.20674,168.50208 187.87501,167.06434 C 187.69361,166.27808 187.12805,165.79517 186.68751,165.78309 z M 257.25001,165.78309 C 256.80947,165.79517 256.24393,166.27808 256.06251,167.06434 C 255.73078,168.50208 255.74548,168.88621 255.46876,170.15809 C 255.19246,171.42956 256.3483,171.62952 256.62501,170.68934 C 256.90131,169.7496 257.5958,167.78535 257.78126,166.78309 C 257.88503,166.22315 257.70609,165.89895 257.43751,165.81434 C 257.38155,165.79672 257.31295,165.78137 257.25001,165.78309 z M 165.71876,166.18934 C 165.13997,166.23465 164.72491,166.96181 165.31251,168.03309 C 165.94637,169.18996 167.03368,170.64128 167.53126,171.47059 C 168.02886,172.29991 168.88969,171.74036 168.28126,170.68934 C 167.67324,169.63877 167.46889,168.4321 166.75001,166.93934 C 166.48045,166.37941 166.06604,166.16216 165.71876,166.18934 z M 278.21876,166.18934 C 277.87148,166.16216 277.45707,166.37941 277.18751,166.93934 C 276.46863,168.4321 276.26428,169.63877 275.65626,170.68934 C 275.04783,171.74036 275.90866,172.29991 276.40626,171.47059 C 276.90384,170.64128 277.99115,169.18996 278.62501,168.03309 C 279.21261,166.96181 278.79755,166.23465 278.21876,166.18934 z M 134.03126,169.51838 C 133.36345,169.4829 133.15409,170.68863 133.78126,171.48713 C 134.69393,172.64817 135.32901,173.26405 136.37501,174.20588 C 137.20474,174.95227 137.44592,173.98351 137.03126,173.23713 C 136.61662,172.49076 136.01682,171.7315 135.18751,170.48713 C 134.73288,169.80512 134.33481,169.53451 134.03126,169.51838 z M 309.90626,169.51838 C 309.60271,169.53451 309.20464,169.80512 308.75001,170.48713 C 307.9207,171.7315 307.3209,172.49076 306.90626,173.23713 C 306.4916,173.98351 306.73278,174.95227 307.56251,174.20588 C 308.60851,173.26405 309.24359,172.64817 310.15626,171.48713 C 310.78343,170.68863 310.57407,169.4829 309.90626,169.51838 z M 139.06251,170.51838 C 138.53029,170.52532 138.17911,170.91843 138.59376,171.83088 C 139.18763,173.13695 139.97076,174.61654 140.46876,175.61213 C 140.96636,176.60732 142.48303,176.94156 141.87501,175.39338 C 141.26659,173.84521 141.14677,173.04988 140.59376,171.61213 C 140.31726,170.89327 139.59474,170.51145 139.06251,170.51838 z M 304.87501,170.51838 C 304.34278,170.51145 303.62026,170.89327 303.34376,171.61213 C 302.79075,173.04988 302.67093,173.84521 302.06251,175.39338 C 301.45449,176.94156 302.97116,176.60732 303.46876,175.61213 C 303.96676,174.61654 304.74989,173.13695 305.34376,171.83088 C 305.75841,170.91843 305.40723,170.52532 304.87501,170.51838 z M 129.31251,170.86213 C 128.53874,170.87003 128.47208,171.6458 129.15626,172.14338 C 130.06892,172.80684 131.15649,173.54322 132.21876,174.39338 C 133.46273,175.38856 133.9447,174.4731 133.28126,173.64338 C 132.61782,172.81408 131.97153,171.9731 130.31251,171.14338 C 129.89776,170.93606 129.57043,170.8595 129.31251,170.86213 z M 314.62501,170.86213 C 314.36709,170.8595 314.03976,170.93606 313.62501,171.14338 C 311.96599,171.9731 311.3197,172.81408 310.65626,173.64338 C 309.99282,174.4731 310.47479,175.38856 311.71876,174.39338 C 312.78103,173.54322 313.86859,172.80684 314.78126,172.14338 C 315.46544,171.6458 315.39877,170.87003 314.62501,170.86213 z M 204.96876,171.58088 C 204.5358,171.64145 204.16235,172.13322 204.34376,172.76838 C 204.67549,173.92942 205.05205,175.15983 205.28126,176.36213 C 205.50256,177.52359 206.8463,177.53773 206.62501,176.48713 C 206.40415,175.43655 206.29299,174.12199 205.90626,172.51838 C 205.76109,171.91704 205.45795,171.62817 205.15626,171.58088 C 205.09342,171.57104 205.03061,171.57223 204.96876,171.58088 z M 238.78126,171.58088 C 238.47957,171.62817 238.17645,171.91704 238.03126,172.51838 C 237.64453,174.12199 237.53339,175.43655 237.31251,176.48713 C 237.09122,177.53773 238.43498,177.52359 238.65626,176.36213 C 238.88547,175.15983 239.26205,173.92942 239.59376,172.76838 C 239.77517,172.13322 239.40174,171.64145 238.96876,171.58088 C 238.90691,171.57223 238.84412,171.57104 238.78126,171.58088 z M 174.87501,169.59559 C 174.53504,169.68956 174.33942,170.33955 174.59376,171.25184 C 176.004,176.31148 176.4363,178.97621 176.18751,180.22059 C 175.93873,181.46457 175.256,181.63524 174.34376,181.22059 C 173.43153,180.80594 172.36056,180.20736 171.53126,179.62684 C 170.70196,179.04592 169.83939,179.74084 171.03126,180.72059 C 177.08606,185.69729 181.28306,191.38482 182.90626,198.28309 C 183.238,199.69294 184.12381,199.85878 183.87501,198.28309 C 182.5027,189.59329 182.23882,182.44969 184.31251,177.97059 C 185.09182,176.28738 184.30689,174.67095 183.06251,177.40809 C 182.23321,179.23301 180.89102,179.95295 179.81251,178.37684 C 178.7344,176.80116 176.5072,172.59717 175.84376,170.68934 C 175.59482,169.97391 175.28778,169.64292 175.03126,169.59559 C 174.97783,169.58574 174.92358,169.58217 174.87501,169.59559 z M 268.90626,169.59559 C 268.64974,169.64292 268.3427,169.97391 268.09376,170.68934 C 267.43032,172.59717 265.20312,176.80116 264.12501,178.37684 C 263.0465,179.95295 261.70431,179.23301 260.87501,177.40809 C 259.63063,174.67095 258.8457,176.28738 259.62501,177.97059 C 261.6987,182.44969 261.43482,189.59329 260.06251,198.28309 C 259.81371,199.85878 260.69952,199.69294 261.03126,198.28309 C 262.65446,191.38482 266.85146,185.69729 272.90626,180.72059 C 274.09813,179.74084 273.23556,179.04592 272.40626,179.62684 C 271.57696,180.20736 270.50599,180.80594 269.59376,181.22059 C 268.68152,181.63524 267.99879,181.46457 267.75001,180.22059 C 267.50122,178.97621 267.93352,176.31148 269.34376,171.25184 C 269.5981,170.33955 269.40248,169.68956 269.06251,169.59559 C 269.01394,169.58217 268.95969,169.58574 268.90626,169.59559 z M 144.43751,172.01838 C 143.89144,172.02532 143.43872,172.40782 143.68751,173.23713 C 144.08634,174.5657 144.91121,176.00157 145.18751,176.83088 C 145.46423,177.66021 146.35337,177.27317 146.18751,176.11213 C 146.02167,174.95111 145.94005,174.25902 145.71876,172.98713 C 145.60813,172.35141 144.98359,172.01145 144.43751,172.01838 z M 299.50001,172.01838 C 298.95393,172.01145 298.32939,172.35141 298.21876,172.98713 C 297.99747,174.25902 297.91585,174.95111 297.75001,176.11213 C 297.58415,177.27317 298.47329,177.66021 298.75001,176.83088 C 299.02631,176.00157 299.85118,174.5657 300.25001,173.23713 C 300.4988,172.40782 300.04608,172.02532 299.50001,172.01838 z M 163.21876,170.28309 C 162.58372,170.16913 162.49242,171.80734 163.03126,172.47059 C 163.75015,173.35576 164.74859,174.42538 165.75001,175.62684 C 166.57933,176.62244 167.09175,175.73741 166.59376,174.90809 C 166.09619,174.07837 165.35814,173.19678 164.03126,171.09559 C 163.69944,170.5703 163.43044,170.32108 163.21876,170.28309 z M 280.71876,170.28309 C 280.50708,170.32108 280.23808,170.5703 279.90626,171.09559 C 278.57938,173.19678 277.84133,174.07837 277.34376,174.90809 C 276.84577,175.73741 277.35819,176.62244 278.18751,175.62684 C 279.18893,174.42538 280.18737,173.35576 280.90626,172.47059 C 281.4451,171.80734 281.3538,170.16913 280.71876,170.28309 z M 148.71876,174.23713 C 148.32474,174.20948 147.9904,174.52908 148.15626,175.33088 C 148.38756,176.44733 148.7233,177.37403 149.00001,178.42463 C 149.27633,179.47524 150.00001,179.29522 150.00001,178.29963 C 150.00002,177.30446 149.82212,176.19398 149.65626,175.14338 C 149.57334,174.61809 149.11279,174.26479 148.71876,174.23713 z M 295.21876,174.23713 C 294.82473,174.26479 294.36418,174.61809 294.28126,175.14338 C 294.1154,176.19398 293.9375,177.30446 293.93751,178.29963 C 293.93751,179.29522 294.66119,179.47524 294.93751,178.42463 C 295.21422,177.37403 295.54996,176.44733 295.78126,175.33088 C 295.94712,174.52908 295.61278,174.20948 295.21876,174.23713 z M 161.81251,175.65809 C 161.19365,175.75159 160.6491,176.34985 161.37501,177.28309 C 162.53607,178.77584 163.80743,179.82383 164.25001,180.37684 C 164.69218,180.92987 165.81263,180.72579 165.09376,179.56434 C 164.35906,178.37789 163.2476,176.94908 162.75001,176.06434 C 162.56343,175.73257 162.18383,175.602 161.81251,175.65809 z M 281.87501,175.65809 C 281.60285,175.6867 281.32745,175.81551 281.18751,176.06434 C 280.68992,176.94908 279.57846,178.37789 278.84376,179.56434 C 278.12489,180.72579 279.24534,180.92987 279.68751,180.37684 C 280.13009,179.82383 281.40145,178.77584 282.56251,177.28309 C 283.28842,176.34985 282.74387,175.75159 282.12501,175.65809 C 282.03218,175.64407 281.96573,175.64855 281.87501,175.65809 z M 141.15626,179.83088 C 140.668,179.78654 140.49938,180.18047 141.15626,181.08088 C 142.64903,183.12666 144.29582,186.22273 144.40626,187.54963 C 144.51713,188.87695 143.86095,188.86213 143.25001,188.86213 C 141.42512,188.86215 140.53363,187.53012 138.87501,187.14338 C 137.21599,186.75625 136.97522,187.62865 138.15626,188.48713 C 144.23856,192.91082 150.33501,197.84636 152.78126,202.33088 C 153.77645,204.15578 155.12181,204.82284 154.37501,203.08088 C 152.08795,197.74371 151.53367,193.22426 152.03126,190.48713 C 152.52926,187.75001 153.20794,185.90698 153.12501,184.33088 C 153.0421,182.7552 152.1484,182.86271 151.78126,184.33088 C 151.53247,185.32648 151.05048,186.64538 150.71876,187.14338 C 150.38705,187.64099 149.05314,187.91993 147.78126,186.20588 C 146.50937,184.49186 143.30061,181.19144 142.25001,180.36213 C 141.85605,180.05115 141.44922,179.85749 141.15626,179.83088 z M 302.78126,179.83088 C 302.4883,179.85749 302.08147,180.05115 301.68751,180.36213 C 300.63691,181.19144 297.42815,184.49186 296.15626,186.20588 C 294.88438,187.91993 293.55047,187.64099 293.21876,187.14338 C 292.88704,186.64538 292.40505,185.32648 292.15626,184.33088 C 291.78912,182.86271 290.89542,182.7552 290.81251,184.33088 C 290.72958,185.90698 291.40826,187.75001 291.90626,190.48713 C 292.40385,193.22426 291.84957,197.74371 289.56251,203.08088 C 288.81571,204.82284 290.16107,204.15578 291.15626,202.33088 C 293.60251,197.84636 299.69896,192.91082 305.78126,188.48713 C 306.9623,187.62865 306.72153,186.75625 305.06251,187.14338 C 303.40389,187.53012 302.5124,188.86215 300.68751,188.86213 C 300.07657,188.86213 299.42039,188.87695 299.53126,187.54963 C 299.6417,186.22273 301.28849,183.12666 302.78126,181.08088 C 303.43814,180.18047 303.26952,179.78654 302.78126,179.83088 z' fill='%23000' stroke='none'/%3E %3Cpath d='M 150.12687,212.65106 152.07661,218.82525 M 154.13742,211.48082 155.86506,217.72081 M 158.46968,210.7684 159.65672,217.1334 M 162.48993,209.96408 163.7604,216.31295 M 167.64553,209.45517 168.67848,215.84698 M 173.13007,209.46186 174.24249,215.84031 M 178.48383,207.65149 179.28735,214.07616 M 183.52067,207.97645 184.32419,214.40112 M 188.39503,207.32654 189.19855,213.75121 M 193.28767,206.82164 193.72967,213.28125 M 198.51623,206.81977 198.89973,213.28312 M 203.25656,206.49325 203.58317,212.95973 M 208.48353,206.16701 208.75481,212.63605 M 214.49524,206.00453 214.76652,212.47357 M 293.81064,212.65106 291.8609,218.82525 M 289.80009,211.48082 288.07245,217.72081 M 285.46783,210.7684 284.28079,217.1334 M 281.44758,209.96408 280.17711,216.31295 M 276.29198,209.45517 275.25903,215.84698 M 270.80744,209.46186 269.69502,215.84031 M 265.45368,207.65149 264.65016,214.07616 M 260.41684,207.97645 259.61332,214.40112 M 255.54248,207.32654 254.73896,213.75121 M 250.64984,206.82164 250.20784,213.28125 M 245.42128,206.81977 245.03778,213.28312 M 240.68095,206.49325 240.35434,212.95973 M 235.45398,206.16701 235.1827,212.63605 M 229.44227,206.00453 229.17099,212.47357 M 221.96876,205.58364 221.96876,212.7068'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Crect width='1200' height='600' fill='%23ffb700'/%3E %3Cpath d='M50,300 215,50H380V550H215z' fill='%23ff5b00'/%3E %3Crect width='165' height='500' x='50' y='50' fill='%23005641'/%3E %3Crect width='725' height='500' x='430' y='50' fill='%238d2029'/%3E %3Cpath id='leaf' d='m1086.1,466.06s6.7982,13.841,14.309,19.48c11.128,8.3556,33.945,7.752,43.629,17.5,11.604,11.495-0.9004,26.682-0.7959,28l0.6363,8.0206s-7.8245,0.0943-11.119,0.60793c-4.9538,0.7724-6.886,4.8032-16.109,4.2045-23.189-1.5052-22.254-22.397-23.566-40.25-1.1646-6.7983-3.8594-15.662-5.3908-22.458-1.313-5.8277-1.5933-15.105-1.5933-15.105z' fill='%23ffb700' stroke='%23000' stroke-width='2.12575722'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(-1,0,0,1,1585,0)'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(1,0,0,-1,0,600)'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(-1,0,0,-1,1585,600)'/%3E %3Cuse xlink:href='%23lion' stroke='%23000' stroke-width='5.5598'/%3E %3Cg id='lion' fill='%23ffb700'%3E %3Cpath d='m681.54,479.56,4.3593-2.517,1.8649,2.5215c2.4846,3.3595,9.3595,3.3215,13.921-0.0773l3.4882-2.5985,2.9208,2.5985c3.8402,3.4168,11.012,3.4213,15.591,0.0122,3.206-2.3882,3.653-2.4362,5.7728-0.61944,1.2637,1.0831,4.9702,2.3162,8.2366,2.7402,5.8828,0.76367,5.9719,0.72173,9.4138-4.442,2.8826-4.3245,3.3335-6.0748,2.6456-10.269-0.45593-2.7807-0.9471-7.2562-1.0915-9.9454-0.26119-4.8694-0.23309-4.8997,6.8598-7.3695,3.9171-1.364,8.4514-3.1933,10.076-4.0653,2.8328-1.5202,10.643-10.699,10.643-12.508,0-0.47938-3.0511-1.2137-6.7801-1.632-14.833-1.6637-17.345-9.6288-7.7022-24.423,15.725-24.128,25.215-47.625,25.278-62.593,0.0285-6.6906,0.40945-8.937,1.2692-7.482,3.5135,5.9459-2.7808,30.877-12.316,48.78l-3.8392,7.2089,3.6635-0.84337c2.0149-0.46382,13.861-5.4619,26.325-11.107,34.115-15.451,45.833-18.479,67.911-17.549,18.497,0.77911,26.374,4.3927,39.434,18.09,6.9185,7.2565,13.583,12.449,25.775,20.08,25.975,16.259,27.058,17.667,28.293,36.788,1.2515,19.373,0.62869,20.424-14.024,23.661-12.524,2.7669-20.375,8.6054-22.481,16.717-1.1245,4.3318,1.242,4.4565,7.5561,0.39845l4.6275-2.9741,2.0576,2.9741c2.7051,3.91,8.455,3.9256,13.23,0.0356l3.6067-2.9381,3.6869,2.9381c5.7286,4.565,13.347,3.458,15.497-2.252,0.41335-1.0975,1.5164-0.74587,3.75,1.1953,4.1852,3.6374,14.914,5.1976,16.072,2.3376,0.44221-1.0912-0.3978-3.7862-1.8666-5.9887-6.2419-9.3596-8.1945-13.823-8.2758-18.918-0.11266-7.0863,2.0014-10.505,10.061-16.268,9.7908-7.0008,12.816-16.033,5.3706-16.033-4.5972,0-9.2317-4.0634-12.187-10.686-6.0079-13.461-4.8304-28.552,4.1866-53.657,9.1588-25.5,10.175-30.202,10.211-47.256,0.03-13.789-0.3175-16.174-3.4548-23.734-1.9182-4.6223-5.8102-11.505-8.6489-15.294l-5.1614-6.8903,6.6267-5.49c20.234-16.763,16.095-44.198-8.263-54.769-7.4516-3.2338-9.3134-3.5194-22.372-3.4316-7.8342,0.0527-19.78,1.0836-26.546,2.2911-6.8986,1.2311-18.575,2.2205-26.585,2.2526-12.725,0.0512-14.885-0.26249-19.789-2.8727-5.1132-2.7217-5.9899-4.0139-6.991-10.305-0.20575-1.2931-1.1099-2.5831-2.0089-2.8666-1.7392-0.54841-9.771,6.4223-10.958,9.51-0.58543,1.5235-1.0633,1.4182-2.7808-0.61319-1.1407-1.349-2.7333-4.4487-3.5393-6.8883-2.0267-6.1353,0.46204-10.735,7.6738-14.181l5.5952-2.6741-3.2993-2.0474c-6.8083-4.2248-18.385-1.3347-22.572,5.635-1.1843,1.9715-2.4761,3.5881-2.8706,3.5924-0.39444,0.003-2.6455-1.8765-5.0025-4.1795-8.7904-8.5893-5.7666-21.297,5.9908-25.177,6.2696-2.0689,11.818-0.49068,12.972,3.69,1.7624,6.3826,7.2409-2.0071,6.2584-9.584-0.6533-5.0374-0.55514-5.212,2.9305-5.212,4.8473,0,15.165,6.3619,18.356,11.319,3.7064,5.7573,3.4367,14.823-0.64203,21.58l-3.2027,5.3055,4.1894-0.83896c6.1434-1.2302,12.112-5.0453,15.131-9.6721,3.192-4.8914,3.5352-14.416,0.70469-19.555-2.7429-4.981-2.4284-5.7717,1.6267-4.0885,6.8969,2.8628,10.584,6.0201,13.35,11.431,2.4908,4.8729,2.6298,6.0838,1.2814,11.156-0.83198,3.1291-2.6831,7.246-4.1137,9.1486-2.2274,2.9626-2.3034,3.4593-0.52871,3.4593,3.3052,0,10.206-3.1281,12.658-5.7373,1.2383-1.3182,3.0437-4.564,4.012-7.2129l1.7607-4.8162,2.023,3.6712c2.8609,5.1912,8.4225,9.8627,15.204,12.77,7.293,3.1265,10.33,3.3027,6.5164,0.37792-2.5718-1.9723-7.3109-15.878-5.8747-17.238,0.84508-0.80031,10.747,6.8186,22.053,16.968,10.695,9.6009,17.415,12.746,27.238,12.746,12.548,0.00008,19.854-10.923,14.214-21.251-3.288-6.0216-10.613-6.8581-14.896-1.7011-1.9696,2.3714-2.5103,4.2577-1.9334,6.745,0.7066,3.047,0.4309,3.453-2.3451,3.453-3.6473,0-10.837-4.6664-23.606-15.321-19.471-16.248-43.13-30.02-60.214-35.05-10.963-3.2285-34.383-4.4883-45.528-2.4492-12.062,2.207-26.329,9.1099-34.101,16.499-13.772,13.094-13.991,30.518-0.58141,46.385l3.8411,4.5452-2.6005,4.0394c-3.7831,5.8765-3.4591,13.785,0.80339,19.61,1.8774,2.5656,3.7712,4.6637,4.2085,4.6623,0.43728-0.001,0.91679-1.6508,1.0654-3.6654,0.37644-5.0966,2.5638-8.5113,6.3183-9.8632,3.3816-1.2176,5.5676-0.64252,21.051,5.5376,16.289,6.5015,43.077,6.9484,71.561,1.1938,13.964-2.8211,30.43-2.6552,37.674,0.37962,13.279,5.5631,16.357,20.036,6.5955,31.022-4.2256,4.7559-8.3008,6.6927-21.983,10.448-10.412,2.8575-12.878,3.0472-36.543,2.8109-20.218-0.20184-27.484,0.18642-35.737,1.9096-8.9598,1.8707-14.471,2.0594-40.79,1.3961l-30.431-0.76685,3.3746,2.7943c1.856,1.5368,4.4782,3.4277,5.8271,4.202,2.2952,1.3174,2.2187,1.4944-1.1927,2.7593-2.0049,0.7434-6.4548,1.3516-9.8886,1.3516h-6.2432l-0.84015,5.3057c-0.46215,2.9182-0.42705,6.3252,0.0776,7.5711,0.74459,1.8377,0.46708,2.1016-1.4696,1.3977-1.313-0.47719-4.97-1.4158-8.1265-2.0857-3.1565-0.66995-7.4054-2.0342-9.442-3.0316-3.4248-1.6773-3.8054-1.6322-5.0669,0.60016-1.1264,1.9935-11.702,9.8644-13.254,9.8644-0.25046,0-0.57378-1.5176-0.71843-3.3725-0.14464-1.8549-1.6703-6.6837-3.3904-10.731-1.7202-4.047-3.5162-8.4619-3.9913-9.8109-0.71672-2.035-1.0412-2.1394-1.9056-0.61319-0.573,1.0118-1.4096,3.7711-1.8591,6.1318-0.44947,2.3607-2.043,6.1958-3.5412,8.5224l-2.724,4.2301-1.7374-3.617c-1.8651-3.8828-4.9615-7.9092-6.0825-7.9092-0.37837,0-1.0228,1.2417-1.432,2.7593-0.85453,3.1692-8.197,11.957-9.9903,11.957-0.66041,0-1.2007-2.4834-1.2007-5.5186s-0.5827-5.5186-1.2949-5.5186-1.2949,0.78545-1.2949,1.7454c0,2.3335-6.2706,9.2918-8.3736,9.2918-0.91771,0-2.394,0.82779-3.2807,1.8395-2.3118,2.638-4.2029,2.2678-3.231-0.63242,0.45568-1.3596,0.15939-4.5328-0.65846-7.0516-0.81788-2.5188-1.6875-5.1996-1.9325-5.9573-0.30871-0.95429-2.5558-0.70116-7.3116,0.82362-7.6852,2.4639-10.261,2.028-6.3087-1.0676,1.4449-1.1316,3.6425-5.0514,4.8838-8.7107,1.2412-3.6592,3.0726-6.9061,4.0698-7.2151,1.3963-0.43282,1.322,0.10204-0.32373,2.3272-1.1753,1.5891-2.1404,3.7321-2.1448,4.7624,0,1.0303-0.88884,3.473-1.9656,5.4282-1.0766,1.9552-1.7534,3.7483-1.5039,3.9845,0.24941,0.23626,3.1735-0.87452,6.4978-2.4684l6.0442-2.8979,0.0246,2.5925c0.0142,1.4259,0.74212,5.1875,1.6186,8.3592l1.5937,5.7666,4.1143-1.891c4.2049-1.9326,8.1874-8.8222,8.1874-14.164,0-2.6406,1.5126-2.2353,2.132,0.57128,0.18181,0.8236,1.1312,3.9147,2.1099,6.8692l1.7795,5.3717,2.817-3.3916c1.5494-1.8654,3.4917-5.5244,4.3163-8.131,1.4315-4.5251,3.6793-6.4706,3.6793-3.1845,0,2.368,6.4622,10.861,7.7088,10.131,0.60253-0.35262,1.8023-3.5401,2.6661-7.0833,1.7967-7.3686,4.6952-12.38,6.537-11.302,0.69252,0.40535,0.96225,1.192,0.59929,1.7482-0.36297,0.55613,1.1254,5.3468,3.3075,10.646,2.1821,5.2991,4.3732,10.634,4.8693,11.856,0.797,1.9632,1.5174,1.678,6.1947-2.4527,2.911-2.5708,5.5531-5.4487,5.8713-6.3953,0.48094-1.431,1.1303-1.3786,3.8524,0.31056,3.8067,2.3622,16.605,6.1683,17.593,5.2321,0.37021-0.35059,0.74975-3.7118,0.8435-7.4694l0.17042-6.8319,3.6804,0.76323c2.0242,0.41978,6.2805,0.39398,9.4584-0.0575l5.7779-0.82057-5.1492-3.5327c-2.8322-1.943-5.6958-4.4574-6.3636-5.5875-0.71142-1.204-3.232-2.2263-6.0873-2.469-7.7147-0.65558-21.388-8.3244-21.388-11.996,0-0.68925,1.8938,0.48271,4.2085,2.6043,5.1349,4.7067,12.269,7.6609,18.499,7.6609h4.6621l-2.884-3.8358c-1.6567-2.2034-3.1425-6.3832-3.4914-9.8218-0.55604-5.481-1.1346-6.3525-6.8578-10.331-3.4376-2.3899-7.6957-5.972-9.4622-7.9603l-3.2119-3.615-1.6387,4.2921c-0.90139,2.3607-2.003,4.2921-2.4479,4.2921-0.44494,0-2.1777-1.3797-3.8503-3.0659-1.6728-1.6862-3.3768-3.0596-3.7867-3.0518-0.4101,0.007-1.8919,2.2791-3.2929,5.0474l-2.5474,5.0333-1.9684-2.9012c-1.0827-1.5957-3.64-4.4189-5.6829-6.2738s-3.1174-3.3725-2.3877-3.3725c0.72956,0,3.251,1.9323,5.6033,4.294l4.2765,4.294,1.7405-3.146c1.0328-1.8669,1.4199-4.7346,0.95201-7.0533-0.68203-3.3797-0.5862-3.5761,0.70963-1.4546,0.82408,1.349,3.3259,3.9353,5.5597,5.7473l4.0616,3.2946,2.8028-5.1341c2.7895-5.1094,2.8091-5.1194,4.0782-2.0682,1.6972,4.0805,13.98,14.149,24.437,20.032,1.6118,0.9067,0.9322-2.2112-2.0444-9.3809-0.78834-1.8988-1.4333-5.3219-1.4333-7.607,0-3.39-0.97793-4.8988-5.3136-8.1981-6.2592-4.7632-8.2835-8.1504-9.463-15.835-0.47783-3.1128-1.5732-6.5749-2.4343-7.6935-1.2773-1.6596-1.4884-0.73081-1.1466,5.0465,0.23036,3.8942-0.27608,8.7359-1.1256,10.759l-1.5443,3.6791-1.1938-3.0659c-0.65653-1.6862-3.5605-4.6187-6.4535-6.5166-2.8929-1.8979-4.9233-3.7694-4.5119-4.1589,0.41126-0.38953,3.3874,1.3402,6.6134,3.8437,4.9147,3.814,5.9973,4.227,6.678,2.5471,0.79975-1.9739-0.001-10.562-1.5461-16.563-0.77113-2.9968-0.70366-2.9807,2.9932,0.71559,2.7266,2.7261,4.2342,5.9776,5.4023,11.65,1.4838,7.2068,2.2324,8.4066,8.8962,14.258,4.0018,3.5138,7.4844,6.1913,7.7391,5.9502,0.25458-0.24116,0.75961-9.3307,1.1222-20.199,0.69536-20.841-0.0906-25.8-5.1098-32.239l-2.5788-3.3085,4.054-4.3729c5.2886-5.7045,7.7168-10.277,8.7701-16.515l0.85683-5.0748-4.5751,4.3329c-3.7462,3.5479-5.5352,4.3329-9.8743,4.3329-4.2965,0-5.9749-0.72001-8.8702-3.8052-3.4739-3.7017-9.6295-7.2634-15.549-8.9969-2.1867-0.64031-2.9136-0.3614-2.9136,1.1179,0,1.0841-1.2079,4.2133-2.6842,6.9538l-2.6841,4.9828-5.6238-5.5587c-3.4497-3.4096-7.5436-6.0635-10.589-6.8644-7.7808-2.0462-8.2022-1.843-8.2022,3.954,0,8.7932-3.7543,10.431-10.511,4.5868-5.1508-4.4554-9.4235-5.4241-19.191-4.3505l-7.5435,0.82916,1.3573,3.4054c1.1337,2.8446,0.8782,4.0425-1.5508,7.2732-3.9398,5.2399-9.0624,7.5098-16.948,7.5098-3.6319,0-8.1768,0.75156-10.1,1.6701-1.9232,0.91856-6.7016,1.9768-10.619,2.3517-3.9171,0.37491-8.0922,1.044-9.2778,1.4869-1.8554,0.69306-2.059,0.12189-1.4614-4.098,0.91472-6.4581-3.5965-11.222-10.627-11.222-9.1217,0-13.329,8.1592-9.7568,18.922,0.68749,2.0714,1.5871,5.3381,1.999,7.2593,0.42746,1.9932,4.5362,7.2825,9.5688,12.318,4.8509,4.8537,9.4354,9.9041,10.188,11.223,0.75262,1.3191,3.2407,3.4359,5.529,4.704l4.1608,2.3058-0.5488-4.4519c-0.60318-4.8928,0.46295-5.6604,3.0662-2.2077,0.93053,1.2343,3.2945,3.2293,5.2531,4.4333,3.0853,1.8967,3.561,1.9353,3.561,0.28842,0-1.0454,0.62895-3.4543,1.3976-5.3531l1.3977-3.4523,2.4251,4.6972c1.3338,2.5835,5.6714,8.455,9.639,13.048,7.6986,8.9118,12.389,18.871,9.9683,21.163-0.98194,0.92988-3.6363,0.85791-9.1376-0.24774-4.2646-0.85709-9.5394-1.3101-11.722-1.0068-4.4571,0.61953-4.8082,0.0441-2.067-3.3881,2.8931-3.6226,2.4329-4.2201-3.2508-4.2201-6.5757,0-22.901-3.1522-29.168-5.6319-6.0934-2.4112-7.4993-1.8108-9.2928,3.9686-0.80725,2.601-2.2853,7.3142-3.2844,10.474l-1.8166,5.7444,6.5927-0.6349c3.626-0.3492,8.2897-1.1431,10.364-1.7642,2.0741-0.62112,3.9591-0.95122,4.1889-0.73356,0.22985,0.21769-0.6946,2.4623-2.0543,4.988l-2.4721,4.5922,4.1103-0.8379c2.2608-0.46085,5.662-1.5885,7.5584-2.5059,3.2998-1.5963,3.5648-1.4804,6.1676,2.6973,3.2006,5.1376,5.7611,4.9265,6.3292-0.52181,0.58738-5.6325,2.4401-4.7994,5.9255,2.6645,3.3515,7.1772,6.8385,9.7112,7.5085,5.4565,0.22232-1.4126,2.0278-3.7122,4.012-5.1101,4.0136-2.8276,7.0382-1.9792,8.7723,2.4603,1.795,4.5955-2.2084,9.3323-13.853,16.391-23.327,14.14-36.886,33.479-40.757,58.128-3.4915,22.233,7.4134,45.207,29.29,61.708,10.469,7.8966,27.1,16.231,26.043,13.051-4.4882-13.505-4.3404-39.274,0.2503-43.621,0.68891-0.65244,0.45194,2.0364-0.52663,5.9752-3.645,14.672-2.0615,26.363,7.282,53.763,8.4506,24.782,7.2809,35.373-4.6794,42.374-3.8414,2.2484-6.3146,2.6189-16.643,2.4936-11.207-0.13613-12.428,0.0895-16.026,2.9564-3.4881,2.7798-8.0108,11.906-8.0108,16.165,0,2.3072,2.562,2.0018,7.5966-0.90506z'/%3E %3Cpath d='m863.45,479.06,4.7011-3.0213,3.1903,3.0213c4.1796,3.9583,9.0759,3.8698,13.094-0.23669,1.7536-1.792,3.3283-3.0336,3.4993-2.7593,0.17093,0.27434,0.95293,1.6025,1.7376,2.9515,0.99334,1.7076,3.0357,2.5662,6.7222,2.8263,4.4417,0.31334,5.6344-0.1165,7.3993-2.6674l2.1038-3.041,4.6277,2.9741c12.669,8.1426,19.42-0.40017,13.758-17.411-2.879-8.6495-1.296-13.512,7.983-24.521,3.9128-4.6423,7.1176-9.5973,7.1215-11.011,0-2.2539-0.72386-2.5559-5.9314-2.4527-4.9834,0.0994-6.4413-0.43585-9.0644-3.3233-4.2665-4.6965-4.013-10.075,0.75623-16.044l3.81-4.7681-6.7596-4.5873c-3.7178-2.5231-10.422-8.4924-14.899-13.265-10.054-10.719-19.939-15.802-32.975-16.955l-8.7404-0.77298,0.0129,6.6158c0.0168,8.5168,4.0137,16.71,14.924,30.588,12.405,15.779,13.271,18.222,13.774,38.846l0.42473,17.442-3.5896,3.4057c-3.2436,3.0773-4.7062,3.47-15.173,4.0736-9.9645,0.57467-12.058,1.0888-14.982,3.6791-3.8836,3.4404-5.0449,5.3118-6.244,10.063-0.69887,2.7688-0.41568,3.3725,1.5825,3.3725,1.3386,0,4.5493-1.3597,7.1349-3.0214z'/%3E %3Cpath d='m596.82,433.98c1.1086-1.4991,2.0158-3.9198,2.0158-5.3794,0-2.2052,0.98543-2.7937,5.8314-3.4819l5.8314-0.82816-3.889-3.0993c-4.6204-3.6819-5.0478-6.5584-0.97546-6.5647,4.056,0,10.925-4.2118,11.969-7.3279,0.48536-1.4483,0.18013-3.3834-0.69044-4.3769-2.2738-2.5946-6.5486-2.2034-7.3427,0.67204-0.85348,3.091-2.2824,3.0992-5.5219,0.0306-4.8732-4.6153-4.9826-14.169-0.22595-19.732,2.2418-2.6218,2.2218-2.7938-0.6362-5.5005-3.0745-2.9118-5.2702-8.6748-3.826-10.043,0.45957-0.43524,2.8886-0.0884,5.3979,0.77114,3.5656,1.2211,4.9732,1.2396,6.4421,0.0846,4.4496-3.4973-0.37114-7.9944-7.5068-7.0025-2.8718,0.3992-4.0582,0-4.4706-1.4897-0.31195-1.1298-2.8238-2.605-5.6539-3.3204-5.0569-1.2784-5.0926-1.2628-5.0926,2.2213,0,3.8179-2.1794,4.5382-6.3206,2.0889-3.365-1.9903-6.6286-0.44518-6.6286,3.1383,0,3.3434,3.3623,4.9923,9.3882,4.604,4.6219-0.29789,4.7939,3.1391,0.40427,8.0796l-3.1567,3.5529,2.5008,3.5928c3.7037,5.321,3.3919,14.158-0.65433,18.547l-3.1721,3.4409-2.081-2.7593c-2.8919-3.8346-6.8476-3.5776-7.9323,0.51543-0.71028,2.6802-0.12315,3.905,3.2331,6.745,2.2555,1.9086,5.5485,3.4702,7.3178,3.4702,4.3784,0,4.2072,3.4433-0.34417,6.9217l-3.561,2.7216,5.5034,0.85366c3.0269,0.46958,5.5034,1.3529,5.5034,1.9628,0,2.339,3.8141,9.6148,5.0401,9.6148,0.70818,0,2.1948-1.2265,3.3034-2.7256z'/%3E %3Cpath d='m668.48,402.92c5.0001-1.9709,15.821-11.134,15.821-13.398,0-0.71202-2.9869-3.997-6.6374-7.3001-7.6824-6.9509-16.039-18.657-18.204-25.501-1.1289-3.5687-6.5843-9.6779-21.951-24.581l-20.448-19.832-5.8934,1.4927c-3.2414,0.82104-7.1962,1.5127-8.7885,1.537-2.7441,0.0417-2.6943,0.19928,0.95383,3.0226l3.8489,2.9786,5.3959-2.9948c5.2303-2.9029,5.4165-2.9208,6.0615-0.58461,0.37773,1.3676-0.43704,3.7378-1.8831,5.479-1.4019,1.6877-2.2004,3.6023-1.7748,4.2546,0.42564,0.65216-0.92107,2.016-2.9927,3.0306-3.8397,1.8805-6.5048,8.0707-3.4747,8.0707,2.7261,0,8.7373-7.4169,8.0447-9.9256-0.35481-1.2846-0.18323-2.6059,0.38121-2.9363,2.3412-1.3703,2.1949,4.4528-0.18374,7.3168-1.4019,1.6877-2.2004,3.6023-1.7748,4.2546,0.42564,0.65218-0.92107,2.016-2.9927,3.0306-3.8148,1.8683-6.5067,8.0707-3.5029,8.0707,2.944,0,8.8566-7.0875,8.1244-9.7388-0.38303-1.3874-0.23476-2.7927,0.32968-3.1231,1.5768-0.92296,2.4275,3.6741,1.0964,5.9264-0.71298,1.2066-0.70651,2.8536,0.0168,4.1598,1.3096,2.3663-0.0182,6.9107-2.4316,8.3233-1.0345,0.60546-0.33394,1.7936,2.1753,3.6885,3.631,2.7423,3.7014,3.0302,3.7014,15.13,0,10.112,0.40827,12.722,2.2661,14.482,2.0848,1.9754,2.2661,1.9825,2.2661,0.0884,0-2.069,3.6318-4.5981,6.6028-4.5981,0.8764,0,6.3518,4.6402,12.167,10.312,5.8509,5.7058,11.973,10.561,13.707,10.87,1.7232,0.30733,3.5888,0.63391,4.1458,0.72575,0.55695,0.092,3.1792-0.68688,5.8271-1.7306z'/%3E %3Cpath d='m605.96,354c0-3.2598-6.7241-6.7394-14.767-7.6415-6.4933-0.72835-6.5996-0.68714-6.5996,2.5565,0,2.685,1.0211,3.7413,5.5034,5.6928,7.2024,3.1357,15.863,2.804,15.863-0.60778z'/%3E %3Cpath d='m613.33,353.7c3.2799-2.976,4.8339-6.5156,2.8606-6.5156-2.2695,0-8.293,5.4052-8.293,7.4417,0,3.1786,1.1188,2.9878,5.4324-0.92616z'/%3E %3Cpath d='m606.34,344.06c0.27788-1.8392-0.8597-3.0666-4.2697-4.6066-7.3558-3.3221-16.15-4.8607-18.268-3.196-3.901,3.0662-1.3018,7.1829,5.0028,7.9235,2.5382,0.29812,5.98,1.0722,7.6482,1.7202,4.8456,1.882,9.4537,1.0239,9.8867-1.8411z'/%3E %3Cpath d='m606.34,334.21c0.39598-2.6237-1.2816-3.5626-14.978-8.3834-10.225-3.5989-14.752-1.9018-11.484,4.3058,1.1384,2.1624,3.049,3.1503,7.3339,3.7919,3.187,0.4773,7.5427,1.4104,9.6793,2.0738,5.7081,1.772,9.0058,1.148,9.4489-1.788z'/%3E %3Cpath d='m613.2,324.98c2.0666-2.0947,3.7572-4.567,3.7572-5.4936,0-3.0061-8.1614,2.3121-9.2017,5.9959-1.2478,4.4187,0.77501,4.2322,5.4449-0.50233z'/%3E %3Cpath d='m606.34,324.36c0.45051-2.9886-4.5198-5.6876-14.294-7.7622-7.1711-1.522-10.334-0.6588-9.7971,2.6736,0.29315,1.8191,2.6814,3.1481,9.4566,5.2626,10.843,3.3836,14.104,3.3449,14.634-0.17403z'/%3E %3Cpath d='m615.9,310.45c12.525-5.5755,13.608-19.635,1.7976-23.326-4.9037-1.5327-8.0341-0.70686-9.9112,2.6147-1.4372,2.5434-0.476,7.1676,1.4899,7.1676,0.66417,0,1.2076,0.85596,1.2076,1.9021,0,4.8819-19.123,7.0939-26.965,3.119-2.7551-1.3964-3.9546-5.0211-1.6616-5.0211,1.7134,0,2.8981-3.6935,2.0226-6.3059-1.1928-3.5592-4.7799-4.7922-9.9831-3.4317-11.74,3.0699-11.41,16.865,0.54277,22.719,9.8013,4.8001,31.287,5.0919,41.46,0.56291z'/%3E %3Cpath d='m608.11,299.64c0.72529-0.68694,0.41011-1.7425-0.80582-2.6982-2.6627-2.0928-2.5207-5.2056,0.4-8.7689,2.1933-2.6759,2.4673-6.6804,3.2223-47.074,1.3008-69.611,6.4773-121.97,13.3-134.53,2.7163-5.0009,2.3354-5.0208-4.6839-0.24499-9.0418,6.1522-15.926,14.163-22.026,25.631-11.516,21.651-15.518,50.78-15.518,112.96,0,35.305,0.24051,39.924,2.2515,43.243,1.9103,3.1523,2.0118,4.3165,0.66998,7.6833-0.86981,2.1824-1.2645,4.2682-0.87709,4.6351,2.5711,2.435,21.302,1.789,24.067-0.82993z'/%3E %3Cpath d='m713.34,233.26c0.39236-0.6012-0.47458-3.6364-1.9264-6.745-2.2635-4.8468-3.1753-5.6519-6.4-5.6519-10.102,0-26.341-4.5144-43.083-11.976-9.6677-4.3091-13.007-5.2994-14.166-4.2013-2.958,2.8014,1.9582,9.4508,9.5715,12.946,6.754,3.1007,25.635,6.9107,34.248,6.9107,4.9966,0,5.1147,0.22548,2.2713,4.3354l-2.0914,3.0228,5.6524,0.14508c3.1087,0.0799,7.4004,0.56638,9.5371,1.0813,5.5493,1.3373,5.6012,1.3384,6.3876,0.13328z'/%3E %3Cpath fill='%23000' d='m772.35,264.63c0-1.7992-5.2837-6.6752-10.638-9.817-4.2046-2.4674-4.8992-2.5424-4.9086-0.52996-0.0143,3.0552-2.7311,10.731-3.798,10.731-0.60162,0-1.4912-1.4999-1.9771-3.3332-0.48587-1.8332-2.5241-5.4462-4.5295-8.0287l-3.6462-4.6956-2.8391,4.3506c-2.6467,4.0557-7.2315,8.0278-9.2662,8.0278-0.48599,0-0.58103-2.1359-0.21134-4.7465,0.40169-2.8364,0.092-5.0863-0.77073-5.591-0.79353-0.4645-1.4428-0.30245-1.4428,0.3601,0,1.5283-6.367,8.751-7.7142,8.751-0.55513,0-1.3322-2.0695-1.727-4.5989-0.39469-2.5294-1.0656-6.5304-1.4908-8.8911-0.42526-2.3608,0.48144-0.75983,2.015,3.5576l2.7884,7.8498,3.0577-4.7839c1.6817-2.6312,3.0607-5.5063,3.0643-6.3893,0-0.88294,0.57248-1.2741,1.2641-0.86936,0.69149,0.40477,1.654,3.5676,2.1387,7.0284l0.88145,6.2925,3.3646-3.689c1.8506-2.0289,4.019-4.7452,4.8188-6.0363,1.427-2.3036,1.5078-2.3017,4.3463,0.10554,1.5907,1.349,4.0363,4.5757,5.4345,7.1704,1.3984,2.5947,2.7296,4.5262,2.9584,4.2923,0.22868-0.23399,0.74108-2.9088,1.1388-5.9441,0.39754-3.0352,0.75248-5.6312,0.7886-5.7688,0.19786-0.7521,10.135,5.7072,13.812,8.9778,2.3631,2.1022,4.6074,3.5278,4.9873,3.1681,0.37993-0.35979,0.69071-3.4612,0.69071-6.8921,0-5.3167-0.56355-6.7417-3.8155-9.6485-3.7391-3.3422-3.8437-3.3606-5.2252-0.91579-1.7931,3.173-3.9084,3.2188-3.9084,0.0846,0-2.2875-7.0659-11.08-8.9041-11.08-0.47653,0-1.9646,1.9315-3.3071,4.2923-1.3424,2.3607-2.786,4.29-3.208,4.2874-1.8125-0.0111-11.774-11.117-11.769-13.122,0-1.5945,0.67129-1.1868,2.4176,1.4761,1.3269,2.0235,3.9777,5.0443,5.8904,6.7129,3.8731,3.3787,5.2811,2.5571,6.7757-3.9536,0.42577-1.8549,1.1658-3.3725,1.6444-3.3725,1.6558,0,10.327,9.2097,11.547,12.264l1.2244,3.0659,0.92741-3.3725c1.134-4.124,2.3852-4.2774,4.1958-0.51425,0.75626,1.572,4.4918,4.8404,8.3011,7.263l6.926,4.4047,1.39-4.4303c0.76451-2.4366,1.7773-3.8368,2.2506-3.1116,0.70585,1.0815-1.0945,8.4227-2.4528,10.002-0.20356,0.23674-2.4479-1.0705-4.9875-2.9049l-4.6172-3.3353-0.0182,5.9708c-0.0129,3.2839-0.36905,7.2125-0.79856,8.7301-0.83976,2.9674-3.0686,3.8021-3.0686,1.1492z'/%3E %3Cpath fill='%23000' d='m737.82,217.03c-8.2314-6.8725-9.481-8.4451-9.2987-11.702l0.19399-3.4668,0.537,3.3485c0.31363,1.9552,2.5058,4.8853,5.2686,7.0422l4.7318,3.6937,2.9076-3.3631c1.5993-1.8497,2.9287-4.0529,2.9544-4.896,0.0673-2.1985,0.46176-2.0139,6.0347,2.8216,4.9515,4.2963,5.0287,4.3168,5.7651,1.533,0.41049-1.5519,0.26481-4.4736-0.32372-6.4926-1.6179-5.5499-1.3009-6.3875,1.1507-3.0403,1.2214,1.6677,3.1854,4.0253,4.3644,5.239,2.0523,2.1129,2.1775,2.0868,2.9412-0.6132,0.43872-1.551,0.80557-4.3898,0.81528-6.3085l0.0182-3.4885,4.4645,5.0607c4.1702,4.7272,4.5544,4.9018,5.8272,2.6494,0.7495-1.3262,1.3716-4.5171,1.3824-7.0908,0.0142-3.3248,0.36439-4.1637,1.21-2.8977,1.4121,2.114,0.43172,7.87-2.1758,12.775l-1.8712,3.5199-2.4571-3.8264c-3.1417-4.8928-4.1876-4.8142-6.2036,0.46582-1.9052,4.9898-3.1441,5.3696-5.0005,1.533-1.2013-2.4829-1.43-2.1787-2.2827,3.0374l-0.94776,5.7967-5.6785-4.4068-5.6786-4.4068-2.5528,2.9023c-1.4041,1.5963-2.5722,3.5922-2.5959,4.4353-0.0517,1.8274-1.4176,1.8844-3.4995,0.14622z'/%3E %3Cpath fill='%23000' d='m811.04,191.43c-2.9962-2.6993-5.0602-5.2746-4.5867-5.723,0.47342-0.44838,1.0065-0.57681,1.1846-0.28542,0.17806,0.29139,2.6271,2.8668,5.4424,5.723,6.4822,6.5765,5.1496,6.7629-2.0403,0.28543z'/%3E %3Cpath fill='%23000' d='m713.51,181.35c-2.7255-3.6852-2.5373-6.1267,0.7803-10.121,2.3974-2.8864,3.4925-3.2781,7.6788-2.7463,2.6854,0.34111,8.4638,2.7138,12.841,5.2725,5.0555,2.9552,10.285,4.9349,14.335,5.427,3.5069,0.42609,6.3763,0.58673,6.3763,0.35699,0-0.22973-1.4568-2.6032-3.2373-5.2744-4.2283-6.3433-4.0835-7.0241,0.68552-3.2237,4.8954,3.9012,10.751,5.0421,23.836,4.6444l6.393-0.19431-3.7088-3.6663c-5.1869-5.1273-3.5906-5.587,2.1375-0.61554,5.3722,4.6626,5.0358,4.991-6.2715,6.1196-4.8048,0.47958-9.9719,0.1317-14.267-0.96048-6.4256-1.6342-6.675-1.6093-5.4578,0.54471,0.70158,1.2414,1.8378,2.2571,2.5248,2.2571,0.68721,0,1.2495,0.62908,1.2495,1.3979,0,2.3644-13.879,0.28524-20.511-3.0727-15.151-7.6712-17.058-8.3355-20.664-7.1991-2.0067,0.63235-4.0153,2.4833-4.7074,4.3381-2.3091,6.1873,6.4658,10.997,10.085,5.5273,1.049-1.5853,0.804-2.6696-1.0397-4.5988-2.5248-2.6423-2.288-3.0188,1.1205-1.7801,2.4199,0.87945,2.7455,6.6892,0.49439,8.8212-2.5757,2.4393-8.4536,1.7488-10.674-1.254z'/%3E %3Cpath fill='%23000' d='m773.19,166.07c-1.8946-1.7944-0.40932-2.2338,8.0847-2.3922,10.508-0.19593,16.89-1.947,24.42-6.7006,6.0333-3.8088,7.669-3.0593,1.9424,0.88996-5.2242,3.6027-13.372,6.3723-21.239,7.2191-3.8093,0.41006-8.1505,0.9781-9.6473,1.2623-1.4967,0.28421-3.0991,0.15887-3.561-0.27852z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1140' height='600' viewBox='0 0 209 110' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Crect fill='%23bf0a30' width='209' height='110'/%3E %3Cpath d='M0,15H209 M0,35H209 M0,55H209 M0,75H209 M0,95H209' stroke='%23fff' stroke-width='10'/%3E %3Crect fill='%23002868' width='50' height='50'/%3E %3Cg transform='translate(25,25) scale(15)'%3E %3Cg id='B'%3E %3Cpolygon id='A' fill='%23fff' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23A' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23B' transform='rotate(72)'/%3E %3Cuse xlink:href='%23B' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23B' transform='rotate(144)'/%3E %3Cuse xlink:href='%23B' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 450 300'%3E %3Crect width='450' height='300' fill='%23009543'/%3E %3Crect width='450' height='210' fill='%23fff'/%3E %3Crect width='450' height='90' fill='%2300209f'/%3E %3Cg fill='%23fff'%3E %3Cpath fill='%23000' stroke='%23000' d='m224.76,95.569c-1.7098,0.03684-3.3781,1.9308-3.3781,1.9308l0.14732,20.233-6.3878,6.692h5.1711l-0.0437,11.603-30.591,41.193-4.5222-1.563-7.9041,16.861s19.55,12.242,47.925,11.907c31.144-0.37035,48.064-12.471,48.064-12.471l-8.1677-16.644-3.9996,1.7393-30.983-40.979-0.0437-11.949h5.1711l-7.0378-6.6088,0.0416-20.159s-1.7514-1.8203-3.4613-1.7835z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='5' d='m235.43,144.01-21.153,0s-7.6776-16.176-6.4331-27.485c1.2672-11.515,7.8483-16.963,16.598-17.059,10.345-0.11526,15.767,5.0691,17.405,16.598,1.6231,11.424-6.4172,27.947-6.4172,27.947z'/%3E %3Cpath d='m187.79,182.57c-0.3458,0.46106-2.8816,5.5326-2.8816,5.5326l4.38-0.92211-1.4984-4.6105z'/%3E %3Cpath d='m190.32,189.14-4.6105,1.4984,5.5327,2.19-0.92212-3.6884z'/%3E %3Cpath d='m192.4,182.68,2.3053,6.8006,5.6479-1.6137-1.4984-3.2274-6.4548-1.9595z'/%3E %3Cpath d='m195.97,191.91,0.80685,2.7663,7.4921,1.8442-2.9968-6.3395-5.3021,1.729z'/%3E %3Cpath d='m204.27,186.14,2.6511,6.3395,5.6479-2.19-1.8442-2.7663-6.4548-1.3832z'/%3E %3Cpath d='m207.96,194.79,0.92211,2.4205,8.76,1.2679-3.6884-5.7632-5.9937,2.0747z'/%3E %3Cpath d='m216.37,187.99,3.2274,5.6479,8.1837-2.9969-0.9221-2.19-10.489-0.46106z'/%3E %3Cpath d='m221.1,195.71,1.729,2.9969,10.143-0.3458-3.8037-5.6479-8.0684,2.9968z'/%3E %3Cpath d='m231.82,188.22,2.7663,4.7258,6.4548-3.1121-1.729-2.5358-7.4921,0.92212z'/%3E %3Cpath d='m242.42,191.79-6.4548,3.2274,1.729,2.7663,8.6448-1.3832-3.919-4.6106z'/%3E %3Cpath d='m244.5,186.83,3.3426,4.1495,5.4174-4.2648-1.8442-1.9595-6.9158,2.0748z'/%3E %3Cpath d='m254.41,189.02-5.1869,3.919,1.3832,2.4205,7.1464-1.8442-3.3426-4.4953z'/%3E %3Cpath d='m261.56,180.84,1.2679,1.8442-3.5732,5.3021-3.6884-4.7258,5.9937-2.4205z'/%3E %3Cpath d='m263.98,185.45,2.19,4.38-4.38,1.4984-0.34579-2.0748,2.5358-3.8037z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='500' height='300' viewBox='0 0 5 3'%3E %3Crect fill='%23C1272D' width='5' height='3'/%3E %3Crect fill='%23006A44' width='5' height='2'/%3E %3Crect fill='%23FDB913' width='5' height='1'/%3E %3C/svg%3E"

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='600'%3E %3Crect width='1000' height='300' y='300' fill='%2300A1DE '/%3E %3Crect width='1000' height='300' fill='%23ed2939'/%3E %3Crect width='1000' height='200' y='200' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3Cpath fill='%239E3039' d='m0,0h1200v600H0'/%3E %3Cpath fill='%23FFF' d='m0,240h1200v120H0'/%3E %3C/svg%3E"

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='960' height='480'%3E %3Crect width='960' height='480' fill='%23239e46'/%3E %3Crect width='960' height='360' fill='%23000'/%3E %3Crect width='960' height='120' fill='%23e70013'/%3E %3Ccircle cx='480' cy='240' r='60' fill='%23fff'/%3E %3Ccircle cx='492.132034' cy='240' r='52.132034' fill='%23000'/%3E %3Cpath d='M509.175411,240 589.875233,213.779039 540,282.426407V197.573593L589.875233,266.220961z' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' width='900' height='600' id='svg2' version='1.1' inkscape:version='0.48.4 r9939' sodipodi:docname='AJAX.svg'%3E %3Cmetadata id='metadata12'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3Cdc:title%3E%3C/dc:title%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Cdefs id='defs10' /%3E %3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1920' inkscape:window-height='1057' id='namedview8' showgrid='false' fit-margin-top='0' fit-margin-left='0' fit-margin-right='0' fit-margin-bottom='0' inkscape:zoom='0.63555556' inkscape:cx='455.8698' inkscape:cy='278.86414' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:current-layer='svg2' /%3E %3Crect width='900' height='600' id='rect4' x='-900' y='0' transform='scale(-1,1)' style='fill:%23c1272d;fill-opacity:1;stroke:none' /%3E %3Cpath d='m 449.99991,224.31497 -44.4674,136.87006 116.40181,-84.55895 H 378.06451 l 116.4028,84.55895 z' id='path6' inkscape:connector-curvature='0' style='fill:none;stroke:%23006233;stroke-width:14.62993431;stroke-miterlimit:4;stroke-dasharray:none' /%3E %3C/svg%3E"

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='750' height='600'%3E %3Crect fill='%23FFF' width='750' height='600'/%3E %3Crect fill='%23CE1126' width='750' height='300'/%3E %3C/svg%3E"

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1800' height='900'%3E %3Crect width='1800' height='900' fill='%23cc092f'/%3E %3Crect width='1200' height='900' fill='%23ffd200'/%3E %3Crect width='600' height='900' fill='%230046ae'/%3E %3Cg%3E %3Cg%3E %3Cpath fill='%23000' d='m847.69 183.24c-3.223 0-6.038 0.822-7.68 2.1 2.609 0.76 4.506 3.166 4.506 6.092v7.423h-7.422c-2.907 0-5.315-1.87-6.093-4.454-1.278 1.642-2.099 4.457-2.099 7.679 0 3.223 0.821 6.039 2.099 7.679 0.761-2.61 3.166-4.506 6.093-4.506h7.422v35.681c0 2.805-1.754 5.132-4.198 5.989 3.541 0.482 6.588 5.234 7.423 7.833 0.837-2.593 3.884-7.351 7.424-7.833-2.47-0.842-4.251-3.166-4.251-5.989v-35.683h7.424c2.908 0 5.315 1.87 6.093 4.456 1.277-1.642 2.098-4.459 2.098-7.68 0-3.223-0.82-6.038-2.098-7.679-0.761 2.609-3.167 4.504-6.093 4.504h-7.424v-7.422c0-2.908 1.869-5.315 4.455-6.093-1.64-1.276-4.457-2.098-7.679-2.098z'/%3E %3Cpath fill='%23f5d402' d='m847.69 184.78c-1.678 0-3.156 0.314-4.402 0.716 1.664 1.447 2.765 3.544 2.765 5.939v7.423c0 0.106-0.031 0.207-0.052 0.308v1.177h-1.178c-0.1 0.021-0.202 0.051-0.307 0.052h-7.424c-2.367 0-4.439-1.083-5.886-2.713-0.416 1.259-0.768 2.697-0.768 4.403 0 1.678 0.314 3.156 0.716 4.402 1.447-1.664 3.543-2.763 5.938-2.763h8.959c-0.01 0.154-0.052 0.303-0.052 0.459v0.768c0.021 0.1 0.051 0.201 0.052 0.307v35.681c0 2.317-1.195 4.139-2.765 5.58 1.123 0.693 2.09 1.565 2.918 2.561 0.737 0.885 1.03 1.751 1.536 2.661 0.507-0.908 0.799-1.776 1.536-2.661 0.815-0.978 1.768-1.82 2.867-2.509-1.584-1.437-2.765-3.305-2.765-5.631v-37.168h1.229c0.1-0.02 0.201-0.05 0.307-0.05h7.423c2.366 0 4.438 1.083 5.886 2.712 0.415-1.258 0.769-2.695 0.769-4.402 0-1.677-0.315-3.156-0.717-4.402-1.447 1.664-3.543 2.763-5.938 2.763h-7.423c-0.105 0-0.207-0.031-0.307-0.052h-1.178v-1.177c-0.021-0.099-0.051-0.201-0.052-0.308v-7.422c0-2.367 1.084-4.438 2.713-5.887-1.259-0.414-2.696-0.768-4.402-0.768'/%3E %3Cpath fill='%23000' d='m940.609,313.987c-4.535-3.221-8.258-6.862-10.904-11.11-6.372-10.223-9.061-22.773-9.061-35.527,0-5.391,6.04-11.46,6.04-15.82,0-6.59-0.614-10.544-0.614-10.544,2.143,0.292,5.887,4.095,5.887,4.095s-0.129-10.938-3.585-12.849c0,0,1.398-1.438,6.451-1.587-1.42-3.596-8.446-7.986-8.446-7.986,0.351-0.629,1-1.173,1.842-1.638,1.765-0.976,4.245-1.62,6.142-1.997-2.022-0.419-4.352-1.061-6.91-1.895-5.842-1.903-12.719-4.697-19.146-7.78-11.732-5.628-20.669-5.99-25.596-5.9895-3.575,0.0005-8.84,0.0985-11.927,2.1515-2.825,1.875-2.595,4.314-3.584,5.17-2.33,2.016-6.321,1.945-8.243,1.945-12.44,0-12.901,13.311-12.901,13.311s3.181-4.813,8.805-4.813c9.351,0,16.433,5.094,16.433,7.013,0,0.777-0.964,0.921-1.023,0.921-6.108,0-15.326-3.516-20.223-3.686v2.406c10.931,3.803,22.013,9.187,22.013,32.917,0,14.943-1.789,30.19-9.265,42.183-2.648,4.247-6.418,7.881-10.955,11.11l44.385,7.9995z'/%3E %3Cg id='eagle_half'%3E %3Cpath fill='%23000' d='m896.222,303.988-44.383,10.0005c-2.019-0.61-11.513-3.56-18.174-7.269-11.726-6.532-17.806-13.031-31.74-13.669v-10.598c0-5.662,2.049-10.763,2.049-16.177-5.874-1.575-22.178-21.51-37.218-30.358-22.13,14.334-39.265,37.865-39.265,48.686,0,0,0.665,232.51,0,313.51,0,4.668-2.815,11.263-2.815,11.263,8.079-3.418,22.888-23.68,26.006-31.382v3.687c12.201-5.564,21.135-20.184,25.136-27.747,0.071,1.093,0.257,3.838,0.257,3.838,10.9-9.555,24.776-66.038,24.776-66.038l23.124,22.7255s-8.363,16.9755-11.621,20.0155c0,0,2.184,0.277,4.658,0.256-1.522,2.188-13.147,18.925-16.791,25.238-3.41,5.906-5.816,3.277-11.058,3.277-4.347,0-14.2,6.925-15.818,9.727-1.701,2.945-2.968,6.523-2.968,9.471,0,3.24,3.43,7.679,3.43,7.679,0.369-1.551,1.023-2.099,1.023-2.099s9.013,11.228,10.341,12.695c1.034,1.143,5.645,1.886,7.27,0.411,4.066-3.697,8.002-6.282,11.621-11.621,1.863-2.751,2.005-5.904,4.146-8.858,7.162-9.88,21.415-28.799,24.675-33.121,0.218,1.203,0.405,2.205,0.612,3.43,3.694-7.457,21.451-21.706,21.451-21.706l18.578,8.55s-34.687,79.735-65.476,91.995c0,0,13.395,5.691,29.845,14.232,2.4,1.246,4.871,2.584,7.372,3.943,2.071-2.494,4.251-5.265,6.399-8.141,9.836-13.16,19.455-28.412,19.455-28.412,0.67,3.961-4.524,16.194-13.31,31.281-1.728,2.964-3.53,6.064-5.529,9.213,2.229,1.273,4.441,2.559,6.655,3.892,16.295,9.805,31.598,21.077,37.267,31.432l4,-10.009 -4,-10.009v-349.957l2,-5z'/%3E %3Cg fill='%23b07f55'%3E %3Cpath d='m896.202,667.221c-5.749-6.236-17.769-13.855-31.278-20.886,16.334-29.316,24.428-75.655,20.63-84.88,0,0-6.705,24.033-14.898,37.729-7.586,12.684-16.925,26.95-25.954,37.526-7.428-3.169-14.631-5.828-20.785-7.68,27.058-20.843,54.726-89.742,54.726-89.742l-28.612-13.26s-10.704,12.479-14.18,14.796c0,0-1.485-6.206-2.355-8.396,0,0-4.101,3.102-6.346,3.176,0,0-0.671-4.212-1.178-6.964-2.825,1.883-7.525,1.485-7.525,1.485,4.127-1.954,9.01-13.925,9.01-13.925l-27.322-36.343s-9.597,46.116-20.528,55.596v-198.58l8.652,8.036,13.105-12.235v-9.317l-11.621,10.852v-28.105c1.751-2.649,2.912-4.626,3.788-6.194,1.881,3.279,7.96,13.329,15.101,19.505,1.175-4.778,8.908-9.318,8.908-9.318s2.771,7.508,7.012,9.368c1.492-2.628,10.394-8.446,10.394-8.446s-7.616,1.157-10.7,4.045c-2.649-0.593-3.328-11.058-3.328-11.058s-11.207,5.459-13.156,9.368c-2.137-0.578-5.464-8.988-6.759-12.44,1.955-0.213,4.716-0.46,8.345-0.46,3.196,0,7.285,1.514,11.569,3.532,4.707,2.216,9.631,5.022,14.028,7.014,5.632,2.55,14.153,3.068,16.637,3.174-2.845,2-5.973,3.826-9.367,5.529,0,0,13.411-0.124,22.832-4.813,3.361-2.162,6.849-4.316,9.829-6.86-1.293,3.593-3.306,7.839-6.452,11.467,13.836-1.171,20.726-9.072,22.679-11.723,0.918,2.375,2.553,6.187,5.119,9.47h5v340z'/%3E %3Cpath d='m794.247,267.298,0.255,6.348,0,18.687c-5.019-1.727-11.326-9.973-14.384-14.334v-2.56c0-2.408,1.417-4.167,2.457-5.119l-3.02-1.074c-1.152,1.313-2.406,3.263-2.406,5.784v1.485l-9.009,9.676-8.856-13.413v-3.276c0-2.208,1.698-4.67,3.123-6.348l-2.97-1.075c-1.499,1.942-3.072,4.559-3.072,7.013v2.661c-2.083,2.156-10.187,10.496-10.187,10.496s-4.066-8.737-5.17-11.109c6.205-8.595,16.266-18.219,25.7488-25.1245,0,0,20.5642,18.8805,27.4902,21.2825z'/%3E %3Cpath d='m742.127,285.421,0,15.411-7.167,6.654,0-22.883c0-2.191,0.918-4.831,2.4565-7.731z'/%3E %3Cpath d='m764.447,291.359,0,9.522-8.241,7.731,0-29.794z'/%3E %3Cpath d='m753.286,308.561-8.243-7.679,0-11.159,8.243-8.652z'/%3E %3Cpath d='m790.913,296.991c-1.914,2.705-6.927,9.321-12.337,12.236v-26.1605c1.241,2.0645,6.934,11.2745,12.337,13.9245z'/%3E %3Cpath d='m775.656,284.397,0,24.163-8.243-7.679,0-8.549z'/%3E %3Cpath d='m742.126,310.147,0,24.113-7.167-6.707,0-10.7z'/%3E %3Cpath d='m753.28,317.878,0,8.651-8.244,7.678,0-24.0085z'/%3E %3Cpath d='m764.438,310.2,0,24.01-8.241-7.731,0-8.549z'/%3E %3Cpath d='m775.651,317.93,0,8.549-8.243,7.73,0-24.0095z'/%3E %3Cpath d='m786.81,334.26-8.244-7.731,0-8.036c2.843-1.735,5.702-4.924,8.2435-8.2935z'/%3E %3Cpath d='m765.925,344.908,8.703-8.089,0,198.63s0.607,9.856,1.024,16.279c-3.87,3.912-18.429,18.634-18.429,18.634v-233.596z'/%3E %3Cpath d='m752.253,562.94c0,6.385-11.659,21.273-17.303,24.675v-250.74l8.6,8.036,8.703-8.0895z'/%3E %3C/g%3E %3Cg fill='%23d10429'%3E %3Cpath d='m824.535,541.388,6.348-4.352s0.423,2.1,0.972,4.967c-2.718,3.716-18.331,25.024-26.057,35.425-1.921,2.584-3.534,9.163-3.534,9.163s-2.814-1.331-2.814-3.736c0-2.362,0.308-5.171,0.308-5.171s-2.101,2.406-5.735,2.406c0-2.903,5.614-6.052,5.836-10.186-4.281,3.174-7.999,1.545-12.951,3.072-5.393,1.661-6.895,3.927-8.549,3.84-0.974-0.053-1.856-1.733-1.484-2.765,0.644-1.787,7.314-6.733,11.977-7.627,1.117-0.214,9.903,1.912,11.673-0.819,7.292-11.252,19.13-29.518,20.272-31.278,0.752-0.18,1.444-0.371,1.9955-0.719,0,0-0.0675,5.751,1.7425,7.78z'/%3E %3Cpath d='m783.72,576.452c0.353,0.408,0.322,1.006-0.053,1.33l-2.866,2.508c-0.375,0.324-0.977,0.255-1.33-0.154-0.354-0.408-0.324-1.006,0.052-1.331l2.866-2.508c0.187-0.163,0.428-0.233,0.6655-0.204,0.2375,0.027,0.4875,0.154,0.6655,0.359z'/%3E %3Cpath d='m788.071,579.472c0.857,0.988,0.802,2.388-0.103,3.175l-6.962,6.091c-0.906,0.788-2.367,0.63-3.226-0.357-0.857-0.988-0.803-2.439,0.103-3.225l6.962-6.041c0.339-0.296,0.802-0.477,1.229-0.5125,0.712-0.0585,1.46,0.2535,1.997,0.8695z'/%3E %3Cpath d='m792.061,584.182c0.857,0.988,0.803,2.387-0.103,3.174l-7.012,6.092c-0.906,0.787-2.316,0.63-3.175-0.358-0.858-0.987-0.803-2.438,0.104-3.224l6.961-6.041c0.339-0.295,0.75-0.476,1.178-0.5125,0.711-0.0585,1.51,0.2515,2.047,0.8695z'/%3E %3Cpath d='m794.464,587.919c0.713-0.058,1.461,0.201,1.997,0.819,0.858,0.988,0.803,2.439-0.102,3.225l-6.963,6.042c-0.906,0.787-2.316,0.629-3.174-0.359s-0.854-2.388,0.051-3.175l7.014-6.091c0.338-0.296,0.749-0.427,1.177-0.461z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23eagle_half' transform='matrix(-1,0,0,1,1792.404,0)'/%3E %3Cpath fill='%23b07f55' d='m885.934,206.637c11.458,0,19.517,5.224,30.359,10.033,2.841,1.26,5.45,2.281,7.779,3.071-1.459,1.293-2.594,2.592-2.918,3.687,0,0,4.859,0.9,7.064,4.967,0,0-4.62,0.524-5.375,3.224,2.588,0.195,5.159,3.457,5.171,6.605l-6.553-2.049s1.587,7.358,1.587,15.358c0,4.086-5.886,8.894-5.886,15.819,0,21.734,5.475,30.088,9.369,36.807,1.523,2.629,2.761,5.654,5.324,7.935-11.218-5.973-19.556-13.439-19.556-20.374v-26.262h-2.918v26.262c0,5.029,1.228,7.372,1.228,7.372,1.761,5.564,5.321,14.152,7.526,17.61-10.321-5.578-15.564-12.563-15.564-15.153v-36.092h-2.918v36.603l0.563,2.508c-1.251,1.88-2.877,4.106-3.993,4.863-1.113-0.756-2.69-2.986-3.943-4.863l0.564-2.508v-36.603h-2.918v36.092c0,2.589-5.243,9.575-15.563,15.153,2.205-3.459,5.764-12.046,7.524-17.61,0,0,1.229-2.342,1.229-7.372v-26.262h-2.918v26.262c0,6.927-8.307,14.405-19.505,20.374,2.537-2.283,3.757-5.321,5.272-7.935,4.258-7.348,9.522-16.683,9.522-43.258,0-9.974-1.475-16.755-4.044-21.501-0.781-1.566-1.833-5.734,4.146-5.734,3.097,0,10.188,5.478,10.188,5.478s-0.292-4.371-3.891-6.86c-0.597-0.413-1.586-1.712-1.586-2.919,0-0.904,1.551-3.135,2.763-3.686,0.833-0.378-12.183-2.646-12.183-8.549,0-1.229,0.773-2.048,3.479-2.048,3.545,0,9.312,4.249,14.438,4.249,3.789,0,5.283-0.922,9.163-0.922,4.742,0,14.635,8.979,18.019,8.651-3.783-2.375-9.894-11.365-19.145-11.365-3.211,0-6.117,0.717-9.114,0.717-3.841,0-7.623-3.533-11.774-3.533-2.782,0-5.889,0.155-6.349-0.564-0.805-1.255-0.08-1.983,0.666-3.02,1.409-1.957,5.366-2.525,9.267-2.661,1.17-0.041,2.338-0.061,3.4325-0.0505,1.0905,0.0115,2.0995,0.0535,2.9715,0.0535z'/%3E %3Cpath fill='%23cc092f' d='m848.73 220.69s2.419-4.581 8.534-4.581c2.556 0 10.992-0.177 10.992-0.177 1.124 2.921 6.249 7.802 6.249 12.878 0 0-5.202-9.377-19.723-9.377-3.649 0-6.054 1.256-6.054 1.256z'/%3E %3Cpath fill='%23d10429' d='m872.34 230.6s-3.093 3.258-3.765 4.997c-3.061-1.16-8.399-6.661-8.399-6.661s4.525 2.642 12.163 1.664z'/%3E %3Cpath fill='%23000' d='m867.44 221.97s-3.568-1.144-3.568-2.342c0-1.526 1.733-1.526 2.769-0.337 0.713 0.819 0.798 2.68 0.798 2.68z'/%3E %3Cellipse fill='%23000' cx='882.798' cy='222.06' rx='5.112' ry='4.043'/%3E %3Ccircle fill='%23f5d402' cx='882.8' cy='222.06' r='3.56'/%3E %3Ccircle fill='%23000' cx='882.799' cy='222.06' r='1.511'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%23000'%3E %3Crect width='20.503' height='20.503' x='1052.3' y='157.29' transform='matrix(0.7902,0.4311,-0.1917,0.8793,0,0)'/%3E %3Cpath d='m725.9 418.73-5.836 2.663 65.936 144.42h7.014zm77.762 170.32-4.76 4.915 2.969 6.553 5.784-2.662z'/%3E %3Cpath d='m746.39 532.6s5.554 11.472 9.775 13.045c-2.183-0.595-9.271 2.006-9.271 2.006s12.499 11.165 23.1 11.898c8.99 0.619 13.355-3.868 13.355-3.868l-1.801-9.524s-5.5-6.642-14.302-9.707c-8.894-3.098-20.857-3.848-20.857-3.848z'/%3E %3Cpath d='m788.26 512.05s-7.669 6.565-9.768 14.169c-2.1 7.605 1.368 16.247 1.368 16.247l6.444 12.021s8.931-4.753 12.73-11.86c3.799-7.108 2.406-16.698 2.406-16.698s-7.075 2.634-7.975 3.8c1.493-7.884-5.206-17.679-5.206-17.679z'/%3E %3Cpath d='m763.61 508.98s-8.722 2.948-17.192 2.438c-8.068-0.487-14.777-7.262-14.777-7.262s6.688-4.526 9.989-3.923c-3.631-1.327-8.896-10.423-8.896-10.423s7.482-2.261 14.116 0.24c6.634 2.503 12.419 9.77 12.419 9.77l4.342 9.16z'/%3E %3Cpath d='m766.61 466.38s4.362 9.032 3.328 12.171c1.353-2.09 6.474-5.345 6.474-5.345s3.096 14.624 0.135 23.656c-2.96 9.031-11.974 12.47-11.974 12.47l-9.943-19.337s-1.48-7.164 1.62-12.837c3.101-5.673 10.36-10.779 10.36-10.779z'/%3E %3Cpath d='m709.86 442.47s9.427-0.99 18.051 2.583c7.21 2.993 9.42 8.433 9.42 8.433l3.551 9.52s-10.261 3.848-18.368 0.906c-8.108-2.945-14.065-12.68-14.065-12.68s5.666-2.149 7.823-1.343c-3.142-1.39-6.41-7.419-6.41-7.419v0.001z'/%3E %3Cpath d='m739.51 424.8s4.137 5.313 4.261 11.424c1.103-3.249 6.268-6.84 6.268-6.84s5.312 12.855 4.146 21.982c-1.166 9.128-8.809 14.527-8.809 14.527l-9.531-18.092s-3.106-7.415-2.191-13.167c0.916-5.75 5.856-9.836 5.856-9.836z'/%3E %3Cpath d='m706.86 390.2s-1.709 9.854 1.199 15.53c2.598 5.065 4.252 6.176 4.252 6.176-4.954-3.269-12.444-3.551-12.444-3.551s2.666 10.721 9.037 15.612 16.195 3.748 16.195 3.748 6.46-8.6 6.01-17.865c-0.449-9.265-7.808-19.197-7.808-19.197s-2.902 6.02-3.158 10.514c-1.878-4.633-13.285-10.966-13.285-10.966z'/%3E %3Cpath d='m783.86 555.27 0.265 3.537c5.875 0.055 6.75-0.53 8.256 1.322 1.003 1.234 3.389 2.311 5.787 1.215 2.4-1.095 3.475-3.977 2.38-6.376s-3.326-2.92-5.475-2.496c-1.319 0.26-2.187 1.313-3.306 1.891-2.128 1.102-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m783.35 552.57 2.859 2.095c-3.067 5.014-4.024 5.446-3.251 7.705 0.515 1.504 0.166 4.097-2.035 5.553-2.2 1.455-5.214 0.841-6.669-1.358-1.454-2.2-0.715-4.366 0.783-5.965 0.92-0.982 2.27-1.16 3.353-1.803 2.062-1.223 4.959-6.228 4.959-6.228z'/%3E %3Cpath d='m763.45 510.57 0.264 3.537c5.876 0.054 6.75-0.53 8.256 1.321 1.002 1.233 3.389 2.311 5.787 1.215 2.401-1.095 3.476-3.976 2.379-6.375-1.095-2.4-3.325-2.92-5.474-2.496-1.32 0.261-2.187 1.313-3.305 1.891-2.129 1.101-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m764.64 511.82 2.5 2.517c-3.809 4.474-4.824 4.753-4.411 7.104 0.276 1.567-0.473 4.075-2.874 5.17-2.399 1.095-5.279 0.021-6.376-2.379-1.095-2.399-0.028-4.425 1.701-5.771 1.061-0.825 2.425-0.793 3.593-1.258 2.227-0.887 5.867-5.382 5.867-5.382z'/%3E %3Cpath d='m743.67 468.72 0.265 3.537c5.876 0.054 6.75-0.53 8.257 1.323 1.003 1.231 3.388 2.309 5.788 1.213 2.398-1.095 3.474-3.975 2.379-6.377-1.097-2.399-3.326-2.919-5.476-2.495-1.32 0.261-2.187 1.313-3.306 1.891-2.128 1.102-7.908 0.907-7.908 0.907z'/%3E %3Cpath d='m745.3 467.98 2.499 2.516c-3.809 4.475-4.822 4.754-4.411 7.105 0.276 1.566-0.473 4.074-2.873 5.169-2.399 1.094-5.28 0.02-6.376-2.379-1.094-2.4-0.027-4.426 1.701-5.771 1.061-0.827 2.424-0.793 3.594-1.26 2.227-0.887 5.866-5.38 5.866-5.38z'/%3E %3Cpath d='m722.6 424.54 0.264 3.536c5.876 0.055 6.751-0.53 8.256 1.321 1.004 1.234 3.39 2.311 5.788 1.217 2.4-1.097 3.475-3.977 2.38-6.377s-3.326-2.921-5.476-2.496c-1.318 0.261-2.186 1.314-3.305 1.891-2.128 1.101-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m724.23 423.8 2.498 2.517c-3.808 4.475-4.823 4.753-4.41 7.105 0.276 1.566-0.474 4.074-2.873 5.169-2.4 1.095-5.28 0.021-6.375-2.379-1.096-2.399-0.028-4.427 1.699-5.771 1.062-0.825 2.425-0.793 3.594-1.26 2.226-0.886 5.866-5.38 5.866-5.38z'/%3E %3C/g%3E %3Cg fill='%23f5d402'%3E %3Crect width='12.717' height='12.718' x='1056.2' y='161.19' transform='matrix(0.7902,0.4311,-0.1917,0.8793,0,0)'/%3E %3Cpath d='m759.72 500.09c-2.106 0.874-5.23-8.295-7.524-13.318-2.353-5.155-7.131-13.1-5.774-13.72 1.489-0.68 3.451 3.492 5.859 8.767 2.408 5.273 9.412 17.449 7.439 18.269z'/%3E %3Cpath d='m738.09 451.8c-2.105 0.877-4.41-5.127-6.703-10.151-2.353-5.154-4.645-8.795-3.288-9.415 1.49-0.68 3.69 3.837 5.616 8.055 1.866 4.088 6.348 10.69 4.374 11.512z'/%3E %3Cpath d='m788.13 561.29c-1.653 0.442-8.869-14.662-14.703-27.442-5.833-12.779-10.177-23.119-8.82-23.736 1.49-0.681 6.213 11.391 12.049 24.172 5.835 12.781 12.713 26.673 11.475 27.006z'/%3E %3C/g%3E %3Cg fill='%23097754'%3E %3Cpath d='m709.76 396.19s-0.255 7.201 2.127 11.285c2.383 4.086 7.704 5.715 7.704 5.715s0.254-7.199-2.128-11.283c-2.383-4.086-7.703-5.717-7.703-5.717z'/%3E %3Cpath d='m704.78 412.48s6.255 0.368 9.868 3.136c3.61 2.768 5.009 8.535 5.009 8.535s-4.146 0.421-7.756-2.347c-3.611-2.769-7.121-9.324-7.121-9.324z'/%3E %3Cpath d='m724.41 397.94s-2.08 4.77-1.84 9.912c0.239 5.143 3.24 10.937 3.24 10.937s2.713-6.174 2.474-11.318c-0.238-5.143-3.147-8.075-3.874-9.531z'/%3E %3Cpath d='m713.88 444.3s3.071 4.288 7.799 6.626c4.728 2.337 11.773 2.424 11.773 2.424s-3.516-4.562-8.245-6.9c-4.728-2.337-11.327-2.152-11.327-2.152z'/%3E %3Cpath d='m715.4 454.26s2.257 4.421 6.384 6.316c4.129 1.896 12.574 1.74 12.574 1.74s-3.24-4.131-7.368-6.027c-4.128-1.897-11.591-2.029-11.591-2.029z'/%3E %3Cpath d='m739.17 430.68s-2.495 4.123-2.251 8.666c0.245 4.545 3.227 9.511 3.227 9.511s2.097-5.693 1.852-10.237c-0.244-4.545-2.829-7.94-2.829-7.94z'/%3E %3Cpath d='m748.36 436.51s-4.269 5.73-4.882 11.621c-0.613 5.89 2.428 11.942 2.428 11.942s5.157-5.178 5.77-11.068c0.613-5.892-3.316-12.493-3.316-12.493z'/%3E %3Cpath d='m736.59 490.91s0.513 2.118 2.297 4.367c1.783 2.251 4.836 4.632 4.836 4.632s2.949-0.948 6.615-0.155c3.665 0.795 8.54 4.06 8.54 4.06s-5.247-7.831-10.695-10.876c-5.448-3.043-11.591-2.029-11.591-2.029z'/%3E %3Cpath d='m736.05 504.37s6.793-2.902 12.387-2.153c5.595 0.749 10.639 5.171 10.639 5.171s-7.561 2.616-13.155 1.868c-5.596-0.749-9.872-4.886-9.872-4.886z'/%3E %3Cpath d='m764.76 472.79s-6.007 6.364-6.511 11.887c-0.503 5.522 4.871 10.669 4.871 10.669s-0.264-3.542 0.661-5.874c0.926-2.332 2.893-4.822 2.893-4.822s0.838-2.843 0.514-5.123c-0.453-3.186-2.428-6.737-2.428-6.737z'/%3E %3Cpath d='m773.38 480.16s-5.662 5.729-7.158 11.864c-1.497 6.135 1.17 12.676 1.17 12.676s5.149-4.062 6.646-10.196c1.497-6.135-0.659-14.344-0.659-14.344z'/%3E %3Cpath d='m787.56 517.14s2.565 5.355 3.215 9.833c0.652 4.477 0.048 6.027 0.048 6.027s-2.652 2.607-3.841 4.14c-1.528 1.97-1.752 5.576-1.752 5.576s-5.325-7.916-4.504-13.703c0.82-5.786 6.834-11.874 6.834-11.874z'/%3E %3Cpath d='m798.78 529.53s-6.818 4.503-9.523 9.123c-2.708 4.617-1.304 9.349-1.304 9.349s4.858-0.428 7.566-5.046c2.706-4.618 3.26-13.427 3.26-13.427z'/%3E %3Cpath d='m753.98 548.55s9.826-0.268 15.832 1.209c6.006 1.475 8.192 4.695 8.192 4.695s-6.753 3.162-12.759 1.686c-6.006-1.475-11.266-7.591-11.266-7.591z'/%3E %3Cpath d='m752.32 536.89s4.433 6.873 10.164 9.367c7.898 3.435 17.043 1.77 17.043 1.77s-4.968-6.089-11.804-8.777c-6.838-2.687-15.403-2.359-15.403-2.359z'/%3E %3C/g%3E %3Cpath fill='%23000' d='m1088.74,401.944,1.281,2.712s-2.08,0.714-3.022,2.559c-0.94,1.847,0.615,4.455,0.615,4.455s-10.804-0.943-12.491,0.154c-1.528,0.99,0.647,8.474-0.359,14.795-1.402,8.81-4.875,8.07-5.017,9.777-0.138,1.659,1.331,4.249,1.331,4.249s-2.026,0.638-2.458,1.485c-0.695,1.362,0.484,3.875-0.358,5.528-4.7,9.223-11.64,22.836-16.228,31.843-0.641,1.257-2.363,1.737-3.226,3.43-0.796,1.562-0.153,3.839-0.153,3.839s-3.041,0.182-4.096,2.253c-1.121,2.2-0.461,5.17-0.461,5.17s-1.923,0.246-2.868,2.099c-1.009,1.981,0.7,3.02,0.259,3.891-6.169,12.102-13.434,26.368-17.867,35.068-1.631,3.199-7.338,3.84-10.65,10.341-3.214,6.306,1.382,10.955,1.382,10.955s-4.772,0.432-6.04,2.919c-1.292,2.535-0.27,6.384,3.174,8.139,3.444,1.754,7.207,0.334,8.5-2.201,1.267-2.487-1.281-6.604-1.281-6.604s6.463,0.931,9.675-5.376c3.313-6.501,0.52-11.441,2.15-14.641,4.434-8.7,11.7-22.965,17.867-35.068,0.445-0.871,2.267-0.117,3.276-2.098,0.944-1.853,0-3.532,0-3.532s2.822-1.23,3.943-3.431c1.056-2.071-0.563-4.658-0.563-4.658s2.223-0.792,3.02-2.354c0.862-1.693,0.228-3.35,0.869-4.609,4.59-9.006,11.531-22.62,16.229-31.841,0.843-1.655,3.555-2.221,4.249-3.585,0.432-0.846-0.255-2.866-0.255-2.866s2.988-0.296,4.248-1.383c1.298-1.118-1.337-3.516,4.967-9.829,4.522-4.528,11.817-7.192,11.722-9.01-0.105-2.01-7.218-10.187-7.218-10.187s3.001-0.253,3.942-2.098c0.941-1.846,0.308-3.994,0.308-3.994l2.968-0.512,0.0005-14.078zm-98.136,196.074c-0.448,0.877-0.53,2.076,0,3.121,0,0-3.583-1.12-4.812-0.512-1.158,0.573,0,17.458,0,17.458s14.295-9.018,14.077-10.29c-0.23-1.352-3.225-3.635-3.225-3.635,1.158-0.186,2.061-0.912,2.509-1.791,0.47-0.925,0.533-3.568-2.714-5.223-1.216-0.62-2.299-0.804-3.1745-0.716-1.4555,0.147-2.3655,1.01-2.6605,1.588z'/%3E %3Cg fill='%23f5d402'%3E %3Cpath d='m1091.34,402.51,6.757,3.431-0.101-8.1405z'/%3E %3Cpath d='m1088.73,407.425c-0.868,1.704-0.025,3.886,1.894,4.863,1.92,0.977,4.148,0.373,5.018-1.33,0.868-1.704,0.023-3.885-1.895-4.863-0.72-0.367-1.476-0.511-2.2015-0.4615-1.2075,0.0825-2.2725,0.7265-2.8155,1.7915z'/%3E %3Cpath d='m1077.11,413.62c-0.711,0.46,0.256,6.545,0.051,11.722-0.194,4.882-1.756,6.257-2.611,7.935-0.789,1.549-3.634,3.379-3.634,3.379l2.354,2.355s1.532-2.386,3.942-7.118c2.843-5.579,2.751-15.688,3.585-16.227,0.725-0.469,6.655-1.946,6.655-1.946-0.001,0-5.442-0.294-8.447-0.2545-1.003,0.0125-1.73,0.0475-1.895,0.1545z'/%3E %3Cpath d='m1077.73,441.725s0.787-2.188,3.533-7.577c3.311-6.499,10.379-11.213,10.544-12.389,0.172-1.212-2.4565-6.9105-2.4565-6.9105s-6.2355,1.1955-7.1175,2.0485c-0.852,0.823-0.476,9.267-3.788,15.767-2.744,5.388-4.094,7.372-4.094,7.372z'/%3E %3Cpath d='m1093.65,422.22c0.052,0.989-8.163,6.861-11.007,12.439-2.41,4.731-3.43,7.373-3.43,7.373l3.277,0.512s-0.226-3.367,0.563-4.915c0.854-1.677,1.079-3.731,4.915-6.757,4.068-3.209,9.567-6.014,9.522-6.861-0.041-0.782-6.1435-8.344-6.1435-8.344s2.2565,5.692,2.3035,6.553z'/%3E %3Cpath d='m1069.59,458.72c4.936-9.688,6.444-10.348,7.065-11.569,0.669-1.312,0.509-3.078-1.689-4.199-0.824-0.419-1.531-0.526-2.1495-0.459-1.0335,0.111-1.7845,0.767-2.2015,1.586-0.622,1.222-0.285,2.855-5.223,12.544l-11.212,21.961s-1.175,2.156,1.024,3.276c2.199,1.119,3.174-1.127,3.174-1.127z'/%3E %3Cpath d='m1049.78,483.908c-0.611,1.201,0.436,2.964,2.355,3.943,1.919,0.976,3.996,0.791,4.607-0.41,0.611-1.2-0.486-2.964-2.406-3.943-0.959-0.489-1.935-0.687-2.7645-0.613-0.8295,0.072-1.4855,0.424-1.7915,1.023z'/%3E %3Cpath d='m1045.63,490.153c-0.792,1.553,0.443,3.783,2.765,4.968,2.322,1.183,4.84,0.886,5.631-0.667,0.792-1.554-0.444-3.782-2.765-4.967-0.871-0.442-1.733-0.677-2.5595-0.716-1.3745-0.065-2.5765,0.411-3.0715,1.382z'/%3E %3Cpath d='m1043.02,497.117c-0.611,1.199,0.437,2.963,2.355,3.941,1.919,0.978,3.995,0.791,4.608-0.409,0.611-1.2-0.437-2.964-2.355-3.942-0.96-0.49-1.986-0.688-2.8155-0.615-0.8285,0.073-1.4855,0.424-1.7925,1.025z'/%3E %3Cpath d='m1041.33,503.772s-12.448,24.5-16.84,33.121c-1.404,2.754-7.312,4.47-9.625,9.011-2.33,4.568-0.686,8.844,2.354,10.392,3.039,1.549,7.502,0.423,9.83-4.146,2.313-4.54,0.235-10.353,1.637-13.106,4.393-8.624,16.843-33.122,16.843-33.122s1.226-2.156-0.973-3.276c-0.55-0.28-1.028-0.308-1.433-0.2555-1.212,0.1555-1.793,1.3815-1.793,1.3815z'/%3E %3Cpath d='m1009.84,560.646c-0.933,1.83,0.134,4.269,2.405,5.426,2.272,1.158,4.904,0.601,5.837-1.228,0.933-1.83-0.186-4.27-2.457-5.427-0.852-0.435-1.721-0.637-2.56-0.6135-1.399,0.0395-2.643,0.6995-3.225,1.8425z'/%3E %3Cpath d='m993.257,598.069c-0.71,0.024-1.298,0.249-1.535,0.717-0.477,0.935,0.508,2.413,2.201,3.276,1.693,0.862,3.464,0.782,3.942-0.154,0.477-0.937-0.51-2.414-2.201-3.276-0.847-0.432-1.695-0.588-2.407-0.564z'/%3E %3Cpath d='m987.421,602.675v12.082l9.83-7.065s-1.333-2.354-4.25-3.84c-2.917-1.485-5.58-1.178-5.58-1.178z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23f5d402' d='m993.643,333.597c0-6.626,8.703-13.157,8.703-13.157h-212.246s8.703,6.53,8.703,13.157v157.986c0,4.162,1.286,6.872,3.328,9.521,2.041,2.853,6.39,6.795,10.903,9.727,13.94,9.053,37.246,18.599,54.88,26.621,14.694,6.684,20.671,9.381,28.309,18.839,7.639-9.458,13.667-12.154,28.361-18.839,17.631-8.021,40.938-17.568,54.879-26.621,4.515-2.932,8.864-6.873,10.904-9.727,2.042-2.649,3.276-5.359,3.276-9.521z'/%3E %3Cpath fill='%23d10429' d='m803.82,422.981,0-89.385c0-5.059-2.5605-8.139-2.5605-8.139h189.928s-2.56,3.081-2.56,8.139l0.054,89.385-92.4305,28z'/%3E %3Cpath fill='%230b45bb' d='m988.681,422.981-57.234-1.075-70.393,0-57.234,1.075,0,68.601c0,3.448,3.578,11.525,24.215,21.807,34.111,16.998,60.33,24.934,68.189,34.607,7.858-9.673,34.077-17.61,68.189-34.607,20.636-10.282,24.214-18.359,24.214-21.807z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m930.063,419.401s33.019-8.326,33.019-43.617c0-27.563-33.103-41.237-34.044-47.814-3.235,11.381,11.058,27.1,11.058,45.715,0,24.086-17.764,25.239-17.764,25.239-4.157,0-5.841,2.968-7.475,2.968-3.497-0.365-5.143-4.813-8.601-4.813-3.247,0-5.74,5.017-10.033,5.017-4.292,0-6.735-5.017-9.983-5.017-3.456,0-5.103,4.448-8.6,4.813-1.634,0-3.319-2.968-7.476-2.968,0,0-17.763-1.153-17.763-25.239,0-18.615,14.295-34.336,11.058-45.715-0.938,6.577-34.041,20.25-34.041,47.814,0,35.291,33.019,43.617,33.019,43.617l-9.42,17.149s13.645,0.683,20.887,6.861c8.733,7.448,7.883,23.229,7.883,34.709,0,9.045-1.143,18.59-5.784,22.524-6.232,5.284-10.445,5.675-10.445,11.878,0,5.174,3.977,6.211,10.445,9.625,8.287,4.373,7.901,10.238,20.22,10.238,12.321,0,11.985-5.864,20.273-10.238,6.468-3.414,10.444-4.451,10.444-9.625,0-6.203-4.214-6.594-10.444-11.878-4.641-3.936-5.784-13.48-5.784-22.524,0-11.48-0.849-27.261,7.883-34.709,7.243-6.177,20.886-6.861,20.887-6.861z'/%3E %3Cpath d='m896.22,330.42-5.735,16.281-15.614-7.424,7.423,15.615-16.279,5.784,16.279,5.785-7.423,15.563,15.614-7.423,5.735,16.279,5.785-16.279,15.614,7.423-7.422-15.563,16.279-5.785-16.279-5.784,7.422-15.615-15.614,7.424-5.785-16.281z'/%3E %3Cpath d='m861.05,421.91s-20.387-4.984-28.002-15.051c-13.313,11.976-29.232,16.126-29.232,16.126s16.607,7.498,29.232,17.048c5.817-8.336,28.002-18.123,28.002-18.123z'/%3E %3Cpath d='m931.44,421.91s22.186,9.786,28.004,18.123c12.623-9.55,29.229-17.048,29.229-17.048s-15.917-4.151-29.229-16.126c-7.615,10.066-28.004,15.051-28.004,15.051z'/%3E %3Cpath d='m869.4,443.61-7.935,7.934,7.935,7.935,7.935-7.935-7.935-7.934z'/%3E %3Cpath d='m923.1,443.61-7.934,7.934,7.934,7.935,7.935-7.935-7.935-7.934z'/%3E %3Cpath d='m867.403,489.94c0,10.025-0.972,15.307-0.972,15.307s11.186-3.293,13.414-14.641c1.044-5.32,2.207-24.918-3.175-28.259l-14.5895-2.867c1.5755,3.899,5.3225,15.977,5.3225,30.46z'/%3E %3Cpath d='m915.829,462.348c-5.381,3.34-4.218,22.938-3.174,28.259,2.227,11.348,13.413,14.641,13.413,14.641s-0.972-5.282-0.972-15.307c0-14.483,3.747-26.562,5.3245-30.4605z'/%3E %3Cpath d='m833.005,462.915c-5.031,1.262-8.071,6.385-6.808,11.416,0.193,0.77,0.511,1.481,0.87,2.15-0.733-0.244-1.498-0.406-2.304-0.461-0.323-0.022-0.655-0.011-0.972,0-4.761,0.16-8.73,3.903-9.061,8.755-0.354,5.174,3.579,9.629,8.755,9.983,0.772,0.052,1.523,0.024,2.251-0.103-0.445,0.611-0.83,1.263-1.125,1.996-1.937,4.813,0.409,10.351,5.222,12.288,4.812,1.935,10.298-0.461,12.234-5.273,0.296-0.735,0.461-1.452,0.564-2.202,0.443,0.615,0.976,1.179,1.586,1.689,3.979,3.328,9.931,2.801,13.259-1.177,3.329-3.978,2.801-9.881-1.178-13.208-0.602-0.504-1.27-0.9-1.945-1.228,0.723-0.232,1.426-0.552,2.098-0.972,4.395-2.755,5.725-8.609,2.969-13.004-1.894-3.021-5.222-4.574-8.549-4.351-1.513,0.101-3.029,0.572-4.403,1.434-0.671,0.421-1.267,0.888-1.791,1.433,0.001-0.756-0.064-1.534-0.256-2.303-1.104-4.403-5.151-7.305-9.5215-7.117-0.6245,0.027-1.2655,0.098-1.8945,0.255z'/%3E %3Cpath d='m932.825,490.25c1.017,9.587,8.808,17.619,18.429,19.914-1.643-2.687-2.735-5.682-3.072-8.856-1.205-11.37,7.588-20.581,19.607-20.581,1.894,0,3.729,0.234,5.528,0.667-4.237-6.947-12.215-11.775-20.887-11.7745-12.018,0.0005-20.813,9.2625-19.605,20.6305z'/%3E %3C/g%3E %3Cg fill='%23ffd200'%3E %3Cpath d='m847.592,373.684c0,18.128,9.667,28.821,22.576,28.821,2.462,0,5.155,3.328,7.475,3.328,3.782,0,6.298-4.198,8.601-4.198,2.927,0,4.9,4.607,9.982,4.607,5.083,0,7.107-4.607,10.034-4.607,2.302,0,4.818,4.198,8.6,4.198,2.321,0,5.012-3.328,7.475-3.328,12.909,0,22.577-10.693,22.577-28.821,0-14.784-12.416-32.81-11.058-35.734,0,0,24.214,17.369,24.214,37.832,0,32.963-33.429,41.109-33.429,41.109l7.525,16.944s-10.362,1.554-16.689,6.656c-8.439,6.805-8.55,25.191-8.55,37.626,0,14.648,0.545,20.855,5.837,24.829,5.58,4.193,9.777,5.096,9.777,9.369,0,3.723-4.345,5.246-9.983,7.73-6.413,2.827-7.052,7.731-16.33,7.731-9.279,0-9.867-4.904-16.28-7.731-5.637-2.484-9.983-4.006-9.983-7.73,0-4.273,4.197-5.176,9.777-9.369,5.292-3.974,5.836-10.181,5.836-24.829,0-12.435-0.11-30.821-8.549-37.626-6.328-5.104-16.689-6.656-16.689-6.656l7.524-16.944s-33.428-8.145-33.428-41.109c0-20.463,24.215-37.832,24.215-37.832,1.358,2.924-11.057,20.95-11.057,35.734zm35.988,136.126c-6.567,0-10.75,1.386-10.75,3.379,0,1.994,4.184,3.328,10.75,3.328,1.75,0,3.737-1.019,3.737-3.328s-1.988-3.379-3.737-3.379zm25.34,0c-1.75,0-3.737,1.071-3.737,3.379-0.001,2.309,1.987,3.328,3.737,3.328,6.568,0,10.75-1.333,10.75-3.328,0-1.994-4.183-3.379-10.75-3.379z'/%3E %3Cpath d='m896.28,341.38,3.686,10.394,9.931-4.761-4.71,9.982,10.342,3.687-10.342,3.686,4.71,9.931-9.931-4.71-3.737,10.341-3.686-10.341-9.931,4.71,4.71-9.931-10.341-3.686,10.341-3.687-4.71-9.982,9.931,4.761,3.737-10.394z'/%3E %3Cpath d='m850.147,422.528c-0.002,0-17.099,12.696-17.099,12.696l-0.206,0.255-0.358-0.307-18.941-11.877s12.087-4.167,19.1975-11.4155c6.7285,7.7035,17.4065,10.6485,17.4065,10.6485z'/%3E %3Cpath d='m978.948,423.295s-12.609,6.28-18.943,11.877l-0.357,0.307-0.204-0.255c-5.986-6.871-17.098-12.696-17.098-12.696s10.676-2.945,17.4045-10.648c7.1115,7.248,19.1975,11.415,19.1975,11.415z'/%3E %3Cpath d='m869.4,447.4,4.147,4.145-4.147,4.199-4.198-4.199,4.198-4.145z'/%3E %3Cpath d='m923.1,447.4,4.199,4.145-4.199,4.199-4.146-4.199,4.146-4.145z'/%3E %3Cpath d='m875.033,465.519c2.897,3.998,2.405,10.462,2.405,19.455,0,9.067-6.808,12.541-6.808,12.541,0-21.794-2.247-27.034-3.43-33.6345z'/%3E %3Cpath d='m925.3,463.88c-1.185,6.602-3.429,11.841-3.429,33.634,0,0-6.809-3.474-6.809-12.541,0-8.993-0.492-15.455,2.406-19.454l7.832-1.639z'/%3E %3Cpath id='leaf' d='m842.832,472.128c0.204,0.816,0.226,1.618,0.153,2.407-0.06,0.654-0.234,1.248-0.46,1.842-1.133-0.414-2.359-0.615-3.635-0.615-3.159,0-5.987,1.39-7.935,3.585-0.511-0.452-0.955-0.952-1.33-1.536-0.42-0.649-0.775-1.359-0.973-2.15-0.982-3.913,1.411-7.876,5.324-8.857,0.488-0.124,1-0.185,1.4845-0.2045,3.3925-0.1455,6.5115,2.1055,7.3715,5.5285z'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(72,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(144,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(216,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(288,838.89,486.468)'/%3E %3Ccircle cx='838.890' cy='486.468' r='7.065'/%3E %3Cpath d='m962.925,476.942c-11.729,2.268-20.17,12.628-18.942,24.727-3.738-3.096-6.473-7.266-6.962-11.877-0.951-8.979,5.571-15.922,15.4095-15.922,3.7615,0,7.3755,1.152,10.4945,3.072z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='640' height='320'%3E %3Crect width='640' height='320' fill='%23d3ae3b'/%3E %3Crect width='608' height='288' x='16' y='16' fill='%23c40308'/%3E %3Cg%3E %3Cpath fill='%23B96B29' d='M389.64,157.4c1.874-0.529,8.39-2.433,12.981-6.158,4.591-3.726,5.487-6.711,5.858-8.323,0.368-1.612,0.527-2.88-0.66-1.955-1.187,0.923-4.749,3.725-7.176,5.073-2.429,1.347-4.672,1.982-5.991,2.353-1.319,0.368-2.375,0.606-1.107,0.104,1.265-0.501,5.409-1.956,8.602-5.152,3.192-3.197,5.714-7.988,5.768-10.93,0.053-2.941-0.157-2.732-1.103-1.996-0.946,0.735-4.308,4.886-6.198,6.461-1.891,1.577-4.938,3.678-6.461,4.57-1.524,0.894-3.677,1.892-0.683-0.157,2.994-2.047,8.666-6.881,10.979-13.132,2.311-6.251,1.89-9.927,1.838-10.558-0.052-0.63-0.578-1.891-1.103-0.734-0.525,1.154-4.309,8.719-7.354,11.975-3.048,3.257-2.312,2.627-2.995,3.152-0.682,0.525-1.839,1.471-0.366-0.369,1.471-1.837,4.517-6.093,6.094-10.294,1.574-4.203,1.995-8.406,2.047-10.822,0.053-2.416-0.997-5.777-1.471-6.774-0.472-1-0.945-1.734-1.104-0.58-0.156,1.156-2.573,8.615-3.887,12.239-1.313,3.625-3.938,7.723-4.465,8.511-0.524,0.788-1.89,2.416-0.42-0.315,1.471-2.732,4.307-10.769,4.676-18.385,0.367-7.617-0.683-11.819-1.734-13.92-1.05-2.102-1.96-2.847-1.96-2.847s0.18,5.2-1.372,12.67c-1.553,7.471-3.819,11.415-3.819,11.415s-0.954,1.076-0.3-0.717c0.443-1.206,1.354-3.86,1.771-8.358,0.439-4.719,0.491-10.088-0.887-14.659-1.5-4.978-4.104-7.523-4.104-7.523-0.726,7.142-0.582,16.344-3.199,23.803-0.49-0.438-1.138-1.248-1.396,0.401-0.478,2.451-1.433,7.053-4.654,12.91-3.224,5.857-4.535,6.634-4.535,6.634s-0.597-1.435-1.016-2.211c-0.417-0.777-0.656-1.196-1.194-0.12-0.535,1.076-2.326,5.2-6.266,9.742-3.938,4.542-6.146,6.753-6.026,10.159,0.12,3.407,1.909,5.141,4.296,6.694,2.388,1.555,2.807,2.39,2.447,4.243-0.358,1.854-2.507,2.51-4.355,2.57-1.852,0.06-4.179-0.12-5.014,0.358-0.836,0.479-0.895,1.673-1.731,2.509-0.834,0.838-1.192,1.314-1.969,1.436-0.273,0.042-0.495,0.067-0.667,0.086-0.172-8.985,3.31-12.991,3.31-12.991l-9.731-11.433c-0.503,0.247-1.005,0.478-1.509,0.696-0.068-0.132-0.162-0.276-0.285-0.432-1.295-1.654-1.719-3.056-1.719-5.176,0.484,0.048,1.455,0.398,2.337,0.221,0.882-0.176,0.22-1.061-0.044-1.901-0.265-0.842-0.53-3.76-0.354-4.866,0.177-1.106,0.264-1.549,0.264-1.549s1.413,1.549,2.294,1.549c0.884,0,0.794-0.884,0.927-1.858,0.199-1.467,0.889-3.319,2.028-4.335,0,0,1.543,1.063,3.309,1.063,1.763,0,4.144-0.487,6.04-2.3,1.897-1.813,1.853-2.256,1.853-2.256s3.527,1.238,6.218,1.372c2.69,0.132,5.557-0.311,6.924-3.141,1.367-2.831-0.398-5.44-0.705-5.883-0.31-0.443-1.191-0.797-1.191,0s0.045,2.919-1.588,3.981c-1.632,1.061-2.91,1.016-4.454,0.53-1.543-0.486-3.704-1.106-6.174-0.752-2.215,0.317-2.515,0.492-2.553,0.525,0.115-0.118,2.126-2.18,4.096-2.781,2.029-0.619,3.221,0.221,3.882,1.017s1.234,2.08,1.764,0.221c0.529-1.857,0.221-3.98-0.661-5.352-0.883-1.371-2.778-2.256-4.763-2.034-1.985,0.221-2.689,0.53-2.689,0.53s-1.016-2.874-3.573-3.405c-3.12-0.648-6.562,0.525-9.261,2.034,0,0-2.117,0.488-4.277-0.132-1.415-0.406-2.83-1.267-3.639-1.811,0.246-0.827,0.73-2.354,0.73-2.354s0.618-0.188,1.264-0.431c0.646-0.242,0.512-0.458,0.593-0.996,0.08-0.538-1.214-1.475-1.214-1.475s-0.187-1.617,1.94-2.726c2.126-1.109,1.895-0.924,1.895-0.924s1.247,0.231,1.756-0.139c0.508-0.37,0.508-0.601,0.508-0.601s0.942-0.309,1.288-0.877c0.345-0.567,0.409-1.387,0.156-2.049-0.25-0.663-0.567-0.789-0.219-1.105,0.345-0.315,0.66-1.072,0.691-1.608,0.032-0.538,0.032-0.662,0.032-0.662s0.723-0.254,0.69-1.357c-0.032-1.105-0.629-1.547-0.976-1.642-0.345-0.094-0.564-0.094-0.564-0.094s-0.063-0.663-0.629-1.545c-0.568-0.884-0.944-1.262-0.944-1.262s0.408-0.313,0.188-1.039c-0.22-0.726-0.724-1.167-1.227-1.327-0.503-0.157-1.037,0-1.037,0s-1.667-1.009-2.453-1.419c-0.787-0.41-0.976-0.504-0.976-0.504s-0.031-0.694-0.314-1.073-0.944-0.537-1.29-0.537-0.723,0.19-0.723,0.19-2.832-0.727-3.995-0.916c-1.164-0.189-1.228-0.284-1.228-0.284s-2.515-1.199-3.489-1.388c-0.976-0.189-1.258-0.283-1.258-0.283s1.018-1.232,1.08-2.651c0.064-1.42-0.879-2.759-1.885-3.358-0.568-0.337-0.873-0.393-1.058-0.509l-0.021-0.977,1.89,0.19,0.156-3.042-1.84,0.233,0.282-1.831-3.856-0.044,0.282,1.83-1.855-0.127,0.157,2.998,1.951-0.252-0.189,1.134s-0.714,0.121-1.319,0.567c-1.006,0.6-1.857,1.768-1.794,3.188,0.062,1.419,0.911,2.682,0.911,2.682s-0.251,0.063-1.226,0.251c-0.975,0.189-3.492,1.388-3.492,1.388s-0.063,0.094-1.227,0.284c-1.163,0.189-3.994,0.916-3.994,0.916s-0.377-0.19-0.724-0.19c-0.346,0-1.006,0.158-1.289,0.537-0.283,0.378-0.314,1.073-0.314,1.073s-0.189,0.095-0.976,0.504c-0.787,0.41-2.453,1.419-2.453,1.419s-0.536-0.157-1.039,0c-0.503,0.159-1.006,0.601-1.226,1.327s0.188,1.039,0.188,1.039-0.378,0.378-0.944,1.262c-0.565,0.882-0.628,1.545-0.628,1.545s-0.221,0-0.566,0.094c-0.346,0.095-0.944,0.537-0.975,1.642-0.032,1.103,0.692,1.357,0.692,1.357s0,0.125,0.031,0.662c0.032,0.537,0.347,1.293,0.692,1.608,0.346,0.316,0.032,0.442-0.22,1.105-0.251,0.662-0.189,1.482,0.157,2.049,0.346,0.568,1.287,0.877,1.287,0.877s0,0.231,0.508,0.601c0.508,0.37,1.756,0.139,1.756,0.139s-0.23-0.185,1.895,0.924c2.125,1.109,1.94,2.726,1.94,2.726s-1.294,0.938-1.213,1.475c0.081,0.538-0.054,0.754,0.592,0.996,0.646,0.243,1.265,0.431,1.265,0.431s0.483,1.526,0.729,2.354c-0.809,0.544-2.223,1.405-3.637,1.811-2.161,0.62-4.279,0.132-4.279,0.132-2.697-1.509-6.139-2.682-9.26-2.034-2.558,0.531-3.573,3.405-3.573,3.405s-0.705-0.309-2.689-0.53c-1.984-0.222-3.881,0.663-4.764,2.034-0.882,1.372-1.19,3.495-0.661,5.352,0.529,1.859,1.103,0.575,1.764-0.221,0.662-0.796,1.853-1.636,3.881-1.017,1.97,0.601,3.981,2.663,4.096,2.781-0.039-0.033-0.337-0.208-2.553-0.525-2.469-0.354-4.63,0.266-6.173,0.752s-2.822,0.531-4.454-0.53c-1.632-1.063-1.588-3.185-1.588-3.981s-0.882-0.443-1.19,0-2.073,3.053-0.706,5.883c1.367,2.83,4.233,3.273,6.923,3.141,2.69-0.134,6.218-1.372,6.218-1.372s-0.043,0.443,1.853,2.256c1.896,1.813,4.277,2.3,6.042,2.3s3.307-1.063,3.307-1.063c1.139,1.017,1.831,2.869,2.029,4.335,0.132,0.974,0.045,1.858,0.927,1.858,0.881,0,2.293-1.549,2.293-1.549s0.088,0.443,0.264,1.549c0.176,1.106-0.088,4.024-0.353,4.866-0.264,0.84-0.926,1.725-0.043,1.901,0.882,0.177,1.852-0.173,2.337-0.221,0,2.12-0.425,3.522-1.72,5.176-0.114,0.146-0.204,0.281-0.272,0.407-0.482-0.211-0.964-0.434-1.446-0.671l-9.731,11.433s3.498,4.025,3.309,13.059v-0.063c-0.177-0.017-0.413-0.045-0.708-0.09-0.777-0.121-1.134-0.598-1.97-1.436-0.835-0.836-0.895-2.03-1.73-2.509s-3.163-0.299-5.013-0.358c-1.851-0.061-3.998-0.717-4.357-2.57-0.357-1.854,0.061-2.688,2.447-4.243,2.387-1.554,4.177-3.287,4.297-6.694,0.119-3.406-2.088-5.618-6.027-10.159-3.939-4.542-5.729-8.666-6.266-9.742s-0.776-0.657-1.194,0.12c-0.418,0.776-1.014,2.211-1.014,2.211s-1.313-0.777-4.535-6.634c-3.223-5.857-4.178-10.458-4.655-12.91-0.259-1.649-0.908-0.838-1.396-0.401-2.62-7.459-2.475-16.662-3.2-23.803,0,0-2.604,2.545-4.104,7.523-1.377,4.57-1.325,9.94-0.886,14.659,0.417,4.498,1.327,7.153,1.769,8.358,0.656,1.793-0.298,0.717-0.298,0.717s-2.268-3.944-3.819-11.415c-1.552-7.47-1.373-12.67-1.373-12.67s-0.909,0.745-1.96,2.847c-1.05,2.101-2.1,6.303-1.733,13.92,0.368,7.617,3.205,15.653,4.676,18.385,1.471,2.731,0.105,1.103-0.421,0.315-0.525-0.788-3.151-4.885-4.465-8.511-1.313-3.624-3.729-11.083-3.887-12.239-0.158-1.155-0.63-0.42-1.104,0.58-0.473,0.998-1.523,4.359-1.471,6.774,0.053,2.416,0.473,6.619,2.049,10.822,1.576,4.202,4.622,8.457,6.093,10.294,1.471,1.84,0.315,0.894-0.368,0.369s0.053,0.104-2.994-3.152-6.829-10.821-7.354-11.975c-0.526-1.157-1.051,0.104-1.104,0.734-0.052,0.631-0.473,4.307,1.839,10.558,2.311,6.251,7.984,11.085,10.979,13.132,2.994,2.049,0.84,1.051-0.683,0.157-1.523-0.892-4.57-2.993-6.461-4.57-1.891-1.575-5.253-5.726-6.198-6.461-0.946-0.736-1.155-0.946-1.103,1.996s2.575,7.732,5.768,10.93c3.192,3.196,7.334,4.651,8.602,5.152,1.267,0.502,0.211,0.264-1.109-0.104-1.318-0.37-3.561-1.006-5.989-2.353-2.428-1.349-5.989-4.15-7.177-5.073-1.188-0.925-1.029,0.343-0.66,1.955,0.37,1.612,1.267,4.598,5.857,8.323,4.591,3.726,11.108,5.629,12.981,6.158,1.874,0.527,0.554,0.527,0.554,0.527s-0.739-0.104-4.538-0.952c-3.799-0.845-9.552-3.856-11.109-4.834-1.557-0.979-1.793-1.348-1.583,0.713,0.212,2.06,2.402,6.474,5.911,8.535s9.842,3.119,11.478,3.197c1.636,0.08,1.214,0.317,0.475,0.369-0.739,0.053-2.56,0.053-5.541-0.289-2.444-0.282-6.074-1.469-7.305-1.889-0.138-0.526-0.265-1.036-0.323-1.35-0.145-0.785-0.551-0.669-0.813-0.493-0.262,0.172-0.407,0.318-1.276,0.755-0.872,0.438-0.901-0.086-0.93-0.348-0.029-0.264-0.203-1.399-0.232-1.979-0.029-0.584-0.349-0.613-0.754-0.438-0.407,0.176-2.352,0.99-3.077,1.312-0.726,0.319-0.058,0.901,0.319,1.599,0.377,0.701,0.958,1.719,0.958,1.719s-1.829,0.495-2.41,0.641c-0.58,0.146-0.406,0.554-0.261,0.962,0.146,0.406,1.045,2.445,1.277,3.027s0.755,0.233,0.755,0.233l1.828-1.077,0.638,2.444c-0.031,0.039-0.845,0.194-1.77,0.843-0.924,0.648-0.693,1.483,0.416,1.808,1.108,0.324,2.403,0.881,3.835,3.476,1.432,2.597,1.802,7.276,2.68,14.647,0.878,7.367,5.591,11.122,6.238,11.586s0.277,0.834,0.277,0.834-0.647,0.929-0.369,2.365c0.277,1.435,1.524,2.271,2.171,2.502,0.646,0.23,0.462,0.88,0.462,0.88s-0.324,1.575,0,4.45c0.323,2.873,2.68,6.117,3.327,6.674,0.646,0.555,0.693,0.834,0.601,1.066-0.092,0.231-0.509,0.047-1.294,0.648-0.786,0.603-1.664,1.437-2.217,2.456-0.555,1.021-0.37,1.623-0.186,3.014,0.185,1.391,2.218,2.642,2.218,2.642s-0.37,0.093-0.461,1.112c-0.092,1.02,0.646,2.178,1.571,2.919,0.924,0.742,2.68,1.113,2.68,1.113s0.139,0.88,0.231,1.482c0.092,0.604,1.248,1.204,1.987,1.622,0.739,0.417,2.171,0.186,2.772-0.093,0.6-0.277,1.016,0.047,1.385,0.648,0.371,0.604,0.232,2.92,0.232,3.848,0,0.927-0.555,1.9-0.232,2.364,0.324,0.463,1.202,0.138,2.08-0.371,0.878-0.511,1.109-0.139,1.895,0.371,0.786,0.509,2.033,0.974,2.357,0.927,0.323-0.047,0.185-0.881,0.185-1.576s0.125-2.268,0.448-2.5c0.153-0.11,1.513-0.211,2.555-0.652,0.485-0.204,1.109-0.416,1.155-0.88,0.046-0.463-0.647-0.463-2.171-1.251-1.525-0.787-1.802-1.253-2.772-1.901-0.971-0.648-0.508-0.88-0.508-1.158,0-0.276,0.461-0.602,0.646-0.973s0.092-1.204,0.092-1.204,0.786-0.788,1.155-1.206c0.37-0.416,0.832-1.067,1.34-1.483s1.293-2.409,1.802-3.059c0.508-0.648,1.664-1.344,2.356-2.225,0.693-0.881,2.542-2.317,3.605-3.013,1.063-0.695,3.927-2.04,3.927-2.04s-0.046,1.715,0.693,2.549c0.739,0.836,1.709-0.647,4.99-2.966,3.281-2.317,5.776-3.151,5.776-3.151s0.693,1.065,1.57,2.178c0.878,1.113,1.664-0.047,5.684-5.607,3.171-4.388,7.348-8.399,8.97-9.898,0.299,0.133,0.595,0.266,0.89,0.402-0.076,0.214-0.16,0.456-0.244,0.721-0.369,1.152-0.967,1.89-1.75,3.5-0.783,1.611-1.979,1.979-3.361,4.145-1.381,2.164-1.565,3.636-1.704,5.847-0.138,2.21,1.105,2.671,1.105,2.671s-2.026,1.979-2.625,3.453c-0.598,1.473-0.921,4.467-0.921,4.467s-0.323,0.137-1.059,1.657c-0.737,1.521-2.073,1.749-4.006,3.684-1.935,1.934-4.098,2.763-5.111,3.359-1.013,0.601-0.737,1.198-0.46,1.981,0.275,0.782,1.657,1.565,3.269,2.164,1.612,0.598,2.164,0.368,3.27,0.322,1.105-0.045,0.23,0.829-0.23,1.288-0.46,0.462-1.059,2.072-0.967,3.868,0.092,1.797,1.428,1.381,3.086,1.105,1.657-0.275,3.591-1.105,3.591-1.105s0,0-0.184,0.508c-0.184,0.506-0.276,0.873-0.276,2.303,0,1.427,0.23,2.117,0.645,2.484,0.415,0.369,1.244-0.413,1.842-0.597,0.599-0.187,1.612-0.783,3.085-1.105,1.473-0.323,2.025-0.967,2.025-0.967s-0.368,0.459-0.46,1.473c-0.093,1.014-0.046,2.532,0.185,3.408,0.229,0.873,0.874,1.933,1.887,2.854,1.013,0.922,1.243,0.507,1.979-0.644,0.737-1.152,2.256-2.626,2.256-2.626s0.092,0.369,1.105,3.638c1.013,3.27,4.328,5.986,4.328,5.986s3.315-2.717,4.328-5.986c1.013-3.269,1.104-3.638,1.104-3.638s1.521,1.474,2.257,2.626c0.737,1.15,0.968,1.565,1.98,0.644,1.013-0.921,1.657-1.98,1.888-2.854,0.23-0.876,0.276-2.395,0.186-3.408-0.094-1.014-0.462-1.473-0.462-1.473s0.553,0.644,2.026,0.967c1.473,0.322,2.486,0.919,3.084,1.105,0.599,0.184,1.429,0.966,1.843,0.597,0.414-0.367,0.645-1.058,0.645-2.484,0-1.43-0.092-1.797-0.276-2.303-0.185-0.508-0.185-0.508-0.185-0.508s1.935,0.83,3.592,1.105,2.992,0.691,3.086-1.105c0.091-1.796-0.508-3.406-0.968-3.868-0.461-0.459-1.335-1.333-0.23-1.288,1.104,0.046,1.657,0.275,3.269-0.322,1.611-0.599,2.993-1.382,3.27-2.164,0.276-0.783,0.553-1.381-0.46-1.981-1.013-0.597-3.178-1.426-5.111-3.359-1.933-1.935-3.27-2.163-4.007-3.684-0.735-1.521-1.057-1.657-1.057-1.657s-0.324-2.994-0.922-4.467c-0.599-1.475-2.625-3.453-2.625-3.453s1.244-0.461,1.105-2.671c-0.138-2.211-0.321-3.683-1.703-5.847-1.382-2.165-2.58-2.533-3.363-4.145-0.782-1.61-1.381-2.348-1.749-3.5-0.073-0.232-0.153-0.464-0.235-0.696,0.395-0.176,0.792-0.351,1.188-0.521,1.611,1.485,5.806,5.51,8.987,9.911,4.021,5.563,4.807,6.722,5.685,5.608,0.877-1.111,1.57-2.177,1.57-2.177s2.495,0.833,5.776,3.15c3.28,2.318,4.251,3.801,4.989,2.967,0.391-0.439,0.478-1.168,0.525-1.727,0,0,1.885,0.551,4.044,1.307,1.295,0.454,2.733,1.026,3.801,1.477,2.842,1.203,3.15,1.822,5.411,3.608s5.48,1.614,8.529,0.686c3.047-0.926,11.167-3.605,14.42-5.014,3.254-1.411,5.584-2.646,5.927-3.3,0.342-0.652,0.718-2.474,0.718-3.125,0-0.653-0.718-1.614-0.959-1.787-0.238-0.173-0.135-0.688-0.068-1.099,0.068-0.413-0.136-1.649-0.649-2.2-0.514-0.55-0.445-0.754-0.377-2.337,0.145-3.351-2.247-7.576-5.636-8.921,0,0-0.091-0.39-0.366-0.62-0.272-0.229-0.73-0.435-0.73-0.435s0.067-1.927,0.045-2.341c-0.022-0.413,0.16-0.365,0.391-0.252,0.228,0.114,0.593,0.574,1.142,0.712,0.549,0.137,0.892-0.254,1.007-0.872,0.113-0.619,0.571-1.858,0.777-2.478,0.207-0.618-0.047-0.711-0.298-0.779-0.251-0.07-1.074-0.16-1.464-0.254-0.388-0.091-0.388-0.114-0.297-0.32,0.093-0.205,0.229-0.526,0.731-1.308,0.504-0.78,0.047-0.803-0.435-0.962-0.48-0.161-2.651-0.826-3.246-0.919-0.596-0.092-0.733,0.413-0.733,0.665,0,0.254,0.023,1.354,0.046,1.767s-0.365,0.298-0.594,0.184c-0.23-0.114-0.755-0.437-1.166-0.758-0.412-0.32-0.709-0.022-0.87,0.437-0.16,0.458-0.662,2.341-0.822,2.891-0.16,0.551-0.115,0.986,0.114,1.077,0.229,0.093,1.303,0,1.944,0,0.639,0,0.273,0.368,0.273,0.368s-0.686,1.124-0.915,1.559c-0.228,0.437-0.617,0.506-1.143,0.506s-1.408-0.007-1.408-0.007-3.514,0.132-6.101,2.056c-2.586,1.923-3.315,3.514-3.713,4.441-0.398,0.93-0.861,0.729-1.261,1.062-0.397,0.332-1.524,1.526-1.524,2.256,0,0.729,0.265,1.126-0.861,1.855-1.129,0.73-2.057,3.913-0.531,5.571,1.525,1.656,2.122,3.313,2.587,4.11,0.462,0.796,0,1.127-0.399,1.127-0.397,0-1.228-0.676-1.922-1.194-0.694-0.517-4.197-3.253-5.702-4.375-1.507-1.124-0.398-0.995-0.398-0.995s0.383,0.035,1.262-0.335c0.877-0.371,1.017-0.833,0.137-1.112-0.877-0.277-2.587-1.251-3.048-1.715-0.463-0.463-0.693-0.973,0.185-1.437,0.877-0.463,2.818-1.715,1.294-2.132-1.526-0.419-3.328-0.741-4.807-1.159-1.479-0.417-1.618-0.834-1.618-0.834l0.972-1.391s0.785-1.111-0.139-1.251-3.142-0.417-5.175-1.299c-4.061-1.759-6.605-4.742-7.548-8.383l0.067-0.088c0.759,1.501,2.525,4.306,5.188,4.393,3.64,0.12,4.057-1.017,3.222-2.212s-1.79-2.271-2.028-2.629c-0.24-0.359-0.3-0.838,0.655,0.06s2.773,3.944,8.264,3.586c5.489-0.358,5.462-1.435,5.462-1.733,0-1.054-1.118-1.221-1.777-1.882-0.344-0.345-0.553-0.846,0.555-0.423s3.824,0.924,7.52,0.131c1.458-0.311,5.324-1.999,5.698-3.962,0,0-2.454-0.134-4.168-0.873-1.716-0.741-2.745-1.347-0.924-0.977,1.821,0.369,5.357,1.108,8.47,0.053,1.819-0.618,4.17-2.09,4.169-4.783,0,0-3.377-0.713-4.617-1.163-1.24-0.449-1.636-0.792-1.636-0.792s4.826,1.531,9.208-0.688c4.38-2.219,4.564-5.257,4.564-5.971s-0.105-0.926-0.105-0.926-3.984,0.979-6.965,0.952c-2.982-0.026-3.906-0.291-3.906-0.291s8.339-0.238,12.533-2.801c4.195-2.563,4.434-7.611,4.434-7.611s-4.751,1.691-7.731,2.036c-2.981,0.342-4.803,0.342-5.541,0.289-0.739-0.052-1.16-0.289,0.475-0.369,1.638-0.078,7.968-1.137,11.478-3.197,3.51-2.062,5.699-6.476,5.911-8.535,0.211-2.061-0.026-1.691-1.584-0.713-1.557,0.978-7.308,3.989-11.107,4.834-3.799,0.848-4.538,0.952-4.538,0.952s-1.46-0.07,0.42-0.59zm-150.1,9.58c-0.406,0.233-1.683,0.96-1.683,0.96s-0.668-1.368-0.842-1.775c-0.174-0.408-0.087-0.583,0.144-0.583,0.233,0,0.93-0.203,1.481-0.261,0.079-0.009,0.151-0.021,0.215-0.036,0.184,0.525,0.426,1.094,0.744,1.665-0.02,0.02-0.04,0.03-0.06,0.04zm51.18,29.97c-1.017,1.902-3.789,3.895-5.822,4.775s-4.251,1.159-5.175,1.297c-0.924,0.139-0.139,1.252-0.139,1.252l0.97,1.392s-0.138,0.416-1.617,0.834c-1.479,0.416-3.28,0.74-4.805,1.158-1.525,0.416,0.416,1.668,1.293,2.133,0.878,0.462,0.647,0.973,0.185,1.436-0.462,0.464-2.171,1.437-3.049,1.715s-0.74,0.743,0.138,1.113c0.878,0.369,3.281,0.833,3.281,0.833s-0.046,0.093-1.524,1.206c-1.479,1.112-4.067,1.854-5.776,1.946-1.71,0.092-4.413,0.204-7.841,0.046-3.427-0.156-3.821-0.235-3.821-0.235s-0.118-1.144-0.355-2.838c-0.236-1.693-1.26-4.097-2.048-5.199-0.789-1.104-2.442-3.31-2.442-3.31s0.039-0.473,0.157-1.024,0.039-1.143-0.361-2.184c-0.401-1.042-2.403-2.563-2.403-2.563s-0.081-1.121-0.081-2.163c0-1.041-0.72-5.126-1.362-7.048-0.64-1.922-3.764-6.968-5.206-9.371-1.442-2.402-2.298-5.964-2.734-8.729-0.436-2.766-0.261-3.668-0.116-4.396,0.064-0.319,0.2-0.609,0.328-0.867,0.592,0.765,1.35,1.489,2.318,2.082,4.195,2.563,12.533,2.801,12.533,2.801s-0.924,0.265-3.905,0.291c-2.981,0.026-6.965-0.952-6.965-0.952s-0.106,0.212-0.106,0.926,0.186,3.752,4.565,5.971c4.379,2.22,9.208,0.688,9.208,0.688s-0.396,0.343-1.636,0.792c-1.24,0.45-4.617,1.163-4.617,1.163,0,2.693,2.351,4.165,4.168,4.783,3.114,1.056,6.649,0.316,8.471-0.053,1.82-0.37,0.792,0.235-0.924,0.977-1.714,0.739-4.168,0.873-4.168,0.873,0.376,1.963,4.242,3.651,5.699,3.962,3.694,0.793,6.411,0.292,7.52-0.131s0.897,0.078,0.554,0.423c-0.659,0.661-1.777,0.828-1.777,1.882,0,0.299-0.028,1.375,5.462,1.733s7.308-2.688,8.263-3.586c0.955-0.897,0.895-0.419,0.656-0.06-0.238,0.357-1.193,1.434-2.028,2.629-0.836,1.195-0.418,2.332,3.222,2.212,2.681-0.088,4.455-2.932,5.204-4.424l0.05,0.069c0.049,0.067,0.099,0.133,0.147,0.196-0.34,0.88-0.93,2.32-1.58,3.54zm44.28-118.76c-0.496-0.945-0.759-1.39-0.759-1.39s2.068,0.97,3.299,2.361c1.23,1.393,1.203,2.127,1.387,2.811,0.184,0.683,0,1.942-0.183,3.124-0.184,1.181-0.184,1.891,0.053,2.311,0.235,0.42,0.445,0.63,0.445,0.63s-0.918,0.236-1.781,0.578c-0.864,0.342-1.989,0.656-2.617,0.131-0.629-0.525-0.785-0.893-0.392-1.234,0.392-0.342,1.857-0.762,2.041-3.282,0.18-2.521-0.99-5.094-1.49-6.04zm-11.28,6.857c0.472-1.197,0.666-2.34,0.305-4.792-0.303-2.061-0.703-3.826-0.805-6.047,0,0,1.528,0.335,3.723,2.341,2.193,2.006,2.695,4.068,2.695,5.072,0,1.002-0.529,2.229-0.612,3.205-0.083,0.975,0.277,1.839,0.277,1.839s-0.806,0.333-1.527,0.834c-0.722,0.502-1.222,0.809-2.333,0.753-1.112-0.056-1.779-0.557-2.418-0.892s-1.054-0.39-1.054-0.39,1.27-0.724,1.74-1.923zm-10.7-8.498c2.195-2.005,3.722-2.341,3.722-2.341-0.101,2.221-0.501,3.986-0.806,6.047-0.36,2.452-0.166,3.595,0.306,4.792,0.473,1.199,1.75,1.923,1.75,1.923s-0.416,0.056-1.056,0.39c-0.638,0.334-1.305,0.836-2.417,0.892-1.111,0.055-1.611-0.251-2.333-0.753-0.723-0.501-1.528-0.834-1.528-0.834s0.361-0.864,0.277-1.839c-0.083-0.975-0.61-2.202-0.61-3.205,0.01-1.004,0.51-3.066,2.7-5.072zm-7.91,12.197c-0.629,0.525-1.754,0.211-2.619-0.131-0.864-0.342-1.78-0.578-1.78-0.578s0.209-0.209,0.445-0.63c0.236-0.419,0.236-1.129,0.052-2.311-0.183-1.182-0.367-2.441-0.183-3.124,0.183-0.684,0.157-1.418,1.387-2.811,1.231-1.391,3.299-2.361,3.299-2.361s-0.262,0.445-0.759,1.39c-0.498,0.946-1.676,3.519-1.492,6.041,0.184,2.52,1.65,2.939,2.042,3.282,0.39,0.34,0.23,0.708-0.4,1.233zm29.24,21.078c-2.162,1.195-3.396,0.929-3.308,1.813,0.089,0.885,2.027,1.549,2.027,1.549s-1.984,2.123-3.528,3.097c-1.542,0.973-3.353,1.592-3.353,1.592s-0.616,0.089-0.264,1.062c0.354,0.973,0.971,1.636,1.455,1.902,0.485,0.265,0.751,0.354,0.751,0.354s-2.69,2.875-3.881,3.804c-1.191,0.929-1.853,1.238-2.822,1.637-0.971,0.398-0.484,1.99-0.265,2.699,0.22,0.706,1.058,1.68,1.544,1.813,0.483,0.133,0.661,0.486,0.044,1.46-0.462,0.726-2.001,2.657-2.735,3.722l-0.045,0.023c-0.729-1.058-2.289-3.014-2.753-3.745-0.617-0.974-0.441-1.327,0.044-1.46s1.324-1.106,1.544-1.813c0.219-0.709,0.705-2.301-0.267-2.699-0.969-0.399-1.631-0.708-2.821-1.637-1.191-0.929-3.881-3.804-3.881-3.804s0.265-0.089,0.75-0.354c0.486-0.266,1.103-0.929,1.456-1.902,0.352-0.973-0.265-1.062-0.265-1.062s-1.808-0.619-3.352-1.592c-1.542-0.974-3.528-3.097-3.528-3.097s1.94-0.664,2.029-1.549c0.088-0.885-1.147-0.619-3.308-1.813s-2.867-2.698-2.867-2.698,2.514-0.841,3.749-3.362c0.437-0.893,0.542-1.708,0.496-2.39l0.095,0.032c4.014,1.307,8.706,1.83,12.9,1.83,4.187,0,8.877-0.526,12.883-1.83l0.095-0.032c-0.047,0.682,0.058,1.497,0.495,2.39,1.235,2.521,3.75,3.362,3.75,3.362s-0.7,1.51-2.86,2.71z'/%3E%3Cg%3E%3Cpath fill='%23D4AF3A' d='M347.47,158.5c0-6.785,3.122-11.076,3.122-11.076l-8.493-9.73c-8.089,3.127-15.5,3.317-22.098-0.04-6.598,3.357-14.009,3.167-22.096,0.04l-8.496,9.73s3.123,4.291,3.123,11.076c0,6.786-1.312,11.82-2.079,15.103-0.766,3.283-1.422,9.411,0.329,13.79,1.75,4.376,3.611,8.207,11.162,11.381s11.491,4.814,14.117,7.004c2.627,2.187,3.94,3.938,3.94,3.938s1.313-1.752,3.94-3.938c2.625-2.189,6.565-3.83,14.117-7.004,7.55-3.174,9.411-7.005,11.162-11.381,1.75-4.379,1.094-10.507,0.328-13.79-0.76-3.28-2.07-8.31-2.07-15.1z'/%3E%3Cpath fill='%23B96B29' d='M344.8,161.3c-1.065-6.481,2.671-12.189,2.671-12.189l-7.271-8.501c-5.602,3.147-13.398,2.724-20.174-0.393-6.774,3.116-14.573,3.54-20.173,0.393l-7.271,8.501s3.736,5.708,2.669,12.189c-1.067,6.48-3.363,16.736-2.789,20.919,0.574,4.184,3.528,9.024,6.563,11.567s7.547,4.677,10.745,5.825c3.2,1.148,6.318,3.363,7.795,4.512,1.476,1.148,2.46,2.134,2.46,2.134s0.985-0.985,2.462-2.134,4.594-3.363,7.792-4.512c3.2-1.148,7.713-3.282,10.747-5.825,3.036-2.543,5.989-7.384,6.563-11.567,0.57-4.2-1.73-14.45-2.8-20.93z'/%3E%3Cpath fill='%231D5E91' d='M344.1,162.07c-1.053-6.998,2.104-12.635,2.104-12.635l-6.563-7.308c-5.547,2.849-12.289,2.113-19.634-0.434-7.344,2.547-14.085,3.282-19.633,0.434l-6.564,7.308s3.159,5.637,2.106,12.635-2.663,14.924-2.354,19.57c0.021,0.319,0.055,0.644,0.101,0.972h5.978s0.346-0.403,1.012-0.687c0.664-0.287,0.854-0.478,0.854-0.478s0.127-1.207,0.855-1.461c0.728-0.255,1.045-0.255,1.33-0.255s0.507-0.063,0.855-0.413c0.349-0.349,1.297-1.206,1.709-2.413s0.666-1.684,0.666-2.478c0-0.793,0.285-2.063,0.285-2.063s-0.159-0.381-0.76-0.158c-0.602,0.222-0.697-0.381-0.759-0.985-0.064-0.604-0.032-1.841,0.316-2.413s0.475-0.763,0.475-0.763l-0.254-0.951s-3.799,0.761-4.463-2.192c-0.665-2.953-0.792-4.384-0.887-4.699-0.095-0.319-0.19-0.479-0.697-0.445-0.507,0.031-1.583-0.317-2.343-1.843-0.76-1.524-0.823-2.159-0.602-2.762,0.222-0.604,0.634-0.381,0.76-0.191,0.126,0.191,1.14,1.652,1.552,1.238,0.411-0.413,0.19-0.413-0.38-1.556s-0.38-1.523-0.317-2.097c0.063-0.571-0.189-1.334-0.189-1.651,0-0.316,0.348-0.571,0.696-0.413,0.349,0.159,0.665,0.413,0.823,0.604,0.158,0.19,0.222,0.478,0.539,0.287s0.126-1.24,0.126-1.588c0-0.35,0.412-0.604,0.919-0.318,0.506,0.286,0.759,0.825,0.759,1.206,0,0.382,0.032,0.731,0.222,0.731s0.412-0.572,0.443-0.954c0.031-0.379,0.253-0.952,0.602-0.475,0.349,0.475,0.475,1.176,0.349,1.905-0.127,0.729,0.126,0.35-0.127,1.62-0.252,1.271-0.379,1.842-0.348,2.795,0.032,0.952,0.063,1.492,0.538,2.668,0.475,1.175,0.854,2.539,1.741,2.571,0.887,0.031,1.14,0.031,1.14,0.031s0.981-1.905,1.742-2.35c0.76-0.444,1.836-0.509,2.596-0.604,0.76-0.096,1.076-0.318,1.076-0.509s-0.253-0.253-1.171-0.381c-0.917-0.126-1.677-0.35-1.708-1.048-0.032-0.698,0.157-1.302-0.444-1.333-0.601-0.032-2.089-0.511-2.627-1.493-0.538-0.985-0.412-1.208-0.348-1.746,0.063-0.54,0.759-1.621,1.203-0.604s0.729,1.143,1.108,1.365c0.38,0.224,0.886,0.287,0.634-0.413-0.254-0.698-0.412-1.142-0.349-1.649,0.063-0.51,0.412-0.73,0.824-0.826,0.411-0.096,1.646-0.478,2.279-0.604,0.632-0.126,0.665-0.189,0.665-0.189s0.063-0.445,0.886-0.699c0.823-0.254,1.361-0.285,1.963-0.285,0.601,0,1.044,0.095,1.836-0.287,0.792-0.38,1.424-0.443,1.931-0.412,0.506,0.032,0.887,0.223,1.267,0.476,0.38,0.255,0.253,0.604,0.253,0.953,0,0.35,0.063,0.54,0.601,0.54,0.54,0,1.015,0,1.521,0.19,0.508,0.191,1.204,0.476,0.76,1.016-0.442,0.541-0.473,1.144-0.76,1.112-0.283-0.032-0.252,0.286-0.38,0.477-0.126,0.189-0.221,0.349,0.097,0.54,0.314,0.19,0.347,0.381,0.791,0.793,0.442,0.413,1.107,0.858,0.442,1.525-0.663,0.666-1.835,1.207-1.835,1.207s-0.666,0.316,0.094,0.763c0.76,0.443,1.109,1.365,1.394,1.523,0.284,0.159,0.57,0.413,0.76,0.508,0.189,0.096,0.158,0.73,0.158,0.73s-0.411,0.287-0.981,0.509c-0.57,0.223-1.172,0.477-1.709,0.477-0.539,0-0.824,0-0.602,0.508,0.221,0.507,0.602,1.049,0.696,1.333,0.095,0.286,0.222,0.795,0.222,0.795s0.885,0.189,1.678,0.189c0.791,0,1.14,0.032,2.881-0.158,1.741-0.189,2.249-0.254,3.927-0.064,1.679,0.19,1.93,0.128,2.374,0.286,0.443,0.159,0.886,0.383,0.886,0.383s2.375-0.033,3.673-0.318c1.298-0.286,1.616-1.113,1.427-1.556-0.19-0.445-0.16-1.111-2.439-1.43-2.278-0.319-3.197-0.191-5.003-0.541-1.804-0.349-4.623-1.27-5.128-3.524-0.508-2.255,1.329-3.207,2.248-3.651,0.918-0.446,2.912-1.144,3.831-1.524,0.917-0.382,2.597-0.762,4.369-0.509,1.772,0.255,2.785,0.73,3.482,0.318,0.696-0.413,1.267-0.096,1.14,0.539-0.125,0.635-0.823,1.938-2.818,2.541-1.994,0.604-4.399,0.667-5.698,0.318-1.299-0.351-2.279-0.858-3.071-0.573-0.791,0.286-1.678,1.271-0.824,2.445,0.857,1.177,5.226,1.525,6.396,1.651,1.172,0.129,5.509-0.19,6.744,1.969,1.234,2.161,0.252,4.573-1.203,5.114-1.456,0.539-2.691,0.89-3.799,1.048s-1.108,0.158-1.108,0.158,0.506,1.144,0.506,1.621c0,0.476-0.063,1.365,0.476,1.713,0.538,0.351,1.299,0.604,2.217,0.509,0.918-0.094,2.026,0.54,2.09,1.366,0.062,0.825,0.316,1.968,0.41,3.62,0.096,1.651,0,3.017,0,3.017s-0.063,0.636-0.284,1.238c-0.222,0.604-1.362,2.943-1.362,2.943h6.375c0.046-0.328,0.08-0.652,0.102-0.972,0.26-4.71-1.35-12.63-2.4-19.63z'/%3E%3Cpath fill='%236D8C3E' d='M294.42,185.72c1.25,3.571,3.826,7.187,7.748,9.549,5.45,3.282,7.804,2.849,12.944,6.193,5.141,3.344,4.831,3.902,4.893,3.902s-0.248-0.559,4.894-3.902c5.14-3.345,7.493-2.911,12.943-6.193,3.923-2.362,6.498-5.978,7.747-9.549h-51.158z'/%3E%3Cpath fill='%23D4AF3A' d='M298.88,158.13c0.585,0.615,1.017,0.802,1.91,0.71,0.894-0.095,1.109,0.555,1.263,1.263,0.154,0.709,0.154,2.372,0.801,3.912,0.646,1.54,2.803,1.633,2.803,1.633,0.06-0.743,0.319-1.742,0.647-2.557,0.058-0.146,0.338-0.833-0.432-0.833s-0.739-0.308-1.201-1.047c-0.461-0.739-1.355-2.71-1.57-3.974-0.215-1.263,0.185-3.142,0.4-3.819,0.216-0.678,0.247-1.14,0-1.263-0.247-0.124-0.739,0-0.739,0s0.185,0.585-0.032,0.677c-0.215,0.094-0.4-0.308-0.553-0.738-0.155-0.432-0.339-0.37-0.647-0.34-0.308,0.031-0.308,0.309-0.092,0.617,0.215,0.307,0.092,0.861,0.092,0.861s-0.678-0.492-0.955-0.616c-0.277-0.122-0.924,0.124-0.986,0.494-0.061,0.368,0.247,1.323,0.832,1.816,0.585,0.494,0.585,1.51,0.4,1.973-0.184,0.461-1.047,0.399-1.232,0.185-0.185-0.216-0.554-0.277-0.801,0-0.25,0.28-0.5,0.44,0.09,1.05z'/%3E%3Cpath fill='%23D4AF3A' d='M298.54,156.5s-0.339-0.276-0.462-0.43c-0.123-0.156-0.37-0.495-0.37-0.495s-0.062,0.154-0.062,0.524,0.4,0.771,0.4,0.771l0.49-0.37z'/%3E%3Cpath fill='%23D4AF3A' d='M299.83,152.22c0.278-0.123,0.493-0.186,0.278-0.493-0.216-0.308-0.401-0.647-0.617-0.709-0.216-0.061-0.4-0.03-0.4-0.03s0.246,0.555,0.307,0.894c0.06,0.34,0.16,0.46,0.43,0.34z'/%3E%3Cpath fill='%23D4AF3A' d='M301.44,150.92c-0.031,0.277,0.031,0.401,0.277,0.277,0.247-0.124,0.339-0.462,0.215-0.709-0.123-0.246-0.4-0.43-0.4-0.43l-0.185-0.125c-0.02,0,0.11,0.71,0.08,0.98z'/%3E%3Cpath fill='%23D4AF3A' d='M303.74,151.29c0.03-0.308-0.093-0.646-0.093-0.646s0,0.369-0.154,0.586c-0.154,0.215-0.123,0.154,0.031,0.339,0.15,0.19,0.18,0.03,0.21-0.28z'/%3E%3Cpath fill='%23D4AF3A' d='M307.36,166.95c0.453,1.05,1.604-0.595,2.65-1.925,1.045-1.329,1.011-0.313,0.871,0.77-0.139,1.085,0.279,2.24,0.698,2.975,0.418,0.732,0.767,0.313,0.94-0.212,0.175-0.522,0.314-1.607,0.663-2.132s0.697-0.07,0.732,0.384,0.592,1.47,1.115,2.063c0.522,0.596,0.767-0.209,0.941-0.943s0.383-1.854,0.523-2.31c0.139-0.454,0.627-0.069,0.627-0.069s0.35,0.35,1.047,1.014c0.695,0.666,0.766-0.385,0.836-0.907,0.069-0.526-0.105-1.68,0.104-1.856,0.209-0.174,0.801,0.246,1.709,0.702,0.906,0.453,0.872-0.421,0.768-0.911-0.106-0.488-0.627-1.608-1.36-2.237-0.732-0.63-0.836-1.364-0.592-1.68,0.243-0.313,1.115-0.035,1.672-0.104,0.559-0.07,0.838-0.139,1.256-0.208,0.418-0.071,0.418-0.491,0.418-0.491s-0.313-0.524-0.906-1.048c-0.594-0.526-0.94-0.944-1.673-1.12-0.733-0.175-1.743,0-1.743,0s0,0-0.105-0.21c-0.104-0.209-0.313-0.209-0.453,0-0.14,0.21-0.488,0.49-0.768,0.734-0.278,0.245-0.453,0.385-0.627,0.279-0.175-0.104,0.139-0.35,0.139-0.35s0.384-0.278,0.733-0.979c0.348-0.7,0.453-1.365,0.174-1.679-0.279-0.316-1.046,0-1.464,0-0.419,0-0.663,0.069-0.697-0.14-0.036-0.21,0.418-0.104,0.941-0.176,0.524-0.069,0.837-0.699,1.011-1.224s0.314-0.455,0.628-0.14c0.313,0.315,0.594,0.245,0.662,0.034,0.068-0.21,0.349-0.733,0.697-1.259,0.349-0.524,0.558-1.258,0.174-1.747-0.384-0.49-1.325-0.422-1.708-0.104-0.383,0.313-0.627,0.628-0.731,1.397-0.105,0.77-0.314,0.349-0.314,0.104s-0.314-0.63-0.175-0.944c0.14-0.313,0-0.665,0-0.665s-0.069-0.663-0.802-0.804-1.569,0.035-2.301,0.21-0.593,0.806-0.593,0.806-0.558,0.033-1.151,0.104c-0.592,0.069-1.29,0.313-1.848,0.453-0.557,0.141-0.767,0.21-0.767,0.489,0,0.281,0.105,0.736,0.105,0.736s0.453,0,0.697,0.139c0.244,0.141,0.104,0.385-0.175,0.49-0.278,0.106-0.383,0.14-0.383,0.489,0,0.351,0.14,0.421,0.418,0.421s0.872,0,1.569,0.313c0.698,0.314,0.872,0.943,0.802,1.293-0.07,0.351-1.047,0.805-1.535,0.805s-0.627,0.106-0.627,0.42c0,0.315,0.593,0.281,0.593,0.281s0.592,0.034,1.743,0.173c1.151,0.141,1.325,0.386,1.849,0.84,0.522,0.455,0.139,0.56-0.105,0.699-0.244,0.141-0.628,0.455-1.011,0.596-0.384,0.139-0.628,0.42-0.977,0.488-0.349,0.07-1.221,0.036-2.824,0.666-1.604,0.629-2.162,2.729-2.162,2.729s0.209-0.071,0.941-0.457c0.732-0.384,1.639-0.804,2.476-1.328,0.836-0.523,0.836,0.246,0.418,0.979-0.418,0.734,0.384,0.594,0.628,0.385,0.244-0.211,0.558-0.42,1.359-0.84,0.803-0.419,0.523,0.245,0.523,0.245s-0.244,0.489-0.313,1.645c-0.07,1.154,1.15,0.069,1.708-0.665s0.802,0,0.383,0.84c-0.418,0.84-1.22,1.503-1.673,1.503-0.454,0-0.802-0.489-0.837-0.769s0.14-1.12-0.139-1.329c-0.28-0.209-1.082,0.035-1.674,0.384-0.593,0.35-0.733,0.071-0.872-0.244-0.14-0.315,0.209-0.42,0.07-0.629-0.14-0.211-0.453,0-0.698,0.104-0.244,0.104-0.802,0.42-1.882,0.979-1.082,0.559-1.011,0.873-1.011,1.678s0.2,0.99,0.65,2.04z'/%3E%3Cpath fill='%23D4AF3A' d='M317.82,149.44c0.227-0.144,0.639-0.309,0.639-0.309s0.515-0.123,0.988-0.186c0.473-0.062,0.391-0.33,0.287-0.555-0.102-0.229-0.287-0.31-0.903-0.31-0.619,0-1.011,0.31-1.36,0.452-0.351,0.145-0.762,0.248-0.762,0.248s0.083,0.103,0.309,0.433c0.22,0.35,0.57,0.39,0.79,0.24z'/%3E%3Cpath fill='%23D4AF3A' d='M320.34,151.94c0.247,0,0.515-0.145,0.515-0.145s0.451-0.227,0.865-0.37c0.411-0.145,0.576-0.207,0.822-0.701,0.247-0.494-0.268-0.494-0.987-0.678-0.721-0.188-1.071,0.06-1.152,0.328-0.084,0.268-0.063,0.576-0.351,1.092-0.29,0.51,0.04,0.47,0.29,0.47z'/%3E%3Cpath fill='%23D4AF3A' d='M320.11,152.57c-0.699,0-1.481,1.05-1.77,1.235s-0.124,0.37-0.124,0.37,0.206,0.433,0.287,0.844c0.084,0.413,0.104,1.113,0.104,1.113s0.103,0.042,0.514,0.042c0.413,0,0.659-0.207,1.051-0.495s0.7-0.392,1.256-0.495c0.557-0.102,0.823-0.205,1.44-0.534,0.619-0.329-0.329-0.906-0.987-1.441-0.66-0.51-1.07-0.62-1.77-0.62z'/%3E%3Cpath fill='%23D4AF3A' d='M310.8,154.99c0.554-0.062,0.801-0.338,0.801-0.646s-0.28-0.647-0.986-0.585c-1.735,0.154-3.417-0.468-3.727-2.187,0,0-0.585,1.076,0.493,2.279,1.09,1.2,2.87,1.2,3.43,1.14z'/%3E%3Cpath fill='%23D4AF3A' d='M304.89,182.31c0.088,0.153,0.196,0.248,0.306,0.305h2.658c0.453-0.127,0.456-0.544,0.478-0.832,0.026-0.343,0.289-1.317,0.657-3.084,0.368-1.765,0.999-3.028,1.261-3.74s-0.263-0.948-0.447-1.397c-0.184-0.447-0.473-1.237-0.552-1.632-0.079-0.396-0.709-0.343-1.051-0.317s-0.395,0.58-0.447,1.107c-0.052,0.525-0.289,2.081-0.551,3.425-0.263,1.344-1.787,3.136-2.207,3.53-0.421,0.396-0.762,0.554-1.051,0.554s-0.919,0-1.235,0.185c-0.314,0.185-0.629,0.686-0.656,1.079-0.026,0.396,0.605,0.607,0.605,0.607s0.499-0.29,0.683-0.527c0.184-0.237,0.604-0.29,1.024-0.368,0.42-0.079,0.473,0.078,0.315,0.288-0.16,0.2-0.11,0.25,0.21,0.81z'/%3E%3Cpath fill='%23D4AF3A' d='M300.82,182.17c-0.201,0.071-0.348,0.271-0.439,0.437h1.737c-0.021-0.142-0.068-0.311-0.168-0.437-0.21-0.26-0.77-0.13-1.13,0z'/%3E%3Cpath fill='%23D4AF3A' d='M303.18,182.12c-0.212,0.115-0.468,0.303-0.598,0.489h1.87c0.066-0.174,0.087-0.407-0.142-0.594-0.42-0.35-0.84-0.06-1.13,0.1z'/%3E%3Cpath fill='%23D4AF3A' d='M319.4,181.35c-0.204,0-0.385,0.182-0.679,0.385-0.293,0.204-0.383,0.521-0.428,0.771-0.008,0.044-0.003,0.079,0.011,0.108h0.794c0.031-0.028,0.053-0.064,0.053-0.108,0-0.228,0.09-0.432,0.43-0.726,0.35-0.3,0.03-0.43-0.17-0.43z'/%3E%3Cpath fill='%23D4AF3A' d='M320.96,182.21c0-0.248-0.091-0.475-0.271-0.452s-0.474,0.34-0.722,0.521c-0.138,0.101-0.241,0.235-0.317,0.336h1.174c0.07-0.14,0.14-0.29,0.14-0.41z'/%3E%3Cpath fill='%23D4AF3A' d='M328.18,173.58c0.563-0.408,0.474-0.521,0.495-0.951,0.022-0.431,0.022-0.566-0.203-0.724-0.226-0.16-1.06-0.521-1.85-0.521s-2.281,0.181-2.845,0.565c-0.565,0.386-0.836,1.767-0.836,2.49s0.113,0.838,0.316,0.838,0.542-0.521,0.542-0.521,0.744,0.974,1.196,1.654c0.452,0.679,0.248,0.95,0.047,1.47-0.204,0.521-0.948,1.902-1.535,2.197-0.589,0.295-1.04,0.021-1.739-0.09-0.699-0.114-1.084,0.09-1.49,0.497s-0.021,0.726,0.226,0.726c0.249,0,0.587-0.023,0.858,0.316,0.188,0.235,0.061,0.772-0.034,1.082h3.459c0.59-0.262,0.997-1.072,1.156-1.514,0.182-0.497,0.926-1.153,1.288-1.492,0.36-0.341,0.406-0.567,0.406-1.314s-0.203-1.177-0.476-1.697c-0.271-0.521-0.474-1.269-0.384-1.698,0.06-0.46,0.81-0.93,1.37-1.34z'/%3E%3Cpath fill='%23D4AF3A' d='M322.49,164.95c0.346,0.562,0.174,0.669-0.323,0.776-0.495,0.108-1.033,0.194-1.811,0.13-0.775-0.065-0.755,0.043-0.775,0.432-0.021,0.388-0.088,1.208-0.54,1.811-0.453,0.604-1.014,0.367-1.359,0.13s-0.539-0.174-0.668,0.258-0.367,0.734-0.733,1.38c-0.367,0.647-0.604,0.669-0.863,0.604s-0.496-0.453-0.755-0.475-0.669-0.538-1.057-1.165c-0.388-0.624-0.582,0.064-0.84,0.605-0.26,0.538-0.517,0.928-1.014,0.861-0.496-0.063-1.056-0.991-1.336-1.552-0.281-0.562-0.453-1.1-0.884-1.079-0.431,0.022-1.143,0.928-1.618,1.164-0.475,0.238-0.604,0.152-0.819-0.149-0.215-0.302-0.496,0.108-0.776,0.819-0.28,0.712,0.022,1.314,0.41,1.509,0.388,0.194,1.164-0.367,1.682-0.712,0.517-0.344,0.754-0.258,1.294-0.258,0.539,0,0.496,0.885,0.733,2.177,0.237,1.294,0.992,1.467,0.992,1.467s0.259,0.216,0.841-0.775c0.582-0.992,0.646-1.963,1.208-1.963,0.56,0,0.604,0.129,1.164,0.905,0.561,0.776,1.035,1.358,1.358,0.776,0.323-0.583,0.604-1.445,0.971-1.746,0.366-0.303,0.711-0.389,0.323,0.172-0.389,0.561-0.561,1.164,0.237,0.928s3.838-1.467,5.067-1.703c0,0,1.444-0.237,3.105-0.323,1.66-0.088,2.069-0.195,2.717-0.195,0.646,0,0.668-0.065,0.712-0.496,0.042-0.432-0.302-0.345-1.51-0.345-1.207,0-2.049,0.151-2.89,0.281-0.841,0.129-1.228,0.107-1.079-0.108,0.152-0.216,0.389-0.367,1.36-0.517,0.969-0.151,2.954-0.26,3.989-0.281,1.034-0.021,0.711,0.302,0.624,0.992-0.087,0.689,0.087,1.704,0.152,2.351,0.063,0.646,0.085,0.841,0.646,1.746s2.5,1.467,3.062,1.769c0.561,0.302,0.475,0,0.453-0.54-0.022-0.538,0.431-0.517,0.927-0.237,0.495,0.282,1.315,0.519,1.897,0.67,0.582,0.149,0.668,0.258,0.668,0.56s0.065,0.971,0.131,1.597c0.063,0.625,0.042,0.818-0.217,1.207s-1.358,1.508-1.358,1.508-0.496,0-1.553,0.261c-1.057,0.259-1.381,0.755-1.488,1.186s0.195,0.561,0.238,0.733c0.023,0.095,0.014,0.328,0.001,0.518h0.244c0.089-0.151,0.215-0.349,0.379-0.562,0.368-0.474,1.296-0.582,1.898-0.302,0.396,0.185,0.401,0.599,0.359,0.863h2.415c0.326-0.629,1.099-2.133,1.302-2.589,0.258-0.581,0.409-0.948,0.431-1.746s0.107-3.881-0.043-4.054c-0.151-0.173,0.043-0.69,0-1.553-0.044-0.862,0-1.51-1.596-1.66-1.597-0.151-2.092-0.818-2.631-1.359-0.541-0.538-0.41-1.789-0.84-3.298-0.432-1.509-1.488-1.747-3.364-2.114-1.877-0.365-3.257-0.409-4.658-0.279s-3.147,0.324-4.118,0.236c-0.95-0.12-0.8,0.16-0.45,0.72z'/%3E%3Cpath fill='%23D4AF3A' d='M331.55,182.27c-0.164,0.106-0.273,0.232-0.346,0.342h1.63c0.008-0.14-0.015-0.297-0.16-0.472-0.24-0.3-0.72-0.13-1.12,0.13z'/%3E%3Cpath fill='%23D4AF3A' d='M334.47,182.16c-0.265,0.134-0.436,0.306-0.541,0.452h1.653c0.006-0.063,0.004-0.129-0.009-0.191-0.05-0.26-0.55-0.54-1.1-0.26z'/%3E%3Cpath fill='%23D4AF3A' d='M293.75,183.19c0.092,0.512,0.212,1.031,0.361,1.553h51.785c0.149-0.521,0.27-1.041,0.36-1.553h-52.506z'/%3E%3Cpath fill='%23D4AF3A' d='M328.65,158.45c1.636,1.089,6.83,1.147,9.269,1.636,2.439,0.487,2.269,2.353,1.521,3.328-0.746,0.977-4.177,1.094-4.792,1.176,0.332,0.23,0.832,0.947,0.832,0.947s0.374-0.027,1.406-0.115c1.032-0.085,2.841-0.343,4.075-1.377,1.234-1.032,1.147-2.696,0.058-3.815-1.091-1.12-2.899-1.234-4.736-1.435-1.836-0.201-3.271-0.345-5.337-0.689-2.065-0.344-3.07-1.176-3.07-2.382,0-1.205,1.12-1.836,1.923-2.066,0.803-0.229,2.094-0.572,3.242-0.144,1.148,0.431,2.497,0.487,4.764,0.202,2.268-0.288,2.784-1.866,2.784-1.866s-0.288,0.144-1.435,0.172c-1.148,0.028-1.981-0.487-4.074-0.518-2.097-0.028-2.843,0.72-3.818,1.063-0.976,0.345-3.586,0.604-4.361,2.296-0.77,1.7,0.12,2.5,1.76,3.59z'/%3E%3Cellipse rx='0.977' ry='0.962' cy='150.64' cx='315.04' fill='%23B96B29'/%3E%3Cpath fill='%23B96B29' d='M336.02,152.28c-1.293-0.114-2.986,0.229-2.986,0.229s0.315,0.259,0.746,0.23c0.43-0.029,1.206-0.058,2.468,0.171,1.263,0.231,2.181-0.373,2.181-0.373s-1.12-0.14-2.41-0.26z'/%3E%3Cpath fill='%231D5E91' d='M323.74,176.38c-0.316-0.498-0.407-0.452-0.77-0.135-0.361,0.316-0.725-0.771-0.77-1.449-0.045-0.677,0.271-2.759,0.271-2.759s-1.765,0.362-2.714,0.678c-0.949,0.317-1.854,0.408-2.623,0.59s-1.176,0.36-1.583,0.271c-0.407-0.09-1.267-0.136-1.945-0.136s-0.632,0.136-1.312,0.814c-0.678,0.677-0.859,1.039-1.402,2.307-0.543,1.265-0.724,2.441-0.904,3.979-0.119,1.007-0.314,1.702-0.436,2.064h8.108c0.097-0.26,0.223-0.587,0.333-0.829,0.212-0.468,0.658-0.765,0.977-0.914s0.596-0.149,0.743-0.508c0.148-0.362,0.553-0.66,0.978-0.851s1.168-0.085,1.849,0.106c0.679,0.19,0.913-0.276,1.103-0.531,0.191-0.255,0.277-0.616,0.639-1.082,0.361-0.469,0.09-0.894,0.09-0.894s-0.33-0.22-0.65-0.72z'/%3E%3Cpath fill='%231D5E91' d='M336.75,176.6c-0.105-0.468-0.063-0.53-0.34-0.596-0.276-0.064-0.743-0.148-1.146-0.317-0.403-0.17-0.361,0.913-0.361,0.913s-0.957,0.104-2.039-0.021c-1.083-0.128-2.357-1.104-2.804-1.424-0.445-0.318-0.935-1.04-0.935-1.04s-0.34,0.318-0.68,0.51-0.531,0.871-0.594,1.551c-0.064,0.68,0.786,1.507,0.849,2.187,0.064,0.681-0.743,2.04-1.147,2.592-0.275,0.379-0.632,1.186-0.829,1.657h3.914c0.082-0.201,0.216-0.455,0.42-0.658,0.402-0.404,1.084-0.489,1.084-0.489s0-0.17,0.148-0.53c0.147-0.361,0.552-0.786,1.528-1.169,0.978-0.382,2.146-0.446,2.146-0.446s0.466-0.382,0.807-0.913c0.34-0.53,0.09-1.33-0.02-1.8z'/%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23D4AF3A' d='M304.15,219.77c0.729,0.243,2.091-0.291,2.772-1.118,0.68-0.827,0.924-2.093,1.41-2.821,0.486-0.73,0.839-1.271,0.839-1.271s-0.104,1.202-0.749,2.813c-0.615,1.536-0.722,3.637-0.576,4.537,0.292,1.799,1.459,2.091,2.14,1.847,0.517-0.184,1.3-0.981,2.019-2.177,0.227-0.379,0.386-0.903,0.608-1.324,0.462-0.875,0.875-2.309,1.079-2.269,0.45,0.088,0.162,1.101-0.008,1.782-0.341,1.361-1.021,3.356-1.07,4.572s0.098,3.404,1.313,3.502c1.216,0.097,1.848-0.974,2.528-3.454,0.681-2.479,0.828-3.259,1.119-3.259,0.292,0,0.292,1.702,0.292,2.432,0,0.251,0.01,0.942,0.109,1.637,0.189,1.329,0.577,2.925,0.961,3.276,0.583,0.535,1.07,0.437,1.07,0.437s0.485,0.099,1.07-0.437c0.583-0.535,1.069-4.184,1.069-4.913s0-2.432,0.291-2.432c0.294,0,0.438,0.779,1.119,3.259,0.682,2.48,1.313,3.551,2.529,3.454,1.216-0.098,1.363-2.286,1.314-3.502s-0.729-3.211-1.071-4.572c-0.341-1.362,0.146-1.265,1.071,0.486,0.288,0.547,0.587,1.217,0.88,1.685,0.648,1.031,1.278,1.649,1.746,1.816,0.68,0.244,1.848-0.048,2.14-1.847,0.292-1.801-1.07-6.956-1.07-6.956s0.098,0.146,0.584,0.876c0.486,0.729,0.729,1.994,1.411,2.821,0.68,0.827,2.043,1.361,2.772,1.118s0.827-1.606,0.291-4.038c-0.535-2.432-2.724-3.793-4.28-5.739-1.432-1.788-2.535-4.936-2.701-5.429-1.959,0.97-3.677,2.071-5.229,3.692-3.219,3.358-3.918,4.197-3.918,4.197s-0.7-0.839-3.918-4.197c-1.563-1.631-3.291-2.734-5.265-3.709-0.182,0.415-1.52,3.421-2.966,5.23-0.719,0.899-1.71,1.578-2.414,2.441-0.818,1.003-1.316,2.206-1.604,3.513-0.52,2.42-0.42,3.78,0.31,4.03z'/%3E%3Cpath fill='%23D4AF3A' d='M304.06,228.01c0.942-0.829,1.427-1.286,1.427-1.286s0.685-0.57,0.514,0.515c-0.172,1.084-0.543,3.311-0.314,4.28,0.228,0.971,0.342,1.798,1.541,1.084,1.199-0.713,1.484-1.142,2.055-1.74,0.57-0.6,1.17-0.855,1.027,0.086-0.144,0.941-0.571,2.368-0.371,4.28,0.2,1.911,1.142,2.196,2.368,0.57,1.228-1.626,1.969-3.109,2.34-3.909,0.371-0.799,1.113-1.483,1.113,0,0,3.192,0.732,7.835,4.251,9.074,3.521-1.239,4.253-5.882,4.253-9.074,0-1.483,0.74-0.799,1.11,0,0.372,0.8,1.113,2.283,2.341,3.909,1.227,1.626,2.169,1.341,2.368-0.57,0.199-1.912-0.229-3.339-0.371-4.28s0.457-0.686,1.028-0.086c0.57,0.599,0.854,1.027,2.054,1.74,1.199,0.714,1.313-0.113,1.541-1.084,0.228-0.97-0.143-3.196-0.313-4.28-0.172-1.085,0.513-0.515,0.513-0.515s0.485,0.457,1.428,1.286c0.94,0.827,2.233,0.877,2.233,0.877s0.605-3.351-0.791-5.352-1.909-2.652-1.909-2.652-0.79-0.046-1.395-0.278c-0.604-0.233-1.192-0.67-1.192-0.67s0,1.027,0,1.368v0.486s1.711,1.626,2.111,2.111c0.398,0.483,1.198,1.312,0.029,0.513-1.17-0.799-2.141-1.598-2.141-1.598s-0.229,1.684-0.714,2.112c-0.484,0.427-1.17,0.483-1.454,0.37-0.285-0.115-0.285-0.115-0.285-0.115l-0.086,0.658s1.055,1.969,1.197,2.768c0.144,0.799-0.086,0.712-0.57-0.315-0.485-1.025-1.426-2.339-1.854-3.052s-1.056-1.199-0.999-0.285c0.058,0.913-0.313,2.567-0.628,3.166-0.313,0.6-0.513,0.799-0.513,0.799s0.655,2.313,0.741,2.74c0.087,0.428,0.028,0.913-0.342,0.37-0.371-0.542-1.428-2.824-1.428-2.824s-1.398-0.057-1.797-0.457c-0.399-0.4-1.027-1.938-1.027-1.938s-0.572,1.964-1.046,2.595c-0.473,0.63-1.575,1.259-1.575,1.259s-0.079,3.416-0.156,4.02c-0.08,0.604-0.105,0.866-0.361,0.866-0.255,0-0.282-0.263-0.361-0.866-0.077-0.604-0.156-4.02-0.156-4.02s-1.104-0.629-1.577-1.259c-0.472-0.631-1.045-2.595-1.045-2.595s-0.627,1.538-1.027,1.938c-0.399,0.4-1.797,0.457-1.797,0.457s-1.056,2.282-1.427,2.824c-0.371,0.543-0.428,0.058-0.342-0.37s0.742-2.74,0.742-2.74-0.2-0.199-0.514-0.799c-0.314-0.599-0.685-2.253-0.627-3.166,0.056-0.914-0.572-0.428-1,0.285s-1.369,2.026-1.854,3.052c-0.485,1.027-0.713,1.114-0.57,0.315s1.198-2.768,1.198-2.768l-0.085-0.658-0.285,0.115c-0.286,0.113-0.97,0.057-1.456-0.37-0.485-0.429-0.713-2.112-0.713-2.112s-0.97,0.799-2.14,1.598c-1.17,0.799-0.371-0.029,0.029-0.513,0.399-0.485,2.11-2.111,2.11-2.111s0-0.144,0-0.486v-1.368s-0.586,0.437-1.191,0.67c-0.605,0.232-1.396,0.278-1.396,0.278s-0.512,0.651-1.908,2.652c-1.396,2.001-0.791,5.352-0.791,5.352s1.3-0.04,2.24-0.86z'/%3E%3Cpath fill='%23D4AF3A' d='M321.23,250.32c-0.902-1.055-1.203-1.58-1.203-1.58s-0.301,0.525-1.202,1.58c-0.904,1.053-3.01,2.708-3.01,2.708s0.188,2.784,1.204,4.287c0.856,1.27,1.675,2.43,3.008,3.311,1.333-0.881,2.153-2.041,3.009-3.311,1.017-1.503,1.204-4.287,1.204-4.287s-2.11-1.66-3.01-2.71z'/%3E%3Cpath fill='%23B96B29' d='M319.57,253.73c0.083,0.646,0.028,2.279,0.421,2.279s0.336-1.634,0.421-2.279c0.083-0.646,0.111-2.195,0.111-2.195h-1.067c0.01-0.01,0.04,1.54,0.12,2.19z'/%3E%3Cpath fill='%23D4AF3A' d='M319.98,100.87c-3.766,0.064-8.184-0.456-10.615-1.361-0.864,0.191-1.728,0.381-2.592,0.571,4.007,1.509,7.355,2.094,13.207,2.153,5.853-0.059,9.2-0.644,13.206-2.153-0.864-0.19-1.729-0.38-2.593-0.571-2.43,0.901-6.85,1.421-10.62,1.361z'/%3E%3Cpath fill='%23D4AF3A' d='M333.68,97.727c-0.299-0.249-2.013-1.471-2.46-1.694-0.447-0.225-0.099-0.822-0.024-1.071,0.074-0.25,2.012-0.798,3.081-1.072,1.067-0.274,0.894-0.499,0.894-0.499s-0.622-0.723-4.498-1.146c-3.874-0.423-10.68-0.324-10.68-0.324s-6.807-0.1-10.683,0.324c-3.875,0.423-4.496,1.146-4.496,1.146s-0.174,0.225,0.895,0.499c1.068,0.274,3.005,0.822,3.08,1.072,0.075,0.249,0.423,0.847-0.024,1.071-0.447,0.223-2.162,1.445-2.459,1.694-0.298,0.25-0.323,0.648,0.149,0.673,0.472,0.024,0.48,0.017,1.813-0.25,3.988-0.793,7.742-1.015,11.727-1.07,3.983,0.055,7.736,0.277,11.726,1.07,1.332,0.266,1.34,0.274,1.813,0.25,0.47-0.025,0.45-0.423,0.15-0.673z'/%3E%3Cpath fill='%23D4AF3A' d='M329.27,99.373c-2.659-0.315-4.347-0.659-9.27-0.615-4.922,0.043-6.609,0.3-9.27,0.615,1.675,0.672,4.384,1.01,9.27,1.01,4.89,0,7.6-0.34,9.27-1.007z'/%3E%3Cpolygon points='319.18,62.889,321.21,62.725,321.02,60.951,323.2,61.254,323.29,59.503,321,59.714,321.4,57.823,318.88,57.8,319.32,59.714,317.1,59.503,317.1,61.254,319.3,60.998' fill='%23D4AF3A'/%3E%3Cpath fill='%23D4AF3A' d='M323.61,65.76h-2.726v-2.325c-0.26-0.053-0.528-0.079-0.805-0.079-0.244,0-0.481,0.021-0.712,0.063v2.342h-2.82c-0.095,0.295-0.146,0.61-0.146,0.935,0,0.133,0.009,0.265,0.026,0.396h7.301c0.018-0.131,0.026-0.263,0.026-0.396-0.01-0.326-0.07-0.64-0.16-0.936z'/%3E%3Cpath fill='%231D5E91' d='M320.08,70.032c1.621,0,2.997-0.954,3.485-2.276h-6.972c0.49,1.323,1.87,2.276,3.49,2.276z'/%3E%3Cpath fill='%231D5E91' d='M321.58,63.648v1.598h1.808c-0.37-0.706-1.01-1.275-1.81-1.598z'/%3E%3Cpath fill='%231D5E91' d='M318.57,63.648c-0.791,0.323-1.434,0.892-1.809,1.598h1.809v-1.598z'/%3E%3Cpath fill='%23B96B29' d='M322.17,93.312c-0.688-0.325-2.188-0.966-2.188-0.966s-1.426,0.703-2.201,1.092c-0.775,0.388-0.675,0.275-0.913,0.84s0.024,0.765,0.362,0.915c0.338,0.151,2.79,1.406,2.79,1.406s2.426-1.129,3.013-1.406c0.589-0.275,0.478-0.551,0.314-0.979-0.16-0.425-0.49-0.575-1.17-0.902z'/%3E%3Cpolygon points='317.64,94.027,320.04,95.249,322.41,94.027,319.98,92.889' fill='%23D4AF3A'/%3E%3Cpath fill='%23D4AF3A' d='M319.98,84.648s-0.202,0.847-0.473,1.206c-0.271,0.36-0.476,0.681-0.398,1.119,0.078,0.437,0.578,0.729,0.871,0.729,0.292,0,0.793-0.292,0.87-0.729,0.079-0.438-0.126-0.759-0.397-1.119-0.26-0.359-0.47-1.206-0.47-1.206z'/%3E%3Ccircle cy='88.56' cx='320' r='0.451' fill='%23D4AF3A'/%3E%3Cpath fill='%23D4AF3A' d='M318.39,86.24s0.78-0.866,1.068-1.415c0.289-0.548,0.524-1.039,0.524-1.039s0.234,0.491,0.523,1.039c0.289,0.548,1.068,1.415,1.068,1.415s1.097-0.578,1.731-2.684c0.636-2.107-0.146-4.329-0.434-6.724s-0.52-6.521-0.52-6.521c-0.831,0.476-1.616,0.678-2.37,0.691-0.754-0.014-1.54-0.216-2.371-0.691,0,0-0.23,4.126-0.519,6.521-0.289,2.396-1.068,4.617-0.433,6.724,0.64,2.106,1.73,2.684,1.73,2.684z'/%3E%3Cellipse rx='1.894' ry='1.828' cy='81.506' cx='319.98' fill='%23B96B29'/%3E%3Cellipse rx='1.822' ry='1.759' cy='77.22' cx='319.98' fill='%23B96B29'/%3E%3Cellipse rx='1.738' ry='1.677' cy='73.121' cx='319.98' fill='%23B96B29'/%3E%3Cellipse rx='1.004' ry='0.968' cy='81.178' cx='319.98' fill='%23D4AF3A'/%3E%3Cellipse rx='0.966' ry='0.931' cy='76.905' cx='319.98' fill='%23D4AF3A'/%3E%3Cellipse rx='0.847' ry='0.817' cy='72.82' cx='319.98' fill='%23D4AF3A'/%3E%3Cpath fill='%23b96b29' d='m319.93,224.04c0.117,0.024,0.14-0.277,0.163-0.835,0.022-0.556,0.094-1.9,0.231-2.688,0.139-0.789-0.209-0.742-0.418-0.695-0.208,0.046-0.323,0.648-0.323,0.997,0,0.347,0.092,2.341,0.092,2.758s0.139,0.44,0.255,0.463z'/%3E%3C/g%3E%3Cg id='g4017'%3E%3Cpath fill='%23d4af3a' d='m300.28,239.41c0.841-0.534,1.571-1.126,3.478-2.392,1.907-1.267,2.608-2.673,2.608-2.673h-0.673c-0.365,0-0.673-0.507-0.701-1.013-0.029-0.507,0-1.547,0.14-2.757,0.14-1.209-0.196-2.194-0.196-2.194s-0.813,0.758-2.047,1.406c-1.234,0.647-1.74,0.337-1.74,0.337l-0.309-1.236s-0.532,1.126-1.29,2.446c-0.758,1.322-2.805,2.786-4.263,3.882-1.459,1.098-3.058,2.252-4.264,2.674-1.206,0.421-0.504,0.985-0.504,0.985s1.206,1.208,4.319,1.771,4.601-0.702,5.442-1.236z'/%3E%3Cpath fill='%23d4af3a' d='m311.17,238.2c-1.112-0.117-1.777-0.537-1.992-1.745-0.141-0.787,0.057-3.798,0.057-3.798s-0.365,0.309-0.786,0.817c-0.421,0.505-1.375,0.618-1.375,0.618s-0.14,0.422-0.561,1.096c-0.421,0.677-0.954,1.493-2.02,2.167-1.065,0.676-2.299,1.464-3.113,2.139-0.814,0.676-1.767,1.464-2.833,2.054-1.066,0.591-2.02,1.548-2.385,3.122-0.364,1.575-0.083,2.082,1.15,1.998,1.234-0.085,1.375,0.028,3.366-0.479,1.992-0.506,4.824-2.728,6.899-4.05,2.079-1.323,3.593-3.939,3.593-3.939z'/%3E%3Cpath fill='%23d4af3a' d='m316.69,240.02s-0.842-1.067-1.15-2.279c-0.309-1.209-0.897-3.6-0.897-3.6s-0.281,0.76-0.954,2.192c-0.674,1.436-1.823,1.774-1.823,1.774s-0.057,0.618-1.01,1.828c-0.954,1.209-2.355,2.334-3.787,3.18-1.431,0.842-3.282,1.998-4.292,3.432-1.009,1.435-1.094,2.925-0.616,3.572,0.477,0.646,1.149-0.085,2.103-0.563s3.675-0.9,7.433-2.926c3.758-2.025,4.993-6.61,4.993-6.61z'/%3E%3Cpath fill='%23d4af3a' d='m318.32,248.44c1.038-1.547,1.207-5.315,1.207-5.315s-0.364-0.253-0.87-0.677c-0.504-0.422-1.486-1.912-1.486-1.912s-0.617,1.293-1.29,2.503c-0.673,1.211-1.011,1.632-2.413,2.926-1.402,1.295-3.31,2.561-4.124,3.939-0.813,1.378-0.364,4.135,0.169,5.063,0.533,0.93,1.29,0.618,2.075-0.14,0.786-0.759,1.038-0.956,2.412-2.138s3.283-2.702,4.32-4.249z'/%3E%3Cpath fill='%23b96b29' d='m305.98,216.89c0.552-1.128,1.176-2.496,1.68-3.19,0.503-0.697,0.863-1.489,0.863-1.489s-1.344,1.224-1.872,2.088c-0.527,0.863-0.863,1.703-1.104,2.64-0.238,0.935-0.119,1.078,0.433-0.049z'/%3E%3Cpath fill='%23b96b29' d='m311.31,217.85c0.216-0.745,0.337-1.24,0.337-1.24s0.217-0.72,0.097-0.768c-0.12-0.049-0.673,0.447-1.057,1.67-0.385,1.225-0.96,2.999-0.84,3.071,0.119,0.073,1.247-1.989,1.463-2.733z'/%3E%3Cpath fill='%23b96b29' d='m315.51,221.23c0.24-0.527,0.24-0.551,0.24-0.551s0.432-1.392,0.432-1.68c0-0.287-0.144-0.623-0.503,0.096-0.361,0.721-0.384,1.415-0.457,1.728-0.071,0.312-0.479,1.392-0.36,1.488,0.12,0.096,0.408-0.551,0.648-1.081z'/%3E%3Cpath fill='%23b96b29' d='m302.47,234.03-0.562-0.338s-0.336,0.451-0.813,0.957c-0.477,0.505-1.011,0.703-1.375,1.182-0.364,0.478-0.926,1.069-1.795,1.519s-1.206,0.591-1.037,0.732c0.168,0.141,0.757-0.197,0.757-0.197s0.252-0.029,1.29-0.647,1.29-0.956,1.963-1.547,1.572-1.661,1.572-1.661z'/%3E%3Cpath fill='%23b96b29' d='m307.02,239.41c0.393-0.422,0.813-0.704,0.589-0.93-0.225-0.224-0.505-0.196-0.87,0.113-0.364,0.31-1.402,1.293-1.879,1.716-0.477,0.422-0.869,0.676-1.346,1.041-0.477,0.366-1.515,0.928-2.019,1.209-0.505,0.282-0.028,0.312-0.028,0.312s0.393-0.199,0.813-0.34c0.42-0.14,1.626-0.675,1.626-0.675s0.477-0.225,1.122-0.675c0.645-0.449,1.599-1.35,1.992-1.771z'/%3E%3Cpath fill='%23b96b29' d='m312.26,243.04c0.336-0.674-0.028-0.479-0.589-0.252-0.561,0.225-1.823,1.604-2.552,2.109s-1.347,0.703-1.963,1.014c-0.617,0.309-0.617,0.477-0.588,0.618,0.027,0.141,0.279,0.141,0.532,0.028,0.253-0.112,1.122-0.619,1.122-0.619s0.365-0.111,0.702-0.141c0.337-0.028,0.813-0.396,1.571-1.041,0.755-0.647,1.428-1.039,1.765-1.716z'/%3E%3Cpath fill='%23b96b29' d='m314.7,247.85c-0.926,0.563-2.524,1.828-2.945,2.673-0.422,0.845-0.702,1.435-0.562,1.575,0.14,0.141,0.589-0.141,0.786-0.479,0.196-0.337,0.617-0.844,0.617-0.844s1.598-1.574,2.187-1.94,1.543-1.406,1.768-2.025c0.224-0.62,0.056-0.956,0.056-0.956s-0.982,1.433-1.907,1.996z'/%3E%3Cpath fill='%23c52126' d='m289.99,113.28c-0.848-0.498-3.128-1.473-5.556-1.679-2.426-0.205-4.302,0.16-6.316,0.704-1.443,0.39-2.612,0.45-3.768,0.14-1.737-0.463-3.084-2.031-3.542-3.952,0,0-1.602,2.054,0.036,4.283,0.787,1.072,1.812,1.742,2.856,1.953,3.399,0.685,6.733-1.39,9.564-1.571,2.719-0.177,4.854,1.547,4.854,1.547s0.643,0.534,1.549,0.007c0.908-0.53,1.171-0.934,0.323-1.432z'/%3E%3Cpath fill='%23d4af3a' d='m280.2,211.66s-0.334-0.033-0.802-0.101c-0.468-0.067-1.471-0.402-1.772-0.537-0.301-0.133-0.769-0.167-1.07,0.168-0.301,0.336-2.742,1.777-2.742,1.777h4.046c1.404,0,2.34-1.307,2.34-1.307z'/%3E%3Cpath fill='%23d4af3a' d='m291.59,210.97v-0.404l-0.539-1.161s-0.629,0.395-1.242,1.029c-0.789,0.819-1.638,1.97-2.017,2.456-0.674,0.863-1.616,1.675-0.808,0.296,0.808-1.378,1.077-1.972,1.723-2.891,0.647-0.918,1.132-1.323,1.052-1.378-0.081-0.054-0.594-0.134-2.291-0.35-1.696-0.218-2.747-0.865-3.528-1.325-0.781-0.459-2.182-1.215-2.182-1.215s-2.882,1.215-3.96,1.485-1.724,0.432-0.674,0.946c1.051,0.513,1.939,0.675,2.451,0.998,0.511,0.326,2.101,0.838,3.071,0.838,0.969,0,2.612,0.026,1.966,0.702-0.646,0.677-1.374,1.974-2.074,3.944-0.7,1.974-0.727,3.729-0.727,4.594s0.107,1.728,0.107,1.728,1.185-1.322,4.364-3.321c3.178-2,4.363-2.675,4.956-2.946,0.592-0.269,0.89-0.269,0.781-1.025-0.106-0.757-0.429-2.621-0.429-3z'/%3E%3Cpath fill='%23d4af3a' d='m303.73,201.31c-0.192-0.086-0.39-0.175-0.59-0.268-0.053,0.014-0.102,0.029-0.146,0.052-0.373,0.187-2.312,1.492-3.095,2.761-0.783,1.267-1.566,1.38-0.709,0,0.858-1.382,1.492-2.164,2.163-2.761,0.259-0.23,0.491-0.422,0.677-0.569-1.56-0.752-3.254-1.663-4.893-2.804-0.212,0.423-0.619,1.173-1.08,1.659-0.671,0.708-2.163,1.306-2.163,1.306s1.193-1.231,1.604-2.164c0.261-0.595,0.432-1.236,0.521-1.621-1.141-0.889-2.234-1.902-3.21-3.065-0.199,0.807-0.844,2.771-2.755,4.91-2.498,2.798-7.496,4.214-7.496,4.214s-1.752,0.187-0.335,0.56,2.424,1.007,5.184,0.521c2.759-0.483,2.945-0.596,3.318-0.706,0.373-0.113,1.38-0.038,0,0.484-1.379,0.521-4.587,1.005-5.817,0.895-1.231-0.111-2.909-0.373-1.156,0.56s2.499,1.305,3.58,1.305c1.082,0,1.529,0.336,2.574,0.336,1.044,0,1.341-0.187,2.088-0.336,0.746-0.148,1.23,0.111,1.23,0.41,0,0.298-1.006,1.118-0.969,3.17,0.037,2.051,0.186,3.394,0.372,3.988,0.188,0.599,0.635,1.567,0.933,2.128,0.298,0.559,0.411,1.117,0.708-0.075,0.298-1.194,0.969-2.909,1.231-4.064,0.261-1.156,0.41-1.193,0.522-1.79,0.111-0.597,0.746-1.044,0.447,0.037s-0.634,2.461-0.857,3.431c-0.225,0.97-0.746,2.759,0.148,1.342,0.895-1.416,4.251-5.183,4.81-5.854s1.007-1.306,1.417-1.864c0.41-0.56,1.566-1.306,2.126-2.126,0.506-0.742,1.988-2.187,2.624-2.704-0.949-0.403-1.95-0.825-3.006-1.298z'/%3E%3Cpath fill='%23d4af3a' d='m257.37,115.23c0.089,2.055,2.364,5.987,3.658,8.087,1.294,2.101,1.65,2.947,1.428,3.082-0.224,0.134-0.759-0.938-1.473-1.875-0.714-0.938-2.096-3.127-3.256-4.78s-2.855-5.584-3.078-5.942c-0.223-0.357-0.313-0.581-0.892-0.135-0.58,0.447-1.695,4.781-0.356,7.73,1.338,2.948,3.345,5.091,4.192,6.119,0.848,1.028,1.963,2.636,1.784,2.771-0.178,0.133-0.49-0.269-1.516-1.341s-2.722-2.904-3.836-4.244c-0.906-1.088-2.135-3.298-2.566-4.088-0.162-0.299-0.371-0.218-0.527-0.062-0.367,0.369-0.955,1.226-0.699,3.569,0.357,3.262,2.052,5.138,3.568,6.791,1.517,1.653,3.034,3.037,2.811,3.261s-1.784-1.162-2.855-2.189c-1.07-1.027-3.703-3.573-4.282-4.289-0.581-0.714-1.427-0.358-1.383,2.457s3.167,5.674,4.46,7.238c1.295,1.563,2.9,2.5,2.767,2.813-0.134,0.313-1.428-0.49-2.275-1.072-0.847-0.581-4.015-2.636-4.639-3.083-0.624-0.446-0.937,0.402-0.134,3.083,0.803,2.679,3.123,4.824,4.505,5.806,1.383,0.983,3.613,2.188,3.479,2.503-0.133,0.312-1.07-0.09-2.364-0.716-1.293-0.625-2.854-1.206-3.97-1.518-1.116-0.313-1.115,0.49-1.115,0.49s-0.224,2.278,1.427,4.11,3.524,2.547,5.308,2.858c1.784,0.313,2.052,0.403,2.007,0.672-0.044,0.268-0.223,0.312-0.624,0.312s-2.052,0.179-3.569,0.179-2.319,0.356-2.319,1.027-0.045,1.564,2.23,3.082c2.274,1.52,4.817,1.743,5.888,1.967,1.07,0.223,1.114,0.313,0.892,0.626-0.223,0.312-0.713,0.268-2.409,0.446-1.695,0.178-2.721,0.849-2.944,1.295-0.223,0.447,0.134,1.788,1.518,2.725,1.382,0.939,3.166,1.252,5.843,1.073,2.677-0.18,3.346-0.224,3.435,0.224,0.09,0.446-0.802,0.581-2.141,0.805-1.338,0.222-2.365,0.222-3.123,0.848-0.759,0.626-0.178,1.921,1.115,2.859s4.506,0.938,5.844,0.849,3.39-0.581,3.524-0.224-0.981,0.895-2.363,1.385c-1.384,0.493-1.786,0.804-2.052,1.386-0.269,0.58-0.045,1.116,1.605,1.741,1.65,0.626,4.059,0.626,5.308,0.045,1.25-0.58,1.918-0.805,2.142-0.58,0.222,0.225,0,0.447-0.268,0.76-0.267,0.313-1.338,1.161-2.721,1.519s-1.517,0.358-2.008,1.474c-0.49,1.117,0.758,2.012,3.256,2.102,2.499,0.088,5.844-0.894,6.915-1.521,1.071-0.626,1.472-0.759,1.65-0.535,0.178,0.223,0.134,0.357-0.401,0.758-0.536,0.404-2.231,1.609-3.078,1.833-0.847,0.223-0.937,0.848-0.937,1.429,0,0.58-0.223,1.742,2.007,2.279,2.231,0.536,4.862,0.135,7.271-1.564,0.776-0.546,1.227-0.997,1.481-1.388-0.195-2.281-0.092-3.849,0.182-5.295-0.473-0.05-1.37-0.186-2.288-0.555-1.338-0.535-1.873-1.786-2.186-2.457-0.313-0.67-0.758-0.67-1.294-0.492-0.536,0.181-1.071,0.403-1.829,0.359s-2.364-0.447-3.524-1.833c-1.16-1.385-0.938-2.724-0.982-3.396-0.045-0.67-1.115-0.178-1.65-0.178-0.536,0-2.097-0.224-3.523-1.206-1.428-0.983-1.428-2.323-1.562-2.86-0.134-0.535-0.714-0.892-1.16-1.072-0.445-0.178-1.16-0.356-2.142-1.161-0.981-0.804-1.337-2.367-1.382-2.903-0.044-0.536-0.625-0.581-2.632-1.608s-1.829-3.172-1.739-4.02c0.089-0.85,1.025-1.563,1.025-1.878,0-0.313-0.669-0.401-1.338-0.804-0.669-0.401-2.364-1.072-2.408-3.573-0.045-2.502,1.606-2.77,1.606-2.77s-0.313-0.135-0.982-0.536c-0.669-0.403-2.497-1.653-2.497-3.128,0-1.474,0.668-2.144,1.159-2.502,0.491-0.357,1.829-0.714,1.829-0.714s-0.848-0.537-1.205-1.698c-0.357-1.162-0.491-2.59,0.356-3.618,0.848-1.028,2.275-1.028,3.034-1.028s1.427,0.402,1.695,0.18c0.268-0.224,0.312-0.402,0.044-0.983-0.267-0.58-0.312-2.011-0.089-2.501,0.224-0.492,0.268-1.474,2.187-2.1,1.917-0.625,3.924,0.67,4.549,1.028s0.357-0.493,0.357-1.117c0-0.625-1.293-2.189-2.766-4.423-1.472-2.234-2.141-3.396-3.792-6.791s-2.722-7.773-2.944-8.89c-0.223-1.117-0.669-0.582-0.669-0.582s-0.446,0.18-1.472,2.77c-1.024,2.592-1.202,4.96-1.113,7.013z'/%3E%3Cpath fill='%23d4af3a' d='m291.02,160.92c-1.15-0.058-2.643-0.689-3.792-2.358-1.148-1.669-2.873-2.073-5.861-2.016-2.988,0.058-4.367-1.38-5.114-3.451-0.747-2.073,0.115-4.433,3.16-5.929s4.425-3.165,4.539-5.753c0.115-2.59-3.044-5.813-6.205-9.438s-5.631-8.748-5.631-8.748-0.919,1.209-0.919,2.417,0.459,2.474,0,2.819c-0.46,0.346-0.632-0.517-2.47-1.323-1.839-0.806-3.333-0.92-4.482,0.403s0,3.625,1.034,4.719c1.035,1.093,1.896,1.9,1.609,2.303s-1.839-0.633-2.356-0.979-1.724-1.668-3.505-1.496-2.414,0.69-2.586,2.187c-0.172,1.496,1.609,2.818,2.758,3.395,1.149,0.574,1.609,1.093,1.321,1.322-0.287,0.231-0.575,0-1.092-0.171-0.516-0.173-1.953-0.345-2.872,0-0.92,0.345-2.414,1.61-1.035,3.165,1.379,1.554,4.252,2.129,4.827,2.243,0.574,0.115,0.862-0.058,0.919,0.402,0.057,0.462-1.207,0.462-2.758,0.52s-2.011,1.553-1.781,2.704,2.815,2.416,4.251,2.647c1.438,0.23,1.954,0,2.069,0.402,0.116,0.402-0.172,0.575-0.977,0.806-0.804,0.229-2.356,0.403-2.644,1.669-0.287,1.266-0.344,1.841,0.863,2.936,1.207,1.093,3.161,0.92,3.735,0.805,0.575-0.114,1.265-0.749,1.839-0.172,0.574,0.574-0.518,1.035-1.495,1.726-0.977,0.692-0.919,2.015,0.747,2.936,1.666,0.922,3.333,0.574,4.022,0.345s1.609-1.323,2.068-0.633c0.46,0.69-1.436,0.921-2.241,1.899-0.804,0.977-0.517,2.588,1.092,3.566,1.609,0.979,4.252,0.288,4.712-0.114,0.459-0.402,1.033-0.574,1.378-0.229,0.344,0.343-0.172,1.264-0.517,2.07-0.344,0.806-0.977,3.165,1.437,4.086,2.414,0.92,4.597-1.151,4.999-1.555,0.402-0.402,0.804-0.46,1.149-0.287,0.344,0.174,0.173,0.518-0.115,0.921-0.287,0.402-0.919,2.128,0.804,3.338,1.177,0.825,2.461,0.764,3.157,0.644,0.359-1.348,0.826-2.788,1.302-4.805h-0.36c-0.23,0-0.276,0.345-0.276,0.483s0.069,0.253-0.139,0.253c-0.207,0-0.23,0.115-0.529,0.323-0.299,0.207-0.575,0.459-0.737,0.345-0.161-0.115,0.622-0.53,0.829-0.783,0.208-0.254,0.622-0.645,0.645-0.92,0.023-0.277,0.161-0.438,0.575-0.783,0.129-0.107,0.23-0.235,0.31-0.359,0.277-1.342,0.548-2.913,0.795-4.815,0.167-1.291,0.262-2.507,0.299-3.643l-0.755-0.039z'/%3E%3Cpath fill='%23d4af3a' d='m241.91,125.05c2.567,5.193,6.192,8.117,6.192,8.117s-0.476-1.29-0.687-2.177c-0.209-0.888-0.046-1.892-0.046-1.892s-0.91-1.167-2.591-3.758-2.568-6.419-2.568-6.419,1.564,3.828,2.778,5.86c1.215,2.031,2.616,3.688,2.616,3.688s0.489-1.796,0.84-1.89c0.35-0.093,0.607,0.187,0.91,0.583,0.304,0.397,0.562,0.36,0.562,0.36s-0.415-0.857-1.053-1.885c-0.29-0.467-0.713-0.971-1.012-1.443-0.957-1.512-3.02-4.385-4.078-7.259-1.058-2.875-3.373-10.083-3.776-12.202-0.402-2.117-0.805-0.958-1.208,0.606-0.402,1.563-0.956,3.781-0.604,7.108s1.157,7.41,3.725,12.603z'/%3E%3Cpath fill='%23d4af3a' d='m245.23,139.07c0.956,0.706,2.366,1.663,2.366,1.663s-0.223-0.521-0.364-1.146-0.201-1.912-0.201-1.912-1.126-0.988-1.91-1.672c-0.784-0.685-1.77-1.571-3.72-3.987-1.95-2.417-0.382-0.966,1.206,0.766s4.625,4.248,4.625,4.248,0-0.04,0.02-0.563c0.021-0.523,0.182-0.906,0.463-1.268,0.282-0.363,0.133-0.414-1.579-1.724-1.711-1.311-6.142-6.302-7.954-9.278-1.813-2.975-3.776-7.008-3.776-7.008s-0.956,5.95,2.669,12.504c3.624,6.553,7.199,8.671,8.155,9.377z'/%3E%3Cpath fill='%23d4af3a' d='m264.25,176.6c1.986-0.77,1.442-2.729,1.442-2.761s-1.218,0.386-2.338,0.802c-1.122,0.419-3.877,1.22-4.966,1.251-1.088,0.032-1.088-0.127-1.121-0.288-0.032-0.159,0.833,0,2.402-0.288,1.57-0.289,4.325-1.733,4.805-2.053,0.48-0.322,0.416-0.387-0.288-0.451-0.705-0.063-1.313-0.385-1.57-0.608-0.255-0.225-0.992,0.097-2.786,0.515-1.795,0.416-5.511,1.058-8.362,1.058s-5.509-0.481-5.958-0.578c-0.449-0.096-0.929,0.161,0.449,2.472,1.377,2.309,6.215,3.561,9.578,3.528,3.363-0.034,6.727-1.83,8.713-2.599z'/%3E%3Cpath fill='%23d4af3a' d='m255.31,171.83c3.47,0.029,4.764-1.002,4.764-1.002s0-0.177-0.47-0.883c-0.471-0.706-0.382-1.914-0.382-1.914s-0.824,0.147-2.265,0.354c-1.441,0.206-3.117,0.412-4.97,0.088s-1.058-0.53,0.412-0.354c1.471,0.177,4.293-0.354,5.205-0.677,0.911-0.324,0.529-0.618-0.088-0.826-0.617-0.204-2.293-1.266-2.293-1.266s-4.205,0.53-8.116,0.09c-3.911-0.444-6.382-1.444-7.176-1.562s-0.765,0.207-0.765,0.207-0.206,0.352,1.146,2.471c1.353,2.123,4,3.507,6.235,4.154,2.235,0.649,5.293,1.091,8.763,1.12z'/%3E%3Cpath fill='%23d4af3a' d='m254.42,163.7s-0.147-0.206-0.353-0.914c-0.206-0.707,0.382-1.236,0.382-1.236s-0.794-0.235-3.382-0.56c-2.588-0.324-2.734-0.53-4.323-0.884-1.588-0.353-2.646-0.824-2.617-1.001s0.529,0.089,1.47,0.441c0.94,0.354,4.911,0.766,6.587,1.002,1.676,0.235,2.617,0.413,2.911,0.235,0.294-0.177,1.323-0.442,1.323-0.442s-0.706-0.204-1.588-0.353c-0.883-0.147-1.676-0.53-2.146-0.854-0.471-0.324-0.618-0.414-2.735-0.647-2.118-0.235-3.823-0.914-7.617-2.298-3.792-1.385-6.646-3.033-7.41-3.651-0.765-0.618-0.706-0.176-0.5,0.618,0.206,0.796,0.176,1.796,2.088,4.034,1.911,2.239,2.852,3.21,7.674,4.979,4.825,1.766,10.236,1.531,10.236,1.531z'/%3E%3Cpath fill='%23d4af3a' d='m240.16,151.95c4.264,3.004,9.261,4.107,10.321,4.24,0.238-0.278-0.258-1.276-0.03-1.885,0.276-0.729,0.736-0.736,1.765-0.795,1.029-0.061,0.353-0.266,0.118-0.266s-0.294-0.029-2-0.471c-1.706-0.44-3.44-0.707-5.792-1.591-2.353-0.883-3.058-1.531-3-1.708,0.059-0.176,1.088,0.561,3.265,1.385,2.176,0.824,4.705,1.148,6.087,1.444,1.382,0.292,0.176-0.296-0.471-0.679-0.647-0.384-1.559-1.797-1.559-1.797s-1.529-0.265-4.028-1.03c-2.5-0.766-4.587-1.621-6.675-2.798-0.717-0.406-1.411-0.929-2.159-1.466-1.431-1.026-2.869-2.075-3.428-2.48-0.854-0.618-0.588-0.118-0.5,0.265s0.676,2.151,2.028,4.094c1.353,1.944,1.794,2.533,6.058,5.538z'/%3E%3Cpath fill='%23d4af3a' d='m239.46,143.5c4.205,3.329,7.821,4.357,8.439,4.623,0.617,0.266,0.559-0.088,0.441-0.441-0.118-0.354-0.207-1.501-0.207-1.501s-1.5-0.855-3.176-1.827c-1.676-0.973-3.528-2.297-4.763-3.15-1.235-0.854-0.5-0.795-0.118-0.473,0.382,0.324,2.088,1.326,3.793,2.386,1.706,1.061,4.293,2.592,4.293,2.592s0.059-0.559,0.412-0.913,1.234-0.264,1.234-0.264-0.441-0.442-0.706-0.854c-0.264-0.414-1.647-0.854-3.205-1.592-1.559-0.735-4.353-2.796-6.411-4.534-2.058-1.737-6.058-6.096-6.322-6.45-0.265-0.354-0.441-0.294-0.471,0.147-0.029,0.441-0.176,0.736,0.265,2.739,0.444,2.002,2.296,6.184,6.502,9.512z'/%3E%3Cpath fill='%23d4af3a' d='m254.34,112.03c0.477,0.99,0.999,1.738,1.375,2.383,0.568,0.974,0.888,1.605,0.888,1.605s0.114-0.343,0.024-0.928-0.18-1.396-0.022-2.363c0.083-0.518,0.195-1.034,0.167-1.494-0.033-0.523-0.208-0.975-0.279-1.273-0.135-0.564-0.741-3.016-1.034-4.748-0.292-1.733-0.606-4.208-0.584-6.392,0.022-2.183,0.337-1.081,0.337-0.022s0.112,2.679,0.449,5.176c0.337,2.498,1.393,6.301,1.393,6.301s0.067-0.585,0.382-1.418,0.832-1.777,1.236-2.813c0.404-1.035,0.262-1.208,0.262-1.208s-1.476-7.066-1.864-10.406c-0.389-3.339-1.01-12.116-1.01-12.116-2.16,2.173-3.766,7.892-4.052,13.301-0.214,4.075,0.444,7.847,0.635,9.376,0.378,3.028,0.904,5.392,1.697,7.039z'/%3E%3Cpath fill='%23d4af3a' d='m249.55,123.18c0.067-1.6,0.435-2.811,1.467-3.166,0,0-0.913-1.601-1.711-3.883-0.545-1.563-0.996-3.567-1.225-5.105-0.564-3.787-1.016-7.688,0.113-1.3,1.128,6.387,2.483,8.648,2.483,8.648l1.637,2.657c-0.242-1.167-0.28-1.987-0.218-3.262s0.225-3.002,0.613-4.369c0,0-1.976-3.956-3.217-8.706s-1.951-9.069-1.976-11.644c-0.113-2.488-0.169-3.449-0.169-3.449s-2.031,1.526-2.708,9.27c-0.678,7.745,1.355,15.151,2.37,17.978,1.016,2.825,2.541,6.331,2.541,6.331z'/%3E%3Cpath fill='%23d4af3a' d='m271.71,182.24s-0.32-0.224-1.281-0.834c-0.961-0.608-0.672-2.438-0.672-2.438s-0.256,0.192-0.962,0.674c-0.705,0.481-1.505,1.025-2.466,1.411s-1.442,0.642-2.05,0.834c-0.609,0.193-0.448-0.063,0.064-0.353,0.512-0.288,0.673-0.449,1.955-0.962,1.28-0.514,3.843-2.76,3.843-2.76s-0.609-0.064-1.666-0.096-2.403-0.577-2.403-0.577-1.056,0.962-5.317,2.79c-4.261,1.83-7.881,2.31-7.881,2.31s0.449,2.183,2.499,2.921c1.698,0.738,4.037,1.187,8.618,0.097,4.58-1.09,7.719-3.017,7.719-3.017z'/%3E%3Cpath fill='%23d4af3a' d='m277.32,186.61c0.353-1.799-0.673-3.05-0.673-3.05s-0.224,0.128-0.864,0.706c-0.641,0.578-1.571,1.669-3.364,2.566s-2.435,0.834-0.705-0.097,4.261-3.561,4.261-3.561l-0.672-0.257c-0.674-0.257-1.827,0.192-6.632,3.079-4.805,2.888-7.625,2.985-7.625,2.985s2.146,2.599,7.977,2.406c5.831-0.19,7.945-2.982,8.297-4.777z'/%3E%3Cpath fill='%23d4af3a' d='m288.34,184.52s-0.641,0.897-1.506,1.475-3.171,0.931-3.171,0.931-0.096,0.257-0.544,0.834c-0.449,0.578-1.442,1.958-2.467,2.696-1.024,0.738-2.627,1.218-2.723,1.025s0.929-0.577,1.922-1.187c0.993-0.608,1.89-1.733,2.563-2.502,0.673-0.771-0.288-0.642-0.288-0.642s-1.217,0.031-2.339-0.064c-1.121-0.098-0.897,0-1.217,0.546s-0.769,1.026-1.602,1.989c-1.016,1.174-1.981,2.238-2.947,3.399-0.64,0.771-0.16,0.995-0.16,0.995s0.289,0.482,2.883,0.77c1.602,0.179,3.337-0.023,5.163-1.076,1.131-0.656,2.298-1.695,3.488-2.998,3.105-3.399,2.945-6.191,2.945-6.191z'/%3E%3Cpath fill='%23d4af3a' d='m289.72,191.54c-0.641,0.835-0.994,1.188-0.994,1.188s0.449-1.38,0.833-2.022c0.205-0.342,0.427-0.667,0.592-0.894-0.429-0.964-0.781-2-1.041-3.117-0.285,0.923-1.172,3.631-2.274,5.392-1.344,2.148-2.531,2.919-1.762,3.495,0.769,0.578,2.274,0.707,3.973-0.128,1.64-0.805,2.114-2.211,2.347-3.346-0.288-0.446-0.558-0.909-0.808-1.394-0.212,0.131-0.52,0.376-0.866,0.826z'/%3E%3Cellipse rx='1.192' ry='1.092' cy='105.75' cx='289.34' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m286.83,103.69c1.088-0.026,1.673-0.541,2.874-0.425,1.417,0.138,3.337,0.964,5.669,2.202,1.823,0.824,4.23,1.236,6.548,0.571,0.649-0.187,1.291-0.542,1.912-0.892,2.835-1.606,2.149-4.771,2.149-4.771-2.092,1.509-4.678,2.32-7.087,2.156,0,0,0.183,0.138,0.594,0.551,0.412,0.413,1.165,0.893,0.915,1.102-0.249,0.207-1.28-0.781-2.149-1.423-0.869-0.643-2.149-1.514-4.344-2.154-2.195-0.644-4.664-0.688-6.31,0.227-1.646,0.919-1.783,2.066-1.554,2.524,0.126,0.257,0.429,0.341,0.783,0.332z'/%3E%3Cpath fill='%23d4af3a' d='m317.64,126.8c-0.503-0.138-1.371-0.275-2.514-1.33-1.144-1.054-3.887-4.082-4.208-4.632-0.32-0.551-0.183-1.055,0.595-1.377,0.777-0.32,1.326-1.33,1.326-1.33s-1.691-0.643-2.834-1.469c-1.144-0.824-3.796-3.21-4.162-3.806s-0.183-0.688,0.366-0.871c0.55-0.184,0.687-0.551,0.687-0.551s-1.235-0.779-2.377-1.696c-1.144-0.917-2.698-2.431-2.698-2.431-1.713,0.688-4.401,0.398-5.853,0.138-2.561-0.458-4.435-1.514-4.435-1.514s-0.092,0.413-0.412,1.193c-0.32,0.779-1.509,1.239-2.698,0.458-1.189-0.779-0.915-2.476-0.915-2.476s-0.96-0.596-2.926-1.33-3.566-0.826-5.167-0.092c-1.601,0.733-2.378,2.935-2.378,4.587,0,1.65,0.87,0.963,1.052,0.732,0.183-0.229,0.549-1.422,2.561-1.742,2.012-0.322,3.841,0.642,6.127,2.521,2.286,1.882,2.789,2.019,3.932,3.211,1.143,1.193,0.229,1.834-1.737,2.477s-4.481-0.642-4.573-0.595c-0.378,0.189,0.848,1.938,2.544,2.599,1.696,0.66,3.864,0.232,5.55-0.444,1.143-0.458,1.356,0.015,1.691,0.367,1.857,1.952,2.34,3.781,2.652,6.009,0.949-0.292,1.606-1.24,1.738-2.018,0.063-0.373,0.183-1.193,0.823-0.597,0.64,0.597,1.143,3.898,1.143,5.412s-0.458,3.532-0.458,3.532l0.458-0.046c0.275-0.046,0.823-0.367,1.555-0.779,0.731-0.414,0.777,0.046,0.777,0.871s0.274,2.385,1.372,5.183,2.698,3.714,2.698,3.714,0.321-0.55,0.641-1.65c0.319-1.101,0.549-3.256,0.549-5.137s-0.503-5.917-0.503-5.917,2.287,2.798,4.664,3.487c2.378,0.688,4.756,0.275,5.762-0.872,1.003-1.146,0.088-1.65-0.415-1.789z'/%3E%3Cpath fill='%23d4af3a' d='m302,134.04s-0.722,1.597-1.116,2.166-0.569,0.658-0.569,0.658,0.722,0.612,1.773,0.94c1.051,0.329,1.992,0.525,1.992,0.525s-1.183-1.621-1.598-2.758c-0.416-1.138-0.482-1.531-0.482-1.531z'/%3E%3Cpath fill='%23d4af3a' d='m316.28,133.1c-0.351-0.897-0.569-1.401-0.569-1.401-1.459,0.292-4.227-0.393-5.429-1.116,0,0,1.095,2.231,2.189,2.998,1.095,0.766,1.248,0.81,1.248,0.81s-1.094,0.176-2.561-1.269c-1.466-1.445-2.123-3.109-2.123-3.109s0.328,3.853-0.263,6.216-0.722,2.67-0.722,2.67,3.107,0.547,6.566-0.416c3.458-0.964,3.72-1.27,3.72-1.27s0.415-0.109-0.131-0.831c-0.547-0.721-1.575-2.385-1.925-3.282z'/%3E%3Cpath fill='%23b96b29' d='m310,124.64c-1.064-1.223-1.17-1.516-1.17-1.516s-0.372,0.372-0.054,0.905c0.319,0.531,1.835,1.86,2.872,2.445,1.038,0.585,2.074,0.771,2.074,0.771l-0.053-0.213c0,0.001-2.606-1.169-3.669-2.392z'/%3E%3Cpath fill='%23b96b29' d='m305.78,132.67s-0.266-4.84-0.266-5.558-0.452-0.532-0.452-0.532l-0.531,0.239s0.907,6.173,1.04,7.077c0.113,0.762,0.488,0.697,0.68,0.663-0.38-0.197-0.455-1.668-0.471-1.889z'/%3E%3Cpath fill='%23b96b29' d='m299.25,111.72c-0.395-0.394-1.283-0.689-0.427,0.264,0.855,0.954,1.975,2.14,2.303,3.128,0.33,0.987,0.527,2.204-0.032,1.941-0.56-0.264-0.955-0.264-1.547-0.757-0.593-0.494-1.711-1.318-2.172-1.448-0.461-0.132-1.283,0-0.625,0.723,0.658,0.725,1.383,1.417,2.633,2.337,1.251,0.922,1.975,1.316,2.633,1.777,0.658,0.462,1.316,0.856,1.316,0.856s-0.593-3.949-1.679-5.693-2.008-2.732-2.403-3.128z'/%3E%3Cpath fill='%23b96b29' d='m277.91,177.87c-0.802,0.608-1.853,0.857-1.853,0.857s-0.498-0.026-0.498,0.167,0.581,0,1.189-0.11c0.608-0.111,1.438-0.72,1.742-0.941,0.304-0.222,0.747-0.499,0.608-0.887-0.138-0.388-0.387,0.305-1.188,0.914z'/%3E%3Cpath fill='%23b96b29' d='m284.8,181.56c-0.166,0.192-1.493,1.19-1.493,1.19s-0.415,0.276-0.858,0.442c-0.442,0.167-0.552,0.417-0.552,0.417s0.083,0.109,0.552-0.027c0.47-0.14,1.854-1.109,2.295-1.497,0.442-0.389,0.637-0.498,0.471-0.664-0.165-0.166-0.248-0.055-0.415,0.139z'/%3E%3Cpath fill='%23b96b29' d='m256.87,131.93c0.248,0.302,0.55,0.715,0.688,0.577,0.138-0.137-0.028-0.275-0.358-0.661-0.33-0.385-0.522-0.578-0.522-0.578s-0.467-0.744-0.743-1.02c-0.275-0.275-0.688-0.413-0.165,0.22,0.523,0.635,0.853,1.158,1.1,1.462z'/%3E%3Cpath fill='%23b96b29' d='m254.75,136.58c0.302,0.277,0.577,0.523,0.907,0.881s0.578,0.743,0.77,0.551c0.193-0.193-0.495-0.605-0.797-0.992-0.303-0.386-0.55-0.633-0.936-0.936s-0.853-0.551-0.853-0.551,0.606,0.772,0.909,1.047z'/%3E%3Cpath fill='%23b96b29' d='m255.54,144.09c0.525,0.553,1.299,0.719,1.41,0.499,0.111-0.222-0.055-0.4-0.496-0.62-0.439-0.22-1.155-0.688-1.513-0.936-0.357-0.249-0.715-0.524-0.963-0.771-0.247-0.248-0.54-0.471-0.632-0.387-0.092,0.085,0.729,0.968,0.977,1.107,0.249,0.138,0.692,0.554,1.217,1.108z'/%3E%3Cpath fill='%23b96b29' d='m257.06,150.1c0-0.221,0.054-0.331-0.388-0.36-0.442-0.027-1.051-0.109-1.051-0.109s-0.857-0.333-0.913-0.167c-0.055,0.167,0.719,0.5,1.051,0.555,0.332,0.056,0.746,0.166,0.939,0.275,0.195,0.11,0.362,0.026,0.362-0.194z'/%3E%3Cpath fill='%23b96b29' d='m257.72,156.63c-0.939,0-1.742-0.223-1.797-0.084s0.442,0.361,0.913,0.526c0.471,0.167,1.356,0.222,1.964,0.249s0.719-0.11,0.691-0.414c-0.028-0.306-0.83-0.277-1.771-0.277z'/%3E%3Cpath fill='%23b96b29' d='m265.08,163.78c-0.138-0.138-0.47-0.027-0.996,0.083-0.524,0.112-1.382,0.278-1.88,0.251s-1.576-0.056-1.576-0.056l-0.608,0.138c0,0.139,0.801,0.111,1.963,0.249,1.161,0.139,1.935-0.11,2.488-0.194,0.554-0.083,0.748-0.331,0.609-0.471z'/%3E%3Cpath fill='%23b96b29' d='m268.12,168.87c-0.581,0.222-0.995,0.276-1.438,0.276-0.442,0-1.493,0.194-1.493,0.194s-0.498,0.056-0.415,0.25c0.083,0.193,0.249,0,0.69-0.056,0.443-0.056,0.775,0,1.549-0.027,0.774-0.028,1.217-0.223,1.687-0.305,0.47-0.084,0.995-0.333,0.747-0.638-0.249-0.303-0.746,0.084-1.327,0.306z'/%3E%3Cpath fill='%23b96b29' d='m274.04,172.72c-0.332,0.333-1.604,1.191-1.604,1.191s-0.249,0.194-0.747,0.443-0.47,0.361-0.387,0.499,0.387-0.194,0.663-0.305,1.189-0.722,1.659-1.107c0.47-0.39,1.078-0.694,0.967-0.97-0.109-0.277-0.219-0.082-0.551,0.249z'/%3E%3Cpath fill='%23b96b29' d='m264.19,122.87s0.11,0.253,1.131,1.531c1.022,1.277,0.475,0.072,0.219-0.254-0.256-0.33-1.751-2.444-2.262-3.029-0.51-0.584-0.583-0.292-0.328,0.072,0.256,0.365,1.24,1.68,1.24,1.68z'/%3E%3Cpath fill='%23b96b29' d='m262.04,129.43c0.146-0.146-0.183-0.292-0.766-1.021-0.584-0.73-1.751-2.225-1.751-2.225s-0.329-0.693-0.438-0.621c-0.109,0.073,0.401,1.167,0.875,1.643,0.475,0.474,1.094,1.386,1.423,1.787s0.511,0.583,0.657,0.437z'/%3E%3Cpath fill='%23b96b29' d='m264.87,141.73c0-0.357-1.155-0.303-1.677-0.413-0.523-0.11-1.458-0.303-1.458-0.303s-1.101-0.193-1.128-0.055c-0.028,0.136,0.22,0.274,0.825,0.386,0.605,0.109,1.513,0.385,2.201,0.495s1.237,0.249,1.237-0.11z'/%3E%3Cpath fill='%23b96b29' d='m262.04,135.09c0.766,0.62,1.276,0.912,1.678,1.131,0.401,0.218,0.729,0.548,0.949,0.292,0.219-0.257-0.183-0.438-0.839-0.73-0.657-0.292-0.985-0.547-0.985-0.547s-0.365-0.182-0.694-0.365c-0.329-0.182-0.876-0.401-0.109,0.219z'/%3E%3Cpath fill='%23b96b29' d='m268.64,130.71c-0.475-0.401-0.876-0.622-0.876-0.622s-0.583-0.547-0.693-0.365c-0.109,0.184,0.656,0.73,1.021,1.058,0.365,0.329,1.022,1.278,1.35,1.095,0.328-0.182-0.329-0.765-0.802-1.166z'/%3E%3Cpath fill='%23b96b29' d='m264.33,147.85s-0.637,0.165-1.051,0.276-0.442,0.306,0.305,0.306,1.051-0.194,1.797-0.334c0.747-0.138,0.997-0.221,0.885-0.47-0.11-0.25-0.498-0.166-0.802-0.083s-1.134,0.305-1.134,0.305z'/%3E%3Cpath fill='%23b96b29' d='m265.49,154.06c-0.055,0.14,0.525,0,0.912-0.138,0.387-0.139,1.189-0.553,1.659-0.692,0.471-0.138,0.471-0.222,0.471-0.499,0-0.276-0.499-0.056-1.106,0.139-0.608,0.194-1.383,0.804-1.383,0.804s-0.498,0.248-0.553,0.386z'/%3E%3Cpath fill='%23b96b29' d='m273.48,157.82c0.554-0.334,0.665-0.582,0.47-0.749-0.193-0.165-0.359-0.138-0.801,0.222-0.443,0.36-1.3,0.969-1.3,0.969s-0.442,0.167-0.774,0.333-0.747,0.443-0.636,0.609c0.11,0.166,0.802,0,1.161-0.305,0.36-0.304,1.328-0.748,1.88-1.079z'/%3E%3Cpath fill='%23b96b29' d='m277.25,162.81c0.221-0.195,0.884-0.414,1.189-0.637,0.304-0.222,0.498-0.886,0.249-0.969s-0.387,0.276-0.912,0.663c-0.526,0.389-2.323,1.579-2.323,1.579l-0.471,0.194c-0.498,0.193-0.276,0.333,0.139,0.277,0.415-0.057,0.691-0.057,1.189-0.442,0.497-0.388,0.718-0.471,0.94-0.665z'/%3E%3Cpath fill='%23b96b29' d='m282.83,167.54c0.471-0.193,1.162-0.803,1.494-1.106,0.331-0.306,0.746-0.693,0.498-0.887-0.25-0.193-0.525,0.056-0.913,0.414-0.387,0.361-1.411,1.441-1.411,1.441s-0.138,0.027-0.691,0.471c-0.553,0.442,0.028,0.359,0.221,0.166,0.194-0.193,0.333-0.305,0.802-0.499z'/%3E%3Cpolygon points='305.58,96.588,307.83,94.99,305.18,94.311,303.48,95.668' fill='%23d4af3a'/%3E%3Cellipse rx='2.146' ry='2.069' transform='translate(-5.9509277e-6,-3.4236908e-6)' cy='94.716' cx='312.78' fill='%23b96b29'/%3E%3Cellipse cx='312.78' rx='1.295' cy='94.278' ry='1.237' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m308.3,87.608c0.552,0.205,1.27,0.115,1.27,0.115s0.217-0.952-0.308-1.416c-0.525-0.462-1-0.796-1.308-1.105-0.308-0.31-0.384-0.413-0.384-0.413s0,0.823-0.04,1.338c-0.037,0.516,0.219,1.274,0.77,1.481z'/%3E%3Cellipse cx='309.44' rx='0.394' cy='88.65' ry='0.373' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m306.51,88.25c-0.167,0.232-0.525,0.604-0.525,0.604s0.436,0.013,0.795,0.27c0.359,0.258,0.821,0.476,1.244,0.425,0.423-0.053,0.603-0.452,0.513-0.734-0.089-0.283-0.294-0.577-0.987-0.836-0.693-0.256-0.873,0.039-1.04,0.271z'/%3E%3Cpath fill='%23d4af3a' d='m308.01,90.756c-1.348,0.121-3.129-1.369-3.129-1.369-0.166,1.197-0.906,1.818-2.04,2.045l0.104,0.053s1.054,0.539,2.299,0.728c0.563,0.086,1.064-0.011,1.669-0.132,0.73-0.148,1.551-0.356,1.995-0.63,0.813-0.502,0.57-1.803,0.57-1.803s-0.119,0.986-1.468,1.108z'/%3E%3Cpath fill='%23d4af3a' d='m302.76,89.404c-0.553-0.208-1.383-0.607-1.729-0.625-0.346-0.017-0.848-0.104-0.761,0.538,0.086,0.642,0.743,0.954,1.382,0.971,0.64,0.018,0.969-0.225,1.349-0.417,0.381-0.19,0.312-0.259-0.241-0.467z'/%3E%3Cpath fill='%23d4af3a' d='m298.54,87.114c-0.604-0.433-1.142-0.554-1.142-0.554s-0.397,1.041-0.173,1.683c0.225,0.642,0.692,0.814,1.262,0.796,0.571-0.016,1.418-0.312,1.176-0.745-0.241-0.432-0.518-0.746-1.123-1.18z'/%3E%3Cellipse cx='299.09' rx='0.466' cy='90.041' ry='0.336' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m300.38,84.865c-0.374-1.774-0.311-3.704,1.37-6.163,1.682-2.46,4.607-3.456,4.607-3.456s0.093-0.187,1.027-1.182c0.934-0.997,2.833-2.241,2.833-2.241s-2.204,0.544-3.457,0.945c0,0.022,0.001,0.043,0.001,0.066,0,0.851-0.676,1.541-1.51,1.541-0.318,0-0.615-0.102-0.859-0.274-0.68,0.132-2.944,1.485-3.523,1.968,0.144,0.236,0.228,0.514,0.228,0.812,0,0.849-0.677,1.54-1.511,1.54-0.25,0-0.485-0.061-0.693-0.172-0.068,0.108-0.132,0.217-0.193,0.328-0.475,0.873-0.825,1.711-1.083,2.478,0.387,0.267,0.646,0.766,0.646,1.336,0,0.846-0.573,1.534-1.281,1.541-0.049,0.498-0.045,0.846-0.026,0.995,0.062,0.499,0.249,0.81,1.12,1.059,0.872,0.249,2.055,1.774,2.055,1.774,0.084,0,0.706-1.12,0.249-2.895z'/%3E%3Cpath fill='%23d4af3a' d='m305.74,73.506c0.318-0.258,0.374-0.653,0.121-0.879-0.25-0.227-0.711-0.2-1.029,0.06-0.317,0.26-0.373,0.655-0.121,0.881,0.251,0.226,0.712,0.2,1.029-0.062z'/%3E%3Cpath fill='%23d4af3a' d='m300.1,77.317c0.357-0.326,0.42-0.819,0.136-1.104-0.283-0.284-0.803-0.25-1.162,0.076-0.358,0.324-0.419,0.818-0.136,1.102,0.283,0.285,0.803,0.251,1.162-0.074z'/%3E%3Cellipse cx='296.74' rx='0.871' cy='82.109' ry='0.856' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m315.54,70.017c-0.452,0.099-1.288,0.371-2.539,1.026h0.023c0.87,0,1.546,0.556,1.546,1.276,0,0.721-0.791,1.504-1.66,1.504s-1.461-0.755-1.461-1.476c0-0.169,0.04-0.333,0.111-0.482-0.371,0.229-0.767,0.482-1.189,0.767-2.771,1.868-3.424,2.771-4.793,5.324-1.37,2.551-1.868,5.353-1.277,7.003,0.592,1.649,2.771,1.992,2.802,1.992s-0.249-0.249-0.281-0.559c-0.031-0.313,0.063-0.468,0.156-1.091,0.093-0.621,0.031-1.368,0.031-1.368s0.498-0.063,0.778,0.28c0.281,0.342,0.686,0.747,0.965,1.088,0.28,0.342,1.027,0.997,1.027,0.997s0.437-0.624,0.437-1.371c0-0.746-0.498-1.555-0.592-2.863s0.592-3.643,1.867-5.354c1.277-1.712,3.673-3.268,4.389-3.611,0.716-0.341,0.84-0.872,0.872-1.183,0.031-0.311,0.093-0.528,0.155-1.307,0.064-0.778-0.652-0.747-1.367-0.592z'/%3E%3Cpath fill='%23d4af3a' d='m312.79,72.973c0.49,0,0.936-0.441,0.936-0.845,0-0.405-0.381-0.717-0.872-0.717-0.49,0-0.888,0.329-0.888,0.732s0.333,0.83,0.824,0.83z'/%3E%3Cpath fill='%23d4af3a' d='m316.91,89.249c0.668,0.272,1.422,0.119,1.777-0.118,0.355-0.238,0.475-0.843,0.054-1.189-0.419-0.345-1.044-0.333-1.432-0.118-0.388,0.216-1.261,0.831-1.261,0.831s0.194,0.324,0.862,0.594z'/%3E%3Cpath fill='%23d4af3a' d='m319.05,89.999c-0.241,0.372-0.419,0.598-1.161,0.63s-1.547-0.016-2.031-0.501c-0.484-0.484-0.822-1.164-0.822-1.164l-0.838-0.016s-0.273,1.165-0.644,1.486c-0.371,0.324-1.661,0.373-2.225-0.048s-1.08-0.938-1.176-0.873,0,0.485,0.58,0.986c0.58,0.5,0.982,0.809,1.918,0.809h5.318s1.08,0.063,1.387-0.583c0.306-0.646,0.32-1.051,0.177-1.212-0.144-0.161-0.241,0.113-0.483,0.486z'/%3E%3Cpath fill='%23d4af3a' d='m310.96,89.098c0.798,0.443,1.239,0.173,1.529-0.184,0.292-0.356,0.345-0.518,0.345-0.518s-0.754-0.271-1.12-0.487c-0.367-0.215-0.614-0.421-0.98-0.378-0.367,0.044-0.42,0.098-0.42,0.098s-0.151,1.025,0.646,1.469z'/%3E%3Cellipse cx='307.11' rx='1.775' cy='81.24' ry='1.759' fill='%23b96b29'/%3E%3Cpath fill='%23b96b29' d='m310.19,75.144c-0.71-0.478-1.753-0.287-2.331,0.426-0.576,0.715-0.467,1.683,0.245,2.16,0.71,0.479,1.755,0.287,2.332-0.426,0.576-0.712,0.466-1.68-0.246-2.16z'/%3E%3Cellipse cx='307.04' rx='1.031' cy='81.012' ry='0.983' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m309.45,75.338c-0.457-0.125-1.022,0.1-1.26,0.502-0.238,0.403,0.014,0.832,0.623,0.956,1.121,0.229,1.655-1.179,0.637-1.458z'/%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23D4AF3A' d='M282.34,212.67s-2.742,1.31-3.611,1.543c-0.869,0.237-1.07,0.237-1.07,0.237s-1.873,1.709-3.244,2.513c-1.44,0.848-3.093,1.463-4.748,1.646-2.141,0.233-8.025,0.166-10.667,0.066s-4.279,0.536-5.417,1.811c-1.137,1.275-1.404,3.119,0.034,4.528s3.042,0.705,3.578-0.167c0.534-0.873,0.267-1.98,0.033-2.482-0.233-0.504,0.469-0.672,1.204-0.705,0.736-0.033,1.973,0.067,3.11,0.235,1.137,0.167,3.144,0.838,4.013,1.308,0.87,0.47,0.368,0.537-0.234,0.436s-1.27-0.335-2.341-0.736c-1.07-0.402-1.973-0.604-2.641-0.639-0.668-0.033-0.436,0.336-0.301,0.57,0.133,0.235,0.501,0.805,0.601,1.074,0.101,0.269-0.2,1.272-0.2,1.272l0.334,0.639s0.401-0.639,0.535-0.972c0.133-0.337-0.034-0.973,0.1-1.275s0.702-0.302,1.137,0.202c0.435,0.502,0.937,1.107,1.17,2.379,0.234,1.275-0.201,2.181-0.201,2.181s0.536,0.438,0.636,0.737c0.101,0.303-0.134,1.511-0.134,1.511s0.368,0.234,0.703-0.471c0.334-0.703,0.735-1.944,0.835-2.381,0.1-0.436,0.401-1.24,0.936-0.637s0.903,1.342,1.004,1.711c0.099,0.368,0.099,0.671,0.099,0.671s1.204-1.175,1.605-1.846,1.237-1.677,2.375-2.615c1.137-0.939,3.109-2.817,4.079-3.455,0.969-0.637,3.444-1.979,4.213-2.448s0.903-0.502,1.037-1.812c0.134-1.309,0.77-2.48,1.07-3.387,0.29-0.91,0.36-1.24,0.36-1.24z'/%3E%3Cpath fill='%23D4AF3A' d='M238.49,163.52c-0.022-0.223-0.468-1.006-0.579-1.408-0.112-0.401-0.513-0.157-0.513-0.157s-0.87,0.492-1.516,0.671-0.736-0.066-0.803-0.401c-0.066-0.338-0.223-1.387-0.334-2.125-0.112-0.736-0.268-0.691-0.535-0.582-0.267,0.113-1.07,0.403-1.627,0.65-0.557,0.245-0.379,0.514-0.201,0.826,0.178,0.314,0.825,1.632,1.114,2.102,0.29,0.469,0.022,0.671-0.313,0.828-0.334,0.156-0.824,0.223-1.493,0.446s-0.624,0.38-0.558,0.604c0.067,0.225,0.513,1.141,0.758,1.564,0.245,0.425,0.468,0.135,0.468,0.135s0.714-0.647,1.315-0.939c0.602-0.289,0.646-0.201,0.802,0.247,0.156,0.447,0.848,2.795,0.981,3.242,0.134,0.445,0.357,0.401,0.669,0.269,0.312-0.134,0.735-0.202,1.092-0.314,0.357-0.111,0.491-0.827,0.491-0.827s-1.315-2.369-1.672-2.974c-0.357-0.604,0-0.738,0.268-0.782,0.267-0.044,1.047-0.156,1.716-0.313,0.66-0.17,0.48-0.55,0.46-0.78z'/%3E%3Cpath fill='%23D4AF3A' d='M253.35,227.9c-0.1-0.571,0-1.142-0.435-1.577-0.435-0.437-0.97-1.308-1.17-2.012-0.2-0.705,0.167-1.04,0.1-1.443-0.066-0.402-0.602-0.402-1.136,0.035-0.536,0.436-1.238,0.838-1.238,2.112,0,1.273,0.469,2.784,2.241,3.319,1.77,0.54,1.74,0.14,1.64-0.43z'/%3E%3Cpath fill='%23D4AF3A' d='M255.15,227.29s-0.368-0.234-0.535,0.101-0.134,0.504,0.334,1.241,0.77,0.906,1.304,1.24c0.535,0.336,0.167-0.334,0.1-0.536-0.066-0.202,0-0.469-0.133-0.638-0.134-0.168-0.202-0.369-0.202-0.904,0-0.53-0.87-0.5-0.87-0.5z'/%3E%3Cpath fill='%23D4AF3A' d='M257.32,233.33c0.334-0.505,0.636-0.638,1.438-1.006s2.273-0.57,2.774-0.604c0.502-0.034,1.639-1.006,1.471-2.014-0.167-1.006-0.903-1.408-1.538-1.542s-1.204-0.134-1.404,0.167c-0.201,0.303-0.569,0.705-1.271,0.939s-0.803,0.47-1.237,0.604c-0.435,0.135-0.101,0.403-0.468,0.705-0.368,0.301-0.869,0-1.438-0.168-0.568-0.168-0.602-0.268-1.237-0.303-0.635-0.033-2.307-0.133-2.307-0.133s-0.067-0.034-0.434-0.034c-0.368,0-0.402,0.067-0.568,0.47-0.167,0.402,0.033,1.409,0.435,1.912,0.401,0.502,1.705,0.737,2.574,1.006,0.87,0.267,1.305,0.369,2.041,0.502,0.76,0.13,0.86-0.01,1.19-0.51z'/%3E%3Cpath fill='%23D4AF3A' d='M265.45,234.13c0.702-0.47,0.3-1.275,0.134-1.777-0.167-0.504-1.137-0.604-1.639-0.604s-0.769,0-1.037,0.234c-0.268,0.234-0.635,0.57-1.371,0.806-0.734,0.234-1.304,0.502-2.307,0.905-1.003,0.401-1.305,1.072-1.739,1.343-0.435,0.267-1.27,0-1.27,0s-0.603-0.169-0.803,0c-0.201,0.165,0,0.501,0.401,0.937,0.402,0.438,1.17,0.403,2.039,0.672,0.87,0.268,1.037,0.066,1.372-0.168,0.334-0.234,0.602-0.737,1.204-1.107,0.602-0.368,1.906-0.436,2.541-0.502,0.65-0.07,1.79-0.27,2.49-0.74z'/%3E%3Cpath fill='%23D4AF3A' d='M265.45,231.08c0.3,0.27,0.635,0.639,0.903,0.201,0.268-0.435,0.702-1.341,0.401-1.877-0.302-0.536-0.668-1.007-0.668-1.007s-0.502,1.543-0.736,1.946c-0.22,0.41-0.19,0.47,0.11,0.74z'/%3E%3Cpath fill='%23D4AF3A' d='M262.74,226.45c0-0.873-0.602-1.946-0.602-1.946s-0.201,0.805-0.568,1.51c-0.368,0.703-0.736,1.073-0.736,1.073s0.87,0.234,1.204,0.234,0.71,0.01,0.71-0.86z'/%3E%3Cpath fill='%23D4AF3A' d='M257.73,228.3c0.936-0.201,1.438-0.57,1.839-0.905s0.636-1.242,0.368-1.71c-0.267-0.472-0.936-0.973-1.203-0.973h-0.502s-0.268,0.872-0.635,1.308c-0.368,0.437-0.802,0.737-0.769,1.308,0.03,0.56-0.04,1.16,0.9,0.96z'/%3E%3Cpath fill='%23D4AF3A' d='M259.63,224.04c0.034-0.436-0.135-0.905-0.435-1.207-0.301-0.302-0.502-0.502-0.502-0.502s-0.067,0.67-0.133,1.039c-0.067,0.369-0.1,0.436-0.1,0.436s0.268,0.27,0.502,0.37c0.23,0.09,0.63,0.3,0.66-0.14z'/%3E%3Cpath fill='%23D4AF3A' d='M248.07,200.25l0.632-3.952c-0.475-3.951-2.53-7.691-4.162-10.274-1.634-2.581-3.32-6.638-4.058-8.799-0.737-2.161-1.232-5.119-1.232-6.667,0-1.55,0.661-2.347,0.661-2.347s0.287-0.42,0.022-0.686c-0.265-0.265-0.683-0.021-1.103,0.398s-0.86,1.194-1.037,1.747c-0.177,0.555-0.177,0.753-0.177,0.753s-0.838-0.198-2.184-0.087c-1.346,0.109-1.985,0.221-2.03,0.508-0.044,0.288,0.177,0.51,1.147,0.93,0.971,0.42,1.589,0.597,2.074,1.173,0.486,0.575,1.727,3.465,2.106,4.86,0.379,1.396,1.19,5.18,1.519,8.15s1.331,6.568,2.732,9.573c0.46,0.99,2.97,5.67,5.09,4.73z'/%3E%3Cpath fill='%23D4AF3A' d='M250.52,207.21c-0.915,0.511-0.881,4.25-0.475,6.188,0.407,1.939,2.305,4.353,2.881,4.999,0.577,0.646,0.712,0.646,1.018,0.476,0.306-0.169,0.44-0.169,0.44-0.169s0.814-0.272,1.425-0.748c0.609-0.477,0.372-1.667,0.27-2.721-0.102-1.056-0.915-3.164-2.406-5.61-1.48-2.45-2.23-2.93-3.14-2.42z'/%3E%3Cpath fill='%23D4AF3A' d='M251.53,204.18c0-1.22-1.058-2.142-2.274-2.142-0.575,0-1.082,0.145-1.396,0.428-1.234,1.113-0.49,3.891,1.293,3.891,0.646,0,1.401-0.108,1.868-0.555,0.42-0.39,0.51-1.04,0.51-1.62z'/%3E%3Cpath fill='%23D4AF3A' d='M269.21,239.32c-0.487-0.086-0.774-0.285-1.492-0.773-0.717-0.487-1.865-1.492-2.066-1.98-0.202-0.488-0.202-0.517-0.89-0.286-0.689,0.229-1.665,0.2-2.41,0.229-0.746,0.029,0.085,0.86,0.602,1.637,0.517,0.774,0.344,3.385,0.344,3.385s0,0.23-0.115,0.604c-0.115,0.372-0.028,0.631,0.172,0.717,0.201,0.086,0.315-0.086,0.832-0.69,0.517-0.602,1.464-2.179,1.464-2.179s0.144,0.027,0.947,0.229,2.095,0.086,2.755-0.115c0.68-0.2,0.36-0.69-0.13-0.78z'/%3E%3Cpath fill='%23D4AF3A' d='M266.14,241.34c-0.344-0.058-0.487-0.087-0.66,0.141-0.171,0.231-0.315,0.663-0.401,0.891-0.086,0.23-0.058,0.432,0.144,0.604,0.201,0.173,0.488,0.373,0.488,0.373s0.287,0.316,0.575,0.458c0.287,0.145,0.343-0.285,0.343-0.602,0-0.315,0.172-0.89,0.172-1.263s-0.3-0.55-0.65-0.6z'/%3E%3Cpath fill='%231D5E91' d='M396.62,216.11c-0.839-0.199-1.195-0.518-1.195-0.518s-0.359-0.04-0.641,0.479c-0.276,0.517-1.354,1.195-1.354,1.195s-1.515,0.4-1.715,1.438c-0.199,1.036,0.519,1.395,1.236,1.275,0.72-0.12,2.474-0.479,3.229-1.395,0.758-0.918,0.878-1.437,1.037-1.797,0.14-0.35,0.23-0.47-0.61-0.67z'/%3E%3Cpath fill='%231D5E91' d='M398.97,207.85c-0.545-2.306-2.034-5.155-4.905-6.582,0,0-1.077,3.79-1.396,4.987-0.32,1.195-0.32,1.156,0.598,1.396,0.916,0.238,3.867,0.876,4.466,1.036s1.6,0.67,1.24-0.85z'/%3E%3Cpath fill='%231D5E91' d='M385.29,205.7c0.677,0.12,0.598-0.16,0.837-1.077,0.239-0.916,1.435-5.463,1.435-5.463s-3.029-0.12-5.662,1.155c-2.633,1.276-3.789,3.629-3.789,3.629s0.679,0.279,2.474,0.679c1.8,0.39,4.03,0.95,4.71,1.07z'/%3E%3Cpath fill='%231D5E91' d='M378.27,211.96c-1.075-0.199-1.475-0.319-1.475-0.319s0.678,2.591,1.795,4.028c1.116,1.436,2.353,2.155,4.666,2.194,2.313,0.04,4.067-1.236,4.347-2.233,0.279-0.998,0.758-1.754,0.758-1.754s-4.188-0.561-5.903-0.959c-1.74-0.4-3.13-0.76-4.21-0.96z'/%3E%3Cpath fill='%23D4AF3A' d='M377.55,210.32c1.038,0.239,9.572,1.874,10.29,2.034,0.719,0.158,1.316,0.318,1.516,0.118,0.201-0.198,0.319-0.318,1.077-0.599,0.758-0.277,0.719-1.036,0.719-1.036s0.199-0.719,0.277-1.436c0.081-0.717,0.48-0.957,1.317-0.079,0.838,0.876,0.997,2.152,1.156,3.39,0.16,1.236,2.115,1.555,2.871,1.675,0.759,0.12,1.116-0.12,1.556-0.837,0.439-0.718,0.679-2.154,0.798-3.072,0.119-0.916,0.041-0.837-0.917-1.076-0.957-0.238-5.384-1.235-6.183-1.437-0.796-0.199-0.637-0.717-0.518-1.275s1.874-6.183,1.874-6.183c-1.249-0.772-3.004-1.232-5.104-1.475,0,0-1.276,5.742-1.517,6.621-0.238,0.876-0.798,0.876-1.714,0.716-0.918-0.158-7.539-1.712-7.539-1.712s0,0-0.517,1.234c-0.519,1.236-0.758,2.713-0.758,3.47s0.27,0.74,1.3,0.97z'/%3E%3Cpath fill='%23D4AF3A' d='M400.2,215.51c-0.88-0.575-1.527-0.727-1.985,0.344-0.459,1.071-0.496,2.64-1.642,3.748-1.146,1.109-2.75,2.256-4.354,2.142-1.603-0.115-2.52-0.498-2.139-2.333,0.383-1.835,2.827-2.409,3.399-3.365s0.42-2.065-0.421-2.791c-0.84-0.728-2.062-0.88-2.405-0.65-0.343,0.229-1.337,1.071-1.832,2.446-0.497,1.377-0.802,2.486-1.872,3.366-1.067,0.879-3.817,1.759-5.955,1.261-2.138-0.497-2.901-1.147-3.704-3.25-0.802-2.103-1.756-5.582-2.177-5.965-0.419-0.382-0.954-0.688-1.87-0.039-0.917,0.649-0.993,1.606-1.107,2.372-0.115,0.764,0,1.646,0.915,2.754,0.917,1.108,1.872,2.217,2.216,3.363,0.344,1.147,1.374,2.907-0.077,2.983-1.45,0.076-2.099,0.114-3.207-0.955-1.107-1.071-5.423-4.016-6.605-4.973-1.184-0.956-1.68-1.261-1.68-1.261-1.997-0.035-3.997-0.856-5.994-2.217,0,0,1.146,2.943,1.374,4.052,0.229,1.109,0.191,1.72,0.191,1.72s4.352,2.218,6.071,3.06c1.718,0.841,5.192,2.83,6.871,3.861,1.682,1.034,3.094,2.64,6.072,2.028,2.979-0.612,9.01-2.447,10.957-3.021,1.948-0.574,7.332-1.912,9.317-3.288s2.177-1.3,2.519-2.677c0.34-1.35,0-2.11-0.88-2.69z'/%3E%3Cpath fill='%23D4AF3A' d='M388.71,194.92c0.331-0.044,0.464-0.089,1.479-0.221,1.017-0.134,0.64,0.84,0.463,1.216-0.176,0.375-0.485,1.127-0.903,1.834-0.422,0.71,0.131,0.82,0.418,0.93,0.287,0.112,0.706,0.155,1.523,0.377,0.818,0.22,0.662-0.377,0.685-0.686,0.022-0.311,0.065-1.925,0.155-2.499,0.088-0.574,0.617-0.42,0.816-0.31s0.706,0.396,1.127,0.617c0.418,0.224,0.617-0.021,0.706-0.264s0.286-0.685,0.464-1.327c0.177-0.641-0.221-0.509-0.62-0.509-0.396,0-0.971,0-1.633-0.021-0.662-0.022-0.243-0.664-0.243-0.664s0.486-0.795,0.861-1.393c0.376-0.597,0.244-0.685-0.133-0.797-0.374-0.111-1.545-0.376-1.876-0.464-0.331-0.087-0.485-0.044-0.485,0.178s-0.045,1.37-0.045,1.813c0,0.441-0.043,0.707-0.618,0.729-0.574,0.021-0.928-0.312-1.391-0.819-0.464-0.507-0.662-0.309-0.707-0.109-0.044,0.199-0.42,1.658-0.508,2.056-0.11,0.39,0.11,0.37,0.44,0.32z'/%3E%3Cpath fill='%23D4AF3A' d='M391.91,209.41s-0.041,1.157-0.16,1.555c-0.12,0.4-0.398,0.998,0.08,1.157,0.479,0.16,0.917,0.358,1.194,0.279,0.281-0.079,0.16-0.638,0-1.116-0.158-0.479-0.397-1.078-0.757-1.476-0.35-0.39-0.35-0.39-0.35-0.39z'/%3E%3Cpath fill='%23D4AF3A' d='M398.93,214.03c0.16,0.358,0.479,0.438,0.719,0.519,0.239,0.079,0.559,0.079,0.559-0.359s0.079-0.997-0.278-1.476c-0.359-0.479-0.55-0.828-0.758-0.12-0.21,0.72-0.4,1.09-0.24,1.44z'/%3E%3Cpath fill='%23D4AF3A' d='M374.48,209.37c0.199,0.04,0.957,0.279,0.957,0.279s0-1.117,0.159-1.875c0.159-0.756,0.479-1.275,0.2-1.275s-0.438,0.239-0.64,0.558c-0.198,0.318-0.758,0.399-0.956,1.316-0.2,0.91,0.08,0.95,0.28,0.99z'/%3E%3Ccircle cy='207.45' cx='379.27' r='1.556' fill='%23B96B29'/%3E%3Ccircle cy='208.53' cx='383.65' r='1.595' fill='%23B96B29'/%3E%3Ccircle cy='211.24' cx='396.42' r='1.596' fill='%23B96B29'/%3E%3Ccircle cy='209.57' cx='388.04' r='1.596' fill='%23B96B29'/%3E%3Ccircle cy='205.74' cx='389.2' r='1.596' fill='%23B96B29'/%3E%3Ccircle cy='201.91' cx='390.32' r='1.596' fill='%23B96B29'/%3E%3Ccircle cy='207.3' cx='379.38' r='0.777' fill='%23D4AF3A'/%3E%3Ccircle cy='208.37' cx='383.77' r='0.798' fill='%23D4AF3A'/%3E%3Ccircle cy='211.08' cx='396.54' r='0.797' fill='%23D4AF3A'/%3E%3Ccircle cy='209.41' cx='388.16' r='0.797' fill='%23D4AF3A'/%3E%3Ccircle cy='205.58' cx='389.32' r='0.797' fill='%23D4AF3A'/%3E%3Ccircle cy='201.75' cx='390.44' r='0.798' fill='%23D4AF3A'/%3E%3C/g%3E%3Cuse xlink:href='%23g4017' transform='matrix(-1,0,0,1,639.96566,0)' height='320' width='640' y='0' x='0'/%3E%3C/g%3E%3C/svg%3E"

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23007E3A' width='900' height='600'/%3E %3Crect fill='%23FC3D32' width='900' height='300'/%3E %3Crect fill='%23FFF' width='300' height='600'/%3E %3C/svg%3E"

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='570' height='300'%3E %3Ctitle%3EFlag of the Marshall Islands%3C/title%3E %3Crect height='300' width='570' fill='%23003893'/%3E %3Cpath d='M0,295.2V288L570,35V122.4z' fill='%23fff'/%3E %3Cpath d='M0,290.4V285.6L570,4.8V63.6z' fill='%23dd7500'/%3E %3Cg fill='%23fff' transform='translate(109.536,109.536)'%3E %3Cg id='r6'%3E %3Cpath d='M0,-93 5.59,0H-5.59z'/%3E %3Cpath id='r1' d='M0,-66.588 6.824,0H-6.824z' transform='rotate(15)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(15)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(30)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(45)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(60)'/%3E %3C/g%3E %3Cuse xlink:href='%23r6' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r6' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r6' transform='rotate(270)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1400' height='700' viewBox='0 0 56 28'%3E %3Crect width='56' height='28' fill='%23d20000'/%3E %3Cg fill='%23ffe600'%3E %3Cpath d='M 0,0 8.4,0 28,13.5 47.6,0 56,0 0,28 8.4,28 28,14.5 47.6,28 56,28 z M 56,11.2 56,16.8 0,11.2 0,11.2 0,16.8 z M 25.2,0 28,12 30.8,0 z M 25.2,28 28,16 30.8,28 z'/%3E %3Ccircle cx='28' cy='14' r='4.5' stroke='%23d20000'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect fill='%23CE1126' width='450' height='300'/%3E %3Crect fill='%23FCD116' width='300' height='300'/%3E %3Crect fill='%2314B53A' width='150' height='300'/%3E %3C/svg%3E"

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1800' height='1200' viewBox='0 0 18 12'%3E %3Crect width='18' height='6' fill='%23FECB00'/%3E %3Crect width='18' height='6' y='6' fill='%23EA2839'/%3E %3Crect width='18' height='4' y='4' fill='%2334B233'/%3E %3Cg transform='translate(9,6.422)scale(4.422)'%3E %3Cpolygon id='pt' points='-0.3249196962329062,0 0,-1 0.3249196962329062,0' fill='%23FFF'/%3E %3Cuse xlink:href='%23pt' transform='rotate(-144)'/%3E%3Cuse xlink:href='%23pt' transform='rotate(-72)'/%3E%3Cuse xlink:href='%23pt' transform='rotate(72)'/%3E%3Cuse xlink:href='%23pt' transform='rotate(144)'/%3E%3C/g%3E %3C/svg%3E"

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='4800' height='2400'%3E %3Cg fill='%23f9cf02'%3E%3Cg transform='scale(5)'%3E%3Crect width='960' height='480' fill='%23c4272f'/%3E %3Crect x='320' width='320' height='480' fill='%23015197'/%3E%3Ccircle cx='160' cy='164' r='44'/%3E %3Ccircle cx='160' cy='144' r='48' fill='%23c4272f'/%3E%3Ccircle cx='160' cy='152' r='32'/%3E %3Cpath d='M140,92a20,20 0 0,0 40,0c0-8-5-9-5-12 0-3,3-7-3-12 3,5-2,6-2,11 0,5,2,5,2,9a4,4 0 0,1-8,0c0-4,4-8,4-14 0-6-1-8-4-13-3-5-8-9-4-13-6,2-3,10-3,15 0,5-4,8-4,14 0,6,3,7,3,11a4,4 0 0,1-8,0c0-4,2-4,2-9 0-5-5-6-2-11-6,5-3,9-3,12 0,3-5,4-5,12Z'/%3E %3Cpath d='M72,216V408H112V216ZM208,216V408H248V216ZM120,248V264H200V248ZM120,360V376H200V360ZM120,216H200L160,240ZM120,384H200L160,408Z'/%3E%3C/g%3E %3Cg stroke='%23c4272f' stroke-width='24'%3E%3Ccircle cx='800' cy='1560' r='212'/%3E %3Cpath fill='none' d='M800,1348A106,106 0 0,1 800,1560A106,106 0 0,0 800,1772'/%3E%3C/g%3E%3C/g%3E %3Cg fill='%23c4272f'%3E%3Ccircle cx='800' cy='1454' r='40'/%3E %3Ccircle cx='800' cy='1666' r='40'/%3E%3C/g%3E%3C/svg%3E"

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300' viewBox='0 0 660 440'%3E %3Crect fill='%2300785E' width='660' height='440'/%3E %3Cpolygon fill='%23FBD116' points='330 82.958 315.792 126.693 352.995 99.666 307.005 99.666 344.208 126.693 '/%3E %3Cg id='h'%3E %3Cpath fill='%23FFF' d='M330 303.99h-93.937c-1.184-1.2-2.35-2.423-3.488-3.667H330c0.751 0.269 1.267 0.958 1.306 1.736C331.348 302.903 330.818 303.694 330 303.99zM330 275.265c0.545-1.114 1.607-3.694 1.125-6.921 -0.218-1.463-0.692-2.644-1.125-3.492 -5.271 4.988-15.175 12.981-29.785 17.401 -6.821 2.064-14.055 3.173-21.548 3.173h-57.872c1.706 2.507 3.494 4.954 5.364 7.333h55.945C300.346 292.76 317.058 286.179 330 275.265zM229.539 252.628c-2.785 1.072-5.772 1.741-8.887 1.926 13.629 15.415 33.545 25.144 55.723 25.144 21.066 0 40.091-8.775 53.625-22.867 2.297-15.839 3.968-33.969 4.167-53.998 0.232-23.321-1.581-44.2-4.167-62.032 -6.045 5.419-17.371 17.128-22.71 35.079 -1.998 6.72-3.072 13.837-3.072 21.203 0 15.291 4.623 29.506 12.547 41.329 -9.731-12.57-15.526-28.338-15.526-45.454 0-11.369 2.558-22.144 7.126-31.783 -3.154-3.334-5.551-7.392-6.904-11.902 -6.121 10.804-9.618 23.284-9.618 36.581 0 16.539 5.409 31.819 14.552 44.172 -15.923-16.693-38.377-27.099-63.25-27.099 -1.336 0-2.667 0.034-3.989 0.093 2.503 2.333 4.604 5.089 6.188 8.157 24.742 0.038 47.078 10.377 62.964 26.949 -15.171-12.672-34.698-20.303-55.995-20.303 -11.902 0-23.25 2.382-33.594 6.696 10.629 28.085 37.78 48.075 69.574 48.075 2.059 0 4.1-0.093 6.116-0.258 -4.29 0.771-8.709 1.174-13.22 1.174C261.128 273.51 242.92 265.554 229.539 252.628zM330 334.01h-48.684c15.067 5.988 31.492 9.281 48.684 9.281 0.414-0.788 1.125-2.395 1.146-4.542C331.168 336.492 330.417 334.804 330 334.01zM330 311.552h-85.83c2.322 1.99 4.711 3.902 7.169 5.729H330c0.197-0.201 1.167-1.236 1.167-2.865S330.197 311.753 330 311.552zM330 323.01h-70.304c4.257 2.686 8.675 5.139 13.242 7.333H330c0.33-0.523 1.112-1.917 1.063-3.844C331.018 324.78 330.335 323.54 330 323.01z'/%3E %3Cpolygon fill='%23FBD116' points='237.639 150.67 224.197 179.509 252.019 164.076 220.444 160.202 243.712 181.901'/%3E %3Cpolygon fill='%23FBD116' points='260.663 112.27 269.966 142.699 280.328 112.607 254.26 130.861 286.079 131.413'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='matrix(-1,0,0,1,660,0)'/%3E %3C/svg%3E"

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='500'%3E %3Crect width='1000' height='500' fill='%230071bc'/%3E %3Cg%3E %3Cg fill='none' stroke='%23000' stroke-width='1.93488'%3E %3Cpath fill='%23fff' d='m557.8173,395.54368c0,0 17.63179,-18.64915 34.58541,-15.08878 5.08623,-19.66633 24.24388,-21.19218 24.24388,-21.19218 0,0 -1.86484,-21.70066 22.71782,-26.4477 0.67818,-14.74979 15.59747,-26.95637 15.59747,-26.95637 0,0 -3.05169,-22.88732 12.54577,-28.14305 -9.49408,-18.14048 3.22119,-31.36461 3.05169,-31.7036 -0.1695,-0.33899 -16.10595,-28.65192 -1.86503,-36.78945 -15.08878,-12.71528 -10.17206,-27.12593 -10.17206,-27.12593 0,0 -16.44513,-4.23859 -10.51143,-23.9048 -13.56294,-2.37343 -16.27545,-24.24373 -16.27545,-24.24373 0,0 -20.85318,4.23831 -23.39619,-13.90209 -13.73244,2.20413 -15.25829,-11.35889 -15.42778,-11.35889 -0.1695,0 -27.29557,7.29005 -32.72077,-13.22393 -10.51106,5.42533 -15.08879,-4.238455 -15.08879,-4.238455 0,0 -15.08879,7.459663 -24.07418,-6.950964 -17.9708,11.189419 -27.97355,-0.508699 -27.97355,-0.508699 0,0 -23.56569,15.597348 -31.36442,3.560296 -13.90213,14.071702 -26.27819,7.968364 -26.27819,7.968364 0,0 -10.51132,18.648948 -27.46502,13.901928 -3.89937,17.29277 -23.3961,17.63186 -23.3961,17.63186 0,0 2.03443,15.25841 -21.36167,19.32726 -3.05166,17.97078 -15.25832,21.02252 -15.25832,21.02252 0,0 1.18674,17.46223 -9.83316,23.05701 3.89936,9.83336 -6.27287,21.87026 -6.27287,21.87026 0,0 10.85037,13.56293 -3.89935,28.82141 14.24112,3.72968 3.89935,28.31272 3.89935,28.31272 0,0 19.66631,8.81591 7.29011,25.09135 14.07156,4.57755 9.66359,15.76715 9.83315,22.37904 8.98545,4.06866 16.9537,2.03432 13.05435,20.1748 27.6345,3.0517 14.58016,18.30999 14.58016,18.30999 0,0 12.88483,0.50867 7.79872,10.68093 23.56565,-0.5085 26.95637,17.63179 26.95637,17.63179 0,0 21.87032,-5.7644 24.7524,2.71251 2.88214,8.47692 -9.49405,65.61086 -9.49405,65.61086 0,0 -18.47953,0 -32.21204,-14.7496 -32.21203,-0.84767 -25.09149,-22.04004 -25.60009,-22.04004 -0.5086,0 -10.68084,3.89937 -15.93648,-13.73243 -21.5312,4.40805 -20.85307,-13.73224 -21.0226,-13.90193 -0.16953,-0.1695 -9.66358,-4.40804 -6.10333,-13.39345 -22.20934,2.03415 -20.51398,-19.66632 -20.51398,-19.66632 -4.86006,-1.97802 -6.66845,-6.49888 -5.93379,-11.01992 -2.88212,-1.01736 -22.54842,-1.35635 -12.3762,-27.29537 -18.81862,-11.35911 -7.12056,-24.41336 -7.12056,-24.41336 0,0 -25.93915,-13.39344 -5.9338,-28.82141 -14.91924,-22.03986 1.18676,-33.05959 1.18676,-33.05959 0,0 -20.68351,-21.02267 0.33909,-35.94194 -3.39074,-31.87287 15.59741,-39.50199 15.59741,-39.50199 0,0 -10.00268,-25.93931 17.12324,-36.78964 1.69536,-26.278245 20.68351,-26.956402 20.68351,-26.956402 0,0 0.5086,-20.853066 30.34712,-18.818577 5.76424,-18.648947 26.10869,-14.919173 26.10869,-14.919173 0,0 6.27289,-22.548468 33.90742,-11.698137 14.07148,-27.464941 34.9247,-13.393384 34.9247,-13.393384 0,0 13.22375,-8.646532 19.83582,-5.933874 8.39584,-14.428497 26.26988,-0.559337 37.82654,2.23289 4.18844,-1.628821 19.13791,-12.913767 30.66633,1.327406 15.25847,-10.002714 28.31272,7.968209 28.31272,7.968209 0,0 21.02249,-10.680583 30.85575,13.732627 44.58818,-4.068997 38.1458,25.091366 38.1458,25.091366 0,0 35.0941,-7.968209 27.46506,26.956399 31.87291,2.20396 28.65172,23.22664 28.65172,23.22664 0,0 20.17481,15.25811 11.35892,28.99074 17.97098,0.84778 11.35891,18.14056 11.35891,18.14056 0,0 13.73263,5.25569 2.37351,26.61721 26.27821,21.02248 5.08623,41.87586 4.91673,41.70616 -0.16969,-0.16949 14.07162,16.95363 1.18666,36.61996 3.89938,31.19493 -11.86759,39.16296 -11.86759,39.16296 0,0 4.06887,20.17501 -13.56294,25.93922 -0.33899,23.73519 -22.71802,26.61738 -22.71802,26.61738 0,0 5.93389,10.31001 -16.27544,21.16045 -0.87593,15.88188 -24.07437,17.15485 -24.07437,17.15485 0,0 -2.20384,29.1602 -31.70343,21.36167 -7.15963,23.39658 -41.70597,16.44513 -42.38415,16.10614 -0.67817,-0.33918 -6.61187,-50.18288 -6.61187,-50.35258 z'/%3E %3Cpath d='m599.01,420.07s-2.6164,5.0315,7.8492,9.4592'/%3E %3Cpath d='m619.94,408.19s11.673-2.8176,19.522,0'/%3E %3Cpath d='m654.76,378.81c0,0.20143-1.61,5.2329,7.648,12.478'/%3E %3Cpath d='m661.4,365.73s6.8427,5.0315,18.315,4.8302'/%3E %3Cpath d='m592.37,380.42s0.40246,13.283-6.4402,19.522'/%3E %3Cpath d='m615.31,359.89s11.27,2.8176,20.529-1.8112'/%3E %3Cpath d='m687.56,340.37s2.4151,3.4214,14.893,2.8178'/%3E %3Cpath d='m638.86,332.52c0.40246,0.20122,14.692,4.8302,23.749,0.60388'/%3E %3Cpath d='m667.43,277.77s0.60368-0.8051,5.0315,14.692'/%3E %3Cpath d='m678.5,234.1s-0.60388,8.2515-7.2454,11.874'/%3E %3Cpath d='m720.97,200.29s-9.6605,7.849-7.849,11.069'/%3E %3Cpath d='m672.87,194.65s5.0315,8.4528-3.22,14.289'/%3E %3Cpath d='m648.52,158.43s8.6542-0.4027,12.478,7.044'/%3E %3Cpath d='m666.63,103.69c0,0.20119,1.8112,1.8112-1.61,5.2327'/%3E %3Cpath d='m604.84,104.49s4.629,7.2453,3.8239,16.101'/%3E %3Cpath d='m631.61,79.937c2.0125-0.20119,8.8554-3.2202,8.8554-3.2202'/%3E %3Cpath d='m601.82,51.157c-0.20124,0-2.6164,9.0566,1.8114,12.277'/%3E %3Cpath d='m590.75,92.415c0,9.6605,7.648,7.2452,2.4153,16.503'/%3E %3Cpath d='m572.04,84.365c-0.20123,0-12.075,9.258-12.075,10.868'/%3E %3Cpath d='m541.04,79.333s5.0315,5.0313,3.8239,11.874'/%3E %3Cpath d='m499.58,73.295c-0.20123,0.40257-4.2266,9.0566-7.0441,10.667'/%3E %3Cpath d='m462.96,73.497c0.20122,0,4.0251,8.0504-1.0063,13.887'/%3E %3Cpath d='m397.75,106.91c0.20126,0.40242,10.264,2.0125,10.264,2.0125'/%3E %3Cpath d='m372.59,130.25c0.20126-0.20136,12.277-3.8239,12.277-3.8239'/%3E %3Cpath d='m353.07,145.35c0.40253,0,8.4529,1.4089,10.465,0.40255'/%3E %3Cpath d='m347.43,152.79s2.6164,1.4089,0.40252,14.893'/%3E %3Cpath d='m308.19,117.37,4.8302,7.2453'/%3E %3Cpath d='m291.68,154.6c0-0.20134,4.8302,7.2452,11.271,8.6541'/%3E %3Cpath d='m329.72,192.44c0.20127,0,7.8491-1.6102,9.0567-2.4152'/%3E %3Cpath d='m326.3,219.81c0.20127,0-0.20125-5.0315,6.0378-8.4529'/%3E %3Cpath d='m318.05,232.29c0,0.20124,5.8365,7.4466,9.8617,8.4529'/%3E %3Cpath d='m314.63,246.18c0.60377-0.20143,6.8428-5.6356,14.088-5.2329'/%3E %3Cpath d='m312.61,264.89s0.20125,6.2392,18.717,4.6292'/%3E %3Cpath d='m314.43,286.83c0-0.20122,5.434-12.478,16.503-17.107'/%3E %3Cpath d='m329.32,302.53s1.6101-5.2329,10.868-8.8554'/%3E %3Cpath d='m339.58,323.26s6.6416-5.4339,9.0567-6.2388'/%3E %3Cpath d='m347.84,339.36s4.0252,4.2264,14.088-3.019'/%3E %3Cpath d='m299.33,342.78c1.2076-0.20123,15.899-3.6225,20.931,4.0253'/%3E %3Cpath d='m305.17,354.86s15.497-2.0127,17.51-0.40246'/%3E %3Cpath d='m360.51,358.08s-2.0126,4.2266,17.107-2.8176'/%3E %3Cpath d='m384.26,365.73c-3.4214,5.8364,0.80503,10.465-3.6227,13.082'/%3E %3Cpath d='m326.1,373.78c0.60378-0.40226,7.0441-2.6162,6.0378-11.874'/%3E %3Cpath d='m331.94,387.66c0.80505-0.20122,11.472-4.8302,13.686-2.4151'/%3E %3Cpath d='m352.87,401.15s1.4088-9.4592,4.4277-10.465'/%3E %3Cpath d='m368.97,415.44s8.8554-0.20122,12.679-3.0188'/%3E %3Cpath d='m386.07,383.44c0.20127,0.20123,8.2517,4.4276,25.359,0.20123'/%3E %3Cpath d='m392.51,421.88s2.4151,12.277,2.2139,15.094'/%3E %3Cpath d='m632.21,133.87,6.6417-0.00015'/%3E %3Cpath d='m526.35,75.308s-2.6163,7.6477-6.0376,9.6604'/%3E %3Cpath d='m454.5,31.836c0.20122,0.20119,0.80511,6.2389-3.0188,11.472'/%3E %3Cpath d='m418.28,45.522c0,0.20134,1.6101,6.8431-9.0566,9.0568'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%23f7df73' stroke='%23000' stroke-linejoin='round' fill-rule='evenodd'%3E %3Cpath d='m561.72,423.68s100.53-28.397,130.89-151.78c-17.626,126.65-127.63,166.79-127.63,166.79l-3.264-15.015z' stroke-width='2.4186'/%3E %3Cpath d='m429.95,421.01s-99.612-28.908-129.69-154.51c17.464,128.92,126.46,169.79,126.46,169.79l3.234-15.285z' stroke-width='2.429'/%3E %3C/g%3E %3Cg fill='%238c1800'%3E %3Cpath d='m572.03,431.37c3.1074,0,10.794-8.5048,15.21-9.486,4.416-0.98118,4.9065-5.3974-0.1635-5.5607-5.07-0.1635-9.4858,5.7242-9.4858,5.7242s-4.416,3.7618-8.9953,4.2525c-4.5795,0.49068-1.6356,6.2146,3.4344,5.07z'/%3E %3Cpath d='m593.45,415.67s-3.1076-1.1449,4.9065-4.2523c8.0139-3.1074,7.5232-6.7055,10.14-8.1776,2.6167-1.4719,8.1774-5.3972,9.3223-3.1074,1.1449,2.2897-5.8878,6.8692-7.5232,7.3599-1.6356,0.49069-9.6496,7.8504-11.939,8.5046-2.2897,0.65418-3.9253,0.32719-4.9065-0.32719z'/%3E %3Cpath d='m419.74,428.84c-3.079,0-10.695-8.6576-15.071-9.6565-4.3755-0.99882-4.8615-5.4944,0.162-5.6606,5.0235-0.16644,9.3988,5.827,9.3988,5.827s4.3755,3.8294,8.9128,4.3289c4.5375,0.49951,1.6206,6.3264-3.4029,5.1611z'/%3E %3Cpath d='m398.51,412.86s3.0791-1.1654-4.8615-4.3287c-7.9405-3.1633-7.4543-6.8261-10.047-8.3246-2.5928-1.4983-8.1024-5.4942-9.2368-3.1633s5.8339,6.9927,7.4543,7.4922c1.6206,0.4995,9.5612,7.9915,11.83,8.6574,2.2688,0.66595,3.8893,0.33307,4.8615-0.33307z'/%3E %3Cpath stroke='%238c1800' stroke-width='2.4186' d='m629.92,388.19s-10.467,6.0511-8.9953,7.5232c1.4721,1.4721,10.794-5.7242,10.958-5.8876,0.1635-0.16369,3.9253-4.743-1.9626-1.6356z'/%3E %3Cpath stroke='%238c1800' stroke-width='2.429' d='m362.37,384.89s10.371,6.1599,8.9128,7.6584c-1.4586,1.4985-10.695-5.827-10.857-5.9935-0.162-0.16663-3.8893-4.8282,1.9446-1.665z'/%3E %3C/g%3E %3Cg fill='none' stroke='%238c1800' stroke-linecap='round'%3E %3Cpath stroke-width='3.14418' d='m645.46,372.82c-6.869,7.6869-6.869,7.5234-6.869,7.5234'/%3E %3Cpath stroke-width='2.90232' d='m655.76,360.23-6.542,8.0141'/%3E %3Cpath stroke-width='2.66046' d='m666.07,343.87-7.3599,11.776'/%3E %3Cpath stroke-width='2.4186' d='m674.74,327.19-6.0513,12.103'/%3E %3Cpath stroke-width='2.4186' d='m678.66,318.36-1.9626,4.2523'/%3E %3Cpath stroke-width='1.45116' d='m683.08,306.75-1.6356,5.07'/%3E %3Cpath stroke-width='3.15775' d='m346.98,369.24c6.8061,7.8251,6.8061,7.6586,6.8061,7.6586'/%3E %3Cpath stroke-width='2.914845' d='m336.77,356.42,6.4821,8.1582'/%3E %3Cpath stroke-width='2.67194' d='m326.56,339.77,7.2925,11.987'/%3E %3Cpath stroke-width='2.429' d='m317.97,322.79,5.9959,12.32'/%3E %3Cpath stroke-width='2.429' d='m314.08,313.8,1.9446,4.3287'/%3E %3Cpath stroke-width='1.4574' d='m309.71,301.98,1.6206,5.1611'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='%23217900' stroke='%23000' stroke-width='1.93488133' stroke-linejoin='round'%3E %3Cpath d='m343.56,115.74c0.0863,0,7.4767,6.4097,6.0965,16.07-1.38,9.6605-6.9591,23.09-5.8378,33.095,0.68549,4.011,0.42592,11.198,0.42592,11.198s-6.6997-9.5198-6.786-19.698,7.2549-19.842,7.2549-27.346c0-7.5041-1.3261-13.492-1.1535-13.319z'/%3E %3Cpath d='m339.9,118.62s-9.6981,9.258-10.947,18.255c-0.92216,4.6376-1.2801,26.247-1.3891,35.839-0.21797,2.9426-1.4376,14.558-1.6965,18.785-0.25868,4.2264,7.1339-7.2146,7.5566-16.53-0.23134-9.6425-0.23191-29.953,0.74897-33.005,0.87192-3.9237,0.68199-8.2587,2.0308-12.194,1.7845-5.4608,3.7826-11.064,3.6963-11.15z'/%3E %3C/g%3E %3Cg fill='none' stroke='%236b18b5' stroke-linejoin='round'%3E %3Cpath stroke-width='1.9349' d='m276.41,180.31s6.574,9.1024,7.7539,14.328c1.18,5.2254,3.3713,15.508,6.2368,19.722,2.8656,4.214,19.216,27.644,20.059,37.421,0.16855,6.4052-6.7425,17.362-17.025,17.53-6.4054-0.16833-22.924-4.3823-23.599-18.542-0.67426-14.159,5.0569-14.497,5.7311-23.093,0.67425-8.5967,0.84282-47.197,0.84282-47.366z'/%3E %3Cpath d='m389.35,56.361s-6.8061,0.48536-12.046,3.326c-4.0599,2.5035-10.937,6.1054-15.743,12.769-12.223,9.5289-30.612,13.975-36.412,21.891-3.4716,5.3855-3.2583,18.338,5.4402,23.823,5.5606,3.1839,21.865,8.1648,29.797-3.5835,7.9319-11.748,3.21-15.014,7.0999-22.71,6.4183-17.641,21.776-35.372,21.864-35.517z'/%3E %3Cpath d='m554.44,39.166s-5.0831-4.5518-10.769-6.3401c-4.6226-1.1752-12.322-0.66401-20.288-1.4458-15.348-2.1526-31.171-13.253-40.892-11.912-6.2839,1.2523-15.441,10.416-13.331,20.481,1.5808,6.2095,8.5255,18.768,22.483,16.294,13.958-2.4741,13.837-5.5188,22.072-8.0777,20.085-11.262,40.56-8.9616,40.724-8.9991z'/%3E %3Cpath d='m718.18,198.3c1.1458-2.6191-0.96454-7.5419-2.4637-13.311-1.4552-4.5424-3.6275-11.592-8.9417-17.858-6.3145-14.154-5.2323-33.564-11.524-41.094-4.3941-4.6633-17.019-7.5668-24.433-0.44034-4.4262,4.6333-13.177,19.264-3.6774,29.785,9.4995,10.521,13.64,6.558,20.176,12.182,15.583,10.467,23.215,28.816,30.863,30.736z'/%3E %3Cpath d='m712.59,321.94c2.128-2.9464,5.9383-8.6249,5.4852-13.354-0.35873-3.7457,1.7166-15.101,1.9434-20.055,1.4084-15.434,11.069-27.962,8.4423-41.372-1.5543-6.216-10.658-15.083-20.61-12.489-6.126,1.879-19.765,9.3842-16.62,23.206,3.1459,13.822,7.6118,13.593,10.566,21.694,8.4798,16.748,3.054,36.642,10.793,42.37z'/%3E %3C/g%3E %3Cg fill='%236b18b5'%3E %3Cpath d='m491.8,26.96c0.00082-2.1778-2.449-3.9435-5.4712-3.9435s-5.472,1.7657-5.4712,3.9435c-0.00082,2.1778,2.449,3.9435,5.4712,3.9435s5.472-1.7657,5.4712-3.9435z'/%3E %3Cpath d='m494.14,36.133c0-2.0885-2.5216-3.7816-5.6321-3.7816s-5.6321,1.6931-5.6321,3.7816,2.5216,3.7816,5.6321,3.7816,5.6321-1.6931,5.6321-3.7816z'/%3E %3Cpath d='m501.14,25.271s-6.4368,4.8276-3.7815,6.7586c2.655,1.931,9.9768-4.1838,9.9768-4.1838l-6.1953-2.5748z'/%3E %3Cpath d='m690.31,135.8c0.002-1.3724-0.6414-2.6413-1.687-3.3281-1.0455-0.68677-2.3342-0.68677-3.3798,0-1.0456,0.68678-1.6888,1.9558-1.687,3.3281-0.002,1.3723,0.6414,2.6413,1.687,3.3281,1.0456,0.68677,2.3342,0.68677,3.3798,0s1.6888-1.9558,1.687-3.3281z'/%3E %3Cpath d='m687.86,126.59c0-2.2888-1.5806-4.1443-3.5303-4.1443-1.9498,0-3.5303,1.8554-3.5303,4.1443,0,2.2888,1.5806,4.1443,3.5303,4.1443s3.5303-1.8555,3.5303-4.1443z'/%3E %3Cpath d='m689.55,145.32c0-1.1868-0.61848-2.1489-1.3814-2.1489-0.76294,0-1.3814,0.9621-1.3814,2.1489s0.61849,2.1489,1.3814,2.1489c0.76295,0,1.3814-0.96211,1.3814-2.1489z'/%3E %3Cpath d='m695.23,128.59c0-1.3564-0.61849-2.456-1.3814-2.456-0.76295,0-1.3814,1.0996-1.3814,2.456s0.61848,2.456,1.3814,2.456c0.76294,0,1.3814-1.0996,1.3814-2.456z'/%3E %3Cpath d='m679.72,130.28c0-1.102-0.61849-1.9954-1.3814-1.9954-0.76295,0-1.3814,0.89336-1.3814,1.9954s0.61848,1.9954,1.3814,1.9954c0.76294,0,1.3814-0.89335,1.3814-1.9954z'/%3E %3Cpath d='m682.18,143.48c0.00057-1.7807-1.3053-3.2246-2.9163-3.2246-1.6111,0-2.9169,1.4439-2.9163,3.2246-0.00058,1.7807,1.3053,3.2246,2.9163,3.2246,1.6111,0,2.9169-1.4439,2.9163-3.2246z'/%3E %3Cpath d='m674.5,137.64c0-1.5259-1.0995-2.7628-2.4559-2.7628-1.3563,0-2.4559,1.237-2.4559,2.7628,0,1.5259,1.0995,2.7628,2.4559,2.7628s2.4559-1.237,2.4559-2.7628z'/%3E %3Cpath d='m673.28,129.82c0.001-0.82331-0.40833-1.5846-1.0736-1.9965-0.6653-0.41197-1.4853-0.41197-2.1506,0-0.66529,0.41198-1.0746,1.1732-1.0736,1.9965-0.001,0.82331,0.40831,1.5846,1.0736,1.9965,0.66531,0.41198,1.4853,0.41198,2.1506,0,0.66529-0.41197,1.0746-1.1732,1.0736-1.9965z'/%3E %3Cpath d='m708.27,169.62c-3.1705-4.1843-8.2462-5.9474-11.337-3.9381-3.0907,2.0094-3.0261,7.0303,0.14438,11.215,3.1705,4.1843,8.2462,5.9474,11.337,3.9381,3.0907-2.0094,3.0261-7.0303-0.1444-11.215z'/%3E %3Cpath d='m717.28,246.81c0.61438-5.1345-1.8899-9.656-5.5934-10.099-3.7035-0.44315-7.2039,3.3599-7.8183,8.4944-0.61437,5.1345,1.8899,9.656,5.5934,10.099,3.7036,0.44316,7.2039-3.3599,7.8183-8.4944z'/%3E %3Cpath d='m719.18,291.75c1.0554-5.0622-1.049-9.7831-4.7005-10.544-3.6514-0.76131-7.4671,2.7253-8.5226,7.7875-1.0554,5.0622,1.049,9.7832,4.7004,10.544,3.6514,0.76132,7.4672-2.7253,8.5226-7.7875z'/%3E %3Cpath d='m727.84,249.69c0-2.0345-1.3744-3.6838-3.0699-3.6838-1.6954,0-3.0699,1.6493-3.0699,3.6838s1.3744,3.6839,3.0699,3.6839c1.6954,0,3.0699-1.6493,3.0699-3.6839z'/%3E %3Cpath d='m720.32,258.13-6.2932,7.1374s-5.9093,0.15343-5.6024,2.0721c0.30705,1.9186,8.1352,7.6747,8.0584,9.977-0.0768,2.3025,5.2188-0.53712,5.2188-0.53712s4.2209-12.817,4.2209-12.893c0-0.0768-0.23025-8.9028-2.5326-8.7491-2.3025,0.15343-2.9263,2.8303-3.0699,2.9933z'/%3E %3Cpath d='m306.38,255.31c0-1.6541-1.341-2.9951-2.9951-2.9951-1.6542,0-2.9952,1.3409-2.9952,2.9951,0,1.6541,1.341,2.9951,2.9952,2.9951s2.9951-1.3409,2.9951-2.9951z'/%3E %3Cpath d='m309.21,246.16c0-1.7461-1.341-3.1616-2.9951-3.1616-1.6542,0-2.9951,1.4155-2.9951,3.1616s1.341,3.1616,2.9951,3.1616c1.6542,0,2.9951-1.4155,2.9951-3.1616z'/%3E %3Cpath d='m284.61,202.63c-1.1233-2.5177-3.4627-3.9213-5.2251-3.135-1.7624,0.78632-2.2805,3.4648-1.1572,5.9825s3.4627,3.9213,5.2251,3.135c1.7624-0.78632,2.2805-3.4648,1.1572-5.9825z'/%3E %3Cpath d='m292.04,229.75c-1.5431-3.2632-4.7567-5.0823-7.1777-4.0632s-3.1327,4.4906-1.5896,7.7538,4.7567,5.0823,7.1777,4.0632,3.1327-4.4906,1.5896-7.7538z'/%3E %3Cpath d='m299.99,249.63c0.49995-4.0758-1.1889-7.8199-3.7722-8.3627-2.5833-0.54278-5.0828,2.3213-5.5827,6.3971-0.49995,4.0758,1.1889,7.8199,3.7722,8.3627,2.5833,0.54278,5.0828-2.3213,5.5827-6.3971z'/%3E %3Cpath d='m287.23,252.54c1.5978-3.7828,0.99957-7.8464-1.3361-9.0763s-5.5243,0.83956-7.1221,4.6223c-1.5978,3.7828-0.99957,7.8464,1.3361,9.0763s5.5243-0.83957,7.1221-4.6223z'/%3E %3Cpath d='m281.42,243.99c0-1.9299-1.49-3.4944-3.3279-3.4944-1.838,0-3.3279,1.5645-3.3279,3.4944s1.49,3.4945,3.3279,3.4945c1.838,0,3.3279-1.5645,3.3279-3.4945z'/%3E %3Cpath d='m278.76,235.34c0-1.7461-1.341-3.1616-2.9952-3.1616s-2.9951,1.4155-2.9951,3.1616,1.341,3.1616,2.9951,3.1616c1.6542,0,2.9952-1.4155,2.9952-3.1616z'/%3E %3Cpath d='m281.58,218.7c0-2.9408-1.3037-5.3248-2.912-5.3248-1.6082,0-2.9119,2.384-2.9119,5.3248s1.3037,5.3248,2.9119,5.3248,2.912-2.384,2.912-5.3248z'/%3E %3Cpath d='m290.54,217.42c0.38801-2.9151-0.58979-5.4502-2.184-5.6624-1.5942-0.21218-3.201,1.979-3.589,4.8941-0.38799,2.9151,0.5898,5.4502,2.184,5.6624,1.5942,0.21218,3.201-1.979,3.589-4.8941z'/%3E %3Cpath d='m354.39,90.042c1.1868-4.1283-0.0372-8.2775-2.7339-9.2673-2.6967-0.98984-5.845,1.5544-7.0318,5.6828-1.1868,4.1283,0.0372,8.2775,2.7339,9.2673,2.6967,0.98984,5.845-1.5544,7.0318-5.6828z'/%3E %3Cpath d='m342.27,108.42c3.5565-3.0269,5.0759-7.2124,3.3936-9.3486-1.6823-2.1361-5.9293-1.414-9.4858,1.6129s-5.0759,7.2124-3.3936,9.3486,5.9293,1.414,9.4858-1.6129z'/%3E %3Cpath d='m335.19,98.217c3.517-2.5985,5.0195-6.1916,3.3559-8.0255-1.6636-1.8338-5.8634-1.2139-9.3805,1.3846-3.517,2.5985-5.0195,6.1916-3.3559,8.0255,1.6636,1.8338,5.8634,1.2139,9.3805-1.3846z'/%3E %3Cpath d='m362.46,80.281c2.3718-1.8131,3.385-4.3202,2.2631-5.5997s-3.9541-0.84699-6.3258,0.96612c-2.3718,1.8131-3.385,4.3202-2.2631,5.5997s3.954,0.84699,6.3258-0.96612z'/%3E %3Cpath d='m348.25,97.659c1.6219-2.5064,1.7308-5.2083,0.24334-6.0348-1.4875-0.82655-4.0082,0.53523-5.6301,3.0416s-1.7308,5.2083-0.24334,6.0348c1.4875,0.82655,4.0082-0.53523,5.6301-3.0416z'/%3E %3Cpath d='m368.76,86.92c2.5506-2.1495,3.5444-4.9969,2.2197-6.3598s-4.4663-0.72518-7.017,1.4244c-2.5506,2.1495-3.5444,4.9969-2.2197,6.3598s4.4663,0.72518,7.017-1.4244z'/%3E %3Cpath d='m331.69,111.97c2.3843-0.11899,4.1842-1.3067,4.02-2.6528-0.16412-1.3461-2.23-2.3409-4.6144-2.2219-2.3843,0.11898-4.1841,1.3067-4.02,2.6528,0.16411,1.3461,2.23,2.3409,4.6143,2.222z'/%3E %3Cpath d='m376.57,73.606c1.6219-2.5064,1.7308-5.2083,0.24334-6.0348-1.4875-0.82655-4.0082,0.53523-5.6301,3.0416s-1.7308,5.2083-0.24334,6.0348c1.4875,0.82655,4.0082-0.53523,5.6301-3.0416z'/%3E %3C/g%3E %3Cg fill='%23ffd200' stroke='%23ef8a10' stroke-width='1.93488133'%3E %3Cpath d='m553.24,88.375s12.574-5.8004,16.169-16.603c3.5942-10.802-10.882-10.906-12.795-7.4727-1.9124,3.4337,1.6313,11.983,0.71862,14.243-0.91288,2.26-6.0283,7.7162-4.0925,9.8326z'/%3E %3Cpath stroke-width='2.4186' d='m441.8,92.316s8.1629-11.186,6.0466-22.372c-2.1164-11.186-14.814-4.2327-14.814-0.30232s7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m419.73,98.967s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m395.24,106.53s8.1629-11.186,6.0466-22.372c-2.1164-11.186-14.814-4.2327-14.814-0.30232s7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m378.01,123.76s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m359.87,140.39s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath d='m401.57,43.519s-10.87,8.5789-11.84,19.922c-0.9698,11.343,13.13,8.0606,14.187,4.2751,1.057-3.7856-4.3868-11.269-4.0276-13.68,0.35932-2.4108,4.0577-8.9115,1.6809-10.517z'/%3E %3Cpath d='m437.85,32.333s-10.87,8.5789-11.84,19.922c-0.96981,11.343,13.13,8.0606,14.187,4.2751,1.057-3.7856-4.3868-11.269-4.0276-13.68,0.35933-2.4108,4.0577-8.9115,1.6809-10.517z'/%3E %3Cpath d='m302.66,130.27s2.2963,13.656,11.776,19.96c9.48,6.3037,13.38-7.6378,10.569-10.385-2.8112-2.7468-11.991-1.5714-13.932-3.0453-1.9412-1.4741-5.8632-7.8423-8.4136-6.53z'/%3E %3Cpath d='m284.54,176.64s0.11238,13.847,8.4788,21.568c8.3664,7.7207,14.418-5.4306,12.076-8.5865-2.3425-3.156-11.592-3.444-13.277-5.2058-1.6842-1.762-4.5521-8.6694-7.2776-7.7759z'/%3E %3Cpath d='m326.34,228.44s-4.9424-12.936-15.479-17.248c-10.536-4.3119-11.613,10.125-8.3155,12.264,3.2974,2.1388,12.065-0.82252,14.259,0.24011,2.1936,1.0626,7.2936,6.5329,9.5354,4.744z'/%3E %3Cpath d='m317.66,206.05s8.3793-11.025,6.481-22.25-14.729-4.5203-14.805-0.59063c-0.0764,3.9296,7.0662,9.8139,7.3214,12.238,0.25509,2.424-1.6996,9.643,1.003,10.603z'/%3E %3Cpath d='m578.94,99.561s12.574-5.8004,16.169-16.603c3.5942-10.802-10.882-10.906-12.795-7.4727-1.9124,3.4337,1.6313,11.983,0.71862,14.243-0.91288,2.26-6.0283,7.7162-4.0925,9.8326z'/%3E %3Cpath d='m616.97,118.53s7.3965-11.707,4.5367-22.726-15.064-3.2326-14.801,0.68905c0.26295,3.9215,7.8866,9.1676,8.3502,11.561,0.46321,2.393-0.86141,9.7539,1.9142,10.477z'/%3E %3Cpath d='m720.74,226.27s-4.9601-12.929-15.502-17.226c-10.542-4.2976-11.599,10.141-8.2989,12.275,3.3005,2.1342,12.064-0.83896,14.259,0.22038,2.1951,1.0597,7.3024,6.5233,9.5419,4.7308z'/%3E %3Cpath d='m670,234.3s0.28772-13.845,8.7511-21.459c8.4636-7.6145,14.348,5.6121,11.966,8.7385-2.3824,3.126-11.635,3.2968-13.342,5.0373-1.7064,1.7406-4.6611,8.6112-7.3754,7.6832z'/%3E %3Cpath d='m661.83,87.484s-12.945-4.9172-23.175,0.07937c-10.23,4.9968-0.16872,15.406,3.6223,14.367,3.7906-1.0386,7.4135-9.5536,9.6665-10.485,2.253-0.93052,9.7301-1.0977,9.8859-3.962z'/%3E %3Cpath d='m632.21,62.693s-12.945-4.9172-23.175,0.07937c-10.23,4.9968-0.16872,15.406,3.6223,14.367,3.7906-1.0385,7.4135-9.5537,9.6665-10.485,2.253-0.93052,9.7301-1.0977,9.8859-3.962z'/%3E %3Cpath d='m588.02,39.053s-10.975,8.4448-12.084,19.775c-1.1087,11.331,13.03,8.2212,14.133,4.4487,1.1033-3.7723-4.248-11.322-3.8595-13.729,0.38891-2.4064,4.167-8.861,1.8097-10.495z'/%3E %3Cpath d='m559.27,32.131s-5.0048,12.912-0.0772,23.175,15.404,0.27293,14.391-3.525c-1.0127-3.7976-9.5034-7.4779-10.419-9.7372-0.9154-2.2592-1.0321-9.7372-3.8953-9.9123z'/%3E %3Cpath d='m477.66,81.887s8.9517-10.565,7.6509-21.875c-1.3006-11.31-14.468-5.295-14.753-1.3747-0.28481,3.92,6.5356,10.174,6.6622,12.609,0.12635,2.4343-2.2087,9.5394,0.4398,10.641z'/%3E %3C/g%3E %3Cg fill='%23de2010' stroke='%23000' stroke-width='2.38277'%3E %3Cpath d='m701.62,233.11c-0.50236-4.0492-2.4537-7.607-5.117-9.3315-2.6632-1.7245-5.6335-1.3532-7.7903,0.97376s-3.172,6.2556-2.6626,10.304c0.50235,4.0492,2.4537,7.607,5.117,9.3315,2.6632,1.7245,5.6335,1.3532,7.7902-0.97377,2.1568-2.327,3.172-6.2556,2.6626-10.304z'/%3E %3Cpath d='m699.95,212.66c-0.50236-4.0492-2.4537-7.607-5.117-9.3315-2.6632-1.7245-5.6335-1.3532-7.7903,0.97377s-3.172,6.2556-2.6626,10.304c0.50235,4.0492,2.4537,7.607,5.117,9.3315,2.6632,1.7245,5.6335,1.3532,7.7902-0.97377,2.1568-2.327,3.172-6.2556,2.6626-10.304z'/%3E %3Cpath d='m695.8,190.82c-0.85624-3.9894-3.1127-7.362-5.9172-8.8458s-5.7306-0.85294-7.6745,1.6546c-1.944,2.5076-2.61,6.5102-1.7468,10.498,0.85624,3.9894,3.1127,7.362,5.9172,8.8458s5.7306,0.85294,7.6746-1.6546c1.944-2.5076,2.61-6.5102,1.7468-10.498z'/%3E %3Cpath d='m688.23,168c-1.8449-3.6393-4.8866-6.3252-7.9767-7.0451-3.0901-0.71985-5.7587,0.63609-6.9992,3.5563-1.2405,2.9203-0.86415,6.9604,0.98712,10.597,1.8449,3.6393,4.8866,6.3252,7.9767,7.0451,3.09,0.71985,5.7587-0.6361,6.9992-3.5563,1.2405-2.9203,0.86415-6.9604-0.98712-10.597z'/%3E %3Cpath d='m680.14,149.69c-1.8449-3.6393-4.8866-6.3252-7.9767-7.0451-3.0901-0.71985-5.7587,0.63609-6.9992,3.5563-1.2405,2.9203-0.86415,6.9604,0.98712,10.597,1.8449,3.6393,4.8866,6.3252,7.9767,7.0451,3.09,0.71985,5.7587-0.6361,6.9992-3.5563,1.2405-2.9203,0.86415-6.9604-0.98712-10.597z'/%3E %3Cpath d='m668.64,131.28c-2.1465-3.47-5.4047-5.8887-8.5446-6.3443s-5.6841,1.1215-6.6729,4.1363c-0.98876,3.0148-0.27162,7.0086,1.8809,10.475,2.1465,3.47,5.4047,5.8887,8.5446,6.3443,3.1399,0.45559,5.6841-1.1215,6.6729-4.1363,0.98877-3.0148,0.27162-7.0086-1.8809-10.475z'/%3E %3Cpath d='m655.85,113.54c-2.4719-3.2462-5.9486-5.3386-9.1179-5.4885-3.1692-0.14991-5.5491,1.6657-6.2418,4.762-0.69268,3.0963,0.40721,7.002,2.8848,10.244,2.4719,3.2462,5.9486,5.3386,9.1179,5.4885,3.1693,0.14991,5.5491-1.6657,6.2418-4.762,0.69268-3.0963-0.40721-7.002-2.8848-10.244z'/%3E %3Cpath d='m640.59,96.996c-2.9164-2.8536-6.6597-4.4199-9.8172-4.1088-3.1575,0.31109-5.249,2.4525-5.4856,5.6165-0.23652,3.164,1.4179,6.8691,4.3393,9.7176,2.9164,2.8536,6.6597,4.4199,9.8172,4.1088,3.1575-0.31109,5.249-2.4525,5.4855-5.6165,0.23652-3.164-1.4179-6.8691-4.3393-9.7176z'/%3E %3Cpath d='m623.41,81.776c-3.1665-2.5733-7.038-3.7886-10.154-3.1884-3.1155,0.60021-5.0012,2.925-4.9457,6.0973s2.0438,6.7095,5.2147,9.2772c3.1665,2.5733,7.038,3.7886,10.154,3.1884,3.1155-0.60021,5.0012-2.925,4.9457-6.0973s-2.0438-6.7095-5.2147-9.2772z'/%3E %3Cpath d='m605.21,69.628c-3.5497-2.0119-7.5693-2.5676-10.542-1.4585-2.9726,1.1091-4.4462,3.7146-3.8648,6.8337s3.1293,6.2771,6.6825,8.2828c3.5497,2.0119,7.5693,2.5676,10.542,1.4585,2.9726-1.1091,4.4462-3.7146,3.8648-6.8337s-3.1293-6.2771-6.6825-8.2828z'/%3E %3Cpath d='m584.84,58.844c-3.7181-1.6805-7.7716-1.8681-10.631-0.49302-2.8594,1.375-4.0897,4.1039-3.2268,7.1571,0.86286,3.0532,3.6876,5.9663,7.4086,7.6402,3.7181,1.6805,7.7716,1.8681,10.631,0.49302,2.8594-1.375,4.0897-4.1039,3.2268-7.1571-0.86285-3.0532-3.6876-5.9663-7.4086-7.6402z'/%3E %3Cpath d='m564.86,50.799c-3.8224-1.4274-7.8794-1.3428-10.64,0.22081-2.7607,1.5636-3.8053,4.3688-2.7397,7.3573s4.0793,5.7056,7.9042,7.1263c3.8224,1.4274,7.8794,1.3428,10.64-0.22081,2.7607-1.5636,3.8053-4.3688,2.7397-7.3573s-4.0793-5.7056-7.9042-7.1263z'/%3E %3Cpath d='m544.56,44.43c-3.9202-1.1315-7.9588-0.73759-10.592,1.0322-2.6334,1.7698-3.4608,4.6465-2.1702,7.5449,1.2906,2.8985,4.5028,5.3777,8.425,6.5023,3.9202,1.1315,7.9588,0.73759,10.592-1.0322,2.6334-1.7698,3.4608-4.6465,2.1702-7.5449-1.2906-2.8985-4.5028-5.3777-8.425-6.5023z'/%3E %3Cpath d='m522.21,40.62c-4.0477-0.51427-7.9775,0.49696-10.307,2.6512-2.3294,2.1542-2.7039,5.1241-0.98236,7.7892,1.7216,2.6651,5.2773,4.62,9.3259,5.1272,4.0477,0.51427,7.9775-0.49696,10.307-2.6512,2.3294-2.1542,2.7039-5.1241,0.98236-7.7892-1.7216-2.6651-5.2773-4.62-9.3259-5.1272z'/%3E %3Cpath d='m500.15,39.375c-4.0768-0.16747-7.9061,1.175-10.043,3.5199-2.1373,2.3449-2.2574,5.3358-0.31502,7.8446,1.9424,2.5087,5.6518,4.1535,9.7289,4.3139,4.0768,0.16747,7.9061-1.175,10.043-3.5199,2.1373-2.3449,2.2574-5.3358,0.31501-7.8446-1.9424-2.5087-5.6518-4.1535-9.7289-4.3139z'/%3E %3Cpath d='m479.94,40.089c-4.0768-0.16747-7.9061,1.175-10.043,3.5199-2.1373,2.3449-2.2574,5.3358-0.31502,7.8446,1.9424,2.5087,5.6518,4.1535,9.7289,4.3139,4.0768,0.16747,7.9061-1.175,10.043-3.5199,2.1373-2.3449,2.2574-5.3358,0.31501-7.8446-1.9424-2.5087-5.6518-4.1535-9.7289-4.3139z'/%3E %3Cpath d='m456.25,42.895c-3.9785,0.90558-7.3229,3.2036-8.7718,6.0263-1.449,2.8226-0.78191,5.7407,1.7495,7.6535s6.542,2.5291,10.519,1.6166c3.9785-0.90558,7.3228-3.2036,8.7718-6.0263,1.449-2.8226,0.78192-5.7407-1.7495-7.6535s-6.542-2.5291-10.519-1.6166z'/%3E %3Cpath d='m434.7,48.296c-3.8902,1.2306-7.0337,3.7967-8.2449,6.7292s-0.30576,5.7856,2.3748,7.4831,6.7283,1.9809,10.616,0.74352c3.8902-1.2306,7.0337-3.7967,8.2449-6.7292s0.30576-5.7856-2.3748-7.4831-6.7283-1.9809-10.616-0.74352z'/%3E %3Cpath d='m415.04,56.715c-3.7159,1.6852-6.5314,4.6075-7.3847,7.6634-0.85329,3.0559,0.38555,5.7809,3.2492,7.147,2.8637,1.3661,6.9164,1.1654,10.629-0.5263,3.7159-1.6852,6.5314-4.6075,7.3847-7.6634s-0.38555-5.7809-3.2492-7.147c-2.8637-1.3661-6.9164-1.1654-10.629,0.5263z'/%3E %3Cpath d='m395.43,66.766c-3.5586,1.9961-6.1145,5.1479-6.704,8.2654-0.58948,3.1176,0.87731,5.7269,3.8471,6.8437s6.9906,0.57113,10.546-1.4312c3.5586-1.9961,6.1145-5.1479,6.704-8.2654,0.58948-3.1176-0.87731-5.7269-3.8471-6.8437s-6.9906-0.57113-10.546,1.4312z'/%3E %3Cpath d='m376.88,79.349c-3.3206,2.371-5.5189,5.7818-5.7661,8.945-0.24721,3.1632,1.4944,5.5977,4.568,6.3851,3.0736,0.78747,7.0113-0.19191,10.328-2.5687,3.3206-2.371,5.5189-5.7818,5.7661-8.945,0.24721-3.1632-1.4944-5.5977-4.568-6.3851-3.0736-0.78747-7.0112,0.19191-10.328,2.5687z'/%3E %3Cpath d='m359.71,92.358c-3.1081,2.6435-5.0099,6.2281-4.9886,9.4008s1.9627,5.4511,5.0919,5.9757c3.1292,0.52459,6.9699-0.78445,10.073-3.4333,3.1081-2.6435,5.0099-6.2281,4.9885-9.4008-0.0213-3.1727-1.9627-5.4511-5.0918-5.9757-3.1292-0.52459-6.9699,0.78446-10.073,3.4333z'/%3E %3Cpath d='m344.56,108.19c-2.9106,2.8595-4.5504,6.5713-4.3016,9.7343,0.24877,3.163,2.3486,5.2964,5.5072,5.5952,3.1587,0.29886,6.8957-1.2822,9.8012-4.1468,2.9106-2.8595,4.5504-6.5713,4.3016-9.7343-0.24876-3.163-2.3485-5.2964-5.5072-5.5952-3.1587-0.29885-6.8957,1.2822-9.8012,4.1468z'/%3E %3Cpath d='m331.51,125.79c-2.661,3.0931-3.9844,6.9291-3.4718,10.06,0.51264,3.1311,2.7836,5.0812,5.9562,5.1146s6.7642-1.8549,9.4198-4.9526c2.661-3.0931,3.9844-6.9291,3.4718-10.06-0.51264-3.1311-2.7836-5.0812-5.9562-5.1146s-6.7642,1.8549-9.4198,4.9526z'/%3E %3Cpath d='m319.58,143.81c-2.316,3.3593-3.2227,7.3145-2.3791,10.373,0.84363,3.0586,3.3096,4.7554,6.4677,4.4503,3.1581-0.30511,6.5278-2.5657,8.8379-5.929,2.316-3.3593,3.2227-7.3145,2.3791-10.373-0.84363-3.0586-3.3096-4.7554-6.4677-4.4503-3.1581,0.30511-6.5278,2.5657-8.8379,5.929z'/%3E %3Cpath d='m309.64,164.24c-1.7045,3.7072-1.9183,7.7594-0.56184,10.628,1.3565,2.8682,4.0773,4.1162,7.136,3.2731,3.0588-0.84308,5.99-3.6489,7.688-7.359,1.7045-3.7072,1.9183-7.7594,0.56184-10.628-1.3565-2.8682-4.0773-4.1162-7.136-3.2731-3.0588,0.84308-5.99,3.6489-7.688,7.359z'/%3E %3Cpath d='m301.77,185.59c-1.3614,3.8464-1.207,7.9013,0.40393,10.635,1.6109,2.7334,4.4337,3.7296,7.4034,2.6127s5.6346-4.1769,6.9892-8.0257c1.3614-3.8464,1.207-7.9013-0.40393-10.635-1.6109-2.7334-4.4337-3.7296-7.4034-2.6127s-5.6346,4.1769-6.9892,8.0257z'/%3E %3Cpath stroke-width='2.1334' d='m294.94,226.01c-0.38059,3.2566,0.75959,6.3785,2.9894,8.1879s5.2104,2.031,7.8173,0.58131c2.607-1.4498,4.4436-4.3503,4.8171-7.6074,0.3806-3.2566-0.75959-6.3785-2.9894-8.1879s-5.2104-2.031-7.8173-0.5813c-2.607,1.4498-4.4436,4.3503-4.8171,7.6074z'/%3E %3Cpath d='m296.76,207.14c-0.91046,3.9774-0.29124,7.9877,1.6231,10.518,1.9143,2.5302,4.8328,3.1955,7.6545,1.7448,2.8218-1.4507,5.1174-4.7966,6.0209-8.7755,0.91046-3.9774,0.29123-7.9876-1.6231-10.518-1.9143-2.5302-4.8328-3.1955-7.6545-1.7448-2.8218,1.4507-5.1174,4.7966-6.0209,8.7755z'/%3E %3C/g%3E %3Cg fill='%23ffe300'%3E %3Cpath d='m685.33,197.47c2.4854-2.6607,4.7977-3.413,7.7239-2.4427-1.0319-7.0192-3.2529-9.4006-5.9587-8.5554-2.7057,0.84519-3.9303,4.4536-1.7652,10.998z'/%3E %3Cpath d='m689.13,218.66c2.6788-2.4658,5.0415-3.0416,7.8862-1.8536-0.49998-7.077-2.5355-9.6191-5.2971-8.9802-2.7617,0.6389-4.2546,4.1447-2.5891,10.834z'/%3E %3Cpath d='m680.14,178.14c1.7282-3.2047,3.7738-4.5196,6.8502-4.3242-2.7806-6.527-5.5336-8.2663-7.9361-6.7616-2.4024,1.5046-2.6703,5.3057,1.0859,11.086z'/%3E %3Cpath d='m670.71,158.86c1.7282-3.2047,3.7738-4.5196,6.8502-4.3242-2.7806-6.527-5.5336-8.2663-7.9361-6.7616-2.4024,1.5046-2.6703,5.3057,1.0859,11.086z'/%3E %3Cpath d='m648.1,123.54c1.1907-3.4408,2.9985-5.0674,6.0662-5.369-3.7935-5.9952-6.7903-7.2694-8.9196-5.3982s-1.783,5.6659,2.8534,10.767z'/%3E %3Cpath d='m633.32,108.15c1.0599-3.4833,2.8048-5.1771,5.859-5.5945-4.0174-5.8476-7.0602-7.0076-9.1172-5.0572-2.0572,1.9503-1.5676,5.7293,3.2582,10.652z'/%3E %3Cpath d='m602.26,81.935c-0.0644-3.6404,1.074-5.7893,3.8512-7.127-5.6232-4.326-8.8753-4.4925-10.231-2.0035-1.3565,2.4891,0.27302,5.9336,6.3803,9.1305z'/%3E %3Cpath d='m618.42,94.057c0.56691-3.5966,2.0602-5.5159,5.027-6.3525-4.789-5.2344-7.9632-5.9615-9.7299-3.7449-1.7671,2.2166-0.75848,5.8912,4.7029,10.097z'/%3E %3Cpath d='m583.81,71.756c-0.4396-3.6144,0.47096-5.8692,3.0952-7.4863-6.0394-3.7227-9.2915-3.5528-10.384-0.93706-1.0924,2.6158,0.88386,5.8737,7.2883,8.4234z'/%3E %3Cpath d='m564.96,63.528c-0.95234-3.5143-0.37382-5.8762,1.992-7.8522-6.5099-2.8202-9.7042-2.1866-10.411,0.55846-0.70701,2.7452,1.7153,5.6868,8.4187,7.2938z'/%3E %3Cpath d='m544.65,57.235c-1.2464-3.421-0.86992-5.8235,1.32-7.9927-6.7252-2.259-9.8544-1.3572-10.326,1.4378-0.47212,2.7952,2.1905,5.5212,9.0059,6.5549z'/%3E %3Cpath d='m524.7,53.373c-1.4906-3.3219-1.2888-5.7453,0.73855-8.0672-6.8711-1.7667-9.9267-0.64101-10.195,2.1808-0.26875,2.8221,2.584,5.3483,9.4563,5.8864z'/%3E %3Cpath d='m503.57,51.753c-1.8271-3.1494-1.8776-5.5807-0.10196-8.1003-7.0172-1.0447-9.9397,0.39174-9.9138,3.2261,0.0253,2.8347,3.1246,5.0515,10.016,4.8742z'/%3E %3Cpath d='m462.21,54.869c-2.5324-2.616-3.1674-4.9634-2.0518-7.8368-7.0621,0.67789-9.5519,2.7765-8.8436,5.521,0.70797,2.745,4.2504,4.1492,10.895,2.3157z'/%3E %3Cpath d='m482.57,52.189c-2.1551-2.9348-2.4666-5.3465-0.97229-8.0424-7.0888-0.28422-9.8398,1.4581-9.5094,4.2733,0.32989,2.8155,3.6496,4.6863,10.482,3.7691z'/%3E %3Cpath d='m442.23,59.185c-2.8813-2.2259-3.8463-4.458-3.1541-7.4616-6.892,1.6834-9.0552,4.1173-7.9606,6.7319,1.0942,2.6151,4.8013,3.4969,11.115,0.7297z'/%3E %3Cpath d='m403.98,76.772c-3.2521-1.6372-4.6241-3.645-4.5159-6.7254-6.4459,2.9637-8.1066,5.7647-6.5347,8.1233,1.5717,2.3592,5.3788,2.5197,11.051-1.398z'/%3E %3Cpath d='m422.42,67.35c-3.0292-2.02-4.1472-4.1796-3.6657-7.224-6.7581,2.1589-8.7467,4.7375-7.4729,7.2696,1.2735,2.5326,5.033,3.1543,11.139-0.04555z'/%3E %3Cpath d='m369.67,100.66c-3.5219-0.92352-5.2822-2.6013-5.8183-5.6366-5.6867,4.242-6.7272,7.3275-4.6983,9.3068,2.0288,1.9798,5.7859,1.3434,10.517-3.6703z'/%3E %3Cpath d='m386.04,87.263c-3.4388-1.1964-5.0623-3.0068-5.3592-6.0747-6.0013,3.7838-7.2802,6.7784-5.4124,8.9105,1.8676,2.1326,5.6629,1.7922,10.772-2.8358z'/%3E %3Cpath d='m355.13,114.99c-3.5912-0.59954-5.4968-2.1103-6.3066-5.0843-5.2776,4.7413-6.0333,7.9087-3.8328,9.6954,2.2004,1.7872,5.884,0.8119,10.139-4.6111z'/%3E %3Cpath d='m342.09,131.9c-3.6308-0.27111-5.6656-1.6027-6.7421-4.4909-4.8254,5.2008-5.2905,8.4237-2.9369,10.003,2.3535,1.5801,5.9334,0.27444,9.679-5.5124z'/%3E %3Cpath d='m331.19,149.2c-3.6295,0.2881-5.8442-0.71618-7.3503-3.4054-3.9721,5.8784-3.9381,9.1345-1.3704,10.335,2.5678,1.2011,5.9055-0.63741,8.7207-6.9296z'/%3E %3Cpath d='m321.61,167.67c-3.5615,0.75666-5.8878,0.0483-7.73-2.4229-3.1757,6.3441-2.7195,9.5683-0.0177,10.425,2.7019,0.85774,5.7728-1.3983,7.7478-8.0026z'/%3E %3Cpath d='m313.95,186.62c-3.3966,1.3114-5.8058,0.98047-8.0163-1.1675-2.1304,6.7671-1.1692,9.8783,1.6342,10.297,2.8037,0.41883,5.4784-2.2953,6.382-9.1291z'/%3E %3Cpath d='m308.82,207.75c-3.3012,1.5359-5.7271,1.3668-8.0764-0.62825-1.6727,6.8946-0.50531,9.9344,2.3199,10.164,2.8254,0.23006,5.3124-2.657,5.7566-9.5359z'/%3E %3Cpath d='m306.73,225.33c-3.1078,1.646-5.5296,1.8405-8.0697,0.59614-0.92446,5.6189,0.55546,7.8398,3.3793,7.6391,2.8241-0.20045,4.9816-2.794,4.6904-8.2352z'/%3E %3Cpath d='m662.3,141.68c1.2428-3.4223,3.0749-5.0212,6.1469-5.2762-3.702-6.0522-6.679-7.3718-8.8366-5.5331-2.1574,1.8386-1.8687,5.6382,2.6897,10.809z'/%3E %3Cpath d='m691.45,240.12c2.6788-2.4658,5.0415-3.0416,7.8862-1.8536-0.49997-7.077-2.5355-9.6191-5.2971-8.9802-2.7617,0.6389-4.2546,4.1447-2.5891,10.834z'/%3E %3C/g%3E %3Cpath d='m646.9,149.66s7.3965-11.707,4.5367-22.726-15.064-3.2326-14.801,0.68906c0.26295,3.9215,7.8866,9.1676,8.3502,11.561,0.4632,2.393-0.86142,9.7539,1.9142,10.477z' fill='%23ffd200' stroke='%23ef8a10' stroke-width='1.008'/%3E %3Cg fill='%23217900' stroke='%23000' stroke-width='2.4186' stroke-linejoin='round'%3E %3Cpath stroke-width='1.9349' d='m663.67,124.92c-0.0863,0-8.0216,7.9354-6.6415,17.596,1.38,9.6605,7.504,21.564,6.3828,31.569-1.1215,10.006-2.9327,16.647-2.9327,16.647s9.3155-10.609,9.4018-20.787-6.383-23.548-6.383-31.052c0-7.5041,0.34519-14.146,0.17259-13.973z'/%3E %3Cpath stroke-width='1.9349' d='m678.42,157.35s-6.2104,4.5715-5.6065,15.095c0.60369,10.523,11.472,29.844,11.472,29.844s7.9355,16.302,7.6766,20.529c-0.25869,4.2264,1.4664-4.0538,0.69017-13.369-0.77627-9.3155-12.766-29.844-12.766-29.844s-2.5877-4.2263-2.3288-11.213c0.25869-6.9867,0.94886-10.954,0.86257-11.041z'/%3E %3Cpath d='m505.65,52.293s26.653,1.0353,26.825,18.286c-0.0863,2.674-0.00019,5.8651-0.94886,13.542,5.2615-2.8462,8.7981-10.782,8.1079-15.871,0.0863-17.51-23.806-29.499-33.984-15.957z'/%3E %3Cpath d='m488.75,51.517s21.477-4.4853,21.65,12.766c0.17259,17.251-6.8141,20.011-6.8141,20.011s16.475-3.5365,16.561-21.046c0.0863-17.51-21.218-25.272-31.397-11.731z'/%3E %3Cpath d='m697.38,249.19c0.49396,7.7393,8.0686,15.149,5.1048,28.652-3.7873,15.314-17.125,51.705-14.82,58.127-3.952-5.4341-3.2934-10.539-3.6227-18.113-0.32931-7.5745,11.032-35.732,12.021-45.283-0.00019-8.5624,0.82311-20.254,1.3171-23.382z'/%3E %3Cpath d='m697.38,249.36s12.35,15.643,11.691,27.993c-0.65862,12.35-7.5747,26.84-5.2693,33.262-3.952-5.4341-4.9399-8.8921-5.2693-16.467-0.32931-7.5745,6.0926-15.973,4.7753-24.206-1.3175-8.2333-6.0928-20.583-5.9281-20.583z'/%3E %3Cpath d='m292.82,252.81c-0.49397,7.7393-6.2574,14.655-3.2936,28.158,3.7873,15.314,17.29,34.744,15.149,56.974,3.952-5.4343,5.1048-11.527,5.4341-19.102,0.32931-7.5745-14.984-33.098-15.973-42.648,0.00019-8.5624-0.8231-20.254-1.3171-23.382z'/%3E %3Cpath d='m292.82,252.98s-12.021,15.149-11.362,27.499c0.16465,8.2331,15.314,42.648,13.009,49.07,3.952-5.4339,5.1046-4.7755,4.9398-13.009-4.446-21.077-12.35-34.58-11.032-42.813,1.3175-8.2333,4.6108-20.748,4.4462-20.748z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='1.9349'%3E %3Cpath fill='%238c8a8c' d='m526.38,104.56s21.457,1.3504,22.508,13.655c1.0502,12.304-5.1017,19.807-5.1017,19.807s2.7009,26.559-18.306,34.361c-22.508,2.701-57.769,0.60024-57.769,0.60024s-10.354,2.551-14.555-18.906c-4.2014-21.457-5.4018-36.612-5.4018-36.612s2.1007-12.004,17.256-12.754c15.155-0.75019,61.22,0.15013,61.371-0.14998z'/%3E %3Cpath stroke-linecap='round' d='m543.63,137.87s-11.554,14.405-10.353,20.257'/%3E %3Cpath fill='%238c8a8c' d='m528.18,171.63c2.851,2.4008,5.5518,5.1016,6.152,13.955,0.6002,8.853,1.2004,17.706,1.2004,17.706l15.005,135.05,13.204,97.683,0.9003,15.155s-3.151,11.104-12.004,12.004c-6.452,13.504-41.414,17.406-44.865,17.256-3.151-0.14996-14.255-4.8016-21.007-4.2014-6.7524,0.60001-18.456,5.1015-23.708,4.3514-5.2516-0.75015-17.106-4.8016-19.206-13.354-14.705-4.6516-17.106-15.905-17.106-15.905l15.905-112.99,15.455-142.85s1.8006-19.056,9.4531-21.907c7.9527-0.7502,49.066,0.7502,60.62-1.9506z'/%3E %3Cpath d='m447.15,367.15-3.151,99.934'/%3E %3Cpath d='m544.23,380.35,8.853,82.378'/%3E %3Cpath fill='%23fff' stroke-width='2.0159' stroke-linejoin='round' d='m498.19,114.45,29.923,92.093,96.82,0.004-78.327,56.92,29.916,92.095-78.331-56.915-78.331,56.914,29.916-92.095-78.327-56.92,96.82-0.004z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='-72 -28 144 96'%3E %3Crect x='-72' y='-28' width='144' height='96' fill='%23006233'/%3E %3Ccircle cy='8' r='31' fill='%23ffc400'/%3E %3Ccircle r='30' fill='%23006233'/%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-12 v 12 h 6' transform='rotate(18 0,-12)' fill='%23ffc400'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/svg%3E"

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m769.466,147.526,256.879,0-0.306,182.787c2.1373,73.4798-43.6616,119.076-127.931,139.634-59.834-14.86-128.837-45.596-128.939-137.549l0.30537-184.872z'/%3E %3Cpath fill='%2300a2bd' stroke='%23000' stroke-width='1.8125' d='m775.152,153.036,245.493,0-0.2914,175.155c2.0416,70.4101-41.7273,114.102-122.261,133.802-57.188-14.237-123.132-43.692-123.229-131.805l0.29189-177.152z'/%3E %3Cpath fill='%23a53d08' d='m1018.74,348.938c-8.9307,67.2099-60.6921,96.5757-120.655,112.162-53.073-14.238-110.174-36.968-121.243-111.824l241.901-0.33785z'/%3E %3Cpath fill='%23000' d='m888.365,185.664-0.34221-22.0753,17.4554,0.17111,0.17111,21.9042,47.7434,0,0.17109,17.1126-47.9145,0.17111-0.38281,201.815-17.0262,0.10728-0.2175-202.093-47.5824,0.17125,0.0101-17.4548z'/%3E %3Cg fill='%23ff9a08' stroke='%23000' stroke-width='0.9676'%3E %3Cpath d='m849.714,357.267,43.703,45.3378c15.1121-16.61,4.62991-78.6955-15.247-90.1304-2.3824,7.35162-6.43375,16.1663-10.7403,19.0083-9.47444,6.45695-32.6922,14.0058-24.9316,18.8401,1.76989-2.45053,6.39893-4.76476,8.5773,0.68151,2.58684,8.57687-9.66655,9.12208-9.66655,9.12208s-7.76038-0.95411-9.12194-8.85092c-1.36144-7.89537,11.5591-15.1049,12.6619-15.6559,1.08911-0.40891,17.9714-4.90107,20.8308-19.8783,3.53951-14.7047,7.21531-12.5253,7.89681-12.7979,22.0548,2.17794,36.4869,41.662,37.3047,69.4357,0.81634,27.7737-11.3,46.1542-13.4794,47.3794-2.17793,1.22527-52.553-59.7684-52.553-59.7684l4.76521-2.72313z' fill-rule='evenodd'/%3E %3Cpath d='m881.573,315.061,0.27116,81.8247'/%3E %3Cpath d='m876.672,316.558c0,0.13629,0.27116,74.3382,0.27116,74.3382'/%3E %3Cpath d='m871.362,327.314,0.27115,59.0884'/%3E %3Cpath d='m867.005,331.534,0.27261,48.8788'/%3E %3Cpath d='m862.376,333.713v41.2531'/%3E %3Cpath d='m857.338,336.981v32.6748'/%3E %3Cpath d='m852.982,339.568v25.0506'/%3E %3Cg fill='none' stroke='%23ffdf00' stroke-width='1.8125' stroke-linecap='round'%3E %3Cpath stroke-width='0.9676' d='m849.033,362.441,45.0653,51.6004'/%3E %3Cpath d='m896.276,329.901s20.4236,44.6578,1.49788,81.4172'/%3E %3Cpath d='m843.723,353.046s1.49772-3.94841,3.40377-2.31424'/%3E %3Cpath d='m840.184,341.61s-8.16898,7.2153-3.67594,11.8452'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.3987'%3E %3Cpath fill='%23008021' d='m905.779,228.044c3.02538-2.59499,4.59503-4.18109,6.46848-3.89248,1.87346,0.28798,4.42414,0.14367,6.2976-0.43292,1.87978-0.57723,11.1774-1.73042,15.0003-0.43292,1.2975,0.14431,3.02538,0.86584,5.68999,3.10069,2.67094,2.23422,6.56342,6.12797,5.26592,16.9415-1.29749,10.8135-0.87343,15.4389-1.44306,21.4833-1.00635,10.6698-3.37349,19.4554-7.63939,18.744,5.76593,10.0932,6.34189,18.744,10.0888,25.6651,3.75324,6.92102,6.05708,21.051,4.61402,36.3349-1.43674,15.2838-5.47479,49.5991,6.63304,72.6692-2.01903,1.4418-6.91786,0-11.2471-4.61402-4.32287-4.61401-6.22164-4.46275-9.80399-1.73041-10.9559,8.36282-21.2156,18.4421-36.3298,8.36282-3.46209-2.30701-4.55705-5.07415-2.01902-12.1116,6.34189-17.5902,9.42423-41.7249,8.42421-53.0599v-127.027z'/%3E %3Cg fill='%23ffe1cf'%3E %3Cpath d='m916.171,217.23c0.79116,2.45131,1.22155,5.62289-0.076,8.50649-1.29749,2.8836-1.58231,6.34443,0.57596,10.5255,3.4621-4.902,8.36726-3.89249,11.2471-6.77609,2.88613-2.88423,3.46209-5.62352,5.62669-6.20075-2.1646-1.87409-5.48112-3.89248-4.75959-9.3717,0.72154-5.47923,8.36093-9.9483,1.44307-18.3118-4.46844-5.39821-10.9622-3.89248-13.7724-1.80193-1.32281,0.9823-2.44942,2.37853-2.87981,3.31589-0.43671,0.93736,0.1076,3.07031-0.94305,4.32603-0.71521,0.86457-1.58864,1.72472-2.59499,2.45068-0.64558,0.469-1.05065,1.15192-0.36077,1.94688,0.27849,0.31772,0.78483,0.38545,1.3418,0.57849-0.32279,0.64875-0.68988,1.29559-1.05065,1.76459-0.34178,0.43988-0.19621,0.85951,0.21519,1.21775-0.54431,1.72978,0.50634,1.91775-0.21519,3.21588-0.6266,1.12218-1.47471,2.45005,0.8671,3.74881,0.64559,0.36013,3.71527,1.07217,5.33555,0.86521z'/%3E %3Cpath d='m888.126,245.923c-4.03806,1.00952-10.5255-0.72026-15.4307-0.1443-2.1646,0.2557-3.89248-0.86458-3.60133-3.02728,0.28481-2.16333,0.57596-5.47922,0.13924-8.50713-0.6709-4.71845,1.58864-11.2464,4.75959-18.4561,3.17095-7.209,4.75958-11.2458,4.75958-14.6345,0-2.23486,0.2152-4.75832,2.23423-6.05582,1.4937-0.95888,1.77851-1.88991,2.31017-2.66714,1.22154-1.80257,2.37346-2.23485,2.51903-1.15319,0.0886,0.64305-0.14557,1.22534-0.72153,2.09055,1.2975-1.08167,3.50007-2.34372,4.00008-2.70385,0.50634-0.36013,3.06968-2.1627,3.20892-0.46836,1.01268-0.50444,1.69624-0.469,1.94941,0.0715,0.27216,0.58482,0.1076,0.82976-0.39874,1.26205,0.72153-0.14431,1.55066,1.11774,0.10759,2.23485,0.75951-0.25254,1.51269,1.00952,0.18355,2.1627-1.37977,1.19053-2.95575,2.01903-3.46209,2.95576-0.50634,0.93736-3.93046,3.56905-5.29757,4.14565-1.37345,0.57659-1.44307,1.36775-1.44307,3.38804,0,22.2042-2.66461,20.4004-2.66461,25.7372,0,1.44181-0.29114,2.7393,1.15192,2.30638,1.44307-0.43229,3.53172-1.08103,5.69632-1.08103v12.5439z'/%3E %3Cpath d='m888.987,293.792c6.51912-3.25829,13.9876-4.46971,17.8801-5.47859,3.89248-1.00951,10.0951-4.03679,13.1205-5.62289,3.03171-1.58674,5.48112-3.74945,7.20901-4.32604,1.73421-0.57659,3.67095-1.76965,4.75958-3.89248,5.62037-10.9584,8.65207-19.7523,8.65207-27.3955,0-5.0463-1.29749-10.6698-6.20265-6.63241-4.60769,3.79502-9.62677,11.1104-10.9559,16.437-2.01903,8.07421-3.74691,9.80462-4.18363,11.3901-0.43039,1.58674-2.06333,1.58485-4.03805,2.01903-8.5065,1.87472-10.5255,3.17158-16.8674,7.9299-6.3419,4.75833-13.2661,8.94005-17.8801,11.535-4.61402,2.59562-5.47479,2.8836-6.48747,4.97415-1.00635,2.09055-1.94308,3.67665-2.81018,4.61465-0.86711,0.93673-1.11395,2.03232-0.93673,3.17158,0.14557,0.93736-0.29115,5.26276-0.36077,6.70456-0.076,1.4418,0.28482,1.80257,0.86711,1.87409,0.57596,0.0728,1.36711-0.21583,1.65826-1.94624-0.29115,1.73041,2.08865,1.15319,2.23422-0.14368-0.076,1.87409,2.44941,0.79306,2.59499-0.93736,0,1.22534,1.91143,0.37786,2.08865-0.21646,0.43038-1.4418,0.79115-3.0279,1.36711-4.18109,0.84179-1.67408,1.74054-3.84248,3.39247-5.04694,1.87346-1.36964,1.00635-2.8836,4.89883-4.83047z'/%3E %3Cpath d='m935.703,411.88c0.43672,1.5861,1.22787,3.38867,1.51269,4.47034,0.29115,1.08103-0.21519,1.41838-0.50001,2.01839-1.51269,3.17222-3.1393,8.22865-3.39247,10.9578-0.13924,1.58611-1.22154,3.10006-1.72788,4.03742-0.55698,1.03357-0.34178,1.83105,0.93672,2.81145,0.61394,0.46837,2.59499-0.1443,2.81019-1.15319,0.72153,0.72027,2.01902,0.43229,2.59498-0.64938,0.65192,0.64938,1.73422,0.21646,2.45575-0.86457,0.64558,0.43229,1.58231-0.43292,1.94307-1.01015,1.01268,0.50508,2.09498-0.10759,2.12663-2.08991,0.006-0.39811,0.25317-1.08167,0.54431-1.55003,0.28482-0.469,0.39242-1.36965,0.36077-2.16333-0.038-0.79306,0.46836-2.37853,1.15192-3.49628,0.68356-1.11774,1.87346-3.10006,1.36712-4.97414-0.46837-1.74624-1.22155-1.58611-1.87346-4.10895-1.58231-1.65889-3.74691-3.9659-5.98113-4.1102-2.23422-0.14368-3.53171,1.37028-4.3292,1.87472z'/%3E %3Cpath d='m894.683,424.28c2.01902,2.0184,6.56342,2.09055,9.73437-1.29813-1.15192-0.50444-3.67729-1.65826-4.82921-2.59498-1.58864,1.5861-3.39247,3.38804-4.90516,3.89311z'/%3E %3C/g%3E %3Cpath fill='%23870f00' d='m915.089,195.026c0.79116-5.11846,4.41781-4.99757,6.70267-4.46971,0.93672,0.21646,3.2469,0.43229,5.40517-0.14431,4.27856-1.13989,7.50014,0.36077,7.06976,4.47035,1.15192,0.86457,2.37346,2.88296,2.15827,4.61401-0.2152,1.72978,0.14557,2.45068,1.73421,2.66651,1.58231,0.21709,4.97478,2.16333,2.73423,4.90263,2.1646,1.29812,3.82286,4.61401,2.67094,6.84887-1.15192,2.23485-4.61402,2.59562-6.05708,0.57659-1.58231,0.7209-4.18363,0.86521-5.76594-0.79242-1.0823,1.29686-3.82286,1.15319-4.3292,0-0.50001-1.15382-1.35446-1.77092-2.37346-2.09118-1.15825-0.36014-1.22788-3.53235,0.50001-3.89312-0.2152-0.93736-0.13925-2.01839,0.29114-2.52283s0.0696-1.4418-0.93673-2.23549c-1.01267-0.79305-1.87345-3.82096-0.8671-5.47859-1.72788,0.5766-5.55074-1.08166-6.3419-2.23485-0.79748-1.15382-1.87345-1.22534-2.59499-0.21646z'/%3E %3Cg fill='none'%3E %3Cpath d='m916.171,217.23c2.81018-0.36077,3.74691-2.09055,5.83556-1.94688'/%3E %3Cpath d='m910.184,209.401c0.18355,0.16202,0.41773,0.2943,0.68356,0.44051,0.56963,0.3076,1.1899,0.34305,1.76586,0.41457'/%3E %3Cpath d='m911.019,206.418c0.39242,0.13544,0.81014,0.33292,1.18357,0.719'/%3E %3Cpath d='m917.538,195.026c-1.65826-1.58611,2.81018-4.82984,7.50015-0.21646,0.87343,0.86141,3.09499,0.86584,3.7469,0.64875'/%3E %3Cpath d='m924.026,197.477c2.1646-0.50507,5.40517-0.50507,6.34189,1.94624,0.94306,2.45132,2.81652,0.86521,4.3292,3.74944,1.51269,2.88361,3.89249,6.12734,6.19633,3.89249'/%3E %3Cpath d='m931.741,213.698c-0.65191-0.86521-0.93673-2.73993-0.50634-4.03806-0.86711-1.00888-0.50634-3.09942,0-4.10894'/%3E %3Cpath d='m925.539,207.714c0.076,0.86521,1.22787,2.45132,3.0317,2.7393'/%3E %3Cpath d='m937.507,214.491c-1.00635-1.2975-0.86711-2.45068-0.64559-4.03742'/%3E %3Cpath d='m926.982,200.145c-0.0696,1.29749,0.72154,3.0279,2.08865,3.6045,0.29115,0.72027,1.73421,2.73929,4.61402,2.45131'/%3E %3Cpath d='m934.267,194.882c-1.58231-1.22788-3.72793-2.74057-6.56342-3.11462'/%3E %3Cpath d='m916.671,236.262c-2.44941,3.31652-4.03805,7.9299-2.8798,14.4186,1.15192,6.48874,3.02537,16.0048-1.73421,20.3302'/%3E %3Cpath d='m935.418,283.555c-3.31652-0.72027-8.07611-0.72027-10.6711,1.15382s-6.92419,2.01839-9.80399,0.57659'/%3E %3Cpath d='m928.425,283.339c-2.88613,0.50444-4.25325,2.52284-4.25325,7.85775,0,5.33492-1.15192,13.1205-0.14557,20.7624'/%3E %3Cpath d='m923.159,285.574c-1.87345,0.50444-3.81653,0.57596-3.45576,5.62289'/%3E %3Cpath d='m913.431,291.341c0.0696-3.10006,1.15192-5.98366,3.17095-5.47922'/%3E %3Cpath d='m934.191,291.918c0.14558-6.84887-1.36711-8.79511-3.38614-8.72295,2.74056,0.0721,4.60769,0.40697,5.76594,11.6066,0.8671,8.36283,2.61397,11.323,4.61401,17.8795,5.18998,17.0136,2.59499,43.2553,5.18998,52.4833'/%3E %3Cpath d='m930.228,293.936c5.47479,15.8611,8.36093,33.4513-0.57596,61.7113,6.05075,16.7256,12.1078,28.8366,13.2598,35.7583'/%3E %3Cpath d='m912.924,331.424c1.00635-3.60387-2.59498-4.03679,0.57596-16.725,1.37345-5.49631,1.58864-8.79511,0.72154-10.5255'/%3E %3Cpath d='m914.222,311.672c-1.2975,5.62352,4.18362,16.149,1.44306,23.7903'/%3E %3Cpath d='m908.886,336.904c0,4.90199,1.15192,11.2464,0.8671,16.149-0.29114,4.902,1.7089,7.17356,4.03806,11.823,8.36092,16.7256,14.0509,28.6588,13.2598,44.4091-0.13924,2.8836,0.86711,8.93942-2.15827,10.6692'/%3E %3Cpath d='m909.101,424.208c0.86711,0.0721,1.80384-0.36014,2.88614-2.95576s4.54439-18.1674,3.10132-28.8373'/%3E %3Cpath d='m916.817,404.527c0.43039,3.31589,0.43039,10.0926-1.72788,15.4275'/%3E %3Cpath d='m922.298,394.578c1.29749,7.06533,1.15192,13.4098,0.14557,17.8788'/%3E %3Cpath d='m919.412,412.456c0.14558,2.8836,1.44307,10.0932-0.72153,10.6705'/%3E %3Cpath d='m930.228,379.006c5.32922,8.36283,9.51285,28.9816,13.9813,33.3064'/%3E %3Cpath d='m934.842,408.996c-0.14558-2.30701-0.29115-5.47859-1.58864-6.92103'/%3E %3Cpath d='m877.24,308.067c0.0696-1.58674-0.2152-3.10069,1.51268-5.55137'/%3E %3Cpath d='m874.645,309.004c0.21519-5.55137,0.13924-6.05644,1.72788-7.5704'/%3E %3Cpath d='m872.411,309.148c0.0696-3.96464-0.43672-5.33492,1.15192-7.85838'/%3E %3Cpath d='m892.304,190.196c-0.61393,0.39621-4.21527,3.1355-5.72796,4.28932'/%3E %3Cpath d='m893.854,191.529c-0.68356,0.10759-2.66461,1.73041-6.19633,4.46971'/%3E %3Cpath d='m893.962,193.764c-1.11394,0.50444-3.24057,2.55955-5.18997,3.92919'/%3E %3Cpath d='m885.095,193.368c-0.53798,0.39621-1.58231,1.55003-2.08865,1.94624'/%3E %3Cpath d='m935.343,435.022c-0.3228-0.36076-0.3228-1.62281,0.25317-3.0279'/%3E %3Cpath d='m937.937,434.373c-0.39241-0.39621,0-2.12662,0.39875-3.24436'/%3E %3Cpath d='m940.393,433.508c-0.46837-0.21646-0.61394-1.22597,0.0696-2.59562'/%3E %3Cpath d='m942.336,432.498c-0.32279-0.10759-0.46836-0.64874,0.1076-2.23422'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m913.969,199.567c1.04432,1.36965,2.12662,1.22471,2.3165,2.10764,0.18988,0.88419,0.32912,0.94685,0.53165,1.20888,0.20254,0.2614-0.49368,0.20887-0.83545,0.0677-0.33545-0.14114-1.18357-0.12658-1.70257-0.11899-0.51267,0.008-1.1266-0.59874-0.74052-0.67026,0.37975-0.0709,0.32912-0.19051,0.27216-0.4595-0.057-0.26836,0.21519-0.69306,0.37342-0.77091,0.16456-0.0779,0.0506-0.0633-0.0949-0.42342-0.1519-0.36077-0.34178-1.2361-0.12025-0.94116z'/%3E %3Cpath d='m914.602,198.313c1.17091,0.13734,3.18994,0.76963,4.2849,1.98168,0.86077,0.95318,0.15823,0.70065-0.27849,0.73609-0.43672,0.0367-1.29117-0.27279-1.72155-0.81457-0.42406-0.54115-1.69624-1.22724-2.37347-1.40573-0.4114-0.10633-0.79748-0.60191,0.0886-0.49747z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23cf142b'/%3E %3Crect width='450' height='600' fill='%23fff'/%3E %3Cg%3E %3Cpath fill='%23e60d2e' d='m22.222,82.828,0,45.457,45.455,0c0,7.5741,7.5762,15.151,15.152,15.151v45.454h45.452v-45.454c7.5762,0,15.152-7.5766,15.152-15.151h45.455v-45.457h-45.455c0-7.5741-7.5762-15.151-15.152-15.151v-45.454h-45.452v45.454c-7.5762,0-15.152,7.5766-15.152,15.151h-45.455z'/%3E %3Cpath fill='%2396877d' d='m25.254,85.857,0,39.397,45.452,0c0,7.5738,7.5762,15.15,15.152,15.15v45.454h39.392v-45.454c7.5762,0,15.152-7.5766,15.152-15.15h45.452v-39.397h-45.452c0-7.5741-7.5762-15.151-15.152-15.151v-45.454h-39.392v45.454c-7.5762,0-15.152,7.5766-15.152,15.151h-45.452z'/%3E %3Cpath fill='%23ccc' d='m26.77,87.373,0,36.364,45.452,0c0,7.5741,7.5762,15.153,15.152,15.153v45.454h36.362v-45.454c7.5762,0,15.152-7.5791,15.152-15.153h45.452v-36.364h-45.452c0-7.5738-7.5762-15.15-15.152-15.15v-45.454h-36.362v45.454c-7.5762,0-15.152,7.5766-15.152,15.15h-45.452z'/%3E %3Cg id='vi' fill='%23d0d0d0'%3E %3Cpath fill='%2396877d' d='m84.536,71.681c2.6626,2.6628,1.9431,7.6994-1.6071,11.25-3.5502,3.5503-8.5867,4.2698-11.249,1.6072-2.6626-2.6626-1.9431-7.6994,1.6071-11.25,3.5502-3.5501,8.5867-4.2698,11.249-1.6072z'/%3E %3Cpath d='m71.143,79.715,1.0712-1.0722,4.2856,2.1422-2.143-4.2853,1.0714-1.0722,4.2855,8.5711-8.5708-4.2856z'/%3E %3Cpath d='m77.572,73.287,1.0714-1.0714,6.4282,6.4283-1.0714,1.0714z'/%3E %3C/g%3E %3Cuse xlink:href='%23vi' transform='rotate(90,105.555,105.557)'/%3E %3Cuse xlink:href='%23vi' transform='rotate(180,105.555,105.557)'/%3E %3Cuse xlink:href='%23vi' transform='rotate(270,105.555,105.557)'/%3E %3Cg fill='none' stroke='%2396877d' stroke-width='0.514'%3E %3Ccircle cx='105.555' cy='105.557' r='31.822'/%3E %3Ccircle cx='105.555' cy='105.557' r='24.245'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Ccircle cx='93.434' cy='131.31' r='1.515'/%3E %3Ccircle cx='117.675' cy='131.31' r='1.515'/%3E %3Cpath d='m104.55,131.31,0,1.5798-2.0203,0c-2.0203,0-2.0203,1.5798,0,1.5798h2.0203v1.5798c0.007,1.637,1.7632,1.8358,1.8917,0.13718l0.12826-1.7078h2.0203c2.02,0,2.02-1.5798,0-1.5798h-2.0203v-1.5798c0-1.5798-2.02-1.5798-2.02,0z'/%3E %3Cpath d='m75.954,113.4,2.0836-0.49669-0.23018-0.96558c-0.05274-0.22154-0.14029-0.37212-0.26261-0.45176-0.12227-0.0796-0.33208-0.10192-0.62945-0.0669l-0.03456-0.14462,1.7943-0.42772,0.03456,0.14462c-0.20528,0.0516-0.35004,0.11445-0.43437,0.18823-0.08431,0.0738-0.13986,0.16141-0.16664,0.26283-0.02678,0.10141-0.01904,0.24072,0.02319,0.41794l0.23018,0.96558,1.6653-0.39698c0.26844-0.064,0.44162-0.12317,0.51955-0.17754,0.05893-0.0416,0.10192-0.10968,0.12895-0.20426,0.03521-0.12958,0.0379-0.25691,0.0081-0.38202l-0.04572-0.19152,0.14462-0.0346,0.54235,2.2752-0.14462,0.0346-0.04465-0.18767c-0.05228-0.21889-0.15392-0.36268-0.30524-0.43127-0.0983-0.0427-0.30644-0.0261-0.62439,0.0497l-3.4245,0.81632c-0.26844,0.064-0.44161,0.12317-0.51955,0.17753-0.05893,0.0416-0.10222,0.10838-0.1299,0.20035-0.03582,0.12697-0.03853,0.25431-0.0081,0.38201l0.04465,0.18768-0.14462,0.0346-0.94026-3.9444,1.1528-0.32851,0.03261,0.13683c-0.23143,0.12678-0.39442,0.24896-0.48896,0.3665-0.09453,0.11756-0.15218,0.24837-0.17294,0.39239-0.02075,0.14403,0.0018,0.35418,0.06766,0.63043l0.27863,1.1689zm-1.3422-9.402c0.03979-0.70618,0.34243-1.303,0.90792-1.7904,0.56549-0.48738,1.2495-0.70846,2.052-0.66326,0.82656,0.0466,1.498,0.34604,2.0143,0.89839,0.5163,0.55236,0.75358,1.199,0.71183,1.94-0.0422,0.74898-0.34381,1.3633-0.90484,1.8428-0.56102,0.47958-1.2642,0.69556-2.1095,0.64794-0.864-0.0487-1.5523-0.38264-2.0648-1.0019-0.44467-0.53759-0.64696-1.1622-0.6069-1.8737zm0.28861,0.0927c-0.02742,0.48684,0.13113,0.88756,0.47566,1.2021,0.42874,0.39179,1.0765,0.6121,1.9431,0.66093,0.88808,0.05,1.5822-0.10137,2.0824-0.45424,0.38022-0.27106,0.58382-0.64601,0.6108-1.1248,0.02878-0.51091-0.14672-0.94411-0.52652-1.2996-0.3798-0.35548-0.99903-0.55741-1.8577-0.6058-0.93088-0.0524-1.6353,0.0917-2.1134,0.43237-0.38036,0.27376-0.58517,0.67009-0.61441,1.189zm7.894-9.9511-0.5176,1.3596-3.0375,0.8174c-0.04359,0.12962-0.08066,0.23448-0.11117,0.3146-0.0124,0.03256-0.02636,0.06738-0.04191,0.10444-0.01555,0.03709-0.03221,0.07518-0.04997,0.11428l1.4798,0.56335c0.3205,0.12201,0.5329,0.16274,0.63721,0.12218,0.14641-0.05317,0.25581-0.17496,0.32826-0.36525l0.07577-0.19905,0.13896,0.0529-0.83073,2.1821-0.13896-0.0529,0.07293-0.19155c0.08198-0.21532,0.07048-0.39601-0.03445-0.54204-0.05761-0.08213-0.23164-0.17848-0.52208-0.28906l-3.2901-1.2525c-0.32049-0.12201-0.5329-0.16274-0.63721-0.12218-0.14736,0.05566-0.25771,0.17998-0.33112,0.37276l-0.07293,0.19155-0.13896-0.0529,0.70634-1.8554c0.2059-0.54083,0.39713-0.92456,0.57371-1.1512,0.17658-0.22662,0.40474-0.38916,0.68447-0.48765s0.56608-0.09195,0.85903,0.01957c0.31299,0.11916,0.54581,0.32462,0.69848,0.61637,0.15267,0.29177,0.19508,0.66984,0.12722,1.1342l1.8614-0.49542c0.42703-0.11264,0.72853-0.23431,0.90446-0.36521,0.17594-0.13082,0.33184-0.32948,0.46769-0.59598l0.13896,0.0529zm-3.9947,2.6203c0.01811-0.04758,0.03447-0.08865,0.04906-0.12322,0.01461-0.03458,0.02618-0.06313,0.03477-0.08567,0.18493-0.48575,0.21917-0.89198,0.10274-1.2187-0.1164-0.32671-0.3374-0.55201-0.66291-0.67593-0.31799-0.12105-0.6144-0.11994-0.88925,0.0033-0.27484,0.12328-0.47469,0.34893-0.59956,0.67693-0.05529,0.14523-0.10632,0.35084-0.15312,0.61683l2.1183,0.80642zm11.596-18.053,1.0531,1.3672-0.11806,0.07646c-0.35222-0.2826-0.68176-0.4538-0.98862-0.51362-0.4425-0.08686-0.87738,0.0081-1.3046,0.28477-0.58242,0.37723-0.87613,0.89464-0.88114,1.5522-0.0021,0.55362,0.17083,1.0991,0.51894,1.6366,0.28254,0.43626,0.62467,0.77966,1.0264,1.0302,0.40168,0.25056,0.79339,0.37113,1.1751,0.3617,0.38172-0.0094,0.71651-0.10735,1.0043-0.29378,0.16864-0.10923,0.31785-0.23619,0.44759-0.38087,0.12973-0.14467,0.24074-0.30595,0.33302-0.48382l-0.85639-1.3223c-0.14856-0.22936-0.26321-0.36818-0.34394-0.41644-0.08075-0.04825-0.16966-0.06726-0.26677-0.05704-0.09711,0.01023-0.23785,0.07513-0.42227,0.19448l-0.08302-0.12817,1.7709-1.147,0.08302,0.12817-0.08432,0.05462c-0.1754,0.1136-0.25784,0.25-0.24732,0.40916,0.0089,0.11233,0.09274,0.29106,0.2515,0.53617l0.90664,1.3998c-0.16831,0.30692-0.35727,0.57454-0.56689,0.80287-0.20962,0.22834-0.46847,0.44227-0.77654,0.6418-0.88375,0.57238-1.7385,0.7238-2.5643,0.45423-0.61932-0.20217-1.1089-0.58098-1.4686-1.1364-0.26069-0.40252-0.41379-0.8508-0.45924-1.3449-0.05463-0.58706,0.04172-1.1283,0.28906-1.6236,0.20835-0.41264,0.54077-0.7668,0.99726-1.0625,0.1664-0.10776,0.32637-0.19222,0.4799-0.25335,0.15351-0.0612,0.38497-0.12637,0.69427-0.1959,0.15647-0.03441,0.25611-0.0654,0.29888-0.09297,0.04269-0.02776,0.06653-0.071,0.07138-0.13003,0.0049-0.059-0.02647-0.14805-0.09404-0.26709l0.1248-0.08083zm8.8735,0.61442-2.039,0.5422-0.1363,0.92615c-0.03364,0.22797-0.03703,0.39242-0.01019,0.4934,0.02126,0.08029,0.07829,0.14067,0.17086,0.1812s0.26812,0.03612,0.52668-0.01322l0.03817,0.14372-1.6584,0.44098-0.03817-0.14372c0.20976-0.09736,0.33873-0.18572,0.38694-0.26507,0.099-0.1594,0.17816-0.45074,0.23748-0.87404l0.70002-4.827,0.13591-0.0362,2.9981,3.8935c0.24122,0.31289,0.43597,0.50576,0.58426,0.5786,0.14827,0.07285,0.33159,0.08718,0.54994,0.04297l0.0382,0.14372-2.0778,0.55252-0.03817-0.14372c0.20698-0.06609,0.33943-0.13878,0.39738-0.21796,0.058-0.07918,0.0756-0.16149,0.0529-0.24693-0.0303-0.11391-0.12993-0.2801-0.2989-0.49854l-0.51986-0.67266zm-0.18516-0.25849-1.4592-1.8908-0.35063,2.3721,1.8099-0.48127zm9.6209-0.02828,0.13143,0.03327-0.52332,1.4597-4.2165-0.16404,0.006-0.14858,0.20481,0.008c0.23023,0.009,0.39779-0.0596,0.50268-0.20567,0.0596-0.08349,0.0954-0.28049,0.10745-0.59105l0.1367-3.5138c0.0132-0.34-0.016-0.55428-0.0876-0.64287-0.0998-0.12186-0.25281-0.18679-0.45895-0.19481l-0.20481-0.008,0.006-0.14858,2.4657,0.09592-0.006,0.14858c-0.28903-0.01392-0.49287,0.005-0.61151,0.05664-0.11865,0.05169-0.20105,0.11954-0.24721,0.20354-0.0462,0.08402-0.0756,0.28798-0.0882,0.61191l-0.1331,3.4214c-0.009,0.2222,0.007,0.37563,0.0465,0.46029,0.0299,0.05749,0.0778,0.10089,0.14374,0.13026,0.0659,0.02938,0.27418,0.05088,0.62489,0.06453l0.39756,0.01547c0.41764,0.01626,0.71198-0.0031,0.88304-0.05815,0.17109-0.05493,0.32924-0.15811,0.47454-0.30932,0.1453-0.15119,0.29412-0.39275,0.44646-0.72466zm7.2573,1.942,0.11707,0.06835-0.90692,1.2578-4.0064-1.3248,0.0467-0.14118,0.1946,0.06436c0.21875,0.07234,0.39874,0.05284,0.53997-0.05847,0.0803-0.06374,0.16929-0.24314,0.26686-0.53821l1.104-3.3386c0.10682-0.32305,0.13808-0.53705,0.0938-0.642-0.0622-0.14473-0.19123-0.24947-0.38709-0.31424l-0.1946-0.06436,0.0467-0.14118,2.3428,0.7747-0.0467,0.14118c-0.27388-0.09339-0.47498-0.13166-0.60329-0.11484-0.12831,0.01684-0.22625,0.05931-0.2939,0.12715-0.0676,0.06794-0.15231,0.25582-0.25409,0.56359l-1.075,3.2509c-0.0698,0.21112-0.0974,0.36285-0.0828,0.45516,0.0128,0.06352,0.0469,0.11852,0.10206,0.16497,0.0552,0.04647,0.24939,0.12479,0.58261,0.23499l0.37774,0.12491c0.39682,0.13122,0.68503,0.19407,0.86463,0.18856,0.17959-0.0055,0.36014-0.06081,0.54163-0.16584,0.18148-0.10507,0.39135-0.29599,0.62961-0.57275zm5.8487,3.0973-1.7221-1.2189-0.79864,0.48837c-0.19664,0.12013-0.32513,0.22285-0.38549,0.30813-0.048,0.06779-0.0579,0.15021-0.0298,0.24726,0.0282,0.09704,0.14395,0.22907,0.34742,0.39607l-0.0859,0.12138-1.4007-0.99138,0.0859-0.12137c0.2091,0.09875,0.35956,0.14125,0.45138,0.12746,0.18582-0.02604,0.46028-0.15182,0.82341-0.37729l4.1557-2.5533,0.11481,0.08126-1.0706,4.796c-0.0858,0.38563-0.10928,0.65872-0.0703,0.81927,0.039,0.16053,0.14539,0.31051,0.31915,0.44992l-0.0859,0.12138-1.7549-1.2421,0.0859-0.12138c0.18331,0.11663,0.32394,0.17185,0.42187,0.16566,0.0979-0.0062,0.17241-0.04539,0.22351-0.11752,0.0681-0.09623,0.13193-0.27916,0.19151-0.54882l0.18376-0.83003zm0.08-0.30775,0.51785-2.3316-2.0464,1.2496,1.5286,1.0819zm6.4627,1.191,0.88066,1.1881-1.2996,5.1103,2.5247-1.8714c0.26904-0.19942,0.41459-0.35399,0.43665-0.46372,0.0314-0.14663-0.0168-0.30606-0.14439-0.47825l-0.11246-0.15174,0.11946-0.08854,1.1295,1.5239-0.11946,0.08854-0.11487-0.15497c-0.13721-0.18511-0.29049-0.27492-0.45985-0.26945-0.10398,0.0037-0.27868,0.0964-0.52401,0.27837l-3.6903,2.7353-0.0862-0.11622,1.3862-5.4996-2.6959,1.9982c-0.26905,0.19942-0.41539,0.35292-0.43904,0.4605-0.0298,0.14879,0.0183,0.30822,0.14439,0.47825l0.11487,0.15497-0.11946,0.08854-1.1295-1.5239,0.11946-0.08854,0.11247,0.15174c0.13879,0.18726,0.29287,0.27815,0.46223,0.27267,0.10397-0.0037,0.27868-0.0964,0.52402-0.27835l3.0445-2.2567c0.0544-0.23707,0.0809-0.40598,0.0796-0.50673-0.001-0.10075-0.0286-0.22977-0.0818-0.38707-0.0269-0.07677-0.0874-0.17867-0.18154-0.30565l0.11946-0.08854zm6.871,12.662-1.1847,0.48309-0.0508-0.144c0.20233-0.10285,0.34047-0.19436,0.41442-0.27451,0.11879-0.13013,0.1899-0.27253,0.21334-0.42717,0.0234-0.15465-0.002-0.33806-0.0774-0.55022l-0.2561-0.72361-3.925,1.3887c-0.31574,0.11164-0.50066,0.2155-0.55483,0.3114-0.0721,0.13351-0.0729,0.30003-0.002,0.49957l0.0629,0.17808-0.14018,0.04957-0.77076-2.1785,0.14019-0.04957,0.0644,0.18184c0.0769,0.2172,0.19703,0.34805,0.36054,0.39251,0.10048,0.02697,0.2947-0.01047,0.58263-0.11236l3.925-1.3887-0.2184-0.61758c-0.0849-0.23993-0.16291-0.40418-0.23401-0.4927-0.0944-0.11436-0.22643-0.19414-0.39587-0.23933-0.16946-0.0452-0.3735-0.03554-0.61212,0.029l-0.0508-0.144,1.2262-0.36564,1.4839,4.194zm-4.3136,9.6659-0.0755-1.4528,2.4487-1.9744c-0.0125-0.13618-0.0209-0.24707-0.0254-0.33268-0.002-0.0348-0.003-0.0722-0.004-0.11247-0.00067-0.0402-0.00091-0.0818-0.00045-0.12474l-1.5813,0.0822c-0.34247,0.0178-0.55323,0.0663-0.63228,0.14555-0.11245,0.10779-0.16337,0.26336-0.1528,0.46671l0.0111,0.21271-0.14849,0.008-0.12122-2.3318,0.14849-0.008,0.0106,0.20469c0.012,0.2301,0.0954,0.39075,0.25042,0.48195,0.0859,0.0519,0.28397,0.0697,0.59434,0.0536l3.5157-0.18276c0.34247-0.0178,0.55323-0.0663,0.63229-0.14554,0.11228-0.11047,0.16309-0.26871,0.15238-0.47473l-0.0106-0.20467,0.14849-0.008,0.10307,1.9826c0.03,0.57792,0.01,1.0062-0.06,1.2848-0.07,0.27863-0.21311,0.51947-0.42924,0.72253-0.21615,0.20305-0.48074,0.31272-0.79378,0.32899-0.33444,0.0174-0.63041-0.0765-0.8879-0.28181-0.25749-0.20526-0.44896-0.53401-0.57442-0.98625l-1.5028,1.2049c-0.34518,0.27549-0.57183,0.50861-0.67995,0.69934s-0.17053,0.43543-0.1872,0.73409l-0.14849,0.008zm2.5964-4.0103c0.003,0.0508,0.004,0.095,0.005,0.13254,0.00064,0.0375,0.002,0.0683,0.003,0.0924,0.027,0.51906,0.1597,0.90452,0.39806,1.1564,0.23845,0.25186,0.53158,0.36875,0.87941,0.35067,0.33979-0.0177,0.61052-0.13838,0.81217-0.36215,0.20164-0.22378,0.29336-0.5109,0.27514-0.8614-0.008-0.15519-0.0444-0.3639-0.10902-0.62613l-2.2635,0.11767zm1.4941,11.21-0.48239,1.8386-0.14382-0.0377,0.0265-0.10106c0.0177-0.0674,0.0137-0.17368-0.0119-0.31889s-0.0803-0.28555-0.16376-0.42104c-0.0836-0.1355-0.23063-0.31396-0.4412-0.53539l-1.6684-1.7964-1.3216-0.34676c-0.32394-0.085-0.53559-0.10174-0.63496-0.0503-0.13468,0.0699-0.2299,0.21113-0.28565,0.42363l-0.0449,0.17104-0.14382-0.0377,0.58744-2.239,0.14382,0.0377-0.049,0.1866c-0.0585,0.22285-0.0326,0.39862,0.0777,0.52727,0.068,0.0788,0.24967,0.15691,0.54509,0.23442l1.2478,0.32737,2.5873-0.86676c0.30401-0.10305,0.49641-0.17651,0.57717-0.22043,0.0807-0.044,0.19165-0.14983,0.33267-0.31782,0.0395-0.045,0.0722-0.11677,0.098-0.21525l0.14383,0.0378-0.59152,2.2546-0.14382-0.0377,0.0306-0.11662c0.0319-0.12181,0.0328-0.24136,0.003-0.35868-0.0302-0.11731-0.10225-0.19095-0.21628-0.22086-0.0933-0.0245-0.28248,0.0104-0.56755,0.10454l-1.9874,0.65431,1.3536,1.4603c0.20279,0.21939,0.3638,0.34473,0.48301,0.37601,0.0726,0.019,0.14227,0.0172,0.20915-0.005,0.0669-0.0226,0.12568-0.0647,0.17643-0.12614,0.0508-0.0615,0.0945-0.16218,0.1312-0.30212l0.14382,0.0377z'/%3E %3C/g%3E %3Cg fill='%2396877d' stroke='%23000' stroke-width='0.203'%3E %3Cpath d='m122.85,110.19c0.53163-0.13451,1.4092-0.0256,1.4092-0.0256s0.0769,0.3651-0.15373,0.4868c0.25621,0.14732,1.1786,0.10248,1.1786,0.10248s-0.3587,0.27543-0.53804,0.38431c0.33307,0.032,0.743,0.46118,0.743,0.46118s-0.76862,0.1281-1.1017-0.0512c0.20497,0.40993,0.17935,0.76863,0.17935,0.76863s-1.2426-0.30745-1.691-1.1273'/%3E %3Cpath d='m120.77,109.49c-0.30104,0.74301-2.5108-0.64052-2.5108-0.64052s0.9736,1.5437,2.434,1.7166'/%3E %3Cpath d='m93.181,123.66,25.877,0,1.9984-1.5885-3.3307-1.7935-5.1242-1.7422-2.0497-1.1273-3.7919,0.20497-3.177,1.691-4.3556,0.51242-1.0248,1.1786-3.2282,0.25621-5.0729-0.10248,8.4549,1.3323-6.9689-0.3587,1.7935,1.5373z'/%3E %3Cpath d='m107.12,116.23c-3.241-1.7422-4.189,2.5493-5.5854,3.5869,1.8831,0.32026,3.3051-1.4476,4.9192-2.3059,1.224,3.333,3.1514,1.1273,3.1514,1.1273s2.0112,3.1898,4.6886,1.7422c0.73019,0.55085,1.5372,0.0512,1.5372,0.0512s0.9736,0.17935,1.1786-0.25621c0.51241,0.17935,1.0761-0.46117,1.0761-0.46117s1.1145,0.0128,1.3323-0.56366c1.6526,0.29464,3.8431-3.382,3.8431-3.382l0.66615-1.281,0.97359-0.20497s0.0641-0.64052-0.46118-0.6149c-0.0128-0.38432-0.34588-0.58929-0.81986-0.51242,0.0897-0.23059-0.25621-0.40994-0.25621-0.40994-0.92236,0.23059-0.9736,2.5621-0.9736,2.5621s-1.6141,1.2298-2.2034,1.5372c-0.0256-1.3323-2.2546-3.1386-1.7935-3.9969,0.46117-0.8583,1.9088,1.3195,3.177,0.92235,1.2682-0.39712,1.8914-2.0468,1.9472-3.3307-0.35869-0.87111-1.2298-2.3059-1.2298-2.3059l-0.81987-0.0512-0.71739-1.7422s-1.5116,0.98641-1.486,1.8447c0.0256,0.8583,1.5885,1.5885,1.5885,1.5885s-0.90121,0.56325-1.7422,0.30745c-0.0769,0.87111,1.0248,0.70457,1.4348,0.71738,0.20497,0.62771,0.81987,0.9736,0.81987,0.9736s0.38432,0.96078-0.6149,0.87111c-0.99922-0.0897-2.1781-2.3919-3.5869-1.3323-1.4988,1.1273,0.66614,3.177,0.66614,3.177s-1.3195,0.69176-2.1009,2.4596c-3.1898-2.6902-5.0601-1.4348-8.6086-0.71739z'/%3E %3Cpath d='m102.46,111.67c1.3323,1.2554,0.40316,3.3422,0.92235,3.7407,0.55085,0.42274,1.3323-0.20497,1.3323-0.20497,1.3963,0.37151,3.8944-0.40993,3.8944-0.40993,1.0994,0.61473,0.66541-0.29241,1.3323-0.25621,0.58928,1.5116,2.5621,1.2298,2.5621,1.2298s-1.8063-1.8447-2.9208-2.3571c-0.8583,0.51242-3.3564,0.58928-3.7919,0.51242-0.48533-0.0857-0.17935-0.67896-0.40994-1.0248,0.91849-0.89406,0.19216-3.1129-0.30745-3.9456-2.036-1.3563-4.4684,0.96777-2.6133,2.7158z'/%3E %3Cpath d='m93.599,107.92c-1.6758,0.45291-4.5835-2.165-5.9423-1.1595s-0.72467,3.4784,0.18117,4.7104c0.885,1.2036-1.2953,1.6396-1.8841,2.3552-0.55353,0.67276,0.18117,1.4493,0.18117,1.4493l0.61597,0.39857-0.1087,0.90583,0.3261,1.087s0.29892,0.26269,0.39857-0.0725c0.28081,0.28081,0.02966,1.0928,0.72467,1.1957-0.24887-0.52003,0.18117-1.9566,0.18117-1.9566s1.2138,0.0906,1.5218-0.4348c0.30798-0.52539-0.28987-1.6667-0.28987-1.6667h0.36233c-0.40763-0.28081-0.5435-1.1232-0.5435-1.1232s1.6849-0.53444,1.6667-1.8117c-0.01812-1.2772-2.7356-2.636-1.7392-3.2972,1.1051-0.73373,3.0255,1.9023,4.6741,0.68844,1.6315-1.2012,0.57974-0.0362,0.57974-0.0362s0.74569-1.6783-0.90584-1.2319z'/%3E %3Cpath d='m102.25,89.971c-2.2418-0.93516-6.8216-0.99281-9.3773-2.2546-1.1209,0.07046-1.6205,0.95438-1.6654,1.3067-1.1722-0.05765-1.9664,1.7871-1.7935,2.1522-2.1329-0.86471-3.1258,2.5108-2.434,3.2026-1.8191,0.07686-1.5949,2.402-1.7678,3.0489-0.58288,1.4156,0.1298,1.8919,1.281,1.3835,0.17294,0.6149-0.06911,0.95934-0.58928,1.0761,3.1575,3.6133,4.9421-2.2236,7.7119-2.2034,3.4583-1.0124,4.8167-2.7158,4.8167-2.7158l1.3579,0.17934s2.4596-5.1754,2.4596-5.1754z'/%3E %3Ccircle cx='105.145' cy='87.384' r='3.305'/%3E %3Cpath d='m99.33,113.41c-2.0497-0.37151-5.4444-2.498-5.7903-5.2779,1.9088-7.4941,11.755-3.5807,12.604-9.2173-0.21639-3.7187,0.44951-7.3999,2.5119-10.511,0.96079-1.217,2.2034-1.5373,2.2034-1.5373s0.22257,0.79372-0.10248,1.3323c1.6269-0.17935,3.856,0.7302,5.3804,0.81987,0.44837,0.90954,0.40994,1.2426,0.30745,1.7935-0.10248,0.55085-0.71738,0.40993-0.71738,0.40993-0.39767,0.37723-0.87565,0.76105-1.9472,0.56366-0.80706,0.6149-2.5108,0.76863-2.5108,0.76863s3.5613,3.7535,2.972,4.9192c0.74301,0.34588,1.8447,1.9984,1.8447,1.9984s2.434-1.281,3.2282-2.4596c1.4092,0,3.715,1.4732,4.868,1.6397,1.4092,1.1401,2.8183,2.3059,2.8183,2.3059s-1.6782,1.1017-2.4084-0.3587c-0.88392,0.0769-2.7927-2.0369-5.4316-1.3835-0.0769,2.3443-2.6646,3.9969-2.6646,3.9969s2.4153-0.33802,3.7406,0.46117c1.3707,1.153,3.382,2.7158,3.382,2.7158l1.7935,3.0745s-1.6397,0.28183-2.2546-1.8447c-0.61491,1.7166-0.64052-1.0633-3.0745-2.3571-0.74301,0.0897-1.1145,0.14092-1.7422-0.35869-1.755,0.47399-3.8303,1.4988-6.3028,1.2298-1.755,0.55085-3.0361,2.0112-4.8167,2.8183-1.7807,0.80706-2.3059,0.40993-2.3059,0.40993l-1.4348,0.0512c-0.20699,0.86376-0.0897,2.1778-0.87111,2.4084,0.49961,0.53804-0.35869,2.8311-1.2298,3.2282,0.40993,1.4732,1.6108,1.9242,2.8695,2.6646,0,0,1.1145-0.51241,1.8447,0.15373,0.73019,0.66614,1.486,2.5621,1.486,2.5621s-1.5197,0.10268-1.9984-0.10248c-0.47871-0.20516-0.52523-0.70458-1.0761-0.56366-3.4716-3.0873-5.3024-1.8593-5.6366-2.5621-0.34252-0.72035,0.81987-2.6005,0.46118-3.7919z'/%3E %3Cpath d='m90.99,99.655c0.18117-0.22646,1.4493,0.25363,1.4493,0.25363l2.3189,1.4493,4.7104,3.0436,1.6667,2.4276-3.0074-0.9783-4.1668-3.5871-2.2465-1.4493s-0.90584-0.93301-0.72467-1.1595z'/%3E %3Cpath d='m118.85,107.37c-1.6269-0.40994-5.6366,4.458-5.6366,4.458l3.0233,3.2795s0.0897-5.5854,2.6133-7.7375z'/%3E %3Cpath d='m99.023,93.789c-0.88723,1.1368-0.96662,3.4287,0.18756,4.3531,0.10881,1.3911,1.2915,4.1971,2.2208,4.4605,1.0153,0.28784,5.0729,1.2298,6.6614,0.97359-0.30381,2.5745,1.7164,4.641,3.5869,5.9953-0.0136,0.23103-0.0168,0.51306,0.19928,0.79864,0.20936,0.27664,1.1923,0.32734,1.2355,0.17495,0.43591,0.6126,2.5473,0.88157,2.7003,0.60869,0.14884-0.26552-3.1056-2.5307-3.8276-3.222-0.6133-1.1442-1.7749-3.6938-2.0497-5.7391-1.5973-1.9003-4.3395-1.8623-4.3395-1.8623l0.0864-3.7231,0.15373-4.2018-1.486-0.76863s0.29956-0.13652,0.46117-0.30745c0.36089,0.15517,1.0391-0.56988,1.1273-0.77484,0.34187,0.12113,0.65138,0.11952,0.71117-0.06314,0.0528-0.16132,0.11399-0.87942,0.23863-1.2505,1.1211-0.98705-0.16365-3.08-1.8778-3.1144-1.6961-0.03441-2.0765,2.0232-2.044,2.1796,0.15932,0.64556,0.12499,0.97102,0,1.1273-0.12777,0.15976-0.71739,0.51242-0.71739,0.51242s-0.94797-0.44837-2.1009,0-2.4468,1.0505-2.5108,1.7935c-0.52523,0.07686-1.3835,0.75582-1.5373,1.3323-0.46118-0.08967-1.0633,0.29464-2.0497,1.8959-1.7678,0.78144-1.8703,4.5605-1.8703,4.5605s-0.47719,0.69496-0.49961,1.0633c-0.02242,0.3683,0.16654,0.70458,0.39712,0.64053,0.02562,0.24339,0.34588,0.46117,0.4868,0.38431,0.05124,0.2434,0.40298,0.37952,0.6149,0.34588,0.01922,0.16654,0.70137,0.12491,0.75582-0.0256,0.06008-0.16611-0.0675-0.99692,0.0128-1.0633,0.07366-0.0609,0.64052,0.37151,0.79425,0.25621,0.15373-0.11529-0.02936-0.48449-0.11529-0.62771-0.07686-0.12811-0.56366-0.26902-0.67895-0.87111s0.30745-1.4348,0.30745-1.4348,1.9216-1.5116,2.1393-2.8055c1.4476,0.14092,2.213-1.1241,2.6261-1.6013z'/%3E %3Cpath d='m95.679,88.37c0.43876-1.0729,2.0241-0.97359,2.0241-0.97359s0.56686-1.4924,2.703-0.60209c0.80386-0.62131,2.9208,0.26902,2.9208,0.26902s0.7927-1.0562,1.8319-0.93516c1.9248,0.22418,2.245,1.9888,2.1265,2.2931-1.0537,0.26582-2.879-0.85629-4.2659-0.53804-0.81026,0.45797-2.1233,0.94157-2.6133,1.6013-1.2842,0.13451-2.655-1.1818-4.7271-1.1145z'/%3E %3Cpath d='m99.689,90.151c0.4804-0.29464,1.6588-0.81262,2.4596-0.17935,0.83908,0.90314,2.1265,1.7422,2.1265,1.7422l1.4604,0.6149,0.66614,0.40994-0.43556,6.6871c-1.3518-1.3831-2.6186-1.6253-3.5869-3.2539-0.51883-0.69817-0.1217-2.3763-1.0248-3.4844-0.90314-1.1081-1.8639-1.8575-1.6654-2.5365z'/%3E %3Cpath d='m103.2,92.082s0.76544-0.14493,0.97831,0.03623c0.26722,0.09058,0.52538,0.16758,0.59785,0.39857,0.28987,0.08605,0.48915,0.23552,0.48915,0.45292,0.27175,0.07247,0.38045,0.56162,0.38045,0.56162l-0.25363,0.38045s-0.28987-0.27175-0.3261-0.56162c-0.1834-0.09031-0.5888-0.1857-0.68844-0.45292-0.31704-0.0317-0.52085-0.19476-0.57973-0.47104-0.2944,0.06794-0.59786-0.34422-0.59786-0.34422z'/%3E %3Cpath d='m109.68,87.717c-0.43556-0.4868-1.2042-0.1281-1.2042-0.1281l-2.0497,3.5357-0.89673,0.74301-0.0769,2.7671,0.743,2.5877-0.25621,1.9984s1.0322-0.96837,1.153-1.5116c0.11529-0.51882-0.38432-2.2034-0.38432-2.2034s-0.6149-1.0505,0.12811-2.9976c0.743-1.9472,2.434-3.5613,2.8439-4.7911z'/%3E %3Cpath d='m114.74,90.868s-3.2003,4.5733-8.4398,6.2003c-1.4476,0.34588-0.92236-3.382-0.92236-3.382l-0.35869,0.10248s-0.80706,3.651,1.1273,3.6894c5.2651-1.0376,9.2156-6.5806,9.2156-6.5806l-0.63-0.028z'/%3E %3Cpath d='m116.91,117.16s-0.4868,0.3587-1.1273,0c-0.33307-0.76862-1.2298-0.81987-1.2298-0.81987s-0.57758-1.6593-1.486-1.1786c-0.14091-0.8583-1.1273-0.40993-1.1273-0.40993s-0.0256-1.2426-1.1786-1.0761c0.38431-1.422-1.5885-1.3323-1.5885-1.3323s-0.064-1.6013-2.972-1.281c6.2643-2.8055,11.222,4.4068,11.222,4.4068'/%3E %3Cpath d='m119.88,117.77s1.4476,1.6269,2.2034,1.6397c0.75582,0.0128,0.81987-1.5885,0.81987-1.5885s0.2434,0.69176,0.6149,0.51242c-0.0384,0.48679,0.46118,0.6149,0.46118,0.6149s-1.3067,3.0361-5.0217,0.15372'/%3E %3Cpath d='m108.55,118.39-0.51242,2.1009s-0.65333,0.58928-0.46118,0.71739c0.19216,0.1281,1.2298-0.20497,1.2298-0.20497s1.6141-0.19215,2.1009-0.66614c0.33308,0.75582,1.0761,0.81987,1.0761,0.81987s0.0512-0.32026-0.0512-0.51242c0.35869,0.0641,0.66615-0.0512,0.66615-0.0512s0.20496-0.58929-0.25621-0.81987c0.0512-0.43556,0.26901-0.81987-0.51242-0.76863-0.57647,0.6149-1.9984,1.3195-2.3571,1.0761-0.35869-0.2434,1.4092-1.0248,0.92236-2.0497'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 6 4'%3E %3Crect fill='%2300A551' width='6' height='4'/%3E %3Crect fill='%23FFD500' width='6' height='3'/%3E %3Crect fill='%231A206D' width='6' height='2'/%3E %3Crect fill='%23EA2839' width='6' height='1'/%3E %3C/svg%3E"

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='720' height='480'%3E %3Crect fill='%23D21034' width='720' height='480'/%3E %3Cg fill='%23007E3A'%3E %3Crect width='480' height='240' x='120' y='120'/%3E %3Ccircle fill='%23FFF' cx='390' cy='240' r='80'/%3E %3Ccircle cx='420' cy='240' r='80'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='-225 -114 450 300'%3E %3Ctitle%3EFlag of Malawi%3C/title%3E %3Crect x='-225' y='-114' width='450' height='300'/%3E %3Cg fill='%23CE1126'%3E %3Ccircle r='64.5'/%3E %3Crect x='-225' y='-14' width='450' height='100'/%3E %3Cg id='r16'%3E %3Cg id='r8'%3E %3Cg id='r4'%3E %3Cg id='r2'%3E %3Cpath id='r' d='M0-102c-2.2,0-3,3.3-3,6.5 0,8 1,12 3,23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5'/%3E %3Cuse transform='rotate(5)' xlink:href='%23r'/%3E%3C/g%3E %3Cuse transform='rotate(10)' xlink:href='%23r2'/%3E%3C/g%3E %3Cuse transform='rotate(20)' xlink:href='%23r4'/%3E%3C/g%3E %3Cuse transform='rotate(40)' xlink:href='%23r8'/%3E%3C/g%3E %3Cuse transform='rotate(-80)' xlink:href='%23r16'/%3E%3C/g%3E %3Crect x='-225' y='-21.5' width='450' height='7.5'/%3E %3Crect x='-225' y='86' width='450' height='100' fill='%23339E35'/%3E %3C/svg%3E"

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='840' height='480'%3E %3Cdefs%3E %3ClinearGradient id='lg'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%23f15770' offset='1'/%3E %3C/linearGradient%3E %3CradialGradient id='rg1' xlink:href='%23lg' gradientUnits='userSpaceOnUse' cx='842.31' cy='103.66' r='25.859' gradientTransform='matrix(0.185743,0.047185,-0.04532,0.186354,233.798119,198.76959)'/%3E %3CradialGradient id='rg2' xlink:href='%23lg' gradientUnits='userSpaceOnUse' cx='651.52' cy='550.46' r='25.859' gradientTransform='matrix(-0.176418,-0.070669,0.065152,-0.163915,430.544346,377.87561)'/%3E %3CradialGradient id='rg3' xlink:href='%23lg' gradientUnits='userSpaceOnUse' cx='380.84' cy='740.37' r='25.859' gradientTransform='matrix(0.098907,0.003695,-0.004498,0.194304,442.362219,123.304182)'/%3E %3C/defs%3E %3Crect height='480' width='840' fill='%23ce1126'/%3E %3Crect height='480' width='560' fill='%23fff'/%3E %3Crect height='480' width='280' fill='%23006847'/%3E %3Cg id='coa'%3E %3Cg id='branches'%3E %3Cg fill='%23fcca3e' stroke='%23aa8c30'%3E %3Cpath stroke-width='0.35' d='m466.96,303.53,0,0,0.29345,5.8781,2.2196-1.4668-1.702-4.8389z'/%3E %3Ccircle stroke-width='0.3' cx='466.703' cy='301.93' r='1.892'/%3E %3Cpath stroke-width='0.35' d='m474,312.69,0,0-4.3004-4.119-1.9314,1.5534,5.8424,3.4045z'/%3E %3Cpath stroke-width='0.3' d='m473.63,315.01c-0.60827-0.81462-0.40336-2.0033,0.44551-2.6582,0.85314-0.65442,2.0376-0.52396,2.6459,0.28851,0.60132,0.81461,0.40284,2.0065-0.44871,2.6615-0.85368,0.65276-2.0371,0.5207-2.6427-0.29176z'/%3E %3Cpath stroke-width='0.35' d='m507.04,251.22,0,0,4.4071,4.3842,0.51221-2.2192-4.0283-2.7009z'/%3E %3Ccircle stroke-width='0.3' cx='506.451' cy='250.09' r='1.845'/%3E %3Cpath stroke-width='0.35' d='m518.65,253.82,0,0-6.7334,1.9215,0.55489-2.2246,5.789-0.56291z'/%3E %3Ccircle stroke-width='0.3' cx='519.742' cy='252.89' r='1.803'/%3E %3Cpath stroke-width='0.35' d='m496.03,287,0,0-4.1083-6.3977,0.6616-0.33016,4.6472,5.4884z'/%3E %3Ccircle stroke-width='0.3' cx='491.518' cy='279.115' r='1.909'/%3E %3Cpath stroke-width='0.35' d='m496.29,287.17,0,0,5.2181,0.95262,0.19208-0.71446-4.3698-1.732z'/%3E %3Ccircle stroke-width='0.3' cx='503.102' cy='288.18' r='1.889'/%3E %3Cpath stroke-width='0.3' d='m373.59,301.72c0,0.91047-0.7139,1.5562-1.391,1.5562-0.67173,0-1.2191-0.73506-1.2191-1.6401,0-0.90881,0.54688-1.6439,1.2191-1.6439,0.67708,0,1.391,0.8238,1.391,1.7278z'/%3E %3Cpath stroke-width='0.35' d='m373.56,304.65,0,0,1.1952,6.5655-1.59-0.62787-0.5709-5.7049z'/%3E %3Cpath stroke-width='0.3' d='m375.01,302.42c0.76673,0.99436-0.53142,2.5115-1.9091,2.8888-1.3781,0.37564-3.0978-0.26035-3.0807-1.5221,0.0182-1.4317,2.0099-0.68632,2.5445-0.85254,0.82541-0.26036,1.621-1.5838,2.4453-0.51422z'/%3E %3Cellipse stroke-width='0.3' cx='363.566' cy='312.49' rx='2.045' ry='1.483'/%3E %3Cpath stroke-width='0.35' d='m367.03,312.14,0,0,6.3066-0.31393-1.0671-1.2557-5.1808,0.56291z'/%3E %3Cpath stroke-width='0.3' d='m367.56,311.41c0.52556,1.5973,0.56932,3.7744-1.2181,3.5448-1.7911-0.23275-1.4523-1.8333-1.591-2.4498-0.2561-1.121-1.3067-2.1305-0.22783-3.2234,1.0794-1.0966,2.5082,0.52883,3.037,2.1283z'/%3E %3Cellipse stroke-width='0.3' cx='347.006' cy='276.955' rx='1.236' ry='1.881'/%3E %3Cpath stroke-width='0.35' d='m347.03,281.12,0,0,0.14406,6.1108-1.59-1.4452,0.11205-4.8659z'/%3E %3Cpath stroke-width='0.3' d='m349.39,279.26c0.32173,1.4095-1.7452,2.2041-3.1522,1.9421-1.4059-0.25767-2.4693-0.99271-2.2564-2.2891,0.21288-1.2985,1.9592-1.0068,2.5552-0.64738,0.59597,0.35563,2.4058-0.9851,2.8534,0.99436z'/%3E %3Cellipse stroke-width='0.3' cx='336.229' cy='286.5' rx='2.13' ry='0.973'/%3E %3Cpath stroke-width='0.35' d='m340.06,286.5,0,0,4.7966-0.32476,2.0435,1.5805-6.9148-0.2598z'/%3E %3Cpath stroke-width='0.3' d='m338.3,283.93c1.2938,0.0412,2.187,1.4674,2.0024,2.9814-0.18354,1.5134-1.3488,2.7373-2.5413,2.5522-1.193-0.19162-1.1076-1.1984-1.0788-1.4988,0.0293-0.30473,0.69578-0.85249,0.76781-1.3418,0.0699-0.48607-0.34148-1.5697-0.18728-2.0726,0.1574-0.50502,0.45565-0.63818,1.0372-0.62028z'/%3E %3Cpath stroke-width='0.3' d='m334.43,246.74c-0.53623,0.85196-1.5548,1.4988-2.0707,1.167-0.51702-0.33289-0.3324-1.5204,0.20168-2.373,0.53302-0.85036,1.3846-1.2742,1.9021-0.9413,0.51648,0.33397,0.49941,1.2947-0.0331,2.1472z'/%3E %3Cpath stroke-width='0.35' d='m329.08,256.35,0,0,2.6784-6.3111-0.40017-0.3464-3.0359,4.4329z'/%3E %3Cpath stroke-width='0.3' d='m331.27,250.05c-1.3264-0.96999-1.6188-1.9638-1.192-2.9435,0.42471-0.97811,1.4187-0.34317,1.4187-0.34317s0.65357,0.72208,1.1354,0.97812c0.4834,0.26197,1.2517-0.0839,1.8188,0.72047,0.56878,0.80595,0.22677,1.6125-0.22782,1.8154-0.45513,0.1992-1.845,0.57541-2.9532-0.22733z'/%3E %3Cpath stroke-width='0.3' d='m320.14,249.22c0.95075,0.5429,1.4555,1.4576,1.1295,2.0564-0.3276,0.58892-1.3664,0.63332-2.3188,0.0893-0.94814-0.53912-1.4539-1.4576-1.1252-2.0531,0.32652-0.59379,1.3627-0.63493,2.3145-0.0926z'/%3E %3Cpath stroke-width='0.35' d='m322.92,251.99,0,0,4.946,2.9661-0.14406,2.3328-5.3675-4.6115z'/%3E %3Cpath stroke-width='0.3' d='m322.88,252.55c-1.0965,1.2254-2.1038,1.4095-3.0129,0.86767-0.91239-0.54238-0.17714-1.4723-0.17714-1.4723s0.78005-0.57428,1.089-1.0306c0.30999-0.45847,0.0592-1.2714,0.91453-1.751,0.85421-0.47795,1.6049-0.0427,1.7522,0.44006,0.14458,0.47958,0.35107,1.9226-0.56558,2.9462z'/%3E %3C/g%3E %3Cg fill='%23aa8c30'%3E %3Cpath d='m468.03,303.97s-0.36069,0.23925-0.55756,0.62681c-0.18888,0.38755-0.40443,1.1654-0.40443,1.1654l0.0224-1.8994,0.64027-0.36972,0.29933,0.47688z'/%3E %3Cpath d='m468.31,302.78s-0.44232,0.75023-1.4923,0.69065c-1.0463-0.0563-1.5601-0.54451-1.6866-1.0798-0.12857-0.53098-0.12857-0.92019,0.20971-1.5421,0.34145-0.61868-0.49569,0.59052-0.49569,0.59052v1.1822l0.76728,0.90882,0.65042,0.20136,0.64347,0.0412,0.8222-0.27227,0.55274-0.41733,0.0288-0.30312z'/%3E %3Cpath d='m473.84,312.44s-0.52981,0.27551-0.93478,0.12829c-2.4789-0.88012-4.5608-2.3334-4.5608-2.3334l4.9818,3.0934,0.5138-0.88823z'/%3E %3Cpath d='m476.94,313.85s-0.0555,0.8704-1.0207,1.3045c-0.96252,0.43356-1.638,0.23438-1.9896-0.18296-0.35108-0.41733-0.52661-0.7621-0.50368-1.4712,0.031-0.70909-0.17554,0.75236-0.17554,0.75236l0.52981,1.055,1.089,0.45357,0.67602-0.11906,0.58689-0.25927,0.61146-0.62301,0.30734-0.62788-0.11098-0.282z'/%3E %3Cpath d='m508.79,251.4s-0.12646,0.19595-0.12646,0.5191c0,0.3253-0.0198,0.90881-0.0198,0.90881l-1.0852-1.2081,0.54901-0.71395,0.68242,0.4942z'/%3E %3Cpath d='m508.21,249.83c0.0635,0.86387-1.1909,2.0937-2.1289,1.7045-0.93639-0.38593-1.6172-1.3602-1.105-2.3334,0.51007-0.97267-0.25665,0.36806-0.25665,0.36806l0.12966,1.4263,0.89102,0.81952,1.1098,0.066,0.87446-0.49473,0.53142-0.97433-0.0459-0.58186z'/%3E %3Cpath d='m521.38,252.18s-0.21288-0.59218-0.10404,0.0747c0.10404,0.67228-0.75552,2.1088-1.7602,1.9768-0.99772-0.12882-1.456-1.003-1.3717-1.8154,0.0848-0.80921-0.16859,0.28039-0.16859,0.28039l0.15794,1.0836,0.53617,0.50771,0.76567,0.45306,0.89423-0.15318,0.80938-0.51908,0.36122-0.76162v-0.54291l-0.12007-0.58406z'/%3E %3Cpath d='m516.87,253.18s0.0341,0.4536-0.56236,0.77946c-0.59651,0.32368-1.7244,0.99435-1.7244,0.99435l3.7055-1.0798-0.30678-0.8985-1.1119,0.2046z'/%3E %3Cpath d='m494.43,282.57s-0.20007,0.21758-0.21127,0.67933c-0.0128,0.46821,0.0944,1.0192,0.0944,1.0192l-2.0772-3.2839,0.61734-0.38973,1.5766,1.9751z'/%3E %3Cpath d='m493.29,279.48c-0.37028,0.86548-1.8818,1.416-2.6069,0.9943-0.72453-0.42057-1.3408-1.9887-0.45512-2.6794l-0.46153,0.40216-0.23422,0.8953,0.33188,0.93804,0.72453,0.81947,0.66801,0.20623,1.0677-0.21434,0.77684-0.60678c0-0.00036,0.56289-1.6179,0.18886-0.75507z'/%3E %3Cpath d='m500.61,287.01s0.0197,0.38757-0.66105,0.38757c-0.67921,0-2.1065,0.0227-2.1065,0.0227l3.4505,0.6658,0.17072-0.68852-0.85367-0.38756z'/%3E %3Cpath d='m504.85,287.82c0.30893,1.1513-0.71389,2.2609-2.0344,1.8734-1.32-0.39244-1.6743-1.7029-1.2598-2.4087l-0.32652,0.82273,0.24063,1.0945,0.80938,0.70583,0.82754,0.1797,0.84673-0.20947,0.85533-0.82114,0.21234-0.97971-0.17128-0.2571z'/%3E %3Cpath d='m374.92,302.46c0.35587,0.40219-0.19742,1.9015-1.6887,2.5062-1.4918,0.6019-2.2308,0.0281-2.6267-0.47632-0.39803-0.50341-0.37029-1.0355-0.37029-1.0355l-0.21289,0.27226,0.20009,0.77947,0.75338,0.64629,1.3184,0.28688,0.98175-0.18511,0.96572-0.51909,0.49566-0.51963,0.42738-0.63331,0.056-0.77674-0.24117-0.39081h-0.0576l-0.0235,0.0314,0.0224,0.0141z'/%3E %3Cpath d='m373.59,305.73s-0.25504,0.0844-0.48179,0.46226c-0.22569,0.37241-0.31213,1.0338-0.31213,1.0338l-0.11472-1.7543,0.76781-0.40596,0.14086,0.66416z'/%3E %3Cpath d='m368.62,311.01s-0.14032,0.37564,0.25611,0.57535c0.39802,0.2046,1.3349,0.43248,1.3349,0.43248l-2.4421,0.0855-0.25557-0.9483,1.1066-0.14507z'/%3E %3Cpath d='m367.79,312.53s0.0288,0.0877,0.0235,0.24737c-0.008,0.16346-0.0512,0.40054-0.19369,0.70422-0.2849,0.6019-0.39748,1.2964-1.2768,1.121-0.88246-0.17105-1.2506-0.83577-1.336-1.4095-0.0854-0.57539-0.28384-0.80595-0.28384-0.80595v0.77513l0.53891,1.2975,0.8798,0.4038h0.76727l0.59651-0.23113,0.28332-0.77838,0.14405-0.63493-0.14299-0.68904z'/%3E %3Cpath d='m361.63,312.36s0.28544,1.1242,1.5339,1.1524c1.2501,0.0314,1.5628-0.34804,1.5628-0.34804l0.14139,0.43356-0.45404,0.22951-1.0852,0.12394-0.95504-0.18999-0.44392-0.32799-0.33879-0.59,0.0389-0.48337z'/%3E %3Cpath d='m349.24,279.02s0.0422,0.12883-0.0437,0.53913c-0.0854,0.40922-0.84993,1.3836-2.2788,1.4035-1.4262,0.0232-2.0216-0.45521-2.4053-0.92992-0.38416-0.47363-0.44872-1.1443-0.44872-1.1443l-0.0422,0.71342,0.55328,0.88551,1.4059,0.66142,1.3424,0.009,1.3622-0.39893,0.59704-0.66143,0.13926-0.72533-0.18141-0.35183z'/%3E %3Cpath d='m346.98,282.05s-0.5106,0.0444-0.76567,0.27174c-0.25504,0.22948-0.48019,0.50663-0.48019,0.50663l-0.0203-1.6953,1.2661,0.0958v0.82112z'/%3E %3Cpath d='m340.84,286.53s-0.0976,0.0991,0.64134,0.43193c0.73896,0.33289,4.1046,0.69071,4.1046,0.69071l-5.3971-0.1456,0.19848-0.92126,0.45245-0.0557z'/%3E %3Cpath d='m340.23,286.63s-0.0139,0.20461-0.2828,0.75022c-0.26944,0.54778-0.94915,2.0032-2.0867,1.8019-1.137-0.20243-0.99398-0.99597-0.99398-1.1226,0-0.13154-0.0155-0.40542-0.0155-0.40542l-0.19847,0.82274,0.26943,0.57534,0.46793,0.29013,0.92409,0.1153,0.6237-0.27553,0.68189-0.6495,0.35534-0.69071,0.28386-0.73505-0.0288-0.47686z'/%3E %3Cpath d='m337.32,286.77s-0.031,0.25764-0.92462,0.29013c-0.89477,0.0232-2.1721-0.36266-2.1721-0.36266l0.42577,0.53099,0.73842,0.18946,0.92249,0.013,0.72405-0.0709,0.28598-0.58999z'/%3E %3Cpath d='m334.57,248.86s0.19849,0.57701-0.31265,0.95156c-0.51061,0.3724-1.6204,0.60297-2.329,0.19919-0.70962-0.40379-1.9896-1.6985-1.9896-1.6985l0.59811,1.0674,0.93585,0.77839,1.3061,0.3724,1.2491-0.19812,0.56984-0.49419,0.17075-0.40054-0.19849-0.57755z'/%3E %3Cpath d='m330.76,250.59s0.0278,0.14831,0,0.72207c-0.0283,0.57701-0.2561,1.5286-0.2561,1.5286l1.136-2.5392-0.45351-0.40379-0.42632,0.6923z'/%3E %3Cpath d='m323.72,252.58s-0.16967-0.17484,0.16967,0.57539c0.3404,0.75077,3.1234,3.4296,3.1234,3.4296l-4.429-3.7424,0.50955-0.72586,0.62637,0.46334z'/%3E %3Cpath d='m322.24,253.01s-0.56878,0.35075-1.0794,0.37565c-0.51166,0.0298-1.3627-0.0281-1.4763-0.63492-0.11363-0.60137,0.16968-0.86062,0.16968-0.86062l-0.36868,0.83412,0.14245,0.45845,0.65415,0.3762,0.90866,0.0871,0.82219-0.4038,0.22731-0.2322z'/%3E %3Cpath d='m320.45,251.11s0.0555,0.17321-0.76781,0.0579c-0.8238-0.11583-1.8162-1.0652-1.8162-1.0652l0.65196,1.0355,1.392,0.57648,0.53998-0.60464z'/%3E %3C/g%3E %3Cg fill='%239ca168'%3E %3Cpath d='m524.81,238.85c-0.40337,5.0323-5.3672,7.6028-7.9645,9.4841-2.6021,1.8831-3.8581,4.216-3.8581,4.216l-0.87291,2.9348-0.42737,1.8766-0.0843,0.65278c0.17183,0.52287,0.39271,1.4295,0.4258,2.7898,0.0667,2.2886-0.1462,5.5499-0.1462,5.5499l3.4942-2.5062,2.5322-0.95155,0.76561-0.12234s-2.8118,2.7952-3.9184,5.8203c-1.105,3.0258-3.1528,9.4499-6.9856,11.522-3.8309,2.0758-6.221,1.2135-7.4975,2.3378-1.2757,1.121-1.3216,1.423-1.3216,1.423l-1.6321,2.2339-1.2917,1.6704-1.208,0.83632-0.76402,0.61814c-0.0261,0.62301-0.1003,1.4301-0.30894,2.1738-0.41883,1.4772-0.91821,3.121-0.91821,3.121s0.76567-0.46604,1.6951-0.58186c0.92302-0.12016,1.7863-0.10881,1.7863-0.10881s-0.72297,0.88552-0.978,1.7495c-0.25557,0.86601,0.1702,6.0516-4.7699,9.1613-4.9428,3.1113-17.524,2.6214-17.524,2.6214l-2.3828,0.9483-2.243,1.6753-2.0478,2.2452-0.15259,0.60517s-1.5473,1.8863-2.6587,2.6236c-1.105,0.73346-3.6602,2.4157-3.6602,2.4157s2.1694-0.0823,2.8966,0.17266c0.72191,0.26361,4.5992,1.9919,4.5992,1.9919s-2.8406-0.0574-4.7699,0.68905c-1.9341,0.74863-10.735,5.7332-14.995,5.5894-4.2572-0.14183-10.338-6.3674-10.338-6.3674l-2.7547-1.9291-4.5715-0.8915-5.653-0.31828,0.0811-0.74049,0.10724-0.91368s1.9176-0.21761,5.0026,0.14668c2.6389,0.31449,3.5172,1.1903,5.7305,1.449,2.2169,0.25928,3.8538-0.0639,4.6648-0.42869,0.80937-0.37403,7.645-6.1612,7.645-6.1612l7.6877-2.6972,2.9383,0.4287,1.3008,0.34642,1.1957,0.34642s-0.40283,0.62787-1.2576,1.4263c-0.85153,0.79676-1.9181,1.3407-1.9181,1.3407l0.93958,0.75184,4.8532-0.77513,1.5852,0.4092s0.12324,0.033,0.45619,0.24359c0.0752-0.34966,0.26996-1.076,0.70694-1.6471,0.59651-0.77673,3.3235-3.0025,4.4909-3.7803,1.1765-0.77674,1.4305-0.88552,1.8152-1.2964,0.38201-0.41082,1.9587-4.4753,1.9587-4.4753l0.21394-2.0704,5.3672-5.166,3.6196-3.8464,1.5777-4.386-0.1718-0.88391s1.3002,1.3386,1.0661,4.0607c-0.23425,2.7221-0.83236,3.6737-0.83236,3.6737s3.6618-2.5294,5.6236-3.3949c1.5729-0.69231,2.7334-0.64577,3.1367-0.60297,0.517-0.29338,1.9272-1.1654,2.7824-2.419,1.0661-1.5529,1.3445-2.0103,1.3445-2.6366,0-0.62627,0.17019-3.6504,0.17019-3.6504l-0.34145-9.2709,3.1533-6.9781,4.5763-4.1056,0.87504-0.51963s-0.36442,0.97159-0.4279,1.6439c-0.0635,0.66741-0.0635,1.855-0.0635,1.855s2.3199-3.1735,3.514-3.757c0.27318-0.1337,0.51383-0.24737,0.73308-0.34858,0.24863-0.44169,0.68243-1.3288,0.9444-2.5635,0.36867-1.7559,0.42789-4.117,0.42789-4.117l0.0699-3.8382-0.7459-2.9846-2.1305-5.7268-0.0843-7.5386-1.5964-2.1532s1.5116-0.11691,3.3843,2.5852c1.8738,2.7026,2.4298,6.5031,2.4298,6.5031l4.3506-13.352s1.1674,1.5762,1.9928,4.2128c0.83502,2.6366,1.0884,4.4288,1.0884,4.4288l1.7132-3.7067c-0.0144,0.0395-0.0523,0.25711,0.20487,1.3088,0.29558,1.2303,2.9575,2.7671,2.5547,7.801zm-88.327,85.346s-0.81364-2.0444-5.0026-4.1186c-4.19-2.0725-7.3099-2.4764-7.3099-2.4764l-0.0459,1.54,6.5758,2.8677,3.2786,2.6794,2.5039-0.49203z'/%3E %3Cpath fill='%23717732' d='m466.42,311.65c0.40443-0.53913,3.9446-3.6932,5.7519-4.6231,1.812-0.93045,4.2156-1.1015,4.2156-1.1015,2.4933-0.45682,2.8983-0.0871,8.6484-3.2628,5.7519-3.1741,7.031-6.828,8.1376-7.7133,1.1066-0.88717,3.1282-1.1015,3.1282-1.1015s-2.4069,2.8298-4.5133,5.1411c-2.1075,2.3151-4.3687,3.7809-7.6065,5.9645-3.2354,2.1825-9.9628,2.2912-9.9628,2.2912-2.8358,0.6495-3.793,1.3375-5.3698,2.7188-1.575,1.3851-2.6459,2.8904-2.6459,2.8904s-0.18621-0.66308,0.21661-1.2038zm15.868-16.658c-5.3211,4.8623-7.07,9.3788-7.07,9.3788s4.7294-4.0612,7.1576-6.3941c2.4287-2.3345,5.8331-3.4594,7.3692-4.8851,1.5345-1.4268,1.6188-2.635,2.5974-3.5454,0.97853-0.90502,1.7063-1.3392,1.7063-1.3392s-2.3455-1.8133-11.761,6.7847zm-11.228,11.253s2.2756-0.99923,3.1367-3.042c0.64026-1.5134,0.2993-1.8994,1.2789-3.6309,0,0,5.5376-5.3469,7.4943-7.6487,3.4947-4.1056,1.9181-7.474,1.9181-7.474s0.38201,1.7278-1.0645,3.5416c-1.4486,1.8138-8.5918,6.6987-9.4579,9.5086-0.8681,2.8093-0.38201,2.9116-0.76727,4.4055-0.88408,3.4431-2.5386,4.34-2.5386,4.34zm-3.6799,13.813s-2.7857-1.8696-5.9058-1.6704c-6.3615,0.40435-11.743,4.32-15.944,4.4353-4.2065,0.11582-5.8577-1.9935-9.1047-4.2063-3.4617-2.3611-12.039-2.0184-12.039-2.0184l-0.0539,0.2046-0.0598,0.25063s5.8967,0.059,8.4112,0.75669c4.803,1.325,7.3917,6.3263,12.846,6.0067,7.0764-0.41731,12.879-4.727,15.772-4.7124,4.9695,0.032,6.0778,0.95375,6.0778,0.95375zm-31.556-3.2217s4.9343,0.88878,8.767-1.9226c3.8341-2.8092,8.3898-6.61,10.905-6.7831,2.513-0.1727,5.1552,0.47523,5.1552,0.47523s-3.1981-1.4263-5.7503-1.3852c-2.5594,0.0444-5.1552,0.3908-7.5429,1.8166-2.3844,1.4279-3.5348,4.0169-6.1323,5.66-2.6005,1.6461-5.4024,2.1391-5.4024,2.1391zm-0.8814,6.6351c-0.65946,0-1.4273,0.42869-1.6839,0.38754-0.25344-0.0411-1.765-1.5995-3.8746-2.7205-2.1097-1.1226-5.2528-1.8019-5.2528-1.8019s-0.39163,0.0974,0.31213,0.33289c0.7016,0.2387,3.2995,1.121,4.9599,1.8994,1.6631,0.7816,3.3422,2.5494,3.4947,2.8309,0.1494,0.28525,0.74483,1.0798,1.9811,1.0355,1.2352-0.0412,1.726-0.75023,1.5942-1.2298-0.12325-0.47361-0.87077-0.73393-1.5308-0.73393zm3.4718-4.7952s1.9533,1.1151,5.1941,1.0354c6.9039-0.17267,11.247-4.897,15.769-6.625,4.5101-1.731,6.8264-0.23274,6.8264-0.23274s0.11897-0.24413-0.0262-0.34966c-0.63706-0.47688-2.7339-1.6141-5.0447-1.5795-7.584,0.11529-14.68,4.897-17.774,6.1922-2.9906,1.2509-4.9439,1.5589-4.9439,1.5589zm73.393-52.271c-2.3252,2.4022-5.7957,10.071-7.3276,12.165-1.5313,2.0974-3.4526,2.7221-4.2806,3.5665-0.72833,0.74045-3.514,4.4932-4.1542,5.403-0.63706,0.90555-0.83075,0.64629-1.2779,1.0355-0.44551,0.38755-0.68082,0.41083,0.0635,0.21434,0.74536-0.19107,0.98008-0.64577,2.1305-1.9421,1.1487-1.2974,1.0858-1.8815,2.9158-3.5221,1.8317-1.6455,5.1488-3.5151,6.797-5.5333,1.6444-2.0168,5.0058-9.8223,6.7628-11.723,1.9032-2.0612,5.2266-3.2861,5.2266-3.2861s-2.6203-0.76374-6.8558,3.6223zm-11.799,14.544s-0.0864-1.3835,1.6183-3.4166c1.7031-2.033,2.3012-1.7694,3.6618-4.7535,1.3621-2.9808,1.9634-5.8748,3.0685-9.0294,1.105-3.1573,3.0231-6.2702,3.0231-6.2702s-1.7879,0.17267-3.6212,2.6398c-1.8333,2.4634-4.7294,6.9578-6.221,11.365-1.4918,4.4076-1.5291,9.4643-1.5291,9.4643zm-2.1732,2.8904s0.63866-0.34099,0.72191-4.1874c0.088-3.8469-0.21128-9.2468,0.89743-11.927,1.105-2.6777,6.9856-9.1186,6.9856-9.1186s-2.4303,0.60517-5.8363,3.3273c-3.4051,2.7205-4.8548,6.1387-4.6856,8.7269,0.17234,2.5971,1.622,5.5334,1.749,8.0847,0.12271,2.5473,0.16807,5.0945,0.16807,5.0945zm13.841-26.47s1.4513-5.2153,2.0446-6.4844c0.60132-1.2698,0.6275-2.0168,3.5785-5.3278,1.6924-1.8994,3.3544-3.1162,4.0598-5.7626,0.71176-2.6545,0.68616-10.055,0.68616-10.055s-0.76727,0.68744-1.3915,1.9865c-0.62745,1.2991-0.17181,6.1056-1.28,8.3235-1.1087,2.2214-3.6052,7.4376-4.8569,8.5592,0,0-0.25344-3.7446,0.20008-7.5204,0.45512-3.7727,1.7341-4.9235,2.3002-7.4029,0.56823-2.4747,0.22729-8.8728,0.22729-8.8728s-2.0152,2.0775-3.0119,4.465c-0.98922,2.3908-1.5879,6.6827-1.6167,9.9099-0.0299,3.2282,0.73948,5.8502,0.85314,7.693,0.10883,1.8436,0.25236,2.7075-0.48554,4.7243-0.73789,2.0168-0.36709,0.63492-0.82274,2.5938-0.45512,1.9584-0.93424,3.4296-0.93424,3.4296l0.44977-0.25873zm-4.5971-28.292s1.7591,2.2176,1.4726,4.7535c-0.28384,2.5343-1.248,5.878-0.25343,8.5271,0.99457,2.6485,2.472,2.9105,2.87,4.4353,0.39854,1.5264,0.42309,4.5062,0.42309,4.5062s0.8238-5.6605,0.25612-7.2154c-0.56557-1.5529-0.8222-0.83631-1.6444-2.4764-0.82595-1.6406,0.0262-6.1339-0.59812-8.7553-0.62369-2.6225-2.5258-3.7754-2.5258-3.7754z'/%3E %3Cpath d='m402.55,323.75s0.53302-1.4891,4.1105-3.2379c3.578-1.751,8.9647-4.1078,9.4771-3.8058,0.51166,0.30473-0.278,2.2506-0.278,2.2506l-3.4697,1.0571-2.7686,1.6222-3.2365,2.0953-3.8346,0.0184z'/%3E %3Cpath d='m411.67,314.34c-4.572,0.1732-7.0652,1.2975-7.9447,1.4712-0.30307,0.059-0.96144,0.52614-1.5238,0.24899-1.0719-0.53262-2.0045-2.0049-2.0045-2.0049l-0.96626-0.80649-0.22676,3.2818-6.6736-5.7871-0.71123,3.8285-0.85153,1.7608-6.6169-6.2541,0.31265,4.839s-1.7308,0.22788-1.8172,0.17319c-0.0843-0.0579-4.7139-3.2845-4.7139-3.2845l-1.391,0.46171,1.534,2.8515-5.9656,0.46279s-0.48126,0.26198-1.2912,1.0057c-0.80938,0.74698-1.257,1.448-1.257,1.448s-0.17928,0.30366,0.0315,0.4433c0.21394,0.14018,1.844,0.1088,2.3551-0.0877,0.51061-0.19431,0.8409-0.90662,0.98976-0.61489,0.1478,0.29337,0.33988,1.6011,1.129,1.4706,0.78965-0.12993,3.5604-2.2306,5.5371-1.3072,2.2036,1.0257-2.8534,2.5175-2.3316,4.084,0.51862,1.5584,4.1628,0.8969,5.0896,0.39732,0.9257-0.49475,3.6927-3.946,4.8238-2.635,1.5761,1.8268-3.3107,3.2417-2.4063,5.0653,0.87344,1.7608,3.6004,1.3645,4.9188,0.60677,1.3227-0.75562,4.3917-5.4794,5.0714-4.4618,1.1807,1.7694-2.5893,3.4577-1.6423,4.8277,0.94921,1.3716,3.0359-0.0498,4.421-1.0257,1.3846-0.97266,1.9384-3.2861,3.8538-4.3643,1.9171-1.0798,1.7879-0.62952,2.314-0.64789,0.52927-0.0244,2.0099-1.4902,2.0099-1.4902l4.5053-1.9129,2.2057,0.16022,1.1386,0.54073,2.2585,0.31503,0.26519-1.9048s-2.6128-1.2222-4.429-1.1545zm-36.054,0.0363,0.95396-1.6931-0.5405-0.82166s-1.5895-0.89043-3.0375-2.3573c-1.4486-1.4728-1.9779-1.809-2.641-2.1402-0.66425-0.33454-2.8961-1.7873-2.8961-1.7873l-1.0063-3.7132-0.59491-1.0734-1.7212,0.67441-2.2665-7.9869-0.44285-1.4322-0.93585-0.0547-1.8583,4.8423-2.0782-3.0241-0.52822-6.6191-1.2954,1.4528-1.6684,1.6947-2.9644-6.0003s-0.24064-0.15318-0.3927,0.34642c-0.14939,0.48608-0.40549,2.3805-0.22035,3.5042-0.79234-0.49472-2.1545-1.4284-3.9787-3.0009-3.0109-2.5922-3.7348-3.9259-3.7348-3.9259l-1.4048-3.1724,1.3195-2.7898,0.65998-3.3267-2.8961,1.1849-0.51062-7.5199-0.44871-2.3746-3.4926,4.9928s-1.3611-1.9243-1.3611-2.1402c0-0.21435,0.0624-4.7519,0.0624-4.7519l-0.93692-0.28309-1.4288,2.6794s-1.3723-2.7648-1.9784-3.3538c0.0966-1.062,0.25556-3.7743-0.38897-5.8694-0.81739-2.6647-1.7714-4.0845-1.431-6.2606,0.34306-2.1765,1.2261-2.3843,1.1253-3.3538-0.10297-0.9662-1.535,0.62627-1.057-0.65443,0.47805-1.278,5.0442-4.182,4.0902-5.7032-0.95557-1.5221-5.3506,2.386-4.3282-0.2387,1.0207-2.6279,5.247-2.6647,5.4858-6.3279,0.1478-2.282-3.9877,1.4182-4.3623,0.27553-0.37403-1.1388,2.5546-3.4886,2.5226-4.976-0.0347-1.4853,0.54473-1.6569-0.27372-2.4531-0.81685-0.79457-3.339,3.1096-3.339,3.1096l-2.76-1.0387-0.95557,3.9443-0.84993,3.35-3.4083-2.0016,0.91935,4.0791,0.81899,3.9752-3.5454-0.90015,1.8754,3.3868,2.4421,2.4812,1.5089,2.046,1.0933,0.58731,1.4635,1.4555,0.51114,2.1765s0.85366,2.387,0.85366,2.4915c0,0.10176,0.13553,2.3481,0.13553,2.3481l0.0341,1.5545-0.0768,1.2065-0.0528,0.45359-0.0742,0.51963-0.0304,1.423c-0.6664,0.0639-1.7484-1.0208-2.1444-0.34479-0.42418,0.73671,2.0467,2.636,1.5772,3.1113-0.46793,0.47795-4.0892-0.73346-4.3015,0.43194-0.21448,1.167,0.34041,2.8082,2.4282,3.3273,2.0862,0.51908,6.9423,1.6417,6.1339,2.5916-0.81044,0.95321-6.0917-2.8937-5.8774-0.0839,0.21182,2.8065,2.044,3.9736,3.4073,4.4932,1.3632,0.51962,6.6864-0.0839,6.3882,1.167-0.29719,1.2547-4.3442-0.38918-4.7278,1.4252-0.38256,1.8182,2.8118,2.0742,3.4953,2.0742,0.68029,0,2.8945-0.0844,3.7461,0.56348,0.85313,0.64791,3.8325,3.802,5.7091,5.4014,1.591,1.3553,5.0261,3.7359,6.0297,4.4271l-0.0486-0.006c-1.0095-0.0942-3.101-0.31502-3.4334,0.43844-0.42418,0.97159,8.0104,3.979,5.59,4.9122-2.4202,0.92992-5.0271-2.576-5.7257-0.4341-0.7,2.1434,1.6017,3.9541,2.9158,4.7341,1.3109,0.77839,8.7905,0.15805,7.3249,1.8479-1.4652,1.6969-6.8841-1.1405-6.9348,0.86767-0.0512,2.0066,3.6127,5.1855,5.4868,5.0967,1.8749-0.0839,3.935-3.0934,4.7876-1.4674,0.8526,1.6238-1.4491,2.282,0.35747,2.714,1.8056,0.43033,3.0834-1.8501,5.1792-1.436,2.0942,0.41569,5.3848,1.7429,7.2255,3.4193,1.8392,1.6769,3.73,3.6142,3.73,3.6142z'/%3E %3Cpath fill='%23717732' d='m404.74,322.82c1.2784,0.0227,1.4491,0.71341,1.6199,0.69231,0.17073-0.0233,2.322-1.8588,4.3655-2.9814,2.0451-1.1258,5.1536-1.7938,5.1536-1.7938l0.19369,0.28092s-3.7034,0.92505-5.4944,2.1808c-2.2169,1.5567-3.9616,2.531-4.0694,2.8098-0.1067,0.27879-0.91399,0.82114-2.1716,0.84443-1.256,0.0179-1.7895-0.73237-1.7895-1.1047,0-0.36482,0.91555-0.94835,2.1924-0.92832zm11.161-5.6536s-1.1066,0.11529-1.7319-0.43412c-0.62583-0.54724-2.0163-1.0354-3.3528-1.0354-1.3328,0-3.4713,0.73559-5.1653,2.3594-0.13713,0.13209-0.47647,0.7567-1.9341,1.731,0.50633,0.0974,1.488-0.57375,2.5568-1.4392,1.5334-1.2482,3.4643-1.5865,4.827-1.7841,1.3622-0.20621,2.2158,0.57429,2.8417,1.0041,0.62425,0.43519,1.901,0.31503,1.901,0.31503l0.0576-0.71668zm-66.249-27.074c0.13819-0.0579,0.11684-0.3594,0.0256-0.88229-0.20542-0.0779-1.0303-0.42546-2.8833-1.5302-2.1721-1.2974-6.6869-4.8867-6.6869-4.8867s1.8765,1.8182,3.7493,3.5037c1.8733,1.6834,5.2406,3.7576,5.2406,3.7576l0.0165,0.013c0.28759,0.0281,0.49354,0.0444,0.53837,0.0249zm46.769,33.13s0.68189-0.89364,1.8957-2.8461c1.2138-1.9524,2.3209-2.577,2.4911-2.8146,0.17074-0.23707-0.46845-1.1886-0.83128-1.9242-0.36069-0.73506-0.29719-1.5118-0.29719-1.5746,0-0.0655,0.44605,1.1427,1.3408,1.8144,0.89475,0.66576,1.4342,1.2292,1.4342,1.2292s1.781-0.23709,1.8253-0.58347c0.0422-0.34642-0.0443-0.58353-0.342-0.71182-0.29665-0.13044-0.63813,0.26685-1.4475-0.0893-1.6823-0.73073-2.3647-3.2823-3.3662-3.3684-1.0004-0.0861-0.28545,2.7021-0.72404,2.7432-1.5548,0.14995-2.7686-5.66-6.4962-5.8977-2.6235-0.16996-3.0882,0.32476-3.2162,0.90662-0.12591,0.58347,3.1741,4.0645,2.0665,4.5576-1.1071,0.50123-4.6221-5.4644-7.1774-5.5317-2.5552-0.0644-2.7686,0.90988-2.5781,1.4706,0.19155,0.56242,2.8331,1.0588,2.2153,2.9186-0.59865,1.8041-3.173-2.7849-5.536-2.5294-2.3647,0.25927-2.6203,0.43195-2.728,1.1015-0.10405,0.67067,0.83128,1.6423,0.4914,1.8799-0.34041,0.236-1.8328,0.17106-3.0247,0.9927-1.192,0.82381-2.855,3.0702-2.855,3.0702s1.5553-2.203,3.6201-2.4422c2.0665-0.23599,7.2854,0.0233,7.2854,0.0233s-0.70268-0.43411-1.4689-1.1248c-0.76669-0.69232-1.4278-2.0953-1.4278-2.0953s1.1514,1.0814,2.2586,1.9865c1.1066,0.91041,2.4911,1.6011,2.4911,1.6011s2.2153,0.21599,2.3647,0.47688c0.14941,0.25872-0.0651,0.77513-0.97908,1.7678-0.91666,0.99435-2.2372,2.1646-2.2372,2.1646s2.2142-1.6866,2.6411-2.0542c0.42577-0.36647,1.9592-1.5335,1.9592-1.5335s1.6199,0.21437,1.7895,0.17268c0.16912-0.0427,0.0918-0.60517-0.99452-2.2041-1.0847-1.5979-2.1145-3.3289-2.1145-3.3289s1.3339,1.2271,2.6822,3.0057c1.3488,1.7776,1.1508,2.5987,1.7041,2.6864,0.55381,0.0855,1.4475,0.20785,1.8519,0.18783,0.54366-0.0281,0.4055,0.77513-0.53302,2.203-0.93585,1.4263-1.4886,3.2607-1.4886,3.2607s0.9561-1.5351,1.9784-2.5916c1.0228-1.0587,1.5569-2.3145,1.9608-2.3778,0.40549-0.0644,1.7746,0.10717,1.9672,0.0249,0.18994-0.0893-0.32761-0.65117-1.0506-2.1224-0.72458-1.4674-0.95877-3.5005-0.95877-3.5005s0.7032,1.9048,1.8109,3.2861c1.1071,1.3819,1.534,2.4942,1.7741,2.5094,0.24116,0.0114,1.097-0.099,1.7186-0.0904,0.31266,0.006,0.34787-0.0693,0.38362,0.12828,0.10564,0.61002-0.15046,0.97486-0.89476,2.3794-0.74484,1.403-1.2341,2.7882-1.2341,2.7882zm-28.284-16.403c1.598,0.54453,2.2153,0.54453,2.2153,0.54453s-2.1939-1.2991-2.7697-3.1362c-0.57625-1.8339-0.0635-5.7049-1.0004-5.66-0.93746,0.0444-1.4705,2.8525-2.4069,2.2912-0.93799-0.56023,0.31853-5.7278-0.70374-7.9287-1.0207-2.2063-3.4275-3.7414-3.983-2.9419-0.55327,0.80436-0.42417,5.5537-1.9155,4.518-1.4913-1.0354,0.12753-5.1-0.32119-6.9578-0.44659-1.8604-1.574-3.199-2.4266-2.7454-0.8526,0.45683,0.33879,3.934-1.002,3.9752-1.3419,0.0449-1.1498-2.4417-1.7244-2.6788-0.57519-0.23708-0.76781,0.50121-1.0868,0.0265-0.32015-0.4785-0.1478-2.2506-0.85154-2.078-0.70268,0.17322-0.57466,1.5351-0.38362,2.2891,0.19101,0.75669,0.61681,1.8382,0.91506,2.3362,0.29773,0.49635,1.3638,1.121,1.28,1.5351-0.0859,0.41084-0.64135,0.75668-1.3638,0.77672-0.72565,0.0217-2.3658-0.046-2.3658-0.046s1.7463,0.54399,2.4069,0.60837c0.65998,0.0639,1.94-0.28093,2.2575,0.30203,0.31907,0.58513,1.8535,2.6577,1.8535,2.6577s0.36068-1.0798,0.55276-2.9846c0.19153-1.8977,0.10616-3.5649,0.10616-3.5649s0.51061,2.2062,0.44765,3.5254c-0.0624,1.3142-0.55434,3.8864-0.55434,3.8864s1.448,1.2103,1.0239,1.5351c-0.42577,0.32532-1.9389,0.28364-3.7066,0.26036-1.7666-0.0233-4.2802-0.62786-4.2802-0.62786s2.2575,1.0815,3.8325,1.3386c1.5761,0.26197,5.0052,0.34641,5.0052,0.34641l2.3423,2.6545s1.1221-1.9259,1.2784-3.8398c0.1574-1.9178-0.0422-4.1419-0.0422-4.1419s0.48927,2,0.57625,3.7083c0.0843,1.7099-0.55595,4.7324-0.76727,4.9912-0.21342,0.26037-1.4102,1.0041-2.4639,1.2682-1.5473,0.38917-4.6504,0.78326-4.6504,0.78326s2.863,0.38211,4.9198-0.10881c2.06-0.48607,2.3012-1.0588,2.8753-0.71235,0.57626,0.34859,1.0874,0.97486,1.0874,0.97486s1.233,0.95641,1.7895,1.2081c0.0864,0.1927-0.95182,0.62141-1.4784,0.95322-0.52395,0.32966-1.9096,0.97106-1.9096,0.97106s2.0243-0.73505,2.9196-0.97106c0.44712-0.12232,1.5329-0.52071,1.5329-0.52071l0.5965,0.32477s0.0422-0.43194-0.12753-1.6406c-0.16966-1.2097-0.42683-2.3794-0.42683-2.3794s0.70267,1.1031,0.91667,2.1402c0.21181,1.0371,0.21181,2.0942,0.21181,2.0942s0.1718,0.29933,1.7693,0.8401zm-40.808-46.754s0.45511-2.1916,0.45511-4.7243c0-2.5392-1.7623-6.4572-2.0462-6.859-0.28331-0.40543-0.45351-0.75023-0.45351-0.75023l1.1909-1.8404-1.5324,1.206s-0.85099-0.17321-1.5895-0.63166c-0.73842-0.45847-1.1082-1.1508-1.1082-1.1508s0.78324,0.57862,1.534,0.89151c0.74911,0.31016,0.93585,0.20135,0.93585,0.20135l-0.59063-2.5575s-0.78218-0.31178-2.5216-1.2796c-1.7383-0.9678-3.3059-2.4883-3.3059-2.4883s2.3519,1.4182,3.6804,1.9692c1.3307,0.55536,2.0798,0.58998,2.0798,0.58998s1.3979-0.41732,2.1129-0.83412c0.71496-0.41244,2.1812-1.5204,2.1812-1.5204s-1.3968,0.79677-2.3177,1.0041c-0.91934,0.20948-2.0787,0.34317-2.0787,0.34317l-0.40976-3.108-1.4635-1.5204c-1.1578-1.5221-2.0472-3.6986-2.0472-3.6986s1.1936,1.5183,2.1497,2.2442c0.95503,0.73073,1.8397,1.9026,1.8397,1.9026s1.0906-0.58839,2.146-1.3121c1.0548-0.72534,3.6788-2.6284,3.6788-2.6284s-1.4977,0.79297-3.5764,1.7624c-2.0798,0.9678-2.1481,0.86607-2.1481,0.86607s-0.16967-1.3473,0.13766-1.9378c0.30732-0.58513,0.95503-1.5529,0.8526-2.1402-0.10244-0.59053-0.54527-0.38269-0.71604-0.86548-0.17126-0.48662,0.54474-3.4544,0.54474-3.4544s0.17127,1.0701,0.20488,1.6206c0.0341,0.55103-0.2721,1.3142,0.47806,1.3142,0.74911,0,4.2599-3.5253,4.7011-4.183,0.44231-0.65602,1.0922-2.4536-0.75125-1.7262-1.8381,0.72368-1.3995,2.295-2.9287,2.1749-0.44392-0.0346-0.95343-2.0033-1.5329-1.5204-0.57995,0.48662-1.8749,1.6947-2.1144,3.0766-0.23689,1.3835,0.3084,3.4923-0.47592,4.1137-0.78539,0.62355-1.4662-2.3838-2.9996-1.9703-1.5334,0.41408-1.8738,2.5229-1.6342,3.3522,0.23904,0.82926,3.5769,4.701,2.5216,5.1871-1.0575,0.48336-3.6479-3.2861-5.0442-0.72693-1.3984,2.5559,4.3954,5.1854,5.1093,5.8074,0.71602,0.62461,0.0699,0.79837,1.0911,2.0758,1.0239,1.2758,2.3871,1.5897,3.1021,2.4553,0.7139,0.86388,2.8278,4.9738,2.8278,7.6353,0.00036,2.6637-0.1686,3.6352-0.1686,3.6352zm15.388,22.438s-1.4182-1.6558-0.94813-4.3746c0.46792-2.7221,2.3439-7.5215,1.7041-8.1258-0.63866-0.60298-2.6394,2.9386-3.1522,2.1191-0.51167-0.82167,1.1498-5.6194,0.29932-7.6081-0.8542-1.9865-0.93745-3.2395-2.6416-3.0664-1.7052,0.17268-2.4276,5.7904-3.236,4.7979-0.81205-0.9927,0.46632-3.4988-0.087-4.8391-0.55329-1.3402-0.8526-1.8171-1.7041-1.6027-0.851,0.21705-1.2352,2.8092-1.8312,2.7681-0.5965-0.0444-1.5766-3.1162-2.8118-2.6777-1.2352,0.43031,2.9378,5.8753,2.9378,5.8753s0.74589-0.6479,1.1301-1.5778c0.38362-0.92993,0.76567-1.9459,0.76567-1.9459s0.342,1.7727,0.0432,2.4655c-0.29666,0.68852-0.53249,2.3118-0.53249,2.3118s-1.0223,0.32315-2.7046,0.0622c-1.6823-0.25549-3.0668-0.94776-3.0668-0.94776s1.129,0.7567,2.8524,1.2081c1.726,0.45522,3.5577,1.0176,3.5577,1.0176s0.44871,0.56023,1.2138,1.5746c0.76728,1.0171,1.4278,1.8799,1.4278,1.8799s0.49087-1.0354,0.98015-2.7438c0.4898-1.7061,1.6604-4.5143,1.6604-4.5143s-0.36176,3.3917-0.76675,5.055c-0.40389,1.6655-0.83021,4.0201-0.83021,4.0201s-1.4918-0.14993-3.4926-0.51908c-2.0013-0.3697-4.7289-1.0572-4.7289-1.0572s2.386,0.95156,4.7086,1.5762c2.3199,0.62301,3.7685,1.016,3.7685,1.016l1.8242,2.4103s0.49834-0.8774,1.2224-1.8896c0.72298-1.0209,1.2784-2.4022,1.2784-2.4022s-0.3196,1.8821-0.87344,3.0046c-0.55434,1.1243-0.93799,1.7938-0.93799,1.7938s-1.1717,0.28202-2.2575,0.25712c-1.0869-0.0195-3.3011-0.0427-3.3011-0.0427s1.853,0.62461,3.3224,0.86768c1.4699,0.236,2.5354,0.38593,2.5354,0.38593s0.10565,0.66901,0.89369,1.7954c0.78699,1.1215,1.7783,1.6726,1.7783,1.6726z'/%3E %3C/g%3E %3Cg id='ribbon'%3E %3Cpath fill='%23fff' d='m412.7,331.62s-0.83128-0.89364-1.9378-1.4772c-1.1076-0.58186-1.4795-0.40921-1.4795-0.40921l-0.51274-0.18294,0.97053-2.5294,7.2944-6.968,1.129-7.0038,0.26891-0.007,4.2263-0.0444-0.0454,9.5594,1.3408,0.60676,8.1413,4.8824-0.0261,2.1256s-0.40336,0.14346-1.1893,0.4536c-0.78966,0.31502-0.97854,0.54563-0.97854,0.54563l-3.0722,0.2885-5.3666-3.8907-2.2164-2.3302-4.0448,5.1822-2.5024,1.1984z'/%3E %3Cpath fill='%23016848' d='m418.44,313.04s-0.12005,0.36971-0.17233,1.4463c-0.0555,1.0766,0.071,6.7238-0.20489,7.4959-0.27477,0.77187-4.2012,2.3925-6.4454,4.3476-2.243,1.9622-2.3279,3.4014-2.3279,3.4014s-0.73949,0.0563-2.1315,0.5754c-1.3904,0.51583-2.0152,1.2948-2.0152,1.2948s0.82381-3.4826,4.4568-6.7083c3.6388-3.2315,5.396-3.5037,5.8005-4.0461,0.4071-0.53748,0-6.7174,0.088-7.217,0.0822-0.49473,0.5186-0.53912,0.81899-0.58347,0.29932-0.0433,2.1326-0.006,2.1326-0.006z'/%3E %3Cpath fill='%23016848' d='m427.71,333.68s0.57197-1.121,0.93958-1.4977c0.36601-0.37404,1.2517-1.009,1.2517-1.009s0.13819-0.14182-1.8498-1.0073c-1.988-0.86388-3.0103-0.57647-4.429-1.5827-1.4187-1.0074-2.8406-2.7373-2.8406-2.7373l-1.9026,1.6985s1.1392,1.6141,2.2164,2.6512c1.0762,1.0349,3.5188,1.3819,4.5992,1.9865,1.0788,0.60675,2.0152,1.4977,2.0152,1.4977z'/%3E %3Cpath fill='%23cd202a' d='m422,313s2.1518-0.12829,2.4511,0.20459c0.29719,0.3329,0.25344,0.70204,0.26624,0.81248,0.009,0.10393,0.11205,5.2207-0.26624,6.9023-0.40016,1.7576-1.3083,3.5118-1.8205,4.0326-0.51221,0.51802-3.7471,3.3441-5.2822,4.8391-1.5329,1.4977-3.093,3.6325-3.093,3.6325s-0.56824-0.63493-1.0516-1.2417c-0.48072-0.60463-0.96785-0.80596-0.85313-1.2081,0.11312-0.40218,1.734-2.8244,4.3185-4.524,2.5819-1.7001,4.7427-3.6293,5.224-6.3941,0.48713-2.767,0.10671-7.0556,0.10671-7.0556z'/%3E %3Cpath fill='%23cd202a' d='m436.38,330.48s-0.51701-0.52072-2.337-0.55105c-1.8269-0.0314-1.9763,0.24411-1.9763,0.24411s-1.0031-1.2644-2.6122-2.3118c-1.6108-1.049-2.8246-0.89363-4.5555-2.0331-1.7324-1.141-2.641-2.8049-2.641-2.8049l1.3344-2.7107s1.4923,2.0975,3.0375,3.2363c1.5489,1.1378,4.9812,2.2474,6.0773,3.2071,1.0922,0.95535,3.673,3.724,3.673,3.724z'/%3E %3C/g%3E %3C/g%3E %3Cg id='water'%3E %3Cpath fill='%2330c2dc' stroke='%230872a7' stroke-width='0.7' d='m452.73,299.48s-4.6857-1.8166-4.3474-3.462c0.34147-1.6406,10.824-4.4044,10.824-4.4044l0.16754-2.7649s-1.5329-0.0855-4.1756,0.77839c-2.6411,0.86387-6.8162,1.9865-11.328,1.9865-2.7403,0-4.2257-0.28633-4.97-0.51095-0.48393-0.14672-36.95-2.2886-38.139-2.2767-0.51327,0.01-1.1664-0.007-1.9896-0.0628-4.8564-0.34642-7.9794-7.7785-7.9794-7.7785l-2.2996,0.40218s0.70589,3.652-0.51274,3.9752c-2.3839,0.63492-18.229-7.8373-18.229-7.8373l-0.87505,3.4366s9.6882,5.1822,9.3959,7.1096c-0.29185,1.9259-3.1645,1.7792-3.1645,1.7792l1.2314,2.3102c0.43539,0.0395,15.95,0.78811,16.214,5.4462,0.10831,1.8815-3.8047,2.9955-3.8047,2.9955l1.305,1.593v0.79297s8.6169,0.0515,11.003,1.3836c2.385,1.3342,3.5994,3.2585,6.5224,4.9365,2.9207,1.6801,22.752,1.2698,25.851,0.39891,3.5022-0.9873,5.6541-4.956,11.35-6.6842,5.6952-1.7262,7.5349-1.8128,7.5349-1.8128z'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='373.416' cy='292.05' r='2.745'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='389.095' cy='279.26' r='2.746'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='454.822' cy='299.74' r='2.817'/%3E %3Cpath fill='%23f8c83c' d='m361.11,275.15c-0.8953,2.072,2.6384,6.0051,5.1093,6.4369,2.4714,0.43194,3.8341-0.17104,4.2604-1.3819,0.42683-1.2136,0.095-2.5278-0.46847-3.2823-1.5761-2.1191-8.0094-3.8469-8.9011-1.7727z'/%3E %3Cpath fill='%23fff' d='m368.9,278.31c-0.0672-1.252-2.1289-2.4655-3.4494-2.4655-1.3206,0-2.6421-0.0412-2.4282,0.65116,0.21183,0.68905,3.6207,1.6011,3.705,1.987,0.0854,0.38919-1.0218,0.86228-0.46792,1.3819,0.55381,0.51964,1.2352,0.13208,1.7895-0.25765,0.5538-0.39027,0.89315-0.51908,0.85099-1.2969z'/%3E %3Cpath fill='%23f8c83c' d='m390.71,301.99c0.56664,1.8252-0.851,2.7183-2.6843,3.5416-1.8312,0.82113-5.5788,0.34317-6.4305-1.1226-0.85313-1.4696,1.3627-3.8469,3.6201-4.4093,2.2575-0.56076,4.9823,0.34642,5.4943,1.9903z'/%3E %3Cpath fill='%23fff' d='m386.92,303.07c0.71604-0.12396,0.72507,1.0831,1.3638,0.99216,0.6392-0.0839,1.192-1.121,1.0212-1.8138-0.16968-0.69231-1.3638-1.6423-2.385-1.5546-1.0223,0.0871-4.0459,2.6344-3.7066,3.3267,0.34147,0.68905,1.0223,0.60517,1.5777,0.34696,0.55435-0.26035,1.3627-1.1675,2.1289-1.2975z'/%3E %3Cpath fill='%23f8c83c' d='m458.35,292.53c1.661,2.2095,4.6563,0.17266,5.4495-0.68798,0.79608-0.86549,3.2371-2.2767,2.2441-3.7181-0.99612-1.4393-2.6966-1.324-3.8341-1.2698-1.1359,0.0579-3.4649,1.7316-3.8597,2.5067-0.39858,0.7816-0.73949,2.1927,0,3.1692z'/%3E %3Cpath fill='%23fff' d='m458.89,291.07s0.14462-2.4071,2.3892-2.5067c1.2763-0.0574,1.3328,0.34696,2.3001,0.8953,0.96251,0.54451,1.3328-0.72047,1.3328-0.72047s0.0581,1.7002-1.5014,1.7559c-1.5638,0.0563-0.99827-0.69066-2.5291-0.92127-1.3499-0.20459-1.9918,1.4972-1.9918,1.4972z'/%3E %3C/g%3E %3Cg id='pedestal' fill='%23f9aa51' stroke='%23953220' stroke-width='0.7' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='m422.43,286.4-1.1087-0.71881s-2.2158-0.11367-3.7194-0.0855c-1.5073,0.0281-4.4866,0.17268-4.4866,0.17268l4.4552,12.934,5.3408,7.693,2.0462,0.73507,4.1462-0.27498,0.70534-2.0152-1.5601-12.475-5.8187-5.9656z'/%3E %3Cpath d='m407.71,287.21,0.21342-1.469s1.0079-0.12829,2.4138-0.17105c1.4059-0.0466,2.6336,0.092,2.7846,0.20082,0.14459,0.1088,3.1095,3.7316,4.1297,6.1056,1.0207,2.3795,2.2142,6.3525,3.5353,8.7766,1.3216,2.4174,4.1766,6.4796,4.1766,6.4796s-1.4289,0.0844-2.6864,0.0844c-1.256,0-2.6534,0.0444-2.6534,0.0444l-2.3951-0.92832-7.5178-11.688-2.0008-7.436z'/%3E %3Cpath d='m404.57,285.62s3.0668-0.0563,3.3512,0.11529c0.28439,0.17321,3.6916,3.2006,5.0533,6.9429,1.3654,3.7446,0.68243,4.2642,2.4458,8.1258,1.7564,3.8599,4.2017,6.4518,4.2017,6.4518s-5.1119,0.2885-8.0088-0.23114c-2.8972-0.51908-3.9195-0.46008-4.6019-1.2644-0.68081-0.80981-2.2724-1.7879-2.2724-1.7879h-2.8945l0.67974-4.0342-0.79392-9.0443,0.17073-4.6707,2.6688-0.60351z'/%3E %3Cpath d='m435.24,288.01-4.8836-2.0152-9.0871-0.46172s0.33668,2.4222,0.67815,4.6691c0.34147,2.2442,1.9341,7.545,3.4099,10.139,1.4758,2.5933,2.9548,5.7626,3.7509,6.5095,0.79661,0.75017,6.0217-1.4111,6.0217-1.4111l3.4051-0.51801-0.45352-3.7181-0.48446-1.1507,0.79821-10.574-0.74163-1.6406-2.4138,0.17214z'/%3E %3Cpath d='m403.09,288.07c0,1.1546,1.2223,1.2119,1.534,1.1546,0.31106-0.0595,1.3638-0.46226,1.3638-2.0201,0-1.5546-0.96465-2.7627-2.8694-2.8785-1.9032-0.11529-3.3496,2.2771-3.3496,3.888,0,1.6124,1.6172,2.4488,1.6172,3.0555,0,0-1.6172,1.4977-1.5334,4.117,0.0843,2.6236,2.2158,4.6399,2.2158,4.6399s-2.2729,1.8138-2.2729,3.6304c0,1.8155,1.7341,3.0225,3.3523,3.0225,1.6183,0,3.6916-1.0354,3.6916-2.4157,0-1.3852-1.2213-2.2176-2.2436-2.2176-1.0228,0-1.448,0.60138-1.448,1.0636'/%3E %3Cpath d='m436.8,288.8c0,1.1242-0.72614,1.1708-1.3654,1.1708-0.63919,0-1.4902-0.34805-1.4902-1.776,0-1.4246,1.8754-2.2024,3.0684-2.2024,1.1893,0,3.2371,1.6406,3.2371,3.6309,0,1.9865-1.4496,3.3267-1.4496,3.3267s0.89369,0.4303,0.89369,2.9354c0,2.5094-1.6167,4.321-1.6167,4.321s2.1113,0.82439,2.1113,3.4176c0,2.589-1.7911,3.4366-3.0284,3.4366-1.2362,0-3.3886-0.7367-3.3886-2.5077,0-1.7759,1.1098-2.3979,1.9603-2.3979,0.85154,0,1.6834,0.9943,1.6834,1.9654'/%3E %3Cpath fill='%23953220' stroke='none' d='m406.22,302.5s0.31639,0.20787,0.55541,0.71561c0.24383,0.5126,0.41778,1.3321,0.97907,1.8317,1.1071,0.99436,9.5402,1.2991,12.098,1.2991,2.5547,0,10.221,0.34642,11.671-0.51909,1.4502-0.86281,1.6188-2.2918,2.513-2.9402,0.89369-0.64631,1.1503-0.6019,1.1503-0.6019l-1.1082,0.94835-0.0811,1.8138,0.65624,0.99436s-0.14619,0.52126-1.0436,1.0831c-0.89369,0.56241-1.7031,0.73397-2.9382,0.86441-1.2352,0.12992-17.377,0.0855-19.98-0.3448-2.5968-0.43518-2.426-0.39081-3.1928-0.95155-0.76727-0.56024-1.1935-1.167-1.1935-1.167l0.34147-1.1654-0.42737-1.8604z'/%3E %3Cpath fill='%23953220' stroke='none' d='m432.41,287.01,1.448,0.63492s-1.2368,0.38431-2.1694,2.9365c-0.93959,2.5527-0.17233,3.3716-0.80938,3.6293-0.64027,0.26199-7.6262,0.0444-7.6262,0.0444l-1.1962-2.8985,10.353-4.3465z'/%3E %3C/g%3E %3Cg id='cactus' fill='%23231f20'%3E %3Cpath d='m454.69,286s-1.193-0.43196-1.7453-1.4263c-0.55595-0.9943-1.0244-2.2474-0.59971-2.5077,0.43057-0.25927,1.3216,0.60297,1.24,1.3852-0.088,0.77619,1.105,2.5489,1.105,2.5489z'/%3E %3Cpath d='m468.34,282.23s0.85207,1.5535,1.1487,1.7251c0.30038,0.17267,1.6594,0.78324,1.6594,0.78324s-1.9144,0,-2.5093-0.52126c-0.59971-0.51962-1.4496-1.9459-1.4496-1.9459l1.1509-0.0412z'/%3E %3Cpath d='m472.46,283.49s-1.1503,0.68905-2.1273,0.30202c-0.98014-0.38971-1.7442-0.95321-1.367-1.3819,0.38682-0.43411,0.63812-0.26036,1.1503,0.29987,0.51274,0.56509,2.3439,0.77999,2.3439,0.77999z'/%3E %3Cpath d='m479.4,277.61s-0.93798,0.82544-1.6188,0.82544-2.0462-0.26359-2.0462-0.56561c0-0.30151,1.7879-0.47471,2.0867-0.43033,0.302,0.0427,1.5782,0.17051,1.5782,0.17051z'/%3E %3Cpath d='m469,263.83s-1.5361,0.47363-2.0445,1.2547c-0.50849,0.77672-0.38364,1.6406,0.25663,1.5962,0.63706-0.0412,0.80938-0.90555,0.80938-1.1659,0-0.25548,0.97854-1.685,0.97854-1.685z'/%3E %3Cpath d='m462.15,267.59s-1.1493,0.7302-1.4481,1.3819c-0.30093,0.64577-0.55596,2.0277,0.12485,2.0742,0.68401,0.0427,0.89903-1.0392,0.93798-1.5995,0.0454-0.56241,0.38523-1.8566,0.38523-1.8566z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='0.7' d='m449.89,275.88-3.7594,3.9806s8.6468,4.8407,15.29,4.6252c6.6474-0.21435,14.231-5.4014,14.738-6.4834,0.5138-1.0766,0.0875-5.7032-0.76723-7.1742-0.85212-1.4674-5.451-5.054-7.1966-4.8823-1.7442,0.17267-4.8158,2.5061-7.6685,5.2726-2.8545,2.7665-2.5584,5.0967-6.5175,4.8851-3.9621-0.21651-4.1201-0.22355-4.1201-0.22355z'/%3E %3Cpath fill='%230c8489' d='m448.93,277.47s9.2575,1.3852,11.923-0.97812c2.6736-2.3605,5.5681-6.9712,7.4435-8.0099s2.7228-1.0387,2.7228-1.0387,1.3798,0.87852,2.0168,1.4295c0.64027,0.54451,2.3567,1.9556,2.3567,1.9556l0.7411,4.3974,0.0555,2.4174-2.8929,2.3659-5.3147,2.4482-5.0805,1.5827-4.3169-0.11528-8.744-2.5359-2.2185-1.5697-0.56878-0.50448,1.8765-1.8447z'/%3E %3Cpath fill='%2304534e' d='m463.04,272.14c0-0.78971,0.51701-0.75022,1.2224-0.75022,0.70534,0,1.4758,0.13477,1.4758,0.92286,0,0.78807-0.76989,1.9291-1.4758,1.9291-0.70588,0-1.2224-1.3121-1.2224-2.1018z'/%3E %3Cpath fill='%2304534e' d='m466.76,274.47c0-0.70962,0.54478-1.095,1.3894-1.095,0.84833,0,1.6188,0.94829,1.6188,1.6558,0,0.70908-0.68563,1.2828-1.5276,1.2828-0.84779-0.00036-1.4806-1.1351-1.4806-1.8436z'/%3E %3Cpath fill='%2304534e' d='m465.48,280.01c0-0.88552,0.54265-1.0691,1.391-1.0691,0.84512,0,1.3654,0.39892,1.3654,1.2828,0,0.88065-0.69098,1.5995-1.5361,1.5995-0.84833,0.00037-1.2202-0.93317-1.2202-1.8133z'/%3E %3Cpath fill='%2304534e' d='m460.6,278.31c0-0.9451,0.89742-1.2401,1.6594-1.2401,0.76086,0,1.3782,0.76808,1.3782,1.718,0,0.94669-0.6173,1.7115-1.3782,1.7115-0.76194,0-1.6594-1.2434-1.6594-2.1895z'/%3E %3Cpath fill='%2304534e' d='m452.87,279.25c0-1.0458,0.84673-1.8912,1.8888-1.8912,1.0431,0,1.8898,0.84604,1.8898,1.8912,0,1.0387-0.84673,1.8842-1.8898,1.8842-1.042,0.00036-1.8888-0.84549-1.8888-1.8842z'/%3E %3Cpath fill='%238cbebf' d='m466.76,274.47c0-0.63872,0.8729-1.095,1.3894-1.095,0.5202,0,0.93959,0.51475,0.93959,1.1545,0,0.63332-0.41937,1.1508-0.93959,1.1508-0.51649-0.00037-1.3894-0.57594-1.3894-1.2103z'/%3E %3Cpath fill='%238cbebf' d='m465.51,279.78c0-0.7334,0.67601-1.0387,1.4496-1.0387,0.77523,0,1.3606,0.30474,1.3606,1.0387,0,0.73072-0.62906,1.3224-1.4027,1.3224-0.77737,0-1.4075-0.59212-1.4075-1.3224z'/%3E %3Cpath fill='%238cbebf' d='m460.63,278.16c0-0.80922,1.3296-1.1773,1.8786-1.1773,0.54901,0,0.45351,0.54072,0.45351,1.3521,0,0.81461-0.44871,1.469-0.99772,1.469-0.54741,0-1.3344-0.8276-1.3344-1.6439z'/%3E %3Cpath fill='%238cbebf' d='m462.93,272.05c0-0.74045,0.5752-0.77838,1.0532-0.77838,0.47485,0,0.82274,0.22247,0.82274,0.96455,0,0.74044-0.38735,1.3391-0.8649,1.3391-0.48124-0.00036-1.0111-0.78539-1.0111-1.5254z'/%3E %3Cpath fill='%238cbebf' d='m452.85,278.68c0-0.85901,0.74751-1.6704,1.8466-1.6704,1.0986,0,2.2132,0.37891,2.2132,1.2363,0,0.85954-1.3424,2.3345-2.441,2.3345-1.1018,0.00036-1.6188-1.0414-1.6188-1.9004z'/%3E %3Cpath d='m456.39,277.18s-1.2779,0.2176-1.9602,0.86607c-0.67923,0.64791-0.76727,1.3852-0.38203,1.5995,0.38203,0.21434,0.85314-0.47688,0.98014-0.77839,0.12486-0.3042,1.3622-1.6872,1.3622-1.6872z'/%3E %3Cpath d='m462.53,275.84s-1.2341,0.86607-1.3606,1.7315c-0.13018,0.86713,0,1.2958,0.34147,1.3402,0.34147,0.0412,0.55061-1.1258,0.42577-1.5578-0.12699-0.42869,0.5933-1.514,0.5933-1.514z'/%3E %3Cpath d='m463.55,277.14s-0.80831,0.0412-1.3622,0.56076c-0.55114,0.52071-1.0629,1.167-0.67922,1.2114,0.38041,0.0412,0.98175-0.25873,1.0191-0.60623,0.0437-0.3448,1.0223-1.1659,1.0223-1.1659z'/%3E %3Cpath d='m464.87,270.01s-0.64027,0.51963-0.98014,0.82006c-0.34306,0.30475-0.76562,1.167-0.34306,1.3868,0.42897,0.2176,0.72613-0.17483,1.0238-0.77672,0.29932-0.61056,0.29932-1.43,0.29932-1.43z'/%3E %3Cpath d='m469.52,272.99s-1.1957,0.16835-1.5761,0.68799c-0.38203,0.51963-0.64187,1.1264-0.12859,1.1264,0.50901,0,0.63705-0.26035,0.85206-0.73397,0.21449-0.47472,0.85261-1.0804,0.85261-1.0804z'/%3E %3Cpath d='m468.79,278.48s-0.25344,0.82114-0.97855,1.2087c-0.72452,0.39242-0.93585,0.73666-1.2346,0.21705-0.29932-0.51746,0.0843-0.77839,0.46792-0.91042,0.38308-0.12612,1.7452-0.51531,1.7452-0.51531z'/%3E %3Cpath fill='%2304534e' d='m476.2,274.76s0.5138,2.5494-1.7004,3.8004c-2.2148,1.2547-8.4352,5.6621-14.312,5.1427-5.8801-0.51908-12.568-3.888-12.568-3.888l-0.93477,0.43194,1.4891,0.64791,4.5587,1.8999,5.1925,1.515,3.2408,0.21434,2.8118-0.34642,5.1941-1.7251,4.4012-2.249,2.2852-1.8154,0.61254-0.75022-0.0566-1.0636v-1.4696l-0.21395-0.34481z'/%3E %3Cpath d='m360.78,241.54s1.3638,1.167,1.2352,2.1597c-0.12859,0.99435-0.46952,1.3868-0.85048,1.2119-0.38468-0.17322-0.38468-1.2119-0.29931-1.6406,0.0848-0.43735-0.0854-1.731-0.0854-1.731z'/%3E %3Cpath d='m370.86,250.91s-0.38469,1.7262-1.0671,1.8994c-0.68029,0.17321-1.1914-0.56023-1.0645-0.86387,0.12859-0.30367,0.68189-0.0427,0.98068-0.30367,0.29772-0.25548,1.1508-0.73179,1.1508-0.73179z'/%3E %3Cpath d='m348.92,252.25s0.46739,0.99435,1.3627,1.167c0.89369,0.17159,1.3216-0.43356,1.193-0.73505-0.12751-0.30042-0.51113-0.21761-0.98068-0.21761-0.46792,0-1.575-0.21434-1.575-0.21434z'/%3E %3Cpath d='m352.84,259.94s0.81045,0.95321,1.9171,1.0814c1.1066,0.12882,1.661-0.73506,1.7452-0.99436,0.0854-0.25981-1.2768-0.21705-1.7041,0.12882-0.42471,0.34642-1.9582-0.21597-1.9582-0.21597z'/%3E %3Cpath d='m359.78,265.86s1.7879-0.34642,2.0851-0.81953c0.29986-0.47632,0.76728-1.2964,0.38469-1.7738-0.38469-0.47307-0.68189,0.73505-0.89476,1.2081-0.21289,0.47849-1.575,1.3852-1.575,1.3852z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='0.7' d='m370.95,261.16s1.1946-8.0104-5.2822-13.657c-6.4753-5.6456-10.678-4.2642-12.895-2.1863-2.2142,2.071-4.1446,8.8728,2.7264,14.808,6.8734,5.9341,15.337,4.091,15.337,4.091l0.11312-3.0555z'/%3E %3Cpath fill='%230c8489' d='m351.2,252.68s-0.12271-4.4006,1.9555-5.7102c2.0787-1.3158,8.9257-2.4569,12.301,4.045,3.3742,6.4962,3.4414,9.7464,2.5899,13.032l-3.6121-0.0358-5.5894-2.2788-4.635-3.4231-3.0103-5.6295z'/%3E %3Cpath fill='%2304534e' d='m370.09,262.31s-1.1344,1.2682-3.4644,1.154c-2.3284-0.11692-13.176-2.9397-15.903-12.676l0.17128,2.1305,0.11258,0.69232,0.71497,1.9622,2.2825,3.3137,2.8646,2.4553,3.6116,1.868,2.5904,0.75995,3.3726,0.58893h1.9432l1.7041-2.249z'/%3E %3Cpath fill='%2304534e' d='m364.44,259.5c0-0.86874,0.44497-0.89529,1.136-0.89529,0.6899,0,1.2207-0.30475,1.2207,0.56076,0,0.86767-0.47379,2.1186-1.1637,2.1186-0.68989,0-1.193-0.91966-1.193-1.7841z'/%3E %3Cpath fill='%2304534e' d='m364.9,254.35c0-0.59977,0.54581-1.0831,1.224-1.0831,0.67387,0,1.2181,0.48337,1.2181,1.0831,0,0.59703-0.54474,1.0766-1.2181,1.0766-0.67762,0-1.224-0.48012-1.224-1.0766z'/%3E %3Cpath fill='%2304534e' d='m359.98,260.03c0-0.46768,0.61628-0.84871,1.3771-0.84871,0.76139,0,1.3776,0.38106,1.3776,0.84871,0,0.4682-1.3685,1.1085-2.1299,1.1085-0.75979,0-0.62477-0.63979-0.62477-1.1085z'/%3E %3Cpath fill='%2304534e' d='m359.53,253.96c0-0.76321,0.37029-0.51963,1.0377-0.51963,0.66746,0,1.4902,0.2176,1.4902,0.98133,0,0.76371-0.82327,1.7857-1.4902,1.7857-0.66692,0-1.0377-1.4858-1.0377-2.2474z'/%3E %3Cpath fill='%2304534e' d='m354.96,254.98c0-0.64305,0.43325-1.5421,1.249-1.5421,0.81525,0,1.7025,0.8985,1.7025,1.5421,0,0.64412-0.65997,1.167-1.4768,1.167-0.81419,0-1.4747-0.52288-1.4747-1.167z'/%3E %3Cpath fill='%2304534e' d='m355.78,249.61c0-0.66575,0.45353-0.63167,1.2912-0.63167,0.83929,0,1.5206,0.33993,1.5206,1.0106,0,0.66633-0.98014,1.4961-1.8188,1.4961-0.83876,0-0.99292-1.2038-0.99292-1.875z'/%3E %3Cpath fill='%2304534e' d='m360.73,249.09c0-0.64631,0.55007-0.43412,1.3344-0.43412,0.78646,0,1.4214,0.52288,1.4214,1.1675,0,0.64304-1.0041,1.3667-1.7901,1.3667-0.78378,0.00036-0.96571-1.4571-0.96571-2.1002z'/%3E %3Cpath fill='%238cbebf' d='m355.78,249.47c0.11258-0.46225,0.43378-0.77999,1.0218-0.77999,0.58742,0,1.1066,0.11042,1.1066,0.77999,0,0.66576-0.47699,1.2119-1.0639,1.2119-0.58849,0.00036-1.2245-0.56508-1.0645-1.2119z'/%3E %3Cpath fill='%238cbebf' d='m354.87,254.74c0-0.65117,0.32653-1.2666,0.99292-1.2666,0.66638,0,1.193,0.066,1.193,0.721,0,0.65442-0.58369,1.4111-1.2496,1.4111-0.66639,0-0.93638-0.21272-0.93638-0.86548z'/%3E %3Cpath fill='%238cbebf' d='m360.69,249.18c0-0.51801,0.44391-0.57541,1.0788-0.57541,0.63385,0,1.05,0.13207,1.05,0.64631,0,0.51962-0.51435,0.93643-1.1498,0.93643-0.63546,0.00054-0.97908-0.48986-0.97908-1.0073z'/%3E %3Cpath fill='%238cbebf' d='m359.56,254.23c0,0.70909,0.52021,1.2861,1.1637,1.2861,0.64346,0,1.3344-0.56403,1.3344-1.2699,0-0.71234-0.71924-1.3857-1.3627-1.3857-0.64402,0.00036-1.1354,0.66202-1.1354,1.3694z'/%3E %3Cpath fill='%238cbebf' d='m365.1,253.49c0,0.64197,0.55809,1.1675,1.248,1.1675,0.69044,0,1.2496-0.52612,1.2496-1.1675,0-0.64577-0.55916-1.1654-1.2496-1.1654-0.68937,0-1.248,0.51963-1.248,1.1654z'/%3E %3Cpath fill='%238cbebf' d='m359.76,259.97c0-0.56349,0.58528-1.108,1.1653-1.108,0.57941,0,1.1354,0.35778,1.1354,0.9218,0,0.564-1.0084,1.3256-1.5895,1.3256-0.58047,0-0.71121-0.57541-0.71121-1.1394z'/%3E %3Cpath fill='%238cbebf' d='m364.47,259.14c0-0.69065,0.52714-0.74858,1.2496-0.74858,0.72245,0,1.0783,0.0693,1.0783,0.76161,0,0.69233-0.58368,1.2579-1.3051,1.2579-0.72245,0.00036-1.0228-0.57807-1.0228-1.2709z'/%3E %3Cpath d='m365.75,251.04s0.72245,0.90556,0.85047,1.5963c0.12698,0.69064,0.12698,1.4706-0.12805,1.5584-0.2561,0.0855-0.68083-0.4341-0.80885-1.0804-0.12698-0.65117,0.0864-2.0742,0.0864-2.0742z'/%3E %3Cpath d='m361.62,246.63s0.46791,0.73725,0.46791,1.3857c0,0.64738-0.0854,1.3386-0.42576,1.3386-0.33988,0-0.33988-0.64738-0.33988-1.1242,0-0.47362,0.29773-1.6,0.29773-1.6z'/%3E %3Cpath d='m356.76,247.28s0.46899,0.73724,0.46899,1.3852c0,0.6463-0.0854,1.3392-0.42578,1.3392-0.34146,0-0.34146-0.64791-0.34146-1.121,0-0.47849,0.29825-1.6032,0.29825-1.6032z'/%3E %3Cpath d='m355.06,248.19s0.63866,0.17321,1.192,0.60349c0.55381,0.43195,0.76673,0.94942,0.55381,1.2098-0.21289,0.25928-0.72351-0.12667-0.851-0.43195-0.12912-0.30257-0.89476-1.3814-0.89476-1.3814z'/%3E %3Cpath d='m358.76,253.28s0.93691,0.0427,1.4491,0.51909c0.51062,0.47687,0.93585,0.86607,0.63813,1.2119-0.29772,0.34481-1.0228-0.26035-1.3216-0.6035-0.29772-0.34589-0.76568-1.1275-0.76568-1.1275z'/%3E %3Cpath d='m354.25,253.11s0.85261,0.21325,1.2773,0.51638c0.42736,0.30474,0.55488,0.91041,0.34146,1.0387-0.21288,0.12666-0.5106-0.0871-0.89369-0.47471-0.38361-0.39134-0.72511-1.0804-0.72511-1.0804z'/%3E %3Cpath d='m365.15,256.53s0.29932,1.0371,0.29932,1.7678c0,0.73725,0.0854,1.3852-0.2561,1.3852-0.34041,0-0.51115-0.90662-0.51115-1.469,0-0.56403,0.46793-1.6839,0.46793-1.6839z'/%3E %3Cpath d='m363.92,258.21s0.76727,0.30204,1.1076,0.6035c0.3404,0.30475,0.42684,0.77946,0.17074,0.86548-0.25505,0.0861-0.42578-0.47469-0.63974-0.69065-0.21181-0.21597-0.63866-0.77838-0.63866-0.77838z'/%3E %3Cpath d='m359.06,258.51s0.82007,0.0974,1.1776,0.34155c0.35641,0.24358,0.3927,1.3646,0.35641,1.5102-0.0347,0.14343-0.56931,0.046-0.78592-0.48769-0.21129-0.53587-0.74804-1.364-0.74804-1.364z'/%3E %3Cpath fill='%2304534e' d='m357.18,243.69s-4.2913,0.93045-5.0746,3.697c-0.78539,2.7665-0.81953,5.8416-0.81953,5.8416l-0.61414-3.5232,0.85367-2.2826,1.248-2.0969,1.8888-1.1886,1.7015-0.58732,0.81633,0.1402z'/%3E %3Cpath fill='%2304534e' d='m370.57,260.1s0.44444-1.0712-0.81579-4.458c-1.2629-3.3884-3.8517-7.8154-3.8517-7.8154l2.012,2.2821,1.5996,2.5938,0.78431,2.3838,0.57947,2.1797-0.0336,2.1402-0.27424,0.69391z'/%3E %3Cpath d='m374.91,254.62s1.4897,0.97592,1.639,1.5134c0.15047,0.54239,0.21183,0.71556-0.16913,0.86607-0.38415,0.15482-1.002-0.45196-1.1728-0.86607-0.17073-0.41082-0.29718-1.5134-0.29718-1.5134z'/%3E %3Cpath d='m368.62,271.52s0.70375-1.3175,1.6401-1.8138c0.93638-0.49636,1.6391-0.43411,1.8952-0.12883,0.25611,0.30204-0.61734,0.9927-1.2554,1.2314-0.63974,0.23816-2.2799,0.71122-2.2799,0.71122z'/%3E %3Cpath d='m379.19,275.56s1.0442-0.49635,1.726-1.233c0.68189-0.73072,0.76722-1.2498,0.51061-1.5102-0.25451-0.25927-1.1071,0.1743-1.4913,0.75617-0.38308,0.58027-0.74536,1.987-0.74536,1.987z'/%3E %3Cpath d='m378.04,274.57s0.36227-1.3602,0.72565-1.7938c0.36174-0.43194,0.87184-0.66902,1.256-0.43194,0.38523,0.23708,0.1494,0.84603-0.12858,1.1659-0.27584,0.32585-1.853,1.0598-1.853,1.0598z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='0.7' d='m395.71,266.52s-6.5844-9.5231-16.811-10.026c-8.1793-0.4038-10.763,6.9001-10.465,9.1031,0.29239,2.1684,3.3651,6.9284,14.27,7.7326,10.905,0.80757,12.665-5.1394,13.12-5.4297,0.45298-0.28851-0.11418-1.3802-0.11418-1.3802z'/%3E %3Cpath fill='%230c8489' d='m387.94,259.98s2.7264,2.078,3.8778,3.7181c1.1492,1.6406,1.4054,2.8531,0.72405,3.0702-0.68297,0.21111-6.603-5.2759-11.459-6.4401-4.8574-1.1686-9.0732-0.0855-10.011,2.2474-0.93532,2.3345-0.5949,5.8336,1.6204,7.2565,2.2153,1.4312,12.609,3.1129,12.609,3.1129s4.7278-0.6479,4.8969-0.73233c0.17126-0.0871,3.0252-1.6866,3.0252-1.6866l0.63759-1.6423,0.76776-2.1614,0.34147-0.86441-2.5136-2.7649-4.516-3.1129z'/%3E %3Cpath fill='%2304534e' d='m379.59,261.32c0,0.61003-0.64133,0.91207-1.2773,0.91207-0.63652,0-1.1717-0.32152-1.1717-0.92992,0-0.61001,0.51489-1.1031,1.1498-1.1031,0.63546,0,1.2992,0.5126,1.2992,1.121z'/%3E %3Cpath fill='%2304534e' d='m373.59,263.48c0-0.61163,0.68617-0.60138,1.375-0.60138,0.68882,0,1.2464,0.50124,1.2464,1.1129,0,0.61003-1.0826,1.4528-1.7057,1.1578-0.7646-0.3697-0.9156-1.0523-0.9156-1.6693z'/%3E %3Cpath fill='%2304534e' d='m380.04,267.01c0-0.77727,0.65785-1.4084,1.471-1.4084,0.81098,0,1.4684,0.63113,1.4684,1.4084,0,0.77294-1.105,1.6152-1.916,1.6152-0.81205,0-1.0234-0.84276-1.0234-1.6152z'/%3E %3Cpath fill='%238cbebf' d='m375.16,268.45c0-0.67932,0.69894-0.81948,1.2997-0.81948,0.59811,0,1.3622,0.63819,1.3622,1.3175,0,0.67933-0.76407,1.1443-1.3622,1.1443-0.60024,0-1.2997-0.96133-1.2997-1.6423z'/%3E %3Cpath fill='%2304534e' d='m383.89,270.82c0-0.55372,0.33026-1.0474,0.89583-1.0474,0.56396,0,1.2554,0.33125,1.2554,0.88391,0,0.5575-0.56237,1.1675-1.1279,1.1675-0.56556,0-1.0234-0.44872-1.0234-1.0041z'/%3E %3Cpath fill='%2304534e' d='m387.81,267.83c0-0.70583,0.39909-0.63007,1.0874-0.63007,0.68828,0,1.383,0.39893,1.383,1.1031,0,0.70583-0.86489,1.0798-1.5537,1.0798-0.6883,0.00036-0.91666-0.8525-0.91666-1.5529z'/%3E %3Cpath fill='%238cbebf' d='m379.21,260.76c0,0.54564-0.22675,0.83898-0.76722,0.83898-0.5405,0-1.1935-0.29339-1.1935-0.83898,0-0.55104,0.2497-0.71721,0.78859-0.71721,0.54159-0.00037,1.1722,0.16617,1.1722,0.71721z'/%3E %3Cpath fill='%238cbebf' d='m376.08,263.31c0,0.59971-0.90437,0.97432-1.47,0.97432-0.56503,0-0.93691-0.37404-0.93691-0.97432,0-0.59544,0.43644-0.77513,1.002-0.77513,0.56503,0,1.4048,0.1797,1.4048,0.77513z'/%3E %3Cpath fill='%238cbebf' d='m377.47,268.35c0,0.52289-0.19847,0.92667-0.80831,0.92667-0.61146,0-1.407-0.40379-1.407-0.92667,0-0.52449,0.22036-0.88717,0.83129-0.88717,0.61147,0.00037,1.384,0.36321,1.384,0.88717z'/%3E %3Cpath fill='%238cbebf' d='m382.68,266.64c0,0.54885-1.074,1.167-1.6407,1.167-0.56503,0-0.80884-1.009-0.80884-1.5545,0-0.55104,0.45566-0.9927,1.0223-0.9927,0.5661,0,1.4272,0.83251,1.4272,1.3803z'/%3E %3Cpath fill='%238cbebf' d='m390.24,268.26c0,0.57215-0.90919,0.53913-1.4278,0.53913-0.51541,0-0.97907-0.63818-0.97907-1.2065,0-0.57539,0.17127-1.1031,1.4486-0.95321,0.51381,0.0606,0.95823,1.0506,0.95823,1.6206z'/%3E %3Cpath fill='%238cbebf' d='m385.77,270.57c0,0.57053-0.43805,1.0355-0.978,1.0355-0.53997,0-0.98016-0.46497-0.98016-1.0355,0-0.57375,0.43965-0.80002,0.98016-0.80002,0.54049,0,0.978,0.22625,0.978,0.80002z'/%3E %3Cpath d='m386.45,267.42s1.0639-0.34642,1.8722-0.2636c0.80991,0.0888,0.8542,0.39243,0.8542,0.51963,0,0.13153-0.64026,0.39242-0.93798,0.30149-0.29985-0.0828-1.7884-0.55751-1.7884-0.55751z'/%3E %3Cpath d='m382.02,271.17s0.8526-0.51963,1.4918-0.6463c0.63707-0.12829,1.1492,0.0839,1.106,0.47308-0.0427,0.39135-0.25343,0.4785-0.89369,0.4785-0.63759,0-1.7041-0.30529-1.7041-0.30529z'/%3E %3Cpath d='m379.17,264.61s1.8301,0.7784,2.2153,1.5118c0.38202,0.73504,0.55274,0.9088,0.16966,1.1242-0.38254,0.21596-0.81044-0.26198-1.0644-0.60463-0.25611-0.34479-1.3206-2.0314-1.3206-2.0314z'/%3E %3Cpath d='m378.7,266.94s1.4059-0.38756,2.0446-0.38756c0.64026,0,0.81044,0.0444,0.89529,0.34642,0.0854,0.29986-0.14245,0.43032-0.668,0.40217-0.52448-0.0304-2.2718-0.36103-2.2718-0.36103z'/%3E %3Cpath d='m374.21,267.03s1.5345,0.2046,1.9171,0.60515c0.38362,0.4038,0.38362,0.76647,0.22676,0.99217-0.1558,0.23276-0.88141,0.0877-1.1076-0.14344-0.22676-0.23058-1.0361-1.4539-1.0361-1.4539z'/%3E %3Cpath d='m373.99,269.24c0.0699-0.0709,0.59491-0.86553,1.1498-1.0501,0.55274-0.18782,1.1919-0.15805,1.304,0.12666,0.11631,0.28849-0.48072,0.72101-0.87771,0.80815-0.39749,0.0855-1.5761,0.11529-1.5761,0.11529z'/%3E %3Cpath d='m372.83,262.53l1.5195,0.41732c0.55435,0.41842,0.68082,0.75023,0.55435,0.91042-0.12913,0.15643-0.66694,0.24358-1.1226-0.0574-0.66852-0.45088-0.95135-1.2704-0.95135-1.2704z'/%3E %3Cpath d='m376.16,258.66s1.5489,0.43249,2.06,1.1367c0.50955,0.70742,0.43858,1.1258,0.18354,1.2693-0.2545,0.14398-0.8526-0.21543-1.1919-0.53047-0.34147-0.32043-1.0516-1.8755-1.0516-1.8755z'/%3E %3Cpath fill='%2304534e' d='m393.86,269.79s-3.1512,2.681-10.264,2.4222c-7.1154-0.26035-13.548-3.2861-15.165-6.6132l0.63813,1.6417,1.5772,2.1175,4.9839,2.5505,5.5798,1.2498,4.4306,0.26198,4.1745-0.73506s3.0658-1.469,3.2376-1.5546c0.16967-0.0855,0.51113-0.82167,0.51113-0.82167l0.29613-0.51908z'/%3E %3Cpath fill='%2304534e' d='m394.8,266.42s-1.192-1.4706-2.855-3.0258c-1.662-1.5578-8.1354-5.7514-8.1354-5.7514l5.2384,2.3795,3.4521,2.8975,2.4703,2.7178-0.1702,0.78212z'/%3E %3Cpath d='m395.1,260.11s1.7895,0.69231,2.0878,1.1242c0.29933,0.43032,0.68082,0.82167,0.68082,0.82167s-0.46738,1.1654-0.89369,0.69231c-0.42684-0.47849-0.51113-0.47849-0.98067-1.1264-0.46846-0.65117-0.89423-1.5118-0.89423-1.5118z'/%3E %3Cpath d='m400.42,257.26s1.6626,0.69232,2.258,1.514c0.5965,0.82113,0.46898,1.5118,0.21395,1.5989-0.25664,0.0877-1.3627-0.86553-1.535-1.2525-0.16967-0.38756-0.93692-1.8604-0.93692-1.8604z'/%3E %3Cpath d='m402.09,256.92s1.574,1.1692,1.8301,1.685c0.25664,0.51963,0.76727,1.2087,0.25664,1.3819-0.51274,0.1732-1.2357-0.60298-1.4486-1.0766-0.21396-0.47958-0.63814-1.9903-0.63814-1.9903z'/%3E %3Cpath d='m411.07,259.03s1.2357,0.42869,1.3643,1.469c0.12699,1.0387-0.12859,1.7722-0.12859,1.7722s-0.8526-0.73345-0.8526-0.95322c0-0.21272,0.1286-0.38755,0-0.86062-0.12698-0.47794-0.38309-1.4274-0.38309-1.4274z'/%3E %3Cpath d='m413.46,259.86s0.97908,0.99435,1.1087,1.6406c0.12645,0.64738,0.2529,1.0831-0.29772,1.167-0.55542,0.0909-0.85154-0.56242-0.85154-1.121,0-0.56563,0.0406-1.6866,0.0406-1.6866z'/%3E %3Cpath d='m397.36,279.48s0.76561,0.3448,1.4891,0.0855c0.72458-0.26036,1.3238-0.90662,1.193-1.3391-0.12592-0.43519-0.50955-0.82274-1.065-0.25982-0.55327,0.56023-0.25344,0.82274-0.68081,1.0333-0.42684,0.21813-0.93639,0.48011-0.93639,0.48011z'/%3E %3Cpath d='m406.22,281.89s1.193-0.17268,2.0029-1.0404c0.80885-0.86062,1.1508-1.4658,0.59596-1.6834-0.55273-0.21597-1.2778,0-1.4059,0.69065-0.12752,0.69232-1.193,2.0331-1.193,2.0331z'/%3E %3Cpath d='m413.5,282.15s0.89743-0.51964,1.5798-1.1654c0.67922-0.6495,1.0613-1.0354,0.5933-1.5123-0.46738-0.48012-0.80884-0.13371-1.0202,0.0855-0.21502,0.21759,0,0.21759-0.25556,0.90721-0.25878,0.69064-0.89743,1.685-0.89743,1.685z'/%3E %3Cpath d='m415.72,282.11s0.96038-1.1675,1.1823-1.8187c0.21449-0.64577,0.34148-1.3802-0.095-1.3392-0.43537,0.0412-0.96411,0.64951-0.99136,1.1264-0.0347,0.47308-0.096,2.0315-0.096,2.0315z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='0.7' d='m393.56,270.31c0.0624-3.2016,4.6003-10.587,9.8378-10.502,2.1812,0.0374,6.4577,1.1724,9.9254,2.7237,2.894,1.2958,3.8351,2.7254,5.7529,3.1984,1.9171,0.4747,4.8121,0.12828,4.8121,0.12828l6.5176-0.73345-5.1114,7.4772-1.8285,1.6406s-1.622,3.154-6.2632,4.9679c-4.644,1.8154-12.482,0.47525-16.018-0.38755-3.5353-0.86335-7.7096-4.2318-7.6246-8.5127z'/%3E %3Cpath fill='%2304534e' d='m393.56,270.31,0.34148,0.007c0.0106-0.7188,0.28865-1.7429,0.78752-2.8461,0.74483-1.6574,1.9827-3.5086,3.4969-4.9267,1.5168-1.4165,3.2952-2.3908,5.1226-2.3908h0.0838c1.0394,0.0195,2.6395,0.30474,4.398,0.78106,1.7591,0.47849,3.681,1.1459,5.396,1.9091,1.4187,0.63492,2.3487,1.2991,3.1874,1.8799,0.8377,0.5754,1.5942,1.0869,2.6208,1.3392,0.82647,0.20623,1.7927,0.26361,2.6507,0.26361,1.2485,0,2.2756-0.12233,2.2836-0.12504l5.7711-0.65117-4.6611,6.8178-1.8498,1.6585-0.0293,0.0563-0.002,0.007c-0.0747,0.14018-1.6818,3.0799-6.0794,4.8012-1.6268,0.63493-3.7055,0.87686-5.8518,0.87686-3.761,0-7.7331-0.73666-9.9617-1.2806-1.6844-0.40923-3.546-1.4263-4.9668-2.8428-1.4235-1.416-2.4004-3.2136-2.3988-5.205l0.002-0.12234-0.34148-0.007-0.34147-0.01-0.002,0.13857c0.002,2.2274,1.089,4.1928,2.6026,5.6979,1.5174,1.5102,3.4691,2.5754,5.2854,3.022,2.2686,0.55264,6.276,1.3029,10.121,1.3029,2.1977,0,4.3463-0.24413,6.096-0.92666,4.7449-1.8572,6.4192-5.0864,6.4422-5.133l-0.29932-0.15968,0.22409,0.2571,1.8594-1.6666,5.5649-8.1354-7.2634,0.81841s-0.0598,0.006-0.17074,0.0163c-0.33773,0.0341-1.1311,0.10068-2.0344,0.10068-0.82914,0-1.7543-0.0563-2.4901-0.2387-0.89049-0.22247-1.5601-0.66309-2.3951-1.2417-0.83395-0.5754-1.8204-1.2774-3.2995-1.934-1.7522-0.78971-3.7039-1.4625-5.4949-1.9492-1.7927-0.48769-3.4195-0.78486-4.5613-0.80922h-0.096c-1.3798,0-2.6971,0.48932-3.889,1.2515-1.79,1.141-3.3139,2.9067-4.4087,4.6945-1.0916,1.7922-1.7602,3.5962-1.7917,4.8954l0.34147,0.009z'/%3E %3Cpath fill='%230c8489' d='m425.21,271.31c-0.55275,0.43249-1.1492,0.43249-1.8306,0.43249-0.68564,0-15.207-8.8589-19.723-8.4715-4.5133,0.38756-8.8162,2.3345-8.9439,6.9594-0.12751,4.6215,1.0223,4.6664,1.9587,5.9624,0.93799,1.2975,9.7982,3.2433,9.7982,3.2433l5.4094-0.0909,4.3474-0.47307,3.8314-2.0742,2.0894-1.6834,1.4027-1.7294,1.661-2.0748z'/%3E %3Cpath fill='%2304534e' d='m402.26,268.95c0,0.90721-0.35054,1.5421-1.2336,1.5421-0.88087,0-1.5398-0.40056-1.5398-1.3077,0-0.90341,0.50101-1.2433,1.383-1.2433,0.883-0.00036,1.3904,0.10231,1.3904,1.009z'/%3E %3Cpath fill='%2304534e' d='m403.78,264.91c0-0.75402,0.72827-1.0836,1.5644-1.0836,0.83449,0,1.4768,0.30365,1.4768,1.0571,0,0.74857-0.65999,1.3256-1.4945,1.3256-0.8361,0-1.5468-0.54938-1.5468-1.2991z'/%3E %3Cpath fill='%2304534e' d='m412.48,267.27c0-0.65442,0.56236-1.1854,1.2586-1.1854,0.6915,0,1.2538,0.53099,1.2538,1.1854,0,0.65603-0.56236,1.187-1.2538,1.187-0.69627,0.00036-1.2586-0.53099-1.2586-1.187z'/%3E %3Cpath fill='%2304534e' d='m414.23,272.6c0-0.83737,0.60932-1.5134,1.3638-1.5134,0.75178,0,1.4539,0.35237,1.4539,1.187,0,0.8325-0.27213,1.6471-1.0244,1.6471-0.75125,0-1.7933-0.48606-1.7933-1.3207z'/%3E %3Cpath fill='%2304534e' d='m410.01,276.01c0-0.71721,0.63706-1.2964,1.4278-1.2964,0.78753,0,1.4246,0.57866,1.4246,1.2964,0,0.71775-0.56237,1.1822-1.3483,1.1822-0.78912,0-1.5041-0.46441-1.5041-1.1822z'/%3E %3Cpath fill='%2304534e' d='m402.04,274.63c0-0.69392,0.5613-1.2531,1.256-1.2531,0.69573,0,1.2581,0.55915,1.2581,1.2531,0,0.69231-0.56237,1.2531-1.2581,1.2531-0.69411,0-1.256-0.56076-1.256-1.2531z'/%3E %3Cpath fill='%238cbebf' d='m402.21,268.76c0,0.71181-0.61147,1.2964-1.3638,1.2964-0.75445,0-1.3638-0.58406-1.3638-1.2964,0-0.71721,0.60506-1.0008,1.3568-1.0008,0.75337,0.00053,1.3707,0.28363,1.3707,1.0008z'/%3E %3Cpath fill='%238cbebf' d='m406.43,264.65c0,0.69231-0.21502,1.1405-0.94547,1.1405-0.72826,0-1.6951-0.44818-1.6951-1.1405,0-0.69231,0.59329-1.2503,1.3205-1.2503,0.72827,0.00036,1.32,0.55803,1.32,1.2503z'/%3E %3Cpath fill='%238cbebf' d='m414.86,266.9c0,0.59544-0.55274,1.076-1.2352,1.076-0.68243,0-1.2352-0.4812-1.2352-1.076,0-0.59758,0.55275-1.0836,1.2352-1.0836,0.68242,0,1.2352,0.48606,1.2352,1.0836z'/%3E %3Cpath fill='%2304534e' d='m410.39,270.46c0,0.91207-0.35106,1.5464-1.2336,1.5464-0.88194,0-1.5409-0.40217-1.5409-1.3094,0-0.90662,0.50048-1.2412,1.384-1.2412,0.88247,0,1.3904,0.10231,1.3904,1.0041z'/%3E %3Cpath fill='%238cbebf' d='m404.3,274.33c0,0.71881-0.61199,1.2975-1.3638,1.2975-0.75178,0-1.3627-0.5786-1.3627-1.2975,0-0.71069,0.86543-1.0766,1.6199-1.0766,0.75071,0,1.1066,0.36645,1.1066,1.0766z'/%3E %3Cpath fill='%238cbebf' d='m410.13,270.31c0,0.71556-0.59063,1.2948-1.3206,1.2948-0.72826,0-1.32-0.57861-1.32-1.2948,0-0.7134,0.59171-1.2991,1.32-1.2991,0.72988,0,1.3206,0.58567,1.3206,1.2991z'/%3E %3Cpath fill='%238cbebf' d='m417.02,272.09c0,0.78811-0.4802,1.4165-1.3035,1.4165-0.8222,0-1.4897-0.63872-1.4897-1.423,0-0.78811,0.23903-1.0571,1.0602-1.0571,0.82167,0.00037,1.733,0.27551,1.733,1.0636z'/%3E %3Cpath fill='%238cbebf' d='m412.61,275.71c0,0.74211-0.49887,1.1637-1.2522,1.1637-0.75392,0-1.4758-0.42166-1.4758-1.1637,0-0.73831,0.64506-1.0442,1.3968-1.0442,0.7491,0,1.3312,0.30583,1.3312,1.0442z'/%3E %3Cpath d='m413.12,271.39s2.1673-0.21761,2.5525,0.17266c0.3863,0.38918,0.34201,0.9483,0.17073,1.1226-0.17073,0.1732-1.0238,0.21596-1.2352-0.0839-0.21128-0.30474-1.4881-1.2114-1.4881-1.2114z'/%3E %3Cpath d='m410.99,264.39s1.662,0.42869,2.3423,1.121c0.68188,0.69231,0.55541,1.3857,0.42843,1.514-0.12912,0.12666-0.72666,0.26035-1.1935-0.25766-0.46793-0.51908-1.5772-2.3773-1.5772-2.3773z'/%3E %3Cpath d='m406.05,267.76s1.9384,1.0571,2.3647,1.6601c0.42684,0.60517,0.53303,1.0836,0.34147,1.3392-0.19261,0.26036-1.1524-0.0644-1.3002-0.38756-0.14779-0.3226-1.4059-2.6117-1.4059-2.6117z'/%3E %3Cpath d='m405.2,269.25s2.1721,0.282,2.7051,0.69065c0.53249,0.41246,0.91613,0.43356,0.87291,0.75617-0.0416,0.3253-0.27531,0.56561-0.61734,0.51962-0.34148-0.0444-1.2784-0.45521-1.4902-0.6479-0.21395-0.19433-1.4705-1.3186-1.4705-1.3186z'/%3E %3Cpath d='m402.7,262.89s2.2164,0.34804,2.671,0.69231c0.45458,0.34804,0.56824,1.3288,0.056,1.6174-0.51114,0.28308-1.0783-0.28852-1.2491-0.69231-0.17127-0.4038-1.4779-1.6174-1.4779-1.6174z'/%3E %3Cpath d='m397.92,266.24s2.0382,0.96945,2.671,1.8712c0.34148,0.48606,0.63973,0.90502,0,1.1242-0.58421,0.19431-1.192-0.86388-1.192-1.1242,0-0.25874-1.479-1.8712-1.479-1.8712z'/%3E %3Cpath d='m397.47,268.89s1.3051-0.28851,1.9314-0.28851c0.62317,0,1.5222-0.21704,1.5334,0.28851,0.009,0.50664-0.76567,0.6019-1.2272,0.45684-0.45512-0.15535-2.2377-0.45684-2.2377-0.45684z'/%3E %3Cpath d='m408.75,276.17s1.4273-0.88878,2.1294-0.73671c0.70375,0.15317,0.93692,0.0888,0.93692,0.51909,0,0.43248-0.83075,0.34641-1.0874,0.34641-0.25557-0.00036-1.9789-0.12882-1.9789-0.12882z'/%3E %3Cpath d='m400.85,275.02s0.55167-0.82113,1.1487-0.90342c0.5965-0.0893,0.85154-0.0449,0.93692,0.21109,0.0854,0.26361-0.51061,0.73672-0.76722,0.73672-0.2545,0-1.3184-0.0444-1.3184-0.0444z'/%3E %3Cpath fill='%2304534e' d='m423.43,273.58s-2.171,2.6133-5.1968,3.9113c-3.0236,1.2975-5.3238,1.7261-9.5418,1.4674-4.2161-0.25872-6.2606-0.90662-9.1154-2.3741-2.854-1.4696-5.1114-3.5865-5.5382-4.4948-0.42418-0.91041,0.46952,1.5134,0.46952,1.5134l2.5989,3.4101,3.109,1.3852,4.5576,1.121,4.3026,0.51963,3.2781-0.0823,3.9211-0.61057,2.512-0.90175,1.7052-1.0404,1.3216-1.0831,1.6167-2.741z'/%3E %3Cpath fill='%2304534e' d='m419.37,265.86s-1.1807,0.39135-3.7781-1.2114c-2.6-1.5963-5.7107-3.6737-11.589-3.7148-5.8774-0.0412-7.7507,3.979-8.1354,4.2766-0.38415,0.30366,2.6395-3.4972,2.6395-3.4972l2.6848-1.4279,2.0878-0.34642,2.0024,0.0872,2.5978,0.69285,2.3428,0.73344,2.7286,0.90662,2.3828,1.3045,2.8801,1.5031,1.1562,0.69337z'/%3E %3Cpath fill='%2304534e' d='m427.26,267.59s-3.4489-0.0449-4.429,0.0412c-0.98335,0.0855-1.0239,0.25982-1.1541,0.51909-0.12804,0.25928-0.38203,0.60517-0.38203,0.60517l-1.0644-2.2918,4.6856-0.64952,2.5514,0.95482-0.20754,0.82113z'/%3E %3Cpath fill='%230c8489' stroke='%2304534e' stroke-width='0.7' d='m420.91,291.7c0.2369,0.62846,0.78325,1.199,1.4694,1.2152,0.68723,0.02,2.1321-0.0265,2.1321-0.0265l4.6643-0.27876,1.6401-1.8815,1.0009-4.2144s1.2597-1.5313,1.2597-1.5957,4.3426-2.3995,4.3426-2.3995l3.7509-1.0815,2.4058-0.2571,3.3192-1.1015,2.4522-1.2758,1.065-1.5784,1.0415-2.3974-1.0415-3.2434-2.6005-3.4772-4.4044-1.7927h-3.6473l-4.0875,1.4907-7.1983,1.7045s-3.9627,1.7278-5.6039,4.818c-1.6348,3.0896-1.6156,3.8924-1.8919,7.9736-0.28011,4.0872-0.0683,9.3991-0.0683,9.3991z'/%3E %3Cpath fill='%238cbebf' d='m422.86,290.09c1.3782,0,0.31373-2.2788,1.877-4.9879,1.5622-2.7037,3.4638-5.9928,3.9461-5.9928,0.48232,0,0.56396,0.49256,1.1327,0.32152,0.56878-0.17267,1.5377-1.0387,1.5942-1.2715,0.0565-0.22895,0.0565-1.7559,1.2469-2.7356,1.1957-0.98132,2.87-2.3627,3.6628-2.5359,0.79661-0.16833,1.1674-0.31664,1.3083,0.0574,0.14193,0.37404-0.45619,0.89364,0.0864,1.0669,0.53944,0.17482,1.7895,0.11745,2.1001-0.69231,0.31213-0.80762,0.22729-1.2363,0.22729-1.2363s0.82435-0.8065,2.3866-0.46225c1.5633,0.34641,1.7586,0.25764,1.901,0.86607,0.14138,0.60296-0.71176,0.68905-0.53944,1.1226,0.1686,0.42871-0.11738,0.38269,0.0422,0.7107,0.159,0.32693,0.40977,1.2471,1.4593,1.219,1.0548-0.0281,1.5078-0.63492,1.5078-0.63492l0.30892-0.55377s0.28919-0.65496-0.11045-0.91367c-0.39963-0.26036-0.25556-0.57701,0.143-0.40435,0.39643,0.17322,1.9864,2.3908,2.5274,1.4674,0.54159-0.91965,0.59811-2.2176,0.31213-2.5326-0.28438-0.31828-2.5274-3.6899-2.5274-3.6899l-4.0048-1.3537-5.3078,0.43572-5.1423,2.9365-4.7134,2.5067s-0.25663,3.8583-1.1087,3.1686c-0.85154-0.69231-2.0739-2.5922-2.4394-1.9589-0.37188,0.63492-1.1941,3.4561-1.6775,4.8656-0.48392,1.4127-1.8738,5.7642-1.734,7.3789,0.14406,1.6124,1.026,3.8334,1.535,3.8334z'/%3E %3Cpath fill='%238cbebf' d='m427.6,283.85c-0.37189,0.0281-0.91026,0.40379-1.0788,0.61814-0.17233,0.21758-0.41136,0.67986-0.25663,1.1827,0.15579,0.50285,0.89369,0.99435,0.95241,1.0517l0.59117-0.0163,1.2789-0.37241s0.40818-0.4617,0.43112-1.0636c0.0262-0.60843-0.34468-0.76648-0.52662-0.8244-0.18727-0.0568-1.3915-0.57592-1.3915-0.57592z'/%3E %3Cpath fill='%238cbebf' d='m435.72,277.14c-0.72619-0.25873-1.0468,0.23599-1.1717,0.45197-0.12805,0.21759-0.0731,0.7437-0.0731,0.7437s0.15953,1.0052,0.54158,1.1919c0.38202,0.18133,1.3862,0.52938,1.7009,0.18133,0.32333-0.34155,0.6472-0.58187,0.62583-1.2298-0.0176-0.6495-0.92142-0.96945-0.92142-0.96945l-0.70213-0.3697z'/%3E %3Cpath fill='%238cbebf' d='m442.26,278.71c-0.031-0.24737-0.6696-0.42058-1.0954-0.3448-0.42577,0.0742-0.99612,0.61649-0.79286,1.4393,0.19474,0.81952,0.978,0.89203,1.5895,0.73505,0.60986-0.15967,0.49407-1.0257,0.49407-1.1524-0.00037-0.12775-0.19528-0.67714-0.19528-0.67714z'/%3E %3Cpath fill='%238cbebf' d='m423.37,280.03c0,0.37402,0.68082,1.154,1.5926,1.0961,0.90544-0.0574,1.471-0.75023,1.5622-1.2964,0.0811-0.54938-0.48446,0.45847-1.1674,0.63332-0.67922,0.17105-1.0778,0.34642-1.391-0.0298-0.31213-0.37348-0.5965-0.40325-0.5965-0.40325z'/%3E %3Cpath fill='%2304534e' d='m429.52,285.25s0.0976,0.83411-0.50367,1.2666c-0.60132,0.43194-0.98549,0.38755-1.3328,0.38755-0.34628,0-0.72298-0.0709-0.97534-0.41733-0.25344-0.3464-0.44178-0.83571-0.44178-0.83571s0.6632,1.0918,1.7063,0.80435c1.0436-0.28525,1.5473-1.2054,1.5473-1.2054z'/%3E %3Cpath fill='%2304534e' d='m447.11,274.35s-0.009,0.84063-0.66319,1.1886c-0.64988,0.34806-0.94546,0.44819-1.2917,0.4038-0.3436-0.0466-0.82114-0.18674-1.0484-0.54938-0.77203-1.2054-0.31533-1.9935-0.31533-1.9935s0.55541,2.092,1.6284,1.9459c1.073-0.14776,1.6903-0.99542,1.6903-0.99542z'/%3E %3Cpath fill='%2304534e' d='m431.43,278.1s-0.53624,1.6406-1.6188,1.6406c-1.0762,0-0.98816-0.3134-0.90865-0.51964,0.0896-0.19756,0.48606,0.20624,0.96732,0.059,0.48447-0.14127,1.5601-1.18,1.5601-1.18z'/%3E %3Cpath fill='%2304534e' d='m434.47,277.81s-0.11044,1.1886,0.28758,1.5897c0.39804,0.40543,0.85314,0.61002,1.3083,0.61002,0.45511,0,0.79607-0.11907,1.1343-0.577,0.34148-0.46171,0.14138-0.95322,0.14138-0.95322s0.007,0.24901-0.33293,0.59379c-0.34307,0.34642-0.62103,0.40218-0.96251,0.40218-0.33987,0-0.92249-0.0427-1.0954-0.44495-0.17287-0.40217-0.48073-1.2206-0.48073-1.2206z'/%3E %3Cpath fill='%2304534e' d='m440.04,272.09s0.34201,0.89037-0.34148,1.6124c-0.67868,0.72047-1.9859,0.31666-1.9859,0.31666s1.0516,0.25765,1.5633-0.31666c0.51114-0.57699,0.76406-1.6124,0.76406-1.6124z'/%3E %3Cpath fill='%2304534e' d='m422.26,292.59s6.9124-0.11691,7.4681-1.0685c0.55114-0.94835-0.59811-4.6664,3.5774-7.6027,4.1718-2.9381,7.413-2.8975,9.6262-3.0718,2.2153-0.17159,6.9984-1.6617,7.8384-5.9164,0.50902-2.5954-2.9825-2.7681-4.302-5.2298-1.3211-2.4639-4.7273-1.468-4.8985-1.468-0.1686,0-3.9541-0.10989-5.7503,1.6406-1.0676,1.0387-0.93799,2.3345-1.4496,2.9386-0.51221,0.60464-5.0708,0-5.5798,0.73506-0.51168,0.73345,0.12698,2.2869-0.21608,2.6344-0.33615,0.34479-1.4448-0.99596-1.4448-0.99596l0.38201-3.6715,5.8379-3.4133,6.6404-3.6737s4.349,0.21434,4.5186,0.13045c0.17181-0.0893,4.4727,2.2452,4.5992,2.2896,0.12698,0.0449,2.2564,2.5938,2.2564,2.5938s0.41884,1.0404,0.59812,3.0653c0.0859,0.964,0.005,1.7922-0.20488,2.5473-1.0746,3.8252-4.8206,6.3973-8.766,6.5924-3.9429,0.19757-7.4975,1.9784-9.2981,3.2839-1.804,1.3077-2.7014,7.0652-2.727,7.7561-0.0245,0.69065-8.5912,0.22248-8.5912,0.22248l-0.11524-0.31829z'/%3E %3Cpath d='m425.17,279.13c-0.35109,0.28201-0.87131,0.26523-0.98335-0.13208-0.31748-1.1307,0.35587-2.8065,0.35587-2.8065s-0.0165,1.7543,0.11364,2.0444c0.13019,0.28851,0.48074,0.22247,0.63867,0.46226,0.0571,0.0828,0.1542,0.20515-0.12485,0.43194z'/%3E %3Cpath d='m429.52,278.24c-0.33454-0.10338-0.27638-1.167-0.0224-1.6222,0.25664-0.45196,2.1971-1.8815,2.1971-1.8815s-0.61889,1.4295-0.85527,1.9492c-0.23369,0.51584-0.8969,1.6845-1.3195,1.5545z'/%3E %3Cpath d='m427.81,285.26c-0.27159,0.0574-0.36069-0.54238-0.36069-1.2991,0-0.75562,1.3227-2.137,1.3227-2.137s-0.40498,1.2119-0.45032,1.5963c-0.0406,0.39081,0.21609,0.73671,0.1702,1.1919-0.0411,0.45197-0.37935,0.58353-0.68188,0.64791z'/%3E %3Cpath d='m431.03,283.32s-0.61734,0.71394-1.3227,1.1031c-0.69893,0.38595-1.4641,0.96945-1.8952,0.84277-0.42258-0.13207,0.27318-1.0517,0.5122-1.1475,1.1941-0.47362,2.7057-0.79837,2.7057-0.79837z'/%3E %3Cpath d='m436.95,274.87s-0.78539,0.65117-1.1685,1.5762c-0.38523,0.92991-0.55435,1.6883-0.17074,1.8604,0.38736,0.17266,0.95771-1.0604,1.0031-1.4712,0.0406-0.40868,0.33612-1.9654,0.33612-1.9654z'/%3E %3Cpath d='m439.12,277.83s-0.55221-0.51584-1.534-0.75349c-0.97693-0.24086-1.4256-0.0217-1.5313,0.25873-0.10725,0.27931-0.83236,0.72422-0.46954,0.93965,0.36229,0.21435,0.78699-0.37727,1.0852-0.44493,0.30092-0.0644,0.6424-0.28039,1.1717-0.1927,0.53143,0.0871,1.2779,0.1927,1.2779,0.1927z'/%3E %3Cpath d='m437.85,272.03c0.34734,0.30204,0.87767-0.25981,1.3654-0.80756,0.48073-0.54777,0.85047-1.5567,0.85047-1.5567s-0.99666,0.51962-1.4192,0.86607c-0.42951,0.34425-0.99505,1.3256-0.79661,1.4982z'/%3E %3Cpath d='m446.88,271.82s-1.1626,0.55051-1.5606,1.0669c-0.39802,0.5191-0.91025,1.0934-0.51167,1.3819,0.39803,0.2885,0.76194-0.25765,1.0804-0.68905,0.30838-0.43248,0.99184-1.7597,0.99184-1.7597z'/%3E %3Cpath d='m444.3,277.87s-0.39483,0.80815-1.1327,1.2963c-0.73789,0.49312-1.6204,0.72047-1.7586,0.4601-0.14618-0.25712,0.11366-0.80757,0.39323-0.94777,0.28919-0.14561,0.4578-0.11745,1.1082-0.28852,0.65363-0.17212,1.3899-0.52015,1.3899-0.52015z'/%3E %3C/g%3E %3Cg id='blooms'%3E %3Cellipse fill='url(%23rg1)' cx='385.5514' cy='257.828' rx='3.7691' ry='5.631' transform='rotate(8.6669,385.5514,257.828)'/%3E %3Cg fill='%23fcca3e' stroke='%23aa8c30'%3E %3Cpath stroke-width='0.35' d='m387.66,247.73,0,0-2.2409,5.602,1.8301-0.25439,1.0564-4.9309z'/%3E %3Cpath stroke-width='0.3' d='m388.7,245.35c-0.79714-0.10067-1.5302,0.50666-1.6337,1.3608-0.10404,0.8487,0.45832,1.6174,1.256,1.7213,0.79927,0.0991,1.5286-0.51097,1.6342-1.3586,0.10297-0.85143-0.45671-1.6195-1.2565-1.7234z'/%3E %3Cpath stroke-width='0.35' d='m485.22,259.35,0,0-5.5222,5.1798,2.2783,0.57915,3.7882-4.9904z'/%3E %3Cpath stroke-width='0.3' d='m487.68,257.21c-0.88407-0.48823-2.0542-0.15534-2.6165,0.74318-0.56558,0.8953-0.3036,2.0184,0.57887,2.5045,0.88407,0.48824,2.0542,0.15536,2.6197-0.74157,0.56236-0.8969,0.30252-2.0195-0.58213-2.5061z'/%3E %3Cpath stroke-width='0.35' d='m344.88,229.45,0,0,2.9132,6.4193,1.2538-1.7862-3.2973-4.8605z'/%3E %3Cpath stroke-width='0.3' d='m343.71,226.65c-0.72298,0.61328-0.79821,1.731-0.16648,2.4996,0.63065,0.77674,1.7287,0.90503,2.4532,0.29501,0.72244-0.60843,0.79821-1.731,0.16753-2.4996-0.63224-0.77293-1.7292-0.90501-2.4543-0.29499z'/%3E %3C/g%3E %3Cg fill='%23aa8c30'%3E %3Cpath d='m389.25,245.56s0.45031,0.24358-0.0694,0.0839c-0.52287-0.1586-1.7586,0.44167-1.7607,1.3142,0,0.8736,0.64667,1.3586,1.3008,1.3651,0.65518,0.006-0.24223,0.11854-0.24223,0.11854l-0.84251-0.24736-0.34948-0.50772-0.27958-0.70423,0.21556-0.7567,0.49674-0.64464,0.64935-0.23438,0.43003,0.0514,0.45139,0.16184z'/%3E %3Cpath d='m387.99,249.33s-0.35641-0.0725-0.67922,0.40759c-0.32012,0.47957-0.97266,1.3852-0.97266,1.3852l1.2512-3.0815,0.68188,0.35617-0.28118,0.93264z'/%3E %3Cpath d='m488.22,257.69s0.40335,0.48498-0.12645,0.0611c-0.52983-0.42219-2.2868-0.33992-2.7435,0.63168-0.45832,0.97431,0.0555,1.8166,0.81525,2.1316,0.76568,0.31665-0.34147,0.0195-0.34147,0.0195l-0.86115-0.67066-0.143-0.73073,0.031-0.92019,0.64507-0.73672,0.92041-0.48174,0.88033,0.0412,0.47486,0.26685,0.44873,0.38809z'/%3E %3Cpath d='m484.78,261.3s-0.38202-0.2544-1.0095,0.13153c-0.62423,0.38432-1.8562,1.0831-1.8562,1.0831l3.0604-2.8406,0.61574,0.71882-0.81045,0.90721z'/%3E %3Cpath d='m344.33,226.33s0.56398-0.19756,0.0123,0.12883c-0.55006,0.32477-1.0377,1.8728-0.30465,2.5738,0.73362,0.70257,1.6604,0.52939,2.1886-0.0314,0.53088-0.56075-0.0939,0.30474-0.0939,0.30474l-0.88193,0.531-0.70587-0.10879-0.81846-0.3199-0.46153-0.78812-0.14246-0.94995,0.32227-0.75023,0.39003-0.3264,0.49565-0.2636z'/%3E %3Cpath d='m346.49,230.45s-0.34788,0.25223-0.20329,0.91154c0.1494,0.66468,0.38682,1.9508,0.38682,1.9508l-1.5889-3.5464,0.84566-0.30853,0.5597,0.9927z'/%3E %3C/g%3E %3Cellipse fill='url(%23rg2)' cx='351.4697' cy='241.6067' rx='6.0604' ry='4.0788' transform='rotate(62.907,351.4697,241.6067)'/%3E %3Cg fill='%23e92736'%3E %3Cpath d='m344.65,240.24s1.2491,0.2885,1.9293-0.0574c0.68243-0.34643,0.79714-0.86607,0.96518-1.0338,0.1718-0.17321,0.34254-0.8076,0.28545-1.2119-0.0576-0.40379-0.96518-1.7857-1.2507-1.8994-0.28278-0.11692-1.2491,0-1.4171-0.17483-0.17074-0.17321,0.14139-0.54938-0.22942-0.63493-0.36816-0.0861-2.2697,2.0774-1.9309,2.4223,0.342,0.34263,0.53943-0.17158,0.6525,0.11691,0.11419,0.28363,0.0299,1.0918,0.0299,1.436,0,0.34588,0.96571,1.0371,0.96571,1.0371z'/%3E %3Cpath d='m346.5,236.2c0.14886,0.29987,0.85154,1.2368,1.136,1.3521,0.28438,0.11747,1.136,0.14832,1.4208,0.0335,0.28438-0.11583,1.1919-0.98131,1.2207-1.357,0.0283-0.37401,0-0.66142-0.16967-1.0387-0.16967-0.37456-0.0715-1.3803-0.41137-1.4376-0.34147-0.0579-0.49086-0.10392-0.66051-0.30203-0.17074-0.2046,0.10617-0.56402-0.15047-0.93643-0.2529-0.37727-3.2936,1.4117-3.0663,1.7559,0.22782,0.34642,0.53998-0.026,0.65251,0.20298,0.11311,0.2268-0.14245,1.3808,0.0283,1.7272z'/%3E %3Cpath d='m353.37,235.43c0.16968-0.45847,0.11312-1.9589-0.19848-2.2772-0.31212-0.31665-0.82487-0.34317-0.85314-0.54724-0.0266-0.19974,0.36976-0.28851,0.36976-0.63493,0-0.34318-3.379,0.1153-3.1517,0.49473,0.22782,0.37131,0.79661,0.17158,0.76674,0.39892-0.0283,0.23059-0.56878,0.51909-0.62478,0.80975-0.056,0.28689,0.17234,1.2401,0.31214,1.4674,0.14246,0.23437-0.0555,0.51801,0.34147,0.66309,0.39908,0.14506,0.3404,0.14506,0.71123,0.26035,0.36813,0.1153,1.7031,0.0563,1.8749-0.0893,0.167-0.14344,0.28171-0.0855,0.45191-0.54564z'/%3E %3Cpath d='m382.1,252.31s0.55434,0.96075,1.1669,1.1886c0.612,0.22734,0.99611-0.003,1.2037,0.003,0.20542,0.007,0.69312-0.2555,0.90705-0.52776,0.21449-0.27389,0.53142-1.6574,0.43645-1.9048-0.096-0.24737-0.73148-0.79297-0.7256-0.99756,0.006-0.21274,0.41883-0.23114,0.2561-0.51585-0.16433-0.28525-2.6026-0.22084-2.616,0.19594-0.0112,0.42005,0.42259,0.24251,0.31107,0.48175-0.10991,0.24195-0.65416,0.65929-0.86649,0.86062-0.21397,0.20189-0.0731,1.2157-0.0731,1.2157z'/%3E %3Cpath d='m385.66,251.11c-0.0998,0.26847-0.26412,1.2628-0.16701,1.5118,0.0966,0.24411,0.57781,0.80108,0.81312,0.91041,0.23743,0.11529,1.2997,0.18295,1.5452-0.0179,0.24864-0.19973,0.40869-0.38756,0.53784-0.71555,0.13072-0.32694,0.8067-0.85575,0.64454-1.1047-0.16434-0.24738-0.2241-0.36646-0.20009-0.59053,0.0235-0.23275,0.40657-0.26197,0.48661-0.64411,0.0795-0.38106-2.7953-1.2563-2.8742-0.91042-0.079,0.34643,0.33295,0.32314,0.25718,0.52937-0.0747,0.20677-0.9321,0.72261-1.0431,1.0317z'/%3E %3Cpath d='m390.16,255c0.38362-0.16184,1.272-1.0734,1.2827-1.4576,0.0118-0.38215-0.26838-0.72368-0.16272-0.85742,0.10616-0.13695,0.39162,0.0628,0.60612-0.1402,0.21129-0.19919-2.0488-2.0655-2.147-1.7028-0.0976,0.36265,0.35802,0.60349,0.20114,0.72046-0.15899,0.11583-0.65143-0.0574-0.86061,0.0779-0.21129,0.12993-0.66159,0.83252-0.71924,1.0566-0.0581,0.22409-0.35375,0.26902-0.20702,0.60351,0.14299,0.33614,0.10991,0.30041,0.25558,0.60137,0.14458,0.30203,0.95984,1.1102,1.1498,1.1329,0.18834,0.0249,0.21982,0.13045,0.60132-0.0346z'/%3E %3Cpath d='m476.9,262.25s0.0485,1.0701,0.46099,1.5513c0.41616,0.4785,0.83716,0.46659,1.0095,0.57055,0.17074,0.1023,0.69787,0.11041,0.99297-0.0163,0.29613-0.12991,1.1674-1.1459,1.1962-1.3998,0.0261-0.24899-0.26998-1.0089-0.17181-1.1827,0.096-0.17104,0.44817,0.004,0.43697-0.30962-0.0149-0.31827-2.0888-1.4165-2.2804-1.0701-0.19314,0.34643,0.24704,0.40056,0.0507,0.55211-0.19635,0.15156-0.84037,0.24249-1.1034,0.31177-0.2673,0.0709-0.59169,0.9927-0.59169,0.9927z'/%3E %3Cpath d='m480.26,262.95c-0.21448,0.15643-0.84197,0.82326-0.89102,1.0501-0.0486,0.22735,0.0523,0.86061,0.18408,1.0517,0.12965,0.19163,0.93638,0.72368,1.2336,0.68799,0.29932-0.0395,0.52022-0.10393,0.78699-0.29013,0.26996-0.18673,1.0697-0.27064,1.0644-0.53262-0.005-0.25873,0.0101-0.3789,0.14193-0.53208,0.13287-0.15859,0.45512-0.0103,0.70855-0.25928,0.25611-0.24574-1.5835-2.2079-1.8172-1.9833-0.23849,0.22246,0.096,0.39243-0.0651,0.51097-0.16272,0.11962-1.0991,0.1153-1.3462,0.29662z'/%3E %3Cpath d='m480.96,267.83c0.36442,0.14019,1.5574,0.13532,1.8205-0.0925,0.25986-0.22572,0.29615-0.61002,0.45673-0.623,0.1606-0.0163,0.21929,0.28362,0.49567,0.29391,0.2764,0.006,0-2.544-0.30199-2.3843-0.30412,0.16185-0.16593,0.59544-0.34466,0.56728-0.18195-0.0265-0.39963-0.43897-0.62745-0.48931-0.22569-0.0514-0.98815,0.0974-1.1796,0.19756-0.18408,0.10393-0.40819-0.0547-0.53303,0.24034-0.12485,0.2939-0.12485,0.25114-0.22623,0.52666-0.1019,0.27497-0.096,1.2774,0.016,1.4111,0.11098,0.12829,0.064,0.21543,0.42417,0.35238z'/%3E %3C/g%3E %3Cg fill='%23f7e204'%3E %3Cpath d='m346.72,237.45c0.27798,0.41732-0.0902,1.4214-0.31693,1.7061-0.22569,0.28363-1.7399-0.12992-1.7618-0.4103-0.0245-0.28362-0.13394-0.75834,0.064-1.0246,0.19901-0.26522,0.70856-0.8736,1.0938-0.79623,0.38362,0.0698,0.8222,0.38322,0.92089,0.52505z'/%3E %3Cpath d='m347.13,235.57c-0.17766,0.37944,0.0774,0.80815,0.27212,1.0171,0.19581,0.20785,1.2832,0.47849,1.5804,0.29878,0.29612-0.18295,0.75017-1.8685,0.5405-2.1288-0.20807-0.25929-0.79339-0.30367-0.98922-0.27552-0.19848,0.0352-1.28,0.82493-1.4038,1.0885z'/%3E %3Cpath d='m350.75,233.85c-0.14618,0.3448-0.0982,0.82112,0.0251,0.9678,0.12272,0.14831,0.83128,0.64464,1.2475,0.62354,0.4167-0.0265,0.61415-1.1941,0.61415-1.4182,0-0.22409-0.12326-0.31991-0.41778-0.44819-0.29185-0.12233-1.4689,0.27498-1.4689,0.27498z'/%3E %3Cpath d='m385.02,251.98c-0.0934,0.41732-0.92624,0.77513-1.232,0.79623-0.30893,0.0232-0.93959-1.1756-0.78058-1.3554,0.1606-0.17971,0.38683-0.52938,0.66693-0.55536,0.27798-0.0298,0.95081-0.066,1.1306,0.22246,0.17927,0.282,0.24597,0.74318,0.21502,0.89203z'/%3E %3Cpath d='m386.42,251.14c-0.34039,0.10826-0.45404,0.52232-0.46631,0.76968-0.0144,0.24411,0.45671,1.0902,0.74003,1.1692,0.28544,0.0823,1.5879-0.61868,1.6236-0.90395,0.0358-0.2831-0.27639-0.67933-0.41298-0.78432-0.13126-0.10554-1.2522-0.32639-1.4843-0.25061z'/%3E %3Cpath d='m389.59,252.43c-0.30039,0.10717-0.56077,0.41734-0.58262,0.58353-0.0187,0.16346,0.0923,0.90016,0.35108,1.1491,0.25824,0.24738,1.0895-0.30961,1.2277-0.44168,0.13552-0.13153,0.12699-0.26523,0.0304-0.5245-0.0944-0.26035-1.0266-0.76648-1.0266-0.76648z'/%3E %3Cpath d='m479.57,263.19c-0.25984,0.31124-1.1146,0.21922-1.3846,0.0888-0.26679-0.12395-0.27319-1.4312-0.0619-1.5069,0.21129-0.0758,0.55436-0.25873,0.80302-0.15317,0.24382,0.10392,0.82594,0.39729,0.85207,0.72045,0.0241,0.32477-0.12058,0.74211-0.20861,0.8509z'/%3E %3Cpath d='m480.84,263.31c-0.32332-0.0742-0.62263,0.18512-0.75605,0.35941-0.13499,0.17807-0.18514,1.0241-0.002,1.2087,0.18032,0.19269,1.5697,0.26361,1.741,0.0655,0.16861-0.19756,0.12059-0.63273,0.0683-0.77294-0.0523-0.13802-0.82915-0.813-1.0516-0.8606z'/%3E %3Cpath d='m482.29,265.9c-0.26999-0.11367-0.65042-0.0909-0.77364-0.005-0.11738,0.0909-0.53624,0.61222-0.52661,0.92506,0.009,0.31503,0.93318,0.48986,1.1087,0.49473,0.17874,0.009,0.26304-0.0823,0.37029-0.29878,0.10724-0.21707-0.17874-1.1156-0.17874-1.1156z'/%3E %3C/g%3E %3Cellipse fill='url(%23rg3)' cx='476.6946' cy='268.5685' rx='2.9385' ry='5.8621' transform='rotate(47.855,476.6946,268.5685)'/%3E %3C/g%3E %3Cg id='eagle_snake'%3E %3Cg id='snake1' fill='%2378732e'%3E %3Cpath fill='%23a8ac71' d='m375.12,185.22s-5.0261,0.43195-8.5191-0.1732c-3.4926-0.60517-2.7264-9.507-2.8124-9.7656-0.0838-0.25927-2.1294-2.4206-1.789-4.4076,0.34146-1.9881,6.7943-7.233,7.6679-7.5183,0.5965-0.19486,1.8738,0.34642,1.8738,0.34642s1.631-1.5865,2.115-1.5865c0.49834,0,1.1871,0.91528,0.99559,1.3061-0.19262,0.38755-2.4079,1.6834-2.5786,2.6777-0.17073,0.99376,0.0219,1.9881-0.61841,2.9597-0.63813,0.97267-1.8733,2.2902-2.0227,3.1113-0.14886,0.82112-0.5106,1.5351,0.10725,1.8371,0.61787,0.30311,2.727,0.0427,4.5368-0.77673,1.8088-0.82274,2.5541-1.9243,2.8102-1.8155,0.2561,0.10717-1.0436,2.2669-3.045,3.1118-2.0013,0.84224-3.3229,1.8138-4.3239,1.6634,0,0-1.1071,2.6582,2.3226,2.8082,3.4275,0.15155,5.3238-0.75563,5.3238-0.75563l-2.044,6.9776z'/%3E %3Cpath fill='%23a8ac71' d='m355.48,206.18s2.64,1.0354,2.64,3.9784c0,2.9365-2.8945,5.3982-2.8108,10.584,0.087,5.1871,0.89155,5.2385,7.7534,10.804,0.21343,0.17321,1.6615,1.6439,2.044,3.3305,0.38522,1.6818,1.6188,11.622,8.2231,11.576,6.6009-0.0412,7.4964-4.2306,7.4964-4.2306l-2.8118-4.15s-2.3012,0.68851-3.5364,0.38918c-1.2336-0.30366-2.3396-1.1248-3.0668-2.7221-0.72298-1.5995-0.92089-5.4083-2.044-7.0866-2.7686-4.1489-7.7101-4.8412-7.7523-9.2057-0.0432-4.366,3.0236-4.839,2.1716-10.027-0.851-5.1838-7.0284-7.6914-7.0284-7.6914l-2.5125-1.0155-0.87291,5.2072,2.1076,0.25874z'/%3E %3Cpath fill='%23f1a720' d='m373.67,169.89c2.2142-0.51747,0.93692-6.2905,0.93692-6.2905l-1.5329,1.2764s0.94815,1.233,0.94815,2.5592c0.00036,1.3267-0.35214,2.4547-0.35214,2.4547z'/%3E %3Cpath fill='%23a8ac71' d='m377.71,227.47s-1.0271-0.84443-1.129-0.91367c-0.79125-0.52613-4.2566-3.3273-3.7018-11.656,0.62584-9.4215,14.325-14.376,15.219-18.122,0.99244-4.1484,4.094-5.9608-6.8146-14.49l-2.5568,2.996,4.4733,3.357s0.98976-0.5559,1.0474,0.71395c0.0576,1.266-1.193,2.3546-1.5009,3.3473-0.28279,0.90662-7.0855,5.6327-7.5969,6.0944-0.51061,0.46171-3.9056,3.101-3.9056,3.101s-1.7709,1.7413-3.419,5.3998c-1.6455,3.6607-0.79714,8.3545-0.79714,8.3545s0.0539,10.003,10.681,11.817z'/%3E %3Cpath d='m371.03,232.74,0.76727,3.5432-2.1721,0.79836-0.93745-0.0412-0.6803,0.29987-1.6828,1.6244-0.42685-0.1337s-0.25557,0.0893-0.3404-0.94942c-0.0854-1.0355-0.23476-1.9443-0.23476-1.9443l2.0451,0.83952,0.72298,0.046,0.51167-0.17321,0.89476-1.9421,1.5329-1.9676z'/%3E %3Cpath d='m364.68,233.39s-0.68189-0.82113-1.0218-1.3175c-0.29078-0.42383-0.43645-0.52234-1.193-1.1264l1.4897-0.83898,1.5985,0.02-0.23476,1.9226-0.63867,1.3402z'/%3E %3Cpath d='m368.31,227.7s0.99933,0.49635,1.3206,1.2515c0.31852,0.75835,0.78752,1.6866,0.78752,1.6866l-2.5338-0.19161-1.9389-0.61003,1.257-1.7494,1.1076-0.38702z'/%3E %3Cpath d='m367.32,243.37s-0.51275-0.32152-0.81045-1.1405c-0.29932-0.82327-0.53355-2.1418-0.53355-2.1418l1.6839-0.32152,1.98,0.79623,0.55541,0.0466s-0.46899,0.99217-0.53301,1.0371c-0.0635,0.0427-1.9171,1.6601-1.9171,1.6601l-0.42525,0.0639z'/%3E %3Cpath d='m374.04,237.94s-1.4881-0.4682-1.7244-1.1686c-0.25452-0.75402-0.44765-0.6019-0.44765-0.6019l-0.46686,2.0066-0.59758,1.8815s0.12751,0.32368,0.1942,0.32368c0.0619,0,1.4251-0.34642,1.5121-0.38756,0.0843-0.0412,1.1253-1.1248,1.1482-1.1886,0.0213-0.065,0.38204-0.86495,0.38204-0.86495z'/%3E %3Cpath d='m367.77,244.25s0.74536,0.41029,1.7879,1.0155c1.0447,0.60351,1.6626,0.60351,1.6626,0.60351l0.78752-0.84118,0.80885-1.5995,0.10671-0.19433-4.0251,0.36428-1.1285,0.65171z'/%3E %3Cpath d='m373.59,242.7,3.4313-2.0542,0.23262-1.8555-0.68029-0.52071s0.12859,0.0639-0.80831,0.0639h-1.1728l-0.61782,2.2707-0.3847,2.0958z'/%3E %3Cpath d='m371.14,245.94s2.4047,1.0355,6.5582-0.47632c1.8813-0.68419,2.2372-1.5979,2.2372-1.5979l-1.662-0.64578-1.574,1.4046-5.5595,1.3153z'/%3E %3Cpath d='m367.86,219.31s-0.24277-0.77513-0.47859-1.7889c-0.23316-1.0155-0.21342-1.4479-0.21342-1.4479l1.2229,0.63492,1.7677,1.3159-1.257,0.99756-1.0415,0.2885z'/%3E %3Cpath d='m370.75,224.2s-0.59811-0.60517-1.1092-1.3797c-0.51061-0.77999-0.86542-1.5004-0.86542-1.5004l1.2997,0.26847,1.5132,0.73073-0.66853,1.9556-0.16967-0.0747z'/%3E %3Cpath fill='%23c6c7a6' d='m363.02,169.18c-0.22836,0.83572-0.54051,2.3627,0.62477,2.6512,0.63065,0.1548,3.1276-0.0514,5.9629-3.2845,1.3643-1.5562,1.3904-3.0853,1.3904-3.0853l0.54052-1.7543s-1.1076-0.80815-2.8972,0.31502c-1.6086,1.0106-5.6215,5.1579-5.6215,5.1579z'/%3E %3Cellipse fill='%231c242f' cx='370.771' cy='164.639' rx='0.502' ry='0.531'/%3E %3Cpath fill='%23a8ac71' d='m367.16,165.17c-1.2112,0.94509-2.3428,2.1619-2.3428,2.1619s1.9155-0.54238,3.4393-1.9259c0.86489-0.78485,2.5514-1.0902,3.4387-0.88391,0.46152,0.10554,0.30092-0.48986,0.0854-0.6593-0.49674-0.39405-1.8818-0.59216-2.1838-0.36266-0.0422,0.0325-1.2181,0.71828-2.4367,1.6698z'/%3E %3Cpath d='m372.92,218.3s-0.0838-0.39893-0.13765-1.3933c-0.0544-0.99436,0.0592-1.4923,0.0592-1.4923l-1.1349,0.9857-1.0868,1.5118,1.6823,0.6035,0.61788-0.21543z'/%3E %3Cpath d='m367.04,214.94s-0.1558-1.5465-0.0704-3.0138c0.0838-1.4674,0.68027-4.1354,0.68027-4.1354l0.71818,1.8252,2.0648,3.2185,0.66051,0.47633-1.7468,1.2764-1.7874,0.58187-0.51914-0.22897z'/%3E %3Cpath d='m372.96,214.12s0.10457-0.73345,0.28706-1.4127c0.17554-0.66469,0.69465-1.7278,0.69465-1.7278s0.0283,0.1088-0.0571,0.12666c-0.0843,0.0232-1.8104,1.4512-1.853,1.5134-0.0422,0.066-0.80831,0.73345-0.80831,0.73345l1.0847,0.82439,0.7-0.0412'/%3E %3Cpath d='m368.19,206.48s0.2625-0.96454,1.178-2.1316c0.91507-1.1659,1.8178-2.3627,1.8178-2.3627l0.78058,3.1346,0.46792,2.6761,0.0843,0.56563s-0.63706,0.28201-0.89316,0.25873c-0.25663-0.0217-2.1732-0.13207-2.4079-0.45521-0.23209-0.3237-1.0276-1.6856-1.0276-1.6856z'/%3E %3Cpath d='m374.4,210.13s0.58155-0.61815,1.0927-1.0918c0.51061-0.47795,1.3243-1.3949,1.3243-1.3949l-4.2076,0.76973,0.59704,1.423,1.1936,0.29391z'/%3E %3Cpath d='m371.86,201.43s0.39003-0.13856,1.5201-1.2812c1.1269-1.1475,1.7031-1.0089,1.7031-1.0089l0.46952,4.5159-2.2153-0.64952-1.4774-1.5762z'/%3E %3Cpath d='m377.1,207.36,0,0,2.5344-2.571-4.215-1.207,0.76831,2.9607z'/%3E %3Cpath d='m378.87,200.56,0.25556-4.3644s-0.85901,0.40218-1.9459,1.3088c-1.0847,0.90662-1.5895,1.1951-1.5895,1.1951l0.51008,0.77999,1.4913,0.97107,1.2784,0.10933z'/%3E %3Cpath d='m382.62,196.33,0.006-3.4361-0.14779,0.066s-0.60453,0.92992-1.3056,1.5118c-0.70375,0.58347-1.0234,0.99377-1.0234,0.99377l1.1296,0.73558,1.3408,0.12885z'/%3E %3Cpath d='m384.19,200.93s1.1882-0.98784,2.0568-1.6736c1.2986-1.029,1.9469-2.15,1.9469-2.15l-5.451-0.41245,0.21289,2.183,1.2346,2.0531z'/%3E %3Cpath d='m371.51,182.88-0.17074,2.3924,0,0,4.5458-0.0271-1.1098-1.5264-1.3872-0.86601-1.3072-1.3261z'/%3E %3Cpath d='m380.29,204.19c0.23956-0.17971,1.423-1.0669,1.9795-1.6325,0.61787-0.62681,1.5873-1.2531,1.5873-1.2531l-4.3233-0.47631,0.0854,2.8542,0.67121,0.50771z'/%3E %3Cpath d='m388.52,196.4s0.46418-1.7397,0.4199-3.4036c-0.0422-1.6634-0.31372-2.4071-0.31372-2.4071l-3.2366,2.203,0.46739,1.6422,1.2368,1.3408,1.4262,0.62461z'/%3E %3Cpath d='m382.98,192.4s0.95824-1.1594,1.0218-1.8284c0.0645-0.66955,0.0576-0.46171,0.0576-0.46171l2.5568,0.0427,1.5318,0.12882,0.19154,0.15318-1.1492,1.3602-1.5767,0.90663-2.0227,0.23925-0.61093-0.54073z'/%3E %3Cpath d='m388.16,189.85s-0.99985-1.7164-1.566-2.6696c-0.56344-0.94996-1.1183-1.403-1.1183-1.403l-1.2474,3.7132-0.12592,0.3594h4.0577z'/%3E %3Cpath fill='%23fff' d='m356.53,215.28-0.48874,1.0338s1.7031-0.88391,3.0247-0.83898c1.319,0.0427,2.7899,1.6866,2.7899,1.6866l0.31906-1.1941s-1.7468-1.705-2.8971-1.7873c-1.1514-0.0888-2.7478,1.0999-2.7478,1.0999zm0.85154-7.6257s0.36334,0.43033,0.44764,0.55917c0.0843,0.13044,0.12806-1.2742,1.8519-2.0082,1.7255-0.73558,2.664-0.15156,2.664-0.15156s-0.34147-0.99436-1.106-1.2103c-0.76781-0.21759-1.5132-0.0644-2.4516,0.60516-0.93638,0.67067-1.4059,2.2058-1.4059,2.2058zm5.8571,5.7423s-0.8083-1.7229-2.2132-2.0694c-1.4075-0.34641-3.196,0.73073-3.196,0.73073l-0.29665,0.90988s1.9155-1.0831,3.3214-0.51908c1.4059,0.56075,1.9592,2.1619,1.9592,2.1619l0.42524-1.2141zm-6.5795-6.6955c0.0843,0.30367,0.42577,0.68905,0.42577,0.68905s-0.19262-1.855,0.65998-2.8065c0.8526-0.95102,1.4902-1.2958,1.4902-1.2958l-0.78859-0.41245s-1.1279,0.75669-1.5132,1.5784c-0.38255,0.82113-0.35961,1.9443-0.27424,2.2474zm-0.76087-3.0387c0.39644-0.9218,1.5692-1.3256,1.5692-1.3256s-0.11899-0.20406-0.38309-0.34641c-0.26679-0.14182-0.54265,0.0114-0.54265,0.0114s-0.75659,0.39243-1.2122,1.4295c-0.45299,1.0355-0.3959,2.5343-0.3959,2.5343l0.70214,0.3908c0.00037,0.00054-0.13552-1.7722,0.2625-2.694zm10.337-25.064c1.0799-0.57702,1.8749-0.46172,1.8749-0.46172s-1.5942,1.6785-0.8254,3.7679c-0.90438,1.7511-1.1893,3.0815-1.1893,3.0815h0.85046s0.28812-1.3635,0.62423-2.4368c0.9225,1.7857,2.4714,2.7898,2.4714,2.7898l1.3056-0.0574s0.002-1.7397,0.6728-3.2547l0.12484,0.14181c1.4171,1.4988,2.6112,1.8469,2.6112,1.8469l0.0144-0.44711s-1.4913-0.87906-2.3428-2.0314l-0.0843-0.12395,0.0251-0.0493c1.0239-1.6124,2.3876-2.1316,2.3876-2.1316l0.90865,0.75023,0.22571-0.2885-0.68083-0.86387-0.78753,0.0217s-1.4118,1.1773-2.3226,2.2046c-0.65415-1.0225-1.0345-2.0542-1.0345-2.0542l-0.58368-0.21435s-1.4144,0.16347-2.6805,2.2079c-0.15688-1.5004,1.5734-3.1378,1.5734-3.1378l-0.0854-0.6268s-1.7479,0.32965-3.1101,0.73345c-1.3622,0.40433-2.1934,1.6866-2.1934,1.6866l-0.056,0.92019c-0.00036-0.00036,1.2266-1.3971,2.306-1.9729zm1.8744,2.7654c0.79501-1.1524,2.5557-1.901,2.5557-1.901s0.0448,0.93318,1.0143,2.1733c-0.66158,1.1621-0.95716,2.9532-0.95716,2.9532s-1.3627-0.86228-2.5552-2.5922c-0.087-0.12504-0.15366-0.25549-0.20968-0.38756,0.0486-0.0861,0.0987-0.16996,0.15206-0.24574zm-9.9388,27.758,0.064,1.0122s1.0436-1.141,2.6192-1.1854c1.5766-0.0449,2.9191,1.1854,2.9191,1.1854s0.0197-1.3586-0.19261-1.4858c-0.21289-0.13208-1.4913-0.86714-2.6843-0.86714-1.192,0-2.7254,1.3408-2.7254,1.3408zm28.115-14.739c-0.20754-0.37619-0.43323-0.90342-0.61199-1.3489,0.23796-0.0893,0.47379-0.20947,0.69626-0.37619,1.3216-0.99597,2.2575-2.0742,2.2575-2.0742l-0.46846-0.73505h-2.1294c-0.41777,0-1.304-0.10555-1.805-0.16996,0.0934-0.32639,0.35587-1.2433,0.66319-2.1965,0.38415-1.1886,0.72987-1.8268,0.72987-1.8268l-0.72405-0.73345s0.17073,0.67607-1.1076,0.84929c-1.2779,0.17321-3.6351-1.0355-3.6351-1.0355v0.518s2.0734,0.66309,3.2654,0.83572c0.70428,0.1023,1.2549-0.13856,1.59-0.35129-0.18353,0.37782-0.52074,1.1167-0.70214,1.776-0.15526,0.56562-0.37775,0.93478-0.36227,1.1805,0.01,0.15967,0.24223,0.30366,0.24223,0.30366l-0.11365,1.1096s1.2784,0.17158,1.8733,0.17158c0.59704,0,2.2153,0.13045,2.2153,0.13045s-1.1508,1.3408-2.2575,1.8582c-0.14619,0.0693-0.29933,0.12341-0.45993,0.16942-0.0587-0.15643-1.3222-2.0839-1.3222-2.0839l-0.12752,0.71235s0.90385,1.2412,0.99404,1.5037c-0.81686,0.10879-1.9944-0.17104-1.9944-0.17104l-0.51114,0.56236s-0.0363,1.5995,0.0123,3.2547c-1.1044-0.30041-2.3412-0.74857-2.3412-0.74857l-0.45671,0.34642,0.0224-0.0806-0.58796,0.46982s-0.51167,1.9421-0.38254,4.1484l0.007,0.11205c-2.1006-0.52071-3.1602-1.7559-3.1602-1.7559l-0.51114,0.43357s-0.34414,1.9042,0.13019,4.2031c-1.7943-0.35616-3.3534-1.9129-3.3534-1.9129l-0.66693,0.56076s0.39803,3.7181,0.82273,5.7476c0.0352,0.17322,0.0848,0.32315,0.13019,0.47634-0.35161,0.0379-0.68669,0.0574-0.98228,0.0427-1.8301-0.0877-2.9671-1.7727-2.9671-1.7727l-0.54051,1.3094s0.69733,3.5746,2.6987,5.1741c0.16168,0.12882,0.31107,0.24736,0.45086,0.35942-1.71,1.3965-3.7594,1.6157-3.7594,1.6157l0.12591,1.1275s1.2229,0.95808,2.4148,1.7825c0.11791,0.0758,0.24223,0.15319,0.37242,0.22084-0.95081,0.8493-2.1155,1.1941-2.1155,1.1941l0.31265,0.74698s1.5831-1.1048,2.3167-1.7002c1.0607,0.42707,2.4564,0.59539,2.4564,0.59539v-0.60677s-1.0265-0.092-1.9784-0.39567l0.13926-0.12883c0.59651-0.577,1.7607-2.3611,1.7607-2.3611l0.11204-1.2964s-0.73253-0.10393-1.527-0.7367c2.4164-1.652,2.5088-2.4038,2.5088-2.4038l0.45512-0.85415s-0.81525-0.35075-1.4171-1.5383c1.6567-0.32152,3.8037-0.85741,3.8346-0.94777,0.0416-0.12882,0.28705-0.26901,0.28705-0.26901s-0.9289-1.5221-1.3254-3.3852c1.9096,0.49473,3.8592,0.81301,3.8592,0.81301l0.6104-0.52126s-0.47059-1.5448-0.62157-3.2266c2.2654,0.14344,4.1868,0.3134,4.1868,0.3134l0.38256-0.43356s-1.2768-2.4417-1.2341-3.8236l0.003-0.12665c0.43538,0.0823,0.87184,0.13531,1.2731,0.12665,1.8765-0.0449,3.9616,0,3.9616,0l0.32014-0.71394c0.001-0.00036-1.8104-1.2325-2.2345-2.0125zm-13.789,20.331s-0.6088,1.2363-1.845,2.6626c-0.10031,0.11205-0.19742,0.2111-0.29506,0.31178-0.21182-0.0893-0.42737-0.18999-0.64187-0.31178-1.448-0.82273-1.8188-1.7592-1.8188-1.7592s0.79982-0.39243,3.2365-2.0265c1.288,1.0209,1.3643,1.1232,1.3643,1.1232zm1.1354-4.124s-0.76086,0.90502-2.5338,2.4883c-0.18141-0.17321-0.36441-0.36428-0.54692-0.59864-1.1354-1.4723-2.5552-2.7389-2.4127-4.9565,0,0,0.88033,1.5865,2.8412,1.3819,0.39911-0.0379,0.85902-0.10879,1.336-0.19108,0.52234,1.3137,1.3163,1.8761,1.3163,1.8761zm2.6416-3.3256s-1.8146,0.59543-3.499,0.86714c-0.0715-0.17483-0.14138-0.35454-0.20754-0.56509-0.6376-2.0742-0.6376-5.2288-0.6376-5.2288s1.4155,0.97812,3.4008,1.5286c0.57626,2.3546,0.94333,3.3982,0.94333,3.3982zm-0.60132-3.8371c-0.29398-1.9356,0.0918-3.855,0.0918-3.855s1.0548,1.0539,3.0231,1.3835c0.13499,1.7889,0.34147,2.6777,0.34147,2.6777s-1.4945,0.0828-3.4564-0.20623zm7.6311-2.9478s-1.2693,0.49148-3.7087,0.14994c-0.017-0.23221-0.031-0.46983-0.04-0.71234-0.0854-2.203,0.10885-3.9871,0.10885-3.9871l0.007-0.026c0.3468,0.15319,1.6449,0.6842,2.8556,0.97919l0.0106,0.14019c0.16967,1.9871,0.7662,3.4561,0.7662,3.4561zm-0.17233-4.104-0.13179-0.0314c0.0838-1.4127,0.0774-3.4691,0.0774-3.4691s1.1871,0.31664,2.1011,0.19269c0.2417,0.60031,0.0854,0.7567,0.68029,1.6639,0.5981,0.90828,1.4918,1.6439,1.4918,1.6439s-3.0247,0.25711-4.2188,0zm-9.88,24.441-0.17074-0.70583s-1.1914,0.88552-1.5297,1.7954c-0.12912-0.02-0.25558-0.053-0.37456-0.0942-0.79394-0.28849-2.6672-1.0203-2.6672-1.0203l0.26785,0.53101s1.9453,0.89363,2.4554,1.0089l0.16434,0.0298c-0.25451,0.77513-0.64455,1.8414-0.64455,1.8414l0.31266,0.43357s0.17767-1.3142,0.67922-2.2328c0.66693,0.066,1.5916,0.10068,1.5916,0.10068s-0.11364,0.51583-0.28599,1.0934c-0.16807,0.57701-0.5106,1.9307-0.5106,1.9307l0.58262,0.36104,2.7147,0.0563-0.45726-0.53912s-0.0843-0.13532-0.96465-0.16292c-0.88193-0.0298-1.4208,0.11529-1.4208,0.11529s0.11311-0.54938,0.45458-1.6455c0.34041-1.0966,0.35535-1.0322,0.35535-1.0322l-0.34147-0.94942s-0.86757,0.2387-1.4433,0.21922c0.50635-0.74045,1.2325-1.1345,1.2325-1.1345zm-14.825-1.7115c1.662,0,3.0668,1.121,3.0668,1.121l-0.0635-0.79463s-1.2986-1.7526-2.7889-1.7526c-1.4929,0-3.2595,1.5351-3.2595,1.5351v1.6406s1.383-1.7494,3.045-1.7494zm17.507,25.497c-1.7031,0.73232-3.6212,0.73232-3.6212,0.73232s0.51914-0.74209,1.027-2.0249c3.332-0.93477,3.999-3.1589,3.999-3.1589l-0.21182-0.82167s-0.80724,2.0331-3.4921,3.154c0.49675-1.5746,0.99986-4.2339,0.99986-4.2339l-0.91506-0.23708s-1.3136,1.6439-2.5531,2.0612c0.84037-1.6368,0.9561-3.5102,0.9561-3.5102l-0.4055-0.71395s-0.89476,0.8011-2.3006,1.0598c-0.21182,0.0395-0.44391,0.0363-0.68669,0.007l0.005-0.007c0.76775-1.0782,2.2377-4.1912,2.2377-4.1912l-0.25716-0.58565s-1.1279,2.7486-2.2783,4.1272c-0.14779,0.17971-0.29132,0.34643-0.43644,0.50665-1.1764-0.33994-2.8635-1.3473-2.8635-1.3473l0.18994,0.5191s0.9561,0.73072,2.3492,1.174c-0.84833,0.89038-1.7741,1.7196-1.7741,1.7196l0.0838,1.2531s2.1593,0.41083,3.9323,0.59052c-1.4273,2.0195-2.5883,2.6924-2.5883,2.6924l0.57466,0.86606s1.7538-0.0114,4.9023-0.78485c-0.89583,1.6921-1.5788,2.4271-1.5788,2.4271s2.8742,0.19756,4.8345-0.80003c1.9592-0.99436,2.5552-2.0298,2.5552-2.0298l-0.55328-0.60843c-0.00036-0.00036-0.42631,1.429-2.1305,2.1646zm-9.0726-5.4072s0.84671-0.92993,1.5724-1.8842l0.0891,0.0244c2.0013,0.43249,2.5541-0.17266,2.5541-0.17266s0.37989,1.0847-0.83983,3.0334c-1.44-0.0595-3.3758-1.0008-3.3758-1.0008zm1.7884,4.0201,1.7895-2.078c0.12699-0.14668,0.23904-0.29013,0.34148-0.43681,1.9624-0.0693,3.0668-1.6791,3.0668-1.6791s0.22997,1.6244-0.64774,3.6261c-2.4933,0.90827-4.5501,0.56781-4.5501,0.56781zm-2.4282-12.879c1.8749,0.12883,4.3031,1.0127,4.3031,1.0127l-0.29773-0.9927s-2.3081-0.56402-3.745-0.75023c0.64134-1.4376,2.0611-2.1218,2.0611-2.1218l-0.63812-0.34642s-0.78646,0.12829-1.853,1.9454c-0.088,0.14669-0.16647,0.29825-0.23957,0.45143-0.13658-0.01-0.26891-0.0178-0.40016-0.0178-1.7031-0.046-3.1309,0.94776-3.1309,0.94776l0.25666,0.51909s1.4838-0.64144,2.9462-0.6674c-0.52982,1.4756-0.92462,3.1524-0.92462,3.1524l0.38468,0.88717s0.7427-2.3708,1.2618-4.0201h0.0155v0.00053zm-3.9392-8.0382-0.4055-1.0404s-2.0008-0.70908-3.5343,0.0227c-1.534,0.73559-2.6843,2.5077-2.6843,2.5077l0.63974,1.2087s1.0644-1.9654,2.4703-2.4385c1.4048-0.47795,3.514-0.26035,3.514-0.26035zm3.8971,3.0453-1.32-0.69232s-2.1721,0.62842-2.9394,1.4063c-0.76723,0.77999-1.3846,2.767-1.1728,3.3273,0.21342,0.56076,0.89636,0.92832,0.89636,0.92832s0.36068-2.0958,1.4262-3.0886c1.066-0.99377,3.1095-1.8809,3.1095-1.8809zm-5.0666-0.62462c0.89209-0.86387,2.512-1.1903,2.512-1.1903l-0.81045-0.73399s-1.9592,0.23762-2.9815,1.1459c-1.0218,0.90882-2.3428,2.7882-2.3428,2.7882l1.1514,1.1215c0-0.00054,1.5761-2.2707,2.4714-3.1313zm6.7441-58.716,0.0699-0.0893c1.0324-1.3288,2.0344-1.3288,2.4282-1.2216,0.16434,0.046,0.38416,0.0265,0.58101-0.006l-0.007,0.006,0.031-0.0114c0.0491-0.01,0.0934-0.0179,0.13766-0.0281,0.0502,0,0.096,0.0168,0.12165,0.066-0.32759,0.51801-0.79287,1.9373-1.0351,3.1297-0.29878,1.469-0.93531,1.6423-1.4048,2.5489-0.46793,0.90881-1.447,2.4222-1.4902,3.7164-0.0427,1.2975,0.29718,1.9887,0.63866,2.1619,0.34148,0.17321,0.96626-0.56401,0.93692-0.86387-0.0432-0.43195-0.38256,0-0.63813,0s-0.21288-0.43195-0.34147-1.2103c-0.12858-0.77838,0.93585-2.9381,1.3206-3.6309,0.38256-0.69066,1.1914-1.5118,1.3622-2.6794,0.15259-1.0404,0.91079-3.3192,0.91079-3.3273,0-0.0644-0.57941-0.223-1.7079-0.30203-0.84036-0.0612-1.973,0.67606-2.5093,1.5004-0.53249,0.82113-2.2089,1.4788-2.2089,1.4788s1.837,0.0136,2.8049-1.2379z'/%3E %3Cpath d='m374.33,178.91-3.2707,0.0866,0.93905,2.4465z'/%3E %3Cpath d='m370.48,178.78s-0.47539-0.30149-0.70267-0.56242c-0.22729-0.26036-0.40444-0.36753-0.40444-0.36753l-1.178,0.74211-0.68189,2.4206,0.33987,0.34481,2.6272-2.5776z'/%3E %3Cpath d='m370.04,185.34-2.386-3.5151-1.3622,2.9316,0.65251,0.23058s0.65249,0.0644,1.6465,0.20785c0.99452,0.14506,1.4491,0.14506,1.4491,0.14506z'/%3E %3Cpath d='m379.74,244.06s-0.0389,0.0265-0.12005,0.0823c-0.56504,0.37782-3.0685,1.9058-6.1414,1.9058-1.4283,0-2.9799-0.32693-4.5347-1.2482-0.9156-0.54618-1.5414-1.3608-2.0024-2.3464-0.69258-1.4761-0.9956-3.3354-1.3115-5.1394-0.32226-1.8036-0.64882-3.5514-1.4443-4.8358-1.0719-1.7083-3.0898-2.7762-4.8985-4.2983-1.813-1.5221-3.4238-3.4506-3.7615-6.8755-0.0336-0.34643-0.0491-0.68905-0.0491-1.0257-0.002-2.262,0.72565-4.2306,1.4614-5.9522,0.73308-1.7262,1.4897-3.1952,1.495-4.5224,0-0.22248-0.0224-0.44169-0.0715-0.65278-0.2433-1.0257-1.1279-1.8847-1.94-2.5197-0.81472-0.62841-1.567-1.0155-1.575-1.0209l-0.017-0.008-1.2709-0.35128-0.10724,0.39892,1.2491,0.34641,0.0544-0.19973-0.0918,0.18457s0.0432,0.0217,0.12111,0.066c0.28118,0.15482,0.99772,0.57701,1.6828,1.1508,0.6867,0.57373,1.3296,1.311,1.495,2.0444,0.0416,0.17971,0.0608,0.36915,0.0608,0.56077,0.006,1.1621-0.71604,2.6214-1.4609,4.3579-0.7411,1.7391-1.4956,3.7641-1.4972,6.1168,0,0.3513,0.0182,0.70583,0.0529,1.0653,0.3436,3.5519,2.0542,5.6076,3.9077,7.1577,1.8546,1.5481,3.8389,2.6252,4.8131,4.2031,0.98388,1.5697,1.2432,4.0807,1.7154,6.4983,0.2369,1.2054,0.53143,2.3924,1.0164,3.4295,0.48287,1.0387,1.1637,1.9308,2.1657,2.5262,1.6204,0.9608,3.2498,1.3039,4.7406,1.3039,3.665-0.003,6.4807-2.0547,6.4988-2.0672l-0.2353-0.33505z'/%3E %3Cpath d='m376.91,237.6-0.0251,0.0195c-0.14085,0.0823-0.79554,0.44872-1.6401,0.44872-0.67762-0.003-1.4758-0.22409-2.2841-1.0193-0.98655-0.97432-1.2752-1.8777-1.5243-3.0252-0.24438-1.1476-0.43485-2.5294-1.2123-4.34-0.80457-1.8664-2.7841-3.357-4.6253-4.8212-1.8493-1.456-3.547-2.8872-3.8517-4.4434-0.0608-0.29339-0.087-0.58567-0.087-0.8774-0.004-1.3142,0.56395-2.6463,1.1498-4.1533,0.58529-1.5069,1.1812-3.1919,1.1812-5.2152,0-0.34262-0.016-0.69557-0.0534-1.0549-0.27157-2.6084-2.2601-4.5473-4.151-5.8416-1.8957-1.2942-3.7152-1.9492-3.7242-1.9524l-0.13552,0.39081s0.10725,0.0379,0.3036,0.11854c0.68349,0.27876,2.4143,1.0501,4.0187,2.2886,1.606,1.2401,3.0695,2.9316,3.2813,5.0388,0.0347,0.34642,0.0518,0.6858,0.0518,1.0122,0,1.9394-0.57092,3.5616-1.1514,5.0621-0.57995,1.4988-1.1781,2.872-1.1807,4.307,0,0.3199,0.031,0.63818,0.095,0.96134,0.37616,1.7857,2.1582,3.2184,4.0006,4.6875,1.8504,1.4609,3.7775,2.9478,4.5043,4.6594,0.75605,1.7624,0.93638,3.0886,1.1866,4.2588,0.2481,1.1708,0.58262,2.1992,1.6407,3.2385,0.87767,0.86768,1.8002,1.1378,2.568,1.1329,1.0965-0.002,1.8749-0.52125,1.8899-0.53262l-0.22515-0.34804z'/%3E %3Cpath fill='%23a8ac71' d='m388.97,227.59s2.2895,0.53911,2.2057,2.3973c-0.0854,1.8598-1.1076,4.4488-1.1076,4.4488l-3.1533-2.8525,1.7756-1.5697,0.65197-0.93318-0.37242-1.4907z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='0.35' d='m349.61,205.23s-2.2575,0.77673-2.7254-0.21598c-0.46899-0.99435-0.25557-1.7727-0.29718-1.987-0.0448-0.21597-1.3654-0.30312-1.2368-1.5995,0.12752-1.2975,1.7884-1.2103,2.131-1.2103,0.34147,0,0.4247-1.9903,1.5767-1.8994,1.1498,0.0839,1.7025,1.423,1.7025,1.423l-1.1508,5.489z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='0.35' d='m352.12,205.84s-1.916,0.99597-2.5136,0.0428c-0.5965-0.95155,0-2.1619-0.21341-2.3778-0.21396-0.21436-1.3611-0.60352-1.1498-1.7262,0.21342-1.1242,1.4059-0.77998,1.8333-0.99595,0.42417-0.21436,0.72245-1.901,1.9155-1.5979,1.1919,0.30365,1.4059,1.2531,1.4059,1.2531s-0.93852,4.4932-1.2779,5.4019z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='0.35' d='m355.36,206.27s-0.55489,1.2119-1.9171,0.94776c-1.3638-0.25549-0.93692-2.2442-1.1514-2.5922-0.21181-0.34264-1.1914-0.60351-1.0218-1.8566,0.17074-1.2515,1.4059-1.0798,1.8738-1.2515,0.469-0.17483,0.97907-2.1191,1.8749-1.8171,0.89583,0.30367,1.7452,1.4263,1.5756,1.9454,0,0-1.916,0.6035-2.1721,1.901-0.2545,1.2969,0.93799,2.7232,0.93799,2.7232z'/%3E %3Cpath fill='%23af7029' d='m385.51,227.14s-1.7031-1.8718-2.8961-3.5118c-1.193-1.6455-3.0391-3.5205-3.0391-3.5205l-2.9239-1.4674-1.8456-3.0832-0.22942-3.6293,0.79661-2.1023,1.1071-1.6141s-6.057,2.1683-2.9825,13.771c1.3083,4.9268,4.6579,5.644,4.6579,5.644l5.5665-0.34101,1.7885-0.1456z'/%3E %3Cpath fill='%23816c2a' d='m382.71,188.39c0.57573,0.0184,0.86062,0.20947,1.034,0.45034,0.17288,0.24411,0.22837,0.57054,0.22677,0.85089,0,0.15318-0.0155,0.2885-0.031,0.38593l-0.0197,0.11205-0.008,0.0346,0.19848,0.053-0.18622-0.0839c-2.0029,4.4385-6.2557,6.5095-10.07,9.2741-1.9042,1.3835-3.6932,2.9467-5.0074,5.0783-1.3147,2.1354-2.1449,4.838-2.1449,8.4683,0,0.18295,0.002,0.37241,0.007,0.56076,0.14619,6.673,2.6694,10.264,5.4478,12.142,2.775,1.8842,5.7775,2.0742,6.9108,2.0774,0.29665,0,0.4658-0.013,0.46953-0.013l0.006-0.003h0.006c0.002,0,0.77684-0.0991,1.8936-0.20136,1.1146-0.0974,2.5664-0.19974,3.9046-0.19974,0.85473,0,1.6658,0.0412,2.3028,0.14831,0.63866,0.0991,1.1002,0.28688,1.2416,0.48012,0.17874,0.22409,0.24543,0.44656,0.24756,0.67607,0.004,0.50447-0.36494,1.0864-0.81577,1.5513-0.44285,0.46496-0.96466,0.82439-1.1487,0.91042l0.17127,0.37402c0.26518-0.12395,0.78645-0.48986,1.272-0.99595,0.47806-0.50286,0.92356-1.141,0.9305-1.8398,0-0.31665-0.10404-0.6463-0.3404-0.93804-0.29186-0.34804-0.81739-0.51097-1.4929-0.6284-0.67388-0.1088-1.5009-0.14994-2.3679-0.14994-2.7142,0-5.8459,0.40055-5.8518,0.40055l0.0262,0.20786-0.0166-0.20786s-0.0341,0.002-0.10991,0.005c-0.0747,0.003-0.18675,0.006-0.32813,0.006-1.0906,0-4.0144-0.1927-6.6837-2.0033-2.6672-1.8171-5.1125-5.2331-5.2661-11.807-0.002-0.1862-0.006-0.36916-0.006-0.55264,0.003-3.5697,0.81098-6.1831,2.0814-8.2476,1.9053-3.0983,4.8794-4.9841,7.7876-6.945,2.9057-1.9605,5.7513-4.0033,7.3142-7.4574l0.008-0.0168,0.004-0.0178c0.002-0.0103,0.0715-0.28038,0.0715-0.63818-0.002-0.32964-0.0566-0.74046-0.30359-1.0934-0.24384-0.35453-0.69097-0.61163-1.3547-0.62301l-0.0106,0.41517z'/%3E %3Cpath fill='%23fff' d='m390.88,229.04s-1.4358,2.6312-1.8008,2.6577c-0.36492,0.0265,1.2427,0.41571,1.6071,1.0355l-0.34307,0.64304s-1.5894-1.1312-2.5867-1.1789l-0.0891-0.97106s0.81259-0.27389,1.4864-0.88877c0.55383-0.50611,1.1322-1.9226,1.1429-2.249l0.58314,0.95156z'/%3E %3Cpath fill='%23fcca3d' d='m396.48,230.77-3.579,0.98078-1.8237-1.141s0.14939-1.4902-0.66052-2.1283c-0.8345-0.66143-1.3301-0.85416-2.0552-1.1578-0.72406-0.30203-3.2797-0.35615-3.2797-0.35615l-6.4646-6.9995,2.4143,0.25548,3.8192-0.47308,3.5502-0.30203,1.8749,0.27551,2.0008,0.61814,1.0516,0.89044,1.0922,0.9662,1.0943,1.8003,0.69626,2.033,0.28386,2.1878-0.0149,2.55z'/%3E %3Cpath fill='%23af7029' d='m396.62,230.54s-1.28,0.37782-2.8972,0.3448c-1.6204-0.0227-2.6491-0.27388-2.6491-0.27388s0.0928,0.1023-0.24865,1.1692c-0.3404,1.0685-0.6541,1.7278-0.6541,1.7278l0.0587,4.2041,3.4073,0.66795,1.7895-0.69445,0.90918-4.5819,0.28438-2.5635z'/%3E %3Cpath fill='%23fcca3d' d='m395.67,228.76,0,0,0.15473,1.6292,0.66693,0.19486-0.016-1.4668z'/%3E %3Cpath fill='%23fcca3d' d='m392.46,189.47-0.39802-2.8655-1.1215-1.901-1.4203-1.9459-1.5195-1.672-0.851-0.75995-0.35588-0.56242-3.7348,0.1732-1.9576,2.3335s5.1002,3.599,7.0193,7.5317c1.6513,0.49636,2.9367,1.54,3.6692,2.2555l0.17288-0.31016,0.49726-2.2772z'/%3E %3Cpath fill='%23af7029' d='m388.84,192.63c-0.0529,2.9202-0.55435,4.3081-0.94172,4.9549l2.2622-2.5938,1.6294-2.93c-0.73253-0.71555-2.0179-1.7592-3.6692-2.2556,0.45565,0.93804,0.73468,1.8929,0.71924,2.8244z'/%3E %3Cpath fill='%23816c2a' d='m394.11,235.87c-0.003-0.002-1.0522-1.3126-1.8344-2.0791-0.79821-0.77672-1.7212-1.2022-1.7325-1.2087l-0.16966,0.37782s0.0502,0.0227,0.14406,0.0742c0.28171,0.14831,0.92249,0.51909,1.4748,1.0587,0.37454,0.36591,0.82754,0.87906,1.1839,1.2942,0.3564,0.42059,0.61681,0.74372,0.61681,0.74537l0.31692-0.26252z'/%3E %3Cpath fill='%236f5b24' d='m396.31,232.73s-0.342,1.2645-1.6188,2.4157c-1.2789,1.154-2.8972,1.9324-2.8972,1.9324l3.6628,1.3537,2.4426-2.2739-1.5894-3.4279z'/%3E %3Cpath fill='%23404118' d='m396.85,235.77-0.22409,0.433-0.68828,0.66575-0.53888,0.57374,0.91237-3.7996,0,0,0.65092,1.1204,0.0854,0.60621z'/%3E %3Cpath fill='none' stroke='%2378732e' stroke-width='0.3' d='m375.12,185.22s-5.0261,0.43195-8.5191-0.1732c-3.4926-0.60517-2.7264-9.507-2.8124-9.7656-0.0838-0.25927-2.1294-2.4206-1.789-4.4076,0.34146-1.9881,6.7943-7.233,7.6679-7.5183,0.5965-0.19486,1.8738,0.34642,1.8738,0.34642s1.631-1.5865,2.115-1.5865c0.49834,0,1.1871,0.91528,0.99559,1.3061-0.19262,0.38755-2.4079,1.6834-2.5786,2.6777-0.17073,0.99376,0.0219,1.9881-0.61841,2.9597-0.63813,0.97267-1.8733,2.2902-2.0227,3.1113-0.14886,0.82112-0.5106,1.5351,0.10725,1.8371,0.61787,0.30311,2.727,0.0427,4.5368-0.77673,1.8088-0.82274,2.5541-1.9243,2.8102-1.8155,0.2561,0.10717-1.0436,2.2669-3.045,3.1118-2.0013,0.84224-3.3229,1.8138-4.3239,1.6634,0,0-1.1071,2.6582,2.3226,2.8082,3.4275,0.15155,5.3238-0.75563,5.3238-0.75563l-2.044,6.9776z'/%3E %3C/g%3E %3Cg id='eagle'%3E %3Cg id='wings' fill='%23d2a567'%3E %3Cpath fill='%23ab6d29' stroke='%234d2a15' stroke-width='0.51' d='m418.24,147.56s-9.2062-1.7375-9.0545,5.9261c0.048,2.419,0.58422,3.258,2.5306,3.8036,1.9469,0.54239,5.8459,0.74045,9.1538,3.7034,3.3054,2.963,3.5529,5.1362,3.5529,6.9135,0,1.777-0.82594,3.4079-0.82594,3.4079l2.0899,10.124,2.0969,7.5071,6.2296-3.606,3.6521-11.112-4.6744-20.002-14.751-6.6656z'/%3E %3Cpath fill='%234d2a15' d='m427.38,186.09s3.2072-1.2119,4.0326-3.8036c0.22623-0.71234-3.2392-3.8301-3.3235-3.8301-0.0827,0,1.7618,0.89203,2.6133,1.6688,0.85154,0.77999,1.5046,1.0966,1.7586,0.98133,0.25663-0.1153,1.7357-3.5448,1.1674-4.2934-0.56877-0.74857-1.4518-2.5061-2.7862-3.3982-1.3328-0.89364-3.0946-0.77839-3.0946-0.77839s2.4447-0.77838,3.665-0.0861c1.2171,0.69066,1.3328,1.4972,1.4742,1.2103,0.14353-0.28849-0.25664-3.7181-0.80938-4.8705s-1.1199-1.7002-2.5989-1.987c-1.4726-0.29013-3.0636-0.17484-3.0636-0.17484s2.1294-1.1805,3.7461-0.77673c1.6172,0.4038,1.5926,1.2103,1.7308,1.0371,0.1462-0.17321-0.79607-3.1394-1.1749-3.8896-0.38521-0.74856-2.3161-2.2474-2.8561-2.4206-0.53784-0.17321-2.3012-0.22735-2.3012-0.22735l-0.85207,0.0114s1.2256-0.84929,2.7878-0.70582c1.5585,0.14506,1.6428,0.66307,1.869,0.577,0.2273-0.0855-0.17074-0.28687-1.1183-0.95156-0.95396-0.66089-5.5536-2.6214-5.5536-2.6214l-4.2028-0.0574s-0.0448-1.0653,1.1791-1.266c1.2213-0.20298,1.5756,0.15643,1.4897-0.16022-0.0848-0.31611-3.547-1.0782-3.547-1.0782s-1.9907,0.0579-2.8433,0.0861c-0.84993,0.0298-3.9472,0.38755-3.9472,0.38755s0.26997-0.67933,0.87558-1.2087c0.46151-0.40597,1.1765-0.65929,1.7666-0.82113,1.3611-0.37565-0.76728-1.4409-0.76728-1.4409l1.137-1.7278,5.113,0.43033,10.791,6.3102,5.0565,4.3513,3.2066,8.1814-0.96519,14.058-7.2164,5.964s-3.1773,0.49149-3.1773,0.34643c-0.00037-0.14507,0.73895-3.0258,0.73895-3.0258z'/%3E %3Cpath d='m417.97,151.17s-0.34255-0.99436-0.34255-2.2474c0-1.2531,0.2145-1.2103,0.2145-1.2103s-3.4494-0.47632-5.9645,1.5118c-2.5114,1.9887-1.0655,5.4446-1.0655,5.4446s1.0981-1.0798,2.5007-1.5995c1.4048-0.51584,3.9334-0.43031,3.9334-0.43031,0.21235-0.21761-0.55275-1.2119-1.4907-1.4263-0.93959-0.21597-2.7681-0.21597-2.7681-0.21597s1.065-0.73559,2.8972-0.56076c1.8317,0.17159,2.0856,0.73399,2.0856,0.73399z'/%3E %3Cpath fill='%238f4620' d='m428.76,187.3-2.3306,0.80815,1.4203,9.794,9.3131,15.959,4.8852-0.86063,1.6481-2.9402l1.3067,0.57701c0.56237,0.577,2.386,3.6866,3.9205,4.32,1.5308,0.6344,2.3236,0.4038,3.6895,1.5021,1.3653,1.0918,6.3476,8.5111,6.6046,8.7964,0.25236,0.2885-0.28599-3.1822-0.28599-3.1822l-1.5195-4.4369-1.8834-3.0966-0.28599-0.83413,2.584,0.0281,1.6028,0.98132,2.457,2.0558,1.2763,1.5134,0.668,1.5578,0.28224,1.3651,0.65678,2.1186,1.36,2.9402,1.6369,2.7946,0.5229-1.141-0.79608-3.2829-2.4986-7.9655-1.5324-2.6794s2.0152,1.4528,2.553,1.6406c0.53993,0.18999,2.3727,2.9267,2.3727,2.9267l1.1658,2.8212,0.83823,2.6214,0.57519,2.2918,0.84192,2.445,1.4464-0.83252-0.25344-1.7694-1.2501-5.4628-0.53779-5.9197s0.69734-0.0168,1.5441,0.9202c0.85527,0.93478,1.622,3.0566,1.622,3.0566l0.62745,5.357,0.84832,4.9116,1.5895,5.0144,1.661,3.1524,1.0804,1.7694s0.0565-2.5045,0.0406-2.6198c-0.0128-0.11258-2.0302-20.968-2.0302-20.968l0.27158-0.87905s0.24061-0.13207,0.93638,0.86228c0.69573,0.9927,1.3926,2.5478,1.3926,2.5478l0.60988,3.2699,0.29717,2.262,0.42632,4.2636,0.56717,4.6215,2.1326,4.9598,1.1504,2.6761,0.64028-3.1806-1.0122-22.429,0.47327-0.64791s1.1893,0.97971,1.5862,1.6736c0.39964,0.68798,1.1397,1.364,1.1397,1.364l0.69413,4.943,0.6253,14.145,0.4962,3.6439,4.1606-37.049,2.5696-0.56075,0.29717-0.70743-1.8754-1.4409-4.2129-6.5378-2.8428-6.3247-4.9834-9.1822-8.6478-10.544s-5.3656-4.5819-6.7302-5.6188c-1.3637-1.0354-2.4917-1.685-2.4917-1.685l0.42633-1.3175,1.4267-2.3129-0.23369-0.10718-1.1119,0.066-2.8929,0.41028-2.9191-0.86553-5.7273-3.9968-6.1339-2.917-3.602-1.2747-8.6885-2.2046-8.6452-1.1675-3.8794-0.0525-3.5337,0.65929s-1.7965,0.74045-2.3594,1.8501c-0.55916,1.1096-0.60293,1.8863-0.43165,3.507,0.16913,1.6212,1.1492,2.4634,3.578,3.4594,2.4319,0.99216,8.136,4.7963,8.136,4.7963l2.7499,2.7632,1.0207,1.3191,0.1478,1.0171,1.8514,14.584-3.6618,7.9292-2.6251,1.3618z'/%3E %3Cpath fill='%23ab6d29' d='m438.11,210.03s1.5601,2.6512,3.7754,0.60677c2.2185-2.046-0.96732-7.8667-0.93479-8.2129,0.0277-0.34642,1.0207-0.46009,1.0207-0.46009l1.6204,2.996s0.96412,1.6124,0.59331,4.1765c-0.36602,2.5641-2.838,4.7833-2.838,4.7833l-2.8118-0.63491-0.42525-3.2547z'/%3E %3Cpath fill='%234d2a15' d='m492.51,244.21-2.0024-5.9228s-0.59277-3.802-0.59277-4.5804c0-0.77998-0.38576-10.416-0.55755-12.229-0.16913-1.8138-0.0811-3.8913-0.27316-4.1468-0.19315-0.26361-2.1732-2.8758-2.1732-2.8758l-0.84993-0.88717,0.60132-0.43032s0.73788,0.80815,0.93959,0.37132c0.19473-0.4287-0.0325-2.531-0.85207-5.8171-0.82541-3.2845-5.0303-10.976-5.0303-10.976l0.45405,0.37401,1.1669,1.1822,2.4709,1.9865,5.3409,1.9589,2.8961,0.46171,1.8722,3.7462s1.3344,6.4534,1.2501,9.7053c-0.0859,3.2585-0.28599,5.9079-1.534,9.1629-1.2469,3.2564-1.5606,13.57-1.7308,15.21-0.17236,1.6455-0.79661,3.2563-0.79661,3.2563l-0.59918,0.44981z'/%3E %3Cpath fill='%238f4620' d='m492.53,227.08s1.1183-1.3321,1.6092-3.1627c0.48765-1.8268,0.67922-16.196-1.0206-17.975-1.7063-1.7776-5.1845-3.179-5.357-3.062-0.17179,0.11692,1.391,4.6843,1.391,4.6843s0.52234,0.66901,1.0564,1.8582c0.29398,0.66143,0.69893,1.8582,0.76726,2.295,0.19316,1.2368,1.2123,4.15,1.3622,7.9046,0.14458,3.7527,0.19153,7.4579,0.19153,7.4579z'/%3E %3Cpath fill='%234d2a15' d='m484.68,236.1s0.73153-6.7986,0.39005-11.778c-0.3383-4.9776-0.75071-5.5996-1.224-6.4999-0.48072-0.8969-2.1828-4.15-3.3432-8.299-1.1573-4.1467-1.908-7.3276-2.6571-8.1568-0.74911-0.83085-2.2511-2.6268-2.5893-2.1418-0.34149,0.48336-0.34149,1.5204-0.34149,1.5204l-2.0461-0.55536-0.47646-1.3126,0.65624-2.1169-0.1302-0.90882-0.24009-1.4972,2.6427,2.1023,5.4249,3.7165,2.7254,11.252,2.5269,7.0011,0.35427,11.857-0.25556,10.44-1.4171-4.6231z'/%3E %3Cpath fill='%234d2a15' d='m487.87,203.66s1.4187,1.3386,2.2478,1.8036c0.83235,0.46496,2.3988,1.4279,2.0867,1.5351-0.30573,0.10717-1.7783-0.46659-2.695-0.98459-0.91661-0.518-1.5409-1.154-1.5409-1.154l-0.0987-1.2z'/%3E %3Cpath fill='%234d2a15' d='m477.3,233.42s1.081-2.386,0.91025-5.4126c-0.17233-3.0258-1.6172-10.315-2.0723-11.239-0.45512-0.9234-2.6101-2.3004-4.5442-6.3941-1.931-4.0926-1.733-4.9267-3.0071-6.424-1.2805-1.4988-2.6165-3.1973-2.6165-3.1973l0.39642-4.379,4.715,2.3908,2.0168,1.0073,2.3876,11.464,2.131,3.199,0.90491,4.5836,1.1396,10.686,0.62054,8.4998-0.33825,0.74857-2.6437-5.5333z'/%3E %3Cpath fill='%234d2a15' d='m471.86,228.57s0.12647-3.3706-0.72827-6.3941c-0.85314-3.0258-1.4464-5.2764-2.386-6.2247-0.93639-0.94777-3.3187-3.4128-5.4495-6.6116-2.1305-3.1968-5.0724-6.5688-5.0724-6.5688l0.0779-4.2886s1.4134,1.3305,2.6197,1.9162c1.2058,0.58513,3.0129,1.5957,3.0129,1.5957l1.2597,4.9186,1.6268,3.5384,2.3828,3.1643,1.5228,1.4062,0.97052,5.2943,0.52289,2.9792,1.2549,4.2523-0.41564,2.1289-1.1989-1.1058z'/%3E %3Cpath fill='%234d2a15' d='m467.94,228.61-1.3008-1.2515s0.70375-0.84603,0.36283-2.531c-0.34149-1.6834-0.78859-3.3056-1.5569-4.9035-0.76407-1.5979-0.99612-2.5722-1.4662-3.0453-0.47113-0.4747-4.4536-4.2377-5.8374-5.3789-1.3819-1.1476-3.5108-3.3305-4.834-4.1733-1.32-0.84059-2.2799-1.0587-2.2799-1.0587l-0.7459-5.2731s1.7484,2.3334,2.792,2.7221c1.0436,0.3908,2.7499,0.92992,2.7499,0.92992l3.7018,6.5475,1.2581,1.6639,3.4291,2.7432,1.4043,2.8298,1.0436,3.2645,1.3003,4.4964,0.23422,2.7204-0.25504-0.30257z'/%3E %3Cpath fill='%234d2a15' d='m460.66,227.14s-2.186-2.5062-2.5285-4.1224c-0.33988-1.6125,0.22942-1.6125-0.45566-3.4561-0.68243-1.8415-2.9527-4.5489-4.827-6.0511-1.877-1.4972-4.5426-3.685-4.3719-4.897,0.17073-1.2087,0.51059-1.2666,0.51059-1.2666l1.136,0.97811,5.8459,6.2258,1.7943,3.2569,1.3622,4.0596,0.90812,1.9026,0.87927,2.4222-0.25345,0.94777z'/%3E %3Cpath fill='%234d2a15' d='m481.76,196.6s4.0304,4.9992,5.0549,0.4038c0.45512-2.046-1.3979-5.9389-1.3979-5.9389s-3.7461-6.5635-5.0218-8.1483c-1.2779-1.5844-7.5253-9.5947-7.5253-9.5947l-4.5699-2.1316,1.5601,2.681s3.4067,3.3982,7.7561,10.917c4.341,7.5188,3.4894,11.667,3.4894,11.667l0.65411,0.14506z'/%3E %3Cpath fill='%234d2a15' d='m458.35,166.47s8.0046,6.828,13.163,14.216c5.152,7.3901,7.1967,12.319,6.0457,13.31-1.1503,0.99376-4.3885-0.55917-5.7043-2.635-1.3216-2.0742-2.4346-5.7049-7.2875-11.237-4.8569-5.5301-7.1967-6.353-7.1967-6.353l-3.4947-5.6605,4.4743-1.6406z'/%3E %3Cpath fill='%234d2a15' d='m454.18,182.84s4.7278,3.9324,7.7085,7.1293c2.9841,3.199,4.5181,5.489,4.5181,5.489l1.9133,1.901s-1.1492-2.0298-0.50902-2.7221c0.63707-0.69065,1.408-0.34481,1.408-0.34481l-15.039-15.776v4.3238z'/%3E %3Cpath fill='%234d2a15' d='m453.2,183.28s1.5345,2.9386,4.047,5.4014c2.513,2.4617,5.2806,5.1,5.2806,5.1l1.0676,3.8452s-6.8584-5.2694-6.9012-3.9752c-0.0443,1.2958,1.6626,3.9752,1.6626,3.9752l-2.0888-1.1232-2.8977-4.1928-1.7469-3.6293-1.9587-5.0144,3.5353-0.387z'/%3E %3Cpath fill='%234d2a15' d='m432.46,199.53s3.5774,3.1973,5.5387,0.0861c1.9603-3.1118,0.42631-6.6976,0.42631-6.6976s5.0511,7.4488,6.4753,0.4747c0.25557-1.2531-3.0684-6.0938-3.0684-6.0938l1.1925-1.121,2.5514,4.3194s2.3924-1.0798,2.3924-4.0623c0-2.9808-2.4704-6.828-2.4704-6.828l2.3551,2.6214s4.6691,0.1023,4.7571-2.7519c0.0827-2.8509-3.9205-5.8336-3.9205-5.8336s3.1949,0.21597,3.1496-1.6423c-0.0389-1.8566-4.3394-3.1546-4.4274-4.32-0.0843-1.1675,1.2779-3.1562,3.2376-2.0758,1.9602,1.0798,4.6857,1.9454,5.7925-0.17158,1.1082-2.1191-0.0843-2.5489-0.0843-2.5489s-2.5162-0.51908-2.7665-0.60517c-0.25984-0.0871-4.4765-2.3778-4.4765-2.3778l-3.5401-1.3386-3.6554-0.47632,1.3574,2.7221,0.94279,7.4756,0.0389,3.4577,0.68083,7.5204-1.7895,6.2659-0.92784,1.1291-0.65784,0.84117-1.5601,3.3088-2.1881,2.3692-2.8001,3.5811-2.5552,2.7714z'/%3E %3Cpath fill='%23ab6d29' d='m457.82,213.57s-0.90385-2.2442-2.8347-3.7446c-1.9341-1.5005-5.001-1.6141-5.001-1.6141l5.2512,5.5633,2.5845-0.2046z'/%3E %3Cpath fill='%23ab6d29' d='m465.17,214.84s-1.7026-3.3965-3.689-5.474c-1.988-2.0742-3.2963-4.7535-3.8373-4.7535-0.53618,0-0.93424,0.1153-0.93424,0.1153l0.51007,4.2918,3.6346,3.5173c-0.00036,0,3.4094,2.5337,4.3159,2.3032z'/%3E %3Cpath fill='%23ab6d29' d='m471.22,214.58s-0.84833-3.946-2.8668-7.7481c-2.012-3.8041-4.1446-5.3602-4.1446-5.3602l0.48074,4.0629,1.6514,3.9178,2.6656,3.8615,2.2137,1.266z'/%3E %3Cpath fill='%23ab6d29' d='m476.16,212.36s1.4187-8.1237,0.14299-10.373c-1.2757-2.2474-3.689-2.6777-3.689-2.6777l-0.77203,1.1789,0.77203,5.7909,1.9272,4.4353,1.6188,1.6461z'/%3E %3Cpath fill='%23ab6d29' d='m481.02,198.82s1.1909,0.60516,2.639,3.3403c1.4464,2.7373,3.4947,10.835,3.4616,11.266-0.0261,0.4287-0.76407,0.32964-0.96197,0.23275-0.19848-0.10555-5.1135-7.7828-5.1135-7.7828l-0.78005-7.1742,0.75499,0.11746z'/%3E %3Cpath d='m446.72,208.26s2.599-0.56243,2.599-1.469c0-0.90828-3.1058-2.7237-2.8513-4.1928,0.12379-0.73345,2.6395,0.13045,2.8124-0.38919,0.1686-0.51746-2.5974-4.839-1.749-5.832,0.85207-0.99436,3.1954,4.6664,3.1954,4.6664s1.4043,2.6626,0.89423,4.1912c-1.5772,4.7102-4.9007,3.0252-4.9007,3.0252z'/%3E %3Cpath d='m452.81,202.38c0.12644-0.37781,4.0907,0.5191,4.1329,0.25875,0.1526-0.92992-3.5769-3.802-3.5769-3.802s-0.85367-1.6406-0.59329-1.8994c0.25077-0.26036,2.6379,0.25928,2.7691-0.0871,0.12378-0.34641-2.7318-4.1056-2.7318-4.7963,0-0.69284,0.77203-0.0877,0.77203-0.0877s2.2559,2.3345,3.4505,4.236c1.1882,1.901,2.3092,3.4577,1.9128,6.4812-0.42258,3.2395-6.4721,0.73345-6.1355-0.30367z'/%3E %3Cpath d='m470.71,196.42s-0.64348-2.6794-0.25824-3.0258c0.38522-0.3448,1.4096-0.6479,1.4096-0.6479s-2.1129-1.3175-3.1143-1.3408c-1.001-0.0217-1.1487-0.31339-1.4043,0.1088-0.25664,0.42058,1.8109,3.0242,1.8109,3.0242l1.5564,1.8815z'/%3E %3Cpath d='m458.65,198.49s6.0917,1.5134,6.3471,1.0815c0.25557-0.43194-4.8574-5.1887-4.8574-5.1887s-0.33988-0.86062-0.25398-1.1643c0.0843-0.30149,2.2137-0.3448,2.8524,0.17321,0.63707,0.51801,0,1.5107,0.21448,1.901,0.2113,0.38919,2.131,3.3273,2.4725,2.851,0.34146-0.47471-0.38735-4.0613-0.21446-4.32,0.16858-0.25929,2.3439,2.0298,2.935,2.419,0.59811,0.38919,4.008,3.0702,4.349,1.8154,0.34147-1.2515,0.5528-1.469,0.42257-2.2046-0.12485-0.73345,1.1381,3.4594-0.45509,3.9752-1.5884,0.52125-3.4196-0.55862-3.4196-0.55862l-1.4075-1.082-0.82274-0.86387s0.91026,3.2417-0.15579,3.5849c-1.0628,0.34804-2.3001,0.17484-2.3001,0.17484l-2.5531-0.26035-3.1533-2.3335z'/%3E %3Cpath d='m472.64,194.33s6.5015,3.901,7.1432,3.212c0.64187-0.69066-1.6988-9.8479-1.3216-10.803,0.302-0.76374,5.279,10.401,2.854,11.927-1.853,1.1637-2.7691,0.34479-2.7691,0.34479l-3.1933-1.685-2.7131-2.9965z'/%3E %3Cpath d='m490.73,210.76s0.58855,0.43518,1.4171,0.66953c0.26302,0.0758,1.0452,0.31341,0.82915,0.33669-0.2113,0.0178-1.7325,0.20406-1.8413,0.24574-0.10565,0.0422-0.40498-1.252-0.40498-1.252z'/%3E %3Cpath d='m484.42,189.27s0.61949,0.35453,1.0047,0.46171c0.38362,0.10879,0.87451,0.34642,0.87451,0.41083,0,0.066-0.48074,0.27064-0.8222,0.22733-0.34147-0.0433-0.55275-0.14018-0.55275-0.14018l-0.50421-0.95969z'/%3E %3Cpath d='m482.55,186.07s0.6664,0.30528,1.5179-0.30148c0.85527-0.60517,0.91025-1.0073,0.84196-1.3256-0.0715-0.31664-1.4091-0.31664-1.8589-0.62027-0.45675-0.29988-0.42952-0.84876-0.42952-0.84876l-1.4625-0.0281-0.53991,0.20136,1.9309,2.9229z'/%3E %3Cpath d='m488.29,204.93s1.9896,1.1675,2.5466,1.2764c0.55061,0.10879,1.4902,0.62845,1.3606,0.80002-0.12485,0.17321-1.5942,0.30312-2.3407-0.12882-0.74483-0.43357-0.99137-0.1651-0.99137-0.1651l-0.57519-1.7824z'/%3E %3Cpath d='m477.58,175.32,0.0325,0.0114c0.11046,0.0314,0.47806,0.12504,0.79447,0.0904,0.37882-0.0427,0.69418-0.27388,0.82754-0.12666,0.26679,0.29824,0.0507,1.6818-0.48767,2.0758-0.53624,0.39567-1.1925,0.71555-1.287,0.69065-0.0992-0.0232-2.0969-2.8888-2.0969-2.8888l2.2169,0.14722z'/%3E %3Cpath d='m468.26,166.98s1.3019-0.0774,1.9523-0.0741c0.64983,0,1.4059,0.46982,1.9896,0.83951,0.58528,0.37077,1.1701,4.2983,0.85153,5.0388-0.31533,0.74211-4.6953-2.544-4.8137-2.838-0.12484-0.29825-2.0254-3.2379-2.0254-3.2379l2.0457,0.27173z'/%3E %3Cpath d='m464.15,165.2s3.1891,0.19757,2.8962-1.8252c-0.2892-2.0282-1.7516-2.9153-1.7516-2.9153l-3.8197,2.7156,2.6752,2.0249z'/%3E %3Cpath d='m455.6,161.47s0.85367,0.47145,1.8029,0.0974c0.94867-0.3697,3.4552-3.6293,5.2816-4.025,1.8269-0.39405,2.1907-0.36753,2.5354,0.0514,0.33988,0.41841,0.16914,2.2717-0.24703,2.7882-0.41138,0.52127-5.7214,2.7665-5.7214,2.7665s-1.105-0.066-1.9635-0.26522c-0.86115-0.20298-1.7357-0.57214-1.7357-0.57214l0.0475-0.84117z'/%3E %3Cpath d='m454.61,155.6c-0.80671-1.8842-2.2398-2.6512-2.7777-2.5262-0.53516,0.12396,1.8253,2,2.1668,4.5939,0.34147,2.5916,0.31533,4.3314,0.26945,4.4796-0.0485,0.14668,1.0959,0.16293,1.0959,0.16293l0.21768-0.98945,0.13658-0.70742-0.0128-0.63818-0.15633-1.3402-0.28065-1.0571-0.23263-0.8114c-0.00036,0.00053-0.0139-0.19378-0.42631-1.1665z'/%3E %3Cpath d='m447.06,152.92c-2.4442-2.8525-6.8718-4.884-7.1737-4.884-0.30092,0,5.1536,3.2861,6.3888,5.4014,1.2352,2.1185,1.2789,4.9695,1.8322,5.3586,0.55221,0.39079,1.0661-0.19271,1.1098-0.25712,0.0406-0.066,0.4455-0.64951,0.38202-0.82274-0.0651-0.17159-0.34148-1.3602-0.34148-1.3602l-0.84833-1.4263-0.51381-0.88717-0.83556-1.1226z'/%3E %3Cpath d='m439.82,149.94c-3.0914-2.7237-8.6922-4.0185-13.23-4.0824-4.5379-0.066-6.8563,0.34317-6.1986,2.8276,0.66318,2.4866,2.7078,3.5665,6.5389,3.5665,3.8373,0,4.7539-0.41029,6.8178,0.23601,2.0675,0.64955,3.9595,1.8171,4.707,2.5938,0.7475,0.77838-1.4257-1.901-3.3843-3.37-1.9598-1.469-3.2472-2.2393-3.2472-2.2393s-0.37669-0.80815,2.2692-0.44006c2.6358,0.3659,6.1713,2.0758,7.1315,4.2788,0.95717,2.2046,0.80938,3.415,0.78859,3.8896-0.0245,0.4747,0.91507-0.25927,0.91507-0.25927l0.38362-1.0814s0.15099-0.86388-0.36067-1.8355c-0.51062-0.97266-0.59811-1.2975-1.7885-2.7005-1.1941-1.4062-1.3419-1.384-1.3419-1.384z'/%3E %3Cpath d='m427.23,187.35c1.932-0.0574,6.2488-3.7446,6.8766-8.8707,0.62423-5.1297-2.5584-15.559-3.2963-16.653-0.73789-1.0966,1.1898-0.51909,2.243,0.57541s3.2098,8.5276,3.2098,13.944c0,5.4185-1.0804,6.9712-3.9766,9.7384-2.8967,2.7649-5.2272,2.478-5.2272,2.478l0.17074-1.2119z'/%3E %3Cpath d='m433.94,202.57s0.96358,1.2103,2.0408,0.80595c1.9896-0.7437,5.0549-2.2111,5.0549-5.0702,0-1.8452-2.3828-3.4561-2.4965-4.1484-0.11364-0.69065,0-1.2682,0-1.2682l2.0985,0.46171,0.59972,2.9365s0.8222,0.86547,1.6743,0.5207c0.85527-0.34804,3.2925-2.1316,2.9511-3.8615-0.33774-1.7299-2.6651-3.8599-2.8929-4.7243-0.22784-0.86547,0.0555-1.6141,0.0555-1.6141l1.9896,0.34479,0.60826,2.5272s0.52447,0.87419,1.6626,0.64305c1.136-0.23059,3.1234-2.3048,2.6704-3.2845-0.45564-0.97918-1.9309-3.2861-2.0445-3.5151-0.11419-0.22896-0.0566-1.095-0.0566-1.095l0.79607,0.4471s0.76567,0.30204,2.3001-0.14994c1.534-0.45521,3.0263-1.4923,3.0018-2.5505-0.0192-1.0587-1.1487-2.0742-1.2368-2.6561-0.0843-0.58352-0.0208-0.82274-0.0208-0.82274l1.0025,0.15157,1.2352,1.5335,0.29613,1.8365-0.44552,1.5762-1.8722,2.0331-1.8562,0.77838-0.50849-0.0444,1.1295,1.967-0.36601,2.6155-1.638,1.5102-2.1971,1.3191-0.16913,2.4417-1.2138,2.6366-2.8118,1.6634h-0.82595l-0.32333,1.5979-1.7634,2.5077-3.0455,2.0298-2.2185,0.41028-1.2763-1.8582,0.11259-0.6322z'/%3E %3Cpath d='m450.74,174.88s5.1002,1.4393,4.9407-1.7873c-0.0875-1.8155-4.9956-5.9918-5.3078-6.6827-0.31211-0.69231-0.22781-1.6423-0.22781-1.6423l2.5408,2.3264s3.2424,0.77187,4.1654-1.1015c0.92195-1.8696,0.17874-3.0469,0.0166-3.0896-0.15953-0.0412,0.7443-0.16347,0.7443-0.16347l1.5014,0.30691-0.17875,2.8867-1.6641,7.2581s0.4423,2.8493-1.804,3.0523c-2.2436,0.20406-4.7268-1.3634-4.7268-1.3634z'/%3E %3Cpath d='m455.57,213.55s0.088-1.4706-1.0484-2.4948c-1.1376-1.0225-3.3235-1.9871-3.6767-2.2046-0.35586-0.21436,3.6474,4.5505,3.6474,4.5505l1.0778,0.14885z'/%3E %3Cpath d='m462.96,213.79s-2.5584-3.154-3.109-4.2377c-0.55596-1.0766-1.876-3.4561-2.942-3.5649-1.0628-0.10718,1.0031,3.9324,1.0031,3.9324l4.1505,3.7841,0.89744,0.0861z'/%3E %3Cpath d='m469.96,213.72s-2.1923-4.1468-2.727-5.3586c-0.52983-1.2119-1.6818-4.5181-2.9825-5.4249-1.2955-0.90663,0.17074,1.5118,0.17074,1.5118l1.3862,4.2999,2.4319,3.7397,1.7207,1.232z'/%3E %3Cpath d='m475.12,210.71s-0.1494-3.54-0.57893-6.0052c-0.42255-2.4634-2.3407-4.5159-2.4671-4.4288-0.12964,0.0877,0.1462,4.386,0.1462,4.386l2.8998,6.0479z'/%3E %3Cpath d='m485.77,213.38s-1.7879-4.2572-2.513-6.2675c-0.72459-2.0098-2.5125-5.38-2.704-5.4233-0.19156-0.0433,0.533,3.8664,0.533,3.8664l2.171,6.2242,2.513,1.6z'/%3E %3Cpath d='m495.01,202.23s-1.6396-1.685-5.1765-3.0702c-3.5331-1.3803-7.0695-1.5335-7.0695-1.5335l0.4258,0.45306,1.606,1.364,3.6959,1.8994,4.8254,1.1675,1.693-0.28038z'/%3E %3Cpath fill='%23202020' d='m457.05,204.32s0.0277,3.0831,1.6167,4.9565c1.5926,1.8745,5.3392,5.3008,6.0805,5.9934,0.73843,0.68906,1.3622,4.4932,2.4709,7.6636,1.1034,3.166,1.3654,5.7626,1.8445,6.6543,0.48285,0.89043,1.4742,2.3313,0.7395,2.1878-0.7395-0.14343-1.4235-1.0089-1.877-2.1603-0.45564-1.1508-0.31373-1.1508-0.25237-2.7372,0.0555-1.5859-2.4149-9.7085-3.5529-10.6-1.1376-0.8969-6.361-5.2434-8.3796-8.2412-2.0136-2.996-1.5868-3.6883-1.5868-3.6883l2.8967-0.0292z'/%3E %3Cpath fill='%23202020' d='m465.48,224.63c-1.1087-2.2755-1.3067-4.2918-1.6481-5.6471-0.34147-1.3538-4.7427-5.0388-5.7957-5.5317-0.79608-0.37242-2.4543,0.10067-3.1208-0.40218-0.66586-0.50285-4.8286-5.2266-4.8286-5.2266s-0.62585,0.58999-0.42579,0.76161c0.20009,0.17484,4.5149,4.8407,6.0741,6.3364,1.567,1.4988,2.4149,4.8412,3.5524,7.4344,1.138,2.5884,0.68237,2.0725,0.7966,3.3386,0.11365,1.2698,0.90972,1.9919,1.7031,1.9919,0.79447,0,0.99457-0.37564,0.69899-0.59378-0.302-0.21434-1.9214-2.1153-2.8572-4.5803-0.85474-2.2474-1.9603-6.3941-3.3235-7.9527-0.0875-0.0958-0.18995-0.21759-0.30681-0.34642,0.32175-0.0379,0.86436-0.1402,1.6967-0.1862,1.0538-0.0563,5.396,3.9486,5.77,5.1297,0.36708,1.1822-0.0315,1.6406,1.7879,5.59,1.8168,3.9486,2.6672,4.8688,2.6672,4.8688h0.31693c-0.00036,0.00054-1.6519-2.7085-2.7568-4.9841z'/%3E %3Cpath fill='%23202020' d='m458.65,198.49s3.1533,1.9881,4.0876,2.2474c0.93478,0.25873,1.6188,0.34641,1.6188,0.34641s0.47005,5.7498,2.7691,8.9877c2.2969,3.2434,4.1723,4.4104,4.1723,4.4104s0.0859,6.2622,1.7906,10.587c1.7063,4.32,2.0446,9.5482,1.661,10.368-0.38362,0.82113-1.8338-2.5478-2.7664-5.5301-0.9396-2.983-1.8349-6.2194-2.4725-8.2097-0.63812-1.9886-2.386-4.9727-3.364-5.7925-0.98388-0.82112-0.19368-0.73232,0.38202-0.21596,0.57519,0.51909,2.2361,2.5705,3.3022,5.8796,1.0628,3.304,1.4886,6.6533,2.0638,6.6762,0.57573,0.02,1.0207-0.54071,1.0031-1.2119-0.0229-0.66576-0.7459-2.3974-1.2762-5.4874-0.53624-3.0896-1.0692-5.2055-1.5799-6.0709-0.51329-0.86387-1.2576-1.0155-3.2355-4.4732-1.9811-3.4561-2.8556-5.3789-3.197-6.9797-0.34147-1.5995,0.0619-1.4457-0.27905-1.685-0.33826-0.23708-0.59329,0.0232-2.1027-0.81948-1.5142-0.84277-2.577-3.0263-2.577-3.0263z'/%3E %3Cpath fill='%23202020' d='m466.82,197.32s1.9309,1.4988,3.0087,1.9589c1.0804,0.46008,2.6411,0.54563,2.6411,0.54563s-0.39325,5.4463,1.7357,8.9914c2.1294,3.5432,4.3431,5.6156,4.3431,5.6156s0.34148,1.3272,1.0239,8.93c0.68242,7.6092,0.70855,7.7497,0.90705,10.804,0.19955,3.0539,0.29399,13.875-0.14351,13.542-1.6449-1.2682-0.28279-7.1459-1.105-9.5631-0.82381-2.4238-2.1289-2.8276-3.7204-9.6801-1.5911-6.859-0.57034-8.416-1.7031-10.978-1.1359-2.5657-2.641-2.7952-2.641-2.7952s2.1001,0.40434,2.9809,2.5641c0.88253,2.1602,1.0175,7.9009,1.7356,10.747,1.6172,6.424,3.833,9.678,3.833,9.678s-0.48444-8.0655-1.1087-12.646c-0.62585-4.5841-0.59437-8.4112-1.4464-10.169-0.85528-1.7608-2.7014-3.1719-3.8063-5.5056-1.1082-2.3329-1.5052-6.9135-2.0478-8.0943-0.53677-1.1822-0.84513-0.81461-1.6156-1.1226-2.5002-1.0089-2.871-2.8244-2.871-2.8244z'/%3E %3Cpath fill='%23202020' d='m472.64,194.33s1.7047,1.8994,4.0854,3.3126c2.3898,1.4111,3.5806,0.98132,3.951,1.2677,0.36867,0.28851-0.48394,5.1281,2.0168,9.593,2.5002,4.4666,3.4083,4.5527,3.4654,5.1611,0.0555,0.59972,0.51006,13.768,0.82381,18.232,0.31049,4.465,0.65036,19.446-1.1946,19.446-1.8444,0-0.17021-11.065-1.0788-13.656-0.91186-2.5949-0.87879-1.8446-1.7586-3.914-0.88413-2.079-0.87131-10.281-2.274-15.13-1.0484-3.6277-2.1305-4.2063-2.1305-4.2063s1.7655,0.94942,2.5845,3.9486c0.8238,2.9944,1.0804,13.052,2.0446,14.661,0.96358,1.6157,2.3567,3.6028,2.6704,5.1032,0.31373,1.4955-0.19848-19.103-0.62424-20.34-0.42419-1.2417-4.5736-8.7013-4.8873-12.821-0.3084-4.1186-0.45513-4.5246-0.81899-4.8391-0.3735-0.3199-1.5601-0.0595-3.5204-1.9026-1.9634-1.8431-3.3544-3.9173-3.3544-3.9173z'/%3E %3Cpath fill='%23202020' d='m482.01,196.7c0.11685-0.39568,1.3002,2.2144,5.0058,3.685,3.7055,1.469,7.2426,1.2103,7.7117,1.5979,0.46794,0.38918,2.8129,5.9656,2.8945,13.395,0.0897,7.436-1.2773,6.743-2.4266,13.141-1.1487,6.3957-1.1941,19.4-1.916,21.389-0.34306,0.73345-0.72512,1.0355-1.1103,2.2918-0.38203,1.2498,0.29612,3.6287-0.85314,3.6715-1.1477,0.0427-1.2763-1.8138-1.2763-2.8092,0-0.99436,1.1946-4.5359,1.1946-8.081,0-3.5454-0.76888-3.9757-1.2805-8.2129-0.5106-4.2328-0.55274-17.715-1.0207-19.012-0.46844-1.2942-2.7825-4.1008-2.7825-4.1008s2.4847,1.5941,3.0813,3.4079c0.59437,1.8187,0.65357,16.79,1.32,19.796,0.68243,3.0652,0.46793-0.69232,0.72458-2.4239,0.25343-1.7262,1.1503-9.0737,1.0206-13.006-0.12857-3.9292-1.7911-12.444-3.1533-13.871,0,0,0.70855,0.82599,1.4891,2.6972,0.0192,0.053,0.50047,0.54565,1.0591,0.86874,0.5901,0.3394,1.2645,0.5126,1.2843,0.57375,0.0192,0.0444-0.74751-0.0644-1.351-0.32693-0.44657-0.1927-0.7731-0.55697-0.75873-0.52234,0.83978,2.2241,1.6866,5.6632,1.7677,10.58,0.11737,6.6987-0.978,21.437,0.088,21.608,1.0661,0.17483,0.85528-8.0366,1.9603-14.691,1.105-6.6559,2.5968-7.6091,2.1289-13.052-0.46793-5.4446-1.9149-11.323-3.0636-12.058-1.1487-0.73346-4.4322-0.47469-7.3313-2.3345-2.8919-1.856-4.5272-3.8068-4.4066-4.2009z'/%3E %3Cpath fill='%23202020' d='m435.05,204.2s1.0677,0.47471,2.3012-0.12828c1.2384-0.60676,4.517-3.1973,4.517-4.2804,0-1.0798,0.0454-2.1597,0.0454-2.1597s0.0406,0.47634,0.98016,0.60351c0.93317,0.1337,3.618-1.8994,3.8277-3.1952,0.21608-1.2963,0.21608-3.586-0.0811-4.0612-0.29933-0.47633,0.80777,0.4747,1.3606-0.0444,0.55435-0.51909,3.1528-2.2046,3.1138-3.9324-0.0454-1.7294-1.4513-3.3289-1.4513-3.3289s1.279,0.17321,2.043,0c0.76989-0.16942,3.3251-1.6834,3.2386-3.2395-0.0859-1.5562-0.9764-3.9324-2.982-4.1056,0,0,1.4918,0.34642,2.9414-0.17159,1.447-0.5191,1.9603-1.3408,1.9603-2.9846,0-1.6406-2.9399-5.1839-3.4521-5.4853-0.51008-0.30204,3.1512,1.0371,4.0891-0.43357,0.93265-1.469,1.0629-2.5062,0.80778-3.3256-0.25504-0.82273-1.0223-1.0371-1.0223-1.0371s1.5798,0.43032,3.7087-0.64952c2.1294-1.0798,4.0032-2.5061,4.9834-2.4634,0.97855,0.0444-3.1106,2.2025-3.3251,3.415-0.0859,0.49961,1.1151,1.357,2.965,2.7124,0.11684,0.0823,0.17179,0.16129,0.35749,0.26035,0.83823,0.45305,4.0209,0.58351,4.2353,0.74371,0.26624,0.19649-3.0754,0.12395-2.7894,0.34155,2.2495,1.7196,4.9834,4.0233,7.4857,7.0631,0.0944,0.11259,0.6243,0.57214,1.2341,0.74857,0.7459,0.21272,1.5958,0.14507,1.7063,0.28688,0.0811,0.10879-2.1598-0.0563-2.0787,0.0514,1.6022,2.0872,3.0487,4.2009,4.294,6.1596,0.0875,0.13857,0.60934,0.74858,1.2058,1.0057,0.65362,0.28038,1.3867,0.21272,1.4758,0.36104,0.16646,0.25927-1.8231,0.0103-1.6705,0.26198,2.4895,4.0894,4.3362,7.8865,4.3362,7.8865s-4.0112-7.0535-8.9129-12.544c-4.8985-5.4874-6.0479-6.221-6.3028-5.7017-0.2561,0.51801,3.6634,5.357,5.7503,8.7697,2.0851,3.4166,3.9824,7.6626,3.9824,7.6626s-4.9198-10.211-11.819-16.477c-6.9039-6.2654-7.6241-7.3024-8.393-7.0438-0.76722,0.26036-1.36,4.884-0.89369,5.8336,0.46793,0.95156,5.4933,4.7535,9.794,9.8105,4.3031,5.0556,9.7582,13.741,9.7582,13.741s-3.8752-6.2654-10.436-13.224c-6.5614-6.9568-9.071-8.5554-9.5824-8.5127-0.51223,0.0427-0.55756,1.2975-1.32,2.3345-0.76887,1.0355-2.3455,0.90662-2.3908,1.3835-0.0384,0.47471,5.5424,5.6156,6.6474,6.221,1.1066,0.60517,1.7031,0.30366,2.5552,0.77839,0.85153,0.4747,1.7746,1.2682,1.7746,1.2682s-1.1749-0.44709-2.0286-0.70582c-0.85368-0.25927-1.7063-0.30366-1.7063-0.0433,0,0.25766,4.5181,5.7888,5.2816,6.1355,0.76882,0.34643,1.1946,0.17322,2.2169,0.56242,1.0207,0.38917,2.4741,1.4263,2.4741,1.4263s-1.5815-0.90881-2.6886-1.1248c-1.105-0.21596-1.5745,0-1.534,0.30367,0.0454,0.30149,3.4521,4.6664,3.2829,4.7535-0.16912,0.0861-5.2821-6.0511-9.6283-9.896-4.3463-3.8469-6.3038-4.668-6.5176-4.5375-0.21128,0.12882-0.0843,1.2547-1.1503,1.6423-1.065,0.38918-2.0451,0.51908-2.0451,0.90662,0,0.38918,3.9205,4.0629,6.6864,7.1315,2.7691,3.0669,5.1552,5.964,5.1552,5.964s-2.8102-2.8098-5.8769-5.7048c-3.0684-2.8953-4.6414-4.0179-4.9407-3.8452-0.2993,0.17158-0.33986,1.6406-0.0443,2.0298,0.29772,0.38918,5.9667,7.0882,5.7962,7.2597-0.17073,0.17321-6.688-8.0366-7.1138-8.0366-0.42952,0-0.68457,1.0355-1.1087,1.5118-0.42898,0.47632-2.2585,0.47632-2.2585,1.1226,0,0.64951,9.2003,9.6785,8.9455,9.8944,0,0-7.6225-6.5672-7.8795-6.1783-0.25717,0.38919,3.1917,6.6976,2.9804,6.828-0.21396,0.13045-4.4727-6.6116-4.859-6.5672-0.37721,0.0412-0.33986,0.77674-1.4464,1.7706-1.105,0.99436-2.5109,0.56242-2.5552,0.99436-0.0422,0.43194,6.3482,7.5204,6.1761,7.6487-0.17074,0.12882-6.4721-6.742-6.6442-6.353-0.0422,0.1023-0.38201,0.39892-0.21128,0.99435,0.46846,1.6574,1.8904,4.6713,1.7031,4.9252,0,0-2.0446-4.1917-2.6-4.0185-0.55275,0.17321-0.55275,0.99595-1.4923,1.5995-0.93264,0.60516-1.7004,0.47632-1.7879,0.90661-0.0827,0.43194,1.1082,1.1675,1.622,2.1635,0.50688,0.99436,0.93638,3.1557,0.93638,3.1557s-0.64027-1.8187-1.5345-2.9841c-0.89369-1.1675-1.7063-1.9459-2.386-1.9459-0.68083,0-1.1503,0.64957-1.1503,0.64957l-0.64027-1.514z'/%3E %3Cpath fill='%23202020' d='m494.74,201.99s2.0851-0.12829,2.3407-0.56077c0.25665-0.43356-0.76728-0.13045-2.6411-2.1597-1.8728-2.0331-6.6575-15.89-11.884-22.863-8.5554-11.411-16.569-16.636-16.569-16.636s9.5327,5.5168,16.913,16.292c7.4927,10.949,9.3126,19.534,11.411,21.78,2.1043,2.2474,4.1489,2.6496,4.0352,3.2845-0.11416,0.63493-0.45564,1.095-1.2517,1.2103-0.79287,0.11529-2.727,0.28688-2.727,0.28688l0.37189-0.63386z'/%3E %3Cpath fill='%23202020' d='m431.77,198.97s0.0555,0.16672,0.44178,0.2111c0.39162,0.0493,2.9809-2.5343,2.838-3.2796,0,0-1.1508-0.43194-2.0835-1.3819-0.93639-0.95156-1.1525-2.4634-1.1525-2.4634s0.85367,1.685,1.5766,2.1597c0.72458,0.47471,1.8738,0.73345,2.3001,0.38918,0.42737-0.34643,4.2385-3.1687,4.0043-4.2788,0,0-1.1909,0.0433-2.3012-0.77838-1.1055-0.82114-1.3067-2.5078-1.3067-2.5078s0.71336,1.3553,1.8493,1.9048c1.1311,0.54724,2.2414,0.31611,2.5552-0.0877,0.31213-0.40433,2.8118-3.8339,2.5253-4.8391,0,0-1.2757,0.14344-2.4133-0.66308-1.136-0.80815-1.7309-2.8244-1.7309-2.8244s0.8222,1.7002,2.2692,1.987c1.4496,0.2885,2.6427-0.5754,2.8684-1.6108,0.22622-1.0371,1.0223-4.8986-0.19474-5.8785,0,0-1.8786,0.60515-3.212-0.0855-1.3312-0.69231-1.8151-2.3908-1.8151-2.3908s1.1344,1.5551,2.6358,1.7559c1.5084,0.20137,2.1635-0.6035,2.4154-1.2103,0.25983-0.60516,0.31532-2.793-0.14034-4.0033-0.45351-1.2103-1.3926-1.1248-1.6151-2.9381,0,0-0.48767,0.71882-2.4186,0.71882-1.9304,0-2.9548-2.1895-2.9548-2.1895s1.5377,1.4133,3.069,1.2975c1.5324-0.1153,2.1011-1.3835,2.1337-2.3627,0.0229-0.98131-0.77148-1.8452-1.1941-2.8525-0.4263-1.0089-0.45671-2.2193-0.74002-2.0742-0.28438,0.14344-0.65202,1.0653-2.6427,0.74857-1.9859-0.31502-2.4132-1.6704-2.4132-1.6704s1.4486,1.009,2.5552,0.9218c1.1114-0.0855,1.8167-0.60516,1.8167-1.3532,0-0.75023-0.42257-2.1337-2.9233-4.2658-2.497-2.1316-4.5432-3.599-4.5432-3.599s3.2376,1.7857,5.3376,3.5432c2.106,1.7581,3.2931,3.4577,3.2931,3.4577s2.3044,0.74857,2.5579-0.0298c0.25396-0.77839,0.21608-1.7494-0.51008-3.133-0.70856-1.3521-2.6816-3.37-2.6816-3.37s2.0638,1.7061,3.0423,3.4772c0.97854,1.7722,0.53676,3.0041,0.61782,3.436,0.0875,0.43033,4.3885,2.0959,5.3469,1.5134,0.95877-0.58406,0.51168-1.8371-0.29772-3.1129-0.80778-1.2742-1.4742-2.3329-1.4742-2.3329s1.0047,1.1031,1.726,2.3546c0.72618,1.2547,1.3216,2.249,1.0463,2.8309-0.27478,0.58347-0.87452,0.84278-0.80938,1.0814,0.0651,0.236,1.487,0.9927,2.9388,1.7494,1.4497,0.75669,3.1298,1.4263,3.3448,1.0154,0.2129-0.4119,0.36122-1.4046,0.23689-2.8092-0.13124-1.403-0.93905-3.5432-0.93905-3.5432s0.95557,2.0742,1.1274,3.5432c0.16913,1.4706-0.18887,2.5722,0.14939,3.0896,0.34148,0.51908,1.4043,0.64951,1.4043,0.64951s-0.85154,0.60351-2.7462,0.0427c-1.8952-0.56241-10.031-4.668-10.416-4.2788-0.38202,0.38919,3.792,2.917,5.7097,4.7324,1.9181,1.8138,2.8529,3.7165,2.8529,3.7165s-1.4907-1.2547-2.9372-2.0525c-1.448-0.7995-5.7952-3.0252-6.0741-2.7237-0.27105,0.30365,1.6433,0.69064,1.7895,1.0387,0.14941,0.34642-1.3606,1.7066-1.3606,2.2685,0,0.56077,6.197,4.8607,6.0041,5.3354-0.18996,0.47633-1.5734,1.5995-1.829,1.5351-0.25611-0.066-3.3203-2.4206-3.3203-2.0526,0,0.36807,1.7618,1.8582,1.7442,2.1814-0.0197,0.32476-1.1701,1.1031-0.96251,1.8371,0.21609,0.73505,3.4558,3.3933,3.4329,4.2999-0.0229,0.90662-1.853,1.685-1.5116,2.2685,0.33827,0.58407,2.0008,2.635,2.0008,2.635s-1.7895-1.187-2.3668-1.8122c-0.57519-0.62787-1.7276-1.9881-1.9325-1.7738-0.21556,0.2176-1.3654,2.7454-1.2592,3.3072,0.10885,0.56076,1.5553,1.4246,1.8317,2.9581,0.27798,1.5351-0.21395,3.133-0.32172,3.133-0.10565,0-2.147-2.635-2.5552-2.6777-0.40283-0.0428-0.91346,0.13045-1.2549,0.80003-0.34147,0.66902-1.5356,2.7649-1.383,3.154,0.1446,0.38757,2.1465,0.84277,2.1923,2.4417,0.0422,1.5995-1.2581,3.0886-1.3851,3.0886-0.12806,0-2.4917-3.1757-2.7254-3.1757-0.23531,0-2.9191,2.983-2.9826,3.3489-0.0651,0.36752,1.8301,1.7083,1.4923,2.2274-0.3436,0.51802-1.622-0.19594-2.3471,0.21434-0.72137,0.41247-1.9986,0.92832-2.2559,0.92832-0.25396,0-0.63921-0.86226-0.63921-0.86226z'/%3E %3Cpath fill='%23202020' d='m465.92,159.9s0.21449-0.84224,0.62104-1.2742c0.40281-0.43356,2.0478-2.249,1.4267-2.6149-0.61735-0.3659-2.704,0.30367-4.0241,0.1927-1.3216-0.10554-2.1939,0.2176-6.0281-2.9597,0,0-12.158-8.4998-30.989-9.593-5.9651-0.3448-8.6356,1.7873-8.9193,2.9099-0.0266,0.25874,1.5649-2.4206,7.5546-2.3335,2.6427,0.0281,21.604,1.56,31.436,9.2768,0.51382,0.40217,3.7706,3.5221,6.8168,3.1757,3.0455-0.34642,3.6858-0.69065,3.6207-0.25927-0.063,0.43194-1.0207,1.5562-1.2346,2.0725-0.21128,0.51909-0.42258,1.4706-0.42258,1.4706l0.14247-0.0633z'/%3E %3Cpath fill='%23202020' d='m433.06,162.41s-0.016-0.0547-0.0491-0.15481c-0.1702-0.51801-1.3814-2.2095-3.4419-4.1224-2.4709-2.2918-10.143-5.489-10.525-5.6188-0.38257-0.12992,7.8758,3.8041,10.184,6.0067,3.7018,3.5438,3.8325,3.8896,3.8325,3.8896z'/%3E %3Cpath d='m433.04,175.94s-0.50368-0.83087-2.1192-1.8696c-1.622-1.0371-3.2408-1.469-3.2408-1.469l3.7477,0.95156c1.1087,0.94942,1.6124,2.387,1.6124,2.387z'/%3E %3Cpath d='m432.07,168.89s-0.5106-0.73399-2.8102-1.469c-2.3012-0.73506-2.8529-0.69231-2.8529-0.69231s2.1294-0.90662,3.7461-0.0839c1.6177,0.81895,1.9171,2.2452,1.9171,2.2452z'/%3E %3Cpath d='m430.71,163.1s-0.46952-1.0371-2.5141-1.7706c-2.0445-0.73557-3.4948-0.86548-3.4948-0.86548s2.1289-0.60349,4.1772,0.21599c2.0445,0.82059,1.8317,2.42,1.8317,2.42z'/%3E %3Cpath d='m428.24,159.38s-0.59971-0.81953-4.429-1.7262c-3.8373-0.91042-5.3275-0.95322-5.3275-0.95322s5.4543-0.43031,6.9012,0.17484c1.4459,0.60356,2.8556,2.5045,2.8556,2.5045z'/%3E %3Cpath d='m421.21,155.36s-2.3396-0.64791-4.5987-0.82113c-2.2585-0.17321-5.7962,0.12883-5.7962,0.12883s6.5624-1.0355,8.307-0.64631c1.7484,0.38702,2.0878,1.3386,2.0878,1.3386z'/%3E %3C/g%3E %3Cg id='claws' fill='%23f8c83c' stroke='%23977c2e' stroke-width='0.35'%3E %3Cpath d='m399.63,236.56s1.1648,2.046,3.4643,2.1316c2.3012,0.0861,4.0892,3.3716,4.0892,3.3716l-2.5279,2.478-6.0757,0.28525-1.9582-3.1394,3.0082-5.127z'/%3E %3Cpath d='m399.77,234.46c0.19849-0.40054-1.7895-4.3232-3.2098-4.9841-1.4198-0.65929,0.48286,1.2698,0.17073,2.0742-0.31158,0.80815-0.52181,1.8024-0.4087,1.9459,0.11473,0.14344,1.1744,1.8019,0.60719,2.5505-0.56931,0.74857,2.8406-1.5865,2.8406-1.5865z'/%3E %3Cpath d='m398.68,240.44s1.081,0.53912,1.9325,0.29012c0.8526-0.25061,1.6092-1.1166,1.6092-1.1166'/%3E %3Cpath d='m397.58,238.92s3.4099-2.478,3.126-3.8004c-0.28598-1.3272-0.96625-1.2693-1.4214-1.1524-0.45353,0.11367-2.5552,1.8431-2.6678,2.2452-0.11418,0.40271,0.96304,2.7075,0.96304,2.7075z'/%3E %3Cpath d='m395.17,240.62s0.62424,1.6439,1.7308,1.6439c1.1087,0,2.6987-0.89364,2.7264-1.5535,0.0293-0.66741-1.1076-1.8761-1.8461-2.2193-0.73788-0.3448-2.4421,0.54558-2.4421,0.54558l-0.16914,1.5833z'/%3E %3Cpath d='m398.27,238.38c-0.16968,0.51422-2.329,1.5248-3.0391,1.5827-0.70856,0.0574-2.1571-1.7575-1.5628-2.0184,0.59811-0.25928,1.3376-0.23275,1.8754-0.51746,0.5405-0.29177,0.68242-1.009,0.99404-1.0387,0.31212-0.0281,1.193,0.20299,1.4198,0.74697,0.22836,0.55051,0.48233,0.72533,0.31267,1.245z'/%3E %3Cpath d='m396.05,239.81s-3.348,4.5262-4.74,4.2967c-1.392-0.23059,0.56718-6.4256,0.56718-6.4256s0.5405,0.34695,1.6471,0.69444c1.1076,0.34318,2.2153,0.74697,2.5258,1.4344z'/%3E %3Cpath d='m390.09,236.59s4.3175,0.74803,4.5165,1.4414c0.19847,0.69066-2.0739,1.6125-3.2947,1.6125-1.2218-0.00036-1.2218-3.0539-1.2218-3.0539z'/%3E %3Cpath fill='%23202220' stroke='none' d='m379.35,243.13s0.57039,2.0758,2.4447,2.1916c1.8738,0.1153,3.6346-1.9605,3.6346-1.9605l-4.4306-1.7278-1.6487,1.4966z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m379.35,243.13-0.0966,0.0281c0.00037,0.0103,0.14621,0.53587,0.53409,1.0869,0.38522,0.54565,1.0239,1.1226,2.0019,1.1789l0.15686,0.007c1.8877-0.0114,3.5492-2,3.5593-2.0016l0.0944-0.11367-4.6232-1.8008-1.7426,1.5833,0.0187,0.0606,0.0971-0.0287,0.0715,0.0763,1.5996-1.4561,4.3703,1.7067,0.0373-0.0958-0.0758-0.0677s-0.1003,0.11746-0.28437,0.30203c-0.54474,0.54726-1.8162,1.6292-3.1223,1.6238l-0.14619-0.003c-0.89797-0.0547-1.4811-0.577-1.8461-1.0934-0.1846-0.25927-0.31052-0.51585-0.39002-0.70423-0.04-0.0974-0.0688-0.17809-0.088-0.23112l-0.0251-0.0839-0.10085,0.0265,0.0715,0.0763-0.0715-0.0763z'/%3E %3Cpath fill='%23202220' stroke='none' d='m380.6,242.55s0.73681,1.56,3.1805,1.6174c2.4421,0.0563,4.373-1.96,4.373-1.96l-3.8624-3.0539-3.6911,3.3965z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m380.6,242.55-0.0902,0.0466c0.004,0.0178,0.77791,1.6157,3.2675,1.6736h0.10672c2.45-0.003,4.3346-1.9854,4.3436-1.9887l0.0795-0.0823-4.0208-3.179-3.8112,3.5086,0.0347,0.0677,0.0902-0.0466,0.0683,0.078,3.6276-3.3386,3.7956,2.9987,0.0619-0.0801-0.0742-0.0747-0.0811,0.0855c-0.38469,0.36482-2.0707,1.8484-4.1142,1.8452h-0.10139c-1.1989-0.0314-1.9688-0.4222-2.4452-0.80815-0.23531-0.19269-0.39804-0.37727-0.50048-0.51746-0.0523-0.0709-0.0891-0.12828-0.11205-0.17105l-0.0315-0.0595-0.0934,0.0422,0.0683,0.078-0.0683-0.078z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m380.93,242.91s1.0788,0.89311,2.3567,0.96455c1.2789,0.0709,2.8694-0.33127,2.8694-0.33127l-1.4635,0.53046-1.05,0.11691-0.99403-0.15805-0.89369-0.33289-0.69627-0.518-0.12858-0.27172z'/%3E %3Cpath fill='%23202220' stroke='none' d='m383.78,240.76s1.0788,2.6528,3.3507,2.3643c2.2713-0.29012,2.3279-1.6124,2.3279-1.6124l-2.5552-3.6899-3.1234,2.9381z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m383.78,240.76-0.0944,0.0428c0.002,0.007,0.24757,0.61002,0.75659,1.2168,0.50634,0.61056,1.2859,1.2314,2.346,1.2314,0.11525,0,0.23423-0.01,0.35534-0.0244,1.1541-0.1456,1.7661-0.55916,2.0814-0.94995,0.31799-0.38918,0.33827-0.74697,0.33827-0.76161l0.00036-0.0335-2.6443-3.8133-3.2605,3.0664,0.0266,0.0676,0.0944-0.0422,0.0699,0.079,3.0375-2.8558,2.4885,3.5898,0.0827-0.0606-0.10083-0.004-0.006,0.0449c-0.0443,0.22409-0.2812,1.2114-2.2334,1.4674-0.11364,0.0163-0.22356,0.0227-0.33026,0.0227-0.97748,0-1.7009-0.57374-2.1897-1.1556-0.2433-0.29014-0.42416-0.58353-0.54686-0.8027-0.0592-0.1088-0.10297-0.20137-0.13392-0.26199-0.0293-0.066-0.0422-0.10122-0.0422-0.10122l-0.095,0.0379,0.0699,0.079-0.0699-0.079z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m384.1,241.28s1.3622,1.6574,2.5568,1.6309c1.1903-0.0298,1.9448-0.48012,1.9448-0.48012l0.056,0.18999-0.62585,0.31666-1.0799,0.21921-1.106-0.14668-0.90865-0.54618-0.83717-1.1838z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m379.79,243.94s1.05,1.0782,2.0152,1.1226c0.96731,0.0427,2.4431-0.77838,2.4431-0.77838l0.18462-0.0579-0.25451,0.23113-0.99558,0.54617-1.2069,0.34642-0.95076-0.1732-0.72404-0.44493-0.44018-0.56077-0.071-0.23112z'/%3E %3Cpath d='m389.83,236.36c1.0218-0.14344,3.1512,2.767,3.1512,4.2063,0,1.4409-0.62317,3.6022-1.6748,3.5448-1.0522-0.059-3.4371-2.1911-3.976-3.2823-0.5405-1.0966-1.0783-1.8468-0.68028-2.4244,0.39536-0.57648,3.18-2.0444,3.18-2.0444z'/%3E %3Cpath d='m379.24,236.62s-1.7041-1.3224-2.386-0.63167c-0.68189,0.68905-0.45513,2.9943,0,3.4561,0.45351,0.46171,2.497-1.0966,2.497-1.0966l-0.11098-1.7278z'/%3E %3Cpath d='m379.01,238.23s-2.2724,0.23276-2.2724,1.2699c0,1.0387,1.0794,2.1316,1.3061,2.3611,0.22569,0.2322,2.2718-0.92181,2.2718-0.92181l-1.3056-2.7091z'/%3E %3Cpath d='m379.92,240.13s-2.33,0.6923-2.33,1.4972c0,0.8027,1.0223,2.3054,1.7591,2.3054,0.74055,0,1.3093-1.4447,1.5911-1.7294,0.28598-0.28904-1.0202-2.0731-1.0202-2.0731z'/%3E %3Cpath d='m381.06,233.39s-0.45458-0.63167-1.4208-0.23113c-0.96518,0.40433-2.0445,1.3835-1.8738,2.9402,0.17073,1.5529,0.73788,2.5916,0.73788,2.5916l3.522-1.2114-0.96519-4.0894z'/%3E %3Cpath d='m381.34,236.1s-3.0082,0.97972-3.1223,2.1305c-0.11471,1.154,0.68189,2.3086,1.4768,2.5343,0.79554,0.23276,3.3502-2.2452,3.3502-2.2452l-1.7047-2.4195z'/%3E %3Cpath d='m383.95,240.89s-2.9532,1.9535-3.3512,1.9535c-0.39749,0-1.4768-1.5546-1.2517-2.59,0.22836-1.0371,2.2164-1.7857,3.0119-2.0758,0.79608-0.2885,1.5911,2.7124,1.5911,2.7124z'/%3E %3Cpath d='m386.54,230.17s-0.93746-0.77998-2.7264-0.64789c-1.7895,0.12827-3.1085,2.4617-3.3219,3.6293-0.21394,1.1637-0.0432,3.37,0.63866,3.7164,0.68029,0.34317,4.3869-2.6382,4.3869-2.6382l1.0228-4.0596z'/%3E %3Cpath d='m382.92,239.02c-1.2352-0.13153-2.3428-1.9042-2.131-2.9808,0.21181-1.082,2.6421-2.9419,3.9194-2.7237,1.2768,0.21434,1.0207,3.415,1.0207,3.415s-1.5756,2.4185-2.8092,2.2896z'/%3E %3Cpath d='m386.85,238.75s-0.62478,1.4426-1.8749,2.0774c-1.2491,0.63113-1.987,0.11204-2.7264-0.9234-0.73682-1.0387,0.34147-1.5004,0.91025-2.0195,0.56717-0.51422,2.2142-0.92019,2.2142-0.92019l1.4769,1.7857z'/%3E %3Cpath d='m384.86,234.95s-1.392,1.121-0.59545,2.4206c0.79448,1.2975,1.4203,1.7559,2.4122,1.9275,0.99558,0.17483,1.646-0.22896,2.4437-1.1822,0.79501-0.94996,1.9587-1.3802,1.8461-2.5641-0.11418-1.1805-0.56877-2.1023-1.2789-2.4482-0.70856-0.34372-2.8673,0.0308-4.8276,1.8463z'/%3E %3Cpath fill='%23202220' stroke='none' d='m388.82,229.39s-1.4364-0.55104-2.545,0.0991c-1.1071,0.6479-1.8733,1.967-1.9144,3.1741-0.0437,1.2119,0.21503,2.9072,0.21503,2.9072s1.5201-0.43356,2.4997-1.2547c0.97908-0.81947,1.3029-1.0436,1.1648-1.4658-0.0827-0.2571-0.48445-0.54237-0.48445-1.5578,0-1.7732,1.0644-1.902,1.0644-1.902z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m388.82,229.39s-1.6594-0.28039-2.489,0.26035c-0.83075,0.53751-1.534,1.3391-1.8328,2.419-0.29985,1.082-0.0859,1.3619-0.0859,1.3619s-0.1558-0.93965,0.13872-1.8398c0.34041-1.0306,1.1872-2.058,2.0136-2.3004,1.0079-0.29499,2.2553,0.0991,2.2553,0.0991z'/%3E %3Cpath d='m431.58,260.88s1.1994-0.50502,2.028-0.95914c0.83289-0.45684,2.6219-1.6228,2.6219-1.6228l0.5752,2.9846-2.3001,1.7722-2.004,0.02-1.2112-0.88391,0.29025-1.311z'/%3E %3Cpath d='m428.37,261.18s0.031,0.0379,1.4321,0.0693c1.3942,0.0363,1.5308-0.48607,1.7783-0.36591,0.24703,0.12071,0.64027,1.6109,0.64027,1.6109l-0.51061,0.93531-2.0136,1.141-1.6999-0.93531-0.13873-2.3497,0.5122-0.10555z'/%3E %3Cpath d='m444.32,260.22s-0.40015-0.66741-1.1978-1.3586c-0.795-0.69391-2.8412-2.478-2.8412-2.478l-0.0144,6.4668,2.9841-0.0731,1.4219-1.9995-0.35268-0.55751z'/%3E %3Cpath d='m428.37,261.18s-0.44337-0.65443-1.7079-0.51584c-1.2549,0.13694-2.5877,1.1637-2.7211,2.0363-0.13979,0.86767,0,3.3906,0.68082,3.875,0.67922,0.48337,1.5329,0.72694,2.8945,0.38053,1.3659-0.34642,8.3155-4.635,8.3155-4.635s-0.81739,0.17268-1.7714,0.38432c-0.95235,0.20622-1.8397-0.21164-1.8397-0.21164s-0.95396,1.0734-2.043,1.2471c-1.0943,0.17267-1.3963-0.51963-1.6044-1.0355-0.2033-0.51747-0.2033-1.5254-0.2033-1.5254z'/%3E %3Cpath d='m433.01,263.42s-1.0239,0.39079-1.4096,0.67226c-0.38201,0.27931-1.757,0.76375-1.757,0.76375l0.52502,2.1088,2.958,0.75562,1.8546-1.5318,0.0213-2.1218-2.1923-0.64683z'/%3E %3Cpath d='m446.77,261.93s-0.46792-0.43357-1.0238-1.0587c-0.54901-0.62462-1.232-0.75509-1.4251-0.64951-0.19208,0.11042-1.5942,1.9226-1.5942,1.9226l-0.10725,1.3651,1.638,0.88552,1.1503,0.21435,1.5132-0.99437-0.151-1.685z'/%3E %3Cpath d='m436.61,260.89s-1.3216,0.6019-1.9619,1.1443c-0.64025,0.54073-1.638,1.1443-1.638,1.3819,0,0.236,1.4918,1.7825,1.4918,1.7825l1.5116,0.12233,3.2787-2.2934-0.21449-2.0958-2.4677-0.0417z'/%3E %3Cpath d='m449.07,263.61s-0.25238-0.51801-0.76405-0.99435c-0.51222-0.47688-1.1487-0.73233-1.5361-0.69065-0.38043,0.0412-1.661,1.9459-1.661,1.9459l-0.159,0.53752,1.1828,1.3732,2.0969,0.50936,1.4464-1.4593-0.60612-1.2216z'/%3E %3Cpath stroke-linecap='round' stroke-linejoin='round' d='m443.6629 265.9017 1.4907 0.2571s-0.0443 0.3913 0.3852 0.7372c0.4242 0.3443 0.4679 0.0817 0.4679 0.0817s0.2129 1.43 1.7879 2.6382c0 0 1.8338 0.6068 2.7681 0.0877 0.9396-0.5196 0.8083 0.1597 0.8083 0.1597l2.6427-3.2694s0-0.6512-0.6387-0.6923c0 0 0.4663-2.0314-1.2368-2.4655-1.7005-0.4319-3.0669 0.1732-3.0669 0.1732s-1.3067 2.3974-2.0851 2.0742c-0.1819-0.0763-0.6274-0.315-0.938-0.6463-0.7203-0.7811-0.938-1.167-0.938-1.167s-0.5522 0.1727-1.1909-0.2604c-0.6419-0.4319-1.1909-1.4712-1.1909-1.4712s-0.9801-0.1727-1.32-0.5158c-0.3415-0.3464-0.6957-1.0284-0.6957-1.0284l-2.4378 1.7521s-0.0768 0.7735-1.4988 1.8106c-1.4187 1.0409-2.2692 1.0409-2.2692 1.0409s-0.3964 2.1289-1.9896 1.7803c-1.5894-0.3426-2.6688-2.1267-2.6688-2.1267s-1.1376-0.1732-1.8754 0.8027c-0.7395 0.9813-1.0826 1.3288-1.0826 2.307 0 0.9792 0.6274 2.3605 1.1381 2.8228 0.5138 0.4601 2.1059 1.7262 3.9755 0.747 1.877-0.9781 1.2512-2.5906 1.2512-2.5906s-0.0566 0.1158 1.0794-0.6344c1.1344-0.7508 2.3823-1.9015 3.2371-2.2458'/%3E %3Cpath d='m440.75,252.87,0.0128,4.1803s0.51008,3.7148-0.30198,4.8823c-0.80671,1.167-3.7482,0.90722-4.1707-0.0871-0.42577-0.9927-0.21395-4.2323-0.21395-4.2323l4.6739-4.7432z'/%3E %3Cpath stroke-linecap='round' stroke-linejoin='round' d='m437.45,265.54s-0.62583,1.1069,1.3083,1.2666c0.54901,0.0482,0.91506-0.14831,1.1621-0.43032,0.49941-0.57701,0.39004-1.0566,0.39004-1.0566s-0.17073,1.5448,1.5681,1.6022c1.9341,0.0693,1.7634-1.7857,1.7634-1.7857'/%3E %3Cpath fill='%23202220' stroke='none' d='m421.55,268.97s-1.0762-1.8187,0.20168-2.4785c1.2773-0.66308,1.9598,0.0298,2.7232,0.0579,0.76727,0.0298,0.51701-1.966,0.34787-2.3697-0.17234-0.40379-0.57518-1.2596-0.88407-1.4891-0.31373-0.23221-4.5379,0.18998-4.5059,3.0258,0.031,2.7237,2.1171,3.2536,2.1171,3.2536z'/%3E %3Cpath fill='%23202220' stroke='none' d='m428.17,275.74s-1.3622-1.9302-0.62371-3.0815c0.74109-1.154,1.3029-0.46172,1.6775-0.49257,0.36548-0.0265,0.53623-0.86281-0.088-2.1289-0.62745-1.2698-1.391-1.9048-1.8461-1.9622-0.45565-0.0573-3.0002,1.8138-2.4965,4.2063,0.60131,2.8921,3.3769,3.4588,3.3769,3.4588z'/%3E %3Cpath fill='%23202220' stroke='none' d='m452,273.41s4.5928,1.928,4.9114-2.7091c0.17074-2.4764-2.0446-4.1912-2.7531-4.1749-0.48394,0.009-0.85153,0.28526-1.6743,1.265-0.82541,0.98133-1.4512,1.6985-1.1114,2.0775,0.34146,0.3724,1.7031-0.40379,2.3012,1.0636,1.0239,2.5083-1.6737,2.478-1.6737,2.478z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m428.17,275.74s-3.5785-0.7897-3.5476-4.2869c0.0176-2.3334,2.6165-3.3716,2.6165-3.3716s-2.4037,1.2764-2.4458,3.3273c-0.0747,3.5584,3.3769,4.3314,3.3769,4.3314z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m421.6,268.97s-2.0649-0.45523-2.2895-3.4263c-0.22516-2.9694,4.675-2.8531,4.675-2.8531s-4.6974,0.22462-4.4509,3.0702c0.25345,2.937,2.0654,3.2092,2.0654,3.2092z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m452,273.41s0.92142,0.44547,1.9763,0.40433c1.05-0.0412,2.3145-0.31827,2.7531-2.0742,0.43858-1.7559,0.25663-2.589-0.90063-4.1386-0.81259-1.0782-1.5574-1.0582-1.5574-1.0582s0.7918,0.15642,1.4171,1.1329c0.62584,0.98133,1.5345,2.0774,0.91025,4.0494-0.62744,1.9735-2.5269,2.0146-3.2226,1.9568-0.69364-0.0574-1.376-0.27227-1.376-0.27227z'/%3E %3C/g%3E %3Cg id='body' fill='%234d2a15'%3E %3Cpath fill='%23904720' d='m397.2,176.12-0.86435-0.17862,0.62425-1.4452,2.417-0.88225,2.4116-0.0974,2.5397-0.10284,1.1685,0.80648,0,0,1.3019,3.0094-4.8126,2.8687-0.77898,0.2598-0.29878-1.1854-0.7363-1.9431z'/%3E %3Cpath fill='%23202020' d='m442.21,245.84,0,0-0.29879-7.2204-19.469,6.008,7.7098,7.215z'/%3E %3Cpath fill='%23d2a567' d='m406.16,233.27-1.638-1.2845s-1.1754-0.82924-1.8285-1.0306c-0.65149-0.20298-1.4902-0.0427-1.4902-0.0427l-0.26837,0.38378,0.2545,0.66794,1.7762,2.071s2.8961,1.4988,2.9671,1.5286c0.0704,0.0281,1.0484,1.009,1.0484,1.009l0.68349,0.28849-1.5046-3.5908z'/%3E %3Cpath fill='%23d2a567' d='m405.7,236.33,1.1098,0.14614,1.1098,1.272,0.68828,1.3586,0.90703,1.797,0.28812,1.0446-2.1715-0.4763,0,0-6.3066-1.954,0.54422-1.4993,1.1044-1.0122,0.91236-0.40053,1.2859-0.19486z'/%3E %3Cpath fill='%23d2a567' d='m409.8,241.52,0,0,1.0404-0.0866,0.70429-0.60079-0.3308-2.3599,0.38415-7.5614-5.1221-6.0567-1.0458,3.4911,1.5046,6.1216,1.1098,3.6697z'/%3E %3Cpath fill='%23ab6d29' d='m406.13,227.69s-0.33881,0.63166,0.0854,2.6182c0.42684,1.9865,1.1648,6.4272,2.9255,9.453,1.7602,3.0204-1.7025-2.3908-1.7025-2.3908s-2.7264-6.1387-2.3012-10.777c0.42685-4.6383,0.99297,1.0966,0.99297,1.0966z'/%3E %3Cpath fill='%23ab6d29' d='m409.85,231.52s-1.1071,1.4431-1.2779,2.5077c-0.17073,1.0636,0.0854,2.8802,0.0854,2.8802s-0.17073-1.3797,0.96518-1.7018c1.136-0.3134,0.99297,3.1167,1.05,3.4295,0.056,0.31827,0.65464-6.135,0.65464-6.135l-1.4774-0.98078z'/%3E %3Cpath fill='%23ab6d29' d='m410.42,244.19l-5.7674-1.3234c-2.9799-1.3272-4.5576-2.3659-4.5-3.0832,0.0571-0.72047,5.296,0.17267,6.0623,0.34643,0.76566,0.17267,3.1111,1.3516,3.1111,1.3516h1.3472l2.4453-1.0798,0.33828,2.6068-3.037,1.1816z'/%3E %3Cpath fill='%23ab6d29' d='m400.79,243.1s1.4214,1.0073,0.73949,1.4393c-0.68188,0.43248-2.5007,0.48986-3.0679,0.34696-0.56825-0.14561,5.5654,1.3516,5.5654,1.3516s1.1919-1.0089,1.1076-1.0669c-0.0848-0.059-4.3447-2.0709-4.3447-2.0709z'/%3E %3Cpath fill='%23d2a567' d='m399.27,241.58c0.21394-0.34641,0.38468,0.80761,2.3711,1.0669,1.9896,0.25766,2.8972-0.34642,2.8972-0.34642l0.88033,0.57701,1.0506,0.23058-0.96572,1.4393-3.6351-1.0685-1.9587-1.0918-0.63973-0.80702z'/%3E %3Cpath fill='%23ab6d29' d='m412.22,238.97,1.0244,1.4668,0.63492-3.1934-0.0427-3.3287-2.0862-1.3802,0,0z'/%3E %3Cpath d='m406.47,233.58-1.7041-2.8542-2.2153-4.0596,1.3627-2.3345,1.6626,2.4173s-0.46953,1.6439-0.17074,3.199c0.29826,1.5578,1.065,3.632,1.065,3.632z'/%3E %3Cpath fill='%23d2a567' d='m394.8,243.95s0.73788-1.2271,2.4714-1.3667c1.7319-0.14831,3.1228,0.23113,3.1228,0.23113l3.5204,1.8382,0.71123,1.1562-6.6447-0.89149-3.181-0.96727z'/%3E %3Cpath fill='%238f4620' d='m412.09,232.2s0.12698,3.9735,0.2529,5.2271c0.1286,1.2525,0.89796,2.4617,0.77043,2.9808-0.12913,0.51963-0.38522,0.77839-1.2384,1.0798-0.85154,0.30203-2.5541,0-2.5541,0s1.6599-0.21706,1.7452-0.56023c0.0843-0.34642-0.51061-1.8582-0.59758-3.2417-0.0838-1.383,0.087-2.8953-0.38202-2.8953-0.469,0-0.97907,0.60516-1.0655,0.77838-0.0848,0.17321,0.46686-4.9267,1.0223-5.489,0.5554-0.55915,2.0467,2.1202,2.0467,2.1202z'/%3E %3Cpath fill='%23ab6d29' d='m399.94,242.64s-0.67922-0.63492-0.6664-1.0669c0.0144-0.4341,0.79661,2.0861,4.4434,1.9459,3.6495-0.14398,3.4366-0.20622,3.4366-0.20622h1.7041s-0.38256,1.5897-0.6819,1.731c-0.29772,0.14343-2.8396,1.8582-2.8817,1.9048l-0.91134,0.49961,0.0731-0.25766-0.17075,0.013-0.29772-2.8082-3.1512-1.2103-0.89636-0.54506z'/%3E %3Cpath fill='%238f4620' d='m406.47,233.58s-4.2182-4.366-5.622-7.2597c-1.407-2.8985-0.55436-6.8723-0.55436-6.8723l3.9627,5.1854s-0.51168,0.99436-0.34308,2.635c0.17127,1.6439,2.5568,6.3113,2.5568,6.3113z'/%3E %3Cpath fill='%23ab6d29' d='m403.77,249.48c-0.14085-0.30203-0.29986-1.2617,0.51114-2.2755,2.5056-3.1259,8.8461-5.3715,8.8461-5.3715l0.007,3.8231-8.136,3.9113-1.2288-0.0871z'/%3E %3Cpath fill='%238f4620' d='m404.25,246.59c0.35375-0.25387,1.7725-1.3056,1.822-1.7592,0.0576-0.51585-0.96464-0.60352-2.8091-0.97812-1.8471-0.37565-3.3507-1.2081-3.3507-1.2081s2.2713,1.7559,3.1517,2.1023c0.87927,0.34804,0.79661,0.6923,0.68189,0.92339-0.11363,0.23059,0.45299,0.95482,0.50421,0.91966z'/%3E %3Cpath fill='%238f4620' d='m415.14,247.48s-1.1728-1.751-1.5489-2.8233c-0.37242-1.0712-0.39109-2.7979-0.46152-2.8174-0.0667-0.02-0.78272,0.57049-1.3083,0.81408-0.52822,0.23926-2.4037,0.84603-2.5056,0.91693-0.10298,0.0677,2.5883-0.0563,2.5738,0.87687-0.0182,0.93643-3.8698,1.3343-3.8858,1.4019-0.0166,0.0671,3.101-0.68905,2.9132,0.0671-0.18834,0.76214-1.567,0.83305-3.2365,1.5226-1.67,0.69232-2.4021,1.042-3.0204,1.4014-0.61789,0.35455-0.91507,0.62788-0.91507,0.62788s0.7443,0.42058,1.9293,0.37781c1.1796-0.0449,3.7988-0.69231,3.7988-0.69231l5.0288-1.9129,0.63813,0.23924z'/%3E %3Cpath fill='%23ab6d29' d='m415.14,247.48s-1.4032-0.48986-2.401-6.3471c-1.0004-5.8518-0.70802-7.4296-0.70802-7.4296l2.3695,1.6536,2.123,3.8599-1.3835,8.2632z'/%3E %3Cpath fill='%238f4620' d='m415.9,237.74s-1.1066,3.2824-1.1066,5.1871c0,1.8977-0.19528,3.1919,0.34841,4.5446,0.54371,1.3467,2.4069,3.0236,2.4069,3.0236l0.84993-0.88877,0.38256-2.6545,0.21448-4.4104-3.0956-4.8017z'/%3E %3Cpath fill='%23202020' d='m419.23,242.2s0.53731,8.2658-1.5553,8.4929c-1.0009,0.1088-2.5141-3.1129-2.5333-3.2179-0.0219-0.1088,1.8231,2.9987,2.5114,2.7183,1.3216-0.53913,0.9156-8.5971,0.9156-8.5971l0.66159,0.6041z'/%3E %3Cpath fill='%23202020' d='m415.14,247.48s-0.35428-0.15372-0.92945-1.0918c-0.57515-0.93804-0.0747,0.82925-4.4807,2.387-4.4092,1.5551-5.9848,0.69232-5.9848,0.69232s1.4699,1.1443,5.9191-0.15481c4.4525-1.2942,4.0475-1.5762,4.6419-1.7045,0.60024-0.12828,0.83396-0.12828,0.83396-0.12828z'/%3E %3Cpath fill='%23ab6d29' d='m406.94,236.95s0.69465,0.59379,1.4897,2.2046c0.79554,1.6108,1.3627,2.7389,1.3627,2.7389l0.19901-0.2046s-0.54051-1.5529-1.2773-2.7649c-0.73788-1.2119-2.8694-4.1484-2.8694-4.1484l1.0954,2.1743z'/%3E %3Cpath fill='%238f4620' d='m404.26,247.21s0.45459-1.5465,0-1.8339c-0.45564-0.28688-0.88247,0.0249-3.8901-0.34642-3.0108-0.37943-5.5675-1.0815-5.5675-1.0815s2.044,1.2541,4.0022,1.7722c1.9619,0.51746,4.516,1.0945,4.516,1.0945l0.68189,0.1153,0.2577,0.27984z'/%3E %3Cpath fill='%23202020' d='m404.26,247.21s0.0624-0.36483-0.27798-0.73559c-0.3404-0.36755-0.95877,0.17483-4.6019-0.84278-3.641-1.0106-4.5779-1.6829-4.5779-1.6829s1.2986,1.1459,4.5149,1.967c3.2168,0.8206,4.9428,1.2942,4.9428,1.2942z'/%3E %3Cpath fill='%23ab6d29' d='m405.9,236.32s-2.7568,0.14993-3.6431,0.86062c-0.88194,0.71395-2.1001,2.6041-2.1001,2.6041l1.7917,0.20785s-0.22301-1.6639,0.63011-2.4964c0.85101-0.83139,2.1406-0.90721,3.3214-1.1762z'/%3E %3Cpath fill='%238f4620' d='m400.68,231.08s1.1076,1.4674,2.2575,1.9865c1.1508,0.51908,2.3006,0.95155,2.8556,1.5118,0.55168,0.56077,1.1498,2.3757,1.1498,2.3757s-3.9627-1.7689-4.7278-2.6366c-0.76829-0.86334-1.535-3.2374-1.535-3.2374z'/%3E %3Cpath fill='%238f4620' d='m404.52,231.99s-0.36068-0.59217-1.4475-1.0902c-1.0858-0.49635-1.885-0.4184-2.1934-0.19431-0.30946,0.22733-0.20276,0.36969-0.20276,0.36969l1.4486,2.183,0.80884-0.19594s-2.1529-1.357-1.6498-1.7825c1.0532-0.89909,3.236,0.71015,3.236,0.71015z'/%3E %3Cpath fill='%23202020' d='m415.2,227,22.174-11.453,0,0,10.495,14.609-19.165,5.1366-10.143,0.86601-4.9407-3.5831z'/%3E %3Cpath d='m444.93,233.26,27.643,23.94,0,0-3.0626,2.1055-6.4773-1.8457-13.461-13.304-4.9833-5.0175z'/%3E %3Cpath d='m480.33,252.46s-6.8654-5.4142-15.788-12.038c-8.9198-6.6287-19.949-14.982-19.949-14.982l0.51009,7.1443,22.818,20.972,7.5263,3.6287,3.8063-1.1508,1.931-2.0168-0.85474-1.5584z'/%3E %3Cpath fill='%23803f1d' d='m444.85,235.53s7.9623,8.9861,14.016,13.568c6.0463,4.5787,11.841,9.5914,13.031,8.8979,1.193-0.69232,0.76727-1.4658,0.76727-1.4658l-27.984-22.818,0.16914,1.8171z'/%3E %3Cpath d='m464.4,258.5-2.8118,2.1867,0,0-3.2333-1.3207-16.999-17.374,0.85368-3.1988,2.3796,0.34641z'/%3E %3Cpath fill='%23202020' d='m480.33,252.46s-2.0835,4.9138-6.5143,3.7646c-4.4306-1.1546-28.826-24.332-28.826-24.332l-0.0566,2.419s24.722,22.645,29.494,23.567c4.7715,0.9234,8.6794-3.2185,8.1782-3.6866-0.33452-0.3134-2.2756-1.7316-2.2756-1.7316z'/%3E %3Cpath fill='%23803f1d' d='m442.12,239.16s7.8811,10.111,12.057,13.827c4.1772,3.7181,7.754,6.6527,9.4579,6.3113,1.7015-0.34642-1.0223-2.2468-1.0223-2.2468l-11.929-11.756-6.0901-6.1355c-0.001,0-2.385-0.94996-2.473,0z'/%3E %3Cpath fill='%23202020' d='m444.08,239.16s20.011,20.396,21.595,20.859c3.3544,0.97972,8.1248-2.4796,8.1248-2.4796l-1.7618-1.0355-0.22783,0.63167s-0.85314,2.0758-5.1685,1.1524c-4.3169-0.918-21.879-19.819-21.879-19.819l-0.68296,0.69064z'/%3E %3Cpath d='m451.62,258.68-7.2829-8.3841-1.6167-2.7658-0.43217-3.5452,14.529,14.609,0,0-2.0435,1.3802-1.7927-0.6008z'/%3E %3Cpath fill='%23202020' d='m464.78,258.97s-1.7623,2.5938-4.151,2.0742c-2.3828-0.51585-3.745-2.2452-3.745-2.2452l-13.93-13.64-0.34-2.08s15.281,16.17,18.015,16.884c1.9907,0.51962,3.4718-1.9042,3.4718-1.9042l0.67922,0.9234z'/%3E %3Cpath fill='%23202020' d='m457.05,258.51s-0.68242,2.0168-2.7238,1.731c-2.0483-0.2885-2.672-1.0961-2.672-1.0961l-8.5324-10.14-0.16914-2.7054s8.8707,12.269,10.919,12.962c2.0445,0.69066,2.5552-1.3852,2.5552-1.3852l0.62369,0.63327z'/%3E %3Cpath fill='%23b07229' d='m447.93,231.92s8.2642,7.0866,8.9471,7.4328c0.68082,0.34803,3.5758,0.43409,3.745,0.8628,0.17074,0.43519-1.869,0-2.0413,0.43519-0.16861,0.43032,4.174,3.9773,4.8548,4.0612,0.68081,0.0872,4.1755,0.0872,4.0913,0.51746-0.0848,0.43574-2.386,0-2.4709,0.51963-0.0843,0.51747,3.7514,3.5448,4.429,3.6309,0.68456,0.0871,5.1114,0.0871,5.1114,0.51585,0,0.4368-3.5801-0.0839-3.491,0.6923,0.0827,0.77839,6.0495,4.4932,5.792,5.0144-0.25663,0.51746-7.1576-4.668-7.326-4.4093-0.17232,0.25874-0.4263,1.9026-0.85528,2.1614-0.42255,0.25928,0-2.1614-0.34145-3.1968-0.33986-1.0387-4.3431-4.0629-4.7689-3.7165-0.42256,0.3448-0.0827,2.1597-0.51006,2.1597-0.42631,0,0.0875-2.2468-0.34149-3.0258-0.42629-0.77673-4.174-3.8896-4.684-3.8896-0.51222,0-0.17076,1.6455-0.51222,1.9031-0.34307,0.25874-0.25503-1.9031-0.76727-2.5938-0.50794-0.68906-9.2003-8.5538-8.8605-9.0753z'/%3E %3Cpath d='m433.76,254.86s0.0651,3.1308-1.3424,3.5876c-1.4043,0.45522-4.0662-5.7513-4.0662-5.7513l-0.61782-5.7866,4.1329,3.8452,1.8936,4.1051z'/%3E %3Cpath d='m444.84,253.27s0.0581-0.91693-0.0491-1.6704c-0.10404-0.75562-0.34574-1.8994-0.34574-1.8994l-0.26998-3.2239-0.76568-2.1597-0.61943-1.3618-0.89583,0.0639-2.1726,1.5405-0.74483,2.092,1.1492,3.9129,1.0645,3.5649,1.6167,0.51909,2.0329-1.3781z'/%3E %3Cpath d='m441.99,258.74c0.48766-0.14668-0.45353-4.4353-0.45353-4.4353l-2.5536-6.3402-0.68242-2.2452-2.0723-0.78159-1.3637,1.56,0.31212,2.5062s1.9864,4.1749,2.9548,5.6477c0.96571,1.4663,3.0103,4.3492,3.8586,4.0883z'/%3E %3Cpath fill='%23202020' d='m439.7,245.29c0.74163,0.51585,1.5911,2.2176,1.7884,3.3684,0,0,1.7063,4.6648,1.4784,5.1281-0.22784,0.46225-1.2517,0.51963-1.2517,0.51963s2.2756,2.3611,2.958,2.0742c0.67921-0.28852,0.39483-2.5938,0.16647-3.1129-0.22622-0.51962-0.96572-0.17158-1.2469-0.69064-0.28438-0.52126-1.1397-3.6293-1.1946-5.4756-0.0565-1.8398-0.11363-3.1096,0.11419-3.5719,0.22729-0.46009,1.9325,3.8604,1.9325,6.1686l0.73629,0.86388s-0.45564-3.1719-0.73629-4.15c-0.28438-0.97812-0.90865-2.6512-0.90865-2.996,0-0.34642,0.34147-1.1524,0.34147-1.9589,0-0.80595-0.0566-1.3234-0.0566-1.3234s0.90492,0.62952,1.248,0.57646c0.33987-0.059,0.85047-0.51908,1.0762-2.5386,0.22942-2.0136-0.22569-7.8784-0.22569-7.8784l-8.8589,11.684,2.6394,3.3137z'/%3E %3Cpath fill='%23202020' d='m439.7,244.28s-0.34147,3.1411,0.82434,6.3658c1.1653,3.2288,1.4742,3.3457,1.7031,3.8052,0.22568,0.45901,0.20328,3.8604-0.22942,4.2907,0,0-2.2671-5.7888-3.0327-8.6414-0.76887-2.8531-0.96571-3.9492-1.3643-4.1803-0.39804-0.23058-1.0548-0.28849-1.0548-0.28849l3.1538-1.3516z'/%3E %3Cpath d='m438.86,261c0.25396-0.053,0.0976-1.3337,0.0976-1.3337l-0.36708-3.0242-3.1106-6.3861-3.4099-3.0669-1.7895-2.7649-0.25397,5.2731s2.4703,5.2694,4.0892,6.7826c1.6178,1.5107,4.2929,4.6333,4.7443,4.5197z'/%3E %3Cpath fill='%23202020' d='m426.13,246.61s0.53463,1.4144,0.53463,2.3394v1.7857s1.2469,2.5348,2.3844,4.5543c1.1381,2.0114,2.2153,4.0894,3.1789,3.6287,0.96732-0.46172,1.3099-1.9605,1.3659-2.1348,0.0555-0.16943-1.0794,1.7294-1.6503,1.4409-0.56556-0.28687-3.1186-8.5239-3.0631-8.6992,0.0555-0.1732-0.68243-0.518-1.2517-1.0945-0.56932-0.57753-1.4988-1.8209-1.4988-1.8209z'/%3E %3Cpath fill='%23202020' d='m435.41,253.79s-1.765-2.8769-2.3322-4.1468c-0.56718-1.2693-1.5329-2.2501-1.8168-2.2501-0.28438,0-0.65357-2.5792-0.65357-2.5792s0.93745,1.7164,2.1289,2.2902c1.1946,0.57648,1.9288,1.0387,2.5029,0.80762,0,0,0.33934,1.3272,0.33934,2.6528s-0.1686,3.2255-0.1686,3.2255z'/%3E %3Cpath fill='%235c3a1d' d='m429.73,249.55s0.5949,1.8122,1.7586,3.5416c1.1642,1.7294,3.0754,3.8057,3.0754,3.8057s-2.1097-2.0763-3.2146-3.6899c-1.1082-1.6141-1.8466-3.7197-1.8466-3.7197l0.22729,0.0622z'/%3E %3Cpath fill='%23202020' d='m435.8,247.4s0.56236-1.5676,1.05-1.6439c0.48605-0.0725,1.5116-0.38052,1.5116-0.38052s-0.87766-0.2176-1.5815-1.0387c-0.73789-0.872-0.90865-0.80816-1.7111-1.7413,0,0,0.45512,1.7413,0.59277,2.5619,0.13819,0.82166,0.13819,2.2425,0.13819,2.2425z'/%3E %3Cpath fill='%23202020' d='m435.24,247.91s2.5269,5.4147,3.1773,7.2298c0.64988,1.8166,0.53944,4.5278,0.53944,4.5278s-0.31212-1.9307-0.87873-3.5173c-0.57037-1.5844-2.8705-5.9913-3.0652-6.5096-0.20381-0.5207,0.22728-1.731,0.22728-1.731z'/%3E %3Cpath d='m438.68,244.39,0.59758-7.9559-0.59758-2.8082-3.5806-7.9495s-0.17073,1.1675-1.0645,1.1215c-0.89423-0.0449-3.2797-1.2948-4.0929-2.3779,0,0,0.47166,1.8598,0.30252,3.6309-0.17233,1.7738-0.46845,2.7221-0.46845,2.7221l6.8996,12.965,2.0045,0.65169z'/%3E %3Cpath fill='%238b441f' d='m424.96,249.61s1.0778,1.2991,1.7031,1.1258c0.62264-0.17104,0.39483-2.6523-0.39803-4.0326-0.7966-1.3819-9.2035-12.619-10.452-13.311-1.248-0.68905,9.1474,16.218,9.1474,16.218z'/%3E %3Cpath fill='%238b441f' stroke='%235c3a1d' stroke-width='0.07' d='m430.7,244.97c0.1686,0.51909,0.77363,4.1018-0.67922,4.4369-2.0056,0.4617-11.243-12.297-12.671-14.048,0,0-5.7984-3.6255-5.9111-4.5489-0.11524-0.9234,6.2515,1.2531,6.2515,1.2531l12.382,11.84s0.45459,0.54723,0.62744,1.0669z'/%3E %3Cpath fill='%23202020' d='m424.96,249.61s-1.0223-1.8138-1.1135-3.108c-0.0811-1.2964-0.50687-1.9887-0.59116-2.4223-0.0859-0.43031-6.8157-10.194-7.498-10.804-0.67922-0.60192-2.9799-1.8994-2.9799-1.8994s0.2657,1.5551,0.2657,2.2474c0,0.69066,0.0758,0.88552,0.0758,0.88552s2.1299,4.0444,5.1952,7.5862c3.0652,3.54,6.6458,7.5151,6.6458,7.5151z'/%3E %3Cpath d='m435.24,247.91c0.90651-0.51908,0.50848-3.6287,0.1702-4.6101-0.34467-0.97971-5.8507-12.44-5.8507-12.44l-1.6514,0.63006-3.1208-2.4482-1.757-1.901s0.61895,2.7389,0.56398,4.0645c-0.0581,1.324-0.11365,2.1289-0.11365,2.1289l4.3714,7.6636,7.388,6.9129z'/%3E %3Cpath d='m441.43,241,1.3099-1.7278-0.68242-5.7049-3.634-12.442s-0.91026,0.22898-1.8205-0.34641c-0.90652-0.57861-1.8445-1.6736-1.8445-1.6736l0.88247,7.4328,3.7509,10.429,0.22568,3.1134,1.8125,0.91967z'/%3E %3Cpath fill='%23202020' d='m430.07,243.91s-3.6602-3.9773-4.8564-5.9645c-1.1946-1.9881-2.2137-3.8896-2.2137-3.8896s-1.0207,0.43356-2.3012-0.0839c-1.2784-0.52126-2.9783-2.3345-2.9783-2.3345s-1.0228,1.9865,4.2588,7.3452c6.0463,6.1344,8.0906,4.9273,8.0906,4.9273z'/%3E %3Cpath fill='%238b441f' d='m438.89,245.25c1.5409-0.61867,1.4923-7.0887,0.0454-11.453-1.4528-4.366-3.8367-8.1221-3.8367-8.1221s2.9841,6.9995,3.6212,9.8533c0.63813,2.8526,0,4.8802-0.51222,4.7075-0.51059-0.17321-0.51059-1.6818-1.7031-4.4521-1.1893-2.7621-1.9992-3.4544-1.9992-3.4544s4.2145,11.536,3.0199,11.321c-1.1893-0.21598-7.07-13.007-7.3238-13.354-0.25984-0.34643-0.42576,0.47469-0.42576,0.47469s5.2384,16.032,9.1148,14.479z'/%3E %3Cpath d='m442.31,214.09,2.5877,5.4954,0.81739,5.8101,0.20328,4.8986s0.1686,9.6668-1.0207,9.8976c-1.193,0.23112-1.7618-0.9234-1.8167-1.1546-0.0587-0.23059-2.2169-10.89-2.2169-10.89l-2.2692-11.12,0.80458-0.77839,0.27157-1.6406,1.7586-0.11692,0.88033-0.40163z'/%3E %3Cpath fill='%238b441f' d='m435.24,247.91c1.0287-0.14182,0-2.7632,0-2.7632s-0.85367,1.2666-1.5361,0.40379c-0.68242-0.86387-1.7639-4.0645-1.7639-4.0645l-0.68081-1.9286s-0.73789,2.1305-1.6999,2.1305c-0.96839,0-5.9651-8.4699-5.9651-8.4699l-0.59811,0.83572c0.00036-0.00036,7.0428,14.578,12.244,13.856z'/%3E %3Cpath fill='%23202020' d='m431.94,241.49s0.85367-2.0742,0.51221-3.9735c-0.34147-1.9042-2.8929-6.6527-2.8929-6.6527s-0.76882,0.1732-1.7895-0.17483c-1.0223-0.34642-2.982-1.6439-2.982-1.6439s1.3622,3.5448,2.8929,6.1387c1.5377,2.5906,4.2593,6.3065,4.2593,6.3065z'/%3E %3Cpath fill='%23202020' d='m436.03,238.55s-0.63867-4.4981-2.68-8.6462c-2.0478-4.1484-3.4131-5.489-3.4131-5.489s0.17233,0.90988,0.13019,2.5949c-0.0406,1.6834,0,2.0298,0,2.0298s1.8738,0.69231,3.2829,3.1985c1.4027,2.5067,2.68,6.3124,2.68,6.3124z'/%3E %3Cpath fill='%23202020' d='m441.6,230.86s-0.28438-4.8412-1.05-7.6108c-0.76727-2.7622-1.575-6.4353-1.575-6.4353s0.096-0.3724,0.42258-0.56402c0.19154-0.11853,0.47005-0.17483,0.85634-0.0427,1.0207,0.3448,1.4464,2.8953,1.4464,2.8953s-0.12645-3.9308-0.21395-4.1024c-0.0811-0.17483-0.34147-0.65116-0.34147-0.65116s-0.33827,0.17321-0.80991,0.13207c-0.46793-0.046-1.0207-0.13207-1.0207-0.13207s0.32066,1.2087-0.19155,1.7727c-0.37188,0.41028-0.72773-0.36809-0.93425-0.47363-0.0795-0.0427-0.19367,0.55916-0.19367,0.55916s0.38202,1.3819,0.46846,2.5938c0.0843,1.2119-0.12646,2.2046-0.12646,2.2046s0.75071,2.8921,1.5585,4.668c0.81418,1.7684,1.7047,5.1866,1.7047,5.1866z'/%3E %3Cpath fill='%23202020' d='m445.92,230.3s0.85154-6.9568-0.72191-11.407c-1.5799-4.4537-2.8998-5.6188-2.8998-5.6188l-0.72191,0.86548s2.3711,3.7792,3.0652,7.3008c0.72879,3.6721,1.2784,8.8589,1.2784,8.8589z'/%3E %3Cpath fill='%23202020' d='m438.93,233.8s-0.7715-5.4425-1.7516-8.9428c-0.97854-3.5037-1.2549-4.7552-1.2549-4.7552l-1.4886-1.3819s0.87451,3.7148,0.78646,4.7979c-0.0843,1.0766-0.17181,1.8138-0.17181,1.8138s0.72619,1.8582,1.7063,3.4095c0.97854,1.5589,2.1742,5.0588,2.1742,5.0588z'/%3E %3Cpath fill='%23904720' d='m442.57,242.44c1.3894,0.0412,0.1702-7.832-0.39801-9.8485-0.56878-2.0163-3.8101-11.484-3.8101-11.484s3.8976,13.463,3.5806,14.136c-0.45993,0.99922-1.9832-4.091-2.267-4.0331-0.28278,0.0541,2.8945,9.1026,1.7548,9.2185-1.1311,0.11528-1.6983-1.9048-1.6983-1.9048l0.11045,1.9622c0,0.00053,0.73949,1.9015,2.7275,1.954z'/%3E %3Cpath fill='%23904720' d='m444.27,238.46c0.9476,0-0.26624-7.4296-0.9444-10.716-0.67922-3.2861-2.5776-9.8533-2.5776-9.8533s1.9272,4.5527,3.0103,9.7956c1.0762,5.2402,1.8104,11.984,0.79286,12.1-1.0207,0.11529-1.5345-0.98132-1.5345-0.98132l-0.1686-1.2119c0,0.00036,0.45457,0.86767,1.4219,0.86767z'/%3E %3Cpath fill='%23312317' d='m431.48,247.19c0.14619,0.52938,0.11737,3.0788-1.2346,2.8959-1.3526-0.18349-3.8245-2.4655-4.3329-3.9654,0,0,2.9382,3.2499,3.9488,3.2298,1.0116-0.0227,1.0079-3.3548,0.83876-4.2193-0.17233-0.86228,0.78005,2.059,0.78005,2.059z'/%3E %3Cpath fill='%23d2a567' d='m438.55,211.8s1.7484,1.1194,3.1528,0.29987c1.4064-0.82113,2.3439-2.8082,2.3012-3.8896-0.0454-1.0782-0.0859-2.0309-0.93959-3.1541-0.84993-1.1226,1.3622,0.94942,1.3227,3.0258-0.0422,2.0758,0.12699,5.6584-3.1965,6.4385-3.3235,0.77839-1.8744-0.17321-1.8744-0.17321l-0.7662-2.5473z'/%3E %3Cpath fill='%238f4620' d='m435.92,205.45s2.0968,3.4361,2.9041,6.5261c0.80991,3.0896,0.65999,4.2772,0.1494,4.34-0.51167,0.0677-0.70321-0.36428-0.83075-1.141-0.12645-0.78212-2.2228-9.725-2.2228-9.725z'/%3E %3Cpath fill='%231e2121' d='m399.14,209.67,0,0,13.883,20.14,17.383-19.621-10.991-11.323z'/%3E %3Cpath d='m416.69,197.31,0,0-0.80566,3.1555,1.702,5.3585,2.8972,2.9823,3.3614,2.2408,0.76831-2.506,0.81099-2.9336,0.84834-0.30311,2.1289,0.82271,1.4086-2.0297,2.2569-4.0648-0.46952-1.5751-0.53888-1.1204-3.5161-6.127-1.1845,2.3166-1.1044,0.67116-2.0488-1.1637-2.4703,3.2367-3.0199-1.4019z'/%3E %3Cpath fill='%235c3818' d='m423.85,211.06s0.60185-0.42869,0.85527-2.0282c0.25824-1.5995,0.29932-6.4828-0.12646-8.4288-0.42576-1.9421-1.7063-5.7887-1.9603-5.4874-0.25396,0.30366,2.004,4.2361,1.6626,9.0326-0.33988,4.7963-0.17073,6.1371-1.1946,6.6116-1.0244,0.47362,0.76353,0.30041,0.76353,0.30041z'/%3E %3Cpath fill='%235c3818' d='m424.66,202.98s2.3001,3.2829,3.4099,2.1153c1.105-1.1654,0.55274-5.3586-0.16861-6.9995-0.72832-1.6439-1.4923-4.0201-1.4923-4.0201l0.68242-0.69066s0.76407,2.7649,1.1898,4.4948c0.42579,1.7278,1.7031,6.8259,0.16861,7.7358-1.5308,0.90662-3.7477-1.8598-3.7477-1.8598l-0.0422-0.77619z'/%3E %3Cpath fill='%238f4620' d='m417.23,205.24s0.76674-1.1226,1.8178-1.2384c1.0506-0.11529,1.2528,0.3448,1.2528,0.3448l0.93478,2.7075,1.5622,2.7963,1.3894,1.3802-0.82274,0.77839-1.105,0.20298s-3.3-1.7278-3.3528-1.8436c-0.056-0.1153-0.91025-1.2103-0.91025-1.2103l-0.76621-3.9178z'/%3E %3Cpath fill='%23d2a567' d='m422.69,233.84c-1.082,0.56241-3.5748-0.68093-4.9796-1.9194-1.4064-1.2368-8.8167-8.8012-8.8167-8.8012l-1.0367-4.1928,2.8673,0.77947,5.0277-2.1597,0.93852-1.7722,6.0463-3.1546,3.3694-1.8138,7.3233-0.13045,1.7468-3.5876s2.457,4.2491,2.8668,5.9934c0.41298,1.7429,0.32654,7.1032-0.31158,7.4457-0.63707,0.34642-3.0231-1.6011-3.3646-1.7278-0.34147-0.12829,1.7895,7.5204,0,7.8202-1.7911,0.30205-4.7715-2.8509-4.7715-2.8509s1.1925,6.8258-0.21129,6.8707c-1.4075,0.0444-5.0415-1.7115-6.5886-3.3852-0.00037,0,1.7282,5.6327-0.10512,6.5859z'/%3E %3Cpath fill='%238f4620' d='m421.25,224.98s1.1802,1.7316,1.5473,2.2755c0.36869,0.54564-0.0635,3.7824-0.28598,4.3795-0.45565,1.2401-2.1294-1.4674-3.0397-3.8599,0,0-2.6656-4.4369-2.8369-5.0123-0.1702-0.57753,4.6152,2.2171,4.6152,2.2171z'/%3E %3Cpath fill='%238f4620' d='m435.52,208.07s2.5845,10.66,1.336,11.032c-1.2517,0.37402-4.8025-3.3716-5.1973-3.9178-0.40016-0.54725-5.3408-8.4112-5.3408-8.4112l-1.05-1.0669,0.31213-0.54725,2.1001,0.80436,7.84,2.1062z'/%3E %3Cpath fill='%238f4620' d='m417.23,228.55c-0.5752,0.37078-1.6748-1.3819-2.186-1.8436-0.51167-0.45847-2.2436-2.5938-3.9477-4.3216-1.7015-1.7262-2.9521-2.996-2.9521-3.3424,0-0.34642-1.0228-1.4393-1.0228-1.4393l0.90919-1.1492,1.193-0.17483s7.0433,5.6156,7.5258,6.5063c0.48074,0.89909,0.79554,5.5617,0.48074,5.7647z'/%3E %3Cpath fill='%238f4620' d='m427.83,228.64c-0.33187,0.26197-4.9978-3.1145-6.9594-5.9079-1.9603-2.7946-4.0038-5.2434-4.4877-6.5411-0.48287-1.2964-0.88087-2.4747-0.88087-2.4747l1.4214,0.3134c0.00037,0,11.444,14.175,10.907,14.61z'/%3E %3Cpath fill='%238f4620' d='m429.5,223.71c-0.25985,0.31828-2.2996-1.2087-3.5508-2.8525-1.2501-1.6406-0.5933-3.685-0.5933-3.685s4.398,6.2237,4.1441,6.5378z'/%3E %3Cpath fill='%238f4620' d='m432.11,223.08c-0.63385,0.3015-3.3091-2.9251-5.5355-6.5672-1.6481-2.6929-2.0574-3.0966-2.4122-3.311-0.61147-0.3724-1.7639-0.54723-1.7639-0.54723l-0.22889-0.34643,1.1941-0.29013,0.88246-1.0338,1.3894-1.7889,5.5403,11.18c0.001,0,1.36,2.5061,0.93425,2.7043z'/%3E %3Cpath fill='%23ab6d29' d='m417.72,231.92c0.0443,0.40596-0.0224,0.81627-1.5329,0.66469-1.5105-0.15155-9.4135-4.366-12.972-10.177-3.555-5.8139-4.0245-6.5902-4.0245-6.5902l1.5772-1.7938,12.545,14.302,4.4077,3.5941z'/%3E %3Cpath fill='%238f4620' d='m417.72,231.92c0.16968,0.66469-0.62316,0.83738-1.4187,0.63493-0.79661-0.20135-3.9493-1.3256-8.9754-6.9151-5.0239-5.5884-6.9845-9.5914-6.9845-9.6801,0-0.0839-0.2545-2.3908-0.2545-2.3908l1.4753-0.63332,8.6345,13.164,7.5237,5.8203z'/%3E %3Cpath d='m426.11,226.27s-2.6021-1.8598-4.2631-3.8469c-1.6578-1.9887-5.0271-6.61-4.9417-7.5205,0.0864-0.90662,1.4918-0.90662,1.4918-0.90662l-0.0843-2.3297,0.42578-0.78325,2.4292,0.99436,3.0652,3.7641,1.1242,1.5254s1.9864,4.7811,1.6012,5.2136c-0.38203,0.43356-3.1939-2.6794-3.5353-2.2902-0.34148,0.39081,3.1986,5.8336,2.687,6.1799z'/%3E %3Cpath d='m421.25,224.98s0.85207,1.2964,0.46473,2.2046c-0.37723,0.90502-0.72031,1.3819-1.9998-0.518-1.2789-1.9042-2.823-4.0331-2.966-3.8794-0.14139,0.15967,0.15421,2.9267-0.48286,2.9267-0.64187,0-2.6421-2.3757-3.9211-4.2788-1.2768-1.901-3.2349-5.055-3.2349-5.055s0.17074-0.64952,0.0854-2.8093c-0.0854-2.1619-0.2561-3.2829-0.2561-3.2829s0.18461,0.67607,0.4119,1.1805c0.22516,0.50447,0.56664,0.86387,0.56664,0.86387l4.6857,5.5205,1.3173-0.91693,2.7745,5.4099,2.5546,2.6339z'/%3E %3Cpath d='m403.49,216.94s3.6217,6.353,6.9861,9.8998c3.3651,3.54,7.2426,5.0815,7.2426,5.0815l-10.946-12.948-3.2824-2.0331z'/%3E %3Cpath d='m431.26,220.7c-0.18942,0.13045-2.4282-2.2918-3.8325-4.452-1.4075-2.1597-2.5125-5.1871-2.4282-6.5261,0.088-1.3408,0.46792-4.5787,0.46792-4.5787s3.7514,3.8896,4.4695,5.7033c0.72827,1.8171,2.2692,4.2886,1.9309,4.5933-0.33987,0.30203-2.8636-1.7002-3.1629-1.2216-0.2988,0.47524,2.9393,6.2215,2.5552,6.4818z'/%3E %3Cpath d='m435.52,216.64c-0.45778,0.2306-2.3407-1.9886-2.854-3.3716-0.5122-1.3852-0.68242-4.1056-0.68242-4.1056l-1.661-3.9324,0.1702-4.3627,1.661-0.26198,2.5109,3.4594s0.98175,2.0298,0.93959,4.9695c-0.0448,2.9375,0.42471,7.3447-0.0843,7.6054z'/%3E %3Cpath d='m406,227.32c-3.3662-4.1489-5.4099-8.0398-5.4099-8.0398l-1.1076-3.7164,0.59704,0.47632s0.97908,4.2788,6.174,9.375c5.1978,5.1032,6.3492,5.5317,6.3492,5.5317s1.0207,2.813,0.51167,3.8058c0.00036,0-3.7487-3.2861-7.1149-7.4328z'/%3E %3Cpath fill='%23202020' d='m411.61,233.27s-4.4312-3.914-7.9532-8.3513c-3.5204-4.4353-5.7364-8.6997-5.7364-8.6997l1.535-1.4425s2.9239,6.828,5.0261,9.537c2.1017,2.7091,7.1283,8.9567,7.1283,8.9567z'/%3E %3Cpath fill='%23202020' d='m417.72,231.92s-5.1397-5.0978-7.7523-7.9784c-2.6112-2.8786-4.0587-5.7909-4.0587-5.7909l2.1566,0.83465s0.85261,2.2458,2.7264,4.5836c1.876,2.3329,6.9279,8.3508,6.9279,8.3508z'/%3E %3Cpath fill='%23202020' d='m416.75,222.78s-2.8113-3.4263-4.1457-5.5862c-1.336-2.1602-2.7003-4.9267-2.7003-4.9267s3.7786,4.3216,4.8862,4.6085c1.1066,0.29012,1.0778-0.0265,1.0778-0.0265s-0.45458,1.5534-0.0843,2.8509c0.36922,1.298,0.96625,3.0799,0.96625,3.0799z'/%3E %3Cpath fill='%23202020' d='m417.89,208.88s0.45564,2.4152,0.14246,3.8301c-0.31,1.4095-1.0623,1.3997-1.0623,1.3997s1.4603,2.058,2.3135,2.9202c0.84833,0.86554,2.982,2.3627,2.982,2.3627s-1.7063-2.3627-2.3898-3.5714c-0.67976-1.2103-1.6737-2.564-1.2453-3.7462,0.42418-1.1838,2.727,0.80815,3.3774,1.3553,0.65624,0.54564,3.3544,3.7446,3.3544,3.7446s-0.99772-3.3159-2.3306-4.5224c-1.336-1.2087-5.1418-3.7727-5.1418-3.7727z'/%3E %3Cpath fill='%23202020' d='m429.22,216.13s-1.4486-3.4821-2.2756-5.614c-0.82274-2.1354-2.1129-6.7569-2.1129-6.7569s0.0976,2.117-0.0166,3.6737c-0.11364,1.5562-0.66586,3.9324-1.3451,4.2756-0.68242,0.34642-0.83556,0.41354-2.0904,0.0677-1.2554-0.34643,0.87289,0.58406,0.87289,0.58406s1.2789-0.0412,1.8338-0.66955c0.55061-0.63007,0.67815-1.9686,1.2789-1.7744,0.59438,0.19649,1.232,2.2274,1.7255,3.1129,0.48606,0.88498,2.1294,3.101,2.1294,3.101z'/%3E %3Cpath fill='%23202020' d='m424.81,203.72s2.7014,3.0258,3.8714,1.6639c1.1733-1.3603,0.49086-5.2072,0.49086-5.2072s1.6401,0.62787,2.1518,0.21759c0.5122-0.41029,0.27477-1.9226,0.27477-1.9226s2.9142,4.2555,4.3185,6.9776c1.408,2.7221,2.1289,7.6359,2.1289,7.6359s-2.4117-3.9194-3.634-7.6359c-1.1151-3.3819-2.7467-4.9251-3.0476-4.6014-0.29559,0.32314-0.7443,2.7005-0.38203,3.9324,0.36442,1.2298,1.3622,2.8309,2.0446,4.5803,0.68241,1.7494,1.4464,4.4948,1.4464,4.4948s-1.3846-2.0974-2.1902-3.2417c-0.80991-1.1443-1.6626-1.5995-2.2169-2.137-0.55274-0.54238-1.3851-1.5367-2.1907-1.8598-0.81205-0.32314-2.409-1.1242-2.409-0.49635,0,0.62519-0.31853-1.233-0.31853-1.233l-0.33827-1.1675z'/%3E %3Cpath fill='%23171717' d='m415.76,216.68s1.4907,2.9841,2.6816,4.5392c1.1936,1.5551,2.814,3.7592,2.814,3.7592s-2.5552-2.3329-3.579-3.802c-1.0234-1.4712-1.9165-4.4964-1.9165-4.4964z'/%3E %3Cpath fill='%238f4620' d='m433.35,217.46c-0.38362,0.15156-1.622-0.29987-1.7506,0.15156-0.12485,0.45198,0.70535,2.2274,1.622,3.1573,0.91186,0.92666,1.2992,0.96781,1.5132,0.86228,0.2113-0.11042-0.0976-0.92992-0.24704-1.8815-0.14938-0.94995-0.0325-1.9654-0.13818-2.2707-0.10564-0.30094-0.99932-0.019-0.99932-0.019z'/%3E %3Cpath fill='%23d2a567' d='m401.52,198.44-1.5505,1.0171-1.8744,3.8041,0.51061,6.9728s1.733,2.4488,2.7963,3.9903c1.0655,1.5416,4.588,5.5152,5.4965,5.2862,0.90812-0.23222,1.876-2.9944,1.988-4.4932,0.11365-1.5021,0.22783-4.2636,0.22783-4.2636s0.8526,1.4972,2.3274,3.108c1.4769,1.6157,2.727,3.1129,3.4099,2.9993,0.68243-0.11692,2.7232-4.2063,2.7798-4.7254,0.056-0.51584-5.1114-13.195-5.1114-13.195l-2.299-1.1919-8.7013,0.69177z'/%3E %3Cpath fill='%23ab6d29' d='m413.12,208.99s0.89156,3.2385,1.4464,4.8407c0.55436,1.5963-0.0155,2.9814,0.28545,3.0241,0.29666,0.0395,2.9943-3.5876,3.0359-5.2282,0.0448-1.6406,0.0448-3.3273-0.67922-8.3417-0.72726-5.0123,0.23369-6.47,0.23369-6.47l-1.5542-1.266-2.6848,5.403-0.0832,8.0382z'/%3E %3Cpath fill='%23ab6d29' d='m404.04,206.14s0.59652,4.8823,0.93692,6.4812c0.34149,1.5995,1.2773,4.32,1.7901,4.2756,0.51061-0.0395,2.1289-4.32,2.1721-5.7888,0,0-1.1076-2.0725-1.0655-7.3025,0.0432-5.2288-0.51166-5.7481-0.51166-5.7481l-3.3219,8.0826z'/%3E %3Cpath fill='%2345392d' d='m397.04,196.05s-4.0876,5.9341-4.0054,9.1902c0.087,3.2547,0.62477,2.5343,1.5644,5.4708,0.93585,2.9446,1.4486,7.2928,1.5036,7.6674,0.0576,0.37241,0.65305-0.2046,0.73843-0.63492,0.0848-0.43194,0.19901-21.694,0.19901-21.694z'/%3E %3Cpath fill='%23ab6d29' d='m397.02,196.75s-3.578,5.5301-3.3213,8.5854c0.2545,3.0501,0.7368,2.9678,1.7591,5.7048,1.0223,2.7373,1.1076,7.1988,1.1076,7.1988s1.136-0.34317,2.4133-1.2515c1.2779-0.91042,2.4276-2.7648,2.4276-2.7648s-0.43803-0.99437-1.2629-2.7784c-0.82274-1.7889-0.90865-2.4802-0.90865-2.4802l-1.05-1.4988,0.31213-5.3008,0.93585-3.8317v-1.4414l-2.4128-0.14182z'/%3E %3Cpath fill='%23dbad6c' d='m416.35,206.27s-1.7879-0.38919-2.5136-0.82114c-0.72084-0.43194-1.0207-1.469-1.0207-1.469l0.42737-1.0371,3.1069,3.3273z'/%3E %3Cpath fill='%23d2a567' d='m397.75,197.35s-2.5824,5.5617-2.2718,9.3916c0.31372,3.8334,2.4148,8.7301,2.6138,8.7884,0.19848,0.0574,0.11205-0.37403,0.16967-1.2401,0.0571-0.86228-0.11258-11.436-0.11258-11.436l1.2496-3.7164,0.056-1.9307-1.7047,0.14343z'/%3E %3Cpath fill='%238f4620' d='m404,198.59s0.34201,1.672,0.11365,2.3643c-0.22676,0.69066-1.5905,1.5551-2.1577,2.6501-0.56878,1.0945-1.3627,3.6293-1.3627,3.6293s0.62317-1.4398,1.4768-2.3611c0.851-0.9218,1.193-1.5551,1.3638-1.0387,0.16808,0.51909,0.45352,2.7107,0.28173,3.1145-0.16861,0.40055-0.85154,1.062-1.304,2.5906-0.48339,1.6276,0.0555,3.1129,0.0555,3.1129s0.29825-1.8604,0.56985-2.8244c0.23689-0.8525,0.96357-1.2699,0.96357-1.2699l1.4208,3.0588s0-1.4431,0.22889-2.5392c0.22676-1.0934,1.4166-2.635,1.8007-2.635,0.38415,0,0.97961-0.21597-0.46953-0.95103-0.46685-0.30204-0.16913-5.6172,0.21343-5.8336,0.38415-0.21435,2.385-0.29174,2.1748-1.0257-0.21342-0.73345-1.9501-2.7124-2.1208-2.8856-0.17073-0.17213-3.2488,2.8433-3.2488,2.8433z'/%3E %3Cpath fill='%23dbad6c' d='m416.06,209.9s-1.2394-0.21597-1.9203-0.34643c-0.68028-0.12882-0.76567-0.77672-0.76567-0.77672l0.21555-0.81948,1.5734,0.86388,0.8969,1.0788z'/%3E %3Cpath fill='%238f4620' d='m399.59,210.53c-0.0336,0.57054-0.45671,1.154-0.73147,1.9519-0.33187,0.96454-0.52395,2.1121-0.52395,2.1121s-0.38469-2.5522-0.51114-4.3465c-0.12859-1.7922-0.25556-2.9597-0.46791-3.0669-0.21344-0.10717-0.83129,0.84058-0.83129,0.84058s0-2.0098,0.38255-2.9808c0.38363-0.97106,0.70321-2.3546,0.36336-2.5705-0.34255-0.2176-1.065,0.38919-1.384,0.90661-0.32119,0.5191-0.91667,1.6423-0.91667,1.6423s0.38203-1.7066,0.78646-2.3974c0.4055-0.69231,2.3449-2.9186,2.7062-3.7825,0.36121-0.86388,0.36174-1.7938,0.36174-1.7938l1.344-0.0644s1.3995,1.0934,1.4128,2.0428c0.009,0.53585-1.3419,1.1362-1.3723,1.1984-0.0864,0.17321-1.1279-0.0877-1.3846,4.3644-0.2561,4.4531,0.88247,4.0872,0.76621,5.9437z'/%3E %3Cpath fill='%238f4620' d='m411.84,199.14s0.29719,2.419,0.0416,3.154c-0.25556,0.73506-0.97907,1.3392-1.4897,2.2902-0.51166,0.95156-0.46952,3.2434-0.46952,3.2434s0.25663-1.1264,0.68349-1.8187c0.42418-0.68904,0.76567-1.2958,0.93693-1.2958,0.16913,0,0.68081,0.86549,1.0218,2.1202,0.34147,1.2515,1.0239,3.3684,1.0239,3.3684s-0.29666-1.6439,0.12592-1.6439c0.42416,0,0.59437-0.12829,1.1498,0.30475,0.55649,0.43193,1.1946,1.0355,1.1946,1.0355s-0.0443-0.60351-0.85367-1.469c-0.80831-0.86388-1.2757-0.81948-1.535-1.9871-0.2529-1.1675-0.37883-2.3329-0.2529-2.8092,0.12591-0.47364,0.68189,0.30365,1.1493,0.86388,0.46845,0.56241,1.9598,1.8598,1.9598,1.8598s-0.63867-0.99436-0.81045-1.2975c-0.16967-0.30365-0.0437-2.5922,0-3.8896,0.0427-1.2958-0.0437-2.5045,0.42418-2.8493,0.47112-0.34805,0.55647-2.0347,0.3404-2.3362-0.21022-0.30149-4.6403,3.1562-4.6403,3.1562z'/%3E %3Cpath fill='%231e2121' d='m426.09,194.16s0.11577,2.7351,0.48445,4.3216c0.36709,1.5844,1.4203,5.0404,1.4203,5.0404s-1.4203-2.5641-2.0462-4.7817c-0.62584-2.2176-1.1946-4.6084-1.7618-4.7811-0.56611-0.1732-1.2208,1.0653-1.2208,1.9865,0,0.92126,0.59811,4.3795,1.3654,5.59,0.76727,1.2105-1.2224-1.5849-1.7063-3.0831-0.47913-1.4988-0.96571-2.8228-0.96571-2.8228s-0.48074,1.266-0.28278,2.6794c0.20008,1.4111,1.3947,3.4279,1.3947,3.4279s-0.77042-0.66309-1.2517-1.2401c-0.48287-0.57539-0.91025-0.9202-0.91025-0.9202s0.0843,1.9307,0.5965,2.7649c0.50848,0.83465,1.5046,2.1602,1.5046,2.1602s-1.1909-0.89203-1.6465-1.4111c-0.45511-0.518-0.59438-0.89038-0.59438-0.89038s0.25344,2.7632,0.85154,4.2339c0.59491,1.4674,1.9016,3.8896,1.9016,3.8896s-1.5638-1.2417-2.6133-3.6569c-1.0484-2.4223-1.5628-9.6358-1.3077-10.733,0,0,0.8019-1.3635,1.5414-2.4304,0.74002-1.0653,1.6743-6.1569,1.6743-6.1569s1.1605,4.7092,1.9533,5.6028c0.79715,0.89204,1.6194,1.2103,1.6194,1.2103z'/%3E %3Cpath fill='%231e2121' d='m414.82,192.74s0.60132,1.2628,0.98335,1.8252c0.38256,0.56241,0.76775,1.2845,0.76775,1.2845s-1.4091,1.5134-2.9825,2.7237c-1.5804,1.2087-3.666,2.5489-4.1334,1.8582-0.46845-0.69231-0.44604-1.2861-0.44604-1.2861s1.7341-1.0371,3.0972-2.419c1.3611-1.3835,1.8322-2.1088,2.1321-2.8412,0.29878-0.73666,0.58154-1.1454,0.58154-1.1454z'/%3E %3Cpath fill='%231e2121' d='m400.48,197.41s0.24437,2.9397,1.4806,2.8953c1.2362-0.0427,4.8985-3.7592,5.1536-3.9308,0.25556-0.17322,0.50046-1.082,0.50046-1.3852,0-0.30149-0.22248-0.99377-0.22248-0.99377s-3.9419,4.0412-5.3463,4.1716c-1.027,0.0936-1.566-0.75723-1.566-0.75723z'/%3E %3Cpath fill='%231e2121' d='m400.6,193.55s-0.46953,2.0677-0.40443,2.6512c0.0624,0.58187,0.24863,1.0355,0.24863,1.0355s-2.8262,0.99217-3.2942,0.12991c-0.46952-0.86388-0.16006-2.0958-0.16006-2.0958s1.3099,0.006,2.0334-0.16509c0.72512-0.17375,1.5767-1.5557,1.5767-1.5557z'/%3E %3Cpath fill='%231e2121' d='m427.27,189.4s1.1519,3.0306,1.8915,4.2426c0.74162,1.2103,1.9016,3.7148,1.9016,3.7148s-1.9016-2.2176-2.4981-2.7069c-0.59651-0.48987-1.5638-1.3061-1.5638-1.3061s0.27799-0.81627,0.27799-1.4479c0-0.63493-0.009-2.4964-0.009-2.4964z'/%3E %3Cpath fill='%23dbad6c' d='m396.55,195.29s1.05,0.13047,1.6951,0.0942c0.64988-0.0346,1.0746-0.29501,1.0746-0.29501l1.074-1.6043s-0.54687,1.8994-0.16966,3.2482c0.37454,1.3489,1.1562,1.5562,1.4635,1.5562,0.30627,0,1.805-0.31179,2.9655-1.5221,1.1578-1.2087,2.7595-2.4699,2.7595-2.4699s-0.37562,1.7445,0.23796,3.4723c0.61521,1.7294,1.6001,1.6947,2.9303,0.62301,1.3285-1.0717,2.695-2.9067,3.4232-3.7181,0.3991-0.44494,0.90758-1.3732,0.90758-1.3732l1.4625-1.1659,1.2602-7.1213-0.68242-0.93478-1.8445,0.88012-2.2084-0.88012-0.64829-0.8985-1.2602,2.1434-1.3296,0.86387-0.67172,0.11205-1.5436,0.30367-0.68082-1.3835-0.40976-1.0717-0.75017-0.34479-3.1757,3.2033-1.7986-0.092-1.8066,2.8342-1.2954,1.7954-1.3296,3.1492,0.35108,0.59597z'/%3E %3Cpath fill='%238f4620' d='m411.97,188.08s0.25664,1.7727-0.6376,4.7535c-0.89423,2.9825-2.1294,5.1-2.1294,5.1s3.1938-1.9459,4.7294-5.4446c1.5286-3.5021,1.1754-7.5215,1.1754-7.5215l-3.1378,3.1129z'/%3E %3Cpath fill='%238f4620' d='m415.84,184.83s0.3863,0.51746,0.0443,3.1968c-0.34147,2.6794-0.97907,5.2715-0.97907,5.2715s0.3783,0.64952,0.80778,1.5134c0.42417,0.86388,1.4918,2.3778,2.2575,2.1185,0.76728-0.26035,1.9576-1.1675,2.767-2.9413,0.80992-1.7711,1.5345-3.4988,1.8322-3.7592,0.29772-0.25928,0.42737,0.1732,0.55755,0.30366,0.12646,0.13044,0.3735,1.6423,1.1376,2.2902,0.76728,0.6479,1.7682,1.6639,2.2361,1.3618,0.46846-0.30203,0.92623-1.187,0.84197-1.6228-0.0843-0.43031-1.7047-5.271-1.7047-5.271l-2.043-5.2288-1.3099-2.0309-3.7188,0.34642-2.7264,4.4515z'/%3E %3Cpath fill='%23ab6d29' d='m422.29,180.03s1.05,2.2474,1.1119,4.668c0.0555,2.4206-0.48447,4.9549-0.48447,4.9549s0.22623-3.0242-0.11364-4.839c-0.34147-1.8154-0.88087-2.9976-0.82274-3.5156,0.055-0.51801,0.30893-1.2682,0.30893-1.2682z'/%3E %3Cpath d='m427.34,189.49s0.21129,2.0888,0,3.0799c-0.21288,0.99595-1.6641-0.6463-2.5546-3.9308-0.89744-3.2845-0.72671-4.0185-1.408-5.6172-0.68563-1.6011-1.0954-2.9824-1.0954-2.9824l1.8626-0.25765,3.1954,9.7085z'/%3E %3Cpath d='m418.23,195.59s3.5524-2.0147,4.0022-8.0826c0.2161-2.8509-1.6172-7.4756-1.6172-7.4756s0,4.9251-1.32,8.1023c-1.3206,3.1774-2.4085,5.2959-2.4085,5.2959s0.85261-0.36969,1.2805-0.88717c0.4247-0.518,1.0207-1.4062,1.0207-1.4062s0.19154,0.91041-0.12698,2.0974c-0.31906,1.1881-0.83075,2.3557-0.83075,2.3557z'/%3E %3Cpath d='m415.1,184.96s-0.11365,1.3407-1.6049,2.5505c-1.4918,1.2103-4.1718,2.5506-4.1718,2.5506s1.9582-1.8154,2.68-3.415c0.72725-1.5995,0.17127-2.635,0.17127-2.635s-0.2529,0.86228-1.106,1.5118c-0.85153,0.64951-2.0867,0.77673-2.0867,0.77673s0.10244-0.81948,0.86917-1.6834c0.1574-0.17645,0.12858-0.58351,0.23583-0.918,0.41936-1.2963,1.535-3.1015,1.535-3.1015s0.85153,1.9026,1.7031,2.7221c0.85152,0.82113,1.7751,1.6411,1.7751,1.6411z'/%3E %3Cpath fill='%231e2121' d='m426.21,177.79s0.84993,2.1911,1.1909,5.186c0.34147,2.9976-0.0555,6.5127-0.0555,6.5127s-1.8167-2.8244-2.2708-3.9773c-0.45513-1.1524-0.45513-2.8802-0.85314-3.7456-0.23904-0.518-0.89102-1.0376-1.3718-1.3705-0.31532-0.21922-1.3258-0.17159-1.3258-0.17159s1.0484-0.50285,1.1376-1.4246c0.0811-0.9218,0-1.4111,0-1.4111s0.67922,0.34479,1.7884,0.48985c1.1055,0.1429,1.7602-0.0877,1.7602-0.0877z'/%3E %3Cpath fill='%231e2121' d='m418.25,190.58s1.94-2.7091,2.4468-6.0511c0.51221-3.3408-0.0843-4.4948-0.0843-4.4948s-0.79448-0.11367-1.447-0.74857c-0.65363-0.63273-1.6732-2.2755-1.6732-2.2755s0.28225,1.7294-0.0891,3.8317c-0.36654,2.1023-2.2996,4.117-2.2996,4.117s1.026,0.35616,1.933-0.17158c1.9261-1.1248,1.7879-3.2547,1.7879-3.2547s0.42417,0.25927,0.36814,2.9088c-0.0581,2.6528-0.94279,6.1387-0.94279,6.1387z'/%3E %3Cpath fill='%238f4620' d='m395.31,195.2c-0.41083-0.0574,1.2789-2.681,2.4287-4.4948,1.1508-1.8155,2.7686-4.366,2.7686-4.366s0.29932,0.30367,0.98014,0.26036c0.68083-0.0449,2.4276-0.82113,3.1522-2.1619,0.72458-1.3391,1.2773-2.8082,1.3216-3.2417,0.0422-0.43032-0.12912,2.3345,1.1914,3.8469,1.3216,1.5118,1.2784,1.3835,1.8327,1.2531,0,0-0.0427,1.9026-0.55435,3.6737-0.51062,1.7727-1.0223,4.3232-1.0223,4.3232s0.21288-3.3273-0.342-4.2804c-0.55168-0.94996-0.851,0.0872-1.319,1.2975-0.46792,1.2087-1.4897,2.0742-1.4897,2.0742s0.76568-1.469,1.2768-3.0252c0.5106-1.5551,0.25663-1.5995,0.12698-1.6423-0.12698-0.0427-0.38202-0.0855-0.93531,0.56242-0.55436,0.6479-1.1087,0.82113-1.1087,0.82113s0.68188-0.56241,0.89476-1.3408c0.21395-0.77674,0.85261-1.901,1.2352-2.3329,0.38255-0.43194,0.6392-0.95156,0.6392-1.2531,0-0.30365-0.0859-0.95156-0.34201-0.95156-0.25344,0-0.59544,0.3908-1.829,1.5562-1.2368,1.1659-1.4507,1.2515-1.6636,1.685-0.21288,0.43194-0.38362,0.99217-1.1508,3.415-0.76568,2.419-1.2779,3.415-1.4032,3.6309-0.1286,0.21435-0.68243,0.5754-0.68243,0.5754s0.42631-1.3537,1.0645-3.1259c0.63867-1.7706,1.4913-4.1056,1.2784-4.4948-0.21288-0.38756-0.76726-0.3448-0.93745,0-0.16967,0.34642-1.4048,1.8582-2.6405,3.6721-1.2357,1.8171-1.2357,4.0645-1.534,4.15-0.00036,0.00053-0.8238-0.0276-1.2368-0.0855z'/%3E %3Cpath fill='%23874f20' d='m427.43,175.83c-0.0245,0.20948,0.11418,1.5053-1.2202,1.9589-1.336,0.4552-2.9532-0.0855-3.1255-0.236-0.16859-0.15157-0.16859-1.8598-0.16859-1.8598l4.5144,0.13695z'/%3E %3Cpath fill='%23b27129' d='m401.59,180.06s-0.24329,1.2352-0.97266,2.7649c-0.73147,1.5302-1.9432,2.8049-1.7933,2.9993,0.14833,0.19432,0.83128,0.90881,1.8952,0.88718,1.0655-0.0217,1.448-6.3765,1.448-6.3765l-0.1862-0.22734-0.3911-0.0476z'/%3E %3Cpath fill='%23dbad6c' d='m417.95,176.56s-0.48181,8.4208-2.8454,8.4058c-2.3631-0.0114-3.4328-4.2572-3.4328-4.2572s-0.19582,5.6787-3.2141,5.6787c-1.3626,0-2.8017-4.3843-2.4954-5.1806,0,0-0.55915,3.0242-1.9827,4.1435-2.8241,2.2225-4.6248,1.1362-4.7214,0.78972-0.0976-0.34479,2.385-2.714,2.7254-6.0249,0,0,0.43697,0.14832,1.1188-0.83898,0.68187-0.98728,1.0719-2.0725,1.7527-1.8766,0.68189,0.1965,4.0896-1.3835,4.0896-1.3835l1.7863-2.262s0.20969,0.73233,1.5233-0.15696c1.3142-0.89044,1.7532-2.2225,1.7532-2.2225l3.5038,2.963,0.43859,2.2231z'/%3E %3Cpath fill='%23b27129' d='m408.73,168.56s2.1192,3.2087,3.5358,4.9928c0.0827,0.10393,0.77791-0.67121,0.77791-0.67121,0.46793,0.64139,0.72672,1.1984,0.58422,1.5351-0.55274,1.2975-1.7025,3.0685-0.76781,4.9267,0,0-0.29664-1.0371,0.21556-2.3762,0.51167-1.3408,0.89369-1.8171,1.193-1.7727,0.29772,0.0433,0.81044,7.6914,1.3216,7.6487,0.50901-0.0444,1.1914-3.4577,1.1914-5.8764,0-2.4223,0.4834-0.43357,0.71175,0.0427,0.22676,0.47469,2.3119,3.8896,4.1009,3.3706,1.7895-0.518,1.5361-3.6737,1.4902-4.3632-0.0384-0.69392-1.2757-4.8835-1.2757-4.8835l-8.0099-5.042s-0.23369,0.63165-0.65999,2.059c-0.4279,1.4263-4.4093,0.40921-4.4093,0.40921z'/%3E %3Cpath fill='%238f4620' d='m420.1,167.81s0.4674,0.43194,1.2389,2.4206c0.7646,1.9881,0.84886,8.4272-0.1718,8.3823-1.0239-0.0427-3.07-1.2087-3.4083-2.0742-0.34254-0.86388,0.12593-4.0607-0.55381-4.9267-0.68189-0.86388-1.4918-3.0236-1.5356-3.6293-0.0437-0.60356,0.13019-2.5489,0.13019-2.5489l1.7868-0.64951,2.5136,3.0258z'/%3E %3Cpath d='m419.53,165.81,3.4083,5.0702,3.0119,4.3513s1.5163,0.50286,1.4774,0.6035c-0.0422,0.1023-1.7484,1.9589-4.1115,0.64139-1.1754-0.65603-0.57573-2.7026-2.0643-5.9854-1.4934-3.2845-4.1756-4.7108-4.1756-4.7108l0.93852-0.90722,1.5153,0.93697z'/%3E %3Cpath fill='%231e2121' d='m417.65,163.04s3.0449,2.0114,4.1238,4.2014c1.0794,2.1895,1.7068,3.5156,3.0135,5.6472,1.3029,2.1316,2.6998,2.7946,2.6389,2.9381-0.0555,0.14506-0.93585,0.34641-1.5895-0.14345-0.65518-0.48986-1.3328-1.0653-1.8744-2.046-0.54158-0.97918-2.4426-4.5505-3.1544-5.474-0.70962-0.92179-2.9788-2.6496-3.037-2.4763-0.0555,0.1732,0.70962,0.69231,2.0179,2.7946,1.305,2.1023,1.6172,4.0034,1.5324,4.0331-0.0859,0.0298-0.37028-0.77839-1.5062-2.6794-1.1354-1.9026-3.6052-4.3513-3.7477-4.005-0.14247,0.34643,1.2197,2.5938,1.9021,3.8896,0.68081,1.2958,1.8194,4.3216,1.7047,4.3216-0.11312,0-0.90972-1.7002-2.2745-3.8041-1.3611-2.1024-1.6172-1.843-2.187-2.5326-0.56505-0.69392-1.781-2.2885-1.781-2.2885s1.2165,0.38593,2.4069-0.39242c1.1952-0.77839,1.8114-1.9838,1.8114-1.9838z'/%3E %3Cpath fill='%238f4620' d='m409.9,168.65s1.9603,0.45197,3.0215,0.32152c1.0682-0.12883,1.4294-0.0855,1.4294-0.0855s0.63705,0.86547,0.63705,1.8582c0,0.99435-0.68242,2.8525-0.97908,2.8953-0.29772,0.0427-0.25344-1.685-0.72031-2.2902-0.47112-0.60571-3.3886-2.6994-3.3886-2.6994z'/%3E %3Cpath fill='%23b27129' d='m410.94,173.79s0.63386,2.1251,0.14726,5.0864c-0.48767,2.9646-2.1918,6.026-2.6299,6.026-0.43697,0-0.29238-3.3586-0.48605-5.1341-0.0203-0.18998-0.0416-0.37131-0.0619-0.54398-0.0277-0.24574-0.67066,2.2393-0.69465,2.0249-0.0262-0.22572,0.56663-3.1475,0.54473-3.3359-0.0838-0.70422-0.13766-1.1161-0.13766-1.1161l2.1993-2.6117,1.1188-0.39568z'/%3E %3Cpath fill='%238f4620' d='m407.21,176c-0.59597,0.73559-1.51,0.53585-2.3551,0.80003-0.79234,0.24573-1.0783,1.4544-1.0783,1.4544s0.64026-0.4747,0.93852-0.34642c0.29718,0.13045,0.6525,0.1023,0.0555,1.5697-0.59597,1.4706-2.9239,3.9622-2.8113,3.992,0.11364,0.0298,2.6-2.104,3.4083-3.3142,0.80883-1.2087,0.73788-1.9291,0.90812-2.3627,0.16966-0.43195,1.136-0.94942,1.3488-0.99216,0.21395-0.0449,0.6835,0.0427,0.89476,0.90662,0.21343,0.86388,0.55435,3.3273,0.72458,3.4133,0.17074,0.0855,0.76674-2.2474,1.0218-3.4133,0.25557-1.1675,0.24436-3.7381,0.24436-3.7381s-0.15846-0.0644-0.75604-0.19595c-0.59545-0.12883-2.0243-1.154-2.0243-1.154s0.28066,2.3946-0.51967,3.3809z'/%3E %3Cpath fill='%23dbad6c' d='m417.72,160.94s0.80885,2.0098-0.85313,3.415c-0.49246,0.41408-0.96625,0.69066-1.8456,0.73559-0.88301,0.0412-2.2868-0.71395-2.2868-0.71395l-5.0912-2.1191-2.6827-0.84116-1.3206-0.36754,0.18995-1.469,3.9829,0.17321,3.9419,1.5102,1.725,0.56242,1.4683,0.25872h1.1092l0.9156-0.25872s0.42309-0.17321,0.55006-0.40921c0.13072-0.23871,0.19689-0.47633,0.19689-0.47633z'/%3E %3Cpath fill='%23ab6d29' d='m417.72,160.94c0.16755,0.34641-0.30038,1.469-0.68241,1.6423-0.38576,0.17321-1.0687,0.4747-2.6005,0.12882-1.5318-0.34479-3.1085-1.3392-4.8126-1.8138-1.7031-0.47633-2.9815-0.90828-4.302-0.86548-1.3216,0.0449-0.68189-0.56242-0.68189-0.56242s3.0247-0.34317,5.6669,0.64951c2.6427,0.99436,3.7786,1.6698,5.113,1.6406,1.9992-0.0412,2.2996-0.81953,2.2996-0.81953z'/%3E %3Cpath d='m403.79,159.34s0.5949,0.12882,1.1076,0.0427c0.51221-0.0871,0.89636-0.38918,0.89636-0.38918s0.0854,0.69231-0.25662,0.90828c-0.34149,0.21596-1.3627,0.12882-1.534,0.12882-0.17126,0.00036-0.21342-0.69065-0.21342-0.69065z'/%3E %3Cpath fill='%23dbad6c' d='m413.8,165.63s1.7831,1.7445,1.3051,3.2547l-3.4344-1.5784-5.6018-2.3329-3.0348-0.90662-0.37294-0.47633s0.57571-0.53912,0.85153-1.0571c0.27637-0.5191,0.19154-1.0155,0.19154-1.0155l3.7055,0.49636,3.8762,1.1903,2.5141,2.4254z'/%3E %3Cpath fill='%23dbad6c' d='m409.99,168.13s3.1954,4.1272,2.449,5.4874l-7.4558-4.7092-2.6272,4.3281-6.1323-3.0236s4.9471-3.8122,5.5227-4.5246c0.57464-0.71395,0.61787-0.97266,0.61787-0.97266l2.7691,0.53912,4.3639,1.3852,0.49247,1.4902z'/%3E %3Cpath fill='%23ab6d29' d='m408.26,162.03s2.6112,0.63493,4.2892,1.4972c1.6748,0.86388,4.0187,1.0587,4.0187,1.0587s-0.94173,0.99376-2.7713,1.0452c-0.54052,0.0146-1.845-1.0371-2.6987-1.6406-0.851-0.60676-3.3075-1.3256-3.3075-1.3256l0.46953-0.63493z'/%3E %3Cpath d='m403.66,160.63s1.8754,0.38918,3.0263,0.90662c1.1498,0.51908,1.2352,0.38918,1.5334,0.26036,0.29771-0.13045,0.33986-0.26036,0.33986-0.26036s0.23584,1.1264-0.65998,1.1264c-0.89476,0-1.256-0.30365-2.4053-0.82274-1.1509-0.51801-1.9187,0-1.9187,0l0.0843-1.2103z'/%3E %3Cpath fill='%23ab6d29' d='m414.02,167.88s1.3371,0.83571,1.0783,1.0073c-0.2529,0.17321-0.92303,0.48986-2.0851,0.56241-1.1621,0.0725-1.7191-0.0709-2.544-0.44709-0.82166-0.37403-1.3333-1.8155-3.3219-2.5922-1.987-0.77839-2.329-0.89363-3.6911-1.2401-1.3638-0.3448-1.6759-0.31666-1.6759-0.31666l1.2507-0.51908,4.286,0.86548,3.6639,1.0653,2.2153,1.0668,0.8238,0.54779z'/%3E %3Cpath fill='%23ab6d29' d='m406.82,170.4,0.85261,3.3706-0.46953,2.0331-1.1498,0.73345-1.0645-0.43194-0.29825-0.60517s0.46898-0.77673,0-1.469c-0.46632-0.69066-2.64-1.5551-2.64-1.5551s0.85261-1.6439,1.8306-2.0315c0.97908-0.38919,0.50954-1.6423,0.50954-1.6423l2.4292,1.5979z'/%3E %3Cpath d='m402.64,163.53s0.68081,0.57541,2.075,0.72101c0.59063,0.0628,1.6967,0.26035,2.8347,0.61814,0.38255,0.12071,1.3174-0.39893,1.3958-0.37565l-0.80938,0.48498c1.2368,0.35617,2.7899,0.8969,3.3363,1.1459,1.479,0.66955,2.641,1.7294,2.5552,1.7575-0.0464,0.0146-0.84245-0.46172-2.5552-1.1822-1.2432-0.52288-2.8235-1.0106-3.9755-1.2401-2.5573-0.50123-5.113-0.34263-5.6509-0.51747-0.54159-0.17159,0.22676-0.20135,0.50953-0.48986,0.2844-0.28741,0.2844-0.92232,0.2844-0.92232z'/%3E %3Cpath fill='%23ab6d29' d='m412.18,172.78s0.81152,0.86387-0.0416,1.1659c-0.85153,0.30366-3.1741,0.24899-4.2802-0.91855,0,0-0.27744-1.1113-0.70374-1.6292-0.42525-0.51909-2.1294-1.5995-3.1095-2.2046-0.97908-0.60515,0.3388-0.69231,0.3388-0.69231s3.4953,1.3408,4.7737,2.0314c1.2784,0.69284,3.0226,2.2474,3.0226,2.2474z'/%3E %3Cpath d='m412.23,172.86s-1.7212-2.3778-6.5015-4.2626c-0.13178-0.0509,1.6263-0.3015,1.4891-0.3513-0.20489-0.079-2.3055,0.0412-2.5226-0.033-0.36015-0.12394-0.73308-0.24735-1.1247-0.3659-2.5136-0.76375-2.6966-0.69065-2.8662-1.0371-0.17234-0.3448-0.48445,0.0574-0.73948,0.48931-0.25718,0.43195-0.96519,1.3684-0.90919,1.2828,0.0566-0.0877,1.8472-0.50448,3.2659-0.15806,1.4208,0.34318,1.3622,0.86388,1.2491,1.4111-0.11312,0.54725-1.845,2.6512-1.6465,2.7091,0.19901,0.0563,1.1919-1.9903,2.4981-1.7002,1.3072,0.28851,1.734,1.0073,1.734,1.0073s-0.0299-0.74857-0.28331-1.0669c-0.25664-0.31664-1.7052-1.6704-1.3077-1.6704,0.39748,0,2.0157,0.37403,4.3452,1.5551,2.2676,1.1551,2.6384,1.4999,3.3197,2.1906z'/%3E %3Cpath fill='%23dbad6c' d='m404.43,169.12s3.665,1.0371,3.4942,4.9267c-0.17073,3.888-3.0108,3.1687-3.2675,1.7576-0.25344-1.4127,0.34146,0.67606,1.3638,0.48823,1.1172-0.20298,1.3488-1.3224,1.2784-2.8212-0.0683-1.4398-0.36815-2.1619-1.2501-2.9976-0.87927-0.83571-1.6188-1.3537-1.6188-1.3537z'/%3E %3Cpath fill='%236c3f18' d='m388.58,159.75s0.38362,0.295-0.66051,3.0404c-1.0447,2.7438-1.6092,3.7213-3.1933,5.4676-2.9623,3.2612-4.2609,3.2829-3.9414,4.6664,0.32014,1.3835,1.47,1.0144,1.7244,1.0588,0.25664,0.0433,5.5809-7.8004,5.5809-7.8004l1.1712-4.7108-0.27639-1.3175-0.40496-0.40434z'/%3E %3Cpath fill='%23dbad6c' d='m401.79,154.14s1.534,2.3016,1.05,6.6533c-0.48287,4.3497-6.2162,8.1531-6.2162,8.1531l-8.3786,5.7909-3.5006-0.20948s-0.54211,0.0779-1.05-0.0547c-0.5506-0.14343-1.0671-0.71395-1.1855-0.71395-0.22729,0-0.65411-1.4706-0.65411-1.4706l1.1087-1.3532,3.0386-3.0274,1.9016-2.7356s0.85313-1.5843,0.96625-3.1113c0.11471-1.527-0.28385-2.3053-0.28385-2.3053l0.71123,1.095,0.39589,2.3048-0.31266,2.5641,2.1876-1.469,2.8961-1.2948s0.79661-0.11692,1.3638-1.7294c0.56665-1.6141,1.0442-3.9849,1.0532-5.042,0.0112-1.0604-0.11738-2.3334-0.11738-2.3334s0.18194-0.0114,0.36441,0.0974c0.18035,0.10717,0.946,1.4479,0.946,2.2128,0,0.76807,0.4898,3.5892,0.4898,3.5892l1.3429-1.3635s0.98977-1.2417,1.256-1.888c0.26571-0.64898,0.6376-1.6715,0.62691-2.3589z'/%3E %3Cpath fill='%23904720' d='m402.72,175.91s0.57518,0.47471,0.36174,2.0525c-0.21289,1.5784-1.5116,2.4422-2.1496,2.4634l0.0624-2.203-1.8519-1.4706-1.9822-0.6035s0.1286-0.1088,0.36175-0.34642c0.2353-0.23708,2.2809-1.0799,2.2809-1.0799l2.9169,1.1876z'/%3E %3Cpath fill='%23ab6d29' d='m401.27,175.93s0.57519,0.56076,1.4913,0.32313c0.9156-0.23599,1.3008-1.7083,0.80938-2.2902-0.48981-0.58347-0.27639,1.4046-0.87184,1.6212-0.59758,0.21598-1.2352-1.4907-2.0456-1.6639-0.80938-0.17321-2.0878,0.38918-2.4063,0.92665-0.3196,0.54238,1.3002,0.11043,1.3002,0.11043l0.8713,0.23707,0.64027,0.15157,0.21128,0.58405z'/%3E %3Cpath fill='%23904720' d='m389.17,169.89s1.0889,0.32784,2.2681,0.16817c1.1792-0.16022,4.0763-1.3684,4.0763-1.3684s1.3339-0.75023,2.3145-1.7002c0.97747-0.94995,4.0753-2.8823,4.4157-6.7404,0.3388-3.8615-0.45511-6.1072-0.45511-6.1072s4.5763,5.0009,0.56717,10.746c-2.6112,3.7441-4.883,4.8391-4.883,4.8391s4.4306-1.2964,4.8286-0.23112c0.39484,1.0653-0.20701,2.7237-0.32172,2.983,0,0,2.5136,0.58353,2.8753,1.8582,0.21768,0.76536-2.8534-0.88717-5.1739-0.32476-2.321,0.56241-3.3432,1.9437-3.3432,1.9437s-0.4263-0.66955-2.4922-0.68905c-2.0675-0.0227-3.0034,0.94942-4.1761,0.90662-1.1701-0.0444-4.853-0.83-5.5643-1.8373,0,0,0.87873-1.0973,2.4371-2.875,1.0652-2.0486,2.6267-1.5707,2.6267-1.5707z'/%3E %3Cpath fill='%23ab6d29' d='m398.69,159.53s1.79-1.7575,2.385-3.0534c0.59811-1.2964,0.71123-2.3335,0.71123-2.3335s0.20008,1.4095-0.851,2.9944c-1.0522,1.5865-2.2142,2.681-2.2142,2.681l-0.031-0.28851z'/%3E %3Cpath fill='%23904720' d='m398.2,155.61s1.463,5.6755-0.0992,8.0083c-1.5628,2.3335-8.3593,5.3549-8.3593,5.3549s5.1508-2.7909,6.7703-6.003c1.6172-3.2136,1.5041-5.8913,1.5041-5.8913l0.18461-1.469z'/%3E %3Cpath fill='%231e2121' d='m391.44,170.05s2.1737-0.0449,3.4083-0.77838c1.2362-0.73346,2.9825-2.2902,2.9825-2.2902s-1.6183,1.4263-2.0878,1.4263c-0.46953,0-0.85154-0.73345-0.6392-1.2964,0,0-0.38309,1.0804-1.3622,1.8138-0.97961,0.73506-2.3017,1.1248-2.3017,1.1248z'/%3E %3Cpath fill='%231e2121' d='m396.5,162.97s1.8311-1.9026,1.7879-5.878c-0.0422-3.9752-1.534-3.2401-1.534-3.2401s1.2362,0.90662,0.98014,3.9324c-0.2545,3.0242-1.2341,5.1854-1.2341,5.1854z'/%3E %3Cpath fill='%231e2121' d='m398.72,163.36s2.0632-0.49798,2.7894-1.7083c0.72298-1.2087,0.70374-3.5205,0.70374-3.5205s-0.21448,2.1175-0.81151,2.8937c-0.59544,0.77892-2.6816,2.3351-2.6816,2.3351z'/%3E %3Cpath fill='%231e2121' d='m397.52,175.8s1.0239-1.9887,2.3876-1.469c1.3611,0.51639,1.3611,1.5995,1.3611,1.5995s-0.55328-0.86388-1.574-0.90881c-1.0239-0.0427-2.1748,0.77838-2.1748,0.77838z'/%3E %3Cpath fill='%231e2121' d='m393.65,172.22s3.0231-0.73671,4.8132-1.2975c1.7879-0.56075,3.8346-1.4263,3.8346-1.4263s-1.4918,1.8582-3.7082,3.1113c-2.2153,1.2531-4.0459,1.3392-4.0459,1.3392s4.1761-1.8138,4.5149-2.5478c0.00036,0-4.0027,1.0798-5.4089,0.82113z'/%3E %3Cpath fill='%23fff' d='m388.81,167.55a3.4648,3.5296,67.762,0,1,-3.9761,5.7172'/%3E %3Cpath fill='%23f16e16' d='m388.63,167.94a3.0522,3.1092,67.771,0,1,-3.5737,4.9719'/%3E %3Cpath fill='%23000' d='m387.28,169.62a1.2259,1.2259,0,1,1,-1.1941,1.8534'/%3E %3Cpath fill='%23d5d3ca' d='m387.45,171.18c-0.0386,0.21551-0.24182,0.36146-0.4524,0.32171-0.21425-0.036-0.35504-0.24034-0.31893-0.45585,0.0361-0.21735,0.23934-0.36143,0.45116-0.32355,0.21425,0.036,0.35506,0.2422,0.32017,0.45769z'/%3E %3Cpath fill='%23ab6d29' d='m389.58,165.4s2.0168-1.9865,2.4703-4.6101c0.45512-2.622,0.17874-4.1121,0.17874-4.1121l1.0997,1.1443,0.42418,1.9903-0.71016,3.311,2.218-1.0073c0.73629-1.0073,1.901-5.5024,1.503-8.2669,0,0,0.59811,1.2103-0.19848,4.9831-0.79447,3.776-1.4431,4.2223-4.2826,5.777-1.4646,0.8011-3.3098,2.3405-4.9731,5.5403-0.74013,1.4238-2.7415,3.6732-3.0638,4.0018-0.0518,0.0525,1.4224-2.0151,2.1422-3.5576,1.0778-2.3099,2.2551-3.6079,2.2551-3.6079l0.93691-1.5854z'/%3E %3Cpath fill='%23904720' d='m388.64,166.99s0.87932-2.6512,0.87932-4.091-0.93639-3.1411-0.93639-3.1411,1.2768-0.17322,1.391,2.9662c0.11311,3.1427-0.56877,3.3159-1.3339,4.2658z'/%3E %3Cpath d='m392.69,163.61s0.93638-2.3329,0.87397-3.8896c-0.0651-1.5562-1.3408-3.0469-1.3408-3.0469s1.5756,0.30312,1.7041,3.1346c0.12645,2.8293-0.36388,2.8525-1.2373,3.802z'/%3E %3Cpath fill='%23ab6d29' d='m383.39,174.25s-0.72832-0.93644-0.64401-1.6704c0.0854-0.73345,0.0283-0.90011,1.8376-2.8027,1.8098-1.901,2.8118-3.0669,3.2589-4.0824,0.44764-1.0171,1.916-3.789,0.7459-5.9357,0,0,0.80884,3.1281-1.002,5.6124-1.8109,2.4834-2.8524,3.7792-4.3442,4.8823-1.4902,1.1015-1.6391,1.619-1.5969,2.2474,0.0433,0.62627,0.19101,1.2531,0.44712,1.4046,0.45511,0.26848,1.2976,0.34426,1.2976,0.34426z'/%3E %3Cpath fill='%236c4119' d='m400.94,180.42s0.40389,0.0427,0.65998-0.43195c0.25451-0.47469,0.25451-1.2742-0.38362-2.0742-0.63974-0.79949-1.3638-1.2742-2.2586-1.5351-0.89476-0.25873-2.6181-0.43194-2.6181-0.43194s0.58582,1.0106,1.7452,1.6634c0.56717,0.32152,1.534-0.0855,2.1518,0.51908,0.61788,0.60677,0.70321,2.2907,0.70321,2.2907z'/%3E %3Cpath fill='%236c4119' d='m400.94,180.42s2.012-0.65331,2.1496-2.5922c0.0854-1.2006-0.16967-1.6212-0.16967-1.6212s0.29719,0.62681,1.1076,0.86388l0.72405-0.28038c-0.00036,0.00036-1.1925,3.7597-3.8117,3.6298z'/%3E %3C/g%3E %3Cg id='beak' fill='%23f9c83a'%3E %3Cpath fill='%23bf802d' d='m386.9,180.05s0.39322,0.16347,1.1392,1.0274c0.74589,0.86386,1.097,1.1459,1.097,1.1459l4.8778-1.2531,1.5777-1.5562-1.3216-2.0942h-3.4926l-3.8773,2.7302z'/%3E %3Cpath stroke='%238f4620' stroke-width='0.48' d='m398.72,178.39-0.93959-1.2661s-0.19901-0.48985-0.90865-0.86388c-0.70963-0.37402-3.6634-0.34641-3.6634-0.34641l-2.1299,0.43194s-0.59598,0.54724-1.6759,0.31665c-1.0788-0.22897-3.4643-1.2103-3.4643-1.2103l-2.3855-1.0371s-1.7879-0.74857-2.186-0.60517c-0.39856,0.14345-1.8738,1.7581-1.8738,1.7581s-0.25611,0.86548,0.31159,0.89203c0.56718,0.0298-0.8526,0.28851-0.8526,0.28851s-3.7066,2.0331-4.3015,5.6637c-0.59757,3.6271,6.0901,8.9866,8.5602,6.2638,0,0-3.6201-2.6794-2.8955-4.9267,0.7235-2.2474,2.3855-3.6309,5.2389-3.8004,2.854-0.1732,3.0247-0.5207,4.2599-1.3851,1.2352-0.86388,3.5348-1.3819,5.2395,0.38918,1.7025,1.7705-6.4753,3.4594-6.4753,3.4594l0.89369,1.2942c0.002-0.00054,10.099-3.4582,9.2479-5.3165z'/%3E %3Cpath fill='%23fcf3d8' d='m379.85,187s-4.0886-0.99436-3.7498-4.7535c0.34254-3.7576,3.7498-5.1411,4.3463-5.3137,0.59597-0.17483,0.46899-2.0775,1.1508-2.2902,0.68082-0.21758,1.9896,0,2.5867,0.56077,0.5965,0.56242,1.8631,1.0918,1.8631,1.0918s-7.2399,3.2217-7.3035,7.3767c-0.0443,2.7659,1.1066,3.3283,1.1066,3.3283z'/%3E %3Cpath fill='%23fdeaaf' d='m398.7,177.99s-0.49513,0.30203-0.62905,0.053c-0.76566-1.4246-2.5557-1.8041-4.0048-1.7808-1.8456,0.0281-3.0973,0.71555-4.3474,0.71555-1.2491,0-0.90758-0.19972-2.385-0.26035-1.4774-0.0563-4.6285-2.3892-5.3398-2.1581-0.70962,0.23059-0.99398,1.108-0.90758,1.54,0.0864,0.43193-1.2821,0.45846-1.4806,0.14019-0.19955-0.31665,1.0874-2.3546,2.3658-2.3546,3.4355,0,5.9864,2.3151,7.6343,2.3151,1.6482,0,2.2158-0.95102,4.4296-0.95102,2.2164-0.001,4.6078,0.98298,4.6648,2.741z'/%3E %3Cpath fill='%23513625' d='m387.45,180.66s1.6422-0.32476,2.8742-0.86388c1.2368-0.53913,2.8833-0.97106,2.8833-0.97106s-1.5105,0.99922-2.5547,1.4988c-1.0436,0.49473-2.7339,0.76807-2.7339,0.76807l-0.46899-0.43195z'/%3E %3Cpath d='m381.66,189.16c-0.29718,0.11692-1.7324,0.0574-4.0176-1.469-2.2863-1.527-2.8817-4.1186-2.8817-4.1186s-0.52554-2.4802,1.845-4.9992c2.3722-2.5213,2.7606-1.7954,2.8871-1.6785,0.10884,0.1023-0.11952,0.22463-0.11952,0.22463l-2.0878,1.7002-1.0351,1.7429-0.91881,1.5681,0.072,1.855,1.057,1.8647,3.2706,2.0428,1.9288,1.2671z'/%3E %3Cpath fill='%238b5122' d='m380.41,174.93-0.13179-0.31179v0.33939c0.10565-0.006,0.11899-0.026,0.13179-0.0276l-0.13179-0.31178v0.33939-0.3448l-0.23637,0.24575c0.0854,0.0823,0.18461,0.099,0.23637,0.099v-0.3448l-0.23637,0.24575,0.23637-0.24575h-0.33774c-0.002,0.0563,0.0176,0.16346,0.10137,0.24575l0.23637-0.24575h-0.33774,0.33561l-0.30733-0.14182c-0.008,0.0244-0.0266,0.0509-0.0283,0.14182h0.33561l-0.30734-0.14182,0.26678,0.12179-0.23796-0.17321-0.0283,0.0514,0.26678,0.12178-0.23797-0.1732,0.0592,0.0433-0.0555-0.046-0.004,0.003,0.0592,0.0433-0.0555-0.046c-0.0155,0.02-0.0928,0.10392-0.18353,0.21109-0.13979,0.16347-0.32493,0.38594-0.48287,0.63007-0.15473,0.24898-0.30146,0.50285-0.30946,0.82434l0.01,0.11854c0.0443,0.32964,0.26731,0.58999,0.51115,0.70423,0.24597,0.12503,0.50527,0.15155,0.75178,0.15317,0.54579-0.002,1.05-0.15967,1.0676-0.16346,0.17927-0.0541,0.28279-0.25061,0.2273-0.43195-0.0539-0.18295-0.24544-0.28525-0.42417-0.23058l-0.0144,0.005c-0.0838,0.0249-0.493,0.13044-0.85635,0.12882-0.18515,0.002-0.35375-0.0298-0.44498-0.079-0.0944-0.0541-0.11951-0.079-0.14459-0.19432v-0.01c-0.005-0.033,0.0277-0.15155,0.10244-0.28363,0.10724-0.20299,0.28705-0.43898,0.44124-0.62301,0.0768-0.0904,0.14567-0.16996,0.20009-0.2295l0.0667-0.0806,0.0325-0.0395,0.0266-0.0412,0.0229-0.0493c0.006-0.0227,0.0198-0.0547,0.0213-0.12232,0.002-0.059-0.0198-0.16671-0.10404-0.25061-0.0827-0.0823-0.18461-0.0974-0.23903-0.0974-0.10406,0.006-0.12166,0.0244-0.13446,0.0281-0.17234,0.0742-0.25397,0.27714-0.18034,0.45142,0.0726,0.17593,0.27051,0.2582,0.44552,0.18405z'/%3E %3Cpath d='m387.36,178.44s-4.89,1.3684-5.0148,1.4577c-0.35856,0.25872,1.567-0.0412,3.0786-0.0877,0.99297-0.0281,1.7586,0.22301,1.7586,0.22301s0.58742-0.0168,1.1823-0.24737c1.8749-0.73233,5.8208-2.1992,6.1873-0.47145,0.30573,1.4409-5.45,2.7069-5.45,2.7069l-0.0502,0.56887,4.6269-1.1524,2.385-1.2531,0.76776-1.2314-2.3022-1.6406h-3.3646l-1.5548,0.43195-2.25,0.69557z'/%3E %3Cpath fill='%238f4620' d='m380.21,185.51c0.36174,1.0155,1.1791,2.4948,2.1011,2.9662,0,0,0.15579,0.0168,0.1003,0.11528-0.0576,0.10068-0.73949,0.52126-2.3012,0.1153-1.5617-0.40217-3.9477-1.0371-5.396-5.4142l0.0443,0.96454,0.85154,1.7148,1.5318,1.5843,2.4015,1.5118,1.646,0.40218,1.3915-0.35942,0.62477-0.47469-1.4342-1.2964-1.7591-2.9976c-0.001,0.001-0.071,0.41625,0.19742,1.1681z'/%3E %3C/g%3E %3C/g%3E %3Cg id='snake2' fill='%23816c2a'%3E %3Cpath fill='%23fcca3d' d='m396.5,228.99,0,0-0.0747,1.5859-0.87502-0.0866,0.15473-1.9864z'/%3E %3Cpath fill='%23fcca3d' d='m390.37,183.78,0,0-1.6167-1.8186-1.0511,0.15696,1.6006,2.2787z'/%3E %3Cpath d='m396.42,232.7c-0.003,0-0.97695-0.64138-2.2414-1.2249-1.2912-0.59378-3.1042-0.86227-3.1138-0.86607l-0.0603,0.4092s0.10991,0.0178,0.29612,0.0525c0.56075,0.10231,1.8056,0.36429,2.7099,0.7816,0.61628,0.28526,1.1663,0.5824,1.5596,0.81301,0.19581,0.11366,0.35373,0.20947,0.46257,0.27714,0.10832,0.0677,0.16594,0.10554,0.16594,0.10554l0.22143-0.34804z'/%3E %3Cpath d='m396.28,228.65c-0.002,0-0.89369-0.0644-1.8461-0.0644-0.65892,0-1.3419,0.0298-1.8082,0.14018-1.0938,0.27065-1.8072,0.8244-1.821,0.83412l0.24544,0.32964,0.0277-0.02c0.13392-0.0991,0.76245-0.52287,1.6455-0.74045,0.39217-0.0958,1.0677-0.13369,1.7106-0.12882,0.46632,0,0.92142,0.0151,1.2602,0.0298,0.33719,0.0163,0.55701,0.0346,0.55701,0.0346l0.0288-0.41462z'/%3E %3Cpath d='m395.81,225.17c-0.004,0.003-2.2575,1.0636-3.3043,1.7559-1.0345,0.6858-2.1203,1.5778-2.123,1.5794l0.25823,0.32477s0.26677-0.22084,0.66426-0.52613c0.39376-0.30852,0.91827-0.69609,1.423-1.0322,0.49568-0.32638,1.3158-0.76321,2.0024-1.1112,0.69097-0.35075,1.2517-0.61329,1.2517-0.61329l-0.17233-0.37727z'/%3E %3Cpath d='m393.64,221.59v0.006c0.001,0.0779-0.0187,0.91041-0.42257,1.5519-0.0992,0.15967-0.41777,0.54398-0.82274,1.0025-0.612,0.68903-1.4321,1.5746-2.1017,2.2869-0.6664,0.70743-1.1813,1.2434-1.1813,1.2434l0.29346,0.29175c0.002-0.003,0.91662-0.95968,1.8925-2.0049,0.48499-0.5245,0.98922-1.0766,1.4-1.5383,0.4135-0.4666,0.7288-0.84277,0.86489-1.0571,0.4786-0.77134,0.48447-1.6601,0.48661-1.776v-0.006h-0.40924z'/%3E %3Cpath d='m390.81,219.99,0.016,0.0742c0.0325,0.15155,0.095,0.52613,0.095,1.0257,0,0.5126-0.0683,1.1611-0.30572,1.8333-0.27478,0.78865-0.81579,1.9178-1.2837,2.8428-0.23584,0.46495-0.45192,0.87525-0.60987,1.1773-0.1574,0.295-0.25557,0.47308-0.25557,0.47308l0.35534,0.20622c0.004-0.006,1.599-2.9132,2.179-4.5624,0.25611-0.72532,0.3292-1.4198,0.3292-1.9703,0-0.71394-0.12111-1.1919-0.12538-1.2054l-0.39431,0.10555z'/%3E %3Cpath d='m388.07,219.66s0.017,0.16184,0.0341,0.43194c0.0192,0.27388,0.0373,0.64791,0.0373,1.062,0.002,0.76808-0.0635,1.6769-0.28918,2.3015-0.24597,0.69771-0.58262,1.6124-0.85901,2.3513-0.27424,0.73884-0.48447,1.3023-0.48447,1.3023l0.38096,0.14669s0.84993-2.2588,1.3483-3.6602c0.25184-0.71395,0.31054-1.6504,0.31214-2.4417,0-0.85249-0.0731-1.5351-0.0731-1.5383l-0.40711,0.0444z'/%3E %3Cpath d='m385.96,219.65s-0.003,0.6961-0.0464,1.5616c-0.0416,0.86548-0.12485,1.8977-0.27478,2.5392-0.31639,1.3521-0.64828,3.3013-0.64828,3.3013l0.40282,0.0709s0.0822-0.48824,0.20329-1.1394c0.12272-0.64952,0.28545-1.4706,0.44018-2.137,0.32013-1.3852,0.32919-4.1863,0.33079-4.1933l-0.40762-0.003z'/%3E %3Cpath d='m383.68,220.02s0.0293,0.25549,0.0566,0.64952c0.0283,0.39567,0.0566,0.92019,0.0566,1.4528,0,0.61163-0.0406,1.233-0.15099,1.6536-0.33241,1.2661-0.52982,3.2515-0.53141,3.2564l0.40815,0.0444c0-0.003,0.0481-0.49311,0.13819-1.141,0.0902-0.6463,0.22196-1.4512,0.38096-2.0526,0.12859-0.4877,0.16327-1.1329,0.16327-1.7608,0-1.0966-0.11258-2.1451-0.11525-2.1484l-0.40604,0.046z'/%3E %3Cpath d='m381.89,220.26s0.006,0.0806,0.006,0.23438c0,0.48769-0.0432,1.6698-0.38095,2.8856-0.22783,0.81136-0.49567,1.7694-0.71123,2.5229-0.21128,0.75349-0.36814,1.3045-0.36814,1.3045l0.39322,0.11528s0.62425-2.2046,1.0783-3.8339c0.35374-1.2698,0.39483-2.4845,0.39483-2.9944,0-0.15969-0.002-0.25062-0.002-0.25224l-0.40977,0.0178z'/%3E %3Cpath d='m379.89,220.28s0.0106,0.0904,0.0245,0.24413c0.0112,0.1613,0.0245,0.38377,0.0245,0.65277,0.002,0.76374-0.10565,1.8728-0.57946,2.7389-0.4007,0.73073-1.1541,1.4442-1.8098,1.9605-0.32653,0.26036-0.62797,0.4747-0.8457,0.62033-0.11045,0.0742-0.19902,0.12991-0.25985,0.16944l-0.0944,0.0563,0.20809,0.35941c0.0106-0.0114,2.2575-1.3337,3.1603-2.9678,0.5282-0.9678,0.62905-2.1353,0.62905-2.9365,0-0.56401-0.0512-0.94509-0.0518-0.95102l-0.40551,0.0536z'/%3E %3Cpath d='m378.66,219.89s-0.031,0.1023-0.0886,0.2755c-0.17662,0.5229-0.62104,1.6802-1.2517,2.4618-0.4167,0.51639-1.1023,1.062-1.6786,1.4642-0.28918,0.20298-0.55167,0.36915-0.74055,0.48823-0.18995,0.11854-0.30519,0.18295-0.30519,0.18457l0.20007,0.35942c0.01-0.005,1.9155-1.0896,2.8401-2.2355,0.91822-1.141,1.4118-2.8655,1.4155-2.8791l-0.39109-0.11908z'/%3E %3Cpath d='m376.71,218.91s-0.0432,0.0855-0.11419,0.22409c-0.11204,0.2111-0.29025,0.53912-0.49193,0.85255-0.20221,0.31826-0.43325,0.62461-0.62157,0.78971-0.26784,0.22896-0.7966,0.56728-1.2475,0.83246-0.45192,0.26902-0.83075,0.4747-0.83395,0.47633l0.19314,0.36591c0.002-0.003,0.38789-0.20785,0.84779-0.48337,0.46153-0.27497,0.99137-0.60842,1.3056-0.87905,0.32814-0.28526,0.64668-0.77673,0.89797-1.2054,0.25184-0.42545,0.42898-0.78811,0.42898-0.78811l-0.36441-0.18512z'/%3E %3Cpath d='m375.76,217.69s-0.12272,0.14507-0.32013,0.37133c-0.29932,0.33938-0.76513,0.8525-1.2304,1.2991-0.23263,0.22085-0.46419,0.4287-0.67013,0.58513-0.20542,0.15968-0.39323,0.26901-0.49995,0.30203l0.11472,0.39731c0.26571-0.0823,0.54686-0.28851,0.86062-0.55051,0.93104-0.79297,2.0536-2.1305,2.0558-2.1353l-0.31053-0.26902z'/%3E %3Cpath d='m375.29,216.87s-0.1131,0.092-0.29665,0.23438c-0.27371,0.2111-0.70695,0.52937-1.1408,0.78812-0.42684,0.26197-0.87718,0.4617-1.0954,0.45467h-0.0106v0.41409h0.0106c0.26411-0.003,0.54848-0.11205,0.84833-0.25874,0.89904-0.44709,1.9357-1.3094,1.9421-1.3094l-0.2577-0.32314z'/%3E %3Cpath d='m374.93,215.99c-0.002,0-0.45352,0.26197-0.97587,0.53099-0.26358,0.13369-0.54051,0.27172-0.78752,0.37782-0.24331,0.10555-0.46313,0.17646-0.56183,0.1862l0.04,0.41028c0.18994-0.02,0.41776-0.10392,0.68029-0.21434,0.77897-0.33126,1.8039-0.93318,1.8098-0.93318l-0.20488-0.35778z'/%3E %3Cpath d='m374.5,214.17-0.0427,0.046c-0.0966,0.10554-0.36174,0.37402-0.70375,0.61002-0.33987,0.24412-0.75819,0.45035-1.1376,0.45035l0.006,0.41569c0.5885-0.013,1.1215-0.33288,1.5206-0.63272,0.39749-0.30854,0.65837-0.61003,0.66212-0.61708l-0.30466-0.27227z'/%3E %3Cpath d='m374.65,211.31c-0.002,0-0.36975,0.29176-0.77524,0.67607-0.40283,0.38756-0.84197,0.84763-1.0057,1.2698,0.002,0.003-0.0571,0.0991-0.11952,0.16292l-0.0886,0.0742-0.0266,0.0163h-0.004l0.006,0.0249v-0.0249h-0.006l0.006,0.0249v-0.0249,0.41245c0.19635-0.008,0.31052-0.11692,0.40709-0.21434,0.0976-0.1088,0.16702-0.20461,0.20543-0.30366,0.0971-0.27877,0.51807-0.74857,0.90705-1.1129,0.19421-0.1862,0.38202-0.35291,0.52074-0.4682,0.13659-0.11854,0.22676-0.1862,0.22676-0.1862l-0.25397-0.3264z'/%3E %3Cpath d='m388.69,194.52s0.92142,0.005,1.503,0.005c0.13392,0,0.2497-0.002,0.33346-0.002h0.096l0.0304-0.003h0.016l0.0187-0.003,0.0315-0.008,0.0491-0.0227,0.0502-0.0476,0.0416-0.12395-0.0363-0.12071-0.0747-0.0628-0.0587-0.0227-0.031-0.002-0.017,0.41408,0.007-0.16185-0.0176,0.16185h0.0106l0.007-0.16185-0.0176,0.16185,0.0213-0.19811-0.0416,0.19432,0.0203,0.003,0.0213-0.19811-0.0416,0.19433,0.0432-0.20299-0.0747,0.1927,0.032,0.01,0.0432-0.20298-0.0747,0.19269,0.0747-0.19269-0.12058,0.16671,0.0454,0.0265,0.0747-0.1927-0.12058,0.16672-0.0464-0.0476,0.167-0.11854h-0.20381l0.0373,0.11854,0.167-0.11854h-0.20381l0.0416-0.12503,0.0811-0.0644,0.0795,0.18619-0.0229-0.20298-0.0566,0.0163,0.0795,0.18621-0.0229-0.20298,0.0144,0.13694-0.004-0.13694h-0.0106l0.0144,0.13694-0.004-0.13694h-0.4471c-0.58,0-1.4993-0.002-1.5009-0.002l-0.004,0.41462z'/%3E %3Cpath d='m388.74,193.29,0.13018,0.008c0.29026-0.002,0.58048-0.11854,0.87612-0.27552,0.44125-0.23599,0.89743-0.5786,1.3099-0.85901,0.20488-0.14019,0.40123-0.26577,0.57037-0.35128,0.16807-0.0855,0.31374-0.13209,0.4023-0.13209l-0.006-0.4157c-0.25984,0.008-0.50848,0.13045-0.77844,0.2885-0.40497,0.23708-0.8494,0.57701-1.2757,0.8525-0.42258,0.282-0.83449,0.48336-1.0991,0.47633l-0.0747-0.003-0.055,0.41136z'/%3E %3Cpath d='m388.57,191.32c0.30572-0.0412,0.62584-0.18999,0.96839-0.38269,0.51061-0.28851,1.065-0.68253,1.5718-1.0025,0.50313-0.32314,0.97854-0.55915,1.233-0.55535l-0.006-0.41571c-0.29505,0.008-0.60025,0.13857-0.9321,0.31503-0.49301,0.26902-1.0442,0.65981-1.5617,0.9911-0.5154,0.33288-1.0095,0.6035-1.3243,0.63819l0.0512,0.41192z'/%3E %3Cpath d='m387.84,189.49c0.4914-0.26198,1.2357-0.83572,2.0099-1.4344,0.77043-0.59704,1.567-1.2168,2.1011-1.5437l-0.21183-0.35454c-0.57144,0.34804-1.3654,0.97105-2.1363,1.5681-0.76722,0.59544-1.5222,1.1692-1.9501,1.3965l0.18727,0.36806z'/%3E %3Cpath d='m386.46,187.4c0.97908-0.69066,3.3747-2.4071,4.2727-2.9765l-0.21609-0.35074c-0.92089,0.58348-3.3091,2.2966-4.2892,2.9879l0.23263,0.3394z'/%3E %3Cpath d='m384.63,185.39c0.64615-0.55044,1.5612-1.1637,2.4047-1.7045,0.84673-0.54072,1.6161-1.0106,2.0013-1.2963l-0.24062-0.33451c-0.35374,0.2636-1.1317,0.73884-1.9795,1.2796-0.84832,0.54559-1.7714,1.1637-2.4469,1.7375l0.2609,0.31827z'/%3E %3Cpath d='m383.19,184.15c0-0.002,0.96358-0.70204,2.0141-1.4458,0.52502-0.37077,1.0719-0.75183,1.5281-1.0587,0.45405-0.30636,0.82968-0.54398,0.96946-0.60842l-0.16968-0.37565c-0.19902,0.0936-0.56236,0.32639-1.0254,0.63819-1.3798,0.92832-3.5545,2.5132-3.5561,2.5148l0.23957,0.33558z'/%3E %3Cpath fill='%2378732e' d='m386.48,180.09s0.0886,0.0709,0.24864,0.1992c0.55915,0.45684,1.9661,1.6688,3.2269,3.2498,1.2618,1.5811,2.3663,3.5297,2.362,5.4329,0,0.18296-0.009,0.36591-0.0299,0.54564-0.28278,2.478-1.5254,4.6577-3.2488,6.6746-2.5851,3.0236-6.245,5.6589-9.2703,8.33-1.5147,1.3337-2.8694,2.6794-3.8554,4.1023-0.98174,1.4225-1.5958,2.93-1.5958,4.557,0,0.0742,0.003,0.14832,0.005,0.22085,0.0512,1.4972,0.53623,3.1345,1.47,4.4547,0.93371,1.3202,2.3284,2.328,4.1665,2.511,0.30358,0.0314,0.6136,0.0433,0.92355,0.0433,2.3626-0.002,4.9359-0.75563,7.3912-0.75184,2.0665,0.003,4.0256,0.51259,5.7706,2.4206,1.6657,1.8203,2.1785,4.7503,2.1753,7.5696,0,2.0195-0.25771,3.9768-0.51541,5.4313-0.12805,0.72693-0.25717,1.3256-0.35375,1.7424-0.096,0.41624-0.16006,0.64951-0.16006,0.64951l0.39323,0.11258c0.003-0.0114,1.0442-3.8306,1.0442-7.9361-0.003-2.8672-0.50367-5.8913-2.2863-7.8517-1.8226-2.0033-3.9414-2.5592-6.0687-2.5522-2.5322,0-5.1114,0.75349-7.3912,0.75023-0.29932,0-0.5949-0.013-0.88301-0.0412-1.7089-0.17321-2.9932-1.0934-3.8746-2.3362-0.88087-1.2449-1.3456-2.8147-1.3947-4.2328-0.00036-0.066-0.002-0.13369-0.002-0.20408,0-2.0282,1.0132-3.8782,2.5904-5.6787,2.3679-2.7026,5.9768-5.258,9.1132-8.0906,3.1351-2.8325,5.8149-5.9576,6.2621-9.8468,0.0224-0.19756,0.0336-0.39567,0.0336-0.59324-0.005-2.3611-1.5195-4.6496-3.0119-6.3626-1.4934-1.7099-2.9831-2.8439-2.9895-2.8477l-0.24437,0.32856z'/%3E %3Cpath fill='%23a8ac71' d='m383.38,184.11,0,0-0.49086-0.42218-0.42151,0.15155,0.79499,0.64951z'/%3E %3Cpath fill='%23a8ac71' d='m384.7,185.36,0,0-0.36815-0.37888-0.19208,0.10826,0.30412,0.40053z'/%3E %3Cpath fill='%2378732e' d='m386.54,187.39,0,0-0.31479-0.40054-0.19208,0.24898,0.32013,0.36806z'/%3E %3Cpath fill='%2378732e' d='m387.92,189.45,0,0-0.22943-0.41135-0.36815,0.0649,0.4802,0.51961z'/%3E %3Cpath fill='%2378732e' d='m388.7,191.39,0,0-0.18141-0.56291-0.0534,0.0974-0.032,0.42759z'/%3E %3Cpath fill='%2378732e' d='m388.79,193.34,0,0,0.0213-0.53584-0.24543-0.15155,0.032,0.73611z'/%3E %3Cpath fill='%2378732e' d='m388.71,194.59,0,0,0.0534-0.60621-0.16006-0.10825,0.0107,0.79024z'/%3E %3Cpath fill='%2378732e' d='m372.77,213.96s0.0422-0.49798,0.18301-0.92992c0.13552-0.43356-0.39482,0.20406-0.39482,0.20406l-0.0651,0.59705,0.2769,0.12881z'/%3E %3Cpath fill='%23fff' d='m372.64,215.2-0.23476,0.10718,0.0854,0.58239,0.12859-0.18295c-0.00037-0.00054,0.0208-0.32693,0.0208-0.50664z'/%3E %3Cpath fill='%2378732e' d='m372.68,217.51,0,0-0.032-0.56832-0.17074-0.065,0,0.92555z'/%3E %3Cpath fill='%23fff' d='m372.83,218.8,0,0-0.0534-0.5142-0.18141,0.0271-0.0107,0.48714z'/%3E %3Cpath fill='%23fff' d='m373.18,220.66,0,0-0.10671-0.49796-0.11738,0.11907,0.096,0.49796z'/%3E %3Cpath fill='%23fff' d='m373.67,222.57,0,0-0.20275-0.67116-0.14939,0.0649,0.20275,0.6441z'/%3E %3Cpath fill='%23a8ac71' d='m374.91,225.13,0,0-0.27744-0.41676-0.26144-0.0433,0.33613,0.50879z'/%3E %3Cpath fill='%23a8ac71' d='m376.8,227s-0.25611-0.15155-0.62905-0.45467c-0.37135-0.30204-0.14832,0.28201-0.14832,0.28201l0.53247,0.28201,0.24491-0.10935z'/%3E %3Cpath fill='%23a8ac71' d='m389.63,227.96s-0.29878-0.20406-0.51167-0.30149c-0.21289-0.0974,0.11631,0.02,0.29826,0.4433,0.18034,0.42221,0.21341-0.14181,0.21341-0.14181z'/%3E %3Cpath fill='%23fff' d='m390.73,228.85s-0.24543-0.31178-0.40709-0.42005c-0.159-0.10555-0.10405,0.32316-0.10405,0.32316l0.3292,0.14181,0.18194-0.0449z'/%3E %3Cpath fill='%23a8ac71' d='m390.95,229.36c-0.13711-0.18296-0.28544,0.27064-0.28544,0.27064l0.39323,0.36807s0.0315-0.45197-0.10779-0.63871z'/%3E %3Cpath fill='%23a8ac71' d='m391.01,231.13s0.0859-0.37782,0.064-0.61708c-0.0213-0.23708-0.21183,0.0844-0.21183,0.0844l0.0203,0.53262h0.12752z'/%3E %3Cpath fill='%23fff' d='m390.39,233,0,0,0.14939-0.46548-0.19208,0.005-0.11738,0.48172z'/%3E %3Cpath fill='%23fff' d='m370.86,164.65s0.73468-0.15156,0.17927,0.68093c-0.55328,0.83139,0.37242-0.74478,0.37242-0.74478l-0.29773-0.0877-0.25396,0.15155z'/%3E %3C/g%3E %3Cg id='eagle2'%3E %3Cpath fill='%23f9c83a' d='m386.69,179.57,0.4471,0.45521s-0.41723-0.10879-0.59596-0.13044c-0.18088-0.0232,0.14886-0.32477,0.14886-0.32477z'/%3E %3Cpath fill='%238f4620' d='m387.13,180.03s-0.62904,0.0855-0.851,0.11854c-0.22515,0.0314,0.25505-0.24899,0.25505-0.24899l0.59597,0.13045z'/%3E %3Cpath fill='%23977c2e' d='m394.97,237.46s0.53463-0.0563,0.77363-0.38431c0.23743-0.32639-0.15206,0.51314-0.15206,0.51314l-0.34201,0.12828-0.27958-0.25711z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2800' height='1400'%3E %3Crect width='2800' height='1400' id='red' style='fill:%23cc0001'/%3E %3Crect width='2800' height='100' y='1300' id='white' style='fill:%23fff'/%3E %3Cuse transform='translate(0,-200)' id='use3035' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-400)' id='use3038' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-600)' id='use3062' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-800)' id='use3064' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-1000)' id='use3066' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-1200)' id='use3068' xlink:href='%23white'/%3E %3Crect width='1400' height='800' id='blue' style='fill:%23010066'/%3E %3Cpath d='M 576,100 C 409.85356,100 275,234.40553 275,400 C 275,565.59446 409.85356,699.99999 576,700 C 636.02725,700 691.95466,682.43566 738.92693,652.21675 C 711.57383,661.65623 682.2175,666.81914 651.65599,666.81914 C 504.3291,666.81915 384.75944,547.64674 384.75944,400.80929 C 384.75944,253.97184 504.32908,134.79944 651.65599,134.79944 C 684.21403,134.79944 715.40185,140.61419 744.2578,151.26671 C 696.21698,118.90999 638.30493,100 576,100 z' id='path4945' style='fill:%23fc0'/%3E %3Cpath d='M 914.28574,471.42858 L 814.74817,418.17806 L 844.17832,527.16068 L 777.60261,435.99589 L 756.83247,546.9551 L 736.40474,435.93234 L 669.5481,526.89131 L 699.31432,418.00001 L 599.61295,470.94319 L 673.67755,385.75059 L 560.87853,390.19195 L 664.57212,345.5715 L 561.01668,300.63137 L 673.80146,305.42069 L 600.00003,220.00001 L 699.53759,273.25053 L 670.10745,164.26791 L 736.68316,255.4327 L 757.4533,144.47349 L 777.88103,255.49624 L 844.73767,164.53728 L 814.97145,273.42858 L 914.67282,220.4854 L 840.60822,305.67799 L 953.40723,301.23664 L 849.71365,345.85709 L 953.26909,390.79722 L 840.48431,386.0079 z' transform='matrix(1.2737922,0,0,1.2422928,-89.4427,-29.478379)' id='path4959' style='fill:%23fc0'/%3E %3C/svg%3E"

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23000'/%3E %3Crect width='900' height='206.25' fill='%23fff'/%3E %3Crect width='900' height='187.5' fill='%23007168'/%3E %3Crect y='393.5' width='900' height='206.5' fill='%23fff'/%3E %3Crect y='412.5' width='900' height='187.5' fill='%23fce100'/%3E %3Cpath d='M 0,0 V 600 L 393.75,300 z' fill='%23d21034'/%3E %3Cpath d='M 189.54603,214.56867 L 128.78569,171.99623 L 69.930531,217.0706 L 91.643351,146.12847 L 30.587837,104.08263 L 104.76744,102.81043 L 125.88822,31.750306 L 150.02091,101.90617 L 224.12978,100.03443 L 164.86501,144.66535 z' transform='matrix(1.221793,2.542786e-2,-2.542786e-2,1.221793,-21.7604,145.5065)' fill='%23fce100'/%3E %3Cpath d='M 77.1122,167.913 L 118.946,167.913 C 122.312,171.689 129.822,173.229 136.975,167.868 C 150.087,160.688 175.454,167.913 175.454,167.913 L 180.449,162.606 L 168.273,122.645 L 163.902,117.962 C 163.902,117.962 154.537,112.343 136.741,114.216 C 118.946,116.089 112.702,113.592 112.702,113.592 C 112.702,113.592 97.0927,115.465 92.7219,117.65 C 92.2414,118.039 87.7268,122.645 87.7268,122.645 z' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 85.5415,157.611 C 85.5415,157.611 125.502,152.616 137.054,167.913 C 130.53,172.377 124.786,172.745 118.634,168.226 C 119.614,166.593 132.995,152.616 167.024,157.299' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='none' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 128.312,117.65 L 128,161.67 M 163.902,118.274 L 171.395,153.24 M 93.1339,117.725 L 88.9756,135.757' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 49.9417,172.706 L 59.7799,184.241 C 60.9352,184.93 61.9614,184.886 62.9876,184.241 L 77.5681,166.745 L 83.6919,159.163 C 84.6401,158.04 84.9428,156.787 84.8583,155.664 L 96.5657,145.261 C 97.5234,145.327 98.0938,145.435 99.0515,145.5 C 97.92,145.207 97.0898,144.656 97.9807,143.416 L 100.605,141.375 L 102.646,143.999 C 102.646,143.999 99.7304,147.79 99.4388,147.79 C 99.1472,147.79 96.2311,147.79 96.2311,147.79 L 90.1073,153.331 L 92.7843,155.697 L 96.8143,166.745 L 101.772,163.245 L 98.5639,151.873 L 105.563,144.291 L 102.938,140.208 L 104.688,137.875 C 104.688,137.875 128.91,153.125 138.242,149.043 C 138.494,149.134 138.806,138.167 138.806,138.167 C 138.806,138.167 113.728,135.543 113.144,130.585 C 112.561,125.628 118.685,125.045 118.685,125.045 L 116.06,121.254 L 116.644,119.212 L 121.018,124.753 L 130.933,116.296 L 189.254,182.783 C 192.438,181.492 193.118,180.713 193.337,177.534 C 193.255,177.454 136.182,111.922 136.182,111.922 L 140.556,107.257 C 141.418,106.285 141.721,105.872 141.722,104.34 L 148.429,98.5082 C 150.446,99.2011 151.732,100.41 152.803,102.007 L 171.242,86.3801 C 171.728,86.8661 173.204,87.3521 174.206,86.8055 L 204.691,57.5442 L 171.466,81.0116 L 170.3,80.1368 C 170.3,79.1647 171.505,78.9243 170.3,77.2207 C 169.009,75.6716 167.092,78.6788 166.801,78.6788 C 166.509,78.6788 161.992,77.0824 161.002,75.06 L 160.677,80.4284 L 152.22,88.3019 L 145.805,88.0103 L 136.473,97.0501 L 135.307,100.549 L 136.765,103.466 C 136.765,103.466 131.807,107.84 131.807,107.548 C 131.807,107.257 130.805,106.259 130.762,106.13 L 135.015,102.299 L 135.598,99.6747 L 134.179,97.4589 C 133.749,97.7714 128.308,103.466 128.016,102.882 C 127.53,102.338 112.27,85.0942 112.27,85.0942 L 113.144,81.8865 L 103.23,71.0969 C 99.6155,69.849 93.8982,69.6389 92.7318,77.5123 C 91.8235,79.3616 84.2751,77.8039 84.2751,77.8039 L 80.1926,78.6788 L 57.1554,111.339 L 69.9862,126.794 L 96.2311,93.5508 L 97.0102,84.1332 L 102.517,90.2905 C 104.353,90.5264 106.102,90.5471 107.766,89.7073 L 123.315,107.063 L 120.726,109.589 C 121.601,110.561 122.203,111.182 123.078,112.154 C 123.953,111.571 124.788,110.871 125.663,110.287 C 125.955,110.677 126.441,111.416 126.733,111.805 C 125.43,112.514 124.516,113.458 123.213,114.167 C 121.128,112.808 119.115,111.116 119.268,108.423 L 110.52,115.713 L 110.228,117.171 L 84.2751,138.75 L 81.9422,139.042 L 81.359,145.749 L 98.2723,131.752 L 98.2723,129.71 L 100.022,131.168 L 113.144,120.671 C 113.144,120.671 114.019,121.837 113.728,121.837 C 113.436,121.837 102.063,132.335 102.063,132.335 L 101.772,133.501 L 99.7304,135.251 L 98.5639,134.376 L 82.817,148.373 L 80.4842,148.373 L 71.7359,157.122 C 69.4795,157.318 67.5243,157.557 65.6121,158.871 z' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='%23000' fill-rule='evenodd' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E"

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 90 60'%3E %3Cpath d='M90,0H0V60z' fill='%23003580'/%3E %3Cpath d='M0,60H90V0z' fill='%23009543'/%3E %3Cpath d='M0,60 90,0' stroke='%23fff' stroke-width='20'/%3E %3Cpath d='M0,60 90,0' stroke='%23d21034' stroke-width='15'/%3E %3Cg fill='%23ffce00' transform='translate(18,16.34148)'%3E%3C!-- ty=(87*sqrt(13)-281)/2 --%3E %3Cg id='r4'%3E %3Cpath id='r' d='M0,10 1.552914,5.795555H-1.552914z'/%3E%3C!-- x2=6*sin(15deg); y2=6*cos(15deg) --%3E %3Cuse xlink:href='%23r' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(30)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(60)'/%3E %3Ccircle r='5.5' stroke='%23003580'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='450'%3E %3Ctitle%3EFlag of New Caledonia%3C/title%3E %3Crect fill='%23009543' width='900' height='450'/%3E %3Crect fill='%23ed4135' width='900' height='300'/%3E %3Crect fill='%230035ad' width='900' height='150'/%3E %3Ccircle stroke='%23000' stroke-width='5' fill='%23fae600' cx='300' cy='225' r='147.48'/%3E %3Cpath stroke='%23000' stroke-width='6' d='M275,247h50 M275,210h50 M300,78V330'/%3E %3Cpath d='M240.62,360.419 C300.811,384.999,357.228,361.929,357.228,361.929 C357.228,361.929,335.931,338.881,325.014,329.882 C314.361,321.104,283.023,321.451,272.329,329.882 C263.405,336.92,237.809,362.852,240.62,360.419Z'/%3E %3Cellipse cx='300' cy='293' rx='16.5' ry='24'/%3E %3Cellipse cx='300' cy='228.5' rx='20' ry='12.66'/%3E %3Cellipse cx='300' cy='170' rx='20' ry='20'/%3E %3Cpath d='M324,95.5 C323.994,95.4866,325.733,98.3708,322.087,104.936 C304.661,136.319,287.174,136.997,283.855,139.7 C280.197,142.678,278.653,142.474,278.653,142.474 C278.914,139.786,279.157,128.795,279.348,127.736 C281.993,113.073,304.144,113.275,321.48,98.2605 C324.188,95.915,323.994,95.4866,323.994,95.4866Z'/%3E %3Cg id='leaf'%3E %3Cpath d='m 265.5,163 c0,0 3.91436,11.22974 4.5,22.5 c0.93516,17.99657 18.18031,18.5 30,18.5 l0,-10 c-8.85851,0 -16.55267,-1.31658 -23,-14.5 c-3.18045,-6.50336 -11.5,-16.5 -11.5,-16.5z'/%3E %3Cpath d='m 265,308 c0,0 6.29638,-7.76543 13.6619,-25.97461 C282.5048,272.5249 291.6115,267 300,267 l0,-14 c-19.02757,0 -28.1503,7.0552 -29.11281,17.36332 C268.90975,291.54089 265,308 265,308z'/%3E %3C/g%3E %3Cuse xlink:href='%23leaf' transform='translate(600,0)scale(-1,1)'/%3E %3C/svg%3E"

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='700' height='600'%3E%3Crect width='700' height='600' fill='%230DB02B'/%3E%3Crect width='700' height='400' fill='%23FFF'/%3E%3Crect width='700' height='200' fill='%23e05206'/%3E%3Ccircle cx='350' cy='300' r='85' fill='%23e05206'/%3E%3C/svg%3E"

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='920' height='460'%3E %3Crect width='920' height='460' fill='%23007934'/%3E %3Crect width='360' height='460' x='280' fill='%23fff'/%3E %3Cpath fill='%23007934' d='m463.32,30.575c-0.80416,8.7038-1.61,17.412-2.4141,26.116-2.9476,0.44414-5.8944,0.88632-8.842,1.3304-0.00002,0,6.141,3.4483,7.2132,6.9121,0.1716,0.55476,0.103,1.0139-0.1454,1.3593-0.0816,0.10798-0.20658,0.22795-0.31994,0.31813-1.7789,1.3671-7.0388,0.72303-7.0388,0.72303,0-0.00002,6.968,5.8794,7.5041,8.0111,0.012,0.0499,0.028,0.0964,0.029,0.14472-0.00068,0.03992,0.008,0.1058,0,0.14452-0.008,0.03074-0.0458,0.08562-0.0582,0.11576-0.0476,0.1046-0.1334,0.2225-0.23268,0.31813-1.6382,1.5132-9.3656,1.9377-9.3656,1.9377s8.5677,6.1091,9.1038,9.5728c0.48584,3.1391,0.0784,4.9777,0,5.2925-0.59872-0.51141-14.415-12.122-23.327-8.7341-0.44388,0.2306-0.70656,0.45033-0.8144,0.66518-0.0474,0.10718-0.0574,0.24076-0.029,0.34705,0.62434,1.9313,13.227,3.9097,22.018,11.511-0.21806,1.9022-25.055-6.0507-25.973-1.0701,0.77684,1.4044,26.729,5.145,28.649,8.5317-9.5578,0.3554-29.303-2.1035-28.649,1.0412-1.9974,3.6306,18.649,1.58,27.311,4.5406,2.5391,2.869,2.294,5.2791-2.1233,5.5817-8.3488-3.9693-27.034-6.9188-27.079-1.8509,0.00044,0.006-0.00092,0.0238,0,0.0289,0.002,0.006,0.027,0.024,0.029,0.0289,0.008,0.016,0.016,0.0433,0.0292,0.0579,0.0298,0.0285,0.0962,0.0603,0.1454,0.0868,2.11,1.0525,19.51,0.53911,26.061,4.8587-9.2879,2.1008-40.782-4.2618-40.982-1.1568,0.89722,1.4502,5.8807,7.8149,14.456,7.5483,8.5749-0.26653,28.414,3.4668,29.755,6.1312,0.0418,0.0832,0.0414,0.16866,0.029,0.23138-0.58064,1.8582-26.126-5.6683-35.95-1.0412-10.182,4.7967,29.198,1.8889,35.63,7.7508,6.4314,5.8619-12.856-0.54949-12.856-0.54949,0.00002,0-26.783-3.7157-30.802-1.8509-4.0199,1.8657-8.5803,6.1312-8.5803,6.1312s2.6722,5.3166,5.3518,4.2514c0.40822-0.16248,0.68724-0.19562,0.8435-0.14452,0.004,0.002,0.0254-0.002,0.0292,0,0.004,0.002,0.0256,0.0269,0.0292,0.0289,0.006,0.004,0.0238,0.024,0.0292,0.0289,0.004,0.006,0.0244,0.0234,0.029,0.0289,0.002,0.002,0.0274,0.0257,0.0292,0.0289,0.012,0.0267,0.0246,0.083,0.029,0.11578,0.0632,0.79931-1.8324,3.1235-1.8324,3.1235s37.532,9.0411,45.839,17.034c8.3068,7.9942-47.7-12.523-47.7-12.523,0-0.00002-22.51,8.2588,1.3379,8.7919-2.6581,3.8668,1.101,6.2468,1.3379,6.3915,0,0,39.668,8.2679,43.687,14.663,4.0199,6.395-27.063-6.1386-34.03-9.6017-6.7217-3.3423-25.432,1.7676-26.497,3.3259-0.008,0.012-0.0238,0.0459-0.029,0.0579-0.002,0.006,0.002,0.0232,0,0.0289-0.002,0.012-0.00088,0.0473,0,0.0579,0.00092,0.006-0.00094,0.0238,0,0.0289,0.002,0.006-0.002,0.0238,0,0.0289,0.002,0.006,0.0266,0.0236,0.029,0.0289,0.002,0.006-0.002,0.0236,0,0.0289,0.012,0.0214,0.0414,0.0653,0.0582,0.0868,0.004,0.006,0.0242,0.0236,0.029,0.0289,1.1986,1.3133,9.5504,3.1219,9.8019,5.3793,0.00092,0.01-0.00068,0.02,0,0.0289,0.004,0.12056-0.0334,0.2632-0.0874,0.37598-1.052,2.0283-11.016,2.8911-11.431,4.8009-0.006,0.0327-0.029,0.0824-0.029,0.11578-0.00002,2.1323,50.125,12.524,63.523,23.715s-39.382-13.333-39.382-13.333,2.9477,3.995,0,5.0612c-2.9477,1.0652-13.419-14.92-30.569-5.0612-3.1236,4.0563,14.974,7.2758,19.575,7.7218-1.5711,4.0166-2.9411,5.3453,3.4903,9.3415,0.70332,0.43718,1.0982,0.7013,1.2507,0.83872,0.004,0.004,0.025,0.0248,0.0292,0.029l0.029,0.029c0.002,0.002-0.00092,0.0264,0,0.029-0.00058,0.002,0.00092,0.0276,0,0.029-0.002,0.0004-0.0256-0.00012-0.029,0-0.004-0.0002-0.0246,0.00048-0.0292,0-0.99616-0.155-12.55-6.0591-13.758-6.3048-0.012-0.002-0.0492,0.00072-0.0582,0-0.004,0.00022-0.0262-0.00054-0.029,0,0,0.53304,1.3379,6.941,1.3379,6.941-5.9372-4.7958-13.114-6.2418-19.836-1.3303-0.01,0.28412-0.0592,4.8825,6.6897,7.7219-3.8039,7.7286,4.2986,5.329,17.161,12.523-19.116-4.9679-20.647,4.2602-6.9805,6.3915s51.19,3.4668,60.033,14.923c1.8653,2.4168,2.3715,3.632,2.0069,4.02-1.4749,1.3291-15.044-8.4295-17.015-8.7919-0.004,0.002-0.025-0.004-0.0292,0-0.004,0.004-0.025,0.0244-0.0292,0.029-0.025,0.0312-0.0624,0.093-0.0874,0.1446-0.48156,1.06-0.93074,5.6685-0.93074,5.6685-5.7166-3.2901-10.962-6.2414-17.8-7.6351-0.5361,1.0652-0.42372,2.5788-0.95982,3.644-6.2053-4.4496-11.611-7.578-20.622-8.0111-0.3574,1.4215-0.71878,2.8588-1.0762,4.2803,0.00002-0.00002-7.5122-9.3259-22.251,0-8.2296,5.8665,31.089,2.1242,37.52,9.0522,6.4314,6.9271,1.338,7.9822,1.338,7.9822-5.3592-1.9537-10.696-3.8883-16.055-5.842,0,0-19.044-3.4819-24.403,0.78086-5.3592,4.2636,78.243,14.658,80.654,26.116,1.626,6.2136-19.642-6.5065-38.044-11.973-0.7118,2.0339-1.4405,4.0684-2.1523,6.1023-0.43642-0.4293-7.5548-7.3139-15.532-8.5027-0.002,0.004-0.027,0.0222-0.0292,0.029-0.00094,0.01,0.00024,0.0448,0,0.058,0.012,0.87446,1.6288,7.1145,1.6288,7.1145-0.00002,0.00002-20.613-9.6029-31.063-4.5406-10.451,5.0623,36.433,7.726,40.72,12.523,0.46888,0.52454,0.66404,0.90692,0.63988,1.1569-0.008,0.0432-0.0374,0.109-0.0582,0.1444-1.0356,1.5081-15.017-4.0618-16.404-1.3014-1.6083,3.1975-24.38-5.8533-24.112-1.5907,0.26804,4.2636,3.2285,6.6518,3.2285,6.6518-0.00002,0,47.43,4.5269,49.038,10.122,1.6074,5.5954-26.264-3.1813-26.264-3.1813s-2.6961,3.9772-0.55262,5.842c0.0838,0.0728,0.1506,0.1426,0.1744,0.1734,0.0007,0.002-0.00016,0.0274,0,0.029-0.002-0.00064-0.0254,0.00092-0.0292,0-0.96878-0.31776-16.07-10.153-14.601-2.6029-5.9093-2.3396-21.166-9.5864-19.022-3.9911,2.112,5.5131,41.905,13.363,43.076,13.593-1.0523,0.0824-17.881,1.4824-17.102,5.871-22.555-13.663-22.502-5.4696-21.989-4.8298,0.00092,0.00088-0.00094,0.0282,0,0.029-1.2671-0.1992-29.016-7.073-6.9515,4.8009,11.833,6.3674,14.717,8.8497,14.776,9.8042,0.00038,0.021,0.002,0.0672,0,0.0868-0.004,0.0254-0.0202,0.064-0.029,0.0868-0.002,0.006-0.0262,0.0236-0.0292,0.029-0.01,0.016-0.018,0.0434-0.029,0.0578-0.004,0.004-0.025,0.0244-0.0292,0.029-0.004,0.004-0.0244,0.0248-0.0292,0.029-0.004,0.004-0.024,0.025-0.029,0.029-0.006,0.004-0.0236,0.0252-0.0292,0.029-0.45872,0.2918-1.5672,0.1696-1.8906,0.1734-0.014,0.0005-0.0482-0.00092-0.0582,0-0.006,0.002-0.028,0.026-0.029,0.029l0.029,0.029c0.3148,0.46536,2.046,5.1646,1.9487,5.9866-0.002,0.014-0.0256,0.0472-0.0292,0.0578-0.002,0.004,0.002,0.0248,0,0.029-0.00092,0.002-0.0276-0.002-0.0292,0-0.002,0.00092,0.002,0.028,0,0.029-0.002,0.00052-0.027-0.00036-0.0292,0-0.002-0.00024-0.026,0.00048-0.0292,0-0.96696-0.24222-15.581-8.0078-20.593-8.5316-5.0921-0.5331-29.215,6.6534-3.4903,17.844s41.526-2.6693,55.728-1.0701c14.202,1.5983,20.914,4.0015,19.575,8.5317-1.3403,4.5293-14.528-14.85-28.388,1.9088-15.766-3.1022-26.462-4.8974-18.324,6.6229-25.747-9.5675-41.47,2.9189-9.0456,7.9822,31.862,0.93378,51.452-7.7219,51.452-7.7219,0,0.00002,5.375,9.878,13.147,2.9499,7.4065-6.6024,7.9891,1.8005,8.2603,2.6029,0.004,0.012,0.025,0.0222,0.0292,0.029,0.002,0.002-0.002,0.0278,0,0.029,0.002,0,0.026,0.0004,0.029,0,0.57222-0.143,7.475-3.2102,7.475-3.2102,0.62546,0.00002,1.2651,0,1.8906,0v63.944c8.6643,0.0888,17.309,0.1714,25.973,0.2603,0,0-8.3071-55.674-3.752-63.134,4.4136-7.2271,8.5863-6.447,8.842-6.3915,0,0,16.885,5.051,18.76,4.2514,0.0218-0.01,0.0664-0.018,0.0874-0.029,0.014-0.008,0.045-0.021,0.0582-0.029,0.0326-0.0206,0.0866-0.0628,0.1164-0.0868,0.006-0.004,0.0232-0.024,0.0292-0.029,1.3722-1.2456-0.0258-6.1609,8.5512-5.4082,2.6483-0.95788,1.6378-5.1559,3.3448-6.1891,0.0302-0.018,0.0846-0.0424,0.1164-0.0578,0.0644-0.0302,0.161-0.065,0.23268-0.0868,0.1-0.0286,0.23388-0.0462,0.34902-0.0578,2.6796-0.26652,54.392,14.376,65.646,0.52058-2.9477-7.7267-13.143-0.52682-15.823-0.2603-2.4116,0.00002-12.602-4.7958-18.498,0-5.3592-3.9962-29.726-6.6518-29.726-6.6518-3.2157-3.1975,58.149,1.5881,61.632-0.80978,7.2347-7.1946-13.392-6.389-16.608-3.9911-5.7166-3.464-12.9-3.2077-17.277-0.80976-2.0988-4.992-22.024-2.8299-33.099-4.2514-3.5452-2.0675-2.9549-3.2542-0.55262-4.5406,23.134,0.97728,46.151,3.9809,69.398,2.9499,6.2834-8.145-7.9101-11.217-16.608-4.2803-5.1061-8.3496-15.545-0.2714-22.512-1.0701-6.9666-0.79962-3.7521-9.3139,5.09-7.9822,8.843,1.3327,24.655-0.5435,27.602-4.5406,2.9467-3.9962-1.7596-8.0449-16.346-4.2514-4.9367-4.7976-15.792-0.008-20.884,1.5907-6.7739-3.7574-22.534-0.52288-27.893,0.80978-5.2466-3.2428,27.602-8.5316,27.602-8.5316,12.679-0.22304,19.831-2.4044,23.85-3.4705,19.168-10.215-0.26688-11.3-10.325-3.8754-6.2434-4.8467-12.173,0.41904-17.8,2.2848-5.2756,1.7483-15.032,3.0217-16.23,2.5161-0.014-0.006-0.0468-0.0218-0.0582-0.029-0.002-0.002-0.0262-0.0264-0.0292-0.029l-0.029-0.029c-0.00092-0.002,0.00064-0.026,0-0.029,0-0.002-0.00046-0.0256,0-0.029,0.004-0.012,0.0208-0.044,0.029-0.0578,0.79028-1.2183,15.241-10.036,15.241-10.036,0-0.00002,18.76-1.3468,22.512-1.8798,2.2862-0.32486,10.299-4.0965,10.296-5.495-0.0672-0.86806-3.4056-0.78834-13.525,1.7642-9.111,0.79958-14.462,0.28294-17.946,0.54946-5.6028-0.57596-7.9633-1.1632-8.4348-1.6774-0.018-0.0218-0.047-0.0652-0.0582-0.0868-0.0392-0.0928-0.014-0.20012,0.0582-0.28922,0.018-0.0206,0.0634-0.0664,0.0874-0.0868,1.3734-1.0907,10.238-1.8799,10.238-1.8799,0,0.00002,27.063-2.4678,28.853-3.8754,0.006-0.006,0.0234-0.0234,0.029-0.029,0.01-0.012,0.0228-0.0468,0.029-0.0578,0.002-0.006,0.0276-0.0236,0.0292-0.029,0.55686-11.002-22.959-5.9217-23.588-5.842,0.0672-7.7363-21.224-0.1136-22.221,0-0.002-0.00028-0.0278,0.00052-0.0292,0-0.91604-0.53664-1.3153-1.1029-1.3961-1.6196-0.0262-0.197-0.00092-0.41868,0.0582-0.60734,0.53332-1.5952,3.752-2.8342,3.752-2.8342,5.8953-1.4206,14.71-1.8641,17.015-3.7308,0,0,16.639-0.1456,18.615-4.5406-4.0831-11.201-35.213,1.9828-39.382,3.9911-0.8353,0-1.3468-0.20866-1.5997-0.5495-1.3688-1.9886,5.3863-8.5371,5.6135-8.763,0.002-0.002,0.0238-0.0268,0.029-0.029,1.0295-0.29038,25.884-1.5549,37.753-17.555,0.83768-9.8933-14.194,5.5817-14.194,5.5817-1.1225-12.831-16.345,0.81374-25.188,1.8799-8.8421,1.0652-9.101-4.0012-2.9377-4.8009,6.1624-0.79868,13.124-0.2758,16.608-9.6017,3.4829-9.3259,13.947,0.54304,15.823-2.921,1.8169-3.3558-3.4237-6.2163-3.752-6.3915,0.00002,0,7.7656-8.0173-4.8282-7.7508-12.467,0.26386-28.585-1.5536-28.911-1.5906,0.78186-0.29674,13.48-5.0591,25.421-4.8009,12.327,0.26652,5.6245-8.792-6.1662-8.792-11.79,0-17.946-3.9911-17.946-3.9911,6.6995-2.4867,13.399-4.9749,20.098-7.4616-0.44678-1.8648-0.89122-3.7169-1.338-5.5817,0,0,11.786-9.3326-4.8282-7.2013-16.614,2.1323-18.498,2.4004-18.498,2.4004-0.00002,0-32.705,4.9833-33.478,5.0612-0.002,0-0.026,0.00034-0.0292,0-0.31656-0.0493-3.5559-1.0501-4.1592-2.2848-0.018-0.0405-0.0456-0.1036-0.0582-0.14452-0.014-0.0493-0.0244-0.12356-0.0292-0.17346-0.004-0.0583-0.01-0.14332,0-0.20244,0.135-0.65065,1.1438-1.3542,3.723-1.9955,8.5749-2.1314,38.87-8.251,43.425-6.6518,0.58728,0.20602,1.016,0.15948,1.2798-0.0579,1.708-1.5368-3.9744-11.338-17.917-12.725-16.078-1.5983-25.973,3.9911-25.973,3.9911s-10.462-3.7435-0.8144-6.941c9.6462-3.1966,24.926,1.0701,24.926,1.0701-0.00002,0,17.14-5.07,2.9376-7.2013-14.202-2.1323-18.68,1.9171-25.188,2.1402-2.5977-3.2243,22.297-3.9855,23.85-6.6518-2.6256-4.7976-18.028,0-27.05,0-3.8374-1.6186-4.0913-4.2523,0.26178-5.8709,9.2004-0.35538,17.849,0.18184,27.05-0.17346-0.26804-4.8846,0.006-10.675-0.26176-15.559-11.67-2.1203-25.355,1.5527-31.907,1.2436,1.7526-5.3298,26.949-6.7055,29.755-8.1557,5.7892-7.1953-24.167-0.11118-24.897,0-5.3173-0.78111-4.9953-4.123-1.6288-6.1312,7.7707-0.88844,25.197,1.1323,23.879-4.1068-1.0098-4.9093-12.082-2.2808-16.637-1.2147-4.555,1.0652-11.256,0.26028-11.256,0.26028-2.917-3.905,26.27-2.3089,26.003-5.3214-0.38064-3.4587-18.501-1.0763-24.665-0.8098-4.7404-3.2522,22.286-5.4145,23.559-5.842,0.006-0.004,0.0256-0.02594,0.0292-0.02894,1.0099-8.8575-18.76,0-22.512,0-0.64484,0-1.1329-0.16008-1.4834-0.43382-0.0782-0.06328-0.167-0.1577-0.2327-0.23136-1.288-1.4941-0.1454-4.9166-0.1454-4.9166s7.0453-3.1479,7.475-3.9043c0.002-0.006,0.027-0.02316,0.0292-0.02894,0.00086-0.002-0.00062-0.02616,0-0.02894-0.00008-0.002,0.00032-0.02654,0-0.02894-0.002-0.004-0.0262-0.02456-0.0292-0.02894-0.016-0.02236-0.0552-0.06068-0.0874-0.08682-0.82702-0.63325-5.673-2.2317-6.3115-2.2848-0.004-0.00022-0.025,0-0.0292,0-0.004-0.0015-0.0252-0.02674-0.029-0.02894-0.008-0.006-0.0222-0.02036-0.0292-0.02894-0.004-0.004-0.0258-0.02336-0.0292-0.02894-0.365-0.74486,0.0874-6.0445,0.0874-6.0445s5.5825-4.1597,5.9335-5.8131c0.002-0.014-0.002-0.04452,0-0.05788,0.002-0.014-0.00068-0.04512,0-0.05788,0.0003-0.012,0.0005-0.0455,0-0.05788-0.00088-0.012,0.002-0.0461,0-0.05788-0.00092-0.006,0.00092-0.02336,0-0.02894-0.004-0.016-0.0228-0.04232-0.0292-0.05788-0.002-0.006,0.002-0.02376,0-0.02894-0.002-0.004-0.0264-0.02396-0.0292-0.02894-0.006-0.01-0.0226-0.02-0.0292-0.02894-0.01-0.014-0.018-0.0455-0.029-0.05788-0.004-0.004-0.0246-0.02496-0.0292-0.02894-0.0224-0.018-0.0604-0.04152-0.0874-0.05788-0.012-0.006-0.0464-0.02296-0.0582-0.02894-1.4099-0.67313-7.2423,1.3304-7.2423,1.3304-0.00002-1.7763,0-3.5451,0-5.3215-0.00002,0,5.1065-0.55195,5.6426-2.9499,0.0314-0.14052,0.016-0.27865,0-0.4049-0.008-0.0501-0.014-0.12556-0.0292-0.17346-0.0332-0.103-0.0834-0.22493-0.1456-0.31813-0.01-0.014-0.0476-0.04392-0.0582-0.05788-1.1684-1.4997-5.9335-1.7063-5.9335-1.7063-0.89348-9.3256-1.7823-18.641-2.6759-27.966zm-4.77,91.332,0,3.673c0.00002,0-6.0093-0.30606-7.126-1.2436-0.006-0.004-0.0244-0.0244-0.0292-0.0289-0.004-0.004-0.0246-0.0242-0.0292-0.0289-0.004-0.004-0.025-0.0242-0.0292-0.0289-0.004-0.004-0.0254-0.0242-0.0292-0.0289-0.01-0.014-0.0216-0.0431-0.0292-0.0579-0.002-0.004,0.002-0.024,0-0.0289-0.002-0.004-0.0276-0.024-0.029-0.0289-0.00092-0.004,0.00088-0.024,0-0.0289-0.00092-0.01,0.0001-0.0475,0-0.0579,0.00022-0.006-0.0005-0.0238,0-0.0289,0.0008-0.006-0.00092-0.0236,0-0.0289,0.006-0.0214,0.018-0.0649,0.029-0.0868,0.002-0.006,0.026-0.0234,0.0292-0.0289,0.014-0.0224,0.0392-0.0641,0.0582-0.0868,0.006-0.006,0.0236-0.0232,0.0292-0.0289,0.012-0.012,0.0454-0.0461,0.0582-0.0579,0.0402-0.0353,0.0928-0.079,0.1454-0.11578,2.0161-1.4035,6.0415-1.3704,6.8351-1.5906,0.006-0.002,0.023,0.002,0.0292,0,0.006-0.002,0.024-0.0267,0.029-0.0289,0.004-0.002,0.0254,0.002,0.0292,0,0.004-0.002,0.0262-0.0265,0.0292-0.0289zm8.5221,4.8876c0.20764,0,11.97,0.1006,13.001,1.6196,0.008,0.012,0.0226,0.0447,0.0292,0.0579,0.008,0.02,0.0242,0.0665,0.0292,0.0868,0.002,0.014-0.00072,0.0439,0,0.0579-0.00014,0.021,0.004,0.0655,0,0.0868-0.006,0.0216-0.02,0.0647-0.0292,0.0868-0.89816,1.8972-12.798,3.0367-12.798,3.0367l-0.23268-5.0322zm-0.66898,7.2591c0.004,0.002,0.0248-0.002,0.029,0,0.004,0.002,0.0232-0.002,0.0292,0,0.69832,0.18344,5.5701,0.34048,6.1662,1.1568,0.006,0.008,0.0246,0.0212,0.0292,0.0289,0.002,0.004-0.002,0.025,0,0.0289,0.004,0.008,0.0264,0.0208,0.0292,0.0289,0.00092,0.004-0.00086,0.025,0,0.0289,0.00044,0.004-0.00026,0.0248,0,0.0289,0.00002,0.004,0.00016,0.0247,0,0.0289-0.0004,0.004,0.00058,0.0246,0,0.0289-0.0008,0.004,0.00092,0.0246,0,0.0289-0.002,0.004-0.0276,0.0244-0.0292,0.0289-0.002,0.004,0.002,0.0244,0,0.0289-0.008,0.014-0.02,0.0439-0.0292,0.0579-0.004,0.004-0.0256,0.0242-0.0292,0.0289-0.004,0.004,0.004,0.0242,0,0.0289-1.0099,1.2272-5.5056,1.5618-5.7299,1.5618-0.002-0.0004-0.0274,0.00074-0.0292,0-0.002-0.00092,0.002-0.0275,0-0.0289-0.004-0.006-0.0254-0.0226-0.029-0.0289-0.20552-0.4149-0.40722-3.0656-0.40722-3.0656zm-35.863,9.6596c3.8405-0.1984,11.462,0.70093,25.77,4.6274,0,0.30278,0.28972,3.9918,0.1744,4.5984-0.00092,0.004-0.0278,0.0246-0.0292,0.0289-0.00092,0.004,0.00094,0.0261,0,0.0289-0.002,0.002-0.0258,0.0285-0.0292,0.0289-0.2243-0.11198-26.031-7.4859-28.388-7.3748-0.0644,0.002-0.1424,0.006-0.2036,0-0.052-0.006-0.1256-0.018-0.1744-0.0289-0.0642-0.016-0.1472-0.0611-0.20358-0.0868-0.0208-0.01-0.0678-0.018-0.0874-0.0289-0.006-0.004-0.0228-0.025-0.0292-0.0289-0.0784-0.0529-0.1562-0.13314-0.20358-0.20244-0.004-0.006-0.0258-0.0234-0.0292-0.0289-0.006-0.012-0.0238-0.0465-0.029-0.0579-0.002-0.006,0.002-0.023,0-0.0289-0.004-0.012-0.0264-0.0459-0.0292-0.0579-0.00092-0.006,0.00092-0.0228,0-0.0289-0.00092-0.012,0.0003-0.0453,0-0.0579,0.00024-0.012-0.00092-0.0451,0-0.0579,0.004-0.0321,0.018-0.0828,0.0292-0.11578,0.0318-0.079,0.097-0.18084,0.1744-0.26028,0.39462-0.38378,1.3829-0.76932,3.2867-0.86764zm13.379,10.903c4.1136-0.14672,13.969,2.211,14.514,2.0823-0.00002,0.78143,0.4361,4.475-0.0582,5.2347-0.004,0.006-0.0242,0.023-0.0292,0.0289-0.004,0.006-0.024,0.024-0.0292,0.0289-0.006,0.004-0.0238,0.0251-0.0292,0.0289-0.01,0.006-0.0466,0.0244-0.0582,0.0289-0.006,0.002-0.0228-0.00092-0.0292,0-0.012,0.00092-0.045,0.00092-0.0582,0-0.006-0.00092-0.022,0.002-0.0292,0-0.83768-0.20822-15.382-4.8016-15.939-6.6807-0.008-0.0309-0.00066-0.0862,0-0.11578,0.006-0.0655,0.038-0.14552,0.0874-0.20244,0.006-0.006,0.0224-0.023,0.0292-0.0289,0.006-0.006,0.022-0.023,0.0292-0.0289,0.27922-0.22006,0.85536-0.34943,1.5997-0.37597zm40.487,10.122c3.9283-0.0764,6.7017,0.25803,5.6717,1.446-2.8052,3.2354-22.192,5.8999-22.192,5.8999l-0.34902-5.8999c0.41636-0.0609,10.267-1.3177,16.87-1.446zm-55.495,18.394c3.2967-0.17446,10.974,1.6257,28.068,8.8209l0.1164,4.2514c0.00002,0-28.948-8.73-29.958-10.18-0.49704-0.71379-1.421-2.7229,1.7742-2.8921zm56.717,6.3337c0.88072-0.0445,1.5006,0.0441,1.716,0.26028,0.006,0.006,0.0244,0.0228,0.029,0.0289,0.012,0.02,0.0222,0.0657,0.0292,0.0868,0.004,0.0218,0.0296,0.0631,0.0292,0.0868-0.012,0.12196-0.104,0.28623-0.26178,0.46274-2.6936,3.0133-17.161,6.0155-17.161,6.0155s-0.00002-3.7923,0-3.9043c0.002,0.0002,0.026-0.00004,0.0292,0,0.65948-0.0224,11.279-2.8188,15.59-3.0367zm-63.465,0.52057c4.3217-0.22785,14.08,2.0514,35.95,12.349-0.00002,0.1068,0.1948,3.6583,0.1162,3.9911-0.002-0.00042-0.0262,0.00082-0.0292,0-1.2966-0.41556-39.353-13.708-39.353-13.708-0.0406-0.14572-0.61308-2.4246,3.3158-2.6318zm72.452,16.63c1.1059-0.0462,1.8315,0.049,2.0069,0.2892,0.016,0.0278,0.027,0.0836,0.0292,0.1158-0.004,0.1156-0.1006,0.26294-0.29088,0.4338-3.451,3.099-25.453,6.8535-26.235,6.9121-0.004,0-0.0258,0.00044-0.0292,0-0.002-0.00092-0.026,0.002-0.029,0-0.002-0.002-0.0264-0.0262-0.0292-0.029-0.008-0.01-0.023-0.0438-0.0292-0.0578-0.002-0.006,0.002-0.0236,0-0.029-0.004-0.012-0.0262-0.0448-0.0292-0.0578-0.1398-0.7183,0.31564-3.2338,0.34902-3.5862,0.00032-0.006,0-0.0254,0-0.029,0.00092,0.00092,0.027-0.00092,0.0292,0,0.004,0.00068,0.0242,0.0286,0.029,0.029,0.006,0.00028,0.0226-0.00008,0.0292,0,1.4083-0.0234,18.27-3.7446,24.199-3.9911zm-64.686,9.6885c6.5501-0.33646,26.397,8.7127,27.37,8.9944,0.002,0.0005,0.0272-0.00006,0.0292,0-0.102,0.40426-0.1188,3.6714-0.20358,4.1935-0.002,0.014,0.002,0.0502,0,0.0578-0.0008,0.002-0.0284-0.0009-0.0292,0-0.53504-0.28494-27.736-11.51-28.94-10.614-0.75036-1.7681,0.0276-2.5421,1.7742-2.6318zm58.52,2.3715c1.3629-0.0596,2.3605,0.00064,2.6759,0.1734,0.0382,0.024,0.0732,0.0576,0.0874,0.0868,0.002,0.004-0.00092,0.0238,0,0.029,0.00024,0.006,0.00048,0.0236,0,0.029-0.002,0.012,0.006,0.0462,0,0.0578-0.004,0.006-0.0248,0.0228-0.0292,0.029-0.02,0.0254-0.0556,0.0588-0.0874,0.0868-2.0197,1.7852-20.767,5.466-20.767,5.466s-0.0874-3.4536-0.0874-3.7886c0.53248-0.1132,12.635-1.9246,18.208-2.1691zm-1.5125,11.944c1.3191-0.0436,2.2543,0.0312,2.4723,0.26028l0.029,0.029c0.006,0.01-0.002,0.0472,0,0.0578,0.0009,0.006,0.0288,0.0234,0.0292,0.029-0.00028,0.006-0.0282,0.0232-0.0292,0.029-0.002,0.012,0.006,0.0452,0,0.0578-0.004,0.006-0.0252,0.0224-0.029,0.029-0.016,0.0262-0.0348,0.0596-0.0582,0.0868-0.018,0.0206-0.064,0.0658-0.0874,0.0868-2.0235,1.7366-17.917,5.0611-17.917,5.0611s-0.43628-3.7923-0.43628-3.9043c0.44088,0.01,11.067-1.6583,16.026-1.822zm-67.071,0.95438c3.8347-0.24108,13.337,1.3301,36.793,9.8042l0.78532,4.5695c0,0.00002-39.055-12.536-40.167-12.928,0.002,0-0.00084-0.0258,0-0.029,0.00092-0.0242-0.006-0.0828,0-0.1448,0.014-0.1148,0.0724-0.2955,0.20358-0.46276,0.27524-0.33548,0.90404-0.71664,2.385-0.80976zm51.452,9.9199c0.47064,0.1,7.0193,0.31614,8.2312,1.3304,0.006,0.004,0.0238,0.0242,0.0292,0.029,0.004,0.004,0.0242,0.024,0.0292,0.029,0.004,0.004,0.025,0.024,0.0292,0.029,0.012,0.016,0.02,0.0426,0.0292,0.0578,0.002,0.006,0.0264,0.0238,0.029,0.029,0.01,0.021,0.0238,0.0652,0.0292,0.0868,0.00092,0.006-0.00082,0.0234,0,0.029,0.00054,0.006-0.00024,0.0234,0,0.029-0.00004,0.012,0.00092,0.0466,0,0.0578-0.0009,0.006,0.00092,0.0232,0,0.029-0.002,0.012-0.025,0.046-0.0292,0.0578-0.002,0.006,0.002,0.023,0,0.029-0.006,0.012-0.0218,0.0458-0.029,0.0578-1.0099,1.5622-7.8531,2.1402-7.8531,2.1402s-0.33622-3.0612-0.49446-4.02zm15.852,8.9076c1.5249-0.0364,2.6194,0.1372,2.8504,0.5784,0.13,0.29904-0.1202,0.74078-0.84346,1.3304-5.6105,4.5746-17.83,5.466-17.83,5.466v-5.0322c0.002,0.00024,0.0234,0.00038,0.0292,0,0.69412-0.082,10.731-2.2219,15.794-2.3426zm15.561,4.6852c1.9368-0.073,2.7713,0.24986,3.0249,0.6941,0.0204,0.0394,0.0464,0.1032,0.0582,0.1448,0.018,0.0752,0.0354,0.18,0.0292,0.26032-0.0624,0.57318-0.68666,1.26-1.1634,1.7063-1.908,1.7852-32.314,11.366-32.314,11.366s-0.22894-6.355-0.1164-6.9121c17.777-5.357,26.472-7.1081,30.482-7.2591zm-19.662,17.989c1.9331-0.0716,3.4447,0.042,3.8975,0.49162,0.0278,0.0298,0.0688,0.0828,0.0874,0.1158,0.01,0.0202,0.0224,0.0654,0.029,0.0868,0.006,0.0216-0.002,0.064,0,0.0868,0.00094,0.0386,0.01,0.1026,0,0.1448-0.022,0.0852-0.0806,0.19-0.1456,0.28922-2.6014,2.5386-15.241,2.921-15.241,2.921v-3.1524c2.3735-0.0796,7.6569-0.84556,11.372-0.9833zm12.652,5.1768c0.60092-0.014,0.96738,0.083,1.018,0.2603,0.002,0.014,0.002,0.043,0,0.0578-0.0304,0.1476-0.20694,0.37124-0.58172,0.63624-5.0493,3.5695-24.025,7.2302-24.025,7.2302s0.23512-2.4946,0.34902-3.0945c0.5278-0.008,18.699-4.9795,23.239-5.0901zm10.645,3.9622c2.236-0.021,3.9426,0.30708,4.9155,1.0122,0.002,0,0.0274-0.00048,0.0292,0,0.00072,0.002-0.00054,0.0258,0,0.029,0.00034,0.004-0.00016,0.025,0,0.029-0.00046,0.01,0.00092,0.0464,0,0.0578-0.0952,0.69158-1.5167,3.945-6.5152,5.3504-6.2343-0.5537-32.693,7.2241-33.216,7.3459-0.002-0.002-0.0278,0.002-0.029,0-0.002-0.01,0.00092-0.0434,0-0.0578-0.014-0.49822,0.34904-3.1813,0.34902-3.1813,9.1205-5.4234,25.695-10.503,34.466-10.585zm-67.74,15.27c0.0584-0.00092,0.1124-0.0002,0.1744,0,11.445,1.2272,15.72,5.4873,16.928,7.2013-2.2821,3.982-20.37-4.9484-18.469-6.8542,0.21758-0.1932,0.6654-0.33254,1.367-0.34706zm65.588,0.75196c0.45456-0.018,0.8697,0.0752,1.1634,0.26028,0.12,0.0798,0.2384,0.1944,0.31996,0.31812,0.1102,0.1776,0.1836,0.41798,0.2036,0.6941-1.1956,1.837-7.3791,1.0351-7.7659,0.9833,0.3115-0.1104,3.8818-2.1726,6.0789-2.2558zm-24.519,12.378c0.84862-0.0348,1.5537,0.0504,1.9487,0.28918,0.0478,0.0308,0.1076,0.0794,0.1454,0.1158,0.012,0.012,0.0474,0.0446,0.0582,0.0578,0.016,0.02,0.0454,0.0652,0.0582,0.0868,0.012,0.022,0.02,0.0632,0.0292,0.0868,0.072,0.21614,0.044,0.51458-0.1454,0.86762-1.7954,3.3474-9.6564,2.1112-9.6564,2.1112v-2.3426c0.002,0.00066,0.0272-0.00054,0.029,0,0.44278,0.0374,4.7752-1.1598,7.5332-1.2725zm-46.304,8.8209c2.4185-0.1214,4.5324,1.4562,6.7479,2.7185,4.9367-1.0041,15.066,0.78088,15.066,0.78088v4.4538c0,0.004-0.0228,0.0258-0.0292,0.029-0.004,0.002-0.023-0.002-0.029,0-0.92204,0.1596-12.793-0.3561-15.444-2.0244-2.1624,0-8.284-3.2125-8.7548-4.8587-0.004-0.014-0.0262-0.0442-0.0292-0.0578-0.004-0.0204,0.002-0.0668,0-0.0868-0.00066-0.014-0.00026-0.045,0-0.058,0.00068-0.012-0.002-0.0456,0-0.0578,0.00092-0.006-0.00094-0.0228,0-0.029,0.002-0.012,0.0252-0.0462,0.0292-0.0578,0.002-0.006-0.002-0.0232,0-0.029,0.84598-0.44826,1.6703-0.68424,2.4432-0.72302zm51.918,2.198c1.8569-0.0994,2.6442,0.47132,1.1925,2.5161-4.0394,5.6898-14.485,3.3548-14.485,3.3548l-0.43628-3.5284c3.6843,0.143,10.418-2.1652,13.728-2.3426zm-39.033,11.539c4.2236-0.1958,8.8129,1.475,8.8129,1.475,0.1082,0.21432,2.27,4.4517,0.34904,5.8709-0.0714,0.0512-0.1498,0.1014-0.23268,0.1446-2.3567,1.2272-13.62-0.95902-14.281-5.466,1.3254-1.3911,3.289-1.9289,5.3517-2.0245zm-43.541,2.198c3.8627-0.23048,8.1774,2.1356,8.6675,2.3715,0.006,0.002,0.0254-0.00092,0.029,0,0,0.1334-0.1454,4.2803-0.1454,4.2803s-7.6465-2.1195-10.064-6.3915c0.48468-0.1314,1.0023-0.22986,1.5125-0.2603zm73.558,0.57842c4.3081-0.0272,9.5129,0.97916,10.267,2.4294,0.1426,0.2966,0.1002,0.62358-0.1744,0.9544-2.1323,2.5654-14.252,0.23136-14.252,0.23136v-3.1234c1.0783-0.31364,2.5636-0.4816,4.1592-0.49168z'/%3E %3C/svg%3E"

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' width='2400' height='1200'%3E %3Crect width='6' height='3' fill='%23008751'/%3E %3Crect x='2' width='2' height='3' fill='%23FFF'/%3E %3C/svg%3E"

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='600'%3E %3Cdefs%3E %3ClinearGradient id='cap1' gradientUnits='userSpaceOnUse' x1='498.738' y1='289.055' x2='500.626' y2='283.42'%3E %3Cstop stop-color='%23510000' offset='0'/%3E %3Cstop stop-color='%238a0000' offset='0.3'/%3E %3Cstop stop-color='%23a00' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='cap2' gradientUnits='userSpaceOnUse' x1='501.444' y1='291.373' x2='502.927' y2='287.449'%3E %3Cstop stop-color='%23ff2a2a' offset='0'/%3E %3Cstop stop-color='%23f00' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='mountain' gradientUnits='userSpaceOnUse' x1='484.764' y1='311.709' x2='484.764' y2='317.647'%3E %3Cstop stop-color='%23F5F549' offset='0'/%3E %3Cstop stop-color='%2397C924' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='seafgrad'%3E %3Cstop stop-color='%23025' offset='0'/%3E %3Cstop stop-color='%2304a' offset='0.5'/%3E %3Cstop stop-color='%23025' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='seabgrad' xlink:href='%23seafgrad' gradientUnits='userSpaceOnUse' x1='444.509' y1='317.486' x2='634.411' y2='317.486'/%3E %3CclipPath id='shield'%3E %3Cpath fill='%23000' d='m500,226.375 -63.7015,110.332h127.401z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1000' height='600' fill='%230067C6'/%3E %3Crect width='1000' height='200' y='200' fill='%23fff'/%3E %3Cg id='text' fill='%23c8a400'%3E %3Cpath d='m410,299.329c3.32634,0.22223,6.65268,0.44445,9.97902,0.66668,0.0329-0.48587,0.064-0.97205,0.0981-1.45773-1.30824-0.0873-2.61644-0.17511-3.92471-0.26198,0.0986-1.60327,0.23297-3.20473,0.3036-4.80942,1.38833-1.00412,2.77759-2.00697,4.16149-3.01719,0.0412-0.61599,0.0823-1.23197,0.12346-1.84796-1.46281,1.06196-2.92562,2.12393-4.38843,3.18589-0.14757-1.03794-0.72165-2.10727-1.76463-2.46788-0.91323-0.33059-2.03168-0.3884-2.82311,0.26424-1.00326,0.738-1.18359,2.05857-1.31388,3.20783-0.17463,2.17695-0.29658,4.35998-0.45091,6.53752zm1.51943-1.36222c0.12006-1.63759,0.19451-3.27916,0.35147-4.91355,0.12284-0.80837,0.27116-1.7421,0.97877-2.25692,0.63951-0.42451,1.58455-0.10865,1.84624,0.61403,0.52201,1.24667,0.29033,2.62159,0.22338,3.93021-0.0632,0.94689-0.12655,1.89378-0.18977,2.84068-1.06985-0.0707-2.14151-0.14232-3.21009-0.21445z'/%3E %3Cpath d='m411.299,284.006c3.24602,0.75791,6.49205,1.51582,9.73807,2.27373,0.73769-3.1594,1.47537-6.31879,2.21306-9.47819-0.4612-0.10769-0.92241-0.21537-1.38361-0.32306-0.62753,2.68761-1.25507,5.37521-1.8826,8.06282-0.98811-0.2308-1.97626-0.4614-2.96437-0.69221,0.56551-2.42194,1.13101-4.84387,1.69651-7.26581-0.45886-0.10714-0.91773-0.21428-1.37659-0.32142-0.5655,2.42194-1.13099,4.84388-1.69649,7.26582-0.87427-0.20424-1.7486-0.40821-2.62286-0.61249,0.60401-2.58683,1.208-5.17367,1.812-7.7605-0.46355-0.10824-0.92711-0.21647-1.39066-0.32471-0.71415,3.05867-1.42831,6.11735-2.14246,9.17602z'/%3E %3Cpath d='m414.807,270.929c3.14837,1.09493,6.29675,2.18986,9.44512,3.28479,0.15992-0.45982,0.31983-0.91964,0.47975-1.37946-1.2384-0.4307-2.47682-0.86135-3.71521-1.29209,0.48491-1.42877,1.01619-2.8425,1.46212-4.28396,0.31982-1.1769,0.56684-2.55272-0.12567-3.64707-0.56233-0.80874-1.56218-1.32766-2.54938-1.29642-1.08858,0.0466-1.97544,0.84759-2.45833,1.77548-0.71429,1.34208-1.11369,2.81798-1.63458,4.23987-0.30127,0.86629-0.60255,1.73257-0.90382,2.59886zm1.82516-0.91156c0.50573-1.41719,0.96234-2.85276,1.50949-4.25451,0.34032-0.74874,0.75526-1.63711,1.61685-1.87541,0.70884-0.16219,1.45167,0.38249,1.5132,1.10855,0.17309,1.3358-0.4107,2.59669-0.82087,3.83664-0.25986,0.74722-0.51973,1.49444-0.77958,2.24166-1.01301-0.35237-2.02604-0.70467-3.03909-1.05693z'/%3E %3Cpath d='m420.024,258.833c1.78079,1.03286,3.54652,2.09256,5.33751,3.10726,1.01015,0.54316,2.29139,0.85386,3.34732,0.24536,1.44062-0.79757,2.34305-2.27069,3.05103-3.70714,0.55788-1.21033,0.96223-2.71397,0.25161-3.95061-0.76525-1.23498-2.15613-1.80264-3.34366-2.54015-1.15241-0.67405-2.30482-1.34811-3.45723-2.02216-0.2446,0.4182-0.4892,0.83639-0.7338,1.25459,1.69411,0.99759,3.40038,1.97522,5.08648,2.98594,0.80638,0.49107,1.47446,1.38051,1.33556,2.36857-0.15909,1.178-0.83235,2.21182-1.50327,3.1639-0.5532,0.77126-1.48261,1.39382-2.46901,1.18523-1.02907-0.19727-1.86511-0.87054-2.7694-1.35707-1.13311-0.66277-2.26623-1.32553-3.39934-1.9883-0.24459,0.41819-0.48923,0.83643-0.7338,1.25458z'/%3E %3Cpath d='m427.227,247.062c2.64728,2.02559,5.29456,4.05117,7.94184,6.07676,1.2324-1.60897,2.45998-3.22252,3.70139-4.82374,0.71204-1.0218,1.36783-2.35063,0.88541-3.60415-0.43852-0.99742-1.46605-1.76954-2.56718-1.82076-0.49731-0.0682-1.14581,0.30822-1.41493,0.47419,0.28305-1.06581-0.58942-2.0679-1.57186-2.35041-1.18182-0.42013-2.38052,0.33763-3.16221,1.17835-0.9204,1.00107-1.68892,2.12852-2.53072,3.19463-0.42725,0.55838-0.85449,1.11675-1.28174,1.67513zm2.01433-0.29772c0.92943-1.19063,1.80918-2.42176,2.78303-3.57628,0.45282-0.50395,1.17935-1.07479,1.88161-0.70532,0.64009,0.27772,0.79787,1.08511,0.49233,1.66627-0.48521,1.03983-1.28618,1.88276-1.95401,2.80542-0.36367,0.47529-0.72737,0.95057-1.09102,1.42588-0.70398-0.53866-1.40796-1.07732-2.11194-1.61597zm3.23588,2.47597c0.96434-1.2336,1.87255-2.51286,2.89009-3.70336,0.51954-0.54354,1.17239-1.22856,1.99705-1.07233,0.70444,0.16212,1.21664,0.92689,0.97341,1.63628-0.39626,1.30911-1.37599,2.31142-2.16426,3.39599-0.4137,0.54068-0.82742,1.08134-1.2411,1.62203-0.81839-0.62621-1.6368-1.2524-2.45519-1.87861z'/%3E %3Cpath d='m436.231,236.455,6.8675,7.26894,5.88255-5.55767-0.97575-1.03279-4.70554,4.44565-0.12052,0.11387-0.0869-0.092-5.80486-6.14418z'/%3E %3Cpath d='m445.035,228.752,6.09535,7.92761,1.18915-0.91429-6.09535-7.92762z'/%3E %3Cpath d='m453.991,222.67c-0.98774,0.61544-1.78425,1.33504-2.39782,2.17554-0.6112,0.83726-0.94122,1.71049-0.98884,2.62241-0.0476,0.91165,0.19536,1.79452,0.73286,2.6572,0.49251,0.79046,1.15266,1.40385,1.97619,1.84418,0.82023,0.43856,1.70565,0.60098,2.67598,0.49235,0.96511-0.10804,2.05508-0.53501,3.26884-1.29126,1.16547-0.72616,1.99135-1.56229,2.50028-2.52478,0.48822-0.92337,0.62578-1.90365,0.41645-2.94732l-1.38296,0.5422c0.36225,1.99857-0.92658,2.9588-2.36991,3.87479-2.2587,1.37399-4.45973,1.27451-5.80828-0.78982-1.39827-2.32778,0.12974-4.25089,2.05166-5.49964,1.36386-0.85119,2.70794-1.43321,3.98724-0.61857l1.08262-0.9642c-0.74564-0.51452-1.59209-0.75257-2.55559-0.6994-1.01162,0.0558-2.06822,0.42819-3.18872,1.12632z'/%3E %3Cpath d='m465.808,216.773-1.047,11.2056,1.55741-0.62791,0.31478-3.47417,0.006-0.003,5.05831-2.03938,2.63645,2.28431,1.5574-0.62791-8.52648-7.34584-1.5574,0.62791zm1.36835,1.14857,3.32461,2.87791-3.72338,1.50118,0.39877-4.37909z'/%3E %3Cpath d='m487.726,210.591c0.20805,3.32683,0.41609,6.65367,0.62414,9.9805,1.80444-0.12174,3.6118-0.20647,5.41405-0.35597,1.4176-0.16233,2.93884-0.53067,3.9077-1.65878,1.2513-1.3881,1.42875-3.46194,0.88129-5.18861-0.4596-1.52076-1.82744-2.6711-3.37555-2.9629-1.52435-0.29289-3.07841-0.0617-4.61381,0.008-0.94594,0.0591-1.89188,0.11841-2.83782,0.1774zm1.5393,1.32733c1.43646-0.0757,2.87074-0.21585,4.30969-0.22392,0.81646-0.0241,1.62864,0.21461,2.28786,0.70072,1.00072,0.68405,1.58799,1.91553,1.45667,3.12503-0.0712,1.38985-1.09329,2.66855-2.44413,3.02043-0.77283,0.19999-1.57593,0.25601-2.36712,0.34365-0.93214,0.0583-1.86428,0.11665-2.79643,0.17483-0.14939-2.38021-0.29825-4.76046-0.44654-7.14074z'/%3E %3Cpath d='m501.664,210c-0.19023,3.3279-0.38046,6.6558-0.57069,9.9837,3.23909,0.18516,6.47818,0.37031,9.71727,0.55547,0.027-0.47284,0.0541-0.94567,0.0811-1.41851-2.75541-0.1572-5.51074-0.31562-8.26619-0.47205,0.0573-1.01308,0.11603-2.02606,0.17328-3.03914,2.48308,0.14086,4.96605,0.28372,7.44909,0.42535,0.0269-0.47043,0.0538-0.94086,0.0807-1.41129-2.48304-0.14163-4.966-0.28449-7.44908-0.42535,0.0507-0.89637,0.10241-1.79268,0.15347-2.68903,2.65213,0.15053,5.30416,0.30305,7.95625,0.45434,0.0272-0.47524,0.0543-0.95049,0.0815-1.42573-3.13557-0.17925-6.27113-0.35851-9.4067-0.53776z'/%3E %3Cpath d='m527.774,214.166-3.61612,9.3233,1.28604,0.4988,2.86698-7.3919,0.14904-0.38427,0.15998,0.42657,3.44815,9.91881,1.68397,0.65315,3.61613-9.3233-1.28934-0.50007-2.86569,7.38853-0.1464,0.37752-0.158-0.42191-3.45405-9.91335z'/%3E %3Cpath d='m541.208,219.937-4.54582,8.90705-1.33607-0.68187,4.54582-8.90705z'/%3E %3Cpath d='m548.751,224.356c-0.97142-0.64089-1.95772-1.06453-2.97756-1.27147-1.01591-0.20614-1.9472-0.14174-2.79583,0.19546-0.84836,0.3371-1.54936,0.92626-2.1091,1.77467-0.51289,0.77738-0.79492,1.63325-0.85151,2.56539-0.0563,0.92841,0.16547,1.80086,0.66904,2.63737,0.50084,0.83202,1.34364,1.64445,2.53733,2.432,1.14619,0.75621,2.25064,1.15792,3.33769,1.21888,1.04287,0.0584,1.99114-0.22553,2.85229-0.85122l-1.06975-1.03062c-1.66517,1.16306-3.07555,0.39239-4.5102-0.53714-2.19107-1.47947-3.01898-3.52128-1.70555-5.60813,1.53212-2.24195,3.91737-1.65565,5.8541-0.43,1.3426,0.88435,2.43232,1.86302,2.22572,3.36554l1.32796,0.58161c0.15651-0.89231,0.0197-1.76089-0.43062-2.61434-0.47283-0.89607-1.25205-1.70096-2.35401-2.428z'/%3E %3Cpath d='m558.272,231.538-10.4535,4.16977,1.26814,1.10073,3.2365-1.30154,0.005,0.005,4.1188,3.57507-0.83343,3.38738,1.26814,1.10073,2.65816-10.936-1.26815-1.10073zm-0.39961,1.74123-1.0486,4.27035-3.03182-2.63158,4.08042-1.63877z'/%3E %3Cpath d='m565.825,238.486c-2.572,2.12101-5.14401,4.24201-7.71601,6.36302,0.30955,0.37576,0.6199,0.75094,0.92896,1.12706,1.01157-0.83421,2.02316-1.66839,3.03473-2.50261,1.02878,1.23361,2.02924,2.49136,3.07954,3.70663-0.32075,1.6831-0.6431,3.36591-0.95647,5.05041,0.39278,0.4763,0.78555,0.95259,1.17833,1.42889,0.33526-1.77628,0.67051-3.55257,1.00577-5.32885,0.86447,0.70788,2.1276,1.06331,3.16016,0.50203,0.88803-0.42012,1.67042-1.22768,1.7162-2.25661,0.10773-1.37866-0.87542-2.49623-1.66235-3.51871-1.25571-1.5241-2.5136-3.04745-3.76886-4.57126zm-0.17038,2.03353c1.08022,1.33434,2.21438,2.62669,3.24602,3.99893,0.47574,0.70741,1.06859,1.70139,0.52294,2.52797-0.44979,0.70689-1.43474,0.64494-2.03913,0.18646-1.2247-0.82376-2.0334-2.08693-2.9893-3.18371-0.40756-0.49424-0.81514-0.98846-1.2227-1.4827,0.82739-0.68229,1.6549-1.36466,2.48217-2.04695z'/%3E %3Cpath d='m577.523,254.401-11.2426,0.51528,0.83758,1.45542,3.48429-0.16949,0.003,0.006,2.72039,4.72706-1.89709,2.92745,0.83758,1.45542,6.09396-9.46182-0.83758-1.45542zm-0.94796,1.51425-2.38965,3.69121-2.00246-3.47954,4.39211-0.21167z'/%3E %3Cpath d='m583.939,267.638c-0.62517-1.69658-1.61122-3.43366-3.27989-4.28241-1.85658-0.93284-4.32804-0.47908-5.6446,1.15572-1.14698,1.35925-1.20561,3.28116-0.89925,4.9518,0.36199,1.91793,1.24128,3.74411,2.56297,5.18542-0.24899,0.0895-0.49798,0.17897-0.74697,0.26846,0.15949,0.44375,0.31898,0.88751,0.47847,1.33126,1.56145-0.56118,3.12289-1.12237,4.68434-1.68356-0.60724-1.6861-1.21448-3.37219-1.82172-5.05829-0.36076,0.12966-0.72152,0.25931-1.08228,0.38897,0.44666,1.24274,0.89326,2.4855,1.33997,3.72822-0.52894,0.19019-1.05794,0.38024-1.5869,0.57038-1.39993-1.20263-2.18095-2.98027-2.58642-4.74823-0.30073-1.32658-0.3127-2.91664,0.69375-3.96056,1.15449-1.20086,3.20117-1.57383,4.58696-0.54964,1.36679,1.00022,2.13826,2.6215,2.52811,4.233,0.26694,1.05995,0.22329,2.32-0.58098,3.14709-0.22477,0.16883,0.13155,0.40385,0.19251,0.60544,0.12747,0.21048,0.25493,0.42097,0.3824,0.63145,0.84766-0.66844,1.36007-1.71422,1.34362-2.79667,0.0283-1.06426-0.20642-2.12058-0.56409-3.11785z'/%3E %3Cpath d='m586.811,275.447-5.59255,1.08792c-1.03793,0.20191-1.81583,0.53072-2.3346,0.96809-0.51784,0.43655-0.84913,1.05225-1.00889,1.87102-0.15808,0.81019-0.13548,1.80286,0.0969,3.01081,0.002,0.009,0.004,0.0182,0.005,0.0277,0.23733,1.207,0.58855,2.13574,1.03883,2.82758,0.45504,0.69917,0.99299,1.14578,1.63672,1.35637,0.64489,0.21099,1.48934,0.2242,2.52725,0.0223l5.59255-1.08792-0.27754-1.42669-5.45747,1.06164c-2.44995,0.47659-3.27516-0.81293-3.69596-3.01869-0.002-0.009-0.003-0.0183-0.005-0.0277-0.43677-2.20264-0.15514-3.70748,2.2948-4.18408l5.45748-1.06164-0.27752-1.4267z'/%3E %3Cpath d='m589.879,292.467-10.3479-4.42525,0.12129,1.67483,3.21126,1.36264,0.00051,0.007,0.39395,5.43971-2.98142,1.8111,0.1213,1.67484,9.60233-5.87006-0.1213-1.67483zm-1.51216,0.95131-3.75709,2.28466-0.28998-4.00412,4.04707,1.71946z'/%3E %3Crect width='1.5' height='6.3' x='-322.944' y='414.199' transform='scale(-1,1) rotate(14.748924)'/%3E %3Crect width='1.5' height='6.3' x='644.14' y='159.606' transform='rotate(14.748924)'/%3E %3Cpath d='m433.217,343.989-11.1807,1.28621,0.93557,1.39445,3.46441-0.40839,0.004,0.006,3.03863,4.52906-1.69156,3.05083,0.93557,1.39445,5.42972-9.85801-0.93556-1.39445zm-0.84172,1.57578-2.13049,3.84662-2.23671-3.33381,4.3672-0.51281z'/%3E %3Cpath d='m437.497,350.098-7.12714,6.66478,0.95177,1.0178,6.00626-5.61661-3.15096,8.66999,1.09151,1.16724,8.61117-2.61405-5.89802,5.51541,0.95176,1.0178,7.12714-6.66478-1.44571-1.54602-8.75099,2.61438,3.27652-8.46862z'/%3E %3Cpath d='m447.878,360.689c-2.00517,2.66278-4.01035,5.32555-6.01552,7.98833,2.59171,1.95166,5.18343,3.90333,7.77514,5.85499,0.2849-0.37833,0.5698-0.75667,0.8547-1.135-2.2047-1.6602-4.40935-3.32047-6.61409-4.98063,0.61036-0.8106,1.2208-1.62113,1.83116-2.43173,1.98679,1.49606,3.97352,2.9922,5.96029,4.48829,0.28345-0.37641,0.5669-0.75281,0.85035-1.12922-1.98677-1.49609-3.9735-2.99224-5.96029-4.4883,0.54002-0.71722,1.08018-1.43435,1.62017-2.1516,2.12207,1.59791,4.24406,3.19593,6.3661,4.79388,0.28635-0.38026,0.5727-0.76052,0.85905-1.14078-2.50902-1.88941-5.01804-3.77882-7.52706-5.66823z'/%3E %3Cpath d='m457.662,367.85c-1.56999,2.94092-3.13997,5.88185-4.70996,8.82277,0.42937,0.22948,0.85923,0.45816,1.2883,0.68814,0.61751-1.15665,1.23489-2.31336,1.85248-3.46997,1.42112,0.74871,2.82545,1.53016,4.25943,2.25383,0.34467,1.67837,0.68772,3.35708,1.03974,5.03393,0.54461,0.29074,1.08923,0.58147,1.63384,0.87221-0.36674-1.77005-0.73349-3.5401-1.10023-5.31015,1.06896,0.32516,2.37225,0.17258,3.11309-0.73977,0.62944-0.70484,1.05797-1.69332,0.75635-2.63927-0.35132-1.30341-1.63425-1.98592-2.71701-2.61729-1.80294-0.96908-3.61175-1.92868-5.41603-2.89443zm0.61719,1.94509c1.50709,0.8222,3.04815,1.58484,4.52472,2.46067,0.68458,0.46205,1.55319,1.0947,1.46717,2.02654-0.0761,0.81768-0.95762,1.2541-1.70343,1.08062-1.45923-0.24188-2.68995-1.11223-3.9896-1.76124-0.60467-0.32278-1.20931-0.64561-1.814-0.96836,0.50503-0.94608,1.01013-1.89215,1.51514-2.83823z'/%3E %3Cpath d='m468.957,373.756-3.77856,9.25864,1.38879,0.5668,3.77856-9.25864z'/%3E %3Cpath d='m477.975,376.871c-1.1045-0.36671-2.16696-0.51975-3.20557-0.45482-1.03459,0.0647-1.91722,0.36866-2.6492,0.91462-0.73176,0.5458-1.25576,1.29675-1.57605,2.26139-0.29347,0.88389-0.34361,1.78363-0.15626,2.6985,0.18663,0.9112,0.62734,1.69614,1.33082,2.37323,0.69968,0.67346,1.72451,1.23922,3.08173,1.68985,1.30322,0.43271,2.4741,0.5339,3.5397,0.31054,1.02228-0.21431,1.8643-0.73475,2.53348-1.56255l-1.30064-0.71755c-1.30612,1.5555-2.86822,1.17743-4.495,0.65224-2.50004-0.85988-3.82967-2.61674-3.10307-4.97303,0.89751-2.56285,3.35319-2.61592,5.54172-1.93512,1.52616,0.50545,2.8326,1.16765,3.02317,2.67228l1.43343,0.2169c-0.0805-0.90234-0.43816-1.70562-1.09461-2.41289-0.68925-0.74259-1.65072-1.31757-2.90365-1.73359z'/%3E %3Cpath d='m488.029,379.122-6.54019,9.15906,1.66192,0.24047,2.01921-2.8446,0.007,0.001,5.39774,0.78104,1.13004,3.30029,1.66192,0.24048-3.6757-10.6373-1.66191-0.24047zm0.60512,1.6809,1.42636,4.15944-3.97323-0.57492,2.54687-3.58452z'/%3E %3Cpath d='m511.47,379.193c-1.14266,0.22076-2.14408,0.60727-3.01802,1.1722-0.87056,0.56274-1.4915,1.25979-1.86263,2.09414-0.37102,0.83409-0.46045,1.74541-0.26766,2.74338,0.17666,0.91443,0.57327,1.7236,1.1844,2.42972,0.6087,0.70328,1.37718,1.1721,2.32202,1.41827,0.93976,0.24486,2.11036,0.23669,3.51447-0.0346,1.34825-0.26047,2.41884-0.74526,3.23879-1.46156,0.7866-0.6872,1.26619-1.55314,1.44461-2.60254l-1.4854,0.0108c-0.37773,1.99571-1.925,2.43052-3.60068,2.76868-2.601,0.47368-4.62033-0.40766-5.13988-2.81808-0.47161-2.67419,1.64391-3.9223,3.88562-4.3997,1.57827-0.30613,3.04163-0.36804,3.94421,0.85082l1.35617-0.51239c-0.51183-0.74748-1.21684-1.27295-2.13544-1.56846-0.96449-0.31025-2.08436-0.34112-3.38058-0.0907z'/%3E %3Cpath d='m518.148,378.01c0.94813,3.19565,1.89626,6.39129,2.84439,9.58694,3.11037-0.92283,6.22073-1.84565,9.3311-2.76848-0.13471-0.45405-0.26943-0.90809-0.40414-1.36214-2.64589,0.78505-5.29182,1.57-7.93769,2.35511-0.28864-0.97278-0.57724-1.94559-0.86588-2.91837,2.38433-0.70751,4.7687-1.41486,7.15305-2.12231-0.13403-0.45173-0.26805-0.90347-0.40208-1.3552-2.38435,0.70745-4.76872,1.4148-7.15305,2.12231-0.25541-0.86072-0.51069-1.72147-0.76615-2.58217,2.54667-0.75567,5.09338-1.51119,7.64007-2.2668-0.1354-0.45636-0.27079-0.91271-0.40619-1.36907-3.01114,0.89339-6.02229,1.78679-9.03343,2.68018z'/%3E %3Cpath d='m528.966,374.61c1.39945,3.02534,2.79891,6.05067,4.19836,9.07601,0.41731-0.19304,0.83461-0.38607,1.25192-0.57911-1.16723-2.5233-2.33445-5.04661-3.50169-7.5699,3.2371,1.46816,6.45494,2.97935,9.68455,4.46424,0.21532,0.18677,0.43059,0.0619,0.64586-0.0532,0.41968-0.19414,0.83935-0.38827,1.25903-0.5824-1.39945-3.02534-2.79891-6.05067-4.19836-9.07601-0.41837,0.19353-0.83673,0.38706-1.2551,0.58059,1.16571,2.52002,2.33141,5.04004,3.49712,7.56005-3.32359-1.50694-6.62903-3.05445-9.94557-4.57714-0.54537,0.25228-1.09075,0.50455-1.63612,0.75683z'/%3E %3Cpath d='m539.947,369.452,0.7834,1.1903,3.57155-2.3506,0.13556-0.0892,0.0676,0.10271,4.64663,7.0602,1.2141-0.79904-4.64663-7.06021-0.0676-0.10271,0.13849-0.0912,3.58924-2.36224-0.7834-1.1903z'/%3E %3Cpath d='m550.009,362.562c2.25912,2.45158,4.51825,4.90315,6.77737,7.35473,0.35826-0.32963,0.71559-0.66044,1.07443-0.98933-0.88853-0.9642-1.77701-1.92843-2.66556-2.89261,1.17531-1.0949,2.3759-2.16325,3.53179-3.27856,1.69818,0.22782,3.39617,0.45717,5.09534,0.67753,0.45399-0.41836,0.90799-0.83671,1.36198-1.25507-1.79202-0.23715-3.58403-0.4743-5.37605-0.71145,0.65931-0.90206,0.94479-2.18281,0.32762-3.18296-0.46831-0.86361-1.31769-1.60043-2.34759-1.58963-1.38249-0.0318-2.44436,1.01126-3.42205,1.85319-1.45278,1.3374-2.90492,2.6777-4.35728,4.01416zm2.0398,0.0584c1.27303-1.15184,2.50096-2.35547,3.81453-3.46086,0.6802-0.51389,1.64011-1.16046,2.49542-0.66105,0.73053,0.41027,0.7228,1.39714,0.29822,2.02581-0.75622,1.26942-1.97455,2.14713-3.01826,3.16305-0.46989,0.433-0.93977,0.866-1.40966,1.299-0.72675-0.78859-1.45368-1.57749-2.18025-2.36595z'/%3E %3Cpath d='m561.643,350.918,4.47337,10.3272,1.06321-1.29975-1.39553-3.1971,0.004-0.005,3.45322-4.22148,3.41028,0.73412,1.06321-1.29976-11.009-2.33754-1.06322,1.29975zm1.75217,0.34857,4.29916,0.9234-2.54189,3.1074-1.75727-4.0308z'/%3E %3Cpath d='m565.998,345.253,8.39039,5.44074,4.40302-6.79009-1.19211-0.77303-3.52205,5.43147-0.0902,0.13913-0.10617-0.0688-7.09208-4.59886z'/%3E %3C/g%3E %3Cg clip-path='url(%23shield)'%3E %3Cg id='rays'%3E %3Cpath fill='%23fff' d='m500.001,226.408 -31.4786,54.5355 -15.42,26.7015h93.7971l-14.7145,-25.4844 -32.1841,-55.7526z'/%3E %3Cg id='rays5'%3E %3Cg id='ray'%3E %3Cpath fill='%2317c0eb' stroke='%2317c0eb' stroke-width='0.12869333' opacity='0.62040818' d='m500.001,226.408-2.35655,4.08164,2.35655,54.9769,2.35656-54.9769z'/%3E %3Cpath fill='%23fff' d='m500.001,277.475c-0.044,0 -0.0891,0.002 -0.1335,0.003l0.1335,3.11123 0.13351-3.11123c-0.0443,-0.00097 -0.0892,-0.003 -0.13351,-0.003z'/%3E %3C/g%3E %3Cuse xlink:href='%23ray' transform='rotate(72,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(144,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(216,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(288,500.001,285.46654)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays5' transform='rotate(8,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(16,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(24,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(32,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(40,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(48,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(56,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(64,500.001,285.46654)'/%3E %3C/g%3E %3Cg id='rainbow'%3E %3Cpath fill='%23f00' d='m500,265.844c-11.0666,0-21.1953,4.05143-28.9688,10.75l-14.656,25.406c-0.50136,2.67038-0.75,5.43402-0.75,8.25h5.03125c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h5.03125c0-2.81337-0.24954-5.58193-0.75-8.25l-14.6562-25.4062c-7.77293-6.69663-17.904-10.75-28.9688-10.75z'/%3E %3Cpath fill='%23f60' d='m500,266.656c-11.764,0-22.4393,4.67488-30.2812,12.25l-12.031,20.844c-0.83351,3.36611-1.28125,6.87625-1.28125,10.5h4.25c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h4.25c0-3.62494-0.44735-7.16414-1.28125-10.5312l-12.0312-20.8125c-7.841-7.57455-18.5177-12.25-30.2812-12.25z'/%3E %3Cpath fill='%23ff0' d='m500,267.469c-12.7024,0-24.1008,5.52218-31.9375,14.3125l-8.71875,15.0938c-1.38396,4.20847-2.125,8.70346-2.125,13.375h3.4375c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h3.4375c0-4.67311-0.74037-9.16532-2.125-13.375l-8.719-15.095c-7.836-8.788-19.237-14.312-31.938-14.312z'/%3E %3Cpath fill='%230f0' d='m500,268.25c-14.5495,0-27.3723,7.41414-34.9062,18.6562l-2.8125,4.875c-2.735,5.574-4.282,11.842-4.282,18.469h2.65625c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h2.6562c0-6.61555-1.55577-12.8712-4.28125-18.4375l-2.844-4.937c-7.536-11.227-20.337-18.625-34.875-18.625z'/%3E %3Cpath fill='%230cf' d='m500,269.062c-22.7472,0-41.1875,18.4403-41.1875,41.1875h1.84375c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h1.84375c0-22.7472-18.4403-41.1875-41.1875-41.1875z'/%3E %3Cpath fill='%2300f' d='m500,269.844c-22.3058,0-40.375,18.1004-40.375,40.4062h1.34375c0-21.5594,17.4718-39.0312,39.0312-39.0312s39.0312,17.4718,39.0312,39.0312h1.375c0-22.3058-18.1004-40.4062-40.4062-40.4062z'/%3E %3Cpath fill='%23800080' d='m500.001,270.657c-21.8638,0-39.5887,17.7249-39.5887,39.5887,0,0.24501,0.003,0.48981,0.007,0.73377h0.8008c-0.005-0.24405-0.007-0.48864-0.007-0.73377,0-21.4222,17.3658-38.7879,38.7879-38.7879,21.4222,0,38.7879,17.3658,38.7879,38.7879,0,0.24513-0.002,0.48972-0.007,0.73377h0.79727c0.004-0.24396,0.007-0.48876,0.007-0.73377,0-21.8638-17.7214-39.5887-39.5852-39.5887z'/%3E %3C/g%3E %3Cg id='cap'%3E %3Cpath fill='%23510000' d='m500.395,288.134c-0.64444-0.12422-1.22556-0.48362-1.77526-0.60947-0.75553,0.72433-0.83505,1.45617-0.73118,2.07933,0.26291,0.13958,0.31133,0.353,0.87825,0.86011s0.49599,0.7732,0.46178,1.96543c-0.0144,0.50237,0.0702,1.58063,0.57906,1.682,0.54856,0.1093,0.93237-0.34645,1.08988-1.16049,0.15297-0.79058,0.4179-1.2158,0.69822-1.70182,0.30651-1.85224-0.19317-2.50796-1.20075-3.11509z'/%3E %3Cpath fill='%23f00' d='m497.168,283.524c-0.5954,0.015-1.52849,1.01222-1.94312,0.4754-0.2385-0.30879-0.2787-0.90191-0.037-1.40011,0.55866-1.15143,1.12448-1.71603,2.16738-2.33046,2.37772-1.40083,3.8889-0.95056,5.07395,1.06271,1.0982,1.77292,2.15196,3.72986,2.24612,5.37194,0.0291,0.50093,0.28239,1.40776-0.15623,1.85983-1.34779,1.38922-4.59607-1.43513-6.49718-0.9882-0.63913,0.15025-1.37729,0.6166-1.98048,0.21781-0.46922-0.31025-0.0771-0.99697,0.27265-1.29413,0.61215-0.52003,1.50103-2.36524,1.38013-3.16441-0.0677-0.44682-0.08,0.17838-0.52586,0.18962z'/%3E %3Cpath fill='url(%23cap1)' d='m496.927,282.548c-1.08326,0.4452-0.96582,1.07615-1.50945,1.59022,0.15386,0.0578,0.7653,0.31056,1.36345-0.30126,0.25817-0.21386,0.54788-0.29339,0.67713-0.36245-0.30513,0.22158-0.52326,0.55469-0.68366,0.68484-0.40495,0.32861-1.03464,1.08239-1.34095,1.84608-0.30631,0.76368-0.43013,1.67294-0.37506,1.78203,0.0551,0.1091,0.42587,0.77878,1.5653,1.23156,2.03098,0.80708,2.41713,2.43864,4.47768,2.43864,1.61336,0,1.35441-1.05575,2.64581-0.83159,1.1192,0.19425,1.71404-0.69654,0.63574-1.23178-1.371-0.46864-4.09192-0.19196-5.37247,0.0332-0.41337-4.08361-0.0551-2.64985-0.15181-4.40521-0.0968-1.75536-0.62285-1.86055,0.0724-3.28125-0.57778,0.87239-1.27677,0.73447-2.004,0.807z'/%3E %3Cpath fill='%23ff2a2a' d='m500.938,279.795c-0.0401,0.22319-0.0767,0.51644-0.0555,0.6,0.087,0.33854,0.17464,0.69288,0.27745,0.99375,0.11493,0.33621,0.16173,0.57942,0.24047,0.92812,0.0812,0.35981,0.40101,0.50003,0.69364,0.72188,0.36987,0.28044,0.0839,1.03755,0.31445,1.06875,0.18399,0.025,0.48828-1.07134,0.49017-1.24688,0-0.23637-0.001-0.42692-0.037-0.64687-0.1351-0.29493-0.27167-0.58548-0.42543-0.87188-0.002-0.004-0.007-0.006-0.009-0.009-0.0604-0.11211-0.12197-0.22206-0.19422-0.32812-0.21674-0.3182-0.48469-0.61247-0.78613-0.8625-0.0186-0.0154-0.0367-0.0318-0.0555-0.0469-0.0843-0.0645-0.17013-0.13028-0.25896-0.1875-0.0629-0.0405-0.12933-0.0758-0.19422-0.1125z'/%3E %3Cpath fill='url(%23cap2)' d='m501.249,287.398c-0.71834-0.18768-1.42584-0.54264-2.03712-0.72519-1.20046-0.3585-2.47993-1.13407-3.3655-0.81346-0.31696,0.14032-0.28927,0.45588-0.39018,0.90946-0.0419,0.53363-0.59621,1.31951-0.13634,1.06243,0.68545-0.38318,2.49069,0.73271,3.09544,1.10617,0.28651,0.17693,0.89218,0.52377,1.08153,1.02169,0.18934,0.49792,0.092,1.75593,0.0412,2.29553-0.0533,0.56606,0.11902,1.83505,0.68594,1.98695,0.61122,0.16378,1.07804-0.32245,1.31579-1.2298,0.23091-0.8812,0.40519-1.38725,0.75742-1.91526s0.75591-0.75584,1.31984-0.86236c0.56393-0.10651,1.38228,0.46186,1.38228-0.20334,0-0.43694-0.38382-0.85479-0.22071-1.45374,0.12846-0.47174-0.40137-0.37766-0.84179-0.57224-1.03591-0.31872-1.96945-0.41916-2.6878-0.60684z'/%3E %3Cpath fill='%23910000' d='m498.363,288.902c-0.32675-0.17761-2.3152-1.4778-3.04281-1.07105-0.22993,0.12854-0.31747-0.0162-0.32062-0.25731-0.004-0.24106,0.10913-0.59399,0.18399-0.86612,0.0749-0.27214,0.19591-0.79179,0.5164-1.06192,0.68731-0.5793,2.2686,0.57503,3.1082,0.88679-0.0717,0.4352-0.47012,2.35517-0.44516,2.36961z'/%3E %3Cpath fill='%23ff3a3a' d='m501.763,291.361c0.91566-1.60289,1.50762-1.39687,2.61336-1.37357,0.36843,0.008,0.47628-0.32925,0.39238-0.66749-0.278,0.62397-1.66206-0.069-2.41497,0.26261-1.57249,0.69255-1.28027,3.76979-2.02634,4.07028,0.77552,0.65117,1.1236-1.74573,1.43557-2.29183z'/%3E %3C/g%3E %3Cg id='seab' fill='url(%23seabgrad)'%3E %3Cpath fill='%23fff' d='m453.103,307.645-9.95545,17.2366,113.708,0-9.95545-17.2366-93.7972,0z'/%3E %3Cg id='wavesb3'%3E %3Cpath id='waveb1' d='m449.705,321.364c-1.65776,0-3.19731,0.16736-4.70961,0.35278l-0.48684,0.84666c2.43344-0.21658,4.69724-0.64924,7.14027-0.70908,3.29349,0.0801,6.2835,0.82902,9.78611,0.82902,1.51792,0.0147,3.02697-0.0297,4.5262,0,3.49923,0,6.48854-0.74896,9.78259-0.82902,3.29576,0.0801,6.30397,0.82902,9.80375,0.82902,1.51769,0.005,3.17747-0.0238,4.52973,0,3.49922,0,6.47429-0.74896,9.76495-0.82902,3.29293,0.0801,6.26925,0.82902,9.76848,0.82902,1.53042,0.0148,3.03299-0.0299,4.54381,0,3.49923,0,6.49037-0.74896,9.78612-0.82902,3.29632,0.0795,6.28114,0.82902,9.78258,0.82902,1.51624,0.0145,3.03114-0.0297,4.52976,0,3.49867,0,6.47485-0.74896,9.76495-0.82902,2.55081,0.062,4.92094,0.51761,7.48601,0.72319l-0.51507-0.89252c-1.40293-0.16829-2.8346-0.32103-4.36741-0.32103-1.52925-0.0208-3.03636,0.0308-4.54734,0-3.4992,0-6.47369,0.74842-9.76495,0.82902-3.29632-0.0801-6.28347-0.82902-9.78612-0.82902-1.51274-0.0209-3.0301,0.0312-4.52617,0-3.49921,0-6.49263,0.74897-9.7861,0.82902-3.29407-0.0801-6.28337-0.82902-9.7826-0.82902-1.52189-0.0207-3.04194,0.0308-4.54734,0-3.49922,0-6.4754,0.74897-9.76495,0.82902-3.29404-0.0801-6.26924-0.82902-9.76847-0.82902-1.52279-0.0213-3.02634,0.0313-4.52618,0-3.5026,0-6.48979,0.74897-9.78611,0.82902-3.29405-0.0806-6.28335-0.82902-9.78259-0.82902-1.52022-0.0209-3.04332,0.0313-4.54733,0z'/%3E %3Cuse xlink:href='%23waveb1' y='-1.1132812'/%3E %3Cuse xlink:href='%23waveb1' y='-2.2304687'/%3E %3C/g%3E %3Cuse xlink:href='%23wavesb3' y='-3.34375'/%3E %3Cuse xlink:href='%23wavesb3' y='-6.6914063'/%3E %3Cpath d='m453.23,307.458 -0.12347,0.21519h93.7901l-0.12348,-0.21519h-93.5432zm-0.21872,0.37746 -0.127,0.21873h94.2346l-0.127,-0.21873h-93.9806zm-0.20109,0.34572 -0.20461,0.35631h94.792l-0.2046,-0.35631h-94.3828zm-0.3175,0.55033 -0.25047,0.43392h95.5187l-0.25048,-0.43392h-95.0178zm-0.39864,0.69144 -0.25047,0.43392h96.316l-0.25047,-0.43392h-95.815zm-0.39864,0.69144 -0.24695,0.43039h97.1062l-0.24693,-0.43039h-96.6123zm-0.39864,0.69144 -0.25048,0.43039h97.9106l-0.25048,-0.43039h-97.4096zm-0.43039,0.74436 -0.30339,0.52916h98.8772l-0.30339,-0.52916h-98.2704z'/%3E %3Cpath d='m457.357,312.287c3.45019,0.6621 3.7818,0 3.7818,0zm81.5028,0s0.3316,0.6621 3.7818,0z'/%3E %3C/g%3E %3Cg id='mountains' fill='%23ccd11e'%3E %3Cg id='mountain1'%3E %3Cpath fill='url(%23mountain)' d='m530.631,297.043c-1.70879,0-2.23164,0.86208-2.23164,0.86208-2.73683,10.5758-11.8078,21.3327-22.6008,21.3327h-8.08019v10.7684c0,0.003,0.0112,0,0.017,0h61.4976l-6.18652-10.9539c-9.70777-1.44879-17.6397-11.3728-20.1666-21.1472-0.0003,0-0.54017-0.86208-2.24897-0.86208z'/%3E %3Cpath fill='%2397c924' d='m530.631,297.465c-0.78411,0-1.26009,0.18069-1.53836,0.35499-0.26383,0.16497-0.31454,0.2757-0.32096,0.28758,0,0.007-0.0151,0.01-0.0176,0.0168-1.39971,5.32242-4.35191,10.6683-8.33374,14.7065-4.01201,4.06971-9.06971,6.82929-14.605,6.82929h-7.67481v9.92268h60.8557l-5.68004-10.0578c-4.68763-0.61173-8.97309-3.16302-12.4584-6.69417-3.98569-4.03827-6.93211-9.38349-8.33374-14.7065,0,0-0.0164-0.0165-0.017-0.0168-0.007-0.012-0.0696-0.10431-0.33797-0.27057-0.28308-0.17556-0.75393-0.372-1.53804-0.372z'/%3E %3Cpath fill='%23ede71f' d='m530.63,297.465c0.14713,0,0.27966,0.0211,0.4057,0.0341,0.0238,3.01731,0,8.10909,0,10.8013-0.0287,2.34006-0.83034,4.2225-2.01175,6.44085-0.54742,1.5541-0.98612,0.96232-2.34929,2.85666-1.83161,0.65398-3.18666,0.90876-5.13836,1.21655-2.51753,0.39758-8.12164,0.75027-10.8869,0.13523,3.64106-1.06725,6.96079-3.26938,9.77096-6.11954,0.74649-0.7573,1.45945-1.5595,2.12967-2.40011,1.11812-1.40047,2.12751-2.91291,3.00924-4.47944,0.35269-0.6264,0.68645-1.24901,0.99749-1.89326,0.46683-0.9661,0.88335-1.95059,1.25119-2.94104,0.12279-0.3305,0.24396-0.66588,0.35485-0.99747,0.22233-0.66372,0.41706-1.32961,0.59179-1.99495,0.002-0.006,0.0151-0.0103,0.0168-0.0168,0.006-0.0119,0.0579-0.12225,0.32077-0.28724,0.13578-0.0849,0.3316-0.17039,0.57502-0.23692,0.005-0.001,0.0124,0.001,0.0168,0,0.25153-0.0665,0.55446-0.11793,0.9461-0.11793z'/%3E %3Cpath fill='%23c6cb24' d='m529.938,298.902c-0.41166,6.03407-2.27735,13.1917-6.64434,17.8107-1.60658,1.33664-3.65998,2.54995-5.64577,2.2546,6.77038-5.51045,10.8853-13.9468,12.2901-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m524.494,309.281c-1.00181,2.72142-4.78784,6.74649-8.84,10.0451-1.15058,0.0352-1.75967,0.10115-2.80422,0.0379,2.46776-0.22502,8.22171-5.08258,11.6442-10.0829z'/%3E %3C/g%3E %3Cuse xlink:href='%23mountain1' x='-15.340665'/%3E %3Cg id='mountain3' fill='%23c6cb24'%3E %3Cpath fill='url(%23mountain)' d='m502.218,297.911c2.73458,10.5755,11.7902,21.3327,22.5831,21.3327h8.08853v10.7681c0,0.003-0.0144,0-0.017,0h-65.7947c-0.006,0-0.0167,0.003-0.0167,0v-10.7681h8.07151c10.7926,0,19.863-10.7575,22.6001-21.3327,0,0,0.53408-0.86562,2.24287-0.86562s2.24287,0.86562,2.24287,0.86562z'/%3E %3Cpath fill='%2397c924' d='m499.975,297.465c0.78378,0,1.25463,0.19644,1.53836,0.372,0.26865,0.16626,0.33123,0.25869,0.33829,0.27057,0,0,0.017,0.0168,0.017,0.0168,1.40164,5.32275,4.34806,10.6683,8.33375,14.7065,4.0165,4.06971,9.08671,6.82929,14.6226,6.82929h7.64046v9.92238h-64.9804v-9.92238h7.67448c5.53561,0,10.593-2.75991,14.6053-6.82929,3.98184-4.03827,6.93371-9.38379,8.33374-14.7065,0.003-0.007,0.0151-0.01,0.017-0.0168,0.006-0.012,0.0575-0.12228,0.32096-0.28758,0.2786-0.1743,0.75458-0.35499,1.53837-0.35499z'/%3E %3Cpath fill='%23ede71f' d='m499.263,297.53c-0.0864,0.0162-0.16714,0.0347-0.24243,0.0546-0.004,0.001-0.0128-0.001-0.0176,0-0.24288,0.0665-0.43572,0.15144-0.5715,0.23636-0.26398,0.16499-0.31454,0.27385-0.32103,0.28575-0.002,0.006-0.016,0.0111-0.0176,0.0176-0.17526,0.66535-0.37034,1.333-0.59266,1.99672-0.11089,0.33159-0.23352,0.66433-0.35631,0.99484-0.36838,0.99044-0.782,1.97606-1.24883,2.94216-0.31158,0.64425-0.64567,1.26802-0.99836,1.89442-0.88173,1.56653-1.89108,3.07628-3.0092,4.47675-0.67076,0.84061-1.38428,1.64511-2.13077,2.40242-2.80963,2.85016-6.12791,5.04991-9.76842,6.11716,2.76473,0.61504,4.03154-0.056,6.54853-0.45356,1.95224-0.30779,4.21092-0.5631,6.04308-1.21708,1.3637-1.89434,0.89896-1.29988,1.44639-2.85397,1.18086-2.21836,2.90542-4.22182,3.33375-6.68161,1.61858-3.02147,1.90301-8.6137,1.90304-10.2126z'/%3E %3Cpath d='m499.275,298.902c-0.41166,6.03407-2.27681,13.1917-6.6438,17.8107-1.60658,1.33664-3.65998,2.54995-5.64577,2.2546,6.77038-5.51045,10.8848-13.9468,12.2896-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m493.832,309.281c-1.00204,2.72139-4.78809,6.74682-8.84021,10.0453-1.15033,0.035-1.75951,0.10077-2.80424,0.0375,2.46787-0.2253,8.22237-5.08266,11.6444-10.0828z'/%3E %3Cpath fill='%23ede71f' d='m500.951,297.584c0.004,0.001,0.0128-0.001,0.0176,0,0.24288,0.0665,0.43572,0.15144,0.5715,0.23636,0.26398,0.16499,0.31454,0.27385,0.32103,0.28575,0.002,0.006,0.016,0.0111,0.0176,0.0176,0.17526,0.66535,0.37034,1.333,0.59266,1.99672,0.11089,0.33159,0.23352,0.66433,0.35631,0.99484,0.36838,0.99044,0.782,1.97606,1.24883,2.94216,0.31158,0.64425,0.64567,1.26802,0.99836,1.89442,0.88173,1.56653,1.89108,3.07628,3.0092,4.47675,0.67076,0.84061,1.38428,1.64511,2.13077,2.40242,2.80963,2.85016,6.12791,5.44502,9.76842,6.51227-7.24491,0.0274-10.3888-0.63-13.022-4.01661-2.63318-3.38661-3.60599-4.86816-4.1405-6.93644-0.53451-2.06829-2.02539-6.57045-1.86986-10.8063z'/%3E %3Cpath d='m501.476,298.902c0.41166,6.03407,2.2209,12.0063,6.58735,16.6253,1.60659,1.33664,3.65999,2.54994,5.64577,2.2546-7.33482-5.00192-10.8288-12.7615-12.2331-18.8799z'/%3E %3C/g%3E %3Cg id='mountain4'%3E %3Cpath fill='url(%23mountain)' d='m484.749,297.043c-1.70911,0-2.24833,0.86208-2.24833,0.86208-2.52242,9.74649-11.825,22.3182-21.4962,23.8113l-4.78983,8.28981h49.0144v-11.3486c-8.82472-2.37071-15.8893-11.6292-18.2484-20.7525-0.00034,0-0.52284-0.86208-2.23164-0.86208z'/%3E %3Cpath fill='%2397c924' d='m484.749,297.465c-0.7841,0-1.25495,0.19644-1.53836,0.372-0.26864,0.16626-0.33123,0.25869-0.33797,0.27057-0.00033,0-0.017,0.0168-0.017,0.0168-1.40164,5.32275-4.67746,10.7045-8.07974,14.9888-3.40228,4.28421-9.71968,8.61825-14.0417,9.07638l-4.28272,7.39371h48.0605v-10.6937c-3.55405-1.09062-6.79917-3.26637-9.5523-6.05864-3.98183-4.03827-6.93371-9.38379-8.33374-14.7065-0.002-0.007-0.0154-0.01-0.017-0.0168-0.006-0.012-0.0578-0.12228-0.32128-0.28758-0.27891-0.1743-0.7549-0.35499-1.53868-0.35499z'/%3E %3Cpath fill='%2393bc30' d='m483.445,298.903c-0.61721,9.04327-5.65334,20.4536-11.3402,22.4194-1.85433,0.64154-5.09834,0.86441-6.22727,1.00883,9.94892-4.73151,15.8284-15.8536,17.5675-23.4282z'/%3E %3Cpath fill='%23ede71f' d='m484.746,297.465c-0.14713,0-0.27966,0.0211-0.4057,0.0341-0.0233,3.01731,0,8.10909,0,10.8013,0.0292,2.34006,0.83088,4.2225,2.01175,6.44085,0.0687,0.1942,0.13577,0.35377,0.20285,0.49009,0.41003,1.08564,0.7135,1.46267,2.28222,2.6538,4.9869,3.78651,11.1698,4.35287,14.8082,4.04021-1.13975-0.89849-2.35794-1.71529-3.4317-2.46772,1.71152-0.0552,3.3511-0.24883,4.51358-0.5074-3.64051-1.06725-6.96079-3.26938-9.77042-6.11954-0.48955-0.49658-0.94501-1.02182-1.40319-1.55518-0.20826-0.29156-0.50091-0.69725-0.59178-0.81139-1.11812-1.40047-2.26275-2.94699-3.14448-4.51352-0.35269-0.6264-0.6859-1.24901-0.99748-1.89326-0.46683-0.9661-0.88282-1.95059-1.25119-2.94104-0.1228-0.3305-0.24397-0.66588-0.35486-0.99747-0.22232-0.66372-0.41652-1.32961-0.59178-1.99495-0.002-0.006-0.0152-0.0103-0.0168-0.0168-0.006-0.0119-0.0573-0.12225-0.32132-0.28724-0.13578-0.0849-0.3316-0.17039-0.57502-0.23692-0.005-0.001-0.0124,0.001-0.0168,0-0.25153-0.0665-0.55446-0.11793-0.9461-0.11793z'/%3E %3Cpath d='m485.446,298.902c0.41166,6.03407,2.27735,13.1917,6.6438,17.8107,1.60658,1.33664,3.65998,2.54995,5.64577,2.2546-6.77038-5.50991-10.8853-13.9468-12.2896-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m489.613,307.247c2.36901,5.83689,8.37001,11.2893,14.5434,14.9536,1.15032,0.035,1.49118,0.003,2.53623-0.06-4.41834-2.3709-11.5382-5.75379-17.0796-14.8936z'/%3E %3C/g%3E %3Cuse xlink:href='%23mountain4' x='-15.429624' fill='%23c6cb24'/%3E %3C/g%3E %3Cg id='seaf'%3E %3Cpath fill='%23fff' d='m556.5,324.692c-0.57438,0.20274-4.4212-0.18918-6.43291-0.0441l-1.27942,0.33561c-1.12352-0.008-2.2382,0.0249-3.33025,0-3.60215,0-6.64947,0.94833-10.0754,0.94896-3.43268,0-6.47005-0.94896-10.0754-0.94896-1.11911-0.008-2.23365,0.025-3.33025,0-3.6015,0-6.64626,0.94896-10.0754,0.94896-3.42915,0-6.47326-0.94896-10.0754-0.94896-1.13086-0.007-2.24155,0.0238-3.34789,0-3.60182,0-6.63215,0.94896-10.0578,0.94896-3.42883,0-6.45594-0.94896-10.0578-0.94896-0.26736,0-0.51646,0.009-0.77612,0.0177-0.17781-0.004-0.37669-0.0177-0.55739-0.0177-0.11972,0-0.22152-0.003-0.33867,0-0.11714-0.003-0.23659,0-0.35631,0-0.18069,0-0.3443,0.0138-0.52212,0.0177-0.25964-0.008-0.51195-0.0177-0.77963-0.0177-3.60535,0-6.64241,0.94929-10.0754,0.94896-3.42914,0-6.47358-0.94896-10.0754-0.94896-0.2619,0-0.52159,0.01-0.77611,0.0177-0.1807-0.004-0.33885-0.0177-0.52212-0.0177-0.12421,0-0.25198-0.003-0.37394,0-0.11715-0.003-0.23659,0-0.35631,0-0.1807,0-0.36162,0.0138-0.53975,0.0177-0.25902-0.008-0.50844-0.0177-0.77612-0.0177-2.87883,0-6.21806,0.60744-8.93592,0.8502l-6.27243,10.8584,62.9712-0.007,64.3753,0.007z'/%3E %3Cpath fill='url(%23seafgrad)' d='m547.993,323.111c-0.19914,0-0.3979,0-0.5962,0.007-3.24025,0.0945-5.56407,1.1148-11.2007,1.1148-5.63662,0-6.21814-1.01862-12.5836-0.87843-5.9467,0.13098-8.44224,1.2612-11.6699,1.21707-3.22765-0.0441-8.47272-0.69756-12.5095-0.27513-4.03677,0.4224-8.8283,1.28394-11.9733,1.29114-3.90833-0.0174-7.81956-0.73101-11.9062-0.32454-4.08669,0.40647-5.99703,1.49994-11.0631,1.48518-4.35525-0.0126-9.08294-0.69768-12.7459-0.69498-3.43476,0.003-7.26655,0.95724-10.0859,1.44288l-0.84314,1.46403c2.24704-0.26058,8.55148-1.21821,10.802-1.27707,2.34423-0.0613,10.717,0.48306,15.3352,0.32457,4.61831-0.15849,5.15872-1.17123,10.6186-1.17123,3.80095,0,6.66602,0.39864,10.5657,0.39864,2.43414,0,4.64322-1.24179,8.34319-1.24179,0.93595-0.0267,1.86447-0.0608,2.794-0.0914,3.11857-0.51522,8.38344,0.0449,12.0474,0.23274,3.31532,0.17289,5.45733-0.61554,8.9147-0.73023,1.49575-0.0682,2.99739-0.0659,4.47322-0.1483,3.46061-0.11481,6.42225,0.64053,9.68022,0.62442,3.24998-0.20046,6.40346-0.9225,9.86013-1.03716,1.51123-0.0717,2.99793-0.0723,4.49087-0.1482,2.28616-0.0758,5.83581,0.0784,8.27264,0.50094l-0.83962-1.4499c-2.37954-0.0756-5.31192-0.63528-8.18091-0.63501z'/%3E %3Cg id='wavesf3'%3E %3Cpath id='wavef1' fill='url(%23seafgrad)' d='m450.312,334.748c-3.4571,0-6.40225,0.85314-9.65206,0.94542-1.21068-0.0338-2.36647-0.18372-3.53485-0.34572l-0.49037,0.8502c0.48641,0.0323,0.97518,0.0635,1.48873,0.0635,1.50121,0.0181,2.99033-0.0362,4.47333,0,3.4571,0,6.38201-0.85251,9.63442-0.94545,3.25403,0.0923,6.20548,0.94545,9.66617,0.94545,1.5011,0.0185,2.99216-0.0362,4.47329,0,3.45743,0,6.41213-0.85317,9.66616-0.94545,3.25601,0.0923,6.23024,0.94545,9.68735,0.94545,1.49515,0.018,2.99325-0.0361,4.46979,0,3.45745,0,6.40128-0.85317,9.65206-0.94545,3.25339,0.0923,6.19143,0.94545,9.64853,0.94545,1.51281,0.0184,2.99932-0.0362,4.49089,0,3.45713,0,6.41051-0.85317,9.66617-0.94545,3.25762,0.0917,6.21,0.94545,9.66971,0.94545,1.49537,0.018,2.99209-0.0361,4.46978,0,3.45709,0,6.40095-0.85317,9.65206-0.94545,3.25303,0.0923,6.20903,0.94545,9.66616,0.94545,1.49931,0.0181,2.99554-0.0361,4.47325,0,0.60565,0,1.19636-0.0342,1.77801-0.0776l-0.46213-0.79728c-1.06409,0.14412-2.13376,0.27615-3.235,0.3069-3.25439-0.0923-6.19497-0.94542-9.65207-0.94542-1.51059-0.0196-2.99775,0.0292-4.49089,0-3.4571,0-6.39678,0.85314-9.64853,0.94542-3.25694-0.0916-6.2058-0.94542-9.66617-0.94542-1.49604-0.0198-2.99286,0.0297-4.47325,0-3.45713,0-6.41243,0.85314-9.66617,0.94542-3.25435-0.0923-6.20904-0.94542-9.66617-0.94542-1.50326-0.0196-3.00351,0.0292-4.4909,0-3.45712,0-6.39874,0.85314-9.64852,0.94542-3.25406-0.0923-6.19497-0.94542-9.65206-0.94542-1.5058-0.02-2.98967,0.0296-4.47325,0-3.46037,0-6.40921,0.8538-9.66618,0.94542-3.25436-0.0923-6.20873-0.94542-9.66617-0.94542-1.50222-0.0201-3.00578,0.0298-4.49089,0z'/%3E %3Cuse xlink:href='%23wavef1' y='-1.2894435'/%3E %3Cuse xlink:href='%23wavef1' y='-2.5745998'/%3E %3C/g%3E %3Cuse xlink:href='%23wavesf3' y='-3.8671875'/%3E %3Cuse xlink:href='%23wavesf3' y='-7.7286534'/%3E %3C/g%3E %3Cpath fill='%2397c924' d='m443.846,324.705-2.42711,4.191c2.83897-0.47073,7.10222-1.70307,10.6345-1.70568,3.66291-0.003,8.08192,0.90279,12.4372,0.91545,5.06609,0.0147,6.97643-1.07871,11.0631-1.48521,4.08668-0.40644,7.99791,0.52761,11.9062,0.54507,3.14498-0.007,7.93651-1.08924,11.9733-1.51167,4.03678-0.42243,7.73721,0.29346,12.603,0.3687,4.86583,0.0753,5.62964-1.17963,11.5763-1.31061,6.36544-0.14022,6.94696,0.8784,12.5836,0.8784,4.24149,0.22824,7.88284-0.8541,11.6664-1.12182,3.78351-0.26772,5.53834,0.043,8.3044,0.10938l-1.83798-3.25263c-0.0306,0-0.0608,0.003-0.0917,0.004l-101.246,2.2256z'/%3E %3Cpath fill='%23fff' d='m550.067,324.648s2.71009,0.1485,3.84748,0.27558c1.13739,0.12711,2.95452,0.25356,2.95452,0.25356l-0.36909-0.48504c-0.57438,0.20274-4.4212-0.18918-6.43291-0.0441z'/%3E %3C/g%3E %3Cpath fill='%23c8a400' d='m500,224.874 -32.1418,55.6856 -32.8579,56.8991 64.2977,-0.007 65.7018,0.007 -32.153,-55.683 -32.847,-56.902zm0,3.00212 31.5491,54.652 30.8506,53.4278 -63.1018,-0.004 -61.7012,0.004 31.5597,-54.6448z'/%3E %3C/svg%3E"

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 9 6'%3E %3Crect fill='%2321468B' width='9' height='6'/%3E %3Crect fill='%23FFF' width='9' height='4'/%3E %3Crect fill='%23AE1C28' width='9' height='2'/%3E %3C/svg%3E"

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='1100' height='800'%3E %3Crect width='1100' height='800' fill='%23ef2b2d'/%3E %3Crect width='200' height='800' x='300' fill='%23fff'/%3E %3Crect width='1100' height='200' y='300' fill='%23fff'/%3E %3Crect width='100' height='800' x='350' fill='%23002868'/%3E %3Crect width='1100' height='100' y='350' fill='%23002868'/%3E %3C/svg%3E"

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' version='1.1' width='726' height='885' viewBox='-17.582 -4.664 71.571 87.246'%3E %3Ctitle%3EFlag of Nepal%3C/title%3E %3Cdesc%3ECoding according to the official construction in 'Constitution of the Kingdom of Nepal, Article 5, Shedule 1', adopted in November 1990%3C/desc%3E %3C!-- 2*TN= (17955-7335*Sqrt(2))/1468 --%3E %3Cuse xlink:href='%23b' stroke='%23003893' stroke-width='5.1646754223'/%3E %3C!-- F,G,C,A,B,D --%3E %3C!-- Fy=Gy = 80-30*Sqrt(2) --%3E %3Cpath id='b' d='M -15,37.5735931288 h 60 L -15,0 v 80 h 60 L -15,20 z' fill='%23DC143C'/%3E %3Cg fill='%23fff'%3E %3C!-- LN = -Px = Qx = 5/4*Sqrt(609-366*Sqrt(2)), Py = Qy= 50-75/4*Sqrt(2) --%3E %3C!-- MQ = 5/4*(23-9*Sqrt(2)) --%3E %3Cpath d='M -11.9502769431,23.4834957055 A 12.8400974233,12.8400974233 0 0,0 11.9502769431,23.4834957055 A 11.9502769431 11.9502769431 0 0,1 -11.9502769431,23.4834957055'/%3E %3C!-- Px, Py, MQ, MQ, Qx, Qy, LN, LN, Px, Py --%3E %3C!-- Ty = (183895-69735*Sqrt(2))/2936 TM = (37095-14685*Sqrt(2))/2936 --%3E %3Cg transform='translate(0,29.0445562765) scale(5.5610605710)'%3E %3Ccircle r='1'/%3E %3Cg id='jags6'%3E %3Cg id='jags3'%3E %3C!-- sin(Pi/16),-cos(Pi/16), 0, -TS/TM = -Sqrt(884995-8076*Sqrt(2))/673, -sin(Pi/16),-cos(Pi/16) --%3E %3Cpath id='jag' d='M 0.195090322016,-0.980785280403 L 0,-1.388784109750 L -0.195090322016,-0.980785280403' transform='rotate(11.25)'/%3E %3Cuse xlink:href='%23jag' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23jag' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23jags3' transform='rotate(67.5)'/%3E %3C/g%3E %3Cuse xlink:href='%23jags6' transform='scale(-1, 1)'/%3E %3C/g%3E %3C!-- Wy = 80-15*Sqrt(2) NM= 15/4*(5-2*Sqrt(2)) --%3E %3Cg transform='translate(0,58.7867965644) scale(8.1433982822)'%3E %3Ccircle r='1'/%3E %3Cg id='rays4'%3E %3Cg id='rays2'%3E %3C!-- sin(Pi/12),cos(Pi/12), 0, LN/NM=(79+Sqrt(2))/51, -sin(Pi/12),cos(Pi/12) --%3E %3Cpath id='ray' d='M 0.258819045103,0.965925826289 L 0,1.576749285537 L -0.258819045103,0.965925826289'/%3E %3Cuse xlink:href='%23ray' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays2' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays4' transform='rotate(30)'/%3E %3Cuse xlink:href='%23rays4' transform='rotate(60)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300'%3E %3Crect fill='%23002b7f' width='600' height='300'/%3E %3Crect fill='%23ffc61e' y='137.5' width='600' height='25'/%3E %3Cpath fill='%23fff' d='M 150,262.5 L 143.5295,236.6481 L 125,255.8012 L 132.3223,230.1777 L 106.6987,237.5 L 125.8519,218.9705 L 100,212.5 L 125.8519,206.0295 L 106.6987,187.5 L 132.3223,194.8223 L 125,169.1988 L 143.5295,188.3519 L 150,162.5 L 156.4705,188.3519 L 175,169.1988 L 167.6777,194.8223 L 193.3013,187.5 L 174.1481,206.0295 L 200,212.5 L 174.1481,218.9705 L 193.3013,237.5 L 167.6777,230.1777 L 175,255.8012 L 156.4705,236.6481 L 150,262.5 z'/%3E %3C/svg%3E"

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 120 60'%3E %3CclipPath id='t'%3E %3Cpath d='M0,0V15H70V30H60zM0,30V40H30V0H60z'/%3E %3C/clipPath%3E %3Ctitle%3EFlag of Niue%3C/title%3E %3Crect width='120' height='60' fill='%23002868'/%3E %3Cg stroke='%23cf142b' stroke-width='6'%3E %3Cpath d='M0,0L60,30M60,0L0,30' stroke='%23fff'/%3E %3Cpath d='M0,0L60,30M60,0L0,30' clip-path='url(%23t)' stroke-width='4'/%3E %3Cpath d='M30,0V40M0,15H70' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0V40M0,15H70'/%3E %3C/g%3E %3Cpath d='M60,0h60V60H0V30H60z' fill='%23fcd116'/%3E %3Cg transform='translate(30,15)'%3E %3Cg transform='scale(5.10390485)'%3E %3Ccircle r='1' fill='%23002868'/%3E %3Cpath id='s' d='M0,-513674 301930,415571 -488533,-158734H488533L-301930,415571' fill='%23fcd116' transform='scale(0.00000194676)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='translate(-17.5,0.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(17.5,0.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(0,10.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(0,-9.71) scale(3)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' height='600' width='1200'%3E %3Cdefs%3E %3CclipPath id='Canton'%3E %3Cpath d='M 0,0 L 600,0 L 600,300 L 0,300 z'/%3E %3C/clipPath%3E %3CclipPath id='Diagonals'%3E %3Cpath d='M 0,0 L 300,150 L 0,150 z M 300,0 L 600,0 L 300,150 z M 300,150 L 600,150 L 600,300 z M 300,150 L 300,300 L 0,300 z'/%3E %3C/clipPath%3E %3Cg id='Pentagram'%3E %3Cg id='Arm' transform='translate(0,-0.324925)'%3E %3Cpath d='M 0,0 L 0,0.5 L 1,0 z'/%3E %3Cpath d='M 0,0 L 0,-0.5 L 1,0 z' transform='rotate(-36,1,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23Arm' transform='scale(-1,1)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(72,0,0)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(-72,0,0)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(-72,0,0) scale(-1,1)'/%3E %3C/g%3E %3C/defs%3E %3Crect fill='%2300247d' x='0' y='0' width='1200' height='600'/%3E %3Cg id='Flag_of_the_United_Kingdom'%3E %3Cpath id='Saint_Andrews_Cross' stroke='%23ffffff' d='M 0,0 L 600,300 M 0,300 L 600,0' stroke-width='60' clip-path='url(%23Canton)'/%3E %3Cpath id='Saint_Patricks_Cross' stroke='%23cc142b' d='M 0,0 L 600,300 M 0,300 L 600,0' stroke-width='40' clip-path='url(%23Diagonals)'/%3E %3Cg id='Saint_Georges_Cross'%3E %3Cpath stroke='%23ffffff' d='M 300,0 L 300,300 M 0,150 L 600,150' stroke-width='100' clip-path='url(%23Canton)'/%3E %3Cpath stroke='%23cc142b' d='M 300,0 L 300,300 M 0,150 L 600,150' stroke-width='60' clip-path='url(%23Canton)'/%3E %3C/g%3E %3C/g%3E %3Cg id='Southern_Cross'%3E %3Cg id='Gamma_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,120) scale(45.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,120) scale(30)'/%3E %3C/g%3E %3Cg transform='rotate(82,900,240)'%3E %3Cg id='Delta_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,120) rotate(-82) scale(40.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,120) rotate(-82) scale(25)'/%3E %3C/g%3E %3Cg id='Beta_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,380) rotate(-82) scale(45.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,380) rotate(-82) scale(30)'/%3E %3C/g%3E %3C/g%3E %3Cg id='Alpha_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,480) scale(50.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,480) scale(35)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 1200 600'%3E %3Ctitle%3EFlag of Oman%3C/title%3E %3Crect width='1200' fill='%23db161b' height='600'/%3E %3Crect height='200' width='900' x='300' fill='%23fff'/%3E %3Crect height='200' width='900' y='400' x='300' fill='%23008000'/%3E %3Cg id='a' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Crect rx='3.2154' ry='3.0152' height='21.217' width='38.669' y='102.64' x='65.854' stroke-width='0.28333pt'/%3E %3Crect rx='3.0505' ry='2.764' height='19.449' width='36.686' y='103.52' x='66.846' stroke-width='0.26422pt'/%3E %3Cpath d='M83.904,108.83l1.853,0.06,0.084,0.84,1.516,0.77,1.18-0.96,1.431,0.77-1.347,0.84,0.337,1.16,1.684-0.06v1.55l-1.347-0.07-0.674,0.97,1.516,1.1-1.179,0.9-1.264-0.97-1.853,0.39,0.084,1.42-2.021,0.13-0.253-1.36-1.684-0.71-0.927,0.97-1.432-0.71,0.843-1.1-1.011-0.71h-1.432l-0.084-2,1.432,0.13,1.01-1.16-1.179-0.9,1.516-1.04,1.095,0.84,1.853-0.25,0.253-0.84z' stroke-width='0.16681166pt'/%3E %3Cellipse cx='68.944' cy='426.78' rx='11.049' ry='9.9439' transform='matrix(0.1841806,0,0,0.1752043,71.76647,38.246478)' stroke-width='1pt'/%3E %3Cpath d='M71.803,104.41l-2.974,2.65'/%3E %3Cpath d='M73.786,104.41l-2.974,2.65'/%3E %3Cpath d='M75.769,104.41l-2.974,2.65'/%3E %3Cpath d='M77.752,104.41l-2.974,2.65'/%3E %3Cpath d='M79.735,104.41l-2.974,2.65'/%3E %3Cpath d='M81.718,104.41l-2.974,2.65'/%3E %3Cpath d='M83.702,104.41l-2.975,2.65'/%3E %3Cpath d='M85.685,104.41l-2.975,2.65'/%3E %3Cpath d='M87.668,104.41l-2.975,2.65'/%3E %3Cpath d='M89.651,104.41l-2.975,2.65'/%3E %3Cpath d='M91.634,104.41l-2.975,2.65'/%3E %3Cpath d='M93.617,104.41l-2.975,2.65'/%3E %3Cpath d='M85.685,104.41l-2.975,2.65'/%3E %3Cpath d='M95.6,104.41l-2.975,2.65'/%3E %3Cpath d='M97.583,104.41l-2.975,2.65'/%3E %3Cpath d='M99.566,104.41l-2.975,2.65'/%3E %3Cpath d='M101.55,104.41l-2.976,2.65'/%3E %3Cpath d='M98.574,104.41l2.976,2.65'/%3E %3Cpath d='M96.591,104.41l2.975,2.65'/%3E %3Cpath d='M94.608,104.41l2.975,2.65'/%3E %3Cpath d='M92.625,104.41l2.975,2.65'/%3E %3Cpath d='M90.642,104.41l2.975,2.65'/%3E %3Cpath d='M88.659,104.41l2.975,2.65'/%3E %3Cpath d='M86.676,104.41l2.975,2.65'/%3E %3Cpath d='M84.693,104.41l2.975,2.65'/%3E %3Cpath d='M82.71,104.41l2.975,2.65'/%3E %3Cpath d='M80.727,104.41l2.975,2.65'/%3E %3Cpath d='M78.744,104.41l2.975,2.65'/%3E %3Cpath d='M76.761,104.41l2.974,2.65'/%3E %3Cpath d='M84.693,104.41l2.975,2.65'/%3E %3Cpath d='M74.778,104.41l2.974,2.65'/%3E %3Cpath d='M72.795,104.41l2.974,2.65'/%3E %3Cpath d='M70.812,104.41l2.974,2.65'/%3E %3Cpath d='M68.829,104.41l2.974,2.65'/%3E %3Cpath d='M71.803,119.43l-2.974,2.66'/%3E %3Cpath d='M73.786,119.43l-2.974,2.66'/%3E %3Cpath d='M75.769,119.43l-2.974,2.66'/%3E %3Cpath d='M77.752,119.43l-2.974,2.66'/%3E %3Cpath d='M79.735,119.43l-2.974,2.66'/%3E %3Cpath d='M81.718,119.43l-2.974,2.66'/%3E %3Cpath d='M83.702,119.43l-2.975,2.66'/%3E %3Cpath d='M85.685,119.43l-2.975,2.66'/%3E %3Cpath d='M87.668,119.43l-2.975,2.66'/%3E %3Cpath d='M89.651,119.43l-2.975,2.66'/%3E %3Cpath d='M91.634,119.43l-2.975,2.66'/%3E %3Cpath d='M93.617,119.43l-2.975,2.66'/%3E %3Cpath d='M85.685,119.43l-2.975,2.66'/%3E %3Cpath d='M95.6,119.43l-2.975,2.66'/%3E %3Cpath d='M97.583,119.43l-2.975,2.66'/%3E %3Cpath d='M99.566,119.43l-2.975,2.66'/%3E %3Cpath d='M101.55,119.43l-2.976,2.66'/%3E %3Cpath d='M98.574,119.43l2.976,2.66'/%3E %3Cpath d='M96.591,119.43l2.975,2.66'/%3E %3Cpath d='M94.608,119.43l2.975,2.66'/%3E %3Cpath d='M92.625,119.43l2.975,2.66'/%3E %3Cpath d='M90.642,119.43l2.975,2.66'/%3E %3Cpath d='M88.659,119.43l2.975,2.66'/%3E %3Cpath d='M86.676,119.43l2.975,2.66'/%3E %3Cpath d='M84.693,119.43l2.975,2.66'/%3E %3Cpath d='M82.71,119.43l2.975,2.66'/%3E %3Cpath d='M80.727,119.43l2.975,2.66'/%3E %3Cpath d='M78.744,119.43l2.975,2.66'/%3E %3Cpath d='M76.761,119.43l2.974,2.66'/%3E %3Cpath d='M84.693,119.43l2.975,2.66'/%3E %3Cpath d='M74.778,119.43l2.974,2.66'/%3E %3Cpath d='M72.795,119.43l2.974,2.66'/%3E %3Cpath d='M70.812,119.43l2.974,2.66'/%3E %3Cpath d='M68.829,119.43l2.974,2.66'/%3E %3C/g%3E %3Cuse xlink:href='%23a' x='-300' transform='scale(-1,1)'/%3E %3Cg id='b'%3E %3Cpath d='M126.51,147.12c-48.114,47.05-68.638,53-59.006,56.79s40.616-20.49,72.856-52.75c32.24-32.25,51.98-60.956,42.35-64.747-9.63-3.792-5.03,10.662-56.2,60.707z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.42368097pt' fill='%23fff'/%3E %3Cpath d='M86.008,181.31l16.852,4.42c-15.861,15.03-33.708,21.22-38.665,18.57-4.958-2.65,8.923-8.84,21.813-22.99z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M86.008,183.08l13.881,3.54c-15.453,14.45-30.737,18.56-34.692,16.8-3.977-1.77,8.255-6.74,20.811-20.34z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028045' fill='%23fff'/%3E %3Cpath d='M137.79,145.06c-0.04,0.23-0.15,1.24-0.25,1.64,0,0.56-0.06,0.98-0.12,1.42-0.16,0.38-0.13,0.73-0.62,0.87-0.33,0.46-0.54,0.58-0.98,0.77-0.3,0.23-0.76,0.46-1.24,0.65-0.49,0.19-0.94,0.21-1.47,0.11-0.44-0.27-0.75-0.54-1.11-0.76-0.09-0.35-0.16-0.86-0.25-1.2,0.13,0.35,0.23,0.91,0.25,1.41-0.05,0.55-0.25,0.79-0.49,1.2' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M133.23,152.37c-0.04-0.03-0.08-0.07-0.12-0.11,0.29,0.26,0.17,0.14-0.5-0.21-0.47-0.22-0.98-0.34-1.6-0.44h-1.72c-0.67,0-1.12,0.09-1.6,0.22-0.35,0.31-0.87,0.48-1.23,0.76-0.38,0.23-0.54,0.5-0.74,0.87-0.34,0.3-0.56,0.76-0.87,0.99-0.13,0.5-0.42,0.48-0.61,0.87,0.58,0.04,1.05,0.11,1.35,0.43,0.52,0.24-0.43-0.23-0.61-0.43-0.41-0.11-0.51-0.22-1.11-0.22-0.56-0.16-0.9,0.13-1.48,0.22-0.33,0.17-0.43,0.22-0.86,0.22' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M126.58,157.83c-0.25,0.01-1.4,0.2-1.85,0-0.5-0.12-0.8-0.36-1.11-0.77-0.15-0.29,0,0.53,0,0.88-0.05,0.64-0.27,0.65-0.61,1.09-0.36,0.2-0.74,0.49-1.11,0.65-0.31,0.24-0.69,0.4-1.11,0.55-0.37,0.15-0.81,0.31-1.11,0.54-0.41,0.26-0.37,0.58-0.61,0.98,0.04,0.54,0.14,0.84,0.49,1.1,0.14,0.36,0.47,0.73,0.74,0.98,0.3,0.5,0.64,0.73-0.13,0.87-0.42,0.16-0.65,0.03-1.1,0' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M118.82,165.46c-0.3-0.06-1.38-0.38-1.85-0.54h-1.72c-0.67,0.04-0.8,0.22-1.36,0.43-0.36,0.33-0.61,0.56-1.11,0.77-0.26,0.3-0.78,0.81-0.98,1.2-0.15,0.37-0.25,0.87-0.25,1.42,0.01,0.63,0.2,0.74,0.25,1.31,0.14,0.46,0.36,0.89,0.74,1.3,0.05,0.14,0.09,0.18,0.24,0.22' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M112.95,173c-0.05,0-0.17,0.28-0.35,0.52-0.39,0.4-0.44,0.43-1.05,0.43-0.54-0.02-0.49-0.21-0.87-0.35-0.18-0.27-0.41-0.49-0.61-0.86-0.14-0.22-0.27-0.57-0.44-0.77-0.16-0.26-0.36-0.45-0.53-0.69-0.16-0.07-0.22-0.14-0.43-0.17,0.5,0.08,0.54,0.25,0.87,0.51,0.15,0.25,0.31,0.5,0.44,0.78,0.05,0.37,0.17,0.66,0.17,1.12,0,0.47,0,0.81-0.17,1.2-0.21,0.22-0.36,0.44-0.61,0.61-0.21,0.19-0.46,0.45-0.62,0.68-0.27,0.17-0.47,0.31-0.78,0.52-0.27,0.15-0.55,0.31-0.96,0.35-0.52-0.04-0.67-0.18-1.05-0.35-0.33-0.24-0.59-0.39-0.88-0.6-0.23-0.16-0.46-0.47-0.61-0.69-0.47-0.12-0.77-0.07-1.05,0.17-0.24,0.16-0.45,0.37-0.61,0.6-0.15,0.07-0.38,0.28-0.53,0.35' stroke='%23db161b' stroke-width='0.33028191' fill='none'/%3E %3Cpath d='M103.32,176.56c0.14,0.06,0.64,0.41,0.87,0.54,0.14,0.45,0.36,0.7,0.43,1.18,0.12,0.47,0.11,0.98,0.11,1.51-0.12,0.55-0.35,0.95-0.54,1.39-0.35,0.24-0.52,0.4-0.98,0.65-0.43,0.06-0.86,0.11-1.41,0.11-0.34,0.11-0.98,0.16-1.31,0-0.48-0.07-0.843-0.26-1.194-0.43-0.402-0.23-0.649-0.44-1.088-0.65-0.213-0.31-0.544-0.59-0.869-0.97-0.271-0.36-0.47-0.56-0.653-0.96,0.161,0.46,0.405,0.86,0.544,1.29,0.247,0.45,0.391,0.62,0.435,1.18,0.151,0.45,0.109,0.99,0.109,1.5-0.048,0.35-0.073,1.01-0.218,1.29v0.33' stroke='%23db161b' stroke-width='0.33028162' fill='none'/%3E %3Cpath d='M87.242,186.23v0.16c0-0.42-0.011-0.21,0.175,0.62,0.33,0.37,1.104,0.47,1.749,0.31,0.566-0.41,0.548-0.73,1.574-0.93,0.991,0.06,1.369,0.32,1.924,0.62,0.658,0.29,0.962,0.44,1.399,1.09,0.217,0.53,0.338,0.89-0.35,1.09-0.547,0.35-1.197,0.54-1.924,0.63-0.808,0-1.39-0.09-1.749,0.31-0.555,0.51-0.524,0.82-0.524,1.71-0.187,0.28-0.224,1.1-0.35,1.41-0.486,0.2-0.771,0.31-1.574,0.31-0.189-0.48-0.398-1.35-0.525-1.87-0.137-0.56-0.179-1.34-0.525-1.72-0.326-0.42-0.743-0.8-1.224-1.09-0.214-0.27-0.622-0.49-1.049-0.62,0.686,0.31,0.784,0.65,0.874,1.4-0.603,0.27-0.764,0.46-1.749,0.47-0.968-0.07-1.202-0.29-1.574-0.78-0.067,0.78-0.348,1.04-0.524,1.72-0.36,0.47-0.513,0.95-0.875,1.55,0.154,0.76,0.486,0.79,0.525,1.72,0.227,0.61,0.202,1.19,0.699,1.56,0.222,0.24,0.388,0.29,0.875,0.31-1.013,0-1.603-0.1-2.274-0.47-0.519-0.28-0.911-0.64-1.399-0.93-0.619-0.4-1.384-0.77-2.099-0.94-0.808,0-1.39-0.08-1.749,0.31-0.495,0.32-0.828,0.86-1.049,1.56-0.162,0.81-0.224,1.35,0.175,1.87,0.296,0.61,0.363,0.84,0,1.56-0.407,0.51-1.012,0.57-1.924,0.78-0.666-0.03-1.306-0.16-1.749-0.31' stroke='%23db161b' stroke-width='0.33028123' fill='none'/%3E %3Cpath d='M181.41,104.66c21.35-36.858,35.52-68.222,31.62-70.014-3.89-1.791-24.37,26.665-45.72,63.518l14.1,6.496z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33520904pt' fill='%23fff'/%3E %3Cpath d='M180,104.01c20.59-35.557,34.78-65.574,31.67-67.007s-22.35,26.258-42.95,61.81' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.29448283pt' fill='%23fff'/%3E %3Cpath d='M176.46,85.461c-2.51,4.157-5.16,8.908-7.74,13.352l11.28,5.197c2.57-4.448,5.38-9.13,7.73-13.356l-11.27-5.193z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M177.41,86.895c-2.5,4.157-4.25,7.338-6.82,11.782l8.45,3.893c2.58-4.442,4.48-7.554,6.83-11.78l-8.46-3.895z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Crect transform='matrix(-0.9083207,-0.4182743,-0.5012544,0.8653,0,0)' height='9.9849' width='6.2072' stroke='%23db161b' y='6.5585' x='-205.69' stroke-width='0.33495pt' fill='%23fff'/%3E %3Cpath d='M183.55,91.712l-10.64,6.043' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M178.54,100.35l-0.63-11.235' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M209.03,47.727l-5.64-2.597' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cellipse rx='3.5433' ry='3.5433' stroke='%23db161b' transform='matrix(-0.4490005,0.1132067,0.1013394,0.3938715,444.34717,-55.797864)' cy='92.126' cx='545.67' stroke-width='1pt' fill='%23db161b'/%3E %3C/g%3E %3Cuse xlink:href='%23b' x='-300' transform='scale(-1,1)'/%3E %3Cpath d='M135.26,84.958c0,30.942,0.18,42.602-2.1,44.202-2.16,1.71-62.348,0-62.348,8.84s49.578,17.68,64.448,17.68c19.83,0,29.75-8.84,29.75-26.52v-44.202h-29.75z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.30510197pt' fill='%23fff'/%3E %3Cpath d='M135.26,93.798v4.42c9.92,1.474,19.83,1.474,29.75,0v-4.42c-9.92,1.474-19.83,1.474-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,84.958v4.42c9.92,1.473,19.83,1.473,29.75,0v-4.42c-9.92,1.473-19.83,1.473-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,89.378v4.42c9.92,1.474,19.83,1.474,29.75,0v-4.42c-9.92,1.473-19.83,1.473-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,98.218v4.422c9.92,1.47,19.83,1.47,29.75,0v-4.422c-9.92,1.474-19.83,1.474-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402506,84.325604)' cy='210.83' cx='256.89' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,83.530922)' cy='246.26' cx='292.32' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,83.372046)' cy='263.98' cx='327.76' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,83.372046)' cy='263.98' cx='363.19' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,83.530922)' cy='246.26' cx='398.62' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402534,84.325604)' cy='210.83' cx='434.06' stroke-width='4.4628' fill='%23fff'/%3E %3Cg fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Cpath d='M135.26,107.06l29.75,23.87'/%3E %3Cpath d='M138.23,107.06l26.78,21.21'/%3E %3Cpath d='M142.2,107.94l22.81,17.68'/%3E %3Cpath d='M145.18,107.94l19.83,15.03'/%3E %3Cpath d='M148.15,107.94l16.86,12.38'/%3E %3Cpath d='M151.12,107.94l13.89,9.73'/%3E %3Cpath d='M154.1,107.94l10.91,7.07'/%3E %3Cpath d='M157.07,107.94l7.94,5.31'/%3E %3Cpath d='M160.05,107.94l4.96,3.54'/%3E %3Cpath d='M163.02,107.94l1.99,1.77'/%3E %3Cpath d='M135.26,109.71l29.75,23.87'/%3E %3Cpath d='M165.01,107.06l-32.72,26.52'/%3E %3Cpath d='M162.03,107.06l-28.75,22.98'/%3E %3Cpath d='M158.07,107.94l-22.81,17.68'/%3E %3Cpath d='M155.09,107.94l-19.83,15.03'/%3E %3Cpath d='M152.12,107.94l-16.86,12.38'/%3E %3Cpath d='M149.14,107.94l-13.88,9.73'/%3E %3Cpath d='M146.17,107.94l-10.91,7.07'/%3E %3Cpath d='M143.19,107.94l-7.93,5.31'/%3E %3Cpath d='M140.22,107.94l-4.96,3.54'/%3E %3Cpath d='M137.24,107.94l-1.98,1.77'/%3E %3Cpath d='M165.01,109.71l-32.72,26.52'/%3E %3Cpath d='M165.01,112.36l-32.72,26.52'/%3E %3Cpath d='M165.01,115.01l-32.72,26.53'/%3E %3Cpath d='M165.01,117.67l-32.72,26.52'/%3E %3Cpath d='M165.01,120.32l-32.72,26.52'/%3E %3Cpath d='M165.01,122.97l-32.72,26.52'/%3E %3Cpath d='M165.01,125.62l-32.72,26.52'/%3E %3Cpath d='M165.01,128.28l-32.72,26.52'/%3E %3Cpath d='M165.01,130.93l-30.74,24.75'/%3E %3Cpath d='M165.01,133.58l-27.77,22.1'/%3E %3Cpath d='M164.01,137.12l-21.81,17.68'/%3E %3Cpath d='M163.02,140.65l-17.84,14.15'/%3E %3Cpath d='M161.04,145.07l-8.92,7.07'/%3E %3Cpath d='M135.26,112.36l28.75,22.99'/%3E %3Cpath d='M135.26,115.01l28.75,22.99'/%3E %3Cpath d='M135.26,117.67l27.76,22.1'/%3E %3Cpath d='M135.26,120.32l27.76,22.1'/%3E %3Cpath d='M135.26,122.97l26.77,21.22'/%3E %3Cpath d='M134.27,124.74l26.77,21.22'/%3E %3Cpath d='M134.27,127.39l24.79,19.45'/%3E %3Cpath d='M133.28,129.16l24.79,19.45'/%3E %3Cpath d='M132.29,130.93l23.79,18.56'/%3E %3Cpath d='M132.29,133.58l22.8,17.68'/%3E %3Cpath d='M132.29,136.23l19.83,15.91'/%3E %3C/g%3E %3Cpath d='M135.26,102.64v4.42c9.92,1.47,19.83,1.47,29.75,0v-4.42c-9.92,1.47-19.83,1.47-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M132.29,138.88l17.84,14.15' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,141.54l15.86,12.37' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,144.19l13.88,10.61' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,146.84l9.91,7.96' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,149.49l7.93,6.19' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,152.14l4.95,3.54' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402506,97.586004)' cy='210.83' cx='256.89' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,96.791347)' cy='246.26' cx='292.32' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,96.632446)' cy='263.98' cx='327.76' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,96.632446)' cy='263.98' cx='363.19' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,96.791347)' cy='246.26' cx='398.62' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402534,97.586004)' cy='210.83' cx='434.06' stroke-width='4.4628' fill='%23fff'/%3E %3Cg fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Cpath d='M92.625,148.61l35.695-18.57'/%3E %3Cpath d='M90.642,147.72l33.708-17.68'/%3E %3Cpath d='M89.651,145.96l30.739-15.92'/%3E %3Cpath d='M88.659,144.19l26.771-14.15'/%3E %3Cpath d='M86.676,142.42l24.784-12.38'/%3E %3Cpath d='M87.668,139.77l16.852-8.84'/%3E %3Cpath d='M86.676,138l12.89-7.07'/%3E %3Cpath d='M86.676,135.35l8.924-4.42'/%3E %3Cpath d='M95.6,149.49l33.71-17.68'/%3E %3Cpath d='M98.574,150.38l31.726-16.8'/%3E %3Cpath d='M101.55,151.26l29.74-15.91'/%3E %3Cpath d='M104.52,152.14l24.79-13.26'/%3E %3Cpath d='M108.49,152.14l21.81-11.49'/%3E %3Cpath d='M111.46,153.03l18.84-9.73'/%3E %3Cpath d='M114.44,153.91l14.87-7.95'/%3E %3Cpath d='M118.4,153.91l11.9-6.19'/%3E %3Cpath d='M122.37,154.8l7.93-4.42'/%3E %3Cpath d='M126.34,154.8l4.95-2.66'/%3E %3C/g%3E %3Cpath d='M133.28,129.16h-4.96c-1.65,8.84-1.65,17.68,0,26.52h4.96c-1.66-8.84-1.66-17.68,0-26.52z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M74.778,141.54l11.898-8.84' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M74.778,135.35l11.898,10.61' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M92.625,130.93l-5.949,0.88c-1.322,5.6-1.322,10.31,0,15.91l5.949,1.77c-1.322-5.6-1.322-12.96,0-18.56z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.18807621pt' fill='%23fff'/%3E %3Cpath d='M164.97,86.726v-4.457c-4.45,0.037-7.43-2.615-7.43-5.305l-14.85,0.037c0,2.653-2.97,5.305-7.43,5.305v4.42h29.71z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.32342911pt' fill='%23fff'/%3E %3Crect height='5.3041' width='12.734' stroke='%23db161b' y='71.697' x='143.75' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='5.3042' width='10.612' stroke='%23db161b' y='66.393' x='144.81' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='5.3042' width='10.612' stroke='%23db161b' y='61.089' x='144.81' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='7.0722' width='8.4893' stroke='%23db161b' y='54.017' x='145.87' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='6.1882' width='9.2211' stroke='%23db161b' y='47.829' x='145.51' stroke-width='0.28488pt' fill='%23fff'/%3E %3Cellipse rx='42.52' ry='33.661' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,81.982856,1.8592021)' cy='161.22' cx='237.4' stroke-width='1pt' fill='%23fff'/%3E %3Cpath d='M156.78,41.64c0,2.319,3.07,6.189,3.07,6.189-2.23,1.52-5.83,2.652-9.22,2.652s-7.62-0.631-9.22-2.652c0,0,3.07-3.87,3.07-6.189,0-2.318-3.07-5.304-3.07-5.304,2.22-1.52,5.83-2.652,9.22-2.652s6.99,1.132,9.22,2.652c0,0-3.07,2.986-3.07,5.304z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26859274pt' fill='%23fff'/%3E %3Cpath d='M154.73,41.64c0,2.319,3.07,7.073,3.07,7.073-2.22,1.52-3.78,1.768-7.17,1.768s-5.57,0.253-7.17-1.768c0,0,3.07-4.754,3.07-7.073,0-2.318-3.07-6.188-3.07-6.188,2.22-1.52,3.78-1.768,7.17-1.768s4.95,0.248,7.17,1.768c0,0-3.07,3.87-3.07,6.188z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26859274pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,81.982856,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,106.57247,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,94.277639,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,94.277639,-7.8650879)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2994823,0,0,0.249492,83.263631,42.524442)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2994823,0,0,0.249492,100.24214,42.524442)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cpath d='M142.69,77.001h14.85l-7.42,7.957-7.43-7.957z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.27334673pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.3993101,0,0,0.3326564,72.298311,27.790617)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Crect rx='1.2377' ry='0.93811' height='5.3042' width='22.805' stroke='%23db161b' y='109.72' x='133.77' stroke-width='0.33028' fill='%23fff'/%3E %3Cpath d='M163.52,105.3c-2.75,0-4.96,2.06-4.96,4.62v4.02c0,2.56,2.21,4.62,4.96,4.62s4.96-2.06,4.96-4.62v-4.02c0-2.56-2.21-4.62-4.96-4.62zm0,1.77c-1.65,0-2.98,1.65-2.98,3.7v2.33c0,2.05,1.33,3.69,2.98,3.69s2.97-1.64,2.97-3.69v-2.33c0-2.05-1.32-3.7-2.97-3.7z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M137.74,106.19c-1.65,0-2.97,1.64-2.97,3.69v4.1c0,2.05,1.32,3.7,2.97,3.7s2.97-1.65,2.97-3.7v-4.1c0-2.05-1.32-3.69-2.97-3.69zm0-1.77c-2.75,0-4.96,2.06-4.96,4.62v5.79c0,2.56,2.21,4.62,4.96,4.62s4.96-2.06,4.96-4.62v-5.79c0-2.56-2.21-4.62-4.96-4.62z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M129.81,107.95c-1.65,0-2.98,1.65-2.98,3.7v0.96c0,2.05,1.33,3.7,2.98,3.7s2.97-1.65,2.97-3.7v-0.96c0-2.05-1.32-3.7-2.97-3.7zm0-1.76c-2.75,0-4.96,2.06-4.96,4.62v2.65c0,2.56,2.21,4.62,4.96,4.62,2.74,0,4.96-2.06,4.96-4.62v-2.65c0-2.56-2.22-4.62-4.96-4.62z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M117.91,105.51c-2.97,0-5.35,1.84-5.35,4.13v4.58c0,2.29,2.38,4.13,5.35,4.13s5.35-1.84,5.35-4.13v-4.58c0-2.29-2.38-4.13-5.35-4.13zm0-1.98c-4.94,0-8.92,2.31-8.92,5.17v6.47c0,2.86,3.98,5.16,8.92,5.16s8.92-2.3,8.92-5.16v-6.47c0-2.86-3.98-5.17-8.92-5.17z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028102' fill='%23fff'/%3E %3Cpath d='M182.36,106.39c-2.97,0-5.36,1.85-5.36,4.14v4.58c0,2.29,2.39,4.13,5.36,4.13,2.96,0,5.35-1.84,5.35-4.13v-4.58c0-2.29-2.39-4.14-5.35-4.14zm0-1.97c-4.95,0-8.93,2.3-8.93,5.16v6.47c0,2.86,3.98,5.16,8.93,5.16,4.94,0,8.92-2.3,8.92-5.16v-6.47c0-2.86-3.98-5.16-8.92-5.16z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028102' fill='%23fff'/%3E %3Crect rx='0.64577' ry='0.93811' height='5.3042' width='11.898' stroke='%23db161b' y='109.72' x='165.5' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.3767' ry='1.2508' height='7.0722' width='6.9406' stroke='%23db161b' y='108.84' x='154.6' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.3767' ry='1.2508' height='7.0722' width='6.9406' stroke='%23db161b' y='108.84' x='121.88' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.7534' ry='1.5635' height='8.8403' width='13.881' stroke='%23db161b' y='107.95' x='100.06' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.69959' ry='1.5635' height='8.8403' width='12.89' stroke='%23db161b' y='108.84' x='186.32' stroke-width='0.33028' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300' viewBox='0 0 36 24'%3E %3Crect width='36' height='24' fill='%23fff'/%3E %3Cg fill='%23005293'%3E %3Cg id='star' transform='translate(9,6)'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-3 v 3 h 1.5 z' transform='rotate(18 0,-3)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Crect y='12' width='18' height='12'/%3E %3C/g%3E %3Cg fill='%23d21034'%3E %3Crect x='18' width='18' height='12'/%3E %3Cuse xlink:href='%23star' x='18' y='12'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg width='900' height='600' xmlns='http://www.w3.org/2000/svg' id='Flag_of_Peru'%3E %3Crect height='600' width='900' fill='%23D91023' x='0' y='0' /%3E %3Crect height='600' width='300' fill='white' x='300' y='0' /%3E %3C/svg%3E"

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='400'%3E %3CclipPath id='c'%3E %3Cellipse cx='300' cy='201' rx='85.849' ry='88.189'/%3E %3C/clipPath%3E %3Crect width='600' height='400' fill='%23ce1126'/%3E %3Crect width='600' height='200' y='100' fill='%23fff'/%3E %3Cg clip-path='url(%23c)'%3E %3Cg fill='%23ff9c10'%3E %3Cpath d='m277.29,191.02-14.575-0.41947,0-5.7622,14.575,6.1816z'/%3E %3Cpath d='m277.23,189.34-14.515-7.3829v-9.6023s-1.7009,0.23946-1.4578-1.681c0.0802-4.0011,10.667,7.3028,16.093,10.984l-0.12114,7.6826z'/%3E %3Cpath d='m214.37,214.37,30.606,0.24025,0-18.966l-34.98-1.67,4.3734,20.405z'/%3E %3Cpath d='m212.91,188.2,32.551,3.1209-0.2423-13.444-31.822-12.484-0.48701,22.807z'/%3E %3Cpath d='m219.47,161.32,25.021,12.003,3.5727-3.6863s-2.301-1.5668-2.1871-3.0084c0.0433-1.4582,2.3147-1.6794,2.358-3.2621,0.0417-1.4582-2.573-1.6334-2.6011-3.0924-0.17088-1.5811,2.0154-3.2764,2.0154-3.2764l-22.591-19.446-5.5881,23.768z'/%3E %3Cpath d='m383.68,214.61-32.307,0-0.2423-18.485,35.464-2.6412-2.9148,21.127z'/%3E %3Cpath d='m384.47,187.91c-0.40794-3.001-0.83573-5.9945-1.5312-8.9375-0.93116-3.9401-2.1206-7.8167-3.5625-11.594-0.10645-0.27883-0.26579-0.53476-0.375-0.8125l-27.625,11.562,0.25,13.688,32.844-3.9062z'/%3E %3Cpath d='m365.59,143.47c-5.5104,4.1667-11.021,8.3333-16.531,12.5,0.0273,1.1959,1.2194,2.1156,1.5482,3.2604,0.76317,1.6063-0.75368,3.0262-1.6924,4.1613-0.76068,1.047,0.87892,1.5806,1.4239,2.1993,1.1999,1.2319,0.15476,3.1621-1.1234,3.8787,1.5397,0.9212,2.3175,2.6452,2.6562,4.3438,8.25-4.2917,16.5-8.5833,24.75-12.875-2.9604-6.2356-6.6513-12.132-11.031-17.468z'/%3E %3Cpath d='m319.56,191.44,13.845-0.59944,0.2423-5.5235-14.088,6.1229z'/%3E %3Cpath d='m319.55,188.44-0.0594-6.2411s13.115-11.703,15.909-13.864c0,2.401-1.5172,4.2604-1.5172,4.2604v9.1234l-14.332,6.7216z'/%3E %3Cpath d='m234.54,135.87c0.24229,0.24026,14.718,16.14,14.718,16.14,0.40598-1.5066,3.7436-1.7357,7.1437-1.4954,3.4018,0.23946,6.1128-0.22519,6.1128,2.1758,0,2.4002-1.7258,2.0592-1.7258,3.7402s2.5858,1.5399,2.5858,3.6982c0,2.1607-1.875,1.7198-1.8846,3.3929-0.006,1.3829,1.956,1.4566,1.956,1.4566l13.785,13.205,0.0602-14.105-28.42-44.052-14.331,15.845z'/%3E %3Cpath d='m257.28,119.19c0.21581,0.64069,19.25,38.906,19.25,38.906s0.21583-35.913,3.4604-37.837l-5.4068-9.8338-17.303,8.765z'/%3E %3Cpath d='m319.41,115.06c-2.3958,8.2812-4.7917,16.562-7.1875,24.844,2.2408,0.26667,4.5038,0.33859,6.7557,0.21383,2.0248,0.17376,0.4475,2.0722,0.55535,3.1952-0.01,5.0928-0.0199,10.186-0.0298,15.278,6.7708-11.958,13.542-23.917,20.312-35.875-4.6702-2.4376-9.627-4.2482-14.616-5.9053-1.9021-0.67149-3.8355-1.2533-5.7902-1.7509z'/%3E %3Cpath d='m344.69,125.44c-8.375,12.875-16.75,25.75-25.125,38.625-0.0104,4.9583-0.0208,9.9167-0.0312,14.875,5.5944-5.3224,11.217-10.617,16.794-15.957,1.0585-1.4987-3.3598-2.2326-1.1513-4.0588,2.0005-0.63097,2.3398-3.8629,0.233-4.4839-1.7358-2.5486,1.5703-3.8992,3.6531-3.6202,2.9008,0.13241,5.8889-0.63149,8.725,0.17415,1.5616,1.4931,3-2.2551,4.532-3.0989,3.0298-3.0477,6.0632-6.0921,9.0586-9.1737-4.937-5.1457-10.573-9.615-16.688-13.282z'/%3E %3C/g%3E %3Cg fill='%23083d9c' stroke='%23083d9c' stroke-width='1.932'%3E %3Cpath stroke-width='2.057' d='m279.88,275.41c-6.1779,0.34881-12.334,4.5177-15.219,6.75,5.1802,2.2672,10.71,4.037,16.594,5.25,9.3748,1.574,18.75,1.5625,28.125,1.5625,1.5304-0.1927,3.0449-0.41052,4.5312-0.65625l19.75-6.6562s-9.5008-6.2714-17.031-6c-7.5312,0.27137-12.615,7.6383-18.688,7.0938-6.0727-0.54364-8.5049-7.3438-17.25-7.3438-0.27329,0-0.53902-0.0154-0.8125,0z'/%3E %3Cpath d='m244.01,270.31,112.23,0.4805s-9.7159-10.323-21.134-10.563c-11.417-0.24185-8.2581,4.8012-17.003,5.5203-8.7444,0.72076-10.932-5.2809-18.948-5.0414-8.015,0.23947-12.632,5.0414-18.703,5.2824-6.0726,0.23947-13.846-6.0032-18.462-5.7614-4.6157,0.23946-21.134,7.2013-21.134,7.2013l3.1579,2.8807z'/%3E %3Cpath d='m229.68,257.1,138.46,0.4813c2.1855-3.1209-6.802-10.563-15.06-11.284-6.8036,0.23946-11.66,6.9619-17.247,7.2029-5.5873,0.23947-11.902-6.9634-18.219-6.7216-6.315,0.23946-12.874,6.7216-19.19,6.7216-6.315,0-10.931-6.9634-18.946-6.9634-8.0158,0-11.66,7.6826-17.733,7.2029-6.0743-0.4805-11.418-7.6818-17.247-7.6818-5.8296,0-15.546,8.6421-17.489,8.1616-1.9432-0.47972,2.4278,3.6014,2.6725,2.8807z'/%3E %3Cpath d='m283.21,243.86,30.908-0.0182c0.2407-0.24025-6.9199-10.55-15.449-9.8227-9.5017,0.24581-15.956,9.841-15.459,9.841z'/%3E %3Cpath d='m381.77,243.12-42.294,0s5.4741-3.1971,6.9664-6.1475c2.7359,1.4756,1.9897,2.9505,7.4639,3.1963,5.4725,0.24582,10.697-6.1459,15.923-5.9001,5.2238,0.2458,11.941,9.0972,11.941,8.8514z'/%3E %3Cpath d='m215.1,243.12,42.294,0s-5.4741-3.1971-6.9664-6.1475c-2.7359,1.4756-1.9897,2.9505-7.4638,3.1963-5.4717,0.24582-10.697-6.1459-15.923-5.9001-5.2238,0.2458-11.941,9.0972-11.941,8.8514z'/%3E %3Cpath d='m218.26,229.98,30.121,0.23947s-1.9432-4.0804-2.1855-9.1218c-7.7752-2.6396-14.09,5.7614-19.677,6.0016-5.5856,0.23946-11.415-6.0016-11.415-6.0016l3.1571,8.8823z'/%3E %3Cpath d='m379.07,229.98-30.122,0.23947s1.944-4.0804,2.1863-9.1218c7.7744-2.6396,14.089,5.7614,19.677,6.0016,5.5865,0.23946,11.416-6.0016,11.416-6.0016l-3.1571,8.8823z'/%3E %3Cpath d='m290.89,230.22,15.302-0.47893s0.24389-4.5617-7.7728-4.5617c-8.0158,0-7.2866,5.2817-7.5296,5.0406z'/%3E %3C/g%3E %3Cg fill='%23ce1126' stroke='%23630810' stroke-width='1.9319' stroke-linejoin='round'%3E %3Cpath d='m282.87,181,31.823,8.4034,0-44.895c-14.576,0.72077-26.72-27.368-0.97161-29.288-25.263-3.6015-28.179,2.8807-31.093,9.8426l0.2423,55.937z'/%3E %3Cpath d='m289.94,221.58c-6.9215,11.33-25.425,7.9697-29.752,0.0603-1.2965-0.36317-0.52953-48.8-0.52953-48.8s-2.0675-0.93089-2.163-2.42c-0.0947-1.5042,2.8113-1.6406,2.8113-3.5658,0-1.9236-2.9677-1.1696-3.0271-3.1059,0.0128-1.8515,3.1683-1.5962,3.0271-3.3073-0.16688-1.9284-3.5342-1.6429-3.677-3.4207-0.1091-1.4122,2.4085-2.6436,3.1082-3.2787-0.45251,0.0222-2.3387-0.0278-2.3508-0.0341-1.7667,0.0357-3.5342,0.0714-5.3,0.10704-3.7652,0.004,0.065,0.81116,0.01,2.9584-0.0345,1.4027-1.9095,2.336-2.0772,3.5555-0.0594,1.252,2.6829,2.1314,2.7174,3.634,0.0313,1.3408-2.6941,1.432-2.5963,2.6777,0.16929,2.1084,2.4141,2.5722,2.3804,3.8488-0.0345,1.275-3.0207,1.7611-3.0287,2.7784,0.10429,1.968,0.43244,49.807,0.43244,49.807,4.7585,24.37,32.228,30.569,40.015-1.4955z'/%3E %3Cpath d='m308.05,221.58c6.9215,11.33,25.424,7.9697,29.751,0.0603,1.2965-0.36317,0.53034-48.8,0.53034-48.8s2.0675-0.93089,2.1622-2.42c0.0947-1.5042-2.6292-1.6406-2.6292-3.5658,0-1.9236,2.7864-1.1696,2.845-3.1059-0.012-1.8515-2.9252-1.7159-2.784-3.4278,0.16608-1.9276,2.4534-1.7024,2.5834-3.4801,0.10911-1.5311-1.4361-2.4636-2.1357-3.0987,0.45249,0.0222,2.2168-0.0278,2.2296-0.0341,1.7659,0.0357,3.5334,0.0714,5.2992,0.10704,3.766,0.004-0.065,0.81116-0.009,2.9584,0.0337,1.4027,1.9087,2.336,2.0772,3.5555,0.0586,1.252-2.6837,2.1314-2.7182,3.634-0.0305,1.3408,2.695,1.432,2.5963,2.6777-0.16928,2.1084-2.4141,2.5722-2.3796,3.8488,0.0337,1.275,3.0207,1.7611,3.0279,2.7784-0.10349,1.968-0.43164,49.807-0.43164,49.807-4.7593,24.37-32.228,30.569-40.015-1.4955z'/%3E %3C/g%3E %3Cg fill='%23630810' stroke='%23630810' stroke-width='2.7916' stroke-linecap='round'%3E %3Cpath d='m281.66,223.73c2.6725-1.4415,5.1011-2.8807,6.802-6.2427l-10.446,0.23947s-4.8564,2.8823-7.2866,6.0032h10.931z'/%3E %3Cpath d='m315.42,223.73c-2.6725-1.4415-5.1003-2.8807-6.8012-6.2427l10.445,0.23947s4.8572,2.8823,7.2866,6.0032h-10.931z'/%3E %3Cpath d='m262.71,213.65 71.903,0.23946'/%3E %3Cg id='x'%3E %3Cpath d='m266.11,196.61 8.5023,11.284'/%3E %3Cpath d='m266.11,207.89 9.2315,-11.043'/%3E %3Cpath d='m270.97,195.88 -0.24252,6.9617'/%3E %3C/g%3E %3Cuse xlink:href='%23x' x='13.603532'/%3E %3Cuse xlink:href='%23x' x='27.449532'/%3E %3Cuse xlink:href='%23x' x='41.781532'/%3E %3Cuse xlink:href='%23x' x='55.627532'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='450' viewBox='0 0 768 576'%3E %3Ctitle%3EFlag of Papua New Guinea%3C/title%3E %3Crect width='768' height='576' fill='%23000'/%3E %3Cpath d='M0,0H768V576z' fill='%23ce1126'/%3E %3Cpath d='M475.48467,167.35351C469.81245,174.67996 456.38967,159.98385 440.30967,159.64818C424.22967,159.31251 412.839,175.05784 408.14967,180.41851C403.46034,185.77918 388.38534,213.91818 388.72,216.93318C389.05467,219.94818 398.10067,208.55851 401.45034,206.54851C401.785,210.56851 397.765,215.25885 398.77,216.59851C399.775,217.93818 410.49433,208.55851 414.17967,208.22385C415.18467,210.90418 412.16967,213.58351 413.17467,217.60351C414.51534,218.94318 420.54534,210.90318 424.56534,209.22885C425.23467,212.24385 420.88,217.93918 423.22467,221.62351C424.9,221.95818 434.949,210.23385 438.29967,208.89318C441.65034,207.55251 436.62433,219.94818 438.29967,220.95318C441.31467,218.94318 450.69534,208.22284 453.71034,206.88318C456.72534,205.54351 453.37567,220.61851 454.71534,220.61851C458.39967,217.93818 467.78034,205.20885 468.78534,203.19885C469.79034,201.18885 467.78034,222.62851 478.165,234.01918C488.54967,245.40985 504.29601,258.47385 505.97034,258.47385C507.98034,254.78851 505.30101,247.08418 506.97534,247.41885C511.66467,252.44385 520.375,259.81351 522.385,259.81351C524.395,259.81351 521.04433,251.77351 523.72467,251.77351C529.08534,256.79851 544.495,276.56385 574.645,285.60885C572.635,279.91351 568.27933,274.88851 567.94467,272.20918C569.95467,272.54385 576.99067,275.89452 578.33034,275.55885C579.67,275.22318 563.59,255.45885 564.595,252.77851C568.28034,252.44385 569.95567,254.78851 571.29534,253.11318C569.62,250.43385 555.55,234.68851 555.55,231.00318C555.55,227.31784 559.90567,231.67351 561.24534,231.00318C562.585,230.33284 555.88567,216.26284 557.22534,214.58851C558.565,212.91418 573.30433,223.63351 576.98967,223.63351C580.675,223.63351 577.99467,210.56851 579.67,209.89818C581.34534,209.22784 593.74101,216.93318 596.42034,216.93318C599.09967,216.93318 598.765,211.23784 599.77,211.90818C600.775,212.57851 629.92,241.72351 619.87,275.89351C609.82,300.34918 589.72101,313.41418 560.24034,302.69385C561.91467,305.37418 577.66,318.43918 594.745,313.74885C611.83,309.05851 632.59933,295.65885 630.25467,262.15918C627.91,228.65952 616.854,223.96918 615.17967,218.94418C613.50534,213.91918 617.86101,220.28385 621.54534,221.62452C625.22967,222.96519 620.875,214.58851 619.87,210.90318C618.865,207.21784 630.925,218.60851 633.94,219.61351C636.955,220.61851 626.905,192.14385 623.89,190.13385C620.875,188.12385 626.905,190.80318 628.915,191.47351C630.925,192.14385 610.48933,160.31851 606.13467,160.31851C601.78,160.31851 609.819,158.64318 612.16467,158.64318C614.51034,158.64318 588.71601,137.87284 584.36034,137.87284C580.00467,137.87284 593.739,132.51217 595.07967,132.17751C597.42534,132.51217 565.26534,115.09251 536.455,132.51217C534.77967,131.17351 550.02351,120.62101 550.525,116.09851C550.69284,114.92568 545.50101,112.41318 545.16534,111.07351C544.82967,109.73385 553.20534,105.71386 553.54,102.69886C551.53,100.01853 547.84467,101.02352 545.83467,100.3542C545.33317,97.841696 552.87067,91.643861 552.20034,88.964531C551.69784,87.457031 546.16933,86.954531 544.82967,87.959531C543.49,88.964531 548.34817,80.924531 547.51,78.579866C546.84067,77.574866 544.16034,78.245201 541.48,78.914531C539.80467,78.579866 550.19034,64.174196 548.18034,62.164196C546.17034,60.154196 518.02933,76.903526 507.64467,95.663861C497.26,114.42418 505.30101,129.49918 503.96034,135.86385C502.61967,142.22851 500.94433,148.59418 496.58967,148.59418C492.235,148.59418 482.18601,141.89385 478.83534,138.54418C475.48467,135.19452 474.81534,132.84885 470.125,131.50918C465.43467,130.16952 454.71534,134.18952 450.69534,134.52418C446.67534,134.85885 430.93,131.50918 429.925,132.51418C428.92,133.51918 445.33467,139.54918 449.02,141.55918C452.70534,143.56918 453.04101,146.24952 455.72034,147.92385C458.39967,149.59818 483.52467,156.96885 475.48467,167.35351zM573.64,214.58851C581.68,222.62851 635.95,258.80851 635.95,303.02851C635.95,347.24851 596.41933,345.90985 585.02967,344.56918C597.76,355.28851 646,353.27851 646,303.02851C646,258.80851 583.69,214.58851 575.65,210.56851C567.61,206.54851 565.6,206.54851 573.64,214.58851z' fill='%23fcd116'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M220.254,418.599,231.709,381.748,243.164,419,213,396.168h37.418z'/%3E %3Cpath id='sl' d='m192.418,178.496 -22.909,73.702 60.327,-44.862h-74.836l60.327,45.664z'/%3E %3Cuse xlink:href='%23sl' x='-88' y='112.504'/%3E %3Cuse xlink:href='%23sl' x='87.582' y='104.504'/%3E %3Cuse xlink:href='%23sl' y='264.504'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='450' viewBox='0 0 180 90'%3E %3Ctitle%3EFlag of the Philippines%3C/title%3E %3Cdesc%3ECoding according to the official 'description and specification of the FILIPINO flag' in Executive Order No. 23 from 1936%3C/desc%3E %3Crect width='180' height='90' fill='%230038a8'/%3E %3Crect y='45' width='180' height='45' fill='%23ce1126'/%3E %3Cpath d='M 77.942286,45 0,90 0,0' fill='%23fff'/%3E %3C!-- 45*Sqrt(3) --%3E %3Cg transform='translate(28,45)' fill='%23fcd116'%3E %3Ccircle r='9'/%3E %3Cg id='j'%3E %3Cg id='i'%3E %3Cg id='h'%3E %3C!-- these coordinates are -1/(1+tan(k*Pi/48)),1-1/(1+tan(k*Pi/48)) --%3E %3C!-- k in %7B1,2,3%7D. 2nd scaling factor is 85/0.88366349... --%3E %3Cpath d='M -1,0 L -0.93848823,0.06151177 L 0,0 L -0.93848823,-0.06151177 z' transform='scale(19)'/%3E %3Cpath id='g' d='M -0.88366349,0.11633651 L -0.83408932,0.16591068 L 0,0 z' transform='scale(19.238092)'/%3E %3Cuse xlink:href='%23g' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23i' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23j' transform='rotate(180)'/%3E %3Cg transform='translate(-2.019238)'%3E %3C!-- 15*Sqrt(3)-28 --%3E %3Cg id='s' transform='translate(37.961524,0)'%3E %3C!-- 30*Sqrt(3)-14 --%3E %3C!-- 5-pointed star with ri=2 and rc=5, not(!) r2/r1 = 0.381966... --%3E %3Cpath id='t' d='M 5,0 L 1.618034,1.175571 1.545085,4.755283 -0.618034,1.902113 -4.045085,2.938926 -2,0 z'/%3E %3Cuse xlink:href='%23t' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='rotate(120)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-120)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='-75 -40 120 80' version='1.1'%3E %3Ctitle%3EFlag of Pakistan%3C/title%3E %3Crect x='-75' y='-40' width='120' height='80' fill='%23fff'/%3E %3Crect x='-45' y='-40' width='90' height='80' fill='%2301411C'/%3E %3Ccircle r='24' fill='%23fff'/%3E %3Ccircle r='22' cx='-7' cy='-40' fill='%2301411C' transform='rotate(-41.63354, 45, -40)'/%3E %3Cpolygon points='0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571' fill='%23fff' transform='rotate(-41.63354) translate(16) rotate(18) scale(0.00001557408)'/%3E %3C/svg%3E"

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1280' height='800' id='Flag of Poland' viewBox='0 0 16 10'%3E%3Crect width='16' height='10' fill='%23fff'/%3E%3Crect width='16' height='5' fill='%23dc143c' y='5'/%3E%3C/svg%3E"

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 30 15'%3E %3CclipPath id='cp'%3E %3Cpath d='M0,0V75H350V150H300zM300,0H150V200H0V150z'/%3E %3C/clipPath%3E %3Crect fill='%2300247D' width='30' height='15'/%3E %3Cg transform='scale(0.05)'%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23cf142b' stroke-width='30'/%3E %3Cpath d='M300,0V150H0V300H600V0z' fill='%2300247d'/%3E %3C/g%3E %3Cg fill='%23F7E017' stroke='%23000000' stroke-width='0.015'%3E %3Cpath d='M20.018 7.954c-0.32 0.271-0.625 0.667-0.7 1.025 -0.211 1.007-0.491 1.231-0.923 1.015 0 0.541 0.474 0.582 0.682 0.266 0 0.507 0.184 0.947 0.599 1.322 0.175 0.158 0.208 0.05 0.125-0.125 -0.083-0.175-0.083-0.74-0.249-1.064 0.266 0.191 0.657 0.083 0.624-0.441 -0.341 0.2-0.68 0.192-0.715-0.283C19.418 9.112 19.635 8.303 20.018 7.954z'/%3E %3Cpath d='M19.613 3.949c0.023-0.2-0.02-0.405-0.166-0.534 -0.282-0.248-0.558-0.166-0.764 0.034 -0.308-0.166-0.471 0.423-0.82 0.324 0.058 0.191 0.15 0.274 0.324 0.208 -0.183 0.166 0 0.366-0.216 0.565 0.391 0.125 0.599-0.091 0.582-0.466 0.15 0.133 0.382 0.125 0.507-0.025 -0.208-0.067-0.209-0.247-0.125-0.416C19.06 3.39 19.646 3.4 19.613 3.949z'/%3E %3Cpath fill='%23337321' d='M20.515 6.842c-0.441 0.233-1.247 0.133-1.322-0.441 -0.075-0.574 0.482-0.832 0.632-0.906 0.233-0.117 0.416 0.091 0.341 0.333 0.258-0.091 0.316-0.391 0.191-0.565 0.341 0.025 0.657-0.233 0.79-0.599 -0.12 0.114-0.446 0.037-0.714 0.02 0.083-0.091 0.082-0.269 0.057-0.361C20.208 4.613 19.8 4.48 19.26 5.32c0.083-0.291 0.241-0.873 0.333-1.256 0.009-0.038 0.016-0.076 0.021-0.115C19.646 3.4 19.061 3.39 18.936 3.64c0.137 0.154 0.065 0.334 0.016 0.607 -0.058 0.324-0.183 1.073-0.291 1.322 -0.033-0.391-0.291-0.416-0.341-0.607 -0.075 0.05-0.116 0.183-0.1 0.274 -0.092-0.1-0.408 0.025-0.524-0.125 -0.125 0.249 0.075 0.499 0.283 0.607 -0.121 0.008-0.15 0.154-0.283 0.154 0.179 0.208 0.362 0.291 0.574 0.308 0.212 0.017 0.37 0.096 0.499 0.353C18.977 6.95 19.769 7.22 20.515 6.842z'/%3E %3Cpath d='M21.613 6.334c-0.249 0.69-0.931 1.181-1.239 1.256 -0.524 0.127-1.592 0.646-1.878 0.913 -0.045-0.01-0.087-0.026-0.118-0.048 -0.141-0.1-0.258-0.424-0.008-0.699 0.782-0.732 1.622-0.416 2.146-0.915 -0.441 0.233-1.247 0.133-1.322-0.441 0.474 0.125 1.331 0.133 2.012-0.599C21.297 5.902 21.563 6.218 21.613 6.334z'/%3E %3Cpath fill='%23337321' d='M20.018 7.954c-0.395 0.335-0.6 1.158-0.558 1.715 0.012 0.155 0.055 0.26 0.121 0.324 0.029-0.316 0.249-1.133 0.81-1.497 0.474-0.308 1.214-0.998 1.489-1.788 -0.05-0.141-0.133-0.241-0.291-0.341C21.316 7.113 20.587 7.471 20.018 7.954z'/%3E %3Cpath fill='%23316D3A' d='M21.359 6.014c-0.141 0.212-0.462 0.503-0.769 0.62 0.066-0.075 0.087-0.17 0.091-0.249 -0.391 0.15-1.173 0.133-1.489 0.017 0.474 0.125 1.331 0.133 2.012-0.599C21.272 5.877 21.33 5.943 21.359 6.014z'/%3E %3Cpath fill='%23337321' d='M18.37 7.756c-0.636 0.595-0.216 1.114 0.033 1.231 -0.066 0.416 0.324 0.366 0.316 0.715 0.158-0.091 0.2-0.333 0.175-0.524 0.2 0.216 0.707-0.025 0.815 0.374 0.067-0.441-0.274-0.881-0.698-0.84 0.175-0.158 0.075-0.416-0.091-0.482 -0.033 0.324-0.399 0.324-0.541 0.225C18.237 8.355 18.12 8.031 18.37 7.756z'/%3E %3Cpath d='M19.746 11.54c-0.069 0.04-0.064 0.129-0.021 0.187 0.087 0.116-0.062 0.38 0.22 0.437 0.083 0.017 0.147-0.034 0.179-0.129 0.087-0.262-0.191-0.291-0.216-0.416C19.883 11.494 19.804 11.507 19.746 11.54z'/%3E %3Cpath d='M19.983 12.031c-0.093 0.043-0.175 0.104-0.137 0.403 0.015 0.124 0.008 0.424-0.1 0.428 0.066 0.033 0.208 0.069 0.266-0.008 0.056 0.094 0.183 0.067 0.233-0.05 0.066 0.054 0.158-0.037 0.158-0.116 0.058 0.037 0.175-0.017 0.145-0.195 0.071 0.025 0.162-0.025 0.195-0.071 -0.104-0.021-0.366-0.162-0.428-0.274C20.253 12.035 20.091 11.981 19.983 12.031z'/%3E %3Cg fill='none'%3E %3Cpath d='M18.542 3.62c0.042-0.062 0.089-0.12 0.141-0.171'/%3E %3Cpath d='M20.124 4.721c0.073-0.042 0.185-0.047 0.309-0.039'/%3E %3Cpath d='M20.012 12.854c-0.029-0.042-0.04-0.216-0.019-0.322'/%3E %3Cpath d='M20.245 12.804c-0.046-0.035-0.133-0.156-0.148-0.262'/%3E %3Cpath d='M20.403 12.688c-0.058-0.027-0.2-0.21-0.231-0.328'/%3E %3Cpath d='M20.548 12.492c-0.069-0.015-0.279-0.152-0.366-0.297'/%3E %3C/g%3E %3Cpath d='M24.382 7.765c1.023 0.857 1.089 1.538 0.931 1.938 -0.083-0.374-0.507-0.956-0.948-1.106L24.382 7.765z'/%3E %3Cpath fill='%23337321' d='M22.553 7.282h1.896c0 0 0 0.499 0 2.245 0 1.913-1.064 3.044-2.146 3.642 -1.081-0.599-2.146-1.73-2.146-3.642 0-1.746 0-2.245 0-2.245h1.331c0.002 0.116 0.013 0.291 0.15 0.466C21.952 7.717 22.307 7.482 22.553 7.282z'/%3E %3Cpath fill='%23006EC7' d='M24.449 7.282c0 0 0 0.499 0 2.245 0 0.577-0.097 1.084-0.262 1.525l-1.883-3.455 -1.883 3.455c-0.165-0.442-0.262-0.948-0.262-1.525 0-1.746 0-2.245 0-2.245H24.449z'/%3E %3Cpath stroke='none' d='M24.244 10.887c-0.033 0.102-0.094 0.267-0.14 0.369l-1.8-3.346 -1.8 3.346c-0.047-0.102-0.107-0.267-0.14-0.369l1.941-3.598L24.244 10.887z'/%3E %3Cpath d='M23.159 12.118c0.05 0.025 0.142 0.071 0.183 0.088 0.1-0.2 0.116-0.482 0.083-0.732 -0.108 0.275-0.474 0.266-0.574 0.432 0.061 0.031 0.118 0.071 0.167 0.106 -0.125 0.125-0.417 0.334-0.583 0.384v-1.784c0-0.125-0.042-0.229-0.042-0.333 0 0 0-0.286 0-0.369 0-0.083-0.017-0.204-0.091-0.204 -0.075 0-0.091 0.121-0.091 0.204 0 0.083 0 0.369 0 0.369 0 0.104-0.042 0.225-0.042 0.333v1.784c-0.091-0.266-0.45-0.175-0.616-0.441 0.065-0.016 0.134-0.021 0.2-0.008 -0.125-0.424-0.466-0.457-0.532-0.582 0 0.175-0.075 0.582 0.042 0.757 0.026-0.031 0.065-0.064 0.113-0.092 0.141 0.308 0.777 0.309 0.927 0.816C22.423 12.659 22.856 12.443 23.159 12.118z'/%3E %3Cpath d='M22.303 10.634c0.141 0 0.59-0.046 0.753-0.046 0.042 0 0.077-0.063 0.077-0.141s-0.034-0.141-0.077-0.141c-0.162 0-0.611-0.046-0.753-0.046 -0.141 0-0.59 0.046-0.753 0.046 -0.042 0-0.077 0.063-0.077 0.141s0.034 0.141 0.077 0.141C21.713 10.588 22.162 10.634 22.303 10.634z'/%3E %3Cpath d='M22.212 9.903c-0.03-0.024-0.069-0.039-0.113-0.039 -0.094 0-0.171 0.07-0.171 0.156 0 0.086 0.076 0.156 0.171 0.156 0.094 0 0.17-0.07 0.17-0.156 0-0.067 0.097-0.067 0.097 0 0 0.135-0.12 0.244-0.267 0.244 -0.148 0-0.267-0.109-0.267-0.244 0-0.135 0.12-0.244 0.267-0.244 0.044 0 0.086 0.01 0.123 0.027C22.219 9.825 22.212 9.867 22.212 9.903z'/%3E %3Cpath d='M21.551 10.588c0.042 0 0.076-0.063 0.076-0.141s-0.034-0.141-0.076-0.141'/%3E %3Cpath d='M21.613 10.588c0.042 0 0.076-0.063 0.076-0.141s-0.034-0.141-0.076-0.141'/%3E %3Cpath d='M22.024 10.617c0.051 0 0.092-0.076 0.092-0.17 0-0.094-0.041-0.17-0.092-0.17'/%3E %3Cpath d='M22.119 10.624c0.053 0 0.096-0.08 0.096-0.178 0-0.098-0.043-0.178-0.096-0.178'/%3E %3Cpath d='M22.439 10.626c0.054 0 0.097-0.081 0.097-0.18 0-0.099-0.044-0.18-0.097-0.18'/%3E %3Cpath d='M22.539 10.621c0.053 0 0.096-0.078 0.096-0.174 0-0.096-0.043-0.174-0.096-0.174'/%3E %3Cpath d='M22.986 10.59c0.043 0 0.078-0.064 0.078-0.144s-0.035-0.144-0.078-0.144'/%3E %3Cpath d='M21.376 12.03c0.051-0.031 0.113-0.059 0.178-0.074'/%3E %3Cpath d='M23.068 12.047c-0.015-0.011-0.032-0.022-0.049-0.035'/%3E %3Cpath d='M23.159 12.118c0.116-0.125 0.213-0.266 0.267-0.428'/%3E %3Cpath fill='%23FFF' d='M21.922 8.87c0-0.041 0.033-0.058 0.072-0.087 0.047-0.035 0.066-0.052 0.108-0.052h0.546c0.04 0 0.05 0.01 0.05 0.048V9.52c0 0.037-0.009 0.048-0.05 0.048h-0.726V8.862'/%3E %3Cpath fill='%23E5E5E5' d='M22.513 9.633c0.072 0 0.059-0.002 0.109-0.052 0.053-0.052 0.048-0.048 0.048-0.096V8.806c0-0.035-0.009-0.045-0.046-0.045h-0.505c-0.04 0-0.057 0.016-0.1 0.049 -0.036 0.027-0.066 0.044-0.066 0.082v0.741H22.513z'/%3E %3Cpath fill='%23FFF' d='M22.567 9.617c0 0.037-0.009 0.048-0.05 0.048h-0.546c-0.041 0-0.049-0.01-0.049-0.048V8.875c0-0.037 0.009-0.048 0.049-0.048h0.546c0.041 0 0.05 0.01 0.05 0.048V9.617z'/%3E %3Cpath fill='%2396877D' d='M23.625 6.847c0.106 0.119 0.141 0.278 0.083 0.434h-0.158c0.066-0.2 0.025-0.39-0.258-0.415 -0.423-0.037-0.915 0.782-1.655 0.881 -0.216-0.258-0.205-0.749 0.07-0.982 -0.142-0.409-0.441-0.859-0.649-1.053 -0.136-0.022-0.293-0.033-0.394-0.027 0.108-0.233 0.416-0.478 0.666-0.578 0.04-0.059 0.084-0.116 0.124-0.167 0.025-0.32 1.547-0.17 1.871 0.029C23.326 5.328 23.467 6.523 23.625 6.847z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='M21.781 7.066c-0.036-0.554-0.26-1.011-0.575-1.322 0.15 0.042 0.457 0.042 0.665-0.108 0.274-0.183 0.99-0.503 1.252-0.366 0.021 0.046 0.033 0.15 0.017 0.216 -0.062-0.166-0.753 0.091-0.948 0.17 -0.187 0.087-0.27 0.204-0.204 0.466 -0.108-0.091-0.071-0.179-0.183-0.245C21.85 5.985 21.887 6.18 21.9 6.338c-0.042-0.112-0.116-0.353-0.279-0.495 0.141 0.274 0.264 0.933 0.206 1.283 0.112 0 0.36-0.11 0.459-0.189 -0.087 0.125-0.339 0.212-0.501 0.245 -0.073 0.087-0.123 0.312-0.119 0.437C21.655 7.465 21.703 7.09 21.781 7.066z'/%3E %3Cpath d='M23.625 6.847c-0.138-0.153-0.395-0.236-0.723-0.147 0.05-0.025 0.158-0.067 0.254-0.083 -0.012-0.087-0.091-0.462-0.104-0.553l0.092-0.037c0.046 0.225 0.104 0.482 0.141 0.586 0.029 0.008 0.096 0.021 0.154 0.05 -0.025-0.087-0.166-0.715-0.162-0.782l0.125-0.067C23.451 6.155 23.53 6.65 23.625 6.847z'/%3E %3C/g%3E %3Cpath fill='%2396877D' d='M23.551 7.282c0.066-0.2 0.025-0.39-0.258-0.415 -0.219-0.019-0.457 0.194-0.738 0.415H23.551z'/%3E %3Cpath fill='%2396877D' d='M21.713 5.49c-0.125 0.017-0.403-0.008-0.545-0.054 0.008-0.038 0.023-0.076 0.041-0.118 -0.087 0.058-0.253 0.172-0.316 0.251C21.093 5.611 21.505 5.632 21.713 5.49z'/%3E %3Cpath fill='none' d='M21.708 6.766c0.046 0.133 0.076 0.261 0.08 0.375'/%3E %3Cpath fill='none' d='M21.331 5.108c-0.075 0.11-0.141 0.228-0.163 0.328 0.141 0.046 0.42 0.071 0.545 0.054'/%3E %3Cpath fill='none' d='M21.059 5.713c0.054 0.009 0.104 0.019 0.147 0.031 0.15 0.042 0.457 0.042 0.665-0.108 0.208-0.15 0.773-0.615 1.414-0.665'/%3E %3Cpath fill='none' d='M20.894 5.569c0.2 0.042 0.612 0.062 0.819-0.079 0.482-0.328 0.948-0.52 1.414-0.545'/%3E %3Cpath fill='%23337321' d='M24.382 7.765c0.698 0.482 1.214 0.948 1.364 1.696 0.15 0.748 0.433 0.948 0.782 0.748 -0.083 0.432-0.516 0.482-0.881 0.15 0.033 0.499-0.166 1.098-0.682 1.314 -0.033-0.299 0.165-0.536 0.108-0.782 -0.025-0.108-0.033-0.358 0.108-0.474 -0.274 0.091-0.707-0.083-0.748-0.491 0.316 0.15 0.723 0.175 0.881-0.225C25.471 9.303 25.405 8.621 24.382 7.765z'/%3E %3Cpath fill='%23337321' d='M25.264 3.873c0.216-0.565 0.782-0.507 0.973-0.266 0.557-0.316 0.632 0.399 1.106 0.258 -0.008 0.133-0.166 0.258-0.341 0.249 0.183 0.166-0.075 0.416 0.316 0.565 -0.333 0.166-0.798-0.008-0.923-0.466 -0.108 0.216-0.499 0.216-0.657 0.042 0.341-0.091 0.316-0.407 0.125-0.532C25.67 3.597 25.33 3.648 25.264 3.873z'/%3E %3Cpath fill='%23337321' d='M23.577 5.118c0.155 0.5 0.476 0.966 0.822 1.283 0.399 0.366 1.002 0.274 1.339-0.075 0.008 0.696-0.713 0.75-1.114 0.532 -0.177-0.096-0.32-0.046-0.15 0.108 0.258 0.233 0.822 0.406 1.488 0.549 1.164 0.249 0.749 1.173 0.408 1.164 0.098-0.002 0.178-0.104 0.037-0.231 -1.01-0.909-3.064-0.551-3.031-2.58 -0.216 0.532-1.106 0.324-0.69-0.308 0.133 0.108 0.366 0.116 0.433-0.05 0.052-0.129 0.018-0.354-0.215-0.548 0.038-0.003 0.121 0 0.112-0.096 0.01 0.056 0.061 0.139 0.192 0.111 0.037 0.059 0.077 0.098 0.13 0.077 0.01-0.004 0.042-0.02 0.029-0.079C23.377 5.087 23.508 5.126 23.577 5.118z'/%3E %3Cpath d='M24.623 6.858c0.482 0.316 1.028 0.316 1.53-0.266 0.158-0.183 0.407-0.341 0.582-0.358 0.175-0.017 0.166-0.183 0.299-0.216 -0.083-0.025-0.116-0.125-0.241-0.112 0.312-0.108 0.22-0.358 0.374-0.478 -0.125 0.046-0.32-0.141-0.499 0.096 0.046-0.108-0.017-0.237-0.062-0.287 0.017 0.125-0.245 0.15-0.295 0.466 -0.028 0.177-0.125 0.166-0.141-0.108 -0.012-0.201-0.108-0.757-0.224-1.039 -0.116-0.283-0.143-0.671 0.015-0.729 -0.024-0.04-0.057-0.076-0.098-0.102 -0.193-0.126-0.532-0.075-0.599 0.15 -0.216 0.565 0.391 0.89 0.341 1.505 -0.091-0.457-0.832-0.574-0.823-1.023 -0.241 0.108-0.208 0.308-0.116 0.466 -0.15-0.233-0.491 0.15-0.782-0.166 -0.033 0.416 0.333 0.574 0.632 0.59 -0.15 0.266 0.05 0.491 0.249 0.565 0.008-0.466 0.963-0.275 0.973 0.524C25.746 7.016 25.014 7.074 24.623 6.858z'/%3E %3Cpath d='M25.962 7.515c1.164 0.249 0.749 1.173 0.408 1.164 -0.217-0.005-0.424-0.187-0.437-0.345 -0.249 0.133-0.183 0.395 0.008 0.499 -0.524-0.062-0.744 0.283-0.757 0.661 0.096-0.175 0.387-0.187 0.495-0.15 0.108 0.037 0.387 0.058 0.499-0.067 -0.092 0.079 0.058 0.262-0.071 0.403 0.437-0.017 0.628-0.424 0.553-0.603C27.226 8.563 27.118 7.723 25.962 7.515z'/%3E %3Cpath d='M25.076 11.466c0.076 0.047 0.066 0.147 0.015 0.21 -0.103 0.126 0.052 0.427-0.265 0.478 -0.094 0.015-0.163-0.045-0.194-0.152 -0.086-0.296 0.226-0.316 0.259-0.455C24.925 11.409 25.012 11.426 25.076 11.466z'/%3E %3Cpath d='M24.79 12.003c0.102 0.052 0.19 0.124 0.136 0.456 -0.023 0.138-0.028 0.473 0.093 0.482 -0.076 0.034-0.235 0.067-0.297-0.021 -0.067 0.102-0.207 0.066-0.258-0.066 -0.077 0.057-0.175-0.049-0.171-0.137 -0.067 0.039-0.194-0.026-0.154-0.224 -0.08 0.025-0.18-0.035-0.215-0.087 0.117-0.019 0.415-0.165 0.49-0.288C24.488 11.996 24.671 11.943 24.79 12.003z'/%3E %3Cpath fill='none' d='M24.721 12.921c0.034-0.045 0.054-0.24 0.035-0.359'/%3E %3Cpath fill='none' d='M24.464 12.855c0.053-0.037 0.155-0.168 0.176-0.286'/%3E %3Cpath fill='none' d='M24.292 12.718c0.066-0.028 0.232-0.226 0.272-0.357'/%3E %3Cpath fill='none' d='M24.138 12.494c0.077-0.013 0.318-0.157 0.421-0.316'/%3E %3Cpath d='M23.376 5.869c-0.014 0.852 0.34 1.284 0.831 1.564 -0.182-0.109-0.103-0.483-0.349-0.604 0.058-0.004 0.15 0.079 0.295 0.046 -0.071-0.158-0.187-0.399-0.457-0.432 0.071-0.008 0.225 0.017 0.324-0.021C23.879 6.205 23.505 6.309 23.376 5.869z'/%3E %3Cpath d='M23.288 5.058c-0.03-0.01-0.055-0.04-0.08-0.079 -0.131 0.028-0.182-0.055-0.192-0.111 0.008 0.096-0.074 0.092-0.113 0.095 0.234 0.194 0.268 0.419 0.216 0.548 -0.067 0.166-0.299 0.158-0.433 0.05 -0.017 0.353 0.441 0.47 0.607 0.025 0 0.075 0.096 0.067 0.121 0.166C23.532 5.561 23.442 5.286 23.288 5.058z'/%3E %3Cpath fill='%23337321' d='M22.557 3.37c-0.208-0.191-0.304-0.511-0.295-0.694 0.008-0.183 0.083-0.383 0.349-0.299 -0.083 0-0.025 0.166-0.112 0.183 0.071 0.025 0.166-0.033 0.179-0.071 0.017 0.058 0.125 0.042 0.133 0.108 0.042-0.033-0.004-0.195-0.066-0.229 0.046-0.025 0.071-0.154 0.05-0.216 -0.042 0.008-0.104 0.067-0.116 0.15 0.021-0.067-0.004-0.233-0.121-0.258 -0.033 0.046-0.042 0.158 0.004 0.22 -0.108-0.025-0.266 0.046-0.304 0.137 0.008-0.11 0.024-0.267 0.092-0.366 0.023-0.033-0.033-0.091-0.077-0.012 -0.081-0.158-0.297-0.241-0.393-0.162s-0.224-0.037-0.303 0.087c-0.079 0.125-0.347 0.138-0.333 0.27 0.008 0.079-0.011 0.201-0.05 0.245 -0.096 0.108 0.046 0.187 0.071 0.283 -0.017-0.316 0.486-0.931 0.99-0.69 -0.046 0.079-0.086 0.237-0.1 0.428 -0.021 0.283 0.021 0.682 0.295 0.915L22.557 3.37z'/%3E %3Cpath fill='%23CF142B' d='M22.706 2.38c-0.003-0.075 0.127-0.172 0.301-0.17 0.21 0.002 0.372 0.193 0.54 0.175 0.168-0.019 0.085 0.075 0.05 0.1 -0.035 0.025-0.056 0.062-0.044 0.108 0.012 0.046-0.009 0.076-0.077 0.033 -0.15-0.094-0.299 0.037-0.497-0.035C22.81 2.527 22.711 2.492 22.706 2.38z'/%3E %3Cpath fill='%2396877D' d='M21.85 4.343c-0.083-0.262-0.399-0.549-0.553-0.615l-0.008-0.141c0.083-0.033 0.283-0.191 0.374-0.279 0.624 0.299 1.472-0.125 1.863-0.565l0.15 0.091 -0.075 0.1 -0.079-0.042c-0.096 0.116-0.453 0.452-0.561 0.523 0.145 0.037 0.344 0.062 0.399 0.059C23.709 3.224 23.983 3 24.116 2.983l0.112 0.15 -0.1 0.071 -0.079-0.046c-0.374 0.308-0.798 0.981-0.965 1.43C22.852 4.538 22.02 4.571 21.85 4.343z'/%3E %3Cpath fill='none' d='M22.961 3.415c-0.054-0.014-0.1-0.029-0.129-0.045 -0.067 0.062-0.233 0.116-0.445 0.125'/%3E %3Cpath fill='none' d='M21.883 4.251c-0.056-0.31 0.033-0.653 0.191-0.757 0.345 0.229 0.936 0.229 1.285-0.021'/%3E %3Cpath fill='none' d='M21.883 4.089c0.266-0.008 0.844 0.037 0.985 0.058 0.141 0.021 0.378 0.079 0.345 0.15'/%3E %3Cpath fill='none' d='M22.006 4.045l0.077-0.076 -0.077-0.076L21.93 3.968 22.006 4.045z'/%3E %3Cpath fill='%23337321' d='M22.187 2.497c-0.096-0.133-0.359-0.175-0.416 0.004 -0.025 0.079-0.062 0.162-0.125 0.2 -0.062 0.037-0.048 0.151-0.021 0.2 0.066 0.121 0.008 0.237 0.137 0.316 0-0.096 0.141-0.195 0.262-0.22 0.121-0.025 0.303-0.133 0.328-0.254C22.378 2.621 22.42 2.521 22.187 2.497z'/%3E %3Cpath fill='%2396877D' d='M21.588 3.694h0.033l0.001 0.227c0.007 0.002 0.014 0.006 0.02 0.01l0.196-0.113 0.017 0.029 -0.197 0.114c0.001 0.007 0.002 0.015 0.001 0.022l0.196 0.113 -0.017 0.029L21.64 4.013c-0.005 0.005-0.012 0.01-0.019 0.012l0 0.226h-0.033l0-0.227c-0.007-0.002-0.014-0.006-0.02-0.01l-0.196 0.113 -0.017-0.029 0.197-0.114c-0.001-0.007-0.002-0.015-0.001-0.022l-0.196-0.113 0.017-0.029 0.197 0.113c0.005-0.005 0.012-0.01 0.019-0.012L21.588 3.694 21.588 3.694z'/%3E %3Cpath fill='%2396877D' d='M21.884 4.25c-0.071 0.072-0.17 0.116-0.28 0.116 -0.218 0-0.394-0.176-0.394-0.394 0-0.218 0.176-0.394 0.394-0.394 0.128 0 0.241 0.061 0.313 0.155 -0.02 0.05-0.044 0.161-0.046 0.211 -0.014-0.136-0.128-0.242-0.268-0.242 -0.149 0-0.269 0.121-0.269 0.269 0 0.149 0.121 0.269 0.269 0.269 0.124 0 0.232-0.087 0.263-0.202C21.867 4.09 21.869 4.209 21.884 4.25z'/%3E %3Cpath fill='%23337321' d='M21.438 4.625c-0.025-0.029-0.071-0.108-0.066-0.166 0.037-0.004 0.108 0.021 0.141 0.054 -0.004-0.042-0.021-0.133-0.012-0.175 0.046 0.017 0.141 0.071 0.175 0.133 -0.008-0.042-0.025-0.15-0.008-0.216 0.05 0.029 0.133 0.108 0.15 0.162 0.004-0.083 0.033-0.22 0.058-0.254 0.037 0.037 0.096 0.071 0.133 0.121 0.008-0.067 0.042-0.146 0.091-0.166 0.037 0.042 0.096 0.137 0.108 0.245 0.037-0.012 0.087-0.075 0.108-0.108 0.021 0.033 0.042 0.091 0.029 0.162 0.046-0.042 0.1-0.1 0.112-0.15 0.033 0.025 0.096 0.087 0.112 0.154 -0.008-0.054-0.004-0.15-0.021-0.204 0.062 0.033 0.112 0.091 0.125 0.154 0.017-0.058 0.054-0.162 0.087-0.187 0.033 0.067 0.067 0.146 0.062 0.212 0.021-0.042 0.054-0.116 0.087-0.133 0.029 0.046 0.025 0.146 0.017 0.2 0.029-0.042 0.083-0.091 0.116-0.108 0.004 0.025 0.008 0.075 0 0.112 0.037-0.021 0.1-0.133 0.121-0.191 0.058 0.029 0.116 0.129 0.121 0.179 0.042-0.017 0.125-0.091 0.15-0.133 0 0.029 0.013 0.108-0.004 0.17 0.025-0.025 0.05-0.075 0.062-0.096 0.017 0.042 0.004 0.141-0.013 0.195 0.037-0.033 0.092-0.054 0.125-0.054 0.004 0.071-0.046 0.195-0.092 0.287C23.114 4.713 22.278 4.671 21.438 4.625z'/%3E %3Cpath stroke='none' d='M22.83 2.423c-0.002-0.031 0.066-0.1 0.189-0.099 0.147 0.001 0.283 0.109 0.4 0.101 0.118-0.008 0.06 0.031 0.035 0.041 -0.025 0.01-0.039 0.026-0.031 0.044 0.009 0.019-0.006 0.031-0.054 0.014 -0.105-0.038-0.21 0.015-0.348-0.014C22.902 2.483 22.833 2.469 22.83 2.423z'/%3E %3Cpath d='M21.567 4.875C21.442 5.025 21.318 5 21.293 4.904c-0.025-0.096 0.067-0.141 0.033-0.225 -0.033-0.083 0.054-0.121 0.096-0.083 0.042 0.037 0.175-0.083 0.233 0.042 0.058 0.125 0.104 0.212 0.071 0.262C21.692 4.95 21.592 4.925 21.567 4.875z'/%3E %3Cpath d='M22.103 4.65c-0.023-0.055 0.106-0.16 0.173-0.085 0.067 0.075 0.171-0.081 0.229 0.037 0.058 0.119 0.077 0.181 0.106 0.247 0.029 0.067-0.158 0.102-0.216 0.044 0.008 0.039-0.162 0.07-0.208-0.042C22.162 4.792 22.135 4.723 22.103 4.65z'/%3E %3Cpath d='M22.968 4.719c-0.031-0.058 0.121-0.141 0.2-0.035 0.021-0.044 0.171-0.052 0.181 0.075 0.01 0.127 0.015 0.202 0.019 0.252 0.004 0.05-0.091 0.096-0.16-0.031 -0.123 0.025-0.179-0.044-0.193-0.116C23 4.79 22.985 4.754 22.968 4.719z'/%3E %3Cpath fill='%23337321' d='M21.648 4.636c-0.019-0.042 0.106-0.125 0.191-0.062 0.085 0.062 0.203-0.054 0.254 0.058 0.102 0.227 0.108 0.243 0.077 0.287 -0.031 0.044-0.164 0.027-0.198-0.033 -0.006 0.042-0.121 0.035-0.181 0.002C21.723 4.85 21.675 4.711 21.648 4.636z'/%3E %3Cpath fill='%23337321' d='M22.523 4.646c-0.029-0.064 0.166-0.121 0.252-0.008 0.044-0.04 0.139-0.042 0.193 0.081 0.054 0.123 0.062 0.191 0.023 0.222 -0.028 0.022-0.129 0.039-0.162-0.017 -0.046 0.029-0.187 0.004-0.218-0.075C22.58 4.771 22.553 4.702 22.523 4.646z'/%3E %3Cpath fill='%23337321' d='M23.351 4.769c-0.004-0.058 0.102-0.085 0.141 0 0.04 0.085 0.166 0.008 0.177 0.15 0.002 0.027-0.015 0.131-0.054 0.181s-0.233 0-0.245-0.106C23.357 4.887 23.353 4.827 23.351 4.769z'/%3E %3Cg fill='none'%3E %3Cpath d='M21.567 4.875c-0.046-0.062-0.108-0.162-0.187-0.054'/%3E %3Cpath d='M21.973 4.885c-0.027-0.035-0.062-0.094-0.075-0.139'/%3E %3Cpath d='M22.395 4.894c-0.029-0.021-0.073-0.062-0.096-0.106'/%3E %3Cpath d='M22.357 4.675c0.073 0.008 0.123 0.077 0.145 0.108 0.023 0.031 0.071 0.087 0.108 0.094'/%3E %3Cpath d='M22.829 4.925c-0.025-0.04-0.05-0.075-0.056-0.104'/%3E %3Cpath d='M22.775 4.638c0.025 0.035 0.044 0.064 0.058 0.098'/%3E %3Cpath d='M23.207 4.979c-0.033-0.062-0.085-0.123-0.129-0.143'/%3E %3Cpath d='M23.191 4.75c0.004 0.123 0.168 0.131 0.175 0.218'/%3E %3Cpath d='M23.492 4.769c0.017 0.031 0.023 0.062 0.025 0.114'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 45 30'%3E %3Crect fill='%23ED0000' width='45' height='30'/%3E %3Cpath stroke='%23FFF' stroke-width='6' d='M0,9 h 45 m -45,12 h 45'/%3E %3Cpath fill='%230050F0' d='M0,0L25.98076,15L0,30z'/%3E %3Ccomment%3Ethe star is in the center of gravity of the triangle, so the x-pos is irrational (tan(30 deg) * 15)%3C/comment%3E %3Cg fill='%23FFF' transform='translate(8.6602540378443864676372317075294,15) scale(5)'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23triangle' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 6 3'%3E%3Crect fill='%23007A3D' width='6' height='3'/%3E%3Crect fill='%23FFF' width='6' height='2'/%3E%3Crect width='6' height='1'/%3E%3Cpath fill='%23CE1126' d='M0,0l2,1.5L0,3Z'/%3E%3C/svg%3E"

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='400'%3E %3Crect width='600' height='400' fill='%23f00'/%3E %3Crect width='240' height='400' fill='%23060'/%3E %3Cg fill='%23ff0' fill-rule='evenodd' stroke='%23000' stroke-width='0.573' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='m318.24,262.04c-30.21-0.91-168.74-87.38-169.69-101.15l7.6496-12.757c13.741,19.966,155.36,104.06,169.27,101.08l-7.2299,12.823'/%3E %3Cpath d='m154.59,146.4c-2.7101,7.2937,36.149,31.318,82.903,59.754,46.752,28.434,87.065,46.006,90.053,43.486,0.18256-0.32544,1.4701-2.5409,1.352-2.5232-0.56001,0.84402-1.9234,1.1104-4.0506,0.49741-12.631-3.6433-45.575-18.765-86.374-43.506-40.798-24.743-76.294-47.544-81.811-57.232-0.38363-0.67116-0.65702-1.8962-0.60146-2.8487l-0.13405-0.002-1.1747,2.0532-0.16139,0.32191h-0.00088zm164.36,116.04c-0.51238,0.92957-1.4675,0.96044-3.2816,0.76112-11.3-1.2506-45.589-17.925-86.162-42.213-47.21-28.26-86.2-54.01-81.97-60.74l1.1509-2.0346,0.22665,0.0706c-3.8037,11.405,76.948,57.578,81.702,60.522,46.724,28.947,86.115,45.851,89.601,41.458l-1.2682,2.181v-0.002z'/%3E %3Cpath d='m240.17,169.23c30.237-0.23901,67.55-4.1319,89.023-12.69l-4.6265-7.5168c-12.692,7.0247-50.21,11.644-84.652,12.335-40.736-0.37483-69.49-4.1681-83.897-13.835l-4.3672,8.0045c26.484,11.207,53.623,13.587,88.52,13.703'/%3E %3Cpath d='m330.44,156.71c-0.73904,1.1818-14.743,6.0113-35.373,9.5753-13.988,2.1325-32.234,3.9555-55.004,3.9776-21.633,0.0203-39.305-1.5196-52.684-3.3329-21.656-3.3955-32.833-8.1201-36.965-9.7896,0.39509-0.78581,0.64908-1.337,1.0301-2.0708,11.895,4.736,23.124,7.5918,36.279,9.6158,13.291,1.8,30.75,3.362,52.276,3.3417,22.664-0.0229,40.709-1.9844,54.616-4.0534,21.155-3.4122,32.711-7.8034,34.334-9.8425l1.494,2.5788h-0.002zm-4.0603-7.6226c-2.293,1.8415-13.718,5.8932-33.819,9.1034-13.415,1.9226-30.472,3.6433-52.265,3.6645-20.704,0.0203-37.619-1.375-50.485-3.2491-20.414-2.6661-31.279-7.4754-35.196-8.8776,0.3898-0.67381,0.78666-1.3423,1.1941-2.0135,3.0479,1.5346,13.533,5.7909,34.226,8.7224,12.72,1.8036,29.661,3.1477,50.262,3.1265,21.69-0.0221,38.553-1.7762,51.883-3.6883,20.205-2.7799,31.077-7.9472,32.728-9.241l1.4728,2.4509v0.002z'/%3E %3Cpath d='m140.88,205.66c18.598,10.003,59.905,15.044,98.994,15.391,35.591,0.0564,81.958-5.5016,99.297-14.69l-0.47712-10.012c-5.4246,8.4773-55.113,16.609-99.206,16.276-44.093-0.3325-85.038-7.1429-98.687-15.959l0.0794,8.9914'/%3E %3Cpath d='m340.12,204.22,0.00088,2.3874c-2.606,3.1159-18.946,7.8255-39.437,11.142-15.595,2.391-35.927,4.1945-61.262,4.1945-24.069,0-43.263-1.7163-58.148-4.0014-23.529-3.4264-38.579-9.4262-41.6-11.217l0.0132-2.7852c9.0748,6.0334,33.661,10.447,41.917,11.798,14.788,2.2701,33.868,3.9732,57.817,3.9732,25.216,0,45.434-1.7912,60.931-4.1663,14.701-2.1237,35.644-7.6465,39.767-11.324h0.00088zm0.01-8.4922,0.00088,2.3874c-2.606,3.1142-18.946,7.8237-39.437,11.14-15.595,2.391-35.927,4.1945-61.262,4.1945-24.069,0-43.263-1.7145-58.148-4.0014-23.529-3.4246-38.579-9.4245-41.6-11.216l0.0132-2.7852c9.0748,6.0325,33.661,10.447,41.917,11.796,14.788,2.2719,33.868,3.9758,57.817,3.9758,25.216,0,45.434-1.7921,60.931-4.169,14.701-2.1237,35.644-7.6465,39.767-11.324l0.00088,0.002z'/%3E %3Cpath d='m239.79,260.32c-42.772-0.25489-79.421-11.659-87.16-13.544l5.6433,8.8344c13.67,5.7503,49.424,14.32,81.927,13.371,32.504-0.94809,60.91-3.466,80.928-13.211l5.7862-9.1555c-13.642,6.425-60.068,13.639-87.125,13.705'/%3E %3Cpath stroke-width='0.55' d='m323.3,253.72c-0.85016,1.2991-1.7171,2.5823-2.5963,3.8294-9.4417,3.3293-24.319,6.8245-30.597,7.844-12.824,2.6423-32.665,4.594-50.274,4.6029-37.89-0.55474-68.905-7.9719-83.496-14.299l-1.1773-2.0241,0.19225-0.30427,1.9966,0.77435c25.948,9.2834,55.091,12.987,82.698,13.652,17.538,0.0617,35.095-2.01,49.292-4.5491,21.771-4.3621,30.574-7.65,33.275-9.1405l0.68701-0.38541h-0.00088zm5.0172-8.2753c0.022,0.0256,0.0441,0.0503,0.0653,0.0776-0.63585,1.0733-1.2911,2.1652-1.9622,3.2623-5.0357,1.8-18.702,5.7988-38.659,8.5893-13.149,1.7912-21.322,3.526-47.479,4.034-49.015-1.2471-80.75-10.831-88.289-13.195l-1.1174-2.1431c28.406,7.4154,57.422,12.592,89.408,13.121,23.931-0.50976,34.112-2.2719,47.152-4.0499,23.271-3.6186,34.996-7.4498,38.515-8.5558-0.0441-0.0635-0.0961-0.13053-0.15433-0.19932l2.5231-0.9428-0.002,0.002z'/%3E %3Cpath d='m328.83,197.76c0.13873,28.137-14.26,53.386-25.858,64.525-16.408,15.759-38.163,25.896-63.569,26.363-28.37,0.52117-55.12-17.974-62.295-26.099-14.028-15.885-25.449-36.057-25.815-63.243,1.7376-30.709,13.793-52.1,31.268-66.769s40.743-21.813,60.121-21.302c22.358,0.59003,48.475,11.558,66.521,33.332,11.823,14.266,16.943,29.748,19.627,53.193zm-89.186-96.342c54.485,0,99.296,44.338,99.296,98.703,0,54.364-44.811,98.704-99.296,98.704s-98.924-44.339-98.924-98.704,44.439-98.703,98.924-98.703'/%3E %3Cpath d='m239.91,101.08c54.534,0,99.011,44.483,99.011,99.022,0,54.538-44.478,99.02-99.011,99.02-54.534,0-99.011-44.481-99.011-99.02s44.478-99.022,99.011-99.022zm-96.832,99.0224c0,53.26,43.736,96.842,96.832,96.842,53.097,0,96.833-43.582,96.833-96.842,0-53.262-43.737-96.844-96.833-96.844s-96.832,43.584-96.832,96.844z'/%3E %3Cpath d='m239.99,109.31c49.731,0,90.693,40.821,90.693,90.704,0,49.884-40.963,90.703-90.693,90.703s-90.693-40.819-90.693-90.703c0-49.883,40.964-90.704,90.693-90.704zm-88.515,90.7034c0,48.685,39.979,88.524,88.515,88.524s88.515-39.839,88.515-88.524c0-48.686-39.978-88.525-88.515-88.525-48.536,0-88.515,39.839-88.515,88.525z'/%3E %3Cpath d='m243.98,100.68-8.48545,0,0.01,198.96,8.51455,0z'/%3E %3Cpath d='m243.13,99.546h2.1598l0.0185,201.25h-2.1616l-0.0159-201.25zm-8.4213,0.0018h2.1766l0.003,201.25h-2.1783v-201.25z'/%3E %3Cpath d='m338.99,203.935,0-7.3554-5.99-5.58-34-9-49-5-59,3-42,10-8.48,6.28,0,7.3572l21.48-9.637,51-8h49l36,4,25,6z'/%3E %3Cpath d='m239.95,184.77c23.383-0.0432,46.07,2.2154,64.065,5.7194,18.569,3.7121,31.637,8.3556,36.105,13.571l-0.005,2.5823c-5.3884-6.4902-22.973-11.248-36.518-13.968-17.858-3.474-40.393-5.7168-63.647-5.6736-24.538,0.0459-47.387,2.3698-64.984,5.8032-14.12,2.8019-32.951,8.3679-35.302,13.858v-2.689c1.2911-3.8003,15.313-9.4792,34.984-13.417,17.729-3.4572,40.62-5.7415,65.302-5.7864zm0.01-8.4922c23.383-0.0423,46.07,2.2172,64.065,5.7194,18.569,3.7139,31.637,8.3556,36.105,13.571l-0.005,2.5823c-5.3884-6.4885-22.973-11.247-36.518-13.966-17.858-3.4757-40.393-5.7185-63.647-5.6736-24.538,0.0441-47.276,2.3698-64.875,5.8014-13.626,2.5832-33.226,8.3696-35.412,13.86v-2.6908c1.2911-3.7588,15.597-9.6414,34.985-13.417,17.729-3.4572,40.62-5.7397,65.302-5.7864z'/%3E %3Cpath d='m239.48,132.96c36.849-0.18433,68.99,5.1523,83.695,12.685l5.3638,9.279c-12.781-6.888-47.456-14.05-89.005-12.979-33.854,0.20814-70.027,3.7271-88.176,13.41l6.4035-10.709c14.895-7.7241,50.022-11.643,81.72-11.684'/%3E %3Cpath d='m239.97,140.62c21.017-0.0556,41.325,1.1298,57.476,4.0437,15.041,2.7993,29.385,7.0009,31.436,9.2604l1.5901,2.8099c-4.9881-3.257-17.401-6.8836-33.339-9.906-16.006-3.0083-36.3-4.0049-57.2-3.9502-23.722-0.0811-42.152,1.1712-57.969,3.9291-16.728,3.13-28.334,7.6015-31.197,9.7261l1.5583-2.9704c5.5631-2.8381,14.39-6.2592,29.223-8.9297,16.357-2.988,34.983-3.8841,58.423-4.0128h-0.00088zm-0.009-8.4843c20.113-0.0529,39.972,1.068,55.452,3.8506,12.209,2.3768,24.283,6.0872,28.704,9.3892l2.3256,3.6954c-3.9536-4.3947-18.836-8.5593-31.974-10.892-15.361-2.6494-34.395-3.698-54.508-3.8656-21.108,0.0591-40.615,1.352-55.752,4.1081-14.441,2.7481-23.76,6.0016-27.703,8.5425l2.0451-3.0868c5.4414-2.8646,14.232-5.4954,25.303-7.6465,15.249-2.7764,34.876-4.0358,56.108-4.0949z'/%3E %3Cpath d='m289.15,241.26c-18.218-3.4008-36.469-3.8947-49.217-3.7447-61.407,0.71967-81.244,12.609-83.665,16.209l-4.5894-7.4815c15.634-11.332,49.073-17.687,88.587-17.037,20.518,0.33602,38.224,1.6986,53.119,4.5835l-4.2358,7.4727'/%3E %3Cpath stroke-width='0.55' d='m239.58,236.46c17.082,0.25488,33.849,0.96044,50.033,3.9784l-1.172,2.069c-15.031-2.7746-31.055-3.8365-48.803-3.75-22.663-0.17727-45.585,1.9394-65.541,7.6668-6.2968,1.7524-16.721,5.8006-17.784,9.1458l-1.1659-1.9226c0.33601-1.9773,6.6363-6.081,18.414-9.3901,22.858-6.5458,44.239-7.6491,66.019-7.799v0.002zm0.77519-8.5963c17.698,0.33073,35.975,1.1492,53.74,4.6681l-1.2206,2.1537c-16.042-3.1847-31.369-4.2466-52.415-4.5702-22.735,0.0414-46.851,1.6625-68.778,8.0372-7.0791,2.062-19.297,6.5202-19.704,10.05l-1.1659-2.0655c0.26545-3.2059,10.842-7.388,20.358-10.156,22.096-6.4241,46.275-8.076,69.186-8.1174z'/%3E %3Cpath d='M327.58,247.38,320.201,258.829,299,240,244,203,182,169,149.81,157.99,156.67,145.27,159,144l20,5,66,34,38,24,32,23,13,15z'/%3E %3Cpath d='m148.65,158.29c5.646-3.8294,47.139,14.655,90.555,40.834,43.301,26.254,84.677,55.921,80.942,61.473l-1.2285,1.9323-0.56354,0.4445c0.12083-0.0864,0.74345-0.84755-0.0609-2.906-1.8449-6.0704-31.195-29.491-79.894-58.895-47.475-28.309-87.041-45.371-90.997-40.494l1.247-2.3892h-0.00089zm180.44,88.927c3.57-7.052-34.916-36.044-82.632-64.272-48.813-27.666-83.994-43.951-90.42-39.095l-1.4278,2.5991c-0.0124,0.14287,0.052-0.17727,0.35364-0.4101,1.1685-1.0195,3.1052-0.95074,3.9792-0.96662,11.065,0.16581,42.667,14.709,87.006,40.128,19.428,11.315,82.071,51.491,81.832,62.789,0.0168,0.97102,0.0803,1.1712-0.28485,1.6519l1.5936-2.4236v-0.002z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='0.67037' d='m180.6,211.01c0,16.271,6.6628,30.987,17.457,41.742,10.815,10.778,25.512,17.579,41.809,17.579,16.381,0,31.247-6.6525,42.016-17.389,10.769-10.735,17.443-25.552,17.446-41.88h-0.002v-79.189l-118.74-0.14111,0.0123,79.278h0.002z'/%3E %3Cpath fill='%23f00' stroke='%23000' stroke-width='0.50734' d='m182.82,211.12v0.045c0,15.557,6.4414,29.724,16.775,40.009,10.354,10.305,24.614,16.712,40.214,16.712,15.681,0,29.912-6.3606,40.222-16.626,10.308-10.265,16.697-24.433,16.699-40.044h-0.002v-76.826l-113.84-0.0185-0.0697,76.748m91.022-53.747,0.004,48.891-0.0414,5.1717h0.00088c0,1.3608-0.082,2.9122-0.24076,4.2333-0.92512,7.7294-4.4801,14.467-9.7451,19.708-6.1636,6.1357-14.671,9.9413-24.047,9.9413-9.327,0-17.639-3.9379-23.829-10.1-6.3497-6.32-10.03-14.986-10.03-23.947l-0.0132-54.023,67.94,0.12259,0.002,0.002z'/%3E %3Cg id='castle3'%3E %3Cg id='castle' fill='%23ff0' stroke='%23000' stroke-width='0.5'%3E %3Cpath stroke='none' d='m190.19,154.43c0.13493-5.521,4.0524-6.828,4.0806-6.8474,0.0282-0.0185,4.2314,1.4076,4.2173,6.8986l-8.2978-0.0512'/%3E %3Cpath d='m186.81,147.69-0.68172,6.3447,4.1406,0.009c0.0397-5.2493,3.9739-6.1225,4.0691-6.1031,0.0891-0.005,3.9889,1.1606,4.0929,6.1031h4.1511l-0.74962-6.3932-15.022,0.0379v0.002z'/%3E %3Cpath d='m185.85,154.06h16.946c0.35717,0,0.64908,0.35277,0.64908,0.78404,0,0.43039-0.29191,0.78141-0.64908,0.78141h-16.946c-0.35717,0-0.64908-0.35102-0.64908-0.78141,0-0.43127,0.29191-0.78404,0.64908-0.78404z'/%3E %3Cpath d='m192.01,154.03c0.0185-3.3126,2.2621-4.2501,2.2736-4.2483,0.00088,0,2.3423,0.96661,2.3609,4.2483h-4.6344'/%3E %3Cpath d='m186.21,145.05h16.245c0.34218,0,0.62263,0.31839,0.62263,0.70468,0,0.38717-0.28045,0.70467-0.62263,0.70467h-16.245c-0.34218,0-0.62263-0.31573-0.62263-0.70467,0-0.38629,0.28045-0.70468,0.62263-0.70468z'/%3E %3Cpath d='m186.55,146.47h15.538c0.32719,0,0.59529,0.31662,0.59529,0.70379,0,0.38805-0.2681,0.70467-0.59529,0.70467h-15.538c-0.32719,0-0.59529-0.31662-0.59529-0.70467,0-0.38717,0.2681-0.70379,0.59529-0.70379z'/%3E %3Cpath d='m191.57,135.88,1.2267,0.002v0.87136h0.89513v-0.89076l1.2567,0.004v0.88723h0.89778v-0.89076h1.2576l-0.002,2.0117c0,0.31574-0.25398,0.52035-0.54854,0.52035h-4.4113c-0.29633,0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z'/%3E %3Cpath d='m196.19,138.57,0.27691,6.4514-4.3028-0.0159,0.28486-6.4523,3.741,0.0168'/%3E %3Cpath id='cp1' d='m190.94,141.56,0.13141,3.4775-4.1256,0.002,0.11641-3.4793h3.8786-0.00089z'/%3E %3Cuse xlink:href='%23cp1' x='10.609'/%3E %3Cpath id='cp2' d='m186.3,139.04,1.1994,0.003v0.87224h0.8775v-0.89253l1.2294,0.004v0.889h0.87926v-0.89253l1.2302,0.002-0.002,2.0117c0,0.31398-0.2487,0.51859-0.5362,0.51859h-4.3169c-0.28926,0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z'/%3E %3Cuse xlink:href='%23cp2' x='10.609'/%3E %3Cpath fill='%23000' stroke='none' d='m193.9,140.61c-0.0265-0.62706,0.87661-0.63411,0.86603,0v1.5364h-0.866v-1.536'/%3E %3Cpath id='cp3' fill='%23000' stroke='none' d='m188.57,142.84c-0.003-0.6059,0.83693-0.61824,0.82635,0v1.1871h-0.826v-1.187'/%3E %3Cuse xlink:href='%23cp3' x='10.641'/%3E %3C/g%3E %3Cuse xlink:href='%23castle' y='46.3198'/%3E %3Cuse xlink:href='%23castle' transform='matrix(0.70460892,-0.70959585,0.70959585,0.70460892,-35.341459,275.10898)'/%3E %3C/g%3E %3Cuse xlink:href='%23castle' x='45.7138'/%3E %3Cuse xlink:href='%23castle3' transform='matrix(-1,0,0,1,479.79195,0)'/%3E %3Cg id='quina' fill='%23fff'%3E %3Cpath fill='%23039' d='m232.636,202.406v0.005c0,2.2119,0.84927,4.2272,2.2118,5.6894,1.3652,1.4667,3.2454,2.3777,5.302,2.3777,2.0672,0,3.9439-0.90487,5.3029-2.3654,1.3581-1.4587,2.2021-3.47219,2.2021-5.693v-10.768l-14.992-0.0123-0.0273,10.766'/%3E %3Ccircle cx='236.074' cy='195.735' r='1.486'/%3E %3Ccircle cx='244.392' cy='195.742' r='1.486'/%3E %3Ccircle cx='240.225' cy='199.735' r='1.486'/%3E %3Ccircle cx='236.074' cy='203.916' r='1.486'/%3E %3Ccircle cx='244.383' cy='203.905' r='1.486'/%3E %3C/g%3E %3Cuse xlink:href='%23quina' y='-26.016'/%3E %3Cuse xlink:href='%23quina' x='-20.799'/%3E %3Cuse xlink:href='%23quina' x='20.745'/%3E %3Cuse xlink:href='%23quina' y='25.784'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='500'%3E %3Crect fill='%234AADD6' width='800' height='500'/%3E %3Ccircle fill='%23FFDE00' cx='350' cy='250' r='150'/%3E %3C/svg%3E"

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='330'%3E %3Crect width='600' height='330' fill='%230038a8'/%3E %3Crect width='600' height='220' fill='%23fff'/%3E %3Crect width='600' height='110' fill='%23d52b1e'/%3E %3Cg%3E %3Cg fill='none' stroke='%23000'%3E %3Ccircle stroke-width='1.07585' cx='300' cy='165' r='42.2'/%3E %3Ccircle stroke-width='0.47815' cx='300' cy='165' r='34.67'/%3E %3Ccircle stroke-width='0.43816' cx='300' cy='165' r='26.56'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m277.53,181.28-4.8927,2.9054-1.4963-2.5198c-0.27744-0.46724-0.44945-0.84813-0.51601-1.1427-0.0666-0.29453-0.0363-0.58185,0.0908-0.86197,0.12709-0.28011,0.34638-0.51266,0.65787-0.69763,0.27145-0.16118,0.53998-0.24239,0.80558-0.24363,0.26562-0.001,0.51973,0.0631,0.76232,0.19286,0.15451,0.0828,0.32407,0.22138,0.50868,0.41571-0.0469-0.21589-0.0648-0.38284-0.0536-0.50084,0.007-0.0794,0.0448-0.21092,0.1133-0.39456,0.0685-0.18363,0.12781-0.31439,0.17786-0.39227l0.98439-1.5732,1.0147,1.7088-1.0156,1.6955c-0.13279,0.2173-0.20433,0.38317-0.21461,0.49762-0.0109,0.15394,0.0246,0.29989,0.10651,0.43783l0.0793,0.1335,1.9858-1.1792zm-3.812,0.20962-0.37853-0.63744c-0.041-0.069-0.14247-0.18926-0.30456-0.36086-0.0795-0.0882-0.17921-0.13961-0.29919-0.15414-0.11997-0.0145-0.23336,0.01-0.34016,0.0734-0.15797,0.0938-0.2495,0.21587-0.2746,0.3662s0.0443,0.36344,0.20811,0.63933l0.39438,0.66415z'/%3E %3Cpath d='m269.11,177.71-1.4871-4.4713,1.1528-0.38341,0.93096,2.7992,0.85817-0.28541-0.86358-2.5966,1.1013-0.36626,0.86358,2.5966,1.0644-0.35401-0.9579-2.8802,1.2228-0.40668,1.514,4.5524z'/%3E %3Cpath d='m267.16,171.06-0.3323-2.9038c-0.0724-0.63243,0.0238-1.1233,0.28857-1.4727,0.26476-0.34935,0.67479-0.5558,1.2301-0.61935,0.57074-0.0653,1.0364,0.0553,1.3971,0.36169,0.36064,0.30644,0.58127,0.81187,0.66188,1.5163l0.10944,0.95637,2.0978-0.24007,0.2008,1.7546zm2.2094-2.0304-0.049-0.42806c-0.0385-0.33678-0.1241-0.56661-0.25667-0.68948-0.13256-0.12287-0.29011-0.17386-0.47265-0.15298-0.17739,0.0203-0.32102,0.0967-0.43089,0.22903-0.10986,0.13238-0.14612,0.36183-0.10876,0.68833l0.0569,0.49746z'/%3E %3Cpath d='m266.98,160.38,0.18811-1.7443,3.3729,0.36373c0.33446,0.0361,0.64465,0.12223,0.93056,0.25847,0.28592,0.13625,0.52815,0.32764,0.72669,0.57418s0.32966,0.49688,0.39335,0.75099c0.0894,0.3532,0.10849,0.76778,0.0572,1.2437-0.0297,0.27528-0.0814,0.57357-0.15507,0.89486-0.0737,0.32129-0.17957,0.58511-0.31764,0.79144-0.13807,0.20634-0.32237,0.38882-0.55289,0.54745-0.23053,0.15863-0.46131,0.25932-0.69235,0.30207-0.37184,0.0692-0.69669,0.0888-0.97455,0.0589l-3.3729-0.36374,0.18811-1.7443,3.4539,0.37248c0.30873,0.0333,0.55915-0.0262,0.75126-0.1786,0.19211-0.15236,0.30454-0.38033,0.33727-0.68392,0.0325-0.301-0.0276-0.54628-0.18026-0.73582-0.15263-0.18954-0.38589-0.30123-0.69977-0.33508z'/%3E %3Cpath d='m267.74,156.21,1.0861-3.1072c0.18101-0.51785,0.44822-0.87058,0.80162-1.0582,0.3534-0.18759,0.71941-0.21522,1.098-0.0829,0.31756,0.111,0.55534,0.30514,0.71335,0.5824,0.10535,0.18485,0.15759,0.41967,0.15673,0.70444,0.22773-0.3535,0.48638-0.58175,0.77594-0.68476,0.28956-0.103,0.60534-0.0947,0.94732,0.0248,0.27847,0.0973,0.50623,0.2496,0.68326,0.45675,0.17704,0.20718,0.29101,0.44575,0.34192,0.71573,0.0319,0.16742,0.0171,0.39799-0.0444,0.6917-0.0818,0.39082-0.14402,0.6473-0.18672,0.76943l-1.0016,2.8653zm2.6922-0.93805,0.25231-0.72183c0.0905-0.25893,0.1089-0.45466,0.0552-0.58721-0.0537-0.13253-0.16486-0.22826-0.33341-0.28718-0.15633-0.0546-0.29619-0.0466-0.41956,0.024s-0.22903,0.23176-0.31698,0.48335l-0.25615,0.73282zm2.1105,0.73772,0.29586-0.84641c0.0999-0.2858,0.11965-0.50504,0.0593-0.65773-0.0604-0.15268-0.17608-0.25891-0.34708-0.31868-0.15877-0.0555-0.30668-0.0421-0.44373,0.0402s-0.25637,0.2688-0.35798,0.55948l-0.29458,0.84275z'/%3E %3Cpath d='m270.43,149.37,0.90849-1.5054,3.6722,2.2161,1.4179-2.3495,1.1997,0.72398-2.3264,3.855z'/%3E %3Cpath d='m273.87,144.16,1.1282-1.3537,4.3712,3.643-1.1282,1.3537z'/%3E %3Cpath d='m281.52,141.22,1.4723-0.65101c0.20313,0.39522,0.31475,0.77525,0.33485,1.1401,0.0201,0.36486-0.0469,0.71073-0.20101,1.0376-0.15411,0.32689-0.42448,0.65645-0.81111,0.98868-0.46907,0.40307-0.91088,0.66415-1.3254,0.78324-0.41455,0.1191-0.87733,0.0997-1.3884-0.0583-0.51102-0.15794-0.99673-0.50481-1.4571-1.0406-0.61387-0.71439-0.89577-1.4266-0.84571-2.1366,0.0501-0.71001,0.42249-1.3635,1.1172-1.9605,0.54365-0.46714,1.0654-0.72446,1.5654-0.77195,0.49996-0.0475,1.0211,0.0915,1.5635,0.41697l-0.95243,1.2739c-0.1542-0.0961-0.28002-0.15514-0.37744-0.1772-0.16227-0.038-0.32099-0.038-0.47616-0.00025-0.15516,0.0378-0.29947,0.11405-0.43293,0.22872-0.30224,0.25972-0.42927,0.5804-0.38109,0.96205,0.0335,0.28513,0.21632,0.62101,0.54856,1.0076,0.41149,0.47888,0.76617,0.74473,1.064,0.79755,0.29785,0.0528,0.57828-0.0338,0.84127-0.25975,0.25514-0.21924,0.38641-0.45657,0.39382-0.71199,0.007-0.25542-0.0767-0.54483-0.25221-0.86823z'/%3E %3Cpath d='m287.58,139.04-1.7674,0.94226,0.19872,0.95853-1.5858,0.84547-0.78977-6.0274,1.692-0.90208,4.5643,4.0151-1.6235,0.86556zm-0.90425-0.91228-1.5172-1.5092,0.41089,2.099z'/%3E %3Cpath d='m292.05,132.3,2.5741-0.44458c0.50743-0.0876,0.92922-0.0896,1.2654-0.006,0.33614,0.0838,0.62845,0.23678,0.87693,0.45908,0.24847,0.22232,0.44811,0.49639,0.59892,0.82222,0.15081,0.32584,0.25924,0.68,0.32531,1.0625,0.10349,0.59923,0.11554,1.0757,0.0362,1.4295-0.0794,0.35377-0.22095,0.66314-0.42465,0.92809-0.20371,0.26496-0.43815,0.45841-0.70331,0.58036-0.36233,0.16762-0.69776,0.27807-1.0063,0.33136l-2.5741,0.44458zm1.952,0.97061,0.52914,3.0637,0.42456-0.0733c0.36208-0.0625,0.61269-0.14717,0.75181-0.25392s0.23474-0.26769,0.28687-0.48283c0.0521-0.21514,0.0394-0.54711-0.0381-0.99589-0.10262-0.59413-0.26976-0.98411-0.50142-1.1699-0.23167-0.18582-0.5719-0.23998-1.0207-0.16247z'/%3E %3Cpath d='m299.36,131.32,4.7078,0.2013-0.0519,1.2138-2.9472-0.12602-0.0386,0.90356,2.734,0.11691-0.0496,1.1595-2.734-0.11691-0.0479,1.1207,3.0326,0.12967-0.055,1.2875-4.7932-0.20495z'/%3E %3Cpath d='m306.21,131.86,1.7079,0.41801-1.0197,4.1661,2.6655,0.6524-0.33312,1.361-4.3734-1.0704z'/%3E %3Cpath d='m315.34,134.89,2.516,1.4873c0.54797,0.32393,0.88136,0.69687,1.0002,1.1188,0.1188,0.42194,0.036,0.87348-0.24843,1.3546-0.29234,0.49452-0.6695,0.7931-1.1315,0.89575-0.46199,0.10265-0.99815-0.0264-1.6085-0.38723l-0.82865-0.48985-1.0745,1.8177-1.5203-0.89873zm0.2858,2.9871,0.37089,0.21925c0.2918,0.1725,0.52669,0.24297,0.70467,0.21141,0.17798-0.0316,0.31371-0.12642,0.40721-0.28458,0.0909-0.1537,0.11665-0.3143,0.0774-0.4818-0.0393-0.16749-0.20035-0.33486-0.48325-0.5021l-0.43103-0.2548z'/%3E %3Cpath d='m320.56,144.51-1.4666-1.364-0.8415,0.50015-1.316-1.2239,5.4413-2.7102,1.4041,1.3058-2.3091,5.6233-1.3472-1.253zm0.56794-1.1521,0.93263-1.9261-1.8507,1.0723z'/%3E %3Cpath d='m321.81,147.14,4.692-3.2194,1.658,2.4164c0.30744,0.44807,0.504,0.81689,0.5897,1.1064,0.0857,0.28955,0.0743,0.57824-0.0342,0.86607-0.10849,0.28783-0.31209,0.53423-0.6108,0.73919-0.26032,0.17861-0.52295,0.27722-0.78791,0.29583-0.26497,0.0186-0.52274-0.0289-0.77331-0.14255-0.1596-0.0725-0.33786-0.19969-0.5348-0.38152,0.061,0.21236,0.0897,0.37777,0.0863,0.49625-0.002,0.0797-0.0309,0.2134-0.0872,0.40113-0.0564,0.18773-0.10695,0.32208-0.1518,0.40308l-0.87931,1.6342-1.1244-1.6387,0.90241-1.7584c0.11829-0.22552,0.17882-0.39572,0.18159-0.5106,0.00081-0.15433-0.0442-0.29763-0.13493-0.42992l-0.0878-0.12802-1.9043,1.3066zm3.7901-0.45867,0.41944,0.61131c0.0454,0.0661,0.15455,0.17952,0.32753,0.34014,0.0851,0.0828,0.18796,0.12758,0.30863,0.13423,0.12067,0.007,0.23221-0.0252,0.33464-0.0954,0.15148-0.10394,0.23483-0.23174,0.25004-0.38339,0.0152-0.15165-0.068-0.35976-0.24951-0.62434l-0.437-0.63691z'/%3E %3Cpath d='m327.36,155.2-0.74229-1.8602-0.97457,0.0922-0.66605-1.6692,6.0777-0.12252,0.71065,1.7809-4.4924,4.0953-0.68188-1.7088zm1.0062-0.7985,1.6668-1.3421-2.1315,0.1777z'/%3E %3Cpath d='m329.85,160.62,1.1708-0.17519,0.40208,2.6871-2.3992,0.359c-0.42757-0.46194-0.73428-0.88112-0.92012-1.2576-0.18585-0.37645-0.31936-0.83594-0.40054-1.3785-0.0999-0.66794-0.0675-1.2294,0.0973-1.6845,0.16477-0.45507,0.45504-0.8321,0.8708-1.1311,0.41575-0.299,0.91538-0.49216,1.4989-0.57947,0.6142-0.0919,1.1674-0.0452,1.6596,0.14023,0.49216,0.18539,0.89253,0.50487,1.2011,0.95844,0.23876,0.35413,0.40638,0.85365,0.50289,1.4986,0.093,0.62188,0.10634,1.0954,0.0399,1.4207-0.0665,0.32522-0.20284,0.60727-0.40911,0.84615-0.20629,0.23888-0.48347,0.43668-0.83156,0.59343l-0.55043-1.6327c0.20207-0.10089,0.34706-0.24229,0.43497-0.4242,0.0879-0.18192,0.1127-0.40083,0.0744-0.65675-0.0571-0.38132-0.23497-0.6654-0.53373-0.85225-0.29877-0.18686-0.73477-0.2374-1.308-0.15162-0.60908,0.0911-1.027,0.27076-1.2538,0.53886-0.22676,0.26811-0.30951,0.60689-0.24824,1.0164,0.0291,0.1945,0.085,0.37583,0.16774,0.54399,0.0827,0.16815,0.20894,0.35597,0.37866,0.56344l0.52975-0.0793z'/%3E %3Cpath d='m333.57,168.88-0.15576,1.7475-3.379-0.30119c-0.33507-0.0299-0.6468-0.11026-0.93519-0.24118-0.28839-0.13093-0.53412-0.3178-0.7372-0.56061-0.20307-0.24283-0.3388-0.49069-0.40719-0.74358-0.096-0.35149-0.1227-0.76564-0.0802-1.2425,0.0246-0.27579,0.0707-0.57499,0.13846-0.89759,0.0677-0.3226,0.16869-0.58833,0.30292-0.79719,0.13422-0.20886,0.31511-0.39472,0.54265-0.55759,0.22755-0.16288,0.45643-0.26782,0.68664-0.31485,0.37049-0.0761,0.69492-0.10173,0.97328-0.0769l3.379,0.30119-0.15576,1.7475-3.4602-0.30842c-0.30929-0.0276-0.55857,0.0366-0.74782,0.19248-0.18926,0.15589-0.29744,0.38591-0.32455,0.69005-0.0269,0.30156,0.0378,0.54568,0.19387,0.73236,0.15612,0.18667,0.39141,0.29402,0.70586,0.32206z'/%3E %3Cpath d='m327.28,174.9,0.62561-1.9026-0.80624-0.5552,0.56134-1.7072,4.7375,3.8091-0.59893,1.8215-6.0736,0.2543,0.57468-1.7478zm1.284,0.034,2.1396,0.0416-1.748-1.2326z'/%3E %3Cpath d='m330.6,179.56-1.0037,1.6746-2.2386-0.002,1.0574,1.9732-0.9977,1.6647-1.6992-3.5978-2.0442-1.2252,0.90591-1.5115,2.0442,1.2252z'/%3E %3C/g%3E %3Cg fill='%23009b3a' stroke='%23000' stroke-width='0.1'%3E %3Cpath d='m305.58,145.3s16.052,6.9159,13.249,21.207-11.74,14.195-15.244,15.775c-3.5043,1.5793-5.9218,3.8396-7.3046,3.5235-1.3827-0.31613-3.2104-1.3832-3.2104-1.3832s-0.14627,2.3471,2.6684,2.7742,6.5145-3.7042,8.2916-4.1636c1.7771-0.45933,12.688-1.6436,15.343-16.185,3.0983-15.522-13.693-21.092-13.792-21.548z'/%3E %3Cpath d='m313.68,148.34a2.2037,0.52177,75.104,0,1,-1.0572,0.0811,2.2037,0.52177,75.104,1,1,1.0572,-0.0811z'/%3E %3Cpath d='m313.13,148.49a2.2707,0.50636,63.335,1,1,-0.95726,0.34968,2.2707,0.50636,63.335,0,1,0.95726,-0.34968z'/%3E %3Cpath d='m311.52,149.55a2.1502,0.53476,17.053,0,1,-0.10032,1.0864,2.1502,0.53476,17.053,0,1,0.10032,-1.0864z'/%3E %3Cpath d='m311.76,148.96a2.2609,0.50857,34.225,1,1,-0.46166,0.91557,2.2609,0.50857,34.225,1,1,0.46166,-0.91557z'/%3E %3Cpath d='m312.44,148.68a2.299,0.50014,46.194,1,1,-0.6989,0.71633,2.299,0.50014,46.194,0,1,0.6989,-0.71633z'/%3E %3Cpath d='m313.56,150.7c0.009,0.01-0.61928,0.34913-0.76157,0.39979-0.14231,0.0506-0.3352-0.18953-0.74445,0.0205-0.40924,0.21003-0.69016,0.59314-0.7795,0.81798-0.0893,0.22483,0.11595,0.31904,0.61058,0.0786,0.49463-0.24042,0.62481-0.62134,0.8633-0.77059,0.23847-0.14922,0.6385-0.36885,0.86618-0.44991,0.0986-0.21524,0.41874-0.67667,0.58423-0.94149,0.16549-0.2648,0.81483-0.70186,1.0512-1.2107,0.20634-0.42091,0.12886-0.77938-0.14731-0.6296-0.27617,0.14979-0.63323,0.57288-0.79951,0.87657-0.16629,0.30371-0.0235,0.69038-0.2082,0.97494-0.14547,0.2062-0.49727,0.83331-0.53495,0.83386z'/%3E %3Cpath d='m318.53,152.34a3.3048,0.7416,88.415,1,1,-1.491,-0.357,3.3048,0.7416,88.415,1,1,1.491,0.357z'/%3E %3Cpath d='m317.7,152.31a3.4427,0.71192,77.49,1,1,-1.4415,0.0724,3.4427,0.71192,77.49,1,1,1.4415,-0.0724z'/%3E %3Cpath d='m315.13,153.11a3.2071,0.7642,34.91,1,1,-0.4987,1.511,3.2071,0.7642,34.91,1,1,0.4987,-1.511z'/%3E %3Cpath d='m315.65,152.38a3.4298,0.71459,50.904,0,1,-0.94257,1.1046,3.4298,0.71459,50.904,1,1,0.94257,-1.1046z'/%3E %3Cpath d='m316.69,152.28a3.5036,0.69953,61.837,1,1,-1.2051,0.71311,3.5036,0.69953,61.837,1,1,1.2051,-0.71311z'/%3E %3Cpath d='m317.57,155.67c0.01,0.0178-0.97325,0.22286-1.1871,0.23175-0.21385,0.009-0.40144-0.42144-1.0378-0.30379-0.63631,0.11765-1.1522,0.54061-1.3504,0.82262-0.19818,0.28203,0.0549,0.50882,0.81953,0.38586,0.76463-0.12297,1.0711-0.61026,1.4508-0.71727,0.37968-0.107,1.0064-0.24252,1.3486-0.25671,0.20777-0.26415,0.80398-0.78171,1.1209-1.0869,0.31688-0.30518,1.3609-0.64054,1.8567-1.2634,0.42514-0.51046,0.43655-1.0585,0.005-0.9676-0.43208,0.0909-1.0667,0.53707-1.3975,0.89759-0.33087,0.36054-0.26112,0.97825-0.6112,1.3031-0.26974,0.23022-0.96462,0.97091-1.017,0.95483z'/%3E %3Cpath d='m321.14,159a0.73839,3.3192,8.7402,1,1,-1.3929,-0.63898,0.73839,3.3192,8.7402,1,1,1.3929,0.63898z'/%3E %3Cpath d='m320.35,158.8a3.4648,0.70737,87.95,1,1,-1.422,-0.20538,3.4648,0.70737,87.95,1,1,1.422,0.20538z'/%3E %3Cpath d='m317.69,159.1a3.2231,0.76041,46.026,1,1,-0.76003,1.3966,3.2231,0.76041,46.026,1,1,0.76003,-1.3966z'/%3E %3Cpath d='m318.33,158.48a3.4552,0.70935,61.791,1,1,-1.1206,0.90994,3.4552,0.70935,61.791,1,1,1.1206,-0.90994z'/%3E %3Cpath d='m319.35,158.58a3.5309,0.69413,72.543,1,1,-1.3065,0.47282,3.5309,0.69413,72.543,1,1,1.3065,-0.47282z'/%3E %3Cpath d='m319.61,162.09c0.006,0.0195-0.99148,0.0332-1.2021,0.00066-0.21062-0.0323-0.31635-0.49335-0.95952-0.49937-0.64317-0.006-1.2237,0.3126-1.4683,0.55307-0.24457,0.24047-0.0381,0.51308,0.73143,0.5385,0.76954,0.0255,1.157-0.39697,1.5474-0.42973,0.39042-0.0327,1.0274-0.0462,1.3644,0.005,0.25074-0.22097,0.92685-0.61761,1.2916-0.85817,0.36477-0.24055,1.4457-0.37122,2.0427-0.8912,0.50763-0.42249,0.61765-0.9616,0.17894-0.95479-0.43872,0.007-1.1395,0.32554-1.5279,0.61807-0.38843,0.29252-0.43169,0.916-0.83247,1.1696-0.30518,0.17556-1.118,0.77363-1.1663,0.74768'/%3E %3Cpath d='m321.34,166.42a0.73814,3.3203,31.311,0,1,-1.0129,-1.1684,0.73814,3.3203,31.311,0,1,1.0129,1.1684'/%3E %3Cpath d='m320.69,165.91a0.70283,3.4872,20.618,0,1,-1.2076,-0.77836,0.70283,3.4872,20.618,0,1,1.2076,0.77836'/%3E %3Cpath d='m318.17,165.09a3.2755,0.74824,69.934,0,1,-1.2303,0.98083,3.2755,0.74824,69.934,0,1,1.2303,-0.98083'/%3E %3Cpath d='m318.99,164.78a3.5112,0.69802,85.137,0,1,-1.3677,0.38052,3.5112,0.69802,85.137,1,1,1.3677,-0.38052'/%3E %3Cpath d='m319.88,165.3a0.68491,3.5784,5.5508,1,1,-1.3664,-0.10172,0.68491,3.5784,5.5508,1,1,1.3664,0.10172'/%3E %3Cpath d='m318.75,168.66c-0.002,0.0206-0.91045-0.37916-1.0886-0.4962-0.17812-0.11705-0.0948-0.58827-0.67475-0.85977-0.57992-0.2715-1.2292-0.21605-1.544-0.0942-0.31478,0.12187-0.23372,0.46002,0.45307,0.80175,0.68677,0.34174,1.2015,0.11022,1.5677,0.24126,0.36615,0.13105,0.94806,0.38192,1.2331,0.5692,0.31278-0.10125,1.0789-0.18952,1.5025-0.26178,0.42362-0.0722,1.4529,0.25346,2.1953,0.0181,0.62359-0.18191,0.93252-0.63634,0.53272-0.8114-0.39982-0.17507-1.158-0.16922-1.6232-0.0586-0.46522,0.11067-0.74646,0.67093-1.2077,0.74038-0.34444,0.0366-1.3125,0.25518-1.3461,0.21116'/%3E %3Cpath d='m319.34,173.95a0.86442,3.782,48.457,1,1,-0.73094,-1.6561,0.86442,3.782,48.457,1,1,0.73094,1.6561'/%3E %3Cpath d='m318.79,173.16a0.82109,3.9816,37.466,1,1,-1.0735,-1.296,0.82109,3.9816,37.466,1,1,1.0735,1.296'/%3E %3Cpath d='m316.29,171.34a3.8093,0.85822,86.522,1,1,-1.6766,0.63757,3.8093,0.85822,86.522,1,1,1.6766,-0.63757'/%3E %3Cpath d='m317.29,171.29a0.80649,4.0537,11.633,0,1,-1.6306,-0.0747,0.80649,4.0537,11.633,1,1,1.6306,0.0747'/%3E %3Cpath d='m318.1,172.18a0.79539,4.1102,22.119,1,1,-1.4706,-0.60655,0.79539,4.1102,22.119,1,1,1.4706,0.60655'/%3E %3Cpath d='m315.75,175.49c-0.009,0.022-0.87758-0.74786-1.0352-0.94149-0.15759-0.19362,0.089-0.68363-0.46017-1.1931-0.54912-0.50946-1.282-0.68314-1.6686-0.66249-0.38655,0.0207-0.40846,0.42323,0.23521,1.0489,0.64368,0.62564,1.2864,0.5563,1.6464,0.8334,0.35997,0.2771,0.91807,0.76453,1.1702,1.0743,0.37758,0.001,1.2499,0.18108,1.7399,0.25458,0.49005,0.0735,1.516,0.80535,2.4105,0.81412,0.74621,0.0248,1.2356-0.36504,0.85306-0.7029-0.38257-0.33788-1.219-0.60568-1.7675-0.6518-0.54847-0.0462-1.0422,0.47055-1.5728,0.38034-0.39119-0.0842-1.5286-0.19313-1.5511-0.25388'/%3E %3Cpath d='m314.17,180.54a0.96734,4.1698,79.752,1,1,0.19909,-1.9977,0.96734,4.1698,79.752,1,1,-0.19909,1.9977'/%3E %3Cpath d='m314.09,179.47a0.92321,4.3692,68.504,0,1,-0.32819,-1.8534,0.92321,4.3692,68.504,0,1,0.32819,1.8534'/%3E %3Cpath d='m312.66,176.29a0.96428,4.1831,26.238,0,1,-1.9665,-0.36332,0.96428,4.1831,26.238,1,1,1.9665,0.36332'/%3E %3Cpath d='m313.66,176.83a0.90974,4.4339,41.823,0,1,-1.533,-1.0142,0.90974,4.4339,41.823,0,1,1.533,1.0142'/%3E %3Cpath d='m313.95,178.15a0.89742,4.4948,52.671,1,1,-1.0881,-1.4274,0.89742,4.4948,52.671,0,1,1.0881,1.4274'/%3E %3Cpath d='m309.87,179.93c-0.0207,0.0157-0.43852-1.2188-0.48489-1.4941-0.0464-0.27531,0.45926-0.59874,0.20755-1.4008-0.25172-0.8021-0.86427-1.3912-1.2486-1.5951-0.38437-0.20393-0.6254,0.16627-0.34588,1.1336,0.27952,0.96728,0.9377,1.273,1.1338,1.7448,0.19607,0.47173,0.4685,1.2581,0.54266,1.6986,0.36367,0.2197,1.1074,0.89507,1.5403,1.2484,0.43283,0.35332,1.0233,1.6427,1.8819,2.1684,0.70667,0.45515,1.392,0.36743,1.2073-0.17513-0.18469-0.54259-0.84572-1.281-1.3499-1.6421-0.50418-0.36109-1.2629-0.15524-1.7257-0.54789-0.33158-0.3063-1.3698-1.0677-1.3584-1.1386'/%3E %3Cpath d='m307.4,184.24a1.2121,4.2194,89.068,0,1,0.007,-2.4245,1.2121,4.2194,89.068,0,1,-0.007,2.4245'/%3E %3Cpath d='m306.84,180.45a1.1714,4.3658,37.587,0,1,-1.7986,-1.5041,1.1714,4.3658,37.587,1,1,1.7986,1.5041'/%3E %3Cpath d='m307.43,182.38a1.1973,4.2713,66.472,0,1,-0.8567,-2.2386,1.1973,4.2713,66.472,0,1,0.8567,2.2386'/%3E %3Cpath d='m308.58,145.66a2.6209,0.53282,41.126,0,1,-0.99489,0.54201,2.6209,0.53282,41.126,1,1,0.99489,-0.54201'/%3E %3Cpath d='m307.29,146.75a2.6543,0.52611,8.1634,0,1,0.202,1.0896,2.6543,0.52611,8.1634,1,1,-0.202,-1.0896'/%3E %3Cpath d='m307.81,146.06a2.776,0.50303,26.817,1,1,-0.52645,0.86106,2.776,0.50303,26.817,0,1,0.52645,-0.86106'/%3E %3Cpath d='m288.79,180.13s3.5359,0.75834,6.6097,1.8755c3.0739,1.1172,7.7443,4.9517,8.9996,5.1689,1.4081,0.0641,3.3608-0.41654,4.1019-2.4496-2.1685,0.57838-3.4689,1.457-5.539,0.31964-0.73141-0.27703-3.1265-2.4578-5.752-3.625s-7.9208-2.4978-7.9208-2.4978l-0.49937,1.2083'/%3E %3Cpath d='m292.56,148.16c-0.0127-0.0303,4.0701-2.1474,4.0701-2.1474l-4.4882,1.1477-0.52144,0.78964,0.93955,0.21005'/%3E %3Cpath d='m296.42,149.15c-1.5758-0.28645-3.9992-0.81633-5.5421-0.9399,1.0665-1.1813,2.536-3.1789,3.4417-4.4051-0.59804,1.1695-1.5368,2.7117-1.9073,3.8312,1.0862,0.5863,2.7936,1.0454,4.0078,1.5138'/%3E %3Cpath d='m291.83,148.41c-0.0177-0.0279,3.6168-2.8004,3.6168-2.8004l-4.2006,1.8792-0.37387,0.86847,0.95766,0.0527'/%3E %3Cpath d='m295.69,149.11c-1.5867-0.30167-4.0287-0.85794-5.5794-0.99119,1.0478-1.2168,2.4844-3.2756,3.3699-4.5394-0.57788,1.2063-1.4906,2.7965-1.8411,3.952,1.1012,0.60975,2.8232,1.0903,4.0506,1.5786'/%3E %3Cpath d='m291.23,148.64c-0.01-0.0311,4.2591-1.7838,4.2591-1.7838l-4.5864,0.75479-0.59212,0.73968,0.91942,0.28937'/%3E %3Cpath d='m295.21,149.15c-1.6049-0.13379-4.0856-0.43321-5.635-0.39973,0.89323-1.351,2.0721-3.6004,2.7993-4.9815-0.42971,1.2892-1.1454,3.0051-1.3563,4.2178,1.1608,0.49985,2.9206,0.80072,4.192,1.1634'/%3E %3Cpath d='m290.79,148.66c-0.0233-0.0237,2.8854-3.5159,2.8854-3.5159l-3.6561,2.7338-0.16967,0.93251,0.9404-0.1504'/%3E %3Cpath d='m295.19,149.38c-1.7196-0.0327-4.3869-0.18429-6.0307-0.0383,0.81363-1.5376,1.8405-4.0759,2.4746-5.6347-0.32708,1.4374-0.91528,3.3608-1.0174,4.6992,1.2844,0.46358,3.1854,0.66769,4.5735,0.97377'/%3E %3Cpath d='m290.21,149.49c-0.0223-0.0308,3.5039-3.3619,3.5039-3.3619l-4.2398,2.3458-0.29039,1.0048,1.0262,0.0113'/%3E %3Cpath d='m294.42,149.49c-1.848,0.007-4.6936-0.0933-6.4968,0.10867,1.1962-1.7142,2.8298-4.536,3.8367-6.269-0.65065,1.5916-1.6836,3.725-2.0711,5.2021,1.2892,0.47854,3.2974,0.65581,4.7312,0.95826'/%3E %3Cpath d='m289.03,149.74c-0.0176-0.0333,4.476-3.7911,4.476-3.7911l-5.0591,2.6902-0.52142,1.1141,1.1046-0.0132'/%3E %3Cpath d='m293.75,149.6c-1.83,0.26391-4.6638,0.56204-6.4216,1.0097,0.93966-1.8374,2.154-4.8155,2.9034-6.6449-0.41668,1.6421-1.1346,3.8655-1.3069,5.3593,1.346,0.28713,3.3611,0.18057,4.8251,0.27594'/%3E %3Cpath d='m288.43,150.49c-0.0259-0.0268,3.4487-4.7769,3.4487-4.7769l-4.3038,3.8915-0.23064,1.1922,1.0858-0.3068'/%3E %3Cpath d='m292.74,150.17c-1.8426,0.17159-4.6899,0.32693-6.4707,0.68564,1.0418-1.7872,2.4221-4.6995,3.2735-6.4883-0.50848,1.6185-1.3505,3.8022-1.6066,5.2848,1.3282,0.35426,3.347,0.34906,4.8038,0.51778'/%3E %3Cpath d='m287.81,150.99c-0.0179-0.0338,4.3902-3.7991,4.3902-3.7991l-4.981,2.6844-0.50347,1.1213,1.0943-0.007'/%3E %3Cpath d='m292.2,150.36c-1.837,0.38744-4.6873,0.87846-6.4421,1.442,0.85827-1.8764,1.9372-4.8962,2.6036-6.7515-0.33926,1.6475-0.95401,3.8889-1.0536,5.3732,1.3752,0.18936,3.4073-0.0559,4.8922-0.0637'/%3E %3Cpath d='m287.08,151.19c-0.03-0.0213,2.8045-5.2073,2.8045-5.2073l-3.7959,4.5028-0.0628,1.1897,1.0542-0.48522'/%3E %3Cpath d='m292.2,150.66c-1.9709,0.51269-5.0424,1.1852-6.9015,1.891,0.71391-2.1333,1.5308-5.5533,2.0364-7.6546-0.17164,1.855-0.57348,4.3854-0.5018,6.0476,1.534,0.1517,3.7366-0.21064,5.367-0.28402'/%3E %3Cpath d='m286.53,152.39c-0.0298-0.0303,3.5334-5.2185,3.5334-5.2185l-4.5179,4.2179-0.1906,1.3165,1.1751-0.31589'/%3E %3Cpath d='m291.42,151.25c-1.9374,0.61271-4.9624,1.4426-6.7795,2.2401,0.61082-2.1464,1.264-5.5698,1.669-7.6734-0.0842,1.8422-0.36592,4.3642-0.21696,6.0029,1.5335,0.0673,3.7084-0.40931,5.3275-0.56959'/%3E %3Cpath d='m285.82,153.16c-0.0343-0.0242,2.6855-5.7607,2.6855-5.7607l-3.8184,4.9613,0.0173,1.3246,1.1156-0.52521'/%3E %3Cpath d='m290.68,152.04c-1.9847,0.45234-5.0722,1.0322-6.9539,1.6786,0.80306-2.0896,1.7642-5.4488,2.3585-7.5126-0.25108,1.8295-0.76055,4.3205-0.76099,5.9662,1.5208,0.19251,3.7297-0.10474,5.3564-0.13211'/%3E %3Cpath d='m285.18,153.71c-0.0238-0.0354,4.3881-4.5082,4.3881-4.5082l-5.173,3.338-0.42128,1.2662,1.2062-0.0961'/%3E %3Cpath d='m289.8,152.82c-1.966,0.26388-5.0168,0.54834-6.8942,1.02,0.91275-2.0472,2.058-5.3709,2.7652-7.4125-0.3577,1.8371-1.0084,4.3219-1.1101,5.9967,1.4734,0.34649,3.6488,0.26266,5.239,0.39584'/%3E %3Cpath d='m284.31,153.26c-0.0323-0.0271,2.9857-5.6409,2.9857-5.6409l-4.0499,4.7466-0.0631,1.3441,1.1273-0.44976'/%3E %3Cpath d='m290.04,152.15c-2.1381,0.87557-5.4778,2.0958-7.4812,3.1751,0.65695-2.5384,1.3495-6.5596,1.7791-9.0308-0.077,2.141-0.36647,5.0863-0.18727,6.9715,1.6973-0.0533,4.0995-0.7916,5.8893-1.1159'/%3E %3Cpath d='m283.9,154.97c-0.0346-0.0302,3.5737-6.4733,3.5737-6.4733l-4.7176,5.4774-0.13032,1.5296,1.2742-0.53369'/%3E %3Cpath d='m289.22,152.95c-2.0951,0.9847-5.3742,2.3775-7.3258,3.5553,0.5427-2.5381,1.0549-6.539,1.3737-8.998,0.0186,2.1135-0.13932,5.0315,0.1235,6.8784,1.6918-0.14952,4.0566-1.014,5.8286-1.4358'/%3E %3Cpath d='m283.17,155.95c-0.0392-0.0225,2.6078-6.9665,2.6078-6.9665l-3.9029,6.222,0.099,1.5082,1.1961-0.76364'/%3E %3Cpath d='m288.3,153.53c-2.0902,1.0013-5.3626,2.4201-7.3079,3.6131,0.5268-2.5408,1.0138-6.543,1.317-9.0029,0.0321,2.1119-0.10721,5.0291,0.1676,6.8726,1.6919-0.16336,4.0527-1.0468,5.8233-1.4828'/%3E %3Cpath d='m282.58,156.78c-0.0319-0.0338,4.0345-6.1433,4.0345-6.1433l-5.0869,5.0282-0.24792,1.5233,1.3003-0.40818'/%3E %3Cpath d='m288.11,153.21c-1.8636,1.4877-4.8118,3.6746-6.4923,5.3092-0.003-2.5647-0.34635-6.5176-0.55367-8.9482,0.46762,2.0126,0.93175,4.8392,1.5844,6.5336,1.642-0.58507,3.7979-2.0286,5.4615-2.8945'/%3E %3Cpath d='m282.78,157.07c-0.0447-0.006,0.46739-7.3613,0.46739-7.3613l-1.9438,7.1568,0.54238,1.3482,0.934-1.1436'/%3E %3Cpath d='m287.58,153.89c-1.869,1.4782-4.8251,3.6499-6.5118,5.2759,0.008-2.5657-0.3191-6.522-0.51623-8.9546,0.45907,2.0159,0.91126,4.8461,1.5566,6.5446,1.6438-0.57637,3.8048-2.0088,5.4714-2.866'/%3E %3Cpath d='m282.31,158.32c-0.0416-0.0175,1.8801-7.1926,1.8801-7.1926l-3.2533,6.6145,0.2567,1.4768,1.1165-0.89863'/%3E %3Cpath d='m287.37,154.06c-1.7662,1.74-4.5782,4.3217-6.1396,6.1914-0.27684-2.6316-1.0544-6.6488-1.5284-9.1194,0.6982,2.0118,1.4798,4.8594,2.3351,6.5234,1.6338-0.78834,3.7067-2.5165,5.3328-3.5955'/%3E %3Cpath d='m282.32,159.24c-0.0462-0.007,0.35192-7.6498,0.35192-7.6498l-1.8789,7.4327,0.58349,1.4029,0.94347-1.1858'/%3E %3Cpath d='m286.81,155.33c-1.8902,1.5628-4.8841,3.862-6.5822,5.5756-0.0591-2.665-0.50061-6.7694-0.76796-9.2932,0.52674,2.0871,1.0678,5.0201,1.7784,6.7748,1.6814-0.62281,3.8742-2.1423,5.5718-3.0572'/%3E %3Cpath d='m281.76,160.11c-0.0403-0.0248,2.6632-7.1952,2.6632-7.1952l-3.9937,6.3751,0.10446,1.5793,1.226-0.75915'/%3E %3Cpath d='m286.78,155.36c-1.6729,1.7696-4.3365,4.3957-5.8152,6.2962-0.2642-2.6676-1.004-6.7388-1.4549-9.2426,0.66316,2.038,1.406,4.9231,2.2178,6.6079,1.5481-0.80419,3.5117-2.5626,5.0523-3.6616'/%3E %3Cpath d='m281.86,160.48c-0.0468-0.00066-0.31503-7.607-0.31503-7.607l-1.2318,7.5764,0.70623,1.3169,0.84065-1.2864'/%3E %3Cpath d='m285.96,155.93c-1.6186,1.7855-4.2014,4.4366-5.6223,6.3515-0.34233-2.6683-1.2009-6.7377-1.7249-9.2404,0.72226,2.0346,1.549,4.9167,2.4093,6.5966,1.5223-0.81796,3.4317-2.5947,4.9379-3.7076'/%3E %3Cpath d='m281.43,161.24c-0.0429-0.0127,0.84948-7.7276,0.84948-7.7276l-2.2658,7.3094,0.45158,1.5011,0.96479-1.0828'/%3E %3Cpath d='m285.61,156.23c-1.4798,1.9335-3.8561,4.822-5.1287,6.865-0.54421-2.6206-1.71-6.5845-2.4229-9.0227,0.87524,1.9534,1.919,4.7394,2.9052,6.3264,1.4572-0.96185,3.2278-2.915,4.6464-4.1687'/%3E %3Cpath d='m281.4,161.96c-0.0443-0.002-0.49032-7.737-0.49032-7.737l-0.97414,7.6757,0.70154,1.3522,0.76292-1.2909'/%3E %3Cpath d='m285.46,156.67c-1.3891,2.0246-3.6307,5.0578-4.806,7.1817-0.67929-2.6103-2.051-6.5406-2.8906-8.9584,0.97816,1.921,2.1678,4.6717,3.2389,6.218,1.4155-1.045,3.0957-3.1045,4.4578-4.4413'/%3E %3Cpath d='m281.88,162.68c-0.0433-0.0142,0.78724-7.7718,0.78724-7.7718l-2.2149,7.3052,0.46702,1.529,0.96068-1.0624'/%3E %3Cpath d='m285.18,157.39c-1.1974,2.206-3.1506,5.5334-4.1267,7.8084-0.90975-2.5008-2.6261-6.2176-3.6778-8.5047,1.1445,1.7739,2.5738,4.3433,3.7769,5.7318,1.3118-1.2357,2.7952-3.517,4.0276-5.0355'/%3E %3Cpath d='m281.61,163.32c-0.0435,0.0121-2.172-7.3702-2.172-7.3702l0.73403,7.7686,0.97861,1.0955,0.45931-1.4939'/%3E %3Cpath d='m285.13,158.25c-1.2476,2.1993-3.2806,5.5166-4.3014,7.7848-0.91524-2.4932-2.6498-6.1988-3.7125-8.479,1.1622,1.7686,2.6107,4.3302,3.836,5.7144,1.3575-1.232,2.8996-3.5064,4.1778-5.0202'/%3E %3Cpath d='m281.71,164.71c-0.0459,0.00002-0.79743-7.7496-0.79743-7.7496l-0.71779,7.7504,0.77557,1.3281,0.73965-1.329'/%3E %3Cpath d='m285.26,158.93c-1.2828,2.1698-3.3689,5.4389-4.4262,7.6828-0.87461-2.5145-2.5487-6.2606-3.5741-8.5656,1.1332,1.7957,2.5398,4.3912,3.7424,5.8042,1.3771-1.1999,2.9555-3.4378,4.2579-4.9214'/%3E %3Cpath d='m281.64,165.33c-0.0457,0.005-1.438-7.6104-1.438-7.6104l-0.0703,7.7943,0.88248,1.2271,0.62581-1.411'/%3E %3Cpath d='m284.71,160.03c-1.3837,2.078-3.6216,5.1981-4.7836,7.3658-0.7531-2.5716-2.2454-6.4286-3.1591-8.8014,1.0454,1.8718,2.3257,4.5611,3.4586,6.0554,1.4316-1.1029,3.1136-3.2284,4.4842-4.6198'/%3E %3Cpath d='m280.97,166.18c-0.0447-0.0122,0.64352-7.779,0.64352-7.779l-2.1198,7.3762,0.51212,1.5034,0.96413-1.1006'/%3E %3Cpath d='m284.79,160.22c-1.1829,2.2504-3.1184,5.6512-4.0726,7.9608-0.98749-2.4525-2.8292-6.0817-3.9579-8.315,1.2132,1.7179,2.7357,4.2162,4.0008,5.5474,1.321-1.2885,2.7961-3.6264,4.0297-5.1932'/%3E %3Cpath d='m280.71,166.83c-0.0445,0.0139-2.3872-7.25-2.3872-7.25l0.91887,7.7096,1.0284,1.0491,0.44002-1.5087'/%3E %3Cpath d='m284.47,160.8c-0.82599,2.4697-2.2198,6.234-2.8118,8.7118-1.3408-2.1938-3.6994-5.3571-5.1462-7.3047,1.4525,1.4228,3.3268,3.5446,4.7723,4.5761,1.1066-1.5547,2.207-4.1742,3.1857-5.9832'/%3E %3Cpath d='m282.83,167.42c-0.0441,0.0157-2.5849-7.1499-2.5849-7.1499l1.1296,7.6676,1.0567,1.0074,0.39853-1.5251'/%3E %3Cpath d='m284.45,161.56c-0.80817,2.4781-2.1748,6.2568-2.7489,8.7406-1.3566-2.1795-3.7381-5.3178-5.199-7.2501,1.4628,1.4074,3.3524,3.5094,4.8054,4.5256,1.0954-1.5662,2.1769-4.197,3.1425-6.0161'/%3E %3Cpath d='m282.85,168.64c-0.0421,0.0224-3.3258-6.6866-3.3258-6.6866l1.9368,7.4247,1.1558,0.83503,0.23325-1.5732'/%3E %3Cpath d='m284.2,162.18c-0.5167,2.5726-1.4378,6.5146-1.7217,9.0594-1.5966-1.9663-4.3201-4.7362-5.9916-6.4424,1.613,1.1856,3.7295,2.9986,5.2878,3.7978,0.90653-1.7097,1.6769-4.4729,2.4255-6.4148'/%3E %3Cpath d='m283.07,169.69c-0.0454,0.009-1.7934-7.4979-1.7934-7.4979l0.29571,7.7844,0.9389,1.1646,0.55876-1.451'/%3E %3Cpath d='m284.21,162.98c-0.27334,2.6303-0.82051,6.6781-0.86543,9.2492-1.7668-1.7422-4.7264-4.1325-6.5433-5.6057,1.7105,0.96289,3.9788,2.4825,5.5991,3.0682,0.74032-1.8239,1.2476-4.678,1.8097-6.7117'/%3E %3Cpath d='m283.16,170.24c-0.0354,0.0346-4.7406-5.413-4.7406-5.413l3.5722,6.556,1.3053,0.44601-0.1369-1.589'/%3E %3Cpath d='m284.31,163.9c-0.2837,2.6285-0.84683,6.6728-0.90187,9.2435-1.76-1.7521-4.7104-4.1591-6.5216-5.6425,1.7068,0.97255,3.9692,2.505,5.5873,3.0998,0.74754-1.8195,1.266-4.6705,1.8362-6.7008'/%3E %3Cpath d='m283.69,171.49c-0.041,0.0242-3.6411-6.525-3.6411-6.525l2.2874,7.3243,1.195,0.78156,0.15873-1.5808'/%3E %3Cpath d='m284.52,164.98c-0.17301,2.6443-0.56557,6.7207-0.5128,9.2934-1.8299-1.6444-4.8751-3.8712-6.7449-5.244,1.7442,0.8685,4.0662,2.2628,5.7059,2.7592,0.66981-1.8639,1.0678-4.7448,1.5518-6.8086'/%3E %3Cpath d='m284.15,172.69c-0.0369,0.0323-4.4987-5.7041-4.4987-5.7041l3.2806,6.7699,1.2848,0.52845-0.0667-1.5943'/%3E %3Cpath d='m284.57,166.2c-0.15709,2.646-0.52509,6.7261-0.45686,9.2986-1.8395-1.6286-4.8978-3.829-6.7755-5.1857,1.7491,0.8534,4.0793,2.2276,5.7218,2.7098,0.65851-1.8699,1.0392-4.7545,1.5106-6.8227'/%3E %3Cpath d='m284.56,173.66c-0.0427,0.0197-3.1543-6.877-3.1543-6.877l1.7456,7.5287,1.1347,0.90411,0.274-1.5558'/%3E %3Cpath d='m284.69,166.99c0.0903,2.655,0.10463,6.7657,0.41156,9.317-1.9764-1.3734-5.215-3.1518-7.2041-4.2492,1.8146,0.6139,4.2541,1.668,5.9284,1.9268,0.4794-1.9499,0.58873-4.8724,0.86412-6.9945'/%3E %3Cpath d='m285.11,173.39c-0.0266,0.0435-5.7616-3.9448-5.7616-3.9448l4.8844,5.3824,1.3575,0.0701-0.4804-1.5077'/%3E %3Cpath d='m284.87,167.27c0.22922,2.6428,0.45861,6.7394,0.89939,9.2707-2.0509-1.2942-5.3868-2.9444-7.4359-3.9631,1.8492,0.54333,4.347,1.5018,6.0371,1.6964,0.37805-1.9616,0.3347-4.8786,0.49945-7.0041'/%3E %3Cpath d='m285.73,174.86c-0.0353,0.0336-4.8006-5.5183-4.8006-5.5183l3.636,6.6258,1.314,0.47899-0.14944-1.5865'/%3E %3Cpath d='m285.29,168.28c0.34006,2.6317,0.74172,6.7188,1.2879,9.2262-2.0982-1.1719-5.4919-2.6228-7.5767-3.5191,1.8655,0.43245,4.3949,1.2414,6.0871,1.3344,0.29381-1.9864,0.12737-4.9038,0.20173-7.0415'/%3E %3Cpath d='m286.69,175.79c-0.0271,0.0431-5.7175-4.0403-5.7175-4.0403l4.8227,5.4618,1.3574,0.0933-0.4626-1.5148'/%3E %3Cpath d='m285.47,169.4c0.51244,2.6008,1.1827,6.6519,1.8915,9.1088-2.1618-0.97386-5.6288-2.1041-7.7589-2.8035,1.8815,0.25605,4.4475,0.82589,6.1344,0.75872,0.15996-2.0152-0.19901-4.9183-0.26704-7.0641'/%3E %3Cpath d='m287.32,176.59c-0.0357,0.0328-4.729-5.6059-4.729-5.6059l3.5489,6.6901,1.3083,0.50387-0.12812-1.588'/%3E %3Cpath d='m285.78,170.12c0.75054,2.5293,1.7931,6.4861,2.7243,8.8454-2.2284-0.68355-5.7618-1.3487-7.9333-1.7623,1.8841,0.004,4.4741,0.22995,6.1355-0.0628-0.0309-2.0343-0.65805-4.8861-0.92656-7.0203'/%3E %3Cpath d='m287.57,176.6c-0.01,0.0517-6.6064-1.4152-6.6064-1.4152l6.2826,3.1233,1.2691-0.47761-0.94521-1.2305'/%3E %3Cpath d='m286.21,170.91c0.74065,2.533,1.7677,6.4948,2.6898,8.8588-2.2262-0.696-5.7576-1.381-7.9279-1.8067,1.8844,0.0147,4.4742,0.25521,6.137-0.0281-0.0228-2.034-0.63878-4.8887-0.89888-7.024'/%3E %3Cpath d='m288.65,177.3c-0.0197,0.0468-6.3209-3.0528-6.3209-3.0528l5.6692,4.5959,1.3583-0.12728-0.70667-1.4158'/%3E %3Cpath d='m285.88,171.35c1.2554,2.3082,3.0909,5.9481,4.4875,8.0501-2.3158-0.17673-5.9011-0.0474-8.1055,0.0273,1.8392-0.41187,4.4133-0.76254,5.9739-1.4156-0.45081-1.9829-1.6525-4.6337-2.3559-6.6618'/%3E %3Cpath d='m289.65,177.99c-0.0123,0.0508-6.5681-1.814-6.5681-1.814l6.1642,3.4904,1.2962-0.39585-0.89236-1.2805'/%3E %3Cpath d='m286.56,172.33c1.2689,2.2992,3.1258,5.9263,4.5345,8.0181-2.3151-0.15736-5.8968,0.002-8.099,0.0956,1.8352-0.42766,4.4051-0.80025,5.9604-1.4669-0.4629-1.9805-1.6803-4.6231-2.3958-6.6467'/%3E %3Cpath d='m290.48,178.53c-0.0234,0.0441-6.1205-3.6614-6.1205-3.6614l5.3476,5.1176,1.3751,0.0136-0.60219-1.4699'/%3E %3Cpath d='m287.07,172.91c1.4696,2.146,3.6456,5.55,5.2323,7.4692-2.2891,0.14354-5.7916,0.77074-7.9455,1.1516,1.761-0.66908,4.2489-1.3786,5.7118-2.2514-0.64696-1.9306-2.0993-4.4284-2.9986-6.3694'/%3E %3Cpath d='m290.93,179.07c-0.002,0.0538-6.6066-0.15568-6.6066-0.15568l6.5361,1.9315,1.1622-0.72207-1.0918-1.0538'/%3E %3Cpath d='m294.76,147.06c0.00065-0.0206,4.7533-0.79299,4.7533-0.79299l-4.7291,0.11031-0.82503,0.42379,0.80086,0.25889'/%3E %3Cpath d='m297.37,148.07c-1.3791-0.41674-3.4631-1.1148-4.8787-1.4225,1.5043-0.59791,3.7307-1.6585,5.1008-2.309-1.0541,0.65981-2.5868,1.5076-3.4038,2.1691,0.78925,0.5361,2.2218,1.0828,3.1818,1.5624'/%3E %3Cpath d='m294.55,147.22c-0.005-0.0199,4.5986-1.2633,4.5986-1.2633l-4.7642,0.6073-0.7185,0.49317,0.88409,0.16283'/%3E %3Cpath d='m297.59,148.41c-1.6114-0.15181-4.0828-0.46088-5.6728-0.47676,1.198-1.0608,2.8775-2.8356,3.9121-3.9252-0.71132,1.024-1.805,2.3829-2.2765,3.3514,1.0804,0.43367,2.8148,0.724,4.0372,1.0505'/%3E %3Cpath d='m292.84,147.55c0.004-0.0209,4.7795-0.53969,4.7795-0.53969l-4.657-0.14908-0.87096,0.38293,0.74852,0.30584'/%3E %3Cpath d='m296.38,148.59c-1.4653-0.28018-3.6918-0.76832-5.174-0.94216,1.4082-0.69122,3.4606-1.8807,4.7239-2.6105-0.94322,0.71246-2.3349,1.6427-3.0389,2.3371,0.89228,0.44221,2.4349,0.84107,3.489,1.2156'/%3E %3Cpath d='m292.43,147.5c-0.0121-0.018,4.207-1.8106,4.207-1.8106l-4.6079,1.2163-0.55216,0.56093,0.95306,0.0333'/%3E %3Cpath d='m296.24,149.12c-1.2194-0.5036-3.0876-1.3567-4.294-1.7117,0.93412-0.86906,2.2505-2.3921,3.0614-3.3263-0.56395,0.93353-1.4259,2.1406-1.8066,3.0664,0.80976,0.68926,2.1192,1.3658,3.0392,1.9717'/%3E %3Cpath d='m292.67,147.81c-0.009-0.0282,3.2732-1.4184,3.2732-1.4184l-3.5645,0.48835-0.43827,0.63528,0.72961,0.29475'/%3E %3Cpath d='m289.93,178.46c0.003,0.0524-6.7834,0.0512-6.7834,0.0512l6.8687,1.6793,1.1269-0.73842-1.2122-0.99207'/%3E %3Cpath d='m291.15,178.9c-0.008,0.0497-6.8895-1.6024-6.8895-1.6024l6.6159,3.2432,1.2964-0.41713-1.0228-1.2237'/%3E %3Cpath d='m292.28,179.36c-0.00001,0.052-6.8397-0.34479-6.8397-0.34479l6.8394,2.0617,1.1727-0.66479-1.1723-1.0521'/%3E %3Cpath d='m287.94,174.53c1.7794,1.9611,4.4452,5.086,6.3123,6.8152-2.2976,0.34709-5.7574,1.2758-7.8858,1.8423,1.6915-0.81215,4.1133-1.7294,5.4752-2.7134-0.91749-1.8253-2.7273-4.1313-3.9017-5.944'/%3E %3Cpath d='m293.22,179.71c-0.0125,0.0479-6.8369-2.2373-6.8369-2.2373l6.4245,3.8199,1.3459-0.28376-0.9335-1.2989'/%3E %3Cpath d='m288.57,174.98c1.9393,1.7687,4.8642,4.6079,6.8646,6.1309-2.2015,0.63398-5.474,2.0002-7.4877,2.8357,1.5623-1.0308,3.8248-2.2579,5.0481-3.4224-1.0855-1.737-3.0907-3.8515-4.425-5.5442'/%3E %3Cpath d='m293.78,180.13c0.0106,0.0527-6.4875,1.2757-6.4875,1.2757l6.8362,0.46588,0.96514-0.95299-1.3138-0.78855'/%3E %3Cpath d='m292.43,179.72c0.007,0.0521-6.7667,0.51919-6.7667,0.51919l6.9817,1.1997,1.0693-0.81376-1.2844-0.90516'/%3E %3Cpath d='m293.68,180.08c-0.005,0.0501-6.9968-1.1217-6.9968-1.1217l6.8468,2.776,1.2626-0.50524-1.1127-1.1491z'/%3E %3Cpath d='m294.84,180.46c0.004,0.0518-6.8526,0.12836-6.8526,0.12836l6.9812,1.5829,1.1205-0.74354-1.2491-0.96772z'/%3E %3Cpath d='m290.14,175.94c1.9233,1.8319,4.8186,4.7625,6.812,6.3572-2.2671,0.5045-5.6507,1.669-7.7325,2.3804,1.6273-0.92621,3.9756-2.0076,5.261-3.0824-1.0528-1.756-3.0324-3.9295-4.3406-5.6552z'/%3E %3Cpath d='m295.81,180.74c-0.009,0.0487-6.9919-1.7581-6.9919-1.7581l6.6991,3.364,1.3221-0.37572-1.0293-1.2302z'/%3E %3Cpath d='m290.81,176.34c2.0685,1.6291,5.201,4.2571,7.3119,5.637-2.1497,0.78383-5.3134,2.3714-7.2605,3.3431,1.4819-1.1352,3.648-2.5144,4.7815-3.7595-1.2138-1.6564-3.374-3.6256-4.8329-5.2206z'/%3E %3Cpath d='m296.4,181.12c0.0145,0.0519-6.3794,1.7192-6.3794,1.7192l6.8581-0.007,0.89174-1.0165-1.3705-0.6953z'/%3E %3C/g%3E %3Cpath d='m305.21,171.52-5.2112-3.6015-5.2113,3.6015,1.9542-5.7624-4.5599-3.6016,5.8626,0,1.9542-5.7624,1.9542,5.7624,5.8626,0-4.5598,3.6016,1.9542,5.7624z' fill='%23fedf00' stroke='%23000' stroke-width='0.298846'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1400' height='550' viewBox='0 0 75 18' preserveAspectRatio='none'%3E %3Crect width='75' height='18' fill='%238d1b3d'/%3E %3Cpath d='M22,18H0V0H22l6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1z' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='900' height='600'%3E%3Crect width='900' height='600' fill='%23ED2939'/%3E%3Crect width='600' height='600' fill='%23fff'/%3E%3Crect width='300' height='600' fill='%23002395'/%3E%3C/svg%3E"

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' x='0' y='0' fill='%23002B7F'/%3E %3Crect width='1' height='2' x='1' y='0' fill='%23FCD116'/%3E %3Crect width='1' height='2' x='2' y='0' fill='%23CE1126'/%3E %3C/svg%3E"

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1350' height='900'%3E %3Crect width='1350' height='900' fill='%23fff'/%3E %3Crect width='1350' height='600' fill='%230c4076'/%3E %3Crect width='1350' height='300' fill='%23c6363c'/%3E %3Cg%3E %3Cg transform='matrix(1,0,0,1.0043716,0,-0.32788075)'%3E %3Cpath fill='%2321231e' d='m473.38,259.35zm1.0098,0.0337zm-93.132,5.2436c-2.30984-0.2547,3.48357-0.77423,4.85921-0.74476,29.2392-1.8271,58.4803-3.65646,87.7454-5.02418,0.006,2.14822-3.95456,0.6738-5.64195,1.28281-29.1557,1.44472-58.2914,3.26022-87.4244,5.10075l0.24884-0.33104,0.21312-0.28351-0.00025-0.00007zm-0.98838,0.21166zm6.5343,31.051c-2.1781-10.3503-4.3562-20.7007-6.5343-31.051,2.24726-0.16069,1.38028,4.47146,2.35289,6.27247,1.72326,8.18896,3.44653,16.3779,5.16979,24.5669-0.40297,0.52555-0.43759,0.86795-0.98838,0.21166zm0.50852,0.40289zm94.846-4.0806c0.0433,2.29366-4.10686,0.52718-5.7799,1.1954-29.69,0.92479-59.374,2.03894-89.0665,2.88458,0.19988-2.2311,4.5146-0.57519,6.41431-1.2042,29.4799-0.8776,58.953-1.98321,88.4321-2.87578zm-0.031,0zm94.368,3.466c2.17326,1.02636-3.85742,0.3909-5.13524,0.45206-29.7469-0.88096-59.4862-1.99829-89.2324-2.90039,0.261-2.20443,4.35614-0.33324,6.22483-0.82645,29.5516,0.92252,59.0972,2.03005,88.6514,2.87146l-0.3246,0.25718-0.18392,0.14571-0.00004,0.00043zm0.98838,0.21167zm6.5343-31.051c-2.1781,10.3503-4.3562,20.7007-6.5343,31.051-2.11816-0.77417,0.53953-4.65151,0.37613-6.6958,1.72326-8.18896,3.44653-16.3779,5.16979-24.5669,0.52516-0.60989,0.63576-0.32596,0.98838,0.21167zm-0.46196-0.61456zm-93.659-4.8395c0.85119-0.69952,3.25454-0.4022,5.6201-0.28896,29.3609,1.44451,58.7011,3.27626,88.0386,5.12823-0.33902,2.1985-4.37641,0.19693-6.27673,0.62314-28.9574-1.80781-57.9166-3.61747-86.8995-4.97079l-0.28992-0.29572-0.19233-0.19618-0.0002,0.00028zm0.48224,0.49189zm0.52164-0.70235zm-1.0098,0.0337zm-7.7662,0.33554c-0.26642-2.10699,3.13572-0.64702,4.5454-1.14803,1.46862,0.29926,4.03852-0.80448,4.72484,0.78781-1.24999,1.64015-1.01458-2.07321-0.69234,0.279-2.85184-0.1798-5.72414,0.0233-8.5779,0.0812zm0.0358,0zm-8.2687,0.15754c1.0121-0.99117-2.1605,0.38747-0.12416-1.2868,2.79684-0.11403,5.59664,0.039,8.39288,0.1126,0.0956,2.04592-3.17785,0.47514-4.63511,0.8877-1.04538-0.12573-3.39414,0.14117-3.7721-0.0661-0.18937-1.11976,0.32819-1.11472,0.13849,0.35262zm-0.001-1.0198zm-0.50493,0.49309z'/%3E %3Cpath fill='%2321231e' d='m595.05,245.94c0.0372-1.74531-1.12336,2.50426-2.61752,3.49924-3.30087,4.72366-5.97194,9.84635-8.52802,14.9999-1.91597-0.9918,1.28773-3.68708,1.60194-5.38187,2.55225-4.85337,5.37293-9.59783,8.85245-13.8509,0.23038,0.24454,0.46077,0.48908,0.69115,0.73362zm-19.257-3.8894c1.11489-2.15622,0.74235,3.64582,1.68789,4.68067,1.01782,4.15895,6.01522,4.8658,9.30486,2.99685,2.75858-1.1619,5.26098-2.84052,7.66234-4.60855,1.10343,2.00092-3.51171,3.10344-4.95573,4.43176-3.68943,2.32758-9.93234,3.71048-12.3254-1.08238-1.13466-2.10183-1.51617-4.50635-1.7094-6.85988l0.27578,0.36288,0.0596,0.0785,0.00003,0.00016zm0.33662-0.95972zm-2.3217,0.50873c-1.86165-1.06886,1.12616-0.83085,2.00025-0.60675,0.84953,0.6349-0.32476,1.29458-1.08013,0.87102-0.28529-0.10725-2.05396,0.15027-0.92012-0.26427zm-0.8499-0.55322zm-25.304-5.2652c-1.11228-1.84231,2.27293,3.41439,2.86485,4.85914,2.77981,4.639,7.31564,10.8912,13.5437,8.97385,3.98056-1.52616,6.61543-5.14297,8.89543-8.56764,1.75148,1.36422-1.99329,3.85915-2.86027,5.44615-3.18666,4.14828-9.57046,6.29638-13.8855,2.5393-4.38568-3.38206-7.03834-8.43233-9.44151-13.3037l0.45497,0.0273,0.42837,0.0257v-0.00006zm-0.85469-0.54601zm-28.404-0.52196c-0.9862-1.97825,2.03968,3.3787,2.5155,4.7294,2.43356,4.82873,7.244,10.8718,13.3708,8.52925,5.67603-2.37174,9.24016-7.79817,12.5177-12.7367,1.73769,1.46427-2.17742,4.15712-2.93552,5.96811-3.59358,4.70113-9.60295,10.4227-15.9662,7.48462-5.40233-2.82024-8.04852-8.77773-10.364-14.0999l0.45106,0.0655,0.41079,0.0596-0.0001,0.00014zm-0.78784-0.63739zm-33.758,0.67227c2.08897-0.5,2.52174,3.56913,4.3558,4.98183,3.49185,5.14994,10.3852,8.68657,16.3777,5.63581,5.33949-2.39297,9.39208-6.83258,13.024-11.29,1.56541,1.64519-2.6179,3.87631-3.56828,5.58578-4.92733,5.29594-12.9451,10.3756-20.1567,6.41828-4.51465-2.44149-7.70441-6.88804-10.0326-11.3317zm0.0645,0.24895zm0.94659-2.3343zm-1.0122,0zm-0.97763,0.3644c1.20423-0.49907,0.15925-0.84589,1.53075-0.65462-0.68554,0.7487,0.0961,1.26538,0.1567-0.17391,1.74497,1.19636-1.11609,1.56779-1.68745,0.82853zm0.38079,0.27301zm0.32587-1.1173zm-0.5479-0.26819zm-0.97525,1.1906c-0.16788-1.11305,0.0537-1.03062,0.9747-1.19,0.75087,1.27677-0.24,1.04137-0.9747,1.19zm0.18144,0zm-0.6231-0.45821c-2.47651-0.75314,1.95467-1.21263,0.4078,0.45179-0.35682-0.13032-1.64228-0.10653-0.4078-0.45179zm-0.90005-0.46423zm-0.19338,0.38004zm0.90005,0.46423zm-0.97883-0.36441c-2.16759-0.42351,0.61642,1.34548-0.52538-0.28424,0.9365-0.53696,1.75305,1.18652,0.35001,1.0037-1.59127,0.40291-1.09639-2.14183,0.17537-0.71946zm-0.71026-0.46542zm-0.302,2.552zm1.0122,0zm-33.684-0.16117c-1.52923-1.61612,2.78602,2.5088,3.5859,3.71858,4.69831,5.08626,12.0826,10.5385,19.2279,7.06916,4.5087-2.27149,7.49211-6.60018,9.922-10.8754,1.84456,1.34183-1.92238,4.18942-2.67985,5.9483-3.75595,5.44876-11.095,9.05955-17.4479,5.87542-5.52407-2.4388-9.72564-7.00847-13.4698-11.6108l0.45106-0.0655,0.41078-0.0596-0.00009-0.00009zm-0.93585-0.38725zm-28.302,1.5274c-1.38497-1.70396,2.49951,2.80557,3.14895,4.13944,3.45105,4.44999,8.6491,10.35,14.9307,8.07341,5.39524-2.60704,7.94324-8.55017,10.2228-13.7403,1.93604,1.19867-1.46661,4.57244-1.98583,6.51653-2.57583,5.01954-7.95743,10.6591-14.1249,8.22888-5.92753-2.41297-9.67595-8.02348-13.0751-13.165l0.45497-0.0273,0.42836-0.0257,0.0001,0.00001zm-0.91199-0.44016zm-25.7,6.5448c0.26845-2.42295,2.48706,3.01062,3.72633,3.64645,2.90521,3.86884,8.7862,6.35487,12.8763,2.70906,4.22689-3.29104,6.76664-8.1916,9.09722-12.9004,1.91177,1.29626-1.73644,4.49387-2.30264,6.43896-2.93895,4.87791-7.97076,10.977-14.4031,8.85164-4.20281-1.58182-7.02251-5.36233-9.41826-8.97893l0.39927,0.21982,0.0245,0.0135,0.00039-0.00014zm0.002-1.0198zm-2.077,0.79616c-2.21632-0.32364,0.86972-0.99964,1.81233-0.79438,1.10472,0.97881-0.44028,1.14503-1.309,1.0668-0.35662-0.0624-1.37114,0.51995-0.50333-0.27242zm-1.0075-0.077zm-17.892,3.6741c-1.66824-0.0297,3.14066,1.52771,4.4072,2.92192,3.41176,2.18178,9.44342,4.50078,11.9023-0.15689,1.05898-1.97376,1.39688-4.23344,1.58274-6.43893,2.19242,0.32355,0.0526,4.33402-0.24416,5.98073-1.43759,4.63417-7.192,5.11424-10.877,2.97475-2.6748-1.17937-5.11411-2.82219-7.46235-4.54787,0.23045-0.24454,0.46079-0.4892,0.69126-0.73371zm10.885,18.497c-0.17763,2.44645-1.89403-2.6447-2.60701-3.55988-2.60833-5.00483-5.47769-9.91068-9.05895-14.2899,1.67772-1.37425,2.76531,2.68796,4.04782,3.74505,3.09639,4.55843,5.64713,9.45624,8.09207,14.3861l-0.39189-0.23272-0.082-0.0487-0.00003,0.00004zm0.043,1.0174zm101.31-5.9736c-0.18613,2.39053-4.82344,0.59472-6.77936,1.37442-31.5046,1.65513-63.0113,3.28334-94.5322,4.5991,0.35876-2.32098,5.10517-0.60957,7.21342-1.32617,31.3754-1.35332,62.7371-3.00314,94.0982-4.64735zm-0.0525,0zm101.33,4.9549c-0.21954,2.38729-4.8924,0.12992-6.82256,0.72972-31.5125-1.35806-63.0114-3.00913-94.5093-4.66704,0.56932-2.27695,5.12619-0.12692,7.28702-0.63649,31.3277,1.64549,62.7732,3.26971,94.0449,4.57381zm0,1.0198zm0.001,0zm0.45242-0.28262z'/%3E %3Cpath d='m583.45,264.21c3.2719-6.6002,6.7086-13.075,11.297-18.682-11.747,8.7421-17.928,7.4228-18.788-3.9591-0.69592-0.24775-1.6377-0.24775-2.5784-0.24775-8.9635,13.98-17.683,12.042-26.156-5.8148-11.543,18.351-21.448,18.022-29.225-1.1137-13.313,16.726-24.528,16.772-33.646,0.35359l-0.001-2.0854c0.50732,0.2261,0.16233,0.29826-1.0338,0.13229l-0.19337-0.38004c-0.35573,0.071-0.6828,0.13349-0.98242,0.18881-0.29961-0.0553-0.62789-0.11785-0.98241-0.18881l-0.19338,0.38004c-1.1973,0.16597-1.5422,0.0937-1.0349-0.13229v2.0866c-9.1174,16.417-20.333,16.372-33.646-0.35478-7.7769,19.135-17.683,19.465-29.226,1.1137-8.4717,17.857-17.192,19.794-26.155,5.8148-0.94064-0.001-1.8825,0-2.5796,0.24775-0.85827,11.382-7.0392,12.701-18.786,3.9591,4.5874,5.6068,8.0252,12.082,11.297,18.682,33.848-1.4131,67.579-3.181,101.31-4.9561,33.728,1.7751,67.457,3.543,101.31,4.9561h0.001z' fill='%23edb92e'/%3E %3Cpolygon points='504.63,277.31,482.13,288.56,459.63,277.31,482.13,266.06' transform='matrix(1.0106622,0,0,1.0182434,-5.1283744,-6.1909008)' fill='%23EDB92E'/%3E %3Cg%3E %3Cpath fill='%23edb92e' d='m473.89,259.19-0.006,0.17559c-17.488,0.78174-48.477,2.522-93.121,5.3662l6.5343,31.051c29.651-0.83704,64.257-2.1383,94.845-3.0632,30.588,0.92484,65.195,2.2261,94.846,3.0632l6.5343-31.051c-44.64-2.86-75.63-4.6-93.12-5.38l-0.006-0.17679c1.7667-0.34755-0.97524-0.40769-8.2532-0.15633-7.278-0.25257-10.018-0.19122-8.2508,0.15633h-0.001z'/%3E %3Cpath fill='%23edb92e' d='m597.33,236.74-3.6837-0.61936c-7.075,17.39-13.417,17.812-14.611,1.27,1.5816-0.56885,0.95733-3.335,2.7491-2.2285,0.93943,0.57848,2.1308-1.0692,1.3536-1.9772-2.0054-1.4817-3.7876-1.252-5.5411,0.39808-0.82484-2.641-2.8506-3.8725-5.3752-2.7601-1.0898,0.48106-0.71621,2.4582,0.3784,2.3452,1.7679-0.18401,1.0576,1.6657,1.6079,2.902-12.548,16.482-18.963,14.52-17.4-7.1245-2.9878-0.61936-6.4662-1.2375-9.577-2.3512-11.548,23.346-19.765,24.349-26.418,3.3987,1.4253-1.068,1.0194-3.7511,3.1024-2.8888,1.1734,0.48587,2.1594-1.5995,1.1102-2.4895-2.4316-2.0613-5.0708-1.365-6.8387,1.2844-1.4193-2.8539-3.9488-3.8834-6.619-2.1491-1.1531,0.74804-0.43809,2.9429,0.78665,2.611,2.3528-0.63621,1.2964,2.4738,3.0762,3.5406-5.1007,19.695-30.867,21.02-26.65-8.1311-2.3647,0.0794-4.5014,0.15995-6.6298,0.23933-2.1296-0.0795-4.2663-0.15995-6.6322-0.23933,4.2173,29.151-21.55,27.826-26.649,8.1311,1.7786-1.0668,0.72218-4.1756,3.075-3.5406,1.2247,0.33193,1.9409-1.8629,0.78782-2.611-2.6715-1.7342-5.1997-0.70476-6.619,2.1491-1.769-2.6494-4.4083-3.3458-6.8387-1.2844-1.0504,0.88996-0.0645,2.9754,1.1101,2.4895,2.0818-0.86229,1.676,1.8208,3.1012,2.8888-6.6525,20.95-14.869,19.947-26.416-3.3987-3.1108,1.1136-6.5904,1.7318-9.5782,2.3512,1.5626,21.644-4.8512,23.607-17.4,7.1245,0.5503-1.2363-0.15875-3.086,1.6079-2.902,1.0946,0.11304,1.4694-1.8653,0.3796-2.3452-2.5259-1.1137-4.5504,0.11906-5.3752,2.7601-1.7535-1.65-3.5369-1.8785-5.5423-0.39808-0.77709,0.908,0.41542,2.5556,1.3536,1.9772,1.7929-1.1064,1.1674,1.6597,2.7491,2.2285-1.1925,16.542-7.5358,16.12-14.61-1.27l-3.6837,0.61936c-0.1134,4.0866,1.3059,8.4342,3.8067,11.63,10.608,13.554,18.499,10.479,18.788-4.7012,13.89,16.392,24.394,14.319,26.278-2.9705,11.685,21.809,30.433,11.372,30.821-1.8557,5.146,19.226,33.665,19.091,35.489-3.0066,1.8228,22.096,30.34,22.232,35.487,3.0066,0.38795,13.227,19.136,23.665,30.821,1.8557,1.8836,17.289,12.388,19.363,26.278,2.9705,0.28769,15.18,8.178,18.255,18.788,4.7012,2.4996-3.1942,3.9201-7.543,3.8067-11.63h-0.002z'/%3E %3Cpath fill='%2321231e' d='m593.72,235.62c4.42035,0.0529,4.09659,2.47992-0.16711,1.00541-0.24039-0.55867-0.74483-0.76636,0.16711-1.00541zm-0.55148,0.30909zm-14.312,0.98376c1.16449,0.80019,0.75643,3.84363,1.44574,6.24637,0.44281,2.39292,1.81934,7.19081,5.10289,5.32393,3.94972-3.12497,5.7706-8.0871,7.76379-12.5545,1.99124,1.0586-1.31141,4.28763-1.69505,6.15516-1.90284,3.11051-4.05796,8.35163-8.46091,7.75936-4.07546-2.50461-3.88959-8.1876-4.49068-12.4138l0.25373-0.39259,0.0805-0.12454v0.00057zm-0.33422,0.51714zm3.5166-2.6999c-0.23535,1.18205-1.37813,0.21489-1.45473,1.61274-0.0853,1.41247-2.39737,1.81681-1.40024,0.36786,0.74771-1.00213,1.07014-3.22892,2.85497-1.9806zm0.79018-1.1317c1.39325-2.16743,1.4084,2.38339-0.43779,2.18026-1.68696-0.0134-0.0348-0.99845,0.42268-1.59091,0.19229-0.13451-0.11764-0.8219,0.0151-0.58935zm0.59923-0.8226zm-6.323,0.96212c0.83333-0.13234,0.38212-1.6633,2.72043-1.97821,1.17208-0.2798,4.42981,0.43022,3.00334,1.83897-1.41394-1.3028-3.66527-1.07437-4.89654,0.35919l-0.45173-0.12018-0.3755-0.0999v0.00013zm0.82723,0.22008zm-5.5173-2.6663c-1.10113-1.94135,3.00183-1.62888,3.93323-0.56399,1.47105,0.51458,2.0684,4.23919,0.51457,2.35959-0.66798-1.83311-2.68078-2.72664-4.4478-1.7956zm0.12296,1.3722c0.49138,2.55158-2.61806-0.5429-1.21772-1.70331,0.92324-1.27327,1.10805,0.4049,0.76102,1.16989,0.0389,0.22812,0.18514,0.56135,0.4567,0.53342zm2.0615,3.7186c-1.13998-0.33671-1.03714-0.339-1.21378-1.9976,0.0869-0.91014-1.56601-0.90876-0.65384-1.73452,2.00859-0.11834,1.68723,2.44935,1.86762,3.73212zm0.0609-0.51833zm-17.964-6.4173c1.04706-2.14916,0.19517,4.21701,0.38105,5.54021,0.26715,3.80995-0.2516,8.9339,3.30869,11.3438,4.47689,0.55328,7.55438-3.97647,10.3697-6.8032,0.86954-1.79634,5.2322-5.59717,2.69668-1.66852-3.4853,3.86519-7.02787,9.44546-12.7512,9.6081-4.65413-1.61747-4.34631-7.71439-4.62884-11.7784,0.20662-1.36132-0.39676-7.09256,0.62388-6.24209zm0.20293-0.99821zm-9.2261-1.6248c-1.97345-1.45633,2.81352,0.35091,3.88548,0.49541,1.58037,0.68088,4.56327,0.35935,5.24746,1.58708-0.86854,1.12176-3.59656-0.52247-5.17107-0.52308-0.75062-0.32725-5.48367-1.02535-3.96187-1.55941zm-0.90483-0.45459zm-26.267,3.2171c1.43621,0.48473,1.67472,3.74145,2.86863,5.95494,1.73695,3.82972,4.34092,9.73853,9.4897,8.7066,6.46687-2.86337,9.49052-9.96879,12.8395-15.7643,2.04472-4.36295,1.87416,0.23332,0.0233,2.12412-3.32088,5.54051-6.48027,12.5373-13.0484,14.7154-5.8784,0.76848-8.68815-5.79593-10.5951-10.2536-0.46518-1.7455-1.84757-3.70414-1.57769-5.48321zm-0.17906,0.56404zm3.7757-3.5153c-0.28562,1.11307-1.89302,0.73119-1.97294,2.40994-0.26968,1.76224-2.3634,1.04814-1.04793-0.1732,0.53218-1.28237,1.24182-3.1327,3.02087-2.23674zm0.59208-1.6284c1.53383-2.08556,1.80574,2.6853-0.15308,2.65302-1.59974,0.0775-0.13414-1.01715,0.33222-1.57458,0.135-0.35201,0.1353-0.8206-0.17914-1.07844zm-6.9652,1.1233c0.59863-0.2418,0.55796-2.35872,3.02125-2.99938,1.38406-0.60916,4.46706,0.0855,4.29584,1.45571-0.85556,0.72177-2.39721-1.38554-3.78255-0.54881-1.58898,0.12001-2.08177,2.39643-3.53454,2.09248zm0.87259,0.0553zm-6.7659-2.0048c-1.51989-1.62577,2.34198-2.01658,3.42371-1.63211,1.34497,0.33514,4.31386,2.68693,2.54009,3.5459-1.04631-2.17041-3.7058-3.65923-5.9638-1.91379zm0.38198,1.6909c0.89366,2.27048-2.41443,0.24126-1.73476-1.16446-0.13078-1.62648,1.89793-1.29375,1.034-0.0613-0.11278,0.44842,0.0985,1.32368,0.70076,1.22572zm3.6969,4.1612c-1.09755,0.41176-1.66777-0.25075-2.20698-2.07939,0.0966-1.47169-1.62615-0.81171-1.49028-2.08174,2.75889-0.77621,2.22201,2.95428,3.69726,4.16113zm-0.23039-0.56645zm-26.893-7.1846c0.70054-2.21881-0.0356,4.12807,0.0428,5.55076-0.31094,6.59403,2.67729,15.2506,10.3023,15.8513,7.93822,0.47477,14.0898-6.72709,15.799-13.9082,2.11226,0.9697-1.03572,4.79975-1.7058,6.62573-3.65534,6.67077-13.2265,11.3076-19.8765,6.06713-5.97109-4.98168-6.0368-13.6799-5.07894-20.7688l0.31038,0.34953,0.2065,0.23255,0.00019-0.00003zm-0.0335-1.0174zm-6.6322,1.2568c-0.43299-1.96683,2.45398-0.70454,3.63958-1.1474,1.06516-0.15604,4.19908-0.27263,2.58682,0.9304-2.07561,0.0679-4.15097,0.14508-6.2264,0.217zm0.0382,0zm-6.1511-0.8214c-2.37288-0.0858,1.53868-0.67901,2.51035-0.33436,1.19816,0.38358,4.00588-0.72539,3.60257,1.1474-2.20983-0.0798-4.41966-0.15955-6.62978-0.231l0.31037-0.34954,0.20649-0.23254v0.00004zm-1.0003,0.14672zm-26.408,7.62c1.32812,0.61093,1.58193,3.93667,3.11235,6.05203,3.29761,6.35393,12.302,11.0914,18.6298,6.12001,5.61917-4.8039,5.55221-13.054,4.66592-19.7922,2.31595,0.081,1.01905,4.8802,1.4448,6.89443,0.13978,6.85334-3.40948,15.3774-11.1777,15.9536-8.44274,0.57476-15.0885-7.0012-16.9056-14.6615l0.17611-0.433,0.0543-0.13345,0.00002-0.00003zm-0.23038,0.56645zm3.6957-4.1612c0.17186,1.35151-1.60823,0.56743-1.49135,2.08506,0.0702,1.23372-1.98714,3.35454-1.74869,1.34333,1.12205-1.20159,0.7023-4.22121,3.24004-3.42839zm0.38317-1.6909c1.257-2.26578,2.12993,2.43562,0.18168,2.64947-1.5772,0.28534-0.26066-0.99056,0.13109-1.60207,0.0893-0.36811,0.0276-0.8267-0.31277-1.0474zm-6.7647,2.0048c0.56002-0.31749,0.25863-2.41144,2.61658-3.36142,1.29405-0.77958,4.4397-0.48861,4.44325,0.89445-0.75592,0.82473-2.55305-1.06666-3.82015-0.0612-1.55975,0.32466-1.76128,2.64329-3.23968,2.52821zm0.87139-0.0553zm-6.9652-1.1233c-1.60139-1.48335,2.21402-2.38904,3.44381-2.01373,1.29245,0.26808,4.46434,2.19182,2.65,3.19183-1.19948-2.20484-4.20839-3.10711-6.09381-1.1781zm0.59207,1.6284c1.17474,2.13851-2.36964,0.5493-1.86635-0.93336-0.33757-1.59676,1.71914-1.52398,1.01696-0.19253-0.0575,0.45817,0.26762,1.30226,0.84939,1.12589zm3.7745,3.5153c-1.12885,0.24263-1.39578-0.15952-2.12358-1.84607-0.0726-1.27557-2.18026-0.53676-1.43-1.7523,2.27211-0.7746,2.52113,2.39996,3.55358,3.59837zm-0.17905-0.56404zm-26.549-2.5099c-0.20613-2.40415,2.31228,3.55091,3.08216,4.61773,3.02653,4.83326,5.94433,11.0441,11.8558,12.7077,5.32028,0.005,7.46122-6.07353,9.2715-10.1591,0.18743-2.16352,3.16509-6.73035,1.88717-2.18019-2.02789,5.03619-3.99282,11.9749-9.99368,13.3448-6.13222-0.0317-9.50612-6.3623-12.5266-10.8386-1.51372-2.51789-2.88962-5.11547-4.1982-7.745l0.4331,0.17588,0.18881,0.0767-0.00006,0.00012zm-0.33901-0.95972zm-8.905,2.7938c-2.44392-0.25038,2.49295-1.10568,3.52018-1.31458,1.796-0.0615,4.29113-1.68992,5.54045-1.0382-0.22903,1.46978-3.54391,1.31649-5.0188,1.96674-0.80026-0.0462-5.11995,1.56276-4.04183,0.38604zm-1.0075,0.0746zm-17.359,6.8792c1.62514-0.26637,2.7218,2.82629,4.52032,4.36682,2.64721,2.61004,5.60126,6.6892,9.75499,6.09987,3.67356-2.52608,3.03684-7.87318,3.3113-11.8113-0.22927-1.58273-0.29613-8.21137,0.86711-4.2096,0.0282,5.38671,0.95481,11.7155-2.62549,16.224-3.98436,2.8873-8.25184-1.74594-10.9447-4.40679-1.64525-1.98437-3.90449-3.92324-4.88351-6.26307zm0.0609,0.51834zm2.0603-3.7186c0.0573,1.1083-1.30725,1.27342-0.95683,2.74358-0.0238,1.5391-1.66221,0.42631-0.94422-0.64333-0.01-1.14564,0.53696-2.34128,1.90105-2.10025zm0.12535-1.3722c0.78758-2.41774,2.29117,1.77206,0.51715,2.2416-1.53929,0.46951-0.16203-1.02224-0.1798-1.7495-0.0267-0.20498-0.14395-0.40762-0.33735-0.4921zm-5.5173,2.6663c0.51763-0.48894-0.29603-2.04707,1.76661-3.36862,1.00522-0.93845,4.80223-1.15124,3.75059,0.70239-1.95742-1.12537-4.29065,0.37605-4.68992,2.44632l-0.45173,0.12018-0.3755,0.0999-0.00005-0.00016zm0.82723-0.22008zm-5.6414-0.21768c-1.86926-1.14879,1.8532-2.10338,2.91983-1.76082,1.25511-0.0716,3.58554,2.13489,1.58641,1.92408-1.23885-1.35616-3.52774-1.08766-4.50624-0.16326zm-0.76636-0.66627zm1.473,1.8761c1.44185,2.18869-2.71479,0.50151-1.81331-1.1762,0.56143-1.47218,1.03191,0.29238,1.25545,0.99342,0.13426,0.14069,0.36212,0.31005,0.55786,0.18278zm3.5166,2.6999c-1.01377,0.43418-1.39273,0.35279-2.16799-1.34341-0.0205-1.11221-1.69813-0.36509-1.15854-1.46471,2.08909-1.07409,2.00031,2.07091,3.32653,2.80812zm-0.33423-0.51714zm-14.696-0.28743c0.12316-2.41599,1.94674,3.46092,2.756,4.55326,1.75343,2.89042,3.345,7.20687,7.08959,7.78886,3.70041-1.83945,3.45901-7.02126,4.0898-10.5885,1.42518-3.13202,0.95656,2.87974,0.45967,4.22111-0.48788,3.05305-2.05363,8.6329-6.19197,7.0685-4.64909-2.95496-6.5632-8.55575-8.75457-13.3517l0.40777,0.22853,0.14372,0.0805-0.00001-0.00056zm-0.16713-1.0054zm-3.6837,0.61938c4.197-1.39605,4.67574,1.00496,0.16713,1.00539-0.45609-0.44178-0.9044-0.47541-0.16713-1.00539zm-0.42138,0.48826zm4.7091,11.329c-1.96327,1.27455-2.90857-3.47938-3.76133-5.00663-0.27102-1.81139-2.18384-6.03476,0.0623-6.29353-0.0867,4.03391,1.22986,8.10515,3.69903,11.3002zm18.774-4.7168c-0.57942,0.10382,0.61202,3.22996-0.34136,5.53456-0.41833,4.36839-3.7059,10.0567-8.85811,8.34339-4.3935-1.40679-7.54471-5.06691-10.3699-8.53102,1.93398-1.14164,3.2716,3.40997,5.27529,4.26152,2.70567,2.83653,8.32834,5.52335,10.9866,1.20459,1.98402-3.09737,2.28728-6.90811,2.41702-10.4918,0.29468-0.10875,0.596-0.21234,0.89052-0.32122zm-0.89051,0.32112zm27.229-3.2027c-0.73331-0.12534,0.33883,3.13873-0.82706,5.27183-0.93273,5.15528-5.2038,10.8982-11.0872,9.49409-6.34385-1.49385-11.0351-6.51575-15.1934-11.2231,1.9628-1.14876,3.54231,3.4401,5.56848,4.39539,3.94613,3.58897,9.94985,8.1238,15.3223,4.74722,3.75514-2.95948,4.69246-8.01621,5.26898-12.499,0.31596-0.0615,0.63199-0.12502,0.94794-0.18638zm-0.94779,0.18641zm31.812-1.9327c-0.84669-0.52848,0.50928,3.5402-1.15529,5.51589-2.98148,8.14953-13.6758,12.3997-21.1058,7.4451-4.19781-2.47528-7.19615-6.51667-9.4933-10.7315,2.12416-0.79947,2.70082,3.92604,4.59525,5.10187,4.29725,5.96091,13.1602,9.09795,19.5534,4.5251,3.8924-2.57725,6.47361-7.05924,6.61303-11.7403,0.32679-0.0368,0.66793-0.0804,0.99272-0.11622zm35.504-2.9164c-0.90424-0.77737,0.36918,3.46903-1.06527,5.39795-2.69462,9.73313-14.4084,14.6829-23.5415,10.9869-5.84185-2.07991-10.3483-7.2207-11.8736-13.2039,2.22138-0.25699,1.89244,4.47389,3.82698,5.8678,6.19346,9.31131,21.6996,10.2443,28.2285,0.82498,2.06414-2.87919,3.11581-6.36922,3.41754-9.8737,0.33495-0.00018,0.6729,0.00023,1.00738-0.00005zm35.489,3.0331c-0.75342-0.71764-0.24281,3.50227-2.09139,5.16766-5.62112,10.4033-21.738,12.7611-29.632,3.70293-2.92746-3.22499-4.41496-7.52579-4.77259-11.8196,2.22471,0.10134,0.9645,4.60047,2.50861,6.29088,3.52246,9.7114,16.4886,12.9971,24.8557,7.55166,4.05827-2.38237,6.94259-6.49016,8.13852-11.0105,0.32986,0.0401,0.66388,0.0764,0.99316,0.11699zm30.819,1.816c-0.54989-0.32762-1.23663,3.57341-3.19459,5.19045-4.33233,6.41781-13.3332,10.4515-20.511,6.22031-4.74301-2.60335-7.96751-7.77589-8.12305-13.1954,2.14039,0.16506,0.89799,4.47479,2.60736,6.06324,3.34776,7.34735,13.4726,10.3682,20.0217,5.34536,3.58161-2.45008,6.20248-6.03662,8.252-9.8099,0.30976,0.0572,0.63915,0.12986,0.94761,0.18596zm-0.9478-0.18641zm27.229,3.2027c-0.51158-0.28961-1.64251,2.90211-3.68846,4.219-4.35725,4.22474-10.7264,9.59-17.1234,6.58686-4.65967-2.81898-5.84285-8.70313-6.4746-13.7112,2.19962-0.0282,0.99442,4.31765,2.23232,6.0091,1.02326,4.61216,5.46691,9.11091,10.4901,7.2379,5.63925-1.82898,9.86418-6.32847,13.6737-10.6627,0.28963,0.10251,0.60132,0.21884,0.89039,0.321zm-0.8905-0.32112zm18.774,4.7168c1.60676,1.56163-2.43073,3.74637-3.43954,5.31196-3.05784,3.26303-9.19855,6.30987-12.5548,1.79695-2.38869-3.29927-2.75905-7.5404-2.90203-11.4853,2.23841,0.24724,0.59693,4.65726,1.78659,6.54217,0.48279,3.71764,4.00989,7.78983,8.01076,5.766,3.77153-1.58309,6.58208-4.82473,9.09901-7.9318zm4.2042-10.805c0.70765-2.33588,0.5336,3.82891-0.20641,5.02472-0.74717,2.03623-1.76648,5.65421-3.569,6.11975-0.33663-1.58141,2.34622-3.86732,2.48751-6.03075,0.86539-1.03182,0.32423-6.14787,1.2879-5.11372zm0-1.0198zm-0.002,0zm0,1.0198z'/%3E %3Cpath fill='%23edb92e' d='m482.14,262.87c-33.9831-0.007-67.9688,1.70838-101.771,5.21779-7.82824-0.16357-1.90797-8.28401,3.26332-6.28889,66.8828-6.63062,134.465-6.58824,201.306,0.49558,7.55519,3.0911-1.5647,8.07021-5.92354,5.29755-32.186-3.177-64.531-4.729-96.874-4.723z'/%3E %3Cpath fill='%230c4076' d='m482.14,105.07c9.4827,0,17.169,7.7439,17.169,17.298,0,9.5527-7.6862,17.298-17.169,17.298-9.4815,0-17.168-7.7439-17.168-17.298,0-9.5538,7.6862-17.298,17.168-17.298z'/%3E %3Cpath fill='%23edb92e' d='m485.26,84.894c1.6783-0.0457,3.026-1.4312,3.026-3.1329,0-1.7042-1.3501-3.0908-3.0308-3.1341-0.009-1.7234-1.3978-3.1173-3.1108-3.1173-1.7118,0-3.1012,1.3951-3.1108,3.1185-1.6795,0.0433-3.0308,1.4287-3.0308,3.1329,0,1.7017,1.3489,3.0872,3.0272,3.1329v6.4246h-5.491c-0.009-1.7222-1.399-3.1161-3.1108-3.1161-1.6903,0-3.0678,1.3614-3.1108,3.0547-1.7094,0.0084-3.0941,1.4083-3.0941,3.1329,0,1.7258,1.3847,3.1257,3.0953,3.1341,0.0429,1.6933,1.4181,3.0547,3.1096,3.0547,1.6664,0,3.0284-1.3229,3.1072-2.9826h5.4934v21.372h6.2311v-21.372h5.4934c0.0787,1.6597,1.4408,2.9826,3.1072,2.9826,1.6915,0,3.0678-1.3614,3.1096-3.0547,1.7106-0.0081,3.0953-1.4083,3.0953-3.1341,0-1.7246-1.3847-3.1245-3.0941-3.1329-0.0429-1.6933-1.4205-3.0547-3.1108-3.0547-1.7118,0-3.1,1.3939-3.1108,3.1161h-5.4898v-6.425z'/%3E %3Cpath fill='%2321231e' d='m487.78,81.761c0.7837-0.16044,1.26563,0.07068,0.9022,0.89596-0.36456,1.53642-1.82464,2.72958-3.40929,2.74556-0.057-0.611939-0.15181-1.17534,0.60993-1.1148,1.10578-0.301495,1.91536-1.38304,1.89716-2.52672zm-3.0308-3.1317c0.94669,0.142646,0.96875-0.121972,0.63462-0.505077,1.86638,0.0622,3.45234,1.7768,3.40875,3.63665-0.62011,0.04608-1.17173,0.114767-1.0901-0.64583-0.26241-1.10836-1.31638-1.96858-2.45928-1.97958-0.16476-0.168414-0.32874-0.33922-0.49399-0.50616zm0.49299,0.50632zm-3.0976-3.1161c-0.15909-0.783964,0.0692-1.27979,0.89887-0.90556,1.56416,0.378377,2.73567,1.90441,2.71793,3.51051-0.62448,0.05264-1.17312,0.115346-1.0972-0.64824-0.27748-1.12544-1.35782-1.97534-2.5196-1.95671zm-3.0976,3.1173c0.12042-0.948408-0.14006-0.974066-0.5156-0.626595,0.0207-1.88802,1.72006-3.55425,3.61309-3.51044,0.0464,0.624875,0.11389,1.17794-0.65056,1.10266-1.12525,0.273241-1.96806,1.37202-1.95393,2.52794-0.16431,0.16882-0.3288,0.337559-0.493,0.50643zm0.49299-0.50632zm-3.0308,3.1305c-0.78465,0.161986-1.26782-0.07359-0.8998-0.89838,0.36214-1.53828,1.82736-2.72821,3.41157-2.74311,0.0566,0.611558,0.15234,1.1762-0.60994,1.11361-1.10807,0.299629-1.91986,1.383-1.90183,2.52788zm3.0272,3.1329c-0.94799-0.146838-0.96823,0.117145-0.63463,0.502677-1.86421-0.06475-3.44748-1.77758-3.40496-3.63548,0.61924-0.04556,1.17156-0.115451,1.09,0.64462,0.26095,1.10785,1.31461,1.96545,2.45536,1.97954,0.16487,0.169199,0.32874,0.341051,0.49423,0.50864zm-0.493-0.50872zm-0.51926,6.9333v-6.4246c0.97884-0.256192,1.16489,0.280405,1.0122,1.15574v5.26886c-0.49465,0.584918-0.51113,0.593664-1.0122,0zm1.0122,0zm-5.9971-0.50992h5.491c0.2532,0.978382-0.27444,1.17592-1.15574,1.0198h-4.33526c-0.58405-0.495349-0.58531-0.515742,0-1.0198zm0,1.0198zm-3.1108-3.1161c-0.1592-0.784278,0.0694-1.27929,0.89886-0.90555,1.56364,0.379439,2.73513,1.90307,2.71793,3.50933-0.62169,0.0511-1.17449,0.117609-1.096-0.64583-0.27902-1.12697-1.35618-1.9759-2.52079-1.95795zm-3.1084,3.0547c0.13909-0.945162-0.11803-0.979858-0.50187-0.638544,0.0575-1.86092,1.74409-3.47743,3.60955-3.43597,0.0411,0.615795,0.1215,1.17909-0.63983,1.09906-1.11138,0.268071-1.95515,1.33656-1.96564,2.47866-0.16721,0.165544-0.33599,0.331495-0.50221,0.49679zm0.50255-0.4967zm-3.0929,3.1197c-0.7906,0.164948-1.26656-0.07936-0.8985-0.90559,0.37152-1.56023,1.87604-2.75524,3.48427-2.73718,0.048,0.621654,0.12201,1.17986-0.64318,1.10518-1.12895,0.281464-1.95963,1.37925-1.94259,2.53759zm3.0941,3.1209c-0.94977-0.123293-0.96313,0.143905-0.62286,0.519376-1.8946-0.02318-3.52935-1.7531-3.48356-3.6402,0.62877-0.05113,1.16988-0.107573,1.0936,0.65544,0.26665,1.12322,1.35153,1.9838,2.5092,1.9691,0.16795,0.165007,0.33525,0.333295,0.50362,0.49628zm-0.50256-0.49669zm3.1072,3.0547c0.15625,0.77861-0.0637,1.28014-0.89168,0.9064-1.54161-0.37051-2.70955-1.85496-2.72223-3.43818,0.61539-0.06206,1.16954-0.145841,1.1051,0.61574,0.29471,1.10535,1.3627,1.93396,2.50881,1.91604zm3.1072-2.9826c-0.1444,0.937675,0.11335,0.983985,0.49733,0.649243-0.10199,1.82837-1.76834,3.3931-3.60434,3.35319-0.0373-0.60859-0.12676-1.18124,0.63266-1.09638,1.09284-0.262224,1.93395-1.29665,1.96944-2.41973,0.1682-0.162147,0.33731-0.323942,0.50491-0.48632zm-0.50493,0.48586zm5.9983,0.53398h-5.4934c-0.2532-0.978382,0.27444-1.17592,1.15574-1.0198h4.33766c0.58018,0.496093,0.58837,0.517498,0,1.0198zm0-1.0198zm-0.50613,21.882v-21.372c0.97884-0.256192,1.16489,0.280405,1.0122,1.15574v20.2163c-0.49465,0.5849-0.51114,0.59368-1.0122,0zm0.50613,0.50992zm6.2311,0h-6.2311c-0.2532-0.97838,0.27444-1.17592,1.15574-1.0198h5.07536c0.58015,0.49611,0.58841,0.51743,0,1.0198zm0.50613-0.50992zm0-21.372v21.372c-0.97884,0.25619-1.16489-0.28041-1.0122-1.15574v-20.2163c0.49465-0.584928,0.51113-0.593674,1.0122,0zm-1.0122,0zm5.9995,0.50993h-5.4934c-0.2532-0.978382,0.27444-1.17592,1.15574-1.0198h4.33766c0.61835,0.487793,0.5559,0.501114,0,1.0198zm0-1.0198zm3.1072,2.9826c0.15008,0.76847-0.0521,1.2802-0.87857,0.9113-1.51829-0.36347-2.6837-1.80117-2.73348-3.36023,0.6053-0.06892,1.16477-0.17869,1.1171,0.57962,0.30795,1.0835,1.36621,1.88568,2.49495,1.86931zm3.1072-3.0547c-0.13912,0.945169,0.11808,0.979856,0.50183,0.638532-0.0561,1.86123-1.74247,3.47778-3.60811,3.43622-0.0415-0.61709-0.12087-1.17873,0.64102-1.09812,1.11124-0.268671,1.95323-1.33677,1.96299-2.47871,0.16702-0.166085,0.33719-0.331264,0.50227-0.49792zm-0.50255,0.49669zm3.0941-3.1209c0.7902-0.164836,1.26715,0.07919,0.8986,0.90559-0.37074,1.56126-1.87663,2.75658-3.48547,2.73837-0.0481-0.621389-0.12176-1.18018,0.64318-1.10556,1.12929-0.280684,1.96194-1.38008,1.94369-2.5384zm-3.0929-3.1197c0.94976,0.123278,0.96313-0.143824,0.62287-0.519394,1.89385,0.02362,3.52751,1.75279,3.48256,3.63904-0.62841,0.05103-1.17033,0.107695-1.0935-0.65544-0.26712-1.12206-1.35102-1.983-2.50801-1.9675-0.16811-0.165235-0.33515-0.333059-0.50392-0.49671zm0.50255,0.49669zm-3.1084-3.0547c-0.15563-0.777035,0.0626-1.2813,0.89049-0.90677,1.54197,0.37019,2.71156,1.85469,2.72482,3.43835-0.61464,0.06147-1.16922,0.146536-1.1051-0.61456-0.29518-1.10572-1.36093-1.93435-2.51021-1.91702zm-3.1108,3.1161c0.14266-0.954848-0.11272-0.975006-0.50238-0.628993,0.0227-1.88704,1.72124-3.55084,3.61337-3.50689,0.0464,0.624866,0.11389,1.17795-0.65056,1.10265-1.12497,0.2722-1.96838,1.37138-1.95434,2.52674-0.16864,0.168848-0.33771,0.337562-0.50609,0.50649zm0.50612-0.50632zm-5.9959-0.51353h5.4898c0.2532,0.978382-0.27444,1.17592-1.15574,1.0198h-4.33406c-0.58016-0.496109-0.58839-0.517424,0-1.0198zm0,1.0198zm0.50613-6.9345v6.4246c-0.97884,0.256192-1.16489-0.280405-1.0122-1.15574v-5.26886c0.49033-0.605226,0.50188-0.57543,1.0122,0zm-1.0122,0zm0.50613,0zm-0.50613,0z'/%3E %3Cpath fill='%2321231e' d='m499.82,122.37c-0.69799,0.0953-1.26389,0.0552-1.03216-0.80265-0.22012-5.9866-3.92922-11.6752-9.3245-14.2818-2.26582-1.12113-4.79136-1.70106-7.31839-1.70339-0.0929-0.70294-0.0585-1.2752,0.80262-0.99859,6.27187,0.21967,12.2044,4.12271,14.9662,9.745,1.2599,2.48109,1.89891,5.26157,1.90625,8.04138zm-17.675,17.808c-0.0929-0.69814-0.0585-1.27217,0.80264-1.04009,5.94126-0.22531,11.546-3.95665,14.1223-9.30217,1.14747-2.30975,1.73451-4.88799,1.73794-7.46535,0.70284-0.0953,1.2667-0.0552,0.99133,0.80263-0.2145,6.31771-4.09317,12.3356-9.76365,15.1316-2.43547,1.2353-5.16184,1.86656-7.89053,1.87335zm-17.674-17.808c0.69799-0.0953,1.26389-0.0552,1.03216,0.80265,0.22011,5.98653,3.92925,11.6754,9.32449,14.2818,2.26539,1.1212,4.79059,1.70082,7.3172,1.7034,0.0929,0.70294,0.0585,1.2752-0.80262,0.99859-6.27155-0.22-12.2034-4.12305-14.965-9.74499-1.25988-2.48111-1.89892-5.26156-1.90623-8.04141zm17.674-17.808c0.0929,0.69814,0.0585,1.27217-0.80264,1.04009-5.94128,0.22551-11.5449,3.95672-14.1214,9.30198-1.14737,2.30979-1.73419,4.88818-1.73758,7.46552-0.70284,0.0953-1.2667,0.0552-0.99133-0.80263,0.21505-6.31699,4.09124-12.3381,9.76368-15.1316,2.43504-1.23535,5.16098-1.86632,7.8893-1.87334z'/%3E %3Cpath fill='%23edb92e' d='m498.96,118.85c0.23158,1.1353,0.35454,2.3103,0.35454,3.5141,0,0.83103-0.0598,1.6488-0.1731,2.4498-5.6438-0.19723-11.302-0.33072-16.995-0.33072-5.6927,0-11.351,0.13349-16.996,0.33072-0.11341-0.80096-0.17309-1.6188-0.17309-2.4498,0-1.2038,0.12294-2.3788,0.35572-3.5141,5.5841-0.19122,11.183-0.32352,16.813-0.32352,5.6307,0,11.229,0.13229,16.813,0.32352z'/%3E %3Cpath fill='%2321231e' d='m499.82,122.37c-0.30016-0.11009-1.05994,0.2422-1.0132-0.21647-0.012-1.07272-0.12562-2.1443-0.3404-3.19544,0.3157,0.0479,0.99981-0.45709,1.03377,0.0144,0.21552,1.11861,0.32033,2.25957,0.31983,3.39747zm-0.69711,2.9585c-0.0724-0.25491,0.24475-1.31059-0.1847-0.83167-0.39168,0.47095-0.26548-0.004-0.22795-0.33256,0.0594-0.59642,0.0994-1.19536,0.094-1.795,0.28975,0.0998,0.9868-0.2046,1.0112,0.1588-0.005,0.79061-0.0671,1.58084-0.1743,2.364-0.17275,0.14538-0.34548,0.29151-0.51825,0.43643zm0.51806-0.43656c0.25818,0.58161-0.90359,0.56404-0.2426,0.20444,0.0809-0.0682,0.16174-0.13629,0.2426-0.20444zm-17.495,0.10704c0.10952-0.32649-0.26762-1.13963,0.28822-1.0198,5.57628,0.003,11.1517,0.13392,16.7243,0.3298-0.12101,0.32181,0.22776,1.14717-0.32375,1.00752-5.56069-0.19529-11.1249-0.31587-16.6888-0.31752zm-17.496-0.10704c0.23517-0.1171,1.32876,0.0112,0.7799-0.33004-0.66416-0.39181,0.28148-0.22674,0.5924-0.28124,5.37257-0.18235,10.7478-0.3,16.1237-0.2991-0.10952,0.32649,0.26762,1.13963-0.28822,1.0198-5.56468,0.005-11.1287,0.13001-16.6897,0.3272-0.17266-0.14555-0.3455-0.29103-0.51805-0.43662zm0.51806,0.43656c-0.52863,0.35657-0.70757-0.79582-0.24251-0.20444,0.0808,0.0682,0.16189,0.1363,0.24251,0.20444zm-0.697-2.958c0.29086,0.0979,0.9733-0.19896,1.0132,0.1516,0.00058,0.74494,0.067,1.4886,0.1627,2.2269-0.29951-0.0569-0.94304,0.34042-1.0212-0.01-0.1002-0.78519-0.15576-1.57744-0.1547-2.36882zm0.84513-4.0229c0.0944,0.25471-0.16695,1.31112,0.25346,0.83115,0.43002-0.49592,0.13517,0.23189,0.12471,0.50856-0.13999,0.88698-0.21006,1.78514-0.2098,2.68311-0.30327-0.11123-1.08197,0.25027-1.0112-0.23331,0.0188-1.13611,0.1345-2.2712,0.3649-3.38427,0.15887-0.13489,0.32125-0.27123,0.47793-0.40524zm-0.47867,0.40529c-0.0561-0.61333,0.8337-0.4371,0.0937-0.0794l-0.055,0.0466-0.0387,0.0328-0.00002,0.00007zm17.309-0.73001c-0.10952,0.32649,0.26762,1.13963-0.28822,1.0198-5.50414,0.006-11.0076,0.12846-16.5083,0.3192,0.0989-0.32935-0.30517-1.12878,0.25455-1.02735,5.51183-0.18637,11.0276-0.31402,16.5419-0.31165zm17.309,0.73121c-0.23255,0.1366-1.31671,0.0555-0.77108,0.39103,0.60716,0.38732-0.42201,0.14068-0.69717,0.18785-5.27821-0.17646-10.559-0.2857-15.8404-0.28723,0.10952-0.32649-0.26762-1.13963,0.28822-1.0198,5.51534,0.004,11.0298,0.13282,16.5417,0.3221,0.15944,0.13509,0.31982,0.27225,0.47868,0.40605zm-0.47868-0.40649c0.59538-0.15831,0.56814,0.75232,0.0942,0.08l-0.0549-0.0466-0.0393-0.0334-0.00001,0.00003z'/%3E %3Cpath fill='%23edb92e' d='m468.82,133.18c-3.6348-2.2574-4.2698,1.2363-4.1779,4.7493,0.34618,13.234,2.8649,25.827-0.67444,42.031-1.4157,6.4847-3.6969,10.132-1.4742,11.382,5.67,3.187,8.2687,6.1022,7.3687,7.6705,1.676,3.2183,5.8563,2.5965,12.278,1.5646,6.4221,1.0319,10.604,1.6536,12.281-1.5646-0.90125-1.5683,1.6986-4.4835,7.3675-7.6705,2.2238-1.2496-0.0573-4.8972-1.4742-11.382-3.5381-16.205-1.0194-28.797-0.67445-42.031,0.0919-3.5129-0.54194-7.0066-4.1767-4.7493-7.1562,4.445-19.404,4.4955-26.643,0z'/%3E %3Cpath fill='%2321231e' d='m465.15,137.91c-1.13492,0.39435-1.10489-0.45711-1.0059-1.31084,0.0741-1.72415,0.3321-4.27811,2.42455-4.63622,0.90579-0.0879,1.76607,0.31743,2.51989,0.77692-0.31968,1.37213-1.14114,0.3878-2.02702,0.24591-1.57427-0.12729-1.75392,1.89596-1.87295,3.04179-0.0473,0.62629-0.0522,1.2548-0.0386,1.88244zm-0.68518,42.154c-1.49056,0.14927-0.72608-1.14459-0.61519-2.03882,2.10769-10.3489,1.55599-20.9734,0.74386-31.4296-0.19569-2.88366-0.37622-5.76922-0.4525-8.6589,1.42763-0.51187,0.96307,0.96944,1.07474,1.86102,0.53321,11.1562,1.9787,22.3804,0.41763,33.5213-0.28791,2.26452-0.68891,4.51405-1.16854,6.74505zm-1.7225,10.828c-0.24418,1.40216-1.28074,0.5448-1.5363-0.35237-0.4797-2.41277,0.7936-4.72699,1.32894-7.03154,0.35009-1.21112,0.674-2.43034,0.94207-3.66242,1.4748-0.1483,0.7406,1.11274,0.56702,1.98677-0.57116,2.69693-1.88817,5.2662-1.95201,8.04692,0.0398,0.42209,0.26201,0.81769,0.65028,1.01264zm7.5704,7.8786c-1.231,0.98022-0.69309-0.14898-0.89308-0.98728-1.3885-2.62471-4.14433-4.13428-6.57813-5.66227-1.22736-0.39213,0.16316-1.82665,0.85206-0.67925,2.50362,1.59179,5.31919,3.21134,6.66951,5.97232,0.42825,0.39574-0.0547,2.48146-0.0524,1.35794l0.00002-0.001,0.002-0.00011zm-0.89528,0.47385zm12.806,0.82501c0.15434,1.33728-0.52616,1.05384-1.66398,1.26951-3.06792,0.36834-6.4309,1.22195-9.34575-0.21141-0.77385-0.42499-1.39203-1.10269-1.79624-1.88338,0.96526-1.01893,1.19535,0.27865,1.9505,0.77812,2.41126,1.46815,5.38593,0.73772,8.0211,0.46119,0.94624-0.12091,1.8887-0.32408,2.83437-0.41403zm-0.15995,0zm11.923-0.80697c1.11314-1.06205,1.03627,0.22511,0.30156,0.86126-2.01817,2.29356-5.41733,1.84354-8.13508,1.55829-1.36808-0.16802-2.72863-0.39057-4.08966-0.60701-0.23186-1.43768,1.01579-0.8303,1.90275-0.7301,2.83865,0.32523,5.93404,1.15437,8.64506-0.12199,0.66223-0.0395,1.44916-2.01211,1.37428-0.9598l0.001-0.00065zm0.87617-0.50993zm6.6835-7.8605c1.05382,0.97535-0.26305,1.2773-1.00509,1.76909-2.14025,1.42973-4.62336,2.84185-5.72381,5.27844,0.35122,0.74069-0.92909,1.90267-1.04158,0.73193-0.12417-2.19348,1.92805-3.68489,3.43095-4.96056,1.36651-1.05589,2.83668-1.97197,4.33953-2.8189zm-1.7225-10.828c1.25686-0.74767,1.13395,0.66286,1.40021,1.51294,0.59706,2.81863,2.00978,5.50848,1.97749,8.42816,0.016,0.64513-0.95328,2.32826-1.39999,1.3469-0.57038-0.64574,0.79586-1.16624,0.40587-2.05358-0.46751-3.14524-1.79308-6.1065-2.38358-9.23442zm-0.68517-42.154c1.45659-0.43718,0.91058,1.02714,0.94531,1.92363-0.51843,11.0491-1.96313,22.1616-0.44623,33.1977,0.28854,2.28752,0.68857,4.56018,1.17538,6.81363-1.30055,0.76997-1.13178-0.75155-1.36418-1.62023-2.12616-10.4371-1.58231-21.153-0.76265-31.6992,0.19683-2.86901,0.37555-5.74114,0.45237-8.61557zm-3.4068-4.3019c-0.98595-0.83683-0.0366-1.26962,0.81291-1.50932,1.61678-0.68258,3.1457,0.75905,3.33512,2.32222,0.26503,1.15057,0.29609,2.33957,0.2692,3.51535-1.44837,0.43519-0.9023-1.01329-1.0486-1.90866-0.12606-1.14-0.27977-3.12038-1.83262-3.04839-0.55515,0.0743-1.06387,0.34429-1.53601,0.6288zm-27.173,0c0.34904-1.48258,1.34021-0.27401,2.19942,0.0405,6.28023,2.87072,13.6596,3.05873,20.2142,1.02284,1.47551-0.48427,2.90628-1.11632,4.22966-1.9316,1.06356,0.9042-0.12844,1.26861-0.90841,1.67168-6.56178,3.12782-14.3442,3.37712-21.2439,1.24644-1.56848-0.51089-3.085-1.18501-4.49102-2.04984z'/%3E %3C/g%3E %3Cg id='g3987'%3E %3Cpath d='m363.03,212.12c-1.8968-4.1431-0.36646-9.9267,0.25306-11.235,0.31394-0.66267-0.61595-2.1179-1.0194-2.6879-12.907-18.281-13.128-19.903-4.2305-26.753,8.0288-6.1804,26.161-12.19,39.133-16.235,2.7013-2.0625,4.4203-4.8671,6.8757-7.1762-24.928,1.7932-51.946,11.919-65.572,23.754-7.2004,6.2538,1.5554,18.889,12.28,38.106,6.631,4.7842,9.7418,7.0102,12.28,2.2273h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m362.83,200.67c1.42356,0.15756,0.52025,1.20436,0.37718,2.06975-0.70703,2.98973-0.96545,6.28561,0.28622,9.1714-1.1655,1.08438-1.29206-0.62648-1.55226-1.47223-0.67614-3.22372-0.28088-6.70903,0.88886-9.76892zm-0.97525-2.1732c0.70327-0.97529,1.15582-0.30292,1.49075,0.4833,0.32245,0.64097,0.69801,1.4101,0.3959,2.1275-0.66451-0.17858-1.01351-0.44623-1.04137-1.12077-0.21462-0.53043-0.52197-1.02367-0.84528-1.49003zm-4.1254-27.454c1.39475,0.99442-0.63226,1.5257-1.23665,2.27869-2.20407,1.75225-4.72794,4.22169-3.98144,7.32816,1.16243,4.64361,4.24326,8.48251,6.79954,12.4352,1.10994,1.61543,2.23755,3.21862,3.36696,4.82047-1.05118,1.37902-1.51846-0.72115-2.22185-1.39503-3.13688-4.6999-6.7813-9.22107-8.68013-14.6042-1.05887-2.78929,0.0851-5.89819,2.28684-7.77894,1.14088-1.12044,2.40535-2.10506,3.66673-3.08435zm39.134-16.236c1.49486,1.18373-0.90984,1.141-1.7053,1.57016-11.095,3.59176-22.3191,7.13826-32.5998,12.7354-1.45801,0.82839-2.88099,1.72344-4.21543,2.74078-1.3627-0.95927,0.51206-1.47439,1.19767-2.0926,8.34889-5.23365,17.7559-8.43325,27.0105-11.6573,3.47549-1.16871,6.96825-2.28528,10.4686-3.37703l-0.15637,0.0806,0.0002-0.00005zm0.61116,0.81299zm6.6059-7.074c-0.28058-2.02239,0.76279,0.33335-0.56111,0.73125-2.00817,2.11887-3.69971,4.56319-6.04488,6.34278-1.29837-0.89917,0.35048-1.40197,0.91329-2.14217,1.87535-1.84134,3.39174-4.01461,5.31183-5.81336,0.12697,0.29381,0.25383,0.58789,0.38087,0.8815zm-0.0717-1.0174c2.15314-0.95468,0.72445,1.46557,0.14867,0.34418l-0.0774-0.17913-0.0713-0.16505zm-65.206,24.648c-1.48319-0.94729,0.65089-1.62413,1.28245-2.3688,10.3237-7.9504,22.541-13.0547,34.926-16.8412,9.4408-2.81216,19.1685-4.70981,28.9973-5.43829,0.62827,1.65229-1.50406,0.92587-2.45502,1.22836-16.8376,1.68551-33.427,6.37331-48.5195,14.0549-5.03877,2.63385-9.91383,5.64711-14.2312,9.36501zm12.244,37.306c-0.68468,1.76551-1.21177-0.41899-1.73445-1.11723-4.35334-7.95055-9.3681-15.6093-12.6266-24.1044-1.39982-3.78852-2.34836-8.65096,0.59198-11.9784,0.57356-1.52973,2.24856-0.12289,0.8083,0.61154-2.76449,3.11772-1.68286,7.64838-0.39609,11.1688,3.30928,8.49618,8.33567,16.1681,12.694,24.1403,0.0487,0.15342,1.08434,1.80514,0.66286,1.27929zm-0.5897,0.82742zm12.574,1.3037c0.024,1.32186,0.66803,0.75402-0.45426,2.13529-1.34413,1.98531-4.08001,1.80097-5.92365,0.67096-2.19807-1.15762-4.17624-2.67559-6.19647-4.10946,0.5393-1.63338,1.64041,0.16,2.52037,0.55775,2.1717,1.37773,4.32157,3.41814,7.03874,3.38062,1.5537-0.13946,1.96382-1.87755,3.01527-2.63516zm-0.44643,0.26939zm0.44764,0.75045zm0.45957-0.7228z'/%3E %3Cpath d='m359.11,213.58c-0.56223-1.6452-0.96689-3.2315-1.245-4.7192-0.54312-2.7096-0.31036-5.5166,0.59089-8.1516-2.9747-4.2093-6.3123-8.783-8.7211-13.328-1.7201-3.2448-3.0487-6.8575-2.0376-10.558,1.0791-3.9471,4.4943-6.6362,7.58-9.0115,3.6957-2.8455,8.6244-5.3374,13.613-7.466,11.172-4.6338,20.054-6.902,26.563-7.1077l-4.1314,3.8353c-12.112,3.917-26.406,9.0836-33.283,14.379-8.8978,6.8503-8.677,8.4715,4.2305,26.753,0.40227,0.57005,1.3334,2.0253,1.0194,2.6879-0.61954,1.3085-1.7619,7.341,0.13608,11.483-1.1149,2.101-2.73,1.003-4.3164,1.2038h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m357.37,208.96c1.2023-0.69963,1.12019,0.49762,1.32007,1.34677,0.24836,1.04899,0.54912,2.08555,0.8988,3.10523-0.76918,0.50853-1.16351,0.2382-1.26044-0.60011-0.39409-1.26052-0.7216-2.57907-0.95843-3.85189zm0.99077-0.20204zm-0.31634-7.7547c1.07875-1.17627,0.92008,0.1568,0.55133,0.9891-0.5813,2.19952-0.68318,4.53204-0.23487,6.76558-1.18468,0.67074-1.15285-0.50747-1.22367-1.38305-0.2147-2.30362,0.0908-4.64736,0.8412-6.83345,0.022,0.15393,0.0436,0.30834,0.066,0.46182zm0.82366-0.59171zm-9.5794-12.791c0.87844-0.90594,1.20031,0.0102,1.58643,0.78533,2.37674,4.18619,5.21998,8.07918,7.99299,12.0061-0.76071,1.02097-1.20066,0.13008-1.66879-0.60132-2.79759-3.95397-5.6275-7.90822-7.91063-12.1901zm-2.0782-10.933c1.19103-0.0396,0.89352,0.75122,0.71496,1.58149-0.38383,3.12158,0.81923,6.16426,2.25582,8.87076-0.86221,0.88672-1.20217,0.0339-1.52554-0.77211-1.44023-2.97236-2.36859-6.40777-1.44524-9.68014zm7.7602-9.282c1.04219,0.73396,0.1623,1.2091-0.5491,1.71257-2.62612,2.07397-5.31561,4.49701-6.23705,7.83888-1.34898,0.0592-0.81101-0.96892-0.44048-1.76549,1.48584-3.31153,4.42601-5.62575,7.22663-7.78596zm13.728-7.5322c0.86212,1.00293-0.16382,1.20712-0.97566,1.53465-4.24032,1.8885-8.42973,3.99034-12.138,6.80855-1.20061-0.83657,0.13148-1.337,0.84993-1.87494,3.8184-2.62363,8.01992-4.64186,12.2638-6.46826zm-0.005,0.002zm27.103-6.2634c-1.32888-1.56835,0.38817,0.51823-1.09294,0.16827-8.90508,0.63181-17.4107,3.71142-25.6208,7.03566-0.93202-1.10118,0.43228-1.24443,1.24723-1.60797,8.04752-3.15859,16.3998-6.06219,25.1084-6.47978,0.11936,0.29455,0.23884,0.58968,0.35812,0.88382zm-0.35812-0.88394c1.5886-0.4526,1.23185,0.53836,0.29854,0.73698-0.0995-0.24565-0.19913-0.49141-0.29854-0.73698zm-4.4584,3.9688c1.37713-1.2784,2.75427-2.5568,4.1314-3.8352,1.30947,0.7455-0.0897,1.3791-0.70925,2.04492-0.98514,0.86997-1.89227,1.84536-2.92557,2.65024-0.16551-0.28666-0.33114-0.57328-0.49658-0.85996zm0.68518,0.75045zm-33.318,14.409c-1.16761-0.81385,0.0644-1.29942,0.78427-1.8184,7.12743-4.63247,15.1817-7.56198,23.1289-10.45,2.95523-1.04203,5.92686-2.03714,8.90863-3.00047,0.86,1.19955-0.59485,1.20791-1.43331,1.5379-9.45346,3.17549-18.9894,6.39075-27.7122,11.298-1.26795,0.74422-2.50888,1.53904-3.67633,2.43295zm4.3355,26.053c-0.86038,1.19922-1.28983-0.13273-1.82828-0.83539-3.13738-4.63737-6.64997-9.1252-8.79676-14.3368-1.05651-2.43423-0.88904-5.45191,0.96363-7.46369,1.34883-1.63675,3.05246-2.92691,4.71285-4.22796,1.20226,0.83586-0.14084,1.3296-0.80867,1.92874-2.14845,1.75876-4.83828,3.94108-4.49715,7.04186,0.56256,3.79833,2.95381,6.98065,4.92826,10.1686,1.72495,2.60911,3.52573,5.16774,5.32612,7.72468zm1.0636,3.2014c-0.56401-0.21279-1.03822-0.37412-1.01019-1.03526-0.21232-0.56538-0.53662-1.08054-0.8774-1.5762,0.65569-0.8454,1.12171-0.43367,1.43715,0.38461,0.3408,0.66701,0.76607,1.47382,0.45044,2.22685zm0.12653,11.505c-1.11933-0.67925-0.96005,0.251-1.38585-1.30006-0.94363-3.46102-0.80777-7.25066,0.34752-10.6422,1.21691,0.1593,0.71641,0.97351,0.50498,1.79796-0.68562,3.24798-0.67101,6.74308,0.54164,9.84824l-0.005,0.15849-0.004,0.13762,0.00024-0.00001zm0.0131-0.45459zm-4.776,0.908c0.26019,1.86013-0.57906-0.0795,0.4378-0.026,1.19079,0.0553,2.86135,0.5552,3.43228-0.90926,1.14187,0.21124,0.81018,0.97549,0.0919,1.50812-1.10419,0.96509-2.60756,0.34063-3.8986,0.44289-0.0212-0.33857-0.0422-0.67715-0.0634-1.01571zm0.001,1.0198c-0.42824-1.41674,0.94189-0.86456,0,0.00004v-0.00004zm0.47867-0.67589z'/%3E %3Cpath d='m468.14,132.2c0.11221-2.3151-0.0442-1.9242-0.39034,1.6476-0.37242-0.71558-0.86185-1.0439-1.4539-1.0319-1.0469,0.0193-1.6783,1.6152-1.781,5.2195,0.0621,0.92964,0.12534,1.8485,0.1874,2.7601-33.058-0.73482-52.66,4.2838-57.715,13.922-4.16,7.9303,2.9126,21.062,13.584,36.055,1.2904,1.8136,1.2486,1.6597,0.001,3.1546-1.8049,2.1624-3.7494,5.8232-2.2883,9.0391-6.4662,3.5671-14.161,4.433-20.874,1.4853-1.1137-2.9609-3.5321-4.3704-5.4874-5.7126-0.39749-0.27421-1.8359-0.98016-1.9792-1.4408-3.5274-11.349-7.0679-21.843-10.107-31.615-9.5364-30.687,75.242-33.501,88.304-33.483z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m467.31,134.09c1.78922-0.69149-0.88161,0.0861,0.0912-1.71891,0.11624-0.70232-0.008-2.45417,1.09065-1.92664,0.61594,0.77038-0.0119,2.57428-0.83988,1.52908-0.17738-1.41058,0.15052-0.73252,0.95353-0.99088-0.30201,0.92883,0.003,2.34017-0.57547,2.96563-0.23997,0.0471-0.48008,0.0951-0.71999,0.14172zm0.95137-0.18761c0.62386,2.81545-1.74498,0.41371-0.25607,0.0505l0.23176-0.0457,0.0243-0.005v0.00001zm-1.9481-0.57127c-0.33159-0.92098,0.163-1.28221,0.9003-0.8023,0.53025,0.30634,1.50929,1.23464,0.36564,1.41762-0.43274,0.36162-0.61766-0.78747-1.26594-0.61532zm0.001,0zm-1.2868,4.6759c-1.59652,0.63722-0.83712-1.19048-0.86956-2.0725,0.19329-1.36235,0.44029-3.43642,2.13625-3.6227,0.34854,0.91201-0.30936,1.02823-0.6552,1.68545-0.50861,1.23034-0.55567,2.8571-0.61149,4.00975zm-1.0099,0.0673zm0.68161,3.2351c0.38211-1.77344-0.7502,0.25215-0.55308-1.32871,0.11783-0.71544-0.64162-2.19889,0.57712-1.95302,0.64412,0.0236,0.23469,1.25249,0.42678,1.79432,0.0483,0.62931,0.1998,1.07886-0.45082,1.48741zm0.51566-0.54361zm-57.772,14.195c-1.86266-0.46323,0.378-2.12761,0.86845-3.02956,5.18364-5.62506,12.9448-7.71189,20.174-9.27169,11.9207-2.31708,24.1285-2.58551,36.2357-2.36731,0.41142,1.89623-2.20773,0.63942-3.31242,0.96537-13.4237-0.0294-27.1038,0.34789-40.0449,4.26795-5.32664,1.76686-11.0737,4.29553-13.9208,9.43524zm13.547,35.52c-1.22964,1.46994-1.76114-1.2884-2.62336-1.97242-5.11337-7.60866-10.47-15.4342-12.6328-24.4736-0.68217-3.1575-0.71402-6.62271,0.81401-9.55049,1.76843,0.39278-0.18674,2.01309-0.0326,3.18495-0.96835,6.39456,2.12764,12.4933,4.98499,18.0048,2.81555,5.14825,6.0987,10.024,9.48974,14.8067zm-0.0226,3.7799c-1.32461-0.5223-0.21852-1.06931,0.055-1.83515-0.33195-0.79846-1.36343-1.50712-0.0317-1.94443,0.82765,0.88602,1.57023,2.33956,0.39055,3.28672-0.13713,0.16493-0.2763,0.32936-0.41383,0.49286zm-2.4328,9.1582c-0.6025-1.16764-1.05894-0.0375-1.21971-2.13953-0.27472-2.83653,1.12935-5.53909,2.87813-7.6753,1.43804,0.5689,0.02,1.38617-0.35214,2.21288-1.26845,2.01708-2.12979,4.64715-1.08902,6.9429-0.0724,0.21968-0.14482,0.4394-0.21726,0.65905zm0.21725-0.65905zm-21.806,1.8773c1.03469-1.00344,1.51403-0.12119,3.17285,0.25857,5.97698,1.74862,12.544,0.62035,17.9317-2.3719,1.2997,1.44846-1.5994,1.64158-2.47586,2.30461-5.82807,2.37542-12.8178,2.76708-18.5201-0.0771l-0.10857-0.11469v0.0005zm0.27097,0.28623zm-5.571-5.7583c0.48791-1.61741,1.63056,0.0509,2.48986,0.48444,1.62997,1.1713,3.06161,2.71455,3.75556,4.62682-1.16154,0.96689-1.19164-0.5885-1.78935-1.26638-1.11252-1.65828-2.83339-2.74872-4.45607-3.84488zm-2.1761-1.709c0.74103-0.54134,1.13851-0.23993,1.72171,0.25433,0.78596,0.31685,1.37931,0.81649,0.42272,1.43475-0.73516-0.50465-1.74522-0.83607-2.14443-1.68908zm-10.107-31.615c1.54988-0.99531,1.2512,1.54937,1.82477,2.43551,3.04711,9.63598,6.25243,19.2214,9.24676,28.8742-1.62736,0.9971-1.28004-1.78915-1.90937-2.7125-3.00054-9.54952-6.18339-19.0408-9.16216-28.5972zm88.281-33.661c2.3149,0.15457-0.977,0.80657-1.86393,0.55722-18.4851,0.47121-37.046,2.06528-55.0758,6.31884-8.90951,2.29073-18.1093,5.02306-25.3401,10.948-3.71026,3.03372-6.31519,7.74526-5.64734,12.6401,0.11025,1.0209,1.21713,3.65707-0.40502,2.96632-1.49202-4.68998-0.48681-10.0683,2.82553-13.7496,5.03077-5.87525,12.4878-8.88952,19.6414-11.3272,16.135-5.13516,33.0891-7.02945,49.9148-8.22361,5.47898-0.3435,10.9664-0.59165,16.4568-0.61421-0.16875,0.16139-0.33781,0.32399-0.5063,0.48422zm1.0099,0.0505zm-0.50494-0.0253zm0.50494,0.0253z'/%3E %3Cpath d='m404.99,190.16c3.5166,0,6.3672,2.8719,6.3672,6.4149,0,3.5442-2.8506,6.4161-6.3672,6.4161s-6.3672-2.8719-6.3672-6.4161c0-3.5418,2.8505-6.4149,6.3672-6.4149z' fill='%23FFF'/%3E %3Cpath d='m411.87,196.57h-1.0122c0.0268-2.1992-1.2955-4.3408-3.2747-5.3-0.7998-0.39875-1.6926-0.6056-2.5861-0.60484v-1.0198c2.3326-0.0201,4.6106,1.2606,5.8244,3.2491,0.68656,1.0953,1.0469,2.3841,1.0487,3.6755zm-6.8733,6.9261v-1.0198c2.1697,0.0263,4.2691-1.2876,5.2254-3.2297,0.41942-0.82526,0.63601-1.751,0.63558-2.6764h1.0122c0.0201,2.3519-1.2532,4.6604-3.2586,5.8909-1.0772,0.67558-2.3441,1.0335-3.6146,1.035zm-6.8733-6.9261h1.0122c-0.0261,2.1859,1.2785,4.3173,3.24,5.2834,0.80828,0.41087,1.7145,0.62309,2.6208,0.62256v1.0198c-2.3327,0.0203-4.6104-1.2609-5.8244-3.2491-0.68595-1.0969-1.0479-2.3837-1.0487-3.6766zm6.8733-6.9248v1.0198c-2.1696-0.0263-4.2694,1.2871-5.2253,3.2295-0.42014,0.82468-0.63576,1.7502-0.63548,2.6751h-1.0123c-0.0199-2.3517,1.2544-4.6585,3.2586-5.8897,1.0772-0.67543,2.3438-1.0337,3.6144-1.0348z' fill='%2321231e'/%3E %3Cpath d='m350.75,203.61c3.2648,0,5.9124,2.6663,5.9124,5.9567,0,3.2905-2.6476,5.9567-5.9124,5.9567-3.266,0-5.9136-2.6675-5.9136-5.9567,0-3.2904,2.6476-5.9567,5.9136-5.9567z' fill='%23FFF'/%3E %3Cpath d='m357.17,209.56h-1.0123c0.0211-1.9413-1.0892-3.8374-2.7925-4.7689-0.79387-0.44551-1.704-0.67765-2.6137-0.67802v-1.0198c2.1783-0.0185,4.305,1.1779,5.439,3.0342,0.64073,1.0226,0.97738,2.227,0.97941,3.4326zm-6.4185,6.4667v-1.0198c1.9894,0.0233,3.9151-1.1732,4.8045-2.9476,0.39671-0.76908,0.6015-1.6344,0.60191-2.4993h1.0123c0.017,2.1835-1.1563,4.3288-3.0136,5.4802-1.0116,0.64519-2.207,0.98366-3.4051,0.9865zm-6.4197-6.4667h1.0122c-0.0235,2.0052,1.1667,3.9592,2.9594,4.8576,0.75367,0.38754,1.6007,0.58937,2.4479,0.58935v1.0198c-2.1785,0.0176-4.307-1.1773-5.4402-3.0354-0.64027-1.0226-0.97781-2.226-0.9794-3.4314zm6.4197-6.4666v1.0198c-2.0017-0.0231-3.9402,1.1876-4.8218,2.9804-0.38703,0.76044-0.58493,1.614-0.58557,2.4666h-1.0122c-0.0172-2.1958,1.17-4.3522,3.0441-5.5,1.0063-0.6311,2.189-0.9647,3.3755-0.9668z' fill='%2321231e'/%3E %3Cpath d='m345.1,192.72c3.2648,0,5.9124,2.6675,5.9124,5.9579,0,3.2892-2.6476,5.9567-5.9124,5.9567-3.266,0-5.9124-2.6675-5.9124-5.9567,0-3.2904,2.6464-5.9579,5.9124-5.9579z' fill='%23FFF'/%3E %3Cpath d='m351.52,198.68h-1.0122c0.0231-2.0049-1.1654-3.9602-2.9587-4.858-0.75282-0.38946-1.6006-0.5893-2.4475-0.58995v-1.0198c2.1781-0.0175,4.306,1.178,5.439,3.0355,0.64069,1.0225,0.97733,2.2269,0.97941,3.4323zm-6.4185,6.4666v-1.0198c1.9379,0.0221,3.8165-1.1107,4.733-2.8126,0.44347-0.80194,0.67273-1.7184,0.67336-2.634h1.0122c0.0172,2.1959-1.1707,4.3518-3.0442,5.5-1.0058,0.63018-2.1882,0.96517-3.3744,0.9665zm-6.4185-6.4666h1.0122c-0.0231,2.0047,1.1661,3.9591,2.9584,4.8576,0.75365,0.38756,1.6007,0.58928,2.4479,0.58926v1.0198c-2.1658,0.0173-4.2832-1.1633-5.4194-3.0048-0.65505-1.0284-0.99618-2.2447-0.99919-3.4619zm6.4185-6.4678v1.0198c-1.9374-0.0214-3.8178,1.1096-4.7326,2.8131-0.44377,0.80211-0.67337,1.719-0.67389,2.635h-1.0122c-0.0178-2.1961,1.1701-4.3519,3.0429-5.5012,1.0069-0.62976,2.1891-0.96488,3.3758-0.9667z' fill='%2321231e'/%3E %3Cpath d='m339.79,181.71c3.266,0,5.9124,2.6663,5.9124,5.9567,0,3.2892-2.6464,5.9567-5.9124,5.9567-3.2648,0-5.9124-2.6675-5.9124-5.9567,0-3.2904,2.6476-5.9567,5.9124-5.9567z' fill='%23FFF'/%3E %3Cpath d='m346.21,187.66h-1.0122c0.0228-1.9924-1.1502-3.9362-2.926-4.8407-0.76117-0.3995-1.6212-0.60553-2.4802-0.60622v-1.0198c2.1658-0.0179,4.2819,1.1635,5.4194,3.0035,0.65427,1.0292,0.99676,2.2452,0.9991,3.4632zm-6.4185,6.4666v-1.0198c1.9251,0.0212,3.7943-1.0949,4.7149-2.7811,0.45597-0.80894,0.69064-1.738,0.69158-2.6657h1.0123c0.0177,2.1834-1.1568,4.3274-3.0123,5.4802-1.0122,0.64387-2.2079,0.98423-3.4065,0.98639zm-6.4185-6.4666h1.0122c-0.0234,1.9928,1.1514,3.9348,2.926,4.8405,0.76108,0.3998,1.6211,0.60565,2.4802,0.60632v1.0198c-2.1782,0.0176-4.306-1.1779-5.439-3.0355-0.64073-1.0221-0.97729-2.2262-0.97941-3.4312zm6.4185-6.4666v1.0198c-1.9893-0.0231-3.9153,1.1731-4.8045,2.9477-0.3967,0.76908-0.6015,1.6344-0.60191,2.4993h-1.0122c-0.017-2.1834,1.156-4.3291,3.0135-5.4802,1.0117-0.64531,2.2071-0.98358,3.4052-0.98661z' fill='%2321231e'/%3E %3Cpath d='m444.27,202.15c3.4164-0.2321,2.5712,5.8942,1.8968,7.2592-0.87976,1.7823-1.6974,1.8388-2.8076,0.19121-0.85111-1.2628-2.5044-7.2183,0.91079-7.4504z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m446.62,209.63c-0.30161-0.15154-0.60321-0.30307-0.90482-0.45461,0.32656-0.77695,0.44318-1.62371,0.5251-2.45701,0.0679-1.03225,0.0606-2.11221-0.35043-3.07951-0.19955-0.45937-0.58101-0.87475-1.09433-0.95955-0.16156-0.0318-0.32629-0.0332-0.49039-0.0267-0.0231-0.33913-0.0461-0.67827-0.0692-1.0174,0.64466-0.0417,1.32067,0.11979,1.81599,0.55022,0.71308,0.60455,1.01659,1.54516,1.14739,2.44254,0.17923,1.32162,0.0624,2.67294-0.23469,3.96901-0.0862,0.35263-0.19014,0.70613-0.34462,1.033zm-3.6778,0.25015c0.27853-0.19082,0.55705-0.38164,0.83558-0.57246,0.2538,0.35319,0.50892,0.74436,0.9085,0.94518,0.25421,0.0959,0.44699-0.17186,0.5897-0.3406,0.17308-0.22862,0.31193-0.4809,0.4392-0.73722,0.30161,0.15154,0.60321,0.30307,0.90482,0.45461-0.31398,0.61004-0.68124,1.27588-1.33747,1.56761-0.52064,0.23116-1.12429,0.022-1.52306-0.34818-0.32098-0.27759-0.57944-0.62201-0.81727-0.96894zm1.294-8.2454c0.0231,0.33913,0.0461,0.67827,0.0692,1.0174-0.48692,0.0234-0.9811,0.25675-1.22149,0.69647-0.38433,0.66622-0.39805,1.46923-0.35548,2.21706,0.0926,1.15609,0.37193,2.3023,0.84369,3.36273,0.0606,0.13046,0.12695,0.25835,0.2052,0.37915-0.27853,0.19082-0.55706,0.38164-0.83559,0.57246-0.47444-0.76732-0.73635-1.64438-0.95202-2.51408-0.26571-1.16486-0.4178-2.39325-0.15483-3.57254,0.16743-0.75999,0.60358-1.50114,1.31564-1.86138,0.33415-0.1797,0.70999-0.26328,1.08568-0.29727z'/%3E %3Cpath d='m444.49,205.46c8.0312-0.54719,6.0449,13.845,4.4584,17.055-2.0687,4.1864-3.9917,4.3163-6.5999,0.44859-1.9994-2.9645-5.8885-16.956,2.1427-17.503h-0.001z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m449.4,222.74c-0.30161-0.15153-0.60322-0.30307-0.90483-0.4546,0.74791-1.72339,1.03509-3.60618,1.2504-5.46019,0.23335-2.54016,0.24236-5.18025-0.6136-7.61411-0.46974-1.31387-1.37623-2.58315-2.75224-3.03292-0.59726-0.19743-1.2306-0.24222-1.856-0.2119-0.0231-0.33913-0.0461-0.67827-0.0692-1.0174,1.35332-0.0906,2.77186,0.24733,3.81009,1.15352,1.49563,1.29486,2.12758,3.28702,2.41834,5.18459,0.43059,3.03506,0.16517,6.14152-0.51005,9.12118-0.19969,0.79415-0.41955,1.59102-0.77291,2.33183zm-7.4702,0.50752c0.27853-0.19082,0.55706-0.38164,0.83559-0.57246,0.67074,0.9427,1.36994,1.97502,2.45424,2.47268,0.74199,0.33284,1.50122-0.18849,1.95562-0.752,0.54315-0.63228,0.94534-1.3694,1.31988-2.10992,0.30161,0.15154,0.60322,0.30307,0.90483,0.45461-0.64026,1.23192-1.34501,2.5687-2.60498,3.26388-0.93463,0.52379-2.09875,0.20308-2.87539-0.45849-0.79601-0.63679-1.41858-1.46167-1.98979-2.2983zm2.5605-17.28v-1.0198c0.0116,0.33957,0.0231,0.67913,0.0347,1.0187-1.23882,0.0741-2.49527,0.61211-3.20976,1.66191-1.03555,1.48152-1.20141,3.37076-1.17078,5.12842,0.10122,2.88879,0.77476,5.74883,1.85677,8.42441,0.22242,0.5134,0.45875,1.02338,0.76398,1.49369-0.27853,0.19082-0.55706,0.38164-0.83559,0.57246-1.04087-1.68758-1.61094-3.61562-2.10159-5.52256-0.61689-2.6495-0.98739-5.43944-0.42598-8.13192,0.34448-1.62122,1.22924-3.23758,2.75168-4.0132,0.7053-0.3877,1.50525-0.55834,2.30134-0.63062,0.0119,0.33926,0.0223,0.68045,0.0352,1.01851zm-0.001-1.0198c0.002,0.33762,0.002,0.68218,0,1.0198-0.0115-0.33953-0.0231-0.67907-0.0346-1.0186l0.0346-0.001v-0.0002z'/%3E %3Cpath d='m379.74,210.81c3.2624-1.0463,3.8914,5.1065,3.5596,6.5941-0.43331,1.9423-1.214,2.1924-2.6822,0.85989-1.1245-1.021-4.1397-6.4077-0.87737-7.454z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m383.79,217.51c-0.32866-0.0746-0.65733-0.14913-0.98599-0.22369,0.12602-0.77108,0.0528-1.56012-0.0473-2.33013-0.15456-1.00636-0.39736-2.03197-0.9565-2.89688-0.30175-0.46828-0.79376-0.89378-1.38363-0.86076-0.17969,0.00023-0.35529,0.0438-0.52759,0.0913-0.10187-0.32391-0.20373-0.64783-0.3056-0.97174,0.60869-0.19296,1.29481-0.20088,1.8739,0.0909,0.83394,0.40217,1.35394,1.23387,1.69496,2.06408,0.50341,1.26674,0.71555,2.63783,0.72734,3.99666-0.003,0.34785-0.0202,0.70064-0.0896,1.04023zm-3.5142,1.1269c0.22601-0.25255,0.45201-0.50511,0.67802-0.75766,0.33584,0.28523,0.68155,0.61963,1.13013,0.7018,0.2564,0.01,0.37116-0.2798,0.46724-0.47194,0.11468-0.26389,0.18777-0.54312,0.253-0.82262,0.32866,0.0746,0.65733,0.14913,0.98599,0.2237-0.16018,0.66929-0.36215,1.40425-0.93089,1.8453-0.44441,0.34122-1.06896,0.29242-1.54086,0.0356-0.38521-0.19337-0.72338-0.46831-1.04263-0.75422zm-0.69115-8.3187c0.10186,0.32391,0.20372,0.64783,0.30558,0.97174-0.47588,0.14153-0.90398,0.49865-1.02829,0.99303-0.20904,0.76333-0.018,1.5671,0.21544,2.30219,0.36836,1.07375,0.90236,2.09715,1.60125,2.99317,0.0858,0.10569,0.17547,0.20856,0.27563,0.30096-0.22601,0.25256-0.45202,0.50511-0.67803,0.75767-0.6458-0.63791-1.1107-1.4329-1.52782-2.23231-0.52485-1.05588-0.95622-2.19746-0.98579-3.38898-0.0235-0.7869,0.22593-1.62137,0.83662-2.14833,0.28284-0.25398,0.62847-0.42508,0.98541-0.54914z'/%3E %3Cpath d='m380.74,213.97c7.6695-2.4594,9.1449,11.994,8.3642,15.491-1.0194,4.564-2.8553,5.1522-6.3039,2.0216-2.6428-2.3993-9.7298-15.055-2.0603-17.513z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m389.6,229.58c-0.32866-0.0746-0.65733-0.14914-0.98599-0.22371,0.31737-1.85218,0.1538-3.75034-0.0781-5.60321-0.37356-2.52128-0.98909-5.0872-2.39792-7.24637-0.7874-1.20127-2.03417-2.24906-3.53028-2.28947-0.58135-0.0303-1.156,0.0835-1.71155,0.24584-0.10186-0.32391-0.20372-0.64783-0.30558-0.97174,1.29164-0.41303,2.75045-0.42728,3.9746,0.20669,1.77365,0.90752,2.86112,2.71149,3.59063,4.50048,1.12427,2.83271,1.59293,5.89621,1.644,8.93308-0.008,0.81845-0.0291,1.6466-0.19983,2.44841zm-7.1359,2.2886c0.22601-0.25256,0.45201-0.50511,0.67802-0.75767,0.87245,0.75551,1.7967,1.58823,2.96515,1.81354,0.80236,0.14253,1.41589-0.54436,1.72296-1.20243,0.37841-0.7442,0.59648-1.5564,0.78373-2.36628,0.32866,0.0746,0.65733,0.14913,0.98599,0.22369-0.33,1.35114-0.69877,2.81913-1.75804,3.79632-0.7808,0.7334-1.99001,0.70407-2.90163,0.24455-0.92528-0.42385-1.72244-1.08112-2.47618-1.75172zm-1.8741-18.378c0.10186,0.32391,0.20373,0.64783,0.30559,0.97174-1.20337,0.37121-2.30362,1.2186-2.74088,2.42942-0.66111,1.77411-0.3208,3.72972,0.17398,5.50171,0.80978,2.70115,2.11456,5.25236,3.77687,7.52746,0.31667,0.42015,0.65113,0.82989,1.03621,1.18969-0.22601,0.25256-0.45202,0.50511-0.67803,0.75767-1.4072-1.39217-2.4208-3.12469-3.34601-4.85968-1.22714-2.4267-2.24623-5.0488-2.33777-7.79649-0.05-1.66005,0.43149-3.43961,1.7249-4.55908,0.59328-0.54519,1.32974-0.89937,2.08514-1.16244zm0.15279,0.48587c-0.11532-0.36672-0.20041-0.63731-0.0351-0.11154,0.0117,0.0372,0.0234,0.0744,0.0351,0.11154z'/%3E %3Cpath d='m464.2,137.77c-17.233-1.5683-34.854,0.19483-52.298,7.1714-14.703,5.881-13.262,23.054,4.6662,46.89-1.6222,3.0199-2.545,6.7745-2.6906,11.109,1.8968-0.10464,3.2266-0.0553,4.9001-0.0974-1.2987-2.8876,0.15518-6.4246,1.7965-8.9165,1.0708-1.6272,1.2892-1.341-0.001-3.1545-10.672-14.993-17.744-28.125-13.584-36.055,5.0553-9.6368,24.656-14.657,57.715-13.922-0.0598-0.87914-0.12176-1.7667-0.18144-2.6627-0.10506-0.12027-0.21128-0.23934-0.3235-0.3608l0.001-0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m412.09,145.42c-1.04336-1.30994,0.9551-1.30418,1.78982-1.78213,15.987-6.06128,33.3877-7.96408,50.3674-6.37006,0.34816,1.65821-1.47115,0.71786-2.43862,0.8246-16.8546-1.28577-34.008,0.9908-49.7186,7.32759zm4.9252,46.659c-1.20248-0.55236-0.94617,0.16653-1.94556-1.42318-5.66899-7.87904-11.011-16.3721-13.12-25.9686-1.20264-5.51591-0.65525-11.9584,3.5169-16.144,1.72886-1.82505,3.93894-3.12333,6.25084-4.07103,1.05098,1.31839-0.98555,1.30823-1.74559,1.94787-4.4098,2.19629-7.37133,6.84314-7.5199,11.7652-0.34791,7.50434,2.87125,14.6082,6.39593,21.0481,2.4068,4.28844,5.18136,8.35969,8.12549,12.295,0.0139,0.18347,0.0277,0.36809,0.0418,0.55047zm-0.0417-0.55081zm-3.1215,10.908c0.36453,1.80662-0.87004,0.27162-0.41866-0.69497,0.24164-3.50874,1.02239-7.02981,2.69137-10.1482,1.56088,0.29803,0.21996,1.46501,0.005,2.38442-1.14301,2.85149-1.63947,5.92488-1.74565,8.98424-0.17729-0.17513-0.35548-0.3507-0.53216-0.52553zm0.0549,1.0174zm4.4119-0.39566c1.6471-0.99757,0.3349,0.82805-0.74008,0.31625-1.22423,0.005-2.4491,0.005-3.6718,0.075-0.56759-1.50448,1.1407-0.96178,2.05913-1.0854,0.93344-0.011,1.86708-0.004,2.8004-0.025-0.14921,0.23969-0.29845,0.47955-0.44765,0.71915zm0.92154-0.42093zm0.91438-8.9874c1.44754,0.40226,0.22985,1.34137-0.10253,2.18481-1.04182,2.05598-1.7849,4.58019-0.81143,6.8026-1.19989,1.0853-1.3161-0.7093-1.43751-1.596-0.20852-2.65071,0.94298-5.21475,2.35147-7.39141zm0.009-2.5761c0.79738-1.12577,1.32451,0.0128,1.7035,0.80577,0.38563,0.89781-0.45124,1.63435-0.871,2.33292-1.24092-0.36067-0.50881-1.04206-0.0573-1.76067,0.011-0.51379-0.56431-0.94789-0.77522-1.37802zm-13.621-36.591c1.57643,0.28689,0.19988,1.50284,0.12778,2.47764-1.25455,5.38267,0.98655,10.7888,3.22151,15.5971,3.09196,6.32508,7.03774,12.1833,11.0928,17.9218-1.00015,1.32727-1.46913-0.5773-2.1302-1.26445-5.00628-7.32598-10.0948-14.8455-12.6955-23.4163-1.02793-3.6728-1.44131-7.81409,0.38355-11.3157zm57.658-13.649c1.96395-0.31701-0.0284,0.91165-0.98447,0.44944-12.9923-0.14576-26.1598,0.18278-38.8245,3.36134-5.86593,1.6128-12.1202,3.81373-15.9863,8.78466-0.27977,0.95984-1.69397,2.1558-1.67657,0.73396,3.17075-5.39764,9.29845-8.01308,15.011-9.8308,12.1424-3.53977,24.9092-4.05648,37.4806-4.11067,1.83231,0.004,3.6643,0.034,5.49623,0.0687-0.17196,0.18098-0.34397,0.3632-0.5159,0.54335zm1.0099-0.0697zm-1.066-2.291c0.72087-1.05033,1.01076-0.33807,0.94754,0.54848-0.0683,0.54488,0.32509,1.49092-0.0634,1.75593-0.98646,0.41821-0.87461-0.4241-0.90548-1.10353,0.006-0.36836-0.17551-1.54002-0.0334-1.33267l0.0547,0.13225,0.00002-0.00046zm0.75919-0.67349zm-1.0612-0.38485c0.67131,1.06842,0.66951,0.24649,0.82672,0.12332,0.54589,0.32368-0.36651,0.80653-0.57539,0.87948-0.22153-0.15199-0.38547-0.53559-0.25133-1.0028zm-0.0119,0.70835zm0.72935,0.012zm-0.31276-0.86831z'/%3E %3Cpath d='m380.59,142.66c3.3913,0,6.1404,2.7685,6.1404,6.1852s-2.7491,6.1864-6.1404,6.1864-6.1404-2.7697-6.1404-6.1864,2.7491-6.1852,6.1404-6.1852z' fill='%23FFF'/%3E %3Cpath d='m387.24,148.84h-1.0122c0.0251-2.1141-1.2455-4.1741-3.1496-5.0944-0.76834-0.3831-1.6262-0.58087-2.4844-0.58054v-1.0198c2.2555-0.0199,4.4585,1.2189,5.6317,3.1418,0.6669,1.0576,1.0115,2.3049,1.0146,3.553zm-6.6465,6.6964v-1.0198c2.0858,0.0245,4.1056-1.2375,5.0235-3.106,0.40447-0.79203,0.60971-1.6817,0.61058-2.5702h1.0122c0.0194,2.2741-1.212,4.5064-3.152,5.6948-1.0402,0.65606-2.266,0.99894-3.4943,1.0012zm-6.6465-6.6964h1.0122c-0.0245,2.1018,1.23,4.1512,3.1171,5.0788,0.77603,0.395,1.6468,0.59682,2.5169,0.59744v1.0198c-2.2558,0.0197-4.459-1.2194-5.6317-3.1429-0.66692-1.0576-1.0115-2.305-1.0145-3.5531zm6.6465-6.6952v1.0198c-2.0856-0.0248-4.1053,1.2367-5.0234,3.1048-0.40444,0.79204-0.60979,1.6817-0.61058,2.5702h-1.0123c-0.0193-2.2614,1.198-4.4816,3.1202-5.6744,1.0485-0.66743,2.2842-1.0193,3.5261-1.0205z' fill='%2321231e'/%3E %3Cpath d='m392.62,138.7c3.3913,0,6.1404,2.7685,6.1404,6.1852,0,3.4179-2.7491,6.1864-6.1404,6.1864-3.3901,0-6.1392-2.7685-6.1392-6.1864,0-3.4155,2.7479-6.1852,6.1392-6.1852z' fill='%23FFF'/%3E %3Cpath d='m399.27,144.88h-1.0122c0.025-2.114-1.2455-4.1741-3.1497-5.0944-0.76834-0.38311-1.6262-0.58087-2.4844-0.58055v-1.0198c2.2555-0.0199,4.4585,1.2189,5.6317,3.1418,0.66711,1.0576,1.0112,2.3052,1.0146,3.553zm-6.6465,6.6964v-1.0198c2.0734,0.0246,4.0812-1.2217,5.0069-3.072,0.41479-0.80073,0.62638-1.7031,0.62719-2.6041h1.0122c0.0194,2.2745-1.2121,4.5067-3.152,5.696-1.042,0.65377-2.2651,0.99888-3.4944,0.99997zm-6.6453-6.6964h1.0122c-0.0246,2.0891,1.2138,4.1261,3.0821,5.062,0.78498,0.40473,1.6679,0.61451,2.5508,0.61423v1.0198c-2.2681,0.0199-4.4828-1.2334-5.6508-3.1743-0.65291-1.0518-0.99149-2.2857-0.99423-3.5217zm6.6453-6.6952v1.0198c-2.0728-0.0245-4.0795,1.2217-5.0056,3.0709-0.414,0.80107-0.62737,1.7028-0.62748,2.604h-1.0122c-0.0198-2.2866,1.2259-4.53,3.1829-5.7145,1.0344-0.64203,2.2463-0.97796,3.4624-0.98032z' fill='%2321231e'/%3E %3Cpath d='m394.22,143.97c0.60521,0.819,1.2176,1.6368,1.8383,2.4558-9.7012,5.3614-13.717,11.016-12.77,16.702,0.16115,0.97655,3.1108,11.382,9.7,31.549,4.5026,3.1329,7.8593,5.9375,10.07,8.4125-0.24829,0.28142,0.71025,1.1594,0.42376,1.3999,0.67325,3.08-2.7753,2.4534-5.0899,1.6933-1.1149-2.9609-4.5157-6.1022-6.4698-7.4456-0.3987-0.273-1.8371-0.98017-1.9803-1.4396-3.5262-11.349-7.0679-21.843-10.106-31.615-3.0523-9.8196,3.5608-16.781,14.384-21.713z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m396.31,146.88c-0.46317-1.34873-0.47128-0.23017-0.81769-0.36561-0.56249-0.73998-1.11647-1.48641-1.67-2.2331,0.60172-0.75812,1.05871-0.54555,1.43721,0.23477,0.35809,0.59059,1.003,1.11475,1.18097,1.74341-0.0436,0.20675-0.0865,0.41421-0.13049,0.62053zm0.15877-0.75526zm-12.674,16.928c-0.94051,0.44849-1.20646-0.0648-1.12333-0.95391-0.27841-4.5549,2.70284-8.51783,6.02737-11.3043,2.18519-1.86347,4.61743-3.41493,7.12371-4.8076,0.89236,0.86221,0.0308,1.21196-0.75548,1.6024-4.20189,2.52357-8.53144,5.56333-10.6069,10.1697-0.71753,1.65731-0.96734,3.50993-0.66541,5.29371zm0-0.001zm9.4887,31.214c-0.49234,1.28659-0.94547,0.47165-1.11057-0.4705-3.23056-10.0412-6.5261-20.07-9.3057-30.2476-0.18514-0.68966,1.39257-0.66357,1.10773,0.25376,2.87281,10.3296,6.20287,20.5254,9.50072,30.7253-0.064-0.087-0.12823-0.17399-0.19218-0.26102zm-0.57535,0.83945zm10.736,8.3308c-0.92459-1.31863-0.53594,0.42959-1.17499-0.4558-2.85031-3.00488-6.18141-5.50215-9.5615-7.87495,0.36815-1.18876,1.06595-0.57783,1.74721-0.013,3.19239,2.30615,6.33442,4.73723,8.98649,7.66544,0.001,0.22592,0.00042,0.45365,0.003,0.67829zm-0.002-0.6783zm0.54194,1.6308c-0.90704,0.63423-0.9602-0.45432-0.94207,0.023-0.23936-0.50368-0.79914-1.09613-0.3533-1.65109,0.35874,0.55996,0.80686,0.47143,0.91891,0.59029,0.28064,0.43809,0.70747,1.09443,0.20612,1.53827,0.0567-0.16678,0.11442-0.33401,0.17034-0.50046zm-0.98837,0.21888zm-5.0684,1.7643c1.28046-0.14508,0.25929-0.95467,1.41961-0.42706,1.12396,0.22863,2.56916,0.75398,3.54985-0.0779,0.3807-0.64222-0.2252-1.56074,0.90694-1.43804,0.48398,0.17131,0.27721,1.35035,0.0356,1.83862-1.00389,1.55105-3.15763,1.05167-4.65899,0.68763-0.44247-0.14866-0.96335-0.17063-1.25298-0.58325zm0.31633,0.30427zm-6.5976-7.5093c0.338-1.12303,0.97809-0.71236,1.60371-0.0672,2.28817,1.90119,4.47775,4.11732,5.62273,6.91148-0.83276,0.61651-1.14813,0.13108-1.42231-0.66758-1.41392-2.46748-3.51963-4.51859-5.80413-6.17671zm0.5682-0.84185zm-2.7467-0.8659c0.50158-0.0722,0.95215-0.58858,1.29051-0.0318,0.46241,0.33565,0.97786,0.58735,1.4564,0.8975-0.30269,0.63756-0.63897,1.06703-1.22589,0.45225-0.55203-0.35826-1.25765-0.67338-1.52102-1.31797zm-10.106-31.615c1.05842-0.74384,1.1912,0.28412,1.4161,1.13987,3.16545,10.0734,6.52782,20.0839,9.65423,30.1697-0.99848,0.69277-1.18655-0.16467-1.3777-1.01979-3.15627-10.1203-6.53911-20.1694-9.69263-30.2898zm15.272-22.17c-1.47708,0.64,0.42424,0.72306-0.94732,1.1179-4.99999,2.41732-10.1205,5.56177-12.7524,10.6495-1.6062,3.10018-1.66877,6.81301-0.60738,10.0968-0.99911,0.69667-1.19429-0.16983-1.32103-1.03742-1.1159-4.32163,0.0576-9.06005,2.92522-12.4568,3.17629-3.87011,7.60076-6.45558,12.0887-8.5299,0.20436,0.0533,0.41157,0.10691,0.61424,0.15996zm-0.61476-0.15996z'/%3E %3Cpath d='m355.95,216.87-0.36766,1.9796c-2.8243,0.66024-5.2403,0.82502-7.2457,0.49428,3.3555-3.2989,5.8539-4,7.6134-2.4738z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m355.08,218.76c0.12255-0.65987,0.24511-1.31973,0.36766-1.9796,0.33105,0.0625,0.66211,0.12508,0.99316,0.18762-0.12255,0.65987-0.24511,1.31973-0.36766,1.9796-0.12733,0.1343-0.25466,0.26859-0.38199,0.40289-0.20372-0.19684-0.40745-0.39367-0.61117-0.59051zm0.99316,0.18762c-0.0434,0.10312-0.004,0.28587-0.10074,0.33758-0.0686-0.002-0.36702,0.12829-0.22499,0.006,0.10858-0.11452,0.21716-0.22903,0.32573-0.34356zm-8.0956,0.036c0.23555,0.24293,0.47111,0.48587,0.70666,0.7288-0.0907-0.28903-0.18144-0.57807-0.27216-0.8671,2.08792,0.33347,4.22058,0.0982,6.27884-0.3182,0.25758-0.0545,0.51497-0.10998,0.77112-0.1709,0.0764,0.33113,0.15279,0.66227,0.22919,0.9934-2.21533,0.51104-4.50821,0.83-6.78159,0.58982-0.22067-0.0245-0.44088-0.0533-0.6599-0.0898-0.0906-0.28793-0.18211-0.58172-0.27216-0.866zm0.27216,0.86711c-0.32946-0.0545-0.65893-0.10904-0.98839-0.16356,0.23874-0.23452,0.47749-0.46903,0.71623-0.70355,0.0907,0.28904,0.18144,0.57807,0.27216,0.86711zm8.1911-2.8827c-0.33105-0.0625-0.66211-0.12508-0.99316-0.18762,0.0557,0.15995,0.11141,0.3199,0.16711,0.47985-0.53408-0.48034-1.27209-0.72173-1.98637-0.62876-1.02241,0.11916-1.94132,0.64771-2.77105,1.22751-0.77854,0.55099-1.49199,1.18803-2.17317,1.85406-0.23555-0.24293-0.47111-0.48587-0.70666-0.7288,1.10809-1.07676,2.2984-2.10564,3.69122-2.79672,0.97137-0.4805,2.10757-0.76431,3.17831-0.47263,0.52811,0.1415,1.01424,0.41687,1.42665,0.77354,0.0557,0.15966,0.11161,0.32088,0.16712,0.47957zm-0.16712-0.47987c0.0652,0.0918,0.25945,0.13834,0.20588,0.27165-0.0203,0.15706-0.0438,0.27245-0.0926,0.0537-0.0378-0.10845-0.0755-0.21695-0.11333-0.32537zm-0.32946,0.38605c0.16553,0.0312,0.33105,0.0625,0.49658,0.0937-0.16553-0.0312-0.33105-0.0625-0.49658-0.0937zm0.32946-0.38605c0.0652,0.0918,0.25945,0.13834,0.20588,0.27165-0.0203,0.15706-0.0438,0.27245-0.0926,0.0537-0.0378-0.10845-0.0755-0.21695-0.11333-0.32537z'/%3E %3Cpath d='m355.64,212.34c1.7702,0.39447,1.9338,0.69514,2.7061,0.82983,0.99196,0.17198,2.3587,0.10222,3.2994-0.72881,3.8377-2.3187,3.9201,1.8581,2.4292,4.9862-1.0815,2.2658-0.52642,4.8262,0.50494,6.7661,1.22,2.291,0.96091,3.3398,0.0978,3.9591-0.59684,0.39327-1.1662,0.76248-1.6771,1.0908-1.0337,1.2291-1.8192,1.0174-1.9648-0.5905-3.8318-1.5887-5.1007-5.2916-6.2478-8.5508-1.6771-4.7661-7.771-5.893,0.8511-7.7619h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m358.43,212.66c-0.0573,0.33433-0.11459,0.66867-0.17189,1.003-0.83298-0.16819-1.58347-0.60973-2.42336-0.7629-0.43209,0.0334-0.24735-0.32366-0.19014-0.5999,0.023-0.33847,0.1135-0.57442,0.47196-0.37935,0.77788,0.14806,1.48579,0.52045,2.24471,0.72435,0.0229,0.005,0.0478,0.008,0.0687,0.0148zm2.9532-0.66387c0.17348,0.29104,0.34697,0.58208,0.52045,0.87312,0.098-0.0575-0.38965,0.31729-0.56329,0.38864-0.93682,0.50096-2.0484,0.57892-3.08216,0.40496,0.0573-0.33433,0.11459-0.66867,0.17189-1.003,1.01471,0.16821,2.16048,0.0489,2.95311-0.66372zm-0.0728,0.0542zm3.2182,5.5899c-0.30368-0.14671-0.60979-0.29728-0.91197-0.44159,0.5659-1.25436,1.00368-2.65747,0.78293-4.04443-0.0541-0.49157-0.45518-0.99183-0.99667-0.87602-0.54204,0.0588-1.03487,0.32097-1.49932,0.59098-0.17348-0.29104-0.34697-0.58208-0.52045-0.87312,0.88121-0.52053,2.01311-1.03814,3.0133-0.53685,0.9601,0.52409,1.13146,1.75176,1.06889,2.74348-0.078,1.19311-0.43268,2.35849-0.93671,3.43755zm0.4942,6.3043c-0.29683,0.16035-0.59367,0.32071-0.8905,0.48106-1.13998-2.12356-1.599-4.77475-0.59915-7.04066,0.079-0.39332,0.47209,0.0819,0.70482,0.11366,0.43126,0.0617,0.1832,0.35671,0.0907,0.62411-0.69887,1.91816-0.23371,4.0672,0.69414,5.82183zm-0.0704,4.6266c-0.19219-0.27003-0.36915-0.62091-0.57057-0.84188,0.61594-0.37636,0.59476-1.1931,0.39281-1.79874-0.15296-0.52547-0.38867-1.02208-0.64245-1.50541,0.29683-0.16035,0.59367-0.32071,0.8905-0.48106,0.54671,1.07359,1.14269,2.31566,0.77194,3.5406-0.14886,0.44458-0.46054,0.82004-0.84223,1.08649zm0.0167-0.0121-0.0167,0.0121,0.0167-0.0121zm-1.5852,1.0054c-0.25704-0.21968-0.51409-0.43937-0.77113-0.65905,0.57048-0.42832,1.19879-0.78017,1.78591-1.1876,0.18462,0.28463,0.36925,0.56925,0.55387,0.85388-0.55947,0.3658-1.11882,0.73198-1.6816,1.0927,0.0372-0.0332,0.0771-0.0669,0.11295-0.0999zm-0.77113-0.65905zm-1.7714,0.21046c0.12812-0.31429,0.25624-0.62859,0.38436-0.94288,0.19469,0.23468,0.3668,0.47259,0.36176,0.78894,0.0525,0.18491,0.077,0.45078,0.2545,0.55263,0.32564-0.0883,0.55112-0.36978,0.7697-0.6099,0.25704,0.21969,0.51409,0.43937,0.77113,0.65906-0.46314,0.5596-1.18883,1.19461-1.96482,0.88435-0.65645-0.30978-0.8261-1.10122-0.88891-1.7582,0.10419,0.14188,0.20764,0.28474,0.31228,0.426zm0.38436-0.94288c0.34683-0.0736,0.40528,0.69265,0.16623,0.22709-0.0554-0.0757-0.11079-0.15146-0.16623-0.22709zm-6.9163-7.9086c0.31752-0.11385,0.63504-0.22771,0.95256-0.34156,0.8562,2.42863,1.74108,5.00098,3.68136,6.79737,0.66669,0.61476,1.44546,1.10485,2.28235,1.4528-0.12812,0.3143-0.25624,0.62859-0.38436,0.94289-2.09891-0.84036-3.73569-2.56214-4.76474-4.54526-0.73596-1.37025-1.25192-2.84299-1.76717-4.30624zm1.3274-8.4426v1.0198c0.19309-0.0163-0.49502,0.1162-0.65056,0.15877-1.06961,0.28921-2.21215,0.49616-3.13651,1.13914-0.41538,0.24431-0.0997,0.71614,0.10943,0.98563,1.00354,1.25595,2.19131,2.3929,2.90143,3.85839,0.15182,0.30516,0.28276,0.61974,0.40152,0.93915-0.31752,0.11385-0.63505,0.2277-0.95257,0.34155-0.58288-1.70225-1.88325-2.98994-3.01374-4.33665-0.47866-0.566-0.92888-1.4098-0.48393-2.12045,0.54413-0.82478,1.57369-1.10175,2.46095-1.40202,0.77748-0.23065,1.5675-0.43374,2.36398-0.58331zm-0.10624,0.012zm0.10743,1.0078c-0.002-0.33761-0.002-0.68219,0-1.0198,0.24109,0.0779-0.018,0.55756,0.0242,0.79516-0.008,0.0749-0.0161,0.14976-0.0242,0.22464zm0-1.0198z'/%3E %3Cpath d='m357.15,212.5c3.3364,1.1978,3.7088-0.66627,5.9601-0.57126-0.88692,5.1413-1.7846,7.8016-7.1097,5.0427-2.9389-1.5238-6.7014,0.70594-7.4164,2.3596-0.26142,0.60372-1.9708-0.65065-2.5951-2.0253-2.6154-5.7571,6.6883-6.4113,11.161-4.8058z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m363.61,212.02c-0.33184-0.0585-0.66369-0.11706-0.99553-0.17559,0.15876,0.19884,0.31753,0.39768,0.47629,0.59652-1.23807-0.0936-2.23158,0.83253-3.43391,0.94246-0.9083,0.11462-1.82174-0.098-2.67424-0.4001,0.113-0.31991,0.226-0.63981,0.339-0.95972,0.98732,0.36821,2.12142,0.55493,3.11464,0.10029,0.8497-0.381,1.74296-0.77266,2.69748-0.70029,0.15874,0.19876,0.31763,0.39794,0.47627,0.59643zm-0.47627-0.59652c0.20064,0.0591,0.6937-0.11768,0.54024,0.2271-0.009,0.37475-0.10557,0.4087-0.29526,0.0797-0.0817-0.10225-0.16328-0.20457-0.24498-0.30678zm-7.3627,6.0048c0.15438-0.30226,0.30877-0.60453,0.46315-0.90679,1.10067,0.54188,2.28134,1.12318,3.5417,1.03522,0.9055-0.0699,1.51566-0.86588,1.82836-1.64939,0.539-1.29488,0.76019-2.69105,1.01031-4.06312,0.33184,0.0585,0.66369,0.11706,0.99553,0.17559-0.30675,1.64407-0.55338,3.34667-1.34797,4.84107-0.48797,0.95036-1.44554,1.68842-2.53843,1.71973-1.39844,0.0703-2.73054-0.54319-3.95265-1.15231zm-6.7217,2.1094c-0.30877-0.1355-0.61754-0.271-0.92631-0.4065,0.57033-1.18306,1.71591-1.96833,2.86955-2.52075,1.62736-0.75094,3.61343-0.93963,5.24151-0.089-0.15439,0.30226-0.30877,0.60453-0.46316,0.90679-1.54678-0.80112-3.43522-0.44713-4.89266,0.38402-0.72067,0.42315-1.44868,0.96066-1.82893,1.72544zm-3.5178-2.0168c0.30639-0.14111,0.61277-0.28221,0.91916-0.42332,0.38573,0.77141,0.99288,1.4741,1.7757,1.85553,0.26023,0.005-0.35243,0.19076,0.048,0.24382,0.25847,0.11342,0.51693,0.22684,0.7754,0.34026-0.21215,0.52028-0.88963,0.55672-1.32379,0.30751-0.95894-0.49445-1.72749-1.36337-2.19449-2.3238zm11.79-5.4973c-0.113,0.31991-0.226,0.63981-0.339,0.95972-2.0899-0.70375-4.34568-0.8657-6.52971-0.61576-1.30468,0.18625-2.68847,0.50339-3.68513,1.42102-0.70825,0.62513-0.87698,1.66975-0.59356,2.54242,0.0635,0.2654,0.17579,0.51396,0.27632,0.76657-0.30638,0.14111-0.61277,0.28222-0.91915,0.42333-0.49177-1.07325-0.71984-2.36523-0.19187-3.46925,0.62597-1.30017,2.0114-1.99991,3.34322-2.36876,2.34774-0.61853,4.84073-0.55717,7.20639-0.0673,0.48442,0.11078,0.96422,0.24189,1.43249,0.40802zm-0.1695,0.47986c0.0655-0.18535,0.25009-0.70803,0.0872-0.24676-0.029,0.0823-0.0581,0.16451-0.0872,0.24676z'/%3E %3Cpath d='m458.84,124.49c3.3758,0,6.1117,2.7577,6.1117,6.1588s-2.736,6.1588-6.1117,6.1588c-3.3758,0-6.1129-2.7577-6.1129-6.1588s2.7372-6.1588,6.1129-6.1588z' fill='%23FFF'/%3E %3Cpath d='m465.46,130.64h-1.0122c0.0268-2.145-1.2906-4.233-3.2434-5.1234-0.73535-0.34813-1.549-0.52507-2.3621-0.52502v-1.0198c2.2466-0.0199,4.4402,1.2148,5.6083,3.1303,0.6611,1.0538,1.0078,2.2958,1.0094,3.538zm-6.6178,6.6687v-1.0198c2.0753,0.0255,4.0847-1.2311,4.9976-3.09,0.4023-0.78858,0.60822-1.6738,0.60794-2.5585h1.0122c0.0196,2.2644-1.2066,4.4872-3.1374,5.6718-1.0369,0.65097-2.2568,0.99575-3.4803,0.99647zm-6.619-6.6687h1.0123c-0.0257,2.1043,1.2399,4.1545,3.1347,5.0708,0.76421,0.38169,1.6181,0.57823,2.4719,0.57769v1.0198c-2.2596,0.0203-4.4642-1.2292-5.6292-3.1614-0.64831-1.0478-0.98821-2.2761-0.98969-3.5069zm6.619-6.6687v1.0198c-2.0884-0.0258-4.109,1.2475-5.0157,3.1237-0.39123,0.78009-0.59131,1.6528-0.59092,2.5249h-1.0122c-0.0196-2.2647,1.207-4.4878,3.1386-5.6719,1.0368-0.65131,2.257-0.99519,3.4802-0.99655z' fill='%2321231e'/%3E %3Cpath d='m446.31,124.49c3.3758,0,6.1129,2.7577,6.1129,6.1588s-2.7371,6.1588-6.1129,6.1588-6.1129-2.7577-6.1129-6.1588,2.7372-6.1588,6.1129-6.1588z' fill='%23FFF'/%3E %3Cpath d='m452.93,130.64h-1.0123c0.0256-2.1043-1.2399-4.1545-3.1348-5.0708-0.76422-0.38166-1.6181-0.57822-2.4719-0.57767v-1.0198c2.2595-0.0202,4.4642,1.2294,5.6292,3.1616,0.64837,1.0478,0.9881,2.2763,0.98978,3.5068zm-6.619,6.6687v-1.0198c2.0884,0.0258,4.109-1.2473,5.0157-3.1236,0.39127-0.78008,0.59125-1.6528,0.59102-2.5249h1.0122c0.0196,2.2647-1.207,4.4877-3.1386,5.6719-1.0369,0.65096-2.2568,0.99574-3.4803,0.99646zm-6.619-6.6687h1.0122c-0.0257,2.1043,1.2399,4.1545,3.1347,5.0708,0.76421,0.3817,1.6181,0.57823,2.4719,0.57769v1.0198c-2.2596,0.0203-4.4642-1.2292-5.6292-3.1614-0.64829-1.0478-0.98821-2.2761-0.98967-3.5069zm6.619-6.6687v1.0198c-2.0884-0.0258-4.109,1.2475-5.0157,3.1237-0.39134,0.78007-0.59113,1.6528-0.59092,2.5249h-1.0123c-0.0196-2.2647,1.207-4.4878,3.1386-5.6719,1.0368-0.65131,2.257-0.99519,3.4802-0.99655z' fill='%2321231e'/%3E %3Cpath d='m433.79,125.48c3.3758,0,6.1129,2.7565,6.1129,6.1588,0,3.4011-2.7371,6.1588-6.1129,6.1588s-6.1117-2.7577-6.1117-6.1588c0-3.4023,2.736-6.1588,6.1117-6.1588z' fill='%23FFF'/%3E %3Cpath d='m440.41,131.63h-1.0122c0.0252-2.0913-1.2232-4.1314-3.1012-5.0537-0.77243-0.39332-1.6391-0.59534-2.5054-0.59489v-1.0198c2.2464-0.0197,4.4396,1.2142,5.6089,3.1287,0.66087,1.0544,1.0087,2.2967,1.0099,3.5397zm-6.619,6.6687v-1.0198c2.0884,0.0258,4.109-1.2473,5.0157-3.1236,0.39129-0.78008,0.59116-1.6528,0.59102-2.5249h1.0122c0.0196,2.2647-1.207,4.4877-3.1386,5.6718-1.0369,0.6511-2.2568,0.99554-3.4803,0.99645zm-6.6178-6.6687h1.0122c-0.0268,2.145,1.2906,4.233,3.2434,5.1234,0.73525,0.34844,1.549,0.52522,2.3621,0.52522v1.0198c-2.2594,0.0202-4.4645-1.2292-5.6285-3.162-0.64779-1.0481-0.98772-2.2758-0.98927-3.5065zm6.6178-6.6687v1.0198c-2.0878-0.0257-4.1087,1.2464-5.0146,3.1229-0.39147,0.78011-0.59081,1.6534-0.59092,2.5256h-1.0122c-0.021-2.3339,1.2845-4.6238,3.3155-5.7782,0.99565-0.58449,2.1488-0.88846,3.3022-0.89015z' fill='%2321231e'/%3E %3Cpath d='m422.25,127.7c3.3758,0,6.1117,2.7565,6.1117,6.1576,0,3.4023-2.736,6.16-6.1117,6.16-3.3758,0-6.1129-2.7577-6.1129-6.16,0-3.4011,2.7372-6.1576,6.1129-6.1576z' fill='%23FFF'/%3E %3Cpath d='m428.87,133.86h-1.0122c0.0257-2.1036-1.239-4.1538-3.1335-5.0696-0.76418-0.3818-1.6181-0.57832-2.4719-0.57778v-1.0198c2.259-0.0201,4.4641,1.2283,5.6285,3.1607,0.64775,1.0481,0.98783,2.2757,0.98918,3.5065zm-6.6178,6.6699v-1.0198c2.0882,0.0263,4.1077-1.2483,5.0145-3.1237,0.39127-0.78049,0.59099-1.6536,0.59093-2.5261h1.0122c0.0194,2.2646-1.2057,4.4873-3.1365,5.6726-1.0372,0.65118-2.2573,0.99615-3.4811,0.99701zm-6.619-6.6699h1.0123c-0.0229,2.0136,1.1298,3.9791,2.895,4.9467,0.82444,0.46083,1.7672,0.70494,2.7117,0.70307v1.0198c-2.2466,0.0198-4.4402-1.2149-5.6089-3.1299-0.66171-1.0539-1.0081-2.2972-1.01-3.5397zm6.619-6.6675v1.0198c-2.1008-0.026-4.1325,1.2627-5.0326,3.1559-0.37974,0.77176-0.57462,1.6316-0.57411,2.4913h-1.0122c-0.0213-2.3215,1.271-4.5986,3.2842-5.7582,1.0036-0.59625,2.1685-0.90741,3.3348-0.90896z' fill='%2321231e'/%3E %3Cpath d='m346.3,159.43c3.3913,0,6.1404,2.7685,6.1404,6.1864,0,3.4167-2.7491,6.1852-6.1404,6.1852-3.3901,0-6.1404-2.7685-6.1404-6.1852,0-3.4179,2.7491-6.1864,6.1404-6.1864z' fill='%23FFF'/%3E %3Cpath d='m352.94,165.62h-1.0122c0.0244-2.1014-1.2294-4.1512-3.1163-5.0784-0.77649-0.39497-1.6473-0.59804-2.518-0.59788v-1.0198c2.2555-0.0198,4.4585,1.2188,5.6317,3.1418,0.6663,1.0588,1.0115,2.3057,1.0147,3.5543zm-6.6465,6.6952v-1.0198c2.0856,0.0248,4.1053-1.2367,5.0234-3.1048,0.4044-0.79205,0.60982-1.6817,0.61068-2.5702h1.0122c0.0193,2.2614-1.198,4.4816-3.1202,5.6744-1.0485,0.66744-2.2842,1.0193-3.5262,1.0205zm-6.6465-6.6952h1.0122c-0.0247,2.1013,1.2301,4.1496,3.1162,5.0772,0.77675,0.39411,1.6473,0.5981,2.518,0.59778v1.0198c-2.2427,0.0192-4.434-1.2046-5.6115-3.11-0.68017-1.0637-1.0316-2.325-1.0349-3.5848zm6.6465-6.6964v1.0198c-2.0734-0.0247-4.0812,1.2217-5.007,3.072-0.41479,0.80074-0.62652,1.7031-0.62727,2.6041h-1.0122c-0.0194-2.2745,1.2121-4.5067,3.152-5.696,1.042-0.65378,2.2652-0.99887,3.4945-0.99997z' fill='%2321231e'/%3E %3Cpath d='m356.82,152.75c3.3901,0,6.1392,2.7685,6.1392,6.1864,0,3.4167-2.7479,6.1852-6.1392,6.1852s-6.1404-2.7685-6.1404-6.1852,2.7491-6.1864,6.1404-6.1864z' fill='%23FFF'/%3E %3Cpath d='m363.47,158.94h-1.0122c0.0243-2.0891-1.2142-4.126-3.0823-5.062-0.78499-0.40473-1.6679-0.61451-2.5508-0.61423v-1.0198c2.2681-0.0199,4.4825,1.2338,5.6509,3.1744,0.65292,1.0518,0.99144,2.286,0.99443,3.5217zm-6.6453,6.6952v-1.0198c2.0849,0.025,4.1041-1.2363,5.022-3.1037,0.40405-0.79264,0.61091-1.6822,0.61094-2.5713h1.0122c0.0196,2.2609-1.1971,4.4804-3.118,5.674-1.049,0.66754-2.2847,1.0196-3.5272,1.0208zm-6.6465-6.6952h1.0122c-0.0248,2.114,1.2456,4.1741,3.1498,5.0944,0.76834,0.3831,1.6262,0.58086,2.4844,0.58054v1.0198c-2.2555,0.0199-4.4585-1.2189-5.6317-3.1418-0.66705-1.0576-1.0113-2.3052-1.0147-3.553zm6.6465-6.6964v1.0198c-2.0858-0.0245-4.1056,1.2375-5.0235,3.106-0.40439,0.79206-0.60982,1.6817-0.61068,2.5702h-1.0122c-0.0195-2.2741,1.2119-4.5063,3.1518-5.6948,1.0403-0.65613,2.2661-0.99889,3.4946-1.0012z' fill='%2321231e'/%3E %3Cpath d='m368.79,147.09c3.3913,0,6.1404,2.7685,6.1404,6.1864,0,3.4167-2.7479,6.1852-6.1404,6.1852-3.3901,0-6.1392-2.7685-6.1392-6.1852,0-3.4179,2.7479-6.1864,6.1392-6.1864z' fill='%23FFF'/%3E %3Cpath d='m375.43,153.28h-1.0122c0.0254-2.1145-1.2453-4.1749-3.1496-5.0957-0.76834-0.38311-1.6262-0.58086-2.4844-0.58054v-1.0198c2.2555-0.02,4.4585,1.2188,5.6317,3.1417,0.66602,1.0589,1.012,2.3052,1.0146,3.5543zm-6.6465,6.6952v-1.0198c2.0854,0.0253,4.1049-1.2362,5.0232-3.1038,0.40414-0.79262,0.61077-1.6822,0.61074-2.5713h1.0122c0.02,2.2736-1.2111,4.5051-3.15,5.6939-1.0428,0.65391-2.266,1.0001-3.4961,1.001zm-6.6453-6.6952h1.0122c-0.0244,2.0887,1.2143,4.125,3.0821,5.0608,0.78499,0.40471,1.6679,0.6145,2.5508,0.61422v1.0198c-2.2682,0.0198-4.4825-1.2336-5.6513-3.1741-0.65256-1.0513-0.99118-2.2851-0.99378-3.5207zm6.6453-6.6964v1.0198c-2.0727-0.0248-4.0801,1.2214-5.0056,3.0709-0.41428,0.80141-0.62746,1.7036-0.62739,2.6052h-1.0122c-0.0198-2.2739,1.2111-4.5056,3.1497-5.6956,1.0424-0.6538,2.2657-0.99959,3.4954-1.0004z' fill='%2321231e'/%3E %3Cpath d='m338.16,169.49c3.3913,0,6.1404,2.7685,6.1404,6.1864,0,3.4155-2.7491,6.1852-6.1404,6.1852-3.3901,0-6.1392-2.7685-6.1392-6.1852,0-3.4179,2.7479-6.1864,6.1392-6.1864z' fill='%23FFF'/%3E %3Cpath d='m344.8,175.68h-1.0122c0.0254-2.1145-1.2453-4.1749-3.1496-5.0956-0.7683-0.38323-1.6262-0.58096-2.4844-0.58064v-1.0198c2.2555-0.0198,4.4585,1.2188,5.6317,3.1418,0.66587,1.0589,1.0122,2.3051,1.0146,3.5543zm-6.6465,6.6952v-1.0198c2.0733,0.0242,4.081-1.2219,5.007-3.072,0.41458-0.80038,0.62624-1.7023,0.62709-2.603h1.0122c0.0193,2.2739-1.2126,4.5058-3.1523,5.6941-1.0404,0.65545-2.2656,0.9986-3.494,1.0007zm-6.6453-6.6952h1.0122c-0.024,2.0887,1.2144,4.125,3.0823,5.0608,0.78498,0.40474,1.6679,0.61452,2.5508,0.61424v1.0198c-2.2682,0.0198-4.4825-1.2336-5.6513-3.1741-0.65285-1.0513-0.99076-2.2856-0.99397-3.5207zm6.6453-6.6964v1.0198c-2.0726-0.0248-4.0801,1.2214-5.0055,3.0709-0.4143,0.80141-0.62741,1.7036-0.6275,2.6052h-1.0122c-0.0197-2.2739,1.2113-4.5056,3.1498-5.6956,1.0424-0.65379,2.2656-0.99959,3.4954-1.0004z' fill='%2321231e'/%3E %3Cpolygon points='409.61,280.14,431.38,267.54,454.53,277.39,432.76,290' transform='matrix(1.0106622,0,0,1.0182434,-5.1283744,-6.1909008)' fill='%23edb92e'/%3E %3Cpath d='m431.11,266.67-22.003,12.832-0.50613-0.88274,22.003-12.832,0.45122-0.0277,0.0549,0.9104zm-0.50613-0.88274,0.21845-0.12748,0.23277,0.0997-0.45122,0.0277zm23.447,10.945-23.392-10.035,0.39631-0.93807,23.392,10.035,0.0549,0.91041-0.45122,0.0277zm0.39631-0.93807,0.93108,0.39928-0.87617,0.51114-0.0549-0.91042zm-22.456,12.861,22.005-12.833,0.50613,0.88276-22.005,12.833-0.45122,0.0277-0.0549-0.91041zm0.50613,0.88274-0.21845,0.12749-0.23277-0.0997,0.45122-0.0277zm-23.445-10.947,23.39,10.036-0.39631,0.93807-23.39-10.036-0.0549-0.9104,0.45122-0.0277zm-0.39631,0.93807-0.93108-0.39929,0.87617-0.51112,0.0549,0.91041z' fill='%2321231e'/%3E %3Cpath d='m431.13,270.65c5.6414-0.34757,10.401,2.4426,10.631,6.2309,0.22918,3.7896-4.1576,7.1425-9.7979,7.4901-5.6402,0.34757-10.4-2.4426-10.63-6.2309-0.23038-3.7896,4.1564-7.1426,9.7967-7.4901z' fill='%23c6363c'/%3E %3Cpath fill='%2321231e' d='m442.26,276.85c-0.33663,0.0208-0.67327,0.0417-1.0099,0.0625-0.11067-1.89705-1.53793-3.4232-3.12645-4.30807-2.10372-1.18449-4.57799-1.58605-6.96851-1.44518-0.0207-0.33913-0.0414-0.67827-0.0621-1.0174,3.07128-0.17538,6.32587,0.47814,8.77602,2.42641,1.31073,1.04785,2.29378,2.57629,2.39094,4.28174zm-10.272,8.0301c-0.0207-0.33913-0.0414-0.67827-0.0621-1.0174,2.80968-0.18622,5.70025-1.12047,7.72544-3.14926,0.98778-0.99786,1.69112-2.36835,1.59874-3.80088,0.33663-0.0208,0.67327-0.0417,1.0099-0.0625,0.13581,2.09365-1.08228,4.03638-2.67826,5.2969-2.13781,1.7186-4.88606,2.55648-7.59372,2.73314zm-11.166-6.7084c0.33663-0.0208,0.67327-0.0417,1.0099-0.0625,0.10885,1.87832,1.51266,3.39564,3.08095,4.28273,2.11303,1.20326,4.60549,1.61284,7.01283,1.47053,0.0207,0.33913,0.0414,0.67827,0.0621,1.0174-3.07097,0.17544-6.32499-0.47816-8.77482-2.4263-1.31073-1.04797-2.29368-2.57596-2.39096-4.28186zm10.271-8.0301c0.0207,0.33913,0.0414,0.67827,0.0621,1.0174-2.80965,0.18633-5.70028,1.12043-7.72544,3.14926-0.98713,0.99808-1.69176,2.36831-1.59765,3.80088-0.33663,0.0208-0.67327,0.0417-1.0099,0.0625-0.13845-2.1119,1.10221-4.06761,2.71756-5.32951,2.13291-1.69663,4.86151-2.52476,7.55333-2.70053z'/%3E %3Cpath d='m382.38,269.85,23.776,9.074-19.628,13.224c-5.0875-1.7042-9.1222-19.12-4.1481-22.298z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m405.98,279.4c-7.92533-3.02467-15.8507-6.04933-23.776-9.074,0.21782-0.26484,0.14943-1.16498,0.62885-0.84918,7.83508,2.99022,15.6702,5.98045,23.5053,8.97067-0.005,0.39978,0.34169,1.07978-0.33034,0.94938l-0.0278,0.003v-0.00007zm0.35811-0.9525c0.26314,0.17753,1.29242,0.26716,0.61641,0.55245-0.49084,0.50826-0.61013,0.21203-0.59614-0.37276-0.007-0.0599-0.0135-0.11979-0.0203-0.17969zm-20.088,13.277c6.54267-4.408,13.0853-8.816,19.628-13.224,0.0872,0.33228,0.85434,0.79979,0.32071,1.00858-6.46256,4.35402-12.9251,8.70805-19.3877,13.0621-0.61722,0.2997-0.46235-0.41329-0.55505-0.80157l-0.006-0.045v-0.00005zm0.56104,0.84666zm-4.2496-23.198c-0.004,0.29311-0.6705,1.09603-0.0698,0.92318,0.31022-0.008-0.56365,0.46333-0.62724,0.74742-1.18154,1.73471-1.2569,3.94105-1.23285,5.97116,0.18317,3.87287,1.11376,7.74339,2.88697,11.2008,0.76536,1.35775,1.6644,2.83575,3.17209,3.4485-0.2038,0.26517-0.11085,1.19131-0.58598,0.85213-1.77498-0.82109-2.84185-2.60054-3.70808-4.27432-1.72776-3.57007-2.65433-7.52524-2.78049-11.4855-0.0138-2.24138,0.16911-4.69031,1.59518-6.52481,0.37405-0.38327,0.75895-0.90636,1.35022-0.85854zm-0.45002,0.0458c0.38906-0.2638,0.54986,0.0593,0,0.0001v-0.0001zm0.27096,0.43055zm-0.27096-0.43055c0.38906-0.2638,0.54986,0.0593,0,0.0001v-0.0001z'/%3E %3Cpath d='m382.83,274.26c5.6211-0.57727,10.49,2.0168,10.872,5.792,0.38198,3.7775-3.8676,7.3061-9.4887,7.8834-3.6551,0.37522-5.9279-2.8455-6.323-6.2598-0.39631-3.4131,1.0851-7.0199,4.9395-7.4156z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='m394.21,280c-0.33503,0.0345-0.67007,0.0689-1.0051,0.10342-0.17586-1.7771-1.51447-3.19884-3.02146-4.02596-2.20459-1.22507-4.81264-1.55539-7.29699-1.31142-0.0342-0.33753-0.0684-0.67507-0.10266-1.0126,2.9357-0.29116,6.05547,0.17931,8.54542,1.83879,1.50488,0.99988,2.70248,2.56777,2.88079,4.40777zm-9.9399,8.4414c-0.0342-0.33753-0.0684-0.67507-0.10266-1.0126,2.7073-0.29286,5.44855-1.2804,7.39222-3.24752,1.05366-1.06606,1.80559-2.54703,1.64535-4.07781,0.33503-0.0345,0.67007-0.069,1.0051-0.10343,0.20782,1.95861-0.7883,3.85349-2.19493,5.15775-2.08965,1.96179-4.9297,2.98545-7.74508,3.28361zm-6.8769-6.7072c0.33503-0.0393,0.67007-0.0786,1.0051-0.11787,0.2382,1.99128,1.13519,4.04604,2.87126,5.16322,0.85371,0.54547,1.89545,0.75564,2.89796,0.64942,0.0342,0.33753,0.0684,0.67507,0.10266,1.0126-1.72233,0.20632-3.50238-0.46201-4.67819-1.73392-1.2798-1.33877-1.9801-3.15349-2.19879-4.97345zm5.3907-7.9808c0.0342,0.33753,0.0684,0.67507,0.10266,1.0126-1.47758,0.12303-2.88612,0.95404-3.63048,2.24907-0.82226,1.37006-1.03441,3.03311-0.85802,4.60134-0.33503,0.0393-0.67007,0.0786-1.0051,0.11786-0.25733-2.22809,0.22844-4.68178,1.83687-6.3303,0.93315-0.96599,2.2273-1.52055,3.55407-1.65057z'/%3E %3Cpath d='m457.46,280.42c1.7631,0,3.1931,1.4396,3.1931,3.2171,0,1.7763-1.43,3.2159-3.1931,3.2159s-3.1919-1.4396-3.1919-3.2159c0-1.7775,1.4288-3.2171,3.1919-3.2171z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m461.16,283.63h-1.0123c0.0181-1.09046-0.69927-2.14339-1.72005-2.52663-0.30697-0.11995-0.63691-0.18095-0.96643-0.17986v-1.0198c1.19461-0.008,2.36388,0.61312,3.03596,1.59879,0.4323,0.61988,0.66297,1.37555,0.66282,2.1275zm-3.6993,3.7258v-1.0198c1.08922,0.0176,2.13175-0.71222,2.50723-1.7314,0.11948-0.30978,0.18006-0.64204,0.17885-0.974h1.0122c0.008,1.20516-0.60989,2.39095-1.60619,3.07013-0.60913,0.42684-1.35303,0.65539-2.09209,0.65507zm-3.6981-3.7258h1.0122c-0.0175,1.08935,0.69781,2.14269,1.71845,2.52507,0.30696,0.12009,0.63677,0.18138,0.96634,0.18013v1.0198c-1.20864,0.008-2.39157-0.62805-3.05911-1.63399-0.41654-0.61261-0.6398-1.35519-0.63788-2.09101zm3.6981-3.727v1.0198c-1.05127-0.0158-2.06174,0.66157-2.46506,1.62937-0.14608,0.33885-0.22176,0.70781-0.22002,1.07683h-1.0122c-0.009-1.25103,0.6586-2.48078,1.71868-3.14701,0.58536-0.37856,1.28594-0.58026,1.9786-0.57899z'/%3E %3Cpath d='m408.71,283.14c1.7631,0,3.1931,1.4396,3.1931,3.2171,0,1.7763-1.43,3.2159-3.1931,3.2159s-3.192-1.4396-3.192-3.2159c0-1.7775,1.4289-3.2171,3.192-3.2171z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m412.41,286.36h-1.0122c0.0179-1.08318-0.68922-2.13028-1.70025-2.51886-0.31243-0.12523-0.64944-0.18869-0.98594-0.18764v-1.0198c1.19461-0.008,2.36389,0.61312,3.03598,1.59879,0.4319,0.61971,0.66406,1.3764,0.66241,2.12751zm-3.6993,3.7258v-1.0198c1.0892,0.0175,2.13187-0.71223,2.50743-1.73139,0.11941-0.3098,0.18022-0.64203,0.17895-0.974h1.0123c0.008,1.20519-0.61017,2.3909-1.6064,3.07013-0.6093,0.42682-1.35243,0.65532-2.09228,0.65506zm-3.6981-3.7258h1.0122c-0.0175,1.08938,0.69787,2.14268,1.71846,2.52517,0.30695,0.12008,0.63676,0.18137,0.96632,0.18012v1.0198c-1.20864,0.008-2.39157-0.62806-3.0591-1.634-0.41655-0.61267-0.63978-1.35499-0.63788-2.09109zm3.6981-3.727v1.0198c-1.05123-0.0158-2.06183,0.66146-2.4649,1.6294-0.14597,0.33886-0.22142,0.70784-0.21978,1.0768h-1.0122c-0.009-1.25103,0.65862-2.48078,1.71869-3.14702,0.58502-0.37855,1.28701-0.58036,1.97819-0.57898z'/%3E %3Cpath d='m406.99,268.29c1.7631,0,3.1932,1.4408,3.1932,3.2171s-1.4301,3.2171-3.1932,3.2171-3.1919-1.4408-3.1919-3.2171,1.4288-3.2171,3.1919-3.2171z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m410.69,271.51h-1.0122c0.0179-1.08332-0.69016-2.12948-1.70043-2.51885-0.31243-0.12524-0.64944-0.1887-0.98594-0.18765v-1.0198c1.20917-0.009,2.39166,0.62887,3.05963,1.63473,0.41748,0.6126,0.6395,1.35442,0.63894,2.09157zm-3.6993,3.727v-1.0198c1.0827,0.0179,2.11836-0.70368,2.50012-1.71275,0.12455-0.3153,0.18728-0.65475,0.18626-0.99365h1.0122c0.009,1.23666-0.6436,2.45208-1.68333,3.12296-0.59298,0.39474-1.30674,0.60343-2.01525,0.60324zm-3.6981-3.727h1.0122c-0.0176,1.0896,0.6978,2.14343,1.71846,2.52627,0.30694,0.12009,0.63675,0.18138,0.96632,0.18002v1.0198c-1.20191,0.008-2.37831-0.62102-3.04707-1.61798-0.42429-0.61488-0.65142-1.36632-0.64991-2.10811zm3.6981-3.727v1.0198c-1.05122-0.0162-2.06044,0.66185-2.46444,1.62869-0.14655,0.339-0.22206,0.70843-0.22063,1.07771h-1.0122c-0.009-1.24347,0.65093-2.46525,1.69983-3.13444,0.58928-0.38716,1.29679-0.5919,1.99744-0.59176z'/%3E %3Cpath d='m457.34,266.19c1.7631,0,3.1919,1.4396,3.1919,3.2159,0,1.7775-1.4288,3.2171-3.1919,3.2171-1.7643,0-3.1931-1.4396-3.1931-3.2171,0-1.7763,1.4288-3.2159,3.1931-3.2159z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m461.04,269.41h-1.0122c0.0172-1.08218-0.6883-2.12923-1.69903-2.51716-0.31248-0.12516-0.64929-0.18912-0.98586-0.18784v-1.0198c1.20863-0.008,2.39161,0.62791,3.0591,1.63391,0.41648,0.61253,0.63997,1.35543,0.63799,2.09089zm-3.6981,3.727v-1.0198c1.08186,0.017,2.11895-0.70238,2.49843-1.71274,0.12498-0.3152,0.18744-0.65474,0.18636-0.99365h1.0122c0.009,1.25091-0.65864,2.48081-1.71868,3.14701-0.58518,0.37868-1.28643,0.58004-1.97831,0.57918zm-3.6993-3.727h1.0122c-0.0175,1.08258,0.68778,2.13033,1.69902,2.51845,0.31278,0.12551,0.65012,0.18906,0.98705,0.18774v1.0198c-1.24816,0.009-2.46903-0.6708-3.12342-1.73255-0.37702-0.59165-0.57599-1.29737-0.57485-1.99344zm3.6993-3.7258v1.0198c-1.08189-0.0173-2.11911,0.70165-2.49962,1.71153-0.12448,0.31535-0.1877,0.6546-0.18646,0.99356h-1.0122c-0.009-1.25083,0.65876-2.48113,1.71998-3.1458,0.58499-0.37962,1.28642-0.57995,1.9783-0.57909z'/%3E %3Cpath d='m370.93,237.39c2.4172-0.74323,6.1953,4.6362,7.0941,4.5436,1.1889-3.0764-1.2367-10.433-5.5328-16.257-2.9186-0.9585-3.18-2.8479-3.7828-7.2303-0.18026-1.3109-2.6798-0.4077-2.7252,1.8232-0.0502,2.3909-0.23397,3.715,0.29722,5.7559,0.20891,0.80457,0.0931,1.5755-0.79858,2.3103,4.5504,1.8148,5.6677,4.0397,5.448,9.056v-0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m377.56,241.75c0.26209,0.14036,0.80292,0.24169,0.89702,0.40557-0.23235,0.26071-0.56516,0.38209-0.87915,0.17624-1.06507-0.64691-1.84858-1.65372-2.78534-2.46238-0.94744-0.82377-1.9237-1.78182-3.19981-2.02916-0.41056,0.0666-0.62759,0.003-0.65881-0.45942-0.25221-0.40882-0.0547-0.60401,0.38943-0.56315,1.42116-0.006,2.59108,0.96733,3.62734,1.83171,1.04307,0.86959,1.92264,1.92621,3.01159,2.73931,0.22645-0.006-0.37045,0.27574-0.40227,0.36128zm0.94302,0.37042c-0.0441,0.45372-0.69245,0.35098-0.0982,0.075,0.0325-0.0246,0.0657-0.0506,0.0982-0.075zm-6.1607-15.958c0.13039-0.27971,0.18037-0.80509,0.35966-0.93541,0.49825,0.39446,0.77476,1.01077,1.15765,1.51333,2.14008,3.26704,3.87434,6.86033,4.69345,10.6961,0.28898,1.53595,0.48598,3.17848-0.0499,4.68395-0.28143-0.15422-0.76481-0.21439-0.92454-0.42528,0.50327-1.61222,0.15408-3.33745-0.21807-4.94017-1.02264-3.89207-2.90913-7.52648-5.26788-10.7729,0.0832,0.0601,0.16636,0.12042,0.24963,0.1804zm0.31275-0.96933zm-4.4406-6.6759c0.31858-0.003,0.77513-0.18889,1.01068-0.0822,0.26904,1.67922,0.3599,3.44117,1.11691,4.99251,0.45096,0.9115,1.36887,1.47318,2.31259,1.7655-0.13579,0.29008-0.1697,0.78459-0.36744,0.95035-1.34597-0.40363-2.55153-1.35732-3.05546-2.69513-0.6256-1.56618-0.76645-3.2788-1.01728-4.93107zm-1.7177,1.7643c-0.31372-0.0475-0.798,0.0631-1.00905-0.0795,0.017-1.39355,1.11889-2.86235,2.58871-2.86772,0.57584,0.00062,1.08578,0.47196,1.14048,1.04356-0.32214,0.007-0.76131,0.18005-1.0134,0.0878-0.15203-0.25955-0.56034-0.0324-0.7592,0.07-0.5973,0.36383-0.93941,1.05893-0.94754,1.74588zm0.28052,5.6164c-0.31537,0.0407-0.74808,0.27974-0.99287,0.20122-0.53294-1.90312-0.34218-3.89189-0.29896-5.83924,0.31484,0.0475,0.7958-0.0632,1.01064,0.0796-0.039,1.85607-0.23431,3.74484,0.28119,5.55845zm-1.1018,1.9651c-0.12262,0.25672-0.27938,0.82022-0.38124,0.89046,0.0288-0.30018-0.27826-0.72297,0.01-0.92779,0.48487-0.39873,0.69041-1.07281,0.4946-1.6711,0.31544-0.0408,0.74794-0.27971,0.99296-0.20124,0.30371,1.02423-0.14039,2.1486-0.98413,2.77716-0.0435-0.28829-0.0916-0.5834-0.1322-0.86749zm-0.37243,0.94768c-0.192-0.15772-1.03527-0.21343-0.62116-0.46607,0.30602-0.29652,0.59638-0.55196,0.55794,0.0555,0.0211,0.13686,0.0421,0.27371,0.0632,0.41057zm5.1281,8.5821c0.27513-0.00092,0.87397,0.002,0.95432-0.001-0.28124-0.0787-0.86629,0.12878-0.94886-0.1372,0.0631-2.00607,0.0366-4.22375-1.24695-5.88733-0.97906-1.24796-2.44795-1.97098-3.88646-2.55622,0.15364-0.28108,0.21803-0.77206,0.42591-0.92555,1.98211,0.78546,4.01539,1.95641,4.94472,3.97255,0.81406,1.72655,0.83776,3.68723,0.769,5.55797-0.33722-0.008-0.67447-0.0151-1.01168-0.0229zm1.0122-0.001c-0.33507,0.002-0.67713,0.002-1.0122,0,0.20068-0.35461,0.41304-0.63106,0.72959-0.21048,0.0942,0.0702,0.18862,0.14039,0.28261,0.21048zm-1.0122,0c-0.26067-0.39086,0.62528-0.67794,0.18666-0.25387-0.0622,0.0846-0.12444,0.16925-0.18666,0.25387z'/%3E %3Cpath d='m368.78,218.51c-0.4166,1.009-0.54312,1.8352-0.64339,3.3674-0.0764,1.1678,0.34975,2.261,1.0922,3.2291,0.74486,0.97294,1.8108,1.8292,3.0081,2.5244,0.74128,0.43176,1.5924,1.6248,2.2656,2.9814,0.66966,1.3494,1.1603,2.8719,1.1877,3.9543,0.0955,3.5803,0.78904,6.7084,2.4172,7.3253,1.0648,0.40409,1.4909,0.34155,2.3158,0.14913-0.23278-0.64342-0.14444-1.549-0.71861-2.4462-0.73889-1.157-1.3871-2.4859-1.4456-3.6488-0.0513-0.9044-0.47509-1.5081-0.12533-3.2905,0.2256-1.1546,0.97285-1.5911,0.84035-2.6554-0.25665-2.0625-1.8741-6.0205-4.2484-6.0205-2.3408-0.001-3.4343-0.25376-4.6459-3.3698-0.41183-1.0595-0.95018-1.5695-1.2999-2.0998z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m368.64,221.91c-0.31387-0.0605-0.79436,0.0255-1.0063-0.12453,0.0721-1.17881,0.20225-2.37746,0.6765-3.47175,0.27776,0.15941,0.75873,0.2339,0.91212,0.44528-0.42283,0.99528-0.51742,2.08478-0.58232,3.151zm0.98718,2.884c-0.2745,0.16402-0.57757,0.54874-0.83455,0.57738-0.76601-0.99981-1.25497-2.2557-1.16193-3.52853,0.31385,0.0605,0.79438-0.0255,1.00629,0.12453-0.0593,1.03021,0.37247,2.02514,0.99019,2.82662zm2.8613,2.3945c-0.19235,0.25726-0.32829,0.72829-0.55547,0.85355-1.17184-0.69024-2.27125-1.54208-3.10542-2.62521,0.27488-0.16432,0.57682-0.54816,0.83511-0.57782,0.76307,0.97142,1.76464,1.73071,2.82578,2.34948zm2.465,3.1954c-0.301,0.10713-0.67245,0.42532-0.93032,0.40325-0.53228-0.99456-1.09534-2.0543-2.0404-2.71558,0.19217-0.25696,0.32865-0.72889,0.55522-0.8531,1.11132,0.75938,1.8077,1.99851,2.4155,3.16543zm1.2402,4.1684c-0.31785-0.0313-0.78635,0.0991-1.01237-0.0308-0.0906-1.294-0.57654-2.52365-1.13213-3.68267,0.30075-0.10701,0.67296-0.42556,0.92996-0.40306,0.61334,1.28887,1.14693,2.67762,1.21454,4.11651zm2.0902,6.8624c-0.14745,0.28351-0.20638,0.77408-0.40841,0.9299-1.28978-0.56771-1.81751-2.01949-2.15443-3.28652-0.36551-1.46353-0.49324-2.975-0.5372-4.47923,0.31736,0.0313,0.78732-0.0992,1.01167,0.0308,0.0891,1.95776,0.2125,3.99724,1.09023,5.78518,0.23204,0.41789,0.53816,0.83882,0.99814,1.01986zm1.6628,0.79978c0.27897-0.0745,0.77978-0.34153,0.92305-0.29826-0.183,0.26794-0.23347,0.71533-0.63926,0.68796-0.76925,0.19721-1.57943,0.067-2.30314-0.2351,0.14833-0.28575,0.20463-0.7696,0.40972-0.93319,0.621,0.27607,1.32146,0.31212,1.96941,0.11089-0.11902,0.22024-0.24471,0.45822-0.35978,0.6677zm0.95019-0.34877c0.18998,0.36363,0.27439,0.66998-0.25093,0.64548-0.26579,0.12832,0.25104-0.55934,0.25093-0.64548zm-1.6186-1.9964c0.28301-0.18409,0.56829-0.36696,0.8499-0.55181,0.52679,0.753,0.54377,1.69119,0.7685,2.54786-0.31057,0.072-0.71713,0.34651-0.96899,0.29459-0.23493-0.75788-0.19056-1.61082-0.64941-2.29064zm-1.5256-3.8954c0.33524-0.0164,0.68133-0.0443,1.0099-0.0537,0.0979,1.24116,0.72159,2.36064,1.3652,3.39843-0.28739,0.13932-0.6224,0.49646-0.88062,0.50239-0.72643-1.16633-1.40527-2.46395-1.49448-3.84712zm1.0099-0.0577zm-1.1268-3.3602c0.30372,0.10049,0.79101,0.0774,0.98235,0.25355-0.21311,0.90723-0.0934,1.83837,0.10502,2.735,0.20515,0.47018-0.2601,0.39021-0.5909,0.40758-0.36983,0.12713-0.42503-0.0871-0.433-0.40268-0.23732-0.98394-0.28293-2.0022-0.0635-2.99345zm0.8356-2.4931c0.31775-0.00051,0.77659-0.17773,1.00824-0.0704,0.17264,1.02972-0.66109,1.8089-0.85014,2.76078-0.3028-0.10031-0.79279-0.0778-0.98102-0.25327,0.10842-0.78367,0.71741-1.38796,0.83027-2.16263,0.009-0.0914,0.003-0.18371-0.007-0.27448zm-3.747-5.5743c0.0386-0.31831-0.077-0.79934,0.0573-1.01675,1.5371,0.0496,2.64688,1.34392,3.3533,2.58399,0.66979,1.19937,1.14755,2.51679,1.33891,3.87964-0.31932,0.00069-0.77347,0.17737-1.01052,0.0707-0.28832-1.70092-0.94753-3.39695-2.11469-4.69006-0.42901-0.44134-0.98606-0.82862-1.62426-0.8275zm-5.1162-3.6946c0.31323-0.12402,0.62896-0.24634,0.94063-0.37142,0.45338,1.08833,0.95664,2.39625,2.16179,2.82989,0.64725,0.2156,1.33927,0.21035,2.01376,0.2156-0.0387,0.32019,0.0771,0.79558-0.0573,1.01954-1.26991,0.024-2.70267-0.11714-3.60218-1.12683-0.68023-0.72469-1.09564-1.65333-1.45666-2.56678zm-0.36287-2.089c-0.25321-0.12659-0.80745-0.29895-0.87641-0.39754,0.31207,0.0455,0.78258-0.25529,0.95403,0.0956,0.48606,0.6221,0.95367,1.27274,1.2266,2.02066-0.30991,0.0795-0.70508,0.36187-0.96295,0.3176-0.26692-0.73292-0.78471-1.32383-1.22838-1.95118,0.29501-0.0283,0.59546-0.0575,0.88711-0.0851zm-0.93349-0.39205c0.1478-0.20504,0.24757-0.91237,0.4272-0.7846,0.0632,0.23353,0.71622,0.74911,0.23261,0.72115-0.21994,0.0212-0.43987,0.0423-0.65981,0.0635zm0.46673,0.19602zm-0.46673-0.19602c0.1478-0.20504,0.24757-0.91237,0.4272-0.7846,0.0632,0.23353,0.71622,0.74911,0.23261,0.72115-0.21994,0.0212-0.43987,0.0423-0.65981,0.0635z'/%3E %3Cpath d='m359.96,227.08c0.63505-0.49068,1.405-0.85268,2.1284-1.1353,1.2307-0.48106,2.5438-0.55442,3.8115-0.17078,5.6128,1.6969,8.0706,11.668,1.9207,14.064-1.2116,0.14793-2.3289-0.9477-3.4164-3.3542-1.282-3.1846-2.6452-5.3951-4.1063-6.7469-0.89527-1.1293-0.9251-2.0854-0.33901-2.6566h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m361.91,225.47c0.12176,0.3167,0.24351,0.6334,0.36527,0.9501-0.70426,0.27714-1.39959,0.60173-2.0031,1.0641-0.20532-0.26939-0.41063-0.53879-0.61595-0.80818,0.67821-0.52265,1.4608-0.89446,2.25378-1.20602zm4.1397-0.184c-0.0971,0.32552-0.19417,0.65103-0.29125,0.97655-1.13423-0.35172-2.38265-0.2786-3.4832,0.1581-0.12176-0.3167-0.24351-0.6334-0.36527-0.9501,1.30901-0.51874,2.79085-0.59987,4.13972-0.18455zm1.8359,15.058c-0.0406-0.33753-0.0812-0.67507-0.12176-1.0126-0.27912,0.0731,0.32263-0.1496,0.42032-0.21483,1.28691-0.64473,2.20863-1.89602,2.53428-3.28843,0.5175-2.18864-0.0319-4.53642-1.18526-6.43468-0.86302-1.41886-2.16437-2.63523-3.77467-3.13132,0.0971-0.32552,0.19417-0.65103,0.29126-0.97655,2.10301,0.64724,3.74417,2.32874,4.72897,4.25335,1.09263,2.15078,1.52576,4.73659,0.76649,7.06537-0.5164,1.60524-1.74506,2.96313-3.30771,3.60527-0.11609,0.0495-0.22599,0.11317-0.35192,0.13442zm0.12175-0.0312zm-4.0681-3.638c0.29957-0.13883,0.67835-0.24362,0.93025-0.40294,0.48068,1.01549,0.99617,2.09065,1.9142,2.78406,0.28213,0.19944,0.63188,0.32218,0.9799,0.276,0.0406,0.33753,0.0812,0.67507,0.12176,1.0126-1.10232,0.14821-2.06973-0.61202-2.68473-1.45314-0.51458-0.68031-0.91078-1.44159-1.26138-2.21658zm0.008,0.0205zm-4.0407-6.641c0.26341-0.21167,0.52682-0.42333,0.79023-0.635-0.0727-0.0891,0.28225,0.26418,0.37842,0.36804,1.73197,1.85476,2.8468,4.17989,3.80192,6.50513-0.31275,0.12748-0.6255,0.25496-0.93825,0.38244-0.90593-2.20666-1.9542-4.41896-3.59421-6.18282-0.13897-0.15308-0.29604-0.28822-0.43811-0.43779zm0.0525,0.0577zm0.004-3.5418v1.0198c0.20409-0.0789,0.45687-0.23205,0.21115,0.0337-0.28853,0.60098,0.12132,1.25386,0.47283,1.73176,0.0754,0.1823-0.33688,0.30624-0.45012,0.46597-0.18978,0.22169-0.36403,0.27647-0.48643-0.028-0.54972-0.7571-0.91423-1.83414-0.39662-2.70104,0.13722-0.27018,0.35858-0.44484,0.64919-0.52219zm-0.35213,0.14431c0.15654-0.23834,0.52864-0.13897,0.0926-0.038-0.0309,0.0127-0.0618,0.0253-0.0926,0.038zm0.35333,0.87553c-0.002-0.3376-0.002-0.6822,0-1.0198,0.10266,0.30467,0.20532,0.60934,0.30798,0.91401-0.10265,0.0352-0.20538,0.0706-0.30798,0.10579zm0.30798-0.10583z'/%3E %3Cpath d='m362.79,227.74c5.3919-2.1046,9.361,8.2261,4.3224,10.189-2.7049,1.0535-2.9628-2.3307-3.488-4.2117-0.70906-2.5412-6.0126-3.9555-0.83439-5.9772z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m367.29,238.4c-0.12176-0.3167-0.24352-0.6334-0.36528-0.9501,0.80213-0.30555,1.45265-0.96865,1.72956-1.78236,0.45034-1.24488,0.27685-2.63116-0.15073-3.85757-0.47186-1.3165-1.29028-2.56906-2.49712-3.31567-0.85572-0.54839-1.96311-0.68449-2.9171-0.32222-0.21016,0.12628-0.18226-0.24425-0.27585-0.36127-0.0705-0.18325-0.1409-0.3665-0.21135-0.54975,0.81907-0.30917,1.72653-0.40947,2.58209-0.19813,1.38175,0.32533,2.51736,1.31614,3.29788,2.47105,1.03923,1.55084,1.60959,3.46088,1.40049,5.33058-0.13452,1.11832-0.63687,2.22769-1.54018,2.92966-0.31434,0.25883-0.68117,0.44282-1.05241,0.60578zm-4.1576-4.5484c0.32469-0.0922,0.64937-0.1844,0.97406-0.2766,0.32491,1.14092,0.44301,2.36788,1.0537,3.40711,0.23166,0.40197,0.67705,0.70193,1.15487,0.623,0.20986-0.0195,0.41239-0.0828,0.60948-0.15499,0.12176,0.3167,0.24352,0.6334,0.36528,0.9501-0.7368,0.30031-1.64789,0.35671-2.312-0.14566-0.81603-0.60018-1.14-1.62058-1.3959-2.55678-0.1642-0.61185-0.28246-1.23538-0.44949-1.84618zm-0.53-6.5905c0.12176,0.3167,0.24351,0.63339,0.36527,0.95009-0.64587,0.27802-1.35401,0.53203-1.82278,1.08119-0.24964,0.31741,0.056,0.68495,0.25812,0.93453,0.87445,0.98927,2.05105,1.76392,2.58528,3.01493,0.0718,0.17543,0.20317,0.3994-0.0877,0.39157-0.25592,0.0727-0.51184,0.14535-0.76776,0.21802-0.29339-0.9026-1.06393-1.52159-1.71806-2.1642-0.5687-0.55769-1.24725-1.141-1.36893-1.97346-0.0841-0.67969,0.38877-1.27104,0.92435-1.62776,0.50179-0.34913,1.06816-0.59932,1.63219-0.82491z'/%3E %3Cpath d='m363.35,229.27c2.6285-1.0247,6.2382,5.1365,2.9484,6.5364-2.2215,0.94529-3.9774-0.29825-4.69-2.1552-0.71384-1.8569-0.10266-3.6621,1.7416-4.3812z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='m366.5,236.28c-0.1313-0.31269-0.26261-0.62537-0.39391-0.93806,0.4619-0.18696,0.83652-0.58784,0.94358-1.08039,0.18305-0.82587-0.0877-1.67761-0.46061-2.41185-0.44427-0.82683-1.07323-1.60437-1.93395-2.01785-0.34714-0.15605-0.75398-0.22259-1.11746-0.0818-0.12175-0.3167-0.24351-0.63339-0.36526-0.95009,0.58487-0.22259,1.24847-0.17661,1.81733,0.0725,0.93312,0.40124,1.66633,1.1664,2.20737,2.01057,0.56679,0.89648,0.96076,1.946,0.91848,3.01887-0.0238,0.7333-0.33146,1.46905-0.90312,1.94201-0.21094,0.18373-0.46067,0.32053-0.71245,0.43612zm-5.3585-2.4402c0.31434-0.12267,0.62868-0.24534,0.94302-0.36801,0.34832,0.91971,1.04747,1.77357,2.02048,2.05413,0.66131,0.19552,1.37644,0.0841,2.00099-0.18386,0.1313,0.31269,0.26261,0.62537,0.39391,0.93806-0.96407,0.41965-2.10391,0.51065-3.08043,0.0792-1.08141-0.4596-1.86585-1.4412-2.27797-2.51956zm2.0305-5.0403c0.12176,0.3167,0.24352,0.6334,0.36528,0.9501-0.75169,0.27785-1.39916,0.8883-1.6076,1.67637-0.19143,0.67408-0.0933,1.39972,0.15485,2.04574-0.31434,0.12267-0.62868,0.24535-0.94302,0.36802-0.42354-1.07932-0.46895-2.35666,0.10012-3.39298,0.40854-0.76792,1.12591-1.33794,1.93037-1.64725zm0.18264,0.47505c-0.0609-0.15835-0.12176-0.3167-0.18264-0.47505,0.0609,0.15835,0.12176,0.3167,0.18264,0.47505z'/%3E %3Cpath d='m400.08,179.66c3.5166,0,6.3672,2.8719,6.3672,6.4149,0,3.5418-2.8505,6.4149-6.3672,6.4149-3.5166,0-6.3672-2.8719-6.3672-6.4149s2.8505-6.4149,6.3672-6.4149z' fill='%23FFF'/%3E %3Cpath d='m406.95,186.07h-1.0122c0.0269-2.1992-1.2954-4.3408-3.2746-5.3-0.79979-0.39878-1.6927-0.60543-2.5861-0.60475v-1.0198c2.3326-0.02,4.6106,1.2607,5.8244,3.2492,0.68633,1.0953,1.0473,2.3839,1.0486,3.6754zm-6.8733,6.9248v-1.0198c2.1696,0.0263,4.2693-1.2872,5.2253-3.2296,0.42015-0.82468,0.63578-1.7502,0.63549-2.6752h1.0122c0.0199,2.3517-1.2544,4.6585-3.2586,5.8897-1.0772,0.67562-2.3441,1.0334-3.6144,1.0349zm-6.8733-6.9248h1.0122c-0.0268,2.1992,1.2955,4.3408,3.2747,5.3,0.79978,0.39881,1.6927,0.60521,2.5861,0.60475v1.0198c-2.3326,0.02-4.6106-1.2607-5.8244-3.2492-0.68639-1.0953-1.0472-2.3839-1.0487-3.6753zm6.8733-6.9249v1.0198c-2.1692-0.0264-4.2688,1.2868-5.2248,3.2285-0.42042,0.82499-0.6362,1.7507-0.6361,2.6761h-1.0122c-0.0196-2.3515,1.2531-4.6597,3.2586-5.8897,1.0773-0.67541,2.3438-1.0338,3.6145-1.0348z' fill='%2321231e'/%3E %3Cpath d='m395.43,169c3.5166,0,6.3672,2.8719,6.3672,6.4161,0,3.543-2.8505,6.4149-6.3672,6.4149-3.5166,0-6.3672-2.8719-6.3672-6.4149,0-3.5442,2.8505-6.4161,6.3672-6.4161z' fill='%23FFF'/%3E %3Cpath d='m402.31,175.42h-1.0123c0.0262-2.1859-1.2784-4.3173-3.2399-5.2834-0.80826-0.41092-1.7145-0.62294-2.6208-0.62248v-1.0198c2.3327-0.0202,4.6104,1.261,5.8244,3.2492,0.68585,1.0969,1.048,2.3836,1.0486,3.6765zm-6.8733,6.9249v-1.0198c2.1692,0.0263,4.2688-1.2868,5.2248-3.2285,0.42041-0.82501,0.63643-1.7507,0.63599-2.6761h1.0123c0.0196,2.3515-1.2531,4.6597-3.2586,5.8897-1.0772,0.67541-2.3438,1.0337-3.6144,1.0348zm-6.8733-6.9249h1.0122c-0.0267,2.1992,1.2956,4.3408,3.2748,5.3,0.79978,0.39879,1.6927,0.60526,2.5861,0.60464v1.0198c-2.3326,0.0201-4.6106-1.2606-5.8244-3.2491-0.68647-1.0953-1.047-2.384-1.0488-3.6753zm6.8733-6.9261v1.0198c-2.1697-0.0263-4.2691,1.2876-5.2253,3.2297-0.41957,0.82525-0.636,1.751-0.63569,2.6764h-1.0122c-0.0201-2.3519,1.2532-4.6604,3.2586-5.8909,1.0773-0.6756,2.3441-1.0335,3.6146-1.035z' fill='%2321231e'/%3E %3Cpath d='m410.68,131.46c3.3913,0,6.1404,2.7685,6.1404,6.1852s-2.7491,6.1864-6.1404,6.1864c-3.3901,0-6.1404-2.7697-6.1404-6.1864s2.7491-6.1852,6.1404-6.1852z' fill='%23FFF'/%3E %3Cpath d='m417.32,137.65h-1.0122c0.0249-2.1141-1.2455-4.1742-3.1497-5.0944-0.76829-0.38324-1.6262-0.58096-2.4844-0.58064v-1.0198c2.2555-0.0199,4.4585,1.2189,5.6317,3.1418,0.66698,1.0577,1.0114,2.305,1.0146,3.5531zm-6.6465,6.6964v-1.0198c2.0858,0.0245,4.1056-1.2375,5.0234-3.106,0.40443-0.79205,0.60972-1.6817,0.61067-2.5702h1.0122c0.0194,2.2741-1.212,4.5064-3.152,5.6948-1.0403,0.65607-2.266,0.99891-3.4944,1.0012zm-6.6465-6.6964h1.0122c-0.0247,2.102,1.2305,4.1506,3.1171,5.0787,0.77624,0.39428,1.6468,0.59699,2.5169,0.59745v1.0198c-2.2429,0.019-4.4344-1.2054-5.6115-3.1112-0.68009-1.0637-1.0318-2.3249-1.0348-3.5848zm6.6465-6.6952v1.0198c-2.0856-0.0248-4.1053,1.2367-5.0235,3.1048-0.40442,0.79205-0.60978,1.6817-0.61057,2.5702h-1.0122c-0.0193-2.2614,1.198-4.4816,3.1202-5.6744,1.0485-0.6675,2.2842-1.0192,3.5261-1.0205z' fill='%2321231e'/%3E %3Cpath d='m400.36,136.18c3.5166,0,6.3672,2.8719,6.3672,6.4149,0,3.5442-2.8505,6.4161-6.3672,6.4161-3.5166,0-6.3672-2.8719-6.3672-6.4161,0-3.543,2.8505-6.4149,6.3672-6.4149z' fill='%23FFF'/%3E %3Cpath d='m407.23,142.59h-1.0123c0.0268-2.1992-1.2955-4.3408-3.2747-5.3-0.79978-0.39882-1.6927-0.60543-2.5861-0.60474v-1.0198c2.3326-0.02,4.6106,1.2607,5.8244,3.2492,0.68638,1.0953,1.0472,2.3839,1.0487,3.6753zm-6.8733,6.9261v-1.0198c2.1564,0.0259,4.2443-1.271,5.2076-3.1947,0.43102-0.83399,0.65397-1.7727,0.65332-2.7111h1.0122c0.0201,2.3519-1.2532,4.6604-3.2586,5.8909-1.0772,0.67547-2.3439,1.0336-3.6145,1.0348zm-6.8733-6.9261h1.0122c-0.0261,2.1859,1.2785,4.3173,3.24,5.2834,0.80829,0.41083,1.7145,0.62315,2.6208,0.62259v1.0198c-2.3327,0.0202-4.6104-1.261-5.8244-3.2492-0.68596-1.0969-1.0479-2.3837-1.0487-3.6766zm6.8733-6.9249v1.0198c-2.1692-0.0263-4.2688,1.2869-5.2248,3.2286-0.42046,0.82498-0.63626,1.7507-0.6359,2.6761h-1.0122c-0.0196-2.3515,1.2531-4.6597,3.2586-5.8897,1.0772-0.67545,2.344-1.0336,3.6143-1.0349z' fill='%2321231e'/%3E %3Cpath d='m392.77,145.25c3.5166,0,6.3672,2.8719,6.3672,6.4161,0,3.543-2.8505,6.4149-6.3672,6.4149-3.5166,0-6.3672-2.8719-6.3672-6.4149,0-3.5442,2.8505-6.4161,6.3672-6.4161z' fill='%23FFF'/%3E %3Cpath d='m399.64,151.66h-1.0122c0.0263-2.1859-1.2783-4.3173-3.2398-5.2834-0.80826-0.41092-1.7145-0.62294-2.6208-0.62248v-1.0198c2.3327-0.0202,4.6104,1.261,5.8244,3.2492,0.68578,1.0969,1.0482,2.3835,1.0484,3.6764zm-6.8733,6.9249v-1.0198c2.1692,0.0263,4.2688-1.2868,5.2248-3.2285,0.42052-0.82496,0.63592-1.7507,0.63568-2.6761h1.0122c0.0196,2.3515-1.2531,4.6597-3.2586,5.8897-1.0771,0.6754-2.3441,1.0337-3.6141,1.0348zm-6.8733-6.9249h1.0122c-0.0265,2.1857,1.2786,4.3162,3.2397,5.2822,0.80826,0.41089,1.7145,0.62292,2.6208,0.62246v1.0198c-2.3326,0.0201-4.6106-1.2606-5.8244-3.2491-0.68617-1.0953-1.0476-2.3838-1.0484-3.6753zm6.8733-6.9261v1.0198c-2.1697-0.0263-4.2691,1.2876-5.2254,3.2297-0.4195,0.82525-0.636,1.751-0.63557,2.6764h-1.0122c-0.0201-2.3519,1.2532-4.6604,3.2586-5.8909,1.0772-0.67557,2.3441-1.0335,3.6145-1.035z' fill='%2321231e'/%3E %3Cpath d='m391.54,156.66c3.5178,0,6.3672,2.8719,6.3672,6.4149s-2.8494,6.4149-6.3672,6.4149c-3.5166,0-6.3672-2.8719-6.3672-6.4149s2.8505-6.4149,6.3672-6.4149z' fill='%23FFF'/%3E %3Cpath d='m398.41,163.08h-1.0122c0.0261-2.186-1.2787-4.316-3.2396-5.2828-0.80866-0.40993-1.7148-0.62273-2.6212-0.62192v-1.0198c2.3462-0.0205,4.6365,1.2759,5.8458,3.283,0.67214,1.0883,1.026,2.3634,1.0273,3.6415zm-6.8733,6.9248v-1.0198c2.1825,0.0271,4.2942-1.303,5.2424-3.2635,0.40884-0.81623,0.61864-1.7288,0.6183-2.6412h1.0122c0.0214,2.4236-1.3346,4.8012-3.4437,5.9998-1.0344,0.60654-2.2316,0.92283-3.4293,0.92471zm-6.8733-6.9248h1.0122c-0.027,2.1992,1.2954,4.3408,3.2746,5.3,0.79978,0.39884,1.6927,0.60539,2.5861,0.60485v1.0198c-2.3326,0.0201-4.6106-1.2606-5.8244-3.2491-0.68648-1.0953-1.0471-2.3841-1.0486-3.6756zm6.8733-6.9249v1.0198c-2.1692-0.0262-4.2688,1.2869-5.2248,3.2286-0.42041,0.82499-0.6363,1.7507-0.636,2.6761h-1.0122c-0.0196-2.3515,1.2531-4.6597,3.2586-5.8897,1.0772-0.67563,2.3442-1.0333,3.6144-1.0349z' fill='%2321231e'/%3E %3Cpath d='m474.41,198.02c-2.7013-5.0307-5.5662-8.2478-8.5958-9.6501,4.1756-13.155,5.158-30.146,2.7025-51.096-0.24828-3.1305-1.0206-4.4787-2.2131-4.457-1.0457,0.0193-1.6783,1.6164-1.781,5.2207,0.75919,11.525,1.6927,21.606,1.1698,30.165-0.46792,7.6428-2.262,13.996-4.2376,21.155-0.27335,0.99339,0.43093,1.7751,3.8688,3.7126,2.5366,1.4432,4.1338,3.2171,4.6662,5.0728,0.73531-0.29585,1.2068-0.20686,1.4718-0.12989,2.5474,0.73843,3.6229,0.53758,2.9484,0.006v0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m465.33,188.22c1.37942,0.84479,0.31363-0.67394,1.28681-0.01,3.76061,2.12291,6.20398,5.87985,8.2353,9.57188-0.87222,0.8986-1.20795,0.009-1.59666-0.78278-1.90541-3.21156-4.20476-6.4853-7.65567-8.16132-0.0899-0.20605-0.17985-0.41211-0.26978-0.61816zm0.26978,0.61816zm2.4101-51.518c1.12748-0.4471,1.13948,0.34547,1.15895,1.25699,1.56937,14.5214,1.94753,29.383-1.20325,43.7277-0.46846,2.09789-1.02767,4.17533-1.67337,6.22559-1.22934-0.0134-0.86137-0.85442-0.54607-1.67675,3.91271-13.5333,4.09303-27.8283,3.03051-41.7787-0.20758-2.58945-0.4685-5.17452-0.76677-7.75483zm0.001,0.0193zm-1.701-4.0072c-0.19093-0.76289,0.0524-1.3177,0.82729-0.83763,1.59379,0.95796,1.67718,3.09014,1.87987,4.74411-1.07379,0.41608-1.13182-0.33938-1.1566-1.21707-0.2164-0.91076-0.35969-2.57892-1.55056-2.68941zm-1.2856,4.6771c-1.02215,0.36256-1.15101-0.22633-0.95725-1.09606,0.17758-1.51285,0.17263-3.41719,1.52306-4.40726,0.74295-0.58735,0.86282,0.30832,0.66959,0.8287-0.93085,0.468-0.90426,1.78623-1.0958,2.68657-0.0792,0.61762-0.12483,1.52458-0.1396,1.98805zm-1.0099,0.0673zm2.1797,30.162c-1.23365,0.30441-1.0192-0.66798-0.93435-1.54611,0.33379-9.55667-0.66155-19.0888-1.24515-28.6163,1.18603-0.46038,1.09872,0.53314,1.10948,1.41694,0.59843,9.56475,1.58916,19.1546,1.07002,28.7455zm-4.2555,21.259c-1.20299,0.0323-0.90558-0.78215-0.60808-1.59939,1.80387-6.45388,3.4768-13.0046,3.85379-19.7224,1.18731-0.28827,1.04352,0.59868,0.90828,1.46297-0.53653,6.77042-2.339,13.3422-4.15399,19.8588zm3.63,3.1329c-0.24124,1.05666-0.83274,0.86412-1.51798,0.29819-1.20654-0.82645-2.99228-1.55125-3.15939-3.20158-0.25332-0.78259,1.25767-0.45275,1.03026,0.1456,0.7578,1.33978,2.39775,1.94414,3.64711,2.75779zm-0.001-0.001zm4.2317,5.0451c0.76811,1.01675-0.15908,1.11383-0.44816,0.17286-0.78609-1.94114-2.51229-3.31112-4.27885-4.32922,0.24923-1.06711,0.87973-0.82762,1.54569-0.23741,1.69903,1.14774,3.26431,2.70946,3.85486,4.72449-0.22453-0.11019-0.44896-0.22075-0.67354-0.33072zm0.37481,0.94527zm1.4241-1.092c-0.1866,0.38056-0.063,1.16407-0.65363,0.92297-0.38135-0.0622-0.88968,0.42057-0.92103-0.21472-0.56454-0.65372,0.2405-0.75974,0.7515-0.80105,0.27489-0.0146,0.56629,0.009,0.82316,0.0928zm3.3149,0.4955c-1.51257,0.4011-0.52734-0.77183,0.10738-0.0661,0.42231,0.92313-0.85888,1.21724-1.52311,1.0199-0.73933-0.0857-1.46417-0.26529-2.17849-0.4701-0.004-1.10162,0.6533-0.97421,1.46593-0.67914,0.44159,0.11125,1.13843,0.17931,1.46606,0.15529-0.5855,1.01666,0.28797,0.0872,0.66223,0.0402zm-1.0122,0c-0.62826-1.45559,1.18286-0.70396,0.44969-0.22091-0.14989,0.0736-0.29981,0.14726-0.44969,0.22091zm0,0.001c1.32674-0.19986,0.81027,0.29768,0.0276,0.11036l-0.0277-0.11036h0.00008z'/%3E %3Cpath d='m458.4,214.56c1.5649-0.98617,1.8717-0.724,2.3742-1.371,0.64699-0.83223,0.65534-2.1984,0.45242-3.5081-0.81888-5.2844,2.3349-4.5472,5.8825-2.2105,1.7738,1.169,3.5584,3.8822,5.0828,5.2989,1.5244,1.4155,2.7885,1.537,3.1681,2.0962,0.0477,2.0277,0.0573,3.7799,0.0429,4.5725v0.005c0.0144,0.79255,0.006,2.5424-0.0429,4.5701-0.38079,0.55924-1.6449,0.6795-3.1681,2.0962-1.5244,1.4167-3.3089,4.1299-5.0828,5.2977-3.5477,2.338-6.7014,3.074-5.8825-2.2105,0.20172-1.3097,0.19457-2.6759-0.45242-3.5081-0.50254-0.64703-0.80932-0.38484-2.3742-1.371-1.0158-0.63861-1.7774-1.4083-2.2847-2.243-0.50733-0.83583-0.23158-1.7354-0.23158-2.635,0-0.90078-0.27575-1.8004,0.23158-2.635,0.50732-0.83583,1.2689-1.6055,2.2847-2.2441z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m460.37,212.87c1.18548,0.4309,0.46548,1.22528-0.4026,1.44027-0.6942,0.31908-1.65135,1.05561-1.78302-0.22459,0.66418-0.51447,1.57497-0.64672,2.18562-1.21568zm0.34975-3.1161c1.66152-0.73563,1.08592,1.7692,0.95562,2.68595-0.0351,0.98508-0.96484,1.26062-1.22021,0.30612,0.51981-0.90828,0.39262-2.00011,0.26459-2.99207zm6.6596-2.7144c-0.61882,1.79782-2.14069-0.59072-3.31288-0.6057-1.39327-0.84731-2.81313,0.3906-2.46901,1.87803,0.2261,0.819,0.11931,1.74565-0.89471,1.3245-0.19934-1.45513-0.34213-3.47111,1.1983-4.25573,1.69634-0.62165,3.39551,0.43359,4.83575,1.25051,0.21658,0.13231,0.4306,0.26879,0.64255,0.40839zm5.1484,5.3506c-0.82452,1.59132-1.76893-0.63023-2.49459-1.23321-0.97957-1.16938-1.9563-2.37274-3.20769-3.2659,0.56227-1.72221,1.84758,0.36927,2.55418,0.95362,1.06744,1.16575,2.00633,2.448,3.1481,3.54549zm3.3304,2.4582c-0.45016-0.0764-1.03489,0.0857-1.05868,0.19811-0.97156-0.59172-2.08123-1.01326-2.87434-1.84878,0.46757-1.55931,1.54561,0.21739,2.43408,0.43537,0.52208,0.33623,1.34803,0.52532,1.49894,1.2153zm-0.0871-0.2754zm0.1313,4.8599c-1.77224,0.45486-0.73294-1.92075-1.02182-2.90777-0.10721-0.8674-0.19677-2.18358,0.97764-1.56964,0.0459,1.49166,0.0538,2.98517,0.0442,4.47741zm-1.0122,0,0-0.009,0,0.009zm0,0.005c0.61973-0.017,1.16401,0.007,0.21039,0.007l-0.21039-0.007zm0,0.009,0-0.009,0,0.009zm0.87976,4.8491c-0.31266-0.45475-1.05634-0.38426-0.91328-0.5872,0.0278-1.42039,0.0482-2.84116,0.0327-4.26184,1.78729-0.4773,0.74646,1.9645,1.00579,2.95611-0.0438,0.62465,0.0375,1.2872-0.12524,1.89293zm0.0883-0.2766zm-3.3304,2.4582c-1.48587-0.92203,0.64603-1.70404,1.41636-2.18072,0.50399-0.58439,1.71861-0.60868,1.70096,0.13594-0.94962,0.81892-2.25536,1.07838-3.11732,2.04478zm-5.1484,5.3494c-1.28484-1.09729,0.90131-1.68589,1.37139-2.62008,1.04112-1.14956,1.96247-2.40877,3.09184-3.47714,1.47565,0.92104-0.71621,1.83092-1.14645,2.76787-1.00718,1.19959-2.01918,2.429-3.31678,3.32935zm-6.6596-2.7144c1.64003-0.23117,0.57413,1.54398,0.95186,2.46346,0.14768,1.32209,1.71251,1.25194,2.60838,0.76886,0.91055-0.22035,1.89696-1.17195,2.60546-1.23969,1.14022,0.93503-0.73692,1.3325-1.35285,1.8044-1.17626,0.57406-2.69901,1.1741-3.92225,0.41687-1.29396-0.97662-1.06914-2.80368-0.8906-4.2139zm-0.35095-3.1161c1.18529-1.52884,1.58413,1.17265,1.46784,2.07599,0.3484,0.93518-0.6327,1.65645-1.08304,0.80316,0.0992-0.96143,0.20333-2.04223-0.3848-2.87915zm-2.243-1.2532c0.39022-1.50965,1.66912-0.0909,2.55469,0.17623,1.0376,0.44049-0.50984,1.51892-0.89647,0.66417-0.58922-0.209-1.13368-0.50317-1.65822-0.8404zm0.53478-0.8635zm-2.983-1.5454c1.10418-1.22212,1.55272,0.87724,2.54429,1.24768,0.94022,0.26665-0.27871,1.72968-0.78634,0.68092-0.69202-0.53357-1.30443-1.17918-1.75795-1.9286zm-0.30678-2.9008c1.72116-0.47493,0.52001,1.53663,1.167,2.3694-1.08874,1.22529-1.3942-0.64701-1.21833-1.51358,0.0189-0.28515,0.0447-0.57,0.0513-0.85582zm0.30678-2.9008c1.41825,0.36586,0.31098,1.86905,0.70775,2.90066-1.52096,0.46478-1.09415-1.53064-0.93707-2.41927,0.0567-0.16888,0.13332-0.33123,0.22932-0.48139zm2.4471-2.4101c1.1864,0.99833-0.58124,1.42646-1.06794,2.22844-0.18885,0.82728-1.18406,0.73197-1.27267,0.0103,0.59561-0.91308,1.42096-1.66108,2.34061-2.23872zm0.53715,0.8635z'/%3E %3Cpath d='m475.52,220.24-0.1313,0.88877c-3.7518,0.47384-6.8494,1.9856-9.5543,4.356,1.7893-2.6675,5.6283-4.6531,9.6856-5.2448z' fill='%2321231e'/%3E %3Cpath d='m475.52,218.64-0.1313-0.88877c-3.7518-0.47504-6.8494-1.9856-9.5543-4.356,1.7893,2.6663,5.6283,4.6518,9.6856,5.2448z' fill='%2321231e'/%3E %3Cpath d='m461.16,207.28c1.1412,0.46904,2.3838,0.97174,3.4366,1.994,1.5996,1.5526,0.56342,4.1299-1.5041,6.6242-0.65176,0.78653-0.96689,2.1768-0.96212,3.561,0.005,1.3842,0.33185,2.7625,0.96212,3.5238,2.0663,2.4943,3.1036,5.0716,1.5041,6.6242-1.0516,1.0223-2.2943,1.5226-3.4355,1.9928-0.10982-0.60133-0.0979-1.3903,0.0585-2.4017,0.20293-1.3097,0.19577-2.6759-0.45121-3.5081-0.50374-0.64703-0.80933-0.38485-2.3754-1.3698-1.0146-0.63982-1.7762-1.4095-2.2847-2.2442-0.50732-0.83463-0.23159-1.7342-0.23159-2.635,0-0.90079-0.27693-1.8004,0.23159-2.635,0.50851-0.83584,1.2701-1.6055,2.2847-2.2442,1.5661-0.98617,1.8717-0.72398,2.3754-1.371,0.64697-0.83224,0.65414-2.1984,0.45121-3.5081-0.15637-1.0114-0.16831-1.8016-0.0585-2.4029h-0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m464.95,208.9c-0.23397,0.24454-0.46793,0.48908-0.7019,0.73362-0.91295-0.89844-2.10691-1.41622-3.27672-1.8897,0.12733-0.31429,0.25465-0.62858,0.38198-0.94287,1.29138,0.51733,2.59275,1.10862,3.59664,2.09895zm-1.467,7.3169c-0.25837-0.21773-0.51881-0.4345-0.7759-0.65283,0.9859-1.23087,1.98239-2.60024,2.15917-4.21287,0.0559-0.62706-0.14991-1.28456-0.61894-1.71738,0.23396-0.24454,0.46793-0.48907,0.70189-0.73361,0.98976,0.90738,1.13073,2.40311,0.71294,3.62054-0.43276,1.37583-1.27552,2.59395-2.17916,3.69615zm-0.84394,3.2339c-0.3374,0.00067-0.6748,0.001-1.0122,0.002,0.0161-1.34951,0.22439-2.79638,1.0809-3.88792,0.25864,0.21728,0.51727,0.43455,0.77591,0.65183-0.68638,0.90697-0.82812,2.13163-0.84461,3.23409zm0.84394,3.199c-0.25863,0.21728-0.51727,0.43456-0.7759,0.65184-0.84391-1.08251-1.05407-2.51246-1.0802-3.8482,0.3374-0.00067,0.6748-0.001,1.0122-0.002,0.0222,1.09578,0.1677,2.29982,0.8439,3.19836zm1.467,7.3169c-0.23397-0.24454-0.46793-0.48908-0.7019-0.73362,0.84296-0.77049,0.70835-2.05256,0.29983-3.00919-0.4335-1.07432-1.10998-2.03049-1.84016-2.92228,0.25864-0.21728,0.51727-0.43456,0.77591-0.65184,1.14221,1.41733,2.26777,3.03194,2.39743,4.90445,0.0505,0.89239-0.27714,1.79488-0.93111,2.41248zm-4.2842,1.7186c0.33185-0.0617,0.6637-0.12347,0.99555-0.1852-0.12951-0.14538-0.893-0.32577-0.53127-0.44424,1.11746-0.45229,2.24687-0.96625,3.1179-1.8228,0.23396,0.24454,0.46793,0.48908,0.70189,0.73362-1.00301,0.98942-2.30518,1.58051-3.59541,2.09746-0.22948-0.12626-0.45952-0.25267-0.68866-0.37884zm0.68877,0.37885c-0.31438,0.13297-0.70547,0.40623-0.64606-0.14447-0.17173-0.48675,0.42527,0.094,0.63662,0.13928l0.009,0.005zm-0.63267-2.9513c0.33343,0.0521,0.66687,0.10422,1.0003,0.15633-0.10837,0.73614-0.18489,1.49174-0.0599,2.2309-0.33185,0.0617-0.66369,0.12347-0.99554,0.1852-0.14582-0.85155-0.0683-1.72425,0.0551-2.57243zm-0.34855-3.1161c0.265-0.20926,0.53-0.41853,0.795-0.62779,0.82549,1.11333,0.7398,2.59874,0.5537,3.9001-0.33343-0.0521-0.66687-0.10423-1.0003-0.15634,0.13479-1.02312,0.27025-2.22191-0.3484-3.11597zm-2.2465-1.252c0.1782-0.28754,0.36052-0.57738,0.53617-0.8635,0.63697,0.4534,1.39858,0.66928,2.06695,1.05851,0.15701,0.14805,0.62886,0.40966,0.26499,0.56657-0.23708,0.0814-0.5187,0.6382-0.72247,0.37271-0.48577-0.37574-1.12606-0.49084-1.63927-0.83365-0.17157-0.0954-0.34011-0.19737-0.50637-0.30064zm0.001,0c-0.37599-0.23571-0.56675-0.3574-0.0797-0.0503-0.0554-0.007,0.11159,0.0504,0.0797,0.0503zm-2.4483-2.4101c0.28699-0.17769,0.57628-0.3541,0.86185-0.53258,0.52134,0.85548,1.27934,1.54762,2.1224,2.0789-0.17905,0.28784-0.35811,0.57568-0.53716,0.86352-0.97569-0.61387-1.84565-1.42091-2.44709-2.40984zm0,0.001c0.18231,0.29745,0.43538,0.71543,0.10978,0.18031-0.0366-0.0601-0.0734-0.12015-0.10978-0.18031zm-0.30678-2.902h1.0122c0.0213,0.78443-0.27018,1.64568,0.1542,2.3695-0.28728,0.17719-0.57456,0.35439-0.86184,0.53158-0.56554-0.87544-0.33583-1.92989-0.30456-2.90108zm0.30678-2.9008c0.28699,0.17769,0.57628,0.3541,0.86185,0.53259-0.42471,0.72279-0.1369,1.58398-0.1564,2.3678h-1.0123c-0.0267-0.97393-0.26122-2.02696,0.30685-2.90039zm2.4471-2.4101c0.17819,0.28754,0.36052,0.57738,0.53616,0.8635-0.84229,0.53142-1.59938,1.2224-2.1207,2.0772-0.28728-0.17719-0.57457-0.35439-0.86185-0.53158,0.59819-0.98949,1.47812-1.8011,2.44639-2.40912zm2.2465-1.2532c0.26501,0.20926,0.53001,0.41851,0.79502,0.62777-0.53026,0.73148-1.50814,0.8111-2.21065,1.30913-0.337,0.37957-0.4591-0.13021-0.64487-0.38502-0.38137-0.32095,0.0717-0.45225,0.33787-0.61056,0.50767-0.33849,1.14231-0.44951,1.62105-0.82394,0.0359-0.0367,0.0688-0.0802,0.10158-0.11738zm0.34856-3.1161c0.33343-0.0521,0.66687-0.10423,1.0003-0.15634,0.18585,1.30135,0.27187,2.78679-0.5538,3.90002-0.26501-0.20926-0.53001-0.41851-0.79502-0.62777,0.62008-0.89094,0.48426-2.09996,0.34852-3.11591zm0.44167-1.9711v-1.0198c0.16015,0.2853,0.60612,0.48864,0.46078,0.85993-0.0663,0.65848-0.001,1.3227,0.097,1.9746-0.33343,0.0521-0.66687,0.10423-1.0003,0.15635-0.12519-0.84945-0.20104-1.72114-0.0558-2.5732,0.16614,0.2004,0.33198,0.4033,0.49832,0.60212zm0-1.0198c0.39362-0.0362,0.76271-0.052,0.52816,0.43586,0.0319,0.45434-0.41609-0.39493-0.52816-0.43586zm-0.001,0c0.002,0.33761,0.002,0.6822,0,1.0198-0.39382-0.0281,0.002-0.58526-0.0323-0.8538,0.0108-0.0553,0.0215-0.11066,0.0323-0.166z'/%3E %3Cpath d='m361,226.26,0.67683-0.29225c-1.5399-2.1515-1.8729-4.2081-1.2832-6.2658-1.3119,1.6356-0.99195,4.2117,0.6064,6.558z' fill='%2321231e'/%3E %3Cpath d='m410.74,199.91c1.3286,1.6861,1.1686,2.0902,1.8896,2.5737,0.94064,0.62418,2.2167,0.4065,3.4008-0.0458,4.8583-1.8593,4.8607,2.0048,3.4486,6.4282-0.68399,2.1455-2.7562,4.4714-3.6802,6.2959-0.90841,1.7871-0.71265,3.1257-1.1197,3.5827-1.7619,0.29225-3.2755,0.50632-3.9643,0.5857h-0.005c-0.67444,0.10822-2.1749,0.30186-3.907,0.48826-0.56701-0.3235-1.0051-1.5935-2.6118-2.9874-1.6127-1.4011-4.4024-2.9176-5.9028-4.6302-3.0439-3.4732-4.6626-6.8106,0.12413-6.694,1.1913,0.03,2.3826-0.18761,2.9162-1.0439,0.42256-0.66868,0.10505-0.97174,0.51568-2.9285,0.26857-1.2832,0.73889-2.3067,1.3429-3.0427,0.61355-0.74924,1.5088-0.58449,2.3337-0.73843,0.832-0.15635,1.5888-0.64703,2.508-0.18159,0.91794,0.46542,1.8454,1.2375,2.7109,2.3367v0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m412.91,202.06c-0.24397,0.18063-0.37488,0.97042-0.69325,0.75341-0.74601-0.60238-1.01722-1.58368-1.64479-2.29142-0.49912-0.36791,0.24652-0.58241,0.48483-0.86046,0.27808-0.0362,0.47403,0.54673,0.70133,0.77338,0.41463,0.51253,0.609,1.23976,1.15188,1.62509zm-0.55627,0.85147zm3.4999-0.94769c0.0129,0.33317,0.61853,0.941,0.12056,1.0389-1.15017,0.41363-2.54114,0.62103-3.62049-0.0918,0.24401-0.20341,0.36771-0.91928,0.69348-0.76968,0.8852,0.4442,1.93388,0.13883,2.80645-0.17742zm4.1087,7.0608c-0.27846-0.20085-1.13945-0.1-0.87927-0.57982,0.44637-1.60236,0.97215-3.322,0.545-4.98364-0.20269-0.84819-1.16333-1.11748-1.92675-0.95466-0.5118,0.0748-1.00769,0.22892-1.49094,0.40999-0.0167-0.34186-0.63635-0.96369-0.0946-1.04624,1.22774-0.44544,2.83069-0.74718,3.87145,0.25951,1.05887,1.16649,0.86851,2.89202,0.63092,4.32717-0.15433,0.87043-0.39348,1.7267-0.65582,2.56769zm-3.7112,6.3716c-0.23863-0.2412-1.10928-0.28485-0.77209-0.70704,1.11509-2.02556,2.75191-3.76811,3.52122-5.97728,0.26167,0.19475,1.0899,0.10332,0.88931,0.53157-0.83347,2.25699-2.51729,4.05207-3.63844,6.15275zm-1.4873,3.8533c-0.14463-0.27326,0.043-1.23142-0.40949-0.87007-0.0587-0.0215,0.14704-0.47317,0.13547-0.65649,0.15822-0.9634,0.40816-1.92105,0.86134-2.79097,0.23368,0.23827,1.06604,0.27588,0.79417,0.68279-0.50679,0.97344-0.55063,2.08914-0.87104,3.11875-0.0882,0.25488-0.26442,0.41606-0.51045,0.51599zm0.29365-0.16236zm-4.3403,0.75525c0.0679-0.31318-0.12865-1.01507,0.0812-1.0318,1.27135-0.1567,2.53703-0.35681,3.80093-0.5645-0.0517,0.32745,0.41118,1.02396-0.069,1.04428-1.26745,0.20074-2.54054,0.4137-3.81311,0.55202zm0.0573-0.004zm0.0179-0.004c-0.0351-0.22048-0.21657-1.36105-0.11601-0.72919,0.0649,0.7025,0.0261-0.75971,0.04-0.0737,0.00052,0.12039,0.00056,1.17223-0.004,0.60028-0.0189-0.67681,0.0299-0.0119,0.08,0.20258zm-0.15997-1.0054zm-4.0765,1.4348c0.0582-0.30702,0.80093-0.92604,0.22504-0.94402,0.28877-0.0526,0.82698-0.0946,1.21336-0.14584,0.88077-0.10435,1.76146-0.21124,2.63837-0.3446-0.0528,0.31974,0.39183,1.00278-0.0512,1.03824-1.2594,0.17036-2.52702,0.35811-3.7906,0.44554-0.0779-0.0169-0.15835-0.0312-0.23492-0.0493zm0.3032,0.0625zm-2.9962-3.1076c0.27647-0.15025,0.50802-0.96512,0.81549-0.635,0.92597,0.77437,1.54684,1.82062,2.30491,2.73926,0.0645,0.21682-0.31467,0.81028-0.48621,0.90274-0.7937-0.63758-1.19778-1.63066-1.93374-2.33194-0.22-0.23813-0.45677-0.46318-0.70045-0.67506zm-5.9518-4.6795c0.31316-0.13758,0.65896-0.92358,0.94131-0.47393,1.67851,1.72083,3.851,2.83163,5.67176,4.38135-0.28972,0.17711-0.52723,1.00206-0.8624,0.60054-1.88991-1.53492-4.10283-2.68578-5.75067-4.50796zm0.51687-7.5394c-0.12017,0.29644,0.21583,1.06366-0.23506,1.01698-0.75382,0.0303-1.71917,0.01-2.19908,0.69702-0.31024,0.90853,0.29283,1.81479,0.7219,2.58186,0.5652,0.91854,1.24977,1.75641,1.95448,2.5703-0.313,0.13758-0.66963,0.93729-0.94226,0.46202-1.16407-1.41458-2.43432-2.89957-2.81184-4.74226-0.22253-1.02177,0.44518-2.08212,1.45321-2.34232,0.66023-0.22308,1.36726-0.25246,2.05865-0.2436zm2.4769-0.80938c0.18354,0.24797,1.00944,0.37544,0.74466,0.70281-0.75275,0.97935-2.09419,1.15226-3.24807,1.12222,0.11031-0.30563-0.20022-1.04455,0.2339-1.0164,0.79431-0.0158,1.78108-0.0864,2.26951-0.80863zm-0.002,0.004zm0.45003-2.7625c0.2604,0.16521,1.03933-0.009,0.95268,0.38346-0.237,0.85561-0.09,1.77567-0.3822,2.61382-0.10564,0.56234-0.51912,0.0335-0.8114-0.10579-0.39753-0.12206,0.0758-0.49866-0.0276-0.79832,0.0341-0.7034,0.11746-1.40833,0.2685-2.09317zm1.4468-3.2628c0.15803,0.26335,0.8816,0.46813,0.68669,0.76725-0.59907,0.78932-0.93905,1.74347-1.14492,2.70437-0.28648-0.16869-1.12467,0.0173-0.9335-0.45942,0.2548-1.08115,0.68667-2.14872,1.39173-3.0122zm0.78067,0.64944c0.16497-0.20348,0.81454-0.99221,0.33957-0.41395-0.11321,0.13793-0.22624,0.27626-0.33957,0.41395zm1.8502-1.5634c-0.0496,0.30061,0.39118,0.9468,0.0277,1.0267-0.63371,0.11579-1.4194-0.0223-1.8776,0.5326-0.16725-0.27482-0.98167-0.50774-0.62657-0.81773,0.64951-0.68314,1.62931-0.62437,2.47646-0.74157zm0.18621,1.0006c-0.33784,0.0648-1.13052,0.21117-0.35025,0.0656,0.11659-0.0218,0.23442-0.0442,0.35025-0.0656zm2.6417-1.1365c-0.23096,0.23038-0.25387,1.01596-0.63861,0.83101-0.6847-0.21078-1.33798,0.20096-2.003,0.3047,0.0421-0.34578-0.45251-1.03858,0.0818-1.06337,0.82662-0.26273,1.74599-0.53268,2.5598-0.0723zm2.9902,2.7914c-0.29128,0.0991-1.20265-0.24285-0.92046,0.26421-0.11243-0.0773-0.46086-0.54968-0.69132-0.75841-0.53678-0.55001-1.14633-1.03627-1.8321-1.3877,0.22774-0.22529,0.26564-1.04856,0.64219-0.80941,1.06654,0.59994,2.00868,1.44992,2.71544,2.4411,0.0285,0.0832,0.0591,0.16804,0.0863,0.25021zm-0.10982-0.3163zm-0.90243,0.31751c0.19535,0.0299,1.14307-0.0649,0.88023,0.0462-0.33506,0.0266-0.8473,0.55557-0.88023-0.0462zm0.10982,0.31629z'/%3E %3Cpath d='m410.05,219.43c-0.26381-0.007-0.52762-0.0205-0.79261-0.0325-1.368-3.8364-3.5011-6.9321-6.3063-9.5358,2.8159,1.5731,5.5614,5.4155,7.0989,9.5695v-0.001z' fill='%2321231e'/%3E %3Cpath d='m411.43,219.24c0.2471-0.0806,0.493-0.15995,0.74009-0.24173-0.50255-3.9892,0.0668-7.5358,1.5363-10.88-1.9612,2.3752-2.7598,6.8058-2.2764,11.122z' fill='%2321231e'/%3E %3Cpath d='m418.3,201.97c-0.18025,1.4227-0.36527,2.9537-1.0719,4.3187-1.0636,2.0541-3.6838,1.2628-6.483-0.69874-0.88094-0.61817-2.231-0.76129-3.4772-0.5412-1.2426,0.21888-2.3826,0.79135-2.8792,1.6128-1.596,2.6386-3.5118,4.1203-5.3096,2.6134-1.1913-1.0006-1.997-2.291-2.7515-3.4769,0.48226-0.21046,1.1651-0.31509,2.0902-0.29223,1.1913,0.03,2.3826-0.18763,2.9162-1.0439,0.42257-0.66869,0.10743-0.97174,0.51687-2.9236,0.26978-1.2868,0.7377-2.3079,1.3417-3.0475,0.61355-0.74925,1.51-0.57968,2.3349-0.73482,0.832-0.15515,1.5876-0.65063,2.5068-0.18402,0.91796,0.46423,1.8454,1.2375,2.7121,2.3368,1.3274,1.6861,1.1627,2.0902,1.8896,2.5773,0.93944,0.62055,2.2167,0.39927,3.3996-0.0493,0.91555-0.34637,1.6628-0.49189,2.2644-0.46663z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m417.68,206.53c-0.29922-0.15715-0.59845-0.3143-0.89767-0.47145,0.6633-1.28163,0.83985-2.73595,1.0196-4.14793,0.33423,0.0433,0.66847,0.0866,1.0027,0.12989-0.18866,1.532-0.40514,3.1016-1.12463,4.48949zm-7.2207-0.51594c0.19258-0.27902,0.38516-0.55803,0.57774-0.83705,1.25164,0.83937,2.60689,1.71855,4.15302,1.81369,0.66099,0.0478,1.31723-0.32463,1.59229-0.93176,0.29922,0.15715,0.59844,0.31429,0.89766,0.47144-0.47243,1.01081-1.60685,1.59428-2.70362,1.47137-1.66848-0.15206-3.16284-1.06611-4.51709-1.98769zm-3.1012-0.45821c-0.0581-0.33433-0.11618-0.66867-0.17427-1.003,1.29746-0.21817,2.73491-0.13409,3.85317,0.6235-0.19258,0.27901-0.38517,0.55803-0.57775,0.83704-0.89849-0.59834-2.0682-0.62496-3.10115-0.45754zm-2.5342,1.3758c-0.28808-0.17639-0.57615-0.35278-0.86423-0.52917,0.69644-1.09634,1.99496-1.62213,3.22441-1.8493,0.0581,0.33433,0.11619,0.66867,0.17428,1.003-0.94266,0.18411-1.97848,0.5427-2.53446,1.37547zm-6.0652,2.7396c0.21545-0.26099,0.43259-0.52136,0.64698-0.78273,0.58856,0.56876,1.53489,0.63305,2.20431,0.16793,1.02139-0.63421,1.72462-1.65158,2.34964-2.65408,0.28808,0.17639,0.57615,0.35278,0.86423,0.52917-0.83361,1.33278-1.83193,2.73567-3.35905,3.31092-0.93474,0.34301-1.97096,0.073-2.70611-0.57121zm-2.6285-4.3356c0.13369,0.31188,0.26739,0.62377,0.40108,0.93565,0.11301-0.16186,0.14095-0.9534,0.32512-0.58493,0.73125,1.15247,1.49378,2.31707,2.54916,3.20262-0.21565,0.26057-0.43131,0.52115-0.64696,0.78172-1.18683-0.98926-2.03653-2.29925-2.8544-3.59225,0.0754-0.24725,0.15023-0.49723,0.226-0.74281zm-0.22561,0.74323c-0.18165-0.27654-0.50138-0.59532,0.0242-0.6555,0.41309-0.25953-0.0212,0.43281-0.0174,0.63303l-0.007,0.0225zm2.5294-1.0764c-0.008,0.33881-0.0189,0.68026-0.0253,1.0174-0.63084-0.004-1.28549,0.005-1.8775,0.2491-0.13369-0.31189-0.26739-0.62377-0.40108-0.93566,0.72339-0.30768,1.52925-0.34583,2.30388-0.33084zm2.4769-0.80938c0.28417,0.1793,0.57306,0.37581,0.85429,0.5444-0.69101,1.08914-2.1016,1.3097-3.29212,1.28292-0.15204-0.17541-0.003-0.63449-0.0419-0.91654,0.10335-0.22498,0.60998-0.0404,0.87627-0.13611,0.58976-0.0712,1.26579-0.24012,1.60351-0.77467zm-0.002,0.004zm0.45122-2.7589c0.32946,0.0705,0.65893,0.14111,0.98839,0.21166-0.21582,0.82764-0.18155,1.69066-0.33127,2.52579-0.0856,0.19462-0.16587,0.73703-0.43361,0.45013-0.17343-0.20586-0.79501-0.29128-0.58292-0.59775,0.17433-0.70735,0.10248-1.4581,0.27815-2.17072,0.0249-0.14013,0.0515-0.27993,0.0813-0.41911zm1.4456-3.2664c0.25997,0.2156,0.52198,0.43556,0.78067,0.64843-0.65641,0.8122-1.02266,1.81766-1.2384,2.82932-0.32946-0.0706-0.65892-0.14112-0.98838-0.21168,0.24593-1.17138,0.68553-2.32944,1.44611-3.26607zm0,0.001c0.21824-0.26945,0.49703-0.6088,0.11782-0.14439-0.0392,0.0479-0.0788,0.0971-0.11782,0.14439zm2.6333-0.91281c0.0618,0.33322,0.12174,0.67276,0.18483,1.002-0.67743,0.16128-1.53366-0.0397-2.0374,0.5552-0.26023-0.21647-0.52045-0.43295-0.78068-0.64942,0.57001-0.74616,1.56372-0.81835,2.4259-0.8766,0.069-0.008,0.14082-0.0192,0.20735-0.0312zm-0.001,0.001c0.26018-0.0505,0.88871-0.16683,0.28779-0.0542-0.0957,0.018-0.19284,0.0366-0.28779,0.0542zm2.8267-0.1395c-0.15165,0.30279-0.30233,0.61158-0.4546,0.9106-0.71655-0.37205-1.47128,0.11643-2.1868,0.2303-0.0613-0.33433-0.12255-0.66867-0.18383-1.003,0.86297-0.21089,1.78692-0.61836,2.66145-0.2126,0.053,0.0198,0.11985,0.0562,0.16378,0.0747zm-0.4536,0.9116zm3.3352,1.5646c-0.26421,0.21086-0.52842,0.42173-0.79263,0.63259-0.69838-0.88185-1.53326-1.68239-2.5426-2.1972,0.1512-0.30387,0.3024-0.60774,0.4536-0.91161,1.14022,0.58158,2.09409,1.47778,2.88163,2.47622zm1.7702,2.4678c-0.18654,0.282-0.36841,0.5759-0.55787,0.85047-0.80086-0.52293-1.05735-1.50744-1.64963-2.2158-0.15148-0.24327-0.54422-0.50523-0.10355-0.67099,0.25246-0.14624,0.55112-0.65397,0.72903-0.1864,0.52032,0.62516,0.86482,1.3703,1.34041,2.02306,0.0687,0.0746,0.16964,0.15088,0.24161,0.19966zm-0.55387,0.85147zm3.4987-0.95249c0.11846,0.31734,0.23783,0.63979,0.35571,0.9539-1.21176,0.4649-2.69544,0.7558-3.85444-0.002,0.18463-0.28383,0.36925-0.56765,0.55388-0.85148,0.89598,0.55803,2.02948,0.23128,2.94485-0.10052zm2.9437,0.0758c-0.33423-0.0433-0.66847-0.0866-1.0027-0.12989,0.0972,0.20229,0.7442,0.65588,0.23029,0.57463-0.62553,0.0316-1.2324,0.21419-1.81533,0.43324-0.11857-0.3183-0.23715-0.63659-0.35572-0.95489,0.78646-0.29188,1.61683-0.52939,2.4636-0.4953,0.15964,0.18991,0.32179,0.38656,0.47986,0.57221zm-0.47988-0.57367c0.38134-0.0329,0.68946-0.004,0.49546,0.44986,0.0285,0.33294-0.39165-0.39821-0.49546-0.44986z'/%3E %3Cpath d='m391.76,221.18c0.7747-0.94167,1.0827-0.73241,1.2247-1.3241,0.17906-0.76489-0.27097-1.9627-0.8535-3.104-2.3313-4.5701,0.14922-4.1852,3.5118-2.3825,0.85231,0.45702,1.8419,1.2676,2.8243,2.1034,0.99077,0.84306,1.9744,1.7258,2.798,2.3175,1.6664,1.199,2.6954,1.2351,3.1812,1.7198,0.74009,1.8569,1.3489,3.4636,1.6055,4.1864,0.001,0.004,0.001,0.004,0.006,0.007,0.28409,0.724,0.88214,2.3283,1.541,4.178-0.10623,0.51594-1.0648,0.65906-1.781,1.9784-0.70428,1.3001-1.2582,3.6584-2.12,4.795-1.2641,1.6657-2.4196,2.6578-3.3197,2.4943-0.89766-0.16357-1.5375-1.4769-1.7774-4.3813-0.0942-1.1281-0.7389-2.3223-1.4826-3.0295-0.58014-0.55203-0.70906-0.31992-2.1439-1.1281-0.92751-0.52195-1.7165-1.1654-2.3456-1.8653-0.6267-0.69754-0.72338-1.4781-1.0146-2.2478-0.29246-0.77331-0.77829-1.5334-0.70309-2.267,0.0752-0.74323,0.35214-1.4456,0.84991-2.0505h-0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m392.49,219.74c0.28133,0.12416,0.8275,0.0884,0.96719,0.29825-0.15479,0.70139-0.94618,0.9065-1.31118,1.46767-0.17614-0.25239-0.80983-0.46425-0.70059-0.74193,0.27235-0.38486,0.70741-0.61745,1.0218-0.9462,0.0101-0.019,0.0159-0.0732,0.0228-0.0778zm0.98361,0.23332zm-1.7953-2.9874c0.30015-0.0631,0.74635-0.57298,0.95494-0.35598,0.48643,1.03377,1.05133,2.16867,0.8392,3.34313-0.27944-0.13815-0.87427-0.0668-0.96761-0.32841,0.0404-0.9418-0.43872-1.83404-0.82653-2.65874zm4.1994-3.0656c-0.2126,0.22548-0.28614,0.89956-0.58683,0.84089-1.02754-0.50067-2.08671-1.12826-3.25991-1.13122-0.5011,0.0626-0.27304,0.73047-0.20735,1.05646,0.17301,0.63994,0.46031,1.24112,0.75501,1.83245-0.30027,0.0618-0.74952,0.57775-0.9559,0.35345-0.48004-1.04496-1.10756-2.19399-0.83337-3.37812,0.27012-0.89238,1.35475-1.02433,2.12987-0.79979,1.04326,0.24602,2.01584,0.72977,2.95848,1.22588zm2.9126,2.1636c-0.25272,0.17674-0.4667,0.81006-0.74365,0.70113-0.84302-0.70288-1.68089-1.42989-2.6446-1.9651,0.20285-0.23395,0.29095-0.84818,0.56339-0.85149,1.02466,0.58467,1.92532,1.35997,2.82486,2.11546zm2.7658,2.2922c-0.23128,0.20552-0.39805,0.80236-0.66839,0.77092-0.95822-0.70978-1.84063-1.5142-2.7497-2.2843,0.25351-0.17532,0.46795-0.81707,0.74605-0.69873,0.88222,0.74694,1.73674,1.53097,2.67204,2.21211zm3.3567,1.9447c-0.22825,0.18088-0.9522,0.2076-0.86876,0.48541,0.0603,0.0925-0.39979-0.23938-0.57078-0.26449-0.88458-0.3426-1.73739-0.77492-2.50438-1.3362,0.23967-0.19529,0.40056-0.85549,0.69008-0.75658,0.85744,0.66039,1.90314,0.97393,2.84924,1.46779,0.16382,0.10319,0.31627,0.22826,0.4046,0.40407zm-0.11341-0.17197zm1.7297,4.3873c-0.30118,0.0541-0.76773,0.34544-0.97677,0.2736-0.50043-1.37906-1.03622-2.74504-1.57706-4.10869,0.30528-0.0335,0.79706-0.50449,0.98508-0.26284,0.53714,1.35947,1.07523,2.72586,1.56875,4.09793zm-0.004-0.0108,0.004,0.0108-0.004-0.0108zm0-0.008c-0.22454,0.17624-0.96326,0.20967-0.86431,0.47575-0.0422,0.11117,0.68547,0.3659,0.16972-0.003-0.52399-0.5278-0.0328-0.0348,0.20517,0.2057-0.0406-0.0383-0.75545-0.7608-0.3122-0.31452,0.49983,0.50312,0.19615,0.1994-0.11724-0.11713-0.0892-0.003,0.22502,0.56773-0.0626-0.065,0.0916,0.33835,0.68336-0.15283,0.98346-0.16029,0.0717,0.36871-0.26803-0.61221,0.0255,0.15182-0.091-0.0747-0.75161-0.75474-0.323-0.31928,0.49937,0.50266,0.19792,0.20118-0.11625-0.11612-0.18613-0.18948,0.71666,0.72101,0.31219,0.31452-0.4512-0.37456-0.29295-0.3625-0.0606-0.26647,0.0279,0.0432,0.11202,0.14907,0.16008,0.2143zm-0.16711-0.22007zm1.7332,4.6891c-0.2838,0.023-0.91937-0.3575-0.98204-0.0809,0.007,0.29086-0.22059-0.57063-0.31347-0.75405-0.39507-1.08947-0.79126-2.17869-1.21116-3.25883,0.30532-0.0615,0.73611-0.41099,0.96813-0.30423,0.52531,1.38785,1.06182,2.77886,1.52427,4.18552,0.004,0.0706,0.0107,0.14266,0.0143,0.21253zm-0.0191-0.27541zm-1.8132,2.3945c-0.21871-0.21538-0.89598-0.30085-0.82584-0.59806,0.37214-0.72614,1.08153-1.24513,1.66753-1.72832,0.27443,0.13178,0.90639,0.0419,0.96446,0.30781-0.29642,0.73011-1.17051,0.9636-1.5642,1.6324-0.0897,0.12261-0.17019,0.25333-0.24195,0.38617zm-2.1618,4.8599c-0.19055-0.2453-0.81405-0.42773-0.73655-0.71195,0.91094-1.43176,1.22037-3.14411,2.0104-4.63622,0.22085,0.21656,0.89165,0.29848,0.82909,0.59985-0.76942,1.55021-1.09549,3.31933-2.10294,4.74832zm-3.8115,2.6867c0.12059-0.293,0.0218-0.87143,0.27226-0.995,0.90041-0.11174,1.51453-0.90543,2.10168-1.52391,0.25932-0.18889,0.4545-0.794,0.73313-0.70889,0.15212,0.2384,0.87782,0.40246,0.58272,0.69882-0.83284,1.01651-1.72876,2.18504-3.0654,2.5221-0.20524,0.04-0.41915,0.0414-0.62439,0.007zm-2.1916-4.8395c0.30806,0.0278,0.80611-0.17097,1.01323-0.0228,0.146,1.22554,0.21287,2.5657,0.95397,3.60276,0.3136,0.2145,0.49893,0.34043,0.31467,0.75279,0.0306,0.45324-0.18907,0.61941-0.56594,0.33625-1.05508-0.65385-1.30908-1.99416-1.52843-3.12429-0.0871-0.51045-0.14468-1.03447-0.1875-1.54476zm-1.3262-2.7024c0.25869-0.16674,0.50793-0.75867,0.77242-0.66501,0.85628,0.88239,1.4416,2.05136,1.5617,3.28055-0.30699-0.0399-0.84904,0.20298-1.0165-0.005-0.12776-0.98-0.61454-1.92001-1.31762-2.61074zm-2.0436-1.0535c0.21708-0.22082,0.30577-0.89448,0.60425-0.8282,0.67819,0.44626,1.55121,0.54936,2.13428,1.14114-0.26318,0.16368-0.50886,0.77732-0.78302,0.66033-0.55044-0.39456-1.24947-0.52374-1.8191-0.8975-0.0455-0.0251-0.0908-0.051-0.13641-0.0758zm-2.4733-1.9687c0.26688-0.16019,0.54914-0.66282,0.80693-0.62061,0.62264,0.67787,1.35882,1.24893,2.1605,1.6999-0.21027,0.22721-0.308,0.85607-0.58729,0.83697-0.88434-0.51255-1.69817-1.15413-2.38014-1.91626zm-1.1125-2.4077c0.30529-0.0524,0.7519-0.41561,0.974-0.285,0.25105,0.68551,0.3756,1.45386,0.8875,2.0094-0.26921,0.14694-0.56396,0.70878-0.81765,0.6038-0.58265-0.65519-0.76136-1.52845-1.04385-2.3282zm-0.73293-2.5003c0.30959,0.0686,0.77289,0.011,1.0011,0.14644,0.012,0.71882,0.44597,1.33094,0.6771,1.9907-0.30639,0.0627-0.73196,0.38788-0.9692,0.29831-0.31136-0.78256-0.79643-1.56406-0.709-2.43545zm1.0051,0.10344c-0.0117,0.12107-0.009,0.0881,0-0.0001v0.0001zm0.34737-1.5923c0.0348-0.22519-0.0703-1.08132,0.0533-0.90541,0.0686,0.30922,0.50709,0.65514,0.1819,0.92234-0.32641,0.46302-0.52798,1.01183-0.5808,1.5757-0.29724-0.0896-0.84806,0.0276-0.9971-0.18282,0.0924-0.81934,0.42795-1.60935,0.9546-2.2439,0.12881,0.27745,0.26192,0.55939,0.38807,0.83409zm0-1.0198c0.3027,0.0363,0.90786-0.0703,1.03542,0.0487-0.22458,0.15569-0.51983,0.86931-0.69963,0.6715-0.11193-0.24008-0.22389-0.48018-0.33579-0.72024zm-0.001,0c0.002,0.33762,0.002,0.68219,0,1.0198-0.0402-0.3095-0.63716-0.8192-0.16122-0.94312,0.0537-0.0255,0.10755-0.0512,0.16122-0.0767zm0,1.0198c-0.3027-0.0363-0.90786,0.0703-1.03542-0.0487,0.22458-0.1557,0.51981-0.86933,0.69961-0.67152,0.11193,0.24008,0.2239,0.48019,0.33581,0.72026z'/%3E %3Cpath d='m406.51,226.13c0.0692,0.32111,0.14802,0.63621,0.22203,0.94408-1.4456,0.33916-2.6428,0.93446-3.6408,1.7523-0.99554,0.81781-1.7941,1.8677-2.4256,3.1281,0.22083-1.3951,0.91437-2.6434,1.9338-3.6452,1.017-1.0018,2.3659-1.7643,3.9094-2.1792h0.001z' fill='%2321231e'/%3E %3Cpath d='m405.92,224.45c-0.13966-0.31028-0.28528-0.62178-0.43212-0.93206-1.6091-0.1335-3.1645-0.54479-4.6864-1.205-1.5088-0.65545-2.9854-1.555-4.4465-2.6711,1.1579,1.2977,2.6643,2.4017,4.3188,3.2279,1.6688,0.83463,3.4904,1.3854,5.2451,1.5803h0.001z' fill='%2321231e'/%3E %3Cpath d='m391.36,213.8c0.99315,0.3656,1.6592,0.82141,2.8016,1.7667,0.8702,0.72038,1.3441,1.7607,1.5136,2.9477,0.1707,1.193,0.0394,2.5448-0.29365,3.8846-0.20532,0.83104,0.0466,2.2478,0.53597,3.644,0.48702,1.3878,1.2176,2.7613,1.9565,3.5009,2.4435,2.4498,4.16,5.0391,3.4772,6.6422-0.44644,1.0499-0.78426,1.3217-1.4838,1.798-0.29127-0.59891-0.98599-1.1353-1.2212-2.1527-0.30319-1.3121-0.79142-2.6711-1.5661-3.4865-0.59923-0.63861-0.73173-1.3518-2.2203-2.279-0.96332-0.60252-1.7822-0.34396-2.4375-1.1497-1.2689-1.5598-2.9329-5.3758-1.3059-7.1173,1.6031-1.7186,2.1773-2.6891,0.82366-5.6488-0.46077-1.0066-0.44883-1.7402-0.58133-2.35h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m394.49,215.17c-0.21407,0.26218-0.42813,0.52435-0.6422,0.78653-0.80723-0.66904-1.65056-1.33454-2.65363-1.6815,0.11539-0.3191,0.23078-0.63821,0.34617-0.95731,1.11177,0.38658,2.05715,1.10508,2.94966,1.85228zm1.6926,3.2688c-0.32083,0.009-0.76671,0.1862-1.00891,0.0886-0.14163-0.96862-0.55292-1.94-1.32619-2.57071,0.21407-0.26218,0.42815-0.52435,0.64222-0.78653,0.98402,0.80224,1.52551,2.03093,1.69288,3.26867zm-0.30319,4.0794c-0.32676-0.0824-0.65608-0.16273-0.98123-0.24635,0.29564-1.20127,0.4502-2.45565,0.2842-3.68853,0.32031-0.009,0.76774-0.18636,1.00813-0.0885,0.17673,1.34368,0.008,2.71937-0.3111,4.02335zm-0.98123-0.24535zm1.5029,3.5971c-0.31239,0.0717-0.71632,0.33438-0.9711,0.28588-0.40111-1.24084-0.78726-2.5728-0.53207-3.88298,0.3013,0.11368,0.77898,0.11781,0.96922,0.30046-0.15496,1.11339,0.19468,2.24803,0.53395,3.29664zm1.8371,3.3097c-0.251,0.20134-0.50263,0.61362-0.75323,0.68126-0.95793-1.03296-1.55934-2.34094-2.03658-3.65182,0.31296-0.0719,0.71516-0.33396,0.97197-0.28618,0.43288,1.16358,0.96219,2.34054,1.81784,3.25674zm3.5847,7.2039c-0.2798-0.16146-0.74805-0.24235-0.90911-0.45459,0.29765-1.00391-0.27839-2.00581-0.76942-2.84823-0.73359-1.16628-1.65365-2.20293-2.62072-3.17947,0.25114-0.20148,0.50239-0.61335,0.75347-0.68147,1.42833,1.48021,2.87153,3.07397,3.55094,5.0531,0.21361,0.68053,0.27723,1.4422-0.005,2.11066zm-2.4017,1.8208c0.24998-0.15067,0.77764-0.32849,0.85275-0.46206-0.17282-0.10248-0.92324-0.10313-0.50175-0.30867,0.54056-0.32788,0.89796-0.871,1.1216-1.451,0.2778,0.16066,0.75209,0.24398,0.90607,0.45337-0.30852,0.82153-0.89057,1.51833-1.64328,1.96839-0.24407-0.067-0.49631-0.13119-0.73539-0.20003zm0.73651,0.19843c-0.304,0.26592-0.58375,0.44091-0.6783-0.0787-0.17813-0.27341,0.53099,0.0955,0.6783,0.0787zm-1.997-2.4594c0.31966-0.0368,0.74883-0.2519,0.99938-0.17611,0.1762,0.77532,0.81944,1.30291,1.16862,1.98951-0.30286,0.11669-0.65592,0.38863-0.92761,0.40889-0.45863-0.71775-1.0714-1.35431-1.24039-2.22229zm-1.4408-3.252c0.24313-0.234,0.49692-0.46786,0.73332-0.70194,0.93988,1.02701,1.37248,2.39681,1.694,3.72328-0.31913,0.0366-0.74989,0.25216-0.99856,0.17592-0.28252-1.13026-0.63323-2.31327-1.42876-3.19726zm0.002,0.002zm-2.1212-2.1984c0.17746-0.28864,0.35492-0.57727,0.53238-0.86591,0.8976,0.51465,1.58879,1.2988,2.14746,2.1566,0.35957,0.2389-0.11178,0.42372-0.27507,0.63345-0.23075,0.40392-0.4482,0.1515-0.62625-0.14371-0.45506-0.722-1.03652-1.34754-1.77852-1.78043zm-2.5629-1.2592c0.26077-0.21481,0.52357-0.43393,0.78306-0.64602,0.52708,0.61941,1.45102,0.49546,2.10078,0.9183,0.44158,0.12015-0.10378,0.49565-0.17274,0.7461-0.0972,0.42685-0.38637,0.0546-0.64048,0.004-0.74267-0.2301-1.57594-0.34998-2.07062-1.0224zm-1.2832-7.7896c0.24501,0.23229,0.49456,0.46639,0.7367,0.69754-0.78746,0.91302-0.5644,2.24165-0.26581,3.30747,0.34344,1.12644,0.8673,2.20882,1.59564,3.13754-0.26103,0.21567-0.52205,0.43135-0.78308,0.64702-1.16116-1.53103-1.98643-3.38585-2.09247-5.32053-0.031-0.88403,0.19471-1.81118,0.80902-2.46904zm0.73293-5.0872c0.30494-0.10041,0.68406-0.39894,0.94217-0.37425,0.60463,1.32173,1.14491,2.9178,0.45043,4.31316-0.33561,0.7003-0.86556,1.28041-1.38752,1.84584-0.2459-0.23251-0.49181-0.46503-0.73771-0.69754,0.74656-0.78917,1.60691-1.74126,1.42623-2.91811-0.0888-0.75941-0.38401-1.47755-0.6936-2.1691zm-0.12176-3.0728v1.0198c0.15777-0.0986,0.45813-0.78045,0.52039-0.48716,0.10771,0.71767,0.19169,1.4538,0.5164,2.1141-0.305,0.10044-0.68395,0.39889-0.94225,0.37429-0.36196-0.75338-0.45947-1.58784-0.58869-2.40237,0.16456-0.20581,0.3304-0.41495,0.49415-0.61866zm-0.49418,0.61936c-0.0777-0.33881-0.28153-0.77932,0.25992-0.61936,0.50804-0.0803-0.1818,0.41613-0.25821,0.61722l-0.002,0.002zm0.49537,0.40048c-0.002-0.33762-0.002-0.68218,0-1.0198,0.37144,0.0353-0.0172,0.60105,0.0272,0.86464-0.009,0.0517-0.0181,0.10368-0.0272,0.15516zm0-1.0198z'/%3E %3Cpath d='m434.07,226.22c-1.2772,1.1016-1.5996,0.88394-1.9565,1.549-0.45243,0.84546-0.24114,2.1287,0.14801,3.3337,1.5375,4.7529-1.3608,4.3356-4.8416,2.5172-1.7321-0.9044-3.7542-3.2171-5.3251-4.3788-1.5781-1.1594-2.6858-1.1509-3.1179-1.6308-0.44166-1.8773-0.79619-3.525-0.93825-4.2778-0.005,0-0.005,0-0.005-0.005-0.1707-0.74925-0.51925-2.4306-0.89051-4.4077,0.21727-0.58931,1.3047-0.8611,2.3731-2.4594,1.0851-1.6176,2.1654-4.6362,3.5692-6.1058,2.8768-3.0126,5.7655-4.3067,5.9255,1.4793,0.0394,1.4023,0.28649,2.8202,1.0373,3.5863,0.58849,0.60253,0.83199,0.29224,2.4709,1.1016,1.0684,0.52675,1.9218,1.2159,2.5342,2.0036,0.61476,0.78894,0.48823,1.7294,0.62431,2.6302,0.13489,0.89718,0.53358,1.7643,0.17786,2.6434-0.35095,0.86952-0.94541,1.6981-1.7858,2.4209z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m432.56,228.01c-0.21644-0.22408-0.97072-0.29971-0.8046-0.63027,0.46165-0.69995,1.36136-0.897,1.9273-1.49703,0.1747,0.0402,0.7713,0.61247,0.6116,0.81388-0.48851,0.4725-1.13288,0.73938-1.6449,1.16959-0.0345,0.0449-0.0638,0.0957-0.0894,0.14383zm0.1838,2.93443c-0.33227,0.00031-0.9584,0.56977-1.03602,0.077-0.32309-1.12016-0.58671-2.40102-0.0382-3.4949,0.24803,0.25102,1.05919,0.29369,0.78918,0.72928-0.23962,0.88974,0.0263,1.8348,0.28504,2.68865zm-5.5555,3.1269c0.24165-0.24517,0.28559-1.10467,0.71099-0.77888,1.13285,0.52543,2.33755,1.1862,3.62501,1.05346,0.76711-0.14137,0.69169-1.10697,0.60297-1.69373-0.0724-0.47388-0.20065-0.93692-0.34532-1.39327,0.34025-0.003,0.98225-0.58685,1.04234-0.0514,0.32177,1.14858,0.691,2.56657-0.12185,3.59798-0.8989,0.93185-2.33305,0.57869-3.41127,0.2031-0.72481-0.25554-1.4211-0.58465-2.10287-0.9373zm-5.3907-4.4197c0.26003-0.17377,0.42626-0.98288,0.75303-0.70375,1.74761,1.34876,3.17059,3.11429,5.10306,4.2189-0.23912,0.24038-0.28903,1.10763-0.70289,0.7734-1.92433-1.1596-3.38257-2.9405-5.1532-4.28855zm0.59685-0.82262zm-3.9082-1.1016c0.26244-0.1656,1.17065-0.0366,0.86662-0.46062,0.73918,0.44436,1.62727,0.6149,2.35231,1.10499,0.25157,0.21081,0.94401,0.38366,0.48689,0.7365-0.21883,0.38572-0.43928,0.6877-0.79916,0.26491-0.79662-0.58135-1.80788-0.73668-2.6245-1.26805-0.14029-0.0923-0.21429-0.22902-0.28216-0.37773zm0.11698,0.2249zm-0.56342-4.1107c0.0787-0.26349-0.19298-1.27637,0.21154-0.84304,0.46913,0.25186,0.33646,0.85901,0.50123,1.29527,0.2255,1.06889,0.4678,2.13423,0.7171,3.19784-0.33234-0.0259-0.99951,0.48933-1.03989-0.008-0.31467-1.34784-0.62072-2.69817-0.88631-4.05662,0.16526,0.1381,0.33189,0.27729,0.49633,0.41473zm0-1.0198c0.4861-0.31319,0.67983,0.76229,0.23216,0.19396-0.0774-0.0646-0.15476-0.12933-0.23216-0.19396zm-0.49777,0.61937c0.30405,0.004,0.86176-0.35157,0.99909-0.11226,0.0652-0.22127-0.52878-0.72969-0.50213-0.37008-0.10507,0.20625,0.22862,1.07027-0.19387,0.80248-0.20495,0.11412-0.3659-0.722-0.30309-0.32014zm0.98599-0.22851zm-1.8574-4.4702c0.31322,0.0111,1.01675,0.6374,0.97039,0.0818,0.27867,1.46619,0.56297,2.93164,0.887,4.38855-0.31111-0.0213-0.90421,0.4058-1.02059,0.0746-0.30315-1.44239-0.62341-2.88895-0.85419-4.34139,0.006-0.0678,0.0109-0.13606,0.0174-0.20353zm-0.0226,0.2718zm2.4507-2.8395c0.20609,0.26438,1.04392,0.41354,0.69115,0.78091-0.55086,0.84242-1.38863,1.41441-2.12727,2.06951-0.25773,0.12076-0.67551-0.23175-0.99198-0.28247,0.38418-0.82403,1.33734-1.14799,1.8758-1.8542,0.19948-0.22549,0.38712-0.46276,0.5523-0.71375zm3.6241-6.1744c0.15942,0.29697,0.93069,0.57142,0.56734,0.88679-1.43417,1.75785-2.12146,3.97171-3.35343,5.85766-0.2067-0.26421-1.0188-0.40371-0.70731-0.77407,1.20605-1.96154,1.93093-4.2399,3.4934-5.97038zm6.7945,1.8184c-0.33024-0.0935-1.09781,0.2836-1.02222-0.24659-0.0803-1.03767-0.11441-2.21694-0.84094-3.03549-0.70057-0.5555-1.60289,0.0247-2.22779,0.42809-0.72328,0.50196-1.36698,1.10876-1.97522,1.74279-0.16338-0.30185-0.97343-0.5943-0.53606-0.90488,1.1013-1.07253,2.31084-2.26274,3.89393-2.50799,1.10944-0.15537,2.01919,0.76231,2.29791,1.76482,0.29893,0.8856,0.37838,1.83332,0.41039,2.75925zm0.89288,3.2435c-0.28165,0.12682-0.58434,0.90341-0.85031,0.57127-0.85362-1.05574-0.99985-2.47684-1.05248-3.78615,0.32246,0.0941,1.07918-0.27646,1.0199,0.22617,0.0737,1.0233,0.16768,2.18778,0.88289,2.98871zm-0.001-0.001zm2.3337,1.003c-0.22846,0.23854-0.25424,1.05637-0.65059,0.81564-0.76383-0.45399-1.77956-0.41441-2.40271-1.10312,0.29443-0.14982,0.57233-0.88469,0.8773-0.57266,0.64487,0.31892,1.38549,0.42718,2.02164,0.7843,0.0515,0.0252,0.10282,0.0509,0.15436,0.0758zm2.7097,2.1455c-0.28964,0.10157-0.64343,0.77036-0.8917,0.50921-0.61038-0.74185-1.40445-1.31634-2.2621-1.74052,0.22896-0.23657,0.25716-1.07342,0.65534-0.80701,0.9572,0.50177,1.83518,1.1861,2.49846,2.03832zm-0.795,0.63019c0.34331,0.43956,0.48598,0.62538,0.0564,0.0727l-0.0423-0.0544-0.0141-0.0181v-0.0002zm1.522,2.2393c-0.29934-0.0581-0.95498,0.3566-1.02219-0.008-0.0999-0.75118-0.004-1.59448-0.49591-2.23115,0.30288-0.11022,0.69598-0.84849,0.9263-0.44629,0.53827,0.79406,0.48139,1.77881,0.5918,2.68576zm0.14562,2.9116c-0.2672-0.22063-1.07545-0.17895-0.86165-0.62774,0.12424-0.72591-0.1915-1.42207-0.2844-2.1321,0.3101,0.0434,0.92138-0.32852,1.0253-0.001,0.18687,0.90359,0.50215,1.86147,0.12075,2.76088zm-1.9254,2.6158c-0.12344-0.29822-0.82486-0.63757-0.50974-0.9043,0.64003-0.58162,1.17481-1.2905,1.4993-2.0956,0.24179,0.20589,1.02697,0.18913,0.86066,0.56286-0.41537,0.942-1.07231,1.77177-1.85022,2.43704z'/%3E %3Cpath d='m417.9,222.59c-0.0238-0.28503-0.0501-0.57487-0.068-0.86711,3.2063-0.87794,5.6927-2.7252,7.722-5.4348-1.1412,2.8948-4.2078,5.2832-7.654,6.3019z' fill='%2321231e'/%3E %3Cpath d='m418.22,224.11c0.099,0.27661,0.19338,0.55323,0.29127,0.82502,3.359,0.0637,6.3719,1.1774,9.1902,3.1437-2.0579-2.3416-5.8216-3.8304-9.4815-3.9688z' fill='%2321231e'/%3E %3Cpath d='m432.69,233.31c-1.0851-0.33555-2.2716-0.68792-3.3638-1.531-1.664-1.2868-1.1806-3.7799,0.24828-6.3536,0.45838-0.82503,0.5121-2.2093,0.27455-3.5659-0.23874-1.3638-0.77232-2.6999-1.4897-3.3866-2.3456-2.2622-3.7804-4.7565-2.5891-6.5857,0.79621-1.2207,1.8813-1.9326,2.8744-2.6037,0.21129,0.62899,0.35095,1.4696,0.3796,2.5544,0.0369,1.4023,0.28171,2.819,1.0325,3.5863,0.5885,0.60252,0.832,0.29224,2.471,1.1016,1.0684,0.52676,1.9218,1.2159,2.5342,2.0036,0.61476,0.78893,0.48823,1.7294,0.62431,2.6302,0.13489,0.89718,0.53357,1.7643,0.17786,2.6434-0.35095,0.86833-0.94541,1.6982-1.7858,2.4209-1.2773,1.1016-1.5996,0.88395-1.9565,1.549-0.45241,0.84547-0.23994,2.1275,0.148,3.3338,0.29605,0.91522,0.43094,1.6416,0.42019,2.2033z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m429.01,232.18c0.20532-0.26939,0.41063-0.53879,0.61595-0.80818,0.93553,0.73203,2.08053,1.11021,3.20363,1.4477-0.0987,0.32472-0.19736,0.64943-0.29604,0.97415-1.2409-0.36968-2.49375-0.80487-3.52354-1.61367zm0.11459-7.0066c0.29445,0.16596,0.58889,0.33193,0.88334,0.49789-0.7068,1.32956-1.41031,2.82253-1.18372,4.36784,0.0893,0.52422,0.37634,1.0117,0.802,1.33272-0.20532,0.26939-0.41063,0.53879-0.61595,0.80818-1.14153-0.83836-1.43459-2.39124-1.15401-3.71248,0.21295-1.1647,0.70435-2.26272,1.26834-3.29415zm0.21844-3.2279c0.33185-0.0593,0.6637-0.11866,0.99555-0.17799,0.20434,1.29181,0.28026,2.70511-0.3315,3.90376-0.29444-0.16596-0.58888-0.33192-0.88332-0.49788,0.48223-0.99083,0.37705-2.17248,0.21927-3.22789zm-1.3417-3.1076c0.23218-0.24566,0.46961-0.4914,0.6985-0.73702,0.96183,0.97886,1.38745,2.34915,1.6392,3.66669-0.33185,0.0593-0.6637,0.11866-0.99555,0.17799-0.21578-1.10597-0.5481-2.2714-1.34215-3.10766zm0.001,0.001zm-2.6631-7.2351c0.28144,0.18597,0.56508,0.37606,0.84513,0.55945-0.69658,1.06305-0.20719,2.40278,0.39728,3.3849,0.57699,0.94919,1.32509,1.78163,2.11876,2.5538-0.23317,0.24534-0.46634,0.49067-0.69951,0.73601-1.35972-1.3493-2.72208-2.89508-3.11244-4.8276-0.15434-0.82427-0.0134-1.70207,0.45078-2.40656zm3.7757-2.4871c-0.31911,0.10904-0.63823,0.21809-0.95734,0.32713,0.15875,0.12448,0.94272,0.16614,0.61981,0.354-0.97607,0.64832-1.95191,1.36417-2.59293,2.36581-0.28171-0.18681-0.56342-0.37362-0.84513-0.56043,0.74418-1.16599,1.8775-1.99673,3.0154-2.7464,0.25325,0.0866,0.50763,0.17319,0.76019,0.25989zm-0.76038-0.25977c0.2901-0.19203,0.64494-0.57503,0.67411,0.002,0.26652,0.48965-0.41622,0.0246-0.65805,0.003l-0.0161-0.005zm1.1662,2.9645c-0.3201-0.0284-0.78164,0.0946-1.01223-0.0296-0.0307-0.79126-0.10132-1.59152-0.35017-2.34777,0.31911-0.10904,0.63823-0.21808,0.95734-0.32712,0.28982,0.87026,0.37667,1.79298,0.40506,2.70452zm0.88811,3.2423c-0.24033,0.23813-0.48066,0.47625-0.72099,0.71438-0.97042-1.05018-1.1226-2.56464-1.1773-3.93025,0.31974,0.0284,0.78237-0.0946,1.01168,0.0297,0.061,1.08937,0.13232,2.32763,0.88661,3.18622zm2.3325,1.0018c-0.14802,0.30467-0.29603,0.60934-0.44405,0.91401-0.67326-0.38481-1.44944-0.50906-2.14615-0.8299-0.20524-0.14515-0.66006-0.36508-0.26335-0.56932,0.22784-0.11238,0.43951-0.71235,0.67783-0.37476,0.57822,0.30124,1.25298,0.38429,1.83311,0.69718,0.11531,0.0514,0.23037,0.10772,0.34261,0.16279zm2.7097,2.1455c-0.26474,0.2092-0.53156,0.4227-0.795,0.6292-0.62264-0.7984-1.45507-1.41409-2.3588-1.8603,0.14802-0.30467,0.29603-0.60934,0.44405-0.91401,1.04079,0.51035,1.99771,1.2313,2.70975,2.14511zm-0.795,0.6302c0.16876,0.21502,0.58031,0.74654,0.18804,0.24174-0.0626-0.0806-0.12563-0.16107-0.18804-0.24174zm1.522,2.2393c-0.33311,0.0511-0.66883,0.1-1.0003,0.15253-0.13457-0.79847,0.006-1.70925-0.5177-2.3919,0.265-0.21006,0.53001-0.42013,0.79501-0.63019,0.66449,0.81116,0.60987,1.89051,0.72299,2.86956zm0.14563,2.9116c-0.31195-0.12828-0.62391-0.25656-0.93586-0.38484,0.2931-0.78464-0.1159-1.59254-0.2102-2.375,0.33343-0.0505,0.66687-0.10103,1.0003-0.15154,0.16888,0.95493,0.55157,1.96245,0.14576,2.91138zm-1.9254,2.6158c-0.21885-0.25817-0.43769-0.51634-0.65654-0.77451,0.70519-0.60578,1.29614-1.3595,1.646-2.2252,0.31195,0.12828,0.62391,0.25656,0.93586,0.38484-0.40873,1.01505-1.09956,1.90865-1.92532,2.61487zm-1.83954,1.40349c-0.29683-0.16115-0.59366-0.32231-0.89049-0.48346,0.38408-0.77784,1.31785-0.96635,1.90032-1.54895,0.26874-0.34011,0.45373,0.30836,0.68149,0.45445,0.35297,0.24979-0.24906,0.42287-0.39951,0.61546-0.38454,0.35592-0.95916,0.48474-1.2665,0.91738l-0.025,0.0458-0.00031-0.00068zm0.18381,2.93444c-0.32071,0.10503-0.64141,0.21006-0.96212,0.31509-0.36408-1.18952-0.69504-2.55747-0.1123-3.73302,0.29683,0.16115,0.59366,0.32231,0.89049,0.48346-0.41814,0.92618-0.0848,2.01268,0.18393,2.93447zm-0.2089,2.84789c0.0987-0.32472,0.19736-0.64944,0.29604-0.97416-0.19966,0.0593-0.69415,0.70347-0.65514,0.28985-0.0346-0.63234-0.19992-1.24828-0.3921-1.8488,0.32071-0.10503,0.64141-0.21005,0.96212-0.31508,0.24306,0.76677,0.45124,1.5601,0.4441,2.3703-0.21837,0.15925-0.43651,0.31887-0.65502,0.47789zm0.65415-0.47746c-0.04,0.29134,0.14228,0.89035-0.33512,0.57621-0.6123-0.0593,0.0625-0.33321,0.27094-0.52934l0.0454-0.0331,0.0188-0.0137h-0.00003zm-0.50613-0.009c-0.1571,0.51694-0.15944,0.52465-0.00099,0.003l0.00099-0.003zm0.50613,0.009c-0.04,0.29134,0.14228,0.89035-0.33512,0.57621-0.6123-0.0593,0.0625-0.33321,0.27094-0.52934l0.0454-0.0331,0.0188-0.0137h-0.00003z'/%3E %3Cpath d='m410.55,216.45c4.0263-0.19844,7.9142,3.3241,8.486,7.6344,0.57059,4.3103-2.2441,7.6561-6.1034,7.7018-3.8592,0.0458-7.4451-3.1136-8.1828-7.2736-0.73769-4.16,1.7738-7.8641,5.8002-8.0626z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m419.54,224.02c-0.33423,0.0449-0.66847,0.0898-1.0027,0.13469-0.44684-3.33325-3.04532-6.34863-6.36491-7.06366-0.52305-0.11266-1.06064-0.14834-1.59477-0.12925-0.0167-0.33913-0.0335-0.67827-0.0502-1.0174,2.84853-0.13664,5.56954,1.45774,7.22179,3.71617,0.94636,1.27423,1.57836,2.78669,1.79079,4.35945zm-6.5988,8.279c-0.004-0.33993-0.008-0.67987-0.0119-1.0198,1.94,0.007,3.8405-1.06386,4.8037-2.75413,0.77465-1.30397,1.0047-2.87948,0.8041-4.37035,0.33423-0.0449,0.66847-0.0898,1.0027-0.13469,0.3311,2.32994-0.35679,4.86789-2.1105,6.49534-1.1973,1.14435-2.83895,1.76949-4.4881,1.78363zm-8.6865-7.6933c0.33185-0.0601,0.66369-0.12027,0.99554-0.1804,0.5471,3.18398,3.04202,6.03864,6.24593,6.71192,0.47069,0.0987,0.95217,0.14532,1.43306,0.14211,0.004,0.33993,0.008,0.67987,0.0119,1.0198-2.97493,0.0397-5.77433-1.73817-7.32978-4.21974-0.67401-1.05443-1.13604-2.24198-1.35665-3.47369zm6.2729-8.6615c0.0167,0.33913,0.0335,0.67827,0.0502,1.0174-1.85997,0.0623-3.64749,1.12179-4.56416,2.74648-0.83308,1.40656-1.04794,3.12139-0.76293,4.71719-0.33184,0.0601-0.66369,0.12026-0.99553,0.18039-0.4451-2.40202,0.18774-5.06723,1.9642-6.80214,1.13709-1.13685,2.7094-1.78745,4.30822-1.85932z'/%3E %3Cpath d='m410.89,218.57c2.9448-0.12868,5.7691,2.4221,6.2024,5.5743,0.43451,3.1522-1.5864,5.6476-4.4584,5.6958-2.8338,0.0505-5.5208-2.3379-6.0389-5.377-0.53358-3.1064,1.3513-5.7643,4.2949-5.893z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m417.59,224.07c-0.33423,0.0465-0.66847,0.093-1.0027,0.13951-0.3324-2.42571-2.25924-4.61465-4.6935-5.06915-0.32551-0.0542-0.65611-0.0783-0.98599-0.0656-0.0143-0.33913-0.0287-0.67827-0.043-1.0174,2.18262-0.0947,4.26262,1.15323,5.48803,2.91352,0.65001,0.91611,1.08065,1.98876,1.23716,3.09912zm-4.9514,6.2754c-0.006-0.33993-0.0111-0.67987-0.0167-1.0198,1.38842,0.001,2.74788-0.77403,3.42043-1.99431,0.5429-0.93532,0.69249-2.06021,0.54471-3.12185,0.33423-0.0465,0.66847-0.093,1.0027-0.13951,0.24751,1.69717-0.2104,3.53873-1.43021,4.78086-0.91218,0.95088-2.20941,1.47701-3.52093,1.49461zm-6.545-5.8003c0.33185-0.0577,0.6637-0.11546,0.99555-0.17319,0.39616,2.33713,2.26013,4.42614,4.61844,4.87745,0.30145,0.0545,0.60799,0.0812,0.91436,0.076,0.006,0.33993,0.0111,0.67987,0.0167,1.0198-2.22591,0.0361-4.31658-1.29421-5.49659-3.1368-0.52526-0.80399-0.88537-1.7192-1.04846-2.66323zm4.77115-6.48829c0.0143,0.33913,0.0287,0.67827,0.043,1.0174-1.33132,0.0373-2.61855,0.78481-3.27694,1.94818-0.58896,1.00022-0.73722,2.21582-0.54185,3.34925-0.33185,0.0577-0.66369,0.11545-0.99554,0.17318-0.32228-1.78013,0.13702-3.74986,1.44067-5.04699,0.87378-0.88694,2.09051-1.39512,3.33066-1.44102z'/%3E %3Cpath d='m411.22,220.72c1.8419-0.0685,3.6026,1.5141,3.8879,3.4889,0.28529,1.9748-0.98599,3.5682-2.7885,3.6067-1.8037,0.0372-3.5011-1.4636-3.8222-3.4059-0.32111-1.9435,0.88215-3.6188,2.7228-3.6885v-0.001z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='m415.6,224.13c-0.33343,0.0489-0.66687,0.0978-1.0003,0.14671-0.20859-1.43809-1.34732-2.73763-2.79308-3.01145-0.18955-0.0356-0.38282-0.0448-0.57536-0.042-0.0127-0.33913-0.0255-0.67827-0.0382-1.0174,1.45037-0.055,2.83064,0.78136,3.63156,1.96118,0.40188,0.58471,0.67498,1.2604,0.77538,1.96296zm-3.2779,4.19c-0.007-0.33993-0.0143-0.67987-0.0215-1.0198,0.8606,0.00054,1.68749-0.52569,2.05363-1.30401,0.26296-0.52871,0.32952-1.13922,0.24539-1.7197,0.33343-0.0489,0.66687-0.0978,1.0003-0.14674,0.18873,1.2052-0.18737,2.52525-1.11494,3.34642-0.58808,0.53562-1.37102,0.82599-2.16288,0.84383zm-4.3319-3.8316c0.33265-0.0561,0.66529-0.11224,0.99794-0.16836,0.22866,1.42227,1.37181,2.70161,2.81388,2.94366,0.1644,0.0285,0.33158,0.0387,0.4983,0.0357,0.007,0.33993,0.0144,0.67987,0.0216,1.0198-1.47341,0.0312-2.8678-0.83845-3.64552-2.06357-0.34693-0.53398-0.58073-1.14137-0.6862-1.7672zm2.7157-3.7727h1.0122c-0.16234,0.16958-0.32469,0.33915-0.48703,0.50873-0.83079,0.0143-1.62304,0.51903-1.9876,1.26563-0.28878,0.55882-0.35704,1.21324-0.2554,1.82923-0.33264,0.0561-0.66529,0.11225-0.99793,0.16838-0.21057-1.20911,0.13596-2.54549,1.05047-3.39361,0.57465-0.55007,1.35937-0.86115,2.15166-0.88754-0.16171,0.16968-0.32668,0.3397-0.48637,0.50918zm1.0122,0v0.49069c-0.16234,0.006-0.32469,0.0121-0.48703,0.0181,0.16233-0.1696,0.32477-0.33916,0.48703-0.50879zm0-0.001c-0.33507,0.002-0.67713,0.002-1.0122,0,0.16234-0.16957,0.32468-0.33915,0.48702-0.50872,0.17503,0.16956,0.35029,0.33922,0.52518,0.50872zm-1.0122,0v-0.49068c0.16234-0.006,0.32468-0.0121,0.48702-0.0181-0.16233,0.1696-0.32476,0.33915-0.48702,0.50878z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m482.14,182.98c3.7685,0,6.822,3.0764,6.822,6.8731,0,3.7968-3.0535,6.8732-6.822,6.8732-3.7673,0-6.822-3.0764-6.822-6.8732,0-3.7956,3.0547-6.8731,6.822-6.8731z' fill='%23FFF'/%3E %3Cpath d='m489.47,189.85h-1.0122c0.0279-2.3407-1.3595-4.6239-3.4526-5.6729-0.88056-0.45505-1.8722-0.69026-2.8629-0.68985v-1.0198c2.501-0.0218,4.943,1.3598,6.2325,3.4992,0.71532,1.1614,1.0948,2.5201,1.0952,3.8834zm-7.3281,7.3831v-1.0198c2.323,0.0279,4.5733-1.3682,5.6113-3.4409,0.46533-0.89843,0.70433-1.9109,0.70411-2.922h1.0122c0.0234,2.5978-1.4383,5.1464-3.7072,6.4175-1.0946,0.63293-2.3573,0.96382-3.6205,0.96528zm-7.3281-7.3831h1.0122c-0.0268,2.3405,1.3593,4.6252,3.454,5.6726,0.87994,0.45554,1.8713,0.69068,2.8616,0.69019v1.0198c-2.4871,0.0217-4.9154-1.3449-6.2102-3.4642-0.731-1.1677-1.116-2.5423-1.1177-3.9184zm7.3281-7.3831v1.0198c-2.3367-0.0273-4.5998,1.3859-5.6293,3.4784-0.45424,0.88884-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71991,2.4984-1.1014,3.8526-1.103z' fill='%2321231e'/%3E %3Cpath d='m482.14,171.07c3.7685,0,6.822,3.0776,6.822,6.8731,0,3.7968-3.0535,6.8732-6.822,6.8732-3.7673,0-6.822-3.0764-6.822-6.8732,0-3.7956,3.0547-6.8731,6.822-6.8731z' fill='%23FFF'/%3E %3Cpath d='m489.47,177.94h-1.0122c0.0283-2.3684-1.3939-4.6771-3.5264-5.7102-0.86217-0.43085-1.8258-0.65232-2.7891-0.65277v-1.0198c2.4873-0.0212,4.9167,1.3441,6.2102,3.4654,0.73156,1.1663,1.1164,2.542,1.1176,3.9174zm-7.3281,7.3831v-1.0198c2.323,0.0279,4.5733-1.368,5.6113-3.4408,0.46534-0.89842,0.70433-1.9109,0.70411-2.922h1.0122c0.0234,2.5978-1.4383,5.1464-3.7072,6.4175-1.0946,0.63293-2.3572,0.96371-3.6205,0.96519zm-7.3281-7.3831h1.0122c-0.0268,2.3405,1.3593,4.6252,3.454,5.6726,0.87994,0.45558,1.8712,0.69084,2.8616,0.6903v1.0198c-2.4871,0.0218-4.9154-1.3447-6.2102-3.4641-0.73103-1.1678-1.116-2.5422-1.1177-3.9186zm7.3281-7.3831v1.0198c-2.3367-0.0273-4.5998,1.3859-5.6293,3.4784-0.45424,0.88884-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71976,2.4982-1.1017,3.8526-1.103z' fill='%2321231e'/%3E %3Cpath d='m482.14,159.61c3.7685,0,6.822,3.0776,6.822,6.8732s-3.0535,6.8731-6.822,6.8731c-3.7673,0-6.822-3.0776-6.822-6.8731,0-3.7956,3.0547-6.8732,6.822-6.8732z' fill='%23FFF'/%3E %3Cpath d='m489.47,166.49h-1.0122c0.0283-2.3684-1.3939-4.6771-3.5264-5.7102-0.8622-0.43079-1.8258-0.65248-2.7891-0.65287v-1.0198c2.4872-0.0211,4.9167,1.3442,6.2102,3.4654,0.73156,1.1663,1.1164,2.542,1.1176,3.9174zm-7.3281,7.3831v-1.0198c2.3229,0.0267,4.5746-1.3678,5.6111-3.4422,0.46571-0.89789,0.70461-1.91,0.7043-2.9208h1.0122c0.0215,2.5073-1.3364,4.9677-3.474,6.2798-1.1492,0.71924-2.499,1.1017-3.8537,1.103zm-7.3281-7.3831h1.0122c-0.0281,2.3687,1.3947,4.6769,3.5273,5.7098,0.86177,0.43137,1.8252,0.6527,2.7883,0.65312v1.0198c-2.5015,0.0216-4.9429-1.3608-6.2325-3.5004-0.71673-1.1606-1.0934-2.5196-1.0953-3.8823zm7.3281-7.3831v1.0198c-2.3367-0.0272-4.5998,1.386-5.6293,3.4785-0.45424,0.88884-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71998,2.4986-1.1013,3.8526-1.1031z' fill='%2321231e'/%3E %3Cpath d='m482.14,127.08c3.7685,0,6.822,3.0776,6.822,6.8731,0,3.7968-3.0535,6.8744-6.822,6.8744-3.7673,0-6.822-3.0776-6.822-6.8744,0-3.7956,3.0547-6.8731,6.822-6.8731z' fill='%23FFF'/%3E %3Cpath d='m489.47,133.95h-1.0122c0.0283-2.3684-1.3939-4.6771-3.5264-5.7102-0.86217-0.43085-1.8258-0.6523-2.7891-0.65276v-1.0198c2.4873-0.0212,4.9168,1.3441,6.2102,3.4654,0.73156,1.1663,1.1164,2.542,1.1176,3.9174zm-7.3281,7.3843v-1.0198c2.3228,0.0272,4.5728-1.3687,5.6107-3.4413,0.4656-0.89881,0.70527-1.9113,0.70469-2.9229h1.0122c0.0236,2.5845-1.4229,5.1189-3.6708,6.3984-1.1035,0.64565-2.3797,0.98346-3.6568,0.98567zm-7.3281-7.3843h1.0122c-0.0273,2.3546,1.3765,4.6517,3.4903,5.692,0.87087,0.44417,1.8485,0.67153,2.8254,0.67208v1.0198c-2.4732,0.021-4.8893-1.3292-6.1878-3.4303-0.7467-1.1744-1.1379-2.5639-1.1401-3.9537zm7.3281-7.3831v1.0198c-2.3367-0.0271-4.5998,1.3859-5.6293,3.4785-0.45424,0.88884-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71996,2.4986-1.1013,3.8526-1.1031z' fill='%2321231e'/%3E %3Cpath d='m482.14,137.16c3.7685,0,6.822,3.0764,6.822,6.8719,0,3.7968-3.0535,6.8743-6.822,6.8743-3.7673,0-6.822-3.0776-6.822-6.8743,0-3.7956,3.0547-6.8719,6.822-6.8719z' fill='%23FFF'/%3E %3Cpath d='m489.47,144.03h-1.0122c0.0283-2.3546-1.3775-4.6491-3.4895-5.6909-0.87167-0.44187-1.849-0.67136-2.826-0.67081v-1.0198c2.5647-0.0233,5.0658,1.4324,6.3285,3.6617,0.65615,1.1223,0.99754,2.4212,0.99923,3.7199zm-7.3281,7.3843v-1.0198c2.3228,0.027,4.5728-1.3686,5.6107-3.4413,0.46559-0.89882,0.70527-1.9113,0.70469-2.923h1.0122c0.0236,2.5845-1.4229,5.1189-3.6708,6.3984-1.1035,0.64578-2.3799,0.98315-3.6568,0.98567zm-7.3281-7.3843h1.0122c-0.0273,2.3545,1.3765,4.6517,3.4903,5.692,0.87087,0.44419,1.8485,0.67155,2.8254,0.6721v1.0198c-2.4875,0.0215-4.9157-1.3454-6.2102-3.4654-0.73184-1.1671-1.1157-2.5427-1.1177-3.9185zm7.3281-7.3819v1.0198c-2.3643-0.0284-4.6529,1.4195-5.666,3.5512-0.43071,0.86977-0.64884,1.8407-0.64952,2.8104h-1.0122c-0.021-2.5072,1.3361-4.9682,3.4752-6.2786,1.1475-0.71967,2.499-1.1022,3.8526-1.1029z' fill='%2321231e'/%3E %3Cpath d='m482.14,148.16c3.7685,0,6.822,3.0776,6.822,6.8732,0,3.7968-3.0535,6.8744-6.822,6.8744-3.7673,0-6.822-3.0776-6.822-6.8744,0-3.7956,3.0547-6.8732,6.822-6.8732z' fill='%23FFF'/%3E %3Cpath d='m489.47,155.03h-1.0122c0.0283-2.3684-1.3939-4.6771-3.5264-5.7102-0.86219-0.43078-1.8258-0.65246-2.7891-0.65286v-1.0198c2.4873-0.0211,4.9167,1.3443,6.2102,3.4654,0.73156,1.1663,1.1164,2.542,1.1176,3.9174zm-7.3281,7.3843v-1.0198c2.3228,0.0272,4.5728-1.3686,5.6107-3.4412,0.46559-0.89882,0.70528-1.9113,0.70469-2.923h1.0122c0.0236,2.5845-1.4229,5.1189-3.6708,6.3984-1.1035,0.64568-2.3797,0.98331-3.6568,0.98556zm-7.3281-7.3843h1.0122c-0.0273,2.3545,1.3765,4.6517,3.4903,5.692,0.87087,0.44418,1.8485,0.67154,2.8254,0.67209v1.0198c-2.4732,0.021-4.8893-1.3292-6.1878-3.4303-0.7467-1.1744-1.1379-2.5638-1.1401-3.9537zm7.3281-7.3831v1.0198c-2.3367-0.0272-4.5998,1.386-5.6293,3.4785-0.45425,0.88883-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71984,2.4984-1.1016,3.8526-1.1031z' fill='%2321231e'/%3E %3Cpath d='m486.99,195.51c0.97764,1.5779,0.7186,1.8858,1.3596,2.3933,0.82602,0.65184,2.1821,0.65905,3.482,0.45581,5.2451-0.82502,4.5134,2.3512,2.194,5.9267-1.1591,1.7871-3.8521,3.5851-5.2582,5.1209-1.405,1.5358-1.5256,2.8094-2.0806,3.193-2.0126,0.0481-3.7506,0.0577-4.5384,0.0433h-0.004c-0.78784,0.0145-2.5247,0.006-4.5372-0.0433-0.55387-0.38364-0.67445-1.6572-2.0806-3.193-1.405-1.5358-4.0992-3.3338-5.2582-5.1209-2.3194-3.5743-3.0499-6.7517,2.194-5.9267,1.2999,0.20324,2.6572,0.19603,3.482-0.45581,0.64221-0.50753,0.38317-0.8154,1.3608-2.3933,0.63504-1.0222,1.3978-1.7895,2.2274-2.3019,0.82841-0.51113,1.7213-0.2321,2.6154-0.2321,0.89288,0,1.7858-0.27903,2.6154,0.2321,0.82841,0.51233,1.5924,1.2796,2.2274,2.3019h-0.001z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m488.66,197.51c-0.25615,0.15897-0.44919,0.92333-0.74608,0.69824-0.65656-0.60854-0.74168-1.57756-1.26883-2.28148-0.15902-0.27227,0.63977-0.59748,0.80908-0.61857,0.45224,0.63894,0.65581,1.41476,1.0613,2.07114,0.0433,0.0485,0.0981,0.0913,0.14453,0.13067zm-0.62311,0.80096zm3.716-0.44858c-0.0558,0.33175,0.41491,1.05164-0.0991,1.0452-1.21583,0.15079-2.59273,0.18537-3.6168-0.5954,0.25751-0.18209,0.43785-0.87062,0.74611-0.71456,0.88584,0.52005,1.99912,0.396,2.96976,0.26476zm2.6954,6.7096c-0.21622-0.26844-1.07505-0.39896-0.69711-0.79492,0.70951-1.19866,1.5394-2.4757,1.52441-3.91707-0.0389-0.91203-1.10254-1.12267-1.83547-1.1138-0.51326-0.009-1.02498,0.0479-1.53179,0.1243,0.0541-0.33898-0.42619-1.07584,0.12276-1.04642,1.27965-0.15434,2.85152-0.26411,3.79853,0.78665,0.87125,1.13445,0.34647,2.66298-0.18185,3.82782-0.34211,0.74152-0.75819,1.44834-1.19948,2.13344zm-5.3108,5.187c-0.16591-0.29815-0.99767-0.57565-0.55041-0.89343,1.61803-1.6703,3.66422-2.92823,5.01365-4.85162,0.19868,0.2549,1.01451,0.38827,0.72338,0.73963-1.4251,1.9598-3.53609,3.26125-5.18662,5.00542zm-2.4399,3.3566c-0.10771-0.29507,0.21889-1.20241-0.29074-0.93087,0.50374-0.68185,0.77128-1.59705,1.32109-2.28885,0.23372-0.22157,0.48022-0.86891,0.76989-0.73127,0.20661,0.28514,0.90994,0.53926,0.40696,0.86298-0.74768,0.80428-1.05837,1.88644-1.67992,2.76849-0.13161,0.17624-0.31467,0.27581-0.52728,0.31952zm0.27456-0.089zm-4.8249,0.13349c0.10055-0.28918-0.20356-0.98805,0.15315-1.01795,1.45767,0.0103,2.91549-0.009,4.37276-0.0419-0.0978,0.32293,0.27588,1.09427-0.23494,1.02427-1.42216,0.0315-2.90195,0.0483-4.29097,0.0355zm0-1.0198,0.009,0-0.009,0zm-0.004,0c0.007,0.18828,0.007,1.16276-0.001,0.8795,0.004-0.28959-0.0174-0.60511,0.001-0.8795zm-0.009,0,0.009,0-0.009,0zm-4.8142,0.88636c0.0843-0.3026,0.8781-0.8476,0.30604-0.92598,1.47155,0.0306,3.01038,0.055,4.50811,0.0385-0.0884,0.30082,0.21533,0.9817-0.142,1.0218-1.48709-0.003-2.98334,0.0204-4.46428-0.0676-0.0688-0.0217-0.14003-0.0465-0.20787-0.0667zm0.27456,0.089zm-2.4399-3.3566c0.30676-0.14124,0.64671-0.95061,0.92422-0.48554,0.76613,0.82111,1.18399,1.87226,1.73172,2.83174,0.13732,0.27929-0.38,0.61826-0.49076,0.92116-0.74417-0.62803-0.90451-1.67486-1.49742-2.42455-0.202-0.29619-0.42878-0.57771-0.66776-0.84281zm-5.3108-5.187c0.32541-0.0881,0.77284-0.80664,0.9913-0.34844,1.42087,1.87707,3.46791,3.13397,5.06192,4.84514-0.30593,0.14039-0.63056,0.92742-0.91939,0.50443-1.67299-1.70367-3.7674-3.00839-5.13383-5.00113zm2.6954-6.7096c-0.15404,0.30995,0.0839,1.14701-0.43308,0.96888-0.93251-0.0906-2.04935-0.26333-2.82315,0.38614-0.57249,0.74686-0.13118,1.7557,0.16273,2.53089,0.33971,0.79388,0.77931,1.54033,1.2459,2.26536-0.32919,0.0907-0.79828,0.8345-0.99812,0.32127-0.83305-1.39557-1.77588-2.91632-1.67857-4.60387,0.0601-1.17015,1.20221-1.92008,2.29113-1.97038,0.74402-0.0788,1.49657-0.008,2.23316,0.10171zm3.0929-0.35239c0.1059,0.30815,0.86791,0.71576,0.42386,0.94287-1.09222,0.67724-2.45109,0.59195-3.67181,0.4161,0.15196-0.29508-0.0755-1.10323,0.39034-0.973,0.94572,0.1025,2.04228,0.19971,2.85761-0.38597zm1.2438-2.2634c0.18953,0.2426,0.95573,0.35211,0.77227,0.67971-0.55743,0.74242-0.6248,1.80136-1.3933,2.38449-0.11005-0.30814-0.79916-0.66343-0.47621-0.93426,0.40004-0.64504,0.5978-1.40991,1.0419-2.03915-0.003-0.0363,0.0489-0.0572,0.0553-0.0908zm0,0.001zm2.3922-2.4666c0.0736,0.30734,0.68895,0.74034,0.38432,0.9599-0.78607,0.52398-1.42415,1.24707-1.9194,2.0468-0.20586-0.25504-1.04171-0.37039-0.72927-0.74069,0.58948-0.89805,1.34584-1.70025,2.26435-2.26601zm2.8792-0.30789c-0.0984,0.2987,0.21121,1.0188-0.1814,1.0148-0.72121-0.008-1.50828-0.23454-2.1701,0.1617-0.0682-0.31396-0.76119-0.79623-0.33071-0.97771,0.83689-0.43928,1.78824-0.21551,2.68221-0.19879zm2.8804,0.30789c-0.25196,0.19932-0.33583,1.00378-0.7033,0.7769-0.69761-0.28442-1.4529-0.0518-2.1771-0.066,0.0917-0.30031-0.19041-0.9697,0.1528-1.0218,0.91804-0.055,1.90647-0.22518,2.7276,0.3109zm-0.001,0zm1.9636,3.246c-0.0506-0.23628,0.12393-1.35018-0.13505-0.77382-0.17984,0.47884-0.35543,0.62304-0.58228,0.10153-0.47851-0.67149-1.07144-1.2704-1.775-1.7055,0.24322-0.20381,0.35042-0.9986,0.6947-0.76242,0.91004,0.60319,1.65268,1.43526,2.2261,2.3594-0.14275,0.26028-0.28608,0.52048-0.42847,0.78081zm0.42855-0.78052c0.0946,0.28795,0.8281,0.93128,0.13387,0.78052-0.68178,0.15413-0.52984-0.1851-0.22479-0.61493,0.0303-0.0552,0.0606-0.11039,0.0909-0.16559zm-0.42974-0.23933c-0.0817,0.24202,0.16861,1.06094-0.12235,0.95113-0.60517-0.13251,0.031-0.61965,0.12235-0.95117v0.00004zm-0.42854,0.77932c-0.0942-0.28758-0.82715-0.9306-0.13267-0.77932,0.7181-0.16191,0.47158,0.24659,0.18938,0.67619l-0.0338,0.0615-0.0229,0.0417z'/%3E %3Cpath d='m481.35,212.77-0.88335-0.13228c-0.4703-3.7799-1.9696-6.9008-4.3236-9.6272,2.6476,1.8028,4.6184,5.6705,5.2069,9.7595z' fill='%2321231E'/%3E %3Cpath d='m494.21,198.3c-0.46674,1.1485-0.96451,2.4017-1.9792,3.4624-1.5422,1.6104-4.0991,0.56644-6.5749-1.5166-0.78067-0.65544-2.1606-0.97293-3.5345-0.96812-1.3739,0.005-2.7419,0.33313-3.4975,0.96812-2.4757,2.083-5.0326,3.1269-6.5749,1.5166-1.0146-1.0595-1.5112-2.3127-1.9768-3.4624,0.59565-0.11064,1.3799-0.0974,2.3826,0.0602,1.2999,0.20324,2.656,0.19604,3.482-0.45461,0.6422-0.50752,0.38317-0.81659,1.3608-2.3933,0.63385-1.0235,1.3978-1.7907,2.2274-2.3031,0.82842-0.51113,1.7213-0.23211,2.6142-0.23211,0.89408,0,1.787-0.27902,2.6166,0.23211,0.82842,0.51233,1.5924,1.2796,2.2274,2.3031,0.97763,1.5767,0.7186,1.8858,1.3596,2.3933,0.82603,0.65184,2.1821,0.65785,3.482,0.45461,1.0039-0.15755,1.7894-0.17078,2.385-0.0602z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m492.6,202.12c-0.24272-0.23572-0.48544-0.47144-0.72816-0.70716,0.89443-0.92371,1.4057-2.12571,1.8755-3.30234,0.31195,0.12908,0.62391,0.25817,0.93586,0.38725-0.51484,1.29723-1.09758,2.60754-2.0832,3.62225zm-7.2624-1.4793c0.21612-0.26031,0.43126-0.5227,0.64799-0.78173,1.21827,0.98952,2.57463,1.99566,4.18032,2.17533,0.62461,0.0603,1.27764-0.15353,1.70578-0.62149,0.24272,0.23572,0.48544,0.47145,0.72816,0.70717-0.8946,0.99207-2.38639,1.14062-3.59543,0.71645-1.36868-0.43825-2.57589-1.28662-3.66682-2.19573zm0.64699-0.78173c0.12688,0.10511,0.78556,0.66149,0.394,0.33152-0.13121-0.11046-0.26335-0.22126-0.394-0.33152zm-3.8568-0.0673c-0.00067-0.33993-0.001-0.67987-0.002-1.0198,1.34122,0.0153,2.77978,0.22898,3.85919,1.0873-0.21566,0.26057-0.43132,0.52115-0.64698,0.78172-0.89742-0.68763-2.1137-0.8346-3.21021-0.84922zm-3.174,0.84908c-0.21556-0.26031-0.43555-0.5227-0.64837-0.78173,1.06989-0.84737,2.49249-1.06051,3.81995-1.0866,0.00067,0.33993,0.001,0.67987,0.002,1.0198-1.09219,0.0222-2.28424,0.17005-3.17358,0.84853zm-7.2636,1.4793c0.24272-0.23572,0.48543-0.47144,0.72815-0.70716,0.7601,0.84571,2.03884,0.71397,2.98696,0.29974,1.06835-0.43757,2.01682-1.11851,2.89915-1.85379,0.21646,0.26057,0.43291,0.52115,0.64937,0.78172-1.40405,1.14524-3.0026,2.28522-4.86854,2.41562-0.88872,0.053-1.78673-0.28378-2.39509-0.93613zm-1.7046-4.3175c0.0613,0.33433,0.12256,0.66867,0.18384,1.003,0.14437-0.13228,0.3231-0.89658,0.4409-0.53564,0.44753,1.1243,0.95574,2.26119,1.8083,3.14235-0.24271,0.23572-0.48543,0.47143-0.72814,0.70715-0.98561-1.01425-1.56863-2.32575-2.08065-3.62358,0.12504-0.23065,0.25173-0.46478,0.37575-0.69328zm-0.37601,0.69394c-0.13032-0.31513-0.40447-0.70914,0.14535-0.65127,0.48146-0.17084-0.0961,0.42816-0.13805,0.63779l-0.007,0.0135zm2.9281-0.63621c-0.0517,0.33593-0.10345,0.67187-0.15518,1.0078-0.73023-0.10759-1.47997-0.18718-2.2133-0.0617-0.0613-0.33433-0.12255-0.66867-0.18382-1.003,0.84479-0.14626,1.71066-0.0664,2.5523,0.0569zm3.0929-0.35117c0.20749,0.26739,0.41664,0.53422,0.6231,0.80196-1.10247,0.82644-2.5788,0.74267-3.87107,0.5554,0.0517-0.33593,0.10345-0.67187,0.15518-1.0078,1.01556,0.1359,2.21137,0.2702,3.09279-0.34956zm0.6231,0.80096c-0.27731,0.22077-0.64203,0.50621-0.15598,0.12305,0.0519-0.0409,0.10435-0.0828,0.15598-0.12305zm0.62073-3.0632c0.28569,0.1796,0.57138,0.35919,0.85707,0.53879-0.45692,0.64745-0.66583,1.42351-1.0635,2.09936-0.15895,0.18968-0.42817,0.62268-0.58392,0.20634-0.0853-0.23862-0.63963-0.5133-0.30649-0.7161,0.3606-0.53969,0.50729-1.20084,0.86915-1.74697,0.073-0.12869,0.15007-0.25621,0.22769-0.38142zm2.3922-2.4678c0.17587,0.28944,0.35173,0.57888,0.5276,0.86832-0.85161,0.5282-1.5374,1.29132-2.0627,2.1385-0.28569-0.1796-0.57139-0.35919-0.85708-0.53879,0.6068-0.98113,1.40569-1.85965,2.39218-2.46803zm2.878-0.30788v1.0198c-0.77796,0.0191-1.63382-0.26801-2.3503,0.1566-0.17587-0.28944-0.35174-0.57889-0.52761-0.86833,0.86671-0.56924,1.91321-0.33519,2.87791-0.30807zm2.8816,0.30788c-0.17581,0.28915-0.35573,0.5806-0.529,0.86832-0.71717-0.4257-1.57377-0.1383-2.3526-0.1574v-1.0198c0.96839-0.0267,2.01134-0.26182,2.8816,0.30888zm-0.001,0zm2.3922,2.4678c-0.2854,0.18009-0.57308,0.35892-0.85707,0.53979-0.52534-0.84757-1.2118-1.61177-2.0641-2.1397,0.17667-0.28944,0.35333-0.57889,0.53-0.86833,0.98402,0.61061,1.78689,1.48688,2.39117,2.46824zm1.2426,2.2622c-0.20817,0.26672-0.4153,0.53557-0.62411,0.80097-0.72497-0.54059-0.8041-1.51683-1.29693-2.22588-0.37681-0.33877,0.12667-0.46407,0.38325-0.65083,0.30128-0.36229,0.4322,0.0289,0.57764,0.29202,0.34919,0.5263,0.46491,1.18027,0.84321,1.68194,0.0357,0.0352,0.0824,0.0724,0.11694,0.10178zm-0.62311,0.80097c-0.38375-0.30215-0.38144-0.30219,0.0002,0h-0.0002zm3.716-0.44979c0.0517,0.33593,0.10345,0.67187,0.15518,1.0078-1.29202,0.18685-2.77058,0.27305-3.87105-0.5569,0.2077-0.26699,0.4154-0.53398,0.6231-0.80097,0.88238,0.62374,2.08239,0.48551,3.09277,0.35007zm2.9305,0.6374c-0.31195-0.12908-0.6239-0.25817-0.93585-0.38725,0.034,0.20575,0.61155,0.79167,0.1709,0.66413-0.66988-0.0769-1.34701-0.006-2.0107,0.0927-0.0517-0.33593-0.10345-0.67187-0.15518-1.0078,0.84312-0.12503,1.70875-0.20318,2.5546-0.0577,0.12536,0.232,0.25114,0.46382,0.37623,0.69592zm-0.37602-0.69514c0.33558,0.0592,0.81149,0.0418,0.46653,0.4727-0.11688,0.50521-0.30575-0.30438-0.45872-0.45829l-0.008-0.0144h-0.00001zm-0.0919,0.50151c0.48893,0.20233,0.50833,0.21035,0.008,0.003l-0.008-0.003zm0.0919-0.50151c0.33558,0.0592,0.81149,0.0418,0.46653,0.4727-0.11688,0.50521-0.30575-0.30438-0.45872-0.45829l-0.008-0.0144h-0.00001z'/%3E %3Cpath d='m482.14,211.65c4.2698,0,7.7316,3.4877,7.7316,7.7896s-3.4617,7.7896-7.7316,7.7896c-4.2698,0-7.7304-3.4877-7.7304-7.7896s3.4605-7.7896,7.7304-7.7896z' fill='%23EDB92E'/%3E %3Cpath d='m482.94,212.77,0.88214-0.13228c0.47032-3.7799,1.9696-6.9008,4.3236-9.6272-2.6476,1.8028-4.6184,5.6705-5.2057,9.7595z' fill='%2321231e'/%3E %3C/g%3E %3Cuse xlink:href='%23g3987' transform='matrix(-1,0,0,1,964.28557,0)'/%3E %3Cg%3E %3Cpath stroke='%2321231e' stroke-width='1.01444578' fill='%23edb92e' d='m576.93,293.58c2.0018,0.30308,3.0618,1.5683,2.9914,2.8611,0.0692,1.294-0.99197,2.5592-2.9962,2.8623-0.45479,0.12386-0.96331,0.21647-1.5291,0.26578-60.788,5.2363-125.72,5.2375-186.51,0-0.56461-0.0493-1.0731-0.14192-1.5291-0.26578-2.0042-0.30307-3.0654-1.5683-2.995-2.8623-0.0692-1.2929,0.98957-2.558,2.9902-2.8611,0.456-0.12508,0.96689-0.21647,1.5339-0.26578,60.789-5.2375,125.72-5.2351,186.51,0,0.5682,0.0493,1.0779,0.1407,1.5339,0.26578z'/%3E %3Cpath fill='%2321231e' d='m412.13,298.41c-0.76635-0.0252-0.76295-1.36398,0-1.3888,0.59174,0.0185,2.72417-0.21214,3.92052-0.24171,6.46351-0.38192,12.9315-0.71027,19.4001-0.97481,0.66075,2.11101-2.21204,0.97043-3.42686,1.35993-3.69659,0.16703-7.39259,0.34756-11.0873,0.55187,4.85318,0.26466,9.70802,0.49891,14.5643,0.6996,0.56067,2.14616-2.08298,0.81013-3.24918,1.07593-6.71085-0.29953-13.4193-0.65489-20.1234-1.07903,0.071-0.52587-0.042,0.0465,0.002-0.003zm0.0429-0.69634zm46.617-2.629c0.61492,2.12525-2.23274,0.9246-3.45596,1.2879-6.61392,0.1571-13.2266,0.36881-19.8367,0.6428-0.6608-2.11204,2.21374-0.97075,3.42929-1.35009,6.61919-0.25294,13.2407-0.44599,19.8634-0.58061zm23.348-0.22608c0.57186,2.13774-2.24892,0.87788-3.47971,1.21605-6.61542,0.0172-13.2308,0.0871-19.8449,0.21995-0.61477-2.12735,2.23458-0.92079,3.45841-1.2767,6.62081-0.11139,13.2475-0.15944,19.8662-0.1593zm23.348,0.26096c0.52671,2.14846-2.26785,0.83068-3.50493,1.14298-6.61431-0.11788-13.2296-0.18116-19.845-0.18568-0.57113-2.13727,2.25278-0.87765,3.48329-1.20421,6.62225,0.0251,13.2484,0.10837,19.8666,0.24691zm23.342,0.73843c0.48183,2.15877-2.28534,0.78424-3.52851,1.07207-6.612-0.25751-13.2263-0.45441-19.8417-0.59847-0.5264-2.14956,2.27087-0.8295,3.50843-1.13091,6.62237,0.16071,13.2432,0.38148,19.8618,0.65731zm23.322,1.2087c0.35453-0.15541,0.96012,0.97474,0.2053,1.248-2.37546,0.22975-5.54571,0.34822-8.22215,0.517-5.10136,0.28017-10.2045,0.52748-15.3092,0.7403-0.66089-2.11121,2.21192-0.97192,3.42675-1.36234,3.35945-0.15015,6.7182-0.31554,10.0763-0.49406-4.51675-0.24334-9.0351-0.45662-13.5544-0.6466-0.48421-2.16106,2.28693-0.78348,3.53075-1.06106,6.61801,0.29462,13.2371,0.65235,19.8466,1.05876zm-0.0394,0.64342,0,0.005,0-0.005zm-116.61,0.70476c0.77874-0.004,0.72839,1.28362-0.0507,1.2102,0.0171-0.40094,0.033-0.81666,0.0507-1.2102zm93.325,1.1569c-0.77816,0.0714-0.83268-1.21321-0.052-1.2093,0.0175,0.39961,0.0337,0.82021,0.052,1.2093z'/%3E %3Cpath fill='%2321231e' d='m482.37,265.18-22.74,11.455-0.45122-0.91161,22.74-11.455,0.45122,0,0,0.91162zm-0.45122-0.91162,0.22561-0.11305,0.22561,0.11305-0.45122,0zm22.74,12.367-22.74-11.455,0.45122-0.91161,22.74,11.455,0,0.9116-0.45122,0zm0.45122-0.9116,0.90483,0.45581-0.90483,0.45579,0-0.9116zm-23.191,11.455,22.74-11.455,0.45122,0.9116-22.74,11.455-0.45122,0,0-0.9116zm0.45122,0.9116-0.22561,0.11306-0.22561-0.11306,0.45122,0zm-22.74-12.367,22.74,11.455-0.45122,0.91161-22.74-11.455,0-0.91161,0.45122,0zm-0.45122,0.91161-0.90483-0.4558,0.90483-0.45581,0,0.91161z'/%3E %3Cpath fill='%230c4076' d='m482.14,269.15c5.651,0,10.234,3.0776,10.234,6.8731,0,3.7968-4.5826,6.8732-10.234,6.8732-5.651,0-10.232-3.0764-10.232-6.8732,0-3.7956,4.5814-6.8731,10.232-6.8731z'/%3E %3Cpath fill='%2321231e' d='m492.88,276.02c-0.39628-0.0793-1.17356,0.25337-1.03186-0.39271-0.24304-2.32505-2.2509-3.98603-4.26585-4.87326-1.70676-0.75518-3.58053-1.09433-5.44189-1.097,0.0937-0.37485-0.27829-1.22325,0.39061-1.01333,3.30274,0.0929,6.81132,1.17694,8.999,3.77776,0.82543,1.0137,1.35162,2.28029,1.34999,3.59854zm-10.74,7.3831c0.0937-0.37769-0.2783-1.21482,0.39063-1.02516,3.0039-0.0957,6.21119-1.04138,8.21473-3.40259,0.67794-0.82943,1.12681-1.87277,1.12204-2.95492,0.3818,0.083,1.20536-0.25848,0.9966,0.39207-0.20774,2.64588-2.36513,4.65985-4.65817,5.7063-1.88842,0.88551-3.98756,1.27866-6.06583,1.2843zm-10.738-7.383c0.3963,0.0793,1.17364-0.25338,1.03196,0.39272,0.24272,2.32492,2.24909,3.98639,4.26455,4.87326,1.70657,0.75523,3.58061,1.09493,5.44189,1.09708-0.0937,0.37485,0.27829,1.22325-0.39061,1.01333-3.30197-0.0929-6.81187-1.176-8.9978-3.77777-0.82651-1.0125-1.35102-2.28116-1.34999-3.59862zm10.738-7.3831c-0.0937,0.37769,0.2783,1.21482-0.39063,1.02516-3.00445,0.096-6.21089,1.04228-8.21472,3.40401-0.67678,0.82938-1.12575,1.87215-1.12075,2.9537-0.38182-0.083-1.20544,0.25849-0.9967-0.39207,0.20749-2.64549,2.36531-4.65854,4.65687-5.7063,1.88889-0.88546,3.98744-1.27799,6.06593-1.2845z'/%3E %3Cpath fill='%23edb92e' d='m482.14,211.65c4.2698,0,7.7316,3.4877,7.7316,7.7896s-3.4617,7.7896-7.7316,7.7896c-4.2698,0-7.7304-3.4877-7.7304-7.7896s3.4605-7.7896,7.7304-7.7896z'/%3E %3Cpath fill='%2321231e' d='m490.38,219.44h-1.0122c0.0307-2.69177-1.57395-5.31759-3.9895-6.50853-0.99731-0.50844-2.11693-0.7707-3.23575-0.77059v-1.0198c2.81193-0.0235,5.55681,1.53018,7.00575,3.93604,0.80721,1.3033,1.23003,2.83302,1.2317,4.36288zm-8.2377,8.2995v-1.0198c2.67198,0.0311,5.25994-1.58427,6.43849-3.97654,0.51969-1.01768,0.78651-2.16077,0.78666-3.30268h1.0122c0.0246,2.88919-1.58246,5.72366-4.08819,7.16713-1.24769,0.74343-2.70009,1.12957-4.14916,1.13189zm-8.2365-8.2995h1.0122c-0.0306,2.69123,1.57245,5.31792,3.9881,6.50852,0.99733,0.50841,2.1169,0.77088,3.23575,0.77069v1.0198c-2.7959,0.0234-5.52584-1.51249-6.98009-3.89619-0.82215-1.31137-1.25537-2.8581-1.25596-4.40282zm8.2365-8.2995v1.0198c-2.67154-0.031-5.26015,1.58361-6.4373,3.97655-0.51966,1.01769-0.78668,2.16073-0.78676,3.30267h-1.0122c-0.0226-2.81828,1.5022-5.58529,3.90657-7.05886,1.28957-0.81079,2.80889-1.23901,4.32969-1.24016z'/%3E %3Cpath fill='%23edb92e' d='m482.14,213.71c3.1394,0,5.6844,2.564,5.6844,5.727,0,3.1642-2.545,5.7282-5.6844,5.7282s-5.6844-2.564-5.6844-5.7282c0-3.163,2.545-5.727,5.6844-5.727z'/%3E %3Cpath fill='%2321231e' d='m488.33,219.44h-1.0122c0.0218-1.92029-1.11622-3.7938-2.83474-4.65272-0.72087-0.37292-1.53276-0.56331-2.34366-0.56438v-1.0198c2.1012-0.0172,4.15313,1.13629,5.24634,2.92784,0.61775,0.98617,0.94199,2.14687,0.94426,3.30906zm-6.1905,6.2381v-1.0198c1.92848,0.0226,3.79638-1.15118,4.63189-2.88577,0.36284-0.72015,0.54493-1.52712,0.5464-2.33253h1.0122c0.0171,2.1066-1.11514,4.17601-2.9065,5.28725-0.97643,0.62082-2.12812,0.94861-3.28399,0.95085zm-6.191-6.238h1.0122c-0.0219,1.93247,1.13043,3.81729,2.86595,4.67005,0.71323,0.36208,1.51319,0.54728,2.31245,0.54824v1.0198c-2.1012,0.0172-4.15313-1.1363-5.24635-2.92784-0.61861-0.98609-0.94151-2.14797-0.94425-3.31025zm6.1905-6.237v1.0198c-1.90551-0.022-3.75153,1.12283-4.60183,2.82398-0.3815,0.73585-0.57526,1.56512-0.57658,2.39312h-1.0122c-0.0171-2.11828,1.12933-4.19725,2.93611-5.30517,0.97057-0.60782,2.11016-0.92984,3.2545-0.93173z'/%3E %3Cpath fill='%230c4076' d='m482.14,215.83c1.9768,0,3.5787,1.614,3.5787,3.6055,0,1.9916-1.6019,3.6055-3.5787,3.6055-1.9756,0-3.5787-1.6152-3.5787-3.6055,0-1.9916,1.6031-3.6055,3.5787-3.6055z'/%3E %3Cpath fill='%2321231e' d='m486.23,219.44h-1.0122c0.0152-1.20121-0.74035-2.36698-1.84623-2.83826-0.38477-0.17115-0.80603-0.25661-1.22677-0.25739v-1.0198c1.32693-0.009,2.62637,0.68445,3.36603,1.78466,0.46821,0.68106,0.7171,1.50568,0.71917,2.33079zm-4.0848,4.1155v-1.0198c1.192,0.015,2.34008-0.74418,2.80758-1.83821,0.17704-0.39396,0.26457-0.82622,0.26552-1.25764h1.0123c0.009,1.37354-0.71855,2.72385-1.8782,3.46221-0.65203,0.42623-1.42897,0.65167-2.2072,0.65344zm-4.0848-4.1155h1.0122c-0.0146,1.20131,0.74109,2.36751,1.84753,2.83826,0.38426,0.17134,0.80529,0.25636,1.22558,0.25739v1.0198c-1.31942,0.009-2.61173-0.67689-3.35297-1.76686-0.47733-0.68414-0.72964-1.5167-0.73234-2.34859zm4.0848-4.1155v1.0198c-1.19976-0.0146-2.35452,0.75442-2.81713,1.85915-0.17019,0.38848-0.25504,0.81275-0.25584,1.2365h-1.0122c-0.008-1.33117,0.67321-2.64034,1.77278-3.39196,0.6743-0.46988,1.49103-0.72228,2.31239-0.72349z'/%3E %3Cpath d='m482.156,256.301c-43.811,0.21546-67.7872,2.12298-101.625,5.28937-2.02242,0.18925-3.08656,0.89329-3.5,1.21345-0.92466,0.71605-1.32296,1.91247-1.21875,2.98694,0.0927,0.9557,1.12251,3.15638,4.90625,2.76914,23.5771-2.41292,63.7284-5.42575,101.344-5.19603,33.7227,0.20595,66.8395,1.65152,100.875,5.13381,3.00818,0.30777,4.78549-0.35776,5.40625-2.30244,0.53807-1.68562-0.43231-3.14247-1.90625-3.85813-1.9886-0.96554-4.65184-0.94268-8.40625-1.27568-31.1675-2.76438-67.3206-4.90087-95.875-4.76043zm0.125,1.08898c28.7518-0.19006,65.1972,1.71859,95.75,4.63599,3.75206,0.35827,7.1273,0.62131,8,1.21344,1.03365,0.70134,1.84661,1.33975,1.3125,2.76915-0.33591,0.89898-1.0415,1.80792-4.28125,1.46235-33.2559-3.54733-67.801-4.9481-100.906-5.1338-38.2581-0.21459-77.4416,2.5462-101,5.1338-3.78374,0.41561-4.15102-1.0562-4.3125-1.80461-0.20339-0.94266,0.11832-1.5515,1.09375-2.27132,0.44591-0.32906,0.76009-0.57567,2.78125-0.77785,30.6681-3.06777,57.7222-4.93733,101.562-5.22715z' fill='%2321231e'/%3E %3C/g%3E %3C/g%3E %3Cpath d='m314.58,301.17,0,271.32,0,0.004c0.00099,48.555,18.82,92.636,49.174,124.58s72.248,51.749,118.39,51.749h0.00599c46.145-0.00099,88.036-19.805,118.39-51.747,30.356-31.943,49.174-76.026,49.175-124.58v-271.31c-111.71-0.0105-223.43,0.0152-335.14-0.00099z' fill='%23C6363C'/%3E %3Cpath fill='%23FFF' d='m313.39,300c0.1913,94.2424-0.38257,188.499,0.28683,282.732,2.19028,42.5696,19.7274,84.2695,49.2088,115.138,3.18197-4.31506-7.18653-9.19381-9.0302-14.0508-27.6221-34.671-40.243-79.6868-38.107-123.694v-257.765h332.78c-0.19204,93.4137,0.384,186.842-0.2878,280.247-2.85479,67.338-47.2018,131.996-111.115,155.153-17.5416,6.56314-36.2692,9.84193-54.9891,9.8786,1.1411,5.43872,12.1996,0.63827,17.2225,1.4299,63.8825-6.28011,119.605-53.7793,140.576-113.741,11.2656-28.9559,11.5662-60.3486,10.9518-90.9522v-244.376c-112.499,0.00002-224.998,0.00005-337.497,0.00007z'/%3E %3Cg%3E %3Cg stroke='%2321231e' stroke-width='0.99388075' fill='%23FFF'%3E %3Cpath d='m483.67,734.79c1.4555-0.23969,3.9126,0.0669,5.7692-1.3934,2.47-1.9421,1.4907-9.7869,1.2678-14.751-1.1353-25.354-2.1733-68.034-3.4634-127.97-2.1123-0.28786-3.6499-0.13982-5.0949,0.0787-1.4438-0.21853-2.9814-0.36657-5.0937-0.0787-1.2901,59.939-2.3281,102.62-3.4646,127.97-0.22167,4.964-1.2022,12.809,1.269,14.751,1.8566,1.4604,4.3137,1.1526,5.7692,1.3934h3.0412z'/%3E %3Cpath d='m499.55,734.06c-1.4719-0.10574-3.8903,0.42296-5.8724-0.86238-2.6354-1.7095-2.8524-9.7329-3.0799-14.696-1.1623-25.353-3.508-67.829-7.6458-127.64,2.0771-0.47819,3.6229-0.46996,5.0808-0.38419,0.22753-0.0564,0.45858-0.10927,0.69315-0.16096,9.527,59.168,13.124,101.14,19.648,126.46,0.90075,3.4953,2.8348,12.254-0.17592,15.099-1.717,1.6225-4.1918,1.5403-5.6191,1.9104l-3.0283,0.27611v-0.001z'/%3E %3Cpath d='m518.2,731.39c-1.4754,0.0271-3.8364,0.77426-5.9264-0.32662-2.7796-1.4639-2.6671-9.4721-3.9056-14.28-6.5246-25.321-10.122-67.309-19.653-126.5,2.0255-0.66617,3.5643-0.79777,5.0245-0.84475l0.20641-0.0681c15.15,57.536,19.692,98.095,31.451,123.15,1.0884,3.4718,4.0522,12.691,1.2186,15.903-1.5646,1.7729-4.0358,1.9139-5.4244,2.4132l-2.9908,0.54985z'/%3E %3Cpath d='m536.98,726.08c-1.4649,0.17387-3.9349,1.5391-6.1234,0.65089-2.911-1.1808-3.3661-9.747-5.4608-14.209-11.813-25.169-16.342-65.982-31.66-123.94,1.9504-0.86239,3.4693-1.1455,4.9178-1.337,1.3277-0.60976,1.0755-0.92347,3.1854-1.2325,17.797,57.241,23.578,97.056,40.366,121.76,2.7104,3.9876,4.6937,11.975,2.8559,14.525-1.3816,1.9186-3.827,2.304-5.1594,2.9384l-2.9228,0.8424h0.001z'/%3E %3Cpath d='m464.75,734.06c1.4719-0.10574,3.8904,0.42296,5.8725-0.86238,2.6366-1.7095,2.8524-9.7329,3.0799-14.696,1.1635-25.353,3.508-67.829,7.6458-127.64-2.0771-0.47819-3.6218-0.46996-5.0808-0.38419-0.22753-0.0564-0.45741-0.10927-0.69315-0.16096-9.527,59.168-13.124,101.14-19.648,126.46-0.89958,3.4953-2.8336,12.254,0.17593,15.099,1.7182,1.6225,4.1918,1.5403,5.6203,1.9104l3.0283,0.27611-0.001-0.001z'/%3E %3Cpath d='m446.09,731.39c1.4743,0.0271,3.8364,0.77426,5.9264-0.32662,2.7785-1.4639,2.6659-9.4721,3.9044-14.28,6.5246-25.321,10.122-67.309,19.655-126.5-2.0255-0.66617-3.5655-0.79777-5.0257-0.84475l-0.20524-0.0681c-15.151,57.536-19.693,98.095-31.451,123.15-1.0884,3.4718-4.0534,12.691-1.2186,15.903,1.5634,1.7729,4.0358,1.9139,5.4244,2.4132l2.9908,0.54985z'/%3E %3Cpath d='m427.31,726.08c1.4649,0.17387,3.9349,1.5391,6.1234,0.65089,2.911-1.1808,3.3661-9.747,5.462-14.209,11.812-25.169,16.341-65.982,31.659-123.94-1.9504-0.86239-3.4693-1.1455-4.9178-1.337-1.3277-0.60976-1.0755-0.92347-3.1854-1.2325-17.797,57.241-23.578,97.056-40.366,121.76-2.7093,3.9876-4.6937,11.975-2.8559,14.525,1.3816,1.9186,3.827,2.304,5.1594,2.9384l2.9227,0.8424h-0.00099z'/%3E %3Cpath d='m527.05,682.84c-1.3406,0.0811-3.3602,0.89879-5.4643-0.10457-2.7984-1.3347-4.6257-9.0667-6.1258-13.873-11.915-23.54-22.791-65.347-40.632-123.45,1.7276-0.72844,3.108-0.91407,4.4322-1.0128,1.1752-0.51695,2.4536-0.98809,4.3782-1.162,19.215,57.497,27.843,99.074,46.623,121.97,3.101,3.7796,5.4068,12.025,3.9314,14.414-1.1072,1.7976-3.3368,2.0267-4.5143,2.5672l-2.6295,0.64855h0.00099z'/%3E %3Cpath d='m511.85,685.82c-1.3441-0.0271-3.4494,0.62739-5.4268-0.54046-2.6319-1.5521-3.5619-9.3945-4.5014-14.299-4.8016-25.052-13.658-67.097-26.244-126.12,1.8038-0.58628,3.1995-0.6603,4.5284-0.65442,1.2292-0.42063,2.5556-0.78719,4.492-0.80716,14.871,58.657,18.311,102.58,32.376,125.13,2.5627,4.1086,3.9982,12.402,2.2566,14.663-1.3101,1.7001-3.5561,1.7506-4.7899,2.1947l-2.6917,0.4359z'/%3E %3Cpath d='m496.38,687.58c-1.3347-0.13394-3.5045,0.34894-5.34-0.97048-2.4407-1.7565-2.4642-9.6354-2.8348-14.592-1.8977-25.321-5.876-67.88-11.614-127.64,1.8625-0.43942,3.2605-0.403,4.5823-0.28902,1.2726-0.32076,2.6342-0.58041,4.5636-0.4453,8.0551,59.573,12.736,102.71,17.833,127.14,1.0169,4.8723,2.5521,12.664,0.55829,14.776-1.4989,1.5873-3.7402,1.458-5.0186,1.8023l-2.7304,0.21854z'/%3E %3Cpath d='m437.24,682.84c1.3406,0.0811,3.3602,0.89879,5.4643-0.10457,2.7984-1.3347,4.6257-9.0667,6.1258-13.873,11.915-23.54,22.791-65.347,40.632-123.45-1.7276-0.72844-3.108-0.91407-4.4322-1.0128-1.174-0.51695-2.4536-0.98809-4.3782-1.162-19.215,57.497-27.843,99.074-46.623,121.97-3.0998,3.7796-5.4068,12.025-3.9314,14.414,1.1072,1.7976,3.3368,2.0267,4.5143,2.5672l2.6295,0.64855h-0.00099z'/%3E %3Cpath d='m452.44,685.82c1.3429-0.0271,3.4482,0.62739,5.4268-0.54046,2.6319-1.5521,3.5608-9.3945,4.5002-14.299,4.8016-25.052,13.659-67.097,26.245-126.12-1.805-0.58628-3.1995-0.6603-4.5296-0.65442-1.228-0.42063-2.5545-0.78719-4.4908-0.80716-14.871,58.657-18.311,102.58-32.378,125.13-2.5627,4.1086-3.9982,12.402-2.2554,14.663,1.3101,1.7001,3.5549,1.7506,4.7887,2.1947l2.6929,0.4359z'/%3E %3Cpath d='m467.92,687.58c1.3347-0.13394,3.5045,0.34894,5.34-0.97048,2.4407-1.7565,2.4642-9.6354,2.836-14.592,1.8977-25.321,5.876-67.88,11.614-127.64-1.8636-0.43942-3.2605-0.403-4.5823-0.28902-1.2726-0.32076-2.6342-0.58041-4.5647-0.4453-8.054,59.573-12.735,102.71-17.832,127.14-1.0169,4.8723-2.5533,12.664-0.55945,14.776,1.5001,1.5873,3.7402,1.458,5.0198,1.8023l2.7304,0.21854h-0.00099z'/%3E %3Cpath d='m483.52,688.09c1.3124-0.23967,3.5279,0.0682,5.2028-1.3923,2.2284-1.9421,1.3441-9.7881,1.1435-14.752-1.0239-25.356-1.9598-68.036-3.1233-127.98-1.9059-0.28784-3.2922-0.13981-4.5952,0.0787-1.303-0.21736-2.6882-0.36656-4.594-0.0787-1.1635,59.942-2.0994,102.62-3.1233,127.98-0.20055,4.964-1.0849,12.81,1.1424,14.752,1.676,1.4604,3.8915,1.1526,5.2039,1.3923h2.7433z'/%3E %3Cpath d='m516.54,647.97c-1.0274,0.0811-2.5744,0.89997-4.1859-0.1034-2.1428-1.3358-3.542-9.0667-4.6914-13.873-9.1259-23.54-17.457-65.347-31.123-123.45,1.3241-0.72726,2.3809-0.91289,3.3942-1.0128,0.90075-0.51696,1.8801-0.98692,3.3543-1.162,14.718,57.497,21.327,99.074,35.711,121.97,2.375,3.7797,4.1413,12.025,3.0119,14.415-0.84914,1.7964-2.5568,2.0267-3.4576,2.566l-2.015,0.64971h0.00099z'/%3E %3Cpath d='m504.9,650.96c-1.0298-0.0271-2.6413,0.62623-4.1566-0.54046-2.0161-1.552-2.728-9.3945-3.4482-14.299-3.6769-25.054-10.461-67.099-20.101-126.12,1.3828-0.58628,2.4512-0.6603,3.4681-0.65442,0.94179-0.42062,1.9575-0.78719,3.4411-0.80716,11.391,58.657,14.025,102.58,24.799,125.13,1.9634,4.1086,3.0623,12.402,1.7288,14.663-1.004,1.7001-2.7234,1.7506-3.6687,2.1947l-2.0619,0.43589z'/%3E %3Cpath d='m493.05,652.72c-1.0216-0.13511-2.6835,0.34896-4.0897-0.97164-1.8695-1.7553-1.8871-9.6354-2.1721-14.592-1.452-25.32-4.5002-67.88-8.8949-127.64,1.4274-0.43824,2.4982-0.40182,3.5103-0.28902,0.97464-0.32076,2.0185-0.57924,3.4963-0.44412,6.1692,59.573,9.7546,102.71,13.659,127.14,0.77877,4.8723,1.9551,12.664,0.42808,14.776-1.1482,1.5873-2.8653,1.4581-3.8446,1.8011l-2.0912,0.21971h-0.00099z'/%3E %3Cpath d='m447.75,647.97c1.0274,0.0811,2.5744,0.89997,4.1859-0.1034,2.1428-1.3358,3.542-9.0667,4.6914-13.873,9.1259-23.54,17.457-65.347,31.123-123.45-1.3241-0.72726-2.3809-0.91289-3.3942-1.0128-0.90075-0.51696-1.8789-0.98692-3.3543-1.162-14.718,57.497-21.327,99.074-35.711,121.97-2.375,3.7797-4.1413,12.025-3.0119,14.415,0.84914,1.7964,2.5568,2.0267,3.4576,2.566l2.015,0.64971h-0.00099z'/%3E %3Cpath d='m459.39,650.96c1.0286-0.0271,2.6413,0.62623,4.1566-0.54046,2.015-1.552,2.728-9.3945,3.447-14.299,3.678-25.054,10.462-67.099,20.101-126.12-1.3816-0.58628-2.4501-0.6603-3.4681-0.65442-0.94062-0.42062-1.9575-0.78719-3.44-0.80716-11.391,58.657-14.025,102.58-24.8,125.13-1.9622,4.1086-3.0623,12.402-1.7276,14.663,1.0028,1.7001,2.7234,1.7506,3.6675,2.1947l2.063,0.43589z'/%3E %3Cpath d='m471.25,652.72c1.0227-0.13511,2.6846,0.34896,4.0897-0.97164,1.8707-1.7553,1.8883-9.6354,2.1721-14.592,1.4532-25.32,4.5002-67.88,8.8949-127.64-1.4274-0.43824-2.497-0.40182-3.5103-0.28902-0.97464-0.32076-2.0173-0.57924-3.4951-0.44412-6.1704,59.573-9.7558,102.71-13.66,127.14-0.77877,4.8723-1.9551,12.664-0.42692,14.776,1.1482,1.5873,2.8641,1.4581,3.8434,1.8011l2.0924,0.21971z'/%3E %3Cpath d='m483.2,653.23c1.0063-0.23967,2.7034,0.0681,3.9865-1.3923,1.7065-1.9421,1.0298-9.7869,0.87611-14.751-0.78463-25.357-1.5024-68.037-2.3938-127.98-1.459-0.28785-2.5216-0.13981-3.5197,0.0787-0.99809-0.21852-2.0595-0.36656-3.5186-0.0787-0.89136,59.942-1.6091,102.62-2.3938,127.98-0.15364,4.964-0.83038,12.809,0.87612,14.751,1.2831,1.4604,2.9802,1.1526,3.9865,1.3923h2.1006z'/%3E %3Cpath d='m474.88,559.13c-0.0786,4.2484-0.13019,9.015-0.16185,13.914l-0.047,0.0154-10.59,2.2006c-0.0234,4.8312,11.917,55.429,18.064,55.429,6.1539,0,18.088-50.631,18.064-55.462l-10.588-2.1677-0.0481-0.0153c-0.0329-4.8993-0.0833-9.6659-0.16185-13.914-2.2249,1.847-4.6808,5.0709-7.2658,7.9823-2.5861-2.9114-5.0386-6.1353-7.2635-7.9823h-0.002z'/%3E %3C/g%3E %3Cg%3E %3Cg id='g3464'%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m412.13,584.52c-3.2019,0.13746-7.1298,1.9703-18.607,11.936-5.0092,10.24-10.058,20.537-17.019,29.416-2.3762,1.5708-4.2387,2.6658-6.1223,3.2886-1.9645,0.64854-16.435,0.17036-16.788-0.43589-4.5026-4.0898-11.384-1.1749-9.0872,3.1382-1.7839,1.6942,2.144,7.8883,5.3013,5.3188,2.8981-2.3592,12.985-0.13158,16.346-1.3523-1.2714,3.0312-10.384,5.0051-16.755,5.468-5.822,0.2479-5.435,6.0637-3.0342,10.524,2.7269,1.7412,0.48791-0.45703,1.4778,0.81539,2.6061,3.869,8.1818,3.3661,8.3683-0.41591,0.19469-3.916,13.787-9.0115,15.825-12.016-2.4923,5.9438-8.2393,11.489-11.094,17.31-3.0646,3.0818-4.9283,3.6974-0.96525,9.9115,4.3982-0.50287,4.6562-1.6719,7.3631,0.89057,6.012-0.65794,6.9843-2.445,6.0108-7.2104-1.0298-5.0333,3.1772-14.139,4.5765-16.711,1.2913-2.3733,1.6068-4.8382,2.8618-6.3245,2.1803-2.5824,12.571-7.7508,15.232-6.3315,4.8966,2.6118,8.6345,1.0316,9.2514-3.7174-1.5775-1.2231-0.39407-7.9682-3.7824-8.2537-2.7703-0.2338-4.4123,0.62035-6.9573,2.7023-4.0112,3.2792-6.0695,5.025-7.3901,4.6608-3.1268-0.86121,5.6649-5.1802,13.66-15.683,11.081-14.553,11.841-21.948,11.327-26.928l0.00099-0.00099z' fill='%23EDB92E'/%3E %3Cuse xlink:href='%23path1214' transform='matrix(-1,0,0,1,801.63351,0)'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m345.18,634.54c-4.0123-2.3522-6.3181-2.2593-7.8745-0.50873-0.85501,0.96225-1.9481,0.4641-1.3089-1.0468,2.6682-6.3139,6.9233-7.0999,10.741-4.1403,1.0696,0.99044,1.9282,1.8422,2.7879,2.6917-0.64038,0.94815-3.8282,2.277-4.3454,3.0042z' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m402.64,628.89c4.2586-2.9008,8.2498-3.4683,10.436-1.8387,1.2022,0.89528,2.3903,0.25262,1.3324-1.236-4.417-6.2199-9.5939-6.536-13.5-3.0289-1.0603,1.1491-1.9035,2.1301-2.7456,3.1088,1.337,1.4663,4.2914,3.1194,4.4768,2.9948z' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m369.09,664.55c0.12901-0.25729-0.97815-5.4398-2.7116-7.0588-1.3488,1.0809-2.8629,2.0349-4.2868,3.5224-4.2598,4.4517-4.241,11.011,2.4137,16.728,1.6432,1.4122,2.3926-0.0764,1.7288-1.7001-1.1353-2.7763,0.24395-6.3186,2.8559-11.492z' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m352.47,650.93c-3.956,1.6437-5.3212,3.7268-5.177,6.4631,0.0786,1.505-0.90895,2.0655-1.4672,0.31605-4.8368-11.243,0.18062-13.347,7.43-12.938,0.41636,1.9586-0.61457,6.0872-0.78698,6.1588h0.001z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m383.95,621.26c0.3374,0.20443,0.6748,0.40886,1.0122,0.61329-0.3244,0.50656-0.34001,1.1771-0.0602,1.70646,0.4121,0.80365,1.17014,1.35457,1.92862,1.80651-0.19821,0.3415-0.39642,0.683-0.59463,1.0245-0.95832-0.56597-1.88564-1.29077-2.39267-2.30615-0.39948-0.78123-0.43536-1.74297-0.0555-2.53875,0.0473-0.10524,0.10465-0.20602,0.16216-0.30586zm6.5058,0.81656c-0.24786,0.30665-0.49573,0.6133-0.74359,0.91995-0.81429-0.64465-1.60347-1.33429-2.5099-1.84933-0.39091-0.20626-0.8601-0.4293-1.30322-0.2542-0.42602,0.19069-0.69677,0.59875-0.93815,0.98008-0.3374-0.20404-0.6748-0.40808-1.0122-0.61212,0.39642-0.6551,0.93046-1.30294,1.69088-1.53077,0.69094-0.21537,1.42902,0.00076,2.0456,0.3324,0.95154,0.51593,1.77912,1.2239,2.62229,1.8952,0.0494,0.0389,0.099,0.0835,0.14829,0.11879z'/%3E %3Cpath fill='%2321231e' d='m387.33,617.58c0.3374,0.20443,0.6748,0.40887,1.0122,0.6133-0.32411,0.50693-0.33904,1.17676-0.0601,1.70661,0.41244,0.80334,1.16992,1.35483,1.92808,1.80733-0.19821,0.3411-0.39642,0.6822-0.59463,1.0233-0.95852-0.56475-1.88467-1.28976-2.39268-2.30383-0.39611-0.77618-0.43762-1.73031-0.0636-2.52292,0.05-0.11127,0.10711-0.22041,0.17073-0.32379zm6.5058,0.81656c-0.24786,0.30704-0.49572,0.61407-0.74358,0.92111-0.81287-0.64683-1.60458-1.33345-2.5099-1.8505-0.39147-0.20529-0.85995-0.4288-1.30331-0.25327-0.4266,0.18942-0.69751,0.59861-0.93807,0.98033-0.3374-0.20443-0.6748-0.40887-1.0122-0.6133,0.3933-0.64965,0.92118-1.29208,1.67269-1.52411,0.70153-0.22678,1.45512-0.005,2.0807,0.33511,0.96699,0.5283,1.80731,1.2511,2.66548,1.9347,0.0293,0.0226,0.059,0.0507,0.0882,0.0699z'/%3E %3Cpath fill='%2321231e' d='m390.88,612.83c0.35303,0.18211,0.70607,0.36422,1.0591,0.54633-0.4265,0.80663-0.40479,1.80508-0.002,2.6161,0.45277,0.94343,1.25296,1.66552,2.09913,2.25504-0.22402,0.32897-0.44803,0.65795-0.67205,0.98692-1.14831-0.79271-2.20783-1.83054-2.68436-3.17096-0.38433-1.04823-0.31033-2.24642,0.2-3.23343zm7.145,1.1032c-0.27367,0.28902-0.54733,0.57805-0.821,0.86707-0.89004-0.83429-1.74809-1.71752-2.7606-2.40633-0.38725-0.23925-0.84397-0.51655-1.3161-0.38752-0.51241,0.19724-0.80796,0.70377-1.07237,1.15504-0.061,0.14719-0.12686,0.27895-0.27847,0.13391-0.29917-0.15432-0.59833-0.30865-0.8975-0.46297,0.39201-0.74961,0.88739-1.5244,1.68435-1.88791,0.63621-0.28989,1.37902-0.17431,1.98468,0.1361,0.96794,0.49186,1.7618,1.2521,2.55437,1.98031,0.30895,0.28724,0.61952,0.58946,0.92264,0.8723z'/%3E %3Cpath fill='%2321231e' d='m394.82,607.72c0.3581,0.17428,0.7162,0.34855,1.0743,0.52283-0.4936,0.9997-0.43902,2.21783,0.0679,3.20131,0.48703,0.98869,1.29989,1.77423,2.17694,2.42177-0.23418,0.32427-0.46836,0.64855-0.70254,0.97282-1.2606-0.92605-2.39716-2.14156-2.86574-3.66498-0.35306-1.13018-0.27296-2.38932,0.24913-3.45375zm7.552,1.2666c-0.28305,0.28158-0.56609,0.56317-0.84914,0.84475-0.95102-0.9464-1.86116-1.95016-2.95441-2.73751-0.40338-0.26228-0.88515-0.57213-1.38628-0.42766-0.53587,0.22046-0.83891,0.75983-1.11382,1.23929-0.082,0.0872-0.1013,0.33917-0.21727,0.31813-0.34367-0.16708-0.68735-0.33415-1.03102-0.50122,0.4081-0.82193,0.91008-1.68634,1.76458-2.10654,0.66373-0.32396,1.45422-0.19818,2.08445,0.14388,1.03064,0.55043,1.85771,1.39744,2.68784,2.20391,0.3412,0.33631,0.67943,0.6905,1.01507,1.02297z'/%3E %3Cpath fill='%2321231e' d='m399.15,602.61c0.33387,0.21109,0.66773,0.42218,1.0016,0.63327-0.47378,0.72384-0.62251,1.64944-0.36688,2.47931,0.37412,1.25297,1.27919,2.25861,2.2239,3.12472,0.1479,0.13461,0.29967,0.26478,0.45242,0.39384-0.25255,0.3043-0.50511,0.60861-0.75766,0.91291-1.21965-1.02962-2.3743-2.2367-2.94617-3.75499-0.38495-1.02829-0.38643-2.2076,0.0818-3.20945,0.088-0.19975,0.1969-0.39971,0.31103-0.57961zm7.525,1.4299c-0.28969,0.26905-0.57939,0.53811-0.86908,0.80716-0.87256-0.92719-1.71627-1.89687-2.7299-2.67519-0.41247-0.294-0.92379-0.62869-1.45131-0.4578-0.60689,0.24764-0.99162,0.82048-1.35128,1.33991-0.0699,0.20983-0.19153,0.18383-0.33631,0.052-0.26276-0.16594-0.52553-0.33187-0.7883-0.49781,0.49754-0.76789,1.06777-1.56896,1.92948-1.95195,0.71916-0.33396,1.56783-0.16199,2.22047,0.24359,1.02913,0.62365,1.84574,1.52697,2.67427,2.38571,0.2357,0.24954,0.46771,0.50499,0.70196,0.75435z'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m462.62,580.6-9.4895-5.3752c-3.9924,2.8668-6.9456,13.516-0.12315,22.215,8.5032,10.843,11.947,18.704,14.025,27.481,6.1891-7.9294,8.3178-16.27,4.3876-24.406-5.3024-10.976-8.753-17.165-8.7999-19.915z' fill='%23FFF'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m470.37,573.01-9.4895-5.3752c-3.9924,2.8679-12.335,13.179-5.5136,21.877,8.5032,10.843,17.338,19.044,19.415,27.819,6.1903-7.9282,8.8233-16.271,4.8943-24.407-5.3024-10.975-9.2585-17.164-9.3066-19.913z' fill='%23FFF'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m449.43,569.16-9.4895-5.3752c-3.9924,2.8668-6.9456,13.515-0.12315,22.214,8.5043,10.844,11.947,18.706,14.025,27.482,6.1903-7.9294,8.319-16.271,4.3888-24.407-5.3036-10.975-8.753-17.164-8.8011-19.913z' fill='%23FFF'/%3E %3Cpath d='m405.49,468.99c0.18179,8.6778-1.3558,66.559-1.8402,74.738-0.48321,8.1444-4.0921,13.695-7.9378,16.877-3.5268-4.8488-5.632-11.392-6.134-19.156-0.25451-3.9582,0.47382-58.733,0.77759-69.991,6.4812-17.161,11.29-17.811,15.134-2.4685z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m404.14,543.76c-1.71385,0.35612-0.65866-1.76311-0.86398-2.77246,0.80624-23.2651,1.45647-46.5386,1.72476-69.8165-0.45774-1.11048,0.48063-3.37179,0.98854-1.55775-0.14541,21.3149-0.82314,42.6232-1.45118,63.9284-0.11718,3.40644-0.22042,6.81502-0.39814,10.2183zm-8.8351,17.141c1.19201-0.71951-0.38875-0.72748,1.28027-1.75743,4.12388-4.02511,6.25829-9.7519,6.56258-15.4419,1.71842-0.3589,0.65513,1.74111,0.71012,2.73536-0.80615,5.55881-3.46906,10.9457-7.83516,14.5557-0.23921-0.0307-0.4788-0.0609-0.71781-0.0917zm0.71778,0.0916zm-6.9468-19.508c1.61235-0.56846,0.88306,1.53273,1.22074,2.48472,0.66676,5.78243,2.36629,11.5855,5.81041,16.3466-1.11271,1.37933-1.62561-0.97142-2.29533-1.71086-3.00554-5.18815-4.34436-11.1834-4.73582-17.1205zm0.80928-70.199c1.63934-0.0179,0.69619,1.53574,0.89839,2.78445-0.37555,22.1585-0.76737,44.3199-0.7433,66.482,0.15753,1.87534-1.66343,0.53588-1.00619-0.82738,0.0296-22.7602,0.37564-45.5202,0.81936-68.2759l0.0317-0.16332,0.00004,0.00011zm-0.0317,0.16331zm16.128-2.4661c-1.60133,0.62436-1.10848-1.41608-1.68493-2.46449-0.96888-2.75913-1.68286-6.07452-4.23682-7.82059-2.19049-0.75026-3.66401,1.73845-4.73245,3.24856-1.88502,3.03716-3.23129,6.36639-4.51312,9.6917-1.80255-0.20645,0.009-2.0384,0.15064-3.08955,1.65247-3.68467,3.13667-7.78405,6.38705-10.3763,1.85652-1.50747,4.33692-0.12192,5.27887,1.74935,1.69251,2.75877,2.56024,5.95076,3.35076,9.06136zm-0.0153-0.11044z'/%3E %3Cpath d='m367.87,454.83-2.456,79.583c-0.77525,7.06,8.4175,49.073,13.442,57.361,12.436-5.3176,15.062-33.821,12.721-61.594-2.3398-27.775,0.39173-51.76,2.2882-56.751,0.16537-6.2822-0.8902-12.835-0.95235-19.378-7.9179,0.47349-17.125,0.30431-25.043,0.77896z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m364.91,534.4c0.81863-26.5277,1.63727-53.0553,2.4559-79.583,2.00906-0.18992,0.46287,2.96295,0.86084,4.28783-0.7758,25.1215-1.54947,50.243-2.32661,75.3645-0.33003-0.023-0.66013-0.0465-0.99013-0.0693zm0.99222,0.0305zm12.751,56.888c0.71842,2.27904-1.44719-1.0928-1.57931-2.05384-4.50783-11.7892-7.16035-24.193-9.73103-36.5212-1.07185-6.07705-2.51239-12.182-2.43058-18.3819,1.89867-0.10345,0.50712,2.7447,1.12252,3.99929,1.77987,14.1235,5.05062,28.0354,8.93429,41.7182,1.21964,3.88287,2.3376,7.85254,4.30355,11.4391-0.20641-0.0662-0.41312-0.13375-0.61944-0.19958zm0.38939,0.91642zm12.031-62.01c1.93699-0.45988,0.80991,2.71145,1.29055,3.94258,0.83056,14.4316,0.94984,29.207-2.93253,43.2484-1.78479,5.78999-4.54688,12.1486-10.3891,14.8192-1.04447-1.57962,2.04223-1.66927,2.71858-2.91727,5.78612-5.6445,7.45667-14.0154,8.76412-21.6833,1.79248-12.3778,1.54492-24.9734,0.54839-37.4095zm2.2871-56.806c2.04742-0.29514-0.19317,2.50286,0.0752,3.6844-2.58042,15.6214-2.62798,31.5632-1.78443,47.3381,0.11353,1.90151,0.25629,3.80109,0.41208,5.69957-1.93503,0.46199-0.81088-2.70098-1.29263-3.92954-0.98689-16.2253-0.967-32.6247,1.58228-48.7127,0.22985-1.30314,0.61102-3.10937,1.00755-4.07975zm0.99223,0.0259zm-1.4192-18.894c0.0296-2.28165,0.77742,1.03598,0.5323,1.93507,0.23314,5.65586,1.02818,11.2892,0.88609,16.9585-1.75242,0.39268-0.67625-1.92271-0.99542-2.96314-0.14784-5.48368-0.89866-10.9348-0.9498-16.4228,0.17564,0.16405,0.35109,0.32849,0.52683,0.49232zm-0.0586-0.99397zm-24.517,1.2912c-2.36485-0.29954,1.60977-0.80775,2.50872-0.66251,7.3336-0.29875,14.6796-0.20342,22.0085-0.6292,0.44083,1.91066-2.56017,0.75067-3.74954,1.17357-7.07633,0.26342-14.1634,0.18751-21.2344,0.5998,0.15546-0.16045,0.31147-0.3214,0.46673-0.48166zm-0.99224-0.0305zm0.49612,0.0153zm-0.49612-0.0153z'/%3E %3Cpath d='m353.13,467.85,1.6889,79.603c-0.4058,7.094,10.96,48.541,16.409,56.542,12.613-9.7893,10.075-49.808,8.1419-61.917-3.8516-24.13-3.1972-52.079-1.8684-56.621-0.16068-6.2822-0.32136-13.805-0.72364-20.334-7.8827,0.9082-15.764,1.8188-23.647,2.727h-0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m354.32,547.47c-0.56297-26.5343-1.12593-53.0687-1.6889-79.603,2.00539-0.29152,0.61507,2.96023,1.08562,4.27026,0.53168,25.1168,1.0682,50.2336,1.59686,75.3503-0.33118-0.006-0.66244-0.012-0.99358-0.0176zm0.99457-0.0212zm15.608,56.159c1.15861,2.07973-1.51036-0.96724-1.60246-2.02495-5.18426-11.7058-8.51903-24.1327-11.7547-36.4899-1.3327-5.82587-3.02426-11.6605-3.24412-17.6619,1.892-0.20216,0.64851,2.72254,1.33118,3.94472,2.51654,14.0296,6.51833,27.7686,11.1216,41.2455,1.41213,3.78013,2.727,7.65191,4.86263,11.0993-0.23799-0.0375-0.47647-0.0754-0.71421-0.1127zm0.60753,0.78719zm7.3479-62.232c1.9043-0.59003,0.97768,2.67526,1.51917,3.86328,1.4132,14.2565,1.8245,28.8288-1.06518,42.9333-1.30923,5.62379-3.19524,11.6222-7.80198,15.4355-1.41041-1.30428,1.64154-2.17497,2.00776-3.57635,4.87138-7.28239,5.81354-16.3273,6.58413-24.8434,0.71832-11.2677,0.33616-22.632-1.2439-33.8123zm-1.8742-56.687c1.94636-0.44579,0.15803,2.24252,0.47305,3.35864-1.12551,15.622-0.33781,31.3508,1.48978,46.8907,0.26241,2.09803,0.56406,4.19093,0.89191,6.27969-1.90271,0.61335-0.99483-2.64649-1.56973-3.82081-2.09636-16.2323-2.93319-32.6846-1.84335-49.0276,0.0798-1.11352,0.35908-3.11068,0.55834-3.6807zm0.99223-0.0259zm-1.1635-19.826c-0.0796-2.29566,0.84339,1.05589,0.57932,1.97031,0.30283,5.94802,0.43128,11.9029,0.5844,17.8562-1.75924,0.47646-0.75202-1.96077-1.06874-3.00182-0.1478-5.76502-0.29743-11.5317-0.6476-17.2887,0.18423,0.15457,0.36832,0.30978,0.55262,0.46402zm-0.11259-0.98926zm-23.591,3.7197c-0.51665-1.88658,2.30987-0.87153,3.4679-1.39793,6.70754-0.77384,13.4151-1.54773,20.1228-2.32037,0.55755,1.86267-2.44011,0.90186-3.58188,1.41447-6.66926,0.76756-13.3406,1.54352-20.0088,2.30383zm0.0563-0.004zm-0.0575-0.99279zm-0.49729,0.50873z'/%3E %3Cpath d='m342.19,486.7,20.911-0.53341c-1.7769,8.6837-0.35537,35.655,3.2523,56.214,3.3825,19.277,8.1067,69.272-11.96,81.276-12.444-26.379-2.9696-52.014-9.2409-74.92-4.8931-24.344-5.8584-44.679-2.9626-62.037z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m363.12,486.66c-6.97033,0.1778-13.9407,0.35561-20.911,0.53341-0.30523-1.99644,2.92892-0.63108,4.22927-1.1025,5.55198-0.14162,11.104-0.28325,16.6559-0.42487,0.38447,0.50933,0.77009,0.55158,0.0258,0.99396zm-0.0258-0.99396zm3.7543,56.626c-1.88735,0.64392-1.03402-2.6025-1.63027-3.76077-2.28541-15.5683-3.79333-31.334-3.20988-47.0818,0.11408-1.80357,0.26476-3.61005,0.61221-5.38579,1.90658,0.0541,0.15456,2.63041,0.48978,3.90162-0.81994,14.5147,0.54772,29.0659,2.36724,43.4587,0.40141,2.96427,0.85739,5.92114,1.37092,8.86805zm-12.898,81.575c0.66675-0.58066,1.02837-1.42759,2.81464-2.58491,6.99114-6.3467,9.39655-16.0369,10.8489-25.022,2.41798-17.323,1.16529-34.964-1.47212-52.1868-0.79575-2.82581,1.5201-1.46036,1.11584,0.68072,2.60708,17.5245,3.82027,35.484,1.12579,53.0738-1.61856,9.10777-4.38879,18.923-11.8715,24.9867-0.84073,0.36386-1.59524,1.64739-2.56157,1.05245zm0.70371,0.21501zm-9.9822-75.249c1.87337-0.82976,1.2189,2.49765,1.86502,3.61044,3.4866,18.2687-0.59609,37.0847,3.21072,55.3308,1.05605,5.40405,2.76594,10.6798,5.10149,15.6671-1.67248,1.09555-1.71694-2.34818-2.53482-3.38259-5.90264-14.449-5.48479-30.3331-5.24645-45.6485,0.0662-8.56863-0.13178-17.2581-2.39596-25.5772zm0.007,0.0329zm-2.4958-62.666c0.52105,0.89337,0.37259,1.82583,0.008,3.85362-2.59897,19.5352-0.36107,39.3608,3.45403,58.5818-1.87455,0.6877-1.10342-2.60188-1.73806-3.75129-3.53728-19.153-5.37153-38.9316-2.20163-58.2697,0.15884-0.13707,0.31887-0.2783,0.47745-0.41442zm-0.47736,0.41473zm0.49026,0.0823zm-0.49026-0.0823z'/%3E %3Cpath d='m422.15,454.38c-0.0809,8.6802-3.3708,66.485-4.1026,74.644-0.72951,8.1244-4.5037,13.556-8.4445,16.614-3.379-4.9592-5.2849-11.567-5.5499-19.342-0.13605-3.9641,2.2519-58.69,2.8958-69.933,6.9972-16.946,11.824-17.441,15.201-1.9832z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m418.54,529.07c-1.72461,0.30331-0.60256-1.78409-0.7795-2.79954,1.51005-23.2276,2.86479-46.4682,3.83949-69.7248-0.42383-1.12436,0.58065-3.35908,1.03331-1.52764-0.79659,21.4402-2.12636,42.8577-3.41101,64.2733-0.2119,3.26056-0.41166,6.52235-0.68229,9.77868zm-9.35,16.85c1.21509-0.68421-0.36502-0.7381,1.33484-1.71726,4.24395-3.89206,6.55024-9.5486,7.02531-15.2225,1.72876-0.30613,0.60131,1.76086,0.6275,2.75637-0.97552,5.52685-3.79679,10.8292-8.27325,14.2962-0.23813-0.0376-0.47626-0.0752-0.7144-0.11279zm0.71426,0.11279zm-6.3498-19.718c1.61058-0.5757,0.8439,1.40467,1.12603,2.31063,0.47319,5.87365,1.99135,11.8079,5.33047,16.7332-1.15605,1.34758-1.59229-1.0221-2.24363-1.78056-2.84636-5.27882-4.00374-11.3198-4.21287-17.2633zm2.9333-70.14c1.63948,0.0328,0.64813,1.55613,0.81516,2.81033-1.05006,22.0661-2.10061,44.1352-2.75386,66.217,0.39111,1.8536-1.70277,1.101-0.98745-0.43796,0.71164-22.8184,1.75818-45.6262,2.88887-68.4273l0.0375-0.16215-0.00022,0.0001zm-0.0375,0.16214zm16.195-1.9503c-1.62102,0.57626-1.06395-1.45097-1.60993-2.51733-0.88232-2.7906-1.49978-6.1236-3.99749-7.95182-2.16445-0.81919-3.71636,1.61886-4.82862,3.09566-1.97519,2.97645-3.42279,6.2598-4.804,9.54253-1.79564-0.26178,0.0735-2.03861,0.2452-3.08518,1.76437-3.62849,3.36988-7.67881,6.69854-10.1652,1.90387-1.44912,4.33641,0.0201,5.22123,1.9171,1.60904,2.80991,2.37687,6.03053,3.07507,9.16422zm-0.0117-0.11162zm-0.48555,0.10692zm0.48555-0.10692z'/%3E %3Cpath d='m384.99,407.23c-0.5571,18.646-0.87495,59.108-0.75883,62.547,0.26506,7.7755,3.3309,17.672,6.7087,22.631,3.9408-3.0583,7.7162-8.4898,8.4457-16.615,0.59933-6.6793,0.81044-39.483,0.9113-55.923-4.2176-2.7164-8.5665-6.1095-12.081-9.7211,0.00099,0-3.0963-2.754-3.2253-2.9184z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m384.72,469.76c-1.48975,0.52089-0.89658-1.15349-1.01508-2.05419,0.0574-20.1655,0.26249-40.3325,0.78135-60.4918,1.53759-0.42444,0.82376,1.27089,0.93132,2.19553-0.45506,20.0321-0.71212,40.0705-0.70221,60.1078l0.003,0.17785,0.001,0.0649v-0.0001zm5.9088,22.254c1.29664,1.25687-0.57324,0.70369-0.75063-0.33603-3.53445-6.27545-5.44449-13.4101-6.07893-20.5597-0.71021-1.16298,1.03408-2.11083,0.95302-0.64735,0.52224,7.05722,2.38273,14.0898,5.76213,20.3256,0.099,0.5449,1.6207,1.74384,0.11441,1.21746zm0.60753,0.78719zm7.647-17.054c1.52428-0.33232,0.77449,1.23311,0.73443,2.13358-0.88163,5.75328-3.73253,11.3215-8.38136,14.9201-1.2766-0.88515,0.38237-1.40236,0.94719-2.13796,4.04679-3.88512,6.23119-9.38701,6.69974-14.9158zm1.1377-55.46c0.80713-1.77856,0.84932,0.51215,0.75577,1.35163-0.15877,17.334-0.12873,34.6753-0.76171,52.0003-0.21775,0.82469,0.41826,2.70521-1.02706,2.11787-0.1464-1.13858,0.13454-2.68706,0.11561-3.98715,0.53297-17.2957,0.55051-34.6023,0.68879-51.9044,0.0762,0.14053,0.15268,0.28144,0.2286,0.42172zm0.53717-0.83654zm-12.35-9.801c-0.17292,1.94343,0.31849-0.77072,1.14502,0.94347,3.40696,3.33934,7.20354,6.26692,11.2051,8.85755-0.41487,1.51781-1.46824,0.0937-2.28019-0.31899-3.72537-2.55548-7.26501-5.40212-10.4253-8.6361,0.11846-0.28197,0.23691-0.56397,0.35538-0.84593zm-0.35538,0.84594c-1.9091-0.94949,1.08709-1.38701,0.0109-0.026l-0.0109,0.026h0.00001zm-2.3738-3.251c-1.66535,0.33113-0.23535-0.80333,0.28624,0.0422,0.9153,0.83063,1.837,1.65424,2.75962,2.47669-0.52857,1.95078-0.0906-1.14204-0.68026,0.72724-1.08373-0.98462-2.20191-1.93403-3.25229-2.95393,0.2954-0.0972,0.59189-0.19589,0.88669-0.29216zm-0.99223-0.0305c-0.65842-2.06006,1.39594-0.6334,0.37986-0.12531-0.12642,0.0417-0.25364,0.0838-0.37986,0.12531z'/%3E %3Cpath d='m399.93,419.25c-0.37063,20.09-0.15364,51.736-0.0656,54.309,0.26506,7.7755,2.1721,14.383,5.5499,19.344,3.9408-3.0594,8.1032-8.6849,8.8316-16.809,0.44802-5.0016,1.8378-26.451,1.968-42.913-5.3013-1.6707-11.99-10.366-16.284-13.93z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m400.36,473.54c-1.19409,0.42497-1.04663-0.57638-1.01972-1.43338-0.1602-17.6221-0.18616-35.2471,0.0941-52.8681,1.41171-0.42667,0.91428,0.98812,0.96266,1.87646-0.23766,17.4732-0.23582,34.9516-0.037,52.425zm4.75,18.966c1.27037,1.14312-0.43159,0.82266-0.67314-0.19733-3.47169-5.58987-4.84017-12.2288-5.06922-18.7362,1.33215-0.48183,0.9822,0.83468,1.08199,1.70591,0.41505,6.07757,1.92314,12.2425,5.3746,17.3404-0.23806-0.0376-0.47628-0.0752-0.71423-0.11279zm0.60753,0.78719zm8.0328-17.248c1.43245-0.32405,0.85026,1.03779,0.76147,1.91655-0.91062,5.95456-4.02168,11.6106-8.79427,15.331-1.09483-0.7482-0.0439-1.21887,0.59028-1.79769,4.35362-3.94445,6.95217-9.62536,7.44252-15.4499zm2.314-42.394c0.23031-1.71572,0.8856-0.14636,0.63409,0.76744-0.21891,13.9205-0.89827,27.8346-1.95795,41.7158-1.38241,0.31385-0.876-0.95007-0.84685-1.82761,0.9721-13.691,1.66652-27.4076,1.82287-41.1338,0.11578,0.15925,0.23335,0.31966,0.34784,0.4781zm0.29791-0.94932zm-15.935-13.446c-1.77514,0.28386-0.0863-0.8728,0.46943,0.16942,4.61331,4.15065,8.40067,9.31817,13.7915,12.5374,0.57094,0.53137,2.18439,0.41,1.4428,1.47734-0.5395,0.3768-1.6561-0.55953-2.34356-0.84489-5.47895-3.43244-9.3369-8.77293-14.1741-12.9657,0.27131-0.12453,0.54268-0.2491,0.81395-0.37361zm-0.99457-0.0188c-0.62236-1.71397,1.61225-0.30973,0.11042-0.0506l-0.11039,0.0507-0.00003-0.00004z'/%3E %3Cpath d='M387.08,405.55,372.84,385.03c-2.8782,10.123-6.3873,82.767-2.2683,88.725,0.26506,7.7755,3.0717,14.355,6.4507,19.314,3.9408-3.0583,9.8226-8.5556,8.1231-16.78-1.6983-8.2243,0.20642-62.257,1.9317-70.731h-0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m373.25,384.74c4.74533,6.84267,9.49067,13.6853,14.236,20.528-1.23793,1.40211-1.73608-1.30781-2.59732-1.99952-4.15166-5.98661-8.30333-11.9732-12.455-17.9598-0.31629-0.72206,0.4176-0.37672,0.81631-0.56865zm-0.88549,0.14804zm-1.2948,88.845c-1.41023,0.68686-1.25026-0.6789-1.70724-1.95697-1.38194-8.25519-1.11057-16.6786-1.14526-25.02,0.27662-18.2687,1.03438-36.5541,2.97102-54.7282,0.29855-2.39311,0.57868-4.79903,1.17622-7.13993,1.77733,0.0213,0.24972,1.97173,0.38831,3.03802-1.89467,13.5977-2.47527,27.3396-3.09584,41.0429-0.4057,12.953-0.90673,25.9532,0.13657,38.8879,0.22173,1.99153,0.40847,4.04624,1.27622,5.87621zm-0.088-0.2667zm5.7387,19.204c1.31526,1.7146-1.0333,0.0201-1.16792-0.97211-3.30459-5.3831-5.27264-11.6082-5.47528-17.9321,1.6411-0.5292,0.82738,1.58063,1.17799,2.5341,0.63269,5.89973,2.84132,11.5905,6.17944,16.4828-0.23802-0.0376-0.47635-0.0752-0.71423-0.11277zm0.60754,0.78719zm7.3326-17.072c1.60814-0.8107,1.07596,1.603,1.27818,2.56354,0.16364,6.02897-4.03133,11.0766-8.61081,14.509-1.36895-0.98451,0.68305-1.53544,1.25915-2.32645,4.26571-3.59862,7.41057-9.00915,6.07348-14.746zm2.4184-70.334c0.0774-2.1924,0.70238,0.76659,0.17558,1.60837-1.45117,14.2668-1.809,28.6212-2.16547,42.9497-0.0519,8.37837-0.4192,16.8015,0.47528,25.1464-0.64307,1.70542-1.37882-0.64958-1.20547-1.70405-0.75223-12.6483-0.22681-25.3324,0.14176-37.9863,0.45437-10.0433,0.69197-20.1267,2.0025-30.1035,0.0289-0.92954,0.20061-0.26562,0.57582,0.0893zm0-0.99631zm-0.00099,0zm0,0.99631z'/%3E %3Cpath d='m357.88,451.24c-0.64507,11.241-1.1013,18.85-0.96642,22.814,0.26623,7.7767,2.1721,14.383,5.5499,19.344,3.942-3.0583,8.9606-8.4746,8.4457-16.615-1.9903-31.459,1.4473-61.093,5.4526-89.577-3.3778-2.4802-9.072-5.1531-12.451-7.6333-6.7556,38.356-9.0087,62.162-6.032,71.669l0.001-0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m357.41,474.03c-1.72219,0.59221-0.78856-1.6364-1.00994-2.58023,0.14338-6.75569,0.61822-13.4985,0.98412-20.2445,1.81866-0.35886,0.57861,2.01069,0.81986,3.05856-0.32961,6.58271-0.87576,13.1761-0.79404,19.7661zm4.75,18.968c1.332,1.73328-1.05676,0.007-1.15245-0.99528-3.11942-5.42882-4.37108-11.7336-4.5899-17.9371,1.663-0.54382,0.81741,1.6136,1.14806,2.5683,0.49613,5.78534,2.01967,11.6244,5.30845,16.4769-0.23793-0.0376-0.47661-0.0752-0.71416-0.11285zm0.60754,0.78719zm7.6458-16.977c1.70269-0.5888,0.84215,1.71247,0.95761,2.68455-0.44138,5.79902-4.08301,10.8563-8.60353,14.2928-1.39535-0.99177,0.71229-1.5481,1.2608-2.36626,4.09875-3.6817,6.83912-9.00247,6.38512-14.6111zm5.6555-89.207c1.23202-1.93087,0.5407,1.42081,0.42808,2.22282-4.0439,28.7575-6.97573,57.8602-5.09122,86.9204-1.81031,0.5635-0.79279-2.07508-1.1746-3.12109-1.54927-28.9422,1.56764-57.8753,5.63951-86.4934,0.0659,0.15713,0.1324,0.31414,0.19823,0.47129zm0.58642-0.80364zm-12.255-7.1446c-2.12638-0.56005,0.99663-0.35876,1.51297,0.66734,3.53049,2.24218,7.33398,4.04126,10.7421,6.47724-0.66438,1.70951-1.98801-0.5613-3.05176-0.8236-3.30979-2.03274-6.82086-3.74167-9.98563-6.0061,0.26076-0.10496,0.52155-0.20991,0.78229-0.31488zm-0.97816-0.17388zm-5.8947,71.403c1.42301,1.68365-1.04697-0.28412-0.63216-1.49683-1.58139-9.29493-0.51905-18.7791,0.32665-28.0961,1.50177-14.0139,3.77622-27.9311,6.20028-41.8108,1.90997-0.105,0.26029,2.28288,0.41292,3.40858-2.96216,17.7164-5.99229,35.4992-6.70532,53.4777-0.0721,4.91978-0.13596,9.94715,1.22312,14.7205-0.27498-0.0676-0.55135-0.13599-0.82549-0.20303zm0.70371,0.70494zm0.00099-0.00099zm-0.70372-0.70493z'/%3E %3Cpath d='m343.64,471.82,3.861,14.631c0.26624,7.7755,5.0667,14.196,8.4457,19.156,3.9408-3.0583,7.5203-8.088,6.5152-16.18-5.7786-46.464-3.7132-77.204,6.0331-115.07-22.039,15.045-32.255,46.787-24.855,97.459z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m347.02,486.58c-1.287-4.877-2.574-9.754-3.861-14.631,1.8344-0.77091,1.27593,2.56671,2.00392,3.6955,0.94028,3.59788,1.91529,7.18878,2.83411,10.791-0.32568,0.0482-0.65136,0.0963-0.97703,0.14452zm0.96173-0.25377zm7.661,18.889c1.25652,1.86148-1.17654-0.33182-1.42735-1.25243-3.60681-5.19902-7.00418-10.996-7.21068-17.4919,1.82478-0.43279,0.76603,2.32075,1.41681,3.42488,1.20795,5.76299,4.64844,10.673,7.93549,15.4323-0.23807-0.0376-0.47631-0.0751-0.71427-0.11285zm0.60754,0.78719zm5.7188-16.512c1.85769-0.57723,0.89893,2.38935,1.14009,3.53411-0.13236,5.09343-2.79131,9.94798-6.85875,12.978-1.42058-1.25292,1.50699-2.0088,1.99666-3.23329,3.23254-3.56331,4.37813-8.58695,3.722-13.2788zm6.806-114.72c-0.54335-2.06344,0.48386,1.56134-0.53289,2.61743-5.99313,23.4948-9.08311,47.7688-8.41463,72.0295,0.29454,13.3615,1.4882,26.6878,3.12666,39.9469-1.92021,0.51603-0.90803-2.71705-1.47357-3.93299-3.31167-27.6444-4.07621-55.802,0.5948-83.3409,1.53097-9.37392,3.57643-18.6579,5.93836-27.8557,0.25377,0.17857,0.50748,0.35727,0.76127,0.53577zm-0.56061-0.82242zm-24.094,97.744c-1.87847,0.87576-0.91535-2.50374-1.48933-3.57837-2.59649-20.4977-3.22566-41.8008,2.87305-61.7674,3.92434-12.8003,11.4836-24.8229,22.7101-32.3978,1.35763,1.42122-1.80203,1.99252-2.51812,3.1143-12.5025,9.86505-19.225,25.2741-21.946,40.6361-3.22233,17.814-2.14545,36.2559,0.37029,53.9932zm-0.96174,0.25379zm0.48088-0.12689zm-0.48088,0.12689z'/%3E %3Cpath d='m344.77,486.22-20.223-6.7169c-2.5768,20.221,1.384,45.621,6.8295,79.114,4.6762,28.76,2.2178,51.522-1.357,66.121,21.575-2.9549,30.695-30.772,19.88-83.093-2.8312-13.695-5.6766-31.201-5.1289-55.426z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m324.71,479.03c6.741,2.23897,13.482,4.47793,20.223,6.7169-0.43447,2.01589-3.13982-0.48826-4.57928-0.47273-5.31856-1.76652-10.6371-3.53303-15.9557-5.29955-0.60268-0.66233-0.24906-0.54457,0.31197-0.94462zm-0.64859,0.40887zm7.8123,79.098c-1.96,0.56489-1.02565-2.88922-1.67773-4.13965-3.28668-21.2478-7.19169-42.5808-6.90576-64.1614,0.078-3.60875,0.32265-7.21485,0.7712-10.7969,2.01706-0.0282,0.20098,2.92936,0.55707,4.25722-1.4386,20.2282,1.95115,40.3758,4.92437,60.3167,0.75956,4.84412,1.54511,9.68427,2.33085,14.5241zm-1.9141,65.708c-0.26727,2.37297-0.26261-2.11025,0.36154-3.03264,4.29729-20.5445,3.88975-41.8606,0.57227-62.5151,1.93765-0.59279,1.01474,2.78542,1.61127,4.00867,2.88294,20.6066,2.8552,41.8374-1.99599,62.1508-0.18301-0.20382-0.36618-0.40895-0.54909-0.6118zm0.13371,0.98692zm19.326-83.485c1.96409-0.6315,1.12258,2.96846,1.84538,4.2091,3.17457,17.4663,5.41916,35.5796,1.96528,53.1799-1.96997,9.49145-6.58948,19.5002-15.7635,23.8977-2.32011,1.12692-4.82657,1.82144-7.37322,2.19811-0.54316-1.94591,2.81397-1.00428,3.96915-1.91303,9.15173-2.7497,14.8116-11.5847,17.1804-20.3887,4.19957-15.3596,2.86903-31.5666,0.69365-47.1418-0.71705-4.70187-1.56487-9.3817-2.51717-14.0413zm-4.7981-55.055c0.92323-2.26426,0.5734,2.348,0.59714,3.2846-0.20867,17.3141,1.57067,34.6347,5.17404,51.568-1.87732,0.69596-1.11619-2.61462-1.76866-3.75852-3.36792-16.9618-4.77261-34.2946-4.34275-51.5782l0.17234,0.24527,0.16779,0.23879,0.0001,0.00003zm0.31197-0.94462z'/%3E %3Cpath fill='%2321231e' d='m343.56,584.05c0.43123,0.005,1.62794-0.11881,0.94951,0.4901-0.38016,0.31128-0.97813-0.006-0.94951-0.4901zm-4.302-40.199c1.48585-0.84811,1.31913,0.81891,1.57689,1.82825,2.49011,12.6365,4.3117,25.5022,3.90582,38.4121-1.67317,0.47895-1.07006-1.16462-1.13013-2.21607,0.13562-12.7915-1.79675-25.5264-4.35258-38.0243zm-5.4127-50.215c1.63623-0.54273,1.12916,1.08652,1.20609,2.13411,0.21569,16.0736,2.09295,32.1085,5.36643,47.8418-1.51011,0.85935-1.31962-0.87115-1.58885-1.88835-3.17123-15.8248-4.89985-31.9521-4.98367-48.0876zm1.1811-0.008c-0.43405,0.0143-1.62176,0.18679-0.96862-0.4515,0.37229-0.32526,0.979-0.04,0.96862,0.4515z'/%3E %3Cpath d='m343.96,367.25,13.271,2.2323c-0.64976,2.848-4.0205,20.313-4.6304,23.295-4.9635,24.275-8.2358,52.876-4.4838,84.249,1.3922,11.641,3.861,21.161,7.4804,28.518-14.559-1.6531-23.89-15.872-22.683-40.67-2.5298-28.961-1.4191-51.991,3.2699-69.313,1.3734-5.0744,5.7904-24.209,7.776-28.31z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m357.15,369.98c-4.42367-0.7441-8.84733-1.4882-13.271-2.2323,0.08-2.02073,2.99714-0.0612,4.36466-0.27566,3.02351,0.50858,6.04702,1.01716,9.07053,1.52574,0.4469,0.57749,0.53108,0.60955-0.16419,0.98222zm0.16419-0.98222zm-4.2258,23.886c-1.88321,0.0192-0.21892-2.31964-0.32202-3.48733,1.32255-6.67341,2.58093-13.3601,3.98126-20.0178,1.86715,0.009,0.20222,2.27974,0.29804,3.43885-1.3428,6.68404-2.62469,13.3803-3.95728,20.0662zm-4.4768,84.09c-1.92518,0.51031-0.90768-2.71769-1.43164-3.9511-2.76466-26.8258-0.50165-53.9836,4.93477-80.3383,1.99512,0.10356,0.0106,2.83869,0.18964,4.15738-5.12619,26.3368-6.91987,53.4411-3.69277,80.132zm6.9304,29.072c0.29848-0.87932-1.26355-0.68482-1.61069-2.9432-3.49165-8.26152-5.2206-17.1449-6.30722-26.0111,1.92327-0.51118,0.91334,2.7202,1.52813,3.93187,1.25974,8.34007,3.18366,16.6863,6.89176,24.3082-0.16729,0.23796-0.33481,0.47665-0.50198,0.71422zm0.50198-0.71435zm-23.624-40.407c1.99626-0.56431,0.46705,2.54062,0.89521,3.68146-0.0124,10.4198,1.68763,21.768,8.95256,29.7569,3.45926,3.76298,8.30996,6.15558,13.3862,6.69414,0.0505,2.02623-2.88354,0.18586-4.14959,0.17742-8.95488-2.50847-14.8323-10.9129-17.1062-19.5517-1.90632-6.71921-2.29916-13.8636-1.97822-20.7583zm0.98989-0.0869zm2.2953-69.4c1.95662,0.22625-0.11151,2.77202,0.00015,4.11266-4.72508,21.4106-4.07356,43.5687-2.29555,65.2876-1.95198,0.44921-0.81385-2.78363-1.3252-4.02984-1.5462-21.7712-1.91586-44.0889,3.6206-65.3704zm8.3378-28.671c0.29395,0.99468,0.0426,1.583-0.63828,3.37653-2.62777,8.41341-4.51181,17.033-6.74012,25.5555-1.92186-0.16319,0.0499-2.5841-0.0471-3.82483,2.19417-8.29981,3.84391-16.793,6.89652-24.8334,0.1759-0.0916,0.35319-0.18219,0.52896-0.27385zm-0.52896,0.27375zm0.44686,0.21737zm-0.44686-0.21737z'/%3E %3Cpath d='m335.92,370.39,6.5152,7.4407c-1.8496,1.3218,1.2878,7.0259-0.40112,18.103-1.0896,6.2892-4.831,13.704-5.605,21.729-2.5662,26.596-2.5756,59.898,5.4162,81.186-14.559-1.6531-19.556-14.853-20.028-39.678-0.38938-20.523-0.45624-44.72,4.6926-72.661,1.045-6.5301,4.1824-11.737,9.4098-16.12z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m342.06,378.16c-2.17173-2.4802-4.34347-4.9604-6.5152-7.4406,1.26424-1.50311,2.22486,1.63777,3.34658,2.31444,1.22226,1.59996,3.0032,3.02571,3.88445,4.73201,0.0537,0.7229-0.22935,0.40139-0.71583,0.39415zm0.74593-0.6556zm-0.28501,18.515c-1.95798,0.11409-0.26083-2.43951-0.58879-3.62704,0.50281-4.48473-0.44055-8.94113-0.57248-13.4024-0.2257-1.33576,1.6214-1.99502,1.12718-0.46057-0.43333,3.16268,0.67112,6.36176,0.54449,9.56011,0.0711,2.65176-0.11385,5.30785-0.5104,7.92989zm0.002-0.009zm-5.6015,21.702c-1.95682,0.12872-0.32586-2.63437-0.42339-3.86079,1.17329-6.13907,3.86635-11.8661,5.04442-18.0007,1.84504-0.0915,0.30233,2.15523,0.285,3.24274-1.71064,6.1831-4.29935,12.1747-4.90603,18.6187zm4.865,81.632c0.23672-0.91311-1.0969-0.66652-1.30245-2.86455-5.25253-16.459-6.11731-33.9298-6.0602-51.0904,0.0958-9.27407,0.62513-18.5418,1.50754-27.7736,1.94733-0.12684,0.36058,2.65518,0.64464,3.91595-1.64879,20.7949-2.0119,41.9069,1.75349,62.5032,0.95143,4.97084,2.21566,9.89143,3.97783,14.6398-0.17362,0.22302-0.34721,0.44695-0.52085,0.66957zm0.52074-0.66969zm-20.989-39.493c1.92675-0.34815,0.65767,2.62574,1.11176,3.84661,0.51186,9.18038,1.17222,18.8701,5.94046,26.9769,2.80026,4.80724,8.02703,7.87553,13.529,8.34999,0.14386,1.8901-2.40239,0.37098-3.55005,0.33291-6.85443-1.61993-11.597-7.70361-13.6182-14.1757-2.71123-8.13772-3.18369-16.8206-3.41291-25.3307zm4.6996-72.749c1.96403-0.1178,0.21185,2.38482,0.38002,3.55125-3.99152,22.8195-4.63305,46.0658-4.08515,69.1786-1.91435,0.36569-0.65313-2.56459-1.06065-3.75941-0.46355-23.0649,0.51447-46.2939,4.76578-68.9704zm0.98051,0.15744zm9.2925-16.526c-0.64823,0.79847-0.24654,1.17795-1.8883,2.36621-3.92598,3.74965-6.60742,8.77998-7.40419,14.1599-1.82778,0.12394-0.36212-2.10623-0.32606-3.17694,1.41619-5.2933,4.72515-9.94133,8.92656-13.4033,0.23064,0.0181,0.46148,0.0359,0.69199,0.0541zm-0.69198-0.054z'/%3E %3Cpath d='m372.29,389.97-13.435-1.5673c-2.4688,12.704-4.3571,21.686-4.8146,26.212-0.8984,8.8764,1.7921,17.014,4.8673,23.075,4.9541-2.9866,7.2552-9.5108,9.3394-18.659,2.0912-9.1866,2.6119-19.201,4.044-29.061h-0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m358.91,387.91c4.47833,0.52243,8.95667,1.04487,13.435,1.5673,0.0903,0.86246-0.2522,1.17814-1.0834,0.87629-4.15551-0.48477-8.31103-0.96955-12.4665-1.45432-0.44106-0.53525-0.5489-0.61345,0.11494-0.98927zm-0.54537,0.39946zm-3.8329,26.358c-0.78772,0.0741-1.19567-0.16882-0.88897-0.97423,1.0176-7.23257,2.60891-14.3685,3.9712-21.5407,0.25134-1.28073,0.50095-2.56179,0.75071-3.84283,0.86696-0.0244,1.15292,0.34269,0.78931,1.14735-1.49125,7.87942-3.22819,15.7168-4.43184,23.6477-0.0732,0.51966-0.13508,1.04109-0.19041,1.56273zm4.1179,22.598c0.66366,0.67489,0.39211,1.1689-0.28442,0.45821-3.58421-7.11012-5.63845-15.1696-4.82139-23.1573,0.82342-0.087,1.18743,0.19833,0.90799,1.02572-0.56196,7.57636,1.48045,15.1541,4.8967,21.8743-0.23287-0.067-0.46647-0.13402-0.69888-0.20091zm0.51136,0.85298zm8.5993-19.196c0.77534,0.0333,1.18726,0.2943,0.77173,1.07386-1.24553,5.07681-2.52515,10.3434-5.62498,14.6545-1.02107,1.37274-2.27703,2.58191-3.74608,3.46714-0.58299-0.62039-0.52432-1.0654,0.27882-1.38037,3.60211-2.67742,5.28987-7.0583,6.59522-11.1939,0.67026-2.18095,1.21655-4.39778,1.72529-6.62124zm4.5284-28.453c-0.22392-0.9538,0.27863-1.17808,0.46115-0.21194-1.39786,9.61954-1.8818,19.3815-4.02075,28.8854-0.77799-0.0317-1.18569-0.29782-0.77877-1.07974,1.98265-9.28195,2.47122-18.789,3.84695-28.1636,0.1638,0.18994,0.32763,0.37992,0.49142,0.56983zm0-0.99632c0.97134-0.25122,0.4479,1.10661-0.00003,0h0.00003zm-0.00099,0c0.0459,0.61947-0.072,1.48655-0.0199,0.34339,0.007-0.11373,0.0134-0.23129,0.0199-0.34339zm0,0.99632z'/%3E %3Cpath d='m407.15,418.58-11.924,0.12454c-0.40815,10.961-0.70371,18.379-0.50902,22.241,0.38235,7.5758,2.2718,13.994,5.5065,18.795,3.6218-3.0195,7.0488-8.3488,7.5895-16.274,0.54303-7.9576-0.58876-16.429-0.66265-24.887z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m395.23,418.2c3.97467-0.0415,7.94933-0.083,11.924-0.12455,0.0131,0.54896,0.18621,1.25485-0.61739,1.00286-3.76587,0.0393-7.53174,0.0787-11.2976,0.118-0.53911-0.49003-0.61346-0.51779-0.009-0.99631zm-0.49142,0.47935c-0.17773-0.77125,0.92706-0.49913,0.043-0.0423l-0.043,0.042-0.00001,0.0003zm0.48321,22.235c-0.49996,0.009-1.22701,0.26355-1.01498-0.50662-0.1343-6.27878,0.22641-12.5548,0.42379-18.8288,0.0359-0.96652,0.0728-1.933,0.10806-2.89955,0.54858,0.0119,1.25906-0.12638,0.96916,0.6636-0.22131,6.88903-0.61472,13.7785-0.51985,20.6731,0.008,0.29931,0.0215,0.60043,0.0338,0.89826zm4.6926,18.437c0.35881,0.42363,0.97485,0.99123,0.0156,0.67716-0.43836-0.31033-0.65933-0.95709-0.98767-1.41301-3.10422-5.33833-4.3954-11.5376-4.71281-17.6514,0.54754-0.036,1.24257-0.23618,1.02787,0.57601,0.39834,6.26108,1.86186,12.6384,5.38652,17.9157-0.24314-0.0348-0.48646-0.0698-0.7295-0.10452zm0.63568,0.76604c-0.30118,0.79957-1.14352-0.387-0.28659-0.0411,0.0955,0.0137,0.19106,0.0274,0.28659,0.0411zm6.7756-16.691c0.54824,0.0291,1.26602-0.0878,0.94226,0.69263-0.49428,6.02097-3.00849,12.0697-7.71776,15.9981-0.34919-0.41496-0.93309-0.84246-0.17315-1.16784,4.38079-3.91265,6.58343-9.75566,6.94865-15.5229zm-0.16185-24.355c-0.0108-0.55475-0.13605-1.37926,0.43772-0.55717,0.13553,1.0846,0.0554,2.26886,0.13215,3.3913,0.25151,7.19262,1.05653,14.3876,0.5834,21.5885-0.54809-0.0291-1.26286,0.0881-0.9536-0.69333,0.43855-8.08368-0.6445-16.1435-0.70123-24.2228,0.16697,0.16436,0.33582,0.32963,0.50156,0.49341zm-0.009-0.99632c0.78401-0.23538,0.5439,0.94178,0.0556,0.054l-0.0553-0.0543-0.00031,0.00029z'/%3E %3Cpath d='m419.99,424.24-11.913,0.54164c-0.027,10.969-0.0645,18.392,0.26389,22.246,0.64507,7.557,2.7574,13.906,6.1563,18.59,3.5162-3.144,6.7544-8.5897,7.0195-16.528,0.26623-7.9717-1.16-16.398-1.5282-24.849h0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m408.06,424.28c3.971-0.18054,7.942-0.36109,11.913-0.54163,0.0344,0.55041,0.23019,1.24822-0.58486,1.02259-3.76118,0.171-7.52236,0.34201-11.2835,0.51301-0.52616-0.39141-0.59479-0.57759-0.0446-0.99397zm-0.47501,0.4958c-0.20325-0.76784,0.91097-0.52755,0.0389-0.0409l-0.0391,0.0408,0.00019,0.00004zm1.2561,22.205c-0.49991,0.0268-1.21772,0.30807-1.03239-0.47092-0.35557-6.42039-0.20913-12.8552-0.23119-19.2823,0.002-0.81709,0.003-1.63417,0.005-2.45126,0.55138-0.009,1.25736-0.17137,0.99333,0.6321,0.0201,6.83181-0.12717,13.6695,0.1889,20.4964,0.0219,0.35892,0.0464,0.71768,0.0765,1.07601zm5.3306,18.262c0.37652,0.41272,1.00896,0.95706,0.035,0.67527-0.4502-0.30527-0.69641-0.94834-1.04598-1.39782-3.27682-5.22336-4.78115-11.3636-5.30955-17.4543,0.5483-0.0569,1.23548-0.27984,1.04787,0.54283,0.61577,6.24189,2.29975,12.563,6.00552,17.7128-0.24416-0.0263-0.4893-0.0525-0.73285-0.0787zm0.6615,0.74253c-0.27435,0.81283-1.15875-0.34955-0.28554-0.0307,0.0952,0.0102,0.19041,0.0204,0.28554,0.0307zm6.1926-16.916c0.55129,0.008,1.26253-0.13166,0.96368,0.66236-0.28305,6.03357-2.58665,12.1657-7.1562,16.2539-0.36394-0.40217-0.96312-0.80968-0.21268-1.16102,4.24172-4.06136,6.23987-9.98007,6.4052-15.7552zm-1.0321-25.331c-0.007,0.5584-0.12044,1.38469,0.43526,0.5407,0.15651,0.20432,0.0726,1.05805,0.14175,1.51302,0.43877,7.77172,1.68591,15.5086,1.4474,23.3101-0.55109-0.008-1.25907,0.13179-0.97629-0.6628,0.15571-8.09334-1.20756-16.11-1.54415-24.1817,0.1653-0.17309,0.33098-0.34633,0.49603-0.51931zm-0.49612,0.51931c-0.28021-0.80038,0.95565-0.57673,0.0609-0.0637l-0.0609,0.0637h-0.00008zm0.49729,0.47701c-0.00097-0.32293-0.006-1.52192,0.0101-0.54635-0.0154,0.16502,0.0446,0.42036-0.0101,0.54635z'/%3E %3Cpath d='m395,412.42-11.895-0.84475c-1.2937,10.893-2.1897,18.263-2.3082,22.127-0.23339,7.5816,1.1306,14.133,3.9666,19.18,3.8552-2.714,7.7021-7.7485,8.882-15.603,1.1857-7.8883,0.74359-16.423,1.3546-24.86z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m383.14,411.08c3.965,0.28158,7.93,0.56317,11.895,0.84475-0.0287,0.5529,0.0845,1.26949-0.7018,0.94913-3.75453-0.26664-7.50907-0.53328-11.2636-0.79992-0.47754-0.45038-0.52486-0.64309,0.0704-0.99396zm-0.52896,0.43823c-0.11159-0.78896,0.96648-0.41794,0.0415-0.0344l-0.0415,0.0344,0.00001-0.00003zm-1.3183,22.201c-0.58106,0.0167-1.22605,0.0857-0.96654-0.67979,0.40011-6.44802,1.29024-12.8529,2.01667-19.2693,0.0894-0.75058,0.17947-1.50106,0.26783-2.25176,0.63452,0.0158,1.23429,0.0589,0.90249,0.83589-0.77174,6.78725-1.71204,13.5612-2.17649,20.379-0.0181,0.32845-0.0345,0.65761-0.044,0.98603zm3.1843,18.757c0.3282,0.45535,0.8936,1.06989-0.0449,0.67517-0.4091-0.35894-0.58412-1.02149-0.87577-1.51052-2.65183-5.56705-3.43601-11.8413-3.25571-17.9525,0.61403-0.03,1.23412-0.0656,0.97583,0.73074-0.10203,6.24918,0.84481,12.697,3.91925,18.2204-0.23937-0.0544-0.48025-0.10907-0.71869-0.16326zm0.57236,0.81538c-0.36703,0.77744-1.11146-0.48541-0.27807-0.0632,0.0927,0.0211,0.18538,0.0421,0.27807,0.0632zm8.1044-16.084c0.6345,0.0354,1.23228,0.0975,0.86633,0.86201-0.99351,5.92598-3.9859,11.7093-8.9707,15.2224-0.31561-0.44273-0.8652-0.91629-0.0768-1.17778,4.68123-3.54393,7.35158-9.18927,8.18115-14.9066zm1.8109-24.289c0.0323-0.56004-0.0246-1.38897,0.48366-0.5145,0.0257,1.29706-0.15195,2.66917-0.17171,3.99691-0.29787,6.98689-0.11395,14.0179-1.1398,20.9544-0.63337-0.0352-1.23062-0.0973-0.88007-0.86412,1.07182-7.99175,0.65347-16.0802,1.24818-24.1061,0.15324,0.1778,0.30653,0.35562,0.45974,0.53341zm0.0704-0.99397c0.80649-0.16894,0.45973,0.98647,0.0464,0.0539l-0.0465-0.0539,0.00004,0.00005z'/%3E %3Cpath d='m383.86,399.58-13.046-5.4186c-2.2249,8.8235-5.2309,37.867,0.11142,50.133,4.3466-2.9537,8.726-8.4934,10.188-17.225,1.4672-8.7695,1.907-18.098,2.7456-27.489z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m371,393.7c4.34867,1.8062,8.69733,3.6124,13.046,5.4186-0.14774,0.85697-0.56565,1.06129-1.28225,0.54403-4.04792-1.68129-8.09584-3.36257-12.1438-5.04386-0.432-0.577-0.211-0.678,0.38-0.919zm-0.67204,0.3372c-0.007-1.00429,1.18279-0.16392,0-0.00001v0.00001zm0.31431,49.843c0.61609,0.62128,0.5669,1.10299-0.21604,0.51007-2.16521-5.34031-2.6369-11.1729-2.90831-16.8744-0.30702-9.56175,0.36616-19.1514,1.84211-28.6003,0.26687-1.63635,0.57208-3.26766,0.96806-4.87812,0.79296,0.0452,1.17196,0.34066,0.75531,1.11732-1.57735,7.60498-2.2529,15.3722-2.56906,23.1234-0.19981,7.36173-0.12625,14.8305,1.59801,22.0292,0.33814,1.28853,0.74541,2.55895,1.26434,3.7867-0.24481-0.0713-0.48961-0.14259-0.73442-0.21388zm0.55829,0.82477c-0.67973,0.78289-1.00265-0.69375-0.005-0.001l0.005,0.001zm9.4191-17.72c0.8405-0.0381,1.17469,0.28637,0.81096,1.09209-1.23375,6.52177-4.6618,12.8398-10.2301,16.6278-0.59294-0.57478-0.60907-1.03113,0.18955-1.35871,5.18282-3.88722,8.20643-10.0637,9.22959-16.3612zm3.0459-26.948c0.12132-0.86649,0.70906-1.09636,0.65637-0.0903-0.81216,9.07534-1.22937,18.2019-2.72183,27.2024-0.83754,0.0371-1.1724-0.28301-0.82897-1.09184,1.37819-8.7845,1.79271-17.6774,2.58943-26.5242,0.10168,0.16799,0.20327,0.33613,0.305,0.50403zm0.38-0.91877zm-0.19,0.45938zm0.19-0.45938z'/%3E %3Cpath id='path1214' d='m387.75,701.16c7.9625,6.3832,15.249-8.2173,8.1865-27.512-5.225-14.277-30.765-8.7354-16.54,10.47,0.67439,0.91055,1.6244,0.48759,1.4895-0.55102-0.80809-3.9383,1.703-6.227,5.5769-5.5009,10.577,1.9809,10.91,22.069-0.59347,17.5-2.0994-0.13629-0.22049,3.9101,1.8789,5.5937h0.00099z' stroke='%2321231E' stroke-width='0.99388075' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m400.05,639.16-0.006,0.12923c-1.038,3.3496-4.906,7.5382-7.9179,10.679-4.6668,4.8688-3.5631,12.245-0.33308,16.164,3.5232,4.2755,5.096,9.0914,5.8032,12.833,0.52778,2.3063,1.4731,7.4712,0.78464,15.508-0.33896,3.9559-2.7292,5.9932-4.9682,7.7661-1.1377,0.90233,0.48321,3.0524,4.2445,5.878,0.41167,0.309,1.5435,1.0844,2.083,3.0442,0.20759,0.47114,1.9528,0.47114,2.1616,0,0.53951-1.9597,1.6713-2.7352,2.0842-3.0442,3.7602-2.8256,5.381-4.9757,4.2434-5.878-2.239-1.7729-4.6292-3.8102-4.9682-7.7661-0.68847-8.0352,0.25802-13.201,0.78581-15.508,0.70722-3.742,2.28-8.5568,5.8032-12.833,3.23-3.9206,4.3337-11.297-0.3331-16.164-3.0119-3.1405-6.8799-7.329-7.9179-10.679l-0.006-0.12923c-0.0516-0.6509-0.41167-0.97752-0.77174-0.97752-0.36005,0-0.72012,0.32662-0.77173,0.97752z' fill='%23EDB92E'/%3E %3Cpath d='m395.06,685.47,11.51,0c1.9809,0,3.6018,1.592,3.6018,3.5376v0.00099c0,1.9456-1.6209,3.5376-3.6018,3.5376h-11.51c-1.9809,0-3.6018-1.592-3.6018-3.5376v-0.00099c0-1.9456,1.6209-3.5376,3.6018-3.5376z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m406.57,685.97h-11.51v-0.9963h11.51v0.9963zm4.0991,3.0395h-0.99457c0.0277-1.51992-1.25651-2.88558-2.7578-3.02022-0.35387,0.0683-0.39264-0.13955-0.34709-0.44542,0.0521-0.20646-0.15184-0.67649,0.20995-0.56435,1.84255,0.0636,3.53491,1.51513,3.82718,3.34384,0.0412,0.22637,0.059,0.45643,0.0623,0.68615zm-0.99457,0.00099c0.32922-0.002,0.66536-0.002,0.99457,0h-0.99457zm-3.1045,4.0358v-0.99631c1.53615,0.0334,2.98088-1.22992,3.09244-2.77343-0.0963-0.3766,0.27827-0.24927,0.52363-0.26653,0.25584,0.00001,0.61285-0.0878,0.47064,0.2917-0.10618,1.86025-1.67035,3.47611-3.5096,3.70223-0.19126,0.0265-0.38459,0.039-0.57711,0.0423zm-11.51-0.99631h11.51v0.99631h-11.51v-0.99631zm-4.0991-3.0395h0.99458c-0.0279,1.52,1.2564,2.88573,2.75772,3.02051,0.35387-0.0683,0.39264,0.13955,0.34709,0.44542-0.0521,0.20646,0.15184,0.67649-0.20995,0.56434-1.84267-0.0634-3.53486-1.51514-3.82724-3.34384-0.0411-0.22648-0.0592-0.4564-0.0622-0.68643zm0.99458-0.00099c-0.32922,0.002-0.66536,0.002-0.99458,0h0.99458zm3.1045-4.0358v0.9963c-1.53605-0.0337-2.98089,1.22961-3.09241,2.77303,0.0963,0.3766-0.27827,0.24927-0.52363,0.26653-0.25584-0.00001-0.61285,0.0878-0.47064-0.2917,0.1064-1.87487,1.69537-3.50055,3.55179-3.70738,0.17734-0.0238,0.35606-0.0341,0.53489-0.0368z'/%3E %3Cpath d='m417.13,579.19,0.38352-10.914c-4.3806-2.2276-15.174,0.0599-19.732,10.136-5.6825,12.56-11.058,19.246-17.873,25.141,9.8777,1.8446,18.248-0.11044,23.641-7.3561,7.2764-9.7752,11.167-15.697,13.58-17.007z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m418.01,568.3c-0.12784,3.638-0.25568,7.276-0.38352,10.914-0.85651,0.16264-1.1901-0.16196-0.95784-1.01382,0.11638-3.3118,0.23275-6.62359,0.34913-9.93538,0.48555-0.22024,0.73793-0.72982,0.99223,0.0352zm-0.27093-0.46174zm-19.504,10.786c-0.85771-0.17842-1.03836-0.60188-0.47956-1.29299,2.99556-6.01824,9.41158-10.3771,16.2118-10.3215,1.29323,0.0308,2.60389,0.25292,3.77224,0.82878-0.22124,0.76064-0.57191,1.05112-1.27138,0.55337-3.66825-1.01468-7.61163,0.088-10.8336,1.92752-3.26881,1.89645-5.85352,4.8668-7.39946,8.30479zm-18.234,24.446c-0.10448,0.9136-0.2351,1.15935-0.41636,0.1116,5.65286-4.78786,10.3048-10.6892,13.8527-17.1809,1.41237-2.53659,2.69433-5.14411,3.89252-7.78809,0.85414,0.17672,1.04057,0.60291,0.49778,1.30155-3.68976,8.06074-8.37567,15.813-14.8661,21.9375-0.88519,0.85383-1.79891,1.67762-2.72716,2.48427-0.0778-0.28865-0.15561-0.5773-0.23341-0.86595zm-0.18296,0.97751c-0.96744-0.0394-1.15507-0.29001-0.27513-0.82982,0.13712,0.0751,0.18094,0.60096,0.27513,0.82982zm23.334-8.1421c0.7877,0.35314,0.89926,0.80653,0.20099,1.35695-3.25206,4.10818-8.22457,6.66814-13.4051,7.23646-3.37229,0.4227-6.79777,0.16475-10.1297-0.45158-0.0144-0.81919,0.28858-1.18034,1.0931-0.81774,5.73953,0.95924,12.018,0.66309,17.0682-2.5066,2.0149-1.25388,3.75755-2.91667,5.17255-4.81749zm13.483-16.727c0.76239-0.13505,1.31994,0.15786,0.44151,0.63474-2.29717,1.79822-3.90832,4.29292-5.68731,6.57043-2.49148,3.3636-4.93734,6.7608-7.43973,10.1164-0.79622-0.35383-0.88945-0.81079-0.21361-1.38057,3.52704-4.66464,6.78442-9.54018,10.5503-14.0197,0.77975-0.86906,1.58477-1.75425,2.60805-2.34079-0.0864,0.13983-0.17287,0.27964-0.25921,0.41949zm0.99224,0.0352z'/%3E %3Cpath d='m425.16,580.63-11.789-4.9651c-4.8333,9.8527-8.1232,16.512-9.493,20.127-2.687,7.0905-3.4212,13.768-2.178,19.535,4.7864-1.2184,10.314-4.6326,14.051-11.652,3.752-7.0471,6.0625-15.277,9.4098-23.046z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m413.56,575.2c3.92967,1.65503,7.85933,3.31007,11.789,4.9651-0.18283,0.65106-0.42077,1.16706-1.09322,0.61801-3.6935-1.55557-7.38699-3.11113-11.0805-4.6667-0.30293-0.58749-0.30668-0.77884,0.3847-0.91641zm-0.63803,0.2385zm-8.5829,20.523c-0.65139-0.16016-1.1851-0.37811-0.6509-1.06334,2.60013-6.17747,5.68348-12.136,8.59993-18.167,0.31566-0.33569,0.36532-1.45066,0.89247-1.16541,0.86427,0.13505,0.49247,0.69146,0.18475,1.22602-2.94824,6.09459-6.06299,12.1164-8.70471,18.3534-0.11064,0.27073-0.21777,0.54288-0.32154,0.81632zm-2.7644,18.876c0.20009,0.63589,0.39626,1.2664-0.36358,0.58745-1.41298-6.63433-0.17046-13.5516,2.1994-19.8159,0.59064,0.17216,1.20602,0.33307,0.68494,1.01042-2.13791,5.90256-3.2358,12.3815-1.91306,18.5964-0.20258-0.12608-0.40508-0.25239-0.6077-0.37833zm0.24395,0.96578c-0.76089,0.42729-0.7316-0.83736-0.0365-0.0227l0.0365,0.0227zm13.49-12.368c0.61579,0.24343,1.13268,0.51628,0.51488,1.12674-2.97573,5.36071-7.99242,9.72827-14.005,11.2414-0.23097-0.61638-0.37864-1.17301,0.47016-1.16441,5.69398-1.66802,10.3036-6.0119,13.02-11.2038zm9.6561-22.354c0.22011-0.6172,0.44037-1.25401,0.64859-0.26082-3.30104,7.62909-5.5349,15.7098-9.42736,23.0821-0.60517-0.24327-1.13588-0.50951-0.53247-1.12555,3.66152-7.1776,5.85368-14.9729,9.04735-22.3513,0.088,0.21853,0.17593,0.43706,0.26389,0.65559zm0.3847-0.91641c0.84675,0.1252,0.0898,1.08836,0.0127,0.0316l-0.0127-0.0316z'/%3E %3Cpath d='m428.55,580.62-12.643-1.9315c-2.2847,10.735-3.8528,17.998-4.3008,21.839-0.8773,7.5323,0.0375,14.187,2.6495,19.478,4.3442-2.3522,8.8726-7.0165,10.786-14.736,1.9211-7.752,2.1557-16.298,3.508-24.649h0.001z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m415.98,578.2c4.21433,0.64383,8.42867,1.28767,12.643,1.9315-0.0302,0.65001-0.10849,1.23457-0.88263,0.87265-3.97016-0.60653-7.94033-1.21306-11.9105-1.81959-0.42368-0.5606-0.53524-0.60279,0.15012-0.98456zm-0.56062,0.3889c-0.028-0.80167,0.99371-0.31802,0.0278-0.0193l-0.0279,0.0193h0.00004zm-3.3215,22c-0.58909-0.0296-1.23109-0.0211-0.90451-0.76662,0.9691-6.42675,2.46105-12.7596,3.77656-19.121,0.14959-0.70419,0.29944-1.40832,0.44955-2.1124,0.64731,0.0672,1.22245,0.18113,0.81671,0.93151-1.37958,6.65787-2.93204,13.2862-3.99864,20.0042-0.0497,0.35435-0.098,0.70913-0.13967,1.06436zm1.92,18.982c0.34945,0.56801,0.68018,1.12047-0.20993,0.65912-2.98802-6.09014-3.46779-13.1024-2.69723-19.756,0.61512,0.0226,1.24217,0.0357,0.91014,0.81186-0.63282,6.24583-0.12115,12.7982,2.67849,18.5024-0.22716-0.0725-0.45431-0.14494-0.68147-0.21736zm0.47149,0.87648c-0.61128,0.5996-0.92456-0.6168-0.0637-0.0203l0.0637,0.0203h0.00001zm10.068-15.294c0.64544,0.0894,1.21716,0.22256,0.7765,0.95654-1.57887,5.93019-5.37912,11.3969-10.8442,14.3372-0.36225-0.53601-0.65369-1.03898,0.16385-1.23808,5.12194-3.01539,8.53162-8.34822,9.90389-14.0556zm3.99-25.028c-0.1063,0.78708,0.0492,1.09119,0.47594,0.66955-1.32938,8.17581-1.52967,16.5281-3.5018,24.5979-0.64409-0.0891-1.21564-0.22219-0.79099-0.96018,1.80279-7.85537,2.0269-15.9528,3.3267-23.889,0.16333-0.1394,0.32713-0.27899,0.49015-0.41826zm-0.49025,0.41827zm0.49142,0.57805c-0.0498-0.39684,0.065-1.5339,0.0401-0.52852-0.0134,0.1761-0.0267,0.35282-0.0401,0.52852z'/%3E %3Cpath d='m430.43,563.41,7.5391-0.0634c4.4017,2.1877,9.0216,12.222,3.6827,21.906-6.6547,12.071-8.7928,20.385-9.4379,29.382-7.3796-6.8309-10.818-14.723-8.2428-23.384,3.474-11.687,6.853-25.118,6.4589-27.84z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m437.97,563.85c-2.51303,0.0211-5.02607,0.0423-7.5391,0.0634-0.26476-0.96741,0.27196-1.14719,1.13537-1.00593,2.20465,0.0175,4.42542-0.10964,6.61992-0.00098-0.0722,0.31439-0.14351,0.62966-0.21619,0.94351zm-0.009-0.9963zm4.1226,22.645c-0.94563-0.24295-0.88161-0.77978-0.36288-1.47165,2.84748-5.78449,2.42144-13.272-1.70109-18.3478-0.64527-0.74756-1.38934-1.42962-2.27416-1.88218,0.20066-0.90364,0.70484-0.97121,1.33471-0.35013,3.29923,2.54727,4.92911,6.73545,5.36539,10.7792,0.41028,3.88691-0.47598,7.86088-2.36197,11.2725zm-10.21,29.506c1.02003-0.98391,0.24148-0.35685-0.14184-0.62884,0.49299-7.69611,2.59633-15.2332,5.85693-22.2068,1.11403-2.43045,2.33597-4.81021,3.62422-7.1526,0.97129,0.24427,0.86372,0.80228,0.32234,1.48644-4.22195,7.75017-7.5717,16.1264-8.52658,24.9592-0.12693,1.06815-0.22484,2.13965-0.30254,3.21246-0.2774,0.11001-0.55574,0.22027-0.83253,0.33011zm0.83272-0.33014c0.0876,1.03279-0.18537,1.15289-0.82967,0.33295,0.2632-0.11332,0.55506-0.2218,0.82967-0.33295zm-9.2151-23.561c0.93546,0.0433,1.04166,0.52586,0.68091,1.2979-1.32444,5.07036-0.21027,10.57,2.57538,14.9575,1.57506,2.5754,3.59359,4.85439,5.7993,6.90544-0.4518,0.82442-0.94132,0.71204-1.44303-0.00061-4.41702-4.25594-8.05021-9.81655-8.43617-16.0891-0.16691-2.38277,0.14828-4.78435,0.82361-7.07116zm6.9304-28.196c-0.12533,0.99771,0.11604,0.91724,0.50612,0.54045,0.0499,2.84725-0.72678,5.63387-1.28277,8.4078-1.49442,6.57166-3.29484,13.0699-5.20161,19.5326-1.00203-0.031-1.01305-0.59909-0.62812-1.38184,2.20115-7.65206,4.38794-15.3301,5.82399-23.1691,0.16499-1.11043,0.37884-2.23338,0.29473-3.35994,0.16268-0.18978,0.32444-0.38116,0.48766-0.56998zm-0.48673,0.56983zm0.49142-0.0717zm-0.49142,0.0717z'/%3E %3Cpath d='m433.79,558.16-12.055-4.2802c-4.261,10.115-7.1638,16.951-8.3249,20.639-2.2765,7.2327-2.6284,13.941-1.0556,19.629,4.709-1.4921,10.675-4.5751,14.004-11.796,3.3414-7.2515,4.5342-16.245,7.4312-24.192z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m421.9,553.41c4.01833,1.42673,8.03667,2.85347,12.055,4.2802-0.1474,0.65506-0.3519,1.19011-1.05275,0.68205-3.77845-1.34156-7.55689-2.68312-11.3353-4.02468-0.33547-0.5687-0.34757-0.76101,0.33308-0.93757zm-0.62396,0.27493zm-7.3936,20.983c-0.65568-0.12304-1.20594-0.30837-0.71114-1.02108,2.23986-6.31718,4.9793-12.4417,7.54401-18.6305,0.29617-0.35475,0.28387-1.46736,0.82445-1.21924,0.86915,0.0866,0.53396,0.66227,0.2559,1.21472-2.59363,6.2532-5.35693,12.4435-7.63874,18.8203-0.0949,0.27746-0.18447,0.5567-0.27448,0.83576zm-1.6795,19.005c0.23744,0.62322,0.46784,1.2379-0.3284,0.60743-1.79205-6.54273-0.94696-13.5209,1.06068-19.9111,0.59969,0.13775,1.22098,0.26413,0.7424,0.96928-1.79906,6.01522-2.52158,12.5469-0.84599,18.6762-0.20957-0.11396-0.41912-0.22797-0.62869-0.3419zm0.30026,0.94932c-0.73159,0.47002-0.78175-0.78993-0.0416-0.0226l0.0416,0.0226zm13.402-12.48c0.63007,0.20882,1.15836,0.45411,0.57586,1.09736-2.29931,4.70921-6.44552,8.38082-11.263,10.3783-0.88826,0.37797-1.79516,0.71153-2.71502,1.00416-0.26859-0.60348-0.44471-1.15211,0.40814-1.18433,4.92487-1.6299,9.41438-4.86525,12.0147-9.41446,0.35598-0.61131,0.67942-1.24043,0.97933-1.88101zm7.7162-23.514c0.18524-0.62803,0.36953-1.27534,0.63333-0.29842-2.90442,7.94644-3.94709,16.4902-7.44642,24.2312-0.61546-0.20945-1.16231-0.4445-0.59932-1.09383,3.22987-7.54946,4.29606-15.7881,7.11215-23.4781,0.10009,0.21305,0.20017,0.4261,0.30026,0.63915zm0.33308-0.93757c0.85014,0.0733,0.15384,1.08086,0.0161,0.0343l-0.0161-0.0343zm-0.16654,0.46879zm0.16654-0.46879c0.85014,0.0733,0.15384,1.08086,0.0161,0.0343l-0.0161-0.0343z'/%3E %3Cpath d='m425.6,549.74-2.6448-16.405c-2.7691-0.75076-6.4483,5.7288-10.048,9.5096-0.83037,0.87178-1.7839,1.6919-2.5087,2.7669-1.5142,2.2441-2.7374,4.9193-3.4165,7.9552-3.0119,13.456-7.4007,20.454-12.874,27.615,10.045-0.20796,17.844-3.829,21.652-12.023,5.1371-11.055,7.7432-17.645,9.8402-19.419z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m423.44,533.25c0.8816,5.46833,1.7632,10.9367,2.6448,16.405-0.94522,0.43546-1.16692-0.13255-1.16844-1.00592-0.81895-5.07976-1.63791-10.1595-2.45686-15.2393,0.44652-0.31001,0.56913-0.89049,0.9805-0.1598zm-0.36006-0.40064zm-9.8191,10.333c-0.76003-0.44442-0.77958-0.89688-0.0715-1.39257,2.45497-2.70303,4.34814-5.94719,7.24132-8.22868,0.75531-0.54075,1.70872-0.96178,2.64947-0.71207-0.004,0.95561-0.51742,0.94808-1.28814,1.07574-2.19189,1.15965-3.57251,3.34069-5.13322,5.1913-1.09547,1.38513-2.183,2.78337-3.39792,4.06628zm-2.4559,2.7023c-0.50569-0.28947-1.08795-0.5856-0.44784-1.07158,0.65636-0.83775,1.4496-1.55243,2.1857-2.317,0.89788,0.4865,0.62143,1.00089-0.0923,1.50764-0.59197,0.58607-1.17813,1.18923-1.64554,1.88094zm-3.3438,7.7861c-0.90108,0.0145-1.11221-0.41846-0.72936-1.19374,0.67915-2.54043,1.77819-4.96929,3.24977-7.14924,0.73049,0.30746,0.9517,0.70402,0.35259,1.2856-1.3462,2.16848-2.31558,4.56744-2.873,7.05738zm-13.369,27.007c0.29327,1.21976-0.41372,0.86819-0.24053,0.007,4.23797-5.43792,7.80901-11.4461,10.0342-17.9938,1.06365-3.02062,1.90327-6.11634,2.60681-9.23932,1.04024-0.0502,1.0313,0.55942,0.70402,1.36924-1.81063,7.87087-4.8124,15.5309-9.4485,22.1808-1.03538,1.52683-2.1327,3.0106-3.25142,4.47711-0.13484-0.2669-0.26994-0.53479-0.40462-0.80108zm0.0211,0.9963c-1.14662,0.35616-1.01101-0.45229-0.35143-0.69584,0.11714,0.23192,0.23429,0.46406,0.35143,0.69584zm21.191-12.731c0.96099,0.17313,0.94335,0.71055,0.41243,1.39936-2.48405,4.90545-7.17729,8.46545-12.4201,9.97466-2.97255,0.90615-6.08324,1.28774-9.18339,1.35712-0.2914-0.98444,0.27522-1.14101,1.13891-1.03731,5.95791-0.25802,12.212-1.99125,16.452-6.40668,1.49565-1.53613,2.69474-3.34747,3.60011-5.28715zm9.8003-19.129c0.86691-0.36415,1.25156,0.0424,0.45624,0.64501-2.03286,2.56201-3.2153,5.66443-4.63509,8.58228-1.57529,3.43984-3.12517,6.89132-4.72072,10.3219-0.97983-0.17529-0.92926-0.72662-0.42692-1.44283,2.51137-5.29629,4.70365-10.7515,7.50941-15.9033,0.56158-0.95451,1.15028-1.92255,1.98714-2.6637-0.0567,0.15355-0.11342,0.30708-0.17006,0.46063zm0.9805-0.1598z'/%3E %3C/g%3E %3Cuse xlink:href='%23g3464' transform='matrix(-1,0,0,1,964.29686,0)'/%3E %3Cpath stroke='%2321231E' d='m536.38,414.88c1.5869-0.32898,3.2089-0.78836,4.8568-1.3676-7.6306-4.7877-13.959-10.575-21.484-22.122-7.7068-11.828,3.379-32.951,7.9238-44.156,9.4966-7.0412,18.449-17.379,21.29-31.012,1.1259-7.3349-19.09-4.6832-32.997,1.8857-16.996,8.0293-19.31,5.804-25.369,7.1634-2.1545,10.42,2.3562,11.303,6.6934,10.79-9.3652,15.028-13.273,29.986-15.141,51.497-1.8684-21.512-5.7786-36.469-15.144-51.497,4.3384,0.51226,8.8492-0.37009,6.6934-10.79-6.0589-1.3582-8.3718,0.86707-25.369-7.1634-13.906-6.5689-34.123-9.2206-32.997-1.8857,2.8418,13.632,11.793,23.97,21.29,31.012,4.5448,11.205,15.631,32.329,7.9238,44.156-7.5238,11.547-13.853,17.335-21.484,22.122,1.649,0.57922,3.2699,1.0386,4.858,1.3676-1.1541,1.5755-11.049,4.6632-12.209,3.8419-7.5743-5.3622-14.956-17.956-21.396-25.265-18.245-20.712-27.347-36.702-24.13-49.597,4.5847-13.887,20.93-29.475-0.72365-26.783-21.653,2.694-39.601,32.426-45.366,68.197-2.1381,13.274-3.3778,24.385-4.8251,33.478,11.819-4.2202,17.054-8.4334,20.199-13.622-1.4133,4.9346-2.4735,9.6189-3.1843,14.088,9.669-1.7142,16.683-6.4643,19.195-15.137,1.0169-3.5118,2.2683-6.4314,3.5666-8.8552,2.9697,1.0574,6.8225,0.99632,11.508-0.15509,1.7792,4.2508,15.098,19.102,22.256,30.014,8.0821,12.322,20.229,21.742,24.231,22.255,2.0032,0.2573,2.619-4.192,2.1733-10.324,21.125,0.15038,42.235,0.27493,62.935-0.42884,20.7,0.70377,41.811,0.57922,62.936,0.42884-0.44686,6.1318,0.16772,10.581,2.1709,10.324,4.0018-0.51343,16.149-9.9326,24.23-22.255,7.1579-10.914,20.478-25.764,22.256-30.014,4.6855,1.1502,8.5395,1.2125,11.508,0.15509,1.2995,2.4238,2.5498,5.3434,3.5678,8.8552,2.5111,8.6731,9.5259,13.423,19.194,15.137-0.70958-4.4705-1.7698-9.1548-3.1831-14.088,3.1432,5.1884,8.3788,9.4016,20.198,13.622-1.4473-9.0926-2.687-20.204-4.8251-33.478-5.7634-35.771-23.713-65.503-45.366-68.197-21.652-2.6917-5.3083,12.896-0.72365,26.783,3.2171,12.896-5.8842,28.885-24.13,49.597-6.4389,7.3091-13.821,19.903-21.395,25.265-1.1599,0.82126-11.056-2.2664-12.209-3.8419z' fill='%23FFF'/%3E %3Cg id='g3535'%3E %3Cpath d='m440.58,356.77c-2.0361,1.7812-8.7565,1.807-17.956,2.3968-14.818,0.52048-23.397-3.9536-25.301-13.446,5.5605,6.6288,12.191,9.908,19.725,8.041,10.164-2.5178,15.978-4.3248,18.296-3.876,1.5622,0.55455,3.8434,3.3802,5.2356,6.8838z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m422.64,359.67c-0.0273-0.58009-0.23047-1.24829,0.6016-1.03502,4.67788-0.33997,9.39458-0.35355,14.0308-1.12115,1.03375-0.2215,2.13164-0.43964,2.97904-1.11254,0.37616,0.39942,0.94293,0.85764,0.14661,1.11499-2.18055,1.14814-4.71786,1.2352-7.12013,1.49473-3.54135,0.28687-7.09326,0.42529-10.6379,0.65899zm0.0141,0zm-24.952-14.263c-0.56121,0.45063-1.0128,0.83016-0.0887,0.31755,0.45214-0.14605,0.29284,0.94778,0.53965,1.29466,1.00292,3.73849,3.67839,6.92055,7.10533,8.68778,4.892,2.5633,10.5517,3.04355,15.9864,3.00204,0.44337,0.12859,1.48464-0.37739,1.37365,0.33955,0.30085,0.84346-0.54281,0.60994-1.09574,0.65-5.67852,0.0734-11.5915-0.42855-16.7065-3.09806-3.53249-1.82683-6.33576-5.04428-7.48797-8.86826-0.20114-0.62553-0.35523-1.26471-0.49298-1.90694,0.28895-0.13944,0.57789-0.27889,0.86684-0.41832zm19.225,7.8789c0.22252,0.61301,0.37496,1.18286-0.48321,1.13025-4.38554,0.96699-9.0772-0.00014-12.8395-2.4129-2.5435-1.58301-4.74001-3.66906-6.66265-5.95461,0.45125-0.47366,0.89502-0.85483,1.24486-0.0754,3.2846,3.77899,7.61218,7.02752,12.7021,7.68374,2.01383,0.26843,4.06922,0.11596,6.03842-0.37109zm18.581-3.8619c-0.27733,0.4901-0.0961,1.18318-0.76627,0.90483-2.70273,0.0427-5.3147,0.87142-7.93035,1.47233-3.21657,0.81141-6.42457,1.65669-9.64551,2.45085-0.22518-0.6147-0.37119-1.18172,0.4841-1.14558,4.85797-1.16853,9.65581-2.6043,14.5667-3.54142,1.08234-0.16647,2.20417-0.35966,3.29131-0.14101zm-0.0715-0.02zm5.469,7.7473c-0.38996-0.61127-0.76465-0.80492-0.82432-0.27668-0.98748-2.32098-2.27285-4.66029-4.32193-6.20572-0.72541-0.17389-0.52263-0.64035-0.272-1.18607,0.42937-0.008,0.96207,0.46176,1.35291,0.75766,1.92475,1.70341,3.23074,3.99779,4.20021,6.35146-0.045,0.18645-0.09,0.37289-0.13487,0.55935zm0.13487-0.55925z'/%3E %3Cpath fill='%2321231e' d='m419.53,321.15c0.0285,0.52557,0.0571,1.05113,0.0856,1.5767-0.67235,0.0698-1.10731-0.83629-0.6294-1.3158,0.13673-0.15479,0.34096-0.25225,0.5438-0.2609zm15.272,3.9136c-0.17906,0.49463-0.35811,0.98927-0.53717,1.4839-3.55135-1.26207-7.04724-2.75595-10.7548-3.50922-1.28024-0.25102-2.58933-0.37974-3.89402-0.30978-0.0285-0.52557-0.0571-1.05113-0.0856-1.5767,3.81105-0.19325,7.48236,1.08986,11.0194,2.35068,1.41747,0.51515,2.84268,1.05023,4.25225,1.56112zm8.862,2.5907c0.079,0.52047,0.15794,1.04093,0.23691,1.5614-1.40392,0.12062-2.77133-0.3558-4.10636-0.72626-1.86949-0.56838-3.69689-1.26265-5.52859-1.9402,0.17905-0.49503,0.35811-0.99007,0.53716-1.4851,2.58371,0.94085,5.15251,1.98728,7.85926,2.52241,0.32877,0.0516,0.67405,0.10794,1.00162,0.0677zm0.23691,1.5603c-0.079-0.5201-0.15794-1.0402-0.23691-1.5603,0.66274-0.13796,1.18375,0.72645,0.7527,1.2483-0.11976,0.1689-0.31465,0.28344-0.51579,0.312z'/%3E %3Cpath fill='%2321231e' d='m467.17,336.71c0.0641-0.3893,0.12823-0.7786,0.19235-1.1679,0.39436,0.0471,0.6238,0.53792,0.41891,0.8745-0.11546,0.21606-0.37499,0.33177-0.61126,0.2934zm-9.8613-2.0725c0.10595-0.38067,0.21189-0.76133,0.31784-1.142,3.19473,0.89958,6.46264,1.50481,9.73465,2.044-0.0641,0.38967-0.12823,0.77933-0.19235,1.169-3.31334-0.54742-6.6281-1.16265-9.86014-2.071zm0.31784-1.142c-0.10595,0.38067-0.21189,0.76133-0.31784,1.142-0.39521-0.0936-0.57137-0.63001-0.3057-0.9384,0.14394-0.18633,0.39866-0.266,0.62354-0.2036z'/%3E %3Cpath fill='%2321231e' d='m431.54,331.89c-0.25646,0.4594-0.51292,0.9188-0.76938,1.3782-2.69042-1.51685-4.60582-4.05281-6.15901-6.66166-0.77438-1.29594-1.47166-2.63547-2.19168-3.9618,0.46053-0.25221,0.92107-0.50442,1.3816-0.75663,1.61047,2.9562,3.13524,6.06042,5.60431,8.41373,0.64695,0.60848,1.35976,1.15551,2.13416,1.58816zm7.6071-5.1637c0.46327,0.24869,0.92653,0.49737,1.3898,0.74606-1.16299,2.13225-2.61165,4.22461-4.70078,5.53966-1.30033,0.82202-2.98239,1.146-4.4382,0.55101-0.16958-0.1155-0.62489-0.16931-0.58498-0.37149,0.24234-0.43411,0.48469-0.86823,0.72703-1.30234,0.95683,0.57698,2.18441,0.49252,3.14013-0.0398,1.67797-0.9045,2.86874-2.47511,3.86011-4.06209,0.21319-0.34616,0.41717-0.70774,0.60689-1.06103z'/%3E %3Cpath d='m429.59,330.91-2.1897-2.1935c-1.0673-1.3511-0.45037-3.1511,1.8531-5.401,1.6842,0.73078,3.0318,1.2936,4.3806,1.8563-0.8984,3.0371-2.2472,4.951-4.044,5.7382z' fill='%2321231E'/%3E %3Cpath fill='%2321231e' d='m423.26,412.95c-0.14626,0.35505-0.24183,0.81814-0.41866,1.108-0.57236-0.19639-0.42176-1.13588,0.18451-1.1397,0.0795-0.006,0.15841,0.01,0.23415,0.0317zm23.873-3.5282c0.2764,0.28158,0.5528,0.56317,0.8292,0.84475-2.85707,2.84941-6.58205,4.82734-10.5699,5.49061-4.88263,0.83922-9.89508-0.0671-14.522-1.68701,0.13019-0.37283,0.26037-0.74567,0.39056-1.1185,4.68367,1.63937,9.79909,2.54266,14.716,1.48476,3.46366-0.72617,6.65273-2.52628,9.15618-5.01461zm2.8887-2.8668c0.27835,0.27963,0.55671,0.55926,0.83506,0.83889-0.96197,0.96073-1.92656,1.91879-2.8947,2.8733-0.2764-0.28158-0.5528-0.56317-0.8292-0.84475,0.96706-0.95155,1.92952-1.90871,2.88884-2.86744zm0.83506,0.83889c-0.25475-0.28649-0.63177-0.57453-0.81286-0.86009,0.40509-0.41091,1.15702,0.0709,0.9593,0.6106-0.024,0.094-0.0866,0.18622-0.14644,0.24949z'/%3E %3Cpath fill='%2321231e' d='m452.17,401.28c-0.39057-0.054-0.78113-0.10809-1.1717-0.16213,0.0436-0.53322,0.83399-0.69908,1.0881-0.22861,0.0724,0.11603,0.0999,0.25808,0.0836,0.39074zm-5.5077,15.927c0.0993,0.38223,0.1986,0.76447,0.2979,1.1467-0.22949-0.2714-0.45897-0.54281-0.68846-0.81421,2.1706-4.82111,3.73699-9.91979,4.53806-15.1493,0.0677-0.42378,0.12999-0.84837,0.18851-1.2735,0.39057,0.0537,0.78113,0.10731,1.1717,0.16096-0.723,5.40394-2.20168,10.7012-4.36564,15.7049-0.14846,0.34779-0.30111,0.69377-0.45362,1.0398-0.22948-0.27179-0.459-0.5436-0.68845-0.81538zm-0.39056,0.33249c0.36007,0.16057,0.72013,0.32114,1.0802,0.48171-0.19148,0.5156-1.02971,0.4317-1.1155-0.11099-0.0305-0.12292-0.0131-0.25697,0.0353-0.37072zm15.249-9.5355c0.32331,0.22637,0.64663,0.45273,0.96994,0.6791-2.54489,3.65798-6.34481,6.27398-10.4232,7.96355-1.65717,0.69626-3.37055,1.25322-5.10879,1.70823-0.0993-0.38183-0.1986-0.76367-0.2979-1.1455,4.51592-1.18306,8.96566-3.11061,12.3941-6.35246,0.91515-0.86442,1.74453-1.82203,2.46593-2.85292zm0.96994,0.6791c-0.32331-0.22637-0.64663-0.45273-0.96994-0.6791,0.28211-0.45356,1.06267-0.24183,1.0723,0.2933,0.0141,0.13507-0.0313,0.27913-0.10236,0.3858z'/%3E %3Cpath fill='%2321231e' d='m461.29,400.2c-0.39253,0.036-0.78507,0.0721-1.1776,0.10809-0.075-0.51468,0.6223-0.86148,0.98669-0.4895,0.10908,0.0976,0.17309,0.24157,0.19091,0.38141zm4.4345,15.717c0.2377,0.31527,0.47539,0.63053,0.71309,0.9458-0.28256-0.0664-0.6154-0.0533-0.86632-0.16986-3.16287-4.55487-4.76589-10.0244-5.3675-15.493-0.0342-0.29713-0.0608-0.59504-0.09-0.89268,0.39213-0.036,0.78427-0.0721,1.1764-0.1081,0.48767,5.31571,1.89369,10.6551,4.82017,15.1704,0.14707,0.22933,0.30162,0.45365,0.45627,0.6779-0.28021-0.0426-0.56427-0.0924-0.84208-0.13041zm-0.12901,0.81303c0.32331-0.22636,0.64663-0.45273,0.96994-0.67909,0.32855,0.42034-0.13511,1.0829-0.64221,0.9094-0.13278-0.0343-0.24765-0.1221-0.32773-0.23031zm7.6716-12.607c0.38233,0.0963,0.76467,0.19268,1.147,0.28902-1.18931,4.82941-3.90362,9.33979-7.8789,12.376-0.21878,0.14767-0.34955-0.36525-0.53094-0.4983-0.22006-0.22652-0.37225-0.44396,0.005-0.59046,3.66134-2.87774,6.15479-7.08123,7.25807-11.5762zm1.147,0.28902c-0.38233-0.0963-0.76467-0.19268-1.147-0.28902,0.0972-0.51237,0.87342-0.60948,1.0944-0.1374,0.0709,0.12881,0.0876,0.28665,0.0526,0.42642z'/%3E %3Cpath d='m405.91,317.77c-16.619,1.7976-15.826,12.669-0.28969,28.043,2.9732,2.9408,3.9935,2.8468,4.6281-0.21149,1.1083-5.3434,7.0195-8.5004,10.123-4.4282,2.1123,2.7716,1.6396,4.3577,8.6768,3.3743,8.889,7.4583,16.126,12.704,4.4944,12.267-5.1171-0.19268-9.0603,2.7916-15.727,2.5307,1.9727,3.829,2.3258,4.2731,3.3907,4.5962,6.4624,1.2806,13.273-2.7622,19.793-1.5579,14.285,2.6365-22.887-38.633-22.427-40.263,1.174-4.1533-8.9359-11.599-12.662-4.3507z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m405.97,345.46c-0.63842,1.23846-1.27787,0.0892-1.91709-0.52305-4.06663-4.27995-8.13541-8.87724-10.1508-14.5212-1.1218-3.0258-0.99896-6.83757,1.46938-9.18069,2.77156-2.70665,6.77306-3.5028,10.486-3.95871,0.53366,1.22553-0.65232,1.07905-1.52255,1.20687-3.40595,0.58035-7.26877,1.591-9.22908,4.69776-1.82025,3.10463-0.54232,6.89545,0.99759,9.83683,2.50394,4.69709,6.13668,8.69183,9.86662,12.4421zm3.7918,0.041c1.23655-0.12254,0.92878,0.82322,0.56684,1.62489-0.28918,1.17365-1.70243,1.7251-2.68499,0.99349-0.89226-0.5157-1.63792-1.2395-2.37267-1.95269,0.55407-1.04825,1.10522-0.37822,1.7018,0.23146,0.58531,0.40202,1.31295,1.31586,2.08187,0.93978,0.44179-0.50144,0.55299-1.2107,0.70715-1.83693zm11.005-4.6291c-0.75468,1.07541-1.20296-0.00003-1.94225-0.47584-3.5993-1.99006-7.50785,1.82142-8.08913,5.3069-1.31167,0.1289-0.85329-0.91549-0.51723-1.72594,1.17018-3.03612,4.3719-5.79472,7.79263-5.0023,1.11274,0.27266,2.06762,0.99623,2.75598,1.89718zm8.6005,3.2944c-0.82267,0.89493-0.0252,0.97017-1.46798,1.02783-2.21283,0.22861-5.04601,0.49479-6.47456-1.61862-0.50493-0.68439-0.92609-1.42725-1.44846-2.09945,0.69489-0.96748,1.16417-0.22624,1.57914,0.52367,0.65553,1.25247,1.78838,2.37111,3.30418,2.31447,1.46855,0.17818,2.95855-0.25747,4.39679-0.17925l0.11089,0.0319v-0.00053zm-0.38822-0.11162zm4.5448,13.258c-0.34897-1.27616,0.76789-0.9646,1.63618-0.97489,1.28717-0.097,2.86319,0.0614,3.84925-0.91064,0.20392-1.25764-1.04063-2.20561-1.76368-3.09182-2.65565-2.67061-5.65203-4.96766-8.51636-7.40475,0.51648-1.251,1.22922-0.25488,1.9089,0.29814,3.00325,2.6111,6.33222,4.94884,8.76519,8.13647,0.82652,0.97172,0.98958,2.75446-0.38337,3.32004-1.69558,0.77967-3.67556,0.64217-5.49611,0.62745zm-15.267,1.8058c-1.26553,1.02862-0.71244-0.55103,0.32489-0.25534,4.5533,0.1561,8.72597-1.992,13.1823-2.48968,0.60694,0.0875,2.06733-0.52022,1.77559,0.52242,0.045,0.80826-1.24315,0.22869-1.81842,0.47958-4.28029,0.5466-8.30229,2.52486-12.6773,2.48265-0.75732-0.0816-1.74598,0.32429-0.787-0.73963zm-0.88198,0.45587zm3.9279,3.8795c0.14012,1.19996-0.74295,1.0063-1.3745,0.34552-1.13416-1.21113-1.75717-2.79039-2.55319-4.22498,0.87587-0.8579,1.19019,0.0408,1.54816,0.82243,0.69323,1.07028,1.09315,2.63424,2.42777,3.06983l-0.0481-0.0129-0.00014,0.0001zm-0.19234,0.97752zm19.98-2.5366c0.14648,1.24134-0.79379,0.8877-1.64837,0.79915-6.19169-0.37987-12.1258,2.92894-18.3311,1.73774-0.13055-1.23859,0.79702-0.87957,1.64931-0.78062,6.1938,0.42949,12.1214-2.8804,18.3302-1.75627zm-22.996-39.908c0.98693,0.0432,1.27813,0.60032,1.75926,1.40227,7.27335,9.72399,15.3131,18.9153,21.6824,29.2886,1.39706,2.52315,3.07779,5.10839,3.22757,8.0682-0.002,1.35357-1.21991,2.3099-2.52299,2.25146-1.00449,0.32781-1.85368-0.6834-0.8633-1.073,0.95267,0.22652,2.43681,0.0511,2.39409-1.22302-0.26409-3.04056-2.06253-5.66739-3.54391-8.25018-6.25106-9.98787-14.003-18.9055-21.058-28.3121-0.43061-0.67161-1.06533-1.31019-1.07506-2.15226zm-12.131-3.7209c0.0655-1.28053-0.8678-0.46737,0.0663-1.63521,1.48274-2.35243,4.66815-2.93463,7.12799-1.90927,2.71248,1.07726,5.37582,3.23423,5.96725,6.22126,0.35878,0.95321-0.38673,1.75447-1.00312,0.90271,0.20347-2.25335-1.71126-4.0398-3.40767-5.22378-2.10555-1.46958-5.4093-2.15379-7.35133-0.0535-0.58934,0.47493-0.73943,1.33321-1.39938,1.69782zm0.38938-0.2667zm-0.44216-0.22794zm0.44216,0.22794z'/%3E %3Cpath fill='%2321231e' d='m406.86,317.22c-0.3753,0.13159-0.7506,0.26317-1.1259,0.39476-0.17851-0.43638,0.29851-0.93006,0.7403-0.76399,0.17805,0.0518,0.32614,0.20293,0.3856,0.36923zm7.7021,10.54c-0.25685,0.30312-0.5137,0.60625-0.77055,0.90937-3.08094-2.60039-5.77748-5.75381-7.42321-9.46194-0.2336-0.52173-0.44427-1.05359-0.63427-1.59271,0.3753-0.13159,0.7506-0.26317,1.1259-0.39476,1.24266,3.56448,3.53748,6.68147,6.26598,9.25597,0.46609,0.44197,0.94703,0.86783,1.43615,1.28407zm-0.77173,0.90937c0.25685-0.30312,0.51371-0.60625,0.77056-0.90937,0.37451,0.28535,0.21422,0.95523-0.25099,1.0357-0.17963,0.0433-0.38124-0.004-0.51957-0.12633z'/%3E %3Cpath fill='%2321231E' d='M0.9,0c0,0.435087-0.402944,0.787795-0.9,0.787795s-0.9-0.352708-0.9-0.787795,0.402944-0.787795,0.9-0.787795,0.9,0.352708,0.9,0.787795z' transform='matrix(0.21421557,-1.5108362,1.7589027,0.18400288,404.14272,325.54714)'/%3E %3Cpath fill='%2321231e' d='m358.42,362.56c0.59848-0.47408,1.32908,0.54254,0.68909,0.9577-0.2288-0.31701-0.46287-0.64749-0.68909-0.9577zm-22.681,56.14c1.4717-10.1107,5.01436-19.785,8.4826-29.3523,3.39442-8.52846,6.67439-17.308,12.1596-24.7515,0.46369-1.32127,3.24108-2.73322,2.29845-0.72275-4.4893,4.65989-6.90728,10.8555-9.60853,16.6373-4.91065,11.7007-9.33647,23.7082-11.8608,36.1707-0.44764,1.12949,0.43639,2.66011-1.47141,2.01857zm5.5534,80.362c-5.78817-16.1576-6.83157-33.5392-6.97465-50.5614-0.005-9.94896,0.50423-19.8954,1.42091-29.801,2.25205-0.31461,0.53146,2.66866,0.83998,3.98686-1.5874,21.011-1.8961,42.3628,2.19921,63.1223,0.91312,4.35582,2.07003,8.6669,3.62293,12.8406-0.36938,0.13762-0.73927,0.27475-1.10838,0.41263zm1.1083-0.41357c0.29883,0.70162-0.87351,1.13458-1.10671,0.4112,0.36677-0.13601,0.74642-0.27861,1.10671-0.4112z'/%3E %3C/g%3E %3Cuse xlink:href='%23g3535' transform='matrix(-1,0,0,1,964.29721,0)'/%3E %3Cpath fill='%2321231e' d='m473.11,398.36c-0.36744,0.11209-0.52136,0.43768-0.44596,0.85825,0.0973,1.60258,0.28372,3.19635,0.57726,4.77505,0.34717,1.90631,0.90455,3.77303,1.5507,5.59752,0.98844,2.63176,2.23941,5.16545,3.78762,7.51421,0.91989,1.44912,1.97455,2.83011,3.0336,4.16342,0.21397,0.1901,0.66535,0.19982,0.9308,0.0943,0.53343-0.50658,0.96464-1.16542,1.43447-1.75001,0.8386-1.14048,1.64362-2.30402,2.37938-3.51363,1.45154-2.46533,2.70401-5.05723,3.58456-7.78303,0.72447-2.30922,1.28335-4.68061,1.51478-7.09371,0.11002-0.79391,0.16989-1.59466,0.17871-2.39607-0.0771-0.36516-0.53212-0.59669-0.868-0.403-0.45167,0.20685-0.28061,0.87479-0.35091,1.36115-0.14413,1.84356-0.41895,3.67485-0.8363,5.47723-0.4357,1.85547-1.06395,3.66139-1.78454,5.42373-0.8197,1.97667-1.86651,3.85-2.99053,5.66804-0.84597,1.26376-1.71137,2.51941-2.66568,3.70394-1.03407-1.34203-2.03442-2.71246-2.92593-4.15546-1.35733-2.14179-2.45671-4.44313-3.34951-6.81404-0.77262-2.14584-1.33938-4.36412-1.69086-6.61655-0.18969-1.24583-0.24314-2.53645-0.3812-3.76944-0.12621-0.24497-0.35273-0.38005-0.68246-0.3419z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m549.18,422.03,0,108.56,0,0.004c-0.00099,19.413-7.5285,37.038-19.669,49.809-12.143,12.772-28.899,20.691-47.357,20.691h-0.006c-18.457-0.00099-35.214-7.9188-47.354-20.69-12.143-12.771-19.67-30.397-19.671-49.811v-108.56h134.06z' fill='%23C6363C'/%3E %3Cuse xlink:href='%23path1563' transform='matrix(-1,0,0,1,964.29715,-90.088376)'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m549.18,488.62,0,27.978-53.063,0,0,82.947c-4.5061,1.0104-9.1776,1.5462-13.964,1.5462h-0.005c-4.7852,0-9.4555-0.53458-13.96-1.5462v-82.947h-53.064v-27.978h53.064v-66.588h27.929v66.588h53.063z' fill='%23FFF'/%3E %3Cuse xlink:href='%23path1563' y='-90.088376'/%3E %3Cpath id='path1563' d='m459.14,567.32,0-39.331c-8.5595-2.3028-29.402-10.619-30.486,7.6134-0.50198,8.4276,10.44,13.987,13.39,6.5418,1.3969-3.5223-0.12432-6.0178-2.1827-6.8226-2.2226-0.86943-4.4263,0.92935-3.8376,3.6105-8.8597-4.6373,7.9156-14.483,15.49-1.6684,2.2061,3.7315-3.7226,7.6216-3.7308,10.388-0.007,2.7681,5.8255,6.912,3.7308,10.394-7.6693,12.754-24.351,2.969-15.49-1.6684-0.58876,2.6811,1.6162,4.4799,3.8376,3.6105,2.0572-0.8048,3.5784-3.3003,2.1827-6.8238-2.9509-7.4442-13.892-1.8845-13.39,6.543,1.0837,18.231,21.926,9.915,30.486,7.6122z' stroke='%2321231E' stroke-width='0.99388075' fill='%23FFF'/%3E %3Cuse xlink:href='%23path1563' transform='matrix(-1,0,0,1,964.29715,0)'/%3E %3Cpath fill='%2321231e' d='m414,420.86c0.0769,37.9499-0.15407,75.9048,0.11608,113.851,1.19869,27.857,19.6711,54.508,46.2142,63.7703,22.4262,8.31951,49.0036,2.58773,66.3765-13.74,16.202-14.5213,24.6562-36.6878,23.5841-58.2366,0.00002-35.2156,0.00004-70.4311,0.00005-105.647-45.43,0.00093-90.8621-0.002-136.291,0.001zm2.2653,2.3625h131.79c-0.0773,37.1217,0.15498,74.2486-0.11689,111.367-1.12767,26.6642-18.7148,52.2587-44.0242,61.4104-21.5923,8.2881-47.349,3.04215-64.3154-12.5677-16.0185-14.0851-24.4149-35.7432-23.3346-56.9243,0.00035-34.4285,0.0007-68.857,0.001-103.285z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6' width='900' height='600'%3E%3Crect fill='%23fff' width='9' height='3'/%3E%3Crect fill='%23d52b1e' y='3' width='9' height='3'/%3E%3Crect fill='%230039a6' y='2' width='9' height='2'/%3E%3C/svg%3E"

/***/ }),
/* 184 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1080' height='720' viewBox='0 0 1080 720'%3E %3Crect width='1080' height='720' fill='%2320603D'/%3E %3Crect width='1080' height='540' fill='%23FAD201'/%3E %3Crect width='1080' height='360' fill='%2300A1DE'/%3E %3Cg transform='translate(886.5,188.1)'%3E %3Cg id='h'%3E %3Cpath id='q' fill='%23E5BE01' d='M 116.10000,0.00000 L 35.69202,4.69894 112.14399,30.04889 33.25966,13.77660 100.54555,58.05000 28.56072,21.91541 82.09510,82.09510 21.91541,28.56072 58.05000,100.54555 13.77660,33.25966 30.04889,112.14399 4.69894,35.69202 0.00000,116.10000 -1,-1 z'/%3E %3Cuse xlink:href='%23q' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3Ccircle r='34.3' fill='%23E5BE01' stroke='%2300A1DE' stroke-width='3.4'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg width='750' xmlns='http://www.w3.org/2000/svg' version='1.0' height='500'%3E %3Crect width='750' fill='%23006c35' height='500'/%3E %3Cpath fill-rule='evenodd' d='m323.28 118.09c-0.3878-0.0115-0.96797 0.20495-1.7812 0.6875-1.8284 1.2256-5.4516 5.0006-5.5625 9.3438-0.11087 2.4503-0.57338 2.4407 1.0312 4 1.1591 1.6712 2.3168 1.5069 4.6562 0.28125 1.3436-0.98979 1.7974-1.6212 2.25-3.2812 0.55738-2.7839-2.9295 1.3172-3.375-1.7812-0.77915-2.8766 1.4468-4.0598 3.5625-6.8438 0.0485-1.3111 0.0719-2.381-0.78125-2.4062zm34.062 0.1875c-0.65345 0.088-1.4528 0.92515-2.5625 2.9375-0.79526 2.1076-4.2255 5.2972-1.75 11.875 2.0249 4.1708 2.8567 10.949 1.9375 18.5-1.403 2.1459-1.723 2.8854-3.5625 5.0312-2.5843 2.7789-5.3833 2.0684-7.5312 1.0312-2.0068-1.3526-3.5838-2.0469-4.5-6.3438 0.16531-6.8489 0.56436-18.059-0.6875-20.438-1.8455-3.684-4.8873-2.3628-6.1875-1.25-6.2472 5.712-9.3329 15.357-11.219 23.031-1.7326 5.593-3.5788 3.9755-4.875 1.7188-3.1558-2.9573-3.3775-26.083-7.1875-22.281-6.1021 17.44 3.5018 36.545 10.156 34.688 4.8008 1.9876 7.847-7.1505 9.8125-17.156 1.3446-2.8081 2.3721-3.1309 3.0625-1.6875-0.17741 13.306 0.95406 16.274 4.375 20.312 7.6311 5.8874 13.943 0.7459 14.438 0.25 0.49491-0.4949 5.9375-5.9375 5.9375-5.9375 1.3224-1.391 3.0698-1.4756 4.9375-0.25 1.8153 1.65 1.5822 4.4922 5.4688 6.4688 3.2708 1.3083 10.255 0.31819 11.875-2.5 2.1802-3.7364 2.7088-5.0203 3.7188-6.4375 1.5562-2.0713 4.2188-1.1542 4.2188-0.5-0.24796 1.1551-1.8124 2.2946-0.75 4.375 1.8506 1.3879 2.2804 0.49593 3.375 0.1875 3.8715-1.8506 6.7812-10.25 6.7812-10.25 0.17134-3.1327-1.611-2.8951-2.75-2.25-1.4857 0.90815-1.5768 1.2168-3.0625 2.125-1.8929 0.28122-5.5597 1.5299-7.375-1.2812-1.8536-3.3796-1.8641-8.0912-3.2812-11.5 0-0.24795-2.4765-5.3599-0.1875-5.6875 1.1551 0.21469 3.6392 0.85659 4.0312-1.2188 1.2116-2.0229-2.6142-7.7615-5.2188-10.656-2.2608-2.4815-5.3824-2.784-8.4062-0.25-2.1177 1.9483-1.8035 4.1242-2.2188 6.1875-0.53925 2.3697-0.43618 5.3048 1.9688 8.4375 2.1136 4.1678 5.9535 9.5151 4.6875 17.062 0 0-2.2313 3.5917-6.1562 3.125-1.6359-0.35681-4.3016-1.0648-5.7188-11.531-1.0724-7.9224 0.26872-19.022-3.0938-24.219-0.75911-1.9611-1.4109-3.8654-2.5-3.7188zm-10.78 0.84c-1.0171 0.0888-2.1438 1.2735-3.0625 3.5625-0.78821 1.7407-1.751 10.844-1.5938 10.844-0.62896 2.7093 2.8308 3.8574 4.4062 0.375 2.3616-6.3843 2.373-9.1042 2.5312-11.812-0.3679-2.0627-1.2641-3.0576-2.2812-2.9688zm39.812 0.71875c-1.0447 0.0947-1.8768 0.70635-2.1875 2.25-0.41629 3.6296-0.20355 5.6032 0.40625 8.625 0.46769 2.0149 3.4004 5.3884 4.8438 7.3438 6.896 9.2694 13.531 18.583 19.938 28.219 1.0072 7.155 1.7452 14.154 2.2188 21.125 1.0382 15.284 1.3537 34.31 0.40625 50.406 2.8636 0.1129 7.4518-4.6239 9.0625-11.562 1.0472-9.5976-0.37299-29.18-0.46875-34.844-0.0675-2.3514-0.21224-5.157-0.375-8.0938 7.4527 12.179 14.683 25.082 21.781 39.25 2.5874-1.2297 2.0139-15.798 0.5-17.844-5.6807-12.227-13.529-24.296-16.031-28.938-0.90311-1.6763-3.9793-6.3547-7.625-11.75-0.67122-7.6985-1.4006-14.219-1.875-16.188-1.1722-8.1381 3.3447 0.91775 2.7188-3.8125-1.4656-8.127-5.9513-13.65-11.25-21.094-1.7085-2.4211-1.6747-2.9149-4.3125 0.59375-1.5766 3.5768-1.5553 6.5526-1.0938 9.3438-0.69381-1.0083-1.5514-2.2039-2.7812-3.6875-4.576-3.9259-4.8583-4.1405-8.6562-7.3438-1.1976-0.84982-3.4776-2.1579-5.2188-2zm118 1.2188c-0.50876-0.0791-1.0631 0.17099-1.6875 1.0938-1.1934 1.0462-2.4768 2.9408-2.4375 5.375 0.29027 4.2888 1.0535 8.68 1.3438 12.969 0.10229 0.57392 0.2102 1.1448 0.3125 1.7188-0.46081-0.58803-0.86314-1.0469-1.0938-1.2812-8.3598-8.7822 3.841-1.4353-1.5938-8.2188-4.5962-5.0467-5.941-6.6526-9.875-9.6875-1.9726-1.275-3.1644-3.7112-3.8125 0.4375-0.25802 3.6447-0.52618 7.8653-0.28125 10.938-0.0141 1.7074 1.7542 4.9216 3.2812 6.8125 5.5768 6.8517 11.273 14.142 17 21.75 1.2052 15.516 1.5266 29.739 2.75 45.281-0.17335 6.6473-2.218 15.476-4.1562 16.312 0 0-2.9599 1.7004-4.9375-0.1875-1.4383-0.57755-7.1875-9.5938-7.1875-9.5938-2.9432-2.6982-4.9055-1.9272-7 0-5.7755 5.5769-8.3876 16.023-12.312 23.219-1.012 1.6056-3.8623 2.9724-7.0312-0.125-8.0484-10.996-3.3419-26.648-4.3438-22.625-7.1685 8.0786-3.9938 21.465-2.375 24.344 2.3636 4.7282 4.2758 7.7553 8.875 10.094 4.189 3.0833 7.4508 1.159 9.25-1 4.2152-4.3684 4.2714-15.54 6.25-17.75 1.3879-4.06 4.8662-3.3617 6.5625-1.5625 1.644 2.3636 3.585 3.9014 6 5.1875 3.9319 3.4683 8.6246 4.0984 13.25 0.9375 3.1609-1.773 5.2119-4.0772 7.0625-8.625 1.9856-5.3106 1.0038-33.142 0.5625-48.625 2.9696 4.1831 5.9006 8.4568 8.8125 12.781 1.2782 13.591 1.8582 26.976 1.4375 39.812-0.30139 2.5521 8.9062-7.6196 8.8438-12.438-0.0415-4.2158 0.008-8.0366 0-11.594 4.466 7.1306 8.789 14.38 12.875 21.719 2.532-1.3416 1.6641-15.678 0.0625-17.656-4.2781-7.1786-9.7567-14.936-14-20.938-0.83864-7.5749-1.9805-16.512-2.5-19.25-0.8094-4.2696-1.6201-10.683-2.8438-15.75-0.33567-1.9786-1.3488-8.2985-1.0312-8.9062 0.49893-1.4141 2.3842 0.0452 3.3125-1.5938 1.3899-1.5149-4.8179-17.598-7.9688-22.188-1.1329-2.0572-3.1818-1.3453-5.7188 2-2.3526 2.2013-1.4918 7.2234-0.59375 12 2.3327 12.174 4.4149 24.572 6.0625 36.938-3.0501-4.5343-6.7725-10.021-10.438-15.312-0.0985-0.51026-0.46875-2.3803-0.46875-2.4062-0.00002-0.21873-0.50509-9.959-0.9375-12.281-0.0756-0.94243-0.30028-1.2137 0.6875-1.0938 1.0473 0.88094 1.1896 0.92846 1.8438 1.2188 1.0573 0.19352 1.9818-1.594 1.3438-3.25-3.2708-6.0325-6.5418-12.092-9.8125-18.125-0.3936-0.38756-0.83499-0.79588-1.3438-0.875zm-304.53 0.3125c-1.8123-0.0518-3.8118 1.0716-3.0312 3.25-0.45458 1.1873 3.5475 5.2009 4.25 7.4062 0.62996 1.5704-0.62483 6.6271 0.6875 7.0938 1.2065 0.52312 2.868-3.5005 3.5-7.2188 0.34975-2.037 0.0851-9.0082-4.6562-10.438-0.24291-0.0549-0.4911-0.0863-0.75-0.0937zm346.91 0.04c-0.41312 0.041-0.91624 0.70862-1.6875 2.3438-1.8546 3.0379-2.4928 8.4774-1.75 13.281 4.4652 30.203 7.7834 59.449 8.4688 86.219-0.38402 2.541-0.49612 3.8926-1.6875 7.0938-2.6358 3.3786-5.5427 7.6142-8.2812 9.6562-2.7376 2.0411-8.5638 3.9871-10.469 5.5-6.0436 3.4935-6.074 7.5111-1.1875 7.6562 8.4213-0.97769 18.386-1.6686 25.25-12.031 1.8365-2.9038 3.999-10.776 4.0938-15.594 0.64204-28.247-0.36143-55.866-4.5938-76.281-0.27113-1.9887-1.1492-6.5596-0.8125-7.1562 0.54529-1.398 3.3005 0.13992 4.2812-1.4688 1.4394-1.4696-7.1254-12.436-10.125-17.125-0.59928-1.1776-0.96885-2.1465-1.5-2.0938zm-88.312 0.46875c-0.34774 0.06-0.86114 0.58925-1.8125 1.8438-2.3525 7.6916-3.1793 13.973-2.2812 18.75 6.0426 31.534 12.234 60.263 11.25 90.281 2.8656 0.0191 6.1786-6.5553 7.5938-13.062 0.7751-8.9636-0.51716-14.419-0.75-19.688-0.23181-5.2685-5.9639-48.014-7.125-52-1.401-7.5374 5.5735-0.99148 4.8125-5.375-2.411-5.5265-8.4287-13.574-10.312-18.375-0.70808-1.2858-0.79543-2.475-1.375-2.375zm-215.03 0.59375c-0.7426 0.12864-1.4592 0.74056-1.7188 1.75-0.16329 0.66121 0.28622 1.7611-0.3125 2.0938-0.3437 0.34673-1.6482 0.11368-1.5938-1.7188 0-0.58359-0.42846-1.1926-0.6875-1.5625-0.26005-0.17034-0.43554-0.21875-0.90625-0.21875-0.57352 0.0232-0.56052 0.17445-0.875 0.65625-0.14 0.49-0.32 0.97-0.32 1.53-0.0716 0.65214-0.33273 0.873-0.8125 0.96875-0.53623 0-0.40932 0.0584-0.84375-0.21875-0.25803-0.28222-0.5625-0.3932-0.5625-0.875 0-0.49892-0.13107-1.2954-0.28125-1.625-0.22778-0.30036-0.58775-0.45667-1-0.5625-2.2467 0.008-2.4103 2.5898-2.2812 3.5625-0.16832 0.18344-0.25163 4.7592 2.8125 6.0312 4.1134 1.9614 11.827 1.1322 11.5-5.5 0.00001-0.58662-0.12904-2.5565-0.1875-3.0938-0.41981-0.9777-1.1949-1.3474-1.9375-1.2188zm55.188 0.0625c-1.4216 0.0725-2.6766 0.47991-3.75 1.0312-2.7265 2.6106-3.3657 6.7957-1.2188 9.4062 2.0895 0.98677 4.1742 3.0899 2.7812 4.25-5.9087 6.3111-21.287 16.857-22.062 18.781-0.006 0.0157-0.0279 0.0481-0.0312 0.0625-0.002 0.0138 0.00015 0.05 0 0.0625 0.00047 0.006-0.001 0.0256 0 0.0312 0.005 0.0159 0.0214 0.0496 0.0312 0.0625 0.004 0.004 0.0268 0.0276 0.0312 0.0312 0.005 0.003 0.0257-0.003 0.0312 0 0.006 0.003 0.0245 0.029 0.0312 0.0312 0.007 0.002 0.0233-0.002 0.0312 0 0.002 0.002 0.0286 0.029 0.0312 0.0312 0.78147 0.52416 10.404 0.51176 11.469 0.0312 0.008-0.004 0.0248-0.0271 0.0312-0.0312 0.003-0.002 0.0286 0.002 0.0312 0 0.002-0.002-0.002-0.0291 0-0.0312 3.307-1.2186 19-19.156 19-19.156-0.81342-0.69647-1.5626-1.2098-2.375-1.9062-0.87086-0.75393-0.78317-1.4951 0-2.25 3.8866-2.2618 2.655-7.2382 0.625-9.5-1.6828-0.75445-3.2659-1.01-4.6875-0.9375zm144.25 0.0625c-0.41312 0.041-0.91624 0.67737-1.6875 2.3125-1.8546 3.0379-3.1149 8.3282-2.9688 13.281 4.0176 27.814 5.2493 52.154 7.875 79.969 0.21369 2.6902-0.18067 6.598-1.9688 8.1562-6.6141 6.9064-16.151 15.424-26.531 19.344-1.1168 1.2539 2.7768 6.5988 7.8125 6.5938 8.4213-0.9777 15.823-5.7042 22.688-18.156 1.8355-2.9039 5.0615-9.1196 5.1562-13.938 0.64205-28.247-1.4239-50.209-5.6562-70.625-0.27114-1.9886-0.0867-4.3408 0.25-4.9375 0.54529-0.65112 2.3943 0.0149 3.375-1.5938 1.4393-1.4696-3.8441-13.655-6.8438-18.344-0.59928-1.1776-0.96885-2.1152-1.5-2.0625zm-223.47 0.85c-1.1623 0.1359-2.2557 1.0822-2.7812 2.3438-0.19454 4.4611-0.2207 8.9199 0.28125 13.031 2.029 7.2108 2.6715 13.553 3.6562 20.938 0.27314 9.8909-5.7117 4.2786-5.4375-0.625 1.3819-6.3692 1.0089-16.396-0.21875-18.938-0.97367-2.541-2.1011-3.1683-4.4688-2.75-1.8798-0.1149-6.7361 5.1765-8.0938 13.938 0.00001-0.00001-1.1311 4.4965-1.625 8.5-0.66423 4.5246-3.6616 7.7288-5.75-0.625-1.8052-6.0718-2.9147-21.032-5.9375-17.531-0.86582 11.681-1.8939 32.235 8.0312 34.344 12.005 1.1541 5.3735-20.294 9.7188-24.188 0.82147-1.9242 2.3438-1.9584 2.4688 0.46875v18.219c-0.10986 5.9226 3.7877 7.6826 6.8125 8.9062 3.1478-0.24292 5.235-0.15687 6.4688 2.9062 0.49188 10.502 1.0081 21.03 1.5 31.531 0 0 7.2773 2.0912 7.625-17.719 0.34876-11.632-2.3163-21.393-0.75-23.656 0.0554-2.2235 2.9055-2.3335 4.875-1.25 3.1377 2.2134 4.5298 4.9374 9.4062 3.8438 7.4204-2.0441 11.89-5.6459 12-11.344-0.43342-5.4146-1.0598-10.835-3.4062-16.25 0.32759-0.98475-1.4203-3.5465-1.0938-4.5312 1.3335 2.0884 3.3509 1.9151 3.8125 0-1.263-4.1618-3.2292-8.1494-6.4062-9.875-2.6257-2.3132-6.4679-1.824-7.875 3-0.65214 5.5588 2.0146 12.147 6.0625 17.531 0.85977 2.1036 2.0624 5.6022 1.5312 8.75-2.154 1.2287-4.2896 0.7175-6.0938-1.1875 0.00001-0.00001-5.9062-4.4215-5.9062-5.4062 1.5673-10.035 0.33759-11.184-0.53125-13.969-0.60677-3.8443-2.4286-5.0618-3.9062-7.6875-1.4776-1.5663-3.482-1.5663-4.4375 0-2.6106 4.5256-1.3858 14.242 0.5 18.594 1.3627 4.0025 3.4525 6.5 2.4688 6.5-0.81038 2.2618-2.5002 1.7356-3.7188-0.875-1.7397-5.3955-2.0938-13.437-2.0938-17.062-0.52212-4.4944-1.1042-14.095-4.0625-16.531-0.78934-1.0751-1.721-1.4494-2.625-1.3438zm42.156 0.0625c-0.59574 0.0753-1.2543 0.41445-2.0312 0.59375-2.5521 0.8124-4.9414 3.0187-4.1875 7.3125 3.0168 18.332 4.9832 32.323 8 50.656 0.46368 2.1469-1.336 4.9768-3.6562 4.6875-3.9451-2.669-4.9242-8.0746-11.656-7.8438-4.8734 0.0585-10.431 5.3615-11.125 10.469-0.81239 4.059-1.1017 8.4601 0 12 3.425 4.1184 7.5277 3.6793 11.125 2.75 2.9583-1.2176 5.3923-4.133 6.4375-3.4375 0.003 0.003 0.0286-0.004 0.0312 0 0.003 0.004-0.003 0.027 0 0.0312 0.64509 1.1276-0.0608 10.663-13.938 18.031-8.5281 3.8292-15.316 4.7441-18.969-2.2188-2.2628-4.3513 0.16462-20.924-5.4062-17.094-16.475 42.467 38.598 48.395 44.75 1.75 0.39844-1.3159 1.6121-2.6362 2.4688-2.3125 0.3759 0.16008 0.71998 0.67052 0.84375 1.625-1.2771 42.235-42.606 45.13-49.625 31.844-1.7397-3.1317-2.2631-10.103-2.4375-14.281-0.31817-2.5275-0.95237-3.9854-1.6875-4.5625-1.6745-1.2582-3.9247 2.023-4.4062 7.7188-0.69647 4.5831-0.5 5.8413-0.5 10.25 2.2044 33.359 55.388 19.026 64.031-8.5312 4.2787-14.246-0.0871-24.993 1.3438-26.312 0.0124-0.0104 0.0493-0.0222 0.0625-0.0312 0.0136-0.008 0.048-0.0242 0.0625-0.0312 0.0149-0.006 0.0467-0.0262 0.0625-0.0312 0.0487-0.013 0.13046-0.0305 0.1875-0.0312 5.2796 5.6868 12.688 0.72253 14.312-1.25 0.69648-0.98677 2.4387-1.6198 3.6562-0.34375 4.1184 2.9603 11.337 1.5649 12.844-3.6562 0.87085-5.1052 1.6069-10.361 1.7812-15.812-2.6827 0.83292-4.8475 1.4566-5.7188 2.375-0.20749 0.22659-0.36097 0.47794-0.40625 0.75-0.23283 1.5089-0.45467 3.0224-0.6875 4.5312-0.0249 0.12473-0.065 0.23996-0.125 0.34375-0.11434 0.18521-0.30336 0.35601-0.5 0.46875-0.94842 0.51783-2.6022 0.22171-2.6875-1.1562-1.276-5.8017-6.5276-6.5563-9.7188 2.4375-2.1469 1.7397-6.0616 2.0793-6.4688-0.53125 0.52213-6.0335-1.9089-6.8434-6.7812-4-1.5664-11.951-3.1202-23.361-4.6875-35.312 2.031-0.0585 3.8934 1.414 5.75-0.90625-2.0092-6.2487-6.2607-18.963-8.6562-20.156-0.0188-0.009-0.0439-0.024-0.0625-0.0312-0.10876-0.1305-0.23745-0.25071-0.34375-0.34375-0.0442-0.0375-0.1123-0.0933-0.15625-0.125-0.0439-0.0305-0.11251-0.0687-0.15625-0.0937-0.0962-0.0528-0.21644-0.0958-0.3125-0.125-0.2184-0.0619-0.43059-0.091-0.65625-0.0625zm164.34 0.0937c-2.1076-0.0625-4.4397 1.2657-3.5312 3.9062-0.52916 1.4403 4.5283 6.326 5.3438 9 1.4676 4.1084-1.1208 8.0273 0.40625 8.5938 1.4051 0.63399 3.36-4.2415 4.0938-8.75 0.84767-3.6447-1.7525-11.114-5.4375-12.656-0.28247-0.0665-0.57391-0.0848-0.875-0.0937zm-128.03 4.5c0.95979-0.0978 2.1195 0.78407 2.6875 2.0312 0.60588 1.3303 0.30199 2.6014-0.6875 2.8438-0.98948 0.24236-2.2691-0.63842-2.875-1.9688-0.60586-1.3303-0.30199-2.6326 0.6875-2.875 0.0618-0.0152 0.12351-0.0247 0.1875-0.0312zm237.5 6.1562c-1.9215-0.0673-4.0156 1.3916-3.1875 4.25-0.4818 1.5593 4.1009 6.8552 4.8438 9.75 0.66826 2.0602-1.017 8.6997 0.375 9.3125 1.2811 0.6864 3.0818-4.5873 3.75-9.4688 0.37092-2.672-1.6093-12.049-4.9688-13.719-0.25753-0.0719-0.538-0.11538-0.8125-0.125zm-131.31 3.25c0.17575 0.78356 0.3514 1.5724 0.46875 2.375 0.39382 1.7317 0.73331 3.4518 1.0938 5.1562-1.5169-2.0887-2.7725-3.7763-3.3125-4.375-3.4323-4.079 0.0773-2.6786 1.75-3.1562zm30.25 14.875c-0.7426 0.12864-1.4592 0.7718-1.7188 1.7812-0.16329 0.6612 0.31746 1.7299-0.28125 2.0625-0.3437 0.34673-1.6794 0.14492-1.625-1.6875-0.00001-0.5836-0.42846-1.2238-0.6875-1.5938-0.26003-0.17035-0.43554-0.21875-0.90625-0.21875-0.57353 0.0232-0.56053 0.17446-0.875 0.65625-0.13304 0.49087-0.3125 0.97487-0.3125 1.5312-0.0716 0.65214-0.30147 0.87299-0.78125 0.96875-0.53622 0-0.44058 0.0584-0.875-0.21875-0.25804-0.28221-0.5625-0.39321-0.5625-0.875 0.00001-0.49893-0.13107-1.2954-0.28125-1.625-0.2278-0.30037-0.58776-0.42541-1-0.53125-2.2467 0.008-2.379 2.5586-2.25 3.5312-0.16834 0.18344-0.28288 4.7905 2.7812 6.0625 4.1134 1.9614 11.858 1.101 11.531-5.5312 0.00001-0.58662-0.16029-2.5565-0.21875-3.0938-0.41981-0.9777-1.1949-1.3474-1.9375-1.2188zm-138.12 1.375c-0.5072-0.0517-1.1721 0.13451-1.9375 0.59375-3.6376 1.9675-5.0461 7.8039-2.7812 11.219 2.1157 3.0077 5.4607 1.9062 5.9062 1.9062 3.564 0.4455 5.6875-6.6875 5.6875-6.6875-0.00001 0 0.10732-2.0056-4.125 1.7812-1.781 0.33363-2.0232-0.3096-2.4688-1.3125-0.37093-1.8556-0.29122-3.7371 0.5625-5.5938 0.39436-1.1131 0.002-1.8201-0.84375-1.9062zm195.25 0.90625c-2.0194-0.0982-4.1688 1.2095-4.7188 3.9688 0.008 1.6278 0.73488 2.5224 0.59375 4-0.21065 0.84465-1.0809 1.4001-3.1562 0.40625 0.32455-0.29835-1.3438-2.6562-1.3438-2.6562-1.6188-0.98576-3.7804 0.0535-5.1875 0.96875-0.7741 1.4071-1.3467 3.8189-0.46875 6.2812 2.3233 4.2928 10.293 11.618 14.094 11.688 0.0706-3.8705 0.4466-9.0175 0.65625-12.219 0.0897-1.2085 0.37315-2.5404 1.5312-2.8438 1.1571-0.30238 3.1653 1.1642 3.1875-0.0937-0.21066-2.4624-0.70279-6.096-2.0938-7.8125-0.71249-1.0557-1.8821-1.6286-3.0938-1.6875zm-161.62 13.469c-0.0537 0.0197-0.10688 0.0656-0.15625 0.0937-0.0242 0.0147-0.0693 0.0449-0.0937 0.0625-0.40219 0.30193-0.87679 0.99874-1.9375 1.75-1.7891 2.035-2.1098 3.4521-2 7.5312 0.10179 0.43147 3.3965 9.5919 6.1875 16.031 1.8818 6.6927 3.6228 14.356 2.3438 21.594-4.4057 9.5684-13.263 18.15-21.812 22.812-4.3557 1.395-8.1174 0.91994-9.125-0.0312-0.008-0.008-0.024-0.0236-0.0312-0.0312-2.5014-1.6818-2.5588-4.6756-2.4062-5.1875-0.00005-0.003 0.00017-0.0277 0-0.0312 0.006-0.006 0.0255-0.0258 0.0312-0.0312 7.2138-5.0246 15.454-9.0914 21.906-22.656 1.905-5.1838 2.4866-8.2964 0.59375-16.312-0.73791-2.9868-1.6494-5.4446-3.6875-7.5625 0.005-0.006 0.0259-0.0257 0.0312-0.0312 1.228-0.58751 4.4141 1.7597 4.9062 0.28125-0.75393-3.8271-3.3461-8.965-6.2812-11.594-2.5702-2.3344-5.3662-2.6046-7.7188-0.46875-2.6499 1.4746-3.2135 6.7707-1.9375 11.406 1.4172 3.4895 5.2433 4.1017 7.9688 11.125-0.00005 0.007-0.00024 0.0289 0 0.0312 0.0568 0.44036 0.93536 5.2424-0.4375 7.1875-1.1141 3.4742-15.424 14.759-16.438 15.438-0.0112 0.0112-0.0829 0.0519-0.0937 0.0625-0.006 0.006-0.0259 0.026-0.0312 0.0312-0.003 0.002-0.0246 0.0245-0.0312 0.0312-0.003 0.003-0.0284 0.028-0.0312 0.0312-0.003 0-0.0278 0.00017-0.0312 0-0.002-0.00007-0.0241-0.00011-0.0312 0-0.006-0.005-0.0257-0.0254-0.0312-0.0312 0.00024-0.003-0.00007-0.0284 0-0.0312-0.006-0.0108-0.0256-0.0512-0.0312-0.0625-0.0431-0.28175 0.0326-0.99908 0-2.1562-0.094-2.1144 0.78114-6.8979 0.71875-7.7188 0.00003-0.003-0.00009-0.0281 0-0.0312-0.006-0.006-0.0254-0.0257-0.0312-0.0312 0.00004-0.003-0.00016-0.0278 0-0.0312-0.007 0.00014-0.0302 0.00009-0.0312 0-4.7302 3.0541-6.2924 12.416-7.1562 15.188-11.975 8.2741-25.574 14.43-33.406 22.812-4.0791 6.3702 28.104-7.3147 31.844-8.9688 0.0321 0.0241 0.0641 0.063 0.0937 0.0937 0.71089 0.78237 0.77161 3.5103 2.9062 5.9688 3.3453 4.5317 10.456 7.3224 17.375 5.5938 11.603-4.194 18.288-12.102 25.094-20.875 0.97266-1.4151 2.4972-2.5301 3.9062-1.4375 4.6768 10.47 18.161 17.92 35.594 18.688 4.0338-4.9056 2.1046-7.3177 0.46875-8.3438-0.50391-0.33487-8.6698-3.5184-9.9375-6.6875-0.79829-2.9492 1.1426-5.5648 5.0312-7.5312 11.193-1.3537 22.196-2.8573 32.844-6.2812 0.10784-3.5772 2.2149-8.9267 3.625-11.25 0.97909-1.612 1.6086-1.7716 1.8438-2 0.008-0.008 0.0246-0.023 0.0312-0.0312 0.003-0.004 0.0284-0.0269 0.0312-0.0312 0.006-0.005 0.0256-0.0257 0.0312-0.0312 0.00002-0.0107 0.00042-0.0514 0-0.0625 0.006-0.0708-0.00049-0.19272-0.0312-0.3125l-1.8125-1.0625-35.719-0.15625c-0.44124-0.16987-0.76931-0.34037-0.96875-0.5-0.0152-0.0127-0.0489-0.0499-0.0625-0.0625-0.006-0.006-0.0253-0.025-0.0312-0.0312-0.006-0.006-0.0261-0.0251-0.0312-0.0312-0.005-0.0109-0.0263-0.0516-0.0312-0.0625-0.003-0.003-0.0277-0.0279-0.0312-0.0312 0.00006-0.003-0.00029-0.0279 0-0.0312-0.003-0.003-0.0276-0.0279-0.0312-0.0312 0.00002-0.003-0.00018-0.0279 0-0.0312 0.00001-0.003-0.00013-0.0279 0-0.0312 0-0.003-0.00008-0.0279 0-0.0312-0.00033-0.005 0.00012-0.0265 0-0.0312 0.00013-0.002 0.00009-0.0246 0-0.0312-0.00005-0.003 0.0001-0.0279 0-0.0312-0.00006-0.003 0.00014-0.0279 0-0.0312-0.00007-0.003 0.00019-0.0279 0-0.0312 0.006-0.006 0.0254-0.0256 0.0312-0.0312 0.008-0.0165 0.0204-0.0462 0.0312-0.0625 0.17439-0.23501 0.59702-0.45652 1.125-0.65625 8.5292-1.1621 23.682-3.646 24.688-18.219-0.15724-7.5908-3.2482-12.561-12.562-13.938-6.8439 0.52918-11.725 7.1491-10.938 14.438-0.32757 1.9624 0.66406 5.8136-1.3438 6.25-13.128 1.1994-27.457 9.4251-27.938 15.312-0.003-0.00052-0.0285 0.00014-0.0312 0-0.005 0.006-0.0258 0.0256-0.0312 0.0312-0.0101 0.005-0.046 0.0231-0.0625 0.0312-0.0109-0.00015-0.0515 0.0004-0.0625 0-0.0211 0.007-0.0722 0.0257-0.0937 0.0312-0.006 0.00054-0.0232-0.00011-0.0312 0-0.0178-0.00028-0.0507 0-0.0625 0-0.006-0.00019-0.0232-0.0002-0.0312 0-0.0132 0.00033-0.0516 0.00053-0.0625 0-0.0339-0.007-0.0956-0.0238-0.125-0.0312-0.85384-0.23714-1.9538-1.6462-1.7812-3.625-0.49994-10.177-3.8122-21.693-9-30.562-1.8513-1.8508-2.6579-2.6008-3.1875-2.6875-0.0171-0.002-0.0459 0.0008-0.0625 0-0.0218-0.00009-0.0656 0.00025-0.0937 0-0.005 0.00014-0.0264-0.0004-0.0312 0-0.003-0.00009-0.0283 0.00025-0.0312 0-0.004 0.001-0.0274-0.001-0.0312 0zm34.188 5.375c-0.7426 0.12864-1.4592 0.74055-1.7188 1.75-0.16327 0.66121 0.31746 1.7611-0.28125 2.0938-0.34371 0.34673-1.6794 0.14493-1.625-1.6875 0-0.58359-0.42846-1.2238-0.6875-1.5938-0.26004-0.17034-0.40429-0.21875-0.875-0.21875-0.57352 0.0232-0.59178 0.17445-0.90625 0.65625-0.13306 0.49085-0.3125 0.97487-0.3125 1.5312-0.0716 0.65214-0.30147 0.873-0.78125 0.96875-0.53623 0-0.40933 0.0584-0.84375-0.21875-0.25803-0.28222-0.59375-0.3932-0.59375-0.875-0.00001-0.49893-0.0998-1.2954-0.25-1.625-0.22779-0.30036-0.61901-0.42542-1.0312-0.53125-2.2467 0.008-2.379 2.5586-2.25 3.5312-0.16833 0.18345-0.28288 4.7905 2.7812 6.0625 4.1134 1.9614 13.916 0.80665 11.531-5.5312-0.00001-0.58662-0.16029-2.5565-0.21875-3.0938-0.4198-0.9777-1.1949-1.3474-1.9375-1.2188zm137.97 5.6562c-0.1034-0.0186-0.22236-0.0114-0.34375 0.0312 0 0-19.059 13.559-19.531 14.031-1.8899 1.6802-0.94442 7.5886 0 6.9062 1.3658 0.52513 20.554-12.478 20.188-14 0.83627 0.0491 1.2385-6.6892-0.3125-6.9688zm-119.96 2.01c0.77787-0.0825 1.7982 0.18143 2.7812 0.75 1.4228 0.82293 2.2998 2.0657 2.1875 2.9688-0.004 0.0245 0.005 0.0698 0 0.0937-0.006 0.0238-0.0554 0.0705-0.0625 0.0937-0.008 0.023-0.0221 0.0713-0.0312 0.0937-0.006 0.0148-0.0241 0.048-0.0312 0.0625-0.007 0.0144-0.0231 0.0484-0.0312 0.0625-0.0466 0.0763-0.12358 0.15638-0.1875 0.21875-0.68395 0.63877-2.2626 0.54784-3.75-0.3125-1.4098-0.81544-2.281-2.068-2.1875-2.9688 0.003-0.0246 0.0267-0.0696 0.0312-0.0937 0.0236-0.11178 0.0679-0.21374 0.125-0.3125 0.0204-0.0353 0.0384-0.0926 0.0625-0.125 0.005-0.006 0.0261-0.025 0.0312-0.0312 0.042-0.049 0.10547-0.11459 0.15625-0.15625 0.22671-0.17829 0.54802-0.30575 0.90625-0.34375zm-166.91 3.4375c-9.8758 0.18043-24.338 12.945-24.719 20.031 10.421-5.0044 20.657-9.8212 31.25-15-1.7095-2.5521-0.10363-4.8518-6.5312-5.0312zm32 4.4375c0.96809 0.0109 1.9891 0.48893 2.5312 1.8438 0.48784 1.2428 0.0231 2.5424-0.5625 3.1875-0.003 0.005 0.003 0.0263 0 0.0312-0.009 0.0144-0.0215 0.049-0.0312 0.0625-0.4145 0.53404-1.8697 0.3125-2.9062 0.3125-1.2539-0.0554-1.8721-0.26122-2.625-1.2812-0.35982-1.1339 0.73594-2.2481 1.2188-3.0938 0.005-0.008 0.0263-0.0234 0.0312-0.0312 0.0524-0.0788 0.13801-0.17326 0.21875-0.25 0.375-0.34347 1.0235-0.66453 1.7188-0.75 0.13519-0.0166 0.26795-0.0328 0.40625-0.0312zm251.16 3.93c-1.756 0.21654-3.4252 1.877-2.6562 4.5312-0.4818 1.5593 2.3822 7.0115 3.125 9.9062 0.66827 2.0602-0.86071 7.8872 0.53125 8.5 1.2811 0.68641 4.6502-3.4593 4.5312-8.6562 0.37092-2.672-0.95304-12.517-4.3125-14.188-0.38629-0.10791-0.81353-0.14372-1.2188-0.0937zm-213.31 9.625c-1.552 0.10848-2.9369 0.93803-2.3125 3.125-0.0937 1.5865 4.3851 3.5156 4.6562 7.1875 0.64004 1.5139-0.9575 6.362 0.375 6.8125 1.2236 0.50396 2.9215-3.3513 3.5625-6.9375 0.35479-1.9645-1.5367-8.8358-4.75-10.062-0.49313-0.10609-1.0139-0.16116-1.5312-0.125zm63.844 8.7188c0.11777-0.008 0.22161 0.00072 0.34375 0 0.0205-0.00013 0.0419-0.00009 0.0625 0 3.9793 1.0815 9.8454 1.1936 14.938 1.7188 4.1477 0.26307 6.1971 3.5103 2.3125 4.875-3.8322 1.3124-7.5141 2.3374-7.5312 7.875 0.50376 2.7431 0.39705 4.1826-0.0312 4.8438-0.0335 0.0496-0.0878 0.11552-0.125 0.15625-0.005 0.006-0.0258 0.0258-0.0312 0.0312-0.006 0.005-0.0256 0.0261-0.0312 0.0312-0.006 0.005-0.0255 0.0265-0.0312 0.0312l-0.0312 0.0312c-0.011 0.005-0.0514 0.0259-0.0625 0.0312-0.0557 0.0346-0.12681 0.0715-0.1875 0.0937-0.0536 0.0182-0.1305 0.0217-0.1875 0.0312-0.91095 0.1336-2.234-0.73511-3.2188-1.25-2.3626-1.6964-8.9931-5.8056-9.9375-14.625-0.13438-1.9902 1.3554-3.7064 3.75-3.875zm-155.94 6.7812c-0.24858 0.008-0.74605 0.75061-1.4062 1.5938-5.8753 9.3597-6.3978 23.331-3.1562 27.5 1.7226 1.9695 4.5628 2.8356 6.6562 2.2188 3.6911-1.6006 5.3134-9.077 4.4375-11.812-1.2317-1.9282-2.2078-2.2337-3.4375-0.59375-2.5974 5.2735-3.6784 1.666-3.9062-1.2812-0.39814-5.589 0.14322-10.736 0.75-14.812 0.32304-2.089 0.31108-2.8203 0.0625-2.8125zm200.16 12.29c-0.43689-0.0234-0.90278 0.0449-1.375 0.28125-0.0927 0-4.2058 2.7815-5.5312 4.7188-0.80837 0.61485-0.71671 1.1493-0.46875 2.2188 0.62996 1.4484 1.7401 0.99386 3 0.3125 1.6722-0.2278 2.4808 0.8672 2.3438 2.875-0.77208 2.5037 0.34374 3.4365 0.34375 3.5938 0 0.15724 1.6101 1.5392 3.5 0.4375 3.9894-1.523 6.4755-3.0042 12.062-4.2188 1.4666-0.0292 1.3818-3.9536-0.9375-4.0938-3.0258 0.1522-5.8179 0.30676-8.8438 2.6875-1.8617 0.43039-2.1805-0.70275-2.5938-1.7188-0.47272-2.5208 1.0645-4.2976 0.75-6.1875 0.0839 0.0831-0.93932-0.83604-2.25-0.90625zm128.16 4.7812c-0.74222 0.0232-1.5238 0.12602-2.6562 0.21875-1.2246 0.26006-1.6522 0.79656-1.875 2.2812 0.0877 2.2517 1.4649 2.1402 2.875 3.0312 0.81645 1.0392 1.3476 1.98-0.0625 3.6875-1.3365 1.2246-2.2885 1.9004-3.625 3.125-0.631 1.0765-1.024 2.7299 0.90625 3.25 3.564 1.0019 11.812-4.3569 11.812-4.4688 1.3365-1.0019 0.89313-2.9062 0.78125-2.9062-0.77912-0.89102-2.5374-0.35586-3.7188-0.5-0.56244 0-2.4092-0.27339-1.5312-1.9062 0.73278-1.016 1.0031-1.6232 1.5-2.875 0.55638-1.2246 0.0673-2.0505-1.9375-2.7188-1.021-0.18546-1.7265-0.24193-2.4688-0.21875zm-53.54 108.4c-0.008 0.004-0.0234 0.0258-0.0312 0.0312-5.9277 1.521-5.7433 7.6749-1.9375 10.375-62.594 0-158.65-1.0625-179.25-1.0625-11.525 0-47.987-1.375-48.688-1.375 7.8196 11.437 19.147 13.766 33.969 14 27.802 0 156.62-0.34375 193.28-0.34375-2.6062 4.6275 0.23645 12.074 2.2812 13.438 0.0434 0.0279 0.11369 0.0715 0.15625 0.0937 0.0763 0.038 0.17693 0.0749 0.25 0.0937 0.0242 0.006 0.07-0.003 0.0937 0 2.4271 0.5725 3.4951-1.1846 4.3125-2.4688 3.9372 0.34703 26.097 0.66757 28.125-0.0312 0.007-0.003 0.0245-0.0284 0.0312-0.0312 1.3718 2.0189 2.7332 3.9264 5.3438 3.5938 4.569-0.97972 8.1674-1.477 8.2812-10.75 0 0-0.46704-15.802-10.844-14.812-2.4553 0.37092-9.3438 1.0625-9.3438 1.0625-7.9718-0.94847-13.819-1.0454-22.781-1.375 0.82723-1.0502 2.2878-5.3034 0.5-6.8438-0.46622-0.38767-1.1617-0.60352-2.125-0.53125-0.007 0.0005-0.0244-0.00008-0.0312 0-0.0136-0.00068-0.0492 0.002-0.0625 0-0.007-0.002-0.0248-0.0293-0.0312-0.0312-0.0257-0.009-0.0692-0.0161-0.0937-0.0312-0.0486-0.033-0.11173-0.10294-0.15625-0.15625-0.011-0.0139-0.0517-0.0475-0.0625-0.0625-0.45322-0.65987-0.70068-2.2777-1-2.6875-0.004-0.004-0.0277-0.0271-0.0312-0.0312-0.004-0.003-0.0276-0.0282-0.0312-0.0312-0.0109-0.007-0.0514-0.0277-0.0625-0.0312-0.004-0.00036-0.0275-0.00006-0.0312 0-0.004 0.00091-0.0274-0.001-0.0312 0zm4.25 22.594c0.0109-0.005 0.0202 0.005 0.0312 0 9.1319 0.44551 17.712 0.0857 26.844 0.53125 1.4473 1.2303 0.72345 4.0484-0.21875 4.5625-0.0422 0.0211-0.11339 0.051-0.15625 0.0625-0.0344 0.008-0.0905-0.001-0.125 0-0.0345-0.0007-0.0905 0.008-0.125 0-2.9694-0.0746-4.6869-0.14417-7.6562-0.21875-0.005-0.14772-0.0215-0.30707-0.0625-0.4375-0.70371-2.0856-5.8008-1.9461-7-0.3125-0.0166 0.0235-0.0475 0.0696-0.0625 0.0937-0.0192 0.0325-0.0463 0.0915-0.0625 0.125-0.0193 0.0422-0.0482 0.11238-0.0625 0.15625-0.0187 0.0619-0.0229 0.15372-0.0312 0.21875-0.008 0.0748-0.0379 0.17113-0.0312 0.25-4.0086 0.4818-7.6164-0.13309-11.625-0.28125-1.1761-1.4641-1.0388-4.1134 0.34375-4.75z' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='800' height='400'%3E %3Cpath d='M0,400V0H800z' fill='%230051ba'/%3E %3Cpath d='M0,400H800V0z' fill='%23215b33'/%3E %3Cpath d='M0,400 800,0' stroke='%23fcd116' stroke-width='36'/%3E %3Cg transform='translate(140,120)'%3E %3Cg id='s' fill='%23fff'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath id='o' d='M0,-40V0H20z' transform='rotate(18,0,-40)'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3Cg id='s2' transform='rotate(40.6)'%3E %3Cuse id='s1' xlink:href='%23s' x='-104' transform='rotate(-40.6,-104,0)'/%3E %3Cuse xlink:href='%23s1' x='208'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 187 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='450'%3E %3Cpath d='M0,450H900V0H0z' fill='%23d62828'/%3E %3Cpath d='M0,450V0H600z' fill='%23fcd856'/%3E %3Cpath d='M0,450V0H300z' fill='%23003f87'/%3E %3Cpath d='M0,450H900V150z' fill='%23fff'/%3E %3Cpath d='M0,450H900V300z' fill='%23007a3d'/%3E %3C/svg%3E"

/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='300' viewBox='0 0 12 6'%3E %3Crect width='12' height='6'/%3E %3Crect fill='%23FFF' width='12' height='4'/%3E %3Crect fill='%23D21034' width='12' height='2'/%3E %3Cpolygon fill='%23007229' points='0,0 4,3 0,6'/%3E %3C/svg%3E"

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1600' height='1000' viewBox='0 0 16 10'%3E %3Crect width='16' height='10' fill='%23006aa7'/%3E %3Crect width='2' height='10' x='5' fill='%23fecc00'/%3E %3Crect width='16' height='2' y='4' fill='%23fecc00'/%3E %3C/svg%3E"

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='4320' height='2880'%3E %3Crect fill='%23ed2939' width='4320' height='1440'/%3E %3Crect fill='%23fff' y='1440' width='4320' height='1440'/%3E %3Cpath fill='%23fff' d='M 1481.678,720 A 541.5,541.5 0 1 1 398.67798,720 A 541.5,541.5 0 1 1 1481.678,720 z'/%3E %3Cpath fill='%23ed2939' d='M 1651.835,720 A 511.73499,511.73499 0 1 1 628.36499,720 A 511.73499,511.73499 0 1 1 1651.835,720 z'/%3E %3Cpath fill='%23fff' id='star' d='M 1007.1951,733.06439 L 933.63466,676.63425 L 860.09279,733.09117 L 888.40587,642.09687 L 814.61147,586.0053 L 905.6704,586.1981 L 933.6049,495.07467 L 961.56934,586.18798 L 1052.6282,585.96246 L 978.8522,642.0808 L 1007.1951,733.06439 z'/%3E %3Cuse xlink:href='%23star' transform='translate(577.18853,0)'/%3E %3Cuse xlink:href='%23star' transform='translate(288.88853,-214.21117)'/%3E %3Cuse xlink:href='%23star' transform='translate(107.99953,342.74883)'/%3E %3Cuse xlink:href='%23star' transform='translate(469.18853,342.74883)'/%3E %3C/svg%3E"

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30' width='1200' height='600'%3E %3CclipPath id='t'%3E %3Cpath d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z'/%3E %3C/clipPath%3E %3Cpath d='M0,0 v30 h60 v-30 z' fill='%2300247d'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' stroke='%23fff' stroke-width='6'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' clip-path='url(%23t)' stroke='%23cf142b' stroke-width='4'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23cf142b' stroke-width='6'/%3E %3C/svg%3E"

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' height='600' width='1200' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 12 6'%3E %3Ctitle%3EFlag of Slovenia%3C/title%3E %3Crect width='12' fill='%23ed1c24' height='6'/%3E %3Crect width='12' fill='%23005da4' height='4'/%3E %3Crect width='12' fill='%23fff' height='2'/%3E %3Cg transform='translate(2.2238 1) scale(.12937)'%3E %3Csvg width='12' viewBox='-120 -190.223125 240 309.188274' height='15.459'%3E%3C!-- R0 = 15*sqrt(349) %7E 280.223125 Py= 15*sqrt(285)-90 %7E 163.229145242 --%3E %3Cpath d='m110.26-19.478l9.74-143.75a280.22 280.22 0 0 0 -240 0l9.74 143.75a155.61 155.61 0 0 0 110.26 138.45 155.61 155.61 0 0 0 110.26 -138.45' fill='%23005da4'/%3E %3C!-- 30*sqrt(81/4+1) , 30*sqrt(19)-30 --%3E %3Cpath d='m-90 0a138.29 138.29 0 0 0 90 100.77 138.29 138.29 0 0 0 90 -100.77l-45-60-18 24-27-54-27 54-18-24-45 60' fill='%23fff'/%3E %3Cg id='wave' fill='%23005da4' transform='scale(5) translate(0 5.1962)'%3E %3Cpath d='m-17.196-2.1962a6 6 0 0 0 8.1962 2.1962 6 6 0 0 1 6 0 6 6 0 0 0 6 0 6 6 0 0 1 6 0 6 6 0 0 0 8.1962 -2.1962v1.732a6 6 0 0 1 -8.1962 2.1962 6 6 0 0 0 -6 0 6 6 0 0 1 -6 0 6 6 0 0 0 -6 0 6 6 0 0 1 -8.1962 -2.1962z'/%3E %3C/g%3E %3Cuse xlink:href='%23wave' transform='translate(0 17.321)'/%3E %3Cg id='s' transform='translate(0,-120) scale(2.25)'%3E %3Cpath stroke-width='.2' d='m0-5l1 3.2679 3.3301-0.7679-2.3301 2.5 2.3301 2.5-3.3301-0.7679-1 3.2679-1-3.2679-3.3301 0.7679 2.3301-2.5-2.3301-2.5 3.3301 0.7679z' fill='%23fd0'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='translate(-33.75,-45)'/%3E %3Cuse xlink:href='%23s' transform='translate(33.75,-45)'/%3E %3Cpath d='m-111.58-167.05l9.96 146.99a146.95 146.95 0 0 0 101.62 129.95 146.95 146.95 0 0 0 101.62 -129.95l9.96-146.99a280.22 280.22 0 0 0 8.42 3.82l-9.74 143.75a155.61 155.61 0 0 1 -110.26 138.45 155.61 155.61 0 0 1 -110.26 -138.45l-9.74-143.75a280.22 280.22 0 0 0 8.42 -3.82' fill='%23ed1c24'/%3E %3C/svg%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 9 6'%3E %3Ctitle%3EFlag of Slovakia%3C/title%3E %3Crect width='9' height='6' fill='%23ee1c25'/%3E %3Crect width='9' height='4' fill='%230b4ea2'/%3E %3Crect width='9' height='2' fill='%23fff'/%3E %3Cg%3E %3Cpath fill='%23fff' d='M3.16255,4.635c-0.53781-0.25905-1.3071-0.77323-1.3071-1.79033,0-1.01711,0.04863-1.47967,0.04863-1.47967h1.25847,1.2585s0.04864,0.46256,0.04864,1.47967c0,1.0171-0.76929,1.53128-1.30714,1.79033z'/%3E %3Cpath fill='%23ee1c25' d='M3.16255,4.5c-0.4934-0.23766-1.19917-0.70938-1.19917-1.64251,0-0.933128,0.044612-1.35749,0.044612-1.35749h1.15456,1.15459s0.044626,0.424365,0.044626,1.35749c0,0.933128-0.705776,1.40485-1.19921,1.64251z'/%3E %3Cpath fill='%23fff' d='m3.26808,2.61284c0.133599,0.00216,0.394255,0.00739,0.626352-0.070273,0,0-0.00613,0.083055-0.00613,0.179805,0,0.096773,0.00613,0.179822,0.00613,0.179822-0.21289-0.07125-0.4758-0.07273-0.62635-0.07082v0.515391h-0.211033v-0.515391c-0.150545-0.00191-0.41345-0.0004252-0.626352,0.070815,0,0,0.00613-0.083049,0.00613-0.179822,0-0.09675-0.00613-0.179805-0.00613-0.179805,0.2321,0.077665,0.492753,0.072432,0.626352,0.070273v-0.323676c-0.121766-0.00108-0.297234,0.00473-0.49563,0.071126,0,0,0.00613-0.083055,0.00613-0.179822,0-0.096756-0.00613-0.179811-0.00613-0.179811,0.198103,0.066283,0.373356,0.072192,0.495088,0.071137-0.00626-0.20498-0.06597-0.46332-0.06597-0.46332s0.12289,0.00959,0.172016,0.00959c0.049178,0,0.172031-0.00959,0.172031-0.00959s-0.059695,0.258346-0.065964,0.463301c0.121741,0.00106,0.296989-0.00485,0.495086-0.071137,0,0-0.00613,0.083055-0.00613,0.179811,0,0.096767,0.00613,0.179822,0.00613,0.179822-0.198388-0.066392-0.373863-0.072207-0.495627-0.071126v0.323676z'/%3E %3Cpath fill='%230b4ea2' d='m3.1625,3.29094c-0.24847,0-0.381562,0.344688-0.381562,0.344688s-0.073834-0.163438-0.276562-0.163438c-0.137161,0-0.238243,0.12201-0.3025,0.235,0.24954,0.39705,0.64768,0.64207,0.96062,0.79281,0.31299-0.15075,0.71139-0.39571,0.96094-0.79281-0.064256-0.11299-0.165339-0.235-0.3025-0.235-0.202734,0-0.276875,0.163438-0.276875,0.163438s-0.133073-0.344688-0.381562-0.344688z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect fill='%230072C6' width='450' height='300'/%3E %3Crect fill='%23FFF' width='450' height='200'/%3E %3Crect fill='%231EB53A' width='450' height='100'/%3E %3C/svg%3E"

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='800' height='600'%3E %3Crect fill='%235eb6e4' width='800' height='600'/%3E %3Crect fill='%23fff' width='800' height='300'/%3E %3Cg id='coa'%3E %3Cg id='crown' fill='none' stroke='%23000' stroke-width='0.933'%3E %3Cg fill='%23fff'%3E %3Ccircle cx='459.439' cy='171.232' r='4.044'/%3E %3Ccircle cx='461.689' cy='157.024' r='5.081'/%3E %3Ccircle cx='376.388' cy='141.721' r='3.909'/%3E %3Ccircle cx='338.47' cy='157.024' r='5.081'/%3E %3Ccircle cx='361.666' cy='143.366' r='4.218'/%3E %3Ccircle cx='340.72' cy='171.232' r='4.044'/%3E %3Ccircle cx='346.87' cy='147.119' r='4.885'/%3E %3Ccircle cx='423.77' cy='141.721' r='3.909'/%3E %3Ccircle cx='438.492' cy='143.366' r='4.218'/%3E %3Ccircle cx='453.288' cy='147.119' r='4.886'/%3E %3C/g%3E %3Cg stroke-width='1.09'%3E %3Ccircle cx='459.439' cy='171.231' r='4.458'/%3E %3Ccircle cx='461.69' cy='157.025' r='5.602'/%3E %3Ccircle cx='376.389' cy='141.721' r='4.31'/%3E %3Ccircle cx='338.47' cy='157.025' r='5.602'/%3E %3Ccircle cx='361.666' cy='143.367' r='4.65'/%3E %3Ccircle cx='340.718' cy='171.231' r='4.458'/%3E %3Ccircle cx='346.871' cy='147.119' r='5.386'/%3E %3Ccircle cx='423.769' cy='141.721' r='4.309'/%3E %3Ccircle cx='438.492' cy='143.365' r='4.65'/%3E %3Ccircle cx='453.287' cy='147.119' r='5.387'/%3E %3C/g%3E %3Cg fill='%23000' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='m392.488 132.016c-13.4834 15.5386-37.154 7.94825-47.9528 13.9984-18.7842 10.523 1.64882 35.4862 5.49625 40.2579l20.4697-5.3427c-7.51535-6.013-22.5874-16.2266-18.0484-24.525 4.65236-8.50925 29.3711 0.12401 40.1806-18.0396 2.27362-3.82028 0.53149-7.12735-0.14528-6.349z'/%3E %3Cpath fill='%23f1bf31' d='m392.488 132.481c-13.4834 15.5422-36.3898 8.0941-47.1862 14.1449-18.7848 10.5242 2.4313 34.8756 6.27875 39.649l17.6817-5.3445c-7.5183-6.013-21.7996-16.536-17.2606-24.835 4.65118-8.50865 29.8222-0.0307 40.6317-18.1949 2.27362-3.82028 0.5315-6.19725-0.14528-5.4195z'/%3E %3Cpath stroke-width='0.633' d='m393.711 133.678c-14.6026 19.7168-36.5226 9.7636-45.9432 17.455-10.6418 8.69055 4.8626 25.7953 12.3431 32.5624l1.16943-0.42933c-6.0691-5.75375-24.0579-22.8396-12.6278-32.0652 8.2193-6.63605 31.3311 2.02086 45.1075-17.0546z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m357.83 171.306c-0.35847 0.67855-0.89469 1.84901-1.25611 3.33189-6.24155-7.43505-10.917-15.14-5.99825-21.5044 4.47816-5.79565 15.453-3.17304 26.8778-7.187 5.2329-1.55197 10.3689-4.31575 14.7431-9.4943-0.42048 1.13386-0.85512 2.5063-1.33761 3.87992-11.5955 14.7638-34.7527 7.689-39.1671 15.7612-2.60433 4.7628 1.09487 10.2584 6.13819 15.2126z'/%3E %3Cpath stroke='none' d='m352.11 169.98c1.30334-0.37618 1.96831-1.09843 2.6935-1.94174 0.29528 0.35729 0.60118 0.7128 0.91772 1.06713-0.49901 0.66142-1.06949 1.31044-1.9252 1.75925-1.03465 0.54272-2.16792 0.68091-3.22914 0.68091-0.3555-0.47658-0.70157-0.95965-1.03701-1.44567 0.86103 0.0862 1.82717 0.098 2.58012-0.11988zm-2.8115-5.7715c1.13504-0.17835 1.5939-0.29292 2.49272-0.8002 0.1559 0.34311 0.32893 0.68681 0.51791 1.03051-0.75826 0.44055-1.37775 0.70453-2.42775 0.91949-1.0559 0.21792-2.15138 0.15355-3.12284-0.008-0.20787-0.44527-0.40098-0.89055-0.57519-1.33523 0.94842 0.18307 2.17441 0.34134 3.11516 0.1937zm1.5385-4.8125c-2.07343-0.19843-4.08544-1.28327-5.4951-2.82756 0.0998-0.41339 0.2309-0.82146 0.39271-1.22067 0.81142 1.01456 2.57009 2.76909 5.1862 2.99705-0.0549 0.34842-0.0821 0.69862-0.0838 1.05118zm1.806-4.554c-1.48229-0.86398-2.70473-2.22815-3.45709-3.77185 0.27519-0.19607 0.56338-0.37796 0.86693-0.54567 0.5498 1.16693 1.58327 2.74134 3.38917 3.64311-0.28937 0.20787-0.5557 0.43228-0.79901 0.67441zm3.9835-6.1505c0.24567 1.40728 0.99035 2.59665 2.14547 3.45118-0.38268 0.0803-0.75472 0.16595-1.11614 0.25748-1.02401-0.95019-1.69134-2.17677-1.9311-3.58051 0.29586-0.0455 0.59645-0.088 0.90177-0.12815zm7.098-0.6195c0.36909 1.04586 1.11201 1.96772 2.09173 2.70709 0.10925 0.0815 0.16477 0.18366 0.18189 0.28642l-1.10669 0.13937c-0.99922-0.84803-1.74567-1.89095-2.10296-3.06437l0.93603-0.0685zm6.9235-0.688c0.67145 1.03229 1.58976 1.90276 2.68464 2.55237-0.42638 0.085-0.85275 0.16653-1.27795 0.24271-0.97855-0.72638-1.7941-1.62874-2.39646-2.66398 0.32893-0.0413 0.65905-0.0845 0.98976-0.1311zm6.187-1.259c0.89527 0.86634 2.02972 1.50827 3.24153 1.92048-0.42992 0.16417-0.86338 0.3183-1.29862 0.46417-1.11733-0.51082-2.14016-1.21712-2.9504-2.11712 0.33662-0.0845 0.67205-0.17363 1.00748-0.26752zm6.2295-2.395c0.83031 0.6 1.92106 0.99626 2.89783 1.2378-0.33071 0.23149-0.66614 0.45118-1.00512 0.66378-0.99685-0.31595-2.01791-0.78603-2.79744-1.45807 0.30237-0.14233 0.60414-0.29055 0.90473-0.44351zm4.592-2.906c0.65964 0.33071 1.42913 0.56456 2.18149 0.72638-0.23799 0.26339-0.48071 0.51733-0.72697 0.76477-0.79016-0.20551-1.57854-0.4937-2.25295-0.89469 0.26752-0.19252 0.53386-0.39153 0.79842-0.59645z'/%3E %3Cpath fill='none' stroke-width='0.604' d='m393.76 134.456c0.0437 0.95374-0.22618 1.77579-1.125 3.28878-10.8118 18.1636-36.2918 9.84035-40.9435 18.3508-4.47225 8.17915 9.6425 18.5168 17.2376 24.5716-1.33288 0.4813-2.73839 0.90295-4.21654 1.26023l-1.32697 0.71811-1.96654 0.62067c-6.0691-5.7555-24.0414-22.6854-12.613-31.9087 8.22225-6.63605 31.1776 2.17382 44.954-16.9016z'/%3E %3Cpath d='m407.522 132.016c13.4852 15.5386 37.1558 7.94825 47.9522 13.9984 18.7848 10.523-1.64823 35.4862-5.4933 40.2579l-20.4726-5.3427c7.5183-6.013 22.588-16.2266 18.0514-24.525-4.65296-8.50925-29.3734 0.12401-40.1835-18.0396-2.27303-3.82028-0.52854-7.12735 0.14587-6.349z'/%3E %3Cpath fill='%23f1bf31' d='m407.671 132.481c13.4834 15.5422 36.3898 8.0941 47.1862 14.1449 18.7842 10.5242-2.4313 34.8756-6.27875 39.649l-17.6823-5.3445c7.5189-6.013 21.7996-16.536 17.2624-24.835-4.65237-8.50865-29.824-0.0307-40.6329-18.1949-2.27363-3.82028-0.5315-6.19725 0.14527-5.4195z'/%3E %3Cpath stroke-width='0.633' d='m438.879 183.266c6.0697-5.75375 24.0585-22.8396 12.6284-32.0652-8.2205-6.63605-31.3317 2.02086-45.1081-17.0546l0.0496-0.46832c14.602 19.7168 36.5226 9.7636 45.9432 17.455 10.6258 8.6752-4.95 25.7374-12.46 32.5282z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m442.329 171.306c0.35787 0.67855 0.89409 1.84901 1.25551 3.33189 6.24155-7.43505 10.9176-15.14 5.9988-21.5044-4.47815-5.79625-15.4548-3.17245-26.8796-7.1876-5.2329-1.55197-10.3683-4.31575-14.742-9.4937 0.42048 1.13268 0.85335 2.50394 1.33642 3.87638 11.5931 14.7685 34.7575 7.69195 39.1701 15.7648 2.60315 4.7628-1.09548 10.2584-6.13935 15.2126z'/%3E %3Cpath stroke='none' d='m448.048 170.6c-1.50177-0.37264-2.24764-1.0311-3.23268-1.9252-0.29587 0.34134-0.60118 0.6815-0.91536 1.01988 0.68918 0.66437 1.39725 1.31575 2.46202 1.78996 0.92007 0.40807 1.88917 0.56457 2.81398 0.61063 0.34547-0.45177 0.68327-0.90768 1.01279-1.36831-0.73642 0.0454-1.51004 0.0296-2.14075-0.12697zm2.8125-6.3925c-1.13563-0.17835-1.59331-0.29292-2.49213-0.8002-0.1559 0.34311-0.32952 0.68681-0.51791 1.03051 0.75768 0.43996 1.37598 0.70453 2.42657 0.91949 1.0565 0.21792 2.15197 0.15355 3.12284-0.008 0.20846-0.44527 0.40217-0.89055 0.57579-1.33523-0.94901 0.18307-2.175 0.34134-3.11516 0.1937zm-1.538-4.8125c2.07401-0.19902 4.08425-1.28445 5.4939-2.82756-0.0992-0.41339-0.23091-0.82028-0.39272-1.22008-0.81023 1.01456-2.5689 2.76791-5.18445 2.99587 0.0543 0.34842 0.0815 0.69921 0.0833 1.05177zm-1.8045-4.554c1.48051-0.86339 2.70236-2.22815 3.45472-3.77126-0.2746-0.19666-0.56338-0.37855-0.86693-0.54626-0.5498 1.16693-1.58327 2.74075-3.38799 3.64252 0.28996 0.20787 0.5563 0.43287 0.80019 0.675zm-3.986-6.1505c-0.24626 1.40728-0.99095 2.59606-2.14489 3.45059 0.38268 0.0803 0.75414 0.16594 1.11555 0.25748 1.02343-0.9502 1.69134-2.17678 1.93052-3.57993-0.29587-0.0455-0.59587-0.088-0.90118-0.12815zm-7.098-0.6195c-0.3691 1.04586-1.11083 1.96772-2.09233 2.70709-0.10866 0.0815-0.16476 0.18307-0.1813 0.28582l1.10788 0.13996c0.99862-0.84803 1.74508-1.89094 2.10236-3.06437l-0.93661-0.0685zm-6.9225-0.688c-0.67146 1.0317-1.59036 1.90217-2.68642 2.55178 0.42697 0.085 0.85334 0.16712 1.27913 0.2433 0.97737-0.72638 1.79351-1.62874 2.39528-2.66398-0.32835-0.0408-0.65788-0.0844-0.988-0.1311zm-6.188-1.259c-0.89528 0.86634-2.02914 1.50827-3.24036 1.91989 0.42933 0.16417 0.86339 0.31771 1.29744 0.46417 1.11851-0.51082 2.14016-1.21712 2.9504-2.11653-0.33603-0.0845-0.67205-0.17363-1.00748-0.26752zm-6.2285-2.3945c-0.82973 0.59941-1.92048 0.99567-2.89784 1.23721 0.3313 0.23149 0.66733 0.45 1.00571 0.66319 0.99568-0.31595 2.01615-0.78544 2.79627-1.45689-0.30296-0.14174-0.60414-0.29055-0.90414-0.44351zm-4.5935-2.9065c-0.65906 0.3313-1.42855 0.56457-2.17973 0.72638 0.2374 0.26339 0.48012 0.51674 0.72579 0.76418 0.79016-0.20551 1.57737-0.4937 2.25237-0.8941-0.26752-0.19311-0.53386-0.39153-0.79843-0.59645z'/%3E %3Cpath fill='none' stroke-width='0.604' d='m406.399 134.456c-0.0437 0.95374 0.22677 1.77579 1.12795 3.28878 10.8088 18.1636 36.2894 9.84035 40.9424 18.3508 4.47048 8.17915-9.6437 18.5168-17.2394 24.5716 1.33288 0.4813 2.73839 0.90295 4.21713 1.26023l1.32638 0.71811 1.96654 0.62067c6.0691-5.7555 24.0414-22.6854 12.6136-31.9087-8.22225-6.63605-31.1782 2.17382-44.9546-16.9016z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23000' d='m400.079 166.698h-6.84155s0.81023-6.52205-0.10571-10.9406c-0.74114-3.57284-3.59174-7.67365-3.59174-10.6807 0-3.00591 3.25571-11.4526 3.25571-11.4526h7.28326 7.28445s3.0998 8.44665 3.0998 11.4526c0 3.00709-2.69587 7.1079-3.43701 10.6807-0.91535 4.41851-0.1057 10.9406-0.1057 10.9406h-6.84155z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m400.079 166.698h-6.84155s1.05295-6.5114 0.20374-10.9406c-0.69154-3.60414-3.1252-6.401-3.44646-10.0571-0.4565-5.1579 4.04232-12.0762 4.04232-12.0762h6.04195 6.0425s4.34351 6.9183 3.88819 12.0762c-0.32126 3.6561-2.60138 6.45295-3.29291 10.0571-0.84862 4.42913 0.20374 10.9406 0.20374 10.9406h-6.84155z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m389.977 144.402c0.43051-0.14646 0.88583-0.24862 1.31811-0.24862 1.50118 0 2.09528 0.98031 2.09528 0.98031s3.93189-0.91004 6.68919-0.91004c2.75729 0 6.69036 0.91004 6.69036 0.91004s0.59409-0.98031 2.09468-0.98031c0.38091 0 0.77953 0.0791 1.1628 0.19902 0.0254 0.45826 0.0224 0.90944-0.0159 1.34823-0.32185 3.65846-2.60374 6.45294-3.29292 10.0571-0.42047 2.18918-0.37677 4.88623-0.22382 7.0553l-6.41515 3.0502-6.41515-3.05079c0.15296-2.16909 0.19784-4.86555-0.22204-7.05475-0.69154-3.60413-3.12461-6.39865-3.44823-10.0571-0.0372-0.42283-0.0414-0.85689-0.0171-1.29862z'/%3E %3Cpath fill='%23000' stroke='none' d='m407.092 146.815c-0.29882 0.94311-0.77835 2.45256-1.1941 3.975-0.41516 1.52185-0.7683 3.05374-0.81555 4.04468-0.19074 3.8693 0.47244 8.0699 1.24194 11.863h-0.27875c-1.08661-3.31772-2.34508-8.42835-2.29665-11.8695 0.0272-2.09468 1.35237-6.15235 2.03091-8.0935 0.97795-2.80335 0.77657-4.69665 0.0868-6.57345-0.69095-1.88563-1.87028-3.75413-2.83819-6.4949-0.006-0.0177-0.004-0.0319 0.002-0.0425h1.29744c0.99035 2.69646 2.10354 4.58209 2.76614 6.49135 0.67264 1.9376 0.88465 3.89528-0.002 6.6998zm-13.2495 19.883c0.77303-3.82619 1.41732-7.97245 1.24252-11.863-0.0437-0.98859-0.39685-2.52048-0.81614-4.04468-0.41516-1.52422-0.89646-3.03367-1.1941-3.97441-0.88878-2.8063-0.18071-6.13291 0.74587-8.7508 0.80374-2.26949 1.77165-4.01398 2.01614-4.44095h1.34705c-0.41279 0.67737-4.64291 7.8266-2.79626 13.1114 0.67677 1.94115 2.00079 5.99825 2.03032 8.09115 0.0466 3.43701-1.21595 8.5571-2.29902 11.8712h-0.27638z'/%3E %3Cpath d='m400.079 166.698h-6.84155s1.05295-6.5114 0.20374-10.9406c-0.69154-3.60414-3.1252-6.401-3.44646-10.0571-0.4565-5.1579 4.04232-12.0762 4.04232-12.0762h6.04195 6.0425s4.34351 6.9183 3.88819 12.0762c-0.32126 3.6561-2.60138 6.45295-3.29291 10.0571-0.84862 4.42913 0.20374 10.9406 0.20374 10.9406h-6.84155z'/%3E %3Cellipse fill='%23fff' stroke-width='0.915' cx='400' cy='140.644' rx='3.409' ry='2.507'/%3E %3Cellipse stroke-width='1.029' cx='400' cy='140.492' rx='3.835' ry='2.735'/%3E %3Ccircle fill='%23fff' stroke-width='0.915' cx='400' cy='148.23' r='3.683'/%3E %3Ccircle stroke-width='1.029' cx='400' cy='148.23' r='4.143'/%3E %3C/g%3E %3Cg%3E %3Cpath stroke-width='0.904' d='m360.414 204.281s-1.05709-1.06536-1.37835-1.93524c-0.25512-0.68503-0.27815-1.85433-0.27815-1.85433l-3.78779-6.0691 8.5075-8.08935 16.1764-4.64055 20.3953-1.45748h0.0313l20.3982 1.45748 16.174 4.64055 8.5063 8.08935-3.78662 6.0691s-0.0231 1.16929-0.27815 1.85433c-0.32243 0.86988-1.37894 1.93524-1.37894 1.93524l-18.9714-6.4122-20.6634-0.9254-20.6924 0.9254-18.9738 6.4122z'/%3E %3Cpath fill='%23f1bf31' d='m360.873 203.597s-0.75768-0.94725-1.04646-1.65532c-0.41752-1.02342-0.36318-2.81338-0.36318-2.81338l-4.49351-4.70493 8.5069-8.08935 16.1746-4.64055 20.429-1.45748 20.4266 1.45748 16.177 4.64055 8.50395 8.08935-4.49056 4.70493s0.052 1.78996-0.36555 2.81338c-0.28642 0.70807-1.04645 1.65532-1.04645 1.65532l-18.5144-5.72715-20.6906-0.92775-20.6924 0.92775-18.515 5.72715z'/%3E %3Cpath fill='%23000' d='M358.832,207.288A41.168,12.777 0 1,1 441.168,207.288A41.168,10.824 0 1,1 358.832,207.288z'/%3E %3Cpath fill='%23f1bf31' d='M360.208,207.288A39.792,12.312 0 1,1 439.792,207.288A39.792,10.523 0 1,1 360.208,207.288z'/%3E %3Cellipse fill='%23d99f31' cx='400' cy='208.415' rx='36.785' ry='9.395'/%3E %3Cpath stroke-width='1.09' d='m436.52 209.676c-6.8864 2.94626-20.4319 4.52717-36.4707 4.52717-16.0394-0.001-29.5842-1.5809-36.4701-4.52717'/%3E %3Cpath stroke-width='1.01' d='m435.909 206.262c-7.0565 2.68819-20.2819 4.03287-35.8589 4.0311-15.5776 0-28.8018-1.34409-35.8577-4.03169'/%3E %3Cpath d='m432.459 203.885c-7.4947 2.17441-19.092 3.40335-32.4088 3.40216-13.317 0-24.9124-1.22834-32.4071-3.40216'/%3E %3Cpath d='m427.478 202.07c-7.2313 1.42677-16.78 2.21279-27.4282 2.21279s-20.1962-0.78602-27.4276-2.21279'/%3E %3Cpath d='m419.092 200.318c-5.65925 0.62421-12.1181 0.9561-19.0424 0.9561-6.92365 0-13.3825-0.33188-19.0418-0.9561'/%3E %3Cellipse cx='400' cy='208.415' rx='36.475' ry='9.093'/%3E %3Cpath fill='%23000' stroke-linejoin='round' d='m354.757 192.762c-3.61122-4.80295-6.8309-8.07285-14.6486-10.8342 1.07303-0.86398 2.97107-1.64882 4.7941-2.09705 2.9752-0.73288 6.01535-0.33484 7.97065 0.68918-1.55257-5.55476 1.42854-11.0941 1.42854-11.0941s4.81772-0.27579 9.6992 3.64606c0.15945-6.72695 2.13189-9.92065 2.13189-9.92065s5.07045 0.24331 10.2573 5.39645c0.988-6.9579 4.74213-10.7344 4.74213-10.7344s6.22915 1.95118 9.79015 8.52345c2.37283-9.52265 9.1559-13.2532 9.1559-13.2532s6.78545 3.73051 9.1571 13.2532c3.5622-6.57225 9.79195-8.52345 9.79195-8.52345s3.73051 3.64016 4.74213 10.7344c5.1868-5.15315 10.2567-5.39645 10.2567-5.39645s1.97303 3.1937 2.13307 9.92065c4.88091-3.92185 10.1782-2.4626 10.1782-2.4626s2.50157 4.35591 0.94842 9.91065c1.95414-1.02401 4.99607-1.42205 7.97125-0.68918 1.82244 0.44823 3.72048 1.23307 4.7941 2.09705-7.0016 2.54115-11.1916 6.0313-14.804 10.8342-3.37855-6.9018-21.4548-14.4927-45.1689-14.4927-23.7112 0-41.9434 7.59094-45.3213 14.4927z'/%3E %3Cpath fill='%23f1bf31' stroke-linejoin='round' d='m354.757 191.986c-3.08799-4.84016-7.5455-8.3823-12.1695-10.1722 1.07363-0.86338 2.95867-1.1935 4.95591-1.33287 2.34213-0.16182 4.29154 0.16594 5.9451 0.95079-1.55315-5.55175 0.9691-11.2305 0.9691-11.2305s4.96654 0.0189 9.84805 3.94075c0.16004-6.72695 2.29252-10.0636 2.29252-10.0636s4.75512 0.52913 9.94135 5.68465c1.11319-6.9455 4.74862-10.8656 4.74862-10.8656s6.22855 1.93288 9.78955 8.50275c2.37343-9.5203 9.0006-12.923 9.0006-12.923s6.6301 3.40276 9.00355 12.923c3.56044-6.56989 9.78955-8.50275 9.78955-8.50275s3.75178 3.51083 4.74863 10.8656c5.1868-5.1555 9.94135-5.68465 9.94135-5.68465s2.13189 3.33661 2.29252 10.0636c4.8815-3.92185 10.4664-2.85709 10.4664-2.85709s1.90394 4.59508 0.35138 10.1468c1.65236-0.78485 3.60177-1.1126 5.94215-0.95079 1.99724 0.13937 3.88465 0.46949 4.95768 1.33287-4.62343 1.78996-9.0815 5.3321-12.1689 10.1722-3.37855-6.9018-21.61-13.8596-45.3242-13.8596-23.7112 0-41.9434 6.9579-45.3213 13.8596z'/%3E %3Cpath fill='%23000' d='m352.995 194.157c0-8.75375 20.9002-16.1852 47.0534-16.1852 26.1555 0 46.2815 7.7303 46.2815 15.4104 0 1.84016-1.62579 3.42343-3.77067 4.76929 0.20729-0.57696 0.31122-1.16693 0.31122-1.76279 0-7.6801-16.6666-13.9051-42.822-13.9051-26.1532 0-42.8197 6.225-42.8197 13.9051 0 0.59586 0.10571 1.18582 0.31181 1.76279-2.14548-1.34586-4.54548-2.15551-4.54548-3.99449z'/%3E %3Cpath fill='%23f1bf31' stroke-width='0.904' d='m354.222 193.382c0-6.64195 19.6748-14.9451 45.828-14.9451 26.1538 0 45.8286 8.30315 45.8286 14.9451 0 1.84016-2.04744 2.02441-2.23229 1.45807-2.19803-6.73405-17.4425-12.6679-43.5963-12.6679-26.1532 0-41.3976 5.93385-43.5963 12.6679-0.18484 0.56634-2.2317 0.38208-2.2317-1.45807z'/%3E %3Cpath fill='%23000' stroke-width='0.45' stroke-linejoin='round' d='m399.577 172.094c0.15177-2.3504 0.46299-7.5685 0.46299-7.5685 0.007-0.052 0.0732-0.82796 0.0791-0.77422 0 0 0.29292 5.98995 0.43406 8.3386 0.14114 2.3439 0.28878 6.01475 0.28878 6.01475 0 0.0207-0.0165 0.0396-0.0396 0.0396l-1.50296 0.008c-0.0212 0-0.0395-0.0189-0.0395-0.0396 0 0 0.16595-3.675 0.31713-6.0189zm38.4561 13.549c0.40866-0.81201 0.91713-1.84311 1.2874-2.65453 0.75296-1.65532 2.10946-4.30453 2.10946-4.30453 0.0189-0.0502-0.0437-0.0785-0.0709-0.0336 0 0-1.69842 2.40118-2.65335 3.8935-0.50374 0.78957-1.18523 1.79055-1.72145 2.56713zm-12.8116-4.64353c0.22795-0.51083 1.29508-2.88957 2.12362-4.41556 0.98681-1.81417 2.76969-4.51181 2.76969-4.51181 0.0289-0.0454 0.0898-0.01 0.0667 0.0378 0 0-1.27914 2.73012-2.01378 4.51181-0.7187 1.73977-1.71378 4.51182-1.71378 4.51182l-0.65965 0.009zm-11.599-2.087c0.28169-1.11968 0.85748-3.3685 1.31575-4.95059 0.64429-2.21752 1.03819-3.45709 1.78996-5.63975 0.0165-0.0514 0.0856-0.0325 0.075 0.0189-0.42402 2.25472-0.6502 3.52972-1.03642 5.79095-0.27402 1.6122-0.63839 3.91358-0.80138 4.94941zm-39.3096 2.24384l-0.57106 0.004c-0.0378-0.0271-1.03169-2.79862-1.75039-4.53891-0.73524-1.78103-2.01437-4.51115-2.01437-4.51115-0.0224-0.0485 0.0378-0.0839 0.0667-0.0378 0 0 1.78346 2.69764 2.76968 4.51181 0.82914 1.52422 1.89567 3.90414 2.12363 4.41497zm10.8817-2.07498c-0.16418-1.03642-0.52973-3.33721-0.80315-4.94884-0.38445-2.26065-0.6124-3.53565-1.03583-5.79097-0.009-0.0532 0.0579-0.0703 0.075-0.0207 0.75118 2.18268 1.14567 3.42402 1.78878 5.64155 0.45945 1.5815 1.03465 3.8315 1.31752 4.9506zm-23.1862 6.6231c-0.41339-0.82086-0.93779-1.88386-1.31693-2.71595-0.75591-1.65532-2.10945-4.30454-2.10945-4.30454-0.0206-0.0502 0.0431-0.0785 0.0679-0.0336 0 0 1.69902 2.40118 2.65394 3.89351 0.51614 0.80728 1.21831 1.83779 1.76044 2.62146z'/%3E %3C/g%3E %3Cg stroke-width='0.777' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath fill='%23d99f31' stroke-width='0.719' d='m361.605 197.422c-0.33662-1.9063-1.98485-3.44056-3.25571-3.21674-1.26851 0.22264-3.07264 2.12244-2.73603 4.02638 0.33425 1.90571 2.71713 3.29056 3.988 3.0691 1.26909-0.22441 2.33976-1.97481 2.00374-3.87874z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m359.49 195.078c0.35315 0.41752 0.56693 0.95787 0.56693 1.54783 0 1.32343-1.07126 2.39469-2.39351 2.39469-0.43819 0-0.84802-0.11811-1.20058-0.32244-0.065-0.17008-0.11516-0.34666-0.14705-0.52855-0.29114-1.65118 0.97146-3.1435 2.06989-3.3372 0.0809-0.0142 0.16003-0.0206 0.24035-0.0206 0.29646 0 0.58996 0.0945 0.86397 0.26634z'/%3E %3Cpath d='m360.903 197.466c-0.29055-1.64882-1.41792-2.82815-2.51634-2.63504-1.10079 0.19311-2.36103 1.68779-2.07225 3.33661 0.29292 1.64823 2.05571 2.84823 3.15414 2.65512 1.10019-0.19252 1.72559-1.70846 1.43445-3.35669z'/%3E %3Cpath fill='%23d99f31' d='m375.4 192.846l-0.59764-3.58347-2.413-1.21653s-2.59311 0.70393-4.20886 1.27855c-1.67362 0.59409-4.21063 1.73149-4.21063 1.73149l-0.60236 1.05295 0.75413 4.05296 1.35118 1.20236 9.0201-2.70531 0.90709-1.813z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m365.464 195.441l7.226-2.2865 0.45-0.7485-0.6245-3.7525-0.26-0.257-8.0245 2.944 0.611 3.4025z'/%3E %3Cpath stroke-width='1.09' d='m365.464 195.441l7.226-2.2865 0.45-0.7485-0.475-3.001m2.55548 3.44149l-2.08047-0.442'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m385.724 189.003c-0.0721-0.82618 0.54035-1.55729 1.36713-1.62756 0.82795-0.0726 1.55728 0.5374 1.62932 1.36653 0.0732 0.82618-0.53976 1.55492-1.36594 1.62756-0.82855 0.0726-1.55729-0.54035-1.63052-1.36653zm-3.48189 3.32244c-0.072-0.82618 0.54035-1.55551 1.36653-1.62815 0.82855-0.0726 1.55729 0.53977 1.62993 1.36654 0.0726 0.82618-0.53977 1.55728-1.36595 1.62992-0.82855 0.0703-1.55728-0.54036-1.63051-1.36831zm-3.55394-2.66811c-0.0732-0.82677 0.53976-1.55551 1.36594-1.62756 0.82619-0.0732 1.40552 0.53977 1.47816 1.36595 0.0726 0.82854-0.38799 1.55728-1.21654 1.62992-0.82618 0.0703-1.55552-0.53977-1.62756-1.36831zm3.03071-3.32244c-0.072-0.82618 0.54035-1.55492 1.36653-1.62756 0.82677-0.0726 1.55729 0.54035 1.62756 1.36653 0.0732 0.82618-0.53976 1.5567-1.36594 1.62756-0.82618 0.0726-1.55492-0.53976-1.62815-1.36653z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m385.814 189.398c0.19725-0.52559 0.68149-0.92008 1.27736-0.97145 0.68977-0.0597 1.31044 0.35315 1.54075 0.97205-0.19724 0.52618-0.68149 0.9183-1.27736 0.97027-0.68977 0.0608-1.30984-0.35374-1.54075-0.97087zm-4.00512-2.66752c0.23032 0.6183 0.8504 1.03111 1.53839 0.97087 0.59645-0.0526 1.08071-0.44646 1.27736-0.97205-0.22972-0.61654-0.85098-1.03051-1.53897-0.97028-0.59528 0.052-1.07953 0.44587-1.27677 0.97146zm-3.03189 3.32126c0.23032 0.6189 0.85099 1.03229 1.54075 0.97382 0.58406-0.0514 0.98681-0.43229 1.14626-0.94429-0.18838-0.63307-0.71102-1.06181-1.40964-0.99981-0.59587 0.052-1.08012 0.44528-1.27737 0.97028zm3.55571 2.66693c0.22855 0.61772 0.84922 1.03287 1.5378 0.97264 0.59823-0.052 1.08248-0.44645 1.27854-0.97264-0.2309-0.61653-0.85098-1.02992-1.54016-0.96968-0.59468 0.0526-1.07894 0.44586-1.27618 0.96968z'/%3E %3Cpath stroke-width='0.933' d='m385.724 189.003c-0.0721-0.82618 0.54035-1.55729 1.36713-1.62756 0.82795-0.0726 1.55728 0.5374 1.62932 1.36653 0.0732 0.82618-0.53976 1.55492-1.36594 1.62756-0.82855 0.0726-1.55729-0.54035-1.63052-1.36653zm-3.48189 3.32244c-0.072-0.82618 0.54035-1.55551 1.36653-1.62815 0.82855-0.0726 1.55729 0.53977 1.62993 1.36654 0.0726 0.82618-0.53977 1.55728-1.36595 1.62992-0.82855 0.0703-1.55728-0.54036-1.63051-1.36831zm-3.55394-2.66811c-0.0732-0.82677 0.53976-1.55551 1.36594-1.62756 0.82619-0.0732 1.40552 0.53977 1.47816 1.36595 0.0726 0.82854-0.38799 1.55728-1.21654 1.62992-0.82618 0.0703-1.55552-0.53977-1.62756-1.36831zm3.03071-3.32244c-0.072-0.82618 0.54035-1.55492 1.36653-1.62756 0.82677-0.0726 1.55729 0.54035 1.62756 1.36653 0.0732 0.82618-0.53976 1.5567-1.36594 1.62756-0.82618 0.0726-1.55492-0.53976-1.62815-1.36653z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m392.853 190.393v-3.8935l2.2695-2.113h9.918l2.2695 2.113 0.002 3.8915-2.2715 1.9645h-9.918z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m405.238 184.846l-0.798 0.814v3.717l-0.633 0.625-7.51-0.054-0.623-0.6235v-3.569l-0.6725-0.9095z'/%3E %3Cpath d='m392.853 190.393v-3.8935l2.2695-2.113h9.918l2.2695 2.113 0.002 3.8915-2.2715 1.9645h-9.918z'/%3E %3Cpath stroke-width='1.09' d='m393.463 190.23l2.21103-0.85099m10.9926 0.91122l-2.22639-0.91358m-9.0502 2.72835l0.90118-2.10355m8.4195 2.10355l-0.90118-2.10355m0.63071-4.34114v3.71634l-0.63071 0.6248-7.5118-0.0537-0.62362-0.62303v-3.71634'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m414.374 189.003c0.0732-0.82618-0.53918-1.55729-1.36595-1.62756-0.82795-0.0726-1.55728 0.5374-1.62932 1.36653-0.0709 0.82618 0.53976 1.55492 1.36831 1.62756 0.82618 0.0726 1.55491-0.54035 1.62697-1.36653zm3.48307 3.32244c0.072-0.82618-0.54035-1.55551-1.36712-1.62815-0.82618-0.0726-1.55728 0.53977-1.62933 1.36654-0.0709 0.82618 0.53976 1.55728 1.36831 1.62992 0.82618 0.0703 1.55492-0.54036 1.62815-1.36831zm3.55394-2.66811c0.0732-0.82677-0.53976-1.55551-1.36594-1.62756-0.82618-0.0732-1.40552 0.53977-1.47874 1.36595-0.072 0.82854 0.39035 1.55728 1.21712 1.62992 0.82618 0.0703 1.55552-0.53977 1.62756-1.36831zm-3.02893-3.32244c0.0703-0.82618-0.53977-1.55492-1.3689-1.62756-0.82619-0.0726-1.55492 0.54035-1.62697 1.36653-0.0732 0.82618 0.53976 1.5567 1.36594 1.62756 0.82618 0.0726 1.55492-0.53976 1.62992-1.36653z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m414.285 189.398c-0.19666-0.52618-0.68149-0.92008-1.27736-0.97145-0.68918-0.0597-1.30926 0.35315-1.54016 0.97145 0.19783 0.52618 0.68208 0.9189 1.27795 0.97087 0.68977 0.0608 1.31044-0.35374 1.53957-0.97087zm1.18937-2.66811c0.19725 0.52559 0.6809 0.9189 1.27854 0.97145 0.688 0.0602 1.30807-0.35256 1.53839-0.97086-0.19666-0.525-0.6809-0.91949-1.27855-0.97146-0.68799-0.0602-1.30806 0.35374-1.53838 0.97087zm3.16122 3.3502c0.15827 0.5126 0.56162 0.89409 1.14862 0.94547 0.68859 0.0585 1.30866-0.35492 1.5378-0.97441-0.19725-0.525-0.68149-0.91771-1.27736-0.96968-0.69803-0.062-1.21949 0.36614-1.40906 0.99862zm-3.68622 2.63917c0.19666 0.52559 0.68149 0.92008 1.27796 0.97205 0.68917 0.0602 1.30925-0.35374 1.54016-0.96968-0.19666-0.52618-0.6815-0.92008-1.27796-0.97264-0.6874-0.0602-1.30866 0.35315-1.54016 0.97027z'/%3E %3Cpath stroke-width='0.933' d='m414.374 189.003c0.0732-0.82618-0.53918-1.55729-1.36595-1.62756-0.82795-0.0726-1.55728 0.5374-1.62932 1.36653-0.0709 0.82618 0.53976 1.55492 1.36831 1.62756 0.82618 0.0726 1.55491-0.54035 1.62697-1.36653zm3.48307 3.32244c0.072-0.82618-0.54035-1.55551-1.36712-1.62815-0.82618-0.0726-1.55728 0.53977-1.62933 1.36654-0.0709 0.82618 0.53976 1.55728 1.36831 1.62992 0.82618 0.0703 1.55492-0.54036 1.62815-1.36831zm3.55394-2.66811c0.0732-0.82677-0.53976-1.55551-1.36594-1.62756-0.82618-0.0732-1.40552 0.53977-1.47874 1.36595-0.072 0.82854 0.39035 1.55728 1.21712 1.62992 0.82618 0.0703 1.55552-0.53977 1.62756-1.36831zm-3.02893-3.32244c0.0703-0.82618-0.53977-1.55492-1.3689-1.62756-0.82619-0.0726-1.55492 0.54035-1.62697 1.36653-0.0732 0.82618 0.53976 1.5567 1.36594 1.62756 0.82618 0.0726 1.55492-0.53976 1.62992-1.36653z'/%3E %3Cpath fill='%23d99f31' d='m424.7 192.846l0.59823-3.58347 2.4124-1.21653s2.59311 0.70393 4.20886 1.27855c1.67303 0.59409 4.21063 1.73149 4.21063 1.73149l0.60237 1.05295-0.75355 4.05296-1.35176 1.20236-9.02011-2.70531-0.90708-1.813z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m434.635 195.441l-7.2235-2.2865-0.453-0.7485 0.627-3.7525 0.257-0.257 8.0275 2.944-0.6125 3.4025z'/%3E %3Cpath stroke-width='1.09' d='m434.635 195.441l-7.2235-2.2865-0.453-0.7485 0.476-3.001m-1.88401 4.9525l1.8605-1.2025'/%3E %3Cpath fill='%23d99f31' stroke-width='0.719' d='m438.405 197.422c0.33662-1.9063 1.98544-3.44056 3.25335-3.21674 1.27087 0.22264 3.07559 2.12244 2.74134 4.02638-0.33661 1.90571-2.72008 3.29056-3.99095 3.0691-1.2685-0.22441-2.33976-1.97481-2.00374-3.87874z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m439.953 196.626c0-0.58996 0.21378-1.13032 0.56811-1.54784 0.27342-0.17185 0.56752-0.26634 0.86338-0.26634 0.0786 0 0.15945 0.007 0.23859 0.0207 1.10019 0.1937 2.36043 1.68603 2.06988 3.33721-0.0319 0.18248-0.0821 0.36023-0.14704 0.53031-0.35256 0.20374-0.76182 0.32067-1.19883 0.32067-1.32224 0-2.39409-1.07126-2.39409-2.39468z'/%3E %3Cpath d='m439.106 197.466c0.29055-1.64882 1.4185-2.82815 2.51693-2.63504 1.10019 0.19311 2.36279 1.68779 2.07224 3.33661-0.29114 1.64823-2.05394 2.84823-3.15413 2.65512-1.10079-0.19252-1.72559-1.70846-1.43504-3.35669z'/%3E %3Cpath stroke-width='0.833' d='m424.278 192.878l0.65197-3.89292 2.56181-1.27086s2.77677 0.75591 4.50827 1.37067c1.78937 0.63485 4.50768 1.8437 4.50768 1.8437l0.64547 1.12736-0.80551 4.35178-1.44921 1.28918-9.6614-2.89843-0.959-1.921zm-31.9069-6.5321l2.39646-2.24233h10.6246l2.39586 2.24233 0.004 4.21063-2.39999 2.08228h-10.6246l-2.39646-2.08228v-4.21063zm-16.5502 6.5321l-0.65197-3.89292-2.56241-1.27086s-2.77618 0.75591-4.50768 1.37067c-1.78996 0.63485-4.50768 1.8437-4.50768 1.8437l-0.64311 1.12736 0.80315 4.35178 1.44922 1.28918 9.6614-2.89843 0.95905-1.92048z'/%3E %3C/g%3E %3Cg stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath fill='%23d99f31' stroke-width='0.952' d='m408.129 95.8505c1.77579 0 3.07146 1.58445 3.07146 3.36378 0 1.77992-1.29567 3.52382-3.07146 3.52382-2.3191 0-5.6864-2.74311-5.57245-0.56043l0.0561 1.10433 1.2313 10.1451c3.02244 0.6809-10.5544 0.6809-7.53305 0l1.23543-10.1906 0.0537-1.05886c0.11044-2.18091-3.34016 0.56043-5.57065 0.56043-1.77756 0-3.07087-1.7439-3.07087-3.52382 0-1.77933 1.29331-3.36378 3.07087-3.36378 1.7504 0 3.68327 1.63052 4.92284 0.863975 1.95-1.20236-0.39685-3.90768-0.39685-5.7307 0-1.7752 1.74449-3.22441 3.52382-3.22441 1.77756 0 3.52382 1.44922 3.52382 3.22441 0 1.82303-2.36279 4.44922-0.39507 5.7307 1.17401 0.766535 3.10925-0.863975 4.92106-0.863975z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m397.49 91.5085c-0.20846-0.24803-0.36201-0.52323-0.4624-0.81142 0.37854-1.31811 1.66063-2.36988 3.05315-2.36988 0.61004 0 1.19823 0.20315 1.7002 0.540945-0.1063 0.360235-0.91712 0.434645-1.68307 1.07716-1.09843 0.91949-1.68779 2.65984-2.60787 1.56319zm0.5055 5.0955c0.14173 0.198425 0.2185 0.410435 0.2185 0.6313 0 1.09902-1.8998 1.98957-4.24429 1.98957-1.96359 0-3.61536-0.626575-4.09843-1.47638 0.56929-0.881695 1.59567-1.47342 2.69056-1.47342 1.63642 0 3.87461 1.3937 5.03325 0.679135 0.16948-0.10453 0.30059-0.22205 0.40039-0.350195zm3.2675 0.168c0-0.51319 0.2433-0.99331 0.66555-1.40256-0.10512 0.625985 0.0212 1.18288 0.6372 1.58504 1.09666 0.714565 3.33662-0.679135 5.0309-0.679135 1.07776 0 2.08937 0.573425 2.66516 1.4315-0.65079 1.04055-2.35689 1.78228-4.35768 1.78228-2.5624 0-4.64114-1.21654-4.64114-2.71712z'/%3E %3Cpath d='m407.596 96.2765c1.65886 0 3.15768 1.35532 3.15768 3.01594 0 1.65946-1.49882 3.01536-3.15768 3.01536s-5.7372-2.90256-5.6392-0.68976l0.0537 1.18169 0.69744 9.78365c2.82401 0.63544-8.0829 0.63544-5.2612 0l0.70157-9.8268 0.0502-1.13859c0.0974-2.21102-4.10434 0.68977-5.63505 0.68977-1.65886 0-3.15827-1.35591-3.15827-3.01536 0-1.66063 1.49941-3.01594 3.15827-3.01594 1.63405 0 3.87402 1.39075 5.0327 0.678545 1.82126-1.12323-0.68327-3.77067-0.68327-5.47145 0-1.65827 1.5059-3.1559 3.16653-3.1559 1.66122 0 3.16654 1.49764 3.16654 3.1559 0 1.70079-2.51634 4.27382-0.67914 5.47145 1.09488 0.712205 3.33721-0.678545 5.02916-0.678545z'/%3E %3Ccircle fill='%23f1f1f2' stroke-width='1.703' cx='400' cy='116.288' r='7.901'/%3E %3Cpath fill='%23000' stroke='none' d='m401.46 121.283c0.52973-0.6626 1.11496-1.50355 1.35827-2.28839 0.17894-0.57283 0.77422-0.30354 0.64548 0.18484-0.22618 0.85335-0.74528 1.74626-1.25374 2.4502zm-8.69537-4.65354c0.137-0.11575 0.29232-0.26103 0.47716-0.40866 0.18307-0.14764 0.39862-0.30531 0.65433-0.4506 0.33425-0.2244 0.10158-0.7435-0.30531-0.54626-0.42815 0.20847-0.78071 0.42697-1.0128 0.58347zm-0.0502 1.17166l0.41161 0.73464c0.57697-0.61004 1.54252-1.49882 1.69607-1.64232 0.35669-0.33839-0.10571-0.72874-0.41103-0.51083-0.35078 0.25099-0.85925 0.63544-1.2189 0.96733-0.19783 0.18248-0.36673 0.34429-0.47775 0.45118zm0.59764 1.76279l0.51319 0.59763c1.21299-0.94311 2.29075-2.08642 2.46496-2.27362 0.34252-0.37146-0.0543-0.87638-0.46063-0.5067-0.19311 0.20374-1.76693 1.60335-2.5063 2.17382l-0.0112 0.009zm10.7829 1.33288c0.38209-0.43229 0.79724-1.03642 0.93425-1.73563 0.0502-0.24744 0.22677-0.36555 0.40335-0.32835 0.17007 0.0372 0.29468 0.21378 0.25511 0.45059-0.13936 0.84272-0.57992 1.55906-0.99271 2.04036zm-6.05668 0.77172c1.10728-1.26614 1.91457-2.34803 2.64331-3.56457 0.10984-0.18307 0.30944-0.22854 0.45649-0.15591 0.15591 0.0744 0.22855 0.26162 0.12225 0.47953-0.4565 0.93485-1.07303 1.90394-1.6187 2.59311-0.54626 0.69154-0.95138 1.16516-0.95138 1.16516zm-2.24082-1.37469c0.74079-0.68533 1.58901-1.55227 2.05828-2.12777 0.27815-0.34074 0.88229-0.0768 0.5374 0.43406-0.44232 0.65374-1.12559 1.45984-1.75866 2.04272z'/%3E %3Cpath fill='%23d99f31' d='m406.135 133.626h-6.0573l-6.03305-0.002c-1.02402 1.72913-4.2567 2.90256-6.90235 1.52185-1.87855-0.98209-2.263-3.21201-2.263-3.21201s5.0622 0.18484 5.08935-4.2939c0-4.53898 2.60729-7.50415 6.3555-7.0553 1.63583 0.19488 2.74253 1.01988 3.75355 1.93878 1.01338-0.9189 2.12421-1.74626 3.76299-1.93878 3.74705-0.44469 6.349 2.51634 6.349 7.0199 0 4.51654 5.0888 4.33346 5.0888 4.33346s-0.38386 2.22579-2.26299 3.20788c-2.65571 1.38484-5.9073 0.19724-6.8805-1.52008z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m406.139 133.624h-0.41752c-1.12146 1.03996-2.88426 2.09468-5.64155 2.70532-2.75965-0.61063-4.52008-1.66536-5.64095-2.70532h-0.39449s-4.24016 3.0065-7.2136 0.75177c-1.09843-0.83091-1.33051-1.97717-1.33051-1.97717s5.0888-0.27756 5.0888-4.79409c0-4.50355 2.44429-6.401 5.73305-6.401 1.43681 0 2.74429 0.70984 3.75768 1.62992 1.01102-0.92008 2.32146-1.62992 3.75827-1.62992 3.28878 0 5.7325 1.89744 5.7325 6.401 0 4.51654 5.087 4.79409 5.087 4.79409s-0.23268 1.14626-1.32874 1.97717c-2.97579 2.25473-7.18995-0.75177-7.18995-0.75177z'/%3E %3Cpath stroke='%23f1bf31' stroke-width='0.904' d='m391.164 125.035c-0.26515 0.63957 0.15591 2.86358 0.15591 2.86358s0.1376 2.01969-1.45099 3.5563c-1.10905 1.07363-3.64606 1.54134-3.64606 1.54134m22.7788-7.9612c0.26634 0.63957-0.15532 2.86359-0.15532 2.86359s-0.137 2.01968 1.44922 3.5563c1.10846 1.07362 3.64606 1.54134 3.64606 1.54134'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m399.982 135.868c-6.29585-1.43032-7.112-5.32975-6.9372-5.28605 0.41279 0.10157 1.86673 2.94567 7.03405 4.38307 5.1685-1.4374 6.6195-4.2815 7.03525-4.38307 0.17421-0.0437-0.64193 3.85571-6.9372 5.28605h-0.19488zm-7.7355-11.121c0-1.52421 2.52638-2.80157 5.93445-3.15177 0.70335 0.29586 1.34528 0.73582 1.89922 1.23838 0.55157-0.50138 1.19173-0.94134 1.89331-1.23662 3.39921 0.35256 5.9179 1.62815 5.9179 3.15 0 3.61063-4.1256 5.3569-7.82365 5.3551-3.69804 0-7.82125-1.74449-7.82125-5.3551z'/%3E %3Cpath d='m406.139 133.624h-0.41752c-1.12146 1.03996-2.88426 2.09468-5.64155 2.70532-2.75965-0.61063-4.52008-1.66536-5.64095-2.70532h-0.39449s-4.24016 3.0065-7.2136 0.75177c-1.09843-0.83091-1.33051-1.97717-1.33051-1.97717s5.0888-0.27756 5.0888-4.79409c0-4.50355 2.44429-6.401 5.73305-6.401 1.43681 0 2.74429 0.70984 3.75768 1.62992 1.01102-0.92008 2.32146-1.62992 3.75827-1.62992 3.28878 0 5.7325 1.89744 5.7325 6.401 0 4.51654 5.087 4.79409 5.087 4.79409s-0.23268 1.14626-1.32874 1.97717c-2.97579 2.25473-7.18995-0.75177-7.18995-0.75177z'/%3E %3Cpath fill='%23000' d='m407.625 130.618s-0.75177 5.0516-7.5455 6.5551c-6.7955-1.50355-7.54725-6.5551-7.54725-6.5551s0.75177 4.20827 7.54725 5.7118c6.7937-1.50355 7.5455-5.7118 7.5455-5.7118z'/%3E %3C/g%3E %3C/g%3E %3Cg id='shield' stroke-width='0.933' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath fill='%23a0cfeb' d='m398.792 227.491c13.5414-0.23681 71.818-10.0081 71.818 70.925 0 77.3055-70.5605 108.048-70.5605 108.048s-70.563-29.7809-70.563-113.912c0-75.068 69.3055-65.06 69.3055-65.06z'/%3E %3Cpath fill='%2394bb79' d='m421.681 348.386c4.12972-2.30492 8.889-3.6189 13.953-3.6189 8.237 0 15.6608 3.47422 20.8902 9.03605-20.5866 37.0152-56.4735 52.66-56.4735 52.66s-34.9589-14.7555-55.6635-52.8325c5.2199-5.4614 12.577-8.8636 20.7284-8.8636 5.67935 0 10.9718 1.65059 15.4252 4.49941 5.23465-5.62915 12.7046-9.1488 20.9976-9.1488 7.8508 0 14.964 3.1565 20.1426 8.2683z'/%3E %3Cpath fill='%23658d5c' d='m433.967 345.161c3.55453 0.41102 9.77305 3.75827 12.7796 8.2695-2.33563 3.86043-6.82265 9.9939-9.3 13.3742-5.49565-8.06695-16.8821-18.8676-16.0931-18.0874 0.11397 0.11043 0.59174-0.27756 0.73051-0.35492 1.09606-0.61181 2.1189-1.16634 3.12165-1.63937 2.01851-0.78839 4.14745-1.35472 6.3573-1.6689 0.75768-0.0248 1.55315 0.008 2.40414 0.10689zm-24.18 50.7695c-4.49587 2.37401-7.9943 3.89587-9.7382 4.63051-1.74626-0.73464-5.2453-2.25649-9.7382-4.63051-8.7077-7.0512-26.641-23.5075-39.267-47.4296 4.07185-2.27894 8.76435-3.57874 13.7616-3.57874 0.40925 0 2.10531 0.4937 3.34724 1.07716 7.93585 3.72874 17.7561 14.4348 14.1378 16.4823-2.6563 1.49883-10.255-0.96141-10.6542 1.97835-0.14941 1.11319 14.0964 8.9386 22.1918 15.8303 6.63605 5.6492 17.0014 14.7957 15.959 15.6402zm17.297-7.0315c-9.0632-8.89665-29.4466-26.9964-46.503-39.6762 4.72678-5.0622 11.2654-8.4077 18.5829-9.0071l0.38445 0.0514c9.84215 1.41024 18.7577 11.9634 15.1388 14.0108-2.65571 1.49941-10.2555-0.96142-10.6536 1.97894-0.1311 0.98032 10.1924 7.22125 16.2366 12.4181 5.93445 5.10175 9.81495 8.76735 14.2164 13.5762-2.48917 2.40649-4.97362 4.62047-7.40255 6.64785z'/%3E %3Cpath fill='%23000' d='m422.071 347.943c1.88563 1.77933 2.70768 3.26161 2.71418 3.27224 0.1807 0.30059-0.0213 0.99213-0.5628 0.48544 0 0-0.75-0.71457-2.95275-2.86063-2.96457-2.89252-8.09351-6.5492-12.339-7.2632-0.40749-0.0685-0.58406-0.26989-0.53387-0.56516 0.0473-0.29646 0.30532-0.57697 0.71221-0.51083 0.0768 0.0124 6.3449 1.1941 12.962 7.44215zm-34.8745 5.5545c0.19488 0.1748 0.24685 0.41575 0.13878 0.59409-0.11397 0.18662-0.35492 0.22796-0.55866 0.0809-3.58583-2.54764-5.33565-3.61477-7.41435-4.91871-0.16359-0.10393-0.27224-0.27638-0.14941-0.45886 0.0809-0.12224 0.24921-0.20137 0.40866-0.24744 0.32599-0.0933 0.81851-0.10984 1.13386 0.0874 2.10591 1.32225 3.51969 2.4626 6.44115 4.8626z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.244' d='m421.681 348.386c4.12972-2.30492 8.889-4.08366 13.953-4.08366 8.2766 0 15.7329 3.63543 20.9664 9.36554m-112.312-0.225c5.22695-5.6823 12.6236-9.2947 20.8276-9.2947 5.67935 0 10.9718 2.2695 15.4252 5.1183 5.23465-5.62915 12.7046-9.76715 20.9976-9.76715 7.8508 0 14.964 3.77481 20.1426 8.8866'/%3E %3Cpath fill='none' stroke='%234c819a' stroke-width='0.777' d='m367.911 230.52h66.967m-75.9135 3.71221h84.1205m-90.2515 3.71279h95.794m-100.444 3.71457h104.632m-108.329 3.71221h111.648m-114.663 3.7122h117.374m-119.856 3.7128h122.102m-124.169 3.7122h126.052m-127.756 3.7128h129.332m-130.752 3.71398h132.079m-133.248 3.71043h134.356m-135.301 3.7128h136.22m-50.2455 3.71279h51.0055m-137.726 0h51.354m51.9835 3.71162h35.002m-138.918 0h35.4443m74.937 3.71516h29.0174m-139.824 0h29.234m87.8725 3.7122h23.08m-140.456 0h22.9943m100.604 3.7128h17.1172m-140.856 0h17.0947m111.114 3.70984h12.7996m-141.032 0h13.0288m119.299 3.7128h8.77205m-141.027 0h8.4815'/%3E %3Cg id='tower1' fill='none'%3E %3Cpath fill='%23000' d='m356.655 300.398l-0.0165-7.225 7.7485-3.024 7.7495 2.093 0.0165 8.156z'/%3E %3Cpath fill='%23fff' d='m373.237 333.224l3.39449 13.9482c-3.52559-1.54666-7.4185-2.40591-11.5158-2.40591l-0.72873-57.564 3.09862 0.89055v6.05255l3.87461 0.99685v-5.9947l5.27125 1.3872v9.84155l-3.39449 5.0374v27.8102z'/%3E %3Cpath fill='%23bdbfc1' d='m364.387 332.147v-28.6636-6.07735-10.2024l-0.001-0.0005-3.09922 1.3559v5.96515l-3.87461 1.54489v-5.98995l-5.2695 2.23642v9.5321l3.78721 4.54252 0.0892 27.3933-3.87638 14.0817c3.69331-1.87736 7.84605-2.97933 12.2445-3.08917v-0.0921-12.5368z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='m364.249 332.04l-8.2305 1.7439m-1.73985 8.66869l10.0483-2.12244 10.8644 1.16752m-11.2246-5.22463l-8.8677 1.8065m17.6528-24.6833l-8.364-1.73564-8.48325 2.58897m16.8472 3.09805l-8.364-1.59686-8.48325 2.45019m0-7.85847l8.48325-2.7431 8.364 1.76694m-16.8472 12.7258l8.48325-2.26299 8.364 1.48819m-16.7705 4.66358l8.4065-2.07638 8.44075 1.38072m-16.8472 4.60156l8.4065-1.89153 8.5199 1.27087m-3.0963-24.4116v3.83682m-3.09981-0.58288v3.91359m3.09981 0.82795v3.91654m-7.90395-4.2815v3.91358m0 4.10965v3.913m-3.7193 1.3624v3.60472m0-19.4197v3.60414m3.7193-9.1069v3.91594m2.4961-10.9818l12.2274 2.97697m-12.2274-2.97697l-12.2598 4.44686'/%3E %3Cpath stroke='%23000' stroke-width='1.244' d='m364.387 344.776v-57.5725'/%3E %3Cpath fill='%23000' d='m370.586 334.677l-3.72283-0.51319 0.004-11.7809c0-1.44981 0.88051-2.33622 1.67362-2.33622 1.40611 0 2.04508 1.58445 2.04508 2.95689z'/%3E %3Cpath stroke='%23000' d='m373.237 333.225l3.39449 13.9482c-3.52559-1.54666-7.4185-2.40591-11.5158-2.40591-4.6689 0-9.07735 1.11674-12.972 3.09744l3.87402-14.0794-0.0892-27.3933-3.78485-4.54311v-9.5321l5.2689-2.2376v5.9882l3.87461-1.5437v-5.96515l3.09981-1.35531 3.09862 0.89055v6.05255l3.87461 0.99685v-5.9947l5.27125 1.3872v9.84155l-3.39449 5.0374v27.8102zm3.10037 13.42c-3.40926-1.40964-7.30215-2.18622-11.2205-2.18622-4.47224 0-8.8636 1.01162-12.6466 2.82166l3.84745-13.4132-0.0791-27.4778c0-0.0224-0.0561-0.17894-0.0703-0.19666l-3.71457-4.4563v-9.21435l4.64882-1.9748v5.52105c0 0.25275 0.18898 0.3815 0.42579 0.28642l3.87461-1.54252c0.0803-0.0313 0.19429-0.19961 0.19429-0.28701v-5.7638l2.81162-1.22953 2.76614 0.79606v5.8175c0 0.10985 0.12461 0.27225 0.23209 0.29882l3.87461 0.99863c0.21791 0.0561 0.38858-0.0762 0.38858-0.29882v-5.5937l4.6506 1.22303v9.50905l-3.34075 4.9565c-0.0106 0.0147-0.0537 0.15768-0.0537 0.1748v27.8102l3.41102 13.4208zm1.21476 0.45532c0.075 0.30886-0.7559 0.0201-1.04645-0.10866-3.48603-1.53012-7.3376-2.37874-11.3888-2.37874-4.6193 0-8.97995 1.10374-12.8333 3.06201-0.29941 0.15177-1.14862 0.42992-1.05885 0.1063l4.48228-14.038-0.0868-27.2392-3.71457-4.45808c-0.0148-0.0172-0.0709-0.1748-0.0709-0.19783v-9.5321c0-0.0833 0.11043-0.25099 0.18661-0.28406l5.2701-2.23878c0.23859-0.10157 0.4317 0.0272 0.4317 0.28465v5.5311l3.25394-1.29508v-5.7561c0-0.0803 0.11161-0.25099 0.18661-0.28229l3.09981-1.35531c0.0206-0.0106 0.18662-0.0213 0.20965-0.0147l3.09803 0.89055c0.10217 0.0295 0.22441 0.19134 0.22441 0.29705v5.8116l3.25335 0.83858v-5.5931c0-0.22677 0.17244-0.35728 0.39035-0.30118l5.2695 1.38721c0.10807 0.0265 0.23091 0.18897 0.23091 0.29881v9.84155c0 0.0165-0.0413 0.16004-0.052 0.17245l-3.34075 4.96004v27.6774l4.00512 13.914zm-13.1485-43.577l8.364 1.89094m-8.364-1.89094l-8.475 2.8689'/%3E %3C/g%3E %3Cg id='tower2' fill='none'%3E %3Cpath fill='%23000' d='m391.526 294.975l-0.0165-7.3835 7.7485-2.7885 7.7495 2.4025 0.0165 7.7695z'/%3E %3Cpath fill='%23fff' d='m408.108 328.109l3.39508 13.7888c-3.10394-1.15217-6.4618-1.77992-9.96435-1.77992-0.81295 0-1.61799 0.0338-2.41378 0.1001l0.1343-58.4401 3.09744 1.04646v6.0508l3.87461 1.07539v-5.91555l5.27184 1.69429v9.81085l-3.39508 4.83544v27.7335z'/%3E %3Cpath fill='%23bdbfc1' d='m399.259 340.19v-5.3197-8.22345-28.5874-6.07735-10.2042h-0.0005l-3.09803 1.20236v6.0443l-3.87638 1.38485v-5.98585l-5.2701 2.07992v9.64075l3.7872 4.63642 0.0898 27.58-3.877 15.702c3.64252-2.14489 7.8018-3.50611 12.2451-3.85512v-0.0183z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='m398.802 330.83l-8.5754 1.64646m19.4823 3.86989l-10.502-1.31989-10.3568 1.97008m4.22485-21.0118v3.75768m3.7193 3.39918v3.91536m0-28.1692v3.91417m-3.7193 1.4327v3.75768m3.7193-1.00867v3.91359m7.90455-3.31536v3.913m-3.09981-8.65571v3.91358m3.09981-7.09016v3.83681m-13.8284 20.8854l8.40475-1.81417 8.5193 1.58209m-17.0014-7.64056l8.4821-2.10767 8.3634 1.79765m-16.8455-3.58112l8.4821-2.29488 8.3634 1.90808m-16.8455-3.56518l8.4821-2.43306 8.3634 2.04745m-16.8455-3.58171l8.4821-2.54113 8.3634 2.15257m0.0791 15.8575l-8.4425-1.69075-8.40475 1.9996m8.3887 6.16672l-8.3699 1.71496m20.6138-32.8205l-12.2439-3.55926-12.2445 4.16339m20.6244 4.21654l-8.3634-2.25561-8.4762 2.67549'/%3E %3Cpath stroke='%23000' stroke-width='1.244' d='m399.259 340.19v-58.412'/%3E %3Cpath fill='%23000' d='m405.457 329.407l-3.72225-0.58996 0.004-11.7803c0-1.44981 0.88051-2.25768 1.67539-2.25768 1.40374 0 2.04272 1.58208 2.04278 2.26858z'/%3E %3Cpath stroke='%23000' d='m411.218 341.411c-2.98347-1.03819-6.3431-1.60334-9.67975-1.60334-5.09765 0-10.0418 1.31693-14.2046 3.62716l3.85571-15.0012-0.0786-27.6538c0-0.0231-0.0561-0.17657-0.0709-0.19547l-3.714-4.55v-9.31889l4.64941-1.83957v5.53345c0 0.24685 0.18248 0.37559 0.41456 0.29232l3.87461-1.38898c0.0898-0.0313 0.20552-0.19724 0.20552-0.29055v-5.8305l2.79685-1.08602 2.78031 0.93897v5.8305c0 0.10748 0.12225 0.26929 0.22618 0.29882l3.87461 1.0754c0.21969 0.0602 0.39449-0.0709 0.39449-0.29882v-5.49215l4.65119 1.49705v9.4866l-3.33898 4.75512c-0.008 0.0147-0.0561 0.16181-0.0561 0.17834v27.7335l3.41989 13.301zm1.2065 0.41103c0.072 0.29705-0.74351 0.007-1.02992-0.0998-3.0691-1.1374-6.3892-1.75866-9.8563-1.75866-5.2429 0-10.1534 1.42205-14.3664 3.90178-0.29469 0.17421-1.16044 0.4565-1.07776 0.12224l4.48524-15.6656-0.0898-27.4306-3.71456-4.55138c-0.0147-0.0165-0.0703-0.17244-0.0703-0.19488v-9.64075c0-0.0868 0.11398-0.25512 0.19725-0.28819l5.2677-2.08287c0.23622-0.0933 0.42342 0.0354 0.42342 0.28878v5.54765l3.25571-1.16457v-5.8264c0-0.0892 0.11457-0.25689 0.19902-0.28819l3.09862-1.20237c0.0218-0.008 0.18898-0.0106 0.21083-0.004l3.09863 1.04646c0.0909 0.0313 0.20905 0.19547 0.20905 0.29232v5.8181l3.2563 0.90118v-5.50865c0-0.23622 0.17835-0.36732 0.40512-0.29468l5.27125 1.69606c0.0957 0.0313 0.21378 0.19547 0.21378 0.29528v9.81085c0 0.0183-0.0461 0.16417-0.0561 0.17775l-3.33603 4.75512v27.5982l4.00512 13.7498zm-4.316-13.713l3.39508 13.7888c-3.10394-1.15217-6.4618-1.77992-9.96435-1.77992-5.3008 0-10.265 1.4374-14.524 3.94547l3.87461-15.7028-0.0898-27.58-3.78485-4.63642v-9.64075l5.2701-2.08051v5.9882l3.87461-1.38898v-6.0443l3.09981-1.2 3.09744 1.04646v6.0508l3.87461 1.07539v-5.91555l5.27185 1.69429v9.81085l-3.39508 4.83544v27.7335z'/%3E %3C/g%3E %3Cg id='tower3' fill='none'%3E %3Cpath fill='%23000' d='m426.396 300.554l-0.0145-8.156 7.7485-2.1695 7.7485 2.5555 0.017 7.77z'/%3E %3Cpath fill='%23fff' d='m442.979 333.534l3.39449 13.3134c-3.31772-1.34114-6.94075-2.08052-10.7404-2.08052-0.54709 0-1.09059 0.0154-1.63011 0.0456l0.12658-57.6096 3.09804 1.0441v6.05315l3.87461 1.30748v-5.91735l5.27125 1.77342v9.688l-3.39449 4.80473v27.5776z'/%3E %3Cpath fill='%23bdbfc1' d='m434.13 332.147v-28.6636-6.07735-10.203l-3.09804 0.96791v6.04431l-3.87637 1.15393v-5.98759l-5.27011 1.69606v9.763l3.78544 4.85197 0.0915 27.5492-3.87697 15.0302c3.67027-2.00847 7.8248-3.238 12.2445-3.46594v-0.12225-12.5368z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='m423.572 342.002l10.5065-1.62992 10.6954 1.40788m-11.0922-5.55648l-8.8512 1.35768m6.8209-33.4247v3.91417m-3.72107 1.27739v3.76004m0 12.1317v3.76004m3.72107-8.64745v3.91359m0-12.0136v3.91417m7.90215-3.08386v3.91418m-3.0998-8.73308v3.91359m3.0998-7.01398v3.83799m-13.8278 20.4201l8.40415-1.42618 8.5199 1.58209m-17.0014-11.9976l8.4815-1.82894 8.36635 1.98545m0 3.96791l-8.36635-1.87501-8.4815 1.72146m16.8478-7.76574l-8.36635-2.12423-8.4815 1.96831m16.8478-3.812l-8.36635-2.2317-8.4815 2.07578m16.8614-3.70627l-8.3634-2.43307-8.475 2.17146m-3.78545-4.85256l12.2604-3.43996 12.228 3.74941m-12.228 30.89l-8.38585 1.35768m-0.0349-7.87975l8.40415-1.61338 8.4425 1.76694'/%3E %3Cpath stroke='%23000' stroke-width='1.244' d='m434.13 344.806v-57.603'/%3E %3Cpath fill='%23000' d='m440.329 334.909l-3.72343-0.58937 0.002-11.7809c0-1.45157 0.88229-2.25945 1.67599-2.25945 1.40551 0 2.04508 1.58445 2.04501 2.27066z'/%3E %3Cpath stroke='%23000' d='m446.079 346.338c-3.19784-1.21476-6.82085-1.87913-10.4439-1.87913-4.78406 0-9.4518 1.15866-13.4274 3.20964l3.85335-14.3492-0.0791-27.6254c0-0.0224-0.052-0.17421-0.0667-0.19075l-3.71811-4.76693v-9.4329l4.64882-1.49527v5.5624c0 0.23268 0.17421 0.36319 0.39862 0.29705l3.87461-1.15689c0.0992-0.0283 0.22145-0.19016 0.22145-0.29646v-5.81635l2.78681-0.86988 2.79036 0.94311v5.82815c0 0.0974 0.1187 0.26339 0.20965 0.29468l3.87697 1.30807c0.22854 0.0768 0.40925-0.0514 0.40925-0.29468v-5.48505l4.65059 1.56496v9.36615l-3.33898 4.72382c-0.008 0.0147-0.0555 0.16181-0.0555 0.17834v27.5776l3.40926 12.805zm-3.1-12.804l3.39449 13.3134c-3.31772-1.34114-6.94075-2.08052-10.7404-2.08052-4.9813 0-9.66555 1.27087-13.7474 3.50493l3.87402-15.0307-0.0886-27.5468-3.78543-4.85434v-9.7624l5.2695-1.69606v5.9876l3.87461-1.15453v-6.0437l3.0998-0.96792 3.09804 1.0441v6.05315l3.87461 1.30748v-5.91735l5.27125 1.77342v9.688l-3.39449 4.80473v27.5776zm4.31369 13.2353c0.0774 0.30355-0.74527 0.0165-1.03582-0.10157-3.28052-1.32461-6.86635-2.05512-10.6222-2.05512-4.92934 0-9.5634 1.25787-13.5998 3.46713-0.29764 0.16181-0.99922-0.17658-0.91359-0.50433l4.32874-14.3728-0.0868-27.4028-3.72107-4.76752c-0.0147-0.0165-0.0667-0.17008-0.0667-0.19133v-9.76475c0-0.0992 0.12106-0.26339 0.21614-0.29469l5.2677-1.6943c0.22854-0.0744 0.40748 0.0561 0.40748 0.29528v5.57245l3.25335-0.97205v-5.81105c0-0.10217 0.11988-0.26634 0.21791-0.29764l3.09981-0.96673c0.0165-0.006 0.17244-0.005 0.19134 0.002l3.09744 1.04468c0.0939 0.0307 0.20965 0.19725 0.20965 0.2941v5.82875l3.25571 1.09842v-5.48385c0-0.24094 0.18071-0.37145 0.40925-0.29468l5.27185 1.77342c0.0909 0.0307 0.20965 0.19666 0.20965 0.29469v9.68565c0 0.0165-0.0454 0.16417-0.0561 0.17835l-3.33661 4.72382v27.443l4.00276 13.2738z'/%3E %3C/g%3E %3Cg id='feather' fill='%23000' stroke='%23000'%3E %3Cpath d='m369.418 268.702c-0.28288-2.57008-1.2815-6.72875-4.71556-6.1996 0.17481 4.46811 5.8612 21.2906-0.63779 22.4528l-0.21733-0.23268c0.085-7.6382-7.5496-15.9744-6.0632-22.627 0.98032-4.37717 4.29213-6.7447 8.70355-6.7447 8.04566 0 9.15885 9.99805 3.27934 13.503l-0.34902-0.15177z'/%3E %3Cpath fill='%23fff' d='m369.854 267.53c-0.65433-2.86949-2.23228-6.61065-5.8447-5.97105l-0.23681 0.31122c0.16595 4.80472 6.18955 19.4179 0.4565 21.9986-0.15355-8.3675-7.6949-13.7976-5.75965-21.6414 0.5374-2.17382 2.70531-4.87559 4.81535-5.6681 0.98977-0.37382 2.11772-0.68386 3.18898-0.66319 7.25845 0.14941 9.14175 7.67185 3.38032 11.6338z'/%3E %3Cpath stroke='none' d='m359.574 264.713c0.62067-1.69842 2.65335-3.42048 4.46575-3.63543 0.37677-0.046 0.67973 0.29232 0.82914 0.71161l-0.17303-0.004c-0.20788 0-0.41103 0.0271-0.61477 0.0744 0.0106 0.31004 0.036 0.63366 0.0744 0.96614-0.85039 0.0531-2.32559 0.39508-3.82972 2.23819-0.69567 0.85512-1.06536 0.50433-0.75177-0.35078z'/%3E %3Cpath stroke-width='1.09' d='m359.997 265.232l4.24902-1.73563m-3.92717 3.26811l4.20119-1.81359m-3.8628 3.43288l4.19941-1.97894m-3.39213 3.52205l3.78544-1.95532m-2.51634 3.38563l2.94862-1.67598m-0.82264 2.69941l1.29095-0.71693'/%3E %3Cpath stroke='none' d='m369.137 259.592c-2.22756-3.28288-7.8319-1.43681-9.27695 0.6437-0.10335 0.15177-0.47303-0.075-0.68091-0.15827-0.0278-0.0106-0.0532-0.0242-0.0774-0.0389 0.38858-0.64488 0.87225-1.29626 1.425-1.88327 2.71418-1.73386 7.4362-2.08287 9.3372 0.98208 0.14705 0.23859 0.0414 0.47776-0.13524 0.58524-0.17598 0.10807-0.43582 0.0998-0.59173-0.13051z'/%3E %3C/g%3E %3Cuse xlink:href='%23feather' x='35.338' y='-5.423'/%3E %3Cuse xlink:href='%23feather' x='70.673'/%3E %3Cg stroke='%23000'%3E %3Cpath fill='%23000' d='m446.259 240.532c3.26398 2.15315 14.8104 8.6439 16.5189 45.6354 3.33071 72.0965-58.0165 114.162-58.0165 114.162s77.6215-33.0508 77.6215-114.226l0.0001-0.00026c0-34.1728-13.5668-71.191-40.4758-71.191l-14.7915 0.0465-21.4842 10.0512c-1.125-1.56969-3.27166-2.59134-5.3504-2.59134-2.07579 0-4.2254 1.02165-5.3504 2.59134l-21.4837-10.0512-15.2554-0.0465c-26.9108 0-40.4776 37.0182-40.4776 71.191l0.00005 0.00027c0 81.1752 77.621 114.226 77.621 114.226s-61.3472-42.066-58.0165-114.162c1.70905-36.9916 13.2555-43.4823 16.5195-45.6354l18.1308 6.04764 22.914-13.4114c1.4947 1.59862 3.04017 2.73498 5.4006 2.73248 2.35866 0 3.68149-0.92834 5.39646-2.73248l22.7604 13.5668z'/%3E %3Cpath fill='%23d99f31' d='m431.453 214.144l-31.1716 13.5443-31.171-13.5443-10.9189 0.76801c-26.9108 0-40.4776 37.0182-40.4776 71.191v0.00024c0 81.1752 77.621 114.226 77.621 114.226s-62.1214-42.066-58.793-114.162c1.70905-36.9916 13.5667-44.4124 16.8307-46.5656l19.9756 5.55915 26.9332-15.9212 26.9314 15.9212 19.5115-5.55915c3.26398 2.15315 15.1216 9.574 16.8307 46.5656 3.33012 72.0965-58.7935 114.162-58.7935 114.162s77.6215-33.0508 77.6215-114.226l-0.00005-0.00024c0-34.1728-13.5668-71.191-40.4758-71.191z'/%3E %3Cpath fill='%23000' stroke='none' d='m437.336 228.911c-3.71634 0.4376-6.31831 2.92973-6.4506 6.73525-0.0709 2.03918 0.90118 5.06635 2.30256 6.34725l-0.83683 0.91596c-1.65472-1.5142-2.86772-4.88743-2.78209-7.31105 0.1494-4.26675 3.14587-7.24017 7.61575-7.7634zm-74.5104-1.076c4.47048 0.52324 7.46695 3.49666 7.61635 7.7634 0.085 2.42363-1.12795 5.79685-2.78209 7.31105l-0.83683-0.91595c1.40138-1.28091 2.37284-4.30808 2.30197-6.34725-0.13288-3.80552-2.73426-6.29765-6.4512-6.73525zm-8.73434 7.44655c-5.39825 3.48602-10.2922 10.0972-13.0346 16.9258-0.15177 0.35728-0.38445 0.46358-0.62067 0.37795-0.21201-0.0768-0.30118-0.38209-0.20374-0.68327 2.58543-7.17755 7.43505-13.6642 13.5336-18.186l0.3254 1.56555zm7.1995-12.852c-13.2136 0-23.0197 9.30415-29.6392 26.4685-0.15118 0.32008-0.45473 0.56456-0.78307 0.44882-0.26103-0.0939-0.29055-0.46595-0.17244-0.80197 6.62185-17.4892 16.7256-27.1996 30.5947-27.1996 6.0372 0 11.2276 1.48701 15.6703 4.75157l0.24271 1.60985c-4.45866-3.62776-9.737-5.27715-15.913-5.27715zm0 3.564c-11.5294 0-20.5176 9.7193-26.1821 24.0189-0.16181 0.34252-0.39449 0.52323-0.71044 0.39449-0.24508-0.0998-0.27165-0.46713-0.14704-0.77008 5.37755-14.4614 14.8146-24.727 27.0396-24.727 6.1323 0 11.387 1.94173 15.8114 6.19785l-0.2067 1.37953c-4.33465-4.45335-9.52975-6.4937-15.6048-6.4937zm13.2195 12.5915c-2.30079-6.8699-6.0567-9.51435-13.3778-9.51435-9.65495 0-17.6032 8.77265-22.8561 22.0382-0.12874 0.30295-0.35315 0.4813-0.64134 0.38386-0.24922-0.085-0.28878-0.42756-0.17658-0.73701 5.1136-13.4794 13.317-23.0805 23.674-23.0805 7.68605 0 11.7904 3.16063 14.015 9.84865l-0.6372 1.06122zm51.0465 0.093l-0.67028-0.95729c2.20099-6.8002 6.29115-10.0222 14.0026-10.0453 12.427 0.0579 21.9674 14.0586 26.928 32.3327 0.0998 0.35906 0.0331 0.74764-0.28878 0.81142-0.31535 0.0602-0.56693-0.17834-0.65787-0.51909-4.97304-18.0348-14.4372-31.1699-25.9046-31.2296-7.3813 0.0207-11.1166 2.69055-13.409 9.6071zm43.388 21.7645c0.10453 0.41161 0.0667 0.75827-0.29646 0.84744-0.29468 0.075-0.56279-0.14764-0.66023-0.58524-4.7693-20.384-14.9746-34.3636-29.1804-34.3636-6.11105 0-11.3238 1.52185-15.6396 5.964l-0.19784-1.42972c4.42796-4.27205 9.6933-5.6947 15.8374-5.6947 15.1234 0 25.6424 14.935 30.137 35.2618zm3.8275 0.535c0.075 0.38622-0.0555 0.74941-0.3874 0.80374-0.31654 0.0514-0.57343-0.22028-0.64843-0.59233-4.693-22.305-15.788-38.723-33.151-38.723-6.10455 0-11.3286 2.09764-15.7258 5.7555l0.16654-1.60748c4.42205-3.40453 9.5764-5.3114 15.5592-5.3114 18.2924 0 29.687 17.3061 34.184 39.6726zm-31.651-28.224c9.512 1.1628 18.0579 12.3042 21.6726 26.9858 0.0856 0.37382-0.002 0.74351-0.31949 0.82855-0.30945 0.085-0.58347-0.11457-0.71634-0.5941-4.11319-15.8274-12.2634-24.675-20.7614-25.7569l0.12461-1.46338z'/%3E %3Cpath fill='none' d='m419.351 240.512c-0.73229-0.86634-2.92914-3.98859-2.92914-10.2703m-0.29409 8.36515c-0.68386-0.91594-2.32441-3.61004-2.32441-8.36515m-0.86103 6.4825c-0.58169-0.89174-1.75925-3.11398-1.75925-6.4825m-1.35059 4.64469c-0.39981-0.79784-1.11614-2.52402-1.11614-4.64469m-27.5044 10.2703c0.73229-0.86634 2.92913-3.98859 2.92913-10.2703m0.2941 8.36515c0.68386-0.91594 2.32441-3.61004 2.32441-8.36515m0.86516 6.4801c0.58051-0.89351 1.75512-3.11457 1.75512-6.4801m1.34941 4.64528c0.3998-0.79784 1.11732-2.52461 1.11732-4.64528'/%3E %3Ccircle fill='%23d99f31' stroke='none' cx='400.282' cy='229.24' r='6.199'/%3E %3Cpath fill='none' d='m394.135 227.779c0.66023-2.80335 3.14114-4.88977 6.14585-4.88977 2.62677 0 4.87913 1.59449 5.84705 3.86811m0.33012 4.06182c-0.70157 2.74252-3.21437 4.76929-6.17715 4.76929-2.70295 0-5.012-1.69075-5.92795-4.07185m7.562 1.62815c-0.50197 0.21142-1.05472 0.32776-1.63405 0.32776-2.28189 0-4.1439-1.80886-4.22953-4.07185m7.87325 1.99547c-0.46241 0.77835-1.16634 1.39784-2.00965 1.74863m-1.19173-1.89863c-0.14115 0.0313-0.29056 0.0479-0.44233 0.0479-1.06299 0-1.93937-0.80905-2.04508-1.84547m-2.11181-1.24134c0.12461-0.55453 0.36792-0.88878 0.46949-1.04469'/%3E %3Cpath fill='none' d='m394.135 227.779c0-2.91733 2.55827-5.35865 6.14585-5.35865 2.73838 0 5.84705 1.9246 5.84705 4.33701m0.33012 4.06181c0 2.69469-3.21437 5.07875-6.17715 5.07875-2.70295 0-5.92795-1.96476-5.92795-4.3813'/%3E %3Cpath fill='%23000' d='m423.345 242.22c3.26575 4.3311 8.30965 7.07125 13.9654 7.07125 7.39785 0 13.0294-4.59686 13.0294-11.9451-0.1683-3.89292-2.79685-8.7018-9.01595-8.7018-4.04055 0-7.4705 3.89528-7.4705 7.93585 0 2.23405 0.42815 3.58346 1.80059 5.2636-5.53585-1.77933-9.19845-4.72973-9.19845-11.0108 0-6.44055 4.27087-11.0546 11.2683-11.6356 23.3852-1.94351 37.6748 24.0148 40.428 59.8935 3.92422 51.177-23.6782 91.9745-65.637 115.271-5.8571 3.25099-10.4498 5.8512-12.4394 6.69215l-0.0265 6.36555c15.975-6.1063 34.4959-17.8914 46.0465-28.4416 21.9922-20.0906 42.9732-54.0775 39.7902-99.852-2.01142-28.9063-11.0126-48.293-22.0624-57.8705-18.8924-16.3807-44.6516-9.838-44.6516 9.57755 0 4.23957 1.66713 8.2246 4.17343 11.387zm-46.592 0c-3.26634 4.3311-8.30965 7.07125-13.9672 7.07125-7.39605 0-13.0276-4.59686-13.0276-11.9451 0.1683-3.89292 2.79685-8.7018 9.01595-8.7018 4.03996 0 7.4705 3.89528 7.4705 7.93585 0 2.23405-0.42815 3.58346-1.80059 5.2636 5.53525-1.77933 9.19845-4.72973 9.19845-11.0108 0-6.44055-4.27087-11.0546-11.2683-11.6356-23.3852-1.94351-37.6742 24.0148-40.428 59.8935-3.92422 51.177 23.6782 91.9745 65.637 115.271 5.8571 3.25099 10.4498 5.8512 12.4394 6.69215l0.0265 6.36555c-15.975-6.1063-34.4959-17.8914-46.0465-28.4416-21.9922-20.0906-42.9732-54.0775-39.7902-99.852 2.01142-28.9063 11.0126-48.293 22.0624-57.8705 18.8924-16.3807 44.6516-9.838 44.6516 9.57755 0 4.23957-1.66595 8.2246-4.17342 11.387z'/%3E %3Cpath fill='%23f1bf31' d='m400.048 406.956c-15.975-6.1069-34.4959-18.6685-46.0465-29.2181-21.9922-20.0906-41.5784-53.303-38.3953-99.078 2.01201-28.9046 10.5496-47.2069 21.5976-56.785 18.8929-16.3778 43.2579-8.92205 43.2579 8.95925 0 9.83975-7.98545 17.8382-17.8311 17.8382-5.96105 0-12.2546-4.83662-11.6315-12.101 0.1683-3.89115 3.37618-6.9951 7.30865-6.9951 4.04055 0 7.31635 3.27401 7.31635 7.31635 0 2.23228-1.46339 4.38543-3.03898 5.72895 6.22265-0.22205 11.677-5.5063 11.677-11.7874 0-6.44055-4.89154-11.8288-11.889-12.4098-23.3852-1.94351-38.4974 24.6313-41.0468 60.668-3.62481 51.2045 24.297 92.5955 66.2555 115.89 5.88365 3.26575 10.4935 5.25475 12.466 6.08325 1.97421-0.82855 6.5823-2.81752 12.466-6.08325 41.9587-23.2943 69.8805-64.6855 66.2555-115.89-2.54941-36.0366-17.6616-62.6115-41.0468-60.668-6.99745 0.5811-11.8866 5.9693-11.8866 12.4098 0 6.2811 5.45195 11.5654 11.677 11.7874-1.57618-1.34351-3.04193-3.49666-3.04193-5.72895 0-4.04233 3.27638-7.31635 7.31695-7.31635 3.93248 0 7.1427 3.10394 7.31105 6.9951 0.62244 7.26435-5.67285 12.101-11.6338 12.101-9.84565 0-17.8294-7.99845-17.8294-17.8382 0-17.8813 24.3638-25.337 43.2561-8.95925 11.0504 9.57815 19.588 27.8806 21.5976 56.785 3.18307 45.7748-16.4032 78.9875-38.3953 99.078-11.5506 10.5496-30.0714 23.1112-46.0465 29.2181z'/%3E %3C/g%3E %3C/g%3E %3Cg id='laurel' fill='%23000' stroke='%23000' stroke-width='0.933' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath d='m302.443 357.768s-3.28465-1.32638-4.73859-2.05335c-2.5252-1.2626-8.21575-8.26535-14.5736-11.9551-9.75885-5.6622-19.2041-4.20236-27.8327-7.90865 1.93288 9.03605 8.02085 17.198 18.101 21.5209 8.28071 3.55217 21.6414 0.49843 23.0947 0.6189 1.45394 0.12284 6.0691 1.90394 6.0691 1.90394l-0.11988-2.12657z'/%3E %3Cpath d='m267.223 369.044l0.0874-0.26398c5.338-0.72638 10.3382-1.93642 15.5309-3.25335 11.5046-2.91496 16.8945-0.54803 26.2176 5.8329 0.58346 0.3998 1.275 0.9567 1.9435 1.20827 1.51122 0.57107 2.4815 0.17244 3.94075 0.17244l0.13347 0.0266 2.18563 1.70906c0.16653 0.13051 0.0667 0.24449-0.0909 0.27815-1.90393 0.39212-4.50413 0.38622-6.49664 0.20551-3.00651-0.27402-9.1943 6.8516-18.0018 6.8516-11.1603 0-18.4937-4.93938-25.4498-12.7672z'/%3E %3Cpath fill='%23658d5c' d='m316.303 374.316c-1.74213 0.062-3.59882 0.062-5.3179 0.35079-5.1325 0.86397-10.2136 6.4553-18.0183 6.67975-10.3854 0.29881-16.9429-4.59272-24.0414-11.5736 10.3276-1.55256 18.3106-7.51595 28.9666-4.16279 5.4632 1.71908 11.8848 8.5996 17.0138 7.61399l1.39724 1.09193z'/%3E %3Cpath stroke-width='0.45' d='m309.878 372.946s-9.11045 1.49705-14.785 1.51181c-9.16535 0.0206-23.1928-3.79961-23.1928-3.79961s13.986 4.2313 23.1928 4.41792c5.6622 0.11456 14.785-1.2 14.785-1.2v-0.93012z'/%3E %3Cpath fill='none' stroke-width='0.777' d='m284.538 262.675c0.075-0.28701 0.0189-0.63366-0.16004-1.063-0.18248-0.44468-0.46476-0.91771-0.76358-1.42027-0.31181-0.52559-0.64193-1.07776-0.90296-1.65296-0.26397-0.58523-0.46712-1.2124-0.50905-1.86673l1.41614-0.40512c0.10158 0.7937 0.57933 1.81299 1.1191 2.61437 0.2681 0.39862 0.53976 0.72697 0.77066 0.93425 0.11575 0.1057 0.20966 0.17066 0.27078 0.19664 0.033 0.0165 0.42667 0.44704 0.42667 0.44704l-1.17136 2.61615c-0.0871 0.19549-0.60383 0.0124-0.49635-0.40037z'/%3E %3Cpath stroke-width='0.777' d='m338.065 388.946c-0.046-1.89981 0.33012-1.19173 2.37697-0.35728 0.43642 0.17657 0.11457 0.60413-0.25925 0.83681-1.22303 0.76417-2.30256 2.38346-2.82166 2.02027-1.40787-0.98445-0.52145-1.01929 0.70394-2.4998z'/%3E %3Cpath d='m289.158 254.936c-6.0254 15.3189-8.05985 42.4441-5.9752 54.761 6.4069 37.8674 37.5957 73.3685 66.1455 79.1055 24.8309 4.99075 39.9668 16.1162 49.852 27.9821 6.4612 7.7551 9.91065 11.2766 19.1876 26.7201 3.39035 5.6439-2.40886 6.78545-4.80059 2.1059-6.52795-12.7654-10.0453-18.4382-19.04-28.4728-9.65905-10.7764-23.8672-20.4514-47.0575-25.0802-27.6544-5.5205-60.049-41.0841-66.4565-78.9495-2.08524-12.3189-0.26162-41.7296 6.06259-57.275l2.08229-0.89705'/%3E %3Cpath d='m330.29 387.334c-4.30217 0.47185-7.2112 6.7175-11.5276 10.6476-7.94825 7.23425-20.6846 7.9565-28.8054 3.1252-0.34015-0.20374-0.5126-0.6567-0.12815-0.74527 10.0966-2.29017 11.4136-16.0689 32.4608-14.713 2.46674 0.15945 3.50905 0.66438 5.98585 0.66438l2.01437 1.02106z'/%3E %3Cpath d='m314.307 323.269l0.13937 0.0679c0.1063 6.15474 4.77343 14.5488 5.91735 21.3183 0.98681 5.8299-0.43583 10.7032-2.66989 16.1344-0.55866 1.35354-1.86909 4.07421-1.92047 5.4071-0.0478 1.24134 0.73051 2.38996 1.38897 3.41752 0.23032 0.36141 1.62343 2.19035 1.47992 2.54527-5.5766-4.82894-2.29606-1.6813-4.61693-6.13345-1.19645-2.29606-2.62264-4.38071-3.80846-6.6933-6.26045-12.2114-6.3762-26.064 4.09016-36.0638z'/%3E %3Cpath d='m354.556 389.97c-2.73898-0.88464-5.52755-1.97598-7.0305-4.77934-2.5252-4.70551-1.98485-8.50864-4.57441-13.3777-4.91221-9.2374-14.3699-10.2319-19.1433-18.7949-0.96792 7.87975-2.02441 19.6524 10.2425 28.0718 4.3187 2.96279 10.9051 3.6437 12.4914 4.83366 1.58858 1.18996 2.5435 2.89016 2.5435 2.89016l5.47085 1.1563z'/%3E %3Cpath fill='%23658d5c' d='m349.244 388.53c-0.90118-0.95905-1.9122-1.9246-2.98169-2.69882-2.50336-1.81063-7.9246-1.9813-12.0177-4.9813-5.71596-4.19232-8.67875-8.0888-10.2668-14.997-0.96378-4.18996-0.22264-7.53955-0.0254-11.0232 5.149 7.47875 14.0941 8.1827 18.88 17.1296 2.90905 5.43605 2.52283 13.7038 8.48385 17.009l-2.07225-0.43819z'/%3E %3Cpath stroke-width='0.777' d='m300.355 347.397s-0.34075 0.41043-0.82027 1.77756c-0.21378 0.61417 1.13326 2.46437 1.02342 1.82244-0.27402-1.56969 0.49842-2.67402 0.49842-2.67402l-0.70157-0.92598z'/%3E %3Cpath fill='%23658d5c' d='m302.443 357.768s-3.28465-0.70748-4.73859-1.43209c-2.5252-1.26436-8.1142-8.59604-14.5736-12.2652-9.26045-5.25885-17.3268-4.16043-26.4378-6.8244 2.58544 9.72285 7.52716 15.5392 16.7061 19.66 8.2199 3.68977 21.6414 0.49902 23.0947 0.6189 1.45394 0.12284 6.0691 2.05985 6.0691 2.05985l-0.11988-1.81713z'/%3E %3Cpath fill='%23466343' d='m315.478 368.908c-0.4063-2.89252-3.6939-7.0559-5.07045-9.74825-2.01555-3.94783-3.52914-8.2559-3.97972-12.6827-0.97146-9.53625 1.21653-14.6817 7.4929-21.7488 0.0461 2.07166 0.32421 2.79863 0.9496 4.725 2.62618 8.09175 6.30355 14.7798 5.1118 23.5772-0.5876 4.33111-4.12382 10.4976-4.28563 13.1445-0.0827 1.37067 0.69095 2.97993 1.37422 4.13445l-1.59272-1.40138z'/%3E %3Cpath d='m291.921 343.116c-6.73585-11.1974-22.5342-6.17895-32.8872-15.5805-5.0244-4.56319-7.2691-11.4319-8.27185-17.9646-0.29941-1.94528-1.12973-9.6567-0.67677-11.1538 0.0827-0.27815 0.36319-0.34488 0.57933-0.13288 3.43228 3.35552 6.87285 5.52285 10.8466 8.214 9.4388 6.3886 13.3134 12.385 18.1778 22.3476 6.37085 13.0453 12.1447 5.61025 12.2321 14.2701z'/%3E %3Cpath stroke-width='0.45' d='m312.93 328.102s-2.13839 11.2022-1.81477 18.4069c0.33248 7.36065 3.59646 18.5498 3.59646 18.5498h-0.62126s-3.38386-11.1827-3.5935-18.5498c-0.20788-7.2384 2.43307-18.4069 2.43307-18.4069z'/%3E %3Cpath fill='%23658d5c' d='m281.964 336.012c-3.62862-1.15123-7.78551-1.85014-12.2024-2.91413-4.13977-0.99685-7.52065-3.25807-10.6766-6.10215-4.8998-4.4185-6.5197-10.3424-7.4746-16.6978-0.53563-3.56339-0.68091-7.01635-0.44233-10.6222 0.39449 0.69508 0.89469 1.38248 1.54843 1.85138 3.21437 2.30315 6.564 3.91004 9.78365 6.23565 2.81338 2.03268 4.81122 3.37382 7.1185 5.97345 2.91673 3.29114 5.35215 6.84745 7.40375 10.7327 1.61752 3.06615 3.00413 6.66085 5.0953 9.4429z'/%3E %3Cpath fill='%23a48253' d='m282.118 333.911c1.08366 1.44508 5.4567 3.32245 7.04705 3.52559l1.54665 3.85808v-0.00005c-2.27178-2.65837-5.26653-4.17895-8.74741-5.28332z'/%3E %3Ccircle fill='%23d99f31' cx='271.96' cy='304.79' r='4.417'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m272.469 300.875c-0.22364 0.52367-0.35938 1.12912-0.35938 1.78125 0 1.94764 1.15049 3.53125 2.5625 3.53125 0.3918 0 0.76155-0.12675 1.09375-0.34375 0.0919-0.33421 0.14063-0.68228 0.14063-1.04688 0-2.01267-1.49482-3.67002-3.4375-3.92187z'/%3E %3Ccircle fill='none' stroke-width='1.244' cx='271.96' cy='304.79' r='4.719'/%3E %3Cpath d='m285.013 302.83s2.06162-7.676 4.00276-12.4264c4.59036-11.2458 12.5516-11.6687 16.6086-20.5742 2.32264 6.0124 4.17756 13.7427 0.11988 22.4132-4.68366 10.0164-16.6689 15.8941-16.6689 15.8941l-4.06241-5.3067z'/%3E %3Cpath fill='%23466343' d='m305.587 271.848c5.9823 16.3305-1.91634 28.0884-16.4197 36.1966l-3.82027-5.2801c2.49331-10.4876 4.28327-15.6514 12.2958-23.1036 3.16832-2.94626 5.9445-3.90296 7.9441-7.813z'/%3E %3Cpath fill='%23a48253' d='m288.712 255.666c-5.97105 15.6951-7.7362 41.9398-5.6805 54.084 6.424 37.9571 37.5272 73.589 66.2345 79.357 24.7559 4.9748 39.5563 16.1244 49.7504 27.6461 4.76103 5.38405 8.60255 10.6412 11.7644 15.5912 2.72008 4.25846 5.0498 8.9055 7.3376 12.5823 0.36969 0.5935-2.71949 1.87086-3.04606 1.3435-2.4189-3.91004-4.64233-8.84055-7.42855-13.3565-3.17067-5.1372-8.61675-10.3925-13.353-15.9838-10.0784-11.8996-23.4998-20.8424-46.7604-25.4846-27.5032-5.48975-59.512-40.6193-65.9025-78.39-2.07638-12.2705-0.54626-40.7498 4.92106-55.7845l2.16319-1.60454z'/%3E %3Cpath d='m285.719 329.932c-1.23366-1.18169-3.00886-2.30905-4.1941-3.54035-11.0274-11.4449-8.1313-31.4374 3.96319-41.2022 0.41162-0.33013 0.72284-0.17481 0.78071 0.31122 0.48603 4.02814 1.1126 7.81889 2.72835 12.2563 3.68977 10.1344 4.29154 15.9466 0.93839 24.5752-2.04508 5.25945 0.006 9.89825 0.006 9.89825l-4.22245-2.29843z'/%3E %3Cpath stroke-width='0.623' d='m324.604 379.212c-7.0553-2.41241-14.3433-1.76516-20.2104-7.85495-6.77125-7.024-8.237-17.8896-6.4677-24.1642 0.0868-0.30473 0.32362-0.55453 0.51437-0.31949 1.50355 1.84134 2.30079 3.16654 4.27737 4.62343 7.0677 5.21455 15.7447 7.826 18.7405 15.7908 0.59823 1.58445 0.79607 3.24508 1.35355 4.84193 1.90866 5.47145 5.03975 7.1244 9.5746 10.1114l-7.7823-3.02894z'/%3E %3Cpath fill='%23658d5c' d='m330.117 382.116c-6.6012-5.59785-18.4966-3.5876-25.5804-11.1809-5.2016-5.5748-7.3943-14.3664-6.10455-21.9904 6.287 5.60195 13.5974 7.14035 19.3158 13.4298 6.72935 7.40435 0.99921 12.3726 13.6683 19.5774l-1.29922 0.16418z'/%3E %3Cpath d='m294.865 341.944l0.0189-0.17185c1.64055-1.95414 0.50256-7.82365-0.0354-10.1764-0.92776-4.05532-1.04233-7.54135-0.36733-11.671 0.77894-4.76929 3.39036-9.0756 6.06735-13.024 1.19351-1.75866 5.07045-7.2573 5.47265-9.24865 0.0331-0.17008 0.21378-0.15767 0.28878 0.006 1.47815 3.22323 2.25059 7.14745 2.84705 10.6317 0.83268 4.87914 1.0937 9.3136-0.60059 14.8618-1.51535 4.96654-3.55276 8.1809-6.67325 11.5216-1.32047 1.41201-4.42677 4.52422-4.8815 6.2061-0.0827 0.30709-0.61004 2.54587-0.4937 4.18347l-1.64291-3.1187z'/%3E %3Cpath stroke-width='0.948' d='m283.939 277.75s0.20965 0.0313 1.09429-0.56221c0.88405-0.59173 1.95531-1.61102 2.41063-2.88425 0.45414-1.27087 3.64193-11.8618 7.89865-18.417 4.97244-7.65945 10.1362-11.0935 16.3984-16.7144 0.98386 6.0691 1.12737 15.9608-4.00335 23.8984-4.69843 7.26735-16.6122 12.4435-17.9929 12.9832-1.3813 0.53976-3.74823 0.93898-5.10825 2.74489-0.77008 1.01929-1.2998 3.0065-1.2998 3.0065l0.60236-4.05532z'/%3E %3Cpath d='m282.442 278.762s-0.51733-0.0248-1.18583-0.96733c-0.66614-0.94547-1.33642-2.40236-1.33642-3.9 0-3.16594 3.00237-12.642 1.513-19.816-2.84233-13.6914-7.1445-19.1811-7.8065-24.2616-0.26398-2.02677-11.4449 13.8301-8.04565 28.5449 1.68543 7.2927 10.1616 15.4441 11.351 16.5154 1.18996 1.07126 2.81338 2.46023 3.58996 4.60098 0.7996 2.20748 0.62953 4.71909 0.62953 4.71909l1.29094-5.43545z'/%3E %3Cpath d='m289.004 255.212c0.80374-1.96063 2.13248-4.28327 3.36201-5.31085 3.02244-2.5252 11.4904-8.81455 14.3823-13.399 6.4382-10.2071 5.139-22.7788 4.46634-24.968-5.58305 4.85433-10.6784 8.0563-16.3701 16.092-4.96831 7.0134-6.05435 20.7296-6.4364 23.3298-0.41929 2.8376-1.67953 5.9049-1.67953 5.9049l2.2754-1.64882z'/%3E %3Cpath fill='%23658d5c' stroke-width='0.948' d='m283.998 279.97l0.22441-1.97244c1.53189-0.58582 2.89488-2.11181 3.51319-3.59055 2.66811-6.38446 4.2939-12.8746 8.04155-18.7712 4.86496-7.65355 10.076-10.6311 15.3354-14.8352 0.24508 6.76419 1.43681 13.8897-3.94902 22.7546-3.06083 5.0327-11.9805 10.0199-17.5323 12.2102-2.48327 0.98032-4.26024 1.77698-5.63325 4.20473z'/%3E %3Cpath d='m261.115 266.482c8.51105 7.0884 10.9382 10.4026 13.4416 21.3679 0.2935 1.28445 1.92284 6.83445 2.26831 7.5183 0.81968 1.63169 2.51575 2.40413 3.56043 3.74291 0.11398 0.14765 0.39685 3.03603 0.44055 3.41634 0.0266 0.22973-0.15 0.22382-0.28051 0.10571-1.3246-1.21063-2.02027-3.1063-3.56516-4.24016-1.32874-0.97559-5.8181-1.93346-7.7551-2.73248-4.94587-2.04094-8.9805-5.85945-11.8453-10.3317-3.7813-5.90255-4.20886-13.94-3.29941-20.7054 0.20965-1.55315 0.41929-3.42342 0.96969-4.89567 0.0768-0.20315 0.19724-0.1559 0.30059 0.006 2.01673 3.14174 3.31181 4.70493 5.76435 6.74825z'/%3E %3Cpath fill='%23658d5c' d='m279.992 299.389l0.23504 2.0061c-4.04055-5.46735-5.39235-3.85157-10.9778-6.16475-4.8626-2.01142-8.80985-5.7638-11.6356-10.1575-4.2189-6.56105-4.14035-16.2697-2.35866-23.6676 2.26535 4.46575 11.129 8.9451 14.5305 14.5199 2.18799 3.58524 3.54566 7.84605 4.63169 11.8848 0.54212 2.01969 1.15453 6.09155 1.98957 7.76105 0.62244 1.24784 2.50807 2.91556 3.58524 3.81792z'/%3E %3Cpath fill='%23658d5c' d='m295.366 342.052c1.50768-2.30197 0.18661-8.1366-0.29469-10.7776-0.7435-4.08662-0.79724-7.61575-0.13051-11.7402 1.0878-6.74115 5.35455-11.2571 9.12345-16.7203 0.74292-1.07776 1.48406-2.16791 2.06752-3.34252 4.33111 12.192 5.54585 24.6455-3.89291 34.8856-1.42441 1.54548-4.8502 4.52481-5.3758 6.4016-0.28229 1.00512-0.37973 2.07224-0.45886 3.11043l-1.03819-1.81712z'/%3E %3Cpath fill='%23a48253' d='m331.315 385.465s-0.53386 0.84921-3.04016 0.84921l1.24289 1.2192c0.25017-0.0784 0.50714-0.14533 0.77146-0.19993 2.39586-0.4937 3.13346-0.42107 4.69252 0.18306'/%3E %3Cpath fill='%23466343' d='m328.275 386.314c-2.5063 0-10.3441-1.30157-16.6146 0.33662-9.4553 2.47086-13.3588 11.3156-20.4662 14.459 10.797 4.64941 18.6992 3.50492 27.6838-3.68091 3.62005-2.89435 5.92197-8.41799 10.6398-9.89557z'/%3E %3Cpath fill='none' d='m405.404 431.001s0.0992-1.37835 1.68957-1.93052c1.37244-0.47776 2.08288 0.61417 2.08288 0.61417'/%3E %3Cpath fill='%23a48253' stroke-width='0.777' d='m340.475 388.878s-0.84922 0.49488-1.10019 0.7187c-0.57934 0.51909-1.34174 0.90118-1.57796 1.3252l-0.92244-0.0856c0.57343-0.47717 1.17933-1.29331 1.50532-1.69016 0.19134-0.23032 0.004-1.10669 0.004-1.10669l2.09114 0.83858z'/%3E %3Cpath fill='%23658d5c' stroke='none' d='m287.558 255.574c1.69665-4.80414 1.65768-10.1492 2.60787-15.1382 2.00197-10.5166 4.98957-13.9358 12.587-20.9705 2.42067-2.24055 4.89981-3.87047 7.5325-5.86005 0.42638 3.0254 0.62481 5.56475 0.31772 8.60255-1.49469 14.86-7.82365 18.3674-18.4352 27.4554-2.05807 1.76044-2.58898 4.22717-4.60985 5.91085z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m287.961 254.318c0.27697-0.40453 0.54271-0.63839 0.68622-0.57048 0.11457 0.0543 0.12992 0.28878 0.0614 0.61772-0.33308 0.43111-0.70513 0.83918-1.1504 1.21004 0.14646-0.41516 0.27992-0.83445 0.40276-1.25729z'/%3E %3Cpath fill='none' d='m287.558 255.574c1.69665-4.80414 1.65768-10.1492 2.60787-15.1382 2.00197-10.5166 4.98957-13.9358 12.587-20.9705 2.42067-2.24055 4.89981-3.87047 7.5325-5.86005 0.42638 3.0254 0.62481 5.56475 0.31772 8.60255-1.49469 14.86-7.82365 18.3674-18.4352 27.4554-2.05807 1.76044-2.58898 4.22717-4.60985 5.91085z'/%3E %3Cpath stroke='none' d='m288.224 256.116s0.38208-1.16457 0.95728-2.65158c0.5752-1.48642 0.42757 0.39862 0.42757 0.39862l-0.33839 1.61989-1.04645 0.63307z'/%3E %3Cpath fill='%23658d5c' stroke='none' d='m282.056 278.96l-0.77658 2.49331c-0.43582-3.24449-1.80236-4.69016-4.13976-6.8061-10.1805-9.21025-14.5305-20.0504-10.2596-32.7248 1.49527-4.43032 2.93445-6.874 6.08385-10.33 1.98897 3.40807 2.95275 5.44665 4.3311 9.1447 3.49252 9.38445 4.88563 14.69 3.50079 25.4392-0.49016 3.79724-2.31083 8.42125 0.20965 11.7974 0.27579 0.36732 0.61004 0.79724 1.05059 0.98622z'/%3E %3Cpath fill='none' d='m282.056 278.96l-0.77658 2.49331c-0.43582-3.24449-1.80236-4.69016-4.13976-6.8061-10.1805-9.21025-14.5305-20.0504-10.2596-32.7248 1.49527-4.43032 2.93445-6.874 6.08385-10.33 1.98897 3.40807 2.95275 5.44665 4.3311 9.1447 3.49252 9.38445 4.88563 14.69 3.50079 25.4392-0.49016 3.79724-2.31083 8.42125 0.20965 11.7974 0.27579 0.36732 0.61004 0.79724 1.05059 0.98622z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m281.765 284.471s0.24567-2.46437-0.13642-3.96319c-0.18898-0.74586-0.68326-1.84607-0.68326-1.84607s1.2248 0.62303 1.50531 0.5687c0.28051-0.052-0.68563 5.24055-0.68563 5.24055z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m285.922 260.331c-0.58701 0.23917-2.39173-2.30433-2.61142-4.02579-0.20729-1.63642-0.87874-0.95315-0.79961 0.34666 0.14765 2.41712 3.0378 5.0061 2.63741 6.5427 0.5439-1.32048 0.80079-2.2754 0.77362-2.86359z'/%3E %3Cpath fill='none' stroke-width='0.777' d='m285.922 260.331c-0.58701 0.23917-2.39173-2.30433-2.61142-4.02579-0.20729-1.63642-0.87874-0.95315-0.79961 0.34666 0.14765 2.41712 2.72835 4.56614 2.32796 6.1004'/%3E %3Ccircle fill='%23d99f31' stroke='none' cx='281.443' cy='253.512' r='4.416'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m281.706 253.088c-1.19646-0.83918-1.72146-2.15492-1.17107-2.94213 0.54981-0.78484 1.96595-0.74291 3.16418 0.0957 1.19764 0.83858 1.72086 2.15492 1.17106 2.93976-0.5498 0.78662-1.96594 0.7435-3.16417-0.0933z'/%3E %3Ccircle fill='none' stroke-width='1.315' cx='281.402' cy='253.639' r='4.607'/%3E %3Ccircle fill='%23d99f31' stroke='none' cx='303.963' cy='344.419' r='4.572'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m303.43 343.97c-0.97559-1.34291-1.00866-2.98169-0.0744-3.65846 0.93425-0.67855 2.48149-0.14114 3.45709 1.20236 0.97323 1.34173 1.00866 2.97933 0.0744 3.65906-0.93425 0.67854-2.48091 0.14114-3.45709-1.20296z'/%3E %3Ccircle fill='none' stroke-width='1.4' cx='303.963' cy='344.419' r='4.805'/%3E %3Cpath fill='none' d='m406.8 432.551s0.0502-1.39134 1.69016-1.77756c1.49527-0.35079 2.08228 0.92539 2.08228 0.92539m7.22835 15.6142c-2.98818 0.61713-4.81535-3.13287-3.78957-4.05531 0.67087-0.60177 2.32323-0.47303 3.53563 0.1187 2.16792 1.05708 1.58623 3.6626 0.25394 3.93661z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m417.799 447.313c-2.48149 0.6313-4.43091-2.70118-3.7872-3.43583 0.5935-0.67737 1.8496-0.71221 3.0626-0.12343 2.16791 1.05945 2.04271 3.225 0.7246 3.55926z'/%3E %3Cpath fill='none' d='m417.799 447.313c-2.48149 0.6313-4.43091-2.70118-3.7872-3.43583 0.5935-0.67737 1.8496-0.71221 3.0626-0.12343 2.16791 1.05945 2.04271 3.225 0.7246 3.55926z'/%3E %3Cpath stroke-width='0.45' d='m287.438 256.177c3.1435-9.15885 4.89567-15.5976 10.1008-24.5445 3.54035-6.08385 10.4834-14.6941 10.4834-14.6941s-6.5386 8.83465-9.9307 14.9598c-4.79469 8.66045-5.8701 12.3874-9.69685 23.4579l-0.9567 0.82087z'/%3E %3Cpath stroke-width='0.45' d='m272.549 235.821s-1.14803 14.387 0.66023 23.2943c1.62579 8.00195 7.27325 19.6317 7.27325 19.6317s0.31595 0.23445-1.3187-4.07599c-1.67953-4.42677-3.82027-9.32305-5.18029-15.5811-1.93052-8.88426-1.43446-23.2689-1.43446-23.2689z'/%3E %3Cpath stroke-width='0.45' d='m259.099 273.201s1.90394 4.97953 3.53622 7.95475c4.48052 8.17205 8.3256 12.4476 15.9726 17.7732l0.22441-0.6874c-7.37305-5.23465-10.8402-9.414-15.5788-17.0858-1.83721-2.97756-4.15453-7.95475-4.15453-7.95475z'/%3E %3Cpath stroke-width='0.45' d='m286.481 276.543s9.1565-8.45435 13.8384-15.0656c4.13799-5.84645 9.10275-16.21 9.10275-16.21s-4.53426 10.4918-8.55 16.3736c-4.51004 6.60355-13.1516 14.902-13.1516 14.902h-1.23957z'/%3E %3Cpath stroke-width='0.45' d='m295.454 342.794c1.74212-4.19646 4.36241-9.975 6.3183-16.6317 2.45433-8.35275 3.91122-12.4228 4.19232-21.9278-0.14114 9.49075-1.15275 12.7718-3.1624 20.6776-1.71083 6.7299-4.05295 12.6366-5.7951 16.8307l-1.55315 1.05118z'/%3E %3Cpath stroke-width='0.45' d='m290.24 300.668s6.89705-6.0313 9.97915-11.4296c4.06063-7.11615 4.7439-12.828 4.7439-12.828s-0.0661 5.7431-4.12559 12.8581c-3.08091 5.4006-10.3234 12.2882-10.3234 12.2882l-0.27402-0.88878z'/%3E %3Cpath stroke-width='0.45' d='m282.38 334.885s-5.9504-3.77008-9.2126-6.5191c-12.6573-10.6618-20.5866-25.0323-20.5866-25.0323s7.24665 15.1736 20.1212 25.653c3.42224 2.78445 9.67795 6.67325 9.67795 6.67325v-0.77481z'/%3E %3Cpath fill='none' d='m283.201 336.413s-1.13977-0.48661-0.54626-1.57205'/%3E %3Cpath stroke-width='0.45' d='m328.64 379.995c-5.58545-3.51083-13.4445-8.74135-20.527-16.0164-2.42481-2.49212-5.91495-6.6691-5.91495-6.6691s2.8317 4.42028 5.14075 6.8244c6.3142 6.57165 14.987 12.7382 20.5724 16.2496l0.72874-0.38858z'/%3E %3Cpath stroke-width='0.45' d='m347.968 386.704s-10.5059-7.5366-15.2315-14.1142c-2.57126-3.57579-3.81909-5.78505-5.55885-9.8321 2.08878 4.05532 3.50493 6.25395 6.33485 9.8321 4.73209 5.98525 14.4555 13.184 14.4555 13.184v0.93012z'/%3E %3Cpath stroke-width='0.45' d='m295.95 400.21c15.4476-2.14725 21.4565-11.1726 34.614-13.2224-1.38662 0.0726-1.13327-0.47126-2.39351-0.20551-11.6026 2.44783-18.6974 11.2246-32.2205 13.428z'/%3E %3Ccircle fill='%23d99f31' stroke='none' cx='314.799' cy='382.209' r='4.572'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m319.287 381.34c-0.0402 0.14823-0.0998 0.29173-0.17775 0.42756-0.67087 1.16102-2.5063 1.35354-4.09902 0.43405-1.59449-0.92007-2.34449-2.60551-1.67303-3.76653 0.19074-0.33071 0.47716-0.58287 0.825-0.75295 0.20846-0.0289 0.42047-0.0443 0.6372-0.0443 2.22697 0 4.0813 1.5939 4.4876 3.70216z'/%3E %3Ccircle fill='none' stroke-width='1.399' cx='314.799' cy='382.209' r='4.805'/%3E %3Cpath fill='%23a48253' stroke='none' d='m330.798 384.331s0.42933 0.24331 0.6933 0.54213c0.26576 0.29941 0.36379 0.6561 0.18071 0.88405 0 0 0.10571 0.2622 0.44823 0.51083 0.45886 0.33425 1.063 0.30768 1.72972 0.41161 0.84922 0.137 1.44509 0.25335 2.04686 0.42992 0.60472 0.17657 1.36239 0.49016 1.36239 0.49016l-3.42579-1.7067-3.03543-1.56201z'/%3E %3Cpath stroke-width='0.45' d='m297.758 357.549s-8.52695-2.23583-19.4214-6.3012c-10.8951-4.06772-18.2368-10.872-18.2368-10.872s7.34175 6.18365 18.2368 10.2508c10.8945 4.06772 19.4214 5.99235 19.4214 5.99235v0.93012z'/%3E %3Ccircle fill='%23d99f31' stroke-width='1.244' cx='334.687' cy='394.974' r='4.882'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m338.153 397.954c-1.46103 0.55394-3.39153-0.39626-4.47638-2.27598-1.17107-2.02678-0.91418-4.36654 0.57283-5.22695l0.0638-0.0349c0.12283-0.009 0.24626-0.0154 0.37145-0.0154 2.52461 0 4.57205 2.04685 4.57205 4.57441 0 1.1374-0.41574 2.17795-1.10374 2.97874z'/%3E %3Ccircle fill='none' cx='334.683' cy='394.974' r='4.572'/%3E %3Cpath fill='%23a48253' stroke='none' d='m289.595 332.55s0.5191 1.58859 0.92422 2.57657c0.30059 0.73347 0.83622 1.85197 0.83622 1.85197s-1.11851 0.23918-1.11851 0.11457c0-0.1252-0.87225-4.52422-0.87225-4.52422l0.23032-0.0189z'/%3E %3Cpath fill='%23658d5c' stroke='none' d='m289.006 333.474c-1.65118-2.52874-5.162-5.34215-7.14685-7.40375-3.41339-3.54449-5.5317-7.6063-6.31005-12.4914-1.83779-11.5464 1.52008-19.3116 9.9455-27.117 0.53209 8.1 5.1638 14.8152 6.1441 22.904 1.40551 11.6026-5.97755 13.7894-0.84922 25.1445l-1.78346-1.03642z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m287.887 331.17s0.0986 0.50079 0.2374 1.12086c0.32894 0.39803 0.62657 0.79429 0.88051 1.18229l1.4622 0.8498-0.7813-2.66693-1.79882-0.48602z'/%3E %3Cpath fill='none' d='m289.006 333.474c-1.65118-2.52874-5.162-5.34215-7.14685-7.40375-3.41339-3.54449-5.5317-7.6063-6.31005-12.4914-1.83779-11.5464 1.52008-19.3116 9.9455-27.117 0.53209 8.1 5.1638 14.8152 6.1441 22.904 1.40551 11.6026-5.97755 13.7894-0.84922 25.1445'/%3E %3Cpath stroke-width='0.45' d='m288.996 331.076c-3.35552-5.04745-4.01162-7.5142-5.4301-12.7158-2.66811-9.7689-2.68465-21.6325-0.17421-25.966-2.51044 4.33346-3.02717 16.1368-0.60001 25.9748 1.36654 5.5435 2.45374 8.43605 5.56475 13.5414l0.63957-0.83445z'/%3E %3Cpath fill='none' d='m288.588 332.886c-0.81968-0.95729 0.22855-2.52933 1.17107-1.14213'/%3E %3C/g%3E %3Cg id='oak' fill='%23000' stroke='%23000' stroke-width='0.933' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='0.777' d='m514.668 257.68c-0.013-0.0437 0.0135-0.23032 0.039-0.26752 0 0 0.297-0.43405 0.6-1.14626 0.30705-0.7246 0.61415-1.72146 0.6313-2.83464l1.65885 0.34133c-1.3825 4.93878-1.4386 6.6892-1.4386 6.6892-0.013 0.41575-0.48365 0.47953-0.6065 0.0833l-0.88405-2.86535z'/%3E %3Cpath d='m519.124 275.312c1.32345-0.86811 1.7675-3.11044 1.8502-4.56142 0.14765-2.60374-2.02205-4.90866-2.13425-7.32105-0.0709-1.54725 1.26615-1.7067 1.5195-2.91319 0.2244-1.07776-3.96145-4.85611-2.8317-7.83365 0.80785-2.12835 2.50395-1.08189 3.15175-3.30768 0.6827-2.35689-1.435-5.7248 1.2874-7.30925 1.32225-0.77008 3.264 0.35078 3.8392-1.7126 0.5858-2.09941 0.11985-6.2705 3.1435-6.56515 4.0116-0.39272 4.6317 7.8195 5.3693 8.39645 0.76595 0.6 1.79175-0.5002 2.88425-0.0667 2.94625 1.17343-0.20785 6.60885-1.22125 8.42185 7.47285 0.30532 0.63955 4.95237-0.50845 7.0181 0.3177 0.75414 2.2299 1.03407 2.5435 2.1821 0.2055 0.7559-0.36145 1.42028-0.88465 1.88326-1.67365 1.47816-4.1711 2.03269-5.9882 3.22855l-0.24925 0.17894c-0.062 0.68268 1.8313 2.68228-0.72045 3.52972-4.76515 1.58623-7.7988 2.62618-9.63605 7.43921-0.4943 1.29153-0.66675 5.25529-0.75825 4.84843l-0.65615-5.53585z'/%3E %3Cpath fill='%23658d5c' d='m519.848 279.074l-0.82795-3.63779c0.2238-0.12107 0.41455-0.30177 0.59765-0.47599 0.96965-0.93189 1.43265-3.50905 1.50765-4.80236 0.16185-2.80926-1.87735-4.42028-1.9789-6.75651-0.052-1.2124 1.2939-1.64645 1.5112-2.79448 0.27635-1.46162-3.7559-4.99548-2.6988-7.75926 0.7187-1.87263 2.4602-0.90531 3.16415-3.34488 0.6124-2.12598-1.2248-5.91735 1.07305-7.19055 1.3878-0.76595 3.38445 0.46535 4.0553-1.99311 0.50845-1.85847 0.11635-5.0309 2.7431-5.2943 3.57105-0.35728 4.1067 6.81435 5.03505 7.5266 1.02995 0.78897 1.84785-0.23504 2.8382 0.15177 1.4929 0.58287 1.125 2.64272 0.78895 3.83032-0.38855 1.38071-1.0612 2.51929-1.63225 3.80197-0.11165 0.25571-0.114 0.49606 0.1872 0.61063 0.9384 0.35492 1.73975 0.20492 2.06575 1.43621 0.4423 1.67186-2.126 3.49843-2.6947 4.82363-0.4429 1.0317 1.29155 1.29331 1.51715 2.65985 0.32185 1.92874-6.15175 4.09016-6.64785 4.99547-0.0579 1.26437 1.62165 2.57244-0.4193 3.25571-5.1266 1.71733-10.2449 4.94587-10.1846 10.9571z'/%3E %3Cpath stroke-width='0.45' d='m519.398 275.86s6.52795-11.6226 8.41535-19.8744c1.30395-5.7118 1.87915-14.9581 1.87915-14.9581s-0.2829 9.2132-1.4138 14.9398c-1.7232 8.7059-8.4697 20.987-8.4697 20.987l-0.411-1.09429z'/%3E %3Cpath stroke-width='0.777' d='m519.608 286.898c-0.008-0.0478 0.048-0.23032 0.0809-0.26575 0 0 1.275-1.34114 2.0327-2.19863 0.29525-0.33248 0.4795-0.73523 0.58995-1.06299 0.1057-0.31772 0.1388-0.5504 0.1388-0.5504 0.0295-0.20551 0.20785-0.31771 0.4051-0.25098l2.1697 0.71634c0.29705 0.0974 0.336 0.36732 0.0809 0.54803-0.014 0.008-1.66775 1.17933-2.26535 1.8939-1.3205 1.57382-1.66715 2.16909-2.19865 3.79311-0.1246 0.37559-0.5362 0.34665-0.6-0.046l-0.43405-2.57658z'/%3E %3Cpath fill='%23a48253' stroke-width='0.777' d='m520.348 289.424c0.54565-1.67008 0.91535-2.29902 2.25475-3.89587 0.6313-0.75177 2.32555-1.94941 2.32555-1.94941l-2.17025-0.71634s-0.14115 1.02519-0.80315 1.77756c-0.76005 0.85925-2.04095 2.20689-2.04095 2.20689l0.43405 2.57716z'/%3E %3Cpath d='m511.694 247.35s2.726 5.43365 5.07225 13.7888c4.8378 17.2506 5.46495 39.649 3.3803 51.9685-6.4075 37.8674-40.6624 73.2755-68.315 78.796-23.1928 4.62815-36.8734 14.5134-46.5945 25.236-7.5579 8.73485-10.4794 13.9424-17.3333 27.9054-2.10945 4.29803-9.01535 5.14135-6.04605-0.90945 5.37345-9.49075 10.477-18.2569 18.3484-27.5882 10.2336-11.5654 24.9366-22.9098 49.7652-27.8994 28.549-5.7366 61.442-41.0841 67.85-78.9495 2.08405-12.3189 1.44215-39.1695-5.5193-56.443l-0.60825-5.9049'/%3E %3Cpath stroke-width='0.846' d='m497.255 240.334s-8.04805-0.30532-4.17756-6.401c-3.68327-1.81063-8.1242-5.0935-3.37205-7.80295-0.21319-0.92363-3.02244-1.81063-2.81103-3.98859 0.12284-1.25197 1.7067-1.8248 1.8437-2.36279-0.52323-0.98622-4.19587-5.7012-2.92323-7.10905 1.95355-2.15965 6.17481 0.44173 8.09706 1.60098 0.47834-0.2935 1.18642-0.88878 1.66181-1.20472 2.80512-1.85847 2.99173 2.63681 3.75945 4.07362 0.35315 0.65847 2.56712-1.125 4.06182-0.33425 2.58485 1.36654 1.4433 4.70315 2.09295 6.9555 0.6472-0.0703 1.57795-0.59764 2.22575-0.64134 4.19-0.28051 1.9205 7.0949 1.74155 9.414 6.66085-0.96082 1.5372 5.8736 1.9063 11.7437 0.10215 1.62166-0.4004 5.20335-1.6506 3.82678-3.9425-4.34174-14.8996-3.15414-12.4559-7.7699z'/%3E %3Cpath stroke-width='0.977' d='m496.324 264.527c-1.44154-0.11634-4.56851-0.55866-5.18505-1.9252-0.97382-2.16792 1.55905-2.9126 1.43445-3.07678-0.88642-1.17992-4.99488-1.93523-5.0179-3.58819-0.0165-1.16043 1.92284-1.99075 1.57973-3.04783-0.46949-1.44685-3.23682-3.64843-2.16378-5.2571 1.30039-1.94528 4.03465 0.6685 5.35275 0.65197 0.62716-0.008 1.51417-1.39725 2.71594-1.41851 1.76929-0.029 2.84705 3.41339 3.51556 3.32008 0.73937-0.10157 1.19173-1.11732 1.91872-1.33464 2.21695-0.66733 2.85 1.72972 3.37205 3.29055 1.0317 3.08563 2.1443-0.57697 3.812 0.14941 4.21475 1.83957 2.47915 10.0931 3.70215 11.084 0.73645 0.59528 2.11715 0.52087 2.6593 1.36181 1.1545 1.7941-0.42935 5.4189 0.45885 8.664 0.35965 1.3128 4.4557 5.1248 4.4557 5.1248s0.636 3.81792 0.5315 3.6189c-1.8455-3.55098-2.24645-4.3937-5.55-6.9183-3.1748-2.4248-7.9996-0.50197-9.1128-1.77283-1.2378-1.41614 0.1931-2.70827-0.45-3.32835-0.2457-0.23504-3.97265 0.15118-4.5331 0.0951-2.64922-0.26575-5.0805-2.67638-3.49607-5.6929z'/%3E %3Cpath fill='%23658d5c' stroke-width='0.977' d='m518.514 278.198l0.42755 2.37697c-6.7955-9.72105-12.3414-5.85945-13.7988-7.4392-1.10905-1.20237 0.30475-2.06811-0.6-3.01063-0.9573-0.99863-6.66911 1.11496-8.36576-3.32008-0.35315-0.92244 0.90708-2.44607 0.26988-2.57067-1.44508-0.28288-3.39272-0.24272-4.38485-1.55079-0.41338-0.54626-0.7689-1.2939-0.22854-1.88386 0.28051-0.30473 0.61063-0.56398 0.84449-0.91063 0.88288-1.3128-4.48642-2.32559-4.50295-4.27973-0.0106-1.11968 1.46161-1.52421 0.92185-2.90256-0.47126-1.20649-2.10118-3.20374-1.2691-4.51654 1.00925-1.58976 3.27225 0.41162 4.53308 0.55689 0.6189 0.0709 1.66949-1.3872 2.69114-1.41614 1.62579-0.0479 2.3191 2.97284 3.56221 2.85059 1.2124-0.11988 2.5896-2.00551 3.91655-0.36732 0.9242 1.14212 0.90295 4.47697 3.0685 3.51083 0.51735-0.23032 1.2874-0.86162 1.86675-0.61004 3.46535 1.49882 2.5807 7.0677 3.4423 10.0305 0.463 1.59035 2.11595 1.23957 2.7077 2.22342 0.2864 0.47776 0.5256 1.03051 0.57285 1.59036 0.042 0.48012-0.0325 0.95374-0.0974 1.42677-0.2681 1.92047-0.0874 3.64606 0.401 5.52755 0.3856 1.49882 2.4933 4.27677 4.02165 4.68425z'/%3E %3Cpath d='m520.088 307.84l0.34015-0.27992c1.19825-0.0213 2.0268-2.49804 2.3876-3.44527 1.5012-3.93426-1.19585-10.4622 3.34725-10.4416 0.2321-1.62757 0.56515-5.625 2.0451-6.69036 1.0736-0.77362 2.12595 0.19961 3.15175-0.1057 0.76005-1.53189 1.12145-4.43918 3.30355-4.84784 0.69155-0.12874 2.1431 0.99449 2.38405 0.87225 0.5953-0.29882 1.3016-3.41811 3.04785-3.88937 1.07715-0.29055 2.0929 0.82205 2.48505 0.57106 0.63955-0.40925 1.25845-1.07775 1.78995-1.64468 2.27775-2.43307 5.1177-2.475 5.04155 0.77067-0.027 1.1563-0.76655 2.78858-1.17935 3.84331-0.1417 0.35728 1.4321 1.1061 1.67125 1.56555 0.80555 1.53425-2.02615 3.35551-2.6598 4.56378 0.0435 0.20373 1.4994 0.49428 1.7167 0.79901 1.88565 2.63741-3.57105 5.52755-4.95175 7.14865-0.5439 0.63779 1.3246 2.0563 1.06535 3.16063-1.0441 4.42854-7.86495 2.79863-9.375 3.48602-0.525 0.24095-0.68505 2.61201-1.12915 3.21437-1.92045 2.59548-9.5262-0.57519-11.2536 1.05059-1.5738 1.48229-2.09705 4.00926-3.09805 5.8116-0.2161 0.39213-0.63365 0.27166-0.5982-0.1376l0.4677-5.3752z'/%3E %3Cpath fill='%23658d5c' d='m520.538 308.03c1.4079-0.0685 2.28605-2.63268 2.7112-3.74764 0.55455-1.45335 0.802-2.90256 0.8581-4.45158 0.0851-2.25059-1.5242-6.20434 1.97005-5.6687 0 0 0.73705-5.2754 2.24825-6.49194 0.98505-0.79134 2.7437-0.34252 3.1689-0.6567 1.0075-0.74291 0.61715-3.95965 2.79035-4.37067 0.84155-0.16004 2.351 0.67264 2.99235 0.35315 0.8037-0.4004 1.0919-2.81398 2.6303-3.22441 0.962-0.25571 2.2364 0.78248 2.8636 0.39036 1.3246-0.82677 2.33325-3.44292 4.2065-2.91733 2.11415 0.59174 1.3683 3.80138 0.8309 5.11595-0.38445 0.94075 0.68505 1.2815 1.06475 1.97244 0.71045 1.29744-1.6506 3.35906-1.94525 4.50354-0.11225 0.4252 0.9283 0.9443 1.18935 1.22303 1.57205 1.67953-2.4768 4.64882-3.56455 5.57716-0.32425 0.27578-1.02815 0.82795-1.06715 1.27086-0.0832 0.94193 0.9319 1.62933 0.6703 2.77796-0.8888 3.89882-6.316 2.74901-8.44845 3.46122-0.85985 0.28582-0.98445 2.03209-1.51595 2.76142-1.7061 2.34212-9.18605 0.0791-11.1933 1.9122-1.2 1.09607-2.16795 2.9817-2.82995 4.45808l0.3697-4.24843z'/%3E %3Cpath stroke-width='0.45' d='m521.658 307.028c0.2362-0.0661 9.06675-7.0949 14.0268-12.4831 4.0618-4.41201 9.4577-12.121 9.4577-12.121s-5.3315 7.86085-9.3018 12.4305c-5.0203 5.77855-13.9447 13.5024-14.1809 13.5691-0.2368 0.0661-0.23915-1.32933 0-1.39548z'/%3E %3Cpath d='m523.694 284.444c-2.07815-1.20827-1.7693-7.67365 1.27085-10.6075 2.5559-2.4691 9.7063 4.8 7.487 7.8065-1.22715 1.66359-6.5675 4.07421-8.7579 2.80099z'/%3E %3Cpath d='m532.498 280.529c-1.28565 1.05708-4.27145-0.32362-5.7868-1.83898-1.38895-1.39134-2.23285-3.51968-1.4014-4.50177 1.6376-1.94351 6.2014-4.73386 8.3941-2.8943 2.1821 1.82953-0.0415 8.27835-1.2059 9.23505z'/%3E %3Cpath fill='%23a48253' d='m532.078 281.366c-1.16695 1.58031-6.2622 3.61713-8.1496 2.52047-1.6423-0.95492-1.6234-6.8374 1.35825-9.71695 1.88095-1.81476 8.8925 4.35178 6.79135 7.19645z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m533.248 271.806c1.8189 1.52657 0.0584 7.45455-1.0488 8.3634-0.9402 0.77481-3.6124-0.25925-5.1614-1.80768-1.4073-1.41024-2.07815-3.3809-1.5319-4.02815 1.68365-1.99606 5.9238-4.05354 7.74215-2.52756z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m531.891 271.844c-0.52735 0.5568-0.875 1.50977-0.875 2.59375 0 1.68392 0.8431 3.05749 1.89065 3.10937 0.14395-0.45772 0.27745-0.94121 0.375-1.4375 0.1685-0.85662 0.2537-1.73033 0.1875-2.4375-0.0662-0.70716-0.28955-1.21091-0.57815-1.45312-0.005-0.005-0.01-0.0111-0.0155-0.0156-0.2463-0.20005-0.57355-0.31783-0.96875-0.35938-0.005-0.0005-0.011 0.00049-0.0155 0z'/%3E %3Cpath stroke-width='0.863' d='m493.752 286.796c-0.58111-1.79174-3.34311-3.02717-3.63308-5.18445-0.1311-0.98032 0.94252-2.64744 0.85276-2.938-0.47717-1.55728-3.07441-3.56516-1.7439-5.50215 1.71732-2.50216 4.16279 0.0809 6.19845 0.67264 0.33366-0.12697 0.44586-1.24606 1.24134-1.45748 3.11634-0.82854 5.8299 4.23367 6.64845 4.54075 2.41655 0.91595 4.3122-3.35964 5.6262 5.98405 1.03405-0.24743 2.4396-0.50256 3.0632 0.56044 2.5701 4.40374 1.0695 13.8927 6.2055 16.4422l0.16655 0.33661c-0.0703 0.37323-0.2368 3.17836-0.99035 2.26359-1.29805-1.57382-2.3197-3.8126-4.5803-4.20886-2.38585-0.41752-12.8032 3.35138-13.0831-1.38071-0.0331-0.55866 0.72284-1.3252 0.47304-1.86733-0.59529-1.30334-6.85336-0.84685-7.51006-4.34528-0.25689-1.37244 0.70807-2.62264 1.06535-3.91594z'/%3E %3Cpath fill='%23658d5c' stroke-width='0.863' d='m517.578 301.936c-3.8309-5.9445-5.5441-3.70216-11.3616-3.26398-1.32695 0.0992-5.8016 0.28642-5.72245-1.95414 0.023-0.63779 0.5067-0.80551 0.10985-1.57382-0.84511-1.64468-6.08803-1.3435-6.87698-4.38898-0.40866-1.57618 0.45709-3.70039 0.23681-4.29449-0.7311-1.97834-3.98622-3.82854-3.0189-6.41989 0.12874-0.34429 0.31949-0.66202 0.38209-1.0317 0.19488-1.1439-2.14311-3.76418-1.10256-5.45255 1.20886-1.96359 3.31949-0.4128 4.92697 0.31536 1.15039 0.52205 0.85925-0.49607 1.61988-0.74705 1.32815-0.44055 2.98347 0.82854 3.87229 1.67953 0.4984 0.47953 2.074 2.35925 2.475 2.54586 0.93835 0.43583 2.53285-0.0602 3.62125 0.32185 0.97735 0.34488 1.63995 4.44921 1.7876 5.49565l0.18895 0.13111c0.89055-0.19312 2.20275-0.18485 2.73665 0.68326 2.4289 3.96142 1.2354 13.4191 6.44645 16.2904l-0.3213 1.66359z'/%3E %3Cpath stroke-width='0.45' d='m517.278 301.663s-6.9183-11.4426-12.89-17.4284c-3.80965-3.81615-10.6412-8.82875-10.6412-8.82875s6.89587 5.2305 10.6412 9.26045c5.44845 5.8612 11.4951 16.9966 11.4951 16.9966h1.3949z'/%3E %3Cpath d='m509.884 319.282c0.30885 0.14704 0.96675 0.0325 1.37835 0.14291 3.0484 0.83268-1.314 9.67206-1.5614 11.6126-0.0644 0.51733 0.2675 2.18918 0.235 2.30079l-0.66495 3.76241c-0.1181 0.39035 0.0726-3.74351-0.52735-4.77343-1.0624-1.82717-4.4138-0.84095-6.13525-1.1067-2.84648-0.43819-0.6254-2.87126-1.86085-3.36555-2.04095-0.81614-6.2994 0.34902-6.8061-2.68878-0.18898-1.13386 0.55866-2.34685 0.48189-3.31595-1.46339-1.69429-5.22225-2.07224-4.7876-5.04745 0.14941-1.03169 1.65413-2.12657 1.61338-2.79508-0.052-0.80964-3.15-3.0815-2.41122-4.73563 0.45296-1.01102 1.32697-1.01516 1.40965-1.60512 0.0874-0.61063-2.51162-4.51181-0.32599-5.56655 2.62264-1.26496 4.78878 1.6937 6.67795 1.8313 0.9567 0.0703 1.80237-1.49527 3.24922-1.17342 1.52657 0.34074 1.69667 2.38583 2.39232 3.52146 0.67445 0.0248 1.33705-0.69744 2.08645-0.77422 3.19725-0.33484 2.70295 4.7876 3.5256 6.5504 0.0998 0.21437 1.0612-0.36732 1.45745-0.21142 0.6685 0.25926 0.91595 1.00453 1.0128 1.65709 0.2811 1.91811-0.7429 3.96968-0.43935 5.7803z'/%3E %3Cpath d='m530.144 326.956c0.6006 6.0378-7.58505 0.0909-12.0862 2.48976-1.3429 0.71339-4.48465 3.1187-4.2561 2.54115l1.13325-2.85296c0.37385-0.31594 1.58035-0.32008 2.00435-0.51319 0.9756-0.44409 2.31025-1.98838 3.2055-3.66437 1.2396-2.32323 0.3945-4.94941 1.14805-6.6567 1.1545-2.61024 2.961-0.21023 3.73935-0.77421 1.44095-1.04469 1.68425-6.32245 5.20395-6.37675 0.92715-0.0147 0.90885 0.16417 1.5508 0.47362 0.7323-1.06713 0.9691-2.37933 2.39175-2.82343 1.02755-0.32185 1.7291 0.59351 2.6787 0.58465 0.68095-0.53327 3.3201-4.95532 5.4827-4.43623 2.4319 0.58288 0.96615 4.90808 0.7831 6.4925 0.2681 0.29469 0.60415 0.28819 1.0299 0.85748 1.67365 2.23996-0.949 4.6317-1.8502 6.3951 0.23685 0.52914 0.9136 0.49784 1.06125 1.17048 0.6 2.73484-4.5945 3.07146-5.1301 3.80256 0 0.25276 0.3998 0.54508 0.3549 1.1185-0.26395 3.34902-8.025 2.45434-8.4449 2.17206z'/%3E %3Cpath d='m477.587 346.87c0.15355-1.14449-2.24055-2.88012-1.23543-4.45217 0.81554-1.27441 2.67815-0.61595 3.42756-1.27205 0.64606-2.02677-0.42697-4.75926 2.38642-5.3888 1.42795-0.31712 2.21279 1.12972 2.67579 2.23052 0.17421 0.40866 0.80787 2.93563 1.05295 3.02303 0.52736 0.18898 1.92461-0.80964 2.62441-0.71044 1.90571 0.27461 0.40276 3.84095 0.98209 4.84843 0.40689 0.70808 1.42205 0.14941 2.07047 0.37205 1.92224 0.66024 0.42933 3.85926 0.42933 5.2258 0 0.83682 1.38484 1.09193 1.49941 2.5122 0.20138 2.54587-1.95 2.82167-3.17304 4.46634-0.17007 0.23033-0.21141 0.34252-0.0183 0.57698 2.1071 2.56889 0.91359 3.82087-1.4185 5.51695-2.74665 1.99489-6.9762 3.26575-5.42305 7.5307 0 0-1.38897 2.85059-1.53838 1.90217-0.22028-1.39548 0.45649-2.81989 0.0703-4.3376-0.41339-1.61929-5.3634-3.74764-5.56065-5.4939-0.14115-1.2313 1.2874-1.41614 1.3996-2.52461 0.12933-1.26024-4.2939-2.42363-3.77657-4.92107 0.27992-1.35 1.71909-1.74626 2.34803-2.83642-0.10157-1.06063-5.03505-4.82894-0.70334-5.8116 0.54567-0.12461 1.41319-0.11634 1.8809-0.4565z'/%3E %3Cpath fill='%23658d5c' d='m481.75 372.916c0.1683-1.22953 0.31771-2.89075 0.004-4.09666-0.45236-1.74449-4.29626-3.93898-4.46634-5.4508-0.10985-0.96319 0.6254-1.21476 0.77893-2.4189 0.20788-1.62283-3.78898-2.66161-3.31594-4.89567 0.28819-1.36831 1.99783-2.02205 1.83543-3.23681-0.0892-0.67677-2.11358-2.34863-1.68189-4.08662 0.35079-1.40551 1.875-0.84508 2.75906-1.55256 0.97027-0.77303-1.90158-3.1311-0.98563-4.54961 0.72638-1.12677 2.71358-0.63306 3.27638-1.43031 0.58346-0.82441-0.46713-4.26674 2.3002-4.90867 2.18917-0.50669 2.63504 4.19174 3.56339 4.875 0.87815 0.64843 1.27677-0.5126 2.65099-0.32598 1.35413 0.18484 0.31004 3.49252 0.84566 4.48937 0.57874 1.0813 1.49883 0.22205 2.43544 0.5563 1.51122 0.53977 0.0206 3.74587 0.0206 4.86083 0 1.16457 1.2313 1.1628 1.34114 2.54115 0.17893 2.24054-1.95178 2.80748-3.07914 4.18819-0.31181 0.37972-0.33898 0.73287 0.007 1.10492 2.02855 2.18563 0.59764 3.49842-1.3748 4.92283-3.06437 2.21516-6.66495 3.43996-5.12185 7.90215l-1.79233 1.51181z'/%3E %3Cpath d='m531.058 337.065c1.5242-0.39213 3.61715-1.87854 5.08935-0.70335 2.79035 2.22933-2.0699 6.13345-2.96695 8.22225-0.017 0.76181 1.5526 1.02107 1.4504 2.55532-0.17835 2.69764-3.77185 2.12244-5.462 3.08563-0.13345 0.48602 0.6183 0.90708 0.6183 1.3872 0 3.81851-5.76555 2.37697-7.9642 3.09154-0.6998 0.22618 0.47955 2.24823-2.02085 3.1937-1.07955 0.4063-2.6244-0.0213-3.7187-0.21437-1.3264-0.23445-2.67815-0.50847-4.03405-0.43406-0.55865 0.0313-1.1315 0.17835-1.69255 0.12933-0.24035-0.0213-0.41275-0.1376-0.32185-0.40925l6.3-18.5852c0.13465-0.39862 2.87185 0.6378 3.4819 0.6378 0.67855 0 1.3453-1.42441 1.8189-1.8567 1.6441-1.50118 2.4378 0.6313 3.81025 0.63957 1.0004 0.004 3.81615-5.589 5.612-0.73937z'/%3E %3Cpath stroke-width='0.777' d='m499.83 340.094c-0.049-0.78544-1.62933 1.60453-1.62933 1.60453s1.12323 1.1067 1.88745 1.76279c0.9425 0.81201 2.5228 1.95355 2.5228 1.95355l0.1518-1.17697s-2.79276-1.95177-2.93272-4.1439z'/%3E %3Cpath d='m498.153 332.518c0.42815 0.6059 0.16004 1.42441-0.13288 2.03209-0.32126 0.67086-0.51023 1.07185-0.94901 1.65531-1.43681 1.90394-4.62756 3.60414-6.0685 2.61615-1.3122-0.89941-3.99508-8.7809-1.89567-10.1386 1.99666-1.29213 7.17755 1.1876 9.04605 3.83504z'/%3E %3Cpath d='m490.57 336.029c0.62303-0.94311 1.53307-1.65945 2.42185-2.33622 1.26378-0.96733 4.47992-2.67815 5.9002-1.30748 1.86262 1.79941 2.75967 7.23955 0.59586 9.12875-2.85059 2.49212-7.464-0.37737-9.26045-2.84409-0.6183-0.84862-0.17008-1.86496 0.34252-2.64095z'/%3E %3Cpath fill='%23a48253' d='m493.292 334.184c1.94764-1.44685 4.16044-2.25059 4.99725-1.37008 2.24647 2.3693 2.35927 6.90355 0.7996 8.22815-1.57145 1.33346-5.224 1.22716-8.3758-2.75493-0.66496-0.84094 0.6124-2.64153 2.57894-4.10315z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m497.646 332.256c1.05237 1.93523-4.68839 7.33345-6.60295 6.0549-1.32874-0.88465-3.13937-7.67835-1.83544-8.85415 1.84193-1.663 7.5242 1.11732 8.4384 2.79921z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m490.641 329.5c-0.47064 0.0306-0.83673 0.15553-1.0625 0.35937-0.0285 0.0258-0.067 0.11921-0.10937 0.23438 0.78185 0.38655 2.17713 0.73662 3.60937 1.375 2.04575 0.91048 3.46033 2.10899 4.0625 1.76562 0.0958-0.33218 0.10073-0.59098 0.0312-0.71875-0.14553-0.26775-0.62961-0.74254-1.28125-1.1875-0.65163-0.44495-1.46835-0.8852-2.3125-1.21875-0.84414-0.33355-1.71393-0.56172-2.4375-0.60937-0.18089-0.0119-0.34311-0.0102-0.5 0z'/%3E %3Cpath fill='%23466343' d='m512.038 356.94c2.87125-0.13878 5.61675 1.13622 7.35235 0.50905 2.58485-0.93012 1.0069-2.94212 2.25295-3.05433 1.24605-0.11456 7.53305 0.34666 7.5266-2.78209 0-0.60236-0.5067-0.8374-0.2805-1.51594 0.22615-0.67913 4.9565-0.45059 5.1266-2.97756 0.10745-1.61102-1.36005-1.62933-1.13385-2.60551 0.22615-0.9756 5.2925-5.76851 2.7679-7.75275-1.7386-1.36654-4.5868 1.01929-4.85495 0.32184-0.35075-0.90944-0.4293-1.67007-1.58205-1.77755-1.66715-0.15355-2.67405 2.4998-3.76185 2.4998-1.09015 0-1.5862-1.09016-2.7035-0.99036-1.46165 0.12874-1.6819 2.36103-2.928 2.36103-1.24545 0-3.18895-0.69154-3.18895-0.69154l-6.2994 18.5846s1.03995-0.0974 1.7067-0.12874z'/%3E %3Cpath fill='none' stroke-width='0.623' d='m515.124 349.614s5.91555-2.24055 9.39095-4.26674c3.32245-1.93701 7.99785-5.71655 7.99785-5.71655m-17.3888 9.98325s5.91555-1.92932 9.39095-3.95551c3.32245-1.93937 7.99785-6.02775 7.99785-6.02775'/%3E %3Cpath stroke-width='0.777' d='m477.297 379.028s2.34213-0.56752 3.28111-0.56752c0.93779 0 1.49232 0.45472 1.49232 0.45472l1.06536-1.95767s-3.18544 0.37795-4.12973 0.29291l-1.70905 1.77756z'/%3E %3Cpath fill='none' d='m463.168 400.047c-1.86024-2.26949 4.31102-8.15435 6.6071-6.489 1.64468 1.1941 3.7122 6.3142 2.07461 7.8425-1.82776 1.7002-7.20295 0.45236-8.6817-1.35354z'/%3E %3Cpath stroke-width='0.777' d='m460.324 392.568l-0.68563-0.0472c-1.20414-1.50177-1.64233-1.56142-3.40689-2.04331-0.56102-0.15355-0.63956-0.74528-0.0337-0.90709l2.13484-0.56043c0.33839-0.088 1.2437 0.72047 1.50059 0.91122 0.40748 0.30295 2.47914 0.74705 1.71969 1.48051l-1.22895 1.16635z'/%3E %3Cpath fill='none' d='m459.855 391.228c0.87165-1.31221 6.28465-1.62402 9.44115 1.15807 1.94114 1.71378 0.37972 4.13031-1.46162 5.68935-1.82303 1.54489-4.58267 2.81988-5.71654 1.82894-3.21615-2.81339-3.31182-7.09845-2.263-8.6764z'/%3E %3Cpath fill='%23658d5c' d='m513.108 333.132s2.61675-2.72422 4.7256-3.78485c4.0925-2.06161 10.7433 1.25611 11.7313-0.61063 0.50435-0.95079-0.2569-1.64646 0.37795-1.8998 0.63365-0.25335 7.89035 1.18582 8.17855-2.09528 0.0543-0.59114-0.7553-0.88996-0.1264-1.52185 0.63075-0.63071 5.2134-0.93779 4.75455-3.10394-0.1447-0.6933-1.1421-0.88878-0.8864-1.58208 0.25335-0.69567 3.6874-3.95965 2.22165-5.96105-0.42755-0.58406-1.5071-0.46949-1.4268-1.18347 0.2557-2.21752 1.0016-5.64565-0.8303-5.8246-1.9683-0.19075-4.2685 3.81201-5.0368 3.96615-0.95375 0.19075-1.52185-0.74941-2.475-0.4441-1.5827 0.50611-1.83545 2.85059-2.47085 2.85059-0.6331 0-0.58525-0.65433-1.60335-0.63366-3.1081 0.065-3.3691 5.0516-4.9246 6.27695-0.88645 0.69744-1.40965-0.24271-2.2837-0.062-2.1537 0.44174-1.5183 5.82755-2.65985 7.54135-1.1427 1.7126-3.61295 3.73878-4.11965 3.99449-0.50905 0.25335-1.50535 0.25099-1.50535 0.25099l-1.64055 3.82677z'/%3E %3Cpath fill='%23a48253' stroke-width='0.777' d='m455.154 389.994s1.97244 0.6626 3.28051 0.73346c0.87992 0.0478 2.2565-0.12637 2.2565-0.12637s-0.54095 0.11398-1.125-0.29942c-0.19075-0.13523-1.54252-1.33287-1.54252-1.33287l-2.86949 1.02519z'/%3E %3Cpath fill='%23a48253' d='m460.398 391.64c1.45335-1.64705 5.66045-1.47048 8.7455 1.25019 1.53189 1.35118 0.51909 3.3815-1.30158 4.98899-1.83366 1.61752-4.16339 2.5187-4.95236 1.83071-3.0815-2.69469-3.55867-6.8616-2.49154-8.06991z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m463.517 399.896c-0.69095-0.78897 0.41338-3.20787 1.88327-4.53248 1.30216-1.1752 3.42224-1.97835 3.88051-1.48643 1.79882 1.93111 3.64016 5.36695 2.21221 7.06951-1.43327 1.70905-6.4187 0.72874-7.976-1.05059z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m469.062 394.484c-0.0464 0.006-0.0943 0.0215-0.14063 0.0312-1.49232 0.31772-2.33885 2.27882-1.89062 4.39063 0.2006 0.94383 0.62976 1.76231 1.17187 2.34375 0.002 0.002 0.0133-0.002 0.0156 0 1.29582 0.1 2.43774-0.15348 2.85938-0.65625 0.52391-0.62469 0.48832-1.6812 0.0156-2.90625-0.43676-1.13192-1.24009-2.30607-2.03125-3.20313z'/%3E %3Cpath fill='%23a48253' stroke-width='0.777' d='m515.848 260.454s0.052-1.77107 1.4492-6.7624c0.24275-0.86988 0.90295-1.35177 0.90295-1.35177l-2.6061-0.35728s0.6644 0.6313 0.6526 1.45512c-0.033 2.33031-1.28505 4.15098-1.28505 4.15098l0.8864 2.86536z'/%3E %3Cpath fill='%23658d5c' stroke-width='0.846' d='m512.958 255.114s-1.6943-4.95237-3.14175-6.75885c-1.53185-1.91693-2.63265-2.3191-5.41475-3.20788-2.4608-0.7872-6.30416-1.42027-6.46596-3.34901-0.16358-1.92874 0.0626-1.56378-0.63897-1.74863-2.25886-0.5935-5.0829-1.34055-4.54311-3.57756 0.53976-2.23819 1.37244-2.58661 0.40512-3.0561-1.42855-0.68918-5.18505-2.87599-4.73623-4.78997 0.44646-1.91634 2.11772-1.94173 1.41378-3.11693-0.5061-0.84035-2.31732-1.76279-2.17205-3.29468 0.10039-1.04469 1.42264-1.38307 1.38307-2.31319-0.0395-0.93189-3.58996-5.064-1.50118-6.78955 1.90394-1.57145 5.26595 1.2378 6.1252 1.59271 0.86162 0.35492 1.85197-1.4681 3.11221-1.1687 1.61988 0.38623 1.70492 2.81103 2.18209 3.67088 0.87401 1.56732 2.66223-0.47185 4.06123 0.27992 2.3321 1.25433 1.5201 5.56655 2.1496 6.43879 0.6266 0.87166 2.3498-0.52145 3.57285 0.15119 1.90215 1.05059 0.2746 7.34645 0.3986 8.37995 0.12465 1.03701 1.5077 0.14586 2.2967 0.76063 2.10115 1.63583-0.4565 6.6-0.052 10.7882 0.1394 1.44744 0.48605 3.69568 0.48605 3.69568l1.0795 7.41319z'/%3E %3Cpath d='m496.894 399.126c0.66082 1.13504 1.86083 1.91811 2.41653 3.08504 0.78544 1.64055 0.0502 3.30768-1.93051 3.18543-0.85748-0.0526-1.64646-0.71456-2.46851-0.7813-0.66496-0.0514-2.56653 2.49154-4.41024 2.40886-2.51279-0.11043-3.71043-3.17657-5.2429-4.74449-1.22067-0.25748-2.11772 1.54075-3.47362 1.29567-2.78622-0.50256-2.65158-4.92461-3.613-6.87225-0.76771-0.57106-1.92874 0.63721-3.47362-0.45531-2.3876-1.68544-1.1374-6.98445-3.69804-8.46675-2.25472-1.3063-7.02345-0.44055-6.60885-0.65788l2.65807-1.3813c0.16595-0.0874 0.67441 0.15591 0.84036 0.18898 4.3565 0.86752 10.187 0.15354 14.6528 0.15354 2.14075 0 1.79646 1.72973 2.14075 2.08288l0.17244 0.0265c2.22342 0.15413 4.87736-0.008 6.77305 1.39311 2.29429 1.70315 0.12283 3.225 0.11457 3.60709l0.10334 0.0496 0.48544 0.16417 1.49764 0.43996c1.16043 0.37205 2.46023 0.88642 3.23858 1.875 1.13445 1.44095-0.13878 2.11359-0.17421 3.40335z'/%3E %3Cpath fill='%23466343' d='m467.191 386.192c0.96142 0.60827 13.7864 0.20374 15.5084 0.20374 1.86201 0 1.25374 1.47165 1.88918 2.02618 0.77244 0.35079 9.57995 0.0585 7.5744 3.38682-0.23032 0.38209-0.53209 0.72697-0.72638 1.12736l0.0449 0.36969c0.89941 0.74527 4.02224 0.80374 5.3817 2.5559 0.81023 1.04645-1.33642 2.72598-0.41693 3.38858 1.76516 1.26851 5.7118 6.9142-1.45158 5.2193-1.72323-0.40866-3.76358 4.39607-7.5118 0.0963-0.45472-0.52323-1.51122-2.04803-1.94586-2.34862-1.04646-0.72284-2.37874 0.95728-3.6626 0.74764-2.36044-0.38859-2.50748-4.52835-3.35729-6.26455-1.17106-0.81792-2.15079 0.1559-3.54803-0.83091-3.16831-2.23583 0.71456-9.9077-9.5368-8.7614l1.75866-0.91594z'/%3E %3Cpath stroke-width='0.45' d='m466.256 386.406s9.65435 1.95531 15.2008 4.7504c5.09055 2.56653 11.9197 8.46319 11.9197 8.46319s-6.6567-6.26635-11.7644-8.92795c-5.2866-2.75315-14.5819-4.59508-14.5819-4.59508l-0.77422 0.30946z'/%3E %3Cpath d='m491.113 376.212c2.50394 2.31909-1.28268 10.0447-4.1256 9.56105-4.53012-0.77185-7.0181-5.8884-6.16475-8.0687 0.91181-2.33563 7.58505-3.99685 10.2904-1.49232z'/%3E %3Cpath fill='none' d='m486.598 384.988c-1.28031-0.91831-0.78839-4.16929 0.34488-6.13345 1.03819-1.79882 2.51457-2.92795 3.6437-2.57481 3.2126 1.00276 6.33305 5.22816 5.1307 7.80235-1.1811 2.53701-7.8443 1.81713-9.1193 0.90591z'/%3E %3Cpath fill='%23a48253' d='m490.902 376.44c2.3002 2.12953-1.35177 9.14585-3.86161 8.7183-4.31752-0.73523-5.87245-5.1809-5.3492-7.0116 0.53799-1.89153 6.6567-4.07185 9.21085-1.7067z'/%3E %3Cpath d='m505.924 381.749c-0.411 0.5439-1.275 1.55492-2.1762 1.54665-3.84331-0.0366-3.5752-3.31772-5.5937-5.49745-0.67677-0.16417-1.17697 0.63307-2.49981 0.33189-1.73386-0.39685-1.83956-4.81476-4.43681-5.7177-1.3128-0.45531-4.9689-0.47421-6.9992 1.43209l3.63308-2.82756c3.51141 1.37834 6.67559-6.09625 10.6972-5.10355 1.14212 0.28169 1.17933 1.02756 2.50039 0.91122 2.93565-0.25984 5.92145-2.18622 9.45475-1.01988 2.1142 0.69803-0.63305 3.52972 2.0398 3.2061 1.7191-0.20964 4.2809-0.20138 4.7917 1.93524 0.28055 1.17283-0.3242 1.70433-0.19545 2.55354 0.34665 0.27047 6.79845 2.51457 3.38445 4.24193 0.54035 1.51654 3.13345 2.5317 1.761 4.38957-1.2874 1.74626-4.0299-0.19075-4.79055 0.5315-0.31295 0.30118-0.30055 1.13622-0.57635 1.4811-1.138 1.41319-4.1327-1.45807-5.4112-1.72854-1.2685 4.31102-3.5693 2.28012-5.58305-0.66614z'/%3E %3Cpath fill='%23658d5c' d='m491.454 372.425c2.66634 0.75118 2.73898 4.86437 4.27559 5.2488 1.53603 0.38386 1.49646-0.42579 2.45847-0.20374 0.88878 0.20374 1.78583 5.3882 6.08326 4.85256 1.0943-0.13701 1.64295-1.30039 1.64295-1.30039s1.57145 2.57716 3.2238 2.80925c2.37815 0.33425 1.69725-1.8059 2.3008-1.87677 0.96615-0.11162 2.7425 1.9376 4.5183 1.9376 1.0004 0 0.8575-1.7067 1.91395-1.7067 1.0571 0 3.14355 1.00689 4.00335-0.23091 1.12325-1.61516-1.4929-3.50905-1.68365-4.08602-0.1931-0.5752 0.7435-0.59174 0.6455-1.14803-0.3638-2.05335-3.69805-2.3817-3.98685-3.1063-0.28815-0.72224 0.46535-1.46811 0.1831-2.59311-0.47715-1.91457-3.1937-1.9813-4.42265-1.70906-2.84645 0.63367-0.26575-2.40236-2.2943-3.25747-3.4925-1.47284-8.57305 1.31634-9.8705 0.77008-0.87226-0.36733-1.20474-0.47599-1.95001-0.6065-3.14587-0.54626-6.04605 4.04292-8.03325 5.0002l0.99212 1.2065z'/%3E %3Cpath stroke-width='0.45' d='m490.467 370.994s9.64847-0.59409 15.3107 1.37658c4.89805 1.70433 11.3634 6.9118 11.3634 6.9118s-6.96615-5.1242-12.1482-6.62955c-5.57482-1.61752-14.8666-0.73111-14.8666-0.73111l0.34075-0.92775z'/%3E %3Cpath stroke-width='0.45' d='m481.945 371.67s1.84547-12.28 1.68602-20.172c-0.0957-4.74449-1.00098-12.1228-1.00098-12.1228s1.26909 7.6488 1.46634 12.5888c0.29232 7.3376-1.37717 18.7754-1.37717 18.7754l-0.77421 0.93071z'/%3E %3Cpath d='m472.62 371.22c0.17657 0.525 1.9624 1.04233 1.8 3.0313-0.19488 2.43721-3.86811 1.68838-5.5766 2.83405-0.64607 0.43583 0.76535 2.52875 0.0248 3.52146-1.32697 1.77107-5.83465 0.71457-6.1624 1.15394-0.60472 0.81024 1.46929 3.04016-0.71634 4.26969-3.03838 1.70846-9.4518-0.99331-12.9106 2.07165-0.20374 0.18307-1.54901 1.69429-1.60098 1.70906-1.97717 0.52086-7.22185 1.60275-6.60885 1.34527 3.07677-1.2998 8.025-2.56653 8.99235-4.68189 0.82677-1.80236 0.20137-5.2057 0.53976-7.15335 0.50256-2.91083 2.64095-1.73976 3.34489-2.66398 0.56929-0.74705-0.48958-4.80413 1.81063-6.71635 1.61575-1.34114 3.34961-0.41987 4.82539-1.48287 1.54252-1.10847-0.78897-4.81477 2.25886-5.8695 1.83189-0.63307 3.73583 1.41201 4.15099 1.32225 1.13976-0.24449 2.47441-3.67737 4.78583-3.21556 2.30256 0.45827 1.275 3.4943 1.17697 4.89981 3.85984 0.47953 1.77106 3.34961-0.13465 5.625z'/%3E %3Cpath fill='%23658d5c' d='m441.417 390.864s8.2075-3.42993 8.87775-5.1514c1.03228-2.63918-0.0933-6.63605 1.3435-7.59095 0.93662-0.62481 1.875-0.31181 2.48977-1.2 0.61594-0.88878-0.18307-5.1951 2.03445-6.93485 1.38897-1.08839 2.64094-0.1128 4.33346-1.30217 1.82303-1.28563-0.48012-4.45984 2.3067-5.50395 1.64055-0.61476 3.28937 1.39311 4.10728 1.17933 1.57146-0.40925 2.40178-3.53622 4.7067-3.20197 1.85374 0.26811 0.94665 2.15552 0.82854 3.94075-0.0685 1.02579 1.54016 0.54981 2.01851 1.98721 0.35078 1.04645-1.08012 3.29468-2.03741 4.13209-0.54626 0.47716 1.66359 1.31575 1.53071 2.80216-0.1931 2.13662-4.31515 2.28603-5.27184 2.62855-1.23544 0.44055-0.12107 2.28661-0.95965 3.36201-1.34114 1.71909-4.77934 0.65197-5.39235 1.47224-0.56044 0.74941 0.68563 2.67993-0.89233 3.86398-1.63996 1.22953-8.01495 0.45059-9.049 0.83268-3.07264 1.1315-5.5748 2.31083-5.5748 2.31083l-5.39999 2.37343z'/%3E %3Cpath stroke-width='0.45' d='m450.209 386.042s8.97225-6.45295 13.5608-12.2232c2.53051-3.18307 5.8736-8.0185 5.8736-8.0185s-3.23681 5.0138-5.7201 8.32795c-4.52835 6.0437-13.5662 12.9496-13.5662 12.9496l-0.14823-1.03583z'/%3E %3Cpath stroke-width='0.45' d='m517.264 328.63c3.4488-1.86437 9.71105-5.09115 14.8252-9.7565 3.43995-3.13937 7.9252-8.93445 7.9252-8.93445s-4.45395 6.0939-7.9252 9.3992c-5.2199 4.97126-11.8412 8.51105-15.2906 10.3754l0.46535-1.08366z'/%3E %3Cpath fill='%23466343' d='m509.938 333.264l-0.79135 2.63268c0-3.63603-0.1435-5.3675-4.4492-5.139-0.66735 0.0331-1.35415 0.10748-2.01675 0.004-2.188-0.34252-0.50195-1.65708-1.19765-2.65807-0.85155-1.22067-6.6112-0.12401-7.0819-3.01063-0.18071-1.11673 1.06417-2.44606 0.15118-3.32245-1.38248-1.32401-4.82599-2.47205-4.45808-4.8998 0.15355-0.99863 1.49114-1.72323 1.29803-2.65335-0.25807-1.23957-2.73307-3.39508-2.12835-4.75689 0.4813-1.08603 1.36418-0.73523 1.44744-1.76043 0.0951-1.14449-1.90807-4.00099-0.12283-4.8691 2.35453-1.14449 3.94902 1.09016 5.9693 1.25433 1.17165 0.0951 1.96653-1.30039 3.18957-1.02756 1.58209 0.35078 1.59214 2.89783 2.60969 3.41929 0.3738 0.18898 1.49465-0.76004 2.02205-0.82027 2.83405-0.3254 2.1909 5.17205 3.1559 6.45945 0.35075 0.46535 1.0984 0.002 1.6051 0.16004 1.77345 0.55216-0.1264 6.5628 0.60475 7.36655 0.2486 0.27402 1.1498 0.12047 1.54425 0.23032 1.48055 0.41574 0.44645 4.23779 0.202 5.17675-0.5504 2.10768-2.45435 6.24745-1.55315 8.214z'/%3E %3Cpath stroke-width='0.45' d='m509.828 332.84s-2.74665-10.9352-6.64605-16.8118c-3.22856-4.86674-10.3028-10.8674-10.3028-10.8674s6.76715 6.04605 9.83742 10.8674c3.76415 5.90905 6.33305 16.8118 6.33305 16.8118h0.77835z'/%3E %3Cpath stroke-width='0.45' d='m515.794 275.694s-6.4925-10.546-12.0738-16.0311c-4.55554-4.48111-12.9827-9.9933-12.9827-9.9933s8.0309 5.6705 12.362 10.1658c5.2943 5.4933 11.455 15.8586 11.455 15.8586h1.23955z'/%3E %3Cpath fill='%23a48253' d='m512.964 250.457c1.0819 2.70827 2.6327 6.89585 3.66435 10.8059 4.8402 18.336 5.2866 39.5244 3.2144 51.7665-6.3809 37.7061-40.6642 72.7855-68.103 78.263-23.2966 4.6506-37.0666 14.7455-46.8461 25.5348-4.63642 5.1136-8.3386 10.2148-11.204 15.0774-2.84233 4.81949-4.7067 8.9516-7.22955 13.1038-0.0295 0.0147-0.0744 0.0336-0.14114 0.0561-0.17008 0.0608-0.39686 0.11397-0.65788 0.16417-0.55453 0.10394-1.25669 0.18484-1.92283 0.21201-0.67914 0.029-1.2815 0.002-1.64469-0.0874l-0.0868-0.0231c0.35492-0.54981 0.70807-1.08544 1.05472-1.65473 2.40591-3.96555 4.49705-7.8313 7.24785-12.4246 2.74252-4.57618 5.9864-9.4057 10.4008-14.3953 10.1758-11.5028 24.6378-22.6294 49.3536-27.5964 28.7722-5.7827 61.6275-41.4632 68.062-79.4835 2.0947-12.3809 2.04925-33.7606-5.8181-56.926l0.6561-2.39232z'/%3E %3Cpath stroke-width='0.45' d='m511.844 248.246c-2.38585-6.0815-4.06535-9.424-7.5201-14.9676-4.46281-7.1616-13.5278-16.8809-13.5278-16.8809s8.57715 9.75885 12.7967 16.8514c4.464 7.50415 6.50905 12.1216 9.07145 20.4685l-0.82025-5.47145z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m513.234 254.084s-0.36555-0.90945-0.55455-1.50768c-0.39445-1.23957-0.7122-3.26162-0.7122-3.26162s0.5882 1.41615 0.98035 2.34863c0.34425 0.82205 0.89465 2.45197 0.89465 2.45197l-0.60825-0.0313z'/%3E %3Cpath d='m514.378 317.002c-1.77755-1.47638-6.6508-5.9693-6.6508-8.26595 0-2.73602 2.55475-2.26535 3.1689-2.66575-0.10985-1.10847-3.85805-3.84567-2.35455-6.3124 0.9904-1.62756 3.24335-1.17107 4.0778-1.83484 0.63775-1.74449-1.83725-6.27051 0.14705-8.72481 1.17575-1.45393 2.0852-0.36791 2.6374-0.50019 0.1104-0.76477 0.0874-1.5437 0.1742-2.30906 0.15-1.35354 0.64015-2.69764 2.21395-2.77795 2.20275-0.11457 3.6998 2.71299 4.74865 4.26614 0.23385-0.13464 1.38245-0.29645 1.6252-0.41693 2.71005-1.3252 1.72735 7.0819 1.80415 8.37815 0.6313-0.0213 1.91275-0.37382 2.4732-0.046 2.90255 1.71261-2.86535 10.7179-3.4795 12.8363-0.25575 0.88051 3.04545 0.17244 0.5102 3.37146-1.47815 1.86674-3.36375 3.51909-4.99545 5.25119l-6.1004-0.24922z'/%3E %3Cpath fill='%23658d5c' d='m515.298 323.974c1.10255-2.90493 0.71045-5.7366-1.4805-7.32285-2.34625-1.69902-5.475-5.7325-5.47085-8.0687 0.007-2.76142 2.75075-1.07953 2.87775-2.38524 0.0957-0.97441-3.6065-3.89587-2.28665-6.0425 0.85985-1.39547 3.15005-1.23366 3.72935-1.93346 0.9638-1.16457-1.42615-6.3307 0.46535-8.7366 1.03995-1.32284 1.8461 0.0833 2.5394-0.40512 0.67085-0.4754-0.40515-4.42441 2.14075-4.53898 2.45255-0.10984 4.2561 4.00335 4.6488 3.87638 0.7931-0.25512 1.73565-1.08366 2.62855-0.23622 0.8699 0.82441 0.59825 7.8443 0.59825 7.8443s1.6671-0.16181 2.20095 0.16594c2.21695 1.36418-1.76515 9.3331-2.8866 11.5176-0.9567 1.86437 1.84605 2.09882 0.40925 4.01339-2.36455 3.15414-7.09015 6.939-7.8378 11.5796'/%3E %3Cpath stroke-width='0.45' d='m518.028 321.924s1.7752-11.4201 2.2671-17.446c0.4028-4.94115-0.69565-13.0742-0.69565-13.0742s0.63365 7.82365 0.2309 12.7654c-0.4919 6.02365-3.1376 20.3563-3.1376 20.3563l1.33525-2.60138z'/%3E %3Cpath d='m492.06 364.365c0.9939-2.55413-1.93347-10.0435 0.27578-11.3551 1.26261-0.75177 2.05985 0.66024 3.28938-0.55039 1.57145-1.55315-0.88701-7.40195 1.98661-9.25216 1.66949-1.07362 2.99175 0.47362 4.59925-0.98444 1.0671-0.97146 1.11435-4.88563 3.82675-5.5642 1.8024-0.45059 2.63035 0.77657 4.2272 0.99685 1.3535 0.18425 5.9486-6.2191 8.8051-4.68898 2.9923 1.60512 0.3431 5.00255-0.25925 7.27794-0.3154 1.18996 2.23225 1.02166 1.9931 3.01418-0.21735 1.82126-2.3002 3.64666-2.302 4.4126 0 0.81437 2.10535 1.36831 2.19035 2.89252 0.16775 2.96279-4.60745 3.37973-6.212 4.64056-0.8415 0.66023 1.0831 2.78858-0.1045 4.74862-1.25845 2.08229-6.61715 0.62067-7.5077 1.06712-0.7246 0.36555-0.017 3.89529-0.9201 5.14666-1.4675 2.03563-8.46496 0.12519-11.0563 0.54862-3.4689 0.5687-4.98543 1.27913-7.16695 3.87047l4.33524-6.22085z'/%3E %3Cpath fill='%23658d5c' d='m487.657 368.456s2.73426-1.41614 3.71929-2.99587c0.9691-1.55965 1.09429-2.11949 1.0565-4.58445-0.0231-1.49705-1.32697-6.64845 0.14114-7.4687 1.2065-0.67264 1.875 0.64606 3.37854-0.77422 1.83307-1.73149-0.85571-7.7238 1.75453-9.34195 1.57382-0.97559 2.99532 0.75 4.81477-0.87815 1.24135-1.11023 1.02935-4.84606 3.47365-5.4579 1.5319-0.38445 2.7508 0.80965 4.2 1.00453 1.77165 0.23859 5.80985-5.6516 8.34035-4.27323 1.10905 0.60473 1.4374 1.45335 1.23365 2.67048-0.2197 1.31161-0.9632 2.47086-1.24725 3.75177-0.36555 1.65059 1.86615 1.50532 1.6648 3.24745-0.189 1.65413-2.1514 3.24094-2.1514 4.31457 0 1.17519 1.7693 1.93878 1.88385 3.38445 0.21555 2.74016-5.51515 2.79449-5.97815 4.29744-0.45885 1.48937 0.6561 2.60611-0.42755 4.36241-1.17105 1.89449-5.20335 0.2185-6.77895 0.86161-1.31515 0.53386-0.5191 3.50493-1.31635 4.69548-2.201 3.28228-12.8504-1.32756-17.2252 4.68602l-0.53622-1.50177z'/%3E %3Cpath stroke-width='0.45' d='m487.976 368.836s11.3226-9.63605 17.5347-16.7746c4.78405-5.4933 11.2458-14.9162 11.2458-14.9162s-6.0319 9.5386-10.6252 15.072c-5.6114 6.75885-15.9916 15.8652-15.9916 15.8652l-2.16378 0.75354z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m486.963 369.091l1.85611-0.5374s-0.68091 0.79902-0.95492 1.04645c-0.23269 0.20729-0.84272 0.77776-0.84272 0.77776l-0.0585-1.28681z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m486.87 384.764c-0.91772-0.65846-0.68091-3.67087 0.47716-5.67875 1.05059-1.8189 2.67875-2.70118 3.35375-2.38583 2.4809 1.16457 5.5872 5.0622 4.59625 7.18585-0.98386 2.10768-7.2124 1.74626-8.42714 0.87874z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m491.359 377.719c-0.27752 0.11743-0.53145 0.27483-0.73437 0.5-1.02107 1.13386-0.54262 3.2262 1.0625 4.67187 0.81629 0.73435 1.76736 1.15884 2.64062 1.25 0.003-0.002 0.0122 0.002 0.0156 0 0.22095-0.15174 0.37483-0.31663 0.45313-0.48437 0.34923-0.74843-0.0269-2.09591-0.9375-3.40625-0.67849-0.9763-1.6093-1.90396-2.5-2.53125z'/%3E %3Cpath d='m516.644 254.586c-2.35455-0.8126-3.9638-5.16615-2.98405-9.02775 0.97205-3.82323 10.7309-2.26594 9.6803 2.28779-0.8303 3.5941-4.69845 7.42915-6.69625 6.73995z'/%3E %3Cpath d='m523.074 246.464c-0.34725 2.29252-3.3673 2.54823-4.76515 2.26299-1.487-0.29882-4.29215-1.87854-3.9638-3.77657 0.6957-4.02815 3.94725-7.13385 5.8636-6.8309 2.0953 0.33189 3.42405 4.65295 2.86535 8.3445z'/%3E %3Cpath fill='%23a48253' d='m516.848 253.845c-1.98305-0.30709-3.53385-4.39961-2.58485-8.1325 0.8888-3.50315 9.23325-1.288 8.475 1.99489-0.82795 3.58995-3.95255 6.43639-5.89015 6.13759z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m520.134 238.734c1.62815 0.25689 3.3555 3.92598 2.7886 7.65945-0.27165 1.80355-3.08505 1.70433-4.52245 1.41378-1.54845-0.31418-4.15455-1.35-3.9071-2.77796 0.6874-3.98267 4.14215-6.53444 5.64095-6.29529z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m519.859 239.266c-0.0739 0.006-0.1556 0.0246-0.25 0.0468 0.10145 0.65378 0.5141 1.61433 0.7031 2.71875 0.251 1.46339 0.21925 3.85023 1.2344 3.67188 0.62925-0.11081 0.8995-0.61025 0.9062-1.57813-0.0004-0.005 0-0.0104 0-0.0156-0.0844-0.96678-0.30585-1.87923-0.60935-2.64062-0.5278-1.32405-1.34795-2.13229-1.79685-2.20313-0.0485-0.008-0.11365-0.006-0.1875 0z'/%3E %3Cpath fill='none' d='m382.268 446.704c-0.77008-1.13445 0.99212-4.61634 4.68189-4.19646 1.61752 0.18484 0.83504 2.52638-1.17284 3.92835-1.40787 0.98032-2.73838 1.40315-3.50905 0.26811z'/%3E %3Cpath fill='%23a48253' d='m382.268 446.704c-0.77008-1.13445 0.35079-3.57166 4.06358-3.72934 1.33288-0.0585 1.45335 2.05926-0.55453 3.46123-1.40787 0.98031-2.73838 1.40314-3.50905 0.2681z'/%3E %3Cpath fill='none' d='m394.916 431s-0.0998-1.37894-1.69016-1.93052c-1.37067-0.47834-2.23819 0.61418-2.23819 0.61418m2.37756 3.17716s-0.0502-1.39134-1.68838-1.77756c-1.49469-0.35079-2.08465 0.92599-2.08465 0.92599'/%3E %3C/g%3E %3Cg id='motto' fill='%23000'%3E %3Cpath fill='%23fff' d='m401.704 427.164c7.68955-0.0904 13.4716-0.82146 20.0468-2.11949-1.55138 5.27305-4.65296 15.3042 7.7445 15.3042 9.02125 0 18.5976-5.4254 27.897-0.65374 20.3108 10.4168 35.6463 2.97756 48.0443-10.9695 0 0-9.16657 1.95768-18.5977 1.54901 0 0 7.06535-6.02125 7.74865-13.9488-6.1996 4.64882-12.3998 5.32795-18.6012 5.32795-6.19605 0-10.1598-3.74409-18.2764-5.0244 0.45708-2.80512 0.94724-5.6622 1.67834-9.6012 0.79666-4.30039-0.38858-7.79055-6.6443-8.5258-13.614-1.59803-26.8004 6.2551-50.892 6.63305-24.2563-0.37795-40.8821-8.2311-54.4985-6.63305-6.2557 0.73524-7.44095 4.2254-6.6437 8.5258 0.73051 3.93898 1.22067 6.79605 1.67481 9.6012-8.1136 1.28032-12.078 5.0244-18.2734 5.0244-6.20435 0-12.4016-0.67913-18.6018-5.32795 0.68327 7.92755 7.7492 13.9488 7.7492 13.9488-9.4305 0.40866-18.5982-1.54901-18.5982-1.54901 12.3998 13.947 27.734 21.3862 48.0449 10.9695 9.2994-4.77166 18.8758 0.65374 27.897 0.65374 12.3974 0 9.29585-10.0311 7.7451-15.3042 7.03585 1.38898 14.824 2.15374 23.3534 2.15374l0.003-0.0342z'/%3E %3Cpath d='m337.705 427.301c-0.90118 0.41693-1.36417-0.1624-0.34843-0.6815 0.72048-0.36968 3.83032-1.72381 6.07916-2.16555 0.0874-0.0165 0.17008 0.0437 0.18248 0.13288l0.0815 0.6c0.0124 0.0768-0.0502 0.16004-0.12637 0.17244-2.11595 0.37618-5.1124 1.59036-5.8683 1.94174zm0.519 2.946c-0.90118 0.41693-1.36594-0.16181-0.34843-0.6809 0.71812-0.36792 3.98622-1.97481 6.23681-2.41713 0.0626-0.0124 0.15235 0.0372 0.1748 0.0974l0.22618 0.59823c0.0354 0.0974-0.0165 0.18838-0.11811 0.20729-2.11772 0.37382-5.41715 1.84606-6.17125 2.19508zm32.3145 5.392c-3.86398-0.4004-8.42715-1.57146-13.272-2.24646-6.13345-0.85512-11.4668-0.5374-17.8518 2.3563-0.35138 0.16004-0.53799 0.17657-0.675 0.18071-0.11811 0.004-0.29882-0.0272-0.33602-0.20552-0.0295-0.137 0.0644-0.26515 0.1494-0.34901 0.0974-0.0969 0.24272-0.18603 0.41929-0.27756 5.9427-3.0378 12.1606-3.58347 18.4004-2.73426 4.83603 0.65788 9.4435 1.67067 13.2992 2.06989 2.1691 0.22441 4.64646-0.14114 5.462-1.44744 0.21437-0.34075 0.82914 0.39685 0.62776 0.71634-1.23366 1.97657-4.11792 2.15551-6.22325 1.93701zm-33.6075-11.0435c-0.16181 0.0626-0.31772 0.10217-0.43405 0.10393-0.0974 0-0.25276-0.0248-0.30296-0.17066-0.0461-0.13465 0.0419-0.25276 0.10748-0.32186 0.0797-0.0803 0.20197-0.16003 0.34902-0.22795 2.33799-1.07539 2.94449-1.26437 6.3685-2.17618 0.28818-0.0768 0.50256 0.0939 0.55217 0.31358 0.0473 0.21615-0.0667 0.46536-0.35493 0.53327-2.67224 0.63603-3.97441 1.05059-6.28525 1.94587zm-0.527-2.999c-0.15236 0.0602-0.29527 0.0957-0.40925 0.0915-0.10748-0.004-0.23917-0.0455-0.28819-0.17422-0.0484-0.12283 0.01-0.24331 0.0762-0.32184 0.0732-0.0856 0.17894-0.16596 0.31949-0.22855 2.35926-1.03996 3.30178-1.37657 6.5888-1.9996 0.27579-0.0537 0.5002 0.098 0.57697 0.29527 0.085 0.21733-0.0231 0.46654-0.32185 0.52323-3.20964 0.60768-4.34587 0.94193-6.54215 1.81418zm34.1425 9.0065c-2.6374-0.27225-5.6392-0.86161-8.8199-1.38071-0.33012-0.0543-0.45709-0.34075-0.41752-0.57933 0.0396-0.23918 0.24921-0.46949 0.57933-0.41575 3.16004 0.51496 6.1441 1.10256 8.762 1.37421 1.07716 0.11044 2.06811-0.0408 2.92973-0.37736 0.31122-0.12283 0.56456 0.0579 0.65197 0.28465 0.0892 0.22618 0.0265 0.52913-0.28465 0.65138-1.01279 0.39921-2.16555 0.57106-3.40098 0.44291zm-13.876 5.25c-5.2636-0.82027-11.7544 0.0685-16.7811 2.57244-0.22027 0.10984-0.41929 0.14764-0.5687 0.1624-0.12224 0.01-0.30531 0.006-0.38445-0.13524-0.0437-0.0791-0.0331-0.16181-0.008-0.22205 0.0248-0.0608 0.0667-0.11811 0.11811-0.1683 0.0998-0.10335 0.26221-0.21614 0.47599-0.32776 7.4079-3.59055 13.0642-3.35138 17.4703-2.85118 4.72323 0.53386 8.8677 1.55905 13.3878 1.8998 0.39271 0.0289 0.50019 0.38209 0.60236 0.6874 0.0933 0.28229 0.26516 0.79961-1.14862 0.64784-4.47402-0.47363-8.5689-1.54843-13.1634-2.26536zm13.833-2.9805c-5.00195-0.5191-11.6398-2.22579-18.0042-2.50807-0.32775-0.0148-0.53504-0.23504-0.53681-0.48602-0.002-0.26162 0.21083-0.47126 0.54508-0.4565 6.3874 0.28406 13.102 1.80591 18.1228 2.325 1.85374 0.19311 3.88052-0.17422 4.85434-1.04645 0.29232-0.26339 1.04645 0.7246 0.76653 0.9744-1.29212 1.15808-3.74173 1.40552-5.74785 1.19764zm-31.7325 0.1075c-0.90118 0.41752-1.36417-0.16181-0.34901-0.6809 0.82205-0.42166 5.34215-2.55768 7.75335-2.71772 0.33189-0.0231 0.5746 0.18071 0.64547 0.41516 0.0774 0.25984-0.0685 0.53149-0.42579 0.5563-2.16732 0.1435-6.75825 2.02618-7.624 2.42716z'/%3E %3Cpath d='m462.392 427.301c0.90118 0.41693 1.36594-0.1624 0.34901-0.6815-0.72106-0.36968-3.82913-1.72381-6.07795-2.16555-0.0892-0.0165-0.17243 0.0437-0.18425 0.13288l-0.0815 0.6c-0.01 0.0768 0.0502 0.16004 0.12637 0.17244 2.11595 0.37618 5.1124 1.59036 5.8683 1.94174zm-0.5185 2.946c0.90118 0.41693 1.36417-0.16181 0.34901-0.6809-0.7187-0.36792-3.98917-1.97481-6.2374-2.41713-0.062-0.0124-0.15177 0.0372-0.1748 0.0974l-0.22559 0.59823c-0.0378 0.0974 0.0142 0.18838 0.11811 0.20729 2.11595 0.37382 5.41715 1.84606 6.17065 2.19508zm-32.3145 5.392c3.86339-0.4004 8.42715-1.57146 13.272-2.24646 6.1311-0.85512 11.4674-0.5374 17.8518 2.3563 0.35079 0.16004 0.5374 0.17657 0.675 0.18071 0.11811 0.004 0.29882-0.0272 0.33661-0.20552 0.029-0.137-0.065-0.26515-0.14941-0.34901-0.098-0.0969-0.2433-0.18603-0.42224-0.27756-5.94035-3.0378-12.1606-3.58347-18.398-2.73426-4.8378 0.65788-9.4435 1.67067-13.2992 2.06989-2.1691 0.22441-4.64646-0.14114-5.462-1.44744-0.21437-0.34075-0.82913 0.39685-0.62775 0.71634 1.23366 1.97657 4.11791 2.15551 6.22325 1.93701zm33.608-11.0435c0.16181 0.0626 0.31771 0.10217 0.43405 0.10393 0.0974 0 0.25276-0.0248 0.30296-0.17066 0.046-0.13465-0.0414-0.25276-0.10748-0.32186-0.0791-0.0803-0.20138-0.16003-0.34902-0.22795-2.338-1.07539-2.9439-1.26437-6.3685-2.17618-0.29055-0.0768-0.50433 0.0939-0.55217 0.31358-0.0472 0.21615 0.0667 0.46536 0.35493 0.53327 2.67224 0.63603 3.97382 1.05059 6.28525 1.94587zm0.5265-2.999c0.15177 0.0602 0.29527 0.0957 0.40925 0.0915 0.10807-0.004 0.23917-0.0455 0.28819-0.17422 0.0484-0.12283-0.01-0.24331-0.0762-0.32184-0.0709-0.0856-0.18071-0.16596-0.31949-0.22855-2.35926-1.03996-3.30178-1.37657-6.5888-1.9996-0.27579-0.0537-0.5002 0.098-0.57697 0.29527-0.085 0.21733 0.0224 0.46654 0.32008 0.52323 3.21378 0.60768 4.34941 0.94193 6.5439 1.81418zm-34.1425 9.0065c2.6374-0.27225 5.6392-0.86161 8.8199-1.38071 0.33248-0.0543 0.45531-0.34075 0.41752-0.57933-0.0396-0.23918-0.24921-0.46949-0.57933-0.41575-3.16004 0.51496-6.1435 1.10256-8.762 1.37421-1.07776 0.11044-2.06811-0.0408-2.92973-0.37736-0.31122-0.12283-0.56456 0.0579-0.65138 0.28465-0.0898 0.22618-0.0271 0.52913 0.28406 0.65138 1.01279 0.39921 2.16555 0.57106 3.40098 0.44291zm13.876 5.25c5.2636-0.82027 11.7561 0.0685 16.7811 2.57244 0.22027 0.10984 0.41929 0.14764 0.5687 0.1624 0.12224 0.01 0.30531 0.006 0.38445-0.13524 0.0431-0.0791 0.0331-0.16181 0.008-0.22205-0.0248-0.0608-0.0667-0.11811-0.11634-0.1683-0.10157-0.10335-0.26398-0.21614-0.47776-0.32776-7.40845-3.59055-13.0642-3.35138-17.4703-2.85118-4.72323 0.53386-8.8677 1.55905-13.3854 1.8998-0.39448 0.0289-0.50256 0.38209-0.60472 0.6874-0.0933 0.28229-0.26516 0.79961 1.14862 0.64784 4.47402-0.47363 8.5689-1.54843 13.1634-2.26536zm-13.8335-2.9805c5.00255-0.5191 11.6404-2.22579 18.0042-2.50807 0.32775-0.0148 0.53563-0.23504 0.5374-0.48602 0.003-0.26162-0.21319-0.47126-0.54567-0.4565-6.38445 0.28406-13.102 1.80591-18.1222 2.325-1.85374 0.19311-3.88052-0.17422-4.85434-1.04645-0.29232-0.26339-1.04409 0.7246-0.76594 0.9744 1.29153 1.15808 3.74173 1.40552 5.74665 1.19764zm31.733 0.1075c0.90118 0.41752 1.36594-0.16181 0.34901-0.6809-0.82441-0.42166-5.3427-2.55768-7.7551-2.71772-0.32834-0.0231-0.57342 0.18071-0.6437 0.41516-0.0774 0.25984 0.0679 0.53149 0.4252 0.5563 2.16792 0.1435 6.75885 2.02618 7.6246 2.42716z'/%3E %3Cg stroke='%23000' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='0.933' d='m400.04 427.329c-10.3441 0-17.1048-1.5815-26.3462-3.25335-21.515-3.89292-26.1928-0.93425-26.1928 2.78858 0 1.19351 1.10492 1.54666 1.90157 1.1876 0.40749-0.18484 0.74351-0.86988 0.74351-0.86988-0.75768-0.008-1.25433-0.30945-1.09429-1.24783 0.45945-2.71772 6.04665-3.95552 24.642-0.92776 9.2705 1.50709 16.0104 2.788 26.3546 2.788l-0.008-0.46536zm0.0165 0c10.3447 0 17.1053-1.5815 26.3468-3.25335 21.515-3.89292 26.1928-0.93425 26.1928 2.78858 0 1.19351-1.10492 1.54666-1.90157 1.1876-0.40749-0.18484-0.74351-0.86988-0.74351-0.86988 0.75768-0.008 1.25433-0.30945 1.09429-1.24783-0.45945-2.71772-6.04665-3.95552-24.642-0.92776-9.2705 1.50709-16.0104 2.788-26.3552 2.788l0.008-0.46536z'/%3E %3Cpath d='m342.374 416.79c-3.40866 0.54626-6.53565 1.71083-9.7311 2.96516-8.70825 3.4193-18.6992 2.89607-26.4378-2.60787 0.53976 3.91122 2.25472 7.31695 4.7628 10.3046 0.61299 0.72697 2.49212 2.5872 2.49212 2.5872 0.313 0.3254 0.25689 0.53327-0.1872 0.54567-5.92795 0.25335-11.3114 0.17658-17.1402-0.91122 13.7616 15.134 27.5858 18.9006 46.4304 9.7441 9.90235-4.80886 18.15 0.62067 28.0394 0.62067 10.4894 0 9.5014-6.86635 7.19235-14.6238l1.25846 0.13583c1.6878 4.76634 4.33937 16.523-8.4508 15.5722-9.85865-0.73111-17.7508-5.75435-27.6838-1.01575-15.2941 7.29624-26.3462 7.19234-39.6538-2.68229-2.71358-2.0126-7.08605-5.6309-8.951-8.39055-0.45236-0.67027 0.004-1.07126 0.68386-0.86161 5.0516 1.56791 12.7004 1.57205 16.5939 1.46988-3.15236-3.17067-6.69865-9.05495-6.5451-13.2762 0.0206-0.54626 0.27992-0.64961 0.74351-0.4128 7.20885 3.73524 9.9142 5.2364 18.3212 5.2364 4.95 0 15.0638-5.59134 18.0744-5.0126l0.18838 0.61299z'/%3E %3Cpath stroke-width='0.933' d='m457.723 416.79c3.40748 0.54626 6.53445 1.71083 9.7317 2.96516 8.70825 3.4193 18.6998 2.89607 26.4378-2.60787-0.53977 3.91122-2.25709 7.31695-4.76516 10.3046-0.61063 0.72697-2.48918 2.5872-2.48918 2.5872-0.31358 0.3254-0.25806 0.53327 0.18662 0.54567 5.9256 0.25335 11.3114 0.17658 17.1402-0.91122-13.764 15.134-27.5859 18.9006-46.4327 9.7441-9.9-4.80886-18.1476 0.62067-28.0364 0.62067-10.49 0-9.50195-6.86635-7.1929-14.6238l-1.25611 0.13583c-1.69015 4.76634-4.34173 16.523 8.44901 15.5722 9.85809-0.73111 17.7502-5.75435 27.6833-1.01575 15.2941 7.29624 26.3462 7.19234 39.6538-2.68229 2.71359-2.0126 7.08605-5.6309 8.9504-8.39055 0.45535-0.67027-0.006-1.07126-0.68265-0.86161-5.05215 1.56791-12.701 1.57205-16.5939 1.46988 3.14941-3.17067 6.69805-9.05495 6.5445-13.2762-0.0206-0.54626-0.28051-0.64961-0.7435-0.4128-7.20885 3.73524-9.9142 5.2364-18.3212 5.2364-4.95237 0-15.0638-5.59134-18.0744-5.0126l-0.18898 0.61299z'/%3E %3Cpath d='m399.473 405.15c-11.8264 0.0856-21.8008-2.06752-30.1246-3.94489-6.9-1.55669-14.935-3.33661-22.0092-2.39586-5.15315 0.68976-7.2567 2.96516-6.3762 8.16025 1.09607 6.4571 2.05926 12.9685 3.23268 19.405 0.67677 3.71457 2.65571 4.21299 6.14645 3.59587 5.0262-0.88878 21.147-4.49292 24.7683 0.0856 3.4754 4.39134 0.0886 7.5579-4.74921 7.6388-0.67677 0.01-0.45827-0.46122-0.23032-0.46122 4.62815 0 7.88565-2.67815 4.89567-6.78485-3.14941-4.32756-18.2315-1.15512-24.3732 0.27992-3.9059 0.91181-6.50315 0.40925-7.22185-4.38544-0.99035-6.60885-1.59862-11.1496-3.6939-19.6955-3.54213-14.4455 22.2378-7.75335 29.6646-6.02775 10.1244 2.3504 18.577 3.86162 30.584 4.22126 12.0307-0.35964 20.4827-1.87086 30.6071-4.22126 7.425-1.72559 33.2067-8.4177 29.667 6.02775-2.09705 8.54585-2.7059 13.0866-3.69626 19.6955-0.71811 4.79469-3.31594 5.29725-7.22125 4.38544-6.14235-1.43504-21.2238-4.60749-24.3738-0.27992-2.98996 4.10669 0.26752 6.78485 4.89626 6.78485 0.22796 0 0.44587 0.47126-0.2309 0.46122-4.83544-0.0809-8.22461-3.24745-4.74863-7.6388 3.62067-4.57855 19.7416-0.97441 24.7683-0.0856 3.49016 0.61712 5.4691 0.1187 6.14585-3.59587 1.17107-6.4364 2.13662-12.9478 3.23327-19.405 0.88051-5.1951-1.22303-7.4705-6.37915-8.16025-7.07365-0.94075-15.1069 0.83917-22.0063 2.39586-8.3238 1.87737-18.2988 4.03052-30.1258 3.94489h-1.04882z'/%3E %3C/g%3E %3Cg id='text'%3E %3Cpath d='m361.531 417.226c-1.61929-0.13878-4.2254-0.28406-4.2254-0.28406l-0.94488-12.8817 3.13111 0.37323 0.65019 10.0518c0.31772 0.0189 1.72323 0.11221 2.65985 0.21437 1.06477 0.11575 2.78445 0.38622 2.78445 0.38622l0.19666 2.58721s-2.62559-0.30827-4.25198-0.44705z'/%3E %3Cpath d='m368.29 417.947l-0.7055-12.4225 3.154 0.484 0.7055 12.422z'/%3E %3Cpath d='m377.81 412.179l1.07126 0.18307c1.59626 0.27224 1.71909-0.27815 1.70846-0.94902-0.0165-0.81023-0.39271-1.30807-2.0061-1.58386l-0.81969-0.13996 0.046 2.48977zm0.11397 4.9376l1.49233 0.25512c1.73858 0.29527 2.16142-0.0265 2.14488-0.89823-0.0189-0.99922-0.62067-1.59922-2.49744-1.9187l-1.19232-0.20375 0.0526 2.76556zm1.83366 2.76555l-4.99843-0.85334-0.22618-12.271 4.49528 0.76653c3.08563 0.525 4.75099 1.87855 4.7941 4.20886 0.0165 0.97559-0.53386 1.62284-1.13563 1.97185 0.86811 0.48425 2.10118 1.59272 2.13248 3.21851 0.0414 2.28012-1.34351 3.59173-5.0616 2.95866z'/%3E %3Cpath d='m391.53 421.566c-1.67126-0.15767-4.33937-0.52972-4.33937-0.52972l-0.12224-6.1825-0.12106-6.2067 7.12265 0.73937 0.0224 1.22066 0.0248 1.23958-3.98268-0.41339 0.0502 2.54823 4.18583 0.43347 0.046 2.30491-4.18583-0.43346 0.049 2.62027c0.3183 0.049 1.75039 0.26929 2.7124 0.35492 1.08189 0.0974 2.8565 0.13465 2.8565 0.13465l0.0478 2.4626s-2.69882-0.13465-4.36654-0.29292z'/%3E %3Cpath d='m401.918 415.228c1.663-0.029 2.39173-0.73701 2.37106-1.8691-0.0213-1.18937-0.53622-1.68779-2.04331-1.66063l-1.39488 0.023 0.0614 3.52323 1.00571-0.0165zm6.962 6.4175c-2.4567-0.0809-3.77894-1.31221-5.0746-2.76556l-1.37067-1.53602c-0.19488 0.0165-0.40512 0.0201-0.61654 0.0242l-0.81201 0.0147 0.0732 4.32934-3.07973 0.0514-0.21378-12.3868 4.7817-0.0827c2.74488-0.0485 4.76929 1.18287 4.8189 3.93839 0.0231 1.34291-0.59351 2.53523-1.84961 3.30945l1.18937 1.2437c0.66851 0.6933 1.41614 1.15453 2.72658 1.47047l-0.57284 2.38937z'/%3E %3Cpath d='m408.991 411.684l-0.015-2.45 10.9515-1.5115 0.0145 2.452-3.904 0.538 0.0585 9.887-3.1435 0.4325-0.0585-9.886z'/%3E %3Cpath d='m426.623 409.195c-0.37559 1.34586-0.77422 2.68464-1.17933 4.02342 0.85925-0.0868 1.76043-0.24035 2.58661-0.48779-0.37145-1.19587-0.73642-2.38937-1.07775-3.59764l-0.32953 0.062zm3.35079 8.99645l-1.21654-3.32422c-0.64547 0.23681-1.34114 0.37618-2.04094 0.4819-0.70571 0.1057-1.41614 0.17834-2.09055 0.28228l-1.32933 3.81437-3.18485 0.59587 3.84981-10.6246-1.34823 0.25334-0.0248-2.44783c2.84705-0.46536 5.60845-0.98445 8.364-1.57028l0.11161 2.43189-1.35945 0.25512 3.54804 9.2374-3.27874 0.61477z'/%3E %3Cpath d='m438.3 417.4c-2.02264 0.0355-3.09213-0.31359-4.01339-0.80551l0.86161-2.29607c1.14744 0.38386 1.81595 0.5439 3.15768 0.52087 1.47638-0.0272 2.19863-0.49016 2.20926-1.16044 0.008-0.44882-0.33425-0.7624-0.91772-1.04645-0.58405-0.28465-1.3624-0.5191-2.14134-0.82264-1.56083-0.60827-3.16594-1.50295-3.12874-3.63957 0.0437-2.42539 2.75138-3.6626 4.9252-3.7004 1.95414-0.0349 3.0502 0.36555 4.00099 0.76654l-0.79075 2.22579c-0.96142-0.26162-1.92697-0.48603-3.1624-0.463-1.22067 0.0206-1.93288 0.65375-1.94115 1.1067-0.007 0.35138 0.33603 0.6313 0.93838 0.91535 0.59174 0.27875 1.38485 0.53799 2.17559 0.86988 1.58681 0.66319 3.21674 1.62816 3.18131 3.63426-0.0502 2.75905-2.81989 3.85158-5.35456 3.89468z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='300' height='600' fill='%2300853f'/%3E %3Crect x='300' width='300' height='600' fill='%23fdef42'/%3E %3Crect x='600' width='300' height='600' fill='%23e31b23'/%3E %3Cg transform='translate(450,300)' fill='%2300853f'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-100 v 100 h 50 z' transform='rotate(18 0,-100)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 81 54'%3E %3Crect fill='%234189DD' width='81' height='54'/%3E %3Cg transform='translate(40.5 27) scale(13)'%3E %3Cg id='t'%3E %3Cpolygon id='w' fill='%23FFF' points='0,0 0,1 .5,1' transform='translate(0 -1) rotate(18)'/%3E %3Cuse xlink:href='%23w' transform='scale(-1 1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(144)'/%3E %3Cuse xlink:href='%23t' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23377e3f' /%3E %3Crect y='120' width='900' height='360' fill='%23fff' /%3E %3Crect y='180' width='900' height='240' fill='%23b40a2d' /%3E %3Cpath d='M 450,191.459 520.534,408.541 335.873,274.377 564.127,274.377 379.466,408.541 z' fill='%23ecc81d' /%3E %3C/svg%3E"

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='500' viewBox='0 0 20 10'%3E %3Crect fill='%23078930' width='20' height='10'/%3E %3Crect fill='%23FFF' width='20' height='7'/%3E %3Crect width='20' height='3'/%3E %3Crect fill='%23DA121A' y='3.5' width='20' height='3'/%3E %3Cpolygon fill='%230F47AF' points='0,0 8.660254,5 0,10'/%3E %3Cpolygon fill='%23FCDD09' points='-513674,0 415571,301930 -158734,-488533 -158734,488533 415571,-301930' transform='translate(2.88675,5) scale(0.000003114816)'/%3E %3C/svg%3E"

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2800' height='1400'%3E %3Crect width='2800' height='1400' fill='%2312ad2b'/%3E %3Crect y='400' width='2800' height='600' fill='%23ffce00'/%3E %3Cpath d='M 0,0 V 1400 L 700,700' fill='%23d21034'/%3E %3Cg id='star' transform='translate(1400,700)' fill='%23000'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-200 v 200 h 100' transform='rotate(18 0,-200)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' x='700'/%3E %3C/svg%3E"

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1064' height='600'%3E %3Ctitle%3EFlag of El Salvador%3C/title%3E %3Crect height='600' width='1064' fill='%230f47af'/%3E %3Crect height='200' width='1064' y='200' fill='%23fff'/%3E %3Cg transform='translate(16.12698,0)'%3E %3Cg%3E %3Cg fill-rule='evenodd' stroke='%23000' stroke-width='0.304' fill='%23fff'%3E %3Cpath d='m515.01,353.35c1.5188,0,3.1669,0,10.11-1.6925,6.9428-1.6491,12.67-5.8572,14.015-6.4651,1.3451-0.60692,3.2972-0.43425,3.2972-0.43425-0.73822-0.78061-2.864-2.7337-5.8572-2.7337-3.0377,0-1.8228,0-4.3828,1.0846-2.56,1.0422-7.8971,4.2949-16.921,4.2949h-0.17266c-9.0251,0-14.665-3.2527-17.225-4.2949-2.56-1.0846-1.3886-1.0846-4.3828-1.0846-3.0377,0-5.12,1.9531-5.9006,2.7337,0,0,1.9955-0.17267,3.3406,0.43425,1.3451,0.60794,7.072,4.816,14.015,6.4651,6.8973,1.6925,8.5898,1.6925,10.065,1.6925z'/%3E %3Cpath d='m488.37,347.44c0.73718-0.43321-0.1737-1.6481-0.1737-1.6481l2.7337-0.60794c-1.3451-0.60692-3.3406-0.43425-3.3406-0.43425-0.5211,0.43425-0.43425,0.95534-0.5211,1.3451-0.0434,0.39082-0.0434,0.99877,0.26055,1.3017,0.25952,0.26055,1.0412,0.0434,1.0412,0.0434z'/%3E %3Cpath d='m490.92,345.19-2.7337,0.60794s0.91088,1.2149,0.1737,1.6481l4.816-0.91088s-0.73719-0.5211-2.256-1.3451z'/%3E %3Cpath d='m541.69,347.44c-0.73719-0.43321,0.13027-1.6481,0.13027-1.6481l-2.6903-0.60794c1.3451-0.60692,3.2972-0.43425,3.2972-0.43425,0.56349,0.43425,0.47664,0.95534,0.56349,1.3451,0.0434,0.39082,0.0434,0.99877-0.25951,1.3017-0.30294,0.26055-1.0412,0.0434-1.0412,0.0434z'/%3E %3Cpath d='m539.13,345.19,2.6903,0.60794s-0.86746,1.2149-0.13027,1.6481l-4.816-0.91088s0.73718-0.5211,2.256-1.3451z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m511.97,343.31-1.2188,3.0312,0.5625,0.21875c0.9109,0.39087,1.8168,0.18523,2.25-0.8125,0.39086-1.0422-0.13254-1.8088-1-2.1562l-0.59375-0.28125zm0.25,0.625,0.0937,0.0312c0.69376,0.303,1.1154,0.79993,0.8125,1.625-0.3474,0.78061-1.0372,0.80398-1.6875,0.5l-0.125-0.0312,0.90625-2.125z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='69.829,129.54,71.13,126.65,71.466,126.78,70.165,129.67,70.165,129.67'/%3E %3Cpath d='m516.34,345.28c-0.63438,0.0162-1.2381,0.44315-1.5312,1.0938-0.39086,0.8685-0.0115,1.7967,0.8125,2.1875,0.8241,0.34739,1.7977-0.0266,2.1875-0.9375,0.34737-0.824-0.0197-1.8269-0.84375-2.2188-0.20602-0.0869-0.41354-0.13041-0.625-0.125zm-0.0312,0.5c0.14642-0.001,0.31702,0.0286,0.46875,0.0937,0.65028,0.2595,0.82305,0.95559,0.5625,1.5625-0.2605,0.60797-0.96673,0.9168-1.5312,0.65625-0.52007-0.2605-0.80397-0.91113-0.5-1.5625,0.19538-0.4552,0.56075-0.74598,1-0.75z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' d='m503.81,347.36c-0.0434-0.21609-0.12924-0.38979-0.34637-0.47664-0.21609-0.0869-0.56348,0-0.65033,0.26055-0.0869,0.25951,0.0868,0.47767,0.21712,0.60691l0.21712,0.1737c0.34637,0.30397,0.56349,0.65137,0.34637,1.1714-0.21713,0.56452-0.78061,0.78165-1.3017,0.60795-0.43425-0.1737-0.69479-0.69376-0.56452-1.2149l0.39082,0.0868c-0.13027,0.30397,0.0434,0.65034,0.34637,0.78061,0.30397,0.13027,0.65137-0.0869,0.78164-0.38979,0.12924-0.34739-0.0868-0.56452-0.30397-0.78164l-0.17267-0.1737c-0.26055-0.26055-0.47664-0.56452-0.30397-0.99773,0.1737-0.47767,0.69479-0.65137,1.128-0.47767,0.34636,0.13027,0.52109,0.39082,0.56348,0.73821l-0.34739,0.0858z'/%3E %3Cpath fill-rule='evenodd' d='m506.2,347.53-0.52109,1.8228c-0.13028,0.5211-0.13028,1.0422,0.43424,1.2149,0.60692,0.17473,0.86746-0.25952,1.0412-0.78061l0.52006-1.8662,0.34637,0.13027-0.56349,1.9531c-0.1737,0.69376-0.73718,1.128-1.432,0.91088-0.69376-0.17266-0.95431-0.82403-0.73718-1.5188l0.56348-1.9965,0.34843,0.13028z'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M82.754,133.95,80.992,131.06,80.53,133.36,80.194,133.32,80.824,130.05,80.824,130.05,82.544,132.9,83.006,130.64,83.342,130.68z'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M83.552,133.87,83.929,130.76,84.265,130.8,83.887,133.95,83.887,133.95z'/%3E %3Cpath d='m530.31,348.88c-0.91089-0.0435-1.6441,0.68286-1.6875,1.5938-0.0434,0.99879,0.65162,1.7378,1.5625,1.7812,0.86846,0.0434,1.6441-0.62623,1.6875-1.625,0.0434-0.91086-0.694-1.75-1.5625-1.75zm-0.0625,0.46875c0.69377,0.0435,1.1372,0.63092,1.0938,1.2812,0,0.69483-0.54934,1.1562-1.1562,1.1562-0.60796-0.0434-1.0938-0.59863-1.0938-1.25,0.0434-0.6503,0.50592-1.1875,1.1562-1.1875z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M90.979,134.04,88.545,131.77,88.713,134.12,88.335,134.12,88.084,130.85,88.084,130.85,90.518,133.11,90.35,130.8,90.728,130.76z'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M92.952,133.57,92.364,130.47,92.742,130.43,93.287,133.15,93.287,133.15,94.169,132.99,94.253,133.36z'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M94.63,133.24,93.917,130.17,94.295,130.09,95.008,133.15,95.008,133.15z'/%3E %3Cpath d='m540,347.72c-0.1356,0.007-0.26512,0.0299-0.40625,0.0625l-0.34375,0.125,0.875,3.125,0.6875-0.15625c0.52109-0.1737,0.95495-0.56738,0.78125-1.2188-0.0869-0.34739-0.42167-0.63715-0.8125-0.59375,0.1737-0.1737,0.19965-0.50163,0.15625-0.71875-0.16282-0.5211-0.53069-0.64739-0.9375-0.625zm0.0625,0.40625c0.20733-0.0346,0.4023,0.0493,0.5,0.375,0.13028,0.39082-0.13456,0.50795-0.4375,0.59375l-0.0937,0.0312-0.3125-0.9375h0.125c0.076-0.0326,0.14964-0.051,0.21875-0.0625zm0.5,1.3125c0.254-0.0285,0.52858,0.0181,0.59375,0.34375,0.13027,0.39082-0.16478,0.57045-0.46875,0.65625l-0.28125,0.0937-0.25-1,0.1875-0.0312c0.0757-0.0217,0.13409-0.053,0.21875-0.0625z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M98.869,130.01,98.995,130.34,97.861,130.72,98.239,131.85,99.414,131.43,99.54,131.81,98.029,132.32,96.98,129.34,96.98,129.34,98.533,128.79,98.617,129.12,97.442,129.54,97.735,130.38z'/%3E %3Cpath d='m544.75,346.19c-0.30397-0.0434-0.55195,0.026-0.8125,0.15625l-0.4375,0.1875,1.2188,3.0312,0.34375-0.125-0.46875-1.3125,0.125-0.0312,1.3438,0.90625,0.46875-0.15625-1.4688-0.96875c0.38977-0.21712,0.51745-0.69075,0.34375-1.125-0.0869-0.26055-0.35228-0.5191-0.65625-0.5625zm-0.0937,0.40625c0.16814,0.0163,0.31889,0.12662,0.40625,0.34375,0.17267,0.43321-0.18489,0.65097-0.53125,0.78125l-0.0625,0.0312-0.40625-1,0.0937-0.0312c0.15198-0.0651,0.33186-0.14128,0.5-0.125z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M100.8,127.87,102.44,127.15,102.6,127.45,101.93,127.74,103.11,130.3,103.11,130.3,102.77,130.47,101.6,127.91,100.97,128.2z'/%3E %3Cpath d='m548.34,344.19,0.21875,3.7188,0.40625-0.21875-0.0625-0.84375,1.2812-0.65625,0.6875,0.5625,0.34375-0.21875-2.875-2.3438zm0.4375,0.875,1,0.8125-0.90625,0.46875-0.0937-1.2812z' transform='translate(-16.12698,0)'/%3E %3Cpath d='m551.44,342.88c-0.31836,0.0182-0.65974,0.11748-0.96875,0.3125l-0.5625,0.3125,1.7188,2.8125,0.5-0.28125c0.86746-0.5201,1.252-1.3894,0.6875-2.3438-0.35219-0.59644-0.8444-0.84287-1.375-0.8125zm0.15625,0.5c0.30384,0.0271,0.60492,0.19339,0.84375,0.5625,0.43326,0.73715,0.0264,1.2967-0.625,1.6875l-0.0625,0.0312-1.1875-1.9375,0.0937-0.0937c0.3252-0.1737,0.63366-0.27714,0.9375-0.25z' transform='translate(-16.12698,0)'/%3E %3C/g%3E %3Cg id='g3' stroke='%23000' stroke-miterlimit='2.61310005'%3E %3Cg fill-rule='evenodd' stroke-width='0.13017058' fill='%23e60000'%3E %3Cpath d='m485.07,355.17c0.5211,0,0.91089-0.39082,0.91089-0.91192,0-0.47767-0.38979-0.86746-0.91089-0.86746-0.47663,0-0.91088,0.38979-0.91088,0.86746,0,0.5211,0.43425,0.91192,0.91088,0.91192z'/%3E %3Cpath d='m479.95,361.5c0.52006,0,0.91088-0.38979,0.91088-0.91089,0-0.47767-0.38979-0.91192-0.91088-0.91192-0.47767,0-0.91088,0.43425-0.91088,0.91192,0,0.5211,0.43424,0.91089,0.91088,0.91089z'/%3E %3Cpath d='m468.06,341.63c0.47664,0,0.91089-0.43425,0.91089-0.91089,0-0.52109-0.43425-0.91192-0.91089-0.91192-0.52006,0-0.91088,0.39083-0.91088,0.91192,0,0.47664,0.38979,0.91089,0.91088,0.91089z'/%3E %3Cpath d='m460.68,345.32c0.52007,0,0.99774-0.43424,0.99774-0.99876,0-0.52007-0.47767-0.99774-0.99774-0.99774-0.56452,0-0.99773,0.47767-0.99773,0.99774,0,0.56452,0.43321,0.99876,0.99773,0.99876z'/%3E %3Cpath d='m459.34,323.02c0.5211,0,0.99774-0.43322,0.99774-0.99774,0-0.52109-0.47664-0.99773-0.99774-0.99773-0.56348,0-0.99773,0.47664-0.99773,0.99773,0,0.56556,0.43321,0.99774,0.99773,0.99774z'/%3E %3Cpath d='m453.13,324.84c0.56452,0,0.99773-0.43425,0.99773-0.99774,0-0.56452-0.43321-0.99773-0.99773-0.99773-0.52006,0-0.99774,0.43321-0.99774,0.99773,0,0.56349,0.47664,0.99774,0.99774,0.99774z'/%3E %3Cpath d='m456.3,304.97c0.56452,0,0.99773-0.47767,0.99773-0.99774,0-0.56452-0.43321-0.99876-0.99773-0.99876-0.56349,0-0.99774,0.43424-0.99774,0.99876,0,0.5211,0.43425,0.99774,0.99774,0.99774z'/%3E %3Cpath d='m450.75,286.7c0.52006,0,0.99773-0.43425,0.99773-0.95431,0-0.56349-0.47663-0.99774-0.99773-0.99774-0.56452,0-0.99773,0.43322-0.99773,0.99774,0,0.52109,0.43321,0.95431,0.99773,0.95431z'/%3E %3Cpath d='m457.82,288.52c0.56349,0,0.99773-0.43321,0.99773-0.99774,0-0.52006-0.43424-0.99773-0.99773-0.99773-0.56452,0-0.99773,0.47767-0.99773,0.99773-0.001,0.56349,0.43321,0.99774,0.99773,0.99774z'/%3E %3Cpath d='m464.76,273.3c0.52109,0,0.99773-0.43424,0.99773-0.99773,0-0.52109-0.47664-0.95431-0.99773-0.95431-0.56349,0-0.99774,0.43322-0.99774,0.95431,0.001,0.56349,0.43425,0.99773,0.99774,0.99773z'/%3E %3Cpath d='m459.47,269.09c0.56452,0,0.99773-0.43424,0.99773-0.99773,0-0.52006-0.43321-0.99773-0.99773-0.99773-0.56349,0-0.99774,0.47664-0.99774,0.99773-0.001,0.56349,0.43322,0.99773,0.99774,0.99773z'/%3E %3Cpath d='m470.01,258.85c0.56348,0,0.99773-0.43322,0.99773-0.99774s-0.43425-0.99773-0.99773-0.99773c-0.56452,0-0.99774,0.43321-0.99774,0.99773-0.001,0.56452,0.43322,0.99774,0.99774,0.99774z'/%3E %3Cpath d='m448.49,305.1c0.56349,0,0.99774-0.43424,0.99774-0.95431,0-0.52109-0.43321-0.95534-0.99774-0.95534-0.52109,0-0.9543,0.43425-0.9543,0.95534,0,0.52007,0.43321,0.95431,0.9543,0.95431z'/%3E %3C/g%3E %3Cg stroke-width='0.26034117' fill='none'%3E %3Cpath d='m485.93,358.9s-0.73718-3.1669-0.60794-3.9041l0.78164-0.60794'/%3E %3Cpath d='m484.72,360.11s-2.8205,0.13027-3.7314,0.43425c0,0,0,0.1737-0.30294,0.78164'/%3E %3Cpath d='m467.28,345.8s-0.1737-3.7748,0.60795-4.0788c0,0,0.73718-0.30294,1.1714-0.91089'/%3E %3Cpath d='m464.41,344.58s-2.1257-0.30501-2.7337,0c0,0-0.13028,0.60691-0.60795,0.78061'/%3E %3Cpath d='m460.34,322.45-0.73719,0.43425c-0.78061,0.30294-2.256,3.9475-2.256,3.9475s-2.4297-1.8228-3.4709-1.9965h-1.0846'/%3E %3Cpath d='m447.97,304.66s0.60794,0.60794,1.2149,0.30397c0,0,2.9942,1.9531,3.1669,2.7337,0,0,3.1679-3.1669,3.7748-2.864,0,0,0.30294,0.43425,0.91088-0.17369'/%3E %3Cpath d='m451.31,286.14s0.30397,0.43321,0.86746,0.73718c0,0,1.3886,1.9955,1.3886,3.4709,0,0,2.56-2.256,3.2972-2.0823,0,0,0.91088,0.30294,1.5178,0'/%3E %3Cpath d='m458.69,268.83s0.60692,0.73718,1.0412,0.13027c0,0,1.8218,2.256,0.73719,3.9485,0,0,2.56-0.60691,3.3406-0.1737,0,0,0.30294,1.0412,1.2149,0.43425'/%3E %3C/g%3E %3Cg fill-rule='evenodd' stroke-width='0.26034117' fill='%231f601a'%3E %3Cpath d='m532.79,378.34s-3.9041-0.30294-4.512-0.30294c-0.60794,0-1.9531-2.6913-2.56-3.1669-0.60795-0.43425-10.848-5.424-17.486-6.4651-6.6388-1.0412-16.834-4.9897-18.961-6.0309-11.021-5.2937-23.343-15.099-26.077-19.135-2.864-4.208-5.9006-14.015-7.2457-19.264-0.60795-2.4308-3.9051-12.366-3.9051-19.135,0-7.8526,0.91088-14.318,2.1257-19.438,1.1714-5.12,9.9794-20.131,15.359-26.814,0,0-12.105,18.743-14.188,25.903-2.0823,7.376-2.6903,16.357-2.56,21.477,0.13028,4.2091,3.6446,19.612,8.7646,30.936,4.0788,9.0685,7.6365,10.153,14.015,15.229,2.9942,2.3873,8.7211,6.1611,13.537,8.5919,4.816,2.3863,15.056,5.4229,17.789,5.8572,2.6903,0.47768,16.401,4.512,18.223,5.424,1.8249,0.91088,6.4672,4.9897,7.682,6.3338z'/%3E %3Cpath d='m464.11,343.41c0.30397-1.3886,0.43321-2.4297,0.91088-2.864,0.43322-0.47767,1.9531-2.3005,2.256-3.4709,0.30397-1.2148,0-2.1257,0-2.7337,0-0.60795,0.43321-2.6903,0.43321-2.6903s-0.73718-2.56-1.3451-3.0377c-0.60691-0.43425-2.1257-2.561-2.4297-3.1669,0,0,0.17266,1.2149-0.30397,1.8228-0.43425,0.60691-0.60692,2.1257-0.60692,2.9942,0,0.91089,0.30294,3.0377,0,4.0778-0.30397,1.1714-0.73718,2.1268-0.43424,3.4709,0.26158,1.0856,1.5199,5.5976,1.5199,5.5976z'/%3E %3Cpath d='m463.63,341.89s-3.4274-4.3818-3.4274-6.2046c0-1.7794-0.30294-2.864-0.60691-3.2972-0.30398-0.43321-2.256-2.7337-0.47664-5.5532,0.78061-1.2149,0.91088-1.128,1.3451-2.4308,0.60691-1.6491,1.8228-1.6491,1.9955-3.2961,0,0,0.43424,1.952,0.56452,3.6001,0.17266,1.6491-0.13028,2.257-0.26055,3.1669-0.1737,0.91192,0.43321,1.9531,0.43321,3.2972,0,1.3886-0.17266,1.9097-0.17266,2.7337-0.002,0.43528-0.56659,6.1622,0.60587,7.9839z'/%3E %3Cpath d='m502.25,365.41s-2.9074-0.30397-3.992-0.47767c-0.78061-0.0869-2.56-0.52006-3.5577-0.91088-0.86746-0.30398-2.56-1.2159-4.0344-2.7771-2.7771-2.9508-2.5166-4.5131-2.9942-4.6433-0.99773-0.17266,1.5612-0.43321,2.7771-0.25951,1.1714,0.13027,2.8205,0.99773,3.9051,2.0389,1.128,1.0422,2.864,2.2136,3.4709,2.6479,0.60691,0.47664,1.0412,0.65033,1.6915,1.5188,0.65137,0.86746,0.60794,1.432,2.7337,2.8629z'/%3E %3Cpath d='m506.24,367.53s-7.2891-3.2538-8.0274-3.8617c-0.78061-0.56452-1.9955-1.736-2.7771-2.56-0.73718-0.82507-3.8183-2.3873-4.3383-3.384-0.34636-0.6948-2.256-3.3406-3.384-5.424-0.56452-1.0846,4.8594,0.3474,4.8594,0.3474,4.4262,1.7794,2.4297,0.52109,4.8594,2.3439,1.4754,1.128,2.4731,2.0823,2.864,2.9074,0.56349,1.3017,1.2149,3.5567,1.8662,4.7292,0.60691,1.1704,1.7773,2.6882,4.0778,4.9018z'/%3E %3Cpath d='m510.19,368.45s-6.0309-1.5622-8.7646-5.2937c-1.9531-2.56-1.9531-1.7783-2.7771-2.6468-0.99773-1.0846-2.56-2.256-3.8607-4.4686,0.12924,0.21712-1.736-5.9006-1.6491-6.6388,0.0434-0.43322,2.2994,0.30397,4.1212,1.0846,1.5622,0.65137,2.4731,1.9096,3.8183,2.7347,1.6057,1.0412,1.8228,3.6435,2.56,4.8594,1.0412,1.7784,1.1714,2.6903,1.1714,3.5567-0.0434,1.3451,0.73718,1.7794,1.1714,2.9074,0.52213,1.3441,2.1268,1.128,4.2091,3.9051z'/%3E %3Cpath d='m500.56,366.45s-5.12-2.256-5.8582-2.4297c-0.78061-0.13028-1.0846-0.60795-2.1257-0.91192-0.86746-0.21712-1.6491-0.86746-3.7748-0.43321-0.91088,0.21609-4.6423,1.0412-5.5542,0.60691-0.91088-0.47767,1.3451,2.561,2.3863,3.1669,1.0846,0.60794,2.864,0.91191,4.3828,0.73822,1.5178-0.13028,3.6011,0,4.3818,0,0.73719,0,1.1714,0.17369,2.256-0.13028,1.0422-0.30294,1.3451-0.78061,3.9062-0.60691z'/%3E %3Cpath d='m504.03,366.45s-5.7279-1.432-6.6822-1.432c-0.95431,0-3.688,0.1737-4.816,0.39082-1.0846,0.1737-4.512-0.1737-5.5108,0.3474-1.0412,0.47664-5.5966,1.128-6.8115,0.82403-1.2149-0.26054,2.4297,3.2538,3.8617,3.6446,4.6423,1.3017,3.2538,1.128,6.248,0.3474,1.8228-0.47767,4.4262-0.60794,5.3371-0.73822,0.91088-0.1737,0.73718-0.69479,1.9531-1.2148,1.2138-0.52007,3.2527-1.8218,6.4206-2.1692z'/%3E %3Cpath d='m508.71,368.84s-5.7269-2.3873-10.197-1.1725c-3.08,0.86849-2.9942,0.73822-4.208,0.95534-1.432,0.21712-2.6468-0.5211-4.9897,0.43321-1.1714,0.47767-6.1611,2.5176-7.5497,2.4308-1.2583-0.0868,3.992,3.3406,5.424,3.1235,4.5989-0.65137,8.9382,0.91089,11.064,0.0434,1.9086-0.73822,3.0377-1.2583,3.992-1.5623,0.9543-0.34739,1.4754-1.2148,2.0823-1.6491,0.60691-0.47664,0.99773-1.6481,4.3818-2.6024z'/%3E %3Cpath d='m478.13,355.69s-3.2972-3.6435-3.9485-4.1212c-0.60691-0.47767-2.1692-1.6057-2.9942-2.3439-0.69376-0.60691-1.3886-1.952-3.5143-2.4731-0.91088-0.21712-3.1235-0.65137-3.7738-1.432-0.60794-0.82507,0.12924,2.9074,0.82404,3.9041,0.69479,0.99877,2.1702,2.0399,3.6011,2.561,1.432,0.52007,3.2538,1.5623,3.9051,1.9086,0.69376,0.30397,1.0412,0.65137,2.1257,0.82507,1.0846,0.21712,1.5622-0.0868,3.7748,1.1714z'/%3E %3Cpath d='m481.25,357.21s-5.5976-3.9475-6.4651-4.3818c-0.86746-0.39083-2.4731-0.95431-3.5143-1.3017-1.0846-0.30397-3.9051-2.3439-5.0331-2.3439s-3.2538-0.0869-4.2081-0.82403c-0.99773-0.78165-0.13027,2.7337,0.95431,3.7314,3.6012,3.2093,1.128,2.256,4.1212,2.864,1.8228,0.38978,4.2525,1.3886,5.12,1.6481,0.91089,0.26055,0.99774-0.30293,2.2994-0.21608,1.3027,0.0434,3.7325-0.21713,6.7256,0.82403z'/%3E %3Cpath d='m482.59,358.25s-2.2994-1.5199-6.8549-2.3005c-3.1235-0.56452-2.9942-0.6948-4.1646-0.99773-1.3886-0.43425-1.6925-0.43425-4.2525-0.56452-1.2583-0.0868-6.2046,1.5188-7.376,0.82506-1.0846-0.60794,1.2149,1.5178,2.6034,2.0389,1.9955,0.73822,1.736,2.0399,3.9051,2.7337,2.2994,0.73822,4.7292,1.6491,6.0743,1.3896,1.0412-0.21712,1.8228-0.6948,3.2972-0.82507,1.431-0.17473,3.9475-2.257,6.768-2.2994z'/%3E %3Cpath d='m483.07,357.08s1.128-5.4663,0.1737-6.768c-0.47664-0.60794-1.0846-1.4754-1.2149-2.865-0.13027-1.3451-1.0412-3.6001-1.6491-4.3383-0.60691-0.78061-1.8228-4.2515-1.5188-5.1189,0,0-3.1669,3.1235-2.9942,5.1189,0.13027,1.9531,0.13027,1.4764,0,2.3873-0.1737,0.91089,0.73718,3.9041,1.3451,4.816,0.60691,0.91089,0.30397,3.6435,0.91088,4.2081,0.60898,0.60794,4.2112,3.0377,4.9473,2.56z'/%3E %3Cpath d='m482.59,358.25c0.34739,0.17267-1.9086-1.736-2.9942-2.2136-1.0412-0.43425-5.2502-1.6491-5.5542-2.6903-0.30294-1.0856-3.7748-4.6857-3.9041-5.5976-0.13028-0.69376-0.78165-2.1257-0.60795-2.864,0.13028-0.73718,0.43425-2.56,0.91089-3.6011,0.43321-1.0846,1.4754-3.6001,2.56-4.0778,0,0,0.86746,2.864,1.1714,3.9051,0.30397,1.0846,0.60691,2.2994,1.0846,2.864,0.43321,0.60795,1.952,3.4698,2.0823,4.5555,0.1737,1.0412,0.91089,4.512,1.0846,5.2492,0.1313,0.73822,2.9518,3.8193,4.1667,4.4707z'/%3E %3Cpath d='m464.11,343.41c0.13027,0.78165-2.256-0.78061-3.4709-0.78061s-4.816,0.47664-5.7269-0.43424c-0.91088-0.91192-2.256-2.56-2.7337-2.864-0.43425-0.30398-2.0834-3.0377-2.56-4.512-0.43424-1.5188-3.6011-4.2525-4.0354-4.5555,0,0,4.3394-0.86849,7.072,0.91089,2.6903,1.8228,2.864,1.3886,3.4709,1.6491,0.60691,0.30397,5.2502,4.2515,5.5542,5.7269,0.30397,1.5188,2.257,4.0788,2.4297,4.8594z'/%3E %3Cpath d='m464.11,343.41s-3.9051-2.7337-4.816-2.6034c-0.91088,0.1737-5.1634-2.9942-5.4229-4.9463-0.1737-1.0412-2.2126-2.5166-2.56-3.1669-1.0846-1.8228-1.6925-5.8572-3.1669-6.9417,0,0,4.0778,1.0412,5.12,1.2148,1.9531,0.30397,3.6011,0.60691,4.3394,2.256,0.78061,1.6491,1.3886,3.0376,1.9955,3.1669,0.60691,0.1737,1.4754,2.257,1.7794,4.3818,0.30191,2.0834,2.7316,6.6388,2.7316,6.6388z'/%3E %3Cpath d='m456.73,322.89c0.65034,1.0412,0.60691-6.0319,0.86746-6.7691,0.30294-0.73822,1.0846-2.257,1.6915-2.864,0.60794-0.60795,0.60794-2.6903,0.91088-3.2972,0.26055-0.60795,0.13027-4.6857-0.30294-5.7269,0,0-1.2149,0.91089-1.8228,1.6481-0.60691,0.73822-1.6491,1.0422-1.952,1.9531-0.30398,0.91192-0.91089,0.91192-1.3451,1.8228-0.47664,0.91192-0.91089,2.3863-0.60691,3.6011,0.30397,1.2149,0.13027,1.6491,0.13027,2.7337,0,1.0401,1.5188,5.5532,2.4297,6.8983z'/%3E %3Cpath d='m456.86,323.49s-0.30398-1.9531,0.47663-2.6903c0.73719-0.78165,1.4754-0.78165,1.7794-1.2149,0.30294-0.47767,0.17267-1.0422,0.47664-1.6491,0.30397-0.60795,0.95431-1.6057,1.0412-2.1268,0.30397-1.6491,1.2148-3.4709,0.43424-5.2492,0,0-1.6491,0.56349-2.0823,0.86746-0.47767,0.30397-1.8228,1.5188-1.9531,2.7337-0.17266,1.3451-0.30294,1.5188-0.78061,2.257-0.43321,0.73719-1.0412,2.9942-0.30294,4.3818,0.78061,1.3462,0.91089,2.6903,0.91089,2.6903z'/%3E %3Cpath d='m452.48,300.46s-0.30397-4.3818,0.91089-5.7279c1.2148-1.3451,1.5188-3.9041,4.2091-5.2937,0,0-0.13028,1.0846,0,1.8228,0.17369,0.73718,0.47663,2.864,0,3.6011-0.43425,0.78061-1.9531,2.1257-1.9531,2.7337,0,0.60794-1.0412,2.1257-1.7783,2.4297-0.78165,0.26055-1.3886,0.43425-1.3886,0.43425z'/%3E %3Cpath d='m452.48,302.84s0-3.1235,0.91089-4.0344c0.91088-0.91088,1.3886-1.3886,1.8228-1.9531,0.43321-0.60691,0.91088-2.1257,1.952-2.7337,1.0412-0.60691,2.864-2.1257,3.0377-2.6903,0,0,0.43321,3.7314-0.60691,5.7279-1.0846,1.952-1.0846,2.9942-2.256,3.4274-1.2149,0.47767-1.3886,0.78165-1.8218,1.0846-0.47767,0.30397-1.2148,0.73821-1.8228,0.73821-0.60898,0-1.2159,0.43322-1.2159,0.43322z'/%3E %3Cpath d='m455.95,323.36c0.1737,0.8685,0.78061-1.9531-2.3863-1.9531s-5.7279-1.2149-6.8115-2.2994c-1.0412-1.0412-1.6491-1.7794-2.0834-2.257-0.47664-0.43321-1.6491-2.256-1.8218-3.1669-0.13027-0.86849-1.0412-4.2091-0.91088-4.816,0,0,1.6925,0.30294,2.4297,0.91089,0.73718,0.60794,2.1257,0.60794,2.864,1.0846,0.73718,0.43424,1.3451,1.6491,1.8228,2.0834,0.43321,0.47767,1.7783,0.47767,2.3863,1.3451,0.60691,0.91088,1.6481,2.864,1.8218,3.7748,0.13027,0.91088,1.2148,1.8218,1.9531,2.256,0.73615,0.4787,0.60588,2.2581,0.73615,3.0376z'/%3E %3Cpath d='m455.65,322.15s-2.0823-2.56-3.1669-2.56c-1.0412,0-3.7314-2.7347-3.9051-3.9051-0.13027-1.2149-1.0412-3.4709-1.6491-3.9475-0.60691-0.43425-1.6481-1.4754-1.5178-3.2972,0.17266-1.8228,0.17266-4.816,0.17266-4.816s0.60795,1.8228,1.4754,2.256c0.91088,0.43425,2.56,1.0422,2.864,1.6501,0.30294,0.60691,1.5188,0.60691,1.9955,2.4297,0.43321,1.7794,0.43321,1.6491,0.73719,2.256,0.30397,0.60795,1.0412,1.3462,1.3451,2.561,0.30397,1.2118,1.9531,4.3352,1.6491,7.3729z'/%3E %3Cpath d='m452.53,305.53c-0.0858,0.82403,1.2149-1.6057-1.6491-2.4742-2.9074-0.86746-4.9028-2.6903-5.5532-3.9475-0.65137-1.2149-0.99773-2.0823-1.3017-2.6034-0.25952-0.56349-0.86746-2.5166-0.73719-3.384,0.0869-0.86746,0.21712-4.1222,0.5211-4.6433,0,0,1.432,0.73822,1.9086,1.4754,0.5211,0.78061,1.7794,1.1714,2.3429,1.7794,0.52109,0.60691,0.73718,1.8652,1.0412,2.4297,0.30397,0.52007,1.5188,0.91089,1.8228,1.8662,0.30397,0.99773,0.69479,3.08,0.56452,3.9475-0.0869,0.86746,0.60691,1.9531,1.1714,2.6044,0.56349,0.60691-0.0879,2.2116-0.13131,2.9498z'/%3E %3Cpath d='m452.57,304.32s-1.2149-2.9084-2.1692-3.1669c-0.95431-0.30397-2.5166-2.7771-2.6034-3.9051-0.12924-1.3017-0.30294-3.4709-0.73718-4.0344-0.43322-0.56452-1.2149-2.4297-0.60692-4.0354,0.65034-1.6057,1.6491-3.7314,1.6491-3.7314s0.86746,1.3451,1.3451,2.1702c0.78061,1.5623,1.5622,1.6915,1.6925,2.2994,0.0869,0.65034,1.0412,1.0412,1.3886,2.2994,0.47767,1.6925-0.0434,1.6057,0.0434,2.256,0.13028,0.60692,0.60692,1.5188,0.52007,2.6903-0.0445,1.1694,0.60691,4.51-0.52213,7.1578z'/%3E %3Cpath d='m454.91,286.14c0.13028-0.43321,1.0412-0.91088,2.1257-1.2149,1.0412-0.30294,2.6903-2.6903,3.4274-3.2972,0.69376-0.65137,1.0846-1.6057,1.9955-2.1257,0.91088-0.5211,1.4754-2.3873,1.7794-4.2091,0,0-2.56,0.60691-3.2972,0.73719-0.73718,0.17369-2.256,1.0846-2.864,1.8218-0.60691,0.73822-1.2148,1.9531-1.8228,2.256-0.60691,0.30397-1.3451,2.1268-1.3451,3.3406,0.001,1.1725,0.001,2.6913,0.001,2.6913z'/%3E %3Cpath d='m454.78,284.79s-0.17266-1.7794-0.17266-2.56c0-0.91088-0.56452-3.3406,0.73718-5.2937,0.91088-1.3451,4.2525-3.9051,5.12-4.0354,0,0,0.60692,2.3863,0.47664,3.1235-0.17266,0.78061-0.95431,3.7748-1.6491,4.0778-0.69376,0.30501-2.4297,3.9062-4.512,4.6878z'/%3E %3Cpath d='m454,286.14c-0.38979,0.65034-0.12924-2.256-1.0412-2.9942-0.91089-0.78061-1.0412-1.8218-1.0412-3.0377,0-1.2149,0.26055-2.0823,0.43321-2.8629,0.13028-0.73822,2.4297-3.9051,2.257-4.816,0,0,1.3017,2.9508,1.6481,3.7748,0.47767,1.0412-0.30294,2.1257-0.12924,2.9942,0.12924,0.91088,0.86746,2.56,0.30294,3.4709-0.47664,0.78061-1.8218,2.4297-2.4297,3.4709z'/%3E %3Cpath d='m461.98,270.61s0.1737-0.43321,1.5188-0.43321,3.2972-0.13131,3.9051-0.73925c0.60691-0.60691,1.6491-1.3886,2.256-1.6925,0.60691-0.25951,1.6491-1.6481,1.8228-2.256,0.12924-0.60692,1.2149-1.7794,1.6491-1.7794,0,0-1.6491-0.1737-3.4709,0.30397-1.7783,0.43321-4.3383,1.3451-4.9463,2.56-0.60898,1.1725-2.7347,4.0364-2.7347,4.0364z'/%3E %3Cpath d='m462.46,270.3c0.34739,1.0412,2.864-1.0412,3.4274-1.7783,0.60795-0.78165,1.5199-1.9531,1.5199-1.9531s1.432-1.7349,1.8228-2.4297c0.91088-1.6491,0.69376-4.6423,0.30294-4.3818-0.47664,0.30398-2.1257,1.2149-2.56,1.3886-0.47767,0.13027-1.3451,0.43321-1.6491,1.1714-0.30398,0.78061-0.60795,1.8218-1.0846,2.2994-0.43321,0.43321-3.1669,1.952-1.7794,5.6835z'/%3E %3Cpath d='m461.55,270.3s2.0834-1.4754,2.864-2.256c0.91089-0.86746,0.43322-2.0823,0.91089-2.6903,0.38978-0.56452,1.4754-1.9531,1.1714-2.864-0.30294-0.91089-0.86746-3.4709-0.86746-3.4709s-1.0846,1.0412-1.8218,1.8228c-0.78061,0.73718-0.91088,1.3451-1.2148,2.256-0.30294,0.91089-0.91089,1.5188-1.2149,2.256-0.30397,0.73718,0,2.256,0.17266,3.1669,0.13028,0.91089,0,1.7794,0,1.7794z'/%3E %3C/g%3E %3Cg stroke-width='0.13017058' fill='none'%3E %3Cpath d='m494.83,365.23s-9.936-0.13027-10.848-1.3451'/%3E %3Cpath d='m500.56,366.45s-6.4651,1.7794-9.936,1.3451c-3.4709-0.43321-5.12,0.30397-5.9016,0.30397-0.73719,0-4.512-1.5188-4.512-1.5188'/%3E %3Cpath d='m507.19,368.84s-4.9897,0.91089-6.0309,1.2149c-1.0412,0.30294-6.1611,2.256-7.68,2.256-1.2149,0-4.1657-0.13027-4.9897,0-1.4754,0.30398-5.424,0-6.3338-0.43321'/%3E %3Cpath d='m488.37,356.95s3.7748,2.257,4.3818,2.9942c0.56349,0.78164,3.9051,3.4709,4.512,3.4709'/%3E %3Cpath d='m488.37,352.26s6.4651,5.5976,7.5063,6.3348c1.0846,0.78164,7.4194,6.9428,8.1576,7.8536'/%3E %3Cpath d='m493.61,349.87s5.12,4.0778,5.7279,5.7269c0.60691,1.6491,2.1257,3.6012,2.1257,3.6012s2.1257,4.208,2.864,4.816c0.73719,0.60691,2.256,2.2126,4.0788,3.3406'/%3E %3Cpath d='m464.41,346.1s5.3805,4.5555,6.8549,5.424'/%3E %3Cpath d='m462.16,348.96s5.424,3.7738,7.8102,4.6847c2.4297,0.86849,4.3818,1.6491,9.632,2.3873'/%3E %3Cpath d='m481.73,358.16s-6.0309-0.30397-7.072,0c-1.0412,0.30294-5.7279-0.78164-6.9428-1.0856-1.2149-0.26055-6.0309-1.1714-6.6378-1.3451'/%3E %3Cpath d='m472.53,337.81s-0.30294,3.2972,0.17369,4.6857c0.43425,1.3451,2.56,5.2492,2.3863,6.1611-0.13027,0.91088,1.2149,4.9887,2.4297,5.7269'/%3E %3Cpath d='m478.73,338.42s-1.0846,3.2972-0.60691,4.3828c0.43321,1.0412,1.1714,2.9942,1.1714,4.2081,0,1.2138,0.78061,2.9942,1.0846,3.7738,0.30397,0.73822-0.1737,3.2972,0.60691,4.0354,0.73718,0.78061,1.6491,2.1257,1.6491,2.1257'/%3E %3Cpath d='m446.49,330.74,0,0s4.816,1.8228,5.424,2.9942c0.56452,1.2159,1.4754,1.5199,1.9531,2.1268'/%3E %3Cpath d='m464.24,326.23s1.2149,4.816,0.91089,6.0309c-0.30397,1.1725-0.30397,3.6012-0.30397,4.512,0,0.91192-1.3451,4.512-1.2149,5.12'/%3E %3Cpath d='m462.29,322.15s-0.43424,2.864-0.60691,4.0778c-0.13027,1.1725,0,3.1669-0.30397,3.9051-0.30397,0.73719-0.73822,4.816,0,6.6378'/%3E %3Cpath d='m449.06,326.23s3.9051,3.2972,4.816,4.2091c0.91088,0.91089,4.9463,5.2492,5.12,6.3338,0.13027,1.0422,2.9942,4.3394,3.9051,5.12'/%3E %3Cpath d='m442.42,309.35s3.9051,3.9051,4.2091,4.816c0.30294,0.91192,1.9531,2.3863,2.7337,2.864'/%3E %3Cpath d='m460.77,311s-1.4754,2.257-1.4754,2.9942c0,0.78164-0.60691,2.7347-1.2149,3.4709-0.38979,0.5211-1.6491,2.7337-1.5188,4.0778'/%3E %3Cpath d='m459.6,304.66s-0.60691,2.1268-0.91088,3.6011c-0.30397,1.5188-1.0846,3.0377-1.3451,3.9475-0.30398,0.91192-1.5188,5.2502-1.0846,7.9839'/%3E %3Cpath d='m445.89,304.53s0.43425,2.0833,1.4754,3.1669c1.0846,1.0422,2.7337,2.561,2.864,3.4274,0.1737,0.91088,1.5188,5.4229,3.0377,6.9428,1.5188,1.5188,1.6491,3.0377,1.6491,3.0377'/%3E %3Cpath d='m444.37,289.18s0.43322,2.56,0.73719,3.2972c0.30397,0.73822,1.5188,4.0788,2.7337,5.12'/%3E %3Cpath d='m457.34,289.91s-0.78061,2.0823-0.91089,2.9942c-0.1737,0.91088-1.0846,1.9531-1.2148,2.4297-0.1737,0.43321-0.73719,1.952-0.73719,1.952'/%3E %3Cpath d='m460.03,291.99c-0.13028,0.91088-1.8228,3.6446-1.9531,4.0788-0.1737,0.47664-1.0412,2.56-1.952,3.1669-0.91088,0.60691-3.6011,2.56-3.4709,3.3406'/%3E %3Cpath d='m448.27,286.14s-0.13027,3.2972,0.47664,4.512c0.60794,1.2148,1.3451,3.0377,1.6491,3.9485,0.30397,0.86746,0.30397,2.3863,0.43321,3.4274,0.1737,1.0846,0.60795,3.0376,1.2149,3.7738'/%3E %3Cpath d='m463.81,275.9s-2.1702,2.4731-3.1679,3.4709c-0.99773,0.99774-4.816,5.12-4.9897,5.8572'/%3E %3Cpath d='m460.21,273.64s-2.1257,4.6423-2.6034,5.3805c-0.43425,0.78061-0.86746,1.9955-0.86746,1.9955'/%3E %3Cpath d='m454.78,273.47s0.13027,3.6446,0,4.5554c-0.17266,0.86746-0.17266,2.3863,0,2.864,0.13027,0.43321-0.47664,3.7314-0.60691,4.512'/%3E %3Cpath d='m472.22,264.14s-4.816,2.864-5.5542,3.6011'/%3E %3Cpath transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M42.888,45.28,39.699,49.938,38.985,51.281' stroke-width='0.1259'/%3E %3Cpath d='m465.63,259.93s-1.0846,2.56-1.2149,3.6011c-0.1737,1.0846-1.6491,4.3828-2.256,5.5976'/%3E %3Cpath d='m469.23,257.98s-0.47767,1.0412,1.3451,0.73822' stroke-width='0.26034117'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23g3' transform='matrix(-1,0,0,1,1030.0497,0)'/%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m514.57,366.14s0.73718-1.8218,2.256-0.1737c0,0,1.8218,4.2525,0.43321,4.3818-1.3451,0.17474-2.6903,0.43425-2.8205-0.30293-0.17267-0.73719,0.13131-3.9051,0.13131-3.9051z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m516.52,365.54s0.47663-6.4651,1.3451-6.7691c0.91088-0.30397,3.6435-1.8228,5.2926-0.47767,1.6491,1.3886,0.13027,8.0708-0.47664,8.6787-0.56452,0.60691-1.4754,2.4731-4.9463,2.0389l-0.47767-1.6481s1.8228-0.1737,3.0377-0.78165c1.2149-0.60794,1.6057-1.1714,1.5188-1.7794-0.1737-0.91089-0.0869-4.2515-0.99773-4.5555-0.91192-0.30397-2.3439-0.73718-2.3439-0.73718s-1.3451,5.0321-1.6481,6.4641l-0.30397-0.43321z'/%3E %3Cpath d='m514.44,370.05s-6.2046,3.6011-3.0377,9.0251l-2.1257-1.3451s-1.1714,2.1268-0.13027,3.3406c0,0-4.2081-3.7748-0.91088-8.2879,3.3406-4.5554,6.0308-4.2515,6.0308-4.2515l0.1737,1.5188z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%2300209f'/%3E %3Cpath d='m514.44,367.06s-2.7337-1.8228-6.6388-0.78165c0,0-1.736-5.5966-1.0846-7.376,0.30293-0.82403,0.91088-0.91088,0.91088-0.91088s-1.9531-1.1725-1.3451,4.0778c0.60691,5.2937,1.6481,6.7691,1.6481,6.7691s5.12,0.30294,6.3348-0.30397l0.17473-1.4744z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%2300209f'/%3E %3Cpath d='m514.44,367.06s-5.4239-9.0685-6.8115-9.0685c0,0-1.5622-0.21712,1.952-0.60795,1.2148-0.13027,3.1669,0,4.0788,1.6925,0.91089,1.6491,1.6481,5.5532,1.952,6.1611,0,0-1.0412,0.30398-1.1714,1.8228z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%2300209f'/%3E %3Cpath d='m514.44,367.06s-3.6446-1.6925-4.0788-2.1268c-0.47664-0.43425-1.2149-5.5532-0.78061-5.2502,0,0-1.4754-1.6915-1.952-1.6915-0.30397,0-1.3451,0.78061-1.0412,2.56,0.30293,1.8228,0.73718,4.5554,1.2148,5.7269-0.001,0,2.8629-1.1704,6.6378,0.78165z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%23011322'/%3E %3Cpath d='m517.74,370.05s1.9531,1.2149,1.9531,3.4709,0.91089,6.3348,2.7337,7.2457c0,0,0.43321-1.6925,1.0412-1.9965,0,0,1.8228,2.1268,2.3873,2.1268,0,0-1.0422-1.9531-1.0422-2.864,0-0.91192-0.91089-4.3818-1.8228-5.2502-0.86746-0.91088-2.6903-3.0377-5.2492-3.7748v1.0422h-0.001z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%2300209f'/%3E %3Cpath d='m518.48,359.51-1.6481,6.4641,0.43322,1.3896s0.60794-0.1737,0.91088-0.91192c0.30397-0.78061,1.2159-6.3348,1.6925-6.5085l-1.3886-0.43321z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%23011322'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m514.35,369.31s-2.9508,0.91192-4.0778,3.2103c0,0-0.39082-1.4754,3.9909-3.6011l0.0868,0.39082z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m517.83,369.31s2.0389,0.82507,2.56,2.0399c0,0-1.9531-1.3017-2.56-1.5188v-0.52z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m514.35,367.58s-4.5989,0.73822-5.5976,0.52109c0,0,1.3886,0.30398,5.6845-0.0868l-0.0869-0.43424z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m521.82,364.8s0.5211,2.3005,0.86849,2.1702c0.38979-0.1737,1.1714-3.8617,1.2149-5.5966,0.0869-1.6936-0.73822-2.0834-1.432-1.9965-0.65137,0.0434-1.0422,1.5622-0.95534,2.256,0.0434,0.65034,0.21712,2.7771,0.30397,3.1669z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m516.83,365.97s1.8652,4.1657,0.43321,4.3818c-1.3886,0.21816,0.60795,0.17474-0.34739-2.6903-0.38979-1.0846-0.99774-2.4297-1.3017-2.4297,0.001,0.001,1.0856,0.39186,1.2159,0.73822z'/%3E %3Cpath d='m514.57,366.14s0.73718-1.8218,2.256-0.1737c0,0,1.8218,4.2525,0.43321,4.3818-1.3451,0.17474-2.6903,0.43425-2.8205-0.30293-0.17267-0.73719,0.13131-3.9051,0.13131-3.9051z' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='none'/%3E %3Cpath d='m516.52,365.54s0.47663-6.4651,1.3451-6.7691c0.91088-0.30397,3.6435-1.8228,5.2926-0.47767,1.6491,1.3886,0.13027,8.0708-0.47664,8.6787-0.56452,0.60691-1.4754,2.4731-4.9463,2.0389l-0.47767-1.6481s1.8228-0.1737,3.0377-0.78165c1.2149-0.60794,1.6057-1.1714,1.5188-1.7794-0.1737-0.91089-0.0869-4.2515-0.99773-4.5555-0.91192-0.30397-2.3439-0.73718-2.3439-0.73718s-1.3451,5.0321-1.6481,6.4641l-0.30397-0.43321z' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='none'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m509.84,255.9c-0.39082-0.95431-0.47663-7.376-0.39082-8.3737,0.13028-1.736,3.1235-10.24,3.7314-11.238,0.65137-0.99773,0.47767-1.2149,0.73719-1.8228l0.86745-1.1714c0.65137,1.0846,1.128,2.7771,1.2583,4.1222,0,0-0.56349,4.0788-1.0412,5.9016-0.43321,1.8218-1.6057,4.3383-1.8228,4.8594-0.56349,1.2583-0.52007,2.4297-0.17267,2.5166l-3.1669,5.2058z'/%3E %3Cpath fill-rule='evenodd' fill='%23fff' d='m515.01,247.35,0.47767,0.52006c1.3451-1.432,1.431-4.4252,1.431-4.4252l-0.86746-6.0309s-0.56349,4.0788-1.0412,5.9016c-0.43321,1.8218-1.6057,4.3383-1.8228,4.8594-0.86746,2.1702-0.21609,2.4297-0.17266,2.5166l1.9955-3.3416z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m515.48,247.87c1.3451-1.432,1.431-4.4252,1.431-4.4252s0.95534,4.9028,0.43425,5.945c-0.52007,1.0412-0.52007,0.73718-0.43425,1.2583l-1.431-2.7782z'/%3E %3Cpath d='m516.91,250.65c-0.0858-0.52109-0.0858-0.21712,0.43425-1.2583,0.52109-1.0412-0.43425-5.945-0.43425-5.945l-0.86746-6.0309c-0.13027-1.3451-0.60691-3.0377-1.2583-4.1222l-0.86746,1.1714c-0.25951,0.60692-0.0858,0.82404-0.73719,1.8228-0.60691,0.99773-3.6011,9.5017-3.7314,11.238-0.0858,0.99773,0,7.4194,0.39082,8.3737' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.26034117' fill='none'/%3E %3Cg%3E %3Cpath d='m515.01,234.11s-0.0869-0.95431-0.1737-1.3017c-0.0434-0.17369,0.52007,0.86746,0.99774,0.73719,0.86746,0.26055,1.8228,1.432,2.0834,1.736-0.39083,0.56349-1.3017,1.6491-1.9531,1.432-0.56349-0.1737-0.43321-0.99773-0.60794-1.5188-0.0869-0.25951-0.38979-0.60691-0.34637-1.0846z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m515.05,233.33c0.0434,0.0434,0.30294,0.3474,0.34739,0.39082,0.21609,0.13028,0.43322,0,0.69376,0.1737,0.65034,0.43321,0.86746,0.82404,1.5623,1.5188' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m515.66,233.99c0.82403,0.38979,1.2583,1.0412,1.8228,1.7349,0,0,0.0434-0.0868,0-0.0868' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m514.09,233.42s0.86746-0.43321,1.1714-0.60691c0.17369-0.0868-0.65034,0.78061-0.34637,1.1714,0.0434,0.91088-0.69376,2.2126-0.95431,2.56-0.65033-0.1737-1.3017-0.1737-1.8218-1.1714-0.21713-0.3474,0.38978-0.73822,0.78061-1.0846,0.21609-0.17473,0.69376-0.73822,1.1704-0.86849z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m514.87,233.16c-0.0434,0.0868-0.25952,0.38979-0.25952,0.52006-0.0434,0.21713,0.13028,0.39083,0.0869,0.69376-0.1737,0.73719-0.47767,1.0846-0.86746,1.9955' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m514.44,233.99c-0.0869,0.91088-0.52109,1.5178-0.99773,2.2994,0-0.0434,0.13027,0,0.13027,0' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m515.44,232.81c0.60691-0.73718,1.6915-1.3886,2.2126-0.9543,0.0434,0.0434,0.47664,0.30294,0.60691,0.56348,0.26055,0.30398,0.21712,0.43425,0.0869,0.78165-0.38979,0.78061-1.432,0.38978-2.0823,0.0434-0.13027-0.0868-0.52006-0.43425-0.73718-0.3474-0.3474,0.13028-0.21713,0.13028-0.3474,0.13028,0.12924,0.0868,0.26055,0.0434,0.3474,0.0868,0.60691,0.17266,1.0412,0.52006,1.7783,0.86746,0.5211,0.21609,1.4754-0.47767,1.432-0.95431,0-0.56452-0.91088-1.5623-1.3451-1.5623-0.99773,0-1.7794,0.60692-2.4731,1.3886,0.1737-0.13027,0.38979,0.13027,0.5211-0.0434z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m514.87,232.81c-0.56349-0.73718-1.6491-1.3886-2.1692-0.9543-0.0434,0.0434-0.47767,0.30294-0.60691,0.56348-0.26055,0.26055-0.26055,0.43425-0.0869,0.78165,0.3474,0.78061,1.432,0.38978,2.0389,0.0434,0.1737-0.0868,0.56452-0.43425,0.78061-0.3474,0.3474,0.13028,0.21713,0.13028,0.3474,0.13028-0.13027,0.0868-0.26055,0.0434-0.39082,0.0868-0.56349,0.17266-0.99773,0.52006-1.7783,0.86746-0.52007,0.21609-1.432-0.47767-1.432-0.95431,0.0434-0.60795,0.9543-1.5623,1.3886-1.5623,0.99773,0,1.7794,0.60692,2.4297,1.3886-0.1313-0.13027-0.34739,0.13027-0.52109-0.0434z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m515.09,232.38c-0.26055-0.0868-0.56349,0.17267-0.65033,0.34637-0.0869,0.21712,0.0868,0.56348,0.34636,0.60691,0.3474,0.13027,0.82403,0.0434,0.91088-0.34637,0.0869-0.34739-0.30294-0.43424-0.60691-0.60691z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath fill-rule='evenodd' fill='%23FC0' d='m515.05,226.35s0.39082,2.3439,1.5622,4.0354-1.432,1.4754-1.6057,2.0823c0,0-0.78061-1.6915-1.6057-2.1257,0,0,1.3017-2.0389,1.6491-3.9485v-0.0434z'/%3E %3Cpath d='m515.05,226.35c0,0 0.39082,2.3439 1.5622,4.0354 0,0 -1.432,1.4754 -1.6057,2.0823 0,0 -0.78061,-1.6915 -1.6057,-2.1257 0,0 1.3017,-2.0389 1.6491,-3.9485' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m515.01,228.82c0,0 0.30294,1.0412 0.65034,1.736 0,0 -0.56349,0.43425 -0.65034,0.69376 0,0 -0.30294,-0.69376 -0.60691,-0.86746 -10e-4,0 0.56349,-0.91088 0.60691,-1.5622z' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%23fff' d='m515.01,344.54c-0.0869,0-0.21712-0.17473-0.34636-0.21815-0.39082-0.25952-1.128-0.25952-1.3017-0.47664-1.0412-1.1714-0.34739-3.4274,0.0858-4.816,0.86746-2.6034,0.99773-4.9897,1.5622-7.4628h0.0434c0.56348,2.4731,0.69376,4.8594,1.5188,7.4628,0.47663,1.3886,1.1714,3.6446,0.13027,4.816-0.21712,0.21712-0.91088,0.21712-1.3017,0.47664-0.1313,0.0434-0.26054,0.21815-0.39082,0.21815z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m515.01,331.48c0.56452,2.4731,0.73719,4.9897,1.5623,7.5931,0.43321,1.3017,1.0846,3.384,0.30397,4.5555v-0.0434c0.38979,0,0.73718-0.13027,1.0846-0.26055,0.13027-0.0434,0.25951-0.0869,0.30294-0.21712,0.13027-0.21609,0.30397-0.38979,0.47767-0.52006,0.26055-0.1737,0.56452-0.0434,0.82507-0.21713,0.0869-0.0868,0.13027-0.17369,0.1737-0.17369,0.52006-0.26055,1.0412-0.56452,1.2583-1.128,0.13027-0.39082,0.1737-0.82507,0.0869-1.2593-0.0434-0.30294-0.1737-0.52006-0.26055-0.78061-0.1737-0.39082-0.3474-0.78164-0.5211-1.1714-0.17369-0.39082-0.43424-0.73822-0.60691-1.129-0.0868-0.21609-0.1737-0.38979-0.30397-0.56349-0.0869-0.17369-0.21712-0.34739-0.30397-0.52109-0.0868-0.1737-0.30397-0.30397-0.43425-0.47767-0.1737-0.1737-0.21712-0.1737-0.3474-0.30294-0.0434-0.0434-0.25951-0.0869-0.21609-0.1737-0.0868,0-0.21712-0.0868-0.26054-0.13027-0.3474-0.73822-0.65137-1.128-0.99774-1.8662-0.17369-0.30397-0.21712-0.86746-0.21712-1.2149h-1.6057v0.002z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m515.01,331.48c-0.52006,2.4731-0.69376,4.9897-1.5622,7.5931-0.39082,1.3017-1.0412,3.384-0.26055,4.5555l-0.0434-0.0434h0.0434c-0.38979,0-0.73718-0.13027-1.128-0.26055-0.0868-0.0434-0.21712-0.0869-0.30397-0.21712-0.12924-0.21609-0.25951-0.38979-0.47664-0.52006-0.21712-0.1737-0.52006-0.0434-0.78061-0.21713-0.0869-0.0868-0.13027-0.17369-0.21609-0.17369-0.52109-0.26055-0.99773-0.56452-1.2148-1.128-0.13028-0.39082-0.1737-0.82507-0.0869-1.2593,0.0434-0.30294,0.17266-0.52006,0.26055-0.78061,0.17369-0.39082,0.34636-0.78164,0.52006-1.1714,0.1737-0.39082,0.38979-0.73822,0.60691-1.129,0.0869-0.21609,0.1737-0.38979,0.30397-0.56349,0.0868-0.17369,0.17267-0.34739,0.30294-0.52109,0.0869-0.1737,0.30397-0.30397,0.43425-0.47767,0.1737-0.1737,0.21712-0.1737,0.34636-0.30294,0.0434-0.0434,0.26055-0.0869,0.21712-0.1737,0.0868,0,0.21609-0.0868,0.21609-0.13027,0.39083-0.73822,0.6948-1.128,1.0412-1.8662,0.1737-0.30397,0.21712-0.86746,0.21712-1.2149h1.5633v0.002z'/%3E %3Cg id='g1' stroke-width='0.17359523' stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m514.27,331.57s-0.99773,4.0778-1.5622,5.12c-0.60691,1.0412-2.9508,2.9508-1.432,5.9006' stroke='%23011322'/%3E %3Cpath d='m514.35,331.57s-0.95431,4.1212-1.5622,5.1624c-0.60795,1.0856-2.9074,3.0377-1.3451,5.9885' stroke='%23011d33'/%3E %3Cpath d='m514.48,331.57s-0.99774,4.1646-1.6057,5.2492c-0.56349,1.0422-2.864,3.08-1.2583,6.0319' stroke='%23022743'/%3E %3Cpath d='m514.57,331.57s-0.95431,4.2515-1.5623,5.2926c-0.60691,1.0422-2.864,3.1235-1.2583,6.1611' stroke='%23033054'/%3E %3Cpath d='m514.7,331.57s-0.99773,4.2949-1.6057,5.3795c-0.60691,1.0422-2.8195,3.1669-1.1714,6.2046' stroke='%23053a65'/%3E %3Cpath d='m514.18,331.57s-0.9543,3.9475-1.6057,5.0766c-0.60692,1.0846-2.9508,2.9942-1.3886,5.9006' stroke='%23011d33'/%3E %3Cpath d='m514.05,331.61s-0.91088,3.7738-1.6046,5.0331c-0.60795,1.0412-2.9508,2.9508-1.3886,5.8572' stroke='%23022743'/%3E %3Cpath d='m513.96,331.61s-0.91088,3.6446-1.6481,4.9897c-0.56452,1.0412-2.9508,2.9508-1.3886,5.9006' stroke='%23033054'/%3E %3Cpath d='m513.83,331.61s-0.82403,3.5567-1.6491,4.9463c-0.56349,1.0846-2.9064,2.9508-1.3875,5.9006' stroke='%23053a65'/%3E %3Cpath d='m513.75,331.65s-0.82403,3.383-1.6491,4.9028c-0.60691,1.0412-2.9508,2.9508-1.3886,5.8572' stroke='%2300209f'/%3E %3Cpath d='m514.79,331.57s-0.95431,4.3818-1.5622,5.4229c-0.60692,1.0422-2.7771,3.2538-1.1714,6.3348' stroke='%2300209f'/%3E %3C/g%3E %3Cuse xlink:href='%23g1' transform='matrix(-1,0,0,1,1030.0498,0)'/%3E %3Cpath d='m518.65,335.17c0.13028,0.1737,0.3474,0.30397,0.43425,0.47767,0.0869,0.1737,0.21712,0.3474,0.30397,0.5211,0.13027,0.1737,0.21712,0.3474,0.30397,0.56348,0.17267,0.39083,0.43322,0.73822,0.60691,1.129,0.1737,0.38978,0.3474,0.78061,0.5211,1.1714,0.0869,0.26055,0.21712,0.47767,0.26055,0.78061,0.0868,0.43424,0.0434,0.86849-0.0869,1.2593-0.21712,0.56349-0.73822,0.86746-1.2583,1.128-0.0434,0-0.0869,0.0869-0.1737,0.1737-0.26055,0.1737-0.56452,0.0434-0.82507,0.21712-0.1737,0.13028-0.3474,0.30397-0.47767,0.52006-0.0434,0.13028-0.17267,0.1737-0.30294,0.21713-0.3474,0.13027-0.69479,0.26054-1.0846,0.26054v0.0434-0.0434c-0.0434,0.0869-0.13028,0.1737-0.1737,0.26055-0.21712,0.21713-0.91088,0.21713-1.3017,0.47664-0.13027,0.0434-0.26054,0.21816-0.39082,0.21816-0.0869,0-0.21712-0.17474-0.34636-0.21816-0.39082-0.25951-1.128-0.25951-1.3017-0.47664-0.0869-0.0869-0.13027-0.1737-0.1737-0.26055v0.0434l-0.0434-0.0434h0.0434c-0.38978,0-0.73718-0.13027-1.128-0.26054-0.0868-0.0434-0.21713-0.0868-0.30398-0.21713-0.12924-0.21609-0.25951-0.38978-0.47663-0.52006-0.21713-0.1737-0.52006-0.0434-0.78061-0.21712-0.0869-0.0868-0.13028-0.1737-0.21609-0.1737-0.5211-0.26055-0.99774-0.56452-1.2149-1.128-0.13027-0.39082-0.1737-0.82507-0.0869-1.2593,0.0434-0.30294,0.17267-0.52006,0.26055-0.78061,0.1737-0.39082,0.34636-0.78165,0.52006-1.1714,0.1737-0.39083,0.38979-0.73822,0.60691-1.129,0.0869-0.21608,0.1737-0.38978,0.30398-0.56348,0.0868-0.1737,0.17266-0.3474,0.30293-0.5211,0.0868-0.1737,0.30398-0.30397,0.43425-0.47767' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='none'/%3E %3C/g%3E %3Cg id='g2'%3E %3Cg fill-rule='evenodd'%3E %3Cpath fill='%23fff' d='m487.37,293.56c-1.4754-3.688-3.0377-11.238-2.9508-12.973,0.30294-7.1154,0.21713-9.2412,0.86746-16.53l7.3326,8.3737c-0.1737,2.8205-0.21713,3.688,0,5.4663,0.0869,0.65137,0.47767,3.8617,0.99773,5.12l-6.247,10.543z'/%3E %3Cpath fill='%2300209f' d='m493.61,283.01c-0.52006-1.2583-0.91088-4.4686-0.99773-5.12-0.21712-1.7783-0.1737-2.6468,0-5.4663l4.512,4.9897-3.5143,5.5966z'/%3E %3Cpath fill='%2300209f' d='m474.96,289.91c-0.13027-1.6491-0.26055-3.4709-0.26055-4.2949,0.0434-5.12-0.56349-7.9839,0-13.407,0.43425-4.2515,1.4754-9.8491,1.2583-14.448-0.0869-1.3017,0.17267-2.6034,0.21713-3.8617l9.1119,10.153c-0.65034,7.2891-0.56452,9.4149-0.86746,16.53-0.0869,1.7349,1.4754,9.2846,2.9508,12.973l-1.9086,3.2103-10.502-6.8549z'/%3E %3Cpath fill='%2300209f' d='m481.34,303.67c-0.60691-0.99774-1.128-3.8617-1.2583-4.4252-0.30294-1.5188-0.30294-2.3873-0.21609-4.9897l5.0331,3.2972-3.5588,6.1177z'/%3E %3Cpath fill='%2300209f' d='m466.97,327.7c-0.56452-0.34637-1.5188-1.3451-1.8228-2.2126-0.60795-1.736-0.47767-1.6925-0.91089-3.6012-0.25951-1.0846-0.25951-2.2994-0.52109-3.4274-0.21609-1.128-1.8218-4.7292-1.8652-6.2046-0.17267-4.7281-1.736-7.9395-1.3451-13.103,0.26054-3.992,1.1714-9.4149,0.73718-13.581-0.13027-1.128,0.0434-2.4307,0.0868-3.5577l10.24,6.6822c-0.39082,6.8549-0.21713,8.7645-0.21713,15.402-0.0434,1.6057,1.3886,8.1132,3.1235,11.021l-7.5052,12.582z'/%3E %3Cpath fill='%2300209f' d='m483.98,331.48c1.9096,1.736,5.424,2.6468,5.9885,3.0377,1.2583,0.91088,3.1235,2.256,6.2914,2.4297,2.3429,0.1737,3.384-0.43321,5.7703-0.73718,2.7337-0.3474-0.34739,0.0868,2.2994-0.47767,1.3451-0.3474,1.3451-0.56453,3.1669-0.99774,1.3451-0.30397,2.6903-0.65137,3.5143-1.7794,0.30397-0.43425,0.56452-0.78061,0.60794-1.4754h1.8218c0.1737,0.52006-0.3474,1.5188-0.52006,1.8662-0.13028,0.1737-0.3474,0.47663-0.47664,0.65033-0.26055,0.56452-0.21712,0.43425-0.6948,0.8685-0.12924,0.0869-0.69376,0.56348-0.86745,0.65033-0.34637,0.26055-0.69377,0.60795-1.0846,0.65137-1.7794,0.30397-2.5166,0.69376-4.2091,1.1714-1.6057,0.47768-0.73718,0.39083-1.952,0.6948-0.60691,0.12924-1.8228,0.60691-2.4297,0.69376-1.0846,0.1737-1.2583,0.3474-2.3863,0.60794-2.9074,0.65034-5.7269,0.47664-8.5908,0.30398-1.1714-0.0868-4.0354-0.6948-5.0331-1.3896-1.7794-1.2583-5.6845-1.7349-7.4194-2.9498-0.25952-0.17473-1.3451-0.69479-1.5612-0.91192-1.6925-1.3886-3.0377-1.7794-4.816-2.9074h12.581z'/%3E %3Cpath fill='%2300209f' d='m497.74,331.48,13.885,0c-0.0434,0.6948-0.30397,1.0412-0.60794,1.4754-0.82404,1.128-2.1692,1.4754-3.5143,1.7794-1.432,0.34637-2.9074-0.43424-4.4252-0.43424-3.6456-1.128-4.0788-2.257-5.3371-2.8205z'/%3E %3Cpath fill='%23fff' d='m497.74,331.48c1.2583,0.65137,1.8662,1.736,5.3371,2.8205,1.3451,0,2.8205,0.60794,4.0788,0.56452-1.5188,0.34739-1.5623,0.56348-2.8205,0.86746-2.6468,0.56452,0.43321,0.13027-2.2994,0.47767-2.3863,0.30397-3.4274,0.91088-5.7703,0.73718-3.1669-0.1737-5.0331-1.5188-6.2914-2.4297-0.56452-0.39082-4.0788-1.3017-5.9885-3.0377h13.754z'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.17359523' stroke-miterlimit='2.61310005'%3E %3Cg%3E %3Cpath d='m476.65,259.71s1.6925,14.969,7.5063,14.406' stroke='%23022743'/%3E %3Cpath d='m484.16,274.03c-2.9074,0.13027-4.816-3.5577-5.9006-7.0286-1.128-3.5577-1.6057-7.2891-1.6057-7.3326' stroke='%23022847'/%3E %3Cpath d='m484.16,273.99c-2.9074-0.0868-4.816-3.8172-5.8137-7.072-1.1714-3.4274-1.6925-7.2457-1.6925-7.2891' stroke='%23032b4c'/%3E %3Cpath d='m484.2,273.95c-2.9074-0.25951-4.8594-4.0778-5.8137-7.1154-1.128-3.3406-1.6925-7.1589-1.736-7.2457' stroke='%23032d4f'/%3E %3Cpath d='m484.2,273.9c-2.9074-0.47664-4.8594-4.3818-5.7703-7.1589-1.128-3.2538-1.736-7.1154-1.7794-7.2457' stroke='%23032f53'/%3E %3Cpath d='m484.24,273.82c-2.9508-0.60692-4.9028-4.5989-5.7269-7.1589-1.128-3.1669-1.8228-7.072-1.8662-7.2023' stroke='%23043258'/%3E %3Cpath d='m484.24,273.77c-2.9074-0.82403-4.9028-4.8594-5.6845-7.2023-1.128-3.08-1.8652-6.9852-1.8652-7.1589' stroke='%2304345b'/%3E %3Cpath d='m484.29,273.73c-2.9508-0.99774-4.9463-5.12-5.6845-7.2891-1.0846-2.9074-1.9086-6.8983-1.9086-7.072' stroke='%2304365e'/%3E %3Cpath d='m484.29,273.69c-2.9508-1.2148-4.9463-5.3805-5.5976-7.3326-1.128-2.8205-1.952-6.8115-1.9955-7.072' stroke='%23043862'/%3E %3Cpath d='m484.29,273.6c-2.9074-1.3451-4.9463-5.64-5.5542-7.3326-1.128-2.7337-1.9955-6.7691-2.0389-7.0286' stroke='%23053b67'/%3E %3Cpath d='m484.33,273.55c-2.9508-1.5188-4.9897-5.9006-5.5542-7.376-1.0846-2.6468-2.0389-6.6822-2.0823-6.9852' stroke='%23053d6a'/%3E %3Cpath d='m484.33,273.51c-2.9508-1.736-4.9897-6.1611-5.4674-7.4194-1.128-2.56-2.1257-6.6388-2.1692-6.9417' stroke='%23053f6e'/%3E %3Cpath d='m484.37,273.47c-2.9508-1.9086-5.0331-6.4206-5.4674-7.5063-1.0846-2.3863-2.1257-6.552-2.2126-6.8983' stroke='%23064172'/%3E %3Cpath d='m476.69,259.02c0.0868,0.38978,1.1714,4.5554,2.256,6.8549,0.39082,0.82403,2.4731,5.4239,5.4239,7.5063' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m476.87,256.33s4.8594,11.889,7.9395,10.544' stroke='%23022743'/%3E %3Cpath d='m484.81,266.87c-1.3451,0.56349-3.3406-1.8228-4.9463-4.5989-1.736-3.0377-2.9942-5.9885-2.9942-5.9885' stroke='%23022a49'/%3E %3Cpath d='m484.81,266.83c-1.1714,0.52006-3.2537-1.7794-4.9028-4.6423-1.7794-3.1669-3.0376-5.944-3.0376-5.944' stroke='%23032d4f'/%3E %3Cpath d='m484.81,266.79c-0.99773,0.43321-3.1669-1.736-4.8594-4.6857-1.8662-3.3406-3.0377-5.9006-3.0377-5.9006' stroke='%23033054'/%3E %3Cpath d='m484.81,266.79c-0.82403,0.34739-3.1235-1.736-4.7726-4.7726-1.952-3.4709-3.1235-5.8572-3.1235-5.8572' stroke='%23043359'/%3E %3Cpath d='m484.85,266.74c-0.69376,0.30397-3.08-1.6925-4.7726-4.816-1.9955-3.6446-3.1235-5.8572-3.1235-5.8572' stroke='%23043760'/%3E %3Cpath d='m484.85,266.74c-0.52006,0.21712-2.9942-1.6925-4.7292-4.9028-2.0389-3.7748-3.1669-5.8148-3.1669-5.8148' stroke='%23053a65'/%3E %3Cpath d='m484.85,266.7c-0.34636,0.17369-2.9074-1.6491-4.6857-4.9463-2.1257-3.9485-3.1669-5.7713-3.1669-5.7713' stroke='%23053d6a'/%3E %3Cpath d='m484.85,266.7c-0.17267,0.0434-2.8205-1.6491-4.6423-4.9897-2.1692-4.1222-3.2114-5.7703-3.2114-5.7703' stroke='%23064171'/%3E %3Cpath d='m477,255.9s1.0412,1.432,3.2538,5.7269c1.8228,3.4274,4.5989,5.0331,4.5989,5.0331' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M492.88,278.72 496.65,278.02' stroke='%2300209f'/%3E %3Cpath d='M492.62,274.86 496.7,277.07' stroke='%2300209f'/%3E %3Cpath d='M492.53,275.03 496.7,277.07' stroke='%23064171'/%3E %3Cpath d='M492.53,275.2 496.74,277.11' stroke='%23053e6c'/%3E %3Cpath d='M492.53,275.42 496.74,277.16' stroke='%23053b67'/%3E %3Cpath d='M492.57,275.59 496.78,277.2' stroke='%23043862'/%3E %3Cpath d='M492.57,275.77 496.83,277.2' stroke='%2304355c'/%3E %3Cpath d='M492.57,275.94 496.87,277.24' stroke='%23043258'/%3E %3Cpath d='M492.57,276.11 496.91,277.29' stroke='%23032f53'/%3E %3Cpath d='M492.57,276.33 496.96,277.33' stroke='%23032c4d'/%3E %3Cpath d='M492.57,276.51 497,277.37' stroke='%23022a49'/%3E %3Cpath d='M492.83,278.54 496.7,277.98' stroke='%23064171'/%3E %3Cpath d='M492.83,278.33 496.74,277.89' stroke='%23053e6c'/%3E %3Cpath d='M492.79,278.11 496.78,277.85' stroke='%23053b67'/%3E %3Cpath d='M492.79,277.94 496.83,277.81' stroke='%23043862'/%3E %3Cpath d='M492.75,277.72H496.87' stroke='%2304355c'/%3E %3Cpath d='M492.75,277.5 496.91,277.68' stroke='%23043258'/%3E %3Cpath d='M492.75,277.33 496.96,277.59' stroke='%23032f53'/%3E %3Cpath d='M492.7,277.11 497.04,277.55' stroke='%23032c4d'/%3E %3Cpath d='M492.7,276.9 497.09,277.5' stroke='%23022a49'/%3E %3Cpath d='M492.66,276.72 497.13,277.42' stroke='%23022743'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m474.96,277.81s0.21712,3.1669,0.91088,4.512c0.99774,1.8662,3.9051,4.7302,7.2457,6.8125' stroke='%23022743'/%3E %3Cpath d='m483.2,289.13c-2.1692-1.3886-4.1212-3.1235-5.4663-4.6423-0.73822-0.78061-1.3451-1.6057-1.736-2.256-0.69376-1.3886-0.99774-4.512-0.99774-4.512' stroke='%23022847'/%3E %3Cpath d='m483.29,289.13c-2.1692-1.3886-4.1222-3.2537-5.424-4.7292-0.73719-0.78061-1.3451-1.5622-1.6915-2.2994-0.78061-1.3886-1.1714-4.4686-1.1714-4.4686' stroke='%23032b4c'/%3E %3Cpath d='m483.33,289.13c-2.1257-1.432-4.0778-3.384-5.3371-4.7726-0.69376-0.78061-1.3017-1.6057-1.6915-2.3429-0.82507-1.4754-1.3017-4.4686-1.3017-4.4686' stroke='%23032d4f'/%3E %3Cpath d='m483.42,289.09c-2.1257-1.432-4.0778-3.4274-5.3371-4.816-0.65033-0.73719-1.2148-1.5623-1.6491-2.3429-0.86746-1.5188-1.432-4.4686-1.432-4.4686' stroke='%23032f53'/%3E %3Cpath d='m483.5,289.09c-2.1257-1.432-4.0354-3.5577-5.2937-4.9028-0.60691-0.69376-1.2149-1.5188-1.6491-2.3429-0.91088-1.5622-1.5188-4.4686-1.5188-4.4686' stroke='%23043258'/%3E %3Cpath d='m483.59,289.09c-2.1257-1.4754-4.0354-3.688-5.2502-4.9897-0.60691-0.69376-1.1714-1.5178-1.6491-2.3429-0.95431-1.6491-1.6491-4.4686-1.6491-4.4686' stroke='%2304345b'/%3E %3Cpath d='m483.63,289.09c-2.0389-1.5188-3.992-3.8183-5.1634-5.0766-0.56452-0.65034-1.1714-1.4744-1.6491-2.3429-0.99773-1.6925-1.7794-4.4696-1.7794-4.4696' stroke='%2304365e'/%3E %3Cpath d='m483.72,289.05c-2.0399-1.4754-3.992-3.8617-5.12-5.12-0.56349-0.60795-1.128-1.4754-1.6491-2.3429-1.0412-1.736-1.9086-4.4696-1.9086-4.4696' stroke='%23043862'/%3E %3Cpath d='m483.81,289.05c-2.0399-1.5188-3.992-3.992-5.0766-5.2068-0.52006-0.56452-1.128-1.432-1.6491-2.3429-1.0846-1.8228-1.9955-4.4696-1.9955-4.4696' stroke='%23053b67'/%3E %3Cpath d='m483.85,289.05c-1.9965-1.5188-3.9051-4.1222-4.9897-5.2937-0.52007-0.56452-1.0846-1.432-1.6491-2.3429-1.0846-1.8652-2.1257-4.4686-2.1257-4.4686' stroke='%23053d6a'/%3E %3Cpath d='m483.94,289.05c-1.9955-1.5622-3.9051-4.2091-4.9463-5.3371-0.47664-0.56452-1.0846-1.432-1.6491-2.3863-1.128-1.9086-2.256-4.4686-2.256-4.4686' stroke='%23053f6e'/%3E %3Cpath d='m484.03,289c-1.9955-1.5622-3.9051-4.2949-4.9029-5.3805-0.47767-0.52006-1.0412-1.432-1.6057-2.3863-1.2149-1.9965-2.4297-4.4686-2.4297-4.4686' stroke='%23064172'/%3E %3Cpath d='m475.09,276.68s2.8205,5.3371,4.1657,6.8549c0.95431,1.0412,2.864,3.9051,4.8594,5.4674' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m475.17,289.91c3.08,2.0389,3.8617,2.56,10.239,6.6378l1.9531-2.9942s-0.73718-1.7783-1.0412-2.6034' stroke='%23011d33'/%3E %3Cpath d='m475.22,289.87c2.9508,1.9965,3.9475,2.6468,10.195,6.5509l0.0869-0.0858c0-0.0434,1.7349-2.9074,1.7349-2.9074s-0.0868-0.34636-0.30293-0.78061c-0.21713-0.56349-0.47768-1.2149-0.60795-1.6915' stroke='%23011e34'/%3E %3Cpath d='m475.22,289.87c2.864,1.9096,4.1222,2.7337,10.195,6.4651l0.0869-0.13027c0-0.0868,1.6481-2.9074,1.6481-2.9074s-0.0868-0.30293-0.25951-0.73718c-0.21712-0.52006-0.43425-1.1714-0.56452-1.6046' stroke='%23022037'/%3E %3Cpath d='m475.22,289.87c2.7771,1.8218,4.2949,2.7771,10.195,6.3348l0.0869-0.13028c0-0.0868,1.5612-2.864,1.5178-2.864,0,0-0.0434-0.30398-0.21609-0.6948-0.1737-0.52006-0.39082-1.128-0.52109-1.5612' stroke='%23022139'/%3E %3Cpath d='m475.22,289.83c2.6903,1.7784,4.4686,2.864,10.195,6.248l0.0869-0.13027c0-0.13027,1.432-2.864,1.432-2.864s0-0.26055-0.1737-0.65137c-0.21713-0.52006-0.39083-1.0412-0.47767-1.4744' stroke='%2302223b'/%3E %3Cpath d='m475.26,289.83c2.56,1.6925,4.5989,2.9508,10.152,6.1177,0.0434,0,0.0869-0.13027,0.0869-0.13027,0-0.1737,1.3451-2.8205,1.3451-2.864-0.0434,0,0-0.21713-0.1737-0.60691-0.1737-0.47664-0.30398-0.95431-0.39082-1.3886' stroke='%2302233d'/%3E %3Cpath d='m475.26,289.78c2.4731,1.6491,4.7726,3.0377,10.197,6.0309,0,0,0.0434-0.13028,0.0869-0.13028,0-0.21609,1.2149-2.8205,1.1714-2.8205,0,0,0.0434-0.21713-0.0869-0.60691-0.1737-0.43322-0.30398-0.86746-0.3474-1.3017' stroke='%23022540'/%3E %3Cpath d='m475.26,289.78c2.3863,1.6057,4.9463,3.08,10.197,5.9006l0.0869-0.13027c0-0.21609,1.0846-2.7771,1.0846-2.8205,0,0,0.0869-0.17369-0.0868-0.52006-0.1737-0.47664-0.26055-0.82403-0.30398-1.2583' stroke='%23022541'/%3E %3Cpath d='m475.26,289.78c2.2994,1.5188,5.12,3.1669,10.197,5.8137,0-0.0434,0.0869-0.17266,0.0869-0.17266,0-0.26055,0.99774-2.7771,0.95431-2.8205,0,0,0.13028-0.13027,0-0.47663-0.1737-0.43425-0.21712-0.78061-0.26055-1.1714' stroke='%23022743'/%3E %3Cpath d='m475.3,289.74c2.1692,1.4754,5.2502,3.2538,10.153,5.7279,0-0.0434,0.0869-0.13027,0.0869-0.1737,0-0.30397,0.86746-2.7771,0.86746-2.7771s0.13028-0.13027,0-0.47663c-0.1737-0.39082-0.1737-0.69376-0.1737-1.0846' stroke='%23022847'/%3E %3Cpath d='m475.3,289.74c2.0823,1.3886,5.3805,3.3406,10.153,5.5976,0.0434-0.0434,0.0869-0.13027,0.0869-0.1737,0-0.34636,0.78061-2.7337,0.73719-2.7771,0,0,0.21712-0.12924,0.0869-0.43321-0.1737-0.39082-0.13028-0.60691-0.13028-0.99774' stroke='%23022a49'/%3E %3Cpath d='m475.3,289.74c1.9955,1.3017,5.5532,3.384,10.153,5.4674,0.0434-0.0434,0.0869-0.13028,0.13028-0.1737-0.0434-0.3474,0.65033-2.7337,0.60691-2.7337,0-0.0434,0.21712-0.13027,0.0869-0.43321-0.13027-0.3474-0.0869-0.5211-0.0869-0.91089' stroke='%23032a4a'/%3E %3Cpath d='m475.35,289.7c1.8652,1.2583,5.6835,3.4709,10.11,5.3805,0.0434-0.0434,0.0869-0.12924,0.13028-0.17266,0-0.39083,0.52006-2.6903,0.47664-2.7337,0,0,0.25951-0.0869,0.17266-0.34636-0.17266-0.3474-0.0868-0.47767-0.0434-0.86746' stroke='%23032b4c'/%3E %3Cpath d='m475.35,289.7c1.7783,1.1714,5.8572,3.5577,10.11,5.2502,0.0434,0,0.13028-0.13028,0.13028-0.1737,0-0.43321,0.43321-2.6903,0.38979-2.7337,0,0,0.30294-0.0434,0.17266-0.30294-0.12924-0.34739,0-0.39082,0.0434-0.78061' stroke='%23032d4f'/%3E %3Cpath d='m475.35,289.7c1.6915,1.0846,6.0309,3.6011,10.153,5.1634,0-0.0434,0.0869-0.1737,0.0869-0.21713,0-0.43321,0.34636-2.6468,0.30294-2.6903h-0.0434s0.34637-0.0434,0.26055-0.30397c-0.13027-0.30294,0-0.30294,0.0858-0.69376' stroke='%23032e50'/%3E %3Cpath d='m475.35,289.65c1.6046,1.0846,6.2046,3.688,10.153,5.0766,0.0434-0.0434,0.0869-0.17266,0.0869-0.21609,0-0.47663,0.21609-2.6468,0.17266-2.6903l0.26055-0.26054c-0.13027-0.25952,0.0434-0.25952,0.17267-0.60692' stroke='%23032f53'/%3E %3Cpath d='m475.39,289.65c1.4754,0.99774,6.3338,3.7748,10.11,4.9463,0.0434-0.0434,0.0869-0.1737,0.0869-0.21712,0-0.52007,0.12924-2.6468,0.0858-2.6903,0,0,0.39083,0.0434,0.30398-0.17267-0.13028-0.30397,0.0868-0.21712,0.17266-0.56349' stroke='%23033156'/%3E %3Cpath d='m475.39,289.61c1.3886,0.95431,6.5075,3.8617,10.11,4.8594,0.0434-0.0434,0.0869-0.1737,0.12924-0.21713,0-0.56348-0.0434-2.6034-0.0858-2.6468,0,0,0.43322,0.0434,0.34637-0.17267-0.0868-0.26055,0.13027-0.13027,0.25951-0.47664' stroke='%23043258'/%3E %3Cpath d='m475.39,289.61c1.3017,0.86746,6.6812,3.9051,10.11,4.7292,0.0434-0.0434,0.0869-0.1737,0.12924-0.21712,0-0.56349-0.12924-2.6034-0.17267-2.6468,0,0,0.43322,0.0858,0.38979-0.13027-0.13027-0.21712,0.13028-0.0434,0.30294-0.38979' stroke='%23043359'/%3E %3Cpath d='m475.39,289.61c1.2148,0.78061,6.8115,3.992,10.11,4.5989,0.0434-0.0434,0.12924-0.12924,0.12924-0.21609,0-0.60795-0.21712-2.56-0.30397-2.6468,0,0,0.52109,0.13028,0.43424-0.0869-0.0869-0.21712,0.21713,0.0434,0.38979-0.30294' stroke='%2304355c'/%3E %3Cpath d='m475.43,289.57c1.0846,0.73718,6.9417,4.0788,10.066,4.5554,0.0434-0.0858,0.12924-0.17267,0.12924-0.25952,0-0.65033-0.34636-2.56-0.38979-2.6034,0,0,0.52006,0.0869,0.43321-0.0434-0.0434-0.21712,0.26055,0.0868,0.43425-0.25952' stroke='%2304365e'/%3E %3Cpath d='m475.43,289.57c0.99773,0.65033,7.1154,4.1657,10.066,4.4262,0.0869-0.0869,0.12924-0.1737,0.12924-0.26055,0-0.65033-0.43321-2.5166-0.52006-2.6034,0,0,0.56348,0.13027,0.52006,0-0.0858-0.17267,0.30397,0.13027,0.47767-0.17267' stroke='%23043760'/%3E %3Cpath d='m475.43,289.57c0.91088,0.56452,7.2891,4.208,10.11,4.2959,0.0434-0.0868,0.0858-0.17369,0.12924-0.26054-0.0434-0.69376-0.56348-2.5166-0.65033-2.6034,0,0,0.60691,0.17369,0.52109,0.0434-0.0434-0.17266,0.34637,0.21712,0.56349-0.0858' stroke='%23043862'/%3E %3Cpath d='m475.48,289.52c0.78164,0.5211,7.4194,4.2959,10.066,4.2091,0.0434-0.0434,0.0858-0.1737,0.12924-0.26055,0-0.73718-0.69376-2.5166-0.73718-2.56h-0.0434s0.65137,0.17266,0.60795,0.0434c-0.0434-0.13027,0.34636,0.30294,0.60691,0' stroke='%23053a65'/%3E %3Cpath d='m475.48,289.52c0.69479,0.47767,7.5931,4.3828,10.066,4.0788,0.0434-0.0434,0.12924-0.1737,0.12924-0.26055,0-0.78061-0.78061-2.4731-0.86746-2.56,0,0,0.65137,0.21609,0.60692,0.13028-0.0434-0.13028,0.43424,0.34636,0.69479,0.0434' stroke='%23053b67'/%3E %3Cpath d='m475.48,289.52c0.60691,0.39082,7.7668,4.4262,10.066,3.9485,0.0434-0.0434,0.12924-0.1737,0.12924-0.25951,0-0.78164-0.86746-2.4731-0.9543-2.5166v-0.0434s0.69376,0.26055,0.65033,0.1737c-0.0434-0.13027,0.43425,0.43321,0.6948,0.13027' stroke='%23053c68'/%3E %3Cpath d='m475.48,289.48c0.52109,0.34739,7.9405,4.5131,10.066,3.9051,0.0858-0.0869,0.12924-0.21609,0.12924-0.30293,0-0.82404-0.99773-2.4297-1.0846-2.5166,0,0,0.73719,0.26055,0.69376,0.1737-0.0434-0.0868,0.47664,0.52006,0.78061,0.21712' stroke='%23053e6c'/%3E %3Cpath d='m475.52,289.48c0.39082,0.26054,8.0708,4.5999,10.023,3.7748,0.0858-0.0869,0.12924-0.21712,0.17267-0.30397-0.0434-0.86746-1.128-2.4297-1.2149-2.5166,0,0,0.73719,0.30398,0.73719,0.21713-0.0434-0.0434,0.52006,0.60691,0.82403,0.30397' stroke='%23053f6e'/%3E %3Cpath d='m475.52,289.48c0.30397,0.17369,8.2011,4.6423,10.023,3.6446,0.0858-0.0869,0.12924-0.21713,0.17267-0.30398,0-0.86746-1.2583-2.4297-1.3451-2.4731,0,0,0.82403,0.30397,0.78061,0.26054,0-0.0869,0.56348,0.60691,0.91088,0.3474' stroke='%23053f6f'/%3E %3Cpath d='m475.52,289.43c0.21712,0.13028,8.3748,4.7292,10.023,3.5577,0.0858-0.0868,0.12924-0.1737,0.17267-0.30397,0-0.91088-1.3451-2.3863-1.432-2.4731,0,0,0.82403,0.3474,0.82403,0.30397-0.0434-0.0434,0.60691,0.69376,0.91089,0.43425' stroke='%23064171'/%3E %3Cpath d='m475.52,289.43c0.13027,0.0434,8.5474,4.816,10.066,3.4274,0.0434-0.0868,0.12924-0.1737,0.12924-0.30397,0-0.95431-1.432-2.3863-1.5622-2.4731l0.86745,0.34636s0.65034,0.78061,0.99774,0.5211' stroke='%23064374'/%3E %3Cpath d='m475.57,289.39s9.7189,5.4674,10.153,3.0377c0-0.99774-1.6491-2.4297-1.6491-2.4297l0.91088,0.34637s0.65034,0.86745,1.0412,0.60794' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m474.44,315.12-7.5497,12.582c-0.56452-0.34637-1.5188-1.3451-1.8228-2.2126-0.56452-1.736-0.47767-1.736-0.91089-3.6012-0.21608-1.0846-0.25951-2.2994-0.47663-3.4274-0.26055-1.128-1.8662-4.7292-1.9096-6.2046' stroke='%23011d33'/%3E %3Cpath d='m461.77,312.26c0.0434,1.4754,1.6491,4.9897,1.9096,6.1177,0.21712,1.129,0.26055,2.3439,0.47663,3.4274,0.43322,1.8662,0.34637,1.8228,0.95431,3.5577,0.26055,0.86746,1.2583,1.8662,1.7794,2.2126,0.0434,0,7.5063-12.452,7.5497-12.452' stroke='%23011d33'/%3E %3Cpath d='m461.77,312.26c0.0434,1.433,1.6491,4.9463,1.8662,6.0743,0.26055,1.129,0.30398,2.3005,0.56349,3.384,0.43321,1.8228,0.30294,1.8228,0.91088,3.5577,0.30398,0.82404,1.2583,1.8228,1.7794,2.1702,0.0434,0,7.4628-12.28,7.5497-12.322' stroke='%23011e34'/%3E %3Cpath d='m461.77,312.26c0.0434,1.433,1.6057,4.9028,1.8662,6.0308,0.26055,1.0856,0.30398,2.257,0.56349,3.3406,0.43321,1.8228,0.30294,1.7794,0.91088,3.5143,0.30398,0.82507,1.2583,1.7794,1.7794,2.1268,0.0868,0.0434,7.4628-12.106,7.5497-12.149' stroke='%23011e34'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3896,1.6057,4.8594,1.8662,5.944,0.26055,1.129,0.30398,2.257,0.56349,3.3406,0.43321,1.7794,0.34636,1.7794,0.91088,3.4709,0.30398,0.82404,1.2583,1.7794,1.7794,2.1268,0.13027,0.0434,7.4194-11.976,7.5497-12.018' stroke='%23011f36'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3896,1.6057,4.816,1.8662,5.9016,0.26055,1.0846,0.30398,2.256,0.56349,3.2961,0.43321,1.7794,0.34636,1.736,0.95431,3.4274,0.30294,0.82507,1.2148,1.7794,1.7794,2.1268,0.0868,0.0434,7.3326-11.846,7.5063-11.888' stroke='%23011f36'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3896,1.5622,4.7292,1.8662,5.8148,0.26055,1.0846,0.30398,2.256,0.56349,3.2961,0.43321,1.736,0.34636,1.736,0.95431,3.384,0.30294,0.82507,1.2148,1.7794,1.7794,2.1268,0.13027,0.0434,7.3326-11.715,7.5063-11.758' stroke='%23022037'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3462,1.5622,4.6857,1.8662,5.7713,0.26055,1.0846,0.30398,2.2126,0.56349,3.2538,0.43321,1.7349,0.38979,1.7349,0.95431,3.3396,0.30294,0.82507,1.2148,1.7794,1.7794,2.0834,0.17266,0.0868,7.2891-11.498,7.5063-11.584' stroke='%23022037'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3462,1.5622,4.6423,1.8662,5.7279,0.26055,1.0412,0.30398,2.1692,0.56349,3.2103,0.43321,1.6925,0.38979,1.6925,0.99773,3.3396,0.30294,0.78165,1.2149,1.6925,1.736,2.0399,0.17266,0.0434,7.2891-11.368,7.5063-11.454' stroke='%23022139'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3027,1.5622,4.5989,1.8662,5.6411,0.26055,1.0846,0.30398,2.1692,0.56349,3.2103,0.43321,1.6925,0.38979,1.6925,0.99773,3.2961,0.30294,0.78164,1.2149,1.6925,1.736,2.0399,0.21608,0.0434,7.2457-11.238,7.5063-11.323' stroke='%23022139'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3027,1.5188,4.5554,1.8662,5.5976,0.26055,1.0412,0.30398,2.1257,0.60691,3.1669,0.43322,1.6915,0.34637,1.6481,0.95431,3.2538,0.30294,0.78061,1.2149,1.6925,1.736,2.0389,0.25951,0.0434,7.2023-11.107,7.5063-11.193' stroke='%23022139'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3027,1.5188,4.4696,1.8662,5.5542,0.26055,0.99773,0.30398,2.1257,0.60691,3.08,0.43322,1.6925,0.38979,1.6925,0.95431,3.2537,0.30294,0.78061,1.2149,1.6915,1.736,1.9955,0.25951,0.0869,7.2023-10.934,7.5063-11.02' stroke='%2302223b'/%3E %3Cpath d='m461.77,312.26c0.0434,1.2593,1.5188,4.4262,1.8662,5.4674,0.26055,1.0412,0.30398,2.1268,0.60691,3.08,0.43322,1.6925,0.38979,1.6925,0.99774,3.2103,0.30294,0.78061,1.1714,1.6491,1.6925,1.9965,0.30293,0.0858,7.1589-10.761,7.5063-10.89' stroke='%2302223b'/%3E %3Cpath d='m461.77,312.26c0.0434,1.2593,1.5188,4.3828,1.8662,5.4239,0.26055,0.99774,0.30398,2.0834,0.60691,3.0377,0.43322,1.6491,0.38979,1.6491,0.99774,3.2103,0.30294,0.73719,1.1714,1.6057,1.736,1.9531,0.30294,0.0868,7.072-10.631,7.4628-10.76' stroke='%2302233d'/%3E %3Cpath d='m461.77,312.26c0.0434,1.2159,1.4754,4.3394,1.8662,5.3805,0.26055,0.99773,0.30398,2.0399,0.60691,2.9942,0.43322,1.6491,0.43322,1.6491,0.99774,3.1669,0.30294,0.73719,1.2148,1.6057,1.736,1.9531,0.30294,0.0858,7.072-10.5,7.4628-10.63' stroke='%2302233d'/%3E %3Cpath d='m461.77,312.26c0.0434,1.2159,1.4754,4.2949,1.8662,5.2937,0.26055,0.99773,0.3474,2.0399,0.60691,2.9942,0.43322,1.6057,0.43322,1.6057,0.99774,3.1235,0.34636,0.73718,1.2148,1.6057,1.736,1.9096,0.34636,0.13027,7.0286-10.327,7.4628-10.456' stroke='%2302233e'/%3E %3Cpath d='m461.77,312.26c0.0434,1.1725,1.4754,4.2091,1.8662,5.2502,0.26055,0.99774,0.3474,1.9965,0.60691,2.9508,0.43322,1.6057,0.43322,1.6057,1.0412,3.08,0.30294,0.73822,1.1714,1.6057,1.6925,1.9096,0.38979,0.13028,7.0286-10.197,7.4628-10.326' stroke='%2302233e'/%3E %3Cpath d='m461.77,312.21c0.0434,1.2159,1.4754,4.2091,1.8228,5.2502,0.30397,0.95431,0.39082,1.9965,0.65033,2.9074,0.43322,1.5623,0.43322,1.6057,1.0412,3.0377,0.30294,0.73822,1.1714,1.5623,1.6925,1.9096,0.38979,0.13028,6.9852-10.023,7.4628-10.195' stroke='%23022540'/%3E %3Cpath d='m461.77,312.21c0.0434,1.2159,1.432,4.1657,1.8228,5.1634,0.30397,0.95431,0.39082,1.9965,0.65033,2.9074,0.47664,1.5623,0.47664,1.5623,1.0412,3.0377,0.30294,0.6948,1.1714,1.5188,1.6925,1.8228,0.43321,0.13028,6.9417-9.8491,7.4628-10.022' stroke='%23022540'/%3E %3Cpath d='m461.77,312.21c0.0434,1.1725,1.432,4.1222,1.8228,5.12,0.26055,0.9543,0.39082,1.9531,0.69376,2.864,0.43321,1.5188,0.43321,1.5622,1.0412,2.9942,0.30294,0.69479,1.128,1.5188,1.6491,1.8228,0.47664,0.13027,6.9417-9.7188,7.4628-9.8915' stroke='%23022540'/%3E %3Cpath d='m461.77,312.21c0.0434,1.1725,1.432,4.0354,1.8228,5.0766,0.26055,0.91089,0.39082,1.9096,0.69376,2.8205,0.43321,1.5188,0.43321,1.5188,1.0412,2.9508,0.30294,0.6948,1.1714,1.5188,1.6491,1.8228,0.47664,0.13027,6.8983-9.5886,7.4628-9.7612' stroke='%23022541'/%3E %3Cpath d='m461.77,312.21c0.0434,1.129,1.432,3.992,1.8228,4.9897,0.26055,0.95534,0.39082,1.9096,0.69376,2.8205,0.43321,1.4754,0.47664,1.5188,1.0412,2.9084,0.30294,0.69377,1.1714,1.5178,1.6925,1.8218,0.47664,0.13028,6.8549-9.4583,7.4194-9.631' stroke='%23022541'/%3E %3Cpath d='m461.77,312.21c0.0434,1.129,1.3886,3.9485,1.8228,4.9463,0.26055,0.91191,0.39082,1.8662,0.69376,2.7771,0.43321,1.4754,0.47664,1.4754,1.0412,2.865,0.34636,0.69376,1.1714,1.4754,1.6925,1.7783,0.52007,0.1737,6.8115-9.2412,7.4194-9.4573' stroke='%23022743'/%3E %3Cpath d='m461.77,312.21c0.0434,1.129,1.3886,3.9051,1.8228,4.9028,0.26055,0.8685,0.39082,1.8662,0.69376,2.7347,0.43321,1.432,0.47664,1.4744,1.0846,2.8629,0.30294,0.65137,1.128,1.433,1.6491,1.736,0.52007,0.1737,6.768-9.1119,7.4194-9.327' stroke='%23022743'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0856,1.3886,3.8617,1.8228,4.816,0.26055,0.91192,0.39082,1.8662,0.69376,2.7347,0.43321,1.432,0.47664,1.4754,1.0846,2.8205,0.30294,0.65033,1.128,1.432,1.6491,1.736,0.56349,0.17266,6.768-8.9827,7.4194-9.1978' stroke='%23022845'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0856,1.3886,3.7748,1.8228,4.7726,0.26055,0.86849,0.39082,1.8228,0.69376,2.6913,0.43321,1.3886,0.52109,1.432,1.0846,2.7771,0.34636,0.65034,1.128,1.432,1.6491,1.736,0.60692,0.17266,6.7246-8.8524,7.4194-9.0685' stroke='%23022845'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0422,1.3451,3.7314,1.8228,4.7292,0.26055,0.8685,0.39082,1.7794,0.69376,2.6479,0.47664,1.3886,0.52109,1.432,1.0846,2.7337,0.34636,0.65034,1.128,1.432,1.6491,1.6925,0.60692,0.21712,6.6812-8.6787,7.4194-8.8948' stroke='%23022847'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0422,1.3451,3.688,1.8228,4.6423,0.26055,0.8685,0.39082,1.7794,0.73718,2.6479,0.43322,1.3451,0.47767,1.3886,1.0846,2.6903,0.30293,0.65137,1.128,1.3886,1.6057,1.6925,0.65034,0.21713,6.6812-8.5484,7.4194-8.808' stroke='%23022847'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0422,1.3451,3.6446,1.8228,4.5989,0.26055,0.86849,0.39082,1.736,0.73718,2.561,0.43322,1.3886,0.52007,1.432,1.0846,2.6903,0.30293,0.65034,1.128,1.3886,1.6057,1.6925,0.69377,0.1737,6.6378-8.3748,7.4194-8.6777' stroke='%23022847'/%3E %3Cpath d='m461.77,312.21c0.0434,0.99877,1.3451,3.6012,1.8228,4.5555,0.26055,0.82506,0.39082,1.736,0.73718,2.5176,0.43322,1.3451,0.52007,1.432,1.0846,2.6903,0.34636,0.60795,1.128,1.3451,1.6491,1.6491,0.65034,0.17369,6.5943-8.2445,7.376-8.5474' stroke='%23022a49'/%3E %3Cpath d='m461.77,312.21c0.0434,0.99877,1.3017,3.5143,1.8228,4.4696,0.26055,0.82403,0.39082,1.7349,0.73718,2.5166,0.43322,1.3451,0.52007,1.3886,1.0846,2.6468,0.34636,0.60794,1.128,1.3451,1.6491,1.6057,0.69376,0.21712,6.5509-8.0708,7.376-8.3737' stroke='%23022a49'/%3E %3Cpath d='m461.77,312.21c0.0434,0.95534,1.3017,3.4709,1.8228,4.4262,0.26055,0.82403,0.43321,1.6915,0.73718,2.4731,0.43322,1.3017,0.52007,1.3886,1.128,2.6034,0.30397,0.60795,1.0846,1.3451,1.6057,1.6057,0.73718,0.21713,6.5075-7.9405,7.376-8.2434' stroke='%23032a4a'/%3E %3Cpath d='m461.77,312.21c0.0434,0.95534,1.3017,3.4274,1.7794,4.3828,0.30398,0.78061,0.47664,1.6481,0.78061,2.4297,0.43322,1.3017,0.56349,1.3451,1.128,2.56,0.3474,0.60795,1.0846,1.3027,1.6057,1.6057,0.73718,0.21712,6.5075-7.8102,7.376-8.1132' stroke='%23032a4a'/%3E %3Cpath d='m461.81,312.21c0,0.95534,1.2149,3.384,1.736,4.2949,0.30398,0.82507,0.47664,1.6501,0.78061,2.4307,0.43322,1.2583,0.56349,1.3451,1.128,2.5166,0.3474,0.60794,1.128,1.3017,1.6057,1.5622,0.78061,0.26055,6.4641-7.5931,7.376-7.9395' stroke='%23032b4c'/%3E %3Cpath d='m461.81,312.21c0,0.91192,1.2149,3.3406,1.736,4.2525,0.30398,0.78061,0.47664,1.6057,0.78061,2.3863,0.47767,1.2583,0.56349,1.3451,1.1714,2.5166,0.30397,0.56452,1.0846,1.2593,1.5622,1.5199,0.82403,0.25951,6.4206-7.4639,7.376-7.8102' stroke='%23032b4c'/%3E %3Cpath d='m461.81,312.21c0,0.91192,1.2149,3.2538,1.736,4.1657,0.30398,0.78061,0.47664,1.6491,0.78061,2.3863,0.47767,1.2583,0.56349,1.3017,1.1714,2.4742,0.30397,0.56348,1.0846,1.2583,1.5622,1.5178,0.82403,0.26055,6.4206-7.3326,7.376-7.6789' stroke='%23032c4d'/%3E %3Cpath d='m461.81,312.21c0,0.8685,1.2149,3.2103,1.736,4.1222,0.30398,0.78061,0.47664,1.6057,0.82404,2.3429,0.43424,1.2148,0.56348,1.3017,1.128,2.4307,0.34739,0.56349,1.0846,1.2583,1.5622,1.5188,0.86746,0.26055,6.3772-7.2033,7.376-7.5497' stroke='%23032c4d'/%3E %3Cpath d='m461.81,312.21c0,0.8685,1.1714,3.1669,1.736,4.0788,0.30398,0.73718,0.47664,1.5622,0.82404,2.2994,0.43424,1.2159,0.56348,1.2593,1.128,2.3873,0.34739,0.56349,1.0846,1.2149,1.6057,1.4754,0.86746,0.30294,6.3348-7.0296,7.3326-7.376' stroke='%23032c4d'/%3E %3Cpath d='m461.81,312.21c0,0.8685,1.1714,3.1235,1.736,3.992,0.30398,0.78061,0.47664,1.5622,0.82404,2.2994,0.43424,1.1725,0.56348,1.2593,1.1714,2.3439,0.30397,0.56348,1.0412,1.2148,1.5622,1.4754,0.86746,0.26055,6.2914-6.8559,7.3326-7.2457' stroke='%23032d4f'/%3E %3Cpath d='m461.81,312.21c0,0.82507,1.1714,3.08,1.736,3.9485,0.30398,0.73719,0.47664,1.5188,0.82404,2.256,0.43424,1.1725,0.60691,1.2148,1.1714,2.3439,0.3474,0.52109,1.0412,1.1714,1.5622,1.432,0.91089,0.26054,6.248-6.7257,7.3326-7.1154' stroke='%23032d4f'/%3E %3Cpath d='m461.81,312.21c0,0.82507,1.1714,2.9942,1.736,3.9051,0.30398,0.73718,0.47664,1.4754,0.82404,2.2126,0.43424,1.129,0.60691,1.2159,1.1714,2.3005,0.3474,0.5211,1.0846,1.1714,1.5622,1.432,0.95431,0.26055,6.248-6.5954,7.3326-6.9852' stroke='%23032e50'/%3E %3Cpath d='m461.81,312.21c0,0.78165,1.128,2.9508,1.736,3.8183,0.30398,0.73719,0.47664,1.5188,0.82404,2.2126,0.43424,1.129,0.60691,1.2159,1.1714,2.257,0.3474,0.52109,1.0846,1.1714,1.5622,1.3886,0.95431,0.30398,6.2046-6.4217,7.3326-6.8115' stroke='%23032e50'/%3E %3Cpath d='m461.81,312.21c0,0.78165,1.128,2.9084,1.736,3.7748,0.30398,0.69479,0.47664,1.4754,0.82404,2.1702,0.43424,1.0846,0.60691,1.1714,1.2148,2.2126,0.3474,0.5211,1.0412,1.128,1.5188,1.3886,0.99774,0.30397,6.2046-6.2914,7.3326-6.6812' stroke='%23032f53'/%3E %3Cpath d='m461.81,312.21c0,0.73822,1.128,2.865,1.736,3.7314,0.30398,0.6948,0.47664,1.432,0.82404,2.1268,0.47664,1.0846,0.65033,1.1714,1.2148,2.1692,0.3474,0.5211,1.0412,1.128,1.5188,1.3886,1.0412,0.30397,6.1611-6.1177,7.3326-6.5509' stroke='%23032f53'/%3E %3Cpath d='m461.81,312.21c0,0.73822,1.128,2.8216,1.736,3.6446,0.30398,0.69376,0.47664,1.432,0.82404,2.1268,0.47664,1.0412,0.65033,1.128,1.2148,2.1692,0.3474,0.47767,1.0412,1.0856,1.5623,1.3451,0.99773,0.30397,6.0743-5.9874,7.2891-6.4206' stroke='%23033054'/%3E %3Cpath d='m461.81,312.21c0,0.73822,1.0846,2.7347,1.736,3.6012,0.30398,0.69376,0.47664,1.3886,0.86746,2.0834,0.43322,1.0412,0.60691,1.128,1.1714,2.1257,0.3474,0.47767,1.0412,1.0856,1.5623,1.3017,1.0412,0.3474,6.0743-5.8137,7.2891-6.2469' stroke='%23033054'/%3E %3Cpath d='m461.81,312.21c0,0.6948,1.0846,2.6913,1.736,3.5577,0.26055,0.65137,0.52007,1.3451,0.86746,1.9965,0.43322,1.0412,0.65034,1.1714,1.2149,2.1257,0.3474,0.47767,1.0412,1.0422,1.5188,1.3027,1.0846,0.34637,6.0309-5.6845,7.2891-6.1177' stroke='%23033054'/%3E %3Cpath d='m461.81,312.21c0,0.6948,1.0846,2.6479,1.6925,3.4709,0.30397,0.65137,0.56349,1.3886,0.91088,1.9965,0.43322,1.0412,0.65034,1.128,1.2149,2.0834,0.3474,0.47664,1.0412,1.0412,1.5188,1.3017,1.0846,0.34636,5.9885-5.5542,7.2891-5.9874' stroke='%23033156'/%3E %3Cpath d='m461.81,312.21c0,0.65137,1.0846,2.6044,1.6925,3.4274,0.30397,0.65137,0.56349,1.3451,0.91088,1.9531,0.43322,0.99774,0.65034,1.128,1.2149,2.0389,0.3474,0.47768,1.0412,1.0422,1.5188,1.3027,1.128,0.30398,5.9885-5.3805,7.2891-5.8572' stroke='%23033156'/%3E %3Cpath d='m461.81,312.21c0,0.65137,1.0412,2.561,1.6925,3.384,0.30397,0.60795,0.56349,1.3017,0.91088,1.9096,0.43322,0.99774,0.65034,1.0846,1.2583,2.0399,0.3474,0.47664,0.99774,0.99773,1.4754,1.2149,1.1714,0.34739,5.945-5.2068,7.2891-5.6835' stroke='%23043258'/%3E %3Cpath d='m461.81,312.21c0,0.65137,1.0412,2.4742,1.6925,3.2972,0.30397,0.65137,0.56349,1.3017,0.91088,1.9097,0.43322,0.9543,0.69376,1.0846,1.2583,1.9965,0.3474,0.47663,0.99774,0.99773,1.4754,1.2148,1.1714,0.3474,5.945-5.0766,7.2891-5.5532' stroke='%23043258'/%3E %3Cpath d='m461.81,312.17c0,0.65137,1.0412,2.4742,1.6925,3.2972,0.30397,0.60794,0.56349,1.2593,0.91088,1.8662,0.47664,0.9543,0.69376,1.0846,1.2583,1.9531,0.3474,0.47767,0.99774,0.95431,1.4754,1.2149,1.2148,0.3474,5.9016-4.9463,7.2891-5.4229' stroke='%23043359'/%3E %3Cpath d='m461.81,312.17c0,0.65137,1.0412,2.4307,1.6925,3.2537,0.30397,0.60795,0.56349,1.2159,0.91088,1.8228,0.47664,0.91191,0.69376,1.0412,1.2583,1.9096,0.39083,0.47663,0.99774,0.95431,1.5188,1.1714,1.2149,0.39082,5.8137-4.7726,7.2457-5.2492' stroke='%23043359'/%3E %3Cpath d='m461.81,312.17c0,0.60794,0.99773,2.3873,1.6925,3.1669,0.30397,0.60794,0.56349,1.2593,0.95431,1.8228,0.43321,0.91191,0.69376,1.0412,1.2583,1.8662,0.3474,0.47767,0.99773,0.95431,1.4754,1.1714,1.2149,0.39082,5.8137-4.5989,7.2457-5.1189' stroke='%2304345b'/%3E %3Cpath d='m461.81,312.17c0,0.60794,0.99773,2.3005,1.6925,3.1235,0.30397,0.56452,0.56349,1.2149,0.95431,1.7794,0.43321,0.86849,0.69376,0.99876,1.2583,1.8228,0.3474,0.47767,0.99773,0.95534,1.4754,1.1714,1.2583,0.39082,5.7714-4.4686,7.2457-4.9887' stroke='%2304345b'/%3E %3Cpath d='m461.81,312.17c0,0.60794,0.99773,2.257,1.6925,3.08,0.30397,0.56452,0.56349,1.1725,0.95431,1.736,0.43321,0.86849,0.69376,0.99877,1.2583,1.8228,0.3474,0.43425,0.99773,0.91192,1.4754,1.128,1.3017,0.39082,5.7714-4.3383,7.2457-4.8584' stroke='%2304345b'/%3E %3Cpath d='m461.81,312.17c0,0.56452,0.95431,2.2136,1.6925,2.9942,0.30397,0.56452,0.56349,1.1725,0.95431,1.736,0.43321,0.82507,0.69376,0.95535,1.2583,1.7794,0.39082,0.43425,0.99773,0.86849,1.4754,1.0856,1.3017,0.43321,5.7279-4.1657,7.2457-4.6857' stroke='%2304355c'/%3E %3Cpath d='m461.81,312.17c0,0.56452,0.95431,2.1702,1.6925,2.9508,0.30397,0.56348,0.56349,1.128,0.95431,1.6915,0.43321,0.82507,0.73718,0.95534,1.3017,1.736,0.3474,0.43425,0.95431,0.8685,1.432,1.0846,1.3451,0.43425,5.6845-4.0344,7.2457-4.5544' stroke='%2304355c'/%3E %3Cpath d='m461.81,312.17c0,0.52109,0.95431,2.1268,1.6925,2.9084,0.30397,0.52006,0.56349,1.0846,0.95431,1.6491,0.43321,0.82403,0.73718,0.95431,1.3017,1.6915,0.3474,0.43425,0.95431,0.8685,1.432,1.0856,1.3886,0.43321,5.6845-3.9051,7.2457-4.4252' stroke='%2304365e'/%3E %3Cpath d='m461.81,312.17c0,0.52109,0.95431,2.0399,1.6925,2.8216,0.30397,0.52006,0.56349,1.128,0.95431,1.6491,0.47663,0.78061,0.73718,0.91088,1.3017,1.6481,0.39083,0.43424,0.99774,0.86849,1.432,1.0856,1.3886,0.39083,5.6411-3.7314,7.2457-4.2949' stroke='%2304365e'/%3E %3Cpath d='m461.81,312.17c0,0.52109,0.91089,1.9965,1.6925,2.7781,0.30397,0.52006,0.56349,1.0846,0.95431,1.6046,0.47663,0.78164,0.78061,0.91191,1.3017,1.6491,0.39083,0.39082,0.99774,0.82507,1.4754,0.99877,1.3886,0.43321,5.5542-3.5577,7.2023-4.1212' stroke='%23043760'/%3E %3Cpath d='m461.81,312.17c0,0.47767,0.91089,1.9531,1.6925,2.7347,0.30397,0.47663,0.56349,1.0412,0.95431,1.5622,0.47663,0.73719,0.78061,0.86746,1.3451,1.6057,0.3474,0.38979,0.95431,0.78061,1.432,0.99773,1.432,0.43425,5.5542-3.4274,7.2023-3.9909' stroke='%23043760'/%3E %3Cpath d='m461.81,312.17c0,0.47767,0.91089,1.9096,1.6491,2.6479,0.3474,0.52006,0.65034,1.0412,1.0412,1.5622,0.43425,0.73719,0.73822,0.86746,1.3017,1.5622,0.3474,0.38979,0.95431,0.78061,1.432,0.99774,1.432,0.43424,5.5108-3.2972,7.2023-3.9041' stroke='%23043862'/%3E %3Cpath d='m461.81,312.17c0,0.43424,0.91089,1.8662,1.6491,2.6044,0.3474,0.47664,0.65034,0.99774,1.0412,1.4754,0.43425,0.73718,0.73822,0.91088,1.3017,1.5622,0.39082,0.38979,0.95431,0.78061,1.432,0.99773,1.4754,0.43425,5.5108-3.1669,7.2023-3.7738' stroke='%23043862'/%3E %3Cpath d='m461.81,312.17c0,0.43424,0.86746,1.7794,1.6491,2.5176,0.3474,0.52007,0.65034,0.99774,1.0412,1.4754,0.43425,0.73718,0.78165,0.86746,1.3451,1.5188,0.3474,0.39082,0.91089,0.78061,1.3886,0.95431,1.5188,0.47767,5.4674-2.9508,7.2023-3.6001' stroke='%23043862'/%3E %3Cpath d='m461.81,312.17c0,0.43424,0.86746,1.736,1.6491,2.4742,0.3474,0.47767,0.65034,0.99773,1.0412,1.432,0.43425,0.69376,0.78165,0.86746,1.3451,1.5188,0.3474,0.34739,0.91089,0.73718,1.3886,0.91088,1.5188,0.47767,5.4239-2.8205,7.2023-3.4698' stroke='%23043963'/%3E %3Cpath d='m461.81,312.17c0,0.39082,0.86746,1.6925,1.6491,2.4307,0.3474,0.43425,0.65034,0.95431,1.0412,1.3886,0.43425,0.69479,0.78165,0.82403,1.3451,1.4754,0.38979,0.3474,0.95431,0.6948,1.3886,0.91089,1.5622,0.47767,5.4239-2.6903,7.2023-3.3396' stroke='%23043963'/%3E %3Cpath d='m461.81,312.17c0,0.39082,0.86746,1.6491,1.6491,2.3439,0.3474,0.47768,0.65034,0.95431,1.0412,1.3886,0.47767,0.65034,0.82507,0.82507,1.3451,1.432,0.38979,0.3474,0.95431,0.69479,1.3886,0.91088,1.6057,0.47767,5.3805-2.56,7.2023-3.2093' stroke='%23053a65'/%3E %3Cpath d='m461.81,312.17c0,0.34739,0.82404,1.6057,1.6491,2.3005,0.3474,0.43425,0.65034,0.91088,1.0412,1.3451,0.47767,0.65137,0.82507,0.82507,1.3886,1.3886,0.34636,0.34739,0.91088,0.69479,1.3886,0.86849,1.6057,0.52006,5.2937-2.3873,7.1589-3.0377' stroke='%23053a65'/%3E %3Cpath d='m461.81,312.17c0,0.34739,0.82404,1.5199,1.6491,2.257,0.3474,0.43424,0.65034,0.86745,1.0412,1.3017,0.47767,0.60795,0.82507,0.78061,1.3886,1.3451,0.38979,0.3474,0.91088,0.6948,1.3886,0.86849,1.6057,0.47664,5.2937-2.2136,7.1589-2.9074' stroke='%23053b67'/%3E %3Cpath d='m461.81,312.17c0,0.34739,0.82404,1.4764,1.6491,2.1702,0.3474,0.43424,0.65034,0.86746,1.0846,1.3017,0.43424,0.60795,0.78164,0.78165,1.3451,1.3451,0.38979,0.30398,0.91088,0.65137,1.3886,0.82507,1.6491,0.47664,5.2502-2.0834,7.1589-2.7771' stroke='%23053b67'/%3E %3Cpath d='m461.81,312.17c0,0.30397,0.82404,1.433,1.6491,2.1268,0.3474,0.39082,0.65034,0.86746,1.0846,1.2583,0.43424,0.56452,0.82507,0.73822,1.3451,1.3017,0.38979,0.30397,0.91088,0.60794,1.3886,0.78164,1.6925,0.5211,5.2502-1.9096,7.1589-2.6034' stroke='%23053c68'/%3E %3Cpath d='m461.81,312.17c0,0.30397,0.78061,1.3896,1.6491,2.0834,0.3474,0.39082,0.65034,0.82507,1.0846,1.2148,0.43424,0.56452,0.82507,0.73822,1.3886,1.2593,0.34637,0.30294,0.91089,0.60691,1.3451,0.78061,1.6925,0.52109,5.2068-1.7794,7.1589-2.4731' stroke='%23053c68'/%3E %3Cpath d='m461.81,312.17c0,0.26055,0.78061,1.3462,1.6491,1.9965,0.30398,0.39082,0.65034,0.82507,1.0846,1.2148,0.43424,0.5211,0.82507,0.6948,1.3886,1.2159,0.38979,0.30294,0.91089,0.60692,1.3451,0.78061,1.736,0.5211,5.1634-1.6491,7.1589-2.3429' stroke='%23053c68'/%3E %3Cpath d='m461.81,312.17c0,0.26055,0.78061,1.2593,1.6491,1.9531,0.30398,0.39082,0.65034,0.78165,1.0846,1.1714,0.43424,0.5211,0.86849,0.6948,1.3886,1.1725,0.38979,0.30294,0.91089,0.60691,1.3451,0.78061,1.7794,0.5211,5.1634-1.4754,7.1589-2.2126' stroke='%23053d6a'/%3E %3Cpath d='m461.81,312.17c0,0.21712,0.78061,1.2159,1.6491,1.9096,0.30398,0.3474,0.65034,0.73822,1.0846,1.128,0.47767,0.47767,0.86849,0.69479,1.3886,1.129,0.38979,0.30397,0.91089,0.60691,1.3451,0.73718,1.7794,0.56452,5.12-1.3017,7.1589-2.0389' stroke='%23053d6a'/%3E %3Cpath d='m461.81,312.17c0,0.21712,0.73719,1.1725,1.6491,1.8228,0.30398,0.39082,0.65034,0.73822,1.0846,1.129,0.47767,0.47664,0.86849,0.65034,1.432,1.128,0.38978,0.25951,0.86746,0.52006,1.3451,0.69376,1.7794,0.56452,5.0766-1.1714,7.1154-1.9086' stroke='%23053e6c'/%3E %3Cpath d='m461.81,312.17c0,0.21712,0.73719,1.129,1.6057,1.7794,0.3474,0.3474,0.73718,0.6948,1.128,1.0856,0.47767,0.43321,0.86849,0.65034,1.432,1.0846,0.38978,0.26055,0.86746,0.5211,1.3451,0.69376,1.8228,0.56452,5.0331-1.0412,7.1154-1.7783' stroke='%23053e6c'/%3E %3Cpath d='m461.81,312.17c0,0.1737,0.73719,1.0856,1.6057,1.736,0.3474,0.30397,0.73718,0.69479,1.128,1.0422,0.47767,0.43321,0.91088,0.60691,1.432,1.0412,0.38978,0.26055,0.86746,0.52006,1.3451,0.69479,1.8228,0.56349,4.9897-0.91191,7.1154-1.6491' stroke='%23053f6e'/%3E %3Cpath d='m461.81,312.17c0,0.1737,0.73719,0.99876,1.6057,1.6491,0.3474,0.3474,0.73718,0.69479,1.1714,1.0422,0.43425,0.38979,0.86746,0.60691,1.432,0.99774,0.34636,0.26054,0.86746,0.52109,1.3017,0.65033,1.8662,0.56452,4.9897-0.69376,7.1154-1.4744' stroke='%23053f6e'/%3E %3Cpath d='m461.81,312.17c0,0.13027,0.69376,0.95534,1.6057,1.6057,0.3474,0.30397,0.73718,0.65137,1.1714,0.95534,0.43425,0.43321,0.86746,0.65033,1.432,0.99773,0.38979,0.26055,0.86746,0.47767,1.3017,0.65137,1.9096,0.56349,4.9463-0.56452,7.1154-1.3451' stroke='%23053f6f'/%3E %3Cpath d='m461.81,312.17c0,0.13027,0.69376,0.91192,1.6057,1.5622,0.3474,0.30397,0.73718,0.60795,1.1714,0.91192,0.43425,0.39082,0.86746,0.60691,1.432,0.99773,0.38979,0.21713,0.86746,0.43425,1.3017,0.60795,1.9096,0.56348,4.9028-0.43425,7.1154-1.2149' stroke='%23053f6f'/%3E %3Cpath d='m461.81,312.17c0,0.13027,0.69376,0.86849,1.6057,1.4764,0.3474,0.30293,0.73718,0.60691,1.1714,0.91088,0.43425,0.39082,0.91089,0.60691,1.432,0.95431,0.38979,0.21712,0.86746,0.43424,1.3017,0.60794,1.9531,0.56452,4.9028-0.30397,7.1154-1.0846' stroke='%23053f6f'/%3E %3Cpath d='m461.81,312.17c0,0.0869,0.65034,0.78164,1.6057,1.433,0.3474,0.25952,0.73718,0.56349,1.1714,0.86746,0.47767,0.39082,0.91089,0.56452,1.4754,0.91088,0.38978,0.21713,0.82403,0.43425,1.2583,0.56452,1.9955,0.60692,4.8594-0.13027,7.1154-0.91088' stroke='%23064171'/%3E %3Cpath d='m461.81,312.17c0,0.0869,0.65034,0.73822,1.6057,1.3896,0.3474,0.25951,0.73718,0.56348,1.1714,0.82403,0.47767,0.3474,0.91089,0.56452,1.4754,0.86746,0.38978,0.21712,0.82403,0.43425,1.3017,0.56452,1.952,0.60795,4.816,0,7.072-0.78061' stroke='%23064171'/%3E %3Cpath d='m461.81,312.17c0,0.0434,0.65034,0.69479,1.6057,1.3027,0.3474,0.25951,0.73718,0.56348,1.1714,0.82403,0.47767,0.3474,0.95431,0.56452,1.4754,0.82507,0.38978,0.21609,0.86746,0.38979,1.3017,0.56349,1.9955,0.60794,4.7726,0.1737,7.072-0.65034' stroke='%23064172'/%3E %3Cpath d='m461.81,312.13c0,0.0869,0.65034,0.6948,1.6057,1.3027,0.3474,0.26055,0.73718,0.52006,1.1714,0.78061,0.47767,0.30397,0.95431,0.5211,1.4754,0.82507,0.43321,0.17267,0.86746,0.34636,1.3017,0.52006,2.0389,0.60795,4.7292,0.30398,7.072-0.52006' stroke='%23064172'/%3E %3Cpath d='m461.81,312.13c0,0.0869,0.60691,0.65137,1.6057,1.2593,0.3474,0.21712,0.73718,0.47664,1.1714,0.73718,0.47767,0.30398,0.95431,0.5211,1.5188,0.78165,0.38979,0.1737,0.82404,0.34636,1.2583,0.47663,2.0389,0.65137,4.7292,0.47768,7.072-0.34636' stroke='%23064374'/%3E %3Cpath d='m461.81,312.13c0,0.0434,0.60691,0.56452,1.6057,1.1725,0.3474,0.26055,0.73718,0.47664,1.2149,0.73718,0.43424,0.26055,0.91088,0.47767,1.4754,0.73822,0.38979,0.1737,0.82404,0.3474,1.2583,0.47664,2.0823,0.65137,4.6857,0.60795,7.072-0.21609' stroke='%23064374'/%3E %3Cpath d='m461.81,312.13c0,0.0434,0.60691,0.5211,1.6057,1.129,0.3474,0.21713,0.73718,0.43425,1.2149,0.69376,0.43424,0.26055,0.9543,0.47768,1.4754,0.6948,0.38979,0.1737,0.82404,0.3474,1.2583,0.47767,2.1257,0.60691,4.6423,0.73719,7.072-0.0869' stroke='%2300209f'/%3E %3Cpath d='m461.81,312.13s6.4651,5.0766,12.626,2.9084' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m461.55,292.17s1.2583,8.1132,1.736,9.2846c0.43321,1.0422,2.9942,5.6845,6.8983,6.7691' stroke='%23022743'/%3E %3Cpath d='m461.55,292.17s1.3451,8.0274,1.8662,9.1988c0.43425,1.0412,2.8205,5.4663,6.8115,6.8115' stroke='%23022a49'/%3E %3Cpath d='m461.59,292.13s1.3886,7.9839,1.9096,9.1988c0.43425,1.0412,2.6903,5.2058,6.7246,6.8549' stroke='%23032b4c'/%3E %3Cpath d='m461.59,292.13s1.4754,7.9405,1.9965,9.1119c0.47664,1.0412,2.5166,4.9887,6.6378,6.8983' stroke='%23032e50'/%3E %3Cpath d='m461.64,292.13s1.5188,7.8526,2.0399,9.0251c0.52006,1.0846,2.3863,4.7716,6.5943,6.9418' stroke='%23033054'/%3E %3Cpath d='m461.64,292.13s1.6057,7.8092,2.1702,8.9817c0.47664,1.0846,2.2126,4.4686,6.4641,6.9852' stroke='%23043359'/%3E %3Cpath d='m461.64,292.08s1.6925,7.7668,2.257,8.9382c0.52006,1.0846,2.0389,4.2525,6.3772,7.0286' stroke='%2304355c'/%3E %3Cpath d='m461.68,292.08s1.7349,7.7234,2.2994,8.8948c0.52006,1.0846,1.9086,3.992,6.2904,7.072' stroke='%23043760'/%3E %3Cpath d='m461.68,292.08s1.8218,7.6365,2.3863,8.808c0.56348,1.0846,1.7794,3.7748,6.248,7.1154' stroke='%23053a65'/%3E %3Cpath d='m461.72,292.04s1.8652,7.6365,2.4731,8.7646c0.56349,1.128,1.5622,3.5153,6.1177,7.2023' stroke='%23053c68'/%3E %3Cpath d='m461.72,292.04s1.9955,7.5497,2.56,8.7211c0.56349,1.0846,1.432,3.2538,6.0309,7.2023' stroke='%23053f6e'/%3E %3Cpath d='m461.77,292.04s2.0399,7.5063,2.6034,8.6343c0.60691,1.128,1.3017,3.0377,5.9874,7.2457' stroke='%23064172'/%3E %3Cpath d='m461.77,291.99s2.1268,7.4628,2.6903,8.5908c0.60691,1.128,1.1714,2.8205,5.9006,7.3326' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m462.07,287.18s1.0412,11.455,9.1978,14.622' stroke='%23022743'/%3E %3Cpath d='m462.07,287.18c0.0434,0.0434,0.47664,3.688,2.1257,7.2457,1.3017,2.7337,3.4709,5.8572,7.072,7.3326' stroke='%23022a49'/%3E %3Cpath d='m462.11,287.18c0,0.0434,0.52007,3.7748,2.1692,7.2023,1.2149,2.5166,3.384,5.7713,6.9852,7.376' stroke='%23032b4c'/%3E %3Cpath d='m462.11,287.18c0.0434,0.0868,0.65034,3.9051,2.256,7.1154,1.1714,2.3429,3.2972,5.7279,6.8983,7.4194' stroke='%23032e50'/%3E %3Cpath d='m462.16,287.18c0,0.0868,0.73718,3.992,2.3429,7.072,1.0412,2.1692,3.1669,5.6411,6.7691,7.4194' stroke='%23033054'/%3E %3Cpath d='m462.16,287.18c0.0434,0.13027,0.86746,4.0788,2.4297,6.9852,0.95431,1.9965,3.1235,5.5976,6.6822,7.5063' stroke='%23043359'/%3E %3Cpath d='m462.2,287.18c0,0.13027,0.95431,4.1657,2.4731,6.9417,0.91088,1.7794,3.0377,5.5108,6.5954,7.5063' stroke='%2304355c'/%3E %3Cpath d='m462.2,287.14c0.0434,0.21713,1.0846,4.3394,2.56,6.9428,0.82403,1.5612,2.9508,5.4229,6.5085,7.5052' stroke='%23043760'/%3E %3Cpath d='m462.2,287.14c0.0869,0.21713,1.2149,4.4252,2.6468,6.8559,0.78061,1.432,2.864,5.3805,6.4217,7.5486' stroke='%23053a65'/%3E %3Cpath d='m462.25,287.14c0.0434,0.26055,1.3017,4.512,2.6903,6.8125,0.69376,1.2149,2.7771,5.2937,6.3348,7.5921' stroke='%23053c68'/%3E %3Cpath d='m462.25,287.14c0.0858,0.26055,1.432,4.5999,2.8205,6.7256,0.60691,1.0412,2.6468,5.2502,6.2046,7.6355' stroke='%23053f6e'/%3E %3Cpath d='m462.29,287.14c0.0434,0.30398,1.5188,4.7302,2.864,6.6822,0.52006,0.82403,2.56,5.1634,6.1177,7.6355' stroke='%23064172'/%3E %3Cpath d='m462.29,287.14c0.0858,0.30398,1.6491,4.816,2.9508,6.5954,0.47664,0.65034,2.4731,5.12,6.0309,7.7224' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m462.16,284.01s2.3863,9.1988,9.0251,11.455' stroke='%23022743'/%3E %3Cpath d='m462.16,284.01s0.91088,3.2537,3.08,6.4217c1.432,2.1258,3.5143,4.2081,5.944,5.0331' stroke='%23022847'/%3E %3Cpath d='m462.16,283.97s0.95431,3.2103,3.1235,6.3772c1.5188,2.1692,3.6446,4.3383,5.9006,5.12' stroke='%23032a4a'/%3E %3Cpath d='m462.16,283.93s0.99773,3.1669,3.2103,6.3338c1.5623,2.2126,3.7314,4.4686,5.8137,5.1634' stroke='%23032c4d'/%3E %3Cpath d='m462.2,283.88s0.99774,3.1235,3.2538,6.3338c1.6057,2.2126,3.8617,4.5554,5.7279,5.2068' stroke='%23032f53'/%3E %3Cpath d='m462.2,283.88s1.0412,3.0376,3.3406,6.248c1.6491,2.256,3.9485,4.6857,5.6845,5.2502' stroke='%23033156'/%3E %3Cpath d='m462.2,283.84s1.0846,3.0377,3.384,6.2046c1.736,2.3429,4.1222,4.816,5.6411,5.3371' stroke='%23043359'/%3E %3Cpath d='m462.2,283.79s1.128,2.9942,3.4709,6.1611c1.7794,2.3863,4.2091,4.9463,5.5542,5.4239' stroke='%2304355c'/%3E %3Cpath d='m462.25,283.79s1.0846,2.9074,3.5143,6.1177c1.8228,2.3863,4.3394,5.0331,5.4674,5.424' stroke='%23043760'/%3E %3Cpath d='m462.25,283.75s1.128,2.864,3.6011,6.0743c1.8652,2.4297,4.4252,5.2068,5.3805,5.5108' stroke='%23043963'/%3E %3Cpath d='m462.25,283.71s1.1714,2.8205,3.6446,6.0308c1.9086,2.4731,4.5989,5.3371,5.3371,5.5976' stroke='%23053b67'/%3E %3Cpath d='m462.25,283.66s1.2148,2.7771,3.7314,6.0309c1.9531,2.5166,4.6857,5.424,5.2502,5.5976' stroke='%23053e6c'/%3E %3Cpath d='m462.29,283.66s1.2149,2.6903,3.7748,5.944c1.9955,2.56,4.816,5.5542,5.1634,5.6845' stroke='%23053f6f'/%3E %3Cpath d='m462.29,283.62s1.2583,2.6468,3.8617,5.9006c2.0389,2.6034,4.9028,5.6845,5.12,5.7713' stroke='%23064172'/%3E %3Cpath d='m462.29,283.58s1.3017,2.6034,3.9051,5.8572c2.1257,2.6468,5.0766,5.8148,5.0766,5.8148' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M479.9,296.55 484.46,297.38' stroke='%2300209f'/%3E %3Cpath d='M480.38,300.02 484.46,298.29' stroke='%2300209f'/%3E %3Cpath d='M479.86,296.68 484.42,297.38' stroke='%23064171'/%3E %3Cpath d='M479.86,296.85 484.46,297.42' stroke='%23053e6c'/%3E %3Cpath d='M479.9,297.03 484.5,297.42' stroke='%23053b67'/%3E %3Cpath d='M479.9,297.2 484.55,297.46' stroke='%23043862'/%3E %3Cpath d='M479.9,297.38 484.59,297.46' stroke='%2304355c'/%3E %3Cpath d='M479.95,297.55 484.63,297.51' stroke='%23043258'/%3E %3Cpath d='M479.95,297.68 484.68,297.51' stroke='%23032f53'/%3E %3Cpath d='M479.95,297.85 484.72,297.55' stroke='%23032c4d'/%3E %3Cpath d='M479.99,298.03 484.76,297.55' stroke='%23022a49'/%3E %3Cpath d='M480.34,299.81 484.5,298.2' stroke='%23064171'/%3E %3Cpath d='M480.29,299.63 484.55,298.11' stroke='%23053e6c'/%3E %3Cpath d='M480.29,299.46 484.59,298.07' stroke='%23053b67'/%3E %3Cpath d='M480.25,299.28 484.63,297.98' stroke='%23043862'/%3E %3Cpath d='M480.21,299.11 484.68,297.94' stroke='%2304355c'/%3E %3Cpath d='M480.21,298.94 484.72,297.85' stroke='%23043258'/%3E %3Cpath d='M480.16,298.72 484.76,297.81' stroke='%23032f53'/%3E %3Cpath d='M480.12,298.55 484.81,297.72' stroke='%23032c4d'/%3E %3Cpath d='M480.12,298.37 484.85,297.68' stroke='%23022a49'/%3E %3Cpath d='M480.08,298.2 484.89,297.59' stroke='%23022743'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m484.24,331.57s-2.4297,0.13027-2.6468,0.21712c-0.26055,0.0434-9.8926-0.1737-9.8926-0.1737' stroke='%23032b4c'/%3E %3Cpath d='m484.29,331.61s-2.3863,0.21713-2.7337,0.30398c-0.39082,0.0424-9.7623-0.26055-9.7623-0.26055' stroke='%23032e50'/%3E %3Cpath d='m484.29,331.65s-2.2994,0.30294-2.7771,0.38979c-0.52109,0.0879-9.632-0.34637-9.632-0.34637' stroke='%23033054'/%3E %3Cpath d='m484.33,331.7s-2.256,0.34637-2.864,0.47768c-0.65034,0.12924-9.5452-0.43425-9.5452-0.43425' stroke='%23043359'/%3E %3Cpath d='m484.33,331.7s-2.1692,0.47768-2.9508,0.60692c-0.73719,0.17369-9.3715-0.52007-9.3715-0.52007' stroke='%2304355c'/%3E %3Cpath d='m484.33,331.74s-2.0834,0.52006-2.9942,0.69376c-0.86746,0.21712-9.2412-0.60691-9.2412-0.60691' stroke='%23043760'/%3E %3Cpath d='m484.37,331.78s-2.0389,0.60691-3.08,0.82404c-0.99773,0.1737-9.1119-0.73719-9.1119-0.73719' stroke='%23053a65'/%3E %3Cpath d='m484.37,331.83s-1.9955,0.69376-3.1235,0.91088c-1.128,0.21713-9.0251-0.78164-9.0251-0.78164' stroke='%23053c68'/%3E %3Cpath d='m484.42,331.87s-1.952,0.73719-3.2103,0.99774c-1.2583,0.26054-8.8948-0.8685-8.8948-0.8685' stroke='%23053f6e'/%3E %3Cpath d='m484.42,331.91s-1.8662,0.82403-3.2538,1.0846c-1.3886,0.30397-8.7645-0.95534-8.7645-0.95534' stroke='%23064172'/%3E %3Cpath d='m472.48,332.09s7.1154,1.3451,8.6343,1.0412c1.5188-0.30397,3.3406-1.1725,3.3406-1.1725' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m486.06,337.07s4.5554,0.6948,4.7292,0.65137c0.0858,0,2.6468-0.1737,2.7337-0.1737,0.0434,0,2.2126-0.52109,2.2126-0.52109' stroke='%23022a49' stroke-width='0.17359523'/%3E %3Cpath d='m485.8,336.99s4.6857,0.73822,5.0331,0.65137c0.17267-0.0434,2.5166-0.1737,2.6468-0.1737,0.13027,0,2.0823-0.47767,2.0823-0.47767' stroke='%23032d4f' stroke-width='0.17359523'/%3E %3Cpath d='m485.54,336.86s4.816,0.82507,5.2937,0.69479c0.25951-0.0434,2.3863-0.1737,2.6034-0.1737,0.1737,0,1.9096-0.43424,1.9096-0.43424' stroke='%23033054' stroke-width='0.17359523'/%3E %3Cpath d='m485.28,336.73s4.9028,0.8685,5.5966,0.73822c0.34739-0.0434,2.257-0.17369,2.5166-0.17369,0.21712-0.0434,1.736-0.3474,1.736-0.3474' stroke='%23043359' stroke-width='0.17359523'/%3E %3Cpath d='m485.02,336.64s5.0331,0.91088,5.8572,0.73718c0.43424-0.0868,2.1702-0.17369,2.4731-0.21712,0.30398,0,1.5623-0.26055,1.5623-0.26055' stroke='%23043760' stroke-width='0.17359523'/%3E %3Cpath d='m484.76,336.51s5.1634,0.99773,6.1611,0.78061c0.5211-0.0869,1.9965-0.1737,2.3863-0.21713,0.3474,0,1.3886-0.21712,1.3886-0.21712' stroke='%23053a65' stroke-width='0.17359523'/%3E %3Cpath d='m484.5,336.38s5.2502,1.0846,6.4206,0.86746c0.65034-0.13027,1.9096-0.21712,2.3429-0.26055,0.43424-0.0434,1.2148-0.1737,1.2148-0.1737' stroke='%23053d6a' stroke-width='0.17359523'/%3E %3Cpath d='m484.24,336.29s5.3805,1.128,6.7246,0.86746c0.69479-0.1737,1.736-0.26055,2.256-0.26055,0.47767-0.0434,1.0846-0.0869,1.0846-0.0869' stroke='%23064171' stroke-width='0.17359523'/%3E %3Cpath transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' stroke='%23022743' d='M59.296,119.6,63.577,120.19,66.304,120.06,68.612,119.47' stroke-width='0.1679'/%3E %3Cpath d='m483.98,336.16s5.5108,1.2148,7.0286,0.91088c1.4754-0.30397,3.08-0.30397,3.08-0.30397' stroke='%2300209f' stroke-width='0.17359523'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m505.76,336.81s2.864-1.0412,4.2949-1.5612c2.6903-0.99876,2.9942-3.688,2.9942-3.688' stroke='%2300209f'/%3E %3Cpath d='m505.46,335.95s1.736-0.69376,3.1669-1.2148c3.8183-1.432,3.384-3.2538,3.384-3.2538' stroke='%2300209f'/%3E %3Cpath d='m505.2,336.12s2.256-0.86746,3.4274-1.3017c0.60794-0.21713,1.3886-0.56452,1.7794-0.82507,0.52007-0.30397,1.1714-0.91088,1.3451-1.2149,0.3474-0.52109,0.3474-1.2583,0.3474-1.2583' stroke='%23053e6c'/%3E %3Cpath d='m504.94,336.34s2.8205-1.0846,3.688-1.3886c0.43424-0.1737,1.4754-0.60794,1.736-0.78164,0.39082-0.26055,1.3017-0.99774,1.432-1.2149,0.26055-0.43425,0.43321-1.432,0.43321-1.432' stroke='%23043862'/%3E %3Cpath d='m504.68,336.51s3.384-1.2583,3.9485-1.4764c0.30397-0.0858,1.5188-0.60691,1.6925-0.69376,0.26055-0.1737,1.432-1.128,1.5188-1.2583,0.1737-0.26055,0.47768-1.5623,0.47768-1.5623' stroke='%23043258'/%3E %3Cpath d='m504.42,336.73s3.9051-1.4744,4.208-1.5622c0.13028-0.0869,1.6057-0.60691,1.6925-0.69376,0.13027-0.0434,1.5188-1.1714,1.5622-1.2583,0.0868-0.13027,0.56453-1.6491,0.56453-1.6491' stroke='%23032c4d'/%3E %3Cpath d='m505.46,336.86s3.4709-1.3017,4.6423-1.736c0.82404-0.30294,1.6925-1.0412,2.0823-1.5612,0.56452-0.82507,0.78164-1.9965,0.78164-1.9965' stroke='%23053e6c'/%3E %3Cpath d='m505.11,336.86s4.1657-1.5188,5.0331-1.8662c0.60794-0.21609,1.6925-1.0846,1.9531-1.4744,0.43321-0.60794,0.73719-1.9531,0.73719-1.9531' stroke='%23043862'/%3E %3Cpath d='m504.81,336.9s4.816-1.8228,5.3805-1.9955c0.43425-0.1737,1.6925-1.1725,1.8662-1.432,0.30397-0.43425,0.69376-1.9096,0.69376-1.9096' stroke='%23043258'/%3E %3Cpath d='m504.5,336.9s5.4239-2.0389,5.7279-2.1257c0.21608-0.0869,1.6481-1.2148,1.7783-1.3451,0.13027-0.21712,0.65033-1.8662,0.65033-1.8662' stroke='%23032c4d'/%3E %3Cpath transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' stroke='%23022743' d='M76.543,119.3,82.461,117.12,84.055,115.91,84.643,114.14'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m511.27,331.57s-2.5166,0.13027-2.7771,0.21712c-0.26054,0.0434-10.283-0.1737-10.283-0.1737' stroke='%23032b4c'/%3E %3Cpath d='m511.32,331.61s-2.4731,0.21713-2.864,0.30398c-0.39082,0.0424-10.153-0.26055-10.153-0.26055' stroke='%23032e50'/%3E %3Cpath d='m511.32,331.65s-2.3863,0.30294-2.9074,0.38979c-0.52109,0.0879-10.023-0.34637-10.023-0.34637' stroke='%23033054'/%3E %3Cpath d='m511.32,331.7s-2.2994,0.34637-2.9508,0.47768c-0.65137,0.12924-9.8926-0.43425-9.8926-0.43425' stroke='%23043359'/%3E %3Cpath d='m511.36,331.7s-2.257,0.47768-3.0377,0.60692c-0.78061,0.17369-9.7623-0.52007-9.7623-0.52007' stroke='%2304355c'/%3E %3Cpath d='m511.36,331.74s-2.1692,0.52006-3.08,0.69376c-0.91088,0.21712-9.6754-0.60691-9.6754-0.60691' stroke='%23043760'/%3E %3Cpath d='m511.4,331.78s-2.1257,0.60691-3.1669,0.82404c-1.0846,0.1737-9.5452-0.73719-9.5452-0.73719' stroke='%23053a65'/%3E %3Cpath d='m511.4,331.83s-2.0389,0.69376-3.2538,0.91088c-1.1714,0.21713-9.3714-0.78164-9.3714-0.78164' stroke='%23053c68'/%3E %3Cpath d='m511.45,331.87s-2.0389,0.73719-3.3406,0.99774c-1.3017,0.26054-9.2412-0.8685-9.2412-0.8685' stroke='%23053f6e'/%3E %3Cpath d='m511.45,331.91s-1.9531,0.82403-3.384,1.0846c-1.432,0.30397-9.1119-0.95534-9.1119-0.95534' stroke='%23064172'/%3E %3Cpath d='m498.99,332.09s7.4628,1.3451,9.0251,1.0412c1.5622-0.30397,3.4709-1.1725,3.4709-1.1725' stroke='%2300209f'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.17359523' stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m474.96,289.91c-0.13027-1.2583-0.1737-2.5166-0.1737-3.2103,0.0434-5.1634-0.65034-9.0685-0.0869-14.491,0.43425-4.2515,1.4754-9.8491,1.2583-14.448-0.0869-1.3017,0.17267-2.6034,0.21713-3.8617l20.957,23.517'/%3E %3Cpath d='m466.97,327.7c-0.56452-0.34637-1.5188-1.3451-1.8228-2.2126-0.60795-1.736-0.47767-1.6925-0.91089-3.6012-0.25951-1.0846-0.25951-2.2994-0.52109-3.4274-0.21609-1.128-1.8218-4.7292-1.8652-6.2046-0.17267-4.7281-1.736-7.9395-1.3451-13.103,0.26054-3.992,1.1714-9.4149,0.73718-13.581-0.13027-1.128,0.0434-2.4307,0.0868-3.5577l23.56,15.576'/%3E %3Cpath d='m513.44,331.48c0.1737,0.52006-0.3474,1.5188-0.52006,1.8662-0.13028,0.1737-0.3474,0.47663-0.47664,0.65033-0.26055,0.56452-0.21712,0.43425-0.6948,0.8685-0.12924,0.0869-0.69376,0.56348-0.86745,0.65033-0.34637,0.26055-0.69377,0.60795-1.0846,0.65137-1.7794,0.30397-2.5166,0.69376-4.2091,1.1714-1.6057,0.47768-0.73718,0.39083-1.952,0.6948-0.60691,0.12924-1.8228,0.60691-2.4297,0.69376-1.0846,0.1737-1.2583,0.3474-2.3863,0.60794-2.9074,0.65034-5.7269,0.47664-8.5908,0.30398-1.1714-0.0868-4.0354-0.6948-5.0331-1.3896-1.7794-1.2583-5.6845-1.7349-7.4194-2.9498-0.25952-0.17473-1.3451-0.69479-1.5612-0.91192-1.6925-1.3886-3.0377-1.7794-4.816-2.9074'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-miterlimit='2.61310005'%3E %3Cg%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='58.457,80.488,58.457,80.488,35.334,65.381,34.915,66.01,57.911,81.286' stroke-width='0.1259' fill='%23FC0'/%3E %3Cpath d='m461.16,280.89c-0.1737-0.91088,0.0868-2.1268,0.73718-2.257,0.0434,0,0.52006-0.17266,0.82404-0.0858,0.39082,0,0.47663,0.12924,0.65033,0.43321,0.34636,0.82404-0.65033,1.3451-1.3451,1.6057-0.1737,0.0434-0.65034,0.13027-0.73718,0.34636-0.13028,0.3474-0.0434,0.21713-0.13028,0.3474,0.13028-0.0434,0.1737-0.1737,0.30294-0.26055,0.5211-0.30294,1.0412-0.38979,1.7794-0.73718,0.56452-0.25952,0.65137-1.3886,0.26055-1.7349-0.43322-0.3474-1.7784-0.30397-2.0823,0.0434-0.65034,0.73719-0.69376,1.736-0.56349,2.7337,0-0.21712,0.3474-0.1737,0.30398-0.43425z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m460.77,281.32c-0.91088-0.0434-2.0834,0.3474-2.1257,0.99773,0,0.0869-0.0869,0.60795,0,0.86746,0.0434,0.39082,0.17267,0.47767,0.52007,0.56452,0.86745,0.25952,1.2583-0.78061,1.3886-1.5188,0.0434-0.1737,0.0434-0.65033,0.26055-0.78061,0.34636-0.1737,0.25951-0.0868,0.34636-0.1737-0.0434,0.13028-0.1737,0.21713-0.21712,0.30398-0.21609,0.56348-0.25952,1.128-0.52006,1.9086-0.1737,0.56349-1.3017,0.78061-1.6491,0.43425-0.43424-0.3474-0.56348-1.6925-0.26054-2.0399,0.65137-0.73718,1.6491-0.91088,2.6468-0.91088-0.17266,0.0434-0.12924,0.39082-0.38979,0.3474z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m460.6,280.93c-0.26054,0.13027-0.26054,0.47767-0.13027,0.69479,0.0869,0.21609,0.47664,0.25951,0.65034,0.17267,0.34636-0.21609,0.56452-0.60692,0.34636-0.95431-0.21506-0.30398-0.56245-0.0434-0.86643,0.0868z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m455.56,277.76c0,0 2.5166,0.99773 4.5554,1.0412 0,0 0.0869,1.7794 0.52007,2.2994 0,0 -1.8218,-0.34637 -2.6468,0.0868 10e-4,0 -1.0836,-2.4731 -2.4287,-3.4274z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m457.6,279.02c0,0 0.99773,0.43425 1.8218,0.43425 0,0 0.0434,0.69376 0.21713,0.91088 0,0 -0.73719,-0.13027 -1.0412,0.0434 0,-10e-4 -0.43425,-0.99773 -0.99773,-1.3886z' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m460.77,282.88s0.47664-0.82403,0.60691-1.128c0.0858-0.17266-0.0434,0.99774,0.38979,1.128,0.56349,0.73719,0.69376,2.256,0.69376,2.6468-0.65033,0.21609-1.2148,0.60691-2.2126,0.13027-0.34636-0.21712-0.0869-0.86746,0.0434-1.3886,0.0879-0.26158,0.17473-0.99877,0.4787-1.3886z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m461.25,282.23c0,0.12924,0.0868,0.65034,0.0434,0.56349,0-0.21609,0.25951,0.21712,0.30294,0.30397,0.3474,0.65034,0.47767,1.128,0.60794,2.3863' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m461.46,283.32c0.21713,0.99774,0.39083,0.95431,0.39083,2.3439l0.0868-0.0868' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m461.42,284.23c0.17266,0.69376,0.12924,1.0412,0.17266,1.3886-0.0434,0-0.25951,0.17267-0.30293,0.17267' stroke-width='0.13017058' fill='none'/%3E %3C/g%3E %3Cg%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='70.375,61.185,70.375,61.185,49.728,38.23,49.309,38.733,69.745,61.772' stroke-width='0.1259' fill='%23fc0'/%3E %3Cpath d='m476.61,253.08c0.0434-0.95431,0.56452-2.0834,1.2149-2.0399,0.0434,0,0.56452-0.0434,0.82403,0.0868,0.39083,0.0868,0.43425,0.26055,0.52007,0.60795,0.17369,0.86746-0.91089,1.128-1.6481,1.2148-0.1737,0-0.69376-0.0434-0.82404,0.1737-0.21712,0.30397-0.0869,0.21609-0.21712,0.30397,0.13027,0,0.26055-0.13027,0.3474-0.17369,0.60691-0.17267,1.128-0.17267,1.952-0.30294,0.56452-0.0868,0.91088-1.2149,0.60794-1.6057-0.30397-0.43425-1.6057-0.73719-1.9965-0.47664-0.82403,0.56349-1.0846,1.5188-1.1714,2.56,0.0445-0.21919,0.3474-0.13234,0.39082-0.34843z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m476.13,253.38c-0.91088-0.25952-2.1257-0.13028-2.3429,0.47767,0,0.0434-0.21609,0.56348-0.17267,0.82403-0.0434,0.38979,0.0434,0.52006,0.38979,0.69376,0.73719,0.43425,1.3886-0.47664,1.6925-1.1714,0.0869-0.1737,0.21712-0.60691,0.43321-0.69376,0.3474-0.0858,0.26055,0,0.3474-0.0858-0.0434,0.12924-0.17267,0.17267-0.25952,0.25952-0.34739,0.52006-0.52109,0.99773-0.9543,1.7349-0.30398,0.47767-1.432,0.47767-1.736,0.0434-0.30294-0.47664-0.0869-1.7783,0.25952-2.0389,0.78164-0.60794,1.8228-0.56452,2.7771-0.26055-0.1737-0.0424-0.21713,0.30501-0.43425,0.21713z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m476.04,252.95c-0.30398,0.0434-0.3474,0.43322-0.30398,0.65034,0.0434,0.21712,0.38979,0.38979,0.60691,0.30397,0.3474-0.13027,0.69376-0.43321,0.56349-0.82403-0.12924-0.3474-0.56349-0.1737-0.86642-0.13028z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m471.92,248.69c0,0 2.1702,1.5622 4.1222,2.0834 0,0 -0.30398,1.7794 0,2.3429 0,0 -1.736,-0.73718 -2.6034,-0.52109 0,0 -0.43424,-2.6468 -1.5188,-3.9051z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m473.57,250.43c0,0 0.86746,0.60691 1.6491,0.82404 0,0 -0.13028,0.69376 0,0.91088 0,0 -0.69376,-0.26055 -1.0412,-0.1737 0,0.001 -0.1737,-1.0846 -0.60795,-1.5612z' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m475.74,254.9s0.65034-0.69376,0.86746-0.9543c0.13028-0.1737-0.30294,0.9543,0.0869,1.2148,0.38979,0.82404,0.13028,2.2994,0.0434,2.7337-0.69376,0.0434-1.3017,0.25951-2.1257-0.43425-0.30398-0.26055,0.0858-0.82403,0.34636-1.3017,0.13027-0.25952,0.39082-0.95431,0.78164-1.2583z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m476.35,254.42c0,0.0868-0.0434,0.43321-0.0434,0.52006,0.0434,0.26055,0.25951,0.3474,0.30294,0.65137,0.13027,0.73718-0.0434,1.2149-0.0868,2.1692' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m476.26,255.29c0.21609,0.91088,0.0434,1.6491-0.0868,2.5166-0.0434,0,0.0868,0,0.0868-0.0434' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m476.13,256.81c-0.12924,0.34636-0.12924,0.56348-0.17266,0.9543-0.0434-0.0434-0.21713,0.13028-0.26055,0.0869' stroke-width='0.13017058' fill='none'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23g2' transform='matrix(-1,0,0,1,1030.0498,0)'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M87.035,32.69,38.397,114.06,135.71,114.06,135.71,114.06z' fill='%23fc0' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.41960001' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='M87.035,37.978,43.14,111.42,130.97,111.42,130.97,111.42z' fill='%23fff' stroke='%23fff' stroke-miterlimit='2.61310005' stroke-width='0.1259' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='M56.148,89.594,56.148,89.594,43.14,111.42,130.97,111.42,117.92,89.594z' fill='%23007e93' stroke='%23007e93' stroke-miterlimit='2.61310005' stroke-width='0.2518' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cg stroke-width='0.17359523' stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m507.11,266.09c2.1268-1.9096,4.7292-2.6903,7.7668-2.7337h0.21712c2.9508,0.0434,5.945,0.73718,7.8526,2.7337' stroke='%23086aad'/%3E %3Cpath d='m507.06,266.18c2.0823-1.9531,4.7726-2.6903,7.8102-2.7337h0.21712c3.0366,0,6.0309,0.73719,7.9395,2.7771' stroke='%230863aa'/%3E %3Cpath d='m507.02,266.31c2.0823-2.0389,4.816-2.7771,7.8971-2.8205h0.21713c3.0366,0.0434,6.0743,0.78061,7.9829,2.864' stroke='%23095fa8'/%3E %3Cpath d='m506.93,266.4c2.0834-2.0389,4.9028-2.8205,7.9839-2.8205h0.26055c3.08,0,6.1177,0.78061,8.0263,2.9508' stroke='%230a58a5'/%3E %3Cpath d='m506.89,266.48c2.0399-2.0823,4.9463-2.8205,8.0708-2.864h0.21712c3.1669,0.0434,6.2035,0.82404,8.1132,3.0377' stroke='%230a52a2'/%3E %3Cpath d='m506.81,266.57c2.0389-2.1257,4.9897-2.864,8.1566-2.864h0.26055c3.2103,0.0434,6.2469,0.82404,8.2,3.08' stroke='%230b4d9f'/%3E %3Cpath d='m506.76,266.7c2.0389-2.1692,5.0331-2.9508,8.2434-2.9508h0.21713c3.2972,0.0434,6.2904,0.86746,8.2869,3.1669' stroke='%230c479d'/%3E %3Cpath d='m506.2,267.61c2.3863-2.5166,5.3371-3.2538,8.8514-3.2538h0.21609c3.8617,0.0434,7.1599,1.3451,9.0685,4.0354' stroke='%23270a7f'/%3E %3Cpath d='m506.24,267.48c2.3429-2.4297,5.2937-3.1669,8.808-3.2103h0.21609c3.7748,0.0434,7.0296,1.3017,8.9827,3.9486' stroke='%23241183'/%3E %3Cpath d='m506.33,267.39c2.2994-2.4297,5.2068-3.1669,8.6777-3.1669h0.21713c3.7314,0.0434,6.9852,1.2148,8.9382,3.8617' stroke='%23221786'/%3E %3Cpath d='m506.37,267.31c2.256-2.3863,5.2068-3.1235,8.5908-3.1669h0.21712c3.688,0.0434,6.8983,1.1714,8.8948,3.7748' stroke='%231f1f8a'/%3E %3Cpath d='m506.46,267.18c2.1692-2.2994,5.12-3.08,8.504-3.08h0.1737c3.6446,0,6.8549,1.0412,8.8514,3.6446' stroke='%231a258d'/%3E %3Cpath d='m506.5,267.09c2.1257-2.3005,5.12-3.0377,8.4171-3.08h0.21713c3.5577,0.0434,6.768,0.99773,8.7211,3.5577' stroke='%23172d91'/%3E %3Cpath d='m506.54,267c2.0823-2.257,5.0766-3.0377,8.3303-3.0377h0.21712c3.5143,0,6.6812,0.91088,8.6777,3.4274' stroke='%23143393'/%3E %3Cpath d='m506.63,266.87c2.0389-2.2136,5.0331-2.9508,8.2434-2.9942h0.1737c3.4709,0,6.6378,0.86746,8.6343,3.384' stroke='%23113b97'/%3E %3Cpath d='m510.01,261.15c1.4754-1.0412,3.0377-1.3451,4.9897-1.3451,1.8662,0,3.5143,0.30397,4.9463,1.2583' stroke='%23ff0a00'/%3E %3Cpath d='m509.97,261.23c1.4754-1.0412,3.08-1.3451,5.0331-1.3451,1.8662,0,3.5577,0.30294,4.9897,1.2583' stroke='%23F10'/%3E %3Cpath d='m509.93,261.32c1.5188-1.0412,3.1235-1.3886,5.0766-1.3886,1.8662,0,3.6012,0.34636,5.0766,1.3017' stroke='%23ff1500'/%3E %3Cpath d='m509.89,261.45c1.5188-1.0846,3.1235-1.432,5.12-1.432,1.9086,0,3.6446,0.34636,5.12,1.3017' stroke='%23ff1a00'/%3E %3Cpath d='m509.84,261.54c1.5188-1.0846,3.1669-1.431,5.1634-1.431,1.9086,0,3.688,0.34637,5.1634,1.3017' stroke='%23ff2000'/%3E %3Cpath d='m509.8,261.62c1.5188-1.0846,3.2103-1.4754,5.2068-1.4754,1.9086,0,3.7314,0.39082,5.2068,1.3886' stroke='%23ff2700'/%3E %3Cpath d='m509.75,261.71c1.5188-1.0846,3.2103-1.4754,5.2502-1.4754,1.9086,0,3.7748,0.39082,5.2502,1.3886' stroke='%23ff2f00'/%3E %3Cpath d='m509.71,261.8c1.5188-1.128,3.2538-1.4754,5.2937-1.4754,1.952,0,3.8183,0.39082,5.3371,1.3886' stroke='%23F30'/%3E %3Cpath d='m509.67,261.88c1.5188-1.128,3.2972-1.5188,5.3371-1.5188,1.952,0,3.8617,0.43424,5.3805,1.432' stroke='%23ff3c00'/%3E %3Cpath d='m509.62,261.97c1.5622-1.128,3.3406-1.5188,5.3805-1.5188,1.952,0,3.9051,0.43424,5.424,1.432' stroke='%23ff4100'/%3E %3Cpath d='m509.58,262.06c1.5622-1.128,3.3406-1.5188,5.4239-1.5188,1.9955,0,3.9485,0.43425,5.4674,1.432' stroke='%23ff4600'/%3E %3Cpath d='m508.41,264.01c1.6915-1.3017,4.3818-1.9531,6.6378-1.9531,2.3863,0,4.9897,0.65034,6.6812,1.9965' stroke='%23fff500'/%3E %3Cpath d='m508.5,263.88c1.6481-1.3017,4.2949-1.9096,6.5509-1.9096,2.3429,0,4.9028,0.60691,6.5944,1.9965' stroke='%23ffeb00'/%3E %3Cpath d='m508.54,263.79c1.6925-1.3017,4.2515-1.9096,6.5075-1.9096,2.2994,0,4.8594,0.60691,6.5509,1.9531' stroke='%23ffe000'/%3E %3Cpath d='m508.63,263.66c1.6491-1.2583,4.1657-1.8652,6.4217-1.8652,2.2994,0,4.816,0.60691,6.4641,1.9086' stroke='%23ffd600'/%3E %3Cpath d='m508.67,263.58c1.6491-1.2583,4.1222-1.8652,6.3783-1.8652,2.256,0,4.7302,0.60691,6.4206,1.8652' stroke='%23ffcf00'/%3E %3Cpath d='m508.76,263.45c1.6491-1.2583,4.0788-1.8228,6.2914-1.8228,2.256,0,4.6868,0.56452,6.3338,1.8662' stroke='%23ffc400'/%3E %3Cpath d='m508.8,263.36c1.6491-1.2583,4.0354-1.8228,6.248-1.8228s4.5999,0.56452,6.2469,1.8228' stroke='%23ffba00'/%3E %3Cpath d='m508.89,263.23c1.6057-1.2149,3.9485-1.7783,6.1611-1.7783s4.5565,0.56348,6.2035,1.7783' stroke='%23ffb000'/%3E %3Cpath d='m508.93,263.14c1.6491-1.2583,3.9051-1.7794,6.1177-1.7794,2.1692,0,4.5131,0.56349,6.1177,1.7794' stroke='%23ffa600'/%3E %3Cpath d='m509.02,263.01c1.6057-1.2148,3.8183-1.736,6.0309-1.736,2.1257,0,4.4262,0.5211,6.0308,1.736' stroke='%23ff9c00'/%3E %3Cpath d='m509.06,262.93c1.6057-1.2148,3.8183-1.736,5.9874-1.736,2.1257,0,4.3828,0.5211,5.9885,1.6925' stroke='%23ff9100'/%3E %3Cpath d='m509.15,262.79c1.6057-1.1714,3.7314-1.6925,5.9016-1.6925,2.0823,0,4.3394,0.52006,5.9016,1.6491' stroke='%23ff8700'/%3E %3Cpath d='m509.19,262.71c1.6057-1.2149,3.688-1.6925,5.8572-1.6925,2.0823,0,4.2525,0.52006,5.8582,1.6491' stroke='%23ff7d00'/%3E %3Cpath d='m509.28,262.58c1.5612-1.1714,3.6011-1.6481,5.7703-1.6481,2.0389,0,4.2091,0.52006,5.7713,1.6046' stroke='%23ff7500'/%3E %3Cpath d='m509.32,262.49c1.6046-1.1714,3.5577-1.6481,5.7269-1.6481,2.0389,0,4.1222,0.47663,5.6845,1.5622' stroke='%23ff6b00'/%3E %3Cpath d='m509.41,262.36c1.5612-1.1714,3.5143-1.6057,5.64-1.6057,1.9955,0,4.0788,0.47664,5.6411,1.5623' stroke='%23ff6100'/%3E %3Cpath d='m509.45,262.27c1.6057-1.1714,3.4709-1.6057,5.5976-1.6057,1.952,0,4.0354,0.47664,5.5542,1.5188' stroke='%23ff5700'/%3E %3Cpath d='m508.19,264.23c1.7783-1.3886,4.512-2.0389,6.8549-2.0389,2.4297,0,5.0766,0.69376,6.8115,2.0823' stroke='%23ebf605'/%3E %3Cpath d='m508.15,264.36c1.8652-1.4754,4.512-2.0823,6.8983-2.0823,2.4297,0,5.1634,0.69376,6.8983,2.1257' stroke='%23d6ec09'/%3E %3Cpath d='m508.06,264.49c1.952-1.5623,4.512-2.1692,6.9852-2.1692,2.4731,0,5.2068,0.73719,6.9417,2.1692' stroke='%23c2e30e'/%3E %3Cpath d='m507.98,264.62c2.0823-1.6491,4.5554-2.2126,7.072-2.2126,2.4731,0,5.2502,0.73719,6.9852,2.2126' stroke='%23add912'/%3E %3Cpath d='m507.93,264.75c2.1257-1.6915,4.5565-2.256,7.072-2.256,2.56,0,5.3371,0.73718,7.1154,2.2126' stroke='%2399cf16'/%3E %3Cpath d='m507.85,264.88c2.256-1.7794,4.5565-2.3439,7.1589-2.3439,2.6034,0,5.4239,0.78061,7.1589,2.3005' stroke='%2385c61a'/%3E %3Cpath d='m507.8,265.01c2.2994-1.8652,4.5565-2.3863,7.2023-2.3863,2.6034,0,5.4674,0.78061,7.2457,2.3005' stroke='%2370bc1f'/%3E %3Cpath d='m507.71,265.14c2.4297-1.952,4.5999-2.4731,7.2891-2.4731,2.6468,0,5.5108,0.82404,7.2891,2.3863' stroke='%235cb323'/%3E %3Cpath d='m507.63,265.22c2.5166-1.9965,4.5989-2.4731,7.376-2.4731,2.6468,0,5.5542,0.82404,7.376,2.3863' stroke='%2347a928'/%3E %3Cpath d='m507.24,265.92c2.2126-1.952,4.7726-2.6468,7.8102-2.6468,2.864,0,5.8582,0.73822,7.7668,2.6034' stroke='%230d74a4'/%3E %3Cpath d='m507.28,265.87c2.256-1.9955,4.7292-2.6903,7.7668-2.6903,2.864,0,5.8148,0.78061,7.7234,2.6034' stroke='%23127a97'/%3E %3Cpath d='m507.33,265.79c2.2994-1.9955,4.7292-2.6468,7.7234-2.6468,2.8205,0,5.8148,0.78061,7.68,2.56' stroke='%2317808b'/%3E %3Cpath d='m507.37,265.7c2.3429-1.9955,4.6857-2.6034,7.68-2.6034,2.7771,0,5.7713,0.78061,7.5931,2.5166' stroke='%231a847d'/%3E %3Cpath d='m507.41,265.66c2.3863-2.0389,4.6857-2.6468,7.5931-2.6468,2.8205,0,5.7714,0.82403,7.5921,2.5166' stroke='%231e8a6d'/%3E %3Cpath d='m507.46,265.57c2.4297-2.0389,4.6423-2.6034,7.5497-2.6034,2.7771,0,5.7279,0.82404,7.5497,2.5166' stroke='%23238f5e'/%3E %3Cpath d='m507.5,265.53c2.4731-2.0823,4.6423-2.6034,7.5063-2.6034,2.7337,0,5.6845,0.82403,7.5063,2.4731' stroke='%232b944e'/%3E %3Cpath d='m507.54,265.44c2.5166-2.0833,4.5989-2.56,7.4628-2.56,2.6903,0,5.6845,0.82403,7.4628,2.4297' stroke='%232f9b3e'/%3E %3Cpath d='m519.91,260.97c-1.432-0.95431-3.08-1.2583-4.9028-1.2583-1.9531,0-3.4709,0.3474-4.9463,1.3451' stroke='%23F00'/%3E %3Cpath d='m524.46,268.57c-1.9955-2.8205-5.3795-4.1657-9.3715-4.1657-3.6011,0-6.5075,0.78061-8.9817,3.2972' stroke='%232a007c'/%3E %3Cpath d='m522.86,265.92c-1.9086-1.8652-4.9018-2.6034-7.8092-2.6034-3.08,0-5.6835,0.73822-7.8526,2.6903' stroke='%230671b0'/%3E %3Cpath d='m523.6,267.09c-2.0399-2.4731-5.1634-3.2538-8.5908-3.2538-3.2103,0-6.2914,0.73719-8.3303,2.9508' stroke='%230c419a'/%3E %3Cpath d='m521.82,264.18c-1.736-1.3886-4.3818-2.0399-6.768-2.0399-2.2994,0-5.0766,0.65033-6.768,1.952' stroke='%23FF0'/%3E %3Cpath d='m520.51,262.06c-1.5188-0.99773-3.5143-1.4754-5.5108-1.4754-2.0823,0-3.9051,0.43321-5.4674,1.6057' stroke='%23ff4d00'/%3E %3Cpath d='m522.42,265.22c-1.7794-1.5622-4.7292-2.4297-7.4194-2.4297-2.8205,0-4.8594,0.47664-7.4194,2.56' stroke='%2333a02c'/%3E %3C/g%3E %3Cg stroke-width='0.17359523' stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m505.81,268.13c2.8205-1.3886,5.7714-2.256,9.1978-2.256,3.2538,0,6.7246,1.2149,9.4583,2.6903l9.632,16.097c0,10.543-8.5908,19.264-19.09,19.264-10.543,0-19.047-8.504-19.134-19.177l9.936-16.618z' stroke='%23fef2ec'/%3E %3Cpath d='m515.01,266.09c3.2103,0,6.6378,1.2583,9.328,2.6903,0.0434,0,9.5017,15.837,9.5017,15.88,0,10.369-8.4606,19.003-18.83,19.003-10.413,0-18.786-8.3737-18.873-18.917,0-0.0434,9.7623-16.358,9.8057-16.358,2.7761-1.3875,5.6835-2.2994,9.0675-2.2994z' stroke='%23fef2ea'/%3E %3Cpath d='m514.96,266.61c3.1669,0,6.5075,1.1714,9.1119,2.6034,0.0868,0.0434,9.2412,15.315,9.2412,15.446,0,10.109-8.2445,18.526-18.353,18.526-10.066,0-18.266-8.2-18.31-18.439,0-0.13027,9.4149-15.88,9.5017-15.923,2.7337-1.3451,5.5532-2.2126,8.808-2.2126z' stroke='%23fef0e6'/%3E %3Cpath d='m514.96,267.13c3.0811,0,6.3338,1.128,8.8514,2.5166,0.1737,0.0869,9.0251,14.839,9.0251,15.056,0,9.8057-8.0274,17.963-17.876,17.963-9.8057,0-17.746-7.9405-17.833-17.92,0-0.21712,9.1119-15.36,9.2846-15.489,2.6479-1.3027,5.3805-2.1268,8.5485-2.1268z' stroke='%23feede3'/%3E %3Cpath d='m514.96,267.87c2.9508,0,6.0743,1.0846,8.504,2.4297,0.26055,0.1737,8.5919,14.058,8.5919,14.406,0,9.3715-7.681,17.182-17.096,17.182-9.3715,0-17.008-7.5931-17.051-17.138,0-0.3474,8.5474-14.665,8.8514-14.795,2.5166-1.2593,5.2058-2.0834,8.2-2.0834z' stroke='%23fee8dc'/%3E %3Cpath d='m514.96,268.39c2.864,0,5.9016,1.0412,8.2434,2.3429,0.3474,0.21609,8.3313,13.537,8.3313,13.971,0,9.1119-7.4628,16.704-16.575,16.704-9.1119,0-16.488-7.4184-16.53-16.661,0-0.43424,8.2-14.145,8.5908-14.362,2.4287-1.2138,5.0321-1.9955,7.9395-1.9955z' stroke='%23fee6d5'/%3E %3Cpath d='m514.96,269.13c2.7337,0,5.6411,1.0412,7.8537,2.256,0.47663,0.26055,7.9395,12.755,7.9395,13.32,0,8.7211-7.072,15.923-15.793,15.923-8.6777,0-15.75-7.0286-15.793-15.837,0-0.60795,7.7224-13.45,8.2-13.754,2.3429-1.1714,4.816-1.9086,7.5931-1.9086z' stroke='%23fee3cf'/%3E %3Cpath d='m514.96,269.65c2.6903,0,5.4239,0.95431,7.6355,2.1692,0.5211,0.30397,7.681,12.235,7.681,12.887,0,8.4172-6.8994,15.402-15.316,15.402-8.4172,0-15.229-6.8125-15.272-15.315,0-0.6948,7.376-12.974,7.8971-13.277,2.2984-1.1714,4.6847-1.8662,7.375-1.8662z' stroke='%23fee0cc'/%3E %3Cpath d='m514.96,270.17c2.6034,0,5.2502,0.91088,7.376,2.0823,0.56452,0.34637,7.4194,11.758,7.4194,12.496,0,8.1132-6.6388,14.882-14.795,14.882-8.1132,0-14.709-6.5943-14.752-14.839,0-0.78164,7.0286-12.496,7.6365-12.843,2.1681-1.0846,4.512-1.7783,7.1154-1.7783z' stroke='%23fedec6'/%3E %3Cpath d='m514.96,273.47c2.0389,0,4.0788,0.69479,5.7279,1.6057,1.0412,0.60691,5.7269,8.4171,5.7269,9.7188,0,6.2904-5.12,11.498-11.455,11.498-6.2914,0-11.411-5.12-11.455-11.498,0-1.3017,4.816-9.328,5.9016-9.936,1.6915-0.86746,3.5143-1.3886,5.5532-1.3886z' stroke='%23fdcdaa'/%3E %3Cpath d='m514.96,273.69c1.9955,0,3.992,0.69376,5.5976,1.6057,1.0846,0.65034,5.5966,8.1566,5.5966,9.5017,0,6.1611-5.0321,11.238-11.194,11.238-6.1611,0-11.194-4.9897-11.194-11.194,0-1.3886,4.6423-9.1119,5.7703-9.7623,1.6491-0.86746,3.4285-1.3886,5.424-1.3886z' stroke='%23fdcdaa'/%3E %3Cpath d='m514.96,274.94c1.7794,0,3.5577,0.60691,4.9897,1.432,1.2593,0.73719,4.9463,6.8549,4.9463,8.4172,0,5.4663-4.4686,9.9784-9.936,9.9784s-9.8926-4.4252-9.936-9.936c0-1.6057,3.8183-7.896,5.12-8.6343,1.432-0.77958,3.0366-1.2572,4.816-1.2572z' stroke='%23fdc59e'/%3E %3Cpath d='m514.96,275.2c1.736,0,3.4709,0.56349,4.8594,1.3886,1.3027,0.78061,4.816,6.5943,4.816,8.201,0,5.3371-4.3383,9.7188-9.6754,9.7188s-9.6754-4.2959-9.6754-9.6754c0-1.6491,3.6446-7.6365,4.9897-8.4172,1.3886-0.73925,2.9498-1.2159,4.6857-1.2159z' stroke='%23fdc59e'/%3E %3Cpath d='m515.01,266.35c3.1669,0,6.5509,1.2149,9.1988,2.6468,0.0434,0.0434,9.3704,15.576,9.3704,15.663,0,10.24-8.3737,18.786-18.569,18.786-10.24,0-18.57-8.3303-18.614-18.699,0-0.0868,9.5886-16.097,9.632-16.141,2.7771-1.3886,5.6411-2.256,8.9817-2.256z' stroke='%23fef0e9'/%3E %3Cpath d='m514.96,266.87c3.1245,0,6.4206,1.1714,8.9817,2.56,0.13028,0.0868,9.1543,15.099,9.1543,15.273,0,9.9349-8.1576,18.223-18.137,18.223-9.936,0-18.006-8.0698-18.093-18.179,0-0.1737,9.2846-15.619,9.4149-15.706,2.6913-1.3462,5.4674-2.1702,8.6787-2.1702z' stroke='%23feede3'/%3E %3Cpath d='m514.96,267.39c3.0377,0,6.248,1.128,8.7211,2.4731,0.21712,0.13028,8.8948,14.578,8.8948,14.839,0,9.6754-7.9405,17.703-17.616,17.703-9.6754,0-17.486-7.8536-17.573-17.659,0-0.26054,8.8948-15.143,9.1119-15.273,2.6458-1.3017,5.3361-2.0823,8.4606-2.0823z' stroke='%23feebdf'/%3E %3Cpath d='m514.96,267.61c2.9942,0,6.1611,1.128,8.6343,2.4731,0.21712,0.13027,8.7211,14.318,8.7211,14.622,0,9.5452-7.8102,17.442-17.355,17.442-9.5017,0-17.225-7.7234-17.312-17.399,0-0.30397,8.7211-14.882,8.9817-15.056,2.56-1.2583,5.2492-2.0823,8.3303-2.0823z' stroke='%23feebdd'/%3E %3Cpath d='m514.96,268.13c2.9074,0,5.9885,1.0846,8.3737,2.3863,0.30397,0.1737,8.4616,13.798,8.4616,14.188,0,9.2412-7.5497,16.921-16.835,16.921-9.2412,0-16.747-7.4628-16.791-16.878,0-0.39082,8.3737-14.406,8.7211-14.578,2.4731-1.2593,5.1189-2.0399,8.0698-2.0399z' stroke='%23fee8d9'/%3E %3Cpath d='m514.96,268.65c2.8205,0,5.8148,1.0412,8.1132,2.2994,0.39082,0.21712,8.2011,13.277,8.2011,13.754,0,8.9817-7.3326,16.444-16.314,16.444-8.9382,0-16.227-7.2891-16.314-16.358,0-0.5211,8.0708-13.971,8.4606-14.188,2.4297-1.2149,4.9897-1.952,7.8537-1.952z' stroke='%23fee6d3'/%3E %3Cpath d='m514.96,268.91c2.7771,0,5.7279,0.99773,7.9829,2.256,0.43424,0.26055,8.0708,13.016,8.0708,13.537,0,8.8514-7.2023,16.183-16.054,16.183-8.808,0-15.967-7.1589-16.054-16.096,0-0.56452,7.8971-13.711,8.3303-13.971,2.3863-1.1714,4.9028-1.9086,7.7234-1.9086z' stroke='%23fee3d2'/%3E %3Cpath d='m514.96,269.39c2.7337,0,5.5108,0.99774,7.7234,2.2136,0.52006,0.30294,7.8526,12.495,7.8526,13.103,0,8.5908-7.0286,15.663-15.576,15.663s-15.489-6.9417-15.533-15.576c0-0.65137,7.5497-13.233,8.0708-13.494,2.2984-1.1714,4.7281-1.9096,7.4618-1.9096z' stroke='%23fee0cc'/%3E %3Cpath d='m514.96,269.91c2.6468,0,5.3371,0.95431,7.5063,2.1257,0.52006,0.3474,7.5497,12.018,7.5497,12.713,0,8.2434-6.7691,15.099-15.056,15.099-8.2434,0-14.969-6.6812-15.013-15.056,0-0.73822,7.2023-12.757,7.7658-13.06,2.2136-1.127,4.5999-1.8218,7.2468-1.8218z' stroke='%23fedec8'/%3E %3Cpath d='m514.96,270.43c2.56,0,5.1634,0.91089,7.2457,2.0389,0.60795,0.39082,7.2891,11.498,7.2891,12.279,0,7.9829-6.552,14.622-14.535,14.622-7.9839,0-14.448-6.5085-14.491-14.578,0-0.82404,6.8549-12.235,7.5063-12.626,2.1247-1.0836,4.4252-1.7349,6.9852-1.7349z' stroke='%23fddbc5'/%3E %3Cpath d='m514.96,270.65c2.5166,0,5.0766,0.91088,7.1154,2.0389,0.65137,0.39082,7.1589,11.238,7.1589,12.063,0,7.8526-6.4206,14.361-14.274,14.361-7.8537,0-14.232-6.3782-14.274-14.318,0-0.86746,6.7246-12.019,7.4194-12.409,2.0813-1.0422,4.3383-1.736,6.8549-1.736z' stroke='%23fddbc2'/%3E %3Cpath d='m514.96,270.91c2.4731,0,4.9897,0.86746,6.9852,1.9965,0.6948,0.43321,7.0296,10.977,7.0296,11.846,0,7.7224-6.2914,14.101-14.015,14.101-7.7234,0-13.97-6.248-14.014-14.057,0-0.91088,6.5509-11.759,7.2457-12.192,2.0823-1.0422,4.2949-1.6936,6.768-1.6936z' stroke='%23fdd9bf'/%3E %3Cpath d='m514.96,271.17c2.4297,0,4.9028,0.86746,6.8549,1.9531,0.73822,0.43321,6.8994,10.717,6.8994,11.628,0,7.5931-6.1611,13.84-13.754,13.84-7.5497,0-13.711-6.1177-13.754-13.797,0-0.95431,6.3783-11.498,7.1154-11.932,2.0389-1.0422,4.2091-1.6925,6.6388-1.6925z' stroke='%23fdd9bf'/%3E %3Cpath d='m514.96,271.43c2.3863,0,4.817,0.82403,6.7246,1.9086,0.78164,0.47768,6.7691,10.457,6.7691,11.411,0,7.4194-6.0743,13.581-13.494,13.581-7.4194,0-13.45-6.0309-13.494-13.537,0-0.99773,6.2046-11.281,6.9852-11.715,1.9955-1.0412,4.1222-1.6481,6.5085-1.6481z' stroke='%23fdd6bc'/%3E %3Cpath d='m514.96,271.69c2.3429,0,4.7302,0.82404,6.5943,1.8662,0.82507,0.47664,6.6388,10.197,6.6388,11.194,0,7.2891-5.944,13.32-13.233,13.32-7.2891,0-13.19-5.9006-13.233-13.277,0-1.0412,5.9874-11.021,6.8559-11.498,1.951-0.99773,4.0344-1.6057,6.3772-1.6057z' stroke='%23fdd6b9'/%3E %3Cpath d='m514.96,271.95c2.2994,0,4.6433,0.78061,6.5075,1.8228,0.82507,0.52006,6.5085,9.936,6.5085,10.977,0,7.1589-5.8572,13.103-13.016,13.103-7.1589,0-12.929-5.8137-12.973-13.059,0-1.0846,5.8137-10.804,6.6812-11.281,1.952-0.99773,3.992-1.5622,6.2914-1.5622z' stroke='%23fdd4b8'/%3E %3Cpath d='m514.96,272.17c2.256,0,4.5565,0.82404,6.3772,1.8218,0.86849,0.5211,6.3782,9.6754,6.3782,10.761,0,7.0286-5.7269,12.842-12.755,12.842-7.0286,0-12.712-5.6845-12.712-12.799,0-1.128,5.64-10.544,6.5509-11.064,1.9086-0.95431,3.9051-1.5623,6.1611-1.5623z' stroke='%23fdd4b6'/%3E %3Cpath d='m514.96,272.43c2.2126,0,4.4696,0.78061,6.248,1.7783,0.91088,0.5211,6.247,9.4149,6.247,10.544,0,6.8983-5.64,12.582-12.495,12.582-6.8549,0-12.453-5.5966-12.496-12.538,0-1.128,5.5108-10.283,6.4651-10.848,1.8218-0.90985,3.8183-1.5178,6.0309-1.5178z' stroke='%23fdd2b2'/%3E %3Cpath d='m514.96,272.69c2.1692,0,4.3828,0.73718,6.1177,1.736,0.95431,0.56349,6.1177,9.1543,6.1177,10.37,0,6.7246-5.5108,12.279-12.235,12.279-6.7246,0-12.192-5.4674-12.235-12.279,0-1.1714,5.3371-10.066,6.3348-10.587,1.7784-0.95431,3.7314-1.5188,5.9006-1.5188z' stroke='%23fdd1b0'/%3E %3Cpath d='m514.96,272.95c2.1257,0,4.2525,0.73718,5.9885,1.6925,0.99774,0.56349,5.9874,8.8948,5.9874,10.153,0,6.5944-5.3805,12.018-11.976,12.018-6.5954,0-11.931-5.3371-11.975-12.018,0-1.2148,5.1634-9.8057,6.2046-10.37,1.7349-0.91192,3.6446-1.4754,5.7703-1.4754z' stroke='%23fdd0b0'/%3E %3Cpath d='m514.96,273.21c2.0823,0,4.1657,0.69377,5.8582,1.6481,1.0412,0.60795,5.8572,8.6777,5.8572,9.936,0,6.4206-5.2502,11.758-11.715,11.758-6.4651,0-11.672-5.2068-11.714-11.758,0-1.2583,4.9897-9.5452,6.0309-10.153,1.7349-0.91088,3.6011-1.431,5.6835-1.431z' stroke='%23fdd0ad'/%3E %3Cpath d='m514.96,273.95c1.952,0,3.9051,0.65137,5.5108,1.5622,1.0846,0.65034,5.424,7.896,5.424,9.2846,0,6.0309-4.9028,11.021-10.935,11.021-6.0309,0-10.934-4.9028-10.934-10.977,0-1.432,4.4686-8.8948,5.64-9.5452,1.6057-0.82507,3.3406-1.3451,5.2937-1.3451z' stroke='%23fdcaa6'/%3E %3Cpath d='m514.96,274.21c1.9096,0,3.8183,0.65033,5.3805,1.5188,1.128,0.69479,5.2937,7.6365,5.2937,9.0685,0,5.9006-4.7726,10.76-10.674,10.76-5.9006,0-10.673-4.7726-10.717-10.717,0-1.4754,4.3394-8.6343,5.5108-9.328,1.6046-0.8261,3.2961-1.3027,5.2058-1.3027z' stroke='%23fdcaa4'/%3E %3Cpath d='m514.96,274.47c1.8662,0,3.7314,0.60691,5.2502,1.4754,1.1714,0.69376,5.2068,7.376,5.2068,8.8514,0,5.7703-4.6857,10.499-10.457,10.499-5.7703,0-10.413-4.6857-10.456-10.457,0-1.5188,4.1646-8.3737,5.3805-9.0685,1.5612-0.823,3.2093-1.3007,5.0755-1.3007z' stroke='%23fdc8a4'/%3E %3Cpath d='m514.96,274.73c1.8228,0,3.6446,0.60691,5.12,1.431,1.2149,0.73822,5.0766,7.1154,5.0766,8.6353,0,5.64-4.5989,10.239-10.197,10.239-5.5966,0-10.153-4.5554-10.197-10.197,0-1.5622,3.992-8.1566,5.2502-8.8514,1.5188-0.77958,3.1235-1.2572,4.9463-1.2572z' stroke='%23fdc8a1'/%3E %3Cpath d='m514.96,275.46c1.6925,0,3.384,0.56349,4.7302,1.3451,1.3451,0.78061,4.6847,6.3338,4.6847,7.9839,0,5.2068-4.2081,9.4583-9.4149,9.4583s-9.4149-4.2081-9.4149-9.4149c0-1.6925,3.4709-7.4194,4.816-8.2,1.3875-0.73925,2.9064-1.1725,4.5989-1.1725z' stroke='%23fdc39b'/%3E %3Cpath d='m514.96,275.72c1.6491,0,3.2972,0.5211,4.5999,1.3017,1.3886,0.82403,4.5554,6.0743,4.5554,7.8102,0,5.0331-4.1222,9.1988-9.1554,9.1988-5.0766,0-9.1543-4.1222-9.1543-9.1988,0-1.7349,3.2972-7.1589,4.6857-7.9829,1.3441-0.69479,2.8195-1.129,4.4686-1.129z' stroke='%23fdc398'/%3E %3Cpath d='m514.96,275.98c1.6057,0,3.2103,0.52006,4.5131,1.2583,1.3886,0.82404,4.3818,5.8137,4.3818,7.5921,0,4.9028-3.992,8.9382-8.8948,8.9382s-8.8948-3.9909-8.8948-8.9382c0-1.7783,3.08-6.9417,4.5565-7.7668,1.3007-0.69273,2.7326-1.0836,4.3383-1.0836z' stroke='%23fdc097'/%3E %3Cpath d='m514.96,276.25c1.5622,0,3.1245,0.47664,4.3828,1.2149,1.432,0.86745,4.2515,5.5976,4.2515,7.376,0,4.7726-3.8607,8.6777-8.6343,8.6777-4.7726,0-8.6343-3.8617-8.6777-8.6777,0-1.8218,2.9508-6.6812,4.4686-7.5063,1.2583-0.69376,2.6468-1.0846,4.2091-1.0846z' stroke='%23fdc095'/%3E %3Cpath d='m514.96,276.46c1.5188,0,2.9942,0.52006,4.2525,1.2149,1.4754,0.86746,4.1212,5.3371,4.1212,7.1589,0,4.6423-3.7304,8.4182-8.3737,8.4182-4.6423,0-8.3737-3.7748-8.4172-8.4182,0-1.8652,2.7771-6.4206,4.2949-7.2891,1.2583-0.65033,2.6034-1.0846,4.1222-1.0846z' stroke='%23fdbe92'/%3E %3Cpath d='m514.96,276.72c1.4754,0,2.9074,0.47664,4.1222,1.1714,1.4754,0.91089,3.9909,5.0766,3.9909,6.9417,0,4.4686-3.6435,8.1576-8.1132,8.1576-4.512,0-8.1566-3.6446-8.1566-8.1576,0-1.9086,2.6034-6.2046,4.1646-7.072,1.2149-0.65137,2.5166-1.0412,3.992-1.0412z' stroke='%23fdbe90'/%3E %3Cpath d='m514.96,276.98c1.432,0,2.8205,0.43425,3.992,1.128,1.5188,0.91089,3.9041,4.816,3.9041,6.7246,0,4.3394-3.5567,7.8971-7.896,7.8971-4.3383,0-7.8971-3.5143-7.8971-7.8971,0-1.952,2.4297-5.944,4.0354-6.8549,1.1714-0.60691,2.4297-0.99774,3.8617-0.99774z' stroke='%23fdbb8f'/%3E %3Cpath d='m514.96,277.24c1.3886,0,2.7337,0.43321,3.8617,1.0846,1.5622,0.95431,3.7738,4.5555,3.7738,6.5075,0,4.2091-3.4264,7.6365-7.6355,7.6365-4.2081,0-7.6365-3.384-7.6365-7.6365,0-1.9955,2.256-5.6835,3.9051-6.6378,1.0846-0.60691,2.3429-0.95431,3.7314-0.95431z' stroke='%23fdbb8d'/%3E %3Cpath d='m514.96,277.5c1.3451,0,2.6468,0.38979,3.7314,1.0412,1.6057,0.95431,3.6446,4.2949,3.6446,6.2904,0,4.0788-3.2972,7.4194-7.376,7.4194s-7.376-3.3406-7.376-7.4194c0-2.0389,2.0823-5.4663,3.7748-6.4206,1.0412-0.56452,2.256-0.91088,3.6012-0.91088z' stroke='%23fdb98a'/%3E %3Cpath d='m514.96,277.76c1.3017,0,2.56,0.38979,3.6011,0.99773,1.6491,0.99773,3.5143,4.0354,3.5143,6.0743,0,3.9486-3.2103,7.1589-7.1154,7.1589-3.9485,0-7.1154-3.2103-7.1154-7.1589,0-2.0823,1.9096-5.2068,3.6011-6.1611,1.0412-0.60794,2.2126-0.91088,3.5143-0.91088z' stroke='%23fdb98a'/%3E %3Cpath d='m514.96,277.98c1.2583,0,2.4731,0.39082,3.5143,0.99773,1.6491,0.99773,3.3406,3.7748,3.3406,5.8572,0,3.8183-3.08,6.8994-6.8549,6.8994-3.8183,0-6.8549-3.08-6.8983-6.8994,0-2.1257,1.7794-4.9897,3.5143-5.944,0.99773-0.56349,2.1257-0.91088,3.384-0.91088z' stroke='%23fcb687'/%3E %3Cpath d='m514.96,278.24c1.2148,0,2.3863,0.34739,3.384,0.9543,1.6925,1.0412,3.2103,3.5143,3.2103,5.64,0,3.688-2.9508,6.6388-6.5943,6.6388s-6.6378-2.9508-6.6378-6.6388c0-2.1692,1.6057-4.7292,3.384-5.7269,0.95431-0.56348,2.0389-0.86745,3.2538-0.86745z' stroke='%23fcb685'/%3E %3Cpath d='m514.96,278.5c1.1714,0,2.2994,0.34637,3.2537,0.91089,1.736,1.0412,3.08,3.2537,3.08,5.4229,0,3.5143-2.8205,6.3782-6.3338,6.3782s-6.3772-2.864-6.3772-6.3348c0-2.256,1.4309-4.512,3.2537-5.5532,0.91089-0.52006,1.952-0.82404,3.1235-0.82404z' stroke='%23fcb485'/%3E %3Cpath d='m514.96,290.95c3.3406,0,6.0743-2.7337,6.0743-6.0743,0-3.384-2.7347-6.1177-6.0743-6.1177-3.384,0-6.1177,2.7337-6.1177,6.1177,0,3.3406,2.7337,6.0743,6.1177,6.0743z' stroke='%23fcb482'/%3E %3C/g%3E %3Cpath d='m515.01,291c3.3406,0,6.0743-2.7337,6.0743-6.1177,0-3.3406-2.7347-6.0743-6.0743-6.0743-3.384,0-6.1177,2.7337-6.1177,6.0743,0,3.384,2.7337,6.1177,6.1177,6.1177z' fill-rule='evenodd' stroke='%23fff' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23fff'/%3E %3Cg stroke='%23000'%3E %3Cg stroke-width='0.13' fill='none'%3E %3Cpath d='M516.31,278.89 517,275.64'/%3E %3Cpath d='M515.66,278.81 516,275.51'/%3E %3Cpath d='M515.01,278.76 515.01,275.46'/%3E %3Cpath d='M514.4,278.81 514.05,275.51'/%3E %3Cpath d='M513.75,278.89 513.05,275.64'/%3E %3Cpath d='M513.14,279.07 512.1,275.9'/%3E %3Cpath d='M512.53,279.28 511.19,276.25'/%3E %3Cpath d='M511.97,279.54 510.28,276.68'/%3E %3Cpath d='M511.4,279.89 509.45,277.24'/%3E %3Cpath d='M510.93,280.32 508.67,277.85'/%3E %3Cpath d='M510.45,280.76 507.98,278.54'/%3E %3Cpath d='M510.06,281.28 507.37,279.33'/%3E %3Cpath d='M509.67,281.8 506.81,280.15'/%3E %3Cpath d='M509.41,282.36 506.37,281.02'/%3E %3Cpath d='M509.15,282.97 506.02,281.93'/%3E %3Cpath d='M508.97,283.58 505.76,282.88'/%3E %3Cpath d='M508.89,284.23 505.59,283.88'/%3E %3Cpath d='M508.84,284.88 505.55,284.88'/%3E %3Cpath d='M508.89,285.49 505.59,285.83'/%3E %3Cpath d='M508.97,286.14 505.72,286.83'/%3E %3Cpath d='M509.15,286.74 505.98,287.79'/%3E %3Cpath d='M509.37,287.35 506.33,288.7'/%3E %3Cpath d='M509.67,287.92 506.15,290.09'/%3E %3Cpath d='M510.01,288.48 502.81,293.6'/%3E %3Cpath d='M510.41,288.96 502.73,295.77'/%3E %3Cpath d='M510.84,289.43 504.5,296.51'/%3E %3Cpath d='M511.36,289.83 506.54,296.29'/%3E %3Cpath d='M511.88,290.22 506.85,298.94'/%3E %3Cpath d='M512.45,290.48 509.67,296.81'/%3E %3Cpath d='M513.05,290.74 510.23,299.46'/%3E %3Cpath d='M513.66,290.91 512.45,296.77'/%3E %3Cpath d='M514.31,291 513.44,300.02'/%3E %3Cpath d='M515.57,291 515.92,294.29'/%3E %3Cpath d='M516.22,290.91 518.17,299.41'/%3E %3Cpath d='M516.83,290.74 518.48,295.77'/%3E %3Cpath d='M517.43,290.52 521.3,298.89'/%3E %3Cpath d='M518.04,290.22 522.16,297.33'/%3E %3Cpath d='M518.56,289.87 524.51,297.68'/%3E %3Cpath d='M519.08,289.48 524.29,295.51'/%3E %3Cpath d='M519.52,289.05 527.24,296.07'/%3E %3Cpath d='M519.91,288.52 524.12,291.56'/%3E %3Cpath d='M520.3,288 523.16,289.65'/%3E %3Cpath d='M520.56,287.44 523.6,288.78'/%3E %3Cpath d='M520.82,286.83 523.94,287.87'/%3E %3Cpath d='M520.99,286.22 524.2,286.92'/%3E %3Cpath d='M521.08,285.57 524.38,285.92'/%3E %3Cpath d='M521.12,284.92 524.42,284.92'/%3E %3Cpath d='M521.08,284.31 524.38,283.97'/%3E %3Cpath d='M520.99,283.66 524.25,282.97'/%3E %3Cpath d='M520.82,283.06 523.99,282.02'/%3E %3Cpath d='M520.6,282.45 523.64,281.1'/%3E %3Cpath d='M520.34,281.84 523.21,280.19'/%3E %3Cpath d='M519.99,281.32 522.64,279.37'/%3E %3Cpath d='M519.56,280.8 522.03,278.59'/%3E %3Cpath d='M519.13,280.37 521.34,277.89'/%3E %3Cpath d='M518.61,279.93 520.56,277.29'/%3E %3Cpath d='M518.09,279.59 519.73,276.72'/%3E %3Cpath d='M517.52,279.33 518.87,276.29'/%3E %3Cpath d='M516.91,279.07 517.96,275.94'/%3E %3Cpath d='M515.01,270.99 515.01,268.43'/%3E %3Cpath d='M512.14,271.3 511.62,268.78'/%3E %3Cpath d='M509.37,272.17 508.32,269.87'/%3E %3Cpath d='M506.85,273.64 505.33,271.56'/%3E %3Cpath d='M504.68,275.55 502.77,273.86'/%3E %3Cpath d='M502.99,277.94 500.73,276.64'/%3E %3Cpath d='M501.77,280.58 499.34,279.76'/%3E %3Cpath d='M501.16,283.4 498.6,283.14'/%3E %3Cpath d='M501.16,286.31 498.6,286.57'/%3E %3Cpath d='M501.77,289.18 499.3,289.96'/%3E %3Cpath d='M527.02,291.87 529.24,293.17'/%3E %3Cpath d='M528.19,289.22 530.62,290'/%3E %3Cpath d='M528.8,286.4 531.36,286.66'/%3E %3Cpath d='M528.8,283.49 531.36,283.23'/%3E %3Cpath d='M528.19,280.63 530.67,279.85'/%3E %3Cpath d='M527.02,277.98 529.24,276.68'/%3E %3Cpath d='M525.33,275.64 527.24,273.9'/%3E %3Cpath d='M523.21,273.69 524.68,271.6'/%3E %3Cpath d='M520.69,272.21 521.73,269.87'/%3E %3Cpath d='M517.91,271.3 518.43,268.83'/%3E %3C/g%3E %3Cpath d='m518.56,287.74s-0.86746-0.47767-1.3886-0.47767c-0.52006,0-2.8205-0.13028-3.7314,0.13027-0.52006,0.1737-0.95431,0.60691-0.95431,0.60691s0.60691,0.60795,1.8218,0.73822c1.2583,0.0858,2.0389,0,2.6903-0.21712,0.73822-0.21713,1.5622-0.78061,1.5622-0.78061z' fill-rule='evenodd' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23e60000'/%3E %3Cpath d='m512.66,286.83s0.0868-1.6925,1.2583-3.8183c0,0-0.38979,0.60691-0.60691,1.128,0,0-0.65137,0.3474-1.0422-0.13027-0.38979-0.38979-0.17267-0.56349,0.13027-1.1714,0.25951-0.47767,0.21609-0.95431,0.56349-1.2583,0.30294-0.30397,0.56348-0.34739,1.3886-0.34739,0.82507,0,1.3451,0.0868,2.0389,1.0412,0.60691,0.82404,0.95431,1.6057,1.2583,2.0389,0.69376,1.0846,0.69376,2.3863,0.69376,2.3863l0.21713,1.0412s-0.86746-0.47767-1.3886-0.47767c-0.52006,0-2.8205-0.13028-3.7314,0.13027-0.52006,0.1737-0.9543,0.60691-0.9543,0.60691s-0.34637-0.77854,0.17473-1.1694z' fill-rule='evenodd' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23e60000'/%3E %3Cpath d='m512.66,286.83s0.65137-0.39082,2.864-0.3474c2.56,0.0434,2.6458,0.21713,2.8195,0.39082' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m514.87,296.38,0-8.9817s0.30397-0.26055,0.99773,0v8.8948s0.21712,6.8115-0.52109,6.768c-0.86746,0.001-0.47664-1.5612-0.47664-6.6812z' fill-rule='evenodd' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3C/g%3E %3Cg fill='%23e60000'%3E %3Cpath d='m505.59,288.83,0.1737,0.3474-1.7349,0.73718,0.25951,0.60691-0.25951,0.0869c-0.1737-0.39082-0.30397-0.52006-0.73822-0.43321l-0.12924-0.26055,2.4287-1.0846z' fill-rule='evenodd'/%3E %3Cpath d='m503.72,288.09c-0.13028-0.0868-0.26055-0.25951-0.30398-0.47664-0.0869-0.43424,0.0868-0.91088,0.65137-1.0412,0.25952-0.0868,0.91089-0.0868,1.128,0.73718,0.0868,0.3474,0.0434,0.78061-0.52109,0.99773l-0.0858-0.34739c0.30294-0.0858,0.38979-0.34637,0.30294-0.65034-0.0869-0.34636-0.38979-0.47664-0.73719-0.38979-0.34739,0.0868-0.47663,0.38979-0.43321,0.69376,0.0434,0.1737,0.17267,0.34637,0.39082,0.43322l0.0434,0.26054-1.4754,0.13028-0.30294-1.3451,0.34637-0.0434,0.26055,1.0846,0.73615-0.0434z' fill-rule='evenodd'/%3E %3Cpath d='m503.03,283.23c-0.43425,0-0.60692,0.30397-0.60692,0.60794-0.0434,0.25951,0,0.65034,0.38979,0.69376,0.26055,0,0.3474-0.1737,0.39082-0.30397l0.25952-0.78061c0.0868-0.34636,0.34636-0.56349,0.73718-0.52006,0.65034,0.0434,0.78061,0.65033,0.73719,1.128-0.0434,0.47768-0.21712,0.6948-0.30294,0.78061-0.26055,0.21713-0.47767,0.26055-0.73822,0.21713l0.0434-0.34637c0.47767,0.0434,0.65137-0.34739,0.69479-0.69479,0.0434-0.25951,0-0.69376-0.39082-0.73719-0.30397-0.0434-0.39082,0.0868-0.52006,0.5211l-0.1737,0.56349c-0.0868,0.1737-0.21713,0.56348-0.69376,0.52006-0.43322-0.0434-0.82404-0.34636-0.78061-0.99773,0.0868-0.95431,0.65033-0.99774,0.95431-0.99774v0.35z' fill-rule='evenodd'/%3E %3Cpath d='M75.327,65.759,76.082,66.01,76.543,64.625,76.837,64.751,76.375,66.094,77.215,66.388,77.719,64.877,78.012,64.961,78.012,64.961,77.425,66.808,74.907,66.01,75.495,64.164,75.83,64.29z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='m520.81,277.53c-0.19515,0.0487-0.40098,0.18964-0.53125,0.40625l-0.59375,1.0312,2.2812,1.4375,0.21875-0.28125-1-0.625,0.4375-0.71875c0.30294-0.52109,0.0964-0.94016-0.25-1.1562-0.17371-0.10856-0.36735-0.14247-0.5625-0.0937zm0.15625,0.40625c0.0589,0.009,0.12236,0.0503,0.1875,0.0937,0.2605,0.17369,0.26745,0.39674,0.0937,0.65625l-0.34375,0.5625-0.75-0.4375,0.40625-0.625c0.0977-0.16282,0.22945-0.27646,0.40625-0.25z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M80.11,62.024,79.901,62.275,78.222,60.681,77.593,61.311,77.383,61.101,77.383,61.101,78.852,59.548,79.104,59.758,78.474,60.429z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='M80.992,61.269,79.439,59.17,79.691,58.96,81.286,61.059,81.286,61.059z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='M80.95,58.499,81.327,59.212,82.628,58.541,82.754,58.834,81.496,59.506,81.873,60.261,83.3,59.548,83.426,59.8,83.426,59.8,81.705,60.723,80.488,58.373,82.208,57.492,82.334,57.786z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='m513.75,274.77-0.3474-1.5612c0-0.0868-0.0434-0.39082-0.13027-0.65136l-0.25951,2.3863-0.3474,0.0869-1.2583-2.0823c0.0434,0.26054,0.13027,0.60691,0.1737,0.65033l0.34636,1.6057-0.34636,0.0434-0.60795-2.6468,0.5211-0.0869,1.2583,2.0834,0.26055-2.4297,0.52006-0.13028,0.56348,2.6903-0.34636,0.0424z' fill-rule='evenodd'/%3E %3Cpath d='m530.78,272-0.125,2.7188,1.1562,0.0312c0.60691,0.0434,0.96875-0.2845,0.96875-0.71875,0.0434-0.47664-0.29505-0.6007-0.46875-0.6875,0.30392-0.12924,0.375-0.3888,0.375-0.5625,0.0434-0.38978-0.19869-0.7066-0.71875-0.75l-1.2-0.03zm0.40625,0.375,0.59375,0.0625c0.39082,0,0.53125,0.11446,0.53125,0.375-0.0434,0.304-0.2151,0.38715-0.5625,0.34375h-0.625l0.0625-0.78125zm-0.0625,1.125,0.65625,0.0625c0.26055,0,0.5625,0.0911,0.5625,0.4375,0,0.26055-0.2151,0.4375-0.5625,0.4375l-0.6875-0.0625,0.0312-0.875z' transform='translate(-16.12698,0)'/%3E %3Cpath d='m533.8125,272.25 -0.71875,2.65625 0.34375,0.0937 0.28125,-1.125 0.875,0.25c0.4343,0.12924 0.38715,0.37662 0.34375,0.59375 -0.0434,0.0858 -0.1684,0.48255 -0.125,0.65625l0.4375,0.125 0,-0.0312c-0.0868,-0.0869 -0.0747,-0.1388 -0.0312,-0.3125l0.0625,-0.46875c0.13027,-0.3474 0.005,-0.4767 -0.125,-0.5625 0.1737,-0.0879 0.44445,-0.14146 0.53125,-0.53125 0.1737,-0.56349 -0.222,-0.80723 -0.65625,-0.9375L533.8125,272.25zm0.34375,0.46875L534.9375,273c0.1737,0.0434 0.44278,0.11022 0.3125,0.5 -0.0869,0.34745 -0.3332,0.32465 -0.59375,0.28125l-0.75,-0.21875 0.25,-0.84375z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M92.742,58.289,92.322,58.96,93.581,59.716,93.413,59.967,92.154,59.254,91.734,60.009,93.077,60.807,92.952,61.059,92.952,61.059,91.273,60.093,92.574,57.827,94.253,58.792,94.085,59.086z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='m540.31,275.81-2.0625,1.7188,0.6875,0.875c0.607,0.65036,1.3359,0.35854,1.8125-0.0312,0.60795-0.4777,0.75892-1.1865,0.28125-1.75l-0.71875-0.8125zm-0.0312,0.59375,0.40625,0.5c0.30397,0.34736,0.25892,0.72303-0.21875,1.1562-0.47659,0.3908-0.91478,0.37865-1.2188,0.0312l-0.40625-0.46875,1.4375-1.2188z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M97.735,63.157,96.98,63.534,97.651,64.793,97.357,64.961,96.729,63.661,95.932,64.038,96.645,65.465,96.351,65.591,96.351,65.591,95.47,63.87,97.819,62.695,98.701,64.416,98.407,64.542z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='m525.11,283.71-0.0434-0.3474,1.8662-0.25951-0.0868-0.60692,0.26055-0.0434c0.13027,0.43321,0.17369,0.56349,0.60691,0.60691l0.0434,0.25951-2.6468,0.39083z' fill-rule='evenodd'/%3E %3Cpath d='m542.09,284.53c-0.12924,0-0.36446-0.0106-0.625,0.25-0.17373,0.21712-0.21875,0.48358-0.21875,0.65625-0.0434,0.60794,0.39042,0.90625,0.78125,0.90625,0.21608,0.0434,0.5138-0.0286,0.6875-0.375,0.0434,0.13027,0.18385,0.34475,0.53125,0.34375,0.34637,0.0434,0.71875-0.17433,0.71875-0.78125,0.0434-0.60794-0.38456-0.84375-0.6875-0.84375-0.26055,0-0.44435,0.11549-0.53125,0.375-0.0869-0.30294-0.30885-0.48785-0.65625-0.53125zm0,0.4375c0.21712,0,0.44965,0.18489,0.40625,0.53125,0,0.26055-0.12239,0.46875-0.46875,0.46875-0.39085,0-0.4375-0.31413-0.4375-0.53125,0-0.38974,0.28391-0.46875,0.5-0.46875zm1.1875,0.125c0.1737,0,0.38715,0.0901,0.34375,0.4375,0,0.34641-0.21348,0.4375-0.34375,0.4375-0.21713-0.0434-0.40625-0.23945-0.40625-0.5,0-0.21609,0.18912-0.375,0.40625-0.375z' transform='translate(-16.12698,0)'/%3E %3Cpath d='m526.76,286.92c0.86746,0.21609,0.78061,0.86746,0.73719,1.128-0.12924,0.43321-0.52006,0.73822-0.99773,0.60794-0.43425-0.0868-0.56349-0.43424-0.69376-0.91088l-0.0869-0.30397c-0.0869-0.38979-0.26055-0.52007-0.39082-0.56349l-0.3474,1.432-0.30397-0.0868,0.43424-1.7794c0.56349,0.1737,0.78165,0.47767,0.91089,0.86746l0.0868,0.39082c0.0869,0.30294,0.1737,0.56349,0.5211,0.60691,0.1737,0.0868,0.47767,0,0.56452-0.38978,0.13028-0.47767-0.30397-0.60795-0.47767-0.65137l0.0434-0.3474z' fill-rule='evenodd'/%3E %3Cpath d='m524.12,289.52,0.17267-0.34636,1.6925,0.82403,0.26055-0.56452,0.26055,0.0868c-0.1737,0.43425-0.21712,0.60795,0.13027,0.86746l-0.0868,0.26055-2.4297-1.128z' fill-rule='evenodd'/%3E %3C/g%3E %3Cpath d='M87.035,37.978,43.14,111.42,130.97,111.42,130.97,111.42z' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.2938' fill='none' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cg%3E %3Cg stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m517.43,319.37c1.1714,0.30397,2.6034,0.47767,4.0344,0.0868,1.9531-0.47767,3.7748-1.6057,6.0743-1.3886,1.6491,0.17267,3.9051,1.6057,6.6388,1.6057,2.6903,0,3.6011-0.95534,5.944-1.433,1.6491-0.34636,2.4742-0.17267,4.2525,0.21712,2.0389,0.39082,3.08,1.5623,6.5075,1.3027' stroke='%23000' stroke-width='0.13017058'/%3E %3Cpath d='m482.42,322.63c1.5178-1.1725,4.2081-1.6491,6.248-1.1725,2.6903,0.56452,3.8607,1.2583,6.7246,1.2148,2.1268-0.0424,3.9485-1.4744,6.1177-1.4744,3.6011,0,3.7314,0.73719,6.8983,1.3451,0.82404,0.17267,1.8662,0.17267,2.6903,0,1.1714-0.21712,2.2136-0.60794,3.1669-1.0856,0.99774-0.52007,3.5143-0.43322,4.7726-0.30294,2.256,0.21609,3.1669,1.0846,3.6446,1.2148,1.2149,0.30294,2.6034,0.47768,4.0344,0.0869,1.9531-0.56452,3.7738-1.8228,6.1177-1.5622,1.6491,0.1737,3.9041,1.7783,6.5954,1.7783,2.6903,0,3.6435-1.0846,5.944-1.6046,1.6925-0.39082,2.5166-0.1737,4.2949,0.21712,1.9965,0.47664,3.08,1.7783,6.5085,1.4744' stroke='%23fff' stroke-width='0.47725767'/%3E %3Cpath d='m477.3,320.07c1.5188-0.99773,4.2091-1.432,6.248-1.0412,2.6903,0.5211,3.8617,1.1714,6.7246,1.128,2.1257-0.0434,3.9485-1.3451,6.1177-1.3451,3.6011,0,3.7314,0.69479,6.8983,1.2149,0.82506,0.13027,1.8662,0.13027,2.6903,0,1.1714-0.17267,2.2126-0.56349,3.1669-0.99774,0.9543-0.43424,3.5143-0.34739,4.7726-0.26054,2.256,0.21712,3.1669,0.95534,3.6446,1.0856,1.2149,0.25952,2.6034,0.43321,4.0344,0.0858,1.9531-0.52006,3.7748-1.6057,6.1177-1.3886,1.6491,0.1737,3.9051,1.6057,6.5954,1.5623,2.6903,0,3.6446-0.95431,5.944-1.432,1.6925-0.3474,2.5166-0.13028,4.2949,0.21712,1.9965,0.43425,3.08,1.6057,6.5085,1.3017' stroke='%23fff' stroke-width='0.34708709'/%3E %3Cpath d='m472.61,327.49c1.5188-1.2583,4.2091-1.7783,6.2914-1.3017,2.6468,0.65137,3.8183,1.432,6.6822,1.3886,2.1257-0.0434,3.9909-1.6481,6.1177-1.6481,3.6446,0,3.7304,0.82404,6.8983,1.5188,0.82404,0.17267,1.8662,0.17267,2.7337,0,1.1714-0.26054,2.1692-0.69479,3.1235-1.2593,0.99773-0.52006,3.5143-0.43321,4.816-0.30294,2.2126,0.25951,3.1235,1.1714,3.6012,1.3451,1.2148,0.30294,2.6034,0.52006,4.0778,0.0868,1.9531-0.65137,3.7748-1.9965,6.0743-1.736,1.6491,0.21609,3.9051,1.9955,6.6388,1.9955,2.6468,0,3.6011-1.2148,5.9006-1.8218,1.6925-0.43425,2.5166-0.1737,4.2949,0.26054,2.0399,0.52007,3.08,1.9955,6.5085,1.6481' stroke='%23fff' stroke-width='0.60742819'/%3E %3Cpath d='m473.83,323.23c1.5623-1.0412,4.2525-1.432,6.2914-1.0412,2.6903,0.52006,3.8617,1.128,6.7256,1.0846,0.95431,0,1.8228-0.26054,2.7337-0.56452' stroke='%23fff' stroke-width='0.34708709'/%3E %3Cpath d='m487.58,318.81c0.43321-0.13027,1.6915-0.73719,3.5143-0.73719,3.6446,0,1.3451,0.0434,4.512,0.60692,0.82403,0.13027,3.1235,0.17369,3.7748-0.47767' stroke='%23000' stroke-width='0.3037658'/%3E %3Cpath d='m531.15,328.49c1.1714-0.21712,2.1702-0.56452,3.1669-0.99877,0.95431-0.43321,3.4709-0.38978,4.7726-0.25951,2.257,0.21712,3.1235,0.95431,3.6446,1.0412,1.2148,0.30397,2.6034,0.47767,4.0344,0.0869,1.9531-0.47767,3.7748-1.6057,6.1177-1.3886,1.6491,0.1737,3.9051,1.6057,6.5954,1.6057' stroke='%23000' stroke-width='0.3037658'/%3E %3Cpath d='m536.74,318.46c2.6913,0,3.6012-0.95431,5.945-1.432,1.6491-0.34636,2.4731-0.13027,4.2515,0.21713,2.0389,0.39082,3.08,1.6057,6.5075,1.3017' stroke='%23fff' stroke-width='0.34708709'/%3E %3Cpath d='m472.74,327.75c1.5622-0.99773,4.2515-1.432,6.2914-1.0412,2.6903,0.5211,3.8617,1.1714,6.7246,1.128,2.1257-0.0434,3.9486-1.3451,6.1177-1.3451,3.6012,0,3.7314,0.6948,6.8983,1.2149,0.82403,0.13027,1.8662,0.13027,2.6903,0,1.1714-0.1737,2.1692-0.56349,3.1669-0.99774,0.95431-0.43424,3.4709-0.34739,4.7726-0.21712,2.256,0.1737,3.1235,0.91192,3.6435,1.0412' stroke='%23000' stroke-width='0.13017058'/%3E %3Cpath d='m478.47,324.45c1.5612-1.0412,4.2515-1.432,6.2904-1.0412,2.6903,0.52109,3.8617,1.128,6.6822,1.0846,2.1692-0.0434,3.9909-1.3451,6.1177-1.3017,3.6446,0,3.7748,0.65137,6.9418,1.2149,0.82403,0.13028,1.8652,0.13028,2.6903,0,1.1714-0.21609,2.1692-0.56349,3.1669-0.99773,0.9543-0.43425,3.4709-0.39082,4.7726-0.26055,2.2126,0.21712,3.1235,0.95534,3.6446,1.0422,1.1714,0.30294,2.6034,0.47664,4.0354,0.0869,1.952-0.47767,3.7738-1.6067,6.1177-1.3886,1.7783,0.17266,4.0344,1.6046,6.5943,1.6046,2.6913,0,3.6446-0.95431,5.944-1.432,1.6491-0.3474,2.4742-0.17266,4.2959,0.21712,1.9955,0.39083,3.08,1.5623,6.4641,1.2583' stroke='%23000' stroke-width='0.60742819'/%3E %3C/g%3E %3Cg fill-rule='evenodd' stroke='%23000' stroke-width='0.26' fill='%23fc0'%3E %3Cpath d='m479.69,311.82c0.43321,0.0868,1.4754-0.73822,1.7794-0.95534,0.43321-0.26055,0.65033-0.91088,0.99773-1.2583,0.34636-0.39082,1.3886-0.86746,1.8652-1.1714,2.0823-1.3017,3.0377-2.0399,4.4686-3.9485,1.9531-2.6903,4.2525-4.9028,7.1154-6.5075,0.91088-0.52109,2.2994-0.3474,3.2972,0.0858,0.30294,0.13027,0.69376,0.47767,1.0412,0.73718,1.2148,0.95431,2.864,1.6491,4.8594,2.257,1.9086,0.56349,2.3429,1.8218,3.8617,3.1669,0.73718,0.65033,1.5622,1.2149,2.4731,1.6481,0.0869,0.0434,0.30294,0.39082,0.38979,0.43424,0.86746,0.65137,1.8228,1.1725,2.56,1.8228,1.3886,1.2583,2.6903,2.5176,3.9909,3.8617,0.21713,0.21609,0.30397,0.65033,0.5211,0.82403,0.99773,0.95431,1.9531,1.9531,3.1669,2.5166,1.2148,0.60794,2.2994,1.3896,3.4274,2.0834-11.542,0.43424-22.171-0.30398-33.755,0.0434-0.30397,0.0434-0.39082,0-2.1268,0-0.86745-0.0434-1.3886,0.0434-2.256,0.0434-3.5143-0.0434-6.8549-0.0434-10.977-0.0868l3.3003-5.5966z'/%3E %3Cpath d='m525.03,317.12c-0.95431-0.60794-1.9096-1.2583-2.9508-1.7794-1.2149-0.56349-2.1702-1.5623-3.1669-2.5166-0.21712-0.1737-0.30397-0.60794-0.5211-0.82403-1.3017-1.3451-2.6034-2.6044-3.9909-3.8617-0.73718-0.65034-1.6925-1.1714-2.56-1.8228-0.0869-0.0434-0.30293-0.39082-0.38978-0.43424-0.91089-0.43321-1.736-0.99774-2.4731-1.6481-0.99773-0.91192-1.5188-1.736-2.3429-2.3873l0.0434-0.0434c0.47767-0.3474,0.99773-0.69376,1.5622-0.95431,0.73719-0.43321,1.9086-0.30294,2.7337,0.0868,0.26055,0.0869,0.60794,0.3474,0.86746,0.56349,0.99773,0.82507,2.3863,1.3886,4.0354,1.9096,1.6057,0.47767,1.9965,1.5188,3.2538,2.6034,0.60794,0.56452,1.2583,1.0422,2.0399,1.3896,0.0434,0.0434,0.21609,0.30294,0.30294,0.38979,0.73822,0.52109,1.5188,0.95534,2.1702,1.5188,1.128,1.0422,2.2136,2.0834,3.2972,3.2103,0.1737,0.1737,0.21712,0.5211,0.43425,0.6948,0.82403,0.78061,1.6481,1.6057,2.6468,2.0823,0.99774,0.47767,1.8652,1.129,2.8205,1.6925-2.6034,0.13027-5.1634,0.13027-7.7234,0.13027h-0.0889z'/%3E %3Cpath d='m514.74,303.06c0.34637,0.0868,0.73719,0.21712,1.128,0.3474,1.6057,0.47767,1.9965,1.5188,3.2538,2.6034,0.60794,0.56452,1.2583,1.0422,2.0399,1.3896,0.0434,0.0434,0.21609,0.30294,0.30294,0.38979,0.73822,0.52109,1.5188,0.95534,2.1702,1.5188,1.128,1.0422,2.2136,2.0834,3.2972,3.2103,0.1737,0.1737,0.21713,0.52109,0.43425,0.69479,0.82403,0.78061,1.6481,1.6057,2.6468,2.0823,0.86746,0.39082,1.6057,0.95534,2.3863,1.433,2.1268,0,4.2515-0.0434,6.4651-0.13027-0.86849-0.5211-1.6491-1.129-2.6034-1.5623-0.91192-0.43424-1.6057-1.1725-2.3873-1.9096-0.17369-0.13027-0.21712-0.43424-0.38978-0.60794-0.99877-1.0412-1.9965-1.952-3.0377-2.9074-0.56349-0.52109-1.2583-0.91088-1.9086-1.3886-0.0868-0.0434-0.26055-0.30397-0.30397-0.3474-0.6948-0.34636-1.3017-0.73718-1.8662-1.2583-1.128-0.99773-1.4754-1.9531-2.9508-2.3863-1.4754-0.43424-2.7337-0.99876-3.6435-1.6925-0.26055-0.21712-0.56452-0.47767-0.78165-0.56452-0.78164-0.34739-1.8228-0.47767-2.5166-0.0868-0.60691,0.34843-1.2148,0.73925-1.7349,1.1725z'/%3E %3Cpath d='m525.33,305.53c0.30397,0.34636,0.60794,0.69376,1.0412,1.0846,0.56452,0.5211,1.1714,0.91192,1.8662,1.2583,0.0434,0.0434,0.21712,0.30397,0.30397,0.3474,0.65034,0.47767,1.3451,0.86746,1.9086,1.3886,1.0422,0.95535,2.0399,1.8662,3.0377,2.9074,0.17266,0.1737,0.21609,0.47767,0.38978,0.60794,0.78165,0.73719,1.4754,1.4754,2.3873,1.9096,0.60691,0.30294,1.128,0.65034,1.6925,0.99774h-0.0434c2.5166,0,5.0321,0,7.5931-0.0869-0.69479-0.43425-1.3027-0.91089-2.0834-1.2583-0.73718-0.39082-1.3017-0.99774-1.9531-1.5623-0.12924-0.13027-0.17267-0.34739-0.30398-0.52109-0.82403-0.82404-1.6046-1.5623-2.4297-2.3429-0.47664-0.43424-1.0412-0.73821-1.5622-1.129-0.0868-0.0434-0.21713-0.21609-0.26055-0.25951-0.56349-0.26055-1.0412-0.60795-1.5188-0.99877-0.91088-0.82403-1.1714-1.6057-2.3429-1.9531-1.2159-0.38979-2.257-0.78061-2.9942-1.3886-0.21712-0.17266-0.43424-0.34636-0.60794-0.43321-0.65034-0.26055-1.4754-0.39082-2.0399-0.0868-0.78061,0.43321-1.432,0.91088-2.0823,1.4754v0.0434h0.002z'/%3E %3Cpath d='m544.99,315.6c-0.47767-0.3474-0.99773-0.65034-1.5622-0.91089-0.73719-0.39082-1.3017-0.99773-1.9531-1.5622-0.12924-0.13027-0.17266-0.3474-0.30397-0.5211-0.82403-0.82403-1.6046-1.5622-2.4297-2.3429-0.47664-0.43425-1.0412-0.73822-1.5623-1.129-0.0869-0.0434-0.21712-0.21609-0.26054-0.25951-0.56349-0.26055-1.0412-0.60795-1.5188-0.99877-0.78061-0.69376-1.0846-1.3451-1.8652-1.7794l0.0424,0.0434c0.39083-0.30294,0.82507-0.60692,1.2593-0.82404,0.52006-0.30397,1.2149-0.1737,1.7783,0.0434,0.13028,0.0434,0.3474,0.26054,0.5211,0.39082,0.65137,0.47664,1.4754,0.86746,2.561,1.1714,0.99773,0.30294,1.2149,0.95431,1.9955,1.6491,0.39082,0.3474,0.82506,0.65034,1.3017,0.86746,0.0434,0.0434,0.13028,0.21713,0.21712,0.26055,0.43425,0.30397,0.95431,0.56452,1.3451,0.95534,0.69479,0.65034,1.3886,1.3017,2.0833,1.9955,0.13028,0.13027,0.13028,0.3474,0.26055,0.43425,0.5211,0.47767,1.0412,0.99773,1.6491,1.3017,0.65033,0.3474,1.2148,0.73822,1.8218,1.0846-1.8218,0.0868-3.6001,0.0868-5.3795,0.0868v0.0434h-0.001z'/%3E %3C/g%3E %3Cg stroke='%2300633b' stroke-width='0.13' fill='none'%3E %3Cpath d='m494.83,298.72c0.56349-0.0869,0.30294-0.21609,0.82403,0.13027'/%3E %3Cpath d='m493.79,299.41c0.60691-0.0869,0.82404-0.47767,1.2583,0.0434'/%3E %3Cpath d='m493.22,299.81c0.26055,0,0.43425-0.30397,1.2583,0.17267'/%3E %3Cpath d='m492.62,300.5c0.5211-0.13027,0.82403-0.0868,1.3451,0.0869'/%3E %3Cpath d='m491.92,301.02c0.60691-0.1737,0.86745,0.26055,1.5188,0.13027'/%3E %3Cpath d='m491.18,301.76c0.38979,0,0.5211-0.13028,0.86746,0,0.43321,0.13027,0.34636,0.0434,0.78061,0.0868'/%3E %3Cpath d='m490.36,302.54c0.43424,0,0.56348-0.0869,0.9543-0.0434,0.52007,0.0868,0.39083,0.13028,0.91089,0.0434'/%3E %3Cpath d='m489.88,303.19c0.86746-0.0868,1.128-0.0434,1.7349,0.1737'/%3E %3Cpath d='m488.71,304.79c0.73719-0.21712,1.0846-0.21712,1.736,0.0434'/%3E %3Cpath d='m476.65,317.2c2.3863-0.39082,5.2068,0.0434,7.5931-0.30397'/%3E %3Cpath d='m489.06,304.01c0.60691-0.21712,0.47664-0.13027,1.0846-0.0868,0.60795,0.0868,0.86746,0.1737,1.0412,0.0868'/%3E %3Cpath d='m488.1,305.4c0.60691-0.30397,1.3451-0.13027,1.9531,0.0434'/%3E %3Cpath d='m489.67,306.05c-0.65034-0.1737-1.3451-0.0434-2.0389,0'/%3E %3Cpath d='m489.15,306.75c-0.6948-0.21712-1.432-0.30397-2.1268-0.0868'/%3E %3Cpath d='m486.06,307.27c0.86746,0,1.6925-0.21712,2.56,0.0868'/%3E %3Cpath d='m485.33,307.96c0.91088-0.30397,1.8228-0.0434,2.7771,0.0434'/%3E %3Cpath d='m484.46,308.48c0.95431-0.0434,1.8652-0.0434,2.8205-0.0868,0.13027,0,0.43424-0.13028,0.60691,0.0868'/%3E %3Cpath d='m487.58,309c-1.432,0.30397-2.864,0.0869-4.2959,0.13027'/%3E %3Cpath d='m486.8,309.74c-0.47768,0.0434-1.2149,0.21712-1.8662,0.1737-0.13028-0.0434-0.25952-0.13028-0.38979-0.13028-0.73718-0.0434-1.4754-0.0434-2.1692,0.21713'/%3E %3Cpath d='m482.07,310.52c0.30398-0.1737,0.65034-0.21712,0.95431-0.13027,0.91089,0.13027,1.7783,0,2.6468,0.21609,0.21712,0.0868,0.43424,0.21712,0.69376,0.21712'/%3E %3Cpath d='m481.55,310.87c0.65033,0,1.3017-0.0868,1.952,0.0434,0.82403,0.21712,1.6057,0.39082,2.4731,0.43424h-0.0869'/%3E %3Cpath d='m480.94,311.35c0.69376,0,1.3451,0.13028,2.0399,0.26055,0.91088,0.1737,1.8218-0.0868,2.6903,0.1737'/%3E %3Cpath d='m480.12,311.78c0.91088,0.38979,1.8662,0.0434,2.8205,0.21712,0.91089,0.17267,1.736,0.12924,2.6034,0.30294'/%3E %3Cpath d='m479.51,312.47c1.3886,0.0434,2.7771,0,4.2091,0.26055,0.38978,0.0868,0.99773,0.26055,1.5188,0.1737'/%3E %3Cpath d='m479.04,313.08c1.3451,0.26054,2.7337,0.0434,4.0778,0.39082,0.60794,0.13027,1.2583,0.25951,1.9096,0.25951h-0.0868'/%3E %3Cpath d='m478.47,314.12c0.12924-0.0434,0.30294-0.13027,0.43321-0.13027,1.0846,0,2.1257,0.1737,3.2538,0.0434,0.86746-0.0434,1.8218-0.13027,2.6903,0.1737h-0.0868'/%3E %3Cpath d='m477.99,314.82c2.1692-0.21713,4.3828,0.0868,6.552,0'/%3E %3Cpath d='m477.6,315.47c2.2994,0.26055,4.5989,0.0434,6.8549,0.21713'/%3E %3Cpath d='m477.26,316.16c0.99773,0.21712,1.9965-0.0868,2.9942,0.13027,0.73719,0.13028,1.3886,0.25952,2.1268,0.13028,0.65033-0.1737,1.2583,0.0434,1.8652-0.0434'/%3E %3Cpath d='m493.53,306.88h0.21713'/%3E %3Cpath d='m493.31,307.14c0.0868,0.0434,0.21712-0.13028,0.26055,0.0434'/%3E %3Cpath d='m493.05,307.49h0.47663'/%3E %3Cpath d='m492.83,307.79h0.60691'/%3E %3Cpath d='m492.44,308.18c0.3474,0.0434,0.65137,0.0869,0.99773,0.0869h-0.0869'/%3E %3Cpath d='m492.1,308.7c0.38979-0.13027,0.82404,0,1.2149-0.13027h-0.0869'/%3E %3Cpath d='m491.58,309.31h1.6491-0.0858'/%3E %3Cpath d='m491.31,309.7c0.60692,0,1.1714-0.0869,1.736,0.0434h-0.0434'/%3E %3Cpath d='m490.97,310.26c0.65033-0.0869,1.3451,0,2.0399,0.0868'/%3E %3Cpath d='m490.58,310.87c0.43321-0.0434,0.78061,0.21712,1.2149,0.30397,0.34739,0.0869,0.65033,0,0.9543-0.0434'/%3E %3Cpath d='m490.45,311.35c0.65034,0.21713,1.3451,0.26055,1.9955,0.30398'/%3E %3Cpath d='m490.06,311.87c0.56349-0.0434,1.0846,0.0868,1.6491,0.25951,0.25951,0.0869,0.52006,0.0434,0.73718,0.0434h-0.0434'/%3E %3Cpath d='m489.32,312.69c0.6948-0.30397,1.5188-0.0869,2.256,0.13028,0.26055,0.0869,0.52109-0.0434,0.82403-0.0434h-0.0869'/%3E %3Cpath d='m489.23,313.21c0.82507-0.26055,1.6925-0.26055,2.4742,0.0869,0.12924,0.0434,0.30293,0,0.43321,0'/%3E %3Cpath d='m488.71,313.82c1.0846,0.21712,2.2126-0.12924,3.2972,0.1737'/%3E %3Cpath d='m488.41,314.3c0.86746,0.3474,1.8228,0,2.7771,0.26055,0.30294,0.0869,0.60691,0.0869,0.91088-0.0434'/%3E %3Cpath d='m487.8,314.95c0.39082-0.13027,0.78164-0.21712,1.1714-0.13027,1.0412,0.26055,1.9955,0.1737,2.9508,0.30397'/%3E %3Cpath d='m487.32,315.64c0.21712-0.0434,0.43424,0.13028,0.60691,0.0869,1.3451-0.21712,2.6903,0,3.992-0.0869'/%3E %3Cpath d='m486.98,316.16c1.0412,0.38979,2.1257,0,3.2538,0.30397,0.43425,0.13027,0.99773,0.1737,1.4754,0'/%3E %3Cpath d='m486.59,316.9c1.6057,0.0434,3.1235-0.0434,4.9897,0.1737'/%3E %3Cpath d='m495.7,307.7c0.1737-0.0434,0.30397,0.13028,0.47767,0.0869'/%3E %3Cpath d='m495.48,308.18c0.21712-0.0434,0.39082-0.13027,0.60794-0.0868'/%3E %3Cpath d='m495.31,308.61c0.30294,0.0434,0.56349-0.0434,0.86746,0.0869'/%3E %3Cpath d='m495.09,309.22c0.34636,0,0.73718,0,1.0846,0.0868'/%3E %3Cpath d='m494.79,309.83c0.47664-0.13028,0.91089,0.0434,1.3886-0.0868'/%3E %3Cpath d='m494.74,310.26c0.43322,0.1737,0.86746,0.0434,1.3451,0.0868v-0.0868'/%3E %3Cpath d='m494.48,310.95c0.43321-0.0434,0.82403-0.0869,1.2148,0.0868,0.13028,0.0434,0.30398,0,0.47767-0.0868'/%3E %3Cpath d='m494.44,311.56c0.56349-0.21713,1.128,0.13027,1.736,0'/%3E %3Cpath d='m494.18,312.3c0.65137-0.0434,1.2583,0.0869,1.9096,0'/%3E %3Cpath d='m493.96,312.86c0.25951-0.0869,0.56349-0.26055,0.82403-0.13027,0.38979,0.1737,0.86746,0.0868,1.3017,0.13027'/%3E %3Cpath d='m493.83,313.52c0.73718-0.26055,1.5188,0.1737,2.256-0.21712'/%3E %3Cpath d='m493.74,314.21c0.34636-0.0868,0.69376-0.0868,1.0846,0.0434,0.38979,0.0869,0.86746,0.0434,1.3451-0.0434'/%3E %3Cpath d='m493.53,314.86c0.86746-0.1737,1.7794,0,2.6903-0.0434l-0.0434,0.0434'/%3E %3Cpath d='m493.01,315.47c1.128-0.0869,2.2994-0.21712,3.4274-0.21712'/%3E %3Cpath d='m493.14,316.16c1.2583-0.21713,2.56-0.13028,3.8617-0.1737'/%3E %3Cpath d='m492.92,316.86c1.2583,0.1737,1.5188-0.0868,2.7771-0.12924,0.21713,0,1.3017-0.21815,1.5188-0.26054,0.1737-0.0434,0.56349,0,0.73822,0'/%3E %3Cpath d='m492.92,317.2c1.9096-0.1737,3.8607,0.1737,5.8137-0.30397'/%3E %3Cpath d='m484.63,316.99h1.5178'/%3E %3Cpath d='m492.01,317.2c0.1737,0.0869,0.38979-0.0868,0.52007,0.0869'/%3E %3Cpath d='m499.26,317.07c1.5612-0.1737,3.1669,0.30397,4.7292,0'/%3E %3Cpath d='m498.47,316.55c0.99773-0.30294,1.9096-0.0858,2.864,0.0879,0.0869,0,0.0869,0.21609,0.1737,0.25951,0.86746,0.13028,1.6925,0,2.56-0.0434'/%3E %3Cpath d='m492.92,316.47h-0.99773'/%3E %3Cpath d='m486.72,316.25c-0.69376,0.0434-1.3886,0.0434-2.0823,0.13027'/%3E %3Cpath d='m499.78,301.63h0.30398'/%3E %3Cpath d='m499.91,302.06c0.13027,0.0434,0.25951,0,0.38979-0.0434'/%3E %3Cpath d='m499.99,302.76c0.0434-0.0434,0.0434-0.13027,0.0868-0.13027,0.12924-0.0434,0.30294-0.0434,0.43321-0.0434'/%3E %3Cpath d='m500.17,303.19c0.21712-0.13027,0.47767-0.0434,0.73718-0.0434'/%3E %3Cpath d='m500.99,303.58c-0.26055-0.0434-0.47767,0.0434-0.69479,0.13027'/%3E %3Cpath d='m500.6,304.32c0.21609-0.13028,0.43425-0.1737,0.69376-0.13028'/%3E %3Cpath d='m501.6,304.71h-0.99773'/%3E %3Cpath d='m500.9,305.23c0.3474,0,0.69376,0.0868,0.95431-0.13028'/%3E %3Cpath d='m502.12,305.84c-0.39082,0-0.73719,0-1.0846,0.0858'/%3E %3Cpath d='m501.29,306.57c0.38979,0.0434,0.78061-0.0434,1.1714-0.21713'/%3E %3Cpath d='m502.55,306.75c-0.34636,0.1737-0.73718,0.21713-1.128,0.30398'/%3E %3Cpath d='m501.64,307.7c0.47767-0.25951,1.0412-0.0434,1.5188-0.21609'/%3E %3Cpath d='m503.29,308.09c-0.38979,0-0.78061-0.0868-1.1714,0.0434-0.13028,0.0434-0.21713,0.13027-0.39082,0.13027'/%3E %3Cpath d='m502.03,309.22c0.30397-0.13027,0.60691-0.34636,0.95431-0.30294,0.0434-0.21712,0.26055,0,0.34636-0.13027,0.0868-0.0434,0.26055,0,0.43425,0'/%3E %3Cpath d='m503.98,309.44c-0.56349-0.0434-1.1714,0.0868-1.7349,0.17369'/%3E %3Cpath d='m502.42,310.35c0.65034-0.26054,1.3017-0.26054,1.9955-0.34739'/%3E %3Cpath d='m502.47,311.17c0.73821-0.17369,1.5188-0.13027,2.2126-0.43424'/%3E %3Cpath d='m505.2,311.26c-0.82403,0.13028-1.6491,0-2.4297,0.39083'/%3E %3Cpath d='m502.94,312.39c0.13028,0.0434,0.21713,0.13027,0.3474,0.0868,0.78164-0.30397,1.5622-0.56349,2.3429-0.47664'/%3E %3Cpath d='m505.85,312.56c-0.78061,0.43425-1.6925,0.26055-2.56,0.30397-0.0858,0-0.17266,0.0868-0.30294,0.13028'/%3E %3Cpath d='m503.29,313.52c0.95431-0.13027,1.8662-0.1737,2.8205-0.30397'/%3E %3Cpath d='m506.72,313.82c-0.78061,0.13027-1.5188-0.0434-2.256,0.13027-0.34637,0.0434-0.65137,0.1737-0.99774,0.26055'/%3E %3Cpath d='m503.59,314.82c0.13028,0,0.30294,0.0434,0.38979-0.0434,0.95431-0.56452,2.0389-0.39082,3.08-0.43424'/%3E %3Cpath d='m507.37,314.95c-0.86746,0-1.7794-0.21712-2.6468,0.0868-0.30294,0.12924-0.60691,0.30294-0.95431,0.30294'/%3E %3Cpath d='m504.07,315.99c0.47664-0.0868,0.91089-0.30397,1.3451-0.39082,0.99774-0.13028,1.9955-0.0434,2.9942-0.0434'/%3E %3Cpath d='m508.41,316.08c-0.56452-0.13028-1.1714-0.1737-1.6925,0-0.86746,0.21712-1.6491,0.43321-2.5166,0.47664'/%3E %3Cpath d='m504.68,316.99c0.69479-0.0869,1.3451-0.30294,2.0399-0.47767,0.56349-0.12924,1.128-0.0424,1.6925-0.0424'/%3E %3Cpath d='m504.72,317.38c1.0412-0.1737,2.0834,0,3.1235-0.3474,0.3474-0.13027,0.73822,0.0869,1.128,0.0434'/%3E %3Cpath d='m508.97,316.68c1.736,0.12924,3.4709-0.21712,5.1634,0.17266'/%3E %3Cpath d='m509.32,317.2c0.21609,0.0434,0.38979-0.13027,0.52006-0.13027,1.432,0,2.864,0.0434,4.2949,0.13027'/%3E %3Cpath d='m513.62,313.52h0.21712'/%3E %3Cpath d='m513.7,313.99c0.17369,0.0868,0.34636-0.21712,0.52006,0'/%3E %3Cpath d='m513.83,314.51h0.91088'/%3E %3Cpath d='m514.09,315.25c0.30398-0.34636,0.73719,0,1.0412-0.21609'/%3E %3Cpath d='m514.31,315.95c0.39082-0.34739,0.95431,0.0434,1.3451-0.30397'/%3E %3Cpath d='m514.4,316.47c0.56348-0.1737,1.1714,0.0424,1.7349-0.30397'/%3E %3Cpath d='m514.61,316.99c0.86746-0.38979,1.8652,0.1737,2.6903-0.43425'/%3E %3Cpath d='m514.7,317.42c1.0846-0.3474,2.2126,0,3.2972-0.0434'/%3E %3Cpath d='m518.69,317.38c1.9096-0.0868,3.8617-0.13027,5.7703,0'/%3E %3Cpath d='m517.87,316.68c1.6925,0.17266,4.2515,0,6.3783,0.17266'/%3E %3Cpath d='m508.5,303.62c0.12924,0,1.3017-0.21712,1.3886-0.21712'/%3E %3Cpath d='m508.89,303.93c0.34739,0.0434,1.1714,0.0434,1.4754-0.21712'/%3E %3Cpath d='m509.45,304.49c0-0.0434,0.99773-0.21609,1.0412-0.21609,0.13027-0.0434,0.30397,0,0.47664-0.0434'/%3E %3Cpath d='m509.89,304.79c0.17266-0.13027,1.5622-0.0434,1.8218-0.0868'/%3E %3Cpath d='m512.05,305.1c-0.26054,0-1.3886,0.0434-1.5622,0.1737'/%3E %3Cpath d='m511.45,305.88c0.1737-0.12924,0.99774-0.25951,1.3017-0.25951'/%3E %3Cpath d='m513.4,306.1c-0.34739,0-1.0846,0.0868-1.4754,0.0868'/%3E %3Cpath d='m512.66,306.75c0.38979-0.0434,1.0846-0.13027,1.3017-0.30397'/%3E %3Cpath d='m514.66,307.09c-0.39082,0-0.91088,0.0434-1.432,0.0868'/%3E %3Cpath d='m513.88,307.7c0.47664,0,1.1714,0,1.5188-0.13027'/%3E %3Cpath d='m515.92,307.87c-0.30398,0.1737-0.91089,0.21713-1.3017,0.30397'/%3E %3Cpath d='m515.26,308.79c0.39082-0.26055,1.0846-0.0868,1.5622-0.26055'/%3E %3Cpath d='m517.35,309.09c-0.47664,0-0.95431-0.0434-1.3017,0.0434-0.13027,0.0434-0.1737,0.13028-0.39082,0.13028'/%3E %3Cpath d='m518.91,310.26c-0.6948-0.0434-1.2583,0.0868-1.8662,0.1737'/%3E %3Cpath d='m517.65,311.09c0.60691-0.26054,1.3451-0.21712,2.0399-0.34739'/%3E %3Cpath d='m519.17,312.91c0.13028,0.0434,0.78061-0.0869,0.91089-0.13028,1.0422-0.13027,1.2148-0.34739,2.1702-0.26055'/%3E %3Cpath d='m522.82,312.95c-1.2593,0.21712-1.736,0.26055-2.6913,0.3474-0.13027,0-0.43321,0.0868-0.52006,0.13027'/%3E %3Cpath d='m520.17,313.82c0.95534-0.17266,2.3439-0.12924,3.2972-0.25951'/%3E %3Cpath d='m524.51,314.08c-0.78061,0.13027-1.6915,0-2.4297,0.1737-0.3474,0.0434-0.99774,0.0869-1.3451,0.1737'/%3E %3Cpath d='m521.64,315.03c0.13027,0,0.30397,0,0.39082-0.0434,0.78165-0.5211,2.0399-0.43425,3.1669-0.43425'/%3E %3Cpath d='m525.9,315.08c-1.0856,0-1.5199,0.0434-2.3439,0.12924-0.30397,0.0434-0.73719,0.21712-1.128,0.21712'/%3E %3Cpath d='m523.34,315.99c0.99773-0.1737,2.9074-0.39082,1.7794-0.30397,1.0412-0.0869,1.2148-0.0869,2.3429-0.0869'/%3E %3Cpath d='m527.76,316.03c-0.69376-0.0869-1.432-0.0869-1.9086,0.0434-0.43425,0.13027-0.30397,0.26055-1.7794,0.30397'/%3E %3Cpath d='m524.68,316.68c0.69479-0.0868,0.78164-0.0434,1.432-0.21712,0.52109-0.13028,1.2159-0.0869,1.8662-0.0869'/%3E %3Cpath d='m525.03,316.94c1.0846-0.13027,1.2148-0.0869,2.3439-0.0434,0.30294,0,0.56349,0,0.95431-0.0434'/%3E %3Cpath d='m508.15,303.19c0.26054-0.13027,0.43424-0.21712,0.91088-0.17369-0.13027-0.1737,0.21712,0,0.30397-0.0868,0-0.0869,0.25952-0.0434,0.43321-0.0434'/%3E %3Cpath d='m507.63,302.67c0.25952-0.13027,0.52007-0.13027,0.95431-0.0869-0.13027-0.21712,0.25952,0,0.30294-0.13027,0.0434-0.0434,0.30397,0,0.47767,0'/%3E %3Cpath d='m516.26,309.96c0.30397-0.13027,0.26055-0.21712,0.69376-0.13027-0.12924-0.21713,0.47767,0,0.5211-0.13028,0.0434-0.0869,0.52109-0.0434,0.69376-0.0434'/%3E %3Cpath d='m518.09,311.69c0.69377-0.1737,1.5623-0.1737,2.1692-0.47767'/%3E %3Cpath d='m521.3,312c-0.82403,0.12924-2.0389,0.0424-2.6903,0.38979'/%3E %3Cpath d='m508.71,301.93c-0.78061-0.0434-0.91089,0.21713-1.4754,0.21713'/%3E %3Cpath d='m517.26,304.1c0.13027,0,0.99773-0.1737,1.128-0.1737'/%3E %3Cpath d='m517.61,304.45c0.52007-0.12924,0.91089,0,1.2149-0.21609'/%3E %3Cpath d='m518.04,304.88c0-0.0434,0.82403-0.13028,0.86746-0.13028,0.13027-0.0434,0.30397-0.0434,0.43425-0.0434'/%3E %3Cpath d='m518.48,305.27c0.1737-0.13027,1.3027-0.0868,1.5623-0.13027'/%3E %3Cpath d='m520.34,305.53c-0.26055-0.0434-1.3017,0.13027-1.4754,0.21712'/%3E %3Cpath d='m519.43,306.23c0.1737-0.13027,1.3017-0.26055,1.5623-0.21712'/%3E %3Cpath d='m521.6,306.44c-0.3474,0-1.3017,0.0868-1.6491,0.13028'/%3E %3Cpath d='m520.51,307.01c0.3474,0,1.432-0.0868,1.6057-0.26055'/%3E %3Cpath d='m522.73,307.35c-0.3474,0-0.95535,0.0434-1.433,0.0869'/%3E %3Cpath d='m521.73,307.92c0.43425,0,1.3886,0,1.6925-0.1737'/%3E %3Cpath d='m523.9,308.05c-0.26055,0.1737-1.0846,0.26055-1.432,0.3474'/%3E %3Cpath d='m523.25,308.87c0.3474-0.21712,1.0412-0.0869,1.4754-0.21712'/%3E %3Cpath d='m525.2,309.18c-0.39082,0-0.86849-0.0434-1.1714,0.0434-0.13027,0.0434-0.1737,0.13028-0.3474,0.0868'/%3E %3Cpath d='m526.63,310.26c-0.60794-0.0434-1.128,0.0868-1.6925,0.1737'/%3E %3Cpath d='m525.5,311.04c0.56349-0.26055,1.2583-0.26055,1.9086-0.3474'/%3E %3Cpath d='m527.02,312.73c0.1737,0.0434,0.60691-0.13028,0.69376-0.13028,0.99877-0.13027,1.129-0.34739,2.0399-0.30397'/%3E %3Cpath d='m530.23,312.73c-1.129,0.21712-1.5622,0.26055-2.4308,0.30397-0.13027,0-0.43321,0.0868-0.52006,0.13027'/%3E %3Cpath d='m527.8,313.52c0.8685-0.13027,2.1702-0.13027,3.0377-0.21712'/%3E %3Cpath d='m531.8,313.78c-0.6948,0.0868-1.5188,0-2.2136,0.13027-0.30398,0.0869-0.95431,0.0869-1.2583,0.1737'/%3E %3Cpath d='m529.19,314.64c0.13027,0,0.26055,0,0.34739-0.0434,0.6948-0.47767,1.8662-0.39082,2.9508-0.39082'/%3E %3Cpath d='m533.1,314.69c-0.99774,0-1.432,0.0434-2.1702,0.13028-0.47768,0.0434-1.0412,0.21712-1.1714,0.21712'/%3E %3Cpath d='m530.49,315.51c0.91192-0.1737,2.9084-0.3474,1.8662-0.26055,0.95534-0.0868,1.129-0.0868,2.1702-0.0868'/%3E %3Cpath d='m534.79,315.6c-0.65137-0.0868-1.2583-0.13028-1.736,0-0.3474,0.0869-0.47767,0.26055-1.9096,0.30397'/%3E %3Cpath d='m531.67,316.21c0.65033-0.0869,1.0412-0.0869,1.6057-0.21712,0.47664-0.13027,1.128-0.0868,1.736-0.0868'/%3E %3Cpath d='m532.32,316.55c0.91192-0.12924,1.0422-0.21609,2.1268-0.17267,0.30397,0,0.52006-0.0434,0.86745-0.0869'/%3E %3Cpath d='m516.74,303.75c0.25951-0.13028,0.17267-0.21713,0.56349-0.1737,0.30397-0.0868,0.52109,0.0434,0.56452-0.0868,0-0.0434,0.25951-0.0434,0.38979-0.0434'/%3E %3Cpath d='m516.13,303.41c0.26054-0.13028,0.30397-0.26055,0.69479-0.21713,0.38979-0.0434,0.56349,0,0.60691-0.13027,0.0434-0.0434,0.26055,0,0.43425,0'/%3E %3Cpath d='m524.33,309.96c0.26055-0.13027,0.13028-0.1737,0.5211-0.13027-0.0868-0.1737,0.43424,0,0.47767-0.0868,0.0434-0.0869,0.47767-0.0434,0.65033-0.0434'/%3E %3Cpath d='m525.9,311.56c0.65033-0.1737,1.432-0.1737,1.9955-0.39083'/%3E %3Cpath d='m528.85,311.87c-0.73821,0.13027-1.6925-0.0434-2.257,0.25951'/%3E %3Cpath d='m517.3,302.58c-0.73718-0.0434-1.3451,0.30294-1.7783,0.60691'/%3E %3Cpath d='m526.2,306.4c0.0869,0,1.129-0.1737,1.1725-0.1737'/%3E %3Cpath d='m526.55,306.66c0.39082-0.0869,0.95431-0.0434,1.1714-0.21713'/%3E %3Cpath d='m526.94,306.96c-0.0434,0,0.82404-0.13028,0.86746-0.13028,0.0869-0.0434,0.21713,0,0.3474,0'/%3E %3Cpath d='m527.28,307.27c0.12924-0.0869,1.2149-0.0869,1.3886-0.13027'/%3E %3Cpath d='m528.93,307.44c-0.21712-0.0434-1.0422,0.0868-1.1725,0.17266'/%3E %3Cpath d='m528.37,307.96c0.13028-0.0869,0.82404-0.1737,1.0412-0.1737'/%3E %3Cpath d='m529.84,308.14c-0.21713,0-0.99774,0.0868-1.2583,0.0868'/%3E %3Cpath d='m529.06,308.57c0.25951,0,1.0412-0.0869,1.2148-0.21713'/%3E %3Cpath d='m530.75,308.83c-0.30397,0-0.78061,0.0434-1.128,0.0434'/%3E %3Cpath d='m529.97,309.26c0.3474,0,1.0412,0,1.3017-0.13028'/%3E %3Cpath d='m531.67,309.39c-0.21713,0.13028-0.8685,0.1737-1.129,0.21712'/%3E %3Cpath d='m530.93,310c0.26055-0.1737,1.0422-0.0434,1.3451-0.13028'/%3E %3Cpath d='m532.66,310.22c-0.3474,0-0.69376-0.0434-0.95431,0.0434-0.0869,0.0434-0.1737,0.0434-0.30397,0.0434'/%3E %3Cpath d='m533.75,311.09c-0.47664-0.0434-1.0846,0.13028-1.4754,0.1737'/%3E %3Cpath d='m532.75,311.61c0.39082-0.1737,1.0846-0.13027,1.5622-0.21712'/%3E %3Cpath d='m533.83,312.91c0.0869,0.0434,0.65137-0.0434,0.73822-0.0434,0.73718-0.0869,0.86746-0.26055,1.5622-0.21712'/%3E %3Cpath d='m536.53,312.99c-0.8685,0.13027-1.2159,0.17369-1.9097,0.21712-0.0869,0-0.39082,0.0434-0.47767,0.0434'/%3E %3Cpath d='m534.49,313.56c0.69376-0.13028,1.8228-0.0868,2.5166-0.1737'/%3E %3Cpath d='m537.7,313.78c-0.52109,0.0868-1.1714,0-1.6925,0.0868-0.43425,0.0868-1.0422,0.13027-1.0856,0.13027'/%3E %3Cpath d='m535.48,314.47c0.0869,0,0.6948-0.1737,0.73822-0.1737,0.86746-0.0869,1.1714-0.1737,1.9965-0.21712'/%3E %3Cpath d='m538.69,314.47c-0.78061,0-1.0846,0.0434-1.6491,0.0868-0.39082,0.0434-1.0412,0.26055-1.128,0.26055'/%3E %3Cpath d='m536.57,315.16c0.56349-0.12924,2.256-0.30294,1.5622-0.25951,0.73719-0.0434,0.86746-0.0434,1.6481-0.0868'/%3E %3Cpath d='m540,315.16c-0.47664-0.0424-0.95431-0.0858-1.3451,0-0.21712,0.0868-0.47664,0.1737-1.5622,0.26055'/%3E %3Cpath d='m537.52,315.64c0.52007-0.0869,0.86746-0.0434,1.3017-0.1737,0.39082-0.13027,0.91088-0.0434,1.3451-0.0869'/%3E %3Cpath d='m537.96,315.9c0.69376-0.0869,0.95431-0.1737,1.7783-0.13027,0.21713,0,0.39083,0,0.6948-0.0434'/%3E %3Cpath d='m525.98,306.1c0.21712-0.0869,0.30397-0.21713,0.60795-0.1737,0.21712-0.0434,0.39082,0.0434,0.39082-0.0434,0.0434-0.0424,0.21712-0.0424,0.3474-0.0424'/%3E %3Cpath d='m525.63,305.79c0.21712-0.0868,0.26055-0.1737,0.56348-0.1737,0.30398,0,0.43425,0,0.47768-0.0434,0-0.0868,0.21712-0.0434,0.30397-0.0434'/%3E %3Cpath d='m531.8,310.82c0.21712-0.0869,0.26055-0.13028,0.60691-0.0869-0.13027-0.13028,0.30397,0,0.3474-0.0858,0-0.0445,0.3474,0,0.47767,0'/%3E %3Cpath d='m533.18,312.08c0.47664-0.12924,1.0846-0.12924,1.5188-0.34637'/%3E %3Cpath d='m535.44,312.3c-0.56349,0.0869-1.3886-0.0434-1.8662,0.21712'/%3E %3Cpath d='m526.55,305.18c-0.56452-0.0434-0.69376,0.1737-1.0412,0.43425'/%3E %3Cpath d='m534.31,306.75c0.0869,0,0.99773-0.13027,1.0846-0.13027'/%3E %3Cpath d='m534.62,307.05c0.34637-0.0868,0.91089-0.0868,1.0846-0.21713'/%3E %3Cpath d='m534.96,307.31,0.82507-0.13028c0.0869-0.0434,0.21712,0,0.30397,0'/%3E %3Cpath d='m535.35,307.74c0.13027-0.0868,1.0422-0.25952,1.2159-0.25952'/%3E %3Cpath d='m536.83,307.74c-0.21712-0.0434-1.0846,0.13027-1.2148,0.21712'/%3E %3Cpath d='m536.09,308.27c0.0869-0.0869,0.95431-0.21712,1.1714-0.17369'/%3E %3Cpath d='m537.7,308.4c-0.26054,0-0.95534,0.0434-1.3017,0.13027'/%3E %3Cpath d='m536.83,308.79c0.26055,0,1.0856-0.0868,1.2149-0.21712'/%3E %3Cpath d='m538.52,309c-0.25952,0-0.91089,0.0869-1.2583,0.13027'/%3E %3Cpath d='m537.78,309.44c0.30294,0,0.99774,0,1.2149-0.13028'/%3E %3Cpath d='m539.35,309.52c-0.21713,0.13027-0.95535,0.13027-1.2149,0.21712'/%3E %3Cpath d='m538.69,310.13c0.21712-0.1737,0.91191-0.0868,1.2148-0.1737'/%3E %3Cpath d='m540.26,310.31c-0.30397,0-0.60691,0-0.86746,0.0434-0.0434,0.0434-0.26055,0.0434-0.3474,0.0434'/%3E %3Cpath d='m541.26,311.09c-0.43425-0.0434-0.95535,0.13028-1.3462,0.1737'/%3E %3Cpath d='m540.26,311.65c0.39082-0.1737,1.0856-0.1737,1.5622-0.26055'/%3E %3Cpath d='m541.34,312.82c0.0858,0,0.60691-0.0868,0.69376-0.0868,0.69479-0.0869,0.82403-0.21713,1.432-0.1737'/%3E %3Cpath d='m543.81,312.86c-0.78164,0.13028-1.128,0.1737-1.736,0.21713-0.0869,0-0.39082,0-0.43425,0.0434'/%3E %3Cpath d='m541.91,313.47c0.65137-0.0869,1.736-0.1737,2.3429-0.21713'/%3E %3Cpath d='m544.94,313.6c-0.52006,0.0434-1.128,0-1.6057,0.0868-0.39082,0.0858-0.95431,0.0858-0.99773,0.12924'/%3E %3Cpath d='m542.86,314.21c0.0869,0,0.65137-0.13027,0.6948-0.13027,0.78164-0.0868,1.0846-0.1737,1.8662-0.21712'/%3E %3Cpath d='m545.85,314.21c-0.73821,0.0434-0.99876,0.0434-1.5188,0.0869-0.39083,0.0434-0.95535,0.26055-1.0856,0.26055'/%3E %3Cpath d='m543.86,314.86c0.56453-0.0868,2.1258-0.30397,1.4754-0.21712,0.65034-0.0869,0.78061-0.0869,1.5188-0.0869'/%3E %3Cpath d='m547.07,314.86c-0.47767-0.0434-0.95534-0.0868-1.2583,0-0.21712,0.0869-0.43425,0.1737-1.432,0.21713'/%3E %3Cpath d='m544.77,315.29c0.43425-0.0434,0.78164-0.0434,1.2149-0.17266,0.34739-0.0869,0.78164-0.0434,1.2159-0.0434'/%3E %3Cpath d='m545.12,315.55c0.69479-0.0868,0.91088-0.13027,1.6925-0.13027,0.21713,0,0.3474,0,0.60795-0.0434'/%3E %3Cpath d='m534.14,306.49c0.1737-0.0869,0.21713-0.1737,0.5211-0.13028,0.21712-0.0434,0.3474,0,0.39082-0.0434,0-0.0434,0.1737-0.0434,0.30294-0.0434'/%3E %3Cpath d='m533.79,306.23c0.21712-0.0869,0.21712-0.1737,0.52109-0.13027,0.26055-0.0434,0.39082,0,0.43425-0.0869,0-0.0434,0.17266-0.0434,0.30397-0.0434'/%3E %3Cpath d='m539.48,310.87c0.1737-0.0868,0.25951-0.0868,0.52006-0.0868-0.0869-0.12924,0.30397,0,0.3474-0.0434,0.0434-0.0434,0.3474-0.0434,0.43425-0.0434'/%3E %3Cpath d='m540.69,312c0.43321-0.0869,1.0846-0.0869,1.4754-0.26055'/%3E %3Cpath d='m542.86,312.21c-0.56349,0.0868-1.432-0.0434-1.8652,0.1737'/%3E %3Cpath d='m534.66,305.66c-0.5211-0.0434-0.6948,0.1737-0.99877,0.38979'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg fill='%23fc0'%3E %3Cpath d='M491.53,373.25l0.75,5.56c-1.47-0.48-2.82,0.38-3.47,1.6-1.04,2.08-0.12,3.65,1.88,4.65l2.69,1.38,5-9.72-2-1-2,3.9h-0.04l-0.43-5.15-2.38-1.22zm0.75,7.34c0.32,0.03,0.67,0.17,1.03,0.35l0.25,0.12-1.4,2.66-0.25-0.13c-0.91-0.47-1.52-1.04-1-2.12,0.35-0.68,0.83-0.92,1.37-0.88z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='39.783,154.09,42.594,155.98,44.188,153.63,41.251,151.66,42.258,150.15,46.958,153.34,41.083,162.07,36.383,158.92,37.391,157.45,40.328,159.38,40.328,159.38,41.629,157.45,38.775,155.56'/%3E %3Cpath d='M480.84,365.62l-2.65,3.07-0.85-0.69c-1.73-1.52-3.48-1.45-5,0.28-1.6,1.91-1.01,3.58,0.82,5.1l2.28,1.96,7.06-8.28-1.66-1.44zm-5.53,3.54c0.38,0.03,0.8,0.29,1.25,0.68l0.35,0.25-1.97,2.29-0.32-0.26c-0.82-0.69-1.29-1.34-0.46-2.34,0.41-0.48,0.77-0.66,1.15-0.62z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' d='m451.31,368.27-1.4754-1.6491,4.512-4.1212c0.99774-0.86849,2.3429-2.257,1.0846-3.6446-1.2583-1.3886-2.7771-0.21712-3.7738,0.6948l-4.5131,4.0778-1.4754-1.6057,4.816-4.3818c1.9965-1.7794,4.2525-2.257,6.2914-0.0434,2.0389,2.256,1.3451,4.512-0.65034,6.2914l-4.816,4.3818z'/%3E %3Cpath d='M463.44,347.66c-0.62-0.05-1.27,0.1-1.94,0.56-0.95,0.69-1.69,1.93-1.12,3.19-0.79-0.35-1.67-0.11-2.32,0.37-1.78,1.22-1.74,2.73-0.53,4.47l1.56,2.25,9-6.16-1.97-2.84c-0.73-1.06-1.65-1.76-2.68-1.84zm-0.03,2.34c0.65-0.06,1.13,0.47,1.59,1.12l0.28,0.35-2.31,1.56-0.19-0.25c-0.56-0.82-1.15-1.79-0.06-2.53,0.26-0.17,0.47-0.23,0.69-0.25zm-3.19,3.16c0.4-0.01,0.74,0.26,1.06,0.75l0.16,0.21-2.13,1.47-0.15-0.21c-0.48-0.7-0.62-1.35,0.25-1.91,0.31-0.23,0.57-0.31,0.81-0.31z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='16.87,122.62,18.422,121.78,20.898,126.31,11.625,131.35,10.575,129.46,18.296,125.31,18.296,125.31'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='16.702,117.84,16.702,117.84,17.542,119.81,7.889,124.05,7.05,122.08'/%3E %3Cpath fill-rule='evenodd' d='m431.09,327.83c-0.52006,0.78165-0.60691,1.8228-0.34636,2.7337,0.69376,1.9965,2.8205,2.561,4.6423,1.9965,1.736-0.56452,3.08-2.3429,2.4297-4.2949-0.25951-0.91088-1.0412-1.6491-1.8652-2.0399l2.3863-0.78061c0.65034,0.69376,1.1714,1.3886,1.432,2.256,0.99773,3.0377-0.78061,6.0743-3.6446,7.0296-2.9508,0.9543-6.248-0.3474-7.2891-3.5143-0.26055-0.86746-0.30397-1.736-0.17266-2.6034l2.4276-0.78268z'/%3E %3Cpath d='M452.44,313.25l-10.25,6.22,0.31,1.69,11.78,2.37-0.44-2.28-2.4-0.53-0.72-3.88,2.16-1.28-0.44-2.31zm-3.32,4.53l0.47,2.63-4.12-0.5v-0.07l3.65-2.06z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M446.69,292.88c-2.82,0.01-5.04,1.97-5.28,5.06l-0.25,3.12,10.84,0.88,0.25-3.13c0.26-3.21-1.92-5.64-5-5.9-0.19-0.02-0.37-0.04-0.56-0.03zm-0.41,2.5c0.24-0.02,0.49-0.03,0.75,0,1.95,0.13,3.22,1.21,3,3.68v0.32l-6.53-0.54,0.03-0.31c0.15-2.01,1.09-3.04,2.75-3.15z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='8.183,68.444,7.512,71.76,10.323,72.347,11.037,68.906,12.757,69.242,11.625,74.823,1.301,72.641,2.434,67.102,4.196,67.479,3.483,70.92,3.483,70.92,5.749,71.382,6.462,68.067'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='12.589,55.393,11.331,58.583,13.974,59.59,15.275,56.316,16.954,56.946,14.897,62.233,5.036,58.415,7.134,53.127,8.813,53.757,7.512,57.072,7.512,57.072,9.652,57.911,10.911,54.722'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='18.926,48.973,20.521,49.77,18.171,54.386,8.771,49.56,9.736,47.672,17.542,51.659,17.542,51.659'/%3E %3Cpath fill-rule='evenodd' d='m446.19,249.87c-0.6948,0.0434-1.3017,0.25952-1.736,0.82404-0.43424,0.60691-0.43424,1.432,0.13028,1.8662,1.4744,1.0846,3.5577-2.9942,6.5075-0.78164,1.736,1.3017,2.1257,3.3406,0.73719,5.2068-0.91089,1.2583-2.2994,1.6491-3.7748,1.5178l-0.21712-1.952c0.86746,0.25951,1.9096,0.0858,2.4731-0.6948,0.56349-0.69376,0.30397-1.6057-0.38979-2.0823-0.91088-0.69376-1.7794,0-2.6034,0.52006-1.3017,0.82403-2.5166,1.2583-3.8617,0.26055-1.4754-1.0846-1.8228-3.08-0.69376-4.5989,0.60691-0.82404,1.8228-1.6491,2.8205-1.7794l0.60795,1.6936z'/%3E %3Cpath d='M467.19,240.31l-1.22,1.22,4.97,10.97,1.62-1.69-1-2.25,2.72-2.81,2.28,0.94,1.63-1.69-11-4.69zm1.72,3.1l3.47,1.59-1.69,1.78-1.81-3.34,0.03-0.03z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='40.328,24.549,41.461,25.934,37.432,29.208,30.802,20.982,32.481,19.64,37.978,26.438,37.978,26.438'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='42.888,12.337,44.86,11.121,47.042,22.535,45.993,23.207,36.635,16.324,38.565,15.065,44.608,19.682,44.608,19.682,44.65,19.64'/%3E %3Cpath d='M495.25,221l-1.56,0.75,0.56,12.03,2.13-0.97-0.1-2.53,3.56-1.59,1.75,1.75,2.16-0.97-8.5-8.47zm0.44,3.56l2.69,2.78-2.26,1-0.43-3.72v-0.06z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M507.41,217.22c-0.56,0-1.16,0.1-1.75,0.28l-3,0.88,3.06,10.43,2.97-0.84c3.12-0.91,4.65-3.83,3.78-6.78-0.71-2.44-2.65-3.99-5.06-3.97zm-0.07,2.28c1.36,0.05,2.27,0.84,2.72,2.41,0.57,1.86-0.02,3.4-2.4,4.09l-0.32,0.12-1.81-6.28,0.31-0.12c0.56-0.15,1.05-0.24,1.5-0.22z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M520.5,214.06c-0.2,0.01-0.42,0.04-0.62,0.06-3.26,0.44-5.19,3.37-4.76,6.41,0.39,3.08,3.03,5.37,6.29,4.94,3.29-0.44,5.2-3.33,4.81-6.41-0.37-2.85-2.71-5.09-5.72-5zm-0.25,2.44c1.73-0.22,3.19,1.21,3.41,2.81,0.17,1.48-0.87,3.52-2.57,3.78-1.69,0.22-3.25-1.52-3.47-3-0.17-1.6,0.85-3.37,2.63-3.59z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M529.53,213.56l-0.12,10.91h2.21l0.04-4.38h0.03l2.69,4.44,2.68,0.03-3.15-4.62c1.52-0.22,2.34-1.61,2.34-3,0.04-2.35-1.51-3.3-3.72-3.35l-3-0.03zm2.25,1.94h0.31c1.04,0,1.86,0.25,1.82,1.47,0,1.21-0.78,1.53-1.91,1.53h-0.25l0.03-3z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='110.2,9.064,106.88,8.225,106.21,10.995,109.65,11.876,109.19,13.597,103.69,12.212,106.26,1.972,111.75,3.357,111.33,5.12,107.89,4.238,107.89,4.238,107.35,6.504,110.62,7.302'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='119.98,13.849,122.62,7.26,124.59,8.057,120.61,18.045,119.18,17.457,116.54,8.477,116.49,8.477,113.85,15.107,111.88,14.352,115.91,4.28,115.91,4.28,117.33,4.826,119.94,13.849'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='132.52,22.661,131.56,24.172,127.19,21.444,132.82,12.505,134.62,13.639,129.96,21.066,129.96,21.066'/%3E %3Cpath d='M588.72,233.25l-10.5,5.91,1.81,1.46,2.16-1.21,3.03,2.53-0.75,2.34,1.84,1.47,3.75-11.41-1.34-1.09zm-1.63,3.16l-1.25,3.62-1.9-1.53,3.15-2.09z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M605.06,250.31l-11.62,2.97,1.34,1.88,2.44-0.57,2.28,3.16-1.34,2.09,1.4,1.91,6.53-10.06-1.03-1.38zm-2.34,2.63l-2.16,3.18-1.44-2,3.6-1.18z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='159.26,58.289,158.29,56.358,163.75,52.624,163.75,52.624,163.75,52.624,156.65,53.379,156.32,52.75,161.19,47.588,161.19,47.546,154.89,49.645,153.93,47.714,164.42,44.482,165.13,45.826,160.14,51.365,167.48,50.567,168.19,51.952'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='166.1,64.206,165,60.975,162.32,61.898,163.45,65.255,161.73,65.843,159.93,60.429,169.92,57.072,171.76,62.443,170.04,63.031,168.91,59.674,168.91,59.674,166.73,60.429,167.82,63.619'/%3E %3Cpath d='M619.81,282.16l-10.62,2.25,0.43,2.15,4.29-0.9h0.06l-3.75,3.65,0.59,2.6,3.81-4.07c0.57,1.44,2.07,1.9,3.41,1.6,2.3-0.48,2.92-2.16,2.44-4.38l-0.66-2.9zm-1.34,2.62l0.06,0.28c0.22,1.04,0.15,1.91-1.06,2.13-1.17,0.26-1.63-0.45-1.85-1.53l-0.06-0.25,2.91-0.63z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='164.5,80.027,164.5,80.027,164.25,77.928,174.74,76.711,174.99,78.81'/%3E %3Cpath fill-rule='evenodd' d='m603.56,306.83c0.73822-0.60794,1.128-1.5622,1.128-2.5166-0.0434-2.1268-1.952-3.2982-3.8172-3.2538-1.8228,0-3.6446,1.3017-3.6012,3.383,0,0.91192,0.47767,1.8662,1.1714,2.4742l-2.5166,0.0434c-0.39082-0.82507-0.69376-1.6491-0.69376-2.56-0.0445-3.2103,2.56-5.5976,5.5532-5.6411,3.1235-0.0434,5.8572,2.1692,5.944,5.5108,0,0.86746-0.21713,1.7783-0.60795,2.5166l-2.56,0.0434z'/%3E %3Cpath d='M611.66,308.88l-0.25,2.31,2.15,1.19-0.47,3.9-2.43,0.56-0.25,2.35,11.62-2.85,0.22-1.75-10.59-5.71zm3.65,4.46l3.41,1.57v0.03l-3.72,0.84,0.31-2.44z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' d='m595.92,340.16c0.91088-0.34739,1.6491-1.0412,1.9965-1.9096,0.78061-1.9955-0.5211-3.8172-2.257-4.512-1.6925-0.65034-3.8607-0.17267-4.6423,1.736-0.3474,0.91192-0.25952,1.9531,0.1737,2.7771l-2.3863-0.91089c-0.0434-0.91088,0-1.7794,0.34636-2.6468,1.1725-2.9508,4.512-4.2081,7.2902-3.08,2.9074,1.128,4.5989,4.2515,3.383,7.3326-0.34636,0.82507-0.86746,1.5623-1.5188,2.1268l-2.3852-0.91296z'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='158.33,129.17,159.93,126.19,157.41,124.8,155.73,127.95,154.18,127.07,156.86,122.08,166.14,127.11,163.45,132.1,161.86,131.22,163.58,128.12,163.58,128.12,161.52,127.03,159.89,130.01'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='151.24,137.48,156.99,141.63,155.73,143.39,147.04,137.02,147.93,135.8,157.28,135.46,157.32,135.46,151.53,131.22,152.79,129.5,161.52,135.88,161.52,135.88,160.64,137.14,151.28,137.43'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='150.57,146.37,152.12,144.78,153.38,146,148.85,150.74,147.59,149.52,149.1,147.92,142.76,141.84,142.76,141.84,144.23,140.29'/%3E %3Cpath d='M585.53,363.41l-1.72,1.37,2.81,3.41v0.03l-4.93-1.6-2.07,1.69,5.41,1.47c-1,1.17-0.75,2.73,0.16,3.81,1.47,1.78,3.31,1.53,5,0.1l2.28-1.91-6.94-8.37zm2.09,6.12l1.91,2.31-0.22,0.16c-0.82,0.69-1.56,1.01-2.34,0.09-0.78-0.95-0.37-1.68,0.5-2.37l0.15-0.19z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M578.72,369.06l-2,1.25,0.44,2.44-3.35,2.06-1.93-1.47-2,1.25,9.59,7.22,1.44-0.9-2.19-11.85zm-1.25,5.72l0.97,3.63h-0.06l-3-2.32,2.09-1.31z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='118.72,160.39,117.96,158.79,122.62,156.57,127.15,166.14,125.22,167.02,121.49,159.13,121.49,159.13'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' width='675' height='450'%3E %3Cdefs%3E %3Cmarker markerWidth='691.235' markerHeight='1592.9' orient='auto'%3E %3Cg transform='translate(139.04186,-931.37552)'%3E %3Cg transform='matrix(0.3358457,0,0,0.3358462,22.073663,254.82087)'%3E %3Cpath d='m-1508.834 4385.729 0 0 0 0 0 0' fill='%23000'/%3E %3Cg transform='matrix(2.9999964,0,0,2.9994449,-746.32978,-2781.9855)'%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342' fill='%23ff0'/%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342-0.012 0z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m375.446 838.791c-11.615-1.163-24.989-3.92-35.313 1.894-6.921-4.079-16.558-3.83-24.763-3.031-4.456 0.797-9.697 0.797-14.354 1.558l-0.73 0.103c-8.449 0.561-16.113-1.936-23.455-5.217 2.331 13.234 4.919 26.797 6.191 40.652 2.77 20.52-9.709 37.748-4.59 58.019 3.056 9.727 13.751 15.382 23.54 16.503 9.478 0.559 19.285 2.112 28.057 4.017 1.668 0.347 3.646 1.121 4.797 1.619 2.417 1.011 4.188 2.496 5.74 4.085 5.296-5.516 13.057-7.05 20.715-7.859 13.8-1.613 30.814-0.736 39.263-13.239l0-0.707c4.59-6.915 3.981-17.464 1.991-25.299-0.134-2.733-0.864-5.144-1.26-7.749-8.431-22.268-1.211-47.311 2.417-69.756-4.432 2.423-9.375 3.567-14.305 4.779-3.932 0.524-8.315 0.286-12.296 0.072l-1.65-0.444M392.795 902.697 392.795 902.697' fill='%23dc171d'/%3E %3Cpath d='m392.795 902.697c-0.055 1.466 0.737 2.618 1.023 3.974 1.613 9.734 3.172 22.627-6.848 28.666-11.085 7.049-25.622 4.03-38.448 7.761-2.563 0.712-6.093 3.069-7.895 4.736-1.157-0.761-2.319-1.93-3.811-2.617-10.555-5.613-24.276-3.732-36.189-6.764-5.984-1.893-12.223-6.555-13.739-12.68-3.896-16.07 5.436-29.767 4.334-45.709-0.712-12.175-2.758-23.862-5.57-35.276 9.314 4.34 20.094 5.064 30.565 2.983 7.755-1.084 16.783-1.108 24.051 2.173 4.005-1.723 8.693-2.496 13.009-2.971 8.206 0.798 17.026 2.283 25.476 2.222 5.643-0.293 10.769-1.924 15.675-4.097-2.91 18.865-8.498 38.625-1.637 57.599' fill='%2362afe1'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049' fill='%23fff'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049 0.006-0.013z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074' fill='%23fff'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074-0.006 0z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809' fill='%23fff'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M311.937 914.432l0.03 7.609 4.797 0-0.024-7.609-4.803 0M370.862 924.836l-0.061-13.087-10.446-0.012 0.049 13.099 10.458 0M363.18 914.481l0.055 7.585 4.791 0-0.043-7.585-4.803 0M370.783 903.506l-0.061-13.101-10.458 0 0.037 13.101 10.489 0-0.006 0zM363.101 893.163l0.03 7.597 4.791 0-0.006-7.597-4.815 0M319.534 903.458l-0.073-13.076-10.464-0.013 0.049 13.082 10.489 0 0 0.007zM311.851 893.115l0.024 7.585 4.803 0.012-0.036-7.597-4.791 0M338.502 903.481l-0.049-13.076-10.47-0.012 0.043 13.087 10.476 0M330.826 893.127l0.024 7.585 4.797 0.024-0.03-7.609-4.791 0M353.124 903.506l-0.073-13.101-10.464-0.012 0.049 13.087 10.489 0.025M345.435 893.14l0.037 7.609 4.797 0-0.024-7.609-4.809 0' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024' fill='%23fff'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024 0.006 0zM325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M329.018 929.675l-0.103-21.342M352.143 929.687l-0.103-21.329M366.79 886.626l-17.081-12.474-19.193-0.024-16.947 12.449 53.222 0.049M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m331.994 863.799 0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m336.371 865.686 0.024 3.792 7.414 0-0.024-3.792-7.414 0M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742' fill='%23fff'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186c0 0 1.065 1.37 0.018 2.94l0.578 1.09-2.131 0 0.578-1.035c0 0-1.09-1.82 0.049-2.995l-0.657-1.186M331.313 900.335l2.21 0-0.639 1.186c0 0 1.065 1.334 0.006 2.94l0.572 1.09-2.124 0 0.572-1.035c0 0-1.065-1.82 0.055-2.995l-0.651-1.186M336.225 900.335l2.204 0-0.657 1.186c0 0 1.077 1.37 0.018 2.94l0.578 1.114-2.112-0.024 0.566-1.035c0 0-1.077-1.808 0.043-2.995l-0.645-1.186 0.006 0zM341.771 900.346l2.222 0-0.651 1.199c0 0 1.065 1.346 0.006 2.922l0.597 1.108-2.143 0 0.572-1.035c0 0-1.065-1.832 0.073-2.995l-0.67-1.199-0.006 0zM346.701 900.346l2.204 0-0.651 1.199c0 0 1.071 1.346 0.012 2.916l0.584 1.114-2.124 0 0.554-1.035c0 0-1.071-1.82 0.085-2.995l-0.664-1.199M351.602 900.359l2.204-0.012-0.651 1.199c0 0 1.09 1.346 0.03 2.922l0.554 1.108-2.131 0 0.572-1.035c0 0-1.065-1.82 0.073-2.995l-0.651-1.187' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' fill='%23f9d90f'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407' fill='%23f9d90f'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407l0 0.012z' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' fill='%237e7e7e'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198' fill='%23f9d90f'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198zM294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406' fill='%23ff0'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406l0 0.012z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' fill='%237e7e7e'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101' fill='%23f9d90f'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101l0 0.005zM387.036 978.575 372.615 975.416' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m333.072 977.041c-0.323 0.207-0.761 0.262-1.266 0.237l-2.277-0.116 0.195-2.842 2.258 0.121c0.444 0.03 0.797 0.116 1.017 0.25 0.457 0.237 0.657 0.676 0.615 1.284-0.03 0.524-0.213 0.865-0.548 1.065m-3.823 4.475 0.225-3.464 2.654 0.183c0.858 0.067 1.497-0.158 1.93-0.597 0.45-0.426 0.682-0.986 0.712-1.619 0.055-0.737-0.134-1.34-0.572-1.784-0.42-0.426-1.017-0.651-1.765-0.724l-3.792-0.237-0.524 8.156 1.126 0.074M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03c0.402 0.037 0.718 0.085 0.95 0.195 0.426 0.201 0.627 0.603 0.627 1.187 0 0.548-0.158 0.914-0.469 1.133-0.298 0.2-0.73 0.292-1.248 0.292l-2.666-0.03 0.024-2.806m-0.043 7.226 0.024-3.482 2.605 0.037c0.463 0 0.804 0.036 1.041 0.152 0.384 0.177 0.572 0.548 0.59 1.059l0.067 1.37c0.018 0.329 0.024 0.53 0.043 0.664 0.037 0.097 0.055 0.201 0.103 0.275l1.4 0-0.024-0.177c-0.158-0.085-0.286-0.249-0.341-0.499-0.049-0.158-0.073-0.396-0.085-0.694l-0.024-1.09c-0.018-0.493-0.103-0.833-0.292-1.023-0.164-0.219-0.39-0.408-0.737-0.524 0.39-0.206 0.682-0.444 0.895-0.737 0.201-0.323 0.304-0.73 0.304-1.229 0-0.937-0.383-1.577-1.163-1.924-0.42-0.189-0.956-0.287-1.589-0.298l-3.914-0.037-0.03 8.181 1.126 0M346.135 980.206c-0.499-0.608-0.767-1.369-0.828-2.27-0.055-1.133 0.164-1.997 0.682-2.582 0.524-0.633 1.199-0.937 2.082-0.986 0.889-0.049 1.619 0.237 2.161 0.797 0.554 0.548 0.87 1.309 0.925 2.259 0.03 0.913-0.128 1.722-0.548 2.434-0.414 0.725-1.102 1.133-2.118 1.157-1.059 0.055-1.851-0.194-2.356-0.81m-1.339-5.15c-0.524 0.81-0.737 1.747-0.682 2.88 0.079 1.223 0.457 2.234 1.169 2.995 0.791 0.761 1.838 1.144 3.129 1.071 1.382-0.061 2.423-0.584 3.129-1.546 0.572-0.87 0.846-1.882 0.785-3.129-0.079-1.114-0.402-2.021-1.004-2.697-0.761-0.907-1.875-1.308-3.385-1.247-1.424 0.091-2.471 0.614-3.147 1.673M383.238 963.29c0.785-0.134 1.467-0.097 2.088 0.116 0.913 0.286 1.528 0.962 1.911 1.997l-1.126 0.158c-0.243-0.559-0.59-0.943-1.059-1.157-0.457-0.2-1.029-0.25-1.686-0.152-0.767 0.116-1.382 0.499-1.814 1.114-0.426 0.657-0.554 1.534-0.365 2.653 0.158 0.926 0.499 1.711 1.059 2.234 0.517 0.536 1.278 0.724 2.271 0.584 0.743-0.122 1.339-0.419 1.759-0.931 0.438-0.486 0.566-1.224 0.42-2.173l-2.624 0.402-0.134-0.901 3.652-0.561 0.712 4.328-0.724 0.11-0.45-0.998c-0.304 0.451-0.609 0.798-0.877 0.998-0.45 0.354-1.059 0.579-1.82 0.688-0.986 0.152-1.887-0.025-2.703-0.548-0.895-0.664-1.473-1.65-1.692-3.019-0.237-1.345-0.024-2.496 0.597-3.403 0.59-0.876 1.449-1.387 2.605-1.552M391.498 962.656l2.618-0.95c0.359-0.133 0.67-0.177 0.937-0.145 0.481 0.036 0.834 0.322 1.035 0.894 0.189 0.487 0.189 0.913-0.024 1.212-0.225 0.31-0.578 0.536-1.09 0.724l-2.459 0.883-1.017-2.618m2.618 6.764-1.278-3.281 2.435-0.877c0.457-0.146 0.773-0.225 1.011-0.2 0.432 0.054 0.761 0.317 0.98 0.815l0.554 1.249c0.122 0.31 0.219 0.499 0.298 0.584 0.037 0.11 0.116 0.177 0.177 0.249l1.321-0.486-0.073-0.177c-0.195 0-0.383-0.11-0.524-0.323-0.103-0.152-0.201-0.371-0.341-0.626l-0.432-1.023c-0.195-0.444-0.396-0.718-0.627-0.883-0.231-0.128-0.524-0.213-0.87-0.237 0.268-0.311 0.463-0.622 0.536-0.987 0.079-0.371 0.043-0.785-0.134-1.247-0.335-0.87-0.95-1.345-1.814-1.406-0.457-0.036-0.98 0.061-1.583 0.273l-3.677 1.309 2.971 7.694 1.077-0.396M403.691 965.366l-4.669-6.812 5.126-3.269 0.566 0.822-4.2 2.684 1.437 2.082 3.878-2.496 0.53 0.797-3.878 2.496 1.583 2.295 4.273-2.734 0.566 0.804-5.217 3.33M407.776 953.325l1.339-1.473c0.621-0.657 1.278-0.956 1.997-0.87 0.718 0.061 1.449 0.438 2.228 1.12 0.213 0.164 0.402 0.377 0.597 0.615 0.341 0.444 0.542 0.835 0.67 1.224 0.11 0.488 0.085 0.932-0.085 1.358-0.103 0.212-0.286 0.462-0.56 0.761l-1.345 1.461-4.839-4.206m7.074 3.207c0.95-1.046 1.157-2.173 0.603-3.445-0.323-0.688-0.816-1.358-1.497-1.942-0.858-0.761-1.753-1.151-2.697-1.223-1.047-0.08-1.936 0.298-2.709 1.144l-2.283 2.447 6.294 5.491 2.283-2.459M419.725 950.171l-7.244-4.255 0.59-0.937 7.256 4.231-0.597 0.973M422.568 945.229l-7.822-3.13 2.307-5.503 0.95 0.365-1.881 4.535 2.356 0.926 1.759-4.177 0.901 0.372-1.741 4.17 2.636 1.071 1.93-4.589 0.95 0.359-2.35 5.601M426.16 935.623l-8.23-1.82 0.274-1.272 7.603-2.569-6.678-1.473 0.244-0.998 8.23 1.771-0.262 1.236-7.615 2.624 6.678 1.443-0.237 1.059M425.508 925.171l0.103-1.035c0.475 0.013 0.877-0.061 1.181-0.225 0.597-0.323 0.944-0.937 1.035-1.845 0.037-0.425 0.018-0.797-0.079-1.151-0.177-0.681-0.56-1.059-1.175-1.12-0.457-0.049-0.785 0.061-1.023 0.311-0.213 0.286-0.438 0.699-0.609 1.284l-0.377 1.077c-0.243 0.706-0.469 1.193-0.712 1.466-0.39 0.512-0.937 0.688-1.637 0.64-0.749-0.079-1.357-0.377-1.79-0.95-0.444-0.524-0.627-1.272-0.517-2.198 0.073-0.846 0.353-1.558 0.852-2.13 0.463-0.524 1.181-0.774 2.1-0.676l-0.085 1.035c-0.45 0-0.81 0.079-1.071 0.262-0.475 0.262-0.737 0.816-0.816 1.625-0.067 0.67 0.024 1.12 0.28 1.462 0.256 0.286 0.578 0.468 0.956 0.499 0.402 0.037 0.718-0.091 0.937-0.401 0.158-0.214 0.347-0.676 0.603-1.425l0.371-1.132c0.183-0.524 0.402-0.925 0.657-1.211 0.457-0.475 1.053-0.676 1.802-0.62 0.913 0.097 1.564 0.475 1.899 1.169 0.329 0.7 0.457 1.473 0.377 2.35-0.103 0.992-0.426 1.771-1.023 2.295-0.597 0.535-1.339 0.718-2.24 0.645M254.898 924.672l0.189 1.022c-0.457 0.091-0.822 0.275-1.09 0.512-0.481 0.45-0.645 1.126-0.481 2.045 0.073 0.389 0.213 0.772 0.39 1.077 0.365 0.621 0.84 0.87 1.443 0.772 0.444-0.079 0.737-0.249 0.877-0.566 0.134-0.311 0.231-0.786 0.262-1.394l0.055-1.151c0.037-0.712 0.116-1.272 0.274-1.583 0.25-0.56 0.718-0.907 1.418-1.022 0.749-0.135 1.406 0.036 1.972 0.462 0.572 0.396 0.95 1.084 1.09 1.997 0.177 0.835 0.097 1.583-0.231 2.258-0.317 0.658-0.925 1.059-1.857 1.23l-0.183-1.034c0.432-0.158 0.755-0.311 0.968-0.524 0.365-0.408 0.475-0.998 0.335-1.808-0.11-0.658-0.335-1.084-0.676-1.297-0.335-0.25-0.67-0.348-1.035-0.286-0.408 0.061-0.676 0.286-0.804 0.651-0.079 0.243-0.14 0.748-0.195 1.522l-0.055 1.193c-0.03 0.56-0.116 1.023-0.304 1.34-0.298 0.584-0.804 0.943-1.54 1.059-0.931 0.158-1.65-0.055-2.161-0.651-0.524-0.584-0.846-1.284-1.01-2.155-0.183-1.035-0.049-1.838 0.365-2.483 0.42-0.664 1.084-1.047 1.984-1.175M254.381 935.465l8.047-2.423 1.875 5.667-0.98 0.31-1.534-4.657-2.447 0.737 1.418 4.303-0.937 0.298-1.406-4.315-2.727 0.815 1.558 4.76-0.962 0.275-1.905-5.771M257.948 945.289l7.402-3.926 0.791 1.381-5.089 5.381 7.433-1.272 0.767 1.37-7.384 3.902-0.524-0.908 4.359-2.294c0.158-0.092 0.402-0.226 0.755-0.414 0.347-0.158 0.737-0.372 1.126-0.573l-7.402 1.26-0.542-0.962 5.053-5.363-0.243 0.122c-0.158 0.091-0.432 0.225-0.804 0.438-0.365 0.226-0.639 0.365-0.816 0.438l-4.346 2.331-0.536-0.925M271.742 956.192c-0.371-0.085-0.737-0.298-1.096-0.67l-1.564-1.613 2.106-1.93 1.577 1.608c0.304 0.298 0.499 0.59 0.603 0.84 0.146 0.48 0 0.919-0.444 1.333-0.402 0.371-0.804 0.524-1.181 0.432m-5.947 0.749 2.581-2.368 1.832 1.857c0.59 0.603 1.193 0.877 1.826 0.865 0.645-0.037 1.199-0.275 1.686-0.737 0.548-0.487 0.81-1.059 0.81-1.673-0.006-0.597-0.28-1.157-0.785-1.68l-2.63-2.685-6.124 5.625 0.791 0.797M273.178 963.515l4.438-6.958 5.247 3.19-0.548 0.828-4.31-2.581-1.333 2.106 3.963 2.404-0.511 0.798-3.969-2.392-1.51 2.355 4.365 2.624-0.524 0.822-5.308-3.196M286.315 962.169l2.666 0.847c0.377 0.115 0.651 0.261 0.834 0.426 0.341 0.323 0.432 0.785 0.231 1.345-0.164 0.487-0.414 0.804-0.804 0.938-0.347 0.06-0.785 0.06-1.297-0.098l-2.514-0.803 0.883-2.655m-2.301 6.836 1.108-3.318 2.484 0.81c0.444 0.116 0.767 0.275 0.925 0.438 0.304 0.274 0.396 0.682 0.244 1.188l-0.371 1.32c-0.085 0.323-0.128 0.536-0.164 0.633 0 0.104 0 0.214 0.018 0.286l1.309 0.426 0.079-0.189c-0.14-0.11-0.219-0.31-0.213-0.559 0.03-0.153 0.073-0.396 0.158-0.676l0.317-1.059c0.128-0.463 0.177-0.81 0.061-1.059-0.097-0.262-0.262-0.5-0.536-0.724 0.414-0.074 0.773-0.201 1.077-0.427 0.286-0.25 0.53-0.597 0.676-1.083 0.298-0.883 0.134-1.62-0.524-2.18-0.329-0.292-0.797-0.542-1.412-0.773l-3.725-1.15-2.605 7.761 1.09 0.335M295.318 827.761 295.318 827.761' fill='%23012a87'/%3E %3Cpath d='m295.318 827.761c0.962-2.32 9.874-8.645 39.117-5.875 0 0 4.943 3.019 7.847 2.63 1.656-0.214-0.974 0.103-3.135-1.693-2.204-1.795-2.672-5.478 2.362-5.381 5.01 0.128 23.765 1.187 24.118 2.873 0.329 1.704-9.916 2.417-13.727 2.319-3.829-0.103-3.385 1.833 0.426 1.687 11.907-0.426 24.903-4.621 38.63 5.089 1.637 1.18-4.139 1.369-8.608-0.53 0 0-12.108 0.628-17.343-0.231 0 0-4.024 3.274-9.265 2.952 0.682 1.698-1.936 8.035-18.414 3.268-2.721 0.835-12.637 2.496-11.554-0.45-2.611 0-7.189 0.84-7.871-0.646-0.657-1.46 8.06-3.671 9.588-5.253 0 0-18.439 0.177-21.933-1.096 0 0-10.878 2.441-10.239 0.323' fill='%23bc715f'/%3E %3Cpath d='m301.229 853.583c0.396-0.535 0.554-1.497 1.394-1.473 1.826 0.486 3.068 3.828 5.314 1.661 0.797-0.177 1.102 0.908 1.759 1.035 0.42 1.857 1.911-0.377 3.025-0.25 2.38-1.059 5.326-1.309 8.145-0.785 0.085 1.82-1.339 3.829-3.129 4.864 0.037 1.833 1.698 3.008 1.668 4.852-0.286 0.688-0.049 1.771-1.09 1.997-1.321-0.237-2.624-0.377-3.719-1.114-0.134-0.134-0.243-0.396-0.524-0.31-0.134 0.615 0.828 1.224 1.205 1.851-0.664 1.132-1.765 0.097-2.691 0.11-0.274 0.651-0.012 1.473-0.682 1.893-1.169-0.036-1.406-1.308-2.124-1.942-0.737 0.797 0.517 1.272 0.694 1.905-0.45 2.398-0.39 4.742-2.788 6.313l-1.607 0.798c-0.438-1.205-0.164-3.032-0.457-4.292-0.95 1.546-1.692 2.898-3.086 4.206-1.631-0.536-2.581-2.459-2.94-4.054-0.682-1.857-0.292-4.079 1.175-5.424-0.499-0.974-2.21-0.749-2.453-2.136-2.563-1.669-3.981 2.922-5.637 0.535-0.536-2.227 0.103-4.998 1.717-6.66-0.359-0.912-1.552-0.675-2.258-1.199-1.613-1.37-3.939-2.818-3.823-5.291 4.413-1.667 9.691-0.444 12.899 2.91' fill='%23008830'/%3E %3Cpath d='m303.518 853.334c-0.103 2.02 1.364 0.547 2.453 1.771-0.852-0.335-1.473 1.473-2.307 0.438l-0.524 0.5c0.304 0.693 0.895 0.785 0.28 1.546-0.913 0.347-1.096-0.797-1.522-1.248-0.073-0.2 0.14-0.578-0.195-0.712-0.517 0.438-1.059 0.597-1.771 0.524-0.195-0.39-0.572-0.901-0.189-1.199 0.7-0.944 1.784 0.34 2.313-0.323 0.085-0.584-0.426-1.297 0.237-1.699 0.457 0.079 1.041-0.17 1.23 0.402M308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99c0.055 0.39-0.201 0.937 0.31 1.212 0.664-0.36 1.37-0.086 1.753 0.572-0.006 0.352 0.103 0.815-0.359 0.986l-1.035-0.194c0.073-0.201-0.256-0.329-0.384-0.524-0.457-0.14-0.724 0.231-1.065 0.456 0.256 0.39 0.846 0.603 0.706 1.102-0.609 0.608-0.907-0.524-1.577-0.238-0.457-0.176 0.164-1.126-0.554-1.412-0.852 0-0.286 1.399-1.376 0.852-0.39-0.439-0.773-1.029-0.353-1.522 0.457-0.305 1.23-0.226 1.619 0.17 0.664-0.736 0.73-3.579 2.319-1.461M302.179 857.924c0.444 0.64-0.097 1.51 0.469 2.222 0.889-1.661 1.747 0.359 2.806 0.201 0.323 0.396 0.11 0.944 0.17 1.394-1.309 0.347-2.885 0.761-4.042-0.286l-0.323 0.371c0.688 0.64 1.339 1.364 0.791 2.435-0.98 0.213-2.496 0.237-2.989-0.773-0.256-0.833 0.597-1.436-0.304-2.106-0.651 0.81-0.621 1.894-1.978 1.157-0.84-0.463-1.09-1.418-0.67-2.222 0.877-1.382 2.411 0.043 3.36-0.633 0.134-1.187-0.304-2.222 0.785-2.879 0.931-0.165 1.364 0.535 1.93 1.119' fill='%23f9d90f'/%3E %3Cpath d='m305.892 858.648c-0.438 2.021-1.96-0.103-2.672-0.189 0.95-1.686 1.546 0.548 2.672 0.189M310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846c-1.059 0.298-0.895-1.023-1.418-1.541l0.408-0.371c0.384 0.463 0.676 1.297 1.011 1.912' fill='%23fff'/%3E %3Cpath d='m309.197 860.444c0.304 0.7-0.688 1.261 0.158 1.771 0.268-0.225 0.597-0.536 0.737-0.664 0.724 0.214 1.564 0.342 2.07 1.059 0.542 1.486-0.962 1.449-1.814 1.863l-0.846-0.036c0.201-0.414-0.365-0.59-0.505-0.876-0.39-0.097-0.712 0.024-0.931 0.352 0.189 0.944 1.339 1.68 0.152 2.52-1.004-0.066-2.563 0.323-2.471-1.065-0.377-0.785 1.023-1.997-0.475-2.045-0.493 1.059-1.035 2.081-2.319 1.077l0.158-1.51c1.23 0.036 2.685 0.249 3.238-1.126 0.353-0.998-0.615-1.918 0.25-2.709 1.254-0.286 1.96 0.554 2.599 1.387' fill='%23f9d90f'/%3E %3Cpath d='m308.296 862.714c0.317 0.749-0.536 0.798-0.937 1.169-0.542 0.043-0.919-0.17-1.248-0.536-0.243-0.907 0.432-0.998 0.95-1.357 0.603-0.25 0.852 0.45 1.236 0.724' fill='%23000'/%3E %3Cpath d='m307.56 863.201c-0.134 0.177-0.323 0.122-0.524 0.17l-0.189-0.906c0.402 0.036 0.925 0.164 0.712 0.736' fill='%23fff'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/marker%3E %3C/defs%3E %3Cpath d='M0 0 298.571 225.241 675 225.241 675 0z' fill='%23dc171d'/%3E %3Cpath d='M0 0 299.005 225.746 0 450z' style='fill:%23fff;stroke:%23fff'/%3E %3Cpath d='M0 450 298.571 225.241 675 225.241 675 450z' fill='%23012a87'/%3E %3Cg transform='matrix(1.0075359,0,0,1.0073522,-229.18917,-679.02099)'%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342' fill='%23ff0'/%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342-0.012 0z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m375.446 838.791c-11.615-1.163-24.989-3.92-35.313 1.894-6.921-4.079-16.558-3.83-24.763-3.031-4.456 0.797-9.697 0.797-14.354 1.558l-0.73 0.103c-8.449 0.561-16.113-1.936-23.455-5.217 2.331 13.234 4.919 26.797 6.191 40.652 2.77 20.52-9.709 37.748-4.59 58.019 3.056 9.727 13.751 15.382 23.54 16.503 9.478 0.559 19.285 2.112 28.057 4.017 1.668 0.347 3.646 1.121 4.797 1.619 2.417 1.011 4.188 2.496 5.74 4.085 5.296-5.516 13.057-7.05 20.715-7.859 13.8-1.613 30.814-0.736 39.263-13.239l0-0.707c4.59-6.915 3.981-17.464 1.991-25.299-0.134-2.733-0.864-5.144-1.26-7.749-8.431-22.268-1.211-47.311 2.417-69.756-4.432 2.423-9.375 3.567-14.305 4.779-3.932 0.524-8.315 0.286-12.296 0.072l-1.65-0.444M392.795 902.697 392.795 902.697' fill='%23dc171d'/%3E %3Cpath d='m392.795 902.697c-0.055 1.466 0.737 2.618 1.023 3.974 1.613 9.734 3.172 22.627-6.848 28.666-11.085 7.049-25.622 4.03-38.448 7.761-2.563 0.712-6.093 3.069-7.895 4.736-1.157-0.761-2.319-1.93-3.811-2.617-10.555-5.613-24.276-3.732-36.189-6.764-5.984-1.893-12.223-6.555-13.739-12.68-3.896-16.07 5.436-29.767 4.334-45.709-0.712-12.175-2.758-23.862-5.57-35.276 9.314 4.34 20.094 5.064 30.565 2.983 7.755-1.084 16.783-1.108 24.051 2.173 4.005-1.723 8.693-2.496 13.009-2.971 8.206 0.798 17.026 2.283 25.476 2.222 5.643-0.293 10.769-1.924 15.675-4.097-2.91 18.865-8.498 38.625-1.637 57.599' fill='%2362afe1'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049' fill='%23fff'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049 0.006-0.013z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074' fill='%23fff'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074-0.006 0z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809' fill='%23fff'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M311.937 914.432l0.03 7.609 4.797 0-0.024-7.609-4.803 0M370.862 924.836l-0.061-13.087-10.446-0.012 0.049 13.099 10.458 0M363.18 914.481l0.055 7.585 4.791 0-0.043-7.585-4.803 0M370.783 903.506l-0.061-13.101-10.458 0 0.037 13.101 10.489 0-0.006 0zM363.101 893.163l0.03 7.597 4.791 0-0.006-7.597-4.815 0M319.534 903.458l-0.073-13.076-10.464-0.013 0.049 13.082 10.489 0 0 0.007zM311.851 893.115l0.024 7.585 4.803 0.012-0.036-7.597-4.791 0M338.502 903.481l-0.049-13.076-10.47-0.012 0.043 13.087 10.476 0M330.826 893.127l0.024 7.585 4.797 0.024-0.03-7.609-4.791 0M353.124 903.506l-0.073-13.101-10.464-0.012 0.049 13.087 10.489 0.025M345.435 893.14l0.037 7.609 4.797 0-0.024-7.609-4.809 0' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024' fill='%23fff'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024 0.006 0zM325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M329.018 929.675l-0.103-21.342M352.143 929.687l-0.103-21.329M366.79 886.626l-17.081-12.474-19.193-0.024-16.947 12.449 53.222 0.049M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m331.994 863.799 0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m336.371 865.686 0.024 3.792 7.414 0-0.024-3.792-7.414 0M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742' fill='%23fff'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186c0 0 1.065 1.37 0.018 2.94l0.578 1.09-2.131 0 0.578-1.035c0 0-1.09-1.82 0.049-2.995l-0.657-1.186M331.313 900.335l2.21 0-0.639 1.186c0 0 1.065 1.334 0.006 2.94l0.572 1.09-2.124 0 0.572-1.035c0 0-1.065-1.82 0.055-2.995l-0.651-1.186M336.225 900.335l2.204 0-0.657 1.186c0 0 1.077 1.37 0.018 2.94l0.578 1.114-2.112-0.024 0.566-1.035c0 0-1.077-1.808 0.043-2.995l-0.645-1.186 0.006 0zM341.771 900.346l2.222 0-0.651 1.199c0 0 1.065 1.346 0.006 2.922l0.597 1.108-2.143 0 0.572-1.035c0 0-1.065-1.832 0.073-2.995l-0.67-1.199-0.006 0zM346.701 900.346l2.204 0-0.651 1.199c0 0 1.071 1.346 0.012 2.916l0.584 1.114-2.124 0 0.554-1.035c0 0-1.071-1.82 0.085-2.995l-0.664-1.199M351.602 900.359l2.204-0.012-0.651 1.199c0 0 1.09 1.346 0.03 2.922l0.554 1.108-2.131 0 0.572-1.035c0 0-1.065-1.82 0.073-2.995l-0.651-1.187' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' fill='%23f9d90f'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407' fill='%23f9d90f'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407l0 0.012z' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' fill='%237e7e7e'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198' fill='%23f9d90f'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198zM294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406' fill='%23ff0'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406l0 0.012z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' fill='%237e7e7e'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101' fill='%23f9d90f'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101l0 0.005zM387.036 978.575 372.615 975.416' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m333.072 977.041c-0.323 0.207-0.761 0.262-1.266 0.237l-2.277-0.116 0.195-2.842 2.258 0.121c0.444 0.03 0.797 0.116 1.017 0.25 0.457 0.237 0.657 0.676 0.615 1.284-0.03 0.524-0.213 0.865-0.548 1.065m-3.823 4.475 0.225-3.464 2.654 0.183c0.858 0.067 1.497-0.158 1.93-0.597 0.45-0.426 0.682-0.986 0.712-1.619 0.055-0.737-0.134-1.34-0.572-1.784-0.42-0.426-1.017-0.651-1.765-0.724l-3.792-0.237-0.524 8.156 1.126 0.074M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03c0.402 0.037 0.718 0.085 0.95 0.195 0.426 0.201 0.627 0.603 0.627 1.187 0 0.548-0.158 0.914-0.469 1.133-0.298 0.2-0.73 0.292-1.248 0.292l-2.666-0.03 0.024-2.806m-0.043 7.226 0.024-3.482 2.605 0.037c0.463 0 0.804 0.036 1.041 0.152 0.384 0.177 0.572 0.548 0.59 1.059l0.067 1.37c0.018 0.329 0.024 0.53 0.043 0.664 0.037 0.097 0.055 0.201 0.103 0.275l1.4 0-0.024-0.177c-0.158-0.085-0.286-0.249-0.341-0.499-0.049-0.158-0.073-0.396-0.085-0.694l-0.024-1.09c-0.018-0.493-0.103-0.833-0.292-1.023-0.164-0.219-0.39-0.408-0.737-0.524 0.39-0.206 0.682-0.444 0.895-0.737 0.201-0.323 0.304-0.73 0.304-1.229 0-0.937-0.383-1.577-1.163-1.924-0.42-0.189-0.956-0.287-1.589-0.298l-3.914-0.037-0.03 8.181 1.126 0M346.135 980.206c-0.499-0.608-0.767-1.369-0.828-2.27-0.055-1.133 0.164-1.997 0.682-2.582 0.524-0.633 1.199-0.937 2.082-0.986 0.889-0.049 1.619 0.237 2.161 0.797 0.554 0.548 0.87 1.309 0.925 2.259 0.03 0.913-0.128 1.722-0.548 2.434-0.414 0.725-1.102 1.133-2.118 1.157-1.059 0.055-1.851-0.194-2.356-0.81m-1.339-5.15c-0.524 0.81-0.737 1.747-0.682 2.88 0.079 1.223 0.457 2.234 1.169 2.995 0.791 0.761 1.838 1.144 3.129 1.071 1.382-0.061 2.423-0.584 3.129-1.546 0.572-0.87 0.846-1.882 0.785-3.129-0.079-1.114-0.402-2.021-1.004-2.697-0.761-0.907-1.875-1.308-3.385-1.247-1.424 0.091-2.471 0.614-3.147 1.673M383.238 963.29c0.785-0.134 1.467-0.097 2.088 0.116 0.913 0.286 1.528 0.962 1.911 1.997l-1.126 0.158c-0.243-0.559-0.59-0.943-1.059-1.157-0.457-0.2-1.029-0.25-1.686-0.152-0.767 0.116-1.382 0.499-1.814 1.114-0.426 0.657-0.554 1.534-0.365 2.653 0.158 0.926 0.499 1.711 1.059 2.234 0.517 0.536 1.278 0.724 2.271 0.584 0.743-0.122 1.339-0.419 1.759-0.931 0.438-0.486 0.566-1.224 0.42-2.173l-2.624 0.402-0.134-0.901 3.652-0.561 0.712 4.328-0.724 0.11-0.45-0.998c-0.304 0.451-0.609 0.798-0.877 0.998-0.45 0.354-1.059 0.579-1.82 0.688-0.986 0.152-1.887-0.025-2.703-0.548-0.895-0.664-1.473-1.65-1.692-3.019-0.237-1.345-0.024-2.496 0.597-3.403 0.59-0.876 1.449-1.387 2.605-1.552M391.498 962.656l2.618-0.95c0.359-0.133 0.67-0.177 0.937-0.145 0.481 0.036 0.834 0.322 1.035 0.894 0.189 0.487 0.189 0.913-0.024 1.212-0.225 0.31-0.578 0.536-1.09 0.724l-2.459 0.883-1.017-2.618m2.618 6.764-1.278-3.281 2.435-0.877c0.457-0.146 0.773-0.225 1.011-0.2 0.432 0.054 0.761 0.317 0.98 0.815l0.554 1.249c0.122 0.31 0.219 0.499 0.298 0.584 0.037 0.11 0.116 0.177 0.177 0.249l1.321-0.486-0.073-0.177c-0.195 0-0.383-0.11-0.524-0.323-0.103-0.152-0.201-0.371-0.341-0.626l-0.432-1.023c-0.195-0.444-0.396-0.718-0.627-0.883-0.231-0.128-0.524-0.213-0.87-0.237 0.268-0.311 0.463-0.622 0.536-0.987 0.079-0.371 0.043-0.785-0.134-1.247-0.335-0.87-0.95-1.345-1.814-1.406-0.457-0.036-0.98 0.061-1.583 0.273l-3.677 1.309 2.971 7.694 1.077-0.396M403.691 965.366l-4.669-6.812 5.126-3.269 0.566 0.822-4.2 2.684 1.437 2.082 3.878-2.496 0.53 0.797-3.878 2.496 1.583 2.295 4.273-2.734 0.566 0.804-5.217 3.33M407.776 953.325l1.339-1.473c0.621-0.657 1.278-0.956 1.997-0.87 0.718 0.061 1.449 0.438 2.228 1.12 0.213 0.164 0.402 0.377 0.597 0.615 0.341 0.444 0.542 0.835 0.67 1.224 0.11 0.488 0.085 0.932-0.085 1.358-0.103 0.212-0.286 0.462-0.56 0.761l-1.345 1.461-4.839-4.206m7.074 3.207c0.95-1.046 1.157-2.173 0.603-3.445-0.323-0.688-0.816-1.358-1.497-1.942-0.858-0.761-1.753-1.151-2.697-1.223-1.047-0.08-1.936 0.298-2.709 1.144l-2.283 2.447 6.294 5.491 2.283-2.459M419.725 950.171l-7.244-4.255 0.59-0.937 7.256 4.231-0.597 0.973M422.568 945.229l-7.822-3.13 2.307-5.503 0.95 0.365-1.881 4.535 2.356 0.926 1.759-4.177 0.901 0.372-1.741 4.17 2.636 1.071 1.93-4.589 0.95 0.359-2.35 5.601M426.16 935.623l-8.23-1.82 0.274-1.272 7.603-2.569-6.678-1.473 0.244-0.998 8.23 1.771-0.262 1.236-7.615 2.624 6.678 1.443-0.237 1.059M425.508 925.171l0.103-1.035c0.475 0.013 0.877-0.061 1.181-0.225 0.597-0.323 0.944-0.937 1.035-1.845 0.037-0.425 0.018-0.797-0.079-1.151-0.177-0.681-0.56-1.059-1.175-1.12-0.457-0.049-0.785 0.061-1.023 0.311-0.213 0.286-0.438 0.699-0.609 1.284l-0.377 1.077c-0.243 0.706-0.469 1.193-0.712 1.466-0.39 0.512-0.937 0.688-1.637 0.64-0.749-0.079-1.357-0.377-1.79-0.95-0.444-0.524-0.627-1.272-0.517-2.198 0.073-0.846 0.353-1.558 0.852-2.13 0.463-0.524 1.181-0.774 2.1-0.676l-0.085 1.035c-0.45 0-0.81 0.079-1.071 0.262-0.475 0.262-0.737 0.816-0.816 1.625-0.067 0.67 0.024 1.12 0.28 1.462 0.256 0.286 0.578 0.468 0.956 0.499 0.402 0.037 0.718-0.091 0.937-0.401 0.158-0.214 0.347-0.676 0.603-1.425l0.371-1.132c0.183-0.524 0.402-0.925 0.657-1.211 0.457-0.475 1.053-0.676 1.802-0.62 0.913 0.097 1.564 0.475 1.899 1.169 0.329 0.7 0.457 1.473 0.377 2.35-0.103 0.992-0.426 1.771-1.023 2.295-0.597 0.535-1.339 0.718-2.24 0.645M254.898 924.672l0.189 1.022c-0.457 0.091-0.822 0.275-1.09 0.512-0.481 0.45-0.645 1.126-0.481 2.045 0.073 0.389 0.213 0.772 0.39 1.077 0.365 0.621 0.84 0.87 1.443 0.772 0.444-0.079 0.737-0.249 0.877-0.566 0.134-0.311 0.231-0.786 0.262-1.394l0.055-1.151c0.037-0.712 0.116-1.272 0.274-1.583 0.25-0.56 0.718-0.907 1.418-1.022 0.749-0.135 1.406 0.036 1.972 0.462 0.572 0.396 0.95 1.084 1.09 1.997 0.177 0.835 0.097 1.583-0.231 2.258-0.317 0.658-0.925 1.059-1.857 1.23l-0.183-1.034c0.432-0.158 0.755-0.311 0.968-0.524 0.365-0.408 0.475-0.998 0.335-1.808-0.11-0.658-0.335-1.084-0.676-1.297-0.335-0.25-0.67-0.348-1.035-0.286-0.408 0.061-0.676 0.286-0.804 0.651-0.079 0.243-0.14 0.748-0.195 1.522l-0.055 1.193c-0.03 0.56-0.116 1.023-0.304 1.34-0.298 0.584-0.804 0.943-1.54 1.059-0.931 0.158-1.65-0.055-2.161-0.651-0.524-0.584-0.846-1.284-1.01-2.155-0.183-1.035-0.049-1.838 0.365-2.483 0.42-0.664 1.084-1.047 1.984-1.175M254.381 935.465l8.047-2.423 1.875 5.667-0.98 0.31-1.534-4.657-2.447 0.737 1.418 4.303-0.937 0.298-1.406-4.315-2.727 0.815 1.558 4.76-0.962 0.275-1.905-5.771M257.948 945.289l7.402-3.926 0.791 1.381-5.089 5.381 7.433-1.272 0.767 1.37-7.384 3.902-0.524-0.908 4.359-2.294c0.158-0.092 0.402-0.226 0.755-0.414 0.347-0.158 0.737-0.372 1.126-0.573l-7.402 1.26-0.542-0.962 5.053-5.363-0.243 0.122c-0.158 0.091-0.432 0.225-0.804 0.438-0.365 0.226-0.639 0.365-0.816 0.438l-4.346 2.331-0.536-0.925M271.742 956.192c-0.371-0.085-0.737-0.298-1.096-0.67l-1.564-1.613 2.106-1.93 1.577 1.608c0.304 0.298 0.499 0.59 0.603 0.84 0.146 0.48 0 0.919-0.444 1.333-0.402 0.371-0.804 0.524-1.181 0.432m-5.947 0.749 2.581-2.368 1.832 1.857c0.59 0.603 1.193 0.877 1.826 0.865 0.645-0.037 1.199-0.275 1.686-0.737 0.548-0.487 0.81-1.059 0.81-1.673-0.006-0.597-0.28-1.157-0.785-1.68l-2.63-2.685-6.124 5.625 0.791 0.797M273.178 963.515l4.438-6.958 5.247 3.19-0.548 0.828-4.31-2.581-1.333 2.106 3.963 2.404-0.511 0.798-3.969-2.392-1.51 2.355 4.365 2.624-0.524 0.822-5.308-3.196M286.315 962.169l2.666 0.847c0.377 0.115 0.651 0.261 0.834 0.426 0.341 0.323 0.432 0.785 0.231 1.345-0.164 0.487-0.414 0.804-0.804 0.938-0.347 0.06-0.785 0.06-1.297-0.098l-2.514-0.803 0.883-2.655m-2.301 6.836 1.108-3.318 2.484 0.81c0.444 0.116 0.767 0.275 0.925 0.438 0.304 0.274 0.396 0.682 0.244 1.188l-0.371 1.32c-0.085 0.323-0.128 0.536-0.164 0.633 0 0.104 0 0.214 0.018 0.286l1.309 0.426 0.079-0.189c-0.14-0.11-0.219-0.31-0.213-0.559 0.03-0.153 0.073-0.396 0.158-0.676l0.317-1.059c0.128-0.463 0.177-0.81 0.061-1.059-0.097-0.262-0.262-0.5-0.536-0.724 0.414-0.074 0.773-0.201 1.077-0.427 0.286-0.25 0.53-0.597 0.676-1.083 0.298-0.883 0.134-1.62-0.524-2.18-0.329-0.292-0.797-0.542-1.412-0.773l-3.725-1.15-2.605 7.761 1.09 0.335M295.318 827.761 295.318 827.761' fill='%23012a87'/%3E %3Cpath d='m295.318 827.761c0.962-2.32 9.874-8.645 39.117-5.875 0 0 4.943 3.019 7.847 2.63 1.656-0.214-0.974 0.103-3.135-1.693-2.204-1.795-2.672-5.478 2.362-5.381 5.01 0.128 23.765 1.187 24.118 2.873 0.329 1.704-9.916 2.417-13.727 2.319-3.829-0.103-3.385 1.833 0.426 1.687 11.907-0.426 24.903-4.621 38.63 5.089 1.637 1.18-4.139 1.369-8.608-0.53 0 0-12.108 0.628-17.343-0.231 0 0-4.024 3.274-9.265 2.952 0.682 1.698-1.936 8.035-18.414 3.268-2.721 0.835-12.637 2.496-11.554-0.45-2.611 0-7.189 0.84-7.871-0.646-0.657-1.46 8.06-3.671 9.588-5.253 0 0-18.439 0.177-21.933-1.096 0 0-10.878 2.441-10.239 0.323' fill='%23bc715f'/%3E %3Cpath d='m301.229 853.583c0.396-0.535 0.554-1.497 1.394-1.473 1.826 0.486 3.068 3.828 5.314 1.661 0.797-0.177 1.102 0.908 1.759 1.035 0.42 1.857 1.911-0.377 3.025-0.25 2.38-1.059 5.326-1.309 8.145-0.785 0.085 1.82-1.339 3.829-3.129 4.864 0.037 1.833 1.698 3.008 1.668 4.852-0.286 0.688-0.049 1.771-1.09 1.997-1.321-0.237-2.624-0.377-3.719-1.114-0.134-0.134-0.243-0.396-0.524-0.31-0.134 0.615 0.828 1.224 1.205 1.851-0.664 1.132-1.765 0.097-2.691 0.11-0.274 0.651-0.012 1.473-0.682 1.893-1.169-0.036-1.406-1.308-2.124-1.942-0.737 0.797 0.517 1.272 0.694 1.905-0.45 2.398-0.39 4.742-2.788 6.313l-1.607 0.798c-0.438-1.205-0.164-3.032-0.457-4.292-0.95 1.546-1.692 2.898-3.086 4.206-1.631-0.536-2.581-2.459-2.94-4.054-0.682-1.857-0.292-4.079 1.175-5.424-0.499-0.974-2.21-0.749-2.453-2.136-2.563-1.669-3.981 2.922-5.637 0.535-0.536-2.227 0.103-4.998 1.717-6.66-0.359-0.912-1.552-0.675-2.258-1.199-1.613-1.37-3.939-2.818-3.823-5.291 4.413-1.667 9.691-0.444 12.899 2.91' fill='%23008830'/%3E %3Cpath d='m303.518 853.334c-0.103 2.02 1.364 0.547 2.453 1.771-0.852-0.335-1.473 1.473-2.307 0.438l-0.524 0.5c0.304 0.693 0.895 0.785 0.28 1.546-0.913 0.347-1.096-0.797-1.522-1.248-0.073-0.2 0.14-0.578-0.195-0.712-0.517 0.438-1.059 0.597-1.771 0.524-0.195-0.39-0.572-0.901-0.189-1.199 0.7-0.944 1.784 0.34 2.313-0.323 0.085-0.584-0.426-1.297 0.237-1.699 0.457 0.079 1.041-0.17 1.23 0.402M308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99c0.055 0.39-0.201 0.937 0.31 1.212 0.664-0.36 1.37-0.086 1.753 0.572-0.006 0.352 0.103 0.815-0.359 0.986l-1.035-0.194c0.073-0.201-0.256-0.329-0.384-0.524-0.457-0.14-0.724 0.231-1.065 0.456 0.256 0.39 0.846 0.603 0.706 1.102-0.609 0.608-0.907-0.524-1.577-0.238-0.457-0.176 0.164-1.126-0.554-1.412-0.852 0-0.286 1.399-1.376 0.852-0.39-0.439-0.773-1.029-0.353-1.522 0.457-0.305 1.23-0.226 1.619 0.17 0.664-0.736 0.73-3.579 2.319-1.461M302.179 857.924c0.444 0.64-0.097 1.51 0.469 2.222 0.889-1.661 1.747 0.359 2.806 0.201 0.323 0.396 0.11 0.944 0.17 1.394-1.309 0.347-2.885 0.761-4.042-0.286l-0.323 0.371c0.688 0.64 1.339 1.364 0.791 2.435-0.98 0.213-2.496 0.237-2.989-0.773-0.256-0.833 0.597-1.436-0.304-2.106-0.651 0.81-0.621 1.894-1.978 1.157-0.84-0.463-1.09-1.418-0.67-2.222 0.877-1.382 2.411 0.043 3.36-0.633 0.134-1.187-0.304-2.222 0.785-2.879 0.931-0.165 1.364 0.535 1.93 1.119' fill='%23f9d90f'/%3E %3Cpath d='m305.892 858.648c-0.438 2.021-1.96-0.103-2.672-0.189 0.95-1.686 1.546 0.548 2.672 0.189M310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846c-1.059 0.298-0.895-1.023-1.418-1.541l0.408-0.371c0.384 0.463 0.676 1.297 1.011 1.912' fill='%23fff'/%3E %3Cpath d='m309.197 860.444c0.304 0.7-0.688 1.261 0.158 1.771 0.268-0.225 0.597-0.536 0.737-0.664 0.724 0.214 1.564 0.342 2.07 1.059 0.542 1.486-0.962 1.449-1.814 1.863l-0.846-0.036c0.201-0.414-0.365-0.59-0.505-0.876-0.39-0.097-0.712 0.024-0.931 0.352 0.189 0.944 1.339 1.68 0.152 2.52-1.004-0.066-2.563 0.323-2.471-1.065-0.377-0.785 1.023-1.997-0.475-2.045-0.493 1.059-1.035 2.081-2.319 1.077l0.158-1.51c1.23 0.036 2.685 0.249 3.238-1.126 0.353-0.998-0.615-1.918 0.25-2.709 1.254-0.286 1.96 0.554 2.599 1.387' fill='%23f9d90f'/%3E %3Cpath d='m308.296 862.714c0.317 0.749-0.536 0.798-0.937 1.169-0.542 0.043-0.919-0.17-1.248-0.536-0.243-0.907 0.432-0.998 0.95-1.357 0.603-0.25 0.852 0.45 1.236 0.724' fill='%23000'/%3E %3Cpath d='m307.56 863.201c-0.134 0.177-0.323 0.122-0.524 0.17l-0.189-0.906c0.402 0.036 0.925 0.164 0.712 0.736' fill='%23fff'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 180 120'%3E %3Crect width='180' height='120' fill='%23000'/%3E %3Crect width='180' height='80' fill='%23fff'/%3E %3Crect width='180' height='40' fill='%23ce1126'/%3E %3Cg id='s' fill='%23007a3d'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M54,47v13h8' transform='rotate(18,54,47)' id='o'/%3E %3Cuse xlink:href='%23o' x='-108' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72,54,60)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72,54,60)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144,54,60)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' x='72'/%3E %3C/svg%3E"

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300' viewBox='0 0 600 400'%3E %3Crect width='600' height='400' fill='%233e5eb9'/%3E %3Crect width='600' height='250' y='75' fill='%23ffd900'/%3E %3Crect width='600' height='200' y='100' fill='%23b10c0c'/%3E %3Cg fill='%23ffd900' stroke='%23000' stroke-width='1.008'%3E %3Cg id='e'%3E %3Cpath fill='%23fff' d='m492.85 154.28-24.285 8.571 24.285 8.571 24.285-8.571-24.285-8.571z'/%3E %3Crect width='357.13' height='5.714' x='122.85' y='160' rx='3.106' ry='2.857'/%3E %3Cpath d='m471.44 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3Cpath d='m468.58 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3Cpath d='m465.72 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3C/g%3E %3Cuse xlink:href='%23e' x='-23.27' y='17.15'/%3E %3Crect stroke-width='1.08' width='485.7' height='8.571' x='59.812' y='195.72' rx='4.224' ry='4.286'/%3E %3C/g%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='1.008' d='m442.85 200c-28.571 28.569-66.668 85.711-142.86 85.711-66.668 0-114.28-57.142-142.86-85.711 28.571-28.574 76.188-85.716 142.86-85.716 76.188 0 114.28 57.142 142.86 85.716z'/%3E %3Cpath fill='%23000' d='m290.02 144.1c7.601 8.549 1.254 11.996 9.3 12.557 8.485 0.623 3.675 9.034 10.812 9.326 4.99 0.218-0.498 20.151 4.305 26.729 4.893 6.857 8.991 2.009 9.077 6.963 0.085 5.124-13.317 4.607-13.552 20.39-0.393 9.096-11.31 9.678-11.831 15.531-0.648 5.505 21.507 8.595 21.211 13.523-0.304 4.913-23.922 4.144-24.95 9.747-0.527 5.033 32.446 9.158 35.098 23.713-4.92 1.609-18.919 3.124-29.499 3.132-66.657 0.048-114.28-57.147-142.85-85.716 28.571-28.574 76.188-85.716 142.86-85.716 0 0-19.789 18.082-9.971 29.815z'/%3E %3Cg stroke='%23FFF'%3E %3Cg id='c' stroke-width='6.927'%3E %3Cg id='b'%3E %3Cpath id='a' stroke-width='6.927' d='M213.933 192.377V169.52M227.783 169.52v22.857M241.643 169.52v22.857'/%3E %3Cuse xlink:href='%23a' y='38.1'/%3E %3C/g%3E %3Cuse xlink:href='%23b' x='41.56'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000'%3E %3Cuse xlink:href='%23c' x='104.76'/%3E %3C/g%3E %3Cg fill='%23a70000'%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='0.855' d='m511.35 196.6c-4.328 7.496 3.321-2.493 21.985 10.056 3.459 2.331 6.481 8.489 6.481 12.759-0.878-0.587-1.53-1.894-2.497-2.743-1.354 1.357 1.293 7.577 1.68 10.517-2.918-1.633-2.637-2.406-3.606-4.413 0.193 2.426-0.501 9.107 0.66 11.68-2.3-0.657-2.147-2.508-3.348-2.88 0.817 2.912-0.712 6.081-0.306 9.355-1.344-1.33-2.776-2.372-3.4-2.909-0.105 1.559-2.585 5.656-2.641 7.13-1.14-0.689-1.45-1.763-1.64-2.486-1.417 1.781-6.454 8.358-6.777 10.364-3.881-3.428-13.823-11.775-15.117-16.206-1.144 2.515-2.8 3.364-6.073 5.2-1.293-7.022-6.13-14.915-3.543-20.934-1.833 1.087-3.342 2.174-5.174 3.511 1.736-10.17 10.587-22.095 23.319-28.001z'/%3E %3Cpath d='m495.21 233.72c1.797-3.592 3.452-4.731 4.613-7.044 2.051-4.065 2.344-7.299 4.131-6.825 1.787 0.474 1.785 2.139-0.53 6.136-2.315 3.997-3.416 4.851-8.214 7.733z'/%3E %3Cpath d='m507.36 242.28c-0.231-2.735 0.562-3.877 0.418-5.638-0.247-3.099-1.514-5.226 0.134-5.377 1.648-0.151 2.418 0.906 2.423 4.029 0.005 3.123-0.478 3.943-2.974 6.987z'/%3E %3Cpath d='m516.58 247.64c-0.72-3.818-0.181-5.511-0.642-7.971-0.802-4.328-2.389-7.177-0.862-7.573 1.527-0.396 2.449 1.004 3.027 5.393 0.578 4.389 0.273 5.595-1.523 10.151z'/%3E %3Cpath d='m526.17 220.89c-2.252-1.709-3.566-1.824-5.018-2.922-2.558-1.927-3.852-3.99-4.675-2.966-0.823 1.024-0.239 2.144 2.442 3.922 2.68 1.778 3.588 1.918 7.252 1.966z'/%3E %3Cpath d='m524.58 233.56c-1.187-2.465-2.436-3.09-3.204-4.676-1.357-2.787-1.359-5.198-2.831-4.58-1.472 0.618-1.59 1.88-0.016 4.578 1.574 2.697 2.398 3.186 6.051 4.678z'/%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='1.067' d='m80.783 203.82c-0.242-2.183 0.225-2.444-1.118-4.09 1.955 0.818 2.029 2.992 4.406 1.449 0.873-0.452 1.254-0.466 0.193-2.891 2.479 0.115 10.596 2.899 11.896 2.963 3.413 0.157 9.644-3.586 13.969 1.016 4.151 4.196 2.765 8.551 2.765 14.362-1.668-0.799-0.864-1.193-2.634-3.271 1.327 5.079-0.071 14.237-0.071 19.624-0.681-1.299-0.581-0.735-1.247-2.08-1.77 4.917-3.891 5.929-3.891 11.74-0.639-2.279-0.022-1.797-0.733-2.996-1.72 3.733-13.26 6.923-8.813 10.686-4.014-2.353-5.774-2.106-7.594-4.223-0.784 0.506-1.407 1.464-2.136 2.777-7.057-3.247-4.534-10.25-10.062-14.928-0.957 1.961-0.521 1.677-1.555 4.869-1.119-4.434-1.425-7.251-2.684-10.511-1.086 1.807-0.989 1.114-2.961 3.845-0.816-5.401-2.144-6.676-1.619-10.25-2.096 1.479-0.724 0.88-2.819 2.7 1.985-13.84 10.558-24.067 16.71-20.792z'/%3E %3Cpath d='m72.101 226.41c1.818-4.456 3.457-5.855 4.632-8.724 2.075-5.042 2.413-9.073 4.156-8.458 1.743 0.615 1.715 2.691-0.617 7.645-2.332 4.955-3.423 6.005-8.171 9.536z'/%3E %3Cpath d='m78.985 237.56c0.729-3.995 1.879-5.45 2.352-8.023 0.839-4.524 0.371-7.893 1.991-7.715 1.62 0.177 1.986 1.885 0.908 6.385-1.078 4.501-1.822 5.566-5.252 9.353z'/%3E %3Cpath d='m87.219 245.31c0.205-3.873 1.113-5.385 1.249-7.88 0.246-4.388-0.599-7.529 0.946-7.547 1.545-0.018 2.095 1.56 1.622 5.953-0.473 4.393-1.045 5.489-3.817 9.474z'/%3E %3Cpath d='m104.9 219.98c-3.381-3.368-5.425-3.997-7.606-6.163-3.842-3.804-5.698-7.376-7.066-6.11s-0.545 3.164 3.5 6.784c4.045 3.62 5.452 4.148 11.172 5.489z'/%3E %3Cpath d='m102.84 233c-2.202-3.382-3.818-4.258-5.24-6.434-2.507-3.824-3.369-7.11-4.79-6.296-1.422 0.814-1.104 2.531 1.613 6.238 2.717 3.706 3.81 4.388 8.417 6.493z'/%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='0.826' d='m253.8 129.5c-3.958 7.655 6.93-2.546 23.998 10.269 3.163 2.381 7.697 11.787 7.697 16.147-3.634-0.773-10.069-4.36-10.069-4.36s7.552 7.564 7.552 16.284c-2.668-1.668-4.003-1.418-4.89-3.466 0 2.823 2.373 4.622 2.373 8.982-1.926-1.537-3.557-2.561-5.186-3.46 2.517 4.36-4.587 12.818-1.032 15.641-6.218-0.899-12.58-4.872-15.097-9.232-1.334 0.899-1.479 2.311-1.531 3.816 0.196 0.163-9.465-7.171-8.577-9.988-1.296 1.818-1.478 2.817-1.774 4.866-3.549-3.5-6.802-7-7.986-11.525-1.577 2.049-1.676 2.049-3.253 4.098-1.183-7.171-1.183-6.915 1.183-13.061-1.676 1.11-3.056 2.22-4.732 3.586 1.587-10.385 9.682-22.563 21.325-28.594z'/%3E %3Cpath d='m244.04 166.9c0.633-5.275 2.012-7.262 2.424-10.659 0.735-5.974-0.137-10.341 1.98-10.23 2.117 0.11 2.727 2.314 1.68 8.276-1.046 5.961-1.929 7.409-6.084 12.614z'/%3E %3Cpath d='m255.09 176.56c-0.429-4.45 0.393-6.345 0.12-9.212-0.47-5.044-2.028-8.461-0.183-8.775 1.845-0.314 2.778 1.378 2.977 6.471 0.199 5.093-0.294 6.45-2.915 11.516z'/%3E %3Cpath d='m272.34 184.44c-1.876-3.851-3.488-4.999-4.699-7.478-2.139-4.356-2.586-7.913-4.236-7.269-1.65 0.645-1.559 2.485 0.824 6.749 2.383 4.264 3.46 5.134 8.111 7.998z'/%3E %3Cpath d='m278.31 149.95c-4.778-2.515-7.232-2.547-10.311-4.163-5.422-2.834-8.578-6.035-9.698-4.273-1.121 1.762 0.375 3.514 5.965 6.09 5.59 2.576 7.307 2.698 14.045 2.346z'/%3E %3Cpath d='m280.06 164.36c-3.479-2.894-5.536-3.32-7.78-5.182-3.953-3.267-5.92-6.476-7.241-5.175-1.32 1.301-0.438 3.019 3.711 6.097 4.149 3.078 5.568 3.46 11.31 4.26z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m1008.94,170.989v85.1747c0,69.9277-27.4673,133.94-108.953,172.848-81.488-38.909-108.956-102.921-108.956-172.849v-85.1747h217.907z'/%3E %3Cpath fill='%23fdc300' d='m1001.61,179.669v79.444c0,65.2229-25.6193,124.928-101.623,161.218-76.0036-36.2906-101.623-95.9956-101.623-161.219v-79.444h203.246z'/%3E %3Cg fill='%23ff9e3d' stroke='%23000' stroke-width='0.2604'%3E %3Cpath d='m852.667,214.487c-1.47074-1.10339-3.06648-1.77759-5.27051-1.83885,0.48747-5.39443-3.43312-7.72372-6.25377-8.7046-2.8165-0.98088-3.79977-2.08427-4.28724-4.29105-0.49163-2.20678-1.96238-3.55518-4.53722-4.29063-2.57484-0.73587-4.78303-3.31017-5.76214-4.53648-0.9791-1.22589-1.34991-0.98088-2.0832,1.10339-0.73746,2.08427-3.67894,6.00738-0.98327,6.13031-1.95822,1.59341-3.06231,3.43267-1.83739,5.88446-1.34992,1.10339-2.32902,2.69722-0.49164,3.31017,1.84156,0.61294,2.32903,1.10338,2.45402,1.59383-1.65407,0-2.08321,3.31016,1.83738,4.04562-0.85828,0.1225-1.22492,2.81972,0.37081,2.81972-2.20819,0-4.04974,3.31058-6.86624,3.31058-2.82065,0-4.2914,0.61253-4.41222,1.83885-0.12499,1.22589-1.59574,2.6968-2.32902,3.31016,2.0832,0.24501,3.42895,0,4.53305-0.85837,1.1041-0.85838,2.94148-1.10339,4.17057-0.12251,1.22493,0.98088,3.79977,1.47091,5.02469,1.22589-2.69567,1.83926-4.65804,4.29105-4.90386,6.62034-0.24582,2.3297-1.83739,5.0265-3.67894,5.76237-1.83739,0.73545-4.28723,2.69722-5.14551,5.0265,2.32902,5.76196,5.63298,7.18536,8.94527,8.70419,5.88714,2.69764,9.56191,4.65898,12.0159,7.3562,2.44985,2.69722,3.43312,0.73546,7.1079,5.39402,3.67893,4.65899,7.11205,13.4861,10.7868,14.9574,3.67893,1.47091,8.33698,0.49044,11.0326-4.16854,2.69983-4.65857,4.41639-51.7364-9.43692-59.583z'/%3E %3Cpath fill='%23ff927f' d='m858.921,194.871c-3.43312,3.6781-7.84951,7.3562-7.11206,13.9765,0.73746,6.62033,1.47074,17.4092-4.65804,21.0869-6.12879,3.6781-9.07027,12.9956-1.71656,18.3897,7.35371,5.39486,7.59952,12.0152,8.82445,18.1451,1.22909,6.12989,4.41639,11.0335,9.32025,6.86535,4.8997,0.73545,7.59953-1.2259,7.59953-5.14901,0-3.92312,0.24582-6.12989,3.92059-7.35621,3.67894-1.22589,4.65805-2.4522,6.37461-5.76195,1.71656-3.31017,2.69566-4.78149,1.71656-6.74326-0.97911-1.96135-1.34992-6.00697-0.61247-8.94961,0.73746-2.94224-0.9791-4.53607-1.96237-6.37491-0.97911-1.83884-1.34575-3.43267-0.85828-5.88488,0.49163-2.4522-0.73329-4.04562-2.44985-5.27193-1.71656-1.22589-2.45402-2.45179-2.08321-4.41355,0.36665-1.96135-1.22909-3.18725-3.06647-4.65857-1.83739-1.47132-3.1873-3.43267-3.1873-6.3749,0-2.94265-5.63715-9.80841-10.0494-11.5248z'/%3E %3Cpath fill='%23ff9ee1' d='m860.267,274.928c8.21199-2.08428,7.4787-15.57,6.25378-21.2094-1.22909-5.63987-4.3789-13.7174-1.96238-20.1064,3.43312-9.07212-4.17058-17.6542-2.2082-21.0869,1.96238-3.43309,1.71656-5.27193,1.47075-6.37532-0.24166-1.10339-2.08321-1.96135-2.20403,0.36793-0.125,2.32929-0.73746,3.18725-2.2082,4.65857s-1.1041,4.65857,0,8.21416c1.1041,3.55518,3.43312,8.95003-0.24582,16.0604-3.67477,7.11078-2.16236,10.2793-0.73329,13.6086,2.20403,5.14901,7.47871,23.0487,1.83739,25.8684z'/%3E %3Cpath d='m823.49,198.059c0.92077,0,2.69983-0.36835,2.69983,0.85796'/%3E %3Cpath d='m821.652,203.943c1.1041-0.79712,3.06648,0.12251,5.02469-1.04214'/%3E %3Cpath d='m823.615,208.847c1.47074,0,3.43312-0.0613,5.2705-1.53258'/%3E %3Cpath d='m825.452,212.893c1.34992,0,3.86226-0.85796,4.47473-2.63555'/%3E %3Cpath d='m825.823,215.713c2.63317-0.12251,6.12879,0.85838,6.61626-0.0613'/%3E %3Cpath d='m825.944,224.417c1.83739-1.71633,6.19128-2.88097,7.17039-4.65856'/%3E %3Cpath d='m830.602,197.078c3.06231,0.9813,1.79573,2.87556,3.30813,4.04603,2.69983,2.08428,0.24582,4.41356,2.45402,5.02651,2.20403,0.61294,2.16653,0.98546,1.59156,3.43267-0.67495,2.88139,2.08321,3.00348,1.1041,4.904'/%3E %3Cpath d='m847.397,212.648c-1.22492,0-4.84136,0.12251-6.3746,3.37142'/%3E %3Cpath d='m821.223,248.018c1.41241,0.24543,2.11653-0.55753,2.51234-1.3484,0.42914-0.85838,0.61247-1.47133,1.89989-1.53258,1.28742-0.0617,3.24979-0.42919,3.67893-1.41007,0.42914-0.98047,1.96238-0.0613,3.2498-2.63597,1.28742-2.57429,2.1457-5.63945,5.57466-6.74284'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.2604'%3E %3Cg fill='%2300a728'%3E %3Cpath d='m918.475,301.589c1.38741,2.01594-0.05,4.19521,2.30402,5.06692,2.75816,1.02089,0.34998,4.64857,3.60394,5.92697,2.88316,1.13422,0.0208,4.60231,3.13731,6.15989,2.78732,1.39465-0.46664,4.64898,3.25396,6.50866,3.71644,1.85926-0.69995,6.04322,2.09154,7.67039,2.78733,1.62716-0.92911,5.81112,2.32485,7.43829,3.25397,1.62674-1.39574,4.88107,1.6249,7.20577,3.02065,2.32429-0.69579,5.81071,2.32486,7.9029,3.02064,2.09219-1.85405,4.88566,1.16243,7.90332,2.32485,2.32428-0.83745,4.60064,0.92911,8.1354,1.16242,2.32429-1.16243,11.6222-7.67036,10.6922-2.32486,3.95186-11.3868,7.43829-14.6408,6.27615-3.25396,2.32428-13.7116,5.57861-19.0613,0.46502-5.34133,5.11359-15.8032,1.85926-19.0572-0.46502-3.25396,1.16214-12.3159-2.32429-14.6408-6.27615-6.50793,0.93004-8.83279-8.36792-7.67036-10.6922,1.76656-3.53476-1.39575-5.81112,0.92911-8.1354,3.01648-3.01766-1.85822-5.81113,1.16243-7.90332,3.02064-2.09219-0.69579-5.57861,2.32485-7.9029,3.02065-2.3247-1.62906-5.57903,1.6249-7.20577,3.25397-1.62717-0.46247-5.81113,2.32486-7.43829,2.79149-1.62717-1.6249-5.81113,2.09153-7.67039,3.72061-1.85968,0.46664-5.11401,3.25397-6.50866,3.11647-1.55758,0.25415-5.02567,3.1373-6.15989,3.25397-1.2784,0.84578-4.90608,3.60395-5.92697,2.39151-0.88546,0.86661-3.12057,2.37485-5.16317,6.9204,2.72263,28.3441,4.67648,37.156,0.0962z'/%3E %3Cpath d='m887.544,302.239c-2.55817,2.5568,0.46664,4.41647-2.09153,7.43787-2.55818,3.02224-0.23332,4.64899-2.32486,7.43829-2.09154,2.78931,0.92911,4.18438-1.39575,7.20578-2.32069,3.02182,0.46664,4.8815-2.09153,7.43829-2.55401,2.5568,0.46663,4.8815-2.09154,7.67081-2.55401,2.7893,0.46664,4.64856-2.09154,7.20536-2.55401,2.55721,0.46664,5.34652-2.09153,7.90289-2.55401,2.55722,0.46663,5.81113-2.32486,8.83337-2.78733,3.0214,0.46664,5.34568-1.85822,7.67038-2.32485,2.32428-0.23332,4.64857-1.85822,6.27573-1.62906,1.62717-1.85821,3.89395-1.16242,4.8815'/%3E %3Cpath d='m892.423,303.169c-2.32069,3.02182,1.16242,4.41647-0.92911,6.97327-2.09154,2.55721,0.92911,3.48684-0.69579,6.50866s1.16242,3.71893-0.92911,6.74075c-2.09154,3.02182,1.16243,5.34611-1.16243,8.36792-2.32486,3.02182,1.16243,4.64857-0.92911,7.67081-2.09154,3.0214,0.92911,4.64856-0.92911,6.97326-1.86238,2.32429,1.39158,4.64857-0.92911,7.43788-2.32485,2.78972,0.92911,4.88149-0.93327,7.43829-1.85822,2.55679,0.69995,5.3461-0.92911,7.43787-1.6249,2.09219,1.16243,5.11401-1.16243,7.90331-2.32485,2.78931,0.46664,4.64899-0.92911,6.50866-1.39574,1.85926-2.49568,4.59065-1.16243,5.34611'/%3E %3Cpath d='m899.86,305.958c-1.15826,4.85983,1.62907,9.18004,0,13.2298-1.62489,4.0502,1.16243,5.67028,0.23332,8.91003-0.92911,3.24016,1.16243,5.67028-0.23332,9.18004-1.39158,3.51018,1.86239,6.2099,0,10.8001-1.85821,4.59023,1.19993,5.73279,0,10.2601-1.39158,5.26568,2.32486,8.05499,0,11.7743-2.32068,3.71894,2.09571,4.64898,0.23332,8.83253-1.85821,4.18437,1.16243,5.81112-0.23332,9.9955'/%3E %3Cpath d='m912.18,302.239c2.55818,2.5568-0.46663,4.41647,2.09154,7.43787,2.55817,3.02224,0.23332,4.64899,2.32486,7.43829,2.09153,2.78931-0.92911,4.18438,1.39574,7.20578,2.32069,3.02182-0.46664,4.8815,2.09154,7.43829,2.55401,2.5568-0.46664,4.8815,2.09154,7.67081,2.554,2.7893-0.46664,4.64856,2.09153,7.20536,2.55401,2.55721-0.46664,5.34652,2.09154,7.90289,2.55401,2.55722-0.46664,5.81113,2.32485,8.83337,2.78733,3.0214-0.46663,5.34568,1.85822,7.67038,2.32486,2.32428,0.23332,4.64857,1.85822,6.27573,1.62907,1.62717,1.86239,3.89395,1.16243,4.8815'/%3E %3Cpath d='m907.301,303.169c2.32069,3.02182-1.16243,4.41647,0.92911,6.97327,2.09153,2.55721-0.92911,3.48684,0.69579,6.50866,1.62906,3.02182-1.16243,3.71893,0.92911,6.74075,2.09153,3.02182-1.16243,5.34611,1.16242,8.36792,2.32486,3.02182-1.16242,4.64857,0.92911,7.67081,2.09154,3.0214-0.92911,4.64856,0.92911,6.97326,1.86239,2.32429-1.39158,4.64857,0.93328,7.43788,2.32069,2.78972-0.93328,4.88149,0.92911,7.43829,1.85822,2.55679-0.69996,5.3461,0.92911,7.43787,1.6249,2.09219-1.16243,5.11401,1.16242,7.90331,2.32486,2.78931-0.46663,4.64899,0.92911,6.50866,1.39575,1.85926,2.49985,4.59065,1.16243,5.34611'/%3E %3C/g%3E %3Cg fill='%23fcc300'%3E %3Cpath d='m884.115,313.745c0.004,1.0438-0.0208,2.08344-0.98744,3.37058-2.09154,2.78931,0.92911,4.18438-1.39575,7.20578-2.32069,3.02182,0.46664,4.8815-2.09153,7.43829-2.55401,2.5568,0.46663,4.8815-2.09154,7.67081-2.55401,2.7893,0.46664,4.64856-2.09154,7.20536-2.55401,2.55721,0.46664,5.34652-2.09153,7.90289-2.55401,2.55722,0.46663,5.81113-2.32486,8.83337-2.78733,3.0214,0.46664,5.34568-1.85822,7.67038-2.32485,2.32428-0.23332,4.64857-1.85822,6.27573,2.78733-2.09177,2.78733-5.34568,4.87887-6.97285,2.09153-1.62758-0.69579-3.95186,0.46664-5.114,1.16242-1.16215,0.23331-6.04364,2.32485-8.36793,2.09154-2.3247,0.23332-6.97326,2.09154-8.60043,1.85822-1.62716,0.46247-6.50824,2.78733-8.13541,2.32485-1.62716,0-5.57861,1.85821-7.6708,1.86239-2.09177,0-5.3461,1.86239-7.90289,1.85822-2.5568,0.0833-4.87817,1.39158-6.97327,0.58329-0.92963,0.58329-7.67039-0.87078-3.83561z'/%3E %3Cpath d='m890.798,316.651c-1.6249,3.02182,1.16242,3.71893-0.92911,6.74075-2.09154,3.02182,1.16243,5.34611-1.16243,8.36792-2.32486,3.02182,1.16243,4.64857-0.92911,7.67081-2.09154,3.0214,0.92911,4.64856-0.92911,6.97326-1.86238,2.32429,1.39158,4.64857-0.92911,7.43788-2.32485,2.78972,0.92911,4.88149-0.93327,7.43829-1.85822,2.55679,0.69995,5.3461-0.92911,7.43787-1.6249,2.09219,1.16243,5.11401-1.16243,7.90331-2.32485,2.78931,0.46664,4.64899-0.92911,6.50866,2.7915-0.93004,1.74573-4.76523,2.7915-5.57861,1.04576-0.81379-0.34998-6.15989,1.27492-7.55455,1.62906-1.39465-1.04577-5.69695,0.46663-7.55454,2.55818-3.13766,0.34998-5.22985,1.85822-7.67039,1.51241-2.44095-0.57496-5.57403,0.5833-7.20578,1.97488-2.7893-0.87495-5.3036,0.57913-7.32203,2.09154-2.90556-0.40414-5.29818,1.04577-7.20578,2.20819-2.90556-0.23332-5.81112,0.69995-7.32203,0.92911-1.51091,2.43735-8.01916-0.46663-9.06504z'/%3E %3Cpath d='m899.86,319.188c-1.62489,4.0502,1.16243,5.67028,0.23332,8.91003-0.92911,3.24016,1.16243,5.67028-0.23332,9.18004-1.39158,3.51018,1.86239,6.2099,0,10.8001-1.85821,4.59023,1.19993,5.73279,0,10.2601-1.39158,5.26568,2.32486,8.05499,0,11.7743-2.32068,3.71894,2.66234,4.95025,0.23332,8.83253-1.16242,1.85967,0.11666,6.62491,1.97488,0.93004,1.86238-5.69487-1.39158-6.39198,0.23332-8.71668,1.62906-2.3247-0.57913-8.48418,0.11666-11.7385,0.69996-3.25433-1.6249-7.6708-0.11666-11.1572,1.51241-3.48642-2.32486-7.20536-0.81245-10.2276,1.51241-3.02141-0.69579-6.74076,0.69579-9.1813,1.39575-2.44054-1.04577-5.69487-0.46247-7.08952,0.57913-1.39466-0.5833-6.547-1.86239-2.57638z'/%3E %3C/g%3E %3Cpath fill='%23ef072d' d='m917.292,304.331c0-26.2659-3.71644-35.3309-17.4323-35.3309-13.7116,0-17.4281,9.06504-17.4281,35.3309h34.8603z'/%3E %3Cpath fill='%23000' d='m882.432,304.331c0-26.2659,3.71644-35.3309,17.4281-35.3309-6.27461,0-10.1077,4.88066-11.1535,8.13499-1.04577,3.25433-0.46664,3.02182,0.92911,1.74342,1.39575-1.27839,0.69579,1.51091-0.46247,3.02182-1.16243,1.51091-2.32486,5.81113-0.69996,4.41647,1.62907-1.39465,2.90399,0.23252,1.16243,2.67306-1.74156,2.44053-3.25397,8.1354-1.51241,6.15989,1.74573-1.97593,2.09154,1.2784,1.04994,2.90556-1.04994,1.62717-0.93328,3.0214,0,2.32428,0.92911-0.69711,0.81245,2.67305-0.11666,3.95145h-6.62459z'/%3E %3Cpath fill='%23000' d='m914.622,302.82c0-20.571-2.55401-26.7309-7.66619-28.8227-2.89566-1.18631-2.97898-0.92963-1.59574,0.92963,1.38325,1.85926,1.17076,4.53272-0.10832,2.67305-1.27492-1.85926-1.6999-2.20803-2.2332-1.39424-0.5333,0.81337,1.48741,4.64857,2.97898,8.13541,1.19993,2.80431,0.42498,4.18354-1.38324,1.39423-1.80823-2.7893-1.80823-0.26251-0.22082,2.09219,2.03737,3.02182,1.97487,12.2031,1.97487,16.0383l8.25366-1.04589z'/%3E %3Cpath fill='%23ef072d' d='m899.86,308.166c5.46217,0,11.441-0.97338,15.4574-2.53304,4.76637-1.85051,5.02052-3.47643,3.37062-5.55236-1.16243-1.46133-3.7206-0.5842-6.15795,0.4871-2.44151,1.07131-9.18276,1.75342-12.67,1.75342-3.48311,0-10.2244-0.68211-12.6659-1.75342-2.43734-1.0713-4.99552-1.94843-6.15795-0.4871-1.64989,2.07593-1.39574,3.70185,3.37063,5.55236,4.01225,1.55966,9.99521,2.53304,15.4532,2.53304z'/%3E %3C/g%3E %3Cg fill='%23b95a1e' stroke='%23000' stroke-width='0.2976'%3E %3Cg%3E %3Cpath d='m952.855,273.393s3.57764,6.17649,6.20159,10.6787c2.62361,4.5016,4.74983,5.52721,6.64995,4.19194,1.89978-1.33586,0.28699-5.00496-1.23506-6.74599-1.52239-1.74163-9.89229-9.91172-9.89229-9.91172l-1.72419,1.78709z'/%3E %3Cpath d='m952.005,273.868s1.41757,7.08152,2.46606,12.2491c1.04835,5.16688,2.72803,6.88205,4.94181,6.29214,2.21365-0.59058,1.85465-4.61693,0.97094-6.79384-0.88385-2.1776-6.18786-12.8251-6.18786-12.8251l-2.19095,1.07774z'/%3E %3Cpath d='m950.499,274.091s-0.008,7.23757,0,12.5221c0.008,5.28383,1.31323,7.32945,3.59492,7.23723,2.28169-0.0929,2.72346-4.11011,2.28772-6.43309-0.43573-2.32368-3.52721-13.9007-3.52721-13.9007l-2.35543,0.57443z'/%3E %3Cpath d='m948.148,273.393s-3.57764,6.17649-6.20159,10.6787c-2.62361,4.5016-4.74983,5.52721-6.64995,4.19194-1.89978-1.33586-0.28699-5.00496,1.23506-6.74599,1.52239-1.74163,9.89229-9.91172,9.89229-9.91172l1.72419,1.78709z'/%3E %3Cpath d='m948.999,273.868s-1.41757,7.08152-2.46606,12.2491c-1.04835,5.16688-2.72803,6.88205-4.94181,6.29214-2.21365-0.59058-1.85465-4.61693-0.97094-6.79384,0.88385-2.1776,6.18786-12.8251,6.18786-12.8251l2.19095,1.07774z'/%3E %3Cpath d='m950.504,274.091s0.008,7.23757,0,12.5221c-0.008,5.28383-1.31323,7.32945-3.59492,7.23723-2.28169-0.0929-2.72346-4.11011-2.28772-6.43309,0.43573-2.32368,3.52721-13.9007,3.52721-13.9007l2.35543,0.57443z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m954.464,218.4s5.82657-6.18876,16.0232-12.3775c10.196-6.18874,17.5728-10.9492,18.936-9.90202,0,1.23779-8.73994,7.42652-16.023,12.3775-7.28309,4.95099-16.023,12.3775-16.023,12.3775l-2.91328-2.4755z'/%3E %3Cpath d='m955.14,223.351s5.75948-3.63469,16.8043-8.66425c10.8719-4.46556,26.219-3.71326,26.219-2.4755-1.45611,1.23774-14.566,1.23774-23.306,4.95099-8.34258,3.54434-16.804,8.66426-16.804,8.66426l-2.91328-2.4755z'/%3E %3Cpath d='m955.202,231.877s5.07089-2.45,16.8043-6.18876c11.6522-3.71325,27.1218-1.23775,27.1218,0-1.45611,1.23774-14.0127,0.48543-22.7526,2.47551-9.04357,1.93924-18.2601,6.18875-18.2601,6.18875l-2.91328-2.4755z'/%3E %3Cpath d='m955.756,240.535s5.84408-4.95866,18.2916-6.18876c12.5245-1.23774,22.7214,6.18876,22.7214,7.42648-1.4561,1.23778-13.1099-5.44762-21.8498-4.49146-9.25941,0.95395-16.2499,5.72924-16.2499,5.72924l-2.91328-2.4755z'/%3E %3Cpath d='m952.855,213.304s9.38996-6.18876,9.38996-11.1398c0-4.951-4.13967-9.90199-5.31344-12.3775,2.34754,0,7.66089,7.42649,7.66089,12.3775,0,5.41052-8.82413,13.6152-8.82413,13.6152l-2.91328-2.4755z'/%3E %3Cpath d='m952.855,213.304s-1.17377-3.71325-1.17377-11.1398c0-8.66428,5.17991-14.175,7.04243-16.0908,0.48494,1.91582-4.6949,8.66427-4.6949,16.0908,0,5.41053,1.73952,13.6152,1.73952,13.6152l-2.91328-2.4755z'/%3E %3Cpath d='m946.539,218.4s-5.82657-6.18876-16.0232-12.3775c-10.196-6.18874-17.5728-10.9492-18.936-9.90202,0,1.23779,8.73994,7.42652,16.023,12.3775,7.28309,4.95099,16.023,12.3775,16.023,12.3775l2.91328-2.4755z'/%3E %3Cpath d='m945.863,223.351s-5.75948-3.63469-16.8043-8.66425c-10.8719-4.46556-26.219-3.71326-26.219-2.4755,1.45611,1.23774,14.566,1.23774,23.306,4.95099,8.34258,3.54434,16.804,8.66426,16.804,8.66426l2.91328-2.4755z'/%3E %3Cpath d='m945.801,231.877s-5.07089-2.45-16.8043-6.18876c-11.6522-3.71325-27.1218-1.23775-27.1218,0,1.45611,1.23774,14.0127,0.48543,22.7526,2.47551,9.04357,1.93924,18.2601,6.18875,18.2601,6.18875l2.91328-2.4755z'/%3E %3Cpath d='m945.247,240.535s-5.84408-4.95866-18.2916-6.18876c-12.5245-1.23774-22.7214,6.18876-22.7214,7.42648,1.4561,1.23778,13.1099-5.44762,21.8498-4.49146,9.25941,0.95395,16.2499,5.72924,16.2499,5.72924l2.91328-2.4755z'/%3E %3Cpath d='m948.148,213.304s-9.38996-6.18876-9.38996-11.1398c0-4.951,4.13967-9.90199,5.31344-12.3775-2.34754,0-7.66089,7.42649-7.66089,12.3775,0,5.41052,8.82413,13.6152,8.82413,13.6152l2.91328-2.4755z'/%3E %3Cpath d='m948.148,213.304s1.17377-3.71325,1.17377-11.1398c0-8.66428-5.17991-14.175-7.04243-16.0908-0.48494,1.91582,4.6949,8.66427,4.6949,16.0908,0,5.41053-1.73952,13.6152-1.73952,13.6152l2.91328-2.4755z'/%3E %3C/g%3E %3Cg stroke='%23fdc301' stroke-width='0.7501'%3E %3Cpath d='m981.025,302.422c-3.64812-8.54578-4.69495-23.5172-4.69495-25.9927,0-6.97118,2.18284-40.8779,2.34748-54.461,0.16463-13.5831-8.21614-21.0417-16.4324-21.0417-7.04243,0-11.7374,4.95102-11.7374,12.3775h3.52125c0-4.951,3.52125-8.66425,8.2162-8.66425,7.04244,0,12.4548,5.85035,12.9112,17.3285,0.50384,13.2662-1.41221,47.7134-1.17377,56.9365,0.23844,9.22374,3.39431,17.4468,7.04243,23.5172z'/%3E %3Cpath d='m919.979,302.422c3.64812-8.54578,4.69495-23.5172,4.69495-25.9927,0-6.97118-2.18284-40.8779-2.34748-54.461-0.16463-13.5831,8.21614-21.0417,16.4324-21.0417,7.04243,0,11.7374,4.95102,11.7374,12.3775h-3.52125c0-4.951-3.52125-8.66425-8.2162-8.66425-7.04244,0-12.4548,5.85035-12.9112,17.3285-0.50384,13.2662,1.41221,47.7134,1.17377,56.9365-0.23844,9.22374-3.39431,17.4468-7.04243,23.5172z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m950.507,273.954c6.56043-0.0974,7.28391-2.47542,7.28391-2.47542s1.45666-4.95099,0.72837-6.18884c-0.72841-1.23772-8.01228-1.23772-8.01228-1.23772v9.90198z'/%3E %3Cpath d='m950.507,269.003c7.04244,0,8.21621-2.47542,8.21621-2.47542s2.34728-4.95099,1.1737-6.18884c-1.17377-1.23772-9.38991-1.23772-9.38991-1.23772v9.90198z'/%3E %3Cpath d='m950.507,264.052c5.86873,0,9.38998-2.47549,9.38998-2.47549s2.34728-4.95099,1.1737-6.18884c-1.17377-1.23772-10.5637-1.23765-10.5637-1.23765v9.90198z'/%3E %3Cpath d='m950.507,257.863c10.5716-0.0974,10.5637-3.17937,10.5637-3.17937s2.34728-4.95099,1.17371-6.18885c-1.17377-1.23771-11.7374-0.53376-11.7374-0.53376v9.90198z'/%3E %3Cpath d='m950.507,252.912c10.5716-0.0974,11.7374-2.47542,11.7374-2.47542s2.34728-4.95099,1.17371-6.18884c-1.17378-1.23772-12.9111-1.23772-12.9111-1.23772v9.90198z'/%3E %3Cpath d='m950.507,246.724c10.5716-0.0974,12.9112-2.47549,12.9112-2.47549s2.34728-4.95099,1.17371-6.18877c-1.17377-1.23772-14.0849-1.23772-14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.507,240.535c10.5716-0.0974,14.0849-2.47549,14.0849-2.47549s1.17357-4.95099,0-6.18877c-1.17377-1.23772-14.0849-1.23772-14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.507,234.346c10.5716-0.0974,14.0849-2.47549,14.0849-2.47549s0-4.95099-1.17371-6.18877c-1.17377-1.23772-12.9112-1.23772-12.9112-1.23772v9.90198z'/%3E %3Cpath d='m950.507,228.157c10.5716-0.0974,12.9111-2.47549,12.9111-2.47549s0-4.95099-1.17371-6.18877c-1.17377-1.23772-11.7374-1.23772-11.7374-1.23772v9.90198z'/%3E %3Cpath d='m950.507,212.631c8.22416,0.01,11.7773,7.15331,11.7573,7.00764l-2.36742,2.32976c-1.25778,1.23778-9.38991,1.23778-9.28894,1.23143l-0.10097-10.5688z'/%3E %3Cpath d='m950.496,273.954c-6.56043-0.0974-7.28391-2.47542-7.28391-2.47542s-1.45666-4.95099-0.72837-6.18884c0.72841-1.23772,8.01228-1.23772,8.01228-1.23772v9.90198z'/%3E %3Cpath d='m950.496,269.003c-7.04244,0-8.21621-2.47542-8.21621-2.47542s-2.34728-4.95099-1.1737-6.18884c1.17377-1.23772,9.38991-1.23772,9.38991-1.23772v9.90198z'/%3E %3Cpath d='m950.496,264.052c-5.86873,0-9.38998-2.47549-9.38998-2.47549s-2.34728-4.95099-1.1737-6.18884c1.17377-1.23772,10.5637-1.23765,10.5637-1.23765v9.90198z'/%3E %3Cpath d='m950.496,257.863c-10.5716-0.0974-10.5637-3.17937-10.5637-3.17937s-2.34728-4.95099-1.17371-6.18885c1.17377-1.23771,11.7374-0.53376,11.7374-0.53376v9.90198z'/%3E %3Cpath d='m950.496,252.912c-10.5716-0.0974-11.7374-2.47542-11.7374-2.47542s-2.34728-4.95099-1.17371-6.18884c1.17378-1.23772,12.9111-1.23772,12.9111-1.23772v9.90198z'/%3E %3Cpath d='m950.496,246.724c-10.5716-0.0974-12.9112-2.47549-12.9112-2.47549s-2.34728-4.95099-1.17371-6.18877c1.17377-1.23772,14.0849-1.23772,14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.496,240.535c-10.5716-0.0974-14.0849-2.47549-14.0849-2.47549s-1.17357-4.95099,0-6.18877c1.17377-1.23772,14.0849-1.23772,14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.496,234.346c-10.5716-0.0974-14.0849-2.47549-14.0849-2.47549s0-4.95099,1.17371-6.18877c1.17377-1.23772,12.9112-1.23772,12.9112-1.23772v9.90198z'/%3E %3Cpath d='m950.496,228.157c-10.5716-0.0974-12.9111-2.47549-12.9111-2.47549s0-4.95099,1.17371-6.18877c1.17377-1.23772,11.7374-1.23772,11.7374-1.23772v9.90198z'/%3E %3Cpath d='m950.496,212.631c-8.22416,0.01-11.7773,7.15331-11.7573,7.00764l2.36742,2.32976c1.25778,1.23778,9.38991,1.23778,9.28894,1.23143l0.10097-10.5688z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect fill='%23C60C30' width='450' height='300'/%3E %3Crect fill='%23FECB00' width='300' height='300'/%3E %3Crect fill='%23002664' width='150' height='300'/%3E %3C/svg%3E"

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='600' height='400'%3E %3Cdefs%3E %3Cpath id='s' transform='scale(21)' fill='%23fff' d='M0,-1 L0.58779,0.80902 L-0.95106,-0.30902 L0.95106,-0.30902 L-0.58779,0.80902z'/%3E %3C/defs%3E %3Crect fill='%23002395' height='400' width='600' /%3E %3Crect fill='%23fff' height='164' width='244' /%3E %3Crect fill='%23002395' height='160' width='80' /%3E %3Crect fill='%23ED2939' height='160' width='80' x='160'/%3E %3Cpath fill='%23fff' d='M355,183 l12.875,20.5 h36.625 v71.5 l-27.5,-43 -37,59 h18 l19,-34 39,70 39,-70 19,34 h18 l-37,-59 -27.5,43 v-39.5 h16.5 l12.25,-19.5 h-28.75 v-12.5 h36.625 l12.875,-20.5 h-122z M398,270.5h-40v14h40z M474,270.5h-40v14h40z'/%3E %3Cuse xlink:href='%23s' x='416' y='362'/%3E %3Cuse xlink:href='%23s' x='371' y='328'/%3E %3Cuse xlink:href='%23s' x='461' y='328'/%3E %3Cuse xlink:href='%23s' x='333' y='227'/%3E %3Cuse xlink:href='%23s' x='499' y='227'/%3E %3C/svg%3E"

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='809' height='500'%3E %3Crect width='809' height='500' fill='%23006a4e'/%3E %3Crect y='100' width='809' height='100' fill='%23ffce00'/%3E %3Crect y='300' width='809' height='100' fill='%23ffce00'/%3E %3Crect width='300' height='300' fill='%23d21034'/%3E %3Cg transform='translate(150,150)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-95 V 0 H 50' transform='rotate(18 0,-95)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23ED1C24' width='900' height='600'/%3E %3Crect fill='%23fff' y='100' width='900' height='400'/%3E %3Crect fill='%23241D4F' y='200' width='900' height='200'/%3E %3C/svg%3E"

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600' viewBox='0 0 1400 700'%3E %3Crect width='1400' fill='%23060' height='700'/%3E %3Crect width='1400' fill='%23fff' height='500'/%3E %3Crect width='1400' fill='%23c00' height='200'/%3E %3Cg fill='%23f8c300'%3E %3Cpath d='M 672.0,340.7 a 12.5,12.5 0,0,1 23.3,5.9 v 50 h 9.4 v -50 a 12.5,12.5 0,0,1 23.3,-5.9 a 29.5,29.5 0,1,0 -56,0'/%3E %3Cpath d='M 678.7,327.65 a 20,20 0,0,1 21.3,9.55 a 20,20 0,0,1 21.3,-9.55 a 21.5,21.5 0,0,0 -42.6,0' fill='%23fff'/%3E %3Cpath id='w' d='M 695.3,376.627 a 38,38 0 0 1 -63.845,24.316 a 39.5,39.5 0 0 1 -59.734,17.467 c 3.6496,36.426 58.252,28.989 62.32,-6.4288 17.154,30.115 54.873,21.49 65.91,-15.4 z'/%3E %3Cuse xlink:href='%23w' transform='translate(700,0) scale(-1,1) translate(-700,0)'/%3E %3Cpath id='r' d='M 658.84,441.31 c -7.6181,16.446 -22.845,19.271 -36.164,5.9953 0,0 5.3539,-3.7831 11.086,-4.826 -1.0748,-4.5744 1.1291,-10.902 4.2354,-14.324 3.2575,2.2264 7.8036,6.6886 8.9598,11.874 8.0291,-1.0394 11.883,1.2815 11.883,1.2815 z'/%3E %3Cuse xlink:href='%23r' transform='rotate(9.37, 700,804)'/%3E %3Cuse xlink:href='%23r' transform='rotate(18.74, 700,804)'/%3E %3Cpath d='M 603,478 a 340,340 0 0 1 194,0' fill='none' stroke-width='16' stroke='%23f8c300'/%3E %3Cg transform='translate(700,380)'%3E %3Cg transform='translate(0,-140)'%3E %3Cpolygon id='s' points='0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571' transform='scale(0.000048669)'/%3E %3C/g%3E %3Cg id='h'%3E %3Cuse xlink:href='%23s' transform='rotate(-30) translate(0,-140) rotate(30)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-60) translate(0,-140) rotate(60)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-90) translate(0,-140) rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1800' height='900'%3E %3Cdefs%3E %3Cg id='star'%3E %3Cg id='arm' transform='translate(0,-0.324925)'%3E %3Cpath d='M1,0H0V0.5z'/%3E %3Cpath d='M1,0H0V-0.5z' transform='rotate(-36,1,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23arm' transform='rotate(72)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(144)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(216)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(288)'/%3E %3C/g%3E %3C/defs%3E %3Crect width='1800' height='900' fill='%2300247d'/%3E %3Cg fill='%23fed100'%3E %3Cpath d='M329.37609,777.2654C311.44173,777.11556 497.99952,677.83404 654.14523,550.66563C858.78891,383.99945 1299.541,117.15633 1429.1161,73.7954c13.5433,-4.53215 -27.7761,23.07308 -33.14,32.01541c-138.3415,163.74043 -27.925,472.72379 144.9726,628.04829c51.99,39.7632 49.3274,41.85082 145.7074,45.7463v9l-1357.28001,-11.34z'/%3E %3Cpath d='m318.12503,795.3246c0,0 -13.16343,9.4029 -13.12495,16.4061c0.043,7.7725 14.76557,18.0468 14.76557,18.0468l1338.74505,14.7656 24.6093,-16.4062 -34.453,-21.328 -1330.54197,-11.4843z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cuse xlink:href='%23star' transform='translate(342.9565,112.5812) scale(45)'/%3E %3Cuse xlink:href='%23star' transform='translate(521.20459,267.53) scale(37.5)'/%3E %3Cuse xlink:href='%23star' transform='translate(135,321.8075) scale(45)'/%3E %3Cuse xlink:href='%23star' transform=' translate(342.9565,652.5812) scale(52.5)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='450' viewBox='-3 -6 24 12'%3E %3Cpath d='M21,6V-6H-3V6z' fill='%23dc241f'/%3E %3Cpath d='M-3,-6V6L9,0z' fill='%23ffc726'/%3E %3Cpath d='M-3,-6V6L5,0z'/%3E %3C!-- -arctan(0.5) v --%3E %3Cg transform='rotate(-26.565051)'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-2.1V0H1z' fill='%23fff' transform='rotate(18,0,-2.1)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect fill='%2328ae66' height='600' width='900'/%3E %3Cg fill='%23fff'%3E %3Cpath id='crescent' d='m446.821,66.5425c26.5998,11.4204,45.2364,37.851,45.2364,68.6278,0,41.2242-33.4308,74.6551-74.6545,74.6551-18.4554,0-35.3454-6.70442-48.3768-17.805,8.06162,3.4572,16.8702,5.5458,26.1504,5.9508,41.1846,1.7982,76.0418-30.1422,77.8398-71.3268,1.04399-23.9112-9.28683-45.6876-26.1954-60.1017z'/%3E %3Cpath id='star' d='m375.616,121.42,8.4582-26.0328-22.1448,16.089,27.3726,0-22.1448-16.089z'/%3E %3Cuse xlink:href='%23star' y='-38.400051' height='600'/%3E %3Cuse xlink:href='%23star' x='37.936928' y='-18.722051'/%3E %3Cuse xlink:href='%23star' x='-37.936072' y='18.721949'/%3E %3Cuse xlink:href='%23star' y='38.399949' height='600'/%3E %3C/g%3E %3Cg id='carpets' fill='%23383739'%3E %3Crect fill='%23ca3745' width='162' height='600' x='107.998'/%3E %3Cg id='ornm5'%3E %3Cg id='ornm'%3E %3Cpath d='m107.998-39.6189v5.87932l9.11017,8.52746-3.07221,2.86017,6.51492,6.03814-2.86017,2.59534v-3.76059h-5.56153v4.50212l12.553,11.7585h6.35594l0.68864-4.13136h-3.65475l3.97238-3.70763,9.95763,9.0572-9.95763,9.11017-3.97238-3.70763h3.65475l-0.68864-4.18432h-6.35594l-12.553,11.7586v4.50212h5.56153v-3.76059l2.86017,2.59534-6.51492,6.03814,3.07221,2.91305-9.11017,8.47458v5.87932l15.413-14.3539-3.07204-2.91305,6.46187-6.03814-5.56153-5.19068,3.7078-3.38983,7.09729,6.5678,15.5722-14.3008-15.5722-14.3008-7.09729,6.62076-3.7078-3.4428,5.56153-5.19068-6.46187-6.03814,3.07204-2.86017-15.413-14.4068zm0,28.5488v22.1398l3.60169-3.65466v-4.29019h3.81356l3.07186-3.125-3.07186-3.07203h-3.81356v-4.34322l-3.60169-3.65466zm26.2712,7.83898-0.52983,3.01907,0.52983,3.07203,3.28373-3.07203-3.28373-3.01907z'/%3E %3Cpath fill='%23faae29' d='m107.998-38.9833v4.66102l9.74576,9.11017-3.0722,2.86017,6.51491,6.03814-3.91949,3.65466v-4.39619h-4.71407v3.91949l12.3412,11.4936h5.72034l0.58254-3.2839h-4.23729l5.08475-4.76695,10.5932,9.6928-10.5932,9.6928-5.08475-4.71398h4.23729l-0.584-3.33686h-5.72034l-12.3412,11.4936v3.91949h4.71407v-4.39619l3.91949,3.65466-6.51491,6.03814,3.0722,2.91305-9.74576,9.05729v4.66102l14.7774-13.7183-3.07203-2.91305,6.46187-6.03814-5.56153-5.19068,4.34339-4.02542,7.09729,6.62076,14.8836-13.7182-14.8836-13.7182-7.09729,6.62076-4.34339-4.02542,5.56153-5.19068-6.46187-6.03814,3.07203-2.86017-14.7774-13.7712zm0,28.5488v20.8686l3.17796-3.17797v-4.60798h4.07831l2.6483-2.64831-2.6483-2.64831h-4.07831v-4.60805l-3.17796-3.17797zm26.5888,8.05085-0.37068,2.17161,0.37068,2.17161,2.33051-2.17161-2.33051-2.17161z'/%3E %3C/g%3E %3Cuse xlink:href='%23ornm' y='109.20679'/%3E %3Cuse xlink:href='%23ornm' y='222.0051'/%3E %3Cuse xlink:href='%23ornm' y='334.80173'/%3E %3Cuse xlink:href='%23ornm' y='447.59835'/%3E %3C/g%3E %3Cuse xlink:href='%23ornm5' transform='matrix(-1,0,0,1,377.99597,0)'/%3E %3Cpath id='branch' fill='%23faae29' d='m121.14,530.824c0.7992,3.4074,3.5082,5.979,4.1538,9.51299,1.2924-3.6846,2.484-6.77342,1.5942-10.8042-0.6366-2.883-3.06181-4.9392-3.3426-7.902-2.64421,2.37721-3.2136,5.74921-2.4054,9.19321zm-0.67021,14.2764c2.24281,3.075,5.36041,5.4336,8.8032,7.0062-0.678-2.6934,0.594-4.7214,2.0058-6.85978,1.701-2.574,2.5302-5.1024,1.1436-8.06637-0.6462,1.5408-1.5144,2.8206-2.5332,4.1382-1.5066,2.05559-2.4972,3.8832-2.7294,6.51962-1.7424-1.2912-2.508-3.2196-3.4398-5.0856-1.4202-2.673-3.7122-4.9074-6.34498-6.3684,0.6996,2.9982,1.2384,6.16859,3.0948,8.71617zm12.5784,9.16557c-0.47939,1.7076-0.8928,3.4008-0.8004,5.1858-1.482-1.5966-3.45-2.7984-5.2056-4.08479-2.391-1.93381-5.178-3.2976-7.1328-5.76,0.2916,3.62399,1.8426,6.57842,4.7874,8.78337,3.1128,2.32981,6.86699,3.58261,9.93303,6.02879-0.459-3.2958,0.7518-5.9364,1.7844-8.96577,0.86041-2.89499,0.0276-5.83439-1.93559-8.0406,0.0294,2.4456-0.74221,4.5456-1.43041,6.85317zm6.98578,11.133c0.64501,2.5002,2.4366,4.53419,3.66001,6.76441-3.29881-1.023-6.20938-2.8122-9.1914-4.4958-3.55201-1.9338-7.40882-3.165-10.6242-5.7186,1.6002,5.9244,5.5662,9.35877,11.3682,11.1102,3.9672,1.1982,7.31038,0.6006,12.1242,2.5458-0.552-3.2586-1.5246-6.77582-3.0654-9.71401-1.1958-2.12519-2.5218-4.22099-3.2604-6.5616-1.0698,1.9224-1.5762,3.8784-1.011,6.06962zm12.1386,9.0654c1.13581,1.94579,2.63521,3.5832,4.4946,4.875-4.68299,0.29819-8.45156-2.6694-13.017-2.7984-2.81999-0.0792-5.4972,0.7962-8.37301,0.5334,3.4128,2.3028,6.98578,4.3134,11.1408,4.85099,5.4012,0.69841,10.3824-0.66059,16.341-0.129-2.7846-1.96499-4.1778-4.5954-5.9136-7.42377-2.2602-3.5322-4.3932-6.0498-8.78938-6.61799,1.76459,1.9836,2.79179,4.4406,4.11659,6.70982zm16.6314,7.77299c-8.25002,1.4022-16.1556,3.2172-24.5814,3.3006,9.43139,3.288,18.318,3.8826,27.672,0.4878,5.055-1.8348,8.931-2.817,12.7488-2.5434,5.5794,0.4008,12.36,2.6022,19.8642,10.5168l2.9496-2.36041c-10.7554-9.58314-24.8278-11.753-38.6527-9.40237z'/%3E %3Cuse xlink:href='%23branch' transform='matrix(-1,0,0,1,378.03633,0)'/%3E %3Cg id='carp1'%3E %3Cpath d='m128.266,70.3392-12.981-7.96019,0-19.1352,12.981-7.96019,0-10.125,12.267-7.3872,9.80042,0,18.6474-10.4886,40.0332,0,18.648,10.4886,9.80042,0,12.267,7.3872,0,10.125,12.981,7.96019-0.0006,19.1352-12.9804,7.96019,0,10.125-12.267,7.3872-9.80042,0-18.648,10.4886-40.0332,0-18.6474-10.4886-9.80042,0-12.267-7.3872z'/%3E %3Cpath fill='%2328ae66' d='m169.068,7.73279-18.644,10.4873-9.74578,0-11.9704,7.20336,0,10.1165-12.9767,7.94494,0,18.644,12.9767,7.94494,0,10.1695,11.9174,7.20336,9.79875,0,18.644,10.4873,39.8305,0,18.644-10.4873,9.79874,0,11.9704-7.20336,0-10.1695,12.9767-7.94494,0-18.644-12.9767-7.94494,0-10.1165-11.9704-7.20336-9.79874,0-18.644-10.4873-39.8305,0zm1.11229,3.86653,37.6589,0,18.644,10.4873,9.74578,0,9.05717,5.45551,0,10.1165,13.0296,7.94494,0,14.4068-13.0296,7.94494,0,10.1165-9.05717,5.45551-9.74578,0-18.644,10.4873-37.6589,0-18.644-10.4873-9.74578,0-9.11014-5.45551,0-10.1165-12.9767-7.94494,0-14.4068,12.9767-7.94494,0-10.1165,9.11014-5.45551,9.74578,0,18.644-10.4873z'/%3E %3Cpath fill='%23faae29' d='m188.783,53.0252,0-41.0085-18.5058,0-18.6486,10.4886-9.72181,0-8.79479,5.2962,0,10.1004-12.9804,7.95959,0,6.73559,69.0807-0.00066,0,41.0095,18.5058,0,18.648-10.4886,9.72241,0,8.79419-5.2962,0-10.0998,12.981-7.96019,0-6.73559z'/%3E %3Cpath fill='%23fff' d='m120.131,53.0254-0.0006,6.73559,12.981,7.96019,0,10.0998,8.79419,5.2962,9.72241,0,18.648,10.4886,18.5064,0,0-41.0095,69.0807,0.000661,0-6.73559-12.981-7.95959,0-10.1004-8.79419-5.2962-9.72241,0-18.648-10.4886-18.5058,0,0,41.0085z'/%3E %3Cg id='carp1h'%3E %3Cg id='carp1q'%3E %3Cpath d='m148.448,26.2804-3.1956-2.9784-3.1662,1.9524,3.201,2.9844-4.11,2.5464,8.96877,0,7.72921,7.29062,2.47261-2.6112-7.515-7.08902,0-4.812z'/%3E %3Cpath d='m163.573,24.9719-3.1956-2.9784-3.1662,1.9524,3.201,2.9844-4.11,2.5464,8.96877,0,7.72922,7.29062,2.47259-2.6112-7.51499-7.08902,0-4.812z'/%3E %3Cpath d='m147.339,34.8358-3.1956-2.9784-3.1656,1.9524,3.2004,2.9844-4.1094,2.5464,8.96877,0,7.72861,7.29062,2.4726-2.6112-7.51499-7.08902,0-4.812z'/%3E %3Cpath d='m188.997,11.5889-8.09309,0-4.23481,4.0812-8.25542,0-6.1002,3.1662,1.4226,3.4662,5.44021-2.8572,2.38259,0,8.34119,9.6468,9.09717-5.5398z'/%3E %3Cpath fill='%23ca3745' d='m145.199,23.8378,2.8716,2.6766-2.406,1.4904-2.8758-2.6808,2.4102-1.4862zm7.20541,0.495,0,4.227,7.3374,6.92158-1.884,1.9896-7.54141-7.11418-7.63559,0,9.72361-6.02398z'/%3E %3Cpath fill='%23ca3745' d='m160.324,22.5293,2.8716,2.6766-2.406,1.4904-2.8752-2.6808,2.4096-1.4862zm7.2054,0.495,0,4.227,7.33741,6.92158-1.88399,1.9896-7.54142-7.11358-7.63559,0,9.72362-6.02458z'/%3E %3Cpath fill='%23ca3745' d='m144.091,32.3932,2.871,2.6766-2.406,1.4904-2.8752-2.6808,2.4102-1.4862zm7.2048,0.495,0,4.227,7.33741,6.92158-1.88341,1.9896-7.54142-7.11358-7.63618,0,9.72361-6.02458z'/%3E %3Cpath fill='%23ca3745' d='m188.783,12.0166-7.70603,0-4.23481,4.0812-8.32377,0-5.6604,2.9376,1.095,2.6688,5.1168-2.6868,2.68501,0,8.232,9.52081,8.79623-5.3562z'/%3E %3C/g%3E %3Cuse xlink:href='%23carp1q' transform='matrix(1,0,0,-1,0,105.62254)'/%3E %3Cpath d='m143.054,39.7108-3.8586-1.4418-0.0924,0.0642-4.98241,3.4572,0,0.929397-7.98,10.0914,7.98,10.0914,0,0.929998,5.07481,3.5208,3.8586-1.4418-2.355-1.5594,0-2.967,0.93599-1.1196,4.18141,0,0-14.9088-4.18141,0-0.93599-1.1196,0-2.967z'/%3E %3Cpath fill='%23ca3745' d='m134.549,42.0137,4.7064-3.2652,2.862,1.0692-1.8468,1.2228,0,3.3522,1.164,1.392,3.9528,0,0,14.0532-3.9528,0-1.164,1.392,0,3.3522,1.8468,1.2228-2.862,1.0692-4.7064-3.2652,0.0006-0.855-7.86302-9.94258,7.86302-9.94318z'/%3E %3C/g%3E %3Cuse xlink:href='%23carp1h' transform='matrix(-1,0,0,1,377.99368,0)'/%3E %3Cpath d='m136.203,61.2822-2.1726-1.8798v-0.906l-4.6608-5.685,4.66141-5.6856v-0.9054l2.17259-1.8798,3.90241,3.1734-2.25241-0.0174,3.32821,3.378,7.60502,0,5.9808-4.677,0-12.3342,14.9586,0,17.3724-10.6608,0-2.796-2.6568-1.7706-0.8418,0-2.8932,1.9362-0.4482,1.4442-2.2632-3.09,4.3986-3.6954,0.7032,0,4.9638-3.642,1.8714,0,4.9632,3.642,0.70381,0,4.3986,3.6954-2.2632,3.09-0.44821-1.4442-2.8932-1.9362-0.8418,0-2.65679,1.7706,0,2.796,17.3724,10.6608,14.9586,0,0,12.3342,5.9808,4.677,7.60502,0,3.3282-3.378-2.2524,0.0174,3.9024-3.1734,2.1726,1.8798,0,0.9054,4.6614,5.6856-4.6614,5.685,0,0.906-2.1726,1.8798-3.9024-3.1734,2.2524,0.0174-3.3282-3.3786-7.60502,0-5.9808,4.6776,0,12.3342-14.9586,0-17.3724,10.6608,0,2.796,2.65679,1.7706,0.8418,0,2.8932-1.9362,0.44821-1.4442,2.2632,3.0894-4.3986,3.696-0.70381,0-4.9632,3.642-1.8714,0-4.9638-3.642-0.7032,0-4.3992-3.696,2.2638-3.0894,0.4482,1.4442,2.8926,1.9362,0.8418,0,2.6574-1.7706,0-2.796-17.3724-10.6608-14.9586,0,0-12.3342-5.98141-4.6776-7.60441,0-3.32821,3.3786,2.25241-0.0174z'/%3E %3Cpath fill='%23faae29' d='m189.211,87.3189,1.9014,1.45379-1.9014,1.4538,0-2.9076zm-6.0438,2.6442,0.0702,0,4.9638,3.6426,0.5796,0,0-2.8416-2.604-1.9914,2.6046-1.9914,0-5.3376-18.5892-11.4078-13.7418,0,0-11.4624-7.09502-5.5488-10.7016,0-2.6898,3.0414-2.68979-3.0414-3.17581,0.0006,4.35961,5.3172,0,0.863402,1.72679,1.5,2.7744-2.16-1.62839,0.0126,0-0.54,3.62879-3.699,7.974,0,6.26223,4.8972,0,12.1146,14.6514,0,17.679,10.8492,0,3.264-2.95559,1.9698-1.1022,0-3.1266-2.0928-0.24061-0.776398-1.5246,2.0808,3.9732,3.3372,0.6174,0zm-47.2008-39.7602,2.11801,2.394-4.2366,0,2.11859-2.394zm52.8156-34.8072-1.9002,1.4538,1.9002,1.4532,0-2.907zm51.1272,37.6296,2.118,2.394,2.118-2.394-4.236,0zm-45.1542-37.3668-4.9638-3.642-0.5796,0,0,2.8404,2.6052,1.9926-2.6058,1.9926,0,5.3364,18.5892,11.4078,13.7418,0,0,11.4624,7.09502,5.5488,10.6998,0,2.69039-3.0408,2.69041,3.0402,3.1764,0-4.3596-5.3172,0-0.863402-1.7268-1.5-2.77441,2.16,1.62841-0.0132,0,0.5406-3.62881,3.6984-7.974,0-6.26162-4.8972,0-12.114-14.652,0-17.679-10.8492,0-3.2646,2.9556-1.9692,1.1022,0,3.1266,2.0928,0.2406,0.776399,1.5246-2.0808-3.9732-3.3378-0.6876,0z'/%3E %3Cpath fill='%23fff' d='m188.782,90.2262-1.9002-1.4532,1.9002-1.4532,0,2.9064zm-50.6976-37.2006-2.118,2.394-2.11801-2.394,4.23601,0zm56.7408,36.9378-0.0702,0-4.9638,3.6426-0.5796,0,0-0.744005,0-2.0964,2.6052-1.9926-2.6058-1.9926,0-5.3364,18.5892-11.4078,13.7418,0,0-11.4624,7.09503-5.5488,10.7004,0,2.6898,3.0414,2.6898-3.0414,3.177,0.000599-4.3596,5.3172,0,0.863402-1.7268,1.5-2.7744-2.16,1.6284,0.0126,0-0.54-3.6288-3.699-7.974,0-6.26163,4.8972,0,12.1146-14.652,0-17.679,10.8492,0,3.264,2.9556,1.9698,1.1022,0,3.1266-2.0928,0.2406-0.776399,1.5246,2.0808-3.9732,3.3372-0.6174,0zm47.202-39.7602-2.11799,2.394,4.2366,0-2.11861-2.394zm-58.7886-34.5444,4.96381-3.642,0.5802,0,0,2.8404-2.6058,1.9926,2.6058,1.9926,0.0006,5.3364-18.5898,11.4078-13.7412,0,0,11.4624-7.09562,5.5488-10.7028,0-2.6898-3.0408-2.6904,3.0402-3.174,0,4.3602-5.3172,0-0.863401,1.7268-1.5,2.7738,2.16-1.6284-0.0132,0,0.5406,3.6294,3.6984,7.9734,0,6.26223-4.8972,0-12.114,14.6514,0,17.6796-10.8492,0-3.2646-2.9556-1.9692-1.1028,0-3.1266,2.0928-0.2406,0.776399-1.524-2.0808,3.9732-3.3378,0.687,0zm5.97241,2.6448,1.9014-1.4538-1.9014-1.4538,0,2.9076z'/%3E %3Cpath fill='%2328ae66' d='m188.783,53.0252,0-28.3449-18.4686,11.334-13.4346,0,0,11.2428-6.82801,5.34,39.1602-0.00066,0,28.3453,18.4674-11.3334,13.4346,0,0-11.2428,6.82801-5.34z'/%3E %3Cpath fill='%23ca3745' d='m150.051,53.0254,6.82861,5.34,0,11.2428,13.434,0,18.4692,11.334,0-28.3459,39.159,0.000661-6.82801-5.34,0-11.2428-13.4346,0-18.4674-11.3334,0,28.3443z'/%3E %3Cpath d='m169.118,39.0635-3.195-2.9784-3.16621,1.9518,3.201,2.9844-4.11,2.5464,8.96877,0,7.72922,7.29122,2.4726-2.6118-7.515-7.08902,0-4.8114z'/%3E %3Cpath d='m208.873,66.5593,3.1956,2.9784,3.1656-1.9524-3.2004-2.9844,4.11-2.5458-8.96937,0-7.72861-7.29123-2.4726,2.6112,7.51499,7.08962,0,4.8114z'/%3E %3Cpath d='m169.118,66.5593-3.1956,2.9784-3.16561-1.9524,3.2004-2.9844-4.1094-2.5458,8.96877,0,7.72861-7.29123,2.47261,2.6112-7.515,7.08962,0,4.8114z'/%3E %3Cpath d='m208.873,39.0635,3.1956-2.9784,3.1656,1.9518-3.2004,2.9844,4.11,2.5464-8.96937,0-7.72861,7.29122-2.4726-2.6118,7.51499-7.08902,0-4.8114z'/%3E %3Cpath fill='%23ca3745' d='m212.122,69.0018-2.871-2.6766,2.406-1.4904,2.8752,2.6808-2.4102,1.4862zm-7.2048-0.495,0-4.2264-7.33741-6.92158,1.884-1.9902,7.54142,7.11418,7.63559,0-9.72362,6.02398zm-39.0468-31.8865,2.8716,2.6766-2.40659,1.491-2.87521-2.6808,2.4102-1.4868zm7.20541,0.4956,0,4.2264,7.33741,6.92158-1.884,1.9902-7.54142-7.11418-7.63559,0,9.72362-6.02398z'/%3E %3Cpath fill='%2328ae66' d='m212.122,36.6203-2.871,2.6766,2.406,1.491,2.8752-2.6808-2.4102-1.4868zm-7.2048,0.4956,0,4.2264-7.33741,6.92158,1.884,1.9902,7.54142-7.11418,7.63559,0-9.72362-6.02398zm-39.0468,31.8859,2.871-2.6766-2.40599-1.4904-2.87521,2.6808,2.4102,1.4862zm7.20481-0.495,0-4.2264,7.33741-6.92158-1.8834-1.9902-7.54142,7.11418-7.63619,0,9.72362,6.02398z'/%3E %3Cpath d='M208.856,52.8119,188.997,66.047,169.138,52.8119,188.997,39.5759z'/%3E %3Cpath fill='%23fff' d='m188.783,40.2328-18.5514,12.3642,37.5318,0-18.5514-12.3642,0,25.1568,18.552-12.3642-37.533,0,18.552,12.3642z'/%3E %3Cpath d='m194.308,57.3629,0,3.639-10.6206,0,0-3.639-6.87359,0,0-9.10318,6.87359,0,0-3.639,10.6206,0,0,3.639,6.87299,0,0,9.10318z'/%3E %3Cpath fill='%23ca3745' d='m184.116,45.0484,0,3.639-6.87299,0,0,3.9096,11.5404,0,0-7.54862-4.6674,0zm5.0964,7.54862,11.5404,0,0-3.9096-6.87299,0,0-3.639-4.6674,0,0,7.54862zm-11.9694,0.4284,0,3.9096,6.873,0,0,3.639,4.6674,0,0-7.54862-11.5404,0zm11.9694,7.54862,4.6674,0,0-3.639,6.873,0,0-3.9096-11.5404,0,0,7.54862z'/%3E %3C/g%3E %3Cg id='carp2'%3E %3Cpath d='m222.877,203.61,0-5.8302,15.9882,0,0-5.8302,15.9882,0,0-52.6812-15.9882,0,0-5.8302-15.9882,0,0-5.8302-15.9882,0,0-5.8302-35.7822,0,0,5.8302-15.9882,0,0,5.8302-15.9888,0,0,5.8302-15.9882,0,0,52.6812,15.9882,0,0,5.8302,15.9888,0,0,5.8302,15.9882,0,0,5.83019,35.7822,0,0-5.83019z'/%3E %3Cpath fill='%23ca3745' d='m171.558,122.193v5.8261h-15.9963v5.82644h-15.9956v5.8261h-15.9959v51.8539h15.9959v5.82712h15.9956v5.82543h15.9963v5.82542h34.9034v-5.82542h15.9966v-5.82543h15.9966v-5.82712h15.9949v-51.8539h-15.9949v-5.8261h-15.9966v-5.82644h-15.9966v-5.8261h-34.9034zm4.23729,4.23729h26.4288v5.8261h15.9966v5.82644h15.9966v5.8261h15.9949v43.3793h-15.9949v5.82712h-15.9966v5.82542h-15.9966v5.82542h-26.4288v-5.82542h-15.9963v-5.82542h-15.9956v-5.82712h-15.9959v-43.3793h15.9959v-5.8261h15.9956v-5.82644h15.9963v-5.8261z'/%3E %3Cpath fill='%23ca3745' d='m160.209,198.519,0-5.8308-15.9882,0,0-5.8296-15.9888,0,0-42.5004,15.9888,0,0-5.8302,15.9882,0,0-5.8302,15.9882,0,0-5.8296,25.6008,0,0,5.8296,15.9888,0,0,5.8302,15.9876,0,0,5.8302,15.9888,0,0,42.5004-15.9888,0,0,5.8296-15.9876,0,0,5.8308-15.9888,0,0,5.8296-25.6008,0,0-5.8296z'/%3E %3Cpath d='m163.921,137.014-4.1412-3.1302,0,6.0108-3.9654,2.52-0.0102-3.7626-3.8034,3.4164-3.8034-3.4164-0.0102,3.7626-4.3944-2.7924,0,5.5728-3.5514,2.571-0.01-3.417-4.2192,3.0558-4.2192-3.0558-0.01,3.417-3.97981-2.8812,0,16.8816-4.662,0,0,7.6842,4.662,0,0,16.8816,3.97981-2.8818,0.01,3.4176,4.2192-3.0558,4.2186,3.0558,0.0102-3.4176,3.5514,2.571,0,5.5734,4.3944-2.7924,0.0102,3.7626,3.8034-3.4164,3.8034,3.4164,0.0102-3.7626,3.9654,2.5194,0,6.0114,4.1412-3.1302,0.009,4.1982,4.0584-3.6294,4.059,3.6294,0.009-4.1982,3.7128,2.8062,0,6.411,5.5512-5.0598,0,5.946,7.6776-4.9362,7.6782,4.9362,0-5.946,5.5512,5.0598,0-6.411,3.7122-2.8062,0.009,4.1982,4.059-3.6294,4.059,3.6294,0.009-4.1982,4.14001,3.1302,0-6.0114,3.9666-2.5194,0.01,3.7626,3.804-3.4164,3.8034,3.4164,0.01-3.7626,4.395,2.7924,0-5.5734,3.5514-2.571,0.01,3.4176,4.2186-3.0558,4.2192,3.0558,0.01-3.4176,3.9798,2.8812,0-16.881,4.662,0,0-7.6842-4.662,0,0-16.8816-3.9798,2.8812-0.01-3.417-4.2192,3.0558-4.2192-3.0558-0.009,3.417-3.5514-2.571,0-5.5728-4.395,2.7924-0.01-3.7626-3.8034,3.4164-3.804-3.4164-0.01,3.7626-3.9666-2.5206,0-6.0102-4.14001,3.1296-0.009-4.1982-4.059,3.63-4.059-3.63-0.009,4.1988-3.7122-2.8074,0-6.4098-5.5512,5.0598,0-5.946-7.6782,4.9362-7.6776-4.9362,0,5.946-5.5512-5.0598,0,6.4104-3.7128,2.8068-0.009-4.1988-4.059,3.63-4.0584-3.63z'/%3E %3Cg fill='%2328ae66'%3E %3Cpath d='m132.21,148.604,0.01-3.4176,3.7926,2.7474,0.1278-0.093,3.6648-2.6544,0.01,3.4176,3.978-2.8794,0,39.768-3.978-2.8794-0.01,3.4176-3.7926-2.7474-3.7926,2.7474-0.01-3.4176-3.97801,2.8794,0-16.4706-4.662,0,0-6.8268,4.662,0,0-16.4706z'/%3E %3Cpath d='m164.356,133.772,3.6324,3.2484,3.6324-3.2484,0.009,4.1022,4.1388-3.129,0,61.7274-4.1388-3.129-0.009,4.1022-3.6324-3.2484-3.6324,3.2484-0.008-4.1022-4.1388,3.129,0-61.7274,4.1388,3.129z'/%3E %3Cpath d='m213.64,133.772-3.6324,3.2484-3.6324-3.2484-0.009,4.1022-4.1382-3.129,0,61.7274,4.1382-3.129,0.009,4.1022,3.6324-3.2484,3.6324,3.2484,0.009-4.1022,4.13881,3.129,0-61.7274-4.13881,3.129z'/%3E %3Cpath d='m245.786,148.604-0.01-3.4176-3.7926,2.7474-0.1284-0.093-3.6648-2.6544-0.01,3.4176-3.9774-2.8794,0,39.768,3.9774-2.8794,0.01,3.4176,3.7932-2.7474,3.7926,2.7474,0.01-3.4176,3.9774,2.8794,0-16.4706,4.662,0,0-6.8268-4.662,0,0-16.4706z'/%3E %3C/g%3E %3Cg fill='%23faae29'%3E %3Cpath d='m148.623,139.611,3.3774,3.0342,3.3774-3.0342,0.01,3.5832,4.3926-2.7918,0,50.4126-4.3926-2.7912-0.01,3.5826-3.3774-3.0336-3.3774,3.0336-0.01-3.5826-4.3926,2.7912,0-50.4126,4.3926,2.7918z'/%3E %3Cpath d='m181.748,133.827-5.5512-5.0598,0,73.6824,5.5512-5.0598,0,6.1314,7.2486-4.6602,0.0006,0,0.0006,0,7.2486,4.6602,0-6.1314,5.5512,5.0598,0-73.6824-5.5512,5.0598,0-6.1314-7.2486,4.6602-0.0006,0-0.0006,0-7.2486-4.6602z'/%3E %3Cpath d='m229.373,139.611-3.3774,3.0342-3.378-3.0342-0.009,3.5832-4.3932-2.7918,0,50.4126,4.3932-2.7912,0.009,3.5826,3.378-3.0336,3.3774,3.0336,0.01-3.5826,4.3926,2.7912,0-50.4126-4.3926,2.7918z'/%3E %3C/g%3E %3Cg id='carp2h'%3E %3Cg id='carp2q'%3E %3Cpath d='m134.288,158.366c0.4854,0.4896,1.0656,0.7374,1.7244,0.7374,0.6582,0,1.2384-0.2478,1.7244-0.7374,1.5186-1.53,1.5696-4.2972,1.5546-6.28859,0,0-1.7556,1.85521-2.0724,2.19-0.2208-0.38159-1.2066-2.08379-1.2066-2.08379s-0.9858,1.7022-1.2072,2.08379c-0.3168-0.33479-2.0724-2.19-2.0724-2.19-0.015,1.9914,0.0366,4.7586,1.5552,6.28859z'/%3E %3Cpath d='m150.966,154.08-1.2792-1.278,0-2.54639-2.9376,2.7228,5.2512,5.2512,5.2512-5.2512-2.9376-2.7228,0,2.54639-1.2786,1.278,0-4.5114,2.265-1.94459-3.3-2.8338-3.3,2.8338,2.2656,1.94459z'/%3E %3Cpath d='m166.953,149.02-1.2786-1.2786,0-2.5464-2.9376,2.7228,5.2512,5.2512,5.2512-5.2512-2.93761-2.7228,0,2.5464-1.2792,1.2786,0-4.512,2.26561-1.9446-3.3-2.8332-3.3,2.8332,2.265,1.9446z'/%3E %3Cpath fill='%23fff' d='m136.013,153.039c0.2622,0.4524,1.12319,1.9398,1.12319,1.9398s1.2132-1.2828,1.7088-1.8054c-0.0594,2.2488-0.5532,4.0254-1.41179,4.89-0.4026,0.4056-0.8802,0.6114-1.4202,0.6114-0.5406,0-1.01821-0.2058-1.4202-0.6108-0.85861-0.8652-1.35241-2.6418-1.41181-4.8906,0.495,0.5232,1.70821,1.8054,1.70821,1.8054,0.37439-0.6468,0.7494-1.2936,1.1238-1.9398z'/%3E %3Cpath fill='%23fff' d='m168.595,144.312,0,5.7432,2.136-2.1354,0-1.7424,1.8912,1.7532-4.6332,4.63319-4.6338-4.63319,1.8912-1.7532,0,1.7424,2.136,2.1354,0-5.7432-2.0358-1.7478,2.6424-2.2686,2.6418,2.2686z'/%3E %3Cpath fill='%23ca3745' d='m152.607,149.372,0,5.7432,2.136-2.136,0-1.7418,1.89119,1.7526-4.6338,4.6338-4.6332-4.6338,1.89121-1.7526,0,1.7418,2.13599,2.136,0-5.7432-2.0358-1.7478,2.6418-2.2686,2.6424,2.2686z'/%3E %3C/g%3E %3Cuse xlink:href='%23carp2q' transform='matrix(-1,0,0,1,377.9958,0)'/%3E %3Cpath d='m195.282,150.937-1.7202-2.3772,4.4112-4.0722-4.11301-3.37919,0,2.39399-1.72019,1.4718,0-4.34219,3.88559-2.86381-7.02902-5.181-7.02902,5.181,3.88621,2.86381,0,4.34219-1.72021-1.4718,0-2.39399-4.1136,3.37919,4.4118,4.0722-1.7202,2.3772z'/%3E %3Cpath fill='%23ca3745' d='m183.552,150.509,1.4508-2.0058-4.32901-3.996,3.03181-2.49119,0,1.68419,2.5776,2.2056,0-5.49-3.5922-2.6472,6.3066-4.64819,6.30661,4.64819-3.5916,2.6472,0,5.49,2.577-2.2056,0-1.68419,3.0324,2.49119-4.329,3.996,1.4514,2.0058z'/%3E %3Cpath d='m185.785,137.769,3.21181,2.367,3.21239-2.367-3.21239-2.3676-0.1272,0.0942z'/%3E %3Cpath fill='%2328ae66' d='m188.997,135.934c0.2124,0.156,2.1144,1.55819,2.49,1.83479-0.3756,0.2766-2.2776,1.6788-2.49,1.83481-0.2118-0.15601-2.1144-1.55821-2.4894-1.83481,0.375-0.2766,2.2776-1.67879,2.4894-1.83479z'/%3E %3C/g%3E %3Cuse xlink:href='%23carp2h' transform='matrix(1,0,0,-1,0,331.21644)'/%3E %3Cpath d='m245.902,163.15-7.0374,0,0-2.805-21.5106,0-14.9742-9.83579-0.0636,0-26.7012,0-14.9736,9.83579-21.5112,0,0,2.805-7.0374,0,0,4.9176,7.0374,0,0,2.805,21.5112,0,14.9736,9.8364,26.7648,0,14.9742-9.8364,21.5106,0,0-2.805,7.0374,0z'/%3E %3Cpath fill='%23ca3745' d='m175.742,150.953-14.9894,9.79873-21.1864,0,0,2.8072-7.04449,0,0,4.07839,7.04449,0,0,2.8072,21.1864,0,14.9894,9.8517,26.5359,0,14.9364-9.8517,21.2393,0,0-2.8072,7.04449,0,0-4.07839-7.04449,0,0-2.8072-21.2393,0-14.9364-9.79873zm0.31779,1.43008,25.8475,0,13.7182,9.00424,0,1.37712,15.3072,0,0,5.72034-15.3072,0,0,1.37712-13.7182,8.95127-25.8475,0-13.6652-8.95127,0-1.37712-15.3602,0,0-5.72034,15.3602,0,0-1.37712z'/%3E %3Cpath fill='%23ca3745' d='m201.799,152.826,13.3788,8.7834,0,1.5588,15.3318,0,0,4.8804-15.3318,0,0,1.5594-13.3788,8.7834-25.6044,0-13.3788-8.7834,0-1.5594-15.3318,0,0-4.8804,15.3318,0,0-1.5588,13.3788-8.7834z'/%3E %3Cg%3E %3Cpath d='m169.551,170.598,5.793,4.3488,3.8106-2.8614-2.2152-1.6632-1.5954,1.1982-1.362-1.0224,21.8154-16.3788-4.4304,0zm12.645,6.40077,4.4304,0,21.816-16.3788-5.79241-4.3482-3.81119,2.86079,2.21519,1.66261,1.596-1.1982,1.362,1.023zm9.17098,0,4.4298,0-21.8148-16.3788,1.362-1.023,1.5954,1.1982,2.2152-1.66261-3.8106-2.86079-5.793,4.3482zm12.645-6.40077-1.362,1.0224-1.596-1.1982-2.21519,1.6632,3.81119,2.8614,5.7924-4.3488-21.816-16.3788-4.4304,0z'/%3E %3Cpath d='m165.164,165.609,3.8934,2.586,3.89341-2.586-3.89341-2.586z'/%3E %3Cpath d='m185.104,165.609,3.8934,2.586,3.8934-2.586-3.8934-2.586z'/%3E %3Cpath d='m212.832,165.609-3.8934,2.586-3.8934-2.586,3.8934-2.586z'/%3E %3Cpath fill='%23faae29' d='m207.729,170.598-5.0784,3.81299-3.0978-2.32559,1.5018-1.1274,1.596,1.1982,2.0754-1.5582-21.2448-15.9498,3.003,0zm-13.2162,5.97179-3.0024,0-21.2448-15.9498,5.079-3.813,3.0966,2.32559-1.5012,1.12681-1.5954-1.1982-2.076,1.5588zm-8.0286,0-3.003,0,21.2448-15.9498-2.0754-1.5588-1.596,1.1982-1.5018-1.12681,3.0978-2.32559,5.0784,3.813zm5.0262-21.9216,3.0024,0-21.2442,15.9498,2.076,1.5582,1.5954-1.1982,1.5012,1.1274-3.0966,2.32559-5.07901-3.81299z'/%3E %3Cpath fill='%2328ae66' d='m169.057,163.538,3.1188,2.0712-3.1188,2.0712-3.1188-2.0712z'/%3E %3Cpath fill='%2328ae66' d='m188.998,163.538,3.1188,2.0712-3.1188,2.0712-3.1182-2.0712z'/%3E %3Cpath fill='%2328ae66' d='m208.939,163.538-3.1188,2.0712,3.1188,2.0712,3.1182-2.0712z'/%3E %3C/g%3E %3C/g%3E %3Cg id='carp3'%3E %3Cg%3E %3Cpath d='m120.514,274.151-1.5276,2.1606,2.7384,2.094-2.739,2.0946,1.5276,2.1606,3.1818,0.3696,3.081-2.3808,7.68181,4.8798,0-4.0524-4.8348-3.0714,4.8348-3.0708,0-4.0524-7.68181,4.8798-3.081-2.3802z'/%3E %3Cpath d='m120.514,260.073-1.5276,2.16119,2.7384,2.094-2.739,2.094,1.5276,2.1612,3.1818,0.369,3.081-2.3808,7.68181,4.8804,0-4.053-4.8348-3.0708,4.8348-3.07139,0-4.0524-7.68181,4.87979-3.081-2.38019z'/%3E %3Cpath d='m120.514,296.739-1.5276-2.1606,2.7384-2.094-2.739-2.0946,1.5276-2.1606,3.1818-0.369,3.081,2.3802,7.68181-4.8798,0,4.0524-4.8348,3.0714,4.8348,3.0708,0,4.0524-7.68181-4.8798-3.081,2.3808z'/%3E %3Cpath d='m257.482,274.151,1.5276,2.1606-2.7384,2.094,2.7384,2.0946-1.5276,2.1606-3.1812,0.3696-3.081-2.3808-7.6824,4.8798,0-4.0524,4.8354-3.0714-4.8354-3.0708,0-4.0524,7.6824,4.8798,3.081-2.3802z'/%3E %3Cpath d='m257.482,260.073,1.5276,2.16119-2.7384,2.094,2.7384,2.094-1.5276,2.1612-3.1812,0.369-3.081-2.3808-7.6824,4.8804,0-4.053,4.8354-3.0708-4.8354-3.07139,0-4.0524,7.6824,4.87979,3.081-2.38019z'/%3E %3Cpath d='m257.482,296.739,1.5276-2.1606-2.7384-2.094,2.7384-2.0946-1.5276-2.1606-3.1812-0.369-3.081,2.3802-7.6824-4.8798,0,4.0524,4.8354,3.0714-4.8354,3.0708,0,4.0524,7.6824-4.8798,3.081,2.3808z'/%3E %3Cpath d='m226.727,235.73,0,5.856,4.25941,0,0,2.5878,4.1844,0,0-4.7124h-3.73201v-3.7314h-4.7118z'/%3E %3Cpath d='m239.283,244.965,0,5.8554,4.25521,0,0,2.5884,4.1886,0,0-4.7124h-3.73141v-3.7314h-4.7124z'/%3E %3Cpath d='m151.269,235.73,0,5.856-4.2606,0,0,2.5878-4.18321,0,0-4.7124h3.73141v-3.7314h4.7124z'/%3E %3Cpath d='m226.727,321.083,0-5.856,4.25941,0,0-2.58779,4.1844,0,0,4.7118h-3.73201v3.73199h-4.7118z'/%3E %3Cpath d='m151.269,321.083,0-5.856-4.2606,0,0-2.58779-4.18321,0,0,4.7118h3.73141v3.73199h4.7124z'/%3E %3Cpath d='m239.283,311.848,0-5.85539,4.25521,0,0-2.5884,4.1886,0,0,4.7118h-3.73141v3.73199h-4.7124z'/%3E %3Cpath d='m138.714,244.965,0,5.8554-4.2564,0,0,2.5884-4.18741,0,0-4.7124h3.73141v-3.7314h4.7124z'/%3E %3Cpath d='m138.714,311.848,0-5.85539-4.2564,0,0-2.5884-4.18741,0,0,4.7118h3.73141v3.73199h4.7124z'/%3E %3Cpath d='m204.753,235.594c-0.27181-0.264-3.2508-3.156-3.2508-3.156l-3.19321,2.95861s2.502,2.42819,2.7834,2.70179l-3.5928,3.4878h5.33401l1.9194-1.8636,1.9194,1.8636h5.3334l-3.5928-3.4878c0.2814-0.2736,2.7828-2.70179,2.7828-2.70179l-3.1926-2.95861c-1.08481,1.05061-2.1672,2.10361-3.2502,3.156z'/%3E %3Cpath d='m188.998,235.594c-0.2712-0.264-3.2502-3.156-3.2502-3.156l-3.1932,2.95861s2.5014,2.42819,2.7834,2.70179l-3.5928,3.4878h5.3334l1.9194-1.8636,1.9194,1.8636h5.3334l-3.5922-3.4878c0.2814-0.2736,2.7828-2.70179,2.7828-2.70179l-3.1926-2.95861c-1.0848,1.05061-2.1672,2.10361-3.2508,3.156z'/%3E %3Cpath d='m173.244,235.594c0.2718-0.264,3.25079-3.156,3.25079-3.156l3.19321,2.95861s-2.502,2.42819-2.7834,2.70179l3.5928,3.4878h-5.33401l-1.91939-1.8636-1.91941,1.8636h-5.33339l3.59279-3.4878c-0.28139-0.2736-2.7834-2.70179-2.7834-2.70179l3.1932-2.95861c1.08481,1.05061,2.1672,2.10361,3.25021,3.156z'/%3E %3Cpath d='m204.753,321.219c-0.27181,0.2634-3.2508,3.1554-3.2508,3.1554l-3.19321-2.9586s2.502-2.4276,2.7834-2.7012l-3.5928-3.4878h5.33401l1.9194,1.8636,1.9194-1.8636h5.3334l-3.5928,3.4878c0.2814,0.2736,2.7828,2.7012,2.7828,2.7012l-3.1926,2.9586c-1.08481-1.0506-2.1672-2.1036-3.2502-3.1554z'/%3E %3Cpath d='m188.998,321.219c-0.2712,0.2634-3.2502,3.1554-3.2502,3.1554l-3.1932-2.9586s2.5014-2.4276,2.7834-2.7012l-3.5928-3.4878h5.3334l1.9194,1.8636,1.9194-1.8636h5.3334l-3.5922,3.4878c0.2814,0.2736,2.7828,2.7012,2.7828,2.7012l-3.1926,2.9586c-1.0848-1.0506-2.1672-2.1036-3.2508-3.1554z'/%3E %3Cpath d='m173.244,321.219c0.2718,0.2634,3.25079,3.1554,3.25079,3.1554l3.19321-2.9586s-2.502-2.4276-2.7834-2.7012l3.5928-3.4878h-5.33401l-1.91939,1.8636-1.91941-1.8636h-5.33339l3.59279,3.4878c-0.28139,0.2736-2.7834,2.7012-2.7834,2.7012l3.1932,2.9586c1.08481-1.0506,2.1672-2.1036,3.25021-3.1554z'/%3E %3C/g%3E %3Cg fill='%2328ae66'%3E %3Cpath d='m134.029,281.713,0,3.0366-7.27801-4.623-3.1806,2.4582-2.8182-0.327-1.1784-1.6674,2.856-2.184-2.856-2.184,1.179-1.6674,2.8176-0.327,3.1806,2.4576,7.27801-4.623,0,3.0366-5.2062,3.3072z'/%3E %3Cpath d='m134.029,267.635,0,3.0372-7.27801-4.623-3.1806,2.4576-2.8182-0.327-1.1784-1.6674,2.856-2.184-2.856-2.1834,1.179-1.66739,2.8176-0.3276,3.1806,2.45759,7.27801-4.62239,0,3.0366-5.2062,3.30659z'/%3E %3Cpath d='m134.029,289.178,0-3.0366-7.27801,4.623-3.1806-2.4582-2.8182,0.327-1.1784,1.6674,2.856,2.184-2.856,2.184,1.179,1.6674,2.8176,0.327,3.1806-2.4576,7.27801,4.623,0-3.0366-5.2062-3.3072z'/%3E %3Cpath d='m243.967,281.713,0,3.0366,7.278-4.623,3.18,2.4582,2.8182-0.327,1.1784-1.6674-2.856-2.184,2.856-2.184-1.1784-1.6674-2.8182-0.327-3.18,2.4576-7.278-4.623,0,3.0366,5.2056,3.3072z'/%3E %3Cpath d='m243.967,267.635,0,3.0372,7.278-4.623,3.18,2.4576,2.8182-0.327,1.1784-1.6674-2.856-2.184,2.856-2.1834-1.1784-1.66739-2.8182-0.3276-3.18,2.45759-7.278-4.62239,0,3.0366,5.2056,3.30659z'/%3E %3Cpath d='m243.967,289.178,0-3.0366,7.278,4.623,3.18-2.4582,2.8182,0.327,1.1784,1.6674-2.856,2.184,2.856,2.184-1.1784,1.6674-2.8182,0.327-3.18-2.4576-7.278,4.623,0-3.0366,5.2056-3.3072z'/%3E %3Cpath d='m231.011,236.159v3.732h3.73141v3.855h-3.32641v-2.5878h-4.26v-4.9992h3.855z'/%3E %3Cpath d='m243.566,245.393v3.7314h3.7314v3.8556h-3.327v-2.5878h-4.2594v-4.9992h3.855z'/%3E %3Cpath d='m146.985,236.159v3.732h-3.7314v3.855h3.327v-2.5878h4.2594v-4.9992h-3.855z'/%3E %3Cpath d='m231.011,320.653v-3.7314h3.73141v-3.855h-3.32641v2.58781h-4.26v4.99859h3.855z'/%3E %3Cpath d='m146.985,320.653v-3.7314h-3.732v-3.855h3.327v2.58781h4.26v4.99859h-3.855z'/%3E %3Cpath d='m243.566,311.419v-3.7314h3.7314v-3.855h-3.327v2.5878h-4.2594v4.9986h3.855z'/%3E %3Cpath d='m134.43,245.393v3.7314h-3.7314v3.8556h3.327v-2.5878h4.2594v-4.9992h-3.855z'/%3E %3Cpath d='m134.431,311.419v-3.7314h-3.732v-3.855h3.327v2.5878h4.26v4.9986h-3.855z'/%3E %3Cpath d='m201.496,233.029c0.26579,0.258,3.25739,3.162,3.25739,3.162s2.99101-2.904,3.25681-3.162c0.25199,0.2328,2.28539,2.1168,2.5638,2.3748-0.288,0.279-2.7762,2.6946-2.7762,2.6946l3.15119,3.0594h-4.1022l-2.0934-2.0328-2.094,2.0328h-4.1022l3.15121-3.0594s-2.48821-2.4156-2.77621-2.6946c0.2784-0.258,2.3118-2.142,2.56381-2.3748z'/%3E %3Cpath d='m185.741,233.029c0.2658,0.258,3.2568,3.162,3.2568,3.162s2.991-2.904,3.2574-3.162c0.252,0.2328,2.28481,2.1168,2.5632,2.3748-0.2874,0.279-2.7756,2.6946-2.7756,2.6946l3.1512,3.0594h-4.1028l-2.0934-2.0328-2.0934,2.0328h-4.1028l3.1512-3.0594s-2.4882-2.4156-2.7756-2.6946c0.2784-0.258,2.3118-2.142,2.5638-2.3748z'/%3E %3Cpath d='m176.502,233.029c-0.2664,0.258-3.2574,3.162-3.2574,3.162s-2.991-2.904-3.25681-3.162c-0.25199,0.2328-2.28539,2.1168-2.56379,2.3748,0.28799,0.279,2.7762,2.6946,2.7762,2.6946l-3.1512,3.0594h4.1022l2.0934-2.0328,2.094,2.0328h4.1022l-3.1512-3.0594s2.4882-2.4156,2.7762-2.6946c-0.2784-0.258-2.3118-2.142-2.5638-2.3748z'/%3E %3Cpath d='m201.496,323.784c0.26579-0.2586,3.25739-3.1626,3.25739-3.1626s2.99101,2.904,3.25681,3.1626c0.25199-0.2334,2.28539-2.1174,2.5638-2.3748-0.288-0.27959-2.7762-2.69459-2.7762-2.69459l3.15119-3.0594h-4.1022l-2.0934,2.03219-2.094-2.03219h-4.1022l3.15121,3.0594s-2.48821,2.415-2.77621,2.69459c0.2784,0.2574,2.3118,2.1414,2.56381,2.3748z'/%3E %3Cpath d='m185.741,323.784c0.2658-0.2586,3.2568-3.1626,3.2568-3.1626s2.991,2.904,3.2574,3.1626c0.252-0.2334,2.28481-2.1174,2.5632-2.3748-0.2874-0.27959-2.7756-2.69459-2.7756-2.69459l3.1512-3.0594h-4.1028l-2.0934,2.03219-2.0934-2.03219h-4.1028l3.1512,3.0594s-2.4882,2.415-2.7756,2.69459c0.2784,0.2574,2.3118,2.1414,2.5638,2.3748z'/%3E %3Cpath d='m176.502,323.784c-0.2664-0.2586-3.2574-3.1626-3.2574-3.1626s-2.991,2.904-3.25681,3.1626c-0.25199-0.2334-2.28539-2.1174-2.56379-2.3748,0.28799-0.27959,2.7762-2.69459,2.7762-2.69459l-3.1512-3.0594h4.1022l2.0934,2.03219,2.094-2.03219h4.1022l-3.1512,3.0594s2.4882,2.415,2.7762,2.69459c-0.2784,0.2574-2.3118,2.1414-2.5638,2.3748z'/%3E %3C/g%3E %3Cpath d='m146.58,306.421,0,9.234,84.8358,0,0-9.234,12.5508,0,0-56.0292-12.5508,0,0-9.234-84.8358,0,0,9.234-12.5508,0,0,56.0292z'/%3E %3Cpath fill='%23ca3745' d='m147.034,241.578v9.21695h-12.5529v55.1898h12.5529v9.21695h83.9509v-9.21695h12.554v-55.1903h-12.5542v-9.21695h-83.9509zm5.40254,3.54915h73.1467v8.89831l3.01864,2.22542h11.3881v44.3322h-11.4407l-2.9661,2.17119v8.95085h-73.1465v-8.89831l-3.01915-2.22373h-11.4407v-44.3322h11.3878l3.07203-2.22542v-8.89831z'/%3E %3Cpath fill='%23ca3745' d='m152.86,245.551v8.15763l11.017-8.15763h-11.017zm61.228,0,11.017,8.15763v-8.15763h-11.017zm-75.6348,11.1237v7.62712l10.3814-7.62712h-10.3806zm90.6788,0,10.4339,7.67966v-7.67966h-10.4339zm10.4339,35.7508-10.4339,7.7339h10.4339v-7.7339zm-101.113,0.0525v7.68135h10.3814l-10.3814-7.68135zm14.4068,10.6474v8.10339h10.9639l-10.9639-8.10339zm72.2449,0-10.9627,8.10339h10.9627v-8.10339z'/%3E %3Cpath fill='%2328ae66' d='m213.377,245.559c0.1128,0.0828,26.0154,19.2144,26.1876,19.3416v27.0102c-0.1722,0.1278-26.0748,19.2588-26.1876,19.3422h-48.7596c-0.11221-0.0834-26.0148-19.2144-26.187-19.3422v-27.0102c0.1722-0.1272,26.0748-19.2588,26.187-19.3416h48.7596z'/%3E %3Cpath d='m144.667,295.021-3.0108-3.4944,2.8266-3.2802-2.8266-3.2802,2.8266-3.2796-2.8266-3.2802,2.8266-3.2802-2.8266-3.2802,2.826-3.2802-2.826-3.2802,3.0108-3.4938,88.6614,0,3.0108,3.4938-2.8266,3.2802,2.8266,3.2802-2.8266,3.2802,2.8266,3.2802-2.8266,3.2802,2.8266,3.2796-2.8266,3.2802,2.8266,3.2802-3.0108,3.4944zm60.9456-45.2364-3.4944-3.0108-3.2808,2.8266-3.2796-2.8266-3.2802,2.8266-3.2802-2.8266-3.2802,2.8266-3.2802-2.8266-3.2796,2.8266-3.2802-2.8266-3.4944,3.0108,0,57.243,3.4944,3.0114,3.2802-2.8266,3.2796,2.826,3.2802-2.8266,3.2802,2.8266,3.2802-2.8266,3.2802,2.8266,3.2796-2.826,3.2808,2.8266,3.4944-3.0114z'/%3E %3Cg fill='%23faae29'%3E %3Cpath d='m198.623,249.981-3.0654-2.6418-3.066,2.6418,0,56.85,3.066,2.6412,3.0654-2.6412z'/%3E %3Cpath d='m185.503,249.981-3.066-2.6418-3.0654,2.6418,0,56.85,3.0654,2.6412,3.066-2.6412z'/%3E %3Cpath d='m144.863,294.593-2.6412-3.066,2.6412-3.066,88.269,0,2.6412,3.066-2.6412,3.066z'/%3E %3Cpath d='m233.132,275.34,2.6418,3.066-2.6418,3.0654-88.2678,0-2.6418-3.0654,2.6418-3.066z'/%3E %3Cpath d='m233.132,268.352,2.6412-3.066-2.6412-3.0654-88.269,0-2.6412,3.0654,2.6412,3.066z'/%3E %3C/g%3E %3Cg fill='%23ca3745'%3E %3Cpath d='m205.184,249.981-3.0654-2.6418-3.066,2.6418,0,56.85,3.066,2.6412,3.06462-2.64063z'/%3E %3Cpath d='m178.943,249.981-3.066-2.6418-3.066,2.6418,0,56.85,3.066,2.6412,3.066-2.6412z'/%3E %3Cpath d='m144.864,288.032-2.6418-3.066,2.6418-3.066,88.2678,0,2.6418,3.066-2.6418,3.066z'/%3E %3Cpath d='m144.864,274.912-2.6418-3.066,2.6418-3.066,88.2678,0,2.6418,3.066-2.6418,3.066z'/%3E %3Cpath d='m192.064,306.831-3.066,2.6412-3.066-2.6412,0-56.85,3.066-2.6418,3.066,2.6418z'/%3E %3C/g%3E %3Cpath d='m218.631,251.09-59.4804,0v4.7238h-7.60141v45.1848h7.60141v4.7232h59.6946v-4.7232h7.60141v-45.1848h-7.60141v-4.7238h-0.2142z'/%3E %3Cpath fill='%23ca3745' d='m159.587,251.535v4.71525h-7.62712v44.3322h7.62712v4.71356h6.25017l-12.4471-10.4339v-32.8932l12.4471-10.4339h-6.25017zm52.5963,0,12.3932,10.4339v32.8932l-12.3932,10.4339h6.24915v-4.71356h7.57458v-44.3322h-7.57458v-4.71525h-6.24915z'/%3E %3Cg fill='%2328ae66'%3E %3Cpath d='m166.525,251.535c-0.1176,0.099-12.5613,10.5202-12.7119,10.6462v32.4681c0.1506,0.12661,12.5943,10.5472,12.7119,10.6462h44.9681c0.11813-0.099,12.5083-10.5202,12.6589-10.6462v-32.4681c-0.15068-0.12594-12.5407-10.5472-12.6589-10.6462zm0.63559,1.80085,43.6441,0,11.5466,9.69279,0,30.7732-11.5466,9.63983-43.6441,0-11.4936-9.63983,0-30.7732z'/%3E %3Cpath d='m178.72,294.289,1.9536,0.8442,0.3594,2.2818-2.4594,2.16359,3.5724,3.4542-3.4374,0-2.4576-2.36579-2.4582,2.36579-3.4374,0,3.573-3.4542-2.46-2.16359,0.36-2.2818,1.953-0.8442,2.4696,1.9746,0.1338-0.10681z'/%3E %3Cpath d='m191.468,294.289,1.953,0.8442,0.36,2.2818-2.4594,2.16359,3.5724,3.4542-3.4374,0-2.4582-2.36579-2.4576,2.36579-3.438,0,3.573-3.4542-2.4594-2.16359,0.36-2.2818,1.953-0.8442,2.469,1.9746,0.1338-0.10681z'/%3E %3Cpath d='m199.277,294.289-1.953,0.8442-0.36,2.2818,2.4594,2.16359-3.5724,3.4542,3.4374,0,2.45821-2.36579,2.45759,2.36579,3.43741,0-3.57241-3.4542,2.4594-2.16359-0.36-2.2818-1.95299-0.8442-2.469,1.9746-0.1344-0.10681z'/%3E %3Cpath d='m178.72,262.523,1.9536-0.8442,0.3594-2.2812-2.4594-2.1636,3.5724-3.4542-3.4374,0-2.4576,2.3652-2.4582-2.3652-3.4374,0,3.573,3.4542-2.46,2.163,0.36,2.2818,1.953,0.8442,2.4696-1.974,0.1338,0.1068z'/%3E %3Cpath d='m191.468,262.523,1.953-0.8442,0.36-2.2812-2.4594-2.1636,3.5724-3.4542-3.4374,0-2.4582,2.3652-2.4576-2.3652-3.438,0,3.573,3.4542-2.4594,2.163,0.36,2.2818,1.953,0.8442,2.469-1.974,0.1338,0.1068z'/%3E %3Cpath d='m199.277,262.523-1.953-0.8442-0.36-2.2812,2.4594-2.1636-3.5724-3.4542,3.4374,0,2.45821,2.3652,2.45759-2.3652,3.43741,0-3.57241,3.4542,2.4594,2.163-0.36,2.2818-1.95299,0.8442-2.469-1.974-0.1344,0.1068z'/%3E %3Cpath d='m221.901,266.167-1.95,1.6146,1.95,1.614,0,2.6766-2.9988-2.4714s-2.0166,1.827-2.1522,1.95c-0.1728-0.0216-2.1156-0.2658-2.3076-0.2898-0.0858-0.1578-0.6924-1.2762-0.813-1.5,0.201-0.2004,1.986-1.9794,1.986-1.9794s-1.785-1.7796-1.986-1.98c0.1206-0.2238,0.7272-1.3428,0.813-1.5,0.192-0.024,2.1348-0.2688,2.3076-0.2904,0.1356,0.123,2.1522,1.9506,2.1522,1.9506l2.9988-2.4708v2.676z'/%3E %3Cpath d='m221.901,276.792-1.95,1.6146,1.95,1.6134,0,2.67719-2.9988-2.47139s-2.0166,1.827-2.1522,1.94999c-0.1728-0.0216-2.1156-0.26639-2.3076-0.28979-0.0858-0.15781-0.6924-1.27681-0.813-1.5,0.201-0.20041,1.986-1.9794,1.986-1.9794s-1.785-1.7802-1.986-1.9806c0.1206-0.2232,0.7272-1.3422,0.813-1.50001,0.192-0.0234,2.1348-0.26819,2.3076-0.28979,0.1356,0.12299,2.1522,1.95,2.1522,1.95l2.9988-2.47021v2.67601z'/%3E %3Cpath d='m221.901,290.646-1.95-1.61461,1.95-1.614,0-2.6766-2.9988,2.4714s-2.0166-1.8276-2.1522-1.9506c-0.1728,0.0216-2.1156,0.2664-2.3076,0.2898-0.0858,0.15781-0.6924,1.27681-0.813,1.5,0.201,0.20101,1.986,1.98,1.986,1.98s-1.785,1.7796-1.986,1.98c0.1206,0.2232,0.7272,1.3422,0.813,1.5,0.192,0.024,2.1348,0.26821,2.3076,0.2898,0.1356-0.12299,2.1522-1.94999,2.1522-1.94999l2.9988,2.47079v-2.67599z'/%3E %3Cpath d='m156.097,266.167,1.9494,1.6146-1.9494,1.614,0,2.6766,2.9988-2.4714s2.0166,1.827,2.1522,1.95c0.1722-0.0216,2.1156-0.2658,2.3076-0.2898,0.0858-0.1578,0.6918-1.2762,0.813-1.5-0.20099-0.2004-1.986-1.9794-1.986-1.9794s1.78501-1.7796,1.986-1.98c-0.1212-0.2238-0.7272-1.3428-0.813-1.5-0.192-0.024-2.1354-0.2688-2.3076-0.2904-0.1356,0.123-2.1522,1.9506-2.1522,1.9506l-2.9988-2.4708v2.676z'/%3E %3Cpath d='m156.097,276.792,1.9494,1.6146-1.9494,1.6134,0,2.67719,2.9988-2.47139s2.0166,1.827,2.1522,1.94999c0.1722-0.0216,2.1156-0.26639,2.3076-0.28979,0.0858-0.15781,0.6918-1.27681,0.813-1.5-0.20099-0.20041-1.986-1.9794-1.986-1.9794s1.78501-1.7802,1.986-1.9806c-0.1212-0.2232-0.7272-1.3422-0.813-1.50001-0.192-0.0234-2.1354-0.26819-2.3076-0.28979-0.1356,0.12299-2.1522,1.95-2.1522,1.95l-2.9988-2.47021v2.67601z'/%3E %3Cpath d='m156.097,290.646,1.9494-1.61461-1.9494-1.614,0-2.6766,2.9988,2.4714s2.0166-1.8276,2.1522-1.9506c0.1722,0.0216,2.1156,0.2664,2.3076,0.2898,0.0858,0.15781,0.6918,1.27681,0.813,1.5-0.20099,0.20101-1.986,1.98-1.986,1.98s1.78501,1.7796,1.986,1.98c-0.1212,0.2232-0.7272,1.3422-0.813,1.5-0.192,0.024-2.1354,0.26821-2.3076,0.2898-0.1356-0.12299-2.1522-1.94999-2.1522-1.94999l-2.9988,2.47079v-2.67599z'/%3E %3C/g%3E %3Cpath fill='%23ca3745' d='m167.32,253.761c-0.11581,0.097-10.6021,8.87607-11.0699,9.26907,0.94518,0.78343,1.85946,1.60292,2.8072,2.38348,0.23983-0.21695,2.0656-1.85424,2.0656-1.85424l2.70127,0.37076,1.05932,1.95975s-1.64758,1.64878-1.90678,1.90678c0.2592,0.2574,1.90678,1.90678,1.90678,1.90678l-1.05932,1.95974-2.70127,0.3178s-1.82568-1.58364-2.06568-1.80085l-2.9661,2.48941v0.84746c0.99787,0.82593,1.96469,1.66435,2.9661,2.4894,0.23999-0.21659,2.06568-1.80084,2.06568-1.80084l2.70127,0.31779,1.05932,1.95975s-1.64758,1.64878-1.90678,1.90678c0.2592,0.25741,1.90678,1.90678,1.90678,1.90678l-1.05932,2.01271-2.70127,0.3178s-1.82568-1.63661-2.06568-1.85382l-2.9661,2.48941v0.90042l2.9661,2.48941c0.23999-0.21659,2.06568-1.85381,2.06568-1.85381l2.70127,0.37076,1.05932,1.95975s-1.64758,1.64878-1.90678,1.90678c0.2592,0.258,1.90678,1.90678,1.90678,1.90678l-1.05932,1.95974-2.70127,0.37076s-1.82568-1.63661-2.06568-1.85381c-0.94385,0.77731-1.86544,1.55378-2.80721,2.33051,0.46785,0.39298,10.9541,9.17158,11.0699,9.26907h2.43644l3.54873-3.4428-2.27754-2.01271,0.42373-2.75424,2.38347-1.00635,2.43644,1.90678,2.38348-1.90678,2.38347,1.00635,0.4767,2.75424-2.33051,2.01271,3.44279,3.2839,3.4428-3.2839-2.33051-2.01271,0.42373-2.75424,2.43644-1.00635,2.38348,1.90678,2.43644-1.90678,2.38347,1.00635,0.42373,2.75424-2.27754,2.01271,3.38983,3.33687,3.4428-3.33687-2.27755-2.01271,0.42373-2.75424,2.43644-1.00635,2.38348,1.90678,2.38347-1.90678,2.43644,1.00635,0.42373,2.75424-2.27754,2.01271,3.54873,3.4428h2.38347c0.11577-0.0975,10.6015-8.87609,11.0699-9.26907-0.94351-0.77702-1.86222-1.55149-2.8072-2.33051-0.24,0.2172-2.01271,1.85381-2.01271,1.85381l-2.70128-0.37076-1.11228-1.95974s1.64818-1.64878,1.90678-1.90678c-0.2586-0.258-1.90678-1.90678-1.90678-1.90678l1.11228-1.95975,2.70128-0.37076s1.77271,1.63722,2.01271,1.85381l2.9661-2.48941v-0.90042l-2.9661-2.48941c-0.24,0.21721-2.01271,1.85382-2.01271,1.85382l-2.70128-0.3178-1.11228-2.01271s1.64818-1.64937,1.90678-1.90678c-0.2586-0.258-1.90678-1.90678-1.90678-1.90678l1.11228-1.95975,2.70128-0.31779s1.77271,1.58425,2.01271,1.80084c0.99454-0.81922,1.97379-1.62008,2.9661-2.43644v-0.95339l-2.9661-2.43644c-0.24,0.21721-2.01271,1.80085-2.01271,1.80085l-2.70128-0.3178-1.11228-1.95974s1.64818-1.64938,1.90678-1.90678c-0.2586-0.258-1.90678-1.90678-1.90678-1.90678l1.11228-1.95975,2.70128-0.37076s1.77271,1.63722,2.01271,1.85381c0.94925-0.78198,1.91118-1.54834,2.86017-2.33051-0.36468-0.30586-11.0065-9.22464-11.1229-9.32203h-2.38347l-3.54873,3.4428,2.27754,2.01271-0.42373,2.75424-2.43644,1.05932-2.38347-1.90678-2.38348,1.90678-2.43644-1.05932-0.42373-2.75424,2.27755-2.01271-3.38983-3.2839-3.4428,3.2839,2.27754,2.01271-0.42373,2.75424-2.38347,1.05932-2.43644-1.90678-2.38348,1.90678-2.43644-1.05932-0.42373-2.75424,2.33051-2.01271-3.4428-3.2839-3.44279,3.2839,2.33051,2.01271-0.4767,2.75424-2.38347,1.05932-2.38348-1.90678-2.43644,1.90678-2.38347-1.05932-0.42373-2.75424,2.27754-2.01271-3.6017-3.4428zm-11.2288,23.5698,0,2.17161,1.27119-1.11229z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m176.271,301.271-1.85424,1.74745h3.65424l-1.8-1.74745z'/%3E %3Cpath d='m188.983,301.271-1.8,1.74745h3.65423l-1.85423-1.74745z'/%3E %3Cpath d='m201.747,301.271-1.85254,1.74745h3.70678l-1.85424-1.74745z'/%3E %3Cpath d='m174.364,253.761,1.90678,1.8,1.85424-1.8h-3.76102z'/%3E %3Cpath d='m187.129,253.761,1.85424,1.8,1.90678-1.8h-3.76102z'/%3E %3Cpath d='m199.895,253.761,1.85254,1.8,1.85424-1.8h-3.70678z'/%3E %3Cpath d='m221.875,266.737-1.27119,1.05932,1.27119,1.00678v-2.0661z'/%3E %3Cpath d='m221.875,277.33-1.27119,1.05932,1.27119,1.05932v-2.11864z'/%3E %3Cpath d='m221.875,287.976-1.27119,1.05932,1.27119,1.05932v-2.11864z'/%3E %3Cpath d='m156.091,266.685v2.17119l1.27119-1.05932-1.27119-1.11187z'/%3E %3Cpath d='m156.091,277.33v2.17118l1.27119-1.11186-1.27119-1.05932z'/%3E %3Cpath d='m156.091,287.924v2.17118l1.27119-1.05932-1.27119-1.11186z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m199.901,274.857,0-3.7914-3.837,0,0-4.1562-14.1318,0,0,4.1562-3.837,0,0,3.7914-5.2992,0,0,7.098,5.2992,0,0,3.7908,3.837,0,0,4.1568,14.1318,0,0-4.1568,3.837,0,0-3.7908,5.2986,0,0-7.098z'/%3E %3Cpath fill='%23faae29' d='m188.783,267.338,0,4.2846-6.0744,3.453,0,3.1164-9.4842,0,0-2.9064,5.2986,0,0-3.7908,3.837,0,0-4.1568z'/%3E %3Cpath fill='%23faae29' d='m189.212,289.475,0-4.2846,6.0738-3.4536,0-3.1158,9.4848,0,0,2.9058-5.2986,0,0,3.7914-3.837,0,0,4.1568z'/%3E %3Cpath fill='%23fff' d='m195.286,278.192,0-3.1164-6.0738-3.453,0-4.2846,6.423,0,0,4.1568,3.837,0,0,3.7908,5.2986,0,0,2.9064z'/%3E %3Cpath fill='%23fff' d='m173.225,278.621,9.4842,0,0,3.1158,6.0744,3.4536,0,4.2846-6.423,0,0-4.1568-3.837,0,0-3.7914-5.2986,0z'/%3E %3Cpath fill='%23ca3745' d='m183.138,278.621,0,2.8884,5.6454,3.21,0-6.0984z'/%3E %3Cpath fill='%2328ae66' d='m188.783,272.094-5.6454,3.2094,0,2.8884,5.6454,0z'/%3E %3Cpath fill='%23ca3745' d='m194.858,278.192,0-2.8884-5.6454-3.2094,0,6.0978z'/%3E %3Cpath fill='%2328ae66' d='m189.212,284.719,5.6454-3.21,0-2.8884-5.6454,0z'/%3E %3C/g%3E %3C/g%3E %3Cg id='carp4'%3E %3Cpath d='m137.647,353.73,0,11.7168-11.1654,0,0,10.6272-11.3166,0,0,30.2586,11.3166,0,0,10.6272,11.1654,0,0,11.7168,40.5978,0,7.1394,4.29-3.4308,2.061-14.4762,0-1.2486-1.4082,13.119,0-3.696-3.7218-18.7662,0,8.5026,8.8518,17.598,0,6.0114-3.612,6.0114,3.612,17.5992,0,8.50201-8.8518-18.7656,0-3.6966,3.7218,13.1196,0-1.2492,1.4082-14.4768,0-3.4308-2.061,7.14-4.29,40.5978,0,0-11.7168,11.1654,0,0-10.6272,11.316,0,0-30.2586-11.316,0,0-10.6272-11.1654,0,0-11.7168-40.5978,0-7.14-4.2894,3.4308-2.0616,14.4768,0,1.2492,1.4082-13.1196,0,3.6966,3.7218,18.7656,0-8.50201-8.8518-17.5992,0-6.0114,3.612-6.0114-3.612-17.598,0-8.5026,8.8518,18.7662,0,3.696-3.7218-13.119,0,1.2486-1.4082,14.4762,0,3.4308,2.0616-7.1394,4.2894z'/%3E %3Cpath fill='%23ca3745' d='m199.629,428.23,40.3071,0,0-11.7055,11.1229,0,0-10.6462,11.3347,0,0-29.3963-11.3347,0,0-10.5932-11.1229,0,0-11.7055-40.3071,0-16.7373-10.1165-17.32,0-7.68009,7.99788,17.5848,0,2.86017-2.86017-13.0826,0,2.01272-2.27754,14.8305,0,18.9619,11.4407,34.6398,0,0,11.7055,11.1758,0,0,10.6462,11.3348,0,0,20.9746-11.3348,0,0,10.6462-11.1758,0,0,11.7055-34.6398,0-18.9619,11.3877-14.8305,0-2.01272-2.22458,13.0826,0-2.86017-2.86017-17.5848,0,7.68009,7.99788,17.32,0zm-22.7224-4.18432-34.6398,0,0-11.7055-11.1229,0,0-10.6462-11.3348,0,0-20.9746,11.3348,0,0-10.6462,11.1229,0,0-11.7055,34.6398,0,19.0149-11.4407,14.7776,0,2.01271,2.27754-13.0297,0,2.86017,2.86017,17.5847,0-7.68008-7.99788-17.32,0-16.7373,10.1165-40.3071,0,0,11.7055-11.1758,0,0,10.5932-11.3348,0,0,29.3963,11.3348,0,0,10.6462,11.1758,0,0,11.7055,40.3071,0,16.7373,10.1165,17.32,0,7.68008-7.99788-17.5847,0-2.86017,2.86017,13.0297,0-2.01271,2.22458-14.7776,0z'/%3E %3Cpath fill='%23faae29' d='m188.983,351.59-11.9703,7.20339-34.322,0,0,11.7055-11.1229,0,0,10.6462-11.3348,0,0,20.1271,11.3348,0,0,10.6462,11.1229,0,0,11.7055,34.322,0,11.9703,7.15042,11.9703-7.15042,34.322,0,0-11.7055,11.1758,0,0-10.6462,11.3348,0,0-20.1271-11.3348,0,0-10.6462-11.1758,0,0-11.7055-34.322,0zm0,2.9661,11.2818,6.77966,32.5212,0,0,11.7055,11.1758,0,0,10.5932,11.2818,0,0,15.0953-11.2818,0,0,10.6462-11.1758,0,0,11.7055-32.5212,0-11.2818,6.77966-11.2288-6.77966-32.5212,0,0-11.7055-11.1758,0,0-10.6462-11.3347,0,0-15.0953,11.3347,0,0-10.5932,11.1758,0,0-11.7055,32.5212,0z'/%3E %3Cpath fill='%2328ae66' d='m232.342,408.954,0,11.7168-32.2002,0-11.1444,6.69599-11.1444-6.69599-32.1996,0,0-11.7168-11.166,0,0-10.6278-11.316,0,0-14.2458,11.316,0,0-10.6278,11.166,0,0-11.7162,32.1402,0,0.0594,0,11.1444-6.696,11.1444,6.696,32.2002,0,0,11.7162,11.1654,0,0,10.6278,11.316,0,0,14.2458-11.316,0,0,10.6278z'/%3E %3Cg%3E %3Cpath d='m149.869,404.849,0,11.34,17.7,0-17.7-11.7396z'/%3E %3Cpath d='m149.869,377.558,0-11.3406,17.7,0-17.7,11.7396z'/%3E %3Cpath d='m228.127,404.849,0,11.34-17.7,0,17.7-11.7396z'/%3E %3Cpath d='m228.127,377.558,0-11.3406-17.7,0,17.7,11.7396z'/%3E %3Cpath fill='%23ca3745' d='m150.298,405.248,15.8496,10.5126-15.8496,0z'/%3E %3Cpath fill='%23ca3745' d='m150.298,377.159c0.6162-0.4092,14.7696-9.79679,15.8496-10.5126h-15.8496v10.5126z'/%3E %3Cpath fill='%23ca3745' d='m227.698,405.248c-0.6168,0.4092-14.7702,9.7962-15.8496,10.5126h15.8496v-10.5126z'/%3E %3Cpath fill='%23ca3745' d='m227.698,377.159c-0.6168-0.4086-14.7702-9.79619-15.8496-10.5126h15.8496v10.5126z'/%3E %3C/g%3E %3Cg id='carp4y'%3E %3Cpath d='m172.445,388.094,0-5.7912-1.9752,0-9.4764-5.925-0.1134,0.0714-9.3624,5.8536-1.9752,0,0,5.7912-4.455,0,0,6.2196,4.455,0,0,5.7906,1.9752,0,9.4758,5.925,9.4764-5.925,1.9752,0,0-5.7906,6.7818,0,0-6.2196z'/%3E %3Cpath fill='%23ca3745' d='m160.994,376.884,8.6682,5.4192-17.3352,0,8.667-5.4192zm8.667,23.2206-8.667,5.4192-8.6664-5.4192,17.3334,0z'/%3E %3Cpath fill='%23ca3745' d='m167.562,388.523,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cg fill='%23faae29'%3E %3Cpath d='m172.017,394.313,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cpath d='m160.78,394.313,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cpath d='m178.799,388.523,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cpath d='m156.325,388.523,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cpath d='m172.017,382.732,0,5.3622-10.809,0,0-5.3622z'/%3E %3Cpath d='m160.78,382.732,0,5.3622-10.809,0,0-5.3622z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m153.349,389.714,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m157.804,383.923,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m169.04,383.923,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m164.585,389.714,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m175.822,389.714,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m169.04,395.505,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m157.804,395.505,0,2.9796-4.8552,0,0-2.9796z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m152.891,390.171-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m157.346,384.38-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m168.583,384.38-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m164.128,390.171-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m175.365,390.171-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m168.583,395.962-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m157.346,395.962-3.9408,0,0,2.0652,3.9408,0z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23carp4y' transform='matrix(-1,0,0,1,377.99506,0)'/%3E %3Cg id='carp4r'%3E %3Cpath d='m200.449,378.42,0,5.7906-1.9752,0-9.4764,5.925-0.1134-0.0708-9.3624-5.8542-1.9752,0,0-5.7906-5.6184,0,0-6.2196,5.6184,0,0-5.79059,1.9752,0,9.4758-5.9256,9.4764,5.9256,1.9752,0,0,5.79059,5.6184,0,0,6.2196z'/%3E %3Cpath fill='%23faae29' d='m188.998,389.63,8.6676-5.4198-17.3346,0,8.667,5.4198zm8.667-23.2206-8.667-5.4198-8.6664,5.4198,17.3334,0z'/%3E %3Cg fill='%23ca3745'%3E %3Cpath d='m200.021,372.2,0-5.36219-10.809,0,0,5.36219z'/%3E %3Cpath d='m188.784,372.2,0-5.36219-10.809,0,0,5.36219z'/%3E %3Cpath d='m205.639,377.991,0-5.3628-10.809,0,0,5.3628z'/%3E %3Cpath d='m194.402,377.991,0-5.3628-10.809,0,0,5.3628z'/%3E %3Cpath d='m183.165,377.991,0-5.3628-10.8084,0,0,5.3628z'/%3E %3Cpath d='m200.021,383.782,0-5.3628-10.809,0,0,5.3628z'/%3E %3Cpath d='m188.784,383.782,0-5.3628-10.809,0,0,5.3628z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m185.807,368.029,0,2.97959-4.8552,0,0-2.97959z'/%3E %3Cpath d='m197.044,368.029,0,2.97959-4.8552,0,0-2.97959z'/%3E %3Cpath d='m180.188,373.82,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m191.426,373.82,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m202.663,373.82,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m185.807,379.611,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m197.044,379.611,0,2.9796-4.8552,0,0-2.9796z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m185.35,368.486-3.9408,0,0,2.06519,3.9408,0z'/%3E %3Cpath d='m196.587,368.486-3.9408,0,0,2.06519,3.9408,0z'/%3E %3Cpath d='m179.731,374.277-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m190.969,374.277-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m202.205,374.277-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m185.35,380.068-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m196.587,380.068-3.9408,0,0,2.0652,3.9408,0z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23carp4r' y='31.788122'/%3E %3C/g%3E %3Cg id='carp5'%3E %3Cpath d='m127.676,479.354,42.0516-22.6314,0.054,0,38.4852,0,42.0516,22.6314,0,37.29-42.0516,22.6308-38.5392,0-42.0516-22.6308z'/%3E %3Cpath fill='%2328ae66' d='m169.863,457.151-41.7376,22.4576v36.7576l41.7376,22.4576h38.2932l41.739-22.4576v-36.7576l-41.739-22.4576h-38.2932zm0.74067,3.01865h36.8118l39.5136,21.239v33.2102l-39.5136,21.239h-36.834l-39.5122-21.239v-33.2102z'/%3E %3Cpath fill='%23faae29' d='m189.212,497.784,0,37.6402,18.0954,0,39.183-21.087,0-16.1244-57.7068-0.00002,0-37.6398-18.0948,0-39.1836,21.0864,0,16.1244z'/%3E %3Cpath fill='%23fff' d='m188.783,497.784,0,37.6402-18.0948,0-39.1836-21.087,0-16.1244,57.7068-0.00002,0-37.6398,18.0954,0,39.183,21.0864,0,16.1244z'/%3E %3Cpath d='m192.514,533.317,0-10.8792-3.5172,2.2314-3.5178-2.2314,0,10.8792-10.9416,0,7.383-5.4144,0-7.7226-11.2596-7.1442-7.8678,0,0-30.0726,7.8678,0,11.2596-7.14419,0-7.7226-7.383-5.4144,0.6546,0,10.287,0,0,10.8798,3.5178-2.232,3.5172,2.232,0-10.8798,10.9422,0-7.3836,5.4144,0,7.7226,11.2596,7.14419,7.86781,0,0,30.0726-7.86781,0-11.2596,7.1442,0,7.7226,7.3836,5.4144z'/%3E %3Cpath fill='%23faae29' d='m192.956,463.135v11.2288l-3.76102-2.38305v3.17797l17.2136,10.9627h5.6678v11.6542h2.70169v-14.4067h-7.57457l-11.5458-7.31017v-8.15763l6.51356-4.7661h-9.21525zm-29.7144,35.0644v14.4068h7.52119l11.6,7.36102v8.15762l-6.51526,4.76611h9.21695v-11.2288l3.70678,2.38475v-3.28475l-17.2136-10.8576h-5.61491v-11.7051h-2.70119z'/%3E %3Cpath fill='%23fff' d='m175.847,463.135,6.51526,4.7661v8.15763l-11.6,7.31017h-7.52119v14.4068h2.70119v-11.6542h5.61491l17.2136-10.9102v-3.23051l-3.70678,2.38305v-11.2286h-9.21695zm36.2288,35.0644v11.7051h-5.6678l-17.2136,10.8576v3.28475l3.76102-2.38475v11.2288h9.21525l-6.51356-4.76611v-8.15762l11.5458-7.36102h7.57457v-14.4068h-2.70169z'/%3E %3Cpath fill='%23ca3745' d='m166.352,509.458,5.3376,0,17.3076,10.9806,17.307-10.9806,5.3382,0,0-22.9164-5.2758,0-0.0624,0-17.307-10.9806-17.3076,10.9806-5.3376,0z'/%3E %3Cpath d='m200.977,503.445,3.6954,0,0-1.7484-2.7798,0,0-3.1782,5.9412,0,0,8.1054-5.6958,0,0.0006,5.5296-11.7246,0,0-7.9452,5.16,0,0,3.1782-1.9986,0,0,1.5888,5.4018,0,0-3.0378-21.9612-13.383-3.6954,0,0,1.7478,2.7804,0,0,3.1782-5.9418,0,0-8.1048,5.6958,0,0-5.5296,0.2142,0,11.5098,0,0,7.9452-5.16,0,0-3.1782,1.9986,0,0-1.5888-5.4012,0,0,3.0378zm-1.9998-13.383,0-3.0378-5.4018,0,0,1.5888,1.9986,0,0,3.1782-5.16,0,0-7.9452,11.7246,0,0,5.5296,5.6952,0,0,8.1048-5.9412,0,0-3.1782,2.7804,0,0-1.7478-3.696,0-21.9606,13.383,0,3.0372,5.4012,0,0-1.5888-1.9986,0,0-3.1782,5.16,0,0,7.9458-11.724,0,0-5.5302-5.6958,0,0-8.1048,5.9418,0,0,3.1782-2.7804,0,0,1.7484,3.6954,0z'/%3E %3Cpath fill='%23fff' d='m199.406,505.697,0,3.7068-6.2592,0,0-2.4456,1.9992,0,0-2.3214-4.3032,0,0,7.0878,10.8672,0,0-5.5296,5.6958,0,0-7.2474-5.0844,0,0,2.3208,2.7798,0,0,2.6052-4.2438,0-22.2696-13.5708,0-3.7068,6.2592,0,0,2.4456-1.9986,0,0,2.3214,4.3026,0,0-7.0884-10.8672,0,0,5.5296-5.6952,0,0,7.248,5.0838,0,0-2.3214-2.7798,0,0-2.6052,4.2438,0zm1.4514-13.5714,4.2444,0,0,2.6052-2.7804,0,0,2.3214,5.0844,0,0-7.248-5.6952,0,0-5.5296-10.8672,0,0,7.0884,4.3026,0,0-2.3214-1.9986,0,0-2.4456,6.2586,0,0,3.7068-22.2696,13.5708-4.2438,0,0-2.6052,2.7798,0,0-2.3214-5.0838,0,0,7.248,5.6952,0,0,5.5296,10.8672,0,0-7.0884-4.3026,0,0,2.3214,1.9986,0,0,2.4456-6.2592,0,0-3.7068z'/%3E %3Cg%3E %3Cpath d='m238.042,499.884,0,11.7618-5.0052,0,0-4.1538-5.0454,0,0,4.1538-5.0052,0,0-11.7618,5.0052,0,0,4.1538,5.0454,0,0-4.1538z'/%3E %3Cpath d='m220.132,515.499,0,11.7618-5.0052,0,0-4.1538-5.0454,0,0,4.1538-5.0052,0,0-11.7618,5.0052,0,0,4.1544,5.0454,0,0-4.1544z'/%3E %3Cpath d='m238.042,496.113,0-11.7618-5.0052,0,0,4.15379-5.0454,0,0-4.15379-5.0052,0,0,11.7618,5.0052,0,0-4.1538,5.0454,0,0,4.1538z'/%3E %3Cpath d='m139.953,499.884,0,11.7618,5.0052,0,0-4.1538,5.04541,0,0,4.1538,5.00519,0,0-11.7618-5.00519,0,0,4.1538-5.04541,0,0-4.1538z'/%3E %3Cpath d='m139.953,496.113,0-11.7618,5.0052,0,0,4.15379,5.04541,0,0-4.15379,5.00519,0,0,11.7618-5.00519,0,0-4.1538-5.04541,0,0,4.1538z'/%3E %3Cpath d='m220.132,480.499,0-11.7618-5.0052,0,0,4.1538-5.0454,0,0-4.1538-5.0052,0,0,11.7618,5.0052,0,0-4.1538,5.0454,0,0,4.1538z'/%3E %3Cpath d='m157.864,515.499,0,11.7618,5.00521,0,0-4.1538,5.04539,0,0,4.1538,5.0052,0,0-11.7618-5.0052,0,0,4.1544-5.04539,0,0-4.1544z'/%3E %3Cpath d='m157.864,480.499,0-11.7618,5.00521,0,0,4.1538,5.04539,0,0-4.1538,5.0052,0,0,11.7618-5.0052,0,0-4.1538-5.04539,0,0,4.1538z'/%3E %3Cpath d='m223.118,472.256,0,8.93219,16.5972,0z'/%3E %3Cpath d='m154.877,523.742,0-8.9322-16.5972,0z'/%3E %3Cpath d='m154.877,472.256,0,8.93219-16.5972,0z'/%3E %3Cpath d='m223.118,523.742,0-8.9322,16.5972,0z'/%3E %3C/g%3E %3Cg fill='%23ca3745'%3E %3Cpath d='m233.465,507.064,0,4.1538,4.1484,0,0-10.9044-4.1484,0,0,4.1538-5.9028,0,0-4.1538-4.1478,0,0,10.9044,4.1478,0,0-4.1538z'/%3E %3Cpath d='m215.555,522.678,0,4.1538,4.1478,0,0-10.9044-4.1478,0,0,4.1538-5.90281,0,0-4.1538-4.1478,0,0,10.9044,4.1478,0,0-4.1538z'/%3E %3Cpath d='m233.465,488.934,0-4.1538,4.1484,0,0,10.9044-4.1484,0,0-4.1544-5.9028,0,0,4.1544-4.1478,0,0-10.9044,4.1478,0,0,4.1538z'/%3E %3Cpath d='m144.53,507.064,0,4.1538-4.1478,0,0-10.9044,4.1478,0,0,4.1538,5.9028,0,0-4.1538,4.1478,0,0,10.9044-4.1478,0,0-4.1538z'/%3E %3Cpath d='m144.53,488.934,0-4.1538-4.1478,0,0,10.9044,4.1478,0,0-4.1544,5.9028,0,0,4.1544,4.1478,0,0-10.9044-4.1478,0,0,4.1538z'/%3E %3Cpath d='m215.555,473.32,0-4.1544,4.1478,0,0,10.905-4.1478,0,0-4.15439-5.90281,0,0,4.15439-4.1478,0,0-10.905,4.1478,0,0,4.1544z'/%3E %3Cpath d='m162.44,522.678,0,4.1538-4.1478,0,0-10.9044,4.1478,0,0,4.1538,5.9028,0,0-4.1538,4.1484,0,0,10.9044-4.1484,0,0-4.1538z'/%3E %3Cpath d='m162.44,473.32,0-4.1544-4.1478,0,0,10.905,4.1478,0,0-4.15439,5.9028,0,0,4.15439,4.1484,0,0-10.905-4.1484,0,0,4.1544z'/%3E %3C/g%3E %3Cpath fill='%23faae29' d='m223.57,472.986v7.78644h14.461l-14.461-7.78644zm-83.58,42.2678,14.4597,7.78644v-7.78644h-14.4605z'/%3E %3Cpath fill='%23fff' d='m154.449,472.986-14.4597,7.78644h14.4597v-7.78644zm69.1203,42.2678v7.78644l14.461-7.78644h-14.461z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800' viewBox='-60 -40 120 80'%3E %3Cg fill='%23E70013'%3E %3Crect x='-60' y='-40' width='120' height='80'/%3E %3Ccircle fill='%23FFF' r='20'/%3E %3Ccircle r='15'/%3E %3Ccircle fill='%23FFF' cx='4' r='12'/%3E %3Cpath transform='translate(4)scale(9)rotate(-90)' d='M0,-1 L0.58779,0.80902 L-0.95106,-0.30902 L0.95106,-0.30902 L-0.58779,0.80902z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='960' height='480' viewBox='0 0 96 48'%3E %3Cg fill='%23C10000'%3E %3Crect width='96' height='48'/%3E %3Crect width='40' fill='%23fff' height='24'/%3E %3Crect x='17' y='3' width='6' height='18'/%3E %3Crect x='11' y='9' width='18' height='6'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800'%3E %3Crect width='1200' height='800' fill='%23E30A17'/%3E %3Ccircle cx='425' cy='400' r='200' style='fill:%23ffffff'/%3E %3Ccircle cx='475' cy='400' r='160' style='fill:%23E30A17'/%3E %3Cpolygon style='fill:%23ffffff' points='583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221'/%3E %3C/svg%3E"

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='480' viewBox='0 0 30 18'%3E %3Crect fill='%23CE1126' width='30' height='18'/%3E %3Cpolygon fill='%23FFF' points='0,0 20.824734,18 30,18 9.175266,0'/%3E %3Cpolygon points='1.52921,0 22.353945,18 28.470789,18 7.646055,0'/%3E %3C/svg%3E"

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Cdefs%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM0,300V400H300V0H600z'/%3E %3C/clipPath%3E %3Cpath id='star' fill='%23ffce00' d='M0,-50.0808 29.4368,40.5162 -47.6297,-15.4758H47.6297L-29.4368,40.5172z'/%3E %3Cuse id='rats' xlink:href='%23star' transform='rotate(36)'/%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%235b97b1'/%3E %3Cuse xlink:href='%23star' x='645.3396' y='540.9936'/%3E %3Cuse xlink:href='%23rats' x='788.0256' y='504.516'/%3E %3Cuse xlink:href='%23rats' x='788.0256' y='382.5324'/%3E %3Cuse xlink:href='%23rats' x='914.0304' y='473.6844'/%3E %3Cuse xlink:href='%23rats' x='914.0304' y='208.2708'/%3E %3Cuse xlink:href='%23star' x='996.4416' y='390.0456'/%3E %3Cuse xlink:href='%23rats' x='1019.928' y='172.0776'/%3E %3Cuse xlink:href='%23star' x='1102.836' y='321.5544'/%3E %3Cuse xlink:href='%23star' x='1102.836' y='87.486'/%3E %3C/svg%3E"

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg%3E %3Csvg width='900' height='600' viewBox='-60 -40 240 160' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Crect x='-60' y='-40' width='100%25' height='100%25' fill='%23fe0000'/%3E %3Crect x='-60' y='-40' width='50%25' height='50%25' fill='%23000095'/%3E %3Cpath id='four_rays' d='M 8,0 L 0,30 L -8,0 L 0,-30 M 0,8 L 30,0 L 0,-8 L -30,0' fill='%23fff'/%3E %3Cuse xlink:href='%23four_rays' transform='rotate(30)'/%3E %3Cuse xlink:href='%23four_rays' transform='rotate(60)'/%3E %3Ccircle r='17' fill='%23000095'/%3E %3Ccircle r='15' fill='%23fff'/%3E %3C/svg%3E"

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 72 48'%3E %3Cpath d='M0,48V0H72z' fill='%231eb53a'/%3E %3Cpath d='M0,48H72V0z' fill='%2300a3dd'/%3E %3Cpath d='M0,48 72,0' stroke='%23fcd116' stroke-width='19'/%3E %3Cpath d='M0,48 72,0' stroke='%23000' stroke-width='13'/%3E %3C/svg%3E"

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800'%3E %3Crect width='1200' height='800' fill='%23005BBB'/%3E %3Crect width='1200' height='400' y='400' fill='%23FFD500'/%3E %3C/svg%3E"

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600'/%3E %3Crect y='100' width='900' height='100' fill='%23fcdc04'/%3E %3Crect y='200' width='900' height='100' fill='%23d90000'/%3E %3Crect y='400' width='900' height='100' fill='%23fcdc04'/%3E %3Crect y='500' width='900' height='100' fill='%23d90000'/%3E %3Ccircle cx='450' cy='300' r='93.5' fill='%23fff'/%3E %3Cg stroke='%23000'%3E %3Cpath d='M 433.52031,228.39062 L 427.45593,217.22033 C 429.79607,214.8802 433.73312,213.07128 440.0095,213.07128 C 440.0095,213.49691 439.37106,225.30563 439.37106,225.30563 z' fill='%23d90000'/%3E %3Cpath d='M 439.37106,225.41204 L 440.22231,213.07128 C 440.22231,213.07128 452.77588,212.32724 459.5843,220.51813 C 459.6907,220.41173 452.88229,230.09231 452.88229,230.09231 z' fill='%23fcdc04'/%3E %3Cpath d='M 453.0951,229.98591 L 459.26508,220.41173 C 463.41413,224.7736 465.11583,227.85858 465.75427,232.53967 C 465.86068,232.64608 455.96728,234.98622 455.96728,234.87981 C 455.96728,234.7734 453.20151,230.09231 453.0951,229.98591 z' fill='%23d90000'/%3E %3Cpath d='M 436.60529,388.07318 C 436.60529,388.07318 448.2012,374.77476 470.75458,377.64774 C 467.35037,372.1154 456.3929,372.75384 456.3929,372.75384 C 456.3929,372.75384 452.9887,346.90266 455.64806,345.62578 C 458.30741,344.3489 469.5841,345.73219 469.5841,345.73219 C 471.07299,345.73219 473.62675,341.68954 471.60583,339.13659 C 469.5841,336.58282 463.62694,326.79583 466.07349,324.88051 C 468.52085,322.966 481.81845,325.94457 481.81845,325.94457 L 444.26496,277.85924 C 444.26496,277.85924 440.43513,259.77414 448.09479,251.0504 C 457.35057,243.39073 456.3929,235.09262 456.07368,235.19903 C 454.7968,226.79451 442.03123,220.73014 433.4139,228.49702 C 428.30718,234.667 431.71139,239.34808 431.71139,239.34808 C 431.71139,239.34808 418.30738,242.9651 417.77534,245.30524 C 417.24331,247.64619 432.88186,244.88043 432.88186,244.88043 L 431.39217,255.62508 C 431.39217,255.62508 400.96631,283.28436 424.26453,307.22103 C 424.47735,307.11462 425.00938,306.15696 425.00938,306.15696 C 425.00938,306.15696 433.20108,316.26399 441.8176,318.49772 C 449.9029,326.79583 449.15886,325.51895 449.15886,325.51895 C 449.15886,325.51895 450.75415,338.60455 449.26527,341.1575 C 447.24354,340.51906 426.60548,339.77503 423.51969,340.94469 C 420.75392,341.79595 410.11567,341.26391 412.77503,358.60498 C 414.79595,353.92389 416.60487,349.77483 416.60487,349.77483 C 416.60487,349.77483 416.28565,356.05121 418.83941,358.28576 C 418.41378,351.68935 421.28595,347.22188 421.28595,347.22188 C 421.28595,347.22188 421.81799,354.45592 423.41328,355.51918 C 425.00938,356.58325 425.00938,343.81686 433.83953,344.88093 C 442.66886,345.945 449.05246,345.62578 449.05246,345.62578 C 449.05246,345.62578 452.03104,370.6257 451.07337,372.96665 C 444.68977,371.47696 429.47766,373.60509 428.52,377.43493 C 437.45573,376.90289 441.6056,377.96615 441.6056,377.96615 C 441.6056,377.96615 434.37156,384.34975 436.60529,388.07318 z'/%3E %3Cpath d='M 440.19145,251.66041 C 440.19145,251.66041 418.05232,276.06251 427.60376,294.73569 C 428.11224,292.13157 427.89049,290.49566 428.20971,290.60207 C 427.67768,290.28285 430.95517,292.8488 430.7058,292.34925 C 430.77566,290.99927 429.70753,288.10598 429.70753,288.10598 C 430.7058,288.35534 431.70489,288.60552 432.70317,288.85488 C 432.12077,287.77295 431.53756,286.69182 430.95517,285.60988 C 432.37014,285.7764 433.78429,285.9421 435.19926,286.10861 C 435.19926,286.10861 433.70144,282.1147 434.20098,282.1147 C 434.69972,282.1147 437.69535,282.36407 437.69535,282.36407 C 431.39948,271.06545 437.33877,261.68215 440.19145,251.66041 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Cpath d='M 447.88198,230.73075 C 447.88198,230.73075 449.05246,239.13527 444.47777,241.58182 C 443.73293,242.11385 440.86075,243.07151 441.28638,244.77402 C 441.81841,247.11416 443.09448,246.68853 444.9034,246.2629 C 449.69008,245.41165 455.22243,235.19903 447.88198,230.73075 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Ccircle cx='438' cy='238' r='1.8' fill='%23fff' stroke='none'/%3E %3Cpath d='M 432.56264,244.98602 C 431.39217,245.94368 425.2222,252.32728 431.28576,254.66742 C 437.56295,252.96491 435.86044,251.79525 437.24373,250.41196 C 437.27947,247.53979 434.12301,246.79494 432.56264,244.98602 z' fill='%23d90000'/%3E %3Cpath d='M 445.96666,305.30652 C 445.64744,306.68981 444.26496,311.79571 446.17947,315.73195 C 451.499,313.49822 453.94555,314.13585 455.75446,315.30633 C 451.39341,311.79571 449.6909,310.30602 445.96666,305.30652 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Cpath d='M 455.11602,329.45519 L 455.43524,341.37032 C 455.43524,341.37032 459.5843,342.11517 461.49881,341.37032 C 463.41413,340.62547 461.3924,333.07221 455.11602,329.45519 z' fill='%23fff' stroke='%23fff'/%3E %3Cpath d='M 485.22266,330.94488 C 485.22266,330.94488 477.56299,312.43415 457.98819,307.75307 C 438.4134,303.07198 440.96635,282.22111 442.56245,280.94423 C 443.41371,279.13531 444.05215,276.36954 449.69008,279.02971 C 455.32883,281.68907 481.28642,294.77387 485.00985,295.41231 C 488.73327,296.05075 485.54188,331.37051 485.22266,330.94488 z' fill='%239ca69c'/%3E %3Cpath d='M 466.60552,307.64666 C 466.2863,307.85947 492.77592,323.2844 484.79703,336.58282 C 492.35111,331.58251 489.90375,322.85959 489.90375,322.85959 C 489.90375,322.85959 496.07372,338.92377 481.07361,346.79626 C 482.66971,348.17954 483.73378,347.85951 483.73378,347.85951 L 481.18001,350.41328 C 481.18001,350.41328 480.00954,352.32779 490.11656,347.43388 C 487.34999,349.66843 487.13798,351.26372 487.13798,351.26372 C 487.13798,351.26372 487.88202,353.39185 494.47843,347.6467 C 489.1589,353.39185 487.98843,356.37043 487.98843,356.26403 C 502.3501,354.98715 533.62722,308.2851 478.09503,294.45465 C 481.07442,297.54044 480.64798,297.11482 480.64798,297.11482 z' fill='%23d90000'/%3E %3Cpath d='M 467.776,303.07198 C 471.39302,305.62493 472.66909,306.47618 473.09472,307.75307 C 469.79692,307.00903 466.81834,307.22103 466.81834,307.22103 C 466.81834,307.22103 459.6907,300.41262 458.41382,299.88058 C 457.45616,299.88058 451.92463,296.36997 451.92463,296.36997 C 449.15886,294.98668 446.60591,285.4125 456.81853,288.17827 C 467.34956,293.17776 468.83926,293.6042 468.83926,293.6042 C 473.02405,294.91601 477.20803,296.22864 481.39283,297.54044 C 483.80444,300.23554 486.21525,302.93064 488.62687,305.62574 C 488.62687,305.62574 475.75489,299.24214 474.15879,299.13574 C 477.6694,302.00791 479.69113,305.94415 479.69113,305.94415 C 475.61274,304.77367 472.0672,303.71042 467.776,303.07198 z' fill='%23fff'/%3E %3Cpath d='M 417.66893,245.94368 C 417.66893,245.94368 430.00969,242.9651 431.49858,243.39073' stroke='%23fff'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1235' height='650' viewBox='0 0 7410 3900'%3E %3Crect width='7410' height='3900' fill='%23b22234'/%3E %3Cpath d='M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0' stroke='%23fff' stroke-width='300'/%3E %3Crect width='2964' height='2100' fill='%233c3b6e'/%3E %3Cg fill='%23fff'%3E %3Cg id='s18'%3E %3Cg id='s9'%3E %3Cg id='s5'%3E %3Cg id='s4'%3E %3Cpath id='s' d='M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z'/%3E %3Cuse xlink:href='%23s' y='420'/%3E %3Cuse xlink:href='%23s' y='840'/%3E %3Cuse xlink:href='%23s' y='1260'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='1680'/%3E %3C/g%3E %3Cuse xlink:href='%23s4' x='247' y='210'/%3E %3C/g%3E %3Cuse xlink:href='%23s9' x='494'/%3E %3C/g%3E %3Cuse xlink:href='%23s18' x='988'/%3E %3Cuse xlink:href='%23s9' x='1976'/%3E %3Cuse xlink:href='%23s5' x='2470'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='900' height='600' viewBox='-5 -5 27 18'%3E %3Ctitle%3EFlag of Uruguay%3C/title%3E %3Crect x='-5' y='-5' width='27' height='18' fill='%23fff'/%3E %3Cg fill='%230038a8'%3E %3Crect x='5' y='-3' width='17' height='2'/%3E %3Crect x='5' y='1' width='17' height='2'/%3E %3Crect x='-5' y='5' width='27' height='2'/%3E %3Crect x='-5' y='9' width='27' height='2'/%3E %3C/g%3E %3Cg transform='scale(0.11)' fill='%23fcd116' stroke='%23000' stroke-width='0.6' stroke-miterlimit='20'%3E %3Cg id='u'%3E %3Cg id='t'%3E %3Cg id='s'%3E %3Cg transform='rotate(22.5)'%3E %3Cpath d='M 1.5,9 6,12 C -2,25 7,27 0,33 3,26 -3,28 -3,16' stroke-linecap='square'/%3E %3Cpath d='M 0,11 C -2,24 4.5,28 0,33' fill='none'/%3E %3C/g%3E %3Cpath d='M 0,0 h 6 l -6,33 l -6,-33 h 6 v 33'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23u' transform='rotate(180)'/%3E %3Ccircle r='11'/%3E %3C/g%3E %3Cg transform='scale(0.011)'%3E %3Cg id='right'%3E %3Cpath d='M 81,-44 c -7,8 -11,-6 -36,-6 -25,0 -29,15 -33,12 -4,-3 21,-21 29,-22 8,-1 31,7 40,16 M 52,-35 c 7,6 1,19 -6,19 -7,0 -20,-12 -14,-20'/%3E %3Cpath d=' M 19,-26 c 1,-12 11,-14 27,-14 16,0 23,12 29,15 -7,0 -13,-10 -29,-10 -16,0 -16,0 -27,10 M 22,-23 c 4,-6 9,6 20,6 11,0 17,-3 24,-8 7,-5 -10,12 -21,12 -11,0 -26,-6 -23,-10'/%3E %3Cpath d='M 56,-17 c 13,-7 5,-17 0,-19 2,2 10,12 0,19 M 0,43 c 6,0 8,-2 16,-2 8,0 27,11 38,7 -23,9 -14,3 -54,3 h -5 M 58,57 c -4,-7 -3,-5 -11,-16 8,6 10,9 11,16 M 0,67 C 25,67 21,62 54,48 30,51 25,59 0,59 h -5 M 0,30 c 7,0 9,-5 17,-5 8,0 19,3 24,7 1,1 -3,-8 -11,-9 C 22,22 25,9 16,7 c 0,4 3,3 4,9 0,5 -9,5 -11,0 2,8 -4,8 -9,8'/%3E %3C/g%3E %3Cuse xlink:href='%23right' transform='scale(-1,1)'/%3E %3Cpath d='M 0,76 c -5,0 -18,3 0,3 18,0 5,-3 0,-3'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='500' height='250'%3E %3Crect width='500' height='250' fill='%231eb53a'/%3E %3Crect width='500' height='125' fill='%230099b5'/%3E %3Crect width='500' height='90' y='80' fill='%23ce1126'/%3E %3Crect width='500' height='80' y='85' fill='%23fff'/%3E %3Ccircle cx='70' cy='40' r='30' fill='%23fff'/%3E %3Ccircle cx='80' cy='40' r='30' fill='%230099b5'/%3E %3Cg fill='%23fff' transform='translate(136,64)'%3E %3Cg id='s3'%3E %3Cg id='s'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath id='o' d='M0,-6V0H3' transform='rotate(18,0,-6)'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='-24'/%3E %3Cuse xlink:href='%23s' y='-48'/%3E %3C/g%3E %3Cuse xlink:href='%23s3' x='24'/%3E %3Cuse xlink:href='%23s3' x='48'/%3E %3Cuse xlink:href='%23s' x='-48'/%3E %3Cuse xlink:href='%23s' x='-24'/%3E %3Cuse xlink:href='%23s' x='-24' y='-24'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='500' height='500' viewBox='0 0 2500 2500'%3E %3Ctitle%3EFlag of Vatican City%3C/title%3E %3Crect width='2500' height='2500' fill='%23fff'/%3E %3Crect width='1250' height='2500' fill='%23ffe000'/%3E %3Cg id='coa' stroke='%23000' stroke-width='3.205' stroke-linejoin='round'%3E %3Cg id='tiara' fill='%23ce9d09' stroke-linecap='round'%3E %3Cg id='band'%3E %3Cpath fill='%23fff' d='m1781.07 990.292l16.1062 3.84122 25.6631 4.16908 11.7604 1.2926-2.0767 49.9158s-2.8084 33.1782-7.6882 48.9616c-3.6176 11.701-15.781 33.1806-15.781 33.1806l-7.6882 11.7346-45.3199-39.2502s7.7255-10.947 10.5207-16.995c3.5074-7.5891 7.6882-23.8739 7.6882-23.8739l4.451-25.897 2.4279-32.776zm-56.9911 151.477l41.2735 36.0131s-8.3454 7.4281-13.3532 9.7114c-9.8241 4.4794-20.7674 7.5168-31.5621 7.2836-7.7283-0.167-15.3195-2.9727-22.3505-6.1856-15.7215-7.1841-33.0314-14.7311-43.1678-28.7322-3.5868-4.9543-5.0026-11.5703-4.8894-17.6856 0.1281-6.9328 6.2807-19.8312 6.2807-19.8312s2.3909 8.636 5.1333 12.0223c4.513 5.5725 11.1176 9.3021 17.5966 12.3749 4.8475 2.2989 10.1441 4.0219 15.4999 4.336 6.9511 0.4078 14.1627-0.6737 20.6367-3.2371 3.3392-1.3222 8.9021-6.0696 8.9021-6.0696z'/%3E %3Cpath fill='%23fff' d='m1658.65 877.67s3.2943 6.60021 4.297 10.1276c1.7151 6.03329 2.9083 12.326 2.8613 18.5981-0.047 6.28734-1.4684 12.5389-3.1474 18.5982-2.5161 9.0802-6.3199 17.7833-10.3005 26.3235-2.5243 5.41581-6.054 10.3236-8.5837 15.7369-4.0792 8.72864-6.9937 17.956-10.5867 26.8957-2.9986 7.46093-6.8645 14.6102-9.156 22.3178-3.0437 10.2378-4.5617 20.8914-6.0086 31.4738-1.2447 9.103-2.2289 18.2805-2.289 27.468-0.071 10.8993 0.257 21.9099 2.289 32.6182 2.0132 10.6096 4.9766 21.2042 9.7283 30.9015 3.8299 7.8163 8.9314 15.1035 14.8784 21.4595 4.9155 5.2533 10.7063 9.7565 16.8814 13.4478 5.6111 3.3542 11.951 5.3107 18.0259 7.7254 8.392 3.3358 25.4328 9.3354 25.4328 9.3354s-23.527-11.5926-31.7275-21.3526c-6.7839-8.0741-10.5208-18.6192-12.8756-28.8986-2.7273-11.9056-2.3831-24.473-1.1445-36.6239 1.3326-13.0719 5.1794-25.8174 9.156-38.3408 4.1968-13.2172 10.0958-25.835 15.4508-38.6268 3.8591-9.2188 8.276-18.2009 12.0172-27.4681 4.4171-10.9412 8.7643-21.9345 12.3034-33.1905 2.1584-6.86471 4.8495-13.7214 5.4303-20.894 0.6311-7.79253-0.3834-15.7424-2.1702-23.3535-2.5031-10.6626-5.5983-21.6488-11.8358-30.6517-3.7541-5.41848-8.8987-10.1529-14.7694-13.1509-5.7326-2.92745-12.5435-5.40098-18.8584-4.1538-2.1092 0.41656-5.2985 3.6779-5.2985 3.6779z'/%3E %3Cpath fill='%23fff' d='m1711.59 945.594s4.4543-17.9908 5.2084-27.1872c0.6452-7.8667 0.2242-15.8223-0.6069-23.6716-0.9248-8.73396-1.4686-17.7937-4.8557-25.897-3.5136-8.40592-9.0243-16.1296-15.5787-22.4577-6.46-6.23687-14.2939-11.3052-22.6599-14.5671-8.8012-3.43152-18.4915-4.27873-27.9203-4.8557-8.0878-0.49492-16.2402 0.19161-24.2785 1.21393-4.6447 0.59072-9.3229 1.33124-13.7578 2.8325-4.1142 1.39268-11.7346 5.66498-11.7346 5.66498l29.9434 48.9616s9.3726-5.51792 14.5671-6.8789c5.494-1.43944 11.3253-1.54575 16.995-1.21393 5.757 0.33691 11.7257 0.89368 16.9949 3.23714 6.7067 2.98278 12.4901 7.98381 17.5468 13.3041 6.1021 6.41995 11.5485 13.7867 14.9589 21.9611 3.1668 7.59027 3.5823 16.072 4.7213 24.2172 0.2473 1.76811 0.4565 5.33646 0.4565 5.33646z'/%3E %3Cpath d='m1717.05 906.676s-5.3336-16.5594-10.3697-23.474c-5.8495-8.03107-13.3653-15.3911-22.2554-19.8275-9.4283-4.70495-30.9939-6.21691-30.9939-6.21691l11.4135 21.1281-19.9659-0.48705-10.4269-17.4343-19.2319 8.7057-9.5679-15.6448 20.4311-9.47347-9.4144-15.1852 20.4231-1.9427 8.8924 14.7s15.8737 0.0481 23.5878 1.66764c5.2383 1.09979 10.3852 2.90955 15.1204 5.40504 4.5315 2.38821 8.6981 5.52167 12.4464 9.01294 4.5081 4.199 8.7319 8.8641 11.8742 14.1632 3.0537 5.14968 6.5418 16.7274 6.5418 16.7274z'/%3E %3Cpath d='m1581.65 845.092l31.8993 46.5923m-17.9701-54.7363l-15.0315 8.78851-14.3063 10.8728 30.9015 47.2106 13.734-10.5866 14.1198-8.18363z'/%3E %3Cpath d='m1653.79 1035.87l17.8828-36.9101 19.1392 7.6135 7.7552-19.059-19.026-8.86935 9.8713-21.3164-14.0201-6.29475-10.5867 20.4578-19.1933-8.02412-8.4281 19.9631 18.6084 7.80376-17.1675 36.6241z'/%3E %3Cpath d='m1796.92 1024.83l18.2088-0.4047v21.0414l17.5333 0.8317-2.9826 21.3575-16.3572-1.0293s-2.6981 12.5748-5.1215 18.4951c-2.5132 6.1396-9.6623 17.3995-9.6623 17.3995l-19.4228-4.8557s7.0265-11.0483 9.7114-16.995c2.4047-5.3259 5.665-16.5903 5.665-16.5903l-19.9387-2.5165 3.4705-20.1921 18.0868 1.2625z'/%3E %3C/g%3E %3Cuse xlink:href='%23band' transform='matrix(-1,0,0,1,3717.75,0)'/%3E %3Cpath fill='%23fff' d='m1756.66 735.602l-27.4199 29.4458 16.8814 50.9303 9.6654 35.7948-27.723 25.8264 50.7288 71.0499-17.3653 19.8177c-1.8179 2.32887-2.4559 5.66203-2.1441 8.59991 0.2858 2.69342 1.5814 5.46434 3.5766 7.29618 4.5597 4.18658 11.3282 5.13314 17.3106 6.72397 21.0652 5.60173 42.9277 8.10234 64.6643 9.72824 4.6678 0.3492 14.0426 0 14.0426 0s9.3574 0.3505 14.0426 0c21.7366-1.62587 43.5991-4.12651 64.6643-9.72824 5.9824-1.59083 12.7509-2.53739 17.3106-6.72397 1.9952-1.83184 3.2908-4.60276 3.5766-7.29618 0.3118-2.93788-0.3262-6.27104-2.1441-8.59991l-16.3019-35.876 51.819-55.5208-19.7758-17.8337-0.4354-43.2583 16.8814-50.9303-25.4118-25.7241-22.9434-61.258s-4.8005-17.0806-8.8699-24.8929c-2.433-4.67074-5.832-8.79081-9.156-12.8757-3.9828-4.89437-8.0012-9.86994-12.8757-13.8771-4.4164-3.63059-9.5357-6.34555-14.5924-9.01295-5.4329-2.86583-10.8919-5.95625-16.8444-7.47197-6.1395-1.56334-18.9437-1.54098-18.9437-1.54098s-12.7871-0.026-18.9437 1.54098c-5.9526 1.51506-11.4115 4.60614-16.8444 7.47197-5.0567 2.6674-10.176 5.38236-14.5924 9.01295-4.8745 4.00714-8.8929 8.98271-12.8757 13.8771-3.324 4.08485-6.723 8.20492-9.156 12.8757-4.0694 7.81233-8.8699 24.8929-8.8699 24.8929z'/%3E %3Cpath d='m1963.27 933.128s-3.1773-2.84544-4.9603-3.99962c-3.7472-2.4257-7.7685-4.47267-11.9369-6.06964-5.6064-2.14787-11.5532-3.28842-17.3997-4.65339-6.6974-1.56366-13.4146-3.13944-20.2321-4.04642-7.9733-1.06074-16.0331-1.53775-24.0762-1.61857-8.6068-0.0865-25.7932 1.21392-25.7932 1.21392s-17.1689-1.30099-25.7932-1.21392c-8.0431 0.0812-16.1029 0.55783-24.0762 1.61857-6.8175 0.90698-13.5347 2.48276-20.2321 4.04642-5.8465 1.36497-11.7933 2.50552-17.3997 4.65339-4.1684 1.59697-8.1897 3.64394-11.9369 6.06964-1.783 1.15418-4.9603 3.99962-4.9603 3.99962m218.711-42.6925s-5.1828-5.26865-8.6021-5.91895c-2.2098-0.42027-4.7416 0.21473-6.5754 1.51741-2.372 1.68499-3.9554 4.56016-4.6534 7.38473-0.6248 2.52827-0.3529 5.36837 0.6069 7.78937 0.8132 2.05124 2.0996 4.33782 4.1476 5.15919 4.8004 1.92528 15.3837-2.02435 15.3837-2.02435zm5.1557-3.59224c5.8013 0.17064 7.9138 3.10789 9.4541 6.47428m-243.23-2.882l-0.3074 13.9074s10.5833 3.94958 15.3837 2.02435c2.048-0.82135 3.3344-3.10795 4.1476-5.15919 0.9598-2.421 1.2317-5.2611 0.6069-7.78937-0.698-2.82457-2.2814-5.69974-4.6534-7.38473-1.8338-1.30268-4.3681-1.95069-6.5754-1.51741-3.4449 0.67621-8.602 5.91895-8.602 5.91895zm-5.1558-3.59224c-5.8013 0.17064-7.9138 3.10789-9.4541 6.47428m198.167 1.34599l-8.4468-0.94606m-130.044 0.94606l8.4468-0.94606m75.9916 0.81471c-2.8651-0.42255-7.6006-4.2094-7.6006-4.2094m-22.7856 4.2094c2.8651-0.42255 7.6006-4.2094 7.6006-4.2094m140.936-19.3466s-4.2156 3.34715-7.2851 3.85745l-1.211 0.6445s-1.9472 5.72805-3.6621 8.17385c-1.7189 2.45145-6.4648 6.25-6.4648 6.25s-4.787-4.14415-7.7442-4.9512c-1.9395-0.52925-4.1634-0.54345-6.0253 0.21485-1.9759 0.8047-3.5479 2.53495-4.7364 4.30665-1.4037 2.09245-2.7058 4.58275-2.5879 7.0996 0.1411 3.01385 3.877 8.1836 3.877 8.1836l-2.5781 4.51175-3.6621 2.373c-6.3145-1.9131-12.631-3.93545-18.9454-7.53905-1.7321-1.88775-3.3581-4.30185-4.5214-9.0332 0 0 4.5436-2.69345 5.5957-4.95115 1.1824-2.5374 1.6683-6.00595 0.2148-8.39845-1.6161-2.66045-5.2762-4.0421-8.3887-4.0918-2.2801-0.0364-4.6888 1.14055-6.25 2.80275-1.6788 1.7875-2.9748 4.46475-2.5781 6.88475 0.4042 2.4662 4.7363 5.81055 4.7363 5.81055s-1.8003 4.55785-3.8379 5.4297c-6.0115 2.57205-9.9784 4.0405-15.2441 4.8535-5.2104 0.80445-11.0723 1.4648-16.2988-0.0195-3.376-0.95875-6.845-2.7304-8.9649-5.5273-0.6311-0.83265-0.8593-3.00785-0.8593-3.00785s6.4664-1.67915 9.0429-3.6621c2.5589-1.9694 5.2823-4.56845 5.8106-7.7539 0.531-3.20115-1.1709-6.58965-3.0176-9.2578-1.8303-2.6446-4.582-4.73805-7.5293-6.0254-1.3298-0.5809-4.3066-0.64455-4.3066-0.64455s-0.6294 0.5709-0.9375 0.8594c-1.2438 1.59805-2.9535 2.8626-4.7657 3.8086-0.032 0.0185-0.076 0.0508-0.1074 0.0684-0.044 0.0245-0.1285 0.0438-0.1758 0.0684-0.3793 0.18905-0.7491 0.41-1.1328 0.5664-0.1998 0.0815-0.51 0.0933-0.7422 0.15625-1.269 0.42885-2.4707 0.78125-2.4707 0.78125s3.8635 1.19585 4.9512 2.7344c0.6719 0.95035 0.9629 2.10935 1.084 3.31055 0.1485 0.7129 0.2344 1.43385 0.2051 2.1289-0.047 1.10925-0.3223 2.23315-0.7032 3.33005-0.3486 1.27815-0.8392 2.5073-1.6699 3.4961-0.4512 0.53715-1.0035 0.98495-1.5918 1.38675-0.028 0.0227-0.049 0.0558-0.078 0.0781-0.03 0.0231-0.086 0.0362-0.1172 0.0586-1.0379 0.67075-2.2093 1.1684-3.3789 1.49415-1.3714 0.3819-4.186 0.0793-4.2871 0.0684 0.1034 0.0002 5.51-0.01 7.666-1.5625 0.067-0.0431 0.1299-0.092 0.1953-0.1367 1.5102-1.205 2.5998-2.97625 3.2617-4.88285 0.2091-0.7666 0.415-1.54335 0.4883-2.31445 0.096-1.01385 0.1157-2.0935 0.01-3.1445-0.3302-1.5845-1.0609-3.1235-2.2168-4.1504-2.4174-2.1477-9.3244-2.40865-9.4141-2.4121-0.1069 0.004-6.99 0.2671-9.4043 2.4121-1.1559 1.0269-1.8866 2.5659-2.2168 4.1504-0.1059 1.051-0.087 2.13065 0.01 3.1445 0.073 0.7711 0.2792 1.54785 0.4883 2.31445 0.6619 1.9066 1.7515 3.67785 3.2617 4.88285 0.065 0.0447 0.1286 0.0936 0.1953 0.1367 2.1559 1.5529 7.5623 1.5627 7.666 1.5625-0.1011 0.0109-2.9156 0.31355-4.2871-0.0684-1.1696-0.32575-2.341-0.8234-3.3789-1.49415-0.031-0.0224-0.087-0.0355-0.1172-0.0586-0.029-0.0223-0.05-0.0554-0.078-0.0781-0.5883-0.4018-1.1406-0.8496-1.5918-1.38675-0.8306-0.9888-1.3213-2.21795-1.6699-3.4961-0.3809-1.0969-0.6563-2.2208-0.7031-3.33005-0.029-0.69505 0.057-1.416 0.205-2.1289 0.1211-1.2012 0.4219-2.3602 1.0938-3.31055 1.0878-1.53855 4.9414-2.7344 4.9414-2.7344s-1.2009-0.352-2.4707-0.78125c-0.2299-0.0625-0.5344-0.0755-0.7324-0.15625-0.3891-0.15855-0.7679-0.38405-1.1524-0.57615-0.042-0.0218-0.1172-0.0368-0.1562-0.0586-0.026-0.0145-0.062-0.0435-0.088-0.0586-1.8212-0.94695-3.5456-2.2132-4.7949-3.81835-0.3082-0.2885-0.9375-0.8594-0.9375-0.8594s-2.967 0.0637-4.2969 0.64455c-2.9473 1.28735-5.7088 3.3808-7.5391 6.0254-1.8467 2.66815-3.5486 6.05665-3.0176 9.2578 0.5283 3.18545 3.2615 5.7845 5.8204 7.7539 2.5765 1.98295 9.0332 3.6621 9.0332 3.6621s-0.2283 2.1752-0.8594 3.00785c-2.1199 2.7969-5.5889 4.56855-8.9649 5.5273-5.2265 1.48435-11.0884 0.824-16.2988 0.0195-5.2657-0.813-9.2326-2.28145-15.2441-4.8535-2.0376-0.87185-3.8379-5.4297-3.8379-5.4297s4.3321-3.34435 4.7363-5.81055c0.3967-2.42-0.8993-5.09725-2.5781-6.88475-1.5612-1.6622-3.9602-2.83915-6.2403-2.80275-3.1125 0.0497-6.7823 1.43135-8.3984 4.0918-1.4535 2.3925-0.9675 5.86105 0.2149 8.39845 1.0521 2.2577 5.5957 4.95115 5.5957 4.95115-1.1633 4.73135-2.7894 7.14545-4.5215 9.0332-6.3144 3.6036-12.6308 5.62595-18.9453 7.53905l-3.6524-2.373-2.5879-4.51175s3.7359-5.16975 3.877-8.1836c0.1179-2.51685-1.1842-5.00715-2.5879-7.0996-1.1885-1.7717-2.7604-3.50195-4.7363-4.30665-1.8619-0.7583-4.0859-0.7441-6.0254-0.21485-2.9572 0.80705-7.7442 4.9512-7.7442 4.9512s-4.7459-3.79855-6.4648-6.25c-1.7149-2.4458-3.6524-8.17385-3.6524-8.17385l-1.2109-0.6445c-3.0703-0.50455-7.2949-3.85745-7.2949-3.85745l-4.4434 0.9375s-4.1014 2.19525-4.1504 4.1504c-0.067 2.70015 3.7256 3.9183 5.4395 6.00585 1.4706 1.7913 2.8406 3.6673 4.1406 5.58595 1.225 1.80785 2.8428 3.47495 3.4375 5.57615 0.6494 2.29425-0.9739 4.97205 0 7.14845 1.2278 2.74365 3.7734 5.4157 6.7188 6.01565 2.6155 0.53275 7.5879-2.57815 7.5879-2.57815l-0.1465 19.8828 10.3027 9.30665 9.7266 20.3125-3.8575 5.1465 1.1426 10c7.4813-9.58415 20.5018-13.7912 32.1875-17.1484 15.7316-4.5196 44.5698-4.8416 58.0078-4.7168 4.4794 0.0416 7.2559 0.13675 7.2559 0.13675s44.2954-1.44185 65.2539 4.58005c11.6856 3.3576 24.7062 7.5643 32.1875 17.1484l1.1426-10-3.8574-5.1465 9.7265-20.3125 10.3028-9.30665-0.1465-19.8828s4.9724 3.1109 7.5879 2.57815c2.9454-0.59995 5.4909-3.272 6.7187-6.01565 0.9739-2.1764-0.6494-4.8542 0-7.14845 0.5947-2.1012 2.2125-3.7683 3.4375-5.57615 1.3-1.91865 2.6798-3.79465 4.1504-5.58595 1.7139-2.08755 5.4967-3.3057 5.4297-6.00585-0.049-1.95515-4.1504-4.1504-4.1504-4.1504l-4.4434-0.9375zm-148.33-2.6074c1.0489 0.98195 3.1026 2.8469 4.7949 3.81835 0.08 0.0418 0.1633 0.0768 0.2441 0.1172 0.5048 0.26415 1.2018 0.50155 1.8848 0.7324 2.913 0.7925 7.9353 0.26675 8.0469 0.2539h0.01 0.02c0.1114 0.0128 5.1327 0.53605 8.0468-0.2539 0.6767-0.22865 1.3711-0.46095 1.875-0.72265 0.094-0.047 0.1896-0.0878 0.2832-0.1367 1.692-0.9767 3.7202-2.82985 4.7657-3.8086 0.5223-0.6711 0.9659-1.39145 1.2988-2.1582 1.1552-2.6608 1.1017-6.11155-0.2051-8.7012-1.5377-3.0469-5.1755-4.49675-8.0859-6.2793-2.5063-1.53495-7.9125-3.72505-7.9981-3.75975-0.1 0.0405-5.4757 2.22685-7.9785 3.75975-2.9104 1.78255-6.558 3.2324-8.0957 6.2793-1.3068 2.58965-1.3603 6.0404-0.2051 8.7012 0.3329 0.76675 0.7765 1.4871 1.2989 2.1582z'/%3E %3Cpath d='m1980.77 829.789s-10.8864-5.06097-16.5904-6.87893c-10.4126-3.31869-21.2354-5.21582-31.9667-7.28356-12.4669-2.40215-25.2596-3.0515-37.6221-5.94324-3.8919-0.91037-7.5305-2.76907-11.445-3.57657-5.4002-1.11395-11.0611-2.8737-16.4523-1.71675-2.9678 0.6369-7.8193 4.578-7.8193 4.578s-4.8672-3.93997-7.8193-4.578c-5.3894-1.16479-11.0521 0.6028-16.4523 1.71675-3.9145 0.8075-7.5531 2.6662-11.445 3.57657-12.3625 2.89174-25.1552 3.54109-37.6221 5.94324-10.7313 2.06774-21.5541 3.96487-31.9667 7.28356-5.704 1.81796-16.5904 6.87893-16.5904 6.87893m197.457-45.1211s5.3501-2.82415 7.2852-5.05855c1.2834-1.48195 2.5069-3.2978 2.6367-5.25395 0.1511-2.277-0.6209-4.853-2.2266-6.4746-1.5608-1.57635-4.061-2.21855-6.2793-2.22655-1.8556-0.006-3.842 0.6124-5.2539 1.8164-1.63 1.39005-2.7809 3.5372-3.0371 5.66405-0.2186 1.81445 0.5096 3.6987 1.3672 5.3125 1.3002 2.44695 5.5078 6.2207 5.5078 6.2207zm-151.123 0s4.2076-3.77375 5.5078-6.2207c0.8576-1.6138 1.5858-3.49805 1.3672-5.3125-0.2562-2.12685-1.4071-4.274-3.0371-5.66405-1.4119-1.204-3.3983-1.8224-5.2539-1.8164-2.2183 0.008-4.7088 0.6502-6.2696 2.22655-1.6057 1.6216-2.3776 4.1976-2.2265 6.4746 0.1298 1.95615 1.3435 3.772 2.6269 5.25395 1.9351 2.2344 7.2852 5.05855 7.2852 5.05855zm-41.0742 18.0078l-11.9336 15.5762s-0.084 4.10895 0.8105 5.86915c1.2312 2.4238 5.8594 5.66405 5.8594 5.66405l0.8496 21.3868-11.3086 19.5996-0.9863 0.20505 7.2949 3.85745c0.342 0.0562 0.6808 0.11165 0.9863 0.0879 4.3781-0.34225 7.0688-5.2579 10.8789-7.44145 4.8491-2.779 10.0115-4.98805 15.1661-7.1484 7.1244-2.9859 14.3588-5.7335 21.7382-8.0176 9.3031-2.87955 18.6911-5.75975 28.3301-7.14845 7.298-1.0514 14.7122-1.54535 22.0996-1.4453 2.4625 0.0333 4.9209 0.12695 7.3731 0.29295 6.5689 0.44475 19.3704 3.40415 19.4726 3.42775 0.086-0.0198 12.9093-2.9827 19.4824-3.42775 9.8085-0.66405 19.7421-0.2495 29.4727 1.15235 9.639 1.3887 19.027 4.2689 28.3301 7.14845 7.3794 2.2841 14.6139 5.0317 21.7383 8.0176 5.1546 2.16035 10.3169 4.3694 15.166 7.1484 3.8101 2.18355 6.5008 7.0992 10.8789 7.44145 0.3085 0.024 0.6505-0.0304 0.9961-0.0879l7.2851-3.85745-0.9863-0.20505-11.3086-19.5996 0.8496-21.3868s4.638-3.24025 5.8692-5.66405c0.8943-1.7602 0.8007-5.86915 0.8007-5.86915l-11.9335-15.5762c-0.0001 0-6.0157 6.00765-9.9122 7.28515-2.0507 0.67235-4.4136 0.6401-6.4746 0-2.501-0.7768-4.4344-2.81105-6.4746-4.45315-4.6088-3.70965-9.2257-7.54105-12.9492-12.1386-2.1328-2.6335-5.2637-8.7012-5.2637-8.7012s-12.9078 10.1416-20.6347 12.1387c-7.5767 1.95835-15.96 1.6057-23.4668-0.6055-1.8839-0.5549-5.0293-3.0664-5.0293-3.0664-8.8263-5.6214-17.652-8.69745-26.4258-7.85155-8.7738-0.8459-17.5995 2.23015-26.4258 7.85155 0 0-3.1552 2.5115-5.0391 3.0664-7.5068 2.2112-15.89 2.56385-23.4667 0.6055-7.727-1.99715-20.6348-12.1387-20.6348-12.1387s-3.1309 6.0677-5.2637 8.7012c-3.7235 4.5976-8.3404 8.429-12.9492 12.1386-2.0402 1.6421-3.9736 3.67635-6.4746 4.45315-2.061 0.6401-4.4239 0.67235-6.4746 0-3.8965-1.2775-9.9121-7.28515-9.9121-7.28515z'/%3E %3Cpath d='m1985.89 796.364s0.4479-5.70292-0.1618-8.45505c-0.5584-2.5204-1.694-4.94002-3.136-7.08123-1.5129-2.2464-5.6473-5.84156-5.6473-5.84156m-1.4343 27.6901c-0.0001 0 3.3941 0.1231 4.8535-0.6055 2.6029-1.2996 6.0742-6.2695 6.0742-6.2695s6.6614 4.60745 10.3125 4.04295c1.8007-0.2784 3.2946-1.88475 4.248-3.4375 1.0106-1.6457 1.6515-3.78155 1.2207-5.66405-0.3431-1.49915-1.6576-2.6497-2.832-3.6426-2.2813-1.92865-6.3955-1.66185-7.8906-4.24805-1.1818-2.04435-0.4569-4.8105 0.1953-7.08005 1.3607-4.7357 4.7512-8.64825 7.4902-12.7442 1.7395-2.60125 5.2931-4.38305 5.6641-7.49025 0.2006-1.67945-2.0215-4.6582-2.0215-4.6582s-5.2216-0.11815-7.6855 0.61525c-4.0775 1.21385-8.3071 2.99495-11.2012 6.11325-2.4056 2.5919-3.1206 6.36555-4.3848 9.668-0.9609 2.50985-2.4219 7.68555-2.4219 7.68555s-6.0411-0.013-8.7011 1.21095c-3.5158 1.6175-7.1107 4.1574-8.7012 7.6855-1.2473 2.7667-1.0733 6.27265 0 9.11135 1.0815 2.86035 3.4928 5.23565 6.0742 6.875 2.8465 1.80775 9.7071 2.83205 9.7071 2.83205zm-234.71-27.69s-4.1344 3.59516-5.6473 5.84156c-1.442 2.14121-2.5776 4.56083-3.136 7.08123-0.6097 2.75213-0.1618 8.45505-0.1618 8.45505m-16.9364-45.4847s-2.2221 2.97875-2.0215 4.6582c0.371 3.1072 3.9246 4.889 5.6641 7.49025 2.739 4.0959 6.1295 8.00845 7.4902 12.7442 0.6522 2.26955 1.3771 5.0357 0.1953 7.08005-1.4951 2.5862-5.6093 2.3194-7.8906 4.24805-1.1744 0.9929-2.4889 2.14345-2.832 3.6426-0.4308 1.8825 0.2101 4.01835 1.2207 5.66405 0.9534 1.55275 2.4473 3.1591 4.248 3.4375 3.6511 0.5645 10.3125-4.04295 10.3125-4.04295s3.4713 4.9699 6.0743 6.2695c1.4594 0.7286 4.8535 0.6055 4.8535 0.6055s6.8703-1.0243 9.7168-2.83205c2.5814-1.63935 4.9829-4.01465 6.0644-6.875 1.0733-2.8387 1.2473-6.34465 0-9.11135-1.5905-3.5281-5.1854-6.068-8.7012-7.6855-2.66-1.22395-8.7011-1.21095-8.7011-1.21095s-1.461-5.1757-2.4219-7.68555c-1.2642-3.30245-1.9792-7.0761-4.3848-9.668-2.8941-3.1183-7.1236-4.8994-11.2011-6.11325-2.4639-0.7334-7.6856-0.61525-7.6856-0.61525zm135.626 14.3174l8.3246-2.43757 8.3246 2.43757m-14.4926 20.0821s-6.481-5.90993-7.6882-9.91375c-0.5271-1.74815-0.45-3.84915 0.4046-5.46267 1.1684-2.20587 5.8673-4.65339 5.8673-4.65339s-7.0852-3.44282-8.9021-6.67661c-1.0288-1.83119-1.1579-4.24509-0.607-6.27195 0.8741-3.21533 3.2994-5.96975 5.8673-8.09287 3.185-2.63316 11.2261-5.26034 11.2261-5.26034s8.0266 2.61995 11.2261 5.26034c2.5698 2.12081 4.9932 4.87754 5.8673 8.09287 0.5509 2.02686 0.4218 4.44076-0.607 6.27195-1.8169 3.23379-8.9021 6.67661-8.9021 6.67661s4.6989 2.44752 5.8673 4.65339c0.8546 1.61352 0.9317 3.71452 0.4046 5.46267-1.2072 4.00382-7.6882 9.91375-7.6882 9.91375l-6.168 0.40463zm22.6719-26.8875s13.4369 5.72681 17.9891 11.1064c1.2701 1.50095 2.3519 3.50054 2.2255 5.46267-0.4485 6.96199-10.3184 18.2089-10.3184 18.2089l-19.9282-8.28243h-12.9438l-19.9282 8.28243s-9.8699-11.2469-10.3184-18.2089c-0.1264-1.96213 0.9554-3.96172 2.2255-5.46267 4.5522-5.37958 17.9891-11.1064 17.9891-11.1064'/%3E %3Cpath d='m1844.36 669.248l8.0562-6.20056 6.5065 0.13988-6.6557-0.14309s-3.591-2.44764-4.578-4.29188c-0.958-1.79023-1.4152-4.02072-1.0015-6.00863 0.5525-2.65484 2.0852-5.45855 4.4277-6.82475 2.2371-1.30479 7.7551-0.47145 7.7551-0.47145s5.5027-0.84166 7.7551 0.47145c2.3428 1.36572 3.8752 4.16991 4.4277 6.82475 0.4137 1.98791-0.043 4.2184-1.0015 6.00863-0.987 1.84424-4.578 4.29188-4.578 4.29188l-6.6557 0.14309 6.5065-0.13988 8.0562 6.20056m52.5845 5.06845l-2.6798 4.65503m32.6326-20.0046l-7.5149 0.98202m8.513 8.80375l-11.5169 0.60428m-1.4979-13.7479c1.4677 0.93659 4.1545 2.86005 4.5946 4.63497 0.7761 3.12938-0.6743 7.07048-3.1391 9.14891-2.3885 2.01406-9.252 1.50107-9.252 1.50107m-181.69 33.5875s11.2946-2.8202 16.9546-4.17785c8.0811-1.93833 16.0993-4.19579 24.2786-5.665 9.2622-1.66374 18.6201-2.88431 28.0067-3.55413 11.7104-0.83564 35.2159-0.57225 35.2159-0.57225s23.488-0.26449 35.2159 0.57225c9.3866 0.66969 18.7445 1.89039 28.0067 3.55413 8.1793 1.46921 16.1975 3.72667 24.2786 5.665 5.66 1.35765 16.9546 4.17785 16.9546 4.17785m-171.551-30.1651l2.6798 4.65503m-32.6326-20.0046l7.5149 0.98202m-8.513 8.80375l11.5169 0.60428m-6.4754 16.0764s12.5425-3.18763 18.8753-4.50628c6.9234-1.44166 13.8728-2.81916 20.8871-3.71964 8.0675-1.03566 16.1997-1.55541 24.3248-1.92859 9.6296-0.44228 28.917-0.36651 28.917-0.36651s19.2699-0.0764 28.917 0.36651c8.1252 0.37308 16.2573 0.89293 24.3248 1.92859 7.0143 0.90048 13.9637 2.27798 20.8871 3.71964 6.3328 1.31865 18.8753 4.50628 18.8753 4.50628m-170.239-14.5393s-6.8635 0.51299-9.252-1.50107c-2.4648-2.07843-3.9152-6.01953-3.1391-9.14891 0.6108-2.46349 5.5498-5.21314 5.5498-5.21314m63.1382 74.0024c-11.9767 0.7232-24.0098 1.474-35.8108 3.6418-12.2927 2.25809-24.4854 5.39728-36.2155 9.71141-11.113 4.08716-22.8689 22.6434-32.0955 15.2222-1.983-1.59501 0.7525-5.08407 1.7168-7.43927 1.8655-4.55651 4.429-8.93224 7.7254-12.5895 2.4138-2.67809 7.9759-3.02712 8.5837-6.58089 0.4416-2.58142-3.4743-4.09285-4.2918-6.58088-1.0439-3.17647-1.5387-6.81352-0.5723-10.0144 1.2405-4.10872 6.5254-6.17981 7.7254-10.3005 1.043-3.58184-2.5475-7.83256-0.8584-11.1589 2.133-4.20065 11.3369-2.77746 12.0173-7.43927 0.3317-2.27285-3.8251-2.9802-4.578-5.15025-0.5324-1.53446 0.3091-3.24011 0.2861-4.86414-0.031-2.20169 0.392-4.60137-0.5723-6.58088-0.857-1.7593-3.702-2.13985-4.2918-4.00576-0.5582-1.76572-0.1716-4.13356 1.1445-5.43639 1.0368-1.02642 3.6319 0.44281 4.2918-0.85837 1.3318-2.62589-2.5388-5.31434-3.7196-8.01151-1.4064-3.21256-3.2072-6.31351-4.0057-9.72827-0.6313-2.69961-2.9585-6.88614-0.5723-8.29764 2.7325-1.61631 5.4768 3.23869 8.0115 5.15025 3.3453 2.52289 7.1094 4.81707 9.4422 8.29764 1.6831 2.51135 0.7428 6.50932 2.9483 8.57708 2.6468 2.48143 7.7583 0.49134 10.4996 2.86794 2.3561 2.04271 4.4414 5.55009 3.7196 8.58376-0.6897 2.89871-7.5314 2.81792-6.867 5.72252 0.7892 3.45006 6.8133 3.17917 10.3005 2.57514 2.033-0.35214 3.4624-2.24683 5.1503-3.43351 1.3108-0.92157 2.389-2.23216 3.8627-2.86127 1.6908-0.72182 5.4363-0.9299 5.4363-0.9299l-2.1459-0.50072s-3.1717-2.52782-3.505-4.36342c-0.3139-1.72858 0.4369-3.73179 1.6452-5.00719 1.3551-1.43043 3.5376-2.16034 5.5079-2.14594 1.6471 0.0118 3.4459 0.66342 4.578 1.85981 1.1609 1.22684 1.8244 3.11308 1.6452 4.7926-0.1565 1.46787-1.1275 2.87998-2.289 3.79116-1.2578 0.98685-4.578 1.43063-4.578 1.43063l2.289 0.64379 6.1517 8.4407 26.5387-1.45409s3.2734-3.3392 2.6302-5.1592c-0.6891-1.94976-2.503-2.66777-5.665-2.52901-8.5812 0.37659-10.3395-6.82843-10.015-12.0381 0.27-4.33353 5.4839-7.27436 9.5092-8.90214 3.8768-1.56776 10.7873 3.59271 12.5439-0.20233 1.5397-3.32652-5.8181-5.02096-6.9801-8.49749-0.5029-1.50446-0.5077-3.33604 0.2023-4.75454 1.8128-3.62158 5.7132-6.02963 9.408-7.68822 1.5569-0.69888 5.0552-0.80928 5.0552-0.80928s3.4821 0.10463 5.0552 0.80928c3.6961 1.65563 7.5952 4.06664 9.408 7.68822 0.71 1.4185 0.7052 3.25008 0.2023 4.75454-1.162 3.47653-8.5198 5.17097-6.9801 8.49749 1.7566 3.79504 8.6671-1.36543 12.5439 0.20233 4.0253 1.62778 9.2392 4.56861 9.5092 8.90214 0.3245 5.20968-1.4338 12.4147-10.015 12.0381-3.162-0.13876-4.9759 0.57925-5.665 2.52901-0.6432 1.82 2.6302 5.1592 2.6302 5.1592l26.5387 1.45409 6.1517-8.4407 2.289-0.64379s-3.3202-0.44378-4.578-1.43063c-1.1615-0.91118-2.1325-2.32329-2.289-3.79116-0.1792-1.67952 0.4843-3.56576 1.6452-4.7926 1.1321-1.19639 2.9309-1.84798 4.578-1.85981 1.9703-0.0144 4.1528 0.71551 5.5079 2.14594 1.2083 1.2754 1.9591 3.27861 1.6452 5.00719-0.3333 1.8356-3.505 4.36342-3.505 4.36342l-2.1459 0.50072s3.7455 0.20808 5.4363 0.9299c1.4737 0.62911 2.5519 1.9397 3.8627 2.86127 1.6879 1.18668 3.1173 3.08137 5.1503 3.43351 3.4872 0.60403 9.5113 0.87492 10.3005-2.57514 0.6644-2.9046-6.1773-2.82381-6.867-5.72252-0.7218-3.03367 1.3635-6.54105 3.7196-8.58376 2.7413-2.3766 7.8528-0.38651 10.4996-2.86794 2.2055-2.06776 1.2652-6.06573 2.9483-8.57708 2.3328-3.48057 6.0969-5.77475 9.4422-8.29764 2.5347-1.91156 5.279-6.76656 8.0115-5.15025 2.3862 1.4115 0.059 5.59803-0.5723 8.29764-0.7985 3.41476-2.5993 6.51571-4.0057 9.72827-1.1808 2.69717-5.0514 5.38562-3.7196 8.01151 0.6599 1.30118 3.255-0.16805 4.2918 0.85837 1.3161 1.30283 1.7027 3.67067 1.1445 5.43639-0.5898 1.86591-3.4348 2.24646-4.2918 4.00576-0.9643 1.97951-0.5415 4.37919-0.5723 6.58088-0.023 1.62403 0.8185 3.32968 0.2861 4.86414-0.7529 2.17005-4.9097 2.8774-4.578 5.15025 0.6804 4.66181 9.8843 3.23862 12.0173 7.43927 1.6891 3.32633-1.9014 7.57705-0.8584 11.1589 1.2 4.12072 6.4849 6.19181 7.7254 10.3005 0.9664 3.20087 0.4716 6.83792-0.5723 10.0144-0.8175 2.48803-4.7334 3.99946-4.2918 6.58088 0.6078 3.55377 6.1699 3.9028 8.5837 6.58089 3.2964 3.65727 5.8599 8.033 7.7254 12.5895 0.9643 2.3552 3.6998 5.84426 1.7168 7.43927-9.2266 7.42112-20.9825-11.1351-32.0955-15.2222-11.7301-4.31413-23.9228-7.45332-36.2155-9.71141-11.801-2.1678-23.8341-2.91831-35.8108-3.6418-6.9678-0.42091-20.9375-0.40462-20.9375-0.40462s-13.9523-0.0172-20.9375 0.40462z'/%3E %3Cpath d='m1869.06 595.401l-10.1836 0.11745-10.1836-0.11745m16.9312-33.8799c2.6422-5.60081-1.9753-9.7497-6.7476-13.8571-4.7723 4.10743-9.3897 8.25632-6.7475 13.8571m14.0661 46.73c3.8943 0.2869 8.6316 4.26757 11.5881 1.71675 1.336-1.1526 0.6752-3.66318 0-5.29332-1.5743-3.80071-8.4131-4.62493-8.7268-8.72683-0.2706-3.53784 5.1908-5.2117 6.2948-8.58376 0.5489-1.67687 0.6808-3.66554 0-5.29332-2.7515-6.57773-14.4931-6.95114-16.5271-13.6805-0.9011-2.98148 5.9324-6.49335 6.7999-6.86893 4.3393-1.87871 9.7036 2.65867 13.9877 0.7993 2.899-1.25827 6.1252-4.1237 6.0696-7.28357-0.06-3.43827-3.7256-6.31645-6.8789-7.68821-6.1079-2.65702-16.2205 5.9042-19.9783 0.40464-3.4586-5.06171 8.643-11.0806 7.0297-16.995-0.7665-2.81003-6.9773-5.26035-6.9773-5.26035s-6.2021 2.43824-6.9773 5.26035c-1.6239 5.91151 10.4883 11.9333 7.0297 16.995-3.7578 5.49956-13.8704-3.06166-19.9783-0.40464-3.1533 1.37176-6.8184 4.24994-6.8789 7.68821-0.056 3.15987 3.1706 6.0253 6.0696 7.28357 4.2841 1.85937 9.6484-2.67801 13.9877-0.7993 0.8674 0.37558 7.701 3.88745 6.7999 6.86893-2.034 6.7294-13.7756 7.10281-16.5271 13.6805-0.6809 1.62778-0.5489 3.61645 0 5.29332 1.1039 3.37206 6.5654 5.04592 6.2948 8.58376-0.3137 4.1019-7.1525 4.92612-8.7268 8.72683-0.6753 1.63014-1.336 4.14072 0 5.29332 2.9565 2.55082 7.6937-1.42985 11.588-1.71675 2.433-0.17924 7.3187 0 7.3187 0s4.8683-0.18054 7.3186 0z'/%3E %3Cpath fill='none' d='m1953.74 953.499s-7.1544-3.01914-10.8036-4.34009c-6.5977-2.3883-13.2592-4.63213-20.0298-6.47428-6.5995-1.79562-13.2329-3.68914-20.0298-4.45107-14.5762-1.63399-44.0021-0.20232-44.0021-0.20232s-29.4085-1.43357-44.0021 0.20232c-6.7969 0.76191-13.4303 2.65545-20.0298 4.45107-6.7706 1.84215-13.4321 4.08598-20.0298 6.47428-3.6492 1.32095-10.8036 4.34009-10.8036 4.34009m201.899-222.5s-11.9524-4.75619-18.0259-6.86702c-5.1003-1.77255-10.2059-3.58154-15.4508-4.86412-6.3972-1.56438-12.932-2.53824-19.4565-3.43352-9.3932-1.28887-18.8433-2.20847-28.307-2.78448-8.5842-0.52248-25.7932-0.60697-25.7932-0.60697s-17.1915 0.0836-25.7932 0.60697c-9.4637 0.57579-18.9138 1.49561-28.307 2.78448-6.5245 0.89528-13.0593 1.86914-19.4565 3.43352-5.2449 1.28258-10.3505 3.09157-15.4508 4.86412-6.0735 2.11083-18.0259 6.86702-18.0259 6.86702m-14.1568 120.41s17.5596-5.91847 26.4055-8.671c9.1286-2.84052 18.1733-6.06275 27.5157-8.09285 11.184-2.43029 22.6108-3.62932 33.9899-4.85571 11.0585-1.19184 33.2791-2.42786 33.2791-2.42786s22.2032 1.23478 33.2791 2.42786c11.3792 1.22574 22.8059 2.42542 33.9899 4.85571 9.3424 2.0301 18.3871 5.25233 27.5157 8.09285 8.8459 2.75253 26.4055 8.671 26.4055 8.671'/%3E %3C/g%3E %3Cg id='silverkey' fill='%23ccc'%3E %3Cg id='keybase'%3E %3Cpath d='m1533.28 904.042l101.171 86.7132s-5.1334 11.2137-7.279 16.9889c-1.9789 5.3266-3.8171 10.7271-5.1455 16.252-1.9584 8.145-4.1351 24.7886-4.1351 24.7886l-117.942-108.035c1.6729-24.6894 15.5662-33.4882 33.3308-36.7078z'/%3E %3Cpath d='m1518.99 958.197l-24.2832 27.1672 15.1647 14.5924-23.4623 22.89-15.1647-15.1647-25.5145 27.2017-0.2368 33.7431 58.0835 45.4939 20.0288-14.8785-1.1445-32.3322 15.4508 8.5838 15.4508-9.4422 0.8583 29.1849-12.5895-9.1561-13.734 18.0259-1.4306 32.0461 43.7772 38.9131 53.0494-47.0794-4.0084-14.1122-2.3054-12.678-1.2464-25.1286 1.9803-27.4395z'/%3E %3Cpath d='m1494.71 985.364l-0.6211 29.9932 15.6428-15.2612z'/%3E %3Cpath fill='none' d='m1571.935 1140.425l-1.8207 34.26245m-18.6096 -139.675l0.6445 31.7845m-14.8106 -17.3405l0.8297 25.8846m-14.425 -36.3405l0.5416 28.9249m-21.4347 15.2245l0.3115 30.6476m24.7368 -9.675l44.0639 36.8974 45.0552 -39.54m-171.018 -66.875l57.579 49.1932 18.8843 -16.8814 -14.8785 -12.5895 16.5953 -15.7369 12.8756 11.1589 14.5924 -14.8785 18.8843 18.312 -17.1507 13.4474 16.0062 14.5929 -15.1647 14.0202'/%3E %3Cpath d='m1901.35 1229.35l48.6021 44.5794 10.7633 31.4287-62.6421-6.6732-35.6637-35.2765-37.9692-35.1752-164.039-142.138s3.4783-13.1014 5.635-19.5218c3.124-9.3004 6.8664-18.3846 10.5645-27.472 0.9279-2.2802 2.9156-6.7855 2.9156-6.7855l183.014 162.24z'/%3E %3Cpath d='m1942.67 1236.04c27.0945 37.8682 72.6912 73.6383 86.5365 90.8418 13.8452 17.2034 22.7646 33.5407 2.5831 55.5383-20.1814 21.9976-43.064 9.5153-61.1352-2.5832-18.0712-12.0984-49.6026-51.3029-94.7165-81.3701z'/%3E %3Cpath d='m1926.7 1299.75l-35.1694-15.8738m40.928-38.2875c2.4231 7.9655 0.5742 16.7742 3.624 24.4159 3.0153 7.5554 14.0225 19.9737 14.0225 19.9737s-6.9976 0.9775-10.2616 2.2451c-4.731 1.8372-11.9561 2.7096-13.172 7.6371-1.0633 4.3091 4.0612 8.0262 7.0898 11.2707 2.9045 3.1116 6.6447 5.3721 10.3159 7.5262 6.1364 3.6005 12.391 7.6535 19.393 8.9161 8.7653 1.5806 25.1291-10.7555 26.6468-1.9791 0.6311 3.6495-7.3892 1.3125-10.7131 2.9459-7.7584 3.8123-11.6492 12.1174-4.8208 17.8939 4.3853 3.7097 11.2751 2.3464 16.9994 2.8209 5.4887 0.455 11.7572-2.745 16.5227 0.016 5.6107 3.2507 12.6678 11.1061 9.6914 16.867-3.0627 5.9283-14.4837 5.7692-19.9267 1.9095-4.0245-2.8539-2.947-9.4733-3.5417-14.371-0.1769-1.4578 0-2.937 0-4.4055'/%3E %3Ccircle cx='2154.6649' cy='1480.1466' r='129.6871'/%3E %3Cpath fill='%23fff' d='m2106.13 1485.65c-22.3554 0-40.4781 18.1226-40.4781 40.478 0 22.3555 18.1227 40.4781 40.4781 40.4781s40.4781-18.1226 40.4781-40.4781l14.0261-0.6088c0 22.3554 18.1227 40.4781 40.4781 40.4781s40.4781-18.1227 40.4781-40.4781-18.1227-40.4781-40.4781-40.4781l0.6088-7.9375c22.3555 0 40.4781-18.1227 40.4781-40.4781s-18.1226-40.4781-40.4781-40.4781c-22.3554 0-40.4781 18.1227-40.4781 40.4781l-14.026-1.2177c0-22.3555-18.1227-40.4781-40.4781-40.4781-22.3555 0-40.4781 18.1226-40.4781 40.4781 0 22.3554 18.1226 40.4781 40.4781 40.4781z'/%3E %3Ccircle cx='2154.6667' cy='1446.0519' r='14.61264'/%3E %3Ccircle cx='2189.3667' cy='1480.1479' r='14.61264'/%3E %3Ccircle cx='2155.2767' cy='1511.1999' r='14.61264'/%3E %3Ccircle cx='2119.3467' cy='1480.1479' r='14.61264'/%3E %3Cpath fill='%23fff' d='m2152.23 1558.42c-5.3378 10.9567-12.6202 15.941-21.919 21.919 13.2474 5.754 29.4005 4.6966 43.838 0-9.2987-4.6497-16.0413-11.9958-21.919-21.919zm-76.5786-80.2317c-10.9566-5.3378-15.9409-12.6203-21.919-21.919-5.7539 13.2473-4.6965 29.4005 0 43.838 4.6498-9.2988 11.9959-16.0414 21.919-21.919zm159.246 3.6531c10.9567-5.3378 15.941-12.6203 21.919-21.919 5.754 13.2473 4.6966 29.4005 0 43.838-4.6497-9.2988-11.9958-16.0414-21.919-21.919zm-78.4052-80.8406c-5.3378-10.9566-12.6203-15.9409-21.919-21.919 13.2473-5.7539 29.4005-4.6965 43.838 0-9.2988 4.6498-16.0414 11.9959-21.919 21.919z'/%3E %3C/g%3E %3Cg fill='%23ce9d09'%3E %3Cg id='keydeco'%3E %3Cpath d='m1533.48 903.819s0.7031-5.06124 0.0001-7.43925c-1.1438-3.86881-3.5741-7.46776-6.5809-10.1575-2.5433-2.27495-5.8071-3.92372-9.1561-4.57801-3.6147-0.70621-7.4637-0.11504-11.0158 0.85837-2.4196 0.6631-6.7534 3.32254-6.7534 3.32254l-14.8491 6.11961-5.5107 17.6674s-3.1741 5.5789-3.9314 8.65611c-0.8104 3.29294-1.4088 6.87107-0.5723 10.1574 0.9826 3.86017 3.2315 7.61137 6.2948 10.1574 2.8332 2.35479 6.6269 3.72901 10.3005 4.00577 2.8265 0.21295 8.2977-1.85982 8.2977-1.85982 1.5802-18.6113 9.856-32.8133 33.4766-36.9102z'/%3E %3Cpath d='m1500.27 885.645l-38.7531-17.0196-3.1474 3.00431 21.1189 38.2016s5.9243-8.73821 9.3535-12.7364c3.5106-4.09311 11.4281-11.4499 11.4281-11.4499z'/%3E %3Ccircle cy='865.26332' cx='1457.292' r='15.951473'/%3E %3Cpath d='m1566.19 932.256c3.3899 27.9522 7.3216 55.9043 16.0248 83.8565l31.0688 28.459c-6.625-29.2317-18.4423-58.4633-18.3681-87.695z'/%3E %3Cpath d='m1613.05 972.415l-85.4875-6.36886 27.2007 24.9158 78.0675 3.37974 1.1469-3.98967z'/%3E %3Cpath d='m1718.36 1066.92c-22.4447 8.4602-31.4178 22.3089-37.8571 37.1712-6.3529 0.5589-12.3057 0.6177-14.4104-4.1336 5.3477-34.6998 30.2103-45.5513 35.7531-47.747 14.9497-2.8246 12.1788 8.8497 16.5144 14.7094z'/%3E %3Cpath d='m1745.88 1092.82c-22.4446 8.4601-31.4177 22.3089-37.857 37.1711-6.3529 0.5589-12.3057 0.6177-14.4104-4.1336 5.3477-34.6998 30.2103-45.5512 35.753-47.747 14.9498-2.8246 12.1789 8.8497 16.5144 14.7095z'/%3E %3Cpath d='m2058.66 1354.69c-7.33655 -0.2015 -15.0781 1.5039 -15.0781 1.5039 0.3035 8.02055 -2.9456 16.58265 -11.7969 26.2305 -7.63945 8.32695 -15.6662 11.70345 -23.67185 12.041l-0.01 0.01s-2.8398 17.65195 2.5879 23.25195c6.3562 6.5581 27.11915 3.87695 27.11915 3.87695l1.7676 -1.1325a129.6875 129.6875 0 0 1 31.91405 -39.7949l0.332 -1.2595s3.0386 -16.5234 -2.1484 -21.5c-2.35045 -2.27015 -6.6137 -3.0726 -11.01565 0z'/%3E %3Ccircle cy='1375.4239' cx='2254.5167' r='17.656865'/%3E %3Ccircle cy='1580.0009' cx='2260.6067' r='17.656865'/%3E %3Ccircle cy='1591.5699' cx='2062.1167' r='17.656865'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='goldkey' fill='%23ce9d09' transform='matrix(-1,0,0,1,3718.256,0)'%3E %3Cuse xlink:href='%23keybase'/%3E %3Cuse xlink:href='%23keydeco' fill='%23ccc'/%3E %3C/g%3E %3Cg id='cord'%3E %3Cg fill='%23fa0204'%3E %3Cpath id='piece1' d='m1869.19 1175.78c0 5.3802-4.4998 7.4585-13.2427 7.4585s-12.7861-2.5349-12.7861-7.9152c0-5.3802 4.0432-6.6974 12.7861-6.6974s13.2427 1.7739 13.2427 7.1541z'/%3E %3Cuse xlink:href='%23piece1' x='6.39127' y='14.309'/%3E %3Cpath d='m1877.34 1208.69c-1.772 5.0801-6.7053 5.5604-14.9604 2.681-8.255-2.8795-11.2378-6.6047-9.4658-11.6847 1.772-5.0801 6.0234-4.9922 14.2785-2.1127 8.2551 2.8794 11.9197 6.0364 10.1477 11.1164z'/%3E %3Cpath id='piece2' d='m1877.51 1222.51c-1.065 5.2737-5.8872 6.4202-14.4571 4.6895s-12.0312-5.0159-10.9662-10.2897c1.065-5.2737 5.289-5.7645 13.8588-4.0338 8.5699 1.7306 12.6295 4.3602 11.5645 9.634z'/%3E %3Cuse xlink:href='%23piece2' x='3.95963' y='16.1422'/%3E %3Cpath d='m1921.73 1216.2c-2.5904-0.6912-2.3033-5.3033-1.583-7.8857 1.107-3.9686 8.3538-9.11 8.3538-9.11s1.7671 5.5627 0.9501 8.1851c-1.1615 3.7283-3.948 9.8173-7.7209 8.8106z'/%3E %3Cpath d='m1912.29 1224.42c-2.8216-0.6217-3.1818-5.5227-2.444-8.3162 1.142-4.3238 9.6454-9.3253 9.6454-9.3253s1.4762 6.0417 0.5196 8.831c-1.2669 3.6937-3.9075 9.6508-7.721 8.8105z'/%3E %3Cpath d='m1901.52 1240.01c-4.2916-1.1384-3.8048-8.7623-2.6592-13.0521 0.946-3.5426 3.7155-9.1195 7.2774-8.2489 4.1673 1.0185 4.1144 8.3214 3.1027 12.4905-0.9208 3.7948-3.9464 9.8117-7.7209 8.8105z'/%3E %3Cpath d='m1888.73 1252.19c-4.2142-0.9262-6.0068-7.6384-5.1637-11.8701 0.8851-4.4419 5.3598-10.4103 9.7819-9.4309 4.4624 0.9884 6.0053 8.3528 4.9293 12.7949-1.0033 4.1426-5.3845 9.4211-9.5475 8.5061z'/%3E %3Cpath d='m1886.51 1259.58c-1.0768 5.087-7.5039 6.86-11.4614 5.5691-4.1541-1.355-9.5785-7.1863-8.4416-12.5236 1.1474-5.3859 8.1788-6.8138 12.3239-5.2257 3.8656 1.4809 8.6428 7.1552 7.5791 12.1802z'/%3E %3Cpath d='m1801.47 1210.29s5.1379 2.5312 7.3489 4.7921c2.321 2.3733 5.1107 3.3218 3.709 6.9229-1.4145 3.6339-5.8427 2.3881-8.1269-0.1558-2.1302-2.3723-2.931-11.5592-2.931-11.5592z'/%3E %3Cpath d='m1826.84 1219.06c5.2115 1.0469 5.1081 7.1209 2.4435 10.8465-2.7971 3.9106-10.8836 8.9923-16.3493 7.8872-5.5156-1.1152-4.8437-7.7572-1.7951-11.658 2.843-3.6377 10.5528-8.1097 15.7009-7.0757z'/%3E %3Cpath id='piece3' d='m1844.26 1230.55c4.8531 2.1688 3.4146 8.0709 0 11.1182-3.5896 3.1987-12.5967 6.3749-17.6849 4.0932-5.1345-2.3024-3.0165-8.6334 0.8162-11.767 3.5744-2.9224 12.0797-5.5868 16.8737-3.4444z'/%3E %3Cuse xlink:href='%23piece3' x='13.9976' y='10.6607'/%3E %3Cpath d='m1862.97 1250.68c4.7874 0.7544 6.069 7.4153 4.5846 11.6962-1.5593 4.494-7.4731 10.6689-12.4956 9.8697-5.0684-0.8064-5.9818-8.1322-4.2007-12.6343 1.6611-4.1985 7.3836-9.6772 12.1127-8.932z'/%3E %3Cpath d='m1875.1 1265.33c3.9649 2.3077 3.0331 9.5902 0.4105 13.5334-2.7541 4.1391-9.845 8.622-14.0023 6.1932-4.1951-2.451-2.7353-10.302 0.2157-14.3787 2.7522-3.8018 9.4605-7.6274 13.3771-5.3479z'/%3E %3Cpath d='m1789.02 1225.44c4.2435-0.3761 7.1824 5.9652 7.1269 10.5849-0.059 4.8498-3.317 12.4028-7.771 12.7899-4.4945 0.3906-7.3089-6.7007-7.0653-11.611 0.2273-4.5791 3.5185-11.3927 7.7102-11.7644z'/%3E %3Cpath d='m1802.91 1237.65c4.1568 0.9325 5.0275 7.8673 3.5694 12.2512-1.5316 4.6021-6.9326 10.8061-11.2933 9.82-4.4004-0.9952-4.9243-8.6065-3.1985-13.21 1.6094-4.293 6.8172-9.7825 10.9234-8.8615z'/%3E %3Cpath d='m1815.79 1246.24c4.9212 1.1581 5.952 9.7707 4.2258 15.2152-1.8133 5.7155-8.2076 13.4205-13.3701 12.1958-5.2096-1.2359-5.8298-10.6887-3.7868-16.4059 1.9054-5.3317 8.071-12.1493 12.9322-11.0055z'/%3E %3Cpath d='m1826.22 1256.8c5.0144-0.6444 9.0048 7.0573 9.301 12.7613 0.3098 5.9882-2.9706 15.4482-8.2344 16.115-5.3117 0.6727-9.2128-7.9599-9.3081-14.0304-0.089-5.6613 3.2892-14.2102 8.2424-14.8467z'/%3E %3Cpath id='piece4' d='m1838.59 1265.66c4.5564-0.5341 8.1822 5.85 8.4514 10.578 0.2815 4.9637-2.6993 12.8053-7.4822 13.358-4.8266 0.5576-8.3713-6.5981-8.4579-11.63-0.081-4.6927 2.9887-11.779 7.4895-12.3067z'/%3E %3Cuse xlink:href='%23piece4' x='12.7879' y='10.3504'/%3E %3Cpath id='piece5' d='m1929.28 1250.88c-3.2434 2.8459-9.7124 0.3125-12.6215-2.8742-3.0537-3.345-5.2098-10.4862-1.8005-13.4679 3.4404-3.009 10.2869 0.1121 13.2276 3.611 2.7423 3.263 4.3982 9.9199 1.1944 12.7311z'/%3E %3Cuse xlink:href='%23piece5' x='-6.99906' y='12.7922'/%3E %3Cuse xlink:href='%23piece5' x='-19.4791' y='23.4522'/%3E %3Cpath d='m1905.19 1281.18c-1.1383 4.1621-7.9325 5.6128-12.1161 4.5566-4.3915-1.1087-10.1258-5.8797-8.9239-10.2466 1.2128-4.4066 8.646-5.5749 13.0279-4.2756 4.0865 1.2117 9.1366 5.8543 8.0121 9.9656z'/%3E %3Cpath d='m1887.18 1278.19c3.6414 2.5388 2.7856 10.5507 0.377 14.8888-2.5295 4.5537-9.0418 9.4855-12.86 6.8135-3.8529-2.6965-2.5122-11.3338 0.1981-15.8188 2.5276-4.1825 8.6887-8.3913 12.2858-5.8835z'/%3E %3Cpath d='m1869.62 1287.55c3.9649 2.3077 3.0332 9.5902 0.4105 13.5334-2.7541 4.1392-9.8449 8.622-14.0022 6.1932-4.1952-2.451-2.7354-10.302 0.2157-14.3787 2.7522-3.8017 9.4604-7.6273 13.3771-5.3479z'/%3E %3Cpath id='piece6' d='m1831.34 1312.91c-3.3916 3.2346-0.7555 11.2719 2.7733 15.2819 3.7054 4.2091 11.7943 8.1045 15.3483 4.7027 3.5863-3.4329 0.2927-12.0241-3.5934-16.1312-3.6241-3.83-11.1791-7.0483-14.5293-3.8532z'/%3E %3Cuse xlink:href='%23piece6' x='-7.31929' y='13.7806'/%3E %3Cpath id='piece7' d='m1820.83 1339.55c-4.3482 1.7486-4.8759 10.1907-3.083 15.2224 1.8833 5.282 7.9545 11.896 12.5156 10.0521 4.6026-1.8607 4.7247-11.0608 2.6358-16.315-1.9481-4.8998-7.7742-10.687-12.0694-8.9598z'/%3E %3Cuse xlink:href='%23piece7' x='-10.5477' y='14.8521'/%3E %3Cpath id='piece8' d='m1802.66 1371.04c-4.5705 1.0369-6.4304 9.2885-5.4581 14.5409 1.0218 5.5138 5.9673 13.0069 10.763 11.9097 4.8395-1.1073 6.4191-10.1716 5.1899-15.6905-1.1464-5.1468-5.981-11.7847-10.4958-10.7605z'/%3E %3Cuse xlink:href='%23piece8' x='-10.1211' y='15.9316'/%3E %3Cpath id='piece9' d='m1784.06 1403.3c-4.6836 0.1712-8.0416 7.9347-8.0603 13.2763-0.019 5.6077 3.4514 13.888 8.3674 13.6993 4.9609-0.1905 8.1942-8.8046 8.0099-14.4558-0.1719-5.2701-3.6915-12.6895-8.3179-12.5204z'/%3E %3Cuse xlink:href='%23piece9' x='-10.3299' y='19.16'/%3E %3Cuse xlink:href='%23piece9' x='-22.3899' y='37.02'/%3E %3Cuse xlink:href='%23piece9' x='-34.87' y='52.31'/%3E %3Cuse xlink:href='%23piece9' x='-47.79' y='66.51'/%3E %3Cuse xlink:href='%23piece9' x='-61.99' y='78.14'/%3E %3Cuse xlink:href='%23piece9' x='-75.5599' y='90.62'/%3E %3Cpath d='m1692.79 1500.17l-5.2618 20.5953s2.9353 7.3347 5.9995 7.026c5.4811-0.552 6.9648-9.0469 8.0099-14.4557 0.9476-8.4237-8.7476-13.1656-8.7476-13.1656z'/%3E %3Cpath d='m2017.21 1513.25c1.6097 6.1241 15.2598 11.3138 15.2598 11.3138l-6.6509-27.7579c-5.7168 0.154-9.4945 12.4363-8.6089 16.4441z'/%3E %3Cpath d='m2016.01 1490.95c-4.3589-1.7217-10.549 4.0428-12.7088 8.9283-2.2663 5.1293-2.4091 14.1062 2.1699 15.9053 4.6206 1.8154 11.0377-4.7785 13.1357-10.0289 1.9564-4.8966 1.7085-13.1047-2.5973-14.8056z'/%3E %3Cpath id='piece10' d='m2000.82 1478.67c-4.6803-0.2433-8.7113 7.193-9.202 12.5121-0.5142 5.584 2.2105 14.1386 7.124 14.3851 4.9583 0.2487 8.9402-8.046 9.2562-13.6913 0.2944-5.2647-2.5557-12.9661-7.1789-13.2065z'/%3E %3Cuse xlink:href='%23piece10' x='-13.4001' y='-13.7001'/%3E %3Cuse xlink:href='%23piece10' x='-25.88' y='-29.23'/%3E %3Cuse xlink:href='%23piece10' x='-38.66' y='-42.32'/%3E %3Cuse xlink:href='%23piece10' x='-49.01' y='-60.28'/%3E %3Cuse xlink:href='%23piece10' x='-60.2801' y='-76.41'/%3E %3Cuse xlink:href='%23piece10' x='-70.63' y='-93.46'/%3E %3Cuse xlink:href='%23piece10' x='-79.76' y='-113.25'/%3E %3Cuse xlink:href='%23piece10' x='-89.81' y='-131.21'/%3E %3Cuse xlink:href='%23piece10' x='-98.03' y='-152.52'/%3E %3Cpath d='m1883.85 1304.56s-1.6473 26.6763 8.0374 28.389c6.0386 1.0678 10.7782-14.9091 10.7782-14.9091z'/%3E %3Cpath id='piece11' d='m1862.02 1610.75c-2.8778 3.699 0.9139 11.2601 4.9952 14.7063 4.2852 3.6171 12.8598 6.2779 15.8737 2.3895 3.0412-3.9239-1.4825-11.936-5.9313-15.4255-4.149-3.2541-12.0958-5.3239-14.9385-1.6701z'/%3E %3Cuse xlink:href='%23piece11' x='18.3' y='-2.15'/%3E %3Cuse xlink:href='%23piece11' x='36.81' y='-5.81'/%3E %3Cpath id='piece12' d='m1916.18 1603.8c-2.2897 4.0891 2.5943 10.9952 7.1468 13.7895 4.7797 2.9327 13.6566 4.2758 16.0525-0.021 2.4176-4.336-3.2579-11.578-8.1802-14.3601-4.5906-2.5942-12.7581-3.4473-15.02 0.592z'/%3E %3Cuse xlink:href='%23piece12' x='20.0199' y='-3.21989'/%3E %3Cpath id='piece13' d='m1953.48 1595.43c-1.9026 4.283 3.5981 10.7088 8.389 13.071 5.03 2.4789 13.993 2.9969 15.982-1.5028 2.0071-4.5407-4.3126-11.2279-9.4707-13.5437-4.8105-2.1594-13.0218-2.255-14.9012 1.9759z'/%3E %3Cuse xlink:href='%23piece13' x='18.94' y='-5.58998'/%3E %3Cpath id='piece14' d='m1991.26 1583.89c-1.6462 4.3879 4.2246 10.4775 9.1467 12.5525 5.1677 2.1773 14.1457 2.1649 15.8653-2.4445 1.7353-4.6513-4.9685-10.9534-10.2545-12.9604-4.9296-1.8714-13.1322-1.4816-14.7584 2.8528z'/%3E %3Cuse xlink:href='%23piece14' x='19.16' y='-6.23998'/%3E %3Cuse xlink:href='%23piece14' x='37.67' y='-13.9899'/%3E %3Cuse xlink:href='%23piece14' x='57.48' y='-22.17'/%3E %3Cuse xlink:href='%23piece14' x='77.5' y='-28.6299'/%3E %3Cuse xlink:href='%23piece14' x='79.87' y='-44.34'/%3E %3Cpath d='m2066.71 1534.88s13.5498 1.9917 14.7891-2.8749c1.6456-6.4625-15.4209-12.7452-15.4209-12.7452z'/%3E %3Cpath id='piece15' d='m1701.62 1575.59c-3.9861 2.4647-3.066 10.8731-0.4409 15.5252 2.7567 4.8833 9.8673 10.3646 14.0469 7.7697 4.2177-2.6186 2.7685-11.7047-0.186-16.5255-2.7555-4.4957-9.4834-9.2042-13.421-6.7695z'/%3E %3Cuse xlink:href='%23piece15' x='18.94' y='7.75003'/%3E %3Cuse xlink:href='%23piece15' x='37.03' y='10.55'/%3E %3Cuse xlink:href='%23piece15' x='56.83' y='15.5001'/%3E %3Cuse xlink:href='%23piece15' x='74.7' y='18.08'/%3E %3Cuse xlink:href='%23piece15' x='92.35' y='21.74'/%3E %3Cuse xlink:href='%23piece15' x='110.43' y='26.69'/%3E %3Cuse xlink:href='%23piece15' x='128.3' y='29.92'/%3E %3Cuse xlink:href='%23piece15' x='146.6' y='32.72'/%3E %3Cpath d='m1648.16 1517.51c-4.1667-2.1454-10.8978 2.9772-13.5312 7.6245-2.7637 4.8794-3.7956 13.7979 0.5824 16.042 4.4179 2.2645 11.457-3.6607 14.0652-8.6773 2.4321-4.6785 2.9991-12.8708-1.1168-14.9901z'/%3E %3Cpath d='m1642.01 1534.4c-4.4151-1.5719-10.4047 4.4008-12.3964 9.3572-2.0898 5.2037-1.9258 14.1803 2.7119 15.8218 4.6799 1.6566 10.868-5.1526 12.7855-10.4717 1.7879-4.9605 1.2598-13.1554-3.1015-14.7082z'/%3E %3Cpath d='m1647.74 1549.94c-4.5395-1.1649-9.9626 5.3264-11.4964 10.4431-1.6092 5.3718-0.6317 14.2965 4.1358 15.5106 4.8109 1.2252 10.3558-6.1173 11.7829-11.5884 1.3306-5.1022 0.061-13.2154-4.4229-14.3661z'/%3E %3Cpath d='m1662.37 1556.31c-4.499-1.3127-10.1315 4.9978-11.8319 10.0615-1.784 5.3163-1.0989 14.2682 3.6263 15.6376 4.7683 1.3819 10.5504-5.7753 12.1556-11.1967 1.4968-5.056 0.4935-13.2064-3.9506-14.5032z'/%3E %3Cpath id='piece16' d='m1671.91 1558.81c-4.5474 1.1337-6.2318 9.4229-5.1483 14.6535 1.1385 5.4908 6.242 12.8773 11.0134 11.6786 4.8148-1.2097 6.2017-10.3055 4.8557-15.7971-1.2554-5.1213-6.2297-11.6551-10.7217-10.5354z'/%3E %3Cuse xlink:href='%23piece16' x='16.79' y='6.23999'/%3E %3Cuse xlink:href='%23piece6' x='8.61071' y='-11.1894'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='6.47'/%3E %3Cuse xlink:href='%23piece6' x='4.91148' y='26.6794'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='47.8699'/%3E %3Cuse xlink:href='%23piece6' x='5.57' y='68.5699'/%3E %3Cuse xlink:href='%23piece6' x='2.22005' y='87.7499'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='109.06'/%3E %3Cuse xlink:href='%23piece6' x='2.22004' y='126.41'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='143.46'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='163.86'/%3E %3Cuse xlink:href='%23piece6' x='3.44006' y='183.95'/%3E %3Cuse xlink:href='%23piece6' x='3.74' y='203.13'/%3E %3Cuse xlink:href='%23piece6' x='4.35006' y='223.52'/%3E %3Cuse xlink:href='%23piece6' x='4.35006' y='243.31'/%3E %3Cuse xlink:href='%23piece6' x='3.74' y='263.1'/%3E %3Cuse xlink:href='%23piece6' x='2.52' y='283.19'/%3E %3Cuse xlink:href='%23piece6' x='2.52' y='305.11'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='327.94'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='349.25'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='369.04'/%3E %3Cuse xlink:href='%23piece6' x='1.31006' y='391.27'/%3E %3Cpath id='piece17' d='m1882.24 1303.18c2.4423 3.7068-1.3196 10.8321-5.1636 13.9699-4.036 3.2931-11.9117 5.4626-14.4688 1.5665-2.5804-3.9315 1.8636-11.4583 6.0421-14.6207 3.8968-2.949 11.1785-4.577 13.5912-0.9154z'/%3E %3Cuse xlink:href='%23piece17' x='2.74003' y='16.13'/%3E %3Cuse xlink:href='%23piece17' x='2.43002' y='34.1'/%3E %3Cuse xlink:href='%23piece17' x='2.13' y='52.36'/%3E %3Cuse xlink:href='%23piece17' x='1.82003' y='69.11'/%3E %3Cuse xlink:href='%23piece17' x='2.74002' y='87.07'/%3E %3Cuse xlink:href='%23piece17' x='1.52002' y='104.42'/%3E %3Cpath d='m1883.25 1426.06c2.6959 3.8337-1.4565 11.2029-5.6994 14.448-4.4549 3.4059-13.148 5.6497-15.9706 1.6202-2.8482-4.0661 2.0571-11.8504 6.6693-15.1211 4.3012-3.05 12.3386-4.7336 15.0017-0.9467z'/%3E %3Cpath id='piece18' d='m1882.09 1443.58c3.3915 3.2345 0.7554 11.2718-2.7734 15.2819-3.7054 4.209-11.7943 8.1044-15.3482 4.7026-3.5863-3.4328-0.2928-12.0241 3.5933-16.1312 3.6241-3.83 11.1791-7.0482 14.5293-3.8532z'/%3E %3Cuse xlink:href='%23piece18' x='.610044' y='20.4001'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='40.4901'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='62.11'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='82.2'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='102.6'/%3E %3Cuse xlink:href='%23piece18' x='.610044' y='122.99'/%3E %3Cuse xlink:href='%23piece18' x='.610045' y='143.69'/%3E %3Cuse xlink:href='%23piece18' x='-.299955' y='164.4'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='183.27'/%3E %3Cuse xlink:href='%23piece18' x='.92' y='203.06'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='224.37'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='245.37'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fa0204' d='m1849.64 1848.26c19.9021 5.5241 31.7591 5.236 48.2193 0.4305l-17.4364-27.9844'/%3E %3Cpath fill='%23ce9d09' d='m1888.31 1776.16-31.7083-8.1414s0.3666-35.1832 20.3893-32.1154c16.6195 2.5464 11.9853 40.3409 11.319 40.2568z'/%3E %3Ccircle fill='%23ce9d09' cx='1872.8856' cy='1722.9711' r='12.9159'/%3E %3Cpath fill='%23fa0204' d='m1885.37 1791.86c7.0484 17.8642 11.3696 33.2411 4.7358 53.3857m7.5972 3.4126c-10.2262-8.2551-36.5822-5.8322-47.9812-0.3475-4.4526 0-16.4454-83.2401 25.7219-81.1827 38.7211 1.8892 24.9493 81.9145 22.2593 81.5302z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fa0204' d='m1815.2 1866.34c19.2918 12.2385 37.2498 11.1397 54.2468 0.4305l-40.2546-41.9766'/%3E %3Ccircle fill='%23ce9d09' cx='1843.3956' cy='1738.2551' r='12.9159'/%3E %3Cpath fill='%23ce9d09' d='m1859.33 1780.02-32.7202-0.6458s-4.2451-26.6125 16.1449-27.7691c16.9243-0.96 17.2516 28.3629 16.5753 28.4149z'/%3E %3Cpath fill='%23fa0204' d='m1843.61 1860.74c-6.2615-13.9097-6.9109-31.0263-5.1664-49.5109m-9.4716 50.372c-7.6816-13.1828-9.1065-30.0153-3.0137-51.233m43.4039 56.6355c-4.9263-6.1908-40.2274-8.8289-54.0959-0.3918-5.02 0-18.5411-93.8481 28.9999-91.5285 43.6557 2.13 28.1288 92.3536 25.096 91.9203z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 72 48'%3E %3Crect width='72' height='48' fill='%23009e60'/%3E %3Crect width='54' height='48' fill='%23fcd116'/%3E %3Crect width='18' height='48' fill='%230072c6'/%3E %3Cg fill='%23009e60'%3E %3Cpath d='m32,34 4,8 4,-8 -4,-8z'/%3E %3Cpath d='m27,24 4,8 4,-8 -4,-8z'/%3E %3Cpath d='m37,24 4,8 4,-8 -4,-8z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 180 120'%3E %3Cdefs%3E %3Cg id='s' transform='translate(0,-36)'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-5V0H3z' fill='%23fff' transform='rotate(18,0,-5)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3C/defs%3E %3Cpath d='M0,0H180V120H0z' fill='%23cf142b'/%3E %3Cpath d='M0,0H180V80H0z' fill='%2300247d'/%3E %3Cpath d='M0,0H180V40H0z' fill='%23ffcc00'/%3E %3Cg transform='translate(90,84)'%3E %3Cg id='s4'%3E %3Cg id='s2'%3E %3Cuse xlink:href='%23s' transform='rotate(10)'/%3E %3Cuse xlink:href='%23s' transform='rotate(30)'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='rotate(40)'/%3E %3C/g%3E %3Cuse xlink:href='%23s4' transform='rotate(-80)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Cdefs%3E %3ClinearGradient id='grad' gradientUnits='userSpaceOnUse' x1='103.083' y1='111.276' x2='92.5511' y2='107.764' gradientTransform='matrix(0.99614143,0,0,2.2525522,703.84172,-75.047171)'%3E %3Cstop stop-color='%23f00' offset='0'/%3E %3Cstop stop-color='%23ff0' offset='1'/%3E %3C/linearGradient%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m776.26,144.068,250.401-0.92914-0.4646,222.992s8.8267,33.9134-104.992,85.4802c40.8818-4.18106,85.4802-47.8503,85.4802-47.8503s18.1181-23.2281,26.9449-10.2204c8.8267,13.0077,17.1889,19.5117,23.6928,24.622,6.504,5.11021,11.614,19.0472,1.8582,29.2676s-25.0866,11.6142-29.2676-0.92915c-6.504,3.25205-46.4568,51.5669-128.22,53.8897-83.1573-1.39373-128.685-54.3542-128.685-54.3542s-11.1496,17.6537-26.9448,3.71663c-15.3307-18.1182-3.71653-29.7324-3.71653-29.7324s13.0078-7.43296,16.7244-12.5433c6.03938-6.96852,7.89764-16.2598,18.1181-16.2598,12.0787,0.92916,16.7244,10.685,16.7244,10.685s41.811,44.134,86.8739,49.7086c-101.736-48.783-105.453-78.98-104.988-86.413l0.46458-221.133z'/%3E %3Cpath fill='%23006129' stroke='%23000' stroke-width='1.8873' d='m782.299,150.107,238.787-1.39371,0,214.63c0.4645,27.874-46.4566,56.2125-119.858,92.4486-75.7244-39.0236-119.394-62.7163-119.858-92.9131l0.92912-212.771z'/%3E %3Cg id='lamp' fill='%23f7c600' stroke='%23000' stroke-width='0.9437'%3E %3Cpath fill='none' stroke='%23f7c600' stroke-width='1.8873' d='m814.794,181.829,14.095-20.7013,14.1636,20.7446'/%3E %3Cpath d='m831.719,174.09c0.00053,1.54631-1.25288,2.80012-2.79923,2.80012s-2.79977-1.25381-2.79924-2.80012c-0.00053-1.54631,1.25289-2.80013,2.79924-2.80013s2.79976,1.25382,2.79923,2.80013z'/%3E %3Cpath d='m817.444,197.119,21.8516,0.0622s0.34262-2.83593-2.28248-4.55956c11.4454-1.57386,8.47204-11.6694,18.0575-12.2416,1.85988,0.28611-5.00735,4.29202-5.00735,4.29202s-5.77927,4.07838-3.14748,6.15185c2.08942,1.64618,3.00441-1.00133,3.29056-3.00428,0.28613-2.00296,9.29933-3.29055,8.01175-9.01315-2.14601-4.72127-14.7359,3.14727-14.7359,3.14727l-8.98216-0.0498c-0.56005-1.00812-3.03547-5.05072-5.59189-5.06944-3.03289,0.11067-5.16923,5.11927-5.16923,5.11927h-13.0191-7.29642s-0.69652,5.21257,9.60433,6.21405c2.31918,3.02889,4.11696,3.87515,6.13307,4.65921-1.34408,1.12015-1.72246,2.47524-1.71681,4.29203z'/%3E %3Cpath d='m819.017,192.684,18.2006-0.062'/%3E %3Cpath d='m810.681,181.953s1.45607,8.51263,8.17643,10.5287'/%3E %3Cpath fill='url(%23grad)' d='m809.561,181.841c0.67203-3.24812,1.90411-3.80827,3.24818-7.95248,0.22402-4.03218-3.24818-3.58421-2.24012-6.1603,1.79209-2.80015,0.89605-5.48827-2.46413-7.61639,0.67204,3.69624-4.36823,7.16842-4.36823,10.1925,0,3.02421,2.57614,2.35218,2.24012,6.94451,0.22402,2.68797-0.67203,2.01609-0.89604,4.59218h4.48022z'/%3E %3Cpath d='m831.495,161.657c0.00049,1.42254-1.15262,2.576-2.57522,2.576-1.42259,0-2.5757-1.15346-2.57521-2.576-0.00049-1.42254,1.15262-2.576,2.57521-2.576,1.4226,0,2.57571,1.15346,2.57522,2.576z'/%3E %3C/g%3E %3Cuse xlink:href='%23lamp' x='-0.77220062' y='41.304015'/%3E %3Cuse xlink:href='%23lamp' x='-1.0892006' y='82.013015'/%3E %3Cuse xlink:href='%23lamp' x='25.626799' y='126.09901'/%3E %3Cuse xlink:href='%23lamp' x='-4.5742006' y='162.16301'/%3E %3Cuse xlink:href='%23lamp' x='-3.7822006' y='204.77301'/%3E %3Cuse xlink:href='%23lamp' x='146.2798' y='0.67201485'/%3E %3Cuse xlink:href='%23lamp' x='144.9358' y='41.218015'/%3E %3Cuse xlink:href='%23lamp' x='143.1438' y='82.661015'/%3E %3Cuse xlink:href='%23lamp' x='145.1598' y='123.43101'/%3E %3Cuse xlink:href='%23lamp' x='144.7118' y='164.20101'/%3E %3Cuse xlink:href='%23lamp' x='144.9358' y='205.19501'/%3E %3Cg fill='%23ffc6b5' stroke='%23000' stroke-width='0.9437'%3E %3Cpath fill='%23f7c600' d='m915.843,406.315s5.70236,13.1472,12.1968,5.06884c6.49443-8.07841,4.11854-11.5633,4.11854-11.5633l-14.573-7.92002-4.27677,9.02885,2.53442,5.3856z'/%3E %3Cpath d='m928.357,404.572s0.95029,0.15854,1.74235-1.26706c0.79206-1.42559-1.74235-2.05942-2.85118-3.64339l-1.26721,2.53457,2.37604,2.37588z'/%3E %3Cpath d='m895.409,401.087-12.8305,6.96957s-6.33605,1.26706-6.8112,0c-0.47529-1.2672,0.15839-2.37603,3.48472-2.53441,3.32648-0.15839,12.3553-8.39532,12.3553-8.39532l3.80163,3.96016z'/%3E %3Cpath d='m895.568,173.149s0.31677,3.00961,0.47515,4.59362c0.15838,1.584-2.53442,4.91039-2.6928,4.752s-1.42559,0.15839-1.26721,1.10884c0.15838,0.95044,2.05927,1.26722,2.05927,1.26722s-0.79206,3.32639,0,3.48477c0.79191,0.1584-2.05927,4.27696,0,5.38568,2.05912,1.10872,5.54398,2.53433,7.12796,2.21755,1.58397-0.31678,0,6.17762,0,6.17762l-4.43516,9.504,24.3936-2.53432-5.06884-8.07851s-2.37588-1.584-1.74235-6.17762c0.63368-4.59361-0.31677-25.344-0.31677-25.344l-17.424-2.37606-1.10883,6.01923z'/%3E %3Cpath d='m891.132,209.264s-7.92002,3.64329-7.60326,13.4641c-2.05912,9.50401-3.16795,19.008-3.16795,19.008s-9.34561,10.6127-12.1968,14.4144c-2.85118,3.80165-7.12811,11.5632-8.71208,13.6224-1.58398,2.05929-7.76158,8.87057-7.6032,11.4049,0.1584,2.53427-1.4256,13.7809,4.752,15.048,1.58399,0.63353,6.65283-12.9889,6.65283-12.9889s0.31676-5.86068-1.4256-6.96953c-1.74235-1.10882,3.80163-4.9105,3.80163-4.9105s10.6128-7.76162,12.9889-9.66239c2.37603-1.90078,8.87046-9.18722,8.87046-9.18722l3.6431-43.2433z'/%3E %3Cpath fill='%23fff' d='m900.161,201.82s2.05927,5.54406,6.65281,4.59362c4.59369-0.95045,9.97929-5.22716,9.97929-5.22716s4.27678-0.1584,4.91046,0.47516c0.63353,0.63356,11.5631,11.2463,11.2464,14.5728-0.31677,3.32651-5.06884,2.37595-6.8112,4.59362-1.74235,2.21767-4.59369,7.76162-3.80162,11.8801,0.79206,4.11845,3.16794,9.50413,2.85118,11.5633-0.31677,2.05917-2.05912,2.69273-2.05912,3.80155,0,1.10885,1.42559,3.00974,1.42559,5.0689,0,2.05917-1.90089,5.06867-1.58397,7.12794,0.31676,2.05929,0.47514,8.0784,0.47514,8.0784l-0.47514,27.8785s1.58397,0.95029,1.74235,2.53442c0.15838,1.58397,10.7712,47.6785,10.7712,47.6785s-0.47514,1.42559-1.58397,1.26721c-1.10883-0.15839,4.27677,7.12795,4.43516,9.18722,0.15838,2.05928,5.54413,18.2162,5.3856,20.4337-0.15838,2.2175-0.9503,7.12796-1.42559,7.28634-0.47515,0.15838,3.48486,10.1377,2.85118,11.7216-0.63353,1.58397-7.12796,1.42559-7.12796,1.42559l-1.74235-0.31676s0.15838,2.05927-1.10883,2.21765-10.6128-0.4753-10.6128-0.4753-2.6928,4.11839-4.27677,3.96001c-1.58413-0.15838-3.64325-3.00956-4.11855-2.53427-0.47514,0.47515,1.42574,3.1678,0.95045,3.95986-0.47515,0.79206-8.55355,2.53457-10.1377-1.26706-1.58397-3.80162,0.95045-2.85133,0.4753-3.64324-0.4753-0.79206-4.11839-2.85118-5.22722-2.21765-1.10882,0.63352,2.85119,1.58397,2.6928,3.16809-0.15838,1.58398-3.48486,3.95986-4.75207,3.95986s-4.27677-5.86075-8.71193-5.22707c-4.43531,0.63353-7.28649,1.74236-7.28649,1.74236s-5.22722,2.2175-7.44487,1.74236c-2.2175-0.47515-3.16795-2.21766-3.16795-3.16795,0-0.95045,1.58397-5.06884,1.42559-6.33605s-1.42559-2.53442-1.42559-4.4353c0-1.90074,3.64325-8.39517,3.64325-8.39517l-0.15839-29.1457s-3.32648-0.00015-3.48486-2.05927,5.06884-46.0945,5.86075-48.9457c0.79206-2.85118,2.85133-12.9888,2.85133-12.9888s-2.37603,1.10882-2.53442,0c-0.15838-1.10883,7.12796-26.2944,7.12796-26.2944s1.26721-12.5137,1.26721-15.8401c0-3.32639-0.63353-7.92001-0.63353-7.92001s-6.50318-2.75297-6.65296-6.96956c-0.59473-6.70875,6.17766-10.4546,6.96973-12.6721,0.79191-2.21755,3.16794-8.87033,3.16794-8.87033s3.48487-6.01923,9.18723-6.96968z'/%3E %3Cpath fill='%23f7c600' d='m897.785,402.988s-15.3648,8.07855-17.5824,8.71208c-2.21765,0.63353-3.64324-2.6928-1.42559-3.32648,2.21765-0.63353,5.70236-0.95045,5.70236-0.95045s-5.22721-4.11839-5.06883-4.27677c0.15853-0.15838,7.12811-2.69265,7.28649-2.69265s2.21765,4.11824,3.64324,3.80148c1.4256-0.31677,5.54399-3.48471,5.54399-3.48471s2.21765,2.53441,1.90074,2.2175z'/%3E %3Cpath d='m919.432,407.423c1.45277,1.87357,2.02077,5.1232,5.34725,3.22246,3.32633-1.90074-1.70401-5.42879-1.70401-5.42879l-3.64324,2.20633z'/%3E %3Cpath d='m925.505,407.106s1.58398,1.26721,3.00957-0.15838-2.85133-4.43516-2.85133-4.43516l-2.05913,2.37604,1.90089,2.2175z'/%3E %3Cpath d='m932.317,216.96c0.15838,0,5.22722,15.6817,5.86074,19.6417,0.63368,3.95995,2.6928,19.8,1.90089,22.0176-0.79206,2.21767-8.87046,12.8304-9.82091,15.5232-0.95044,2.69283-6.65281,12.989-6.65281,12.989s-1.42559,10.1377-2.05927,10.6128c-0.63353,0.47529,1.63531,2.96351,1.42575,3.80162-0.31435,0.9429-4.59369,5.3856-6.49443,4.91046-1.90089-0.4753-4.91046-2.69295-5.06884-4.75207s0.15838-8.87047,1.58397-10.6128c1.4256-1.74236,8.87047-19.3249,9.34562-20.4337,0.47514-1.10884,6.81119-14.8896,6.96957-17.2656,0.15853-2.37605-1.97095-7.87036-4.2111-9.88644-4.98549-14.6729-3.02662-23.5215,7.22082-26.5457z'/%3E %3Cpath fill='%239c5100' d='m895.092,172.199s3.48487,0.47506,5.38561-0.63366c1.90089-1.10873,4.11854-1.58389,5.70251,0.63366,1.58398,2.21756,2.6928,2.05917,2.6928,2.05917s-2.37603,5.86073,0,6.49439c2.37604,0.63367,3.48471,0.63356,3.64325,1.42561,0.15838,0.79206-2.05927,2.53434-1.42574,3.32639,0.63368,0.79206,1.7425,1.74251,1.90088,2.37607,0.15839,0.63356-1.42559,3.32627-0.95044,3.95995,0.4753,0.63366,1.90089,3.16811,2.85118,3.16811,0.95045,0,0.31692,3.96005,3.1681,3.00961s2.6928-3.48489,2.6928-3.48489,3.00957-0.47516,3.80163-3.16801c0.79191-2.69283,2.6928-3.32639,2.6928-3.32639s3.80163-2.05917-1.26721-5.22716c0-22.1761-14.5728-19.8001-14.5728-19.8001s-1.74251-3.96017-4.59369-3.48489-3.00956,3.80179-5.06884,3.48489c-2.05912-0.31688-2.53426-1.74238-2.6928-1.58399-0.15838,0.15839-1.90073,3.32627-1.90073,4.11834,0,0.79204-5.54399-1.10885-5.06884,3.00961,0.47515,4.11845,3.16795,3.96005,3.00956,3.64327z'/%3E %3Cg fill='none'%3E %3Cpath d='m920.753,207.997s-14.0977,9.02885-13.7809,12.1968'/%3E %3Cpath d='m923.921,209.581s-3.16795,3.48477-3.32633,3.48477'/%3E %3Cpath d='m928.198,213.383s-6.96972,5.70244-5.86089,9.34561'/%3E %3Cpath d='m895.251,207.205s-2.05912,4.27673-1.58398,5.70234c0.4753,1.42561,3.96001,6.81128,4.43531,10.1377,0.47515,3.32639,0,5.70246,0,5.70246'/%3E %3Cpath d='m891.608,215.125s0.63353,5.06889,1.58398,6.01922c0.95044,0.95034,3.48486,5.22717,3.80162,6.96956'/%3E %3Cpath d='m890.341,236.192s4.1184,2.05939,7.92002-5.86073'/%3E %3Cpath d='m904.438,224.788c-0.15839,0-3.00957,7.76162,2.05927,10.6128,5.06883,2.85121,8.87046,2.53433,11.088,1.74238,2.21766-0.79194,4.59369-2.21756,4.59369-2.21756'/%3E %3Cpath d='m902.221,234.292s0.31677,10.4546,15.6817,20.7505'/%3E %3Cpath d='m902.854,244.112s-0.15838,9.18712,5.8609,13.3056'/%3E %3Cpath d='m899.686,233.341s-4.59369,13.6223-8.23678,15.048'/%3E %3Cpath d='m898.261,243.32s-0.15838,9.8209-1.42559,13.3057'/%3E %3Cpath d='m895.568,259.002s3.16795,3.96007,6.65281,3.64329c3.48471-0.31678,4.91031-4.43533,7.28634-3.80167,2.37604,0.63367,4.59369,2.53456,10.1377,2.05929'/%3E %3Cpath d='m911.725,265.021s0,8.07839,1.42559,8.87045,0.79206,8.2368,0.79206,8.2368'/%3E %3Cpath d='m892.4,261.22s-0.15838,7.60335-1.10882,10.2961c-0.9503,2.69273-2.85119,7.28645-2.53427,11.2464'/%3E %3Cpath d='m882.737,287.197c0.79191-0.31676,3.48486-2.69265,3.48486-2.69265'/%3E %3Cpath d='m887.648,286.247s-6.81134,29.1458-4.91045,46.5698'/%3E %3Cpath d='m889.232,287.673s-3.48487,21.8593-1.90089,25.9777'/%3E %3Cpath d='m887.489,287.039c0.15838,0,13.3056,0.95029,13.3056,0.95029'/%3E %3Cpath d='m902.696,286.247s3.64324,1.90089,8.71208,1.58397'/%3E %3Cpath d='m901.112,296.86s-0.63368,37.3826-1.58398,45.6194'/%3E %3Cpath d='m920.595,305.413s4.11839,32.7889,6.49443,35.7985'/%3E %3Cpath d='m912.675,309.532s2.53442,28.9873,3.96001,31.5217'/%3E %3Cpath d='m876.718,351.191s4.9103-1.58413,9.34546-6.33605c5.06899,6.81119,12.8305,0.31692,12.8305,0.31692s12.0384,8.23678,17.4242-0.95045c8.23678,5.3856,12.3552-0.79206,12.3552-0.79206s3.00972,4.59354,5.22722,4.11839'/%3E %3Cpath d='m920.753,350.716s6.17767,28.9874,15.3649,37.2242'/%3E %3Cpath d='m888.915,347.706s0.79191,24.2354,2.21751,41.3424'/%3E %3Cpath d='m887.806,375.11s-0.79207,15.84-1.74251,16.9489'/%3E %3Cpath d='m878.46,393.642s1.74236,6.81134,10.4544,0.4753c8.71193-6.3362,8.87032,2.37603,9.18723,3.32633,0.31677,0.95029,1.74236,7.76163,5.06869,2.05927'/%3E %3Cpath d='m910.141,390.158s-1.42559,14.0974,11.088,3.80147c12.5137-10.2959,14.5728-0.15823,14.8896,3.00972'/%3E %3Cpath d='m910.299,166.813s-1.10882,6.96954,6.33605,6.336c-0.95044,3.80167,1.90074,5.0689,1.90074,5.0689'/%3E %3Cpath d='m924.08,182.495c0.15853,0,3.32648,2.05916-0.15838,4.59361'/%3E %3Cpath d='m913.309,188.039s1.58382,1.90089,3.32633,1.42573c1.74236-0.47518,4.59354,1.74239,4.59354,1.74239s2.37603,0.79194,2.6928,0.31678'/%3E %3Cpath d='m903.646,194.058s5.38561,2.05927,8.87047-6.4944'/%3E %3Cpath d='m893.667,185.029,3.1681,0.1584'/%3E %3Cpath d='m858.523,284.924,0.24792,6.94179'/%3E %3Cpath d='m852.013,284.409s4.45059,7.44321,4.0787,11.4099'/%3E %3Cpath stroke-linejoin='round' d='m894.142,188.197,2.85118,0-2.53441,1.10883'/%3E %3Cpath stroke-linejoin='round' d='m911.665,299.962s3.32769-0.34968,3.2229,5.20608c2.12495-6.90163,6.44581-7.0656,6.44581-7.0656'/%3E %3Cpath stroke-width='1.6986' stroke-linejoin='round' d='m898.102,179.327c0.47515,0,2.2175-0.63368,2.53442-0.15839,0.31676,0.47528-1.90089,0.79206-2.53442,0.15839z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='1.8873'%3E %3Cpath fill='%23f7c600' d='m900.299,458.579c66.8976-1.85832,110.102-50.1732,109.638-50.6378-0.4645-0.46458,8.8268-13.4724,16.2599-11.6142,7.4331,1.85832,18.1181,23.6929,31.1259,28.3385,6.5038,10.2204-1.8583,19.5118-4.6457,21.3701-2.7874,1.85831-15.3307,6.96852-17.189-0.46458-1.8581-7.43309-5.5747-6.03935-5.5747-6.03935s-59.4645,58.0707-128.22,55.748c-71.0786,0.46458-129.614-55.748-129.614-55.748l-5.11024,5.57477s-5.57479,6.03937-8.36219,5.57479c-2.78738-0.46458-14.8661-8.3621-15.7952-16.2598-0.92914-7.89767,7.43306-13.0079,7.43306-13.0079s20.4409-15.7954,22.7637-24.1575c4.64566-4.64561,13.4724,3.25189,13.4724,3.25189s53.8897,61.7873,113.819,58.0709z'/%3E %3Cpath d='m748.855,422.646s5.52789-1.4742,7.55478,0.82921c2.0269,2.30327,15.9387,15.9388,15.9387,15.9388'/%3E %3Cpath d='m761.477,429.095-5.52789,4.14587s13.9119,2.76361,10.7794,11.8849'/%3E %3Cpath d='m1052.34,422.185s-2.7641-1.47421-7.0941,1.7505c-4.3303,3.22456-15.294,15.4781-15.294,15.4781'/%3E %3Cpath d='m1039.9,428.727,5.9885,4.60653s-12.5298,0.8292-9.7659,12.7142'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m819.664,437.396c-0.36233,1.05196-1.32124-0.0286-2.1167,0.18281-2.09463,0.0787-3.83438,1.44493-5.62783,2.37754-6.13592,3.57703-12.2718,7.15406-18.4078,10.7311-0.61916-0.20373-0.47224-0.70419-0.32125-1.20622,1.63543-7.66322,3.3341-15.3134,4.92489-22.9858,0.26406-1.34229,0.68917-3.00961-0.60666-3.98662-0.55081-0.37618,0.30172-1.13938,0.65524-0.44562,3.13656,2.23685,6.27311,4.47369,9.40967,6.71054-0.30176,0.88447-0.8363,0.2643-1.3719-0.0946-1.30246-1.25352-2.87297-0.0955-2.83433,1.48783-1.11932,5.05195-2.21088,10.1101-3.31857,15.1646,4.16553-2.47603,8.37867-4.87373,12.5066-7.41174,1.47316-0.65547,2.56043-2.63086,1.02815-3.85506-0.58172-0.34251-1.5433-1.27927-0.58447-1.42187,2.22165,1.58438,4.44331,3.16877,6.66496,4.75315z'/%3E %3Cpath d='m826.275,469.382c-0.16777,0.5721-0.46619,0.69814-0.92215,0.2864-3.69141-2.01877-7.38282-4.03754-11.0742-6.05631,0.16777-0.5721,0.4662-0.69816,0.92216-0.28641,0.99931,0.68068,2.63447,0.93833,3.36348-0.25422,1.46548-2.35102,2.70085-4.83909,4.05889-7.25394,1.8462-3.41959,3.76974-6.79894,5.55943-10.2479,0.85611-1.22152-0.0994-2.72784-1.29719-3.25104-0.40497-0.21691-1.00172-0.37764-0.48962-0.86318,0.2462-0.30433,0.77152,0.34421,1.12983,0.42258,3.53863,1.93522,7.07727,3.87043,10.6159,5.80565-0.16777,0.5721-0.46619,0.69816-0.92215,0.28642-1.001-0.67935-2.64214-0.9398-3.37996,0.24523-1.46544,2.35104-2.70083,4.83909-4.05887,7.25394-1.84621,3.41958-3.76975,6.79893-5.55945,10.2479-0.85548,1.23068,0.0966,2.74667,1.31365,3.26002,0.24676,0.13495,0.49352,0.26991,0.74028,0.40486z'/%3E %3Cpath d='m868.884,459.388c-1.00242,2.8143-2.00484,5.62861-3.00726,8.44291-1.2319-0.13004-0.41252-1.7076-0.79582-2.53896-0.43991-3.80009-3.2427-7.34798-7.06085-8.16085-2.91908-0.79536-6.00002,0.70778-7.71381,3.08201-2.59075,3.5364-4.16561,7.85282-4.38703,12.2348-0.14778,2.49015,0.99504,5.04624,3.16882,6.35708,1.72432,1.13596,3.81745,1.593,5.86414,1.53554,0.72218-2.12904,1.58542-4.21491,2.1873-6.38101,0.24699-1.40888-1.20996-2.26005-2.37507-2.58291-0.18191-0.40867,0.26984-0.91183,0.74426-0.47135,3.67913,1.31047,7.35827,2.62093,11.0374,3.9314-0.13183,1.3581-1.66681-0.10859-2.51672,0.4334-1.35963,0.5218-1.47634,2.15677-1.99174,3.33918-0.44831,1.25866-0.89663,2.51732-1.34495,3.77598-4.94585,0.34999-10.0434-0.69666-14.3476-3.186-4.18483-2.6372-7.01502-7.72851-6.19175-12.7222,0.63731-4.27402,3.30111-8.27732,7.24184-10.1654,3.61966-1.92325,8.03709-1.91584,11.7955-0.3912,2.05559,0.69257,3.82986,1.96318,5.42017,3.40994,0.96375,1.30024,2.82894,1.30279,3.61967-0.17512,0.21785,0.0776,0.43569,0.15518,0.65354,0.23277'/%3E %3Cpath d='m886.836,488.201c-0.0223,0.44877-0.0724,0.85974-0.60997,0.60926-4.21257-0.63812-8.42515-1.27625-12.6377-1.91437,0.0223-0.44877,0.0724-0.85976,0.60998-0.60927,1.09552,0.22381,2.56416,0.20525,3.09269-0.97692,0.53524-1.68791,0.64169-3.47598,0.94965-5.21478,0.72349-4.8563,1.49549-9.70591,2.18624-14.5667,0.26829-1.04778-0.0904-2.23279-1.17512-2.63961-0.6141-0.29133-1.2988-0.33485-1.95936-0.44497,0.0223-0.44877,0.0724-0.85976,0.60997-0.60928,4.21257,0.63813,8.42515,1.27626,12.6377,1.91439-0.0223,0.44877-0.0724,0.85974-0.60998,0.60927-1.1016-0.2267-2.56339-0.19692-3.11123,0.97411-0.53526,1.68791-0.64169,3.47598-0.94966,5.21477-0.72349,4.85631-1.49546,9.70593-2.18623,14.5668-0.26553,1.04485,0.0941,2.25417,1.18531,2.64856,0.61993,0.28179,1.3048,0.32904,1.96771,0.43882z'/%3E %3Cpath d='m920.954,479.914c-0.16674,2.98737-0.33347,5.97475-0.50021,8.96212-7.51522,0.38345-15.0304,0.7669-22.5457,1.15035-0.13786-0.54875,0.009-0.84067,0.60604-0.72557,1.13326,0.0288,2.59279-0.4515,2.73734-1.75192,0.10037-2.22701-0.15016-4.45454-0.22473-6.68127-0.2431-4.44122-0.41871-8.88702-0.70892-13.325,0.12388-1.32148-1.06672-2.30103-2.32047-2.26067-0.39826-0.20163-1.47506,0.4153-1.36759-0.31092-0.18148-0.58815,0.63507-0.2751,0.98049-0.38746,4.18034-0.2133,8.36067-0.42659,12.541-0.63988,0.13785,0.54874-0.009,0.84069-0.60604,0.7256-1.15864-0.006-2.66506,0.27574-2.98562,1.58332-0.18294,1.92668,0.086,3.86449,0.13757,5.79531,0.25424,4.62527,0.43398,9.2557,0.73973,13.8774-0.0938,1.20984,0.87722,2.28029,2.13026,2.04705,1.83023-0.0915,3.69956-0.0136,5.48649-0.47334,2.50745-0.66714,3.8741-3.15018,4.56089-5.46973,0.44973-0.62711,0.0775-2.19165,1.07054-2.10165,0.0896-0.005,0.17929-0.009,0.26893-0.0137'/%3E %3Cpath d='m938.531,458.219c-0.59756,0.0106-0.3343,0.77285-0.48591,1.17286-0.99799,7.4764-1.94375,14.9603-2.97613,22.4318-0.251,1.6554-0.66406,3.58785-2.29741,4.42578-0.60243,0.21391-0.072,1.16167,0.48021,0.63456,2.50975-0.75292,5.01949-1.50585,7.52924-2.25877-0.0947-1.26854-1.54038-0.11599-2.3501-0.33901-1.7273-0.002-1.98401-2.09956-1.7436-3.41099,0.10417-0.88542,0.20833-1.77083,0.3125-2.65625,2.875-0.86458,5.75-1.72917,8.625-2.59375,1.10069,1.38573,2.31391,2.69066,3.30954,4.15271,0.74791,1.41036-1.0692,2.05489-2.12457,2.3273-0.49289,0.0522-0.0627,1.08444,0.38688,0.6048,3.77813-1.13243,7.55627-2.26487,11.3344-3.39731-0.0343-1.28248-1.67666-0.0806-2.36866-0.93623-2.12162-1.59417-3.64389-3.81223-5.39981-5.7751-4.07719-4.79409-8.15438-9.58846-12.2316-14.3824zm-0.0625,8.96875c2.04167,2.4375,4.08333,4.875,6.125,7.3125-2.44792,0.72917-4.89583,1.45833-7.34375,2.1875,0.40625-3.16667,0.8125-6.33333,1.21875-9.5z'/%3E %3Cpath d='m977.1,441.379c1.08619,2.02027,2.17237,4.04053,3.25856,6.0608-1.01376,0.87074-1.54101-1.14943-2.46007-1.45809-1.50628-1.26767-3.77854-1.50742-5.45644-0.43192-0.68677,0.35724-1.36507,0.73053-2.04797,1.09509,3.2768,6.06782,6.50863,12.1606,9.81456,18.2122,0.51183,1.5521,2.41826,1.84313,3.64829,0.96814,0.47558-0.34475,0.90639-0.54064,1.05915,0.18819-1.66296,0.96412-3.48109,1.88159-5.20372,2.82777-2.16967,1.16651-4.33934,2.33303-6.50901,3.49954-0.51117-0.52976-0.16902-0.80293,0.40615-1.00604,1.54289-0.57239,2.13516-2.44512,1.10289-3.76223-3.20609-6.02574-6.4605-12.0261-9.68551-18.042-1.79599,0.99462-4.0898,1.89186-4.54312,4.13133-0.51017,1.40933,0.23983,3.13506,0.2408,4.33405-0.55321,0.57388-0.6986-0.20859-0.9546-0.62321-0.92819-1.7264-1.85638-3.4528-2.78457-5.1792,6.70487-3.60483,13.4097-7.20967,20.1146-10.8145z'/%3E %3Cpath d='m992.351,432.337c2.0776,2.75429,4.1552,5.50857,6.2328,8.26286,1.44515-0.91843,2.65215-2.55983,2.21865-4.35293,0.1665-1.40062-1.83649-2.98786-1.14842-3.96993,0.45322-0.28145,0.72022,0.76715,1.09532,1.04351,2.3726,3.14543,4.7453,6.29085,7.1179,9.43628-0.9284,1.05716-1.6006-1.09804-2.5836-1.33091-1.3865-0.98572-3.3326-1.47708-4.8196-0.39701-1.11024,0.35461-1.05845,0.97758-0.303,1.6619,1.6701,2.15612,3.2205,4.41037,5.003,6.47497,1.091,1.05878,2.448-0.0476,3.3717-0.78331,2.3881-1.6263,4.4849-4.16522,4.362-7.21105,0.1567-1.32908-0.6787-2.81295-0.6701-3.93483,0.5356-0.7123,0.6849,0.39371,0.9923,0.75562,1.122,2.02645,2.244,4.0529,3.366,6.07935-5.8479,4.41112-11.6957,8.82225-17.5436,13.2334-0.76181-0.53919-0.0123-0.85701,0.46753-1.22935,1.63799-1.01232,1.11749-3.07847-0.0879-4.21329-3.74799-4.93642-7.43003-9.92457-11.2263-14.8233-0.97162-1.31754-2.7643-0.62395-3.74511,0.2947-0.40617,0.57713-1.04343-0.5784-0.27209-0.66375,5.51431-4.15951,11.0286-8.31901,16.5429-12.4785,1.5093,2.00085,3.0185,4.0017,4.5278,6.00255-1.0492,1.06371-1.9782-1.30665-3.1748-1.43095-2.17343-1.13109-4.75777-0.21919-6.55386,1.2098-1.07368,0.76459-2.11384,1.57485-3.16929,2.36419'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 17.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Capa_1' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='1275.59px' height='850.394px' viewBox='1488.189 992.126 1275.59 850.394' enable-background='new 1488.189 992.126 1275.59 850.394' xml:space='preserve'%3E %3Crect id='rect3' x='1488.189' y='992.126' fill='%23FFFFFF' width='1275.59' height='850.394'/%3E %3Cpath id='path5' fill='%23369443' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1885.935,1567.623 c0,0-1.033-6.99,12.242-12.116c13.275-5.126,14.307-24.232,11.652-36.97c0,0-6.932,12.116-15.339,16.155 c0,0-13.717,7.146-14.345,20.795c0,0-0.109,4.99-1.142,8.873c-0.565,2.126-6.637-17.087,4.867-31.377 c11.872-14.748,15.192-26.717,5.752-50.017c0,0-0.885,14.135-10.177,22.213c-9.292,8.077-10.474,8.699-10.325,27.96 c0,0,0.148,6.679-3.392,8.854c0,0-7.227-10.563-9.145-17.553c-1.917-6.99-2.802-9.941,5.457-18.019c0,0,26.461-17.1,7.375-54.522 c0,0-0.59,12.893-9.735,20.504c-9.145,7.611-8.407,12.737-8.85,25.941c-0.443,13.203-1.328,12.271-2.36,14.135 c0,0-16.814-30.911-3.835-47.377s20.207-19.883,5.9-50.483c0,0,0.635,15.689-10.818,23.456c-11.453,7.767-8.798,25.941-8.798,25.941 s0.737,6.835-1.622,11.805c0,0-16.202-31.601-0.737-48.62c13.127-14.446,14.012-24.543,6.932-45.047c0,0-0.885,9.476-8.112,14.601 c-7.227,5.126-12.979,10.252-11.652,29.979c0,0,0.59,13.825-1.18,17.708c0,0-6.785-12.582-8.702-20.815 c-1.917-8.233-2.655-13.048,2.36-21.281c5.015-8.233,24.927-31.844,1.18-65.861c0,0-0.737,11.029-6.785,20.97 c-6.047,9.941-3.245,21.747-1.917,30.756s-3.097,17.708-3.097,17.708s-10.325-18.951-8.112-40.697 c2.212-21.747-6.637-39.61-26.697-52.503c0,0-14.602,33.863,5.31,51.105c0,0,16.962,16.776,21.239,37.125 c0,0-12.832-1.243-24.484-23.921c-11.652-22.679-35.841-19.106-37.464-19.261c0,0,3.983,35.105,41.151,45.047 c0,0,23.747,4.039,28.172,21.436c0,0,3.982,11.961,5.605,18.329c0,0-7.522-2.951-14.455-13.203 c-6.932-10.252-6.047-11.495-29.499-13.825c0,0-9.44-1.088-14.455-7.767c0,0,9.882,37.125,35.251,36.814 c0,0,23.157-2.485,36.136,27.96c0,0-2.507-1.553-5.9-3.884c-3.392-2.33-11.947-6.679-28.909-4.66 c-16.962,2.019-21.682-0.777-25.959-2.175c0,0,17.109,31.377,41.299,22.057c24.189-9.32,35.872,24.665,36.136,25.319 c0,0-3.245-2.486-7.522-6.68c-4.277-4.194-13.157-9.366-29.942-4.039c0,0-12.094,4.66-24.337,0.932c0,0,11.8,22.834,39.381,18.951 c27.581-3.884,34.514,20.349,34.514,20.349s-3.687-2.175-6.195-4.194c-2.507-2.019-11.8-7.301-31.711-1.398 c-19.912,5.903-27.139-0.932-27.139-0.932s11.062,20.193,32.301,22.523c0,0,11.8-0.155,16.814-2.019 c5.015-1.864,18.289-4.815,27.434,8.388c0,0-2.507,0.466-6.342-1.243c0,0-14.159-5.126-24.927,3.883c0,0-9.587,9.786-23.157,7.922 c0,0,17.552,17.087,45.428,2.641c0,0,9.44-6.835,16.372-1.553C1869.858,1578.031,1885.935,1567.623,1885.935,1567.623z'/%3E %3Cpath id='path7' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2041.1,1146.669 c0,0-3.238-28.908,19.863-31.688c24.091-2.9,35.989,2.175,35.989,2.175l10.816,21.229l-3.737,14.291l-14.946,6.835 c0,0,2.557-21.954-17.568-22.411c-5.099-0.116-8.096,1.906-16.161,0.626C2047.245,1136.438,2042.907,1145.351,2041.1,1146.669z'/%3E %3Cpath id='path9' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2203.639,1218.226 c-3.442,4.453-17.208,6.006-17.208,6.006s14.159,10.873,20.256,26.407c6.097,15.533-164.113,0.103-164.113,0.103 s7.375-5.281,12.39-15.223c0,0-7.522,2.796-15.044-4.66c0,0,5.605,1.864,12.979-9.32c0,0,10.915-13.98,18.584-17.708 c0,0-3.54,2.175-12.094-2.485c0,0,14.75-1.864,20.059-27.028c0,0,0.885-5.592,6.49-13.669c5.605-8.078,4.425,1.553,14.75-10.874 c0,0,4.72-8.802,0.59-14.187c-4.13-5.385-8.555-3.417-17.208-8.595c-8.653-5.178-12.488-8.078-9.538-16.051 c2.95-7.974,10.62-6.731,11.701-6.731c1.082,0,1.672-6.938,11.112-11.702c9.44-4.764,34.514-2.693,38.25-0.621 c3.737,2.071,18.879,6.524,27.729,28.892c8.85,22.368-2.36,30.756,21.731,64.515c0,0-9.636,2.071-15.831,0.207 C2169.224,1185.502,2181.711,1207.663,2203.639,1218.226z'/%3E %3Cpath id='path11' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2098.328,1123.835 c-19.617-0.932-12.094-19.624-12.094-19.624'/%3E %3Cpath id='path13' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2132.399,1126.398 c0,0-3.466-1.631-6.398-5.514c-4.115-5.449-13.292-8.077-18.233-2.951c0,0-5.015,5.592-9.44,5.903c0,0,5.015,1.553,8.481,4.738 c3.466,3.184,7.08,5.514,12.242,4.815c5.162-0.699,5.974-3.417,8.407-5.048C2129.892,1126.708,2132.399,1126.398,2132.399,1126.398z '/%3E %3Cpath id='path15' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2259.981,1405.765c0,0,18.29,14.912,33.629,0 c0,0,6.195,7.456,18.584,5.281c12.39-2.175,14.455-8.699,15.635-12.427c0,0,10.718,6.253,19.764,1.314 c9.047-4.939,9.047-12.394,9.047-12.394s15.733,3.101,23.796-7.562c8.063-10.663,3.147-21.226-1.18-22.469 c0,0,17.01,4.456,21.633-10.148c3.933-12.427-4.917-18.847-4.917-18.847s35.841-0.172,50.542-11.391c0,0,12.193-7.663,4.917-15.74 c0,0,32.252-5.178,40.315-18.019c0,0,3.54-3.521,2.36-9.734c0,0-0.197-3.521-3.737-3.728c0,0,36.78-5.681,47.395-17.812 c0,0,5.113-5.592,2.557-13.048c0,0-0.541-1.968-1.426-3.288c0,0,33.481-7.068,50-21.98c0,0,9.536-8.496,4.62-19.887 c0,0,55.951-15.322,42.972-39.968c0,0,26.156-8.492,17.896-32.102c0,0,21.633-10.977,12.193-28.374 c-9.034-16.65-36.775,2.899-69.624,11.988c0,0-88.884,27.985-132.656,35.432l-124.372,185.167l-72.568,27.96L2259.981,1405.765z'/%3E %3Cpath id='path17' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2259.097,1269.382c0,0,11.657-8.751,32.449,1.553 c0,0,7,4.82,12.507-0.461c4.601-4.413,5.032-12.549-1.297-17.247c-15.487-11.495-21.24-45.979,2.36-60.269 c0,0,34.219-20.297,159.696-52.229c0,0,10.513-2.915,16.118-1.517c6.172,1.539,10.423,6.835,11.295,11.366 c0,0,5.615,15.956-13.262,25.086c0,0-8.522,3.9-17.306,6.421c0,0,9.648-2.086,13.766,7.456c3.933,9.113-1.77,18.433-19.469,24.439 c0,0-4.787,1.863-11.603,3.521c0,0,15.143,4.349,7.866,16.569c0,0-6.49,12.841-29.401,15.119c0,0,17.109,1.864,5.015,18.122 c0,0-5.31,8.906-22.026,12.22c0,0,12.685,0.414,6.293,11.805c-6.391,11.391-21.432,17.812-36.232,18.847 c0,0-8.016,0.414-13.621-0.829c0,0,14.061,7.042,5.801,18.847c0,0-6.096,8.388-21.337,7.974c0,0,3.956,13.183-7.227,18.174 c-8.702,3.883-15.929-2.33-15.929-2.33s2.95,14.135-9.735,19.106c0,0-6.342,3.262-15.782,0c0,0-7.227,16.155-32.891,4.815 C2239.479,1364.602,2259.097,1269.382,2259.097,1269.382z'/%3E %3Cpath id='path19' fill='%23F6E200' stroke='%23010002' stroke-width='3' d='M2193.461,1317.07'/%3E %3Cpath id='path21' fill='none' stroke='%23010002' stroke-width='3' d='M2654.383,1121.815c0,0-40.315,23.342-165.869,46.684'/%3E %3Cpath id='path23' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1934.384,1534.589c0,0-14.946,25.682-33.039,26.096 c0,0-31.122-3.788-39.922,4.349c-6.136,5.675-12.39,10.356-14.946,24.854s4.916,17.605,6.686,18.226c0,0,1.377,10.356,11.603,7.663 c0,0,0.59,10.77,18.683,5.592c18.093-5.178,25.566-3.521,29.106-21.54c3.54-18.019,6.808-17.724,10.03-19.883 c4.327-2.9,12.455-5.64,18.486-9.113c5.418-3.12,26.156-13.67,33.235-14.498c7.08-0.828,5.506-24.646,5.506-24.646h-18.289 l-8.85-13.048L1934.384,1534.589z'/%3E %3Cpath id='path25' fill='none' stroke='%23010002' stroke-width='3' d='M2636.487,1153.918c0,0-109.115,35.594-159.93,39.968'/%3E %3Cpath id='path27' fill='none' stroke='%23010002' stroke-width='3' d='M2593.515,1193.886c0,0-64.011,20.094-138.971,32.774'/%3E %3Cpath id='path29' fill='none' stroke='%23010002' stroke-width='3' d='M2538.894,1235.753c0,0-72.322,17.372-106.849,20.255'/%3E %3Cpath id='path31' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2490.368,1269.9 c0,0-61.173,12.758-76.672,14.292'/%3E %3Cpolygon id='polygon33' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2421.511,1362.939 2424.574,1460.005 2424.574,1460.005 2407.435,1450.062 2407.435,1450.062 2378.901,1573.241 2367.128,1564.783 2394.904,1446.772 2394.904,1446.772 2375.536,1447.128 2375.536,1447.128 '/%3E %3Cpath id='path35' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2451.43,1301.381 c0,0-44.642,6.783-62.409,6.42'/%3E %3Cpath id='path37' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2395.972,1328.513 c0,0-18.05-0.848-26.724-2.288'/%3E %3Cpath id='path39' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2379.255,1357.509 c0,0-15.34-4.142-24.386-9.941'/%3E %3Cpath id='path41' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2356.64,1387.54 c0,0-11.8-4.556-17.503-16.983'/%3E %3Cpath id='path43' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2327.829,1398.62 c0,0-9.145-8.181-9.735-17.294'/%3E %3Cpolygon id='polygon45' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2532.37,1406.102 2491.805,1493.32 2491.805,1493.32 2481.104,1476.067 2481.104,1476.067 2395.461,1577.264 2386.188,1566.883 2471.506,1466.967 2471.506,1466.967 2454.247,1457.705 2454.247,1457.705 '/%3E %3Cpath id='path47' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2293.61,1405.765 c0,0,3.424-2.953,1.082-15.792'/%3E %3Cpolygon id='polygon49' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2495.369,1342.078 2474.473,1436.672 2474.473,1436.672 2460.361,1422.396 2460.361,1422.396 2383.71,1569.785 2371.898,1562.89 2449.065,1415.802 2449.065,1415.802 2430.27,1410.867 2430.27,1410.867 '/%3E %3Cpath id='path51' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2298.035,1371.126 c0,0,1.77-3.676,1.18-9.475'/%3E %3Cpath id='path53' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1991.986,1405.766c0,0-18.289,14.912-33.629,0 c0,0-6.195,7.456-18.584,5.281s-14.455-8.699-15.635-12.427c0,0-10.718,6.253-19.764,1.314c-9.047-4.939-9.047-12.395-9.047-12.395 s-15.733,3.101-23.796-7.562c-8.063-10.663-3.147-21.226,1.18-22.469c0,0-17.01,4.456-21.633-10.148 c-3.933-12.427,4.917-18.847,4.917-18.847s-35.841-0.172-50.542-11.391c0,0-12.193-7.663-4.916-15.74 c0,0-32.252-5.178-40.315-18.019c0,0-3.54-3.521-2.36-9.734c0,0,0.197-3.521,3.736-3.728c0,0-36.78-5.681-47.395-17.812 c0,0-5.113-5.592-2.557-13.048c0,0,0.541-1.968,1.426-3.288c0,0-33.481-7.068-50.001-21.98c0,0-9.536-8.496-4.62-19.887 c0,0-55.952-15.322-42.972-39.968c0,0-26.156-8.492-17.896-32.102c0,0-21.633-10.977-12.193-28.374 c9.034-16.65,36.776,2.899,69.624,11.988c0,0,88.884,27.985,132.656,35.432l124.372,185.167l72.568,27.96L1991.986,1405.766z'/%3E %3Cpath id='path55' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2362.54,1187.263 c0,0-20.649,8.285-27.532,19.676c-6.883,11.391-2.35,22.462,0,28.814c1.181,3.192,15.733,31.248-1.377,51.545'/%3E %3Cpath id='path57' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1992.871,1269.383c0,0-11.657-8.751-32.449,1.553 c0,0-7,4.82-12.506-0.461c-4.601-4.413-5.033-12.549,1.297-17.247c15.487-11.495,21.239-45.979-2.36-60.269 c0,0-34.219-20.297-159.696-52.229c0,0-10.513-2.915-16.118-1.517c-6.172,1.539-10.423,6.835-11.295,11.366 c0,0-5.615,15.956,13.262,25.086c0,0,8.522,3.9,17.306,6.421c0,0-9.648-2.086-13.766,7.456c-3.933,9.113,1.77,18.433,19.469,24.439 c0,0,4.787,1.863,11.603,3.521c0,0-15.143,4.349-7.866,16.569c0,0,6.49,12.841,29.401,15.119c0,0-17.109,1.864-5.015,18.122 c0,0,5.31,8.906,22.026,12.22c0,0-12.685,0.414-6.293,11.805c6.391,11.391,21.432,17.812,36.233,18.847 c0,0,8.016,0.414,13.621-0.828c0,0-14.061,7.042-5.801,18.847c0,0,6.096,8.388,21.338,7.974c0,0-3.956,13.184,7.227,18.174 c8.702,3.883,15.929-2.33,15.929-2.33s-2.95,14.135,9.735,19.106c0,0,6.342,3.262,15.782,0c0,0,7.227,16.155,32.891,4.815 C2012.488,1364.602,1992.871,1269.383,1992.871,1269.383z'/%3E %3Cpath id='path59' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2362.245,1309.355 c0,0-0.098-0.104-7.375-2.382'/%3E %3Cpath id='path61' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2405.805,1279.531 c0,0-12.308,2.478-24.386,2.589'/%3E %3Cpath id='path63' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2422.816,1249.189 c0,0-14.455,1.45-28.024,1.243'/%3E %3Cpath id='path65' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2444.35,1217.501 c0,0-20.846,4.142-32.056,4.349'/%3E %3Cpath id='path67' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2461.656,1182.085 c0,0-25.709,7.338-44.839,9.941'/%3E %3Cpath id='path69' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2374.339,1207.145 c0,0,18.486,17.19-3.737,33.138c0,0,9.243,14.498-9.243,29.617'/%3E %3Cpath id='path71' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1994.394,1416.2c0,0-3.766,20.218-33.627,45.666 c0,0-23.04,20.324-22.45,43.727c0.601,23.832-4.13,26.51-13.176,34.588c0,0,18.683,1.45,27.729-10.977 c0,0-0.393,20.711-3.147,22.575c0,0,5.859,0.374,14.356-8.906c0,0,5.113-5.385,9.833-7.456c0,0-5.506,14.291-1.18,27.546 c0,0,1.377-5.178,8.653-7.456c0,0,13.176-2.693,18.29-21.747c0,0,3.343-12.634,23.992-23.818c0,0,23.402-8.827,22.813-20.361 S1994.394,1416.2,1994.394,1416.2z'/%3E %3Cpath id='path73' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2366.276,1277.046 c0,0,2.753,27.646-31.072,27.648c0,0,6.49,24.647-26.156,23.819c0,0-3.737,19.675-27.336,15.74'/%3E %3Cpath id='path75' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2317.618,1534.589c0,0,14.946,25.682,33.039,26.096 c0,0,31.122-3.788,39.922,4.349c6.136,5.675,12.39,10.356,14.946,24.854c2.557,14.498-4.917,17.604-6.687,18.226 c0,0-1.377,10.356-11.603,7.663c0,0-0.59,10.77-18.683,5.592s-25.566-3.521-29.106-21.54c-3.54-18.019-6.808-17.724-10.03-19.883 c-4.327-2.9-12.455-5.64-18.486-9.113c-5.418-3.12-26.156-13.669-33.235-14.498c-7.08-0.828-5.507-24.646-5.507-24.646h18.289 l8.85-13.048L2317.618,1534.589z'/%3E %3Cpath id='path77' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2257.608,1416.2c0,0,3.766,20.218,33.627,45.666 c0,0,23.04,20.324,22.45,43.727c-0.601,23.832,4.13,26.51,13.176,34.588c0,0-18.683,1.45-27.729-10.977 c0,0,0.393,20.711,3.147,22.575c0,0-5.86,0.374-14.356-8.906c0,0-5.113-5.385-9.833-7.456c0,0,5.506,14.291,1.18,27.546 c0,0-1.377-5.178-8.653-7.456c0,0-13.176-2.692-18.29-21.747c0,0-3.343-12.634-23.992-23.818c0,0-23.403-8.827-22.813-20.361 C2206.112,1478.047,2257.608,1416.2,2257.608,1416.2z'/%3E %3Cpath id='path79' fill='none' stroke='%23010002' stroke-width='3' d='M2333.695,1560.685c0,0,5.352,1.191,16.962,0'/%3E %3Cpath id='path81' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2383.303,1575.183 c0,0,16.323-2.485,15.536,32.931'/%3E %3Cpath id='path83' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2373.47,1583.26 c0,0,14.75-1.864,13.766,32.517'/%3E %3Cpath id='path85' fill='none' stroke='%23010002' stroke-width='3' d='M2231.088,1500.416c0,0,7.08,1.45,11.997,7.042 c4.916,5.592,14.356,4.556,14.356,4.556s-5.113-4.142-6.883-14.498s-7.473-13.462-7.473-13.462'/%3E %3Cpath id='path87' fill='none' stroke='%23010002' stroke-width='3' d='M2259.974,1474.247c0,0,7.08,1.45,11.996,7.042 c4.916,5.592,14.356,4.556,14.356,4.556s-5.113-4.142-6.883-14.498s-7.473-13.462-7.473-13.462'/%3E %3Cpath id='path89' fill='none' stroke='%23010002' stroke-width='3' d='M2264.842,1514.447c0,0,6.182,1.266,10.474,6.149 c4.293,4.882,12.535,3.978,12.535,3.978s-4.465-3.617-6.01-12.658c-1.545-9.042-6.525-11.754-6.525-11.754'/%3E %3Cpath id='path91' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2149.136,1676.875 c0,0,5.361,23.657,23.993,21.747c0,0,13.176-1.243,12.193-23.197c0,0,19.469,10.356,22.616-15.326c0,0,17.699,4.142,17.503-19.883 c0,0,16.52,2.9,14.553-18.433c0,0,17.896,4.763,17.896-15.326c0,0,41.888-6.947-45.428-86.573l-77.877,46.393L2149.136,1676.875z'/%3E %3Cpath id='path93' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2140.483,1570.709c0,0,12.979,11.516,22.222-5.675 c0,0,12.586-0.621,14.553-10.148c0,0,10.227-1.036,12.193-10.77c0,0,13.963-1.45,13.57-13.255c0,0,25.385-1.96,0.008-30.7 c-25.377-28.741-68.446,47.684-68.446,47.684L2140.483,1570.709z'/%3E %3Cpath id='path95' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2185.322,1675.425 c0,0-1.967-41.63-38.047-101.278'/%3E %3Cpath id='path97' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2207.938,1660.099 c0,0,5.605-24.025-45.232-95.064c0,0,5.9-16.983-12.193-27.857'/%3E %3Cpath id='path99' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2225.44,1640.216 c0,0,1.573-25.993-48.181-85.33c0,0,4.395-15.326-13.634-27.546'/%3E %3Cpath id='path101' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2239.993,1621.783 c0,0-1.868-26.303-50.542-77.667c0,0,2.435-15.74-15.007-25.475'/%3E %3Cpath id='path103' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2257.889,1606.457 c0,0-3.54-30.031-54.868-75.596c0,0,1.77-11.805-15.34-23.818'/%3E %3Cpath id='path105' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2102.865,1676.875 c0,0-5.361,23.657-23.992,21.747c0,0-13.176-1.243-12.193-23.197c0,0-19.469,10.356-22.616-15.326c0,0-17.699,4.142-17.503-19.883 c0,0-16.52,2.9-14.553-18.433c0,0-17.896,4.764-17.896-15.326c0,0-41.888-6.947,45.428-86.573l77.877,46.393L2102.865,1676.875z'/%3E %3Cpath id='path107' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2111.519,1570.709c0,0-12.979,11.516-22.223-5.674 c0,0-12.586-0.621-14.552-10.148c0,0-10.227-1.036-12.193-10.77c0,0-13.963-1.45-13.57-13.255c0,0-25.385-1.96-0.008-30.7 c25.377-28.741,68.446,47.683,68.446,47.683L2111.519,1570.709z'/%3E %3Cpath id='path109' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2066.68,1675.425 c0,0,1.966-41.63,38.047-101.278'/%3E %3Cpath id='path111' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2044.064,1660.099 c0,0-5.605-24.025,45.232-95.064c0,0-5.9-16.983,12.193-27.856'/%3E %3Cpath id='path113' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2126.001,1563.585c12.582,0,26.839,78.599,23.139,125.953 c-1.344,17.198-10.557,31.245-23.139,31.245s-21.795-14.047-23.139-31.245C2099.162,1642.184,2113.419,1563.585,2126.001,1563.585' /%3E %3Cpath id='path115' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2026.561,1640.216 c0,0-1.573-25.993,48.182-85.33c0,0-4.395-15.326,13.634-27.546'/%3E %3Cpath id='path117' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2012.008,1621.783 c0,0,1.868-26.303,50.542-77.667c0,0-2.435-15.74,15.007-25.475'/%3E %3Cellipse id='ellipse119' fill='%23F4C53D' stroke='%23010002' stroke-width='3' cx='2126.001' cy='1562.963' rx='17.41' ry='25.785'/%3E %3Cpath id='path121' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1994.112,1606.457 c0,0,3.54-30.031,54.868-75.596c0,0-1.77-11.805,15.34-23.818'/%3E %3Cpath id='path123' fill='%23FFFFFF' stroke='%23010002' stroke-width='3' d='M2126.001,1557.331c0,0,147.66-65.433,148.029-216.805 h-296.058C1978.341,1491.898,2126.001,1557.331,2126.001,1557.331z'/%3E %3Cline id='line125' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2046.293' y1='1340.525' x2='2069.067' y2='1340.525'/%3E %3Cline id='line127' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2000.746' y1='1340.525' x2='2023.52' y2='1340.525'/%3E %3Cline id='line129' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2091.841' y1='1340.525' x2='2114.614' y2='1340.525'/%3E %3Cpath id='path131' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2000.746,1340.525v96.719c0,0,11.31,22.432,22.774,36.5 v-133.219L2000.746,1340.525L2000.746,1340.525z'/%3E %3Cpath id='path133' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2046.293,1340.525v159.435 c0,0,14.242,13.965,22.774,20.697v-180.132H2046.293z'/%3E %3Cpath id='path135' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2091.841,1340.525v197.076 c0,0,16.248,10.494,22.774,13.937v-211.013H2091.841z'/%3E %3Cline id='line137' fill='none' stroke='%23010002' stroke-width='3' x1='2000.746' y1='1340.525' x2='2023.52' y2='1340.525'/%3E %3Cline id='line139' fill='none' stroke='%23010002' stroke-width='3' x1='2046.293' y1='1340.525' x2='2069.067' y2='1340.525'/%3E %3Cline id='line141' fill='none' stroke='%23010002' stroke-width='3' x1='2091.841' y1='1340.525' x2='2114.614' y2='1340.525'/%3E %3Cpath id='path143' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2251.256,1340.525v96.719c0,0-11.31,22.432-22.773,36.5 v-133.219H2251.256z'/%3E %3Cpath id='path145' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2205.708,1340.525v159.435 c0,0-14.242,13.965-22.774,20.697v-180.132H2205.708z'/%3E %3Cpath id='path147' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2160.161,1340.525v197.076 c0,0-16.248,10.494-22.774,13.937v-211.013H2160.161z'/%3E %3Cline id='line149' fill='none' x1='2281.978' y1='1703.708' x2='2268.261' y2='1720.484'/%3E %3Cline id='line151' fill='none' x1='2251.256' y1='1701.845' x2='2289.057' y2='1736.793'/%3E %3Cpath id='path153' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2364.725,1614.728l-5.742,23.475 l0,0l15.719,15.659l0,0l-22.216,93.839l-19.76-26.542l-29.279,13.665l22.216-93.839l0,0l20.597-5.743l0,0l5.348-23.433 C2351.608,1611.809,2357.838,1609.369,2364.725,1614.728z'/%3E %3Cpath id='path155' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2369.988,1599.248l-11.315,21.11 l0,0l11.335,19.41l0,0l-44.521,84.586l-12.564-31.023l-31.64,5.219l44.521-84.586l0,0l21.306,0.067l0,0l10.924-21.177 C2358.035,1592.854,2365.982,1592.837,2369.988,1599.248z'/%3E %3Cpath id='path157' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2371.898,1605.387l-30.096,38.235 l0,0l6.898,21.598l0,0l-61.447,71.871l-5.615-33.205l-31.943-2.411l61.447-71.871l0,0l20.746,5.113l0,0l31.924-40.59 C2363.811,1594.128,2372.373,1598.38,2371.898,1605.387z'/%3E %3Cpath id='path159' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1900.98,1512.014'/%3E %3Cpath id='path161' fill='none' stroke='%23010002' stroke-width='3' d='M1597.585,1121.816c0,0,40.315,23.342,165.869,46.684'/%3E %3Cpath id='path163' fill='none' stroke='%23010002' stroke-width='3' d='M1615.481,1153.918c0,0,109.115,35.594,159.93,39.968'/%3E %3Cpath id='path165' fill='none' stroke='%23010002' stroke-width='3' d='M1658.453,1193.886c0,0,64.011,20.094,138.971,32.774'/%3E %3Cpath id='path167' fill='none' stroke='%23010002' stroke-width='3' d='M1713.073,1235.753c0,0,72.322,17.371,106.849,20.255'/%3E %3Cpath id='path169' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1761.599,1269.901 c0,0,61.173,12.758,76.672,14.292'/%3E %3Cpath id='path171' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1800.538,1301.382 c0,0,44.642,6.783,62.409,6.42'/%3E %3Cpath id='path173' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1855.996,1328.513 c0,0,18.05-0.848,26.724-2.288'/%3E %3Cpath id='path175' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1872.712,1357.509 c0,0,15.34-4.142,24.386-9.941'/%3E %3Cpath id='path177' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1895.328,1387.54 c0,0,11.8-4.556,17.503-16.983'/%3E %3Cpath id='path179' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1924.139,1398.621 c0,0,9.145-8.181,9.735-17.294'/%3E %3Cpath id='path181' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1958.358,1405.766 c0,0-3.424-2.953-1.082-15.792'/%3E %3Cpath id='path183' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1953.933,1371.126 c0,0-1.77-3.676-1.18-9.475'/%3E %3Cpath id='path185' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1889.428,1187.263 c0,0,20.649,8.284,27.532,19.675c6.883,11.391,2.35,22.462,0,28.814c-1.181,3.192-15.733,31.248,1.377,51.545'/%3E %3Cpath id='path187' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1889.723,1309.355 c0,0,0.098-0.104,7.375-2.382'/%3E %3Cpath id='path189' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1846.163,1279.531 c0,0,12.308,2.478,24.386,2.589'/%3E %3Cpath id='path191' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1829.152,1249.189 c0,0,14.455,1.45,28.024,1.243'/%3E %3Cpath id='path193' fill='%23369443' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1882.877,1610.513 c0,0-0.442-12.581,15.486-13.513l46.901,65.237c0,0-1.77,4.194-23.008,3.728c0,0-2.249-0.015-3.429,2.47 C1917.015,1672.25,1882.877,1610.513,1882.877,1610.513z'/%3E %3Cpath id='path195' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1807.618,1217.501 c0,0,20.846,4.142,32.056,4.349'/%3E %3Cpath id='path197' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1790.312,1182.085 c0,0,25.709,7.338,44.839,9.941'/%3E %3Cpath id='path199' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1877.629,1207.146 c0,0-18.486,17.19,3.736,33.138c0,0-9.243,14.498,9.243,29.617'/%3E %3Cpath id='path201' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1885.692,1277.047 c0,0-2.753,27.646,31.072,27.648c0,0-6.49,24.647,26.156,23.819c0,0,3.736,19.676,27.336,15.74'/%3E %3Cpath id='path203' fill='none' stroke='%23010002' stroke-width='3' d='M1918.258,1560.685c0,0-5.352,1.191-16.962,0'/%3E %3Cpath id='path205' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1868.651,1575.183 c0,0-16.323-2.485-15.536,32.931'/%3E %3Cpath id='path207' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1878.484,1583.26 c0,0-14.75-1.864-13.766,32.516'/%3E %3Cpath id='path209' fill='none' stroke='%23010002' stroke-width='3' d='M2020.914,1500.415c0,0-7.08,1.45-11.996,7.042 s-14.356,4.556-14.356,4.556s5.113-4.142,6.883-14.498s7.473-13.462,7.473-13.462'/%3E %3Cpath id='path211' fill='none' stroke='%23010002' stroke-width='3' d='M1992.028,1474.247c0,0-7.08,1.45-11.996,7.042 c-4.916,5.592-14.356,4.556-14.356,4.556s5.113-4.142,6.883-14.498s7.473-13.462,7.473-13.462'/%3E %3Cpath id='path213' fill='none' stroke='%23010002' stroke-width='3' d='M1987.16,1514.446c0,0-6.182,1.266-10.474,6.148 c-4.293,4.883-12.535,3.978-12.535,3.978s4.465-3.617,6.01-12.659c1.545-9.042,6.525-11.754,6.525-11.754'/%3E %3Cpath id='path215' fill='%23162667' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2274.03,1230.549 c0,0-72.456,37.901-148.029-3.107c-75.573,41.008-148.029,3.107-148.029,3.107v109.976h296.058L2274.03,1230.549L2274.03,1230.549z' /%3E %3Cpath id='path217' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1609.306,1515.748 c7.175-2.929,12.342-5.756,12.32-13.412c-0.005-1.825-1.019-5.863-3.055-12.114l-48.177-147.24 c-2.853-8.747-5.01-13.947-6.01-15.863c-2.166-4.147-6.417-5.835-12.143-8.22h5.93h49.361h5.941 c-6.652,3.143-12.716,5.639-12.659,12.691c0.022,2.693,0.779,6.49,2.341,11.393l36.907,115.541l36.871-115.541 c1.562-4.903,2.369-8.7,2.343-11.393c-0.071-7.248-6.386-9.86-12.591-12.691h5.872h47.565h5.906 c-5.426,2.174-9.848,3.878-12.12,8.22c-1.002,1.916-3.157,7.116-6.009,15.863l-48.177,147.24c-2.038,6.25-2.775,10.357-3.056,12.258 c0,0-2.217,9.312,12.32,13.267L1609.306,1515.748L1609.306,1515.748z'/%3E %3Cpath id='path219' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2635.986,1500.605v-166.709 c0-2.884-0.476-5.095-1.425-6.634c-0.951-1.537-5.09-5.969-10.995-8.364h5.906h43.363h5.906c-5.906,1.955-10.046,6.706-10.995,8.292 c-0.951,1.586-1.425,3.821-1.425,6.706v166.709c0,2.981,0.491,5.264,1.476,6.85c0.983,1.586,5.039,5.458,10.944,8.292h-5.906 h-43.363h-5.906c5.906-2.687,10.044-6.825,10.995-8.364C2635.51,1505.847,2635.986,1503.586,2635.986,1500.605z'/%3E %3C/svg%3E"

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='-15 -10 30 20'%3E %3Crect fill='%23DA251d' x='-20' y='-15' width='40' height='30'/%3E %3Cg id='g' transform='translate(0,-6)'%3E %3Cpolyline id='g1' fill='%23FF0' points='0,0 0,6 4,6' transform='rotate(18)'/%3E %3Cuse xlink:href='%23g1' transform='scale(-1,1)'/%3E %3C/g%3E %3Cg id='g2' transform='rotate(72)'%3E %3Cuse xlink:href='%23g' /%3E %3Cuse xlink:href='%23g' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23g2' transform='scale(-1,1)'/%3E %3C/svg%3E"

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='360' viewBox='0 0 950 570'%3E %3Crect width='950' height='285' fill='%23d21034'/%3E %3Crect y='285' width='950' height='285' fill='%23009543'/%3E %3Cpath d='M 0,0 L 552.8133,285 L 0,570 z' fill='%23000'/%3E %3Crect y='234' width='950' height='102' fill='%23000'/%3E %3Cpath d='M 0,40.502 L 474.251,284.9995 L 0,529.497 z' fill='%23fdce12'/%3E %3Crect y='270' width='950' height='30' fill='%23fdce12'/%3E %3Cpath d='M 0,74.25473 L 408.78173,285 L 0,495.745 z' fill='%23000'/%3E %3Cpath d='M 115.481,339.524 C 115.481,339.524 115.481,360.119 115.481,372 C 143.734,372 199.181,350.35 199.181,280.644 C 199.181,210.938 140.037,198 122.346,198 C 104.656,198 50,210.674 50,267.706 C 50,324.738 103.6,330.019 114.161,330.019 C 124.722,330.019 164.328,320.513 159.84,277.739 C 159.84,289.885 146.11,315.497 117.329,315.497 C 88.549,315.497 70.595,294.109 70.595,272.987 C 70.595,251.863 88.021,223.611 118.385,223.611 C 148.749,223.611 170.928,250.542 170.928,277.739 C 170.928,304.935 149.542,339.524 115.481,339.524 z' fill='%23fdce12'/%3E %3Cg id='frond' fill='%23fdce12'%3E %3Cpath d='M 90.728,297.245 L 92.411,298.334 C 92.411,298.334 105.778,267.838 141.72,246.154 C 137.165,248.629 113.105,260.61 90.728,297.245 z' stroke='%23fdce12'/%3E %3Cpath d='M 94.193,291.997 C 94.193,291.997 90.035,283.482 93.698,279.72 C 97.362,275.957 95.679,289.72 95.679,289.72 L 97.263,287.443 C 97.263,287.443 94.787,277.046 97.56,274.868 C 100.332,272.69 98.946,284.868 98.946,284.868 L 100.629,282.69 C 100.629,282.69 98.847,272.591 101.52,270.709 C 104.194,268.828 102.511,280.215 102.511,280.215 L 104.491,277.937 C 104.491,277.937 103.006,268.333 106.273,266.056 C 109.541,263.778 106.669,275.165 106.669,275.165 L 108.847,272.789 C 108.847,272.789 107.857,263.976 110.63,261.996 C 113.402,260.016 111.026,270.313 111.026,270.313 L 113.006,268.234 C 113.006,268.234 112.412,260.016 115.085,258.135 C 117.759,256.253 115.283,265.957 115.283,265.957 L 117.363,263.976 C 117.363,263.976 116.868,255.758 120.234,254.174 C 123.6,252.59 119.64,261.897 119.64,261.897 L 121.917,259.917 C 121.917,259.917 122.61,250.313 125.482,249.421 C 128.353,248.53 124.195,257.937 124.195,257.937 L 126.274,256.253 C 126.274,256.253 127.363,248.035 130.531,247.045 C 133.7,246.055 128.551,254.57 128.551,254.57 L 130.63,252.986 C 130.63,252.986 132.908,244.768 135.878,243.877 C 138.849,242.986 132.809,251.6 132.809,251.6 L 134.789,250.214 C 134.789,250.214 138.056,242.787 140.73,242.292 C 143.403,241.797 137.759,248.431 137.759,248.431 L 140.235,246.946 C 140.235,246.946 144.492,239.223 145.978,241.599 C 147.463,243.976 140.037,247.441 140.037,247.441 L 137.561,248.827 C 137.561,248.827 146.572,244.57 147.661,246.748 C 148.75,248.926 135.284,250.313 135.284,250.313 L 133.106,251.798 C 133.106,251.798 142.116,249.322 141.027,251.6 C 139.938,253.877 131.027,253.382 131.027,253.382 L 128.947,254.867 C 128.947,254.867 137.957,252.689 136.769,254.768 C 135.581,256.847 126.769,256.649 126.769,256.649 L 124.591,258.432 C 124.591,258.432 133.403,256.154 132.116,258.828 C 130.828,261.501 120.828,261.402 120.828,261.402 L 118.353,263.679 C 118.353,263.679 127.66,260.511 126.868,262.986 C 126.076,265.462 115.481,266.749 115.481,266.749 L 113.105,269.125 C 113.105,269.125 123.105,265.759 120.135,268.828 C 117.165,271.898 109.937,272.69 109.937,272.69 L 107.065,276.155 C 107.065,276.155 116.967,270.214 115.58,273.581 C 114.194,276.947 104.491,279.225 104.491,279.225 L 102.511,281.601 C 102.511,281.601 111.422,276.452 110.531,279.324 C 109.64,282.195 100.134,285.264 100.134,285.264 L 98.55,287.443 C 98.55,287.443 109.045,281.205 108.154,284.373 C 107.263,287.542 97.263,289.819 97.263,289.819 L 95.976,291.799 C 95.976,291.799 105.679,286.255 105.778,288.928 C 105.877,291.601 94.391,294.275 94.391,294.275 L 94.193,291.997 z'/%3E %3C/g%3E %3Cuse xlink:href='%23frond' transform='translate(238.5) scale(-1,1)'/%3E %3C/svg%3E"

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2880' height='1440'%3E %3Cdefs%3E %3Cpath id='s' d='M0,0 0.309017,0.951057 -0.5,0.363271H0.5L-0.309017,0.951057z'/%3E %3C/defs%3E %3Crect width='2880' height='1440' fill='%23ce1126'/%3E %3Crect width='1440' height='720' fill='%23002b7f'/%3E %3Cg fill='%23fff'%3E %3Cuse xlink:href='%23s' transform='translate(720,30) scale(160)'/%3E %3Cuse xlink:href='%23s' transform='translate(500,210) scale(160)'/%3E %3Cuse xlink:href='%23s' transform='translate(945,180) scale(150)'/%3E %3Cuse xlink:href='%23s' transform='translate(830,364.894348) scale(100)'/%3E %3Cuse xlink:href='%23s' transform='translate(720,499.788697) scale(200)'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect width='450' height='300'/%3E %3Crect fill='%23FFF' width='450' height='200'/%3E %3Crect fill='%23CE1126' width='450' height='100'/%3E %3C/svg%3E"

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 9 6'%3E %3CclipPath id='Z'%3E %3Cpath d='M0,0 4.5,3 0,6' id='X'/%3E %3C/clipPath%3E %3CclipPath id='A'%3E %3Cpath d='M0,0H9V6H0z'/%3E %3C/clipPath%3E %3Cg clip-path='url(%23A)'%3E %3Cpath d='M0,0V6H9V0z' fill='%23002395'/%3E %3Cpath d='M0,0V3H9V0z' fill='%23de3831'/%3E %3Cg stroke-width='2' stroke='%23fff'%3E %3Cpath d='M0,0 4.5,3 0,6M4.5,3H9' id='W'/%3E %3Cuse xlink:href='%23X' stroke='%23ffb612' clip-path='url(%23Z)'/%3E %3C/g%3E %3Cuse xlink:href='%23W' fill='none' stroke='%23007a4d' stroke-width='1.2'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='2100' height='1400'%3E %3Crect width='2100' height='1400' fill='%23198a00'/%3E %3Crect x='1850' y='500' width='250' height='900' fill='%23ef7d00'/%3E %3Crect x='1600' y='500' width='250' height='900' fill='%23000'/%3E %3Crect x='1350' y='500' width='250' height='900' fill='%23de2010'/%3E %3Cg fill='%23ef7d00' stroke='%23000' stroke-width='2.25' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='M 1916.4245,168.3344 C 1916.4245,168.3344 2002.4265,134.6285 2010.7593,127.6785 C 2014.5489,131.8483 1976.2829,174.2418 1902.0276,189.87871 C 1969.4633,175.2842 2027.0511,129.4158 2038.7957,130.8058 C 2042.2056,131.5008 2041.4461,175.6316 1886.8731,213.85517 C 1993.7101,188.14097 2055.8431,140.8829 2055.0855,146.0952 C 2055.8431,147.1376 2044.4782,183.27622 1950.9008,211.42263 C 1977.0424,205.86205 2047.8881,166.2494 2047.1305,173.8943 C 2049.4031,177.0216 1978.5575,260.41781 1850.5039,233.31502 C 1952.7956,257.63859 2019.0941,198.91314 2028.5661,199.95564 C 2030.4609,200.30309 2009.6221,251.38355 1880.8128,254.51107 C 1942.568,248.60433 1924.7593,254.16286 1924.7593,254.16286 C 1924.7593,254.16286 1888.3881,280.22426 1844.4417,262.50402 C 1878.918,271.19178 1882.7056,271.53828 1883.4633,274.31751 C 1881.1906,277.79154 1852.7764,283.00526 1825.4995,269.45208 C 1847.4718,277.79154 1867.1733,279.18294 1867.5512,282.31046 C 1867.1733,283.35177 1853.1561,290.64992 1840.654,285.43798 C 1828.1518,280.22426 1712.9782,215.24513 1712.9782,215.24513 L 1909.227,165.902 z'/%3E %3Cpath d='M 1685.7126,344.10525 C 1668.4556,344.10525 1667.9794,358.19028 1667.9794,358.19028 C 1667.9794,358.19028 1666.5551,359.20736 1667.5052,366.03421 C 1670.3541,361.38542 1671.7804,359.93337 1671.7804,359.93337 C 1673.6808,360.22451 1681.5962,362.40249 1694.104,353.39936 C 1682.7032,364.28942 1689.5134,368.35602 1689.5134,368.35602 C 1689.5134,368.35602 1686.8216,376.92419 1695.5285,378.66728 C 1692.8383,375.18109 1694.4214,372.13156 1694.4214,372.13156 C 1694.4214,372.13156 1706.6118,370.97066 1705.8204,357.32052 C 1706.2964,369.66245 1713.5789,372.71197 1713.5789,372.71197 C 1713.5789,372.71197 1713.5789,379.53704 1721.4943,380.11924 C 1717.2212,376.63305 1718.1694,371.26002 1718.1694,371.26002 C 1718.1694,371.26002 1728.4613,364.43494 1719.7526,352.81725 C 1724.9778,350.05699 1729.2529,342.36216 1729.2529,342.36216 C 1729.2529,342.36216 1722.1291,339.60198 1718.8042,337.28017 C 1717.2192,334.22886 1718.6456,317.52919 1718.6456,317.52919 L 1714.3704,295.89129 L 1702.1781,329.58356 C 1702.6522,324.79085 1702.9697,344.10525 1685.7126,344.10525 z'/%3E %3Cpath d='M 1770.9438,295.51356 C 1771.3216,295.86186 1783.8256,308.72015 1795.9482,308.02364 C 1800.4933,304.54953 1786.4761,296.90496 1786.4761,295.16705 C 1791.401,299.33759 1812.238,315.66829 1825.4995,309.76147 C 1830.8022,302.81171 1816.0275,303.85472 1799.7358,285.08968 C 1811.1007,292.03953 1839.5168,307.32884 1852.7764,301.42209 C 1858.4607,295.86186 1823.225,278.48634 1811.4804,264.93494 L 1781.1734,250.68874 L 1739.8773,281.61565 z'/%3E %3Cpath d='M 1724.3449,189.87853 C 1724.3449,189.87853 1738.3622,182.23388 1794.433,186.05621 C 1800.4952,186.75101 1832.6971,175.9792 1842.9266,172.8518 C 1859.2164,170.0719 1911.1199,159.6472 1925.1389,149.9175 C 1934.9888,148.8752 1922.4847,166.597 1909.9846,170.7667 C 1896.7229,176.32663 1848.6091,191.61602 1831.5597,189.53109 C 1852.0189,189.87871 1840.654,205.16792 1806.5555,197.87072 C 1822.8472,206.21035 1816.785,207.6003 1816.785,207.6003 C 1816.785,207.6003 1787.993,208.99025 1780.4158,203.083 C 1799.7377,209.68531 1791.7807,212.11761 1791.7807,212.11761 C 1791.7807,212.11761 1772.0811,213.855 1762.9868,210.03267 C 1777.0041,213.855 1769.8065,216.28754 1769.8065,216.28754 C 1769.8065,216.28754 1758.4416,218.02494 1748.9696,214.89759 C 1739.4994,211.77024 1725.1025,189.87853 1724.3449,189.87853 z'/%3E %3Cpath d='M 1746.8274,302.71636 L 1748.8865,336.69798 C 1748.8865,336.69798 1747.7776,338.44108 1746.8274,339.45816 C 1745.8771,340.47353 1720.5441,335.82644 1724.0276,353.54318 C 1724.0276,360.80493 1724.1863,362.69184 1729.5703,366.75845 C 1728.144,361.96582 1728.6201,358.62694 1728.6201,358.62694 C 1728.6201,358.62694 1735.7439,362.54802 1742.711,351.80187 C 1737.9617,362.40249 1741.2846,366.17804 1742.3936,366.46909 C 1743.5025,368.35772 1740.495,376.92419 1749.9935,376.77866 C 1746.3532,373.58352 1748.0949,368.93642 1748.0949,368.93642 C 1748.0949,368.93642 1758.0695,367.48617 1754.5859,350.93033 C 1758.2281,347.58966 1759.6525,350.78479 1759.6525,350.78479 C 1759.6525,350.78479 1760.7596,360.65939 1769.4684,358.62694 C 1773.428,360.65939 1768.8356,366.03242 1768.8356,366.03242 C 1768.8356,366.03242 1775.1678,366.17804 1777.0683,361.23981 C 1778.9688,356.30336 1781.1847,347.44413 1770.7341,343.81411 C 1769.4684,340.32971 1774.8524,340.03856 1774.8524,340.03856 C 1774.8524,340.03856 1781.502,342.07101 1783.4006,345.12063 C 1785.3011,348.17015 1784.6682,337.13456 1776.4354,335.97196 C 1766.3022,335.68091 1765.6694,333.79399 1765.6694,333.35902 C 1765.6694,332.92244 1763.9276,308.67167 1763.1361,301.70098 z'/%3E %3Cpath d='M 1782.0688,331.67486 C 1782.1934,330.11719 1764.7834,308.61621 1769.2001,305.83699 C 1773.6149,306.67035 1780.8559,316.44969 1786.7216,313.27539 C 1784.9439,309.46353 1779.7036,311.61029 1773.7529,301.85179 C 1767.8041,290.81969 1766.9351,274.25865 1746.0981,256.19352 C 1759.5883,275.31034 1790.1901,286.5157 1791.4861,280.9416 C 1792.782,275.3675 1764.5397,254.28933 1765.9868,249.20906 C 1771.6031,259.64161 1799.9606,282.88746 1820.8542,280.96244 C 1822.2862,276.48689 1803.7445,267.45433 1798.9726,259.01961 C 1785.626,250.79616 1749.9084,222.55764 1749.1925,216.00857 C 1736.1954,198.622 1728.0817,193.36226 1724.3034,191.35975 C 1722.8431,189.78217 1722.4767,188.27399 1722.1914,187.31517 C 1714.123,169.8692 1724.8097,164.2041 1731.0646,163.3664 C 1736.2124,162.8417 1737.7067,163.5485 1741.4113,161.9032 C 1737.0247,160.3293 1732.6401,158.8574 1728.2554,157.2835 C 1733.9738,161.1307 1748.5805,157.7436 1745.4143,168.8249 C 1751.8184,166.5901 1765.4446,151.7209 1729.9707,148.3652 C 1718.4264,136.218 1670.9623,129.237 1659.0818,182.2531 C 1660.0301,182.99639 1660.5269,183.60716 1663.5458,185.67499 C 1648.5575,179.01161 1608.1248,173.8732 1593.554,171.7138 C 1554.1905,161.297 1513.3099,136.1939 1509.3802,139.2811 C 1504.1242,141.4208 1533.1636,166.2005 1531.6542,166.749 C 1506.4747,153.2833 1483.4723,143.7431 1462.0688,135.0617 C 1447.0114,129.8992 1431.9299,117.8797 1430.2669,120.1662 C 1424.7253,130.6954 1454.4075,157.1623 1459.9287,160.2757 C 1465.4516,163.2539 1508.8759,181.72909 1508.2356,181.95975 C 1442.8304,154.731 1431.8645,149.7947 1428.5824,146.6553 C 1422.8177,145.4644 1408.775,128.074 1404.8615,129.1923 C 1402.719,131.1229 1407.0161,158.6011 1438.2263,170.9357 C 1443.3134,174.3363 1505.1266,194.67481 1504.5213,196.26941 C 1504.3701,196.66789 1433.7231,169.5256 1430.9789,168.5552 C 1417.358,163.6563 1400.6447,146.4846 1397.5201,148.4156 C 1394.5379,150.1678 1405.2248,168.754 1418.9884,174.5834 C 1426.2027,177.50343 1453.8752,190.0745 1478.8069,198.07552 C 1480.3981,198.60329 1433.9924,181.93483 1411.6811,173.3834 C 1401.5649,168.2337 1396.801,161.8148 1395.2601,163.1959 C 1392.9808,164.5768 1398.9425,192.03295 1470.6403,207.52545 C 1472.5293,208.26287 1495.8781,202.45215 1494.7241,203.22283 C 1494.4354,203.41556 1471.5384,207.98755 1469.309,207.83131 C 1467.3249,207.55335 1454.781,209.19336 1454.5541,209.78959 C 1453.7962,211.64683 1459.0989,221.47779 1496.1182,219.42766 C 1500.8508,219.16671 1526.5335,210.84928 1524.3758,212.63847 C 1523.2969,213.53358 1489.403,223.63519 1486.8217,223.83447 C 1484.5797,224.12502 1472.6728,225.26704 1472.2326,226.42862 C 1471.695,228.01284 1481.0459,235.00963 1500.9262,236.13064 C 1518.5282,236.98833 1551.9751,226.26591 1551.3042,226.96106 C 1550.6331,227.65612 1519.0604,237.5792 1518.2342,238.18393 C 1517.0918,238.77651 1505.5304,239.35172 1505.1246,240.16612 C 1504.1825,242.19168 1521.802,257.30424 1573.911,241.1763 C 1568.6762,247.66176 1543.4181,252.09749 1543.4544,253.26528 C 1543.3373,254.11259 1549.0191,259.14779 1557.8497,260.94983 C 1562.2647,261.85081 1568.3098,261.66709 1573.8316,260.86664 C 1583.7496,259.04555 1594.202,255.44675 1607.4824,244.18943 C 1609.0694,247.7224 1574.3077,263.85722 1575.9399,265.39586 C 1583.4775,271.80689 1608.5159,264.56939 1610.1556,263.72905 C 1611.7972,262.88693 1658.3714,238.79904 1658.2108,236.01114 C 1658.9344,239.58392 1598.1654,269.86969 1598.8209,271.11208 C 1602.7219,276.82124 1623.4814,270.81226 1624.4731,270.28731 C 1625.4631,269.76397 1650.9661,257.1275 1651.665,256.75496 C 1652.3622,256.38243 1621.6924,273.21904 1624.4241,275.78162 C 1623.1036,286.71498 1672.3226,268.23581 1676.1801,265.93476 C 1678.1089,264.78423 1652.5359,276.24772 1652.4679,281.69356 C 1660.7027,294.46357 1687.0709,290.41253 1691.1381,287.60379 C 1693.1727,286.19862 1688.7446,297.09029 1690.1709,296.10094 C 1690.6678,295.89648 1695.9063,290.21495 1697.9201,286.10327 C 1697.2777,289.67094 1694.3874,295.29174 1692.7004,301.74087 C 1691.0116,308.18993 1690.5279,315.46723 1688.2101,323.19855 C 1687.6791,326.59459 1704.4583,316.5589 1702.0213,292.56797 C 1703.4571,305.04684 1696.7224,328.38106 1698.4848,329.59393 C 1702.01,332.01968 1711.7559,317.97275 1712.7401,308.47409 C 1715.6343,313.2719 1721.7078,323.28692 1726.9331,325.59137 C 1726.3645,318.33312 1727.0332,318.66586 1724.6813,311.53229 C 1726.0376,302.06144 1726.2266,288.9536 1726.5552,274.15293 C 1740.7539,299.1002 1746.4174,309.63499 1742.4503,328.73974 C 1746.6724,330.35457 1753.4165,315.40489 1752.8725,307.70996 C 1758.2943,329.09143 1781.6966,332.29695 1782.0688,331.67486 z'/%3E %3Cpath d='M 1545.5749,173.2876 C 1545.5749,173.2876 1535.9106,179.9848 1523.8842,179.591 C 1526.8908,190.62165 1551.8029,182.15172 1551.8029,182.15172 C 1551.8029,182.15172 1539.7764,194.36428 1531.1861,196.33396 C 1536.3403,200.27349 1558.0311,198.89477 1561.6827,196.925 C 1565.3326,194.95515 1571.7762,187.27308 1571.7762,187.27308 C 1571.7762,187.27308 1549.4406,210.91026 1546.2193,210.71344 C 1545.7897,213.47107 1569.6284,212.48614 1574.5684,208.34971 C 1579.5066,204.21311 1591.9634,198.10691 1591.9634,198.10691 C 1591.9634,198.10691 1559.3195,218.98639 1557.8157,218.98639 C 1570.0573,221.94117 1594.5402,215.44075 1610.2179,206.57684 C 1587.0233,220.75926 1584.8773,223.31981 1573.0646,228.04728 C 1583.5889,230.2142 1588.9559,236.71462 1624.6073,222.53196 C 1645.0097,213.66823 1656.6051,197.51588 1656.6051,197.51588 C 1643.9348,213.07718 1623.9613,226.27561 1601.8435,239.27551 C 1600.5532,241.63891 1625.4649,251.28999 1657.2493,220.95624'/%3E %3Cpath d='M 1718.2413,239.07802 C 1718.2413,239.07802 1720.3891,248.33581 1728.9789,255.42769 C 1737.5707,262.51788 1738.2149,269.41228 1738.2149,269.41228'/%3E %3Cpath d='M 1713.9473,178.80314 C 1713.9473,178.80314 1716.9529,187.07601 1725.758,192.39452 C 1734.7786,197.71286 1748.3103,214.45591 1749.3833,217.41051 C 1750.4223,220.98661 1755.6098,246.76077 1755.1811,249.51746'/%3E %3Cpath d='M 1659.1838,191.60649 C 1659.8279,194.75808 1646.5116,210.71344 1664.7661,229.42617 C 1648.2288,247.94073 1648.2307,250.30583 1648.2307,250.30583 C 1648.2307,250.30583 1657.4646,255.03262 1674.0019,242.0322 C 1701.2751,272.76153 1692.1866,286.82411 1692.1866,286.82411'/%3E %3Cpath d='M 1690.0141,265.13074 C 1690.0141,265.13074 1687.5016,261.82996 1691.9807,249.5036 C 1696.0139,253.96009 1700.4987,254.91133 1702.4653,256.71508 C 1704.4299,258.51881 1725.0232,261.25304 1726.3323,273.87565'/%3E %3Cpath d='M 1714.2231,149.4322 C 1714.2231,148.5049 1710.0765,140.3439 1694.6066,150.5451 C 1702.8979,151.0086 1711.0872,155.3674 1714.2231,149.4322 z'/%3E %3Cpath d='M 1861.8688,186.75118 C 1862.6263,187.09854 1908.0897,196.13332 1923.2443,191.61602 C 1903.9224,215.24513 1865.2786,199.26067 1865.2786,199.26067 C 1884.2207,204.47295 1884.9802,204.12559 1891.0404,208.99025 C 1892.9352,213.50756 1856.1863,211.42263 1844.0619,205.16792 C 1877.7808,214.89759 1878.5384,214.20262 1879.6755,218.02494 C 1881.1926,223.23722 1824.3623,216.63491 1819.4373,209.68531 C 1834.5918,220.45741 1842.9266,222.54242 1851.2614,227.40708 C 1841.0319,231.57703 1822.0896,235.74603 1787.2336,213.16019 C 1833.0748,251.38355 1874.371,248.95092 1880.8128,255.90068 C 1864.9008,277.44503 1803.1456,243.04417 1774.7314,225.66951 C 1746.3173,208.29527 1836.8644,267.71596 1845.2011,266.67286 C 1841.0319,272.5796 1811.1026,267.36766 1809.2077,264.58844'/%3E %3Cpath d='M 1873.6134,226.71211 C 1868.3106,227.40708 1852.3986,227.40708 1850.126,227.05955'/%3E %3Cpath d='M 1532.2598,166.9845 C 1532.2598,166.9845 1566.8363,183.72743 1581.4391,182.54561 C 1577.574,185.89418 1571.7744,187.27308 1571.7744,187.27308 C 1575.4261,188.65197 1585.5196,193.57642 1600.7685,190.42467 C 1597.1169,193.77324 1592.3922,197.51604 1592.3922,197.51604 C 1592.3922,197.51604 1605.4932,202.04636 1620.3114,194.95515 C 1615.8021,200.07642 1613.2234,203.81922 1613.2234,203.81922 L 1623.5324,204.41009'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600' viewBox='0 0 252 126'%3E %3Crect fill='%23319208' width='252' height='126'/%3E %3Crect y='18' fill='%23FFD200' width='252' height='90'/%3E %3Crect y='36' fill='%23DE2010' width='252' height='54'/%3E %3Crect y='54' width='252' height='18'/%3E %3Cpath d='M4.583,0l84,63l-84,63H0V0H4.583z'/%3E %3Cpath fill='%23FFF' d='M0,0l84,63L0,126'/%3E %3Cpolygon fill='%23DE2010' points='46.161,66.045 64.434,53.111 43.405,50.056 34,31 24.595,50.056 3.566,53.111 21.839,66.045 17.836,85.248 34,76 50.164,85.248 '/%3E %3Cpath fill='%23FFC618' d='M28.635,55.109c1.976,4.305,2.47,4.588,7.411,6.282c4.94,1.694,18.898,3.3,20.274,3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917,1.429-4.623,3.97c-0.388,0.106-2.47,1.376-2.4,2.682c0.6-0.071,4.376-1.129,5.682,3.141c1.306,4.27,1.376,11.257,0.035,14.716c-1.341,3.459-3.423,6.07-3.423,9.105c0,0.423,0.282,1.27,0.988,1.27c0.247,1.341,2.223,10.904,2.223,10.904h28.161l4.473-17.292'/%3E %3Cg fill='none' stroke='%23000' stroke-width='0.2117'%3E %3Cpath d='M28.635,55.109c1.976,4.305,2.47,4.588,7.411,6.282c4.94,1.694,18.898,3.3,20.274,3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917,1.429-4.623,3.97c-0.388,0.106-2.47,1.376-2.4,2.682c0.6-0.071,4.376-1.129,5.682,3.141c1.306,4.27,1.376,11.257,0.035,14.716c-1.341,3.459-3.423,6.07-3.423,9.105c0,0.423,0.282,1.27,0.988,1.27c0.247,1.341,2.223,10.904,2.223,10.904h28.161l4.473-17.292'/%3E %3Cpath d='M19.39,70.99c0,0,5.999-0.353,7.623-0.353c1.623,0,16.734,0.019,25.165,1.968'/%3E %3Cpath d='M21.508,70.871c0,0-0.601-0.728-0.213-2.175 c0.388-1.447,4.623-5.188,4.623-10.481'/%3E %3Cpath d='M25.142,70.637c0,0-0.494-2.364,4.905-4.376 c1.518-0.459,5.858-2.894,5.999-4.87'/%3E %3Cpath d='M29.473,66.485c0,0,13.243,0.058,23.724,2.175'/%3E %3Cpath d='M32.793,64.905c0,0,4.551,0.156,5.292-0.056c0.741-0.212,2.053-0.762,2.575-2.313'/%3E %3Cpath d='M35.49,64.959c0,0,2.434-1.265,2.911-2.911'/%3E %3Cpath d='M28.141,81.894c0,0-1.041-7.216-1.253-11.257l2.717,2.594l2.875-2.514l2.472,2.638l2.858-2.425l2.471,2.778l2.83-2.407l2.252,2.618l2.822-2.041l3.355,3.189'/%3E %3Cpath d='M50.951,77.345c-10.081-1.444-23.57-1.35-23.57-1.35'/%3E %3Cpath d='M22.694,51.052c0,0,8.2-3.918,9.647-4.465'/%3E %3C/g%3E %3Cg transform='matrix(0.211738,0,0,0.211738,16,36)' fill='none' stroke='%23000' %3E %3Cpolyline points='52.487,177.086 65.505,188.938 77.267,177.176 89.163,189.442 102.009,178.084 113.836,190.514 127.175,179.501 138.072,192.229 151.342,182.084 165.289,194.403'/%3E %3Ccircle cx='89.425' cy='154.584' r='5.167'/%3E %3Ccircle cx='111.237' cy='156.047' r='5.167'/%3E %3Ccircle cx='30.05' cy='16.5' r='4'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = [
	{
		"name": {
			"common": "Aruba",
			"official": "Aruba",
			"native": {
				"nld": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"pap": {
					"official": "Aruba",
					"common": "Aruba"
				}
			}
		},
		"tld": [
			".aw"
		],
		"cca2": "AW",
		"ccn3": "533",
		"cca3": "ABW",
		"cioc": "ARU",
		"currency": [
			"AWG"
		],
		"callingCode": [
			"297"
		],
		"capital": "Oranjestad",
		"altSpellings": [
			"AW"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"nld": "Dutch",
			"pap": "Papiamento"
		},
		"translations": {
			"deu": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"fra": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"hrv": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"ita": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"jpn": {
				"official": "アルバ",
				"common": "アルバ"
			},
			"nld": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"por": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"rus": {
				"official": "Аруба",
				"common": "Аруба"
			},
			"spa": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"svk": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"fin": {
				"official": "Aruba",
				"common": "Aruba"
			},
			"zho": {
				"official": "阿鲁巴",
				"common": "阿鲁巴"
			}
		},
		"latlng": [
			12.5,
			-69.96666666
		],
		"demonym": "Aruban",
		"landlocked": false,
		"borders": [],
		"area": 180
	},
	{
		"name": {
			"common": "Afghanistan",
			"official": "Islamic Republic of Afghanistan",
			"native": {
				"prs": {
					"official": "جمهوری اسلامی افغانستان",
					"common": "افغانستان"
				},
				"pus": {
					"official": "د افغانستان اسلامي جمهوریت",
					"common": "افغانستان"
				},
				"tuk": {
					"official": "Owganystan Yslam Respublikasy",
					"common": "Owganystan"
				}
			}
		},
		"tld": [
			".af"
		],
		"cca2": "AF",
		"ccn3": "004",
		"cca3": "AFG",
		"cioc": "AFG",
		"currency": [
			"AFN"
		],
		"callingCode": [
			"93"
		],
		"capital": "Kabul",
		"altSpellings": [
			"AF",
			"Afġānistān"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"prs": "Dari",
			"pus": "Pashto",
			"tuk": "Turkmen"
		},
		"translations": {
			"cym": {
				"official": "Islamic Republic of Afghanistan",
				"common": "Affganistan"
			},
			"deu": {
				"official": "Islamische Republik Afghanistan",
				"common": "Afghanistan"
			},
			"fra": {
				"official": "République islamique d'Afghanistan",
				"common": "Afghanistan"
			},
			"hrv": {
				"official": "Islamska Republika Afganistan",
				"common": "Afganistan"
			},
			"ita": {
				"official": "Repubblica islamica dell'Afghanistan",
				"common": "Afghanistan"
			},
			"jpn": {
				"official": "アフガニスタン·イスラム共和国",
				"common": "アフガニスタン"
			},
			"nld": {
				"official": "Islamitische Republiek Afghanistan",
				"common": "Afghanistan"
			},
			"por": {
				"official": "República Islâmica do Afeganistão",
				"common": "Afeganistão"
			},
			"rus": {
				"official": "Исламская Республика Афганистан",
				"common": "Афганистан"
			},
			"spa": {
				"official": "República Islámica de Afganistán",
				"common": "Afganistán"
			},
			"svk": {
				"official": "Afgánsky islamský štát",
				"common": "Afganistan"
			},
			"fin": {
				"official": "Afganistanin islamilainen tasavalta",
				"common": "Afganistan"
			},
			"zho": {
				"official": "阿富汗伊斯兰共和国",
				"common": "阿富汗"
			}
		},
		"latlng": [
			33,
			65
		],
		"demonym": "Afghan",
		"landlocked": true,
		"borders": [
			"IRN",
			"PAK",
			"TKM",
			"UZB",
			"TJK",
			"CHN"
		],
		"area": 652230
	},
	{
		"name": {
			"common": "Angola",
			"official": "Republic of Angola",
			"native": {
				"por": {
					"official": "República de Angola",
					"common": "Angola"
				}
			}
		},
		"tld": [
			".ao"
		],
		"cca2": "AO",
		"ccn3": "024",
		"cca3": "AGO",
		"cioc": "ANG",
		"currency": [
			"AOA"
		],
		"callingCode": [
			"244"
		],
		"capital": "Luanda",
		"altSpellings": [
			"AO",
			"República de Angola",
			"ʁɛpublika de an'ɡɔla"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"por": "Portuguese"
		},
		"translations": {
			"cym": {
				"official": "Republic of Angola",
				"common": "Angola"
			},
			"deu": {
				"official": "Republik Angola",
				"common": "Angola"
			},
			"fra": {
				"official": "République d'Angola",
				"common": "Angola"
			},
			"hrv": {
				"official": "Republika Angola",
				"common": "Angola"
			},
			"ita": {
				"official": "Repubblica dell'Angola",
				"common": "Angola"
			},
			"jpn": {
				"official": "アンゴラ共和国",
				"common": "アンゴラ"
			},
			"nld": {
				"official": "Republiek Angola",
				"common": "Angola"
			},
			"por": {
				"official": "República de Angola",
				"common": "Angola"
			},
			"rus": {
				"official": "Республика Ангола",
				"common": "Ангола"
			},
			"spa": {
				"official": "República de Angola",
				"common": "Angola"
			},
			"svk": {
				"official": "Angolská republika",
				"common": "Angola"
			},
			"fin": {
				"official": "Angolan tasavalta",
				"common": "Angola"
			},
			"zho": {
				"official": "安哥拉共和国",
				"common": "安哥拉"
			}
		},
		"latlng": [
			-12.5,
			18.5
		],
		"demonym": "Angolan",
		"landlocked": false,
		"borders": [
			"COG",
			"COD",
			"ZMB",
			"NAM"
		],
		"area": 1246700
	},
	{
		"name": {
			"common": "Anguilla",
			"official": "Anguilla",
			"native": {
				"eng": {
					"official": "Anguilla",
					"common": "Anguilla"
				}
			}
		},
		"tld": [
			".ai"
		],
		"cca2": "AI",
		"ccn3": "660",
		"cca3": "AIA",
		"cioc": "",
		"currency": [
			"XCD"
		],
		"callingCode": [
			"1264"
		],
		"capital": "The Valley",
		"altSpellings": [
			"AI"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Anguilla",
				"common": "Anguilla"
			},
			"fra": {
				"official": "Anguilla",
				"common": "Anguilla"
			},
			"hrv": {
				"official": "Anguilla",
				"common": "Angvila"
			},
			"ita": {
				"official": "Anguilla",
				"common": "Anguilla"
			},
			"jpn": {
				"official": "アングィラ",
				"common": "アンギラ"
			},
			"nld": {
				"official": "Anguilla",
				"common": "Anguilla"
			},
			"por": {
				"official": "Anguilla",
				"common": "Anguilla"
			},
			"rus": {
				"official": "Ангилья",
				"common": "Ангилья"
			},
			"spa": {
				"official": "Anguila",
				"common": "Anguilla"
			},
			"svk": {
				"official": "Anguilla",
				"common": "Anguilla"
			},
			"fin": {
				"official": "Anguilla",
				"common": "Anguilla"
			},
			"zho": {
				"official": "安圭拉",
				"common": "安圭拉"
			}
		},
		"latlng": [
			18.25,
			-63.16666666
		],
		"demonym": "Anguillian",
		"landlocked": false,
		"borders": [],
		"area": 91
	},
	{
		"name": {
			"common": "Åland Islands",
			"official": "Åland Islands",
			"native": {
				"swe": {
					"official": "Landskapet Åland",
					"common": "Åland"
				}
			}
		},
		"tld": [
			".ax"
		],
		"cca2": "AX",
		"ccn3": "248",
		"cca3": "ALA",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"358"
		],
		"capital": "Mariehamn",
		"altSpellings": [
			"AX",
			"Aaland",
			"Aland",
			"Ahvenanmaa"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"swe": "Swedish"
		},
		"translations": {
			"deu": {
				"official": "Åland-Inseln",
				"common": "Åland"
			},
			"fra": {
				"official": "Ahvenanmaa",
				"common": "Ahvenanmaa"
			},
			"hrv": {
				"official": "Aland Islands",
				"common": "Ålandski otoci"
			},
			"ita": {
				"official": "Isole Åland",
				"common": "Isole Aland"
			},
			"jpn": {
				"official": "オーランド諸島",
				"common": "オーランド諸島"
			},
			"nld": {
				"official": "Åland eilanden",
				"common": "Ålandeilanden"
			},
			"por": {
				"official": "Ilhas Åland",
				"common": "Alândia"
			},
			"rus": {
				"official": "Аландские острова",
				"common": "Аландские острова"
			},
			"spa": {
				"official": "Islas Åland",
				"common": "Alandia"
			},
			"svk": {
				"official": "Alandské ostrovy",
				"common": "Alandy"
			},
			"fin": {
				"official": "Ahvenanmaan maakunta",
				"common": "Ahvenanmaa"
			},
			"zho": {
				"official": "奥兰群岛",
				"common": "奥兰群岛"
			}
		},
		"latlng": [
			60.116667,
			19.9
		],
		"demonym": "Ålandish",
		"landlocked": false,
		"borders": [],
		"area": 1580
	},
	{
		"name": {
			"common": "Albania",
			"official": "Republic of Albania",
			"native": {
				"sqi": {
					"official": "Republika e Shqipërisë",
					"common": "Shqipëria"
				}
			}
		},
		"tld": [
			".al"
		],
		"cca2": "AL",
		"ccn3": "008",
		"cca3": "ALB",
		"cioc": "ALB",
		"currency": [
			"ALL"
		],
		"callingCode": [
			"355"
		],
		"capital": "Tirana",
		"altSpellings": [
			"AL",
			"Shqipëri",
			"Shqipëria",
			"Shqipnia"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"sqi": "Albanian"
		},
		"translations": {
			"cym": {
				"official": "Republic of Albania",
				"common": "Albania"
			},
			"deu": {
				"official": "Republik Albanien",
				"common": "Albanien"
			},
			"fra": {
				"official": "République d'Albanie",
				"common": "Albanie"
			},
			"hrv": {
				"official": "Republika Albanija",
				"common": "Albanija"
			},
			"ita": {
				"official": "Repubblica d'Albania",
				"common": "Albania"
			},
			"jpn": {
				"official": "アルバニア共和国",
				"common": "アルバニア"
			},
			"nld": {
				"official": "Republiek Albanië",
				"common": "Albanië"
			},
			"por": {
				"official": "República da Albânia",
				"common": "Albânia"
			},
			"rus": {
				"official": "Республика Албания",
				"common": "Албания"
			},
			"spa": {
				"official": "República de Albania",
				"common": "Albania"
			},
			"svk": {
				"official": "Albánska republika",
				"common": "Albánsko"
			},
			"fin": {
				"official": "Albanian tasavalta",
				"common": "Albania"
			},
			"zho": {
				"official": "阿尔巴尼亚共和国",
				"common": "阿尔巴尼亚"
			}
		},
		"latlng": [
			41,
			20
		],
		"demonym": "Albanian",
		"landlocked": false,
		"borders": [
			"MNE",
			"GRC",
			"MKD",
			"UNK"
		],
		"area": 28748
	},
	{
		"name": {
			"common": "Andorra",
			"official": "Principality of Andorra",
			"native": {
				"cat": {
					"official": "Principat d'Andorra",
					"common": "Andorra"
				}
			}
		},
		"tld": [
			".ad"
		],
		"cca2": "AD",
		"ccn3": "020",
		"cca3": "AND",
		"cioc": "AND",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"376"
		],
		"capital": "Andorra la Vella",
		"altSpellings": [
			"AD",
			"Principality of Andorra",
			"Principat d'Andorra"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"cat": "Catalan"
		},
		"translations": {
			"cym": {
				"official": "Principality of Andorra",
				"common": "Andorra"
			},
			"deu": {
				"official": "Fürstentum Andorra",
				"common": "Andorra"
			},
			"fra": {
				"official": "Principauté d'Andorre",
				"common": "Andorre"
			},
			"hrv": {
				"official": "Kneževina Andora",
				"common": "Andora"
			},
			"ita": {
				"official": "Principato di Andorra",
				"common": "Andorra"
			},
			"jpn": {
				"official": "アンドラ公国",
				"common": "アンドラ"
			},
			"nld": {
				"official": "Prinsdom Andorra",
				"common": "Andorra"
			},
			"por": {
				"official": "Principado de Andorra",
				"common": "Andorra"
			},
			"rus": {
				"official": "Княжество Андорра",
				"common": "Андорра"
			},
			"spa": {
				"official": "Principado de Andorra",
				"common": "Andorra"
			},
			"svk": {
				"official": "Andorrské kniežatstvo",
				"common": "Andorra"
			},
			"fin": {
				"official": "Andorran ruhtinaskunta",
				"common": "Andorra"
			},
			"zho": {
				"official": "安道尔公国",
				"common": "安道尔"
			}
		},
		"latlng": [
			42.5,
			1.5
		],
		"demonym": "Andorran",
		"landlocked": true,
		"borders": [
			"FRA",
			"ESP"
		],
		"area": 468
	},
	{
		"name": {
			"common": "United Arab Emirates",
			"official": "United Arab Emirates",
			"native": {
				"ara": {
					"official": "الإمارات العربية المتحدة",
					"common": "دولة الإمارات العربية المتحدة"
				}
			}
		},
		"tld": [
			".ae",
			"امارات."
		],
		"cca2": "AE",
		"ccn3": "784",
		"cca3": "ARE",
		"cioc": "UAE",
		"currency": [
			"AED"
		],
		"callingCode": [
			"971"
		],
		"capital": "Abu Dhabi",
		"altSpellings": [
			"AE",
			"UAE",
			"Emirates"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Vereinigte Arabische Emirate",
				"common": "Vereinigte Arabische Emirate"
			},
			"fra": {
				"official": "Émirats arabes unis",
				"common": "Émirats arabes unis"
			},
			"hrv": {
				"official": "Ujedinjeni Arapski Emirati",
				"common": "Ujedinjeni Arapski Emirati"
			},
			"ita": {
				"official": "Emirati Arabi Uniti",
				"common": "Emirati Arabi Uniti"
			},
			"jpn": {
				"official": "アラブ首長国連邦",
				"common": "アラブ首長国連邦"
			},
			"nld": {
				"official": "Verenigde Arabische Emiraten",
				"common": "Verenigde Arabische Emiraten"
			},
			"por": {
				"official": "Emirados Árabes Unidos",
				"common": "Emirados Árabes Unidos"
			},
			"rus": {
				"official": "Объединенные Арабские Эмираты",
				"common": "Объединённые Арабские Эмираты"
			},
			"spa": {
				"official": "Emiratos Árabes Unidos",
				"common": "Emiratos Árabes Unidos"
			},
			"svk": {
				"official": "Spojené arabské emiráty",
				"common": "Spojené arabské emiráty"
			},
			"fin": {
				"official": "Yhdistyneet arabiemiirikunnat",
				"common": "Arabiemiraatit"
			},
			"zho": {
				"official": "阿拉伯联合酋长国",
				"common": "阿拉伯联合酋长国"
			}
		},
		"latlng": [
			24,
			54
		],
		"demonym": "Emirati",
		"landlocked": false,
		"borders": [
			"OMN",
			"SAU"
		],
		"area": 83600
	},
	{
		"name": {
			"common": "Argentina",
			"official": "Argentine Republic",
			"native": {
				"grn": {
					"official": "Argentine Republic",
					"common": "Argentina"
				},
				"spa": {
					"official": "República Argentina",
					"common": "Argentina"
				}
			}
		},
		"tld": [
			".ar"
		],
		"cca2": "AR",
		"ccn3": "032",
		"cca3": "ARG",
		"cioc": "ARG",
		"currency": [
			"ARS"
		],
		"callingCode": [
			"54"
		],
		"capital": "Buenos Aires",
		"altSpellings": [
			"AR",
			"Argentine Republic",
			"República Argentina"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"grn": "Guaraní",
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Argentine Republic",
				"common": "Ariannin"
			},
			"deu": {
				"official": "Argentinische Republik",
				"common": "Argentinien"
			},
			"fra": {
				"official": "République argentine",
				"common": "Argentine"
			},
			"hrv": {
				"official": "Argentinski Republika",
				"common": "Argentina"
			},
			"ita": {
				"official": "Repubblica Argentina",
				"common": "Argentina"
			},
			"jpn": {
				"official": "アルゼンチン共和国",
				"common": "アルゼンチン"
			},
			"nld": {
				"official": "Argentijnse Republiek",
				"common": "Argentinië"
			},
			"por": {
				"official": "República Argentina",
				"common": "Argentina"
			},
			"rus": {
				"official": "Аргентинская Республика",
				"common": "Аргентина"
			},
			"spa": {
				"official": "República Argentina",
				"common": "Argentina"
			},
			"svk": {
				"official": " Argentínska republika",
				"common": "Argentína"
			},
			"fin": {
				"official": "Argentiinan tasavalta",
				"common": "Argentiina"
			},
			"zho": {
				"official": "阿根廷共和国",
				"common": "阿根廷"
			}
		},
		"latlng": [
			-34,
			-64
		],
		"demonym": "Argentine",
		"landlocked": false,
		"borders": [
			"BOL",
			"BRA",
			"CHL",
			"PRY",
			"URY"
		],
		"area": 2780400
	},
	{
		"name": {
			"common": "Armenia",
			"official": "Republic of Armenia",
			"native": {
				"hye": {
					"official": "Հայաստանի Հանրապետություն",
					"common": "Հայաստան"
				},
				"rus": {
					"official": "Республика Армения",
					"common": "Армения"
				}
			}
		},
		"tld": [
			".am"
		],
		"cca2": "AM",
		"ccn3": "051",
		"cca3": "ARM",
		"cioc": "ARM",
		"currency": [
			"AMD"
		],
		"callingCode": [
			"374"
		],
		"capital": "Yerevan",
		"altSpellings": [
			"AM",
			"Hayastan",
			"Republic of Armenia",
			"Հայաստանի Հանրապետություն"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"hye": "Armenian",
			"rus": "Russian"
		},
		"translations": {
			"cym": {
				"official": "Republic of Armenia",
				"common": "Armenia"
			},
			"deu": {
				"official": "Republik Armenien",
				"common": "Armenien"
			},
			"fra": {
				"official": "République d'Arménie",
				"common": "Arménie"
			},
			"hrv": {
				"official": "Republika Armenija",
				"common": "Armenija"
			},
			"ita": {
				"official": "Repubblica di Armenia",
				"common": "Armenia"
			},
			"jpn": {
				"official": "アルメニア共和国",
				"common": "アルメニア"
			},
			"nld": {
				"official": "Republiek Armenië",
				"common": "Armenië"
			},
			"por": {
				"official": "República da Arménia",
				"common": "Arménia"
			},
			"rus": {
				"official": "Республика Армения",
				"common": "Армения"
			},
			"spa": {
				"official": "República de Armenia",
				"common": "Armenia"
			},
			"svk": {
				"official": "Arménska republika",
				"common": "Arménsko"
			},
			"fin": {
				"official": "Armenian tasavalta",
				"common": "Armenia"
			},
			"zho": {
				"official": "亚美尼亚共和国",
				"common": "亚美尼亚"
			}
		},
		"latlng": [
			40,
			45
		],
		"demonym": "Armenian",
		"landlocked": true,
		"borders": [
			"AZE",
			"GEO",
			"IRN",
			"TUR"
		],
		"area": 29743
	},
	{
		"name": {
			"common": "American Samoa",
			"official": "American Samoa",
			"native": {
				"eng": {
					"official": "American Samoa",
					"common": "American Samoa"
				},
				"smo": {
					"official": "Sāmoa Amelika",
					"common": "Sāmoa Amelika"
				}
			}
		},
		"tld": [
			".as"
		],
		"cca2": "AS",
		"ccn3": "016",
		"cca3": "ASM",
		"cioc": "ASA",
		"currency": [
			"USD"
		],
		"callingCode": [
			"1684"
		],
		"capital": "Pago Pago",
		"altSpellings": [
			"AS",
			"Amerika Sāmoa",
			"Amelika Sāmoa",
			"Sāmoa Amelika"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"eng": "English",
			"smo": "Samoan"
		},
		"translations": {
			"deu": {
				"official": "Amerikanisch-Samoa",
				"common": "Amerikanisch-Samoa"
			},
			"fra": {
				"official": "Samoa américaines",
				"common": "Samoa américaines"
			},
			"hrv": {
				"official": "američka Samoa",
				"common": "Američka Samoa"
			},
			"ita": {
				"official": "Samoa americane",
				"common": "Samoa Americane"
			},
			"jpn": {
				"official": "米サモア",
				"common": "アメリカ領サモア"
			},
			"nld": {
				"official": "Amerikaans Samoa",
				"common": "Amerikaans Samoa"
			},
			"por": {
				"official": "Samoa americana",
				"common": "Samoa Americana"
			},
			"rus": {
				"official": "американское Самоа",
				"common": "Американское Самоа"
			},
			"spa": {
				"official": "Samoa Americana",
				"common": "Samoa Americana"
			},
			"svk": {
				"official": "Americká Samoa",
				"common": "Americká Samoa"
			},
			"fin": {
				"official": "Amerikan Samoa",
				"common": "Amerikan Samoa"
			},
			"zho": {
				"official": "美属萨摩亚",
				"common": "美属萨摩亚"
			}
		},
		"latlng": [
			-14.33333333,
			-170
		],
		"demonym": "American Samoan",
		"landlocked": false,
		"borders": [],
		"area": 199
	},
	{
		"name": {
			"common": "Antarctica",
			"official": "Antarctica",
			"native": {}
		},
		"tld": [
			".aq"
		],
		"cca2": "AQ",
		"ccn3": "010",
		"cca3": "ATA",
		"cioc": "",
		"currency": [],
		"callingCode": [],
		"capital": "",
		"altSpellings": [
			"AQ"
		],
		"region": "",
		"subregion": "",
		"languages": {},
		"translations": {
			"cym": {
				"official": "Antarctica",
				"common": "Antarctica"
			},
			"deu": {
				"official": "Antarktika",
				"common": "Antarktis"
			},
			"fra": {
				"official": "Antarctique",
				"common": "Antarctique"
			},
			"hrv": {
				"official": "Antarktika",
				"common": "Antarktika"
			},
			"ita": {
				"official": "Antartide",
				"common": "Antartide"
			},
			"jpn": {
				"official": "南極大陸",
				"common": "南極"
			},
			"nld": {
				"official": "Antarctica",
				"common": "Antarctica"
			},
			"por": {
				"official": "Antártica",
				"common": "Antártida"
			},
			"rus": {
				"official": "Антарктида",
				"common": "Антарктида"
			},
			"spa": {
				"official": "Antártida",
				"common": "Antártida"
			},
			"svk": {
				"official": "Antarktída",
				"common": "Antarktída"
			},
			"fin": {
				"official": "Etelämanner",
				"common": "Etelämanner"
			},
			"zho": {
				"official": "南极洲",
				"common": "南极洲"
			}
		},
		"latlng": [
			-90,
			0
		],
		"demonym": "Antarctican",
		"landlocked": false,
		"borders": [],
		"area": 14000000
	},
	{
		"name": {
			"common": "French Southern and Antarctic Lands",
			"official": "Territory of the French Southern and Antarctic Lands",
			"native": {
				"fra": {
					"official": "Territoire des Terres australes et antarctiques françaises",
					"common": "Terres australes et antarctiques françaises"
				}
			}
		},
		"tld": [
			".tf"
		],
		"cca2": "TF",
		"ccn3": "260",
		"cca3": "ATF",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [],
		"capital": "Port-aux-Français",
		"altSpellings": [
			"TF",
			"French Southern Territories"
		],
		"region": "",
		"subregion": "",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Gebiet der Französisch Süd-und Antarktisgebiete",
				"common": "Französische Süd-und Antarktisgebiete"
			},
			"fra": {
				"official": "Territoire des Terres australes et antarctiques françaises",
				"common": "Terres australes et antarctiques françaises"
			},
			"hrv": {
				"official": "Teritoriju Francuski južni i antarktički teritoriji",
				"common": "Francuski južni i antarktički teritoriji"
			},
			"ita": {
				"official": "Territorio della australi e antartiche francesi Terre",
				"common": "Territori Francesi del Sud"
			},
			"jpn": {
				"official": "フランス領南方·南極地域の領土",
				"common": "フランス領南方・南極地域"
			},
			"nld": {
				"official": "Grondgebied van de Franse Zuidelijke en Antarctische gebieden",
				"common": "Franse Gebieden in de zuidelijke Indische Oceaan"
			},
			"por": {
				"official": "Território do Sul e Antártica Francesa",
				"common": "Terras Austrais e Antárticas Francesas"
			},
			"rus": {
				"official": "Территория Французские Южные и Антарктические земли",
				"common": "Французские Южные и Антарктические территории"
			},
			"spa": {
				"official": "Territorio del Francés Tierras australes y antárticas",
				"common": "Tierras Australes y Antárticas Francesas"
			},
			"svk": {
				"official": "Francúzske juŽné a antarktické územia",
				"common": "Francúzske juŽné a antarktické územia"
			},
			"fin": {
				"official": "Ranskan eteläiset ja antarktiset alueet",
				"common": "Ranskan eteläiset ja antarktiset alueet"
			},
			"zho": {
				"official": "法国南部和南极土地",
				"common": "法国南部和南极土地"
			}
		},
		"latlng": [
			-49.25,
			69.167
		],
		"demonym": "French",
		"landlocked": false,
		"borders": [],
		"area": 7747
	},
	{
		"name": {
			"common": "Antigua and Barbuda",
			"official": "Antigua and Barbuda",
			"native": {
				"eng": {
					"official": "Antigua and Barbuda",
					"common": "Antigua and Barbuda"
				}
			}
		},
		"tld": [
			".ag"
		],
		"cca2": "AG",
		"ccn3": "028",
		"cca3": "ATG",
		"cioc": "ANT",
		"currency": [
			"XCD"
		],
		"callingCode": [
			"1268"
		],
		"capital": "Saint John's",
		"altSpellings": [
			"AG"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Antigua and Barbuda",
				"common": "Antigwa a Barbiwda"
			},
			"deu": {
				"official": "Antigua und Barbuda",
				"common": "Antigua und Barbuda"
			},
			"fra": {
				"official": "Antigua -et-Barbuda",
				"common": "Antigua-et-Barbuda"
			},
			"hrv": {
				"official": "Antigva i Barbuda",
				"common": "Antigva i Barbuda"
			},
			"ita": {
				"official": "Antigua e Barbuda",
				"common": "Antigua e Barbuda"
			},
			"jpn": {
				"official": "アンチグアバーブーダ",
				"common": "アンティグア・バーブーダ"
			},
			"nld": {
				"official": "Antigua en Barbuda",
				"common": "Antigua en Barbuda"
			},
			"por": {
				"official": "Antigua e Barbuda",
				"common": "Antígua e Barbuda"
			},
			"rus": {
				"official": "Антигуа и Барбуда",
				"common": "Антигуа и Барбуда"
			},
			"spa": {
				"official": "Antigua y Barbuda",
				"common": "Antigua y Barbuda"
			},
			"svk": {
				"official": "Antigua a Barbuda",
				"common": "Antigua a Barbuda"
			},
			"fin": {
				"official": "Antigua ja Barbuda",
				"common": "Antigua ja Barbuda"
			},
			"zho": {
				"official": "安提瓜和巴布达",
				"common": "安提瓜和巴布达"
			}
		},
		"latlng": [
			17.05,
			-61.8
		],
		"demonym": "Antiguan, Barbudan",
		"landlocked": false,
		"borders": [],
		"area": 442
	},
	{
		"name": {
			"common": "Australia",
			"official": "Commonwealth of Australia",
			"native": {
				"eng": {
					"official": "Commonwealth of Australia",
					"common": "Australia"
				}
			}
		},
		"tld": [
			".au"
		],
		"cca2": "AU",
		"ccn3": "036",
		"cca3": "AUS",
		"cioc": "AUS",
		"currency": [
			"AUD"
		],
		"callingCode": [
			"61"
		],
		"capital": "Canberra",
		"altSpellings": [
			"AU"
		],
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Commonwealth of Australia",
				"common": "Awstralia"
			},
			"deu": {
				"official": "Commonwealth Australien",
				"common": "Australien"
			},
			"fra": {
				"official": "Australie",
				"common": "Australie"
			},
			"hrv": {
				"official": "Commonwealth of Australia",
				"common": "Australija"
			},
			"ita": {
				"official": "Commonwealth dell'Australia",
				"common": "Australia"
			},
			"jpn": {
				"official": "オーストラリア連邦",
				"common": "オーストラリア"
			},
			"nld": {
				"official": "Gemenebest van Australië",
				"common": "Australië"
			},
			"por": {
				"official": "Comunidade da Austrália",
				"common": "Austrália"
			},
			"rus": {
				"official": "Содружество Австралии",
				"common": "Австралия"
			},
			"spa": {
				"official": "Mancomunidad de Australia",
				"common": "Australia"
			},
			"svk": {
				"official": "Austrálsky zväz",
				"common": "Austrália"
			},
			"fin": {
				"official": "Australian liittovaltio",
				"common": "Australia"
			},
			"zho": {
				"official": "澳大利亚联邦",
				"common": "澳大利亚"
			}
		},
		"latlng": [
			-27,
			133
		],
		"demonym": "Australian",
		"landlocked": false,
		"borders": [],
		"area": 7692024
	},
	{
		"name": {
			"common": "Austria",
			"official": "Republic of Austria",
			"native": {
				"bar": {
					"official": "Republik Österreich",
					"common": "Österreich"
				}
			}
		},
		"tld": [
			".at"
		],
		"cca2": "AT",
		"ccn3": "040",
		"cca3": "AUT",
		"cioc": "AUT",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"43"
		],
		"capital": "Vienna",
		"altSpellings": [
			"AT",
			"Osterreich",
			"Oesterreich"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"bar": "Austro-Bavarian German"
		},
		"translations": {
			"cym": {
				"official": "Republic of Austria",
				"common": "Awstria"
			},
			"deu": {
				"official": "Republik Österreich",
				"common": "Österreich"
			},
			"fra": {
				"official": "République d'Autriche",
				"common": "Autriche"
			},
			"hrv": {
				"official": "Republika Austrija",
				"common": "Austrija"
			},
			"ita": {
				"official": "Repubblica d'Austria",
				"common": "Austria"
			},
			"jpn": {
				"official": "オーストリア共和国",
				"common": "オーストリア"
			},
			"nld": {
				"official": "Republiek Oostenrijk",
				"common": "Oostenrijk"
			},
			"por": {
				"official": "República da Áustria",
				"common": "Áustria"
			},
			"rus": {
				"official": "Австрийская Республика",
				"common": "Австрия"
			},
			"spa": {
				"official": "República de Austria",
				"common": "Austria"
			},
			"svk": {
				"official": "Rakúska republika",
				"common": "Rakúsko"
			},
			"fin": {
				"official": "Itävallan tasavalta",
				"common": "Itävalta"
			},
			"zho": {
				"official": "奥地利共和国",
				"common": "奥地利"
			}
		},
		"latlng": [
			47.33333333,
			13.33333333
		],
		"demonym": "Austrian",
		"landlocked": true,
		"borders": [
			"CZE",
			"DEU",
			"HUN",
			"ITA",
			"LIE",
			"SVK",
			"SVN",
			"CHE"
		],
		"area": 83871
	},
	{
		"name": {
			"common": "Azerbaijan",
			"official": "Republic of Azerbaijan",
			"native": {
				"aze": {
					"official": "Azərbaycan Respublikası",
					"common": "Azərbaycan"
				},
				"rus": {
					"official": "Азербайджанская Республика",
					"common": "Азербайджан"
				}
			}
		},
		"tld": [
			".az"
		],
		"cca2": "AZ",
		"ccn3": "031",
		"cca3": "AZE",
		"cioc": "AZE",
		"currency": [
			"AZN"
		],
		"callingCode": [
			"994"
		],
		"capital": "Baku",
		"altSpellings": [
			"AZ",
			"Republic of Azerbaijan",
			"Azərbaycan Respublikası"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"aze": "Azerbaijani",
			"rus": "Russian"
		},
		"translations": {
			"cym": {
				"official": "Republic of Azerbaijan",
				"common": "Aserbaijan"
			},
			"deu": {
				"official": "Republik Aserbaidschan",
				"common": "Aserbaidschan"
			},
			"fra": {
				"official": "République d'Azerbaïdjan",
				"common": "Azerbaïdjan"
			},
			"hrv": {
				"official": "Republika Azerbajdžan",
				"common": "Azerbajdžan"
			},
			"ita": {
				"official": "Repubblica dell'Azerbaigian",
				"common": "Azerbaijan"
			},
			"jpn": {
				"official": "アゼルバイジャン共和国",
				"common": "アゼルバイジャン"
			},
			"nld": {
				"official": "Republiek Azerbeidzjan",
				"common": "Azerbeidzjan"
			},
			"por": {
				"official": "República do Azerbaijão",
				"common": "Azerbeijão"
			},
			"rus": {
				"official": "Азербайджанская Республика",
				"common": "Азербайджан"
			},
			"spa": {
				"official": "República de Azerbaiyán",
				"common": "Azerbaiyán"
			},
			"svk": {
				"official": "Azerbajǆanská republika",
				"common": "Azerbajǆan"
			},
			"fin": {
				"official": "Azerbaidzanin tasavalta",
				"common": "Azerbaidzan"
			},
			"zho": {
				"official": "阿塞拜疆共和国",
				"common": "阿塞拜疆"
			}
		},
		"latlng": [
			40.5,
			47.5
		],
		"demonym": "Azerbaijani",
		"landlocked": true,
		"borders": [
			"ARM",
			"GEO",
			"IRN",
			"RUS",
			"TUR"
		],
		"area": 86600
	},
	{
		"name": {
			"common": "Burundi",
			"official": "Republic of Burundi",
			"native": {
				"fra": {
					"official": "République du Burundi",
					"common": "Burundi"
				},
				"run": {
					"official": "Republika y'Uburundi ",
					"common": "Uburundi"
				}
			}
		},
		"tld": [
			".bi"
		],
		"cca2": "BI",
		"ccn3": "108",
		"cca3": "BDI",
		"cioc": "BDI",
		"currency": [
			"BIF"
		],
		"callingCode": [
			"257"
		],
		"capital": "Bujumbura",
		"altSpellings": [
			"BI",
			"Republic of Burundi",
			"Republika y'Uburundi",
			"République du Burundi"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"fra": "French",
			"run": "Kirundi"
		},
		"translations": {
			"cym": {
				"official": "Republic of Burundi",
				"common": "Bwrwndi"
			},
			"deu": {
				"official": "Republik Burundi",
				"common": "Burundi"
			},
			"fra": {
				"official": "République du Burundi",
				"common": "Burundi"
			},
			"hrv": {
				"official": "Burundi",
				"common": "Burundi"
			},
			"ita": {
				"official": "Repubblica del Burundi",
				"common": "Burundi"
			},
			"jpn": {
				"official": "ブルンジ共和国",
				"common": "ブルンジ"
			},
			"nld": {
				"official": "Republiek Burundi",
				"common": "Burundi"
			},
			"por": {
				"official": "República do Burundi",
				"common": "Burundi"
			},
			"rus": {
				"official": "Республика Бурунди",
				"common": "Бурунди"
			},
			"spa": {
				"official": "República de Burundi",
				"common": "Burundi"
			},
			"svk": {
				"official": "Burundská republika",
				"common": "Burundi"
			},
			"fin": {
				"official": "Burundin tasavalta",
				"common": "Burundi"
			},
			"zho": {
				"official": "布隆迪共和国",
				"common": "布隆迪"
			}
		},
		"latlng": [
			-3.5,
			30
		],
		"demonym": "Burundian",
		"landlocked": true,
		"borders": [
			"COD",
			"RWA",
			"TZA"
		],
		"area": 27834
	},
	{
		"name": {
			"common": "Belgium",
			"official": "Kingdom of Belgium",
			"native": {
				"deu": {
					"official": "Königreich Belgien",
					"common": "Belgien"
				},
				"fra": {
					"official": "Royaume de Belgique",
					"common": "Belgique"
				},
				"nld": {
					"official": "Koninkrijk België",
					"common": "België"
				}
			}
		},
		"tld": [
			".be"
		],
		"cca2": "BE",
		"ccn3": "056",
		"cca3": "BEL",
		"cioc": "BEL",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"32"
		],
		"capital": "Brussels",
		"altSpellings": [
			"BE",
			"België",
			"Belgie",
			"Belgien",
			"Belgique",
			"Kingdom of Belgium",
			"Koninkrijk België",
			"Royaume de Belgique",
			"Königreich Belgien"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"deu": "German",
			"fra": "French",
			"nld": "Dutch"
		},
		"translations": {
			"cym": {
				"official": "Kingdom of Belgium",
				"common": "Gwlad Belg"
			},
			"deu": {
				"official": "Königreich Belgien",
				"common": "Belgien"
			},
			"fra": {
				"official": "Royaume de Belgique",
				"common": "Belgique"
			},
			"hrv": {
				"official": "Kraljevina Belgija",
				"common": "Belgija"
			},
			"ita": {
				"official": "Regno del Belgio",
				"common": "Belgio"
			},
			"jpn": {
				"official": "ベルギー王国",
				"common": "ベルギー"
			},
			"nld": {
				"official": "Koninkrijk België",
				"common": "België"
			},
			"por": {
				"official": "Reino da Bélgica",
				"common": "Bélgica"
			},
			"rus": {
				"official": "Королевство Бельгия",
				"common": "Бельгия"
			},
			"spa": {
				"official": "Reino de Bélgica",
				"common": "Bélgica"
			},
			"svk": {
				"official": "Belgické kráľovstvo",
				"common": "Belgicko"
			},
			"fin": {
				"official": "Belgian kuningaskunta",
				"common": "Belgia"
			},
			"zho": {
				"official": "比利时王国",
				"common": "比利时"
			}
		},
		"latlng": [
			50.83333333,
			4
		],
		"demonym": "Belgian",
		"landlocked": false,
		"borders": [
			"FRA",
			"DEU",
			"LUX",
			"NLD"
		],
		"area": 30528
	},
	{
		"name": {
			"common": "Benin",
			"official": "Republic of Benin",
			"native": {
				"fra": {
					"official": "République du Bénin",
					"common": "Bénin"
				}
			}
		},
		"tld": [
			".bj"
		],
		"cca2": "BJ",
		"ccn3": "204",
		"cca3": "BEN",
		"cioc": "BEN",
		"currency": [
			"XOF"
		],
		"callingCode": [
			"229"
		],
		"capital": "Porto-Novo",
		"altSpellings": [
			"BJ",
			"Republic of Benin",
			"République du Bénin"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"cym": {
				"official": "Republic of Benin",
				"common": "Benin"
			},
			"deu": {
				"official": "Republik Benin",
				"common": "Benin"
			},
			"fra": {
				"official": "République du Bénin",
				"common": "Bénin"
			},
			"hrv": {
				"official": "Republika Benin",
				"common": "Benin"
			},
			"ita": {
				"official": "Repubblica del Benin",
				"common": "Benin"
			},
			"jpn": {
				"official": "ベナン共和国",
				"common": "ベナン"
			},
			"nld": {
				"official": "Republiek Benin",
				"common": "Benin"
			},
			"por": {
				"official": "República do Benin",
				"common": "Benin"
			},
			"rus": {
				"official": "Республика Бенин",
				"common": "Бенин"
			},
			"spa": {
				"official": "República de Benin",
				"common": "Benín"
			},
			"svk": {
				"official": "Beninská republika",
				"common": "Benin"
			},
			"fin": {
				"official": "Beninin tasavalta",
				"common": "Benin"
			},
			"zho": {
				"official": "贝宁共和国",
				"common": "贝宁"
			}
		},
		"latlng": [
			9.5,
			2.25
		],
		"demonym": "Beninese",
		"landlocked": false,
		"borders": [
			"BFA",
			"NER",
			"NGA",
			"TGO"
		],
		"area": 112622
	},
	{
		"name": {
			"common": "Burkina Faso",
			"official": "Burkina Faso",
			"native": {
				"fra": {
					"official": "République du Burkina",
					"common": "Burkina Faso"
				}
			}
		},
		"tld": [
			".bf"
		],
		"cca2": "BF",
		"ccn3": "854",
		"cca3": "BFA",
		"cioc": "BUR",
		"currency": [
			"XOF"
		],
		"callingCode": [
			"226"
		],
		"capital": "Ouagadougou",
		"altSpellings": [
			"BF"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"cym": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"deu": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"fra": {
				"official": "République du Burkina",
				"common": "Burkina Faso"
			},
			"hrv": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"ita": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"jpn": {
				"official": "ブルキナファソ",
				"common": "ブルキナファソ"
			},
			"nld": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"por": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"rus": {
				"official": "Буркина -Фасо",
				"common": "Буркина-Фасо"
			},
			"spa": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"svk": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"fin": {
				"official": "Burkina Faso",
				"common": "Burkina Faso"
			},
			"zho": {
				"official": "布基纳法索",
				"common": "布基纳法索"
			}
		},
		"latlng": [
			13,
			-2
		],
		"demonym": "Burkinabe",
		"landlocked": true,
		"borders": [
			"BEN",
			"CIV",
			"GHA",
			"MLI",
			"NER",
			"TGO"
		],
		"area": 272967
	},
	{
		"name": {
			"common": "Bangladesh",
			"official": "People's Republic of Bangladesh",
			"native": {
				"ben": {
					"official": "বাংলাদেশ গণপ্রজাতন্ত্রী",
					"common": "বাংলাদেশ"
				}
			}
		},
		"tld": [
			".bd"
		],
		"cca2": "BD",
		"ccn3": "050",
		"cca3": "BGD",
		"cioc": "BAN",
		"currency": [
			"BDT"
		],
		"callingCode": [
			"880"
		],
		"capital": "Dhaka",
		"altSpellings": [
			"BD",
			"People's Republic of Bangladesh",
			"Gônôprôjatôntri Bangladesh"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"ben": "Bengali"
		},
		"translations": {
			"cym": {
				"official": "People's Republic of Bangladesh",
				"common": "Bangladesh"
			},
			"deu": {
				"official": "Volksrepublik Bangladesch",
				"common": "Bangladesch"
			},
			"fra": {
				"official": "La République populaire du Bangladesh",
				"common": "Bangladesh"
			},
			"hrv": {
				"official": "Narodna Republika Bangladeš",
				"common": "Bangladeš"
			},
			"ita": {
				"official": "Repubblica popolare del Bangladesh",
				"common": "Bangladesh"
			},
			"jpn": {
				"official": "バングラデシュ人民共和国",
				"common": "バングラデシュ"
			},
			"nld": {
				"official": "Volksrepubliek Bangladesh",
				"common": "Bangladesh"
			},
			"por": {
				"official": "República Popular do Bangladesh",
				"common": "Bangladesh"
			},
			"rus": {
				"official": "Народная Республика Бангладеш",
				"common": "Бангладеш"
			},
			"spa": {
				"official": "República Popular de Bangladesh",
				"common": "Bangladesh"
			},
			"svk": {
				"official": "Bangladéšska ľudová republika",
				"common": "Bangladéš"
			},
			"fin": {
				"official": "Bangladeshin kansantasavalta",
				"common": "Bangladesh"
			},
			"zho": {
				"official": "孟加拉人民共和国",
				"common": "孟加拉国"
			}
		},
		"latlng": [
			24,
			90
		],
		"demonym": "Bangladeshi",
		"landlocked": false,
		"borders": [
			"MMR",
			"IND"
		],
		"area": 147570
	},
	{
		"name": {
			"common": "Bulgaria",
			"official": "Republic of Bulgaria",
			"native": {
				"bul": {
					"official": "Република България",
					"common": "България"
				}
			}
		},
		"tld": [
			".bg"
		],
		"cca2": "BG",
		"ccn3": "100",
		"cca3": "BGR",
		"cioc": "BUL",
		"currency": [
			"BGN"
		],
		"callingCode": [
			"359"
		],
		"capital": "Sofia",
		"altSpellings": [
			"BG",
			"Republic of Bulgaria",
			"Република България"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"bul": "Bulgarian"
		},
		"translations": {
			"cym": {
				"official": "Republic of Bulgaria",
				"common": "Bwlgaria"
			},
			"deu": {
				"official": "Republik Bulgarien",
				"common": "Bulgarien"
			},
			"fra": {
				"official": "République de Bulgarie",
				"common": "Bulgarie"
			},
			"hrv": {
				"official": "Republika Bugarska",
				"common": "Bugarska"
			},
			"ita": {
				"official": "Repubblica di Bulgaria",
				"common": "Bulgaria"
			},
			"jpn": {
				"official": "ブルガリア共和国",
				"common": "ブルガリア"
			},
			"nld": {
				"official": "Republiek Bulgarije",
				"common": "Bulgarije"
			},
			"por": {
				"official": "República da Bulgária",
				"common": "Bulgária"
			},
			"rus": {
				"official": "Республика Болгария",
				"common": "Болгария"
			},
			"spa": {
				"official": "República de Bulgaria",
				"common": "Bulgaria"
			},
			"svk": {
				"official": "Bulharská republika",
				"common": "Bulharsko"
			},
			"fin": {
				"official": "Bulgarian tasavalta",
				"common": "Bulgaria"
			},
			"zho": {
				"official": "保加利亚共和国",
				"common": "保加利亚"
			}
		},
		"latlng": [
			43,
			25
		],
		"demonym": "Bulgarian",
		"landlocked": false,
		"borders": [
			"GRC",
			"MKD",
			"ROU",
			"SRB",
			"TUR"
		],
		"area": 110879
	},
	{
		"name": {
			"common": "Bahrain",
			"official": "Kingdom of Bahrain",
			"native": {
				"ara": {
					"official": "مملكة البحرين",
					"common": "‏البحرين"
				}
			}
		},
		"tld": [
			".bh"
		],
		"cca2": "BH",
		"ccn3": "048",
		"cca3": "BHR",
		"cioc": "BRN",
		"currency": [
			"BHD"
		],
		"callingCode": [
			"973"
		],
		"capital": "Manama",
		"altSpellings": [
			"BH",
			"Kingdom of Bahrain",
			"Mamlakat al-Baḥrayn"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"cym": {
				"official": "Kingdom of Bahrain",
				"common": "Bahrain"
			},
			"deu": {
				"official": "Königreich Bahrain",
				"common": "Bahrain"
			},
			"fra": {
				"official": "Royaume de Bahreïn",
				"common": "Bahreïn"
			},
			"hrv": {
				"official": "Kraljevina Bahrein",
				"common": "Bahrein"
			},
			"ita": {
				"official": "Regno del Bahrain",
				"common": "Bahrein"
			},
			"jpn": {
				"official": "バーレーン王国",
				"common": "バーレーン"
			},
			"nld": {
				"official": "Koninkrijk Bahrein",
				"common": "Bahrein"
			},
			"por": {
				"official": "Reino do Bahrein",
				"common": "Bahrein"
			},
			"rus": {
				"official": "Королевство Бахрейн",
				"common": "Бахрейн"
			},
			"spa": {
				"official": "Reino de Bahrein",
				"common": "Bahrein"
			},
			"svk": {
				"official": "Bahrajnské kráľovstvo",
				"common": "Bahrajn"
			},
			"fin": {
				"official": "Bahrainin kuningaskunta",
				"common": "Bahrain"
			},
			"zho": {
				"official": "巴林王国",
				"common": "巴林"
			}
		},
		"latlng": [
			26,
			50.55
		],
		"demonym": "Bahraini",
		"landlocked": false,
		"borders": [],
		"area": 765
	},
	{
		"name": {
			"common": "Bahamas",
			"official": "Commonwealth of the Bahamas",
			"native": {
				"eng": {
					"official": "Commonwealth of the Bahamas",
					"common": "Bahamas"
				}
			}
		},
		"tld": [
			".bs"
		],
		"cca2": "BS",
		"ccn3": "044",
		"cca3": "BHS",
		"cioc": "BAH",
		"currency": [
			"BSD"
		],
		"callingCode": [
			"1242"
		],
		"capital": "Nassau",
		"altSpellings": [
			"BS",
			"Commonwealth of the Bahamas"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Commonwealth of the Bahamas",
				"common": "Bahamas"
			},
			"deu": {
				"official": "Commonwealth der Bahamas",
				"common": "Bahamas"
			},
			"fra": {
				"official": "Commonwealth des Bahamas",
				"common": "Bahamas"
			},
			"hrv": {
				"official": "Zajednica Bahama",
				"common": "Bahami"
			},
			"ita": {
				"official": "Commonwealth delle Bahamas",
				"common": "Bahamas"
			},
			"jpn": {
				"official": "バハマ",
				"common": "バハマ"
			},
			"nld": {
				"official": "Gemenebest van de Bahama's",
				"common": "Bahama’s"
			},
			"por": {
				"official": "Comunidade das Bahamas",
				"common": "Bahamas"
			},
			"rus": {
				"official": "Содружество Багамских Островов",
				"common": "Багамские Острова"
			},
			"spa": {
				"official": "Commonwealth de las Bahamas",
				"common": "Bahamas"
			},
			"svk": {
				"official": "Bahamské spoločenstvo",
				"common": "Bahamy"
			},
			"fin": {
				"official": "Bahaman liittovaltio",
				"common": "Bahamasaaret"
			},
			"zho": {
				"official": "巴哈马联邦",
				"common": "巴哈马"
			}
		},
		"latlng": [
			24.25,
			-76
		],
		"demonym": "Bahamian",
		"landlocked": false,
		"borders": [],
		"area": 13943
	},
	{
		"name": {
			"common": "Bosnia and Herzegovina",
			"official": "Bosnia and Herzegovina",
			"native": {
				"bos": {
					"official": "Bosna i Hercegovina",
					"common": "Bosna i Hercegovina"
				},
				"hrv": {
					"official": "Bosna i Hercegovina",
					"common": "Bosna i Hercegovina"
				},
				"srp": {
					"official": "Боснa и Херцеговина",
					"common": "Боснa и Херцеговина"
				}
			}
		},
		"tld": [
			".ba"
		],
		"cca2": "BA",
		"ccn3": "070",
		"cca3": "BIH",
		"cioc": "BIH",
		"currency": [
			"BAM"
		],
		"callingCode": [
			"387"
		],
		"capital": "Sarajevo",
		"altSpellings": [
			"BA",
			"Bosnia-Herzegovina",
			"Босна и Херцеговина"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"bos": "Bosnian",
			"hrv": "Croatian",
			"srp": "Serbian"
		},
		"translations": {
			"cym": {
				"official": "Bosnia and Herzegovina",
				"common": "Bosnia a Hercegovina"
			},
			"deu": {
				"official": "Bosnien und Herzegowina",
				"common": "Bosnien und Herzegowina"
			},
			"fra": {
				"official": "Bosnie-et-Herzégovine",
				"common": "Bosnie-Herzégovine"
			},
			"hrv": {
				"official": "Bosna i Hercegovina",
				"common": "Bosna i Hercegovina"
			},
			"ita": {
				"official": "Bosnia-Erzegovina",
				"common": "Bosnia ed Erzegovina"
			},
			"jpn": {
				"official": "ボスニア·ヘルツェゴビナ",
				"common": "ボスニア・ヘルツェゴビナ"
			},
			"nld": {
				"official": "Bosnië-Herzegovina",
				"common": "Bosnië en Herzegovina"
			},
			"por": {
				"official": "Bósnia e Herzegovina",
				"common": "Bósnia e Herzegovina"
			},
			"rus": {
				"official": "Босния и Герцеговина",
				"common": "Босния и Герцеговина"
			},
			"spa": {
				"official": "Bosnia y Herzegovina",
				"common": "Bosnia y Herzegovina"
			},
			"svk": {
				"official": "Republika Bosny a Hercegoviny",
				"common": "Bosna a Hercegovina"
			},
			"fin": {
				"official": "Bosnia ja Hertsegovina",
				"common": "Bosnia ja Hertsegovina"
			},
			"zho": {
				"official": "波斯尼亚和黑塞哥维那",
				"common": "波斯尼亚和黑塞哥维那"
			}
		},
		"latlng": [
			44,
			18
		],
		"demonym": "Bosnian, Herzegovinian",
		"landlocked": false,
		"borders": [
			"HRV",
			"MNE",
			"SRB"
		],
		"area": 51209
	},
	{
		"name": {
			"common": "Saint Barthélemy",
			"official": "Collectivity of Saint Barthélemy",
			"native": {
				"fra": {
					"official": "Collectivité de Saint-Barthélemy",
					"common": "Saint-Barthélemy"
				}
			}
		},
		"tld": [
			".bl"
		],
		"cca2": "BL",
		"ccn3": "652",
		"cca3": "BLM",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"590"
		],
		"capital": "Gustavia",
		"altSpellings": [
			"BL",
			"St. Barthelemy",
			"Collectivity of Saint Barthélemy",
			"Collectivité de Saint-Barthélemy"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Gebietskörperschaft Saint -Barthélemy",
				"common": "Saint-Barthélemy"
			},
			"fra": {
				"official": "Collectivité de Saint-Barthélemy",
				"common": "Saint-Barthélemy"
			},
			"hrv": {
				"official": "Kolektivnost sv Barthélemy",
				"common": "Saint Barthélemy"
			},
			"ita": {
				"official": "Collettività di Saint Barthélemy",
				"common": "Antille Francesi"
			},
			"jpn": {
				"official": "サン·バルテルミー島の集合体",
				"common": "サン・バルテルミー"
			},
			"nld": {
				"official": "Gemeenschap Saint Barthélemy",
				"common": "Saint Barthélemy"
			},
			"por": {
				"official": "Coletividade de Saint Barthélemy",
				"common": "São Bartolomeu"
			},
			"rus": {
				"official": "Коллективность Санкт -Бартельми",
				"common": "Сен-Бартелеми"
			},
			"spa": {
				"official": "Colectividad de San Barthélemy",
				"common": "San Bartolomé"
			},
			"svk": {
				"official": "Svätý Bartolomej",
				"common": "Svätý Bartolomej"
			},
			"fin": {
				"official": "Saint-Barthélemyn yhteisö",
				"common": "Saint-Barthélemy"
			},
			"zho": {
				"official": "圣巴泰勒米集体",
				"common": "圣巴泰勒米"
			}
		},
		"latlng": [
			18.5,
			-63.41666666
		],
		"demonym": "Saint Barthélemy Islander",
		"landlocked": false,
		"borders": [],
		"area": 21
	},
	{
		"name": {
			"common": "Belarus",
			"official": "Republic of Belarus",
			"native": {
				"bel": {
					"official": "Рэспубліка Беларусь",
					"common": "Белару́сь"
				},
				"rus": {
					"official": "Республика Беларусь",
					"common": "Беларусь"
				}
			}
		},
		"tld": [
			".by"
		],
		"cca2": "BY",
		"ccn3": "112",
		"cca3": "BLR",
		"cioc": "BLR",
		"currency": [
			"BYN"
		],
		"callingCode": [
			"375"
		],
		"capital": "Minsk",
		"altSpellings": [
			"BY",
			"Bielaruś",
			"Republic of Belarus",
			"Белоруссия",
			"Республика Белоруссия"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"bel": "Belarusian",
			"rus": "Russian"
		},
		"translations": {
			"cym": {
				"official": "Republic of Belarus",
				"common": "Belarws"
			},
			"deu": {
				"official": "Republik Belarus",
				"common": "Weißrussland"
			},
			"fra": {
				"official": "République de Biélorussie",
				"common": "Biélorussie"
			},
			"hrv": {
				"official": "Republika Bjelorusija",
				"common": "Bjelorusija"
			},
			"ita": {
				"official": "Repubblica di Belarus",
				"common": "Bielorussia"
			},
			"jpn": {
				"official": "ベラルーシ共和国",
				"common": "ベラルーシ"
			},
			"nld": {
				"official": "Republiek Belarus",
				"common": "Wit-Rusland"
			},
			"por": {
				"official": "República da Bielorrússia",
				"common": "Bielorússia"
			},
			"rus": {
				"official": "Республика Беларусь",
				"common": "Беларусь"
			},
			"spa": {
				"official": "República de Belarús",
				"common": "Bielorrusia"
			},
			"svk": {
				"official": "Bieloruská republika",
				"common": "Bielorusko"
			},
			"fin": {
				"official": "Valko-Venäjän tasavalta",
				"common": "Valko-Venäjä"
			},
			"zho": {
				"official": "白俄罗斯共和国",
				"common": "白俄罗斯"
			}
		},
		"latlng": [
			53,
			28
		],
		"demonym": "Belarusian",
		"landlocked": true,
		"borders": [
			"LVA",
			"LTU",
			"POL",
			"RUS",
			"UKR"
		],
		"area": 207600
	},
	{
		"name": {
			"common": "Belize",
			"official": "Belize",
			"native": {
				"bjz": {
					"official": "Belize",
					"common": "Belize"
				},
				"eng": {
					"official": "Belize",
					"common": "Belize"
				},
				"spa": {
					"official": "Belice",
					"common": "Belice"
				}
			}
		},
		"tld": [
			".bz"
		],
		"cca2": "BZ",
		"ccn3": "084",
		"cca3": "BLZ",
		"cioc": "BIZ",
		"currency": [
			"BZD"
		],
		"callingCode": [
			"501"
		],
		"capital": "Belmopan",
		"altSpellings": [
			"BZ"
		],
		"region": "Americas",
		"subregion": "Central America",
		"languages": {
			"bjz": "Belizean Creole",
			"eng": "English",
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Belize",
				"common": "Belize"
			},
			"deu": {
				"official": "Belize",
				"common": "Belize"
			},
			"fra": {
				"official": "Belize",
				"common": "Belize"
			},
			"hrv": {
				"official": "Belize",
				"common": "Belize"
			},
			"ita": {
				"official": "Belize",
				"common": "Belize"
			},
			"jpn": {
				"official": "ベリーズ",
				"common": "ベリーズ"
			},
			"nld": {
				"official": "Belize",
				"common": "Belize"
			},
			"por": {
				"official": "Belize",
				"common": "Belize"
			},
			"rus": {
				"official": "Белиз",
				"common": "Белиз"
			},
			"spa": {
				"official": "Belice",
				"common": "Belice"
			},
			"svk": {
				"official": "Belize",
				"common": "Belize"
			},
			"fin": {
				"official": "Belize",
				"common": "Belize"
			},
			"zho": {
				"official": "伯利兹",
				"common": "伯利兹"
			}
		},
		"latlng": [
			17.25,
			-88.75
		],
		"demonym": "Belizean",
		"landlocked": false,
		"borders": [
			"GTM",
			"MEX"
		],
		"area": 22966
	},
	{
		"name": {
			"common": "Bermuda",
			"official": "Bermuda",
			"native": {
				"eng": {
					"official": "Bermuda",
					"common": "Bermuda"
				}
			}
		},
		"tld": [
			".bm"
		],
		"cca2": "BM",
		"ccn3": "060",
		"cca3": "BMU",
		"cioc": "BER",
		"currency": [
			"BMD"
		],
		"callingCode": [
			"1441"
		],
		"capital": "Hamilton",
		"altSpellings": [
			"BM",
			"The Islands of Bermuda",
			"The Bermudas",
			"Somers Isles"
		],
		"region": "Americas",
		"subregion": "Northern America",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Bermuda",
				"common": "Bermiwda"
			},
			"deu": {
				"official": "Bermuda",
				"common": "Bermuda"
			},
			"fra": {
				"official": "Bermudes",
				"common": "Bermudes"
			},
			"hrv": {
				"official": "Bermuda",
				"common": "Bermudi"
			},
			"ita": {
				"official": "Bermuda",
				"common": "Bermuda"
			},
			"jpn": {
				"official": "バミューダ",
				"common": "バミューダ"
			},
			"nld": {
				"official": "Bermuda",
				"common": "Bermuda"
			},
			"por": {
				"official": "Bermudas",
				"common": "Bermudas"
			},
			"rus": {
				"official": "Бермудские острова",
				"common": "Бермудские Острова"
			},
			"spa": {
				"official": "Bermuda",
				"common": "Bermudas"
			},
			"svk": {
				"official": "Bermudy",
				"common": "Bermudy"
			},
			"fin": {
				"official": "Bermuda",
				"common": "Bermuda"
			},
			"zho": {
				"official": "百慕大",
				"common": "百慕大"
			}
		},
		"latlng": [
			32.33333333,
			-64.75
		],
		"demonym": "Bermudian",
		"landlocked": false,
		"borders": [],
		"area": 54
	},
	{
		"name": {
			"common": "Bolivia",
			"official": "Plurinational State of Bolivia",
			"native": {
				"aym": {
					"official": "Wuliwya Suyu",
					"common": "Wuliwya"
				},
				"grn": {
					"official": "Tetã Volívia",
					"common": "Volívia"
				},
				"que": {
					"official": "Buliwya Mamallaqta",
					"common": "Buliwya"
				},
				"spa": {
					"official": "Estado Plurinacional de Bolivia",
					"common": "Bolivia"
				}
			}
		},
		"tld": [
			".bo"
		],
		"cca2": "BO",
		"ccn3": "068",
		"cca3": "BOL",
		"cioc": "BOL",
		"currency": [
			"BOB",
			"BOV"
		],
		"callingCode": [
			"591"
		],
		"capital": "Sucre",
		"altSpellings": [
			"BO",
			"Buliwya",
			"Wuliwya",
			"Bolivia, Plurinational State of",
			"Plurinational State of Bolivia",
			"Estado Plurinacional de Bolivia",
			"Buliwya Mamallaqta",
			"Wuliwya Suyu",
			"Tetã Volívia"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"aym": "Aymara",
			"grn": "Guaraní",
			"que": "Quechua",
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Plurinational State of Bolivia",
				"common": "Bolifia"
			},
			"deu": {
				"official": "Multinationaler Staat von Bolivien",
				"common": "Bolivien"
			},
			"fra": {
				"official": "État plurinational de Bolivie",
				"common": "Bolivie"
			},
			"hrv": {
				"official": "Plurinational State of Bolivia",
				"common": "Bolivija"
			},
			"ita": {
				"official": "Stato Plurinazionale della Bolivia",
				"common": "Bolivia"
			},
			"jpn": {
				"official": "ボリビアの多民族国",
				"common": "ボリビア多民族国"
			},
			"nld": {
				"official": "Plurinationale Staat van Bolivia",
				"common": "Bolivia"
			},
			"por": {
				"official": "Estado Plurinacional da Bolívia",
				"common": "Bolívia"
			},
			"rus": {
				"official": "Многонациональное Государство Боливия",
				"common": "Боливия"
			},
			"spa": {
				"official": "Estado Plurinacional de Bolivia",
				"common": "Bolivia"
			},
			"svk": {
				"official": "Bolívijská republika",
				"common": "Bolívija"
			},
			"fin": {
				"official": "Bolivian monikansainen valtio",
				"common": "Bolivia"
			},
			"zho": {
				"official": "多民族玻利维亚国",
				"common": "玻利维亚"
			}
		},
		"latlng": [
			-17,
			-65
		],
		"demonym": "Bolivian",
		"landlocked": true,
		"borders": [
			"ARG",
			"BRA",
			"CHL",
			"PRY",
			"PER"
		],
		"area": 1098581
	},
	{
		"name": {
			"common": "Brazil",
			"official": "Federative Republic of Brazil",
			"native": {
				"por": {
					"official": "República Federativa do Brasil",
					"common": "Brasil"
				}
			}
		},
		"tld": [
			".br"
		],
		"cca2": "BR",
		"ccn3": "076",
		"cca3": "BRA",
		"cioc": "BRA",
		"currency": [
			"BRL"
		],
		"callingCode": [
			"55"
		],
		"capital": "Brasília",
		"altSpellings": [
			"BR",
			"Brasil",
			"Federative Republic of Brazil",
			"República Federativa do Brasil"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"por": "Portuguese"
		},
		"translations": {
			"cym": {
				"official": "Federative Republic of Brazil",
				"common": "Brasil"
			},
			"deu": {
				"official": "Föderative Republik Brasilien",
				"common": "Brasilien"
			},
			"fra": {
				"official": "République fédérative du Brésil",
				"common": "Brésil"
			},
			"hrv": {
				"official": "Savezne Republike Brazil",
				"common": "Brazil"
			},
			"ita": {
				"official": "Repubblica federativa del Brasile",
				"common": "Brasile"
			},
			"jpn": {
				"official": "ブラジル連邦共和国",
				"common": "ブラジル"
			},
			"nld": {
				"official": "Federale Republiek Brazilië",
				"common": "Brazilië"
			},
			"por": {
				"official": "República Federativa do Brasil",
				"common": "Brasil"
			},
			"rus": {
				"official": "Федеративная Республика Бразилия",
				"common": "Бразилия"
			},
			"spa": {
				"official": "República Federativa del Brasil",
				"common": "Brasil"
			},
			"svk": {
				"official": "Brazílska federatívna republika",
				"common": "Brazília"
			},
			"fin": {
				"official": "Brasilian liittotasavalta",
				"common": "Brasilia"
			},
			"zho": {
				"official": "巴西联邦共和国",
				"common": "巴西"
			}
		},
		"latlng": [
			-10,
			-55
		],
		"demonym": "Brazilian",
		"landlocked": false,
		"borders": [
			"ARG",
			"BOL",
			"COL",
			"GUF",
			"GUY",
			"PRY",
			"PER",
			"SUR",
			"URY",
			"VEN"
		],
		"area": 8515767
	},
	{
		"name": {
			"common": "Barbados",
			"official": "Barbados",
			"native": {
				"eng": {
					"official": "Barbados",
					"common": "Barbados"
				}
			}
		},
		"tld": [
			".bb"
		],
		"cca2": "BB",
		"ccn3": "052",
		"cca3": "BRB",
		"cioc": "BAR",
		"currency": [
			"BBD"
		],
		"callingCode": [
			"1246"
		],
		"capital": "Bridgetown",
		"altSpellings": [
			"BB"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"deu": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"fra": {
				"official": "Barbade",
				"common": "Barbade"
			},
			"hrv": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"ita": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"jpn": {
				"official": "バルバドス",
				"common": "バルバドス"
			},
			"nld": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"por": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"rus": {
				"official": "Барбадос",
				"common": "Барбадос"
			},
			"spa": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"svk": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"fin": {
				"official": "Barbados",
				"common": "Barbados"
			},
			"zho": {
				"official": "巴巴多斯",
				"common": "巴巴多斯"
			}
		},
		"latlng": [
			13.16666666,
			-59.53333333
		],
		"demonym": "Barbadian",
		"landlocked": false,
		"borders": [],
		"area": 430
	},
	{
		"name": {
			"common": "Brunei",
			"official": "Nation of Brunei, Abode of Peace",
			"native": {
				"msa": {
					"official": "Nation of Brunei, Abode Damai",
					"common": "Negara Brunei Darussalam"
				}
			}
		},
		"tld": [
			".bn"
		],
		"cca2": "BN",
		"ccn3": "096",
		"cca3": "BRN",
		"cioc": "BRU",
		"currency": [
			"BND"
		],
		"callingCode": [
			"673"
		],
		"capital": "Bandar Seri Begawan",
		"altSpellings": [
			"BN",
			"Brunei Darussalam",
			"Nation of Brunei",
			"the Abode of Peace"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"msa": "Malay"
		},
		"translations": {
			"cym": {
				"official": "Nation of Brunei, Abode of Peace",
				"common": "Brunei"
			},
			"deu": {
				"official": "Nation von Brunei, Wohnung des Friedens",
				"common": "Brunei"
			},
			"fra": {
				"official": "État de Brunei Darussalam",
				"common": "Brunei"
			},
			"hrv": {
				"official": "Nacija od Bruneja, Kuću Mira",
				"common": "Brunej"
			},
			"ita": {
				"official": "Nazione di Brunei, Dimora della Pace",
				"common": "Brunei"
			},
			"jpn": {
				"official": "ブルネイ、平和の精舎の国家",
				"common": "ブルネイ・ダルサラーム"
			},
			"nld": {
				"official": "Natie van Brunei, de verblijfplaats van de Vrede",
				"common": "Brunei"
			},
			"por": {
				"official": "Nação do Brunei, Morada da Paz",
				"common": "Brunei"
			},
			"rus": {
				"official": "Нация Бруней, обитель мира",
				"common": "Бруней"
			},
			"spa": {
				"official": "Nación de Brunei, Morada de la Paz",
				"common": "Brunei"
			},
			"svk": {
				"official": "Brunejský sultanât",
				"common": "Brunej"
			},
			"fin": {
				"official": "Brunei Darussalamin valtio",
				"common": "Brunei"
			},
			"zho": {
				"official": "文莱和平之国",
				"common": "文莱"
			}
		},
		"latlng": [
			4.5,
			114.66666666
		],
		"demonym": "Bruneian",
		"landlocked": false,
		"borders": [
			"MYS"
		],
		"area": 5765
	},
	{
		"name": {
			"common": "Bhutan",
			"official": "Kingdom of Bhutan",
			"native": {
				"dzo": {
					"official": "འབྲུག་རྒྱལ་ཁབ་",
					"common": "འབྲུག་ཡུལ་"
				}
			}
		},
		"tld": [
			".bt"
		],
		"cca2": "BT",
		"ccn3": "064",
		"cca3": "BTN",
		"cioc": "BHU",
		"currency": [
			"BTN",
			"INR"
		],
		"callingCode": [
			"975"
		],
		"capital": "Thimphu",
		"altSpellings": [
			"BT",
			"Kingdom of Bhutan"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"dzo": "Dzongkha"
		},
		"translations": {
			"cym": {
				"official": "Kingdom of Bhutan",
				"common": "Bhwtan"
			},
			"deu": {
				"official": "Königreich Bhutan",
				"common": "Bhutan"
			},
			"fra": {
				"official": "Royaume du Bhoutan",
				"common": "Bhoutan"
			},
			"hrv": {
				"official": "Kraljevina Butan",
				"common": "Butan"
			},
			"ita": {
				"official": "Regno del Bhutan",
				"common": "Bhutan"
			},
			"jpn": {
				"official": "ブータン王国",
				"common": "ブータン"
			},
			"nld": {
				"official": "Koninkrijk Bhutan",
				"common": "Bhutan"
			},
			"por": {
				"official": "Reino do Butão",
				"common": "Butão"
			},
			"rus": {
				"official": "Королевство Бутан",
				"common": "Бутан"
			},
			"spa": {
				"official": "Reino de Bután",
				"common": "Bután"
			},
			"svk": {
				"official": "Bhutánske krâľovstvo",
				"common": "Bhután"
			},
			"fin": {
				"official": "Bhutanin kuningaskunta",
				"common": "Bhutan"
			},
			"zho": {
				"official": "不丹王国",
				"common": "不丹"
			}
		},
		"latlng": [
			27.5,
			90.5
		],
		"demonym": "Bhutanese",
		"landlocked": true,
		"borders": [
			"CHN",
			"IND"
		],
		"area": 38394
	},
	{
		"name": {
			"common": "Bouvet Island",
			"official": "Bouvet Island",
			"native": {
				"nor": {
					"official": "Bouvetøya",
					"common": "Bouvetøya"
				}
			}
		},
		"tld": [
			".bv"
		],
		"cca2": "BV",
		"ccn3": "074",
		"cca3": "BVT",
		"cioc": "",
		"currency": [
			"NOK"
		],
		"callingCode": [],
		"capital": "",
		"altSpellings": [
			"BV",
			"Bouvetøya",
			"Bouvet-øya"
		],
		"region": "",
		"subregion": "",
		"languages": {
			"nor": "Norwegian"
		},
		"translations": {
			"deu": {
				"official": "Bouvet-Insel",
				"common": "Bouvetinsel"
			},
			"fra": {
				"official": "Île Bouvet",
				"common": "Île Bouvet"
			},
			"hrv": {
				"official": "Bouvet Island",
				"common": "Otok Bouvet"
			},
			"ita": {
				"official": "Isola Bouvet",
				"common": "Isola Bouvet"
			},
			"jpn": {
				"official": "ブーヴェ島",
				"common": "ブーベ島"
			},
			"nld": {
				"official": "Bouvet Island",
				"common": "Bouveteiland"
			},
			"por": {
				"official": "Ilha Bouvet",
				"common": "Ilha Bouvet"
			},
			"rus": {
				"official": "Остров Буве",
				"common": "Остров Буве"
			},
			"spa": {
				"official": "Isla Bouvet",
				"common": "Isla Bouvet"
			},
			"svk": {
				"official": "Bouvetov ostrov",
				"common": "Bouvetov ostrov"
			},
			"fin": {
				"official": "Bouvet'nsaari",
				"common": "Bouvet'nsaari"
			},
			"zho": {
				"official": "布维岛",
				"common": "布维岛"
			}
		},
		"latlng": [
			-54.43333333,
			3.4
		],
		"demonym": "",
		"landlocked": false,
		"borders": [],
		"area": 49
	},
	{
		"name": {
			"common": "Botswana",
			"official": "Republic of Botswana",
			"native": {
				"eng": {
					"official": "Republic of Botswana",
					"common": "Botswana"
				},
				"tsn": {
					"official": "Lefatshe la Botswana",
					"common": "Botswana"
				}
			}
		},
		"tld": [
			".bw"
		],
		"cca2": "BW",
		"ccn3": "072",
		"cca3": "BWA",
		"cioc": "BOT",
		"currency": [
			"BWP"
		],
		"callingCode": [
			"267"
		],
		"capital": "Gaborone",
		"altSpellings": [
			"BW",
			"Republic of Botswana",
			"Lefatshe la Botswana"
		],
		"region": "Africa",
		"subregion": "Southern Africa",
		"languages": {
			"eng": "English",
			"tsn": "Tswana"
		},
		"translations": {
			"deu": {
				"official": "Republik Botsuana",
				"common": "Botswana"
			},
			"fra": {
				"official": "République du Botswana",
				"common": "Botswana"
			},
			"hrv": {
				"official": "Republika Bocvana",
				"common": "Bocvana"
			},
			"ita": {
				"official": "Repubblica del Botswana",
				"common": "Botswana"
			},
			"jpn": {
				"official": "ボツワナ共和国",
				"common": "ボツワナ"
			},
			"nld": {
				"official": "Republiek Botswana",
				"common": "Botswana"
			},
			"por": {
				"official": "República do Botswana",
				"common": "Botswana"
			},
			"rus": {
				"official": "Республика Ботсвана",
				"common": "Ботсвана"
			},
			"spa": {
				"official": "República de Botswana",
				"common": "Botswana"
			},
			"svk": {
				"official": "Botswanská republika",
				"common": "Botswana"
			},
			"fin": {
				"official": "Botswanan tasavalta",
				"common": "Botswana"
			},
			"zho": {
				"official": "博茨瓦纳共和国",
				"common": "博茨瓦纳"
			}
		},
		"latlng": [
			-22,
			24
		],
		"demonym": "Motswana",
		"landlocked": true,
		"borders": [
			"NAM",
			"ZAF",
			"ZMB",
			"ZWE"
		],
		"area": 582000
	},
	{
		"name": {
			"common": "Central African Republic",
			"official": "Central African Republic",
			"native": {
				"fra": {
					"official": "République centrafricaine",
					"common": "République centrafricaine"
				},
				"sag": {
					"official": "Ködörösêse tî Bêafrîka",
					"common": "Bêafrîka"
				}
			}
		},
		"tld": [
			".cf"
		],
		"cca2": "CF",
		"ccn3": "140",
		"cca3": "CAF",
		"cioc": "CAF",
		"currency": [
			"XAF"
		],
		"callingCode": [
			"236"
		],
		"capital": "Bangui",
		"altSpellings": [
			"CF",
			"Central African Republic",
			"République centrafricaine"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"fra": "French",
			"sag": "Sango"
		},
		"translations": {
			"cym": {
				"official": "Central African Republic",
				"common": "Gweriniaeth Canolbarth Affrica"
			},
			"deu": {
				"official": "Zentralafrikanische Republik",
				"common": "Zentralafrikanische Republik"
			},
			"fra": {
				"official": "République centrafricaine",
				"common": "République centrafricaine"
			},
			"hrv": {
				"official": "Centralna Afrička Republika",
				"common": "Srednjoafrička Republika"
			},
			"ita": {
				"official": "Repubblica Centrafricana",
				"common": "Repubblica Centrafricana"
			},
			"jpn": {
				"official": "中央アフリカ共和国",
				"common": "中央アフリカ共和国"
			},
			"nld": {
				"official": "Centraal-Afrikaanse Republiek",
				"common": "Centraal-Afrikaanse Republiek"
			},
			"por": {
				"official": "República Centro-Africano",
				"common": "República Centro-Africana"
			},
			"rus": {
				"official": "Центрально-Африканская Республика",
				"common": "Центральноафриканская Республика"
			},
			"spa": {
				"official": "República Centroafricana",
				"common": "República Centroafricana"
			},
			"svk": {
				"official": "Stredoafrická republika",
				"common": "Stredoafrická republika"
			},
			"fin": {
				"official": "Keski-Afrikan tasavalta",
				"common": "Keski-Afrikan tasavalta"
			},
			"zho": {
				"official": "中非共和国",
				"common": "中非共和国"
			}
		},
		"latlng": [
			7,
			21
		],
		"demonym": "Central African",
		"landlocked": true,
		"borders": [
			"CMR",
			"TCD",
			"COD",
			"COG",
			"SSD",
			"SDN"
		],
		"area": 622984
	},
	{
		"name": {
			"common": "Canada",
			"official": "Canada",
			"native": {
				"eng": {
					"official": "Canada",
					"common": "Canada"
				},
				"fra": {
					"official": "Canada",
					"common": "Canada"
				}
			}
		},
		"tld": [
			".ca"
		],
		"cca2": "CA",
		"ccn3": "124",
		"cca3": "CAN",
		"cioc": "CAN",
		"currency": [
			"CAD"
		],
		"callingCode": [
			"1"
		],
		"capital": "Ottawa",
		"altSpellings": [
			"CA"
		],
		"region": "Americas",
		"subregion": "Northern America",
		"languages": {
			"eng": "English",
			"fra": "French"
		},
		"translations": {
			"cym": {
				"official": "Canada",
				"common": "Canada"
			},
			"deu": {
				"official": "Kanada",
				"common": "Kanada"
			},
			"fra": {
				"official": "Canada",
				"common": "Canada"
			},
			"hrv": {
				"official": "Kanada",
				"common": "Kanada"
			},
			"ita": {
				"official": "Canada",
				"common": "Canada"
			},
			"jpn": {
				"official": "カナダ",
				"common": "カナダ"
			},
			"nld": {
				"official": "Canada",
				"common": "Canada"
			},
			"por": {
				"official": "Canadá",
				"common": "Canadá"
			},
			"rus": {
				"official": "Канада",
				"common": "Канада"
			},
			"spa": {
				"official": "Canadá",
				"common": "Canadá"
			},
			"svk": {
				"official": "Kanada",
				"common": "Kanada"
			},
			"fin": {
				"official": "Kanada",
				"common": "Kanada"
			},
			"zho": {
				"official": "加拿大",
				"common": "加拿大"
			}
		},
		"latlng": [
			60,
			-95
		],
		"demonym": "Canadian",
		"landlocked": false,
		"borders": [
			"USA"
		],
		"area": 9984670
	},
	{
		"name": {
			"common": "Cocos (Keeling) Islands",
			"official": "Territory of the Cocos (Keeling) Islands",
			"native": {
				"eng": {
					"official": "Territory of the Cocos (Keeling) Islands",
					"common": "Cocos (Keeling) Islands"
				}
			}
		},
		"tld": [
			".cc"
		],
		"cca2": "CC",
		"ccn3": "166",
		"cca3": "CCK",
		"cioc": "",
		"currency": [
			"AUD"
		],
		"callingCode": [
			"61"
		],
		"capital": "West Island",
		"altSpellings": [
			"CC",
			"Territory of the Cocos (Keeling) Islands",
			"Keeling Islands"
		],
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Territory of the Cocos (Keeling) Islands",
				"common": "Ynysoedd Cocos"
			},
			"deu": {
				"official": "Gebiet der Cocos (Keeling) Islands",
				"common": "Kokosinseln"
			},
			"fra": {
				"official": "Territoire des îles Cocos (Keeling)",
				"common": "Îles Cocos"
			},
			"hrv": {
				"official": "Teritoriju Kokosovi (Keeling) Islands",
				"common": "Kokosovi Otoci"
			},
			"ita": {
				"official": "Territorio della (Keeling) Isole Cocos",
				"common": "Isole Cocos e Keeling"
			},
			"jpn": {
				"official": "ココス諸島の領土",
				"common": "ココス（キーリング）諸島"
			},
			"nld": {
				"official": "Grondgebied van de Eilanden Cocos (Keeling )",
				"common": "Cocoseilanden"
			},
			"por": {
				"official": "Território dos Cocos (Keeling)",
				"common": "Ilhas Cocos (Keeling)"
			},
			"rus": {
				"official": "Территория Кокосовые (Килинг) острова",
				"common": "Кокосовые острова"
			},
			"spa": {
				"official": "Territorio de los (Keeling) Islas Cocos",
				"common": "Islas Cocos o Islas Keeling"
			},
			"svk": {
				"official": "Kokosové ostrovy",
				"common": "Kokosové ostrovy"
			},
			"fin": {
				"official": "Kookossaaret",
				"common": "Kookossaaret"
			},
			"zho": {
				"official": "科科斯",
				"common": "科科斯"
			}
		},
		"latlng": [
			-12.5,
			96.83333333
		],
		"demonym": "Cocos Islander",
		"landlocked": false,
		"borders": [],
		"area": 14
	},
	{
		"name": {
			"common": "Switzerland",
			"official": "Swiss Confederation",
			"native": {
				"fra": {
					"official": "Confédération suisse",
					"common": "Suisse"
				},
				"gsw": {
					"official": "Schweizerische Eidgenossenschaft",
					"common": "Schweiz"
				},
				"ita": {
					"official": "Confederazione Svizzera",
					"common": "Svizzera"
				},
				"roh": {
					"official": "Confederaziun svizra",
					"common": "Svizra"
				}
			}
		},
		"tld": [
			".ch"
		],
		"cca2": "CH",
		"ccn3": "756",
		"cca3": "CHE",
		"cioc": "SUI",
		"currency": [
			"CHE",
			"CHF",
			"CHW"
		],
		"callingCode": [
			"41"
		],
		"capital": "Bern",
		"altSpellings": [
			"CH",
			"Swiss Confederation",
			"Schweiz",
			"Suisse",
			"Svizzera",
			"Svizra"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"fra": "French",
			"gsw": "Swiss German",
			"ita": "Italian",
			"roh": "Romansh"
		},
		"translations": {
			"deu": {
				"official": "Schweizerische Eidgenossenschaft",
				"common": "Schweiz"
			},
			"fra": {
				"official": "Confédération suisse",
				"common": "Suisse"
			},
			"hrv": {
				"official": "švicarska Konfederacija",
				"common": "Švicarska"
			},
			"ita": {
				"official": "Confederazione svizzera",
				"common": "Svizzera"
			},
			"jpn": {
				"official": "スイス連邦",
				"common": "スイス"
			},
			"nld": {
				"official": "Zwitserse Confederatie",
				"common": "Zwitserland"
			},
			"por": {
				"official": "Confederação Suíça",
				"common": "Suíça"
			},
			"rus": {
				"official": "Швейцарская Конфедерация",
				"common": "Швейцария"
			},
			"spa": {
				"official": "Confederación Suiza",
				"common": "Suiza"
			},
			"svk": {
				"official": "Švajčiarska konfederácia",
				"common": "Švajčiarsko"
			},
			"fin": {
				"official": "Sveitsin valaliitto",
				"common": "Sveitsi"
			},
			"zho": {
				"official": "瑞士联邦",
				"common": "瑞士"
			}
		},
		"latlng": [
			47,
			8
		],
		"demonym": "Swiss",
		"landlocked": true,
		"borders": [
			"AUT",
			"FRA",
			"ITA",
			"LIE",
			"DEU"
		],
		"area": 41284
	},
	{
		"name": {
			"common": "Chile",
			"official": "Republic of Chile",
			"native": {
				"spa": {
					"official": "República de Chile",
					"common": "Chile"
				}
			}
		},
		"tld": [
			".cl"
		],
		"cca2": "CL",
		"ccn3": "152",
		"cca3": "CHL",
		"cioc": "CHI",
		"currency": [
			"CLF",
			"CLP"
		],
		"callingCode": [
			"56"
		],
		"capital": "Santiago",
		"altSpellings": [
			"CL",
			"Republic of Chile",
			"República de Chile"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Republic of Chile",
				"common": "Chile"
			},
			"deu": {
				"official": "Republik Chile",
				"common": "Chile"
			},
			"fra": {
				"official": "République du Chili",
				"common": "Chili"
			},
			"hrv": {
				"official": "Republika Čile",
				"common": "Čile"
			},
			"ita": {
				"official": "Repubblica del Cile",
				"common": "Cile"
			},
			"jpn": {
				"official": "チリ共和国",
				"common": "チリ"
			},
			"nld": {
				"official": "Republiek Chili",
				"common": "Chili"
			},
			"por": {
				"official": "República do Chile",
				"common": "Chile"
			},
			"rus": {
				"official": "Республика Чили",
				"common": "Чили"
			},
			"spa": {
				"official": "República de Chile",
				"common": "Chile"
			},
			"svk": {
				"official": "Čílska republika",
				"common": "Čile"
			},
			"fin": {
				"official": "Chilen tasavalta",
				"common": "Chile"
			},
			"zho": {
				"official": "智利共和国",
				"common": "智利"
			}
		},
		"latlng": [
			-30,
			-71
		],
		"demonym": "Chilean",
		"landlocked": false,
		"borders": [
			"ARG",
			"BOL",
			"PER"
		],
		"area": 756102
	},
	{
		"name": {
			"common": "China",
			"official": "People's Republic of China",
			"native": {
				"zho": {
					"official": "中华人民共和国",
					"common": "中国"
				}
			}
		},
		"tld": [
			".cn",
			".中国",
			".中國",
			".公司",
			".网络"
		],
		"cca2": "CN",
		"ccn3": "156",
		"cca3": "CHN",
		"cioc": "CHN",
		"currency": [
			"CNY"
		],
		"callingCode": [
			"86"
		],
		"capital": "Beijing",
		"altSpellings": [
			"CN",
			"Zhōngguó",
			"Zhongguo",
			"Zhonghua",
			"People's Republic of China",
			"中华人民共和国",
			"Zhōnghuá Rénmín Gònghéguó"
		],
		"region": "Asia",
		"subregion": "Eastern Asia",
		"languages": {
			"zho": "Chinese"
		},
		"translations": {
			"cym": {
				"official": "People's Republic of China",
				"common": "Tsieina"
			},
			"deu": {
				"official": "Volksrepublik China",
				"common": "China"
			},
			"fra": {
				"official": "République populaire de Chine",
				"common": "Chine"
			},
			"hrv": {
				"official": "Narodna Republika Kina",
				"common": "Kina"
			},
			"ita": {
				"official": "Repubblica popolare cinese",
				"common": "Cina"
			},
			"jpn": {
				"official": "中華人民共和国",
				"common": "中国"
			},
			"nld": {
				"official": "Volksrepubliek China",
				"common": "China"
			},
			"por": {
				"official": "República Popular da China",
				"common": "China"
			},
			"rus": {
				"official": "Народная Республика Китай",
				"common": "Китай"
			},
			"spa": {
				"official": "República Popular de China",
				"common": "China"
			},
			"svk": {
				"official": "Čínska ľudová republika",
				"common": "Čína"
			},
			"fin": {
				"official": "Kiinan kansantasavalta",
				"common": "Kiina"
			}
		},
		"latlng": [
			35,
			105
		],
		"demonym": "Chinese",
		"landlocked": false,
		"borders": [
			"AFG",
			"BTN",
			"MMR",
			"HKG",
			"IND",
			"KAZ",
			"PRK",
			"KGZ",
			"LAO",
			"MAC",
			"MNG",
			"PAK",
			"RUS",
			"TJK",
			"VNM"
		],
		"area": 9706961
	},
	{
		"name": {
			"common": "Ivory Coast",
			"official": "Republic of Côte d'Ivoire",
			"native": {
				"fra": {
					"official": "République de Côte d'Ivoire",
					"common": "Côte d'Ivoire"
				}
			}
		},
		"tld": [
			".ci"
		],
		"cca2": "CI",
		"ccn3": "384",
		"cca3": "CIV",
		"cioc": "CIV",
		"currency": [
			"XOF"
		],
		"callingCode": [
			"225"
		],
		"capital": "Yamoussoukro",
		"altSpellings": [
			"CI",
			"Côte d'Ivoire",
			"Ivory Coast",
			"Republic of Côte d'Ivoire",
			"République de Côte d'Ivoire"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Republik Côte d'Ivoire",
				"common": "Elfenbeinküste"
			},
			"fra": {
				"official": "République de Côte d' Ivoire",
				"common": "Côte d'Ivoire"
			},
			"hrv": {
				"official": "Republika Côte d'Ivoire",
				"common": "Obala Bjelokosti"
			},
			"ita": {
				"official": "Repubblica della Costa d'Avorio",
				"common": "Costa d'Avorio"
			},
			"jpn": {
				"official": "コートジボワール共和国",
				"common": "コートジボワール"
			},
			"nld": {
				"official": "Republiek Ivoorkust",
				"common": "Ivoorkust"
			},
			"por": {
				"official": "República da Côte d'Ivoire",
				"common": "Costa do Marfim"
			},
			"rus": {
				"official": "Республика Кот-д'Ивуаре",
				"common": "Кот-д’Ивуар"
			},
			"spa": {
				"official": "República de Côte d'Ivoire",
				"common": "Costa de Marfil"
			},
			"svk": {
				"official": "Republika Pobržie Slonoviny",
				"common": "Pobržie Slonoviny"
			},
			"fin": {
				"official": "Norsunluurannikon tasavalta",
				"common": "Norsunluurannikko"
			},
			"zho": {
				"official": "科特迪瓦共和国",
				"common": "科特迪瓦"
			}
		},
		"latlng": [
			8,
			-5
		],
		"demonym": "Ivorian",
		"landlocked": false,
		"borders": [
			"BFA",
			"GHA",
			"GIN",
			"LBR",
			"MLI"
		],
		"area": 322463
	},
	{
		"name": {
			"common": "Cameroon",
			"official": "Republic of Cameroon",
			"native": {
				"eng": {
					"official": "Republic of Cameroon",
					"common": "Cameroon"
				},
				"fra": {
					"official": "République du Cameroun",
					"common": "Cameroun"
				}
			}
		},
		"tld": [
			".cm"
		],
		"cca2": "CM",
		"ccn3": "120",
		"cca3": "CMR",
		"cioc": "CMR",
		"currency": [
			"XAF"
		],
		"callingCode": [
			"237"
		],
		"capital": "Yaoundé",
		"altSpellings": [
			"CM",
			"Republic of Cameroon",
			"République du Cameroun"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"eng": "English",
			"fra": "French"
		},
		"translations": {
			"cym": {
				"official": "Republic of Cameroon",
				"common": "Camerŵn"
			},
			"deu": {
				"official": "Republik Kamerun",
				"common": "Kamerun"
			},
			"fra": {
				"official": "République du Cameroun",
				"common": "Cameroun"
			},
			"hrv": {
				"official": "Republika Kamerun",
				"common": "Kamerun"
			},
			"ita": {
				"official": "Repubblica del Camerun",
				"common": "Camerun"
			},
			"jpn": {
				"official": "カメルーン共和国",
				"common": "カメルーン"
			},
			"nld": {
				"official": "Republiek Kameroen",
				"common": "Kameroen"
			},
			"por": {
				"official": "República dos Camarões",
				"common": "Camarões"
			},
			"rus": {
				"official": "Республика Камерун",
				"common": "Камерун"
			},
			"spa": {
				"official": "República de Camerún",
				"common": "Camerún"
			},
			"svk": {
				"official": "Kamerunská republika",
				"common": "Kamerun"
			},
			"fin": {
				"official": "Kamerunin tasavalta",
				"common": "Kamerun"
			},
			"zho": {
				"official": "喀麦隆共和国",
				"common": "喀麦隆"
			}
		},
		"latlng": [
			6,
			12
		],
		"demonym": "Cameroonian",
		"landlocked": false,
		"borders": [
			"CAF",
			"TCD",
			"COG",
			"GNQ",
			"GAB",
			"NGA"
		],
		"area": 475442
	},
	{
		"name": {
			"common": "DR Congo",
			"official": "Democratic Republic of the Congo",
			"native": {
				"fra": {
					"official": "République démocratique du Congo",
					"common": "RD Congo"
				},
				"kon": {
					"official": "Repubilika ya Kongo Demokratiki",
					"common": "Repubilika ya Kongo Demokratiki"
				},
				"lin": {
					"official": "Republiki ya Kongó Demokratiki",
					"common": "Republiki ya Kongó Demokratiki"
				},
				"lua": {
					"official": "Ditunga dia Kongu wa Mungalaata",
					"common": "Ditunga dia Kongu wa Mungalaata"
				},
				"swa": {
					"official": "Jamhuri ya Kidemokrasia ya Kongo",
					"common": "Jamhuri ya Kidemokrasia ya Kongo"
				}
			}
		},
		"tld": [
			".cd"
		],
		"cca2": "CD",
		"ccn3": "180",
		"cca3": "COD",
		"cioc": "COD",
		"currency": [
			"CDF"
		],
		"callingCode": [
			"243"
		],
		"capital": "Kinshasa",
		"altSpellings": [
			"CD",
			"DR Congo",
			"Congo-Kinshasa",
			"Congo, the Democratic Republic of the",
			"DRC"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"fra": "French",
			"kon": "Kikongo",
			"lin": "Lingala",
			"lua": "Tshiluba",
			"swa": "Swahili"
		},
		"translations": {
			"cym": {
				"official": "Democratic Republic of the Congo",
				"common": "Gweriniaeth Ddemocrataidd Congo"
			},
			"deu": {
				"official": "Demokratische Republik Kongo",
				"common": "Kongo (Dem. Rep.)"
			},
			"fra": {
				"official": "République démocratique du Congo",
				"common": "Congo (Rép. dém.)"
			},
			"hrv": {
				"official": "Demokratska Republika Kongo",
				"common": "Kongo, Demokratska Republika"
			},
			"ita": {
				"official": "Repubblica Democratica del Congo",
				"common": "Congo (Rep. Dem.)"
			},
			"jpn": {
				"official": "コンゴ民主共和国",
				"common": "コンゴ民主共和国"
			},
			"nld": {
				"official": "Democratische Republiek Congo",
				"common": "Congo (DRC)"
			},
			"por": {
				"official": "República Democrática do Congo",
				"common": "República Democrática do Congo"
			},
			"rus": {
				"official": "Демократическая Республика Конго",
				"common": "Демократическая Республика Конго"
			},
			"spa": {
				"official": "República Democrática del Congo",
				"common": "Congo (Rep. Dem.)"
			},
			"svk": {
				"official": "Konžská demokratická republika",
				"common": "Kongo"
			},
			"fin": {
				"official": "Kongon demokraattinen tasavalta",
				"common": "Kongon demokraattinen tasavalta"
			},
			"zho": {
				"official": "刚果民主共和国",
				"common": "民主刚果"
			}
		},
		"latlng": [
			0,
			25
		],
		"demonym": "Congolese",
		"landlocked": false,
		"borders": [
			"AGO",
			"BDI",
			"CAF",
			"COG",
			"RWA",
			"SSD",
			"TZA",
			"UGA",
			"ZMB"
		],
		"area": 2344858
	},
	{
		"name": {
			"common": "Republic of the Congo",
			"official": "Republic of the Congo",
			"native": {
				"fra": {
					"official": "République du Congo",
					"common": "République du Congo"
				},
				"kon": {
					"official": "Repubilika ya Kongo",
					"common": "Repubilika ya Kongo"
				},
				"lin": {
					"official": "Republíki ya Kongó",
					"common": "Republíki ya Kongó"
				}
			}
		},
		"tld": [
			".cg"
		],
		"cca2": "CG",
		"ccn3": "178",
		"cca3": "COG",
		"cioc": "CGO",
		"currency": [
			"XAF"
		],
		"callingCode": [
			"242"
		],
		"capital": "Brazzaville",
		"altSpellings": [
			"CG",
			"Congo",
			"Congo-Brazzaville"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"fra": "French",
			"kon": "Kikongo",
			"lin": "Lingala"
		},
		"translations": {
			"cym": {
				"official": "Republic of the Congo",
				"common": "Gweriniaeth y Congo"
			},
			"deu": {
				"official": "Republik Kongo",
				"common": "Kongo"
			},
			"fra": {
				"official": "République du Congo",
				"common": "Congo"
			},
			"hrv": {
				"official": "Republika Kongo",
				"common": "Kongo"
			},
			"ita": {
				"official": "Repubblica del Congo",
				"common": "Congo"
			},
			"jpn": {
				"official": "コンゴ共和国",
				"common": "コンゴ共和国"
			},
			"nld": {
				"official": "Republiek Congo",
				"common": "Congo"
			},
			"por": {
				"official": "República do Congo",
				"common": "Congo"
			},
			"rus": {
				"official": "Республика Конго",
				"common": "Республика Конго"
			},
			"spa": {
				"official": "República del Congo",
				"common": "Congo"
			},
			"svk": {
				"official": "Konžská republika",
				"common": "Kongo"
			},
			"fin": {
				"official": "Kongon tasavalta",
				"common": "Kongo-Brazzaville"
			},
			"zho": {
				"official": "刚果共和国",
				"common": "刚果"
			}
		},
		"latlng": [
			-1,
			15
		],
		"demonym": "Congolese",
		"landlocked": false,
		"borders": [
			"AGO",
			"CMR",
			"CAF",
			"COD",
			"GAB"
		],
		"area": 342000
	},
	{
		"name": {
			"common": "Cook Islands",
			"official": "Cook Islands",
			"native": {
				"eng": {
					"official": "Cook Islands",
					"common": "Cook Islands"
				},
				"rar": {
					"official": "Kūki 'Āirani",
					"common": "Kūki 'Āirani"
				}
			}
		},
		"tld": [
			".ck"
		],
		"cca2": "CK",
		"ccn3": "184",
		"cca3": "COK",
		"cioc": "COK",
		"currency": [
			"NZD"
		],
		"callingCode": [
			"682"
		],
		"capital": "Avarua",
		"altSpellings": [
			"CK",
			"Kūki 'Āirani"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"eng": "English",
			"rar": "Cook Islands Māori"
		},
		"translations": {
			"cym": {
				"official": "Cook Islands",
				"common": "Ynysoedd Cook"
			},
			"deu": {
				"official": "Cook-Inseln",
				"common": "Cookinseln"
			},
			"fra": {
				"official": "Îles Cook",
				"common": "Îles Cook"
			},
			"hrv": {
				"official": "Cook Islands",
				"common": "Cookovo Otočje"
			},
			"ita": {
				"official": "Isole Cook",
				"common": "Isole Cook"
			},
			"jpn": {
				"official": "クック諸島",
				"common": "クック諸島"
			},
			"nld": {
				"official": "Cook eilanden",
				"common": "Cookeilanden"
			},
			"por": {
				"official": "Ilhas Cook",
				"common": "Ilhas Cook"
			},
			"rus": {
				"official": "острова Кука",
				"common": "Острова Кука"
			},
			"spa": {
				"official": "Islas Cook",
				"common": "Islas Cook"
			},
			"svk": {
				"official": "Cookove ostrovy",
				"common": "Cookove ostrovy"
			},
			"fin": {
				"official": "Cookinsaaret",
				"common": "Cookinsaaret"
			},
			"zho": {
				"official": "库克群岛",
				"common": "库克群岛"
			}
		},
		"latlng": [
			-21.23333333,
			-159.76666666
		],
		"demonym": "Cook Islander",
		"landlocked": false,
		"borders": [],
		"area": 236
	},
	{
		"name": {
			"common": "Colombia",
			"official": "Republic of Colombia",
			"native": {
				"spa": {
					"official": "República de Colombia",
					"common": "Colombia"
				}
			}
		},
		"tld": [
			".co"
		],
		"cca2": "CO",
		"ccn3": "170",
		"cca3": "COL",
		"cioc": "COL",
		"currency": [
			"COP"
		],
		"callingCode": [
			"57"
		],
		"capital": "Bogotá",
		"altSpellings": [
			"CO",
			"Republic of Colombia",
			"República de Colombia"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Republic of Colombia",
				"common": "Colombia"
			},
			"deu": {
				"official": "Republik Kolumbien",
				"common": "Kolumbien"
			},
			"fra": {
				"official": "République de Colombie",
				"common": "Colombie"
			},
			"hrv": {
				"official": "Republika Kolumbija",
				"common": "Kolumbija"
			},
			"ita": {
				"official": "Repubblica di Colombia",
				"common": "Colombia"
			},
			"jpn": {
				"official": "コロンビア共和国",
				"common": "コロンビア"
			},
			"nld": {
				"official": "Republiek Colombia",
				"common": "Colombia"
			},
			"por": {
				"official": "República da Colômbia",
				"common": "Colômbia"
			},
			"rus": {
				"official": "Республика Колумбия",
				"common": "Колумбия"
			},
			"spa": {
				"official": "República de Colombia",
				"common": "Colombia"
			},
			"svk": {
				"official": "Kolumbijská republika",
				"common": "Kolumbia"
			},
			"fin": {
				"official": "Kolumbian tasavalta",
				"common": "Kolumbia"
			},
			"zho": {
				"official": "哥伦比亚共和国",
				"common": "哥伦比亚"
			}
		},
		"latlng": [
			4,
			-72
		],
		"demonym": "Colombian",
		"landlocked": false,
		"borders": [
			"BRA",
			"ECU",
			"PAN",
			"PER",
			"VEN"
		],
		"area": 1141748
	},
	{
		"name": {
			"common": "Comoros",
			"official": "Union of the Comoros",
			"native": {
				"ara": {
					"official": "الاتحاد القمري",
					"common": "القمر‎"
				},
				"fra": {
					"official": "Union des Comores",
					"common": "Comores"
				},
				"zdj": {
					"official": "Udzima wa Komori",
					"common": "Komori"
				}
			}
		},
		"tld": [
			".km"
		],
		"cca2": "KM",
		"ccn3": "174",
		"cca3": "COM",
		"cioc": "COM",
		"currency": [
			"KMF"
		],
		"callingCode": [
			"269"
		],
		"capital": "Moroni",
		"altSpellings": [
			"KM",
			"Union of the Comoros",
			"Union des Comores",
			"Udzima wa Komori",
			"al-Ittiḥād al-Qumurī"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"ara": "Arabic",
			"fra": "French",
			"zdj": "Comorian"
		},
		"translations": {
			"cym": {
				"official": "Union of the Comoros",
				"common": "Comoros"
			},
			"deu": {
				"official": "Union der Komoren",
				"common": "Union der Komoren"
			},
			"fra": {
				"official": "Union des Comores",
				"common": "Comores"
			},
			"hrv": {
				"official": "Savez Komori",
				"common": "Komori"
			},
			"ita": {
				"official": "Unione delle Comore",
				"common": "Comore"
			},
			"jpn": {
				"official": "コモロ連合",
				"common": "コモロ"
			},
			"nld": {
				"official": "Unie van de Comoren",
				"common": "Comoren"
			},
			"por": {
				"official": "União das Comores",
				"common": "Comores"
			},
			"rus": {
				"official": "Союз Коморских Островов",
				"common": "Коморы"
			},
			"spa": {
				"official": "Unión de las Comoras",
				"common": "Comoras"
			},
			"svk": {
				"official": "Komorská únia",
				"common": "Komory"
			},
			"fin": {
				"official": "Komorien liitto",
				"common": "Komorit"
			},
			"zho": {
				"official": "科摩罗联盟",
				"common": "科摩罗"
			}
		},
		"latlng": [
			-12.16666666,
			44.25
		],
		"demonym": "Comoran",
		"landlocked": false,
		"borders": [],
		"area": 1862
	},
	{
		"name": {
			"common": "Cape Verde",
			"official": "Republic of Cabo Verde",
			"native": {
				"por": {
					"official": "República de Cabo Verde",
					"common": "Cabo Verde"
				}
			}
		},
		"tld": [
			".cv"
		],
		"cca2": "CV",
		"ccn3": "132",
		"cca3": "CPV",
		"cioc": "CPV",
		"currency": [
			"CVE"
		],
		"callingCode": [
			"238"
		],
		"capital": "Praia",
		"altSpellings": [
			"CV",
			"Republic of Cabo Verde",
			"República de Cabo Verde"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"por": "Portuguese"
		},
		"translations": {
			"cym": {
				"official": "Republic of Cabo Verde",
				"common": "Cape Verde"
			},
			"deu": {
				"official": "Republik Cabo Verde",
				"common": "Kap Verde"
			},
			"fra": {
				"official": "République du Cap-Vert",
				"common": "Îles du Cap-Vert"
			},
			"hrv": {
				"official": "Republika Cabo Verde",
				"common": "Zelenortska Republika"
			},
			"ita": {
				"official": "Repubblica di Capo Verde",
				"common": "Capo Verde"
			},
			"jpn": {
				"official": "カーボベルデ共和国",
				"common": "カーボベルデ"
			},
			"nld": {
				"official": "Republiek van Cabo Verde",
				"common": "Kaapverdië"
			},
			"por": {
				"official": "República de Cabo Verde",
				"common": "Cabo Verde"
			},
			"rus": {
				"official": "Республика Кабо -Верде",
				"common": "Кабо-Верде"
			},
			"spa": {
				"official": "República de Cabo Verde",
				"common": "Cabo Verde"
			},
			"svk": {
				"official": "Kapverdská republika",
				"common": "Kapverdy"
			},
			"fin": {
				"official": "Kap Verden tasavalta",
				"common": "Kap Verde"
			},
			"zho": {
				"official": "佛得角共和国",
				"common": "佛得角"
			}
		},
		"latlng": [
			16,
			-24
		],
		"demonym": "Cape Verdian",
		"landlocked": false,
		"borders": [],
		"area": 4033
	},
	{
		"name": {
			"common": "Costa Rica",
			"official": "Republic of Costa Rica",
			"native": {
				"spa": {
					"official": "República de Costa Rica",
					"common": "Costa Rica"
				}
			}
		},
		"tld": [
			".cr"
		],
		"cca2": "CR",
		"ccn3": "188",
		"cca3": "CRI",
		"cioc": "CRC",
		"currency": [
			"CRC"
		],
		"callingCode": [
			"506"
		],
		"capital": "San José",
		"altSpellings": [
			"CR",
			"Republic of Costa Rica",
			"República de Costa Rica"
		],
		"region": "Americas",
		"subregion": "Central America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Republic of Costa Rica",
				"common": "Costa Rica"
			},
			"deu": {
				"official": "Republik Costa Rica",
				"common": "Costa Rica"
			},
			"fra": {
				"official": "République du Costa Rica",
				"common": "Costa Rica"
			},
			"hrv": {
				"official": "Republika Kostarika",
				"common": "Kostarika"
			},
			"ita": {
				"official": "Repubblica di Costa Rica",
				"common": "Costa Rica"
			},
			"jpn": {
				"official": "コスタリカ共和国",
				"common": "コスタリカ"
			},
			"nld": {
				"official": "Republiek Costa Rica",
				"common": "Costa Rica"
			},
			"por": {
				"official": "República da Costa Rica",
				"common": "Costa Rica"
			},
			"rus": {
				"official": "Республика Коста-Рика",
				"common": "Коста-Рика"
			},
			"spa": {
				"official": "República de Costa Rica",
				"common": "Costa Rica"
			},
			"svk": {
				"official": "Kostarická republika",
				"common": "Kostarika"
			},
			"fin": {
				"official": "Costa Rican tasavalta",
				"common": "Costa Rica"
			},
			"zho": {
				"official": "哥斯达黎加共和国",
				"common": "哥斯达黎加"
			}
		},
		"latlng": [
			10,
			-84
		],
		"demonym": "Costa Rican",
		"landlocked": false,
		"borders": [
			"NIC",
			"PAN"
		],
		"area": 51100
	},
	{
		"name": {
			"common": "Cuba",
			"official": "Republic of Cuba",
			"native": {
				"spa": {
					"official": "República de Cuba",
					"common": "Cuba"
				}
			}
		},
		"tld": [
			".cu"
		],
		"cca2": "CU",
		"ccn3": "192",
		"cca3": "CUB",
		"cioc": "CUB",
		"currency": [
			"CUC",
			"CUP"
		],
		"callingCode": [
			"53"
		],
		"capital": "Havana",
		"altSpellings": [
			"CU",
			"Republic of Cuba",
			"República de Cuba"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Republic of Cuba",
				"common": "Ciwba"
			},
			"deu": {
				"official": "Republik Kuba",
				"common": "Kuba"
			},
			"fra": {
				"official": "République de Cuba",
				"common": "Cuba"
			},
			"hrv": {
				"official": "Republika Kuba",
				"common": "Kuba"
			},
			"ita": {
				"official": "Repubblica di Cuba",
				"common": "Cuba"
			},
			"jpn": {
				"official": "キューバ共和国",
				"common": "キューバ"
			},
			"nld": {
				"official": "Republiek Cuba",
				"common": "Cuba"
			},
			"por": {
				"official": "República de Cuba",
				"common": "Cuba"
			},
			"rus": {
				"official": "Республика Куба",
				"common": "Куба"
			},
			"spa": {
				"official": "República de Cuba",
				"common": "Cuba"
			},
			"svk": {
				"official": "Kubánska republika",
				"common": "Kuba"
			},
			"fin": {
				"official": "Kuuban tasavalta",
				"common": "Kuuba"
			},
			"zho": {
				"official": "古巴共和国",
				"common": "古巴"
			}
		},
		"latlng": [
			21.5,
			-80
		],
		"demonym": "Cuban",
		"landlocked": false,
		"borders": [],
		"area": 109884
	},
	{
		"name": {
			"common": "Curaçao",
			"official": "Country of Curaçao",
			"native": {
				"eng": {
					"official": "Country of Curaçao",
					"common": "Curaçao"
				},
				"nld": {
					"official": "Land Curaçao",
					"common": "Curaçao"
				},
				"pap": {
					"official": "Pais Kòrsou",
					"common": "Pais Kòrsou"
				}
			}
		},
		"tld": [
			".cw"
		],
		"cca2": "CW",
		"ccn3": "531",
		"cca3": "CUW",
		"cioc": "",
		"currency": [
			"ANG"
		],
		"callingCode": [
			"5999"
		],
		"capital": "Willemstad",
		"altSpellings": [
			"CW",
			"Curacao",
			"Kòrsou",
			"Country of Curaçao",
			"Land Curaçao",
			"Pais Kòrsou"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English",
			"nld": "Dutch",
			"pap": "Papiamento"
		},
		"translations": {
			"deu": {
				"official": "Land Curaçao",
				"common": "Curaçao"
			},
			"fra": {
				"official": "Curaçao",
				"common": "Curaçao"
			},
			"nld": {
				"official": "Land Curaçao",
				"common": "Curaçao"
			},
			"por": {
				"official": "País de Curaçao",
				"common": "ilha da Curação"
			},
			"rus": {
				"official": "Страна Кюрасао",
				"common": "Кюрасао"
			},
			"spa": {
				"official": "País de Curazao",
				"common": "Curazao"
			},
			"svk": {
				"official": "CuraÇao",
				"common": "CuraÇao"
			},
			"fin": {
				"official": "Curaçao",
				"common": "Curaçao"
			},
			"zho": {
				"official": "库拉索",
				"common": "库拉索"
			}
		},
		"latlng": [
			12.116667,
			-68.933333
		],
		"demonym": "Dutch",
		"landlocked": false,
		"borders": [],
		"area": 444
	},
	{
		"name": {
			"common": "Christmas Island",
			"official": "Territory of Christmas Island",
			"native": {
				"eng": {
					"official": "Territory of Christmas Island",
					"common": "Christmas Island"
				}
			}
		},
		"tld": [
			".cx"
		],
		"cca2": "CX",
		"ccn3": "162",
		"cca3": "CXR",
		"cioc": "",
		"currency": [
			"AUD"
		],
		"callingCode": [
			"61"
		],
		"capital": "Flying Fish Cove",
		"altSpellings": [
			"CX",
			"Territory of Christmas Island"
		],
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Territory of Christmas Island",
				"common": "Ynys y Nadolig"
			},
			"deu": {
				"official": "Gebiet der Weihnachtsinsel",
				"common": "Weihnachtsinsel"
			},
			"fra": {
				"official": "Territoire de l'île Christmas",
				"common": "Île Christmas"
			},
			"hrv": {
				"official": "Teritorij Božićni otok",
				"common": "Božićni otok"
			},
			"ita": {
				"official": "Territorio di Christmas Island",
				"common": "Isola di Natale"
			},
			"jpn": {
				"official": "クリスマス島の領土",
				"common": "クリスマス島"
			},
			"nld": {
				"official": "Grondgebied van Christmas Island",
				"common": "Christmaseiland"
			},
			"por": {
				"official": "Território da Ilha Christmas",
				"common": "Ilha do Natal"
			},
			"rus": {
				"official": "Территория острова Рождества",
				"common": "Остров Рождества"
			},
			"spa": {
				"official": "Territorio de la Isla de Navidad",
				"common": "Isla de Navidad"
			},
			"svk": {
				"official": "Teritórium Vianočného ostrova",
				"common": "Vianočnú ostrov"
			},
			"fin": {
				"official": "Joulusaaren alue",
				"common": "Joulusaari"
			},
			"zho": {
				"official": "圣诞岛",
				"common": "圣诞岛"
			}
		},
		"latlng": [
			-10.5,
			105.66666666
		],
		"demonym": "Christmas Islander",
		"landlocked": false,
		"borders": [],
		"area": 135
	},
	{
		"name": {
			"common": "Cayman Islands",
			"official": "Cayman Islands",
			"native": {
				"eng": {
					"official": "Cayman Islands",
					"common": "Cayman Islands"
				}
			}
		},
		"tld": [
			".ky"
		],
		"cca2": "KY",
		"ccn3": "136",
		"cca3": "CYM",
		"cioc": "CAY",
		"currency": [
			"KYD"
		],
		"callingCode": [
			"1345"
		],
		"capital": "George Town",
		"altSpellings": [
			"KY"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Cayman Islands",
				"common": "Ynysoedd_Cayman"
			},
			"deu": {
				"official": "Cayman-Inseln",
				"common": "Kaimaninseln"
			},
			"fra": {
				"official": "Îles Caïmans",
				"common": "Îles Caïmans"
			},
			"hrv": {
				"official": "Kajmanski otoci",
				"common": "Kajmanski otoci"
			},
			"ita": {
				"official": "Isole Cayman",
				"common": "Isole Cayman"
			},
			"jpn": {
				"official": "ケイマン諸島",
				"common": "ケイマン諸島"
			},
			"nld": {
				"official": "Caymaneilanden",
				"common": "Caymaneilanden"
			},
			"por": {
				"official": "Ilhas Cayman",
				"common": "Ilhas Caimão"
			},
			"rus": {
				"official": "Каймановы острова",
				"common": "Каймановы острова"
			},
			"spa": {
				"official": "Islas Caimán",
				"common": "Islas Caimán"
			},
			"svk": {
				"official": "Kajmanie ostrovy",
				"common": "Kajmanie ostrovy"
			},
			"fin": {
				"official": "Caymansaaret",
				"common": "Caymansaaret"
			},
			"zho": {
				"official": "开曼群岛",
				"common": "开曼群岛"
			}
		},
		"latlng": [
			19.5,
			-80.5
		],
		"demonym": "Caymanian",
		"landlocked": false,
		"borders": [],
		"area": 264
	},
	{
		"name": {
			"common": "Cyprus",
			"official": "Republic of Cyprus",
			"native": {
				"ell": {
					"official": "Δημοκρατία της Κύπρος",
					"common": "Κύπρος"
				},
				"tur": {
					"official": "Kıbrıs Cumhuriyeti",
					"common": "Kıbrıs"
				}
			}
		},
		"tld": [
			".cy"
		],
		"cca2": "CY",
		"ccn3": "196",
		"cca3": "CYP",
		"cioc": "CYP",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"357"
		],
		"capital": "Nicosia",
		"altSpellings": [
			"CY",
			"Kýpros",
			"Kıbrıs",
			"Republic of Cyprus",
			"Κυπριακή Δημοκρατία",
			"Kıbrıs Cumhuriyeti"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"ell": "Greek",
			"tur": "Turkish"
		},
		"translations": {
			"cym": {
				"official": "Republic of Cyprus",
				"common": "Cyprus"
			},
			"deu": {
				"official": "Republik Zypern",
				"common": "Zypern"
			},
			"fra": {
				"official": "République de Chypre",
				"common": "Chypre"
			},
			"hrv": {
				"official": "Republika Cipar",
				"common": "Cipar"
			},
			"ita": {
				"official": "Repubblica di Cipro",
				"common": "Cipro"
			},
			"jpn": {
				"official": "キプロス共和国",
				"common": "キプロス"
			},
			"nld": {
				"official": "Republiek Cyprus",
				"common": "Cyprus"
			},
			"por": {
				"official": "República de Chipre",
				"common": "Chipre"
			},
			"rus": {
				"official": "Республика Кипр",
				"common": "Кипр"
			},
			"spa": {
				"official": "República de Chipre",
				"common": "Chipre"
			},
			"svk": {
				"official": " Cyperská republika",
				"common": "Cyprus"
			},
			"fin": {
				"official": "Kyproksen tasavalta",
				"common": "Kypros"
			},
			"zho": {
				"official": "塞浦路斯共和国",
				"common": "塞浦路斯"
			}
		},
		"latlng": [
			35,
			33
		],
		"demonym": "Cypriot",
		"landlocked": false,
		"borders": [
			"GBR"
		],
		"area": 9251
	},
	{
		"name": {
			"common": "Czech Republic",
			"official": "Czech Republic",
			"native": {
				"ces": {
					"official": "česká republika",
					"common": "Česká republika"
				},
				"slk": {
					"official": "Česká republika",
					"common": "Česká republika"
				}
			}
		},
		"tld": [
			".cz"
		],
		"cca2": "CZ",
		"ccn3": "203",
		"cca3": "CZE",
		"cioc": "CZE",
		"currency": [
			"CZK"
		],
		"callingCode": [
			"420"
		],
		"capital": "Prague",
		"altSpellings": [
			"CZ",
			"Česká republika",
			"Česko"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"ces": "Czech",
			"slk": "Slovak"
		},
		"translations": {
			"cym": {
				"official": "Czech Republic",
				"common": "Y Weriniaeth Tsiec"
			},
			"deu": {
				"official": "Tschechische Republik",
				"common": "Tschechische Republik"
			},
			"fra": {
				"official": "République tchèque",
				"common": "République tchèque"
			},
			"hrv": {
				"official": "Češka",
				"common": "Češka"
			},
			"ita": {
				"official": "Repubblica Ceca",
				"common": "Repubblica Ceca"
			},
			"jpn": {
				"official": "チェコ共和国",
				"common": "チェコ"
			},
			"nld": {
				"official": "Tsjechische Republiek",
				"common": "Tsjechië"
			},
			"por": {
				"official": "República Checa",
				"common": "República Checa"
			},
			"rus": {
				"official": "Чешская Республика",
				"common": "Чехия"
			},
			"spa": {
				"official": "República Checa",
				"common": "República Checa"
			},
			"svk": {
				"official": "Česká republika",
				"common": "Česko"
			},
			"fin": {
				"official": "Tšekin tasavalta",
				"common": "Tšekki"
			},
			"zho": {
				"official": "捷克共和国",
				"common": "捷克"
			}
		},
		"latlng": [
			49.75,
			15.5
		],
		"demonym": "Czech",
		"landlocked": true,
		"borders": [
			"AUT",
			"DEU",
			"POL",
			"SVK"
		],
		"area": 78865
	},
	{
		"name": {
			"common": "Germany",
			"official": "Federal Republic of Germany",
			"native": {
				"deu": {
					"official": "Bundesrepublik Deutschland",
					"common": "Deutschland"
				}
			}
		},
		"tld": [
			".de"
		],
		"cca2": "DE",
		"ccn3": "276",
		"cca3": "DEU",
		"cioc": "GER",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"49"
		],
		"capital": "Berlin",
		"altSpellings": [
			"DE",
			"Federal Republic of Germany",
			"Bundesrepublik Deutschland"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"deu": "German"
		},
		"translations": {
			"deu": {
				"official": "Bundesrepublik Deutschland",
				"common": "Deutschland"
			},
			"fra": {
				"official": "République fédérale d'Allemagne",
				"common": "Allemagne"
			},
			"hrv": {
				"official": "Njemačka Federativna Republika",
				"common": "Njemačka"
			},
			"ita": {
				"official": "Repubblica federale di Germania",
				"common": "Germania"
			},
			"jpn": {
				"official": "ドイツ連邦共和国",
				"common": "ドイツ"
			},
			"nld": {
				"official": "Bondsrepubliek Duitsland",
				"common": "Duitsland"
			},
			"por": {
				"official": "República Federal da Alemanha",
				"common": "Alemanha"
			},
			"rus": {
				"official": "Федеративная Республика Германия",
				"common": "Германия"
			},
			"spa": {
				"official": "República Federal de Alemania",
				"common": "Alemania"
			},
			"svk": {
				"official": "Nemecká spolková republika",
				"common": "Nemecko"
			},
			"fin": {
				"official": "Saksan liittotasavalta",
				"common": "Saksa"
			},
			"zho": {
				"official": "德意志联邦共和国",
				"common": "德国"
			}
		},
		"latlng": [
			51,
			9
		],
		"demonym": "German",
		"landlocked": false,
		"borders": [
			"AUT",
			"BEL",
			"CZE",
			"DNK",
			"FRA",
			"LUX",
			"NLD",
			"POL",
			"CHE"
		],
		"area": 357114
	},
	{
		"name": {
			"common": "Djibouti",
			"official": "Republic of Djibouti",
			"native": {
				"ara": {
					"official": "جمهورية جيبوتي",
					"common": "جيبوتي‎"
				},
				"fra": {
					"official": "République de Djibouti",
					"common": "Djibouti"
				}
			}
		},
		"tld": [
			".dj"
		],
		"cca2": "DJ",
		"ccn3": "262",
		"cca3": "DJI",
		"cioc": "DJI",
		"currency": [
			"DJF"
		],
		"callingCode": [
			"253"
		],
		"capital": "Djibouti",
		"altSpellings": [
			"DJ",
			"Jabuuti",
			"Gabuuti",
			"Republic of Djibouti",
			"République de Djibouti",
			"Gabuutih Ummuuno",
			"Jamhuuriyadda Jabuuti"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"ara": "Arabic",
			"fra": "French"
		},
		"translations": {
			"cym": {
				"official": "Republic of Djibouti",
				"common": "Djibouti"
			},
			"deu": {
				"official": "Republik Dschibuti",
				"common": "Dschibuti"
			},
			"fra": {
				"official": "République de Djibouti",
				"common": "Djibouti"
			},
			"hrv": {
				"official": "Republika Džibuti",
				"common": "Džibuti"
			},
			"ita": {
				"official": "Repubblica di Gibuti",
				"common": "Gibuti"
			},
			"jpn": {
				"official": "ジブチ共和国",
				"common": "ジブチ"
			},
			"nld": {
				"official": "Republiek Djibouti",
				"common": "Djibouti"
			},
			"por": {
				"official": "República do Djibouti",
				"common": "Djibouti"
			},
			"rus": {
				"official": "Республика Джибути",
				"common": "Джибути"
			},
			"spa": {
				"official": "República de Djibouti",
				"common": "Djibouti"
			},
			"svk": {
				"official": "ǅibutská republika",
				"common": "ǅibutsko"
			},
			"fin": {
				"official": "Dijiboutin tasavalta",
				"common": "Dijibouti"
			},
			"zho": {
				"official": "吉布提共和国",
				"common": "吉布提"
			}
		},
		"latlng": [
			11.5,
			43
		],
		"demonym": "Djibouti",
		"landlocked": false,
		"borders": [
			"ERI",
			"ETH",
			"SOM"
		],
		"area": 23200
	},
	{
		"name": {
			"common": "Dominica",
			"official": "Commonwealth of Dominica",
			"native": {
				"eng": {
					"official": "Commonwealth of Dominica",
					"common": "Dominica"
				}
			}
		},
		"tld": [
			".dm"
		],
		"cca2": "DM",
		"ccn3": "212",
		"cca3": "DMA",
		"cioc": "DMA",
		"currency": [
			"XCD"
		],
		"callingCode": [
			"1767"
		],
		"capital": "Roseau",
		"altSpellings": [
			"DM",
			"Dominique",
			"Wai‘tu kubuli",
			"Commonwealth of Dominica"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "Commonwealth of Dominica",
				"common": "Dominica"
			},
			"deu": {
				"official": "Commonwealth von Dominica",
				"common": "Dominica"
			},
			"fra": {
				"official": "Commonwealth de la Dominique",
				"common": "Dominique"
			},
			"hrv": {
				"official": "Zajednica Dominika",
				"common": "Dominika"
			},
			"ita": {
				"official": "Commonwealth di Dominica",
				"common": "Dominica"
			},
			"jpn": {
				"official": "ドミニカ国",
				"common": "ドミニカ国"
			},
			"nld": {
				"official": "Gemenebest Dominica",
				"common": "Dominica"
			},
			"por": {
				"official": "Comunidade da Dominica",
				"common": "Dominica"
			},
			"rus": {
				"official": "Содружество Доминики",
				"common": "Доминика"
			},
			"spa": {
				"official": "Mancomunidad de Dominica",
				"common": "Dominica"
			},
			"svk": {
				"official": "Dominické spoločenstvo",
				"common": "Dominika"
			},
			"fin": {
				"official": "Dominican liittovaltio",
				"common": "Dominica"
			},
			"zho": {
				"official": "多米尼加共和国",
				"common": "多米尼加"
			}
		},
		"latlng": [
			15.41666666,
			-61.33333333
		],
		"demonym": "Dominican",
		"landlocked": false,
		"borders": [],
		"area": 751
	},
	{
		"name": {
			"common": "Denmark",
			"official": "Kingdom of Denmark",
			"native": {
				"dan": {
					"official": "Kongeriget Danmark",
					"common": "Danmark"
				}
			}
		},
		"tld": [
			".dk"
		],
		"cca2": "DK",
		"ccn3": "208",
		"cca3": "DNK",
		"cioc": "DEN",
		"currency": [
			"DKK"
		],
		"callingCode": [
			"45"
		],
		"capital": "Copenhagen",
		"altSpellings": [
			"DK",
			"Danmark",
			"Kingdom of Denmark",
			"Kongeriget Danmark"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"dan": "Danish"
		},
		"translations": {
			"cym": {
				"official": "Kingdom of Denmark",
				"common": "Denmarc"
			},
			"deu": {
				"official": "Königreich Dänemark",
				"common": "Dänemark"
			},
			"fra": {
				"official": "Royaume du Danemark",
				"common": "Danemark"
			},
			"hrv": {
				"official": "Kraljevina Danska",
				"common": "Danska"
			},
			"ita": {
				"official": "Regno di Danimarca",
				"common": "Danimarca"
			},
			"jpn": {
				"official": "デンマーク王国",
				"common": "デンマーク"
			},
			"nld": {
				"official": "Koninkrijk Denemarken",
				"common": "Denemarken"
			},
			"por": {
				"official": "Reino da Dinamarca",
				"common": "Dinamarca"
			},
			"rus": {
				"official": "Королевство Дания",
				"common": "Дания"
			},
			"spa": {
				"official": "Reino de Dinamarca",
				"common": "Dinamarca"
			},
			"svk": {
				"official": "Dánske kráľovstvo",
				"common": "Dánsko"
			},
			"fin": {
				"official": "Tanskan kuningaskunta",
				"common": "Tanska"
			},
			"zho": {
				"official": "丹麦王国",
				"common": "丹麦"
			}
		},
		"latlng": [
			56,
			10
		],
		"demonym": "Danish",
		"landlocked": false,
		"borders": [
			"DEU"
		],
		"area": 43094
	},
	{
		"name": {
			"common": "Dominican Republic",
			"official": "Dominican Republic",
			"native": {
				"spa": {
					"official": "República Dominicana",
					"common": "República Dominicana"
				}
			}
		},
		"tld": [
			".do"
		],
		"cca2": "DO",
		"ccn3": "214",
		"cca3": "DOM",
		"cioc": "DOM",
		"currency": [
			"DOP"
		],
		"callingCode": [
			"1809",
			"1829",
			"1849"
		],
		"capital": "Santo Domingo",
		"altSpellings": [
			"DO"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Dominican Republic",
				"common": "Gweriniaeth_Dominica"
			},
			"deu": {
				"official": "Dominikanische Republik",
				"common": "Dominikanische Republik"
			},
			"fra": {
				"official": "République Dominicaine",
				"common": "République dominicaine"
			},
			"hrv": {
				"official": "Dominikanska Republika",
				"common": "Dominikanska Republika"
			},
			"ita": {
				"official": "Repubblica Dominicana",
				"common": "Repubblica Dominicana"
			},
			"jpn": {
				"official": "ドミニカ共和国",
				"common": "ドミニカ共和国"
			},
			"nld": {
				"official": "Dominicaanse Republiek",
				"common": "Dominicaanse Republiek"
			},
			"por": {
				"official": "República Dominicana",
				"common": "República Dominicana"
			},
			"rus": {
				"official": "Доминиканская Республика",
				"common": "Доминиканская Республика"
			},
			"spa": {
				"official": "República Dominicana",
				"common": "República Dominicana"
			},
			"svk": {
				"official": "Dominikánska republika",
				"common": "Dominikánska republika"
			},
			"fin": {
				"official": "Dominikaaninen tasavalta",
				"common": "Dominikaaninen tasavalta"
			},
			"zho": {
				"official": "多明尼加共和国",
				"common": "多明尼加"
			}
		},
		"latlng": [
			19,
			-70.66666666
		],
		"demonym": "Dominican",
		"landlocked": false,
		"borders": [
			"HTI"
		],
		"area": 48671
	},
	{
		"name": {
			"common": "Algeria",
			"official": "People's Democratic Republic of Algeria",
			"native": {
				"ara": {
					"official": "الجمهورية الديمقراطية الشعبية الجزائرية",
					"common": "الجزائر"
				}
			}
		},
		"tld": [
			".dz",
			"الجزائر."
		],
		"cca2": "DZ",
		"ccn3": "012",
		"cca3": "DZA",
		"cioc": "ALG",
		"currency": [
			"DZD"
		],
		"callingCode": [
			"213"
		],
		"capital": "Algiers",
		"altSpellings": [
			"DZ",
			"Dzayer",
			"Algérie"
		],
		"region": "Africa",
		"subregion": "Northern Africa",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"cym": {
				"official": "People's Democratic Republic of Algeria",
				"common": "Algeria"
			},
			"deu": {
				"official": "Demokratische Volksrepublik Algerien",
				"common": "Algerien"
			},
			"fra": {
				"official": "République démocratique et populaire d'Algérie",
				"common": "Algérie"
			},
			"hrv": {
				"official": "Narodna Demokratska Republika Alžir",
				"common": "Alžir"
			},
			"ita": {
				"official": "Repubblica popolare democratica di Algeria",
				"common": "Algeria"
			},
			"jpn": {
				"official": "アルジェリア人民民主共和国",
				"common": "アルジェリア"
			},
			"nld": {
				"official": "Democratische Volksrepubliek Algerije",
				"common": "Algerije"
			},
			"por": {
				"official": "República Argelina Democrática e Popular",
				"common": "Argélia"
			},
			"rus": {
				"official": "Народно-Демократическая Республика Алжир",
				"common": "Алжир"
			},
			"spa": {
				"official": "República Argelina Democrática y Popular",
				"common": "Argelia"
			},
			"svk": {
				"official": "Alžírska demokratická ľudová republika",
				"common": "Alžírsko"
			},
			"fin": {
				"official": "Algerian demokraattinen kansantasavalta",
				"common": "Algeria"
			},
			"zho": {
				"official": "阿尔及利亚人民民主共和国",
				"common": "阿尔及利亚"
			}
		},
		"latlng": [
			28,
			3
		],
		"demonym": "Algerian",
		"landlocked": false,
		"borders": [
			"TUN",
			"LBY",
			"NER",
			"ESH",
			"MRT",
			"MLI",
			"MAR"
		],
		"area": 2381741
	},
	{
		"name": {
			"common": "Ecuador",
			"official": "Republic of Ecuador",
			"native": {
				"spa": {
					"official": "República del Ecuador",
					"common": "Ecuador"
				}
			}
		},
		"tld": [
			".ec"
		],
		"cca2": "EC",
		"ccn3": "218",
		"cca3": "ECU",
		"cioc": "ECU",
		"currency": [
			"USD"
		],
		"callingCode": [
			"593"
		],
		"capital": "Quito",
		"altSpellings": [
			"EC",
			"Republic of Ecuador",
			"República del Ecuador"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Republic of Ecuador",
				"common": "Ecwador"
			},
			"deu": {
				"official": "Republik Ecuador",
				"common": "Ecuador"
			},
			"fra": {
				"official": "République de l'Équateur",
				"common": "Équateur"
			},
			"hrv": {
				"official": "Republika Ekvador",
				"common": "Ekvador"
			},
			"ita": {
				"official": "Repubblica dell'Ecuador",
				"common": "Ecuador"
			},
			"jpn": {
				"official": "エクアドル共和国",
				"common": "エクアドル"
			},
			"nld": {
				"official": "Republiek Ecuador",
				"common": "Ecuador"
			},
			"por": {
				"official": "República do Equador",
				"common": "Equador"
			},
			"rus": {
				"official": "Республика Эквадор",
				"common": "Эквадор"
			},
			"spa": {
				"official": "República del Ecuador",
				"common": "Ecuador"
			},
			"svk": {
				"official": "Ekvádorská republika",
				"common": "Ekvádor"
			},
			"fin": {
				"official": "Ecuadorin tasavalta",
				"common": "Ecuador"
			},
			"zho": {
				"official": "厄瓜多尔共和国",
				"common": "厄瓜多尔"
			}
		},
		"latlng": [
			-2,
			-77.5
		],
		"demonym": "Ecuadorean",
		"landlocked": false,
		"borders": [
			"COL",
			"PER"
		],
		"area": 276841
	},
	{
		"name": {
			"common": "Egypt",
			"official": "Arab Republic of Egypt",
			"native": {
				"ara": {
					"official": "جمهورية مصر العربية",
					"common": "مصر"
				}
			}
		},
		"tld": [
			".eg",
			".مصر"
		],
		"cca2": "EG",
		"ccn3": "818",
		"cca3": "EGY",
		"cioc": "EGY",
		"currency": [
			"EGP"
		],
		"callingCode": [
			"20"
		],
		"capital": "Cairo",
		"altSpellings": [
			"EG",
			"Arab Republic of Egypt"
		],
		"region": "Africa",
		"subregion": "Northern Africa",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"cym": {
				"official": "Arab Republic of Egypt",
				"common": "Yr Aifft"
			},
			"deu": {
				"official": "Arabische Republik Ägypten",
				"common": "Ägypten"
			},
			"fra": {
				"official": "République arabe d'Égypte",
				"common": "Égypte"
			},
			"hrv": {
				"official": "Arapska Republika Egipat",
				"common": "Egipat"
			},
			"ita": {
				"official": "Repubblica araba d'Egitto",
				"common": "Egitto"
			},
			"jpn": {
				"official": "エジプト·アラブ共和国",
				"common": "エジプト"
			},
			"nld": {
				"official": "Arabische Republiek Egypte",
				"common": "Egypte"
			},
			"por": {
				"official": "República Árabe do Egipto",
				"common": "Egito"
			},
			"rus": {
				"official": "Арабская Республика Египет",
				"common": "Египет"
			},
			"spa": {
				"official": "República Árabe de Egipto",
				"common": "Egipto"
			},
			"svk": {
				"official": "Egyptská arabská republika",
				"common": "Egypt"
			},
			"fin": {
				"official": "Egyptin arabitasavalta",
				"common": "Egypti"
			},
			"zho": {
				"official": "阿拉伯埃及共和国",
				"common": "埃及"
			}
		},
		"latlng": [
			27,
			30
		],
		"demonym": "Egyptian",
		"landlocked": false,
		"borders": [
			"ISR",
			"LBY",
			"SDN"
		],
		"area": 1002450
	},
	{
		"name": {
			"common": "Eritrea",
			"official": "State of Eritrea",
			"native": {
				"ara": {
					"official": "دولة إرتريا",
					"common": "إرتريا‎"
				},
				"eng": {
					"official": "State of Eritrea",
					"common": "Eritrea"
				},
				"tir": {
					"official": "ሃገረ ኤርትራ",
					"common": "ኤርትራ"
				}
			}
		},
		"tld": [
			".er"
		],
		"cca2": "ER",
		"ccn3": "232",
		"cca3": "ERI",
		"cioc": "ERI",
		"currency": [
			"ERN"
		],
		"callingCode": [
			"291"
		],
		"capital": "Asmara",
		"altSpellings": [
			"ER",
			"State of Eritrea",
			"ሃገረ ኤርትራ",
			"Dawlat Iritriyá",
			"ʾErtrā",
			"Iritriyā"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"ara": "Arabic",
			"eng": "English",
			"tir": "Tigrinya"
		},
		"translations": {
			"cym": {
				"official": "State of Eritrea",
				"common": "Eritrea"
			},
			"deu": {
				"official": "Staat Eritrea",
				"common": "Eritrea"
			},
			"fra": {
				"official": "État d'Érythrée",
				"common": "Érythrée"
			},
			"hrv": {
				"official": "Država Eritreji",
				"common": "Eritreja"
			},
			"ita": {
				"official": "Stato di Eritrea",
				"common": "Eritrea"
			},
			"jpn": {
				"official": "エリトリア国",
				"common": "エリトリア"
			},
			"nld": {
				"official": "Staat Eritrea",
				"common": "Eritrea"
			},
			"por": {
				"official": "Estado da Eritreia",
				"common": "Eritreia"
			},
			"rus": {
				"official": "Государство Эритрея",
				"common": "Эритрея"
			},
			"spa": {
				"official": "Estado de Eritrea",
				"common": "Eritrea"
			},
			"svk": {
				"official": "Eritrejský štát",
				"common": "Eritrea"
			},
			"fin": {
				"official": "Eritrean valtio",
				"common": "Eritrea"
			},
			"zho": {
				"official": "厄立特里亚",
				"common": "厄立特里亚"
			}
		},
		"latlng": [
			15,
			39
		],
		"demonym": "Eritrean",
		"landlocked": false,
		"borders": [
			"DJI",
			"ETH",
			"SDN"
		],
		"area": 117600
	},
	{
		"name": {
			"common": "Western Sahara",
			"official": "Sahrawi Arab Democratic Republic",
			"native": {
				"ber": {
					"official": "Sahrawi Arab Democratic Republic",
					"common": "Western Sahara"
				},
				"mey": {
					"official": "الجمهورية العربية الصحراوية الديمقراطية",
					"common": "الصحراء الغربية"
				},
				"spa": {
					"official": "República Árabe Saharaui Democrática",
					"common": "Sahara Occidental"
				}
			}
		},
		"tld": [
			".eh"
		],
		"cca2": "EH",
		"ccn3": "732",
		"cca3": "ESH",
		"cioc": "",
		"currency": [
			"MAD",
			"DZD",
			"MRO"
		],
		"callingCode": [
			"212"
		],
		"capital": "El Aaiún",
		"altSpellings": [
			"EH",
			"Taneẓroft Tutrimt"
		],
		"region": "Africa",
		"subregion": "Northern Africa",
		"languages": {
			"ber": "Berber",
			"mey": "Hassaniya",
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Demokratische Arabische Republik Sahara",
				"common": "Westsahara"
			},
			"fra": {
				"official": "République arabe sahraouie démocratique",
				"common": "Sahara Occidental"
			},
			"hrv": {
				"official": "Sahrawi Arab Demokratska Republika",
				"common": "Zapadna Sahara"
			},
			"ita": {
				"official": "Repubblica Araba Saharawi Democratica",
				"common": "Sahara Occidentale"
			},
			"jpn": {
				"official": "サハラアラブ民主共和国",
				"common": "西サハラ"
			},
			"nld": {
				"official": "Sahrawi Arabische Democratische Republiek",
				"common": "Westelijke Sahara"
			},
			"por": {
				"official": "República Árabe Saharaui Democrática",
				"common": "Saara Ocidental"
			},
			"rus": {
				"official": "Sahrawi Арабская Демократическая Республика",
				"common": "Западная Сахара"
			},
			"spa": {
				"official": "República Árabe Saharaui Democrática",
				"common": "Sahara Occidental"
			},
			"svk": {
				"official": "Západná Sahara",
				"common": "Západná Sahara"
			},
			"fin": {
				"official": "Länsi-Sahara",
				"common": "Länsi-Sahara"
			},
			"zho": {
				"official": "阿拉伯撒哈拉民主共和国",
				"common": "西撒哈拉"
			}
		},
		"latlng": [
			24.5,
			-13
		],
		"demonym": "Sahrawi",
		"landlocked": false,
		"borders": [
			"DZA",
			"MRT",
			"MAR"
		],
		"area": 266000
	},
	{
		"name": {
			"common": "Spain",
			"official": "Kingdom of Spain",
			"native": {
				"cat": {
					"official": "Regne d'Espanya",
					"common": "Espanya"
				},
				"eus": {
					"official": "Espainiako Erresuma",
					"common": "Espainia"
				},
				"glg": {
					"official": "Reino de España",
					"common": ""
				},
				"oci": {
					"official": "Reialme d'Espanha",
					"common": "Espanha"
				},
				"spa": {
					"official": "Reino de España",
					"common": "España"
				}
			}
		},
		"tld": [
			".es"
		],
		"cca2": "ES",
		"ccn3": "724",
		"cca3": "ESP",
		"cioc": "ESP",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"34"
		],
		"capital": "Madrid",
		"altSpellings": [
			"ES",
			"Kingdom of Spain",
			"Reino de España"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"cat": "Catalan",
			"eus": "Basque",
			"glg": "Galician",
			"oci": "Occitan",
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Königreich Spanien",
				"common": "Spanien"
			},
			"fra": {
				"official": "Royaume d'Espagne",
				"common": "Espagne"
			},
			"hrv": {
				"official": "Kraljevina Španjolska",
				"common": "Španjolska"
			},
			"ita": {
				"official": "Regno di Spagna",
				"common": "Spagna"
			},
			"jpn": {
				"official": "スペイン王国",
				"common": "スペイン"
			},
			"nld": {
				"official": "Koninkrijk Spanje",
				"common": "Spanje"
			},
			"por": {
				"official": "Reino de Espanha",
				"common": "Espanha"
			},
			"rus": {
				"official": "Королевство Испания",
				"common": "Испания"
			},
			"spa": {
				"official": "Reino de España",
				"common": "España"
			},
			"svk": {
				"official": "Španielske kráľovstvo",
				"common": "Španielsko"
			},
			"fin": {
				"official": "Espanjan kuningaskunta",
				"common": "Espanja"
			},
			"zho": {
				"official": "西班牙王国",
				"common": "西班牙"
			}
		},
		"latlng": [
			40,
			-4
		],
		"demonym": "Spanish",
		"landlocked": false,
		"borders": [
			"AND",
			"FRA",
			"GIB",
			"PRT",
			"MAR"
		],
		"area": 505992
	},
	{
		"name": {
			"common": "Estonia",
			"official": "Republic of Estonia",
			"native": {
				"est": {
					"official": "Eesti Vabariik",
					"common": "Eesti"
				}
			}
		},
		"tld": [
			".ee"
		],
		"cca2": "EE",
		"ccn3": "233",
		"cca3": "EST",
		"cioc": "EST",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"372"
		],
		"capital": "Tallinn",
		"altSpellings": [
			"EE",
			"Eesti",
			"Republic of Estonia",
			"Eesti Vabariik"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"est": "Estonian"
		},
		"translations": {
			"cym": {
				"official": "Republic of Estonia",
				"common": "Estonia"
			},
			"deu": {
				"official": "Republik Estland",
				"common": "Estland"
			},
			"fra": {
				"official": "République d'Estonie",
				"common": "Estonie"
			},
			"hrv": {
				"official": "Republika Estonija",
				"common": "Estonija"
			},
			"ita": {
				"official": "Repubblica di Estonia",
				"common": "Estonia"
			},
			"jpn": {
				"official": "エストニア共和国",
				"common": "エストニア"
			},
			"nld": {
				"official": "Republiek Estland",
				"common": "Estland"
			},
			"por": {
				"official": "República da Estónia",
				"common": "Estónia"
			},
			"rus": {
				"official": "Эстонская Республика",
				"common": "Эстония"
			},
			"spa": {
				"official": "República de Estonia",
				"common": "Estonia"
			},
			"svk": {
				"official": "Estónska republika",
				"common": "Estónsko"
			},
			"fin": {
				"official": "Viron tasavalta",
				"common": "Viro"
			},
			"zho": {
				"official": "爱沙尼亚共和国",
				"common": "爱沙尼亚"
			}
		},
		"latlng": [
			59,
			26
		],
		"demonym": "Estonian",
		"landlocked": false,
		"borders": [
			"LVA",
			"RUS"
		],
		"area": 45227
	},
	{
		"name": {
			"common": "Ethiopia",
			"official": "Federal Democratic Republic of Ethiopia",
			"native": {
				"amh": {
					"official": "የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ",
					"common": "ኢትዮጵያ"
				}
			}
		},
		"tld": [
			".et"
		],
		"cca2": "ET",
		"ccn3": "231",
		"cca3": "ETH",
		"cioc": "ETH",
		"currency": [
			"ETB"
		],
		"callingCode": [
			"251"
		],
		"capital": "Addis Ababa",
		"altSpellings": [
			"ET",
			"ʾĪtyōṗṗyā",
			"Federal Democratic Republic of Ethiopia",
			"የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"amh": "Amharic"
		},
		"translations": {
			"cym": {
				"official": "Federal Democratic Republic of Ethiopia",
				"common": "Ethiopia"
			},
			"deu": {
				"official": "Demokratische Bundesrepublik Äthiopien",
				"common": "Äthiopien"
			},
			"fra": {
				"official": "République fédérale démocratique d'Éthiopie",
				"common": "Éthiopie"
			},
			"hrv": {
				"official": "Savezna Demokratska Republika Etiopija",
				"common": "Etiopija"
			},
			"ita": {
				"official": "Repubblica federale democratica di Etiopia",
				"common": "Etiopia"
			},
			"jpn": {
				"official": "エチオピア連邦民主共和国",
				"common": "エチオピア"
			},
			"nld": {
				"official": "Federale Democratische Republiek Ethiopië",
				"common": "Ethiopië"
			},
			"por": {
				"official": "República Federal Democrática da Etiópia",
				"common": "Etiópia"
			},
			"rus": {
				"official": "Федеративная Демократическая Республика Эфиопия",
				"common": "Эфиопия"
			},
			"spa": {
				"official": "República Democrática Federal de Etiopía",
				"common": "Etiopía"
			},
			"svk": {
				"official": "Etiópska federatívna demokratická republika",
				"common": "Etiópia"
			},
			"fin": {
				"official": "Etiopian demokraattinen liittotasavalta",
				"common": "Etiopia"
			},
			"zho": {
				"official": "埃塞俄比亚联邦民主共和国",
				"common": "埃塞俄比亚"
			}
		},
		"latlng": [
			8,
			38
		],
		"demonym": "Ethiopian",
		"landlocked": true,
		"borders": [
			"DJI",
			"ERI",
			"KEN",
			"SOM",
			"SSD",
			"SDN"
		],
		"area": 1104300
	},
	{
		"name": {
			"common": "Finland",
			"official": "Republic of Finland",
			"native": {
				"fin": {
					"official": "Suomen tasavalta",
					"common": "Suomi"
				},
				"swe": {
					"official": "Republiken Finland",
					"common": "Finland"
				}
			}
		},
		"tld": [
			".fi"
		],
		"cca2": "FI",
		"ccn3": "246",
		"cca3": "FIN",
		"cioc": "FIN",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"358"
		],
		"capital": "Helsinki",
		"altSpellings": [
			"FI",
			"Suomi",
			"Republic of Finland",
			"Suomen tasavalta",
			"Republiken Finland"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"fin": "Finnish",
			"swe": "Swedish"
		},
		"translations": {
			"deu": {
				"official": "Republik Finnland",
				"common": "Finnland"
			},
			"fra": {
				"official": "République de Finlande",
				"common": "Finlande"
			},
			"hrv": {
				"official": "Republika Finska",
				"common": "Finska"
			},
			"ita": {
				"official": "Repubblica di Finlandia",
				"common": "Finlandia"
			},
			"jpn": {
				"official": "フィンランド共和国",
				"common": "フィンランド"
			},
			"nld": {
				"official": "Republiek Finland",
				"common": "Finland"
			},
			"por": {
				"official": "República da Finlândia",
				"common": "Finlândia"
			},
			"rus": {
				"official": "Финляндская Республика",
				"common": "Финляндия"
			},
			"spa": {
				"official": "República de Finlandia",
				"common": "Finlandia"
			},
			"svk": {
				"official": "Fínska republika",
				"common": "Fínsko"
			},
			"fin": {
				"official": "Suomen tasavalta",
				"common": "Suomi"
			},
			"zho": {
				"official": "芬兰共和国",
				"common": "芬兰"
			}
		},
		"latlng": [
			64,
			26
		],
		"demonym": "Finnish",
		"landlocked": false,
		"borders": [
			"NOR",
			"SWE",
			"RUS"
		],
		"area": 338424
	},
	{
		"name": {
			"common": "Fiji",
			"official": "Republic of Fiji",
			"native": {
				"eng": {
					"official": "Republic of Fiji",
					"common": "Fiji"
				},
				"fij": {
					"official": "Matanitu Tugalala o Viti",
					"common": "Viti"
				},
				"hif": {
					"official": "रिपब्लिक ऑफ फीजी",
					"common": "फिजी"
				}
			}
		},
		"tld": [
			".fj"
		],
		"cca2": "FJ",
		"ccn3": "242",
		"cca3": "FJI",
		"cioc": "FIJ",
		"currency": [
			"FJD"
		],
		"callingCode": [
			"679"
		],
		"capital": "Suva",
		"altSpellings": [
			"FJ",
			"Viti",
			"Republic of Fiji",
			"Matanitu ko Viti",
			"Fijī Gaṇarājya"
		],
		"region": "Oceania",
		"subregion": "Melanesia",
		"languages": {
			"eng": "English",
			"fij": "Fijian",
			"hif": "Fiji Hindi"
		},
		"translations": {
			"deu": {
				"official": "Republik Fidschi",
				"common": "Fidschi"
			},
			"fra": {
				"official": "République des Fidji",
				"common": "Fidji"
			},
			"hrv": {
				"official": "Republika Fidži",
				"common": "Fiđi"
			},
			"ita": {
				"official": "Repubblica di Figi",
				"common": "Figi"
			},
			"jpn": {
				"official": "フィジー共和国",
				"common": "フィジー"
			},
			"nld": {
				"official": "Republiek Fiji",
				"common": "Fiji"
			},
			"por": {
				"official": "República de Fiji",
				"common": "Fiji"
			},
			"rus": {
				"official": "Республика Фиджи",
				"common": "Фиджи"
			},
			"spa": {
				"official": "República de Fiji",
				"common": "Fiyi"
			},
			"svk": {
				"official": "Fiǆijská republika",
				"common": "Fiǆi"
			},
			"fin": {
				"official": "Fidžin tasavalta",
				"common": "Fidži"
			},
			"zho": {
				"official": "斐济共和国",
				"common": "斐济"
			}
		},
		"latlng": [
			-18,
			175
		],
		"demonym": "Fijian",
		"landlocked": false,
		"borders": [],
		"area": 18272
	},
	{
		"name": {
			"common": "Falkland Islands",
			"official": "Falkland Islands",
			"native": {
				"eng": {
					"official": "Falkland Islands",
					"common": "Falkland Islands"
				}
			}
		},
		"tld": [
			".fk"
		],
		"cca2": "FK",
		"ccn3": "238",
		"cca3": "FLK",
		"cioc": "",
		"currency": [
			"FKP"
		],
		"callingCode": [
			"500"
		],
		"capital": "Stanley",
		"altSpellings": [
			"FK",
			"Islas Malvinas",
			"Falkland Islands (Malvinas)"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Falkland-Inseln",
				"common": "Falklandinseln"
			},
			"fra": {
				"official": "Îles Malouines",
				"common": "Îles Malouines"
			},
			"hrv": {
				"official": "Falklandski otoci",
				"common": "Falklandski Otoci"
			},
			"ita": {
				"official": "Isole Falkland",
				"common": "Isole Falkland o Isole Malvine"
			},
			"jpn": {
				"official": "フォークランド",
				"common": "フォークランド（マルビナス）諸島"
			},
			"nld": {
				"official": "Falkland eilanden",
				"common": "Falklandeilanden"
			},
			"por": {
				"official": "Ilhas Malvinas",
				"common": "Ilhas Malvinas"
			},
			"rus": {
				"official": "Фолклендские острова",
				"common": "Фолклендские острова"
			},
			"spa": {
				"official": "islas Malvinas",
				"common": "Islas Malvinas"
			},
			"svk": {
				"official": "Falklandské ostrovy",
				"common": "Falklandy"
			},
			"fin": {
				"official": "Falkandinsaaret",
				"common": "Falkandinsaaret"
			},
			"zho": {
				"official": "福克兰群岛",
				"common": "福克兰群岛"
			}
		},
		"latlng": [
			-51.75,
			-59
		],
		"demonym": "Falkland Islander",
		"landlocked": false,
		"borders": [],
		"area": 12173
	},
	{
		"name": {
			"common": "France",
			"official": "French Republic",
			"native": {
				"fra": {
					"official": "République française",
					"common": "France"
				}
			}
		},
		"tld": [
			".fr"
		],
		"cca2": "FR",
		"ccn3": "250",
		"cca3": "FRA",
		"cioc": "FRA",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"33"
		],
		"capital": "Paris",
		"altSpellings": [
			"FR",
			"French Republic",
			"République française"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Französische Republik",
				"common": "Frankreich"
			},
			"fra": {
				"official": "République française",
				"common": "France"
			},
			"hrv": {
				"official": "Francuska Republika",
				"common": "Francuska"
			},
			"ita": {
				"official": "Repubblica francese",
				"common": "Francia"
			},
			"jpn": {
				"official": "フランス共和国",
				"common": "フランス"
			},
			"nld": {
				"official": "Franse Republiek",
				"common": "Frankrijk"
			},
			"por": {
				"official": "República Francesa",
				"common": "França"
			},
			"rus": {
				"official": "Французская Республика",
				"common": "Франция"
			},
			"spa": {
				"official": "República francés",
				"common": "Francia"
			},
			"svk": {
				"official": "Francúzska republika",
				"common": "Francúzsko"
			},
			"fin": {
				"official": "Ranskan tasavalta",
				"common": "Ranska"
			},
			"zho": {
				"official": "法兰西共和国",
				"common": "法国"
			}
		},
		"latlng": [
			46,
			2
		],
		"demonym": "French",
		"landlocked": false,
		"borders": [
			"AND",
			"BEL",
			"DEU",
			"ITA",
			"LUX",
			"MCO",
			"ESP",
			"CHE"
		],
		"area": 551695
	},
	{
		"name": {
			"common": "Faroe Islands",
			"official": "Faroe Islands",
			"native": {
				"dan": {
					"official": "Færøerne",
					"common": "Færøerne"
				},
				"fao": {
					"official": "Føroyar",
					"common": "Føroyar"
				}
			}
		},
		"tld": [
			".fo"
		],
		"cca2": "FO",
		"ccn3": "234",
		"cca3": "FRO",
		"cioc": "",
		"currency": [
			"DKK"
		],
		"callingCode": [
			"298"
		],
		"capital": "Tórshavn",
		"altSpellings": [
			"FO",
			"Føroyar",
			"Færøerne"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"dan": "Danish",
			"fao": "Faroese"
		},
		"translations": {
			"deu": {
				"official": "Färöer",
				"common": "Färöer-Inseln"
			},
			"fra": {
				"official": "Îles Féroé",
				"common": "Îles Féroé"
			},
			"hrv": {
				"official": "Farski Otoci",
				"common": "Farski Otoci"
			},
			"ita": {
				"official": "Isole Faroe",
				"common": "Isole Far Oer"
			},
			"jpn": {
				"official": "フェロー諸島",
				"common": "フェロー諸島"
			},
			"nld": {
				"official": "Faeröer",
				"common": "Faeröer"
			},
			"por": {
				"official": "Ilhas Faroe",
				"common": "Ilhas Faroé"
			},
			"rus": {
				"official": "Фарерские острова",
				"common": "Фарерские острова"
			},
			"spa": {
				"official": "Islas Feroe",
				"common": "Islas Faroe"
			},
			"svk": {
				"official": "Faerské ostrovy",
				"common": "Faerské ostrovy"
			},
			"fin": {
				"official": "Färsaaret",
				"common": "Färsaaret"
			},
			"zho": {
				"official": "法罗群岛",
				"common": "法罗群岛"
			}
		},
		"latlng": [
			62,
			-7
		],
		"demonym": "Faroese",
		"landlocked": false,
		"borders": [],
		"area": 1393
	},
	{
		"name": {
			"common": "Micronesia",
			"official": "Federated States of Micronesia",
			"native": {
				"eng": {
					"official": "Federated States of Micronesia",
					"common": "Micronesia"
				}
			}
		},
		"tld": [
			".fm"
		],
		"cca2": "FM",
		"ccn3": "583",
		"cca3": "FSM",
		"cioc": "FSM",
		"currency": [
			"USD"
		],
		"callingCode": [
			"691"
		],
		"capital": "Palikir",
		"altSpellings": [
			"FM",
			"Federated States of Micronesia",
			"Micronesia, Federated States of"
		],
		"region": "Oceania",
		"subregion": "Micronesia",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Föderierte Staaten von Mikronesien",
				"common": "Mikronesien"
			},
			"fra": {
				"official": "États fédérés de Micronésie",
				"common": "Micronésie"
			},
			"hrv": {
				"official": "Savezne Države Mikronezije",
				"common": "Mikronezija"
			},
			"ita": {
				"official": "Stati federati di Micronesia",
				"common": "Micronesia"
			},
			"jpn": {
				"official": "ミクロネシア連邦",
				"common": "ミクロネシア連邦"
			},
			"nld": {
				"official": "Federale Staten van Micronesia",
				"common": "Micronesië"
			},
			"por": {
				"official": "Estados Federados da Micronésia",
				"common": "Micronésia"
			},
			"rus": {
				"official": "Федеративные Штаты Микронезии",
				"common": "Федеративные Штаты Микронезии"
			},
			"spa": {
				"official": "Estados Federados de Micronesia",
				"common": "Micronesia"
			},
			"svk": {
				"official": "Mikron/u00e9zske federatívne štáty",
				"common": "Mikronézia"
			},
			"fin": {
				"official": "Mikronesian liittovaltio",
				"common": "Mikronesia"
			},
			"zho": {
				"official": "密克罗尼西亚联邦",
				"common": "密克罗尼西亚"
			}
		},
		"latlng": [
			6.91666666,
			158.25
		],
		"demonym": "Micronesian",
		"landlocked": false,
		"borders": [],
		"area": 702
	},
	{
		"name": {
			"common": "Gabon",
			"official": "Gabonese Republic",
			"native": {
				"fra": {
					"official": "République gabonaise",
					"common": "Gabon"
				}
			}
		},
		"tld": [
			".ga"
		],
		"cca2": "GA",
		"ccn3": "266",
		"cca3": "GAB",
		"cioc": "GAB",
		"currency": [
			"XAF"
		],
		"callingCode": [
			"241"
		],
		"capital": "Libreville",
		"altSpellings": [
			"GA",
			"Gabonese Republic",
			"République Gabonaise"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Gabunische Republik",
				"common": "Gabun"
			},
			"fra": {
				"official": "République gabonaise",
				"common": "Gabon"
			},
			"hrv": {
				"official": "Gabon Republika",
				"common": "Gabon"
			},
			"ita": {
				"official": "Repubblica gabonese",
				"common": "Gabon"
			},
			"jpn": {
				"official": "ガボン共和国",
				"common": "ガボン"
			},
			"nld": {
				"official": "Republiek Gabon",
				"common": "Gabon"
			},
			"por": {
				"official": "República do Gabão",
				"common": "Gabão"
			},
			"rus": {
				"official": "Габона Республика",
				"common": "Габон"
			},
			"spa": {
				"official": "República de Gabón",
				"common": "Gabón"
			},
			"svk": {
				"official": "Gabonská republika",
				"common": "Gabon"
			},
			"fin": {
				"official": "Gabonin tasavalta",
				"common": "Gabon"
			},
			"zho": {
				"official": "加蓬共和国",
				"common": "加蓬"
			}
		},
		"latlng": [
			-1,
			11.75
		],
		"demonym": "Gabonese",
		"landlocked": false,
		"borders": [
			"CMR",
			"COG",
			"GNQ"
		],
		"area": 267668
	},
	{
		"name": {
			"common": "United Kingdom",
			"official": "United Kingdom of Great Britain and Northern Ireland",
			"native": {
				"eng": {
					"official": "United Kingdom of Great Britain and Northern Ireland",
					"common": "United Kingdom"
				}
			}
		},
		"tld": [
			".uk"
		],
		"cca2": "GB",
		"ccn3": "826",
		"cca3": "GBR",
		"cioc": "GBR",
		"currency": [
			"GBP"
		],
		"callingCode": [
			"44"
		],
		"capital": "London",
		"altSpellings": [
			"GB",
			"UK",
			"Great Britain"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Vereinigtes Königreich Großbritannien und Nordirland",
				"common": "Vereinigtes Königreich"
			},
			"fra": {
				"official": "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord",
				"common": "Royaume-Uni"
			},
			"hrv": {
				"official": "Ujedinjeno Kraljevstvo Velike Britanije i Sjeverne Irske",
				"common": "Ujedinjeno Kraljevstvo"
			},
			"ita": {
				"official": "Regno Unito di Gran Bretagna e Irlanda del Nord",
				"common": "Regno Unito"
			},
			"jpn": {
				"official": "グレート·ブリテンおよび北アイルランド連合王国",
				"common": "イギリス"
			},
			"nld": {
				"official": "Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland",
				"common": "Verenigd Koninkrijk"
			},
			"por": {
				"official": "Reino Unido da Grã-Bretanha e Irlanda do Norte",
				"common": "Reino Unido"
			},
			"rus": {
				"official": "Соединенное Королевство Великобритании и Северной Ирландии",
				"common": "Великобритания"
			},
			"spa": {
				"official": "Reino Unido de Gran Bretaña e Irlanda del Norte",
				"common": "Reino Unido"
			},
			"svk": {
				"official": "Spojené kráľovstvo Veľkej Británie a SevernéhoÌrska",
				"common": "Veľká Británia (Spojené kráľovstvo)"
			},
			"fin": {
				"official": "Ison-Britannian ja Pohjois-Irlannin yhdistynyt kuningaskunta",
				"common": "Yhdistynyt kuningaskunta"
			},
			"zho": {
				"official": "大不列颠及北爱尔兰联合王国",
				"common": "英国"
			}
		},
		"latlng": [
			54,
			-2
		],
		"demonym": "British",
		"landlocked": false,
		"borders": [
			"IRL"
		],
		"area": 242900
	},
	{
		"name": {
			"common": "Georgia",
			"official": "Georgia",
			"native": {
				"kat": {
					"official": "საქართველო",
					"common": "საქართველო"
				}
			}
		},
		"tld": [
			".ge"
		],
		"cca2": "GE",
		"ccn3": "268",
		"cca3": "GEO",
		"cioc": "GEO",
		"currency": [
			"GEL"
		],
		"callingCode": [
			"995"
		],
		"capital": "Tbilisi",
		"altSpellings": [
			"GE",
			"Sakartvelo"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"kat": "Georgian"
		},
		"translations": {
			"deu": {
				"official": "Georgia",
				"common": "Georgien"
			},
			"fra": {
				"official": "République de Géorgie",
				"common": "Géorgie"
			},
			"hrv": {
				"official": "Gruzija",
				"common": "Gruzija"
			},
			"ita": {
				"official": "Georgia",
				"common": "Georgia"
			},
			"jpn": {
				"official": "グルジア",
				"common": "グルジア"
			},
			"nld": {
				"official": "Georgia",
				"common": "Georgië"
			},
			"por": {
				"official": "Georgia",
				"common": "Geórgia"
			},
			"rus": {
				"official": "Грузия",
				"common": "Грузия"
			},
			"spa": {
				"official": "Georgia",
				"common": "Georgia"
			},
			"svk": {
				"official": "Gruzínsko",
				"common": "Gruzínsko"
			},
			"fin": {
				"official": "Georgia",
				"common": "Georgia"
			},
			"zho": {
				"official": "格鲁吉亚",
				"common": "格鲁吉亚"
			}
		},
		"latlng": [
			42,
			43.5
		],
		"demonym": "Georgian",
		"landlocked": false,
		"borders": [
			"ARM",
			"AZE",
			"RUS",
			"TUR"
		],
		"area": 69700
	},
	{
		"name": {
			"common": "Guernsey",
			"official": "Bailiwick of Guernsey",
			"native": {
				"eng": {
					"official": "Bailiwick of Guernsey",
					"common": "Guernsey"
				},
				"fra": {
					"official": "Bailliage de Guernesey",
					"common": "Guernesey"
				},
				"nfr": {
					"official": "Dgèrnésiais",
					"common": "Dgèrnésiais"
				}
			}
		},
		"tld": [
			".gg"
		],
		"cca2": "GG",
		"ccn3": "831",
		"cca3": "GGY",
		"cioc": "",
		"currency": [
			"GBP"
		],
		"callingCode": [
			"44"
		],
		"capital": "St. Peter Port",
		"altSpellings": [
			"GG",
			"Bailiwick of Guernsey",
			"Bailliage de Guernesey"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"eng": "English",
			"fra": "French",
			"nfr": "Guernésiais"
		},
		"translations": {
			"deu": {
				"official": "Guernsey",
				"common": "Guernsey"
			},
			"fra": {
				"official": "Bailliage de Guernesey",
				"common": "Guernesey"
			},
			"hrv": {
				"official": "Struka Guernsey",
				"common": "Guernsey"
			},
			"ita": {
				"official": "Baliato di Guernsey",
				"common": "Guernsey"
			},
			"jpn": {
				"official": "ガーンジーの得意分野",
				"common": "ガーンジー"
			},
			"nld": {
				"official": "Baljuwschap Guernsey",
				"common": "Guernsey"
			},
			"por": {
				"official": "Bailiado de Guernsey",
				"common": "Guernsey"
			},
			"rus": {
				"official": "Коронное владение Гернси",
				"common": "Гернси"
			},
			"spa": {
				"official": "Bailía de Guernsey",
				"common": "Guernsey"
			},
			"svk": {
				"official": "Guernsey",
				"common": "Guernsey"
			},
			"fin": {
				"official": "Guernsey",
				"common": "Guernsey"
			},
			"zho": {
				"official": "根西岛",
				"common": "根西岛"
			}
		},
		"latlng": [
			49.46666666,
			-2.58333333
		],
		"demonym": "Channel Islander",
		"landlocked": false,
		"borders": [],
		"area": 78
	},
	{
		"name": {
			"common": "Ghana",
			"official": "Republic of Ghana",
			"native": {
				"eng": {
					"official": "Republic of Ghana",
					"common": "Ghana"
				}
			}
		},
		"tld": [
			".gh"
		],
		"cca2": "GH",
		"ccn3": "288",
		"cca3": "GHA",
		"cioc": "GHA",
		"currency": [
			"GHS"
		],
		"callingCode": [
			"233"
		],
		"capital": "Accra",
		"altSpellings": [
			"GH"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Republik Ghana",
				"common": "Ghana"
			},
			"fra": {
				"official": "République du Ghana",
				"common": "Ghana"
			},
			"hrv": {
				"official": "Republika Gana",
				"common": "Gana"
			},
			"ita": {
				"official": "Repubblica del Ghana",
				"common": "Ghana"
			},
			"jpn": {
				"official": "ガーナ共和国",
				"common": "ガーナ"
			},
			"nld": {
				"official": "Republiek Ghana",
				"common": "Ghana"
			},
			"por": {
				"official": "República do Gana",
				"common": "Gana"
			},
			"rus": {
				"official": "Республика Гана",
				"common": "Гана"
			},
			"spa": {
				"official": "República de Ghana",
				"common": "Ghana"
			},
			"svk": {
				"official": " Ghansk/u00e1 republika",
				"common": "Ghana"
			},
			"fin": {
				"official": "Ghanan tasavalta",
				"common": "Ghana"
			},
			"zho": {
				"official": "加纳共和国",
				"common": "加纳"
			}
		},
		"latlng": [
			8,
			-2
		],
		"demonym": "Ghanaian",
		"landlocked": false,
		"borders": [
			"BFA",
			"CIV",
			"TGO"
		],
		"area": 238533
	},
	{
		"name": {
			"common": "Gibraltar",
			"official": "Gibraltar",
			"native": {
				"eng": {
					"official": "Gibraltar",
					"common": "Gibraltar"
				}
			}
		},
		"tld": [
			".gi"
		],
		"cca2": "GI",
		"ccn3": "292",
		"cca3": "GIB",
		"cioc": "",
		"currency": [
			"GIP"
		],
		"callingCode": [
			"350"
		],
		"capital": "Gibraltar",
		"altSpellings": [
			"GI"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Gibraltar",
				"common": "Gibraltar"
			},
			"fra": {
				"official": "Gibraltar",
				"common": "Gibraltar"
			},
			"hrv": {
				"official": "Gibraltar",
				"common": "Gibraltar"
			},
			"ita": {
				"official": "Gibilterra",
				"common": "Gibilterra"
			},
			"jpn": {
				"official": "ジブラルタル",
				"common": "ジブラルタル"
			},
			"nld": {
				"official": "Gibraltar",
				"common": "Gibraltar"
			},
			"por": {
				"official": "Gibraltar",
				"common": "Gibraltar"
			},
			"rus": {
				"official": "Гибралтар",
				"common": "Гибралтар"
			},
			"spa": {
				"official": "Gibraltar",
				"common": "Gibraltar"
			},
			"svk": {
				"official": " Gibraltár",
				"common": "Gibraltár"
			},
			"fin": {
				"official": "Gibraltar",
				"common": "Gibraltar"
			},
			"zho": {
				"official": "直布罗陀",
				"common": "直布罗陀"
			}
		},
		"latlng": [
			36.13333333,
			-5.35
		],
		"demonym": "Gibraltar",
		"landlocked": false,
		"borders": [
			"ESP"
		],
		"area": 6
	},
	{
		"name": {
			"common": "Guinea",
			"official": "Republic of Guinea",
			"native": {
				"fra": {
					"official": "République de Guinée",
					"common": "Guinée"
				}
			}
		},
		"tld": [
			".gn"
		],
		"cca2": "GN",
		"ccn3": "324",
		"cca3": "GIN",
		"cioc": "GUI",
		"currency": [
			"GNF"
		],
		"callingCode": [
			"224"
		],
		"capital": "Conakry",
		"altSpellings": [
			"GN",
			"Republic of Guinea",
			"République de Guinée"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Republik Guinea",
				"common": "Guinea"
			},
			"fra": {
				"official": "République de Guinée",
				"common": "Guinée"
			},
			"hrv": {
				"official": "Republika Gvineja",
				"common": "Gvineja"
			},
			"ita": {
				"official": "Repubblica di Guinea",
				"common": "Guinea"
			},
			"jpn": {
				"official": "ギニア共和国",
				"common": "ギニア"
			},
			"nld": {
				"official": "Republiek Guinee",
				"common": "Guinee"
			},
			"por": {
				"official": "República da Guiné",
				"common": "Guiné"
			},
			"rus": {
				"official": "Республика Гвинея",
				"common": "Гвинея"
			},
			"spa": {
				"official": "República de Guinea",
				"common": "Guinea"
			},
			"svk": {
				"official": "Guinejská republika",
				"common": "Guinea"
			},
			"fin": {
				"official": "Guinean tasavalta",
				"common": "Guinea"
			},
			"zho": {
				"official": "几内亚共和国",
				"common": "几内亚"
			}
		},
		"latlng": [
			11,
			-10
		],
		"demonym": "Guinean",
		"landlocked": false,
		"borders": [
			"CIV",
			"GNB",
			"LBR",
			"MLI",
			"SEN",
			"SLE"
		],
		"area": 245857
	},
	{
		"name": {
			"common": "Guadeloupe",
			"official": "Guadeloupe",
			"native": {
				"fra": {
					"official": "Guadeloupe",
					"common": "Guadeloupe"
				}
			}
		},
		"tld": [
			".gp"
		],
		"cca2": "GP",
		"ccn3": "312",
		"cca3": "GLP",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"590"
		],
		"capital": "Basse-Terre",
		"altSpellings": [
			"GP",
			"Gwadloup"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Guadeloupe",
				"common": "Guadeloupe"
			},
			"fra": {
				"official": "Guadeloupe",
				"common": "Guadeloupe"
			},
			"hrv": {
				"official": "Gvadalupa",
				"common": "Gvadalupa"
			},
			"ita": {
				"official": "Guadeloupe",
				"common": "Guadeloupa"
			},
			"jpn": {
				"official": "グアドループ島",
				"common": "グアドループ"
			},
			"nld": {
				"official": "Guadeloupe",
				"common": "Guadeloupe"
			},
			"por": {
				"official": "Guadalupe",
				"common": "Guadalupe"
			},
			"rus": {
				"official": "Гваделупа",
				"common": "Гваделупа"
			},
			"spa": {
				"official": "Guadalupe",
				"common": "Guadalupe"
			},
			"svk": {
				"official": "Guadeloupe",
				"common": "Guadeloupe"
			},
			"fin": {
				"official": "Guadeloupen departmentti",
				"common": "Guadeloupe"
			},
			"zho": {
				"official": "瓜德罗普岛",
				"common": "瓜德罗普岛"
			}
		},
		"latlng": [
			16.25,
			-61.583333
		],
		"demonym": "Guadeloupian",
		"landlocked": false,
		"borders": [],
		"area": 1628
	},
	{
		"name": {
			"common": "Gambia",
			"official": "Republic of the Gambia",
			"native": {
				"eng": {
					"official": "Republic of the Gambia",
					"common": "Gambia"
				}
			}
		},
		"tld": [
			".gm"
		],
		"cca2": "GM",
		"ccn3": "270",
		"cca3": "GMB",
		"cioc": "GAM",
		"currency": [
			"GMD"
		],
		"callingCode": [
			"220"
		],
		"capital": "Banjul",
		"altSpellings": [
			"GM",
			"Republic of the Gambia"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Republik Gambia",
				"common": "Gambia"
			},
			"fra": {
				"official": "République de Gambie",
				"common": "Gambie"
			},
			"hrv": {
				"official": "Republika Gambija",
				"common": "Gambija"
			},
			"ita": {
				"official": "Repubblica del Gambia",
				"common": "Gambia"
			},
			"jpn": {
				"official": "ガンビア共和国",
				"common": "ガンビア"
			},
			"nld": {
				"official": "Republiek Gambia",
				"common": "Gambia"
			},
			"por": {
				"official": "República da Gâmbia",
				"common": "Gâmbia"
			},
			"rus": {
				"official": "Республика Гамбия",
				"common": "Гамбия"
			},
			"spa": {
				"official": "República de Gambia",
				"common": "Gambia"
			},
			"svk": {
				"official": "Gambijsk/u00e1 republika",
				"common": "Gambia"
			},
			"fin": {
				"official": "Gambian tasavalta",
				"common": "Gambia"
			},
			"zho": {
				"official": "冈比亚共和国",
				"common": "冈比亚"
			}
		},
		"latlng": [
			13.46666666,
			-16.56666666
		],
		"demonym": "Gambian",
		"landlocked": false,
		"borders": [
			"SEN"
		],
		"area": 10689
	},
	{
		"name": {
			"common": "Guinea-Bissau",
			"official": "Republic of Guinea-Bissau",
			"native": {
				"por": {
					"official": "República da Guiné-Bissau",
					"common": "Guiné-Bissau"
				}
			}
		},
		"tld": [
			".gw"
		],
		"cca2": "GW",
		"ccn3": "624",
		"cca3": "GNB",
		"cioc": "GBS",
		"currency": [
			"XOF"
		],
		"callingCode": [
			"245"
		],
		"capital": "Bissau",
		"altSpellings": [
			"GW",
			"Republic of Guinea-Bissau",
			"República da Guiné-Bissau"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"por": "Portuguese"
		},
		"translations": {
			"deu": {
				"official": "Republik Guinea-Bissau",
				"common": "Guinea-Bissau"
			},
			"fra": {
				"official": "République de Guinée-Bissau",
				"common": "Guinée-Bissau"
			},
			"hrv": {
				"official": "Republika Gvineja Bisau",
				"common": "Gvineja Bisau"
			},
			"ita": {
				"official": "Repubblica di Guinea-Bissau",
				"common": "Guinea-Bissau"
			},
			"jpn": {
				"official": "ギニアビサウ共和国",
				"common": "ギニアビサウ"
			},
			"nld": {
				"official": "Republiek Guinee-Bissau",
				"common": "Guinee-Bissau"
			},
			"por": {
				"official": "República da Guiné-Bissau",
				"common": "Guiné-Bissau"
			},
			"rus": {
				"official": "Республика Гвинея -Бисау",
				"common": "Гвинея-Бисау"
			},
			"spa": {
				"official": "República de Guinea-Bissau",
				"common": "Guinea-Bisáu"
			},
			"svk": {
				"official": "Guinejsko-bissauská republika",
				"common": "Guinea-Bissau"
			},
			"fin": {
				"official": "Guinea-Bissaun tasavalta",
				"common": "Guinea-Bissau"
			},
			"zho": {
				"official": "几内亚比绍共和国",
				"common": "几内亚比绍"
			}
		},
		"latlng": [
			12,
			-15
		],
		"demonym": "Guinea-Bissauan",
		"landlocked": false,
		"borders": [
			"GIN",
			"SEN"
		],
		"area": 36125
	},
	{
		"name": {
			"common": "Equatorial Guinea",
			"official": "Republic of Equatorial Guinea",
			"native": {
				"fra": {
					"official": "République de la Guinée Équatoriale",
					"common": "Guinée équatoriale"
				},
				"por": {
					"official": "República da Guiné Equatorial",
					"common": "Guiné Equatorial"
				},
				"spa": {
					"official": "República de Guinea Ecuatorial",
					"common": "Guinea Ecuatorial"
				}
			}
		},
		"tld": [
			".gq"
		],
		"cca2": "GQ",
		"ccn3": "226",
		"cca3": "GNQ",
		"cioc": "GEQ",
		"currency": [
			"XAF"
		],
		"callingCode": [
			"240"
		],
		"capital": "Malabo",
		"altSpellings": [
			"GQ",
			"Republic of Equatorial Guinea",
			"República de Guinea Ecuatorial",
			"République de Guinée équatoriale",
			"República da Guiné Equatorial"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"fra": "French",
			"por": "Portuguese",
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Republic of Equatorial Guinea",
				"common": "Gini Gyhydeddol"
			},
			"deu": {
				"official": "Republik Äquatorialguinea",
				"common": "Äquatorialguinea"
			},
			"fra": {
				"official": "République de Guinée équatoriale",
				"common": "Guinée équatoriale"
			},
			"hrv": {
				"official": "Republika Ekvatorska Gvineja",
				"common": "Ekvatorijalna Gvineja"
			},
			"ita": {
				"official": "Repubblica della Guinea Equatoriale",
				"common": "Guinea Equatoriale"
			},
			"jpn": {
				"official": "赤道ギニア共和国",
				"common": "赤道ギニア"
			},
			"nld": {
				"official": "Republiek Equatoriaal-Guinea",
				"common": "Equatoriaal-Guinea"
			},
			"por": {
				"official": "República da Guiné Equatorial",
				"common": "Guiné Equatorial"
			},
			"rus": {
				"official": "Республика Экваториальная Гвинея",
				"common": "Экваториальная Гвинея"
			},
			"spa": {
				"official": "República de Guinea Ecuatorial",
				"common": "Guinea Ecuatorial"
			},
			"svk": {
				"official": "Republika rovníkovej Guiney",
				"common": "Rovníková Guinea"
			},
			"fin": {
				"official": "Päiväntasaajan Guinean tasavalta",
				"common": "Päiväntasaajan Guinea"
			},
			"zho": {
				"official": "赤道几内亚共和国",
				"common": "赤道几内亚"
			}
		},
		"latlng": [
			2,
			10
		],
		"demonym": "Equatorial Guinean",
		"landlocked": false,
		"borders": [
			"CMR",
			"GAB"
		],
		"area": 28051
	},
	{
		"name": {
			"common": "Greece",
			"official": "Hellenic Republic",
			"native": {
				"ell": {
					"official": "Ελληνική Δημοκρατία",
					"common": "Ελλάδα"
				}
			}
		},
		"tld": [
			".gr"
		],
		"cca2": "GR",
		"ccn3": "300",
		"cca3": "GRC",
		"cioc": "GRE",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"30"
		],
		"capital": "Athens",
		"altSpellings": [
			"GR",
			"Elláda",
			"Hellenic Republic",
			"Ελληνική Δημοκρατία"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"ell": "Greek"
		},
		"translations": {
			"deu": {
				"official": "Hellenische Republik",
				"common": "Griechenland"
			},
			"fra": {
				"official": "République hellénique",
				"common": "Grèce"
			},
			"hrv": {
				"official": "Helenska Republika",
				"common": "Grčka"
			},
			"ita": {
				"official": "Repubblica ellenica",
				"common": "Grecia"
			},
			"jpn": {
				"official": "ギリシャ共和国",
				"common": "ギリシャ"
			},
			"nld": {
				"official": "Helleense Republiek",
				"common": "Griekenland"
			},
			"por": {
				"official": "República Helénica",
				"common": "Grécia"
			},
			"rus": {
				"official": "Греческая Республика",
				"common": "Греция"
			},
			"spa": {
				"official": "República Helénica",
				"common": "Grecia"
			},
			"svk": {
				"official": "Grécka republika",
				"common": "Greécko"
			},
			"fin": {
				"official": "Helleenien tasavalta",
				"common": "Kreikka"
			},
			"zho": {
				"official": "希腊共和国",
				"common": "希腊"
			}
		},
		"latlng": [
			39,
			22
		],
		"demonym": "Greek",
		"landlocked": false,
		"borders": [
			"ALB",
			"BGR",
			"TUR",
			"MKD"
		],
		"area": 131990
	},
	{
		"name": {
			"common": "Grenada",
			"official": "Grenada",
			"native": {
				"eng": {
					"official": "Grenada",
					"common": "Grenada"
				}
			}
		},
		"tld": [
			".gd"
		],
		"cca2": "GD",
		"ccn3": "308",
		"cca3": "GRD",
		"cioc": "GRN",
		"currency": [
			"XCD"
		],
		"callingCode": [
			"1473"
		],
		"capital": "St. George's",
		"altSpellings": [
			"GD"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Grenada",
				"common": "Grenada"
			},
			"fra": {
				"official": "Grenade",
				"common": "Grenade"
			},
			"hrv": {
				"official": "Grenada",
				"common": "Grenada"
			},
			"ita": {
				"official": "Grenada",
				"common": "Grenada"
			},
			"jpn": {
				"official": "グレナダ",
				"common": "グレナダ"
			},
			"nld": {
				"official": "Grenada",
				"common": "Grenada"
			},
			"por": {
				"official": "Grenada",
				"common": "Granada"
			},
			"rus": {
				"official": "Гренада",
				"common": "Гренада"
			},
			"spa": {
				"official": "Granada",
				"common": "Grenada"
			},
			"svk": {
				"official": "Grenada",
				"common": "Grenada"
			},
			"fin": {
				"official": "Grenada",
				"common": "Grenada"
			},
			"zho": {
				"official": "格林纳达",
				"common": "格林纳达"
			}
		},
		"latlng": [
			12.11666666,
			-61.66666666
		],
		"demonym": "Grenadian",
		"landlocked": false,
		"borders": [],
		"area": 344
	},
	{
		"name": {
			"common": "Greenland",
			"official": "Greenland",
			"native": {
				"kal": {
					"official": "Kalaallit Nunaat",
					"common": "Kalaallit Nunaat"
				}
			}
		},
		"tld": [
			".gl"
		],
		"cca2": "GL",
		"ccn3": "304",
		"cca3": "GRL",
		"cioc": "",
		"currency": [
			"DKK"
		],
		"callingCode": [
			"299"
		],
		"capital": "Nuuk",
		"altSpellings": [
			"GL",
			"Grønland"
		],
		"region": "Americas",
		"subregion": "Northern America",
		"languages": {
			"kal": "Greenlandic"
		},
		"translations": {
			"deu": {
				"official": "Grönland",
				"common": "Grönland"
			},
			"fra": {
				"official": "Groenland",
				"common": "Groenland"
			},
			"hrv": {
				"official": "Grenland",
				"common": "Grenland"
			},
			"ita": {
				"official": "Groenlandia",
				"common": "Groenlandia"
			},
			"jpn": {
				"official": "グリーンランド",
				"common": "グリーンランド"
			},
			"nld": {
				"official": "Groenland",
				"common": "Groenland"
			},
			"por": {
				"official": "Groenlândia",
				"common": "Gronelândia"
			},
			"rus": {
				"official": "Гренландия",
				"common": "Гренландия"
			},
			"spa": {
				"official": "Groenlandia",
				"common": "Groenlandia"
			},
			"svk": {
				"official": "Grónsko",
				"common": "Grónsko"
			},
			"fin": {
				"official": "Groönlanti",
				"common": "Groönlanti"
			},
			"zho": {
				"official": "格陵兰",
				"common": "格陵兰"
			}
		},
		"latlng": [
			72,
			-40
		],
		"demonym": "Greenlandic",
		"landlocked": false,
		"borders": [],
		"area": 2166086
	},
	{
		"name": {
			"common": "Guatemala",
			"official": "Republic of Guatemala",
			"native": {
				"spa": {
					"official": "República de Guatemala",
					"common": "Guatemala"
				}
			}
		},
		"tld": [
			".gt"
		],
		"cca2": "GT",
		"ccn3": "320",
		"cca3": "GTM",
		"cioc": "GUA",
		"currency": [
			"GTQ"
		],
		"callingCode": [
			"502"
		],
		"capital": "Guatemala City",
		"altSpellings": [
			"GT"
		],
		"region": "Americas",
		"subregion": "Central America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Republik Guatemala",
				"common": "Guatemala"
			},
			"fra": {
				"official": "République du Guatemala",
				"common": "Guatemala"
			},
			"hrv": {
				"official": "Republika Gvatemala",
				"common": "Gvatemala"
			},
			"ita": {
				"official": "Repubblica del Guatemala",
				"common": "Guatemala"
			},
			"jpn": {
				"official": "グアテマラ共和国",
				"common": "グアテマラ"
			},
			"nld": {
				"official": "Republiek Guatemala",
				"common": "Guatemala"
			},
			"por": {
				"official": "República da Guatemala",
				"common": "Guatemala"
			},
			"rus": {
				"official": "Республика Гватемала",
				"common": "Гватемала"
			},
			"spa": {
				"official": "República de Guatemala",
				"common": "Guatemala"
			},
			"svk": {
				"official": "Guatemalská republika",
				"common": "Guatemala"
			},
			"fin": {
				"official": "Guatemalan tasavalta",
				"common": "Guatemala"
			},
			"zho": {
				"official": "危地马拉共和国",
				"common": "危地马拉"
			}
		},
		"latlng": [
			15.5,
			-90.25
		],
		"demonym": "Guatemalan",
		"landlocked": false,
		"borders": [
			"BLZ",
			"SLV",
			"HND",
			"MEX"
		],
		"area": 108889
	},
	{
		"name": {
			"common": "French Guiana",
			"official": "Guiana",
			"native": {
				"fra": {
					"official": "Guyanes",
					"common": "Guyane française"
				}
			}
		},
		"tld": [
			".gf"
		],
		"cca2": "GF",
		"ccn3": "254",
		"cca3": "GUF",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"594"
		],
		"capital": "Cayenne",
		"altSpellings": [
			"GF",
			"Guiana",
			"Guyane"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Guayana",
				"common": "Französisch Guyana"
			},
			"fra": {
				"official": "Guyane",
				"common": "Guyane"
			},
			"hrv": {
				"official": "Gijana",
				"common": "Francuska Gvajana"
			},
			"ita": {
				"official": "Guiana",
				"common": "Guyana francese"
			},
			"jpn": {
				"official": "ギアナ",
				"common": "フランス領ギアナ"
			},
			"nld": {
				"official": "Guyana",
				"common": "Frans-Guyana"
			},
			"por": {
				"official": "Guiana",
				"common": "Guiana Francesa"
			},
			"rus": {
				"official": "Гвиана",
				"common": "Французская Гвиана"
			},
			"spa": {
				"official": "Guayana",
				"common": "Guayana Francesa"
			},
			"svk": {
				"official": "Francúzska Guyana",
				"common": "Guyana"
			},
			"fin": {
				"official": "Ranskan Guayana",
				"common": "Ranskan Guayana"
			},
			"zho": {
				"official": "法属圭亚那",
				"common": "法属圭亚那"
			}
		},
		"latlng": [
			4,
			-53
		],
		"demonym": "",
		"landlocked": false,
		"borders": [
			"BRA",
			"SUR"
		],
		"area": 83534
	},
	{
		"name": {
			"common": "Guam",
			"official": "Guam",
			"native": {
				"cha": {
					"official": "Guåhån",
					"common": "Guåhån"
				},
				"eng": {
					"official": "Guam",
					"common": "Guam"
				},
				"spa": {
					"official": "Guam",
					"common": "Guam"
				}
			}
		},
		"tld": [
			".gu"
		],
		"cca2": "GU",
		"ccn3": "316",
		"cca3": "GUM",
		"cioc": "GUM",
		"currency": [
			"USD"
		],
		"callingCode": [
			"1671"
		],
		"capital": "Hagåtña",
		"altSpellings": [
			"GU",
			"Guåhån"
		],
		"region": "Oceania",
		"subregion": "Micronesia",
		"languages": {
			"cha": "Chamorro",
			"eng": "English",
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Guam",
				"common": "Guam"
			},
			"fra": {
				"official": "Guam",
				"common": "Guam"
			},
			"hrv": {
				"official": "Guam",
				"common": "Guam"
			},
			"ita": {
				"official": "Guam",
				"common": "Guam"
			},
			"jpn": {
				"official": "グアム",
				"common": "グアム"
			},
			"nld": {
				"official": "Guam",
				"common": "Guam"
			},
			"por": {
				"official": "Guam",
				"common": "Guam"
			},
			"rus": {
				"official": "Гуам",
				"common": "Гуам"
			},
			"spa": {
				"official": "Guam",
				"common": "Guam"
			},
			"svk": {
				"official": "Guam",
				"common": "Guam"
			},
			"fin": {
				"official": "Guam",
				"common": "Guam"
			},
			"zho": {
				"official": "关岛",
				"common": "关岛"
			}
		},
		"latlng": [
			13.46666666,
			144.78333333
		],
		"demonym": "Guamanian",
		"landlocked": false,
		"borders": [],
		"area": 549
	},
	{
		"name": {
			"common": "Guyana",
			"official": "Co-operative Republic of Guyana",
			"native": {
				"eng": {
					"official": "Co-operative Republic of Guyana",
					"common": "Guyana"
				}
			}
		},
		"tld": [
			".gy"
		],
		"cca2": "GY",
		"ccn3": "328",
		"cca3": "GUY",
		"cioc": "GUY",
		"currency": [
			"GYD"
		],
		"callingCode": [
			"592"
		],
		"capital": "Georgetown",
		"altSpellings": [
			"GY",
			"Co-operative Republic of Guyana"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Kooperative Republik Guyana",
				"common": "Guyana"
			},
			"fra": {
				"official": "République coopérative de Guyana",
				"common": "Guyana"
			},
			"hrv": {
				"official": "Zadruga Republika Gvajana",
				"common": "Gvajana"
			},
			"ita": {
				"official": "Co -operative Republic of Guyana",
				"common": "Guyana"
			},
			"jpn": {
				"official": "ガイアナの協同共和国",
				"common": "ガイアナ"
			},
			"nld": {
				"official": "Coöperatieve Republiek Guyana",
				"common": "Guyana"
			},
			"por": {
				"official": "Co -operative República da Guiana",
				"common": "Guiana"
			},
			"rus": {
				"official": "Кооперативная Республика Гайана",
				"common": "Гайана"
			},
			"spa": {
				"official": "República Cooperativa de Guyana",
				"common": "Guyana"
			},
			"svk": {
				"official": "Guyanská kooperatívna republika",
				"common": "Guyana"
			},
			"fin": {
				"official": "Guayanan osuustoiminnallinen tasavalta",
				"common": "Guayana"
			},
			"zho": {
				"official": "圭亚那共和国",
				"common": "圭亚那"
			}
		},
		"latlng": [
			5,
			-59
		],
		"demonym": "Guyanese",
		"landlocked": false,
		"borders": [
			"BRA",
			"SUR",
			"VEN"
		],
		"area": 214969
	},
	{
		"name": {
			"common": "Hong Kong",
			"official": "Hong Kong Special Administrative Region of the People's Republic of China",
			"native": {
				"eng": {
					"official": "Hong Kong Special Administrative Region of the People's Republic of China",
					"common": "Hong Kong"
				},
				"zho": {
					"official": "中华人民共和国香港特别行政区",
					"common": "香港"
				}
			}
		},
		"tld": [
			".hk",
			".香港"
		],
		"cca2": "HK",
		"ccn3": "344",
		"cca3": "HKG",
		"cioc": "HKG",
		"currency": [
			"HKD"
		],
		"callingCode": [
			"852"
		],
		"capital": "City of Victoria",
		"altSpellings": [
			"HK"
		],
		"region": "Asia",
		"subregion": "Eastern Asia",
		"languages": {
			"eng": "English",
			"zho": "Chinese"
		},
		"translations": {
			"deu": {
				"official": "Sonderverwaltungszone der Volksrepublik China",
				"common": "Hongkong"
			},
			"fra": {
				"official": "Région administrative spéciale de Hong Kong de la République populaire de Chine",
				"common": "Hong Kong"
			},
			"hrv": {
				"official": "Hong Kong Posebnog upravnog područjaNarodne Republike Kine",
				"common": "Hong Kong"
			},
			"ita": {
				"official": "Hong Kong Regione amministrativa speciale della Repubblica Popolare Cinese",
				"common": "Hong Kong"
			},
			"jpn": {
				"official": "中華人民共和国香港特別行政区",
				"common": "香港"
			},
			"nld": {
				"official": "Hong Kong Speciale Administratieve Regio van de Volksrepubliek China",
				"common": "Hongkong"
			},
			"por": {
				"official": "Hong Kong Região Administrativa Especial da República Popular da China",
				"common": "Hong Kong"
			},
			"rus": {
				"official": "Hong Kong Специальный административный район Китайской Народной Республики Китая",
				"common": "Гонконг"
			},
			"spa": {
				"official": "Hong Kong Región Administrativa Especial de la República Popular China",
				"common": "Hong Kong"
			},
			"svk": {
				"official": "Špeciálna administratívna oblasťČínskej ľudovej republiky Hongkong",
				"common": "Hongkong"
			},
			"fin": {
				"official": "Hong Kongin erityishallintoalue",
				"common": "Hongkong"
			}
		},
		"latlng": [
			22.267,
			114.188
		],
		"demonym": "Hong Konger",
		"landlocked": false,
		"borders": [
			"CHN"
		],
		"area": 1104
	},
	{
		"name": {
			"common": "Heard Island and McDonald Islands",
			"official": "Heard Island and McDonald Islands",
			"native": {
				"eng": {
					"official": "Heard Island and McDonald Islands",
					"common": "Heard Island and McDonald Islands"
				}
			}
		},
		"tld": [
			".hm",
			".aq"
		],
		"cca2": "HM",
		"ccn3": "334",
		"cca3": "HMD",
		"cioc": "",
		"currency": [
			"AUD"
		],
		"callingCode": [],
		"capital": "",
		"altSpellings": [
			"HM",
			"Heard Island and McDonald Islands"
		],
		"region": "",
		"subregion": "",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Heard und McDonaldinseln",
				"common": "Heard und die McDonaldinseln"
			},
			"fra": {
				"official": "Des îles Heard et McDonald",
				"common": "Îles Heard-et-MacDonald"
			},
			"hrv": {
				"official": "Otok Heard i otočje McDonald",
				"common": "Otok Heard i otočje McDonald"
			},
			"ita": {
				"official": "Isole Heard e McDonald",
				"common": "Isole Heard e McDonald"
			},
			"jpn": {
				"official": "ハード島とマクドナルド諸島",
				"common": "ハード島とマクドナルド諸島"
			},
			"nld": {
				"official": "Heard en McDonaldeilanden",
				"common": "Heard-en McDonaldeilanden"
			},
			"por": {
				"official": "Ilha Heard e Ilhas McDonald",
				"common": "Ilha Heard e Ilhas McDonald"
			},
			"rus": {
				"official": "Остров Херд и острова Макдональд",
				"common": "Остров Херд и острова Макдональд"
			},
			"spa": {
				"official": "Islas Heard y McDonald",
				"common": "Islas Heard y McDonald"
			},
			"svk": {
				"official": "Teritórium Heardovho ostrova a Macdonaldových ostrovov",
				"common": "Heardov ostrov"
			},
			"fin": {
				"official": "Heard ja McDonaldinsaaret",
				"common": "Heard ja McDonaldinsaaret"
			},
			"zho": {
				"official": "赫德岛和麦当劳群岛",
				"common": "赫德岛和麦当劳群岛"
			}
		},
		"latlng": [
			-53.1,
			72.51666666
		],
		"demonym": "Heard and McDonald Islander",
		"landlocked": false,
		"borders": [],
		"area": 412
	},
	{
		"name": {
			"common": "Honduras",
			"official": "Republic of Honduras",
			"native": {
				"spa": {
					"official": "República de Honduras",
					"common": "Honduras"
				}
			}
		},
		"tld": [
			".hn"
		],
		"cca2": "HN",
		"ccn3": "340",
		"cca3": "HND",
		"cioc": "HON",
		"currency": [
			"HNL"
		],
		"callingCode": [
			"504"
		],
		"capital": "Tegucigalpa",
		"altSpellings": [
			"HN",
			"Republic of Honduras",
			"República de Honduras"
		],
		"region": "Americas",
		"subregion": "Central America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Republik Honduras",
				"common": "Honduras"
			},
			"fra": {
				"official": "République du Honduras",
				"common": "Honduras"
			},
			"hrv": {
				"official": "Republika Honduras",
				"common": "Honduras"
			},
			"ita": {
				"official": "Repubblica di Honduras",
				"common": "Honduras"
			},
			"jpn": {
				"official": "ホンジュラス共和国",
				"common": "ホンジュラス"
			},
			"nld": {
				"official": "Republiek Honduras",
				"common": "Honduras"
			},
			"por": {
				"official": "República de Honduras",
				"common": "Honduras"
			},
			"rus": {
				"official": "Республика Гондурас",
				"common": "Гондурас"
			},
			"spa": {
				"official": "República de Honduras",
				"common": "Honduras"
			},
			"fin": {
				"official": "Hondurasin tasavalta",
				"common": "Honduras"
			},
			"svk": {
				"official": "Honduraská republika",
				"common": "Honduras"
			},
			"zho": {
				"official": "洪都拉斯共和国",
				"common": "洪都拉斯"
			}
		},
		"latlng": [
			15,
			-86.5
		],
		"demonym": "Honduran",
		"landlocked": false,
		"borders": [
			"GTM",
			"SLV",
			"NIC"
		],
		"area": 112492
	},
	{
		"name": {
			"common": "Croatia",
			"official": "Republic of Croatia",
			"native": {
				"hrv": {
					"official": "Republika Hrvatska",
					"common": "Hrvatska"
				}
			}
		},
		"tld": [
			".hr"
		],
		"cca2": "HR",
		"ccn3": "191",
		"cca3": "HRV",
		"cioc": "CRO",
		"currency": [
			"HRK"
		],
		"callingCode": [
			"385"
		],
		"capital": "Zagreb",
		"altSpellings": [
			"HR",
			"Hrvatska",
			"Republic of Croatia",
			"Republika Hrvatska"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"hrv": "Croatian"
		},
		"translations": {
			"cym": {
				"official": "Republic of Croatia",
				"common": "Croatia"
			},
			"deu": {
				"official": "Republik Kroatien",
				"common": "Kroatien"
			},
			"fra": {
				"official": "République de Croatie",
				"common": "Croatie"
			},
			"hrv": {
				"official": "Republika Hrvatska",
				"common": "Hrvatska"
			},
			"ita": {
				"official": "Repubblica di Croazia",
				"common": "Croazia"
			},
			"jpn": {
				"official": "クロアチア共和国",
				"common": "クロアチア"
			},
			"nld": {
				"official": "Republiek Kroatië",
				"common": "Kroatië"
			},
			"por": {
				"official": "República da Croácia",
				"common": "Croácia"
			},
			"rus": {
				"official": "Республика Хорватия",
				"common": "Хорватия"
			},
			"spa": {
				"official": "República de Croacia",
				"common": "Croacia"
			},
			"svk": {
				"official": "Chorvátska republika",
				"common": "Chorvátsko"
			},
			"fin": {
				"official": "Kroatian tasavalta",
				"common": "Kroatia"
			},
			"zho": {
				"official": "克罗地亚共和国",
				"common": "克罗地亚"
			}
		},
		"latlng": [
			45.16666666,
			15.5
		],
		"demonym": "Croatian",
		"landlocked": false,
		"borders": [
			"BIH",
			"HUN",
			"MNE",
			"SRB",
			"SVN"
		],
		"area": 56594
	},
	{
		"name": {
			"common": "Haiti",
			"official": "Republic of Haiti",
			"native": {
				"fra": {
					"official": "République d'Haïti",
					"common": "Haïti"
				},
				"hat": {
					"official": "Repiblik Ayiti",
					"common": "Ayiti"
				}
			}
		},
		"tld": [
			".ht"
		],
		"cca2": "HT",
		"ccn3": "332",
		"cca3": "HTI",
		"cioc": "HAI",
		"currency": [
			"HTG",
			"USD"
		],
		"callingCode": [
			"509"
		],
		"capital": "Port-au-Prince",
		"altSpellings": [
			"HT",
			"Republic of Haiti",
			"République d'Haïti",
			"Repiblik Ayiti"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"fra": "French",
			"hat": "Haitian Creole"
		},
		"translations": {
			"deu": {
				"official": "Republik Haiti",
				"common": "Haiti"
			},
			"fra": {
				"official": "République d'Haïti",
				"common": "Haïti"
			},
			"hrv": {
				"official": "Republika Haiti",
				"common": "Haiti"
			},
			"ita": {
				"official": "Repubblica di Haiti",
				"common": "Haiti"
			},
			"jpn": {
				"official": "ハイチ共和国",
				"common": "ハイチ"
			},
			"nld": {
				"official": "Republiek Haïti",
				"common": "Haïti"
			},
			"por": {
				"official": "República do Haiti",
				"common": "Haiti"
			},
			"rus": {
				"official": "Республика Гаити",
				"common": "Гаити"
			},
			"spa": {
				"official": "República de Haití",
				"common": "Haiti"
			},
			"svk": {
				"official": "Haitská republika",
				"common": "Haiti"
			},
			"fin": {
				"official": "Haitin tasavalta",
				"common": "Haiti"
			},
			"zho": {
				"official": "海地共和国",
				"common": "海地"
			}
		},
		"latlng": [
			19,
			-72.41666666
		],
		"demonym": "Haitian",
		"landlocked": false,
		"borders": [
			"DOM"
		],
		"area": 27750
	},
	{
		"name": {
			"common": "Hungary",
			"official": "Hungary",
			"native": {
				"hun": {
					"official": "Magyarország",
					"common": "Magyarország"
				}
			}
		},
		"tld": [
			".hu"
		],
		"cca2": "HU",
		"ccn3": "348",
		"cca3": "HUN",
		"cioc": "HUN",
		"currency": [
			"HUF"
		],
		"callingCode": [
			"36"
		],
		"capital": "Budapest",
		"altSpellings": [
			"HU"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"hun": "Hungarian"
		},
		"translations": {
			"deu": {
				"official": "Ungarn",
				"common": "Ungarn"
			},
			"fra": {
				"official": "Hongrie",
				"common": "Hongrie"
			},
			"hrv": {
				"official": "Madžarska",
				"common": "Mađarska"
			},
			"ita": {
				"official": "Ungheria",
				"common": "Ungheria"
			},
			"jpn": {
				"official": "ハンガリー",
				"common": "ハンガリー"
			},
			"nld": {
				"official": "Hongarije",
				"common": "Hongarije"
			},
			"por": {
				"official": "Hungria",
				"common": "Hungria"
			},
			"rus": {
				"official": "Венгрия",
				"common": "Венгрия"
			},
			"spa": {
				"official": "Hungría",
				"common": "Hungría"
			},
			"svk": {
				"official": "Maďarsko",
				"common": "Maďarsko"
			},
			"fin": {
				"official": "Unkari",
				"common": "Unkari"
			},
			"zho": {
				"official": "匈牙利",
				"common": "匈牙利"
			}
		},
		"latlng": [
			47,
			20
		],
		"demonym": "Hungarian",
		"landlocked": true,
		"borders": [
			"AUT",
			"HRV",
			"ROU",
			"SRB",
			"SVK",
			"SVN",
			"UKR"
		],
		"area": 93028
	},
	{
		"name": {
			"common": "Indonesia",
			"official": "Republic of Indonesia",
			"native": {
				"ind": {
					"official": "Republik Indonesia",
					"common": "Indonesia"
				}
			}
		},
		"tld": [
			".id"
		],
		"cca2": "ID",
		"ccn3": "360",
		"cca3": "IDN",
		"cioc": "INA",
		"currency": [
			"IDR"
		],
		"callingCode": [
			"62"
		],
		"capital": "Jakarta",
		"altSpellings": [
			"ID",
			"Republic of Indonesia",
			"Republik Indonesia"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"ind": "Indonesian"
		},
		"translations": {
			"deu": {
				"official": "Republik Indonesien",
				"common": "Indonesien"
			},
			"fra": {
				"official": "République d'Indonésie",
				"common": "Indonésie"
			},
			"hrv": {
				"official": "Republika Indonezija",
				"common": "Indonezija"
			},
			"ita": {
				"official": "Repubblica di Indonesia",
				"common": "Indonesia"
			},
			"jpn": {
				"official": "インドネシア共和国",
				"common": "インドネシア"
			},
			"nld": {
				"official": "Republiek Indonesië",
				"common": "Indonesië"
			},
			"por": {
				"official": "República da Indonésia",
				"common": "Indonésia"
			},
			"rus": {
				"official": "Республика Индонезия",
				"common": "Индонезия"
			},
			"spa": {
				"official": "República de Indonesia",
				"common": "Indonesia"
			},
			"svk": {
				"official": "Indonézska republika",
				"common": "Indonézia"
			},
			"fin": {
				"official": "Indonesian tasavalta",
				"common": "Indonesia"
			},
			"zho": {
				"official": "印度尼西亚共和国",
				"common": "印度尼西亚"
			}
		},
		"latlng": [
			-5,
			120
		],
		"demonym": "Indonesian",
		"landlocked": false,
		"borders": [
			"TLS",
			"MYS",
			"PNG"
		],
		"area": 1904569
	},
	{
		"name": {
			"common": "Isle of Man",
			"official": "Isle of Man",
			"native": {
				"eng": {
					"official": "Isle of Man",
					"common": "Isle of Man"
				},
				"glv": {
					"official": "Ellan Vannin or Mannin",
					"common": "Mannin"
				}
			}
		},
		"tld": [
			".im"
		],
		"cca2": "IM",
		"ccn3": "833",
		"cca3": "IMN",
		"cioc": "",
		"currency": [
			"GBP"
		],
		"callingCode": [
			"44"
		],
		"capital": "Douglas",
		"altSpellings": [
			"IM",
			"Ellan Vannin",
			"Mann",
			"Mannin"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"eng": "English",
			"glv": "Manx"
		},
		"translations": {
			"deu": {
				"official": "Isle of Man",
				"common": "Insel Man"
			},
			"fra": {
				"official": "Isle of Man",
				"common": "Île de Man"
			},
			"hrv": {
				"official": "Mana ostrvo",
				"common": "Otok Man"
			},
			"ita": {
				"official": "Isola di Man",
				"common": "Isola di Man"
			},
			"jpn": {
				"official": "マン島",
				"common": "マン島"
			},
			"nld": {
				"official": "Isle of Man",
				"common": "Isle of Man"
			},
			"por": {
				"official": "Isle of Man",
				"common": "Ilha de Man"
			},
			"rus": {
				"official": "Остров Мэн",
				"common": "Остров Мэн"
			},
			"spa": {
				"official": "Isla de Man",
				"common": "Isla de Man"
			},
			"svk": {
				"official": "Ostrov Man",
				"common": "Man"
			},
			"fin": {
				"official": "Mansaari",
				"common": "Mansaari"
			},
			"zho": {
				"official": "马恩岛",
				"common": "马恩岛"
			}
		},
		"latlng": [
			54.25,
			-4.5
		],
		"demonym": "Manx",
		"landlocked": false,
		"borders": [],
		"area": 572
	},
	{
		"name": {
			"common": "India",
			"official": "Republic of India",
			"native": {
				"eng": {
					"official": "Republic of India",
					"common": "India"
				},
				"hin": {
					"official": "भारत गणराज्य",
					"common": "भारत"
				},
				"tam": {
					"official": "இந்தியக் குடியரசு",
					"common": "இந்தியா"
				}
			}
		},
		"tld": [
			".in"
		],
		"cca2": "IN",
		"ccn3": "356",
		"cca3": "IND",
		"cioc": "IND",
		"currency": [
			"INR"
		],
		"callingCode": [
			"91"
		],
		"capital": "New Delhi",
		"altSpellings": [
			"IN",
			"Bhārat",
			"Republic of India",
			"Bharat Ganrajya",
			"இந்தியா"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"eng": "English",
			"hin": "Hindi",
			"tam": "Tamil"
		},
		"translations": {
			"deu": {
				"official": "Republik Indien",
				"common": "Indien"
			},
			"fra": {
				"official": "République de l'Inde",
				"common": "Inde"
			},
			"hrv": {
				"official": "Republika Indija",
				"common": "Indija"
			},
			"ita": {
				"official": "Repubblica dell'India",
				"common": "India"
			},
			"jpn": {
				"official": "インド共和国",
				"common": "インド"
			},
			"nld": {
				"official": "Republiek India",
				"common": "India"
			},
			"por": {
				"official": "República da Índia",
				"common": "Índia"
			},
			"rus": {
				"official": "Республика Индия",
				"common": "Индия"
			},
			"spa": {
				"official": "República de la India",
				"common": "India"
			},
			"svk": {
				"official": "Indická republika",
				"common": "India"
			},
			"fin": {
				"official": "Intian tasavalta",
				"common": "Intia"
			},
			"zho": {
				"official": "印度共和国",
				"common": "印度"
			}
		},
		"latlng": [
			20,
			77
		],
		"demonym": "Indian",
		"landlocked": false,
		"borders": [
			"AFG",
			"BGD",
			"BTN",
			"MMR",
			"CHN",
			"NPL",
			"PAK",
			"LKA"
		],
		"area": 3287590
	},
	{
		"name": {
			"common": "British Indian Ocean Territory",
			"official": "British Indian Ocean Territory",
			"native": {
				"eng": {
					"official": "British Indian Ocean Territory",
					"common": "British Indian Ocean Territory"
				}
			}
		},
		"tld": [
			".io"
		],
		"cca2": "IO",
		"ccn3": "086",
		"cca3": "IOT",
		"cioc": "",
		"currency": [
			"USD"
		],
		"callingCode": [
			"246"
		],
		"capital": "Diego Garcia",
		"altSpellings": [
			"IO"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"cym": {
				"official": "British Indian Ocean Territory",
				"common": "Tiriogaeth Brydeinig Cefnfor India"
			},
			"deu": {
				"official": "Britisch-Indischer Ozean",
				"common": "Britisches Territorium im Indischen Ozean"
			},
			"fra": {
				"official": "Territoire britannique de l' océan Indien",
				"common": "Territoire britannique de l'océan Indien"
			},
			"hrv": {
				"official": "British Indian Ocean Territory",
				"common": "Britanski Indijskooceanski teritorij"
			},
			"ita": {
				"official": "Territorio britannico dell'Oceano Indiano",
				"common": "Territorio britannico dell'oceano indiano"
			},
			"jpn": {
				"official": "イギリス領インド洋地域",
				"common": "イギリス領インド洋地域"
			},
			"nld": {
				"official": "Brits Indische Oceaan Territorium",
				"common": "Britse Gebieden in de Indische Oceaan"
			},
			"por": {
				"official": "British Indian Ocean Territory",
				"common": "Território Britânico do Oceano Índico"
			},
			"rus": {
				"official": "Британская территория Индийского океана",
				"common": "Британская территория в Индийском океане"
			},
			"spa": {
				"official": "Territorio Británico del Océano Índico",
				"common": "Territorio Británico del Océano Índico"
			},
			"svk": {
				"official": "Britské indickooceánske územie",
				"common": "Britské indickooceánske územie"
			},
			"fin": {
				"official": "Brittiläinen Intian valtameren alue",
				"common": "Brittiläinen Intian valtameren alue"
			},
			"zho": {
				"official": "英属印度洋领地",
				"common": "英属印度洋领地"
			}
		},
		"latlng": [
			-6,
			71.5
		],
		"demonym": "Indian",
		"landlocked": false,
		"borders": [],
		"area": 60
	},
	{
		"name": {
			"common": "Ireland",
			"official": "Republic of Ireland",
			"native": {
				"eng": {
					"official": "Republic of Ireland",
					"common": "Ireland"
				},
				"gle": {
					"official": "Poblacht na hÉireann",
					"common": "Éire"
				}
			}
		},
		"tld": [
			".ie"
		],
		"cca2": "IE",
		"ccn3": "372",
		"cca3": "IRL",
		"cioc": "IRL",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"353"
		],
		"capital": "Dublin",
		"altSpellings": [
			"IE",
			"Éire",
			"Republic of Ireland",
			"Poblacht na hÉireann"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"eng": "English",
			"gle": "Irish"
		},
		"translations": {
			"deu": {
				"official": "Republik Irland",
				"common": "Irland"
			},
			"fra": {
				"official": "République d'Irlande",
				"common": "Irlande"
			},
			"hrv": {
				"official": "Republika Irska",
				"common": "Irska"
			},
			"ita": {
				"official": "Repubblica d'Irlanda",
				"common": "Irlanda"
			},
			"jpn": {
				"official": "アイルランド共和国",
				"common": "アイルランド"
			},
			"nld": {
				"official": "Republic of Ireland",
				"common": "Ierland"
			},
			"por": {
				"official": "República da Irlanda",
				"common": "Irlanda"
			},
			"rus": {
				"official": "Ирландия",
				"common": "Ирландия"
			},
			"spa": {
				"official": "República de Irlanda",
				"common": "Irlanda"
			},
			"svk": {
				"official": "Írska republika",
				"common": "Írsko"
			},
			"fin": {
				"official": "Irlannin tasavalta",
				"common": "Irlanti"
			},
			"zho": {
				"official": "爱尔兰共和国",
				"common": "爱尔兰"
			}
		},
		"latlng": [
			53,
			-8
		],
		"demonym": "Irish",
		"landlocked": false,
		"borders": [
			"GBR"
		],
		"area": 70273
	},
	{
		"name": {
			"common": "Iran",
			"official": "Islamic Republic of Iran",
			"native": {
				"fas": {
					"official": "جمهوری اسلامی ایران",
					"common": "ایران"
				}
			}
		},
		"tld": [
			".ir",
			"ایران."
		],
		"cca2": "IR",
		"ccn3": "364",
		"cca3": "IRN",
		"cioc": "IRI",
		"currency": [
			"IRR"
		],
		"callingCode": [
			"98"
		],
		"capital": "Tehran",
		"altSpellings": [
			"IR",
			"Islamic Republic of Iran",
			"Iran, Islamic Republic of",
			"Jomhuri-ye Eslāmi-ye Irān"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"fas": "Persian"
		},
		"translations": {
			"deu": {
				"official": "Islamische Republik Iran",
				"common": "Iran"
			},
			"fra": {
				"official": "République islamique d'Iran",
				"common": "Iran"
			},
			"hrv": {
				"official": "Islamska Republika Iran",
				"common": "Iran"
			},
			"ita": {
				"official": "Repubblica islamica dell'Iran",
				"common": "Iran"
			},
			"jpn": {
				"official": "イラン·イスラム共和国",
				"common": "イラン・イスラム共和国"
			},
			"nld": {
				"official": "Islamitische Republiek Iran",
				"common": "Iran"
			},
			"por": {
				"official": "República Islâmica do Irã",
				"common": "Irão"
			},
			"rus": {
				"official": "Исламская Республика Иран",
				"common": "Иран"
			},
			"spa": {
				"official": "República Islámica de Irán",
				"common": "Iran"
			},
			"svk": {
				"official": "Iránska islamská republika",
				"common": "Irán"
			},
			"fin": {
				"official": "Iranin islamilainen tasavalta",
				"common": "Iran"
			},
			"zho": {
				"official": "伊朗伊斯兰共和国",
				"common": "伊朗"
			}
		},
		"latlng": [
			32,
			53
		],
		"demonym": "Iranian",
		"landlocked": false,
		"borders": [
			"AFG",
			"ARM",
			"AZE",
			"IRQ",
			"PAK",
			"TUR",
			"TKM"
		],
		"area": 1648195
	},
	{
		"name": {
			"common": "Iraq",
			"official": "Republic of Iraq",
			"native": {
				"ara": {
					"official": "جمهورية العراق",
					"common": "العراق"
				},
				"arc": {
					"official": "ܩܘܼܛܢܵܐ ܐܝܼܪܲܩ",
					"common": "ܩܘܼܛܢܵܐ"
				},
				"ckb": {
					"official": "کۆماری عێراق",
					"common": "کۆماری"
				}
			}
		},
		"tld": [
			".iq"
		],
		"cca2": "IQ",
		"ccn3": "368",
		"cca3": "IRQ",
		"cioc": "IRQ",
		"currency": [
			"IQD"
		],
		"callingCode": [
			"964"
		],
		"capital": "Baghdad",
		"altSpellings": [
			"IQ",
			"Republic of Iraq",
			"Jumhūriyyat al-‘Irāq"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic",
			"arc": "Aramaic",
			"ckb": "Sorani"
		},
		"translations": {
			"deu": {
				"official": "Republik Irak",
				"common": "Irak"
			},
			"fra": {
				"official": "République d'Irak",
				"common": "Irak"
			},
			"hrv": {
				"official": "Republika Irak",
				"common": "Irak"
			},
			"ita": {
				"official": "Repubblica dell'Iraq",
				"common": "Iraq"
			},
			"jpn": {
				"official": "イラク共和国",
				"common": "イラク"
			},
			"nld": {
				"official": "Republiek Irak",
				"common": "Irak"
			},
			"por": {
				"official": "República do Iraque",
				"common": "Iraque"
			},
			"rus": {
				"official": "Республика Ирак",
				"common": "Ирак"
			},
			"spa": {
				"official": "República de Irak",
				"common": "Irak"
			},
			"svk": {
				"official": "Iracká republika",
				"common": "Irak"
			},
			"fin": {
				"official": "Irakin tasavalta",
				"common": "Irak"
			},
			"zho": {
				"official": "伊拉克共和国",
				"common": "伊拉克"
			}
		},
		"latlng": [
			33,
			44
		],
		"demonym": "Iraqi",
		"landlocked": false,
		"borders": [
			"IRN",
			"JOR",
			"KWT",
			"SAU",
			"SYR",
			"TUR"
		],
		"area": 438317
	},
	{
		"name": {
			"common": "Iceland",
			"official": "Iceland",
			"native": {
				"isl": {
					"official": "Ísland",
					"common": "Ísland"
				}
			}
		},
		"tld": [
			".is"
		],
		"cca2": "IS",
		"ccn3": "352",
		"cca3": "ISL",
		"cioc": "ISL",
		"currency": [
			"ISK"
		],
		"callingCode": [
			"354"
		],
		"capital": "Reykjavik",
		"altSpellings": [
			"IS",
			"Island",
			"Republic of Iceland",
			"Lýðveldið Ísland"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"isl": "Icelandic"
		},
		"translations": {
			"deu": {
				"official": "Island",
				"common": "Island"
			},
			"fra": {
				"official": "République d'Islande",
				"common": "Islande"
			},
			"hrv": {
				"official": "Island",
				"common": "Island"
			},
			"ita": {
				"official": "Islanda",
				"common": "Islanda"
			},
			"jpn": {
				"official": "アイスランド",
				"common": "アイスランド"
			},
			"nld": {
				"official": "IJsland",
				"common": "IJsland"
			},
			"por": {
				"official": "Islândia",
				"common": "Islândia"
			},
			"rus": {
				"official": "Исландия",
				"common": "Исландия"
			},
			"spa": {
				"official": "Islandia",
				"common": "Islandia"
			},
			"svk": {
				"official": "Islandská republika",
				"common": "Island"
			},
			"fin": {
				"official": "Islanti",
				"common": "Islanti"
			},
			"zho": {
				"official": "冰岛",
				"common": "冰岛"
			}
		},
		"latlng": [
			65,
			-18
		],
		"demonym": "Icelander",
		"landlocked": false,
		"borders": [],
		"area": 103000
	},
	{
		"name": {
			"common": "Israel",
			"official": "State of Israel",
			"native": {
				"ara": {
					"official": "دولة إسرائيل",
					"common": "إسرائيل"
				},
				"heb": {
					"official": "מדינת ישראל",
					"common": "ישראל"
				}
			}
		},
		"tld": [
			".il"
		],
		"cca2": "IL",
		"ccn3": "376",
		"cca3": "ISR",
		"cioc": "ISR",
		"currency": [
			"ILS"
		],
		"callingCode": [
			"972"
		],
		"capital": "Jerusalem",
		"altSpellings": [
			"IL",
			"State of Israel",
			"Medīnat Yisrā'el"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic",
			"heb": "Hebrew"
		},
		"translations": {
			"deu": {
				"official": "Staat Israel",
				"common": "Israel"
			},
			"fra": {
				"official": "État d'Israël",
				"common": "Israël"
			},
			"hrv": {
				"official": "Država Izrael",
				"common": "Izrael"
			},
			"ita": {
				"official": "Stato di Israele",
				"common": "Israele"
			},
			"jpn": {
				"official": "イスラエル国",
				"common": "イスラエル"
			},
			"nld": {
				"official": "Staat Israël",
				"common": "Israël"
			},
			"por": {
				"official": "Estado de Israel",
				"common": "Israel"
			},
			"rus": {
				"official": "Государство Израиль",
				"common": "Израиль"
			},
			"spa": {
				"official": "Estado de Israel",
				"common": "Israel"
			},
			"svk": {
				"official": "Izraelský štát",
				"common": "Izrael"
			},
			"fin": {
				"official": "Israelin valtio",
				"common": "Israel"
			},
			"zho": {
				"official": "以色列国",
				"common": "以色列"
			}
		},
		"latlng": [
			31.47,
			35.13
		],
		"demonym": "Israeli",
		"landlocked": false,
		"borders": [
			"EGY",
			"JOR",
			"LBN",
			"SYR"
		],
		"area": 20770
	},
	{
		"name": {
			"common": "Italy",
			"official": "Italian Republic",
			"native": {
				"bar": {
					"official": "Italienische Republik",
					"common": "Italien"
				},
				"ita": {
					"official": "Repubblica italiana",
					"common": "Italia"
				},
				"srd": {
					"official": "Repubbricanu Italia",
					"common": "Italia"
				}
			}
		},
		"tld": [
			".it"
		],
		"cca2": "IT",
		"ccn3": "380",
		"cca3": "ITA",
		"cioc": "ITA",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"39"
		],
		"capital": "Rome",
		"altSpellings": [
			"IT",
			"Italian Republic",
			"Repubblica italiana"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"bar": "Austro-Bavarian German",
			"ita": "Italian",
			"srd": "Sardinian"
		},
		"translations": {
			"deu": {
				"official": "Italienische Republik",
				"common": "Italien"
			},
			"fra": {
				"official": "République italienne",
				"common": "Italie"
			},
			"hrv": {
				"official": "talijanska Republika",
				"common": "Italija"
			},
			"ita": {
				"official": "Repubblica italiana",
				"common": "Italia"
			},
			"jpn": {
				"official": "イタリア共和国",
				"common": "イタリア"
			},
			"nld": {
				"official": "Italiaanse Republiek",
				"common": "Italië"
			},
			"por": {
				"official": "República Italiana",
				"common": "Itália"
			},
			"rus": {
				"official": "итальянская Республика",
				"common": "Италия"
			},
			"spa": {
				"official": "República Italiana",
				"common": "Italia"
			},
			"svk": {
				"official": "Talianska republika",
				"common": "Taliansko"
			},
			"fin": {
				"official": "Italian tasavalta",
				"common": "Italia"
			},
			"zho": {
				"official": "意大利共和国",
				"common": "意大利"
			}
		},
		"latlng": [
			42.83333333,
			12.83333333
		],
		"demonym": "Italian",
		"landlocked": false,
		"borders": [
			"AUT",
			"FRA",
			"SMR",
			"SVN",
			"CHE",
			"VAT"
		],
		"area": 301336
	},
	{
		"name": {
			"common": "Jamaica",
			"official": "Jamaica",
			"native": {
				"eng": {
					"official": "Jamaica",
					"common": "Jamaica"
				},
				"jam": {
					"official": "Jamaica",
					"common": "Jamaica"
				}
			}
		},
		"tld": [
			".jm"
		],
		"cca2": "JM",
		"ccn3": "388",
		"cca3": "JAM",
		"cioc": "JAM",
		"currency": [
			"JMD"
		],
		"callingCode": [
			"1876"
		],
		"capital": "Kingston",
		"altSpellings": [
			"JM"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English",
			"jam": "Jamaican Patois"
		},
		"translations": {
			"deu": {
				"official": "Jamaika",
				"common": "Jamaika"
			},
			"fra": {
				"official": "Jamaïque",
				"common": "Jamaïque"
			},
			"hrv": {
				"official": "Jamajka",
				"common": "Jamajka"
			},
			"ita": {
				"official": "Giamaica",
				"common": "Giamaica"
			},
			"jpn": {
				"official": "ジャマイカ",
				"common": "ジャマイカ"
			},
			"nld": {
				"official": "Jamaica",
				"common": "Jamaica"
			},
			"por": {
				"official": "Jamaica",
				"common": "Jamaica"
			},
			"rus": {
				"official": "Ямайка",
				"common": "Ямайка"
			},
			"spa": {
				"official": "Jamaica",
				"common": "Jamaica"
			},
			"svk": {
				"official": "Jamajka",
				"common": "Jamajka"
			},
			"fin": {
				"official": "Jamaika",
				"common": "Jamaika"
			},
			"zho": {
				"official": "牙买加",
				"common": "牙买加"
			}
		},
		"latlng": [
			18.25,
			-77.5
		],
		"demonym": "Jamaican",
		"landlocked": false,
		"borders": [],
		"area": 10991
	},
	{
		"name": {
			"common": "Jersey",
			"official": "Bailiwick of Jersey",
			"native": {
				"eng": {
					"official": "Bailiwick of Jersey",
					"common": "Jersey"
				},
				"fra": {
					"official": "Bailliage de Jersey",
					"common": "Jersey"
				},
				"nrf": {
					"official": "Bailliage dé Jèrri",
					"common": "Jèrri"
				}
			}
		},
		"tld": [
			".je"
		],
		"cca2": "JE",
		"ccn3": "832",
		"cca3": "JEY",
		"cioc": "",
		"currency": [
			"GBP"
		],
		"callingCode": [
			"44"
		],
		"capital": "Saint Helier",
		"altSpellings": [
			"JE",
			"Bailiwick of Jersey",
			"Bailliage de Jersey",
			"Bailliage dé Jèrri"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"eng": "English",
			"fra": "French",
			"nrf": "Jèrriais"
		},
		"translations": {
			"deu": {
				"official": "Vogtei Jersey",
				"common": "Jersey"
			},
			"fra": {
				"official": "Bailliage de Jersey",
				"common": "Jersey"
			},
			"hrv": {
				"official": "Struka od Jersey",
				"common": "Jersey"
			},
			"ita": {
				"official": "Baliato di Jersey",
				"common": "Isola di Jersey"
			},
			"jpn": {
				"official": "ジャージの得意分野",
				"common": "ジャージー"
			},
			"nld": {
				"official": "Baljuwschap Jersey",
				"common": "Jersey"
			},
			"por": {
				"official": "Bailiado de Jersey",
				"common": "Jersey"
			},
			"rus": {
				"official": "Коронное владение Джерси",
				"common": "Джерси"
			},
			"spa": {
				"official": "Bailía de Jersey",
				"common": "Jersey"
			},
			"svk": {
				"official": "Bailiwick Jersey",
				"common": "Jersey"
			},
			"fin": {
				"official": "Jersey",
				"common": "Jersey"
			},
			"zho": {
				"official": "泽西岛",
				"common": "泽西岛"
			}
		},
		"latlng": [
			49.25,
			-2.16666666
		],
		"demonym": "Channel Islander",
		"landlocked": false,
		"borders": [],
		"area": 116
	},
	{
		"name": {
			"common": "Jordan",
			"official": "Hashemite Kingdom of Jordan",
			"native": {
				"ara": {
					"official": "المملكة الأردنية الهاشمية",
					"common": "الأردن"
				}
			}
		},
		"tld": [
			".jo",
			"الاردن."
		],
		"cca2": "JO",
		"ccn3": "400",
		"cca3": "JOR",
		"cioc": "JOR",
		"currency": [
			"JOD"
		],
		"callingCode": [
			"962"
		],
		"capital": "Amman",
		"altSpellings": [
			"JO",
			"Hashemite Kingdom of Jordan",
			"al-Mamlakah al-Urdunīyah al-Hāshimīyah"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Haschemitisches Königreich Jordanien",
				"common": "Jordanien"
			},
			"fra": {
				"official": "Royaume hachémite de Jordanie",
				"common": "Jordanie"
			},
			"hrv": {
				"official": "Hašemitske Kraljevine Jordan",
				"common": "Jordan"
			},
			"ita": {
				"official": "Regno hascemita di Giordania",
				"common": "Giordania"
			},
			"jpn": {
				"official": "ヨルダン·ハシミテ王国",
				"common": "ヨルダン"
			},
			"nld": {
				"official": "Hasjemitisch Koninkrijk Jordanië",
				"common": "Jordanië"
			},
			"por": {
				"official": "Reino Hachemita da Jordânia",
				"common": "Jordânia"
			},
			"rus": {
				"official": "Иорданского Хашимитского Королевства",
				"common": "Иордания"
			},
			"spa": {
				"official": "Reino Hachemita de Jordania",
				"common": "Jordania"
			},
			"svk": {
				"official": "Jordánske hášimovské kráľovstvo",
				"common": "Jordánsko"
			},
			"fin": {
				"official": "Jordanian hašemiittinen kunigaskunta",
				"common": "Jordania"
			},
			"zho": {
				"official": "约旦哈希姆王国",
				"common": "约旦"
			}
		},
		"latlng": [
			31,
			36
		],
		"demonym": "Jordanian",
		"landlocked": false,
		"borders": [
			"IRQ",
			"ISR",
			"SAU",
			"SYR"
		],
		"area": 89342
	},
	{
		"name": {
			"common": "Japan",
			"official": "Japan",
			"native": {
				"jpn": {
					"official": "日本",
					"common": "日本"
				}
			}
		},
		"tld": [
			".jp",
			".みんな"
		],
		"cca2": "JP",
		"ccn3": "392",
		"cca3": "JPN",
		"cioc": "JPN",
		"currency": [
			"JPY"
		],
		"callingCode": [
			"81"
		],
		"capital": "Tokyo",
		"altSpellings": [
			"JP",
			"Nippon",
			"Nihon"
		],
		"region": "Asia",
		"subregion": "Eastern Asia",
		"languages": {
			"jpn": "Japanese"
		},
		"translations": {
			"deu": {
				"official": "Japan",
				"common": "Japan"
			},
			"fra": {
				"official": "Japon",
				"common": "Japon"
			},
			"hrv": {
				"official": "Japan",
				"common": "Japan"
			},
			"ita": {
				"official": "Giappone",
				"common": "Giappone"
			},
			"jpn": {
				"official": "日本",
				"common": "日本"
			},
			"nld": {
				"official": "Japan",
				"common": "Japan"
			},
			"por": {
				"official": "Japão",
				"common": "Japão"
			},
			"rus": {
				"official": "Япония",
				"common": "Япония"
			},
			"spa": {
				"official": "Japón",
				"common": "Japón"
			},
			"svk": {
				"official": "Japonsko",
				"common": "Japonsko"
			},
			"fin": {
				"official": "Japani",
				"common": "Japani"
			},
			"zho": {
				"official": "日本国",
				"common": "日本"
			}
		},
		"latlng": [
			36,
			138
		],
		"demonym": "Japanese",
		"landlocked": false,
		"borders": [],
		"area": 377930
	},
	{
		"name": {
			"common": "Kazakhstan",
			"official": "Republic of Kazakhstan",
			"native": {
				"kaz": {
					"official": "Қазақстан Республикасы",
					"common": "Қазақстан"
				},
				"rus": {
					"official": "Республика Казахстан",
					"common": "Казахстан"
				}
			}
		},
		"tld": [
			".kz",
			".қаз"
		],
		"cca2": "KZ",
		"ccn3": "398",
		"cca3": "KAZ",
		"cioc": "KAZ",
		"currency": [
			"KZT"
		],
		"callingCode": [
			"76",
			"77"
		],
		"capital": "Astana",
		"altSpellings": [
			"KZ",
			"Qazaqstan",
			"Казахстан",
			"Republic of Kazakhstan",
			"Қазақстан Республикасы",
			"Qazaqstan Respublïkası",
			"Республика Казахстан",
			"Respublika Kazakhstan"
		],
		"region": "Asia",
		"subregion": "Central Asia",
		"languages": {
			"kaz": "Kazakh",
			"rus": "Russian"
		},
		"translations": {
			"deu": {
				"official": "Republik Kasachstan",
				"common": "Kasachstan"
			},
			"fra": {
				"official": "République du Kazakhstan",
				"common": "Kazakhstan"
			},
			"hrv": {
				"official": "Republika Kazahstan",
				"common": "Kazahstan"
			},
			"ita": {
				"official": "Repubblica del Kazakhstan",
				"common": "Kazakistan"
			},
			"jpn": {
				"official": "カザフスタン共和国",
				"common": "カザフスタン"
			},
			"nld": {
				"official": "Republiek Kazachstan",
				"common": "Kazachstan"
			},
			"por": {
				"official": "República do Cazaquistão",
				"common": "Cazaquistão"
			},
			"rus": {
				"official": "Республика Казахстан",
				"common": "Казахстан"
			},
			"spa": {
				"official": "República de Kazajstán",
				"common": "Kazajistán"
			},
			"svk": {
				"official": "Kazašská republika",
				"common": "Kazachstan"
			},
			"fin": {
				"official": "Kazakstanin tasavalta",
				"common": "Kazakstan"
			},
			"zho": {
				"official": "哈萨克斯坦共和国",
				"common": "哈萨克斯坦"
			}
		},
		"latlng": [
			48,
			68
		],
		"demonym": "Kazakhstani",
		"landlocked": true,
		"borders": [
			"CHN",
			"KGZ",
			"RUS",
			"TKM",
			"UZB"
		],
		"area": 2724900
	},
	{
		"name": {
			"common": "Kenya",
			"official": "Republic of Kenya",
			"native": {
				"eng": {
					"official": "Republic of Kenya",
					"common": "Kenya"
				},
				"swa": {
					"official": "Republic of Kenya",
					"common": "Kenya"
				}
			}
		},
		"tld": [
			".ke"
		],
		"cca2": "KE",
		"ccn3": "404",
		"cca3": "KEN",
		"cioc": "KEN",
		"currency": [
			"KES"
		],
		"callingCode": [
			"254"
		],
		"capital": "Nairobi",
		"altSpellings": [
			"KE",
			"Republic of Kenya",
			"Jamhuri ya Kenya"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"eng": "English",
			"swa": "Swahili"
		},
		"translations": {
			"deu": {
				"official": "Republik Kenia",
				"common": "Kenia"
			},
			"fra": {
				"official": "République du Kenya",
				"common": "Kenya"
			},
			"hrv": {
				"official": "Republika Kenija",
				"common": "Kenija"
			},
			"ita": {
				"official": "Repubblica del Kenya",
				"common": "Kenya"
			},
			"jpn": {
				"official": "ケニア共和国",
				"common": "ケニア"
			},
			"nld": {
				"official": "Republiek Kenia",
				"common": "Kenia"
			},
			"por": {
				"official": "República do Quénia",
				"common": "Quénia"
			},
			"rus": {
				"official": "Республика Кения",
				"common": "Кения"
			},
			"spa": {
				"official": "República de Kenya",
				"common": "Kenia"
			},
			"svk": {
				"official": "Kenská republika",
				"common": "Keňa"
			},
			"fin": {
				"official": "Kenian tasavalta",
				"common": "Kenia"
			},
			"zho": {
				"official": "肯尼亚共和国",
				"common": "肯尼亚"
			}
		},
		"latlng": [
			1,
			38
		],
		"demonym": "Kenyan",
		"landlocked": false,
		"borders": [
			"ETH",
			"SOM",
			"SSD",
			"TZA",
			"UGA"
		],
		"area": 580367
	},
	{
		"name": {
			"common": "Kyrgyzstan",
			"official": "Kyrgyz Republic",
			"native": {
				"kir": {
					"official": "Кыргыз Республикасы",
					"common": "Кыргызстан"
				},
				"rus": {
					"official": "Кыргызская Республика",
					"common": "Киргизия"
				}
			}
		},
		"tld": [
			".kg"
		],
		"cca2": "KG",
		"ccn3": "417",
		"cca3": "KGZ",
		"cioc": "KGZ",
		"currency": [
			"KGS"
		],
		"callingCode": [
			"996"
		],
		"capital": "Bishkek",
		"altSpellings": [
			"KG",
			"Киргизия",
			"Kyrgyz Republic",
			"Кыргыз Республикасы",
			"Kyrgyz Respublikasy"
		],
		"region": "Asia",
		"subregion": "Central Asia",
		"languages": {
			"kir": "Kyrgyz",
			"rus": "Russian"
		},
		"translations": {
			"deu": {
				"official": "Kirgisische Republik",
				"common": "Kirgisistan"
			},
			"fra": {
				"official": "République kirghize",
				"common": "Kirghizistan"
			},
			"hrv": {
				"official": "Kirgistanu",
				"common": "Kirgistan"
			},
			"ita": {
				"official": "Kirghizistan",
				"common": "Kirghizistan"
			},
			"jpn": {
				"official": "キルギス共和国",
				"common": "キルギス"
			},
			"nld": {
				"official": "Kirgizische Republiek",
				"common": "Kirgizië"
			},
			"por": {
				"official": "República do Quirguistão",
				"common": "Quirguistão"
			},
			"rus": {
				"official": "Кыргызская Республика",
				"common": "Киргизия"
			},
			"spa": {
				"official": "República Kirguisa",
				"common": "Kirguizistán"
			},
			"svk": {
				"official": "Kirgizská republika",
				"common": "Kirgizsko"
			},
			"fin": {
				"official": "Kirgisian tasavalta",
				"common": "Kirgisia"
			},
			"zho": {
				"official": "吉尔吉斯斯坦共和国",
				"common": "吉尔吉斯斯坦"
			}
		},
		"latlng": [
			41,
			75
		],
		"demonym": "Kirghiz",
		"landlocked": true,
		"borders": [
			"CHN",
			"KAZ",
			"TJK",
			"UZB"
		],
		"area": 199951
	},
	{
		"name": {
			"common": "Cambodia",
			"official": "Kingdom of Cambodia",
			"native": {
				"khm": {
					"official": "ព្រះរាជាណាចក្រកម្ពុជា",
					"common": "Kâmpŭchéa"
				}
			}
		},
		"tld": [
			".kh"
		],
		"cca2": "KH",
		"ccn3": "116",
		"cca3": "KHM",
		"cioc": "CAM",
		"currency": [
			"KHR"
		],
		"callingCode": [
			"855"
		],
		"capital": "Phnom Penh",
		"altSpellings": [
			"KH",
			"Kingdom of Cambodia"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"khm": "Khmer"
		},
		"translations": {
			"cym": {
				"official": "Kingdom of Cambodia",
				"common": "Cambodia"
			},
			"deu": {
				"official": "Königreich Kambodscha",
				"common": "Kambodscha"
			},
			"fra": {
				"official": "Royaume du Cambodge",
				"common": "Cambodge"
			},
			"hrv": {
				"official": "Kraljevina Kambodža",
				"common": "Kambodža"
			},
			"ita": {
				"official": "Regno di Cambogia",
				"common": "Cambogia"
			},
			"jpn": {
				"official": "カンボジア王国",
				"common": "カンボジア"
			},
			"nld": {
				"official": "Koninkrijk Cambodja",
				"common": "Cambodja"
			},
			"por": {
				"official": "Reino do Camboja",
				"common": "Camboja"
			},
			"rus": {
				"official": "Королевство Камбоджа",
				"common": "Камбоджа"
			},
			"spa": {
				"official": "Reino de Camboya",
				"common": "Camboya"
			},
			"svk": {
				"official": "Kamboǆské kráľovstvo",
				"common": "Kamboǆa"
			},
			"fin": {
				"official": "Kambodžan kuningaskunta",
				"common": "Kambodža"
			},
			"zho": {
				"official": "柬埔寨王国",
				"common": "柬埔寨"
			}
		},
		"latlng": [
			13,
			105
		],
		"demonym": "Cambodian",
		"landlocked": false,
		"borders": [
			"LAO",
			"THA",
			"VNM"
		],
		"area": 181035
	},
	{
		"name": {
			"common": "Kiribati",
			"official": "Independent and Sovereign Republic of Kiribati",
			"native": {
				"eng": {
					"official": "Independent and Sovereign Republic of Kiribati",
					"common": "Kiribati"
				},
				"gil": {
					"official": "Ribaberiki Kiribati",
					"common": "Kiribati"
				}
			}
		},
		"tld": [
			".ki"
		],
		"cca2": "KI",
		"ccn3": "296",
		"cca3": "KIR",
		"cioc": "KIR",
		"currency": [
			"AUD"
		],
		"callingCode": [
			"686"
		],
		"capital": "South Tarawa",
		"altSpellings": [
			"KI",
			"Republic of Kiribati",
			"Ribaberiki Kiribati"
		],
		"region": "Oceania",
		"subregion": "Micronesia",
		"languages": {
			"eng": "English",
			"gil": "Gilbertese"
		},
		"translations": {
			"deu": {
				"official": "Unabhängige und souveräne Republik Kiribati",
				"common": "Kiribati"
			},
			"fra": {
				"official": "République de Kiribati",
				"common": "Kiribati"
			},
			"hrv": {
				"official": "Samostalne i suverene Republike Kiribati",
				"common": "Kiribati"
			},
			"ita": {
				"official": "Repubblica indipendente e sovrano di Kiribati",
				"common": "Kiribati"
			},
			"jpn": {
				"official": "キリバスの独立と主権共和国",
				"common": "キリバス"
			},
			"nld": {
				"official": "Onafhankelijke en soevereine republiek Kiribati",
				"common": "Kiribati"
			},
			"por": {
				"official": "Independente e soberano República de Kiribati",
				"common": "Kiribati"
			},
			"rus": {
				"official": "Независимой и суверенной Республики Кирибати",
				"common": "Кирибати"
			},
			"spa": {
				"official": "República Independiente y Soberano de Kiribati",
				"common": "Kiribati"
			},
			"svk": {
				"official": "Kiribatská republika",
				"common": "Kiribati"
			},
			"fin": {
				"official": "Kiribatin tasavalta",
				"common": "Kiribati"
			},
			"zho": {
				"official": "基里巴斯共和国",
				"common": "基里巴斯"
			}
		},
		"latlng": [
			1.41666666,
			173
		],
		"demonym": "I-Kiribati",
		"landlocked": false,
		"borders": [],
		"area": 811
	},
	{
		"name": {
			"common": "Saint Kitts and Nevis",
			"official": "Federation of Saint Christopher and Nevisa",
			"native": {
				"eng": {
					"official": "Federation of Saint Christopher and Nevisa",
					"common": "Saint Kitts and Nevis"
				}
			}
		},
		"tld": [
			".kn"
		],
		"cca2": "KN",
		"ccn3": "659",
		"cca3": "KNA",
		"cioc": "SKN",
		"currency": [
			"XCD"
		],
		"callingCode": [
			"1869"
		],
		"capital": "Basseterre",
		"altSpellings": [
			"KN",
			"Federation of Saint Christopher and Nevis"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Föderation von Saint Kitts und Nevisa",
				"common": "Saint Christopher und Nevis"
			},
			"fra": {
				"official": "Fédération de Saint -Christophe-et Nevisa",
				"common": "Saint-Christophe-et-Niévès"
			},
			"hrv": {
				"official": "Federacija Sv.Kristofora i Nevisa",
				"common": "Sveti Kristof i Nevis"
			},
			"ita": {
				"official": "Federazione di Saint Christopher e Nevisa",
				"common": "Saint Kitts e Nevis"
			},
			"jpn": {
				"official": "セントクリストファーNevisa連盟",
				"common": "セントクリストファー・ネイビス"
			},
			"nld": {
				"official": "Federatie van Saint Kitts en Nevisa",
				"common": "Saint Kitts en Nevis"
			},
			"por": {
				"official": "Federação de São Cristóvão e Nevisa",
				"common": "São Cristóvão e Nevis"
			},
			"rus": {
				"official": "Федерация Сент-Кристофер и Nevisa",
				"common": "Сент-Китс и Невис"
			},
			"spa": {
				"official": "Federación de San Cristóbal y Nevisa",
				"common": "San Cristóbal y Nieves"
			},
			"svk": {
				"official": "Feder໡cia Svätého Krištofa a Nevisu",
				"common": "Svätý Krištof a Nevis"
			},
			"fin": {
				"official": "Saint Christopherin ja Nevisin federaatio",
				"common": "Saint Kitts ja Nevis"
			},
			"zho": {
				"official": "圣克里斯托弗和尼维斯联邦",
				"common": "圣基茨和尼维斯"
			}
		},
		"latlng": [
			17.33333333,
			-62.75
		],
		"demonym": "Kittitian or Nevisian",
		"landlocked": false,
		"borders": [],
		"area": 261
	},
	{
		"name": {
			"common": "South Korea",
			"official": "Republic of Korea",
			"native": {
				"kor": {
					"official": "한국",
					"common": "대한민국"
				}
			}
		},
		"tld": [
			".kr",
			".한국"
		],
		"cca2": "KR",
		"ccn3": "410",
		"cca3": "KOR",
		"cioc": "KOR",
		"currency": [
			"KRW"
		],
		"callingCode": [
			"82"
		],
		"capital": "Seoul",
		"altSpellings": [
			"KR",
			"Korea, Republic of",
			"Republic of Korea"
		],
		"region": "Asia",
		"subregion": "Eastern Asia",
		"languages": {
			"kor": "Korean"
		},
		"translations": {
			"deu": {
				"official": "Republik Korea",
				"common": "Südkorea"
			},
			"fra": {
				"official": "République de Corée",
				"common": "Corée du Sud"
			},
			"hrv": {
				"official": "Republika Koreja",
				"common": "Južna Koreja"
			},
			"ita": {
				"official": "Repubblica di Corea",
				"common": "Corea del Sud"
			},
			"jpn": {
				"official": "大韓民国",
				"common": "大韓民国"
			},
			"nld": {
				"official": "Republiek Korea",
				"common": "Zuid-Korea"
			},
			"por": {
				"official": "República da Coreia",
				"common": "Coreia do Sul"
			},
			"rus": {
				"official": "Республика Корея",
				"common": "Южная Корея"
			},
			"spa": {
				"official": "República de Corea",
				"common": "Corea del Sur"
			},
			"svk": {
				"official": "Kórejská republika",
				"common": "Južná Kórea"
			},
			"fin": {
				"official": "Korean tasavalta",
				"common": "Etelä-Korea"
			},
			"zho": {
				"official": "大韩民国",
				"common": "韩国"
			}
		},
		"latlng": [
			37,
			127.5
		],
		"demonym": "South Korean",
		"landlocked": false,
		"borders": [
			"PRK"
		],
		"area": 100210
	},
	{
		"name": {
			"common": "Kosovo",
			"official": "Republic of Kosovo",
			"native": {
				"sqi": {
					"official": "Republika e Kosovës",
					"common": "Kosova"
				},
				"srp": {
					"official": "Република Косово",
					"common": "Косово"
				}
			}
		},
		"tld": [],
		"cca2": "XK",
		"ccn3": "",
		"cca3": "UNK",
		"cioc": "KOS",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"383"
		],
		"capital": "Pristina",
		"altSpellings": [
			"XK",
			"Република Косово"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"sqi": "Albanian",
			"srp": "Serbian"
		},
		"translations": {
			"deu": {
				"official": "Republik Kosovo",
				"common": "Kosovo"
			},
			"fra": {
				"official": "République du Kosovo",
				"common": "Kosovo"
			},
			"hrv": {
				"official": "Republika Kosovo",
				"common": "Kosovo"
			},
			"ita": {
				"official": "Repubblica del Kosovo",
				"common": "Kosovo"
			},
			"nld": {
				"official": "Republiek Kosovo",
				"common": "Kosovo"
			},
			"por": {
				"official": "República do Kosovo",
				"common": "Kosovo"
			},
			"rus": {
				"official": "Республика Косово",
				"common": "Республика Косово"
			},
			"spa": {
				"official": "República de Kosovo",
				"common": "Kosovo"
			},
			"svk": {
				"official": "Republika Kosovo",
				"common": "Kosovo"
			},
			"fin": {
				"official": "Kosovon tasavalta",
				"common": "Kosovo"
			},
			"zho": {
				"official": "科索沃共和国",
				"common": "科索沃"
			}
		},
		"latlng": [
			42.666667,
			21.166667
		],
		"demonym": "Kosovar",
		"landlocked": true,
		"borders": [
			"ALB",
			"MKD",
			"MNE",
			"SRB"
		],
		"area": 10908
	},
	{
		"name": {
			"common": "Kuwait",
			"official": "State of Kuwait",
			"native": {
				"ara": {
					"official": "دولة الكويت",
					"common": "الكويت"
				}
			}
		},
		"tld": [
			".kw"
		],
		"cca2": "KW",
		"ccn3": "414",
		"cca3": "KWT",
		"cioc": "KUW",
		"currency": [
			"KWD"
		],
		"callingCode": [
			"965"
		],
		"capital": "Kuwait City",
		"altSpellings": [
			"KW",
			"State of Kuwait",
			"Dawlat al-Kuwait"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Staat Kuwait",
				"common": "Kuwait"
			},
			"fra": {
				"official": "État du Koweït",
				"common": "Koweït"
			},
			"hrv": {
				"official": "Država Kuvajt",
				"common": "Kuvajt"
			},
			"ita": {
				"official": "Stato del Kuwait",
				"common": "Kuwait"
			},
			"jpn": {
				"official": "クウェート国",
				"common": "クウェート"
			},
			"nld": {
				"official": "Staat Koeweit",
				"common": "Koeweit"
			},
			"por": {
				"official": "Estado do Kuwait",
				"common": "Kuwait"
			},
			"rus": {
				"official": "Государство Кувейт",
				"common": "Кувейт"
			},
			"spa": {
				"official": "Estado de Kuwait",
				"common": "Kuwait"
			},
			"svk": {
				"official": "Kuvajtský štát",
				"common": "Kuvajt"
			},
			"fin": {
				"official": "Kuwaitin valtio",
				"common": "Kuwait"
			},
			"zho": {
				"official": "科威特国",
				"common": "科威特"
			}
		},
		"latlng": [
			29.5,
			45.75
		],
		"demonym": "Kuwaiti",
		"landlocked": false,
		"borders": [
			"IRQ",
			"SAU"
		],
		"area": 17818
	},
	{
		"name": {
			"common": "Laos",
			"official": "Lao People's Democratic Republic",
			"native": {
				"lao": {
					"official": "ສາທາລະນະ ຊາທິປະໄຕ ຄົນລາວ ຂອງ",
					"common": "ສປປລາວ"
				}
			}
		},
		"tld": [
			".la"
		],
		"cca2": "LA",
		"ccn3": "418",
		"cca3": "LAO",
		"cioc": "LAO",
		"currency": [
			"LAK"
		],
		"callingCode": [
			"856"
		],
		"capital": "Vientiane",
		"altSpellings": [
			"LA",
			"Lao",
			"Lao People's Democratic Republic",
			"Sathalanalat Paxathipatai Paxaxon Lao"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"lao": "Lao"
		},
		"translations": {
			"deu": {
				"official": "Laos, Demokratische Volksrepublik",
				"common": "Laos"
			},
			"fra": {
				"official": "République démocratique populaire lao",
				"common": "Laos"
			},
			"hrv": {
				"official": "Narodna Demokratska Republika",
				"common": "Laos"
			},
			"ita": {
				"official": "Repubblica democratica popolare del Laos",
				"common": "Laos"
			},
			"jpn": {
				"official": "ラオス人民民主共和国",
				"common": "ラオス人民民主共和国"
			},
			"nld": {
				"official": "Lao Democratische Volksrepubliek",
				"common": "Laos"
			},
			"por": {
				"official": "Laos, República Democrática",
				"common": "Laos"
			},
			"rus": {
				"official": "Лаосская Народно-Демократическая Республика",
				"common": "Лаос"
			},
			"spa": {
				"official": "República Democrática Popular Lao",
				"common": "Laos"
			},
			"svk": {
				"official": "Laoská ľudovodemokratická republika",
				"common": "Laos"
			},
			"fin": {
				"official": "Laosin demokraattinen kansantasavalta",
				"common": "Laos"
			},
			"zho": {
				"official": "老挝人民民主共和国",
				"common": "老挝"
			}
		},
		"latlng": [
			18,
			105
		],
		"demonym": "Laotian",
		"landlocked": true,
		"borders": [
			"MMR",
			"KHM",
			"CHN",
			"THA",
			"VNM"
		],
		"area": 236800
	},
	{
		"name": {
			"common": "Lebanon",
			"official": "Lebanese Republic",
			"native": {
				"ara": {
					"official": "الجمهورية اللبنانية",
					"common": "لبنان"
				},
				"fra": {
					"official": "République libanaise",
					"common": "Liban"
				}
			}
		},
		"tld": [
			".lb"
		],
		"cca2": "LB",
		"ccn3": "422",
		"cca3": "LBN",
		"cioc": "LIB",
		"currency": [
			"LBP"
		],
		"callingCode": [
			"961"
		],
		"capital": "Beirut",
		"altSpellings": [
			"LB",
			"Lebanese Republic",
			"Al-Jumhūrīyah Al-Libnānīyah"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic",
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Libanesische Republik",
				"common": "Libanon"
			},
			"fra": {
				"official": "République libanaise",
				"common": "Liban"
			},
			"hrv": {
				"official": "Libanonska Republika",
				"common": "Libanon"
			},
			"ita": {
				"official": "Repubblica libanese",
				"common": "Libano"
			},
			"jpn": {
				"official": "レバノン共和国",
				"common": "レバノン"
			},
			"nld": {
				"official": "Libanese Republiek",
				"common": "Libanon"
			},
			"por": {
				"official": "República Libanesa",
				"common": "Líbano"
			},
			"rus": {
				"official": "Ливанская Республика",
				"common": "Ливан"
			},
			"spa": {
				"official": "República Libanesa",
				"common": "Líbano"
			},
			"svk": {
				"official": "Libanonská republika",
				"common": "Libanon"
			},
			"fin": {
				"official": "Libanonin tasavalta",
				"common": "Libanon"
			},
			"zho": {
				"official": "黎巴嫩共和国",
				"common": "黎巴嫩"
			}
		},
		"latlng": [
			33.83333333,
			35.83333333
		],
		"demonym": "Lebanese",
		"landlocked": false,
		"borders": [
			"ISR",
			"SYR"
		],
		"area": 10452
	},
	{
		"name": {
			"common": "Liberia",
			"official": "Republic of Liberia",
			"native": {
				"eng": {
					"official": "Republic of Liberia",
					"common": "Liberia"
				}
			}
		},
		"tld": [
			".lr"
		],
		"cca2": "LR",
		"ccn3": "430",
		"cca3": "LBR",
		"cioc": "LBR",
		"currency": [
			"LRD"
		],
		"callingCode": [
			"231"
		],
		"capital": "Monrovia",
		"altSpellings": [
			"LR",
			"Republic of Liberia"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Republik Liberia",
				"common": "Liberia"
			},
			"fra": {
				"official": "République du Libéria",
				"common": "Liberia"
			},
			"hrv": {
				"official": "Republika Liberija",
				"common": "Liberija"
			},
			"ita": {
				"official": "Repubblica di Liberia",
				"common": "Liberia"
			},
			"jpn": {
				"official": "リベリア共和国",
				"common": "リベリア"
			},
			"nld": {
				"official": "Republiek Liberia",
				"common": "Liberia"
			},
			"por": {
				"official": "República da Libéria",
				"common": "Libéria"
			},
			"rus": {
				"official": "Республика Либерия",
				"common": "Либерия"
			},
			"spa": {
				"official": "República de Liberia",
				"common": "Liberia"
			},
			"svk": {
				"official": "Libérijská republika",
				"common": "Libéria"
			},
			"fin": {
				"official": "Liberian tasavalta",
				"common": "Liberia"
			},
			"zho": {
				"official": "利比里亚共和国",
				"common": "利比里亚"
			}
		},
		"latlng": [
			6.5,
			-9.5
		],
		"demonym": "Liberian",
		"landlocked": false,
		"borders": [
			"GIN",
			"CIV",
			"SLE"
		],
		"area": 111369
	},
	{
		"name": {
			"common": "Libya",
			"official": "State of Libya",
			"native": {
				"ara": {
					"official": "الدولة ليبيا",
					"common": "‏ليبيا"
				}
			}
		},
		"tld": [
			".ly"
		],
		"cca2": "LY",
		"ccn3": "434",
		"cca3": "LBY",
		"cioc": "LBA",
		"currency": [
			"LYD"
		],
		"callingCode": [
			"218"
		],
		"capital": "Tripoli",
		"altSpellings": [
			"LY",
			"State of Libya",
			"Dawlat Libya"
		],
		"region": "Africa",
		"subregion": "Northern Africa",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Staat Libyen",
				"common": "Libyen"
			},
			"fra": {
				"official": "Grande République arabe libyenne populaire et socialiste",
				"common": "Libye"
			},
			"hrv": {
				"official": "Država Libiji",
				"common": "Libija"
			},
			"ita": {
				"official": "Stato della Libia",
				"common": "Libia"
			},
			"jpn": {
				"official": "リビアの国家",
				"common": "リビア"
			},
			"nld": {
				"official": "Staat van Libië",
				"common": "Libië"
			},
			"por": {
				"official": "Estado da Líbia",
				"common": "Líbia"
			},
			"rus": {
				"official": "Государство Ливии",
				"common": "Ливия"
			},
			"spa": {
				"official": "Estado de Libia",
				"common": "Libia"
			},
			"svk": {
				"official": "Líbya",
				"common": "Líbya"
			},
			"fin": {
				"official": "Libyan valtio",
				"common": "Libya"
			},
			"zho": {
				"official": "利比亚国",
				"common": "利比亚"
			}
		},
		"latlng": [
			25,
			17
		],
		"demonym": "Libyan",
		"landlocked": false,
		"borders": [
			"DZA",
			"TCD",
			"EGY",
			"NER",
			"SDN",
			"TUN"
		],
		"area": 1759540
	},
	{
		"name": {
			"common": "Saint Lucia",
			"official": "Saint Lucia",
			"native": {
				"eng": {
					"official": "Saint Lucia",
					"common": "Saint Lucia"
				}
			}
		},
		"tld": [
			".lc"
		],
		"cca2": "LC",
		"ccn3": "662",
		"cca3": "LCA",
		"cioc": "LCA",
		"currency": [
			"XCD"
		],
		"callingCode": [
			"1758"
		],
		"capital": "Castries",
		"altSpellings": [
			"LC"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "St. Lucia",
				"common": "Saint Lucia"
			},
			"fra": {
				"official": "Sainte-Lucie",
				"common": "Sainte-Lucie"
			},
			"hrv": {
				"official": "Sveta Lucija",
				"common": "Sveta Lucija"
			},
			"ita": {
				"official": "Santa Lucia",
				"common": "Santa Lucia"
			},
			"jpn": {
				"official": "セントルシア",
				"common": "セントルシア"
			},
			"nld": {
				"official": "Saint Lucia",
				"common": "Saint Lucia"
			},
			"por": {
				"official": "Santa Lúcia",
				"common": "Santa Lúcia"
			},
			"rus": {
				"official": "Сент-Люсия",
				"common": "Сент-Люсия"
			},
			"spa": {
				"official": "Santa Lucía",
				"common": "Santa Lucía"
			},
			"svk": {
				"official": "Svätá Lucia",
				"common": "Svätá Lucia"
			},
			"fin": {
				"official": "Saint Lucia",
				"common": "Saint Lucia"
			},
			"zho": {
				"official": "圣卢西亚",
				"common": "圣卢西亚"
			}
		},
		"latlng": [
			13.88333333,
			-60.96666666
		],
		"demonym": "Saint Lucian",
		"landlocked": false,
		"borders": [],
		"area": 616
	},
	{
		"name": {
			"common": "Liechtenstein",
			"official": "Principality of Liechtenstein",
			"native": {
				"deu": {
					"official": "Fürstentum Liechtenstein",
					"common": "Liechtenstein"
				}
			}
		},
		"tld": [
			".li"
		],
		"cca2": "LI",
		"ccn3": "438",
		"cca3": "LIE",
		"cioc": "LIE",
		"currency": [
			"CHF"
		],
		"callingCode": [
			"423"
		],
		"capital": "Vaduz",
		"altSpellings": [
			"LI",
			"Principality of Liechtenstein",
			"Fürstentum Liechtenstein"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"deu": "German"
		},
		"translations": {
			"deu": {
				"official": "Fürstentum Liechtenstein",
				"common": "Liechtenstein"
			},
			"fra": {
				"official": "Principauté du Liechtenstein",
				"common": "Liechtenstein"
			},
			"hrv": {
				"official": "Kneževina Lihtenštajn",
				"common": "Lihtenštajn"
			},
			"ita": {
				"official": "Principato del Liechtenstein",
				"common": "Liechtenstein"
			},
			"jpn": {
				"official": "リヒテンシュタイン公国",
				"common": "リヒテンシュタイン"
			},
			"nld": {
				"official": "Vorstendom Liechtenstein",
				"common": "Liechtenstein"
			},
			"por": {
				"official": "Principado de Liechtenstein",
				"common": "Liechtenstein"
			},
			"rus": {
				"official": "Княжество Лихтенштейн",
				"common": "Лихтенштейн"
			},
			"spa": {
				"official": "Principado de Liechtenstein",
				"common": "Liechtenstein"
			},
			"svk": {
				"official": "Lichtenštajnské kniežatstvo",
				"common": "Lichtenštajnsko"
			},
			"fin": {
				"official": "Liechensteinin ruhtinaskunta",
				"common": "Liechenstein"
			},
			"zho": {
				"official": "列支敦士登公国",
				"common": "列支敦士登"
			}
		},
		"latlng": [
			47.26666666,
			9.53333333
		],
		"demonym": "Liechtensteiner",
		"landlocked": true,
		"borders": [
			"AUT",
			"CHE"
		],
		"area": 160
	},
	{
		"name": {
			"common": "Sri Lanka",
			"official": "Democratic Socialist Republic of Sri Lanka",
			"native": {
				"sin": {
					"official": "ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජය",
					"common": "ශ්‍රී ලංකාව"
				},
				"tam": {
					"official": "இலங்கை சனநாயக சோசலிசக் குடியரசு",
					"common": "இலங்கை"
				}
			}
		},
		"tld": [
			".lk",
			".இலங்கை",
			".ලංකා"
		],
		"cca2": "LK",
		"ccn3": "144",
		"cca3": "LKA",
		"cioc": "SRI",
		"currency": [
			"LKR"
		],
		"callingCode": [
			"94"
		],
		"capital": "Colombo",
		"altSpellings": [
			"LK",
			"ilaṅkai",
			"Democratic Socialist Republic of Sri Lanka"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"sin": "Sinhala",
			"tam": "Tamil"
		},
		"translations": {
			"deu": {
				"official": "Demokratische Sozialistische Republik Sri Lanka",
				"common": "Sri Lanka"
			},
			"fra": {
				"official": "République démocratique socialiste du Sri Lanka",
				"common": "Sri Lanka"
			},
			"hrv": {
				"official": "Demokratska Socijalističke Republike Šri Lanke",
				"common": "Šri Lanka"
			},
			"ita": {
				"official": "Repubblica democratica socialista dello Sri Lanka",
				"common": "Sri Lanka"
			},
			"jpn": {
				"official": "スリランカ民主社会主義共和国",
				"common": "スリランカ"
			},
			"nld": {
				"official": "Democratische Socialistische Republiek Sri Lanka",
				"common": "Sri Lanka"
			},
			"por": {
				"official": "República Democrática Socialista do Sri Lanka",
				"common": "Sri Lanka"
			},
			"rus": {
				"official": "Демократическая Социалистическая Республика Шри-Ланка",
				"common": "Шри-Ланка"
			},
			"spa": {
				"official": "República Democrática Socialista de Sri Lanka",
				"common": "Sri Lanka"
			},
			"svk": {
				"official": "Srílanská demokratická socialistická republika",
				"common": "Srí Lanka"
			},
			"fin": {
				"official": "Sri Lankan demokraattinen sosialistinen tasavalta",
				"common": "Sri Lanka"
			},
			"zho": {
				"official": "斯里兰卡民主社会主义共和国",
				"common": "斯里兰卡"
			}
		},
		"latlng": [
			7,
			81
		],
		"demonym": "Sri Lankan",
		"landlocked": false,
		"borders": [
			"IND"
		],
		"area": 65610
	},
	{
		"name": {
			"common": "Lesotho",
			"official": "Kingdom of Lesotho",
			"native": {
				"eng": {
					"official": "Kingdom of Lesotho",
					"common": "Lesotho"
				},
				"sot": {
					"official": "Kingdom of Lesotho",
					"common": "Lesotho"
				}
			}
		},
		"tld": [
			".ls"
		],
		"cca2": "LS",
		"ccn3": "426",
		"cca3": "LSO",
		"cioc": "LES",
		"currency": [
			"LSL",
			"ZAR"
		],
		"callingCode": [
			"266"
		],
		"capital": "Maseru",
		"altSpellings": [
			"LS",
			"Kingdom of Lesotho",
			"Muso oa Lesotho"
		],
		"region": "Africa",
		"subregion": "Southern Africa",
		"languages": {
			"eng": "English",
			"sot": "Sotho"
		},
		"translations": {
			"deu": {
				"official": "Königreich Lesotho",
				"common": "Lesotho"
			},
			"fra": {
				"official": "Royaume du Lesotho",
				"common": "Lesotho"
			},
			"hrv": {
				"official": "Kraljevina Lesoto",
				"common": "Lesoto"
			},
			"ita": {
				"official": "Regno del Lesotho",
				"common": "Lesotho"
			},
			"jpn": {
				"official": "レソト王国",
				"common": "レソト"
			},
			"nld": {
				"official": "Koninkrijk Lesotho",
				"common": "Lesotho"
			},
			"por": {
				"official": "Reino do Lesoto",
				"common": "Lesoto"
			},
			"rus": {
				"official": "Королевство Лесото",
				"common": "Лесото"
			},
			"spa": {
				"official": "Reino de Lesotho",
				"common": "Lesotho"
			},
			"svk": {
				"official": "Lesothské kráľovstvo",
				"common": "Lesotho"
			},
			"fin": {
				"official": "Lesothon kuningaskunta",
				"common": "Lesotho"
			},
			"zho": {
				"official": "莱索托王国",
				"common": "莱索托"
			}
		},
		"latlng": [
			-29.5,
			28.5
		],
		"demonym": "Mosotho",
		"landlocked": true,
		"borders": [
			"ZAF"
		],
		"area": 30355
	},
	{
		"name": {
			"common": "Lithuania",
			"official": "Republic of Lithuania",
			"native": {
				"lit": {
					"official": "Lietuvos Respublikos",
					"common": "Lietuva"
				}
			}
		},
		"tld": [
			".lt"
		],
		"cca2": "LT",
		"ccn3": "440",
		"cca3": "LTU",
		"cioc": "LTU",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"370"
		],
		"capital": "Vilnius",
		"altSpellings": [
			"LT",
			"Republic of Lithuania",
			"Lietuvos Respublika"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"lit": "Lithuanian"
		},
		"translations": {
			"deu": {
				"official": "Republik Litauen",
				"common": "Litauen"
			},
			"fra": {
				"official": "République de Lituanie",
				"common": "Lituanie"
			},
			"hrv": {
				"official": "Republika Litva",
				"common": "Litva"
			},
			"ita": {
				"official": "Repubblica di Lituania",
				"common": "Lituania"
			},
			"jpn": {
				"official": "リトアニア共和国",
				"common": "リトアニア"
			},
			"nld": {
				"official": "Republiek Litouwen",
				"common": "Litouwen"
			},
			"por": {
				"official": "República da Lituânia",
				"common": "Lituânia"
			},
			"rus": {
				"official": "Литовская Республика",
				"common": "Литва"
			},
			"spa": {
				"official": "República de Lituania",
				"common": "Lituania"
			},
			"svk": {
				"official": "Litovská republika",
				"common": "Litva"
			},
			"fin": {
				"official": "Liettuan tasavalta",
				"common": "Liettua"
			},
			"zho": {
				"official": "立陶宛共和国",
				"common": "立陶宛"
			}
		},
		"latlng": [
			56,
			24
		],
		"demonym": "Lithuanian",
		"landlocked": false,
		"borders": [
			"BLR",
			"LVA",
			"POL",
			"RUS"
		],
		"area": 65300
	},
	{
		"name": {
			"common": "Luxembourg",
			"official": "Grand Duchy of Luxembourg",
			"native": {
				"deu": {
					"official": "Großherzogtum Luxemburg",
					"common": "Luxemburg"
				},
				"fra": {
					"official": "Grand-Duché de Luxembourg",
					"common": "Luxembourg"
				},
				"ltz": {
					"official": "Groussherzogtum Lëtzebuerg",
					"common": "Lëtzebuerg"
				}
			}
		},
		"tld": [
			".lu"
		],
		"cca2": "LU",
		"ccn3": "442",
		"cca3": "LUX",
		"cioc": "LUX",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"352"
		],
		"capital": "Luxembourg",
		"altSpellings": [
			"LU",
			"Grand Duchy of Luxembourg",
			"Grand-Duché de Luxembourg",
			"Großherzogtum Luxemburg",
			"Groussherzogtum Lëtzebuerg"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"deu": "German",
			"fra": "French",
			"ltz": "Luxembourgish"
		},
		"translations": {
			"deu": {
				"official": "Großherzogtum Luxemburg,",
				"common": "Luxemburg"
			},
			"fra": {
				"official": "Grand-Duché de Luxembourg",
				"common": "Luxembourg"
			},
			"hrv": {
				"official": "Veliko Vojvodstvo Luksemburg",
				"common": "Luksemburg"
			},
			"ita": {
				"official": "Granducato di Lussemburgo",
				"common": "Lussemburgo"
			},
			"jpn": {
				"official": "ルクセンブルク大公国",
				"common": "ルクセンブルク"
			},
			"nld": {
				"official": "Groothertogdom Luxemburg",
				"common": "Luxemburg"
			},
			"por": {
				"official": "Grão-Ducado do Luxemburgo",
				"common": "Luxemburgo"
			},
			"rus": {
				"official": "Великое Герцогство Люксембург",
				"common": "Люксембург"
			},
			"spa": {
				"official": "Gran Ducado de Luxemburgo",
				"common": "Luxemburgo"
			},
			"svk": {
				"official": "Luxemburské veľkovojvodstvo",
				"common": "Luxembursko"
			},
			"fin": {
				"official": "Luxemburgin suurherttuakunta",
				"common": "Luxemburg"
			},
			"zho": {
				"official": "卢森堡大公国",
				"common": "卢森堡"
			}
		},
		"latlng": [
			49.75,
			6.16666666
		],
		"demonym": "Luxembourger",
		"landlocked": true,
		"borders": [
			"BEL",
			"FRA",
			"DEU"
		],
		"area": 2586
	},
	{
		"name": {
			"common": "Latvia",
			"official": "Republic of Latvia",
			"native": {
				"lav": {
					"official": "Latvijas Republikas",
					"common": "Latvija"
				}
			}
		},
		"tld": [
			".lv"
		],
		"cca2": "LV",
		"ccn3": "428",
		"cca3": "LVA",
		"cioc": "LAT",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"371"
		],
		"capital": "Riga",
		"altSpellings": [
			"LV",
			"Republic of Latvia",
			"Latvijas Republika"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"lav": "Latvian"
		},
		"translations": {
			"deu": {
				"official": "Republik Lettland",
				"common": "Lettland"
			},
			"fra": {
				"official": "République de Lettonie",
				"common": "Lettonie"
			},
			"hrv": {
				"official": "Republika Latvija",
				"common": "Latvija"
			},
			"ita": {
				"official": "Repubblica di Lettonia",
				"common": "Lettonia"
			},
			"jpn": {
				"official": "ラトビア共和国",
				"common": "ラトビア"
			},
			"nld": {
				"official": "Republiek Letland",
				"common": "Letland"
			},
			"por": {
				"official": "República da Letónia",
				"common": "Letónia"
			},
			"rus": {
				"official": "Латвийская Республика",
				"common": "Латвия"
			},
			"spa": {
				"official": "República de Letonia",
				"common": "Letonia"
			},
			"svk": {
				"official": "Lotyšská republika",
				"common": "Lotyšsko"
			},
			"fin": {
				"official": "Latvian tasavalta",
				"common": "Latvia"
			},
			"zho": {
				"official": "拉脱维亚共和国",
				"common": "拉脱维亚"
			}
		},
		"latlng": [
			57,
			25
		],
		"demonym": "Latvian",
		"landlocked": false,
		"borders": [
			"BLR",
			"EST",
			"LTU",
			"RUS"
		],
		"area": 64559
	},
	{
		"name": {
			"common": "Macau",
			"official": "Macao Special Administrative Region of the People's Republic of China",
			"native": {
				"por": {
					"official": "Região Administrativa Especial de Macau da República Popular da China",
					"common": "Macau"
				},
				"zho": {
					"official": "中华人民共和国澳门特别行政区",
					"common": "澳门"
				}
			}
		},
		"tld": [
			".mo"
		],
		"cca2": "MO",
		"ccn3": "446",
		"cca3": "MAC",
		"cioc": "",
		"currency": [
			"MOP"
		],
		"callingCode": [
			"853"
		],
		"capital": "",
		"altSpellings": [
			"MO",
			"澳门",
			"Macao",
			"Macao Special Administrative Region of the People's Republic of China",
			"中華人民共和國澳門特別行政區",
			"Região Administrativa Especial de Macau da República Popular da China"
		],
		"region": "Asia",
		"subregion": "Eastern Asia",
		"languages": {
			"por": "Portuguese",
			"zho": "Chinese"
		},
		"translations": {
			"deu": {
				"official": "Sonderverwaltungsregion Macau der Volksrepublik China",
				"common": "Macao"
			},
			"fra": {
				"official": "Région administrative spéciale de Macao de la République populaire de Chine",
				"common": "Macao"
			},
			"hrv": {
				"official": "Makao Posebnog upravnog područjaNarodne Republike Kine",
				"common": "Makao"
			},
			"ita": {
				"official": "Macao Regione amministrativa speciale della Repubblica Popolare Cinese",
				"common": "Macao"
			},
			"jpn": {
				"official": "中華人民共和国マカオ特別行政区",
				"common": "マカオ"
			},
			"nld": {
				"official": "Speciale Administratieve Regio Macau van de Volksrepubliek China",
				"common": "Macao"
			},
			"por": {
				"official": "Macau Região Administrativa Especial da República Popular da China",
				"common": "Macau"
			},
			"rus": {
				"official": "Специальный административный район Макао Китайской Народной Республики Китай",
				"common": "Макао"
			},
			"spa": {
				"official": "Macao, Región Administrativa Especial de la República Popular China",
				"common": "Macao"
			},
			"svk": {
				"official": "Macao, Špeciàlna administratívna oblasŦ",
				"common": "Macao"
			},
			"fin": {
				"official": "Macaon Kiinan kansantasavallan erityishallintoalue",
				"common": "Macao"
			}
		},
		"latlng": [
			22.16666666,
			113.55
		],
		"demonym": "Chinese",
		"landlocked": false,
		"borders": [
			"CHN"
		],
		"area": 30
	},
	{
		"name": {
			"common": "Saint Martin",
			"official": "Saint Martin",
			"native": {
				"fra": {
					"official": "Saint-Martin",
					"common": "Saint-Martin"
				}
			}
		},
		"tld": [
			".fr",
			".gp"
		],
		"cca2": "MF",
		"ccn3": "663",
		"cca3": "MAF",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"590"
		],
		"capital": "Marigot",
		"altSpellings": [
			"MF",
			"Collectivity of Saint Martin",
			"Collectivité de Saint-Martin",
			"Saint Martin (French part)"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "St. Martin",
				"common": "Saint Martin"
			},
			"fra": {
				"official": "Saint-Martin",
				"common": "Saint-Martin"
			},
			"hrv": {
				"official": "Saint Martin",
				"common": "Sveti Martin"
			},
			"ita": {
				"official": "saint Martin",
				"common": "Saint Martin"
			},
			"jpn": {
				"official": "サンマルタン島",
				"common": "サン・マルタン（フランス領）"
			},
			"nld": {
				"official": "Saint Martin",
				"common": "Saint-Martin"
			},
			"por": {
				"official": "saint Martin",
				"common": "São Martinho"
			},
			"rus": {
				"official": "Сен-Мартен",
				"common": "Сен-Мартен"
			},
			"spa": {
				"official": "Saint Martin",
				"common": "Saint Martin"
			},
			"svk": {
				"official": "Svätý Martin",
				"common": "Svätý Martin"
			},
			"fin": {
				"official": "Saint-Martin",
				"common": "Saint-Martin"
			},
			"zho": {
				"official": "圣马丁",
				"common": "圣马丁"
			}
		},
		"latlng": [
			18.08333333,
			-63.95
		],
		"demonym": "Saint Martin Islander",
		"landlocked": false,
		"borders": [
			"SXM"
		],
		"area": 53
	},
	{
		"name": {
			"common": "Morocco",
			"official": "Kingdom of Morocco",
			"native": {
				"ara": {
					"official": "المملكة المغربية",
					"common": "المغرب"
				},
				"ber": {
					"official": "ⵜⴰⴳⵍⴷⵉⵜ ⵏ ⵍⵎⵖⵔⵉⴱ",
					"common": "ⵍⵎⴰⵖⵔⵉⴱ"
				}
			}
		},
		"tld": [
			".ma",
			"المغرب."
		],
		"cca2": "MA",
		"ccn3": "504",
		"cca3": "MAR",
		"cioc": "MAR",
		"currency": [
			"MAD"
		],
		"callingCode": [
			"212"
		],
		"capital": "Rabat",
		"altSpellings": [
			"MA",
			"Kingdom of Morocco",
			"Al-Mamlakah al-Maġribiyah"
		],
		"region": "Africa",
		"subregion": "Northern Africa",
		"languages": {
			"ara": "Arabic",
			"ber": "Berber"
		},
		"translations": {
			"deu": {
				"official": "Königreich Marokko",
				"common": "Marokko"
			},
			"fra": {
				"official": "Royaume du Maroc",
				"common": "Maroc"
			},
			"hrv": {
				"official": "Kraljevina Maroko",
				"common": "Maroko"
			},
			"ita": {
				"official": "Regno del Marocco",
				"common": "Marocco"
			},
			"jpn": {
				"official": "モロッコ王国",
				"common": "モロッコ"
			},
			"nld": {
				"official": "Koninkrijk Marokko",
				"common": "Marokko"
			},
			"por": {
				"official": "Reino de Marrocos",
				"common": "Marrocos"
			},
			"rus": {
				"official": "Королевство Марокко",
				"common": "Марокко"
			},
			"spa": {
				"official": "Reino de Marruecos",
				"common": "Marruecos"
			},
			"svk": {
				"official": "Marocké kniežatstvo",
				"common": "Maroko"
			},
			"fin": {
				"official": "Marokon kuningaskunta",
				"common": "Marokko"
			},
			"zho": {
				"official": "摩洛哥王国",
				"common": "摩洛哥"
			}
		},
		"latlng": [
			32,
			-5
		],
		"demonym": "Moroccan",
		"landlocked": false,
		"borders": [
			"DZA",
			"ESH",
			"ESP"
		],
		"area": 446550
	},
	{
		"name": {
			"common": "Monaco",
			"official": "Principality of Monaco",
			"native": {
				"fra": {
					"official": "Principauté de Monaco",
					"common": "Monaco"
				}
			}
		},
		"tld": [
			".mc"
		],
		"cca2": "MC",
		"ccn3": "492",
		"cca3": "MCO",
		"cioc": "MON",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"377"
		],
		"capital": "Monaco",
		"altSpellings": [
			"MC",
			"Principality of Monaco",
			"Principauté de Monaco"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Fürstentum Monaco",
				"common": "Monaco"
			},
			"fra": {
				"official": "Principauté de Monaco",
				"common": "Monaco"
			},
			"hrv": {
				"official": "Kneževina Monako",
				"common": "Monako"
			},
			"ita": {
				"official": "Principato di Monaco",
				"common": "Principato di Monaco"
			},
			"jpn": {
				"official": "モナコ公国",
				"common": "モナコ"
			},
			"nld": {
				"official": "Vorstendom Monaco",
				"common": "Monaco"
			},
			"por": {
				"official": "Principado do Mónaco",
				"common": "Mónaco"
			},
			"rus": {
				"official": "Княжество Монако",
				"common": "Монако"
			},
			"spa": {
				"official": "Principado de Mónaco",
				"common": "Mónaco"
			},
			"svk": {
				"official": "Monacké kniežatstvo",
				"common": "Monako"
			},
			"fin": {
				"official": "Monacon ruhtinaskunta",
				"common": "Monaco"
			},
			"zho": {
				"official": "摩纳哥公国",
				"common": "摩纳哥"
			}
		},
		"latlng": [
			43.73333333,
			7.4
		],
		"demonym": "Monegasque",
		"landlocked": false,
		"borders": [
			"FRA"
		],
		"area": 2.02
	},
	{
		"name": {
			"common": "Moldova",
			"official": "Republic of Moldova",
			"native": {
				"ron": {
					"official": "Republica Moldova",
					"common": "Moldova"
				}
			}
		},
		"tld": [
			".md"
		],
		"cca2": "MD",
		"ccn3": "498",
		"cca3": "MDA",
		"cioc": "MDA",
		"currency": [
			"MDL"
		],
		"callingCode": [
			"373"
		],
		"capital": "Chișinău",
		"altSpellings": [
			"MD",
			"Moldova, Republic of",
			"Republic of Moldova",
			"Republica Moldova"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"ron": "Moldavian"
		},
		"translations": {
			"deu": {
				"official": "Republik Moldau",
				"common": "Moldawie"
			},
			"fra": {
				"official": "République de Moldavie",
				"common": "Moldavie"
			},
			"hrv": {
				"official": "Moldavija",
				"common": "Moldova"
			},
			"ita": {
				"official": "Repubblica di Moldova",
				"common": "Moldavia"
			},
			"jpn": {
				"official": "モルドバ共和国",
				"common": "モルドバ共和国"
			},
			"nld": {
				"official": "Republiek Moldavië",
				"common": "Moldavië"
			},
			"por": {
				"official": "República da Moldávia",
				"common": "Moldávia"
			},
			"rus": {
				"official": "Молдова",
				"common": "Молдавия"
			},
			"spa": {
				"official": "República de Moldova",
				"common": "Moldavia"
			},
			"svk": {
				"official": "Moldavská republika",
				"common": "Moldavsko"
			},
			"fin": {
				"official": "Moldovan tasavalta",
				"common": "Moldova"
			},
			"zho": {
				"official": "摩尔多瓦共和国",
				"common": "摩尔多瓦"
			}
		},
		"latlng": [
			47,
			29
		],
		"demonym": "Moldovan",
		"landlocked": true,
		"borders": [
			"ROU",
			"UKR"
		],
		"area": 33846
	},
	{
		"name": {
			"common": "Madagascar",
			"official": "Republic of Madagascar",
			"native": {
				"fra": {
					"official": "République de Madagascar",
					"common": "Madagascar"
				},
				"mlg": {
					"official": "Repoblikan'i Madagasikara",
					"common": "Madagasikara"
				}
			}
		},
		"tld": [
			".mg"
		],
		"cca2": "MG",
		"ccn3": "450",
		"cca3": "MDG",
		"cioc": "MAD",
		"currency": [
			"MGA"
		],
		"callingCode": [
			"261"
		],
		"capital": "Antananarivo",
		"altSpellings": [
			"MG",
			"Republic of Madagascar",
			"Repoblikan'i Madagasikara",
			"République de Madagascar"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"fra": "French",
			"mlg": "Malagasy"
		},
		"translations": {
			"deu": {
				"official": "Republik Madagaskar",
				"common": "Madagaskar"
			},
			"fra": {
				"official": "République de Madagascar",
				"common": "Madagascar"
			},
			"hrv": {
				"official": "Republika Madagaskar",
				"common": "Madagaskar"
			},
			"ita": {
				"official": "Repubblica del Madagascar",
				"common": "Madagascar"
			},
			"jpn": {
				"official": "マダガスカル共和国",
				"common": "マダガスカル"
			},
			"nld": {
				"official": "Republiek Madagaskar",
				"common": "Madagaskar"
			},
			"por": {
				"official": "República de Madagáscar",
				"common": "Madagáscar"
			},
			"rus": {
				"official": "Республика Мадагаскар",
				"common": "Мадагаскар"
			},
			"spa": {
				"official": "República de Madagascar",
				"common": "Madagascar"
			},
			"svk": {
				"official": "Madagaskarská republika",
				"common": "Madagaskar"
			},
			"fin": {
				"official": "Madagaskarin tasavalta",
				"common": "Madagaskar"
			},
			"zho": {
				"official": "马达加斯加共和国",
				"common": "马达加斯加"
			}
		},
		"latlng": [
			-20,
			47
		],
		"demonym": "Malagasy",
		"landlocked": false,
		"borders": [],
		"area": 587041
	},
	{
		"name": {
			"common": "Maldives",
			"official": "Republic of the Maldives",
			"native": {
				"div": {
					"official": "ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ",
					"common": "ދިވެހިރާއްޖޭގެ"
				}
			}
		},
		"tld": [
			".mv"
		],
		"cca2": "MV",
		"ccn3": "462",
		"cca3": "MDV",
		"cioc": "MDV",
		"currency": [
			"MVR"
		],
		"callingCode": [
			"960"
		],
		"capital": "Malé",
		"altSpellings": [
			"MV",
			"Maldive Islands",
			"Republic of the Maldives",
			"Dhivehi Raajjeyge Jumhooriyya"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"div": "Maldivian"
		},
		"translations": {
			"deu": {
				"official": "Republik Malediven",
				"common": "Malediven"
			},
			"fra": {
				"official": "République des Maldives",
				"common": "Maldives"
			},
			"hrv": {
				"official": "Republika Maldivi",
				"common": "Maldivi"
			},
			"ita": {
				"official": "Repubblica delle Maldive",
				"common": "Maldive"
			},
			"jpn": {
				"official": "モルディブ共和国",
				"common": "モルディブ"
			},
			"nld": {
				"official": "Republiek van de Malediven",
				"common": "Maldiven"
			},
			"por": {
				"official": "República das Maldivas",
				"common": "Maldivas"
			},
			"rus": {
				"official": "Республика Мальдивы",
				"common": "Мальдивы"
			},
			"spa": {
				"official": "República de las Maldivas",
				"common": "Maldivas"
			},
			"svk": {
				"official": "Maldivská republika",
				"common": "Maldivy"
			},
			"fin": {
				"official": "Malediivien tasavalta",
				"common": "Malediivit"
			},
			"zho": {
				"official": "马尔代夫共和国",
				"common": "马尔代夫"
			}
		},
		"latlng": [
			3.25,
			73
		],
		"demonym": "Maldivan",
		"landlocked": false,
		"borders": [],
		"area": 300
	},
	{
		"name": {
			"common": "Mexico",
			"official": "United Mexican States",
			"native": {
				"spa": {
					"official": "Estados Unidos Mexicanos",
					"common": "México"
				}
			}
		},
		"tld": [
			".mx"
		],
		"cca2": "MX",
		"ccn3": "484",
		"cca3": "MEX",
		"cioc": "MEX",
		"currency": [
			"MXN"
		],
		"callingCode": [
			"52"
		],
		"capital": "Mexico City",
		"altSpellings": [
			"MX",
			"Mexicanos",
			"United Mexican States",
			"Estados Unidos Mexicanos"
		],
		"region": "Americas",
		"subregion": "Central America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Vereinigte Mexikanische Staaten",
				"common": "Mexiko"
			},
			"fra": {
				"official": "États-Unis du Mexique",
				"common": "Mexique"
			},
			"hrv": {
				"official": "Sjedinjene Meksičke Države",
				"common": "Meksiko"
			},
			"ita": {
				"official": "Stati Uniti del Messico",
				"common": "Messico"
			},
			"jpn": {
				"official": "メキシコ合衆国",
				"common": "メキシコ"
			},
			"nld": {
				"official": "Verenigde Mexicaanse Staten",
				"common": "Mexico"
			},
			"por": {
				"official": "Estados Unidos Mexicanos",
				"common": "México"
			},
			"rus": {
				"official": "Мексиканских Соединенных Штатов",
				"common": "Мексика"
			},
			"spa": {
				"official": "Estados Unidos Mexicanos",
				"common": "México"
			},
			"svk": {
				"official": "Spojené štášy mexické",
				"common": "Mexiko"
			},
			"fin": {
				"official": "Meksikon yhdysvallat",
				"common": "Meksiko"
			},
			"zho": {
				"official": "墨西哥合众国",
				"common": "墨西哥"
			}
		},
		"latlng": [
			23,
			-102
		],
		"demonym": "Mexican",
		"landlocked": false,
		"borders": [
			"BLZ",
			"GTM",
			"USA"
		],
		"area": 1964375
	},
	{
		"name": {
			"common": "Marshall Islands",
			"official": "Republic of the Marshall Islands",
			"native": {
				"eng": {
					"official": "Republic of the Marshall Islands",
					"common": "Marshall Islands"
				},
				"mah": {
					"official": "Republic of the Marshall Islands",
					"common": "M̧ajeļ"
				}
			}
		},
		"tld": [
			".mh"
		],
		"cca2": "MH",
		"ccn3": "584",
		"cca3": "MHL",
		"cioc": "MHL",
		"currency": [
			"USD"
		],
		"callingCode": [
			"692"
		],
		"capital": "Majuro",
		"altSpellings": [
			"MH",
			"Republic of the Marshall Islands",
			"Aolepān Aorōkin M̧ajeļ"
		],
		"region": "Oceania",
		"subregion": "Micronesia",
		"languages": {
			"eng": "English",
			"mah": "Marshallese"
		},
		"translations": {
			"deu": {
				"official": "Republik der Marshall-Inseln",
				"common": "Marshallinseln"
			},
			"fra": {
				"official": "République des Îles Marshall",
				"common": "Îles Marshall"
			},
			"hrv": {
				"official": "Republika Maršalovi Otoci",
				"common": "Maršalovi Otoci"
			},
			"ita": {
				"official": "Repubblica delle Isole Marshall",
				"common": "Isole Marshall"
			},
			"jpn": {
				"official": "マーシャル諸島共和国",
				"common": "マーシャル諸島"
			},
			"nld": {
				"official": "Republiek van de Marshall-eilanden",
				"common": "Marshalleilanden"
			},
			"por": {
				"official": "República das Ilhas Marshall",
				"common": "Ilhas Marshall"
			},
			"rus": {
				"official": "Республика Маршалловы острова",
				"common": "Маршалловы Острова"
			},
			"spa": {
				"official": "República de las Islas Marshall",
				"common": "Islas Marshall"
			},
			"svk": {
				"official": "Republika Marshallových ostrovov",
				"common": "Marshallove ostrovy"
			},
			"fin": {
				"official": "Marshallinsaarten tasavalta",
				"common": "Marshallinsaaret"
			},
			"zho": {
				"official": "马绍尔群岛共和国",
				"common": "马绍尔群岛"
			}
		},
		"latlng": [
			9,
			168
		],
		"demonym": "Marshallese",
		"landlocked": false,
		"borders": [],
		"area": 181
	},
	{
		"name": {
			"common": "Macedonia",
			"official": "Republic of Macedonia",
			"native": {
				"mkd": {
					"official": "Република Македонија",
					"common": "Македонија"
				}
			}
		},
		"tld": [
			".mk"
		],
		"cca2": "MK",
		"ccn3": "807",
		"cca3": "MKD",
		"cioc": "MKD",
		"currency": [
			"MKD"
		],
		"callingCode": [
			"389"
		],
		"capital": "Skopje",
		"altSpellings": [
			"MK",
			"Macedonia, the Former Yugoslav Republic of",
			"Republic of Macedonia",
			"Република Македонија"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"mkd": "Macedonian"
		},
		"translations": {
			"deu": {
				"official": "Republik Mazedonien",
				"common": "Mazedonien"
			},
			"fra": {
				"official": "République de Macédoine",
				"common": "Macédoine"
			},
			"hrv": {
				"official": "Republika Makedonija",
				"common": "Makedonija"
			},
			"ita": {
				"official": "Repubblica di Macedonia",
				"common": "Macedonia"
			},
			"jpn": {
				"official": "マケドニア共和国",
				"common": "マケドニア旧ユーゴスラビア共和国"
			},
			"nld": {
				"official": "Republic of Macedonia",
				"common": "Macedonië"
			},
			"por": {
				"official": "República da Macedónia",
				"common": "Macedónia"
			},
			"rus": {
				"official": "Республика Македония",
				"common": "Республика Македония"
			},
			"spa": {
				"official": "República de Macedonia",
				"common": "Macedonia"
			},
			"svk": {
				"official": "Macedónska republika",
				"common": "Macedónsko"
			},
			"fin": {
				"official": "Makedonian tasavalta",
				"common": "Makedonia"
			},
			"zho": {
				"official": "马其顿共和国",
				"common": "马其顿"
			}
		},
		"latlng": [
			41.83333333,
			22
		],
		"demonym": "Macedonian",
		"landlocked": true,
		"borders": [
			"ALB",
			"BGR",
			"GRC",
			"UNK",
			"SRB"
		],
		"area": 25713
	},
	{
		"name": {
			"common": "Mali",
			"official": "Republic of Mali",
			"native": {
				"fra": {
					"official": "République du Mali",
					"common": "Mali"
				}
			}
		},
		"tld": [
			".ml"
		],
		"cca2": "ML",
		"ccn3": "466",
		"cca3": "MLI",
		"cioc": "MLI",
		"currency": [
			"XOF"
		],
		"callingCode": [
			"223"
		],
		"capital": "Bamako",
		"altSpellings": [
			"ML",
			"Republic of Mali",
			"République du Mali"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Republik Mali",
				"common": "Mali"
			},
			"fra": {
				"official": "République du Mali",
				"common": "Mali"
			},
			"hrv": {
				"official": "Republika Mali",
				"common": "Mali"
			},
			"ita": {
				"official": "Repubblica del Mali",
				"common": "Mali"
			},
			"jpn": {
				"official": "マリ共和国",
				"common": "マリ"
			},
			"nld": {
				"official": "Republiek Mali",
				"common": "Mali"
			},
			"por": {
				"official": "República do Mali",
				"common": "Mali"
			},
			"rus": {
				"official": "Республика Мали",
				"common": "Мали"
			},
			"spa": {
				"official": "República de Malí",
				"common": "Mali"
			},
			"svk": {
				"official": "Malijská republika",
				"common": "Mali"
			},
			"fin": {
				"official": "Malin tasavalta",
				"common": "Mali"
			},
			"zho": {
				"official": "马里共和国",
				"common": "马里"
			}
		},
		"latlng": [
			17,
			-4
		],
		"demonym": "Malian",
		"landlocked": true,
		"borders": [
			"DZA",
			"BFA",
			"GIN",
			"CIV",
			"MRT",
			"NER",
			"SEN"
		],
		"area": 1240192
	},
	{
		"name": {
			"common": "Malta",
			"official": "Republic of Malta",
			"native": {
				"eng": {
					"official": "Republic of Malta",
					"common": "Malta"
				},
				"mlt": {
					"official": "Repubblika ta ' Malta",
					"common": "Malta"
				}
			}
		},
		"tld": [
			".mt"
		],
		"cca2": "MT",
		"ccn3": "470",
		"cca3": "MLT",
		"cioc": "MLT",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"356"
		],
		"capital": "Valletta",
		"altSpellings": [
			"MT",
			"Republic of Malta",
			"Repubblika ta' Malta"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"eng": "English",
			"mlt": "Maltese"
		},
		"translations": {
			"deu": {
				"official": "Republik Malta",
				"common": "Malta"
			},
			"fra": {
				"official": "République de Malte",
				"common": "Malte"
			},
			"hrv": {
				"official": "Republika Malta",
				"common": "Malta"
			},
			"ita": {
				"official": "Repubblica di Malta",
				"common": "Malta"
			},
			"jpn": {
				"official": "マルタ共和国",
				"common": "マルタ"
			},
			"nld": {
				"official": "Republiek Malta",
				"common": "Malta"
			},
			"por": {
				"official": "República de Malta",
				"common": "Malta"
			},
			"rus": {
				"official": "Республика Мальта",
				"common": "Мальта"
			},
			"spa": {
				"official": "República de Malta",
				"common": "Malta"
			},
			"svk": {
				"official": "Maltská republika",
				"common": "Malta"
			},
			"fin": {
				"official": "Maltan tasavalta",
				"common": "Malta"
			},
			"zho": {
				"official": "马耳他共和国",
				"common": "马耳他"
			}
		},
		"latlng": [
			35.83333333,
			14.58333333
		],
		"demonym": "Maltese",
		"landlocked": false,
		"borders": [],
		"area": 316
	},
	{
		"name": {
			"common": "Myanmar",
			"official": "Republic of the Union of Myanmar",
			"native": {
				"mya": {
					"official": "ပြည်ထောင်စု သမ္မတ မြန်မာနိုင်ငံတော်",
					"common": "မြန်မာ"
				}
			}
		},
		"tld": [
			".mm"
		],
		"cca2": "MM",
		"ccn3": "104",
		"cca3": "MMR",
		"cioc": "MYA",
		"currency": [
			"MMK"
		],
		"callingCode": [
			"95"
		],
		"capital": "Naypyidaw",
		"altSpellings": [
			"MM",
			"Burma",
			"Republic of the Union of Myanmar",
			"Pyidaunzu Thanmăda Myăma Nainngandaw"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"mya": "Burmese"
		},
		"translations": {
			"deu": {
				"official": "Republik der Union von Myanmar",
				"common": "Myanmar"
			},
			"fra": {
				"official": "République de l'Union du Myanmar",
				"common": "Birmanie"
			},
			"hrv": {
				"official": "Republika Unije Mijanmar",
				"common": "Mijanmar"
			},
			"ita": {
				"official": "Repubblica dell'Unione di Myanmar",
				"common": "Birmania"
			},
			"jpn": {
				"official": "ミャンマー連邦共和国",
				"common": "ミャンマー"
			},
			"nld": {
				"official": "Republiek van de Unie van Myanmar",
				"common": "Myanmar"
			},
			"por": {
				"official": "República da União de Myanmar",
				"common": "Myanmar"
			},
			"rus": {
				"official": "Республика Союза Мьянма",
				"common": "Мьянма"
			},
			"spa": {
				"official": "República de la Unión de Myanmar",
				"common": "Myanmar"
			},
			"svk": {
				"official": "Mjanmarská zväzová republika",
				"common": "Mjanmarsko"
			},
			"fin": {
				"official": "Myanmarin liiton tasavalta",
				"common": "Myanmar"
			},
			"zho": {
				"official": "缅甸联邦共和国",
				"common": "缅甸"
			}
		},
		"latlng": [
			22,
			98
		],
		"demonym": "Bamar",
		"landlocked": false,
		"borders": [
			"BGD",
			"CHN",
			"IND",
			"LAO",
			"THA"
		],
		"area": 676578
	},
	{
		"name": {
			"common": "Montenegro",
			"official": "Montenegro",
			"native": {
				"srp": {
					"official": "Црна Гора",
					"common": "Црна Гора"
				}
			}
		},
		"tld": [
			".me"
		],
		"cca2": "ME",
		"ccn3": "499",
		"cca3": "MNE",
		"cioc": "MNE",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"382"
		],
		"capital": "Podgorica",
		"altSpellings": [
			"ME",
			"Crna Gora"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"srp": "Montenegrin"
		},
		"translations": {
			"deu": {
				"official": "Montenegro",
				"common": "Montenegro"
			},
			"fra": {
				"official": "Monténégro",
				"common": "Monténégro"
			},
			"hrv": {
				"official": "Crna Gora",
				"common": "Crna Gora"
			},
			"ita": {
				"official": "Montenegro",
				"common": "Montenegro"
			},
			"jpn": {
				"official": "モンテネグロ",
				"common": "モンテネグロ"
			},
			"nld": {
				"official": "Montenegro",
				"common": "Montenegro"
			},
			"por": {
				"official": "Montenegro",
				"common": "Montenegro"
			},
			"rus": {
				"official": "Черногория",
				"common": "Черногория"
			},
			"spa": {
				"official": "Montenegro",
				"common": "Montenegro"
			},
			"svk": {
				"official": "Čierna Hora",
				"common": "Čierna Hora"
			},
			"fin": {
				"official": "Montenegro",
				"common": "Montenegro"
			},
			"zho": {
				"official": "黑山",
				"common": "黑山"
			}
		},
		"latlng": [
			42.5,
			19.3
		],
		"demonym": "Montenegrin",
		"landlocked": false,
		"borders": [
			"ALB",
			"BIH",
			"HRV",
			"UNK",
			"SRB"
		],
		"area": 13812
	},
	{
		"name": {
			"common": "Mongolia",
			"official": "Mongolia",
			"native": {
				"mon": {
					"official": "Монгол улс",
					"common": "Монгол улс"
				}
			}
		},
		"tld": [
			".mn"
		],
		"cca2": "MN",
		"ccn3": "496",
		"cca3": "MNG",
		"cioc": "MGL",
		"currency": [
			"MNT"
		],
		"callingCode": [
			"976"
		],
		"capital": "Ulan Bator",
		"altSpellings": [
			"MN"
		],
		"region": "Asia",
		"subregion": "Eastern Asia",
		"languages": {
			"mon": "Mongolian"
		},
		"translations": {
			"deu": {
				"official": "Mongolei",
				"common": "Mongolei"
			},
			"fra": {
				"official": "Mongolie",
				"common": "Mongolie"
			},
			"hrv": {
				"official": "Mongolija",
				"common": "Mongolija"
			},
			"ita": {
				"official": "Mongolia",
				"common": "Mongolia"
			},
			"jpn": {
				"official": "モンゴル",
				"common": "モンゴル"
			},
			"nld": {
				"official": "Mongolië",
				"common": "Mongolië"
			},
			"por": {
				"official": "Mongólia",
				"common": "Mongólia"
			},
			"rus": {
				"official": "Монголия",
				"common": "Монголия"
			},
			"spa": {
				"official": "Mongolia",
				"common": "Mongolia"
			},
			"svk": {
				"official": "Mongolsko",
				"common": "Mongolsko"
			},
			"fin": {
				"official": "Mongolian tasavalta",
				"common": "Mongolia"
			},
			"zho": {
				"official": "蒙古",
				"common": "蒙古"
			}
		},
		"latlng": [
			46,
			105
		],
		"demonym": "Mongolian",
		"landlocked": true,
		"borders": [
			"CHN",
			"RUS"
		],
		"area": 1564110
	},
	{
		"name": {
			"common": "Northern Mariana Islands",
			"official": "Commonwealth of the Northern Mariana Islands",
			"native": {
				"cal": {
					"official": "Commonwealth of the Northern Mariana Islands",
					"common": "Northern Mariana Islands"
				},
				"cha": {
					"official": "Sankattan Siha Na Islas Mariånas",
					"common": "Na Islas Mariånas"
				},
				"eng": {
					"official": "Commonwealth of the Northern Mariana Islands",
					"common": "Northern Mariana Islands"
				}
			}
		},
		"tld": [
			".mp"
		],
		"cca2": "MP",
		"ccn3": "580",
		"cca3": "MNP",
		"cioc": "",
		"currency": [
			"USD"
		],
		"callingCode": [
			"1670"
		],
		"capital": "Saipan",
		"altSpellings": [
			"MP",
			"Commonwealth of the Northern Mariana Islands",
			"Sankattan Siha Na Islas Mariånas"
		],
		"region": "Oceania",
		"subregion": "Micronesia",
		"languages": {
			"cal": "Carolinian",
			"cha": "Chamorro",
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Commonwealth der Nördlichen Marianen",
				"common": "Nördliche Marianen"
			},
			"fra": {
				"official": "Commonwealth des îles Mariannes du Nord",
				"common": "Îles Mariannes du Nord"
			},
			"hrv": {
				"official": "Zajednica je Sjeverni Marijanski otoci",
				"common": "Sjevernomarijanski otoci"
			},
			"ita": {
				"official": "Commonwealth delle Isole Marianne Settentrionali",
				"common": "Isole Marianne Settentrionali"
			},
			"jpn": {
				"official": "北マリアナ諸島",
				"common": "北マリアナ諸島"
			},
			"nld": {
				"official": "Commonwealth van de Noordelijke Marianen",
				"common": "Noordelijke Marianeneilanden"
			},
			"por": {
				"official": "Comunidade das Ilhas Marianas do Norte",
				"common": "Marianas Setentrionais"
			},
			"rus": {
				"official": "Содружество Северных Марианских островов",
				"common": "Северные Марианские острова"
			},
			"spa": {
				"official": "Mancomunidad de las Islas Marianas del Norte",
				"common": "Islas Marianas del Norte"
			},
			"svk": {
				"official": "Spoločenstvo ostrovov Severné Mariány",
				"common": "Severné Mariány"
			},
			"fin": {
				"official": "Pohjois-Mariaanit",
				"common": "Pohjois-Mariaanit"
			},
			"zho": {
				"official": "北马里亚纳群岛",
				"common": "北马里亚纳群岛"
			}
		},
		"latlng": [
			15.2,
			145.75
		],
		"demonym": "American",
		"landlocked": false,
		"borders": [],
		"area": 464
	},
	{
		"name": {
			"common": "Mozambique",
			"official": "Republic of Mozambique",
			"native": {
				"por": {
					"official": "República de Moçambique",
					"common": "Moçambique"
				}
			}
		},
		"tld": [
			".mz"
		],
		"cca2": "MZ",
		"ccn3": "508",
		"cca3": "MOZ",
		"cioc": "MOZ",
		"currency": [
			"MZN"
		],
		"callingCode": [
			"258"
		],
		"capital": "Maputo",
		"altSpellings": [
			"MZ",
			"Republic of Mozambique",
			"República de Moçambique"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"por": "Portuguese"
		},
		"translations": {
			"deu": {
				"official": "Republik Mosambik",
				"common": "Mosambik"
			},
			"fra": {
				"official": "République du Mozambique",
				"common": "Mozambique"
			},
			"hrv": {
				"official": "Republika Mozambiku",
				"common": "Mozambik"
			},
			"ita": {
				"official": "Repubblica del Mozambico",
				"common": "Mozambico"
			},
			"jpn": {
				"official": "モザンビーク共和国",
				"common": "モザンビーク"
			},
			"nld": {
				"official": "Republiek Mozambique",
				"common": "Mozambique"
			},
			"por": {
				"official": "República de Moçambique",
				"common": "Moçambique"
			},
			"rus": {
				"official": "Республика Мозамбик",
				"common": "Мозамбик"
			},
			"spa": {
				"official": "República de Mozambique",
				"common": "Mozambique"
			},
			"svk": {
				"official": "Mozambická republika",
				"common": "Mozambik"
			},
			"fin": {
				"official": "Mosambikin tasavalta",
				"common": "Mosambik"
			},
			"zho": {
				"official": "莫桑比克共和国",
				"common": "莫桑比克"
			}
		},
		"latlng": [
			-18.25,
			35
		],
		"demonym": "Mozambican",
		"landlocked": false,
		"borders": [
			"MWI",
			"ZAF",
			"SWZ",
			"TZA",
			"ZMB",
			"ZWE"
		],
		"area": 801590
	},
	{
		"name": {
			"common": "Mauritania",
			"official": "Islamic Republic of Mauritania",
			"native": {
				"ara": {
					"official": "الجمهورية الإسلامية الموريتانية",
					"common": "موريتانيا"
				}
			}
		},
		"tld": [
			".mr"
		],
		"cca2": "MR",
		"ccn3": "478",
		"cca3": "MRT",
		"cioc": "MTN",
		"currency": [
			"MRO"
		],
		"callingCode": [
			"222"
		],
		"capital": "Nouakchott",
		"altSpellings": [
			"MR",
			"Islamic Republic of Mauritania",
			"al-Jumhūriyyah al-ʾIslāmiyyah al-Mūrītāniyyah"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Islamische Republik Mauretanien",
				"common": "Mauretanien"
			},
			"fra": {
				"official": "République islamique de Mauritanie",
				"common": "Mauritanie"
			},
			"hrv": {
				"official": "Islamska Republika Mauritanija",
				"common": "Mauritanija"
			},
			"ita": {
				"official": "Repubblica islamica di Mauritania",
				"common": "Mauritania"
			},
			"jpn": {
				"official": "モーリタニア·イスラム共和国",
				"common": "モーリタニア"
			},
			"nld": {
				"official": "Islamitische Republiek Mauritanië",
				"common": "Mauritanië"
			},
			"por": {
				"official": "República Islâmica da Mauritânia",
				"common": "Mauritânia"
			},
			"rus": {
				"official": "Исламская Республика Мавритания",
				"common": "Мавритания"
			},
			"spa": {
				"official": "República Islámica de Mauritania",
				"common": "Mauritania"
			},
			"svk": {
				"official": "Mauritánska islamská republika",
				"common": "Mauritánia"
			},
			"fin": {
				"official": "Mauritanian islamilainen tasavalta",
				"common": "Mauritania"
			},
			"zho": {
				"official": "毛里塔尼亚伊斯兰共和国",
				"common": "毛里塔尼亚"
			}
		},
		"latlng": [
			20,
			-12
		],
		"demonym": "Mauritanian",
		"landlocked": false,
		"borders": [
			"DZA",
			"MLI",
			"SEN",
			"ESH"
		],
		"area": 1030700
	},
	{
		"name": {
			"common": "Montserrat",
			"official": "Montserrat",
			"native": {
				"eng": {
					"official": "Montserrat",
					"common": "Montserrat"
				}
			}
		},
		"tld": [
			".ms"
		],
		"cca2": "MS",
		"ccn3": "500",
		"cca3": "MSR",
		"cioc": "",
		"currency": [
			"XCD"
		],
		"callingCode": [
			"1664"
		],
		"capital": "Plymouth",
		"altSpellings": [
			"MS"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"fra": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"hrv": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"ita": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"jpn": {
				"official": "モントセラト",
				"common": "モントセラト"
			},
			"nld": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"por": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"rus": {
				"official": "Монтсеррат",
				"common": "Монтсеррат"
			},
			"spa": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"svk": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"fin": {
				"official": "Montserrat",
				"common": "Montserrat"
			},
			"zho": {
				"official": "蒙特塞拉特",
				"common": "蒙特塞拉特"
			}
		},
		"latlng": [
			16.75,
			-62.2
		],
		"demonym": "Montserratian",
		"landlocked": false,
		"borders": [],
		"area": 102
	},
	{
		"name": {
			"common": "Martinique",
			"official": "Martinique",
			"native": {
				"fra": {
					"official": "Martinique",
					"common": "Martinique"
				}
			}
		},
		"tld": [
			".mq"
		],
		"cca2": "MQ",
		"ccn3": "474",
		"cca3": "MTQ",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"596"
		],
		"capital": "Fort-de-France",
		"altSpellings": [
			"MQ"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Martinique",
				"common": "Martinique"
			},
			"fra": {
				"official": "Martinique",
				"common": "Martinique"
			},
			"hrv": {
				"official": "Martinique",
				"common": "Martinique"
			},
			"ita": {
				"official": "Martinique",
				"common": "Martinica"
			},
			"jpn": {
				"official": "マルティニーク島",
				"common": "マルティニーク"
			},
			"nld": {
				"official": "Martinique",
				"common": "Martinique"
			},
			"por": {
				"official": "Martinique",
				"common": "Martinica"
			},
			"rus": {
				"official": "Мартиника",
				"common": "Мартиника"
			},
			"spa": {
				"official": "Martinica",
				"common": "Martinica"
			},
			"svk": {
				"official": "Martinik",
				"common": "Martinik"
			},
			"fin": {
				"official": "Martinique",
				"common": "Martinique"
			},
			"zho": {
				"official": "马提尼克",
				"common": "马提尼克"
			}
		},
		"latlng": [
			14.666667,
			-61
		],
		"demonym": "French",
		"landlocked": false,
		"borders": [],
		"area": 1128
	},
	{
		"name": {
			"common": "Mauritius",
			"official": "Republic of Mauritius",
			"native": {
				"eng": {
					"official": "Republic of Mauritius",
					"common": "Mauritius"
				},
				"fra": {
					"official": "République de Maurice",
					"common": "Maurice"
				},
				"mfe": {
					"official": "Republik Moris",
					"common": "Moris"
				}
			}
		},
		"tld": [
			".mu"
		],
		"cca2": "MU",
		"ccn3": "480",
		"cca3": "MUS",
		"cioc": "MRI",
		"currency": [
			"MUR"
		],
		"callingCode": [
			"230"
		],
		"capital": "Port Louis",
		"altSpellings": [
			"MU",
			"Republic of Mauritius",
			"République de Maurice"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"eng": "English",
			"fra": "French",
			"mfe": "Mauritian Creole"
		},
		"translations": {
			"deu": {
				"official": "Republik Mauritius",
				"common": "Mauritius"
			},
			"fra": {
				"official": "République de Maurice",
				"common": "Île Maurice"
			},
			"hrv": {
				"official": "Republika Mauricijus",
				"common": "Mauricijus"
			},
			"ita": {
				"official": "Repubblica di Mauritius",
				"common": "Mauritius"
			},
			"jpn": {
				"official": "モーリシャス共和国",
				"common": "モーリシャス"
			},
			"nld": {
				"official": "Republiek Mauritius",
				"common": "Mauritius"
			},
			"por": {
				"official": "República das Maurícias",
				"common": "Maurício"
			},
			"rus": {
				"official": "Республика Маврикий",
				"common": "Маврикий"
			},
			"spa": {
				"official": "República de Mauricio",
				"common": "Mauricio"
			},
			"svk": {
				"official": "Maurícijská republika",
				"common": "Maurícius"
			},
			"fin": {
				"official": "Mauritiuksen tasavalta",
				"common": "Mauritius"
			},
			"zho": {
				"official": "毛里求斯共和国",
				"common": "毛里求斯"
			}
		},
		"latlng": [
			-20.28333333,
			57.55
		],
		"demonym": "Mauritian",
		"landlocked": false,
		"borders": [],
		"area": 2040
	},
	{
		"name": {
			"common": "Malawi",
			"official": "Republic of Malawi",
			"native": {
				"eng": {
					"official": "Republic of Malawi",
					"common": "Malawi"
				},
				"nya": {
					"official": "Chalo cha Malawi, Dziko la Malaŵi",
					"common": "Malaŵi"
				}
			}
		},
		"tld": [
			".mw"
		],
		"cca2": "MW",
		"ccn3": "454",
		"cca3": "MWI",
		"cioc": "MAW",
		"currency": [
			"MWK"
		],
		"callingCode": [
			"265"
		],
		"capital": "Lilongwe",
		"altSpellings": [
			"MW",
			"Republic of Malawi"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"eng": "English",
			"nya": "Chewa"
		},
		"translations": {
			"deu": {
				"official": "Republik Malawi",
				"common": "Malawi"
			},
			"fra": {
				"official": "République du Malawi",
				"common": "Malawi"
			},
			"hrv": {
				"official": "Republika Malavi",
				"common": "Malavi"
			},
			"ita": {
				"official": "Repubblica del Malawi",
				"common": "Malawi"
			},
			"jpn": {
				"official": "マラウイ共和国",
				"common": "マラウイ"
			},
			"nld": {
				"official": "Republiek Malawi",
				"common": "Malawi"
			},
			"por": {
				"official": "República do Malawi",
				"common": "Malawi"
			},
			"rus": {
				"official": "Республика Малави",
				"common": "Малави"
			},
			"spa": {
				"official": "República de Malawi",
				"common": "Malawi"
			},
			"svk": {
				"official": "Malawijská republika",
				"common": "Malawi"
			},
			"fin": {
				"official": "Malawin tasavalta",
				"common": "Malawi"
			},
			"zho": {
				"official": "马拉维共和国",
				"common": "马拉维"
			}
		},
		"latlng": [
			-13.5,
			34
		],
		"demonym": "Malawian",
		"landlocked": true,
		"borders": [
			"MOZ",
			"TZA",
			"ZMB"
		],
		"area": 118484
	},
	{
		"name": {
			"common": "Malaysia",
			"official": "Malaysia",
			"native": {
				"eng": {
					"official": "Malaysia",
					"common": "Malaysia"
				},
				"msa": {
					"official": "مليسيا",
					"common": "مليسيا"
				}
			}
		},
		"tld": [
			".my"
		],
		"cca2": "MY",
		"ccn3": "458",
		"cca3": "MYS",
		"cioc": "MAS",
		"currency": [
			"MYR"
		],
		"callingCode": [
			"60"
		],
		"capital": "Kuala Lumpur",
		"altSpellings": [
			"MY"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"eng": "English",
			"msa": "Malay"
		},
		"translations": {
			"deu": {
				"official": "Malaysia",
				"common": "Malaysia"
			},
			"fra": {
				"official": "Fédération de Malaisie",
				"common": "Malaisie"
			},
			"hrv": {
				"official": "Malezija",
				"common": "Malezija"
			},
			"ita": {
				"official": "Malaysia",
				"common": "Malesia"
			},
			"jpn": {
				"official": "マレーシア",
				"common": "マレーシア"
			},
			"nld": {
				"official": "Maleisië",
				"common": "Maleisië"
			},
			"por": {
				"official": "Malásia",
				"common": "Malásia"
			},
			"rus": {
				"official": "Малайзия",
				"common": "Малайзия"
			},
			"spa": {
				"official": "Malasia",
				"common": "Malasia"
			},
			"svk": {
				"official": "Malajzia",
				"common": "Malajzia"
			},
			"fin": {
				"official": "Malesia",
				"common": "Malesia"
			},
			"zho": {
				"official": "马来西亚",
				"common": "马来西亚"
			}
		},
		"latlng": [
			2.5,
			112.5
		],
		"demonym": "Malaysian",
		"landlocked": false,
		"borders": [
			"BRN",
			"IDN",
			"THA"
		],
		"area": 330803
	},
	{
		"name": {
			"common": "Mayotte",
			"official": "Department of Mayotte",
			"native": {
				"fra": {
					"official": "Département de Mayotte",
					"common": "Mayotte"
				}
			}
		},
		"tld": [
			".yt"
		],
		"cca2": "YT",
		"ccn3": "175",
		"cca3": "MYT",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"262"
		],
		"capital": "Mamoudzou",
		"altSpellings": [
			"YT",
			"Department of Mayotte",
			"Département de Mayotte"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Übersee-Département Mayotte",
				"common": "Mayotte"
			},
			"fra": {
				"official": "Département de Mayotte",
				"common": "Mayotte"
			},
			"hrv": {
				"official": "Odjel Mayotte",
				"common": "Mayotte"
			},
			"ita": {
				"official": "Dipartimento di Mayotte",
				"common": "Mayotte"
			},
			"jpn": {
				"official": "マヨット科",
				"common": "マヨット"
			},
			"nld": {
				"official": "Afdeling Mayotte",
				"common": "Mayotte"
			},
			"por": {
				"official": "Departamento de Mayotte",
				"common": "Mayotte"
			},
			"rus": {
				"official": "Департамент Майотта",
				"common": "Майотта"
			},
			"spa": {
				"official": "Departamento de Mayotte",
				"common": "Mayotte"
			},
			"svk": {
				"official": "Department Mayotte",
				"common": "Mayotte"
			},
			"fin": {
				"official": "Mayotte",
				"common": "Mayotte"
			},
			"zho": {
				"official": "马约特",
				"common": "马约特"
			}
		},
		"latlng": [
			-12.83333333,
			45.16666666
		],
		"demonym": "Mahoran",
		"landlocked": false,
		"borders": [],
		"area": 374
	},
	{
		"name": {
			"common": "Namibia",
			"official": "Republic of Namibia",
			"native": {
				"afr": {
					"official": "Republiek van Namibië",
					"common": "Namibië"
				},
				"deu": {
					"official": "Republik Namibia",
					"common": "Namibia"
				},
				"eng": {
					"official": "Republic of Namibia",
					"common": "Namibia"
				},
				"her": {
					"official": "Republic of Namibia",
					"common": "Namibia"
				},
				"hgm": {
					"official": "Republic of Namibia",
					"common": "Namibia"
				},
				"kwn": {
					"official": "Republic of Namibia",
					"common": "Namibia"
				},
				"loz": {
					"official": "Republic of Namibia",
					"common": "Namibia"
				},
				"ndo": {
					"official": "Republic of Namibia",
					"common": "Namibia"
				},
				"tsn": {
					"official": "Lefatshe la Namibia",
					"common": "Namibia"
				}
			}
		},
		"tld": [
			".na"
		],
		"cca2": "NA",
		"ccn3": "516",
		"cca3": "NAM",
		"cioc": "NAM",
		"currency": [
			"NAD",
			"ZAR"
		],
		"callingCode": [
			"264"
		],
		"capital": "Windhoek",
		"altSpellings": [
			"NA",
			"Namibië",
			"Republic of Namibia"
		],
		"region": "Africa",
		"subregion": "Southern Africa",
		"languages": {
			"afr": "Afrikaans",
			"deu": "German",
			"eng": "English",
			"her": "Herero",
			"hgm": "Khoekhoe",
			"kwn": "Kwangali",
			"loz": "Lozi",
			"ndo": "Ndonga",
			"tsn": "Tswana"
		},
		"translations": {
			"deu": {
				"official": "Republik Namibia",
				"common": "Namibia"
			},
			"fra": {
				"official": "République de Namibie",
				"common": "Namibie"
			},
			"hrv": {
				"official": "Republika Namibija",
				"common": "Namibija"
			},
			"ita": {
				"official": "Repubblica di Namibia",
				"common": "Namibia"
			},
			"jpn": {
				"official": "ナミビア共和国",
				"common": "ナミビア"
			},
			"nld": {
				"official": "Republiek Namibië",
				"common": "Namibië"
			},
			"por": {
				"official": "República da Namíbia",
				"common": "Namíbia"
			},
			"rus": {
				"official": "Республика Намибия",
				"common": "Намибия"
			},
			"spa": {
				"official": "República de Namibia",
				"common": "Namibia"
			},
			"svk": {
				"official": "Namíbijská republika",
				"common": "Namíbia"
			},
			"fin": {
				"official": "Namibian tasavalta",
				"common": "Namibia"
			},
			"zho": {
				"official": "纳米比亚共和国",
				"common": "纳米比亚"
			}
		},
		"latlng": [
			-22,
			17
		],
		"demonym": "Namibian",
		"landlocked": false,
		"borders": [
			"AGO",
			"BWA",
			"ZAF",
			"ZMB"
		],
		"area": 825615
	},
	{
		"name": {
			"common": "New Caledonia",
			"official": "New Caledonia",
			"native": {
				"fra": {
					"official": "Nouvelle-Calédonie",
					"common": "Nouvelle-Calédonie"
				}
			}
		},
		"tld": [
			".nc"
		],
		"cca2": "NC",
		"ccn3": "540",
		"cca3": "NCL",
		"cioc": "",
		"currency": [
			"XPF"
		],
		"callingCode": [
			"687"
		],
		"capital": "Nouméa",
		"altSpellings": [
			"NC"
		],
		"region": "Oceania",
		"subregion": "Melanesia",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Neukaledonien",
				"common": "Neukaledonien"
			},
			"fra": {
				"official": "Nouvelle-Calédonie",
				"common": "Nouvelle-Calédonie"
			},
			"hrv": {
				"official": "Nova Kaledonija",
				"common": "Nova Kaledonija"
			},
			"ita": {
				"official": "Nuova Caledonia",
				"common": "Nuova Caledonia"
			},
			"jpn": {
				"official": "ニューカレドニア",
				"common": "ニューカレドニア"
			},
			"nld": {
				"official": "nieuw -Caledonië",
				"common": "Nieuw-Caledonië"
			},
			"por": {
				"official": "New Caledonia",
				"common": "Nova Caledónia"
			},
			"rus": {
				"official": "Новая Каледония",
				"common": "Новая Каледония"
			},
			"spa": {
				"official": "nueva Caledonia",
				"common": "Nueva Caledonia"
			},
			"svk": {
				"official": "Nová Kaledónia",
				"common": "Nová Kaledónia"
			},
			"fin": {
				"official": "Uusi-Kaledonia",
				"common": "Uusi-Kaledonia"
			},
			"zho": {
				"official": "新喀里多尼亚",
				"common": "新喀里多尼亚"
			}
		},
		"latlng": [
			-21.5,
			165.5
		],
		"demonym": "New Caledonian",
		"landlocked": false,
		"borders": [],
		"area": 18575
	},
	{
		"name": {
			"common": "Niger",
			"official": "Republic of Niger",
			"native": {
				"fra": {
					"official": "République du Niger",
					"common": "Niger"
				}
			}
		},
		"tld": [
			".ne"
		],
		"cca2": "NE",
		"ccn3": "562",
		"cca3": "NER",
		"cioc": "NIG",
		"currency": [
			"XOF"
		],
		"callingCode": [
			"227"
		],
		"capital": "Niamey",
		"altSpellings": [
			"NE",
			"Nijar"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Republik Niger",
				"common": "Niger"
			},
			"fra": {
				"official": "République du Niger",
				"common": "Niger"
			},
			"hrv": {
				"official": "Republika Niger",
				"common": "Niger"
			},
			"ita": {
				"official": "Repubblica del Niger",
				"common": "Niger"
			},
			"jpn": {
				"official": "ニジェール共和国",
				"common": "ニジェール"
			},
			"nld": {
				"official": "Republiek Niger",
				"common": "Niger"
			},
			"por": {
				"official": "República do Níger",
				"common": "Níger"
			},
			"rus": {
				"official": "Республика Нигер",
				"common": "Нигер"
			},
			"spa": {
				"official": "República de Níger",
				"common": "Níger"
			},
			"svk": {
				"official": "Nigérská republika",
				"common": "Niger"
			},
			"fin": {
				"official": "Nigerin tasavalta",
				"common": "Niger"
			},
			"zho": {
				"official": "尼日尔共和国",
				"common": "尼日尔"
			}
		},
		"latlng": [
			16,
			8
		],
		"demonym": "Nigerien",
		"landlocked": true,
		"borders": [
			"DZA",
			"BEN",
			"BFA",
			"TCD",
			"LBY",
			"MLI",
			"NGA"
		],
		"area": 1267000
	},
	{
		"name": {
			"common": "Norfolk Island",
			"official": "Territory of Norfolk Island",
			"native": {
				"eng": {
					"official": "Territory of Norfolk Island",
					"common": "Norfolk Island"
				},
				"pih": {
					"official": "Teratri of Norf'k Ailen",
					"common": "Norf'k Ailen"
				}
			}
		},
		"tld": [
			".nf"
		],
		"cca2": "NF",
		"ccn3": "574",
		"cca3": "NFK",
		"cioc": "",
		"currency": [
			"AUD"
		],
		"callingCode": [
			"672"
		],
		"capital": "Kingston",
		"altSpellings": [
			"NF",
			"Territory of Norfolk Island",
			"Teratri of Norf'k Ailen"
		],
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"languages": {
			"eng": "English",
			"pih": "Norfuk"
		},
		"translations": {
			"deu": {
				"official": "Gebiet der Norfolk-Insel",
				"common": "Norfolkinsel"
			},
			"fra": {
				"official": "Territoire de l'île Norfolk",
				"common": "Île Norfolk"
			},
			"hrv": {
				"official": "Teritorij Norfolk Island",
				"common": "Otok Norfolk"
			},
			"ita": {
				"official": "Territorio di Norfolk Island",
				"common": "Isola Norfolk"
			},
			"jpn": {
				"official": "ノーフォーク島の領土",
				"common": "ノーフォーク島"
			},
			"nld": {
				"official": "Grondgebied van Norfolk Island",
				"common": "Norfolkeiland"
			},
			"por": {
				"official": "Território da Ilha Norfolk",
				"common": "Ilha Norfolk"
			},
			"rus": {
				"official": "Территория острова Норфолк",
				"common": "Норфолк"
			},
			"spa": {
				"official": "Territorio de la Isla Norfolk",
				"common": "Isla de Norfolk"
			},
			"svk": {
				"official": "Teritórium ostrova Norfolk",
				"common": "Norfolk"
			},
			"fin": {
				"official": "Norfolkinsaaren territorio",
				"common": "Norfolkinsaari"
			},
			"zho": {
				"official": "诺福克岛",
				"common": "诺福克岛"
			}
		},
		"latlng": [
			-29.03333333,
			167.95
		],
		"demonym": "Norfolk Islander",
		"landlocked": false,
		"borders": [],
		"area": 36
	},
	{
		"name": {
			"common": "Nigeria",
			"official": "Federal Republic of Nigeria",
			"native": {
				"eng": {
					"official": "Federal Republic of Nigeria",
					"common": "Nigeria"
				}
			}
		},
		"tld": [
			".ng"
		],
		"cca2": "NG",
		"ccn3": "566",
		"cca3": "NGA",
		"cioc": "NGR",
		"currency": [
			"NGN"
		],
		"callingCode": [
			"234"
		],
		"capital": "Abuja",
		"altSpellings": [
			"NG",
			"Nijeriya",
			"Naíjíríà",
			"Federal Republic of Nigeria"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Bundesrepublik Nigeria",
				"common": "Nigeria"
			},
			"fra": {
				"official": "République fédérale du Nigeria",
				"common": "Nigéria"
			},
			"hrv": {
				"official": "Savezna Republika Nigerija",
				"common": "Nigerija"
			},
			"ita": {
				"official": "Repubblica federale di Nigeria",
				"common": "Nigeria"
			},
			"jpn": {
				"official": "ナイジェリア連邦共和国",
				"common": "ナイジェリア"
			},
			"nld": {
				"official": "Federale Republiek Nigeria",
				"common": "Nigeria"
			},
			"por": {
				"official": "República Federal da Nigéria",
				"common": "Nigéria"
			},
			"rus": {
				"official": "Федеративная Республика Нигерия",
				"common": "Нигерия"
			},
			"spa": {
				"official": "República Federal de Nigeria",
				"common": "Nigeria"
			},
			"svk": {
				"official": "Nigérijská federatívna republika",
				"common": "Nigéria"
			},
			"fin": {
				"official": "Nigerian liittotasavalta",
				"common": "Nigeria"
			},
			"zho": {
				"official": "尼日利亚联邦共和国",
				"common": "尼日利亚"
			}
		},
		"latlng": [
			10,
			8
		],
		"demonym": "Nigerian",
		"landlocked": false,
		"borders": [
			"BEN",
			"CMR",
			"TCD",
			"NER"
		],
		"area": 923768
	},
	{
		"name": {
			"common": "Nicaragua",
			"official": "Republic of Nicaragua",
			"native": {
				"spa": {
					"official": "República de Nicaragua",
					"common": "Nicaragua"
				}
			}
		},
		"tld": [
			".ni"
		],
		"cca2": "NI",
		"ccn3": "558",
		"cca3": "NIC",
		"cioc": "NCA",
		"currency": [
			"NIO"
		],
		"callingCode": [
			"505"
		],
		"capital": "Managua",
		"altSpellings": [
			"NI",
			"Republic of Nicaragua",
			"República de Nicaragua"
		],
		"region": "Americas",
		"subregion": "Central America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Republik Nicaragua",
				"common": "Nicaragua"
			},
			"fra": {
				"official": "République du Nicaragua",
				"common": "Nicaragua"
			},
			"hrv": {
				"official": "Republika Nikaragva",
				"common": "Nikaragva"
			},
			"ita": {
				"official": "Repubblica del Nicaragua",
				"common": "Nicaragua"
			},
			"jpn": {
				"official": "ニカラグア共和国",
				"common": "ニカラグア"
			},
			"nld": {
				"official": "Republiek Nicaragua",
				"common": "Nicaragua"
			},
			"por": {
				"official": "República da Nicarágua",
				"common": "Nicarágua"
			},
			"rus": {
				"official": "Республика Никарагуа",
				"common": "Никарагуа"
			},
			"spa": {
				"official": "República de Nicaragua",
				"common": "Nicaragua"
			},
			"svk": {
				"official": "Nikaragujská republika",
				"common": "Nikaragua"
			},
			"fin": {
				"official": "Nicaraguan tasavalta",
				"common": "Nicaragua"
			},
			"zho": {
				"official": "尼加拉瓜共和国",
				"common": "尼加拉瓜"
			}
		},
		"latlng": [
			13,
			-85
		],
		"demonym": "Nicaraguan",
		"landlocked": false,
		"borders": [
			"CRI",
			"HND"
		],
		"area": 130373
	},
	{
		"name": {
			"common": "Niue",
			"official": "Niue",
			"native": {
				"eng": {
					"official": "Niue",
					"common": "Niue"
				},
				"niu": {
					"official": "Niuē",
					"common": "Niuē"
				}
			}
		},
		"tld": [
			".nu"
		],
		"cca2": "NU",
		"ccn3": "570",
		"cca3": "NIU",
		"cioc": "",
		"currency": [
			"NZD"
		],
		"callingCode": [
			"683"
		],
		"capital": "Alofi",
		"altSpellings": [
			"NU"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"eng": "English",
			"niu": "Niuean"
		},
		"translations": {
			"deu": {
				"official": "Niue",
				"common": "Niue"
			},
			"fra": {
				"official": "Niue",
				"common": "Niue"
			},
			"hrv": {
				"official": "Niue",
				"common": "Niue"
			},
			"ita": {
				"official": "Niue",
				"common": "Niue"
			},
			"jpn": {
				"official": "ニウエ",
				"common": "ニウエ"
			},
			"nld": {
				"official": "Niue",
				"common": "Niue"
			},
			"por": {
				"official": "Niue",
				"common": "Niue"
			},
			"rus": {
				"official": "Ниуэ",
				"common": "Ниуэ"
			},
			"spa": {
				"official": "Niue",
				"common": "Niue"
			},
			"svk": {
				"official": "Niue",
				"common": "Niue"
			},
			"fin": {
				"official": "Niue",
				"common": "Niue"
			},
			"zho": {
				"official": "纽埃",
				"common": "纽埃"
			}
		},
		"latlng": [
			-19.03333333,
			-169.86666666
		],
		"demonym": "Niuean",
		"landlocked": false,
		"borders": [],
		"area": 260
	},
	{
		"name": {
			"common": "Netherlands",
			"official": "Netherlands",
			"native": {
				"nld": {
					"official": "Nederland",
					"common": "Nederland"
				}
			}
		},
		"tld": [
			".nl"
		],
		"cca2": "NL",
		"ccn3": "528",
		"cca3": "NLD",
		"cioc": "NED",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"31"
		],
		"capital": "Amsterdam",
		"altSpellings": [
			"NL",
			"Holland",
			"Nederland"
		],
		"region": "Europe",
		"subregion": "Western Europe",
		"languages": {
			"nld": "Dutch"
		},
		"translations": {
			"deu": {
				"official": "Niederlande",
				"common": "Niederlande"
			},
			"fra": {
				"official": "Pays-Bas",
				"common": "Pays-Bas"
			},
			"hrv": {
				"official": "Holandija",
				"common": "Nizozemska"
			},
			"ita": {
				"official": "Paesi Bassi",
				"common": "Paesi Bassi"
			},
			"jpn": {
				"official": "オランダ",
				"common": "オランダ"
			},
			"nld": {
				"official": "Nederland",
				"common": "Nederland"
			},
			"por": {
				"official": "Holanda",
				"common": "Holanda"
			},
			"rus": {
				"official": "Нидерланды",
				"common": "Нидерланды"
			},
			"spa": {
				"official": "Países Bajos",
				"common": "Países Bajos"
			},
			"svk": {
				"official": "Holandské kráľovstvo",
				"common": "Holansko"
			},
			"fin": {
				"official": "Alankomaat",
				"common": "Alankomaat"
			},
			"zho": {
				"official": "荷兰",
				"common": "荷兰"
			}
		},
		"latlng": [
			52.5,
			5.75
		],
		"demonym": "Dutch",
		"landlocked": false,
		"borders": [
			"BEL",
			"DEU"
		],
		"area": 41850
	},
	{
		"name": {
			"common": "Norway",
			"official": "Kingdom of Norway",
			"native": {
				"nno": {
					"official": "Kongeriket Noreg",
					"common": "Noreg"
				},
				"nob": {
					"official": "Kongeriket Norge",
					"common": "Norge"
				},
				"smi": {
					"official": "Norgga gonagasriika",
					"common": "Norgga"
				}
			}
		},
		"tld": [
			".no"
		],
		"cca2": "NO",
		"ccn3": "578",
		"cca3": "NOR",
		"cioc": "NOR",
		"currency": [
			"NOK"
		],
		"callingCode": [
			"47"
		],
		"capital": "Oslo",
		"altSpellings": [
			"NO",
			"Norge",
			"Noreg",
			"Kingdom of Norway",
			"Kongeriket Norge",
			"Kongeriket Noreg"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"nno": "Norwegian Nynorsk",
			"nob": "Norwegian Bokmål",
			"smi": "Sami"
		},
		"translations": {
			"deu": {
				"official": "Königreich Norwegen",
				"common": "Norwegen"
			},
			"fra": {
				"official": "Royaume de Norvège",
				"common": "Norvège"
			},
			"hrv": {
				"official": "Kraljevina Norveška",
				"common": "Norveška"
			},
			"ita": {
				"official": "Regno di Norvegia",
				"common": "Norvegia"
			},
			"jpn": {
				"official": "ノルウェー王国",
				"common": "ノルウェー"
			},
			"nld": {
				"official": "Koninkrijk Noorwegen",
				"common": "Noorwegen"
			},
			"por": {
				"official": "Reino da Noruega",
				"common": "Noruega"
			},
			"rus": {
				"official": "Королевство Норвегия",
				"common": "Норвегия"
			},
			"spa": {
				"official": "Reino de Noruega",
				"common": "Noruega"
			},
			"svk": {
				"official": "Nórske kráľovstvo",
				"common": "Nórsko"
			},
			"fin": {
				"official": "Norjan kuningaskunta",
				"common": "Norja"
			},
			"zho": {
				"official": "挪威王国",
				"common": "挪威"
			}
		},
		"latlng": [
			62,
			10
		],
		"demonym": "Norwegian",
		"landlocked": false,
		"borders": [
			"FIN",
			"SWE",
			"RUS"
		],
		"area": 323802
	},
	{
		"name": {
			"common": "Nepal",
			"official": "Federal Democratic Republic of Nepal",
			"native": {
				"nep": {
					"official": "नेपाल संघीय लोकतान्त्रिक गणतन्त्र",
					"common": "नेपाल"
				}
			}
		},
		"tld": [
			".np"
		],
		"cca2": "NP",
		"ccn3": "524",
		"cca3": "NPL",
		"cioc": "NEP",
		"currency": [
			"NPR"
		],
		"callingCode": [
			"977"
		],
		"capital": "Kathmandu",
		"altSpellings": [
			"NP",
			"Federal Democratic Republic of Nepal",
			"Loktāntrik Ganatantra Nepāl"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"nep": "Nepali"
		},
		"translations": {
			"deu": {
				"official": "Demokratischen Bundesrepublik Nepal",
				"common": "Népal"
			},
			"fra": {
				"official": "République du Népal",
				"common": "Népal"
			},
			"hrv": {
				"official": "Savezna Demokratska Republika Nepal",
				"common": "Nepal"
			},
			"ita": {
				"official": "Repubblica federale democratica del Nepal",
				"common": "Nepal"
			},
			"jpn": {
				"official": "ネパール連邦民主共和国",
				"common": "ネパール"
			},
			"nld": {
				"official": "Federale Democratische Republiek Nepal",
				"common": "Nepal"
			},
			"por": {
				"official": "República Democrática Federal do Nepal",
				"common": "Nepal"
			},
			"rus": {
				"official": "Федеративная Демократическая Республика Непал",
				"common": "Непал"
			},
			"spa": {
				"official": "República Democrática Federal de Nepal",
				"common": "Nepal"
			},
			"svk": {
				"official": "Nepálska federatívna demokratická republika",
				"common": "Nepál"
			},
			"fin": {
				"official": "Nepalin demokraattinen liittotasavalta",
				"common": "Nepal"
			},
			"zho": {
				"official": "尼泊尔联邦民主共和国",
				"common": "尼泊尔"
			}
		},
		"latlng": [
			28,
			84
		],
		"demonym": "Nepalese",
		"landlocked": true,
		"borders": [
			"CHN",
			"IND"
		],
		"area": 147181
	},
	{
		"name": {
			"common": "Nauru",
			"official": "Republic of Nauru",
			"native": {
				"eng": {
					"official": "Republic of Nauru",
					"common": "Nauru"
				},
				"nau": {
					"official": "Republic of Nauru",
					"common": "Nauru"
				}
			}
		},
		"tld": [
			".nr"
		],
		"cca2": "NR",
		"ccn3": "520",
		"cca3": "NRU",
		"cioc": "NRU",
		"currency": [
			"AUD"
		],
		"callingCode": [
			"674"
		],
		"capital": "Yaren",
		"altSpellings": [
			"NR",
			"Naoero",
			"Pleasant Island",
			"Republic of Nauru",
			"Ripublik Naoero"
		],
		"region": "Oceania",
		"subregion": "Micronesia",
		"languages": {
			"eng": "English",
			"nau": "Nauru"
		},
		"translations": {
			"deu": {
				"official": "Republik Nauru",
				"common": "Nauru"
			},
			"fra": {
				"official": "République de Nauru",
				"common": "Nauru"
			},
			"hrv": {
				"official": "Republika Nauru",
				"common": "Nauru"
			},
			"ita": {
				"official": "Repubblica di Nauru",
				"common": "Nauru"
			},
			"jpn": {
				"official": "ナウル共和国",
				"common": "ナウル"
			},
			"nld": {
				"official": "Republiek Nauru",
				"common": "Nauru"
			},
			"por": {
				"official": "República de Nauru",
				"common": "Nauru"
			},
			"rus": {
				"official": "Республика Науру",
				"common": "Науру"
			},
			"spa": {
				"official": "República de Nauru",
				"common": "Nauru"
			},
			"svk": {
				"official": "Naurská republika",
				"common": "Nauru"
			},
			"fin": {
				"official": "Naurun tasavalta",
				"common": "Nauru"
			},
			"zho": {
				"official": "瑙鲁共和国",
				"common": "瑙鲁"
			}
		},
		"latlng": [
			-0.53333333,
			166.91666666
		],
		"demonym": "Nauruan",
		"landlocked": false,
		"borders": [],
		"area": 21
	},
	{
		"name": {
			"common": "New Zealand",
			"official": "New Zealand",
			"native": {
				"eng": {
					"official": "New Zealand",
					"common": "New Zealand"
				},
				"mri": {
					"official": "Aotearoa",
					"common": "Aotearoa"
				},
				"nzs": {
					"official": "New Zealand",
					"common": "New Zealand"
				}
			}
		},
		"tld": [
			".nz"
		],
		"cca2": "NZ",
		"ccn3": "554",
		"cca3": "NZL",
		"cioc": "NZL",
		"currency": [
			"NZD"
		],
		"callingCode": [
			"64"
		],
		"capital": "Wellington",
		"altSpellings": [
			"NZ",
			"Aotearoa"
		],
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"languages": {
			"eng": "English",
			"mri": "Māori",
			"nzs": "New Zealand Sign Language"
		},
		"translations": {
			"deu": {
				"official": "Neuseeland",
				"common": "Neuseeland"
			},
			"fra": {
				"official": "Nouvelle-Zélande",
				"common": "Nouvelle-Zélande"
			},
			"hrv": {
				"official": "Novi Zeland",
				"common": "Novi Zeland"
			},
			"ita": {
				"official": "Nuova Zelanda",
				"common": "Nuova Zelanda"
			},
			"jpn": {
				"official": "ニュージーランド",
				"common": "ニュージーランド"
			},
			"nld": {
				"official": "Nieuw Zeeland",
				"common": "Nieuw-Zeeland"
			},
			"por": {
				"official": "nova Zelândia",
				"common": "Nova Zelândia"
			},
			"rus": {
				"official": "Новая Зеландия",
				"common": "Новая Зеландия"
			},
			"spa": {
				"official": "nueva Zelanda",
				"common": "Nueva Zelanda"
			},
			"svk": {
				"official": "Nový Zéland",
				"common": "Nový Zéland"
			},
			"fin": {
				"official": "Uusi-Seelanti",
				"common": "Uusi-Seelanti"
			},
			"zho": {
				"official": "新西兰",
				"common": "新西兰"
			}
		},
		"latlng": [
			-41,
			174
		],
		"demonym": "New Zealander",
		"landlocked": false,
		"borders": [],
		"area": 270467
	},
	{
		"name": {
			"common": "Oman",
			"official": "Sultanate of Oman",
			"native": {
				"ara": {
					"official": "سلطنة عمان",
					"common": "عمان"
				}
			}
		},
		"tld": [
			".om"
		],
		"cca2": "OM",
		"ccn3": "512",
		"cca3": "OMN",
		"cioc": "OMA",
		"currency": [
			"OMR"
		],
		"callingCode": [
			"968"
		],
		"capital": "Muscat",
		"altSpellings": [
			"OM",
			"Sultanate of Oman",
			"Salṭanat ʻUmān"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Sultanat Oman",
				"common": "Oman"
			},
			"fra": {
				"official": "Sultanat d'Oman",
				"common": "Oman"
			},
			"hrv": {
				"official": "Sultanat Oman",
				"common": "Oman"
			},
			"ita": {
				"official": "Sultanato dell'Oman",
				"common": "oman"
			},
			"jpn": {
				"official": "オマーン·スルタン国",
				"common": "オマーン"
			},
			"nld": {
				"official": "Sultanaat van Oman",
				"common": "Oman"
			},
			"por": {
				"official": "Sultanato de Omã",
				"common": "Omã"
			},
			"rus": {
				"official": "Султанат Оман",
				"common": "Оман"
			},
			"spa": {
				"official": "Sultanato de Omán",
				"common": "Omán"
			},
			"svk": {
				"official": "Ománsky sultanát",
				"common": "Omán"
			},
			"fin": {
				"official": "Omanin sulttaanikunta",
				"common": "Oman"
			},
			"zho": {
				"official": "阿曼苏丹国",
				"common": "阿曼"
			}
		},
		"latlng": [
			21,
			57
		],
		"demonym": "Omani",
		"landlocked": false,
		"borders": [
			"SAU",
			"ARE",
			"YEM"
		],
		"area": 309500
	},
	{
		"name": {
			"common": "Pakistan",
			"official": "Islamic Republic of Pakistan",
			"native": {
				"eng": {
					"official": "Islamic Republic of Pakistan",
					"common": "Pakistan"
				},
				"urd": {
					"official": "اسلامی جمہوریۂ پاكستان",
					"common": "پاكستان"
				}
			}
		},
		"tld": [
			".pk"
		],
		"cca2": "PK",
		"ccn3": "586",
		"cca3": "PAK",
		"cioc": "PAK",
		"currency": [
			"PKR"
		],
		"callingCode": [
			"92"
		],
		"capital": "Islamabad",
		"altSpellings": [
			"PK",
			"Pākistān",
			"Islamic Republic of Pakistan",
			"Islāmī Jumhūriya'eh Pākistān"
		],
		"region": "Asia",
		"subregion": "Southern Asia",
		"languages": {
			"eng": "English",
			"urd": "Urdu"
		},
		"translations": {
			"deu": {
				"official": "Islamische Republik Pakistan",
				"common": "Pakistan"
			},
			"fra": {
				"official": "République islamique du Pakistan",
				"common": "Pakistan"
			},
			"hrv": {
				"official": "Islamska Republika Pakistan",
				"common": "Pakistan"
			},
			"ita": {
				"official": "Repubblica islamica del Pakistan",
				"common": "Pakistan"
			},
			"jpn": {
				"official": "パキスタン",
				"common": "パキスタン"
			},
			"nld": {
				"official": "Islamitische Republiek Pakistan",
				"common": "Pakistan"
			},
			"por": {
				"official": "República Islâmica do Paquistão",
				"common": "Paquistão"
			},
			"rus": {
				"official": "Исламская Республика Пакистан",
				"common": "Пакистан"
			},
			"spa": {
				"official": "República Islámica de Pakistán",
				"common": "Pakistán"
			},
			"svk": {
				"official": "Pakistanská islamská republika",
				"common": "Pakistan"
			},
			"fin": {
				"official": "Pakistanin islamilainen tasavalta",
				"common": "Pakistan"
			},
			"zho": {
				"official": "巴基斯坦伊斯兰共和国",
				"common": "巴基斯坦"
			}
		},
		"latlng": [
			30,
			70
		],
		"demonym": "Pakistani",
		"landlocked": false,
		"borders": [
			"AFG",
			"CHN",
			"IND",
			"IRN"
		],
		"area": 881912
	},
	{
		"name": {
			"common": "Panama",
			"official": "Republic of Panama",
			"native": {
				"spa": {
					"official": "República de Panamá",
					"common": "Panamá"
				}
			}
		},
		"tld": [
			".pa"
		],
		"cca2": "PA",
		"ccn3": "591",
		"cca3": "PAN",
		"cioc": "PAN",
		"currency": [
			"PAB",
			"USD"
		],
		"callingCode": [
			"507"
		],
		"capital": "Panama City",
		"altSpellings": [
			"PA",
			"Republic of Panama",
			"República de Panamá"
		],
		"region": "Americas",
		"subregion": "Central America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Republik Panama",
				"common": "Panama"
			},
			"fra": {
				"official": "République du Panama",
				"common": "Panama"
			},
			"hrv": {
				"official": "Republika Panama",
				"common": "Panama"
			},
			"ita": {
				"official": "Repubblica di Panama",
				"common": "Panama"
			},
			"jpn": {
				"official": "パナマ共和国",
				"common": "パナマ"
			},
			"nld": {
				"official": "Republiek Panama",
				"common": "Panama"
			},
			"por": {
				"official": "República do Panamá",
				"common": "Panamá"
			},
			"rus": {
				"official": "Республика Панама",
				"common": "Панама"
			},
			"spa": {
				"official": "República de Panamá",
				"common": "Panamá"
			},
			"svk": {
				"official": "Panamská republika",
				"common": "Panama"
			},
			"fin": {
				"official": "Panaman tasavalta",
				"common": "Panama"
			},
			"zho": {
				"official": "巴拿马共和国",
				"common": "巴拿马"
			}
		},
		"latlng": [
			9,
			-80
		],
		"demonym": "Panamanian",
		"landlocked": false,
		"borders": [
			"COL",
			"CRI"
		],
		"area": 75417
	},
	{
		"name": {
			"common": "Pitcairn Islands",
			"official": "Pitcairn Group of Islands",
			"native": {
				"eng": {
					"official": "Pitcairn Group of Islands",
					"common": "Pitcairn Islands"
				}
			}
		},
		"tld": [
			".pn"
		],
		"cca2": "PN",
		"ccn3": "612",
		"cca3": "PCN",
		"cioc": "",
		"currency": [
			"NZD"
		],
		"callingCode": [
			"64"
		],
		"capital": "Adamstown",
		"altSpellings": [
			"PN",
			"Pitcairn",
			"Pitcairn Henderson Ducie and Oeno Islands"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Pitcairn Inselgruppe",
				"common": "Pitcairn"
			},
			"fra": {
				"official": "Groupe d'îles Pitcairn",
				"common": "Îles Pitcairn"
			},
			"hrv": {
				"official": "Pitcairn skupine otoka",
				"common": "Pitcairnovo otočje"
			},
			"ita": {
				"official": "Pitcairn gruppo di isole",
				"common": "Isole Pitcairn"
			},
			"jpn": {
				"official": "島のピトケアングループ",
				"common": "ピトケアン"
			},
			"nld": {
				"official": "Pitcairn groep eilanden",
				"common": "Pitcairneilanden"
			},
			"por": {
				"official": "Pitcairn grupo de ilhas",
				"common": "Ilhas Pitcairn"
			},
			"rus": {
				"official": "Питкэрн группа островов",
				"common": "Острова Питкэрн"
			},
			"spa": {
				"official": "Grupo de Islas Pitcairn",
				"common": "Islas Pitcairn"
			},
			"svk": {
				"official": "Pitcairnove ostrovy",
				"common": "Pitcairnove ostrovy"
			},
			"fin": {
				"official": "Pitcairn",
				"common": "Pitcairn"
			},
			"zho": {
				"official": "皮特凯恩群岛",
				"common": "皮特凯恩群岛"
			}
		},
		"latlng": [
			-25.06666666,
			-130.1
		],
		"demonym": "Pitcairn Islander",
		"landlocked": false,
		"borders": [],
		"area": 47
	},
	{
		"name": {
			"common": "Peru",
			"official": "Republic of Peru",
			"native": {
				"aym": {
					"official": "Piruw Suyu",
					"common": "Piruw"
				},
				"que": {
					"official": "Piruw Ripuwlika",
					"common": "Piruw"
				},
				"spa": {
					"official": "República del Perú",
					"common": "Perú"
				}
			}
		},
		"tld": [
			".pe"
		],
		"cca2": "PE",
		"ccn3": "604",
		"cca3": "PER",
		"cioc": "PER",
		"currency": [
			"PEN"
		],
		"callingCode": [
			"51"
		],
		"capital": "Lima",
		"altSpellings": [
			"PE",
			"Republic of Peru",
			"República del Perú"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"aym": "Aymara",
			"que": "Quechua",
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Republik Peru",
				"common": "Peru"
			},
			"fra": {
				"official": "République du Pérou",
				"common": "Pérou"
			},
			"hrv": {
				"official": "Republika Peru",
				"common": "Peru"
			},
			"ita": {
				"official": "Repubblica del Perù",
				"common": "Perù"
			},
			"jpn": {
				"official": "ペルー共和国",
				"common": "ペルー"
			},
			"nld": {
				"official": "Republiek Peru",
				"common": "Peru"
			},
			"por": {
				"official": "República do Peru",
				"common": "Perú"
			},
			"rus": {
				"official": "Республика Перу",
				"common": "Перу"
			},
			"spa": {
				"official": "República de Perú",
				"common": "Perú"
			},
			"svk": {
				"official": "Peruánska republika",
				"common": "Peru"
			},
			"fin": {
				"official": "Perun tasavalta",
				"common": "Peru"
			},
			"zho": {
				"official": "秘鲁共和国",
				"common": "秘鲁"
			}
		},
		"latlng": [
			-10,
			-76
		],
		"demonym": "Peruvian",
		"landlocked": false,
		"borders": [
			"BOL",
			"BRA",
			"CHL",
			"COL",
			"ECU"
		],
		"area": 1285216
	},
	{
		"name": {
			"common": "Philippines",
			"official": "Republic of the Philippines",
			"native": {
				"eng": {
					"official": "Republic of the Philippines",
					"common": "Philippines"
				},
				"fil": {
					"official": "Republic of the Philippines",
					"common": "Pilipinas"
				}
			}
		},
		"tld": [
			".ph"
		],
		"cca2": "PH",
		"ccn3": "608",
		"cca3": "PHL",
		"cioc": "PHI",
		"currency": [
			"PHP"
		],
		"callingCode": [
			"63"
		],
		"capital": "Manila",
		"altSpellings": [
			"PH",
			"Republic of the Philippines",
			"Repúblika ng Pilipinas"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"eng": "English",
			"fil": "Filipino"
		},
		"translations": {
			"deu": {
				"official": "Republik der Philippinen",
				"common": "Philippinen"
			},
			"fra": {
				"official": "République des Philippines",
				"common": "Philippines"
			},
			"hrv": {
				"official": "Republika Filipini",
				"common": "Filipini"
			},
			"ita": {
				"official": "Repubblica delle Filippine",
				"common": "Filippine"
			},
			"jpn": {
				"official": "フィリピン共和国",
				"common": "フィリピン"
			},
			"nld": {
				"official": "Republiek der Filipijnen",
				"common": "Filipijnen"
			},
			"por": {
				"official": "República das Filipinas",
				"common": "Filipinas"
			},
			"rus": {
				"official": "Республика Филиппины",
				"common": "Филиппины"
			},
			"spa": {
				"official": "República de las Filipinas",
				"common": "Filipinas"
			},
			"svk": {
				"official": "Filipínska republika",
				"common": "Filipíny"
			},
			"fin": {
				"official": "Filippiinien tasavalta",
				"common": "Filippiinit"
			},
			"zho": {
				"official": "菲律宾共和国",
				"common": "菲律宾"
			}
		},
		"latlng": [
			13,
			122
		],
		"demonym": "Filipino",
		"landlocked": false,
		"borders": [],
		"area": 342353
	},
	{
		"name": {
			"common": "Palau",
			"official": "Republic of Palau",
			"native": {
				"eng": {
					"official": "Republic of Palau",
					"common": "Palau"
				},
				"pau": {
					"official": "Beluu er a Belau",
					"common": "Belau"
				}
			}
		},
		"tld": [
			".pw"
		],
		"cca2": "PW",
		"ccn3": "585",
		"cca3": "PLW",
		"cioc": "PLW",
		"currency": [
			"USD"
		],
		"callingCode": [
			"680"
		],
		"capital": "Ngerulmud",
		"altSpellings": [
			"PW",
			"Republic of Palau",
			"Beluu er a Belau"
		],
		"region": "Oceania",
		"subregion": "Micronesia",
		"languages": {
			"eng": "English",
			"pau": "Palauan"
		},
		"translations": {
			"deu": {
				"official": "Palau",
				"common": "Palau"
			},
			"fra": {
				"official": "République des Palaos (Palau)",
				"common": "Palaos (Palau)"
			},
			"hrv": {
				"official": "Republika Palau",
				"common": "Palau"
			},
			"ita": {
				"official": "Repubblica di Palau",
				"common": "Palau"
			},
			"jpn": {
				"official": "パラオ共和国",
				"common": "パラオ"
			},
			"nld": {
				"official": "Republiek van Palau",
				"common": "Palau"
			},
			"por": {
				"official": "República de Palau",
				"common": "Palau"
			},
			"rus": {
				"official": "Республика Палау",
				"common": "Палау"
			},
			"spa": {
				"official": "República de Palau",
				"common": "Palau"
			},
			"svk": {
				"official": "Palauská republika",
				"common": "Palau"
			},
			"fin": {
				"official": "Palaun tasavalta",
				"common": "Palau"
			},
			"zho": {
				"official": "帕劳共和国",
				"common": "帕劳"
			}
		},
		"latlng": [
			7.5,
			134.5
		],
		"demonym": "Palauan",
		"landlocked": false,
		"borders": [],
		"area": 459
	},
	{
		"name": {
			"common": "Papua New Guinea",
			"official": "Independent State of Papua New Guinea",
			"native": {
				"eng": {
					"official": "Independent State of Papua New Guinea",
					"common": "Papua New Guinea"
				},
				"hmo": {
					"official": "Independen Stet bilong Papua Niugini",
					"common": "Papua Niu Gini"
				},
				"tpi": {
					"official": "Independen Stet bilong Papua Niugini",
					"common": "Papua Niugini"
				}
			}
		},
		"tld": [
			".pg"
		],
		"cca2": "PG",
		"ccn3": "598",
		"cca3": "PNG",
		"cioc": "PNG",
		"currency": [
			"PGK"
		],
		"callingCode": [
			"675"
		],
		"capital": "Port Moresby",
		"altSpellings": [
			"PG",
			"Independent State of Papua New Guinea",
			"Independen Stet bilong Papua Niugini"
		],
		"region": "Oceania",
		"subregion": "Melanesia",
		"languages": {
			"eng": "English",
			"hmo": "Hiri Motu",
			"tpi": "Tok Pisin"
		},
		"translations": {
			"deu": {
				"official": "Unabhängige Staat Papua-Neuguinea",
				"common": "Papua-Neuguinea"
			},
			"fra": {
				"official": "État indépendant de Papouasie-Nouvelle-Guinée",
				"common": "Papouasie-Nouvelle-Guinée"
			},
			"hrv": {
				"official": "Nezavisna Država Papui Novoj Gvineji",
				"common": "Papua Nova Gvineja"
			},
			"ita": {
				"official": "Stato indipendente di Papua Nuova Guinea",
				"common": "Papua Nuova Guinea"
			},
			"jpn": {
				"official": "パプアニューギニア独立国",
				"common": "パプアニューギニア"
			},
			"nld": {
				"official": "Onafhankelijke Staat Papoea -Nieuw-Guinea",
				"common": "Papoea-Nieuw-Guinea"
			},
			"por": {
				"official": "Estado Independente da Papua Nova Guiné",
				"common": "Papua Nova Guiné"
			},
			"rus": {
				"official": "Независимое Государство Папуа-Новой Гвинеи",
				"common": "Папуа — Новая Гвинея"
			},
			"spa": {
				"official": "Estado Independiente de Papúa Nueva Guinea",
				"common": "Papúa Nueva Guinea"
			},
			"svk": {
				"official": "Nezávislý štát Papua-Nová Guinea",
				"common": "Papua-Nová Guinea"
			},
			"fin": {
				"official": "Papua-Uuden-Guinean Itsenäinen valtio",
				"common": "Papua-Uusi-Guinea"
			},
			"zho": {
				"official": "巴布亚新几内亚",
				"common": "巴布亚新几内亚"
			}
		},
		"latlng": [
			-6,
			147
		],
		"demonym": "Papua New Guinean",
		"landlocked": false,
		"borders": [
			"IDN"
		],
		"area": 462840
	},
	{
		"name": {
			"common": "Poland",
			"official": "Republic of Poland",
			"native": {
				"pol": {
					"official": "Rzeczpospolita Polska",
					"common": "Polska"
				}
			}
		},
		"tld": [
			".pl"
		],
		"cca2": "PL",
		"ccn3": "616",
		"cca3": "POL",
		"cioc": "POL",
		"currency": [
			"PLN"
		],
		"callingCode": [
			"48"
		],
		"capital": "Warsaw",
		"altSpellings": [
			"PL",
			"Republic of Poland",
			"Rzeczpospolita Polska"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"pol": "Polish"
		},
		"translations": {
			"deu": {
				"official": "Republik Polen",
				"common": "Polen"
			},
			"fra": {
				"official": "République de Pologne",
				"common": "Pologne"
			},
			"hrv": {
				"official": "Republika Poljska",
				"common": "Poljska"
			},
			"ita": {
				"official": "Repubblica di Polonia",
				"common": "Polonia"
			},
			"jpn": {
				"official": "ポーランド共和国",
				"common": "ポーランド"
			},
			"nld": {
				"official": "Republiek Polen",
				"common": "Polen"
			},
			"por": {
				"official": "República da Polónia",
				"common": "Polónia"
			},
			"rus": {
				"official": "Республика Польша",
				"common": "Польша"
			},
			"spa": {
				"official": "República de Polonia",
				"common": "Polonia"
			},
			"svk": {
				"official": "Poľská republika",
				"common": "Poľsko"
			},
			"fin": {
				"official": "Puolan tasavalta",
				"common": "Puola"
			},
			"zho": {
				"official": "波兰共和国",
				"common": "波兰"
			}
		},
		"latlng": [
			52,
			20
		],
		"demonym": "Polish",
		"landlocked": false,
		"borders": [
			"BLR",
			"CZE",
			"DEU",
			"LTU",
			"RUS",
			"SVK",
			"UKR"
		],
		"area": 312679
	},
	{
		"name": {
			"common": "Puerto Rico",
			"official": "Commonwealth of Puerto Rico",
			"native": {
				"eng": {
					"official": "Commonwealth of Puerto Rico",
					"common": "Puerto Rico"
				},
				"spa": {
					"official": "Estado Libre Asociado de Puerto Rico",
					"common": "Puerto Rico"
				}
			}
		},
		"tld": [
			".pr"
		],
		"cca2": "PR",
		"ccn3": "630",
		"cca3": "PRI",
		"cioc": "PUR",
		"currency": [
			"USD"
		],
		"callingCode": [
			"1787",
			"1939"
		],
		"capital": "San Juan",
		"altSpellings": [
			"PR",
			"Commonwealth of Puerto Rico",
			"Estado Libre Asociado de Puerto Rico"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English",
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Commonwealth von Puerto Rico",
				"common": "Puerto Rico"
			},
			"fra": {
				"official": "Porto Rico",
				"common": "Porto Rico"
			},
			"hrv": {
				"official": "Zajednica Puerto Rico",
				"common": "Portoriko"
			},
			"ita": {
				"official": "Commonwealth di Porto Rico",
				"common": "Porto Rico"
			},
			"jpn": {
				"official": "プエルトリコのコモンウェルス",
				"common": "プエルトリコ"
			},
			"nld": {
				"official": "Gemenebest van Puerto Rico",
				"common": "Puerto Rico"
			},
			"por": {
				"official": "Commonwealth of Puerto Rico",
				"common": "Porto Rico"
			},
			"rus": {
				"official": "Содружество Пуэрто-Рико",
				"common": "Пуэрто-Рико"
			},
			"spa": {
				"official": "Asociado de Puerto Rico",
				"common": "Puerto Rico"
			},
			"svk": {
				"official": "Portorické spoločenstvo",
				"common": "Portoriko"
			},
			"fin": {
				"official": "Puerto Rico",
				"common": "Puerto Rico"
			},
			"zho": {
				"official": "波多黎各联邦",
				"common": "波多黎各"
			}
		},
		"latlng": [
			18.25,
			-66.5
		],
		"demonym": "Puerto Rican",
		"landlocked": false,
		"borders": [],
		"area": 8870
	},
	{
		"name": {
			"common": "North Korea",
			"official": "Democratic People's Republic of Korea",
			"native": {
				"kor": {
					"official": "조선 민주주의 인민 공화국",
					"common": "북한"
				}
			}
		},
		"tld": [
			".kp"
		],
		"cca2": "KP",
		"ccn3": "408",
		"cca3": "PRK",
		"cioc": "PRK",
		"currency": [
			"KPW"
		],
		"callingCode": [
			"850"
		],
		"capital": "Pyongyang",
		"altSpellings": [
			"KP",
			"Democratic People's Republic of Korea",
			"조선민주주의인민공화국",
			"Chosŏn Minjujuŭi Inmin Konghwaguk",
			"Korea, Democratic People's Republic of"
		],
		"region": "Asia",
		"subregion": "Eastern Asia",
		"languages": {
			"kor": "Korean"
		},
		"translations": {
			"deu": {
				"official": "Demokratische Volksrepublik Korea",
				"common": "Nordkorea"
			},
			"fra": {
				"official": "République populaire démocratique de Corée",
				"common": "Corée du Nord"
			},
			"hrv": {
				"official": "Demokratska Narodna Republika Koreja",
				"common": "Sjeverna Koreja"
			},
			"ita": {
				"official": "Repubblica democratica popolare di Corea",
				"common": "Corea del Nord"
			},
			"jpn": {
				"official": "朝鮮民主主義人民共和国",
				"common": "朝鮮民主主義人民共和国"
			},
			"nld": {
				"official": "Democratische Volksrepubliek Korea",
				"common": "Noord-Korea"
			},
			"por": {
				"official": "República Popular Democrática da Coreia",
				"common": "Coreia do Norte"
			},
			"rus": {
				"official": "Корейская Народно-Демократическая Республика Корея",
				"common": "Северная Корея"
			},
			"spa": {
				"official": "República Popular Democrática de Corea",
				"common": "Corea del Norte"
			},
			"svk": {
				"official": "Kórejská ľudovodemokratická republika",
				"common": "Kórejská ľudovodemokratická republika (KĽR, Severná Kó)"
			},
			"fin": {
				"official": "Korean demokraattinen kansantasavalta",
				"common": "Pohjois-Korea"
			},
			"zho": {
				"official": "朝鲜人民民主共和国",
				"common": "朝鲜"
			}
		},
		"latlng": [
			40,
			127
		],
		"demonym": "North Korean",
		"landlocked": false,
		"borders": [
			"CHN",
			"KOR",
			"RUS"
		],
		"area": 120538
	},
	{
		"name": {
			"common": "Portugal",
			"official": "Portuguese Republic",
			"native": {
				"por": {
					"official": "República português",
					"common": "Portugal"
				}
			}
		},
		"tld": [
			".pt"
		],
		"cca2": "PT",
		"ccn3": "620",
		"cca3": "PRT",
		"cioc": "POR",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"351"
		],
		"capital": "Lisbon",
		"altSpellings": [
			"PT",
			"Portuguesa",
			"Portuguese Republic",
			"República Portuguesa"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"por": "Portuguese"
		},
		"translations": {
			"deu": {
				"official": "Portugiesische Republik",
				"common": "Portugal"
			},
			"fra": {
				"official": "République portugaise",
				"common": "Portugal"
			},
			"hrv": {
				"official": "Portugalska Republika",
				"common": "Portugal"
			},
			"ita": {
				"official": "Repubblica portoghese",
				"common": "Portogallo"
			},
			"jpn": {
				"official": "ポルトガル共和国",
				"common": "ポルトガル"
			},
			"nld": {
				"official": "Portugese Republiek",
				"common": "Portugal"
			},
			"por": {
				"official": "República português",
				"common": "Portugal"
			},
			"rus": {
				"official": "Португальская Республика",
				"common": "Португалия"
			},
			"spa": {
				"official": "República Portuguesa",
				"common": "Portugal"
			},
			"svk": {
				"official": "Portugalská republika",
				"common": "Portugalsko"
			},
			"fin": {
				"official": "Portugalin tasavalta",
				"common": "Portugali"
			},
			"zho": {
				"official": "葡萄牙共和国",
				"common": "葡萄牙"
			}
		},
		"latlng": [
			39.5,
			-8
		],
		"demonym": "Portuguese",
		"landlocked": false,
		"borders": [
			"ESP"
		],
		"area": 92090
	},
	{
		"name": {
			"common": "Paraguay",
			"official": "Republic of Paraguay",
			"native": {
				"grn": {
					"official": "Tetã Paraguái",
					"common": "Paraguái"
				},
				"spa": {
					"official": "República de Paraguay",
					"common": "Paraguay"
				}
			}
		},
		"tld": [
			".py"
		],
		"cca2": "PY",
		"ccn3": "600",
		"cca3": "PRY",
		"cioc": "PAR",
		"currency": [
			"PYG"
		],
		"callingCode": [
			"595"
		],
		"capital": "Asunción",
		"altSpellings": [
			"PY",
			"Republic of Paraguay",
			"República del Paraguay",
			"Tetã Paraguái"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"grn": "Guaraní",
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Republik Paraguay",
				"common": "Paraguay"
			},
			"fra": {
				"official": "République du Paraguay",
				"common": "Paraguay"
			},
			"hrv": {
				"official": "Republika Paragvaj",
				"common": "Paragvaj"
			},
			"ita": {
				"official": "Repubblica del Paraguay",
				"common": "Paraguay"
			},
			"jpn": {
				"official": "パラグアイ共和国",
				"common": "パラグアイ"
			},
			"nld": {
				"official": "Republiek Paraguay",
				"common": "Paraguay"
			},
			"por": {
				"official": "República do Paraguai",
				"common": "Paraguai"
			},
			"rus": {
				"official": "Республика Парагвай",
				"common": "Парагвай"
			},
			"spa": {
				"official": "República de Paraguay",
				"common": "Paraguay"
			},
			"svk": {
				"official": "Paraguajská republika",
				"common": "Paraguaj"
			},
			"fin": {
				"official": "Paraguayn tasavalta",
				"common": "Paraguay"
			},
			"zho": {
				"official": "巴拉圭共和国",
				"common": "巴拉圭"
			}
		},
		"latlng": [
			-23,
			-58
		],
		"demonym": "Paraguayan",
		"landlocked": true,
		"borders": [
			"ARG",
			"BOL",
			"BRA"
		],
		"area": 406752
	},
	{
		"name": {
			"common": "Palestine",
			"official": "State of Palestine",
			"native": {
				"ara": {
					"official": "دولة فلسطين",
					"common": "فلسطين"
				}
			}
		},
		"tld": [
			".ps",
			"فلسطين."
		],
		"cca2": "PS",
		"ccn3": "275",
		"cca3": "PSE",
		"cioc": "PLE",
		"currency": [
			"ILS"
		],
		"callingCode": [
			"970"
		],
		"capital": "Ramallah",
		"altSpellings": [
			"PS",
			"Palestine, State of",
			"State of Palestine",
			"Dawlat Filasṭin"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Staat Palästina",
				"common": "Palästina"
			},
			"fra": {
				"official": "État de Palestine",
				"common": "Palestine"
			},
			"hrv": {
				"official": "State of Palestine",
				"common": "Palestina"
			},
			"ita": {
				"official": "Stato di Palestina",
				"common": "Palestina"
			},
			"jpn": {
				"official": "パレスチナ自治政府",
				"common": "パレスチナ"
			},
			"nld": {
				"official": "Staat Palestina",
				"common": "Palestijnse gebieden"
			},
			"por": {
				"official": "Estado da Palestina",
				"common": "Palestina"
			},
			"rus": {
				"official": "Государство Палестина",
				"common": "Палестина"
			},
			"spa": {
				"official": "Estado de Palestina",
				"common": "Palestina"
			},
			"svk": {
				"official": "Palestínsky štát",
				"common": "Palestína"
			},
			"fin": {
				"official": "Palestiinan valtio",
				"common": "Palestiina"
			},
			"zho": {
				"official": "巴勒斯坦国",
				"common": "巴勒斯坦"
			}
		},
		"latlng": [
			31.9,
			35.2
		],
		"demonym": "Palestinian",
		"landlocked": false,
		"borders": [
			"ISR",
			"EGY",
			"JOR"
		],
		"area": 6220
	},
	{
		"name": {
			"common": "French Polynesia",
			"official": "French Polynesia",
			"native": {
				"fra": {
					"official": "Polynésie française",
					"common": "Polynésie française"
				}
			}
		},
		"tld": [
			".pf"
		],
		"cca2": "PF",
		"ccn3": "258",
		"cca3": "PYF",
		"cioc": "",
		"currency": [
			"XPF"
		],
		"callingCode": [
			"689"
		],
		"capital": "Papeetē",
		"altSpellings": [
			"PF",
			"Polynésie française",
			"French Polynesia",
			"Pōrīnetia Farāni"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Französisch-Polynesien",
				"common": "Französisch-Polynesien"
			},
			"fra": {
				"official": "Polynésie française",
				"common": "Polynésie française"
			},
			"hrv": {
				"official": "Francuska Polinezija",
				"common": "Francuska Polinezija"
			},
			"ita": {
				"official": "Polinesia Francese",
				"common": "Polinesia Francese"
			},
			"jpn": {
				"official": "フランス領ポリネシア",
				"common": "フランス領ポリネシア"
			},
			"nld": {
				"official": "Frans-Polynesië",
				"common": "Frans-Polynesië"
			},
			"por": {
				"official": "Polinésia Francesa",
				"common": "Polinésia Francesa"
			},
			"rus": {
				"official": "Французская Полинезия",
				"common": "Французская Полинезия"
			},
			"spa": {
				"official": "Polinesia francés",
				"common": "Polinesia Francesa"
			},
			"svk": {
				"official": "Francúzska Polynézia",
				"common": "Francúzska Polynézia"
			},
			"fin": {
				"official": "Ranskan Polynesia",
				"common": "Ranskan Polynesia"
			},
			"zho": {
				"official": "法属波利尼西亚",
				"common": "法属波利尼西亚"
			}
		},
		"latlng": [
			-15,
			-140
		],
		"demonym": "French Polynesian",
		"landlocked": false,
		"borders": [],
		"area": 4167
	},
	{
		"name": {
			"common": "Qatar",
			"official": "State of Qatar",
			"native": {
				"ara": {
					"official": "دولة قطر",
					"common": "قطر"
				}
			}
		},
		"tld": [
			".qa",
			"قطر."
		],
		"cca2": "QA",
		"ccn3": "634",
		"cca3": "QAT",
		"cioc": "QAT",
		"currency": [
			"QAR"
		],
		"callingCode": [
			"974"
		],
		"capital": "Doha",
		"altSpellings": [
			"QA",
			"State of Qatar",
			"Dawlat Qaṭar"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Staat Katar",
				"common": "Katar"
			},
			"fra": {
				"official": "État du Qatar",
				"common": "Qatar"
			},
			"hrv": {
				"official": "Država Katar",
				"common": "Katar"
			},
			"ita": {
				"official": "Stato del Qatar",
				"common": "Qatar"
			},
			"jpn": {
				"official": "カタール国",
				"common": "カタール"
			},
			"nld": {
				"official": "Staat Qatar",
				"common": "Qatar"
			},
			"por": {
				"official": "Estado do Qatar",
				"common": "Catar"
			},
			"rus": {
				"official": "Государство Катар",
				"common": "Катар"
			},
			"spa": {
				"official": "Estado de Qatar",
				"common": "Catar"
			},
			"svk": {
				"official": "Katarský štát",
				"common": "Katar"
			},
			"fin": {
				"official": "Qatarin valtio",
				"common": "Qatar"
			},
			"zho": {
				"official": "卡塔尔国",
				"common": "卡塔尔"
			}
		},
		"latlng": [
			25.5,
			51.25
		],
		"demonym": "Qatari",
		"landlocked": false,
		"borders": [
			"SAU"
		],
		"area": 11586
	},
	{
		"name": {
			"common": "Réunion",
			"official": "Réunion Island",
			"native": {
				"fra": {
					"official": "Ile de la Réunion",
					"common": "La Réunion"
				}
			}
		},
		"tld": [
			".re"
		],
		"cca2": "RE",
		"ccn3": "638",
		"cca3": "REU",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"262"
		],
		"capital": "Saint-Denis",
		"altSpellings": [
			"RE",
			"Reunion"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Réunion",
				"common": "Réunion"
			},
			"fra": {
				"official": "Ile de la Réunion",
				"common": "Réunion"
			},
			"hrv": {
				"official": "Réunion Island",
				"common": "Réunion"
			},
			"ita": {
				"official": "Réunion",
				"common": "Riunione"
			},
			"jpn": {
				"official": "レユニオン島",
				"common": "レユニオン"
			},
			"nld": {
				"official": "Réunion",
				"common": "Réunion"
			},
			"por": {
				"official": "Ilha da Reunião",
				"common": "Reunião"
			},
			"rus": {
				"official": "Реюньон",
				"common": "Реюньон"
			},
			"spa": {
				"official": "Isla de la Reunión",
				"common": "Reunión"
			},
			"svk": {
				"official": "Réunionský zámorský departmán",
				"common": "Réunion"
			},
			"fin": {
				"official": "Réunion",
				"common": "Réunion"
			},
			"zho": {
				"official": "留尼旺岛",
				"common": "留尼旺岛"
			}
		},
		"latlng": [
			-21.15,
			55.5
		],
		"demonym": "French",
		"landlocked": false,
		"borders": [],
		"area": 2511
	},
	{
		"name": {
			"common": "Romania",
			"official": "Romania",
			"native": {
				"ron": {
					"official": "România",
					"common": "România"
				}
			}
		},
		"tld": [
			".ro"
		],
		"cca2": "RO",
		"ccn3": "642",
		"cca3": "ROU",
		"cioc": "ROU",
		"currency": [
			"RON"
		],
		"callingCode": [
			"40"
		],
		"capital": "Bucharest",
		"altSpellings": [
			"RO",
			"Rumania",
			"Roumania",
			"România"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"ron": "Romanian"
		},
		"translations": {
			"deu": {
				"official": "Rumänien",
				"common": "Rumänien"
			},
			"fra": {
				"official": "Roumanie",
				"common": "Roumanie"
			},
			"hrv": {
				"official": "Rumunija",
				"common": "Rumunjska"
			},
			"ita": {
				"official": "Romania",
				"common": "Romania"
			},
			"jpn": {
				"official": "ルーマニア",
				"common": "ルーマニア"
			},
			"nld": {
				"official": "Roemenië",
				"common": "Roemenië"
			},
			"por": {
				"official": "Romênia",
				"common": "Roménia"
			},
			"rus": {
				"official": "Румыния",
				"common": "Румыния"
			},
			"spa": {
				"official": "Rumania",
				"common": "Rumania"
			},
			"svk": {
				"official": "Rumunsko",
				"common": "Rumunsko"
			},
			"fin": {
				"official": "Romania",
				"common": "Romania"
			},
			"zho": {
				"official": "罗马尼亚",
				"common": "罗马尼亚"
			}
		},
		"latlng": [
			46,
			25
		],
		"demonym": "Romanian",
		"landlocked": false,
		"borders": [
			"BGR",
			"HUN",
			"MDA",
			"SRB",
			"UKR"
		],
		"area": 238391
	},
	{
		"name": {
			"common": "Russia",
			"official": "Russian Federation",
			"native": {
				"rus": {
					"official": "Русская Федерация",
					"common": "Россия"
				}
			}
		},
		"tld": [
			".ru",
			".su",
			".рф"
		],
		"cca2": "RU",
		"ccn3": "643",
		"cca3": "RUS",
		"cioc": "RUS",
		"currency": [
			"RUB"
		],
		"callingCode": [
			"7"
		],
		"capital": "Moscow",
		"altSpellings": [
			"RU",
			"Rossiya",
			"Russian Federation",
			"Российская Федерация",
			"Rossiyskaya Federatsiya"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"rus": "Russian"
		},
		"translations": {
			"deu": {
				"official": "Russische Föderation",
				"common": "Russland"
			},
			"fra": {
				"official": "Fédération de Russie",
				"common": "Russie"
			},
			"hrv": {
				"official": "Ruska Federacija",
				"common": "Rusija"
			},
			"ita": {
				"official": "Federazione russa",
				"common": "Russia"
			},
			"jpn": {
				"official": "ロシア連邦",
				"common": "ロシア連邦"
			},
			"nld": {
				"official": "Russische Federatie",
				"common": "Rusland"
			},
			"por": {
				"official": "Federação Russa",
				"common": "Rússia"
			},
			"rus": {
				"official": "Россия Федерация",
				"common": "Россия"
			},
			"spa": {
				"official": "Federación de Rusia",
				"common": "Rusia"
			},
			"svk": {
				"official": "Ruská federácia",
				"common": "Rusko"
			},
			"fin": {
				"official": "Venäjän federaatio",
				"common": "Venäjä"
			},
			"zho": {
				"official": "俄罗斯联邦",
				"common": "俄罗斯"
			}
		},
		"latlng": [
			60,
			100
		],
		"demonym": "Russian",
		"landlocked": false,
		"borders": [
			"AZE",
			"BLR",
			"CHN",
			"EST",
			"FIN",
			"GEO",
			"KAZ",
			"PRK",
			"LVA",
			"LTU",
			"MNG",
			"NOR",
			"POL",
			"UKR"
		],
		"area": 17098242
	},
	{
		"name": {
			"common": "Rwanda",
			"official": "Republic of Rwanda",
			"native": {
				"eng": {
					"official": "Republic of Rwanda",
					"common": "Rwanda"
				},
				"fra": {
					"official": "République rwandaise",
					"common": "Rwanda"
				},
				"kin": {
					"official": "Repubulika y'u Rwanda",
					"common": "Rwanda"
				}
			}
		},
		"tld": [
			".rw"
		],
		"cca2": "RW",
		"ccn3": "646",
		"cca3": "RWA",
		"cioc": "RWA",
		"currency": [
			"RWF"
		],
		"callingCode": [
			"250"
		],
		"capital": "Kigali",
		"altSpellings": [
			"RW",
			"Republic of Rwanda",
			"Repubulika y'u Rwanda",
			"République du Rwanda"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"eng": "English",
			"fra": "French",
			"kin": "Kinyarwanda"
		},
		"translations": {
			"deu": {
				"official": "Republik Ruanda",
				"common": "Ruanda"
			},
			"fra": {
				"official": "République rwandaise",
				"common": "Rwanda"
			},
			"hrv": {
				"official": "Republika Ruandi",
				"common": "Ruanda"
			},
			"ita": {
				"official": "Repubblica del Ruanda",
				"common": "Ruanda"
			},
			"jpn": {
				"official": "ルワンダ共和国",
				"common": "ルワンダ"
			},
			"nld": {
				"official": "Republiek Rwanda",
				"common": "Rwanda"
			},
			"por": {
				"official": "República do Ruanda",
				"common": "Ruanda"
			},
			"rus": {
				"official": "Республика Руанда",
				"common": "Руанда"
			},
			"spa": {
				"official": "República de Rwanda",
				"common": "Ruanda"
			},
			"svk": {
				"official": "Rwandská republika",
				"common": "Rwanda"
			},
			"fin": {
				"official": "Ruandan tasavalta",
				"common": "Ruanda"
			},
			"zho": {
				"official": "卢旺达共和国",
				"common": "卢旺达"
			}
		},
		"latlng": [
			-2,
			30
		],
		"demonym": "Rwandan",
		"landlocked": true,
		"borders": [
			"BDI",
			"COD",
			"TZA",
			"UGA"
		],
		"area": 26338
	},
	{
		"name": {
			"common": "Saudi Arabia",
			"official": "Kingdom of Saudi Arabia",
			"native": {
				"ara": {
					"official": "المملكة العربية السعودية",
					"common": "العربية السعودية"
				}
			}
		},
		"tld": [
			".sa",
			".السعودية"
		],
		"cca2": "SA",
		"ccn3": "682",
		"cca3": "SAU",
		"cioc": "KSA",
		"currency": [
			"SAR"
		],
		"callingCode": [
			"966"
		],
		"capital": "Riyadh",
		"altSpellings": [
			"Saudi",
			"SA",
			"Kingdom of Saudi Arabia",
			"Al-Mamlakah al-‘Arabiyyah as-Su‘ūdiyyah"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Königreich Saudi-Arabien",
				"common": "Saudi-Arabien"
			},
			"fra": {
				"official": "Royaume d'Arabie Saoudite",
				"common": "Arabie Saoudite"
			},
			"hrv": {
				"official": "Kraljevina Saudijska Arabija",
				"common": "Saudijska Arabija"
			},
			"ita": {
				"official": "Arabia Saudita",
				"common": "Arabia Saudita"
			},
			"jpn": {
				"official": "サウジアラビア王国",
				"common": "サウジアラビア"
			},
			"nld": {
				"official": "Koninkrijk van Saoedi-Arabië",
				"common": "Saoedi-Arabië"
			},
			"por": {
				"official": "Reino da Arábia Saudita",
				"common": "Arábia Saudita"
			},
			"rus": {
				"official": "Королевство Саудовская Аравия",
				"common": "Саудовская Аравия"
			},
			"spa": {
				"official": "Reino de Arabia Saudita",
				"common": "Arabia Saudí"
			},
			"svk": {
				"official": "Saudskoarabské kráľovstvo",
				"common": "Saudská Arábia"
			},
			"fin": {
				"official": "Saudi-Arabian kuningaskunta",
				"common": "Saudi-Arabia"
			},
			"zho": {
				"official": "沙特阿拉伯王国",
				"common": "沙特阿拉伯"
			}
		},
		"latlng": [
			25,
			45
		],
		"demonym": "Saudi Arabian",
		"landlocked": false,
		"borders": [
			"IRQ",
			"JOR",
			"KWT",
			"OMN",
			"QAT",
			"ARE",
			"YEM"
		],
		"area": 2149690
	},
	{
		"name": {
			"common": "Sudan",
			"official": "Republic of the Sudan",
			"native": {
				"ara": {
					"official": "جمهورية السودان",
					"common": "السودان"
				},
				"eng": {
					"official": "Republic of the Sudan",
					"common": "Sudan"
				}
			}
		},
		"tld": [
			".sd"
		],
		"cca2": "SD",
		"ccn3": "729",
		"cca3": "SDN",
		"cioc": "SUD",
		"currency": [
			"SDG"
		],
		"callingCode": [
			"249"
		],
		"capital": "Khartoum",
		"altSpellings": [
			"SD",
			"Republic of the Sudan",
			"Jumhūrīyat as-Sūdān"
		],
		"region": "Africa",
		"subregion": "Northern Africa",
		"languages": {
			"ara": "Arabic",
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Republik Sudan",
				"common": "Sudan"
			},
			"fra": {
				"official": "République du Soudan",
				"common": "Soudan"
			},
			"hrv": {
				"official": "Republika Sudan",
				"common": "Sudan"
			},
			"ita": {
				"official": "Repubblica del Sudan",
				"common": "Sudan"
			},
			"jpn": {
				"official": "スーダン共和国",
				"common": "スーダン"
			},
			"nld": {
				"official": "Republiek Soedan",
				"common": "Soedan"
			},
			"por": {
				"official": "República do Sudão",
				"common": "Sudão"
			},
			"rus": {
				"official": "Республика Судан",
				"common": "Судан"
			},
			"spa": {
				"official": "República de Sudán",
				"common": "Sudán"
			},
			"svk": {
				"official": "Sudánska republika",
				"common": "Sudán"
			},
			"fin": {
				"official": "Sudanin tasavalta",
				"common": "Sudan"
			},
			"zho": {
				"official": "苏丹共和国",
				"common": "苏丹"
			}
		},
		"latlng": [
			15,
			30
		],
		"demonym": "Sudanese",
		"landlocked": false,
		"borders": [
			"CAF",
			"TCD",
			"EGY",
			"ERI",
			"ETH",
			"LBY",
			"SSD"
		],
		"area": 1886068
	},
	{
		"name": {
			"common": "Senegal",
			"official": "Republic of Senegal",
			"native": {
				"fra": {
					"official": "République du Sénégal",
					"common": "Sénégal"
				}
			}
		},
		"tld": [
			".sn"
		],
		"cca2": "SN",
		"ccn3": "686",
		"cca3": "SEN",
		"cioc": "SEN",
		"currency": [
			"XOF"
		],
		"callingCode": [
			"221"
		],
		"capital": "Dakar",
		"altSpellings": [
			"SN",
			"Republic of Senegal",
			"République du Sénégal"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Republik Senegal",
				"common": "Senegal"
			},
			"fra": {
				"official": "République du Sénégal",
				"common": "Sénégal"
			},
			"hrv": {
				"official": "Republika Senegal",
				"common": "Senegal"
			},
			"ita": {
				"official": "Repubblica del Senegal",
				"common": "Senegal"
			},
			"jpn": {
				"official": "セネガル共和国",
				"common": "セネガル"
			},
			"nld": {
				"official": "Republiek Senegal",
				"common": "Senegal"
			},
			"por": {
				"official": "República do Senegal",
				"common": "Senegal"
			},
			"rus": {
				"official": "Республика Сенегал",
				"common": "Сенегал"
			},
			"spa": {
				"official": "República de Senegal",
				"common": "Senegal"
			},
			"svk": {
				"official": "Senegalská republika",
				"common": "Senegal"
			},
			"fin": {
				"official": "Senegalin tasavalta",
				"common": "Senegal"
			},
			"zho": {
				"official": "塞内加尔共和国",
				"common": "塞内加尔"
			}
		},
		"latlng": [
			14,
			-14
		],
		"demonym": "Senegalese",
		"landlocked": false,
		"borders": [
			"GMB",
			"GIN",
			"GNB",
			"MLI",
			"MRT"
		],
		"area": 196722
	},
	{
		"name": {
			"common": "Singapore",
			"official": "Republic of Singapore",
			"native": {
				"zho": {
					"official": "新加坡共和国",
					"common": "新加坡"
				},
				"eng": {
					"official": "Republic of Singapore",
					"common": "Singapore"
				},
				"msa": {
					"official": "Republik Singapura",
					"common": "Singapura"
				},
				"tam": {
					"official": "சிங்கப்பூர் குடியரசு",
					"common": "சிங்கப்பூர்"
				}
			}
		},
		"tld": [
			".sg",
			".新加坡",
			".சிங்கப்பூர்"
		],
		"cca2": "SG",
		"ccn3": "702",
		"cca3": "SGP",
		"cioc": "SIN",
		"currency": [
			"SGD"
		],
		"callingCode": [
			"65"
		],
		"capital": "Singapore",
		"altSpellings": [
			"SG",
			"Singapura",
			"Republik Singapura",
			"新加坡共和国"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"zho": "Chinese",
			"eng": "English",
			"msa": "Malay",
			"tam": "Tamil"
		},
		"translations": {
			"deu": {
				"official": "Republik Singapur",
				"common": "Singapur"
			},
			"fra": {
				"official": "République de Singapour",
				"common": "Singapour"
			},
			"hrv": {
				"official": "Republika Singapur",
				"common": "Singapur"
			},
			"ita": {
				"official": "Repubblica di Singapore",
				"common": "Singapore"
			},
			"jpn": {
				"official": "シンガポール共和国",
				"common": "シンガポール"
			},
			"nld": {
				"official": "Republiek Singapore",
				"common": "Singapore"
			},
			"por": {
				"official": "República de Singapura",
				"common": "Singapura"
			},
			"rus": {
				"official": "Республика Сингапур",
				"common": "Сингапур"
			},
			"spa": {
				"official": "República de Singapur",
				"common": "Singapur"
			},
			"svk": {
				"official": "Singapurská republika",
				"common": "Singapur"
			},
			"fin": {
				"official": "Singaporen tasavalta",
				"common": "Singapore"
			}
		},
		"latlng": [
			1.36666666,
			103.8
		],
		"demonym": "Singaporean",
		"landlocked": false,
		"borders": [],
		"area": 710
	},
	{
		"name": {
			"common": "South Georgia",
			"official": "South Georgia and the South Sandwich Islands",
			"native": {
				"eng": {
					"official": "South Georgia and the South Sandwich Islands",
					"common": "South Georgia"
				}
			}
		},
		"tld": [
			".gs"
		],
		"cca2": "GS",
		"ccn3": "239",
		"cca3": "SGS",
		"cioc": "",
		"currency": [
			"GBP"
		],
		"callingCode": [
			"500"
		],
		"capital": "King Edward Point",
		"altSpellings": [
			"GS",
			"South Georgia and the South Sandwich Islands"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Südgeorgien und die Südlichen Sandwichinseln",
				"common": "Südgeorgien und die Südlichen Sandwichinseln"
			},
			"fra": {
				"official": "Géorgie du Sud et les îles Sandwich du Sud",
				"common": "Géorgie du Sud-et-les Îles Sandwich du Sud"
			},
			"hrv": {
				"official": "Južna Džordžija i Otoci Južni Sendvič",
				"common": "Južna Georgija i otočje Južni Sandwich"
			},
			"ita": {
				"official": "Georgia del Sud e isole Sandwich del Sud",
				"common": "Georgia del Sud e Isole Sandwich Meridionali"
			},
			"jpn": {
				"official": "サウスジョージア·サウスサンドウィッチ諸島",
				"common": "サウスジョージア・サウスサンドウィッチ諸島"
			},
			"nld": {
				"official": "Zuid-Georgië en de Zuidelijke Sandwich-eilanden",
				"common": "Zuid-Georgia en Zuidelijke Sandwicheilanden"
			},
			"por": {
				"official": "Geórgia do Sul e Sandwich do Sul",
				"common": "Ilhas Geórgia do Sul e Sandwich do Sul"
			},
			"rus": {
				"official": "Южная Георгия и Южные Сандвичевы острова",
				"common": "Южная Георгия и Южные Сандвичевы острова"
			},
			"spa": {
				"official": "Georgia del Sur y las Islas Sandwich del Sur",
				"common": "Islas Georgias del Sur y Sandwich del Sur"
			},
			"svk": {
				"official": "Južná Georgia a Južné Sandwichove ostrovy",
				"common": "Južná Georgia a Južné Sandwichove ostrovy"
			},
			"fin": {
				"official": "Etelä-Georgia ja Eteläiset Sandwichsaaret",
				"common": "Etelä-Georgia ja Eteläiset Sandwichsaaret"
			},
			"zho": {
				"official": "南乔治亚岛和南桑威奇群岛",
				"common": "南乔治亚"
			}
		},
		"latlng": [
			-54.5,
			-37
		],
		"demonym": "South Georgian South Sandwich Islander",
		"landlocked": false,
		"borders": [],
		"area": 3903
	},
	{
		"name": {
			"common": "Svalbard and Jan Mayen",
			"official": "Svalbard og Jan Mayen",
			"native": {
				"nor": {
					"official": "Svalbard og Jan Mayen",
					"common": "Svalbard og Jan Mayen"
				}
			}
		},
		"tld": [
			".sj"
		],
		"cca2": "SJ",
		"ccn3": "744",
		"cca3": "SJM",
		"cioc": "",
		"currency": [
			"NOK"
		],
		"callingCode": [
			"4779"
		],
		"capital": "Longyearbyen",
		"altSpellings": [
			"SJ",
			"Svalbard and Jan Mayen Islands"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"nor": "Norwegian"
		},
		"translations": {
			"deu": {
				"official": "Inselgruppe Spitzbergen",
				"common": "Spitzbergen"
			},
			"fra": {
				"official": "Jan Mayen Svalbard",
				"common": "Svalbard et Jan Mayen"
			},
			"hrv": {
				"official": "Svalbard og Jan Mayen",
				"common": "Svalbard i Jan Mayen"
			},
			"ita": {
				"official": "Svalbard og Jan Mayen",
				"common": "Svalbard e Jan Mayen"
			},
			"jpn": {
				"official": "スバールバル諸島OGヤンマイエン",
				"common": "スヴァールバル諸島およびヤンマイエン島"
			},
			"nld": {
				"official": "Svalbard og Jan Mayen",
				"common": "Svalbard en Jan Mayen"
			},
			"por": {
				"official": "Svalbard og Jan Mayen",
				"common": "Ilhas Svalbard e Jan Mayen"
			},
			"rus": {
				"official": "Свальбарда ог Ян-Майен",
				"common": "Шпицберген и Ян-Майен"
			},
			"spa": {
				"official": "Svalbard og Jan Mayen",
				"common": "Islas Svalbard y Jan Mayen"
			},
			"svk": {
				"official": "Svalbard a Jan Mayen",
				"common": "Svalbard a Jan Mayen"
			},
			"fin": {
				"official": "Huippuvuoret",
				"common": "Huippuvuoret"
			},
			"zho": {
				"official": "斯瓦尔巴特",
				"common": "斯瓦尔巴特"
			}
		},
		"latlng": [
			78,
			20
		],
		"demonym": "Norwegian",
		"landlocked": false,
		"borders": [],
		"area": -1
	},
	{
		"name": {
			"common": "Solomon Islands",
			"official": "Solomon Islands",
			"native": {
				"eng": {
					"official": "Solomon Islands",
					"common": "Solomon Islands"
				}
			}
		},
		"tld": [
			".sb"
		],
		"cca2": "SB",
		"ccn3": "090",
		"cca3": "SLB",
		"cioc": "SOL",
		"currency": [
			"SBD"
		],
		"callingCode": [
			"677"
		],
		"capital": "Honiara",
		"altSpellings": [
			"SB"
		],
		"region": "Oceania",
		"subregion": "Melanesia",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Salomon-Inseln",
				"common": "Salomonen"
			},
			"fra": {
				"official": "Îles Salomon",
				"common": "Îles Salomon"
			},
			"hrv": {
				"official": "Solomonski Otoci",
				"common": "Solomonski Otoci"
			},
			"ita": {
				"official": "Isole Salomone",
				"common": "Isole Salomone"
			},
			"jpn": {
				"official": "ソロモン諸島",
				"common": "ソロモン諸島"
			},
			"nld": {
				"official": "Solomon eilanden",
				"common": "Salomonseilanden"
			},
			"por": {
				"official": "Ilhas Salomão",
				"common": "Ilhas Salomão"
			},
			"rus": {
				"official": "Соломоновы острова",
				"common": "Соломоновы Острова"
			},
			"spa": {
				"official": "islas Salomón",
				"common": "Islas Salomón"
			},
			"svk": {
				"official": "Salomonove ostrovy",
				"common": "Salomonove ostrovy"
			},
			"fin": {
				"official": "Salomonsaaret",
				"common": "Salomonsaaret"
			},
			"zho": {
				"official": "所罗门群岛",
				"common": "所罗门群岛"
			}
		},
		"latlng": [
			-8,
			159
		],
		"demonym": "Solomon Islander",
		"landlocked": false,
		"borders": [],
		"area": 28896
	},
	{
		"name": {
			"common": "Sierra Leone",
			"official": "Republic of Sierra Leone",
			"native": {
				"eng": {
					"official": "Republic of Sierra Leone",
					"common": "Sierra Leone"
				}
			}
		},
		"tld": [
			".sl"
		],
		"cca2": "SL",
		"ccn3": "694",
		"cca3": "SLE",
		"cioc": "SLE",
		"currency": [
			"SLL"
		],
		"callingCode": [
			"232"
		],
		"capital": "Freetown",
		"altSpellings": [
			"SL",
			"Republic of Sierra Leone"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Republik Sierra Leone",
				"common": "Sierra Leone"
			},
			"fra": {
				"official": "République de Sierra Leone",
				"common": "Sierra Leone"
			},
			"hrv": {
				"official": "Republika Sijera Leone",
				"common": "Sijera Leone"
			},
			"ita": {
				"official": "Repubblica della Sierra Leone",
				"common": "Sierra Leone"
			},
			"jpn": {
				"official": "シエラレオネ共和国",
				"common": "シエラレオネ"
			},
			"nld": {
				"official": "Republiek Sierra Leone",
				"common": "Sierra Leone"
			},
			"por": {
				"official": "República da Serra Leoa",
				"common": "Serra Leoa"
			},
			"rus": {
				"official": "Республика Сьерра-Леоне",
				"common": "Сьерра-Леоне"
			},
			"spa": {
				"official": "República de Sierra Leona",
				"common": "Sierra Leone"
			},
			"svk": {
				"official": "Sierraleonská republika",
				"common": "Sierra Leone"
			},
			"fin": {
				"official": "Sierra Leonen tasavalta",
				"common": "Sierra Leone"
			},
			"zho": {
				"official": "塞拉利昂共和国",
				"common": "塞拉利昂"
			}
		},
		"latlng": [
			8.5,
			-11.5
		],
		"demonym": "Sierra Leonean",
		"landlocked": false,
		"borders": [
			"GIN",
			"LBR"
		],
		"area": 71740
	},
	{
		"name": {
			"common": "El Salvador",
			"official": "Republic of El Salvador",
			"native": {
				"spa": {
					"official": "República de El Salvador",
					"common": "El Salvador"
				}
			}
		},
		"tld": [
			".sv"
		],
		"cca2": "SV",
		"ccn3": "222",
		"cca3": "SLV",
		"cioc": "ESA",
		"currency": [
			"SVC",
			"USD"
		],
		"callingCode": [
			"503"
		],
		"capital": "San Salvador",
		"altSpellings": [
			"SV",
			"Republic of El Salvador",
			"República de El Salvador"
		],
		"region": "Americas",
		"subregion": "Central America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"cym": {
				"official": "Republic of El Salvador",
				"common": "El Salvador"
			},
			"deu": {
				"official": "Republik El Salvador",
				"common": "El Salvador"
			},
			"fra": {
				"official": "République du Salvador",
				"common": "Salvador"
			},
			"hrv": {
				"official": "Republika El Salvador",
				"common": "Salvador"
			},
			"ita": {
				"official": "Repubblica di El Salvador",
				"common": "El Salvador"
			},
			"jpn": {
				"official": "エルサルバドル共和国",
				"common": "エルサルバドル"
			},
			"nld": {
				"official": "Republiek El Salvador",
				"common": "El Salvador"
			},
			"por": {
				"official": "República de El Salvador",
				"common": "El Salvador"
			},
			"rus": {
				"official": "Республика Эль-Сальвадор",
				"common": "Сальвадор"
			},
			"spa": {
				"official": "República de El Salvador",
				"common": "El Salvador"
			},
			"svk": {
				"official": "Salvádorská republika",
				"common": "Salvádor"
			},
			"fin": {
				"official": "El Salvadorin tasavalta",
				"common": "El Salvador"
			},
			"zho": {
				"official": "萨尔瓦多共和国",
				"common": "萨尔瓦多"
			}
		},
		"latlng": [
			13.83333333,
			-88.91666666
		],
		"demonym": "Salvadoran",
		"landlocked": false,
		"borders": [
			"GTM",
			"HND"
		],
		"area": 21041
	},
	{
		"name": {
			"common": "San Marino",
			"official": "Most Serene Republic of San Marino",
			"native": {
				"ita": {
					"official": "Serenissima Repubblica di San Marino",
					"common": "San Marino"
				}
			}
		},
		"tld": [
			".sm"
		],
		"cca2": "SM",
		"ccn3": "674",
		"cca3": "SMR",
		"cioc": "SMR",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"378"
		],
		"capital": "City of San Marino",
		"altSpellings": [
			"SM",
			"Republic of San Marino",
			"Repubblica di San Marino"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"ita": "Italian"
		},
		"translations": {
			"deu": {
				"official": "Republik San Marino",
				"common": "San Marino"
			},
			"fra": {
				"official": "République de Saint-Marin",
				"common": "Saint-Marin"
			},
			"hrv": {
				"official": "Većina Serene Republika San Marino",
				"common": "San Marino"
			},
			"ita": {
				"official": "Serenissima Repubblica di San Marino",
				"common": "San Marino"
			},
			"jpn": {
				"official": "サンマリノのほとんどセリーヌ共和国",
				"common": "サンマリノ"
			},
			"nld": {
				"official": "Meest Serene Republiek San Marino",
				"common": "San Marino"
			},
			"por": {
				"official": "Sereníssima República de San Marino",
				"common": "San Marino"
			},
			"rus": {
				"official": "Большинство Serene Республика Сан-Марино",
				"common": "Сан-Марино"
			},
			"spa": {
				"official": "Serenísima República de San Marino",
				"common": "San Marino"
			},
			"svk": {
				"official": "Sanmarínska republika",
				"common": "San Maríno"
			},
			"fin": {
				"official": "San Marinon seesteinen tasavalta",
				"common": "San Marino"
			},
			"zho": {
				"official": "圣马力诺共和国",
				"common": "圣马力诺"
			}
		},
		"latlng": [
			43.76666666,
			12.41666666
		],
		"demonym": "Sammarinese",
		"landlocked": true,
		"borders": [
			"ITA"
		],
		"area": 61
	},
	{
		"name": {
			"common": "Somalia",
			"official": "Federal Republic of Somalia",
			"native": {
				"ara": {
					"official": "جمهورية الصومال‎‎",
					"common": "الصومال‎‎"
				},
				"som": {
					"official": "Jamhuuriyadda Federaalka Soomaaliya",
					"common": "Soomaaliya"
				}
			}
		},
		"tld": [
			".so"
		],
		"cca2": "SO",
		"ccn3": "706",
		"cca3": "SOM",
		"cioc": "SOM",
		"currency": [
			"SOS"
		],
		"callingCode": [
			"252"
		],
		"capital": "Mogadishu",
		"altSpellings": [
			"SO",
			"aṣ-Ṣūmāl",
			"Federal Republic of Somalia",
			"Jamhuuriyadda Federaalka Soomaaliya",
			"Jumhūriyyat aṣ-Ṣūmāl al-Fiderāliyya"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"ara": "Arabic",
			"som": "Somali"
		},
		"translations": {
			"deu": {
				"official": "Bundesrepublik Somalia",
				"common": "Somalia"
			},
			"fra": {
				"official": "République fédérale de Somalie",
				"common": "Somalie"
			},
			"hrv": {
				"official": "Savezna Republika Somaliji",
				"common": "Somalija"
			},
			"ita": {
				"official": "Repubblica federale di Somalia",
				"common": "Somalia"
			},
			"jpn": {
				"official": "ソマリア連邦共和国",
				"common": "ソマリア"
			},
			"nld": {
				"official": "Federale Republiek Somalië",
				"common": "Somalië"
			},
			"por": {
				"official": "República Federal da Somália",
				"common": "Somália"
			},
			"rus": {
				"official": "Федеративная Республика Сомали",
				"common": "Сомали"
			},
			"spa": {
				"official": "República Federal de Somalia",
				"common": "Somalia"
			},
			"svk": {
				"official": "Somálska federatívna republika",
				"common": "Somálsko"
			},
			"fin": {
				"official": "Somalian liittotasavalta",
				"common": "Somalia"
			},
			"zho": {
				"official": "索马里共和国",
				"common": "索马里"
			}
		},
		"latlng": [
			10,
			49
		],
		"demonym": "Somali",
		"landlocked": false,
		"borders": [
			"DJI",
			"ETH",
			"KEN"
		],
		"area": 637657
	},
	{
		"name": {
			"common": "Saint Pierre and Miquelon",
			"official": "Saint Pierre and Miquelon",
			"native": {
				"fra": {
					"official": "Collectivité territoriale de Saint-Pierre-et-Miquelon",
					"common": "Saint-Pierre-et-Miquelon"
				}
			}
		},
		"tld": [
			".pm"
		],
		"cca2": "PM",
		"ccn3": "666",
		"cca3": "SPM",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"508"
		],
		"capital": "Saint-Pierre",
		"altSpellings": [
			"PM",
			"Collectivité territoriale de Saint-Pierre-et-Miquelon"
		],
		"region": "Americas",
		"subregion": "Northern America",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "St. Pierre und Miquelon",
				"common": "Saint-Pierre und Miquelon"
			},
			"fra": {
				"official": "Saint-Pierre-et-Miquelon",
				"common": "Saint-Pierre-et-Miquelon"
			},
			"hrv": {
				"official": "Saint Pierre i Miquelon",
				"common": "Sveti Petar i Mikelon"
			},
			"ita": {
				"official": "Saint Pierre e Miquelon",
				"common": "Saint-Pierre e Miquelon"
			},
			"jpn": {
				"official": "サンピエール島·ミクロン島",
				"common": "サンピエール島・ミクロン島"
			},
			"nld": {
				"official": "Saint-Pierre en Miquelon",
				"common": "Saint Pierre en Miquelon"
			},
			"por": {
				"official": "Saint Pierre e Miquelon",
				"common": "Saint-Pierre e Miquelon"
			},
			"rus": {
				"official": "Сен-Пьер и Микелон",
				"common": "Сен-Пьер и Микелон"
			},
			"spa": {
				"official": "San Pedro y Miquelón",
				"common": "San Pedro y Miquelón"
			},
			"svk": {
				"official": "Ostrovy Saint Pierre a Miquelon",
				"common": "Saint Pierre a Miquelon"
			},
			"fin": {
				"official": "Saint-Pierre ja Miquelon",
				"common": "Saint-Pierre ja Miquelon"
			},
			"zho": {
				"official": "圣皮埃尔和密克隆",
				"common": "圣皮埃尔和密克隆"
			}
		},
		"latlng": [
			46.83333333,
			-56.33333333
		],
		"demonym": "French",
		"landlocked": false,
		"borders": [],
		"area": 242
	},
	{
		"name": {
			"common": "Serbia",
			"official": "Republic of Serbia",
			"native": {
				"srp": {
					"official": "Република Србија",
					"common": "Србија"
				}
			}
		},
		"tld": [
			".rs",
			".срб"
		],
		"cca2": "RS",
		"ccn3": "688",
		"cca3": "SRB",
		"cioc": "SRB",
		"currency": [
			"RSD"
		],
		"callingCode": [
			"381"
		],
		"capital": "Belgrade",
		"altSpellings": [
			"RS",
			"Srbija",
			"Republic of Serbia",
			"Република Србија",
			"Republika Srbija"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"srp": "Serbian"
		},
		"translations": {
			"deu": {
				"official": "Republik Serbien",
				"common": "Serbien"
			},
			"fra": {
				"official": "République de Serbie",
				"common": "Serbie"
			},
			"hrv": {
				"official": "Republika Srbija",
				"common": "Srbija"
			},
			"ita": {
				"official": "Repubblica di Serbia",
				"common": "Serbia"
			},
			"jpn": {
				"official": "セルビア共和国",
				"common": "セルビア"
			},
			"nld": {
				"official": "Republiek Servië",
				"common": "Servië"
			},
			"por": {
				"official": "República da Sérvia",
				"common": "Sérvia"
			},
			"rus": {
				"official": "Республика Сербия",
				"common": "Сербия"
			},
			"spa": {
				"official": "República de Serbia",
				"common": "Serbia"
			},
			"svk": {
				"official": "Srbská republika",
				"common": "Srbsko"
			},
			"fin": {
				"official": "Serbian tasavalta",
				"common": "Serbia"
			},
			"zho": {
				"official": "塞尔维亚共和国",
				"common": "塞尔维亚"
			}
		},
		"latlng": [
			44,
			21
		],
		"demonym": "Serbian",
		"landlocked": true,
		"borders": [
			"BIH",
			"BGR",
			"HRV",
			"HUN",
			"UNK",
			"MKD",
			"MNE",
			"ROU"
		],
		"area": 88361
	},
	{
		"name": {
			"common": "South Sudan",
			"official": "Republic of South Sudan",
			"native": {
				"eng": {
					"official": "Republic of South Sudan",
					"common": "South Sudan"
				}
			}
		},
		"tld": [
			".ss"
		],
		"cca2": "SS",
		"ccn3": "728",
		"cca3": "SSD",
		"cioc": "",
		"currency": [
			"SSP"
		],
		"callingCode": [
			"211"
		],
		"capital": "Juba",
		"altSpellings": [
			"SS"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Republik Südsudan",
				"common": "Südsudan"
			},
			"fra": {
				"official": "République du Soudan du Sud",
				"common": "Soudan du Sud"
			},
			"hrv": {
				"official": "Republika Južni Sudan",
				"common": "Južni Sudan"
			},
			"ita": {
				"official": "Repubblica del Sudan del Sud",
				"common": "Sudan del sud"
			},
			"jpn": {
				"official": "南スーダン共和国",
				"common": "南スーダン"
			},
			"nld": {
				"official": "Republiek Zuid-Soedan",
				"common": "Zuid-Soedan"
			},
			"por": {
				"official": "República do Sudão do Sul",
				"common": "Sudão do Sul"
			},
			"rus": {
				"official": "Республика Южный Судан",
				"common": "Южный Судан"
			},
			"spa": {
				"official": "República de Sudán del Sur",
				"common": "Sudán del Sur"
			},
			"svk": {
				"official": "Juhosudánska republika",
				"common": "Južný Sudán"
			},
			"fin": {
				"official": "Etelä-Sudanin tasavalta",
				"common": "Etelä-Sudan"
			},
			"zho": {
				"official": "南苏丹共和国",
				"common": "南苏丹"
			}
		},
		"latlng": [
			7,
			30
		],
		"demonym": "South Sudanese",
		"landlocked": true,
		"borders": [
			"CAF",
			"COD",
			"ETH",
			"KEN",
			"SDN",
			"UGA"
		],
		"area": 619745
	},
	{
		"name": {
			"common": "São Tomé and Príncipe",
			"official": "Democratic Republic of São Tomé and Príncipe",
			"native": {
				"por": {
					"official": "República Democrática do São Tomé e Príncipe",
					"common": "São Tomé e Príncipe"
				}
			}
		},
		"tld": [
			".st"
		],
		"cca2": "ST",
		"ccn3": "678",
		"cca3": "STP",
		"cioc": "STP",
		"currency": [
			"STD"
		],
		"callingCode": [
			"239"
		],
		"capital": "São Tomé",
		"altSpellings": [
			"ST",
			"Democratic Republic of São Tomé and Príncipe",
			"Sao Tome and Principe",
			"República Democrática de São Tomé e Príncipe"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"por": "Portuguese"
		},
		"translations": {
			"deu": {
				"official": "Demokratische Republik São Tomé und Príncipe",
				"common": "São Tomé und Príncipe"
			},
			"fra": {
				"official": "République démocratique de São Tomé et Príncipe",
				"common": "São Tomé et Príncipe"
			},
			"hrv": {
				"official": "Demokratska Republika São Tome i Principe",
				"common": "Sveti Toma i Princip"
			},
			"ita": {
				"official": "Repubblica democratica di São Tomé e Príncipe",
				"common": "São Tomé e Príncipe"
			},
			"jpn": {
				"official": "サントメ·プリンシペ民主共和国",
				"common": "サントメ・プリンシペ"
			},
			"nld": {
				"official": "Democratische Republiek Sao Tomé en Principe",
				"common": "Sao Tomé en Principe"
			},
			"por": {
				"official": "República Democrática de São Tomé e Príncipe",
				"common": "São Tomé e Príncipe"
			},
			"rus": {
				"official": "Демократическая Республика Сан-Томе и Принсипи",
				"common": "Сан-Томе и Принсипи"
			},
			"spa": {
				"official": "República Democrática de Santo Tomé y Príncipe",
				"common": "Santo Tomé y Príncipe"
			},
			"svk": {
				"official": "Demokratická republika Svätého Tomáša A princovho ostrova",
				"common": "Svätý Tomáš a Princov ostrov"
			},
			"fin": {
				"official": "São Tomé ja Príncipen demokraattinen tasavalta",
				"common": "São Téme ja Príncipe"
			},
			"zho": {
				"official": "圣多美和普林西比民主共和国",
				"common": "圣多美和普林西比"
			}
		},
		"latlng": [
			1,
			7
		],
		"demonym": "Sao Tomean",
		"landlocked": false,
		"borders": [],
		"area": 964
	},
	{
		"name": {
			"common": "Suriname",
			"official": "Republic of Suriname",
			"native": {
				"nld": {
					"official": "Republiek Suriname",
					"common": "Suriname"
				}
			}
		},
		"tld": [
			".sr"
		],
		"cca2": "SR",
		"ccn3": "740",
		"cca3": "SUR",
		"cioc": "SUR",
		"currency": [
			"SRD"
		],
		"callingCode": [
			"597"
		],
		"capital": "Paramaribo",
		"altSpellings": [
			"SR",
			"Sarnam",
			"Sranangron",
			"Republic of Suriname",
			"Republiek Suriname"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"nld": "Dutch"
		},
		"translations": {
			"deu": {
				"official": "Republik Suriname",
				"common": "Suriname"
			},
			"fra": {
				"official": "République du Suriname",
				"common": "Surinam"
			},
			"hrv": {
				"official": "Republika Surinam",
				"common": "Surinam"
			},
			"ita": {
				"official": "Repubblica del Suriname",
				"common": "Suriname"
			},
			"jpn": {
				"official": "スリナム共和国",
				"common": "スリナム"
			},
			"nld": {
				"official": "Republiek Suriname",
				"common": "Suriname"
			},
			"por": {
				"official": "República do Suriname",
				"common": "Suriname"
			},
			"rus": {
				"official": "Республика Суринам",
				"common": "Суринам"
			},
			"spa": {
				"official": "República de Suriname",
				"common": "Surinam"
			},
			"svk": {
				"official": "Surinamská republika",
				"common": "Surinam"
			},
			"fin": {
				"official": "Surinamen tasavalta",
				"common": "Suriname"
			},
			"zho": {
				"official": "苏里南共和国",
				"common": "苏里南"
			}
		},
		"latlng": [
			4,
			-56
		],
		"demonym": "Surinamer",
		"landlocked": false,
		"borders": [
			"BRA",
			"GUF",
			"GUY"
		],
		"area": 163820
	},
	{
		"name": {
			"common": "Slovakia",
			"official": "Slovak Republic",
			"native": {
				"slk": {
					"official": "Slovenská republika",
					"common": "Slovensko"
				}
			}
		},
		"tld": [
			".sk"
		],
		"cca2": "SK",
		"ccn3": "703",
		"cca3": "SVK",
		"cioc": "SVK",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"421"
		],
		"capital": "Bratislava",
		"altSpellings": [
			"SK",
			"Slovak Republic",
			"Slovenská republika"
		],
		"region": "Europe",
		"subregion": "Central Europe",
		"languages": {
			"slk": "Slovak"
		},
		"translations": {
			"deu": {
				"official": "Slowakische Republik",
				"common": "Slowakei"
			},
			"fra": {
				"official": "République slovaque",
				"common": "Slovaquie"
			},
			"hrv": {
				"official": "slovačka",
				"common": "Slovačka"
			},
			"ita": {
				"official": "Repubblica slovacca",
				"common": "Slovacchia"
			},
			"jpn": {
				"official": "スロバキア共和国",
				"common": "スロバキア"
			},
			"nld": {
				"official": "Slowaakse Republiek",
				"common": "Slowakije"
			},
			"por": {
				"official": "República Eslovaca",
				"common": "Eslováquia"
			},
			"rus": {
				"official": "Словацкая Республика",
				"common": "Словакия"
			},
			"spa": {
				"official": "República Eslovaca",
				"common": "República Eslovaca"
			},
			"svk": {
				"official": "Slovenská republika",
				"common": "Slovensko"
			},
			"fin": {
				"official": "Slovakian tasavalta",
				"common": "Slovakia"
			},
			"zho": {
				"official": "斯洛伐克共和国",
				"common": "斯洛伐克"
			}
		},
		"latlng": [
			48.66666666,
			19.5
		],
		"demonym": "Slovak",
		"landlocked": true,
		"borders": [
			"AUT",
			"CZE",
			"HUN",
			"POL",
			"UKR"
		],
		"area": 49037
	},
	{
		"name": {
			"common": "Slovenia",
			"official": "Republic of Slovenia",
			"native": {
				"slv": {
					"official": "Republika Slovenija",
					"common": "Slovenija"
				}
			}
		},
		"tld": [
			".si"
		],
		"cca2": "SI",
		"ccn3": "705",
		"cca3": "SVN",
		"cioc": "SLO",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"386"
		],
		"capital": "Ljubljana",
		"altSpellings": [
			"SI",
			"Republic of Slovenia",
			"Republika Slovenija"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"slv": "Slovene"
		},
		"translations": {
			"deu": {
				"official": "Republik Slowenien",
				"common": "Slowenien"
			},
			"fra": {
				"official": "République de Slovénie",
				"common": "Slovénie"
			},
			"hrv": {
				"official": "Republika Slovenija",
				"common": "Slovenija"
			},
			"ita": {
				"official": "Repubblica di Slovenia",
				"common": "Slovenia"
			},
			"jpn": {
				"official": "スロベニア共和国",
				"common": "スロベニア"
			},
			"nld": {
				"official": "Republiek Slovenië",
				"common": "Slovenië"
			},
			"por": {
				"official": "República da Eslovénia",
				"common": "Eslovénia"
			},
			"rus": {
				"official": "Республика Словения",
				"common": "Словения"
			},
			"spa": {
				"official": "República de Eslovenia",
				"common": "Eslovenia"
			},
			"svk": {
				"official": "Slovinská republika",
				"common": "Slovinsko"
			},
			"fin": {
				"official": "Slovenian tasavalta",
				"common": "Slovenia"
			},
			"zho": {
				"official": "斯洛文尼亚共和国",
				"common": "斯洛文尼亚"
			}
		},
		"latlng": [
			46.11666666,
			14.81666666
		],
		"demonym": "Slovene",
		"landlocked": false,
		"borders": [
			"AUT",
			"HRV",
			"ITA",
			"HUN"
		],
		"area": 20273
	},
	{
		"name": {
			"common": "Sweden",
			"official": "Kingdom of Sweden",
			"native": {
				"swe": {
					"official": "Konungariket Sverige",
					"common": "Sverige"
				}
			}
		},
		"tld": [
			".se"
		],
		"cca2": "SE",
		"ccn3": "752",
		"cca3": "SWE",
		"cioc": "SWE",
		"currency": [
			"SEK"
		],
		"callingCode": [
			"46"
		],
		"capital": "Stockholm",
		"altSpellings": [
			"SE",
			"Kingdom of Sweden",
			"Konungariket Sverige"
		],
		"region": "Europe",
		"subregion": "Northern Europe",
		"languages": {
			"swe": "Swedish"
		},
		"translations": {
			"deu": {
				"official": "Königreich Schweden",
				"common": "Schweden"
			},
			"fra": {
				"official": "Royaume de Suède",
				"common": "Suède"
			},
			"hrv": {
				"official": "Kraljevina Švedska",
				"common": "Švedska"
			},
			"ita": {
				"official": "Regno di Svezia",
				"common": "Svezia"
			},
			"jpn": {
				"official": "スウェーデン王国",
				"common": "スウェーデン"
			},
			"nld": {
				"official": "Koninkrijk Zweden",
				"common": "Zweden"
			},
			"por": {
				"official": "Reino da Suécia",
				"common": "Suécia"
			},
			"rus": {
				"official": "Королевство Швеция",
				"common": "Швеция"
			},
			"spa": {
				"official": "Reino de Suecia",
				"common": "Suecia"
			},
			"svk": {
				"official": "švédske kráľovstvo",
				"common": "šveédsko"
			},
			"fin": {
				"official": "Ruotsin kuningaskunta",
				"common": "Ruotsi"
			},
			"zho": {
				"official": "瑞典王国",
				"common": "瑞典"
			}
		},
		"latlng": [
			62,
			15
		],
		"demonym": "Swedish",
		"landlocked": false,
		"borders": [
			"FIN",
			"NOR"
		],
		"area": 450295
	},
	{
		"name": {
			"common": "Swaziland",
			"official": "Kingdom of Swaziland",
			"native": {
				"eng": {
					"official": "Kingdom of Swaziland",
					"common": "Swaziland"
				},
				"ssw": {
					"official": "Kingdom of Swaziland",
					"common": "Swaziland"
				}
			}
		},
		"tld": [
			".sz"
		],
		"cca2": "SZ",
		"ccn3": "748",
		"cca3": "SWZ",
		"cioc": "SWZ",
		"currency": [
			"SZL"
		],
		"callingCode": [
			"268"
		],
		"capital": "Lobamba",
		"altSpellings": [
			"SZ",
			"weSwatini",
			"Swatini",
			"Ngwane",
			"Kingdom of Swaziland",
			"Umbuso waseSwatini"
		],
		"region": "Africa",
		"subregion": "Southern Africa",
		"languages": {
			"eng": "English",
			"ssw": "Swazi"
		},
		"translations": {
			"deu": {
				"official": "Königreich Swasiland",
				"common": "Swasiland"
			},
			"fra": {
				"official": "Royaume du Swaziland",
				"common": "Swaziland"
			},
			"hrv": {
				"official": "Kraljevina Svazi",
				"common": "Svazi"
			},
			"ita": {
				"official": "Regno dello Swaziland",
				"common": "Swaziland"
			},
			"jpn": {
				"official": "スワジランド王国",
				"common": "スワジランド"
			},
			"nld": {
				"official": "Koninkrijk Swaziland",
				"common": "Swaziland"
			},
			"por": {
				"official": "Reino da Suazilândia",
				"common": "Suazilândia"
			},
			"rus": {
				"official": "Королевство Свазиленд",
				"common": "Свазиленд"
			},
			"spa": {
				"official": "Reino de Swazilandia",
				"common": "Suazilandia"
			},
			"svk": {
				"official": "Svazijské kráľovstvo",
				"common": "Svazijsko"
			},
			"fin": {
				"official": "Swazimaan kuningaskunta",
				"common": "Swazimaa"
			},
			"zho": {
				"official": "斯威士兰王国",
				"common": "斯威士兰"
			}
		},
		"latlng": [
			-26.5,
			31.5
		],
		"demonym": "Swazi",
		"landlocked": true,
		"borders": [
			"MOZ",
			"ZAF"
		],
		"area": 17364
	},
	{
		"name": {
			"common": "Sint Maarten",
			"official": "Sint Maarten",
			"native": {
				"eng": {
					"official": "Sint Maarten",
					"common": "Sint Maarten"
				},
				"fra": {
					"official": "Saint-Martin",
					"common": "Saint-Martin"
				},
				"nld": {
					"official": "Sint Maarten",
					"common": "Sint Maarten"
				}
			}
		},
		"tld": [
			".sx"
		],
		"cca2": "SX",
		"ccn3": "534",
		"cca3": "SXM",
		"cioc": "",
		"currency": [
			"ANG"
		],
		"callingCode": [
			"1721"
		],
		"capital": "Philipsburg",
		"altSpellings": [
			"SX",
			"Sint Maarten (Dutch part)"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English",
			"fra": "French",
			"nld": "Dutch"
		},
		"translations": {
			"deu": {
				"official": "Sint Maarten",
				"common": "Sint Maarten"
			},
			"fra": {
				"official": "Sint Maarten",
				"common": "Saint-Martin"
			},
			"ita": {
				"official": "Sint Maarten",
				"common": "Sint Maarten"
			},
			"jpn": {
				"official": "シントマールテン島",
				"common": "シント・マールテン"
			},
			"nld": {
				"official": "Sint Maarten",
				"common": "Sint Maarten"
			},
			"por": {
				"official": "Sint Maarten",
				"common": "São Martinho"
			},
			"rus": {
				"official": "Синт-Маартен",
				"common": "Синт-Мартен"
			},
			"spa": {
				"official": "Sint Maarten",
				"common": "Sint Maarten"
			},
			"svk": {
				"official": "Svätý Martin",
				"common": "Svätý Martin"
			},
			"fin": {
				"official": "Sint Maarten",
				"common": "Sint Maarten"
			},
			"zho": {
				"official": "圣马丁岛",
				"common": "圣马丁岛"
			}
		},
		"latlng": [
			18.033333,
			-63.05
		],
		"demonym": "St. Maartener",
		"landlocked": false,
		"borders": [
			"MAF"
		],
		"area": 34
	},
	{
		"name": {
			"common": "Seychelles",
			"official": "Republic of Seychelles",
			"native": {
				"crs": {
					"official": "Repiblik Sesel",
					"common": "Sesel"
				},
				"eng": {
					"official": "Republic of Seychelles",
					"common": "Seychelles"
				},
				"fra": {
					"official": "République des Seychelles",
					"common": "Seychelles"
				}
			}
		},
		"tld": [
			".sc"
		],
		"cca2": "SC",
		"ccn3": "690",
		"cca3": "SYC",
		"cioc": "SEY",
		"currency": [
			"SCR"
		],
		"callingCode": [
			"248"
		],
		"capital": "Victoria",
		"altSpellings": [
			"SC",
			"Republic of Seychelles",
			"Repiblik Sesel",
			"République des Seychelles"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"crs": "Seychellois Creole",
			"eng": "English",
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Republik der Seychellen",
				"common": "Seychellen"
			},
			"fra": {
				"official": "République des Seychelles",
				"common": "Seychelles"
			},
			"hrv": {
				"official": "Republika Sejšeli",
				"common": "Sejšeli"
			},
			"ita": {
				"official": "Repubblica delle Seychelles",
				"common": "Seychelles"
			},
			"jpn": {
				"official": "セイシェル共和国",
				"common": "セーシェル"
			},
			"nld": {
				"official": "Republiek der Seychellen",
				"common": "Seychellen"
			},
			"por": {
				"official": "República das Seychelles",
				"common": "Seicheles"
			},
			"rus": {
				"official": "Республика Сейшельские Острова",
				"common": "Сейшельские Острова"
			},
			"spa": {
				"official": "República de las Seychelles",
				"common": "Seychelles"
			},
			"svk": {
				"official": "Seychelská republika",
				"common": "Seychely"
			},
			"fin": {
				"official": "Seychellien tasavalta",
				"common": "Seychellit"
			},
			"zho": {
				"official": "塞舌尔共和国",
				"common": "塞舌尔"
			}
		},
		"latlng": [
			-4.58333333,
			55.66666666
		],
		"demonym": "Seychellois",
		"landlocked": false,
		"borders": [],
		"area": 452
	},
	{
		"name": {
			"common": "Syria",
			"official": "Syrian Arab Republic",
			"native": {
				"ara": {
					"official": "الجمهورية العربية السورية",
					"common": "سوريا"
				}
			}
		},
		"tld": [
			".sy",
			"سوريا."
		],
		"cca2": "SY",
		"ccn3": "760",
		"cca3": "SYR",
		"cioc": "SYR",
		"currency": [
			"SYP"
		],
		"callingCode": [
			"963"
		],
		"capital": "Damascus",
		"altSpellings": [
			"SY",
			"Syrian Arab Republic",
			"Al-Jumhūrīyah Al-ʻArabīyah As-Sūrīyah"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Arabische Republik Syrien",
				"common": "Syrien"
			},
			"fra": {
				"official": "République arabe syrienne",
				"common": "Syrie"
			},
			"hrv": {
				"official": "Sirijska Arapska Republika",
				"common": "Sirija"
			},
			"ita": {
				"official": "Repubblica araba siriana",
				"common": "Siria"
			},
			"jpn": {
				"official": "シリアアラブ共和国",
				"common": "シリア・アラブ共和国"
			},
			"nld": {
				"official": "Syrische Arabische Republiek",
				"common": "Syrië"
			},
			"por": {
				"official": "República Árabe Síria",
				"common": "Síria"
			},
			"rus": {
				"official": "Сирийская Арабская Республика",
				"common": "Сирия"
			},
			"spa": {
				"official": "República Árabe Siria",
				"common": "Siria"
			},
			"svk": {
				"official": "Sýrska arabská republika",
				"common": "Sýria"
			},
			"fin": {
				"official": "Syyrian arabitasavalta",
				"common": "Syyria"
			},
			"zho": {
				"official": "叙利亚阿拉伯共和国",
				"common": "叙利亚"
			}
		},
		"latlng": [
			35,
			38
		],
		"demonym": "Syrian",
		"landlocked": false,
		"borders": [
			"IRQ",
			"ISR",
			"JOR",
			"LBN",
			"TUR"
		],
		"area": 185180
	},
	{
		"name": {
			"common": "Turks and Caicos Islands",
			"official": "Turks and Caicos Islands",
			"native": {
				"eng": {
					"official": "Turks and Caicos Islands",
					"common": "Turks and Caicos Islands"
				}
			}
		},
		"tld": [
			".tc"
		],
		"cca2": "TC",
		"ccn3": "796",
		"cca3": "TCA",
		"cioc": "",
		"currency": [
			"USD"
		],
		"callingCode": [
			"1649"
		],
		"capital": "Cockburn Town",
		"altSpellings": [
			"TC"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Turks und Caicos Inseln",
				"common": "Turks-und Caicosinseln"
			},
			"fra": {
				"official": "Îles Turques et Caïques",
				"common": "Îles Turques-et-Caïques"
			},
			"hrv": {
				"official": "Otoci Turks i Caicos",
				"common": "Otoci Turks i Caicos"
			},
			"ita": {
				"official": "Turks e Caicos",
				"common": "Isole Turks e Caicos"
			},
			"jpn": {
				"official": "タークス·カイコス諸島",
				"common": "タークス・カイコス諸島"
			},
			"nld": {
				"official": "Turks-en Caicoseilanden",
				"common": "Turks-en Caicoseilanden"
			},
			"por": {
				"official": "Ilhas Turks e Caicos",
				"common": "Ilhas Turks e Caicos"
			},
			"rus": {
				"official": "Теркс и Кайкос острова",
				"common": "Теркс и Кайкос"
			},
			"spa": {
				"official": "Islas Turcas y Caicos",
				"common": "Islas Turks y Caicos"
			},
			"svk": {
				"official": "Ostrovy Turks a Caicos",
				"common": "Turks a Caicos"
			},
			"fin": {
				"official": "Turks-ja Caicossaaret",
				"common": "Turks-ja Caicossaaret"
			},
			"zho": {
				"official": "特克斯和凯科斯群岛",
				"common": "特克斯和凯科斯群岛"
			}
		},
		"latlng": [
			21.75,
			-71.58333333
		],
		"demonym": "Turks and Caicos Islander",
		"landlocked": false,
		"borders": [],
		"area": 948
	},
	{
		"name": {
			"common": "Chad",
			"official": "Republic of Chad",
			"native": {
				"ara": {
					"official": "جمهورية تشاد",
					"common": "تشاد‎"
				},
				"fra": {
					"official": "République du Tchad",
					"common": "Tchad"
				}
			}
		},
		"tld": [
			".td"
		],
		"cca2": "TD",
		"ccn3": "148",
		"cca3": "TCD",
		"cioc": "CHA",
		"currency": [
			"XAF"
		],
		"callingCode": [
			"235"
		],
		"capital": "N'Djamena",
		"altSpellings": [
			"TD",
			"Tchad",
			"Republic of Chad",
			"République du Tchad"
		],
		"region": "Africa",
		"subregion": "Middle Africa",
		"languages": {
			"ara": "Arabic",
			"fra": "French"
		},
		"translations": {
			"cym": {
				"official": "Republic of Chad",
				"common": "Tsiad"
			},
			"deu": {
				"official": "Republik Tschad",
				"common": "Tschad"
			},
			"fra": {
				"official": "République du Tchad",
				"common": "Tchad"
			},
			"hrv": {
				"official": "Čadu",
				"common": "Čad"
			},
			"ita": {
				"official": "Repubblica del Ciad",
				"common": "Ciad"
			},
			"jpn": {
				"official": "チャド共和国",
				"common": "チャド"
			},
			"nld": {
				"official": "Republiek Tsjaad",
				"common": "Tsjaad"
			},
			"por": {
				"official": "República do Chade",
				"common": "Chade"
			},
			"rus": {
				"official": "Республика Чад",
				"common": "Чад"
			},
			"spa": {
				"official": "República de Chad",
				"common": "Chad"
			},
			"svk": {
				"official": "Čadská republika",
				"common": "Čad"
			},
			"fin": {
				"official": "Tšadin tasavalta",
				"common": "Tšad"
			},
			"zho": {
				"official": "乍得共和国",
				"common": "乍得"
			}
		},
		"latlng": [
			15,
			19
		],
		"demonym": "Chadian",
		"landlocked": true,
		"borders": [
			"CMR",
			"CAF",
			"LBY",
			"NER",
			"NGA",
			"SSD"
		],
		"area": 1284000
	},
	{
		"name": {
			"common": "Togo",
			"official": "Togolese Republic",
			"native": {
				"fra": {
					"official": "République togolaise",
					"common": "Togo"
				}
			}
		},
		"tld": [
			".tg"
		],
		"cca2": "TG",
		"ccn3": "768",
		"cca3": "TGO",
		"cioc": "TOG",
		"currency": [
			"XOF"
		],
		"callingCode": [
			"228"
		],
		"capital": "Lomé",
		"altSpellings": [
			"TG",
			"Togolese",
			"Togolese Republic",
			"République Togolaise"
		],
		"region": "Africa",
		"subregion": "Western Africa",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Republik Togo",
				"common": "Togo"
			},
			"fra": {
				"official": "République togolaise",
				"common": "Togo"
			},
			"hrv": {
				"official": "Togolese Republika",
				"common": "Togo"
			},
			"ita": {
				"official": "Repubblica del Togo",
				"common": "Togo"
			},
			"jpn": {
				"official": "トーゴ共和国",
				"common": "トーゴ"
			},
			"nld": {
				"official": "Republiek Togo",
				"common": "Togo"
			},
			"por": {
				"official": "República do Togo",
				"common": "Togo"
			},
			"rus": {
				"official": "Того Республика",
				"common": "Того"
			},
			"spa": {
				"official": "República de Togo",
				"common": "Togo"
			},
			"svk": {
				"official": "Togská republika",
				"common": "Togo"
			},
			"fin": {
				"official": "Togon tasavalta",
				"common": "Togo"
			},
			"zho": {
				"official": "多哥共和国",
				"common": "多哥"
			}
		},
		"latlng": [
			8,
			1.16666666
		],
		"demonym": "Togolese",
		"landlocked": false,
		"borders": [
			"BEN",
			"BFA",
			"GHA"
		],
		"area": 56785
	},
	{
		"name": {
			"common": "Thailand",
			"official": "Kingdom of Thailand",
			"native": {
				"tha": {
					"official": "ราชอาณาจักรไทย",
					"common": "ประเทศไทย"
				}
			}
		},
		"tld": [
			".th",
			".ไทย"
		],
		"cca2": "TH",
		"ccn3": "764",
		"cca3": "THA",
		"cioc": "THA",
		"currency": [
			"THB"
		],
		"callingCode": [
			"66"
		],
		"capital": "Bangkok",
		"altSpellings": [
			"TH",
			"Prathet",
			"Thai",
			"Kingdom of Thailand",
			"ราชอาณาจักรไทย",
			"Ratcha Anachak Thai"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"tha": "Thai"
		},
		"translations": {
			"deu": {
				"official": "Königreich Thailand",
				"common": "Thailand"
			},
			"fra": {
				"official": "Royaume de Thaïlande",
				"common": "Thaïlande"
			},
			"hrv": {
				"official": "Kraljevina Tajland",
				"common": "Tajland"
			},
			"ita": {
				"official": "Regno di Thailandia",
				"common": "Tailandia"
			},
			"jpn": {
				"official": "タイ王国",
				"common": "タイ"
			},
			"nld": {
				"official": "Koninkrijk Thailand",
				"common": "Thailand"
			},
			"por": {
				"official": "Reino da Tailândia",
				"common": "Tailândia"
			},
			"rus": {
				"official": "Королевство Таиланд",
				"common": "Таиланд"
			},
			"spa": {
				"official": "Reino de Tailandia",
				"common": "Tailandia"
			},
			"svk": {
				"official": "Thajské kráľovstvo",
				"common": "Thajsko"
			},
			"fin": {
				"official": "Thaimaan kuningaskunta",
				"common": "Thaimaa"
			},
			"zho": {
				"official": "泰王国",
				"common": "泰国"
			}
		},
		"latlng": [
			15,
			100
		],
		"demonym": "Thai",
		"landlocked": false,
		"borders": [
			"MMR",
			"KHM",
			"LAO",
			"MYS"
		],
		"area": 513120
	},
	{
		"name": {
			"common": "Tajikistan",
			"official": "Republic of Tajikistan",
			"native": {
				"rus": {
					"official": "Республика Таджикистан",
					"common": "Таджикистан"
				},
				"tgk": {
					"official": "Ҷумҳурии Тоҷикистон",
					"common": "Тоҷикистон"
				}
			}
		},
		"tld": [
			".tj"
		],
		"cca2": "TJ",
		"ccn3": "762",
		"cca3": "TJK",
		"cioc": "TJK",
		"currency": [
			"TJS"
		],
		"callingCode": [
			"992"
		],
		"capital": "Dushanbe",
		"altSpellings": [
			"TJ",
			"Toçikiston",
			"Republic of Tajikistan",
			"Ҷумҳурии Тоҷикистон",
			"Çumhuriyi Toçikiston"
		],
		"region": "Asia",
		"subregion": "Central Asia",
		"languages": {
			"rus": "Russian",
			"tgk": "Tajik"
		},
		"translations": {
			"deu": {
				"official": "Republik Tadschikistan",
				"common": "Tadschikistan"
			},
			"fra": {
				"official": "République du Tadjikistan",
				"common": "Tadjikistan"
			},
			"hrv": {
				"official": "Republika Tadžikistan",
				"common": "Tađikistan"
			},
			"ita": {
				"official": "Repubblica del Tajikistan",
				"common": "Tagikistan"
			},
			"jpn": {
				"official": "タジキスタン共和国",
				"common": "タジキスタン"
			},
			"nld": {
				"official": "Tadzjikistan",
				"common": "Tadzjikistan"
			},
			"por": {
				"official": "República do Tajiquistão",
				"common": "Tajiquistão"
			},
			"rus": {
				"official": "Республика Таджикистан",
				"common": "Таджикистан"
			},
			"spa": {
				"official": "República de Tayikistán",
				"common": "Tayikistán"
			},
			"svk": {
				"official": "Taǆická republika",
				"common": "Taǆikistan"
			},
			"fin": {
				"official": "Tadžikistanin tasavalta",
				"common": "Tadžikistan"
			},
			"zho": {
				"official": "塔吉克斯坦共和国",
				"common": "塔吉克斯坦"
			}
		},
		"latlng": [
			39,
			71
		],
		"demonym": "Tadzhik",
		"landlocked": true,
		"borders": [
			"AFG",
			"CHN",
			"KGZ",
			"UZB"
		],
		"area": 143100
	},
	{
		"name": {
			"common": "Tokelau",
			"official": "Tokelau",
			"native": {
				"eng": {
					"official": "Tokelau",
					"common": "Tokelau"
				},
				"smo": {
					"official": "Tokelau",
					"common": "Tokelau"
				},
				"tkl": {
					"official": "Tokelau",
					"common": "Tokelau"
				}
			}
		},
		"tld": [
			".tk"
		],
		"cca2": "TK",
		"ccn3": "772",
		"cca3": "TKL",
		"cioc": "",
		"currency": [
			"NZD"
		],
		"callingCode": [
			"690"
		],
		"capital": "Fakaofo",
		"altSpellings": [
			"TK"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"eng": "English",
			"smo": "Samoan",
			"tkl": "Tokelauan"
		},
		"translations": {
			"deu": {
				"official": "Tokelau",
				"common": "Tokelau"
			},
			"fra": {
				"official": "Îles Tokelau",
				"common": "Tokelau"
			},
			"hrv": {
				"official": "Tokelau",
				"common": "Tokelau"
			},
			"ita": {
				"official": "Tokelau",
				"common": "Isole Tokelau"
			},
			"jpn": {
				"official": "トケラウ諸島",
				"common": "トケラウ"
			},
			"nld": {
				"official": "Tokelau",
				"common": "Tokelau"
			},
			"por": {
				"official": "Tokelau",
				"common": "Tokelau"
			},
			"rus": {
				"official": "Токелау",
				"common": "Токелау"
			},
			"spa": {
				"official": "Tokelau",
				"common": "Islas Tokelau"
			},
			"svk": {
				"official": "Tokelauské ostrovy",
				"common": "Tokelau"
			},
			"fin": {
				"official": "Tokelau",
				"common": "Tokelau"
			},
			"zho": {
				"official": "托克劳",
				"common": "托克劳"
			}
		},
		"latlng": [
			-9,
			-172
		],
		"demonym": "Tokelauan",
		"landlocked": false,
		"borders": [],
		"area": 12
	},
	{
		"name": {
			"common": "Turkmenistan",
			"official": "Turkmenistan",
			"native": {
				"rus": {
					"official": "Туркменистан",
					"common": "Туркмения"
				},
				"tuk": {
					"official": "Türkmenistan",
					"common": "Türkmenistan"
				}
			}
		},
		"tld": [
			".tm"
		],
		"cca2": "TM",
		"ccn3": "795",
		"cca3": "TKM",
		"cioc": "TKM",
		"currency": [
			"TMT"
		],
		"callingCode": [
			"993"
		],
		"capital": "Ashgabat",
		"altSpellings": [
			"TM"
		],
		"region": "Asia",
		"subregion": "Central Asia",
		"languages": {
			"rus": "Russian",
			"tuk": "Turkmen"
		},
		"translations": {
			"deu": {
				"official": "Turkmenistan",
				"common": "Turkmenistan"
			},
			"fra": {
				"official": "Turkménistan",
				"common": "Turkménistan"
			},
			"hrv": {
				"official": "Turkmenistan",
				"common": "Turkmenistan"
			},
			"ita": {
				"official": "Turkmenistan",
				"common": "Turkmenistan"
			},
			"jpn": {
				"official": "トルクメニスタン",
				"common": "トルクメニスタン"
			},
			"nld": {
				"official": "Turkmenistan",
				"common": "Turkmenistan"
			},
			"por": {
				"official": "Turcomenistão",
				"common": "Turquemenistão"
			},
			"rus": {
				"official": "Туркменистан",
				"common": "Туркмения"
			},
			"spa": {
				"official": "Turkmenistán",
				"common": "Turkmenistán"
			},
			"svk": {
				"official": "Turkménsko",
				"common": "Turkménsko"
			},
			"fin": {
				"official": "Turkmenistan",
				"common": "Turkmenistan"
			},
			"zho": {
				"official": "土库曼斯坦",
				"common": "土库曼斯坦"
			}
		},
		"latlng": [
			40,
			60
		],
		"demonym": "Turkmen",
		"landlocked": true,
		"borders": [
			"AFG",
			"IRN",
			"KAZ",
			"UZB"
		],
		"area": 488100
	},
	{
		"name": {
			"common": "Timor-Leste",
			"official": "Democratic Republic of Timor-Leste",
			"native": {
				"por": {
					"official": "República Democrática de Timor-Leste",
					"common": "Timor-Leste"
				},
				"tet": {
					"official": "Repúblika Demokrátika Timór-Leste",
					"common": "Timór-Leste"
				}
			}
		},
		"tld": [
			".tl"
		],
		"cca2": "TL",
		"ccn3": "626",
		"cca3": "TLS",
		"cioc": "TLS",
		"currency": [
			"USD"
		],
		"callingCode": [
			"670"
		],
		"capital": "Dili",
		"altSpellings": [
			"TL",
			"East Timor",
			"Democratic Republic of Timor-Leste",
			"República Democrática de Timor-Leste",
			"Repúblika Demokrátika Timór-Leste",
			"Timór Lorosa'e",
			"Timor Lorosae"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"por": "Portuguese",
			"tet": "Tetum"
		},
		"translations": {
			"deu": {
				"official": "Demokratische Republik Timor-Leste",
				"common": "Timor-Leste"
			},
			"fra": {
				"official": "République démocratique du Timor oriental",
				"common": "Timor oriental"
			},
			"hrv": {
				"official": "Demokratska Republika Timor-Leste",
				"common": "Istočni Timor"
			},
			"ita": {
				"official": "Repubblica Democratica di Timor Est",
				"common": "Timor Est"
			},
			"jpn": {
				"official": "東ティモール民主共和国",
				"common": "東ティモール"
			},
			"nld": {
				"official": "Democratische Republiek Oost-Timor",
				"common": "Oost-Timor"
			},
			"por": {
				"official": "República Democrática de Timor-Leste",
				"common": "Timor-Leste"
			},
			"rus": {
				"official": "Демократическая Республика Тимор -Лешти",
				"common": "Восточный Тимор"
			},
			"spa": {
				"official": "República Democrática de Timor-Leste",
				"common": "Timor Oriental"
			},
			"svk": {
				"official": "Východotimorská demokratická republika",
				"common": "Východný Timor"
			},
			"fin": {
				"official": "Itä-Timorin demokraattinen tasavalta",
				"common": "Itä-Timor"
			},
			"zho": {
				"official": "东帝汶民主共和国",
				"common": "东帝汶"
			}
		},
		"latlng": [
			-8.83333333,
			125.91666666
		],
		"demonym": "East Timorese",
		"landlocked": false,
		"borders": [
			"IDN"
		],
		"area": 14874
	},
	{
		"name": {
			"common": "Tonga",
			"official": "Kingdom of Tonga",
			"native": {
				"eng": {
					"official": "Kingdom of Tonga",
					"common": "Tonga"
				},
				"ton": {
					"official": "Kingdom of Tonga",
					"common": "Tonga"
				}
			}
		},
		"tld": [
			".to"
		],
		"cca2": "TO",
		"ccn3": "776",
		"cca3": "TON",
		"cioc": "TGA",
		"currency": [
			"TOP"
		],
		"callingCode": [
			"676"
		],
		"capital": "Nuku'alofa",
		"altSpellings": [
			"TO"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"eng": "English",
			"ton": "Tongan"
		},
		"translations": {
			"deu": {
				"official": "Königreich Tonga",
				"common": "Tonga"
			},
			"fra": {
				"official": "Royaume des Tonga",
				"common": "Tonga"
			},
			"hrv": {
				"official": "Kraljevina Tonga",
				"common": "Tonga"
			},
			"ita": {
				"official": "Regno di Tonga",
				"common": "Tonga"
			},
			"jpn": {
				"official": "トンガ王国",
				"common": "トンガ"
			},
			"nld": {
				"official": "Koninkrijk Tonga",
				"common": "Tonga"
			},
			"por": {
				"official": "Reino de Tonga",
				"common": "Tonga"
			},
			"rus": {
				"official": "Королевство Тонга",
				"common": "Тонга"
			},
			"spa": {
				"official": "Reino de Tonga",
				"common": "Tonga"
			},
			"svk": {
				"official": "Tongské kráľovstvo",
				"common": "Tonga"
			},
			"fin": {
				"official": "Tongan kuningaskunta",
				"common": "Tonga"
			},
			"zho": {
				"official": "汤加王国",
				"common": "汤加"
			}
		},
		"latlng": [
			-20,
			-175
		],
		"demonym": "Tongan",
		"landlocked": false,
		"borders": [],
		"area": 747
	},
	{
		"name": {
			"common": "Trinidad and Tobago",
			"official": "Republic of Trinidad and Tobago",
			"native": {
				"eng": {
					"official": "Republic of Trinidad and Tobago",
					"common": "Trinidad and Tobago"
				}
			}
		},
		"tld": [
			".tt"
		],
		"cca2": "TT",
		"ccn3": "780",
		"cca3": "TTO",
		"cioc": "TTO",
		"currency": [
			"TTD"
		],
		"callingCode": [
			"1868"
		],
		"capital": "Port of Spain",
		"altSpellings": [
			"TT",
			"Republic of Trinidad and Tobago"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Republik Trinidad und Tobago",
				"common": "Trinidad und Tobago"
			},
			"fra": {
				"official": "République de Trinité-et-Tobago",
				"common": "Trinité-et-Tobago"
			},
			"hrv": {
				"official": "Republika Trinidad i Tobago",
				"common": "Trinidad i Tobago"
			},
			"ita": {
				"official": "Repubblica di Trinidad e Tobago",
				"common": "Trinidad e Tobago"
			},
			"jpn": {
				"official": "トリニダード·トバゴ共和国",
				"common": "トリニダード・トバゴ"
			},
			"nld": {
				"official": "Republiek Trinidad en Tobago",
				"common": "Trinidad en Tobago"
			},
			"por": {
				"official": "República de Trinidad e Tobago",
				"common": "Trinidade e Tobago"
			},
			"rus": {
				"official": "Республика Тринидад и Тобаго",
				"common": "Тринидад и Тобаго"
			},
			"spa": {
				"official": "República de Trinidad y Tobago",
				"common": "Trinidad y Tobago"
			},
			"svk": {
				"official": "Republika Trinidad a Tobaga",
				"common": "Trinidad a Tobago"
			},
			"fin": {
				"official": "Trinidadin ja Tobagon tasavalta",
				"common": "Trinidad ja Tobago"
			},
			"zho": {
				"official": "特立尼达和多巴哥共和国",
				"common": "特立尼达和多巴哥"
			}
		},
		"latlng": [
			11,
			-61
		],
		"demonym": "Trinidadian",
		"landlocked": false,
		"borders": [],
		"area": 5130
	},
	{
		"name": {
			"common": "Tunisia",
			"official": "Tunisian Republic",
			"native": {
				"ara": {
					"official": "الجمهورية التونسية",
					"common": "تونس"
				}
			}
		},
		"tld": [
			".tn"
		],
		"cca2": "TN",
		"ccn3": "788",
		"cca3": "TUN",
		"cioc": "TUN",
		"currency": [
			"TND"
		],
		"callingCode": [
			"216"
		],
		"capital": "Tunis",
		"altSpellings": [
			"TN",
			"Republic of Tunisia",
			"al-Jumhūriyyah at-Tūnisiyyah"
		],
		"region": "Africa",
		"subregion": "Northern Africa",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Tunesische Republik",
				"common": "Tunesien"
			},
			"fra": {
				"official": "République tunisienne",
				"common": "Tunisie"
			},
			"hrv": {
				"official": "Tuniski Republika",
				"common": "Tunis"
			},
			"ita": {
				"official": "Repubblica tunisina",
				"common": "Tunisia"
			},
			"jpn": {
				"official": "チュニジア共和国",
				"common": "チュニジア"
			},
			"nld": {
				"official": "Republiek Tunesië",
				"common": "Tunesië"
			},
			"por": {
				"official": "República da Tunísia",
				"common": "Tunísia"
			},
			"rus": {
				"official": "Тунисской Республики",
				"common": "Тунис"
			},
			"spa": {
				"official": "República de Túnez",
				"common": "Túnez"
			},
			"svk": {
				"official": "Tuniská republika",
				"common": "Tunisko"
			},
			"fin": {
				"official": "Tunisian tasavalta",
				"common": "Tunisia"
			},
			"zho": {
				"official": "突尼斯共和国",
				"common": "突尼斯"
			}
		},
		"latlng": [
			34,
			9
		],
		"demonym": "Tunisian",
		"landlocked": false,
		"borders": [
			"DZA",
			"LBY"
		],
		"area": 163610
	},
	{
		"name": {
			"common": "Turkey",
			"official": "Republic of Turkey",
			"native": {
				"tur": {
					"official": "Türkiye Cumhuriyeti",
					"common": "Türkiye"
				}
			}
		},
		"tld": [
			".tr"
		],
		"cca2": "TR",
		"ccn3": "792",
		"cca3": "TUR",
		"cioc": "TUR",
		"currency": [
			"TRY"
		],
		"callingCode": [
			"90"
		],
		"capital": "Ankara",
		"altSpellings": [
			"TR",
			"Turkiye",
			"Republic of Turkey",
			"Türkiye Cumhuriyeti"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"tur": "Turkish"
		},
		"translations": {
			"deu": {
				"official": "Republik Türkei",
				"common": "Türkei"
			},
			"fra": {
				"official": "République de Turquie",
				"common": "Turquie"
			},
			"hrv": {
				"official": "Republika Turska",
				"common": "Turska"
			},
			"ita": {
				"official": "Repubblica di Turchia",
				"common": "Turchia"
			},
			"jpn": {
				"official": "トルコ共和国",
				"common": "トルコ"
			},
			"nld": {
				"official": "Republiek Turkije",
				"common": "Turkije"
			},
			"por": {
				"official": "República da Turquia",
				"common": "Turquia"
			},
			"rus": {
				"official": "Республика Турции",
				"common": "Турция"
			},
			"spa": {
				"official": "República de Turquía",
				"common": "Turquía"
			},
			"svk": {
				"official": "Turecká republika",
				"common": "Turecko"
			},
			"fin": {
				"official": "Turkin tasavalta",
				"common": "Turkki"
			},
			"zho": {
				"official": "土耳其共和国",
				"common": "土耳其"
			}
		},
		"latlng": [
			39,
			35
		],
		"demonym": "Turkish",
		"landlocked": false,
		"borders": [
			"ARM",
			"AZE",
			"BGR",
			"GEO",
			"GRC",
			"IRN",
			"IRQ",
			"SYR"
		],
		"area": 783562
	},
	{
		"name": {
			"common": "Tuvalu",
			"official": "Tuvalu",
			"native": {
				"eng": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"tvl": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				}
			}
		},
		"tld": [
			".tv"
		],
		"cca2": "TV",
		"ccn3": "798",
		"cca3": "TUV",
		"cioc": "TUV",
		"currency": [
			"AUD"
		],
		"callingCode": [
			"688"
		],
		"capital": "Funafuti",
		"altSpellings": [
			"TV"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"eng": "English",
			"tvl": "Tuvaluan"
		},
		"translations": {
			"deu": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"fra": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"hrv": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"ita": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"jpn": {
				"official": "ツバル",
				"common": "ツバル"
			},
			"nld": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"por": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"rus": {
				"official": "Тувалу",
				"common": "Тувалу"
			},
			"spa": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"svk": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"fin": {
				"official": "Tuvalu",
				"common": "Tuvalu"
			},
			"zho": {
				"official": "图瓦卢",
				"common": "图瓦卢"
			}
		},
		"latlng": [
			-8,
			178
		],
		"demonym": "Tuvaluan",
		"landlocked": false,
		"borders": [],
		"area": 26
	},
	{
		"name": {
			"common": "Taiwan",
			"official": "Republic of China (Taiwan)",
			"native": {
				"zho": {
					"official": "中华民国",
					"common": "臺灣"
				}
			}
		},
		"tld": [
			".tw",
			".台湾",
			".台灣"
		],
		"cca2": "TW",
		"ccn3": "158",
		"cca3": "TWN",
		"cioc": "TPE",
		"currency": [
			"TWD"
		],
		"callingCode": [
			"886"
		],
		"capital": "Taipei",
		"altSpellings": [
			"TW",
			"Táiwān",
			"Republic of China",
			"中華民國",
			"Zhōnghuá Mínguó",
			"Chinese Taipei for IOC",
			"Taiwan, Province of China"
		],
		"region": "Asia",
		"subregion": "Eastern Asia",
		"languages": {
			"zho": "Chinese"
		},
		"translations": {
			"deu": {
				"official": "Republik China (Taiwan)",
				"common": "Taiwan"
			},
			"fra": {
				"official": "République de Chine (Taïwan)",
				"common": "Taïwan"
			},
			"hrv": {
				"official": "Republika Kina",
				"common": "Tajvan"
			},
			"ita": {
				"official": "Repubblica cinese (Taiwan)",
				"common": "Taiwan"
			},
			"jpn": {
				"official": "中華民国",
				"common": "台湾（台湾省/中華民国）"
			},
			"nld": {
				"official": "Republiek China (Taiwan)",
				"common": "Taiwan"
			},
			"por": {
				"official": "República da China",
				"common": "Ilha Formosa"
			},
			"rus": {
				"official": "Китайская Республика",
				"common": "Тайвань"
			},
			"spa": {
				"official": "República de China en Taiwán",
				"common": "Taiwán"
			},
			"svk": {
				"official": "Čínska republika",
				"common": "Taiwan"
			},
			"fin": {
				"official": "Kiinan tasavalta",
				"common": "Taiwan"
			}
		},
		"latlng": [
			23.5,
			121
		],
		"demonym": "Taiwanese",
		"landlocked": false,
		"borders": [],
		"area": 36193
	},
	{
		"name": {
			"common": "Tanzania",
			"official": "United Republic of Tanzania",
			"native": {
				"eng": {
					"official": "United Republic of Tanzania",
					"common": "Tanzania"
				},
				"swa": {
					"official": "Jamhuri ya Muungano wa Tanzania",
					"common": "Tanzania"
				}
			}
		},
		"tld": [
			".tz"
		],
		"cca2": "TZ",
		"ccn3": "834",
		"cca3": "TZA",
		"cioc": "TAN",
		"currency": [
			"TZS"
		],
		"callingCode": [
			"255"
		],
		"capital": "Dodoma",
		"altSpellings": [
			"TZ",
			"Tanzania, United Republic of",
			"United Republic of Tanzania",
			"Jamhuri ya Muungano wa Tanzania"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"eng": "English",
			"swa": "Swahili"
		},
		"translations": {
			"deu": {
				"official": "Vereinigte Republik Tansania",
				"common": "Tansania"
			},
			"fra": {
				"official": "République -Unie de Tanzanie",
				"common": "Tanzanie"
			},
			"hrv": {
				"official": "Ujedinjena Republika Tanzanija",
				"common": "Tanzanija"
			},
			"ita": {
				"official": "Repubblica Unita di Tanzania",
				"common": "Tanzania"
			},
			"jpn": {
				"official": "タンザニア連合共和国",
				"common": "タンザニア"
			},
			"nld": {
				"official": "Verenigde Republiek Tanzania",
				"common": "Tanzania"
			},
			"por": {
				"official": "República Unida da Tanzânia",
				"common": "Tanzânia"
			},
			"rus": {
				"official": "Объединенная Республика Танзания",
				"common": "Танзания"
			},
			"spa": {
				"official": "República Unida de Tanzania",
				"common": "Tanzania"
			},
			"svk": {
				"official": "Tanzánijská zjednotená republika",
				"common": "Tanzánia"
			},
			"fin": {
				"official": "Tansanian yhdistynyt tasavalta",
				"common": "Tansania"
			},
			"zho": {
				"official": "坦桑尼亚联合共和国",
				"common": "坦桑尼亚"
			}
		},
		"latlng": [
			-6,
			35
		],
		"demonym": "Tanzanian",
		"landlocked": false,
		"borders": [
			"BDI",
			"COD",
			"KEN",
			"MWI",
			"MOZ",
			"RWA",
			"UGA",
			"ZMB"
		],
		"area": 945087
	},
	{
		"name": {
			"common": "Uganda",
			"official": "Republic of Uganda",
			"native": {
				"eng": {
					"official": "Republic of Uganda",
					"common": "Uganda"
				},
				"swa": {
					"official": "Republic of Uganda",
					"common": "Uganda"
				}
			}
		},
		"tld": [
			".ug"
		],
		"cca2": "UG",
		"ccn3": "800",
		"cca3": "UGA",
		"cioc": "UGA",
		"currency": [
			"UGX"
		],
		"callingCode": [
			"256"
		],
		"capital": "Kampala",
		"altSpellings": [
			"UG",
			"Republic of Uganda",
			"Jamhuri ya Uganda"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"eng": "English",
			"swa": "Swahili"
		},
		"translations": {
			"deu": {
				"official": "Republik Uganda",
				"common": "Uganda"
			},
			"fra": {
				"official": "République de l'Ouganda",
				"common": "Ouganda"
			},
			"hrv": {
				"official": "Republika Uganda",
				"common": "Uganda"
			},
			"ita": {
				"official": "Repubblica di Uganda",
				"common": "Uganda"
			},
			"jpn": {
				"official": "ウガンダ共和国",
				"common": "ウガンダ"
			},
			"nld": {
				"official": "Republiek Uganda",
				"common": "Oeganda"
			},
			"por": {
				"official": "República do Uganda",
				"common": "Uganda"
			},
			"rus": {
				"official": "Республика Уганда",
				"common": "Уганда"
			},
			"spa": {
				"official": "República de Uganda",
				"common": "Uganda"
			},
			"svk": {
				"official": "Ugandská republika",
				"common": "Uganda"
			},
			"fin": {
				"official": "Ugandan tasavalta",
				"common": "Uganda"
			},
			"zho": {
				"official": "乌干达共和国",
				"common": "乌干达"
			}
		},
		"latlng": [
			1,
			32
		],
		"demonym": "Ugandan",
		"landlocked": true,
		"borders": [
			"COD",
			"KEN",
			"RWA",
			"SSD",
			"TZA"
		],
		"area": 241550
	},
	{
		"name": {
			"common": "Ukraine",
			"official": "Ukraine",
			"native": {
				"rus": {
					"official": "Украина",
					"common": "Украина"
				},
				"ukr": {
					"official": "Україна",
					"common": "Україна"
				}
			}
		},
		"tld": [
			".ua",
			".укр"
		],
		"cca2": "UA",
		"ccn3": "804",
		"cca3": "UKR",
		"cioc": "UKR",
		"currency": [
			"UAH"
		],
		"callingCode": [
			"380"
		],
		"capital": "Kiev",
		"altSpellings": [
			"UA",
			"Ukrayina"
		],
		"region": "Europe",
		"subregion": "Eastern Europe",
		"languages": {
			"rus": "Russian",
			"ukr": "Ukrainian"
		},
		"translations": {
			"deu": {
				"official": "Ukraine",
				"common": "Ukraine"
			},
			"fra": {
				"official": "Ukraine",
				"common": "Ukraine"
			},
			"hrv": {
				"official": "Ukrajina",
				"common": "Ukrajina"
			},
			"ita": {
				"official": "Ucraina",
				"common": "Ucraina"
			},
			"jpn": {
				"official": "ウクライナ",
				"common": "ウクライナ"
			},
			"nld": {
				"official": "Oekraïne",
				"common": "Oekraïne"
			},
			"por": {
				"official": "Ucrânia",
				"common": "Ucrânia"
			},
			"rus": {
				"official": "Украина",
				"common": "Украина"
			},
			"spa": {
				"official": "Ucrania",
				"common": "Ucrania"
			},
			"svk": {
				"official": "Ukrajina",
				"common": "Ukrajina"
			},
			"fin": {
				"official": "Ukraina",
				"common": "Ukraina"
			},
			"zho": {
				"official": "乌克兰",
				"common": "乌克兰"
			}
		},
		"latlng": [
			49,
			32
		],
		"demonym": "Ukrainian",
		"landlocked": false,
		"borders": [
			"BLR",
			"HUN",
			"MDA",
			"POL",
			"ROU",
			"RUS",
			"SVK"
		],
		"area": 603500
	},
	{
		"name": {
			"common": "United States Minor Outlying Islands",
			"official": "United States Minor Outlying Islands",
			"native": {
				"eng": {
					"official": "United States Minor Outlying Islands",
					"common": "United States Minor Outlying Islands"
				}
			}
		},
		"tld": [
			".us"
		],
		"cca2": "UM",
		"ccn3": "581",
		"cca3": "UMI",
		"cioc": "",
		"currency": [
			"USD"
		],
		"callingCode": [],
		"capital": "",
		"altSpellings": [
			"UM"
		],
		"region": "Americas",
		"subregion": "Northern America",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "USA, kleinere ausgelagerte Inseln",
				"common": "Kleinere Inselbesitzungen der Vereinigten Staaten"
			},
			"fra": {
				"official": "Îles mineures éloignées des États-Unis",
				"common": "Îles mineures éloignées des États-Unis"
			},
			"hrv": {
				"official": "Mali udaljeni otoci SAD-a",
				"common": "Mali udaljeni otoci SAD-a"
			},
			"ita": {
				"official": "Stati Uniti Isole Minori",
				"common": "Isole minori esterne degli Stati Uniti d'America"
			},
			"jpn": {
				"official": "アメリカ合衆国外諸島",
				"common": "合衆国領有小離島"
			},
			"nld": {
				"official": "Kleine afgelegen eilanden van de Verenigde Staten",
				"common": "Kleine afgelegen eilanden van de Verenigde Staten"
			},
			"por": {
				"official": "Estados Unidos Ilhas Menores Distantes",
				"common": "Ilhas Menores Distantes dos Estados Unidos"
			},
			"rus": {
				"official": "Внешние малые острова США",
				"common": "Внешние малые острова США"
			},
			"spa": {
				"official": "Estados Unidos Islas menores alejadas de",
				"common": "Islas Ultramarinas Menores de Estados Unidos"
			},
			"svk": {
				"official": "Menšie odľahlé ostrovy Spjoených štátov",
				"common": "Menšie odľahlé ostrovy USA"
			},
			"fin": {
				"official": "Yhdysvaltain asumattomat saaret",
				"common": "Yhdysvaltain asumattomat saaret"
			},
			"zho": {
				"official": "美国本土外小岛屿",
				"common": "美国本土外小岛屿"
			}
		},
		"latlng": [],
		"demonym": "American",
		"landlocked": false,
		"borders": [],
		"area": 34.2
	},
	{
		"name": {
			"common": "Uruguay",
			"official": "Oriental Republic of Uruguay",
			"native": {
				"spa": {
					"official": "República Oriental del Uruguay",
					"common": "Uruguay"
				}
			}
		},
		"tld": [
			".uy"
		],
		"cca2": "UY",
		"ccn3": "858",
		"cca3": "URY",
		"cioc": "URU",
		"currency": [
			"UYI",
			"UYU"
		],
		"callingCode": [
			"598"
		],
		"capital": "Montevideo",
		"altSpellings": [
			"UY",
			"Oriental Republic of Uruguay",
			"República Oriental del Uruguay"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Republik Östlich des Uruguay",
				"common": "Uruguay"
			},
			"fra": {
				"official": "République orientale de l'Uruguay",
				"common": "Uruguay"
			},
			"hrv": {
				"official": "Orijentalna Republika Urugvaj",
				"common": "Urugvaj"
			},
			"ita": {
				"official": "Repubblica Orientale dell'Uruguay",
				"common": "Uruguay"
			},
			"jpn": {
				"official": "ウルグアイ東方共和国",
				"common": "ウルグアイ"
			},
			"nld": {
				"official": "Oosterse Republiek Uruguay",
				"common": "Uruguay"
			},
			"por": {
				"official": "República Oriental do Uruguai",
				"common": "Uruguai"
			},
			"rus": {
				"official": "Восточной Республики Уругвай",
				"common": "Уругвай"
			},
			"spa": {
				"official": "República Oriental del Uruguay",
				"common": "Uruguay"
			},
			"svk": {
				"official": "Uruguajská východná republika",
				"common": "Uruguaj"
			},
			"fin": {
				"official": "Uruguayn itäinen tasavalta",
				"common": "Uruguay"
			},
			"zho": {
				"official": "乌拉圭东岸共和国",
				"common": "乌拉圭"
			}
		},
		"latlng": [
			-33,
			-56
		],
		"demonym": "Uruguayan",
		"landlocked": false,
		"borders": [
			"ARG",
			"BRA"
		],
		"area": 181034
	},
	{
		"name": {
			"common": "United States",
			"official": "United States of America",
			"native": {
				"eng": {
					"official": "United States of America",
					"common": "United States"
				}
			}
		},
		"tld": [
			".us"
		],
		"cca2": "US",
		"ccn3": "840",
		"cca3": "USA",
		"cioc": "USA",
		"currency": [
			"USD",
			"USN",
			"USS"
		],
		"callingCode": [
			"1"
		],
		"capital": "Washington D.C.",
		"altSpellings": [
			"US",
			"USA",
			"United States of America"
		],
		"region": "Americas",
		"subregion": "Northern America",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Vereinigte Staaten von Amerika",
				"common": "Vereinigte Staaten von Amerika"
			},
			"fra": {
				"official": "Les états-unis d'Amérique",
				"common": "États-Unis"
			},
			"hrv": {
				"official": "Sjedinjene Države Amerike",
				"common": "Sjedinjene Američke Države"
			},
			"ita": {
				"official": "Stati Uniti d'America",
				"common": "Stati Uniti d'America"
			},
			"jpn": {
				"official": "アメリカ合衆国",
				"common": "アメリカ合衆国"
			},
			"nld": {
				"official": "Verenigde Staten van Amerika",
				"common": "Verenigde Staten"
			},
			"por": {
				"official": "Estados Unidos da América",
				"common": "Estados Unidos"
			},
			"rus": {
				"official": "Соединенные Штаты Америки",
				"common": "Соединённые Штаты Америки"
			},
			"spa": {
				"official": "Estados Unidos de América",
				"common": "Estados Unidos"
			},
			"svk": {
				"official": "Spojené štáty Americké",
				"common": "Spojené štáty"
			},
			"fin": {
				"official": "Amerikan yhdysvallat",
				"common": "Yhdysvallat"
			},
			"zho": {
				"official": "美利坚合众国",
				"common": "美国"
			}
		},
		"latlng": [
			38,
			-97
		],
		"demonym": "American",
		"landlocked": false,
		"borders": [
			"CAN",
			"MEX"
		],
		"area": 9372610
	},
	{
		"name": {
			"common": "Uzbekistan",
			"official": "Republic of Uzbekistan",
			"native": {
				"rus": {
					"official": "Республика Узбекистан",
					"common": "Узбекистан"
				},
				"uzb": {
					"official": "O'zbekiston Respublikasi",
					"common": "O‘zbekiston"
				}
			}
		},
		"tld": [
			".uz"
		],
		"cca2": "UZ",
		"ccn3": "860",
		"cca3": "UZB",
		"cioc": "UZB",
		"currency": [
			"UZS"
		],
		"callingCode": [
			"998"
		],
		"capital": "Tashkent",
		"altSpellings": [
			"UZ",
			"Republic of Uzbekistan",
			"O‘zbekiston Respublikasi",
			"Ўзбекистон Республикаси"
		],
		"region": "Asia",
		"subregion": "Central Asia",
		"languages": {
			"rus": "Russian",
			"uzb": "Uzbek"
		},
		"translations": {
			"deu": {
				"official": "Republik Usbekistan",
				"common": "Usbekistan"
			},
			"fra": {
				"official": "République d'Ouzbékistan",
				"common": "Ouzbékistan"
			},
			"hrv": {
				"official": "Republika Uzbekistan",
				"common": "Uzbekistan"
			},
			"ita": {
				"official": "Repubblica di Uzbekistan",
				"common": "Uzbekistan"
			},
			"jpn": {
				"official": "ウズベキスタン共和国",
				"common": "ウズベキスタン"
			},
			"nld": {
				"official": "Republiek Oezbekistan",
				"common": "Oezbekistan"
			},
			"por": {
				"official": "República do Usbequistão",
				"common": "Uzbequistão"
			},
			"rus": {
				"official": "Республика Узбекистан",
				"common": "Узбекистан"
			},
			"spa": {
				"official": "República de Uzbekistán",
				"common": "Uzbekistán"
			},
			"svk": {
				"official": "Uzbecká republika",
				"common": "Uzbekistan"
			},
			"fin": {
				"official": "Uzbekistanin tasavalta",
				"common": "Uzbekistan"
			},
			"zho": {
				"official": "乌兹别克斯坦共和国",
				"common": "乌兹别克斯坦"
			}
		},
		"latlng": [
			41,
			64
		],
		"demonym": "Uzbekistani",
		"landlocked": true,
		"borders": [
			"AFG",
			"KAZ",
			"KGZ",
			"TJK",
			"TKM"
		],
		"area": 447400
	},
	{
		"name": {
			"common": "Vatican City",
			"official": "Vatican City State",
			"native": {
				"ita": {
					"official": "Stato della Città del Vaticano",
					"common": "Vaticano"
				},
				"lat": {
					"official": "Status Civitatis Vaticanæ",
					"common": "Vaticanæ"
				}
			}
		},
		"tld": [
			".va"
		],
		"cca2": "VA",
		"ccn3": "336",
		"cca3": "VAT",
		"cioc": "",
		"currency": [
			"EUR"
		],
		"callingCode": [
			"3906698",
			"379"
		],
		"capital": "Vatican City",
		"altSpellings": [
			"VA",
			"Holy See (Vatican City State)",
			"Vatican City State",
			"Stato della Città del Vaticano"
		],
		"region": "Europe",
		"subregion": "Southern Europe",
		"languages": {
			"ita": "Italian",
			"lat": "Latin"
		},
		"translations": {
			"deu": {
				"official": "Staat Vatikanstadt",
				"common": "Vatikanstadt"
			},
			"fra": {
				"official": "Cité du Vatican",
				"common": "Cité du Vatican"
			},
			"hrv": {
				"official": "Vatikan",
				"common": "Vatikan"
			},
			"ita": {
				"official": "Città del Vaticano",
				"common": "Città del Vaticano"
			},
			"jpn": {
				"official": "バチカン市国の状態",
				"common": "バチカン市国"
			},
			"nld": {
				"official": "Vaticaanstad",
				"common": "Vaticaanstad"
			},
			"por": {
				"official": "Cidade do Vaticano",
				"common": "Cidade do Vaticano"
			},
			"rus": {
				"official": "Город-государство Ватикан",
				"common": "Ватикан"
			},
			"spa": {
				"official": "Ciudad del Vaticano",
				"common": "Ciudad del Vaticano"
			},
			"svk": {
				"official": "Svätá stolica (Vatikánsky mestský štát",
				"common": "Vatikán"
			},
			"fin": {
				"official": "Vatikaanin kaupunkivaltio",
				"common": "Vatikaani"
			},
			"zho": {
				"official": "梵蒂冈城国",
				"common": "梵蒂冈"
			}
		},
		"latlng": [
			41.9,
			12.45
		],
		"demonym": "Italian",
		"landlocked": true,
		"borders": [
			"ITA"
		],
		"area": 0.44
	},
	{
		"name": {
			"common": "Saint Vincent and the Grenadines",
			"official": "Saint Vincent and the Grenadines",
			"native": {
				"eng": {
					"official": "Saint Vincent and the Grenadines",
					"common": "Saint Vincent and the Grenadines"
				}
			}
		},
		"tld": [
			".vc"
		],
		"cca2": "VC",
		"ccn3": "670",
		"cca3": "VCT",
		"cioc": "VIN",
		"currency": [
			"XCD"
		],
		"callingCode": [
			"1784"
		],
		"capital": "Kingstown",
		"altSpellings": [
			"VC"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "St. Vincent und die Grenadinen",
				"common": "Saint Vincent und die Grenadinen"
			},
			"fra": {
				"official": "Saint-Vincent-et-les Grenadines",
				"common": "Saint-Vincent-et-les-Grenadines"
			},
			"hrv": {
				"official": "Sveti Vincent i Grenadini",
				"common": "Sveti Vincent i Grenadini"
			},
			"ita": {
				"official": "Saint Vincent e Grenadine",
				"common": "Saint Vincent e Grenadine"
			},
			"jpn": {
				"official": "セントビンセントおよびグレナディーン諸島",
				"common": "セントビンセントおよびグレナディーン諸島"
			},
			"nld": {
				"official": "Saint Vincent en de Grenadines",
				"common": "Saint Vincent en de Grenadines"
			},
			"por": {
				"official": "São Vicente e Granadinas",
				"common": "São Vincente e Granadinas"
			},
			"rus": {
				"official": "Сент-Винсент и Гренадины",
				"common": "Сент-Винсент и Гренадины"
			},
			"spa": {
				"official": "San Vicente y las Granadinas",
				"common": "San Vicente y Granadinas"
			},
			"svk": {
				"official": "Svätý Vincent a Grenadíny",
				"common": "Svätý Vincent a Grenadíny"
			},
			"fin": {
				"official": "Saint Vincent ja Grenadiinit",
				"common": "Saint Vincent ja Grenadiinit"
			},
			"zho": {
				"official": "圣文森特和格林纳丁斯",
				"common": "圣文森特和格林纳丁斯"
			}
		},
		"latlng": [
			13.25,
			-61.2
		],
		"demonym": "Saint Vincentian",
		"landlocked": false,
		"borders": [],
		"area": 389
	},
	{
		"name": {
			"common": "Venezuela",
			"official": "Bolivarian Republic of Venezuela",
			"native": {
				"spa": {
					"official": "República Bolivariana de Venezuela",
					"common": "Venezuela"
				}
			}
		},
		"tld": [
			".ve"
		],
		"cca2": "VE",
		"ccn3": "862",
		"cca3": "VEN",
		"cioc": "VEN",
		"currency": [
			"VEF"
		],
		"callingCode": [
			"58"
		],
		"capital": "Caracas",
		"altSpellings": [
			"VE",
			"Bolivarian Republic of Venezuela",
			"Venezuela, Bolivarian Republic of",
			"República Bolivariana de Venezuela"
		],
		"region": "Americas",
		"subregion": "South America",
		"languages": {
			"spa": "Spanish"
		},
		"translations": {
			"deu": {
				"official": "Bolivarische Republik Venezuela",
				"common": "Venezuela"
			},
			"fra": {
				"official": "République bolivarienne du Venezuela",
				"common": "Venezuela"
			},
			"hrv": {
				"official": "BOLIVARIJANSKA Republika Venezuela",
				"common": "Venezuela"
			},
			"ita": {
				"official": "Repubblica Bolivariana del Venezuela",
				"common": "Venezuela"
			},
			"jpn": {
				"official": "ベネズエラ·ボリバル共和国",
				"common": "ベネズエラ・ボリバル共和国"
			},
			"nld": {
				"official": "Bolivariaanse Republiek Venezuela",
				"common": "Venezuela"
			},
			"por": {
				"official": "República Bolivariana da Venezuela",
				"common": "Venezuela"
			},
			"rus": {
				"official": "Боливарианская Республика Венесуэла",
				"common": "Венесуэла"
			},
			"spa": {
				"official": "República Bolivariana de Venezuela",
				"common": "Venezuela"
			},
			"svk": {
				"official": "Venezuelská bolívarovská republika",
				"common": "Venezuela"
			},
			"fin": {
				"official": "Venezuelan bolivariaainen tasavalta",
				"common": "Venezuela"
			},
			"zho": {
				"official": "委内瑞拉玻利瓦尔共和国",
				"common": "委内瑞拉"
			}
		},
		"latlng": [
			8,
			-66
		],
		"demonym": "Venezuelan",
		"landlocked": false,
		"borders": [
			"BRA",
			"COL",
			"GUY"
		],
		"area": 916445
	},
	{
		"name": {
			"common": "British Virgin Islands",
			"official": "Virgin Islands",
			"native": {
				"eng": {
					"official": "Virgin Islands",
					"common": "British Virgin Islands"
				}
			}
		},
		"tld": [
			".vg"
		],
		"cca2": "VG",
		"ccn3": "092",
		"cca3": "VGB",
		"cioc": "IVB",
		"currency": [
			"USD"
		],
		"callingCode": [
			"1284"
		],
		"capital": "Road Town",
		"altSpellings": [
			"VG",
			"Virgin Islands, British"
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Jungferninseln",
				"common": "Britische Jungferninseln"
			},
			"fra": {
				"official": "îles Vierges",
				"common": "Îles Vierges britanniques"
			},
			"hrv": {
				"official": "Djevičanski Otoci",
				"common": "Britanski Djevičanski Otoci"
			},
			"ita": {
				"official": "Isole Vergini",
				"common": "Isole Vergini Britanniche"
			},
			"jpn": {
				"official": "バージン諸島",
				"common": "イギリス領ヴァージン諸島"
			},
			"nld": {
				"official": "Maagdeneilanden",
				"common": "Britse Maagdeneilanden"
			},
			"por": {
				"official": "Ilhas Virgens",
				"common": "Ilhas Virgens"
			},
			"rus": {
				"official": "Виргинские острова",
				"common": "Британские Виргинские острова"
			},
			"spa": {
				"official": "Islas Vírgenes",
				"common": "Islas Vírgenes del Reino Unido"
			},
			"svk": {
				"official": "Panenské ostrovy",
				"common": "Panenské ostrovy"
			},
			"fin": {
				"official": "Brittiläiset Neitsytsaaret",
				"common": "Neitsytsaaret"
			},
			"zho": {
				"official": "英属维尔京群岛",
				"common": "英属维尔京群岛"
			}
		},
		"latlng": [
			18.431383,
			-64.62305
		],
		"demonym": "Virgin Islander",
		"landlocked": false,
		"borders": [],
		"area": 151
	},
	{
		"name": {
			"common": "United States Virgin Islands",
			"official": "Virgin Islands of the United States",
			"native": {
				"eng": {
					"official": "Virgin Islands of the United States",
					"common": "United States Virgin Islands"
				}
			}
		},
		"tld": [
			".vi"
		],
		"cca2": "VI",
		"ccn3": "850",
		"cca3": "VIR",
		"cioc": "ISV",
		"currency": [
			"USD"
		],
		"callingCode": [
			"1340"
		],
		"capital": "Charlotte Amalie",
		"altSpellings": [
			"VI",
			"Virgin Islands, U.S."
		],
		"region": "Americas",
		"subregion": "Caribbean",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Jungferninseln der Vereinigten Staaten",
				"common": "Amerikanische Jungferninseln"
			},
			"fra": {
				"official": "Îles Vierges des États-Unis",
				"common": "Îles Vierges des États-Unis"
			},
			"hrv": {
				"official": "Djevičanski Otoci SAD",
				"common": "Američki Djevičanski Otoci"
			},
			"ita": {
				"official": "Isole Vergini degli Stati Uniti",
				"common": "Isole Vergini americane"
			},
			"jpn": {
				"official": "米国のバージン諸島",
				"common": "アメリカ領ヴァージン諸島"
			},
			"nld": {
				"official": "Maagdeneilanden van de Verenigde Staten",
				"common": "Amerikaanse Maagdeneilanden"
			},
			"por": {
				"official": "Ilhas Virgens dos Estados Unidos",
				"common": "Ilhas Virgens dos Estados Unidos"
			},
			"rus": {
				"official": "Виргинские острова Соединенных Штатов",
				"common": "Виргинские Острова"
			},
			"spa": {
				"official": "Islas Vírgenes de los Estados Unidos",
				"common": "Islas Vírgenes de los Estados Unidos"
			},
			"svk": {
				"official": "Americké Panenské ostrovy",
				"common": "Americké Panenské ostrovy"
			},
			"fin": {
				"official": "Yhdysvaltain Neitsytsaaret",
				"common": "Neitsytsaaret"
			},
			"zho": {
				"official": "美属维尔京群岛",
				"common": "美属维尔京群岛"
			}
		},
		"latlng": [
			18.35,
			-64.933333
		],
		"demonym": "Virgin Islander",
		"landlocked": false,
		"borders": [],
		"area": 347
	},
	{
		"name": {
			"common": "Vietnam",
			"official": "Socialist Republic of Vietnam",
			"native": {
				"vie": {
					"official": "Cộng hòa xã hội chủ nghĩa Việt Nam",
					"common": "Việt Nam"
				}
			}
		},
		"tld": [
			".vn"
		],
		"cca2": "VN",
		"ccn3": "704",
		"cca3": "VNM",
		"cioc": "VIE",
		"currency": [
			"VND"
		],
		"callingCode": [
			"84"
		],
		"capital": "Hanoi",
		"altSpellings": [
			"VN",
			"Socialist Republic of Vietnam",
			"Cộng hòa Xã hội chủ nghĩa Việt Nam",
			"Viet Nam"
		],
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"languages": {
			"vie": "Vietnamese"
		},
		"translations": {
			"deu": {
				"official": "Sozialistische Republik Vietnam",
				"common": "Vietnam"
			},
			"fra": {
				"official": "République socialiste du Viêt Nam",
				"common": "Viêt Nam"
			},
			"hrv": {
				"official": "Socijalistička Republika Vijetnam",
				"common": "Vijetnam"
			},
			"ita": {
				"official": "Repubblica socialista del Vietnam",
				"common": "Vietnam"
			},
			"jpn": {
				"official": "ベトナム社会主義共和国",
				"common": "ベトナム"
			},
			"nld": {
				"official": "Socialistische Republiek Vietnam",
				"common": "Vietnam"
			},
			"por": {
				"official": "República Socialista do Vietname",
				"common": "Vietname"
			},
			"rus": {
				"official": "Социалистическая Республика Вьетнам",
				"common": "Вьетнам"
			},
			"spa": {
				"official": "República Socialista de Vietnam",
				"common": "Vietnam"
			},
			"svk": {
				"official": "Vietnamská socialistická republika",
				"common": "Vietnam"
			},
			"fin": {
				"official": "Vietnamin sosialistinen tasavalta",
				"common": "Vietnam"
			},
			"zho": {
				"official": "越南社会主义共和国",
				"common": "越南"
			}
		},
		"latlng": [
			16.16666666,
			107.83333333
		],
		"demonym": "Vietnamese",
		"landlocked": false,
		"borders": [
			"KHM",
			"CHN",
			"LAO"
		],
		"area": 331212
	},
	{
		"name": {
			"common": "Vanuatu",
			"official": "Republic of Vanuatu",
			"native": {
				"bis": {
					"official": "Ripablik blong Vanuatu",
					"common": "Vanuatu"
				},
				"eng": {
					"official": "Republic of Vanuatu",
					"common": "Vanuatu"
				},
				"fra": {
					"official": "République de Vanuatu",
					"common": "Vanuatu"
				}
			}
		},
		"tld": [
			".vu"
		],
		"cca2": "VU",
		"ccn3": "548",
		"cca3": "VUT",
		"cioc": "VAN",
		"currency": [
			"VUV"
		],
		"callingCode": [
			"678"
		],
		"capital": "Port Vila",
		"altSpellings": [
			"VU",
			"Republic of Vanuatu",
			"Ripablik blong Vanuatu",
			"République de Vanuatu"
		],
		"region": "Oceania",
		"subregion": "Melanesia",
		"languages": {
			"bis": "Bislama",
			"eng": "English",
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Vanuatu",
				"common": "Vanuatu"
			},
			"fra": {
				"official": "République de Vanuatu",
				"common": "Vanuatu"
			},
			"hrv": {
				"official": "Republika Vanuatu",
				"common": "Vanuatu"
			},
			"ita": {
				"official": "Repubblica di Vanuatu",
				"common": "Vanuatu"
			},
			"jpn": {
				"official": "バヌアツ共和国",
				"common": "バヌアツ"
			},
			"nld": {
				"official": "Republiek Vanuatu",
				"common": "Vanuatu"
			},
			"por": {
				"official": "República de Vanuatu",
				"common": "Vanuatu"
			},
			"rus": {
				"official": "Республика Вануату",
				"common": "Вануату"
			},
			"spa": {
				"official": "República de Vanuatu",
				"common": "Vanuatu"
			},
			"svk": {
				"official": "Vanuatská republika",
				"common": "Vanuatu"
			},
			"fin": {
				"official": "Vanuatun tasavalta",
				"common": "Vanuatu"
			},
			"zho": {
				"official": "瓦努阿图共和国",
				"common": "瓦努阿图"
			}
		},
		"latlng": [
			-16,
			167
		],
		"demonym": "Ni-Vanuatu",
		"landlocked": false,
		"borders": [],
		"area": 12189
	},
	{
		"name": {
			"common": "Wallis and Futuna",
			"official": "Territory of the Wallis and Futuna Islands",
			"native": {
				"fra": {
					"official": "Territoire des îles Wallis et Futuna",
					"common": "Wallis et Futuna"
				}
			}
		},
		"tld": [
			".wf"
		],
		"cca2": "WF",
		"ccn3": "876",
		"cca3": "WLF",
		"cioc": "",
		"currency": [
			"XPF"
		],
		"callingCode": [
			"681"
		],
		"capital": "Mata-Utu",
		"altSpellings": [
			"WF",
			"Territory of the Wallis and Futuna Islands",
			"Territoire des îles Wallis et Futuna"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"fra": "French"
		},
		"translations": {
			"deu": {
				"official": "Gebiet der Wallis und Futuna",
				"common": "Wallis und Futuna"
			},
			"fra": {
				"official": "Territoire des îles Wallis et Futuna",
				"common": "Wallis-et-Futuna"
			},
			"hrv": {
				"official": "Teritoriju Wallis i Futuna",
				"common": "Wallis i Fortuna"
			},
			"ita": {
				"official": "Territorio delle Isole Wallis e Futuna",
				"common": "Wallis e Futuna"
			},
			"jpn": {
				"official": "ウォリス·フツナ諸島の領土",
				"common": "ウォリス・フツナ"
			},
			"nld": {
				"official": "Grondgebied van de Wallis en Futuna",
				"common": "Wallis en Futuna"
			},
			"por": {
				"official": "Território das Ilhas Wallis e Futuna",
				"common": "Wallis e Futuna"
			},
			"rus": {
				"official": "Территория Уоллис и Футуна острова",
				"common": "Уоллис и Футуна"
			},
			"spa": {
				"official": "Territorio de las Islas Wallis y Futuna",
				"common": "Wallis y Futuna"
			},
			"svk": {
				"official": "Teritórium ostrovov Wallis a Futuna",
				"common": "Wallis a Futuna"
			},
			"fin": {
				"official": "Wallisin ja Futunan yhteisö",
				"common": "Wallis ja Futuna"
			},
			"zho": {
				"official": "瓦利斯和富图纳群岛",
				"common": "瓦利斯和富图纳群岛"
			}
		},
		"latlng": [
			-13.3,
			-176.2
		],
		"demonym": "Wallis and Futuna Islander",
		"landlocked": false,
		"borders": [],
		"area": 142
	},
	{
		"name": {
			"common": "Samoa",
			"official": "Independent State of Samoa",
			"native": {
				"eng": {
					"official": "Independent State of Samoa",
					"common": "Samoa"
				},
				"smo": {
					"official": "Malo Saʻoloto Tutoʻatasi o Sāmoa",
					"common": "Sāmoa"
				}
			}
		},
		"tld": [
			".ws"
		],
		"cca2": "WS",
		"ccn3": "882",
		"cca3": "WSM",
		"cioc": "SAM",
		"currency": [
			"WST"
		],
		"callingCode": [
			"685"
		],
		"capital": "Apia",
		"altSpellings": [
			"WS",
			"Independent State of Samoa",
			"Malo Saʻoloto Tutoʻatasi o Sāmoa"
		],
		"region": "Oceania",
		"subregion": "Polynesia",
		"languages": {
			"eng": "English",
			"smo": "Samoan"
		},
		"translations": {
			"deu": {
				"official": "Unabhängige Staat Samoa",
				"common": "Samoa"
			},
			"fra": {
				"official": "Samoa",
				"common": "Samoa"
			},
			"hrv": {
				"official": "Nezavisna Država Samoa",
				"common": "Samoa"
			},
			"ita": {
				"official": "Stato indipendente di Samoa",
				"common": "Samoa"
			},
			"jpn": {
				"official": "サモア独立国",
				"common": "サモア"
			},
			"nld": {
				"official": "Onafhankelijke Staat Samoa",
				"common": "Samoa"
			},
			"por": {
				"official": "Estado Independente de Samoa",
				"common": "Samoa"
			},
			"rus": {
				"official": "Независимое Государство Самоа",
				"common": "Самоа"
			},
			"spa": {
				"official": "Estado Independiente de Samoa",
				"common": "Samoa"
			},
			"svk": {
				"official": "Nezávislý štátSamoa",
				"common": "Samoa"
			},
			"fin": {
				"official": "Samoan itsenäinen valtio",
				"common": "Samoa"
			},
			"zho": {
				"official": "萨摩亚独立国",
				"common": "萨摩亚"
			}
		},
		"latlng": [
			-13.58333333,
			-172.33333333
		],
		"demonym": "Samoan",
		"landlocked": false,
		"borders": [],
		"area": 2842
	},
	{
		"name": {
			"common": "Yemen",
			"official": "Republic of Yemen",
			"native": {
				"ara": {
					"official": "الجمهورية اليمنية",
					"common": "اليَمَن"
				}
			}
		},
		"tld": [
			".ye"
		],
		"cca2": "YE",
		"ccn3": "887",
		"cca3": "YEM",
		"cioc": "YEM",
		"currency": [
			"YER"
		],
		"callingCode": [
			"967"
		],
		"capital": "Sana'a",
		"altSpellings": [
			"YE",
			"Yemeni Republic",
			"al-Jumhūriyyah al-Yamaniyyah"
		],
		"region": "Asia",
		"subregion": "Western Asia",
		"languages": {
			"ara": "Arabic"
		},
		"translations": {
			"deu": {
				"official": "Republik Jemen",
				"common": "Jemen"
			},
			"fra": {
				"official": "République du Yémen",
				"common": "Yémen"
			},
			"hrv": {
				"official": "Republika Jemen",
				"common": "Jemen"
			},
			"ita": {
				"official": "Repubblica dello Yemen",
				"common": "Yemen"
			},
			"jpn": {
				"official": "イエメン共和国",
				"common": "イエメン"
			},
			"nld": {
				"official": "Republiek Jemen",
				"common": "Jemen"
			},
			"por": {
				"official": "República do Iêmen",
				"common": "Iémen"
			},
			"rus": {
				"official": "Йеменская Республика",
				"common": "Йемен"
			},
			"spa": {
				"official": "República de Yemen",
				"common": "Yemen"
			},
			"svk": {
				"official": "Jemenská republika",
				"common": "Jemen"
			},
			"fin": {
				"official": "Jemenin tasavalta",
				"common": "Jemen"
			},
			"zho": {
				"official": "也门共和国",
				"common": "也门"
			}
		},
		"latlng": [
			15,
			48
		],
		"demonym": "Yemeni",
		"landlocked": false,
		"borders": [
			"OMN",
			"SAU"
		],
		"area": 527968
	},
	{
		"name": {
			"common": "South Africa",
			"official": "Republic of South Africa",
			"native": {
				"afr": {
					"official": "Republiek van Suid-Afrika",
					"common": "South Africa"
				},
				"eng": {
					"official": "Republic of South Africa",
					"common": "South Africa"
				},
				"nbl": {
					"official": "IRiphabliki yeSewula Afrika",
					"common": "Sewula Afrika"
				},
				"nso": {
					"official": "Rephaboliki ya Afrika-Borwa ",
					"common": "Afrika-Borwa"
				},
				"sot": {
					"official": "Rephaboliki ya Afrika Borwa",
					"common": "Afrika Borwa"
				},
				"ssw": {
					"official": "IRiphabhulikhi yeNingizimu Afrika",
					"common": "Ningizimu Afrika"
				},
				"tsn": {
					"official": "Rephaboliki ya Aforika Borwa",
					"common": "Aforika Borwa"
				},
				"tso": {
					"official": "Riphabliki ra Afrika Dzonga",
					"common": "Afrika Dzonga"
				},
				"ven": {
					"official": "Riphabuḽiki ya Afurika Tshipembe",
					"common": "Afurika Tshipembe"
				},
				"xho": {
					"official": "IRiphabliki yaseMzantsi Afrika",
					"common": "Mzantsi Afrika"
				},
				"zul": {
					"official": "IRiphabliki yaseNingizimu Afrika",
					"common": "Ningizimu Afrika"
				}
			}
		},
		"tld": [
			".za"
		],
		"cca2": "ZA",
		"ccn3": "710",
		"cca3": "ZAF",
		"cioc": "RSA",
		"currency": [
			"ZAR"
		],
		"callingCode": [
			"27"
		],
		"capital": "Pretoria",
		"altSpellings": [
			"ZA",
			"RSA",
			"Suid-Afrika",
			"Republic of South Africa"
		],
		"region": "Africa",
		"subregion": "Southern Africa",
		"languages": {
			"afr": "Afrikaans",
			"eng": "English",
			"nbl": "Southern Ndebele",
			"nso": "Northern Sotho",
			"sot": "Southern Sotho",
			"ssw": "Swazi",
			"tsn": "Tswana",
			"tso": "Tsonga",
			"ven": "Venda",
			"xho": "Xhosa",
			"zul": "Zulu"
		},
		"translations": {
			"deu": {
				"official": "Republik Südafrika",
				"common": "Republik Südafrika"
			},
			"fra": {
				"official": "République d'Afrique du Sud",
				"common": "Afrique du Sud"
			},
			"hrv": {
				"official": "Južnoafrička Republika",
				"common": "Južnoafrička Republika"
			},
			"ita": {
				"official": "Repubblica del Sud Africa",
				"common": "Sud Africa"
			},
			"jpn": {
				"official": "南アフリカ共和国",
				"common": "南アフリカ"
			},
			"nld": {
				"official": "Zuid -Afrika",
				"common": "Zuid-Afrika"
			},
			"por": {
				"official": "República da África do Sul",
				"common": "África do Sul"
			},
			"rus": {
				"official": "Южно-Африканская Республика",
				"common": "Южно-Африканская Республика"
			},
			"spa": {
				"official": "República de Sudáfrica",
				"common": "República de Sudáfrica"
			},
			"svk": {
				"official": "Juhoafrická republika",
				"common": "Juhoafrická republika"
			},
			"fin": {
				"official": "Etelä-Afrikan tasavalta",
				"common": "Etelä-Afrikka"
			},
			"zho": {
				"official": "南非共和国",
				"common": "南非"
			}
		},
		"latlng": [
			-29,
			24
		],
		"demonym": "South African",
		"landlocked": false,
		"borders": [
			"BWA",
			"LSO",
			"MOZ",
			"NAM",
			"SWZ",
			"ZWE"
		],
		"area": 1221037
	},
	{
		"name": {
			"common": "Zambia",
			"official": "Republic of Zambia",
			"native": {
				"eng": {
					"official": "Republic of Zambia",
					"common": "Zambia"
				}
			}
		},
		"tld": [
			".zm"
		],
		"cca2": "ZM",
		"ccn3": "894",
		"cca3": "ZMB",
		"cioc": "ZAM",
		"currency": [
			"ZMW"
		],
		"callingCode": [
			"260"
		],
		"capital": "Lusaka",
		"altSpellings": [
			"ZM",
			"Republic of Zambia"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"eng": "English"
		},
		"translations": {
			"deu": {
				"official": "Republik Sambia",
				"common": "Sambia"
			},
			"fra": {
				"official": "République de Zambie",
				"common": "Zambie"
			},
			"hrv": {
				"official": "Republika Zambija",
				"common": "Zambija"
			},
			"ita": {
				"official": "Repubblica di Zambia",
				"common": "Zambia"
			},
			"jpn": {
				"official": "ザンビア共和国",
				"common": "ザンビア"
			},
			"nld": {
				"official": "Republiek Zambia",
				"common": "Zambia"
			},
			"por": {
				"official": "República da Zâmbia",
				"common": "Zâmbia"
			},
			"rus": {
				"official": "Республика Замбия",
				"common": "Замбия"
			},
			"spa": {
				"official": "República de Zambia",
				"common": "Zambia"
			},
			"svk": {
				"official": "Zambijská republika",
				"common": "Zambia"
			},
			"fin": {
				"official": "Sambian tasavalta",
				"common": "Sambia"
			},
			"zho": {
				"official": "赞比亚共和国",
				"common": "赞比亚"
			}
		},
		"latlng": [
			-15,
			30
		],
		"demonym": "Zambian",
		"landlocked": true,
		"borders": [
			"AGO",
			"BWA",
			"COD",
			"MWI",
			"MOZ",
			"NAM",
			"TZA",
			"ZWE"
		],
		"area": 752612
	},
	{
		"name": {
			"common": "Zimbabwe",
			"official": "Republic of Zimbabwe",
			"native": {
				"bwg": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"eng": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"kck": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"khi": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"ndc": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"nde": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"nya": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"sna": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"sot": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"toi": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"tsn": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"tso": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"ven": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"xho": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				},
				"zib": {
					"official": "Republic of Zimbabwe",
					"common": "Zimbabwe"
				}
			}
		},
		"tld": [
			".zw"
		],
		"cca2": "ZW",
		"ccn3": "716",
		"cca3": "ZWE",
		"cioc": "ZIM",
		"currency": [
			"ZWL"
		],
		"callingCode": [
			"263"
		],
		"capital": "Harare",
		"altSpellings": [
			"ZW",
			"Republic of Zimbabwe"
		],
		"region": "Africa",
		"subregion": "Eastern Africa",
		"languages": {
			"bwg": "Chibarwe",
			"eng": "English",
			"kck": "Kalanga",
			"khi": "Khoisan",
			"ndc": "Ndau",
			"nde": "Northern Ndebele",
			"nya": "Chewa",
			"sna": "Shona",
			"sot": "Sotho",
			"toi": "Tonga",
			"tsn": "Tswana",
			"tso": "Tsonga",
			"ven": "Venda",
			"xho": "Xhosa",
			"zib": "Zimbabwean Sign Language"
		},
		"translations": {
			"deu": {
				"official": "Republik Simbabwe",
				"common": "Simbabwe"
			},
			"fra": {
				"official": "République du Zimbabwe",
				"common": "Zimbabwe"
			},
			"hrv": {
				"official": "Republika Zimbabve",
				"common": "Zimbabve"
			},
			"ita": {
				"official": "Repubblica dello Zimbabwe",
				"common": "Zimbabwe"
			},
			"jpn": {
				"official": "ジンバブエ共和国",
				"common": "ジンバブエ"
			},
			"nld": {
				"official": "Republiek Zimbabwe",
				"common": "Zimbabwe"
			},
			"por": {
				"official": "República do Zimbabwe",
				"common": "Zimbabwe"
			},
			"rus": {
				"official": "Республика Зимбабве",
				"common": "Зимбабве"
			},
			"spa": {
				"official": "República de Zimbabue",
				"common": "Zimbabue"
			},
			"svk": {
				"official": "Zimbabwianska republika",
				"common": "Zimbabwe"
			},
			"fin": {
				"official": "Zimbabwen tasavalta",
				"common": "Zimbabwe"
			},
			"zho": {
				"official": "津巴布韦共和国",
				"common": "津巴布韦"
			}
		},
		"latlng": [
			-20,
			30
		],
		"demonym": "Zimbabwean",
		"landlocked": true,
		"borders": [
			"BWA",
			"MOZ",
			"ZAF",
			"ZMB"
		],
		"area": 390757
	}
];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(238);

/***/ })
/******/ ]);
});

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(268);
var continents = __webpack_require__(1036);
var regions = __webpack_require__(450);
var countriesAll = __webpack_require__(1037);
var currenciesAll = __webpack_require__(1038);
var languagesAll = __webpack_require__(1039);
var lookup = __webpack_require__(1040);

var getSymbol = __webpack_require__(1041)

exports.continents = continents;
exports.regions = regions;

exports.countries = {
  all: countriesAll,
};

_.each(countriesAll, function (country) {
  // prefer assigned country codes over inactive ones
  var exportedAlpha2 = exports.countries[country.alpha2];
  if (!exportedAlpha2 || exportedAlpha2.status === 'deleted') {
    exports.countries[country.alpha2] = country;
  }

  var exportedAlpha3 = exports.countries[country.alpha3];
  if (!exportedAlpha3 || exportedAlpha3.status === 'deleted') {
    exports.countries[country.alpha3] = country;
  }
});

exports.currencies = {
  all: currenciesAll,
};

_.each(currenciesAll, function (currency) {
  //If the symbol isn't available, default to the currency code
  var symbol = getSymbol(currency.code);
  if (symbol == '?') {
    symbol = currency.code;
  }

  currency.symbol = symbol;
  exports.currencies[currency.code] = currency;
});

exports.languages = {
  all: languagesAll,
};

// Note that for the languages there are several entries with the same alpha3 -
// eg Dutch and Flemish. Not sure how to best deal with that - here whichever
// comes last wins.
_.each(languagesAll, function (language) {
  exports.languages[language.alpha2] = language;
  exports.languages[language.bibliographic] = language;
  exports.languages[language.alpha3] = language;
});

exports.lookup = lookup({
    countries: countriesAll,
    currencies: currenciesAll,
    languages: languagesAll
});

var callingCountries = {all: []};

var callingCodesAll = _.reduce(countriesAll, function (codes, country) {
  if (country.countryCallingCodes && country.countryCallingCodes.length) {
    callingCountries.all.push(country);

    callingCountries[country.alpha2] = country;
    callingCountries[country.alpha3] = country;

    _.each(country.countryCallingCodes, function (code) {
      if (codes.indexOf(code) == -1) {
        codes.push(code);
      }
    });
  }
  return codes;
}, []);

delete callingCountries['']; // remove empty alpha3s
exports.callingCountries = callingCountries;

callingCodesAll.sort(function (a, b) {
  var parse = function (str) { return parseInt(str) };
  var splitA = _.map(a.split(' '), parse);
  var splitB = _.map(b.split(' '), parse);

  if (splitA[0] < splitB[0]) {
    return -1;
  } else if (splitA[0] > splitB[0]) {
    return 1;
  } else {
    // Same - check split[1]
    if (splitA[1] === undefined && splitB[1] !== undefined) {
      return -1;
    } else if (splitA[1] !== undefined && splitB[1] === undefined) {
      return 1;
    } else if (splitA[1] < splitB[1]) {
      return -1;
    } else if (splitA[1] > splitB[1]) {
      return 1;
    } else {
      return 0;
    }
  }
});

exports.callingCodes = {
  all: callingCodesAll
};


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(268);
var regions = __webpack_require__(450);
var continents = {};

continents.asia = {
  name: 'Asia',
  regions: ['centralAsia', 'southernAsia', 'southeastAsia', 'eastAsia', 'westernAsia'],
  countries: _.flatten([
    regions.centralAsia.countries,
    regions.southernAsia.countries,
    regions.southeastAsia.countries,
    regions.eastAsia.countries,
    regions.westernAsia.countries
  ])
  .sort()
};

continents.africa = {
  name: 'Africa',
  regions: ['centralAfrica', 'northAfrica', 'southernAfrica', 'eastAfrica', 'westAfrica'],
  countries: _.flatten([
      regions.centralAfrica.countries,
      regions.northAfrica.countries,
      regions.southernAfrica.countries,
      regions.eastAfrica.countries,
      regions.westAfrica.countries
  ])
  .sort()
};

continents.northAmerica = {
  name: 'North America',
  regions: ['centralAmerica', 'northernAmerica', 'caribbean'],
  countries: _.flatten([
    regions.centralAmerica.countries,
    regions.northernAmerica.countries,
    regions.caribbean.countries
  ])
  .sort()
};

continents.southAmerica = {
  name: 'South America',
  regions: ['southAmerica'],
  countries: _.flatten([
    regions.southAmerica.countries
  ])
  .sort()
}

continents.antartica = {
  name: 'Antartica',
  regions: ['antartica'],
  countries: _.flatten([
    regions.antartica.countries
  ])
  .sort()
}

continents.europe = {
  name: 'Europe',
  regions: ['northernEurope', 'southernEurope', 'easternEurope', 'westernEurope'],
  countries: _.flatten([
    regions.northernEurope.countries,
    regions.southernEurope.countries,
    regions.easternEurope.countries,
    regions.westernEurope.countries
  ])
  .sort()
}

continents.oceania = {
  name: 'Oceania',
  regions: ['australia', 'melanesia', 'micronesia', 'polynesia'],
  countries: _.flatten([
    regions.australia.countries,
    regions.melanesia.countries,
    regions.micronesia.countries,
    regions.polynesia.countries
  ])
  .sort()
};

module.exports = continents;


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = [{"alpha2":"AC","alpha3":"","countryCallingCodes":["+247"],"currencies":["USD"],"emoji":"","ioc":"SHP","languages":["eng"],"name":"Ascension Island","status":"reserved"},{"alpha2":"AD","alpha3":"AND","countryCallingCodes":["+376"],"currencies":["EUR"],"emoji":"🇦🇩","ioc":"AND","languages":["cat"],"name":"Andorra","status":"assigned"},{"alpha2":"AE","alpha3":"ARE","countryCallingCodes":["+971"],"currencies":["AED"],"emoji":"🇦🇪","ioc":"UAE","languages":["ara"],"name":"United Arab Emirates","status":"assigned"},{"alpha2":"AF","alpha3":"AFG","countryCallingCodes":["+93"],"currencies":["AFN"],"emoji":"🇦🇫","ioc":"AFG","languages":["pus"],"name":"Afghanistan","status":"assigned"},{"alpha2":"AG","alpha3":"ATG","countryCallingCodes":["+1 268"],"currencies":["XCD"],"emoji":"🇦🇬","ioc":"ANT","languages":["eng"],"name":"Antigua And Barbuda","status":"assigned"},{"alpha2":"AI","alpha3":"AIA","countryCallingCodes":["+1 264"],"currencies":["XCD"],"emoji":"🇦🇮","ioc":"","languages":["eng"],"name":"Anguilla","status":"assigned"},{"alpha2":"AI","alpha3":"AFI","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"French Afar and Issas","status":"deleted"},{"alpha2":"AL","alpha3":"ALB","countryCallingCodes":["+355"],"currencies":["ALL"],"emoji":"🇦🇱","ioc":"ALB","languages":["sqi"],"name":"Albania","status":"assigned"},{"alpha2":"AM","alpha3":"ARM","countryCallingCodes":["+374"],"currencies":["AMD"],"emoji":"🇦🇲","ioc":"ARM","languages":["hye","rus"],"name":"Armenia","status":"assigned"},{"alpha2":"AN","alpha3":"ANT","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Netherlands Antilles","status":"deleted"},{"alpha2":"AO","alpha3":"AGO","countryCallingCodes":["+244"],"currencies":["AOA"],"emoji":"🇦🇴","ioc":"ANG","languages":["por"],"name":"Angola","status":"assigned"},{"alpha2":"AQ","alpha3":"ATA","countryCallingCodes":["+672"],"currencies":[],"emoji":"🇦🇶","ioc":"","languages":[],"name":"Antarctica","status":"assigned"},{"alpha2":"AR","alpha3":"ARG","countryCallingCodes":["+54"],"currencies":["ARS"],"emoji":"🇦🇷","ioc":"ARG","languages":["spa"],"name":"Argentina","status":"assigned"},{"alpha2":"AS","alpha3":"ASM","countryCallingCodes":["+1 684"],"currencies":["USD"],"emoji":"🇦🇸","ioc":"ASA","languages":["eng","smo"],"name":"American Samoa","status":"assigned"},{"alpha2":"AT","alpha3":"AUT","countryCallingCodes":["+43"],"currencies":["EUR"],"emoji":"🇦🇹","ioc":"AUT","languages":["deu"],"name":"Austria","status":"assigned"},{"alpha2":"AU","alpha3":"AUS","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇦🇺","ioc":"AUS","languages":["eng"],"name":"Australia","status":"assigned"},{"alpha2":"AW","alpha3":"ABW","countryCallingCodes":["+297"],"currencies":["AWG"],"emoji":"🇦🇼","ioc":"ARU","languages":["nld"],"name":"Aruba","status":"assigned"},{"alpha2":"AX","alpha3":"ALA","countryCallingCodes":["+358"],"currencies":["EUR"],"emoji":"🇦🇽","ioc":"","languages":["swe"],"name":"Åland Islands","status":"assigned"},{"alpha2":"AZ","alpha3":"AZE","countryCallingCodes":["+994"],"currencies":["AZN"],"emoji":"🇦🇿","ioc":"AZE","languages":["aze"],"name":"Azerbaijan","status":"assigned"},{"alpha2":"BA","alpha3":"BIH","countryCallingCodes":["+387"],"currencies":["BAM"],"emoji":"🇧🇦","ioc":"BIH","languages":["bos","cre","srp"],"name":"Bosnia & Herzegovina","status":"assigned"},{"alpha2":"BB","alpha3":"BRB","countryCallingCodes":["+1 246"],"currencies":["BBD"],"emoji":"🇧🇧","ioc":"BAR","languages":["eng"],"name":"Barbados","status":"assigned"},{"alpha2":"BD","alpha3":"BGD","countryCallingCodes":["+880"],"currencies":["BDT"],"emoji":"🇧🇩","ioc":"BAN","languages":["ben"],"name":"Bangladesh","status":"assigned"},{"alpha2":"BE","alpha3":"BEL","countryCallingCodes":["+32"],"currencies":["EUR"],"emoji":"🇧🇪","ioc":"BEL","languages":["nld","fra","deu"],"name":"Belgium","status":"assigned"},{"alpha2":"BF","alpha3":"BFA","countryCallingCodes":["+226"],"currencies":["XOF"],"emoji":"🇧🇫","ioc":"BUR","languages":["fra"],"name":"Burkina Faso","status":"assigned"},{"alpha2":"BG","alpha3":"BGR","countryCallingCodes":["+359"],"currencies":["BGN"],"emoji":"🇧🇬","ioc":"BUL","languages":["bul"],"name":"Bulgaria","status":"assigned"},{"alpha2":"BH","alpha3":"BHR","countryCallingCodes":["+973"],"currencies":["BHD"],"emoji":"🇧🇭","ioc":"BRN","languages":["ara"],"name":"Bahrain","status":"assigned"},{"alpha2":"BI","alpha3":"BDI","countryCallingCodes":["+257"],"currencies":["BIF"],"emoji":"🇧🇮","ioc":"BDI","languages":["fra"],"name":"Burundi","status":"assigned"},{"alpha2":"BJ","alpha3":"BEN","countryCallingCodes":["+229"],"currencies":["XOF"],"emoji":"🇧🇯","ioc":"BEN","languages":["fra"],"name":"Benin","status":"assigned"},{"alpha2":"BL","alpha3":"BLM","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇧🇱","ioc":"","languages":["fra"],"name":"Saint Barthélemy","status":"assigned"},{"alpha2":"BM","alpha3":"BMU","countryCallingCodes":["+1 441"],"currencies":["BMD"],"emoji":"🇧🇲","ioc":"BER","languages":["eng"],"name":"Bermuda","status":"assigned"},{"alpha2":"BN","alpha3":"BRN","countryCallingCodes":["+673"],"currencies":["BND"],"emoji":"🇧🇳","ioc":"BRU","languages":["msa","eng"],"name":"Brunei Darussalam","status":"assigned"},{"alpha2":"BO","alpha3":"BOL","countryCallingCodes":["+591"],"currencies":["BOB","BOV"],"emoji":"🇧🇴","ioc":"BOL","languages":["spa","aym","que"],"name":"Bolivia, Plurinational State Of","status":"assigned"},{"alpha2":"BQ","alpha3":"BES","countryCallingCodes":["+599"],"currencies":["USD"],"emoji":"🇧🇶","ioc":"","languages":["nld"],"name":"Bonaire, Saint Eustatius And Saba","status":"assigned"},{"alpha2":"BQ","alpha3":"ATB","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"British Antarctic Territory","status":"deleted"},{"alpha2":"BR","alpha3":"BRA","countryCallingCodes":["+55"],"currencies":["BRL"],"emoji":"🇧🇷","ioc":"BRA","languages":["por"],"name":"Brazil","status":"assigned"},{"alpha2":"BS","alpha3":"BHS","countryCallingCodes":["+1 242"],"currencies":["BSD"],"emoji":"🇧🇸","ioc":"BAH","languages":["eng"],"name":"Bahamas","status":"assigned"},{"alpha2":"BT","alpha3":"BTN","countryCallingCodes":["+975"],"currencies":["INR","BTN"],"emoji":"🇧🇹","ioc":"BHU","languages":["dzo"],"name":"Bhutan","status":"assigned"},{"alpha2":"BU","alpha3":"BUR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Burma","status":"deleted"},{"alpha2":"BV","alpha3":"BVT","countryCallingCodes":[],"currencies":["NOK"],"emoji":"🇧🇻","ioc":"","languages":[],"name":"Bouvet Island","status":"assigned"},{"alpha2":"BW","alpha3":"BWA","countryCallingCodes":["+267"],"currencies":["BWP"],"emoji":"🇧🇼","ioc":"BOT","languages":["eng","tsn"],"name":"Botswana","status":"assigned"},{"alpha2":"BY","alpha3":"BLR","countryCallingCodes":["+375"],"currencies":["BYR"],"emoji":"🇧🇾","ioc":"BLR","languages":["bel","rus"],"name":"Belarus","status":"assigned"},{"alpha2":"BY","alpha3":"BYS","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Byelorussian SSR","status":"deleted"},{"alpha2":"BZ","alpha3":"BLZ","countryCallingCodes":["+501"],"currencies":["BZD"],"emoji":"🇧🇿","ioc":"BIZ","languages":["eng"],"name":"Belize","status":"assigned"},{"alpha2":"CA","alpha3":"CAN","countryCallingCodes":["+1"],"currencies":["CAD"],"emoji":"🇨🇦","ioc":"CAN","languages":["eng","fra"],"name":"Canada","status":"assigned"},{"alpha2":"CC","alpha3":"CCK","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇨🇨","ioc":"","languages":["eng"],"name":"Cocos (Keeling) Islands","status":"assigned"},{"alpha2":"CD","alpha3":"COD","countryCallingCodes":["+243"],"currencies":["CDF"],"emoji":"🇨🇩","ioc":"COD","languages":["fra","lin","kon","swa"],"name":"Democratic Republic Of Congo","status":"assigned"},{"alpha2":"CF","alpha3":"CAF","countryCallingCodes":["+236"],"currencies":["XAF"],"emoji":"🇨🇫","ioc":"CAF","languages":["fra","sag"],"name":"Central African Republic","status":"assigned"},{"alpha2":"CG","alpha3":"COG","countryCallingCodes":["+242"],"currencies":["XAF"],"emoji":"🇨🇬","ioc":"CGO","languages":["fra","lin"],"name":"Republic Of Congo","status":"assigned"},{"alpha2":"CH","alpha3":"CHE","countryCallingCodes":["+41"],"currencies":["CHF","CHE","CHW"],"emoji":"🇨🇭","ioc":"SUI","languages":["deu","fra","ita","roh"],"name":"Switzerland","status":"assigned"},{"alpha2":"CI","alpha3":"CIV","countryCallingCodes":["+225"],"currencies":["XOF"],"emoji":"🇨🇮","ioc":"CIV","languages":["fra"],"name":"Côte d'Ivoire","status":"assigned"},{"alpha2":"CK","alpha3":"COK","countryCallingCodes":["+682"],"currencies":["NZD"],"emoji":"🇨🇰","ioc":"COK","languages":["eng","mri"],"name":"Cook Islands","status":"assigned"},{"alpha2":"CL","alpha3":"CHL","countryCallingCodes":["+56"],"currencies":["CLP","CLF"],"emoji":"🇨🇱","ioc":"CHI","languages":["spa"],"name":"Chile","status":"assigned"},{"alpha2":"CM","alpha3":"CMR","countryCallingCodes":["+237"],"currencies":["XAF"],"emoji":"🇨🇲","ioc":"CMR","languages":["eng","fra"],"name":"Cameroon","status":"assigned"},{"alpha2":"CN","alpha3":"CHN","countryCallingCodes":["+86"],"currencies":["CNY"],"emoji":"🇨🇳","ioc":"CHN","languages":["zho"],"name":"China","status":"assigned"},{"alpha2":"CO","alpha3":"COL","countryCallingCodes":["+57"],"currencies":["COP","COU"],"emoji":"🇨🇴","ioc":"COL","languages":["spa"],"name":"Colombia","status":"assigned"},{"alpha2":"CP","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Clipperton Island","status":"reserved"},{"alpha2":"CR","alpha3":"CRI","countryCallingCodes":["+506"],"currencies":["CRC"],"emoji":"🇨🇷","ioc":"CRC","languages":["spa"],"name":"Costa Rica","status":"assigned"},{"alpha2":"CS","alpha3":"CSK","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Czechoslovakia","status":"deleted"},{"alpha2":"CS","alpha3":"SCG","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Serbia and Montenegro","status":"deleted"},{"alpha2":"CT","alpha3":"CTE","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Canton and Enderbury Islands","status":"deleted"},{"alpha2":"CU","alpha3":"CUB","countryCallingCodes":["+53"],"currencies":["CUP","CUC"],"emoji":"🇨🇺","ioc":"CUB","languages":["spa"],"name":"Cuba","status":"assigned"},{"alpha2":"CV","alpha3":"CPV","countryCallingCodes":["+238"],"currencies":["CVE"],"emoji":"🇨🇻","ioc":"CPV","languages":["por"],"name":"Cabo Verde","status":"assigned"},{"alpha2":"CW","alpha3":"CUW","countryCallingCodes":["+599"],"currencies":["ANG"],"emoji":"🇨🇼","ioc":"","languages":["nld"],"name":"Curacao","status":"assigned"},{"alpha2":"CX","alpha3":"CXR","countryCallingCodes":["+61"],"currencies":["AUD"],"emoji":"🇨🇽","ioc":"","languages":["eng"],"name":"Christmas Island","status":"assigned"},{"alpha2":"CY","alpha3":"CYP","countryCallingCodes":["+357"],"currencies":["EUR"],"emoji":"🇨🇾","ioc":"CYP","languages":["ell","tur"],"name":"Cyprus","status":"assigned"},{"alpha2":"CZ","alpha3":"CZE","countryCallingCodes":["+420"],"currencies":["CZK"],"emoji":"🇨🇿","ioc":"CZE","languages":["ces"],"name":"Czech Republic","status":"assigned"},{"alpha2":"DD","alpha3":"DDR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"German Democratic Republic","status":"deleted"},{"alpha2":"DE","alpha3":"DEU","countryCallingCodes":["+49"],"currencies":["EUR"],"emoji":"🇩🇪","ioc":"GER","languages":["deu"],"name":"Germany","status":"assigned"},{"alpha2":"DG","alpha3":"","countryCallingCodes":[],"currencies":["USD"],"emoji":"","ioc":"","languages":[],"name":"Diego Garcia","status":"reserved"},{"alpha2":"DJ","alpha3":"DJI","countryCallingCodes":["+253"],"currencies":["DJF"],"emoji":"🇩🇯","ioc":"DJI","languages":["ara","fra"],"name":"Djibouti","status":"assigned"},{"alpha2":"DK","alpha3":"DNK","countryCallingCodes":["+45"],"currencies":["DKK"],"emoji":"🇩🇰","ioc":"DEN","languages":["dan"],"name":"Denmark","status":"assigned"},{"alpha2":"DM","alpha3":"DMA","countryCallingCodes":["+1 767"],"currencies":["XCD"],"emoji":"🇩🇲","ioc":"DMA","languages":["eng"],"name":"Dominica","status":"assigned"},{"alpha2":"DO","alpha3":"DOM","countryCallingCodes":["+1 809","+1 829","+1 849"],"currencies":["DOP"],"emoji":"🇩🇴","ioc":"DOM","languages":["spa"],"name":"Dominican Republic","status":"assigned"},{"alpha2":"DY","alpha3":"DHY","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Dahomey","status":"deleted"},{"alpha2":"DZ","alpha3":"DZA","countryCallingCodes":["+213"],"currencies":["DZD"],"emoji":"🇩🇿","ioc":"ALG","languages":["ara"],"name":"Algeria","status":"assigned"},{"alpha2":"EA","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Ceuta, Mulilla","status":"reserved"},{"alpha2":"EC","alpha3":"ECU","countryCallingCodes":["+593"],"currencies":["USD"],"emoji":"🇪🇨","ioc":"ECU","languages":["spa","que"],"name":"Ecuador","status":"assigned"},{"alpha2":"EE","alpha3":"EST","countryCallingCodes":["+372"],"currencies":["EUR"],"emoji":"🇪🇪","ioc":"EST","languages":["est"],"name":"Estonia","status":"assigned"},{"alpha2":"EG","alpha3":"EGY","countryCallingCodes":["+20"],"currencies":["EGP"],"emoji":"🇪🇬","ioc":"EGY","languages":["ara"],"name":"Egypt","status":"assigned"},{"alpha2":"EH","alpha3":"ESH","countryCallingCodes":["+212"],"currencies":["MAD"],"emoji":"🇪🇭","ioc":"","languages":[],"name":"Western Sahara","status":"assigned"},{"alpha2":"ER","alpha3":"ERI","countryCallingCodes":["+291"],"currencies":["ERN"],"emoji":"🇪🇷","ioc":"ERI","languages":["eng","ara","tir"],"name":"Eritrea","status":"assigned"},{"alpha2":"ES","alpha3":"ESP","countryCallingCodes":["+34"],"currencies":["EUR"],"emoji":"🇪🇸","ioc":"ESP","languages":["spa"],"name":"Spain","status":"assigned"},{"alpha2":"ET","alpha3":"ETH","countryCallingCodes":["+251"],"currencies":["ETB"],"emoji":"🇪🇹","ioc":"ETH","languages":["amh"],"name":"Ethiopia","status":"assigned"},{"alpha2":"EU","alpha3":"","countryCallingCodes":["+388"],"currencies":["EUR"],"emoji":"🇪🇺","ioc":"","languages":[],"name":"European Union","status":"reserved"},{"alpha2":"FI","alpha3":"FIN","countryCallingCodes":["+358"],"currencies":["EUR"],"emoji":"🇫🇮","ioc":"FIN","languages":["fin","swe"],"name":"Finland","status":"assigned"},{"alpha2":"FJ","alpha3":"FJI","countryCallingCodes":["+679"],"currencies":["FJD"],"emoji":"🇫🇯","ioc":"FIJ","languages":["eng","fij"],"name":"Fiji","status":"assigned"},{"alpha2":"FK","alpha3":"FLK","countryCallingCodes":["+500"],"currencies":["FKP"],"emoji":"🇫🇰","ioc":"","languages":["eng"],"name":"Falkland Islands","status":"assigned"},{"alpha2":"FM","alpha3":"FSM","countryCallingCodes":["+691"],"currencies":["USD"],"emoji":"🇫🇲","ioc":"FSM","languages":["eng"],"name":"Micronesia, Federated States Of","status":"assigned"},{"alpha2":"FO","alpha3":"FRO","countryCallingCodes":["+298"],"currencies":["DKK"],"emoji":"🇫🇴","ioc":"FAI","languages":["fao","dan"],"name":"Faroe Islands","status":"assigned"},{"alpha2":"FQ","alpha3":"ATF","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"French Southern and Antarctic Territories","status":"deleted"},{"alpha2":"FR","alpha3":"FRA","countryCallingCodes":["+33"],"currencies":["EUR"],"emoji":"🇫🇷","ioc":"FRA","languages":["fra"],"name":"France","status":"assigned"},{"alpha2":"FX","alpha3":"","countryCallingCodes":["+241"],"currencies":["EUR"],"emoji":"","ioc":"","languages":["fra"],"name":"France, Metropolitan","status":"reserved"},{"alpha2":"GA","alpha3":"GAB","countryCallingCodes":["+241"],"currencies":["XAF"],"emoji":"🇬🇦","ioc":"GAB","languages":["fra"],"name":"Gabon","status":"assigned"},{"alpha2":"GB","alpha3":"GBR","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇬🇧","ioc":"GBR","languages":["eng","cor","gle","gla","cym"],"name":"United Kingdom","status":"assigned"},{"alpha2":"GD","alpha3":"GRD","countryCallingCodes":["+473"],"currencies":["XCD"],"emoji":"🇬🇩","ioc":"GRN","languages":["eng"],"name":"Grenada","status":"assigned"},{"alpha2":"GE","alpha3":"GEO","countryCallingCodes":["+995"],"currencies":["GEL"],"emoji":"🇬🇪","ioc":"GEO","languages":["kat"],"name":"Georgia","status":"assigned"},{"alpha2":"GE","alpha3":"GEL","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Gilbert and Ellice Islands","status":"deleted"},{"alpha2":"GF","alpha3":"GUF","countryCallingCodes":["+594"],"currencies":["EUR"],"emoji":"🇬🇫","ioc":"","languages":["fra"],"name":"French Guiana","status":"assigned"},{"alpha2":"GG","alpha3":"GGY","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇬🇬","ioc":"GCI","languages":["fra"],"name":"Guernsey","status":"assigned"},{"alpha2":"GH","alpha3":"GHA","countryCallingCodes":["+233"],"currencies":["GHS"],"emoji":"🇬🇭","ioc":"GHA","languages":["eng"],"name":"Ghana","status":"assigned"},{"alpha2":"GI","alpha3":"GIB","countryCallingCodes":["+350"],"currencies":["GIP"],"emoji":"🇬🇮","ioc":"","languages":["eng"],"name":"Gibraltar","status":"assigned"},{"alpha2":"GL","alpha3":"GRL","countryCallingCodes":["+299"],"currencies":["DKK"],"emoji":"🇬🇱","ioc":"","languages":["kal"],"name":"Greenland","status":"assigned"},{"alpha2":"GM","alpha3":"GMB","countryCallingCodes":["+220"],"currencies":["GMD"],"emoji":"🇬🇲","ioc":"GAM","languages":["eng"],"name":"Gambia","status":"assigned"},{"alpha2":"GN","alpha3":"GIN","countryCallingCodes":["+224"],"currencies":["GNF"],"emoji":"🇬🇳","ioc":"GUI","languages":["fra"],"name":"Guinea","status":"assigned"},{"alpha2":"GP","alpha3":"GLP","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇬🇵","ioc":"","languages":["fra"],"name":"Guadeloupe","status":"assigned"},{"alpha2":"GQ","alpha3":"GNQ","countryCallingCodes":["+240"],"currencies":["XAF"],"emoji":"🇬🇶","ioc":"GEQ","languages":["spa","fra","por"],"name":"Equatorial Guinea","status":"assigned"},{"alpha2":"GR","alpha3":"GRC","countryCallingCodes":["+30"],"currencies":["EUR"],"emoji":"🇬🇷","ioc":"GRE","languages":["ell"],"name":"Greece","status":"assigned"},{"alpha2":"GS","alpha3":"SGS","countryCallingCodes":[],"currencies":["GBP"],"emoji":"🇬🇸","ioc":"","languages":["eng"],"name":"South Georgia And The South Sandwich Islands","status":"assigned"},{"alpha2":"GT","alpha3":"GTM","countryCallingCodes":["+502"],"currencies":["GTQ"],"emoji":"🇬🇹","ioc":"GUA","languages":["spa"],"name":"Guatemala","status":"assigned"},{"alpha2":"GU","alpha3":"GUM","countryCallingCodes":["+1 671"],"currencies":["USD"],"emoji":"🇬🇺","ioc":"GUM","languages":["eng"],"name":"Guam","status":"assigned"},{"alpha2":"GW","alpha3":"GNB","countryCallingCodes":["+245"],"currencies":["XOF"],"emoji":"🇬🇼","ioc":"GBS","languages":["por"],"name":"Guinea-bissau","status":"assigned"},{"alpha2":"GY","alpha3":"GUY","countryCallingCodes":["+592"],"currencies":["GYD"],"emoji":"🇬🇾","ioc":"GUY","languages":["eng"],"name":"Guyana","status":"assigned"},{"alpha2":"HK","alpha3":"HKG","countryCallingCodes":["+852"],"currencies":["HKD"],"emoji":"🇭🇰","ioc":"HKG","languages":["zho","eng"],"name":"Hong Kong","status":"assigned"},{"alpha2":"HM","alpha3":"HMD","countryCallingCodes":[],"currencies":["AUD"],"emoji":"🇭🇲","ioc":"","languages":[],"name":"Heard Island And McDonald Islands","status":"assigned"},{"alpha2":"HN","alpha3":"HND","countryCallingCodes":["+504"],"currencies":["HNL"],"emoji":"🇭🇳","ioc":"HON","languages":["spa"],"name":"Honduras","status":"assigned"},{"alpha2":"HR","alpha3":"HRV","countryCallingCodes":["+385"],"currencies":["HRK"],"emoji":"🇭🇷","ioc":"CRO","languages":["hrv"],"name":"Croatia","status":"assigned"},{"alpha2":"HT","alpha3":"HTI","countryCallingCodes":["+509"],"currencies":["HTG","USD"],"emoji":"🇭🇹","ioc":"HAI","languages":["fra","hat"],"name":"Haiti","status":"assigned"},{"alpha2":"HU","alpha3":"HUN","countryCallingCodes":["+36"],"currencies":["HUF"],"emoji":"🇭🇺","ioc":"HUN","languages":["hun"],"name":"Hungary","status":"assigned"},{"alpha2":"HV","alpha3":"HVO","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Upper Volta","status":"deleted"},{"alpha2":"IC","alpha3":"","countryCallingCodes":[],"currencies":["EUR"],"emoji":"","ioc":"","languages":[],"name":"Canary Islands","status":"reserved"},{"alpha2":"ID","alpha3":"IDN","countryCallingCodes":["+62"],"currencies":["IDR"],"emoji":"🇮🇩","ioc":"INA","languages":["ind"],"name":"Indonesia","status":"assigned"},{"alpha2":"IE","alpha3":"IRL","countryCallingCodes":["+353"],"currencies":["EUR"],"emoji":"🇮🇪","ioc":"IRL","languages":["eng","gle"],"name":"Ireland","status":"assigned"},{"alpha2":"IL","alpha3":"ISR","countryCallingCodes":["+972"],"currencies":["ILS"],"emoji":"🇮🇱","ioc":"ISR","languages":["heb","ara","eng"],"name":"Israel","status":"assigned"},{"alpha2":"IM","alpha3":"IMN","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇮🇲","ioc":"","languages":["eng","glv"],"name":"Isle Of Man","status":"assigned"},{"alpha2":"IN","alpha3":"IND","countryCallingCodes":["+91"],"currencies":["INR"],"emoji":"🇮🇳","ioc":"IND","languages":["eng","hin"],"name":"India","status":"assigned"},{"alpha2":"IO","alpha3":"IOT","countryCallingCodes":["+246"],"currencies":["USD"],"emoji":"🇮🇴","ioc":"","languages":["eng"],"name":"British Indian Ocean Territory","status":"assigned"},{"alpha2":"IQ","alpha3":"IRQ","countryCallingCodes":["+964"],"currencies":["IQD"],"emoji":"🇮🇶","ioc":"IRQ","languages":["ara","kur"],"name":"Iraq","status":"assigned"},{"alpha2":"IR","alpha3":"IRN","countryCallingCodes":["+98"],"currencies":["IRR"],"emoji":"🇮🇷","ioc":"IRI","languages":["fas"],"name":"Iran, Islamic Republic Of","status":"assigned"},{"alpha2":"IS","alpha3":"ISL","countryCallingCodes":["+354"],"currencies":["ISK"],"emoji":"🇮🇸","ioc":"ISL","languages":["isl"],"name":"Iceland","status":"assigned"},{"alpha2":"IT","alpha3":"ITA","countryCallingCodes":["+39"],"currencies":["EUR"],"emoji":"🇮🇹","ioc":"ITA","languages":["ita"],"name":"Italy","status":"assigned"},{"alpha2":"JE","alpha3":"JEY","countryCallingCodes":["+44"],"currencies":["GBP"],"emoji":"🇯🇪","ioc":"JCI","languages":["eng","fra"],"name":"Jersey","status":"assigned"},{"alpha2":"JM","alpha3":"JAM","countryCallingCodes":["+1 876"],"currencies":["JMD"],"emoji":"🇯🇲","ioc":"JAM","languages":["eng"],"name":"Jamaica","status":"assigned"},{"alpha2":"JO","alpha3":"JOR","countryCallingCodes":["+962"],"currencies":["JOD"],"emoji":"🇯🇴","ioc":"JOR","languages":["ara"],"name":"Jordan","status":"assigned"},{"alpha2":"JP","alpha3":"JPN","countryCallingCodes":["+81"],"currencies":["JPY"],"emoji":"🇯🇵","ioc":"JPN","languages":["jpn"],"name":"Japan","status":"assigned"},{"alpha2":"JT","alpha3":"JTN","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Johnston Island","status":"deleted"},{"alpha2":"KE","alpha3":"KEN","countryCallingCodes":["+254"],"currencies":["KES"],"emoji":"🇰🇪","ioc":"KEN","languages":["eng","swa"],"name":"Kenya","status":"assigned"},{"alpha2":"KG","alpha3":"KGZ","countryCallingCodes":["+996"],"currencies":["KGS"],"emoji":"🇰🇬","ioc":"KGZ","languages":["rus"],"name":"Kyrgyzstan","status":"assigned"},{"alpha2":"KH","alpha3":"KHM","countryCallingCodes":["+855"],"currencies":["KHR"],"emoji":"🇰🇭","ioc":"CAM","languages":["khm"],"name":"Cambodia","status":"assigned"},{"alpha2":"KI","alpha3":"KIR","countryCallingCodes":["+686"],"currencies":["AUD"],"emoji":"🇰🇮","ioc":"KIR","languages":["eng"],"name":"Kiribati","status":"assigned"},{"alpha2":"KM","alpha3":"COM","countryCallingCodes":["+269"],"currencies":["KMF"],"emoji":"🇰🇲","ioc":"COM","languages":["ara","fra"],"name":"Comoros","status":"assigned"},{"alpha2":"KN","alpha3":"KNA","countryCallingCodes":["+1 869"],"currencies":["XCD"],"emoji":"🇰🇳","ioc":"SKN","languages":["eng"],"name":"Saint Kitts And Nevis","status":"assigned"},{"alpha2":"KP","alpha3":"PRK","countryCallingCodes":["+850"],"currencies":["KPW"],"emoji":"🇰🇵","ioc":"PRK","languages":["kor"],"name":"Korea, Democratic People's Republic Of","status":"assigned"},{"alpha2":"KR","alpha3":"KOR","countryCallingCodes":["+82"],"currencies":["KRW"],"emoji":"🇰🇷","ioc":"KOR","languages":["kor"],"name":"Korea, Republic Of","status":"assigned"},{"alpha2":"KW","alpha3":"KWT","countryCallingCodes":["+965"],"currencies":["KWD"],"emoji":"🇰🇼","ioc":"KUW","languages":["ara"],"name":"Kuwait","status":"assigned"},{"alpha2":"KY","alpha3":"CYM","countryCallingCodes":["+1 345"],"currencies":["KYD"],"emoji":"🇰🇾","ioc":"CAY","languages":["eng"],"name":"Cayman Islands","status":"assigned"},{"alpha2":"KZ","alpha3":"KAZ","countryCallingCodes":["+7","+7 6","+7 7"],"currencies":["KZT"],"emoji":"🇰🇿","ioc":"KAZ","languages":["kaz","rus"],"name":"Kazakhstan","status":"assigned"},{"alpha2":"LA","alpha3":"LAO","countryCallingCodes":["+856"],"currencies":["LAK"],"emoji":"🇱🇦","ioc":"LAO","languages":["lao"],"name":"Lao People's Democratic Republic","status":"assigned"},{"alpha2":"LB","alpha3":"LBN","countryCallingCodes":["+961"],"currencies":["LBP"],"emoji":"🇱🇧","ioc":"LIB","languages":["ara","hye"],"name":"Lebanon","status":"assigned"},{"alpha2":"LC","alpha3":"LCA","countryCallingCodes":["+1 758"],"currencies":["XCD"],"emoji":"🇱🇨","ioc":"LCA","languages":["eng"],"name":"Saint Lucia","status":"assigned"},{"alpha2":"LI","alpha3":"LIE","countryCallingCodes":["+423"],"currencies":["CHF"],"emoji":"🇱🇮","ioc":"LIE","languages":["deu"],"name":"Liechtenstein","status":"assigned"},{"alpha2":"LK","alpha3":"LKA","countryCallingCodes":["+94"],"currencies":["LKR"],"emoji":"🇱🇰","ioc":"SRI","languages":["sin","tam"],"name":"Sri Lanka","status":"assigned"},{"alpha2":"LR","alpha3":"LBR","countryCallingCodes":["+231"],"currencies":["LRD"],"emoji":"🇱🇷","ioc":"LBR","languages":["eng"],"name":"Liberia","status":"assigned"},{"alpha2":"LS","alpha3":"LSO","countryCallingCodes":["+266"],"currencies":["LSL","ZAR"],"emoji":"🇱🇸","ioc":"LES","languages":["eng","sot"],"name":"Lesotho","status":"assigned"},{"alpha2":"LT","alpha3":"LTU","countryCallingCodes":["+370"],"currencies":["EUR"],"emoji":"🇱🇹","ioc":"LTU","languages":["lit"],"name":"Lithuania","status":"assigned"},{"alpha2":"LU","alpha3":"LUX","countryCallingCodes":["+352"],"currencies":["EUR"],"emoji":"🇱🇺","ioc":"LUX","languages":["fra","deu","ltz"],"name":"Luxembourg","status":"assigned"},{"alpha2":"LV","alpha3":"LVA","countryCallingCodes":["+371"],"currencies":["EUR"],"emoji":"🇱🇻","ioc":"LAT","languages":["lav"],"name":"Latvia","status":"assigned"},{"alpha2":"LY","alpha3":"LBY","countryCallingCodes":["+218"],"currencies":["LYD"],"emoji":"🇱🇾","ioc":"LBA","languages":["ara"],"name":"Libya","status":"assigned"},{"alpha2":"MA","alpha3":"MAR","countryCallingCodes":["+212"],"currencies":["MAD"],"emoji":"🇲🇦","ioc":"MAR","languages":["ara"],"name":"Morocco","status":"assigned"},{"alpha2":"MC","alpha3":"MCO","countryCallingCodes":["+377"],"currencies":["EUR"],"emoji":"🇲🇨","ioc":"MON","languages":["fra"],"name":"Monaco","status":"assigned"},{"alpha2":"MD","alpha3":"MDA","countryCallingCodes":["+373"],"currencies":["MDL"],"emoji":"🇲🇩","ioc":"MDA","languages":["ron"],"name":"Moldova","status":"assigned"},{"alpha2":"ME","alpha3":"MNE","countryCallingCodes":["+382"],"currencies":["EUR"],"emoji":"🇲🇪","ioc":"MNE","languages":["mot"],"name":"Montenegro","status":"assigned"},{"alpha2":"MF","alpha3":"MAF","countryCallingCodes":["+590"],"currencies":["EUR"],"emoji":"🇲🇫","ioc":"","languages":["fra"],"name":"Saint Martin","status":"assigned"},{"alpha2":"MG","alpha3":"MDG","countryCallingCodes":["+261"],"currencies":["MGA"],"emoji":"🇲🇬","ioc":"MAD","languages":["fra","mlg"],"name":"Madagascar","status":"assigned"},{"alpha2":"MH","alpha3":"MHL","countryCallingCodes":["+692"],"currencies":["USD"],"emoji":"🇲🇭","ioc":"MHL","languages":["eng","mah"],"name":"Marshall Islands","status":"assigned"},{"alpha2":"MI","alpha3":"MID","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Midway Islands","status":"deleted"},{"alpha2":"MK","alpha3":"MKD","countryCallingCodes":["+389"],"currencies":["MKD"],"emoji":"🇲🇰","ioc":"MKD","languages":["mkd"],"name":"Macedonia, The Former Yugoslav Republic Of","status":"assigned"},{"alpha2":"ML","alpha3":"MLI","countryCallingCodes":["+223"],"currencies":["XOF"],"emoji":"🇲🇱","ioc":"MLI","languages":["fra"],"name":"Mali","status":"assigned"},{"alpha2":"MM","alpha3":"MMR","countryCallingCodes":["+95"],"currencies":["MMK"],"emoji":"🇲🇲","ioc":"MYA","languages":["mya"],"name":"Myanmar","status":"assigned"},{"alpha2":"MN","alpha3":"MNG","countryCallingCodes":["+976"],"currencies":["MNT"],"emoji":"🇲🇳","ioc":"MGL","languages":["mon"],"name":"Mongolia","status":"assigned"},{"alpha2":"MO","alpha3":"MAC","countryCallingCodes":["+853"],"currencies":["MOP"],"emoji":"🇲🇴","ioc":"MAC","languages":["zho","por"],"name":"Macao","status":"assigned"},{"alpha2":"MP","alpha3":"MNP","countryCallingCodes":["+1 670"],"currencies":["USD"],"emoji":"🇲🇵","ioc":"","languages":["eng"],"name":"Northern Mariana Islands","status":"assigned"},{"alpha2":"MQ","alpha3":"MTQ","countryCallingCodes":["+596"],"currencies":["EUR"],"emoji":"🇲🇶","ioc":"","languages":[],"name":"Martinique","status":"assigned"},{"alpha2":"MR","alpha3":"MRT","countryCallingCodes":["+222"],"currencies":["MRO"],"emoji":"🇲🇷","ioc":"MTN","languages":["ara","fra"],"name":"Mauritania","status":"assigned"},{"alpha2":"MS","alpha3":"MSR","countryCallingCodes":["+1 664"],"currencies":["XCD"],"emoji":"🇲🇸","ioc":"","languages":[],"name":"Montserrat","status":"assigned"},{"alpha2":"MT","alpha3":"MLT","countryCallingCodes":["+356"],"currencies":["EUR"],"emoji":"🇲🇹","ioc":"MLT","languages":["mlt","eng"],"name":"Malta","status":"assigned"},{"alpha2":"MU","alpha3":"MUS","countryCallingCodes":["+230"],"currencies":["MUR"],"emoji":"🇲🇺","ioc":"MRI","languages":["eng","fra"],"name":"Mauritius","status":"assigned"},{"alpha2":"MV","alpha3":"MDV","countryCallingCodes":["+960"],"currencies":["MVR"],"emoji":"🇲🇻","ioc":"MDV","languages":["div"],"name":"Maldives","status":"assigned"},{"alpha2":"MW","alpha3":"MWI","countryCallingCodes":["+265"],"currencies":["MWK"],"emoji":"🇲🇼","ioc":"MAW","languages":["eng","nya"],"name":"Malawi","status":"assigned"},{"alpha2":"MX","alpha3":"MEX","countryCallingCodes":["+52"],"currencies":["MXN","MXV"],"emoji":"🇲🇽","ioc":"MEX","languages":["spa"],"name":"Mexico","status":"assigned"},{"alpha2":"MY","alpha3":"MYS","countryCallingCodes":["+60"],"currencies":["MYR"],"emoji":"🇲🇾","ioc":"MAS","languages":["msa","eng"],"name":"Malaysia","status":"assigned"},{"alpha2":"MZ","alpha3":"MOZ","countryCallingCodes":["+258"],"currencies":["MZN"],"emoji":"🇲🇿","ioc":"MOZ","languages":["por"],"name":"Mozambique","status":"assigned"},{"alpha2":"NA","alpha3":"NAM","countryCallingCodes":["+264"],"currencies":["NAD","ZAR"],"emoji":"🇳🇦","ioc":"NAM","languages":["eng"],"name":"Namibia","status":"assigned"},{"alpha2":"NC","alpha3":"NCL","countryCallingCodes":["+687"],"currencies":["XPF"],"emoji":"🇳🇨","ioc":"","languages":["fra"],"name":"New Caledonia","status":"assigned"},{"alpha2":"NE","alpha3":"NER","countryCallingCodes":["+227"],"currencies":["XOF"],"emoji":"🇳🇪","ioc":"NIG","languages":["fra"],"name":"Niger","status":"assigned"},{"alpha2":"NF","alpha3":"NFK","countryCallingCodes":["+672"],"currencies":["AUD"],"emoji":"🇳🇫","ioc":"","languages":["eng"],"name":"Norfolk Island","status":"assigned"},{"alpha2":"NG","alpha3":"NGA","countryCallingCodes":["+234"],"currencies":["NGN"],"emoji":"🇳🇬","ioc":"NGR","languages":["eng"],"name":"Nigeria","status":"assigned"},{"alpha2":"NH","alpha3":"NHB","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"New Hebrides","status":"deleted"},{"alpha2":"NI","alpha3":"NIC","countryCallingCodes":["+505"],"currencies":["NIO"],"emoji":"🇳🇮","ioc":"NCA","languages":["spa"],"name":"Nicaragua","status":"assigned"},{"alpha2":"NL","alpha3":"NLD","countryCallingCodes":["+31"],"currencies":["EUR"],"emoji":"🇳🇱","ioc":"NED","languages":["nld"],"name":"Netherlands","status":"assigned"},{"alpha2":"NO","alpha3":"NOR","countryCallingCodes":["+47"],"currencies":["NOK"],"emoji":"🇳🇴","ioc":"NOR","languages":["nor"],"name":"Norway","status":"assigned"},{"alpha2":"NP","alpha3":"NPL","countryCallingCodes":["+977"],"currencies":["NPR"],"emoji":"🇳🇵","ioc":"NEP","languages":["nep"],"name":"Nepal","status":"assigned"},{"alpha2":"NQ","alpha3":"ATN","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Dronning Maud Land","status":"deleted"},{"alpha2":"NR","alpha3":"NRU","countryCallingCodes":["+674"],"currencies":["AUD"],"emoji":"🇳🇷","ioc":"NRU","languages":["eng","nau"],"name":"Nauru","status":"assigned"},{"alpha2":"NT","alpha3":"NTZ","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Neutral Zone","status":"deleted"},{"alpha2":"NU","alpha3":"NIU","countryCallingCodes":["+683"],"currencies":["NZD"],"emoji":"🇳🇺","ioc":"","languages":["eng"],"name":"Niue","status":"assigned"},{"alpha2":"NZ","alpha3":"NZL","countryCallingCodes":["+64"],"currencies":["NZD"],"emoji":"🇳🇿","ioc":"NZL","languages":["eng"],"name":"New Zealand","status":"assigned"},{"alpha2":"OM","alpha3":"OMN","countryCallingCodes":["+968"],"currencies":["OMR"],"emoji":"🇴🇲","ioc":"OMA","languages":["ara"],"name":"Oman","status":"assigned"},{"alpha2":"PA","alpha3":"PAN","countryCallingCodes":["+507"],"currencies":["PAB","USD"],"emoji":"🇵🇦","ioc":"PAN","languages":["spa"],"name":"Panama","status":"assigned"},{"alpha2":"PC","alpha3":"PCI","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Pacific Islands, Trust Territory of the","status":"deleted"},{"alpha2":"PE","alpha3":"PER","countryCallingCodes":["+51"],"currencies":["PEN"],"emoji":"🇵🇪","ioc":"PER","languages":["spa","aym","que"],"name":"Peru","status":"assigned"},{"alpha2":"PF","alpha3":"PYF","countryCallingCodes":["+689"],"currencies":["XPF"],"emoji":"🇵🇫","ioc":"","languages":["fra"],"name":"French Polynesia","status":"assigned"},{"alpha2":"PG","alpha3":"PNG","countryCallingCodes":["+675"],"currencies":["PGK"],"emoji":"🇵🇬","ioc":"PNG","languages":["eng"],"name":"Papua New Guinea","status":"assigned"},{"alpha2":"PH","alpha3":"PHL","countryCallingCodes":["+63"],"currencies":["PHP"],"emoji":"🇵🇭","ioc":"PHI","languages":["eng"],"name":"Philippines","status":"assigned"},{"alpha2":"PK","alpha3":"PAK","countryCallingCodes":["+92"],"currencies":["PKR"],"emoji":"🇵🇰","ioc":"PAK","languages":["urd","eng"],"name":"Pakistan","status":"assigned"},{"alpha2":"PL","alpha3":"POL","countryCallingCodes":["+48"],"currencies":["PLN"],"emoji":"🇵🇱","ioc":"POL","languages":["pol"],"name":"Poland","status":"assigned"},{"alpha2":"PM","alpha3":"SPM","countryCallingCodes":["+508"],"currencies":["EUR"],"emoji":"🇵🇲","ioc":"","languages":["eng"],"name":"Saint Pierre And Miquelon","status":"assigned"},{"alpha2":"PN","alpha3":"PCN","countryCallingCodes":["+872"],"currencies":["NZD"],"emoji":"🇵🇳","ioc":"","languages":["eng"],"name":"Pitcairn","status":"assigned"},{"alpha2":"PR","alpha3":"PRI","countryCallingCodes":["+1 787","+1 939"],"currencies":["USD"],"emoji":"🇵🇷","ioc":"PUR","languages":["spa","eng"],"name":"Puerto Rico","status":"assigned"},{"alpha2":"PS","alpha3":"PSE","countryCallingCodes":["+970"],"currencies":["JOD","EGP","ILS"],"emoji":"🇵🇸","ioc":"PLE","languages":["ara"],"name":"Palestinian Territory, Occupied","status":"assigned"},{"alpha2":"PT","alpha3":"PRT","countryCallingCodes":["+351"],"currencies":["EUR"],"emoji":"🇵🇹","ioc":"POR","languages":["por"],"name":"Portugal","status":"assigned"},{"alpha2":"PU","alpha3":"PUS","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"U.S. Miscellaneous Pacific Islands","status":"deleted"},{"alpha2":"PW","alpha3":"PLW","countryCallingCodes":["+680"],"currencies":["USD"],"emoji":"🇵🇼","ioc":"PLW","languages":["eng"],"name":"Palau","status":"assigned"},{"alpha2":"PY","alpha3":"PRY","countryCallingCodes":["+595"],"currencies":["PYG"],"emoji":"🇵🇾","ioc":"PAR","languages":["spa"],"name":"Paraguay","status":"assigned"},{"alpha2":"PZ","alpha3":"PCZ","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Panama Canal Zone","status":"deleted"},{"alpha2":"QA","alpha3":"QAT","countryCallingCodes":["+974"],"currencies":["QAR"],"emoji":"🇶🇦","ioc":"QAT","languages":["ara"],"name":"Qatar","status":"assigned"},{"alpha2":"RE","alpha3":"REU","countryCallingCodes":["+262"],"currencies":["EUR"],"emoji":"🇷🇪","ioc":"","languages":["fra"],"name":"Reunion","status":"assigned"},{"alpha2":"RH","alpha3":"RHO","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Southern Rhodesia","status":"deleted"},{"alpha2":"RO","alpha3":"ROU","countryCallingCodes":["+40"],"currencies":["RON"],"emoji":"🇷🇴","ioc":"ROU","languages":["ron"],"name":"Romania","status":"assigned"},{"alpha2":"RS","alpha3":"SRB","countryCallingCodes":["+381"],"currencies":["RSD"],"emoji":"🇷🇸","ioc":"SRB","languages":["srp"],"name":"Serbia","status":"assigned"},{"alpha2":"RU","alpha3":"RUS","countryCallingCodes":["+7","+7 3","+7 4","+7 8"],"currencies":["RUB"],"emoji":"🇷🇺","ioc":"RUS","languages":["rus"],"name":"Russian Federation","status":"assigned"},{"alpha2":"RW","alpha3":"RWA","countryCallingCodes":["+250"],"currencies":["RWF"],"emoji":"🇷🇼","ioc":"RWA","languages":["eng","fra","kin"],"name":"Rwanda","status":"assigned"},{"alpha2":"SA","alpha3":"SAU","countryCallingCodes":["+966"],"currencies":["SAR"],"emoji":"🇸🇦","ioc":"KSA","languages":["ara"],"name":"Saudi Arabia","status":"assigned"},{"alpha2":"SB","alpha3":"SLB","countryCallingCodes":["+677"],"currencies":["SBD"],"emoji":"🇸🇧","ioc":"SOL","languages":["eng"],"name":"Solomon Islands","status":"assigned"},{"alpha2":"SC","alpha3":"SYC","countryCallingCodes":["+248"],"currencies":["SCR"],"emoji":"🇸🇨","ioc":"SEY","languages":["eng","fra"],"name":"Seychelles","status":"assigned"},{"alpha2":"SD","alpha3":"SDN","countryCallingCodes":["+249"],"currencies":["SDG"],"emoji":"🇸🇩","ioc":"SUD","languages":["ara","eng"],"name":"Sudan","status":"assigned"},{"alpha2":"SE","alpha3":"SWE","countryCallingCodes":["+46"],"currencies":["SEK"],"emoji":"🇸🇪","ioc":"SWE","languages":["swe"],"name":"Sweden","status":"assigned"},{"alpha2":"SG","alpha3":"SGP","countryCallingCodes":["+65"],"currencies":["SGD"],"emoji":"🇸🇬","ioc":"SIN","languages":["eng","zho","msa","tam"],"name":"Singapore","status":"assigned"},{"alpha2":"SH","alpha3":"SHN","countryCallingCodes":["+290"],"currencies":["SHP"],"emoji":"🇸🇭","ioc":"","languages":["eng"],"name":"Saint Helena, Ascension And Tristan Da Cunha","status":"assigned"},{"alpha2":"SI","alpha3":"SVN","countryCallingCodes":["+386"],"currencies":["EUR"],"emoji":"🇸🇮","ioc":"SLO","languages":["slv"],"name":"Slovenia","status":"assigned"},{"alpha2":"SJ","alpha3":"SJM","countryCallingCodes":["+47"],"currencies":["NOK"],"emoji":"🇸🇯","ioc":"","languages":[],"name":"Svalbard And Jan Mayen","status":"assigned"},{"alpha2":"SK","alpha3":"SVK","countryCallingCodes":["+421"],"currencies":["EUR"],"emoji":"🇸🇰","ioc":"SVK","languages":["slk"],"name":"Slovakia","status":"assigned"},{"alpha2":"SK","alpha3":"SKM","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Sikkim","status":"deleted"},{"alpha2":"SL","alpha3":"SLE","countryCallingCodes":["+232"],"currencies":["SLL"],"emoji":"🇸🇱","ioc":"SLE","languages":["eng"],"name":"Sierra Leone","status":"assigned"},{"alpha2":"SM","alpha3":"SMR","countryCallingCodes":["+378"],"currencies":["EUR"],"emoji":"🇸🇲","ioc":"SMR","languages":["ita"],"name":"San Marino","status":"assigned"},{"alpha2":"SN","alpha3":"SEN","countryCallingCodes":["+221"],"currencies":["XOF"],"emoji":"🇸🇳","ioc":"SEN","languages":["fra"],"name":"Senegal","status":"assigned"},{"alpha2":"SO","alpha3":"SOM","countryCallingCodes":["+252"],"currencies":["SOS"],"emoji":"🇸🇴","ioc":"SOM","languages":["som"],"name":"Somalia","status":"assigned"},{"alpha2":"SR","alpha3":"SUR","countryCallingCodes":["+597"],"currencies":["SRD"],"emoji":"🇸🇷","ioc":"SUR","languages":["nld"],"name":"Suriname","status":"assigned"},{"alpha2":"SS","alpha3":"SSD","countryCallingCodes":["+211"],"currencies":["SSP"],"emoji":"🇸🇸","ioc":"SSD","languages":["eng"],"name":"South Sudan","status":"assigned"},{"alpha2":"ST","alpha3":"STP","countryCallingCodes":["+239"],"currencies":["STD"],"emoji":"🇸🇹","ioc":"STP","languages":["por"],"name":"Sao Tome and Principe","status":"assigned"},{"alpha2":"SU","alpha3":"","countryCallingCodes":[],"currencies":["RUB"],"emoji":"","ioc":"","languages":["rus"],"name":"USSR","status":"reserved"},{"alpha2":"SV","alpha3":"SLV","countryCallingCodes":["+503"],"currencies":["USD"],"emoji":"🇸🇻","ioc":"ESA","languages":["spa"],"name":"El Salvador","status":"assigned"},{"alpha2":"SX","alpha3":"SXM","countryCallingCodes":["+1 721"],"currencies":["ANG"],"emoji":"🇸🇽","ioc":"","languages":["nld"],"name":"Sint Maarten","status":"assigned"},{"alpha2":"SY","alpha3":"SYR","countryCallingCodes":["+963"],"currencies":["SYP"],"emoji":"🇸🇾","ioc":"SYR","languages":["ara"],"name":"Syrian Arab Republic","status":"assigned"},{"alpha2":"SZ","alpha3":"SWZ","countryCallingCodes":["+268"],"currencies":["SZL"],"emoji":"🇸🇿","ioc":"SWZ","languages":["eng","ssw"],"name":"Swaziland","status":"assigned"},{"alpha2":"TA","alpha3":"","countryCallingCodes":["+290"],"currencies":["GBP"],"emoji":"","ioc":"","languages":[],"name":"Tristan de Cunha","status":"reserved"},{"alpha2":"TC","alpha3":"TCA","countryCallingCodes":["+1 649"],"currencies":["USD"],"emoji":"🇹🇨","ioc":"","languages":["eng"],"name":"Turks And Caicos Islands","status":"assigned"},{"alpha2":"TD","alpha3":"TCD","countryCallingCodes":["+235"],"currencies":["XAF"],"emoji":"🇹🇩","ioc":"CHA","languages":["ara","fra"],"name":"Chad","status":"assigned"},{"alpha2":"TF","alpha3":"ATF","countryCallingCodes":[],"currencies":["EUR"],"emoji":"🇹🇫","ioc":"","languages":["fra"],"name":"French Southern Territories","status":"assigned"},{"alpha2":"TG","alpha3":"TGO","countryCallingCodes":["+228"],"currencies":["XOF"],"emoji":"🇹🇬","ioc":"TOG","languages":["fra"],"name":"Togo","status":"assigned"},{"alpha2":"TH","alpha3":"THA","countryCallingCodes":["+66"],"currencies":["THB"],"emoji":"🇹🇭","ioc":"THA","languages":["tha"],"name":"Thailand","status":"assigned"},{"alpha2":"TJ","alpha3":"TJK","countryCallingCodes":["+992"],"currencies":["TJS"],"emoji":"🇹🇯","ioc":"TJK","languages":["tgk","rus"],"name":"Tajikistan","status":"assigned"},{"alpha2":"TK","alpha3":"TKL","countryCallingCodes":["+690"],"currencies":["NZD"],"emoji":"🇹🇰","ioc":"","languages":["eng"],"name":"Tokelau","status":"assigned"},{"alpha2":"TL","alpha3":"TLS","countryCallingCodes":["+670"],"currencies":["USD"],"emoji":"🇹🇱","ioc":"TLS","languages":["por"],"name":"Timor-Leste, Democratic Republic of","status":"assigned"},{"alpha2":"TM","alpha3":"TKM","countryCallingCodes":["+993"],"currencies":["TMT"],"emoji":"🇹🇲","ioc":"TKM","languages":["tuk","rus"],"name":"Turkmenistan","status":"assigned"},{"alpha2":"TN","alpha3":"TUN","countryCallingCodes":["+216"],"currencies":["TND"],"emoji":"🇹🇳","ioc":"TUN","languages":["ara"],"name":"Tunisia","status":"assigned"},{"alpha2":"TO","alpha3":"TON","countryCallingCodes":["+676"],"currencies":["TOP"],"emoji":"🇹🇴","ioc":"TGA","languages":["eng"],"name":"Tonga","status":"assigned"},{"alpha2":"TP","alpha3":"TMP","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"East Timor","status":"deleted"},{"alpha2":"TR","alpha3":"TUR","countryCallingCodes":["+90"],"currencies":["TRY"],"emoji":"🇹🇷","ioc":"TUR","languages":["tur"],"name":"Turkey","status":"assigned"},{"alpha2":"TT","alpha3":"TTO","countryCallingCodes":["+1 868"],"currencies":["TTD"],"emoji":"🇹🇹","ioc":"TTO","languages":["eng"],"name":"Trinidad And Tobago","status":"assigned"},{"alpha2":"TV","alpha3":"TUV","countryCallingCodes":["+688"],"currencies":["AUD"],"emoji":"🇹🇻","ioc":"TUV","languages":["eng"],"name":"Tuvalu","status":"assigned"},{"alpha2":"TW","alpha3":"TWN","countryCallingCodes":["+886"],"currencies":["TWD"],"emoji":"🇹🇼","ioc":"TPE","languages":["zho"],"name":"Taiwan","status":"assigned"},{"alpha2":"TZ","alpha3":"TZA","countryCallingCodes":["+255"],"currencies":["TZS"],"emoji":"🇹🇿","ioc":"TAN","languages":["swa","eng"],"name":"Tanzania, United Republic Of","status":"assigned"},{"alpha2":"UA","alpha3":"UKR","countryCallingCodes":["+380"],"currencies":["UAH"],"emoji":"🇺🇦","ioc":"UKR","languages":["ukr","rus"],"name":"Ukraine","status":"assigned"},{"alpha2":"UG","alpha3":"UGA","countryCallingCodes":["+256"],"currencies":["UGX"],"emoji":"🇺🇬","ioc":"UGA","languages":["eng","swa"],"name":"Uganda","status":"assigned"},{"alpha2":"UK","alpha3":"","countryCallingCodes":[],"currencies":["GBP"],"emoji":"","ioc":"","languages":["eng","cor","gle","gla","cym"],"name":"United Kingdom","status":"reserved"},{"alpha2":"UM","alpha3":"UMI","countryCallingCodes":["+1"],"currencies":["USD"],"emoji":"🇺🇲","ioc":"","languages":["eng"],"name":"United States Minor Outlying Islands","status":"assigned"},{"alpha2":"US","alpha3":"USA","countryCallingCodes":["+1"],"currencies":["USD"],"emoji":"🇺🇸","ioc":"USA","languages":["eng"],"name":"United States","status":"assigned"},{"alpha2":"UY","alpha3":"URY","countryCallingCodes":["+598"],"currencies":["UYU","UYI"],"emoji":"🇺🇾","ioc":"URU","languages":["spa"],"name":"Uruguay","status":"assigned"},{"alpha2":"UZ","alpha3":"UZB","countryCallingCodes":["+998"],"currencies":["UZS"],"emoji":"🇺🇿","ioc":"UZB","languages":["uzb","rus"],"name":"Uzbekistan","status":"assigned"},{"alpha2":"VA","alpha3":"VAT","countryCallingCodes":["+379","+39"],"currencies":["EUR"],"emoji":"🇻🇦","ioc":"","languages":["ita"],"name":"Vatican City State","status":"assigned"},{"alpha2":"VC","alpha3":"VCT","countryCallingCodes":["+1 784"],"currencies":["XCD"],"emoji":"🇻🇨","ioc":"VIN","languages":["eng"],"name":"Saint Vincent And The Grenadines","status":"assigned"},{"alpha2":"VD","alpha3":"VDR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Viet-Nam, Democratic Republic of","status":"deleted"},{"alpha2":"VE","alpha3":"VEN","countryCallingCodes":["+58"],"currencies":["VEF"],"emoji":"🇻🇪","ioc":"VEN","languages":["spa"],"name":"Venezuela, Bolivarian Republic Of","status":"assigned"},{"alpha2":"VG","alpha3":"VGB","countryCallingCodes":["+1 284"],"currencies":["USD"],"emoji":"🇻🇬","ioc":"IVB","languages":["eng"],"name":"Virgin Islands (British)","status":"assigned"},{"alpha2":"VI","alpha3":"VIR","countryCallingCodes":["+1 340"],"currencies":["USD"],"emoji":"🇻🇮","ioc":"ISV","languages":["eng"],"name":"Virgin Islands (US)","status":"assigned"},{"alpha2":"VN","alpha3":"VNM","countryCallingCodes":["+84"],"currencies":["VND"],"emoji":"🇻🇳","ioc":"VIE","languages":["vie"],"name":"Viet Nam","status":"assigned"},{"alpha2":"VU","alpha3":"VUT","countryCallingCodes":["+678"],"currencies":["VUV"],"emoji":"🇻🇺","ioc":"VAN","languages":["bis","eng","fra"],"name":"Vanuatu","status":"assigned"},{"alpha2":"WF","alpha3":"WLF","countryCallingCodes":["+681"],"currencies":["XPF"],"emoji":"🇼🇫","ioc":"","languages":["fra"],"name":"Wallis And Futuna","status":"assigned"},{"alpha2":"WK","alpha3":"WAK","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Wake Island","status":"deleted"},{"alpha2":"WS","alpha3":"WSM","countryCallingCodes":["+685"],"currencies":["WST"],"emoji":"🇼🇸","ioc":"SAM","languages":["eng","smo"],"name":"Samoa","status":"assigned"},{"alpha2":"XK","alpha3":"","countryCallingCodes":["+383"],"currencies":["EUR"],"emoji":"","ioc":"KOS","languages":["sqi","srp","bos","tur","rom"],"name":"Kosovo","status":"user assigned"},{"alpha2":"YD","alpha3":"YMD","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Yemen, Democratic","status":"deleted"},{"alpha2":"YE","alpha3":"YEM","countryCallingCodes":["+967"],"currencies":["YER"],"emoji":"🇾🇪","ioc":"YEM","languages":["ara"],"name":"Yemen","status":"assigned"},{"alpha2":"YT","alpha3":"MYT","countryCallingCodes":["+262"],"currencies":["EUR"],"emoji":"🇾🇹","ioc":"","languages":["fra"],"name":"Mayotte","status":"assigned"},{"alpha2":"YU","alpha3":"YUG","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Yugoslavia","status":"deleted"},{"alpha2":"ZA","alpha3":"ZAF","countryCallingCodes":["+27"],"currencies":["ZAR"],"emoji":"🇿🇦","ioc":"RSA","languages":["afr","eng","nbl","som","tso","ven","xho","zul"],"name":"South Africa","status":"assigned"},{"alpha2":"ZM","alpha3":"ZMB","countryCallingCodes":["+260"],"currencies":["ZMW"],"emoji":"🇿🇲","ioc":"ZAM","languages":["eng"],"name":"Zambia","status":"assigned"},{"alpha2":"ZR","alpha3":"ZAR","countryCallingCodes":[],"currencies":[],"ioc":"","languages":[],"name":"Zaire","status":"deleted"},{"alpha2":"ZW","alpha3":"ZWE","countryCallingCodes":["+263"],"currencies":["USD","ZAR","BWP","GBP","EUR"],"emoji":"🇿🇼","ioc":"ZIM","languages":["eng","sna","nde"],"name":"Zimbabwe","status":"assigned"}]

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = [{"code":"AED","decimals":2,"name":"United Arab Emirates dirham","number":"784"},{"code":"AFN","decimals":2,"name":"Afghan afghani","number":"971"},{"code":"ALL","decimals":2,"name":"Albanian lek","number":"8"},{"code":"AMD","decimals":2,"name":"Armenian dram","number":"51"},{"code":"ANG","decimals":2,"name":"Netherlands Antillean guilder","number":"532"},{"code":"AOA","decimals":2,"name":"Angolan kwanza","number":"973"},{"code":"ARS","decimals":2,"name":"Argentine peso","number":"32"},{"code":"AUD","decimals":2,"name":"Australian dollar","number":"36"},{"code":"AWG","decimals":2,"name":"Aruban florin","number":"533"},{"code":"AZN","decimals":2,"name":"Azerbaijani manat","number":"944"},{"code":"BAM","decimals":2,"name":"Bosnia and Herzegovina convertible mark","number":"977"},{"code":"BBD","decimals":2,"name":"Barbados dollar","number":"52"},{"code":"BDT","decimals":2,"name":"Bangladeshi taka","number":"50"},{"code":"BGN","decimals":2,"name":"Bulgarian lev","number":"975"},{"code":"BHD","decimals":3,"name":"Bahraini dinar","number":"48"},{"code":"BIF","decimals":0,"name":"Burundian franc","number":"108"},{"code":"BMD","decimals":2,"name":"Bermudian dollar (customarily known as Bermuda dollar)","number":"60"},{"code":"BND","decimals":2,"name":"Brunei dollar","number":"96"},{"code":"BOB","decimals":2,"name":"Boliviano","number":"68"},{"code":"BOV","decimals":2,"name":"Bolivian Mvdol (funds code)","number":"984"},{"code":"BRL","decimals":2,"name":"Brazilian real","number":"986"},{"code":"BSD","decimals":2,"name":"Bahamian dollar","number":"44"},{"code":"BTN","decimals":2,"name":"Bhutanese ngultrum","number":"64"},{"code":"BWP","decimals":2,"name":"Botswana pula","number":"72"},{"code":"BYR","decimals":0,"name":"Belarusian ruble","number":"974"},{"code":"BZD","decimals":2,"name":"Belize dollar","number":"84"},{"code":"CAD","decimals":2,"name":"Canadian dollar","number":"124"},{"code":"CDF","decimals":2,"name":"Congolese franc","number":"976"},{"code":"CHE","decimals":2,"name":"WIR Euro (complementary currency)","number":"947"},{"code":"CHF","decimals":2,"name":"Swiss franc","number":"756"},{"code":"CHW","decimals":2,"name":"WIR Franc (complementary currency)","number":"948"},{"code":"CLF","decimals":0,"name":"Unidad de Fomento (funds code)","number":"990"},{"code":"CLP","decimals":0,"name":"Chilean peso","number":"152"},{"code":"CNY","decimals":2,"name":"Chinese yuan","number":"156"},{"code":"COP","decimals":2,"name":"Colombian peso","number":"170"},{"code":"COU","decimals":2,"name":"Unidad de Valor Real","number":"970"},{"code":"CRC","decimals":2,"name":"Costa Rican colon","number":"188"},{"code":"CUC","decimals":2,"name":"Cuban convertible peso","number":"931"},{"code":"CUP","decimals":2,"name":"Cuban peso","number":"192"},{"code":"CVE","decimals":0,"name":"Cape Verde escudo","number":"132"},{"code":"CZK","decimals":2,"name":"Czech koruna","number":"203"},{"code":"DJF","decimals":0,"name":"Djiboutian franc","number":"262"},{"code":"DKK","decimals":2,"name":"Danish krone","number":"208"},{"code":"DOP","decimals":2,"name":"Dominican peso","number":"214"},{"code":"DZD","decimals":2,"name":"Algerian dinar","number":"12"},{"code":"EGP","decimals":2,"name":"Egyptian pound","number":"818"},{"code":"ERN","decimals":2,"name":"Eritrean nakfa","number":"232"},{"code":"ETB","decimals":2,"name":"Ethiopian birr","number":"230"},{"code":"EUR","decimals":2,"name":"Euro","number":"978"},{"code":"FJD","decimals":2,"name":"Fiji dollar","number":"242"},{"code":"FKP","decimals":2,"name":"Falkland Islands pound","number":"238"},{"code":"GBP","decimals":2,"name":"Pound sterling","number":"826"},{"code":"GEL","decimals":2,"name":"Georgian lari","number":"981"},{"code":"GHS","decimals":2,"name":"Ghanaian cedi","number":"936"},{"code":"GIP","decimals":2,"name":"Gibraltar pound","number":"292"},{"code":"GMD","decimals":2,"name":"Gambian dalasi","number":"270"},{"code":"GNF","decimals":0,"name":"Guinean franc","number":"324"},{"code":"GTQ","decimals":2,"name":"Guatemalan quetzal","number":"320"},{"code":"GYD","decimals":2,"name":"Guyanese dollar","number":"328"},{"code":"HKD","decimals":2,"name":"Hong Kong dollar","number":"344"},{"code":"HNL","decimals":2,"name":"Honduran lempira","number":"340"},{"code":"HRK","decimals":2,"name":"Croatian kuna","number":"191"},{"code":"HTG","decimals":2,"name":"Haitian gourde","number":"332"},{"code":"HUF","decimals":2,"name":"Hungarian forint","number":"348"},{"code":"IDR","decimals":2,"name":"Indonesian rupiah","number":"360"},{"code":"ILS","decimals":2,"name":"Israeli new shekel","number":"376"},{"code":"INR","decimals":2,"name":"Indian rupee","number":"356"},{"code":"IQD","decimals":3,"name":"Iraqi dinar","number":"368"},{"code":"IRR","decimals":0,"name":"Iranian rial","number":"364"},{"code":"ISK","decimals":0,"name":"Icelandic króna","number":"352"},{"code":"JMD","decimals":2,"name":"Jamaican dollar","number":"388"},{"code":"JOD","decimals":3,"name":"Jordanian dinar","number":"400"},{"code":"JPY","decimals":0,"name":"Japanese yen","number":"392"},{"code":"KES","decimals":2,"name":"Kenyan shilling","number":"404"},{"code":"KGS","decimals":2,"name":"Kyrgyzstani som","number":"417"},{"code":"KHR","decimals":2,"name":"Cambodian riel","number":"116"},{"code":"KMF","decimals":0,"name":"Comoro franc","number":"174"},{"code":"KPW","decimals":0,"name":"North Korean won","number":"408"},{"code":"KRW","decimals":0,"name":"South Korean won","number":"410"},{"code":"KWD","decimals":3,"name":"Kuwaiti dinar","number":"414"},{"code":"KYD","decimals":2,"name":"Cayman Islands dollar","number":"136"},{"code":"KZT","decimals":2,"name":"Kazakhstani tenge","number":"398"},{"code":"LAK","decimals":0,"name":"Lao kip","number":"418"},{"code":"LBP","decimals":0,"name":"Lebanese pound","number":"422"},{"code":"LKR","decimals":2,"name":"Sri Lankan rupee","number":"144"},{"code":"LRD","decimals":2,"name":"Liberian dollar","number":"430"},{"code":"LSL","decimals":2,"name":"Lesotho loti","number":"426"},{"code":"LTL","decimals":2,"name":"Lithuanian litas","number":"440"},{"code":"LVL","decimals":2,"name":"Latvian lats","number":"428"},{"code":"LYD","decimals":3,"name":"Libyan dinar","number":"434"},{"code":"MAD","decimals":2,"name":"Moroccan dirham","number":"504"},{"code":"MDL","decimals":2,"name":"Moldovan leu","number":"498"},{"code":"MGA","decimals":0,"name":"Malagasy ariary","number":"969"},{"code":"MKD","decimals":0,"name":"Macedonian denar","number":"807"},{"code":"MMK","decimals":0,"name":"Myanma kyat","number":"104"},{"code":"MNT","decimals":2,"name":"Mongolian tugrik","number":"496"},{"code":"MOP","decimals":2,"name":"Macanese pataca","number":"446"},{"code":"MRO","decimals":0,"name":"Mauritanian ouguiya","number":"478"},{"code":"MUR","decimals":2,"name":"Mauritian rupee","number":"480"},{"code":"MVR","decimals":2,"name":"Maldivian rufiyaa","number":"462"},{"code":"MWK","decimals":2,"name":"Malawian kwacha","number":"454"},{"code":"MXN","decimals":2,"name":"Mexican peso","number":"484"},{"code":"MXV","decimals":2,"name":"Mexican Unidad de Inversion (UDI) (funds code)","number":"979"},{"code":"MYR","decimals":2,"name":"Malaysian ringgit","number":"458"},{"code":"MZN","decimals":2,"name":"Mozambican metical","number":"943"},{"code":"NAD","decimals":2,"name":"Namibian dollar","number":"516"},{"code":"NGN","decimals":2,"name":"Nigerian naira","number":"566"},{"code":"NIO","decimals":2,"name":"Nicaraguan córdoba","number":"558"},{"code":"NOK","decimals":2,"name":"Norwegian krone","number":"578"},{"code":"NPR","decimals":2,"name":"Nepalese rupee","number":"524"},{"code":"NZD","decimals":2,"name":"New Zealand dollar","number":"554"},{"code":"OMR","decimals":3,"name":"Omani rial","number":"512"},{"code":"PAB","decimals":2,"name":"Panamanian balboa","number":"590"},{"code":"PEN","decimals":2,"name":"Peruvian nuevo sol","number":"604"},{"code":"PGK","decimals":2,"name":"Papua New Guinean kina","number":"598"},{"code":"PHP","decimals":2,"name":"Philippine peso","number":"608"},{"code":"PKR","decimals":2,"name":"Pakistani rupee","number":"586"},{"code":"PLN","decimals":2,"name":"Polish złoty","number":"985"},{"code":"PYG","decimals":0,"name":"Paraguayan guaraní","number":"600"},{"code":"QAR","decimals":2,"name":"Qatari riyal","number":"634"},{"code":"RON","decimals":2,"name":"Romanian new leu","number":"946"},{"code":"RSD","decimals":2,"name":"Serbian dinar","number":"941"},{"code":"RUB","decimals":2,"name":"Russian rouble","number":"643"},{"code":"RWF","decimals":0,"name":"Rwandan franc","number":"646"},{"code":"SAR","decimals":2,"name":"Saudi riyal","number":"682"},{"code":"SBD","decimals":2,"name":"Solomon Islands dollar","number":"90"},{"code":"SCR","decimals":2,"name":"Seychelles rupee","number":"690"},{"code":"SDG","decimals":2,"name":"Sudanese pound","number":"938"},{"code":"SEK","decimals":2,"name":"Swedish krona/kronor","number":"752"},{"code":"SGD","decimals":2,"name":"Singapore dollar","number":"702"},{"code":"SHP","decimals":2,"name":"Saint Helena pound","number":"654"},{"code":"SLL","decimals":0,"name":"Sierra Leonean leone","number":"694"},{"code":"SOS","decimals":2,"name":"Somali shilling","number":"706"},{"code":"SRD","decimals":2,"name":"Surinamese dollar","number":"968"},{"code":"SSP","decimals":2,"name":"South Sudanese pound","number":"728"},{"code":"STD","decimals":0,"name":"São Tomé and Príncipe dobra","number":"678"},{"code":"SYP","decimals":2,"name":"Syrian pound","number":"760"},{"code":"SZL","decimals":2,"name":"Swazi lilangeni","number":"748"},{"code":"THB","decimals":2,"name":"Thai baht","number":"764"},{"code":"TJS","decimals":2,"name":"Tajikistani somoni","number":"972"},{"code":"TMT","decimals":2,"name":"Turkmenistani manat","number":"934"},{"code":"TND","decimals":3,"name":"Tunisian dinar","number":"788"},{"code":"TOP","decimals":2,"name":"Tongan paʻanga","number":"776"},{"code":"TRY","decimals":2,"name":"Turkish lira","number":"949"},{"code":"TTD","decimals":2,"name":"Trinidad and Tobago dollar","number":"780"},{"code":"TWD","decimals":2,"name":"New Taiwan dollar","number":"901"},{"code":"TZS","decimals":2,"name":"Tanzanian shilling","number":"834"},{"code":"UAH","decimals":2,"name":"Ukrainian hryvnia","number":"980"},{"code":"UGX","decimals":2,"name":"Ugandan shilling","number":"800"},{"code":"USD","decimals":2,"name":"United States dollar","number":"840"},{"code":"USN","decimals":2,"name":"United States dollar (next day) (funds code)","number":"997"},{"code":"USS","decimals":2,"name":"United States dollar (same day) (funds code) (one source[who?] claims it is no longer used, but it is still on the ISO 4217-MA list)","number":"998"},{"code":"UYI","decimals":0,"name":"Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)","number":"940"},{"code":"UYU","decimals":2,"name":"Uruguayan peso","number":"858"},{"code":"UZS","decimals":2,"name":"Uzbekistan som","number":"860"},{"code":"VEF","decimals":2,"name":"Venezuelan bolívar fuerte","number":"937"},{"code":"VND","decimals":0,"name":"Vietnamese dong","number":"704"},{"code":"VUV","decimals":0,"name":"Vanuatu vatu","number":"548"},{"code":"WST","decimals":2,"name":"Samoan tala","number":"882"},{"code":"XAF","decimals":0,"name":"CFA franc BEAC","number":"950"},{"code":"XAG","decimals":null,"name":"Silver (one troy ounce)","number":"961"},{"code":"XAU","decimals":null,"name":"Gold (one troy ounce)","number":"959"},{"code":"XBA","decimals":null,"name":"European Composite Unit (EURCO) (bond market unit)","number":"955"},{"code":"XBB","decimals":null,"name":"European Monetary Unit (E.M.U.-6) (bond market unit)","number":"956"},{"code":"XBC","decimals":null,"name":"European Unit of Account 9 (E.U.A.-9) (bond market unit)","number":"957"},{"code":"XBD","decimals":null,"name":"European Unit of Account 17 (E.U.A.-17) (bond market unit)","number":"958"},{"code":"XCD","decimals":2,"name":"East Caribbean dollar","number":"951"},{"code":"XDR","decimals":null,"name":"Special drawing rights","number":"960"},{"code":"XFU","decimals":null,"name":"UIC franc (special settlement currency)","number":"Nil"},{"code":"XOF","decimals":0,"name":"CFA franc BCEAO","number":"952"},{"code":"XPD","decimals":null,"name":"Palladium (one troy ounce)","number":"964"},{"code":"XPF","decimals":0,"name":"CFP franc","number":"953"},{"code":"XPT","decimals":null,"name":"Platinum (one troy ounce)","number":"962"},{"code":"XTS","decimals":null,"name":"Code reserved for testing purposes","number":"963"},{"code":"XXX","decimals":null,"name":"No currency","number":"999"},{"code":"YER","decimals":2,"name":"Yemeni rial","number":"886"},{"code":"ZAR","decimals":2,"name":"South African rand","number":"710"},{"code":"ZMW","decimals":2,"name":"Zambian kwacha","number":"967"}]

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = [{"alpha2":"aa","alpha3":"aar","bibliographic":"","name":"Afar"},{"alpha2":"ab","alpha3":"abk","bibliographic":"","name":"Abkhazian"},{"alpha2":"","alpha3":"ace","bibliographic":"","name":"Achinese"},{"alpha2":"","alpha3":"ach","bibliographic":"","name":"Acoli"},{"alpha2":"","alpha3":"ada","bibliographic":"","name":"Adangme"},{"alpha2":"","alpha3":"ady","bibliographic":"","name":"Adygei"},{"alpha2":"","alpha3":"ady","bibliographic":"","name":"Adyghe"},{"alpha2":"","alpha3":"afa","bibliographic":"","name":"Afro-Asiatic languages"},{"alpha2":"","alpha3":"afh","bibliographic":"","name":"Afrihili"},{"alpha2":"af","alpha3":"afr","bibliographic":"","name":"Afrikaans"},{"alpha2":"","alpha3":"ain","bibliographic":"","name":"Ainu"},{"alpha2":"ak","alpha3":"aka","bibliographic":"","name":"Akan"},{"alpha2":"","alpha3":"akk","bibliographic":"","name":"Akkadian"},{"alpha2":"","alpha3":"ale","bibliographic":"","name":"Aleut"},{"alpha2":"","alpha3":"alg","bibliographic":"","name":"Algonquian languages"},{"alpha2":"","alpha3":"alt","bibliographic":"","name":"Southern Altai"},{"alpha2":"am","alpha3":"amh","bibliographic":"","name":"Amharic"},{"alpha2":"","alpha3":"ang","bibliographic":"","name":"English, Old (ca.450-1100)"},{"alpha2":"","alpha3":"anp","bibliographic":"","name":"Angika"},{"alpha2":"","alpha3":"apa","bibliographic":"","name":"Apache languages"},{"alpha2":"ar","alpha3":"ara","bibliographic":"","name":"Arabic"},{"alpha2":"","alpha3":"arc","bibliographic":"","name":"Imperial Aramaic (700-300 BCE)"},{"alpha2":"","alpha3":"arc","bibliographic":"","name":"Official Aramaic (700-300 BCE)"},{"alpha2":"an","alpha3":"arg","bibliographic":"","name":"Aragonese"},{"alpha2":"","alpha3":"arn","bibliographic":"","name":"Mapuche"},{"alpha2":"","alpha3":"arn","bibliographic":"","name":"Mapudungun"},{"alpha2":"","alpha3":"arp","bibliographic":"","name":"Arapaho"},{"alpha2":"","alpha3":"art","bibliographic":"","name":"Artificial languages"},{"alpha2":"","alpha3":"arw","bibliographic":"","name":"Arawak"},{"alpha2":"as","alpha3":"asm","bibliographic":"","name":"Assamese"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Asturian"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Asturleonese"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Bable"},{"alpha2":"","alpha3":"ast","bibliographic":"","name":"Leonese"},{"alpha2":"","alpha3":"ath","bibliographic":"","name":"Athapascan languages"},{"alpha2":"","alpha3":"aus","bibliographic":"","name":"Australian languages"},{"alpha2":"av","alpha3":"ava","bibliographic":"","name":"Avaric"},{"alpha2":"ae","alpha3":"ave","bibliographic":"","name":"Avestan"},{"alpha2":"","alpha3":"awa","bibliographic":"","name":"Awadhi"},{"alpha2":"ay","alpha3":"aym","bibliographic":"","name":"Aymara"},{"alpha2":"az","alpha3":"aze","bibliographic":"","name":"Azerbaijani"},{"alpha2":"","alpha3":"bad","bibliographic":"","name":"Banda languages"},{"alpha2":"","alpha3":"bai","bibliographic":"","name":"Bamileke languages"},{"alpha2":"ba","alpha3":"bak","bibliographic":"","name":"Bashkir"},{"alpha2":"","alpha3":"bal","bibliographic":"","name":"Baluchi"},{"alpha2":"bm","alpha3":"bam","bibliographic":"","name":"Bambara"},{"alpha2":"","alpha3":"ban","bibliographic":"","name":"Balinese"},{"alpha2":"","alpha3":"bas","bibliographic":"","name":"Basa"},{"alpha2":"","alpha3":"bat","bibliographic":"","name":"Baltic languages"},{"alpha2":"","alpha3":"bej","bibliographic":"","name":"Bedawiyet"},{"alpha2":"","alpha3":"bej","bibliographic":"","name":"Beja"},{"alpha2":"be","alpha3":"bel","bibliographic":"","name":"Belarusian"},{"alpha2":"","alpha3":"bem","bibliographic":"","name":"Bemba"},{"alpha2":"bn","alpha3":"ben","bibliographic":"","name":"Bengali"},{"alpha2":"","alpha3":"ber","bibliographic":"","name":"Berber languages"},{"alpha2":"","alpha3":"bho","bibliographic":"","name":"Bhojpuri"},{"alpha2":"bh","alpha3":"bih","bibliographic":"","name":"Bihari languages"},{"alpha2":"","alpha3":"bik","bibliographic":"","name":"Bikol"},{"alpha2":"","alpha3":"bin","bibliographic":"","name":"Bini"},{"alpha2":"","alpha3":"bin","bibliographic":"","name":"Edo"},{"alpha2":"bi","alpha3":"bis","bibliographic":"","name":"Bislama"},{"alpha2":"","alpha3":"bla","bibliographic":"","name":"Siksika"},{"alpha2":"","alpha3":"bnt","bibliographic":"","name":"Bantu languages"},{"alpha2":"bo","alpha3":"bod","bibliographic":"tib","name":"Tibetan"},{"alpha2":"bs","alpha3":"bos","bibliographic":"","name":"Bosnian"},{"alpha2":"","alpha3":"bra","bibliographic":"","name":"Braj"},{"alpha2":"br","alpha3":"bre","bibliographic":"","name":"Breton"},{"alpha2":"","alpha3":"btk","bibliographic":"","name":"Batak languages"},{"alpha2":"","alpha3":"bua","bibliographic":"","name":"Buriat"},{"alpha2":"","alpha3":"bug","bibliographic":"","name":"Buginese"},{"alpha2":"bg","alpha3":"bul","bibliographic":"","name":"Bulgarian"},{"alpha2":"","alpha3":"byn","bibliographic":"","name":"Bilin"},{"alpha2":"","alpha3":"byn","bibliographic":"","name":"Blin"},{"alpha2":"","alpha3":"cad","bibliographic":"","name":"Caddo"},{"alpha2":"","alpha3":"cai","bibliographic":"","name":"Central American Indian languages"},{"alpha2":"","alpha3":"car","bibliographic":"","name":"Galibi Carib"},{"alpha2":"ca","alpha3":"cat","bibliographic":"","name":"Catalan"},{"alpha2":"ca","alpha3":"cat","bibliographic":"","name":"Valencian"},{"alpha2":"","alpha3":"cau","bibliographic":"","name":"Caucasian languages"},{"alpha2":"","alpha3":"ceb","bibliographic":"","name":"Cebuano"},{"alpha2":"","alpha3":"cel","bibliographic":"","name":"Celtic languages"},{"alpha2":"cs","alpha3":"ces","bibliographic":"cze","name":"Czech"},{"alpha2":"ch","alpha3":"cha","bibliographic":"","name":"Chamorro"},{"alpha2":"","alpha3":"chb","bibliographic":"","name":"Chibcha"},{"alpha2":"ce","alpha3":"che","bibliographic":"","name":"Chechen"},{"alpha2":"","alpha3":"chg","bibliographic":"","name":"Chagatai"},{"alpha2":"","alpha3":"chk","bibliographic":"","name":"Chuukese"},{"alpha2":"","alpha3":"chm","bibliographic":"","name":"Mari"},{"alpha2":"","alpha3":"chn","bibliographic":"","name":"Chinook jargon"},{"alpha2":"","alpha3":"cho","bibliographic":"","name":"Choctaw"},{"alpha2":"","alpha3":"chp","bibliographic":"","name":"Chipewyan"},{"alpha2":"","alpha3":"chp","bibliographic":"","name":"Dene Suline"},{"alpha2":"","alpha3":"chr","bibliographic":"","name":"Cherokee"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Church Slavic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Church Slavonic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Bulgarian"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Church Slavonic"},{"alpha2":"cu","alpha3":"chu","bibliographic":"","name":"Old Slavonic"},{"alpha2":"cv","alpha3":"chv","bibliographic":"","name":"Chuvash"},{"alpha2":"","alpha3":"chy","bibliographic":"","name":"Cheyenne"},{"alpha2":"","alpha3":"cmc","bibliographic":"","name":"Chamic languages"},{"alpha2":"","alpha3":"cop","bibliographic":"","name":"Coptic"},{"alpha2":"kw","alpha3":"cor","bibliographic":"","name":"Cornish"},{"alpha2":"co","alpha3":"cos","bibliographic":"","name":"Corsican"},{"alpha2":"","alpha3":"cpe","bibliographic":"","name":"Creoles and pidgins, English based"},{"alpha2":"","alpha3":"cpf","bibliographic":"","name":"Creoles and pidgins, French-based"},{"alpha2":"","alpha3":"cpp","bibliographic":"","name":"Creoles and pidgins, Portuguese-based"},{"alpha2":"cr","alpha3":"cre","bibliographic":"","name":"Cree"},{"alpha2":"","alpha3":"crh","bibliographic":"","name":"Crimean Tatar"},{"alpha2":"","alpha3":"crh","bibliographic":"","name":"Crimean Turkish"},{"alpha2":"","alpha3":"crp","bibliographic":"","name":"Creoles and pidgins"},{"alpha2":"","alpha3":"csb","bibliographic":"","name":"Kashubian"},{"alpha2":"","alpha3":"cus","bibliographic":"","name":"Cushitic languages"},{"alpha2":"cy","alpha3":"cym","bibliographic":"wel","name":"Welsh"},{"alpha2":"","alpha3":"dak","bibliographic":"","name":"Dakota"},{"alpha2":"da","alpha3":"dan","bibliographic":"","name":"Danish"},{"alpha2":"","alpha3":"dar","bibliographic":"","name":"Dargwa"},{"alpha2":"","alpha3":"day","bibliographic":"","name":"Land Dayak languages"},{"alpha2":"","alpha3":"del","bibliographic":"","name":"Delaware"},{"alpha2":"","alpha3":"den","bibliographic":"","name":"Slave (Athapascan)"},{"alpha2":"de","alpha3":"deu","bibliographic":"ger","name":"German"},{"alpha2":"","alpha3":"dgr","bibliographic":"","name":"Dogrib"},{"alpha2":"","alpha3":"din","bibliographic":"","name":"Dinka"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Dhivehi"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Divehi"},{"alpha2":"dv","alpha3":"div","bibliographic":"","name":"Maldivian"},{"alpha2":"","alpha3":"doi","bibliographic":"","name":"Dogri"},{"alpha2":"","alpha3":"dra","bibliographic":"","name":"Dravidian languages"},{"alpha2":"","alpha3":"dsb","bibliographic":"","name":"Lower Sorbian"},{"alpha2":"","alpha3":"dua","bibliographic":"","name":"Duala"},{"alpha2":"","alpha3":"dum","bibliographic":"","name":"Dutch, Middle (ca.1050-1350)"},{"alpha2":"","alpha3":"dyu","bibliographic":"","name":"Dyula"},{"alpha2":"dz","alpha3":"dzo","bibliographic":"","name":"Dzongkha"},{"alpha2":"","alpha3":"efi","bibliographic":"","name":"Efik"},{"alpha2":"","alpha3":"egy","bibliographic":"","name":"Egyptian (Ancient)"},{"alpha2":"","alpha3":"eka","bibliographic":"","name":"Ekajuk"},{"alpha2":"el","alpha3":"ell","bibliographic":"gre","name":"Greek, Modern (1453-)"},{"alpha2":"","alpha3":"elx","bibliographic":"","name":"Elamite"},{"alpha2":"en","alpha3":"eng","bibliographic":"","name":"English"},{"alpha2":"","alpha3":"enm","bibliographic":"","name":"English, Middle (1100-1500)"},{"alpha2":"eo","alpha3":"epo","bibliographic":"","name":"Esperanto"},{"alpha2":"et","alpha3":"est","bibliographic":"","name":"Estonian"},{"alpha2":"eu","alpha3":"eus","bibliographic":"baq","name":"Basque"},{"alpha2":"ee","alpha3":"ewe","bibliographic":"","name":"Ewe"},{"alpha2":"","alpha3":"ewo","bibliographic":"","name":"Ewondo"},{"alpha2":"","alpha3":"fan","bibliographic":"","name":"Fang"},{"alpha2":"fo","alpha3":"fao","bibliographic":"","name":"Faroese"},{"alpha2":"fa","alpha3":"fas","bibliographic":"per","name":"Persian"},{"alpha2":"","alpha3":"fat","bibliographic":"","name":"Fanti"},{"alpha2":"fj","alpha3":"fij","bibliographic":"","name":"Fijian"},{"alpha2":"","alpha3":"fil","bibliographic":"","name":"Filipino"},{"alpha2":"","alpha3":"fil","bibliographic":"","name":"Pilipino"},{"alpha2":"fi","alpha3":"fin","bibliographic":"","name":"Finnish"},{"alpha2":"","alpha3":"fiu","bibliographic":"","name":"Finno-Ugrian languages"},{"alpha2":"","alpha3":"fon","bibliographic":"","name":"Fon"},{"alpha2":"fr","alpha3":"fra","bibliographic":"fre","name":"French"},{"alpha2":"","alpha3":"frm","bibliographic":"","name":"French, Middle (ca.1400-1600)"},{"alpha2":"","alpha3":"fro","bibliographic":"","name":"French, Old (842-ca.1400)"},{"alpha2":"","alpha3":"frr","bibliographic":"","name":"Northern Frisian"},{"alpha2":"","alpha3":"frs","bibliographic":"","name":"Eastern Frisian"},{"alpha2":"fy","alpha3":"fry","bibliographic":"","name":"Western Frisian"},{"alpha2":"ff","alpha3":"ful","bibliographic":"","name":"Fulah"},{"alpha2":"","alpha3":"fur","bibliographic":"","name":"Friulian"},{"alpha2":"","alpha3":"gaa","bibliographic":"","name":"Ga"},{"alpha2":"","alpha3":"gay","bibliographic":"","name":"Gayo"},{"alpha2":"","alpha3":"gba","bibliographic":"","name":"Gbaya"},{"alpha2":"","alpha3":"gem","bibliographic":"","name":"Germanic languages"},{"alpha2":"","alpha3":"gez","bibliographic":"","name":"Geez"},{"alpha2":"","alpha3":"gil","bibliographic":"","name":"Gilbertese"},{"alpha2":"gd","alpha3":"gla","bibliographic":"","name":"Gaelic"},{"alpha2":"gd","alpha3":"gla","bibliographic":"","name":"Scottish Gaelic"},{"alpha2":"ga","alpha3":"gle","bibliographic":"","name":"Irish"},{"alpha2":"gl","alpha3":"glg","bibliographic":"","name":"Galician"},{"alpha2":"gv","alpha3":"glv","bibliographic":"","name":"Manx"},{"alpha2":"","alpha3":"gmh","bibliographic":"","name":"German, Middle High (ca.1050-1500)"},{"alpha2":"","alpha3":"goh","bibliographic":"","name":"German, Old High (ca.750-1050)"},{"alpha2":"","alpha3":"gon","bibliographic":"","name":"Gondi"},{"alpha2":"","alpha3":"gor","bibliographic":"","name":"Gorontalo"},{"alpha2":"","alpha3":"got","bibliographic":"","name":"Gothic"},{"alpha2":"","alpha3":"grb","bibliographic":"","name":"Grebo"},{"alpha2":"","alpha3":"grc","bibliographic":"","name":"Greek, Ancient (to 1453)"},{"alpha2":"gn","alpha3":"grn","bibliographic":"","name":"Guarani"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Alemannic"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Alsatian"},{"alpha2":"","alpha3":"gsw","bibliographic":"","name":"Swiss German"},{"alpha2":"gu","alpha3":"guj","bibliographic":"","name":"Gujarati"},{"alpha2":"","alpha3":"gwi","bibliographic":"","name":"Gwich'in"},{"alpha2":"","alpha3":"hai","bibliographic":"","name":"Haida"},{"alpha2":"ht","alpha3":"hat","bibliographic":"","name":"Haitian"},{"alpha2":"ht","alpha3":"hat","bibliographic":"","name":"Haitian Creole"},{"alpha2":"ha","alpha3":"hau","bibliographic":"","name":"Hausa"},{"alpha2":"","alpha3":"haw","bibliographic":"","name":"Hawaiian"},{"alpha2":"he","alpha3":"heb","bibliographic":"","name":"Hebrew"},{"alpha2":"hz","alpha3":"her","bibliographic":"","name":"Herero"},{"alpha2":"","alpha3":"hil","bibliographic":"","name":"Hiligaynon"},{"alpha2":"","alpha3":"him","bibliographic":"","name":"Himachali languages"},{"alpha2":"","alpha3":"him","bibliographic":"","name":"Western Pahari languages"},{"alpha2":"hi","alpha3":"hin","bibliographic":"","name":"Hindi"},{"alpha2":"","alpha3":"hit","bibliographic":"","name":"Hittite"},{"alpha2":"","alpha3":"hmn","bibliographic":"","name":"Hmong"},{"alpha2":"","alpha3":"hmn","bibliographic":"","name":"Mong"},{"alpha2":"ho","alpha3":"hmo","bibliographic":"","name":"Hiri Motu"},{"alpha2":"hr","alpha3":"hrv","bibliographic":"","name":"Croatian"},{"alpha2":"","alpha3":"hsb","bibliographic":"","name":"Upper Sorbian"},{"alpha2":"hu","alpha3":"hun","bibliographic":"","name":"Hungarian"},{"alpha2":"","alpha3":"hup","bibliographic":"","name":"Hupa"},{"alpha2":"hy","alpha3":"hye","bibliographic":"arm","name":"Armenian"},{"alpha2":"","alpha3":"iba","bibliographic":"","name":"Iban"},{"alpha2":"ig","alpha3":"ibo","bibliographic":"","name":"Igbo"},{"alpha2":"io","alpha3":"ido","bibliographic":"","name":"Ido"},{"alpha2":"ii","alpha3":"iii","bibliographic":"","name":"Nuosu"},{"alpha2":"ii","alpha3":"iii","bibliographic":"","name":"Sichuan Yi"},{"alpha2":"","alpha3":"ijo","bibliographic":"","name":"Ijo languages"},{"alpha2":"iu","alpha3":"iku","bibliographic":"","name":"Inuktitut"},{"alpha2":"ie","alpha3":"ile","bibliographic":"","name":"Interlingue"},{"alpha2":"ie","alpha3":"ile","bibliographic":"","name":"Occidental"},{"alpha2":"","alpha3":"ilo","bibliographic":"","name":"Iloko"},{"alpha2":"ia","alpha3":"ina","bibliographic":"","name":"Interlingua (International Auxiliary Language Association)"},{"alpha2":"","alpha3":"inc","bibliographic":"","name":"Indic languages"},{"alpha2":"id","alpha3":"ind","bibliographic":"","name":"Indonesian"},{"alpha2":"","alpha3":"ine","bibliographic":"","name":"Indo-European languages"},{"alpha2":"","alpha3":"inh","bibliographic":"","name":"Ingush"},{"alpha2":"ik","alpha3":"ipk","bibliographic":"","name":"Inupiaq"},{"alpha2":"","alpha3":"ira","bibliographic":"","name":"Iranian languages"},{"alpha2":"","alpha3":"iro","bibliographic":"","name":"Iroquoian languages"},{"alpha2":"is","alpha3":"isl","bibliographic":"ice","name":"Icelandic"},{"alpha2":"it","alpha3":"ita","bibliographic":"","name":"Italian"},{"alpha2":"jv","alpha3":"jav","bibliographic":"","name":"Javanese"},{"alpha2":"","alpha3":"jbo","bibliographic":"","name":"Lojban"},{"alpha2":"ja","alpha3":"jpn","bibliographic":"","name":"Japanese"},{"alpha2":"","alpha3":"jpr","bibliographic":"","name":"Judeo-Persian"},{"alpha2":"","alpha3":"jrb","bibliographic":"","name":"Judeo-Arabic"},{"alpha2":"","alpha3":"kaa","bibliographic":"","name":"Kara-Kalpak"},{"alpha2":"","alpha3":"kab","bibliographic":"","name":"Kabyle"},{"alpha2":"","alpha3":"kac","bibliographic":"","name":"Jingpho"},{"alpha2":"","alpha3":"kac","bibliographic":"","name":"Kachin"},{"alpha2":"kl","alpha3":"kal","bibliographic":"","name":"Greenlandic"},{"alpha2":"kl","alpha3":"kal","bibliographic":"","name":"Kalaallisut"},{"alpha2":"","alpha3":"kam","bibliographic":"","name":"Kamba"},{"alpha2":"kn","alpha3":"kan","bibliographic":"","name":"Kannada"},{"alpha2":"","alpha3":"kar","bibliographic":"","name":"Karen languages"},{"alpha2":"ks","alpha3":"kas","bibliographic":"","name":"Kashmiri"},{"alpha2":"ka","alpha3":"kat","bibliographic":"geo","name":"Georgian"},{"alpha2":"kr","alpha3":"kau","bibliographic":"","name":"Kanuri"},{"alpha2":"","alpha3":"kaw","bibliographic":"","name":"Kawi"},{"alpha2":"kk","alpha3":"kaz","bibliographic":"","name":"Kazakh"},{"alpha2":"","alpha3":"kbd","bibliographic":"","name":"Kabardian"},{"alpha2":"","alpha3":"kha","bibliographic":"","name":"Khasi"},{"alpha2":"","alpha3":"khi","bibliographic":"","name":"Khoisan languages"},{"alpha2":"km","alpha3":"khm","bibliographic":"","name":"Central Khmer"},{"alpha2":"","alpha3":"kho","bibliographic":"","name":"Khotanese"},{"alpha2":"","alpha3":"kho","bibliographic":"","name":"Sakan"},{"alpha2":"ki","alpha3":"kik","bibliographic":"","name":"Gikuyu"},{"alpha2":"ki","alpha3":"kik","bibliographic":"","name":"Kikuyu"},{"alpha2":"rw","alpha3":"kin","bibliographic":"","name":"Kinyarwanda"},{"alpha2":"ky","alpha3":"kir","bibliographic":"","name":"Kirghiz"},{"alpha2":"ky","alpha3":"kir","bibliographic":"","name":"Kyrgyz"},{"alpha2":"","alpha3":"kmb","bibliographic":"","name":"Kimbundu"},{"alpha2":"","alpha3":"kok","bibliographic":"","name":"Konkani"},{"alpha2":"kv","alpha3":"kom","bibliographic":"","name":"Komi"},{"alpha2":"kg","alpha3":"kon","bibliographic":"","name":"Kongo"},{"alpha2":"ko","alpha3":"kor","bibliographic":"","name":"Korean"},{"alpha2":"","alpha3":"kos","bibliographic":"","name":"Kosraean"},{"alpha2":"","alpha3":"kpe","bibliographic":"","name":"Kpelle"},{"alpha2":"","alpha3":"krc","bibliographic":"","name":"Karachay-Balkar"},{"alpha2":"","alpha3":"krl","bibliographic":"","name":"Karelian"},{"alpha2":"","alpha3":"kro","bibliographic":"","name":"Kru languages"},{"alpha2":"","alpha3":"kru","bibliographic":"","name":"Kurukh"},{"alpha2":"kj","alpha3":"kua","bibliographic":"","name":"Kuanyama"},{"alpha2":"kj","alpha3":"kua","bibliographic":"","name":"Kwanyama"},{"alpha2":"","alpha3":"kum","bibliographic":"","name":"Kumyk"},{"alpha2":"ku","alpha3":"kur","bibliographic":"","name":"Kurdish"},{"alpha2":"","alpha3":"kut","bibliographic":"","name":"Kutenai"},{"alpha2":"","alpha3":"lad","bibliographic":"","name":"Ladino"},{"alpha2":"","alpha3":"lah","bibliographic":"","name":"Lahnda"},{"alpha2":"","alpha3":"lam","bibliographic":"","name":"Lamba"},{"alpha2":"lo","alpha3":"lao","bibliographic":"","name":"Lao"},{"alpha2":"la","alpha3":"lat","bibliographic":"","name":"Latin"},{"alpha2":"lv","alpha3":"lav","bibliographic":"","name":"Latvian"},{"alpha2":"","alpha3":"lez","bibliographic":"","name":"Lezghian"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburgan"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburger"},{"alpha2":"li","alpha3":"lim","bibliographic":"","name":"Limburgish"},{"alpha2":"ln","alpha3":"lin","bibliographic":"","name":"Lingala"},{"alpha2":"lt","alpha3":"lit","bibliographic":"","name":"Lithuanian"},{"alpha2":"","alpha3":"lol","bibliographic":"","name":"Mongo"},{"alpha2":"","alpha3":"loz","bibliographic":"","name":"Lozi"},{"alpha2":"lb","alpha3":"ltz","bibliographic":"","name":"Letzeburgesch"},{"alpha2":"lb","alpha3":"ltz","bibliographic":"","name":"Luxembourgish"},{"alpha2":"","alpha3":"lua","bibliographic":"","name":"Luba-Lulua"},{"alpha2":"lu","alpha3":"lub","bibliographic":"","name":"Luba-Katanga"},{"alpha2":"lg","alpha3":"lug","bibliographic":"","name":"Ganda"},{"alpha2":"","alpha3":"lui","bibliographic":"","name":"Luiseno"},{"alpha2":"","alpha3":"lun","bibliographic":"","name":"Lunda"},{"alpha2":"","alpha3":"luo","bibliographic":"","name":"Luo (Kenya and Tanzania)"},{"alpha2":"","alpha3":"lus","bibliographic":"","name":"Lushai"},{"alpha2":"","alpha3":"mad","bibliographic":"","name":"Madurese"},{"alpha2":"","alpha3":"mag","bibliographic":"","name":"Magahi"},{"alpha2":"mh","alpha3":"mah","bibliographic":"","name":"Marshallese"},{"alpha2":"","alpha3":"mai","bibliographic":"","name":"Maithili"},{"alpha2":"","alpha3":"mak","bibliographic":"","name":"Makasar"},{"alpha2":"ml","alpha3":"mal","bibliographic":"","name":"Malayalam"},{"alpha2":"","alpha3":"man","bibliographic":"","name":"Mandingo"},{"alpha2":"","alpha3":"map","bibliographic":"","name":"Austronesian languages"},{"alpha2":"mr","alpha3":"mar","bibliographic":"","name":"Marathi"},{"alpha2":"","alpha3":"mas","bibliographic":"","name":"Masai"},{"alpha2":"","alpha3":"mdf","bibliographic":"","name":"Moksha"},{"alpha2":"","alpha3":"mdr","bibliographic":"","name":"Mandar"},{"alpha2":"","alpha3":"men","bibliographic":"","name":"Mende"},{"alpha2":"","alpha3":"mga","bibliographic":"","name":"Irish, Middle (900-1200)"},{"alpha2":"","alpha3":"mic","bibliographic":"","name":"Mi'kmaq"},{"alpha2":"","alpha3":"mic","bibliographic":"","name":"Micmac"},{"alpha2":"","alpha3":"min","bibliographic":"","name":"Minangkabau"},{"alpha2":"","alpha3":"mis","bibliographic":"","name":"Uncoded languages"},{"alpha2":"mk","alpha3":"mkd","bibliographic":"mac","name":"Macedonian"},{"alpha2":"","alpha3":"mkh","bibliographic":"","name":"Mon-Khmer languages"},{"alpha2":"mg","alpha3":"mlg","bibliographic":"","name":"Malagasy"},{"alpha2":"mt","alpha3":"mlt","bibliographic":"","name":"Maltese"},{"alpha2":"","alpha3":"mnc","bibliographic":"","name":"Manchu"},{"alpha2":"","alpha3":"mni","bibliographic":"","name":"Manipuri"},{"alpha2":"","alpha3":"mno","bibliographic":"","name":"Manobo languages"},{"alpha2":"","alpha3":"moh","bibliographic":"","name":"Mohawk"},{"alpha2":"mn","alpha3":"mon","bibliographic":"","name":"Mongolian"},{"alpha2":"","alpha3":"mos","bibliographic":"","name":"Mossi"},{"alpha2":"","alpha3":"mot","bibliographic":"","name":"Montenegrin"},{"alpha2":"mi","alpha3":"mri","bibliographic":"mao","name":"Maori"},{"alpha2":"ms","alpha3":"msa","bibliographic":"may","name":"Malay"},{"alpha2":"","alpha3":"mul","bibliographic":"","name":"Multiple languages"},{"alpha2":"","alpha3":"mun","bibliographic":"","name":"Munda languages"},{"alpha2":"","alpha3":"mus","bibliographic":"","name":"Creek"},{"alpha2":"","alpha3":"mwl","bibliographic":"","name":"Mirandese"},{"alpha2":"","alpha3":"mwr","bibliographic":"","name":"Marwari"},{"alpha2":"my","alpha3":"mya","bibliographic":"bur","name":"Burmese"},{"alpha2":"","alpha3":"myn","bibliographic":"","name":"Mayan languages"},{"alpha2":"","alpha3":"myv","bibliographic":"","name":"Erzya"},{"alpha2":"","alpha3":"nah","bibliographic":"","name":"Nahuatl languages"},{"alpha2":"","alpha3":"nai","bibliographic":"","name":"North American Indian languages"},{"alpha2":"","alpha3":"nap","bibliographic":"","name":"Neapolitan"},{"alpha2":"na","alpha3":"nau","bibliographic":"","name":"Nauru"},{"alpha2":"nv","alpha3":"nav","bibliographic":"","name":"Navaho"},{"alpha2":"nv","alpha3":"nav","bibliographic":"","name":"Navajo"},{"alpha2":"nr","alpha3":"nbl","bibliographic":"","name":"Ndebele, South"},{"alpha2":"nr","alpha3":"nbl","bibliographic":"","name":"South Ndebele"},{"alpha2":"nd","alpha3":"nde","bibliographic":"","name":"Ndebele, North"},{"alpha2":"nd","alpha3":"nde","bibliographic":"","name":"North Ndebele"},{"alpha2":"ng","alpha3":"ndo","bibliographic":"","name":"Ndonga"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"German, Low"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Low German"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Low Saxon"},{"alpha2":"","alpha3":"nds","bibliographic":"","name":"Saxon, Low"},{"alpha2":"ne","alpha3":"nep","bibliographic":"","name":"Nepali"},{"alpha2":"","alpha3":"new","bibliographic":"","name":"Nepal Bhasa"},{"alpha2":"","alpha3":"new","bibliographic":"","name":"Newari"},{"alpha2":"","alpha3":"nia","bibliographic":"","name":"Nias"},{"alpha2":"","alpha3":"nic","bibliographic":"","name":"Niger-Kordofanian languages"},{"alpha2":"","alpha3":"niu","bibliographic":"","name":"Niuean"},{"alpha2":"nl","alpha3":"nld","bibliographic":"dut","name":"Dutch"},{"alpha2":"nl","alpha3":"nld","bibliographic":"dut","name":"Flemish"},{"alpha2":"nn","alpha3":"nno","bibliographic":"","name":"Norwegian Nynorsk"},{"alpha2":"nn","alpha3":"nno","bibliographic":"","name":"Nynorsk, Norwegian"},{"alpha2":"nb","alpha3":"nob","bibliographic":"","name":"Bokmål, Norwegian"},{"alpha2":"nb","alpha3":"nob","bibliographic":"","name":"Norwegian Bokmål"},{"alpha2":"","alpha3":"nog","bibliographic":"","name":"Nogai"},{"alpha2":"","alpha3":"non","bibliographic":"","name":"Norse, Old"},{"alpha2":"no","alpha3":"nor","bibliographic":"","name":"Norwegian"},{"alpha2":"","alpha3":"nqo","bibliographic":"","name":"N'Ko"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Northern Sotho"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Pedi"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Sepedi"},{"alpha2":"","alpha3":"nso","bibliographic":"","name":"Sotho, Northern"},{"alpha2":"","alpha3":"nub","bibliographic":"","name":"Nubian languages"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Classical Nepal Bhasa"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Classical Newari"},{"alpha2":"","alpha3":"nwc","bibliographic":"","name":"Old Newari"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Chewa"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Chichewa"},{"alpha2":"ny","alpha3":"nya","bibliographic":"","name":"Nyanja"},{"alpha2":"","alpha3":"nym","bibliographic":"","name":"Nyamwezi"},{"alpha2":"","alpha3":"nyn","bibliographic":"","name":"Nyankole"},{"alpha2":"","alpha3":"nyo","bibliographic":"","name":"Nyoro"},{"alpha2":"","alpha3":"nzi","bibliographic":"","name":"Nzima"},{"alpha2":"oc","alpha3":"oci","bibliographic":"","name":"Occitan (post 1500)"},{"alpha2":"oj","alpha3":"oji","bibliographic":"","name":"Ojibwa"},{"alpha2":"or","alpha3":"ori","bibliographic":"","name":"Oriya"},{"alpha2":"om","alpha3":"orm","bibliographic":"","name":"Oromo"},{"alpha2":"","alpha3":"osa","bibliographic":"","name":"Osage"},{"alpha2":"os","alpha3":"oss","bibliographic":"","name":"Ossetian"},{"alpha2":"os","alpha3":"oss","bibliographic":"","name":"Ossetic"},{"alpha2":"","alpha3":"ota","bibliographic":"","name":"Turkish, Ottoman (1500-1928)"},{"alpha2":"","alpha3":"oto","bibliographic":"","name":"Otomian languages"},{"alpha2":"","alpha3":"paa","bibliographic":"","name":"Papuan languages"},{"alpha2":"","alpha3":"pag","bibliographic":"","name":"Pangasinan"},{"alpha2":"","alpha3":"pal","bibliographic":"","name":"Pahlavi"},{"alpha2":"","alpha3":"pam","bibliographic":"","name":"Kapampangan"},{"alpha2":"","alpha3":"pam","bibliographic":"","name":"Pampanga"},{"alpha2":"pa","alpha3":"pan","bibliographic":"","name":"Panjabi"},{"alpha2":"pa","alpha3":"pan","bibliographic":"","name":"Punjabi"},{"alpha2":"","alpha3":"pap","bibliographic":"","name":"Papiamento"},{"alpha2":"","alpha3":"pau","bibliographic":"","name":"Palauan"},{"alpha2":"","alpha3":"peo","bibliographic":"","name":"Persian, Old (ca.600-400 B.C.)"},{"alpha2":"","alpha3":"phi","bibliographic":"","name":"Philippine languages"},{"alpha2":"","alpha3":"phn","bibliographic":"","name":"Phoenician"},{"alpha2":"pi","alpha3":"pli","bibliographic":"","name":"Pali"},{"alpha2":"pl","alpha3":"pol","bibliographic":"","name":"Polish"},{"alpha2":"","alpha3":"pon","bibliographic":"","name":"Pohnpeian"},{"alpha2":"pt","alpha3":"por","bibliographic":"","name":"Portuguese"},{"alpha2":"","alpha3":"pra","bibliographic":"","name":"Prakrit languages"},{"alpha2":"","alpha3":"pro","bibliographic":"","name":"Occitan, Old (to 1500)"},{"alpha2":"","alpha3":"pro","bibliographic":"","name":"Provençal, Old (to 1500)"},{"alpha2":"ps","alpha3":"pus","bibliographic":"","name":"Pashto"},{"alpha2":"ps","alpha3":"pus","bibliographic":"","name":"Pushto"},{"alpha2":"qu","alpha3":"que","bibliographic":"","name":"Quechua"},{"alpha2":"","alpha3":"raj","bibliographic":"","name":"Rajasthani"},{"alpha2":"","alpha3":"rap","bibliographic":"","name":"Rapanui"},{"alpha2":"","alpha3":"rar","bibliographic":"","name":"Cook Islands Maori"},{"alpha2":"","alpha3":"rar","bibliographic":"","name":"Rarotongan"},{"alpha2":"","alpha3":"roa","bibliographic":"","name":"Romance languages"},{"alpha2":"rm","alpha3":"roh","bibliographic":"","name":"Romansh"},{"alpha2":"","alpha3":"rom","bibliographic":"","name":"Romany"},{"alpha2":"ro","alpha3":"ron","bibliographic":"rum","name":"Moldavian"},{"alpha2":"ro","alpha3":"ron","bibliographic":"rum","name":"Romanian"},{"alpha2":"rn","alpha3":"run","bibliographic":"","name":"Rundi"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Aromanian"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Arumanian"},{"alpha2":"","alpha3":"rup","bibliographic":"","name":"Macedo-Romanian"},{"alpha2":"ru","alpha3":"rus","bibliographic":"","name":"Russian"},{"alpha2":"","alpha3":"sad","bibliographic":"","name":"Sandawe"},{"alpha2":"sg","alpha3":"sag","bibliographic":"","name":"Sango"},{"alpha2":"","alpha3":"sah","bibliographic":"","name":"Yakut"},{"alpha2":"","alpha3":"sai","bibliographic":"","name":"South American Indian languages"},{"alpha2":"","alpha3":"sal","bibliographic":"","name":"Salishan languages"},{"alpha2":"","alpha3":"sam","bibliographic":"","name":"Samaritan Aramaic"},{"alpha2":"sa","alpha3":"san","bibliographic":"","name":"Sanskrit"},{"alpha2":"","alpha3":"sas","bibliographic":"","name":"Sasak"},{"alpha2":"","alpha3":"sat","bibliographic":"","name":"Santali"},{"alpha2":"","alpha3":"scn","bibliographic":"","name":"Sicilian"},{"alpha2":"","alpha3":"sco","bibliographic":"","name":"Scots"},{"alpha2":"","alpha3":"sel","bibliographic":"","name":"Selkup"},{"alpha2":"","alpha3":"sem","bibliographic":"","name":"Semitic languages"},{"alpha2":"","alpha3":"sga","bibliographic":"","name":"Irish, Old (to 900)"},{"alpha2":"","alpha3":"sgn","bibliographic":"","name":"Sign Languages"},{"alpha2":"","alpha3":"shn","bibliographic":"","name":"Shan"},{"alpha2":"","alpha3":"sid","bibliographic":"","name":"Sidamo"},{"alpha2":"si","alpha3":"sin","bibliographic":"","name":"Sinhala"},{"alpha2":"si","alpha3":"sin","bibliographic":"","name":"Sinhalese"},{"alpha2":"","alpha3":"sio","bibliographic":"","name":"Siouan languages"},{"alpha2":"","alpha3":"sit","bibliographic":"","name":"Sino-Tibetan languages"},{"alpha2":"","alpha3":"sla","bibliographic":"","name":"Slavic languages"},{"alpha2":"sk","alpha3":"slk","bibliographic":"slo","name":"Slovak"},{"alpha2":"sl","alpha3":"slv","bibliographic":"","name":"Slovenian"},{"alpha2":"","alpha3":"sma","bibliographic":"","name":"Southern Sami"},{"alpha2":"se","alpha3":"sme","bibliographic":"","name":"Northern Sami"},{"alpha2":"","alpha3":"smi","bibliographic":"","name":"Sami languages"},{"alpha2":"","alpha3":"smj","bibliographic":"","name":"Lule Sami"},{"alpha2":"","alpha3":"smn","bibliographic":"","name":"Inari Sami"},{"alpha2":"sm","alpha3":"smo","bibliographic":"","name":"Samoan"},{"alpha2":"","alpha3":"sms","bibliographic":"","name":"Skolt Sami"},{"alpha2":"sn","alpha3":"sna","bibliographic":"","name":"Shona"},{"alpha2":"sd","alpha3":"snd","bibliographic":"","name":"Sindhi"},{"alpha2":"","alpha3":"snk","bibliographic":"","name":"Soninke"},{"alpha2":"","alpha3":"sog","bibliographic":"","name":"Sogdian"},{"alpha2":"so","alpha3":"som","bibliographic":"","name":"Somali"},{"alpha2":"","alpha3":"son","bibliographic":"","name":"Songhai languages"},{"alpha2":"st","alpha3":"sot","bibliographic":"","name":"Sotho, Southern"},{"alpha2":"es","alpha3":"spa","bibliographic":"","name":"Castilian"},{"alpha2":"es","alpha3":"spa","bibliographic":"","name":"Spanish"},{"alpha2":"sq","alpha3":"sqi","bibliographic":"alb","name":"Albanian"},{"alpha2":"sc","alpha3":"srd","bibliographic":"","name":"Sardinian"},{"alpha2":"","alpha3":"srn","bibliographic":"","name":"Sranan Tongo"},{"alpha2":"sr","alpha3":"srp","bibliographic":"","name":"Serbian"},{"alpha2":"","alpha3":"srr","bibliographic":"","name":"Serer"},{"alpha2":"","alpha3":"ssa","bibliographic":"","name":"Nilo-Saharan languages"},{"alpha2":"ss","alpha3":"ssw","bibliographic":"","name":"Swati"},{"alpha2":"","alpha3":"suk","bibliographic":"","name":"Sukuma"},{"alpha2":"su","alpha3":"sun","bibliographic":"","name":"Sundanese"},{"alpha2":"","alpha3":"sus","bibliographic":"","name":"Susu"},{"alpha2":"","alpha3":"sux","bibliographic":"","name":"Sumerian"},{"alpha2":"sw","alpha3":"swa","bibliographic":"","name":"Swahili"},{"alpha2":"sv","alpha3":"swe","bibliographic":"","name":"Swedish"},{"alpha2":"","alpha3":"syc","bibliographic":"","name":"Classical Syriac"},{"alpha2":"","alpha3":"syr","bibliographic":"","name":"Syriac"},{"alpha2":"ty","alpha3":"tah","bibliographic":"","name":"Tahitian"},{"alpha2":"","alpha3":"tai","bibliographic":"","name":"Tai languages"},{"alpha2":"ta","alpha3":"tam","bibliographic":"","name":"Tamil"},{"alpha2":"tt","alpha3":"tat","bibliographic":"","name":"Tatar"},{"alpha2":"te","alpha3":"tel","bibliographic":"","name":"Telugu"},{"alpha2":"","alpha3":"tem","bibliographic":"","name":"Timne"},{"alpha2":"","alpha3":"ter","bibliographic":"","name":"Tereno"},{"alpha2":"","alpha3":"tet","bibliographic":"","name":"Tetum"},{"alpha2":"tg","alpha3":"tgk","bibliographic":"","name":"Tajik"},{"alpha2":"tl","alpha3":"tgl","bibliographic":"","name":"Tagalog"},{"alpha2":"th","alpha3":"tha","bibliographic":"","name":"Thai"},{"alpha2":"","alpha3":"tig","bibliographic":"","name":"Tigre"},{"alpha2":"ti","alpha3":"tir","bibliographic":"","name":"Tigrinya"},{"alpha2":"","alpha3":"tiv","bibliographic":"","name":"Tiv"},{"alpha2":"","alpha3":"tkl","bibliographic":"","name":"Tokelau"},{"alpha2":"","alpha3":"tlh","bibliographic":"","name":"Klingon"},{"alpha2":"","alpha3":"tlh","bibliographic":"","name":"tlhIngan-Hol"},{"alpha2":"","alpha3":"tli","bibliographic":"","name":"Tlingit"},{"alpha2":"","alpha3":"tmh","bibliographic":"","name":"Tamashek"},{"alpha2":"","alpha3":"tog","bibliographic":"","name":"Tonga (Nyasa)"},{"alpha2":"to","alpha3":"ton","bibliographic":"","name":"Tonga (Tonga Islands)"},{"alpha2":"","alpha3":"tpi","bibliographic":"","name":"Tok Pisin"},{"alpha2":"","alpha3":"tsi","bibliographic":"","name":"Tsimshian"},{"alpha2":"tn","alpha3":"tsn","bibliographic":"","name":"Tswana"},{"alpha2":"ts","alpha3":"tso","bibliographic":"","name":"Tsonga"},{"alpha2":"tk","alpha3":"tuk","bibliographic":"","name":"Turkmen"},{"alpha2":"","alpha3":"tum","bibliographic":"","name":"Tumbuka"},{"alpha2":"","alpha3":"tup","bibliographic":"","name":"Tupi languages"},{"alpha2":"tr","alpha3":"tur","bibliographic":"","name":"Turkish"},{"alpha2":"","alpha3":"tut","bibliographic":"","name":"Altaic languages"},{"alpha2":"","alpha3":"tvl","bibliographic":"","name":"Tuvalu"},{"alpha2":"tw","alpha3":"twi","bibliographic":"","name":"Twi"},{"alpha2":"","alpha3":"tyv","bibliographic":"","name":"Tuvinian"},{"alpha2":"","alpha3":"udm","bibliographic":"","name":"Udmurt"},{"alpha2":"","alpha3":"uga","bibliographic":"","name":"Ugaritic"},{"alpha2":"ug","alpha3":"uig","bibliographic":"","name":"Uighur"},{"alpha2":"ug","alpha3":"uig","bibliographic":"","name":"Uyghur"},{"alpha2":"uk","alpha3":"ukr","bibliographic":"","name":"Ukrainian"},{"alpha2":"","alpha3":"umb","bibliographic":"","name":"Umbundu"},{"alpha2":"","alpha3":"und","bibliographic":"","name":"Undetermined"},{"alpha2":"ur","alpha3":"urd","bibliographic":"","name":"Urdu"},{"alpha2":"uz","alpha3":"uzb","bibliographic":"","name":"Uzbek"},{"alpha2":"","alpha3":"vai","bibliographic":"","name":"Vai"},{"alpha2":"ve","alpha3":"ven","bibliographic":"","name":"Venda"},{"alpha2":"vi","alpha3":"vie","bibliographic":"","name":"Vietnamese"},{"alpha2":"vo","alpha3":"vol","bibliographic":"","name":"Volapük"},{"alpha2":"","alpha3":"vot","bibliographic":"","name":"Votic"},{"alpha2":"","alpha3":"wak","bibliographic":"","name":"Wakashan languages"},{"alpha2":"","alpha3":"wal","bibliographic":"","name":"Wolaitta"},{"alpha2":"","alpha3":"wal","bibliographic":"","name":"Wolaytta"},{"alpha2":"","alpha3":"war","bibliographic":"","name":"Waray"},{"alpha2":"","alpha3":"was","bibliographic":"","name":"Washo"},{"alpha2":"","alpha3":"wen","bibliographic":"","name":"Sorbian languages"},{"alpha2":"wa","alpha3":"wln","bibliographic":"","name":"Walloon"},{"alpha2":"wo","alpha3":"wol","bibliographic":"","name":"Wolof"},{"alpha2":"","alpha3":"xal","bibliographic":"","name":"Kalmyk"},{"alpha2":"","alpha3":"xal","bibliographic":"","name":"Oirat"},{"alpha2":"xh","alpha3":"xho","bibliographic":"","name":"Xhosa"},{"alpha2":"","alpha3":"yao","bibliographic":"","name":"Yao"},{"alpha2":"","alpha3":"yap","bibliographic":"","name":"Yapese"},{"alpha2":"yi","alpha3":"yid","bibliographic":"","name":"Yiddish"},{"alpha2":"yo","alpha3":"yor","bibliographic":"","name":"Yoruba"},{"alpha2":"","alpha3":"ypk","bibliographic":"","name":"Yupik languages"},{"alpha2":"","alpha3":"zap","bibliographic":"","name":"Zapotec"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Bliss"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Blissymbolics"},{"alpha2":"","alpha3":"zbl","bibliographic":"","name":"Blissymbols"},{"alpha2":"","alpha3":"zen","bibliographic":"","name":"Zenaga"},{"alpha2":"","alpha3":"zgh","bibliographic":"","name":"Standard Moroccan Tamazight"},{"alpha2":"za","alpha3":"zha","bibliographic":"","name":"Chuang"},{"alpha2":"za","alpha3":"zha","bibliographic":"","name":"Zhuang"},{"alpha2":"zh","alpha3":"zho","bibliographic":"chi","name":"Chinese"},{"alpha2":"","alpha3":"znd","bibliographic":"","name":"Zande languages"},{"alpha2":"zu","alpha3":"zul","bibliographic":"","name":"Zulu"},{"alpha2":"","alpha3":"zun","bibliographic":"","name":"Zuni"},{"alpha2":"","alpha3":"zxx","bibliographic":"","name":"No linguistic content"},{"alpha2":"","alpha3":"zxx","bibliographic":"","name":"Not applicable"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Dimili"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Dimli"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Kirdki"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Kirmanjki"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Zaza"},{"alpha2":"","alpha3":"zza","bibliographic":"","name":"Zazaki"}]

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(268);

module.exports = init;

function init(o) {
  return {
    countries: search.bind(null, o.countries),
    currencies: search.bind(null, o.currencies),
    languages: search.bind(null, o.languages)
  };
}

function search(data, query) {
  var q = _.pairs(query);

  return data.filter(function(d) {
    return q.filter(function(v) {
      var prop = d[v[0]];

      if(_.isArray(prop)) return prop.indexOf(v[1]) >= 0;

      return prop == v[1];
    }).length == q.length;
  });
}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = mapSymbol

var map = __webpack_require__(1042)

function mapSymbol(currencyCode) {
  if (map.hasOwnProperty(currencyCode)) {
    return map[currencyCode]
  } else {
    return '?'
  }
}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports =
{ "ALL": "L"
, "AFN": "؋"
, "ARS": "$"
, "AWG": "ƒ"
, "AUD": "$"
, "AZN": "₼"
, "BSD": "$"
, "BBD": "$"
, "BYR": "p."
, "BZD": "BZ$"
, "BMD": "$"
, "BOB": "Bs."
, "BAM": "KM"
, "BWP": "P"
, "BGN": "лв"
, "BRL": "R$"
, "BND": "$"
, "KHR": "៛"
, "CAD": "$"
, "KYD": "$"
, "CLP": "$"
, "CNY": "¥"
, "COP": "$"
, "CRC": "₡"
, "HRK": "kn"
, "CUP": "₱"
, "CZK": "Kč"
, "DKK": "kr"
, "DOP": "RD$"
, "XCD": "$"
, "EGP": "£"
, "SVC": "$"
, "EEK": "kr"
, "EUR": "€"
, "FKP": "£"
, "FJD": "$"
, "GHC": "¢"
, "GIP": "£"
, "GTQ": "Q"
, "GGP": "£"
, "GYD": "$"
, "HNL": "L"
, "HKD": "$"
, "HUF": "Ft"
, "ISK": "kr"
, "INR": "₹"
, "IDR": "Rp"
, "IRR": "﷼"
, "IMP": "£"
, "ILS": "₪"
, "JMD": "J$"
, "JPY": "¥"
, "JEP": "£"
, "KES": "KSh"
, "KZT": "лв"
, "KPW": "₩"
, "KRW": "₩"
, "KGS": "лв"
, "LAK": "₭"
, "LVL": "Ls"
, "LBP": "£"
, "LRD": "$"
, "LTL": "Lt"
, "MKD": "ден"
, "MYR": "RM"
, "MUR": "₨"
, "MXN": "$"
, "MNT": "₮"
, "MZN": "MT"
, "NAD": "$"
, "NPR": "₨"
, "ANG": "ƒ"
, "NZD": "$"
, "NIO": "C$"
, "NGN": "₦"
, "NOK": "kr"
, "OMR": "﷼"
, "PKR": "₨"
, "PAB": "B/."
, "PYG": "Gs"
, "PEN": "S/."
, "PHP": "₱"
, "PLN": "zł"
, "QAR": "﷼"
, "RON": "lei"
, "RUB": "₽"
, "SHP": "£"
, "SAR": "﷼"
, "RSD": "Дин."
, "SCR": "₨"
, "SGD": "$"
, "SBD": "$"
, "SOS": "S"
, "ZAR": "R"
, "LKR": "₨"
, "SEK": "kr"
, "CHF": "CHF"
, "SRD": "$"
, "SYP": "£"
, "TZS": "TSh"
, "TWD": "NT$"
, "THB": "฿"
, "TTD": "TT$"
, "TRY": ""
, "TRL": "₤"
, "TVD": "$"
, "UGX": "USh"
, "UAH": "₴"
, "GBP": "£"
, "USD": "$"
, "UYU": "$U"
, "UZS": "лв"
, "VEF": "Bs"
, "VND": "₫"
, "YER": "﷼"
, "ZWD": "Z$"
}


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Icon__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Icon__);
var Hover=function(_React$PureComponent){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Hover,_React$PureComponent);function Hover(props){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,Hover);var _this=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Hover.__proto__||Object.getPrototypeOf(Hover)).call(this,props));var _this$props=_this.props,top=_this$props.top,left=_this$props.left;_this.state={top:top,left:left};return _this;}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Hover,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,top=_props.top,left=_props.left;var width=document.getElementById('container').clientWidth;var height=document.getElementById('container').clientHeight;if(top+height>=window.innerHeight){this.setState({top:top-height});}if(left+width>=window.innerWidth){this.setState({left:left-width});}}},{key:'render',value:function render(){var _props2=this.props,handleCloseDetailClick=_props2.handleCloseDetailClick,node=_props2.node,top=_props2.top,left=_props2.left;var description=node.description;description=description.replace(/(?:\r\n|\r|\n)/g,' ');description=description.split('. ');return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'hover-panel',style:{top:this.state.top,left:this.state.left},id:'container'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'header'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3',null,node.label)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'photo'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:node.image,alt:'photo',width:'100',height:'100'})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Icon___default.a,{color:'action',onClick:handleCloseDetailClick,className:'close-icon'},'close')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'description'},description[0]));}}]);return Hover;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);Hover.propTypes={handleCloseDetailClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,left:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,node:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,top:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Hover);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Icon__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Paper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper__);
var Menu=function Menu(_ref){var handleCloseClick=_ref.handleCloseClick,handleFilterClick=_ref.handleFilterClick,isopen=_ref.isopen;var output={};if(handleCloseClick){output.closeicon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Icon___default.a,{color:'action',onClick:handleCloseClick,className:'close-icon'},'close');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer___default.a,{open:isopen,className:'menu-drawer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'menu-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default.a,{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuList"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return handleFilterClick('qatar-charity');}},'Qatar Charity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return handleFilterClick('qcuk');}},'UK Branch'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return handleFilterClick('qcuk+history');}},'History'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return handleFilterClick('qcuk+leadership');}},'Leadership'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default.a,{className:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuList"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return handleFilterClick('sheffield');}},'Emaan Trust of Sheffield'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return handleFilterClick('sheffield+history');}},'History'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return handleFilterClick('sheffield+leadership');}},'Leadership'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return handleFilterClick('sheffield+funding');}},'Funding')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Icon___default.a,{color:'action',onClick:handleCloseClick,className:'close-icon'},'close')));};Menu.propTypes={handleCloseClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleFilterClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isopen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Popover = __webpack_require__(1046);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Popover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _contains = __webpack_require__(150);

var _contains2 = _interopRequireDefault(_contains);

var _debounce = __webpack_require__(247);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactEventListener = __webpack_require__(246);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Modal = __webpack_require__(370);

var _Modal2 = _interopRequireDefault(_Modal);

var _Grow = __webpack_require__(1047);

var _Grow2 = _interopRequireDefault(_Grow);

var _Paper = __webpack_require__(112);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
} // @inheritedComponent Modal

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? n + 'px' : n;
  }).join(' ');
}

// Sum the scrollTop between two elements.
function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }
  return scrollTop;
}

var styles = exports.styles = {
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: 'calc(100vh - 32px)',
    '&:focus': {
      outline: 'none'
    }
  }
};

var Popover = function (_React$Component) {
  (0, _inherits3.default)(Popover, _React$Component);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillUnmount = function () {
      _this.handleResize.cancel();
    }, _this.setPositioningStyles = function (element) {
      if (element && element.style) {
        var positioning = _this.getPositioningStyle(element);
        element.style.top = positioning.top;
        element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
      }
    }, _this.getPositioningStyle = function (element) {
      var marginThreshold = _this.props.marginThreshold;

      // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);
      // Get the offset of of the anchoring element
      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset);

      var elemRect = {
        width: element.clientWidth,
        height: element.clientHeight
      };
      // Get the transform origin point on the element itself
      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      // Calculate element positioning
      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width;

      // Window thresholds taking required margin into account
      var heightThreshold = window.innerHeight - marginThreshold;
      var widthThreshold = window.innerWidth - marginThreshold;

      // Check if the vertical axis needs shifting
      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;
        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning2.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', 'Some part of it can not be seen on the screen (' + (elemRect.height - heightThreshold) + 'px).', 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0;

      // Check if the horizontal axis needs shifting
      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;
        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;
        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: top + 'px',
        left: left + 'px',
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    }, _this.transitionEl = undefined, _this.handleGetOffsetTop = getOffsetTop, _this.handleGetOffsetLeft = getOffsetLeft, _this.handleEnter = function (element) {
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      _this.setPositioningStyles(element);
    }, _this.handleResize = (0, _debounce2.default)(function () {
      var element = _reactDom2.default.findDOMNode(_this.transitionEl);
      _this.setPositioningStyles(element);
    }, 166), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: 'getAnchorOffset',


    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _props = this.props,
          anchorEl = _props.anchorEl,
          anchorOrigin = _props.anchorOrigin,
          anchorReference = _props.anchorReference,
          anchorPosition = _props.anchorPosition;


      if (anchorReference === 'anchorPosition') {
        return anchorPosition;
      }

      var anchorElement = anchorEl || document.body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';

      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    }

    // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: 'getContentAnchorOffset',
    value: function getContentAnchorOffset(element) {
      var _props2 = this.props,
          getContentAnchorEl = _props2.getContentAnchorEl,
          anchorReference = _props2.anchorReference;

      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && (0, _contains2.default)(element, contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        }

        // != the default value
         false ? (0, _warning2.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to null or left `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    }

    // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: 'getTransformOrigin',
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;

      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          anchorEl = _props3.anchorEl,
          anchorOrigin = _props3.anchorOrigin,
          anchorPosition = _props3.anchorPosition,
          anchorReference = _props3.anchorReference,
          children = _props3.children,
          classes = _props3.classes,
          elevation = _props3.elevation,
          getContentAnchorEl = _props3.getContentAnchorEl,
          marginThreshold = _props3.marginThreshold,
          onEnter = _props3.onEnter,
          onEntered = _props3.onEntered,
          onEntering = _props3.onEntering,
          onExit = _props3.onExit,
          onExited = _props3.onExited,
          onExiting = _props3.onExiting,
          open = _props3.open,
          PaperProps = _props3.PaperProps,
          role = _props3.role,
          transformOrigin = _props3.transformOrigin,
          TransitionProp = _props3.transition,
          transitionDuration = _props3.transitionDuration,
          action = _props3.action,
          other = (0, _objectWithoutProperties3.default)(_props3, ['anchorEl', 'anchorOrigin', 'anchorPosition', 'anchorReference', 'children', 'classes', 'elevation', 'getContentAnchorEl', 'marginThreshold', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExited', 'onExiting', 'open', 'PaperProps', 'role', 'transformOrigin', 'transition', 'transitionDuration', 'action']);


      var transitionProps = {};

      // The provided transition might not support the auto timeout value.
      if (TransitionProp === _Grow2.default) {
        transitionProps.timeout = transitionDuration;
      }

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ open: open, BackdropProps: { invisible: true } }, other),
        _react2.default.createElement(
          TransitionProp,
          (0, _extends3.default)({
            appear: true,
            'in': open,
            onEnter: this.handleEnter,
            onEntered: onEntered,
            onEntering: onEntering,
            onExit: onExit,
            onExited: onExited,
            onExiting: onExiting,
            role: role,
            ref: function ref(node) {
              _this2.transitionEl = node;
            }
          }, transitionProps),
          _react2.default.createElement(
            _Paper2.default,
            (0, _extends3.default)({
              className: classes.paper,

              elevation: elevation
            }, PaperProps),
            _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
            children
          )
        )
      );
    }
  }]);
  return Popover;
}(_react2.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes2.default.func,
  /**
   * This is the DOM element that may be used
   * to set the position of the popover.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
  }),
  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes2.default.shape({
    top: _propTypes2.default.number,
    left: _propTypes2.default.number
  }),
  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes2.default.oneOf(['anchorEl', 'anchorPosition']),
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The elevation of the popover.
   */
  elevation: _propTypes2.default.number,
  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes2.default.func,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes2.default.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
  }),
  /**
   * Transition component.
   */
  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  transition: _Grow2.default,
  transitionDuration: 'auto'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPopover' })(Popover);

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getScale = getScale;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransition = __webpack_require__(1048);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _withTheme = __webpack_require__(159);

var _withTheme2 = _interopRequireDefault(_withTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Only exported for tests.
// @inheritedComponent CSSTransition

function getScale(value) {
  return 'scale(' + value + ', ' + Math.pow(value, 2) + ')';
}

/**
 * The Grow transition is used by the Popover component.
 * It's using [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = function (_React$Component) {
  (0, _inherits3.default)(Grow, _React$Component);

  function Grow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Grow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Grow.__proto__ || (0, _getPrototypeOf2.default)(Grow)).call.apply(_ref, [this].concat(args))), _this), _this.autoTimeout = undefined, _this.handleEnter = function (node) {
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else if (typeof timeout === 'number') {
        duration = timeout;
      } else if (timeout && typeof timeout.enter === 'number') {
        duration = timeout.enter;
      } else {
        // The propType will warn in this case.
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration
      }), theme.transitions.create('transform', {
        duration: duration * 0.666
      })].join(',');

      node.style.opacity = '1';
      node.style.transform = getScale(1);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else if (typeof timeout === 'number') {
        duration = timeout;
      } else if (timeout && typeof timeout.exit === 'number') {
        duration = timeout.exit;
      } else {
        // The propType will warn in this case.
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: duration * 0.333
      })].join(',');

      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.addEndListener = function (node, next) {
      if (_this.props.timeout === 'auto') {
        setTimeout(next, _this.autoTimeout || 0);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Grow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appear = _props.appear,
          children = _props.children,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          _props$transitionClas = _props.transitionClasses,
          transitionClasses = _props$transitionClas === undefined ? {} : _props$transitionClas,
          other = (0, _objectWithoutProperties3.default)(_props, ['appear', 'children', 'onEnter', 'onEntering', 'onExit', 'style', 'theme', 'timeout', 'transitionClasses']);


      var style = {};

      // For server side rendering.
      if (!this.props.in || appear) {
        style.opacity = '0';
      }

      style = (0, _extends3.default)({}, style, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _CSSTransition2.default,
        (0, _extends3.default)({
          classNames: transitionClasses,
          onEnter: this.handleEnter,
          onEntering: this.handleEntering,
          onExit: this.handleExit,
          addEndListener: this.addEndListener,
          appear: appear,
          style: style,
          timeout: timeout === 'auto' ? null : timeout
        }, other),
        children
      );
    }
  }]);
  return Grow;
}(_react2.default.Component);

Grow.propTypes =  false ? {
  /**
   * @ignore
   */
  appear: _propTypes2.default.bool,
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])]),
  /**
   * The animation classNames applied to the component as it enters or exits.
   * This property is a direct binding to [`CSSTransition.classNames`](https://reactcommunity.org/react-transition-group/#CSSTransition-prop-classNames).
   */
  transitionClasses: _propTypes2.default.shape({
    appear: _propTypes2.default.string,
    appearActive: _propTypes2.default.string,
    enter: _propTypes2.default.string,
    enterActive: _propTypes2.default.string,
    exit: _propTypes2.default.string,
    exitActive: _propTypes2.default.string
  })
} : {};

Grow.defaultProps = {
  appear: true,
  timeout: 'auto'
};

exports.default = (0, _withTheme2.default)()(Grow);

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(1049);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1051);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(158);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters or exits.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  exit?: string,
   *  exitActive?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ```js
 * import CSSTransition from 'react-transition-group/CSSTransition';
 *
 * const Fade = ({ children, ...props }) => (
 *  <CSSTransition
 *    {...props}
 *    timeout={500}
 *    classNames="fade"
 *  >
 *   {children}
 *  </CSSTransition>
 * );
 *
 * class FadeInAndOut extends React.Component {
 *   constructor(...args) {
 *     super(...args);
 *     this.state= { show: false }
 *
 *     setInterval(() => {
 *       this.setState({ show: !this.state.show })
 *     }, 5000)
 *   }
 *   render() {
 *     return (
 *       <Fade in={this.state.show}>
 *         <div>Hello world</div>
 *       </Fade>
 *     )
 *   }
 * }
 * ```
 *
 * And the coorresponding CSS for the `<Fade>` component:
 *
 * ```css
 * .fade-enter {
 *   opacity: 0.01;
 * }
 *
 * .fade-enter.fade-enter-active {
 *   opacity: 1;
 *   transition: opacity 500ms ease-in;
 * }
 *
 * .fade-exit {
 *   opacity: 1;
 * }
 *
 * .fade-exit.fade-exit-active {
 *   opacity: 0.01;
 *   transition: opacity 300ms ease-in;
 * }
 * ```
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      return { className: className, activeClassName: activeClassName };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(1050);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto',
      listStyle: 'none',
      margin: 0,
      padding: 0,
      position: 'relative'
    },
    padding: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    dense: {
      paddingTop: theme.spacing.unit / 2,
      paddingBottom: theme.spacing.unit / 2
    },
    subheader: {
      paddingTop: 0
    }
  };
};

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          dense = _props.dense,
          disablePadding = _props.disablePadding,
          subheader = _props.subheader,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'component', 'dense', 'disablePadding', 'subheader']);

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty3.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty3.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({ className: className }, other),
        subheader,
        children
      );
    }
  }]);
  return List;
}(_react2.default.Component);

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes2.default.bool,
  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes2.default.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes2.default.node
} : {};

List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};

List.childContextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiList' })(List);

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(109);

var _keycode2 = _interopRequireDefault(_keycode);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _keyboardFocus = __webpack_require__(1054);

var _TouchRipple = __webpack_require__(1055);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _createRippleHandler = __webpack_require__(1059);

var _createRippleHandler2 = _interopRequireDefault(_createRippleHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      // Remove grey highlight
      WebkitTapHighlightColor: theme.palette.common.transparent,
      backgroundColor: 'transparent', // Reset default value
      outline: 'none',
      border: 0,
      borderRadius: 0,
      padding: 0, // Reset default style
      cursor: 'pointer',
      userSelect: 'none',
      verticalAlign: 'middle',
      appearance: 'none',
      textDecoration: 'none',
      // So we take precedent over the style of a native <a /> element.
      color: 'inherit',
      '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
      }
    },
    disabled: {
      pointerEvents: 'none', // Disable link interactions
      cursor: 'default'
    }
  };
};

/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a building block for people who want to create a simple button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = function (_React$Component) {
  (0, _inherits3.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ButtonBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonBase.__proto__ || (0, _getPrototypeOf2.default)(ButtonBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      keyboardFocused: false
    }, _this.onKeyboardFocusHandler = function (event) {
      _this.keyDown = false;
      _this.setState({ keyboardFocused: true });

      if (_this.props.onKeyboardFocus) {
        _this.props.onKeyboardFocus(event);
      }
    }, _this.ripple = null, _this.keyDown = false, _this.button = null, _this.keyboardFocusTimeout = null, _this.keyboardFocusCheckTime = 50, _this.keyboardFocusMaxCheckTimes = 5, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;

      var key = (0, _keycode2.default)(event);

      // Check if key is already down to avoid repeats being counted as multiple activations
      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && key === 'space') {
        _this.keyDown = true;
        event.persist();
        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      }

      // Keyboard accessibility for non interactive elements
      if (event.target === _this.button && onClick && component && component !== 'a' && component !== 'button' && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode2.default)(event) === 'space' && _this.state.keyboardFocused) {
        _this.keyDown = false;
        event.persist();
        _this.ripple.stop(event, function () {
          return _this.ripple.pulsate(event);
        });
      }
      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    }, _this.handleMouseDown = (0, _createRippleHandler2.default)(_this, 'MouseDown', 'start', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      (0, _keyboardFocus.focusKeyPressed)(false);
      if (_this.state.keyboardFocused) {
        _this.setState({ keyboardFocused: false });
      }
    }), _this.handleMouseUp = (0, _createRippleHandler2.default)(_this, 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler2.default)(_this, 'MouseLeave', 'stop', function (event) {
      if (_this.state.keyboardFocused) {
        event.preventDefault();
      }
    }), _this.handleTouchStart = (0, _createRippleHandler2.default)(_this, 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleTouchMove = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleBlur = (0, _createRippleHandler2.default)(_this, 'Blur', 'stop', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      (0, _keyboardFocus.focusKeyPressed)(false);
      _this.setState({ keyboardFocused: false });
    }), _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }

      // Fix for https://github.com/facebook/react/issues/7769
      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _keyboardFocus.detectKeyboardFocus)(_this, _this.button, function () {
        _this.onKeyboardFocusHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ButtonBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.button = (0, _reactDom.findDOMNode)(this);
      (0, _keyboardFocus.listenForFocusKeys)();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!this.props.disabled && nextProps.disabled && this.state.keyboardFocused) {
        this.setState({
          keyboardFocused: false
        });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.props.focusRipple && nextState.keyboardFocused && !this.state.keyboardFocused && !this.props.disableRipple) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.keyboardFocusTimeout);
    } // Used to help track keyboard activation keyDown

  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props = this.props,
          centerRipple = _props.centerRipple,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          component = _props.component,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          focusRipple = _props.focusRipple,
          keyboardFocusedClassName = _props.keyboardFocusedClassName,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onKeyboardFocus = _props.onKeyboardFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onTouchEnd = _props.onTouchEnd,
          onTouchMove = _props.onTouchMove,
          onTouchStart = _props.onTouchStart,
          rootRef = _props.rootRef,
          tabIndex = _props.tabIndex,
          type = _props.type,
          other = (0, _objectWithoutProperties3.default)(_props, ['centerRipple', 'children', 'classes', 'className', 'component', 'disabled', 'disableRipple', 'focusRipple', 'keyboardFocusedClassName', 'onBlur', 'onFocus', 'onKeyboardFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseLeave', 'onMouseUp', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'rootRef', 'tabIndex', 'type']);


      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, keyboardFocusedClassName || '', this.state.keyboardFocused), _classNames), classNameProp);

      var buttonProps = {};

      var ComponentProp = component;

      if (!ComponentProp) {
        if (other.href) {
          ComponentProp = 'a';
        } else {
          ComponentProp = 'button';
        }
      }

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
      }

      if (ComponentProp !== 'a') {
        buttonProps.role = buttonProps.type === 'button' ? undefined : 'button';
        buttonProps.disabled = disabled;
      }

      return _react2.default.createElement(
        ComponentProp,
        (0, _extends3.default)({
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onMouseUp: this.handleMouseUp,
          onTouchEnd: this.handleTouchEnd,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          tabIndex: disabled ? -1 : tabIndex,
          className: className
        }, buttonProps, {
          ref: rootRef
        }, other),
        children,
        !disableRipple && !disabled ? _react2.default.createElement(_TouchRipple2.default, {
          innerRef: function innerRef(node) {
            _this2.ripple = node;
          },
          center: centerRipple
        }) : null
      );
    }
  }]);
  return ButtonBase;
}(_react2.default.Component);

ButtonBase.propTypes =  false ? {
  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes2.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes2.default.bool,
  /**
   * The CSS class applied while the component is keyboard focused.
   */
  keyboardFocusedClassName: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchEnd: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchStart: _propTypes2.default.func,
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * Use that property to pass a ref callback to the root component.
   */
  rootRef: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * @ignore
   */
  type: _propTypes2.default.string
} : {};

ButtonBase.defaultProps = {
  centerRipple: false,
  disableRipple: false,
  focusRipple: false,
  tabIndex: 0,
  type: 'button'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButtonBase' })(ButtonBase);

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusKeyPressed = focusKeyPressed;
exports.detectKeyboardFocus = detectKeyboardFocus;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = __webpack_require__(109);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _contains = __webpack_require__(150);

var _contains2 = _interopRequireDefault(_contains);

var _addEventListener = __webpack_require__(372);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

var internal = {
  listening: false,
  focusKeyPressed: false
};

function focusKeyPressed(pressed) {
  if (typeof pressed !== 'undefined') {
    internal.focusKeyPressed = Boolean(pressed);
  }

  return internal.focusKeyPressed;
}

function detectKeyboardFocus(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

   false ? (0, _warning2.default)(instance.keyboardFocusCheckTime, 'Material-UI: missing instance.keyboardFocusCheckTime') : void 0;
   false ? (0, _warning2.default)(instance.keyboardFocusMaxCheckTimes, 'Material-UI: missing instance.keyboardFocusMaxCheckTimes') : void 0;

  instance.keyboardFocusTimeout = setTimeout(function () {
    if (focusKeyPressed() && (document.activeElement === element || (0, _contains2.default)(element, document.activeElement))) {
      callback();
    } else if (attempt < instance.keyboardFocusMaxCheckTimes) {
      detectKeyboardFocus(instance, element, callback, attempt + 1);
    }
  }, instance.keyboardFocusCheckTime);
}

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode2.default)(event)) !== -1;
}

function listenForFocusKeys() {
  // It's a singleton, we only need to listen once.
  // Also, this logic is client side only, we don't need a teardown.
  if (!internal.listening) {
    (0, _addEventListener2.default)(window, 'keyup', function (event) {
      if (isFocusKey(event)) {
        internal.focusKeyPressed = true;
      }
    });
    internal.listening = true;
  }
}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.DELAY_RIPPLE = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(148);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(1056);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Ripple = __webpack_require__(1058);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DURATION = 550;
var DELAY_RIPPLE = exports.DELAY_RIPPLE = 80;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },
    wrapper: {
      opacity: 1
    },
    wrapperLeaving: {
      opacity: 0,
      animation: 'mui-ripple-exit ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
    },
    wrapperPulsating: {
      position: 'absolute',
      left: 0,
      top: 0,
      display: 'block',
      width: '100%',
      height: '100%',
      animation: 'mui-ripple-pulsate 2500ms ' + theme.transitions.easing.easeInOut + ' 200ms infinite'
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute',
      borderRadius: '50%',
      background: 'currentColor'
    },
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: 'mui-ripple-enter ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
    },
    rippleFast: {
      animationDuration: '200ms'
    }
  };
};

/**
 * @ignore - internal component.
 */

var TouchRipple = function (_React$Component) {
  (0, _inherits3.default)(TouchRipple, _React$Component);

  function TouchRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TouchRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      nextKey: 0,
      ripples: []
    }, _this.ignoringMouseDown = false, _this.startTimer = null, _this.startTimerCommit = null, _this.pulsate = function () {
      _this.start({}, { pulsate: true });
    }, _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments[2];
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === undefined ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === undefined ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === undefined ? false : _options$fakeElement;


      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom2.default.findDOMNode(_this);
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      };

      // Get the size of the ripple
      var rippleX = void 0;
      var rippleY = void 0;
      var rippleSize = void 0;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);

        // For some reason the animation is broken on Mobile Chrome if the size if even.
        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      }

      // Touche devices
      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
        };
        // Deplay the execution of the ripple effect.
        _this.startTimer = setTimeout(function () {
          _this.startTimerCommit();
          _this.startTimerCommit = null;
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
      }
    }, _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;

      var ripples = _this.state.ripples;

      // Add a ripple to the ripples array.
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_Ripple2.default, {
        key: _this.state.nextKey,
        classes: _this.props.classes,
        timeout: {
          exit: DURATION,
          enter: DURATION
        },
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);

      _this.setState({
        nextKey: _this.state.nextKey + 1,
        ripples: ripples
      }, cb);
    }, _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples;

      // The touch interaction occures to quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();
        _this.startTimerCommit();
        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }

    // Used to filter out mouse emulated events on mobile.

    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.

    // This is the hook called once the previous timeout is ready.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          center = _props.center,
          classes = _props.classes,
          className = _props.className,
          other = (0, _objectWithoutProperties3.default)(_props, ['center', 'classes', 'className']);


      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({
          component: 'span',
          enter: true,
          exit: true,
          className: (0, _classnames2.default)(classes.root, className)
        }, other),
        this.state.ripples
      );
    }
  }]);
  return TouchRipple;
}(_react2.default.Component);

TouchRipple.propTypes =  false ? {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

TouchRipple.defaultProps = {
  center: false
};

exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiTouchRipple' })(TouchRipple);

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(1057);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(1);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _Transition = __webpack_require__(158);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var Ripple = function (_React$Component) {
  (0, _inherits3.default)(Ripple, _React$Component);

  function Ripple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Ripple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ripple.__proto__ || (0, _getPrototypeOf2.default)(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      rippleVisible: false,
      rippleLeaving: false
    }, _this.handleEnter = function () {
      _this.setState({
        rippleVisible: true
      });
    }, _this.handleExit = function () {
      _this.setState({
        rippleLeaving: true
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Ripple, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          pulsate = _props.pulsate,
          rippleX = _props.rippleX,
          rippleY = _props.rippleY,
          rippleSize = _props.rippleSize,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'pulsate', 'rippleX', 'rippleY', 'rippleSize']);
      var _state = this.state,
          rippleVisible = _state.rippleVisible,
          rippleLeaving = _state.rippleLeaving;


      var className = (0, _classnames2.default)(classes.wrapper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.wrapperLeaving, rippleLeaving), (0, _defineProperty3.default)(_classNames, classes.wrapperPulsating, pulsate), _classNames), classNameProp);

      var rippleClassName = (0, _classnames2.default)(classes.ripple, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.rippleVisible, rippleVisible), (0, _defineProperty3.default)(_classNames2, classes.rippleFast, pulsate), _classNames2));

      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({ onEnter: this.handleEnter, onExit: this.handleExit }, other),
        _react2.default.createElement(
          'span',
          { className: className },
          _react2.default.createElement('span', { className: rippleClassName, style: rippleStyles })
        )
      );
    }
  }]);
  return Ripple;
}(_react2.default.Component);

Ripple.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes2.default.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes2.default.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes2.default.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes2.default.number
} : {};

Ripple.defaultProps = {
  pulsate: false
};

exports.default = Ripple;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }

    if (event.defaultPrevented) {
      return false;
    }

    if (instance.ripple) {
      instance.ripple[action](event);
    }

    if (instance.props && typeof instance.props['on' + eventName] === 'function') {
      instance.props['on' + eventName](event);
    }

    return true;
  };
}

exports.default = createRippleHandler;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      width: 36,
      height: 36,
      fontSize: theme.typography.pxToRem(18),
      marginRight: 4
    },
    icon: {
      width: 20,
      height: 20,
      fontSize: theme.typography.pxToRem(20)
    }
  };
};

/**
 * It's a simple wrapper to apply the `dense` mode styles to `Avatar`.
 */
function ListItemAvatar(props, context) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  if (context.dense === undefined) {
     false ? (0, _warning2.default)(false, 'Material-UI: <ListItemAvatar> is a simple wrapper to apply the dense styles\n      to <Avatar>. You do not need it unless you are controlling the <List> dense property.') : void 0;
    return props.children;
  }

  return _react2.default.cloneElement(children, (0, _extends3.default)({
    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.root, context.dense), classNameProp, children.props.className),
    childrenClassName: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.icon, context.dense), children.props.childrenClassName)
  }, other));
}

ListItemAvatar.propTypes =  false ? {
  /**
   * The content of the component, normally `Avatar`.
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

ListItemAvatar.contextTypes = {
  dense: _propTypes2.default.bool
};

ListItemAvatar.muiName = 'ListItemAvatar';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemAvatar' })(ListItemAvatar);

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(176);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto',
      minWidth: 0,
      padding: '0 16px',
      '&:first-child': {
        paddingLeft: 0
      }
    },
    inset: {
      '&:first-child': {
        paddingLeft: theme.spacing.unit * 7
      }
    },
    dense: {
      fontSize: theme.typography.pxToRem(13)
    },
    primary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },
    secondary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },
    textDense: {}
  };
};

function ListItemText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      inset = props.inset,
      primary = props.primary,
      secondary = props.secondary,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'disableTypography', 'inset', 'primary', 'secondary']);
  var dense = context.dense;

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense), (0, _defineProperty3.default)(_classNames, classes.inset, inset), _classNames), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    primary && (disableTypography ? primary : _react2.default.createElement(
      _Typography2.default,
      {
        type: 'subheading',
        className: (0, _classnames2.default)(classes.primary, (0, _defineProperty3.default)({}, classes.textDense, dense))
      },
      primary
    )),
    secondary && (disableTypography ? secondary : _react2.default.createElement(
      _Typography2.default,
      {
        type: 'body1',
        className: (0, _classnames2.default)(classes.secondary, (0, _defineProperty3.default)({}, classes.textDense, dense)),
        color: 'textSecondary'
      },
      secondary
    ))
  );
}

ListItemText.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, that can be useful to can render an h4 instead of a
   */
  disableTypography: _propTypes2.default.bool,
  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes2.default.bool,
  primary: _propTypes2.default.node,
  secondary: _propTypes2.default.node
} : {};

ListItemText.defaultProps = {
  disableTypography: false,
  inset: false,
  primary: false,
  secondary: false
};

ListItemText.contextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemText' })(ListItemText);

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      margin: 0
    },
    display4: theme.typography.display4,
    display3: theme.typography.display3,
    display2: theme.typography.display2,
    display1: theme.typography.display1,
    headline: theme.typography.headline,
    title: theme.typography.title,
    subheading: theme.typography.subheading,
    body2: theme.typography.body2,
    body1: theme.typography.body1,
    caption: theme.typography.caption,
    button: theme.typography.button,
    alignLeft: {
      textAlign: 'left'
    },
    alignCenter: {
      textAlign: 'center'
    },
    alignRight: {
      textAlign: 'right'
    },
    alignJustify: {
      textAlign: 'justify'
    },
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    gutterBottom: {
      marginBottom: '0.35em'
    },
    paragraph: {
      marginBottom: theme.spacing.unit * 2
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
};

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      componentProp = props.component,
      color = props.color,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      type = props.type,
      other = (0, _objectWithoutProperties3.default)(props, ['align', 'classes', 'className', 'component', 'color', 'gutterBottom', 'headlineMapping', 'noWrap', 'paragraph', 'type']);


  var className = (0, _classnames2.default)(classes.root, classes[type], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty3.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty3.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty3.default)(_classNames, classes['align' + (0, _helpers.capitalizeFirstLetter)(align)], align !== 'inherit'), _classNames), classNameProp);

  var Component = componentProp || (paragraph ? 'p' : headlineMapping[type]) || 'span';

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes2.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   */
  color: _propTypes2.default.oneOf(['inherit', 'primary', 'textSecondary', 'secondary', 'error', 'default']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the type to a good default headline component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes2.default.bool,
  /**
   * We are empirically mapping the type property to a range of different DOM element type.
   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   */
  headlineMapping: _propTypes2.default.object,
  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes2.default.bool,
  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes2.default.bool,
  /**
   * Applies the theme typography styles.
   */
  type: _propTypes2.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
} : {};

Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  type: 'body1'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTypography' })(Typography);

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      height: 24,
      marginRight: theme.spacing.unit * 2,
      width: 24,
      color: theme.palette.action.active,
      flexShrink: 0
    }
  };
};

/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.cloneElement(children, (0, _extends3.default)({
    className: (0, _classnames2.default)(classes.root, classNameProp, children.props.className)
  }, other));
}

ListItemIcon.propTypes =  false ? {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `material-ui-icons` SVG icon component.
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemIcon' })(ListItemIcon);

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      right: 4,
      top: '50%',
      marginTop: -theme.spacing.unit * 3
    }
  };
};

function ListItemSecondaryAction(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

ListItemSecondaryAction.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemSecondaryAction' })(ListItemSecondaryAction);

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize)
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorInherit: {
      color: 'inherit'
    },
    inset: {
      paddingLeft: theme.spacing.unit * 9
    },
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};

function ListSubheader(props) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      Component = props.component,
      disableSticky = props.disableSticky,
      inset = props.inset,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'component', 'disableSticky', 'inset']);

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.inset, inset), (0, _defineProperty3.default)(_classNames, classes.sticky, !disableSticky), _classNames), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

ListSubheader.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   */
  color: _propTypes2.default.oneOf(['default', 'primary', 'inherit']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: _propTypes2.default.bool,
  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: _propTypes2.default.bool
} : {};

ListSubheader.defaultProps = {
  color: 'default',
  component: 'li',
  disableSticky: false,
  inset: false
};

ListSubheader.muiName = 'ListSubheader';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListSubheader' })(ListSubheader);

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ListItem = __webpack_require__(454);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.subheading, {
      height: theme.spacing.unit * 3,
      boxSizing: 'content-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&$selected': {
        backgroundColor: theme.palette.action.selected
      },
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    }),
    selected: {}
  };
}; // @inheritedComponent ListItem

function MenuItem(props) {
  var classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'selected', 'role']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.selected, selected), classNameProp);

  return _react2.default.createElement(_ListItem2.default, (0, _extends3.default)({
    button: true,
    role: role,
    tabIndex: -1,
    className: className,
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * Use to apply selected styling.
   */
  selected: _propTypes2.default.bool
} : {};

MenuItem.defaultProps = {
  role: 'menuitem',
  selected: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenuItem' })(MenuItem);

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Icon__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Icon__);
var markdown=__webpack_require__(1068).markdown;function createMarkup(html){return{__html:html};}var LoadHtml=function LoadHtml(_ref){var handleCloseClick=_ref.handleCloseClick,handleHTMLClick=_ref.handleHTMLClick,isopen=_ref.isopen,tag=_ref.tag;var contents=__webpack_require__(1074);var content='';var title='';if(tag){tag=tag.replace('+',',');}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=contents[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var item=_step.value;if(item.tags===tag){title=item.title;content=item.body;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}content=markdown.toHTML(content);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer___default.a,{open:isopen,className:'html-drawer',type:'persistent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(event){return handleHTMLClick(event);},dangerouslySetInnerHTML:createMarkup(content)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Icon___default.a,{color:'action',onClick:handleCloseClick,className:'close-icon'},'close')));};LoadHtml.propTypes={handleCloseClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleHTMLClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isopen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,tag:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (LoadHtml);

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

// super simple module for the most common nodejs use case.
exports.markdown = __webpack_require__(1069);
exports.parse = exports.markdown.toHTML;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// Released under MIT license
// Copyright (c) 2009-2010 Dominic Baggott
// Copyright (c) 2009-2010 Ash Berlin
// Copyright (c) 2011 Christoph Dorn <christoph@christophdorn.com> (http://www.christophdorn.com)

/*jshint browser:true, devel:true */

(function( expose ) {

/**
 *  class Markdown
 *
 *  Markdown processing in Javascript done right. We have very particular views
 *  on what constitutes 'right' which include:
 *
 *  - produces well-formed HTML (this means that em and strong nesting is
 *    important)
 *
 *  - has an intermediate representation to allow processing of parsed data (We
 *    in fact have two, both as [JsonML]: a markdown tree and an HTML tree).
 *
 *  - is easily extensible to add new dialects without having to rewrite the
 *    entire parsing mechanics
 *
 *  - has a good test suite
 *
 *  This implementation fulfills all of these (except that the test suite could
 *  do with expanding to automatically run all the fixtures from other Markdown
 *  implementations.)
 *
 *  ##### Intermediate Representation
 *
 *  *TODO* Talk about this :) Its JsonML, but document the node names we use.
 *
 *  [JsonML]: http://jsonml.org/ "JSON Markup Language"
 **/
var Markdown = expose.Markdown = function(dialect) {
  switch (typeof dialect) {
    case "undefined":
      this.dialect = Markdown.dialects.Gruber;
      break;
    case "object":
      this.dialect = dialect;
      break;
    default:
      if ( dialect in Markdown.dialects ) {
        this.dialect = Markdown.dialects[dialect];
      }
      else {
        throw new Error("Unknown Markdown dialect '" + String(dialect) + "'");
      }
      break;
  }
  this.em_state = [];
  this.strong_state = [];
  this.debug_indent = "";
};

/**
 *  parse( markdown, [dialect] ) -> JsonML
 *  - markdown (String): markdown string to parse
 *  - dialect (String | Dialect): the dialect to use, defaults to gruber
 *
 *  Parse `markdown` and return a markdown document as a Markdown.JsonML tree.
 **/
expose.parse = function( source, dialect ) {
  // dialect will default if undefined
  var md = new Markdown( dialect );
  return md.toTree( source );
};

/**
 *  toHTML( markdown, [dialect]  ) -> String
 *  toHTML( md_tree ) -> String
 *  - markdown (String): markdown string to parse
 *  - md_tree (Markdown.JsonML): parsed markdown tree
 *
 *  Take markdown (either as a string or as a JsonML tree) and run it through
 *  [[toHTMLTree]] then turn it into a well-formated HTML fragment.
 **/
expose.toHTML = function toHTML( source , dialect , options ) {
  var input = expose.toHTMLTree( source , dialect , options );

  return expose.renderJsonML( input );
};

/**
 *  toHTMLTree( markdown, [dialect] ) -> JsonML
 *  toHTMLTree( md_tree ) -> JsonML
 *  - markdown (String): markdown string to parse
 *  - dialect (String | Dialect): the dialect to use, defaults to gruber
 *  - md_tree (Markdown.JsonML): parsed markdown tree
 *
 *  Turn markdown into HTML, represented as a JsonML tree. If a string is given
 *  to this function, it is first parsed into a markdown tree by calling
 *  [[parse]].
 **/
expose.toHTMLTree = function toHTMLTree( input, dialect , options ) {
  // convert string input to an MD tree
  if ( typeof input ==="string" ) input = this.parse( input, dialect );

  // Now convert the MD tree to an HTML tree

  // remove references from the tree
  var attrs = extract_attr( input ),
      refs = {};

  if ( attrs && attrs.references ) {
    refs = attrs.references;
  }

  var html = convert_tree_to_html( input, refs , options );
  merge_text_nodes( html );
  return html;
};

// For Spidermonkey based engines
function mk_block_toSource() {
  return "Markdown.mk_block( " +
          uneval(this.toString()) +
          ", " +
          uneval(this.trailing) +
          ", " +
          uneval(this.lineNumber) +
          " )";
}

// node
function mk_block_inspect() {
  var util = __webpack_require__(1070);
  return "Markdown.mk_block( " +
          util.inspect(this.toString()) +
          ", " +
          util.inspect(this.trailing) +
          ", " +
          util.inspect(this.lineNumber) +
          " )";

}

var mk_block = Markdown.mk_block = function(block, trail, line) {
  // Be helpful for default case in tests.
  if ( arguments.length == 1 ) trail = "\n\n";

  var s = new String(block);
  s.trailing = trail;
  // To make it clear its not just a string
  s.inspect = mk_block_inspect;
  s.toSource = mk_block_toSource;

  if ( line != undefined )
    s.lineNumber = line;

  return s;
};

function count_lines( str ) {
  var n = 0, i = -1;
  while ( ( i = str.indexOf("\n", i + 1) ) !== -1 ) n++;
  return n;
}

// Internal - split source into rough blocks
Markdown.prototype.split_blocks = function splitBlocks( input, startLine ) {
  input = input.replace(/(\r\n|\n|\r)/g, "\n");
  // [\s\S] matches _anything_ (newline or space)
  // [^] is equivalent but doesn't work in IEs.
  var re = /([\s\S]+?)($|\n#|\n(?:\s*\n|$)+)/g,
      blocks = [],
      m;

  var line_no = 1;

  if ( ( m = /^(\s*\n)/.exec(input) ) != null ) {
    // skip (but count) leading blank lines
    line_no += count_lines( m[0] );
    re.lastIndex = m[0].length;
  }

  while ( ( m = re.exec(input) ) !== null ) {
    if (m[2] == "\n#") {
      m[2] = "\n";
      re.lastIndex--;
    }
    blocks.push( mk_block( m[1], m[2], line_no ) );
    line_no += count_lines( m[0] );
  }

  return blocks;
};

/**
 *  Markdown#processBlock( block, next ) -> undefined | [ JsonML, ... ]
 *  - block (String): the block to process
 *  - next (Array): the following blocks
 *
 * Process `block` and return an array of JsonML nodes representing `block`.
 *
 * It does this by asking each block level function in the dialect to process
 * the block until one can. Succesful handling is indicated by returning an
 * array (with zero or more JsonML nodes), failure by a false value.
 *
 * Blocks handlers are responsible for calling [[Markdown#processInline]]
 * themselves as appropriate.
 *
 * If the blocks were split incorrectly or adjacent blocks need collapsing you
 * can adjust `next` in place using shift/splice etc.
 *
 * If any of this default behaviour is not right for the dialect, you can
 * define a `__call__` method on the dialect that will get invoked to handle
 * the block processing.
 */
Markdown.prototype.processBlock = function processBlock( block, next ) {
  var cbs = this.dialect.block,
      ord = cbs.__order__;

  if ( "__call__" in cbs ) {
    return cbs.__call__.call(this, block, next);
  }

  for ( var i = 0; i < ord.length; i++ ) {
    //D:this.debug( "Testing", ord[i] );
    var res = cbs[ ord[i] ].call( this, block, next );
    if ( res ) {
      //D:this.debug("  matched");
      if ( !isArray(res) || ( res.length > 0 && !( isArray(res[0]) ) ) )
        this.debug(ord[i], "didn't return a proper array");
      //D:this.debug( "" );
      return res;
    }
  }

  // Uhoh! no match! Should we throw an error?
  return [];
};

Markdown.prototype.processInline = function processInline( block ) {
  return this.dialect.inline.__call__.call( this, String( block ) );
};

/**
 *  Markdown#toTree( source ) -> JsonML
 *  - source (String): markdown source to parse
 *
 *  Parse `source` into a JsonML tree representing the markdown document.
 **/
// custom_tree means set this.tree to `custom_tree` and restore old value on return
Markdown.prototype.toTree = function toTree( source, custom_root ) {
  var blocks = source instanceof Array ? source : this.split_blocks( source );

  // Make tree a member variable so its easier to mess with in extensions
  var old_tree = this.tree;
  try {
    this.tree = custom_root || this.tree || [ "markdown" ];

    blocks:
    while ( blocks.length ) {
      var b = this.processBlock( blocks.shift(), blocks );

      // Reference blocks and the like won't return any content
      if ( !b.length ) continue blocks;

      this.tree.push.apply( this.tree, b );
    }
    return this.tree;
  }
  finally {
    if ( custom_root ) {
      this.tree = old_tree;
    }
  }
};

// Noop by default
Markdown.prototype.debug = function () {
  var args = Array.prototype.slice.call( arguments);
  args.unshift(this.debug_indent);
  if ( typeof print !== "undefined" )
      print.apply( print, args );
  if ( typeof console !== "undefined" && typeof console.log !== "undefined" )
      console.log.apply( null, args );
}

Markdown.prototype.loop_re_over_block = function( re, block, cb ) {
  // Dont use /g regexps with this
  var m,
      b = block.valueOf();

  while ( b.length && (m = re.exec(b) ) != null ) {
    b = b.substr( m[0].length );
    cb.call(this, m);
  }
  return b;
};

/**
 * Markdown.dialects
 *
 * Namespace of built-in dialects.
 **/
Markdown.dialects = {};

/**
 * Markdown.dialects.Gruber
 *
 * The default dialect that follows the rules set out by John Gruber's
 * markdown.pl as closely as possible. Well actually we follow the behaviour of
 * that script which in some places is not exactly what the syntax web page
 * says.
 **/
Markdown.dialects.Gruber = {
  block: {
    atxHeader: function atxHeader( block, next ) {
      var m = block.match( /^(#{1,6})\s*(.*?)\s*#*\s*(?:\n|$)/ );

      if ( !m ) return undefined;

      var header = [ "header", { level: m[ 1 ].length } ];
      Array.prototype.push.apply(header, this.processInline(m[ 2 ]));

      if ( m[0].length < block.length )
        next.unshift( mk_block( block.substr( m[0].length ), block.trailing, block.lineNumber + 2 ) );

      return [ header ];
    },

    setextHeader: function setextHeader( block, next ) {
      var m = block.match( /^(.*)\n([-=])\2\2+(?:\n|$)/ );

      if ( !m ) return undefined;

      var level = ( m[ 2 ] === "=" ) ? 1 : 2;
      var header = [ "header", { level : level }, m[ 1 ] ];

      if ( m[0].length < block.length )
        next.unshift( mk_block( block.substr( m[0].length ), block.trailing, block.lineNumber + 2 ) );

      return [ header ];
    },

    code: function code( block, next ) {
      // |    Foo
      // |bar
      // should be a code block followed by a paragraph. Fun
      //
      // There might also be adjacent code block to merge.

      var ret = [],
          re = /^(?: {0,3}\t| {4})(.*)\n?/,
          lines;

      // 4 spaces + content
      if ( !block.match( re ) ) return undefined;

      block_search:
      do {
        // Now pull out the rest of the lines
        var b = this.loop_re_over_block(
                  re, block.valueOf(), function( m ) { ret.push( m[1] ); } );

        if ( b.length ) {
          // Case alluded to in first comment. push it back on as a new block
          next.unshift( mk_block(b, block.trailing) );
          break block_search;
        }
        else if ( next.length ) {
          // Check the next block - it might be code too
          if ( !next[0].match( re ) ) break block_search;

          // Pull how how many blanks lines follow - minus two to account for .join
          ret.push ( block.trailing.replace(/[^\n]/g, "").substring(2) );

          block = next.shift();
        }
        else {
          break block_search;
        }
      } while ( true );

      return [ [ "code_block", ret.join("\n") ] ];
    },

    horizRule: function horizRule( block, next ) {
      // this needs to find any hr in the block to handle abutting blocks
      var m = block.match( /^(?:([\s\S]*?)\n)?[ \t]*([-_*])(?:[ \t]*\2){2,}[ \t]*(?:\n([\s\S]*))?$/ );

      if ( !m ) {
        return undefined;
      }

      var jsonml = [ [ "hr" ] ];

      // if there's a leading abutting block, process it
      if ( m[ 1 ] ) {
        jsonml.unshift.apply( jsonml, this.processBlock( m[ 1 ], [] ) );
      }

      // if there's a trailing abutting block, stick it into next
      if ( m[ 3 ] ) {
        next.unshift( mk_block( m[ 3 ] ) );
      }

      return jsonml;
    },

    // There are two types of lists. Tight and loose. Tight lists have no whitespace
    // between the items (and result in text just in the <li>) and loose lists,
    // which have an empty line between list items, resulting in (one or more)
    // paragraphs inside the <li>.
    //
    // There are all sorts weird edge cases about the original markdown.pl's
    // handling of lists:
    //
    // * Nested lists are supposed to be indented by four chars per level. But
    //   if they aren't, you can get a nested list by indenting by less than
    //   four so long as the indent doesn't match an indent of an existing list
    //   item in the 'nest stack'.
    //
    // * The type of the list (bullet or number) is controlled just by the
    //    first item at the indent. Subsequent changes are ignored unless they
    //    are for nested lists
    //
    lists: (function( ) {
      // Use a closure to hide a few variables.
      var any_list = "[*+-]|\\d+\\.",
          bullet_list = /[*+-]/,
          number_list = /\d+\./,
          // Capture leading indent as it matters for determining nested lists.
          is_list_re = new RegExp( "^( {0,3})(" + any_list + ")[ \t]+" ),
          indent_re = "(?: {0,3}\\t| {4})";

      // TODO: Cache this regexp for certain depths.
      // Create a regexp suitable for matching an li for a given stack depth
      function regex_for_depth( depth ) {

        return new RegExp(
          // m[1] = indent, m[2] = list_type
          "(?:^(" + indent_re + "{0," + depth + "} {0,3})(" + any_list + ")\\s+)|" +
          // m[3] = cont
          "(^" + indent_re + "{0," + (depth-1) + "}[ ]{0,4})"
        );
      }
      function expand_tab( input ) {
        return input.replace( / {0,3}\t/g, "    " );
      }

      // Add inline content `inline` to `li`. inline comes from processInline
      // so is an array of content
      function add(li, loose, inline, nl) {
        if ( loose ) {
          li.push( [ "para" ].concat(inline) );
          return;
        }
        // Hmmm, should this be any block level element or just paras?
        var add_to = li[li.length -1] instanceof Array && li[li.length - 1][0] == "para"
                   ? li[li.length -1]
                   : li;

        // If there is already some content in this list, add the new line in
        if ( nl && li.length > 1 ) inline.unshift(nl);

        for ( var i = 0; i < inline.length; i++ ) {
          var what = inline[i],
              is_str = typeof what == "string";
          if ( is_str && add_to.length > 1 && typeof add_to[add_to.length-1] == "string" ) {
            add_to[ add_to.length-1 ] += what;
          }
          else {
            add_to.push( what );
          }
        }
      }

      // contained means have an indent greater than the current one. On
      // *every* line in the block
      function get_contained_blocks( depth, blocks ) {

        var re = new RegExp( "^(" + indent_re + "{" + depth + "}.*?\\n?)*$" ),
            replace = new RegExp("^" + indent_re + "{" + depth + "}", "gm"),
            ret = [];

        while ( blocks.length > 0 ) {
          if ( re.exec( blocks[0] ) ) {
            var b = blocks.shift(),
                // Now remove that indent
                x = b.replace( replace, "");

            ret.push( mk_block( x, b.trailing, b.lineNumber ) );
          }
          else {
            break;
          }
        }
        return ret;
      }

      // passed to stack.forEach to turn list items up the stack into paras
      function paragraphify(s, i, stack) {
        var list = s.list;
        var last_li = list[list.length-1];

        if ( last_li[1] instanceof Array && last_li[1][0] == "para" ) {
          return;
        }
        if ( i + 1 == stack.length ) {
          // Last stack frame
          // Keep the same array, but replace the contents
          last_li.push( ["para"].concat( last_li.splice(1, last_li.length - 1) ) );
        }
        else {
          var sublist = last_li.pop();
          last_li.push( ["para"].concat( last_li.splice(1, last_li.length - 1) ), sublist );
        }
      }

      // The matcher function
      return function( block, next ) {
        var m = block.match( is_list_re );
        if ( !m ) return undefined;

        function make_list( m ) {
          var list = bullet_list.exec( m[2] )
                   ? ["bulletlist"]
                   : ["numberlist"];

          stack.push( { list: list, indent: m[1] } );
          return list;
        }


        var stack = [], // Stack of lists for nesting.
            list = make_list( m ),
            last_li,
            loose = false,
            ret = [ stack[0].list ],
            i;

        // Loop to search over block looking for inner block elements and loose lists
        loose_search:
        while ( true ) {
          // Split into lines preserving new lines at end of line
          var lines = block.split( /(?=\n)/ );

          // We have to grab all lines for a li and call processInline on them
          // once as there are some inline things that can span lines.
          var li_accumulate = "";

          // Loop over the lines in this block looking for tight lists.
          tight_search:
          for ( var line_no = 0; line_no < lines.length; line_no++ ) {
            var nl = "",
                l = lines[line_no].replace(/^\n/, function(n) { nl = n; return ""; });

            // TODO: really should cache this
            var line_re = regex_for_depth( stack.length );

            m = l.match( line_re );
            //print( "line:", uneval(l), "\nline match:", uneval(m) );

            // We have a list item
            if ( m[1] !== undefined ) {
              // Process the previous list item, if any
              if ( li_accumulate.length ) {
                add( last_li, loose, this.processInline( li_accumulate ), nl );
                // Loose mode will have been dealt with. Reset it
                loose = false;
                li_accumulate = "";
              }

              m[1] = expand_tab( m[1] );
              var wanted_depth = Math.floor(m[1].length/4)+1;
              //print( "want:", wanted_depth, "stack:", stack.length);
              if ( wanted_depth > stack.length ) {
                // Deep enough for a nested list outright
                //print ( "new nested list" );
                list = make_list( m );
                last_li.push( list );
                last_li = list[1] = [ "listitem" ];
              }
              else {
                // We aren't deep enough to be strictly a new level. This is
                // where Md.pl goes nuts. If the indent matches a level in the
                // stack, put it there, else put it one deeper then the
                // wanted_depth deserves.
                var found = false;
                for ( i = 0; i < stack.length; i++ ) {
                  if ( stack[ i ].indent != m[1] ) continue;
                  list = stack[ i ].list;
                  stack.splice( i+1, stack.length - (i+1) );
                  found = true;
                  break;
                }

                if (!found) {
                  //print("not found. l:", uneval(l));
                  wanted_depth++;
                  if ( wanted_depth <= stack.length ) {
                    stack.splice(wanted_depth, stack.length - wanted_depth);
                    //print("Desired depth now", wanted_depth, "stack:", stack.length);
                    list = stack[wanted_depth-1].list;
                    //print("list:", uneval(list) );
                  }
                  else {
                    //print ("made new stack for messy indent");
                    list = make_list(m);
                    last_li.push(list);
                  }
                }

                //print( uneval(list), "last", list === stack[stack.length-1].list );
                last_li = [ "listitem" ];
                list.push(last_li);
              } // end depth of shenegains
              nl = "";
            }

            // Add content
            if ( l.length > m[0].length ) {
              li_accumulate += nl + l.substr( m[0].length );
            }
          } // tight_search

          if ( li_accumulate.length ) {
            add( last_li, loose, this.processInline( li_accumulate ), nl );
            // Loose mode will have been dealt with. Reset it
            loose = false;
            li_accumulate = "";
          }

          // Look at the next block - we might have a loose list. Or an extra
          // paragraph for the current li
          var contained = get_contained_blocks( stack.length, next );

          // Deal with code blocks or properly nested lists
          if ( contained.length > 0 ) {
            // Make sure all listitems up the stack are paragraphs
            forEach( stack, paragraphify, this);

            last_li.push.apply( last_li, this.toTree( contained, [] ) );
          }

          var next_block = next[0] && next[0].valueOf() || "";

          if ( next_block.match(is_list_re) || next_block.match( /^ / ) ) {
            block = next.shift();

            // Check for an HR following a list: features/lists/hr_abutting
            var hr = this.dialect.block.horizRule( block, next );

            if ( hr ) {
              ret.push.apply(ret, hr);
              break;
            }

            // Make sure all listitems up the stack are paragraphs
            forEach( stack, paragraphify, this);

            loose = true;
            continue loose_search;
          }
          break;
        } // loose_search

        return ret;
      };
    })(),

    blockquote: function blockquote( block, next ) {
      if ( !block.match( /^>/m ) )
        return undefined;

      var jsonml = [];

      // separate out the leading abutting block, if any. I.e. in this case:
      //
      //  a
      //  > b
      //
      if ( block[ 0 ] != ">" ) {
        var lines = block.split( /\n/ ),
            prev = [],
            line_no = block.lineNumber;

        // keep shifting lines until you find a crotchet
        while ( lines.length && lines[ 0 ][ 0 ] != ">" ) {
            prev.push( lines.shift() );
            line_no++;
        }

        var abutting = mk_block( prev.join( "\n" ), "\n", block.lineNumber );
        jsonml.push.apply( jsonml, this.processBlock( abutting, [] ) );
        // reassemble new block of just block quotes!
        block = mk_block( lines.join( "\n" ), block.trailing, line_no );
      }


      // if the next block is also a blockquote merge it in
      while ( next.length && next[ 0 ][ 0 ] == ">" ) {
        var b = next.shift();
        block = mk_block( block + block.trailing + b, b.trailing, block.lineNumber );
      }

      // Strip off the leading "> " and re-process as a block.
      var input = block.replace( /^> ?/gm, "" ),
          old_tree = this.tree,
          processedBlock = this.toTree( input, [ "blockquote" ] ),
          attr = extract_attr( processedBlock );

      // If any link references were found get rid of them
      if ( attr && attr.references ) {
        delete attr.references;
        // And then remove the attribute object if it's empty
        if ( isEmpty( attr ) ) {
          processedBlock.splice( 1, 1 );
        }
      }

      jsonml.push( processedBlock );
      return jsonml;
    },

    referenceDefn: function referenceDefn( block, next) {
      var re = /^\s*\[(.*?)\]:\s*(\S+)(?:\s+(?:(['"])(.*?)\3|\((.*?)\)))?\n?/;
      // interesting matches are [ , ref_id, url, , title, title ]

      if ( !block.match(re) )
        return undefined;

      // make an attribute node if it doesn't exist
      if ( !extract_attr( this.tree ) ) {
        this.tree.splice( 1, 0, {} );
      }

      var attrs = extract_attr( this.tree );

      // make a references hash if it doesn't exist
      if ( attrs.references === undefined ) {
        attrs.references = {};
      }

      var b = this.loop_re_over_block(re, block, function( m ) {

        if ( m[2] && m[2][0] == "<" && m[2][m[2].length-1] == ">" )
          m[2] = m[2].substring( 1, m[2].length - 1 );

        var ref = attrs.references[ m[1].toLowerCase() ] = {
          href: m[2]
        };

        if ( m[4] !== undefined )
          ref.title = m[4];
        else if ( m[5] !== undefined )
          ref.title = m[5];

      } );

      if ( b.length )
        next.unshift( mk_block( b, block.trailing ) );

      return [];
    },

    para: function para( block, next ) {
      // everything's a para!
      return [ ["para"].concat( this.processInline( block ) ) ];
    }
  }
};

Markdown.dialects.Gruber.inline = {

    __oneElement__: function oneElement( text, patterns_or_re, previous_nodes ) {
      var m,
          res,
          lastIndex = 0;

      patterns_or_re = patterns_or_re || this.dialect.inline.__patterns__;
      var re = new RegExp( "([\\s\\S]*?)(" + (patterns_or_re.source || patterns_or_re) + ")" );

      m = re.exec( text );
      if (!m) {
        // Just boring text
        return [ text.length, text ];
      }
      else if ( m[1] ) {
        // Some un-interesting text matched. Return that first
        return [ m[1].length, m[1] ];
      }

      var res;
      if ( m[2] in this.dialect.inline ) {
        res = this.dialect.inline[ m[2] ].call(
                  this,
                  text.substr( m.index ), m, previous_nodes || [] );
      }
      // Default for now to make dev easier. just slurp special and output it.
      res = res || [ m[2].length, m[2] ];
      return res;
    },

    __call__: function inline( text, patterns ) {

      var out = [],
          res;

      function add(x) {
        //D:self.debug("  adding output", uneval(x));
        if ( typeof x == "string" && typeof out[out.length-1] == "string" )
          out[ out.length-1 ] += x;
        else
          out.push(x);
      }

      while ( text.length > 0 ) {
        res = this.dialect.inline.__oneElement__.call(this, text, patterns, out );
        text = text.substr( res.shift() );
        forEach(res, add )
      }

      return out;
    },

    // These characters are intersting elsewhere, so have rules for them so that
    // chunks of plain text blocks don't include them
    "]": function () {},
    "}": function () {},

    __escape__ : /^\\[\\`\*_{}\[\]()#\+.!\-]/,

    "\\": function escaped( text ) {
      // [ length of input processed, node/children to add... ]
      // Only esacape: \ ` * _ { } [ ] ( ) # * + - . !
      if ( this.dialect.inline.__escape__.exec( text ) )
        return [ 2, text.charAt( 1 ) ];
      else
        // Not an esacpe
        return [ 1, "\\" ];
    },

    "![": function image( text ) {

      // Unlike images, alt text is plain text only. no other elements are
      // allowed in there

      // ![Alt text](/path/to/img.jpg "Optional title")
      //      1          2            3       4         <--- captures
      var m = text.match( /^!\[(.*?)\][ \t]*\([ \t]*([^")]*?)(?:[ \t]+(["'])(.*?)\3)?[ \t]*\)/ );

      if ( m ) {
        if ( m[2] && m[2][0] == "<" && m[2][m[2].length-1] == ">" )
          m[2] = m[2].substring( 1, m[2].length - 1 );

        m[2] = this.dialect.inline.__call__.call( this, m[2], /\\/ )[0];

        var attrs = { alt: m[1], href: m[2] || "" };
        if ( m[4] !== undefined)
          attrs.title = m[4];

        return [ m[0].length, [ "img", attrs ] ];
      }

      // ![Alt text][id]
      m = text.match( /^!\[(.*?)\][ \t]*\[(.*?)\]/ );

      if ( m ) {
        // We can't check if the reference is known here as it likely wont be
        // found till after. Check it in md tree->hmtl tree conversion
        return [ m[0].length, [ "img_ref", { alt: m[1], ref: m[2].toLowerCase(), original: m[0] } ] ];
      }

      // Just consume the '!['
      return [ 2, "![" ];
    },

    "[": function link( text ) {

      var orig = String(text);
      // Inline content is possible inside `link text`
      var res = Markdown.DialectHelpers.inline_until_char.call( this, text.substr(1), "]" );

      // No closing ']' found. Just consume the [
      if ( !res ) return [ 1, "[" ];

      var consumed = 1 + res[ 0 ],
          children = res[ 1 ],
          link,
          attrs;

      // At this point the first [...] has been parsed. See what follows to find
      // out which kind of link we are (reference or direct url)
      text = text.substr( consumed );

      // [link text](/path/to/img.jpg "Optional title")
      //                 1            2       3         <--- captures
      // This will capture up to the last paren in the block. We then pull
      // back based on if there a matching ones in the url
      //    ([here](/url/(test))
      // The parens have to be balanced
      var m = text.match( /^\s*\([ \t]*([^"']*)(?:[ \t]+(["'])(.*?)\2)?[ \t]*\)/ );
      if ( m ) {
        var url = m[1];
        consumed += m[0].length;

        if ( url && url[0] == "<" && url[url.length-1] == ">" )
          url = url.substring( 1, url.length - 1 );

        // If there is a title we don't have to worry about parens in the url
        if ( !m[3] ) {
          var open_parens = 1; // One open that isn't in the capture
          for ( var len = 0; len < url.length; len++ ) {
            switch ( url[len] ) {
            case "(":
              open_parens++;
              break;
            case ")":
              if ( --open_parens == 0) {
                consumed -= url.length - len;
                url = url.substring(0, len);
              }
              break;
            }
          }
        }

        // Process escapes only
        url = this.dialect.inline.__call__.call( this, url, /\\/ )[0];

        attrs = { href: url || "" };
        if ( m[3] !== undefined)
          attrs.title = m[3];

        link = [ "link", attrs ].concat( children );
        return [ consumed, link ];
      }

      // [Alt text][id]
      // [Alt text] [id]
      m = text.match( /^\s*\[(.*?)\]/ );

      if ( m ) {

        consumed += m[ 0 ].length;

        // [links][] uses links as its reference
        attrs = { ref: ( m[ 1 ] || String(children) ).toLowerCase(),  original: orig.substr( 0, consumed ) };

        link = [ "link_ref", attrs ].concat( children );

        // We can't check if the reference is known here as it likely wont be
        // found till after. Check it in md tree->hmtl tree conversion.
        // Store the original so that conversion can revert if the ref isn't found.
        return [ consumed, link ];
      }

      // [id]
      // Only if id is plain (no formatting.)
      if ( children.length == 1 && typeof children[0] == "string" ) {

        attrs = { ref: children[0].toLowerCase(),  original: orig.substr( 0, consumed ) };
        link = [ "link_ref", attrs, children[0] ];
        return [ consumed, link ];
      }

      // Just consume the "["
      return [ 1, "[" ];
    },


    "<": function autoLink( text ) {
      var m;

      if ( ( m = text.match( /^<(?:((https?|ftp|mailto):[^>]+)|(.*?@.*?\.[a-zA-Z]+))>/ ) ) != null ) {
        if ( m[3] ) {
          return [ m[0].length, [ "link", { href: "mailto:" + m[3] }, m[3] ] ];

        }
        else if ( m[2] == "mailto" ) {
          return [ m[0].length, [ "link", { href: m[1] }, m[1].substr("mailto:".length ) ] ];
        }
        else
          return [ m[0].length, [ "link", { href: m[1] }, m[1] ] ];
      }

      return [ 1, "<" ];
    },

    "`": function inlineCode( text ) {
      // Inline code block. as many backticks as you like to start it
      // Always skip over the opening ticks.
      var m = text.match( /(`+)(([\s\S]*?)\1)/ );

      if ( m && m[2] )
        return [ m[1].length + m[2].length, [ "inlinecode", m[3] ] ];
      else {
        // TODO: No matching end code found - warn!
        return [ 1, "`" ];
      }
    },

    "  \n": function lineBreak( text ) {
      return [ 3, [ "linebreak" ] ];
    }

};

// Meta Helper/generator method for em and strong handling
function strong_em( tag, md ) {

  var state_slot = tag + "_state",
      other_slot = tag == "strong" ? "em_state" : "strong_state";

  function CloseTag(len) {
    this.len_after = len;
    this.name = "close_" + md;
  }

  return function ( text, orig_match ) {

    if ( this[state_slot][0] == md ) {
      // Most recent em is of this type
      //D:this.debug("closing", md);
      this[state_slot].shift();

      // "Consume" everything to go back to the recrusion in the else-block below
      return[ text.length, new CloseTag(text.length-md.length) ];
    }
    else {
      // Store a clone of the em/strong states
      var other = this[other_slot].slice(),
          state = this[state_slot].slice();

      this[state_slot].unshift(md);

      //D:this.debug_indent += "  ";

      // Recurse
      var res = this.processInline( text.substr( md.length ) );
      //D:this.debug_indent = this.debug_indent.substr(2);

      var last = res[res.length - 1];

      //D:this.debug("processInline from", tag + ": ", uneval( res ) );

      var check = this[state_slot].shift();
      if ( last instanceof CloseTag ) {
        res.pop();
        // We matched! Huzzah.
        var consumed = text.length - last.len_after;
        return [ consumed, [ tag ].concat(res) ];
      }
      else {
        // Restore the state of the other kind. We might have mistakenly closed it.
        this[other_slot] = other;
        this[state_slot] = state;

        // We can't reuse the processed result as it could have wrong parsing contexts in it.
        return [ md.length, md ];
      }
    }
  }; // End returned function
}

Markdown.dialects.Gruber.inline["**"] = strong_em("strong", "**");
Markdown.dialects.Gruber.inline["__"] = strong_em("strong", "__");
Markdown.dialects.Gruber.inline["*"]  = strong_em("em", "*");
Markdown.dialects.Gruber.inline["_"]  = strong_em("em", "_");


// Build default order from insertion order.
Markdown.buildBlockOrder = function(d) {
  var ord = [];
  for ( var i in d ) {
    if ( i == "__order__" || i == "__call__" ) continue;
    ord.push( i );
  }
  d.__order__ = ord;
};

// Build patterns for inline matcher
Markdown.buildInlinePatterns = function(d) {
  var patterns = [];

  for ( var i in d ) {
    // __foo__ is reserved and not a pattern
    if ( i.match( /^__.*__$/) ) continue;
    var l = i.replace( /([\\.*+?|()\[\]{}])/g, "\\$1" )
             .replace( /\n/, "\\n" );
    patterns.push( i.length == 1 ? l : "(?:" + l + ")" );
  }

  patterns = patterns.join("|");
  d.__patterns__ = patterns;
  //print("patterns:", uneval( patterns ) );

  var fn = d.__call__;
  d.__call__ = function(text, pattern) {
    if ( pattern != undefined ) {
      return fn.call(this, text, pattern);
    }
    else
    {
      return fn.call(this, text, patterns);
    }
  };
};

Markdown.DialectHelpers = {};
Markdown.DialectHelpers.inline_until_char = function( text, want ) {
  var consumed = 0,
      nodes = [];

  while ( true ) {
    if ( text.charAt( consumed ) == want ) {
      // Found the character we were looking for
      consumed++;
      return [ consumed, nodes ];
    }

    if ( consumed >= text.length ) {
      // No closing char found. Abort.
      return null;
    }

    var res = this.dialect.inline.__oneElement__.call(this, text.substr( consumed ) );
    consumed += res[ 0 ];
    // Add any returned nodes.
    nodes.push.apply( nodes, res.slice( 1 ) );
  }
}

// Helper function to make sub-classing a dialect easier
Markdown.subclassDialect = function( d ) {
  function Block() {}
  Block.prototype = d.block;
  function Inline() {}
  Inline.prototype = d.inline;

  return { block: new Block(), inline: new Inline() };
};

Markdown.buildBlockOrder ( Markdown.dialects.Gruber.block );
Markdown.buildInlinePatterns( Markdown.dialects.Gruber.inline );

Markdown.dialects.Maruku = Markdown.subclassDialect( Markdown.dialects.Gruber );

Markdown.dialects.Maruku.processMetaHash = function processMetaHash( meta_string ) {
  var meta = split_meta_hash( meta_string ),
      attr = {};

  for ( var i = 0; i < meta.length; ++i ) {
    // id: #foo
    if ( /^#/.test( meta[ i ] ) ) {
      attr.id = meta[ i ].substring( 1 );
    }
    // class: .foo
    else if ( /^\./.test( meta[ i ] ) ) {
      // if class already exists, append the new one
      if ( attr["class"] ) {
        attr["class"] = attr["class"] + meta[ i ].replace( /./, " " );
      }
      else {
        attr["class"] = meta[ i ].substring( 1 );
      }
    }
    // attribute: foo=bar
    else if ( /\=/.test( meta[ i ] ) ) {
      var s = meta[ i ].split( /\=/ );
      attr[ s[ 0 ] ] = s[ 1 ];
    }
  }

  return attr;
}

function split_meta_hash( meta_string ) {
  var meta = meta_string.split( "" ),
      parts = [ "" ],
      in_quotes = false;

  while ( meta.length ) {
    var letter = meta.shift();
    switch ( letter ) {
      case " " :
        // if we're in a quoted section, keep it
        if ( in_quotes ) {
          parts[ parts.length - 1 ] += letter;
        }
        // otherwise make a new part
        else {
          parts.push( "" );
        }
        break;
      case "'" :
      case '"' :
        // reverse the quotes and move straight on
        in_quotes = !in_quotes;
        break;
      case "\\" :
        // shift off the next letter to be used straight away.
        // it was escaped so we'll keep it whatever it is
        letter = meta.shift();
      default :
        parts[ parts.length - 1 ] += letter;
        break;
    }
  }

  return parts;
}

Markdown.dialects.Maruku.block.document_meta = function document_meta( block, next ) {
  // we're only interested in the first block
  if ( block.lineNumber > 1 ) return undefined;

  // document_meta blocks consist of one or more lines of `Key: Value\n`
  if ( ! block.match( /^(?:\w+:.*\n)*\w+:.*$/ ) ) return undefined;

  // make an attribute node if it doesn't exist
  if ( !extract_attr( this.tree ) ) {
    this.tree.splice( 1, 0, {} );
  }

  var pairs = block.split( /\n/ );
  for ( p in pairs ) {
    var m = pairs[ p ].match( /(\w+):\s*(.*)$/ ),
        key = m[ 1 ].toLowerCase(),
        value = m[ 2 ];

    this.tree[ 1 ][ key ] = value;
  }

  // document_meta produces no content!
  return [];
};

Markdown.dialects.Maruku.block.block_meta = function block_meta( block, next ) {
  // check if the last line of the block is an meta hash
  var m = block.match( /(^|\n) {0,3}\{:\s*((?:\\\}|[^\}])*)\s*\}$/ );
  if ( !m ) return undefined;

  // process the meta hash
  var attr = this.dialect.processMetaHash( m[ 2 ] );

  var hash;

  // if we matched ^ then we need to apply meta to the previous block
  if ( m[ 1 ] === "" ) {
    var node = this.tree[ this.tree.length - 1 ];
    hash = extract_attr( node );

    // if the node is a string (rather than JsonML), bail
    if ( typeof node === "string" ) return undefined;

    // create the attribute hash if it doesn't exist
    if ( !hash ) {
      hash = {};
      node.splice( 1, 0, hash );
    }

    // add the attributes in
    for ( a in attr ) {
      hash[ a ] = attr[ a ];
    }

    // return nothing so the meta hash is removed
    return [];
  }

  // pull the meta hash off the block and process what's left
  var b = block.replace( /\n.*$/, "" ),
      result = this.processBlock( b, [] );

  // get or make the attributes hash
  hash = extract_attr( result[ 0 ] );
  if ( !hash ) {
    hash = {};
    result[ 0 ].splice( 1, 0, hash );
  }

  // attach the attributes to the block
  for ( a in attr ) {
    hash[ a ] = attr[ a ];
  }

  return result;
};

Markdown.dialects.Maruku.block.definition_list = function definition_list( block, next ) {
  // one or more terms followed by one or more definitions, in a single block
  var tight = /^((?:[^\s:].*\n)+):\s+([\s\S]+)$/,
      list = [ "dl" ],
      i, m;

  // see if we're dealing with a tight or loose block
  if ( ( m = block.match( tight ) ) ) {
    // pull subsequent tight DL blocks out of `next`
    var blocks = [ block ];
    while ( next.length && tight.exec( next[ 0 ] ) ) {
      blocks.push( next.shift() );
    }

    for ( var b = 0; b < blocks.length; ++b ) {
      var m = blocks[ b ].match( tight ),
          terms = m[ 1 ].replace( /\n$/, "" ).split( /\n/ ),
          defns = m[ 2 ].split( /\n:\s+/ );

      // print( uneval( m ) );

      for ( i = 0; i < terms.length; ++i ) {
        list.push( [ "dt", terms[ i ] ] );
      }

      for ( i = 0; i < defns.length; ++i ) {
        // run inline processing over the definition
        list.push( [ "dd" ].concat( this.processInline( defns[ i ].replace( /(\n)\s+/, "$1" ) ) ) );
      }
    }
  }
  else {
    return undefined;
  }

  return [ list ];
};

// splits on unescaped instances of @ch. If @ch is not a character the result
// can be unpredictable

Markdown.dialects.Maruku.block.table = function table (block, next) {

    var _split_on_unescaped = function(s, ch) {
        ch = ch || '\\s';
        if (ch.match(/^[\\|\[\]{}?*.+^$]$/)) { ch = '\\' + ch; }
        var res = [ ],
            r = new RegExp('^((?:\\\\.|[^\\\\' + ch + '])*)' + ch + '(.*)'),
            m;
        while(m = s.match(r)) {
            res.push(m[1]);
            s = m[2];
        }
        res.push(s);
        return res;
    }

    var leading_pipe = /^ {0,3}\|(.+)\n {0,3}\|\s*([\-:]+[\-| :]*)\n((?:\s*\|.*(?:\n|$))*)(?=\n|$)/,
        // find at least an unescaped pipe in each line
        no_leading_pipe = /^ {0,3}(\S(?:\\.|[^\\|])*\|.*)\n {0,3}([\-:]+\s*\|[\-| :]*)\n((?:(?:\\.|[^\\|])*\|.*(?:\n|$))*)(?=\n|$)/,
        i, m;
    if (m = block.match(leading_pipe)) {
        // remove leading pipes in contents
        // (header and horizontal rule already have the leading pipe left out)
        m[3] = m[3].replace(/^\s*\|/gm, '');
    } else if (! ( m = block.match(no_leading_pipe))) {
        return undefined;
    }

    var table = [ "table", [ "thead", [ "tr" ] ], [ "tbody" ] ];

    // remove trailing pipes, then split on pipes
    // (no escaped pipes are allowed in horizontal rule)
    m[2] = m[2].replace(/\|\s*$/, '').split('|');

    // process alignment
    var html_attrs = [ ];
    forEach (m[2], function (s) {
        if (s.match(/^\s*-+:\s*$/))       html_attrs.push({align: "right"});
        else if (s.match(/^\s*:-+\s*$/))  html_attrs.push({align: "left"});
        else if (s.match(/^\s*:-+:\s*$/)) html_attrs.push({align: "center"});
        else                              html_attrs.push({});
    });

    // now for the header, avoid escaped pipes
    m[1] = _split_on_unescaped(m[1].replace(/\|\s*$/, ''), '|');
    for (i = 0; i < m[1].length; i++) {
        table[1][1].push(['th', html_attrs[i] || {}].concat(
            this.processInline(m[1][i].trim())));
    }

    // now for body contents
    forEach (m[3].replace(/\|\s*$/mg, '').split('\n'), function (row) {
        var html_row = ['tr'];
        row = _split_on_unescaped(row, '|');
        for (i = 0; i < row.length; i++) {
            html_row.push(['td', html_attrs[i] || {}].concat(this.processInline(row[i].trim())));
        }
        table[2].push(html_row);
    }, this);

    return [table];
}

Markdown.dialects.Maruku.inline[ "{:" ] = function inline_meta( text, matches, out ) {
  if ( !out.length ) {
    return [ 2, "{:" ];
  }

  // get the preceeding element
  var before = out[ out.length - 1 ];

  if ( typeof before === "string" ) {
    return [ 2, "{:" ];
  }

  // match a meta hash
  var m = text.match( /^\{:\s*((?:\\\}|[^\}])*)\s*\}/ );

  // no match, false alarm
  if ( !m ) {
    return [ 2, "{:" ];
  }

  // attach the attributes to the preceeding element
  var meta = this.dialect.processMetaHash( m[ 1 ] ),
      attr = extract_attr( before );

  if ( !attr ) {
    attr = {};
    before.splice( 1, 0, attr );
  }

  for ( var k in meta ) {
    attr[ k ] = meta[ k ];
  }

  // cut out the string and replace it with nothing
  return [ m[ 0 ].length, "" ];
};

Markdown.dialects.Maruku.inline.__escape__ = /^\\[\\`\*_{}\[\]()#\+.!\-|:]/;

Markdown.buildBlockOrder ( Markdown.dialects.Maruku.block );
Markdown.buildInlinePatterns( Markdown.dialects.Maruku.inline );

var isArray = Array.isArray || function(obj) {
  return Object.prototype.toString.call(obj) == "[object Array]";
};

var forEach;
// Don't mess with Array.prototype. Its not friendly
if ( Array.prototype.forEach ) {
  forEach = function( arr, cb, thisp ) {
    return arr.forEach( cb, thisp );
  };
}
else {
  forEach = function(arr, cb, thisp) {
    for (var i = 0; i < arr.length; i++) {
      cb.call(thisp || arr, arr[i], i, arr);
    }
  }
}

var isEmpty = function( obj ) {
  for ( var key in obj ) {
    if ( hasOwnProperty.call( obj, key ) ) {
      return false;
    }
  }

  return true;
}

function extract_attr( jsonml ) {
  return isArray(jsonml)
      && jsonml.length > 1
      && typeof jsonml[ 1 ] === "object"
      && !( isArray(jsonml[ 1 ]) )
      ? jsonml[ 1 ]
      : undefined;
}



/**
 *  renderJsonML( jsonml[, options] ) -> String
 *  - jsonml (Array): JsonML array to render to XML
 *  - options (Object): options
 *
 *  Converts the given JsonML into well-formed XML.
 *
 *  The options currently understood are:
 *
 *  - root (Boolean): wether or not the root node should be included in the
 *    output, or just its children. The default `false` is to not include the
 *    root itself.
 */
expose.renderJsonML = function( jsonml, options ) {
  options = options || {};
  // include the root element in the rendered output?
  options.root = options.root || false;

  var content = [];

  if ( options.root ) {
    content.push( render_tree( jsonml ) );
  }
  else {
    jsonml.shift(); // get rid of the tag
    if ( jsonml.length && typeof jsonml[ 0 ] === "object" && !( jsonml[ 0 ] instanceof Array ) ) {
      jsonml.shift(); // get rid of the attributes
    }

    while ( jsonml.length ) {
      content.push( render_tree( jsonml.shift() ) );
    }
  }

  return content.join( "\n\n" );
};

function escapeHTML( text ) {
  return text.replace( /&/g, "&amp;" )
             .replace( /</g, "&lt;" )
             .replace( />/g, "&gt;" )
             .replace( /"/g, "&quot;" )
             .replace( /'/g, "&#39;" );
}

function render_tree( jsonml ) {
  // basic case
  if ( typeof jsonml === "string" ) {
    return escapeHTML( jsonml );
  }

  var tag = jsonml.shift(),
      attributes = {},
      content = [];

  if ( jsonml.length && typeof jsonml[ 0 ] === "object" && !( jsonml[ 0 ] instanceof Array ) ) {
    attributes = jsonml.shift();
  }

  while ( jsonml.length ) {
    content.push( render_tree( jsonml.shift() ) );
  }

  var tag_attrs = "";
  for ( var a in attributes ) {
    tag_attrs += " " + a + '="' + escapeHTML( attributes[ a ] ) + '"';
  }

  // be careful about adding whitespace here for inline elements
  if ( tag == "img" || tag == "br" || tag == "hr" ) {
    return "<"+ tag + tag_attrs + "/>";
  }
  else {
    return "<"+ tag + tag_attrs + ">" + content.join( "" ) + "</" + tag + ">";
  }
}

function convert_tree_to_html( tree, references, options ) {
  var i;
  options = options || {};

  // shallow clone
  var jsonml = tree.slice( 0 );

  if ( typeof options.preprocessTreeNode === "function" ) {
      jsonml = options.preprocessTreeNode(jsonml, references);
  }

  // Clone attributes if they exist
  var attrs = extract_attr( jsonml );
  if ( attrs ) {
    jsonml[ 1 ] = {};
    for ( i in attrs ) {
      jsonml[ 1 ][ i ] = attrs[ i ];
    }
    attrs = jsonml[ 1 ];
  }

  // basic case
  if ( typeof jsonml === "string" ) {
    return jsonml;
  }

  // convert this node
  switch ( jsonml[ 0 ] ) {
    case "header":
      jsonml[ 0 ] = "h" + jsonml[ 1 ].level;
      delete jsonml[ 1 ].level;
      break;
    case "bulletlist":
      jsonml[ 0 ] = "ul";
      break;
    case "numberlist":
      jsonml[ 0 ] = "ol";
      break;
    case "listitem":
      jsonml[ 0 ] = "li";
      break;
    case "para":
      jsonml[ 0 ] = "p";
      break;
    case "markdown":
      jsonml[ 0 ] = "html";
      if ( attrs ) delete attrs.references;
      break;
    case "code_block":
      jsonml[ 0 ] = "pre";
      i = attrs ? 2 : 1;
      var code = [ "code" ];
      code.push.apply( code, jsonml.splice( i, jsonml.length - i ) );
      jsonml[ i ] = code;
      break;
    case "inlinecode":
      jsonml[ 0 ] = "code";
      break;
    case "img":
      jsonml[ 1 ].src = jsonml[ 1 ].href;
      delete jsonml[ 1 ].href;
      break;
    case "linebreak":
      jsonml[ 0 ] = "br";
    break;
    case "link":
      jsonml[ 0 ] = "a";
      break;
    case "link_ref":
      jsonml[ 0 ] = "a";

      // grab this ref and clean up the attribute node
      var ref = references[ attrs.ref ];

      // if the reference exists, make the link
      if ( ref ) {
        delete attrs.ref;

        // add in the href and title, if present
        attrs.href = ref.href;
        if ( ref.title ) {
          attrs.title = ref.title;
        }

        // get rid of the unneeded original text
        delete attrs.original;
      }
      // the reference doesn't exist, so revert to plain text
      else {
        return attrs.original;
      }
      break;
    case "img_ref":
      jsonml[ 0 ] = "img";

      // grab this ref and clean up the attribute node
      var ref = references[ attrs.ref ];

      // if the reference exists, make the link
      if ( ref ) {
        delete attrs.ref;

        // add in the href and title, if present
        attrs.src = ref.href;
        if ( ref.title ) {
          attrs.title = ref.title;
        }

        // get rid of the unneeded original text
        delete attrs.original;
      }
      // the reference doesn't exist, so revert to plain text
      else {
        return attrs.original;
      }
      break;
  }

  // convert all the children
  i = 1;

  // deal with the attribute node, if it exists
  if ( attrs ) {
    // if there are keys, skip over it
    for ( var key in jsonml[ 1 ] ) {
        i = 2;
        break;
    }
    // if there aren't, remove it
    if ( i === 1 ) {
      jsonml.splice( i, 1 );
    }
  }

  for ( ; i < jsonml.length; ++i ) {
    jsonml[ i ] = convert_tree_to_html( jsonml[ i ], references, options );
  }

  return jsonml;
}


// merges adjacent text nodes into a single node
function merge_text_nodes( jsonml ) {
  // skip the tag name and attribute hash
  var i = extract_attr( jsonml ) ? 2 : 1;

  while ( i < jsonml.length ) {
    // if it's a string check the next item too
    if ( typeof jsonml[ i ] === "string" ) {
      if ( i + 1 < jsonml.length && typeof jsonml[ i + 1 ] === "string" ) {
        // merge the second string into the first and remove it
        jsonml[ i ] += jsonml.splice( i + 1, 1 )[ 0 ];
      }
      else {
        ++i;
      }
    }
    // if it's not a string recurse
    else {
      merge_text_nodes( jsonml[ i ] );
      ++i;
    }
  }
}

} )( (function() {
  if ( false ) {
    window.markdown = {};
    return window.markdown;
  }
  else {
    return exports;
  }
} )() );


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1072);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1073);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(1071)))

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = [{"tags":"qatar-charity","title":"Qatar Charity","body":"This view shows how Qatar has opened a branch of one of its most important funding infrastructures – [Qatar Charity](/node/148) (QC) – in London and how it's funding Islamist projects in the West.\n\n## The Role of Qatar\nThe emirate of Qatar has been known for many years as a strong supporter of Islamist movements. Not only did Qatar provide infrastructure and facilities for organizations tied to the [Global Muslim Brotherhood](/node/48) and Hamas, but it also supported other conservative Sunni Islamist movements. As this report documents for the first time, the scale of such Qatari \"dawah\" activities are much bigger than expected. Qatar Charity has ties to Global Muslim Brotherhood through Qatar Charity UK and to the [Yemeni Muslim Brotherhood UK](/node/10) through The Emaan Trust project in the UK.\n\n**[Continue >](/tags/qcuk)**"},{"tags":"qcuk","title":"Qatar Charity in the UK","body":"[Qatar Charity UK](/node/1) (QCUK) was established ostensibly because of a need to supervise growing QC projects in the UK & Europe. From its inception, QCUK has had strong ties to the [Muslim Brotherhood UK](/node/26) and [Muslim Brotherhood Europe](/node/158), and most known QCUK expenditures are being directed to Muslim Brotherhood-related projects in the UK and Europe. Most of the Emaan Trust officers have problematic ties to the UK and [Global Muslim Brotherhood](/node/48), Islamism, or extremism/terrorism.\n\nQCUK has six direct or indirect connections to terror organizations. \n\n## Qatar's Direct Ties to a Terror Organization \n\nQCUK has a direct tie to the terror organization [Global Muslim Brotherhood](/node/48).\n\nMoreover, QCUK has several indirect ties to [Muslim Brotherhood UK](/node/26). One tie is through [Hafez Ahmad Ahmad](/node/72). He listed his Occupation as “Director” and used a [QCUK](/node/1) address as his correspondence address. Hafez Ahmad Ahmad is also the charity manager for the [Kassim Bin Mohammed Al-Thani Mayfair Islamic Centre](/node/75) (MIC), named after the founder of Qatar and formerly known as the Qatar Islamic Centre. \n\n[Hafez Ahmad Ahmad](/node/72) is a former Director of [QCUK](/node/1). He is highly relevant in understanding the charity’s history and likely serves as an alias for [Hafez Al-Karmi](/node/72), best known as a leader in the [Palestinian Forum In Britain](/node/73) (PFB), a part of the [Muslim Brotherhood UK](/node/26) and [Hamas](/node/74) support infrastructure.\n\n[Hassan Alkatib](/node/24) is a Leeds resident, who has listed his profession as “Property Development Consultant,” who was described by UK media as “an active member of the Muslim Brotherhood.” Alkatib is also known to have been a former director of the [Leeds Grand Mosque](/node/25) and an officer in multiple companies tied to the [UK Muslim Brotherhood](/node/26).\n\nOne of the [QCUK](/node/1) projects in the UK, a mosque complex called [The Emaan Trust](/node/7), is the latest in a series of attempts by the [Europe Trust](/node/6) to covertly build large Islamic facilities in European cities controlled by the [Global Muslim Brotherhood](/node/48).\n\n[The Emaan Trust](/node/7) Sheffield project focuses on UK converts to Islam and providing facilities for the [Yemeni Muslim Brotherhood UK](/node/10).  \n\nThe [European Institute Of Human Sciences](/node/162) (EIHS) in presumably the same organization as the [Institut Européen des Sciences Humaines](/node/162) (IESH), an educational and imam training facility in France associated with the [Federation Of Islamic Organizations In Europe](/node/3) (FIOE) and its French member the [Union Des Organisations Islamiques De France](/node/163) (UOIF). Both FIOE and UOIF represent the [Muslim Brotherhood Europe](/node/158).\n\n No further information was available on the [All-Ukrainian Association Of Social Organisations](/node/168) project. However, the website of the [All-Ukrainian Association Of Social Organisations](/node/168) (Alraid), the Ukrainian member organization of [Federation Of Islamic Organizations In Europe](/node/3) (FIOE), lists the [Qatar Charity](/node/148) organization as one of its \"Partners and Donors.\" Alraid is tied to the [Muslim Brotherhood Europe](/node/158).\n\n[Ayyoub Abouliaqin](/node/70), national and [QCUK](/node/1) Director General, is a member of the Conseil D'administration of the [Association Des Musulmans D'Alsace](/node/71) (AMAL), which is affiliated with the [Muslim Brotherhood France](/node/149).\n\nEuropean [QCUK](/node/1) trustees [Ayyoub Abouliaqin](/node/70) and [Hafez Ahmad Ahmad](/node/72) (aka Hafiz Karmi) are important leaders in [Muslim Brotherhood UK](/node/26) and [Muslim Brotherhood Europe](/node/158), with an apparent attempt made to obscure the true identity of Ahmad.\n\n**[Continue >](/tags/qcuk+history)**"},{"tags":"qcuk,history","title":"History of Qatar charity in the United Kingdom","body":"This report further identifies individuals most heavily involved in [Qatar Charity's UK](/node/1) (QCUK) work in London – many of them with ties to the [Global Muslim Brotherhood](/node/48). Furthermore, this report reveals connections between [QCUK](/node/1) and [Europe Trust](/node/6), another important funding vehicle for Brotherhood activists in the West. Many different organizations are using the same address. [QCUK](/node/1) also frequently changed its past directors/trustees with some new leaders having deep ties to the [Muslim Brotherhood](/node/48). \n\n## Incorporation\n[QCUK](/node/1) was incorporated on March 26, 2012, by an agent identified as [Saleh Saeed](/node/139) using an address in West Bromwich, UK. According to UK corporate records, Saleh Saeed is also a director of the following three companies:\n\n- [Zakat House](/node/140)\n- [Yemeni Community Association In Sandwell Limited](/node/141)\n- [Disasters Emergency Committee](/node/142)\n\nThe address used for registration is associated with [Zakat House](/node/140). Three founding directors were appointed:\n\n- [Jassim Salem Al-Ansari](/node/143), Qatari, aid worker\n- [Yousuf Ahmad Al-Kuwari](/node/67), Qatari, CEO of Qatar Charity\n- [Yousuf Ahmed Hassan Al-Hammadi](/node/144), Qatari, businessman\n\nOn January 14, 2013, two directors, Jassim Al-Ansari and Yousuf Al-Hammadi, resigned and four new directors were appointed:\n\n- [Hafez Ahmed Ahmed](/node/72), British\n- [Ijaz Ahmad](/node/150), British\n- [Salman Mohammed Ali A. M. Kaldari](/node/151), Qatari, businessman\n- [Mohammed Ali Al-Ghamdi](/node/169), Qatari, executive director\n\nOn March 31, 2013, the total exemption small company accounts document showed that QCUK had only £900 in the bank.\n\nOn December 20, 2013, QCUK's registered address was changed to 115 Park Street, London W1K 7AP.\n\n## QCUK Opening \nAccording to Gulf media reports in June 2014, the London office of [Qatar Charity UK](/node/1) (QCUK) was opened by a QC delegation headed by QC Chairman [Sheikh Hamad Bin Nasser Al Thani](/node/66) and QC CEO [Yusuf Bin Ahmed Al Kuwari](/node/67). Also present were Qatari Ambassador [Khalid Bin Rashid Al Mansouri](/node/137), a high-level delegate from the Qatari embassy, and [Salman Galadari](/node/138), the Managing Director of the new office. \n\n[Qatar Charity UK](/node/1) was registered with the UK Charity Commission on March 27, 2012. Other names listed for the charity are:\n\n- Qatar Charity UK (Old Name)\n- QCUK (Working Name)\n- Nectar Trust (Working Name)\n\n## QCUK Directors\nThe registered contact is listed as [Ayyoub Abouliaqin](/node/70), the QCUK Director General. \nQCUK Trustees are:\n\n- [Yousuf Al Kuwari](/node/67)\n- [Salah Ahmed Alhammadi](/node/68)\n- [Mohammed Saadon Alkuwari](/node/146)\n\nIn a June 2014 Arabic interview, QCUK’s General Manager [Ayyoub Abouliyaqin](/node/70) stressed the importance of choosing the UK as a base of operation, saying that almost half of Qatar’s foreign investments went there and that the UK has a long history of involvement in humanitarian work. According to Abouliyaqin, one of [QCUK’s](/node/1) aims is to form cooperation with UK humanitarian bodies by focusing on four fields: education, tutoring, economy, and humanitarian work. \n\nOn April 10, 2015, two new directors were appointed:\n\n- [Mohammed Saadon Al-Kuwari](/node/146), Qatari, director\n- [Salah Ahmed Al-Hammadi](/node/68), Qatari, director\n\nOn February 4, 2016, [Hafez Ahmed Ahmed](/node/72), [Ijaz Ahmad](/node/150), [Salman Mohammed Ali A. M. Kaldari](/node/151), and [Mohammed Ali Al-Ghamdi](/node/169) were terminated as directors. \n\n## QCUK Ties to Terror Organizations\n[QCUK](/node/1) has direct ties to the [Global Muslim Brotherhood](/node/48). QCUK has had strong ties to the [Muslim Brotherhood UK](/node/26) and [Muslim Brotherhood Europe](/node/158), and most known QCUK expenditures are being directed to Muslim Brotherhood-related projects in the UK and Europe.\n\n[Hassan Alkatib](/node/24), a Leeds resident who has listed his profession as “Property Development Consultant,” was described by UK media as “an active member of the Muslim Brotherhood.” Alkatib is also known to have been a former director of the [Leeds Grand Mosque](/node/25) and an officer in multiple companies tied to the [UK Muslim Brotherhood](/node/26).\n\nThe third largest [QCUK](/node/1) expenditure (£638,695) was for the [Sheffield Project, Emaan Trust](/node/7), a “multipurpose center” that will contain a nursery, full-time school, social and cultural center with a multipurpose hall, library and restaurant, prayer hall, gym, and parking. [The Emaan Trust](/node/7) Sheffield project focuses on UK converts to Islam and providing facilities for the [Yemeni Muslim Brotherhood UK](/node/10).\n\n[Ayyoub Abouliaqin](/node/70), national and [QCUK](/node/1) Director General, is a member of the Conseil D'administration of the [Association Des Musulmans D'Alsace](/node/71) (AMAL), which is affiliated with [Muslim Brotherhood France](/node/149).\n\n**[Continue >](/tags/qcuk+leadership)**"},{"tags":"qcuk,leadership","title":"Qatar Charity Leadership in the UK","body":"The past and current leadership of QCUK have substantial connections to Qatari business entities or serve as Qatari government officials. Additionally, there are many noteworthy connections to entities strongly associated with the [Global Muslim Brotherhood](/node/48) such as the [Association Des Musulmans D'Alsace](/node/71) (AMAL), the [Palestinian Forum Britain](/node/73) (PFB), and others. \n\n## Hafez Ahmad Ahmad \n[Hafez Ahmad Ahmad](/node/72) (born on April 21, 1961) is a British national resident in England who was appointed as a [QCUK](/node/1) Director on January 14, 2013, and resigned on February 4, 2016. He listed his occupation as “Director” and used a [QCUK](/node/1) address as his correspondence address.\n As a former Director, \n[Hafez Ahmad Ahmad](/node/72) is highly relevant in understanding the charity’s history and likely serves as an alias for [Hafez Al-Karmi](/node/72), best known as a leader in the [Palestinian Forum In Britain](/node/73) (PFB), a part of the [Muslim Brotherhood UK](/node/26) and [Hamas](/node/74) support infrastructure.\n\nGiven that [Hafez Ahmad Ahmad](/node/72) and Hafez Al-Karmi use the same address and date of birth, it is believed that these are the same individuals. This would appear to be confirmed by the use of the names Anas Ahmad and Anas Alkarmi by an individual believed to be Hafez's son who is listed as Anas Ahmad at the same London address, and by the use of both names in UK Charity Commission documents.\n\n## Salah Ahmed Al-Hammadi\nAccording to UK corporate records, [Salah Ahmed Al-Hammadi](/node/68) is a 33-year-old Qatari national described by Italian media reports in March 2016 as Vice-President of the English headquarters of the [Qatar Charity](/node/148) and responsible for projects in Europe. Ahmed Al-Hammadi is presumably a relative of other Hammadis working for QC, but this could not be confirmed. \n\nHis postings on Facebook, mainly in Arabic with some in English, include emotions about the fall of the Morsi government and anti-Israel sentiment. He has 154 friends including Anis Al-Rawi, Chakib Benmakhlouf, Anas Al-Tikriti, Foaud Alaoui, and Aboulkheir Breigheche. \n\nOther items of interest from his Facebook account include: \n\n- Many posts discussing the overthrow of the Muslim Brotherhood government in Egypt.\n- Posting a link from an Arab website that translated a New York Times article allegedly showing involvement of Saudi Arabia and the UAE with the overthrowing of the Morsi regime in Egypt.\n- Posting a picture of Ahmed Al-Hammadi making the Rabi’a sign.\n- Posting a profile picture with the Rabi’a sign in it.\n- Posting pictures and messages from Kuwaiti Muslim Brotherhood leader Tariq Suwaidan.\n- Posting “It’s true that I love MB. And my views might be considered biased by many.”\n- Posting “I was supporting Hizbollah when they were resisting Israel.” And following a comment on Hizbollah, “Nothing is totally good or totally bad.”\n\n## Ayyoub Abouliaqin\nThe [QCUK](/node/1) website and UK Charity Commission reports identify [Ayyoub Abouliaqin](/node/70) as the QCUK Director General, although he's not listed in the QCUK Company House records. \n\nAccording to other UK corporate records, Abouliaqin is a 44-year-old French national who, according to a French legal notice, was born in Douar-Zhiriyne, Morocco. Abouliaqin is currently listed as a member of the Conseil D’administration of the [Association Des Musulmans D'Alsace](/node/71) (AMAL/Mosquée Annour). In May 2015, a local media report identified him as a past AMAL Secretary General.  The same report also noted that AMAL is affiliated with the [Union Des Organisations Islamiques De France](/node/163) (UOIF), essentially [Muslim Brotherhood France](/node/149).\n\n## Ahmed Al-Rawi \n[Ahmed Al-Rawi](/node/32) is a 69-year-old British national resident in England best known as the former President of the [Federation Of Islamic Organizations In Europe](/node/3) (FIOE) and the [Muslim Association Of Britain](/node/18) (MAB). He is currently the head of the [Europe Trust](/node/6), which has ties to [Muslim Brotherhood UK](/node/26).\n\n## Hassan Alkatib\n[Hassan Alkatib](/node/24) is a Leeds resident who has listed his profession as “Property Development Consultant.” The UK media described him as “an active member of the Muslim Brotherhood” and a former director of the [Leeds Grand Mosque](/node/25). Alkatib is also known to have been an officer in multiple companies tied to the [Muslim Brotherhood UK](/node/26). Akram Bonham is a Facebook friend with the following individual known to be connected to the [Global Muslim Brotherhood](/node/48):\n\n - [Hassan Alkatib](/node/24) [(Leeds Grand Mosque)](/node/25)\n\n## Muslim Brotherhood Europe\nThe second largest [QCUK](/node/1) expenditure of £736,690 was for the “EIHS in Chateau Chinon.\" The [European Institute Of Human Sciences](/node/162) (EIHS) is presumably the same organization as the [Institut Européen des Sciences Humaines](/node/162) (IESH), an educational and imam training facility in France associated with the [Federation Of Islamic Organizations In Europe](/node/3) (FIOE) and its French member the [Union Des Organisations Islamiques De France](/node/163) (UOIF). Both FIOE and UOIF represent the [Muslim Brotherhood In Europe](/node/158).\n\n## Yemeni Muslim Brotherhood UK\n[The Emaan Trust](/node/7) Sheffield project appears to be focused on UK converts to Islam and providing facilities for the [Yemeni Muslim Brotherhood UK](/node/10).\n\n## Palestinian Forum in Britain\nA full profile of the [Palestinian Forum In Britain](/node/73) (PFB) is beyond the scope of this report. However, PFB has been described as a part of the [Muslim Brotherhood UK](/node/26) and [Hamas](/node/74) support infrastructure.\n\n[Hafez Ahmad Ahmad](/node/72) is a former Director of [QCUK](/node/1), making him highly relevant in understanding the charity’s history. In addition, Hafez Ahmad Ahmad likely serves as an alias for Hafez Al-Karmi, best known as a leader in the PFB.\n\n**[Continue >](/tags/qcuk+funding)**"},{"tags":"qcuk,funding","title":"Qatar Charity UK Funding","body":"According to the 2015 QCUK Charity Commission report, £3,760,768 was expended on programmatic charitable activity with 7 big projects being funded with this money.\n\n1. [Community Development](/node/161) \n\nThe bulk of the funds, £2,069,615, was spent on “Community Development” for two projects in the UK and one in Europe. The funding is described as being used for the purchase or construction of community centers where marriage functions can be hosted, youth can be involved in sports activities, day care centers for mothers, prayer areas, shops and classrooms for teaching Arabic, and for tuition. \n\n2. [EIHS In Chateau Chinon](/node/162)\n\nThe second largest [QCUK](/node/1) expenditure, £736,690, was for  the “[EIHS In Chateau Chinon](/node/162).” The EIHS is presumably the same organization as the Institut Européen des Sciences Humaines (IESH), an educational and imam training facility in France associated with the [Federation of Islamic Organizations In Europe](/node/3) (FIOE) and its French member the [Union Des Organisations Islamiques De France](/node/163) (UOIF). Both FIOE and UOIF represent the [Muslim Brotherhood in Europe](/node/158). The project is comprised of three buildings where the EIHS “wishes to expand and revamp its premises to transform from an institute to a university campus.” \n\n3. [Sheffield Project, Emaan Trust](/node/7) \n\nThe third largest [QCUK](/node/1) expenditure, £638,695, was for the “Sheffield Project, Emaan Trust\" for a “multipurpose center” that will contain a nursery, full-time school, social and cultural center with a multipurpose hall, library and restaurant, prayer hall, gym, and parking. \nThis Sheffield mosque complex, near completion or already completed, is the latest in a series of attempts by the [Europe Trust](/node/6) to covertly build large Islamic facilities in European cities controlled by the [Muslim Brotherhood](/node/48). The [Emaan Trust](/node/7) Sheffield project appears to be focused on providing facilities for the [Yemeni Muslim Brotherhood UK](/node/10) and centers on UK converts to Islam. Many of the [Emaan Trust](/node/7) officers have problematic ties to the [Muslim Brotherhood](/node/48), Islamism, and/or terrorism. \n\n4. [Swansea University Campus](/node/164)\n\nThe fourth largest [QCUK](/node/1) expenditure, £85,318, was for the [Swansea University Campus](/node/164) to build a lecture theatre, meeting rooms, administrative offices, crèche providing childcare, classrooms for teaching Arabic, prayer hall, and parking. It is likely but not confirmed that these construction projects relate to the mosque located at Swansea University in Swansea, Wales. Swansea is a location where “[EIHS](/node/162) officials are known to have lived.\" \n\n5. [Multipurpose Center Mulhouse ](/node/165)\n\nThe fifth largest [QCUK](/node/1) expenditure, £56,530, was for the “[Multipurpose Center Mulhouse](/node/165).” \nThis funding is presumably for the same project referred to in the document as the “Al Huda Project in Illzach (Suburb of Mulhouse)” that was canceled as a result of “internal due diligence” with the funding being evaluated for another community center project. \n\n6. [Ukraine Students](/node/166)\n\nThe sixth largest [QCUK](/node/1) expenditure, £85,318, was for the “Swansea University Campus” to contribute toward university fees for needy students. No further information was available on this project. However, the website of the [All-Ukrainian Association of Social Organisations](/node/168) (Alraid), the Ukrainian member organization of [Federation of Islamic Organizations In Europe](/node/3) (FIOE), lists the [Qatar Charity](/node/148) organization as one of its “Partners and Donors.” \n\n7. [Iftaar UK](/node/167)\n\nThe seventh largest [QCUK](/node/1) expenditure, £26,289, was for the “[Iftaar UK](/node/167)” in providing 26 grants to support local organizations around the UK and Europe to prove Iftar (Ramadan meals) to poor individuals and the wider community. This expenditure is most likely the same as the “Ramadan Tent Project” in which [QCUK](/node/1) was reported to be working with over 20 UK charitable organizations in order to prove Ramadan meals. Most of these organizations are known to be tied to a terror organization infrastructure in the UK. \n\n**[Continue >](/tags/sheffield+history)**"},{"tags":"sheffield,history","title":"Sheffield History","body":"The third largest [QCUK](/node/1) expenditure, £638,695, was for the [Sheffield Project, Emaan Trust](/node/7). This report describes the QCUK expenditure on this project as follows: \n\n\"The grant provided by [Qatar Charity](/node/148) will be utilized to build a multipurpose center providing diverse and integrated services to different segments and categories of the community. The center will contain the following units: nursery, full-time school, social and cultural center with a multipurpose hall, library and restaurant, prayer hall, gym, and parking.\" \n\nOn July 31, 2006, the Sheffield UK City Council Planning Department received a planning application letter for the [Botham Street Mosque And Islamic Centre](/node/11) signed on behalf of [Catalyst Regeneration](/node/8) by [Akram Bonham](/node/58) (MCIAT), head of the Building Design Department. \n\n## Local Media – Sheffield UK\nIn January 2007, local media in Sheffield UK, a city and metropolitan borough of approximately 1.5 million in South Yorkshire, England, reported on the controversy surrounding the proposed construction of a new suburban mosque. \n\nAccording to the report: \n\"On a wet and windswept January morning it doesn’t look much. The tangle of grass, weeds, trees and bushes at the corner of Petre and Botham Streets, Grimesthorpe even seems a little grim. But this unremarkable plot of suburban Sheffield has become a battleground between two cultures. The 0.83 acres of land promised to the Yemeni Community is set to become the home of a new 3 million mosque on the hill overlooking the lower Don Valley. Local residents want to keep it as a haven for wildlife, and don’t want the traffic from up to 500 Muslim worshippers, who will use the mosque and community center at busy times. The Muslim community says it needs the land for a bigger mosque than its current home on Rothay Road. Residents say they need to keep it for the foxes, squirrels, kestrels and woodpeckers that have made its apple trees and silver birches their home. Sheffield City Council planners believe the land is ideal for a new mosque and sold it to the Yemeni community for 140,000 in 2005. Now they have a fight on their hands. Residents are writing letters by the score, collecting petitions and mobilising opposition to the proposed three store building and its minaret tower.\" \n\nThe article went on to identify [Hameed Al-Asaly](/node/14) and the Birmingham-based company behind the proposed mosque, [Catalyst Regeneration (UK) LTD](/node/8). Al-Asaly was reported to be the chairman of the committee managing the project for [Catalyst Regeneration](/node/8). The article further reported that Sheffield Muslims, including former world boxing champion [Naseem Hamed](/node/15), would be asked to pay for the proposed mosque. \n\nIn February 2008, local media reported that the mosque project had been approved. However, the Planning Department file ends around this time, and no further relevant activity takes place until September 2010 when an application was made to replace the extant planning permission with a newly created Planning Department file. The applicant was [Hameed Al-Asaly](/node/14) who listed the [Al-Emaan Trust](/node/7) as the company at an address in Sheffield.  \n\nA UK company known as the Emaan Trust of Sheffield was incorporated on January 30, 2009, and a charity with the name [The Emaan Trust](/node/7) was registered with the UK Charity Commission on September 28, 2009.  The agent listed for the incorporation was [Omer Al-Hamdoon](/node/17), likely the current President of the [Muslim Association Of Britain](/node/18) (MAB), using the address of the [Muslim Welfare House Of Sheffield](/node/19). \n\nThree initial officers of the company were listed: \n\n- [Saleh Ali Alnoud](/node/20) (Secretary) \n- [Aiman Mohammed Ebrahim Saeed](/node/21) (Director) \n- [Saleh Mohamed Hussein](/node/22) (Director) \n\nOn June 6, 2009, [The Emaan Trust](/node/7) filed a Memo of Association with UK corporate authorities. The document can be generally described as “boilerplate” and was signed by 14 subscribers, 12 of whom are identified as [Emaan Trust](/node/7) officers/trustees. Two additional subscribers of interest are listed as signatories: \n\n## Hassan Alkatib\n[Hassan Alkatib](/node/24) is a Leeds resident who listed his profession as “Property Development Consultant.” UK media described him as “an active member of the [Muslim Brotherhood](/node/48).” [Hassan Alkatib](/node/24) is also known to have been a former director of the [Leeds Grand Mosque](/node/25) and an officer in multiple companies tied to the [UK Muslim Brotherhood](/node/26). \n\n## Mokhtar Badri\nThe document also identifies [Mokhtar Badri](/node/36) as the Project Manager with a Wembley address associated with the [Muslim Association Of Britain](/node/18) (MAB). In 2008, UK media identified Badri as the vice-president of the MAB.\n\n## Foundation Stone Laid\nIn October 2011, [The Emaan Trust](/node/7) of Sheffield website reported that the project's foundation stone had been laid and in July 2012 that \"the foundation work has begun and this stage will include the highway work, drainage, steel frame and building the skeleton for all four floors. This stage will take from six to seven months and will cost 950,000 sterling pounds. The amount we currently have is 610,000 sterling pounds.\" \n\nOn May 22, 2013, the registered office for [The Emaan Trust](/node/7) was changed to a Sheffield address that is part of so-called Council Housing.\n\n## Project Unveiled to Public\nIn June 2013, local media reported that plans for the project would be unveiled to the public: \n\"Members of the public had the chance to look at details of a multi-million pound mosque and Islamic center in Sheffield. The £5 million development is taking place on Petre Street, Burngreave, by the Emaan Trust. Representatives from the police, council and other religions were invited to see the plans and speak to the trust staff at the Mercure St Paul’s Hotel, in the city center. The mosque is under construction at present.\" \n\nA Sheffield Planning Commission document indicates that work on the project started during “summer 2013” after being on hold for “some time.” On August 2013, residents reported that construction work was underway at the site.   \n\n## Disappearing Act with £2 Million\nOne resident claimed: \n\"I have heard from someone in the know that the guy in control of the finance to build the mosque has done a disappearing act with 2 million pounds, so work is on hold. The mosque will get built as it is funded by rich Saudi sheiks.\" \n\nOn February 1, 2016, [The Emaan Trust](/node/7) of Sheffield's website reported on what was expected to be the final phase of the project: \n\"The 4th phase is to complete the stones, the Doom, the Minatare, the Doors and Windows. The work is currently in progress and is expected to be completed in June 2016.\" \n\nAs the website reports no further progress, it's likely that the project is still not complete.\n\n**[Continue >](/tags/sheffield+leadership)**"},{"tags":"sheffield,leadership","title":"Sheffield Leadership","body":"Ten past and current leaders have strong ties to a terror organization. Other leaders are not mentioned in this network graphic.\n\n\n## Current Leadership\n\n### Hassan Alkatib\n[Hassan Alkatib](/node/24) is a Leeds resident who has listed his profession as “Property Development Consultant.” UK media described him as “an active member of the Muslim Brotherhood.” Alkatib is also known to have been a former director of the [Leeds Grand Mosque](/node/25) and an officer in multiple companies tied to the [UK Muslim Brotherhood](/node/26).\n \n### Hameed Al-Asaly (Director/Trustee/Chair/Executive Manager)\n[Hameed Al-Asaly](/node/14) is a 51-year-old British national whose listed correspondence address is social housing in Sheffield and also the registered address for [The Emaan Trust](/node/7). He was married to [Tracy A Al-Asaly](/node/42) at Sheffield in October 1997. In 2006 local media had identified Hameed Al-Asaly as part of the committee managing the mosque project for [Catalyst Regeneration](/node/8), although no record of employment was found for Al-Asaly in Catalyst Regeneration.  \n\n[Catalyst Regeneration's](/node/8) website explains that the company has been providing multi-disciplinary consultancy services to the construction industry for 30 years in the UK, Europe, and the Middle East. Although the website identifies many secular building projects in its portfolio, it also lists numerous mosques, Islamic centers, and Islamic educational facilities. \n\n### Mark Bonham\n[Mark Bonham](/node/58) is a 50-year-old British national resident in England based on multiple sources. It's highly likely the same individual referred to in this report as Akram Bonham, an Islamic convert who adopted Akram as an Arabic surname.\n\nFrom 1996 through 2008, he was the Managing Director for [Barb Services Ltd. UK](/node/59) and of an architectural consulting firm in Birmingham that, from October 2005 until July 2006, used an address associated with at least four other companies and charities tied to the [UK Muslim Brotherhood](/node/26):\n\n- [Europe Trust](/node/6) \n- [Tiseer Trust](/node/60) \n- [Rightstart Foundation](/node/61) \n- [Association Of Muslim Schools UK](/node/62)  \n\n### Ahmed Al-Rawi\n[Ahmed Al-Rawi](/node/32) is a 69-year-old British national resident in England who is best known as the former President of the [Federation Of Islamic Organizations In Europe](/node/3) (FIOE) and the [Muslim Association Of Britain](/node/18) (MAB). He is currently the head of the [Europe Trust](/node/6).\n        \n### Khalid Al-Mathkoor (Honored Chair)\n[Khalid Al-Mathkoor](/node/103) is a 70-year-old Kuwaiti national resident in Kuwait who obtained a Ph.D. in Comparative Jurisprudence from Al-Azhar University in 1978. He's a Professor in comparative jurisprudence and Shariah governance and politics at the Faculty of Shariah, University of Kuwait. Al-Mathkoor has been described as a “religious conservative” and has made remarks strongly defending the [Muslim Brotherhood](/node/48).\n\n### Mutlaq Al-Qarawi (Trustee/Director)        \n[Mutlaq Al-Qarawi](/node/112) is a 64-year-old Kuwaiti national resident in Kuwait who is best known as an official of the [Ministry Of Awqaf & Islamic Affairs in Kuwait](/node/41) where he has been referred to variously as Assistant Undersecretary, Director of the Media Department, Assistant Undersecretary for Technical Affairs and Foreign Affairs, and Assistant Undersecretary. \n\n[Mutlaq Al-Qarawi](/node/112) has attracted substantial media attention in the Netherlands with his role in the [Blauwe Moskee In Slotervaart](/node/115) (Blue Mosque in Slotervaart), a mosque and cultural center in Amsterdam initially funded by the [Europe Trust](/node/6) and headed by [Ahmed Al-Rawi](/node/32) with whom [Mutlaq Al-Qarawi](/node/112) has had a long-standing relationship. On March 29, 2013, [Mutlaq Al-Qarawi](/node/112) was part of a Kuwaiti delegation that attended an education forum of the [Islamic Society Of North America](/node/116) (ISNA) in Rosemont, Illinois. ISNA is a large Islamic umbrella group central to the [Muslim Brotherhood US](/node/117). \n\n### Abdulrazaq Buqara\n[Abderrezak Buqara](/node/30) is a Mathematics Teacher at the Meadowhead School in Sheffield, works at the Birley Community College, and is a Muslim Religious Advisor at the University of Sheffield. \n\nFrom February 2013 – February 2014, he was also President of [The National Association Of Schoolmasters Union Of Woman Teachers](/node/118) (NASUWT). Buqara is also a past chairman of the [Muslim Association Of Britain](/node/18) (MAB) and a current director of the [MAB Charitable Trust](/node/119). He is also a trustee of the [Muslimaat Sheffield Association Of Muslim Women And Girls](/node/152), discussed above in connection with [Hameed Al-Asaly](/node/14) and likely tied to the [MAB](/node/18), and an Executive Committee Member of the [Muslim Welfare House](/node/19) in Sheffield, also close to the MAB. A photo on his Facebook page displays the Rabia symbol, associated with support for the [Muslim Brotherhood](/node/48).\n        \n### Amina Blake (Trustee/Director)\n[Amina Blake](/node/121), also known as Ameena Ali, is a 41-year-old British national resident in England. She had adopted parents and converted to Islam in her late teens. She has worked as an English teacher for the Sheffield City Council and currently describes herself as a “strategic planning and leadership consultant” for unidentified organizations. She has numerous affiliations to groups associated with the UK and [Global Muslim Brotherhood](/node/48), including:\n\n- Vice-President of the [Muslim Association Of Britain](/node/18)(MAB)\n- Official of the [Muslim Council Of Britain](/node/122)\n- Associated with the [Native European Muslim Assembly](/node/45)\n- Trustee of [TIES](/node/123) (charity whose trustees are officials of the [Muslim Welfare House](/node/19) and WAMY)\n\n## Past Leadership\n\n### Adel Al-Falah (Trustee)\n[Adel Abdullah Al-Falah](/node/133) is a 63-year-old Kuwaiti national who has been the Undersecretary of the [Ministry Of Awqaf & Islamic Affairs in Kuwait](/node/41) since 1991. He has also been the Vice President of the Supreme Committee of Working towards Completing the Implementation of the Islamic Shariah of the Amiri Diwan. An Arab Times Kuwait report from August 27, 2014, said that the Deputy Prime Minister was not expected to renew the position of Al-Falah at the Ministry of Awqaf and appeared to link him to [Muslim Brotherhood](/node/48) activity in the country. It could not be confirmed whether or not [Adel Abdullah Al-Falah](/node/133) is currently employed by the Ministry.\n\n**[Continue >](/tags/sheffield+funding)**"},{"tags":"sheffield,funding","title":"Sheffield Funding","body":"According to [QCUK's](/node/1) annual reports, the banker for QCUK is the [Al Rayan Bank](/node/156). Formerly the Islamic Bank Of Britain and previously majority-owned by the [Qatar International Islamic Bank](/node/157), Al Rayan is known to provide banking services for [Muslim Brotherhood](/node/26)/[Hamas](/node/74) organizations in the UK. \n\nTheir website states target funding for the project is £7,414,000.00 with £4,214,000.00 of that amount already collected. [The Emaan Trust](/node/7) reports to the UK Charity Commission contain the following information about its charity’s donors and finances:\n\n- In 2013, contributions were broken down by country: £402,763 (Kuwait), £42,171 (UK), £1,485 (UAE), and £397,043 (Qatar).\n- In 2014, it was reported that the [Ministry of Awqaf in Kuwait](/node/41) donated £85,753 to the Emaan School and its Administration costs.\n- In 2015, it was reported that the total funds available were £2,384,255."}]

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_actions__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_AppBar__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Toolbar__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Typography__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_SvgIcon__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_SvgIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_TopMenu__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_IntegrationAutosuggest__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_Button__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_Button__);
var CONFIG=__webpack_require__(79);var InfoOutlineIcon=function InfoOutlineIcon(props){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_SvgIcon___default.a,props,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('path',{d:'M0 0h24v24H0z',fill:'none'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('path',{d:'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z'}));};var SaveIcon=function SaveIcon(props){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_SvgIcon___default.a,props,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('path',{d:'M0 0h24v24H0z',fill:'none'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('path',{d:'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z'}));};var Header=function(_React$PureComponent){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Header,_React$PureComponent);function Header(props){__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,Header);var _this=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.getSelected=_this.getSelected.bind(_this);return _this;}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Header,[{key:'openInfo',value:function openInfo(){var _props=this.props,app=_props.app,dispatch=_props.dispatch;if(app.tag){dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions__["f" /* infoDrawerStatusChange */])(!app.infodraweropened));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions__["b" /* drawerStatusChange */])(false));dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions__["a" /* closeIntro */])());}}},{key:'gotoHome',value:function gotoHome(){var dispatch=this.props.dispatch;dispatch(Object(__WEBPACK_IMPORTED_MODULE_6_actions__["i" /* showIntro */])());}},{key:'handleFilterClick',value:function handleFilterClick(filter){this.props.handleFilterClick(filter);}},{key:'getSelected',value:function getSelected(selected){var onSelectNode=this.props.onSelectNode;onSelectNode(selected.id);}},{key:'saveDisk',value:function saveDisk(){location.href=CONFIG.fileURL;}},{key:'render',value:function render(){var _this2=this;var app=this.props.app;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'root'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_AppBar___default.a,{position:'static',className:'header'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_Toolbar___default.a,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Typography___default.a,{type:'title',color:'inherit',className:'flex'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'logo',onClick:function onClick(){return _this2.gotoHome();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img',{src:CONFIG.logo_image,className:'logo_image',alt:'logo'}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'logo_title'},CONFIG.logo_title),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'logo_subtitle'},CONFIG.logo_subtitle))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'menu'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_TopMenu__["a" /* default */],{onHomeClick:function onHomeClick(){return _this2.gotoHome();},handleFilterClick:function handleFilterClick(filter){return _this2.handleFilterClick(filter);}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'searchbar'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_IntegrationAutosuggest__["a" /* default */],{nodes:app.allnodes.data,getSelected:this.getSelected}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_Button___default.a,{raised:true,className:'download-button',onClick:function onClick(){return _this2.saveDisk();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(SaveIcon,{className:'left-icon'}),'Full Text'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(InfoOutlineIcon,{className:'iconHover',onClick:function onClick(){return _this2.openInfo();}}))))));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);Header.propTypes={app:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,dispatch:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,handleFilterClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,onSelectNode:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired};function mapStateToProps(state){return{app:state.app};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps)(Header));

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export goTo */
/* unused harmony export hideAlert */
/* unused harmony export showAlert */
/* harmony export (immutable) */ __webpack_exports__["b"] = drawerStatusChange;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeIntro;
/* harmony export (immutable) */ __webpack_exports__["i"] = showIntro;
/* harmony export (immutable) */ __webpack_exports__["d"] = getNodes;
/* harmony export (immutable) */ __webpack_exports__["c"] = getEdges;
/* harmony export (immutable) */ __webpack_exports__["g"] = setDetail;
/* unused harmony export getHtml */
/* harmony export (immutable) */ __webpack_exports__["f"] = infoDrawerStatusChange;
/* harmony export (immutable) */ __webpack_exports__["e"] = getNodesByCountry;
/* harmony export (immutable) */ __webpack_exports__["h"] = setNodes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_constants_index__ = __webpack_require__(58);
/**
 * @module Actions/App
 * @desc App Actions
 *//**
 * Change route path.
 *
 * @param {string} pathname
 * @param {Object} [options]
 * @param {string} [options.param]
 * @param {string} [options.query]
 * @param {Object} [options.state]
 *
 * @returns {function}
 */function goTo(pathname){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["b" /* push */])({pathname:pathname,search:options.search,state:options.state});}/**
 * Hide message.
 *
 * @param {string} id
 * @returns {Object}
 */function hideAlert(id){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].HIDE_ALERT,payload:{id:id}};}/**
 * Show a message.
 *
 * @param {string} message
 * @param {Object} options
 * @param {string} options.type - Type of the alert. Available: success, error, warning, info, black
 * @param {number} [options.timeout] - Delay in seconds for the notification go away. Set this to 0 to not auto-dismiss the notification
 * @param {string} [options.position]
 * @param {string} [options.icon]
 *
 * @returns {Object}
 */function showAlert(message,options){var timeout=options.type==='error'?0:5;return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].SHOW_ALERT,payload:{id:options.id||__WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()(),icon:options.icon,message:message,position:options.position||'bottom-right',type:options.type,timeout:!isNaN(options.timeout)?options.timeout:timeout}};}function drawerStatusChange(draweropened){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].DRAWER_CHANGE,payload:{draweropened:draweropened}};}function closeIntro(){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].CLOSE_INTRO,payload:{}};}function showIntro(){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].SHOW_INTRO,payload:{}};}function getNodes(tag){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].GET_NODES,payload:{tag:tag}};}function getEdges(){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].GET_EDGES,payload:{}};}function setDetail(data){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].SET_DETAIL,payload:{data:data}};}function getHtml(){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].GET_HTML,payload:{}};}function infoDrawerStatusChange(draweropened){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].INFO_DRAWER_CHANGE,payload:{draweropened:draweropened}};}function getNodesByCountry(country){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].GET_NODES_BY_COUNTRY,payload:{country:country}};}function setNodes(nodes){return{type:__WEBPACK_IMPORTED_MODULE_2_constants_index__["a" /* ActionTypes */].SET_NODES,payload:{nodes:nodes}};}

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRepos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_index__ = __webpack_require__(58);
/**
 * @module Actions/User
 * @desc User Actions
 *//**
 * Get Repos
 *
 * @param {string} query
 * @returns {Object}
 */function getRepos(query){return{type:__WEBPACK_IMPORTED_MODULE_0_constants_index__["a" /* ActionTypes */].GITHUB_GET_REPOS_REQUEST,payload:{query:query}};}

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export login */
/* unused harmony export logOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_constants_index__ = __webpack_require__(58);
/**
 * @module Actions/User
 * @desc User Actions
 *//**
 * Login
 *
 * @returns {Object}
 */function login(){return{type:__WEBPACK_IMPORTED_MODULE_0_constants_index__["a" /* ActionTypes */].USER_LOGIN_REQUEST};}/**
 * Logout
 *
 * @returns {Object}
 */function logOut(){return{type:__WEBPACK_IMPORTED_MODULE_0_constants_index__["a" /* ActionTypes */].USER_LOGOUT_REQUEST};}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppBar = __webpack_require__(1080);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AppBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(81);

var _Paper = __webpack_require__(112);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Paper

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box', // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionStatic: {
      position: 'static',
      flexShrink: 0
    },
    colorDefault: {
      backgroundColor: theme.palette.background.appBar,
      color: theme.palette.getContrastText(theme.palette.background.appBar)
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

function AppBar(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      position = props.position,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'position']);


  var className = (0, _classnames2.default)(classes.root, classes['position' + (0, _helpers.capitalizeFirstLetter)(position)], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'inherit'), (0, _defineProperty3.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);

  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({ square: true, component: 'header', elevation: 4, className: className }, other),
    children
  );
}

AppBar.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   */
  color: _propTypes2.default.oneOf(['inherit', 'primary', 'secondary', 'default']),
  /**
   * The positioning type.
   */
  position: _propTypes2.default.oneOf(['static', 'fixed', 'absolute'])
} : {};

AppBar.defaultProps = {
  color: 'primary',
  position: 'fixed'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAppBar' })(AppBar);

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toolbar = __webpack_require__(1082);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toolbar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    }, theme.mixins.toolbar),
    gutters: theme.mixins.gutters({})
  };
};

function Toolbar(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableGutters = props.disableGutters,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableGutters']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.gutters, !disableGutters), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

Toolbar.propTypes =  false ? {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes2.default.bool
} : {};

Toolbar.defaultProps = {
  disableGutters: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiToolbar' })(Toolbar);

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block',
      fill: 'currentColor',
      height: 24,
      width: 24,
      userSelect: 'none',
      flexShrink: 0,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
};

function SvgIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'nativeColor', 'titleAccess', 'viewBox']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalizeFirstLetter)(color)], color !== 'inherit'), classNameProp);

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({
      className: className,
      focusable: 'false',
      viewBox: viewBox,
      color: nativeColor,
      'aria-hidden': titleAccess ? 'false' : 'true'
    }, other),
    titleAccess ? _react2.default.createElement(
      'title',
      null,
      titleAccess
    ) : null,
    children
  );
}

SvgIcon.propTypes =  false ? {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes2.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes2.default.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes2.default.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};

SvgIcon.defaultProps = {
  color: 'inherit',
  viewBox: '0 0 24 24'
};

SvgIcon.muiName = 'SvgIcon';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSvgIcon' })(SvgIcon);

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Button__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_styles__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_icons_ArrowDropDown__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_icons_ArrowDropDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_icons_ArrowDropDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_SvgIcon__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_SvgIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Icon__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MobileMenu__ = __webpack_require__(1092);
var CONFIG=__webpack_require__(79);var HomeIcon=function HomeIcon(props){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_SvgIcon___default.a,props,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('path',{d:'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'}));};var styles=function styles(theme){return{root:{display:'flex'},popperClose:{pointerEvents:'none'},icon:{cursor:'pointer'},button:{fontSize:'1em',height:40,float:'left'},rightIcon:{marginLeft:theme.spacing.unit},menuitem:{fontSize:'1em'},menuContent:{marginTop:30,zIndex:9999}};};var TopMenu=function(_React$PureComponent){__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TopMenu,_React$PureComponent);function TopMenu(){var _ref;var _temp,_this,_ret;__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this,TopMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this,(_ref=TopMenu.__proto__||Object.getPrototypeOf(TopMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={anchorEl:null},_this.handleMenu=function(event){_this.setState({anchorEl:event.currentTarget});},_this.handleClick1=function(event){_this.setState({anchorEl:event.currentTarget});},_this.handleClose1=function(filter){_this.setState({anchorEl:null});if(filter){var handleFilterClick=_this.props.handleFilterClick;handleFilterClick(filter);}},_this.handleClick2=function(event){_this.setState({anchorEl1:event.currentTarget});},_this.handleClose2=function(filter){_this.setState({anchorEl1:null});if(filter){var handleFilterClick=_this.props.handleFilterClick;handleFilterClick(filter);}},_this.handleClose=function(){if(_this.state.anchorEl){_this.setState({anchorEl:null});}if(_this.state.anchorEl1){_this.setState({anchorEl1:null});}if(_this.state.anchorEl2){_this.setState({anchorEl2:null});}},_this.handleClick3=function(event){_this.setState({anchorEl2:event.currentTarget});},_this.handleClose3=function(filter){_this.setState({anchorEl2:null});if(filter){var handleFilterClick=_this.props.handleFilterClick;handleFilterClick(filter);}},_this.handleDownload=function(){location.href=CONFIG.fileURL;},_temp),__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this,_ret);}__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TopMenu,[{key:'render',value:function render(){var _this2=this;var _props=this.props,classes=_props.classes,onHomeClick=_props.onHomeClick;var _state=this.state,anchorEl1=_state.anchorEl1,anchorEl=_state.anchorEl,anchorEl2=_state.anchorEl2;var open=Boolean(anchorEl);var open1=Boolean(anchorEl1);var open2=Boolean(anchorEl2);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{onClick:function onClick(){return _this2.handleClose();}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'topmenu'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(HomeIcon,{className:'iconHover',style:{float:'left'},onClick:function onClick(){return onHomeClick();}}),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Button___default.a,{className:classes.button,onClick:function onClick(){return _this2.handleClose1('qatar-charity');}},'Qatar Charity'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Button___default.a,{className:classes.button,'aria-owns':open?'menu-appbar':null,'aria-haspopup':'true',onClick:this.handleClick1},'Qatar Charity in UK',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_icons_ArrowDropDown___default.a,{className:classes.rightIcon})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu___default.a,{className:'menu-content',id:'menu-appbar',anchorOrigin:{vertical:'top',horizontal:'left'},transformOrigin:{vertical:'top',horizontal:'left'},open:open,anchorEl:anchorEl},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__["MenuItem"],{className:'menu-item',onClick:function onClick(){return _this2.handleClose1('qcuk');}},'Overview'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__["MenuItem"],{className:'menu-item',onClick:function onClick(){return _this2.handleClose1('qcuk+history');}},'History'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__["MenuItem"],{className:'menu-item',onClick:function onClick(){return _this2.handleClose1('qcuk+leadership');}},'Leadership'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__["MenuItem"],{className:'menu-item',onClick:function onClick(){return _this2.handleClose1('qcuk+funding');}},'Funding')),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Button___default.a,{className:classes.button,'aria-owns':open1?'menu-appbar1':null,'aria-haspopup':'true',onClick:this.handleClick2},'Emaan Trust',__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_icons_ArrowDropDown___default.a,{className:classes.rightIcon})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu___default.a,{id:'menu-appbar1',className:'menu-content',anchorOrigin:{vertical:'top',horizontal:'left'},transformOrigin:{vertical:'top',horizontal:'left'},open:open1,anchorEl:anchorEl1},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__["MenuItem"],{className:'menu-item',onClick:function onClick(){return _this2.handleClose2('sheffield+history');}},'History'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__["MenuItem"],{className:'menu-item',onClick:function onClick(){return _this2.handleClose2('sheffield+leadership');}},'Leadership'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Menu__["MenuItem"],{className:'menu-item',onClick:function onClick(){return _this2.handleClose2('sheffield+funding');}},'Funding'))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div',{className:'mobilemenu'},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Icon___default.a,{className:'iconHoverMobile',onClick:this.handleClick3},'menu'),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__MobileMenu__["a" /* default */],{isopen:open2,handleClose:function handleClose(filter){return _this2.handleClose3(filter);},handleDownload:function handleDownload(){return _this2.handleDownload();}})));}}]);return TopMenu;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);TopMenu.propTypes={classes:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,handleFilterClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,onHomeClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_material_ui_styles__["withStyles"])(styles)(TopMenu));

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(244);

var _ButtonBase = __webpack_require__(455);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.button, {
      lineHeight: '1.4em', // Improve readability for multiline button.
      boxSizing: 'border-box',
      minWidth: 88,
      minHeight: 36,
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 2 + 'px',
      borderRadius: 2,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        // Reset on mouse devices
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, 0.12),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    }),
    dense: {
      padding: theme.spacing.unit - 1 + 'px ' + theme.spacing.unit + 'px',
      minWidth: 64,
      minHeight: 32,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 1)
    },
    label: {
      width: '100%',
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },
    flatPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.12),
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    flatSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.12),
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    colorInherit: {
      color: 'inherit'
    },
    raised: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$keyboardFocused': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },
    keyboardFocused: {},
    raisedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    raisedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },
    disabled: {
      color: theme.palette.action.disabled
    },
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },
    mini: {
      width: 40,
      height: 40
    },
    fullWidth: {
      width: '100%'
    }
  };
};

function Button(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      dense = props.dense,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      fab = props.fab,
      fullWidth = props.fullWidth,
      mini = props.mini,
      raised = props.raised,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'dense', 'disabled', 'disableFocusRipple', 'fab', 'fullWidth', 'mini', 'raised']);


  var flat = !raised && !fab;
  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.raised, raised || fab), (0, _defineProperty3.default)(_classNames, classes.fab, fab), (0, _defineProperty3.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty3.default)(_classNames, classes.colorInherit, color === 'inherit'), (0, _defineProperty3.default)(_classNames, classes.flatPrimary, flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.flatSecondary, flat && color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes.raisedPrimary, !flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.raisedSecondary, !flat && color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes.dense, dense), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames), classNameProp);

  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({
      className: className,
      disabled: disabled,
      focusRipple: !disableFocusRipple,
      keyboardFocusedClassName: classes.keyboardFocused
    }, other),
    _react2.default.createElement(
      'span',
      { className: classes.label },
      children
    )
  );
}

Button.propTypes =  false ? {
  /**
   * The content of the button.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It's using the theme palette when that makes sense.
   */
  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Uses a smaller minWidth, ideal for things like card actions.
   */
  dense: _propTypes2.default.bool,
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * If `true`, will use floating action button styling.
   */
  fab: _propTypes2.default.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes2.default.string,
  /**
   * If `true`, and `fab` is `true`, will use mini floating action button styling.
   */
  mini: _propTypes2.default.bool,
  /**
   * If `true`, the button will use raised styling.
   */
  raised: _propTypes2.default.bool,
  /**
   * @ignore
   */
  type: _propTypes2.default.string
} : {};

Button.defaultProps = {
  color: 'default',
  dense: false,
  disabled: false,
  disableFocusRipple: false,
  disableRipple: false,
  fab: false,
  fullWidth: false,
  mini: false,
  raised: false,
  type: 'button'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButton' })(Button);

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _brcast = __webpack_require__(1087);

var _brcast2 = _interopRequireDefault(_brcast);

var _themeListener = __webpack_require__(245);

var _themeListener2 = _interopRequireDefault(_themeListener);

var _exactProp = __webpack_require__(239);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProvider = function (_React$Component) {
  (0, _inherits3.default)(MuiThemeProvider, _React$Component);

  function MuiThemeProvider(props, context) {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);

    // Get the outer theme from the context, can be null
    var _this = (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).call(this, props, context));

    _this.broadcast = (0, _brcast2.default)();
    _this.unsubscribeId = null;
    _this.outerTheme = null;
    _this.outerTheme = _themeListener2.default.initial(context);
    // Propagate the theme so it can be accessed by the children
    _this.broadcast.setState(_this.mergeOuterLocalTheme(_this.props.theme));
    return _this;
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _ref;

      return _ref = {}, (0, _defineProperty3.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty3.default)(_ref, 'muiThemeProviderOptions', {
        sheetsManager: this.props.sheetsManager,
        disableStylesGeneration: this.props.disableStylesGeneration
      }), _ref;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme;
        // Forward the parent theme update to the children
        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Propagate a local theme update
      if (this.props.theme !== nextProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(nextProps.theme));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
      }
    }
    // We are not using the React state in order to avoid unnecessary rerender.

  }, {
    key: 'mergeOuterLocalTheme',


    // Simple merge between the outer theme and the local theme
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning2.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends3.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react2.default.Component);

MuiThemeProvider.propTypes =  false ? {
  /**
   * You can only provide a single element with react@15, a node with react@16.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes2.default.bool,
  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes2.default.object,
  /**
   * A theme object.
   */
  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired
} : {};

MuiThemeProvider.propTypes =  false ? (0, _exactProp2.default)(MuiThemeProvider.propTypes, 'MuiThemeProvider') : {};

MuiThemeProvider.defaultProps = {
  disableStylesGeneration: false,
  sheetsManager: null
};

MuiThemeProvider.childContextTypes = (0, _extends3.default)({}, _themeListener2.default.contextTypes, {
  muiThemeProviderOptions: _propTypes2.default.object
});

MuiThemeProvider.contextTypes = _themeListener2.default.contextTypes;

exports.default = MuiThemeProvider;

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(273);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(117);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' });

var ArrowDropDown = function ArrowDropDown(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

ArrowDropDown = (0, _pure2.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';

exports.default = ArrowDropDown;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(1);

var _setDisplayName = __webpack_require__(457);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(152);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(205);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_List__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Divider__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider__);
var MobileMenu=function MobileMenu(_ref){var isopen=_ref.isopen,handleClose=_ref.handleClose,handleDownload=_ref.handleDownload;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer___default.a,{open:isopen,className:'mobile-menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'parent',onClick:function onClick(){return handleClose('qatar-charity');},primary:'Qatar Charity'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'parent',primary:'Qatar Charity in UK'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'child',onClick:function onClick(){return handleClose('qcuk+history');},primary:'History'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'child',onClick:function onClick(){return handleClose('qcuk+leadership');},primary:'Leadership'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'child',onClick:function onClick(){return handleClose('qcuk+funding');},primary:'Funding'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'parent',primary:'Emaan Trust'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'child',onClick:function onClick(){return handleClose('sheffield+history');},primary:'History'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'child',onClick:function onClick(){return handleClose('sheffield+leadership');},primary:'Leadership'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'child',onClick:function onClick(){return handleClose('sheffield+funding');},primary:'Funding'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItem"],{button:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_List__["ListItemText"],{className:'parent',primary:'Download',onClick:function onClick(){return handleDownload();}}))));};MobileMenu.propTypes={handleClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleDownload:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isopen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (MobileMenu);

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Divider = __webpack_require__(1094);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Divider).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(244);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      height: 1,
      margin: 0, // Reset browser default style.
      border: 'none',
      flexShrink: 0
    },
    inset: {
      marginLeft: 72
    },
    default: {
      backgroundColor: theme.palette.divider
    },
    light: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
    },
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    }
  };
};

function Divider(props) {
  var _classNames;

  var absolute = props.absolute,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      inset = props.inset,
      light = props.light,
      other = (0, _objectWithoutProperties3.default)(props, ['absolute', 'classes', 'className', 'component', 'inset', 'light']);


  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.absolute, absolute), (0, _defineProperty3.default)(_classNames, classes.inset, inset), _classNames), light ? classes.light : classes.default, classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Divider.propTypes =  false ? {
  absolute: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the divider will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * If `true`, the divider will have a lighter color.
   */
  light: _propTypes2.default.bool
} : {};

Divider.defaultProps = {
  absolute: false,
  component: 'hr',
  inset: false,
  light: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDivider' })(Divider);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_downshift__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_TextField__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Paper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Menu__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_icons_Search__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_styles__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_styles__);
var styles={container:{flexGrow:1,width:200,float:'left',height:40,marginRight:0},textField:{width:150,height:40,float:'left'},search:{float:'left'}};var IntegrationAutosuggest=function(_React$Component){__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(IntegrationAutosuggest,_React$Component);function IntegrationAutosuggest(props){__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this,IntegrationAutosuggest);var _this=__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this,(IntegrationAutosuggest.__proto__||Object.getPrototypeOf(IntegrationAutosuggest)).call(this,props));_this.handleChange=function(event){_this.setState({value:event.target.value});};_this.state={value:''};return _this;}__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(IntegrationAutosuggest,[{key:'renderInput',value:function renderInput(inputProps){var classes=inputProps.classes,autoFocus=inputProps.autoFocus,value=inputProps.value,ref=inputProps.ref,other=__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(inputProps,['classes','autoFocus','value','ref']);return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:classes.search},__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_icons_Search___default.a,{style:{height:40}})),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_TextField___default.a,{autoFocus:autoFocus,className:classes.textField,value:this.state.value,InputProps:__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({classes:{input:classes.input}},other)}));}},{key:'renderSuggestion',value:function renderSuggestion(params){var _this2=this;var suggestion=params.suggestion,index=params.index,itemProps=params.itemProps,theme=params.theme,highlightedIndex=params.highlightedIndex,selectedItem=params.selectedItem;var isHighlighted=highlightedIndex===index;var isSelected=selectedItem===suggestion.label;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Menu__["MenuItem"],__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},itemProps,{key:suggestion.id,selected:isHighlighted,component:'div',style:{fontWeight:isSelected?theme.typography.fontWeightMedium:theme.typography.fontWeightRegular},onClick:function onClick(){return _this2.setSelect(suggestion);}}),suggestion.label);}},{key:'setSelect',value:function setSelect(suggestion){this.downshift.closeMenu();this.setState({value:''});this.props.getSelected(suggestion);}},{key:'renderSuggestionsContainer',value:function renderSuggestionsContainer(options){var containerProps=options.containerProps,children=options.children;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Paper___default.a,__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({},containerProps,{square:true}),__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{style:{clear:'both'}}),children);}},{key:'getSuggestions',value:function getSuggestions(inputValue,suggestions){var count=0;return suggestions.filter(function(suggestion){var keep=suggestion.label&&(!inputValue||suggestion.label.toLowerCase().indexOf(inputValue.toLowerCase())!==-1)&&count<5;if(keep){count+=1;}return keep;});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,classes=_props.classes,theme=_props.theme,nodes=_props.nodes;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_downshift__["a" /* default */],{ref:function ref(down){_this3.downshift=down;},render:function render(_ref){var getInputProps=_ref.getInputProps,getItemProps=_ref.getItemProps,isOpen=_ref.isOpen,inputValue=_ref.inputValue,selectedItem=_ref.selectedItem,highlightedIndex=_ref.highlightedIndex;return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div',{className:classes.container},_this3.renderInput(getInputProps({classes:classes,placeholder:'Search',id:'integration-downshift',onChange:_this3.handleChange})),isOpen?_this3.renderSuggestionsContainer({children:_this3.getSuggestions(inputValue,nodes).map(function(suggestion,index){return _this3.renderSuggestion({suggestion:suggestion,index:index,theme:theme,itemProps:getItemProps({item:suggestion.label}),highlightedIndex:highlightedIndex,selectedItem:selectedItem});})}):null);}});}}]);return IntegrationAutosuggest;}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);IntegrationAutosuggest.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,getSelected:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,nodes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array.isRequired,theme:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_material_ui_styles__["withStyles"])(styles,{withTheme:true})(IntegrationAutosuggest));

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

// istanbul ignore next
var statusDiv = typeof document === 'undefined' ? null : document.getElementById('a11y-status-message');

var statuses = [];

function setStatus(status) {
  var isSameAsLast = statuses[statuses.length - 1] === status;
  if (isSameAsLast) {
    statuses = [].concat(toConsumableArray(statuses), [status]);
  } else {
    statuses = [status];
  }
  var div = getStatusDiv();

  // Remove previous children
  while (div.lastChild) {
    div.removeChild(div.firstChild);
  }

  statuses.filter(Boolean).forEach(function (statusItem, index) {
    div.appendChild(getStatusChildDiv(statusItem, index));
  });
}

function getStatusChildDiv(status, index) {
  var display = index === statuses.length - 1 ? 'block' : 'none';

  var childDiv = document.createElement('div');
  childDiv.style.display = display;
  childDiv.textContent = status;

  return childDiv;
}

function getStatusDiv() {
  if (statusDiv) {
    return statusDiv;
  }
  statusDiv = document.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'assertive');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  document.body.appendChild(statusDiv);
  return statusDiv;
}

var idCounter = 1;

/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */
function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}
function noop() {}

function findParent(finder, node, rootNode) {
  if (node !== null && node !== rootNode.parentNode) {
    if (finder(node)) {
      if (node === document.body && node.scrollTop === 0) {
        // in chrome body.scrollTop always return 0
        return document.documentElement;
      }
      return node;
    } else {
      return findParent(finder, node.parentNode, rootNode);
    }
  } else {
    return null;
  }
}

/**
 * Get the closest element that scrolls
 * @param {HTMLElement} node - the child element to start searching for scroll parent at
 * @param {HTMLElement} rootNode - the root element of the component
 * @return {HTMLElement} the closest parentNode that scrolls
 */
var getClosestScrollParent = findParent.bind(null, function (node) {
  return node.scrollHeight > node.clientHeight;
});

/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node - the element that should scroll into view
 * @param {HTMLElement} rootNode - the root element of the component
 * @param {Boolean} alignToTop - align element to the top of the visible area of the scrollable ancestor
 */
// eslint-disable-next-line complexity
function scrollIntoView(node, rootNode) {
  var scrollParent = getClosestScrollParent(node, rootNode);
  if (scrollParent === null) {
    return;
  }
  var scrollParentStyles = getComputedStyle(scrollParent);
  var scrollParentRect = scrollParent.getBoundingClientRect();
  var scrollParentBorderTopWidth = parseInt(scrollParentStyles.borderTopWidth, 10);
  var scrollParentBorderBottomWidth = parseInt(scrollParentStyles.borderBottomWidth, 10);
  var bordersWidth = scrollParentBorderTopWidth + scrollParentBorderBottomWidth;
  var scrollParentTop = scrollParentRect.top + scrollParentBorderTopWidth;
  var nodeRect = node.getBoundingClientRect();

  if (nodeRect.top < 0 && scrollParentRect.top < 0) {
    scrollParent.scrollTop += nodeRect.top;
    return;
  }

  if (nodeRect.top < 0) {
    // the item is above the viewport and the parent is not above the viewport
    scrollParent.scrollTop += nodeRect.top - scrollParentTop;
    return;
  }

  if (nodeRect.top > 0 && scrollParentRect.top < 0) {
    if (scrollParentRect.bottom > 0 && nodeRect.bottom + bordersWidth > scrollParentRect.bottom) {
      // the item is below scrollable area
      scrollParent.scrollTop += nodeRect.bottom - scrollParentRect.bottom + bordersWidth;
    }
    // item and parent top are on different sides of view top border (do nothing)
    return;
  }

  var nodeOffsetTop = nodeRect.top + scrollParent.scrollTop;
  var nodeTop = nodeOffsetTop - scrollParentTop;
  if (nodeTop < scrollParent.scrollTop) {
    // the item is above the scrollable area
    scrollParent.scrollTop = nodeTop;
  } else if (nodeTop + nodeRect.height + bordersWidth > scrollParent.scrollTop + scrollParentRect.height) {
    // the item is below the scrollable area
    scrollParent.scrollTop = nodeTop + nodeRect.height - scrollParentRect.height + bordersWidth;
  }
  // the item is within the scrollable area (do nothing)
}

/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */
function debounce(fn, time) {
  var timeoutId = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(undefined, args);
    }, time);
  };
}

/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls
 * `event.preventDefault()`. Not sure this is the best
 * way to do this, but it seems legit...
 * @param {Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */
function composeEventHandlers() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      fn && fn.apply(undefined, [event].concat(args));
      return event.defaultPrevented;
    });
  };
}

/**
 * This generates a unique ID for all autocomplete inputs
 * @param {String} prefix the prefix for the id
 * @return {String} the unique ID
 */
function generateId(prefix) {
  return prefix + '-' + idCounter++;
}

/**
 * Resets idCounter to 0. Used for SSR.
 */
function resetIdCounter() {
  idCounter = 0;
}

/**
 * Returns the first argument that is not undefined
 * @param {...*} args the arguments
 * @return {*} the defined value
 */
function firstDefined() {
  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return args.find(function (a) {
    return typeof a !== 'undefined';
  });
}

// eslint-disable-next-line complexity
function getA11yStatusMessage(_ref) {
  var isOpen = _ref.isOpen,
      highlightedItem = _ref.highlightedItem,
      selectedItem = _ref.selectedItem,
      resultCount = _ref.resultCount,
      previousResultCount = _ref.previousResultCount,
      itemToString = _ref.itemToString;

  if (!isOpen) {
    if (selectedItem) {
      return itemToString(selectedItem);
    } else {
      return '';
    }
  }

  if (!resultCount) {
    return 'No results.';
  } else if (!highlightedItem || resultCount !== previousResultCount) {
    return resultCount + ' ' + (resultCount === 1 ? 'result is' : 'results are') + ' available, use up and down arrow keys to navigate.';
  }
  return itemToString(highlightedItem);
}

/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */
function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}

/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */
function isDOMElement(element) {
  /* istanbul ignore if */
  if (element.nodeName) {
    // then this is preact
    return typeof element.nodeName === 'string';
  } else {
    // then we assume this is react
    return typeof element.type === 'string';
  }
}

/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */
function getElementProps(element) {
  // props for react, attributes for preact
  return element.props || /* istanbul ignore next (preact) */element.attributes;
}

/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */
function requiredProp(fnName, propName) {
  throw new Error('The property "' + propName + '" is required in "' + fnName + '"');
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state The state object
 * @return {Object} State that is relevant to downshift
 */
function pickState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}

/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */
function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

/* eslint camelcase:0 */

var Downshift$1 = function (_Component) {
  inherits(Downshift, _Component);

  function Downshift() {
    var _ref;

    classCallCheck(this, Downshift);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = possibleConstructorReturn(this, (_ref = Downshift.__proto__ || Object.getPrototypeOf(Downshift)).call.apply(_ref, [this].concat(args)));

    _initialiseProps.call(_this);

    var state = _this.getState({
      highlightedIndex: _this.props.defaultHighlightedIndex,
      isOpen: _this.props.defaultIsOpen,
      inputValue: _this.props.defaultInputValue,
      selectedItem: _this.props.defaultSelectedItem
    });
    if (state.selectedItem) {
      state.inputValue = _this.props.itemToString(state.selectedItem);
    }
    _this.state = state;
    return _this;
  }

  // this is an experimental feature
  // so we're not going to document this yet
  // nor are we going to test it.
  // We will try to avoid breaking it, but
  // we make no guarantees.
  // If you need it, we recommend that you lock
  // down your version of downshift (don't use a
  // version range) to avoid surprise breakages.

  // itemCount can be changed asynchronously
  // from within downshift (so it can't come from a prop)
  // this is why we store it as an instance and use
  // getItemCount rather than just use items.length
  // (to support windowing + async)


  createClass(Downshift, [{
    key: 'getState',


    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * This will perform a shallow merge of the given state object
     * with the state coming from props
     * (for the controlled component scenario)
     * This is used in state updater functions so they're referencing
     * the right state regardless of where it comes from.
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */
    value: function getState() {
      var _this2 = this;

      var stateToMerge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;

      return Object.keys(stateToMerge).reduce(function (state, key) {
        state[key] = _this2.isControlledProp(key) ? _this2.props[key] : stateToMerge[key];
        return state;
      }, {});
    }

    /**
     * This determines whether a prop is a "controlled prop" meaning it is
     * state which is controlled by the outside of this component rather
     * than within this component.
     * @param {String} key the key to check
     * @return {Boolean} whether it is a controlled controlled prop
     */

  }, {
    key: 'isControlledProp',
    value: function isControlledProp(key) {
      return this.props[key] !== undefined;
    }
  }, {
    key: 'getItemCount',
    value: function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      /* eslint-disable no-negated-condition */
      if (this.itemCount != null) {
        return this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        return this.props.itemCount;
      } else {
        return this.items.length;
      }
      /* eslint-enable no-negated-condition */
    }

    // eslint-disable-next-line complexity

  }, {
    key: 'focusInput',
    value: function focusInput() {
      var inputNode = this._rootNode.querySelector('[id="' + this.inputId + '"]');
      inputNode && inputNode.focus && inputNode.focus();
    }
  }, {
    key: 'internalSetState',


    // any piece of our state can live in two places:
    // 1. Uncontrolled: it's internal (this.state)
    //    We will call this.setState to update that state
    // 2. Controlled: it's external (this.props)
    //    We will call this.props.onStateChange to update that state
    //
    // In addition, we'll call this.props.onChange if the
    // selectedItem is changed.
    value: function internalSetState(stateToSet, cb) {
      var _this3 = this;

      var isItemSelected = void 0,
          onChangeArg = void 0;

      var onStateChangeArg = {};
      var isStateToSetFunction = typeof stateToSet === 'function';

      // we want to call `onInputValueChange` before the `setState` call
      // so someone controlling the `inputValue` state gets notified of
      // the input change as soon as possible. This avoids issues with
      // preserving the cursor position.
      // See https://github.com/paypal/downshift/issues/217 for more info.
      if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
        this.props.onInputValueChange(stateToSet.inputValue, _extends({}, this.getStateAndHelpers(), stateToSet));
      }
      return this.setState(function (state) {
        state = _this3.getState(state);
        stateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;

        // checks if an item is selected, regardless of if it's different from
        // what was selected before
        // used to determine if onSelect and onChange callbacks should be called
        isItemSelected = stateToSet.hasOwnProperty('selectedItem');
        // this keeps track of the object we want to call with setState
        var nextState = {};
        // this is just used to tell whether the state changed
        var nextFullState = {};
        // we need to call on change if the outside world is controlling any of our state
        // and we're trying to update that state. OR if the selection has changed and we're
        // trying to update the selection
        if (isItemSelected && stateToSet.selectedItem !== state.selectedItem) {
          onChangeArg = stateToSet.selectedItem;
        }
        stateToSet.type = stateToSet.type || Downshift.stateChangeTypes.unknown;

        Object.keys(stateToSet).forEach(function (key) {
          // onStateChangeArg should only have the state that is
          // actually changing
          if (state[key] !== stateToSet[key]) {
            onStateChangeArg[key] = stateToSet[key];
          }
          // the type is useful for the onStateChangeArg
          // but we don't actually want to set it in internal state.
          // this is an undocumented feature for now... Not all internalSetState
          // calls support it and I'm not certain we want them to yet.
          // But it enables users controlling the isOpen state to know when
          // the isOpen state changes due to mouseup events which is quite handy.
          if (key === 'type') {
            return;
          }
          nextFullState[key] = stateToSet[key];
          // if it's coming from props, then we don't care to set it internally
          if (!_this3.isControlledProp(key)) {
            nextState[key] = stateToSet[key];
          }
        });

        // if stateToSet is a function, then we weren't able to call onInputValueChange
        // earlier, so we'll call it now that we know what the inputValue state will be.
        if (isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this3.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this3.getStateAndHelpers(), stateToSet));
        }

        return nextState;
      }, function () {
        // call the provided callback if it's a callback
        cbToCb(cb)();

        // only call the onStateChange and onChange callbacks if
        // we have relevant information to pass them.
        var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
        if (hasMoreStateThanType) {
          _this3.props.onStateChange(onStateChangeArg, _this3.getStateAndHelpers());
        }

        if (isItemSelected) {
          _this3.props.onSelect(stateToSet.selectedItem, _this3.getStateAndHelpers());
        }

        if (onChangeArg !== undefined) {
          _this3.props.onChange(onChangeArg, _this3.getStateAndHelpers());
        }
        // this is currently undocumented and therefore subject to change
        // We'll try to not break it, but just be warned.
        _this3.props.onUserAction(onStateChangeArg, _this3.getStateAndHelpers());
      });
    }
  }, {
    key: 'getStateAndHelpers',
    value: function getStateAndHelpers() {
      var _getState = this.getState(),
          highlightedIndex = _getState.highlightedIndex,
          inputValue = _getState.inputValue,
          selectedItem = _getState.selectedItem,
          isOpen = _getState.isOpen;

      var _props = this.props,
          id = _props.id,
          itemToString = _props.itemToString;
      var getRootProps = this.getRootProps,
          getButtonProps = this.getButtonProps,
          getLabelProps = this.getLabelProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount;

      return {
        // prop getters
        getRootProps: getRootProps,
        getButtonProps: getButtonProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,

        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,

        //props
        itemToString: itemToString,
        id: id,

        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    }

    //////////////////////////// ROOT

    //\\\\\\\\\\\\\\\\\\\\\\\\\\ ROOT

    //////////////////////////// BUTTON

    //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ BUTTON

    /////////////////////////////// LABEL

    //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ LABEL

    /////////////////////////////// INPUT

  }, {
    key: 'getItemId',

    //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ INPUT

    /////////////////////////////// ITEM
    value: function getItemId(index) {
      return this.props.id + '-item-' + index;
    }
    //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ ITEM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      // the _isMounted property is because we have `updateStatus` in a `debounce`
      // and we don't want to update the status if the component has been umounted
      this._isMounted = true;
      // this.isMouseDown helps us track whether the mouse is currently held down.
      // This is useful when the user clicks on an item in the list, but holds the mouse
      // down long enough for the list to disappear (because the blur event fires on the input)
      // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
      // trigger hiding the menu.
      var onMouseDown = function () {
        _this4.isMouseDown = true;
      };
      var onMouseUp = function (event) {
        _this4.isMouseDown = false;
        if ((event.target === _this4._rootNode || !_this4._rootNode.contains(event.target)) && _this4.getState().isOpen) {
          _this4.reset({ type: Downshift.stateChangeTypes.mouseUp }, function () {
            return _this4.props.onOuterClick(_this4.getStateAndHelpers());
          });
        }
      };
      this.props.environment.addEventListener('mousedown', onMouseDown);
      this.props.environment.addEventListener('mouseup', onMouseUp);

      this.cleanup = function () {
        _this4._isMounted = false;
        _this4.props.environment.removeEventListener('mousedown', onMouseDown);
        _this4.props.environment.removeEventListener('mouseup', onMouseUp);
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.isControlledProp('selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: Downshift.stateChangeTypes.controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }

      var current = this.props.highlightedIndex === undefined ? this.state : this.props;
      var prev = prevProps.highlightedIndex === undefined ? prevState : prevProps;

      if (current.highlightedIndex !== prev.highlightedIndex && !this.avoidScrolling) {
        this.scrollHighlightedItemIntoView();
      }

      this.updateStatus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    }

    // eslint-disable-next-line complexity

  }, {
    key: 'render',
    value: function render() {
      var children = unwrapArray(this.props.render || this.props.children, noop);
      // because the items are rerendered every time we call the children
      // we clear this out each render and
      this.clearItems();
      // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.
      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined;
      // we do something similar for getLabelProps
      this.getLabelProps.called = false;
      // and something similar for getInputProps
      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));
      if (!element) {
        return null;
      }
      if (this.getRootProps.called) {
        if (!this.getRootProps.suppressRefError) {
          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
        }
        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(element, this.getRootProps(getElementProps(element)));
      } else {
        // they didn't apply the root props, but they need to
        // otherwise we can't query around the autocomplete
        throw new Error('downshift: If you return a non-DOM element, you must use apply the getRootProps function');
      }
    }
  }]);
  return Downshift;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Downshift$1.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  defaultHighlightedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  defaultSelectedItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  defaultInputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultIsOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getA11yStatusMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  itemToString: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInputValueChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onUserAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOuterClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  selectedItemChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  itemCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  environment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    addEventListener: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    removeEventListener: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      getElementById: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
      activeElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
      body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
    })
  }),
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  highlightedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  breakingChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    resetInputOnSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
  /* eslint-enable */
};
Downshift$1.defaultProps = {
  defaultHighlightedIndex: null,
  defaultSelectedItem: null,
  defaultInputValue: '',
  defaultIsOpen: false,
  getA11yStatusMessage: getA11yStatusMessage,
  id: generateId('downshift'),
  itemToString: function itemToString(i) {
    if (i == null) {
      return '';
    }
    if (false) {
      //eslint-disable-next-line no-console
      console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
    }
    return String(i);
  },
  onStateChange: function onStateChange() {},
  onInputValueChange: function onInputValueChange() {},
  onUserAction: function onUserAction() {},
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  onOuterClick: function onOuterClick() {},
  selectedItemChanged: function selectedItemChanged(prevItem, item) {
    return prevItem !== item;
  },
  environment: typeof window === 'undefined' /* istanbul ignore next (ssr) */
  ? {} : window,
  breakingChanges: {} };
Downshift$1.stateChangeTypes = {
  unknown: '__autocomplete_unknown__',
  mouseUp: '__autocomplete_mouseup__',
  itemMouseEnter: '__autocomplete_item_mouseenter__',
  keyDownArrowUp: '__autocomplete_keydown_arrow_up__',
  keyDownArrowDown: '__autocomplete_keydown_arrow_down__',
  keyDownEscape: '__autocomplete_keydown_escape__',
  keyDownEnter: '__autocomplete_keydown_enter__',
  blurInput: '__autocomplete_blur_input__',
  changeInput: '__autocomplete_change_input__',
  keyDownSpaceButton: '__autocomplete_keydown_space_button__',
  clickButton: '__autocomplete_click_button__',
  controlledPropUpdatedSelectedItem: '__autocomplete_controlled_prop_updated_selected_item__'
};

var _initialiseProps = function () {
  var _this5 = this;

  this.root_handleClick = composeEventHandlers(this.props.onClick, this.root_handleClick);
  this.input = null;
  this.items = [];
  this.itemCount = null;
  this.previousResultCount = 0;

  this.setItemCount = function (count) {
    return _this5.itemCount = count;
  };

  this.unsetItemCount = function () {
    return _this5.itemCount = null;
  };

  this.getItemNodeFromIndex = function (index) {
    return _this5.props.environment.document.getElementById(_this5.getItemId(index));
  };

  this.setHighlightedIndex = function () {
    var highlightedIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.props.defaultHighlightedIndex;
    var otherStateToSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(_extends({ highlightedIndex: highlightedIndex }, otherStateToSet));
  };

  this.scrollHighlightedItemIntoView = function () {
    var node = _this5.getItemNodeFromIndex(_this5.getState().highlightedIndex);
    var rootNode = _this5._rootNode;
    scrollIntoView(node, rootNode);
  };

  this.openAndHighlightDefaultIndex = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.setHighlightedIndex(undefined, _extends({ isOpen: true }, otherStateToSet));
  };

  this.highlightDefaultIndex = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.setHighlightedIndex(undefined, otherStateToSet);
  };

  this.moveHighlightedIndex = function (amount, otherStateToSet) {
    if (_this5.getState().isOpen) {
      _this5.changeHighlightedIndex(amount, otherStateToSet);
    } else {
      _this5.openAndHighlightDefaultIndex(otherStateToSet);
    }
  };

  this.changeHighlightedIndex = function (moveAmount, otherStateToSet) {
    var itemsLastIndex = _this5.getItemCount() - 1;
    if (itemsLastIndex < 0) {
      return;
    }

    var _getState2 = _this5.getState(),
        highlightedIndex = _getState2.highlightedIndex;

    var baseIndex = highlightedIndex;
    if (baseIndex === null) {
      baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
    }
    var newIndex = baseIndex + moveAmount;
    if (newIndex < 0) {
      newIndex = itemsLastIndex;
    } else if (newIndex > itemsLastIndex) {
      newIndex = 0;
    }
    _this5.setHighlightedIndex(newIndex, otherStateToSet);
  };

  this.clearSelection = function (cb) {
    _this5.internalSetState({
      selectedItem: null,
      inputValue: '',
      isOpen: false
    }, function () {
      _this5.focusInput();
      cbToCb(cb)();
    });
  };

  this.selectItem = function (item, otherStateToSet, cb) {
    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(_extends({
      isOpen: false,
      highlightedIndex: _this5.props.defaultHighlightedIndex,
      selectedItem: item,
      inputValue: _this5.isControlledProp('selectedItem') && _this5.props.breakingChanges.resetInputOnSelection ? _this5.props.defaultInputValue : _this5.props.itemToString(item)
    }, otherStateToSet), function () {
      _this5.focusInput();
      typeof cb === 'function' && cb.apply(undefined, arguments);
    });
  };

  this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
    var item = _this5.items[itemIndex];
    if (item == null) {
      return;
    }
    _this5.selectItem(item, otherStateToSet, cb);
  };

  this.selectHighlightedItem = function (otherStateToSet, cb) {
    return _this5.selectItemAtIndex(_this5.getState().highlightedIndex, otherStateToSet, cb);
  };

  this.rootRef = function (node) {
    return _this5._rootNode = node;
  };

  this.getRootProps = function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$suppressRefErro = _ref4.suppressRefError,
        suppressRefError = _ref4$suppressRefErro === undefined ? false : _ref4$suppressRefErro;

    var _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === undefined ? 'ref' : _ref3$refKey,
        rest = objectWithoutProperties(_ref3, ['refKey']);

    // this is used in the render to know whether the user has called getRootProps.
    // It uses that to know whether to apply the props automatically
    _this5.getRootProps.called = true;
    _this5.getRootProps.refKey = refKey;
    _this5.getRootProps.suppressRefError = suppressRefError;
    return _extends(defineProperty({}, refKey, _this5.rootRef), rest);
  };

  this.keyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      var amount = event.shiftKey ? 5 : 1;
      this.moveHighlightedIndex(amount, {
        type: Downshift$1.stateChangeTypes.keyDownArrowDown
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      var amount = event.shiftKey ? -5 : -1;
      this.moveHighlightedIndex(amount, {
        type: Downshift$1.stateChangeTypes.keyDownArrowUp
      });
    },
    Enter: function Enter(event) {
      if (this.getState().isOpen) {
        event.preventDefault();
        this.selectHighlightedItem({
          type: Downshift$1.stateChangeTypes.keyDownEnter
        });
      }
    },
    Escape: function Escape(event) {
      event.preventDefault();
      this.reset({ type: Downshift$1.stateChangeTypes.keyDownEscape });
    }
  };
  this.buttonKeyDownHandlers = _extends({}, this.keyDownHandlers, {
    ' ': function _(event) {
      event.preventDefault();
      this.toggleMenu({ type: Downshift$1.stateChangeTypes.keyDownSpaceButton });
    }
  });

  this.getButtonProps = function () {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onClick = _ref5.onClick,
        onKeyDown = _ref5.onKeyDown,
        rest = objectWithoutProperties(_ref5, ['onClick', 'onKeyDown']);

    var _getState3 = _this5.getState(),
        isOpen = _getState3.isOpen;

    var eventHandlers = rest.disabled ? {} : {
      onClick: composeEventHandlers(onClick, _this5.button_handleClick),
      onKeyDown: composeEventHandlers(onKeyDown, _this5.button_handleKeyDown)
    };
    return _extends({
      role: 'button',
      'aria-label': isOpen ? 'close menu' : 'open menu',
      'aria-expanded': isOpen,
      'aria-haspopup': true
    }, eventHandlers, rest);
  };

  this.button_handleKeyDown = function (event) {
    if (_this5.buttonKeyDownHandlers[event.key]) {
      _this5.buttonKeyDownHandlers[event.key].call(_this5, event);
    }
  };

  this.button_handleClick = function (event) {
    event.preventDefault();
    // handle odd case for Safari and Firefox which
    // don't give the button the focus properly.
    /* istanbul ignore if (can't reasonably test this) */
    if (_this5.props.environment.document.activeElement === _this5.props.environment.document.body) {
      event.target.focus();
    }
    _this5.toggleMenu({ type: Downshift$1.stateChangeTypes.clickButton });
  };

  this.getLabelProps = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.getLabelProps.called = true;
    if (_this5.getInputProps.called && props.htmlFor && props.htmlFor !== _this5.inputId) {
      throw new Error('downshift: You provided the htmlFor of "' + props.htmlFor + '" for your label, but the id of your input is "' + _this5.inputId + '". You must either remove the id from your input or set the htmlFor of the label equal to the input id.');
    }
    _this5.inputId = firstDefined(_this5.inputId, props.htmlFor, generateId('downshift-input'));
    return _extends({}, props, {
      htmlFor: _this5.inputId
    });
  };

  this.getInputProps = function () {
    var _ref7;

    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onKeyDown = _ref6.onKeyDown,
        onBlur = _ref6.onBlur,
        onChange = _ref6.onChange,
        onInput = _ref6.onInput,
        rest = objectWithoutProperties(_ref6, ['onKeyDown', 'onBlur', 'onChange', 'onInput']);

    _this5.getInputProps.called = true;
    if (_this5.getLabelProps.called && rest.id && rest.id !== _this5.inputId) {
      throw new Error('downshift: You provided the id of "' + rest.id + '" for your input, but the htmlFor of your label is "' + _this5.inputId + '". You must either remove the id from your input or set the htmlFor of the label equal to the input id.');
    }
    _this5.inputId = firstDefined(_this5.inputId, rest.id, generateId('downshift-input'));
    // the boolean cast here is necessary due to a weird deal with
    // babel-plugin-istanbul + preval.macro. No idea...
    var isPreact = Boolean(false);
    var onChangeKey = isPreact /* istanbul ignore next (preact) */
    ? 'onInput' : 'onChange';

    var _getState4 = _this5.getState(),
        inputValue = _getState4.inputValue,
        isOpen = _getState4.isOpen,
        highlightedIndex = _getState4.highlightedIndex;

    var eventHandlers = rest.disabled ? {} : (_ref7 = {}, defineProperty(_ref7, onChangeKey, composeEventHandlers(onChange, onInput, _this5.input_handleChange)), defineProperty(_ref7, 'onKeyDown', composeEventHandlers(onKeyDown, _this5.input_handleKeyDown)), defineProperty(_ref7, 'onBlur', composeEventHandlers(onBlur, _this5.input_handleBlur)), _ref7);
    return _extends({
      role: 'combobox',
      'aria-autocomplete': 'list',
      'aria-expanded': isOpen,
      'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this5.getItemId(highlightedIndex) : null,
      autoComplete: 'off',
      value: inputValue
    }, eventHandlers, rest, {
      id: _this5.inputId
    });
  };

  this.input_handleKeyDown = function (event) {
    if (event.key && _this5.keyDownHandlers[event.key]) {
      _this5.keyDownHandlers[event.key].call(_this5, event);
    }
  };

  this.input_handleChange = function (event) {
    _this5.internalSetState({
      type: Downshift$1.stateChangeTypes.changeInput,
      isOpen: true,
      inputValue: event.target.value
    });
  };

  this.input_handleBlur = function () {
    if (!_this5.isMouseDown) {
      _this5.reset({ type: Downshift$1.stateChangeTypes.blurInput });
    }
  };

  this.getItemProps = function () {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onMouseMove = _ref8.onMouseMove,
        onClick = _ref8.onClick,
        index = _ref8.index,
        _ref8$item = _ref8.item,
        item = _ref8$item === undefined ? requiredProp('getItemProps', 'item') : _ref8$item,
        rest = objectWithoutProperties(_ref8, ['onMouseMove', 'onClick', 'index', 'item']);

    if (index === undefined) {
      _this5.items.push(item);
      index = _this5.items.indexOf(item);
    } else {
      _this5.items[index] = item;
    }
    return _extends({
      id: _this5.getItemId(index),
      // onMouseMove is used over onMouseEnter here. onMouseMove
      // is only triggered on actual mouse movement while onMouseEnter
      // can fire on DOM changes, interrupting keyboard navigation
      onMouseMove: composeEventHandlers(onMouseMove, function () {
        if (index === _this5.getState().highlightedIndex) {
          return;
        }
        _this5.setHighlightedIndex(index, {
          type: Downshift$1.stateChangeTypes.itemMouseEnter
        });

        // We never want to manually scroll when changing state based
        // on `onMouseMove` because we will be moving the element out
        // from under the user which is currently scrolling/moving the
        // cursor
        _this5.avoidScrolling = true;
        setTimeout(function () {
          return _this5.avoidScrolling = false;
        }, 250);
      }),
      onClick: composeEventHandlers(onClick, function () {
        _this5.selectItemAtIndex(index);
      })
    }, rest);
  };

  this.clearItems = function () {
    _this5.items = [];
  };

  this.reset = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cb = arguments[1];

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(function (_ref9) {
      var selectedItem = _ref9.selectedItem;
      return _extends({
        isOpen: false,
        highlightedIndex: _this5.props.defaultHighlightedIndex,
        inputValue: _this5.props.itemToString(selectedItem)
      }, otherStateToSet);
    }, cbToCb(cb));
  };

  this.toggleMenu = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cb = arguments[1];

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(function (_ref10) {
      var isOpen = _ref10.isOpen;

      return _extends({ isOpen: !isOpen }, otherStateToSet);
    }, function () {
      var _getState5 = _this5.getState(),
          isOpen = _getState5.isOpen;

      if (isOpen) {
        _this5.highlightDefaultIndex();
      }
      cbToCb(cb)();
    });
  };

  this.openMenu = function (cb) {
    _this5.internalSetState({ isOpen: true }, cbToCb(cb));
  };

  this.closeMenu = function (cb) {
    _this5.internalSetState({ isOpen: false }, cbToCb(cb));
  };

  this.updateStatus = debounce(function () {
    if (!_this5._isMounted) {
      return;
    }
    var state = _this5.getState();
    var item = _this5.items[state.highlightedIndex] || {};
    var resultCount = _this5.getItemCount();
    var status = _this5.props.getA11yStatusMessage(_extends({
      itemToString: _this5.props.itemToString,
      previousResultCount: _this5.previousResultCount,
      resultCount: resultCount,
      highlightedItem: item
    }, state));
    _this5.previousResultCount = resultCount;
    setStatus(status);
  }, 200);
};

function validateGetRootPropsCalledCorrectly(element, _ref2) {
  var refKey = _ref2.refKey;

  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);
  if (isComposite && !refKeySpecified) {
    throw new Error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    throw new Error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + refKey + '"');
  }
  if (!getElementProps(element)[refKey]) {
    throw new Error('downshift: You must apply the ref prop "' + refKey + '" from getRootProps onto your root element.');
  }
}

/*
 * Fix importing in typescript after rollup compilation
 * https://github.com/rollup/rollup/issues/1156
 * https://github.com/Microsoft/TypeScript/issues/13017#issuecomment-268657860
 */
Downshift$1.default = Downshift$1;
Downshift$1.resetIdCounter = resetIdCounter;

/* harmony default export */ __webpack_exports__["a"] = (Downshift$1);


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextField = __webpack_require__(1098);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = __webpack_require__(458);

var _Input2 = _interopRequireDefault(_Input);

var _FormControl = __webpack_require__(459);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormHelperText = __webpack_require__(460);

var _FormHelperText2 = _interopRequireDefault(_FormHelperText);

var _Select = __webpack_require__(1106);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 * - [FormControl](/api/form-control)
 * - [InputLabel](/api/input-label)
 * - [Input](/api/input)
 * - [FormHelperText](/api/form-helper-text)
 *
 * If you wish to alter the properties applied to the native input, you can do as follow:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 * - using the upper case props for passing values direct to the components.
 * - using the underlying components directly as shown in the demos.
 */
function TextField(props) {
  var autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      children = props.children,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      error = props.error,
      FormHelperTextProps = props.FormHelperTextProps,
      fullWidth = props.fullWidth,
      helperText = props.helperText,
      helperTextClassName = props.helperTextClassName,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      labelClassName = props.labelClassName,
      multiline = props.multiline,
      name = props.name,
      onChange = props.onChange,
      placeholder = props.placeholder,
      required = props.required,
      rootRef = props.rootRef,
      rows = props.rows,
      rowsMax = props.rowsMax,
      select = props.select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      other = (0, _objectWithoutProperties3.default)(props, ['autoComplete', 'autoFocus', 'children', 'className', 'defaultValue', 'disabled', 'error', 'FormHelperTextProps', 'fullWidth', 'helperText', 'helperTextClassName', 'id', 'InputLabelProps', 'inputProps', 'InputProps', 'inputRef', 'label', 'labelClassName', 'multiline', 'name', 'onChange', 'placeholder', 'required', 'rootRef', 'rows', 'rowsMax', 'select', 'SelectProps', 'type', 'value']);


   false ? (0, _warning2.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;

  var helperTextId = helperText && id ? id + '-helper-text' : undefined;
  var InputComponent = _react2.default.createElement(_Input2.default, (0, _extends3.default)({
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: disabled,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onChange: onChange,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputProps));

  return _react2.default.createElement(
    _FormControl2.default,
    (0, _extends3.default)({
      'aria-describedby': helperTextId,
      className: className,
      error: error,
      fullWidth: fullWidth,
      ref: rootRef,
      required: required
    }, other),
    label && _react2.default.createElement(
      _Input.InputLabel,
      (0, _extends3.default)({ htmlFor: id, className: labelClassName }, InputLabelProps),
      label
    ),
    select ? _react2.default.createElement(
      _Select2.default,
      (0, _extends3.default)({ value: value, input: InputComponent }, SelectProps),
      children
    ) : InputComponent,
    helperText && _react2.default.createElement(
      _FormHelperText2.default,
      (0, _extends3.default)({ className: helperTextClassName, id: helperTextId }, FormHelperTextProps),
      helperText
    )
  );
} // @inheritedComponent FormControl

TextField.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes2.default.string,
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * @ignore
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes2.default.string,
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * Properties applied to the `FormHelperText` element.
   */
  FormHelperTextProps: _propTypes2.default.object,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The helper text content.
   */
  helperText: _propTypes2.default.node,
  /**
   * The CSS class name of the helper text element.
   */
  helperTextClassName: _propTypes2.default.string,
  /**
   * The id of the `input` element.
   * Use that property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes2.default.string,
  /**
   * Properties applied to the `InputLabel` element.
   */
  InputLabelProps: _propTypes2.default.object,
  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes2.default.object,
  /**
   * Properties applied to the native `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * The label content.
   */
  label: _propTypes2.default.node,
  /**
   * The CSS class name of the label element.
   */
  labelClassName: _propTypes2.default.string,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes2.default.oneOf(['none', 'dense', 'normal']),
  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes2.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChange: _propTypes2.default.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes2.default.string,
  /**
   * If `true`, the label is displayed as required.
   */
  required: _propTypes2.default.bool,
  /**
   * Use that property to pass a ref callback to the root component.
   */
  rootRef: _propTypes2.default.func,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes2.default.bool,
  /**
   * Properties applied to the `Select` element.
   */
  SelectProps: _propTypes2.default.object,
  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

TextField.defaultProps = {
  required: false,
  select: false
};

exports.default = TextField;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _debounce = __webpack_require__(247);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactEventListener = __webpack_require__(246);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROWS_HEIGHT = 24;

var styles = exports.styles = {
  root: {
    position: 'relative', // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    resize: 'none',
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on ipads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};

/**
 * @ignore - internal component.
 */

var Textarea = function (_React$Component) {
  (0, _inherits3.default)(Textarea, _React$Component);

  function Textarea() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Textarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Textarea.__proto__ || (0, _getPrototypeOf2.default)(Textarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: null
    }, _this.shadow = null, _this.singlelineShadow = null, _this.input = null, _this.value = null, _this.handleResize = (0, _debounce2.default)(function (event) {
      _this.syncHeightWithShadow(event);
    }, 166), _this.handleRefInput = function (node) {
      _this.input = node;
      if (_this.props.textareaRef) {
        _this.props.textareaRef(node);
      }
    }, _this.handleRefSinglelineShadow = function (node) {
      _this.singlelineShadow = node;
    }, _this.handleRefShadow = function (node) {
      _this.shadow = node;
    }, _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (typeof _this.props.value === 'undefined' && _this.shadow) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadow.value = _this.value;
        _this.syncHeightWithShadow(event);
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Textarea, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // <Input> expects the components it renders to respond to 'value'
      // so that it can check whether they are dirty
      this.value = this.props.value || this.props.defaultValue || '';
      this.setState({
        height: Number(this.props.rows) * ROWS_HEIGHT
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncHeightWithShadow(null);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value || Number(nextProps.rowsMax) !== Number(this.props.rowsMax)) {
        this.syncHeightWithShadow(null, nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    }
  }, {
    key: 'syncHeightWithShadow',
    value: function syncHeightWithShadow(event) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;

      if (this.shadow && this.singlelineShadow) {
        // The component is controlled, we need to update the shallow value.
        if (typeof this.props.value !== 'undefined') {
          this.shadow.value = props.value == null ? '' : String(props.value);
        }

        var lineHeight = this.singlelineShadow.scrollHeight;
        var newHeight = this.shadow.scrollHeight;

        // Guarding for jsdom, where scrollHeight isn't present.
        // See https://github.com/tmpvar/jsdom/issues/1013
        if (newHeight === undefined) {
          return;
        }

        if (Number(props.rowsMax) >= Number(props.rows)) {
          newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
        }

        newHeight = Math.max(newHeight, lineHeight);

        if (this.state.height !== newHeight) {
          this.setState({
            height: newHeight
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          textareaRef = _props.textareaRef,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'defaultValue', 'onChange', 'rows', 'rowsMax', 'textareaRef', 'value']);


      return _react2.default.createElement(
        'div',
        { className: classes.root, style: { height: this.state.height } },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement('textarea', {
          ref: this.handleRefSinglelineShadow,
          className: (0, _classnames2.default)(classes.shadow, classes.textarea),
          tabIndex: -1,
          rows: '1',
          readOnly: true,
          'aria-hidden': 'true',
          value: ''
        }),
        _react2.default.createElement('textarea', {
          ref: this.handleRefShadow,
          className: (0, _classnames2.default)(classes.shadow, classes.textarea),
          tabIndex: -1,
          rows: rows,
          'aria-hidden': 'true',
          readOnly: true,
          defaultValue: defaultValue,
          value: value
        }),
        _react2.default.createElement('textarea', (0, _extends3.default)({
          rows: rows,
          className: (0, _classnames2.default)(classes.textarea, className),
          defaultValue: defaultValue,
          value: value,
          onChange: this.handleChange,
          ref: this.handleRefInput
        }, other))
      );
    }
  }]);
  return Textarea;
}(_react2.default.Component);

Textarea.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * @ignore
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes2.default.func,
  /**
   * @ignore
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
} : {};

Textarea.defaultProps = {
  rows: 1
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTextarea' })(Textarea);

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _Typography = __webpack_require__(176);

var _Typography2 = _interopRequireDefault(_Typography);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      'label + div > &': {
        marginTop: -theme.spacing.unit * 2,
        height: 26,
        display: 'flex'
      }
    },
    positionStart: {
      marginRight: theme.spacing.unit
    },
    positionEnd: {
      marginLeft: theme.spacing.unit
    }
  };
};

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      position = props.position,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'component', 'classes', 'className', 'disableTypography', 'position']);


  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty3.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
    }, other),
    typeof children === 'string' && !disableTypography ? _react2.default.createElement(
      _Typography2.default,
      { color: 'textSecondary' },
      children
    ) : children
  );
}

InputAdornment.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes2.default.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes2.default.oneOf(['start', 'end'])
} : {};

InputAdornment.defaultProps = {
  component: 'div',
  disableTypography: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInputAdornment' })(InputAdornment);

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Form = __webpack_require__(1102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      transformOrigin: 'top left'
    },
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, ' + theme.spacing.unit * 3 + 'px) scale(1)'
    },
    labelDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, ' + (theme.spacing.unit * 2.5 + 1) + 'px) scale(1)'
    },
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },
    animated: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },
    disabled: {
      color: theme.palette.text.disabled
    }
  };
};

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      disabled = props.disabled,
      FormControlClasses = props.FormControlClasses,
      marginProp = props.margin,
      shrinkProp = props.shrink,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableAnimation', 'disabled', 'FormControlClasses', 'margin', 'shrink']);
  var muiFormControl = context.muiFormControl;

  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.dirty || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var margin = marginProp;
  if (typeof margin === 'undefined' && muiFormControl) {
    margin = muiFormControl.margin;
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty3.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty3.default)(_classNames, classes.shrink, shrink), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.labelDense, margin === 'dense'), _classNames), classNameProp);

  return _react2.default.createElement(
    _Form.FormLabel,
    (0, _extends3.default)({ 'data-shrink': shrink, className: className, classes: FormControlClasses }, other),
    children
  );
}

InputLabel.propTypes =  false ? {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes2.default.bool,
  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes2.default.bool,
  /**
   * `classes` property applied to the `FormControl` element.
   */
  FormControlClasses: _propTypes2.default.object,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense']),
  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes2.default.bool
} : {};

InputLabel.defaultProps = {
  disabled: false,
  disableAnimation: false
};

InputLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInputLabel' })(InputLabel);

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormGroup = __webpack_require__(1103);

Object.defineProperty(exports, 'FormGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormGroup).default;
  }
});

var _FormLabel = __webpack_require__(1104);

Object.defineProperty(exports, 'FormLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormLabel).default;
  }
});

var _FormControl = __webpack_require__(459);

Object.defineProperty(exports, 'FormControl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormControl).default;
  }
});

var _FormHelperText = __webpack_require__(460);

Object.defineProperty(exports, 'FormHelperText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormHelperText).default;
  }
});

var _FormControlLabel = __webpack_require__(1105);

Object.defineProperty(exports, 'FormControlLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormControlLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },
  row: {
    flexDirection: 'row'
  }
};

/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */
function FormGroup(props) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      row = props.row,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'children', 'row']);

  var rootClassName = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.row, row), className);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: rootClassName }, other),
    children
  );
}

FormGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Display group of elements in a compact row.
   */
  row: _propTypes2.default.bool
} : {};

FormGroup.defaultProps = {
  row: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormGroup' })(FormGroup);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0
    },
    focused: {
      color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
    },
    error: {
      color: theme.palette.error.main
    },
    disabled: {
      color: theme.palette.text.disabled
    }
  };
};

function FormLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabledProp = props.disabled,
      errorProp = props.error,
      focusedProp = props.focused,
      requiredProp = props.required,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'component', 'disabled', 'error', 'focused', 'required']);
  var muiFormControl = context.muiFormControl;


  var required = requiredProp;
  var focused = focusedProp;
  var disabled = disabledProp;
  var error = errorProp;

  if (muiFormControl) {
    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }
    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.focused, focused), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), _classNames), classNameProp);

  var asteriskClassName = (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.error, error));

  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: className }, other),
    children,
    required && _react2.default.createElement(
      'span',
      { className: asteriskClassName },
      '\u2009*'
    )
  );
}

FormLabel.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes2.default.bool,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool
} : {};

FormLabel.defaultProps = {
  component: 'label'
};

FormLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormLabel' })(FormLabel);

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(176);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: theme.palette.common.transparent,
      marginLeft: -14,
      marginRight: theme.spacing.unit * 2 // used for row presentation of radio/checkbox
    },
    disabled: {
      color: theme.palette.text.disabled,
      cursor: 'default'
    },
    label: {}
  };
};

/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */
/* eslint-disable jsx-a11y/label-has-for */

function FormControlLabel(props, context) {
  var checked = props.checked,
      classes = props.classes,
      classNameProp = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties3.default)(props, ['checked', 'classes', 'className', 'control', 'disabled', 'inputRef', 'label', 'name', 'onChange', 'value']);
  var muiFormControl = context.muiFormControl;

  var disabled = disabledProp;

  if (typeof control.props.disabled !== 'undefined') {
    if (typeof disabled === 'undefined') {
      disabled = control.props.disabled;
    }
  }

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp);

  return _react2.default.createElement(
    'label',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.cloneElement(control, {
      disabled: disabled,
      checked: typeof control.props.checked === 'undefined' ? checked : control.props.checked,
      name: control.props.name || name,
      onChange: control.props.onChange || onChange,
      value: control.props.value || value,
      inputRef: control.props.inputRef || inputRef
    }),
    _react2.default.createElement(
      _Typography2.default,
      { component: 'span', className: classes.label },
      label
    )
  );
}

FormControlLabel.propTypes =  false ? {
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes2.default.element,
  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes2.default.node,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

FormControlLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormControlLabel' })(FormControlLabel);

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectInput = __webpack_require__(1107);

var _SelectInput2 = _interopRequireDefault(_SelectInput);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Input = __webpack_require__(458);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import to enforce the CSS injection order

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      width: '100%'
    },
    select: {
      '-moz-appearance': 'none', // Remove Firefox custom style
      '-webkit-appearance': 'none', // Fix SSR issue
      appearance: 'none', // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: theme.spacing.unit * 4,
      width: 'calc(100% - ' + theme.spacing.unit * 4 + 'px)',
      minWidth: theme.spacing.unit * 2, // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style
      },
      // Remove Firefox focus border
      '&:-moz-focusring': {
        color: 'transparent',
        textShadow: '0 0 0 #000'
      },
      // Remove IE11 arrow
      '&::-ms-expand': {
        display: 'none'
      }
    },
    selectMenu: {
      width: 'auto', // Fix Safari textOverflow
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      lineHeight: '1.1875em' // Reset (19px), match the native input line-height
    },
    disabled: {
      cursor: 'default'
    },
    icon: {
      position: 'absolute',
      right: 0,
      top: 4,
      color: theme.palette.text.secondary,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.
    }
  };
}; // @inheritedComponent Input

function Select(props) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      other = (0, _objectWithoutProperties3.default)(props, ['autoWidth', 'children', 'classes', 'displayEmpty', 'input', 'inputProps', 'MenuProps', 'multiple', 'native', 'onClose', 'onOpen', 'open', 'renderValue']);


  return _react2.default.cloneElement(input, (0, _extends3.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _SelectInput2.default
  }, other, {
    inputProps: (0, _extends3.default)({}, inputProps, input ? input.props.inputProps : {}, {
      autoWidth: autoWidth,
      children: children,
      classes: classes,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      multiple: multiple,
      native: native,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue
    })
  }));
}

Select.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes2.default.bool,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes2.default.element,
  /**
   * Properties applied to the `input` element.
   * When `native` is `true`, the properties are applied on the `select` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Properties applied to the `Menu` element.
   */
  MenuProps: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes2.default.bool,
  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback
   * @param {object} child The react element that was selected
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes2.default.func,
  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes2.default.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   */
  renderValue: _propTypes2.default.func,
  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  input: _react2.default.createElement(_Input2.default, null),
  multiple: false,
  native: false
};

Select.muiName = 'Select';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSelect' })(Select);

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(4);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(3);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(148);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(13);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(109);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(5);

var _warning2 = _interopRequireDefault(_warning);

var _ArrowDropDown = __webpack_require__(1108);

var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);

var _Menu = __webpack_require__(451);

var _Menu2 = _interopRequireDefault(_Menu);

var _Input = __webpack_require__(274);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var SelectInput = function (_React$Component) {
  (0, _inherits3.default)(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectInput.__proto__ || (0, _getPrototypeOf2.default)(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      anchorEl: null,
      open: false
    }, _this.ignoreNextBlur = false, _this.isControlled = _this.props.open !== undefined, _this.update = _this.isControlled ? function (_ref2) {
      var event = _ref2.event,
          open = _ref2.open,
          anchorEl = _ref2.anchorEl;

      if (open) {
        _this.props.onOpen(event);
      } else {
        _this.props.onClose(event);
      }
      _this.setState({ anchorEl: anchorEl });
    } : function (_ref3) {
      var open = _ref3.open,
          anchorEl = _ref3.anchorEl;
      return _this.setState({ open: open, anchorEl: anchorEl });
    }, _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;
      _this.update({
        open: true,
        anchorEl: event.currentTarget,
        event: event
      });
    }, _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    }, _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        if (_this.props.onChange) {
          var _this$props = _this.props,
              onChange = _this$props.onChange,
              name = _this$props.name;

          var value = void 0;
          var target = void 0;

          if (event.target) {
            target = event.target;
          }

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? [].concat((0, _toConsumableArray3.default)(_this.props.value)) : [];
            var itemIndex = value.indexOf(child.props.value);
            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = (0, _extends3.default)({}, target, { value: value, name: name });

          onChange(event, child);
        }
      };
    }, _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if (['space', 'up', 'down'].includes((0, _keycode2.default)(event))) {
        event.preventDefault();
        // Opening the menu is going to blur the. It will be focused back when closed.
        _this.ignoreNextBlur = true;
        _this.update({
          open: true,
          anchorEl: event.currentTarget,
          event: event
        });
      }
    }, _this.handleSelectRef = function (node) {
      if (!_this.props.selectRef) {
        return;
      }

      _this.props.selectRef({
        node: node,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SelectInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          disabled = _props.disabled,
          displayEmpty = _props.displayEmpty,
          _props$MenuProps = _props.MenuProps,
          MenuProps = _props$MenuProps === undefined ? {} : _props$MenuProps,
          multiple = _props.multiple,
          name = _props.name,
          native = _props.native,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClose = _props.onClose,
          onFocus = _props.onFocus,
          onOpen = _props.onOpen,
          open = _props.open,
          readOnly = _props.readOnly,
          renderValue = _props.renderValue,
          selectRef = _props.selectRef,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'classes', 'className', 'disabled', 'displayEmpty', 'MenuProps', 'multiple', 'name', 'native', 'onBlur', 'onChange', 'onClose', 'onFocus', 'onOpen', 'open', 'readOnly', 'renderValue', 'selectRef', 'value']);


      if (native) {
         false ? (0, _warning2.default)(multiple === false, 'Material-UI: you can not use the `native` and `multiple` properties ' + 'at the same time on a `Select` component.') : void 0;
         false ? (0, _warning2.default)(!renderValue, 'Material-UI: the `renderValue` property is not used by the native implementation.') : void 0;
         false ? (0, _warning2.default)(!displayEmpty, 'Material-UI: the `displayEmpty` property is not used by the native implementation.') : void 0;

        return _react2.default.createElement(
          'div',
          { className: classes.root },
          _react2.default.createElement(
            'select',
            (0, _extends3.default)({
              className: (0, _classnames2.default)(classes.select, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp),
              name: name,
              disabled: disabled,
              onBlur: onBlur,
              onChange: onChange,
              onFocus: onFocus,
              value: value,
              readOnly: readOnly,
              ref: selectRef
            }, other),
            children
          ),
          _react2.default.createElement(_ArrowDropDown2.default, { className: classes.icon })
        );
      }

      if (value === undefined) {
        throw new Error('Material-UI: the `value` property is required ' + 'when using the `Select` component with `native=false`.');
      }

      var display = void 0;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false;

      // No need to display any value if the field is empty.
      if ((0, _Input.isDirty)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react2.default.Children.map(children, function (child) {
        if (!_react2.default.isValidElement(child)) {
          return null;
        }
        var selected = void 0;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.indexOf(child.props.value) !== -1;
          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = value === child.props.value;
          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react2.default.cloneElement(child, {
          role: 'option',
          selected: selected,
          onClick: _this2.handleItemClick(child)
        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      }

      var minimumMenuWidth = this.state.anchorEl != null && !autoWidth ? this.state.anchorEl.clientWidth : undefined;

      return _react2.default.createElement(
        'div',
        { className: classes.root },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(classes.select, classes.selectMenu, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp),

            'aria-pressed': this.state.open ? 'true' : 'false',
            tabIndex: disabled ? null : 0,
            role: 'button',
            'aria-owns': this.state.open ? 'menu-' + (name || '') : null,
            'aria-haspopup': 'true',
            onKeyDown: this.handleKeyDown,
            onBlur: this.handleBlur,
            onClick: disabled || readOnly ? null : this.handleClick,
            onFocus: onFocus
          },
          display
        ),
        _react2.default.createElement('input', (0, _extends3.default)({
          value: Array.isArray(value) ? value.join(',') : value,
          name: name,
          readOnly: readOnly,
          ref: this.handleSelectRef
        }, other, {
          type: 'hidden'
        })),
        _react2.default.createElement(_ArrowDropDown2.default, { className: classes.icon }),
        _react2.default.createElement(
          _Menu2.default,
          (0, _extends3.default)({
            id: 'menu-' + (name || ''),
            anchorEl: this.state.anchorEl,
            open: this.isControlled ? open : this.state.open,
            onClose: this.handleClose
          }, MenuProps, {
            MenuListProps: (0, _extends3.default)({}, MenuProps.MenuListProps, {
              role: 'listbox'
            }),
            PaperProps: (0, _extends3.default)({}, MenuProps.PaperProps, {
              style: (0, _extends3.default)({
                minWidth: minimumMenuWidth
              }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
            })
          }),
          items
        )
      );
    }
  }]);
  return SelectInput;
}(_react2.default.Component);

SelectInput.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The CSS class name of the select element.
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes2.default.bool,
  /**
   * Properties applied to the `Menu` element.
   */
  MenuProps: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes2.default.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback
   * @param {object} child The react element that was selected
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes2.default.func,
  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes2.default.bool,
  /**
   * @ignore
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   */
  renderValue: _propTypes2.default.func,
  /**
   * Use that property to pass a ref callback to the native select element.
   */
  selectRef: _propTypes2.default.func,
  /**
   * The value of the component, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

SelectInput.muiName = 'SelectInput';

exports.default = SelectInput;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(273);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(117);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' });

var ArrowDropDown = function ArrowDropDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};

ArrowDropDown = (0, _pure2.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';

exports.default = ArrowDropDown;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(273);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(117);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' });

var Search = function Search(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Search = (0, _pure2.default)(Search);
Search.muiName = 'SvgIcon';

exports.default = Search;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var CONFIG=__webpack_require__(79);var RightMenu=function RightMenu(_ref){var handleItemClick=_ref.handleItemClick,handleMouseOut=_ref.handleMouseOut;var output=[];var _loop=function _loop(flag){output.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-menu',key:flag.country},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:flag.image,className:'flag',alt:'logo',onClick:function onClick(){return handleItemClick(flag.country);},onMouseOver:function onMouseOver(){return handleItemClick(flag.country);},onMouseOut:function onMouseOut(){return handleMouseOut();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'tooltiptext'},flag.name)));};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=CONFIG.flags[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var flag=_step.value;_loop(flag);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right-menu-container'},output);};RightMenu.propTypes={handleItemClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleMouseOut:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (RightMenu);

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__(1112)
  , qs = __webpack_require__(1113)
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @api public
 */
function lolcation(loc) {
  loc = loc || global.location || {};

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new URL(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new URL(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @api private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @api private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} location Location defaults for relative paths.
 * @param {Boolean|Function} parser Parser for the query string.
 * @api public
 */
function URL(address, location, parser) {
  if (!(this instanceof URL)) {
    return new URL(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[2] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL}
 * @api public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String}
 * @api public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

URL.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
URL.extractProtocol = extractProtocol;
URL.location = lolcation;
URL.qs = qs;

module.exports = URL;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  //
  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
  // the lastIndex property so we can continue executing this loop until we've
  // parsed all results.
  //
  for (;
    part = parser.exec(query);
    result[decodeURIComponent(part[1])] = decodeURIComponent(part[2])
  );

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [];

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(237);
var NotFound=function NotFound(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'404',className:'app__not-found app__route'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:'/'},__WEBPACK_IMPORTED_MODULE_1_config__["a" /* default */].name)));};/* harmony default export */ __webpack_exports__["a"] = (NotFound);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Icon__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_iframe_resizer_super__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_iframe_resizer_super___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_iframe_resizer_super__);
function resizedCallback_introduce(){document.getElementById("inneriframe_introduce").contentDocument.body.style.fontFamily="Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif";document.getElementById("inneriframe_introduce").contentDocument.body.style.color="#212529";document.getElementById("inneriframe_introduce").contentDocument.body.style.fontWeight="400";}var Introduce=function Introduce(_ref){var handleCloseClick=_ref.handleCloseClick,isopen=_ref.isopen;var output={};if(handleCloseClick){output.closeicon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Icon___default.a,{color:'action',onClick:handleCloseClick,className:'close-icon'},'close');}var iframeResizerOptions={checkOrigin:false,bodyMargin:30,resizedCallback:resizedCallback_introduce};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Drawer___default.a,{open:isopen,className:'intro-drawer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'intro-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'How Qatar funnels money to the world\'s terror organizations:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The emirate of Qatar has been known for many years as a strong supporter of Islamist movements. Not only did Qatar provide infrastructure and facilities for organizations tied to the GLOBAL MUSLIM BROTHERHOOD and/or HAMAS, Qatar also  financially supported other conservative Sunni Islamist movements.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'This report shows how Qatar has opened a branch of one of its most important funding infrastructures \u2013 Qatar Charity (QC) - at the heart of Europe\u2019s financial center London.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Due to its complexity the report is split into three chapters with subchapters: the original Qatar Charity, its branch in the UK and a single project \u2013\xA0the Emaan Trust in Sheffield.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You can access each chapter from the top-menu and read about it in the left sidebar. On the rightside you can see all relevant entities and their connections. Clicking on any connection or node will bring up further details and sources in the sidebar.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',null,'\xA9 2017 to 2018, 1389 Blog, Medford, OR 97501, United States of America.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'next-button',onClick:handleCloseClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Next')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{height:80}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Icon___default.a,{color:'action',onClick:handleCloseClick,className:'close-icon'},'close')));};Introduce.propTypes={handleCloseClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,isopen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (Introduce);

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(18);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(10);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(15);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(11);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(12);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(35);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _iframeResizer = __webpack_require__(1117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 * inject script to facilitate iframe resizing
 * https://github.com/davidjbradshaw/iframe-resizer
 *
 */
var IframeResizer = function (_React$Component) {
  (0, _inherits3.default)(IframeResizer, _React$Component);

  function IframeResizer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, IframeResizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IframeResizer.__proto__ || (0, _getPrototypeOf2.default)(IframeResizer)).call.apply(_ref, [this].concat(args))), _this), _this.updateIframe = function (props) {
      // has src - no injected content
      if (props.src) return;
      // do we have content to inject (content or children)
      var content = props.content || props.children;
      if (!content) return;
      // get frame to inject into
      var frame = _this.refs.frame;
      if (!frame) return;
      // verify frame document access
      // Due to browser security, this will fail with the following error
      //   Uncaught DOMException: Failed to read the 'contentDocument' property from 'HTMLIFrameElement':
      //   Blocked a frame with origin "http://<hostname>" from accessing a cross-origin frame.
      // resolve this by loading documents from the same domain name,
      // or injecting HTML `content` vs. loading via `src`
      var doc = frame.contentDocument;
      if (!doc) return;
      // replace iframe document content
      if (typeof content === 'string') {
        // assume this is a HTML block
        //   we could send this in via REACT dangerously set HTML
        //   but we are in an iframe anyway, already a red-headed step-child.
        doc.open();
        doc.write(content);
        doc.close();
      } else {
        // assume this is a REACT component
        doc.open();
        doc.write('<div id="iframe-root"></div>');
        doc.close();
        _reactDom2.default.render(content, doc.getElementById('iframe-root'));
      }
    }, _this.injectIframeResizerUrl = function () {
      if (!_this.props.iframeResizerUrl) return;
      var frame = _this.refs.frame;
      if (!frame) return;
      // verify frame document access
      // Due to browser security, this will fail with the following error
      //   Uncaught DOMException: Failed to read the 'contentDocument' property from 'HTMLIFrameElement':
      //   Blocked a frame with origin "http://<hostname>" from accessing a cross-origin frame.
      // resolve this by loading documents from the same domain name,
      // or injecting HTML `content` vs. loading via `src`
      var doc = frame.contentDocument;
      if (!doc) return;
      // where can we insert into? (fail into whatever we can find)
      var injectTarget = null;
      ['head', 'HEAD', 'body', 'BODY', 'div', 'DIV'].forEach(function (tagName) {
        if (injectTarget) return;
        var found = doc.getElementsByTagName(tagName);
        if (!(found && found.length)) return;
        injectTarget = found[0];
      });
      if (!injectTarget) {
        console.error('Unable to inject iframe resizer script');
        return;
      }
      var resizerScriptElement = document.createElement('script');
      resizerScriptElement.type = 'text/javascript';
      resizerScriptElement.src = _this.props.iframeResizerUrl;
      injectTarget.appendChild(resizerScriptElement);
    }, _this.onLoad = function () {
      _this.injectIframeResizerUrl();
      // DISABLED because it's causing a loading loop :(
      // if (this.props.onIframeLoaded) this.props.onIframeLoaded();
    }, _this.resizeIframe = function (props) {
      var frame = _this.refs.frame;
      if (!frame) return;
      if (props.iframeResizerEnable) {
        (0, _iframeResizer.iframeResizer)(props.iframeResizerOptions, frame);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(IframeResizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // can't update until we have a mounted iframe
      this.updateIframe(this.props);
      this.resizeIframe(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // can replace content if we got new props
      this.updateIframe(nextProps);
      this.resizeIframe(nextProps);
    }
    // inject the iframe resizer "content window" script

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          id = _props.id,
          frameBorder = _props.frameBorder,
          className = _props.className,
          style = _props.style;

      return _react2.default.createElement('iframe', {
        ref: 'frame',
        src: src,
        id: id,
        frameBorder: frameBorder,
        className: className,
        style: style,
        onLoad: this.onLoad
      });
    }
  }]);
  return IframeResizer;
}(_react2.default.Component);

IframeResizer.propTypes = {
  // iframe content/document
  // option 1. content of HTML to load in the iframe
  content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  // option 2. src to a URL to load in the iframe
  src: _propTypes2.default.string,
  // iframe-resizer controls and helpers
  iframeResizerEnable: _propTypes2.default.bool,
  iframeResizerOptions: _propTypes2.default.object,
  iframeResizerUrl: _propTypes2.default.oneOfType([_propTypes2.default.string, // URL to inject
  _propTypes2.default.bool]),
  // misc props to pass through to iframe
  id: _propTypes2.default.string,
  frameBorder: _propTypes2.default.number,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};
IframeResizer.defaultProps = {
  // resize iframe
  iframeResizerEnable: true,
  iframeResizerOptions: {
    // log: true,
    // autoResize: true,
    // checkOrigin: false,
    // resizeFrom: 'parent',
    // heightCalculationMethod: 'max',
    // initCallback: () => { console.log('ready!'); },
    // resizedCallback: () => { console.log('resized!'); },
  },
  iframeResizerUrl: 'https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.8/iframeResizer.contentWindow.min.js',
  // misc props to pass through to iframe
  frameBorder: 0,
  style: {
    width: '100%',
    minHeight: 20
  }
};

exports.default = IframeResizer;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = __webpack_require__(1118);


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

exports.iframeResizer = __webpack_require__(1119);
exports.iframeResizerContentWindow = __webpack_require__(1120);


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * File: iframeResizer.js
 * Desc: Force iframes to size to content.
 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Reed Dadoune - reed@dadoune.com
 */


;(function(undefined) {
  'use strict';

  if(typeof window === 'undefined') return; // don't run for server side render

  var
    count                 = 0,
    logEnabled            = false,
    hiddenCheckEnabled    = false,
    msgHeader             = 'message',
    msgHeaderLen          = msgHeader.length,
    msgId                 = '[iFrameSizer]', //Must match iframe msg ID
    msgIdLen              = msgId.length,
    pagePosition          = null,
    requestAnimationFrame = window.requestAnimationFrame,
    resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
    settings              = {},
    timer                 = null,
    logId                 = 'Host Page',

    defaults              = {
      autoResize                : true,
      bodyBackground            : null,
      bodyMargin                : null,
      bodyMarginV1              : 8,
      bodyPadding               : null,
      checkOrigin               : true,
      inPageLinks               : false,
      enablePublicMethods       : true,
      heightCalculationMethod   : 'bodyOffset',
      id                        : 'iFrameResizer',
      interval                  : 32,
      log                       : false,
      maxHeight                 : Infinity,
      maxWidth                  : Infinity,
      minHeight                 : 0,
      minWidth                  : 0,
      resizeFrom                : 'parent',
      scrolling                 : false,
      sizeHeight                : true,
      sizeWidth                 : false,
      warningTimeout            : 5000,
      tolerance                 : 0,
      widthCalculationMethod    : 'scroll',
      closedCallback            : function() {},
      initCallback              : function() {},
      messageCallback           : function() {warn('MessageCallback function not defined');},
      resizedCallback           : function() {},
      scrollCallback            : function() {return true;}
    };

  function addEventListener(obj,evt,func) {
    /* istanbul ignore else */ // Not testable in PhantonJS
    if ('addEventListener' in window) {
      obj.addEventListener(evt,func, false);
    } else if ('attachEvent' in window) {//IE
      obj.attachEvent('on'+evt,func);
    }
  }

  function removeEventListener(el,evt,func) {
    /* istanbul ignore else */ // Not testable in phantonJS
    if ('removeEventListener' in window) {
      el.removeEventListener(evt,func, false);
    } else if ('detachEvent' in window) { //IE
      el.detachEvent('on'+evt,func);
    }
  }

  function setupRequestAnimationFrame() {
    var
      vendors = ['moz', 'webkit', 'o', 'ms'],
      x;

    // Remove vendor prefixing if prefixed and break early if not
    for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
      requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    }

    if (!(requestAnimationFrame)) {
      log('setup','RequestAnimationFrame not supported');
    }
  }

  function getMyID(iframeId) {
    var retStr = 'Host page: '+iframeId;

    if (window.top !== window.self) {
      if (window.parentIFrame && window.parentIFrame.getId) {
        retStr = window.parentIFrame.getId()+': '+iframeId;
      } else {
        retStr = 'Nested host page: '+iframeId;
      }
    }

    return retStr;
  }

  function formatLogHeader(iframeId) {
    return msgId + '[' + getMyID(iframeId) + ']';
  }

  function isLogEnabled(iframeId) {
    return settings[iframeId] ? settings[iframeId].log : logEnabled;
  }

  function log(iframeId,msg) {
    output('log',iframeId,msg,isLogEnabled(iframeId));
  }

  function info(iframeId,msg) {
    output('info',iframeId,msg,isLogEnabled(iframeId));
  }

  function warn(iframeId,msg) {
    output('warn',iframeId,msg,true);
  }

  function output(type,iframeId,msg,enabled) {
    if (true === enabled && 'object' === typeof window.console) {
      console[type](formatLogHeader(iframeId),msg);
    }
  }

  function iFrameListener(event) {
    function resizeIFrame() {
      function resize() {
        setSize(messageData);
        setPagePosition(iframeId);
        callback('resizedCallback',messageData);
      }

      ensureInRange('Height');
      ensureInRange('Width');

      syncResize(resize,messageData,'init');
    }

    function processMsg() {
      var data = msg.substr(msgIdLen).split(':');

      return {
        iframe: settings[data[0]] && settings[data[0]].iframe,
        id:     data[0],
        height: data[1],
        width:  data[2],
        type:   data[3]
      };
    }

    function ensureInRange(Dimension) {
      var
        max  = Number(settings[iframeId]['max' + Dimension]),
        min  = Number(settings[iframeId]['min' + Dimension]),
        dimension = Dimension.toLowerCase(),
        size = Number(messageData[dimension]);

      log(iframeId,'Checking ' + dimension + ' is in range ' + min + '-' + max);

      if (size<min) {
        size=min;
        log(iframeId,'Set ' + dimension + ' to min value');
      }

      if (size>max) {
        size=max;
        log(iframeId,'Set ' + dimension + ' to max value');
      }

      messageData[dimension] = '' + size;
    }


    function isMessageFromIFrame() {
      function checkAllowedOrigin() {
        function checkList() {
          var
            i = 0,
            retCode = false;

          log(iframeId,'Checking connection is from allowed list of origins: ' + checkOrigin);

          for (; i < checkOrigin.length; i++) {
            if (checkOrigin[i] === origin) {
              retCode = true;
              break;
            }
          }
          return retCode;
        }

        function checkSingle() {
          var remoteHost  = settings[iframeId] && settings[iframeId].remoteHost;
          log(iframeId,'Checking connection is from: '+remoteHost);
          return origin === remoteHost;
        }

        return checkOrigin.constructor === Array ? checkList() : checkSingle();
      }

      var
        origin      = event.origin,
        checkOrigin = settings[iframeId] && settings[iframeId].checkOrigin;

      if (checkOrigin && (''+origin !== 'null') && !checkAllowedOrigin()) {
        throw new Error(
          'Unexpected message received from: ' + origin +
          ' for ' + messageData.iframe.id +
          '. Message was: ' + event.data +
          '. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
        );
      }

      return true;
    }

    function isMessageForUs() {
      return msgId === (('' + msg).substr(0,msgIdLen)) && (msg.substr(msgIdLen).split(':')[0] in settings); //''+Protects against non-string msg
    }

    function isMessageFromMetaParent() {
      //Test if this message is from a parent above us. This is an ugly test, however, updating
      //the message format would break backwards compatibity.
      var retCode = messageData.type in {'true':1,'false':1,'undefined':1};

      if (retCode) {
        log(iframeId,'Ignoring init message from meta parent page');
      }

      return retCode;
    }

    function getMsgBody(offset) {
      return msg.substr(msg.indexOf(':')+msgHeaderLen+offset);
    }

    function forwardMsgFromIFrame(msgBody) {
      log(iframeId,'MessageCallback passed: {iframe: '+ messageData.iframe.id + ', message: ' + msgBody + '}');
      callback('messageCallback',{
        iframe: messageData.iframe,
        message: JSON.parse(msgBody)
      });
      log(iframeId,'--');
    }

    function getPageInfo() {
      var
        bodyPosition   = document.body.getBoundingClientRect(),
        iFramePosition = messageData.iframe.getBoundingClientRect();

      return JSON.stringify({
        iframeHeight: iFramePosition.height,
        iframeWidth:  iFramePosition.width,
        clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
        clientWidth:  Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0),
        offsetTop:    parseInt(iFramePosition.top  - bodyPosition.top,  10),
        offsetLeft:   parseInt(iFramePosition.left - bodyPosition.left, 10),
        scrollTop:    window.pageYOffset,
        scrollLeft:   window.pageXOffset
      });
    }

    function sendPageInfoToIframe(iframe,iframeId) {
      function debouncedTrigger() {
        trigger(
          'Send Page Info',
          'pageInfo:' + getPageInfo(),
          iframe,
          iframeId
        );
      }

      debouce(debouncedTrigger,32);
    }


    function startPageInfoMonitor() {
      function setListener(type,func) {
        function sendPageInfo() {
          if (settings[id]) {
            sendPageInfoToIframe(settings[id].iframe,id);
          } else {
            stop();
          }
        }

        ['scroll','resize'].forEach(function(evt) {
          log(id, type +  evt + ' listener for sendPageInfo');
          func(window,evt,sendPageInfo);
        });
      }

      function stop() {
        setListener('Remove ', removeEventListener);
      }

      function start() {
        setListener('Add ', addEventListener);
      }

      var id = iframeId; //Create locally scoped copy of iFrame ID

      start();

      if (settings[id]) {
        settings[id].stopPageInfo = stop;
      }
    }

    function stopPageInfoMonitor() {
      if (settings[iframeId] && settings[iframeId].stopPageInfo) {
        settings[iframeId].stopPageInfo();
        delete settings[iframeId].stopPageInfo;
      }
    }

    function checkIFrameExists() {
      var retBool = true;

      if (null === messageData.iframe) {
        warn(iframeId,'IFrame ('+messageData.id+') not found');
        retBool = false;
      }
      return retBool;
    }

    function getElementPosition(target) {
      var iFramePosition = target.getBoundingClientRect();

      getPagePosition(iframeId);

      return {
        x: Math.floor( Number(iFramePosition.left) + Number(pagePosition.x) ),
        y: Math.floor( Number(iFramePosition.top)  + Number(pagePosition.y) )
      };
    }

    function scrollRequestFromChild(addOffset) {
      /* istanbul ignore next */  //Not testable in Karma
      function reposition() {
        pagePosition = newPosition;
        scrollTo();
        log(iframeId,'--');
      }

      function calcOffset() {
        return {
          x: Number(messageData.width) + offset.x,
          y: Number(messageData.height) + offset.y
        };
      }

      function scrollParent() {
        if (window.parentIFrame) {
          window.parentIFrame['scrollTo'+(addOffset?'Offset':'')](newPosition.x,newPosition.y);
        } else {
          warn(iframeId,'Unable to scroll to requested position, window.parentIFrame not found');
        }
      }

      var
        offset = addOffset ? getElementPosition(messageData.iframe) : {x:0,y:0},
        newPosition = calcOffset();

      log(iframeId,'Reposition requested from iFrame (offset x:'+offset.x+' y:'+offset.y+')');

      if(window.top !== window.self) {
        scrollParent();
      } else {
        reposition();
      }
    }

    function scrollTo() {
      if (false !== callback('scrollCallback',pagePosition)) {
        setPagePosition(iframeId);
      } else {
        unsetPagePosition();
      }
    }

    function findTarget(location) {
      function jumpToTarget() {
        var jumpPosition = getElementPosition(target);

        log(iframeId,'Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
        pagePosition = {
          x: jumpPosition.x,
          y: jumpPosition.y
        };

        scrollTo();
        log(iframeId,'--');
      }

      function jumpToParent() {
        if (window.parentIFrame) {
          window.parentIFrame.moveToAnchor(hash);
        } else {
          log(iframeId,'In page link #'+hash+' not found and window.parentIFrame not found');
        }
      }

      var
        hash     = location.split('#')[1] || '',
        hashData = decodeURIComponent(hash),
        target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

      if (target) {
        jumpToTarget();
      } else if(window.top!==window.self) {
        jumpToParent();
      } else {
        log(iframeId,'In page link #'+hash+' not found');
      }
    }

    function callback(funcName,val) {
      return chkCallback(iframeId,funcName,val);
    }

    function actionMsg() {

      if(settings[iframeId] && settings[iframeId].firstRun) firstRun();

      switch(messageData.type) {
      case 'close':
        if(settings[iframeId].closeRequestCallback) chkCallback(iframeId, 'closeRequestCallback', settings[iframeId].iframe);
        else closeIFrame(messageData.iframe);
        break;
      case 'message':
        forwardMsgFromIFrame(getMsgBody(6));
        break;
      case 'scrollTo':
        scrollRequestFromChild(false);
        break;
      case 'scrollToOffset':
        scrollRequestFromChild(true);
        break;
      case 'pageInfo':
        sendPageInfoToIframe(settings[iframeId] && settings[iframeId].iframe,iframeId);
        startPageInfoMonitor();
        break;
      case 'pageInfoStop':
        stopPageInfoMonitor();
        break;
      case 'inPageLink':
        findTarget(getMsgBody(9));
        break;
      case 'reset':
        resetIFrame(messageData);
        break;
      case 'init':
        resizeIFrame();
        callback('initCallback',messageData.iframe);
        break;
      default:
        resizeIFrame();
      }
    }

    function hasSettings(iframeId) {
      var retBool = true;

      if (!settings[iframeId]) {
        retBool = false;
        warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
      }

      return retBool;
    }

    function iFrameReadyMsgReceived() {
      for (var iframeId in settings) {
        trigger('iFrame requested init',createOutgoingMsg(iframeId),document.getElementById(iframeId),iframeId);
      }
    }

    function firstRun() {
      if (settings[iframeId]) {
        settings[iframeId].firstRun = false;
      }
    }

    function clearWarningTimeout() {
      if (settings[iframeId]) {
        clearTimeout(settings[iframeId].msgTimeout);
        settings[iframeId].warningTimeout = 0;
      }
    }

    var
      msg = event.data,
      messageData = {},
      iframeId = null;

    if('[iFrameResizerChild]Ready' === msg) {
      iFrameReadyMsgReceived();
    } else if (isMessageForUs()) {
      messageData = processMsg();
      iframeId    = logId = messageData.id;
      if (settings[iframeId]) {
        settings[iframeId].loaded = true;
      }

      if (!isMessageFromMetaParent() && hasSettings(iframeId)) {
        log(iframeId,'Received: '+msg);

        if ( checkIFrameExists() && isMessageFromIFrame() ) {
          actionMsg();
        }
      }
    } else {
      info(iframeId,'Ignored: '+msg);
    }

  }


  function chkCallback(iframeId,funcName,val) {
    var
      func = null,
      retVal = null;

    if(settings[iframeId]) {
      func = settings[iframeId][funcName];

      if( 'function' === typeof func) {
        retVal = func(val);
      } else {
        throw new TypeError(funcName+' on iFrame['+iframeId+'] is not a function');
      }
    }

    return retVal;
  }

  function closeIFrame(iframe) {
    var iframeId = iframe.id;

    log(iframeId,'Removing iFrame: '+iframeId);
    if (iframe.parentNode) { iframe.parentNode.removeChild(iframe); }
    chkCallback(iframeId,'closedCallback',iframeId);
    log(iframeId,'--');
    delete settings[iframeId];
  }

  function getPagePosition(iframeId) {
    if(null === pagePosition) {
      pagePosition = {
        x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
        y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
      };
      log(iframeId,'Get page position: '+pagePosition.x+','+pagePosition.y);
    }
  }

  function setPagePosition(iframeId) {
    if(null !== pagePosition) {
      window.scrollTo(pagePosition.x,pagePosition.y);
      log(iframeId,'Set page position: '+pagePosition.x+','+pagePosition.y);
      unsetPagePosition();
    }
  }

  function unsetPagePosition() {
    pagePosition = null;
  }

  function resetIFrame(messageData) {
    function reset() {
      setSize(messageData);
      trigger('reset','reset',messageData.iframe,messageData.id);
    }

    log(messageData.id,'Size reset requested by '+('init'===messageData.type?'host page':'iFrame'));
    getPagePosition(messageData.id);
    syncResize(reset,messageData,'reset');
  }

  function setSize(messageData) {
    function setDimension(dimension) {
      messageData.iframe.style[dimension] = messageData[dimension] + 'px';
      log(
        messageData.id,
        'IFrame (' + iframeId +
        ') ' + dimension +
        ' set to ' + messageData[dimension] + 'px'
      );
    }

    function chkZero(dimension) {
      //FireFox sets dimension of hidden iFrames to zero.
      //So if we detect that set up an event to check for
      //when iFrame becomes visible.

      /* istanbul ignore next */  //Not testable in PhantomJS
      if (!hiddenCheckEnabled && '0' === messageData[dimension]) {
        hiddenCheckEnabled = true;
        log(iframeId,'Hidden iFrame detected, creating visibility listener');
        fixHiddenIFrames();
      }
    }

    function processDimension(dimension) {
      setDimension(dimension);
      chkZero(dimension);
    }

    var iframeId = messageData.iframe.id;

    if(settings[iframeId]) {
      if( settings[iframeId].sizeHeight) { processDimension('height'); }
      if( settings[iframeId].sizeWidth ) { processDimension('width'); }
    }
  }

  function syncResize(func,messageData,doNotSync) {
    /* istanbul ignore if */  //Not testable in PhantomJS
    if(doNotSync!==messageData.type && requestAnimationFrame) {
      log(messageData.id,'Requesting animation frame');
      requestAnimationFrame(func);
    } else {
      func();
    }
  }

  function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
    function postMessageToIFrame() {
      var target = settings[id] && settings[id].targetOrigin;
      log(id,'[' + calleeMsg + '] Sending msg to iframe['+id+'] ('+msg+') targetOrigin: '+target);
      iframe.contentWindow.postMessage( msgId + msg, target );
    }

    function iFrameNotFound() {
      warn(id,'[' + calleeMsg + '] IFrame('+id+') not found');
    }

    function chkAndSend() {
      if(iframe && 'contentWindow' in iframe && (null !== iframe.contentWindow)) { //Null test for PhantomJS
        postMessageToIFrame();
      } else {
        iFrameNotFound();
      }
    }

    function warnOnNoResponse() {
      function warning() {
        if (settings[id] && !settings[id].loaded && !errorShown) {
          errorShown = true;
          warn(id, 'IFrame has not responded within '+ settings[id].warningTimeout/1000 +' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ingored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
        }
      }

      if (!!noResponseWarning && settings[id] && !!settings[id].warningTimeout) {
        settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
      }
    }

    var errorShown = false;

    id = id || iframe.id;

    if(settings[id]) {
      chkAndSend();
      warnOnNoResponse();
    }

  }

  function createOutgoingMsg(iframeId) {
    return iframeId +
      ':' + settings[iframeId].bodyMarginV1 +
      ':' + settings[iframeId].sizeWidth +
      ':' + settings[iframeId].log +
      ':' + settings[iframeId].interval +
      ':' + settings[iframeId].enablePublicMethods +
      ':' + settings[iframeId].autoResize +
      ':' + settings[iframeId].bodyMargin +
      ':' + settings[iframeId].heightCalculationMethod +
      ':' + settings[iframeId].bodyBackground +
      ':' + settings[iframeId].bodyPadding +
      ':' + settings[iframeId].tolerance +
      ':' + settings[iframeId].inPageLinks +
      ':' + settings[iframeId].resizeFrom +
      ':' + settings[iframeId].widthCalculationMethod;
  }

  function setupIFrame(iframe,options) {
    function setLimits() {
      function addStyle(style) {
        if ((Infinity !== settings[iframeId][style]) && (0 !== settings[iframeId][style])) {
          iframe.style[style] = settings[iframeId][style] + 'px';
          log(iframeId,'Set '+style+' = '+settings[iframeId][style]+'px');
        }
      }

      function chkMinMax(dimension) {
        if (settings[iframeId]['min'+dimension]>settings[iframeId]['max'+dimension]) {
          throw new Error('Value for min'+dimension+' can not be greater than max'+dimension);
        }
      }

      chkMinMax('Height');
      chkMinMax('Width');

      addStyle('maxHeight');
      addStyle('minHeight');
      addStyle('maxWidth');
      addStyle('minWidth');
    }

    function newId() {
      var id = ((options && options.id) || defaults.id + count++);
      if  (null !== document.getElementById(id)) {
        id = id + count++;
      }
      return id;
    }

    function ensureHasId(iframeId) {
      logId=iframeId;
      if (''===iframeId) {
        iframe.id = iframeId =  newId();
        logEnabled = (options || {}).log;
        logId=iframeId;
        log(iframeId,'Added missing iframe ID: '+ iframeId +' (' + iframe.src + ')');
      }


      return iframeId;
    }

    function setScrolling() {
      log(iframeId,'IFrame scrolling ' + (settings[iframeId] && settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
      iframe.style.overflow = false === (settings[iframeId] && settings[iframeId].scrolling) ? 'hidden' : 'auto';
      switch(settings[iframeId] && settings[iframeId].scrolling) {
        case true:
          iframe.scrolling = 'yes';
          break;
        case false:
          iframe.scrolling = 'no';
          break;
        default:
          iframe.scrolling = settings[iframeId] ? settings[iframeId].scrolling : 'no';
      }
    }

    //The V1 iFrame script expects an int, where as in V2 expects a CSS
    //string value such as '1px 3em', so if we have an int for V2, set V1=V2
    //and then convert V2 to a string PX value.
    function setupBodyMarginValues() {
      if (('number'===typeof(settings[iframeId] && settings[iframeId].bodyMargin)) || ('0'===(settings[iframeId] && settings[iframeId].bodyMargin))) {
        settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
        settings[iframeId].bodyMargin   = '' + settings[iframeId].bodyMargin + 'px';
      }
    }

    function checkReset() {
      // Reduce scope of firstRun to function, because IE8's JS execution
      // context stack is borked and this value gets externally
      // changed midway through running this function!!!
      var
        firstRun           = settings[iframeId] && settings[iframeId].firstRun,
        resetRequertMethod = settings[iframeId] && settings[iframeId].heightCalculationMethod in resetRequiredMethods;

      if (!firstRun && resetRequertMethod) {
        resetIFrame({iframe:iframe, height:0, width:0, type:'init'});
      }
    }

    function setupIFrameObject() {
      if(Function.prototype.bind && settings[iframeId]) { //Ignore unpolyfilled IE8.
        settings[iframeId].iframe.iFrameResizer = {

          close        : closeIFrame.bind(null,settings[iframeId].iframe),

          resize       : trigger.bind(null,'Window resize', 'resize', settings[iframeId].iframe),

          moveToAnchor : function(anchor) {
            trigger('Move to anchor','moveToAnchor:'+anchor, settings[iframeId].iframe,iframeId);
          },

          sendMessage  : function(message) {
            message = JSON.stringify(message);
            trigger('Send Message','message:'+message, settings[iframeId].iframe, iframeId);
          }
        };
      }
    }

    //We have to call trigger twice, as we can not be sure if all
    //iframes have completed loading when this code runs. The
    //event listener also catches the page changing in the iFrame.
    function init(msg) {
      function iFrameLoaded() {
        trigger('iFrame.onload', msg, iframe, undefined , true);
        checkReset();
      }

      addEventListener(iframe,'load',iFrameLoaded);
      trigger('init', msg, iframe, undefined, true);
    }

    function checkOptions(options) {
      if ('object' !== typeof options) {
        throw new TypeError('Options is not an object');
      }
    }

    function copyOptions(options) {
      for (var option in defaults) {
        if (defaults.hasOwnProperty(option)) {
          settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
        }
      }
    }

    function getTargetOrigin (remoteHost) {
      return ('' === remoteHost || 'file://' === remoteHost) ? '*' : remoteHost;
    }

    function processOptions(options) {
      options = options || {};
      settings[iframeId] = {
        firstRun	: true,
        iframe		: iframe,
        remoteHost	: iframe.src.split('/').slice(0,3).join('/')
      };

      checkOptions(options);
      copyOptions(options);

      if (settings[iframeId]) {
        settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
      }
    }

    function beenHere() {
      return (iframeId in settings && 'iFrameResizer' in iframe);
    }

    var iframeId = ensureHasId(iframe.id);

    if (!beenHere()) {
      processOptions(options);
      setScrolling();
      setLimits();
      setupBodyMarginValues();
      init(createOutgoingMsg(iframeId));
      setupIFrameObject();
    } else {
      warn(iframeId,'Ignored iFrame, already setup.');
    }
  }

  function debouce(fn,time) {
    if (null === timer) {
      timer = setTimeout(function() {
        timer = null;
        fn();
      }, time);
    }
  }

  /* istanbul ignore next */  //Not testable in PhantomJS
  function fixHiddenIFrames() {
    function checkIFrames() {
      function checkIFrame(settingId) {
        function chkDimension(dimension) {
          return '0px' === (settings[settingId] && settings[settingId].iframe.style[dimension]);
        }

        function isVisible(el) {
          return (null !== el.offsetParent);
        }

        if (settings[settingId] && isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))) {
          trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
        }
      }

      for (var settingId in settings) {
        checkIFrame(settingId);
      }
    }

    function mutationObserved(mutations) {
      log('window','Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
      debouce(checkIFrames,16);
    }

    function createMutationObserver() {
      var
        target = document.querySelector('body'),

        config = {
          attributes            : true,
          attributeOldValue     : false,
          characterData         : true,
          characterDataOldValue : false,
          childList             : true,
          subtree               : true
        },

        observer = new MutationObserver(mutationObserved);

      observer.observe(target, config);
    }

    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

    if (MutationObserver) createMutationObserver();
  }


  function resizeIFrames(event) {
    function resize() {
      sendTriggerMsg('Window '+event,'resize');
    }

    log('window','Trigger event: '+event);
    debouce(resize,16);
  }

  /* istanbul ignore next */  //Not testable in PhantomJS
  function tabVisible() {
    function resize() {
      sendTriggerMsg('Tab Visable','resize');
    }

    if('hidden' !== document.visibilityState) {
      log('document','Trigger event: Visiblity change');
      debouce(resize,16);
    }
  }

  function sendTriggerMsg(eventName,event) {
    function isIFrameResizeEnabled(iframeId) {
      return	settings[iframeId] &&
          'parent' === settings[iframeId].resizeFrom &&
          settings[iframeId].autoResize &&
          !settings[iframeId].firstRun;
    }

    for (var iframeId in settings) {
      if(isIFrameResizeEnabled(iframeId)) {
        trigger(eventName, event, document.getElementById(iframeId), iframeId);
      }
    }
  }

  function setupEventListeners() {
    addEventListener(window,'message',iFrameListener);

    addEventListener(window,'resize', function() {resizeIFrames('resize');});

    addEventListener(document,'visibilitychange',tabVisible);
    addEventListener(document,'-webkit-visibilitychange',tabVisible); //Andriod 4.4
    addEventListener(window,'focusin',function() {resizeIFrames('focus');}); //IE8-9
    addEventListener(window,'focus',function() {resizeIFrames('focus');});
  }


  function factory() {
    function init(options,element) {
      function chkType() {
        if(!element.tagName) {
          throw new TypeError('Object is not a valid DOM element');
        } else if ('IFRAME' !== element.tagName.toUpperCase()) {
          throw new TypeError('Expected <IFRAME> tag, found <'+element.tagName+'>');
        }
      }

      if(element) {
        chkType();
        setupIFrame(element, options);
        iFrames.push(element);
      }
    }

    function warnDeprecatedOptions(options) {
      if (options && options.enablePublicMethods) {
        warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
      }
    }

    var iFrames;

    setupRequestAnimationFrame();
    setupEventListeners();

    return function iFrameResizeF(options,target) {
      iFrames = []; //Only return iFrames past in on this call

      warnDeprecatedOptions(options);

      switch (typeof(target)) {
      case 'undefined':
      case 'string':
        Array.prototype.forEach.call(
          document.querySelectorAll( target || 'iframe' ),
          init.bind(undefined, options)
        );
        break;
      case 'object':
        init(options,target);
        break;
      default:
        throw new TypeError('Unexpected data type ('+typeof(target)+')');
      }

      return iFrames;
    };
  }

  function createJQueryPublicMethod($) {
    if (!$.fn) {
      info('','Unable to bind to jQuery, it is not fully loaded.');
    } else if (!$.fn.iFrameResize) {
      $.fn.iFrameResize = function $iFrameResizeF(options) {
        function init(index, element) {
          setupIFrame(element, options);
        }

        return this.filter('iframe').each(init).end();
      };
    }
  }

  if (window.jQuery) { createJQueryPublicMethod(window.jQuery); }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && typeof module.exports === 'object') { //Node for browserfy
    module.exports = factory();
  } else {
    window.iFrameResize = window.iFrameResize || factory();
  }

})();


/***/ }),
/* 1120 */
/***/ (function(module, exports) {

/*
 * File: iframeResizer.contentWindow.js
 * Desc: Include this file in any page being loaded into an iframe
 *       to force the iframe to resize to the content size.
 * Requires: iframeResizer.js on host page.
 * Doc: https://github.com/davidjbradshaw/iframe-resizer
 * Author: David J. Bradshaw - dave@bradshaw.net
 * Contributor: Jure Mav - jure.mav@gmail.com
 * Contributor: Ian Caunce - ian@hallnet.co.uk
 */


;(function(undefined) {
  'use strict';

  if(typeof window === 'undefined') return; // don't run for server side render

  var
    autoResize            = true,
    base                  = 10,
    bodyBackground        = '',
    bodyMargin            = 0,
    bodyMarginStr         = '',
    bodyObserver          = null,
    bodyPadding           = '',
    calculateWidth        = false,
    doubleEventList       = {'resize':1,'click':1},
    eventCancelTimer      = 128,
    firstRun              = true,
    height                = 1,
    heightCalcModeDefault = 'bodyOffset',
    heightCalcMode        = heightCalcModeDefault,
    initLock              = true,
    initMsg               = '',
    inPageLinks           = {},
    interval              = 32,
    intervalTimer         = null,
    logging               = false,
    msgID                 = '[iFrameSizer]',  //Must match host page msg ID
    msgIdLen              = msgID.length,
    myID                  = '',
    observer              = null,
    resetRequiredMethods  = {max:1,min:1,bodyScroll:1,documentElementScroll:1},
    resizeFrom            = 'child',
    sendPermit            = true,
    target                = window.parent,
    targetOriginDefault   = '*',
    tolerance             = 0,
    triggerLocked         = false,
    triggerLockedTimer    = null,
    throttledTimer        = 16,
    width                 = 1,
    widthCalcModeDefault  = 'scroll',
    widthCalcMode         = widthCalcModeDefault,
    win                   = window,
    messageCallback       = function() { warn('MessageCallback function not defined'); },
    readyCallback         = function() {},
    pageInfoCallback      = function() {},
    customCalcMethods     = {
      height: function() {
        warn('Custom height calculation function not defined');
        return document.documentElement.offsetHeight;
      },
      width: function() {
        warn('Custom width calculation function not defined');
        return document.body.scrollWidth;
      }
    },
    eventHandlersByName   = {};


  function addEventListener(el,evt,func) {
    /* istanbul ignore else */ // Not testable in phantonJS
    if ('addEventListener' in window) {
      el.addEventListener(evt,func, false);
    } else if ('attachEvent' in window) { //IE
      el.attachEvent('on'+evt,func);
    }
  }

  function removeEventListener(el,evt,func) {
    /* istanbul ignore else */ // Not testable in phantonJS
    if ('removeEventListener' in window) {
      el.removeEventListener(evt,func, false);
    } else if ('detachEvent' in window) { //IE
      el.detachEvent('on'+evt,func);
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  //Based on underscore.js
  function throttle(func) {
    var
      context, args, result,
      timeout = null,
      previous = 0,
      later = function() {
        previous = getNow();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) {
          context = args = null;
        }
      };

    return function() {
      var now = getNow();

      if (!previous) {
        previous = now;
      }

      var remaining = throttledTimer - (now - previous);

      context = this;
      args = arguments;

      if (remaining <= 0 || remaining > throttledTimer) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }

        previous = now;
        result = func.apply(context, args);

        if (!timeout) {
          context = args = null;
        }

      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  }

  var getNow = Date.now || function() {
    /* istanbul ignore next */ // Not testable in PhantonJS
    return new Date().getTime();
  };

  function formatLogMsg(msg) {
    return msgID + '[' + myID + ']' + ' ' + msg;
  }

  function log(msg) {
    if (logging && ('object' === typeof window.console)) {
      console.log(formatLogMsg(msg));
    }
  }

  function warn(msg) {
    if ('object' === typeof window.console) {
      console.warn(formatLogMsg(msg));
    }
  }


  function init() {
    readDataFromParent();
    log('Initialising iFrame ('+location.href+')');
    readDataFromPage();
    setMargin();
    setBodyStyle('background',bodyBackground);
    setBodyStyle('padding',bodyPadding);
    injectClearFixIntoBodyElement();
    checkHeightMode();
    checkWidthMode();
    stopInfiniteResizingOfIFrame();
    setupPublicMethods();
    startEventListeners();
    inPageLinks = setupInPageLinks();
    sendSize('init','Init message from host page');
    readyCallback();
  }

  function readDataFromParent() {

    function strBool(str) {
      return 'true' === str ? true : false;
    }

    var data = initMsg.substr(msgIdLen).split(':');

    myID               = data[0];
    bodyMargin         = (undefined !== data[1]) ? Number(data[1])   : bodyMargin; //For V1 compatibility
    calculateWidth     = (undefined !== data[2]) ? strBool(data[2])  : calculateWidth;
    logging            = (undefined !== data[3]) ? strBool(data[3])  : logging;
    interval           = (undefined !== data[4]) ? Number(data[4])   : interval;
    autoResize         = (undefined !== data[6]) ? strBool(data[6])  : autoResize;
    bodyMarginStr      = data[7];
    heightCalcMode     = (undefined !== data[8]) ? data[8]           : heightCalcMode;
    bodyBackground     = data[9];
    bodyPadding        = data[10];
    tolerance          = (undefined !== data[11]) ? Number(data[11]) : tolerance;
    inPageLinks.enable = (undefined !== data[12]) ? strBool(data[12]): false;
    resizeFrom         = (undefined !== data[13]) ? data[13]         : resizeFrom;
    widthCalcMode      = (undefined !== data[14]) ? data[14]         : widthCalcMode;
  }

  function readDataFromPage() {
    function readData() {
      var data = window.iFrameResizer;

      log('Reading data from page: ' + JSON.stringify(data));

      messageCallback     = ('messageCallback'         in data) ? data.messageCallback         : messageCallback;
      readyCallback       = ('readyCallback'           in data) ? data.readyCallback           : readyCallback;
      targetOriginDefault = ('targetOrigin'            in data) ? data.targetOrigin            : targetOriginDefault;
      heightCalcMode      = ('heightCalculationMethod' in data) ? data.heightCalculationMethod : heightCalcMode;
      widthCalcMode       = ('widthCalculationMethod'  in data) ? data.widthCalculationMethod  : widthCalcMode;
    }

    function setupCustomCalcMethods(calcMode, calcFunc) {
      if ('function' === typeof calcMode) {
        log('Setup custom ' + calcFunc + 'CalcMethod');
        customCalcMethods[calcFunc] = calcMode;
        calcMode = 'custom';
      }

      return calcMode;
    }

    if(('iFrameResizer' in window) && (Object === window.iFrameResizer.constructor)) {
      readData();
      heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
      widthCalcMode  = setupCustomCalcMethods(widthCalcMode,  'width');
    }

    log('TargetOrigin for parent set to: ' + targetOriginDefault);
  }


  function chkCSS(attr,value) {
    if (-1 !== value.indexOf('-')) {
      warn('Negative CSS value ignored for '+attr);
      value='';
    }
    return value;
  }

  function setBodyStyle(attr,value) {
    if ((undefined !== value) && ('' !== value) && ('null' !== value)) {
      document.body.style[attr] = value;
      log('Body '+attr+' set to "'+value+'"');
    }
  }

  function setMargin() {
    //If called via V1 script, convert bodyMargin from int to str
    if (undefined === bodyMarginStr) {
      bodyMarginStr = bodyMargin+'px';
    }

    setBodyStyle('margin',chkCSS('margin',bodyMarginStr));
  }

  function stopInfiniteResizingOfIFrame() {
    document.documentElement.style.height = '';
    document.body.style.height = '';
    log('HTML & body height set to "auto"');
  }


  function manageTriggerEvent(options) {

    var listener = {
      add:    function(eventName) {
        function handleEvent() {
          sendSize(options.eventName,options.eventType);
        }

        eventHandlersByName[eventName] = handleEvent;

        addEventListener(window,eventName,handleEvent);
      },
      remove: function(eventName) {
        var handleEvent = eventHandlersByName[eventName];
        delete eventHandlersByName[eventName];

        removeEventListener(window,eventName,handleEvent);
      }
    };

    if(options.eventNames && Array.prototype.map) {
      options.eventName = options.eventNames[0];
      options.eventNames.map(listener[options.method]);
    } else {
      listener[options.method](options.eventName);
    }

    log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
  }

  function manageEventListeners(method) {
    manageTriggerEvent({method:method, eventType: 'Animation Start',           eventNames: ['animationstart','webkitAnimationStart'] });
    manageTriggerEvent({method:method, eventType: 'Animation Iteration',       eventNames: ['animationiteration','webkitAnimationIteration'] });
    manageTriggerEvent({method:method, eventType: 'Animation End',             eventNames: ['animationend','webkitAnimationEnd'] });
    manageTriggerEvent({method:method, eventType: 'Input',                     eventName:  'input' });
    manageTriggerEvent({method:method, eventType: 'Mouse Up',                  eventName:  'mouseup' });
    manageTriggerEvent({method:method, eventType: 'Mouse Down',                eventName:  'mousedown' });
    manageTriggerEvent({method:method, eventType: 'Orientation Change',        eventName:  'orientationchange' });
    manageTriggerEvent({method:method, eventType: 'Print',                     eventName:  ['afterprint', 'beforeprint'] });
    manageTriggerEvent({method:method, eventType: 'Ready State Change',        eventName:  'readystatechange' });
    manageTriggerEvent({method:method, eventType: 'Touch Start',               eventName:  'touchstart' });
    manageTriggerEvent({method:method, eventType: 'Touch End',                 eventName:  'touchend' });
    manageTriggerEvent({method:method, eventType: 'Touch Cancel',              eventName:  'touchcancel' });
    manageTriggerEvent({method:method, eventType: 'Transition Start',          eventNames: ['transitionstart','webkitTransitionStart','MSTransitionStart','oTransitionStart','otransitionstart'] });
    manageTriggerEvent({method:method, eventType: 'Transition Iteration',      eventNames: ['transitioniteration','webkitTransitionIteration','MSTransitionIteration','oTransitionIteration','otransitioniteration'] });
    manageTriggerEvent({method:method, eventType: 'Transition End',            eventNames: ['transitionend','webkitTransitionEnd','MSTransitionEnd','oTransitionEnd','otransitionend'] });
    if('child' === resizeFrom) {
      manageTriggerEvent({method:method, eventType: 'IFrame Resized',        eventName:  'resize' });
    }
  }

  function checkCalcMode(calcMode,calcModeDefault,modes,type) {
    if (calcModeDefault !== calcMode) {
      if (!(calcMode in modes)) {
        warn(calcMode + ' is not a valid option for '+type+'CalculationMethod.');
        calcMode=calcModeDefault;
      }
      log(type+' calculation method set to "'+calcMode+'"');
    }

    return calcMode;
  }

  function checkHeightMode() {
    heightCalcMode = checkCalcMode(heightCalcMode,heightCalcModeDefault,getHeight,'height');
  }

  function checkWidthMode() {
    widthCalcMode = checkCalcMode(widthCalcMode,widthCalcModeDefault,getWidth,'width');
  }

  function startEventListeners() {
    if ( true === autoResize ) {
      manageEventListeners('add');
      setupMutationObserver();
    }
    else {
      log('Auto Resize disabled');
    }
  }

  function stopMsgsToParent() {
    log('Disable outgoing messages');
    sendPermit = false;
  }

  function removeMsgListener() {
    log('Remove event listener: Message');
    removeEventListener(window, 'message', receiver);
  }

  function disconnectMutationObserver() {
    if (null !== bodyObserver) {
      /* istanbul ignore next */ // Not testable in PhantonJS
      bodyObserver.disconnect();
    }
  }

  function stopEventListeners() {
    manageEventListeners('remove');
    disconnectMutationObserver();
    clearInterval(intervalTimer);
  }

  function teardown() {
    stopMsgsToParent();
    removeMsgListener();
    if (true === autoResize) stopEventListeners();
  }

  function injectClearFixIntoBodyElement() {
    var clearFix = document.createElement('div');
    clearFix.style.clear   = 'both';
    clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
    document.body.appendChild(clearFix);
  }

  function setupInPageLinks() {

    function getPagePosition () {
      return {
        x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
        y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
      };
    }

    function getElementPosition(el) {
      var
        elPosition   = el.getBoundingClientRect(),
        pagePosition = getPagePosition();

      return {
        x: parseInt(elPosition.left,10) + parseInt(pagePosition.x,10),
        y: parseInt(elPosition.top,10)  + parseInt(pagePosition.y,10)
      };
    }

    function findTarget(location) {
      function jumpToTarget(target) {
        var jumpPosition = getElementPosition(target);

        log('Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
        sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
      }

      var
        hash     = location.split('#')[1] || location, //Remove # if present
        hashData = decodeURIComponent(hash),
        target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];

      if (undefined !== target) {
        jumpToTarget(target);
      } else {
        log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
        sendMsg(0,0,'inPageLink','#'+hash);
      }
    }

    function checkLocationHash() {
      if ('' !== location.hash && '#' !== location.hash) {
        findTarget(location.href);
      }
    }

    function bindAnchors() {
      function setupLink(el) {
        function linkClicked(e) {
          e.preventDefault();

          /*jshint validthis:true */
          findTarget(this.getAttribute('href'));
        }

        if ('#' !== el.getAttribute('href')) {
          addEventListener(el,'click',linkClicked);
        }
      }

      Array.prototype.forEach.call( document.querySelectorAll( 'a[href^="#"]' ), setupLink );
    }

    function bindLocationHash() {
      addEventListener(window,'hashchange',checkLocationHash);
    }

    function initCheck() { //check if page loaded with location hash after init resize
      setTimeout(checkLocationHash,eventCancelTimer);
    }

    function enableInPageLinks() {
      /* istanbul ignore else */ // Not testable in phantonJS
      if(Array.prototype.forEach && document.querySelectorAll) {
        log('Setting up location.hash handlers');
        bindAnchors();
        bindLocationHash();
        initCheck();
      } else {
        warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
      }
    }

    if(inPageLinks.enable) {
      enableInPageLinks();
    } else {
      log('In page linking not enabled');
    }

    return {
      findTarget:findTarget
    };
  }

  function setupPublicMethods() {
    log('Enable public methods');

    win.parentIFrame = {

      autoResize: function autoResizeF(resize) {
        if (true === resize && false === autoResize) {
          autoResize=true;
          startEventListeners();
          //sendSize('autoResize','Auto Resize enabled');
        } else if (false === resize && true === autoResize) {
          autoResize=false;
          stopEventListeners();
        }

        return autoResize;
      },

      close: function closeF() {
        sendMsg(0,0,'close');
        teardown();
      },

      getId: function getIdF() {
        return myID;
      },

      getPageInfo: function getPageInfoF(callback) {
        if ('function' === typeof callback) {
          pageInfoCallback = callback;
          sendMsg(0,0,'pageInfo');
        } else {
          pageInfoCallback = function() {};
          sendMsg(0,0,'pageInfoStop');
        }
      },

      moveToAnchor: function moveToAnchorF(hash) {
        inPageLinks.findTarget(hash);
      },

      reset: function resetF() {
        resetIFrame('parentIFrame.reset');
      },

      scrollTo: function scrollToF(x,y) {
        sendMsg(y,x,'scrollTo'); // X&Y reversed at sendMsg uses height/width
      },

      scrollToOffset: function scrollToF(x,y) {
        sendMsg(y,x,'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
      },

      sendMessage: function sendMessageF(msg,targetOrigin) {
        sendMsg(0,0,'message',JSON.stringify(msg),targetOrigin);
      },

      setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod) {
        heightCalcMode = heightCalculationMethod;
        checkHeightMode();
      },

      setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod) {
        widthCalcMode = widthCalculationMethod;
        checkWidthMode();
      },

      setTargetOrigin: function setTargetOriginF(targetOrigin) {
        log('Set targetOrigin: '+targetOrigin);
        targetOriginDefault = targetOrigin;
      },

      size: function sizeF(customHeight, customWidth) {
        var valString = ''+(customHeight?customHeight:'')+(customWidth?','+customWidth:'');
        //lockTrigger();
        sendSize('size','parentIFrame.size('+valString+')', customHeight, customWidth);
      }
    };
  }

  function initInterval() {
    if ( 0 !== interval ) {
      log('setInterval: '+interval+'ms');
      intervalTimer = setInterval(function() {
        sendSize('interval','setInterval: '+interval);
      },Math.abs(interval));
    }
  }

  /* istanbul ignore next */  //Not testable in PhantomJS
  function setupBodyMutationObserver() {
    function addImageLoadListners(mutation) {
      function addImageLoadListener(element) {
        if (false === element.complete) {
          log('Attach listeners to ' + element.src);
          element.addEventListener('load', imageLoaded, false);
          element.addEventListener('error', imageError, false);
          elements.push(element);
        }
      }

      if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
        addImageLoadListener(mutation.target);
      } else if (mutation.type === 'childList') {
        Array.prototype.forEach.call(
          mutation.target.querySelectorAll('img'),
          addImageLoadListener
        );
      }
    }

    function removeFromArray(element) {
      elements.splice(elements.indexOf(element),1);
    }

    function removeImageLoadListener(element) {
      log('Remove listeners from ' + element.src);
      element.removeEventListener('load', imageLoaded, false);
      element.removeEventListener('error', imageError, false);
      removeFromArray(element);
    }

    function imageEventTriggered(event,type,typeDesc) {
      removeImageLoadListener(event.target);
      sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
    }

    function imageLoaded(event) {
      imageEventTriggered(event,'imageLoad','Image loaded');
    }

    function imageError(event) {
      imageEventTriggered(event,'imageLoadFailed','Image load failed');
    }

    function mutationObserved(mutations) {
      sendSize('mutationObserver','mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);

      //Deal with WebKit asyncing image loading when tags are injected into the page
      mutations.forEach(addImageLoadListners);
    }

    function createMutationObserver() {
      var
        target = document.querySelector('body'),

        config = {
          attributes            : true,
          attributeOldValue     : false,
          characterData         : true,
          characterDataOldValue : false,
          childList             : true,
          subtree               : true
        };

      observer = new MutationObserver(mutationObserved);

      log('Create body MutationObserver');
      observer.observe(target, config);

      return observer;
    }

    var
      elements         = [],
      MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
      observer         = createMutationObserver();

    return {
      disconnect: function () {
        if ('disconnect' in observer) {
          log('Disconnect body MutationObserver');
          observer.disconnect();
          elements.forEach(removeImageLoadListener);
        }
      }
    };
  }

  function setupMutationObserver() {
    var	forceIntervalTimer = 0 > interval;

    /* istanbul ignore if */ // Not testable in PhantomJS
    if (window.MutationObserver || window.WebKitMutationObserver) {
      if (forceIntervalTimer) {
        initInterval();
      } else {
        bodyObserver = setupBodyMutationObserver();
      }
    } else {
      log('MutationObserver not supported in this browser!');
      initInterval();
    }
  }


  // document.documentElement.offsetHeight is not reliable, so
  // we have to jump through hoops to get a better value.
  function getComputedStyle(prop,el) {
    /* istanbul ignore next */  //Not testable in PhantomJS
    function convertUnitsToPxForIE8(value) {
      var PIXEL = /^\d+(px)?$/i;

      if (PIXEL.test(value)) {
        return parseInt(value,base);
      }

      var
        style = el.style.left,
        runtimeStyle = el.runtimeStyle.left;

      el.runtimeStyle.left = el.currentStyle.left;
      el.style.left = value || 0;
      value = el.style.pixelLeft;
      el.style.left = style;
      el.runtimeStyle.left = runtimeStyle;

      return value;
    }

    var retVal = 0;
    el =  el || document.body;

    /* istanbul ignore else */ // Not testable in phantonJS
    if (('defaultView' in document) && ('getComputedStyle' in document.defaultView)) {
      retVal = document.defaultView.getComputedStyle(el, null);
      retVal = (null !== retVal) ? retVal[prop] : 0;
    } else {//IE8
      retVal =  convertUnitsToPxForIE8(el.currentStyle[prop]);
    }

    return parseInt(retVal,base);
  }

  function chkEventThottle(timer) {
    if(timer > throttledTimer/2) {
      throttledTimer = 2*timer;
      log('Event throttle increased to ' + throttledTimer + 'ms');
    }
  }

  //Idea from https://github.com/guardian/iframe-messenger
  function getMaxElement(side,elements) {
    var
      elementsLength = elements.length,
      elVal          = 0,
      maxVal         = 0,
      Side           = capitalizeFirstLetter(side),
      timer          = getNow();

    for (var i = 0; i < elementsLength; i++) {
      elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin'+Side,elements[i]);
      if (elVal > maxVal) {
        maxVal = elVal;
      }
    }

    timer = getNow() - timer;

    log('Parsed '+elementsLength+' HTML elements');
    log('Element position calculated in ' + timer + 'ms');

    chkEventThottle(timer);

    return maxVal;
  }

  function getAllMeasurements(dimention) {
    return [
      dimention.bodyOffset(),
      dimention.bodyScroll(),
      dimention.documentElementOffset(),
      dimention.documentElementScroll()
    ];
  }

  function getTaggedElements(side,tag) {
    function noTaggedElementsFound() {
      warn('No tagged elements ('+tag+') found on page');
      return document.querySelectorAll('body *');
    }

    var elements = document.querySelectorAll('['+tag+']');

    if (0 === elements.length) noTaggedElementsFound();

    return getMaxElement(side,elements);
  }

  function getAllElements() {
    return document.querySelectorAll('body *');
  }

  var
    getHeight = {
      bodyOffset: function getBodyOffsetHeight() {
        return  document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
      },

      offset: function() {
        return getHeight.bodyOffset(); //Backwards compatability
      },

      bodyScroll: function getBodyScrollHeight() {
        return document.body.scrollHeight;
      },

      custom: function getCustomWidth() {
        return customCalcMethods.height();
      },

      documentElementOffset: function getDEOffsetHeight() {
        return document.documentElement.offsetHeight;
      },

      documentElementScroll: function getDEScrollHeight() {
        return document.documentElement.scrollHeight;
      },

      max: function getMaxHeight() {
        return Math.max.apply(null,getAllMeasurements(getHeight));
      },

      min: function getMinHeight() {
        return Math.min.apply(null,getAllMeasurements(getHeight));
      },

      grow: function growHeight() {
        return getHeight.max(); //Run max without the forced downsizing
      },

      lowestElement: function getBestHeight() {
        return Math.max(getHeight.bodyOffset(), getMaxElement('bottom',getAllElements()));
      },

      taggedElement: function getTaggedElementsHeight() {
        return getTaggedElements('bottom','data-iframe-height');
      }
    },

    getWidth = {
      bodyScroll: function getBodyScrollWidth() {
        return document.body.scrollWidth;
      },

      bodyOffset: function getBodyOffsetWidth() {
        return document.body.offsetWidth;
      },

      custom: function getCustomWidth() {
        return customCalcMethods.width();
      },

      documentElementScroll: function getDEScrollWidth() {
        return document.documentElement.scrollWidth;
      },

      documentElementOffset: function getDEOffsetWidth() {
        return document.documentElement.offsetWidth;
      },

      scroll: function getMaxWidth() {
        return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
      },

      max: function getMaxWidth() {
        return Math.max.apply(null,getAllMeasurements(getWidth));
      },

      min: function getMinWidth() {
        return Math.min.apply(null,getAllMeasurements(getWidth));
      },

      rightMostElement: function rightMostElement() {
        return getMaxElement('right', getAllElements());
      },

      taggedElement: function getTaggedElementsWidth() {
        return getTaggedElements('right', 'data-iframe-width');
      }
    };


  function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth) {

    function resizeIFrame() {
      height = currentHeight;
      width  = currentWidth;

      sendMsg(height,width,triggerEvent);
    }

    function isSizeChangeDetected() {
      function checkTolarance(a,b) {
        var retVal = Math.abs(a-b) <= tolerance;
        return !retVal;
      }

      currentHeight = (undefined !== customHeight)  ? customHeight : getHeight[heightCalcMode]();
      currentWidth  = (undefined !== customWidth )  ? customWidth  : getWidth[widthCalcMode]();

      return	checkTolarance(height,currentHeight) || (calculateWidth && checkTolarance(width,currentWidth));
    }

    function isForceResizableEvent() {
      return !(triggerEvent in {'init':1,'interval':1,'size':1});
    }

    function isForceResizableCalcMode() {
      return (heightCalcMode in resetRequiredMethods) || (calculateWidth && widthCalcMode in resetRequiredMethods);
    }

    function logIgnored() {
      log('No change in size detected');
    }

    function checkDownSizing() {
      if (isForceResizableEvent() && isForceResizableCalcMode()) {
        resetIFrame(triggerEventDesc);
      } else if (!(triggerEvent in {'interval':1})) {
        logIgnored();
      }
    }

    var	currentHeight,currentWidth;

    if (isSizeChangeDetected() || 'init' === triggerEvent) {
      lockTrigger();
      resizeIFrame();
    } else {
      checkDownSizing();
    }
  }

  var sizeIFrameThrottled = throttle(sizeIFrame);

  function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth) {
    function recordTrigger() {
      if (!(triggerEvent in {'reset':1,'resetPage':1,'init':1})) {
        log( 'Trigger event: ' + triggerEventDesc );
      }
    }

    function isDoubleFiredEvent() {
      return  triggerLocked && (triggerEvent in doubleEventList);
    }

    if (!isDoubleFiredEvent()) {
      recordTrigger();
      if (triggerEvent === 'init') {
        sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth);
      } else {
        sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
      }
    } else {
      log('Trigger event cancelled: '+triggerEvent);
    }
  }

  function lockTrigger() {
    if (!triggerLocked) {
      triggerLocked = true;
      log('Trigger event lock on');
    }
    clearTimeout(triggerLockedTimer);
    triggerLockedTimer = setTimeout(function() {
      triggerLocked = false;
      log('Trigger event lock off');
      log('--');
    },eventCancelTimer);
  }

  function triggerReset(triggerEvent) {
    height = getHeight[heightCalcMode]();
    width  = getWidth[widthCalcMode]();

    sendMsg(height,width,triggerEvent);
  }

  function resetIFrame(triggerEventDesc) {
    var hcm = heightCalcMode;
    heightCalcMode = heightCalcModeDefault;

    log('Reset trigger event: ' + triggerEventDesc);
    lockTrigger();
    triggerReset('reset');

    heightCalcMode = hcm;
  }

  function sendMsg(height,width,triggerEvent,msg,targetOrigin) {
    function setTargetOrigin() {
      if (undefined === targetOrigin) {
        targetOrigin = targetOriginDefault;
      } else {
        log('Message targetOrigin: '+targetOrigin);
      }
    }

    function sendToParent() {
      var
        size  = height + ':' + width,
        message = myID + ':' +  size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');

      log('Sending message to host page (' + message + ')');
      target.postMessage( msgID + message, targetOrigin);
    }

    if(true === sendPermit) {
      setTargetOrigin();
      sendToParent();
    }
  }

  function receiver(event) {
    var processRequestFromParent = {
      init: function initFromParent() {
        function fireInit() {
          initMsg = event.data;
          target  = event.source;

          init();
          firstRun = false;
          setTimeout(function() { initLock = false;},eventCancelTimer);
        }

        if (document.readyState === "interactive" || document.readyState === "complete") {
          fireInit();
        } else {
          log('Waiting for page ready');
          addEventListener(window,'readystatechange',processRequestFromParent.initFromParent);
        }
      },

      reset: function resetFromParent() {
        if (!initLock) {
          log('Page size reset by host page');
          triggerReset('resetPage');
        } else {
          log('Page reset ignored by init');
        }
      },

      resize: function resizeFromParent() {
        sendSize('resizeParent','Parent window requested size check');
      },

      moveToAnchor: function moveToAnchorF() {
        inPageLinks.findTarget(getData());
      },
      inPageLink: function inPageLinkF() {this.moveToAnchor();}, //Backward compatability

      pageInfo: function pageInfoFromParent() {
        var msgBody = getData();
        log('PageInfoFromParent called from parent: ' + msgBody );
        pageInfoCallback(JSON.parse(msgBody));
        log(' --');
      },

      message: function messageFromParent() {
        var msgBody = getData();

        log('MessageCallback called from parent: ' + msgBody );
        messageCallback(JSON.parse(msgBody));
        log(' --');
      }
    };

    function isMessageForUs() {
      return msgID === (''+event.data).substr(0,msgIdLen); //''+ Protects against non-string messages
    }

    function getMessageType() {
      return event.data.split(']')[1].split(':')[0];
    }

    function getData() {
      return event.data.substr(event.data.indexOf(':')+1);
    }

    function isMiddleTier() {
      return !(typeof module !== 'undefined' && module.exports) && ('iFrameResize' in window);
    }

    function isInitMsg() {
      //Test if this message is from a child below us. This is an ugly test, however, updating
      //the message format would break backwards compatibity.
      return event.data.split(':')[2] in {'true':1,'false':1};
    }

    function callFromParent() {
      var messageType = getMessageType();

      if (messageType in processRequestFromParent) {
        processRequestFromParent[messageType]();
      } else if (!isMiddleTier() && !isInitMsg()) {
        warn('Unexpected message ('+event.data+')');
      }
    }

    function processMessage() {
      if (false === firstRun) {
        callFromParent();
      } else if (isInitMsg()) {
        processRequestFromParent.init();
      } else {
        log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
      }
    }

    if (isMessageForUs()) {
      processMessage();
    }
  }

  //Normally the parent kicks things off when it detects the iFrame has loaded.
  //If this script is async-loaded, then tell parent page to retry init.
  function chkLateLoaded() {
    if('loading' !== document.readyState) {
      window.parent.postMessage('[iFrameResizerChild]Ready','*');
    }
  }

  addEventListener(window, 'message', receiver);
  chkLateLoaded();

  

})();


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var Loader=function Loader(_ref){var pulse=_ref.pulse;var html=void 0;if(pulse){html=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'app__loader app__loader--pulse'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null));}else{html=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'app__loader app__loader--rotate'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg',{className:'loader__svg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('circle',{className:'loader__circle',cx:'50',cy:'50',r:'20',fill:'none',strokeWidth:'2'})));}return html;};Loader.propTypes={pulse:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool.isRequired};Loader.defaultProps={pulse:true};/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(387);

Object.defineProperty(exports, 'common', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_common).default;
  }
});

var _red = __webpack_require__(386);

Object.defineProperty(exports, 'red', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_red).default;
  }
});

var _pink = __webpack_require__(384);

Object.defineProperty(exports, 'pink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pink).default;
  }
});

var _purple = __webpack_require__(1123);

Object.defineProperty(exports, 'purple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_purple).default;
  }
});

var _deepPurple = __webpack_require__(1124);

Object.defineProperty(exports, 'deepPurple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deepPurple).default;
  }
});

var _indigo = __webpack_require__(383);

Object.defineProperty(exports, 'indigo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_indigo).default;
  }
});

var _blue = __webpack_require__(1125);

Object.defineProperty(exports, 'blue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blue).default;
  }
});

var _lightBlue = __webpack_require__(1126);

Object.defineProperty(exports, 'lightBlue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightBlue).default;
  }
});

var _cyan = __webpack_require__(1127);

Object.defineProperty(exports, 'cyan', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cyan).default;
  }
});

var _teal = __webpack_require__(1128);

Object.defineProperty(exports, 'teal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_teal).default;
  }
});

var _green = __webpack_require__(1129);

Object.defineProperty(exports, 'green', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_green).default;
  }
});

var _lightGreen = __webpack_require__(1130);

Object.defineProperty(exports, 'lightGreen', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightGreen).default;
  }
});

var _lime = __webpack_require__(1131);

Object.defineProperty(exports, 'lime', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lime).default;
  }
});

var _yellow = __webpack_require__(1132);

Object.defineProperty(exports, 'yellow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_yellow).default;
  }
});

var _amber = __webpack_require__(1133);

Object.defineProperty(exports, 'amber', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_amber).default;
  }
});

var _orange = __webpack_require__(1134);

Object.defineProperty(exports, 'orange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_orange).default;
  }
});

var _deepOrange = __webpack_require__(1135);

Object.defineProperty(exports, 'deepOrange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deepOrange).default;
  }
});

var _brown = __webpack_require__(1136);

Object.defineProperty(exports, 'brown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_brown).default;
  }
});

var _grey = __webpack_require__(385);

Object.defineProperty(exports, 'grey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_grey).default;
  }
});

var _blueGrey = __webpack_require__(1137);

Object.defineProperty(exports, 'blueGrey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blueGrey).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};

exports.default = purple;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};

exports.default = deepPurple;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};

exports.default = blue;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};

exports.default = lightBlue;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};

exports.default = cyan;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};

exports.default = teal;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};

exports.default = green;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};

exports.default = lightGreen;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};

exports.default = lime;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};

exports.default = yellow;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};

exports.default = amber;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};

exports.default = orange;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};

exports.default = deepOrange;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};

exports.default = brown;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};

exports.default = blueGrey;

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

var appCacheIframe;

function hasSW() {
  return 'serviceWorker' in navigator &&
    // This is how I block Chrome 40 and detect Chrome 41, because first has
    // bugs with history.pustState and/or hashchange
    (window.fetch || 'imageRendering' in document.documentElement.style) &&
    (window.location.protocol === 'https:' || window.location.hostname === 'localhost' || window.location.hostname.indexOf('127.') === 0)
}

function install(options) {
  options || (options = {});

  
    if (hasSW()) {
      var registration = navigator.serviceWorker
        .register(
          "/sw.js"
          
        );

      
        var handleUpdating = function(registration) {
          var sw = registration.installing || registration.waiting;
          var ignoreInstalling;
          var ignoreWaiting;

          // No SW or already handled
          if (!sw || sw.onstatechange) return;

          var stateChangeHandler;

          // Already has SW
          if (registration.active) {
            onUpdateStateChange();
            stateChangeHandler = onUpdateStateChange;
          } else {
            onInstallStateChange();
            stateChangeHandler = onInstallStateChange;
          }

          ignoreInstalling = true;
          if (registration.waiting) {
            ignoreWaiting = true;
          }

          sw.onstatechange = stateChangeHandler;

          function onUpdateStateChange() {
            switch (sw.state) {
              case 'redundant': {
                sendEvent('onUpdateFailed');
                sw.onstatechange = null;
              } break;

              case 'installing': {
                if (!ignoreInstalling) {
                  sendEvent('onUpdating');
                }
              } break;

              case 'installed': {
                if (!ignoreWaiting) {
                  sendEvent('onUpdateReady');
                }
              } break;

              case 'activated': {
                sendEvent('onUpdated');
                sw.onstatechange = null;
              } break;
            }
          }

          function onInstallStateChange() {
            switch (sw.state) {
              case 'redundant': {
                // Failed to install, ignore
                sw.onstatechange = null;
              } break;

              case 'installing': {
                // Installing, ignore
              } break;

              case 'installed': {
                // Installed, wait activation
              } break;

              case 'activated': {
                sendEvent('onInstalled');
                sw.onstatechange = null;
              } break;
            }
          }
        };

        var sendEvent = function(event) {
          if (typeof options[event] === 'function') {
            options[event]({
              source: 'ServiceWorker'
            });
          }
        };

        registration.then(function(reg) {
          // WTF no reg?
          if (!reg) return;

          // Installed but Shift-Reloaded (page is not controller by SW),
          // update might be ready at this point (more than one tab opened).
          // Anyway, if page is hard-reloaded, then it probably already have latest version
          // but it's not controlled by SW yet. Applying update will claim this page
          // to be controlled by SW. Maybe set flag to not reload it?
          // if (!navigator.serviceWorker.controller) return;

          handleUpdating(reg);
          reg.onupdatefound = function() {
            handleUpdating(reg);
          };
        }).catch(function(err) {
          sendEvent('onError');
          return Promise.reject(err);
        });
      

      return;
    }
  

  
    if (window.applicationCache) {
      var directory = "/appcache/";
      var name = "manifest";

      var doLoad = function() {
        var page = directory + name + '.html';
        var iframe = document.createElement('iframe');

        
          window.addEventListener('message', function(e) {
            if (e.source !== iframe.contentWindow) return;

            var match = (e.data + '').match(/__offline-plugin_AppCacheEvent:(\w+)/);
            if (!match) return;
            var event = match[1];

            if (typeof options[event] === 'function') {
              options[event]({
                source: 'AppCache'
              });
            }
          });
        

        iframe.src = page;
        iframe.style.display = 'none';

        appCacheIframe = iframe;
        document.body.appendChild(iframe);
      };

      if (document.readyState === 'complete') {
        setTimeout(doLoad);
      } else {
        window.addEventListener('load', doLoad);
      }

      return;
    }
  
}

function applyUpdate(callback, errback) {
  
    if (hasSW()) {
      navigator.serviceWorker.getRegistration().then(function(registration) {
        if (!registration || !registration.waiting) {
          errback && errback();
          return;
        }

        registration.waiting.postMessage({
          action: 'skipWaiting'
        });

        callback && callback();
      });

      return;
    }
  

  
    if (appCacheIframe) {
      try {
        appCacheIframe.contentWindow.__applyUpdate();
        callback && setTimeout(callback);
      } catch (e) {
        errback && setTimeout(errback);
      }
    }
  
}

function update() {
  
    if (hasSW()) {
      navigator.serviceWorker.getRegistration().then(function(registration) {
        if (!registration) return;
        return registration.update();
      });
    }
  

  
    if (appCacheIframe) {
      try {
        appCacheIframe.contentWindow.applicationCache.update();
      } catch (e) {}
    }
  
}


  setInterval(update, 3600000);


exports.install = install;
exports.applyUpdate = applyUpdate;
exports.update = update;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/app.6288c0c.js